
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5c03"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5c03"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ltGt3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7aaPz"));

});
parcelRegister("7aaPz", function(module, exports) {

$parcel$export(module.exports, "Children", () => $5371de5d543fabbd$export$dca3b0875bd9a954, (v) => $5371de5d543fabbd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $5371de5d543fabbd$export$16fa2f45be04daa8, (v) => $5371de5d543fabbd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $5371de5d543fabbd$export$ffb0004e005737fa, (v) => $5371de5d543fabbd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $5371de5d543fabbd$export$e2c29f18771995cb, (v) => $5371de5d543fabbd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $5371de5d543fabbd$export$221d75b3f55bb0bd, (v) => $5371de5d543fabbd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $5371de5d543fabbd$export$5f8d39834fd61797, (v) => $5371de5d543fabbd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $5371de5d543fabbd$export$74bf444e3cd11ea5, (v) => $5371de5d543fabbd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $5371de5d543fabbd$export$ae55be85d98224ed, (v) => $5371de5d543fabbd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $5371de5d543fabbd$export$3ba232387fd5d6dd, (v) => $5371de5d543fabbd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $5371de5d543fabbd$export$e530037191fcd5d7, (v) => $5371de5d543fabbd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $5371de5d543fabbd$export$fd42f52fd3ae1109, (v) => $5371de5d543fabbd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $5371de5d543fabbd$export$c8a8987d4410bf2d, (v) => $5371de5d543fabbd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $5371de5d543fabbd$export$d38cd72104c1f0e9, (v) => $5371de5d543fabbd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $5371de5d543fabbd$export$7d1e3a5e95ceca43, (v) => $5371de5d543fabbd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $5371de5d543fabbd$export$257a8862b851cb5b, (v) => $5371de5d543fabbd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $5371de5d543fabbd$export$a8257692ac88316c, (v) => $5371de5d543fabbd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $5371de5d543fabbd$export$488013bae63b21da, (v) => $5371de5d543fabbd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $5371de5d543fabbd$export$7c73462e0d25e514, (v) => $5371de5d543fabbd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $5371de5d543fabbd$export$7568632d0d33d16d, (v) => $5371de5d543fabbd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $5371de5d543fabbd$export$88948ce120ea2619, (v) => $5371de5d543fabbd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $5371de5d543fabbd$export$35808ee640e87ca7, (v) => $5371de5d543fabbd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $5371de5d543fabbd$export$fae74005e78b1a27, (v) => $5371de5d543fabbd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $5371de5d543fabbd$export$dc8fbce3eb94dc1e, (v) => $5371de5d543fabbd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $5371de5d543fabbd$export$6a7bc4e911dc01cf, (v) => $5371de5d543fabbd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $5371de5d543fabbd$export$6d9c69b0de29b591, (v) => $5371de5d543fabbd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $5371de5d543fabbd$export$f680877a34711e37, (v) => $5371de5d543fabbd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $5371de5d543fabbd$export$d5a552a76deda3c2, (v) => $5371de5d543fabbd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $5371de5d543fabbd$export$aaabe4eda9ed9969, (v) => $5371de5d543fabbd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $5371de5d543fabbd$export$e5c5a5f917a5871c, (v) => $5371de5d543fabbd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $5371de5d543fabbd$export$1538c33de8887b59, (v) => $5371de5d543fabbd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $5371de5d543fabbd$export$13e3392192263954, (v) => $5371de5d543fabbd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $5371de5d543fabbd$export$b8f5890fc79d6aca, (v) => $5371de5d543fabbd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $5371de5d543fabbd$export$60241385465d0a34, (v) => $5371de5d543fabbd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $5371de5d543fabbd$export$306c0aa65ff9ec16, (v) => $5371de5d543fabbd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $5371de5d543fabbd$export$7b286972b8d8ccbf, (v) => $5371de5d543fabbd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $5371de5d543fabbd$export$83d89fbfd8236492, (v) => $5371de5d543fabbd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5371de5d543fabbd$export$dca3b0875bd9a954;
var $5371de5d543fabbd$export$16fa2f45be04daa8;
var $5371de5d543fabbd$export$ffb0004e005737fa;
var $5371de5d543fabbd$export$e2c29f18771995cb;
var $5371de5d543fabbd$export$221d75b3f55bb0bd;
var $5371de5d543fabbd$export$5f8d39834fd61797;
var $5371de5d543fabbd$export$74bf444e3cd11ea5;
var $5371de5d543fabbd$export$ae55be85d98224ed;
var $5371de5d543fabbd$export$3ba232387fd5d6dd;
var $5371de5d543fabbd$export$e530037191fcd5d7;
var $5371de5d543fabbd$export$fd42f52fd3ae1109;
var $5371de5d543fabbd$export$c8a8987d4410bf2d;
var $5371de5d543fabbd$export$d38cd72104c1f0e9;
var $5371de5d543fabbd$export$7d1e3a5e95ceca43;
var $5371de5d543fabbd$export$257a8862b851cb5b;
var $5371de5d543fabbd$export$a8257692ac88316c;
var $5371de5d543fabbd$export$488013bae63b21da;
var $5371de5d543fabbd$export$7c73462e0d25e514;
var $5371de5d543fabbd$export$7568632d0d33d16d;
var $5371de5d543fabbd$export$88948ce120ea2619;
var $5371de5d543fabbd$export$35808ee640e87ca7;
var $5371de5d543fabbd$export$fae74005e78b1a27;
var $5371de5d543fabbd$export$dc8fbce3eb94dc1e;
var $5371de5d543fabbd$export$6a7bc4e911dc01cf;
var $5371de5d543fabbd$export$6d9c69b0de29b591;
var $5371de5d543fabbd$export$f680877a34711e37;
var $5371de5d543fabbd$export$d5a552a76deda3c2;
var $5371de5d543fabbd$export$aaabe4eda9ed9969;
var $5371de5d543fabbd$export$e5c5a5f917a5871c;
var $5371de5d543fabbd$export$1538c33de8887b59;
var $5371de5d543fabbd$export$13e3392192263954;
var $5371de5d543fabbd$export$b8f5890fc79d6aca;
var $5371de5d543fabbd$export$60241385465d0a34;
var $5371de5d543fabbd$export$306c0aa65ff9ec16;
var $5371de5d543fabbd$export$7b286972b8d8ccbf;
var $5371de5d543fabbd$export$83d89fbfd8236492;
'use strict';
var $5371de5d543fabbd$var$l = Symbol.for("react.element"), $5371de5d543fabbd$var$n = Symbol.for("react.portal"), $5371de5d543fabbd$var$p = Symbol.for("react.fragment"), $5371de5d543fabbd$var$q = Symbol.for("react.strict_mode"), $5371de5d543fabbd$var$r = Symbol.for("react.profiler"), $5371de5d543fabbd$var$t = Symbol.for("react.provider"), $5371de5d543fabbd$var$u = Symbol.for("react.context"), $5371de5d543fabbd$var$v = Symbol.for("react.forward_ref"), $5371de5d543fabbd$var$w = Symbol.for("react.suspense"), $5371de5d543fabbd$var$x = Symbol.for("react.memo"), $5371de5d543fabbd$var$y = Symbol.for("react.lazy"), $5371de5d543fabbd$var$z = Symbol.iterator;
function $5371de5d543fabbd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5371de5d543fabbd$var$z && a[$5371de5d543fabbd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5371de5d543fabbd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $5371de5d543fabbd$var$C = Object.assign, $5371de5d543fabbd$var$D = {};
function $5371de5d543fabbd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5371de5d543fabbd$var$D;
    this.updater = e || $5371de5d543fabbd$var$B;
}
$5371de5d543fabbd$var$E.prototype.isReactComponent = {};
$5371de5d543fabbd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$5371de5d543fabbd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $5371de5d543fabbd$var$F() {}
$5371de5d543fabbd$var$F.prototype = $5371de5d543fabbd$var$E.prototype;
function $5371de5d543fabbd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $5371de5d543fabbd$var$D;
    this.updater = e || $5371de5d543fabbd$var$B;
}
var $5371de5d543fabbd$var$H = $5371de5d543fabbd$var$G.prototype = new $5371de5d543fabbd$var$F;
$5371de5d543fabbd$var$H.constructor = $5371de5d543fabbd$var$G;
$5371de5d543fabbd$var$C($5371de5d543fabbd$var$H, $5371de5d543fabbd$var$E.prototype);
$5371de5d543fabbd$var$H.isPureReactComponent = !0;
var $5371de5d543fabbd$var$I = Array.isArray, $5371de5d543fabbd$var$J = Object.prototype.hasOwnProperty, $5371de5d543fabbd$var$K = {
    current: null
}, $5371de5d543fabbd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5371de5d543fabbd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$5371de5d543fabbd$var$J.call(b, d) && !$5371de5d543fabbd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $5371de5d543fabbd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $5371de5d543fabbd$var$K.current
    };
}
function $5371de5d543fabbd$var$N(a, b) {
    return {
        $$typeof: $5371de5d543fabbd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $5371de5d543fabbd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5371de5d543fabbd$var$l;
}
function $5371de5d543fabbd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $5371de5d543fabbd$var$P = /\/+/g;
function $5371de5d543fabbd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $5371de5d543fabbd$var$escape("" + a.key) : b.toString(36);
}
function $5371de5d543fabbd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $5371de5d543fabbd$var$l:
                case $5371de5d543fabbd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $5371de5d543fabbd$var$Q(h, 0) : d, $5371de5d543fabbd$var$I(c) ? (e = "", null != a && (e = a.replace($5371de5d543fabbd$var$P, "$&/") + "/"), $5371de5d543fabbd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($5371de5d543fabbd$var$O(c) && (c = $5371de5d543fabbd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($5371de5d543fabbd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($5371de5d543fabbd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $5371de5d543fabbd$var$Q(k, g);
        h += $5371de5d543fabbd$var$R(k, b, e, f, c);
    }
    else if (f = $5371de5d543fabbd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $5371de5d543fabbd$var$Q(k, g++), h += $5371de5d543fabbd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $5371de5d543fabbd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $5371de5d543fabbd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $5371de5d543fabbd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $5371de5d543fabbd$var$U = {
    current: null
}, $5371de5d543fabbd$var$V = {
    transition: null
}, $5371de5d543fabbd$var$W = {
    ReactCurrentDispatcher: $5371de5d543fabbd$var$U,
    ReactCurrentBatchConfig: $5371de5d543fabbd$var$V,
    ReactCurrentOwner: $5371de5d543fabbd$var$K
};
function $5371de5d543fabbd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$5371de5d543fabbd$export$dca3b0875bd9a954 = {
    map: $5371de5d543fabbd$var$S,
    forEach: function(a, b, e) {
        $5371de5d543fabbd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $5371de5d543fabbd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $5371de5d543fabbd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$5371de5d543fabbd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$5371de5d543fabbd$export$16fa2f45be04daa8 = $5371de5d543fabbd$var$E;
$5371de5d543fabbd$export$ffb0004e005737fa = $5371de5d543fabbd$var$p;
$5371de5d543fabbd$export$e2c29f18771995cb = $5371de5d543fabbd$var$r;
$5371de5d543fabbd$export$221d75b3f55bb0bd = $5371de5d543fabbd$var$G;
$5371de5d543fabbd$export$5f8d39834fd61797 = $5371de5d543fabbd$var$q;
$5371de5d543fabbd$export$74bf444e3cd11ea5 = $5371de5d543fabbd$var$w;
$5371de5d543fabbd$export$ae55be85d98224ed = $5371de5d543fabbd$var$W;
$5371de5d543fabbd$export$3ba232387fd5d6dd = $5371de5d543fabbd$var$X;
$5371de5d543fabbd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $5371de5d543fabbd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $5371de5d543fabbd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$5371de5d543fabbd$var$J.call(b, f) && !$5371de5d543fabbd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $5371de5d543fabbd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$5371de5d543fabbd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $5371de5d543fabbd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $5371de5d543fabbd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$5371de5d543fabbd$export$c8a8987d4410bf2d = $5371de5d543fabbd$var$M;
$5371de5d543fabbd$export$d38cd72104c1f0e9 = function(a) {
    var b = $5371de5d543fabbd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$5371de5d543fabbd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5371de5d543fabbd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $5371de5d543fabbd$var$v,
        render: a
    };
};
$5371de5d543fabbd$export$a8257692ac88316c = $5371de5d543fabbd$var$O;
$5371de5d543fabbd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $5371de5d543fabbd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $5371de5d543fabbd$var$T
    };
};
$5371de5d543fabbd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $5371de5d543fabbd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$5371de5d543fabbd$export$7568632d0d33d16d = function(a) {
    var b = $5371de5d543fabbd$var$V.transition;
    $5371de5d543fabbd$var$V.transition = {};
    try {
        a();
    } finally{
        $5371de5d543fabbd$var$V.transition = b;
    }
};
$5371de5d543fabbd$export$88948ce120ea2619 = $5371de5d543fabbd$var$X;
$5371de5d543fabbd$export$35808ee640e87ca7 = function(a, b) {
    return $5371de5d543fabbd$var$U.current.useCallback(a, b);
};
$5371de5d543fabbd$export$fae74005e78b1a27 = function(a) {
    return $5371de5d543fabbd$var$U.current.useContext(a);
};
$5371de5d543fabbd$export$dc8fbce3eb94dc1e = function() {};
$5371de5d543fabbd$export$6a7bc4e911dc01cf = function(a) {
    return $5371de5d543fabbd$var$U.current.useDeferredValue(a);
};
$5371de5d543fabbd$export$6d9c69b0de29b591 = function(a, b) {
    return $5371de5d543fabbd$var$U.current.useEffect(a, b);
};
$5371de5d543fabbd$export$f680877a34711e37 = function() {
    return $5371de5d543fabbd$var$U.current.useId();
};
$5371de5d543fabbd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $5371de5d543fabbd$var$U.current.useImperativeHandle(a, b, e);
};
$5371de5d543fabbd$export$aaabe4eda9ed9969 = function(a, b) {
    return $5371de5d543fabbd$var$U.current.useInsertionEffect(a, b);
};
$5371de5d543fabbd$export$e5c5a5f917a5871c = function(a, b) {
    return $5371de5d543fabbd$var$U.current.useLayoutEffect(a, b);
};
$5371de5d543fabbd$export$1538c33de8887b59 = function(a, b) {
    return $5371de5d543fabbd$var$U.current.useMemo(a, b);
};
$5371de5d543fabbd$export$13e3392192263954 = function(a, b, e) {
    return $5371de5d543fabbd$var$U.current.useReducer(a, b, e);
};
$5371de5d543fabbd$export$b8f5890fc79d6aca = function(a) {
    return $5371de5d543fabbd$var$U.current.useRef(a);
};
$5371de5d543fabbd$export$60241385465d0a34 = function(a) {
    return $5371de5d543fabbd$var$U.current.useState(a);
};
$5371de5d543fabbd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $5371de5d543fabbd$var$U.current.useSyncExternalStore(a, b, e);
};
$5371de5d543fabbd$export$7b286972b8d8ccbf = function() {
    return $5371de5d543fabbd$var$U.current.useTransition();
};
$5371de5d543fabbd$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("bhjch", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $83602c5f7959a6c2$export$ae55be85d98224ed, (v) => $83602c5f7959a6c2$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $83602c5f7959a6c2$export$d39a5bbd09211389, (v) => $83602c5f7959a6c2$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $83602c5f7959a6c2$export$882461b6382ed46c, (v) => $83602c5f7959a6c2$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $83602c5f7959a6c2$export$466bfc07425424d5, (v) => $83602c5f7959a6c2$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $83602c5f7959a6c2$export$cd75ccfd720a3cd4, (v) => $83602c5f7959a6c2$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $83602c5f7959a6c2$export$fa8d919ba61d84db, (v) => $83602c5f7959a6c2$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $83602c5f7959a6c2$export$757ceba2d55c277e, (v) => $83602c5f7959a6c2$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $83602c5f7959a6c2$export$b3890eb0ae9dca99, (v) => $83602c5f7959a6c2$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $83602c5f7959a6c2$export$502457920280e6be, (v) => $83602c5f7959a6c2$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $83602c5f7959a6c2$export$c78a37762a8d58e1, (v) => $83602c5f7959a6c2$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $83602c5f7959a6c2$export$dc54d992c10e8a18, (v) => $83602c5f7959a6c2$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $83602c5f7959a6c2$export$83d89fbfd8236492, (v) => $83602c5f7959a6c2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $83602c5f7959a6c2$export$ae55be85d98224ed;
var $83602c5f7959a6c2$export$d39a5bbd09211389;
var $83602c5f7959a6c2$export$882461b6382ed46c;
var $83602c5f7959a6c2$export$466bfc07425424d5;
var $83602c5f7959a6c2$export$cd75ccfd720a3cd4;
var $83602c5f7959a6c2$export$fa8d919ba61d84db;
var $83602c5f7959a6c2$export$757ceba2d55c277e;
var $83602c5f7959a6c2$export$b3890eb0ae9dca99;
var $83602c5f7959a6c2$export$502457920280e6be;
var $83602c5f7959a6c2$export$c78a37762a8d58e1;
var $83602c5f7959a6c2$export$dc54d992c10e8a18;
var $83602c5f7959a6c2$export$83d89fbfd8236492;
'use strict';

var $ltGt3 = parcelRequire("ltGt3");

var $hZysK = parcelRequire("hZysK");
function $83602c5f7959a6c2$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $83602c5f7959a6c2$var$da = new Set, $83602c5f7959a6c2$var$ea = {};
function $83602c5f7959a6c2$var$fa(a, b) {
    $83602c5f7959a6c2$var$ha(a, b);
    $83602c5f7959a6c2$var$ha(a + "Capture", b);
}
function $83602c5f7959a6c2$var$ha(a, b) {
    $83602c5f7959a6c2$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$83602c5f7959a6c2$var$da.add(b[a]);
}
var $83602c5f7959a6c2$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $83602c5f7959a6c2$var$ja = Object.prototype.hasOwnProperty, $83602c5f7959a6c2$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $83602c5f7959a6c2$var$la = {}, $83602c5f7959a6c2$var$ma = {};
function $83602c5f7959a6c2$var$oa(a) {
    if ($83602c5f7959a6c2$var$ja.call($83602c5f7959a6c2$var$ma, a)) return !0;
    if ($83602c5f7959a6c2$var$ja.call($83602c5f7959a6c2$var$la, a)) return !1;
    if ($83602c5f7959a6c2$var$ka.test(a)) return $83602c5f7959a6c2$var$ma[a] = !0;
    $83602c5f7959a6c2$var$la[a] = !0;
    return !1;
}
function $83602c5f7959a6c2$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $83602c5f7959a6c2$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $83602c5f7959a6c2$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $83602c5f7959a6c2$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $83602c5f7959a6c2$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $83602c5f7959a6c2$var$z[a] = new $83602c5f7959a6c2$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $83602c5f7959a6c2$var$z[b] = new $83602c5f7959a6c2$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $83602c5f7959a6c2$var$z[a] = new $83602c5f7959a6c2$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $83602c5f7959a6c2$var$z[a] = new $83602c5f7959a6c2$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $83602c5f7959a6c2$var$z[a] = new $83602c5f7959a6c2$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $83602c5f7959a6c2$var$z[a] = new $83602c5f7959a6c2$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $83602c5f7959a6c2$var$z[a] = new $83602c5f7959a6c2$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $83602c5f7959a6c2$var$z[a] = new $83602c5f7959a6c2$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $83602c5f7959a6c2$var$z[a] = new $83602c5f7959a6c2$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $83602c5f7959a6c2$var$ra = /[\-:]([a-z])/g;
function $83602c5f7959a6c2$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($83602c5f7959a6c2$var$ra, $83602c5f7959a6c2$var$sa);
    $83602c5f7959a6c2$var$z[b] = new $83602c5f7959a6c2$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($83602c5f7959a6c2$var$ra, $83602c5f7959a6c2$var$sa);
    $83602c5f7959a6c2$var$z[b] = new $83602c5f7959a6c2$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($83602c5f7959a6c2$var$ra, $83602c5f7959a6c2$var$sa);
    $83602c5f7959a6c2$var$z[b] = new $83602c5f7959a6c2$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $83602c5f7959a6c2$var$z[a] = new $83602c5f7959a6c2$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$83602c5f7959a6c2$var$z.xlinkHref = new $83602c5f7959a6c2$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $83602c5f7959a6c2$var$z[a] = new $83602c5f7959a6c2$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $83602c5f7959a6c2$var$ta(a, b, c, d) {
    var e = $83602c5f7959a6c2$var$z.hasOwnProperty(b) ? $83602c5f7959a6c2$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $83602c5f7959a6c2$var$qa(b, c, e, d) && (c = null), d || null === e ? $83602c5f7959a6c2$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $83602c5f7959a6c2$var$ua = $ltGt3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $83602c5f7959a6c2$var$va = Symbol.for("react.element"), $83602c5f7959a6c2$var$wa = Symbol.for("react.portal"), $83602c5f7959a6c2$var$ya = Symbol.for("react.fragment"), $83602c5f7959a6c2$var$za = Symbol.for("react.strict_mode"), $83602c5f7959a6c2$var$Aa = Symbol.for("react.profiler"), $83602c5f7959a6c2$var$Ba = Symbol.for("react.provider"), $83602c5f7959a6c2$var$Ca = Symbol.for("react.context"), $83602c5f7959a6c2$var$Da = Symbol.for("react.forward_ref"), $83602c5f7959a6c2$var$Ea = Symbol.for("react.suspense"), $83602c5f7959a6c2$var$Fa = Symbol.for("react.suspense_list"), $83602c5f7959a6c2$var$Ga = Symbol.for("react.memo"), $83602c5f7959a6c2$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $83602c5f7959a6c2$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $83602c5f7959a6c2$var$Ja = Symbol.iterator;
function $83602c5f7959a6c2$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $83602c5f7959a6c2$var$Ja && a[$83602c5f7959a6c2$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $83602c5f7959a6c2$var$A = Object.assign, $83602c5f7959a6c2$var$La;
function $83602c5f7959a6c2$var$Ma(a) {
    if (void 0 === $83602c5f7959a6c2$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $83602c5f7959a6c2$var$La = b && b[1] || "";
    }
    return "\n" + $83602c5f7959a6c2$var$La + a;
}
var $83602c5f7959a6c2$var$Na = !1;
function $83602c5f7959a6c2$var$Oa(a, b) {
    if (!a || $83602c5f7959a6c2$var$Na) return "";
    $83602c5f7959a6c2$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $83602c5f7959a6c2$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $83602c5f7959a6c2$var$Ma(a) : "";
}
function $83602c5f7959a6c2$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $83602c5f7959a6c2$var$Ma(a.type);
        case 16:
            return $83602c5f7959a6c2$var$Ma("Lazy");
        case 13:
            return $83602c5f7959a6c2$var$Ma("Suspense");
        case 19:
            return $83602c5f7959a6c2$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $83602c5f7959a6c2$var$Oa(a.type, !1), a;
        case 11:
            return a = $83602c5f7959a6c2$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $83602c5f7959a6c2$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $83602c5f7959a6c2$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $83602c5f7959a6c2$var$ya:
            return "Fragment";
        case $83602c5f7959a6c2$var$wa:
            return "Portal";
        case $83602c5f7959a6c2$var$Aa:
            return "Profiler";
        case $83602c5f7959a6c2$var$za:
            return "StrictMode";
        case $83602c5f7959a6c2$var$Ea:
            return "Suspense";
        case $83602c5f7959a6c2$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $83602c5f7959a6c2$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $83602c5f7959a6c2$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $83602c5f7959a6c2$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $83602c5f7959a6c2$var$Ga:
            return b = a.displayName || null, null !== b ? b : $83602c5f7959a6c2$var$Qa(a.type) || "Memo";
        case $83602c5f7959a6c2$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $83602c5f7959a6c2$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $83602c5f7959a6c2$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $83602c5f7959a6c2$var$Qa(b);
        case 8:
            return b === $83602c5f7959a6c2$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $83602c5f7959a6c2$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $83602c5f7959a6c2$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $83602c5f7959a6c2$var$Ua(a) {
    var b = $83602c5f7959a6c2$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $83602c5f7959a6c2$var$Va(a) {
    a._valueTracker || (a._valueTracker = $83602c5f7959a6c2$var$Ua(a));
}
function $83602c5f7959a6c2$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $83602c5f7959a6c2$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $83602c5f7959a6c2$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $83602c5f7959a6c2$var$Ya(a, b) {
    var c = b.checked;
    return $83602c5f7959a6c2$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $83602c5f7959a6c2$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $83602c5f7959a6c2$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $83602c5f7959a6c2$var$ab(a, b) {
    b = b.checked;
    null != b && $83602c5f7959a6c2$var$ta(a, "checked", b, !1);
}
function $83602c5f7959a6c2$var$bb(a, b) {
    $83602c5f7959a6c2$var$ab(a, b);
    var c = $83602c5f7959a6c2$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $83602c5f7959a6c2$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $83602c5f7959a6c2$var$cb(a, b.type, $83602c5f7959a6c2$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $83602c5f7959a6c2$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $83602c5f7959a6c2$var$cb(a, b, c) {
    if ("number" !== b || $83602c5f7959a6c2$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $83602c5f7959a6c2$var$eb = Array.isArray;
function $83602c5f7959a6c2$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $83602c5f7959a6c2$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $83602c5f7959a6c2$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($83602c5f7959a6c2$var$p(91));
    return $83602c5f7959a6c2$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $83602c5f7959a6c2$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($83602c5f7959a6c2$var$p(92));
            if ($83602c5f7959a6c2$var$eb(c)) {
                if (1 < c.length) throw Error($83602c5f7959a6c2$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $83602c5f7959a6c2$var$Sa(c)
    };
}
function $83602c5f7959a6c2$var$ib(a, b) {
    var c = $83602c5f7959a6c2$var$Sa(b.value), d = $83602c5f7959a6c2$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $83602c5f7959a6c2$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $83602c5f7959a6c2$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $83602c5f7959a6c2$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $83602c5f7959a6c2$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $83602c5f7959a6c2$var$mb, $83602c5f7959a6c2$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $83602c5f7959a6c2$var$mb = $83602c5f7959a6c2$var$mb || document.createElement("div");
        $83602c5f7959a6c2$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $83602c5f7959a6c2$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $83602c5f7959a6c2$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $83602c5f7959a6c2$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $83602c5f7959a6c2$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($83602c5f7959a6c2$var$pb).forEach(function(a) {
    $83602c5f7959a6c2$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $83602c5f7959a6c2$var$pb[b] = $83602c5f7959a6c2$var$pb[a];
    });
});
function $83602c5f7959a6c2$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $83602c5f7959a6c2$var$pb.hasOwnProperty(a) && $83602c5f7959a6c2$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $83602c5f7959a6c2$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $83602c5f7959a6c2$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $83602c5f7959a6c2$var$tb = $83602c5f7959a6c2$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $83602c5f7959a6c2$var$ub(a, b) {
    if (b) {
        if ($83602c5f7959a6c2$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($83602c5f7959a6c2$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($83602c5f7959a6c2$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($83602c5f7959a6c2$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($83602c5f7959a6c2$var$p(62));
    }
}
function $83602c5f7959a6c2$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $83602c5f7959a6c2$var$wb = null;
function $83602c5f7959a6c2$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $83602c5f7959a6c2$var$yb = null, $83602c5f7959a6c2$var$zb = null, $83602c5f7959a6c2$var$Ab = null;
function $83602c5f7959a6c2$var$Bb(a) {
    if (a = $83602c5f7959a6c2$var$Cb(a)) {
        if ("function" !== typeof $83602c5f7959a6c2$var$yb) throw Error($83602c5f7959a6c2$var$p(280));
        var b = a.stateNode;
        b && (b = $83602c5f7959a6c2$var$Db(b), $83602c5f7959a6c2$var$yb(a.stateNode, a.type, b));
    }
}
function $83602c5f7959a6c2$var$Eb(a) {
    $83602c5f7959a6c2$var$zb ? $83602c5f7959a6c2$var$Ab ? $83602c5f7959a6c2$var$Ab.push(a) : $83602c5f7959a6c2$var$Ab = [
        a
    ] : $83602c5f7959a6c2$var$zb = a;
}
function $83602c5f7959a6c2$var$Fb() {
    if ($83602c5f7959a6c2$var$zb) {
        var a = $83602c5f7959a6c2$var$zb, b = $83602c5f7959a6c2$var$Ab;
        $83602c5f7959a6c2$var$Ab = $83602c5f7959a6c2$var$zb = null;
        $83602c5f7959a6c2$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$83602c5f7959a6c2$var$Bb(b[a]);
    }
}
function $83602c5f7959a6c2$var$Gb(a, b) {
    return a(b);
}
function $83602c5f7959a6c2$var$Hb() {}
var $83602c5f7959a6c2$var$Ib = !1;
function $83602c5f7959a6c2$var$Jb(a, b, c) {
    if ($83602c5f7959a6c2$var$Ib) return a(b, c);
    $83602c5f7959a6c2$var$Ib = !0;
    try {
        return $83602c5f7959a6c2$var$Gb(a, b, c);
    } finally{
        if ($83602c5f7959a6c2$var$Ib = !1, null !== $83602c5f7959a6c2$var$zb || null !== $83602c5f7959a6c2$var$Ab) $83602c5f7959a6c2$var$Hb(), $83602c5f7959a6c2$var$Fb();
    }
}
function $83602c5f7959a6c2$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $83602c5f7959a6c2$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($83602c5f7959a6c2$var$p(231, b, typeof c));
    return c;
}
var $83602c5f7959a6c2$var$Lb = !1;
if ($83602c5f7959a6c2$var$ia) try {
    var $83602c5f7959a6c2$var$Mb = {};
    Object.defineProperty($83602c5f7959a6c2$var$Mb, "passive", {
        get: function() {
            $83602c5f7959a6c2$var$Lb = !0;
        }
    });
    window.addEventListener("test", $83602c5f7959a6c2$var$Mb, $83602c5f7959a6c2$var$Mb);
    window.removeEventListener("test", $83602c5f7959a6c2$var$Mb, $83602c5f7959a6c2$var$Mb);
} catch (a) {
    $83602c5f7959a6c2$var$Lb = !1;
}
function $83602c5f7959a6c2$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $83602c5f7959a6c2$var$Ob = !1, $83602c5f7959a6c2$var$Pb = null, $83602c5f7959a6c2$var$Qb = !1, $83602c5f7959a6c2$var$Rb = null, $83602c5f7959a6c2$var$Sb = {
    onError: function(a) {
        $83602c5f7959a6c2$var$Ob = !0;
        $83602c5f7959a6c2$var$Pb = a;
    }
};
function $83602c5f7959a6c2$var$Tb(a, b, c, d, e, f, g, h, k) {
    $83602c5f7959a6c2$var$Ob = !1;
    $83602c5f7959a6c2$var$Pb = null;
    $83602c5f7959a6c2$var$Nb.apply($83602c5f7959a6c2$var$Sb, arguments);
}
function $83602c5f7959a6c2$var$Ub(a, b, c, d, e, f, g, h, k) {
    $83602c5f7959a6c2$var$Tb.apply(this, arguments);
    if ($83602c5f7959a6c2$var$Ob) {
        if ($83602c5f7959a6c2$var$Ob) {
            var l = $83602c5f7959a6c2$var$Pb;
            $83602c5f7959a6c2$var$Ob = !1;
            $83602c5f7959a6c2$var$Pb = null;
        } else throw Error($83602c5f7959a6c2$var$p(198));
        $83602c5f7959a6c2$var$Qb || ($83602c5f7959a6c2$var$Qb = !0, $83602c5f7959a6c2$var$Rb = l);
    }
}
function $83602c5f7959a6c2$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $83602c5f7959a6c2$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $83602c5f7959a6c2$var$Xb(a) {
    if ($83602c5f7959a6c2$var$Vb(a) !== a) throw Error($83602c5f7959a6c2$var$p(188));
}
function $83602c5f7959a6c2$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $83602c5f7959a6c2$var$Vb(a);
        if (null === b) throw Error($83602c5f7959a6c2$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $83602c5f7959a6c2$var$Xb(e), a;
                if (f === d) return $83602c5f7959a6c2$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($83602c5f7959a6c2$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($83602c5f7959a6c2$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($83602c5f7959a6c2$var$p(190));
    }
    if (3 !== c.tag) throw Error($83602c5f7959a6c2$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $83602c5f7959a6c2$var$Zb(a) {
    a = $83602c5f7959a6c2$var$Yb(a);
    return null !== a ? $83602c5f7959a6c2$var$$b(a) : null;
}
function $83602c5f7959a6c2$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $83602c5f7959a6c2$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $83602c5f7959a6c2$var$ac = $hZysK.unstable_scheduleCallback, $83602c5f7959a6c2$var$bc = $hZysK.unstable_cancelCallback, $83602c5f7959a6c2$var$cc = $hZysK.unstable_shouldYield, $83602c5f7959a6c2$var$dc = $hZysK.unstable_requestPaint, $83602c5f7959a6c2$var$B = $hZysK.unstable_now, $83602c5f7959a6c2$var$ec = $hZysK.unstable_getCurrentPriorityLevel, $83602c5f7959a6c2$var$fc = $hZysK.unstable_ImmediatePriority, $83602c5f7959a6c2$var$gc = $hZysK.unstable_UserBlockingPriority, $83602c5f7959a6c2$var$hc = $hZysK.unstable_NormalPriority, $83602c5f7959a6c2$var$ic = $hZysK.unstable_LowPriority, $83602c5f7959a6c2$var$jc = $hZysK.unstable_IdlePriority, $83602c5f7959a6c2$var$kc = null, $83602c5f7959a6c2$var$lc = null;
function $83602c5f7959a6c2$var$mc(a) {
    if ($83602c5f7959a6c2$var$lc && "function" === typeof $83602c5f7959a6c2$var$lc.onCommitFiberRoot) try {
        $83602c5f7959a6c2$var$lc.onCommitFiberRoot($83602c5f7959a6c2$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $83602c5f7959a6c2$var$oc = Math.clz32 ? Math.clz32 : $83602c5f7959a6c2$var$nc, $83602c5f7959a6c2$var$pc = Math.log, $83602c5f7959a6c2$var$qc = Math.LN2;
function $83602c5f7959a6c2$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($83602c5f7959a6c2$var$pc(a) / $83602c5f7959a6c2$var$qc | 0) | 0;
}
var $83602c5f7959a6c2$var$rc = 64, $83602c5f7959a6c2$var$sc = 4194304;
function $83602c5f7959a6c2$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $83602c5f7959a6c2$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $83602c5f7959a6c2$var$tc(h) : (f &= g, 0 !== f && (d = $83602c5f7959a6c2$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $83602c5f7959a6c2$var$tc(g) : 0 !== f && (d = $83602c5f7959a6c2$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $83602c5f7959a6c2$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $83602c5f7959a6c2$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $83602c5f7959a6c2$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $83602c5f7959a6c2$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $83602c5f7959a6c2$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $83602c5f7959a6c2$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $83602c5f7959a6c2$var$yc() {
    var a = $83602c5f7959a6c2$var$rc;
    $83602c5f7959a6c2$var$rc <<= 1;
    0 === ($83602c5f7959a6c2$var$rc & 4194240) && ($83602c5f7959a6c2$var$rc = 64);
    return a;
}
function $83602c5f7959a6c2$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $83602c5f7959a6c2$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $83602c5f7959a6c2$var$oc(b);
    a[b] = c;
}
function $83602c5f7959a6c2$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $83602c5f7959a6c2$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $83602c5f7959a6c2$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $83602c5f7959a6c2$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $83602c5f7959a6c2$var$C = 0;
function $83602c5f7959a6c2$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $83602c5f7959a6c2$var$Ec, $83602c5f7959a6c2$var$Fc, $83602c5f7959a6c2$var$Gc, $83602c5f7959a6c2$var$Hc, $83602c5f7959a6c2$var$Ic, $83602c5f7959a6c2$var$Jc = !1, $83602c5f7959a6c2$var$Kc = [], $83602c5f7959a6c2$var$Lc = null, $83602c5f7959a6c2$var$Mc = null, $83602c5f7959a6c2$var$Nc = null, $83602c5f7959a6c2$var$Oc = new Map, $83602c5f7959a6c2$var$Pc = new Map, $83602c5f7959a6c2$var$Qc = [], $83602c5f7959a6c2$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $83602c5f7959a6c2$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $83602c5f7959a6c2$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $83602c5f7959a6c2$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $83602c5f7959a6c2$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $83602c5f7959a6c2$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $83602c5f7959a6c2$var$Pc.delete(b.pointerId);
    }
}
function $83602c5f7959a6c2$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $83602c5f7959a6c2$var$Cb(b), null !== b && $83602c5f7959a6c2$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $83602c5f7959a6c2$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $83602c5f7959a6c2$var$Lc = $83602c5f7959a6c2$var$Tc($83602c5f7959a6c2$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $83602c5f7959a6c2$var$Mc = $83602c5f7959a6c2$var$Tc($83602c5f7959a6c2$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $83602c5f7959a6c2$var$Nc = $83602c5f7959a6c2$var$Tc($83602c5f7959a6c2$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $83602c5f7959a6c2$var$Oc.set(f, $83602c5f7959a6c2$var$Tc($83602c5f7959a6c2$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $83602c5f7959a6c2$var$Pc.set(f, $83602c5f7959a6c2$var$Tc($83602c5f7959a6c2$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $83602c5f7959a6c2$var$Vc(a) {
    var b = $83602c5f7959a6c2$var$Wc(a.target);
    if (null !== b) {
        var c = $83602c5f7959a6c2$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $83602c5f7959a6c2$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $83602c5f7959a6c2$var$Ic(a.priority, function() {
                        $83602c5f7959a6c2$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $83602c5f7959a6c2$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $83602c5f7959a6c2$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $83602c5f7959a6c2$var$wb = d;
            c.target.dispatchEvent(d);
            $83602c5f7959a6c2$var$wb = null;
        } else return b = $83602c5f7959a6c2$var$Cb(c), null !== b && $83602c5f7959a6c2$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $83602c5f7959a6c2$var$Zc(a, b, c) {
    $83602c5f7959a6c2$var$Xc(a) && c.delete(b);
}
function $83602c5f7959a6c2$var$$c() {
    $83602c5f7959a6c2$var$Jc = !1;
    null !== $83602c5f7959a6c2$var$Lc && $83602c5f7959a6c2$var$Xc($83602c5f7959a6c2$var$Lc) && ($83602c5f7959a6c2$var$Lc = null);
    null !== $83602c5f7959a6c2$var$Mc && $83602c5f7959a6c2$var$Xc($83602c5f7959a6c2$var$Mc) && ($83602c5f7959a6c2$var$Mc = null);
    null !== $83602c5f7959a6c2$var$Nc && $83602c5f7959a6c2$var$Xc($83602c5f7959a6c2$var$Nc) && ($83602c5f7959a6c2$var$Nc = null);
    $83602c5f7959a6c2$var$Oc.forEach($83602c5f7959a6c2$var$Zc);
    $83602c5f7959a6c2$var$Pc.forEach($83602c5f7959a6c2$var$Zc);
}
function $83602c5f7959a6c2$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $83602c5f7959a6c2$var$Jc || ($83602c5f7959a6c2$var$Jc = !0, $hZysK.unstable_scheduleCallback($hZysK.unstable_NormalPriority, $83602c5f7959a6c2$var$$c)));
}
function $83602c5f7959a6c2$var$bd(a) {
    function b(b) {
        return $83602c5f7959a6c2$var$ad(b, a);
    }
    if (0 < $83602c5f7959a6c2$var$Kc.length) {
        $83602c5f7959a6c2$var$ad($83602c5f7959a6c2$var$Kc[0], a);
        for(var c = 1; c < $83602c5f7959a6c2$var$Kc.length; c++){
            var d = $83602c5f7959a6c2$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $83602c5f7959a6c2$var$Lc && $83602c5f7959a6c2$var$ad($83602c5f7959a6c2$var$Lc, a);
    null !== $83602c5f7959a6c2$var$Mc && $83602c5f7959a6c2$var$ad($83602c5f7959a6c2$var$Mc, a);
    null !== $83602c5f7959a6c2$var$Nc && $83602c5f7959a6c2$var$ad($83602c5f7959a6c2$var$Nc, a);
    $83602c5f7959a6c2$var$Oc.forEach(b);
    $83602c5f7959a6c2$var$Pc.forEach(b);
    for(c = 0; c < $83602c5f7959a6c2$var$Qc.length; c++)d = $83602c5f7959a6c2$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $83602c5f7959a6c2$var$Qc.length && (c = $83602c5f7959a6c2$var$Qc[0], null === c.blockedOn);)$83602c5f7959a6c2$var$Vc(c), null === c.blockedOn && $83602c5f7959a6c2$var$Qc.shift();
}
var $83602c5f7959a6c2$var$cd = $83602c5f7959a6c2$var$ua.ReactCurrentBatchConfig, $83602c5f7959a6c2$var$dd = !0;
function $83602c5f7959a6c2$var$ed(a, b, c, d) {
    var e = $83602c5f7959a6c2$var$C, f = $83602c5f7959a6c2$var$cd.transition;
    $83602c5f7959a6c2$var$cd.transition = null;
    try {
        $83602c5f7959a6c2$var$C = 1, $83602c5f7959a6c2$var$fd(a, b, c, d);
    } finally{
        $83602c5f7959a6c2$var$C = e, $83602c5f7959a6c2$var$cd.transition = f;
    }
}
function $83602c5f7959a6c2$var$gd(a, b, c, d) {
    var e = $83602c5f7959a6c2$var$C, f = $83602c5f7959a6c2$var$cd.transition;
    $83602c5f7959a6c2$var$cd.transition = null;
    try {
        $83602c5f7959a6c2$var$C = 4, $83602c5f7959a6c2$var$fd(a, b, c, d);
    } finally{
        $83602c5f7959a6c2$var$C = e, $83602c5f7959a6c2$var$cd.transition = f;
    }
}
function $83602c5f7959a6c2$var$fd(a, b, c, d) {
    if ($83602c5f7959a6c2$var$dd) {
        var e = $83602c5f7959a6c2$var$Yc(a, b, c, d);
        if (null === e) $83602c5f7959a6c2$var$hd(a, b, d, $83602c5f7959a6c2$var$id, c), $83602c5f7959a6c2$var$Sc(a, d);
        else if ($83602c5f7959a6c2$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($83602c5f7959a6c2$var$Sc(a, d), b & 4 && -1 < $83602c5f7959a6c2$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $83602c5f7959a6c2$var$Cb(e);
                null !== f && $83602c5f7959a6c2$var$Ec(f);
                f = $83602c5f7959a6c2$var$Yc(a, b, c, d);
                null === f && $83602c5f7959a6c2$var$hd(a, b, d, $83602c5f7959a6c2$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $83602c5f7959a6c2$var$hd(a, b, d, null, c);
    }
}
var $83602c5f7959a6c2$var$id = null;
function $83602c5f7959a6c2$var$Yc(a, b, c, d) {
    $83602c5f7959a6c2$var$id = null;
    a = $83602c5f7959a6c2$var$xb(d);
    a = $83602c5f7959a6c2$var$Wc(a);
    if (null !== a) {
        if (b = $83602c5f7959a6c2$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $83602c5f7959a6c2$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $83602c5f7959a6c2$var$id = a;
    return null;
}
function $83602c5f7959a6c2$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($83602c5f7959a6c2$var$ec()){
                case $83602c5f7959a6c2$var$fc:
                    return 1;
                case $83602c5f7959a6c2$var$gc:
                    return 4;
                case $83602c5f7959a6c2$var$hc:
                case $83602c5f7959a6c2$var$ic:
                    return 16;
                case $83602c5f7959a6c2$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $83602c5f7959a6c2$var$kd = null, $83602c5f7959a6c2$var$ld = null, $83602c5f7959a6c2$var$md = null;
function $83602c5f7959a6c2$var$nd() {
    if ($83602c5f7959a6c2$var$md) return $83602c5f7959a6c2$var$md;
    var a, b = $83602c5f7959a6c2$var$ld, c = b.length, d, e = "value" in $83602c5f7959a6c2$var$kd ? $83602c5f7959a6c2$var$kd.value : $83602c5f7959a6c2$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $83602c5f7959a6c2$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $83602c5f7959a6c2$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $83602c5f7959a6c2$var$pd() {
    return !0;
}
function $83602c5f7959a6c2$var$qd() {
    return !1;
}
function $83602c5f7959a6c2$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $83602c5f7959a6c2$var$pd : $83602c5f7959a6c2$var$qd;
        this.isPropagationStopped = $83602c5f7959a6c2$var$qd;
        return this;
    }
    $83602c5f7959a6c2$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $83602c5f7959a6c2$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $83602c5f7959a6c2$var$pd);
        },
        persist: function() {},
        isPersistent: $83602c5f7959a6c2$var$pd
    });
    return b;
}
var $83602c5f7959a6c2$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $83602c5f7959a6c2$var$td = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$sd), $83602c5f7959a6c2$var$ud = $83602c5f7959a6c2$var$A({}, $83602c5f7959a6c2$var$sd, {
    view: 0,
    detail: 0
}), $83602c5f7959a6c2$var$vd = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$ud), $83602c5f7959a6c2$var$wd, $83602c5f7959a6c2$var$xd, $83602c5f7959a6c2$var$yd, $83602c5f7959a6c2$var$Ad = $83602c5f7959a6c2$var$A({}, $83602c5f7959a6c2$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $83602c5f7959a6c2$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $83602c5f7959a6c2$var$yd && ($83602c5f7959a6c2$var$yd && "mousemove" === a.type ? ($83602c5f7959a6c2$var$wd = a.screenX - $83602c5f7959a6c2$var$yd.screenX, $83602c5f7959a6c2$var$xd = a.screenY - $83602c5f7959a6c2$var$yd.screenY) : $83602c5f7959a6c2$var$xd = $83602c5f7959a6c2$var$wd = 0, $83602c5f7959a6c2$var$yd = a);
        return $83602c5f7959a6c2$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $83602c5f7959a6c2$var$xd;
    }
}), $83602c5f7959a6c2$var$Bd = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$Ad), $83602c5f7959a6c2$var$Cd = $83602c5f7959a6c2$var$A({}, $83602c5f7959a6c2$var$Ad, {
    dataTransfer: 0
}), $83602c5f7959a6c2$var$Dd = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$Cd), $83602c5f7959a6c2$var$Ed = $83602c5f7959a6c2$var$A({}, $83602c5f7959a6c2$var$ud, {
    relatedTarget: 0
}), $83602c5f7959a6c2$var$Fd = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$Ed), $83602c5f7959a6c2$var$Gd = $83602c5f7959a6c2$var$A({}, $83602c5f7959a6c2$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $83602c5f7959a6c2$var$Hd = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$Gd), $83602c5f7959a6c2$var$Id = $83602c5f7959a6c2$var$A({}, $83602c5f7959a6c2$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $83602c5f7959a6c2$var$Jd = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$Id), $83602c5f7959a6c2$var$Kd = $83602c5f7959a6c2$var$A({}, $83602c5f7959a6c2$var$sd, {
    data: 0
}), $83602c5f7959a6c2$var$Ld = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$Kd), $83602c5f7959a6c2$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $83602c5f7959a6c2$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $83602c5f7959a6c2$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $83602c5f7959a6c2$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $83602c5f7959a6c2$var$Od[a]) ? !!b[a] : !1;
}
function $83602c5f7959a6c2$var$zd() {
    return $83602c5f7959a6c2$var$Pd;
}
var $83602c5f7959a6c2$var$Qd = $83602c5f7959a6c2$var$A({}, $83602c5f7959a6c2$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $83602c5f7959a6c2$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $83602c5f7959a6c2$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $83602c5f7959a6c2$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $83602c5f7959a6c2$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $83602c5f7959a6c2$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $83602c5f7959a6c2$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $83602c5f7959a6c2$var$Rd = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$Qd), $83602c5f7959a6c2$var$Sd = $83602c5f7959a6c2$var$A({}, $83602c5f7959a6c2$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $83602c5f7959a6c2$var$Td = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$Sd), $83602c5f7959a6c2$var$Ud = $83602c5f7959a6c2$var$A({}, $83602c5f7959a6c2$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $83602c5f7959a6c2$var$zd
}), $83602c5f7959a6c2$var$Vd = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$Ud), $83602c5f7959a6c2$var$Wd = $83602c5f7959a6c2$var$A({}, $83602c5f7959a6c2$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $83602c5f7959a6c2$var$Xd = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$Wd), $83602c5f7959a6c2$var$Yd = $83602c5f7959a6c2$var$A({}, $83602c5f7959a6c2$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $83602c5f7959a6c2$var$Zd = $83602c5f7959a6c2$var$rd($83602c5f7959a6c2$var$Yd), $83602c5f7959a6c2$var$$d = [
    9,
    13,
    27,
    32
], $83602c5f7959a6c2$var$ae = $83602c5f7959a6c2$var$ia && "CompositionEvent" in window, $83602c5f7959a6c2$var$be = null;
$83602c5f7959a6c2$var$ia && "documentMode" in document && ($83602c5f7959a6c2$var$be = document.documentMode);
var $83602c5f7959a6c2$var$ce = $83602c5f7959a6c2$var$ia && "TextEvent" in window && !$83602c5f7959a6c2$var$be, $83602c5f7959a6c2$var$de = $83602c5f7959a6c2$var$ia && (!$83602c5f7959a6c2$var$ae || $83602c5f7959a6c2$var$be && 8 < $83602c5f7959a6c2$var$be && 11 >= $83602c5f7959a6c2$var$be), $83602c5f7959a6c2$var$ee = String.fromCharCode(32), $83602c5f7959a6c2$var$fe = !1;
function $83602c5f7959a6c2$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $83602c5f7959a6c2$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $83602c5f7959a6c2$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $83602c5f7959a6c2$var$ie = !1;
function $83602c5f7959a6c2$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $83602c5f7959a6c2$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $83602c5f7959a6c2$var$fe = !0;
            return $83602c5f7959a6c2$var$ee;
        case "textInput":
            return a = b.data, a === $83602c5f7959a6c2$var$ee && $83602c5f7959a6c2$var$fe ? null : a;
        default:
            return null;
    }
}
function $83602c5f7959a6c2$var$ke(a, b) {
    if ($83602c5f7959a6c2$var$ie) return "compositionend" === a || !$83602c5f7959a6c2$var$ae && $83602c5f7959a6c2$var$ge(a, b) ? (a = $83602c5f7959a6c2$var$nd(), $83602c5f7959a6c2$var$md = $83602c5f7959a6c2$var$ld = $83602c5f7959a6c2$var$kd = null, $83602c5f7959a6c2$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $83602c5f7959a6c2$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $83602c5f7959a6c2$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $83602c5f7959a6c2$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$83602c5f7959a6c2$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $83602c5f7959a6c2$var$ne(a, b, c, d) {
    $83602c5f7959a6c2$var$Eb(d);
    b = $83602c5f7959a6c2$var$oe(b, "onChange");
    0 < b.length && (c = new $83602c5f7959a6c2$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $83602c5f7959a6c2$var$pe = null, $83602c5f7959a6c2$var$qe = null;
function $83602c5f7959a6c2$var$re(a) {
    $83602c5f7959a6c2$var$se(a, 0);
}
function $83602c5f7959a6c2$var$te(a) {
    var b = $83602c5f7959a6c2$var$ue(a);
    if ($83602c5f7959a6c2$var$Wa(b)) return a;
}
function $83602c5f7959a6c2$var$ve(a, b) {
    if ("change" === a) return b;
}
var $83602c5f7959a6c2$var$we = !1;
if ($83602c5f7959a6c2$var$ia) {
    var $83602c5f7959a6c2$var$xe;
    if ($83602c5f7959a6c2$var$ia) {
        var $83602c5f7959a6c2$var$ye = "oninput" in document;
        if (!$83602c5f7959a6c2$var$ye) {
            var $83602c5f7959a6c2$var$ze = document.createElement("div");
            $83602c5f7959a6c2$var$ze.setAttribute("oninput", "return;");
            $83602c5f7959a6c2$var$ye = "function" === typeof $83602c5f7959a6c2$var$ze.oninput;
        }
        $83602c5f7959a6c2$var$xe = $83602c5f7959a6c2$var$ye;
    } else $83602c5f7959a6c2$var$xe = !1;
    $83602c5f7959a6c2$var$we = $83602c5f7959a6c2$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $83602c5f7959a6c2$var$Ae() {
    $83602c5f7959a6c2$var$pe && ($83602c5f7959a6c2$var$pe.detachEvent("onpropertychange", $83602c5f7959a6c2$var$Be), $83602c5f7959a6c2$var$qe = $83602c5f7959a6c2$var$pe = null);
}
function $83602c5f7959a6c2$var$Be(a) {
    if ("value" === a.propertyName && $83602c5f7959a6c2$var$te($83602c5f7959a6c2$var$qe)) {
        var b = [];
        $83602c5f7959a6c2$var$ne(b, $83602c5f7959a6c2$var$qe, a, $83602c5f7959a6c2$var$xb(a));
        $83602c5f7959a6c2$var$Jb($83602c5f7959a6c2$var$re, b);
    }
}
function $83602c5f7959a6c2$var$Ce(a, b, c) {
    "focusin" === a ? ($83602c5f7959a6c2$var$Ae(), $83602c5f7959a6c2$var$pe = b, $83602c5f7959a6c2$var$qe = c, $83602c5f7959a6c2$var$pe.attachEvent("onpropertychange", $83602c5f7959a6c2$var$Be)) : "focusout" === a && $83602c5f7959a6c2$var$Ae();
}
function $83602c5f7959a6c2$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $83602c5f7959a6c2$var$te($83602c5f7959a6c2$var$qe);
}
function $83602c5f7959a6c2$var$Ee(a, b) {
    if ("click" === a) return $83602c5f7959a6c2$var$te(b);
}
function $83602c5f7959a6c2$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $83602c5f7959a6c2$var$te(b);
}
function $83602c5f7959a6c2$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $83602c5f7959a6c2$var$He = "function" === typeof Object.is ? Object.is : $83602c5f7959a6c2$var$Ge;
function $83602c5f7959a6c2$var$Ie(a, b) {
    if ($83602c5f7959a6c2$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$83602c5f7959a6c2$var$ja.call(b, e) || !$83602c5f7959a6c2$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $83602c5f7959a6c2$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $83602c5f7959a6c2$var$Ke(a, b) {
    var c = $83602c5f7959a6c2$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $83602c5f7959a6c2$var$Je(c);
    }
}
function $83602c5f7959a6c2$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $83602c5f7959a6c2$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $83602c5f7959a6c2$var$Me() {
    for(var a = window, b = $83602c5f7959a6c2$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $83602c5f7959a6c2$var$Xa(a.document);
    }
    return b;
}
function $83602c5f7959a6c2$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $83602c5f7959a6c2$var$Oe(a) {
    var b = $83602c5f7959a6c2$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $83602c5f7959a6c2$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $83602c5f7959a6c2$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $83602c5f7959a6c2$var$Ke(c, f);
                var g = $83602c5f7959a6c2$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $83602c5f7959a6c2$var$Pe = $83602c5f7959a6c2$var$ia && "documentMode" in document && 11 >= document.documentMode, $83602c5f7959a6c2$var$Qe = null, $83602c5f7959a6c2$var$Re = null, $83602c5f7959a6c2$var$Se = null, $83602c5f7959a6c2$var$Te = !1;
function $83602c5f7959a6c2$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $83602c5f7959a6c2$var$Te || null == $83602c5f7959a6c2$var$Qe || $83602c5f7959a6c2$var$Qe !== $83602c5f7959a6c2$var$Xa(d) || (d = $83602c5f7959a6c2$var$Qe, "selectionStart" in d && $83602c5f7959a6c2$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $83602c5f7959a6c2$var$Se && $83602c5f7959a6c2$var$Ie($83602c5f7959a6c2$var$Se, d) || ($83602c5f7959a6c2$var$Se = d, d = $83602c5f7959a6c2$var$oe($83602c5f7959a6c2$var$Re, "onSelect"), 0 < d.length && (b = new $83602c5f7959a6c2$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $83602c5f7959a6c2$var$Qe)));
}
function $83602c5f7959a6c2$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $83602c5f7959a6c2$var$We = {
    animationend: $83602c5f7959a6c2$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $83602c5f7959a6c2$var$Ve("Animation", "AnimationIteration"),
    animationstart: $83602c5f7959a6c2$var$Ve("Animation", "AnimationStart"),
    transitionend: $83602c5f7959a6c2$var$Ve("Transition", "TransitionEnd")
}, $83602c5f7959a6c2$var$Xe = {}, $83602c5f7959a6c2$var$Ye = {};
$83602c5f7959a6c2$var$ia && ($83602c5f7959a6c2$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $83602c5f7959a6c2$var$We.animationend.animation, delete $83602c5f7959a6c2$var$We.animationiteration.animation, delete $83602c5f7959a6c2$var$We.animationstart.animation), "TransitionEvent" in window || delete $83602c5f7959a6c2$var$We.transitionend.transition);
function $83602c5f7959a6c2$var$Ze(a) {
    if ($83602c5f7959a6c2$var$Xe[a]) return $83602c5f7959a6c2$var$Xe[a];
    if (!$83602c5f7959a6c2$var$We[a]) return a;
    var b = $83602c5f7959a6c2$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $83602c5f7959a6c2$var$Ye) return $83602c5f7959a6c2$var$Xe[a] = b[c];
    return a;
}
var $83602c5f7959a6c2$var$$e = $83602c5f7959a6c2$var$Ze("animationend"), $83602c5f7959a6c2$var$af = $83602c5f7959a6c2$var$Ze("animationiteration"), $83602c5f7959a6c2$var$bf = $83602c5f7959a6c2$var$Ze("animationstart"), $83602c5f7959a6c2$var$cf = $83602c5f7959a6c2$var$Ze("transitionend"), $83602c5f7959a6c2$var$df = new Map, $83602c5f7959a6c2$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $83602c5f7959a6c2$var$ff(a, b) {
    $83602c5f7959a6c2$var$df.set(a, b);
    $83602c5f7959a6c2$var$fa(b, [
        a
    ]);
}
for(var $83602c5f7959a6c2$var$gf = 0; $83602c5f7959a6c2$var$gf < $83602c5f7959a6c2$var$ef.length; $83602c5f7959a6c2$var$gf++){
    var $83602c5f7959a6c2$var$hf = $83602c5f7959a6c2$var$ef[$83602c5f7959a6c2$var$gf], $83602c5f7959a6c2$var$jf = $83602c5f7959a6c2$var$hf.toLowerCase(), $83602c5f7959a6c2$var$kf = $83602c5f7959a6c2$var$hf[0].toUpperCase() + $83602c5f7959a6c2$var$hf.slice(1);
    $83602c5f7959a6c2$var$ff($83602c5f7959a6c2$var$jf, "on" + $83602c5f7959a6c2$var$kf);
}
$83602c5f7959a6c2$var$ff($83602c5f7959a6c2$var$$e, "onAnimationEnd");
$83602c5f7959a6c2$var$ff($83602c5f7959a6c2$var$af, "onAnimationIteration");
$83602c5f7959a6c2$var$ff($83602c5f7959a6c2$var$bf, "onAnimationStart");
$83602c5f7959a6c2$var$ff("dblclick", "onDoubleClick");
$83602c5f7959a6c2$var$ff("focusin", "onFocus");
$83602c5f7959a6c2$var$ff("focusout", "onBlur");
$83602c5f7959a6c2$var$ff($83602c5f7959a6c2$var$cf, "onTransitionEnd");
$83602c5f7959a6c2$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$83602c5f7959a6c2$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$83602c5f7959a6c2$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$83602c5f7959a6c2$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$83602c5f7959a6c2$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$83602c5f7959a6c2$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$83602c5f7959a6c2$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$83602c5f7959a6c2$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$83602c5f7959a6c2$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$83602c5f7959a6c2$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $83602c5f7959a6c2$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $83602c5f7959a6c2$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($83602c5f7959a6c2$var$lf));
function $83602c5f7959a6c2$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $83602c5f7959a6c2$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $83602c5f7959a6c2$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $83602c5f7959a6c2$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $83602c5f7959a6c2$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($83602c5f7959a6c2$var$Qb) throw a = $83602c5f7959a6c2$var$Rb, $83602c5f7959a6c2$var$Qb = !1, $83602c5f7959a6c2$var$Rb = null, a;
}
function $83602c5f7959a6c2$var$D(a, b) {
    var c = b[$83602c5f7959a6c2$var$of];
    void 0 === c && (c = b[$83602c5f7959a6c2$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($83602c5f7959a6c2$var$pf(b, a, 2, !1), c.add(d));
}
function $83602c5f7959a6c2$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $83602c5f7959a6c2$var$pf(c, a, d, b);
}
var $83602c5f7959a6c2$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $83602c5f7959a6c2$var$sf(a) {
    if (!a[$83602c5f7959a6c2$var$rf]) {
        a[$83602c5f7959a6c2$var$rf] = !0;
        $83602c5f7959a6c2$var$da.forEach(function(b) {
            "selectionchange" !== b && ($83602c5f7959a6c2$var$mf.has(b) || $83602c5f7959a6c2$var$qf(b, !1, a), $83602c5f7959a6c2$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$83602c5f7959a6c2$var$rf] || (b[$83602c5f7959a6c2$var$rf] = !0, $83602c5f7959a6c2$var$qf("selectionchange", !1, b));
    }
}
function $83602c5f7959a6c2$var$pf(a, b, c, d) {
    switch($83602c5f7959a6c2$var$jd(b)){
        case 1:
            var e = $83602c5f7959a6c2$var$ed;
            break;
        case 4:
            e = $83602c5f7959a6c2$var$gd;
            break;
        default:
            e = $83602c5f7959a6c2$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$83602c5f7959a6c2$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $83602c5f7959a6c2$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $83602c5f7959a6c2$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $83602c5f7959a6c2$var$Jb(function() {
        var d = f, e = $83602c5f7959a6c2$var$xb(c), g = [];
        a: {
            var h = $83602c5f7959a6c2$var$df.get(a);
            if (void 0 !== h) {
                var k = $83602c5f7959a6c2$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $83602c5f7959a6c2$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $83602c5f7959a6c2$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $83602c5f7959a6c2$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $83602c5f7959a6c2$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $83602c5f7959a6c2$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $83602c5f7959a6c2$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $83602c5f7959a6c2$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $83602c5f7959a6c2$var$Vd;
                        break;
                    case $83602c5f7959a6c2$var$$e:
                    case $83602c5f7959a6c2$var$af:
                    case $83602c5f7959a6c2$var$bf:
                        k = $83602c5f7959a6c2$var$Hd;
                        break;
                    case $83602c5f7959a6c2$var$cf:
                        k = $83602c5f7959a6c2$var$Xd;
                        break;
                    case "scroll":
                        k = $83602c5f7959a6c2$var$vd;
                        break;
                    case "wheel":
                        k = $83602c5f7959a6c2$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $83602c5f7959a6c2$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $83602c5f7959a6c2$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $83602c5f7959a6c2$var$Kb(w, x), null != F && t.push($83602c5f7959a6c2$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $83602c5f7959a6c2$var$wb && (n = c.relatedTarget || c.fromElement) && ($83602c5f7959a6c2$var$Wc(n) || n[$83602c5f7959a6c2$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $83602c5f7959a6c2$var$Wc(n) : null, null !== n && (J = $83602c5f7959a6c2$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $83602c5f7959a6c2$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $83602c5f7959a6c2$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $83602c5f7959a6c2$var$ue(k);
                        u = null == n ? h : $83602c5f7959a6c2$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $83602c5f7959a6c2$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $83602c5f7959a6c2$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $83602c5f7959a6c2$var$vf(F))u++;
                            for(; 0 < w - u;)t = $83602c5f7959a6c2$var$vf(t), w--;
                            for(; 0 < u - w;)x = $83602c5f7959a6c2$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $83602c5f7959a6c2$var$vf(t);
                                x = $83602c5f7959a6c2$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $83602c5f7959a6c2$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $83602c5f7959a6c2$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $83602c5f7959a6c2$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $83602c5f7959a6c2$var$ve;
                else if ($83602c5f7959a6c2$var$me(h)) {
                    if ($83602c5f7959a6c2$var$we) na = $83602c5f7959a6c2$var$Fe;
                    else {
                        na = $83602c5f7959a6c2$var$De;
                        var xa = $83602c5f7959a6c2$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $83602c5f7959a6c2$var$Ee);
                if (na && (na = na(a, d))) {
                    $83602c5f7959a6c2$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $83602c5f7959a6c2$var$cb(h, "number", h.value);
            }
            xa = d ? $83602c5f7959a6c2$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($83602c5f7959a6c2$var$me(xa) || "true" === xa.contentEditable) $83602c5f7959a6c2$var$Qe = xa, $83602c5f7959a6c2$var$Re = d, $83602c5f7959a6c2$var$Se = null;
                    break;
                case "focusout":
                    $83602c5f7959a6c2$var$Se = $83602c5f7959a6c2$var$Re = $83602c5f7959a6c2$var$Qe = null;
                    break;
                case "mousedown":
                    $83602c5f7959a6c2$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $83602c5f7959a6c2$var$Te = !1;
                    $83602c5f7959a6c2$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($83602c5f7959a6c2$var$Pe) break;
                case "keydown":
                case "keyup":
                    $83602c5f7959a6c2$var$Ue(g, c, e);
            }
            var $a;
            if ($83602c5f7959a6c2$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $83602c5f7959a6c2$var$ie ? $83602c5f7959a6c2$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($83602c5f7959a6c2$var$de && "ko" !== c.locale && ($83602c5f7959a6c2$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $83602c5f7959a6c2$var$ie && ($a = $83602c5f7959a6c2$var$nd()) : ($83602c5f7959a6c2$var$kd = e, $83602c5f7959a6c2$var$ld = "value" in $83602c5f7959a6c2$var$kd ? $83602c5f7959a6c2$var$kd.value : $83602c5f7959a6c2$var$kd.textContent, $83602c5f7959a6c2$var$ie = !0)), xa = $83602c5f7959a6c2$var$oe(d, ba), 0 < xa.length && (ba = new $83602c5f7959a6c2$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $83602c5f7959a6c2$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $83602c5f7959a6c2$var$ce ? $83602c5f7959a6c2$var$je(a, c) : $83602c5f7959a6c2$var$ke(a, c)) d = $83602c5f7959a6c2$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $83602c5f7959a6c2$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $83602c5f7959a6c2$var$se(g, b);
    });
}
function $83602c5f7959a6c2$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $83602c5f7959a6c2$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $83602c5f7959a6c2$var$Kb(a, c), null != f && d.unshift($83602c5f7959a6c2$var$tf(a, f, e)), f = $83602c5f7959a6c2$var$Kb(a, b), null != f && d.push($83602c5f7959a6c2$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $83602c5f7959a6c2$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $83602c5f7959a6c2$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $83602c5f7959a6c2$var$Kb(c, f), null != k && g.unshift($83602c5f7959a6c2$var$tf(c, k, h))) : e || (k = $83602c5f7959a6c2$var$Kb(c, f), null != k && g.push($83602c5f7959a6c2$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $83602c5f7959a6c2$var$xf = /\r\n?/g, $83602c5f7959a6c2$var$yf = /\u0000|\uFFFD/g;
function $83602c5f7959a6c2$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($83602c5f7959a6c2$var$xf, "\n").replace($83602c5f7959a6c2$var$yf, "");
}
function $83602c5f7959a6c2$var$Af(a, b, c) {
    b = $83602c5f7959a6c2$var$zf(b);
    if ($83602c5f7959a6c2$var$zf(a) !== b && c) throw Error($83602c5f7959a6c2$var$p(425));
}
function $83602c5f7959a6c2$var$Bf() {}
var $83602c5f7959a6c2$var$Cf = null, $83602c5f7959a6c2$var$Df = null;
function $83602c5f7959a6c2$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $83602c5f7959a6c2$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $83602c5f7959a6c2$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $83602c5f7959a6c2$var$Hf = "function" === typeof Promise ? Promise : void 0, $83602c5f7959a6c2$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $83602c5f7959a6c2$var$Hf ? function(a) {
    return $83602c5f7959a6c2$var$Hf.resolve(null).then(a).catch($83602c5f7959a6c2$var$If);
} : $83602c5f7959a6c2$var$Ff;
function $83602c5f7959a6c2$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $83602c5f7959a6c2$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $83602c5f7959a6c2$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $83602c5f7959a6c2$var$bd(b);
}
function $83602c5f7959a6c2$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $83602c5f7959a6c2$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $83602c5f7959a6c2$var$Nf = Math.random().toString(36).slice(2), $83602c5f7959a6c2$var$Of = "__reactFiber$" + $83602c5f7959a6c2$var$Nf, $83602c5f7959a6c2$var$Pf = "__reactProps$" + $83602c5f7959a6c2$var$Nf, $83602c5f7959a6c2$var$uf = "__reactContainer$" + $83602c5f7959a6c2$var$Nf, $83602c5f7959a6c2$var$of = "__reactEvents$" + $83602c5f7959a6c2$var$Nf, $83602c5f7959a6c2$var$Qf = "__reactListeners$" + $83602c5f7959a6c2$var$Nf, $83602c5f7959a6c2$var$Rf = "__reactHandles$" + $83602c5f7959a6c2$var$Nf;
function $83602c5f7959a6c2$var$Wc(a) {
    var b = a[$83602c5f7959a6c2$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$83602c5f7959a6c2$var$uf] || c[$83602c5f7959a6c2$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $83602c5f7959a6c2$var$Mf(a); null !== a;){
                if (c = a[$83602c5f7959a6c2$var$Of]) return c;
                a = $83602c5f7959a6c2$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $83602c5f7959a6c2$var$Cb(a) {
    a = a[$83602c5f7959a6c2$var$Of] || a[$83602c5f7959a6c2$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $83602c5f7959a6c2$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($83602c5f7959a6c2$var$p(33));
}
function $83602c5f7959a6c2$var$Db(a) {
    return a[$83602c5f7959a6c2$var$Pf] || null;
}
var $83602c5f7959a6c2$var$Sf = [], $83602c5f7959a6c2$var$Tf = -1;
function $83602c5f7959a6c2$var$Uf(a) {
    return {
        current: a
    };
}
function $83602c5f7959a6c2$var$E(a) {
    0 > $83602c5f7959a6c2$var$Tf || (a.current = $83602c5f7959a6c2$var$Sf[$83602c5f7959a6c2$var$Tf], $83602c5f7959a6c2$var$Sf[$83602c5f7959a6c2$var$Tf] = null, $83602c5f7959a6c2$var$Tf--);
}
function $83602c5f7959a6c2$var$G(a, b) {
    $83602c5f7959a6c2$var$Tf++;
    $83602c5f7959a6c2$var$Sf[$83602c5f7959a6c2$var$Tf] = a.current;
    a.current = b;
}
var $83602c5f7959a6c2$var$Vf = {}, $83602c5f7959a6c2$var$H = $83602c5f7959a6c2$var$Uf($83602c5f7959a6c2$var$Vf), $83602c5f7959a6c2$var$Wf = $83602c5f7959a6c2$var$Uf(!1), $83602c5f7959a6c2$var$Xf = $83602c5f7959a6c2$var$Vf;
function $83602c5f7959a6c2$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $83602c5f7959a6c2$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $83602c5f7959a6c2$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $83602c5f7959a6c2$var$$f() {
    $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$Wf);
    $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$H);
}
function $83602c5f7959a6c2$var$ag(a, b, c) {
    if ($83602c5f7959a6c2$var$H.current !== $83602c5f7959a6c2$var$Vf) throw Error($83602c5f7959a6c2$var$p(168));
    $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$H, b);
    $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$Wf, c);
}
function $83602c5f7959a6c2$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($83602c5f7959a6c2$var$p(108, $83602c5f7959a6c2$var$Ra(a) || "Unknown", e));
    return $83602c5f7959a6c2$var$A({}, c, d);
}
function $83602c5f7959a6c2$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $83602c5f7959a6c2$var$Vf;
    $83602c5f7959a6c2$var$Xf = $83602c5f7959a6c2$var$H.current;
    $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$H, a);
    $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$Wf, $83602c5f7959a6c2$var$Wf.current);
    return !0;
}
function $83602c5f7959a6c2$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($83602c5f7959a6c2$var$p(169));
    c ? (a = $83602c5f7959a6c2$var$bg(a, b, $83602c5f7959a6c2$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$Wf), $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$H), $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$H, a)) : $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$Wf);
    $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$Wf, c);
}
var $83602c5f7959a6c2$var$eg = null, $83602c5f7959a6c2$var$fg = !1, $83602c5f7959a6c2$var$gg = !1;
function $83602c5f7959a6c2$var$hg(a) {
    null === $83602c5f7959a6c2$var$eg ? $83602c5f7959a6c2$var$eg = [
        a
    ] : $83602c5f7959a6c2$var$eg.push(a);
}
function $83602c5f7959a6c2$var$ig(a) {
    $83602c5f7959a6c2$var$fg = !0;
    $83602c5f7959a6c2$var$hg(a);
}
function $83602c5f7959a6c2$var$jg() {
    if (!$83602c5f7959a6c2$var$gg && null !== $83602c5f7959a6c2$var$eg) {
        $83602c5f7959a6c2$var$gg = !0;
        var a = 0, b = $83602c5f7959a6c2$var$C;
        try {
            var c = $83602c5f7959a6c2$var$eg;
            for($83602c5f7959a6c2$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $83602c5f7959a6c2$var$eg = null;
            $83602c5f7959a6c2$var$fg = !1;
        } catch (e) {
            throw null !== $83602c5f7959a6c2$var$eg && ($83602c5f7959a6c2$var$eg = $83602c5f7959a6c2$var$eg.slice(a + 1)), $83602c5f7959a6c2$var$ac($83602c5f7959a6c2$var$fc, $83602c5f7959a6c2$var$jg), e;
        } finally{
            $83602c5f7959a6c2$var$C = b, $83602c5f7959a6c2$var$gg = !1;
        }
    }
    return null;
}
var $83602c5f7959a6c2$var$kg = [], $83602c5f7959a6c2$var$lg = 0, $83602c5f7959a6c2$var$mg = null, $83602c5f7959a6c2$var$ng = 0, $83602c5f7959a6c2$var$og = [], $83602c5f7959a6c2$var$pg = 0, $83602c5f7959a6c2$var$qg = null, $83602c5f7959a6c2$var$rg = 1, $83602c5f7959a6c2$var$sg = "";
function $83602c5f7959a6c2$var$tg(a, b) {
    $83602c5f7959a6c2$var$kg[$83602c5f7959a6c2$var$lg++] = $83602c5f7959a6c2$var$ng;
    $83602c5f7959a6c2$var$kg[$83602c5f7959a6c2$var$lg++] = $83602c5f7959a6c2$var$mg;
    $83602c5f7959a6c2$var$mg = a;
    $83602c5f7959a6c2$var$ng = b;
}
function $83602c5f7959a6c2$var$ug(a, b, c) {
    $83602c5f7959a6c2$var$og[$83602c5f7959a6c2$var$pg++] = $83602c5f7959a6c2$var$rg;
    $83602c5f7959a6c2$var$og[$83602c5f7959a6c2$var$pg++] = $83602c5f7959a6c2$var$sg;
    $83602c5f7959a6c2$var$og[$83602c5f7959a6c2$var$pg++] = $83602c5f7959a6c2$var$qg;
    $83602c5f7959a6c2$var$qg = a;
    var d = $83602c5f7959a6c2$var$rg;
    a = $83602c5f7959a6c2$var$sg;
    var e = 32 - $83602c5f7959a6c2$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $83602c5f7959a6c2$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $83602c5f7959a6c2$var$rg = 1 << 32 - $83602c5f7959a6c2$var$oc(b) + e | c << e | d;
        $83602c5f7959a6c2$var$sg = f + a;
    } else $83602c5f7959a6c2$var$rg = 1 << f | c << e | d, $83602c5f7959a6c2$var$sg = a;
}
function $83602c5f7959a6c2$var$vg(a) {
    null !== a.return && ($83602c5f7959a6c2$var$tg(a, 1), $83602c5f7959a6c2$var$ug(a, 1, 0));
}
function $83602c5f7959a6c2$var$wg(a) {
    for(; a === $83602c5f7959a6c2$var$mg;)$83602c5f7959a6c2$var$mg = $83602c5f7959a6c2$var$kg[--$83602c5f7959a6c2$var$lg], $83602c5f7959a6c2$var$kg[$83602c5f7959a6c2$var$lg] = null, $83602c5f7959a6c2$var$ng = $83602c5f7959a6c2$var$kg[--$83602c5f7959a6c2$var$lg], $83602c5f7959a6c2$var$kg[$83602c5f7959a6c2$var$lg] = null;
    for(; a === $83602c5f7959a6c2$var$qg;)$83602c5f7959a6c2$var$qg = $83602c5f7959a6c2$var$og[--$83602c5f7959a6c2$var$pg], $83602c5f7959a6c2$var$og[$83602c5f7959a6c2$var$pg] = null, $83602c5f7959a6c2$var$sg = $83602c5f7959a6c2$var$og[--$83602c5f7959a6c2$var$pg], $83602c5f7959a6c2$var$og[$83602c5f7959a6c2$var$pg] = null, $83602c5f7959a6c2$var$rg = $83602c5f7959a6c2$var$og[--$83602c5f7959a6c2$var$pg], $83602c5f7959a6c2$var$og[$83602c5f7959a6c2$var$pg] = null;
}
var $83602c5f7959a6c2$var$xg = null, $83602c5f7959a6c2$var$yg = null, $83602c5f7959a6c2$var$I = !1, $83602c5f7959a6c2$var$zg = null;
function $83602c5f7959a6c2$var$Ag(a, b) {
    var c = $83602c5f7959a6c2$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $83602c5f7959a6c2$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $83602c5f7959a6c2$var$xg = a, $83602c5f7959a6c2$var$yg = $83602c5f7959a6c2$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $83602c5f7959a6c2$var$xg = a, $83602c5f7959a6c2$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $83602c5f7959a6c2$var$qg ? {
                id: $83602c5f7959a6c2$var$rg,
                overflow: $83602c5f7959a6c2$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $83602c5f7959a6c2$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $83602c5f7959a6c2$var$xg = a, $83602c5f7959a6c2$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $83602c5f7959a6c2$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $83602c5f7959a6c2$var$Eg(a) {
    if ($83602c5f7959a6c2$var$I) {
        var b = $83602c5f7959a6c2$var$yg;
        if (b) {
            var c = b;
            if (!$83602c5f7959a6c2$var$Cg(a, b)) {
                if ($83602c5f7959a6c2$var$Dg(a)) throw Error($83602c5f7959a6c2$var$p(418));
                b = $83602c5f7959a6c2$var$Lf(c.nextSibling);
                var d = $83602c5f7959a6c2$var$xg;
                b && $83602c5f7959a6c2$var$Cg(a, b) ? $83602c5f7959a6c2$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $83602c5f7959a6c2$var$I = !1, $83602c5f7959a6c2$var$xg = a);
            }
        } else {
            if ($83602c5f7959a6c2$var$Dg(a)) throw Error($83602c5f7959a6c2$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $83602c5f7959a6c2$var$I = !1;
            $83602c5f7959a6c2$var$xg = a;
        }
    }
}
function $83602c5f7959a6c2$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $83602c5f7959a6c2$var$xg = a;
}
function $83602c5f7959a6c2$var$Gg(a) {
    if (a !== $83602c5f7959a6c2$var$xg) return !1;
    if (!$83602c5f7959a6c2$var$I) return $83602c5f7959a6c2$var$Fg(a), $83602c5f7959a6c2$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$83602c5f7959a6c2$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $83602c5f7959a6c2$var$yg)) {
        if ($83602c5f7959a6c2$var$Dg(a)) throw $83602c5f7959a6c2$var$Hg(), Error($83602c5f7959a6c2$var$p(418));
        for(; b;)$83602c5f7959a6c2$var$Ag(a, b), b = $83602c5f7959a6c2$var$Lf(b.nextSibling);
    }
    $83602c5f7959a6c2$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($83602c5f7959a6c2$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $83602c5f7959a6c2$var$yg = $83602c5f7959a6c2$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $83602c5f7959a6c2$var$yg = null;
        }
    } else $83602c5f7959a6c2$var$yg = $83602c5f7959a6c2$var$xg ? $83602c5f7959a6c2$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $83602c5f7959a6c2$var$Hg() {
    for(var a = $83602c5f7959a6c2$var$yg; a;)a = $83602c5f7959a6c2$var$Lf(a.nextSibling);
}
function $83602c5f7959a6c2$var$Ig() {
    $83602c5f7959a6c2$var$yg = $83602c5f7959a6c2$var$xg = null;
    $83602c5f7959a6c2$var$I = !1;
}
function $83602c5f7959a6c2$var$Jg(a) {
    null === $83602c5f7959a6c2$var$zg ? $83602c5f7959a6c2$var$zg = [
        a
    ] : $83602c5f7959a6c2$var$zg.push(a);
}
var $83602c5f7959a6c2$var$Kg = $83602c5f7959a6c2$var$ua.ReactCurrentBatchConfig;
function $83602c5f7959a6c2$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($83602c5f7959a6c2$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($83602c5f7959a6c2$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($83602c5f7959a6c2$var$p(284));
        if (!c._owner) throw Error($83602c5f7959a6c2$var$p(290, a));
    }
    return a;
}
function $83602c5f7959a6c2$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($83602c5f7959a6c2$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $83602c5f7959a6c2$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $83602c5f7959a6c2$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $83602c5f7959a6c2$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $83602c5f7959a6c2$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $83602c5f7959a6c2$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $83602c5f7959a6c2$var$Ha && $83602c5f7959a6c2$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $83602c5f7959a6c2$var$Lg(a, b, c), d.return = a, d;
        d = $83602c5f7959a6c2$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $83602c5f7959a6c2$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $83602c5f7959a6c2$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $83602c5f7959a6c2$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $83602c5f7959a6c2$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $83602c5f7959a6c2$var$va:
                    return c = $83602c5f7959a6c2$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $83602c5f7959a6c2$var$Lg(a, null, b), c.return = a, c;
                case $83602c5f7959a6c2$var$wa:
                    return b = $83602c5f7959a6c2$var$Sg(b, a.mode, c), b.return = a, b;
                case $83602c5f7959a6c2$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($83602c5f7959a6c2$var$eb(b) || $83602c5f7959a6c2$var$Ka(b)) return b = $83602c5f7959a6c2$var$Tg(b, a.mode, c, null), b.return = a, b;
            $83602c5f7959a6c2$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $83602c5f7959a6c2$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $83602c5f7959a6c2$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $83602c5f7959a6c2$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($83602c5f7959a6c2$var$eb(c) || $83602c5f7959a6c2$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $83602c5f7959a6c2$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $83602c5f7959a6c2$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $83602c5f7959a6c2$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $83602c5f7959a6c2$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($83602c5f7959a6c2$var$eb(d) || $83602c5f7959a6c2$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $83602c5f7959a6c2$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $83602c5f7959a6c2$var$I && $83602c5f7959a6c2$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $83602c5f7959a6c2$var$I && $83602c5f7959a6c2$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $83602c5f7959a6c2$var$I && $83602c5f7959a6c2$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $83602c5f7959a6c2$var$Ka(h);
        if ("function" !== typeof l) throw Error($83602c5f7959a6c2$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($83602c5f7959a6c2$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $83602c5f7959a6c2$var$I && $83602c5f7959a6c2$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $83602c5f7959a6c2$var$I && $83602c5f7959a6c2$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $83602c5f7959a6c2$var$I && $83602c5f7959a6c2$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $83602c5f7959a6c2$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $83602c5f7959a6c2$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $83602c5f7959a6c2$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $83602c5f7959a6c2$var$Ha && $83602c5f7959a6c2$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $83602c5f7959a6c2$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $83602c5f7959a6c2$var$ya ? (d = $83602c5f7959a6c2$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $83602c5f7959a6c2$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $83602c5f7959a6c2$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $83602c5f7959a6c2$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $83602c5f7959a6c2$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $83602c5f7959a6c2$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($83602c5f7959a6c2$var$eb(f)) return n(a, d, f, h);
            if ($83602c5f7959a6c2$var$Ka(f)) return t(a, d, f, h);
            $83602c5f7959a6c2$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $83602c5f7959a6c2$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $83602c5f7959a6c2$var$Ug = $83602c5f7959a6c2$var$Og(!0), $83602c5f7959a6c2$var$Vg = $83602c5f7959a6c2$var$Og(!1), $83602c5f7959a6c2$var$Wg = $83602c5f7959a6c2$var$Uf(null), $83602c5f7959a6c2$var$Xg = null, $83602c5f7959a6c2$var$Yg = null, $83602c5f7959a6c2$var$Zg = null;
function $83602c5f7959a6c2$var$$g() {
    $83602c5f7959a6c2$var$Zg = $83602c5f7959a6c2$var$Yg = $83602c5f7959a6c2$var$Xg = null;
}
function $83602c5f7959a6c2$var$ah(a) {
    var b = $83602c5f7959a6c2$var$Wg.current;
    $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$Wg);
    a._currentValue = b;
}
function $83602c5f7959a6c2$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $83602c5f7959a6c2$var$ch(a, b) {
    $83602c5f7959a6c2$var$Xg = a;
    $83602c5f7959a6c2$var$Zg = $83602c5f7959a6c2$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($83602c5f7959a6c2$var$dh = !0), a.firstContext = null);
}
function $83602c5f7959a6c2$var$eh(a) {
    var b = a._currentValue;
    if ($83602c5f7959a6c2$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $83602c5f7959a6c2$var$Yg) {
            if (null === $83602c5f7959a6c2$var$Xg) throw Error($83602c5f7959a6c2$var$p(308));
            $83602c5f7959a6c2$var$Yg = a;
            $83602c5f7959a6c2$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $83602c5f7959a6c2$var$Yg = $83602c5f7959a6c2$var$Yg.next = a;
    }
    return b;
}
var $83602c5f7959a6c2$var$fh = null;
function $83602c5f7959a6c2$var$gh(a) {
    null === $83602c5f7959a6c2$var$fh ? $83602c5f7959a6c2$var$fh = [
        a
    ] : $83602c5f7959a6c2$var$fh.push(a);
}
function $83602c5f7959a6c2$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $83602c5f7959a6c2$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $83602c5f7959a6c2$var$ih(a, d);
}
function $83602c5f7959a6c2$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $83602c5f7959a6c2$var$jh = !1;
function $83602c5f7959a6c2$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $83602c5f7959a6c2$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $83602c5f7959a6c2$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $83602c5f7959a6c2$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($83602c5f7959a6c2$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $83602c5f7959a6c2$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $83602c5f7959a6c2$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $83602c5f7959a6c2$var$ih(a, c);
}
function $83602c5f7959a6c2$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $83602c5f7959a6c2$var$Cc(a, c);
    }
}
function $83602c5f7959a6c2$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $83602c5f7959a6c2$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $83602c5f7959a6c2$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $83602c5f7959a6c2$var$A({}, q, r);
                            break a;
                        case 2:
                            $83602c5f7959a6c2$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $83602c5f7959a6c2$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $83602c5f7959a6c2$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($83602c5f7959a6c2$var$p(191, e));
            e.call(d);
        }
    }
}
var $83602c5f7959a6c2$var$th = {}, $83602c5f7959a6c2$var$uh = $83602c5f7959a6c2$var$Uf($83602c5f7959a6c2$var$th), $83602c5f7959a6c2$var$vh = $83602c5f7959a6c2$var$Uf($83602c5f7959a6c2$var$th), $83602c5f7959a6c2$var$wh = $83602c5f7959a6c2$var$Uf($83602c5f7959a6c2$var$th);
function $83602c5f7959a6c2$var$xh(a) {
    if (a === $83602c5f7959a6c2$var$th) throw Error($83602c5f7959a6c2$var$p(174));
    return a;
}
function $83602c5f7959a6c2$var$yh(a, b) {
    $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$wh, b);
    $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$vh, a);
    $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$uh, $83602c5f7959a6c2$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $83602c5f7959a6c2$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $83602c5f7959a6c2$var$lb(b, a);
    }
    $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$uh);
    $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$uh, b);
}
function $83602c5f7959a6c2$var$zh() {
    $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$uh);
    $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$vh);
    $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$wh);
}
function $83602c5f7959a6c2$var$Ah(a) {
    $83602c5f7959a6c2$var$xh($83602c5f7959a6c2$var$wh.current);
    var b = $83602c5f7959a6c2$var$xh($83602c5f7959a6c2$var$uh.current);
    var c = $83602c5f7959a6c2$var$lb(b, a.type);
    b !== c && ($83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$vh, a), $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$uh, c));
}
function $83602c5f7959a6c2$var$Bh(a) {
    $83602c5f7959a6c2$var$vh.current === a && ($83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$uh), $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$vh));
}
var $83602c5f7959a6c2$var$L = $83602c5f7959a6c2$var$Uf(0);
function $83602c5f7959a6c2$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $83602c5f7959a6c2$var$Dh = [];
function $83602c5f7959a6c2$var$Eh() {
    for(var a = 0; a < $83602c5f7959a6c2$var$Dh.length; a++)$83602c5f7959a6c2$var$Dh[a]._workInProgressVersionPrimary = null;
    $83602c5f7959a6c2$var$Dh.length = 0;
}
var $83602c5f7959a6c2$var$Fh = $83602c5f7959a6c2$var$ua.ReactCurrentDispatcher, $83602c5f7959a6c2$var$Gh = $83602c5f7959a6c2$var$ua.ReactCurrentBatchConfig, $83602c5f7959a6c2$var$Hh = 0, $83602c5f7959a6c2$var$M = null, $83602c5f7959a6c2$var$N = null, $83602c5f7959a6c2$var$O = null, $83602c5f7959a6c2$var$Ih = !1, $83602c5f7959a6c2$var$Jh = !1, $83602c5f7959a6c2$var$Kh = 0, $83602c5f7959a6c2$var$Lh = 0;
function $83602c5f7959a6c2$var$P() {
    throw Error($83602c5f7959a6c2$var$p(321));
}
function $83602c5f7959a6c2$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$83602c5f7959a6c2$var$He(a[c], b[c])) return !1;
    return !0;
}
function $83602c5f7959a6c2$var$Nh(a, b, c, d, e, f) {
    $83602c5f7959a6c2$var$Hh = f;
    $83602c5f7959a6c2$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $83602c5f7959a6c2$var$Fh.current = null === a || null === a.memoizedState ? $83602c5f7959a6c2$var$Oh : $83602c5f7959a6c2$var$Ph;
    a = c(d, e);
    if ($83602c5f7959a6c2$var$Jh) {
        f = 0;
        do {
            $83602c5f7959a6c2$var$Jh = !1;
            $83602c5f7959a6c2$var$Kh = 0;
            if (25 <= f) throw Error($83602c5f7959a6c2$var$p(301));
            f += 1;
            $83602c5f7959a6c2$var$O = $83602c5f7959a6c2$var$N = null;
            b.updateQueue = null;
            $83602c5f7959a6c2$var$Fh.current = $83602c5f7959a6c2$var$Qh;
            a = c(d, e);
        }while ($83602c5f7959a6c2$var$Jh);
    }
    $83602c5f7959a6c2$var$Fh.current = $83602c5f7959a6c2$var$Rh;
    b = null !== $83602c5f7959a6c2$var$N && null !== $83602c5f7959a6c2$var$N.next;
    $83602c5f7959a6c2$var$Hh = 0;
    $83602c5f7959a6c2$var$O = $83602c5f7959a6c2$var$N = $83602c5f7959a6c2$var$M = null;
    $83602c5f7959a6c2$var$Ih = !1;
    if (b) throw Error($83602c5f7959a6c2$var$p(300));
    return a;
}
function $83602c5f7959a6c2$var$Sh() {
    var a = 0 !== $83602c5f7959a6c2$var$Kh;
    $83602c5f7959a6c2$var$Kh = 0;
    return a;
}
function $83602c5f7959a6c2$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $83602c5f7959a6c2$var$O ? $83602c5f7959a6c2$var$M.memoizedState = $83602c5f7959a6c2$var$O = a : $83602c5f7959a6c2$var$O = $83602c5f7959a6c2$var$O.next = a;
    return $83602c5f7959a6c2$var$O;
}
function $83602c5f7959a6c2$var$Uh() {
    if (null === $83602c5f7959a6c2$var$N) {
        var a = $83602c5f7959a6c2$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $83602c5f7959a6c2$var$N.next;
    var b = null === $83602c5f7959a6c2$var$O ? $83602c5f7959a6c2$var$M.memoizedState : $83602c5f7959a6c2$var$O.next;
    if (null !== b) $83602c5f7959a6c2$var$O = b, $83602c5f7959a6c2$var$N = a;
    else {
        if (null === a) throw Error($83602c5f7959a6c2$var$p(310));
        $83602c5f7959a6c2$var$N = a;
        a = {
            memoizedState: $83602c5f7959a6c2$var$N.memoizedState,
            baseState: $83602c5f7959a6c2$var$N.baseState,
            baseQueue: $83602c5f7959a6c2$var$N.baseQueue,
            queue: $83602c5f7959a6c2$var$N.queue,
            next: null
        };
        null === $83602c5f7959a6c2$var$O ? $83602c5f7959a6c2$var$M.memoizedState = $83602c5f7959a6c2$var$O = a : $83602c5f7959a6c2$var$O = $83602c5f7959a6c2$var$O.next = a;
    }
    return $83602c5f7959a6c2$var$O;
}
function $83602c5f7959a6c2$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $83602c5f7959a6c2$var$Wh(a) {
    var b = $83602c5f7959a6c2$var$Uh(), c = b.queue;
    if (null === c) throw Error($83602c5f7959a6c2$var$p(311));
    c.lastRenderedReducer = a;
    var d = $83602c5f7959a6c2$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($83602c5f7959a6c2$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $83602c5f7959a6c2$var$M.lanes |= m;
                $83602c5f7959a6c2$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $83602c5f7959a6c2$var$He(d, b.memoizedState) || ($83602c5f7959a6c2$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $83602c5f7959a6c2$var$M.lanes |= f, $83602c5f7959a6c2$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $83602c5f7959a6c2$var$Xh(a) {
    var b = $83602c5f7959a6c2$var$Uh(), c = b.queue;
    if (null === c) throw Error($83602c5f7959a6c2$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $83602c5f7959a6c2$var$He(f, b.memoizedState) || ($83602c5f7959a6c2$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $83602c5f7959a6c2$var$Yh() {}
function $83602c5f7959a6c2$var$Zh(a, b) {
    var c = $83602c5f7959a6c2$var$M, d = $83602c5f7959a6c2$var$Uh(), e = b(), f = !$83602c5f7959a6c2$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $83602c5f7959a6c2$var$dh = !0);
    d = d.queue;
    $83602c5f7959a6c2$var$$h($83602c5f7959a6c2$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $83602c5f7959a6c2$var$O && $83602c5f7959a6c2$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $83602c5f7959a6c2$var$bi(9, $83602c5f7959a6c2$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $83602c5f7959a6c2$var$Q) throw Error($83602c5f7959a6c2$var$p(349));
        0 !== ($83602c5f7959a6c2$var$Hh & 30) || $83602c5f7959a6c2$var$di(c, b, e);
    }
    return e;
}
function $83602c5f7959a6c2$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $83602c5f7959a6c2$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $83602c5f7959a6c2$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $83602c5f7959a6c2$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $83602c5f7959a6c2$var$ei(b) && $83602c5f7959a6c2$var$fi(a);
}
function $83602c5f7959a6c2$var$ai(a, b, c) {
    return c(function() {
        $83602c5f7959a6c2$var$ei(b) && $83602c5f7959a6c2$var$fi(a);
    });
}
function $83602c5f7959a6c2$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$83602c5f7959a6c2$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $83602c5f7959a6c2$var$fi(a) {
    var b = $83602c5f7959a6c2$var$ih(a, 1);
    null !== b && $83602c5f7959a6c2$var$gi(b, a, 1, -1);
}
function $83602c5f7959a6c2$var$hi(a) {
    var b = $83602c5f7959a6c2$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $83602c5f7959a6c2$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $83602c5f7959a6c2$var$ii.bind(null, $83602c5f7959a6c2$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $83602c5f7959a6c2$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $83602c5f7959a6c2$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $83602c5f7959a6c2$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $83602c5f7959a6c2$var$ji() {
    return $83602c5f7959a6c2$var$Uh().memoizedState;
}
function $83602c5f7959a6c2$var$ki(a, b, c, d) {
    var e = $83602c5f7959a6c2$var$Th();
    $83602c5f7959a6c2$var$M.flags |= a;
    e.memoizedState = $83602c5f7959a6c2$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $83602c5f7959a6c2$var$li(a, b, c, d) {
    var e = $83602c5f7959a6c2$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $83602c5f7959a6c2$var$N) {
        var g = $83602c5f7959a6c2$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $83602c5f7959a6c2$var$Mh(d, g.deps)) {
            e.memoizedState = $83602c5f7959a6c2$var$bi(b, c, f, d);
            return;
        }
    }
    $83602c5f7959a6c2$var$M.flags |= a;
    e.memoizedState = $83602c5f7959a6c2$var$bi(1 | b, c, f, d);
}
function $83602c5f7959a6c2$var$mi(a, b) {
    return $83602c5f7959a6c2$var$ki(8390656, 8, a, b);
}
function $83602c5f7959a6c2$var$$h(a, b) {
    return $83602c5f7959a6c2$var$li(2048, 8, a, b);
}
function $83602c5f7959a6c2$var$ni(a, b) {
    return $83602c5f7959a6c2$var$li(4, 2, a, b);
}
function $83602c5f7959a6c2$var$oi(a, b) {
    return $83602c5f7959a6c2$var$li(4, 4, a, b);
}
function $83602c5f7959a6c2$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $83602c5f7959a6c2$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $83602c5f7959a6c2$var$li(4, 4, $83602c5f7959a6c2$var$pi.bind(null, b, a), c);
}
function $83602c5f7959a6c2$var$ri() {}
function $83602c5f7959a6c2$var$si(a, b) {
    var c = $83602c5f7959a6c2$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $83602c5f7959a6c2$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $83602c5f7959a6c2$var$ti(a, b) {
    var c = $83602c5f7959a6c2$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $83602c5f7959a6c2$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $83602c5f7959a6c2$var$ui(a, b, c) {
    if (0 === ($83602c5f7959a6c2$var$Hh & 21)) return a.baseState && (a.baseState = !1, $83602c5f7959a6c2$var$dh = !0), a.memoizedState = c;
    $83602c5f7959a6c2$var$He(c, b) || (c = $83602c5f7959a6c2$var$yc(), $83602c5f7959a6c2$var$M.lanes |= c, $83602c5f7959a6c2$var$rh |= c, a.baseState = !0);
    return b;
}
function $83602c5f7959a6c2$var$vi(a, b) {
    var c = $83602c5f7959a6c2$var$C;
    $83602c5f7959a6c2$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $83602c5f7959a6c2$var$Gh.transition;
    $83602c5f7959a6c2$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $83602c5f7959a6c2$var$C = c, $83602c5f7959a6c2$var$Gh.transition = d;
    }
}
function $83602c5f7959a6c2$var$wi() {
    return $83602c5f7959a6c2$var$Uh().memoizedState;
}
function $83602c5f7959a6c2$var$xi(a, b, c) {
    var d = $83602c5f7959a6c2$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($83602c5f7959a6c2$var$zi(a)) $83602c5f7959a6c2$var$Ai(b, c);
    else if (c = $83602c5f7959a6c2$var$hh(a, b, c, d), null !== c) {
        var e = $83602c5f7959a6c2$var$R();
        $83602c5f7959a6c2$var$gi(c, a, d, e);
        $83602c5f7959a6c2$var$Bi(c, b, d);
    }
}
function $83602c5f7959a6c2$var$ii(a, b, c) {
    var d = $83602c5f7959a6c2$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($83602c5f7959a6c2$var$zi(a)) $83602c5f7959a6c2$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($83602c5f7959a6c2$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $83602c5f7959a6c2$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $83602c5f7959a6c2$var$hh(a, b, e, d);
        null !== c && (e = $83602c5f7959a6c2$var$R(), $83602c5f7959a6c2$var$gi(c, a, d, e), $83602c5f7959a6c2$var$Bi(c, b, d));
    }
}
function $83602c5f7959a6c2$var$zi(a) {
    var b = a.alternate;
    return a === $83602c5f7959a6c2$var$M || null !== b && b === $83602c5f7959a6c2$var$M;
}
function $83602c5f7959a6c2$var$Ai(a, b) {
    $83602c5f7959a6c2$var$Jh = $83602c5f7959a6c2$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $83602c5f7959a6c2$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $83602c5f7959a6c2$var$Cc(a, c);
    }
}
var $83602c5f7959a6c2$var$Rh = {
    readContext: $83602c5f7959a6c2$var$eh,
    useCallback: $83602c5f7959a6c2$var$P,
    useContext: $83602c5f7959a6c2$var$P,
    useEffect: $83602c5f7959a6c2$var$P,
    useImperativeHandle: $83602c5f7959a6c2$var$P,
    useInsertionEffect: $83602c5f7959a6c2$var$P,
    useLayoutEffect: $83602c5f7959a6c2$var$P,
    useMemo: $83602c5f7959a6c2$var$P,
    useReducer: $83602c5f7959a6c2$var$P,
    useRef: $83602c5f7959a6c2$var$P,
    useState: $83602c5f7959a6c2$var$P,
    useDebugValue: $83602c5f7959a6c2$var$P,
    useDeferredValue: $83602c5f7959a6c2$var$P,
    useTransition: $83602c5f7959a6c2$var$P,
    useMutableSource: $83602c5f7959a6c2$var$P,
    useSyncExternalStore: $83602c5f7959a6c2$var$P,
    useId: $83602c5f7959a6c2$var$P,
    unstable_isNewReconciler: !1
}, $83602c5f7959a6c2$var$Oh = {
    readContext: $83602c5f7959a6c2$var$eh,
    useCallback: function(a, b) {
        $83602c5f7959a6c2$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $83602c5f7959a6c2$var$eh,
    useEffect: $83602c5f7959a6c2$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $83602c5f7959a6c2$var$ki(4194308, 4, $83602c5f7959a6c2$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $83602c5f7959a6c2$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $83602c5f7959a6c2$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $83602c5f7959a6c2$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $83602c5f7959a6c2$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $83602c5f7959a6c2$var$xi.bind(null, $83602c5f7959a6c2$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $83602c5f7959a6c2$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $83602c5f7959a6c2$var$hi,
    useDebugValue: $83602c5f7959a6c2$var$ri,
    useDeferredValue: function(a) {
        return $83602c5f7959a6c2$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $83602c5f7959a6c2$var$hi(!1), b = a[0];
        a = $83602c5f7959a6c2$var$vi.bind(null, a[1]);
        $83602c5f7959a6c2$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $83602c5f7959a6c2$var$M, e = $83602c5f7959a6c2$var$Th();
        if ($83602c5f7959a6c2$var$I) {
            if (void 0 === c) throw Error($83602c5f7959a6c2$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $83602c5f7959a6c2$var$Q) throw Error($83602c5f7959a6c2$var$p(349));
            0 !== ($83602c5f7959a6c2$var$Hh & 30) || $83602c5f7959a6c2$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $83602c5f7959a6c2$var$mi($83602c5f7959a6c2$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $83602c5f7959a6c2$var$bi(9, $83602c5f7959a6c2$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $83602c5f7959a6c2$var$Th(), b = $83602c5f7959a6c2$var$Q.identifierPrefix;
        if ($83602c5f7959a6c2$var$I) {
            var c = $83602c5f7959a6c2$var$sg;
            var d = $83602c5f7959a6c2$var$rg;
            c = (d & ~(1 << 32 - $83602c5f7959a6c2$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $83602c5f7959a6c2$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $83602c5f7959a6c2$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $83602c5f7959a6c2$var$Ph = {
    readContext: $83602c5f7959a6c2$var$eh,
    useCallback: $83602c5f7959a6c2$var$si,
    useContext: $83602c5f7959a6c2$var$eh,
    useEffect: $83602c5f7959a6c2$var$$h,
    useImperativeHandle: $83602c5f7959a6c2$var$qi,
    useInsertionEffect: $83602c5f7959a6c2$var$ni,
    useLayoutEffect: $83602c5f7959a6c2$var$oi,
    useMemo: $83602c5f7959a6c2$var$ti,
    useReducer: $83602c5f7959a6c2$var$Wh,
    useRef: $83602c5f7959a6c2$var$ji,
    useState: function() {
        return $83602c5f7959a6c2$var$Wh($83602c5f7959a6c2$var$Vh);
    },
    useDebugValue: $83602c5f7959a6c2$var$ri,
    useDeferredValue: function(a) {
        var b = $83602c5f7959a6c2$var$Uh();
        return $83602c5f7959a6c2$var$ui(b, $83602c5f7959a6c2$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $83602c5f7959a6c2$var$Wh($83602c5f7959a6c2$var$Vh)[0], b = $83602c5f7959a6c2$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $83602c5f7959a6c2$var$Yh,
    useSyncExternalStore: $83602c5f7959a6c2$var$Zh,
    useId: $83602c5f7959a6c2$var$wi,
    unstable_isNewReconciler: !1
}, $83602c5f7959a6c2$var$Qh = {
    readContext: $83602c5f7959a6c2$var$eh,
    useCallback: $83602c5f7959a6c2$var$si,
    useContext: $83602c5f7959a6c2$var$eh,
    useEffect: $83602c5f7959a6c2$var$$h,
    useImperativeHandle: $83602c5f7959a6c2$var$qi,
    useInsertionEffect: $83602c5f7959a6c2$var$ni,
    useLayoutEffect: $83602c5f7959a6c2$var$oi,
    useMemo: $83602c5f7959a6c2$var$ti,
    useReducer: $83602c5f7959a6c2$var$Xh,
    useRef: $83602c5f7959a6c2$var$ji,
    useState: function() {
        return $83602c5f7959a6c2$var$Xh($83602c5f7959a6c2$var$Vh);
    },
    useDebugValue: $83602c5f7959a6c2$var$ri,
    useDeferredValue: function(a) {
        var b = $83602c5f7959a6c2$var$Uh();
        return null === $83602c5f7959a6c2$var$N ? b.memoizedState = a : $83602c5f7959a6c2$var$ui(b, $83602c5f7959a6c2$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $83602c5f7959a6c2$var$Xh($83602c5f7959a6c2$var$Vh)[0], b = $83602c5f7959a6c2$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $83602c5f7959a6c2$var$Yh,
    useSyncExternalStore: $83602c5f7959a6c2$var$Zh,
    useId: $83602c5f7959a6c2$var$wi,
    unstable_isNewReconciler: !1
};
function $83602c5f7959a6c2$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $83602c5f7959a6c2$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $83602c5f7959a6c2$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $83602c5f7959a6c2$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $83602c5f7959a6c2$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $83602c5f7959a6c2$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $83602c5f7959a6c2$var$R(), e = $83602c5f7959a6c2$var$yi(a), f = $83602c5f7959a6c2$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $83602c5f7959a6c2$var$nh(a, f, e);
        null !== b && ($83602c5f7959a6c2$var$gi(b, a, e, d), $83602c5f7959a6c2$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $83602c5f7959a6c2$var$R(), e = $83602c5f7959a6c2$var$yi(a), f = $83602c5f7959a6c2$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $83602c5f7959a6c2$var$nh(a, f, e);
        null !== b && ($83602c5f7959a6c2$var$gi(b, a, e, d), $83602c5f7959a6c2$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $83602c5f7959a6c2$var$R(), d = $83602c5f7959a6c2$var$yi(a), e = $83602c5f7959a6c2$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $83602c5f7959a6c2$var$nh(a, e, d);
        null !== b && ($83602c5f7959a6c2$var$gi(b, a, d, c), $83602c5f7959a6c2$var$oh(b, a, d));
    }
};
function $83602c5f7959a6c2$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$83602c5f7959a6c2$var$Ie(c, d) || !$83602c5f7959a6c2$var$Ie(e, f) : !0;
}
function $83602c5f7959a6c2$var$Gi(a, b, c) {
    var d = !1, e = $83602c5f7959a6c2$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $83602c5f7959a6c2$var$eh(f) : (e = $83602c5f7959a6c2$var$Zf(b) ? $83602c5f7959a6c2$var$Xf : $83602c5f7959a6c2$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $83602c5f7959a6c2$var$Yf(a, e) : $83602c5f7959a6c2$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $83602c5f7959a6c2$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $83602c5f7959a6c2$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $83602c5f7959a6c2$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $83602c5f7959a6c2$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $83602c5f7959a6c2$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $83602c5f7959a6c2$var$eh(f) : (f = $83602c5f7959a6c2$var$Zf(b) ? $83602c5f7959a6c2$var$Xf : $83602c5f7959a6c2$var$H.current, e.context = $83602c5f7959a6c2$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($83602c5f7959a6c2$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $83602c5f7959a6c2$var$Ei.enqueueReplaceState(e, e.state, null), $83602c5f7959a6c2$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $83602c5f7959a6c2$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $83602c5f7959a6c2$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $83602c5f7959a6c2$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $83602c5f7959a6c2$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $83602c5f7959a6c2$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $83602c5f7959a6c2$var$Ni(a, b, c) {
    c = $83602c5f7959a6c2$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $83602c5f7959a6c2$var$Oi || ($83602c5f7959a6c2$var$Oi = !0, $83602c5f7959a6c2$var$Pi = d);
        $83602c5f7959a6c2$var$Li(a, b);
    };
    return c;
}
function $83602c5f7959a6c2$var$Qi(a, b, c) {
    c = $83602c5f7959a6c2$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $83602c5f7959a6c2$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $83602c5f7959a6c2$var$Li(a, b);
        "function" !== typeof d && (null === $83602c5f7959a6c2$var$Ri ? $83602c5f7959a6c2$var$Ri = new Set([
            this
        ]) : $83602c5f7959a6c2$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $83602c5f7959a6c2$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $83602c5f7959a6c2$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $83602c5f7959a6c2$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $83602c5f7959a6c2$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $83602c5f7959a6c2$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $83602c5f7959a6c2$var$mh(-1, 1), b.tag = 2, $83602c5f7959a6c2$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $83602c5f7959a6c2$var$Wi = $83602c5f7959a6c2$var$ua.ReactCurrentOwner, $83602c5f7959a6c2$var$dh = !1;
function $83602c5f7959a6c2$var$Xi(a, b, c, d) {
    b.child = null === a ? $83602c5f7959a6c2$var$Vg(b, null, c, d) : $83602c5f7959a6c2$var$Ug(b, a.child, c, d);
}
function $83602c5f7959a6c2$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $83602c5f7959a6c2$var$ch(b, e);
    d = $83602c5f7959a6c2$var$Nh(a, b, c, d, f, e);
    c = $83602c5f7959a6c2$var$Sh();
    if (null !== a && !$83602c5f7959a6c2$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $83602c5f7959a6c2$var$Zi(a, b, e);
    $83602c5f7959a6c2$var$I && c && $83602c5f7959a6c2$var$vg(b);
    b.flags |= 1;
    $83602c5f7959a6c2$var$Xi(a, b, d, e);
    return b.child;
}
function $83602c5f7959a6c2$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$83602c5f7959a6c2$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $83602c5f7959a6c2$var$bj(a, b, f, d, e);
        a = $83602c5f7959a6c2$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $83602c5f7959a6c2$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $83602c5f7959a6c2$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $83602c5f7959a6c2$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $83602c5f7959a6c2$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($83602c5f7959a6c2$var$Ie(f, d) && a.ref === b.ref) {
            if ($83602c5f7959a6c2$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($83602c5f7959a6c2$var$dh = !0);
            else return b.lanes = a.lanes, $83602c5f7959a6c2$var$Zi(a, b, e);
        }
    }
    return $83602c5f7959a6c2$var$cj(a, b, c, d, e);
}
function $83602c5f7959a6c2$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$ej, $83602c5f7959a6c2$var$fj), $83602c5f7959a6c2$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$ej, $83602c5f7959a6c2$var$fj), $83602c5f7959a6c2$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$ej, $83602c5f7959a6c2$var$fj);
            $83602c5f7959a6c2$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$ej, $83602c5f7959a6c2$var$fj), $83602c5f7959a6c2$var$fj |= d;
    $83602c5f7959a6c2$var$Xi(a, b, e, c);
    return b.child;
}
function $83602c5f7959a6c2$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $83602c5f7959a6c2$var$cj(a, b, c, d, e) {
    var f = $83602c5f7959a6c2$var$Zf(c) ? $83602c5f7959a6c2$var$Xf : $83602c5f7959a6c2$var$H.current;
    f = $83602c5f7959a6c2$var$Yf(b, f);
    $83602c5f7959a6c2$var$ch(b, e);
    c = $83602c5f7959a6c2$var$Nh(a, b, c, d, f, e);
    d = $83602c5f7959a6c2$var$Sh();
    if (null !== a && !$83602c5f7959a6c2$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $83602c5f7959a6c2$var$Zi(a, b, e);
    $83602c5f7959a6c2$var$I && d && $83602c5f7959a6c2$var$vg(b);
    b.flags |= 1;
    $83602c5f7959a6c2$var$Xi(a, b, c, e);
    return b.child;
}
function $83602c5f7959a6c2$var$hj(a, b, c, d, e) {
    if ($83602c5f7959a6c2$var$Zf(c)) {
        var f = !0;
        $83602c5f7959a6c2$var$cg(b);
    } else f = !1;
    $83602c5f7959a6c2$var$ch(b, e);
    if (null === b.stateNode) $83602c5f7959a6c2$var$ij(a, b), $83602c5f7959a6c2$var$Gi(b, c, d), $83602c5f7959a6c2$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $83602c5f7959a6c2$var$eh(l) : (l = $83602c5f7959a6c2$var$Zf(c) ? $83602c5f7959a6c2$var$Xf : $83602c5f7959a6c2$var$H.current, l = $83602c5f7959a6c2$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $83602c5f7959a6c2$var$Hi(b, g, d, l);
        $83602c5f7959a6c2$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $83602c5f7959a6c2$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $83602c5f7959a6c2$var$Wf.current || $83602c5f7959a6c2$var$jh ? ("function" === typeof m && ($83602c5f7959a6c2$var$Di(b, c, m, d), k = b.memoizedState), (h = $83602c5f7959a6c2$var$jh || $83602c5f7959a6c2$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $83602c5f7959a6c2$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $83602c5f7959a6c2$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $83602c5f7959a6c2$var$eh(k) : (k = $83602c5f7959a6c2$var$Zf(c) ? $83602c5f7959a6c2$var$Xf : $83602c5f7959a6c2$var$H.current, k = $83602c5f7959a6c2$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $83602c5f7959a6c2$var$Hi(b, g, d, k);
        $83602c5f7959a6c2$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $83602c5f7959a6c2$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $83602c5f7959a6c2$var$Wf.current || $83602c5f7959a6c2$var$jh ? ("function" === typeof y && ($83602c5f7959a6c2$var$Di(b, c, y, d), n = b.memoizedState), (l = $83602c5f7959a6c2$var$jh || $83602c5f7959a6c2$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $83602c5f7959a6c2$var$jj(a, b, c, d, f, e);
}
function $83602c5f7959a6c2$var$jj(a, b, c, d, e, f) {
    $83602c5f7959a6c2$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $83602c5f7959a6c2$var$dg(b, c, !1), $83602c5f7959a6c2$var$Zi(a, b, f);
    d = b.stateNode;
    $83602c5f7959a6c2$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $83602c5f7959a6c2$var$Ug(b, a.child, null, f), b.child = $83602c5f7959a6c2$var$Ug(b, null, h, f)) : $83602c5f7959a6c2$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $83602c5f7959a6c2$var$dg(b, c, !0);
    return b.child;
}
function $83602c5f7959a6c2$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $83602c5f7959a6c2$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $83602c5f7959a6c2$var$ag(a, b.context, !1);
    $83602c5f7959a6c2$var$yh(a, b.containerInfo);
}
function $83602c5f7959a6c2$var$lj(a, b, c, d, e) {
    $83602c5f7959a6c2$var$Ig();
    $83602c5f7959a6c2$var$Jg(e);
    b.flags |= 256;
    $83602c5f7959a6c2$var$Xi(a, b, c, d);
    return b.child;
}
var $83602c5f7959a6c2$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $83602c5f7959a6c2$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $83602c5f7959a6c2$var$oj(a, b, c) {
    var d = b.pendingProps, e = $83602c5f7959a6c2$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$L, e & 1);
    if (null === a) {
        $83602c5f7959a6c2$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $83602c5f7959a6c2$var$pj(g, d, 0, null), a = $83602c5f7959a6c2$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $83602c5f7959a6c2$var$nj(c), b.memoizedState = $83602c5f7959a6c2$var$mj, a) : $83602c5f7959a6c2$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $83602c5f7959a6c2$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $83602c5f7959a6c2$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $83602c5f7959a6c2$var$Pg(h, f) : (f = $83602c5f7959a6c2$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $83602c5f7959a6c2$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $83602c5f7959a6c2$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $83602c5f7959a6c2$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $83602c5f7959a6c2$var$qj(a, b) {
    b = $83602c5f7959a6c2$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $83602c5f7959a6c2$var$sj(a, b, c, d) {
    null !== d && $83602c5f7959a6c2$var$Jg(d);
    $83602c5f7959a6c2$var$Ug(b, a.child, null, c);
    a = $83602c5f7959a6c2$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $83602c5f7959a6c2$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $83602c5f7959a6c2$var$Ki(Error($83602c5f7959a6c2$var$p(422))), $83602c5f7959a6c2$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $83602c5f7959a6c2$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $83602c5f7959a6c2$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $83602c5f7959a6c2$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $83602c5f7959a6c2$var$nj(g);
        b.memoizedState = $83602c5f7959a6c2$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $83602c5f7959a6c2$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($83602c5f7959a6c2$var$p(419));
        d = $83602c5f7959a6c2$var$Ki(f, d, void 0);
        return $83602c5f7959a6c2$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($83602c5f7959a6c2$var$dh || h) {
        d = $83602c5f7959a6c2$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $83602c5f7959a6c2$var$ih(a, e), $83602c5f7959a6c2$var$gi(d, a, e, -1));
        }
        $83602c5f7959a6c2$var$tj();
        d = $83602c5f7959a6c2$var$Ki(Error($83602c5f7959a6c2$var$p(421)));
        return $83602c5f7959a6c2$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $83602c5f7959a6c2$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $83602c5f7959a6c2$var$yg = $83602c5f7959a6c2$var$Lf(e.nextSibling);
    $83602c5f7959a6c2$var$xg = b;
    $83602c5f7959a6c2$var$I = !0;
    $83602c5f7959a6c2$var$zg = null;
    null !== a && ($83602c5f7959a6c2$var$og[$83602c5f7959a6c2$var$pg++] = $83602c5f7959a6c2$var$rg, $83602c5f7959a6c2$var$og[$83602c5f7959a6c2$var$pg++] = $83602c5f7959a6c2$var$sg, $83602c5f7959a6c2$var$og[$83602c5f7959a6c2$var$pg++] = $83602c5f7959a6c2$var$qg, $83602c5f7959a6c2$var$rg = a.id, $83602c5f7959a6c2$var$sg = a.overflow, $83602c5f7959a6c2$var$qg = b);
    b = $83602c5f7959a6c2$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $83602c5f7959a6c2$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $83602c5f7959a6c2$var$bh(a.return, b, c);
}
function $83602c5f7959a6c2$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $83602c5f7959a6c2$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $83602c5f7959a6c2$var$Xi(a, b, d.children, c);
    d = $83602c5f7959a6c2$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $83602c5f7959a6c2$var$vj(a, c, b);
            else if (19 === a.tag) $83602c5f7959a6c2$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $83602c5f7959a6c2$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $83602c5f7959a6c2$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $83602c5f7959a6c2$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $83602c5f7959a6c2$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $83602c5f7959a6c2$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $83602c5f7959a6c2$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $83602c5f7959a6c2$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $83602c5f7959a6c2$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($83602c5f7959a6c2$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $83602c5f7959a6c2$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $83602c5f7959a6c2$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $83602c5f7959a6c2$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $83602c5f7959a6c2$var$kj(b);
            $83602c5f7959a6c2$var$Ig();
            break;
        case 5:
            $83602c5f7959a6c2$var$Ah(b);
            break;
        case 1:
            $83602c5f7959a6c2$var$Zf(b.type) && $83602c5f7959a6c2$var$cg(b);
            break;
        case 4:
            $83602c5f7959a6c2$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$L, $83602c5f7959a6c2$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $83602c5f7959a6c2$var$oj(a, b, c);
                $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$L, $83602c5f7959a6c2$var$L.current & 1);
                a = $83602c5f7959a6c2$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$L, $83602c5f7959a6c2$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $83602c5f7959a6c2$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$L, $83602c5f7959a6c2$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $83602c5f7959a6c2$var$dj(a, b, c);
    }
    return $83602c5f7959a6c2$var$Zi(a, b, c);
}
var $83602c5f7959a6c2$var$zj, $83602c5f7959a6c2$var$Aj, $83602c5f7959a6c2$var$Bj, $83602c5f7959a6c2$var$Cj;
$83602c5f7959a6c2$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$83602c5f7959a6c2$var$Aj = function() {};
$83602c5f7959a6c2$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $83602c5f7959a6c2$var$xh($83602c5f7959a6c2$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $83602c5f7959a6c2$var$Ya(a, e);
                d = $83602c5f7959a6c2$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $83602c5f7959a6c2$var$A({}, e, {
                    value: void 0
                });
                d = $83602c5f7959a6c2$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $83602c5f7959a6c2$var$gb(a, e);
                d = $83602c5f7959a6c2$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $83602c5f7959a6c2$var$Bf);
        }
        $83602c5f7959a6c2$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($83602c5f7959a6c2$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($83602c5f7959a6c2$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $83602c5f7959a6c2$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$83602c5f7959a6c2$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $83602c5f7959a6c2$var$Dj(a, b) {
    if (!$83602c5f7959a6c2$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $83602c5f7959a6c2$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $83602c5f7959a6c2$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $83602c5f7959a6c2$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $83602c5f7959a6c2$var$S(b), null;
        case 1:
            return $83602c5f7959a6c2$var$Zf(b.type) && $83602c5f7959a6c2$var$$f(), $83602c5f7959a6c2$var$S(b), null;
        case 3:
            d = b.stateNode;
            $83602c5f7959a6c2$var$zh();
            $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$Wf);
            $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$H);
            $83602c5f7959a6c2$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $83602c5f7959a6c2$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $83602c5f7959a6c2$var$zg && ($83602c5f7959a6c2$var$Fj($83602c5f7959a6c2$var$zg), $83602c5f7959a6c2$var$zg = null));
            $83602c5f7959a6c2$var$Aj(a, b);
            $83602c5f7959a6c2$var$S(b);
            return null;
        case 5:
            $83602c5f7959a6c2$var$Bh(b);
            var e = $83602c5f7959a6c2$var$xh($83602c5f7959a6c2$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $83602c5f7959a6c2$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($83602c5f7959a6c2$var$p(166));
                    $83602c5f7959a6c2$var$S(b);
                    return null;
                }
                a = $83602c5f7959a6c2$var$xh($83602c5f7959a6c2$var$uh.current);
                if ($83602c5f7959a6c2$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$83602c5f7959a6c2$var$Of] = b;
                    d[$83602c5f7959a6c2$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $83602c5f7959a6c2$var$D("cancel", d);
                            $83602c5f7959a6c2$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $83602c5f7959a6c2$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $83602c5f7959a6c2$var$lf.length; e++)$83602c5f7959a6c2$var$D($83602c5f7959a6c2$var$lf[e], d);
                            break;
                        case "source":
                            $83602c5f7959a6c2$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $83602c5f7959a6c2$var$D("error", d);
                            $83602c5f7959a6c2$var$D("load", d);
                            break;
                        case "details":
                            $83602c5f7959a6c2$var$D("toggle", d);
                            break;
                        case "input":
                            $83602c5f7959a6c2$var$Za(d, f);
                            $83602c5f7959a6c2$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $83602c5f7959a6c2$var$D("invalid", d);
                            break;
                        case "textarea":
                            $83602c5f7959a6c2$var$hb(d, f), $83602c5f7959a6c2$var$D("invalid", d);
                    }
                    $83602c5f7959a6c2$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $83602c5f7959a6c2$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $83602c5f7959a6c2$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $83602c5f7959a6c2$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $83602c5f7959a6c2$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $83602c5f7959a6c2$var$Va(d);
                            $83602c5f7959a6c2$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $83602c5f7959a6c2$var$Va(d);
                            $83602c5f7959a6c2$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $83602c5f7959a6c2$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $83602c5f7959a6c2$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$83602c5f7959a6c2$var$Of] = b;
                    a[$83602c5f7959a6c2$var$Pf] = d;
                    $83602c5f7959a6c2$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $83602c5f7959a6c2$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $83602c5f7959a6c2$var$D("cancel", a);
                                $83602c5f7959a6c2$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $83602c5f7959a6c2$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $83602c5f7959a6c2$var$lf.length; e++)$83602c5f7959a6c2$var$D($83602c5f7959a6c2$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $83602c5f7959a6c2$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $83602c5f7959a6c2$var$D("error", a);
                                $83602c5f7959a6c2$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $83602c5f7959a6c2$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $83602c5f7959a6c2$var$Za(a, d);
                                e = $83602c5f7959a6c2$var$Ya(a, d);
                                $83602c5f7959a6c2$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $83602c5f7959a6c2$var$A({}, d, {
                                    value: void 0
                                });
                                $83602c5f7959a6c2$var$D("invalid", a);
                                break;
                            case "textarea":
                                $83602c5f7959a6c2$var$hb(a, d);
                                e = $83602c5f7959a6c2$var$gb(a, d);
                                $83602c5f7959a6c2$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $83602c5f7959a6c2$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $83602c5f7959a6c2$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $83602c5f7959a6c2$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $83602c5f7959a6c2$var$ob(a, k) : "number" === typeof k && $83602c5f7959a6c2$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($83602c5f7959a6c2$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $83602c5f7959a6c2$var$D("scroll", a) : null != k && $83602c5f7959a6c2$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $83602c5f7959a6c2$var$Va(a);
                                $83602c5f7959a6c2$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $83602c5f7959a6c2$var$Va(a);
                                $83602c5f7959a6c2$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $83602c5f7959a6c2$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $83602c5f7959a6c2$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $83602c5f7959a6c2$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $83602c5f7959a6c2$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $83602c5f7959a6c2$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $83602c5f7959a6c2$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($83602c5f7959a6c2$var$p(166));
                c = $83602c5f7959a6c2$var$xh($83602c5f7959a6c2$var$wh.current);
                $83602c5f7959a6c2$var$xh($83602c5f7959a6c2$var$uh.current);
                if ($83602c5f7959a6c2$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$83602c5f7959a6c2$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $83602c5f7959a6c2$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $83602c5f7959a6c2$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $83602c5f7959a6c2$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$83602c5f7959a6c2$var$Of] = b, b.stateNode = d;
            }
            $83602c5f7959a6c2$var$S(b);
            return null;
        case 13:
            $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($83602c5f7959a6c2$var$I && null !== $83602c5f7959a6c2$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $83602c5f7959a6c2$var$Hg(), $83602c5f7959a6c2$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $83602c5f7959a6c2$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($83602c5f7959a6c2$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($83602c5f7959a6c2$var$p(317));
                        f[$83602c5f7959a6c2$var$Of] = b;
                    } else $83602c5f7959a6c2$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $83602c5f7959a6c2$var$S(b);
                    f = !1;
                } else null !== $83602c5f7959a6c2$var$zg && ($83602c5f7959a6c2$var$Fj($83602c5f7959a6c2$var$zg), $83602c5f7959a6c2$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($83602c5f7959a6c2$var$L.current & 1) ? 0 === $83602c5f7959a6c2$var$T && ($83602c5f7959a6c2$var$T = 3) : $83602c5f7959a6c2$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $83602c5f7959a6c2$var$S(b);
            return null;
        case 4:
            return $83602c5f7959a6c2$var$zh(), $83602c5f7959a6c2$var$Aj(a, b), null === a && $83602c5f7959a6c2$var$sf(b.stateNode.containerInfo), $83602c5f7959a6c2$var$S(b), null;
        case 10:
            return $83602c5f7959a6c2$var$ah(b.type._context), $83602c5f7959a6c2$var$S(b), null;
        case 17:
            return $83602c5f7959a6c2$var$Zf(b.type) && $83602c5f7959a6c2$var$$f(), $83602c5f7959a6c2$var$S(b), null;
        case 19:
            $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$L);
            f = b.memoizedState;
            if (null === f) return $83602c5f7959a6c2$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $83602c5f7959a6c2$var$Dj(f, !1);
                else {
                    if (0 !== $83602c5f7959a6c2$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $83602c5f7959a6c2$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $83602c5f7959a6c2$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$L, $83602c5f7959a6c2$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $83602c5f7959a6c2$var$B() > $83602c5f7959a6c2$var$Gj && (b.flags |= 128, d = !0, $83602c5f7959a6c2$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $83602c5f7959a6c2$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $83602c5f7959a6c2$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$83602c5f7959a6c2$var$I) return $83602c5f7959a6c2$var$S(b), null;
                    } else 2 * $83602c5f7959a6c2$var$B() - f.renderingStartTime > $83602c5f7959a6c2$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $83602c5f7959a6c2$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $83602c5f7959a6c2$var$B(), b.sibling = null, c = $83602c5f7959a6c2$var$L.current, $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$L, d ? c & 1 | 2 : c & 1), b;
            $83602c5f7959a6c2$var$S(b);
            return null;
        case 22:
        case 23:
            return $83602c5f7959a6c2$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($83602c5f7959a6c2$var$fj & 1073741824) && ($83602c5f7959a6c2$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $83602c5f7959a6c2$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($83602c5f7959a6c2$var$p(156, b.tag));
}
function $83602c5f7959a6c2$var$Ij(a, b) {
    $83602c5f7959a6c2$var$wg(b);
    switch(b.tag){
        case 1:
            return $83602c5f7959a6c2$var$Zf(b.type) && $83602c5f7959a6c2$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $83602c5f7959a6c2$var$zh(), $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$Wf), $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$H), $83602c5f7959a6c2$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $83602c5f7959a6c2$var$Bh(b), null;
        case 13:
            $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($83602c5f7959a6c2$var$p(340));
                $83602c5f7959a6c2$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$L), null;
        case 4:
            return $83602c5f7959a6c2$var$zh(), null;
        case 10:
            return $83602c5f7959a6c2$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $83602c5f7959a6c2$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $83602c5f7959a6c2$var$Jj = !1, $83602c5f7959a6c2$var$U = !1, $83602c5f7959a6c2$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $83602c5f7959a6c2$var$V = null;
function $83602c5f7959a6c2$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $83602c5f7959a6c2$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $83602c5f7959a6c2$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $83602c5f7959a6c2$var$W(a, b, d);
    }
}
var $83602c5f7959a6c2$var$Nj = !1;
function $83602c5f7959a6c2$var$Oj(a, b) {
    $83602c5f7959a6c2$var$Cf = $83602c5f7959a6c2$var$dd;
    a = $83602c5f7959a6c2$var$Me();
    if ($83602c5f7959a6c2$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $83602c5f7959a6c2$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $83602c5f7959a6c2$var$dd = !1;
    for($83602c5f7959a6c2$var$V = b; null !== $83602c5f7959a6c2$var$V;)if (b = $83602c5f7959a6c2$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $83602c5f7959a6c2$var$V = a;
    else for(; null !== $83602c5f7959a6c2$var$V;){
        b = $83602c5f7959a6c2$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $83602c5f7959a6c2$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($83602c5f7959a6c2$var$p(163));
            }
        } catch (F) {
            $83602c5f7959a6c2$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $83602c5f7959a6c2$var$V = a;
            break;
        }
        $83602c5f7959a6c2$var$V = b.return;
    }
    n = $83602c5f7959a6c2$var$Nj;
    $83602c5f7959a6c2$var$Nj = !1;
    return n;
}
function $83602c5f7959a6c2$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $83602c5f7959a6c2$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $83602c5f7959a6c2$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $83602c5f7959a6c2$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $83602c5f7959a6c2$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $83602c5f7959a6c2$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$83602c5f7959a6c2$var$Of], delete b[$83602c5f7959a6c2$var$Pf], delete b[$83602c5f7959a6c2$var$of], delete b[$83602c5f7959a6c2$var$Qf], delete b[$83602c5f7959a6c2$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $83602c5f7959a6c2$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $83602c5f7959a6c2$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $83602c5f7959a6c2$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $83602c5f7959a6c2$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $83602c5f7959a6c2$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($83602c5f7959a6c2$var$Vj(a, b, c), a = a.sibling; null !== a;)$83602c5f7959a6c2$var$Vj(a, b, c), a = a.sibling;
}
function $83602c5f7959a6c2$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($83602c5f7959a6c2$var$Wj(a, b, c), a = a.sibling; null !== a;)$83602c5f7959a6c2$var$Wj(a, b, c), a = a.sibling;
}
var $83602c5f7959a6c2$var$X = null, $83602c5f7959a6c2$var$Xj = !1;
function $83602c5f7959a6c2$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$83602c5f7959a6c2$var$Zj(a, b, c), c = c.sibling;
}
function $83602c5f7959a6c2$var$Zj(a, b, c) {
    if ($83602c5f7959a6c2$var$lc && "function" === typeof $83602c5f7959a6c2$var$lc.onCommitFiberUnmount) try {
        $83602c5f7959a6c2$var$lc.onCommitFiberUnmount($83602c5f7959a6c2$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $83602c5f7959a6c2$var$U || $83602c5f7959a6c2$var$Lj(c, b);
        case 6:
            var d = $83602c5f7959a6c2$var$X, e = $83602c5f7959a6c2$var$Xj;
            $83602c5f7959a6c2$var$X = null;
            $83602c5f7959a6c2$var$Yj(a, b, c);
            $83602c5f7959a6c2$var$X = d;
            $83602c5f7959a6c2$var$Xj = e;
            null !== $83602c5f7959a6c2$var$X && ($83602c5f7959a6c2$var$Xj ? (a = $83602c5f7959a6c2$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $83602c5f7959a6c2$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $83602c5f7959a6c2$var$X && ($83602c5f7959a6c2$var$Xj ? (a = $83602c5f7959a6c2$var$X, c = c.stateNode, 8 === a.nodeType ? $83602c5f7959a6c2$var$Kf(a.parentNode, c) : 1 === a.nodeType && $83602c5f7959a6c2$var$Kf(a, c), $83602c5f7959a6c2$var$bd(a)) : $83602c5f7959a6c2$var$Kf($83602c5f7959a6c2$var$X, c.stateNode));
            break;
        case 4:
            d = $83602c5f7959a6c2$var$X;
            e = $83602c5f7959a6c2$var$Xj;
            $83602c5f7959a6c2$var$X = c.stateNode.containerInfo;
            $83602c5f7959a6c2$var$Xj = !0;
            $83602c5f7959a6c2$var$Yj(a, b, c);
            $83602c5f7959a6c2$var$X = d;
            $83602c5f7959a6c2$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$83602c5f7959a6c2$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $83602c5f7959a6c2$var$Mj(c, b, g) : 0 !== (f & 4) && $83602c5f7959a6c2$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $83602c5f7959a6c2$var$Yj(a, b, c);
            break;
        case 1:
            if (!$83602c5f7959a6c2$var$U && ($83602c5f7959a6c2$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $83602c5f7959a6c2$var$W(c, b, h);
            }
            $83602c5f7959a6c2$var$Yj(a, b, c);
            break;
        case 21:
            $83602c5f7959a6c2$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($83602c5f7959a6c2$var$U = (d = $83602c5f7959a6c2$var$U) || null !== c.memoizedState, $83602c5f7959a6c2$var$Yj(a, b, c), $83602c5f7959a6c2$var$U = d) : $83602c5f7959a6c2$var$Yj(a, b, c);
            break;
        default:
            $83602c5f7959a6c2$var$Yj(a, b, c);
    }
}
function $83602c5f7959a6c2$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $83602c5f7959a6c2$var$Kj);
        b.forEach(function(b) {
            var d = $83602c5f7959a6c2$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $83602c5f7959a6c2$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $83602c5f7959a6c2$var$X = h.stateNode;
                        $83602c5f7959a6c2$var$Xj = !1;
                        break a;
                    case 3:
                        $83602c5f7959a6c2$var$X = h.stateNode.containerInfo;
                        $83602c5f7959a6c2$var$Xj = !0;
                        break a;
                    case 4:
                        $83602c5f7959a6c2$var$X = h.stateNode.containerInfo;
                        $83602c5f7959a6c2$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $83602c5f7959a6c2$var$X) throw Error($83602c5f7959a6c2$var$p(160));
            $83602c5f7959a6c2$var$Zj(f, g, e);
            $83602c5f7959a6c2$var$X = null;
            $83602c5f7959a6c2$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $83602c5f7959a6c2$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$83602c5f7959a6c2$var$dk(b, a), b = b.sibling;
}
function $83602c5f7959a6c2$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $83602c5f7959a6c2$var$ck(b, a);
            $83602c5f7959a6c2$var$ek(a);
            if (d & 4) {
                try {
                    $83602c5f7959a6c2$var$Pj(3, a, a.return), $83602c5f7959a6c2$var$Qj(3, a);
                } catch (t) {
                    $83602c5f7959a6c2$var$W(a, a.return, t);
                }
                try {
                    $83602c5f7959a6c2$var$Pj(5, a, a.return);
                } catch (t) {
                    $83602c5f7959a6c2$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $83602c5f7959a6c2$var$ck(b, a);
            $83602c5f7959a6c2$var$ek(a);
            d & 512 && null !== c && $83602c5f7959a6c2$var$Lj(c, c.return);
            break;
        case 5:
            $83602c5f7959a6c2$var$ck(b, a);
            $83602c5f7959a6c2$var$ek(a);
            d & 512 && null !== c && $83602c5f7959a6c2$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $83602c5f7959a6c2$var$ob(e, "");
                } catch (t) {
                    $83602c5f7959a6c2$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $83602c5f7959a6c2$var$ab(e, f);
                    $83602c5f7959a6c2$var$vb(h, g);
                    var l = $83602c5f7959a6c2$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $83602c5f7959a6c2$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $83602c5f7959a6c2$var$nb(e, q) : "children" === m ? $83602c5f7959a6c2$var$ob(e, q) : $83602c5f7959a6c2$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $83602c5f7959a6c2$var$bb(e, f);
                            break;
                        case "textarea":
                            $83602c5f7959a6c2$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $83602c5f7959a6c2$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $83602c5f7959a6c2$var$fb(e, !!f.multiple, f.defaultValue, !0) : $83602c5f7959a6c2$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$83602c5f7959a6c2$var$Pf] = f;
                } catch (t) {
                    $83602c5f7959a6c2$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $83602c5f7959a6c2$var$ck(b, a);
            $83602c5f7959a6c2$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($83602c5f7959a6c2$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $83602c5f7959a6c2$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $83602c5f7959a6c2$var$ck(b, a);
            $83602c5f7959a6c2$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $83602c5f7959a6c2$var$bd(b.containerInfo);
            } catch (t) {
                $83602c5f7959a6c2$var$W(a, a.return, t);
            }
            break;
        case 4:
            $83602c5f7959a6c2$var$ck(b, a);
            $83602c5f7959a6c2$var$ek(a);
            break;
        case 13:
            $83602c5f7959a6c2$var$ck(b, a);
            $83602c5f7959a6c2$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($83602c5f7959a6c2$var$fk = $83602c5f7959a6c2$var$B()));
            d & 4 && $83602c5f7959a6c2$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($83602c5f7959a6c2$var$U = (l = $83602c5f7959a6c2$var$U) || m, $83602c5f7959a6c2$var$ck(b, a), $83602c5f7959a6c2$var$U = l) : $83602c5f7959a6c2$var$ck(b, a);
            $83602c5f7959a6c2$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($83602c5f7959a6c2$var$V = a, m = a.child; null !== m;){
                    for(q = $83602c5f7959a6c2$var$V = m; null !== $83602c5f7959a6c2$var$V;){
                        r = $83602c5f7959a6c2$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $83602c5f7959a6c2$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $83602c5f7959a6c2$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $83602c5f7959a6c2$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $83602c5f7959a6c2$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $83602c5f7959a6c2$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $83602c5f7959a6c2$var$V = y) : $83602c5f7959a6c2$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $83602c5f7959a6c2$var$rb("display", g));
                            } catch (t) {
                                $83602c5f7959a6c2$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $83602c5f7959a6c2$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $83602c5f7959a6c2$var$ck(b, a);
            $83602c5f7959a6c2$var$ek(a);
            d & 4 && $83602c5f7959a6c2$var$ak(a);
            break;
        case 21:
            break;
        default:
            $83602c5f7959a6c2$var$ck(b, a), $83602c5f7959a6c2$var$ek(a);
    }
}
function $83602c5f7959a6c2$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($83602c5f7959a6c2$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($83602c5f7959a6c2$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($83602c5f7959a6c2$var$ob(e, ""), d.flags &= -33);
                    var f = $83602c5f7959a6c2$var$Uj(a);
                    $83602c5f7959a6c2$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $83602c5f7959a6c2$var$Uj(a);
                    $83602c5f7959a6c2$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($83602c5f7959a6c2$var$p(161));
            }
        } catch (k) {
            $83602c5f7959a6c2$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $83602c5f7959a6c2$var$hk(a, b, c) {
    $83602c5f7959a6c2$var$V = a;
    $83602c5f7959a6c2$var$ik(a, b, c);
}
function $83602c5f7959a6c2$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $83602c5f7959a6c2$var$V;){
        var e = $83602c5f7959a6c2$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $83602c5f7959a6c2$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $83602c5f7959a6c2$var$U;
                h = $83602c5f7959a6c2$var$Jj;
                var l = $83602c5f7959a6c2$var$U;
                $83602c5f7959a6c2$var$Jj = g;
                if (($83602c5f7959a6c2$var$U = k) && !l) for($83602c5f7959a6c2$var$V = e; null !== $83602c5f7959a6c2$var$V;)g = $83602c5f7959a6c2$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $83602c5f7959a6c2$var$jk(e) : null !== k ? (k.return = g, $83602c5f7959a6c2$var$V = k) : $83602c5f7959a6c2$var$jk(e);
                for(; null !== f;)$83602c5f7959a6c2$var$V = f, $83602c5f7959a6c2$var$ik(f, b, c), f = f.sibling;
                $83602c5f7959a6c2$var$V = e;
                $83602c5f7959a6c2$var$Jj = h;
                $83602c5f7959a6c2$var$U = l;
            }
            $83602c5f7959a6c2$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $83602c5f7959a6c2$var$V = f) : $83602c5f7959a6c2$var$kk(a, b, c);
    }
}
function $83602c5f7959a6c2$var$kk(a) {
    for(; null !== $83602c5f7959a6c2$var$V;){
        var b = $83602c5f7959a6c2$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $83602c5f7959a6c2$var$U || $83602c5f7959a6c2$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$83602c5f7959a6c2$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $83602c5f7959a6c2$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $83602c5f7959a6c2$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $83602c5f7959a6c2$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $83602c5f7959a6c2$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($83602c5f7959a6c2$var$p(163));
                }
                $83602c5f7959a6c2$var$U || b.flags & 512 && $83602c5f7959a6c2$var$Rj(b);
            } catch (r) {
                $83602c5f7959a6c2$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $83602c5f7959a6c2$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $83602c5f7959a6c2$var$V = c;
            break;
        }
        $83602c5f7959a6c2$var$V = b.return;
    }
}
function $83602c5f7959a6c2$var$gk(a) {
    for(; null !== $83602c5f7959a6c2$var$V;){
        var b = $83602c5f7959a6c2$var$V;
        if (b === a) {
            $83602c5f7959a6c2$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $83602c5f7959a6c2$var$V = c;
            break;
        }
        $83602c5f7959a6c2$var$V = b.return;
    }
}
function $83602c5f7959a6c2$var$jk(a) {
    for(; null !== $83602c5f7959a6c2$var$V;){
        var b = $83602c5f7959a6c2$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $83602c5f7959a6c2$var$Qj(4, b);
                    } catch (k) {
                        $83602c5f7959a6c2$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $83602c5f7959a6c2$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $83602c5f7959a6c2$var$Rj(b);
                    } catch (k) {
                        $83602c5f7959a6c2$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $83602c5f7959a6c2$var$Rj(b);
                    } catch (k) {
                        $83602c5f7959a6c2$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $83602c5f7959a6c2$var$W(b, b.return, k);
        }
        if (b === a) {
            $83602c5f7959a6c2$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $83602c5f7959a6c2$var$V = h;
            break;
        }
        $83602c5f7959a6c2$var$V = b.return;
    }
}
var $83602c5f7959a6c2$var$lk = Math.ceil, $83602c5f7959a6c2$var$mk = $83602c5f7959a6c2$var$ua.ReactCurrentDispatcher, $83602c5f7959a6c2$var$nk = $83602c5f7959a6c2$var$ua.ReactCurrentOwner, $83602c5f7959a6c2$var$ok = $83602c5f7959a6c2$var$ua.ReactCurrentBatchConfig, $83602c5f7959a6c2$var$K = 0, $83602c5f7959a6c2$var$Q = null, $83602c5f7959a6c2$var$Y = null, $83602c5f7959a6c2$var$Z = 0, $83602c5f7959a6c2$var$fj = 0, $83602c5f7959a6c2$var$ej = $83602c5f7959a6c2$var$Uf(0), $83602c5f7959a6c2$var$T = 0, $83602c5f7959a6c2$var$pk = null, $83602c5f7959a6c2$var$rh = 0, $83602c5f7959a6c2$var$qk = 0, $83602c5f7959a6c2$var$rk = 0, $83602c5f7959a6c2$var$sk = null, $83602c5f7959a6c2$var$tk = null, $83602c5f7959a6c2$var$fk = 0, $83602c5f7959a6c2$var$Gj = Infinity, $83602c5f7959a6c2$var$uk = null, $83602c5f7959a6c2$var$Oi = !1, $83602c5f7959a6c2$var$Pi = null, $83602c5f7959a6c2$var$Ri = null, $83602c5f7959a6c2$var$vk = !1, $83602c5f7959a6c2$var$wk = null, $83602c5f7959a6c2$var$xk = 0, $83602c5f7959a6c2$var$yk = 0, $83602c5f7959a6c2$var$zk = null, $83602c5f7959a6c2$var$Ak = -1, $83602c5f7959a6c2$var$Bk = 0;
function $83602c5f7959a6c2$var$R() {
    return 0 !== ($83602c5f7959a6c2$var$K & 6) ? $83602c5f7959a6c2$var$B() : -1 !== $83602c5f7959a6c2$var$Ak ? $83602c5f7959a6c2$var$Ak : $83602c5f7959a6c2$var$Ak = $83602c5f7959a6c2$var$B();
}
function $83602c5f7959a6c2$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($83602c5f7959a6c2$var$K & 2) && 0 !== $83602c5f7959a6c2$var$Z) return $83602c5f7959a6c2$var$Z & -$83602c5f7959a6c2$var$Z;
    if (null !== $83602c5f7959a6c2$var$Kg.transition) return 0 === $83602c5f7959a6c2$var$Bk && ($83602c5f7959a6c2$var$Bk = $83602c5f7959a6c2$var$yc()), $83602c5f7959a6c2$var$Bk;
    a = $83602c5f7959a6c2$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $83602c5f7959a6c2$var$jd(a.type);
    return a;
}
function $83602c5f7959a6c2$var$gi(a, b, c, d) {
    if (50 < $83602c5f7959a6c2$var$yk) throw $83602c5f7959a6c2$var$yk = 0, $83602c5f7959a6c2$var$zk = null, Error($83602c5f7959a6c2$var$p(185));
    $83602c5f7959a6c2$var$Ac(a, c, d);
    if (0 === ($83602c5f7959a6c2$var$K & 2) || a !== $83602c5f7959a6c2$var$Q) a === $83602c5f7959a6c2$var$Q && (0 === ($83602c5f7959a6c2$var$K & 2) && ($83602c5f7959a6c2$var$qk |= c), 4 === $83602c5f7959a6c2$var$T && $83602c5f7959a6c2$var$Ck(a, $83602c5f7959a6c2$var$Z)), $83602c5f7959a6c2$var$Dk(a, d), 1 === c && 0 === $83602c5f7959a6c2$var$K && 0 === (b.mode & 1) && ($83602c5f7959a6c2$var$Gj = $83602c5f7959a6c2$var$B() + 500, $83602c5f7959a6c2$var$fg && $83602c5f7959a6c2$var$jg());
}
function $83602c5f7959a6c2$var$Dk(a, b) {
    var c = a.callbackNode;
    $83602c5f7959a6c2$var$wc(a, b);
    var d = $83602c5f7959a6c2$var$uc(a, a === $83602c5f7959a6c2$var$Q ? $83602c5f7959a6c2$var$Z : 0);
    if (0 === d) null !== c && $83602c5f7959a6c2$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $83602c5f7959a6c2$var$bc(c);
        if (1 === b) 0 === a.tag ? $83602c5f7959a6c2$var$ig($83602c5f7959a6c2$var$Ek.bind(null, a)) : $83602c5f7959a6c2$var$hg($83602c5f7959a6c2$var$Ek.bind(null, a)), $83602c5f7959a6c2$var$Jf(function() {
            0 === ($83602c5f7959a6c2$var$K & 6) && $83602c5f7959a6c2$var$jg();
        }), c = null;
        else {
            switch($83602c5f7959a6c2$var$Dc(d)){
                case 1:
                    c = $83602c5f7959a6c2$var$fc;
                    break;
                case 4:
                    c = $83602c5f7959a6c2$var$gc;
                    break;
                case 16:
                    c = $83602c5f7959a6c2$var$hc;
                    break;
                case 536870912:
                    c = $83602c5f7959a6c2$var$jc;
                    break;
                default:
                    c = $83602c5f7959a6c2$var$hc;
            }
            c = $83602c5f7959a6c2$var$Fk(c, $83602c5f7959a6c2$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $83602c5f7959a6c2$var$Gk(a, b) {
    $83602c5f7959a6c2$var$Ak = -1;
    $83602c5f7959a6c2$var$Bk = 0;
    if (0 !== ($83602c5f7959a6c2$var$K & 6)) throw Error($83602c5f7959a6c2$var$p(327));
    var c = a.callbackNode;
    if ($83602c5f7959a6c2$var$Hk() && a.callbackNode !== c) return null;
    var d = $83602c5f7959a6c2$var$uc(a, a === $83602c5f7959a6c2$var$Q ? $83602c5f7959a6c2$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $83602c5f7959a6c2$var$Ik(a, d);
    else {
        b = d;
        var e = $83602c5f7959a6c2$var$K;
        $83602c5f7959a6c2$var$K |= 2;
        var f = $83602c5f7959a6c2$var$Jk();
        if ($83602c5f7959a6c2$var$Q !== a || $83602c5f7959a6c2$var$Z !== b) $83602c5f7959a6c2$var$uk = null, $83602c5f7959a6c2$var$Gj = $83602c5f7959a6c2$var$B() + 500, $83602c5f7959a6c2$var$Kk(a, b);
        for(;;)try {
            $83602c5f7959a6c2$var$Lk();
            break;
        } catch (h) {
            $83602c5f7959a6c2$var$Mk(a, h);
        }
        $83602c5f7959a6c2$var$$g();
        $83602c5f7959a6c2$var$mk.current = f;
        $83602c5f7959a6c2$var$K = e;
        null !== $83602c5f7959a6c2$var$Y ? b = 0 : ($83602c5f7959a6c2$var$Q = null, $83602c5f7959a6c2$var$Z = 0, b = $83602c5f7959a6c2$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $83602c5f7959a6c2$var$xc(a), 0 !== e && (d = e, b = $83602c5f7959a6c2$var$Nk(a, e)));
        if (1 === b) throw c = $83602c5f7959a6c2$var$pk, $83602c5f7959a6c2$var$Kk(a, 0), $83602c5f7959a6c2$var$Ck(a, d), $83602c5f7959a6c2$var$Dk(a, $83602c5f7959a6c2$var$B()), c;
        if (6 === b) $83602c5f7959a6c2$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$83602c5f7959a6c2$var$Ok(e) && (b = $83602c5f7959a6c2$var$Ik(a, d), 2 === b && (f = $83602c5f7959a6c2$var$xc(a), 0 !== f && (d = f, b = $83602c5f7959a6c2$var$Nk(a, f))), 1 === b)) throw c = $83602c5f7959a6c2$var$pk, $83602c5f7959a6c2$var$Kk(a, 0), $83602c5f7959a6c2$var$Ck(a, d), $83602c5f7959a6c2$var$Dk(a, $83602c5f7959a6c2$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($83602c5f7959a6c2$var$p(345));
                case 2:
                    $83602c5f7959a6c2$var$Pk(a, $83602c5f7959a6c2$var$tk, $83602c5f7959a6c2$var$uk);
                    break;
                case 3:
                    $83602c5f7959a6c2$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $83602c5f7959a6c2$var$fk + 500 - $83602c5f7959a6c2$var$B(), 10 < b)) {
                        if (0 !== $83602c5f7959a6c2$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $83602c5f7959a6c2$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $83602c5f7959a6c2$var$Ff($83602c5f7959a6c2$var$Pk.bind(null, a, $83602c5f7959a6c2$var$tk, $83602c5f7959a6c2$var$uk), b);
                        break;
                    }
                    $83602c5f7959a6c2$var$Pk(a, $83602c5f7959a6c2$var$tk, $83602c5f7959a6c2$var$uk);
                    break;
                case 4:
                    $83602c5f7959a6c2$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $83602c5f7959a6c2$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $83602c5f7959a6c2$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $83602c5f7959a6c2$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $83602c5f7959a6c2$var$Ff($83602c5f7959a6c2$var$Pk.bind(null, a, $83602c5f7959a6c2$var$tk, $83602c5f7959a6c2$var$uk), d);
                        break;
                    }
                    $83602c5f7959a6c2$var$Pk(a, $83602c5f7959a6c2$var$tk, $83602c5f7959a6c2$var$uk);
                    break;
                case 5:
                    $83602c5f7959a6c2$var$Pk(a, $83602c5f7959a6c2$var$tk, $83602c5f7959a6c2$var$uk);
                    break;
                default:
                    throw Error($83602c5f7959a6c2$var$p(329));
            }
        }
    }
    $83602c5f7959a6c2$var$Dk(a, $83602c5f7959a6c2$var$B());
    return a.callbackNode === c ? $83602c5f7959a6c2$var$Gk.bind(null, a) : null;
}
function $83602c5f7959a6c2$var$Nk(a, b) {
    var c = $83602c5f7959a6c2$var$sk;
    a.current.memoizedState.isDehydrated && ($83602c5f7959a6c2$var$Kk(a, b).flags |= 256);
    a = $83602c5f7959a6c2$var$Ik(a, b);
    2 !== a && (b = $83602c5f7959a6c2$var$tk, $83602c5f7959a6c2$var$tk = c, null !== b && $83602c5f7959a6c2$var$Fj(b));
    return a;
}
function $83602c5f7959a6c2$var$Fj(a) {
    null === $83602c5f7959a6c2$var$tk ? $83602c5f7959a6c2$var$tk = a : $83602c5f7959a6c2$var$tk.push.apply($83602c5f7959a6c2$var$tk, a);
}
function $83602c5f7959a6c2$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$83602c5f7959a6c2$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $83602c5f7959a6c2$var$Ck(a, b) {
    b &= ~$83602c5f7959a6c2$var$rk;
    b &= ~$83602c5f7959a6c2$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $83602c5f7959a6c2$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $83602c5f7959a6c2$var$Ek(a) {
    if (0 !== ($83602c5f7959a6c2$var$K & 6)) throw Error($83602c5f7959a6c2$var$p(327));
    $83602c5f7959a6c2$var$Hk();
    var b = $83602c5f7959a6c2$var$uc(a, 0);
    if (0 === (b & 1)) return $83602c5f7959a6c2$var$Dk(a, $83602c5f7959a6c2$var$B()), null;
    var c = $83602c5f7959a6c2$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $83602c5f7959a6c2$var$xc(a);
        0 !== d && (b = d, c = $83602c5f7959a6c2$var$Nk(a, d));
    }
    if (1 === c) throw c = $83602c5f7959a6c2$var$pk, $83602c5f7959a6c2$var$Kk(a, 0), $83602c5f7959a6c2$var$Ck(a, b), $83602c5f7959a6c2$var$Dk(a, $83602c5f7959a6c2$var$B()), c;
    if (6 === c) throw Error($83602c5f7959a6c2$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $83602c5f7959a6c2$var$Pk(a, $83602c5f7959a6c2$var$tk, $83602c5f7959a6c2$var$uk);
    $83602c5f7959a6c2$var$Dk(a, $83602c5f7959a6c2$var$B());
    return null;
}
function $83602c5f7959a6c2$var$Qk(a, b) {
    var c = $83602c5f7959a6c2$var$K;
    $83602c5f7959a6c2$var$K |= 1;
    try {
        return a(b);
    } finally{
        $83602c5f7959a6c2$var$K = c, 0 === $83602c5f7959a6c2$var$K && ($83602c5f7959a6c2$var$Gj = $83602c5f7959a6c2$var$B() + 500, $83602c5f7959a6c2$var$fg && $83602c5f7959a6c2$var$jg());
    }
}
function $83602c5f7959a6c2$var$Rk(a) {
    null !== $83602c5f7959a6c2$var$wk && 0 === $83602c5f7959a6c2$var$wk.tag && 0 === ($83602c5f7959a6c2$var$K & 6) && $83602c5f7959a6c2$var$Hk();
    var b = $83602c5f7959a6c2$var$K;
    $83602c5f7959a6c2$var$K |= 1;
    var c = $83602c5f7959a6c2$var$ok.transition, d = $83602c5f7959a6c2$var$C;
    try {
        if ($83602c5f7959a6c2$var$ok.transition = null, $83602c5f7959a6c2$var$C = 1, a) return a();
    } finally{
        $83602c5f7959a6c2$var$C = d, $83602c5f7959a6c2$var$ok.transition = c, $83602c5f7959a6c2$var$K = b, 0 === ($83602c5f7959a6c2$var$K & 6) && $83602c5f7959a6c2$var$jg();
    }
}
function $83602c5f7959a6c2$var$Hj() {
    $83602c5f7959a6c2$var$fj = $83602c5f7959a6c2$var$ej.current;
    $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$ej);
}
function $83602c5f7959a6c2$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $83602c5f7959a6c2$var$Gf(c));
    if (null !== $83602c5f7959a6c2$var$Y) for(c = $83602c5f7959a6c2$var$Y.return; null !== c;){
        var d = c;
        $83602c5f7959a6c2$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $83602c5f7959a6c2$var$$f();
                break;
            case 3:
                $83602c5f7959a6c2$var$zh();
                $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$Wf);
                $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$H);
                $83602c5f7959a6c2$var$Eh();
                break;
            case 5:
                $83602c5f7959a6c2$var$Bh(d);
                break;
            case 4:
                $83602c5f7959a6c2$var$zh();
                break;
            case 13:
                $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$L);
                break;
            case 19:
                $83602c5f7959a6c2$var$E($83602c5f7959a6c2$var$L);
                break;
            case 10:
                $83602c5f7959a6c2$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $83602c5f7959a6c2$var$Hj();
        }
        c = c.return;
    }
    $83602c5f7959a6c2$var$Q = a;
    $83602c5f7959a6c2$var$Y = a = $83602c5f7959a6c2$var$Pg(a.current, null);
    $83602c5f7959a6c2$var$Z = $83602c5f7959a6c2$var$fj = b;
    $83602c5f7959a6c2$var$T = 0;
    $83602c5f7959a6c2$var$pk = null;
    $83602c5f7959a6c2$var$rk = $83602c5f7959a6c2$var$qk = $83602c5f7959a6c2$var$rh = 0;
    $83602c5f7959a6c2$var$tk = $83602c5f7959a6c2$var$sk = null;
    if (null !== $83602c5f7959a6c2$var$fh) {
        for(b = 0; b < $83602c5f7959a6c2$var$fh.length; b++)if (c = $83602c5f7959a6c2$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $83602c5f7959a6c2$var$fh = null;
    }
    return a;
}
function $83602c5f7959a6c2$var$Mk(a, b) {
    do {
        var c = $83602c5f7959a6c2$var$Y;
        try {
            $83602c5f7959a6c2$var$$g();
            $83602c5f7959a6c2$var$Fh.current = $83602c5f7959a6c2$var$Rh;
            if ($83602c5f7959a6c2$var$Ih) {
                for(var d = $83602c5f7959a6c2$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $83602c5f7959a6c2$var$Ih = !1;
            }
            $83602c5f7959a6c2$var$Hh = 0;
            $83602c5f7959a6c2$var$O = $83602c5f7959a6c2$var$N = $83602c5f7959a6c2$var$M = null;
            $83602c5f7959a6c2$var$Jh = !1;
            $83602c5f7959a6c2$var$Kh = 0;
            $83602c5f7959a6c2$var$nk.current = null;
            if (null === c || null === c.return) {
                $83602c5f7959a6c2$var$T = 1;
                $83602c5f7959a6c2$var$pk = b;
                $83602c5f7959a6c2$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $83602c5f7959a6c2$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $83602c5f7959a6c2$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $83602c5f7959a6c2$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $83602c5f7959a6c2$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $83602c5f7959a6c2$var$Si(f, l, b);
                            $83602c5f7959a6c2$var$tj();
                            break a;
                        }
                        k = Error($83602c5f7959a6c2$var$p(426));
                    }
                } else if ($83602c5f7959a6c2$var$I && h.mode & 1) {
                    var J = $83602c5f7959a6c2$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $83602c5f7959a6c2$var$Vi(J, g, h, f, b);
                        $83602c5f7959a6c2$var$Jg($83602c5f7959a6c2$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $83602c5f7959a6c2$var$Ji(k, h);
                4 !== $83602c5f7959a6c2$var$T && ($83602c5f7959a6c2$var$T = 2);
                null === $83602c5f7959a6c2$var$sk ? $83602c5f7959a6c2$var$sk = [
                    f
                ] : $83602c5f7959a6c2$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $83602c5f7959a6c2$var$Ni(f, k, b);
                            $83602c5f7959a6c2$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $83602c5f7959a6c2$var$Ri || !$83602c5f7959a6c2$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $83602c5f7959a6c2$var$Qi(f, h, b);
                                $83602c5f7959a6c2$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $83602c5f7959a6c2$var$Sk(c);
        } catch (na) {
            b = na;
            $83602c5f7959a6c2$var$Y === c && null !== c && ($83602c5f7959a6c2$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $83602c5f7959a6c2$var$Jk() {
    var a = $83602c5f7959a6c2$var$mk.current;
    $83602c5f7959a6c2$var$mk.current = $83602c5f7959a6c2$var$Rh;
    return null === a ? $83602c5f7959a6c2$var$Rh : a;
}
function $83602c5f7959a6c2$var$tj() {
    if (0 === $83602c5f7959a6c2$var$T || 3 === $83602c5f7959a6c2$var$T || 2 === $83602c5f7959a6c2$var$T) $83602c5f7959a6c2$var$T = 4;
    null === $83602c5f7959a6c2$var$Q || 0 === ($83602c5f7959a6c2$var$rh & 268435455) && 0 === ($83602c5f7959a6c2$var$qk & 268435455) || $83602c5f7959a6c2$var$Ck($83602c5f7959a6c2$var$Q, $83602c5f7959a6c2$var$Z);
}
function $83602c5f7959a6c2$var$Ik(a, b) {
    var c = $83602c5f7959a6c2$var$K;
    $83602c5f7959a6c2$var$K |= 2;
    var d = $83602c5f7959a6c2$var$Jk();
    if ($83602c5f7959a6c2$var$Q !== a || $83602c5f7959a6c2$var$Z !== b) $83602c5f7959a6c2$var$uk = null, $83602c5f7959a6c2$var$Kk(a, b);
    for(;;)try {
        $83602c5f7959a6c2$var$Tk();
        break;
    } catch (e) {
        $83602c5f7959a6c2$var$Mk(a, e);
    }
    $83602c5f7959a6c2$var$$g();
    $83602c5f7959a6c2$var$K = c;
    $83602c5f7959a6c2$var$mk.current = d;
    if (null !== $83602c5f7959a6c2$var$Y) throw Error($83602c5f7959a6c2$var$p(261));
    $83602c5f7959a6c2$var$Q = null;
    $83602c5f7959a6c2$var$Z = 0;
    return $83602c5f7959a6c2$var$T;
}
function $83602c5f7959a6c2$var$Tk() {
    for(; null !== $83602c5f7959a6c2$var$Y;)$83602c5f7959a6c2$var$Uk($83602c5f7959a6c2$var$Y);
}
function $83602c5f7959a6c2$var$Lk() {
    for(; null !== $83602c5f7959a6c2$var$Y && !$83602c5f7959a6c2$var$cc();)$83602c5f7959a6c2$var$Uk($83602c5f7959a6c2$var$Y);
}
function $83602c5f7959a6c2$var$Uk(a) {
    var b = $83602c5f7959a6c2$var$Vk(a.alternate, a, $83602c5f7959a6c2$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $83602c5f7959a6c2$var$Sk(a) : $83602c5f7959a6c2$var$Y = b;
    $83602c5f7959a6c2$var$nk.current = null;
}
function $83602c5f7959a6c2$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $83602c5f7959a6c2$var$Ej(c, b, $83602c5f7959a6c2$var$fj), null !== c) {
                $83602c5f7959a6c2$var$Y = c;
                return;
            }
        } else {
            c = $83602c5f7959a6c2$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $83602c5f7959a6c2$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $83602c5f7959a6c2$var$T = 6;
                $83602c5f7959a6c2$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $83602c5f7959a6c2$var$Y = b;
            return;
        }
        $83602c5f7959a6c2$var$Y = b = a;
    }while (null !== b);
    0 === $83602c5f7959a6c2$var$T && ($83602c5f7959a6c2$var$T = 5);
}
function $83602c5f7959a6c2$var$Pk(a, b, c) {
    var d = $83602c5f7959a6c2$var$C, e = $83602c5f7959a6c2$var$ok.transition;
    try {
        $83602c5f7959a6c2$var$ok.transition = null, $83602c5f7959a6c2$var$C = 1, $83602c5f7959a6c2$var$Wk(a, b, c, d);
    } finally{
        $83602c5f7959a6c2$var$ok.transition = e, $83602c5f7959a6c2$var$C = d;
    }
    return null;
}
function $83602c5f7959a6c2$var$Wk(a, b, c, d) {
    do $83602c5f7959a6c2$var$Hk();
    while (null !== $83602c5f7959a6c2$var$wk);
    if (0 !== ($83602c5f7959a6c2$var$K & 6)) throw Error($83602c5f7959a6c2$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($83602c5f7959a6c2$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $83602c5f7959a6c2$var$Bc(a, f);
    a === $83602c5f7959a6c2$var$Q && ($83602c5f7959a6c2$var$Y = $83602c5f7959a6c2$var$Q = null, $83602c5f7959a6c2$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $83602c5f7959a6c2$var$vk || ($83602c5f7959a6c2$var$vk = !0, $83602c5f7959a6c2$var$Fk($83602c5f7959a6c2$var$hc, function() {
        $83602c5f7959a6c2$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $83602c5f7959a6c2$var$ok.transition;
        $83602c5f7959a6c2$var$ok.transition = null;
        var g = $83602c5f7959a6c2$var$C;
        $83602c5f7959a6c2$var$C = 1;
        var h = $83602c5f7959a6c2$var$K;
        $83602c5f7959a6c2$var$K |= 4;
        $83602c5f7959a6c2$var$nk.current = null;
        $83602c5f7959a6c2$var$Oj(a, c);
        $83602c5f7959a6c2$var$dk(c, a);
        $83602c5f7959a6c2$var$Oe($83602c5f7959a6c2$var$Df);
        $83602c5f7959a6c2$var$dd = !!$83602c5f7959a6c2$var$Cf;
        $83602c5f7959a6c2$var$Df = $83602c5f7959a6c2$var$Cf = null;
        a.current = c;
        $83602c5f7959a6c2$var$hk(c, a, e);
        $83602c5f7959a6c2$var$dc();
        $83602c5f7959a6c2$var$K = h;
        $83602c5f7959a6c2$var$C = g;
        $83602c5f7959a6c2$var$ok.transition = f;
    } else a.current = c;
    $83602c5f7959a6c2$var$vk && ($83602c5f7959a6c2$var$vk = !1, $83602c5f7959a6c2$var$wk = a, $83602c5f7959a6c2$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($83602c5f7959a6c2$var$Ri = null);
    $83602c5f7959a6c2$var$mc(c.stateNode, d);
    $83602c5f7959a6c2$var$Dk(a, $83602c5f7959a6c2$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($83602c5f7959a6c2$var$Oi) throw $83602c5f7959a6c2$var$Oi = !1, a = $83602c5f7959a6c2$var$Pi, $83602c5f7959a6c2$var$Pi = null, a;
    0 !== ($83602c5f7959a6c2$var$xk & 1) && 0 !== a.tag && $83602c5f7959a6c2$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $83602c5f7959a6c2$var$zk ? $83602c5f7959a6c2$var$yk++ : ($83602c5f7959a6c2$var$yk = 0, $83602c5f7959a6c2$var$zk = a) : $83602c5f7959a6c2$var$yk = 0;
    $83602c5f7959a6c2$var$jg();
    return null;
}
function $83602c5f7959a6c2$var$Hk() {
    if (null !== $83602c5f7959a6c2$var$wk) {
        var a = $83602c5f7959a6c2$var$Dc($83602c5f7959a6c2$var$xk), b = $83602c5f7959a6c2$var$ok.transition, c = $83602c5f7959a6c2$var$C;
        try {
            $83602c5f7959a6c2$var$ok.transition = null;
            $83602c5f7959a6c2$var$C = 16 > a ? 16 : a;
            if (null === $83602c5f7959a6c2$var$wk) var d = !1;
            else {
                a = $83602c5f7959a6c2$var$wk;
                $83602c5f7959a6c2$var$wk = null;
                $83602c5f7959a6c2$var$xk = 0;
                if (0 !== ($83602c5f7959a6c2$var$K & 6)) throw Error($83602c5f7959a6c2$var$p(331));
                var e = $83602c5f7959a6c2$var$K;
                $83602c5f7959a6c2$var$K |= 4;
                for($83602c5f7959a6c2$var$V = a.current; null !== $83602c5f7959a6c2$var$V;){
                    var f = $83602c5f7959a6c2$var$V, g = f.child;
                    if (0 !== ($83602c5f7959a6c2$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($83602c5f7959a6c2$var$V = l; null !== $83602c5f7959a6c2$var$V;){
                                    var m = $83602c5f7959a6c2$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $83602c5f7959a6c2$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $83602c5f7959a6c2$var$V = q;
                                    else for(; null !== $83602c5f7959a6c2$var$V;){
                                        m = $83602c5f7959a6c2$var$V;
                                        var r = m.sibling, y = m.return;
                                        $83602c5f7959a6c2$var$Sj(m);
                                        if (m === l) {
                                            $83602c5f7959a6c2$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $83602c5f7959a6c2$var$V = r;
                                            break;
                                        }
                                        $83602c5f7959a6c2$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $83602c5f7959a6c2$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $83602c5f7959a6c2$var$V = g;
                    else b: for(; null !== $83602c5f7959a6c2$var$V;){
                        f = $83602c5f7959a6c2$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $83602c5f7959a6c2$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $83602c5f7959a6c2$var$V = x;
                            break b;
                        }
                        $83602c5f7959a6c2$var$V = f.return;
                    }
                }
                var w = a.current;
                for($83602c5f7959a6c2$var$V = w; null !== $83602c5f7959a6c2$var$V;){
                    g = $83602c5f7959a6c2$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $83602c5f7959a6c2$var$V = u;
                    else b: for(g = w; null !== $83602c5f7959a6c2$var$V;){
                        h = $83602c5f7959a6c2$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $83602c5f7959a6c2$var$Qj(9, h);
                            }
                        } catch (na) {
                            $83602c5f7959a6c2$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $83602c5f7959a6c2$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $83602c5f7959a6c2$var$V = F;
                            break b;
                        }
                        $83602c5f7959a6c2$var$V = h.return;
                    }
                }
                $83602c5f7959a6c2$var$K = e;
                $83602c5f7959a6c2$var$jg();
                if ($83602c5f7959a6c2$var$lc && "function" === typeof $83602c5f7959a6c2$var$lc.onPostCommitFiberRoot) try {
                    $83602c5f7959a6c2$var$lc.onPostCommitFiberRoot($83602c5f7959a6c2$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $83602c5f7959a6c2$var$C = c, $83602c5f7959a6c2$var$ok.transition = b;
        }
    }
    return !1;
}
function $83602c5f7959a6c2$var$Xk(a, b, c) {
    b = $83602c5f7959a6c2$var$Ji(c, b);
    b = $83602c5f7959a6c2$var$Ni(a, b, 1);
    a = $83602c5f7959a6c2$var$nh(a, b, 1);
    b = $83602c5f7959a6c2$var$R();
    null !== a && ($83602c5f7959a6c2$var$Ac(a, 1, b), $83602c5f7959a6c2$var$Dk(a, b));
}
function $83602c5f7959a6c2$var$W(a, b, c) {
    if (3 === a.tag) $83602c5f7959a6c2$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $83602c5f7959a6c2$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $83602c5f7959a6c2$var$Ri || !$83602c5f7959a6c2$var$Ri.has(d))) {
                a = $83602c5f7959a6c2$var$Ji(c, a);
                a = $83602c5f7959a6c2$var$Qi(b, a, 1);
                b = $83602c5f7959a6c2$var$nh(b, a, 1);
                a = $83602c5f7959a6c2$var$R();
                null !== b && ($83602c5f7959a6c2$var$Ac(b, 1, a), $83602c5f7959a6c2$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $83602c5f7959a6c2$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $83602c5f7959a6c2$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $83602c5f7959a6c2$var$Q === a && ($83602c5f7959a6c2$var$Z & c) === c && (4 === $83602c5f7959a6c2$var$T || 3 === $83602c5f7959a6c2$var$T && ($83602c5f7959a6c2$var$Z & 130023424) === $83602c5f7959a6c2$var$Z && 500 > $83602c5f7959a6c2$var$B() - $83602c5f7959a6c2$var$fk ? $83602c5f7959a6c2$var$Kk(a, 0) : $83602c5f7959a6c2$var$rk |= c);
    $83602c5f7959a6c2$var$Dk(a, b);
}
function $83602c5f7959a6c2$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $83602c5f7959a6c2$var$sc, $83602c5f7959a6c2$var$sc <<= 1, 0 === ($83602c5f7959a6c2$var$sc & 130023424) && ($83602c5f7959a6c2$var$sc = 4194304)));
    var c = $83602c5f7959a6c2$var$R();
    a = $83602c5f7959a6c2$var$ih(a, b);
    null !== a && ($83602c5f7959a6c2$var$Ac(a, b, c), $83602c5f7959a6c2$var$Dk(a, c));
}
function $83602c5f7959a6c2$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $83602c5f7959a6c2$var$Yk(a, c);
}
function $83602c5f7959a6c2$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($83602c5f7959a6c2$var$p(314));
    }
    null !== d && d.delete(b);
    $83602c5f7959a6c2$var$Yk(a, c);
}
var $83602c5f7959a6c2$var$Vk;
$83602c5f7959a6c2$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $83602c5f7959a6c2$var$Wf.current) $83602c5f7959a6c2$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $83602c5f7959a6c2$var$dh = !1, $83602c5f7959a6c2$var$yj(a, b, c);
            $83602c5f7959a6c2$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $83602c5f7959a6c2$var$dh = !1, $83602c5f7959a6c2$var$I && 0 !== (b.flags & 1048576) && $83602c5f7959a6c2$var$ug(b, $83602c5f7959a6c2$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $83602c5f7959a6c2$var$ij(a, b);
            a = b.pendingProps;
            var e = $83602c5f7959a6c2$var$Yf(b, $83602c5f7959a6c2$var$H.current);
            $83602c5f7959a6c2$var$ch(b, c);
            e = $83602c5f7959a6c2$var$Nh(null, b, d, a, e, c);
            var f = $83602c5f7959a6c2$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $83602c5f7959a6c2$var$Zf(d) ? (f = !0, $83602c5f7959a6c2$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $83602c5f7959a6c2$var$kh(b), e.updater = $83602c5f7959a6c2$var$Ei, b.stateNode = e, e._reactInternals = b, $83602c5f7959a6c2$var$Ii(b, d, a, c), b = $83602c5f7959a6c2$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $83602c5f7959a6c2$var$I && f && $83602c5f7959a6c2$var$vg(b), $83602c5f7959a6c2$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $83602c5f7959a6c2$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $83602c5f7959a6c2$var$Zk(d);
                a = $83602c5f7959a6c2$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $83602c5f7959a6c2$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $83602c5f7959a6c2$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $83602c5f7959a6c2$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $83602c5f7959a6c2$var$$i(null, b, d, $83602c5f7959a6c2$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($83602c5f7959a6c2$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $83602c5f7959a6c2$var$Ci(d, e), $83602c5f7959a6c2$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $83602c5f7959a6c2$var$Ci(d, e), $83602c5f7959a6c2$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $83602c5f7959a6c2$var$kj(b);
                if (null === a) throw Error($83602c5f7959a6c2$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $83602c5f7959a6c2$var$lh(a, b);
                $83602c5f7959a6c2$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $83602c5f7959a6c2$var$Ji(Error($83602c5f7959a6c2$var$p(423)), b);
                        b = $83602c5f7959a6c2$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $83602c5f7959a6c2$var$Ji(Error($83602c5f7959a6c2$var$p(424)), b);
                        b = $83602c5f7959a6c2$var$lj(a, b, d, c, e);
                        break a;
                    } else for($83602c5f7959a6c2$var$yg = $83602c5f7959a6c2$var$Lf(b.stateNode.containerInfo.firstChild), $83602c5f7959a6c2$var$xg = b, $83602c5f7959a6c2$var$I = !0, $83602c5f7959a6c2$var$zg = null, c = $83602c5f7959a6c2$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $83602c5f7959a6c2$var$Ig();
                    if (d === e) {
                        b = $83602c5f7959a6c2$var$Zi(a, b, c);
                        break a;
                    }
                    $83602c5f7959a6c2$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $83602c5f7959a6c2$var$Ah(b), null === a && $83602c5f7959a6c2$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $83602c5f7959a6c2$var$Ef(d, e) ? g = null : null !== f && $83602c5f7959a6c2$var$Ef(d, f) && (b.flags |= 32), $83602c5f7959a6c2$var$gj(a, b), $83602c5f7959a6c2$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $83602c5f7959a6c2$var$Eg(b), null;
        case 13:
            return $83602c5f7959a6c2$var$oj(a, b, c);
        case 4:
            return $83602c5f7959a6c2$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $83602c5f7959a6c2$var$Ug(b, null, d, c) : $83602c5f7959a6c2$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $83602c5f7959a6c2$var$Ci(d, e), $83602c5f7959a6c2$var$Yi(a, b, d, e, c);
        case 7:
            return $83602c5f7959a6c2$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $83602c5f7959a6c2$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $83602c5f7959a6c2$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $83602c5f7959a6c2$var$G($83602c5f7959a6c2$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($83602c5f7959a6c2$var$He(f.value, g)) {
                        if (f.children === e.children && !$83602c5f7959a6c2$var$Wf.current) {
                            b = $83602c5f7959a6c2$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $83602c5f7959a6c2$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $83602c5f7959a6c2$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($83602c5f7959a6c2$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $83602c5f7959a6c2$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $83602c5f7959a6c2$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $83602c5f7959a6c2$var$ch(b, c), e = $83602c5f7959a6c2$var$eh(e), d = d(e), b.flags |= 1, $83602c5f7959a6c2$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $83602c5f7959a6c2$var$Ci(d, b.pendingProps), e = $83602c5f7959a6c2$var$Ci(d.type, e), $83602c5f7959a6c2$var$$i(a, b, d, e, c);
        case 15:
            return $83602c5f7959a6c2$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $83602c5f7959a6c2$var$Ci(d, e), $83602c5f7959a6c2$var$ij(a, b), b.tag = 1, $83602c5f7959a6c2$var$Zf(d) ? (a = !0, $83602c5f7959a6c2$var$cg(b)) : a = !1, $83602c5f7959a6c2$var$ch(b, c), $83602c5f7959a6c2$var$Gi(b, d, e), $83602c5f7959a6c2$var$Ii(b, d, e, c), $83602c5f7959a6c2$var$jj(null, b, d, !0, a, c);
        case 19:
            return $83602c5f7959a6c2$var$xj(a, b, c);
        case 22:
            return $83602c5f7959a6c2$var$dj(a, b, c);
    }
    throw Error($83602c5f7959a6c2$var$p(156, b.tag));
};
function $83602c5f7959a6c2$var$Fk(a, b) {
    return $83602c5f7959a6c2$var$ac(a, b);
}
function $83602c5f7959a6c2$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $83602c5f7959a6c2$var$Bg(a, b, c, d) {
    return new $83602c5f7959a6c2$var$$k(a, b, c, d);
}
function $83602c5f7959a6c2$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $83602c5f7959a6c2$var$Zk(a) {
    if ("function" === typeof a) return $83602c5f7959a6c2$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $83602c5f7959a6c2$var$Da) return 11;
        if (a === $83602c5f7959a6c2$var$Ga) return 14;
    }
    return 2;
}
function $83602c5f7959a6c2$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $83602c5f7959a6c2$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $83602c5f7959a6c2$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $83602c5f7959a6c2$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $83602c5f7959a6c2$var$ya:
            return $83602c5f7959a6c2$var$Tg(c.children, e, f, b);
        case $83602c5f7959a6c2$var$za:
            g = 8;
            e |= 8;
            break;
        case $83602c5f7959a6c2$var$Aa:
            return a = $83602c5f7959a6c2$var$Bg(12, c, b, e | 2), a.elementType = $83602c5f7959a6c2$var$Aa, a.lanes = f, a;
        case $83602c5f7959a6c2$var$Ea:
            return a = $83602c5f7959a6c2$var$Bg(13, c, b, e), a.elementType = $83602c5f7959a6c2$var$Ea, a.lanes = f, a;
        case $83602c5f7959a6c2$var$Fa:
            return a = $83602c5f7959a6c2$var$Bg(19, c, b, e), a.elementType = $83602c5f7959a6c2$var$Fa, a.lanes = f, a;
        case $83602c5f7959a6c2$var$Ia:
            return $83602c5f7959a6c2$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $83602c5f7959a6c2$var$Ba:
                    g = 10;
                    break a;
                case $83602c5f7959a6c2$var$Ca:
                    g = 9;
                    break a;
                case $83602c5f7959a6c2$var$Da:
                    g = 11;
                    break a;
                case $83602c5f7959a6c2$var$Ga:
                    g = 14;
                    break a;
                case $83602c5f7959a6c2$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($83602c5f7959a6c2$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $83602c5f7959a6c2$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $83602c5f7959a6c2$var$Tg(a, b, c, d) {
    a = $83602c5f7959a6c2$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $83602c5f7959a6c2$var$pj(a, b, c, d) {
    a = $83602c5f7959a6c2$var$Bg(22, a, d, b);
    a.elementType = $83602c5f7959a6c2$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $83602c5f7959a6c2$var$Qg(a, b, c) {
    a = $83602c5f7959a6c2$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $83602c5f7959a6c2$var$Sg(a, b, c) {
    b = $83602c5f7959a6c2$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $83602c5f7959a6c2$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $83602c5f7959a6c2$var$zc(0);
    this.expirationTimes = $83602c5f7959a6c2$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $83602c5f7959a6c2$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $83602c5f7959a6c2$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $83602c5f7959a6c2$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $83602c5f7959a6c2$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $83602c5f7959a6c2$var$kh(f);
    return a;
}
function $83602c5f7959a6c2$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $83602c5f7959a6c2$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $83602c5f7959a6c2$var$dl(a) {
    if (!a) return $83602c5f7959a6c2$var$Vf;
    a = a._reactInternals;
    a: {
        if ($83602c5f7959a6c2$var$Vb(a) !== a || 1 !== a.tag) throw Error($83602c5f7959a6c2$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($83602c5f7959a6c2$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($83602c5f7959a6c2$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($83602c5f7959a6c2$var$Zf(c)) return $83602c5f7959a6c2$var$bg(a, c, b);
    }
    return b;
}
function $83602c5f7959a6c2$var$el(a, b, c, d, e, f, g, h, k) {
    a = $83602c5f7959a6c2$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $83602c5f7959a6c2$var$dl(null);
    c = a.current;
    d = $83602c5f7959a6c2$var$R();
    e = $83602c5f7959a6c2$var$yi(c);
    f = $83602c5f7959a6c2$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $83602c5f7959a6c2$var$nh(c, f, e);
    a.current.lanes = e;
    $83602c5f7959a6c2$var$Ac(a, e, d);
    $83602c5f7959a6c2$var$Dk(a, d);
    return a;
}
function $83602c5f7959a6c2$var$fl(a, b, c, d) {
    var e = b.current, f = $83602c5f7959a6c2$var$R(), g = $83602c5f7959a6c2$var$yi(e);
    c = $83602c5f7959a6c2$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $83602c5f7959a6c2$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $83602c5f7959a6c2$var$nh(e, b, g);
    null !== a && ($83602c5f7959a6c2$var$gi(a, e, g, f), $83602c5f7959a6c2$var$oh(a, e, g));
    return g;
}
function $83602c5f7959a6c2$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $83602c5f7959a6c2$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $83602c5f7959a6c2$var$il(a, b) {
    $83602c5f7959a6c2$var$hl(a, b);
    (a = a.alternate) && $83602c5f7959a6c2$var$hl(a, b);
}
function $83602c5f7959a6c2$var$jl() {
    return null;
}
var $83602c5f7959a6c2$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $83602c5f7959a6c2$var$ll(a) {
    this._internalRoot = a;
}
$83602c5f7959a6c2$var$ml.prototype.render = $83602c5f7959a6c2$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($83602c5f7959a6c2$var$p(409));
    $83602c5f7959a6c2$var$fl(a, b, null, null);
};
$83602c5f7959a6c2$var$ml.prototype.unmount = $83602c5f7959a6c2$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $83602c5f7959a6c2$var$Rk(function() {
            $83602c5f7959a6c2$var$fl(null, a, null, null);
        });
        b[$83602c5f7959a6c2$var$uf] = null;
    }
};
function $83602c5f7959a6c2$var$ml(a) {
    this._internalRoot = a;
}
$83602c5f7959a6c2$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $83602c5f7959a6c2$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $83602c5f7959a6c2$var$Qc.length && 0 !== b && b < $83602c5f7959a6c2$var$Qc[c].priority; c++);
        $83602c5f7959a6c2$var$Qc.splice(c, 0, a);
        0 === c && $83602c5f7959a6c2$var$Vc(a);
    }
};
function $83602c5f7959a6c2$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $83602c5f7959a6c2$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $83602c5f7959a6c2$var$pl() {}
function $83602c5f7959a6c2$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $83602c5f7959a6c2$var$gl(g);
                f.call(a);
            };
        }
        var g = $83602c5f7959a6c2$var$el(b, d, a, 0, null, !1, !1, "", $83602c5f7959a6c2$var$pl);
        a._reactRootContainer = g;
        a[$83602c5f7959a6c2$var$uf] = g.current;
        $83602c5f7959a6c2$var$sf(8 === a.nodeType ? a.parentNode : a);
        $83602c5f7959a6c2$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $83602c5f7959a6c2$var$gl(k);
            h.call(a);
        };
    }
    var k = $83602c5f7959a6c2$var$bl(a, 0, !1, null, null, !1, !1, "", $83602c5f7959a6c2$var$pl);
    a._reactRootContainer = k;
    a[$83602c5f7959a6c2$var$uf] = k.current;
    $83602c5f7959a6c2$var$sf(8 === a.nodeType ? a.parentNode : a);
    $83602c5f7959a6c2$var$Rk(function() {
        $83602c5f7959a6c2$var$fl(b, k, c, d);
    });
    return k;
}
function $83602c5f7959a6c2$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $83602c5f7959a6c2$var$gl(g);
                h.call(a);
            };
        }
        $83602c5f7959a6c2$var$fl(b, g, a, e);
    } else g = $83602c5f7959a6c2$var$ql(c, b, a, e, d);
    return $83602c5f7959a6c2$var$gl(g);
}
$83602c5f7959a6c2$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $83602c5f7959a6c2$var$tc(b.pendingLanes);
                0 !== c && ($83602c5f7959a6c2$var$Cc(b, c | 1), $83602c5f7959a6c2$var$Dk(b, $83602c5f7959a6c2$var$B()), 0 === ($83602c5f7959a6c2$var$K & 6) && ($83602c5f7959a6c2$var$Gj = $83602c5f7959a6c2$var$B() + 500, $83602c5f7959a6c2$var$jg()));
            }
            break;
        case 13:
            $83602c5f7959a6c2$var$Rk(function() {
                var b = $83602c5f7959a6c2$var$ih(a, 1);
                if (null !== b) {
                    var c = $83602c5f7959a6c2$var$R();
                    $83602c5f7959a6c2$var$gi(b, a, 1, c);
                }
            }), $83602c5f7959a6c2$var$il(a, 1);
    }
};
$83602c5f7959a6c2$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $83602c5f7959a6c2$var$ih(a, 134217728);
        if (null !== b) {
            var c = $83602c5f7959a6c2$var$R();
            $83602c5f7959a6c2$var$gi(b, a, 134217728, c);
        }
        $83602c5f7959a6c2$var$il(a, 134217728);
    }
};
$83602c5f7959a6c2$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $83602c5f7959a6c2$var$yi(a), c = $83602c5f7959a6c2$var$ih(a, b);
        if (null !== c) {
            var d = $83602c5f7959a6c2$var$R();
            $83602c5f7959a6c2$var$gi(c, a, b, d);
        }
        $83602c5f7959a6c2$var$il(a, b);
    }
};
$83602c5f7959a6c2$var$Hc = function() {
    return $83602c5f7959a6c2$var$C;
};
$83602c5f7959a6c2$var$Ic = function(a, b) {
    var c = $83602c5f7959a6c2$var$C;
    try {
        return $83602c5f7959a6c2$var$C = a, b();
    } finally{
        $83602c5f7959a6c2$var$C = c;
    }
};
$83602c5f7959a6c2$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $83602c5f7959a6c2$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $83602c5f7959a6c2$var$Db(d);
                        if (!e) throw Error($83602c5f7959a6c2$var$p(90));
                        $83602c5f7959a6c2$var$Wa(d);
                        $83602c5f7959a6c2$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $83602c5f7959a6c2$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $83602c5f7959a6c2$var$fb(a, !!c.multiple, b, !1);
    }
};
$83602c5f7959a6c2$var$Gb = $83602c5f7959a6c2$var$Qk;
$83602c5f7959a6c2$var$Hb = $83602c5f7959a6c2$var$Rk;
var $83602c5f7959a6c2$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $83602c5f7959a6c2$var$Cb,
        $83602c5f7959a6c2$var$ue,
        $83602c5f7959a6c2$var$Db,
        $83602c5f7959a6c2$var$Eb,
        $83602c5f7959a6c2$var$Fb,
        $83602c5f7959a6c2$var$Qk
    ]
}, $83602c5f7959a6c2$var$tl = {
    findFiberByHostInstance: $83602c5f7959a6c2$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $83602c5f7959a6c2$var$ul = {
    bundleType: $83602c5f7959a6c2$var$tl.bundleType,
    version: $83602c5f7959a6c2$var$tl.version,
    rendererPackageName: $83602c5f7959a6c2$var$tl.rendererPackageName,
    rendererConfig: $83602c5f7959a6c2$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $83602c5f7959a6c2$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $83602c5f7959a6c2$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $83602c5f7959a6c2$var$tl.findFiberByHostInstance || $83602c5f7959a6c2$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $83602c5f7959a6c2$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$83602c5f7959a6c2$var$vl.isDisabled && $83602c5f7959a6c2$var$vl.supportsFiber) try {
        $83602c5f7959a6c2$var$kc = $83602c5f7959a6c2$var$vl.inject($83602c5f7959a6c2$var$ul), $83602c5f7959a6c2$var$lc = $83602c5f7959a6c2$var$vl;
    } catch (a) {}
}
$83602c5f7959a6c2$export$ae55be85d98224ed = $83602c5f7959a6c2$var$sl;
$83602c5f7959a6c2$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$83602c5f7959a6c2$var$nl(b)) throw Error($83602c5f7959a6c2$var$p(200));
    return $83602c5f7959a6c2$var$cl(a, b, null, c);
};
$83602c5f7959a6c2$export$882461b6382ed46c = function(a, b) {
    if (!$83602c5f7959a6c2$var$nl(a)) throw Error($83602c5f7959a6c2$var$p(299));
    var c = !1, d = "", e = $83602c5f7959a6c2$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $83602c5f7959a6c2$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$83602c5f7959a6c2$var$uf] = b.current;
    $83602c5f7959a6c2$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $83602c5f7959a6c2$var$ll(b);
};
$83602c5f7959a6c2$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($83602c5f7959a6c2$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($83602c5f7959a6c2$var$p(268, a));
    }
    a = $83602c5f7959a6c2$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$83602c5f7959a6c2$export$cd75ccfd720a3cd4 = function(a) {
    return $83602c5f7959a6c2$var$Rk(a);
};
$83602c5f7959a6c2$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$83602c5f7959a6c2$var$ol(b)) throw Error($83602c5f7959a6c2$var$p(200));
    return $83602c5f7959a6c2$var$rl(null, a, b, !0, c);
};
$83602c5f7959a6c2$export$757ceba2d55c277e = function(a, b, c) {
    if (!$83602c5f7959a6c2$var$nl(a)) throw Error($83602c5f7959a6c2$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $83602c5f7959a6c2$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $83602c5f7959a6c2$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$83602c5f7959a6c2$var$uf] = b.current;
    $83602c5f7959a6c2$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $83602c5f7959a6c2$var$ml(b);
};
$83602c5f7959a6c2$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$83602c5f7959a6c2$var$ol(b)) throw Error($83602c5f7959a6c2$var$p(200));
    return $83602c5f7959a6c2$var$rl(null, a, b, !1, c);
};
$83602c5f7959a6c2$export$502457920280e6be = function(a) {
    if (!$83602c5f7959a6c2$var$ol(a)) throw Error($83602c5f7959a6c2$var$p(40));
    return a._reactRootContainer ? ($83602c5f7959a6c2$var$Rk(function() {
        $83602c5f7959a6c2$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$83602c5f7959a6c2$var$uf] = null;
        });
    }), !0) : !1;
};
$83602c5f7959a6c2$export$c78a37762a8d58e1 = $83602c5f7959a6c2$var$Qk;
$83602c5f7959a6c2$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$83602c5f7959a6c2$var$ol(c)) throw Error($83602c5f7959a6c2$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($83602c5f7959a6c2$var$p(38));
    return $83602c5f7959a6c2$var$rl(a, b, c, !1, d);
};
$83602c5f7959a6c2$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("hZysK", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cbk4m"));

});
parcelRegister("cbk4m", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $8de61471c947a8b4$export$c4744153514ff05d, (v) => $8de61471c947a8b4$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $8de61471c947a8b4$export$3e506c1ccc9cc1a7, (v) => $8de61471c947a8b4$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $8de61471c947a8b4$export$e26fe2ed2fa76875, (v) => $8de61471c947a8b4$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $8de61471c947a8b4$export$502329bbf4b505b1, (v) => $8de61471c947a8b4$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $8de61471c947a8b4$export$6e3807111c4874c4, (v) => $8de61471c947a8b4$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $8de61471c947a8b4$export$c27134553091fb3a, (v) => $8de61471c947a8b4$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $8de61471c947a8b4$export$33ee1acdc04fd2a2, (v) => $8de61471c947a8b4$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $8de61471c947a8b4$export$b00a404bbd5edef2, (v) => $8de61471c947a8b4$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $8de61471c947a8b4$export$8352ce38b91d0c62, (v) => $8de61471c947a8b4$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $8de61471c947a8b4$export$d66a1c1c77bd778b, (v) => $8de61471c947a8b4$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $8de61471c947a8b4$export$d3dfb8e4810cb555, (v) => $8de61471c947a8b4$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $8de61471c947a8b4$export$839f9183b0465a69, (v) => $8de61471c947a8b4$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $8de61471c947a8b4$export$72fdf0e06517287b, (v) => $8de61471c947a8b4$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $8de61471c947a8b4$export$4b844e58a3e414b4, (v) => $8de61471c947a8b4$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $8de61471c947a8b4$export$816d2913ae6b83b1, (v) => $8de61471c947a8b4$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $8de61471c947a8b4$export$61bcfe829111a1d0, (v) => $8de61471c947a8b4$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $8de61471c947a8b4$export$7ee8c9beb337bc3f, (v) => $8de61471c947a8b4$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $8de61471c947a8b4$export$b5836b71941fa3ed, (v) => $8de61471c947a8b4$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $8de61471c947a8b4$export$cf845f2c119da08a, (v) => $8de61471c947a8b4$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8de61471c947a8b4$export$c4744153514ff05d;
var $8de61471c947a8b4$export$3e506c1ccc9cc1a7;
var $8de61471c947a8b4$export$e26fe2ed2fa76875;
var $8de61471c947a8b4$export$502329bbf4b505b1;
var $8de61471c947a8b4$export$6e3807111c4874c4;
var $8de61471c947a8b4$export$c27134553091fb3a;
var $8de61471c947a8b4$export$33ee1acdc04fd2a2;
var $8de61471c947a8b4$export$b00a404bbd5edef2;
var $8de61471c947a8b4$export$8352ce38b91d0c62;
var $8de61471c947a8b4$export$d66a1c1c77bd778b;
var $8de61471c947a8b4$export$d3dfb8e4810cb555;
var $8de61471c947a8b4$export$839f9183b0465a69;
var $8de61471c947a8b4$export$72fdf0e06517287b;
var $8de61471c947a8b4$export$4b844e58a3e414b4;
var $8de61471c947a8b4$export$816d2913ae6b83b1;
var $8de61471c947a8b4$export$61bcfe829111a1d0;
var $8de61471c947a8b4$export$7ee8c9beb337bc3f;
var $8de61471c947a8b4$export$b5836b71941fa3ed;
var $8de61471c947a8b4$export$cf845f2c119da08a;
'use strict';
function $8de61471c947a8b4$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $8de61471c947a8b4$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $8de61471c947a8b4$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $8de61471c947a8b4$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $8de61471c947a8b4$var$g(C, c)) n < e && 0 > $8de61471c947a8b4$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $8de61471c947a8b4$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $8de61471c947a8b4$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $8de61471c947a8b4$var$l = performance;
    $8de61471c947a8b4$export$c4744153514ff05d = function() {
        return $8de61471c947a8b4$var$l.now();
    };
} else {
    var $8de61471c947a8b4$var$p = Date, $8de61471c947a8b4$var$q = $8de61471c947a8b4$var$p.now();
    $8de61471c947a8b4$export$c4744153514ff05d = function() {
        return $8de61471c947a8b4$var$p.now() - $8de61471c947a8b4$var$q;
    };
}
var $8de61471c947a8b4$var$r = [], $8de61471c947a8b4$var$t = [], $8de61471c947a8b4$var$u = 1, $8de61471c947a8b4$var$v = null, $8de61471c947a8b4$var$y = 3, $8de61471c947a8b4$var$z = !1, $8de61471c947a8b4$var$A = !1, $8de61471c947a8b4$var$B = !1, $8de61471c947a8b4$var$D = "function" === typeof setTimeout ? setTimeout : null, $8de61471c947a8b4$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $8de61471c947a8b4$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $8de61471c947a8b4$var$G(a) {
    for(var b = $8de61471c947a8b4$var$h($8de61471c947a8b4$var$t); null !== b;){
        if (null === b.callback) $8de61471c947a8b4$var$k($8de61471c947a8b4$var$t);
        else if (b.startTime <= a) $8de61471c947a8b4$var$k($8de61471c947a8b4$var$t), b.sortIndex = b.expirationTime, $8de61471c947a8b4$var$f($8de61471c947a8b4$var$r, b);
        else break;
        b = $8de61471c947a8b4$var$h($8de61471c947a8b4$var$t);
    }
}
function $8de61471c947a8b4$var$H(a) {
    $8de61471c947a8b4$var$B = !1;
    $8de61471c947a8b4$var$G(a);
    if (!$8de61471c947a8b4$var$A) {
        if (null !== $8de61471c947a8b4$var$h($8de61471c947a8b4$var$r)) $8de61471c947a8b4$var$A = !0, $8de61471c947a8b4$var$I($8de61471c947a8b4$var$J);
        else {
            var b = $8de61471c947a8b4$var$h($8de61471c947a8b4$var$t);
            null !== b && $8de61471c947a8b4$var$K($8de61471c947a8b4$var$H, b.startTime - a);
        }
    }
}
function $8de61471c947a8b4$var$J(a, b) {
    $8de61471c947a8b4$var$A = !1;
    $8de61471c947a8b4$var$B && ($8de61471c947a8b4$var$B = !1, $8de61471c947a8b4$var$E($8de61471c947a8b4$var$L), $8de61471c947a8b4$var$L = -1);
    $8de61471c947a8b4$var$z = !0;
    var c = $8de61471c947a8b4$var$y;
    try {
        $8de61471c947a8b4$var$G(b);
        for($8de61471c947a8b4$var$v = $8de61471c947a8b4$var$h($8de61471c947a8b4$var$r); null !== $8de61471c947a8b4$var$v && (!($8de61471c947a8b4$var$v.expirationTime > b) || a && !$8de61471c947a8b4$var$M());){
            var d = $8de61471c947a8b4$var$v.callback;
            if ("function" === typeof d) {
                $8de61471c947a8b4$var$v.callback = null;
                $8de61471c947a8b4$var$y = $8de61471c947a8b4$var$v.priorityLevel;
                var e = d($8de61471c947a8b4$var$v.expirationTime <= b);
                b = $8de61471c947a8b4$export$c4744153514ff05d();
                "function" === typeof e ? $8de61471c947a8b4$var$v.callback = e : $8de61471c947a8b4$var$v === $8de61471c947a8b4$var$h($8de61471c947a8b4$var$r) && $8de61471c947a8b4$var$k($8de61471c947a8b4$var$r);
                $8de61471c947a8b4$var$G(b);
            } else $8de61471c947a8b4$var$k($8de61471c947a8b4$var$r);
            $8de61471c947a8b4$var$v = $8de61471c947a8b4$var$h($8de61471c947a8b4$var$r);
        }
        if (null !== $8de61471c947a8b4$var$v) var w = !0;
        else {
            var m = $8de61471c947a8b4$var$h($8de61471c947a8b4$var$t);
            null !== m && $8de61471c947a8b4$var$K($8de61471c947a8b4$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $8de61471c947a8b4$var$v = null, $8de61471c947a8b4$var$y = c, $8de61471c947a8b4$var$z = !1;
    }
}
var $8de61471c947a8b4$var$N = !1, $8de61471c947a8b4$var$O = null, $8de61471c947a8b4$var$L = -1, $8de61471c947a8b4$var$P = 5, $8de61471c947a8b4$var$Q = -1;
function $8de61471c947a8b4$var$M() {
    return $8de61471c947a8b4$export$c4744153514ff05d() - $8de61471c947a8b4$var$Q < $8de61471c947a8b4$var$P ? !1 : !0;
}
function $8de61471c947a8b4$var$R() {
    if (null !== $8de61471c947a8b4$var$O) {
        var a = $8de61471c947a8b4$export$c4744153514ff05d();
        $8de61471c947a8b4$var$Q = a;
        var b = !0;
        try {
            b = $8de61471c947a8b4$var$O(!0, a);
        } finally{
            b ? $8de61471c947a8b4$var$S() : ($8de61471c947a8b4$var$N = !1, $8de61471c947a8b4$var$O = null);
        }
    } else $8de61471c947a8b4$var$N = !1;
}
var $8de61471c947a8b4$var$S;
if ("function" === typeof $8de61471c947a8b4$var$F) $8de61471c947a8b4$var$S = function() {
    $8de61471c947a8b4$var$F($8de61471c947a8b4$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $8de61471c947a8b4$var$T = new MessageChannel, $8de61471c947a8b4$var$U = $8de61471c947a8b4$var$T.port2;
    $8de61471c947a8b4$var$T.port1.onmessage = $8de61471c947a8b4$var$R;
    $8de61471c947a8b4$var$S = function() {
        $8de61471c947a8b4$var$U.postMessage(null);
    };
} else $8de61471c947a8b4$var$S = function() {
    $8de61471c947a8b4$var$D($8de61471c947a8b4$var$R, 0);
};
function $8de61471c947a8b4$var$I(a) {
    $8de61471c947a8b4$var$O = a;
    $8de61471c947a8b4$var$N || ($8de61471c947a8b4$var$N = !0, $8de61471c947a8b4$var$S());
}
function $8de61471c947a8b4$var$K(a, b) {
    $8de61471c947a8b4$var$L = $8de61471c947a8b4$var$D(function() {
        a($8de61471c947a8b4$export$c4744153514ff05d());
    }, b);
}
$8de61471c947a8b4$export$3e506c1ccc9cc1a7 = 5;
$8de61471c947a8b4$export$e26fe2ed2fa76875 = 1;
$8de61471c947a8b4$export$502329bbf4b505b1 = 4;
$8de61471c947a8b4$export$6e3807111c4874c4 = 3;
$8de61471c947a8b4$export$c27134553091fb3a = null;
$8de61471c947a8b4$export$33ee1acdc04fd2a2 = 2;
$8de61471c947a8b4$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$8de61471c947a8b4$export$8352ce38b91d0c62 = function() {
    $8de61471c947a8b4$var$A || $8de61471c947a8b4$var$z || ($8de61471c947a8b4$var$A = !0, $8de61471c947a8b4$var$I($8de61471c947a8b4$var$J));
};
$8de61471c947a8b4$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $8de61471c947a8b4$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$8de61471c947a8b4$export$d3dfb8e4810cb555 = function() {
    return $8de61471c947a8b4$var$y;
};
$8de61471c947a8b4$export$839f9183b0465a69 = function() {
    return $8de61471c947a8b4$var$h($8de61471c947a8b4$var$r);
};
$8de61471c947a8b4$export$72fdf0e06517287b = function(a) {
    switch($8de61471c947a8b4$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $8de61471c947a8b4$var$y;
    }
    var c = $8de61471c947a8b4$var$y;
    $8de61471c947a8b4$var$y = b;
    try {
        return a();
    } finally{
        $8de61471c947a8b4$var$y = c;
    }
};
$8de61471c947a8b4$export$4b844e58a3e414b4 = function() {};
$8de61471c947a8b4$export$816d2913ae6b83b1 = function() {};
$8de61471c947a8b4$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $8de61471c947a8b4$var$y;
    $8de61471c947a8b4$var$y = a;
    try {
        return b();
    } finally{
        $8de61471c947a8b4$var$y = c;
    }
};
$8de61471c947a8b4$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $8de61471c947a8b4$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $8de61471c947a8b4$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $8de61471c947a8b4$var$f($8de61471c947a8b4$var$t, a), null === $8de61471c947a8b4$var$h($8de61471c947a8b4$var$r) && a === $8de61471c947a8b4$var$h($8de61471c947a8b4$var$t) && ($8de61471c947a8b4$var$B ? ($8de61471c947a8b4$var$E($8de61471c947a8b4$var$L), $8de61471c947a8b4$var$L = -1) : $8de61471c947a8b4$var$B = !0, $8de61471c947a8b4$var$K($8de61471c947a8b4$var$H, c - d))) : (a.sortIndex = e, $8de61471c947a8b4$var$f($8de61471c947a8b4$var$r, a), $8de61471c947a8b4$var$A || $8de61471c947a8b4$var$z || ($8de61471c947a8b4$var$A = !0, $8de61471c947a8b4$var$I($8de61471c947a8b4$var$J)));
    return a;
};
$8de61471c947a8b4$export$b5836b71941fa3ed = $8de61471c947a8b4$var$M;
$8de61471c947a8b4$export$cf845f2c119da08a = function(a) {
    var b = $8de61471c947a8b4$var$y;
    return function() {
        var c = $8de61471c947a8b4$var$y;
        $8de61471c947a8b4$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $8de61471c947a8b4$var$y = c;
        }
    };
};

});



parcelRegister("1yPRO", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1231331ea28b2788$export$ffb0004e005737fa, (v) => $1231331ea28b2788$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $1231331ea28b2788$export$34b9dba7ce09269b, (v) => $1231331ea28b2788$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $1231331ea28b2788$export$25062201e9e25d76, (v) => $1231331ea28b2788$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1231331ea28b2788$export$ffb0004e005737fa;
var $1231331ea28b2788$export$34b9dba7ce09269b;
var $1231331ea28b2788$export$25062201e9e25d76;
'use strict';

var $ltGt3 = parcelRequire("ltGt3");
var $1231331ea28b2788$var$k = Symbol.for("react.element"), $1231331ea28b2788$var$l = Symbol.for("react.fragment"), $1231331ea28b2788$var$m = Object.prototype.hasOwnProperty, $1231331ea28b2788$var$n = $ltGt3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1231331ea28b2788$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1231331ea28b2788$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1231331ea28b2788$var$m.call(a, b) && !$1231331ea28b2788$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1231331ea28b2788$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1231331ea28b2788$var$n.current
    };
}
$1231331ea28b2788$export$ffb0004e005737fa = $1231331ea28b2788$var$l;
$1231331ea28b2788$export$34b9dba7ce09269b = $1231331ea28b2788$var$q;
$1231331ea28b2788$export$25062201e9e25d76 = $1231331ea28b2788$var$q;

});

parcelRegister("5oFGv", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $3edf8756d39d488c$export$a7c73072b1a182ae, (v) => $3edf8756d39d488c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $3edf8756d39d488c$export$9f27bc3417b4524d, (v) => $3edf8756d39d488c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $3edf8756d39d488c$export$db77ccec0bb4ccac, (v) => $3edf8756d39d488c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $3edf8756d39d488c$export$8392c0c9d3dcbd35, (v) => $3edf8756d39d488c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $3edf8756d39d488c$export$ffb0004e005737fa, (v) => $3edf8756d39d488c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $3edf8756d39d488c$export$b624eff549462981, (v) => $3edf8756d39d488c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $3edf8756d39d488c$export$7897aa7841a5380c, (v) => $3edf8756d39d488c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $3edf8756d39d488c$export$602eac185826482c, (v) => $3edf8756d39d488c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $3edf8756d39d488c$export$e2c29f18771995cb, (v) => $3edf8756d39d488c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $3edf8756d39d488c$export$5f8d39834fd61797, (v) => $3edf8756d39d488c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $3edf8756d39d488c$export$74bf444e3cd11ea5, (v) => $3edf8756d39d488c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $3edf8756d39d488c$export$998bcd577473dd93, (v) => $3edf8756d39d488c$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $3edf8756d39d488c$export$92387174baf9b227, (v) => $3edf8756d39d488c$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $3edf8756d39d488c$export$ec112efeb987d9c6, (v) => $3edf8756d39d488c$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $3edf8756d39d488c$export$b706b080d889d2c9, (v) => $3edf8756d39d488c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $3edf8756d39d488c$export$5be5a87408f70ddc, (v) => $3edf8756d39d488c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $3edf8756d39d488c$export$45a5e7f76e0caa8d, (v) => $3edf8756d39d488c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $3edf8756d39d488c$export$455c2e768291efa6, (v) => $3edf8756d39d488c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $3edf8756d39d488c$export$9522e17588c12572, (v) => $3edf8756d39d488c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $3edf8756d39d488c$export$2110ac352bb060b9, (v) => $3edf8756d39d488c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $3edf8756d39d488c$export$56885ab8b9c456ab, (v) => $3edf8756d39d488c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $3edf8756d39d488c$export$d927fcb6adf8f9de, (v) => $3edf8756d39d488c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $3edf8756d39d488c$export$b82d16f27459e05a, (v) => $3edf8756d39d488c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $3edf8756d39d488c$export$522c17b4f5e123e8, (v) => $3edf8756d39d488c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $3edf8756d39d488c$export$1aabd8a0274ecfd6, (v) => $3edf8756d39d488c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $3edf8756d39d488c$export$3d6c20d97e46b957, (v) => $3edf8756d39d488c$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $3edf8756d39d488c$export$9b621391a187a31a, (v) => $3edf8756d39d488c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $3edf8756d39d488c$export$f5bbd400c2f4426f, (v) => $3edf8756d39d488c$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3edf8756d39d488c$export$a7c73072b1a182ae;
var $3edf8756d39d488c$export$9f27bc3417b4524d;
var $3edf8756d39d488c$export$db77ccec0bb4ccac;
var $3edf8756d39d488c$export$8392c0c9d3dcbd35;
var $3edf8756d39d488c$export$ffb0004e005737fa;
var $3edf8756d39d488c$export$b624eff549462981;
var $3edf8756d39d488c$export$7897aa7841a5380c;
var $3edf8756d39d488c$export$602eac185826482c;
var $3edf8756d39d488c$export$e2c29f18771995cb;
var $3edf8756d39d488c$export$5f8d39834fd61797;
var $3edf8756d39d488c$export$74bf444e3cd11ea5;
var $3edf8756d39d488c$export$998bcd577473dd93;
var $3edf8756d39d488c$export$92387174baf9b227;
var $3edf8756d39d488c$export$ec112efeb987d9c6;
var $3edf8756d39d488c$export$b706b080d889d2c9;
var $3edf8756d39d488c$export$5be5a87408f70ddc;
var $3edf8756d39d488c$export$45a5e7f76e0caa8d;
var $3edf8756d39d488c$export$455c2e768291efa6;
var $3edf8756d39d488c$export$9522e17588c12572;
var $3edf8756d39d488c$export$2110ac352bb060b9;
var $3edf8756d39d488c$export$56885ab8b9c456ab;
var $3edf8756d39d488c$export$d927fcb6adf8f9de;
var $3edf8756d39d488c$export$b82d16f27459e05a;
var $3edf8756d39d488c$export$522c17b4f5e123e8;
var $3edf8756d39d488c$export$1aabd8a0274ecfd6;
var $3edf8756d39d488c$export$3d6c20d97e46b957;
var $3edf8756d39d488c$export$9b621391a187a31a;
var $3edf8756d39d488c$export$f5bbd400c2f4426f;
'use strict';
var $3edf8756d39d488c$var$b = Symbol.for("react.element"), $3edf8756d39d488c$var$c = Symbol.for("react.portal"), $3edf8756d39d488c$var$d = Symbol.for("react.fragment"), $3edf8756d39d488c$var$e = Symbol.for("react.strict_mode"), $3edf8756d39d488c$var$f = Symbol.for("react.profiler"), $3edf8756d39d488c$var$g = Symbol.for("react.provider"), $3edf8756d39d488c$var$h = Symbol.for("react.context"), $3edf8756d39d488c$var$k = Symbol.for("react.server_context"), $3edf8756d39d488c$var$l = Symbol.for("react.forward_ref"), $3edf8756d39d488c$var$m = Symbol.for("react.suspense"), $3edf8756d39d488c$var$n = Symbol.for("react.suspense_list"), $3edf8756d39d488c$var$p = Symbol.for("react.memo"), $3edf8756d39d488c$var$q = Symbol.for("react.lazy"), $3edf8756d39d488c$var$t = Symbol.for("react.offscreen"), $3edf8756d39d488c$var$u;
$3edf8756d39d488c$var$u = Symbol.for("react.module.reference");
function $3edf8756d39d488c$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $3edf8756d39d488c$var$b:
                switch(a = a.type, a){
                    case $3edf8756d39d488c$var$d:
                    case $3edf8756d39d488c$var$f:
                    case $3edf8756d39d488c$var$e:
                    case $3edf8756d39d488c$var$m:
                    case $3edf8756d39d488c$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $3edf8756d39d488c$var$k:
                            case $3edf8756d39d488c$var$h:
                            case $3edf8756d39d488c$var$l:
                            case $3edf8756d39d488c$var$q:
                            case $3edf8756d39d488c$var$p:
                            case $3edf8756d39d488c$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $3edf8756d39d488c$var$c:
                return r;
        }
    }
}
$3edf8756d39d488c$export$a7c73072b1a182ae = $3edf8756d39d488c$var$h;
$3edf8756d39d488c$export$9f27bc3417b4524d = $3edf8756d39d488c$var$g;
$3edf8756d39d488c$export$db77ccec0bb4ccac = $3edf8756d39d488c$var$b;
$3edf8756d39d488c$export$8392c0c9d3dcbd35 = $3edf8756d39d488c$var$l;
$3edf8756d39d488c$export$ffb0004e005737fa = $3edf8756d39d488c$var$d;
$3edf8756d39d488c$export$b624eff549462981 = $3edf8756d39d488c$var$q;
$3edf8756d39d488c$export$7897aa7841a5380c = $3edf8756d39d488c$var$p;
$3edf8756d39d488c$export$602eac185826482c = $3edf8756d39d488c$var$c;
$3edf8756d39d488c$export$e2c29f18771995cb = $3edf8756d39d488c$var$f;
$3edf8756d39d488c$export$5f8d39834fd61797 = $3edf8756d39d488c$var$e;
$3edf8756d39d488c$export$74bf444e3cd11ea5 = $3edf8756d39d488c$var$m;
$3edf8756d39d488c$export$998bcd577473dd93 = $3edf8756d39d488c$var$n;
$3edf8756d39d488c$export$92387174baf9b227 = function() {
    return !1;
};
$3edf8756d39d488c$export$ec112efeb987d9c6 = function() {
    return !1;
};
$3edf8756d39d488c$export$b706b080d889d2c9 = function(a) {
    return $3edf8756d39d488c$var$v(a) === $3edf8756d39d488c$var$h;
};
$3edf8756d39d488c$export$5be5a87408f70ddc = function(a) {
    return $3edf8756d39d488c$var$v(a) === $3edf8756d39d488c$var$g;
};
$3edf8756d39d488c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3edf8756d39d488c$var$b;
};
$3edf8756d39d488c$export$455c2e768291efa6 = function(a) {
    return $3edf8756d39d488c$var$v(a) === $3edf8756d39d488c$var$l;
};
$3edf8756d39d488c$export$9522e17588c12572 = function(a) {
    return $3edf8756d39d488c$var$v(a) === $3edf8756d39d488c$var$d;
};
$3edf8756d39d488c$export$2110ac352bb060b9 = function(a) {
    return $3edf8756d39d488c$var$v(a) === $3edf8756d39d488c$var$q;
};
$3edf8756d39d488c$export$56885ab8b9c456ab = function(a) {
    return $3edf8756d39d488c$var$v(a) === $3edf8756d39d488c$var$p;
};
$3edf8756d39d488c$export$d927fcb6adf8f9de = function(a) {
    return $3edf8756d39d488c$var$v(a) === $3edf8756d39d488c$var$c;
};
$3edf8756d39d488c$export$b82d16f27459e05a = function(a) {
    return $3edf8756d39d488c$var$v(a) === $3edf8756d39d488c$var$f;
};
$3edf8756d39d488c$export$522c17b4f5e123e8 = function(a) {
    return $3edf8756d39d488c$var$v(a) === $3edf8756d39d488c$var$e;
};
$3edf8756d39d488c$export$1aabd8a0274ecfd6 = function(a) {
    return $3edf8756d39d488c$var$v(a) === $3edf8756d39d488c$var$m;
};
$3edf8756d39d488c$export$3d6c20d97e46b957 = function(a) {
    return $3edf8756d39d488c$var$v(a) === $3edf8756d39d488c$var$n;
};
$3edf8756d39d488c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $3edf8756d39d488c$var$d || a === $3edf8756d39d488c$var$f || a === $3edf8756d39d488c$var$e || a === $3edf8756d39d488c$var$m || a === $3edf8756d39d488c$var$n || a === $3edf8756d39d488c$var$t || "object" === typeof a && null !== a && (a.$$typeof === $3edf8756d39d488c$var$q || a.$$typeof === $3edf8756d39d488c$var$p || a.$$typeof === $3edf8756d39d488c$var$g || a.$$typeof === $3edf8756d39d488c$var$h || a.$$typeof === $3edf8756d39d488c$var$l || a.$$typeof === $3edf8756d39d488c$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$3edf8756d39d488c$export$f5bbd400c2f4426f = $3edf8756d39d488c$var$v;

});

parcelRegister("f0FtT", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $aed708603be332de$export$a7c73072b1a182ae, (v) => $aed708603be332de$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $aed708603be332de$export$9f27bc3417b4524d, (v) => $aed708603be332de$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $aed708603be332de$export$db77ccec0bb4ccac, (v) => $aed708603be332de$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $aed708603be332de$export$8392c0c9d3dcbd35, (v) => $aed708603be332de$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $aed708603be332de$export$ffb0004e005737fa, (v) => $aed708603be332de$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $aed708603be332de$export$b624eff549462981, (v) => $aed708603be332de$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $aed708603be332de$export$7897aa7841a5380c, (v) => $aed708603be332de$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $aed708603be332de$export$602eac185826482c, (v) => $aed708603be332de$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $aed708603be332de$export$e2c29f18771995cb, (v) => $aed708603be332de$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $aed708603be332de$export$5f8d39834fd61797, (v) => $aed708603be332de$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $aed708603be332de$export$74bf444e3cd11ea5, (v) => $aed708603be332de$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $aed708603be332de$export$998bcd577473dd93, (v) => $aed708603be332de$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $aed708603be332de$export$92387174baf9b227, (v) => $aed708603be332de$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $aed708603be332de$export$ec112efeb987d9c6, (v) => $aed708603be332de$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $aed708603be332de$export$b706b080d889d2c9, (v) => $aed708603be332de$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $aed708603be332de$export$5be5a87408f70ddc, (v) => $aed708603be332de$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $aed708603be332de$export$45a5e7f76e0caa8d, (v) => $aed708603be332de$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $aed708603be332de$export$455c2e768291efa6, (v) => $aed708603be332de$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $aed708603be332de$export$9522e17588c12572, (v) => $aed708603be332de$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $aed708603be332de$export$2110ac352bb060b9, (v) => $aed708603be332de$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $aed708603be332de$export$56885ab8b9c456ab, (v) => $aed708603be332de$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $aed708603be332de$export$d927fcb6adf8f9de, (v) => $aed708603be332de$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $aed708603be332de$export$b82d16f27459e05a, (v) => $aed708603be332de$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $aed708603be332de$export$522c17b4f5e123e8, (v) => $aed708603be332de$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $aed708603be332de$export$1aabd8a0274ecfd6, (v) => $aed708603be332de$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $aed708603be332de$export$3d6c20d97e46b957, (v) => $aed708603be332de$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $aed708603be332de$export$9b621391a187a31a, (v) => $aed708603be332de$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $aed708603be332de$export$f5bbd400c2f4426f, (v) => $aed708603be332de$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aed708603be332de$export$a7c73072b1a182ae;
var $aed708603be332de$export$9f27bc3417b4524d;
var $aed708603be332de$export$db77ccec0bb4ccac;
var $aed708603be332de$export$8392c0c9d3dcbd35;
var $aed708603be332de$export$ffb0004e005737fa;
var $aed708603be332de$export$b624eff549462981;
var $aed708603be332de$export$7897aa7841a5380c;
var $aed708603be332de$export$602eac185826482c;
var $aed708603be332de$export$e2c29f18771995cb;
var $aed708603be332de$export$5f8d39834fd61797;
var $aed708603be332de$export$74bf444e3cd11ea5;
var $aed708603be332de$export$998bcd577473dd93;
var $aed708603be332de$export$92387174baf9b227;
var $aed708603be332de$export$ec112efeb987d9c6;
var $aed708603be332de$export$b706b080d889d2c9;
var $aed708603be332de$export$5be5a87408f70ddc;
var $aed708603be332de$export$45a5e7f76e0caa8d;
var $aed708603be332de$export$455c2e768291efa6;
var $aed708603be332de$export$9522e17588c12572;
var $aed708603be332de$export$2110ac352bb060b9;
var $aed708603be332de$export$56885ab8b9c456ab;
var $aed708603be332de$export$d927fcb6adf8f9de;
var $aed708603be332de$export$b82d16f27459e05a;
var $aed708603be332de$export$522c17b4f5e123e8;
var $aed708603be332de$export$1aabd8a0274ecfd6;
var $aed708603be332de$export$3d6c20d97e46b957;
var $aed708603be332de$export$9b621391a187a31a;
var $aed708603be332de$export$f5bbd400c2f4426f;
'use strict';
var $aed708603be332de$var$b = Symbol.for("react.element"), $aed708603be332de$var$c = Symbol.for("react.portal"), $aed708603be332de$var$d = Symbol.for("react.fragment"), $aed708603be332de$var$e = Symbol.for("react.strict_mode"), $aed708603be332de$var$f = Symbol.for("react.profiler"), $aed708603be332de$var$g = Symbol.for("react.provider"), $aed708603be332de$var$h = Symbol.for("react.context"), $aed708603be332de$var$k = Symbol.for("react.server_context"), $aed708603be332de$var$l = Symbol.for("react.forward_ref"), $aed708603be332de$var$m = Symbol.for("react.suspense"), $aed708603be332de$var$n = Symbol.for("react.suspense_list"), $aed708603be332de$var$p = Symbol.for("react.memo"), $aed708603be332de$var$q = Symbol.for("react.lazy"), $aed708603be332de$var$t = Symbol.for("react.offscreen"), $aed708603be332de$var$u;
$aed708603be332de$var$u = Symbol.for("react.module.reference");
function $aed708603be332de$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $aed708603be332de$var$b:
                switch(a = a.type, a){
                    case $aed708603be332de$var$d:
                    case $aed708603be332de$var$f:
                    case $aed708603be332de$var$e:
                    case $aed708603be332de$var$m:
                    case $aed708603be332de$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $aed708603be332de$var$k:
                            case $aed708603be332de$var$h:
                            case $aed708603be332de$var$l:
                            case $aed708603be332de$var$q:
                            case $aed708603be332de$var$p:
                            case $aed708603be332de$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $aed708603be332de$var$c:
                return r;
        }
    }
}
$aed708603be332de$export$a7c73072b1a182ae = $aed708603be332de$var$h;
$aed708603be332de$export$9f27bc3417b4524d = $aed708603be332de$var$g;
$aed708603be332de$export$db77ccec0bb4ccac = $aed708603be332de$var$b;
$aed708603be332de$export$8392c0c9d3dcbd35 = $aed708603be332de$var$l;
$aed708603be332de$export$ffb0004e005737fa = $aed708603be332de$var$d;
$aed708603be332de$export$b624eff549462981 = $aed708603be332de$var$q;
$aed708603be332de$export$7897aa7841a5380c = $aed708603be332de$var$p;
$aed708603be332de$export$602eac185826482c = $aed708603be332de$var$c;
$aed708603be332de$export$e2c29f18771995cb = $aed708603be332de$var$f;
$aed708603be332de$export$5f8d39834fd61797 = $aed708603be332de$var$e;
$aed708603be332de$export$74bf444e3cd11ea5 = $aed708603be332de$var$m;
$aed708603be332de$export$998bcd577473dd93 = $aed708603be332de$var$n;
$aed708603be332de$export$92387174baf9b227 = function() {
    return !1;
};
$aed708603be332de$export$ec112efeb987d9c6 = function() {
    return !1;
};
$aed708603be332de$export$b706b080d889d2c9 = function(a) {
    return $aed708603be332de$var$v(a) === $aed708603be332de$var$h;
};
$aed708603be332de$export$5be5a87408f70ddc = function(a) {
    return $aed708603be332de$var$v(a) === $aed708603be332de$var$g;
};
$aed708603be332de$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $aed708603be332de$var$b;
};
$aed708603be332de$export$455c2e768291efa6 = function(a) {
    return $aed708603be332de$var$v(a) === $aed708603be332de$var$l;
};
$aed708603be332de$export$9522e17588c12572 = function(a) {
    return $aed708603be332de$var$v(a) === $aed708603be332de$var$d;
};
$aed708603be332de$export$2110ac352bb060b9 = function(a) {
    return $aed708603be332de$var$v(a) === $aed708603be332de$var$q;
};
$aed708603be332de$export$56885ab8b9c456ab = function(a) {
    return $aed708603be332de$var$v(a) === $aed708603be332de$var$p;
};
$aed708603be332de$export$d927fcb6adf8f9de = function(a) {
    return $aed708603be332de$var$v(a) === $aed708603be332de$var$c;
};
$aed708603be332de$export$b82d16f27459e05a = function(a) {
    return $aed708603be332de$var$v(a) === $aed708603be332de$var$f;
};
$aed708603be332de$export$522c17b4f5e123e8 = function(a) {
    return $aed708603be332de$var$v(a) === $aed708603be332de$var$e;
};
$aed708603be332de$export$1aabd8a0274ecfd6 = function(a) {
    return $aed708603be332de$var$v(a) === $aed708603be332de$var$m;
};
$aed708603be332de$export$3d6c20d97e46b957 = function(a) {
    return $aed708603be332de$var$v(a) === $aed708603be332de$var$n;
};
$aed708603be332de$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $aed708603be332de$var$d || a === $aed708603be332de$var$f || a === $aed708603be332de$var$e || a === $aed708603be332de$var$m || a === $aed708603be332de$var$n || a === $aed708603be332de$var$t || "object" === typeof a && null !== a && (a.$$typeof === $aed708603be332de$var$q || a.$$typeof === $aed708603be332de$var$p || a.$$typeof === $aed708603be332de$var$g || a.$$typeof === $aed708603be332de$var$h || a.$$typeof === $aed708603be332de$var$l || a.$$typeof === $aed708603be332de$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$aed708603be332de$export$f5bbd400c2f4426f = $aed708603be332de$var$v;

});

parcelRegister("3cXNn", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $2560e03354628640$export$2b8d127b894957b9, (v) => $2560e03354628640$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $2560e03354628640$export$cea3a54a6425200c, (v) => $2560e03354628640$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $2560e03354628640$export$a7c73072b1a182ae, (v) => $2560e03354628640$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $2560e03354628640$export$9f27bc3417b4524d, (v) => $2560e03354628640$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $2560e03354628640$export$db77ccec0bb4ccac, (v) => $2560e03354628640$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $2560e03354628640$export$8392c0c9d3dcbd35, (v) => $2560e03354628640$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $2560e03354628640$export$ffb0004e005737fa, (v) => $2560e03354628640$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $2560e03354628640$export$b624eff549462981, (v) => $2560e03354628640$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $2560e03354628640$export$7897aa7841a5380c, (v) => $2560e03354628640$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $2560e03354628640$export$602eac185826482c, (v) => $2560e03354628640$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $2560e03354628640$export$e2c29f18771995cb, (v) => $2560e03354628640$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $2560e03354628640$export$5f8d39834fd61797, (v) => $2560e03354628640$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2560e03354628640$export$74bf444e3cd11ea5, (v) => $2560e03354628640$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $2560e03354628640$export$92387174baf9b227, (v) => $2560e03354628640$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $2560e03354628640$export$ec112efeb987d9c6, (v) => $2560e03354628640$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $2560e03354628640$export$b706b080d889d2c9, (v) => $2560e03354628640$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $2560e03354628640$export$5be5a87408f70ddc, (v) => $2560e03354628640$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $2560e03354628640$export$45a5e7f76e0caa8d, (v) => $2560e03354628640$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $2560e03354628640$export$455c2e768291efa6, (v) => $2560e03354628640$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $2560e03354628640$export$9522e17588c12572, (v) => $2560e03354628640$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $2560e03354628640$export$2110ac352bb060b9, (v) => $2560e03354628640$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $2560e03354628640$export$56885ab8b9c456ab, (v) => $2560e03354628640$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $2560e03354628640$export$d927fcb6adf8f9de, (v) => $2560e03354628640$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $2560e03354628640$export$b82d16f27459e05a, (v) => $2560e03354628640$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $2560e03354628640$export$522c17b4f5e123e8, (v) => $2560e03354628640$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $2560e03354628640$export$1aabd8a0274ecfd6, (v) => $2560e03354628640$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $2560e03354628640$export$9b621391a187a31a, (v) => $2560e03354628640$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $2560e03354628640$export$f5bbd400c2f4426f, (v) => $2560e03354628640$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2560e03354628640$export$2b8d127b894957b9;
var $2560e03354628640$export$cea3a54a6425200c;
var $2560e03354628640$export$a7c73072b1a182ae;
var $2560e03354628640$export$9f27bc3417b4524d;
var $2560e03354628640$export$db77ccec0bb4ccac;
var $2560e03354628640$export$8392c0c9d3dcbd35;
var $2560e03354628640$export$ffb0004e005737fa;
var $2560e03354628640$export$b624eff549462981;
var $2560e03354628640$export$7897aa7841a5380c;
var $2560e03354628640$export$602eac185826482c;
var $2560e03354628640$export$e2c29f18771995cb;
var $2560e03354628640$export$5f8d39834fd61797;
var $2560e03354628640$export$74bf444e3cd11ea5;
var $2560e03354628640$export$92387174baf9b227;
var $2560e03354628640$export$ec112efeb987d9c6;
var $2560e03354628640$export$b706b080d889d2c9;
var $2560e03354628640$export$5be5a87408f70ddc;
var $2560e03354628640$export$45a5e7f76e0caa8d;
var $2560e03354628640$export$455c2e768291efa6;
var $2560e03354628640$export$9522e17588c12572;
var $2560e03354628640$export$2110ac352bb060b9;
var $2560e03354628640$export$56885ab8b9c456ab;
var $2560e03354628640$export$d927fcb6adf8f9de;
var $2560e03354628640$export$b82d16f27459e05a;
var $2560e03354628640$export$522c17b4f5e123e8;
var $2560e03354628640$export$1aabd8a0274ecfd6;
var $2560e03354628640$export$9b621391a187a31a;
var $2560e03354628640$export$f5bbd400c2f4426f;
'use strict';
var $2560e03354628640$var$b = "function" === typeof Symbol && Symbol.for, $2560e03354628640$var$c = $2560e03354628640$var$b ? Symbol.for("react.element") : 60103, $2560e03354628640$var$d = $2560e03354628640$var$b ? Symbol.for("react.portal") : 60106, $2560e03354628640$var$e = $2560e03354628640$var$b ? Symbol.for("react.fragment") : 60107, $2560e03354628640$var$f = $2560e03354628640$var$b ? Symbol.for("react.strict_mode") : 60108, $2560e03354628640$var$g = $2560e03354628640$var$b ? Symbol.for("react.profiler") : 60114, $2560e03354628640$var$h = $2560e03354628640$var$b ? Symbol.for("react.provider") : 60109, $2560e03354628640$var$k = $2560e03354628640$var$b ? Symbol.for("react.context") : 60110, $2560e03354628640$var$l = $2560e03354628640$var$b ? Symbol.for("react.async_mode") : 60111, $2560e03354628640$var$m = $2560e03354628640$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2560e03354628640$var$n = $2560e03354628640$var$b ? Symbol.for("react.forward_ref") : 60112, $2560e03354628640$var$p = $2560e03354628640$var$b ? Symbol.for("react.suspense") : 60113, $2560e03354628640$var$q = $2560e03354628640$var$b ? Symbol.for("react.suspense_list") : 60120, $2560e03354628640$var$r = $2560e03354628640$var$b ? Symbol.for("react.memo") : 60115, $2560e03354628640$var$t = $2560e03354628640$var$b ? Symbol.for("react.lazy") : 60116, $2560e03354628640$var$v = $2560e03354628640$var$b ? Symbol.for("react.block") : 60121, $2560e03354628640$var$w = $2560e03354628640$var$b ? Symbol.for("react.fundamental") : 60117, $2560e03354628640$var$x = $2560e03354628640$var$b ? Symbol.for("react.responder") : 60118, $2560e03354628640$var$y = $2560e03354628640$var$b ? Symbol.for("react.scope") : 60119;
function $2560e03354628640$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2560e03354628640$var$c:
                switch(a = a.type, a){
                    case $2560e03354628640$var$l:
                    case $2560e03354628640$var$m:
                    case $2560e03354628640$var$e:
                    case $2560e03354628640$var$g:
                    case $2560e03354628640$var$f:
                    case $2560e03354628640$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2560e03354628640$var$k:
                            case $2560e03354628640$var$n:
                            case $2560e03354628640$var$t:
                            case $2560e03354628640$var$r:
                            case $2560e03354628640$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2560e03354628640$var$d:
                return u;
        }
    }
}
function $2560e03354628640$var$A(a) {
    return $2560e03354628640$var$z(a) === $2560e03354628640$var$m;
}
$2560e03354628640$export$2b8d127b894957b9 = $2560e03354628640$var$l;
$2560e03354628640$export$cea3a54a6425200c = $2560e03354628640$var$m;
$2560e03354628640$export$a7c73072b1a182ae = $2560e03354628640$var$k;
$2560e03354628640$export$9f27bc3417b4524d = $2560e03354628640$var$h;
$2560e03354628640$export$db77ccec0bb4ccac = $2560e03354628640$var$c;
$2560e03354628640$export$8392c0c9d3dcbd35 = $2560e03354628640$var$n;
$2560e03354628640$export$ffb0004e005737fa = $2560e03354628640$var$e;
$2560e03354628640$export$b624eff549462981 = $2560e03354628640$var$t;
$2560e03354628640$export$7897aa7841a5380c = $2560e03354628640$var$r;
$2560e03354628640$export$602eac185826482c = $2560e03354628640$var$d;
$2560e03354628640$export$e2c29f18771995cb = $2560e03354628640$var$g;
$2560e03354628640$export$5f8d39834fd61797 = $2560e03354628640$var$f;
$2560e03354628640$export$74bf444e3cd11ea5 = $2560e03354628640$var$p;
$2560e03354628640$export$92387174baf9b227 = function(a) {
    return $2560e03354628640$var$A(a) || $2560e03354628640$var$z(a) === $2560e03354628640$var$l;
};
$2560e03354628640$export$ec112efeb987d9c6 = $2560e03354628640$var$A;
$2560e03354628640$export$b706b080d889d2c9 = function(a) {
    return $2560e03354628640$var$z(a) === $2560e03354628640$var$k;
};
$2560e03354628640$export$5be5a87408f70ddc = function(a) {
    return $2560e03354628640$var$z(a) === $2560e03354628640$var$h;
};
$2560e03354628640$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2560e03354628640$var$c;
};
$2560e03354628640$export$455c2e768291efa6 = function(a) {
    return $2560e03354628640$var$z(a) === $2560e03354628640$var$n;
};
$2560e03354628640$export$9522e17588c12572 = function(a) {
    return $2560e03354628640$var$z(a) === $2560e03354628640$var$e;
};
$2560e03354628640$export$2110ac352bb060b9 = function(a) {
    return $2560e03354628640$var$z(a) === $2560e03354628640$var$t;
};
$2560e03354628640$export$56885ab8b9c456ab = function(a) {
    return $2560e03354628640$var$z(a) === $2560e03354628640$var$r;
};
$2560e03354628640$export$d927fcb6adf8f9de = function(a) {
    return $2560e03354628640$var$z(a) === $2560e03354628640$var$d;
};
$2560e03354628640$export$b82d16f27459e05a = function(a) {
    return $2560e03354628640$var$z(a) === $2560e03354628640$var$g;
};
$2560e03354628640$export$522c17b4f5e123e8 = function(a) {
    return $2560e03354628640$var$z(a) === $2560e03354628640$var$f;
};
$2560e03354628640$export$1aabd8a0274ecfd6 = function(a) {
    return $2560e03354628640$var$z(a) === $2560e03354628640$var$p;
};
$2560e03354628640$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2560e03354628640$var$e || a === $2560e03354628640$var$m || a === $2560e03354628640$var$g || a === $2560e03354628640$var$f || a === $2560e03354628640$var$p || a === $2560e03354628640$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2560e03354628640$var$t || a.$$typeof === $2560e03354628640$var$r || a.$$typeof === $2560e03354628640$var$h || a.$$typeof === $2560e03354628640$var$k || a.$$typeof === $2560e03354628640$var$n || a.$$typeof === $2560e03354628640$var$w || a.$$typeof === $2560e03354628640$var$x || a.$$typeof === $2560e03354628640$var$y || a.$$typeof === $2560e03354628640$var$v);
};
$2560e03354628640$export$f5bbd400c2f4426f = $2560e03354628640$var$z;

});

parcelRegister("Ohofd", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("8oPqs", function(module, exports) {
"use strict";

var $7H3wX = parcelRequire("7H3wX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61d874affadf83e0$var$_en_GB = $7H3wX((parcelRequire("19bxD")));

var $61d874affadf83e0$var$_en_GB2 = $7H3wX((parcelRequire("7uhSr")));

var $61d874affadf83e0$var$_en_GB3 = $7H3wX((parcelRequire("65kZ0")));

var $61d874affadf83e0$var$_en_GB4 = $7H3wX((parcelRequire("8pWqr")));
const $61d874affadf83e0$var$typeTemplate = '${label} is not a valid ${type}';
const $61d874affadf83e0$var$localeValues = {
    locale: 'en-gb',
    Pagination: $61d874affadf83e0$var$_en_GB.default,
    DatePicker: $61d874affadf83e0$var$_en_GB3.default,
    TimePicker: $61d874affadf83e0$var$_en_GB4.default,
    Calendar: $61d874affadf83e0$var$_en_GB2.default,
    global: {
        placeholder: 'Please select',
        close: 'Close'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckAll: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Tour: {
        Next: 'Next',
        Previous: 'Previous',
        Finish: 'Finish'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No Data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            default: 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            enum: '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $61d874affadf83e0$var$typeTemplate,
                method: $61d874affadf83e0$var$typeTemplate,
                array: $61d874affadf83e0$var$typeTemplate,
                object: $61d874affadf83e0$var$typeTemplate,
                number: $61d874affadf83e0$var$typeTemplate,
                date: $61d874affadf83e0$var$typeTemplate,
                boolean: $61d874affadf83e0$var$typeTemplate,
                integer: $61d874affadf83e0$var$typeTemplate,
                float: $61d874affadf83e0$var$typeTemplate,
                regexp: $61d874affadf83e0$var$typeTemplate,
                email: $61d874affadf83e0$var$typeTemplate,
                url: $61d874affadf83e0$var$typeTemplate,
                hex: $61d874affadf83e0$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    }
};
var $61d874affadf83e0$var$_default = module.exports.default = $61d874affadf83e0$var$localeValues;

});
parcelRegister("7H3wX", function(module, exports) {
function $599f49a5d23801c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $599f49a5d23801c5$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("19bxD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $0d5f959f267b2dc8$var$locale = {
    // Options
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};
var $0d5f959f267b2dc8$var$_default = module.exports.default = $0d5f959f267b2dc8$var$locale;

});

parcelRegister("7uhSr", function(module, exports) {
"use strict";

var $7H3wX = parcelRequire("7H3wX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $573933c6b1aa1d61$var$_en_GB = $7H3wX((parcelRequire("65kZ0")));
var $573933c6b1aa1d61$var$_default = module.exports.default = $573933c6b1aa1d61$var$_en_GB.default;

});
parcelRegister("65kZ0", function(module, exports) {
"use strict";

var $7H3wX = parcelRequire("7H3wX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46e37c7ee4f9e0d2$var$_en_GB = $7H3wX((parcelRequire("lS3vS")));

var $46e37c7ee4f9e0d2$var$_en_GB2 = $7H3wX((parcelRequire("8pWqr")));
// Merge into a locale object
const $46e37c7ee4f9e0d2$var$locale = {
    lang: {
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ],
        ...$46e37c7ee4f9e0d2$var$_en_GB.default
    },
    timePickerLocale: {
        ...$46e37c7ee4f9e0d2$var$_en_GB2.default
    }
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
var $46e37c7ee4f9e0d2$var$_default = module.exports.default = $46e37c7ee4f9e0d2$var$locale;

});
parcelRegister("lS3vS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $luXNJ = parcelRequire("luXNJ");
function $fec15dc3421c03c4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fec15dc3421c03c4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fec15dc3421c03c4$var$_typeof(o);
}
function $fec15dc3421c03c4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fec15dc3421c03c4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fec15dc3421c03c4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fec15dc3421c03c4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fec15dc3421c03c4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fec15dc3421c03c4$var$_defineProperty(obj, key, value) {
    key = $fec15dc3421c03c4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fec15dc3421c03c4$var$_toPropertyKey(t) {
    var i = $fec15dc3421c03c4$var$_toPrimitive(t, "string");
    return "symbol" == $fec15dc3421c03c4$var$_typeof(i) ? i : String(i);
}
function $fec15dc3421c03c4$var$_toPrimitive(t, r) {
    if ("object" != $fec15dc3421c03c4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fec15dc3421c03c4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fec15dc3421c03c4$var$locale = $fec15dc3421c03c4$var$_objectSpread($fec15dc3421c03c4$var$_objectSpread({}, $luXNJ.commonLocale), {}, {
    locale: 'en_GB',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    timeSelect: 'Select time',
    dateSelect: 'Select date',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
});
var $fec15dc3421c03c4$var$_default = module.exports.default = $fec15dc3421c03c4$var$locale;

});
parcelRegister("luXNJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.commonLocale = void 0;
var $fa6ac9947ebd4e7a$var$commonLocale = module.exports.commonLocale = {
    yearFormat: 'YYYY',
    dayFormat: 'D',
    cellMeridiemFormat: 'A',
    monthBeforeYear: true
};

});


parcelRegister("8pWqr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $620dfa9f8a4c5723$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $620dfa9f8a4c5723$var$_default = module.exports.default = $620dfa9f8a4c5723$var$locale;

});




parcelRegister("aNuJT", function(module, exports) {
"use strict";

var $7H3wX = parcelRequire("7H3wX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7dc6532a0b527914$var$_ru_RU = $7H3wX((parcelRequire("6zwN0")));

var $7dc6532a0b527914$var$_ru_RU2 = $7H3wX((parcelRequire("jRUYb")));

var $7dc6532a0b527914$var$_ru_RU3 = $7H3wX((parcelRequire("60um6")));

var $7dc6532a0b527914$var$_ru_RU4 = $7H3wX((parcelRequire("5oxLD")));
const $7dc6532a0b527914$var$typeTemplate = "${label} \u043D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0442\u0438\u043F\u043E\u043C ${type}";
const $7dc6532a0b527914$var$localeValues = {
    locale: 'ru',
    Pagination: $7dc6532a0b527914$var$_ru_RU.default,
    DatePicker: $7dc6532a0b527914$var$_ru_RU3.default,
    TimePicker: $7dc6532a0b527914$var$_ru_RU4.default,
    Calendar: $7dc6532a0b527914$var$_ru_RU2.default,
    global: {
        placeholder: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430 \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435",
        close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
    },
    Table: {
        filterTitle: "\u0424\u0438\u043B\u044C\u0442\u0440",
        filterConfirm: 'OK',
        filterReset: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C",
        filterEmptyText: "\u0411\u0435\u0437 \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432",
        filterCheckAll: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B",
        filterSearchPlaceholder: "\u041F\u043E\u0438\u0441\u043A \u0432 \u0444\u0438\u043B\u044C\u0442\u0440\u0430\u0445",
        emptyText: "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445",
        selectAll: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0451",
        selectInvert: "\u0418\u043D\u0432\u0435\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u044B\u0431\u043E\u0440",
        selectNone: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0432\u0441\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
        selectionAll: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
        sortTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430",
        expand: "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443",
        collapse: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443",
        triggerDesc: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
        triggerAsc: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
        cancelSort: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0443"
    },
    Tour: {
        Next: "\u0414\u0430\u043B\u0435\u0435",
        Previous: "\u041D\u0430\u0437\u0430\u0434",
        Finish: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C"
    },
    Modal: {
        okText: 'OK',
        cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430",
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430"
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: "\u041F\u043E\u0438\u0441\u043A",
        itemUnit: "\u044D\u043B\u0435\u043C.",
        itemsUnit: "\u044D\u043B\u0435\u043C.",
        remove: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
        selectAll: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
        deselectAll: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0432\u0441\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
        selectCurrent: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u0435\u043A\u0443\u0449\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
        selectInvert: "\u0418\u043D\u0432\u0435\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u044B\u0431\u043E\u0440",
        removeAll: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0441\u0435 \u0434\u0430\u043D\u043D\u044B\u0435",
        removeCurrent: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0442\u0435\u043A\u0443\u0449\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"
    },
    Upload: {
        uploading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
        removeFile: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0444\u0430\u0439\u043B",
        uploadError: "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
        previewFile: "\u041F\u0440\u0435\u0434\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0444\u0430\u0439\u043B\u0430",
        downloadFile: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0444\u0430\u0439\u043B"
    },
    Empty: {
        description: "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445"
    },
    Icon: {
        icon: "\u0438\u043A\u043E\u043D\u043A\u0430"
    },
    Text: {
        edit: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        copy: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        copied: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E",
        expand: "\u0420\u0430\u0441\u043A\u0440\u044B\u0442\u044C",
        collapse: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C"
    },
    Form: {
        optional: "(\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
        defaultValidateMessages: {
            default: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043F\u043E\u043B\u044F ${label}",
            required: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 ${label}",
            enum: "${label} \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u043E\u0434\u043D\u0438\u043C \u0438\u0437 [${enum}]",
            whitespace: "${label} \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0443\u0441\u0442\u044B\u043C",
            date: {
                format: "${label} \u043D\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u044B",
                parse: "${label} \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u043E \u0432 \u0434\u0430\u0442\u0443",
                invalid: "${label} \u043D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u043E\u0439 \u0434\u0430\u0442\u043E\u0439"
            },
            types: {
                string: $7dc6532a0b527914$var$typeTemplate,
                method: $7dc6532a0b527914$var$typeTemplate,
                array: $7dc6532a0b527914$var$typeTemplate,
                object: $7dc6532a0b527914$var$typeTemplate,
                number: $7dc6532a0b527914$var$typeTemplate,
                date: $7dc6532a0b527914$var$typeTemplate,
                boolean: $7dc6532a0b527914$var$typeTemplate,
                integer: $7dc6532a0b527914$var$typeTemplate,
                float: $7dc6532a0b527914$var$typeTemplate,
                regexp: $7dc6532a0b527914$var$typeTemplate,
                email: $7dc6532a0b527914$var$typeTemplate,
                url: $7dc6532a0b527914$var$typeTemplate,
                hex: $7dc6532a0b527914$var$typeTemplate
            },
            string: {
                len: "${label} \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C ${len} \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432",
                min: "${label} \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u0430 ${min} \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432",
                max: "${label} \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u0430 ${max} \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432",
                range: "\u0414\u043B\u0438\u043D\u0430 ${label} \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043C\u0435\u0436\u0434\u0443 ${min}-${max} \u0441\u0438\u043C\u0432\u043E\u043B\u0430\u043C\u0438"
            },
            number: {
                len: "${label} \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0440\u0430\u0432\u043D\u0430 ${len}",
                min: "${label} \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u0430 ${min}",
                max: "${label} \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u0430 ${max}",
                range: "${label} \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043C\u0435\u0436\u0434\u0443 ${min}-${max}"
            },
            array: {
                len: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 ${label} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0440\u0430\u0432\u043D\u043E ${len}",
                min: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 ${label} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E ${min}",
                max: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 ${label} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E ${max}",
                range: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 ${label} \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043C\u0435\u0436\u0434\u0443 ${min} \u0438 ${max}"
            },
            pattern: {
                mismatch: "${label} \u043D\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0448\u0430\u0431\u043B\u043E\u043D\u0443 ${pattern}"
            }
        }
    },
    QRCode: {
        expired: "QR-\u043A\u043E\u0434 \u0443\u0441\u0442\u0430\u0440\u0435\u043B",
        refresh: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C"
    },
    ColorPicker: {
        presetEmpty: "\u041F\u0443\u0441\u0442\u043E\u0439",
        transparent: "\u041F\u0440\u043E\u0437\u0440\u0430\u0447\u043D\u044B\u0439",
        singleColor: "\u041E\u0434\u0438\u043D \u0446\u0432\u0435\u0442",
        gradientColor: "\u0413\u0440\u0430\u0434\u0438\u0435\u043D\u0442"
    }
};
var $7dc6532a0b527914$var$_default = module.exports.default = $7dc6532a0b527914$var$localeValues;

});
parcelRegister("6zwN0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $4c8f723c37a57f5b$var$locale = {
    // Options
    items_per_page: "/ \u0441\u0442\u0440.",
    jump_to: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438",
    jump_to_confirm: "\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
    page: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
    // Pagination
    prev_page: "\u041D\u0430\u0437\u0430\u0434",
    next_page: "\u0412\u043F\u0435\u0440\u0435\u0434",
    prev_5: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435 5",
    next_5: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 5",
    prev_3: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435 3",
    next_3: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 3",
    page_size: "\u0440\u0430\u0437\u043C\u0435\u0440 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B"
};
var $4c8f723c37a57f5b$var$_default = module.exports.default = $4c8f723c37a57f5b$var$locale;

});

parcelRegister("jRUYb", function(module, exports) {
"use strict";

var $7H3wX = parcelRequire("7H3wX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e76f2888acb95dca$var$_ru_RU = $7H3wX((parcelRequire("60um6")));
var $e76f2888acb95dca$var$_default = module.exports.default = $e76f2888acb95dca$var$_ru_RU.default;

});
parcelRegister("60um6", function(module, exports) {
"use strict";

var $7H3wX = parcelRequire("7H3wX");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45fa4a1d79304623$var$_ru_RU = $7H3wX((parcelRequire("bcyXu")));

var $45fa4a1d79304623$var$_ru_RU2 = $7H3wX((parcelRequire("5oxLD")));
/** Created by Andrey Gayvoronsky on 13/04/16. */ // Merge into a locale object
const $45fa4a1d79304623$var$locale = {
    lang: {
        placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443",
        yearPlaceholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0434",
        quarterPlaceholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        monthPlaceholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u0435\u0441\u044F\u0446",
        weekPlaceholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0435\u0434\u0435\u043B\u044E",
        rangePlaceholder: [
            "\u041D\u0430\u0447\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u0430\u0442\u0430",
            "\u041A\u043E\u043D\u0435\u0447\u043D\u0430\u044F \u0434\u0430\u0442\u0430"
        ],
        rangeYearPlaceholder: [
            "\u041D\u0430\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u0433\u043E\u0434",
            "\u0413\u043E\u0434 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F"
        ],
        rangeMonthPlaceholder: [
            "\u041D\u0430\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u043C\u0435\u0441\u044F\u0446",
            "\u041A\u043E\u043D\u0435\u0447\u043D\u044B\u0439 \u043C\u0435\u0441\u044F\u0446"
        ],
        rangeWeekPlaceholder: [
            "\u041D\u0430\u0447\u0430\u043B\u044C\u043D\u0430\u044F \u043D\u0435\u0434\u0435\u043B\u044F",
            "\u041A\u043E\u043D\u0435\u0447\u043D\u0430\u044F \u043D\u0435\u0434\u0435\u043B\u044F"
        ],
        shortWeekDays: [
            "\u0412\u0441",
            "\u041F\u043D",
            "\u0412\u0442",
            "\u0421\u0440",
            "\u0427\u0442",
            "\u041F\u0442",
            "\u0421\u0431"
        ],
        shortMonths: [
            "\u042F\u043D\u0432",
            "\u0424\u0435\u0432",
            "\u041C\u0430\u0440",
            "\u0410\u043F\u0440",
            "\u041C\u0430\u0439",
            "\u0418\u044E\u043D",
            "\u0418\u044E\u043B",
            "\u0410\u0432\u0433",
            "\u0421\u0435\u043D",
            "\u041E\u043A\u0442",
            "\u041D\u043E\u044F",
            "\u0414\u0435\u043A"
        ],
        ...$45fa4a1d79304623$var$_ru_RU.default
    },
    timePickerLocale: {
        ...$45fa4a1d79304623$var$_ru_RU2.default
    }
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
var $45fa4a1d79304623$var$_default = module.exports.default = $45fa4a1d79304623$var$locale;

});
parcelRegister("bcyXu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $luXNJ = parcelRequire("luXNJ");
function $827beebb28a52ff8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $827beebb28a52ff8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $827beebb28a52ff8$var$_typeof(o);
}
function $827beebb28a52ff8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $827beebb28a52ff8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $827beebb28a52ff8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $827beebb28a52ff8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $827beebb28a52ff8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $827beebb28a52ff8$var$_defineProperty(obj, key, value) {
    key = $827beebb28a52ff8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $827beebb28a52ff8$var$_toPropertyKey(t) {
    var i = $827beebb28a52ff8$var$_toPrimitive(t, "string");
    return "symbol" == $827beebb28a52ff8$var$_typeof(i) ? i : String(i);
}
function $827beebb28a52ff8$var$_toPrimitive(t, r) {
    if ("object" != $827beebb28a52ff8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $827beebb28a52ff8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $827beebb28a52ff8$var$locale = $827beebb28a52ff8$var$_objectSpread($827beebb28a52ff8$var$_objectSpread({}, $luXNJ.commonLocale), {}, {
    locale: 'ru_RU',
    today: "\u0421\u0435\u0433\u043E\u0434\u043D\u044F",
    now: "\u0421\u0435\u0439\u0447\u0430\u0441",
    backToToday: "\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0434\u0430\u0442\u0430",
    ok: "\u041E\u041A",
    clear: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
    week: "\u041D\u0435\u0434\u0435\u043B\u044F",
    month: "\u041C\u0435\u0441\u044F\u0446",
    year: "\u0413\u043E\u0434",
    timeSelect: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0440\u0435\u043C\u044F",
    dateSelect: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0430\u0442\u0443",
    monthSelect: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043C\u0435\u0441\u044F\u0446",
    yearSelect: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0433\u043E\u0434",
    decadeSelect: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0435\u0441\u044F\u0442\u0438\u043B\u0435\u0442\u0438\u0435",
    previousMonth: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u043C\u0435\u0441\u044F\u0446 (PageUp)",
    nextMonth: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043C\u0435\u0441\u044F\u0446 (PageDown)",
    previousYear: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0433\u043E\u0434 (Control + left)",
    nextYear: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0433\u043E\u0434 (Control + right)",
    previousDecade: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0435\u0435 \u0434\u0435\u0441\u044F\u0442\u0438\u043B\u0435\u0442\u0438\u0435",
    nextDecade: "\u0421\u043B\u0435\u0434\u0443\u0449\u0435\u0435 \u0434\u0435\u0441\u044F\u0442\u0438\u043B\u0435\u0442\u0438\u0435",
    previousCentury: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0432\u0435\u043A",
    nextCentury: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0432\u0435\u043A"
});
var $827beebb28a52ff8$var$_default = module.exports.default = $827beebb28a52ff8$var$locale;

});

parcelRegister("5oxLD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $3ed96324a69ff267$var$locale = {
    placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F",
    rangePlaceholder: [
        "\u0412\u0440\u0435\u043C\u044F \u043D\u0430\u0447\u0430\u043B\u0430",
        "\u0412\u0440\u0435\u043C\u044F \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F"
    ]
};
var $3ed96324a69ff267$var$_default = module.exports.default = $3ed96324a69ff267$var$locale;

});




parcelRegister("aslHJ", function(module, exports) {
"use strict";
var $79cd5af0e960da0d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $79cd5af0e960da0d$var$PostgrestQueryBuilder_1 = $79cd5af0e960da0d$var$__importDefault((parcelRequire("bjLOO")));

const $79cd5af0e960da0d$var$PostgrestFilterBuilder_1 = $79cd5af0e960da0d$var$__importDefault((parcelRequire("iQEar")));

var $h3esd = parcelRequire("h3esd");
/**
 * PostgREST client.
 *
 * @typeParam Database - Types for the schema from the [type
 * generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
 *
 * @typeParam SchemaName - Postgres schema to switch to. Must be a string
 * literal, the same one passed to the constructor. If the schema is not
 * `"public"`, this must be supplied manually.
 */ class $79cd5af0e960da0d$var$PostgrestClient {
    // TODO: Add back shouldThrowOnError once we figure out the typings
    /**
     * Creates a PostgREST client.
     *
     * @param url - URL of the PostgREST endpoint
     * @param options - Named parameters
     * @param options.headers - Custom headers
     * @param options.schema - Postgres schema to switch to
     * @param options.fetch - Custom fetch
     */ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch } = {}){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, $h3esd.DEFAULT_HEADERS), headers);
        this.schemaName = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        const url = new URL(`${this.url}/${relation}`);
        return new $79cd5af0e960da0d$var$PostgrestQueryBuilder_1.default(url, {
            headers: Object.assign({}, this.headers),
            schema: this.schemaName,
            fetch: this.fetch
        });
    }
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return new $79cd5af0e960da0d$var$PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch
        });
    }
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        if (head || get) {
            method = head ? 'HEAD' : 'GET';
            Object.entries(args)// params with undefined value needs to be filtered out, otherwise it'll
            // show up as `?param=undefined`
            .filter(([_, value])=>value !== undefined)// array values need special syntax
            .map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(',')}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = 'POST';
            body = args;
        }
        const headers = Object.assign({}, this.headers);
        if (count) headers['Prefer'] = `count=${count}`;
        return new $79cd5af0e960da0d$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $79cd5af0e960da0d$var$PostgrestClient;

});
parcelRegister("bjLOO", function(module, exports) {
"use strict";
var $83d68fd06e8faac9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $83d68fd06e8faac9$var$PostgrestFilterBuilder_1 = $83d68fd06e8faac9$var$__importDefault((parcelRequire("iQEar")));
class $83d68fd06e8faac9$var$PostgrestQueryBuilder {
    constructor(url, { headers: headers = {}, schema: schema, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.schema = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a SELECT query on the table or view.
     *
     * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
     *
     * @param options - Named parameters
     *
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     *
     * @param options.count - Count algorithm to use to count rows in the table or view.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ select(columns, { head: head = false, count: count } = {}) {
        const method = head ? 'HEAD' : 'GET';
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (count) this.headers['Prefer'] = `count=${count}`;
        return new $83d68fd06e8faac9$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an INSERT into the table or view.
     *
     * By default, inserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to insert. Pass an object to insert a single row
     * or an array to insert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count inserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. Only applies for bulk
     * inserts.
     */ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $83d68fd06e8faac9$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPSERT on the table or view. Depending on the column(s) passed
     * to `onConflict`, `.upsert()` allows you to perform the equivalent of
     * `.insert()` if a row with the corresponding `onConflict` columns doesn't
     * exist, or if it does exist, perform an alternative action depending on
     * `ignoreDuplicates`.
     *
     * By default, upserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to upsert with. Pass an object to upsert a
     * single row or an array to upsert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
     * duplicate rows are determined. Two rows are duplicates if all the
     * `onConflict` columns are equal.
     *
     * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
     * `false`, duplicate rows are merged with existing rows.
     *
     * @param options.count - Count algorithm to use to count upserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. This only applies when
     * inserting new rows, not when merging with existing rows under
     * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
     */ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [
            `resolution=${ignoreDuplicates ? 'ignore' : 'merge'}-duplicates`
        ];
        if (onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $83d68fd06e8faac9$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPDATE on the table or view.
     *
     * By default, updated rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param values - The values to update with
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count updated rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ update(values, { count: count } = {}) {
        const method = 'PATCH';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $83d68fd06e8faac9$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform a DELETE on the table or view.
     *
     * By default, deleted rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count deleted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ delete({ count: count } = {}) {
        const method = 'DELETE';
        const prefersHeaders = [];
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $83d68fd06e8faac9$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $83d68fd06e8faac9$var$PostgrestQueryBuilder;

});
parcelRegister("iQEar", function(module, exports) {
"use strict";
var $db8c3dbc7331bdeb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $db8c3dbc7331bdeb$var$PostgrestTransformBuilder_1 = $db8c3dbc7331bdeb$var$__importDefault((parcelRequire("9IjEd")));
class $db8c3dbc7331bdeb$var$PostgrestFilterBuilder extends $db8c3dbc7331bdeb$var$PostgrestTransformBuilder_1.default {
    /**
     * Match only rows where `column` is equal to `value`.
     *
     * To check if the value of `column` is NULL, you should use `.is()` instead.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is not equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-sensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-insensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` IS `value`.
     *
     * For non-boolean columns, this is only relevant for checking if the value of
     * `column` is NULL by setting `value` to `null`.
     *
     * For boolean columns, you can also set `value` to `true` or `false` and it
     * will behave the same way as `.eq()`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is included in the `values` array.
     *
     * @param column - The column to filter on
     * @param values - The values array to filter with
     */ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            // handle postgrest reserved characters
            // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
            if (typeof s === 'string' && new RegExp('[,()]').test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(',');
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * `column` contains every element appearing in `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ contains(column, value) {
        if (typeof value === 'string') // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cs.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * every element appearing in `column` is contained by `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ containedBy(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cd.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is greater than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or greater than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is less than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or less than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where `column` is
     * mutually exclusive to `range` and there can be no element between the two
     * ranges.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
     * Only relevant for array and range columns. Match only rows where
     * `column` and `value` have an element in common.
     *
     * @param column - The array or range column to filter on
     * @param value - The array or range value to filter with
     */ overlaps(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `ov.${value}`);
        else // array
        this.url.searchParams.append(column, `ov.{${value.join(',')}}`);
        return this;
    }
    /**
     * Only relevant for text and tsvector columns. Match only rows where
     * `column` matches the query string in `query`.
     *
     * @param column - The text or tsvector column to filter on
     * @param query - The query text to match with
     * @param options - Named parameters
     * @param options.config - The text search configuration to use
     * @param options.type - Change how the `query` text is interpreted
     */ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = '';
        if (type === 'plain') typePart = 'pl';
        else if (type === 'phrase') typePart = 'ph';
        else if (type === 'websearch') typePart = 'w';
        const configPart = config === undefined ? '' : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
     * Match only rows where each column in `query` keys is equal to its
     * associated value. Shorthand for multiple `.eq()`s.
     *
     * @param query - The object to filter with, with column names as keys mapped
     * to their filter values
     */ match(query) {
        Object.entries(query).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
     * Match only rows which doesn't satisfy the filter.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to be negated to filter with, following
     * PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
     * Match only rows which satisfy at least one of the filters.
     *
     * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure it's properly sanitized.
     *
     * It's currently not possible to do an `.or()` filter across multiple tables.
     *
     * @param filters - The filters to use, following PostgREST syntax
     * @param options - Named parameters
     * @param options.referencedTable - Set this to filter on referenced tables
     * instead of the parent table
     * @param options.foreignTable - Deprecated, use `referencedTable` instead
     */ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : 'or';
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
     * Match only rows which satisfy the filter. This is an escape hatch - you
     * should use the specific filter methods wherever possible.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to filter with, following PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
}
module.exports.default = $db8c3dbc7331bdeb$var$PostgrestFilterBuilder;

});
parcelRegister("9IjEd", function(module, exports) {
"use strict";
var $712776b9c8922975$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $712776b9c8922975$var$PostgrestBuilder_1 = $712776b9c8922975$var$__importDefault((parcelRequire("frFkG")));
class $712776b9c8922975$var$PostgrestTransformBuilder extends $712776b9c8922975$var$PostgrestBuilder_1.default {
    /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */ select(columns) {
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (this.headers['Prefer']) this.headers['Prefer'] += ',';
        this.headers['Prefer'] += 'return=representation';
        return this;
    }
    /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order referenced tables, but it only affects the ordering of the
     * parent table if you use `!inner` in the query.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.referencedTable - Set this to order a referenced table by
     * its columns
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : 'order';
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ''}${column}.${ascending ? 'asc' : 'desc'}${nullsFirst === undefined ? '' : nullsFirst ? '.nullsfirst' : '.nullslast'}`);
        return this;
    }
    /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
     * Limit the query result by starting at an offset `from` and ending at the offset `to`.
     * Only records within this range are returned.
     * This respects the query order and if there is no order clause the range could behave unexpectedly.
     * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
     * and fourth rows of the query.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === 'undefined' ? 'offset' : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        // Range is inclusive, so add 1
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */ single() {
        this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */ maybeSingle() {
        // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
        // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
        if (this.method === 'GET') this.headers['Accept'] = 'application/json';
        else this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        this.isMaybeSingle = true;
        return this;
    }
    /**
     * Return `data` as a string in CSV format.
     */ csv() {
        this.headers['Accept'] = 'text/csv';
        return this;
    }
    /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */ geojson() {
        this.headers['Accept'] = 'application/geo+json';
        return this;
    }
    /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * You need to enable the
     * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
     * setting before using this method.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = 'text' } = {}) {
        var _a;
        const options = [
            analyze ? 'analyze' : null,
            verbose ? 'verbose' : null,
            settings ? 'settings' : null,
            buffers ? 'buffers' : null,
            wal ? 'wal' : null
        ].filter(Boolean).join('|');
        // An Accept header can carry multiple media types but postgrest-js always sends one
        const forMediatype = (_a = this.headers['Accept']) !== null && _a !== void 0 ? _a : 'application/json';
        this.headers['Accept'] = `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`;
        if (format === 'json') return this;
        else return this;
    }
    /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */ rollback() {
        var _a;
        if (((_a = this.headers['Prefer']) !== null && _a !== void 0 ? _a : '').trim().length > 0) this.headers['Prefer'] += ',tx=rollback';
        else this.headers['Prefer'] = 'tx=rollback';
        return this;
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     */ returns() {
        return this;
    }
}
module.exports.default = $712776b9c8922975$var$PostgrestTransformBuilder;

});
parcelRegister("frFkG", function(module, exports) {
"use strict";
var $b3e97066e39cce3a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// @ts-ignore
const $b3e97066e39cce3a$var$node_fetch_1 = $b3e97066e39cce3a$var$__importDefault((parcelRequire("ixUGO")));

const $b3e97066e39cce3a$var$PostgrestError_1 = $b3e97066e39cce3a$var$__importDefault((parcelRequire("ca6un")));
class $b3e97066e39cce3a$var$PostgrestBuilder {
    constructor(builder){
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = builder.headers;
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = builder.shouldThrowOnError;
        this.signal = builder.signal;
        this.isMaybeSingle = builder.isMaybeSingle;
        if (builder.fetch) this.fetch = builder.fetch;
        else if (typeof fetch === 'undefined') this.fetch = $b3e97066e39cce3a$var$node_fetch_1.default;
        else this.fetch = fetch;
    }
    /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
     * Set an HTTP header for the request.
     */ setHeader(name, value) {
        this.headers = Object.assign({}, this.headers);
        this.headers[name] = value;
        return this;
    }
    then(onfulfilled, onrejected) {
        // https://postgrest.org/en/stable/api.html#switching-schemas
        if (this.schema === undefined) ;
        else if ([
            'GET',
            'HEAD'
        ].includes(this.method)) this.headers['Accept-Profile'] = this.schema;
        else this.headers['Content-Profile'] = this.schema;
        if (this.method !== 'GET' && this.method !== 'HEAD') this.headers['Content-Type'] = 'application/json';
        // NOTE: Invoke w/o `this` to avoid illegal invocation error.
        // https://github.com/supabase/postgrest-js/pull/247
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res)=>{
            var _a, _b, _c;
            let error = null;
            let data = null;
            let count = null;
            let status = res.status;
            let statusText = res.statusText;
            if (res.ok) {
                if (this.method !== 'HEAD') {
                    const body = await res.text();
                    if (body === '') ;
                    else if (this.headers['Accept'] === 'text/csv') data = body;
                    else if (this.headers['Accept'] && this.headers['Accept'].includes('application/vnd.pgrst.plan+text')) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_a = this.headers['Prefer']) === null || _a === void 0 ? void 0 : _a.match(/count=(exact|planned|estimated)/);
                const contentRange = (_b = res.headers.get('content-range')) === null || _b === void 0 ? void 0 : _b.split('/');
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                if (this.isMaybeSingle && this.method === 'GET' && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
                            code: 'PGRST116',
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: 'JSON object requested, multiple (or no) rows returned'
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = 'Not Acceptable';
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                const body = await res.text();
                try {
                    error = JSON.parse(body);
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (Array.isArray(error) && res.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = 'OK';
                    }
                } catch (_d) {
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (res.status === 404 && body === '') {
                        status = 204;
                        statusText = 'No Content';
                    } else error = {
                        message: body
                    };
                }
                if (error && this.isMaybeSingle && ((_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.includes('0 rows'))) {
                    error = null;
                    status = 200;
                    statusText = 'OK';
                }
                if (error && this.shouldThrowOnError) throw new $b3e97066e39cce3a$var$PostgrestError_1.default(error);
            }
            const postgrestResponse = {
                error: error,
                data: data,
                count: count,
                status: status,
                statusText: statusText
            };
            return postgrestResponse;
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _a, _b, _c;
            return {
                error: {
                    message: `${(_a = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _a !== void 0 ? _a : 'FetchError'}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: `${(_b = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _b !== void 0 ? _b : ''}`,
                    hint: '',
                    code: `${(_c = fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) !== null && _c !== void 0 ? _c : ''}`
                },
                data: null,
                count: null,
                status: 0,
                statusText: ''
            };
        });
        return res.then(onfulfilled, onrejected);
    }
}
module.exports.default = $b3e97066e39cce3a$var$PostgrestBuilder;

});
parcelRegister("ixUGO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fetch", () => $d807486b5dc73e7e$export$e7aa7bc5c1b3cfb3);
$parcel$export(module.exports, "default", () => $d807486b5dc73e7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Headers", () => $d807486b5dc73e7e$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $d807486b5dc73e7e$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $d807486b5dc73e7e$export$9f633d56d7ec90d3);
"use strict";
// ref: https://github.com/tc39/proposal-global
var $d807486b5dc73e7e$var$getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var $d807486b5dc73e7e$var$globalObject = $d807486b5dc73e7e$var$getGlobal();
const $d807486b5dc73e7e$export$e7aa7bc5c1b3cfb3 = $d807486b5dc73e7e$var$globalObject.fetch;
var $d807486b5dc73e7e$export$2e2bcd8739ae039 = $d807486b5dc73e7e$var$globalObject.fetch.bind($d807486b5dc73e7e$var$globalObject);
const $d807486b5dc73e7e$export$79b704688b15c0f4 = $d807486b5dc73e7e$var$globalObject.Headers;
const $d807486b5dc73e7e$export$7fa6c5b6f8193917 = $d807486b5dc73e7e$var$globalObject.Request;
const $d807486b5dc73e7e$export$9f633d56d7ec90d3 = $d807486b5dc73e7e$var$globalObject.Response;

});

parcelRegister("ca6un", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Error format
 *
 * {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
 */ class $8dab73c3e2c654c9$var$PostgrestError extends Error {
    constructor(context){
        super(context.message);
        this.name = 'PostgrestError';
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
}
module.exports.default = $8dab73c3e2c654c9$var$PostgrestError;

});





parcelRegister("h3esd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_HEADERS = void 0;

var $8FVod = parcelRequire("8FVod");
module.exports.DEFAULT_HEADERS = {
    'X-Client-Info': `postgrest-js/${$8FVod.version}`
};

});
parcelRegister("8FVod", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
module.exports.version = '0.0.0-automated';

});



parcelRegister("gL8Hc", function(module, exports) {
module.exports = import("4sY63").then(()=>parcelRequire('8ByQN'));

});

parcelRegister("6Qyup", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $etwCZ = parcelRequire("etwCZ");
function $4fc25a4ac40c4c88$var$emptyFunction() {}
function $4fc25a4ac40c4c88$var$emptyFunctionWithReset() {}
$4fc25a4ac40c4c88$var$emptyFunctionWithReset.resetWarningCache = $4fc25a4ac40c4c88$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $etwCZ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4fc25a4ac40c4c88$var$emptyFunctionWithReset,
        resetWarningCache: $4fc25a4ac40c4c88$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("etwCZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $a89d1556042ce940$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $a89d1556042ce940$var$ReactPropTypesSecret;

});


parcelRegister("c6zfL", function(module, exports) {
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 

module.exports = function $$$reconciler($$$hostConfig) {
    var exports = {};
    'use strict';
    var aa = (parcelRequire("ltGt3")), ba = (parcelRequire("hZysK")), ca = Object.assign;
    function m(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var da = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ea = Symbol.for("react.element"), fa = Symbol.for("react.portal"), ha = Symbol.for("react.fragment"), ia = Symbol.for("react.strict_mode"), ja = Symbol.for("react.profiler"), ka = Symbol.for("react.provider"), la = Symbol.for("react.context"), ma = Symbol.for("react.forward_ref"), na = Symbol.for("react.suspense"), oa = Symbol.for("react.suspense_list"), pa = Symbol.for("react.memo"), qa = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    Symbol.for("react.debug_trace_mode");
    var ra = Symbol.for("react.offscreen");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.cache");
    Symbol.for("react.tracing_marker");
    var sa = Symbol.iterator;
    function ta(a) {
        if (null === a || "object" !== typeof a) return null;
        a = sa && a[sa] || a["@@iterator"];
        return "function" === typeof a ? a : null;
    }
    function ua(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case ha:
                return "Fragment";
            case fa:
                return "Portal";
            case ja:
                return "Profiler";
            case ia:
                return "StrictMode";
            case na:
                return "Suspense";
            case oa:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case la:
                return (a.displayName || "Context") + ".Consumer";
            case ka:
                return (a._context.displayName || "Context") + ".Provider";
            case ma:
                var b = a.render;
                a = a.displayName;
                a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
                return a;
            case pa:
                return b = a.displayName || null, null !== b ? b : ua(a.type) || "Memo";
            case qa:
                b = a._payload;
                a = a._init;
                try {
                    return ua(a(b));
                } catch (c) {}
        }
        return null;
    }
    function va(a) {
        var b = a.type;
        switch(a.tag){
            case 24:
                return "Cache";
            case 9:
                return (b.displayName || "Context") + ".Consumer";
            case 10:
                return (b._context.displayName || "Context") + ".Provider";
            case 18:
                return "DehydratedFragment";
            case 11:
                return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 5:
                return b;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return ua(b);
            case 8:
                return b === ia ? "StrictMode" : "Mode";
            case 22:
                return "Offscreen";
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
                if ("function" === typeof b) return b.displayName || b.name || null;
                if ("string" === typeof b) return b;
        }
        return null;
    }
    function wa(a) {
        var b = a, c = a;
        if (a.alternate) for(; b.return;)b = b.return;
        else {
            a = b;
            do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
            while (a);
        }
        return 3 === b.tag ? c : null;
    }
    function xa(a) {
        if (wa(a) !== a) throw Error(m(188));
    }
    function ya(a) {
        var b = a.alternate;
        if (!b) {
            b = wa(a);
            if (null === b) throw Error(m(188));
            return b !== a ? null : a;
        }
        for(var c = a, d = b;;){
            var e = c.return;
            if (null === e) break;
            var f = e.alternate;
            if (null === f) {
                d = e.return;
                if (null !== d) {
                    c = d;
                    continue;
                }
                break;
            }
            if (e.child === f.child) {
                for(f = e.child; f;){
                    if (f === c) return xa(e), a;
                    if (f === d) return xa(e), b;
                    f = f.sibling;
                }
                throw Error(m(188));
            }
            if (c.return !== d.return) c = e, d = f;
            else {
                for(var g = !1, h = e.child; h;){
                    if (h === c) {
                        g = !0;
                        c = e;
                        d = f;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = e;
                        c = f;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) {
                    for(h = f.child; h;){
                        if (h === c) {
                            g = !0;
                            c = f;
                            d = e;
                            break;
                        }
                        if (h === d) {
                            g = !0;
                            d = f;
                            c = e;
                            break;
                        }
                        h = h.sibling;
                    }
                    if (!g) throw Error(m(189));
                }
            }
            if (c.alternate !== d) throw Error(m(190));
        }
        if (3 !== c.tag) throw Error(m(188));
        return c.stateNode.current === c ? a : b;
    }
    function Aa(a) {
        a = ya(a);
        return null !== a ? Ba(a) : null;
    }
    function Ba(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            var b = Ba(a);
            if (null !== b) return b;
            a = a.sibling;
        }
        return null;
    }
    function Ca(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            if (4 !== a.tag) {
                var b = Ca(a);
                if (null !== b) return b;
            }
            a = a.sibling;
        }
        return null;
    }
    var Da = Array.isArray, Ea = $$$hostConfig.getPublicInstance, Fa = $$$hostConfig.getRootHostContext, Ga = $$$hostConfig.getChildHostContext, Ha = $$$hostConfig.prepareForCommit, Ia = $$$hostConfig.resetAfterCommit, Ja = $$$hostConfig.createInstance, Ka = $$$hostConfig.appendInitialChild, La = $$$hostConfig.finalizeInitialChildren, Ma = $$$hostConfig.prepareUpdate, Na = $$$hostConfig.shouldSetTextContent, Oa = $$$hostConfig.createTextInstance, Pa = $$$hostConfig.scheduleTimeout, Qa = $$$hostConfig.cancelTimeout, Ra = $$$hostConfig.noTimeout, Sa = $$$hostConfig.isPrimaryRenderer, Ta = $$$hostConfig.supportsMutation, Ua = $$$hostConfig.supportsPersistence, Va = $$$hostConfig.supportsHydration, Wa = $$$hostConfig.getInstanceFromNode, Xa = $$$hostConfig.preparePortalMount, Ya = $$$hostConfig.getCurrentEventPriority, Za = $$$hostConfig.detachDeletedInstance, $a = $$$hostConfig.supportsMicrotasks, ab = $$$hostConfig.scheduleMicrotask, bb = $$$hostConfig.supportsTestSelectors, cb = $$$hostConfig.findFiberRoot, db = $$$hostConfig.getBoundingRect, eb = $$$hostConfig.getTextContent, fb = $$$hostConfig.isHiddenSubtree, gb = $$$hostConfig.matchAccessibilityRole, hb = $$$hostConfig.setFocusIfFocusable, ib = $$$hostConfig.setupIntersectionObserver, jb = $$$hostConfig.appendChild, kb = $$$hostConfig.appendChildToContainer, lb = $$$hostConfig.commitTextUpdate, mb = $$$hostConfig.commitMount, nb = $$$hostConfig.commitUpdate, ob = $$$hostConfig.insertBefore, pb = $$$hostConfig.insertInContainerBefore, qb = $$$hostConfig.removeChild, rb = $$$hostConfig.removeChildFromContainer, sb = $$$hostConfig.resetTextContent, tb = $$$hostConfig.hideInstance, ub = $$$hostConfig.hideTextInstance, vb = $$$hostConfig.unhideInstance, wb = $$$hostConfig.unhideTextInstance, xb = $$$hostConfig.clearContainer, yb = $$$hostConfig.cloneInstance, zb = $$$hostConfig.createContainerChildSet, Ab = $$$hostConfig.appendChildToContainerChildSet, Bb = $$$hostConfig.finalizeContainerChildren, Cb = $$$hostConfig.replaceContainerChildren, Eb = $$$hostConfig.cloneHiddenInstance, Fb = $$$hostConfig.cloneHiddenTextInstance, Gb = $$$hostConfig.canHydrateInstance, Hb = $$$hostConfig.canHydrateTextInstance, Ib = $$$hostConfig.canHydrateSuspenseInstance, Jb = $$$hostConfig.isSuspenseInstancePending, Kb = $$$hostConfig.isSuspenseInstanceFallback, Lb = $$$hostConfig.getSuspenseInstanceFallbackErrorDetails, Mb = $$$hostConfig.registerSuspenseInstanceRetry, Nb = $$$hostConfig.getNextHydratableSibling, Ob = $$$hostConfig.getFirstHydratableChild, Pb = $$$hostConfig.getFirstHydratableChildWithinContainer, Qb = $$$hostConfig.getFirstHydratableChildWithinSuspenseInstance, Rb = $$$hostConfig.hydrateInstance, Sb = $$$hostConfig.hydrateTextInstance, Tb = $$$hostConfig.hydrateSuspenseInstance, Ub = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, Vb = $$$hostConfig.commitHydratedContainer, Wb = $$$hostConfig.commitHydratedSuspenseInstance, Xb = $$$hostConfig.clearSuspenseBoundary, Yb = $$$hostConfig.clearSuspenseBoundaryFromContainer, Zb = $$$hostConfig.shouldDeleteUnhydratedTailInstances, $b = $$$hostConfig.didNotMatchHydratedContainerTextInstance, ac = $$$hostConfig.didNotMatchHydratedTextInstance, bc;
    function cc(a) {
        if (void 0 === bc) try {
            throw Error();
        } catch (c) {
            var b = c.stack.trim().match(/\n( *(at )?)/);
            bc = b && b[1] || "";
        }
        return "\n" + bc + a;
    }
    var dc = !1;
    function ec(a, b) {
        if (!a || dc) return "";
        dc = !0;
        var c = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            if (b) {
                if (b = function() {
                    throw Error();
                }, Object.defineProperty(b.prototype, "props", {
                    set: function() {
                        throw Error();
                    }
                }), "object" === typeof Reflect && Reflect.construct) {
                    try {
                        Reflect.construct(b, []);
                    } catch (l) {
                        var d = l;
                    }
                    Reflect.construct(a, [], b);
                } else {
                    try {
                        b.call();
                    } catch (l) {
                        d = l;
                    }
                    a.call(b.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (l) {
                    d = l;
                }
                a();
            }
        } catch (l) {
            if (l && d && "string" === typeof l.stack) {
                for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
                for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                    if (1 !== g || 1 !== h) {
                        do if (g--, h--, 0 > h || e[g] !== f[h]) {
                            var k = "\n" + e[g].replace(" at new ", " at ");
                            a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                            return k;
                        }
                        while (1 <= g && 0 <= h);
                    }
                    break;
                }
            }
        } finally{
            dc = !1, Error.prepareStackTrace = c;
        }
        return (a = a ? a.displayName || a.name : "") ? cc(a) : "";
    }
    var fc = Object.prototype.hasOwnProperty, gc = [], hc = -1;
    function ic(a) {
        return {
            current: a
        };
    }
    function q(a) {
        0 > hc || (a.current = gc[hc], gc[hc] = null, hc--);
    }
    function v(a, b) {
        hc++;
        gc[hc] = a.current;
        a.current = b;
    }
    var jc = {}, x = ic(jc), z = ic(!1), kc = jc;
    function lc(a, b) {
        var c = a.type.contextTypes;
        if (!c) return jc;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
        var e = {}, f;
        for(f in c)e[f] = b[f];
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
        return e;
    }
    function A(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
    }
    function mc() {
        q(z);
        q(x);
    }
    function nc(a, b, c) {
        if (x.current !== jc) throw Error(m(168));
        v(x, b);
        v(z, c);
    }
    function oc(a, b, c) {
        var d = a.stateNode;
        b = b.childContextTypes;
        if ("function" !== typeof d.getChildContext) return c;
        d = d.getChildContext();
        for(var e in d)if (!(e in b)) throw Error(m(108, va(a) || "Unknown", e));
        return ca({}, c, d);
    }
    function pc(a) {
        a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || jc;
        kc = x.current;
        v(x, a);
        v(z, z.current);
        return !0;
    }
    function rc(a, b, c) {
        var d = a.stateNode;
        if (!d) throw Error(m(169));
        c ? (a = oc(a, b, kc), d.__reactInternalMemoizedMergedChildContext = a, q(z), q(x), v(x, a)) : q(z);
        v(z, c);
    }
    var tc = Math.clz32 ? Math.clz32 : sc, uc = Math.log, vc = Math.LN2;
    function sc(a) {
        a >>>= 0;
        return 0 === a ? 32 : 31 - (uc(a) / vc | 0) | 0;
    }
    var wc = 64, xc = 4194304;
    function yc(a) {
        switch(a & -a){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return a & 4194240;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return a & 130023424;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 1073741824;
            default:
                return a;
        }
    }
    function zc(a, b) {
        var c = a.pendingLanes;
        if (0 === c) return 0;
        var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
        if (0 !== g) {
            var h = g & ~e;
            0 !== h ? d = yc(h) : (f &= g, 0 !== f && (d = yc(f)));
        } else g = c & ~e, 0 !== g ? d = yc(g) : 0 !== f && (d = yc(f));
        if (0 === d) return 0;
        if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
        0 !== (d & 4) && (d |= c & 16);
        b = a.entangledLanes;
        if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - tc(b), e = 1 << c, d |= a[c], b &= ~e;
        return d;
    }
    function Ac(a, b) {
        switch(a){
            case 1:
            case 2:
            case 4:
                return b + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return b + 5E3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return -1;
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return -1;
        }
    }
    function Bc(a, b) {
        for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
            var g = 31 - tc(f), h = 1 << g, k = e[g];
            if (-1 === k) {
                if (0 === (h & c) || 0 !== (h & d)) e[g] = Ac(h, b);
            } else k <= b && (a.expiredLanes |= h);
            f &= ~h;
        }
    }
    function Cc(a) {
        a = a.pendingLanes & -1073741825;
        return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
    }
    function Dc() {
        var a = wc;
        wc <<= 1;
        0 === (wc & 4194240) && (wc = 64);
        return a;
    }
    function Ec(a) {
        for(var b = [], c = 0; 31 > c; c++)b.push(a);
        return b;
    }
    function Fc(a, b, c) {
        a.pendingLanes |= b;
        536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
        a = a.eventTimes;
        b = 31 - tc(b);
        a[b] = c;
    }
    function Gc(a, b) {
        var c = a.pendingLanes & ~b;
        a.pendingLanes = b;
        a.suspendedLanes = 0;
        a.pingedLanes = 0;
        a.expiredLanes &= b;
        a.mutableReadLanes &= b;
        a.entangledLanes &= b;
        b = a.entanglements;
        var d = a.eventTimes;
        for(a = a.expirationTimes; 0 < c;){
            var e = 31 - tc(c), f = 1 << e;
            b[e] = 0;
            d[e] = -1;
            a[e] = -1;
            c &= ~f;
        }
    }
    function Hc(a, b) {
        var c = a.entangledLanes |= b;
        for(a = a.entanglements; c;){
            var d = 31 - tc(c), e = 1 << d;
            e & b | a[d] & b && (a[d] |= b);
            c &= ~e;
        }
    }
    var C = 0;
    function Ic(a) {
        a &= -a;
        return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
    }
    var Jc = ba.unstable_scheduleCallback, Kc = ba.unstable_cancelCallback, Lc = ba.unstable_shouldYield, Mc = ba.unstable_requestPaint, D = ba.unstable_now, Nc = ba.unstable_ImmediatePriority, Oc = ba.unstable_UserBlockingPriority, Pc = ba.unstable_NormalPriority, Qc = ba.unstable_IdlePriority, Rc = null, Sc = null;
    function Tc(a) {
        if (Sc && "function" === typeof Sc.onCommitFiberRoot) try {
            Sc.onCommitFiberRoot(Rc, a, void 0, 128 === (a.current.flags & 128));
        } catch (b) {}
    }
    function Uc(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var Vc = "function" === typeof Object.is ? Object.is : Uc, Wc = null, Xc = !1, Yc = !1;
    function Zc(a) {
        null === Wc ? Wc = [
            a
        ] : Wc.push(a);
    }
    function $c(a) {
        Xc = !0;
        Zc(a);
    }
    function ad() {
        if (!Yc && null !== Wc) {
            Yc = !0;
            var a = 0, b = C;
            try {
                var c = Wc;
                for(C = 1; a < c.length; a++){
                    var d = c[a];
                    do d = d(!0);
                    while (null !== d);
                }
                Wc = null;
                Xc = !1;
            } catch (e) {
                throw null !== Wc && (Wc = Wc.slice(a + 1)), Jc(Nc, ad), e;
            } finally{
                C = b, Yc = !1;
            }
        }
        return null;
    }
    var bd = [], cd = 0, dd = null, ed = 0, fd = [], gd = 0, hd = null, id = 1, jd = "";
    function kd(a, b) {
        bd[cd++] = ed;
        bd[cd++] = dd;
        dd = a;
        ed = b;
    }
    function ld(a, b, c) {
        fd[gd++] = id;
        fd[gd++] = jd;
        fd[gd++] = hd;
        hd = a;
        var d = id;
        a = jd;
        var e = 32 - tc(d) - 1;
        d &= ~(1 << e);
        c += 1;
        var f = 32 - tc(b) + e;
        if (30 < f) {
            var g = e - e % 5;
            f = (d & (1 << g) - 1).toString(32);
            d >>= g;
            e -= g;
            id = 1 << 32 - tc(b) + e | c << e | d;
            jd = f + a;
        } else id = 1 << f | c << e | d, jd = a;
    }
    function md(a) {
        null !== a.return && (kd(a, 1), ld(a, 1, 0));
    }
    function nd(a) {
        for(; a === dd;)dd = bd[--cd], bd[cd] = null, ed = bd[--cd], bd[cd] = null;
        for(; a === hd;)hd = fd[--gd], fd[gd] = null, jd = fd[--gd], fd[gd] = null, id = fd[--gd], fd[gd] = null;
    }
    var od = null, pd = null, F = !1, qd = !1, rd = null;
    function sd(a, b) {
        var c = td(5, null, null, 0);
        c.elementType = "DELETED";
        c.stateNode = b;
        c.return = a;
        b = a.deletions;
        null === b ? (a.deletions = [
            c
        ], a.flags |= 16) : b.push(c);
    }
    function ud(a, b) {
        switch(a.tag){
            case 5:
                return b = Gb(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, od = a, pd = Ob(b), !0) : !1;
            case 6:
                return b = Hb(b, a.pendingProps), null !== b ? (a.stateNode = b, od = a, pd = null, !0) : !1;
            case 13:
                b = Ib(b);
                if (null !== b) {
                    var c = null !== hd ? {
                        id: id,
                        overflow: jd
                    } : null;
                    a.memoizedState = {
                        dehydrated: b,
                        treeContext: c,
                        retryLane: 1073741824
                    };
                    c = td(18, null, null, 0);
                    c.stateNode = b;
                    c.return = a;
                    a.child = c;
                    od = a;
                    pd = null;
                    return !0;
                }
                return !1;
            default:
                return !1;
        }
    }
    function vd(a) {
        return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
    }
    function wd(a) {
        if (F) {
            var b = pd;
            if (b) {
                var c = b;
                if (!ud(a, b)) {
                    if (vd(a)) throw Error(m(418));
                    b = Nb(c);
                    var d = od;
                    b && ud(a, b) ? sd(d, c) : (a.flags = a.flags & -4097 | 2, F = !1, od = a);
                }
            } else {
                if (vd(a)) throw Error(m(418));
                a.flags = a.flags & -4097 | 2;
                F = !1;
                od = a;
            }
        }
    }
    function xd(a) {
        for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
        od = a;
    }
    function yd(a) {
        if (!Va || a !== od) return !1;
        if (!F) return xd(a), F = !0, !1;
        if (3 !== a.tag && (5 !== a.tag || Zb(a.type) && !Na(a.type, a.memoizedProps))) {
            var b = pd;
            if (b) {
                if (vd(a)) throw zd(), Error(m(418));
                for(; b;)sd(a, b), b = Nb(b);
            }
        }
        xd(a);
        if (13 === a.tag) {
            if (!Va) throw Error(m(316));
            a = a.memoizedState;
            a = null !== a ? a.dehydrated : null;
            if (!a) throw Error(m(317));
            pd = Ub(a);
        } else pd = od ? Nb(a.stateNode) : null;
        return !0;
    }
    function zd() {
        for(var a = pd; a;)a = Nb(a);
    }
    function Ad() {
        Va && (pd = od = null, qd = F = !1);
    }
    function Bd(a) {
        null === rd ? rd = [
            a
        ] : rd.push(a);
    }
    var Cd = da.ReactCurrentBatchConfig;
    function Dd(a, b) {
        if (Vc(a, b)) return !0;
        if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
        var c = Object.keys(a), d = Object.keys(b);
        if (c.length !== d.length) return !1;
        for(d = 0; d < c.length; d++){
            var e = c[d];
            if (!fc.call(b, e) || !Vc(a[e], b[e])) return !1;
        }
        return !0;
    }
    function Ed(a) {
        switch(a.tag){
            case 5:
                return cc(a.type);
            case 16:
                return cc("Lazy");
            case 13:
                return cc("Suspense");
            case 19:
                return cc("SuspenseList");
            case 0:
            case 2:
            case 15:
                return a = ec(a.type, !1), a;
            case 11:
                return a = ec(a.type.render, !1), a;
            case 1:
                return a = ec(a.type, !0), a;
            default:
                return "";
        }
    }
    function Fd(a, b) {
        if (a && a.defaultProps) {
            b = ca({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            return b;
        }
        return b;
    }
    var Gd = ic(null), Hd = null, Id = null, Jd = null;
    function Kd() {
        Jd = Id = Hd = null;
    }
    function Ld(a, b, c) {
        Sa ? (v(Gd, b._currentValue), b._currentValue = c) : (v(Gd, b._currentValue2), b._currentValue2 = c);
    }
    function Md(a) {
        var b = Gd.current;
        q(Gd);
        Sa ? a._currentValue = b : a._currentValue2 = b;
    }
    function Nd(a, b, c) {
        for(; null !== a;){
            var d = a.alternate;
            (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
            if (a === c) break;
            a = a.return;
        }
    }
    function Od(a, b) {
        Hd = a;
        Jd = Id = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (G = !0), a.firstContext = null);
    }
    function Pd(a) {
        var b = Sa ? a._currentValue : a._currentValue2;
        if (Jd !== a) {
            if (a = {
                context: a,
                memoizedValue: b,
                next: null
            }, null === Id) {
                if (null === Hd) throw Error(m(308));
                Id = a;
                Hd.dependencies = {
                    lanes: 0,
                    firstContext: a
                };
            } else Id = Id.next = a;
        }
        return b;
    }
    var Qd = null;
    function Rd(a) {
        null === Qd ? Qd = [
            a
        ] : Qd.push(a);
    }
    function Sd(a, b, c, d) {
        var e = b.interleaved;
        null === e ? (c.next = c, Rd(b)) : (c.next = e.next, e.next = c);
        b.interleaved = c;
        return Td(a, d);
    }
    function Td(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        c = a;
        for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
        return 3 === c.tag ? c.stateNode : null;
    }
    var Ud = !1;
    function Vd(a) {
        a.updateQueue = {
            baseState: a.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: 0
            },
            effects: null
        };
    }
    function Wd(a, b) {
        a = a.updateQueue;
        b.updateQueue === a && (b.updateQueue = {
            baseState: a.baseState,
            firstBaseUpdate: a.firstBaseUpdate,
            lastBaseUpdate: a.lastBaseUpdate,
            shared: a.shared,
            effects: a.effects
        });
    }
    function Xd(a, b) {
        return {
            eventTime: a,
            lane: b,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function Yd(a, b, c) {
        var d = a.updateQueue;
        if (null === d) return null;
        d = d.shared;
        if (0 !== (H & 2)) {
            var e = d.pending;
            null === e ? b.next = b : (b.next = e.next, e.next = b);
            d.pending = b;
            return Td(a, c);
        }
        e = d.interleaved;
        null === e ? (b.next = b, Rd(d)) : (b.next = e.next, e.next = b);
        d.interleaved = b;
        return Td(a, c);
    }
    function Zd(a, b, c) {
        b = b.updateQueue;
        if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Hc(a, c);
        }
    }
    function $d(a, b) {
        var c = a.updateQueue, d = a.alternate;
        if (null !== d && (d = d.updateQueue, c === d)) {
            var e = null, f = null;
            c = c.firstBaseUpdate;
            if (null !== c) {
                do {
                    var g = {
                        eventTime: c.eventTime,
                        lane: c.lane,
                        tag: c.tag,
                        payload: c.payload,
                        callback: c.callback,
                        next: null
                    };
                    null === f ? e = f = g : f = f.next = g;
                    c = c.next;
                }while (null !== c);
                null === f ? e = f = b : f = f.next = b;
            } else e = f = b;
            c = {
                baseState: d.baseState,
                firstBaseUpdate: e,
                lastBaseUpdate: f,
                shared: d.shared,
                effects: d.effects
            };
            a.updateQueue = c;
            return;
        }
        a = c.lastBaseUpdate;
        null === a ? c.firstBaseUpdate = b : a.next = b;
        c.lastBaseUpdate = b;
    }
    function ae(a, b, c, d) {
        var e = a.updateQueue;
        Ud = !1;
        var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
        if (null !== h) {
            e.shared.pending = null;
            var k = h, l = k.next;
            k.next = null;
            null === g ? f = l : g.next = l;
            g = k;
            var n = a.alternate;
            null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
        }
        if (null !== f) {
            var t = e.baseState;
            g = 0;
            n = l = k = null;
            h = f;
            do {
                var p = h.lane, B = h.eventTime;
                if ((d & p) === p) {
                    null !== n && (n = n.next = {
                        eventTime: B,
                        lane: 0,
                        tag: h.tag,
                        payload: h.payload,
                        callback: h.callback,
                        next: null
                    });
                    a: {
                        var w = a, Z = h;
                        p = b;
                        B = c;
                        switch(Z.tag){
                            case 1:
                                w = Z.payload;
                                if ("function" === typeof w) {
                                    t = w.call(B, t, p);
                                    break a;
                                }
                                t = w;
                                break a;
                            case 3:
                                w.flags = w.flags & -65537 | 128;
                            case 0:
                                w = Z.payload;
                                p = "function" === typeof w ? w.call(B, t, p) : w;
                                if (null === p || void 0 === p) break a;
                                t = ca({}, t, p);
                                break a;
                            case 2:
                                Ud = !0;
                        }
                    }
                    null !== h.callback && 0 !== h.lane && (a.flags |= 64, p = e.effects, null === p ? e.effects = [
                        h
                    ] : p.push(h));
                } else B = {
                    eventTime: B,
                    lane: p,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                }, null === n ? (l = n = B, k = t) : n = n.next = B, g |= p;
                h = h.next;
                if (null === h) {
                    if (h = e.shared.pending, null === h) break;
                    else p = h, h = p.next, p.next = null, e.lastBaseUpdate = p, e.shared.pending = null;
                }
            }while (1);
            null === n && (k = t);
            e.baseState = k;
            e.firstBaseUpdate = l;
            e.lastBaseUpdate = n;
            b = e.shared.interleaved;
            if (null !== b) {
                e = b;
                do g |= e.lane, e = e.next;
                while (e !== b);
            } else null === f && (e.shared.lanes = 0);
            be |= g;
            a.lanes = g;
            a.memoizedState = t;
        }
    }
    function ce(a, b, c) {
        a = b.effects;
        b.effects = null;
        if (null !== a) for(b = 0; b < a.length; b++){
            var d = a[b], e = d.callback;
            if (null !== e) {
                d.callback = null;
                d = c;
                if ("function" !== typeof e) throw Error(m(191, e));
                e.call(d);
            }
        }
    }
    var de = (new aa.Component).refs;
    function ee(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : ca({}, b, c);
        a.memoizedState = c;
        0 === a.lanes && (a.updateQueue.baseState = c);
    }
    var he = {
        isMounted: function(a) {
            return (a = a._reactInternals) ? wa(a) === a : !1;
        },
        enqueueSetState: function(a, b, c) {
            a = a._reactInternals;
            var d = I(), e = fe(a), f = Xd(d, e);
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            b = Yd(a, f, e);
            null !== b && (ge(b, a, e, d), Zd(b, a, e));
        },
        enqueueReplaceState: function(a, b, c) {
            a = a._reactInternals;
            var d = I(), e = fe(a), f = Xd(d, e);
            f.tag = 1;
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            b = Yd(a, f, e);
            null !== b && (ge(b, a, e, d), Zd(b, a, e));
        },
        enqueueForceUpdate: function(a, b) {
            a = a._reactInternals;
            var c = I(), d = fe(a), e = Xd(c, d);
            e.tag = 2;
            void 0 !== b && null !== b && (e.callback = b);
            b = Yd(a, e, d);
            null !== b && (ge(b, a, d, c), Zd(b, a, d));
        }
    };
    function ie(a, b, c, d, e, f, g) {
        a = a.stateNode;
        return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Dd(c, d) || !Dd(e, f) : !0;
    }
    function je(a, b, c) {
        var d = !1, e = jc;
        var f = b.contextType;
        "object" === typeof f && null !== f ? f = Pd(f) : (e = A(b) ? kc : x.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? lc(a, e) : jc);
        b = new b(c, f);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = he;
        a.stateNode = b;
        b._reactInternals = a;
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
        return b;
    }
    function ke(a, b, c, d) {
        a = b.state;
        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && he.enqueueReplaceState(b, b.state, null);
    }
    function le(a, b, c, d) {
        var e = a.stateNode;
        e.props = c;
        e.state = a.memoizedState;
        e.refs = de;
        Vd(a);
        var f = b.contextType;
        "object" === typeof f && null !== f ? e.context = Pd(f) : (f = A(b) ? kc : x.current, e.context = lc(a, f));
        e.state = a.memoizedState;
        f = b.getDerivedStateFromProps;
        "function" === typeof f && (ee(a, b, f, c), e.state = a.memoizedState);
        "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && he.enqueueReplaceState(e, e.state, null), ae(a, c, e, d), e.state = a.memoizedState);
        "function" === typeof e.componentDidMount && (a.flags |= 4194308);
    }
    function me(a, b, c) {
        a = c.ref;
        if (null !== a && "function" !== typeof a && "object" !== typeof a) {
            if (c._owner) {
                c = c._owner;
                if (c) {
                    if (1 !== c.tag) throw Error(m(309));
                    var d = c.stateNode;
                }
                if (!d) throw Error(m(147, a));
                var e = d, f = "" + a;
                if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
                b = function(a) {
                    var b = e.refs;
                    b === de && (b = e.refs = {});
                    null === a ? delete b[f] : b[f] = a;
                };
                b._stringRef = f;
                return b;
            }
            if ("string" !== typeof a) throw Error(m(284));
            if (!c._owner) throw Error(m(290, a));
        }
        return a;
    }
    function ne(a, b) {
        a = Object.prototype.toString.call(b);
        throw Error(m(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
    }
    function oe(a) {
        var b = a._init;
        return b(a._payload);
    }
    function pe(a) {
        function b(b, c) {
            if (a) {
                var d = b.deletions;
                null === d ? (b.deletions = [
                    c
                ], b.flags |= 16) : d.push(c);
            }
        }
        function c(c, d) {
            if (!a) return null;
            for(; null !== d;)b(c, d), d = d.sibling;
            return null;
        }
        function d(a, b) {
            for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
            return a;
        }
        function e(a, b) {
            a = qe(a, b);
            a.index = 0;
            a.sibling = null;
            return a;
        }
        function f(b, c, d) {
            b.index = d;
            if (!a) return b.flags |= 1048576, c;
            d = b.alternate;
            if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
            b.flags |= 2;
            return c;
        }
        function g(b) {
            a && null === b.alternate && (b.flags |= 2);
            return b;
        }
        function h(a, b, c, d) {
            if (null === b || 6 !== b.tag) return b = re(c, a.mode, d), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function k(a, b, c, d) {
            var f = c.type;
            if (f === ha) return n(a, b, c.props.children, d, c.key);
            if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === qa && oe(f) === b.type)) return d = e(b, c.props), d.ref = me(a, b, c), d.return = a, d;
            d = se(c.type, c.key, c.props, null, a.mode, d);
            d.ref = me(a, b, c);
            d.return = a;
            return d;
        }
        function l(a, b, c, d) {
            if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = te(c, a.mode, d), b.return = a, b;
            b = e(b, c.children || []);
            b.return = a;
            return b;
        }
        function n(a, b, c, d, f) {
            if (null === b || 7 !== b.tag) return b = ue(c, a.mode, d, f), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function t(a, b, c) {
            if ("string" === typeof b && "" !== b || "number" === typeof b) return b = re("" + b, a.mode, c), b.return = a, b;
            if ("object" === typeof b && null !== b) {
                switch(b.$$typeof){
                    case ea:
                        return c = se(b.type, b.key, b.props, null, a.mode, c), c.ref = me(a, null, b), c.return = a, c;
                    case fa:
                        return b = te(b, a.mode, c), b.return = a, b;
                    case qa:
                        var d = b._init;
                        return t(a, d(b._payload), c);
                }
                if (Da(b) || ta(b)) return b = ue(b, a.mode, c, null), b.return = a, b;
                ne(a, b);
            }
            return null;
        }
        function p(a, b, c, d) {
            var e = null !== b ? b.key : null;
            if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
            if ("object" === typeof c && null !== c) {
                switch(c.$$typeof){
                    case ea:
                        return c.key === e ? k(a, b, c, d) : null;
                    case fa:
                        return c.key === e ? l(a, b, c, d) : null;
                    case qa:
                        return e = c._init, p(a, b, e(c._payload), d);
                }
                if (Da(c) || ta(c)) return null !== e ? null : n(a, b, c, d, null);
                ne(a, c);
            }
            return null;
        }
        function B(a, b, c, d, e) {
            if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
            if ("object" === typeof d && null !== d) {
                switch(d.$$typeof){
                    case ea:
                        return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                    case fa:
                        return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                    case qa:
                        var f = d._init;
                        return B(a, b, c, f(d._payload), e);
                }
                if (Da(d) || ta(d)) return a = a.get(c) || null, n(b, a, d, e, null);
                ne(b, d);
            }
            return null;
        }
        function w(e, g, h, k) {
            for(var l = null, n = null, r = g, u = g = 0, E = null; null !== r && u < h.length; u++){
                r.index > u ? (E = r, r = null) : E = r.sibling;
                var y = p(e, r, h[u], k);
                if (null === y) {
                    null === r && (r = E);
                    break;
                }
                a && r && null === y.alternate && b(e, r);
                g = f(y, g, u);
                null === n ? l = y : n.sibling = y;
                n = y;
                r = E;
            }
            if (u === h.length) return c(e, r), F && kd(e, u), l;
            if (null === r) {
                for(; u < h.length; u++)r = t(e, h[u], k), null !== r && (g = f(r, g, u), null === n ? l = r : n.sibling = r, n = r);
                F && kd(e, u);
                return l;
            }
            for(r = d(e, r); u < h.length; u++)E = B(r, e, u, h[u], k), null !== E && (a && null !== E.alternate && r.delete(null === E.key ? u : E.key), g = f(E, g, u), null === n ? l = E : n.sibling = E, n = E);
            a && r.forEach(function(a) {
                return b(e, a);
            });
            F && kd(e, u);
            return l;
        }
        function Z(e, g, h, k) {
            var l = ta(h);
            if ("function" !== typeof l) throw Error(m(150));
            h = l.call(h);
            if (null == h) throw Error(m(151));
            for(var n = l = null, r = g, u = g = 0, E = null, y = h.next(); null !== r && !y.done; u++, y = h.next()){
                r.index > u ? (E = r, r = null) : E = r.sibling;
                var w = p(e, r, y.value, k);
                if (null === w) {
                    null === r && (r = E);
                    break;
                }
                a && r && null === w.alternate && b(e, r);
                g = f(w, g, u);
                null === n ? l = w : n.sibling = w;
                n = w;
                r = E;
            }
            if (y.done) return c(e, r), F && kd(e, u), l;
            if (null === r) {
                for(; !y.done; u++, y = h.next())y = t(e, y.value, k), null !== y && (g = f(y, g, u), null === n ? l = y : n.sibling = y, n = y);
                F && kd(e, u);
                return l;
            }
            for(r = d(e, r); !y.done; u++, y = h.next())y = B(r, e, u, y.value, k), null !== y && (a && null !== y.alternate && r.delete(null === y.key ? u : y.key), g = f(y, g, u), null === n ? l = y : n.sibling = y, n = y);
            a && r.forEach(function(a) {
                return b(e, a);
            });
            F && kd(e, u);
            return l;
        }
        function za(a, d, f, h) {
            "object" === typeof f && null !== f && f.type === ha && null === f.key && (f = f.props.children);
            if ("object" === typeof f && null !== f) {
                switch(f.$$typeof){
                    case ea:
                        a: {
                            for(var k = f.key, l = d; null !== l;){
                                if (l.key === k) {
                                    k = f.type;
                                    if (k === ha) {
                                        if (7 === l.tag) {
                                            c(a, l.sibling);
                                            d = e(l, f.props.children);
                                            d.return = a;
                                            a = d;
                                            break a;
                                        }
                                    } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === qa && oe(k) === l.type) {
                                        c(a, l.sibling);
                                        d = e(l, f.props);
                                        d.ref = me(a, l, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    c(a, l);
                                    break;
                                } else b(a, l);
                                l = l.sibling;
                            }
                            f.type === ha ? (d = ue(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = se(f.type, f.key, f.props, null, a.mode, h), h.ref = me(a, d, f), h.return = a, a = h);
                        }
                        return g(a);
                    case fa:
                        a: {
                            for(l = f.key; null !== d;){
                                if (d.key === l) {
                                    if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                        c(a, d.sibling);
                                        d = e(d, f.children || []);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    } else {
                                        c(a, d);
                                        break;
                                    }
                                } else b(a, d);
                                d = d.sibling;
                            }
                            d = te(f, a.mode, h);
                            d.return = a;
                            a = d;
                        }
                        return g(a);
                    case qa:
                        return l = f._init, za(a, d, l(f._payload), h);
                }
                if (Da(f)) return w(a, d, f, h);
                if (ta(f)) return Z(a, d, f, h);
                ne(a, f);
            }
            return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = re(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
        }
        return za;
    }
    var ve = pe(!0), we = pe(!1), xe = {}, ye = ic(xe), ze = ic(xe), Ae = ic(xe);
    function Be(a) {
        if (a === xe) throw Error(m(174));
        return a;
    }
    function Ce(a, b) {
        v(Ae, b);
        v(ze, a);
        v(ye, xe);
        a = Fa(b);
        q(ye);
        v(ye, a);
    }
    function De() {
        q(ye);
        q(ze);
        q(Ae);
    }
    function Ee(a) {
        var b = Be(Ae.current), c = Be(ye.current);
        b = Ga(c, a.type, b);
        c !== b && (v(ze, a), v(ye, b));
    }
    function Fe(a) {
        ze.current === a && (q(ye), q(ze));
    }
    var J = ic(0);
    function Ge(a) {
        for(var b = a; null !== b;){
            if (13 === b.tag) {
                var c = b.memoizedState;
                if (null !== c && (c = c.dehydrated, null === c || Jb(c) || Kb(c))) return b;
            } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                if (0 !== (b.flags & 128)) return b;
            } else if (null !== b.child) {
                b.child.return = b;
                b = b.child;
                continue;
            }
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
        return null;
    }
    var He = [];
    function Ie() {
        for(var a = 0; a < He.length; a++){
            var b = He[a];
            Sa ? b._workInProgressVersionPrimary = null : b._workInProgressVersionSecondary = null;
        }
        He.length = 0;
    }
    var Je = da.ReactCurrentDispatcher, Ke = da.ReactCurrentBatchConfig, Le = 0, K = null, L = null, M = null, Me = !1, Ne = !1, Oe = 0, Pe = 0;
    function N() {
        throw Error(m(321));
    }
    function Qe(a, b) {
        if (null === b) return !1;
        for(var c = 0; c < b.length && c < a.length; c++)if (!Vc(a[c], b[c])) return !1;
        return !0;
    }
    function Re(a, b, c, d, e, f) {
        Le = f;
        K = b;
        b.memoizedState = null;
        b.updateQueue = null;
        b.lanes = 0;
        Je.current = null === a || null === a.memoizedState ? Se : Te;
        a = c(d, e);
        if (Ne) {
            f = 0;
            do {
                Ne = !1;
                Oe = 0;
                if (25 <= f) throw Error(m(301));
                f += 1;
                M = L = null;
                b.updateQueue = null;
                Je.current = Ue;
                a = c(d, e);
            }while (Ne);
        }
        Je.current = Ve;
        b = null !== L && null !== L.next;
        Le = 0;
        M = L = K = null;
        Me = !1;
        if (b) throw Error(m(300));
        return a;
    }
    function We() {
        var a = 0 !== Oe;
        Oe = 0;
        return a;
    }
    function Xe() {
        var a = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === M ? K.memoizedState = M = a : M = M.next = a;
        return M;
    }
    function Ye() {
        if (null === L) {
            var a = K.alternate;
            a = null !== a ? a.memoizedState : null;
        } else a = L.next;
        var b = null === M ? K.memoizedState : M.next;
        if (null !== b) M = b, L = a;
        else {
            if (null === a) throw Error(m(310));
            L = a;
            a = {
                memoizedState: L.memoizedState,
                baseState: L.baseState,
                baseQueue: L.baseQueue,
                queue: L.queue,
                next: null
            };
            null === M ? K.memoizedState = M = a : M = M.next = a;
        }
        return M;
    }
    function Ze(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function $e(a) {
        var b = Ye(), c = b.queue;
        if (null === c) throw Error(m(311));
        c.lastRenderedReducer = a;
        var d = L, e = d.baseQueue, f = c.pending;
        if (null !== f) {
            if (null !== e) {
                var g = e.next;
                e.next = f.next;
                f.next = g;
            }
            d.baseQueue = e = f;
            c.pending = null;
        }
        if (null !== e) {
            f = e.next;
            d = d.baseState;
            var h = g = null, k = null, l = f;
            do {
                var n = l.lane;
                if ((Le & n) === n) null !== k && (k = k.next = {
                    lane: 0,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
                else {
                    var t = {
                        lane: n,
                        action: l.action,
                        hasEagerState: l.hasEagerState,
                        eagerState: l.eagerState,
                        next: null
                    };
                    null === k ? (h = k = t, g = d) : k = k.next = t;
                    K.lanes |= n;
                    be |= n;
                }
                l = l.next;
            }while (null !== l && l !== f);
            null === k ? g = d : k.next = h;
            Vc(d, b.memoizedState) || (G = !0);
            b.memoizedState = d;
            b.baseState = g;
            b.baseQueue = k;
            c.lastRenderedState = d;
        }
        a = c.interleaved;
        if (null !== a) {
            e = a;
            do f = e.lane, K.lanes |= f, be |= f, e = e.next;
            while (e !== a);
        } else null === e && (c.lanes = 0);
        return [
            b.memoizedState,
            c.dispatch
        ];
    }
    function af(a) {
        var b = Ye(), c = b.queue;
        if (null === c) throw Error(m(311));
        c.lastRenderedReducer = a;
        var d = c.dispatch, e = c.pending, f = b.memoizedState;
        if (null !== e) {
            c.pending = null;
            var g = e = e.next;
            do f = a(f, g.action), g = g.next;
            while (g !== e);
            Vc(f, b.memoizedState) || (G = !0);
            b.memoizedState = f;
            null === b.baseQueue && (b.baseState = f);
            c.lastRenderedState = f;
        }
        return [
            f,
            d
        ];
    }
    function bf() {}
    function cf(a, b) {
        var c = K, d = Ye(), e = b(), f = !Vc(d.memoizedState, e);
        f && (d.memoizedState = e, G = !0);
        d = d.queue;
        df(ef.bind(null, c, d, a), [
            a
        ]);
        if (d.getSnapshot !== b || f || null !== M && M.memoizedState.tag & 1) {
            c.flags |= 2048;
            ff(9, gf.bind(null, c, d, e, b), void 0, null);
            if (null === O) throw Error(m(349));
            0 !== (Le & 30) || hf(c, b, e);
        }
        return e;
    }
    function hf(a, b, c) {
        a.flags |= 16384;
        a = {
            getSnapshot: b,
            value: c
        };
        b = K.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, K.updateQueue = b, b.stores = [
            a
        ]) : (c = b.stores, null === c ? b.stores = [
            a
        ] : c.push(a));
    }
    function gf(a, b, c, d) {
        b.value = c;
        b.getSnapshot = d;
        jf(b) && kf(a);
    }
    function ef(a, b, c) {
        return c(function() {
            jf(b) && kf(a);
        });
    }
    function jf(a) {
        var b = a.getSnapshot;
        a = a.value;
        try {
            var c = b();
            return !Vc(a, c);
        } catch (d) {
            return !0;
        }
    }
    function kf(a) {
        var b = Td(a, 1);
        null !== b && ge(b, a, 1, -1);
    }
    function lf(a) {
        var b = Xe();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: Ze,
            lastRenderedState: a
        };
        b.queue = a;
        a = a.dispatch = mf.bind(null, K, a);
        return [
            b.memoizedState,
            a
        ];
    }
    function ff(a, b, c, d) {
        a = {
            tag: a,
            create: b,
            destroy: c,
            deps: d,
            next: null
        };
        b = K.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, K.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
        return a;
    }
    function nf() {
        return Ye().memoizedState;
    }
    function of(a, b, c, d) {
        var e = Xe();
        K.flags |= a;
        e.memoizedState = ff(1 | b, c, void 0, void 0 === d ? null : d);
    }
    function pf(a, b, c, d) {
        var e = Ye();
        d = void 0 === d ? null : d;
        var f = void 0;
        if (null !== L) {
            var g = L.memoizedState;
            f = g.destroy;
            if (null !== d && Qe(d, g.deps)) {
                e.memoizedState = ff(b, c, f, d);
                return;
            }
        }
        K.flags |= a;
        e.memoizedState = ff(1 | b, c, f, d);
    }
    function qf(a, b) {
        return of(8390656, 8, a, b);
    }
    function df(a, b) {
        return pf(2048, 8, a, b);
    }
    function rf(a, b) {
        return pf(4, 2, a, b);
    }
    function sf(a, b) {
        return pf(4, 4, a, b);
    }
    function tf(a, b) {
        if ("function" === typeof b) return a = a(), b(a), function() {
            b(null);
        };
        if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
            b.current = null;
        };
    }
    function uf(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return pf(4, 4, tf.bind(null, b, a), c);
    }
    function vf() {}
    function wf(a, b) {
        var c = Ye();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Qe(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function xf(a, b) {
        var c = Ye();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Qe(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function yf(a, b, c) {
        if (0 === (Le & 21)) return a.baseState && (a.baseState = !1, G = !0), a.memoizedState = c;
        Vc(c, b) || (c = Dc(), K.lanes |= c, be |= c, a.baseState = !0);
        return b;
    }
    function zf(a, b) {
        var c = C;
        C = 0 !== c && 4 > c ? c : 4;
        a(!0);
        var d = Ke.transition;
        Ke.transition = {};
        try {
            a(!1), b();
        } finally{
            C = c, Ke.transition = d;
        }
    }
    function Af() {
        return Ye().memoizedState;
    }
    function Bf(a, b, c) {
        var d = fe(a);
        c = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (Cf(a)) Df(b, c);
        else if (c = Sd(a, b, c, d), null !== c) {
            var e = I();
            ge(c, a, d, e);
            Ef(c, b, d);
        }
    }
    function mf(a, b, c) {
        var d = fe(a), e = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (Cf(a)) Df(b, e);
        else {
            var f = a.alternate;
            if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
                var g = b.lastRenderedState, h = f(g, c);
                e.hasEagerState = !0;
                e.eagerState = h;
                if (Vc(h, g)) {
                    var k = b.interleaved;
                    null === k ? (e.next = e, Rd(b)) : (e.next = k.next, k.next = e);
                    b.interleaved = e;
                    return;
                }
            } catch (l) {} finally{}
            c = Sd(a, b, e, d);
            null !== c && (e = I(), ge(c, a, d, e), Ef(c, b, d));
        }
    }
    function Cf(a) {
        var b = a.alternate;
        return a === K || null !== b && b === K;
    }
    function Df(a, b) {
        Ne = Me = !0;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
    function Ef(a, b, c) {
        if (0 !== (c & 4194240)) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Hc(a, c);
        }
    }
    var Ve = {
        readContext: Pd,
        useCallback: N,
        useContext: N,
        useEffect: N,
        useImperativeHandle: N,
        useInsertionEffect: N,
        useLayoutEffect: N,
        useMemo: N,
        useReducer: N,
        useRef: N,
        useState: N,
        useDebugValue: N,
        useDeferredValue: N,
        useTransition: N,
        useMutableSource: N,
        useSyncExternalStore: N,
        useId: N,
        unstable_isNewReconciler: !1
    }, Se = {
        readContext: Pd,
        useCallback: function(a, b) {
            Xe().memoizedState = [
                a,
                void 0 === b ? null : b
            ];
            return a;
        },
        useContext: Pd,
        useEffect: qf,
        useImperativeHandle: function(a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([
                a
            ]) : null;
            return of(4194308, 4, tf.bind(null, b, a), c);
        },
        useLayoutEffect: function(a, b) {
            return of(4194308, 4, a, b);
        },
        useInsertionEffect: function(a, b) {
            return of(4, 2, a, b);
        },
        useMemo: function(a, b) {
            var c = Xe();
            b = void 0 === b ? null : b;
            a = a();
            c.memoizedState = [
                a,
                b
            ];
            return a;
        },
        useReducer: function(a, b, c) {
            var d = Xe();
            b = void 0 !== c ? c(b) : b;
            d.memoizedState = d.baseState = b;
            a = {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: a,
                lastRenderedState: b
            };
            d.queue = a;
            a = a.dispatch = Bf.bind(null, K, a);
            return [
                d.memoizedState,
                a
            ];
        },
        useRef: function(a) {
            var b = Xe();
            a = {
                current: a
            };
            return b.memoizedState = a;
        },
        useState: lf,
        useDebugValue: vf,
        useDeferredValue: function(a) {
            return Xe().memoizedState = a;
        },
        useTransition: function() {
            var a = lf(!1), b = a[0];
            a = zf.bind(null, a[1]);
            Xe().memoizedState = a;
            return [
                b,
                a
            ];
        },
        useMutableSource: function() {},
        useSyncExternalStore: function(a, b, c) {
            var d = K, e = Xe();
            if (F) {
                if (void 0 === c) throw Error(m(407));
                c = c();
            } else {
                c = b();
                if (null === O) throw Error(m(349));
                0 !== (Le & 30) || hf(d, b, c);
            }
            e.memoizedState = c;
            var f = {
                value: c,
                getSnapshot: b
            };
            e.queue = f;
            qf(ef.bind(null, d, f, a), [
                a
            ]);
            d.flags |= 2048;
            ff(9, gf.bind(null, d, f, c, b), void 0, null);
            return c;
        },
        useId: function() {
            var a = Xe(), b = O.identifierPrefix;
            if (F) {
                var c = jd;
                var d = id;
                c = (d & ~(1 << 32 - tc(d) - 1)).toString(32) + c;
                b = ":" + b + "R" + c;
                c = Oe++;
                0 < c && (b += "H" + c.toString(32));
                b += ":";
            } else c = Pe++, b = ":" + b + "r" + c.toString(32) + ":";
            return a.memoizedState = b;
        },
        unstable_isNewReconciler: !1
    }, Te = {
        readContext: Pd,
        useCallback: wf,
        useContext: Pd,
        useEffect: df,
        useImperativeHandle: uf,
        useInsertionEffect: rf,
        useLayoutEffect: sf,
        useMemo: xf,
        useReducer: $e,
        useRef: nf,
        useState: function() {
            return $e(Ze);
        },
        useDebugValue: vf,
        useDeferredValue: function(a) {
            var b = Ye();
            return yf(b, L.memoizedState, a);
        },
        useTransition: function() {
            var a = $e(Ze)[0], b = Ye().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: bf,
        useSyncExternalStore: cf,
        useId: Af,
        unstable_isNewReconciler: !1
    }, Ue = {
        readContext: Pd,
        useCallback: wf,
        useContext: Pd,
        useEffect: df,
        useImperativeHandle: uf,
        useInsertionEffect: rf,
        useLayoutEffect: sf,
        useMemo: xf,
        useReducer: af,
        useRef: nf,
        useState: function() {
            return af(Ze);
        },
        useDebugValue: vf,
        useDeferredValue: function(a) {
            var b = Ye();
            return null === L ? b.memoizedState = a : yf(b, L.memoizedState, a);
        },
        useTransition: function() {
            var a = af(Ze)[0], b = Ye().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: bf,
        useSyncExternalStore: cf,
        useId: Af,
        unstable_isNewReconciler: !1
    };
    function Ff(a, b) {
        try {
            var c = "", d = b;
            do c += Ed(d), d = d.return;
            while (d);
            var e = c;
        } catch (f) {
            e = "\nError generating stack: " + f.message + "\n" + f.stack;
        }
        return {
            value: a,
            source: b,
            stack: e,
            digest: null
        };
    }
    function Gf(a, b, c) {
        return {
            value: a,
            source: null,
            stack: null != c ? c : null,
            digest: null != b ? b : null
        };
    }
    function Hf(a, b) {
        try {
            console.error(b.value);
        } catch (c) {
            setTimeout(function() {
                throw c;
            });
        }
    }
    var If = "function" === typeof WeakMap ? WeakMap : Map;
    function Jf(a, b, c) {
        c = Xd(-1, c);
        c.tag = 3;
        c.payload = {
            element: null
        };
        var d = b.value;
        c.callback = function() {
            Kf || (Kf = !0, Lf = d);
            Hf(a, b);
        };
        return c;
    }
    function Mf(a, b, c) {
        c = Xd(-1, c);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ("function" === typeof d) {
            var e = b.value;
            c.payload = function() {
                return d(e);
            };
            c.callback = function() {
                Hf(a, b);
            };
        }
        var f = a.stateNode;
        null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
            Hf(a, b);
            "function" !== typeof d && (null === Nf ? Nf = new Set([
                this
            ]) : Nf.add(this));
            var c = b.stack;
            this.componentDidCatch(b.value, {
                componentStack: null !== c ? c : ""
            });
        });
        return c;
    }
    function Of(a, b, c) {
        var d = a.pingCache;
        if (null === d) {
            d = a.pingCache = new If;
            var e = new Set;
            d.set(b, e);
        } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
        e.has(c) || (e.add(c), a = Pf.bind(null, a, b, c), b.then(a, a));
    }
    function Qf(a) {
        do {
            var b;
            if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
            if (b) return a;
            a = a.return;
        }while (null !== a);
        return null;
    }
    function Rf(a, b, c, d, e) {
        if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = Xd(-1, 1), b.tag = 2, Yd(c, b, 1))), c.lanes |= 1), a;
        a.flags |= 65536;
        a.lanes = e;
        return a;
    }
    var Sf = da.ReactCurrentOwner, G = !1;
    function P(a, b, c, d) {
        b.child = null === a ? we(b, null, c, d) : ve(b, a.child, c, d);
    }
    function Tf(a, b, c, d, e) {
        c = c.render;
        var f = b.ref;
        Od(b, e);
        d = Re(a, b, c, d, f, e);
        c = We();
        if (null !== a && !G) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Uf(a, b, e);
        F && c && md(b);
        b.flags |= 1;
        P(a, b, d, e);
        return b.child;
    }
    function Vf(a, b, c, d, e) {
        if (null === a) {
            var f = c.type;
            if ("function" === typeof f && !Wf(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, Xf(a, b, f, d, e);
            a = se(c.type, null, d, b, b.mode, e);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        f = a.child;
        if (0 === (a.lanes & e)) {
            var g = f.memoizedProps;
            c = c.compare;
            c = null !== c ? c : Dd;
            if (c(g, d) && a.ref === b.ref) return Uf(a, b, e);
        }
        b.flags |= 1;
        a = qe(f, d);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    function Xf(a, b, c, d, e) {
        if (null !== a) {
            var f = a.memoizedProps;
            if (Dd(f, d) && a.ref === b.ref) {
                if (G = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (G = !0);
                else return b.lanes = a.lanes, Uf(a, b, e);
            }
        }
        return Yf(a, b, c, d, e);
    }
    function Zf(a, b, c) {
        var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
        if ("hidden" === d.mode) {
            if (0 === (b.mode & 1)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            }, v($f, ag), ag |= c;
            else {
                if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                    baseLanes: a,
                    cachePool: null,
                    transitions: null
                }, b.updateQueue = null, v($f, ag), ag |= a, null;
                b.memoizedState = {
                    baseLanes: 0,
                    cachePool: null,
                    transitions: null
                };
                d = null !== f ? f.baseLanes : c;
                v($f, ag);
                ag |= d;
            }
        } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, v($f, ag), ag |= d;
        P(a, b, e, c);
        return b.child;
    }
    function bg(a, b) {
        var c = b.ref;
        if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
    }
    function Yf(a, b, c, d, e) {
        var f = A(c) ? kc : x.current;
        f = lc(b, f);
        Od(b, e);
        c = Re(a, b, c, d, f, e);
        d = We();
        if (null !== a && !G) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Uf(a, b, e);
        F && d && md(b);
        b.flags |= 1;
        P(a, b, c, e);
        return b.child;
    }
    function cg(a, b, c, d, e) {
        if (A(c)) {
            var f = !0;
            pc(b);
        } else f = !1;
        Od(b, e);
        if (null === b.stateNode) dg(a, b), je(b, c, d), le(b, c, d, e), d = !0;
        else if (null === a) {
            var g = b.stateNode, h = b.memoizedProps;
            g.props = h;
            var k = g.context, l = c.contextType;
            "object" === typeof l && null !== l ? l = Pd(l) : (l = A(c) ? kc : x.current, l = lc(b, l));
            var n = c.getDerivedStateFromProps, t = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
            t || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && ke(b, g, d, l);
            Ud = !1;
            var p = b.memoizedState;
            g.state = p;
            ae(b, d, g, e);
            k = b.memoizedState;
            h !== d || p !== k || z.current || Ud ? ("function" === typeof n && (ee(b, c, n, d), k = b.memoizedState), (h = Ud || ie(b, c, h, d, p, k, l)) ? (t || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
        } else {
            g = b.stateNode;
            Wd(a, b);
            h = b.memoizedProps;
            l = b.type === b.elementType ? h : Fd(b.type, h);
            g.props = l;
            t = b.pendingProps;
            p = g.context;
            k = c.contextType;
            "object" === typeof k && null !== k ? k = Pd(k) : (k = A(c) ? kc : x.current, k = lc(b, k));
            var B = c.getDerivedStateFromProps;
            (n = "function" === typeof B || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== t || p !== k) && ke(b, g, d, k);
            Ud = !1;
            p = b.memoizedState;
            g.state = p;
            ae(b, d, g, e);
            var w = b.memoizedState;
            h !== t || p !== w || z.current || Ud ? ("function" === typeof B && (ee(b, c, B, d), w = b.memoizedState), (l = Ud || ie(b, c, l, d, p, w, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, w, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, w, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = w), g.props = d, g.state = w, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 1024), d = !1);
        }
        return eg(a, b, c, d, f, e);
    }
    function eg(a, b, c, d, e, f) {
        bg(a, b);
        var g = 0 !== (b.flags & 128);
        if (!d && !g) return e && rc(b, c, !1), Uf(a, b, f);
        d = b.stateNode;
        Sf.current = b;
        var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
        b.flags |= 1;
        null !== a && g ? (b.child = ve(b, a.child, null, f), b.child = ve(b, null, h, f)) : P(a, b, h, f);
        b.memoizedState = d.state;
        e && rc(b, c, !0);
        return b.child;
    }
    function fg(a) {
        var b = a.stateNode;
        b.pendingContext ? nc(a, b.pendingContext, b.pendingContext !== b.context) : b.context && nc(a, b.context, !1);
        Ce(a, b.containerInfo);
    }
    function gg(a, b, c, d, e) {
        Ad();
        Bd(e);
        b.flags |= 256;
        P(a, b, c, d);
        return b.child;
    }
    var hg = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0
    };
    function ig(a) {
        return {
            baseLanes: a,
            cachePool: null,
            transitions: null
        };
    }
    function jg(a, b, c) {
        var d = b.pendingProps, e = J.current, f = !1, g = 0 !== (b.flags & 128), h;
        (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
        if (h) f = !0, b.flags &= -129;
        else if (null === a || null !== a.memoizedState) e |= 1;
        v(J, e & 1);
        if (null === a) {
            wd(b);
            a = b.memoizedState;
            if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : Kb(a) ? b.lanes = 8 : b.lanes = 1073741824, null;
            g = d.children;
            a = d.fallback;
            return f ? (d = b.mode, f = b.child, g = {
                mode: "hidden",
                children: g
            }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = kg(g, d, 0, null), a = ue(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = ig(c), b.memoizedState = hg, a) : lg(b, g);
        }
        e = a.memoizedState;
        if (null !== e && (h = e.dehydrated, null !== h)) return mg(a, b, g, d, h, e, c);
        if (f) {
            f = d.fallback;
            g = b.mode;
            e = a.child;
            h = e.sibling;
            var k = {
                mode: "hidden",
                children: d.children
            };
            0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = qe(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
            null !== h ? f = qe(h, f) : (f = ue(f, g, c, null), f.flags |= 2);
            f.return = b;
            d.return = b;
            d.sibling = f;
            b.child = d;
            d = f;
            f = b.child;
            g = a.child.memoizedState;
            g = null === g ? ig(c) : {
                baseLanes: g.baseLanes | c,
                cachePool: null,
                transitions: g.transitions
            };
            f.memoizedState = g;
            f.childLanes = a.childLanes & ~c;
            b.memoizedState = hg;
            return d;
        }
        f = a.child;
        a = f.sibling;
        d = qe(f, {
            mode: "visible",
            children: d.children
        });
        0 === (b.mode & 1) && (d.lanes = c);
        d.return = b;
        d.sibling = null;
        null !== a && (c = b.deletions, null === c ? (b.deletions = [
            a
        ], b.flags |= 16) : c.push(a));
        b.child = d;
        b.memoizedState = null;
        return d;
    }
    function lg(a, b) {
        b = kg({
            mode: "visible",
            children: b
        }, a.mode, 0, null);
        b.return = a;
        return a.child = b;
    }
    function ng(a, b, c, d) {
        null !== d && Bd(d);
        ve(b, a.child, null, c);
        a = lg(b, b.pendingProps.children);
        a.flags |= 2;
        b.memoizedState = null;
        return a;
    }
    function mg(a, b, c, d, e, f, g) {
        if (c) {
            if (b.flags & 256) return b.flags &= -257, d = Gf(Error(m(422))), ng(a, b, g, d);
            if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
            f = d.fallback;
            e = b.mode;
            d = kg({
                mode: "visible",
                children: d.children
            }, e, 0, null);
            f = ue(f, e, g, null);
            f.flags |= 2;
            d.return = b;
            f.return = b;
            d.sibling = f;
            b.child = d;
            0 !== (b.mode & 1) && ve(b, a.child, null, g);
            b.child.memoizedState = ig(g);
            b.memoizedState = hg;
            return f;
        }
        if (0 === (b.mode & 1)) return ng(a, b, g, null);
        if (Kb(e)) return d = Lb(e).digest, f = Error(m(419)), d = Gf(f, d, void 0), ng(a, b, g, d);
        c = 0 !== (g & a.childLanes);
        if (G || c) {
            d = O;
            if (null !== d) {
                switch(g & -g){
                    case 4:
                        e = 2;
                        break;
                    case 16:
                        e = 8;
                        break;
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                        e = 32;
                        break;
                    case 536870912:
                        e = 268435456;
                        break;
                    default:
                        e = 0;
                }
                e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
                0 !== e && e !== f.retryLane && (f.retryLane = e, Td(a, e), ge(d, a, e, -1));
            }
            og();
            d = Gf(Error(m(421)));
            return ng(a, b, g, d);
        }
        if (Jb(e)) return b.flags |= 128, b.child = a.child, b = pg.bind(null, a), Mb(e, b), null;
        a = f.treeContext;
        Va && (pd = Qb(e), od = b, F = !0, rd = null, qd = !1, null !== a && (fd[gd++] = id, fd[gd++] = jd, fd[gd++] = hd, id = a.id, jd = a.overflow, hd = b));
        b = lg(b, d.children);
        b.flags |= 4096;
        return b;
    }
    function qg(a, b, c) {
        a.lanes |= b;
        var d = a.alternate;
        null !== d && (d.lanes |= b);
        Nd(a.return, b, c);
    }
    function rg(a, b, c, d, e) {
        var f = a.memoizedState;
        null === f ? a.memoizedState = {
            isBackwards: b,
            rendering: null,
            renderingStartTime: 0,
            last: d,
            tail: c,
            tailMode: e
        } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
    }
    function sg(a, b, c) {
        var d = b.pendingProps, e = d.revealOrder, f = d.tail;
        P(a, b, d.children, c);
        d = J.current;
        if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
        else {
            if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
                if (13 === a.tag) null !== a.memoizedState && qg(a, c, b);
                else if (19 === a.tag) qg(a, c, b);
                else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === b) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === b) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            d &= 1;
        }
        v(J, d);
        if (0 === (b.mode & 1)) b.memoizedState = null;
        else switch(e){
            case "forwards":
                c = b.child;
                for(e = null; null !== c;)a = c.alternate, null !== a && null === Ge(a) && (e = c), c = c.sibling;
                c = e;
                null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                rg(b, !1, e, c, f);
                break;
            case "backwards":
                c = null;
                e = b.child;
                for(b.child = null; null !== e;){
                    a = e.alternate;
                    if (null !== a && null === Ge(a)) {
                        b.child = e;
                        break;
                    }
                    a = e.sibling;
                    e.sibling = c;
                    c = e;
                    e = a;
                }
                rg(b, !0, c, null, f);
                break;
            case "together":
                rg(b, !1, null, null, void 0);
                break;
            default:
                b.memoizedState = null;
        }
        return b.child;
    }
    function dg(a, b) {
        0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
    }
    function Uf(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        be |= b.lanes;
        if (0 === (c & b.childLanes)) return null;
        if (null !== a && b.child !== a.child) throw Error(m(153));
        if (null !== b.child) {
            a = b.child;
            c = qe(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = qe(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    function tg(a, b, c) {
        switch(b.tag){
            case 3:
                fg(b);
                Ad();
                break;
            case 5:
                Ee(b);
                break;
            case 1:
                A(b.type) && pc(b);
                break;
            case 4:
                Ce(b, b.stateNode.containerInfo);
                break;
            case 10:
                Ld(b, b.type._context, b.memoizedProps.value);
                break;
            case 13:
                var d = b.memoizedState;
                if (null !== d) {
                    if (null !== d.dehydrated) return v(J, J.current & 1), b.flags |= 128, null;
                    if (0 !== (c & b.child.childLanes)) return jg(a, b, c);
                    v(J, J.current & 1);
                    a = Uf(a, b, c);
                    return null !== a ? a.sibling : null;
                }
                v(J, J.current & 1);
                break;
            case 19:
                d = 0 !== (c & b.childLanes);
                if (0 !== (a.flags & 128)) {
                    if (d) return sg(a, b, c);
                    b.flags |= 128;
                }
                var e = b.memoizedState;
                null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                v(J, J.current);
                if (d) break;
                else return null;
            case 22:
            case 23:
                return b.lanes = 0, Zf(a, b, c);
        }
        return Uf(a, b, c);
    }
    function ug(a) {
        a.flags |= 4;
    }
    function vg(a, b) {
        if (null !== a && a.child === b.child) return !0;
        if (0 !== (b.flags & 16)) return !1;
        for(a = b.child; null !== a;){
            if (0 !== (a.flags & 12854) || 0 !== (a.subtreeFlags & 12854)) return !1;
            a = a.sibling;
        }
        return !0;
    }
    var wg, xg, yg, zg;
    if (Ta) wg = function(a, b) {
        for(var c = b.child; null !== c;){
            if (5 === c.tag || 6 === c.tag) Ka(a, c.stateNode);
            else if (4 !== c.tag && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }, xg = function() {}, yg = function(a, b, c, d, e) {
        a = a.memoizedProps;
        if (a !== d) {
            var f = b.stateNode, g = Be(ye.current);
            c = Ma(f, c, a, d, e, g);
            (b.updateQueue = c) && ug(b);
        }
    }, zg = function(a, b, c, d) {
        c !== d && ug(b);
    };
    else if (Ua) {
        wg = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Eb(f, e.type, e.memoizedProps, e));
                    Ka(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Fb(f, e.memoizedProps, e)), Ka(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), wg(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        var Ag = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Eb(f, e.type, e.memoizedProps, e));
                    Ab(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Fb(f, e.memoizedProps, e)), Ab(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), Ag(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        xg = function(a, b) {
            var c = b.stateNode;
            if (!vg(a, b)) {
                a = c.containerInfo;
                var d = zb(a);
                Ag(d, b, !1, !1);
                c.pendingChildren = d;
                ug(b);
                Bb(a, d);
            }
        };
        yg = function(a, b, c, d, e) {
            var f = a.stateNode, g = a.memoizedProps;
            if ((a = vg(a, b)) && g === d) b.stateNode = f;
            else {
                var h = b.stateNode, k = Be(ye.current), l = null;
                g !== d && (l = Ma(h, c, g, d, e, k));
                a && null === l ? b.stateNode = f : (f = yb(f, l, c, g, d, b, a, h), La(f, c, d, e, k) && ug(b), b.stateNode = f, a ? ug(b) : wg(f, b, !1, !1));
            }
        };
        zg = function(a, b, c, d) {
            c !== d ? (a = Be(Ae.current), c = Be(ye.current), b.stateNode = Oa(d, a, c, b), ug(b)) : b.stateNode = a.stateNode;
        };
    } else xg = function() {}, yg = function() {}, zg = function() {};
    function Bg(a, b) {
        if (!F) switch(a.tailMode){
            case "hidden":
                b = a.tail;
                for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                null === c ? a.tail = null : c.sibling = null;
                break;
            case "collapsed":
                c = a.tail;
                for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
        }
    }
    function Q(a) {
        var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
        if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
        else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
        a.subtreeFlags |= d;
        a.childLanes = c;
        return b;
    }
    function Cg(a, b, c) {
        var d = b.pendingProps;
        nd(b);
        switch(b.tag){
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return Q(b), null;
            case 1:
                return A(b.type) && mc(), Q(b), null;
            case 3:
                c = b.stateNode;
                De();
                q(z);
                q(x);
                Ie();
                c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null);
                if (null === a || null === a.child) yd(b) ? ug(b) : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== rd && (Dg(rd), rd = null));
                xg(a, b);
                Q(b);
                return null;
            case 5:
                Fe(b);
                c = Be(Ae.current);
                var e = b.type;
                if (null !== a && null != b.stateNode) yg(a, b, e, d, c), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                else {
                    if (!d) {
                        if (null === b.stateNode) throw Error(m(166));
                        Q(b);
                        return null;
                    }
                    a = Be(ye.current);
                    if (yd(b)) {
                        if (!Va) throw Error(m(175));
                        a = Rb(b.stateNode, b.type, b.memoizedProps, c, a, b, !qd);
                        b.updateQueue = a;
                        null !== a && ug(b);
                    } else {
                        var f = Ja(e, d, c, a, b);
                        wg(f, b, !1, !1);
                        b.stateNode = f;
                        La(f, e, d, c, a) && ug(b);
                    }
                    null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                }
                Q(b);
                return null;
            case 6:
                if (a && null != b.stateNode) zg(a, b, a.memoizedProps, d);
                else {
                    if ("string" !== typeof d && null === b.stateNode) throw Error(m(166));
                    a = Be(Ae.current);
                    c = Be(ye.current);
                    if (yd(b)) {
                        if (!Va) throw Error(m(176));
                        a = b.stateNode;
                        c = b.memoizedProps;
                        if (d = Sb(a, c, b, !qd)) {
                            if (e = od, null !== e) switch(e.tag){
                                case 3:
                                    $b(e.stateNode.containerInfo, a, c, 0 !== (e.mode & 1));
                                    break;
                                case 5:
                                    ac(e.type, e.memoizedProps, e.stateNode, a, c, 0 !== (e.mode & 1));
                            }
                        }
                        d && ug(b);
                    } else b.stateNode = Oa(d, a, c, b);
                }
                Q(b);
                return null;
            case 13:
                q(J);
                d = b.memoizedState;
                if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                    if (F && null !== pd && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) zd(), Ad(), b.flags |= 98560, e = !1;
                    else if (e = yd(b), null !== d && null !== d.dehydrated) {
                        if (null === a) {
                            if (!e) throw Error(m(318));
                            if (!Va) throw Error(m(344));
                            e = b.memoizedState;
                            e = null !== e ? e.dehydrated : null;
                            if (!e) throw Error(m(317));
                            Tb(e, b);
                        } else Ad(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                        Q(b);
                        e = !1;
                    } else null !== rd && (Dg(rd), rd = null), e = !0;
                    if (!e) return b.flags & 65536 ? b : null;
                }
                if (0 !== (b.flags & 128)) return b.lanes = c, b;
                c = null !== d;
                c !== (null !== a && null !== a.memoizedState) && c && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (J.current & 1) ? 0 === R && (R = 3) : og()));
                null !== b.updateQueue && (b.flags |= 4);
                Q(b);
                return null;
            case 4:
                return De(), xg(a, b), null === a && Xa(b.stateNode.containerInfo), Q(b), null;
            case 10:
                return Md(b.type._context), Q(b), null;
            case 17:
                return A(b.type) && mc(), Q(b), null;
            case 19:
                q(J);
                e = b.memoizedState;
                if (null === e) return Q(b), null;
                d = 0 !== (b.flags & 128);
                f = e.rendering;
                if (null === f) {
                    if (d) Bg(e, !1);
                    else {
                        if (0 !== R || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                            f = Ge(a);
                            if (null !== f) {
                                b.flags |= 128;
                                Bg(e, !1);
                                a = f.updateQueue;
                                null !== a && (b.updateQueue = a, b.flags |= 4);
                                b.subtreeFlags = 0;
                                a = c;
                                for(c = b.child; null !== c;)d = c, e = a, d.flags &= 14680066, f = d.alternate, null === f ? (d.childLanes = 0, d.lanes = e, d.child = null, d.subtreeFlags = 0, d.memoizedProps = null, d.memoizedState = null, d.updateQueue = null, d.dependencies = null, d.stateNode = null) : (d.childLanes = f.childLanes, d.lanes = f.lanes, d.child = f.child, d.subtreeFlags = 0, d.deletions = null, d.memoizedProps = f.memoizedProps, d.memoizedState = f.memoizedState, d.updateQueue = f.updateQueue, d.type = f.type, e = f.dependencies, d.dependencies = null === e ? null : {
                                    lanes: e.lanes,
                                    firstContext: e.firstContext
                                }), c = c.sibling;
                                v(J, J.current & 1 | 2);
                                return b.child;
                            }
                            a = a.sibling;
                        }
                        null !== e.tail && D() > Eg && (b.flags |= 128, d = !0, Bg(e, !1), b.lanes = 4194304);
                    }
                } else {
                    if (!d) {
                        if (a = Ge(f), null !== a) {
                            if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), Bg(e, !0), null === e.tail && "hidden" === e.tailMode && !f.alternate && !F) return Q(b), null;
                        } else 2 * D() - e.renderingStartTime > Eg && 1073741824 !== c && (b.flags |= 128, d = !0, Bg(e, !1), b.lanes = 4194304);
                    }
                    e.isBackwards ? (f.sibling = b.child, b.child = f) : (a = e.last, null !== a ? a.sibling = f : b.child = f, e.last = f);
                }
                if (null !== e.tail) return b = e.tail, e.rendering = b, e.tail = b.sibling, e.renderingStartTime = D(), b.sibling = null, a = J.current, v(J, d ? a & 1 | 2 : a & 1), b;
                Q(b);
                return null;
            case 22:
            case 23:
                return Fg(), c = null !== b.memoizedState, null !== a && null !== a.memoizedState !== c && (b.flags |= 8192), c && 0 !== (b.mode & 1) ? 0 !== (ag & 1073741824) && (Q(b), Ta && b.subtreeFlags & 6 && (b.flags |= 8192)) : Q(b), null;
            case 24:
                return null;
            case 25:
                return null;
        }
        throw Error(m(156, b.tag));
    }
    function Gg(a, b) {
        nd(b);
        switch(b.tag){
            case 1:
                return A(b.type) && mc(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 3:
                return De(), q(z), q(x), Ie(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
            case 5:
                return Fe(b), null;
            case 13:
                q(J);
                a = b.memoizedState;
                if (null !== a && null !== a.dehydrated) {
                    if (null === b.alternate) throw Error(m(340));
                    Ad();
                }
                a = b.flags;
                return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 19:
                return q(J), null;
            case 4:
                return De(), null;
            case 10:
                return Md(b.type._context), null;
            case 22:
            case 23:
                return Fg(), null;
            case 24:
                return null;
            default:
                return null;
        }
    }
    var Hg = !1, S = !1, Ig = "function" === typeof WeakSet ? WeakSet : Set, T = null;
    function Jg(a, b) {
        var c = a.ref;
        if (null !== c) {
            if ("function" === typeof c) try {
                c(null);
            } catch (d) {
                U(a, b, d);
            }
            else c.current = null;
        }
    }
    function Kg(a, b, c) {
        try {
            c();
        } catch (d) {
            U(a, b, d);
        }
    }
    var Lg = !1;
    function Mg(a, b) {
        Ha(a.containerInfo);
        for(T = b; null !== T;)if (a = T, b = a.child, 0 !== (a.subtreeFlags & 1028) && null !== b) b.return = a, T = b;
        else for(; null !== T;){
            a = T;
            try {
                var c = a.alternate;
                if (0 !== (a.flags & 1024)) switch(a.tag){
                    case 0:
                    case 11:
                    case 15:
                        break;
                    case 1:
                        if (null !== c) {
                            var d = c.memoizedProps, e = c.memoizedState, f = a.stateNode, g = f.getSnapshotBeforeUpdate(a.elementType === a.type ? d : Fd(a.type, d), e);
                            f.__reactInternalSnapshotBeforeUpdate = g;
                        }
                        break;
                    case 3:
                        Ta && xb(a.stateNode.containerInfo);
                        break;
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        break;
                    default:
                        throw Error(m(163));
                }
            } catch (h) {
                U(a, a.return, h);
            }
            b = a.sibling;
            if (null !== b) {
                b.return = a.return;
                T = b;
                break;
            }
            T = a.return;
        }
        c = Lg;
        Lg = !1;
        return c;
    }
    function Ng(a, b, c) {
        var d = b.updateQueue;
        d = null !== d ? d.lastEffect : null;
        if (null !== d) {
            var e = d = d.next;
            do {
                if ((e.tag & a) === a) {
                    var f = e.destroy;
                    e.destroy = void 0;
                    void 0 !== f && Kg(b, c, f);
                }
                e = e.next;
            }while (e !== d);
        }
    }
    function Og(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
            var c = b = b.next;
            do {
                if ((c.tag & a) === a) {
                    var d = c.create;
                    c.destroy = d();
                }
                c = c.next;
            }while (c !== b);
        }
    }
    function Pg(a) {
        var b = a.ref;
        if (null !== b) {
            var c = a.stateNode;
            switch(a.tag){
                case 5:
                    a = Ea(c);
                    break;
                default:
                    a = c;
            }
            "function" === typeof b ? b(a) : b.current = a;
        }
    }
    function Qg(a) {
        var b = a.alternate;
        null !== b && (a.alternate = null, Qg(b));
        a.child = null;
        a.deletions = null;
        a.sibling = null;
        5 === a.tag && (b = a.stateNode, null !== b && Za(b));
        a.stateNode = null;
        a.return = null;
        a.dependencies = null;
        a.memoizedProps = null;
        a.memoizedState = null;
        a.pendingProps = null;
        a.stateNode = null;
        a.updateQueue = null;
    }
    function Rg(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }
    function Sg(a) {
        a: for(;;){
            for(; null === a.sibling;){
                if (null === a.return || Rg(a.return)) return null;
                a = a.return;
            }
            a.sibling.return = a.return;
            for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
                if (a.flags & 2) continue a;
                if (null === a.child || 4 === a.tag) continue a;
                else a.child.return = a, a = a.child;
            }
            if (!(a.flags & 2)) return a.stateNode;
        }
    }
    function Tg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? pb(c, a, b) : kb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Tg(a, b, c), a = a.sibling; null !== a;)Tg(a, b, c), a = a.sibling;
    }
    function Ug(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? ob(c, a, b) : jb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Ug(a, b, c), a = a.sibling; null !== a;)Ug(a, b, c), a = a.sibling;
    }
    var V = null, Vg = !1;
    function Wg(a, b, c) {
        for(c = c.child; null !== c;)Xg(a, b, c), c = c.sibling;
    }
    function Xg(a, b, c) {
        if (Sc && "function" === typeof Sc.onCommitFiberUnmount) try {
            Sc.onCommitFiberUnmount(Rc, c);
        } catch (h) {}
        switch(c.tag){
            case 5:
                S || Jg(c, b);
            case 6:
                if (Ta) {
                    var d = V, e = Vg;
                    V = null;
                    Wg(a, b, c);
                    V = d;
                    Vg = e;
                    null !== V && (Vg ? rb(V, c.stateNode) : qb(V, c.stateNode));
                } else Wg(a, b, c);
                break;
            case 18:
                Ta && null !== V && (Vg ? Yb(V, c.stateNode) : Xb(V, c.stateNode));
                break;
            case 4:
                Ta ? (d = V, e = Vg, V = c.stateNode.containerInfo, Vg = !0, Wg(a, b, c), V = d, Vg = e) : (Ua && (d = c.stateNode.containerInfo, e = zb(d), Cb(d, e)), Wg(a, b, c));
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                if (!S && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                    e = d = d.next;
                    do {
                        var f = e, g = f.destroy;
                        f = f.tag;
                        void 0 !== g && (0 !== (f & 2) ? Kg(c, b, g) : 0 !== (f & 4) && Kg(c, b, g));
                        e = e.next;
                    }while (e !== d);
                }
                Wg(a, b, c);
                break;
            case 1:
                if (!S && (Jg(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                    d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
                } catch (h) {
                    U(c, b, h);
                }
                Wg(a, b, c);
                break;
            case 21:
                Wg(a, b, c);
                break;
            case 22:
                c.mode & 1 ? (S = (d = S) || null !== c.memoizedState, Wg(a, b, c), S = d) : Wg(a, b, c);
                break;
            default:
                Wg(a, b, c);
        }
    }
    function Yg(a) {
        var b = a.updateQueue;
        if (null !== b) {
            a.updateQueue = null;
            var c = a.stateNode;
            null === c && (c = a.stateNode = new Ig);
            b.forEach(function(b) {
                var d = Zg.bind(null, a, b);
                c.has(b) || (c.add(b), b.then(d, d));
            });
        }
    }
    function $g(a, b) {
        var c = b.deletions;
        if (null !== c) for(var d = 0; d < c.length; d++){
            var e = c[d];
            try {
                var f = a, g = b;
                if (Ta) {
                    var h = g;
                    a: for(; null !== h;){
                        switch(h.tag){
                            case 5:
                                V = h.stateNode;
                                Vg = !1;
                                break a;
                            case 3:
                                V = h.stateNode.containerInfo;
                                Vg = !0;
                                break a;
                            case 4:
                                V = h.stateNode.containerInfo;
                                Vg = !0;
                                break a;
                        }
                        h = h.return;
                    }
                    if (null === V) throw Error(m(160));
                    Xg(f, g, e);
                    V = null;
                    Vg = !1;
                } else Xg(f, g, e);
                var k = e.alternate;
                null !== k && (k.return = null);
                e.return = null;
            } catch (l) {
                U(e, b, l);
            }
        }
        if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)ah(b, a), b = b.sibling;
    }
    function ah(a, b) {
        var c = a.alternate, d = a.flags;
        switch(a.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $g(b, a);
                bh(a);
                if (d & 4) {
                    try {
                        Ng(3, a, a.return), Og(3, a);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                    try {
                        Ng(5, a, a.return);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                }
                break;
            case 1:
                $g(b, a);
                bh(a);
                d & 512 && null !== c && Jg(c, c.return);
                break;
            case 5:
                $g(b, a);
                bh(a);
                d & 512 && null !== c && Jg(c, c.return);
                if (Ta) {
                    if (a.flags & 32) {
                        var e = a.stateNode;
                        try {
                            sb(e);
                        } catch (p) {
                            U(a, a.return, p);
                        }
                    }
                    if (d & 4 && (e = a.stateNode, null != e)) {
                        var f = a.memoizedProps;
                        c = null !== c ? c.memoizedProps : f;
                        d = a.type;
                        b = a.updateQueue;
                        a.updateQueue = null;
                        if (null !== b) try {
                            nb(e, b, d, c, f, a);
                        } catch (p) {
                            U(a, a.return, p);
                        }
                    }
                }
                break;
            case 6:
                $g(b, a);
                bh(a);
                if (d & 4 && Ta) {
                    if (null === a.stateNode) throw Error(m(162));
                    e = a.stateNode;
                    f = a.memoizedProps;
                    c = null !== c ? c.memoizedProps : f;
                    try {
                        lb(e, c, f);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                }
                break;
            case 3:
                $g(b, a);
                bh(a);
                if (d & 4) {
                    if (Ta && Va && null !== c && c.memoizedState.isDehydrated) try {
                        Vb(b.containerInfo);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                    if (Ua) {
                        e = b.containerInfo;
                        f = b.pendingChildren;
                        try {
                            Cb(e, f);
                        } catch (p) {
                            U(a, a.return, p);
                        }
                    }
                }
                break;
            case 4:
                $g(b, a);
                bh(a);
                if (d & 4 && Ua) {
                    f = a.stateNode;
                    e = f.containerInfo;
                    f = f.pendingChildren;
                    try {
                        Cb(e, f);
                    } catch (p) {
                        U(a, a.return, p);
                    }
                }
                break;
            case 13:
                $g(b, a);
                bh(a);
                e = a.child;
                e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (ch = D()));
                d & 4 && Yg(a);
                break;
            case 22:
                var g = null !== c && null !== c.memoizedState;
                a.mode & 1 ? (S = (c = S) || g, $g(b, a), S = c) : $g(b, a);
                bh(a);
                if (d & 8192) {
                    c = null !== a.memoizedState;
                    if ((a.stateNode.isHidden = c) && !g && 0 !== (a.mode & 1)) for(T = a, d = a.child; null !== d;){
                        for(b = T = d; null !== T;){
                            g = T;
                            var h = g.child;
                            switch(g.tag){
                                case 0:
                                case 11:
                                case 14:
                                case 15:
                                    Ng(4, g, g.return);
                                    break;
                                case 1:
                                    Jg(g, g.return);
                                    var k = g.stateNode;
                                    if ("function" === typeof k.componentWillUnmount) {
                                        var l = g, n = g.return;
                                        try {
                                            var t = l;
                                            k.props = t.memoizedProps;
                                            k.state = t.memoizedState;
                                            k.componentWillUnmount();
                                        } catch (p) {
                                            U(l, n, p);
                                        }
                                    }
                                    break;
                                case 5:
                                    Jg(g, g.return);
                                    break;
                                case 22:
                                    if (null !== g.memoizedState) {
                                        dh(b);
                                        continue;
                                    }
                            }
                            null !== h ? (h.return = g, T = h) : dh(b);
                        }
                        d = d.sibling;
                    }
                    if (Ta) {
                        a: if (d = null, Ta) for(b = a;;){
                            if (5 === b.tag) {
                                if (null === d) {
                                    d = b;
                                    try {
                                        e = b.stateNode, c ? tb(e) : vb(b.stateNode, b.memoizedProps);
                                    } catch (p) {
                                        U(a, a.return, p);
                                    }
                                }
                            } else if (6 === b.tag) {
                                if (null === d) try {
                                    f = b.stateNode, c ? ub(f) : wb(f, b.memoizedProps);
                                } catch (p) {
                                    U(a, a.return, p);
                                }
                            } else if ((22 !== b.tag && 23 !== b.tag || null === b.memoizedState || b === a) && null !== b.child) {
                                b.child.return = b;
                                b = b.child;
                                continue;
                            }
                            if (b === a) break a;
                            for(; null === b.sibling;){
                                if (null === b.return || b.return === a) break a;
                                d === b && (d = null);
                                b = b.return;
                            }
                            d === b && (d = null);
                            b.sibling.return = b.return;
                            b = b.sibling;
                        }
                    }
                }
                break;
            case 19:
                $g(b, a);
                bh(a);
                d & 4 && Yg(a);
                break;
            case 21:
                break;
            default:
                $g(b, a), bh(a);
        }
    }
    function bh(a) {
        var b = a.flags;
        if (b & 2) {
            try {
                if (Ta) {
                    b: {
                        for(var c = a.return; null !== c;){
                            if (Rg(c)) {
                                var d = c;
                                break b;
                            }
                            c = c.return;
                        }
                        throw Error(m(160));
                    }
                    switch(d.tag){
                        case 5:
                            var e = d.stateNode;
                            d.flags & 32 && (sb(e), d.flags &= -33);
                            var f = Sg(a);
                            Ug(a, f, e);
                            break;
                        case 3:
                        case 4:
                            var g = d.stateNode.containerInfo, h = Sg(a);
                            Tg(a, h, g);
                            break;
                        default:
                            throw Error(m(161));
                    }
                }
            } catch (k) {
                U(a, a.return, k);
            }
            a.flags &= -3;
        }
        b & 4096 && (a.flags &= -4097);
    }
    function eh(a, b, c) {
        T = a;
        fh(a, b, c);
    }
    function fh(a, b, c) {
        for(var d = 0 !== (a.mode & 1); null !== T;){
            var e = T, f = e.child;
            if (22 === e.tag && d) {
                var g = null !== e.memoizedState || Hg;
                if (!g) {
                    var h = e.alternate, k = null !== h && null !== h.memoizedState || S;
                    h = Hg;
                    var l = S;
                    Hg = g;
                    if ((S = k) && !l) for(T = e; null !== T;)g = T, k = g.child, 22 === g.tag && null !== g.memoizedState ? gh(e) : null !== k ? (k.return = g, T = k) : gh(e);
                    for(; null !== f;)T = f, fh(f, b, c), f = f.sibling;
                    T = e;
                    Hg = h;
                    S = l;
                }
                hh(a, b, c);
            } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, T = f) : hh(a, b, c);
        }
    }
    function hh(a) {
        for(; null !== T;){
            var b = T;
            if (0 !== (b.flags & 8772)) {
                var c = b.alternate;
                try {
                    if (0 !== (b.flags & 8772)) switch(b.tag){
                        case 0:
                        case 11:
                        case 15:
                            S || Og(5, b);
                            break;
                        case 1:
                            var d = b.stateNode;
                            if (b.flags & 4 && !S) {
                                if (null === c) d.componentDidMount();
                                else {
                                    var e = b.elementType === b.type ? c.memoizedProps : Fd(b.type, c.memoizedProps);
                                    d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                                }
                            }
                            var f = b.updateQueue;
                            null !== f && ce(b, f, d);
                            break;
                        case 3:
                            var g = b.updateQueue;
                            if (null !== g) {
                                c = null;
                                if (null !== b.child) switch(b.child.tag){
                                    case 5:
                                        c = Ea(b.child.stateNode);
                                        break;
                                    case 1:
                                        c = b.child.stateNode;
                                }
                                ce(b, g, c);
                            }
                            break;
                        case 5:
                            var h = b.stateNode;
                            null === c && b.flags & 4 && mb(h, b.type, b.memoizedProps, b);
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                            if (Va && null === b.memoizedState) {
                                var k = b.alternate;
                                if (null !== k) {
                                    var l = k.memoizedState;
                                    if (null !== l) {
                                        var n = l.dehydrated;
                                        null !== n && Wb(n);
                                    }
                                }
                            }
                            break;
                        case 19:
                        case 17:
                        case 21:
                        case 22:
                        case 23:
                        case 25:
                            break;
                        default:
                            throw Error(m(163));
                    }
                    S || b.flags & 512 && Pg(b);
                } catch (t) {
                    U(b, b.return, t);
                }
            }
            if (b === a) {
                T = null;
                break;
            }
            c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                T = c;
                break;
            }
            T = b.return;
        }
    }
    function dh(a) {
        for(; null !== T;){
            var b = T;
            if (b === a) {
                T = null;
                break;
            }
            var c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                T = c;
                break;
            }
            T = b.return;
        }
    }
    function gh(a) {
        for(; null !== T;){
            var b = T;
            try {
                switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        var c = b.return;
                        try {
                            Og(4, b);
                        } catch (k) {
                            U(b, c, k);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if ("function" === typeof d.componentDidMount) {
                            var e = b.return;
                            try {
                                d.componentDidMount();
                            } catch (k) {
                                U(b, e, k);
                            }
                        }
                        var f = b.return;
                        try {
                            Pg(b);
                        } catch (k) {
                            U(b, f, k);
                        }
                        break;
                    case 5:
                        var g = b.return;
                        try {
                            Pg(b);
                        } catch (k) {
                            U(b, g, k);
                        }
                }
            } catch (k) {
                U(b, b.return, k);
            }
            if (b === a) {
                T = null;
                break;
            }
            var h = b.sibling;
            if (null !== h) {
                h.return = b.return;
                T = h;
                break;
            }
            T = b.return;
        }
    }
    var ih = 0, jh = 1, kh = 2, lh = 3, mh = 4;
    if ("function" === typeof Symbol && Symbol.for) {
        var nh = Symbol.for;
        ih = nh("selector.component");
        jh = nh("selector.has_pseudo_class");
        kh = nh("selector.role");
        lh = nh("selector.test_id");
        mh = nh("selector.text");
    }
    function oh(a) {
        var b = Wa(a);
        if (null != b) {
            if ("string" !== typeof b.memoizedProps["data-testname"]) throw Error(m(364));
            return b;
        }
        a = cb(a);
        if (null === a) throw Error(m(362));
        return a.stateNode.current;
    }
    function ph(a, b) {
        switch(b.$$typeof){
            case ih:
                if (a.type === b.value) return !0;
                break;
            case jh:
                a: {
                    b = b.value;
                    a = [
                        a,
                        0
                    ];
                    for(var c = 0; c < a.length;){
                        var d = a[c++], e = a[c++], f = b[e];
                        if (5 !== d.tag || !fb(d)) {
                            for(; null != f && ph(d, f);)e++, f = b[e];
                            if (e === b.length) {
                                b = !0;
                                break a;
                            } else for(d = d.child; null !== d;)a.push(d, e), d = d.sibling;
                        }
                    }
                    b = !1;
                }
                return b;
            case kh:
                if (5 === a.tag && gb(a.stateNode, b.value)) return !0;
                break;
            case mh:
                if (5 === a.tag || 6 === a.tag) {
                    if (a = eb(a), null !== a && 0 <= a.indexOf(b.value)) return !0;
                }
                break;
            case lh:
                if (5 === a.tag && (a = a.memoizedProps["data-testname"], "string" === typeof a && a.toLowerCase() === b.value.toLowerCase())) return !0;
                break;
            default:
                throw Error(m(365));
        }
        return !1;
    }
    function qh(a) {
        switch(a.$$typeof){
            case ih:
                return "<" + (ua(a.value) || "Unknown") + ">";
            case jh:
                return ":has(" + (qh(a) || "") + ")";
            case kh:
                return '[role="' + a.value + '"]';
            case mh:
                return '"' + a.value + '"';
            case lh:
                return '[data-testname="' + a.value + '"]';
            default:
                throw Error(m(365));
        }
    }
    function rh(a, b) {
        var c = [];
        a = [
            a,
            0
        ];
        for(var d = 0; d < a.length;){
            var e = a[d++], f = a[d++], g = b[f];
            if (5 !== e.tag || !fb(e)) {
                for(; null != g && ph(e, g);)f++, g = b[f];
                if (f === b.length) c.push(e);
                else for(e = e.child; null !== e;)a.push(e, f), e = e.sibling;
            }
        }
        return c;
    }
    function sh(a, b) {
        if (!bb) throw Error(m(363));
        a = oh(a);
        a = rh(a, b);
        b = [];
        a = Array.from(a);
        for(var c = 0; c < a.length;){
            var d = a[c++];
            if (5 === d.tag) fb(d) || b.push(d.stateNode);
            else for(d = d.child; null !== d;)a.push(d), d = d.sibling;
        }
        return b;
    }
    var th = Math.ceil, uh = da.ReactCurrentDispatcher, vh = da.ReactCurrentOwner, W = da.ReactCurrentBatchConfig, H = 0, O = null, X = null, Y = 0, ag = 0, $f = ic(0), R = 0, wh = null, be = 0, xh = 0, yh = 0, zh = null, Ah = null, ch = 0, Eg = Infinity, Bh = null;
    function Ch() {
        Eg = D() + 500;
    }
    var Kf = !1, Lf = null, Nf = null, Dh = !1, Eh = null, Fh = 0, Gh = 0, Hh = null, Ih = -1, Jh = 0;
    function I() {
        return 0 !== (H & 6) ? D() : -1 !== Ih ? Ih : Ih = D();
    }
    function fe(a) {
        if (0 === (a.mode & 1)) return 1;
        if (0 !== (H & 2) && 0 !== Y) return Y & -Y;
        if (null !== Cd.transition) return 0 === Jh && (Jh = Dc()), Jh;
        a = C;
        return 0 !== a ? a : Ya();
    }
    function ge(a, b, c, d) {
        if (50 < Gh) throw Gh = 0, Hh = null, Error(m(185));
        Fc(a, c, d);
        if (0 === (H & 2) || a !== O) a === O && (0 === (H & 2) && (xh |= c), 4 === R && Kh(a, Y)), Lh(a, d), 1 === c && 0 === H && 0 === (b.mode & 1) && (Ch(), Xc && ad());
    }
    function Lh(a, b) {
        var c = a.callbackNode;
        Bc(a, b);
        var d = zc(a, a === O ? Y : 0);
        if (0 === d) null !== c && Kc(c), a.callbackNode = null, a.callbackPriority = 0;
        else if (b = d & -d, a.callbackPriority !== b) {
            null != c && Kc(c);
            if (1 === b) 0 === a.tag ? $c(Mh.bind(null, a)) : Zc(Mh.bind(null, a)), $a ? ab(function() {
                0 === (H & 6) && ad();
            }) : Jc(Nc, ad), c = null;
            else {
                switch(Ic(d)){
                    case 1:
                        c = Nc;
                        break;
                    case 4:
                        c = Oc;
                        break;
                    case 16:
                        c = Pc;
                        break;
                    case 536870912:
                        c = Qc;
                        break;
                    default:
                        c = Pc;
                }
                c = Nh(c, Oh.bind(null, a));
            }
            a.callbackPriority = b;
            a.callbackNode = c;
        }
    }
    function Oh(a, b) {
        Ih = -1;
        Jh = 0;
        if (0 !== (H & 6)) throw Error(m(327));
        var c = a.callbackNode;
        if (Ph() && a.callbackNode !== c) return null;
        var d = zc(a, a === O ? Y : 0);
        if (0 === d) return null;
        if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Qh(a, d);
        else {
            b = d;
            var e = H;
            H |= 2;
            var f = Rh();
            if (O !== a || Y !== b) Bh = null, Ch(), Sh(a, b);
            for(;;)try {
                Th();
                break;
            } catch (h) {
                Uh(a, h);
            }
            Kd();
            uh.current = f;
            H = e;
            null !== X ? b = 0 : (O = null, Y = 0, b = R);
        }
        if (0 !== b) {
            2 === b && (e = Cc(a), 0 !== e && (d = e, b = Vh(a, e)));
            if (1 === b) throw c = wh, Sh(a, 0), Kh(a, d), Lh(a, D()), c;
            if (6 === b) Kh(a, d);
            else {
                e = a.current.alternate;
                if (0 === (d & 30) && !Wh(e) && (b = Qh(a, d), 2 === b && (f = Cc(a), 0 !== f && (d = f, b = Vh(a, f))), 1 === b)) throw c = wh, Sh(a, 0), Kh(a, d), Lh(a, D()), c;
                a.finishedWork = e;
                a.finishedLanes = d;
                switch(b){
                    case 0:
                    case 1:
                        throw Error(m(345));
                    case 2:
                        Xh(a, Ah, Bh);
                        break;
                    case 3:
                        Kh(a, d);
                        if ((d & 130023424) === d && (b = ch + 500 - D(), 10 < b)) {
                            if (0 !== zc(a, 0)) break;
                            e = a.suspendedLanes;
                            if ((e & d) !== d) {
                                I();
                                a.pingedLanes |= a.suspendedLanes & e;
                                break;
                            }
                            a.timeoutHandle = Pa(Xh.bind(null, a, Ah, Bh), b);
                            break;
                        }
                        Xh(a, Ah, Bh);
                        break;
                    case 4:
                        Kh(a, d);
                        if ((d & 4194240) === d) break;
                        b = a.eventTimes;
                        for(e = -1; 0 < d;){
                            var g = 31 - tc(d);
                            f = 1 << g;
                            g = b[g];
                            g > e && (e = g);
                            d &= ~f;
                        }
                        d = e;
                        d = D() - d;
                        d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * th(d / 1960)) - d;
                        if (10 < d) {
                            a.timeoutHandle = Pa(Xh.bind(null, a, Ah, Bh), d);
                            break;
                        }
                        Xh(a, Ah, Bh);
                        break;
                    case 5:
                        Xh(a, Ah, Bh);
                        break;
                    default:
                        throw Error(m(329));
                }
            }
        }
        Lh(a, D());
        return a.callbackNode === c ? Oh.bind(null, a) : null;
    }
    function Vh(a, b) {
        var c = zh;
        a.current.memoizedState.isDehydrated && (Sh(a, b).flags |= 256);
        a = Qh(a, b);
        2 !== a && (b = Ah, Ah = c, null !== b && Dg(b));
        return a;
    }
    function Dg(a) {
        null === Ah ? Ah = a : Ah.push.apply(Ah, a);
    }
    function Wh(a) {
        for(var b = a;;){
            if (b.flags & 16384) {
                var c = b.updateQueue;
                if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                    var e = c[d], f = e.getSnapshot;
                    e = e.value;
                    try {
                        if (!Vc(f(), e)) return !1;
                    } catch (g) {
                        return !1;
                    }
                }
            }
            c = b.child;
            if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
            else {
                if (b === a) break;
                for(; null === b.sibling;){
                    if (null === b.return || b.return === a) return !0;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return !0;
    }
    function Kh(a, b) {
        b &= ~yh;
        b &= ~xh;
        a.suspendedLanes |= b;
        a.pingedLanes &= ~b;
        for(a = a.expirationTimes; 0 < b;){
            var c = 31 - tc(b), d = 1 << c;
            a[c] = -1;
            b &= ~d;
        }
    }
    function Mh(a) {
        if (0 !== (H & 6)) throw Error(m(327));
        Ph();
        var b = zc(a, 0);
        if (0 === (b & 1)) return Lh(a, D()), null;
        var c = Qh(a, b);
        if (0 !== a.tag && 2 === c) {
            var d = Cc(a);
            0 !== d && (b = d, c = Vh(a, d));
        }
        if (1 === c) throw c = wh, Sh(a, 0), Kh(a, b), Lh(a, D()), c;
        if (6 === c) throw Error(m(345));
        a.finishedWork = a.current.alternate;
        a.finishedLanes = b;
        Xh(a, Ah, Bh);
        Lh(a, D());
        return null;
    }
    function Yh(a) {
        null !== Eh && 0 === Eh.tag && 0 === (H & 6) && Ph();
        var b = H;
        H |= 1;
        var c = W.transition, d = C;
        try {
            if (W.transition = null, C = 1, a) return a();
        } finally{
            C = d, W.transition = c, H = b, 0 === (H & 6) && ad();
        }
    }
    function Fg() {
        ag = $f.current;
        q($f);
    }
    function Sh(a, b) {
        a.finishedWork = null;
        a.finishedLanes = 0;
        var c = a.timeoutHandle;
        c !== Ra && (a.timeoutHandle = Ra, Qa(c));
        if (null !== X) for(c = X.return; null !== c;){
            var d = c;
            nd(d);
            switch(d.tag){
                case 1:
                    d = d.type.childContextTypes;
                    null !== d && void 0 !== d && mc();
                    break;
                case 3:
                    De();
                    q(z);
                    q(x);
                    Ie();
                    break;
                case 5:
                    Fe(d);
                    break;
                case 4:
                    De();
                    break;
                case 13:
                    q(J);
                    break;
                case 19:
                    q(J);
                    break;
                case 10:
                    Md(d.type._context);
                    break;
                case 22:
                case 23:
                    Fg();
            }
            c = c.return;
        }
        O = a;
        X = a = qe(a.current, null);
        Y = ag = b;
        R = 0;
        wh = null;
        yh = xh = be = 0;
        Ah = zh = null;
        if (null !== Qd) {
            for(b = 0; b < Qd.length; b++)if (c = Qd[b], d = c.interleaved, null !== d) {
                c.interleaved = null;
                var e = d.next, f = c.pending;
                if (null !== f) {
                    var g = f.next;
                    f.next = e;
                    d.next = g;
                }
                c.pending = d;
            }
            Qd = null;
        }
        return a;
    }
    function Uh(a, b) {
        do {
            var c = X;
            try {
                Kd();
                Je.current = Ve;
                if (Me) {
                    for(var d = K.memoizedState; null !== d;){
                        var e = d.queue;
                        null !== e && (e.pending = null);
                        d = d.next;
                    }
                    Me = !1;
                }
                Le = 0;
                M = L = K = null;
                Ne = !1;
                Oe = 0;
                vh.current = null;
                if (null === c || null === c.return) {
                    R = 1;
                    wh = b;
                    X = null;
                    break;
                }
                a: {
                    var f = a, g = c.return, h = c, k = b;
                    b = Y;
                    h.flags |= 32768;
                    if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                        var l = k, n = h, t = n.tag;
                        if (0 === (n.mode & 1) && (0 === t || 11 === t || 15 === t)) {
                            var p = n.alternate;
                            p ? (n.updateQueue = p.updateQueue, n.memoizedState = p.memoizedState, n.lanes = p.lanes) : (n.updateQueue = null, n.memoizedState = null);
                        }
                        var B = Qf(g);
                        if (null !== B) {
                            B.flags &= -257;
                            Rf(B, g, h, f, b);
                            B.mode & 1 && Of(f, l, b);
                            b = B;
                            k = l;
                            var w = b.updateQueue;
                            if (null === w) {
                                var Z = new Set;
                                Z.add(k);
                                b.updateQueue = Z;
                            } else w.add(k);
                            break a;
                        } else {
                            if (0 === (b & 1)) {
                                Of(f, l, b);
                                og();
                                break a;
                            }
                            k = Error(m(426));
                        }
                    } else if (F && h.mode & 1) {
                        var za = Qf(g);
                        if (null !== za) {
                            0 === (za.flags & 65536) && (za.flags |= 256);
                            Rf(za, g, h, f, b);
                            Bd(Ff(k, h));
                            break a;
                        }
                    }
                    f = k = Ff(k, h);
                    4 !== R && (R = 2);
                    null === zh ? zh = [
                        f
                    ] : zh.push(f);
                    f = g;
                    do {
                        switch(f.tag){
                            case 3:
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var E = Jf(f, k, b);
                                $d(f, E);
                                break a;
                            case 1:
                                h = k;
                                var r = f.type, u = f.stateNode;
                                if (0 === (f.flags & 128) && ("function" === typeof r.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Nf || !Nf.has(u)))) {
                                    f.flags |= 65536;
                                    b &= -b;
                                    f.lanes |= b;
                                    var Db = Mf(f, h, b);
                                    $d(f, Db);
                                    break a;
                                }
                        }
                        f = f.return;
                    }while (null !== f);
                }
                Zh(c);
            } catch (qc) {
                b = qc;
                X === c && null !== c && (X = c = c.return);
                continue;
            }
            break;
        }while (1);
    }
    function Rh() {
        var a = uh.current;
        uh.current = Ve;
        return null === a ? Ve : a;
    }
    function og() {
        if (0 === R || 3 === R || 2 === R) R = 4;
        null === O || 0 === (be & 268435455) && 0 === (xh & 268435455) || Kh(O, Y);
    }
    function Qh(a, b) {
        var c = H;
        H |= 2;
        var d = Rh();
        if (O !== a || Y !== b) Bh = null, Sh(a, b);
        for(;;)try {
            $h();
            break;
        } catch (e) {
            Uh(a, e);
        }
        Kd();
        H = c;
        uh.current = d;
        if (null !== X) throw Error(m(261));
        O = null;
        Y = 0;
        return R;
    }
    function $h() {
        for(; null !== X;)ai(X);
    }
    function Th() {
        for(; null !== X && !Lc();)ai(X);
    }
    function ai(a) {
        var b = bi(a.alternate, a, ag);
        a.memoizedProps = a.pendingProps;
        null === b ? Zh(a) : X = b;
        vh.current = null;
    }
    function Zh(a) {
        var b = a;
        do {
            var c = b.alternate;
            a = b.return;
            if (0 === (b.flags & 32768)) {
                if (c = Cg(c, b, ag), null !== c) {
                    X = c;
                    return;
                }
            } else {
                c = Gg(c, b);
                if (null !== c) {
                    c.flags &= 32767;
                    X = c;
                    return;
                }
                if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
                else {
                    R = 6;
                    X = null;
                    return;
                }
            }
            b = b.sibling;
            if (null !== b) {
                X = b;
                return;
            }
            X = b = a;
        }while (null !== b);
        0 === R && (R = 5);
    }
    function Xh(a, b, c) {
        var d = C, e = W.transition;
        try {
            W.transition = null, C = 1, ci(a, b, c, d);
        } finally{
            W.transition = e, C = d;
        }
        return null;
    }
    function ci(a, b, c, d) {
        do Ph();
        while (null !== Eh);
        if (0 !== (H & 6)) throw Error(m(327));
        c = a.finishedWork;
        var e = a.finishedLanes;
        if (null === c) return null;
        a.finishedWork = null;
        a.finishedLanes = 0;
        if (c === a.current) throw Error(m(177));
        a.callbackNode = null;
        a.callbackPriority = 0;
        var f = c.lanes | c.childLanes;
        Gc(a, f);
        a === O && (X = O = null, Y = 0);
        0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || Dh || (Dh = !0, Nh(Pc, function() {
            Ph();
            return null;
        }));
        f = 0 !== (c.flags & 15990);
        if (0 !== (c.subtreeFlags & 15990) || f) {
            f = W.transition;
            W.transition = null;
            var g = C;
            C = 1;
            var h = H;
            H |= 4;
            vh.current = null;
            Mg(a, c);
            ah(c, a);
            Ia(a.containerInfo);
            a.current = c;
            eh(c, a, e);
            Mc();
            H = h;
            C = g;
            W.transition = f;
        } else a.current = c;
        Dh && (Dh = !1, Eh = a, Fh = e);
        f = a.pendingLanes;
        0 === f && (Nf = null);
        Tc(c.stateNode, d);
        Lh(a, D());
        if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
            componentStack: e.stack,
            digest: e.digest
        });
        if (Kf) throw Kf = !1, a = Lf, Lf = null, a;
        0 !== (Fh & 1) && 0 !== a.tag && Ph();
        f = a.pendingLanes;
        0 !== (f & 1) ? a === Hh ? Gh++ : (Gh = 0, Hh = a) : Gh = 0;
        ad();
        return null;
    }
    function Ph() {
        if (null !== Eh) {
            var a = Ic(Fh), b = W.transition, c = C;
            try {
                W.transition = null;
                C = 16 > a ? 16 : a;
                if (null === Eh) var d = !1;
                else {
                    a = Eh;
                    Eh = null;
                    Fh = 0;
                    if (0 !== (H & 6)) throw Error(m(331));
                    var e = H;
                    H |= 4;
                    for(T = a.current; null !== T;){
                        var f = T, g = f.child;
                        if (0 !== (T.flags & 16)) {
                            var h = f.deletions;
                            if (null !== h) {
                                for(var k = 0; k < h.length; k++){
                                    var l = h[k];
                                    for(T = l; null !== T;){
                                        var n = T;
                                        switch(n.tag){
                                            case 0:
                                            case 11:
                                            case 15:
                                                Ng(8, n, f);
                                        }
                                        var t = n.child;
                                        if (null !== t) t.return = n, T = t;
                                        else for(; null !== T;){
                                            n = T;
                                            var p = n.sibling, B = n.return;
                                            Qg(n);
                                            if (n === l) {
                                                T = null;
                                                break;
                                            }
                                            if (null !== p) {
                                                p.return = B;
                                                T = p;
                                                break;
                                            }
                                            T = B;
                                        }
                                    }
                                }
                                var w = f.alternate;
                                if (null !== w) {
                                    var Z = w.child;
                                    if (null !== Z) {
                                        w.child = null;
                                        do {
                                            var za = Z.sibling;
                                            Z.sibling = null;
                                            Z = za;
                                        }while (null !== Z);
                                    }
                                }
                                T = f;
                            }
                        }
                        if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, T = g;
                        else b: for(; null !== T;){
                            f = T;
                            if (0 !== (f.flags & 2048)) switch(f.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Ng(9, f, f.return);
                            }
                            var E = f.sibling;
                            if (null !== E) {
                                E.return = f.return;
                                T = E;
                                break b;
                            }
                            T = f.return;
                        }
                    }
                    var r = a.current;
                    for(T = r; null !== T;){
                        g = T;
                        var u = g.child;
                        if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, T = u;
                        else b: for(g = r; null !== T;){
                            h = T;
                            if (0 !== (h.flags & 2048)) try {
                                switch(h.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        Og(9, h);
                                }
                            } catch (qc) {
                                U(h, h.return, qc);
                            }
                            if (h === g) {
                                T = null;
                                break b;
                            }
                            var Db = h.sibling;
                            if (null !== Db) {
                                Db.return = h.return;
                                T = Db;
                                break b;
                            }
                            T = h.return;
                        }
                    }
                    H = e;
                    ad();
                    if (Sc && "function" === typeof Sc.onPostCommitFiberRoot) try {
                        Sc.onPostCommitFiberRoot(Rc, a);
                    } catch (qc) {}
                    d = !0;
                }
                return d;
            } finally{
                C = c, W.transition = b;
            }
        }
        return !1;
    }
    function di(a, b, c) {
        b = Ff(c, b);
        b = Jf(a, b, 1);
        a = Yd(a, b, 1);
        b = I();
        null !== a && (Fc(a, 1, b), Lh(a, b));
    }
    function U(a, b, c) {
        if (3 === a.tag) di(a, a, c);
        else for(; null !== b;){
            if (3 === b.tag) {
                di(b, a, c);
                break;
            } else if (1 === b.tag) {
                var d = b.stateNode;
                if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Nf || !Nf.has(d))) {
                    a = Ff(c, a);
                    a = Mf(b, a, 1);
                    b = Yd(b, a, 1);
                    a = I();
                    null !== b && (Fc(b, 1, a), Lh(b, a));
                    break;
                }
            }
            b = b.return;
        }
    }
    function Pf(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        b = I();
        a.pingedLanes |= a.suspendedLanes & c;
        O === a && (Y & c) === c && (4 === R || 3 === R && (Y & 130023424) === Y && 500 > D() - ch ? Sh(a, 0) : yh |= c);
        Lh(a, b);
    }
    function ei(a, b) {
        0 === b && (0 === (a.mode & 1) ? b = 1 : (b = xc, xc <<= 1, 0 === (xc & 130023424) && (xc = 4194304)));
        var c = I();
        a = Td(a, b);
        null !== a && (Fc(a, b, c), Lh(a, c));
    }
    function pg(a) {
        var b = a.memoizedState, c = 0;
        null !== b && (c = b.retryLane);
        ei(a, c);
    }
    function Zg(a, b) {
        var c = 0;
        switch(a.tag){
            case 13:
                var d = a.stateNode;
                var e = a.memoizedState;
                null !== e && (c = e.retryLane);
                break;
            case 19:
                d = a.stateNode;
                break;
            default:
                throw Error(m(314));
        }
        null !== d && d.delete(b);
        ei(a, c);
    }
    var bi;
    bi = function(a, b, c) {
        if (null !== a) {
            if (a.memoizedProps !== b.pendingProps || z.current) G = !0;
            else {
                if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return G = !1, tg(a, b, c);
                G = 0 !== (a.flags & 131072) ? !0 : !1;
            }
        } else G = !1, F && 0 !== (b.flags & 1048576) && ld(b, ed, b.index);
        b.lanes = 0;
        switch(b.tag){
            case 2:
                var d = b.type;
                dg(a, b);
                a = b.pendingProps;
                var e = lc(b, x.current);
                Od(b, c);
                e = Re(null, b, d, a, e, c);
                var f = We();
                b.flags |= 1;
                "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, A(d) ? (f = !0, pc(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, Vd(b), e.updater = he, b.stateNode = e, e._reactInternals = b, le(b, d, a, c), b = eg(null, b, d, !0, f, c)) : (b.tag = 0, F && f && md(b), P(null, b, e, c), b = b.child);
                return b;
            case 16:
                d = b.elementType;
                a: {
                    dg(a, b);
                    a = b.pendingProps;
                    e = d._init;
                    d = e(d._payload);
                    b.type = d;
                    e = b.tag = fi(d);
                    a = Fd(d, a);
                    switch(e){
                        case 0:
                            b = Yf(null, b, d, a, c);
                            break a;
                        case 1:
                            b = cg(null, b, d, a, c);
                            break a;
                        case 11:
                            b = Tf(null, b, d, a, c);
                            break a;
                        case 14:
                            b = Vf(null, b, d, Fd(d.type, a), c);
                            break a;
                    }
                    throw Error(m(306, d, ""));
                }
                return b;
            case 0:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Fd(d, e), Yf(a, b, d, e, c);
            case 1:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Fd(d, e), cg(a, b, d, e, c);
            case 3:
                a: {
                    fg(b);
                    if (null === a) throw Error(m(387));
                    d = b.pendingProps;
                    f = b.memoizedState;
                    e = f.element;
                    Wd(a, b);
                    ae(b, d, null, c);
                    var g = b.memoizedState;
                    d = g.element;
                    if (Va && f.isDehydrated) {
                        if (f = {
                            element: d,
                            isDehydrated: !1,
                            cache: g.cache,
                            pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                            transitions: g.transitions
                        }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                            e = Ff(Error(m(423)), b);
                            b = gg(a, b, d, c, e);
                            break a;
                        } else if (d !== e) {
                            e = Ff(Error(m(424)), b);
                            b = gg(a, b, d, c, e);
                            break a;
                        } else for(Va && (pd = Pb(b.stateNode.containerInfo), od = b, F = !0, rd = null, qd = !1), c = we(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                    } else {
                        Ad();
                        if (d === e) {
                            b = Uf(a, b, c);
                            break a;
                        }
                        P(a, b, d, c);
                    }
                    b = b.child;
                }
                return b;
            case 5:
                return Ee(b), null === a && wd(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Na(d, e) ? g = null : null !== f && Na(d, f) && (b.flags |= 32), bg(a, b), P(a, b, g, c), b.child;
            case 6:
                return null === a && wd(b), null;
            case 13:
                return jg(a, b, c);
            case 4:
                return Ce(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = ve(b, null, d, c) : P(a, b, d, c), b.child;
            case 11:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Fd(d, e), Tf(a, b, d, e, c);
            case 7:
                return P(a, b, b.pendingProps, c), b.child;
            case 8:
                return P(a, b, b.pendingProps.children, c), b.child;
            case 12:
                return P(a, b, b.pendingProps.children, c), b.child;
            case 10:
                a: {
                    d = b.type._context;
                    e = b.pendingProps;
                    f = b.memoizedProps;
                    g = e.value;
                    Ld(b, d, g);
                    if (null !== f) {
                        if (Vc(f.value, g)) {
                            if (f.children === e.children && !z.current) {
                                b = Uf(a, b, c);
                                break a;
                            }
                        } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                            var h = f.dependencies;
                            if (null !== h) {
                                g = f.child;
                                for(var k = h.firstContext; null !== k;){
                                    if (k.context === d) {
                                        if (1 === f.tag) {
                                            k = Xd(-1, c & -c);
                                            k.tag = 2;
                                            var l = f.updateQueue;
                                            if (null !== l) {
                                                l = l.shared;
                                                var n = l.pending;
                                                null === n ? k.next = k : (k.next = n.next, n.next = k);
                                                l.pending = k;
                                            }
                                        }
                                        f.lanes |= c;
                                        k = f.alternate;
                                        null !== k && (k.lanes |= c);
                                        Nd(f.return, c, b);
                                        h.lanes |= c;
                                        break;
                                    }
                                    k = k.next;
                                }
                            } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                            else if (18 === f.tag) {
                                g = f.return;
                                if (null === g) throw Error(m(341));
                                g.lanes |= c;
                                h = g.alternate;
                                null !== h && (h.lanes |= c);
                                Nd(g, c, b);
                                g = f.sibling;
                            } else g = f.child;
                            if (null !== g) g.return = f;
                            else for(g = f; null !== g;){
                                if (g === b) {
                                    g = null;
                                    break;
                                }
                                f = g.sibling;
                                if (null !== f) {
                                    f.return = g.return;
                                    g = f;
                                    break;
                                }
                                g = g.return;
                            }
                            f = g;
                        }
                    }
                    P(a, b, e.children, c);
                    b = b.child;
                }
                return b;
            case 9:
                return e = b.type, d = b.pendingProps.children, Od(b, c), e = Pd(e), d = d(e), b.flags |= 1, P(a, b, d, c), b.child;
            case 14:
                return d = b.type, e = Fd(d, b.pendingProps), e = Fd(d.type, e), Vf(a, b, d, e, c);
            case 15:
                return Xf(a, b, b.type, b.pendingProps, c);
            case 17:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Fd(d, e), dg(a, b), b.tag = 1, A(d) ? (a = !0, pc(b)) : a = !1, Od(b, c), je(b, d, e), le(b, d, e, c), eg(null, b, d, !0, a, c);
            case 19:
                return sg(a, b, c);
            case 22:
                return Zf(a, b, c);
        }
        throw Error(m(156, b.tag));
    };
    function Nh(a, b) {
        return Jc(a, b);
    }
    function gi(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
    }
    function td(a, b, c, d) {
        return new gi(a, b, c, d);
    }
    function Wf(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
    }
    function fi(a) {
        if ("function" === typeof a) return Wf(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
            a = a.$$typeof;
            if (a === ma) return 11;
            if (a === pa) return 14;
        }
        return 2;
    }
    function qe(a, b) {
        var c = a.alternate;
        null === c ? (c = td(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
        c.flags = a.flags & 14680064;
        c.childLanes = a.childLanes;
        c.lanes = a.lanes;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies = null === b ? null : {
            lanes: b.lanes,
            firstContext: b.firstContext
        };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
    }
    function se(a, b, c, d, e, f) {
        var g = 2;
        d = a;
        if ("function" === typeof a) Wf(a) && (g = 1);
        else if ("string" === typeof a) g = 5;
        else a: switch(a){
            case ha:
                return ue(c.children, e, f, b);
            case ia:
                g = 8;
                e |= 8;
                break;
            case ja:
                return a = td(12, c, b, e | 2), a.elementType = ja, a.lanes = f, a;
            case na:
                return a = td(13, c, b, e), a.elementType = na, a.lanes = f, a;
            case oa:
                return a = td(19, c, b, e), a.elementType = oa, a.lanes = f, a;
            case ra:
                return kg(c, e, f, b);
            default:
                if ("object" === typeof a && null !== a) switch(a.$$typeof){
                    case ka:
                        g = 10;
                        break a;
                    case la:
                        g = 9;
                        break a;
                    case ma:
                        g = 11;
                        break a;
                    case pa:
                        g = 14;
                        break a;
                    case qa:
                        g = 16;
                        d = null;
                        break a;
                }
                throw Error(m(130, null == a ? a : typeof a, ""));
        }
        b = td(g, c, b, e);
        b.elementType = a;
        b.type = d;
        b.lanes = f;
        return b;
    }
    function ue(a, b, c, d) {
        a = td(7, a, d, b);
        a.lanes = c;
        return a;
    }
    function kg(a, b, c, d) {
        a = td(22, a, d, b);
        a.elementType = ra;
        a.lanes = c;
        a.stateNode = {
            isHidden: !1
        };
        return a;
    }
    function re(a, b, c) {
        a = td(6, a, null, b);
        a.lanes = c;
        return a;
    }
    function te(a, b, c) {
        b = td(4, null !== a.children ? a.children : [], a.key, b);
        b.lanes = c;
        b.stateNode = {
            containerInfo: a.containerInfo,
            pendingChildren: null,
            implementation: a.implementation
        };
        return b;
    }
    function hi(a, b, c, d, e) {
        this.tag = b;
        this.containerInfo = a;
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = Ra;
        this.callbackNode = this.pendingContext = this.context = null;
        this.callbackPriority = 0;
        this.eventTimes = Ec(0);
        this.expirationTimes = Ec(-1);
        this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = Ec(0);
        this.identifierPrefix = d;
        this.onRecoverableError = e;
        Va && (this.mutableSourceEagerHydrationData = null);
    }
    function ii(a, b, c, d, e, f, g, h, k) {
        a = new hi(a, b, c, h, k);
        1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
        f = td(3, null, null, b);
        a.current = f;
        f.stateNode = a;
        f.memoizedState = {
            element: d,
            isDehydrated: c,
            cache: null,
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        Vd(f);
        return a;
    }
    function ji(a) {
        if (!a) return jc;
        a = a._reactInternals;
        a: {
            if (wa(a) !== a || 1 !== a.tag) throw Error(m(170));
            var b = a;
            do {
                switch(b.tag){
                    case 3:
                        b = b.stateNode.context;
                        break a;
                    case 1:
                        if (A(b.type)) {
                            b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                            break a;
                        }
                }
                b = b.return;
            }while (null !== b);
            throw Error(m(171));
        }
        if (1 === a.tag) {
            var c = a.type;
            if (A(c)) return oc(a, c, b);
        }
        return b;
    }
    function ki(a) {
        var b = a._reactInternals;
        if (void 0 === b) {
            if ("function" === typeof a.render) throw Error(m(188));
            a = Object.keys(a).join(",");
            throw Error(m(268, a));
        }
        a = Aa(b);
        return null === a ? null : a.stateNode;
    }
    function li(a, b) {
        a = a.memoizedState;
        if (null !== a && null !== a.dehydrated) {
            var c = a.retryLane;
            a.retryLane = 0 !== c && c < b ? c : b;
        }
    }
    function mi(a, b) {
        li(a, b);
        (a = a.alternate) && li(a, b);
    }
    function ni(a) {
        a = Aa(a);
        return null === a ? null : a.stateNode;
    }
    function oi() {
        return null;
    }
    exports.attemptContinuousHydration = function(a) {
        if (13 === a.tag) {
            var b = Td(a, 134217728);
            if (null !== b) {
                var c = I();
                ge(b, a, 134217728, c);
            }
            mi(a, 134217728);
        }
    };
    exports.attemptDiscreteHydration = function(a) {
        if (13 === a.tag) {
            var b = Td(a, 1);
            if (null !== b) {
                var c = I();
                ge(b, a, 1, c);
            }
            mi(a, 1);
        }
    };
    exports.attemptHydrationAtCurrentPriority = function(a) {
        if (13 === a.tag) {
            var b = fe(a), c = Td(a, b);
            if (null !== c) {
                var d = I();
                ge(c, a, b, d);
            }
            mi(a, b);
        }
    };
    exports.attemptSynchronousHydration = function(a) {
        switch(a.tag){
            case 3:
                var b = a.stateNode;
                if (b.current.memoizedState.isDehydrated) {
                    var c = yc(b.pendingLanes);
                    0 !== c && (Hc(b, c | 1), Lh(b, D()), 0 === (H & 6) && (Ch(), ad()));
                }
                break;
            case 13:
                Yh(function() {
                    var b = Td(a, 1);
                    if (null !== b) {
                        var c = I();
                        ge(b, a, 1, c);
                    }
                }), mi(a, 1);
        }
    };
    exports.batchedUpdates = function(a, b) {
        var c = H;
        H |= 1;
        try {
            return a(b);
        } finally{
            H = c, 0 === H && (Ch(), Xc && ad());
        }
    };
    exports.createComponentSelector = function(a) {
        return {
            $$typeof: ih,
            value: a
        };
    };
    exports.createContainer = function(a, b, c, d, e, f, g) {
        return ii(a, b, !1, null, c, d, e, f, g);
    };
    exports.createHasPseudoClassSelector = function(a) {
        return {
            $$typeof: jh,
            value: a
        };
    };
    exports.createHydrationContainer = function(a, b, c, d, e, f, g, h, k) {
        a = ii(c, d, !0, a, e, f, g, h, k);
        a.context = ji(null);
        c = a.current;
        d = I();
        e = fe(c);
        f = Xd(d, e);
        f.callback = void 0 !== b && null !== b ? b : null;
        Yd(c, f, e);
        a.current.lanes = e;
        Fc(a, e, d);
        Lh(a, d);
        return a;
    };
    exports.createPortal = function(a, b, c) {
        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
            $$typeof: fa,
            key: null == d ? null : "" + d,
            children: a,
            containerInfo: b,
            implementation: c
        };
    };
    exports.createRoleSelector = function(a) {
        return {
            $$typeof: kh,
            value: a
        };
    };
    exports.createTestNameSelector = function(a) {
        return {
            $$typeof: lh,
            value: a
        };
    };
    exports.createTextSelector = function(a) {
        return {
            $$typeof: mh,
            value: a
        };
    };
    exports.deferredUpdates = function(a) {
        var b = C, c = W.transition;
        try {
            return W.transition = null, C = 16, a();
        } finally{
            C = b, W.transition = c;
        }
    };
    exports.discreteUpdates = function(a, b, c, d, e) {
        var f = C, g = W.transition;
        try {
            return W.transition = null, C = 1, a(b, c, d, e);
        } finally{
            C = f, W.transition = g, 0 === H && Ch();
        }
    };
    exports.findAllNodes = sh;
    exports.findBoundingRects = function(a, b) {
        if (!bb) throw Error(m(363));
        b = sh(a, b);
        a = [];
        for(var c = 0; c < b.length; c++)a.push(db(b[c]));
        for(b = a.length - 1; 0 < b; b--){
            c = a[b];
            for(var d = c.x, e = d + c.width, f = c.y, g = f + c.height, h = b - 1; 0 <= h; h--)if (b !== h) {
                var k = a[h], l = k.x, n = l + k.width, t = k.y, p = t + k.height;
                if (d >= l && f >= t && e <= n && g <= p) {
                    a.splice(b, 1);
                    break;
                } else if (!(d !== l || c.width !== k.width || p < f || t > g)) {
                    t > f && (k.height += t - f, k.y = f);
                    p < g && (k.height = g - t);
                    a.splice(b, 1);
                    break;
                } else if (!(f !== t || c.height !== k.height || n < d || l > e)) {
                    l > d && (k.width += l - d, k.x = d);
                    n < e && (k.width = e - l);
                    a.splice(b, 1);
                    break;
                }
            }
        }
        return a;
    };
    exports.findHostInstance = ki;
    exports.findHostInstanceWithNoPortals = function(a) {
        a = ya(a);
        a = null !== a ? Ca(a) : null;
        return null === a ? null : a.stateNode;
    };
    exports.findHostInstanceWithWarning = function(a) {
        return ki(a);
    };
    exports.flushControlled = function(a) {
        var b = H;
        H |= 1;
        var c = W.transition, d = C;
        try {
            W.transition = null, C = 1, a();
        } finally{
            C = d, W.transition = c, H = b, 0 === H && (Ch(), ad());
        }
    };
    exports.flushPassiveEffects = Ph;
    exports.flushSync = Yh;
    exports.focusWithin = function(a, b) {
        if (!bb) throw Error(m(363));
        a = oh(a);
        b = rh(a, b);
        b = Array.from(b);
        for(a = 0; a < b.length;){
            var c = b[a++];
            if (!fb(c)) {
                if (5 === c.tag && hb(c.stateNode)) return !0;
                for(c = c.child; null !== c;)b.push(c), c = c.sibling;
            }
        }
        return !1;
    };
    exports.getCurrentUpdatePriority = function() {
        return C;
    };
    exports.getFindAllNodesFailureDescription = function(a, b) {
        if (!bb) throw Error(m(363));
        var c = 0, d = [];
        a = [
            oh(a),
            0
        ];
        for(var e = 0; e < a.length;){
            var f = a[e++], g = a[e++], h = b[g];
            if (5 !== f.tag || !fb(f)) {
                if (ph(f, h) && (d.push(qh(h)), g++, g > c && (c = g)), g < b.length) for(f = f.child; null !== f;)a.push(f, g), f = f.sibling;
            }
        }
        if (c < b.length) {
            for(a = []; c < b.length; c++)a.push(qh(b[c]));
            return "findAllNodes was able to match part of the selector:\n  " + (d.join(" > ") + "\n\nNo matching component was found for:\n  ") + a.join(" > ");
        }
        return null;
    };
    exports.getPublicRootInstance = function(a) {
        a = a.current;
        if (!a.child) return null;
        switch(a.child.tag){
            case 5:
                return Ea(a.child.stateNode);
            default:
                return a.child.stateNode;
        }
    };
    exports.injectIntoDevTools = function(a) {
        a = {
            bundleType: a.bundleType,
            version: a.version,
            rendererPackageName: a.rendererPackageName,
            rendererConfig: a.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: da.ReactCurrentDispatcher,
            findHostInstanceByFiber: ni,
            findFiberByHostInstance: a.findFiberByHostInstance || oi,
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: "18.2.0"
        };
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) a = !1;
        else {
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (b.isDisabled || !b.supportsFiber) a = !0;
            else {
                try {
                    Rc = b.inject(a), Sc = b;
                } catch (c) {}
                a = b.checkDCE ? !0 : !1;
            }
        }
        return a;
    };
    exports.isAlreadyRendering = function() {
        return !1;
    };
    exports.observeVisibleRects = function(a, b, c, d) {
        if (!bb) throw Error(m(363));
        a = sh(a, b);
        var e = ib(a, c, d).disconnect;
        return {
            disconnect: function() {
                e();
            }
        };
    };
    exports.registerMutableSourceForHydration = function(a, b) {
        var c = b._getVersion;
        c = c(b._source);
        null == a.mutableSourceEagerHydrationData ? a.mutableSourceEagerHydrationData = [
            b,
            c
        ] : a.mutableSourceEagerHydrationData.push(b, c);
    };
    exports.runWithPriority = function(a, b) {
        var c = C;
        try {
            return C = a, b();
        } finally{
            C = c;
        }
    };
    exports.shouldError = function() {
        return null;
    };
    exports.shouldSuspend = function() {
        return !1;
    };
    exports.updateContainer = function(a, b, c, d) {
        var e = b.current, f = I(), g = fe(e);
        c = ji(c);
        null === b.context ? b.context = c : b.pendingContext = c;
        b = Xd(f, g);
        b.payload = {
            element: a
        };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        a = Yd(e, b, g);
        null !== a && (ge(a, e, g, f), Zd(a, e, g));
        return g;
    };
    return exports;
};

});

parcelRegister("3Ibga", function(module, exports) {

$parcel$export(module.exports, "ConcurrentRoot", () => $2b3e3719cfc93117$export$816aac48d41c2f81, (v) => $2b3e3719cfc93117$export$816aac48d41c2f81 = v);
$parcel$export(module.exports, "ContinuousEventPriority", () => $2b3e3719cfc93117$export$3bb88615cd12cb3b, (v) => $2b3e3719cfc93117$export$3bb88615cd12cb3b = v);
$parcel$export(module.exports, "DefaultEventPriority", () => $2b3e3719cfc93117$export$d46163d5c045f347, (v) => $2b3e3719cfc93117$export$d46163d5c045f347 = v);
$parcel$export(module.exports, "DiscreteEventPriority", () => $2b3e3719cfc93117$export$8ee75c97f0333f15, (v) => $2b3e3719cfc93117$export$8ee75c97f0333f15 = v);
$parcel$export(module.exports, "IdleEventPriority", () => $2b3e3719cfc93117$export$d1c113b83e1f881a, (v) => $2b3e3719cfc93117$export$d1c113b83e1f881a = v);
$parcel$export(module.exports, "LegacyRoot", () => $2b3e3719cfc93117$export$ff78c4883554845d, (v) => $2b3e3719cfc93117$export$ff78c4883554845d = v);
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2b3e3719cfc93117$export$816aac48d41c2f81;
var $2b3e3719cfc93117$export$3bb88615cd12cb3b;
var $2b3e3719cfc93117$export$d46163d5c045f347;
var $2b3e3719cfc93117$export$8ee75c97f0333f15;
var $2b3e3719cfc93117$export$d1c113b83e1f881a;
var $2b3e3719cfc93117$export$ff78c4883554845d;
'use strict';
$2b3e3719cfc93117$export$816aac48d41c2f81 = 1;
$2b3e3719cfc93117$export$3bb88615cd12cb3b = 4;
$2b3e3719cfc93117$export$d46163d5c045f347 = 16;
$2b3e3719cfc93117$export$8ee75c97f0333f15 = 1;
$2b3e3719cfc93117$export$d1c113b83e1f881a = 536870912;
$2b3e3719cfc93117$export$ff78c4883554845d = 0;

});

parcelRegister("fyVfK", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $b5467137d1533fa1$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $b5467137d1533fa1$var$NEWLINE_REGEX = /\n/g;
var $b5467137d1533fa1$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $b5467137d1533fa1$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $b5467137d1533fa1$var$COLON_REGEX = /^:\s*/;
var $b5467137d1533fa1$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $b5467137d1533fa1$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $b5467137d1533fa1$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $b5467137d1533fa1$var$NEWLINE = '\n';
var $b5467137d1533fa1$var$FORWARD_SLASH = '/';
var $b5467137d1533fa1$var$ASTERISK = '*';
var $b5467137d1533fa1$var$EMPTY_STRING = '';
// types
var $b5467137d1533fa1$var$TYPE_COMMENT = 'comment';
var $b5467137d1533fa1$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($b5467137d1533fa1$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($b5467137d1533fa1$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($b5467137d1533fa1$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($b5467137d1533fa1$var$FORWARD_SLASH != style.charAt(0) || $b5467137d1533fa1$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($b5467137d1533fa1$var$EMPTY_STRING != style.charAt(i) && ($b5467137d1533fa1$var$ASTERISK != style.charAt(i) || $b5467137d1533fa1$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($b5467137d1533fa1$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $b5467137d1533fa1$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($b5467137d1533fa1$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($b5467137d1533fa1$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($b5467137d1533fa1$var$VALUE_REGEX);
        var ret = pos({
            type: $b5467137d1533fa1$var$TYPE_DECLARATION,
            property: $b5467137d1533fa1$var$trim(prop[0].replace($b5467137d1533fa1$var$COMMENT_REGEX, $b5467137d1533fa1$var$EMPTY_STRING)),
            value: val ? $b5467137d1533fa1$var$trim(val[0].replace($b5467137d1533fa1$var$COMMENT_REGEX, $b5467137d1533fa1$var$EMPTY_STRING)) : $b5467137d1533fa1$var$EMPTY_STRING
        });
        // ;
        match($b5467137d1533fa1$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $b5467137d1533fa1$var$trim(str) {
    return str ? str.replace($b5467137d1533fa1$var$TRIM_REGEX, $b5467137d1533fa1$var$EMPTY_STRING) : $b5467137d1533fa1$var$EMPTY_STRING;
}

});


var $ltGt3 = parcelRequire("ltGt3");
var $d13952e353ee92c1$export$882461b6382ed46c;
var $d13952e353ee92c1$export$757ceba2d55c277e;
'use strict';
var $35c0fb1a856c78db$exports = {};
'use strict';
function $35c0fb1a856c78db$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($35c0fb1a856c78db$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$35c0fb1a856c78db$var$checkDCE();

$35c0fb1a856c78db$exports = (parcelRequire("bhjch"));


var $d13952e353ee92c1$var$i;
$d13952e353ee92c1$export$882461b6382ed46c = $35c0fb1a856c78db$exports.createRoot;
$d13952e353ee92c1$export$757ceba2d55c277e = $35c0fb1a856c78db$exports.hydrateRoot;


var $9d004cf64875b9d1$exports = {};
'use strict';

$9d004cf64875b9d1$exports = (parcelRequire("1yPRO"));



var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
/* eslint-disable @typescript-eslint/ban-types */ /* eslint-disable react-hooks/exhaustive-deps */ 
var $ltGt3 = parcelRequire("ltGt3");
function $deca6326d2021bca$var$useEvent(callback) {
    const fnRef = $ltGt3.useRef(callback);
    fnRef.current = callback;
    const memoFn = $ltGt3.useCallback((...args)=>fnRef.current?.(...args), []);
    return memoFn;
}
var $deca6326d2021bca$export$2e2bcd8739ae039 = $deca6326d2021bca$var$useEvent;




var $ltGt3 = parcelRequire("ltGt3");
function $19612225313d4e36$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ const $b51fc3415a3f1104$var$useInternalLayoutEffect = (0, $19612225313d4e36$export$2e2bcd8739ae039)() ? $ltGt3.useLayoutEffect : $ltGt3.useEffect;
const $b51fc3415a3f1104$var$useLayoutEffect = (callback, deps)=>{
    const firstMountRef = $ltGt3.useRef(true);
    $b51fc3415a3f1104$var$useInternalLayoutEffect(()=>{
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $b51fc3415a3f1104$var$useInternalLayoutEffect(()=>{
        firstMountRef.current = false;
        return ()=>{
            firstMountRef.current = true;
        };
    }, []);
};
const $b51fc3415a3f1104$export$9283e56bae2f7b0f = (callback, deps)=>{
    $b51fc3415a3f1104$var$useLayoutEffect((firstMount)=>{
        if (!firstMount) return callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
var $b51fc3415a3f1104$export$2e2bcd8739ae039 = $b51fc3415a3f1104$var$useLayoutEffect;



var $ltGt3 = parcelRequire("ltGt3");
function $451586bd8fd5d39a$export$2e2bcd8739ae039(defaultValue) {
    const destroyRef = $ltGt3.useRef(false);
    const [value, setValue] = $ltGt3.useState(defaultValue);
    $ltGt3.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $e6bfa36d633a3ae4$var$hasValue(value) {
    return value !== undefined;
}
function $e6bfa36d633a3ae4$export$2e2bcd8739ae039(defaultStateValue, option) {
    const { defaultValue: defaultValue, value: value, onChange: onChange, postState: postState } = option || {};
    // ======================= Init =======================
    const [innerValue, setInnerValue] = (0, $451586bd8fd5d39a$export$2e2bcd8739ae039)(()=>{
        if ($e6bfa36d633a3ae4$var$hasValue(value)) return value;
        else if ($e6bfa36d633a3ae4$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    });
    const mergedValue = value !== undefined ? value : innerValue;
    const postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    const onChangeFn = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(onChange);
    const [prevValue, setPrevValue] = (0, $451586bd8fd5d39a$export$2e2bcd8739ae039)([
        mergedValue
    ]);
    (0, $b51fc3415a3f1104$export$9283e56bae2f7b0f)(()=>{
        const prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $b51fc3415a3f1104$export$9283e56bae2f7b0f)(()=>{
        if (!$e6bfa36d633a3ae4$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    const triggerChange = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((updater, ignoreDestroy)=>{
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}



var $ltGt3 = parcelRequire("ltGt3");

function $5d9e8c1fae772521$export$2e2bcd8739ae039(defaultStateValue, value) {
    const [innerValue, setInnerValue] = (0, $ltGt3.useState)(defaultStateValue);
    const mergedValue = value !== undefined ? value : innerValue;
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)((mount)=>{
        if (!mount) setInnerValue(value);
    }, [
        value
    ]);
    return [
        // Value
        mergedValue,
        // Update function
        setInnerValue
    ];
}



var $ltGt3 = parcelRequire("ltGt3");
var $c312a62dcf5203b4$exports = {};
'use strict';

$c312a62dcf5203b4$exports = (parcelRequire("5oFGv"));



var $ltGt3 = parcelRequire("ltGt3");
function $dcca1fcd5fa22f3b$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    const cacheRef = $ltGt3.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


const $0db035f4b04dc3bd$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
const $0db035f4b04dc3bd$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
const $0db035f4b04dc3bd$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $0db035f4b04dc3bd$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && typeof object === 'object' && // React Element type
    (object.$$typeof === $0db035f4b04dc3bd$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $0db035f4b04dc3bd$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $0db035f4b04dc3bd$var$REACT_FRAGMENT_TYPE);
}


const $22ff46e28c8066e1$var$ReactMajorVersion = Number((0, $ltGt3.version).split('.')[0]);
const $22ff46e28c8066e1$export$f17fd18fa51dcb5b = (ref, node)=>{
    if (typeof ref === 'function') ref(node);
    else if (typeof ref === 'object' && ref && 'current' in ref) ref.current = node;
};
const $22ff46e28c8066e1$export$ab452c34e8e05029 = (...refs)=>{
    const refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return (node)=>{
        refs.forEach((ref)=>{
            $22ff46e28c8066e1$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
const $22ff46e28c8066e1$export$1d1c999670a1285d = (...refs)=>{
    return (0, $dcca1fcd5fa22f3b$export$2e2bcd8739ae039)(()=>$22ff46e28c8066e1$export$ab452c34e8e05029(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs, (prev, next)=>prev.length !== next.length || prev.every((ref, i)=>ref !== next[i]));
};
const $22ff46e28c8066e1$export$c1cec34af06bcf7 = (nodeOrComponent)=>{
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($22ff46e28c8066e1$var$isReactElement(nodeOrComponent) && $22ff46e28c8066e1$var$ReactMajorVersion >= 19) return true;
    const type = (0, $c312a62dcf5203b4$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !type.prototype?.render && type.$$typeof !== (0, $c312a62dcf5203b4$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !nodeOrComponent.prototype?.render && nodeOrComponent.$$typeof !== (0, $c312a62dcf5203b4$exports.ForwardRef)) return false;
    return true;
};
function $22ff46e28c8066e1$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $ltGt3.isValidElement)(node) && !(0, $0db035f4b04dc3bd$export$2e2bcd8739ae039)(node);
}
const $22ff46e28c8066e1$export$b51ae67c7882a242 = (node)=>{
    return $22ff46e28c8066e1$var$isReactElement(node) && $22ff46e28c8066e1$export$c1cec34af06bcf7(node);
};
const $22ff46e28c8066e1$export$7465e5c0bf44f19a = (node)=>{
    if (node && $22ff46e28c8066e1$var$isReactElement(node)) {
        const ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};


function $d5b82237eb4bdd3f$export$2e2bcd8739ae039(entity, path) {
    let current = entity;
    for(let i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}



function $33746bcbc33b48dc$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    const [path, ...restPath] = paths;
    let clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = [
        ...entity
    ];
    else clone = {
        ...entity
    };
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $33746bcbc33b48dc$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $33746bcbc33b48dc$export$2e2bcd8739ae039(entity, paths, value, removeIfUndefined = false) {
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $33746bcbc33b48dc$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $33746bcbc33b48dc$var$isObject(obj) {
    return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $33746bcbc33b48dc$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
const $33746bcbc33b48dc$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $33746bcbc33b48dc$export$4950aa0f605343fb(...sources) {
    let clone = $33746bcbc33b48dc$var$createEmpty(sources[0]);
    sources.forEach((src)=>{
        function internalMerge(path, parentLoopSet) {
            const loopSet = new Set(parentLoopSet);
            const value = (0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(src, path);
            const isArr = Array.isArray(value);
            if (isArr || $33746bcbc33b48dc$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    const originValue = (0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $33746bcbc33b48dc$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || typeof originValue !== 'object') // Init container if not exist
                    clone = $33746bcbc33b48dc$export$2e2bcd8739ae039(clone, path, $33746bcbc33b48dc$var$createEmpty(value));
                    $33746bcbc33b48dc$var$keys(value).forEach((key)=>{
                        internalMerge([
                            ...path,
                            key
                        ], loopSet);
                    });
                }
            } else clone = $33746bcbc33b48dc$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}


/* eslint-disable no-console */ let $474154b5a64067c8$var$warned = {};
const $474154b5a64067c8$var$preWarningFns = [];
const $474154b5a64067c8$export$61616f168f0e5a05 = (fn)=>{
    $474154b5a64067c8$var$preWarningFns.push(fn);
};
function $474154b5a64067c8$export$491112666e282270(valid, message) {}
function $474154b5a64067c8$export$a92e4c44d367d0af(valid, message) {}
function $474154b5a64067c8$export$60eef1277fe463e4() {
    $474154b5a64067c8$var$warned = {};
}
function $474154b5a64067c8$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$474154b5a64067c8$var$warned[message]) {
        method(false, message);
        $474154b5a64067c8$var$warned[message] = true;
    }
}
function $474154b5a64067c8$export$82934adf09101657(valid, message) {
    $474154b5a64067c8$export$848feb93d8f32b9b($474154b5a64067c8$export$491112666e282270, valid, message);
}
function $474154b5a64067c8$export$89ff31684837bbbf(valid, message) {
    $474154b5a64067c8$export$848feb93d8f32b9b($474154b5a64067c8$export$a92e4c44d367d0af, valid, message);
}
$474154b5a64067c8$export$82934adf09101657.preMessage = $474154b5a64067c8$export$61616f168f0e5a05;
$474154b5a64067c8$export$82934adf09101657.resetWarned = $474154b5a64067c8$export$60eef1277fe463e4;
$474154b5a64067c8$export$82934adf09101657.noteOnce = $474154b5a64067c8$export$89ff31684837bbbf;
var $474154b5a64067c8$export$2e2bcd8739ae039 = $474154b5a64067c8$export$82934adf09101657;


function $ce9e10bdc01e86dc$export$2e2bcd8739ae039(obj, fields) {
    const clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach((key)=>{
        delete clone[key];
    });
    return clone;
}




var $ltGt3 = parcelRequire("ltGt3");
function $0f02b0eb7b37195f$export$2e2bcd8739ae039(children, option = {}) {
    let ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.forEach(children, (child)=>{
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($0f02b0eb7b37195f$export$2e2bcd8739ae039(child));
        else if ((0, $0db035f4b04dc3bd$export$2e2bcd8739ae039)(child) && child.props) ret = ret.concat($0f02b0eb7b37195f$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}





function $9385a2419c7c77f5$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $9385a2419c7c77f5$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $9385a2419c7c77f5$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $9385a2419c7c77f5$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $9385a2419c7c77f5$export$2e2bcd8739ae039 = $9385a2419c7c77f5$export$4f5d2d50c9deca37;


function $2b3fc1eb3b80ee8c$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $6374183a5f1f7dba$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $2b3fc1eb3b80ee8c$export$2e2bcd8739ae039)(r);
}


function $322c7edaec67f281$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $f08c52026be8729d$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $2b3fc1eb3b80ee8c$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $2b3fc1eb3b80ee8c$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $85da4a8cd2669204$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $83d01b7684a01087$export$2e2bcd8739ae039(r) {
    return (0, $6374183a5f1f7dba$export$2e2bcd8739ae039)(r) || (0, $322c7edaec67f281$export$2e2bcd8739ae039)(r) || (0, $f08c52026be8729d$export$2e2bcd8739ae039)(r) || (0, $85da4a8cd2669204$export$2e2bcd8739ae039)();
}



var $ltGt3 = parcelRequire("ltGt3");

const $859a31e79ed756e5$export$8bf64cd1c29a1310 = (schema, ...classNames)=>{
    const mergedSchema = schema || {};
    return classNames.filter(Boolean).reduce((acc, cur)=>{
        // Loop keys of the current classNames
        Object.keys(cur || {}).forEach((key)=>{
            const keySchema = mergedSchema[key];
            const curVal = cur[key];
            if (keySchema && typeof keySchema === 'object') {
                if (curVal && typeof curVal === 'object') // Loop fill
                acc[key] = $859a31e79ed756e5$export$8bf64cd1c29a1310(keySchema, acc[key], curVal);
                else {
                    // Covert string to object structure
                    const { _default: defaultField } = keySchema;
                    if (defaultField) {
                        acc[key] = acc[key] || {};
                        acc[key][defaultField] = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(acc[key][defaultField], curVal);
                    }
                }
            } else // Flatten fill
            acc[key] = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(acc[key], curVal);
        });
        return acc;
    }, {});
};
const $859a31e79ed756e5$var$useSemanticClassNames = (schema, ...classNames)=>{
    return $ltGt3.useMemo(()=>$859a31e79ed756e5$export$8bf64cd1c29a1310.apply(void 0, [
            schema
        ].concat(classNames)), [
        schema
    ].concat(classNames));
};
const $859a31e79ed756e5$export$e618dc39ac9ad607 = (...styles)=>{
    return styles.filter(Boolean).reduce((acc, cur = {})=>{
        Object.keys(cur).forEach((key)=>{
            acc[key] = {
                ...acc[key],
                ...cur[key]
            };
        });
        return acc;
    }, {});
};
const $859a31e79ed756e5$var$useSemanticStyles = (...styles)=>{
    return $ltGt3.useMemo(()=>$859a31e79ed756e5$export$e618dc39ac9ad607.apply(void 0, styles), [].concat(styles));
};
// =========================== Export ===========================
const $859a31e79ed756e5$var$fillObjectBySchema = (obj, schema)=>{
    const newObj = {
        ...obj
    };
    Object.keys(schema).forEach((key)=>{
        if (key !== '_default') {
            const nestSchema = schema[key];
            const nextValue = newObj[key] || {};
            newObj[key] = nestSchema ? $859a31e79ed756e5$var$fillObjectBySchema(nextValue, nestSchema) : nextValue;
        }
    });
    return newObj;
};
const $859a31e79ed756e5$export$ccd424010a24474f = (value, info)=>{
    return typeof value === 'function' ? value(info) : value;
};
const $859a31e79ed756e5$export$648566b068f28737 = (classNamesList, stylesList, info, schema)=>{
    const resolvedClassNamesList = classNamesList.map((classNames)=>classNames ? $859a31e79ed756e5$export$ccd424010a24474f(classNames, info) : undefined);
    const resolvedStylesList = stylesList.map((styles)=>styles ? $859a31e79ed756e5$export$ccd424010a24474f(styles, info) : undefined);
    const mergedClassNames = $859a31e79ed756e5$var$useSemanticClassNames.apply(void 0, [
        schema
    ].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(resolvedClassNamesList)));
    const mergedStyles = $859a31e79ed756e5$var$useSemanticStyles.apply(void 0, (0, $83d01b7684a01087$export$2e2bcd8739ae039)(resolvedStylesList));
    return $ltGt3.useMemo(()=>{
        if (!schema) return [
            mergedClassNames,
            mergedStyles
        ];
        return [
            $859a31e79ed756e5$var$fillObjectBySchema(mergedClassNames, schema),
            $859a31e79ed756e5$var$fillObjectBySchema(mergedStyles, schema)
        ];
    }, [
        mergedClassNames,
        mergedStyles,
        schema
    ]);
};


const $2e40f05689cf6d67$var$isNonNullable = (val)=>{
    return val !== undefined && val !== null;
};
var $2e40f05689cf6d67$export$2e2bcd8739ae039 = $2e40f05689cf6d67$var$isNonNullable;




var $ltGt3 = parcelRequire("ltGt3");
var $d3c89c1e130d7e35$export$2e2bcd8739ae039 = (element)=>{
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            const { width: width, height: height } = element.getBBox();
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            const { width: width, height: height } = element.getBoundingClientRect();
            if (width || height) return true;
        }
    }
    return false;
};





var $ltGt3 = parcelRequire("ltGt3");
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $d28312f0b78911be$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $d28312f0b78911be$export$2e2bcd8739ae039 = $d28312f0b78911be$var$murmur2;


function $8fc9a8f8dc109eed$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8fc9a8f8dc109eed$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8fc9a8f8dc109eed$export$2e2bcd8739ae039(o);
}



function $15d162e63dabb336$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $892d9a0b262e20a7$export$2e2bcd8739ae039(t) {
    var i = (0, $15d162e63dabb336$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $db13280b58f1be94$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $892d9a0b262e20a7$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $34ce29ac4bb97565$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $34ce29ac4bb97565$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $34ce29ac4bb97565$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $db13280b58f1be94$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $34ce29ac4bb97565$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $6ffdd9161f116fb2$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


function $1cf8d19f507342fb$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


var $d058379f2019d619$var$APPEND_ORDER = 'data-rc-order';
var $d058379f2019d619$var$APPEND_PRIORITY = 'data-rc-priority';
var $d058379f2019d619$var$MARK_KEY = "rc-util-key";
var $d058379f2019d619$var$containerCache = new Map();
function $d058379f2019d619$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith('data-') ? mark : "data-".concat(mark);
    return $d058379f2019d619$var$MARK_KEY;
}
function $d058379f2019d619$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector('head');
    return head || document.body;
}
function $d058379f2019d619$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $d058379f2019d619$var$findStyles(container) {
    return Array.from(($d058379f2019d619$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === 'STYLE';
    });
}
function $d058379f2019d619$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $6ffdd9161f116fb2$export$2e2bcd8739ae039)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $d058379f2019d619$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === 'prependQueue';
    var styleNode = document.createElement('style');
    styleNode.setAttribute($d058379f2019d619$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($d058379f2019d619$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $d058379f2019d619$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = (option.styles || $d058379f2019d619$var$findStyles(container)).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($d058379f2019d619$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($d058379f2019d619$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $d058379f2019d619$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $d058379f2019d619$var$getContainer(option);
    return (option.styles || $d058379f2019d619$var$findStyles(container)).find(function(node) {
        return node.getAttribute($d058379f2019d619$var$getMark(option)) === key;
    });
}
function $d058379f2019d619$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $d058379f2019d619$var$findExistNode(key, option);
    if (existNode) {
        var container = $d058379f2019d619$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $d058379f2019d619$var$syncRealContainer(container, option) {
    var cachedRealContainer = $d058379f2019d619$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $1cf8d19f507342fb$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        var placeholderStyle = $d058379f2019d619$export$1ab5838465dbd10a('', option);
        var parentNode = placeholderStyle.parentNode;
        $d058379f2019d619$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $d058379f2019d619$export$f80df667f2f5a272() {
    $d058379f2019d619$var$containerCache.clear();
}
function $d058379f2019d619$export$4d99a2890bb989f0(css, key) {
    var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $d058379f2019d619$var$getContainer(originOption);
    var styles = $d058379f2019d619$var$findStyles(container);
    var option = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, originOption), {}, {
        styles: styles
    });
    // Sync real parent
    $d058379f2019d619$var$syncRealContainer(container, option);
    var existNode = $d058379f2019d619$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $d058379f2019d619$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($d058379f2019d619$var$getMark(option), key);
    return newNode;
}



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
function $97adbe7759b0359b$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $ltGt3.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}



/* eslint-disable no-console */ var $a18317b8bba7a6b2$var$warned = {};
var $a18317b8bba7a6b2$var$preWarningFns = [];
var $a18317b8bba7a6b2$export$61616f168f0e5a05 = function preMessage(fn) {
    $a18317b8bba7a6b2$var$preWarningFns.push(fn);
};
function $a18317b8bba7a6b2$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $a18317b8bba7a6b2$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $a18317b8bba7a6b2$export$60eef1277fe463e4() {
    $a18317b8bba7a6b2$var$warned = {};
}
function $a18317b8bba7a6b2$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$a18317b8bba7a6b2$var$warned[message]) {
        method(false, message);
        $a18317b8bba7a6b2$var$warned[message] = true;
    }
}
function $a18317b8bba7a6b2$export$82934adf09101657(valid, message) {
    $a18317b8bba7a6b2$export$848feb93d8f32b9b($a18317b8bba7a6b2$export$491112666e282270, valid, message);
}
function $a18317b8bba7a6b2$export$89ff31684837bbbf(valid, message) {
    $a18317b8bba7a6b2$export$848feb93d8f32b9b($a18317b8bba7a6b2$export$a92e4c44d367d0af, valid, message);
}
$a18317b8bba7a6b2$export$82934adf09101657.preMessage = $a18317b8bba7a6b2$export$61616f168f0e5a05;
$a18317b8bba7a6b2$export$82934adf09101657.resetWarned = $a18317b8bba7a6b2$export$60eef1277fe463e4;
$a18317b8bba7a6b2$export$82934adf09101657.noteOnce = $a18317b8bba7a6b2$export$89ff31684837bbbf;
var $a18317b8bba7a6b2$export$2e2bcd8739ae039 = $a18317b8bba7a6b2$export$82934adf09101657;


/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $c2141253c67cc15b$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $a18317b8bba7a6b2$export$2e2bcd8739ae039)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(a) === 'object' && (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $c2141253c67cc15b$export$2e2bcd8739ae039 = $c2141253c67cc15b$var$isEqual;



var $ltGt3 = parcelRequire("ltGt3");
// [times, realValue]
const $c730a371eb0530a1$var$SPLIT = '%';
function $c730a371eb0530a1$export$1d14e1d8187b9aad(keys) {
    return keys.join($c730a371eb0530a1$var$SPLIT);
}
/** Record update id for extract static style order. */ let $c730a371eb0530a1$var$updateId = 0;
class $c730a371eb0530a1$var$Entity {
    instanceId;
    constructor(instanceId){
        this.instanceId = instanceId;
    }
    /** @private Internal cache map. Do not access this directly */ cache = new Map();
    /** @private Record update times for each key */ updateTimes = new Map();
    extracted = new Set();
    get(keys) {
        return this.opGet($c730a371eb0530a1$export$1d14e1d8187b9aad(keys));
    }
    /** A fast get cache with `get` concat. */ opGet(keyPathStr) {
        return this.cache.get(keyPathStr) || null;
    }
    update(keys, valueFn) {
        return this.opUpdate($c730a371eb0530a1$export$1d14e1d8187b9aad(keys), valueFn);
    }
    /** A fast get cache with `get` concat. */ opUpdate(keyPathStr, valueFn) {
        const prevValue = this.cache.get(keyPathStr);
        const nextValue = valueFn(prevValue);
        if (nextValue === null) {
            this.cache.delete(keyPathStr);
            this.updateTimes.delete(keyPathStr);
        } else {
            this.cache.set(keyPathStr, nextValue);
            this.updateTimes.set(keyPathStr, $c730a371eb0530a1$var$updateId);
            $c730a371eb0530a1$var$updateId += 1;
        }
    }
}
var $c730a371eb0530a1$export$2e2bcd8739ae039 = $c730a371eb0530a1$var$Entity;


const $9431de1ccad4684c$export$3a1a912fd9fd3325 = {};
const $9431de1ccad4684c$var$transform = $9431de1ccad4684c$export$3a1a912fd9fd3325;
var $9431de1ccad4684c$export$2e2bcd8739ae039 = $9431de1ccad4684c$var$transform;


const $6eb27787545be803$export$5d99297dcd5476ac = 'data-token-hash';
const $6eb27787545be803$export$89ce1123b3c0bd9e = 'data-css-hash';
const $6eb27787545be803$export$36f8a6c9fa24262a = 'data-cache-path';
const $6eb27787545be803$export$4c16a0c02134a7dc = '__cssinjs_instance__';
function $6eb27787545be803$export$cf6fa0bbcc94b912() {
    const cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== 'undefined' && document.head && document.body) {
        const styles = document.body.querySelectorAll(`style[${$6eb27787545be803$export$89ce1123b3c0bd9e}]`) || [];
        const { firstChild: firstChild } = document.head;
        Array.from(styles).forEach((style)=>{
            style[$6eb27787545be803$export$4c16a0c02134a7dc] = style[$6eb27787545be803$export$4c16a0c02134a7dc] || cssinjsInstanceId;
            // Not force move if no head
            if (style[$6eb27787545be803$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        const styleHash = {};
        Array.from(document.querySelectorAll(`style[${$6eb27787545be803$export$89ce1123b3c0bd9e}]`)).forEach((style)=>{
            const hash = style.getAttribute($6eb27787545be803$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$6eb27787545be803$export$4c16a0c02134a7dc] === cssinjsInstanceId) style.parentNode?.removeChild(style);
            } else styleHash[hash] = true;
        });
    }
    return new (0, $c730a371eb0530a1$export$2e2bcd8739ae039)(cssinjsInstanceId);
}
const $6eb27787545be803$var$StyleContext = /*#__PURE__*/ $ltGt3.createContext({
    hashPriority: 'low',
    cache: $6eb27787545be803$export$cf6fa0bbcc94b912(),
    defaultCache: true,
    autoPrefix: false
});
const $6eb27787545be803$export$6aedb87c7b665270 = (props)=>{
    const { children: children, ...restProps } = props;
    const parentContext = $ltGt3.useContext($6eb27787545be803$var$StyleContext);
    const context = (0, $97adbe7759b0359b$export$2e2bcd8739ae039)(()=>{
        const mergedContext = {
            ...parentContext
        };
        Object.keys(restProps).forEach((key)=>{
            const value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        const { cache: cache, transformers: transformers = [] } = restProps;
        mergedContext.cache = mergedContext.cache || $6eb27787545be803$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        // autoPrefix
        if (transformers.includes((0, $9431de1ccad4684c$export$3a1a912fd9fd3325))) mergedContext.autoPrefix = true;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], (prev, next)=>!(0, $c2141253c67cc15b$export$2e2bcd8739ae039)(prev[0], next[0], true) || !(0, $c2141253c67cc15b$export$2e2bcd8739ae039)(prev[1], next[1], true));
    return /*#__PURE__*/ $ltGt3.createElement($6eb27787545be803$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $6eb27787545be803$export$2e2bcd8739ae039 = $6eb27787545be803$var$StyleContext;






class $8e83242a3cabb603$var$AbstractCalculator {
}
var $8e83242a3cabb603$export$2e2bcd8739ae039 = $8e83242a3cabb603$var$AbstractCalculator;


const $beda9a709ba57654$var$CALC_UNIT = 'CALC_UNIT';
const $beda9a709ba57654$var$regexp = new RegExp($beda9a709ba57654$var$CALC_UNIT, 'g');
function $beda9a709ba57654$var$unit(value) {
    if (typeof value === 'number') return `${value}${$beda9a709ba57654$var$CALC_UNIT}`;
    return value;
}
class $beda9a709ba57654$export$2e2bcd8739ae039 extends (0, $8e83242a3cabb603$export$2e2bcd8739ae039) {
    result = '';
    unitlessCssVar;
    lowPriority;
    constructor(num, unitlessCssVar){
        super();
        const numType = typeof num;
        this.unitlessCssVar = unitlessCssVar;
        if (num instanceof $beda9a709ba57654$export$2e2bcd8739ae039) this.result = `(${num.result})`;
        else if (numType === 'number') this.result = $beda9a709ba57654$var$unit(num);
        else if (numType === 'string') this.result = num;
    }
    add(num) {
        if (num instanceof $beda9a709ba57654$export$2e2bcd8739ae039) this.result = `${this.result} + ${num.getResult()}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} + ${$beda9a709ba57654$var$unit(num)}`;
        this.lowPriority = true;
        return this;
    }
    sub(num) {
        if (num instanceof $beda9a709ba57654$export$2e2bcd8739ae039) this.result = `${this.result} - ${num.getResult()}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} - ${$beda9a709ba57654$var$unit(num)}`;
        this.lowPriority = true;
        return this;
    }
    mul(num) {
        if (this.lowPriority) this.result = `(${this.result})`;
        if (num instanceof $beda9a709ba57654$export$2e2bcd8739ae039) this.result = `${this.result} * ${num.getResult(true)}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} * ${num}`;
        this.lowPriority = false;
        return this;
    }
    div(num) {
        if (this.lowPriority) this.result = `(${this.result})`;
        if (num instanceof $beda9a709ba57654$export$2e2bcd8739ae039) this.result = `${this.result} / ${num.getResult(true)}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} / ${num}`;
        this.lowPriority = false;
        return this;
    }
    getResult(force) {
        return this.lowPriority || force ? `(${this.result})` : this.result;
    }
    equal(options) {
        const { unit: cssUnit } = options || {};
        let mergedUnit = true;
        if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
        else if (Array.from(this.unitlessCssVar).some((cssVar)=>this.result.includes(cssVar))) mergedUnit = false;
        this.result = this.result.replace($beda9a709ba57654$var$regexp, mergedUnit ? 'px' : '');
        if (typeof this.lowPriority !== 'undefined') return `calc(${this.result})`;
        return this.result;
    }
}



class $7a1f735be0972db7$export$2e2bcd8739ae039 extends (0, $8e83242a3cabb603$export$2e2bcd8739ae039) {
    result = 0;
    constructor(num){
        super();
        if (num instanceof $7a1f735be0972db7$export$2e2bcd8739ae039) this.result = num.result;
        else if (typeof num === 'number') this.result = num;
    }
    add(num) {
        if (num instanceof $7a1f735be0972db7$export$2e2bcd8739ae039) this.result += num.result;
        else if (typeof num === 'number') this.result += num;
        return this;
    }
    sub(num) {
        if (num instanceof $7a1f735be0972db7$export$2e2bcd8739ae039) this.result -= num.result;
        else if (typeof num === 'number') this.result -= num;
        return this;
    }
    mul(num) {
        if (num instanceof $7a1f735be0972db7$export$2e2bcd8739ae039) this.result *= num.result;
        else if (typeof num === 'number') this.result *= num;
        return this;
    }
    div(num) {
        if (num instanceof $7a1f735be0972db7$export$2e2bcd8739ae039) this.result /= num.result;
        else if (typeof num === 'number') this.result /= num;
        return this;
    }
    equal() {
        return this.result;
    }
}


const $fcd74f60869e0b77$var$genCalc = (type, unitlessCssVar)=>{
    const Calculator = type === 'css' ? (0, $beda9a709ba57654$export$2e2bcd8739ae039) : (0, $7a1f735be0972db7$export$2e2bcd8739ae039);
    return (num)=>new Calculator(num, unitlessCssVar);
};
var $fcd74f60869e0b77$export$2e2bcd8739ae039 = $fcd74f60869e0b77$var$genCalc;


// ================================== Cache ==================================
function $40c4d28f809a3a19$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(let i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
class $40c4d28f809a3a19$export$2e2bcd8739ae039 {
    static MAX_CACHE_SIZE = 20;
    static MAX_CACHE_OFFSET = 5;
    cache;
    keys;
    cacheCallTimes;
    constructor(){
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    size() {
        return this.keys.length;
    }
    internalGet(derivativeOption, updateCallTimes = false) {
        let cache = {
            map: this.cache
        };
        derivativeOption.forEach((derivative)=>{
            if (!cache) cache = undefined;
            else cache = cache?.map?.get(derivative);
        });
        if (cache?.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
        return cache?.value;
    }
    get(derivativeOption) {
        return this.internalGet(derivativeOption, true)?.[0];
    }
    has(derivativeOption) {
        return !!this.internalGet(derivativeOption);
    }
    set(derivativeOption, value) {
        // New cache
        if (!this.has(derivativeOption)) {
            if (this.size() + 1 > $40c4d28f809a3a19$export$2e2bcd8739ae039.MAX_CACHE_SIZE + $40c4d28f809a3a19$export$2e2bcd8739ae039.MAX_CACHE_OFFSET) {
                const [targetKey] = this.keys.reduce((result, key)=>{
                    const [, callTimes] = result;
                    if (this.internalGet(key)[1] < callTimes) return [
                        key,
                        this.internalGet(key)[1]
                    ];
                    return result;
                }, [
                    this.keys[0],
                    this.cacheCallTimes
                ]);
                this.delete(targetKey);
            }
            this.keys.push(derivativeOption);
        }
        let cache = this.cache;
        derivativeOption.forEach((derivative, index)=>{
            if (index === derivativeOption.length - 1) cache.set(derivative, {
                value: [
                    value,
                    this.cacheCallTimes++
                ]
            });
            else {
                const cacheValue = cache.get(derivative);
                if (!cacheValue) cache.set(derivative, {
                    map: new Map()
                });
                else if (!cacheValue.map) cacheValue.map = new Map();
                cache = cache.get(derivative).map;
            }
        });
    }
    deleteByPath(currentCache, derivatives) {
        const cache = currentCache.get(derivatives[0]);
        if (derivatives.length === 1) {
            if (!cache.map) currentCache.delete(derivatives[0]);
            else currentCache.set(derivatives[0], {
                map: cache.map
            });
            return cache.value?.[0];
        }
        const result = this.deleteByPath(cache.map, derivatives.slice(1));
        if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
        return result;
    }
    delete(derivativeOption) {
        // If cache exists
        if (this.has(derivativeOption)) {
            this.keys = this.keys.filter((item)=>!$40c4d28f809a3a19$export$dd65e95e99ed0739(item, derivativeOption));
            return this.deleteByPath(this.cache, derivativeOption);
        }
        return undefined;
    }
}



let $5606aec126d5a964$var$uuid = 0;
class $5606aec126d5a964$export$2e2bcd8739ae039 {
    derivatives;
    id;
    constructor(derivatives){
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $5606aec126d5a964$var$uuid;
        if (derivatives.length === 0) (0, $a18317b8bba7a6b2$export$491112666e282270)(derivatives.length > 0, '[Ant Design CSS-in-JS] Theme should have at least one derivative function.');
        $5606aec126d5a964$var$uuid += 1;
    }
    getDerivativeToken(token) {
        return this.derivatives.reduce((result, derivative)=>derivative(token, result), undefined);
    }
}


const $db382206ce669921$var$cacheThemes = new (0, $40c4d28f809a3a19$export$2e2bcd8739ae039)();
function $db382206ce669921$export$2e2bcd8739ae039(derivatives) {
    const derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$db382206ce669921$var$cacheThemes.has(derivativeArr)) $db382206ce669921$var$cacheThemes.set(derivativeArr, new (0, $5606aec126d5a964$export$2e2bcd8739ae039)(derivativeArr));
    // Get theme from cache and return
    return $db382206ce669921$var$cacheThemes.get(derivativeArr);
}






// Create a cache for memo concat
const $df37b8d23d0b3c71$var$resultCache = new WeakMap();
const $df37b8d23d0b3c71$var$RESULT_VALUE = {};
function $df37b8d23d0b3c71$export$6aabcc1951563d93(callback, deps) {
    let current = $df37b8d23d0b3c71$var$resultCache;
    for(let i = 0; i < deps.length; i += 1){
        const dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($df37b8d23d0b3c71$var$RESULT_VALUE)) current.set($df37b8d23d0b3c71$var$RESULT_VALUE, callback());
    return current.get($df37b8d23d0b3c71$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
const $df37b8d23d0b3c71$var$flattenTokenCache = new WeakMap();
function $df37b8d23d0b3c71$export$597374558a261efc(token) {
    let str = $df37b8d23d0b3c71$var$flattenTokenCache.get(token) || '';
    if (!str) {
        Object.keys(token).forEach((key)=>{
            const value = token[key];
            str += key;
            if (value instanceof (0, $5606aec126d5a964$export$2e2bcd8739ae039)) str += value.id;
            else if (value && typeof value === 'object') str += $df37b8d23d0b3c71$export$597374558a261efc(value);
            else str += value;
        });
        // https://github.com/ant-design/ant-design/issues/48386
        // Should hash the string to avoid style tag name too long
        str = (0, $d28312f0b78911be$export$2e2bcd8739ae039)(str);
        // Put in cache
        $df37b8d23d0b3c71$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $df37b8d23d0b3c71$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $d28312f0b78911be$export$2e2bcd8739ae039)(`${salt}_${$df37b8d23d0b3c71$export$597374558a261efc(token)}`);
}
const $df37b8d23d0b3c71$var$randomSelectorKey = `random-${Date.now()}-${Math.random()}`.replace(/\./g, '');
// Magic `content` for detect selector support
const $df37b8d23d0b3c71$var$checkContent = '_bAmBoO_';
function $df37b8d23d0b3c71$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $6ffdd9161f116fb2$export$2e2bcd8739ae039)()) {
        (0, $d058379f2019d619$export$4d99a2890bb989f0)(styleStr, $df37b8d23d0b3c71$var$randomSelectorKey);
        const ele = document.createElement('div');
        ele.style.position = 'fixed';
        ele.style.left = '0';
        ele.style.top = '0';
        handleElement?.(ele);
        document.body.appendChild(ele);
        const support = supportCheck ? supportCheck(ele) : getComputedStyle(ele).content?.includes($df37b8d23d0b3c71$var$checkContent);
        ele.parentNode?.removeChild(ele);
        (0, $d058379f2019d619$export$2232e336aecaa80a)($df37b8d23d0b3c71$var$randomSelectorKey);
        return support;
    }
    return false;
}
let $df37b8d23d0b3c71$var$canLayer = undefined;
function $df37b8d23d0b3c71$export$ac8d3fd9840e20dd() {
    if ($df37b8d23d0b3c71$var$canLayer === undefined) $df37b8d23d0b3c71$var$canLayer = $df37b8d23d0b3c71$var$supportSelector(`@layer ${$df37b8d23d0b3c71$var$randomSelectorKey} { .${$df37b8d23d0b3c71$var$randomSelectorKey} { content: "${$df37b8d23d0b3c71$var$checkContent}"!important; } }`, (ele)=>{
        ele.className = $df37b8d23d0b3c71$var$randomSelectorKey;
    });
    return $df37b8d23d0b3c71$var$canLayer;
}
let $df37b8d23d0b3c71$var$canWhere = undefined;
function $df37b8d23d0b3c71$export$f51d3b8ac4ac9ed1() {
    if ($df37b8d23d0b3c71$var$canWhere === undefined) $df37b8d23d0b3c71$var$canWhere = $df37b8d23d0b3c71$var$supportSelector(`:where(.${$df37b8d23d0b3c71$var$randomSelectorKey}) { content: "${$df37b8d23d0b3c71$var$checkContent}"!important; }`, (ele)=>{
        ele.className = $df37b8d23d0b3c71$var$randomSelectorKey;
    });
    return $df37b8d23d0b3c71$var$canWhere;
}
let $df37b8d23d0b3c71$var$canLogic = undefined;
function $df37b8d23d0b3c71$export$64a912f57d5de48e() {
    if ($df37b8d23d0b3c71$var$canLogic === undefined) $df37b8d23d0b3c71$var$canLogic = $df37b8d23d0b3c71$var$supportSelector(`.${$df37b8d23d0b3c71$var$randomSelectorKey} { inset-block: 93px !important; }`, (ele)=>{
        ele.className = $df37b8d23d0b3c71$var$randomSelectorKey;
    }, (ele)=>getComputedStyle(ele).bottom === '93px');
    return $df37b8d23d0b3c71$var$canLogic;
}
const $df37b8d23d0b3c71$export$9542afab8c2a5f48 = (0, $6ffdd9161f116fb2$export$2e2bcd8739ae039)();
function $df37b8d23d0b3c71$export$523c0b569236b342(num) {
    if (typeof num === 'number') return `${num}px`;
    return num;
}
function $df37b8d23d0b3c71$export$71c98ec84f0481d3(style, tokenKey, styleId, customizeAttrs = {}, plain = false) {
    if (plain) return style;
    const attrs = {
        ...customizeAttrs,
        [(0, $6eb27787545be803$export$5d99297dcd5476ac)]: tokenKey,
        [(0, $6eb27787545be803$export$89ce1123b3c0bd9e)]: styleId
    };
    const attrStr = Object.keys(attrs).map((attr)=>{
        const val = attrs[attr];
        return val ? `${attr}="${val}"` : null;
    }).filter((v)=>v).join(' ');
    return `<style ${attrStr}>${style}</style>`;
}
function $df37b8d23d0b3c71$export$9c59b80dda569a6e(options) {
    const { hashCls: hashCls, hashPriority: hashPriority = 'low' } = options || {};
    if (!hashCls) return '';
    const hashSelector = `.${hashCls}`;
    return hashPriority === 'low' ? `:where(${hashSelector})` : hashSelector;
}



const $67936b70b30a4662$export$309b3b095f0c7662 = (token, prefix = '')=>{
    return `--${prefix ? `${prefix}-` : ''}${token}`.replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1-$2').replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
};
const $67936b70b30a4662$export$a27ef1ee9bbc757e = (cssVars, hashId, options)=>{
    const { hashCls: hashCls, hashPriority: hashPriority = 'low' } = options || {};
    if (!Object.keys(cssVars).length) return '';
    return `${(0, $df37b8d23d0b3c71$export$9c59b80dda569a6e)({
        hashCls: hashCls,
        hashPriority: hashPriority
    })}.${hashId}${options?.scope ? `.${options.scope}` : ''}{${Object.entries(cssVars).map(([key, value])=>`${key}:${value};`).join('')}}`;
};
const $67936b70b30a4662$export$67858afe85bce49f = (token, themeKey, config)=>{
    const { hashCls: hashCls, hashPriority: hashPriority = 'low', prefix: prefix, unitless: unitless, ignore: ignore, preserve: preserve } = config || {};
    const cssVars = {};
    const result = {};
    Object.entries(token).forEach(([key, value])=>{
        if (preserve?.[key]) result[key] = value;
        else if ((typeof value === 'string' || typeof value === 'number') && !ignore?.[key]) {
            const cssVar = $67936b70b30a4662$export$309b3b095f0c7662(key, prefix);
            cssVars[cssVar] = typeof value === 'number' && !unitless?.[key] ? `${value}px` : String(value);
            result[key] = `var(${cssVar})`;
        }
    });
    return [
        result,
        $67936b70b30a4662$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config?.scope,
            hashCls: hashCls,
            hashPriority: hashPriority
        })
    ];
};



var $ltGt3 = parcelRequire("ltGt3");


function $38e3dceceba072e3$var$useProdHMR() {
    return false;
}
let $38e3dceceba072e3$var$webpackHMR = false;
function $38e3dceceba072e3$var$useDevHMR() {
    return $38e3dceceba072e3$var$webpackHMR;
}
var $38e3dceceba072e3$export$2e2bcd8739ae039 = $38e3dceceba072e3$var$useProdHMR;
var $38e3dceceba072e3$var$args;


const $52f8c463c46e455d$var$effectMap = new Map();
function $52f8c463c46e455d$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    const { cache: globalCache } = $ltGt3.useContext((0, $6eb27787545be803$export$2e2bcd8739ae039));
    const fullPath = [
        prefix,
        ...keyPath
    ];
    const fullPathStr = (0, $c730a371eb0530a1$export$1d14e1d8187b9aad)(fullPath);
    const HMRUpdate = (0, $38e3dceceba072e3$export$2e2bcd8739ae039)();
    const buildCache = (updater)=>{
        globalCache.opUpdate(fullPathStr, (prevCache)=>{
            const [times = 0, cache] = prevCache || [
                undefined,
                undefined
            ];
            // HMR should always ignore cache since developer may change it
            let tmpCache = cache;
            const mergedCache = tmpCache || cacheFn();
            const data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $ltGt3.useMemo(()=>{
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        fullPathStr
    ]);
    let cacheEntity = globalCache.opGet(fullPathStr);
    const cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $ltGt3.useInsertionEffect)(()=>{
        buildCache(([times, cache])=>[
                times + 1,
                cache
            ]);
        if (!$52f8c463c46e455d$var$effectMap.has(fullPathStr)) {
            onCacheEffect?.(cacheContent);
            $52f8c463c46e455d$var$effectMap.set(fullPathStr, true);
            // 微任务清理混存，可以认为是单次 batch render 中只触发一次 effect
            Promise.resolve().then(()=>{
                $52f8c463c46e455d$var$effectMap.delete(fullPathStr);
            });
        }
        return ()=>{
            globalCache.opUpdate(fullPathStr, (prevCache)=>{
                const [times = 0, cache] = prevCache || [];
                const nextCount = times - 1;
                if (nextCount === 0) {
                    onCacheRemove?.(cache, false);
                    $52f8c463c46e455d$var$effectMap.delete(fullPathStr);
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        fullPathStr
    ]);
    return cacheContent;
}


const $8cff302f4c2cd4b3$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
const $8cff302f4c2cd4b3$var$hashPrefix = 'css';
const $8cff302f4c2cd4b3$var$tokenKeys = new Map();
function $8cff302f4c2cd4b3$var$recordCleanToken(tokenKey) {
    $8cff302f4c2cd4b3$var$tokenKeys.set(tokenKey, ($8cff302f4c2cd4b3$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $8cff302f4c2cd4b3$var$removeStyleTags(key, instanceId) {
    if (typeof document !== 'undefined') {
        const styles = document.querySelectorAll(`style[${(0, $6eb27787545be803$export$5d99297dcd5476ac)}="${key}"]`);
        styles.forEach((style)=>{
            if (style[0, $6eb27787545be803$export$4c16a0c02134a7dc] === instanceId) style.parentNode?.removeChild(style);
        });
    }
}
const $8cff302f4c2cd4b3$var$TOKEN_THRESHOLD = -1;
// Remove will check current keys first
function $8cff302f4c2cd4b3$var$cleanTokenStyle(tokenKey, instanceId) {
    $8cff302f4c2cd4b3$var$tokenKeys.set(tokenKey, ($8cff302f4c2cd4b3$var$tokenKeys.get(tokenKey) || 0) - 1);
    const cleanableKeyList = new Set();
    $8cff302f4c2cd4b3$var$tokenKeys.forEach((value, key)=>{
        if (value <= 0) cleanableKeyList.add(key);
    });
    // Should keep tokens under threshold for not to insert style too often
    if ($8cff302f4c2cd4b3$var$tokenKeys.size - cleanableKeyList.size > $8cff302f4c2cd4b3$var$TOKEN_THRESHOLD) cleanableKeyList.forEach((key)=>{
        $8cff302f4c2cd4b3$var$removeStyleTags(key, instanceId);
        $8cff302f4c2cd4b3$var$tokenKeys.delete(key);
    });
}
const $8cff302f4c2cd4b3$export$18602cb46ae80b62 = (originToken, overrideToken, theme, format)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    let mergedDerivativeToken = {
        ...derivativeToken,
        ...overrideToken
    };
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
const $8cff302f4c2cd4b3$export$270fba097347f4fa = 'token';
function $8cff302f4c2cd4b3$export$2e2bcd8739ae039(theme, tokens, option) {
    const { cache: { instanceId: instanceId }, container: container, hashPriority: hashPriority } = (0, $ltGt3.useContext)((0, $6eb27787545be803$export$2e2bcd8739ae039));
    const { salt: salt = '', override: override = $8cff302f4c2cd4b3$var$EMPTY_OVERRIDE, formatToken: formatToken, getComputedToken: compute, cssVar: cssVar } = option;
    // Basic - We do basic cache here
    const mergedToken = (0, $df37b8d23d0b3c71$export$6aabcc1951563d93)(()=>Object.assign({}, ...tokens), tokens);
    const tokenStr = (0, $df37b8d23d0b3c71$export$597374558a261efc)(mergedToken);
    const overrideTokenStr = (0, $df37b8d23d0b3c71$export$597374558a261efc)(override);
    const cssVarStr = (0, $df37b8d23d0b3c71$export$597374558a261efc)(cssVar);
    const cachedToken = (0, $52f8c463c46e455d$export$2e2bcd8739ae039)($8cff302f4c2cd4b3$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], ()=>{
        const mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $8cff302f4c2cd4b3$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        const actualToken = {
            ...mergedDerivativeToken
        };
        // Optimize for `useStyleRegister` performance
        const mergedSalt = `${salt}_${cssVar.prefix}`;
        const hashId = (0, $d28312f0b78911be$export$2e2bcd8739ae039)(mergedSalt);
        const hashCls = `${$8cff302f4c2cd4b3$var$hashPrefix}-${(0, $d28312f0b78911be$export$2e2bcd8739ae039)(mergedSalt)}`;
        actualToken._tokenKey = (0, $df37b8d23d0b3c71$export$6c82d0ebe8f2ea2c)(actualToken, mergedSalt);
        // Replace token value with css variables
        const [tokenWithCssVar, cssVarsStr] = (0, $67936b70b30a4662$export$67858afe85bce49f)(mergedDerivativeToken, cssVar.key, {
            prefix: cssVar.prefix,
            ignore: cssVar.ignore,
            unitless: cssVar.unitless,
            preserve: cssVar.preserve,
            hashPriority: hashPriority,
            hashCls: cssVar.hashed ? hashCls : undefined
        });
        tokenWithCssVar._hashId = hashId;
        $8cff302f4c2cd4b3$var$recordCleanToken(cssVar.key);
        return [
            tokenWithCssVar,
            hashCls,
            actualToken,
            cssVarsStr,
            cssVar.key
        ];
    }, ([, , , , themeKey])=>{
        // Remove token will remove all related style
        $8cff302f4c2cd4b3$var$cleanTokenStyle(themeKey, instanceId);
    }, ([, , , cssVarsStr, themeKey])=>{
        if (!cssVarsStr) return;
        const style = (0, $d058379f2019d619$export$4d99a2890bb989f0)(cssVarsStr, (0, $d28312f0b78911be$export$2e2bcd8739ae039)(`css-var-${themeKey}`), {
            mark: (0, $6eb27787545be803$export$89ce1123b3c0bd9e),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        });
        style[0, $6eb27787545be803$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $6eb27787545be803$export$5d99297dcd5476ac), themeKey);
    });
    return cachedToken;
}
const $8cff302f4c2cd4b3$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [, , realToken, styleStr, cssVarKey] = cache;
    const { plain: plain } = options || {};
    if (!styleStr) return null;
    const styleId = realToken._tokenKey;
    const order = -999;
    // ====================== Style ======================
    // Used for rc-util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    const styleText = (0, $df37b8d23d0b3c71$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};




var $ltGt3 = parcelRequire("ltGt3");







var $ltGt3 = parcelRequire("ltGt3");
var $0c34d683ac0b1109$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $0c34d683ac0b1109$export$2e2bcd8739ae039 = $0c34d683ac0b1109$var$unitlessKeys;


var $adba82aa09638379$export$71ad59f2e432cfe8 = '-ms-';
var $adba82aa09638379$export$2c0f367103c8d01c = '-moz-';
var $adba82aa09638379$export$39dfd62a25e0fe93 = '-webkit-';
var $adba82aa09638379$export$a29989082612d0d9 = 'comm';
var $adba82aa09638379$export$aa3a2e812ca8570d = 'rule';
var $adba82aa09638379$export$527d108ccf083c2b = 'decl';
var $adba82aa09638379$export$d3d35020fa5b54f0 = '@page';
var $adba82aa09638379$export$500415a86c544f73 = '@media';
var $adba82aa09638379$export$a763edbf796b780a = '@import';
var $adba82aa09638379$export$2790aeb8b4e5c826 = '@charset';
var $adba82aa09638379$export$1cc683e23b84b133 = '@viewport';
var $adba82aa09638379$export$9447a5efea57e862 = '@supports';
var $adba82aa09638379$export$ef011b4e114b1fba = '@document';
var $adba82aa09638379$export$6aad947bda0f3f46 = '@namespace';
var $adba82aa09638379$export$b44a8529a35fcb60 = '@keyframes';
var $adba82aa09638379$export$2c16de31893252e6 = '@font-face';
var $adba82aa09638379$export$3d846dd52e150c6f = '@counter-style';
var $adba82aa09638379$export$22314bfbb57653fe = '@font-feature-values';
var $adba82aa09638379$export$d773506282b3cfe6 = '@layer';
var $adba82aa09638379$export$1c5a554c78c0cd12 = '@scope';


/**
 * @param {number}
 * @return {number}
 */ var $98d861154f654f5b$export$2335f513bbd82c6d = Math.abs;
var $98d861154f654f5b$export$6788812c4e6611e6 = String.fromCharCode;
var $98d861154f654f5b$export$e6e34fd1f2686227 = Object.assign;
function $98d861154f654f5b$export$d6af199866bfb566(value, length) {
    return $98d861154f654f5b$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $98d861154f654f5b$export$a9db5e087081082d(value, 0)) << 2 ^ $98d861154f654f5b$export$a9db5e087081082d(value, 1)) << 2 ^ $98d861154f654f5b$export$a9db5e087081082d(value, 2)) << 2 ^ $98d861154f654f5b$export$a9db5e087081082d(value, 3) : 0;
}
function $98d861154f654f5b$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $98d861154f654f5b$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $98d861154f654f5b$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $98d861154f654f5b$export$f8e21b1e77979a08(value, search, position) {
    return value.indexOf(search, position);
}
function $98d861154f654f5b$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $98d861154f654f5b$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $98d861154f654f5b$export$36776f635604f274(value) {
    return value.length;
}
function $98d861154f654f5b$export$f9084667e487ed46(value) {
    return value.length;
}
function $98d861154f654f5b$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $98d861154f654f5b$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}
function $98d861154f654f5b$export$3dea766d36a8935f(array, pattern) {
    return array.filter(function(value) {
        return !$98d861154f654f5b$export$4659b591c19bdf3d(value, pattern);
    });
}



var $db8717cf7248451d$export$53f1d5ea8de3d7c = 1;
var $db8717cf7248451d$export$4e0c71f277ca26b3 = 1;
var $db8717cf7248451d$export$f24224f1c91d8156 = 0;
var $db8717cf7248451d$export$5880b8b5730aff45 = 0;
var $db8717cf7248451d$export$c0306caf338ac095 = 0;
var $db8717cf7248451d$export$30a86d91af8ff6e6 = '';
function $db8717cf7248451d$export$35059013cd4a06db(value, root, parent, type, props, children, length, siblings) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $db8717cf7248451d$export$53f1d5ea8de3d7c,
        column: $db8717cf7248451d$export$4e0c71f277ca26b3,
        length: length,
        return: '',
        siblings: siblings
    };
}
function $db8717cf7248451d$export$784d13d8ee351f07(root, props) {
    return (0, $98d861154f654f5b$export$e6e34fd1f2686227)($db8717cf7248451d$export$35059013cd4a06db('', null, null, '', null, null, 0, root.siblings), root, {
        length: -root.length
    }, props);
}
function $db8717cf7248451d$export$590e8b2c435046d9(root) {
    while(root.root)root = $db8717cf7248451d$export$784d13d8ee351f07(root.root, {
        children: [
            root
        ]
    });
    (0, $98d861154f654f5b$export$10d8903dec122b9d)(root, root.siblings);
}
function $db8717cf7248451d$export$eba6f6f03b0a92e7() {
    return $db8717cf7248451d$export$c0306caf338ac095;
}
function $db8717cf7248451d$export$232faf9add678146() {
    $db8717cf7248451d$export$c0306caf338ac095 = $db8717cf7248451d$export$5880b8b5730aff45 > 0 ? (0, $98d861154f654f5b$export$a9db5e087081082d)($db8717cf7248451d$export$30a86d91af8ff6e6, --$db8717cf7248451d$export$5880b8b5730aff45) : 0;
    if ($db8717cf7248451d$export$4e0c71f277ca26b3--, $db8717cf7248451d$export$c0306caf338ac095 === 10) $db8717cf7248451d$export$4e0c71f277ca26b3 = 1, $db8717cf7248451d$export$53f1d5ea8de3d7c--;
    return $db8717cf7248451d$export$c0306caf338ac095;
}
function $db8717cf7248451d$export$48cfd1e771a65c4f() {
    $db8717cf7248451d$export$c0306caf338ac095 = $db8717cf7248451d$export$5880b8b5730aff45 < $db8717cf7248451d$export$f24224f1c91d8156 ? (0, $98d861154f654f5b$export$a9db5e087081082d)($db8717cf7248451d$export$30a86d91af8ff6e6, $db8717cf7248451d$export$5880b8b5730aff45++) : 0;
    if ($db8717cf7248451d$export$4e0c71f277ca26b3++, $db8717cf7248451d$export$c0306caf338ac095 === 10) $db8717cf7248451d$export$4e0c71f277ca26b3 = 1, $db8717cf7248451d$export$53f1d5ea8de3d7c++;
    return $db8717cf7248451d$export$c0306caf338ac095;
}
function $db8717cf7248451d$export$4d3fb11e950abb9e() {
    return (0, $98d861154f654f5b$export$a9db5e087081082d)($db8717cf7248451d$export$30a86d91af8ff6e6, $db8717cf7248451d$export$5880b8b5730aff45);
}
function $db8717cf7248451d$export$e88cb2efb12ae807() {
    return $db8717cf7248451d$export$5880b8b5730aff45;
}
function $db8717cf7248451d$export$58adb3bec8346d0f(begin, end) {
    return (0, $98d861154f654f5b$export$2f35ab04d2335697)($db8717cf7248451d$export$30a86d91af8ff6e6, begin, end);
}
function $db8717cf7248451d$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $db8717cf7248451d$export$2de70f21292aac9e(value) {
    return $db8717cf7248451d$export$53f1d5ea8de3d7c = $db8717cf7248451d$export$4e0c71f277ca26b3 = 1, $db8717cf7248451d$export$f24224f1c91d8156 = (0, $98d861154f654f5b$export$36776f635604f274)($db8717cf7248451d$export$30a86d91af8ff6e6 = value), $db8717cf7248451d$export$5880b8b5730aff45 = 0, [];
}
function $db8717cf7248451d$export$45918ac1574455b1(value) {
    return $db8717cf7248451d$export$30a86d91af8ff6e6 = '', value;
}
function $db8717cf7248451d$export$410ac95b9ec204b8(type) {
    return (0, $98d861154f654f5b$export$87c2784dc9fc4ab)($db8717cf7248451d$export$58adb3bec8346d0f($db8717cf7248451d$export$5880b8b5730aff45 - 1, $db8717cf7248451d$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $db8717cf7248451d$export$660b2ee2d4fb4eff(value) {
    return $db8717cf7248451d$export$45918ac1574455b1($db8717cf7248451d$export$5f8c09e3ae6f64e1($db8717cf7248451d$export$2de70f21292aac9e(value)));
}
function $db8717cf7248451d$export$7af1228ff777d175(type) {
    while($db8717cf7248451d$export$c0306caf338ac095 = $db8717cf7248451d$export$4d3fb11e950abb9e())if ($db8717cf7248451d$export$c0306caf338ac095 < 33) $db8717cf7248451d$export$48cfd1e771a65c4f();
    else break;
    return $db8717cf7248451d$export$9e1725a4cfeada27(type) > 2 || $db8717cf7248451d$export$9e1725a4cfeada27($db8717cf7248451d$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $db8717cf7248451d$export$5f8c09e3ae6f64e1(children) {
    while($db8717cf7248451d$export$48cfd1e771a65c4f())switch($db8717cf7248451d$export$9e1725a4cfeada27($db8717cf7248451d$export$c0306caf338ac095)){
        case 0:
            (0, $98d861154f654f5b$export$10d8903dec122b9d)($db8717cf7248451d$export$c2ab62c7bf24634($db8717cf7248451d$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $98d861154f654f5b$export$10d8903dec122b9d)($db8717cf7248451d$export$410ac95b9ec204b8($db8717cf7248451d$export$c0306caf338ac095), children);
            break;
        default:
            (0, $98d861154f654f5b$export$10d8903dec122b9d)((0, $98d861154f654f5b$export$6788812c4e6611e6)($db8717cf7248451d$export$c0306caf338ac095), children);
    }
    return children;
}
function $db8717cf7248451d$export$955ba06d119e085e(index, count) {
    while(--count && $db8717cf7248451d$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($db8717cf7248451d$export$c0306caf338ac095 < 48 || $db8717cf7248451d$export$c0306caf338ac095 > 102 || $db8717cf7248451d$export$c0306caf338ac095 > 57 && $db8717cf7248451d$export$c0306caf338ac095 < 65 || $db8717cf7248451d$export$c0306caf338ac095 > 70 && $db8717cf7248451d$export$c0306caf338ac095 < 97) break;
    return $db8717cf7248451d$export$58adb3bec8346d0f(index, $db8717cf7248451d$export$e88cb2efb12ae807() + (count < 6 && $db8717cf7248451d$export$4d3fb11e950abb9e() == 32 && $db8717cf7248451d$export$48cfd1e771a65c4f() == 32));
}
function $db8717cf7248451d$export$c889f2fcc19dbf12(type) {
    while($db8717cf7248451d$export$48cfd1e771a65c4f())switch($db8717cf7248451d$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $db8717cf7248451d$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $db8717cf7248451d$export$c889f2fcc19dbf12($db8717cf7248451d$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $db8717cf7248451d$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $db8717cf7248451d$export$48cfd1e771a65c4f();
            break;
    }
    return $db8717cf7248451d$export$5880b8b5730aff45;
}
function $db8717cf7248451d$export$4254d4e2b3745c4c(type, index) {
    while($db8717cf7248451d$export$48cfd1e771a65c4f())// //
    if (type + $db8717cf7248451d$export$c0306caf338ac095 === 57) break;
    else if (type + $db8717cf7248451d$export$c0306caf338ac095 === 84 && $db8717cf7248451d$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $db8717cf7248451d$export$58adb3bec8346d0f(index, $db8717cf7248451d$export$5880b8b5730aff45 - 1) + '*' + (0, $98d861154f654f5b$export$6788812c4e6611e6)(type === 47 ? type : $db8717cf7248451d$export$48cfd1e771a65c4f());
}
function $db8717cf7248451d$export$c2ab62c7bf24634(index) {
    while(!$db8717cf7248451d$export$9e1725a4cfeada27($db8717cf7248451d$export$4d3fb11e950abb9e()))$db8717cf7248451d$export$48cfd1e771a65c4f();
    return $db8717cf7248451d$export$58adb3bec8346d0f(index, $db8717cf7248451d$export$5880b8b5730aff45);
}


function $b3d53f0d6f0256a2$export$ef7acd7185315e22(value) {
    return (0, $db8717cf7248451d$export$45918ac1574455b1)($b3d53f0d6f0256a2$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $db8717cf7248451d$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $b3d53f0d6f0256a2$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $db8717cf7248451d$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $98d861154f654f5b$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $98d861154f654f5b$export$f8e21b1e77979a08)(characters += (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)((0, $db8717cf7248451d$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f', (0, $98d861154f654f5b$export$2335f513bbd82c6d)(index ? points[index - 1] : 0)) != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $db8717cf7248451d$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $db8717cf7248451d$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $db8717cf7248451d$export$955ba06d119e085e)((0, $db8717cf7248451d$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $db8717cf7248451d$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $98d861154f654f5b$export$10d8903dec122b9d)($b3d53f0d6f0256a2$export$4a34f930e789283c((0, $db8717cf7248451d$export$4254d4e2b3745c4c)((0, $db8717cf7248451d$export$48cfd1e771a65c4f)(), (0, $db8717cf7248451d$export$e88cb2efb12ae807)()), root, parent, declarations), declarations);
                    if (((0, $db8717cf7248451d$export$9e1725a4cfeada27)(previous || 1) == 5 || (0, $db8717cf7248451d$export$9e1725a4cfeada27)((0, $db8717cf7248451d$export$4d3fb11e950abb9e)() || 1) == 5) && (0, $98d861154f654f5b$export$36776f635604f274)(characters) && (0, $98d861154f654f5b$export$2f35ab04d2335697)(characters, -1, void 0) !== ' ') characters += ' ';
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $98d861154f654f5b$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && ((0, $98d861154f654f5b$export$36776f635604f274)(characters) - length || variable === 0 && previous === 47)) (0, $98d861154f654f5b$export$10d8903dec122b9d)(property > 32 ? $b3d53f0d6f0256a2$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1, declarations) : $b3d53f0d6f0256a2$export$f8483753829ec8f3((0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $98d861154f654f5b$export$10d8903dec122b9d)(reference = $b3d53f0d6f0256a2$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
                    if (character === 123) {
                        if (offset === 0) $b3d53f0d6f0256a2$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else {
                            switch(atrule){
                                // c(ontainer)
                                case 99:
                                    if ((0, $98d861154f654f5b$export$a9db5e087081082d)(characters, 3) === 110) break;
                                // l(ayer)
                                case 108:
                                    if ((0, $98d861154f654f5b$export$a9db5e087081082d)(characters, 2) === 97) break;
                                default:
                                    offset = 0;
                                // d(ocument) m(edia) s(upports)
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (offset) $b3d53f0d6f0256a2$export$98e6a39c04603d36(value, reference, reference, rule && (0, $98d861154f654f5b$export$10d8903dec122b9d)($b3d53f0d6f0256a2$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
                            else $b3d53f0d6f0256a2$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                ''
                            ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $98d861154f654f5b$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $db8717cf7248451d$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $98d861154f654f5b$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $98d861154f654f5b$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $db8717cf7248451d$export$4d3fb11e950abb9e)() === 45) characters += (0, $db8717cf7248451d$export$410ac95b9ec204b8)((0, $db8717cf7248451d$export$48cfd1e771a65c4f)());
                    atrule = (0, $db8717cf7248451d$export$4d3fb11e950abb9e)(), offset = length = (0, $98d861154f654f5b$export$36776f635604f274)(type = characters += (0, $db8717cf7248451d$export$c2ab62c7bf24634)((0, $db8717cf7248451d$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $98d861154f654f5b$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $b3d53f0d6f0256a2$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $98d861154f654f5b$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $98d861154f654f5b$export$2f35ab04d2335697)(value, post + 1, post = (0, $98d861154f654f5b$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $98d861154f654f5b$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $db8717cf7248451d$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $adba82aa09638379$export$aa3a2e812ca8570d) : type, props, children, length, siblings);
}
function $b3d53f0d6f0256a2$export$4a34f930e789283c(value, root, parent, siblings) {
    return (0, $db8717cf7248451d$export$35059013cd4a06db)(value, root, parent, (0, $adba82aa09638379$export$a29989082612d0d9), (0, $98d861154f654f5b$export$6788812c4e6611e6)((0, $db8717cf7248451d$export$eba6f6f03b0a92e7)()), (0, $98d861154f654f5b$export$2f35ab04d2335697)(value, 2, -2), 0, siblings);
}
function $b3d53f0d6f0256a2$export$f8483753829ec8f3(value, root, parent, length, siblings) {
    return (0, $db8717cf7248451d$export$35059013cd4a06db)(value, root, parent, (0, $adba82aa09638379$export$527d108ccf083c2b), (0, $98d861154f654f5b$export$2f35ab04d2335697)(value, 0, length), (0, $98d861154f654f5b$export$2f35ab04d2335697)(value, length + 1, -1), length, siblings);
}






function $a085de8c37e246b9$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    for(var i = 0; i < children.length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $a085de8c37e246b9$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $adba82aa09638379$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $adba82aa09638379$export$a763edbf796b780a:
        case 0, $adba82aa09638379$export$6aad947bda0f3f46:
        case 0, $adba82aa09638379$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $adba82aa09638379$export$a29989082612d0d9:
            return '';
        case 0, $adba82aa09638379$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $a085de8c37e246b9$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $adba82aa09638379$export$aa3a2e812ca8570d:
            if (!(0, $98d861154f654f5b$export$36776f635604f274)(element.value = element.props.join(','))) return '';
    }
    return (0, $98d861154f654f5b$export$36776f635604f274)(children = $a085de8c37e246b9$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $c147a70af7a4155b$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $98d861154f654f5b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + value;
        // mask-composite
        case 4855:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value.replace('add', 'source-over').replace('substract', 'source-out').replace('intersect', 'source-in').replace('exclude', 'xor') + value;
        // tab-size
        case 4789:
            return (0, $adba82aa09638379$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + (0, $adba82aa09638379$export$2c0f367103c8d01c) + value + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $98d861154f654f5b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $adba82aa09638379$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $98d861154f654f5b$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $adba82aa09638379$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + 'box-' + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $adba82aa09638379$export$39dfd62a25e0fe93) + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $adba82aa09638379$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)((0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)((0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $adba82aa09638379$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $adba82aa09638379$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $adba82aa09638379$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)((0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $adba82aa09638379$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /space-between/, 'justify') + (0, $adba82aa09638379$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $98d861154f654f5b$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $adba82aa09638379$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $98d861154f654f5b$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $adba82aa09638379$export$71ad59f2e432cfe8) + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $98d861154f654f5b$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $98d861154f654f5b$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span', 0) ? value : (0, $adba82aa09638379$export$71ad59f2e432cfe8) + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $98d861154f654f5b$export$f8e21b1e77979a08)(children, 'span', 0) ? (0, $98d861154f654f5b$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $98d861154f654f5b$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $98d861154f654f5b$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $adba82aa09638379$export$71ad59f2e432cfe8) + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $98d861154f654f5b$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $adba82aa09638379$export$71ad59f2e432cfe8) + (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)((0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $adba82aa09638379$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $98d861154f654f5b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $98d861154f654f5b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $98d861154f654f5b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $adba82aa09638379$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $adba82aa09638379$export$2c0f367103c8d01c) + ((0, $98d861154f654f5b$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $98d861154f654f5b$export$f8e21b1e77979a08)(value, 'stretch', 0) ? $c147a70af7a4155b$export$82e9f45cca5ba907((0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $adba82aa09638379$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $adba82aa09638379$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $98d861154f654f5b$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $adba82aa09638379$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $98d861154f654f5b$export$a9db5e087081082d)(value, (0, $98d861154f654f5b$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $adba82aa09638379$export$39dfd62a25e0fe93) + ((0, $98d861154f654f5b$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $adba82aa09638379$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $adba82aa09638379$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $adba82aa09638379$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $d55e8bc355287caf$export$5a7767152ae0305f(collection) {
    var length = (0, $98d861154f654f5b$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $d55e8bc355287caf$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $d55e8bc355287caf$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $adba82aa09638379$export$527d108ccf083c2b:
                element.return = (0, $c147a70af7a4155b$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $adba82aa09638379$export$b44a8529a35fcb60:
                return (0, $a085de8c37e246b9$export$dfdc1655ccc5b9cb)([
                    (0, $db8717cf7248451d$export$784d13d8ee351f07)(element, {
                        value: (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $adba82aa09638379$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $adba82aa09638379$export$aa3a2e812ca8570d:
                if (element.length) return (0, $98d861154f654f5b$export$1be1fc439b849fdf)(children = element.props, function(value) {
                    switch((0, $98d861154f654f5b$export$4659b591c19bdf3d)(value, callback = /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            (0, $db8717cf7248451d$export$590e8b2c435046d9)((0, $db8717cf7248451d$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $adba82aa09638379$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $db8717cf7248451d$export$590e8b2c435046d9)((0, $db8717cf7248451d$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $98d861154f654f5b$export$e6e34fd1f2686227)(element, {
                                props: (0, $98d861154f654f5b$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                        // :placeholder
                        case '::placeholder':
                            (0, $db8717cf7248451d$export$590e8b2c435046d9)((0, $db8717cf7248451d$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $adba82aa09638379$export$39dfd62a25e0fe93) + 'input-$1')
                                ]
                            }));
                            (0, $db8717cf7248451d$export$590e8b2c435046d9)((0, $db8717cf7248451d$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $adba82aa09638379$export$2c0f367103c8d01c) + '$1')
                                ]
                            }));
                            (0, $db8717cf7248451d$export$590e8b2c435046d9)((0, $db8717cf7248451d$export$784d13d8ee351f07)(element, {
                                props: [
                                    (0, $98d861154f654f5b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $adba82aa09638379$export$71ad59f2e432cfe8) + 'input-$1')
                                ]
                            }));
                            (0, $db8717cf7248451d$export$590e8b2c435046d9)((0, $db8717cf7248451d$export$784d13d8ee351f07)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $98d861154f654f5b$export$e6e34fd1f2686227)(element, {
                                props: (0, $98d861154f654f5b$export$3dea766d36a8935f)(children, callback)
                            });
                            break;
                    }
                    return '';
                });
        }
    }
}
function $d55e8bc355287caf$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $adba82aa09638379$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $98d861154f654f5b$export$1be1fc439b849fdf)((0, $db8717cf7248451d$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $98d861154f654f5b$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $98d861154f654f5b$export$2f35ab04d2335697)(value, 1, (0, $98d861154f654f5b$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $98d861154f654f5b$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $98d861154f654f5b$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $98d861154f654f5b$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}



function $cd87919849096df5$export$e7b7955c4f1f8c03(message, info) {
    const { path: path, parentSelectors: parentSelectors } = info;
    (0, $a18317b8bba7a6b2$export$2e2bcd8739ae039)(false, `[Ant Design CSS-in-JS] ${path ? `Error in ${path}: ` : ''}${message}${parentSelectors.length ? ` Selector: ${parentSelectors.join(' | ')}` : ''}`);
}


const $0445ee52c97fcdab$var$linter = (key, value, info)=>{
    if (key === 'content') {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        const contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        const contentValues = [
            'normal',
            'none',
            'initial',
            'inherit',
            'unset'
        ];
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && !value.startsWith('var(') && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $cd87919849096df5$export$e7b7955c4f1f8c03)(`You seem to be using a value for 'content' without quotes, try replacing it with \`content: '"${value}"'\`.`, info);
    }
};
var $0445ee52c97fcdab$export$2e2bcd8739ae039 = $0445ee52c97fcdab$var$linter;



const $fffdde5e9fcc52d9$var$linter = (key, value, info)=>{
    if (key === 'animation') {
        if (info.hashId && value !== 'none') (0, $cd87919849096df5$export$e7b7955c4f1f8c03)(`You seem to be using hashed animation '${value}', in which case 'animationName' with Keyframe as value is recommended.`, info);
    }
};
var $fffdde5e9fcc52d9$export$2e2bcd8739ae039 = $fffdde5e9fcc52d9$var$linter;



function $94df45836ae7ea0b$var$isConcatSelector(selector) {
    const notContent = selector.match(/:not\(([^)]*)\)/)?.[1] || '';
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    const splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter((str)=>str);
    return splitCells.length > 1;
}
function $94df45836ae7ea0b$var$parsePath(info) {
    return info.parentSelectors.reduce((prev, cur)=>{
        if (!prev) return cur;
        return cur.includes('&') ? cur.replace(/&/g, prev) : `${prev} ${cur}`;
    }, '');
}
const $94df45836ae7ea0b$var$linter = (key, value, info)=>{
    const parentSelectorPath = $94df45836ae7ea0b$var$parsePath(info);
    const notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($94df45836ae7ea0b$var$isConcatSelector)) (0, $cd87919849096df5$export$e7b7955c4f1f8c03)(`Concat ':not' selector not support in legacy browsers.`, info);
};
var $94df45836ae7ea0b$export$2e2bcd8739ae039 = $94df45836ae7ea0b$var$linter;



const $23ce61e751257c76$var$linter = (key, value, info)=>{
    switch(key){
        case 'marginLeft':
        case 'marginRight':
        case 'paddingLeft':
        case 'paddingRight':
        case 'left':
        case 'right':
        case 'borderLeft':
        case 'borderLeftWidth':
        case 'borderLeftStyle':
        case 'borderLeftColor':
        case 'borderRight':
        case 'borderRightWidth':
        case 'borderRightStyle':
        case 'borderRightColor':
        case 'borderTopLeftRadius':
        case 'borderTopRightRadius':
        case 'borderBottomLeftRadius':
        case 'borderBottomRightRadius':
            (0, $cd87919849096df5$export$e7b7955c4f1f8c03)(`You seem to be using non-logical property '${key}' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            return;
        case 'margin':
        case 'padding':
        case 'borderWidth':
        case 'borderStyle':
            // case 'borderColor':
            if (typeof value === 'string') {
                const valueArr = value.split(' ').map((item)=>item.trim());
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $cd87919849096df5$export$e7b7955c4f1f8c03)(`You seem to be using '${key}' property with different left ${key} and right ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            }
            return;
        case 'clear':
        case 'textAlign':
            if (value === 'left' || value === 'right') (0, $cd87919849096df5$export$e7b7955c4f1f8c03)(`You seem to be using non-logical value '${value}' of ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            return;
        case 'borderRadius':
            if (typeof value === 'string') {
                const radiusGroups = value.split('/').map((item)=>item.trim());
                const invalid = radiusGroups.reduce((result, group)=>{
                    if (result) return result;
                    const radiusArr = group.split(' ').map((item)=>item.trim());
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $cd87919849096df5$export$e7b7955c4f1f8c03)(`You seem to be using non-logical value '${value}' of ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            }
            return;
        default:
    }
};
var $23ce61e751257c76$export$2e2bcd8739ae039 = $23ce61e751257c76$var$linter;



const $955658b142665923$var$linter = (key, value, info)=>{
    if (typeof value === 'string' && /NaN/g.test(value) || Number.isNaN(value)) (0, $cd87919849096df5$export$e7b7955c4f1f8c03)(`Unexpected 'NaN' in property '${key}: ${value}'.`, info);
};
var $955658b142665923$export$2e2bcd8739ae039 = $955658b142665923$var$linter;



const $e0155908ed25764a$var$linter = (key, value, info)=>{
    if (info.parentSelectors.some((selector)=>{
        const selectors = selector.split(',');
        return selectors.some((item)=>item.split('&').length > 2);
    })) (0, $cd87919849096df5$export$e7b7955c4f1f8c03)('Should not use more than one `&` in a selector.', info);
};
var $e0155908ed25764a$export$2e2bcd8739ae039 = $e0155908ed25764a$var$linter;








const $24913fad303e5915$export$1c054aa01963e47e = 'data-ant-cssinjs-cache-path';
const $24913fad303e5915$export$e0a2f8ff7fc63361 = '_FILE_STYLE__';
function $24913fad303e5915$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map((path)=>{
        const hash = cachePathMap[path];
        return `${path}:${hash}`;
    }).join(';');
}
let $24913fad303e5915$var$cachePathMap;
let $24913fad303e5915$var$fromCSSFile = true;
function $24913fad303e5915$export$aad8462122ac592b(mockCache, fromFile = true) {
    $24913fad303e5915$var$cachePathMap = mockCache;
    $24913fad303e5915$var$fromCSSFile = fromFile;
}
function $24913fad303e5915$export$18298bb220d85216() {
    if (!$24913fad303e5915$var$cachePathMap) {
        $24913fad303e5915$var$cachePathMap = {};
        if ((0, $6ffdd9161f116fb2$export$2e2bcd8739ae039)()) {
            const div = document.createElement('div');
            div.className = $24913fad303e5915$export$1c054aa01963e47e;
            div.style.position = 'fixed';
            div.style.visibility = 'hidden';
            div.style.top = '-9999px';
            document.body.appendChild(div);
            let content = getComputedStyle(div).content || '';
            content = content.replace(/^"/, '').replace(/"$/, '');
            // Fill data
            content.split(';').forEach((item)=>{
                const [path, hash] = item.split(':');
                $24913fad303e5915$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            const inlineMapStyle = document.querySelector(`style[${$24913fad303e5915$export$1c054aa01963e47e}]`);
            if (inlineMapStyle) {
                $24913fad303e5915$var$fromCSSFile = false;
                inlineMapStyle.parentNode?.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $24913fad303e5915$export$5aa0d776d676ab98(path) {
    $24913fad303e5915$export$18298bb220d85216();
    return !!$24913fad303e5915$var$cachePathMap[path];
}
function $24913fad303e5915$export$d3851dfd3659b2ce(path) {
    const hash = $24913fad303e5915$var$cachePathMap[path];
    let styleStr = null;
    if (hash && (0, $6ffdd9161f116fb2$export$2e2bcd8739ae039)()) {
        if ($24913fad303e5915$var$fromCSSFile) styleStr = $24913fad303e5915$export$e0a2f8ff7fc63361;
        else {
            const style = document.querySelector(`style[${(0, $6eb27787545be803$export$89ce1123b3c0bd9e)}="${$24913fad303e5915$var$cachePathMap[path]}"]`);
            if (style) styleStr = style.innerHTML;
            else // Clean up since not exist anymore
            delete $24913fad303e5915$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}



const $5cbbf99d0b51a6f3$var$SKIP_CHECK = '_skip_check_';
const $5cbbf99d0b51a6f3$var$MULTI_VALUE = '_multi_value_';
function $5cbbf99d0b51a6f3$export$8756898546458274(styleStr, autoPrefix) {
    const serialized = autoPrefix ? (0, $a085de8c37e246b9$export$dfdc1655ccc5b9cb)((0, $b3d53f0d6f0256a2$export$ef7acd7185315e22)(styleStr), (0, $d55e8bc355287caf$export$5a7767152ae0305f)([
        (0, $d55e8bc355287caf$export$e08c7d021b829b7a),
        (0, $a085de8c37e246b9$export$fac44ee5b035f737)
    ])) : (0, $a085de8c37e246b9$export$dfdc1655ccc5b9cb)((0, $b3d53f0d6f0256a2$export$ef7acd7185315e22)(styleStr), (0, $a085de8c37e246b9$export$fac44ee5b035f737));
    return serialized.replace(/\{%%%\:[^;];}/g, ';');
}
function $5cbbf99d0b51a6f3$var$isCompoundCSSProperty(value) {
    return typeof value === 'object' && value && ($5cbbf99d0b51a6f3$var$SKIP_CHECK in value || $5cbbf99d0b51a6f3$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $5cbbf99d0b51a6f3$var$injectSelectorHash(key, hashId, hashPriority) {
    if (!hashId) return key;
    const hashClassName = `.${hashId}`;
    const hashSelector = hashPriority === 'low' ? `:where(${hashClassName})` : hashClassName;
    // 注入 hashId
    const keys = key.split(',').map((k)=>{
        const fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        let firstPath = fullPath[0] || '';
        const htmlElement = firstPath.match(/^\w+/)?.[0] || '';
        firstPath = `${htmlElement}${hashSelector}${firstPath.slice(htmlElement.length)}`;
        return [
            firstPath,
            ...fullPath.slice(1)
        ].join(' ');
    });
    return keys.join(',');
}
const $5cbbf99d0b51a6f3$export$e13dc740254f53d7 = (interpolation, config = {}, { root: root, injectHash: injectHash, parentSelectors: parentSelectors } = {
    root: true,
    parentSelectors: []
})=>{
    const { hashId: hashId, layer: layer, path: path, hashPriority: hashPriority, transformers: transformers = [], linters: linters = [] } = config;
    let styleStr = '';
    let effectStyle = {};
    function parseKeyframes(keyframes) {
        const animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            const [parsedStr] = $5cbbf99d0b51a6f3$export$e13dc740254f53d7(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            });
            effectStyle[animationName] = `@keyframes ${keyframes.getName(hashId)}${parsedStr}`;
        }
    }
    function flattenList(list, fullList = []) {
        list.forEach((item)=>{
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    const flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach((originStyle)=>{
        // Only root level can use raw string
        const style = typeof originStyle === 'string' && !root ? {} : originStyle;
        if (typeof style === 'string') styleStr += `${style}\n`;
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            const mergedStyle = transformers.reduce((prev, trans)=>trans?.visit?.(prev) || prev, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach((key)=>{
                const value = mergedStyle[key];
                if (typeof value === 'object' && value && (key !== 'animationName' || !value._keyframe) && !$5cbbf99d0b51a6f3$var$isCompoundCSSProperty(value)) {
                    let subInjectHash = false;
                    // 当成嵌套对象来处理
                    let mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    let nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith('@')) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else if (mergedKey === '&') // 抹掉 root selector 上的单个 &
                        mergedKey = $5cbbf99d0b51a6f3$var$injectSelectorHash('', hashId, hashPriority);
                        else // 注入 hashId
                        mergedKey = $5cbbf99d0b51a6f3$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === '&' || mergedKey === '')) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = '';
                        nextRoot = true;
                    }
                    const [parsedStr, childEffectStyle] = $5cbbf99d0b51a6f3$export$e13dc740254f53d7(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [
                            ...parentSelectors,
                            mergedKey
                        ]
                    });
                    effectStyle = {
                        ...effectStyle,
                        ...childEffectStyle
                    };
                    styleStr += `${mergedKey}${parsedStr}`;
                } else {
                    function appendStyle(cssKey, cssValue) {
                        var linter;
                        // 如果是样式则直接插入
                        const styleName = cssKey.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`);
                        // Auto suffix with px
                        let formatValue = cssValue;
                        if (!(0, $0c34d683ac0b1109$export$2e2bcd8739ae039)[cssKey] && typeof formatValue === 'number' && formatValue !== 0) formatValue = `${formatValue}px`;
                        // handle animationName & Keyframe value
                        if (cssKey === 'animationName' && cssValue?._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += `${styleName}:${formatValue};`;
                    }
                    const actualValue = value?.value ?? value;
                    if (typeof value === 'object' && value?.[$5cbbf99d0b51a6f3$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach((item)=>{
                        appendStyle(key, item);
                    });
                    else appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = `{${styleStr}}`;
    else if (layer) {
        // fixme: https://github.com/thysultan/stylis/pull/339
        if (styleStr) styleStr = `@layer ${layer.name} {${styleStr}}`;
        if (layer.dependencies) effectStyle[`@layer ${layer.name}`] = layer.dependencies.map((deps)=>`@layer ${deps}, ${layer.name};`).join('\n');
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $5cbbf99d0b51a6f3$export$412618713057f6ca(path, styleStr) {
    return (0, $d28312f0b78911be$export$2e2bcd8739ae039)(`${path.join('%')}${styleStr}`);
}
const $5cbbf99d0b51a6f3$export$1e6d9f0d06c7ec14 = 'style';
function $5cbbf99d0b51a6f3$export$2e2bcd8739ae039(info, styleFn) {
    const { path: path, hashId: hashId, layer: layer, nonce: nonce, clientOnly: clientOnly, order: order = 0 } = info;
    const { mock: mock, hashPriority: hashPriority, container: container, transformers: transformers, linters: linters, cache: cache, layer: enableLayer, autoPrefix: autoPrefix } = $ltGt3.useContext((0, $6eb27787545be803$export$2e2bcd8739ae039));
    const fullPath = [
        hashId || ''
    ];
    if (enableLayer) fullPath.push('layer');
    fullPath.push(...path);
    // Check if need insert style
    let isMergedClientSide = (0, $df37b8d23d0b3c71$export$9542afab8c2a5f48);
    (0, $52f8c463c46e455d$export$2e2bcd8739ae039)($5cbbf99d0b51a6f3$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    ()=>{
        const cachePath = fullPath.join('|');
        // Get style from SSR inline style directly
        if ((0, $24913fad303e5915$export$5aa0d776d676ab98)(cachePath)) {
            const [inlineCacheStyleStr, styleHash] = (0, $24913fad303e5915$export$d3851dfd3659b2ce)(cachePath);
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        const styleObj = styleFn();
        const [parsedStyle, effectStyle] = $5cbbf99d0b51a6f3$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: enableLayer ? layer : undefined,
            path: path.join('-'),
            transformers: transformers,
            linters: linters
        });
        const styleStr = $5cbbf99d0b51a6f3$export$8756898546458274(parsedStyle, autoPrefix || false);
        const styleId = $5cbbf99d0b51a6f3$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    (cacheValue, fromHMR)=>{
        const [, styleId] = cacheValue;
        if (fromHMR && (0, $df37b8d23d0b3c71$export$9542afab8c2a5f48)) (0, $d058379f2019d619$export$2232e336aecaa80a)(styleId, {
            mark: (0, $6eb27787545be803$export$89ce1123b3c0bd9e),
            attachTo: container
        });
    }, // Effect: Inject style here
    (cacheValue)=>{
        const [styleStr, styleId, effectStyle, , priority] = cacheValue;
        if (isMergedClientSide && styleStr !== (0, $24913fad303e5915$export$e0a2f8ff7fc63361)) {
            const mergedCSSConfig = {
                mark: (0, $6eb27787545be803$export$89ce1123b3c0bd9e),
                prepend: enableLayer ? false : 'queue',
                attachTo: container,
                priority: priority
            };
            const nonceStr = typeof nonce === 'function' ? nonce() : nonce;
            if (nonceStr) mergedCSSConfig.csp = {
                nonce: nonceStr
            };
            // ================= Split Effect Style =================
            // We will split effectStyle here since @layer should be at the top level
            const effectLayerKeys = [];
            const effectRestKeys = [];
            Object.keys(effectStyle).forEach((key)=>{
                if (key.startsWith('@layer')) effectLayerKeys.push(key);
                else effectRestKeys.push(key);
            });
            // ================= Inject Layer Style =================
            // Inject layer style
            effectLayerKeys.forEach((effectKey)=>{
                (0, $d058379f2019d619$export$4d99a2890bb989f0)($5cbbf99d0b51a6f3$export$8756898546458274(effectStyle[effectKey], autoPrefix || false), `_layer-${effectKey}`, {
                    ...mergedCSSConfig,
                    prepend: true
                });
            });
            // ==================== Inject Style ====================
            // Inject style
            const style = (0, $d058379f2019d619$export$4d99a2890bb989f0)(styleStr, styleId, mergedCSSConfig);
            style[0, $6eb27787545be803$export$4c16a0c02134a7dc] = cache.instanceId;
            // ================ Inject Effect Style =================
            // Inject client side effect style
            effectRestKeys.forEach((effectKey)=>{
                (0, $d058379f2019d619$export$4d99a2890bb989f0)($5cbbf99d0b51a6f3$export$8756898546458274(effectStyle[effectKey], autoPrefix || false), `_effect-${effectKey}`, mergedCSSConfig);
            });
        }
    });
}
const $5cbbf99d0b51a6f3$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [styleStr, styleId, effectStyle, clientOnly, order] = cache;
    const { plain: plain, autoPrefix: autoPrefix } = options || {};
    // Skip client only style
    if (clientOnly) return null;
    let keyStyleText = styleStr;
    // ====================== Share ======================
    // Used for rc-util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    // ====================== Style ======================
    keyStyleText = (0, $df37b8d23d0b3c71$export$71c98ec84f0481d3)(styleStr, undefined, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach((effectKey)=>{
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            const effectStyleStr = $5cbbf99d0b51a6f3$export$8756898546458274(effectStyle[effectKey], autoPrefix || false);
            const effectStyleHTML = (0, $df37b8d23d0b3c71$export$71c98ec84f0481d3)(effectStyleStr, undefined, `_effect-${effectKey}`, sharedAttrs, plain);
            if (effectKey.startsWith('@layer')) keyStyleText = effectStyleHTML + keyStyleText;
            else keyStyleText += effectStyleHTML;
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};


const $b27455a3575a1392$export$d96c342855c5e1fc = 'cssVar';
const $b27455a3575a1392$var$useCSSVarRegister = (config, fn)=>{
    const { key: key, prefix: prefix, unitless: unitless, ignore: ignore, token: token, hashId: hashId, scope: scope = '' } = config;
    const { cache: { instanceId: instanceId }, container: container, hashPriority: hashPriority } = (0, $ltGt3.useContext)((0, $6eb27787545be803$export$2e2bcd8739ae039));
    const { _tokenKey: tokenKey } = token;
    const stylePath = [
        ...config.path,
        key,
        scope,
        tokenKey
    ];
    const cache = (0, $52f8c463c46e455d$export$2e2bcd8739ae039)($b27455a3575a1392$export$d96c342855c5e1fc, stylePath, ()=>{
        const originToken = fn();
        const [mergedToken, cssVarsStr] = (0, $67936b70b30a4662$export$67858afe85bce49f)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope,
            hashPriority: hashPriority,
            hashCls: hashId
        });
        const styleId = (0, $5cbbf99d0b51a6f3$export$412618713057f6ca)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, ([, , styleId])=>{
        if (0, $df37b8d23d0b3c71$export$9542afab8c2a5f48) (0, $d058379f2019d619$export$2232e336aecaa80a)(styleId, {
            mark: (0, $6eb27787545be803$export$89ce1123b3c0bd9e),
            attachTo: container
        });
    }, ([, cssVarsStr, styleId])=>{
        if (!cssVarsStr) return;
        const style = (0, $d058379f2019d619$export$4d99a2890bb989f0)(cssVarsStr, styleId, {
            mark: (0, $6eb27787545be803$export$89ce1123b3c0bd9e),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        });
        style[0, $6eb27787545be803$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $6eb27787545be803$export$5d99297dcd5476ac), key);
    });
    return cache;
};
const $b27455a3575a1392$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [, styleStr, styleId, cssVarKey] = cache;
    const { plain: plain } = options || {};
    if (!styleStr) return null;
    const order = -999;
    // ====================== Style ======================
    // Used for rc-util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    const styleText = (0, $df37b8d23d0b3c71$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $b27455a3575a1392$export$2e2bcd8739ae039 = $b27455a3575a1392$var$useCSSVarRegister;





const $b0e14d55fdf3473c$var$ExtractStyleFns = {
    [(0, $5cbbf99d0b51a6f3$export$1e6d9f0d06c7ec14)]: (0, $5cbbf99d0b51a6f3$export$f9380c9a627682d3),
    [(0, $8cff302f4c2cd4b3$export$270fba097347f4fa)]: (0, $8cff302f4c2cd4b3$export$f9380c9a627682d3),
    [(0, $b27455a3575a1392$export$d96c342855c5e1fc)]: (0, $b27455a3575a1392$export$f9380c9a627682d3)
};
function $b0e14d55fdf3473c$var$isNotNull(value) {
    return value !== null;
}
function $b0e14d55fdf3473c$export$2e2bcd8739ae039(cache, options) {
    const { plain: plain = false, types: types = [
        'style',
        'token',
        'cssVar'
    ], once: once = false } = typeof options === 'boolean' ? {
        plain: options
    } : options || {};
    const matchPrefixRegexp = new RegExp(`^(${(typeof types === 'string' ? [
        types
    ] : types).join('|')})%`);
    // prefix with `style` is used for `useStyleRegister` to cache style context
    const styleKeys = Array.from(cache.cache.keys()).filter((key)=>matchPrefixRegexp.test(key));
    // Common effect styles like animation
    const effectStyles = {};
    // Mapping of cachePath to style hash
    const cachePathMap = {};
    let styleText = '';
    styleKeys.map((key)=>{
        if (once && cache.extracted.has(key)) return null; // Skip if already extracted
        const cachePath = key.replace(matchPrefixRegexp, '').replace(/%/g, '|');
        const [prefix] = key.split('%');
        const extractFn = $b0e14d55fdf3473c$var$ExtractStyleFns[prefix];
        const extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        const updateTime = cache.updateTimes.get(key) || 0;
        const [order, styleId, styleStr] = extractedStyle;
        if (key.startsWith('style')) cachePathMap[cachePath] = styleId;
        // record that this style has been extracted
        cache.extracted.add(key);
        return [
            order,
            styleStr,
            updateTime
        ];
    }).filter($b0e14d55fdf3473c$var$isNotNull).sort(([o1, , u1], [o2, , u2])=>{
        if (o1 !== o2) return o1 - o2;
        return u1 - u2;
    }).forEach(([, style])=>{
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $df37b8d23d0b3c71$export$71c98ec84f0481d3)(`.${(0, $24913fad303e5915$export$1c054aa01963e47e)}{content:"${(0, $24913fad303e5915$export$dfdc1655ccc5b9cb)(cachePathMap)}";}`, undefined, undefined, {
        [(0, $24913fad303e5915$export$1c054aa01963e47e)]: (0, $24913fad303e5915$export$1c054aa01963e47e)
    }, plain);
    return styleText;
}





class $eb725c9f616c62dd$var$Keyframe {
    name;
    style;
    constructor(name, style){
        this.name = name;
        this.style = style;
    }
    getName(hashId = '') {
        return hashId ? `${hashId}-${this.name}` : this.name;
    }
    _keyframe = true;
}
var $eb725c9f616c62dd$export$2e2bcd8739ae039 = $eb725c9f616c62dd$var$Keyframe;






function $8b643635f98a5a53$var$splitValues(value) {
    if (typeof value === 'number') return [
        [
            value
        ],
        false
    ];
    const rawStyle = String(value).trim();
    const importantCells = rawStyle.match(/(.*)(!important)/);
    const splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    let temp = [];
    let brackets = 0;
    return [
        splitStyle.reduce((list, item)=>{
            if (item.includes('(') || item.includes(')')) {
                const left = item.split('(').length - 1;
                const right = item.split(')').length - 1;
                brackets += left - right;
            }
            if (brackets >= 0) temp.push(item);
            if (brackets === 0) {
                list.push(temp.join(' '));
                temp = [];
            }
            return list;
        }, []),
        !!importantCells
    ];
}
function $8b643635f98a5a53$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
const $8b643635f98a5a53$var$keyMap = {
    // Inset
    inset: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    insetBlock: [
        'top',
        'bottom'
    ],
    insetBlockStart: [
        'top'
    ],
    insetBlockEnd: [
        'bottom'
    ],
    insetInline: [
        'left',
        'right'
    ],
    insetInlineStart: [
        'left'
    ],
    insetInlineEnd: [
        'right'
    ],
    // Margin
    marginBlock: [
        'marginTop',
        'marginBottom'
    ],
    marginBlockStart: [
        'marginTop'
    ],
    marginBlockEnd: [
        'marginBottom'
    ],
    marginInline: [
        'marginLeft',
        'marginRight'
    ],
    marginInlineStart: [
        'marginLeft'
    ],
    marginInlineEnd: [
        'marginRight'
    ],
    // Padding
    paddingBlock: [
        'paddingTop',
        'paddingBottom'
    ],
    paddingBlockStart: [
        'paddingTop'
    ],
    paddingBlockEnd: [
        'paddingBottom'
    ],
    paddingInline: [
        'paddingLeft',
        'paddingRight'
    ],
    paddingInlineStart: [
        'paddingLeft'
    ],
    paddingInlineEnd: [
        'paddingRight'
    ],
    // Border
    borderBlock: $8b643635f98a5a53$var$noSplit([
        'borderTop',
        'borderBottom'
    ]),
    borderBlockStart: $8b643635f98a5a53$var$noSplit([
        'borderTop'
    ]),
    borderBlockEnd: $8b643635f98a5a53$var$noSplit([
        'borderBottom'
    ]),
    borderInline: $8b643635f98a5a53$var$noSplit([
        'borderLeft',
        'borderRight'
    ]),
    borderInlineStart: $8b643635f98a5a53$var$noSplit([
        'borderLeft'
    ]),
    borderInlineEnd: $8b643635f98a5a53$var$noSplit([
        'borderRight'
    ]),
    // Border width
    borderBlockWidth: [
        'borderTopWidth',
        'borderBottomWidth'
    ],
    borderBlockStartWidth: [
        'borderTopWidth'
    ],
    borderBlockEndWidth: [
        'borderBottomWidth'
    ],
    borderInlineWidth: [
        'borderLeftWidth',
        'borderRightWidth'
    ],
    borderInlineStartWidth: [
        'borderLeftWidth'
    ],
    borderInlineEndWidth: [
        'borderRightWidth'
    ],
    // Border style
    borderBlockStyle: [
        'borderTopStyle',
        'borderBottomStyle'
    ],
    borderBlockStartStyle: [
        'borderTopStyle'
    ],
    borderBlockEndStyle: [
        'borderBottomStyle'
    ],
    borderInlineStyle: [
        'borderLeftStyle',
        'borderRightStyle'
    ],
    borderInlineStartStyle: [
        'borderLeftStyle'
    ],
    borderInlineEndStyle: [
        'borderRightStyle'
    ],
    // Border color
    borderBlockColor: [
        'borderTopColor',
        'borderBottomColor'
    ],
    borderBlockStartColor: [
        'borderTopColor'
    ],
    borderBlockEndColor: [
        'borderBottomColor'
    ],
    borderInlineColor: [
        'borderLeftColor',
        'borderRightColor'
    ],
    borderInlineStartColor: [
        'borderLeftColor'
    ],
    borderInlineEndColor: [
        'borderRightColor'
    ],
    // Border radius
    borderStartStartRadius: [
        'borderTopLeftRadius'
    ],
    borderStartEndRadius: [
        'borderTopRightRadius'
    ],
    borderEndStartRadius: [
        'borderBottomLeftRadius'
    ],
    borderEndEndRadius: [
        'borderBottomRightRadius'
    ]
};
function $8b643635f98a5a53$var$wrapImportantAndSkipCheck(value, important) {
    let parsedValue = value;
    if (important) parsedValue = `${parsedValue} !important`;
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ const $8b643635f98a5a53$var$transform = {
    visit: (cssObj)=>{
        const clone = {};
        Object.keys(cssObj).forEach((key)=>{
            const value = cssObj[key];
            const matchValue = $8b643635f98a5a53$var$keyMap[key];
            if (matchValue && (typeof value === 'number' || typeof value === 'string')) {
                const [values, important] = $8b643635f98a5a53$var$splitValues(value);
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach((matchKey)=>{
                    clone[matchKey] = $8b643635f98a5a53$var$wrapImportantAndSkipCheck(value, important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $8b643635f98a5a53$var$wrapImportantAndSkipCheck(values[0], important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach((matchKey, index)=>{
                    clone[matchKey] = $8b643635f98a5a53$var$wrapImportantAndSkipCheck(values[index] ?? values[0], important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach((matchKey, index)=>{
                    clone[matchKey] = $8b643635f98a5a53$var$wrapImportantAndSkipCheck(values[index] ?? values[index - 2] ?? values[0], important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $8b643635f98a5a53$export$2e2bcd8739ae039 = $8b643635f98a5a53$var$transform;


/**
 * respect https://github.com/cuth/postcss-pxtorem
 */ // @ts-ignore

const $2acf371a20d54fbe$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $2acf371a20d54fbe$var$toFixed(number, precision) {
    const multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
const $2acf371a20d54fbe$var$transform = (options = {})=>{
    const { rootValue: rootValue = 16, precision: precision = 5, mediaQuery: mediaQuery = false } = options;
    const pxReplace = (m, $1)=>{
        if (!$1) return m;
        const pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        const fixedVal = $2acf371a20d54fbe$var$toFixed(pixels / rootValue, precision);
        return `${fixedVal}rem`;
    };
    const visit = (cssObj)=>{
        const clone = {
            ...cssObj
        };
        Object.entries(cssObj).forEach(([key, value])=>{
            if (typeof value === 'string' && value.includes('px')) {
                const newValue = value.replace($2acf371a20d54fbe$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $0c34d683ac0b1109$export$2e2bcd8739ae039)[key] && typeof value === 'number' && value !== 0) clone[key] = `${value}px`.replace($2acf371a20d54fbe$var$pxRegex, pxReplace);
            // Media queries
            const mergedKey = key.trim();
            if (mergedKey.startsWith('@') && mergedKey.includes('px') && mediaQuery) {
                const newKey = key.replace($2acf371a20d54fbe$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $2acf371a20d54fbe$export$2e2bcd8739ae039 = $2acf371a20d54fbe$var$transform;




const $4087269e78b3d485$export$73abaea5066f503b = {
    supportModernCSS: ()=>(0, $df37b8d23d0b3c71$export$f51d3b8ac4ac9ed1)() && (0, $df37b8d23d0b3c71$export$64a912f57d5de48e)()
};



var $ltGt3 = parcelRequire("ltGt3");
const $6513c993325f3802$var$IconContext = /*#__PURE__*/ (0, $ltGt3.createContext)({});
var $6513c993325f3802$export$2e2bcd8739ae039 = $6513c993325f3802$var$IconContext;





var $ltGt3 = parcelRequire("ltGt3");

function $9530c27c700696d0$export$8793edee2d425525() {}
const { resetWarned: $9530c27c700696d0$var$rcResetWarned } = (0, $474154b5a64067c8$export$2e2bcd8739ae039);
let $9530c27c700696d0$var$deprecatedWarnList = null;
function $9530c27c700696d0$export$60eef1277fe463e4() {
    $9530c27c700696d0$var$deprecatedWarnList = null;
    $9530c27c700696d0$var$rcResetWarned();
}
let $9530c27c700696d0$var$_warning = $9530c27c700696d0$export$8793edee2d425525;
var $9530c27c700696d0$var$valid, $9530c27c700696d0$var$component, $9530c27c700696d0$var$message;
const $9530c27c700696d0$var$warning = $9530c27c700696d0$var$_warning;
const $9530c27c700696d0$export$11b88c75b33aa1fd = /*#__PURE__*/ $ltGt3.createContext({});
const $9530c27c700696d0$export$cf977aa92c751e61 = ()=>{
    const noopWarning = ()=>{};
    noopWarning.deprecated = $9530c27c700696d0$export$8793edee2d425525;
    return noopWarning;
};
var $9530c27c700696d0$export$2e2bcd8739ae039 = $9530c27c700696d0$var$warning;



var $ltGt3 = parcelRequire("ltGt3");
"use client";
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-component/form`
$f58ba1999f6a7d10$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ltGt3.createContext)(undefined);



var $ltGt3 = parcelRequire("ltGt3");

const $307c281918c022d6$var$locale = {
    // Options
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};
var $307c281918c022d6$export$2e2bcd8739ae039 = $307c281918c022d6$var$locale;


var $81ef1f30b771ac17$export$bdd78c3fd9633c1e = {
    yearFormat: 'YYYY',
    dayFormat: 'D',
    cellMeridiemFormat: 'A',
    monthBeforeYear: true
};


function $9f2d637c5dce6994$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9f2d637c5dce6994$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9f2d637c5dce6994$var$_typeof(o);
}
function $9f2d637c5dce6994$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f2d637c5dce6994$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f2d637c5dce6994$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9f2d637c5dce6994$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f2d637c5dce6994$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9f2d637c5dce6994$var$_defineProperty(obj, key, value) {
    key = $9f2d637c5dce6994$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9f2d637c5dce6994$var$_toPropertyKey(t) {
    var i = $9f2d637c5dce6994$var$_toPrimitive(t, "string");
    return "symbol" == $9f2d637c5dce6994$var$_typeof(i) ? i : String(i);
}
function $9f2d637c5dce6994$var$_toPrimitive(t, r) {
    if ("object" != $9f2d637c5dce6994$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9f2d637c5dce6994$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9f2d637c5dce6994$var$locale = $9f2d637c5dce6994$var$_objectSpread($9f2d637c5dce6994$var$_objectSpread({}, (0, $81ef1f30b771ac17$export$bdd78c3fd9633c1e)), {}, {
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
});
var $9f2d637c5dce6994$export$2e2bcd8739ae039 = $9f2d637c5dce6994$var$locale;


const $fb92e9c16769dc94$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $fb92e9c16769dc94$export$2e2bcd8739ae039 = $fb92e9c16769dc94$var$locale;


// Merge into a locale object
const $70b7f2c44368fe54$var$locale = {
    lang: {
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ],
        ...(0, $9f2d637c5dce6994$export$2e2bcd8739ae039)
    },
    timePickerLocale: {
        ...(0, $fb92e9c16769dc94$export$2e2bcd8739ae039)
    }
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$70b7f2c44368fe54$export$2e2bcd8739ae039 = $70b7f2c44368fe54$var$locale;


var $09650f76958a02c7$export$2e2bcd8739ae039 = (0, $70b7f2c44368fe54$export$2e2bcd8739ae039);




const $29f4f00e8825a41b$var$typeTemplate = '${label} is not a valid ${type}';
const $29f4f00e8825a41b$var$localeValues = {
    locale: 'en',
    Pagination: $307c281918c022d6$export$2e2bcd8739ae039,
    DatePicker: $70b7f2c44368fe54$export$2e2bcd8739ae039,
    TimePicker: $fb92e9c16769dc94$export$2e2bcd8739ae039,
    Calendar: $09650f76958a02c7$export$2e2bcd8739ae039,
    global: {
        placeholder: 'Please select',
        close: 'Close',
        sortable: 'sortable'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckAll: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Tour: {
        Next: 'Next',
        Previous: 'Previous',
        Finish: 'Finish'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        deselectAll: 'Deselect all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand',
        collapse: 'Collapse'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            default: 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            enum: '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $29f4f00e8825a41b$var$typeTemplate,
                method: $29f4f00e8825a41b$var$typeTemplate,
                array: $29f4f00e8825a41b$var$typeTemplate,
                object: $29f4f00e8825a41b$var$typeTemplate,
                number: $29f4f00e8825a41b$var$typeTemplate,
                date: $29f4f00e8825a41b$var$typeTemplate,
                boolean: $29f4f00e8825a41b$var$typeTemplate,
                integer: $29f4f00e8825a41b$var$typeTemplate,
                float: $29f4f00e8825a41b$var$typeTemplate,
                regexp: $29f4f00e8825a41b$var$typeTemplate,
                email: $29f4f00e8825a41b$var$typeTemplate,
                url: $29f4f00e8825a41b$var$typeTemplate,
                hex: $29f4f00e8825a41b$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    QRCode: {
        expired: 'QR code expired',
        refresh: 'Refresh',
        scanned: 'Scanned'
    },
    ColorPicker: {
        presetEmpty: 'Empty',
        transparent: 'Transparent',
        singleColor: 'Single',
        gradientColor: 'Gradient'
    }
};
var $29f4f00e8825a41b$export$2e2bcd8739ae039 = $29f4f00e8825a41b$var$localeValues;


let $7122a9fe01bd9900$var$runtimeLocale = {
    ...(0, $29f4f00e8825a41b$export$2e2bcd8739ae039).Modal
};
let $7122a9fe01bd9900$var$localeList = [];
const $7122a9fe01bd9900$var$generateLocale = ()=>$7122a9fe01bd9900$var$localeList.reduce((merged, locale)=>({
            ...merged,
            ...locale
        }), (0, $29f4f00e8825a41b$export$2e2bcd8739ae039).Modal);
function $7122a9fe01bd9900$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) {
        const cloneLocale = {
            ...newLocale
        };
        $7122a9fe01bd9900$var$localeList.push(cloneLocale);
        $7122a9fe01bd9900$var$runtimeLocale = $7122a9fe01bd9900$var$generateLocale();
        return ()=>{
            $7122a9fe01bd9900$var$localeList = $7122a9fe01bd9900$var$localeList.filter((locale)=>locale !== cloneLocale);
            $7122a9fe01bd9900$var$runtimeLocale = $7122a9fe01bd9900$var$generateLocale();
        };
    }
    $7122a9fe01bd9900$var$runtimeLocale = {
        ...(0, $29f4f00e8825a41b$export$2e2bcd8739ae039).Modal
    };
}
function $7122a9fe01bd9900$export$1b6004afda18cd51() {
    return $7122a9fe01bd9900$var$runtimeLocale;
}



var $ltGt3 = parcelRequire("ltGt3");
const $a2444553f97bdd83$var$LocaleContext = /*#__PURE__*/ (0, $ltGt3.createContext)(undefined);
var $a2444553f97bdd83$export$2e2bcd8739ae039 = $a2444553f97bdd83$var$LocaleContext;



var $ltGt3 = parcelRequire("ltGt3");


const $8bb479a5dbe8bc5c$var$useLocale = (componentName, defaultLocale)=>{
    const fullLocale = $ltGt3.useContext((0, $a2444553f97bdd83$export$2e2bcd8739ae039));
    const getLocale = $ltGt3.useMemo(()=>{
        const locale = defaultLocale || (0, $29f4f00e8825a41b$export$2e2bcd8739ae039)[componentName];
        const localeFromContext = fullLocale?.[componentName] ?? {};
        return {
            ...typeof locale === 'function' ? locale() : locale,
            ...localeFromContext || {}
        };
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = $ltGt3.useMemo(()=>{
        const localeCode = fullLocale?.locale;
        // Had use LocaleProvide but didn't set locale
        if (fullLocale?.exist && !localeCode) return (0, $29f4f00e8825a41b$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $8bb479a5dbe8bc5c$export$2e2bcd8739ae039 = $8bb479a5dbe8bc5c$var$useLocale;


"use client";
const $4547604c8eb162f3$export$b2f162cd5c15ea3e = 'internalMark';
const $4547604c8eb162f3$var$LocaleProvider = (props)=>{
    const { locale: locale = {}, children: children, _ANT_MARK__: _ANT_MARK__ } = props;
    $ltGt3.useEffect(()=>{
        const clearLocale = (0, $7122a9fe01bd9900$export$9485ecb9d81a550c)(locale?.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = $ltGt3.useMemo(()=>({
            ...locale,
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $a2444553f97bdd83$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $4547604c8eb162f3$export$2e2bcd8739ae039 = $4547604c8eb162f3$var$LocaleProvider;





// 36 Hex to reduce the size of the file
var $0096f393251ba223$export$2e2bcd8739ae039 = {
    aliceblue: '9ehhb',
    antiquewhite: '9sgk7',
    aqua: '1ekf',
    aquamarine: '4zsno',
    azure: '9eiv3',
    beige: '9lhp8',
    bisque: '9zg04',
    black: '0',
    blanchedalmond: '9zhe5',
    blue: '73',
    blueviolet: '5e31e',
    brown: '6g016',
    burlywood: '8ouiv',
    cadetblue: '3qba8',
    chartreuse: '4zshs',
    chocolate: '87k0u',
    coral: '9yvyo',
    cornflowerblue: '3xael',
    cornsilk: '9zjz0',
    crimson: '8l4xo',
    cyan: '1ekf',
    darkblue: '3v',
    darkcyan: 'rkb',
    darkgoldenrod: '776yz',
    darkgray: '6mbhl',
    darkgreen: 'jr4',
    darkgrey: '6mbhl',
    darkkhaki: '7ehkb',
    darkmagenta: '5f91n',
    darkolivegreen: '3bzfz',
    darkorange: '9yygw',
    darkorchid: '5z6x8',
    darkred: '5f8xs',
    darksalmon: '9441m',
    darkseagreen: '5lwgf',
    darkslateblue: '2th1n',
    darkslategray: '1ugcv',
    darkslategrey: '1ugcv',
    darkturquoise: '14up',
    darkviolet: '5rw7n',
    deeppink: '9yavn',
    deepskyblue: '11xb',
    dimgray: '442g9',
    dimgrey: '442g9',
    dodgerblue: '16xof',
    firebrick: '6y7tu',
    floralwhite: '9zkds',
    forestgreen: '1cisi',
    fuchsia: '9y70f',
    gainsboro: '8m8kc',
    ghostwhite: '9pq0v',
    goldenrod: '8j4f4',
    gold: '9zda8',
    gray: '50i2o',
    green: 'pa8',
    greenyellow: '6senj',
    grey: '50i2o',
    honeydew: '9eiuo',
    hotpink: '9yrp0',
    indianred: '80gnw',
    indigo: '2xcoy',
    ivory: '9zldc',
    khaki: '9edu4',
    lavenderblush: '9ziet',
    lavender: '90c8q',
    lawngreen: '4vk74',
    lemonchiffon: '9zkct',
    lightblue: '6s73a',
    lightcoral: '9dtog',
    lightcyan: '8s1rz',
    lightgoldenrodyellow: '9sjiq',
    lightgray: '89jo3',
    lightgreen: '5nkwg',
    lightgrey: '89jo3',
    lightpink: '9z6wx',
    lightsalmon: '9z2ii',
    lightseagreen: '19xgq',
    lightskyblue: '5arju',
    lightslategray: '4nwk9',
    lightslategrey: '4nwk9',
    lightsteelblue: '6wau6',
    lightyellow: '9zlcw',
    lime: '1edc',
    limegreen: '1zcxe',
    linen: '9shk6',
    magenta: '9y70f',
    maroon: '4zsow',
    mediumaquamarine: '40eju',
    mediumblue: '5p',
    mediumorchid: '79qkz',
    mediumpurple: '5r3rv',
    mediumseagreen: '2d9ip',
    mediumslateblue: '4tcku',
    mediumspringgreen: '1di2',
    mediumturquoise: '2uabw',
    mediumvioletred: '7rn9h',
    midnightblue: 'z980',
    mintcream: '9ljp6',
    mistyrose: '9zg0x',
    moccasin: '9zfzp',
    navajowhite: '9zest',
    navy: '3k',
    oldlace: '9wq92',
    olive: '50hz4',
    olivedrab: '472ub',
    orange: '9z3eo',
    orangered: '9ykg0',
    orchid: '8iu3a',
    palegoldenrod: '9bl4a',
    palegreen: '5yw0o',
    paleturquoise: '6v4ku',
    palevioletred: '8k8lv',
    papayawhip: '9zi6t',
    peachpuff: '9ze0p',
    peru: '80oqn',
    pink: '9z8wb',
    plum: '8nba5',
    powderblue: '6wgdi',
    purple: '4zssg',
    rebeccapurple: '3zk49',
    red: '9y6tc',
    rosybrown: '7cv4f',
    royalblue: '2jvtt',
    saddlebrown: '5fmkz',
    salmon: '9rvci',
    sandybrown: '9jn1c',
    seagreen: '1tdnb',
    seashell: '9zje6',
    sienna: '6973h',
    silver: '7ir40',
    skyblue: '5arjf',
    slateblue: '45e4t',
    slategray: '4e100',
    slategrey: '4e100',
    snow: '9zke2',
    springgreen: '1egv',
    steelblue: '2r1kk',
    tan: '87yx8',
    teal: 'pds',
    thistle: '8ggk8',
    tomato: '9yqfb',
    turquoise: '2j4r4',
    violet: '9b10u',
    wheat: '9ld4j',
    white: '9zldr',
    whitesmoke: '9lhpx',
    yellow: '9zl6o',
    yellowgreen: '61fzm'
};


const $bafdd58c7fe9c8d0$var$round = Math.round;
/**
 * Support format, alpha unit will check the % mark:
 * - rgba(102, 204, 255, .5)      -> [102, 204, 255, 0.5]
 * - rgb(102 204 255 / .5)        -> [102, 204, 255, 0.5]
 * - rgb(100%, 50%, 0% / 50%)     -> [255, 128, 0, 0.5]
 * - hsl(270, 60, 40, .5)         -> [270, 60, 40, 0.5]
 * - hsl(270deg 60% 40% / 50%)   -> [270, 60, 40, 0.5]
 *
 * When `base` is provided, the percentage value will be divided by `base`.
 */ function $bafdd58c7fe9c8d0$var$splitColorStr(str, parseNum) {
    const match = str// Remove str before `(`
    .replace(/^[^(]*\((.*)/, '$1')// Remove str after `)`
    .replace(/\).*/, '').match(/\d*\.?\d+%?/g) || [];
    const numList = match.map((item)=>parseFloat(item));
    for(let i = 0; i < 3; i += 1)numList[i] = parseNum(numList[i] || 0, match[i] || '', i);
    // For alpha. 50% should be 0.5
    if (match[3]) numList[3] = match[3].includes('%') ? numList[3] / 100 : numList[3];
    else // By default, alpha is 1
    numList[3] = 1;
    return numList;
}
const $bafdd58c7fe9c8d0$var$parseHSVorHSL = (num, _, index)=>index === 0 ? num : num / 100;
/** round and limit number to integer between 0-255 */ function $bafdd58c7fe9c8d0$var$limitRange(value, max) {
    const mergedMax = max || 255;
    if (value > mergedMax) return mergedMax;
    if (value < 0) return 0;
    return value;
}
class $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a {
    /**
   * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
   */ isValid = true;
    /**
   * Red, R in RGB
   */ r = 0;
    /**
   * Green, G in RGB
   */ g = 0;
    /**
   * Blue, B in RGB
   */ b = 0;
    /**
   * Alpha/Opacity, A in RGBA/HSLA
   */ a = 1;
    // HSV privates
    _h;
    _s;
    _l;
    _v;
    // intermediate variables to calculate HSL/HSV
    _max;
    _min;
    _brightness;
    constructor(input){
        /**
     * Always check 3 char in the object to determine the format.
     * We not use function in check to save bundle size.
     * e.g. 'rgb' -> { r: 0, g: 0, b: 0 }.
     */ function matchFormat(str) {
            return str[0] in input && str[1] in input && str[2] in input;
        }
        if (!input) ;
        else if (typeof input === 'string') {
            const trimStr = input.trim();
            function matchPrefix(prefix) {
                return trimStr.startsWith(prefix);
            }
            if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) this.fromHexString(trimStr);
            else if (matchPrefix('rgb')) this.fromRgbString(trimStr);
            else if (matchPrefix('hsl')) this.fromHslString(trimStr);
            else if (matchPrefix('hsv') || matchPrefix('hsb')) this.fromHsvString(trimStr);
            else {
                // From preset color
                const presetColor = (0, $0096f393251ba223$export$2e2bcd8739ae039)[trimStr.toLowerCase()];
                if (presetColor) this.fromHexString(// Convert 36 hex to 16 hex
                parseInt(presetColor, 36).toString(16).padStart(6, '0'));
            }
        } else if (input instanceof $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a) {
            this.r = input.r;
            this.g = input.g;
            this.b = input.b;
            this.a = input.a;
            this._h = input._h;
            this._s = input._s;
            this._l = input._l;
            this._v = input._v;
        } else if (matchFormat('rgb')) {
            this.r = $bafdd58c7fe9c8d0$var$limitRange(input.r);
            this.g = $bafdd58c7fe9c8d0$var$limitRange(input.g);
            this.b = $bafdd58c7fe9c8d0$var$limitRange(input.b);
            this.a = typeof input.a === 'number' ? $bafdd58c7fe9c8d0$var$limitRange(input.a, 1) : 1;
        } else if (matchFormat('hsl')) this.fromHsl(input);
        else if (matchFormat('hsv')) this.fromHsv(input);
        else throw new Error('@ant-design/fast-color: unsupported input ' + JSON.stringify(input));
    }
    // ======================= Setter =======================
    setR(value) {
        return this._sc('r', value);
    }
    setG(value) {
        return this._sc('g', value);
    }
    setB(value) {
        return this._sc('b', value);
    }
    setA(value) {
        return this._sc('a', value, 1);
    }
    setHue(value) {
        const hsv = this.toHsv();
        hsv.h = value;
        return this._c(hsv);
    }
    // ======================= Getter =======================
    /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */ getLuminance() {
        function adjustGamma(raw) {
            const val = raw / 255;
            return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
        }
        const R = adjustGamma(this.r);
        const G = adjustGamma(this.g);
        const B = adjustGamma(this.b);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }
    getHue() {
        if (typeof this._h === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._h = 0;
            else this._h = $bafdd58c7fe9c8d0$var$round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
        }
        return this._h;
    }
    getSaturation() {
        if (typeof this._s === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._s = 0;
            else this._s = delta / this.getMax();
        }
        return this._s;
    }
    getLightness() {
        if (typeof this._l === 'undefined') this._l = (this.getMax() + this.getMin()) / 510;
        return this._l;
    }
    getValue() {
        if (typeof this._v === 'undefined') this._v = this.getMax() / 255;
        return this._v;
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */ getBrightness() {
        if (typeof this._brightness === 'undefined') this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
        return this._brightness;
    }
    // ======================== Func ========================
    darken(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() - amount / 100;
        if (l < 0) l = 0;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    lighten(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() + amount / 100;
        if (l > 1) l = 1;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(input, amount = 50) {
        const color = this._c(input);
        const p = amount / 100;
        const calc = (key)=>(color[key] - this[key]) * p + this[key];
        const rgba = {
            r: $bafdd58c7fe9c8d0$var$round(calc('r')),
            g: $bafdd58c7fe9c8d0$var$round(calc('g')),
            b: $bafdd58c7fe9c8d0$var$round(calc('b')),
            a: $bafdd58c7fe9c8d0$var$round(calc('a') * 100) / 100
        };
        return this._c(rgba);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */ tint(amount = 10) {
        return this.mix({
            r: 255,
            g: 255,
            b: 255,
            a: 1
        }, amount);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */ shade(amount = 10) {
        return this.mix({
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, amount);
    }
    onBackground(background) {
        const bg = this._c(background);
        const alpha = this.a + bg.a * (1 - this.a);
        const calc = (key)=>{
            return $bafdd58c7fe9c8d0$var$round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
        };
        return this._c({
            r: calc('r'),
            g: calc('g'),
            b: calc('b'),
            a: alpha
        });
    }
    // ======================= Status =======================
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return this.getBrightness() >= 128;
    }
    // ======================== MISC ========================
    equals(other) {
        return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
    clone() {
        return this._c(this);
    }
    // ======================= Format =======================
    toHexString() {
        let hex = '#';
        const rHex = (this.r || 0).toString(16);
        hex += rHex.length === 2 ? rHex : '0' + rHex;
        const gHex = (this.g || 0).toString(16);
        hex += gHex.length === 2 ? gHex : '0' + gHex;
        const bHex = (this.b || 0).toString(16);
        hex += bHex.length === 2 ? bHex : '0' + bHex;
        if (typeof this.a === 'number' && this.a >= 0 && this.a < 1) {
            const aHex = $bafdd58c7fe9c8d0$var$round(this.a * 255).toString(16);
            hex += aHex.length === 2 ? aHex : '0' + aHex;
        }
        return hex;
    }
    /** CSS support color pattern */ toHsl() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            l: this.getLightness(),
            a: this.a
        };
    }
    /** CSS support color pattern */ toHslString() {
        const h = this.getHue();
        const s = $bafdd58c7fe9c8d0$var$round(this.getSaturation() * 100);
        const l = $bafdd58c7fe9c8d0$var$round(this.getLightness() * 100);
        return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
    }
    /** Same as toHsb */ toHsv() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            v: this.getValue(),
            a: this.a
        };
    }
    toRgb() {
        return {
            r: this.r,
            g: this.g,
            b: this.b,
            a: this.a
        };
    }
    toRgbString() {
        return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
    }
    toString() {
        return this.toRgbString();
    }
    // ====================== Privates ======================
    /** Return a new FastColor object with one channel changed */ _sc(rgb, value, max) {
        const clone = this.clone();
        clone[rgb] = $bafdd58c7fe9c8d0$var$limitRange(value, max);
        return clone;
    }
    _c(input) {
        return new this.constructor(input);
    }
    getMax() {
        if (typeof this._max === 'undefined') this._max = Math.max(this.r, this.g, this.b);
        return this._max;
    }
    getMin() {
        if (typeof this._min === 'undefined') this._min = Math.min(this.r, this.g, this.b);
        return this._min;
    }
    fromHexString(trimStr) {
        const withoutPrefix = trimStr.replace('#', '');
        function connectNum(index1, index2) {
            return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
        }
        if (withoutPrefix.length < 6) {
            // #rgb or #rgba
            this.r = connectNum(0);
            this.g = connectNum(1);
            this.b = connectNum(2);
            this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
        } else {
            // #rrggbb or #rrggbbaa
            this.r = connectNum(0, 1);
            this.g = connectNum(2, 3);
            this.b = connectNum(4, 5);
            this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
        }
    }
    fromHsl({ h: h, s: s, l: l, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._l = l;
        this.a = typeof a === 'number' ? a : 1;
        if (s <= 0) {
            const rgb = $bafdd58c7fe9c8d0$var$round(l * 255);
            this.r = rgb;
            this.g = rgb;
            this.b = rgb;
        }
        let r = 0, g = 0, b = 0;
        const huePrime = h / 60;
        const chroma = (1 - Math.abs(2 * l - 1)) * s;
        const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
        if (huePrime >= 0 && huePrime < 1) {
            r = chroma;
            g = secondComponent;
        } else if (huePrime >= 1 && huePrime < 2) {
            r = secondComponent;
            g = chroma;
        } else if (huePrime >= 2 && huePrime < 3) {
            g = chroma;
            b = secondComponent;
        } else if (huePrime >= 3 && huePrime < 4) {
            g = secondComponent;
            b = chroma;
        } else if (huePrime >= 4 && huePrime < 5) {
            r = secondComponent;
            b = chroma;
        } else if (huePrime >= 5 && huePrime < 6) {
            r = chroma;
            b = secondComponent;
        }
        const lightnessModification = l - chroma / 2;
        this.r = $bafdd58c7fe9c8d0$var$round((r + lightnessModification) * 255);
        this.g = $bafdd58c7fe9c8d0$var$round((g + lightnessModification) * 255);
        this.b = $bafdd58c7fe9c8d0$var$round((b + lightnessModification) * 255);
    }
    fromHsv({ h: h, s: s, v: v, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._v = v;
        this.a = typeof a === 'number' ? a : 1;
        const vv = $bafdd58c7fe9c8d0$var$round(v * 255);
        this.r = vv;
        this.g = vv;
        this.b = vv;
        if (s <= 0) return;
        const hh = h / 60;
        const i = Math.floor(hh);
        const ff = hh - i;
        const p = $bafdd58c7fe9c8d0$var$round(v * (1.0 - s) * 255);
        const q = $bafdd58c7fe9c8d0$var$round(v * (1.0 - s * ff) * 255);
        const t = $bafdd58c7fe9c8d0$var$round(v * (1.0 - s * (1.0 - ff)) * 255);
        switch(i){
            case 0:
                this.g = t;
                this.b = p;
                break;
            case 1:
                this.r = q;
                this.b = p;
                break;
            case 2:
                this.r = p;
                this.b = t;
                break;
            case 3:
                this.r = p;
                this.g = q;
                break;
            case 4:
                this.r = t;
                this.g = p;
                break;
            case 5:
            default:
                this.g = p;
                this.b = q;
                break;
        }
    }
    fromHsvString(trimStr) {
        const cells = $bafdd58c7fe9c8d0$var$splitColorStr(trimStr, $bafdd58c7fe9c8d0$var$parseHSVorHSL);
        this.fromHsv({
            h: cells[0],
            s: cells[1],
            v: cells[2],
            a: cells[3]
        });
    }
    fromHslString(trimStr) {
        const cells = $bafdd58c7fe9c8d0$var$splitColorStr(trimStr, $bafdd58c7fe9c8d0$var$parseHSVorHSL);
        this.fromHsl({
            h: cells[0],
            s: cells[1],
            l: cells[2],
            a: cells[3]
        });
    }
    fromRgbString(trimStr) {
        const cells = $bafdd58c7fe9c8d0$var$splitColorStr(trimStr, (num, txt)=>// Convert percentage to number. e.g. 50% -> 128
            txt.includes('%') ? $bafdd58c7fe9c8d0$var$round(num / 100 * 255) : num);
        this.r = cells[0];
        this.g = cells[1];
        this.b = cells[2];
        this.a = cells[3];
    }
}






const $5a714eb5c7b9ddd8$var$hueStep = 2; // 色相阶梯
const $5a714eb5c7b9ddd8$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
const $5a714eb5c7b9ddd8$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
const $5a714eb5c7b9ddd8$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
const $5a714eb5c7b9ddd8$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
const $5a714eb5c7b9ddd8$var$lightColorCount = 5; // 浅色数量，主色上
const $5a714eb5c7b9ddd8$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
const $5a714eb5c7b9ddd8$var$darkColorMap = [
    {
        index: 7,
        amount: 15
    },
    {
        index: 6,
        amount: 25
    },
    {
        index: 5,
        amount: 30
    },
    {
        index: 5,
        amount: 45
    },
    {
        index: 5,
        amount: 65
    },
    {
        index: 5,
        amount: 85
    },
    {
        index: 4,
        amount: 90
    },
    {
        index: 3,
        amount: 95
    },
    {
        index: 2,
        amount: 97
    },
    {
        index: 1,
        amount: 98
    }
];
function $5a714eb5c7b9ddd8$var$getHue(hsv, i, light) {
    let hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $5a714eb5c7b9ddd8$var$hueStep * i : Math.round(hsv.h) + $5a714eb5c7b9ddd8$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $5a714eb5c7b9ddd8$var$hueStep * i : Math.round(hsv.h) - $5a714eb5c7b9ddd8$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $5a714eb5c7b9ddd8$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    let saturation;
    if (light) saturation = hsv.s - $5a714eb5c7b9ddd8$var$saturationStep * i;
    else if (i === $5a714eb5c7b9ddd8$var$darkColorCount) saturation = hsv.s + $5a714eb5c7b9ddd8$var$saturationStep;
    else saturation = hsv.s + $5a714eb5c7b9ddd8$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $5a714eb5c7b9ddd8$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Math.round(saturation * 100) / 100;
}
function $5a714eb5c7b9ddd8$var$getValue(hsv, i, light) {
    let value;
    if (light) value = hsv.v + $5a714eb5c7b9ddd8$var$brightnessStep1 * i;
    else value = hsv.v - $5a714eb5c7b9ddd8$var$brightnessStep2 * i;
    // Clamp value between 0 and 1
    value = Math.max(0, Math.min(1, value));
    return Math.round(value * 100) / 100;
}
function $5a714eb5c7b9ddd8$export$2e2bcd8739ae039(color, opts = {}) {
    const patterns = [];
    const pColor = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(color);
    const hsv = pColor.toHsv();
    for(let i = $5a714eb5c7b9ddd8$var$lightColorCount; i > 0; i -= 1){
        const c = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)({
            h: $5a714eb5c7b9ddd8$var$getHue(hsv, i, true),
            s: $5a714eb5c7b9ddd8$var$getSaturation(hsv, i, true),
            v: $5a714eb5c7b9ddd8$var$getValue(hsv, i, true)
        });
        patterns.push(c);
    }
    patterns.push(pColor);
    for(let i = 1; i <= $5a714eb5c7b9ddd8$var$darkColorCount; i += 1){
        const c = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)({
            h: $5a714eb5c7b9ddd8$var$getHue(hsv, i),
            s: $5a714eb5c7b9ddd8$var$getSaturation(hsv, i),
            v: $5a714eb5c7b9ddd8$var$getValue(hsv, i)
        });
        patterns.push(c);
    }
    // dark theme patterns
    if (opts.theme === 'dark') return $5a714eb5c7b9ddd8$var$darkColorMap.map(({ index: index, amount: amount })=>new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(opts.backgroundColor || '#141414').mix(patterns[index], amount).toHexString());
    return patterns.map((c)=>c.toHexString());
}


// Generated by script. Do NOT modify!
const $1bd835bbb2d9f8c1$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
const $1bd835bbb2d9f8c1$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$1bd835bbb2d9f8c1$export$a90204d1394caf30.primary = $1bd835bbb2d9f8c1$export$a90204d1394caf30[5];
const $1bd835bbb2d9f8c1$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$1bd835bbb2d9f8c1$export$e63a1643b2f79b16.primary = $1bd835bbb2d9f8c1$export$e63a1643b2f79b16[5];
const $1bd835bbb2d9f8c1$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$1bd835bbb2d9f8c1$export$ad766f34ace1cafd.primary = $1bd835bbb2d9f8c1$export$ad766f34ace1cafd[5];
const $1bd835bbb2d9f8c1$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$1bd835bbb2d9f8c1$export$c24201f7fe3571d8.primary = $1bd835bbb2d9f8c1$export$c24201f7fe3571d8[5];
const $1bd835bbb2d9f8c1$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$1bd835bbb2d9f8c1$export$594c5a8758200c32.primary = $1bd835bbb2d9f8c1$export$594c5a8758200c32[5];
const $1bd835bbb2d9f8c1$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$1bd835bbb2d9f8c1$export$221d31baf2636aad.primary = $1bd835bbb2d9f8c1$export$221d31baf2636aad[5];
const $1bd835bbb2d9f8c1$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$1bd835bbb2d9f8c1$export$955a2ebd2fb142ae.primary = $1bd835bbb2d9f8c1$export$955a2ebd2fb142ae[5];
const $1bd835bbb2d9f8c1$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$1bd835bbb2d9f8c1$export$7474046f446842ee.primary = $1bd835bbb2d9f8c1$export$7474046f446842ee[5];
const $1bd835bbb2d9f8c1$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$1bd835bbb2d9f8c1$export$2aa0182783e7e9de.primary = $1bd835bbb2d9f8c1$export$2aa0182783e7e9de[5];
const $1bd835bbb2d9f8c1$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$1bd835bbb2d9f8c1$export$4138d3aeddcbf415.primary = $1bd835bbb2d9f8c1$export$4138d3aeddcbf415[5];
const $1bd835bbb2d9f8c1$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$1bd835bbb2d9f8c1$export$e13cce2a2d16a9d4.primary = $1bd835bbb2d9f8c1$export$e13cce2a2d16a9d4[5];
const $1bd835bbb2d9f8c1$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$1bd835bbb2d9f8c1$export$2a9ca2e383622e18.primary = $1bd835bbb2d9f8c1$export$2a9ca2e383622e18[5];
const $1bd835bbb2d9f8c1$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$1bd835bbb2d9f8c1$export$e4c89085febbc618.primary = $1bd835bbb2d9f8c1$export$e4c89085febbc618[5];
const $1bd835bbb2d9f8c1$export$3e2c219d3ab79d01 = $1bd835bbb2d9f8c1$export$e4c89085febbc618;
const $1bd835bbb2d9f8c1$export$36ad6df0f83f284d = {
    red: $1bd835bbb2d9f8c1$export$a90204d1394caf30,
    volcano: $1bd835bbb2d9f8c1$export$e63a1643b2f79b16,
    orange: $1bd835bbb2d9f8c1$export$ad766f34ace1cafd,
    gold: $1bd835bbb2d9f8c1$export$c24201f7fe3571d8,
    yellow: $1bd835bbb2d9f8c1$export$594c5a8758200c32,
    lime: $1bd835bbb2d9f8c1$export$221d31baf2636aad,
    green: $1bd835bbb2d9f8c1$export$955a2ebd2fb142ae,
    cyan: $1bd835bbb2d9f8c1$export$7474046f446842ee,
    blue: $1bd835bbb2d9f8c1$export$2aa0182783e7e9de,
    geekblue: $1bd835bbb2d9f8c1$export$4138d3aeddcbf415,
    purple: $1bd835bbb2d9f8c1$export$e13cce2a2d16a9d4,
    magenta: $1bd835bbb2d9f8c1$export$2a9ca2e383622e18,
    grey: $1bd835bbb2d9f8c1$export$e4c89085febbc618
};
const $1bd835bbb2d9f8c1$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$1bd835bbb2d9f8c1$export$e984d34fc144caa1.primary = $1bd835bbb2d9f8c1$export$e984d34fc144caa1[5];
const $1bd835bbb2d9f8c1$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$1bd835bbb2d9f8c1$export$360e10f78e17a865.primary = $1bd835bbb2d9f8c1$export$360e10f78e17a865[5];
const $1bd835bbb2d9f8c1$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$1bd835bbb2d9f8c1$export$d5a12c698b31fa45.primary = $1bd835bbb2d9f8c1$export$d5a12c698b31fa45[5];
const $1bd835bbb2d9f8c1$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$1bd835bbb2d9f8c1$export$2330427fb6a6af6f.primary = $1bd835bbb2d9f8c1$export$2330427fb6a6af6f[5];
const $1bd835bbb2d9f8c1$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$1bd835bbb2d9f8c1$export$67d203119f0ecec.primary = $1bd835bbb2d9f8c1$export$67d203119f0ecec[5];
const $1bd835bbb2d9f8c1$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$1bd835bbb2d9f8c1$export$51ed2a10d86576ed.primary = $1bd835bbb2d9f8c1$export$51ed2a10d86576ed[5];
const $1bd835bbb2d9f8c1$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$1bd835bbb2d9f8c1$export$76a3d804058f9b5f.primary = $1bd835bbb2d9f8c1$export$76a3d804058f9b5f[5];
const $1bd835bbb2d9f8c1$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$1bd835bbb2d9f8c1$export$dee6c7c6683c0d88.primary = $1bd835bbb2d9f8c1$export$dee6c7c6683c0d88[5];
const $1bd835bbb2d9f8c1$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$1bd835bbb2d9f8c1$export$10e0fd027e632624.primary = $1bd835bbb2d9f8c1$export$10e0fd027e632624[5];
const $1bd835bbb2d9f8c1$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$1bd835bbb2d9f8c1$export$abdd57ab473bba66.primary = $1bd835bbb2d9f8c1$export$abdd57ab473bba66[5];
const $1bd835bbb2d9f8c1$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$1bd835bbb2d9f8c1$export$7a65e68792738764.primary = $1bd835bbb2d9f8c1$export$7a65e68792738764[5];
const $1bd835bbb2d9f8c1$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$1bd835bbb2d9f8c1$export$d260a9321db4ab86.primary = $1bd835bbb2d9f8c1$export$d260a9321db4ab86[5];
const $1bd835bbb2d9f8c1$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$1bd835bbb2d9f8c1$export$515283ba400ffa6c.primary = $1bd835bbb2d9f8c1$export$515283ba400ffa6c[5];
const $1bd835bbb2d9f8c1$export$24617255e4daf647 = {
    red: $1bd835bbb2d9f8c1$export$e984d34fc144caa1,
    volcano: $1bd835bbb2d9f8c1$export$360e10f78e17a865,
    orange: $1bd835bbb2d9f8c1$export$d5a12c698b31fa45,
    gold: $1bd835bbb2d9f8c1$export$2330427fb6a6af6f,
    yellow: $1bd835bbb2d9f8c1$export$67d203119f0ecec,
    lime: $1bd835bbb2d9f8c1$export$51ed2a10d86576ed,
    green: $1bd835bbb2d9f8c1$export$76a3d804058f9b5f,
    cyan: $1bd835bbb2d9f8c1$export$dee6c7c6683c0d88,
    blue: $1bd835bbb2d9f8c1$export$10e0fd027e632624,
    geekblue: $1bd835bbb2d9f8c1$export$abdd57ab473bba66,
    purple: $1bd835bbb2d9f8c1$export$7a65e68792738764,
    magenta: $1bd835bbb2d9f8c1$export$d260a9321db4ab86,
    grey: $1bd835bbb2d9f8c1$export$515283ba400ffa6c
};






const $cd7243c61a6df828$export$37e27b43af4d16eb = {
    blue: '#1677FF',
    purple: '#722ED1',
    cyan: '#13C2C2',
    green: '#52C41A',
    magenta: '#EB2F96',
    /**
   * @deprecated Use magenta instead
   */ pink: '#EB2F96',
    red: '#F5222D',
    orange: '#FA8C16',
    yellow: '#FADB14',
    volcano: '#FA541C',
    geekblue: '#2F54EB',
    gold: '#FAAD14',
    lime: '#A0D911'
};
const $cd7243c61a6df828$var$seedToken = {
    // preset color palettes
    ...$cd7243c61a6df828$export$37e27b43af4d16eb,
    // Color
    colorPrimary: '#1677ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1677ff',
    colorLink: '',
    colorTextBase: '',
    colorBgBase: '',
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: 'solid',
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
    motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
    motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
    motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
    motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
};
var $cd7243c61a6df828$export$2e2bcd8739ae039 = $cd7243c61a6df828$var$seedToken;



function $d6cac2b9a1937bee$export$2e2bcd8739ae039(seed, { generateColorPalettes: generateColorPalettes, generateNeutralColorPalettes: generateNeutralColorPalettes }) {
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase: colorBgBase, colorTextBase: colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    const colorErrorBgFilledHover = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(errorColors[1]).mix(new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(errorColors[3]), 50).toHexString();
    return {
        ...neutralColors,
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBgFilledHover: colorErrorBgFilledHover,
        colorErrorBgActive: errorColors[3],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        colorBgMask: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)('#000').setA(0.45).toRgbString(),
        colorWhite: '#fff'
    };
}


const $8018c4f5b898cb2c$var$genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $8018c4f5b898cb2c$export$2e2bcd8739ae039 = $8018c4f5b898cb2c$var$genRadius;


function $d83752978bcd3c7b$export$2e2bcd8739ae039(token) {
    const { motionUnit: motionUnit, motionBase: motionBase, borderRadius: borderRadius, lineWidth: lineWidth } = token;
    return {
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1,
        // radius
        ...(0, $8018c4f5b898cb2c$export$2e2bcd8739ae039)(borderRadius)
    };
}


const $589f08f7fb89b1c5$var$genControlHeight = (token)=>{
    const { controlHeight: controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $589f08f7fb89b1c5$export$2e2bcd8739ae039 = $589f08f7fb89b1c5$var$genControlHeight;


function $5240a85e491ca83a$export$56204a27a2958a55(fontSize) {
    return (fontSize + 8) / fontSize;
}
function $5240a85e491ca83a$export$2e2bcd8739ae039(base) {
    const fontSizes = Array.from({
        length: 10
    }).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.E ** (i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>({
            size: size,
            lineHeight: $5240a85e491ca83a$export$56204a27a2958a55(size)
        }));
}


const $4f185511e189c842$var$genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, $5240a85e491ca83a$export$2e2bcd8739ae039)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $4f185511e189c842$export$2e2bcd8739ae039 = $4f185511e189c842$var$genFontMapToken;


function $4cddc770eb64ce9c$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}




const $b6c089bb78496680$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(baseColor).setA(alpha).toRgbString();
const $b6c089bb78496680$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(baseColor);
    return instance.darken(brightness).toHexString();
};


const $250288fdfe009edb$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $5a714eb5c7b9ddd8$export$2e2bcd8739ae039)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
const $250288fdfe009edb$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || '#fff';
    const colorTextBase = textBaseColor || '#000';
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $b6c089bb78496680$export$31f6399ba7ce6bea)(colorTextBase, 0.88),
        colorTextSecondary: (0, $b6c089bb78496680$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $b6c089bb78496680$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $b6c089bb78496680$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $b6c089bb78496680$export$31f6399ba7ce6bea)(colorTextBase, 0.15),
        colorFillSecondary: (0, $b6c089bb78496680$export$31f6399ba7ce6bea)(colorTextBase, 0.06),
        colorFillTertiary: (0, $b6c089bb78496680$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $b6c089bb78496680$export$31f6399ba7ce6bea)(colorTextBase, 0.02),
        colorBgSolid: (0, $b6c089bb78496680$export$31f6399ba7ce6bea)(colorTextBase, 1),
        colorBgSolidHover: (0, $b6c089bb78496680$export$31f6399ba7ce6bea)(colorTextBase, 0.75),
        colorBgSolidActive: (0, $b6c089bb78496680$export$31f6399ba7ce6bea)(colorTextBase, 0.95),
        colorBgLayout: (0, $b6c089bb78496680$export$7003a8a990e79359)(colorBgBase, 4),
        colorBgContainer: (0, $b6c089bb78496680$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgElevated: (0, $b6c089bb78496680$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $b6c089bb78496680$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorBgBlur: 'transparent',
        colorBorder: (0, $b6c089bb78496680$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderDisabled: (0, $b6c089bb78496680$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderSecondary: (0, $b6c089bb78496680$export$7003a8a990e79359)(colorBgBase, 6)
    };
};


function $51a383b93ff0b6f9$export$2e2bcd8739ae039(token) {
    // pink is deprecated name of magenta, keep this for backwards compatibility
    (0, $1bd835bbb2d9f8c1$export$3968a3afc810b5f5).pink = (0, $1bd835bbb2d9f8c1$export$3968a3afc810b5f5).magenta;
    (0, $1bd835bbb2d9f8c1$export$36ad6df0f83f284d).pink = (0, $1bd835bbb2d9f8c1$export$36ad6df0f83f284d).magenta;
    const colorPalettes = Object.keys((0, $cd7243c61a6df828$export$37e27b43af4d16eb)).map((colorKey)=>{
        const colors = token[colorKey] === (0, $1bd835bbb2d9f8c1$export$3968a3afc810b5f5)[colorKey] ? (0, $1bd835bbb2d9f8c1$export$36ad6df0f83f284d)[colorKey] : (0, $5a714eb5c7b9ddd8$export$2e2bcd8739ae039)(token[colorKey]);
        return Array.from({
            length: 10
        }, ()=>1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        prev = {
            ...prev,
            ...cur
        };
        return prev;
    }, {});
    return {
        ...token,
        ...colorPalettes,
        // Colors
        ...(0, $d6cac2b9a1937bee$export$2e2bcd8739ae039)(token, {
            generateColorPalettes: $250288fdfe009edb$export$da275153033f4ec1,
            generateNeutralColorPalettes: $250288fdfe009edb$export$3e0cb0c1d9c1b691
        }),
        // Font
        ...(0, $4f185511e189c842$export$2e2bcd8739ae039)(token.fontSize),
        // Size
        ...(0, $4cddc770eb64ce9c$export$2e2bcd8739ae039)(token),
        // Height
        ...(0, $589f08f7fb89b1c5$export$2e2bcd8739ae039)(token),
        // Others
        ...(0, $d83752978bcd3c7b$export$2e2bcd8739ae039)(token)
    };
}


const $d39bb1bcbe47a548$var$defaultTheme = (0, $db382206ce669921$export$2e2bcd8739ae039)((0, $51a383b93ff0b6f9$export$2e2bcd8739ae039));
var $d39bb1bcbe47a548$export$2e2bcd8739ae039 = $d39bb1bcbe47a548$var$defaultTheme;


var $ltGt3 = parcelRequire("ltGt3");


const $d628a3c0642cff3d$export$f84bd70098573c5c = {
    token: (0, $cd7243c61a6df828$export$2e2bcd8739ae039),
    override: {
        override: (0, $cd7243c61a6df828$export$2e2bcd8739ae039)
    },
    hashed: false
};
const $d628a3c0642cff3d$export$69b0ebb9efcddb30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createContext($d628a3c0642cff3d$export$f84bd70098573c5c);




var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
const $05767d02b7cb2a66$var$OrderContext = /*#__PURE__*/ $ltGt3.createContext(null);
var $05767d02b7cb2a66$export$2e2bcd8739ae039 = $05767d02b7cb2a66$var$OrderContext;


let $97b0414a436dd092$export$18c8ad048e32c7d5 = false;
function $97b0414a436dd092$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === 'boolean') $97b0414a436dd092$export$18c8ad048e32c7d5 = nextInline;
    return $97b0414a436dd092$export$18c8ad048e32c7d5;
}



var $ltGt3 = parcelRequire("ltGt3");



const $4c83b9a877b10a91$var$EMPTY_LIST = [];
function $4c83b9a877b10a91$export$2e2bcd8739ae039(render, debug) {
    const [ele] = $ltGt3.useState(()=>{
        if (!(0, $19612225313d4e36$export$2e2bcd8739ae039)()) return null;
        const defaultEle = document.createElement('div');
        return defaultEle;
    });
    // ========================== Order ==========================
    const appendedRef = $ltGt3.useRef(false);
    const queueCreate = $ltGt3.useContext((0, $05767d02b7cb2a66$export$2e2bcd8739ae039));
    const [queue, setQueue] = $ltGt3.useState($4c83b9a877b10a91$var$EMPTY_LIST);
    const mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : (appendFn)=>{
        setQueue((origin)=>{
            const newQueue = [
                appendFn,
                ...origin
            ];
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        ele.parentElement?.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (queue.length) {
            queue.forEach((appendFn)=>appendFn());
            setQueue($4c83b9a877b10a91$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}



var $ltGt3 = parcelRequire("ltGt3");

function $cec58e9a999b061e$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    let node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


const $7720754a52a5d205$var$APPEND_ORDER = 'data-rc-order';
const $7720754a52a5d205$var$APPEND_PRIORITY = 'data-rc-priority';
const $7720754a52a5d205$var$MARK_KEY = `rc-util-key`;
const $7720754a52a5d205$var$containerCache = new Map();
function $7720754a52a5d205$var$getMark({ mark: mark } = {}) {
    if (mark) return mark.startsWith('data-') ? mark : `data-${mark}`;
    return $7720754a52a5d205$var$MARK_KEY;
}
function $7720754a52a5d205$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    const head = document.querySelector('head');
    return head || document.body;
}
function $7720754a52a5d205$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $7720754a52a5d205$var$findStyles(container) {
    return Array.from(($7720754a52a5d205$var$containerCache.get(container) || container).children).filter((node)=>node.tagName === 'STYLE');
}
function $7720754a52a5d205$export$1ab5838465dbd10a(css, option = {}) {
    if (!(0, $19612225313d4e36$export$2e2bcd8739ae039)()) return null;
    const { csp: csp, prepend: prepend, priority: priority = 0 } = option;
    const mergedOrder = $7720754a52a5d205$var$getOrder(prepend);
    const isPrependQueue = mergedOrder === 'prependQueue';
    const styleNode = document.createElement('style');
    styleNode.setAttribute($7720754a52a5d205$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($7720754a52a5d205$var$APPEND_PRIORITY, `${priority}`);
    if (csp?.nonce) styleNode.nonce = csp?.nonce;
    styleNode.innerHTML = css;
    const container = $7720754a52a5d205$var$getContainer(option);
    const { firstChild: firstChild } = container;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            const existStyle = (option.styles || $7720754a52a5d205$var$findStyles(container)).filter((node)=>{
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($7720754a52a5d205$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                const nodePriority = Number(node.getAttribute($7720754a52a5d205$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $7720754a52a5d205$var$findExistNode(key, option = {}) {
    let { styles: styles } = option;
    styles ||= $7720754a52a5d205$var$findStyles($7720754a52a5d205$var$getContainer(option));
    return styles.find((node)=>node.getAttribute($7720754a52a5d205$var$getMark(option)) === key);
}
function $7720754a52a5d205$export$2232e336aecaa80a(key, option = {}) {
    const existNode = $7720754a52a5d205$var$findExistNode(key, option);
    if (existNode) {
        const container = $7720754a52a5d205$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $7720754a52a5d205$var$syncRealContainer(container, option) {
    const cachedRealContainer = $7720754a52a5d205$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $cec58e9a999b061e$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        const placeholderStyle = $7720754a52a5d205$export$1ab5838465dbd10a('', option);
        const { parentNode: parentNode } = placeholderStyle;
        $7720754a52a5d205$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $7720754a52a5d205$export$f80df667f2f5a272() {
    $7720754a52a5d205$var$containerCache.clear();
}
function $7720754a52a5d205$export$4d99a2890bb989f0(css, key, originOption = {}) {
    const container = $7720754a52a5d205$var$getContainer(originOption);
    const styles = $7720754a52a5d205$var$findStyles(container);
    const option = {
        ...originOption,
        styles: styles
    };
    // Sync real parent
    $7720754a52a5d205$var$syncRealContainer(container, option);
    const existNode = $7720754a52a5d205$var$findExistNode(key, option);
    if (existNode) {
        if (option.csp?.nonce && existNode.nonce !== option.csp?.nonce) existNode.nonce = option.csp?.nonce;
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    const newNode = $7720754a52a5d205$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($7720754a52a5d205$var$getMark(option), key);
    return newNode;
}



/* eslint-disable no-param-reassign */ 
let $3b9e061be790b547$var$cached;
function $3b9e061be790b547$var$measureScrollbarSize(ele) {
    const randomId = `rc-scrollbar-measure-${Math.random().toString(36).substring(7)}`;
    const measureEle = document.createElement('div');
    measureEle.id = randomId;
    // Create Style
    const measureStyle = measureEle.style;
    measureStyle.position = 'absolute';
    measureStyle.left = '0';
    measureStyle.top = '0';
    measureStyle.width = '100px';
    measureStyle.height = '100px';
    measureStyle.overflow = 'scroll';
    // Clone Style if needed
    let fallbackWidth;
    let fallbackHeight;
    if (ele) {
        const targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        const webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
        const width = parseInt(webkitScrollbarStyle.width, 10);
        const height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            const widthStyle = width ? `width: ${webkitScrollbarStyle.width};` : '';
            const heightStyle = height ? `height: ${webkitScrollbarStyle.height};` : '';
            (0, $7720754a52a5d205$export$4d99a2890bb989f0)(`
#${randomId}::-webkit-scrollbar {
${widthStyle}
${heightStyle}
}`, randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    const scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    const scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $7720754a52a5d205$export$2232e336aecaa80a)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $3b9e061be790b547$export$2e2bcd8739ae039(fresh) {
    if (typeof document === 'undefined') return 0;
    if (fresh || $3b9e061be790b547$var$cached === undefined) $3b9e061be790b547$var$cached = $3b9e061be790b547$var$measureScrollbarSize();
    return $3b9e061be790b547$var$cached.width;
}
function $3b9e061be790b547$export$4f3ef2310365b56a(target) {
    if (typeof document === 'undefined' || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $3b9e061be790b547$var$measureScrollbarSize(target);
}


/**
 * Test usage export. Do not use in your production
 */ function $111f8a3c08ab6d0c$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


const $15b8e49eeab73520$var$UNIQUE_ID = `rc-util-locker-${Date.now()}`;
let $15b8e49eeab73520$var$uuid = 0;
function $15b8e49eeab73520$export$2e2bcd8739ae039(lock) {
    const mergedLock = !!lock;
    const [id] = $ltGt3.useState(()=>{
        $15b8e49eeab73520$var$uuid += 1;
        return `${$15b8e49eeab73520$var$UNIQUE_ID}_${$15b8e49eeab73520$var$uuid}`;
    });
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (mergedLock) {
            const scrollbarSize = (0, $3b9e061be790b547$export$4f3ef2310365b56a)(document.body).width;
            const isOverflow = (0, $111f8a3c08ab6d0c$export$31b5c8f1131a3a52)();
            (0, $7720754a52a5d205$export$4d99a2890bb989f0)(`
html body {
  overflow-y: hidden;
  ${isOverflow ? `width: calc(100% - ${scrollbarSize}px);` : ''}
}`, id);
        } else (0, $7720754a52a5d205$export$2232e336aecaa80a)(id);
        return ()=>{
            (0, $7720754a52a5d205$export$2232e336aecaa80a)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}


const $3f837e5a2b83701e$var$getPortalContainer = (getContainer)=>{
    if (getContainer === false) return false;
    if (!(0, $19612225313d4e36$export$2e2bcd8739ae039)() || !getContainer) return null;
    if (typeof getContainer === 'string') return document.querySelector(getContainer);
    if (typeof getContainer === 'function') return getContainer();
    return getContainer;
};
const $3f837e5a2b83701e$var$Portal = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { open: open, autoLock: autoLock, getContainer: getContainer, debug: debug, autoDestroy: autoDestroy = true, children: children } = props;
    const [shouldRender, setShouldRender] = $ltGt3.useState(open);
    const mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $ltGt3.useEffect(()=>{
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    const [innerContainer, setInnerContainer] = $ltGt3.useState(()=>$3f837e5a2b83701e$var$getPortalContainer(getContainer));
    $ltGt3.useEffect(()=>{
        const customizeContainer = $3f837e5a2b83701e$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer ?? null);
    });
    const [defaultContainer, queueCreate] = (0, $4c83b9a877b10a91$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug);
    const mergedContainer = innerContainer ?? defaultContainer;
    // ========================= Locker ==========================
    (0, $15b8e49eeab73520$export$2e2bcd8739ae039)(autoLock && open && (0, $19612225313d4e36$export$2e2bcd8739ae039)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // =========================== Ref ===========================
    let childRef = null;
    if (children && (0, $22ff46e28c8066e1$export$c1cec34af06bcf7)(children) && ref) childRef = (0, $22ff46e28c8066e1$export$7465e5c0bf44f19a)(children);
    const mergedRef = (0, $22ff46e28c8066e1$export$1d1c999670a1285d)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $19612225313d4e36$export$2e2bcd8739ae039)() || innerContainer === undefined) return null;
    // Render inline
    const renderInline = mergedContainer === false || (0, $97b0414a436dd092$export$121d9fd0ca615463)();
    let reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $ltGt3.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $ltGt3.createElement((0, $05767d02b7cb2a66$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $35c0fb1a856c78db$exports.createPortal)(reffedChildren, mergedContainer));
});
var $3f837e5a2b83701e$export$2e2bcd8739ae039 = $3f837e5a2b83701e$var$Portal;



var $0561688d8f19e269$export$2e2bcd8739ae039 = (0, $3f837e5a2b83701e$export$2e2bcd8739ae039);


var $10b4a7927d31a5fa$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($10b4a7927d31a5fa$exports) {
        classNames.default = classNames;
        $10b4a7927d31a5fa$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $ltGt3 = parcelRequire("ltGt3");


function $8e3ff42e4a468fd4$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $8e3ff42e4a468fd4$export$9aa546fdc20ae5b3(node) {
    if (node && typeof node === 'object' && $8e3ff42e4a468fd4$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($8e3ff42e4a468fd4$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $8e3ff42e4a468fd4$export$2e2bcd8739ae039(node) {
    const domNode = $8e3ff42e4a468fd4$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node && typeof node === 'object' && 'current' in node) {
        const refDomNode = $8e3ff42e4a468fd4$export$9aa546fdc20ae5b3(node.current);
        if (refDomNode) return refDomNode;
    }
    return null;
}




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
const $05b42d43470d9e81$export$db36075d98ba73d3 = /*#__PURE__*/ $ltGt3.createContext(null);
function $05b42d43470d9e81$export$fb8073518f34e6ec({ children: children, onBatchResize: onBatchResize }) {
    const resizeIdRef = $ltGt3.useRef(0);
    const resizeInfosRef = $ltGt3.useRef([]);
    const onCollectionResize = $ltGt3.useContext($05b42d43470d9e81$export$db36075d98ba73d3);
    const onResize = $ltGt3.useCallback((size, element, data)=>{
        resizeIdRef.current += 1;
        const currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(()=>{
            if (currentId === resizeIdRef.current) {
                onBatchResize?.(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize?.(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $ltGt3.createElement($05b42d43470d9e81$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}


// =============================== Const ===============================
const $61fb67a45d2912b8$var$elementListeners = new Map();
function $61fb67a45d2912b8$var$onResize(entities) {
    entities.forEach((entity)=>{
        const { target: target } = entity;
        $61fb67a45d2912b8$var$elementListeners.get(target)?.forEach((listener)=>listener(target));
    });
}
// Delay create ResizeObserver since it's not supported in server side
let $61fb67a45d2912b8$var$observer;
function $61fb67a45d2912b8$var$ensureResizeObserver() {
    if (!$61fb67a45d2912b8$var$observer) $61fb67a45d2912b8$var$observer = new ResizeObserver($61fb67a45d2912b8$var$onResize);
    return $61fb67a45d2912b8$var$observer;
}
const $61fb67a45d2912b8$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
const $61fb67a45d2912b8$export$524f0fd3b47831a = null; // eslint-disable-line
function $61fb67a45d2912b8$export$d1203567a167490e(element, callback) {
    if (!$61fb67a45d2912b8$var$elementListeners.has(element)) {
        $61fb67a45d2912b8$var$elementListeners.set(element, new Set());
        $61fb67a45d2912b8$var$ensureResizeObserver().observe(element);
    }
    $61fb67a45d2912b8$var$elementListeners.get(element).add(callback);
}
function $61fb67a45d2912b8$export$23a2283368c55ea2(element, callback) {
    if ($61fb67a45d2912b8$var$elementListeners.has(element)) {
        $61fb67a45d2912b8$var$elementListeners.get(element).delete(callback);
        if (!$61fb67a45d2912b8$var$elementListeners.get(element).size) {
            $61fb67a45d2912b8$var$ensureResizeObserver().unobserve(element);
            $61fb67a45d2912b8$var$elementListeners.delete(element);
        }
    }
}


function $762dd05dd6e53cdb$var$SingleObserver(props, ref) {
    const { children: children, disabled: disabled } = props;
    const elementRef = $ltGt3.useRef(null);
    const onCollectionResize = $ltGt3.useContext((0, $05b42d43470d9e81$export$db36075d98ba73d3));
    // =========================== Children ===========================
    const isRenderProps = typeof children === 'function';
    const mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    const sizeRef = $ltGt3.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    const canRef = !isRenderProps && /*#__PURE__*/ $ltGt3.isValidElement(mergedChildren) && (0, $22ff46e28c8066e1$export$c1cec34af06bcf7)(mergedChildren);
    const originRef = canRef ? (0, $22ff46e28c8066e1$export$7465e5c0bf44f19a)(mergedChildren) : null;
    const mergedRef = (0, $22ff46e28c8066e1$export$1d1c999670a1285d)(originRef, elementRef);
    const getDomElement = ()=>{
        return (0, $8e3ff42e4a468fd4$export$9aa546fdc20ae5b3)(elementRef.current);
    };
    $ltGt3.useImperativeHandle(ref, ()=>getDomElement());
    // =========================== Observe ============================
    const propsRef = $ltGt3.useRef(props);
    propsRef.current = props;
    // Handler
    const onInternalResize = $ltGt3.useCallback((target)=>{
        const { onResize: onResize, data: data } = propsRef.current;
        const { width: width, height: height } = target.getBoundingClientRect();
        const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = target;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ const fixedWidth = Math.floor(width);
        const fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            const size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            const mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            const mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            const sizeInfo = {
                ...size,
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            };
            // Let collection know what happened
            onCollectionResize?.(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(()=>{
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $ltGt3.useEffect(()=>{
        const currentElement = getDomElement();
        if (currentElement && !disabled) (0, $61fb67a45d2912b8$export$d1203567a167490e)(currentElement, onInternalResize);
        return ()=>(0, $61fb67a45d2912b8$export$23a2283368c55ea2)(currentElement, onInternalResize);
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return canRef ? /*#__PURE__*/ $ltGt3.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren;
}
const $762dd05dd6e53cdb$var$RefSingleObserver = /*#__PURE__*/ $ltGt3.forwardRef($762dd05dd6e53cdb$var$SingleObserver);
var $762dd05dd6e53cdb$export$2e2bcd8739ae039 = $762dd05dd6e53cdb$var$RefSingleObserver;




function $9ed13185b45d829d$var$_extends() {
    $9ed13185b45d829d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9ed13185b45d829d$var$_extends.apply(this, arguments);
}
const $9ed13185b45d829d$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $9ed13185b45d829d$var$ResizeObserver(props, ref) {
    const { children: children } = props;
    const childNodes = typeof children === 'function' ? [
        children
    ] : (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children);
    return childNodes.map((child, index)=>{
        const key = child?.key || `${$9ed13185b45d829d$var$INTERNAL_PREFIX_KEY}-${index}`;
        return /*#__PURE__*/ $ltGt3.createElement((0, $762dd05dd6e53cdb$export$2e2bcd8739ae039), $9ed13185b45d829d$var$_extends({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
const $9ed13185b45d829d$var$RefResizeObserver = /*#__PURE__*/ $ltGt3.forwardRef($9ed13185b45d829d$var$ResizeObserver);
$9ed13185b45d829d$var$RefResizeObserver.Collection = (0, $05b42d43470d9e81$export$fb8073518f34e6ec);
var $9ed13185b45d829d$export$2e2bcd8739ae039 = $9ed13185b45d829d$var$RefResizeObserver;



function $6b508eb2255763e6$var$getRoot(ele) {
    return ele?.getRootNode?.();
}
function $6b508eb2255763e6$export$cca82218ea4431a(ele) {
    return $6b508eb2255763e6$var$getRoot(ele) instanceof ShadowRoot;
}
function $6b508eb2255763e6$export$70e8259662bb498b(ele) {
    return $6b508eb2255763e6$export$cca82218ea4431a(ele) ? $6b508eb2255763e6$var$getRoot(ele) : null;
}




var $ltGt3 = parcelRequire("ltGt3");
function $1fb03482b73301f3$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    const fullClone = {
        ...$ltGt3
    };
    return fullClone.useId;
}
let $1fb03482b73301f3$var$uuid = 0;
function $1fb03482b73301f3$export$2f0435a662835942() {}
const $1fb03482b73301f3$var$useOriginId = $1fb03482b73301f3$var$getUseId();
var $1fb03482b73301f3$export$2e2bcd8739ae039 = $1fb03482b73301f3$var$useOriginId ? // Use React `useId`
function useId(id) {
    const reactId = $1fb03482b73301f3$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    const [innerId, setInnerId] = $ltGt3.useState('ssr-id');
    $ltGt3.useEffect(()=>{
        const nextId = $1fb03482b73301f3$var$uuid;
        $1fb03482b73301f3$var$uuid += 1;
        setInnerId(`rc_unique_${nextId}`);
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};




var $ltGt3 = parcelRequire("ltGt3");

/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */ 



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
const $a0db28a0967de900$export$841858b892ce1f4c = /*#__PURE__*/ $ltGt3.createContext({});
function $a0db28a0967de900$export$2e2bcd8739ae039({ children: children, ...props }) {
    return /*#__PURE__*/ $ltGt3.createElement($a0db28a0967de900$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}





var $ltGt3 = parcelRequire("ltGt3");

function $7e2804f7c0c6d428$export$2e2bcd8739ae039(defaultValue) {
    const [, forceUpdate] = $ltGt3.useReducer((x)=>x + 1, 0);
    const currentValueRef = $ltGt3.useRef(defaultValue);
    const getValue = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(()=>{
        return currentValueRef.current;
    });
    const setValue = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((updater)=>{
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}



var $ltGt3 = parcelRequire("ltGt3");
const $3a177c28cd648b24$export$de71442bbf2143da = 'none';
const $3a177c28cd648b24$export$4fc3521687bcacd2 = 'appear';
const $3a177c28cd648b24$export$5d6af549241fe2e8 = 'enter';
const $3a177c28cd648b24$export$59b1c493d29f68e4 = 'leave';
const $3a177c28cd648b24$export$40b34dd77d5522bf = 'none';
const $3a177c28cd648b24$export$1b792916a5fac4fc = 'prepare';
const $3a177c28cd648b24$export$9563153dd25a3ce8 = 'start';
const $3a177c28cd648b24$export$e205886172277ec6 = 'active';
const $3a177c28cd648b24$export$3a846c3d2fac10b8 = 'end';
const $3a177c28cd648b24$export$98351fa4e6b4f204 = 'prepared';



var $ltGt3 = parcelRequire("ltGt3");

// ================= Transition =================
// Event wrapper. Copy from react source code
function $2a802767ad721a65$var$makePrefixMap(styleProp, eventName) {
    const prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes[`Webkit${styleProp}`] = `webkit${eventName}`;
    prefixes[`Moz${styleProp}`] = `moz${eventName}`;
    prefixes[`ms${styleProp}`] = `MS${eventName}`;
    prefixes[`O${styleProp}`] = `o${eventName.toLowerCase()}`;
    return prefixes;
}
function $2a802767ad721a65$export$6e8b350b1a8958a0(domSupport, win) {
    const prefixes = {
        animationend: $2a802767ad721a65$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $2a802767ad721a65$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
const $2a802767ad721a65$var$vendorPrefixes = $2a802767ad721a65$export$6e8b350b1a8958a0((0, $19612225313d4e36$export$2e2bcd8739ae039)(), typeof window !== 'undefined' ? window : {});
let $2a802767ad721a65$var$style = {};
if ((0, $19612225313d4e36$export$2e2bcd8739ae039)()) ({ style: $2a802767ad721a65$var$style } = document.createElement('div'));
const $2a802767ad721a65$var$prefixedEventNames = {};
function $2a802767ad721a65$export$a032e4f39350c1d8(eventName) {
    if ($2a802767ad721a65$var$prefixedEventNames[eventName]) return $2a802767ad721a65$var$prefixedEventNames[eventName];
    const prefixMap = $2a802767ad721a65$var$vendorPrefixes[eventName];
    if (prefixMap) {
        const stylePropList = Object.keys(prefixMap);
        const len = stylePropList.length;
        for(let i = 0; i < len; i += 1){
            const styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $2a802767ad721a65$var$style) {
                $2a802767ad721a65$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $2a802767ad721a65$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
const $2a802767ad721a65$var$internalAnimationEndName = $2a802767ad721a65$export$a032e4f39350c1d8('animationend');
const $2a802767ad721a65$var$internalTransitionEndName = $2a802767ad721a65$export$a032e4f39350c1d8('transitionend');
const $2a802767ad721a65$export$d28133ed3ad06c8b = !!($2a802767ad721a65$var$internalAnimationEndName && $2a802767ad721a65$var$internalTransitionEndName);
const $2a802767ad721a65$export$760cc9769c51b738 = $2a802767ad721a65$var$internalAnimationEndName || 'animationend';
const $2a802767ad721a65$export$44baea64b8602e3c = $2a802767ad721a65$var$internalTransitionEndName || 'transitionend';
function $2a802767ad721a65$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if (typeof transitionName === 'object') {
        const type = transitionType.replace(/-\w/g, (match)=>match[1].toUpperCase());
        return transitionName[type];
    }
    return `${transitionName}-${transitionType}`;
}


var $4cb9255b50802e8f$export$2e2bcd8739ae039 = (onInternalMotionEnd)=>{
    const cacheElementRef = (0, $ltGt3.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $2a802767ad721a65$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $2a802767ad721a65$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $2a802767ad721a65$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $2a802767ad721a65$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $ltGt3.useEffect(()=>()=>{
            removeMotionEvents(cacheElementRef.current);
        }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $ltGt3 = parcelRequire("ltGt3");
// It's safe to use `useLayoutEffect` but the warning is annoying
const $42bb68eca33749b0$var$useIsomorphicLayoutEffect = (0, $19612225313d4e36$export$2e2bcd8739ae039)() ? (0, $ltGt3.useLayoutEffect) : (0, $ltGt3.useEffect);
var $42bb68eca33749b0$export$2e2bcd8739ae039 = $42bb68eca33749b0$var$useIsomorphicLayoutEffect;




var $ltGt3 = parcelRequire("ltGt3");


let $04c6b38c8eff394e$var$raf = (callback)=>+setTimeout(callback, 16);
let $04c6b38c8eff394e$var$caf = (num)=>clearTimeout(num);
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $04c6b38c8eff394e$var$raf = (callback)=>window.requestAnimationFrame(callback);
    $04c6b38c8eff394e$var$caf = (handle)=>window.cancelAnimationFrame(handle);
}
let $04c6b38c8eff394e$var$rafUUID = 0;
const $04c6b38c8eff394e$var$rafIds = new Map();
function $04c6b38c8eff394e$var$cleanup(id) {
    $04c6b38c8eff394e$var$rafIds.delete(id);
}
const $04c6b38c8eff394e$var$wrapperRaf = (callback, times = 1)=>{
    $04c6b38c8eff394e$var$rafUUID += 1;
    const id = $04c6b38c8eff394e$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $04c6b38c8eff394e$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            const realId = $04c6b38c8eff394e$var$raf(()=>{
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $04c6b38c8eff394e$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$04c6b38c8eff394e$var$wrapperRaf.cancel = (id)=>{
    const realId = $04c6b38c8eff394e$var$rafIds.get(id);
    $04c6b38c8eff394e$var$cleanup(id);
    return $04c6b38c8eff394e$var$caf(realId);
};
var $04c6b38c8eff394e$export$2e2bcd8739ae039 = $04c6b38c8eff394e$var$wrapperRaf;



var $ltGt3 = parcelRequire("ltGt3");
var $5d069dfb0fbebe19$export$2e2bcd8739ae039 = ()=>{
    const nextFrameRef = $ltGt3.useRef(null);
    function cancelNextFrame() {
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback, delay = 2) {
        cancelNextFrame();
        const nextFrameId = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
            if (delay <= 1) callback({
                isCanceled: ()=>nextFrameId !== nextFrameRef.current
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $ltGt3.useEffect(()=>()=>{
            cancelNextFrame();
        }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


const $ea60e049e98b0419$var$FULL_STEP_QUEUE = [
    (0, $3a177c28cd648b24$export$1b792916a5fac4fc),
    (0, $3a177c28cd648b24$export$9563153dd25a3ce8),
    (0, $3a177c28cd648b24$export$e205886172277ec6),
    (0, $3a177c28cd648b24$export$3a846c3d2fac10b8)
];
const $ea60e049e98b0419$var$SIMPLE_STEP_QUEUE = [
    (0, $3a177c28cd648b24$export$1b792916a5fac4fc),
    (0, $3a177c28cd648b24$export$98351fa4e6b4f204)
];
const $ea60e049e98b0419$export$c2029bf6cfdbc28a = false;
const $ea60e049e98b0419$export$dbee1e282e8c4830 = true;
function $ea60e049e98b0419$export$39e04e72f972b885(step) {
    return step === (0, $3a177c28cd648b24$export$e205886172277ec6) || step === (0, $3a177c28cd648b24$export$3a846c3d2fac10b8);
}
var $ea60e049e98b0419$export$2e2bcd8739ae039 = (status, prepareOnly, callback)=>{
    const [step, setStep] = (0, $451586bd8fd5d39a$export$2e2bcd8739ae039)((0, $3a177c28cd648b24$export$40b34dd77d5522bf));
    const [nextFrame, cancelNextFrame] = (0, $5d069dfb0fbebe19$export$2e2bcd8739ae039)();
    function startQueue() {
        setStep((0, $3a177c28cd648b24$export$1b792916a5fac4fc), true);
    }
    const STEP_QUEUE = prepareOnly ? $ea60e049e98b0419$var$SIMPLE_STEP_QUEUE : $ea60e049e98b0419$var$FULL_STEP_QUEUE;
    (0, $42bb68eca33749b0$export$2e2bcd8739ae039)(()=>{
        if (step !== (0, $3a177c28cd648b24$export$40b34dd77d5522bf) && step !== (0, $3a177c28cd648b24$export$3a846c3d2fac10b8)) {
            const index = STEP_QUEUE.indexOf(step);
            const nextStep = STEP_QUEUE[index + 1];
            const result = callback(step);
            if (result === $ea60e049e98b0419$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame((info)=>{
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $ltGt3.useEffect(()=>()=>{
            cancelNextFrame();
        }, []);
    return [
        startQueue,
        step
    ];
};


function $41280bca0e5ac9b9$export$2e2bcd8739ae039(supportMotion, visible, getElement, { motionEnter: motionEnter = true, motionAppear: motionAppear = true, motionLeave: motionLeave = true, motionDeadline: motionDeadline, motionLeaveImmediately: motionLeaveImmediately, onAppearPrepare: onAppearPrepare, onEnterPrepare: onEnterPrepare, onLeavePrepare: onLeavePrepare, onAppearStart: onAppearStart, onEnterStart: onEnterStart, onLeaveStart: onLeaveStart, onAppearActive: onAppearActive, onEnterActive: onEnterActive, onLeaveActive: onLeaveActive, onAppearEnd: onAppearEnd, onEnterEnd: onEnterEnd, onLeaveEnd: onLeaveEnd, onVisibleChanged: onVisibleChanged }) {
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    const [asyncVisible, setAsyncVisible] = (0, $451586bd8fd5d39a$export$2e2bcd8739ae039)();
    const [getStatus, setStatus] = (0, $7e2804f7c0c6d428$export$2e2bcd8739ae039)((0, $3a177c28cd648b24$export$de71442bbf2143da));
    const [style, setStyle] = (0, $451586bd8fd5d39a$export$2e2bcd8739ae039)(null);
    const currentStatus = getStatus();
    const mountedRef = (0, $ltGt3.useRef)(false);
    const deadlineRef = (0, $ltGt3.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    const activeRef = (0, $ltGt3.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $3a177c28cd648b24$export$de71442bbf2143da));
        setStyle(null, true);
    }
    const onInternalMotionEnd = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((event)=>{
        const status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $3a177c28cd648b24$export$de71442bbf2143da)) return;
        const element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        const currentActive = activeRef.current;
        let canEnd;
        if (status === (0, $3a177c28cd648b24$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd?.(element, event);
        else if (status === (0, $3a177c28cd648b24$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd?.(element, event);
        else if (status === (0, $3a177c28cd648b24$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd?.(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    const [patchMotionEvents] = (0, $4cb9255b50802e8f$export$2e2bcd8739ae039)(onInternalMotionEnd);
    // ============================= Step =============================
    const getEventHandlers = (targetStatus)=>{
        switch(targetStatus){
            case 0, $3a177c28cd648b24$export$4fc3521687bcacd2:
                return {
                    [(0, $3a177c28cd648b24$export$1b792916a5fac4fc)]: onAppearPrepare,
                    [(0, $3a177c28cd648b24$export$9563153dd25a3ce8)]: onAppearStart,
                    [(0, $3a177c28cd648b24$export$e205886172277ec6)]: onAppearActive
                };
            case 0, $3a177c28cd648b24$export$5d6af549241fe2e8:
                return {
                    [(0, $3a177c28cd648b24$export$1b792916a5fac4fc)]: onEnterPrepare,
                    [(0, $3a177c28cd648b24$export$9563153dd25a3ce8)]: onEnterStart,
                    [(0, $3a177c28cd648b24$export$e205886172277ec6)]: onEnterActive
                };
            case 0, $3a177c28cd648b24$export$59b1c493d29f68e4:
                return {
                    [(0, $3a177c28cd648b24$export$1b792916a5fac4fc)]: onLeavePrepare,
                    [(0, $3a177c28cd648b24$export$9563153dd25a3ce8)]: onLeaveStart,
                    [(0, $3a177c28cd648b24$export$e205886172277ec6)]: onLeaveActive
                };
            default:
                return {};
        }
    };
    const eventHandlers = $ltGt3.useMemo(()=>getEventHandlers(currentStatus), [
        currentStatus
    ]);
    const [startStep, step] = (0, $ea60e049e98b0419$export$2e2bcd8739ae039)(currentStatus, !supportMotion, (newStep)=>{
        // Only prepare step can be skip
        if (newStep === (0, $3a177c28cd648b24$export$1b792916a5fac4fc)) {
            const onPrepare = eventHandlers[0, $3a177c28cd648b24$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $ea60e049e98b0419$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) setStyle(eventHandlers[step]?.(getDomElement(), null) || null);
        if (step === (0, $3a177c28cd648b24$export$e205886172277ec6) && currentStatus !== (0, $3a177c28cd648b24$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(()=>{
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $3a177c28cd648b24$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $ea60e049e98b0419$export$dbee1e282e8c4830;
    });
    const active = (0, $ea60e049e98b0419$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    const visibleRef = (0, $ltGt3.useRef)(null);
    // Update with new status
    (0, $42bb68eca33749b0$export$2e2bcd8739ae039)(()=>{
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        const isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        let nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $3a177c28cd648b24$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $3a177c28cd648b24$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $3a177c28cd648b24$export$59b1c493d29f68e4);
        const nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $3a177c28cd648b24$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $3a177c28cd648b24$export$de71442bbf2143da));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $ltGt3.useEffect)(()=>{
        if (// Cancel appear
        currentStatus === (0, $3a177c28cd648b24$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $3a177c28cd648b24$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $3a177c28cd648b24$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $3a177c28cd648b24$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $ltGt3.useEffect)(()=>()=>{
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        }, []);
    // Trigger `onVisibleChanged`
    const firstMountChangeRef = $ltGt3.useRef(false);
    (0, $ltGt3.useEffect)(()=>{
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $3a177c28cd648b24$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged?.(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    let mergedStyle = style;
    if (eventHandlers[0, $3a177c28cd648b24$export$1b792916a5fac4fc] && step === (0, $3a177c28cd648b24$export$9563153dd25a3ce8)) mergedStyle = {
        transition: 'none',
        ...mergedStyle
    };
    return [
        getStatus,
        step,
        mergedStyle,
        asyncVisible ?? visible
    ];
}





function $9097534929948ace$export$e265d52a86a9f199(config) {
    let transitionSupport = config;
    if (typeof config === 'object') ({ transitionSupport: transitionSupport } = config);
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    const CSSMotion = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
        const { visible: // Default config
        visible = true, removeOnLeave: removeOnLeave = true, forceRender: forceRender, children: children, motionName: motionName, leavedClassName: leavedClassName, eventProps: eventProps } = props;
        const { motion: contextMotion } = $ltGt3.useContext((0, $a0db28a0967de900$export$841858b892ce1f4c));
        const supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        const nodeRef = (0, $ltGt3.useRef)();
        function getDomElement() {
            return (0, $8e3ff42e4a468fd4$export$9aa546fdc20ae5b3)(nodeRef.current);
        }
        const [getStatus, statusStep, statusStyle, mergedVisible] = (0, $41280bca0e5ac9b9$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props);
        const status = getStatus();
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        const renderedRef = $ltGt3.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        const refObj = $ltGt3.useMemo(()=>{
            const obj = {};
            Object.defineProperties(obj, {
                nativeElement: {
                    enumerable: true,
                    get: getDomElement
                },
                inMotion: {
                    enumerable: true,
                    get: ()=>()=>getStatus() !== (0, $3a177c28cd648b24$export$de71442bbf2143da)
                },
                enableMotion: {
                    enumerable: true,
                    get: ()=>()=>supportMotion
                }
            });
            return obj;
        }, []);
        // We lock `deps` here since function return object
        // will repeat trigger ref from `refConfig` -> `null` -> `refConfig`
        $ltGt3.useImperativeHandle(ref, ()=>refObj, []);
        // ===================== Render =====================
        let motionChildren;
        const mergedProps = {
            ...eventProps,
            visible: visible
        };
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $3a177c28cd648b24$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children({
                ...mergedProps
            }, nodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children({
                ...mergedProps,
                className: leavedClassName
            }, nodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children({
                ...mergedProps,
                style: {
                    display: 'none'
                }
            }, nodeRef);
            else motionChildren = null;
        } else {
            // In motion
            let statusSuffix;
            if (statusStep === (0, $3a177c28cd648b24$export$1b792916a5fac4fc)) statusSuffix = 'prepare';
            else if ((0, $ea60e049e98b0419$export$39e04e72f972b885)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $3a177c28cd648b24$export$9563153dd25a3ce8)) statusSuffix = 'start';
            const motionCls = (0, $2a802767ad721a65$export$27c72201b1d09951)(motionName, `${status}-${statusSuffix}`);
            motionChildren = children({
                ...mergedProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))((0, $2a802767ad721a65$export$27c72201b1d09951)(motionName, status), {
                    [motionCls]: motionCls && statusSuffix,
                    [motionName]: typeof motionName === 'string'
                }),
                style: statusStyle
            }, nodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $ltGt3.isValidElement(motionChildren) && (0, $22ff46e28c8066e1$export$c1cec34af06bcf7)(motionChildren)) {
            const originNodeRef = (0, $22ff46e28c8066e1$export$7465e5c0bf44f19a)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $ltGt3.cloneElement(motionChildren, {
                ref: nodeRef
            });
        }
        return motionChildren;
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $9097534929948ace$export$2e2bcd8739ae039 = $9097534929948ace$export$e265d52a86a9f199((0, $2a802767ad721a65$export$d28133ed3ad06c8b));



var $ltGt3 = parcelRequire("ltGt3");

const $2b5d7fc236835255$export$3904baa009bc026e = 'add';
const $2b5d7fc236835255$export$851162f0adad2cbc = 'keep';
const $2b5d7fc236835255$export$c8b3fb08b68cfc85 = 'remove';
const $2b5d7fc236835255$export$2ac1bd1808d2e43a = 'removed';
function $2b5d7fc236835255$export$c47fd798e598c85c(key) {
    let keyObj;
    if (key && typeof key === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return {
        ...keyObj,
        key: String(keyObj.key)
    };
}
function $2b5d7fc236835255$export$84bd7bd42ccc0f72(keys = []) {
    return keys.map($2b5d7fc236835255$export$c47fd798e598c85c);
}
function $2b5d7fc236835255$export$14527669107aa301(prevKeys = [], currentKeys = []) {
    let list = [];
    let currentIndex = 0;
    const currentLen = currentKeys.length;
    const prevKeyObjects = $2b5d7fc236835255$export$84bd7bd42ccc0f72(prevKeys);
    const currentKeyObjects = $2b5d7fc236835255$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach((keyObj)=>{
        let hit = false;
        for(let i = currentIndex; i < currentLen; i += 1){
            const currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map((obj)=>({
                            ...obj,
                            status: $2b5d7fc236835255$export$3904baa009bc026e
                        })));
                    currentIndex = i;
                }
                list.push({
                    ...currentKeyObj,
                    status: $2b5d7fc236835255$export$851162f0adad2cbc
                });
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push({
            ...keyObj,
            status: $2b5d7fc236835255$export$c8b3fb08b68cfc85
        });
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map((obj)=>({
            ...obj,
            status: $2b5d7fc236835255$export$3904baa009bc026e
        })));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ const keys = {};
    list.forEach(({ key: key })=>{
        keys[key] = (keys[key] || 0) + 1;
    });
    const duplicatedKeys = Object.keys(keys).filter((key)=>keys[key] > 1);
    duplicatedKeys.forEach((matchKey)=>{
        // Remove `STATUS_REMOVE` node.
        list = list.filter(({ key: key, status: status })=>key !== matchKey || status !== $2b5d7fc236835255$export$c8b3fb08b68cfc85);
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach((node)=>{
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $2b5d7fc236835255$export$851162f0adad2cbc;
        });
    });
    return list;
}



function $9073ece020846a7d$var$_extends() {
    $9073ece020846a7d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9073ece020846a7d$var$_extends.apply(this, arguments);
}
const $9073ece020846a7d$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $9073ece020846a7d$export$fcfc62c1d33d5e2e(transitionSupport, CSSMotion = (0, $9097534929948ace$export$2e2bcd8739ae039)) {
    class CSSMotionList extends $ltGt3.Component {
        static defaultProps = {
            component: 'div'
        };
        state = {
            keyEntities: []
        };
        static getDerivedStateFromProps({ keys: keys }, { keyEntities: keyEntities }) {
            const parsedKeyObjects = (0, $2b5d7fc236835255$export$84bd7bd42ccc0f72)(keys);
            const mixedKeyEntities = (0, $2b5d7fc236835255$export$14527669107aa301)(keyEntities, parsedKeyObjects);
            return {
                keyEntities: mixedKeyEntities.filter((entity)=>{
                    const prevEntity = keyEntities.find(({ key: key })=>entity.key === key);
                    // Remove if already mark as removed
                    if (prevEntity && prevEntity.status === (0, $2b5d7fc236835255$export$2ac1bd1808d2e43a) && entity.status === (0, $2b5d7fc236835255$export$c8b3fb08b68cfc85)) return false;
                    return true;
                })
            };
        }
        // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
        removeKey = (removeKey)=>{
            this.setState((prevState)=>{
                const nextKeyEntities = prevState.keyEntities.map((entity)=>{
                    if (entity.key !== removeKey) return entity;
                    return {
                        ...entity,
                        status: (0, $2b5d7fc236835255$export$2ac1bd1808d2e43a)
                    };
                });
                return {
                    keyEntities: nextKeyEntities
                };
            }, ()=>{
                const { keyEntities: keyEntities } = this.state;
                const restKeysCount = keyEntities.filter(({ status: status })=>status !== (0, $2b5d7fc236835255$export$2ac1bd1808d2e43a)).length;
                if (restKeysCount === 0 && this.props.onAllRemoved) this.props.onAllRemoved();
            });
        };
        render() {
            const { keyEntities: keyEntities } = this.state;
            const { component: component, children: children, onVisibleChanged: onVisibleChanged, onAllRemoved: onAllRemoved, ...restProps } = this.props;
            const Component = component || $ltGt3.Fragment;
            const motionProps = {};
            $9073ece020846a7d$var$MOTION_PROP_NAMES.forEach((prop)=>{
                motionProps[prop] = restProps[prop];
                delete restProps[prop];
            });
            delete restProps.keys;
            return /*#__PURE__*/ $ltGt3.createElement(Component, restProps, keyEntities.map(({ status: status, ...eventProps }, index)=>{
                const visible = status === (0, $2b5d7fc236835255$export$3904baa009bc026e) || status === (0, $2b5d7fc236835255$export$851162f0adad2cbc);
                return /*#__PURE__*/ $ltGt3.createElement(CSSMotion, $9073ece020846a7d$var$_extends({}, motionProps, {
                    key: eventProps.key,
                    visible: visible,
                    eventProps: eventProps,
                    onVisibleChanged: (changedVisible)=>{
                        onVisibleChanged?.(changedVisible, {
                            key: eventProps.key
                        });
                        if (!changedVisible) this.removeKey(eventProps.key);
                    }
                }), (props, ref)=>children({
                        ...props,
                        index: index
                    }, ref));
            }));
        }
    }
    return CSSMotionList;
}
var $9073ece020846a7d$export$2e2bcd8739ae039 = $9073ece020846a7d$export$fcfc62c1d33d5e2e((0, $2a802767ad721a65$export$d28133ed3ad06c8b));



var $69429c2a85a175b0$export$2e2bcd8739ae039 = (0, $9097534929948ace$export$2e2bcd8739ae039);






var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
function $34aea424ee2d43cd$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, align: align, arrow: arrow, arrowPos: arrowPos } = props;
    const { className: className, content: content, style: style } = arrow || {};
    const { x: x = 0, y: y = 0 } = arrowPos;
    const arrowRef = $ltGt3.useRef(null);
    // Skip if no align
    if (!align || !align.points) return null;
    const alignStyle = {
        position: 'absolute'
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        const popupPoints = align.points[0];
        const targetPoints = align.points[1];
        const popupTB = popupPoints[0];
        const popupLR = popupPoints[1];
        const targetTB = targetPoints[0];
        const targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            't',
            'b'
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === 't') alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            'l',
            'r'
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === 'l') alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: arrowRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-arrow`, className),
        style: {
            ...alignStyle,
            ...style
        }
    }, content);
}





var $ltGt3 = parcelRequire("ltGt3");
function $6e7516af922c92c7$var$_extends() {
    $6e7516af922c92c7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6e7516af922c92c7$var$_extends.apply(this, arguments);
}
function $6e7516af922c92c7$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, open: open, zIndex: zIndex, mask: mask, motion: motion, mobile: mobile } = props;
    if (!mask) return null;
    return /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), $6e7516af922c92c7$var$_extends({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), ({ className: className })=>/*#__PURE__*/ $ltGt3.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-mask`, mobile && `${prefixCls}-mobile-mask`, className)
        }));
}



var $ltGt3 = parcelRequire("ltGt3");
const $930acac6b12a8f82$var$PopupContent = /*#__PURE__*/ $ltGt3.memo(({ children: children })=>children, (_, next)=>next.cache);
var $930acac6b12a8f82$export$2e2bcd8739ae039 = $930acac6b12a8f82$var$PopupContent;


function $3cea4acec143f075$export$2e2bcd8739ae039(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY) {
    // >>>>> Offset
    const AUTO = 'auto';
    const offsetStyle = isMobile ? {} : {
        left: '-1000vw',
        top: '-1000vh',
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (!isMobile && (ready || !open)) {
        const { points: points } = align;
        const dynamicInset = align.dynamicInset || align._experimental?.dynamicInset;
        const alignRight = dynamicInset && points[0][1] === 'r';
        const alignBottom = dynamicInset && points[0][0] === 'b';
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    return offsetStyle;
}



function $b17fefdb412b77e7$var$_extends() {
    $b17fefdb412b77e7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b17fefdb412b77e7$var$_extends.apply(this, arguments);
}
const $b17fefdb412b77e7$var$Popup = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { popup: popup, className: className, prefixCls: prefixCls, style: style, target: target, onVisibleChanged: onVisibleChanged, open: // Open
    open, keepDom: keepDom, fresh: fresh, onClick: // Click
    onClick, mask: // Mask
    mask, arrow: // Arrow
    arrow, arrowPos: arrowPos, align: align, motion: // Motion
    motion, maskMotion: maskMotion, mobile: // Mobile
    mobile, forceRender: // Portal
    forceRender, getPopupContainer: getPopupContainer, autoDestroy: autoDestroy, portal: Portal, children: children, zIndex: zIndex, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerEnter: onPointerEnter, onPointerDownCapture: onPointerDownCapture, ready: ready, offsetX: offsetX, offsetY: offsetY, offsetR: offsetR, offsetB: offsetB, onAlign: onAlign, onPrepare: onPrepare, onResize: // Resize
    onResize, stretch: stretch, targetWidth: targetWidth, targetHeight: targetHeight } = props;
    const popupContent = typeof popup === 'function' ? popup() : popup;
    // We can not remove holder only when motion finished.
    const isNodeVisible = open || keepDom;
    // ========================= Mobile =========================
    const isMobile = !!mobile;
    // ========================== Mask ==========================
    const [mergedMask, mergedMaskMotion, mergedPopupMotion] = $ltGt3.useMemo(()=>{
        if (mobile) return [
            mobile.mask,
            mobile.maskMotion,
            mobile.motion
        ];
        return [
            mask,
            maskMotion,
            motion
        ];
    }, [
        mobile,
        mask,
        maskMotion,
        motion
    ]);
    // ======================= Container ========================
    const getPopupContainerNeedParams = getPopupContainer?.length > 0;
    const [show, setShow] = $ltGt3.useState(!getPopupContainer || !getPopupContainerNeedParams);
    // Delay to show since `getPopupContainer` need target element
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Resize =========================
    const onInternalResize = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((size, ele)=>{
        onResize?.(size, ele);
        onAlign();
    });
    // ========================= Styles =========================
    const offsetStyle = (0, $3cea4acec143f075$export$2e2bcd8739ae039)(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Misc
    const miscStyle = {};
    if (stretch) {
        if (stretch.includes('height') && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes('minHeight') && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes('width') && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes('minWidth') && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = 'none';
    return /*#__PURE__*/ $ltGt3.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && (()=>getPopupContainer(target)),
        autoDestroy: autoDestroy
    }, /*#__PURE__*/ $ltGt3.createElement((0, $6e7516af922c92c7$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mergedMask,
        motion: mergedMaskMotion,
        mobile: isMobile
    }), /*#__PURE__*/ $ltGt3.createElement((0, $9ed13185b45d829d$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !open
    }, (resizeObserverRef)=>{
        return /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), $b17fefdb412b77e7$var$_extends({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: `${prefixCls}-hidden`
        }, mergedPopupMotion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: (nextVisible)=>{
                motion?.onVisibleChanged?.(nextVisible);
                onVisibleChanged(nextVisible);
            }
        }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
            const cls = (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prefixCls, motionClassName, className, {
                [`${prefixCls}-mobile`]: isMobile
            });
            return /*#__PURE__*/ $ltGt3.createElement("div", {
                ref: (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: {
                    '--arrow-x': `${arrowPos.x || 0}px`,
                    '--arrow-y': `${arrowPos.y || 0}px`,
                    ...offsetStyle,
                    ...miscStyle,
                    ...motionStyle,
                    boxSizing: 'border-box',
                    zIndex: zIndex,
                    ...style
                },
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick,
                onPointerDownCapture: onPointerDownCapture
            }, arrow && /*#__PURE__*/ $ltGt3.createElement((0, $34aea424ee2d43cd$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $ltGt3.createElement((0, $930acac6b12a8f82$export$2e2bcd8739ae039), {
                cache: !open && !fresh
            }, popupContent));
        });
    }), children);
});
var $b17fefdb412b77e7$export$2e2bcd8739ae039 = $b17fefdb412b77e7$var$Popup;



var $ltGt3 = parcelRequire("ltGt3");
// ===================== Nest =====================
const $4f1b3627aab15ab2$var$TriggerContext = /*#__PURE__*/ $ltGt3.createContext(null);
var $4f1b3627aab15ab2$export$2e2bcd8739ae039 = $4f1b3627aab15ab2$var$TriggerContext;
const $4f1b3627aab15ab2$export$14cc6d12cdc906c = /*#__PURE__*/ $ltGt3.createContext(null);



var $ltGt3 = parcelRequire("ltGt3");
function $9b81f97d74004187$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $9b81f97d74004187$export$2e2bcd8739ae039(action, showAction, hideAction) {
    return $ltGt3.useMemo(()=>{
        const mergedShowAction = $9b81f97d74004187$var$toArray(showAction ?? action);
        const mergedHideAction = $9b81f97d74004187$var$toArray(hideAction ?? action);
        const showActionSet = new Set(mergedShowAction);
        const hideActionSet = new Set(mergedHideAction);
        if (showActionSet.has('hover') && !showActionSet.has('click')) showActionSet.add('touch');
        if (hideActionSet.has('hover') && !hideActionSet.has('click')) hideActionSet.add('touch');
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        action,
        showAction,
        hideAction
    ]);
}







var $ltGt3 = parcelRequire("ltGt3");
function $fea35d5e996e6c0f$var$isPointsEq(a1 = [], a2 = [], isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $fea35d5e996e6c0f$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    const { points: points } = align;
    const placements = Object.keys(builtinPlacements);
    for(let i = 0; i < placements.length; i += 1){
        const placement = placements[i];
        if ($fea35d5e996e6c0f$var$isPointsEq(builtinPlacements[placement]?.points, points, isAlignPoint)) return `${prefixCls}-placement-${placement}`;
    }
    return '';
}
function $fea35d5e996e6c0f$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $fea35d5e996e6c0f$export$ba21ed9400ca485b(ele) {
    const scrollerList = [];
    let current = ele?.parentElement;
    const scrollStyle = [
        'hidden',
        'scroll',
        'clip',
        'auto'
    ];
    while(current){
        const { overflowX: overflowX, overflowY: overflowY, overflow: overflow } = $fea35d5e996e6c0f$export$9c0584a7cc24d9e(current).getComputedStyle(current);
        if ([
            overflowX,
            overflowY,
            overflow
        ].some((o)=>scrollStyle.includes(o))) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $fea35d5e996e6c0f$export$34dfc8f73bbb64ae(num, defaultValue = 1) {
    return Number.isNaN(num) ? defaultValue : num;
}
function $fea35d5e996e6c0f$var$getPxValue(val) {
    return $fea35d5e996e6c0f$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $fea35d5e996e6c0f$export$94be9d7985092f2d(initArea, scrollerList) {
    const visibleArea = {
        ...initArea
    };
    (scrollerList || []).forEach((ele)=>{
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        const { overflow: overflow, overflowClipMargin: overflowClipMargin, borderTopWidth: borderTopWidth, borderBottomWidth: borderBottomWidth, borderLeftWidth: borderLeftWidth, borderRightWidth: borderRightWidth } = $fea35d5e996e6c0f$export$9c0584a7cc24d9e(ele).getComputedStyle(ele);
        const eleRect = ele.getBoundingClientRect();
        const { offsetHeight: eleOutHeight, clientHeight: eleInnerHeight, offsetWidth: eleOutWidth, clientWidth: eleInnerWidth } = ele;
        const borderTopNum = $fea35d5e996e6c0f$var$getPxValue(borderTopWidth);
        const borderBottomNum = $fea35d5e996e6c0f$var$getPxValue(borderBottomWidth);
        const borderLeftNum = $fea35d5e996e6c0f$var$getPxValue(borderLeftWidth);
        const borderRightNum = $fea35d5e996e6c0f$var$getPxValue(borderRightWidth);
        const scaleX = $fea35d5e996e6c0f$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        const scaleY = $fea35d5e996e6c0f$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        const eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        const eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        const scaledBorderTopWidth = borderTopNum * scaleY;
        const scaledBorderBottomWidth = borderBottomNum * scaleY;
        const scaledBorderLeftWidth = borderLeftNum * scaleX;
        const scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        let clipMarginWidth = 0;
        let clipMarginHeight = 0;
        if (overflow === 'clip') {
            const clipNum = $fea35d5e996e6c0f$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        const eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        const eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        const eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        const eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}


function $cf21e703846db911$var$getUnitOffset(size, offset = 0) {
    const offsetStr = `${offset}`;
    const cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $cf21e703846db911$var$getNumberOffset(rect, offset) {
    const [offsetX, offsetY] = offset || [];
    return [
        $cf21e703846db911$var$getUnitOffset(rect.width, offsetX),
        $cf21e703846db911$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $cf21e703846db911$var$splitPoints(points = '') {
    return [
        points[0],
        points[1]
    ];
}
function $cf21e703846db911$var$getAlignPoint(rect, points) {
    const topBottom = points[0];
    const leftRight = points[1];
    let x;
    let y;
    // Top & Bottom
    if (topBottom === 't') y = rect.y;
    else if (topBottom === 'b') y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === 'l') x = rect.x;
    else if (leftRight === 'r') x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $cf21e703846db911$var$reversePoints(points, index) {
    const reverseMap = {
        t: 'b',
        b: 't',
        l: 'r',
        r: 'l'
    };
    return points.map((point, i)=>{
        if (i === index) return reverseMap[point] || 'c';
        return point;
    }).join('');
}
function $cf21e703846db911$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign, mobile) {
    const [offsetInfo, setOffsetInfo] = $ltGt3.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    });
    const alignCountRef = $ltGt3.useRef(0);
    const scrollerList = $ltGt3.useMemo(()=>{
        if (!popupEle || mobile) return [];
        return (0, $fea35d5e996e6c0f$export$ba21ed9400ca485b)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    const prevFlipRef = $ltGt3.useRef({});
    const resetFlipCache = ()=>{
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    const onAlign = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(()=>{
        if (popupEle && target && open && !mobile) {
            const popupElement = popupEle;
            const doc = popupElement.ownerDocument;
            const win = (0, $fea35d5e996e6c0f$export$9c0584a7cc24d9e)(popupElement);
            const { position: popupPosition } = win.getComputedStyle(popupElement);
            const originLeft = popupElement.style.left;
            const originTop = popupElement.style.top;
            const originRight = popupElement.style.right;
            const originBottom = popupElement.style.bottom;
            const originOverflow = popupElement.style.overflow;
            // Placement
            const placementInfo = {
                ...builtinPlacements[placement],
                ...popupAlign
            };
            // placeholder element
            const placeholderElement = doc.createElement('div');
            popupElement.parentElement?.appendChild(placeholderElement);
            placeholderElement.style.left = `${popupElement.offsetLeft}px`;
            placeholderElement.style.top = `${popupElement.offsetTop}px`;
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = `${popupElement.offsetHeight}px`;
            placeholderElement.style.width = `${popupElement.offsetWidth}px`;
            // Reset first
            popupElement.style.left = '0';
            popupElement.style.top = '0';
            popupElement.style.right = 'auto';
            popupElement.style.bottom = 'auto';
            popupElement.style.overflow = 'hidden';
            // Calculate align style, we should consider `transform` case
            let targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                const rect = target.getBoundingClientRect();
                rect.x = rect.x ?? rect.left;
                rect.y = rect.y ?? rect.top;
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            const popupRect = popupElement.getBoundingClientRect();
            const { height: height, width: width } = win.getComputedStyle(popupElement);
            popupRect.x = popupRect.x ?? popupRect.left;
            popupRect.y = popupRect.y ?? popupRect.top;
            const { clientWidth: clientWidth, clientHeight: clientHeight, scrollWidth: scrollWidth, scrollHeight: scrollHeight, scrollTop: scrollTop, scrollLeft: scrollLeft } = doc.documentElement;
            const popupHeight = popupRect.height;
            const popupWidth = popupRect.width;
            const targetHeight = targetRect.height;
            const targetWidth = targetRect.width;
            // Get bounding of visible area
            const visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            const scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            let { htmlRegion: htmlRegion } = placementInfo;
            const VISIBLE = 'visible';
            const VISIBLE_FIRST = 'visibleFirst';
            if (htmlRegion !== 'scroll' && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            const isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            const scrollRegionArea = (0, $fea35d5e996e6c0f$export$94be9d7985092f2d)(scrollRegion, scrollerList);
            const visibleRegionArea = (0, $fea35d5e996e6c0f$export$94be9d7985092f2d)(visibleRegion, scrollerList);
            const visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            const adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = 'auto';
            popupElement.style.top = 'auto';
            popupElement.style.right = '0';
            popupElement.style.bottom = '0';
            const popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            popupElement.parentElement?.removeChild(placeholderElement);
            // Calculate scale
            const scaleX = (0, $fea35d5e996e6c0f$export$34dfc8f73bbb64ae)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            const scaleY = (0, $fea35d5e996e6c0f$export$34dfc8f73bbb64ae)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (scaleX === 0 || scaleY === 0 || (0, $8e3ff42e4a468fd4$export$41e30d8dd0ba7a50)(target) && !(0, $d3c89c1e130d7e35$export$2e2bcd8739ae039)(target)) return;
            // Offset
            const { offset: offset, targetOffset: targetOffset } = placementInfo;
            let [popupOffsetX, popupOffsetY] = $cf21e703846db911$var$getNumberOffset(popupRect, offset);
            const [targetOffsetX, targetOffsetY] = $cf21e703846db911$var$getNumberOffset(targetRect, targetOffset);
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            const [popupPoint, targetPoint] = placementInfo.points || [];
            const targetPoints = $cf21e703846db911$var$splitPoints(targetPoint);
            const popupPoints = $cf21e703846db911$var$splitPoints(popupPoint);
            const targetAlignPoint = $cf21e703846db911$var$getAlignPoint(targetRect, targetPoints);
            const popupAlignPoint = $cf21e703846db911$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            const nextAlignInfo = {
                ...placementInfo
            };
            // Next Offset
            let nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            let nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY, area = visibleArea) {
                const l = popupRect.x + offsetX;
                const t = popupRect.y + offsetY;
                const r = l + popupWidth;
                const b = t + popupHeight;
                const visibleL = Math.max(l, area.left);
                const visibleT = Math.max(t, area.top);
                const visibleR = Math.min(r, area.right);
                const visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            const originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            const originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            const targetAlignPointTL = $cf21e703846db911$var$getAlignPoint(targetRect, [
                't',
                'l'
            ]);
            const popupAlignPointTL = $cf21e703846db911$var$getAlignPoint(popupRect, [
                't',
                'l'
            ]);
            const targetAlignPointBR = $cf21e703846db911$var$getAlignPoint(targetRect, [
                'b',
                'r'
            ]);
            const popupAlignPointBR = $cf21e703846db911$var$getAlignPoint(popupRect, [
                'b',
                'r'
            ]);
            const overflow = placementInfo.overflow || {};
            const { adjustX: adjustX, adjustY: adjustY, shiftX: shiftX, shiftY: shiftY } = overflow;
            const supportAdjust = (val)=>{
                if (typeof val === 'boolean') return val;
                return val >= 0;
            };
            // Prepare position
            let nextPopupY;
            let nextPopupBottom;
            let nextPopupX;
            let nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            const needAdjustY = supportAdjust(adjustY);
            const sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === 't' && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                let tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                const newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $cf21e703846db911$var$reversePoints(popupPoints, 0),
                        $cf21e703846db911$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === 'b' && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                let tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY += popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                const newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $cf21e703846db911$var$reversePoints(popupPoints, 0),
                        $cf21e703846db911$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            const needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            const sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === 'l' && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                let tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                const newVisibleArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $cf21e703846db911$var$reversePoints(popupPoints, 1),
                        $cf21e703846db911$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === 'r' && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                let tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX += popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                const newVisibleArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $cf21e703846db911$var$reversePoints(popupPoints, 1),
                        $cf21e703846db911$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            // ============================ Shift ============================
            syncNextPopupPosition();
            const numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === 'number') {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            const numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === 'number') {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            const popupLeft = popupRect.x + nextOffsetX;
            const popupRight = popupLeft + popupWidth;
            const popupTop = popupRect.y + nextOffsetY;
            const popupBottom = popupTop + popupHeight;
            const targetLeft = targetRect.x;
            const targetRight = targetLeft + targetWidth;
            const targetTop = targetRect.y;
            const targetBottom = targetTop + targetHeight;
            /** Max left of the popup and target element */ const maxLeft = Math.max(popupLeft, targetLeft);
            /** Min right of the popup and target element */ const minRight = Math.min(popupRight, targetRight);
            /** The center X of popup & target cross area */ const xCenter = (maxLeft + minRight) / 2;
            /** Arrow X of popup offset */ const nextArrowX = xCenter - popupLeft;
            const maxTop = Math.max(popupTop, targetTop);
            const minBottom = Math.min(popupBottom, targetBottom);
            const yCenter = (maxTop + minBottom) / 2;
            const nextArrowY = yCenter - popupTop;
            onPopupAlign?.(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            let offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            let offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            if (scaleX === 1) {
                nextOffsetX = Math.round(nextOffsetX);
                offsetX4Right = Math.round(offsetX4Right);
            }
            if (scaleY === 1) {
                nextOffsetY = Math.round(nextOffsetY);
                offsetY4Bottom = Math.round(offsetY4Bottom);
            }
            const nextOffsetInfo = {
                ready: true,
                offsetX: nextOffsetX / scaleX,
                offsetY: nextOffsetY / scaleY,
                offsetR: offsetX4Right / scaleX,
                offsetB: offsetY4Bottom / scaleY,
                arrowX: nextArrowX / scaleX,
                arrowY: nextArrowY / scaleY,
                scaleX: scaleX,
                scaleY: scaleY,
                align: nextAlignInfo
            };
            setOffsetInfo(nextOffsetInfo);
        }
    });
    const triggerAlign = ()=>{
        alignCountRef.current += 1;
        const id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(()=>{
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    const resetReady = ()=>{
        setOffsetInfo((ori)=>({
                ...ori,
                ready: false
            }));
    };
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(resetReady, [
        placement
    ]);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}



var $ltGt3 = parcelRequire("ltGt3");
function $702946aa9755a88e$export$2e2bcd8739ae039() {
    const delayRef = $ltGt3.useRef(null);
    const clearDelay = ()=>{
        if (delayRef.current) {
            clearTimeout(delayRef.current);
            delayRef.current = null;
        }
    };
    const delayInvoke = (callback, delay)=>{
        clearDelay();
        if (delay === 0) callback();
        else delayRef.current = setTimeout(()=>{
            callback();
        }, delay * 1000);
    };
    // Clean up on unmount
    $ltGt3.useEffect(()=>{
        return ()=>{
            clearDelay();
        };
    }, []);
    return delayInvoke;
}




function $fff7156b395cae65$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (open && target && popup) {
            const targetElement = target;
            const popupElement = popup;
            const targetScrollList = (0, $fea35d5e996e6c0f$export$ba21ed9400ca485b)(targetElement);
            const popupScrollList = (0, $fea35d5e996e6c0f$export$ba21ed9400ca485b)(popupElement);
            const win = (0, $fea35d5e996e6c0f$export$9c0584a7cc24d9e)(popupElement);
            const mergedList = new Set([
                win,
                ...targetScrollList,
                ...popupScrollList
            ]);
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach((scroller)=>{
                scroller.addEventListener('scroll', notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener('resize', notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return ()=>{
                mergedList.forEach((scroller)=>{
                    scroller.removeEventListener('scroll', notifyScroll);
                    win.removeEventListener('resize', notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}





var $ltGt3 = parcelRequire("ltGt3");

function $6ec6b75f81787216$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    const openRef = $ltGt3.useRef(open);
    openRef.current = open;
    const popupPointerDownRef = $ltGt3.useRef(false);
    // Click to hide is special action since click popup element should not hide
    $ltGt3.useEffect(()=>{
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            const onPointerDown = ()=>{
                popupPointerDownRef.current = false;
            };
            const onTriggerClose = (e)=>{
                if (openRef.current && !inPopupOrChild(e.composedPath?.()?.[0] || e.target) && !popupPointerDownRef.current) triggerOpen(false);
            };
            const win = (0, $fea35d5e996e6c0f$export$9c0584a7cc24d9e)(popupEle);
            win.addEventListener('pointerdown', onPointerDown, true);
            win.addEventListener('mousedown', onTriggerClose, true);
            win.addEventListener('contextmenu', onTriggerClose, true);
            // shadow root
            const targetShadowRoot = (0, $6b508eb2255763e6$export$70e8259662bb498b)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener('mousedown', onTriggerClose, true);
                targetShadowRoot.addEventListener('contextmenu', onTriggerClose, true);
            }
            return ()=>{
                win.removeEventListener('pointerdown', onPointerDown, true);
                win.removeEventListener('mousedown', onTriggerClose, true);
                win.removeEventListener('contextmenu', onTriggerClose, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener('mousedown', onTriggerClose, true);
                    targetShadowRoot.removeEventListener('contextmenu', onTriggerClose, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
    function onPopupPointerDown() {
        popupPointerDownRef.current = true;
    }
    return onPopupPointerDown;
}




var $ltGt3 = parcelRequire("ltGt3");







var $ltGt3 = parcelRequire("ltGt3");

function $8b2e5ea2dcb52b44$export$2e2bcd8739ae039() {
    const [options, setOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(null);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(false);
    const [isAnimating, setIsAnimating] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(false);
    const pendingOptionsRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    const trigger = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((nextOptions)=>{
        if (nextOptions === false) {
            // Clear pending options when hiding
            pendingOptionsRef.current = null;
            setOpen(false);
        } else if (isAnimating && open) // If animating (appear or enter), cache new options
        pendingOptionsRef.current = nextOptions;
        else {
            setOpen(true);
            // Set new options
            setOptions(nextOptions);
            pendingOptionsRef.current = null;
            // Only mark as animating when transitioning from closed to open
            if (!open) setIsAnimating(true);
        }
    });
    const onVisibleChanged = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((visible)=>{
        if (visible) {
            // Animation enter completed, check if there are pending options
            setIsAnimating(false);
            if (pendingOptionsRef.current) {
                // Apply pending options
                setOptions(pendingOptionsRef.current);
                pendingOptionsRef.current = null;
            }
        } else {
            // Animation leave completed
            setIsAnimating(false);
            pendingOptionsRef.current = null;
        }
    });
    return [
        trigger,
        open,
        options,
        onVisibleChanged
    ];
}




var $ltGt3 = parcelRequire("ltGt3");



function $1c554cd74112abe7$var$_extends() {
    $1c554cd74112abe7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c554cd74112abe7$var$_extends.apply(this, arguments);
}
const $1c554cd74112abe7$var$UniqueContainer = (props)=>{
    const { prefixCls: prefixCls, isMobile: isMobile, ready: ready, open: open, align: align, offsetR: offsetR, offsetB: offsetB, offsetX: offsetX, offsetY: offsetY, arrowPos: arrowPos, popupSize: popupSize, motion: motion, uniqueContainerClassName: uniqueContainerClassName, uniqueContainerStyle: uniqueContainerStyle } = props;
    const containerCls = `${prefixCls}-unique-container`;
    const [motionVisible, setMotionVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(false);
    // ========================= Styles =========================
    const offsetStyle = (0, $3cea4acec143f075$export$2e2bcd8739ae039)(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY);
    // Cache for offsetStyle when ready is true
    const cachedOffsetStyleRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(offsetStyle);
    // Update cached offset style when ready is true
    if (ready) cachedOffsetStyleRef.current = offsetStyle;
    // Apply popup size if available
    const sizeStyle = {};
    if (popupSize) {
        sizeStyle.width = popupSize.width;
        sizeStyle.height = popupSize.height;
    }
    // ========================= Render =========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), $1c554cd74112abe7$var$_extends({
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        removeOnLeave: false,
        leavedClassName: `${containerCls}-hidden`
    }, motion, {
        visible: open,
        onVisibleChanged: (nextVisible)=>{
            setMotionVisible(nextVisible);
        }
    }), ({ className: motionClassName, style: motionStyle })=>{
        const cls = (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(containerCls, motionClassName, uniqueContainerClassName, {
            [`${containerCls}-visible`]: motionVisible
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
            className: cls,
            style: {
                '--arrow-x': `${arrowPos?.x || 0}px`,
                '--arrow-y': `${arrowPos?.y || 0}px`,
                ...cachedOffsetStyleRef.current,
                ...sizeStyle,
                ...motionStyle,
                ...uniqueContainerStyle
            }
        });
    });
};
var $1c554cd74112abe7$export$2e2bcd8739ae039 = $1c554cd74112abe7$var$UniqueContainer;




const $d949588b92412a17$var$UniqueProvider = ({ children: children, postTriggerProps: postTriggerProps })=>{
    const [trigger, open, options, onTargetVisibleChanged] = (0, $8b2e5ea2dcb52b44$export$2e2bcd8739ae039)();
    // ========================== Options ===========================
    const mergedOptions = $ltGt3.useMemo(()=>{
        if (!options || !postTriggerProps) return options;
        return postTriggerProps(options);
    }, [
        options,
        postTriggerProps
    ]);
    // =========================== Popup ============================
    const [popupEle, setPopupEle] = $ltGt3.useState(null);
    const [popupSize, setPopupSize] = $ltGt3.useState(null);
    // Used for forwardRef popup. Not use internal
    const externalPopupRef = $ltGt3.useRef(null);
    const setPopupRef = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((node)=>{
        externalPopupRef.current = node;
        if ((0, $8e3ff42e4a468fd4$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
    });
    // ========================== Register ==========================
    // Store the isOpen function from the latest show call
    const isOpenRef = $ltGt3.useRef(null);
    const delayInvoke = (0, $702946aa9755a88e$export$2e2bcd8739ae039)();
    const show = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((showOptions, isOpen)=>{
        // Store the isOpen function for later use in hide
        isOpenRef.current = isOpen;
        delayInvoke(()=>{
            trigger(showOptions);
        }, showOptions.delay);
    });
    const hide = (delay)=>{
        delayInvoke(()=>{
            // Check if we should still hide by calling the isOpen function
            // If isOpen returns true, it means another trigger wants to keep it open
            if (isOpenRef.current?.()) return; // Don't hide if something else wants it open
            trigger(false);
        // Don't clear target, currentNode, options immediately, wait until animation completes
        }, delay);
    };
    // Callback after animation completes
    const onVisibleChanged = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((visible)=>{
        // Call useTargetState callback to handle animation state
        onTargetVisibleChanged(visible);
    });
    // =========================== Align ============================
    const [ready, offsetX, offsetY, offsetR, offsetB, arrowX, arrowY, , , // scaleY - not used in UniqueProvider
    alignInfo, onAlign] = (0, $cf21e703846db911$export$2e2bcd8739ae039)(open, popupEle, mergedOptions?.target, mergedOptions?.popupPlacement, mergedOptions?.builtinPlacements || {}, mergedOptions?.popupAlign, undefined, // onPopupAlign
    false // isMobile
    );
    const alignedClassName = $ltGt3.useMemo(()=>{
        if (!mergedOptions) return '';
        const baseClassName = (0, $fea35d5e996e6c0f$export$faa0aa8ed2fe6432)(mergedOptions.builtinPlacements || {}, mergedOptions.prefixCls || '', alignInfo, false // alignPoint is false for UniqueProvider
        );
        return (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(baseClassName, mergedOptions.getPopupClassNameFromAlign?.(alignInfo));
    }, [
        alignInfo,
        mergedOptions?.getPopupClassNameFromAlign,
        mergedOptions?.builtinPlacements,
        mergedOptions?.prefixCls
    ]);
    const contextValue = $ltGt3.useMemo(()=>({
            show: show,
            hide: hide
        }), []);
    // =========================== Align ============================
    $ltGt3.useEffect(()=>{
        onAlign();
    }, [
        mergedOptions?.target
    ]);
    // =========================== Motion ===========================
    const onPrepare = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(()=>{
        onAlign();
        return Promise.resolve();
    });
    // ======================== Trigger Context =====================
    const subPopupElements = $ltGt3.useRef({});
    const parentContext = $ltGt3.useContext((0, $4f1b3627aab15ab2$export$2e2bcd8739ae039));
    const triggerContextValue = $ltGt3.useMemo(()=>({
            registerSubPopup: (id, subPopupEle)=>{
                subPopupElements.current[id] = subPopupEle;
                parentContext?.registerSubPopup(id, subPopupEle);
            }
        }), [
        parentContext
    ]);
    // =========================== Render ===========================
    const prefixCls = mergedOptions?.prefixCls;
    return /*#__PURE__*/ $ltGt3.createElement((0, $4f1b3627aab15ab2$export$14cc6d12cdc906c).Provider, {
        value: contextValue
    }, children, mergedOptions && /*#__PURE__*/ $ltGt3.createElement((0, $4f1b3627aab15ab2$export$2e2bcd8739ae039).Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ $ltGt3.createElement((0, $b17fefdb412b77e7$export$2e2bcd8739ae039), {
        ref: setPopupRef,
        portal: (0, $0561688d8f19e269$export$2e2bcd8739ae039),
        prefixCls: prefixCls,
        popup: mergedOptions.popup,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(mergedOptions.popupClassName, alignedClassName, `${prefixCls}-unique-controlled`),
        style: mergedOptions.popupStyle,
        target: mergedOptions.target,
        open: open,
        keepDom: true,
        fresh: true,
        autoDestroy: false,
        onVisibleChanged: onVisibleChanged,
        ready: ready,
        offsetX: offsetX,
        offsetY: offsetY,
        offsetR: offsetR,
        offsetB: offsetB,
        onAlign: onAlign,
        onPrepare: onPrepare,
        onResize: (size)=>setPopupSize({
                width: size.offsetWidth,
                height: size.offsetHeight
            }),
        arrowPos: {
            x: arrowX,
            y: arrowY
        },
        align: alignInfo,
        zIndex: mergedOptions.zIndex,
        mask: mergedOptions.mask,
        arrow: mergedOptions.arrow,
        motion: mergedOptions.popupMotion,
        maskMotion: mergedOptions.maskMotion,
        getPopupContainer: mergedOptions.getPopupContainer
    }, /*#__PURE__*/ $ltGt3.createElement((0, $1c554cd74112abe7$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        isMobile: false,
        ready: ready,
        open: open,
        align: alignInfo,
        offsetR: offsetR,
        offsetB: offsetB,
        offsetX: offsetX,
        offsetY: offsetY,
        arrowPos: {
            x: arrowX,
            y: arrowY
        },
        popupSize: popupSize,
        motion: mergedOptions.popupMotion,
        uniqueContainerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(mergedOptions.uniqueContainerClassName, alignedClassName),
        uniqueContainerStyle: mergedOptions.uniqueContainerStyle
    }))));
};
var $d949588b92412a17$export$2e2bcd8739ae039 = $d949588b92412a17$var$UniqueProvider;


function $1b29c21fa1aa3a55$export$55e99723d7f71b47(PortalComponent = (0, $0561688d8f19e269$export$2e2bcd8739ae039)) {
    const Trigger = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
        const { prefixCls: prefixCls = 'rc-trigger-popup', children: children, action: // Action
        action = 'hover', showAction: showAction, hideAction: hideAction, popupVisible: // Open
        popupVisible, defaultPopupVisible: defaultPopupVisible, onOpenChange: onOpenChange, afterOpenChange: afterOpenChange, onPopupVisibleChange: onPopupVisibleChange, afterPopupVisibleChange: afterPopupVisibleChange, mouseEnterDelay: // Delay
        mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay = 0.1, focusDelay: focusDelay, blurDelay: blurDelay, mask: // Mask
        mask, maskClosable: maskClosable = true, getPopupContainer: // Portal
        getPopupContainer, forceRender: forceRender, autoDestroy: autoDestroy, popup: // Popup
        popup, popupClassName: popupClassName, uniqueContainerClassName: uniqueContainerClassName, uniqueContainerStyle: uniqueContainerStyle, popupStyle: popupStyle, popupPlacement: popupPlacement, builtinPlacements: builtinPlacements = {}, popupAlign: popupAlign, zIndex: zIndex, stretch: stretch, getPopupClassNameFromAlign: getPopupClassNameFromAlign, fresh: fresh, unique: unique, alignPoint: alignPoint, onPopupClick: onPopupClick, onPopupAlign: onPopupAlign, arrow: // Arrow
        arrow, popupMotion: // Motion
        popupMotion, maskMotion: maskMotion, mobile: // Private
        mobile, ...restProps } = props;
        const mergedAutoDestroy = autoDestroy || false;
        const openUncontrolled = popupVisible === undefined;
        // =========================== Mobile ===========================
        const isMobile = !!mobile;
        // ========================== Context ===========================
        const subPopupElements = $ltGt3.useRef({});
        const parentContext = $ltGt3.useContext((0, $4f1b3627aab15ab2$export$2e2bcd8739ae039));
        const context = $ltGt3.useMemo(()=>{
            return {
                registerSubPopup: (id, subPopupEle)=>{
                    subPopupElements.current[id] = subPopupEle;
                    parentContext?.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // ======================== UniqueContext =========================
        const uniqueContext = $ltGt3.useContext((0, $4f1b3627aab15ab2$export$14cc6d12cdc906c));
        // =========================== Popup ============================
        const id = (0, $1fb03482b73301f3$export$2e2bcd8739ae039)();
        const [popupEle, setPopupEle] = $ltGt3.useState(null);
        // Used for forwardRef popup. Not use internal
        const externalPopupRef = $ltGt3.useRef(null);
        const setPopupRef = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((node)=>{
            externalPopupRef.current = node;
            if ((0, $8e3ff42e4a468fd4$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
            parentContext?.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        const [targetEle, setTargetEle] = $ltGt3.useState(null);
        // Used for forwardRef target. Not use internal
        const externalForwardRef = $ltGt3.useRef(null);
        const setTargetRef = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((node)=>{
            if ((0, $8e3ff42e4a468fd4$export$41e30d8dd0ba7a50)(node) && targetEle !== node) {
                setTargetEle(node);
                externalForwardRef.current = node;
            }
        });
        // ========================== Children ==========================
        const child = $ltGt3.Children.only(children);
        const originChildProps = child?.props || {};
        const cloneProps = {};
        const inPopupOrChild = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((ele)=>{
            const childDOM = targetEle;
            return childDOM?.contains(ele) || (0, $6b508eb2255763e6$export$70e8259662bb498b)(childDOM)?.host === ele || ele === childDOM || popupEle?.contains(ele) || (0, $6b508eb2255763e6$export$70e8259662bb498b)(popupEle)?.host === ele || ele === popupEle || Object.values(subPopupElements.current).some((subPopupEle)=>subPopupEle?.contains(ele) || ele === subPopupEle);
        });
        // =========================== Arrow ============================
        const innerArrow = arrow ? {
            // true and Object likely
            ...arrow !== true ? arrow : {}
        } : null;
        // ============================ Open ============================
        const [internalOpen, setInternalOpen] = $ltGt3.useState(defaultPopupVisible || false);
        // Render still use props as first priority
        const mergedOpen = popupVisible ?? internalOpen;
        // We use effect sync here in case `popupVisible` back to `undefined`
        const setMergedOpen = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((nextOpen)=>{
            if (openUncontrolled) setInternalOpen(nextOpen);
        });
        // Support ref
        const isOpen = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(()=>mergedOpen);
        (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
            setInternalOpen(popupVisible || false);
        }, [
            popupVisible
        ]);
        // Extract common options for UniqueProvider
        const getUniqueOptions = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((delay = 0)=>({
                popup: popup,
                target: targetEle,
                delay: delay,
                prefixCls: prefixCls,
                popupClassName: popupClassName,
                uniqueContainerClassName: uniqueContainerClassName,
                uniqueContainerStyle: uniqueContainerStyle,
                popupStyle: popupStyle,
                popupPlacement: popupPlacement,
                builtinPlacements: builtinPlacements,
                popupAlign: popupAlign,
                zIndex: zIndex,
                mask: mask,
                maskClosable: maskClosable,
                popupMotion: popupMotion,
                maskMotion: maskMotion,
                arrow: innerArrow,
                getPopupContainer: getPopupContainer,
                getPopupClassNameFromAlign: getPopupClassNameFromAlign,
                id: id
            }));
        // Handle controlled state changes for UniqueProvider
        // Only sync to UniqueProvider when it's controlled mode
        // If there is a parentContext, don't call uniqueContext methods
        (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
            if (uniqueContext && unique && targetEle && !openUncontrolled && !parentContext) {
                if (mergedOpen) uniqueContext.show(getUniqueOptions(mouseEnterDelay), isOpen);
                else uniqueContext.hide(mouseLeaveDelay);
            }
        }, [
            mergedOpen,
            targetEle
        ]);
        const openRef = $ltGt3.useRef(mergedOpen);
        openRef.current = mergedOpen;
        const lastTriggerRef = $ltGt3.useRef([]);
        lastTriggerRef.current = [];
        const internalTriggerOpen = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((nextOpen)=>{
            setMergedOpen(nextOpen);
            // Enter or Pointer will both trigger open state change
            // We only need take one to avoid duplicated change event trigger
            // Use `lastTriggerRef` to record last open type
            if ((lastTriggerRef.current[lastTriggerRef.current.length - 1] ?? mergedOpen) !== nextOpen) {
                lastTriggerRef.current.push(nextOpen);
                onOpenChange?.(nextOpen);
                onPopupVisibleChange?.(nextOpen);
            }
        });
        // Trigger for delay
        const delayInvoke = (0, $702946aa9755a88e$export$2e2bcd8739ae039)();
        const triggerOpen = (nextOpen, delay = 0)=>{
            // If it's controlled mode, always use internal trigger logic
            // UniqueProvider will be synced through useLayoutEffect
            if (popupVisible !== undefined) {
                delayInvoke(()=>{
                    internalTriggerOpen(nextOpen);
                }, delay);
                return;
            }
            // If UniqueContext exists and not controlled, pass delay to Provider instead of handling it internally
            // If there is a parentContext, don't call uniqueContext methods
            if (uniqueContext && unique && openUncontrolled && !parentContext) {
                if (nextOpen) uniqueContext.show(getUniqueOptions(delay), isOpen);
                else uniqueContext.hide(delay);
                return;
            }
            delayInvoke(()=>{
                internalTriggerOpen(nextOpen);
            }, delay);
        };
        // ========================== Motion ============================
        const [inMotion, setInMotion] = $ltGt3.useState(false);
        (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)((firstMount)=>{
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        const [motionPrepareResolve, setMotionPrepareResolve] = $ltGt3.useState(null);
        // =========================== Align ============================
        const [mousePos, setMousePos] = $ltGt3.useState(null);
        const setMousePosByEvent = (event)=>{
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        const [ready, offsetX, offsetY, offsetR, offsetB, arrowX, arrowY, scaleX, scaleY, alignInfo, onAlign] = (0, $cf21e703846db911$export$2e2bcd8739ae039)(mergedOpen, popupEle, alignPoint && mousePos !== null ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign, isMobile);
        const [showActions, hideActions] = (0, $9b81f97d74004187$export$2e2bcd8739ae039)(action, showAction, hideAction);
        const clickToShow = showActions.has('click');
        const clickToHide = hideActions.has('click') || hideActions.has('contextMenu');
        const triggerAlign = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(()=>{
            if (!inMotion) onAlign();
        });
        const onScroll = ()=>{
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $fff7156b395cae65$export$2e2bcd8739ae039)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
            if (mergedOpen && !builtinPlacements?.[popupPlacement]) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        const alignedClassName = $ltGt3.useMemo(()=>{
            const baseClassName = (0, $fea35d5e996e6c0f$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(baseClassName, getPopupClassNameFromAlign?.(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $ltGt3.useImperativeHandle(ref, ()=>({
                nativeElement: externalForwardRef.current,
                popupElement: externalPopupRef.current,
                forceAlign: triggerAlign
            }));
        // ========================== Stretch ===========================
        const [targetWidth, setTargetWidth] = $ltGt3.useState(0);
        const [targetHeight, setTargetHeight] = $ltGt3.useState(0);
        const syncTargetSize = ()=>{
            if (stretch && targetEle) {
                const rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        const onTargetResize = ()=>{
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        const onVisibleChanged = (visible)=>{
            setInMotion(false);
            onAlign();
            afterOpenChange?.(visible);
            afterPopupVisibleChange?.(visible);
        };
        // We will trigger align when motion is in prepare
        const onPrepare = ()=>new Promise((resolve)=>{
                syncTargetSize();
                setMotionPrepareResolve(()=>resolve);
            });
        (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     * @param eventName  Listen event name
     * @param nextOpen  Next open state after trigger
     * @param delay Delay to trigger open change
     * @param callback Callback if current event need additional action
     * @param ignoreCheck  Ignore current event if check return true
     */ function wrapperAction(eventName, nextOpen, delay, callback, ignoreCheck) {
            cloneProps[eventName] = (event, ...args)=>{
                if (!ignoreCheck || !ignoreCheck()) {
                    callback?.(event);
                    triggerOpen(nextOpen, delay);
                }
                // Pass to origin
                originChildProps[eventName]?.(event, ...args);
            };
        }
        // ======================= Action: Touch ========================
        const touchToShow = showActions.has('touch');
        const touchToHide = hideActions.has('touch');
        /** Used for prevent `hover` event conflict with mobile env */ const touchedRef = $ltGt3.useRef(false);
        if (touchToShow || touchToHide) cloneProps.onTouchStart = (...args)=>{
            touchedRef.current = true;
            if (openRef.current && touchToHide) triggerOpen(false);
            else if (!openRef.current && touchToShow) triggerOpen(true);
            // Pass to origin
            originChildProps.onTouchStart?.(...args);
        };
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = (event, ...args)=>{
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            originChildProps.onClick?.(event, ...args);
            touchedRef.current = false;
        };
        // Click to hide is special action since click popup element should not hide
        const onPopupPointerDown = (0, $6ec6b75f81787216$export$2e2bcd8739ae039)(mergedOpen, clickToHide || touchToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        const hoverToShow = showActions.has('hover');
        const hoverToHide = hideActions.has('hover');
        let onPopupMouseEnter;
        let onPopupMouseLeave;
        const ignoreMouseTrigger = ()=>{
            return touchedRef.current;
        };
        if (hoverToShow) {
            const onMouseEnterCallback = (event)=>{
                setMousePosByEvent(event);
            };
            // Compatible with old browser which not support pointer event
            wrapperAction('onMouseEnter', true, mouseEnterDelay, onMouseEnterCallback, ignoreMouseTrigger);
            wrapperAction('onPointerEnter', true, mouseEnterDelay, onMouseEnterCallback, ignoreMouseTrigger);
            onPopupMouseEnter = (event)=>{
                // Only trigger re-open when popup is visible
                if ((mergedOpen || inMotion) && popupEle?.contains(event.target)) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = (event)=>{
                originChildProps.onMouseMove?.(event);
            };
        }
        if (hoverToHide) {
            wrapperAction('onMouseLeave', false, mouseLeaveDelay, undefined, ignoreMouseTrigger);
            wrapperAction('onPointerLeave', false, mouseLeaveDelay, undefined, ignoreMouseTrigger);
            onPopupMouseLeave = ()=>{
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has('focus')) wrapperAction('onFocus', true, focusDelay);
        if (hideActions.has('focus')) wrapperAction('onBlur', false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has('contextMenu')) cloneProps.onContextMenu = (event, ...args)=>{
            if (openRef.current && hideActions.has('contextMenu')) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            originChildProps.onContextMenu?.(event, ...args);
        };
        // ============================ Perf ============================
        const rendedRef = $ltGt3.useRef(false);
        rendedRef.current ||= forceRender || mergedOpen || inMotion;
        // =========================== Render ===========================
        const mergedChildrenProps = {
            ...originChildProps,
            ...cloneProps
        };
        // Pass props into cloneProps for nest usage
        const passedProps = {};
        const passedEventList = [
            'onContextMenu',
            'onClick',
            'onMouseDown',
            'onTouchStart',
            'onMouseEnter',
            'onMouseLeave',
            'onFocus',
            'onBlur'
        ];
        passedEventList.forEach((eventName)=>{
            if (restProps[eventName]) passedProps[eventName] = (...args)=>{
                mergedChildrenProps[eventName]?.(...args);
                restProps[eventName](...args);
            };
        });
        const arrowPos = {
            x: arrowX,
            y: arrowY
        };
        // Child Node
        const triggerNode = /*#__PURE__*/ $ltGt3.cloneElement(child, {
            ...mergedChildrenProps,
            ...passedProps
        });
        // Render
        return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement((0, $9ed13185b45d829d$export$2e2bcd8739ae039), {
            disabled: !mergedOpen,
            ref: setTargetRef,
            onResize: onTargetResize
        }, triggerNode), rendedRef.current && (!uniqueContext || !unique) && /*#__PURE__*/ $ltGt3.createElement((0, $4f1b3627aab15ab2$export$2e2bcd8739ae039).Provider, {
            value: context
        }, /*#__PURE__*/ $ltGt3.createElement((0, $b17fefdb412b77e7$export$2e2bcd8739ae039), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(popupClassName, !isMobile && alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            onPointerDownCapture: onPopupPointerDown,
            mask: mask,
            motion: popupMotion,
            maskMotion: maskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY,
            mobile: mobile
        })));
    });
    return Trigger;
}
var $1b29c21fa1aa3a55$export$2e2bcd8739ae039 = $1b29c21fa1aa3a55$export$55e99723d7f71b47((0, $0561688d8f19e269$export$2e2bcd8739ae039));



var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
const $d13451568443aeb8$export$e4ec87ea71f29b41 = 'ant';
const $d13451568443aeb8$export$eaca8ee5ed21b4e9 = 'anticon';
const $d13451568443aeb8$export$fa216ce2679a073b = [
    'outlined',
    'borderless',
    'filled',
    'underlined'
];
const $d13451568443aeb8$var$defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `${$d13451568443aeb8$export$e4ec87ea71f29b41}-${suffixCls}` : $d13451568443aeb8$export$e4ec87ea71f29b41;
};
const $d13451568443aeb8$export$a92f85ab3e9ad68b = /*#__PURE__*/ $ltGt3.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $d13451568443aeb8$var$defaultGetPrefixCls,
    iconPrefixCls: $d13451568443aeb8$export$eaca8ee5ed21b4e9
});
const { Consumer: $d13451568443aeb8$export$cd5442f2b8da7663 } = $d13451568443aeb8$export$a92f85ab3e9ad68b;
const $d13451568443aeb8$var$EMPTY_OBJECT = {};
function $d13451568443aeb8$export$46f4bd6436a25a31(propName) {
    const context = $ltGt3.useContext($d13451568443aeb8$export$a92f85ab3e9ad68b);
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, renderEmpty: renderEmpty } = context;
    const propValue = context[propName];
    return {
        classNames: $d13451568443aeb8$var$EMPTY_OBJECT,
        styles: $d13451568443aeb8$var$EMPTY_OBJECT,
        ...propValue,
        getPrefixCls: getPrefixCls,
        direction: direction,
        getPopupContainer: getPopupContainer,
        renderEmpty: renderEmpty
    };
}


"use client";
const $365d867b28276e75$var$MotionContent = ({ children: children })=>{
    const { getPrefixCls: getPrefixCls } = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    // This will never reach since we will not render this when no children
    /* istanbul ignore next */ if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).isValidElement(children)) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), {
        visible: true,
        motionName: `${rootPrefixCls}-fade`,
        motionAppear: true,
        motionEnter: true,
        motionLeave: false,
        removeOnLeave: false
    }, ({ style: motionStyle, className: motionClassName })=>{
        const { className: className, style: style } = children.props;
        const mergedStyles = {
            ...style,
            ...motionStyle
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(children, {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, motionClassName),
            style: mergedStyles
        });
    });
};
var $365d867b28276e75$export$2e2bcd8739ae039 = $365d867b28276e75$var$MotionContent;


"use client";
const $4b1ad0676c1397a3$var$cachedPlacements = [
    null,
    null
];
function $4b1ad0676c1397a3$var$uniqueBuiltinPlacements(ori) {
    if ($4b1ad0676c1397a3$var$cachedPlacements[0] !== ori) {
        const target = {};
        Object.keys(ori).forEach((placement)=>{
            target[placement] = {
                ...ori[placement],
                dynamicInset: false
            };
        });
        $4b1ad0676c1397a3$var$cachedPlacements[0] = ori;
        $4b1ad0676c1397a3$var$cachedPlacements[1] = target;
    }
    return $4b1ad0676c1397a3$var$cachedPlacements[1];
}
const $4b1ad0676c1397a3$var$UniqueProvider = ({ children: children })=>{
    const renderPopup = (options)=>{
        const popupEle = typeof options.popup === 'function' ? options.popup() : options.popup;
        const { id: id, builtinPlacements: builtinPlacements } = options;
        const parsedPlacements = $4b1ad0676c1397a3$var$uniqueBuiltinPlacements(builtinPlacements);
        return {
            ...options,
            getPopupContainer: null,
            arrow: false,
            popup: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $365d867b28276e75$export$2e2bcd8739ae039), {
                key: id
            }, popupEle),
            builtinPlacements: parsedPlacements
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $d949588b92412a17$export$2e2bcd8739ae039), {
        postTriggerProps: renderPopup
    }, children);
};
var $4b1ad0676c1397a3$export$2e2bcd8739ae039 = $4b1ad0676c1397a3$var$UniqueProvider;




var $ltGt3 = parcelRequire("ltGt3");
"use client";
const $6171cc8a6fbd07d0$var$DisabledContext = /*#__PURE__*/ $ltGt3.createContext(false);
const $6171cc8a6fbd07d0$export$6adb5f3b918b11bb = ({ children: children, disabled: disabled })=>{
    const originDisabled = $ltGt3.useContext($6171cc8a6fbd07d0$var$DisabledContext);
    return /*#__PURE__*/ $ltGt3.createElement($6171cc8a6fbd07d0$var$DisabledContext.Provider, {
        value: disabled ?? originDisabled
    }, children);
};
var $6171cc8a6fbd07d0$export$2e2bcd8739ae039 = $6171cc8a6fbd07d0$var$DisabledContext;



var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
"use client";
const $9a9e608887097e77$var$SizeContext = /*#__PURE__*/ $ltGt3.createContext(undefined);
const $9a9e608887097e77$export$dbc92d89fabc8ebe = ({ children: children, size: size })=>{
    const originSize = $ltGt3.useContext($9a9e608887097e77$var$SizeContext);
    return /*#__PURE__*/ $ltGt3.createElement($9a9e608887097e77$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
var $9a9e608887097e77$export$2e2bcd8739ae039 = $9a9e608887097e77$var$SizeContext;


function $e8a1f40b62b93219$var$useConfig() {
    const componentDisabled = (0, $ltGt3.useContext)((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const componentSize = (0, $ltGt3.useContext)((0, $9a9e608887097e77$export$2e2bcd8739ae039));
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $e8a1f40b62b93219$export$2e2bcd8739ae039 = $e8a1f40b62b93219$var$useConfig;



var $ltGt3 = parcelRequire("ltGt3");


/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $003c57daacb79f0c$var$isEqual(obj1, obj2, shallow = false) {
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    const refSet = new Set();
    function deepEqual(a, b, level = 1) {
        const circular = refSet.has(a);
        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        const newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && typeof a === 'object' && typeof b === 'object') {
            const keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every((key)=>deepEqual(a[key], b[key], newLevel));
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $003c57daacb79f0c$export$2e2bcd8739ae039 = $003c57daacb79f0c$var$isEqual;




function $9056d331e4ffbbdc$export$2e2bcd8739ae039(theme, parentTheme, config) {
    const warning = (0, $9530c27c700696d0$export$cf977aa92c751e61)('ConfigProvider');
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? {
        ...(0, $d628a3c0642cff3d$export$f84bd70098573c5c),
        hashed: parentTheme?.hashed ?? (0, $d628a3c0642cff3d$export$f84bd70098573c5c).hashed,
        cssVar: parentTheme?.cssVar
    } : parentTheme;
    // Generate a unique key for cssVar
    const themeKey = (0, $ltGt3.useId)();
    return (0, $dcca1fcd5fa22f3b$export$2e2bcd8739ae039)(()=>{
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = {
            ...parentThemeConfig.components
        };
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = {
                ...mergedComponents[componentName],
                ...theme.components[componentName]
            };
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, '')}`;
        const mergedCssVar = {
            prefix: config?.prefixCls,
            // Same as prefixCls by default
            ...parentThemeConfig.cssVar,
            ...themeConfig.cssVar,
            key: themeConfig.cssVar?.key || cssVarKey
        };
        // Base token
        return {
            ...parentThemeConfig,
            ...themeConfig,
            token: {
                ...parentThemeConfig.token,
                ...themeConfig.token
            },
            components: mergedComponents,
            cssVar: mergedCssVar
        };
    }, [
        themeConfig,
        parentThemeConfig
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, $003c57daacb79f0c$export$2e2bcd8739ae039)(prevTheme, nextTheme, true);
        }));
}



var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");

var $32671df02e1f57c4$export$2e2bcd8739ae039 = '6.0.0';


"use client";
var $f586098016a1e759$export$2e2bcd8739ae039 = (0, $32671df02e1f57c4$export$2e2bcd8739ae039);







function $064c376cd2d0e87b$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $064c376cd2d0e87b$var$getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($064c376cd2d0e87b$var$isStableColor(r) && $064c376cd2d0e87b$var$isStableColor(g) && $064c376cd2d0e87b$var$isStableColor(b)) return new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $064c376cd2d0e87b$export$2e2bcd8739ae039 = $064c376cd2d0e87b$var$getAlphaColor;


function $792d423ebfd5ec4b$export$2e2bcd8739ae039(derivativeToken) {
    const { override: override, ...restToken } = derivativeToken;
    const overrideTokens = {
        ...override
    };
    Object.keys((0, $cd7243c61a6df828$export$2e2bcd8739ae039)).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = {
        ...restToken,
        ...overrideTokens
    };
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = '0s';
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = {
        ...mergedToken,
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $064c376cd2d0e87b$export$2e2bcd8739ae039)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $064c376cd2d0e87b$export$2e2bcd8739ae039)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $064c376cd2d0e87b$export$2e2bcd8739ae039)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.lineWidth * 3,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $064c376cd2d0e87b$export$2e2bcd8739ae039)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: 'none',
        linkHoverDecoration: 'none',
        linkFocusDecoration: 'none',
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        boxShadowPopoverArrow: '2px 2px 5px rgba(0, 0, 0, 0.05)',
        boxShadowCard: `
      0 1px 2px -2px ${new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)('rgba(0, 0, 0, 0.16)').toRgbString()},
      0 3px 6px 0 ${new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)('rgba(0, 0, 0, 0.12)').toRgbString()},
      0 5px 12px 4px ${new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)('rgba(0, 0, 0, 0.09)').toRgbString()}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTabsOverflowLeft: 'inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowRight: 'inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowTop: 'inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowBottom: 'inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)',
        // Override AliasToken
        ...overrideTokens
    };
    return aliasToken;
}


const $42a04fd86d13249e$export$c6b9faa6b723d31a = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true,
    opacityImage: true
};
const $42a04fd86d13249e$export$738b109e247a462c = {
    motionBase: true,
    motionUnit: true
};
const $42a04fd86d13249e$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true
};
const $42a04fd86d13249e$export$18602cb46ae80b62 = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override: override, ...components } = overrideToken;
    // Merge with override
    let mergedDerivativeToken = {
        ...derivativeToken,
        override: override
    };
    // Format if needed
    mergedDerivativeToken = (0, $792d423ebfd5ec4b$export$2e2bcd8739ae039)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach(([key, value])=>{
        const { theme: componentTheme, ...componentTokens } = value;
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $42a04fd86d13249e$export$18602cb46ae80b62({
            ...mergedDerivativeToken,
            ...componentTokens
        }, {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function $42a04fd86d13249e$export$2e2bcd8739ae039() {
    const { token: rootDesignToken, hashed: hashed, theme: theme, override: override, cssVar: ctxCssVar, zeroRuntime: zeroRuntime } = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $d628a3c0642cff3d$export$69b0ebb9efcddb30));
    const cssVar = {
        prefix: ctxCssVar?.prefix || 'ant',
        key: ctxCssVar?.key || 'css-var-root'
    };
    const salt = `${(0, $f586098016a1e759$export$2e2bcd8739ae039)}-${hashed || ''}`;
    const mergedTheme = theme || (0, $d39bb1bcbe47a548$export$2e2bcd8739ae039);
    const [token, hashId, realToken] = (0, $8cff302f4c2cd4b3$export$2e2bcd8739ae039)(mergedTheme, [
        (0, $cd7243c61a6df828$export$2e2bcd8739ae039),
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $42a04fd86d13249e$export$18602cb46ae80b62,
        cssVar: {
            ...cssVar,
            unitless: $42a04fd86d13249e$export$c6b9faa6b723d31a,
            ignore: $42a04fd86d13249e$export$738b109e247a462c,
            preserve: $42a04fd86d13249e$var$preserve
        }
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : '',
        token,
        cssVar,
        !!zeroRuntime
    ];
}


"use client";
const $e4cdc26a1be24cd8$var$MotionCacheContext = /*#__PURE__*/ $ltGt3.createContext(true);
function $e4cdc26a1be24cd8$export$2e2bcd8739ae039(props) {
    const parentMotion = $ltGt3.useContext($e4cdc26a1be24cd8$var$MotionCacheContext);
    const { children: children } = props;
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const { motion: motion } = token;
    const needWrapMotionProviderRef = $ltGt3.useRef(false);
    needWrapMotionProviderRef.current || (needWrapMotionProviderRef.current = parentMotion !== motion);
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $ltGt3.createElement($e4cdc26a1be24cd8$var$MotionCacheContext.Provider, {
        value: motion
    }, /*#__PURE__*/ $ltGt3.createElement((0, $a0db28a0967de900$export$2e2bcd8739ae039), {
        motion: motion
    }, children));
    return children;
}



var $ltGt3 = parcelRequire("ltGt3");

"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const $606308a096c30c39$var$PropWarning = /*#__PURE__*/ $ltGt3.memo(({ dropdownMatchSelectWidth: dropdownMatchSelectWidth })=>{
    const warning = (0, $9530c27c700696d0$export$cf977aa92c751e61)('ConfigProvider');
    warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
    return null;
});
var $606308a096c30c39$export$2e2bcd8739ae039 = ()=>null;





"use client";
const $945cb0d2b7017a11$export$b2b65df0d0824629 = {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
};
const $945cb0d2b7017a11$export$23997c3e44cc1c59 = (token, needInheritFontFamily = false)=>({
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: 'none',
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? 'inherit' : token.fontFamily
    });
const $945cb0d2b7017a11$export$171ccda7bc085e59 = ()=>({
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
        fontStyle: 'normal',
        lineHeight: 0,
        textAlign: 'center',
        textTransform: 'none',
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: '-0.125em',
        textRendering: 'optimizeLegibility',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '> *': {
            lineHeight: 1
        },
        svg: {
            display: 'inline-block'
        }
    });
const $945cb0d2b7017a11$export$8c467e8859fdef13 = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        '&::before': {
            display: 'table',
            content: '""'
        },
        '&::after': {
            // https://github.com/ant-design/ant-design/issues/21864
            display: 'table',
            clear: 'both',
            content: '""'
        }
    });
const $945cb0d2b7017a11$export$905d771977096614 = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: 'transparent',
            // remove the gray background on active links in IE 10.
            outline: 'none',
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            '-webkit-text-decoration-skip': 'objects',
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            '&:hover': {
                color: token.colorLinkHover
            },
            '&:active': {
                color: token.colorLinkActive
            },
            '&:active, &:hover': {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            '&:focus': {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            '&[disabled]': {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            }
        }
    });
const $945cb0d2b7017a11$export$689382c111559cd9 = (token, componentPrefixCls, rootCls, resetFont)=>{
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
        boxSizing: 'border-box',
        '&::before, &::after': {
            boxSizing: 'border-box'
        }
    };
    let resetFontStyle = {};
    if (resetFont !== false) resetFontStyle = {
        fontFamily: token.fontFamily,
        fontSize: token.fontSize
    };
    return {
        [rootPrefixSelector]: {
            ...resetFontStyle,
            ...resetStyle,
            [prefixSelector]: resetStyle
        }
    };
};
const $945cb0d2b7017a11$export$6539948f0a737e39 = (token, offset)=>({
        outline: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: offset ?? 1,
        transition: 'outline-offset 0s, outline 0s'
    });
const $945cb0d2b7017a11$export$a44db842bcb28231 = (token, offset)=>({
        '&:focus-visible': $945cb0d2b7017a11$export$6539948f0a737e39(token, offset)
    });
const $945cb0d2b7017a11$export$f1a0b31dfb234e7e = (iconPrefixCls)=>({
        [`.${iconPrefixCls}`]: {
            ...$945cb0d2b7017a11$export$171ccda7bc085e59(),
            [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
                display: 'block'
            }
        }
    });
const $945cb0d2b7017a11$export$9a16e7694a707ab4 = (token)=>({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: token.linkDecoration,
        outline: 'none',
        cursor: 'pointer',
        transition: `all ${token.motionDurationSlow}`,
        border: 0,
        padding: 0,
        background: 'none',
        userSelect: 'none',
        ...$945cb0d2b7017a11$export$a44db842bcb28231(token),
        '&:hover': {
            color: token.colorLinkHover,
            textDecoration: token.linkHoverDecoration
        },
        '&:focus': {
            color: token.colorLinkHover,
            textDecoration: token.linkFocusDecoration
        },
        '&:active': {
            color: token.colorLinkActive,
            textDecoration: token.linkHoverDecoration
        }
    });
const $945cb0d2b7017a11$export$eb00f0b59fe10024 = {
    backdropFilter: 'blur(4px)',
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
};



const $46c3521a2b979686$var$useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    // Generate style for icons
    return (0, $5cbbf99d0b51a6f3$export$2e2bcd8739ae039)({
        theme: theme,
        token: token,
        hashId: '',
        path: [
            'ant-design-icons',
            iconPrefixCls
        ],
        nonce: ()=>csp?.nonce,
        layer: {
            name: 'antd'
        }
    }, ()=>(0, $945cb0d2b7017a11$export$f1a0b31dfb234e7e)(iconPrefixCls));
};
var $46c3521a2b979686$export$2e2bcd8739ae039 = $46c3521a2b979686$var$useResetIconStyle;


"use client";
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let $3f88559997256af7$var$existThemeConfig = false;
const $3f88559997256af7$export$7c4f6da0f9434a77 = /* istanbul ignore next */ null;
const $3f88559997256af7$export$e7f14a745e5c386a = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale'
];
// These props is used by `useContext` directly in sub component
const $3f88559997256af7$var$PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'input',
    'pagination',
    'form',
    'select',
    'button'
];
let $3f88559997256af7$var$globalPrefixCls;
let $3f88559997256af7$var$globalIconPrefixCls;
let $3f88559997256af7$var$globalTheme;
let $3f88559997256af7$var$globalHolderRender;
function $3f88559997256af7$var$getGlobalPrefixCls() {
    return $3f88559997256af7$var$globalPrefixCls || (0, $d13451568443aeb8$export$e4ec87ea71f29b41);
}
function $3f88559997256af7$var$getGlobalIconPrefixCls() {
    return $3f88559997256af7$var$globalIconPrefixCls || (0, $d13451568443aeb8$export$eaca8ee5ed21b4e9);
}
const $3f88559997256af7$var$setGlobalConfig = (props)=>{
    const { prefixCls: prefixCls, iconPrefixCls: iconPrefixCls, theme: theme, holderRender: holderRender } = props;
    if (prefixCls !== undefined) $3f88559997256af7$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $3f88559997256af7$var$globalIconPrefixCls = iconPrefixCls;
    if ('holderRender' in props) $3f88559997256af7$var$globalHolderRender = holderRender;
    if (theme) $3f88559997256af7$var$globalTheme = theme;
};
const $3f88559997256af7$export$f9cd1e43211d8a4a = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${$3f88559997256af7$var$getGlobalPrefixCls()}-${suffixCls}` : $3f88559997256af7$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $3f88559997256af7$var$getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if ($3f88559997256af7$var$globalPrefixCls) return $3f88559997256af7$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $3f88559997256af7$var$getGlobalPrefixCls();
        },
        getTheme: ()=>$3f88559997256af7$var$globalTheme,
        holderRender: $3f88559997256af7$var$globalHolderRender
    });
const $3f88559997256af7$var$ProviderChildren = (props)=>{
    const { children: children, csp: customCsp, autoInsertSpaceInButton: autoInsertSpaceInButton, alert: alert, affix: affix, anchor: anchor, form: form, locale: locale, componentSize: componentSize, direction: direction, space: space, splitter: splitter, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, popupOverflow: popupOverflow, legacyLocale: legacyLocale, parentContext: parentContext, iconPrefixCls: customIconPrefixCls, theme: theme, componentDisabled: componentDisabled, segmented: segmented, statistic: statistic, spin: spin, calendar: calendar, carousel: carousel, cascader: cascader, collapse: collapse, typography: typography, checkbox: checkbox, descriptions: descriptions, divider: divider, drawer: drawer, skeleton: skeleton, steps: steps, image: image, layout: layout, list: list, mentions: mentions, modal: modal, progress: progress, result: result, slider: slider, breadcrumb: breadcrumb, masonry: masonry, menu: menu, pagination: pagination, input: input, textArea: textArea, otp: otp, empty: empty, badge: badge, radio: radio, rate: rate, ribbon: ribbon, switch: SWITCH, transfer: transfer, avatar: avatar, message: message, tag: tag, table: table, card: card, cardMeta: cardMeta, tabs: tabs, timeline: timeline, timePicker: timePicker, upload: upload, notification: notification, tree: tree, colorPicker: colorPicker, datePicker: datePicker, rangePicker: rangePicker, flex: flex, wave: wave, dropdown: dropdown, warning: warningConfig, tour: tour, tooltip: tooltip, popover: popover, popconfirm: popconfirm, qrcode: qrcode, floatButton: floatButton, floatButtonGroup: floatButtonGroup, variant: variant, inputNumber: inputNumber, treeSelect: treeSelect, watermark: watermark } = props;
    // =================================== Context ===================================
    const getPrefixCls = $ltGt3.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls: prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, $d13451568443aeb8$export$eaca8ee5ed21b4e9);
    const csp = customCsp || parentContext.csp;
    (0, $46c3521a2b979686$export$2e2bcd8739ae039)(iconPrefixCls, csp);
    const mergedTheme = (0, $9056d331e4ffbbdc$export$2e2bcd8739ae039)(theme, parentContext.theme, {
        prefixCls: getPrefixCls('')
    });
    const baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        affix: affix,
        anchor: anchor,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        splitter: splitter,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth ?? dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        textArea: textArea,
        otp: otp,
        layout: layout,
        list: list,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        masonry: masonry,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        radio: radio,
        rate: rate,
        ribbon: ribbon,
        switch: SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        cardMeta: cardMeta,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig,
        tour: tour,
        tooltip: tooltip,
        popover: popover,
        popconfirm: popconfirm,
        qrcode: qrcode,
        floatButton: floatButton,
        floatButtonGroup: floatButtonGroup,
        variant: variant,
        inputNumber: inputNumber,
        treeSelect: treeSelect,
        watermark: watermark
    };
    const config = {
        ...parentContext
    };
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $3f88559997256af7$var$PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    if (typeof autoInsertSpaceInButton !== 'undefined') // merge deprecated api
    config.button = {
        autoInsertSpace: autoInsertSpaceInButton,
        ...config.button
    };
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, $dcca1fcd5fa22f3b$export$2e2bcd8739ae039)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const { layer: layer } = $ltGt3.useContext((0, $6eb27787545be803$export$2e2bcd8739ae039));
    const memoIconContextValue = $ltGt3.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp: csp,
            layer: layer ? 'antd' : undefined
        }), [
        iconPrefixCls,
        csp,
        layer
    ]);
    let childNode = /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement((0, $606308a096c30c39$export$2e2bcd8739ae039), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = $ltGt3.useMemo(()=>(0, $33746bcbc33b48dc$export$4950aa0f605343fb)((0, $29f4f00e8825a41b$export$2e2bcd8739ae039).Form?.defaultValidateMessages || {}, memoedConfig.locale?.Form?.defaultValidateMessages || {}, memoedConfig.form?.validateMessages || {}, form?.validateMessages || {}), [
        memoedConfig,
        form?.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $ltGt3.createElement((0, $f58ba1999f6a7d10$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $ltGt3.createElement((0, $4547604c8eb162f3$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $4547604c8eb162f3$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $ltGt3.createElement((0, $6513c993325f3802$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $ltGt3.createElement((0, $9a9e608887097e77$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $ltGt3.createElement((0, $e4cdc26a1be24cd8$export$2e2bcd8739ae039), null, childNode);
    // ================================ Tooltip Unique ===============================
    if (tooltip?.unique) childNode = /*#__PURE__*/ $ltGt3.createElement((0, $4b1ad0676c1397a3$export$2e2bcd8739ae039), null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = $ltGt3.useMemo(()=>{
        const { algorithm: algorithm, token: token, components: components, cssVar: cssVar, ...rest } = mergedTheme || {};
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $db382206ce669921$export$2e2bcd8739ae039)(algorithm) : (0, $d39bb1bcbe47a548$export$2e2bcd8739ae039);
        const parsedComponents = {};
        Object.entries(components || {}).forEach(([componentName, componentToken])=>{
            const parsedToken = {
                ...componentToken
            };
            if ('algorithm' in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === 'function') parsedToken.theme = (0, $db382206ce669921$export$2e2bcd8739ae039)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = {
            ...(0, $cd7243c61a6df828$export$2e2bcd8739ae039),
            ...token
        };
        return {
            ...rest,
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: {
                override: mergedToken,
                ...parsedComponents
            },
            cssVar: cssVar
        };
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $ltGt3.createElement((0, $d628a3c0642cff3d$export$69b0ebb9efcddb30).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $ltGt3.createElement((0, $9530c27c700696d0$export$11b88c75b33aa1fd).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $ltGt3.createElement((0, $6171cc8a6fbd07d0$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $ltGt3.createElement((0, $d13451568443aeb8$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
const $3f88559997256af7$var$ConfigProvider = (props)=>{
    const context = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const antLocale = $ltGt3.useContext((0, $a2444553f97bdd83$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $ltGt3.createElement($3f88559997256af7$var$ProviderChildren, {
        parentContext: context,
        legacyLocale: antLocale,
        ...props
    });
};
$3f88559997256af7$var$ConfigProvider.ConfigContext = (0, $d13451568443aeb8$export$a92f85ab3e9ad68b);
$3f88559997256af7$var$ConfigProvider.SizeContext = (0, $9a9e608887097e77$export$2e2bcd8739ae039);
$3f88559997256af7$var$ConfigProvider.config = $3f88559997256af7$var$setGlobalConfig;
$3f88559997256af7$var$ConfigProvider.useConfig = (0, $e8a1f40b62b93219$export$2e2bcd8739ae039);
Object.defineProperty($3f88559997256af7$var$ConfigProvider, 'SizeContext', {
    get: ()=>{
        return 0, $9a9e608887097e77$export$2e2bcd8739ae039;
    }
});
var $3f88559997256af7$export$2e2bcd8739ae039 = $3f88559997256af7$var$ConfigProvider;



var $ltGt3 = parcelRequire("ltGt3");
function $66d38239e1a27993$export$9522e17588c12572(child) {
    return child && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).isValidElement(child) && child.type === (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Fragment;
}
const $66d38239e1a27993$export$2dfe578f95754f6a = (element, replacement, props)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).isValidElement(element)) return replacement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
};
function $66d38239e1a27993$export$e530037191fcd5d7(element, props) {
    return $66d38239e1a27993$export$2dfe578f95754f6a(element, element, props);
}



var $ltGt3 = parcelRequire("ltGt3");

function $956eb3955017f471$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $f00c77b10d41ae35$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $66e45e43b8094fcb$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $d8ac74b6587c5b61$export$2e2bcd8739ae039(r, e) {
    return (0, $956eb3955017f471$export$2e2bcd8739ae039)(r) || (0, $f00c77b10d41ae35$export$2e2bcd8739ae039)(r, e) || (0, $f08c52026be8729d$export$2e2bcd8739ae039)(r, e) || (0, $66e45e43b8094fcb$export$2e2bcd8739ae039)();
}





var $ltGt3 = parcelRequire("ltGt3");


function $e27c3b84810c9c06$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $a6abaaa62f37bab5$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $892d9a0b262e20a7$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $a6abaaa62f37bab5$export$2e2bcd8739ae039(e, r, t) {
    return r && $a6abaaa62f37bab5$var$_defineProperties(e.prototype, r), t && $a6abaaa62f37bab5$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $b9857b0719ab1f8f$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $b4bc9016f3e318e4$export$2e2bcd8739ae039(t, e) {
    return $b4bc9016f3e318e4$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b4bc9016f3e318e4$export$2e2bcd8739ae039(t, e);
}


function $56605f2979837676$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $b4bc9016f3e318e4$export$2e2bcd8739ae039)(t, e);
}


function $842b6e0da6891434$export$2e2bcd8739ae039(t) {
    return $842b6e0da6891434$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $842b6e0da6891434$export$2e2bcd8739ae039(t);
}


function $d3a6f09ccec9fd7e$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d3a6f09ccec9fd7e$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $72c3cf5bc8600437$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $b9857b0719ab1f8f$export$2e2bcd8739ae039)(t);
}


function $784fa0189d62810b$export$2e2bcd8739ae039(t) {
    var r = (0, $d3a6f09ccec9fd7e$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $842b6e0da6891434$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $842b6e0da6891434$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $72c3cf5bc8600437$export$2e2bcd8739ae039)(this, e);
    };
}





var $2b94831bfc262559$var$AbstractCalculator = /*#__PURE__*/ (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(function AbstractCalculator() {
    (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, AbstractCalculator);
});
var $2b94831bfc262559$export$2e2bcd8739ae039 = $2b94831bfc262559$var$AbstractCalculator;


var $b3b9dffe34f3c8ef$var$CALC_UNIT = 'CALC_UNIT';
var $b3b9dffe34f3c8ef$var$regexp = new RegExp($b3b9dffe34f3c8ef$var$CALC_UNIT, 'g');
function $b3b9dffe34f3c8ef$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($b3b9dffe34f3c8ef$var$CALC_UNIT);
    return value;
}
var $b3b9dffe34f3c8ef$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $56605f2979837676$export$2e2bcd8739ae039)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $784fa0189d62810b$export$2e2bcd8739ae039)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $b9857b0719ab1f8f$export$2e2bcd8739ae039)(_this), "result", '');
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $b9857b0719ab1f8f$export$2e2bcd8739ae039)(_this), "unitlessCssVar", void 0);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $b9857b0719ab1f8f$export$2e2bcd8739ae039)(_this), "lowPriority", void 0);
        var numType = (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $b3b9dffe34f3c8ef$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($b3b9dffe34f3c8ef$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($b3b9dffe34f3c8ef$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($b3b9dffe34f3c8ef$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $2b94831bfc262559$export$2e2bcd8739ae039));









var $3c34411db56472c0$var$NumCalculator = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $56605f2979837676$export$2e2bcd8739ae039)(NumCalculator, _AbstractCalculator);
    var _super = (0, $784fa0189d62810b$export$2e2bcd8739ae039)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, NumCalculator);
        _this = _super.call(this);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $b9857b0719ab1f8f$export$2e2bcd8739ae039)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $2b94831bfc262559$export$2e2bcd8739ae039));
var $3c34411db56472c0$export$2e2bcd8739ae039 = $3c34411db56472c0$var$NumCalculator;


var $db5eb51f312e53e6$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $b3b9dffe34f3c8ef$export$2e2bcd8739ae039) : (0, $3c34411db56472c0$export$2e2bcd8739ae039);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $db5eb51f312e53e6$export$2e2bcd8739ae039 = $db5eb51f312e53e6$var$genCalc;


var $08ab90697118f03a$var$getCompVarPrefix = function getCompVarPrefix(component, prefix) {
    return "".concat([
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2')
    ].filter(Boolean).join('-'));
};
var $08ab90697118f03a$export$2e2bcd8739ae039 = $08ab90697118f03a$var$getCompVarPrefix;





var $ltGt3 = parcelRequire("ltGt3");
function $a7f17bc7a54333b8$export$2e2bcd8739ae039(callback) {
    var fnRef = $ltGt3.useRef();
    fnRef.current = callback;
    var memoFn = $ltGt3.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}





var $ltGt3 = parcelRequire("ltGt3");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $956f158068638b56$var$useInternalLayoutEffect = (0, $6ffdd9161f116fb2$export$2e2bcd8739ae039)() ? $ltGt3.useLayoutEffect : $ltGt3.useEffect;
var $956f158068638b56$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $ltGt3.useRef(true);
    $956f158068638b56$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $956f158068638b56$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $956f158068638b56$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $956f158068638b56$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $956f158068638b56$export$2e2bcd8739ae039 = $956f158068638b56$var$useLayoutEffect;




var $ltGt3 = parcelRequire("ltGt3");
function $74baa4b700eca4d0$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $ltGt3.useRef(false);
    var _React$useState = $ltGt3.useState(defaultValue), _React$useState2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $ltGt3.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $7967f104d62d1697$var$hasValue(value) {
    return value !== undefined;
}
function $7967f104d62d1697$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $74baa4b700eca4d0$export$2e2bcd8739ae039)(function() {
        if ($7967f104d62d1697$var$hasValue(value)) return value;
        else if ($7967f104d62d1697$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $a7f17bc7a54333b8$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $74baa4b700eca4d0$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $956f158068638b56$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $956f158068638b56$export$9283e56bae2f7b0f)(function() {
        if (!$7967f104d62d1697$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $a7f17bc7a54333b8$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}




var $ltGt3 = parcelRequire("ltGt3");
var $14ff92669ec59f4c$exports = {};
'use strict';

$14ff92669ec59f4c$exports = (parcelRequire("f0FtT"));




var $14266d390b9ba209$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $14266d390b9ba209$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $14266d390b9ba209$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $14266d390b9ba209$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(object) === 'object' && // React Element type
    (object.$$typeof === $14266d390b9ba209$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $14266d390b9ba209$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $14266d390b9ba209$var$REACT_FRAGMENT_TYPE);
}


var $7f1d8365b696a16b$var$ReactMajorVersion = Number((0, $ltGt3.version).split('.')[0]);
var $7f1d8365b696a16b$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $7f1d8365b696a16b$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $7f1d8365b696a16b$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $7f1d8365b696a16b$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $97adbe7759b0359b$export$2e2bcd8739ae039)(function() {
        return $7f1d8365b696a16b$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $7f1d8365b696a16b$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($7f1d8365b696a16b$var$isReactElement(nodeOrComponent) && $7f1d8365b696a16b$var$ReactMajorVersion >= 19) return true;
    var type = (0, $14ff92669ec59f4c$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $14ff92669ec59f4c$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $14ff92669ec59f4c$exports.ForwardRef)) return false;
    return true;
};
function $7f1d8365b696a16b$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $ltGt3.isValidElement)(node) && !(0, $14266d390b9ba209$export$2e2bcd8739ae039)(node);
}
var $7f1d8365b696a16b$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $7f1d8365b696a16b$var$isReactElement(node) && $7f1d8365b696a16b$export$c1cec34af06bcf7(node);
};
var $7f1d8365b696a16b$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $7f1d8365b696a16b$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};


function $3191e7204e586272$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}









function $98a7c4d0eb89c4eb$export$2e2bcd8739ae039(r) {
    return (0, $956eb3955017f471$export$2e2bcd8739ae039)(r) || (0, $322c7edaec67f281$export$2e2bcd8739ae039)(r) || (0, $f08c52026be8729d$export$2e2bcd8739ae039)(r) || (0, $66e45e43b8094fcb$export$2e2bcd8739ae039)();
}



function $65d95ae563ac04ed$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $98a7c4d0eb89c4eb$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(entity);
    else clone = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $65d95ae563ac04ed$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $65d95ae563ac04ed$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $3191e7204e586272$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $65d95ae563ac04ed$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $65d95ae563ac04ed$var$isObject(obj) {
    return (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $65d95ae563ac04ed$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $65d95ae563ac04ed$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $65d95ae563ac04ed$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $65d95ae563ac04ed$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $3191e7204e586272$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $65d95ae563ac04ed$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $3191e7204e586272$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $65d95ae563ac04ed$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(originValue) !== 'object') // Init container if not exist
                    clone = $65d95ae563ac04ed$export$2e2bcd8739ae039(clone, path, $65d95ae563ac04ed$var$createEmpty(value));
                    $65d95ae563ac04ed$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $65d95ae563ac04ed$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}





function $b0147a31efd821ae$var$getComponentToken(component, token, defaultToken, options) {
    var customToken = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, token[component]);
    if (options !== null && options !== void 0 && options.deprecatedTokens) {
        var deprecatedTokens = options.deprecatedTokens;
        deprecatedTokens.forEach(function(_ref) {
            var _ref2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_ref, 2), oldTokenKey = _ref2[0], newTokenKey = _ref2[1];
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
                var _customToken$newToken;
                (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
            }
        });
    }
    var mergedToken = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, defaultToken), customToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach(function(key) {
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
}
var $b0147a31efd821ae$export$2e2bcd8739ae039 = $b0147a31efd821ae$var$getComponentToken;




var $a8ae4dfe7c8ed6db$var$enableStatistic = typeof CSSINJS_STATISTIC !== 'undefined';
var $a8ae4dfe7c8ed6db$var$recording = true;
function $a8ae4dfe7c8ed6db$export$4950aa0f605343fb() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!$a8ae4dfe7c8ed6db$var$enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    $a8ae4dfe7c8ed6db$var$recording = false;
    var ret = {};
    objs.forEach(function(obj) {
        if ((0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(obj) !== 'object') return;
        var keys = Object.keys(obj);
        keys.forEach(function(key) {
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: function get() {
                    return obj[key];
                }
            });
        });
    });
    $a8ae4dfe7c8ed6db$var$recording = true;
    return ret;
}
var $a8ae4dfe7c8ed6db$export$754a5e2d36c5fa7a = {};
var $a8ae4dfe7c8ed6db$export$36157caab8bf9cbd = {};
/* istanbul ignore next */ function $a8ae4dfe7c8ed6db$var$noop() {}
/** Statistic token usage case. Should use `merge` function if you do not want spread record. */ var $a8ae4dfe7c8ed6db$var$statisticToken = function statisticToken(token) {
    var tokenKeys;
    var proxy = token;
    var flush = $a8ae4dfe7c8ed6db$var$noop;
    if ($a8ae4dfe7c8ed6db$var$enableStatistic && typeof Proxy !== 'undefined') {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get: function get(obj, prop) {
                if ($a8ae4dfe7c8ed6db$var$recording) {
                    var _tokenKeys;
                    (_tokenKeys = tokenKeys) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
                }
                return obj[prop];
            }
        });
        flush = function flush(componentName, componentToken) {
            var _statistic$componentN;
            $a8ae4dfe7c8ed6db$export$754a5e2d36c5fa7a[componentName] = {
                global: Array.from(tokenKeys),
                component: (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, (_statistic$componentN = $a8ae4dfe7c8ed6db$export$754a5e2d36c5fa7a[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
};
var $a8ae4dfe7c8ed6db$export$2e2bcd8739ae039 = $a8ae4dfe7c8ed6db$var$statisticToken;


function $6aa12583eab4edee$var$getDefaultComponentToken(component, token, getDefaultToken) {
    if (typeof getDefaultToken === 'function') {
        var _token$component;
        return getDefaultToken((0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, (_token$component = token[component]) !== null && _token$component !== void 0 ? _token$component : {}));
    }
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
var $6aa12583eab4edee$export$2e2bcd8739ae039 = $6aa12583eab4edee$var$getDefaultComponentToken;



function $0768b394bd1ed3d6$var$genMaxMin(type) {
    if (type === 'js') return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function max() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return "max(".concat(args.map(function(value) {
                return (0, $df37b8d23d0b3c71$export$523c0b569236b342)(value);
            }).join(','), ")");
        },
        min: function min() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return "min(".concat(args.map(function(value) {
                return (0, $df37b8d23d0b3c71$export$523c0b569236b342)(value);
            }).join(','), ")");
        }
    };
}
var $0768b394bd1ed3d6$export$2e2bcd8739ae039 = $0768b394bd1ed3d6$var$genMaxMin;








var $ltGt3 = parcelRequire("ltGt3");
var $0f8a9454dc7a2578$var$BEAT_LIMIT = 600000;
/**
 * A helper class to map keys to values.
 * It supports both primitive keys and object keys.
 */ var $0f8a9454dc7a2578$var$ArrayKeyMap = /*#__PURE__*/ function() {
    function ArrayKeyMap() {
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, ArrayKeyMap);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "map", new Map());
        // Use WeakMap to avoid memory leak
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "objectIDMap", new WeakMap());
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "nextID", 0);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "lastAccessBeat", new Map());
        // We will clean up the cache when reach the limit
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "accessBeat", 0);
    }
    (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(ArrayKeyMap, [
        {
            key: "set",
            value: function set(keys, value) {
                // New set will trigger clear
                this.clear();
                // Set logic
                var compositeKey = this.getCompositeKey(keys);
                this.map.set(compositeKey, value);
                this.lastAccessBeat.set(compositeKey, Date.now());
            }
        },
        {
            key: "get",
            value: function get(keys) {
                var compositeKey = this.getCompositeKey(keys);
                var cache = this.map.get(compositeKey);
                this.lastAccessBeat.set(compositeKey, Date.now());
                this.accessBeat += 1;
                return cache;
            }
        },
        {
            key: "getCompositeKey",
            value: function getCompositeKey(keys) {
                var _this = this;
                var ids = keys.map(function(key) {
                    if (key && (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(key) === 'object') return "obj_".concat(_this.getObjectID(key));
                    return "".concat((0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(key), "_").concat(key);
                });
                return ids.join('|');
            }
        },
        {
            key: "getObjectID",
            value: function getObjectID(obj) {
                if (this.objectIDMap.has(obj)) return this.objectIDMap.get(obj);
                var id = this.nextID;
                this.objectIDMap.set(obj, id);
                this.nextID += 1;
                return id;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this2 = this;
                if (this.accessBeat > 10000) {
                    var now = Date.now();
                    this.lastAccessBeat.forEach(function(beat, key) {
                        if (now - beat > $0f8a9454dc7a2578$var$BEAT_LIMIT) {
                            _this2.map.delete(key);
                            _this2.lastAccessBeat.delete(key);
                        }
                    });
                    this.accessBeat = 0;
                }
            }
        }
    ]);
    return ArrayKeyMap;
}();
var $0f8a9454dc7a2578$var$uniqueMap = new $0f8a9454dc7a2578$var$ArrayKeyMap();
/**
 * Like `useMemo`, but this hook result will be shared across all instances.
 */ function $0f8a9454dc7a2578$var$useUniqueMemo(memoFn, deps) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(function() {
        var cachedValue = $0f8a9454dc7a2578$var$uniqueMap.get(deps);
        if (cachedValue) return cachedValue;
        var newValue = memoFn();
        $0f8a9454dc7a2578$var$uniqueMap.set(deps, newValue);
        return newValue;
    }, deps);
}
var $0f8a9454dc7a2578$export$2e2bcd8739ae039 = $0f8a9454dc7a2578$var$useUniqueMemo;


/**
 * Provide a default hook since not everyone needs to config this.
 */ var $1e85a451bea2fdfd$var$useDefaultCSP = function useDefaultCSP() {
    return {};
};
var $1e85a451bea2fdfd$export$2e2bcd8739ae039 = $1e85a451bea2fdfd$var$useDefaultCSP;


function $93c2027e1ec6e32b$var$genStyleUtils(config) {
    // Dependency inversion for preparing basic config.
    var _config$useCSP = config.useCSP, useCSP = _config$useCSP === void 0 ? (0, $1e85a451bea2fdfd$export$2e2bcd8739ae039) : _config$useCSP, useToken = config.useToken, usePrefix = config.usePrefix, getResetStyles = config.getResetStyles, getCommonStyle = config.getCommonStyle, getCompUnitless = config.getCompUnitless;
    function genStyleHooks(component, styleFn, getDefaultToken, options) {
        var componentName = Array.isArray(component) ? component[0] : component;
        function prefixToken(key) {
            return "".concat(String(componentName)).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
        }
        // Fill unitless
        var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
        var originCompUnitless = typeof getCompUnitless === 'function' ? getCompUnitless(component) : {};
        var compUnitless = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, originCompUnitless), {}, (0, $db13280b58f1be94$export$2e2bcd8739ae039)({}, prefixToken('zIndexPopup'), true));
        Object.keys(originUnitless).forEach(function(key) {
            compUnitless[prefixToken(key)] = originUnitless[key];
        });
        // Options
        var mergedOptions = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, options), {}, {
            unitless: compUnitless,
            prefixToken: prefixToken
        });
        // Hooks
        var useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, mergedOptions);
        var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var hashId = useStyle(prefixCls, rootCls);
            var cssVarCls = useCSSVar(rootCls);
            return [
                hashId,
                cssVarCls
            ];
        };
    }
    function genCSSVarRegister(component, getDefaultToken, options) {
        var compUnitless = options.unitless, prefixToken = options.prefixToken, ignore = options.ignore;
        return function(rootCls) {
            var _useToken = useToken(), cssVar = _useToken.cssVar, realToken = _useToken.realToken;
            (0, $b27455a3575a1392$export$2e2bcd8739ae039)({
                path: [
                    component
                ],
                prefix: cssVar.prefix,
                key: cssVar.key,
                unitless: compUnitless,
                ignore: ignore,
                token: realToken,
                scope: rootCls
            }, function() {
                var defaultToken = (0, $6aa12583eab4edee$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentToken = (0, $b0147a31efd821ae$export$2e2bcd8739ae039)(component, realToken, defaultToken, {
                    deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
                });
                if (defaultToken) Object.keys(defaultToken).forEach(function(key) {
                    componentToken[prefixToken(key)] = componentToken[key];
                    delete componentToken[key];
                });
                return componentToken;
            });
            return cssVar === null || cssVar === void 0 ? void 0 : cssVar.key;
        };
    }
    function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var cells = Array.isArray(componentName) ? componentName : [
            componentName,
            componentName
        ];
        var _cells = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(cells, 1), component = _cells[0];
        var concatComponent = cells.join('-');
        var mergedLayer = config.layer || {
            name: 'antd'
        };
        // Return new style hook
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useToken2 = useToken(), theme = _useToken2.theme, realToken = _useToken2.realToken, hashId = _useToken2.hashId, token = _useToken2.token, cssVar = _useToken2.cssVar, zeroRuntime = _useToken2.zeroRuntime;
            // Update of `disabledRuntimeStyle` would cause React hook error, so memoized it and never update.
            var memoizedZeroRuntime = (0, $ltGt3.useMemo)(function() {
                return zeroRuntime;
            }, []);
            if (memoizedZeroRuntime) return hashId;
            var _usePrefix = usePrefix(), rootPrefixCls = _usePrefix.rootPrefixCls, iconPrefixCls = _usePrefix.iconPrefixCls;
            var csp = useCSP();
            var type = 'css';
            // Use unique memo to share the result across all instances
            var calc = (0, $0f8a9454dc7a2578$export$2e2bcd8739ae039)(function() {
                var unitlessCssVar = new Set();
                Object.keys(options.unitless || {}).forEach(function(key) {
                    // Some component proxy the AliasToken (e.g. Image) and some not (e.g. Modal)
                    // We should both pass in `unitlessCssVar` to make sure the CSSVar can be unitless.
                    unitlessCssVar.add((0, $67936b70b30a4662$export$309b3b095f0c7662)(key, cssVar.prefix));
                    unitlessCssVar.add((0, $67936b70b30a4662$export$309b3b095f0c7662)(key, (0, $08ab90697118f03a$export$2e2bcd8739ae039)(component, cssVar.prefix)));
                });
                return (0, $db5eb51f312e53e6$export$2e2bcd8739ae039)(type, unitlessCssVar);
            }, [
                type,
                component,
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix
            ]);
            var _genMaxMin = (0, $0768b394bd1ed3d6$export$2e2bcd8739ae039)(type), max = _genMaxMin.max, min = _genMaxMin.min;
            // Shared config
            var sharedConfig = {
                theme: theme,
                token: token,
                hashId: hashId,
                nonce: function nonce() {
                    return csp.nonce;
                },
                clientOnly: options.clientOnly,
                layer: mergedLayer,
                // antd is always at top of styles
                order: options.order || -999
            };
            // This if statement is safe, as it will only be used if the generator has the function. It's not dynamic.
            if (typeof getResetStyles === 'function') // Generate style for all need reset tags.
            (0, $5cbbf99d0b51a6f3$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                clientOnly: false,
                path: [
                    'Shared',
                    rootPrefixCls
                ]
            }), function() {
                return getResetStyles(token, {
                    prefix: {
                        rootPrefixCls: rootPrefixCls,
                        iconPrefixCls: iconPrefixCls
                    },
                    csp: csp
                });
            });
            (0, $5cbbf99d0b51a6f3$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                path: [
                    concatComponent,
                    prefixCls,
                    iconPrefixCls
                ]
            }), function() {
                if (options.injectStyle === false) return [];
                var _statisticToken = (0, $a8ae4dfe7c8ed6db$export$2e2bcd8739ae039)(token), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
                var defaultComponentToken = (0, $6aa12583eab4edee$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentCls = ".".concat(prefixCls);
                var componentToken = (0, $b0147a31efd821ae$export$2e2bcd8739ae039)(component, realToken, defaultComponentToken, {
                    deprecatedTokens: options.deprecatedTokens
                });
                if (defaultComponentToken && (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(defaultComponentToken) === 'object') Object.keys(defaultComponentToken).forEach(function(key) {
                    defaultComponentToken[key] = "var(".concat((0, $67936b70b30a4662$export$309b3b095f0c7662)(key, (0, $08ab90697118f03a$export$2e2bcd8739ae039)(component, cssVar.prefix)), ")");
                });
                var mergedToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(proxyToken, {
                    componentCls: componentCls,
                    prefixCls: prefixCls,
                    iconCls: ".".concat(iconPrefixCls),
                    antCls: ".".concat(rootPrefixCls),
                    calc: calc,
                    max: max,
                    min: min
                }, defaultComponentToken);
                var styleInterpolation = styleFn(mergedToken, {
                    hashId: hashId,
                    prefixCls: prefixCls,
                    rootPrefixCls: rootPrefixCls,
                    iconPrefixCls: iconPrefixCls
                });
                flush(component, componentToken);
                var commonStyle = typeof getCommonStyle === 'function' ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
                return [
                    options.resetStyle === false ? null : commonStyle,
                    styleInterpolation
                ];
            });
            return hashId;
        };
    }
    function genSubStyleComponent(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({
            resetStyle: false,
            // Sub Style should default after root one
            order: -998
        }, options));
        var StyledComponent = function StyledComponent(_ref) {
            var prefixCls = _ref.prefixCls, _ref$rootCls = _ref.rootCls, rootCls = _ref$rootCls === void 0 ? prefixCls : _ref$rootCls;
            useStyle(prefixCls, rootCls);
            return null;
        };
        return StyledComponent;
    }
    return {
        genStyleHooks: genStyleHooks,
        genSubStyleComponent: genSubStyleComponent,
        genComponentStyleHook: genComponentStyleHook
    };
}
var $93c2027e1ec6e32b$export$2e2bcd8739ae039 = $93c2027e1ec6e32b$var$genStyleUtils;









const { genStyleHooks: $2acdd5777733fef1$export$51ec95de45185b42, genComponentStyleHook: $2acdd5777733fef1$export$b8cc4ee2ee8cfbc8, genSubStyleComponent: $2acdd5777733fef1$export$1537386bc155ea56 } = (0, $93c2027e1ec6e32b$export$2e2bcd8739ae039)({
    usePrefix: ()=>{
        const { getPrefixCls: getPrefixCls, iconPrefixCls: iconPrefixCls } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
        const rootPrefixCls = getPrefixCls();
        return {
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls
        };
    },
    useToken: ()=>{
        const [theme, realToken, hashId, token, cssVar, zeroRuntime] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
        return {
            theme: theme,
            realToken: realToken,
            hashId: hashId,
            token: token,
            cssVar: cssVar,
            zeroRuntime: zeroRuntime
        };
    },
    useCSP: ()=>{
        const { csp: csp } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
        return csp ?? {};
    },
    getResetStyles: (token, config)=>{
        const linkStyle = (0, $945cb0d2b7017a11$export$905d771977096614)(token);
        return [
            linkStyle,
            {
                '&': linkStyle
            },
            (0, $945cb0d2b7017a11$export$f1a0b31dfb234e7e)(config?.prefix.iconPrefixCls ?? (0, $d13451568443aeb8$export$eaca8ee5ed21b4e9))
        ];
    },
    getCommonStyle: (0, $945cb0d2b7017a11$export$689382c111559cd9),
    getCompUnitless: ()=>(0, $42a04fd86d13249e$export$c6b9faa6b723d31a)
});
const $2acdd5777733fef1$export$d82b8f66c5649e14 = (antCls, componentAbbr)=>{
    const cssPrefix = `--${antCls.replace('.', '')}-${componentAbbr}-`;
    return (name, withVar = false)=>{
        const raw = `${cssPrefix}${name}`;
        return withVar ? `var(${raw})` : raw;
    };
};


const $25b3dccacf503fc7$var$genWaveStyle = (token)=>{
    const { componentCls: componentCls, colorPrimary: colorPrimary } = token;
    return {
        [componentCls]: {
            position: 'absolute',
            background: 'transparent',
            pointerEvents: 'none',
            boxSizing: 'border-box',
            color: `var(--wave-color, ${colorPrimary})`,
            boxShadow: `0 0 0 0 currentcolor`,
            opacity: 0.2,
            // =================== Motion ===================
            '&.wave-motion-appear': {
                transition: [
                    `box-shadow 0.4s ${token.motionEaseOutCirc}`,
                    `opacity 2s ${token.motionEaseOutCirc}`
                ].join(','),
                '&-active': {
                    boxShadow: `0 0 0 6px currentcolor`,
                    opacity: 0
                },
                '&.wave-quick': {
                    transition: [
                        `box-shadow ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                        `opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`
                    ].join(',')
                }
            }
        }
    };
};
var $25b3dccacf503fc7$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$b8cc4ee2ee8cfbc8)('Wave', $25b3dccacf503fc7$var$genWaveStyle);



var $ltGt3 = parcelRequire("ltGt3");





const $59c6657b0a346860$export$23466a5792b7a5d3 = `${(0, $d13451568443aeb8$export$e4ec87ea71f29b41)}-wave-target`;



var $ltGt3 = parcelRequire("ltGt3");



const $93d215b32898d17a$var$MARK = '__rc_react_root__';
function $93d215b32898d17a$export$b3890eb0ae9dca99(node, container) {
    const root = container[$93d215b32898d17a$var$MARK] || (0, $d13952e353ee92c1$export$882461b6382ed46c)(container);
    root.render(node);
    container[$93d215b32898d17a$var$MARK] = root;
}
async function $93d215b32898d17a$export$121e2d597d222bad(container) {
    // Delay to unmount to avoid React 18 sync warning
    return Promise.resolve().then(()=>{
        container[$93d215b32898d17a$var$MARK]?.unmount();
        delete container[$93d215b32898d17a$var$MARK];
    });
}





function $7a303b6ebf22ca2b$export$9d61ea039e87eb91(color) {
    return color && typeof color === 'string' && color !== '#fff' && color !== '#ffffff' && color !== 'rgb(255, 255, 255)' && color !== 'rgba(255, 255, 255, 1)' && !/rgba\((?:\d*, ){3}0\)/.test(color) && // any transparent rgba color
    color !== 'transparent' && color !== 'canvastext';
}
function $7a303b6ebf22ca2b$export$651d8e9c80304fc8(node, colorSource = null) {
    const style = getComputedStyle(node);
    const { borderTopColor: borderTopColor, borderColor: borderColor, backgroundColor: backgroundColor } = style;
    if (colorSource && $7a303b6ebf22ca2b$export$9d61ea039e87eb91(style[colorSource])) return style[colorSource];
    return [
        borderTopColor,
        borderColor,
        backgroundColor
    ].find($7a303b6ebf22ca2b$export$9d61ea039e87eb91) ?? null;
}


"use client";
function $3b1a7cebb5ccadfb$var$validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
const $3b1a7cebb5ccadfb$var$WaveEffect = (props)=>{
    const { className: className, target: target, component: component, colorSource: colorSource } = props;
    const divRef = $ltGt3.useRef(null);
    // ===================== Effect =====================
    const [color, setWaveColor] = $ltGt3.useState(null);
    const [borderRadius, setBorderRadius] = $ltGt3.useState([]);
    const [left, setLeft] = $ltGt3.useState(0);
    const [top, setTop] = $ltGt3.useState(0);
    const [width, setWidth] = $ltGt3.useState(0);
    const [height, setHeight] = $ltGt3.useState(0);
    const [enabled, setEnabled] = $ltGt3.useState(false);
    const waveStyle = {
        left: left,
        top: top,
        width: width,
        height: height,
        borderRadius: borderRadius.map((radius)=>`${radius}px`).join(' ')
    };
    if (color) waveStyle['--wave-color'] = color;
    function syncPos() {
        const nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, $7a303b6ebf22ca2b$export$651d8e9c80304fc8)(target, colorSource));
        const isStatic = nodeStyle.position === 'static';
        // Rect
        const { borderLeftWidth: borderLeftWidth, borderTopWidth: borderTopWidth } = nodeStyle;
        setLeft(isStatic ? target.offsetLeft : $3b1a7cebb5ccadfb$var$validateNum(-Number.parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : $3b1a7cebb5ccadfb$var$validateNum(-Number.parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        const { borderTopLeftRadius: borderTopLeftRadius, borderTopRightRadius: borderTopRightRadius, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius } = nodeStyle;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map((radius)=>$3b1a7cebb5ccadfb$var$validateNum(Number.parseFloat(radius))));
    }
    $ltGt3.useEffect(()=>{
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            const id = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            let resizeObserver;
            if (typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return ()=>{
                (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(id);
                resizeObserver?.disconnect();
            };
        }
    }, [
        target
    ]);
    if (!enabled) return null;
    const isSmallComponent = (component === 'Checkbox' || component === 'Radio') && target?.classList.contains((0, $59c6657b0a346860$export$23466a5792b7a5d3));
    return /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: (_, event)=>{
            if (event.deadline || event.propertyName === 'opacity') {
                const holder = divRef.current?.parentElement;
                (0, $93d215b32898d17a$export$121e2d597d222bad)(holder).then(()=>{
                    holder?.remove();
                });
            }
            return false;
        }
    }, ({ className: motionClassName }, ref)=>/*#__PURE__*/ $ltGt3.createElement("div", {
            ref: (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(divRef, ref),
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, motionClassName, {
                'wave-quick': isSmallComponent
            }),
            style: waveStyle
        }));
};
const $3b1a7cebb5ccadfb$var$showWaveEffect = (target, info)=>{
    const { component: component } = info;
    // Skip for unchecked checkbox
    if (component === 'Checkbox' && !target.querySelector('input')?.checked) return;
    // Create holder
    const holder = document.createElement('div');
    holder.style.position = 'absolute';
    holder.style.left = '0px';
    holder.style.top = '0px';
    target?.insertBefore(holder, target?.firstChild);
    (0, $93d215b32898d17a$export$b3890eb0ae9dca99)(/*#__PURE__*/ $ltGt3.createElement($3b1a7cebb5ccadfb$var$WaveEffect, {
        ...info,
        target: target
    }), holder);
};
var $3b1a7cebb5ccadfb$export$2e2bcd8739ae039 = $3b1a7cebb5ccadfb$var$showWaveEffect;


const $fea0da3a7d896c30$var$useWave = (nodeRef, className, component, colorSource)=>{
    const { wave: wave } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const [, token, hashId] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const showWave = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((event)=>{
        const node = nodeRef.current;
        if (wave?.disabled || !node) return;
        const targetNode = node.querySelector(`.${(0, $59c6657b0a346860$export$23466a5792b7a5d3)}`) || node;
        const { showEffect: showEffect } = wave || {};
        // Customize wave effect
        (showEffect || (0, $3b1a7cebb5ccadfb$export$2e2bcd8739ae039))(targetNode, {
            className: className,
            token: token,
            component: component,
            event: event,
            hashId: hashId,
            colorSource: colorSource
        });
    });
    const rafId = $ltGt3.useRef(null);
    // Merge trigger event into one for each frame
    const showDebounceWave = (event)=>{
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(rafId.current);
        rafId.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
            showWave(event);
        });
    };
    return showDebounceWave;
};
var $fea0da3a7d896c30$export$2e2bcd8739ae039 = $fea0da3a7d896c30$var$useWave;


const $b5f0e609aabb59e2$var$Wave = (props)=>{
    const { children: children, disabled: disabled, component: component, colorSource: colorSource } = props;
    const { getPrefixCls: getPrefixCls } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const containerRef = (0, $ltGt3.useRef)(null);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('wave');
    const [, hashId] = (0, $25b3dccacf503fc7$export$2e2bcd8739ae039)(prefixCls);
    // =============================== Wave ===============================
    const showWave = (0, $fea0da3a7d896c30$export$2e2bcd8739ae039)(containerRef, (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, hashId), component, colorSource);
    // ============================== Effect ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(()=>{
        const node = containerRef.current;
        if (!node || node.nodeType !== window.Node.ELEMENT_NODE || disabled) return;
        // Click handler
        const onClick = (e)=>{
            // Fix radio button click twice
            if (!(0, $d3c89c1e130d7e35$export$2e2bcd8739ae039)(e.target) || // No need wave
            !node.getAttribute || node.getAttribute('disabled') || node.disabled || node.className.includes('disabled') && !node.className.includes('disabled:') || node.getAttribute('aria-disabled') === 'true' || node.className.includes('-leave')) return;
            showWave(e);
        };
        // Bind events
        node.addEventListener('click', onClick, true);
        return ()=>{
            node.removeEventListener('click', onClick, true);
        };
    }, [
        disabled
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).isValidElement(children)) return children ?? null;
    const ref = (0, $22ff46e28c8066e1$export$c1cec34af06bcf7)(children) ? (0, $22ff46e28c8066e1$export$ab452c34e8e05029)((0, $22ff46e28c8066e1$export$7465e5c0bf44f19a)(children), containerRef) : containerRef;
    return (0, $66d38239e1a27993$export$e530037191fcd5d7)(children, {
        ref: ref
    });
};
var $b5f0e609aabb59e2$export$2e2bcd8739ae039 = $b5f0e609aabb59e2$var$Wave;





var $ltGt3 = parcelRequire("ltGt3");

const $7bb31c172903861d$var$useSize = (customSize)=>{
    const size = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $9a9e608887097e77$export$2e2bcd8739ae039));
    const mergedSize = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        if (!customSize) return size;
        if (typeof customSize === 'string') return customSize ?? size;
        if (typeof customSize === 'function') return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $7bb31c172903861d$export$2e2bcd8739ae039 = $7bb31c172903861d$var$useSize;



var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
const $15bdf1069fb84d0c$var$isValidOrientation = (orientation)=>{
    return orientation === 'horizontal' || orientation === 'vertical';
};
const $15bdf1069fb84d0c$export$550084c67147f6c4 = (orientation, vertical, legacyDirection)=>{
    return (0, $ltGt3.useMemo)(()=>{
        const validOrientation = $15bdf1069fb84d0c$var$isValidOrientation(orientation);
        let mergedOrientation;
        if (validOrientation) mergedOrientation = orientation;
        else if (typeof vertical === 'boolean') mergedOrientation = vertical ? 'vertical' : 'horizontal';
        else {
            const validLegacyDirection = $15bdf1069fb84d0c$var$isValidOrientation(legacyDirection);
            mergedOrientation = validLegacyDirection ? legacyDirection : 'horizontal';
        }
        return [
            mergedOrientation,
            mergedOrientation === 'vertical'
        ];
    }, [
        legacyDirection,
        orientation,
        vertical
    ]);
};






const $c77ef68c934c19ac$var$genSpaceCompactStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-block': {
                display: 'flex',
                width: '100%'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
var // ============================== Export ==============================
$c77ef68c934c19ac$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)([
    'Space',
    'Compact'
], (token)=>[
        $c77ef68c934c19ac$var$genSpaceCompactStyle(token)
    ], ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
const $8eabd28975be2fa5$export$8d1c486ac0db0a7d = /*#__PURE__*/ $ltGt3.createContext(null);
const $8eabd28975be2fa5$export$cd8cf9d7bab8dd4 = (prefixCls, direction)=>{
    const compactItemContext = $ltGt3.useContext($8eabd28975be2fa5$export$8d1c486ac0db0a7d);
    const compactItemClassnames = $ltGt3.useMemo(()=>{
        if (!compactItemContext) return '';
        const { compactDirection: compactDirection, isFirstItem: isFirstItem, isLastItem: isLastItem } = compactItemContext;
        const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl'
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext?.compactSize,
        compactDirection: compactItemContext?.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
const $8eabd28975be2fa5$export$5f56e610a4afb685 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ $ltGt3.createElement($8eabd28975be2fa5$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
const $8eabd28975be2fa5$var$CompactItem = (props)=>{
    const { children: children, ...others } = props;
    return /*#__PURE__*/ $ltGt3.createElement($8eabd28975be2fa5$export$8d1c486ac0db0a7d.Provider, {
        value: $ltGt3.useMemo(()=>others, [
            others
        ])
    }, children);
};
const $8eabd28975be2fa5$var$Compact = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { size: size, direction: direction, orientation: orientation, block: block, prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, vertical: vertical, ...restProps } = props;
    const [mergedOrientation, mergedVertical] = (0, $15bdf1069fb84d0c$export$550084c67147f6c4)(orientation, vertical, direction);
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)((ctx)=>size ?? ctx);
    const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    const [hashId] = (0, $c77ef68c934c19ac$export$2e2bcd8739ae039)(prefixCls);
    const clx = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: mergedVertical
    }, className, rootClassName);
    const compactItemContext = $ltGt3.useContext($8eabd28975be2fa5$export$8d1c486ac0db0a7d);
    const childNodes = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children);
    const nodes = $ltGt3.useMemo(()=>childNodes.map((child, i)=>{
            const key = child?.key || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ $ltGt3.createElement($8eabd28975be2fa5$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: mergedOrientation,
                isFirstItem: i === 0 && (!compactItemContext || compactItemContext?.isFirstItem),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || compactItemContext?.isLastItem)
            }, child);
        }), [
        childNodes,
        compactItemContext,
        mergedOrientation,
        mergedSize,
        prefixCls
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: clx,
        ...restProps
    }, nodes);
};
var $8eabd28975be2fa5$export$2e2bcd8739ae039 = $8eabd28975be2fa5$var$Compact;



var $ltGt3 = parcelRequire("ltGt3");




"use client";
const $d5ab9674fddc9572$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $ltGt3.createContext(undefined);
const $d5ab9674fddc9572$var$ButtonGroup = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, size: size, className: className, ...others } = props;
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    const [, , hashId] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const sizeCls = $ltGt3.useMemo(()=>{
        switch(size){
            case 'large':
                return 'lg';
            case 'small':
                return 'sm';
            default:
                return '';
        }
    }, [
        size
    ]);
    const classes = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId);
    return /*#__PURE__*/ $ltGt3.createElement($d5ab9674fddc9572$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        ...others,
        className: classes
    }));
};
var $d5ab9674fddc9572$export$2e2bcd8739ae039 = $d5ab9674fddc9572$var$ButtonGroup;




var $ltGt3 = parcelRequire("ltGt3");


const $e1e3919c46d634bc$export$6d4fe3a00a1811ad = [
    'blue',
    'purple',
    'cyan',
    'green',
    'magenta',
    'pink',
    'red',
    'orange',
    'yellow',
    'volcano',
    'geekblue',
    'lime',
    'gold'
];


"use client";
const $ea3450de0c6c5939$var$rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
const $ea3450de0c6c5939$export$c5dca2bf412dea0d = $ea3450de0c6c5939$var$rxTwoCNChar.test.bind($ea3450de0c6c5939$var$rxTwoCNChar);
function $ea3450de0c6c5939$export$19bc9a290855952(type) {
    if (type === 'danger') return {
        danger: true
    };
    return {
        type: type
    };
}
function $ea3450de0c6c5939$export$844ec244b1367d54(str) {
    return typeof str === 'string';
}
function $ea3450de0c6c5939$export$b120bc11c0d9c214(type) {
    return type === 'text' || type === 'link';
}
function $ea3450de0c6c5939$var$splitCNCharsBySpace(child, needInserted, style, className) {
    if (child === null || child === undefined || child === '') return;
    const SPACE = needInserted ? ' ' : '';
    if (typeof child !== 'string' && typeof child !== 'number' && $ea3450de0c6c5939$export$844ec244b1367d54(child.type) && $ea3450de0c6c5939$export$c5dca2bf412dea0d(child.props.children)) return (0, $66d38239e1a27993$export$e530037191fcd5d7)(child, (oriProps)=>({
            ...oriProps,
            children: oriProps.children.split('').join(SPACE),
            className: className,
            style: style
        }));
    if ($ea3450de0c6c5939$export$844ec244b1367d54(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
        className: className,
        style: style
    }, $ea3450de0c6c5939$export$c5dca2bf412dea0d(child) ? child.split('').join(SPACE) : child);
    if ((0, $66d38239e1a27993$export$9522e17588c12572)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
        className: className,
        style: style
    }, child);
    return (0, $66d38239e1a27993$export$e530037191fcd5d7)(child, (oriProps)=>({
            ...oriProps,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(oriProps.className, className) || undefined,
            style: {
                ...oriProps.style,
                ...style
            }
        }));
}
function $ea3450de0c6c5939$export$b6ee00a7e7908bc(children, needInserted, style, className) {
    let isPrevChildPure = false;
    const childList = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.forEach(children, (child)=>{
        const type = typeof child;
        const isCurrentChildPure = type === 'string' || type === 'number';
        if (isPrevChildPure && isCurrentChildPure) {
            const lastIndex = childList.length - 1;
            const lastChild = childList[lastIndex];
            childList[lastIndex] = `${lastChild}${child}`;
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.map(childList, (child)=>$ea3450de0c6c5939$var$splitCNCharsBySpace(child, needInserted, style, className));
}
const $ea3450de0c6c5939$var$_ButtonTypes = [
    'default',
    'primary',
    'dashed',
    'link',
    'text'
];
const $ea3450de0c6c5939$var$_ButtonShapes = [
    'default',
    'circle',
    'round',
    'square'
];
const $ea3450de0c6c5939$var$_ButtonHTMLTypes = [
    'submit',
    'button',
    'reset'
];
const $ea3450de0c6c5939$export$9870b52452f51da5 = [
    'outlined',
    'dashed',
    'solid',
    'filled',
    'text',
    'link'
];
const $ea3450de0c6c5939$export$760f16d96e091fc5 = [
    'default',
    'primary',
    'danger'
].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)((0, $e1e3919c46d634bc$export$6d4fe3a00a1811ad)));



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $79309a74130ce8a8$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $79309a74130ce8a8$export$2e2bcd8739ae039 = $79309a74130ce8a8$var$LoadingOutlined;



var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");

function $f6a67f057cdc66b2$var$camelCase(input) {
    return input.replace(/-(.)/g, (match, g)=>g.toUpperCase());
}
function $f6a67f057cdc66b2$export$491112666e282270(valid, message) {
    (0, $474154b5a64067c8$export$82934adf09101657)(valid, `[@ant-design/icons] ${message}`);
}
function $f6a67f057cdc66b2$export$ab652842c37578f4(target) {
    return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}
function $f6a67f057cdc66b2$export$9f5073e7201cc21c(attrs = {}) {
    return Object.keys(attrs).reduce((acc, key)=>{
        const val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$f6a67f057cdc66b2$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $f6a67f057cdc66b2$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(node.tag, {
        key: key,
        ...$f6a67f057cdc66b2$export$9f5073e7201cc21c(node.attrs)
    }, (node.children || []).map((child, index)=>$f6a67f057cdc66b2$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(node.tag, {
        key: key,
        ...$f6a67f057cdc66b2$export$9f5073e7201cc21c(node.attrs),
        ...rootProps
    }, (node.children || []).map((child, index)=>$f6a67f057cdc66b2$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
}
function $f6a67f057cdc66b2$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $5a714eb5c7b9ddd8$export$2e2bcd8739ae039)(primaryColor)[0];
}
function $f6a67f057cdc66b2$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
const $f6a67f057cdc66b2$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
const $f6a67f057cdc66b2$export$2c99b98b77550cb4 = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
  vertical-align: inherit;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
const $f6a67f057cdc66b2$export$938b1f86b61613d0 = (eleRef)=>{
    const { csp: csp, prefixCls: prefixCls, layer: layer } = (0, $ltGt3.useContext)((0, $6513c993325f3802$export$2e2bcd8739ae039));
    let mergedStyleStr = $f6a67f057cdc66b2$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = `@layer ${layer} {\n${mergedStyleStr}\n}`;
    (0, $ltGt3.useEffect)(()=>{
        const ele = eleRef.current;
        const shadowRoot = (0, $6b508eb2255763e6$export$70e8259662bb498b)(ele);
        (0, $7720754a52a5d205$export$4d99a2890bb989f0)(mergedStyleStr, '@ant-design-icons', {
            prepend: !layer,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


const $278c02e35b17af27$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $278c02e35b17af27$var$setTwoToneColors({ primaryColor: primaryColor, secondaryColor: secondaryColor }) {
    $278c02e35b17af27$var$twoToneColorPalette.primaryColor = primaryColor;
    $278c02e35b17af27$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $f6a67f057cdc66b2$export$b71c93f469694483)(primaryColor);
    $278c02e35b17af27$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $278c02e35b17af27$var$getTwoToneColors() {
    return {
        ...$278c02e35b17af27$var$twoToneColorPalette
    };
}
const $278c02e35b17af27$var$IconBase = (props)=>{
    const { icon: icon, className: className, onClick: onClick, style: style, primaryColor: primaryColor, secondaryColor: secondaryColor, ...restProps } = props;
    const svgRef = $ltGt3.useRef(null);
    let colors = $278c02e35b17af27$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $f6a67f057cdc66b2$export$b71c93f469694483)(primaryColor)
    };
    (0, $f6a67f057cdc66b2$export$938b1f86b61613d0)(svgRef);
    (0, $f6a67f057cdc66b2$export$491112666e282270)((0, $f6a67f057cdc66b2$export$ab652842c37578f4)(icon), `icon should be icon definiton, but got ${icon}`);
    if (!(0, $f6a67f057cdc66b2$export$ab652842c37578f4)(icon)) return null;
    let target = icon;
    if (target && typeof target.icon === 'function') target = {
        ...target,
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    };
    return (0, $f6a67f057cdc66b2$export$80d376111cc09ad7)(target.icon, `svg-${target.name}`, {
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true',
        ...restProps,
        ref: svgRef
    });
};
$278c02e35b17af27$var$IconBase.displayName = 'IconReact';
$278c02e35b17af27$var$IconBase.getTwoToneColors = $278c02e35b17af27$var$getTwoToneColors;
$278c02e35b17af27$var$IconBase.setTwoToneColors = $278c02e35b17af27$var$setTwoToneColors;
var $278c02e35b17af27$export$2e2bcd8739ae039 = $278c02e35b17af27$var$IconBase;




function $970b2ef7a26d7d7d$export$8a145f34580ff02b(twoToneColor) {
    const [primaryColor, secondaryColor] = (0, $f6a67f057cdc66b2$export$b5b464c3d8433a9b)(twoToneColor);
    return (0, $278c02e35b17af27$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $970b2ef7a26d7d7d$export$abc7c554784cb4a7() {
    const colors = (0, $278c02e35b17af27$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



'use client';
function $e767a45d917d435a$var$_extends() {
    $e767a45d917d435a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e767a45d917d435a$var$_extends.apply(this, arguments);
}
// Initial setting
// should move it to antd main repo?
(0, $970b2ef7a26d7d7d$export$8a145f34580ff02b)((0, $1bd835bbb2d9f8c1$export$2aa0182783e7e9de).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
const $e767a45d917d435a$var$Icon = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { className: // affect outter <i>...</i>
    className, icon: // affect inner <svg>...</svg>
    icon, spin: spin, rotate: rotate, tabIndex: tabIndex, onClick: onClick, twoToneColor: // other
    twoToneColor, ...restProps } = props;
    const { prefixCls: prefixCls = 'anticon', rootClassName: rootClassName } = $ltGt3.useContext((0, $6513c993325f3802$export$2e2bcd8739ae039));
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(rootClassName, prefixCls, {
        [`${prefixCls}-${icon.name}`]: !!icon.name,
        [`${prefixCls}-spin`]: !!spin || icon.name === 'loading'
    }, className);
    let iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    const svgStyle = rotate ? {
        msTransform: `rotate(${rotate}deg)`,
        transform: `rotate(${rotate}deg)`
    } : undefined;
    const [primaryColor, secondaryColor] = (0, $f6a67f057cdc66b2$export$b5b464c3d8433a9b)(twoToneColor);
    return /*#__PURE__*/ $ltGt3.createElement("span", $e767a45d917d435a$var$_extends({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $ltGt3.createElement((0, $278c02e35b17af27$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$e767a45d917d435a$var$Icon.getTwoToneColor = (0, $970b2ef7a26d7d7d$export$abc7c554784cb4a7);
$e767a45d917d435a$var$Icon.setTwoToneColor = (0, $970b2ef7a26d7d7d$export$8a145f34580ff02b);
var $e767a45d917d435a$export$2e2bcd8739ae039 = $e767a45d917d435a$var$Icon;


function $8ede40f9e9e4f5c2$var$_extends() {
    $8ede40f9e9e4f5c2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8ede40f9e9e4f5c2$var$_extends.apply(this, arguments);
}
const $8ede40f9e9e4f5c2$var$LoadingOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $8ede40f9e9e4f5c2$var$_extends({}, props, {
        ref: ref,
        icon: (0, $79309a74130ce8a8$export$2e2bcd8739ae039)
    }));
/**![loading](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk4OCA1NDhjLTE5LjkgMC0zNi0xNi4xLTM2LTM2IDAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4zQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjMuMSAxOS45LTE2IDM2LTM1LjkgMzZ6IiAvPjwvc3ZnPg==) */ const $8ede40f9e9e4f5c2$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($8ede40f9e9e4f5c2$var$LoadingOutlined);
var $8ede40f9e9e4f5c2$export$2e2bcd8739ae039 = $8ede40f9e9e4f5c2$var$RefIcon;





var $ltGt3 = parcelRequire("ltGt3");

"use client";
const $2f56ad87fbaf2282$var$IconWrapper = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
    const { className: className, style: style, children: children, prefixCls: prefixCls } = props;
    const iconWrapperCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
var $2f56ad87fbaf2282$export$2e2bcd8739ae039 = $2f56ad87fbaf2282$var$IconWrapper;


"use client";
const $f16e2853fe7524e6$var$InnerLoadingIcon = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, iconClassName: iconClassName } = props;
    const mergedIconCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-loading-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $2f56ad87fbaf2282$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $8ede40f9e9e4f5c2$export$2e2bcd8739ae039), {
        className: iconClassName
    }));
});
const $f16e2853fe7524e6$var$getCollapsedWidth = ()=>({
        width: 0,
        opacity: 0,
        transform: 'scale(0)'
    });
const $f16e2853fe7524e6$var$getRealWidth = (node)=>({
        width: node.scrollWidth,
        opacity: 1,
        transform: 'scale(1)'
    });
const $f16e2853fe7524e6$var$DefaultLoadingIcon = (props)=>{
    const { prefixCls: prefixCls, loading: loading, existIcon: existIcon, className: className, style: style, mount: mount } = props;
    const visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement($f16e2853fe7524e6$var$InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), {
        visible: visible,
        // Used for minus flex gap style only
        motionName: `${prefixCls}-loading-icon-motion`,
        motionAppear: !mount,
        motionEnter: !mount,
        motionLeave: !mount,
        removeOnLeave: true,
        onAppearStart: $f16e2853fe7524e6$var$getCollapsedWidth,
        onAppearActive: $f16e2853fe7524e6$var$getRealWidth,
        onEnterStart: $f16e2853fe7524e6$var$getCollapsedWidth,
        onEnterActive: $f16e2853fe7524e6$var$getRealWidth,
        onLeaveStart: $f16e2853fe7524e6$var$getRealWidth,
        onLeaveActive: $f16e2853fe7524e6$var$getCollapsedWidth
    }, ({ className: motionCls, style: motionStyle }, ref)=>{
        const mergedStyle = {
            ...style,
            ...motionStyle
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement($f16e2853fe7524e6$var$InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, motionCls),
            style: mergedStyle,
            ref: ref
        });
    });
};
var $f16e2853fe7524e6$export$2e2bcd8739ae039 = $f16e2853fe7524e6$var$DefaultLoadingIcon;






const $a4a00f80930a83ce$var$genButtonBorderStyle = (buttonTypeCls, borderColor)=>({
        // Border
        [`> span, > ${buttonTypeCls}`]: {
            '&:not(:last-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineEndColor: borderColor
                    }
                }
            },
            '&:not(:first-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineStartColor: borderColor
                    }
                }
            }
        }
    });
const $a4a00f80930a83ce$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, fontSize: fontSize, lineWidth: lineWidth, groupBorderColor: groupBorderColor, colorErrorHover: colorErrorHover } = token;
    return {
        [`${componentCls}-group`]: [
            {
                position: 'relative',
                display: 'inline-flex',
                // Border
                [`> span, > ${componentCls}`]: {
                    '&:not(:last-child)': {
                        [`&, & > ${componentCls}`]: {
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0
                        }
                    },
                    '&:not(:first-child)': {
                        marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
                        [`&, & > ${componentCls}`]: {
                            borderStartStartRadius: 0,
                            borderEndStartRadius: 0
                        }
                    }
                },
                [componentCls]: {
                    position: 'relative',
                    zIndex: 1,
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    },
                    '&[disabled]': {
                        zIndex: 0
                    }
                },
                [`${componentCls}-icon-only`]: {
                    fontSize: fontSize
                }
            },
            // Border Color
            $a4a00f80930a83ce$var$genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
            $a4a00f80930a83ce$var$genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
        ]
    };
};
var $a4a00f80930a83ce$export$2e2bcd8739ae039 = $a4a00f80930a83ce$var$genGroupStyle;






var $ltGt3 = parcelRequire("ltGt3");

const $8b1eacdaa2bcd088$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $8b1eacdaa2bcd088$var$convertHsb2Hsv = (color)=>{
    if (color instanceof (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)) return color;
    if (color && typeof color === 'object' && 'h' in color && 'b' in color) {
        const { b: b, ...resets } = color;
        return {
            ...resets,
            v: b
        };
    }
    if (typeof color === 'string' && /hsb/.test(color)) return color.replace(/hsb/, 'hsv');
    return color;
};
class $8b1eacdaa2bcd088$export$892596cec99bc70e extends (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a) {
    constructor(color){
        super($8b1eacdaa2bcd088$var$convertHsb2Hsv(color));
    }
    toHsbString() {
        const hsb = this.toHsb();
        const saturation = $8b1eacdaa2bcd088$export$8d6531175688484b(hsb.s * 100);
        const lightness = $8b1eacdaa2bcd088$export$8d6531175688484b(hsb.b * 100);
        const hue = $8b1eacdaa2bcd088$export$8d6531175688484b(hsb.h);
        const alpha = hsb.a;
        const hsbString = `hsb(${hue}, ${saturation}%, ${lightness}%)`;
        const hsbaString = `hsba(${hue}, ${saturation}%, ${lightness}%, ${alpha.toFixed(alpha === 0 ? 0 : 2)})`;
        return alpha === 1 ? hsbString : hsbaString;
    }
    toHsb() {
        const { v: v, ...resets } = this.toHsv();
        return {
            ...resets,
            b: v,
            a: this.a
        };
    }
}


const $7d542ccee1228c13$export$90004e2badfbdf1f = 'rc-color-picker';
const $7d542ccee1228c13$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $8b1eacdaa2bcd088$export$892596cec99bc70e)) return color;
    return new (0, $8b1eacdaa2bcd088$export$892596cec99bc70e)(color);
};
const $7d542ccee1228c13$export$f705f0fde43a55a = $7d542ccee1228c13$export$c844f5d21427d1ab('#1677ff');
const $7d542ccee1228c13$export$3a7095e9fd85a71d = (props)=>{
    const { offset: offset, targetRef: targetRef, containerRef: containerRef, color: color, type: type } = props;
    const { width: width, height: height } = containerRef.current.getBoundingClientRect();
    const { width: targetWidth, height: targetHeight } = targetRef.current.getBoundingClientRect();
    const centerOffsetX = targetWidth / 2;
    const centerOffsetY = targetHeight / 2;
    const saturation = (offset.x + centerOffsetX) / width;
    const bright = 1 - (offset.y + centerOffsetY) / height;
    const hsb = color.toHsb();
    const alphaOffset = saturation;
    const hueOffset = (offset.x + centerOffsetX) / width * 360;
    if (type) switch(type){
        case 'hue':
            return $7d542ccee1228c13$export$c844f5d21427d1ab({
                ...hsb,
                h: hueOffset <= 0 ? 0 : hueOffset
            });
        case 'alpha':
            return $7d542ccee1228c13$export$c844f5d21427d1ab({
                ...hsb,
                a: alphaOffset <= 0 ? 0 : alphaOffset
            });
    }
    return $7d542ccee1228c13$export$c844f5d21427d1ab({
        h: hsb.h,
        s: saturation <= 0 ? 0 : saturation,
        b: bright >= 1 ? 1 : bright,
        a: hsb.a
    });
};
const $7d542ccee1228c13$export$20165527867cbf14 = (color, type)=>{
    const hsb = color.toHsb();
    switch(type){
        case 'hue':
            return {
                x: hsb.h / 360 * 100,
                y: 50
            };
        case 'alpha':
            return {
                x: color.a * 100,
                y: 50
            };
        // Picker panel
        default:
            return {
                x: hsb.s * 100,
                y: (1 - hsb.b) * 100
            };
    }
};






var $ltGt3 = parcelRequire("ltGt3");
const $1e685787d51afb93$var$ColorBlock = ({ color: color, prefixCls: prefixCls, className: className, style: style, onClick: onClick })=>{
    const colorBlockCls = `${prefixCls}-color-block`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(colorBlockCls, className),
        style: style,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: `${colorBlockCls}-inner`,
        style: {
            background: color
        }
    }));
};
var $1e685787d51afb93$export$2e2bcd8739ae039 = $1e685787d51afb93$var$ColorBlock;



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
function $3e6ccc26cf94ac75$var$getPosition(e) {
    const obj = 'touches' in e ? e.touches[0] : e;
    const scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
    const scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    return {
        pageX: obj.pageX - scrollXOffset,
        pageY: obj.pageY - scrollYOffset
    };
}
function $3e6ccc26cf94ac75$var$useColorDrag(props) {
    const { targetRef: targetRef, containerRef: containerRef, direction: direction, onDragChange: onDragChange, onDragChangeComplete: onDragChangeComplete, calculate: calculate, color: color, disabledDrag: disabledDrag } = props;
    const [offsetValue, setOffsetValue] = (0, $ltGt3.useState)({
        x: 0,
        y: 0
    });
    const mouseMoveRef = (0, $ltGt3.useRef)(null);
    const mouseUpRef = (0, $ltGt3.useRef)(null);
    // Always get position from `color`
    (0, $ltGt3.useEffect)(()=>{
        setOffsetValue(calculate());
    }, [
        color
    ]);
    (0, $ltGt3.useEffect)(()=>()=>{
            document.removeEventListener('mousemove', mouseMoveRef.current);
            document.removeEventListener('mouseup', mouseUpRef.current);
            document.removeEventListener('touchmove', mouseMoveRef.current);
            document.removeEventListener('touchend', mouseUpRef.current);
            mouseMoveRef.current = null;
            mouseUpRef.current = null;
        }, []);
    const updateOffset = (e)=>{
        const { pageX: pageX, pageY: pageY } = $3e6ccc26cf94ac75$var$getPosition(e);
        const { x: rectX, y: rectY, width: width, height: height } = containerRef.current.getBoundingClientRect();
        const { width: targetWidth, height: targetHeight } = targetRef.current.getBoundingClientRect();
        const centerOffsetX = targetWidth / 2;
        const centerOffsetY = targetHeight / 2;
        const offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
        const offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
        const calcOffset = {
            x: offsetX,
            y: direction === 'x' ? offsetValue.y : offsetY
        };
        // Exclusion of boundary cases
        if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) return false;
        onDragChange?.(calcOffset);
    };
    const onDragMove = (e)=>{
        e.preventDefault();
        updateOffset(e);
    };
    const onDragStop = (e)=>{
        e.preventDefault();
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        document.removeEventListener('touchmove', mouseMoveRef.current);
        document.removeEventListener('touchend', mouseUpRef.current);
        mouseMoveRef.current = null;
        mouseUpRef.current = null;
        onDragChangeComplete?.();
    };
    const onDragStart = (e)=>{
        // https://github.com/ant-design/ant-design/issues/43529
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        if (disabledDrag) return;
        updateOffset(e);
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragStop);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragStop);
        mouseMoveRef.current = onDragMove;
        mouseUpRef.current = onDragStop;
    };
    return [
        offsetValue,
        onDragStart
    ];
}
var $3e6ccc26cf94ac75$export$2e2bcd8739ae039 = $3e6ccc26cf94ac75$var$useColorDrag;






var $ltGt3 = parcelRequire("ltGt3");
const $8f6a4aac91b4e369$var$Handler = ({ size: size = 'default', color: color, prefixCls: prefixCls })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-handler`, {
            [`${prefixCls}-handler-sm`]: size === 'small'
        }),
        style: {
            backgroundColor: color
        }
    });
};
var $8f6a4aac91b4e369$export$2e2bcd8739ae039 = $8f6a4aac91b4e369$var$Handler;



var $ltGt3 = parcelRequire("ltGt3");
const $5a9233ec72dda015$var$Palette = ({ children: children, style: style, prefixCls: prefixCls })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: `${prefixCls}-palette`,
        style: {
            position: 'relative',
            ...style
        }
    }, children);
};
var $5a9233ec72dda015$export$2e2bcd8739ae039 = $5a9233ec72dda015$var$Palette;



var $ltGt3 = parcelRequire("ltGt3");
const $d2e4eb2480a0b589$var$Transform = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
    const { children: children, x: x, y: y } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        ref: ref,
        style: {
            position: 'absolute',
            left: `${x}%`,
            top: `${y}%`,
            zIndex: 1,
            transform: 'translate(-50%, -50%)'
        }
    }, children);
});
var $d2e4eb2480a0b589$export$2e2bcd8739ae039 = $d2e4eb2480a0b589$var$Transform;


const $2ba241b591eaf508$var$Picker = ({ color: color, onChange: onChange, prefixCls: prefixCls, onChangeComplete: onChangeComplete, disabled: disabled })=>{
    const pickerRef = (0, $ltGt3.useRef)();
    const transformRef = (0, $ltGt3.useRef)();
    const colorRef = (0, $ltGt3.useRef)(color);
    const onDragChange = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((offsetValue)=>{
        const calcColor = (0, $7d542ccee1228c13$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: pickerRef,
            color: color
        });
        colorRef.current = calcColor;
        onChange(calcColor);
    });
    const [offset, dragStartHandle] = (0, $3e6ccc26cf94ac75$export$2e2bcd8739ae039)({
        color: color,
        containerRef: pickerRef,
        targetRef: transformRef,
        calculate: ()=>(0, $7d542ccee1228c13$export$20165527867cbf14)(color),
        onDragChange: onDragChange,
        onDragChangeComplete: ()=>onChangeComplete?.(colorRef.current),
        disabledDrag: disabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        ref: pickerRef,
        className: `${prefixCls}-select`,
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $5a9233ec72dda015$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $d2e4eb2480a0b589$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $8f6a4aac91b4e369$export$2e2bcd8739ae039), {
        color: color.toRgbString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: `${prefixCls}-saturation`,
        style: {
            backgroundColor: `hsl(${color.toHsb().h},100%, 50%)`,
            backgroundImage: 'linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))'
        }
    })));
};
var $2ba241b591eaf508$export$2e2bcd8739ae039 = $2ba241b591eaf508$var$Picker;




var $ltGt3 = parcelRequire("ltGt3");

const $72e2ab4136e7831b$var$useColorState = (defaultValue, value)=>{
    const [mergedValue, setValue] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultValue, value);
    const color = (0, $ltGt3.useMemo)(()=>(0, $7d542ccee1228c13$export$c844f5d21427d1ab)(mergedValue), [
        mergedValue
    ]);
    return [
        color,
        setValue
    ];
};
var $72e2ab4136e7831b$export$2e2bcd8739ae039 = $72e2ab4136e7831b$var$useColorState;



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");







var $ltGt3 = parcelRequire("ltGt3");


const $57b5e437b928548d$var$Gradient = ({ colors: colors, children: children, direction: direction = 'to right', type: type, prefixCls: prefixCls })=>{
    const gradientColors = (0, $ltGt3.useMemo)(()=>colors.map((color, idx)=>{
            let result = (0, $7d542ccee1228c13$export$c844f5d21427d1ab)(color);
            if (type === 'alpha' && idx === colors.length - 1) result = new (0, $8b1eacdaa2bcd088$export$892596cec99bc70e)(result.setA(1));
            return result.toRgbString();
        }).join(','), [
        colors,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: `${prefixCls}-gradient`,
        style: {
            position: 'absolute',
            inset: 0,
            background: `linear-gradient(${direction}, ${gradientColors})`
        }
    }, children);
};
var $57b5e437b928548d$export$2e2bcd8739ae039 = $57b5e437b928548d$var$Gradient;




const $9a61e5e9aa4a8918$var$Slider = (props)=>{
    const { prefixCls: prefixCls, colors: colors, disabled: disabled, onChange: onChange, onChangeComplete: onChangeComplete, color: color, type: type } = props;
    const sliderRef = (0, $ltGt3.useRef)();
    const transformRef = (0, $ltGt3.useRef)();
    const colorRef = (0, $ltGt3.useRef)(color);
    const getValue = (c)=>{
        return type === 'hue' ? c.getHue() : c.a * 100;
    };
    const onDragChange = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((offsetValue)=>{
        const calcColor = (0, $7d542ccee1228c13$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: sliderRef,
            color: color,
            type: type
        });
        colorRef.current = calcColor;
        onChange(getValue(calcColor));
    });
    const [offset, dragStartHandle] = (0, $3e6ccc26cf94ac75$export$2e2bcd8739ae039)({
        color: color,
        targetRef: transformRef,
        containerRef: sliderRef,
        calculate: ()=>(0, $7d542ccee1228c13$export$20165527867cbf14)(color, type),
        onDragChange: onDragChange,
        onDragChangeComplete () {
            onChangeComplete(getValue(colorRef.current));
        },
        direction: 'x',
        disabledDrag: disabled
    });
    const handleColor = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        if (type === 'hue') {
            const hsb = color.toHsb();
            hsb.s = 1;
            hsb.b = 1;
            hsb.a = 1;
            const lightColor = new (0, $8b1eacdaa2bcd088$export$892596cec99bc70e)(hsb);
            return lightColor;
        }
        return color;
    }, [
        color,
        type
    ]);
    // ========================= Gradient =========================
    const gradientList = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>colors.map((info)=>`${info.color} ${info.percent}%`), [
        colors
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        ref: sliderRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-slider`, `${prefixCls}-slider-${type}`),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $5a9233ec72dda015$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $d2e4eb2480a0b589$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $8f6a4aac91b4e369$export$2e2bcd8739ae039), {
        size: "small",
        color: handleColor.toHexString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $57b5e437b928548d$export$2e2bcd8739ae039), {
        colors: gradientList,
        type: type,
        prefixCls: prefixCls
    })));
};
var $9a61e5e9aa4a8918$export$2e2bcd8739ae039 = $9a61e5e9aa4a8918$var$Slider;


function $0f44a1511e6fbe1c$export$2e2bcd8739ae039(components) {
    return $ltGt3.useMemo(()=>{
        const { slider: slider } = components || {};
        return [
            slider || (0, $9a61e5e9aa4a8918$export$2e2bcd8739ae039)
        ];
    }, [
        components
    ]);
}


function $e9d240750af8a44f$var$_extends() {
    $e9d240750af8a44f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e9d240750af8a44f$var$_extends.apply(this, arguments);
}
const $e9d240750af8a44f$var$HUE_COLORS = [
    {
        color: 'rgb(255, 0, 0)',
        percent: 0
    },
    {
        color: 'rgb(255, 255, 0)',
        percent: 17
    },
    {
        color: 'rgb(0, 255, 0)',
        percent: 33
    },
    {
        color: 'rgb(0, 255, 255)',
        percent: 50
    },
    {
        color: 'rgb(0, 0, 255)',
        percent: 67
    },
    {
        color: 'rgb(255, 0, 255)',
        percent: 83
    },
    {
        color: 'rgb(255, 0, 0)',
        percent: 100
    }
];
const $e9d240750af8a44f$var$ColorPicker = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
    const { value: value, defaultValue: defaultValue, prefixCls: prefixCls = (0, $7d542ccee1228c13$export$90004e2badfbdf1f), onChange: onChange, onChangeComplete: onChangeComplete, className: className, style: style, panelRender: panelRender, disabledAlpha: disabledAlpha = false, disabled: disabled = false, components: components } = props;
    // ========================== Components ==========================
    const [Slider] = (0, $0f44a1511e6fbe1c$export$2e2bcd8739ae039)(components);
    // ============================ Color =============================
    const [colorValue, setColorValue] = (0, $72e2ab4136e7831b$export$2e2bcd8739ae039)(defaultValue || (0, $7d542ccee1228c13$export$f705f0fde43a55a), value);
    const alphaColor = (0, $ltGt3.useMemo)(()=>colorValue.setA(1).toRgbString(), [
        colorValue
    ]);
    // ============================ Events ============================
    const handleChange = (data, type)=>{
        if (!value) setColorValue(data);
        onChange?.(data, type);
    };
    // Convert
    const getHueColor = (hue)=>new (0, $8b1eacdaa2bcd088$export$892596cec99bc70e)(colorValue.setHue(hue));
    const getAlphaColor = (alpha)=>new (0, $8b1eacdaa2bcd088$export$892596cec99bc70e)(colorValue.setA(alpha / 100));
    // Slider change
    const onHueChange = (hue)=>{
        handleChange(getHueColor(hue), {
            type: 'hue',
            value: hue
        });
    };
    const onAlphaChange = (alpha)=>{
        handleChange(getAlphaColor(alpha), {
            type: 'alpha',
            value: alpha
        });
    };
    // Complete
    const onHueChangeComplete = (hue)=>{
        if (onChangeComplete) onChangeComplete(getHueColor(hue));
    };
    const onAlphaChangeComplete = (alpha)=>{
        if (onChangeComplete) onChangeComplete(getAlphaColor(alpha));
    };
    // ============================ Render ============================
    const mergeCls = (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-panel`, className, {
        [`${prefixCls}-panel-disabled`]: disabled
    });
    const sharedSliderProps = {
        prefixCls: prefixCls,
        disabled: disabled,
        color: colorValue
    };
    const defaultPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $2ba241b591eaf508$export$2e2bcd8739ae039), $e9d240750af8a44f$var$_extends({
        onChange: handleChange
    }, sharedSliderProps, {
        onChangeComplete: onChangeComplete
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: `${prefixCls}-slider-container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-slider-group`, {
            [`${prefixCls}-slider-group-disabled-alpha`]: disabledAlpha
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(Slider, $e9d240750af8a44f$var$_extends({}, sharedSliderProps, {
        type: "hue",
        colors: $e9d240750af8a44f$var$HUE_COLORS,
        min: 0,
        max: 359,
        value: colorValue.getHue(),
        onChange: onHueChange,
        onChangeComplete: onHueChangeComplete
    })), !disabledAlpha && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(Slider, $e9d240750af8a44f$var$_extends({}, sharedSliderProps, {
        type: "alpha",
        colors: [
            {
                percent: 0,
                color: 'rgba(255, 0, 4, 0)'
            },
            {
                percent: 100,
                color: alphaColor
            }
        ],
        min: 0,
        max: 100,
        value: colorValue.a * 100,
        onChange: onAlphaChange,
        onChangeComplete: onAlphaChangeComplete
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $1e685787d51afb93$export$2e2bcd8739ae039), {
        color: colorValue.toRgbString(),
        prefixCls: prefixCls
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: mergeCls,
        style: style,
        ref: ref
    }, typeof panelRender === 'function' ? panelRender(defaultPanel) : defaultPanel);
});
var $e9d240750af8a44f$export$2e2bcd8739ae039 = $e9d240750af8a44f$var$ColorPicker;






var $c5c4ed306dee483e$export$2e2bcd8739ae039 = (0, $e9d240750af8a44f$export$2e2bcd8739ae039);


const $fdef9a771b8d4d72$export$d0aa8b5e56c9af06 = (value, alpha)=>value?.replace(/[^\w/]/g, '').slice(0, alpha ? 8 : 6) || '';
const $fdef9a771b8d4d72$export$6c90ef703dcfba25 = (value, alpha)=>value ? $fdef9a771b8d4d72$export$d0aa8b5e56c9af06(value, alpha) : '';
let $fdef9a771b8d4d72$export$e8cc8a2e87e145b4 = /*#__PURE__*/ function() {
    function AggregationColor(color) {
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, AggregationColor);
        this.cleared = false;
        // Clone from another AggregationColor
        if (color instanceof AggregationColor) {
            this.metaColor = color.metaColor.clone();
            this.colors = color.colors?.map((info)=>({
                    color: new AggregationColor(info.color),
                    percent: info.percent
                }));
            this.cleared = color.cleared;
            return;
        }
        const isArray = Array.isArray(color);
        if (isArray && color.length) {
            this.colors = color.map(({ color: c, percent: percent })=>({
                    color: new AggregationColor(c),
                    percent: percent
                }));
            this.metaColor = new (0, $8b1eacdaa2bcd088$export$892596cec99bc70e)(this.colors[0].color.metaColor);
        } else this.metaColor = new (0, $8b1eacdaa2bcd088$export$892596cec99bc70e)(isArray ? '' : color);
        if (!color || isArray && !this.colors) {
            this.metaColor = this.metaColor.setA(0);
            this.cleared = true;
        }
    }
    return (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(AggregationColor, [
        {
            key: "toHsb",
            value: function toHsb() {
                return this.metaColor.toHsb();
            }
        },
        {
            key: "toHsbString",
            value: function toHsbString() {
                return this.metaColor.toHsbString();
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return $fdef9a771b8d4d72$export$6c90ef703dcfba25(this.toHexString(), this.metaColor.a < 1);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this.metaColor.toHexString();
            }
        },
        {
            key: "toRgb",
            value: function toRgb() {
                return this.metaColor.toRgb();
            }
        },
        {
            key: "toRgbString",
            value: function toRgbString() {
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "isGradient",
            value: function isGradient() {
                return !!this.colors && !this.cleared;
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return this.colors || [
                    {
                        color: this,
                        percent: 0
                    }
                ];
            }
        },
        {
            key: "toCssString",
            value: function toCssString() {
                const { colors: colors } = this;
                // CSS line-gradient
                if (colors) {
                    const colorsStr = colors.map((c)=>`${c.color.toRgbString()} ${c.percent}%`).join(', ');
                    return `linear-gradient(90deg, ${colorsStr})`;
                }
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "equals",
            value: function equals(color) {
                if (!color || this.isGradient() !== color.isGradient()) return false;
                if (!this.isGradient()) return this.toHexString() === color.toHexString();
                return this.colors.length === color.colors.length && this.colors.every((c, i)=>{
                    const target = color.colors[i];
                    return c.percent === target.percent && c.color.equals(target.color);
                });
            }
        }
    ]);
}();



var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $1c6445eeac3cccf5$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $1c6445eeac3cccf5$export$2e2bcd8739ae039 = $1c6445eeac3cccf5$var$RightOutlined;



function $a9490449fe252e7b$var$_extends() {
    $a9490449fe252e7b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9490449fe252e7b$var$_extends.apply(this, arguments);
}
const $a9490449fe252e7b$var$RightOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $a9490449fe252e7b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $1c6445eeac3cccf5$export$2e2bcd8739ae039)
    }));
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ const $a9490449fe252e7b$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($a9490449fe252e7b$var$RightOutlined);
var $a9490449fe252e7b$export$2e2bcd8739ae039 = $a9490449fe252e7b$var$RefIcon;


function $647338af032ea9a1$export$2e2bcd8739ae039() {
    return $647338af032ea9a1$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $647338af032ea9a1$export$2e2bcd8739ae039.apply(null, arguments);
}






var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");



/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ const $b0616a5421b43292$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        const { keyCode: keyCode } = e;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $b0616a5421b43292$var$KeyCode.F1 && keyCode <= $b0616a5421b43292$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $b0616a5421b43292$var$KeyCode.ALT:
            case $b0616a5421b43292$var$KeyCode.CAPS_LOCK:
            case $b0616a5421b43292$var$KeyCode.CONTEXT_MENU:
            case $b0616a5421b43292$var$KeyCode.CTRL:
            case $b0616a5421b43292$var$KeyCode.DOWN:
            case $b0616a5421b43292$var$KeyCode.END:
            case $b0616a5421b43292$var$KeyCode.ESC:
            case $b0616a5421b43292$var$KeyCode.HOME:
            case $b0616a5421b43292$var$KeyCode.INSERT:
            case $b0616a5421b43292$var$KeyCode.LEFT:
            case $b0616a5421b43292$var$KeyCode.MAC_FF_META:
            case $b0616a5421b43292$var$KeyCode.META:
            case $b0616a5421b43292$var$KeyCode.NUMLOCK:
            case $b0616a5421b43292$var$KeyCode.NUM_CENTER:
            case $b0616a5421b43292$var$KeyCode.PAGE_DOWN:
            case $b0616a5421b43292$var$KeyCode.PAGE_UP:
            case $b0616a5421b43292$var$KeyCode.PAUSE:
            case $b0616a5421b43292$var$KeyCode.PRINT_SCREEN:
            case $b0616a5421b43292$var$KeyCode.RIGHT:
            case $b0616a5421b43292$var$KeyCode.SHIFT:
            case $b0616a5421b43292$var$KeyCode.UP:
            case $b0616a5421b43292$var$KeyCode.WIN_KEY:
            case $b0616a5421b43292$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $b0616a5421b43292$var$KeyCode.ZERO && keyCode <= $b0616a5421b43292$var$KeyCode.NINE) return true;
        if (keyCode >= $b0616a5421b43292$var$KeyCode.NUM_ZERO && keyCode <= $b0616a5421b43292$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $b0616a5421b43292$var$KeyCode.A && keyCode <= $b0616a5421b43292$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $b0616a5421b43292$var$KeyCode.SPACE:
            case $b0616a5421b43292$var$KeyCode.QUESTION_MARK:
            case $b0616a5421b43292$var$KeyCode.NUM_PLUS:
            case $b0616a5421b43292$var$KeyCode.NUM_MINUS:
            case $b0616a5421b43292$var$KeyCode.NUM_PERIOD:
            case $b0616a5421b43292$var$KeyCode.NUM_DIVISION:
            case $b0616a5421b43292$var$KeyCode.SEMICOLON:
            case $b0616a5421b43292$var$KeyCode.DASH:
            case $b0616a5421b43292$var$KeyCode.EQUALS:
            case $b0616a5421b43292$var$KeyCode.COMMA:
            case $b0616a5421b43292$var$KeyCode.PERIOD:
            case $b0616a5421b43292$var$KeyCode.SLASH:
            case $b0616a5421b43292$var$KeyCode.APOSTROPHE:
            case $b0616a5421b43292$var$KeyCode.SINGLE_QUOTE:
            case $b0616a5421b43292$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $b0616a5421b43292$var$KeyCode.BACKSLASH:
            case $b0616a5421b43292$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $b0616a5421b43292$export$2e2bcd8739ae039 = $b0616a5421b43292$var$KeyCode;



var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
const $926044fb28a80c97$var$PanelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, forceRender: forceRender, className: className, style: style, children: children, isActive: isActive, role: role, classNames: customizeClassNames, styles: styles } = props;
    const [rendered, setRendered] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(isActive || forceRender);
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(()=>{
        if (forceRender || isActive) setRendered(true);
    }, [
        forceRender,
        isActive
    ]);
    if (!rendered) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-panel`, {
            [`${prefixCls}-panel-active`]: isActive,
            [`${prefixCls}-panel-inactive`]: !isActive
        }, className),
        style: style,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-body`, customizeClassNames?.body),
        style: styles?.body
    }, children));
});
$926044fb28a80c97$var$PanelContent.displayName = 'PanelContent';
var $926044fb28a80c97$export$2e2bcd8739ae039 = $926044fb28a80c97$var$PanelContent;


const $8c34ccd9bbe86fd9$var$CollapsePanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    const { showArrow: showArrow = true, headerClass: headerClass, isActive: isActive, onItemClick: onItemClick, forceRender: forceRender, className: className, classNames: customizeClassNames = {}, styles: styles = {}, prefixCls: prefixCls, collapsible: collapsible, accordion: accordion, panelKey: panelKey, extra: extra, header: header, expandIcon: expandIcon, openMotion: openMotion, destroyOnHidden: destroyOnHidden, children: children, ...resetProps } = props;
    const disabled = collapsible === 'disabled';
    const ifExtraExist = extra !== null && extra !== undefined && typeof extra !== 'boolean';
    const collapsibleProps = {
        onClick: ()=>{
            onItemClick?.(panelKey);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER || e.which === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER) onItemClick?.(panelKey);
        },
        role: accordion ? 'tab' : 'button',
        ['aria-expanded']: isActive,
        ['aria-disabled']: disabled,
        tabIndex: disabled ? -1 : 0
    };
    // ======================== Icon ========================
    const iconNodeInner = typeof expandIcon === 'function' ? expandIcon(props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("i", {
        className: "arrow"
    });
    const iconNode = iconNodeInner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-expand-icon`, customizeClassNames?.icon),
        style: styles?.icon
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
    const collapsePanelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-item`, {
        [`${prefixCls}-item-active`]: isActive,
        [`${prefixCls}-item-disabled`]: disabled
    }, className);
    const headerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(headerClass, `${prefixCls}-header`, {
        [`${prefixCls}-collapsible-${collapsible}`]: !!collapsible
    }, customizeClassNames?.header);
    // ======================== HeaderProps ========================
    const headerProps = {
        className: headerClassName,
        style: styles?.header,
        ...[
            'header',
            'icon'
        ].includes(collapsible) ? {} : collapsibleProps
    };
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, resetProps, {
        ref: ref,
        className: collapsePanelClassNames
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", headerProps, showArrow && iconNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-title`, customizeClassNames?.title),
        style: styles?.title
    }, collapsible === 'header' ? collapsibleProps : {}), header), ifExtraExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: `${prefixCls}-extra`
    }, extra)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
        visible: isActive,
        leavedClassName: `${prefixCls}-panel-hidden`
    }, openMotion, {
        forceRender: forceRender,
        removeOnLeave: destroyOnHidden
    }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $926044fb28a80c97$export$2e2bcd8739ae039), {
            ref: motionRef,
            prefixCls: prefixCls,
            className: motionClassName,
            classNames: customizeClassNames,
            style: motionStyle,
            styles: styles,
            isActive: isActive,
            forceRender: forceRender,
            role: accordion ? 'tabpanel' : undefined
        }, children);
    }));
});
var $8c34ccd9bbe86fd9$export$2e2bcd8739ae039 = $8c34ccd9bbe86fd9$var$CollapsePanel;


const $a00e8cb3074552b5$var$convertItemsToNodes = (items, props)=>{
    const { prefixCls: prefixCls, accordion: accordion, collapsible: collapsible, destroyOnHidden: destroyOnHidden, onItemClick: onItemClick, activeKey: activeKey, openMotion: openMotion, expandIcon: expandIcon, classNames: collapseClassNames, styles: styles } = props;
    return items.map((item, index)=>{
        const { children: children, label: label, key: rawKey, collapsible: rawCollapsible, onItemClick: rawOnItemClick, destroyOnHidden: rawDestroyOnHidden, ...restProps } = item;
        // You may be puzzled why you want to convert them all into strings, me too.
        // Maybe: https://github.com/react-component/collapse/blob/aac303a8b6ff30e35060b4f8fecde6f4556fcbe2/src/Collapse.tsx#L15
        const key = String(rawKey ?? index);
        const mergeCollapsible = rawCollapsible ?? collapsible;
        const mergedDestroyOnHidden = rawDestroyOnHidden ?? destroyOnHidden;
        const handleItemClick = (value)=>{
            if (mergeCollapsible === 'disabled') return;
            onItemClick(value);
            rawOnItemClick?.(value);
        };
        let isActive = false;
        if (accordion) isActive = activeKey[0] === key;
        else isActive = activeKey.indexOf(key) > -1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $8c34ccd9bbe86fd9$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, restProps, {
            classNames: collapseClassNames,
            styles: styles,
            prefixCls: prefixCls,
            key: key,
            panelKey: key,
            isActive: isActive,
            accordion: accordion,
            openMotion: openMotion,
            expandIcon: expandIcon,
            header: label,
            collapsible: mergeCollapsible,
            onItemClick: handleItemClick,
            destroyOnHidden: mergedDestroyOnHidden
        }), children);
    });
};
/**
 * @deprecated The next major version will be removed
 */ const $a00e8cb3074552b5$var$getNewChild = (child, index, props)=>{
    if (!child) return null;
    const { prefixCls: prefixCls, accordion: accordion, collapsible: collapsible, destroyOnHidden: destroyOnHidden, onItemClick: onItemClick, activeKey: activeKey, openMotion: openMotion, expandIcon: expandIcon, classNames: collapseClassNames, styles: styles } = props;
    const key = child.key || String(index);
    const { header: header, headerClass: headerClass, destroyOnHidden: childDestroyOnHidden, collapsible: childCollapsible, onItemClick: childOnItemClick } = child.props;
    let isActive = false;
    if (accordion) isActive = activeKey[0] === key;
    else isActive = activeKey.indexOf(key) > -1;
    const mergeCollapsible = childCollapsible ?? collapsible;
    const handleItemClick = (value)=>{
        if (mergeCollapsible === 'disabled') return;
        onItemClick(value);
        childOnItemClick?.(value);
    };
    const childProps = {
        key: key,
        panelKey: key,
        header: header,
        headerClass: headerClass,
        classNames: collapseClassNames,
        styles: styles,
        isActive: isActive,
        prefixCls: prefixCls,
        destroyOnHidden: childDestroyOnHidden ?? destroyOnHidden,
        openMotion: openMotion,
        accordion: accordion,
        children: child.props.children,
        onItemClick: handleItemClick,
        expandIcon: expandIcon,
        collapsible: mergeCollapsible
    };
    // https://github.com/ant-design/ant-design/issues/20479
    if (typeof child.type === 'string') return child;
    Object.keys(childProps).forEach((propName)=>{
        if (typeof childProps[propName] === 'undefined') delete childProps[propName];
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(child, childProps);
};
function $a00e8cb3074552b5$var$useItems(items, rawChildren, props) {
    if (Array.isArray(items)) return $a00e8cb3074552b5$var$convertItemsToNodes(items, props);
    return (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(rawChildren).map((child, index)=>$a00e8cb3074552b5$var$getNewChild(child, index, props));
}
var $a00e8cb3074552b5$export$2e2bcd8739ae039 = $a00e8cb3074552b5$var$useItems;



const $297f85de79f8d325$var$attributes = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`;
const $297f85de79f8d325$var$eventsName = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`;
const $297f85de79f8d325$var$propList = `${$297f85de79f8d325$var$attributes} ${$297f85de79f8d325$var$eventsName}`.split(/[\s\n]+/);
/* eslint-enable max-len */ const $297f85de79f8d325$var$ariaPrefix = 'aria-';
const $297f85de79f8d325$var$dataPrefix = 'data-';
function $297f85de79f8d325$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $297f85de79f8d325$export$2e2bcd8739ae039(props, ariaOnly = false) {
    let mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = {
        ...ariaOnly
    };
    const attrs = {};
    Object.keys(props).forEach((key)=>{
        if (// Aria
        mergedConfig.aria && (key === 'role' || $297f85de79f8d325$var$match(key, $297f85de79f8d325$var$ariaPrefix)) || // Data
        mergedConfig.data && $297f85de79f8d325$var$match(key, $297f85de79f8d325$var$dataPrefix) || // Attr
        mergedConfig.attr && $297f85de79f8d325$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}


function $76e3d230589db3ef$var$getActiveKeysArray(activeKey) {
    let currentActiveKey = activeKey;
    if (!Array.isArray(currentActiveKey)) {
        const activeKeyType = typeof currentActiveKey;
        currentActiveKey = activeKeyType === 'number' || activeKeyType === 'string' ? [
            currentActiveKey
        ] : [];
    }
    return currentActiveKey.map((key)=>String(key));
}
const $76e3d230589db3ef$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-collapse', destroyOnHidden: destroyOnHidden = false, style: style, accordion: accordion, className: className, children: children, collapsible: collapsible, openMotion: openMotion, expandIcon: expandIcon, activeKey: rawActiveKey, defaultActiveKey: defaultActiveKey, onChange: onChange, items: items, classNames: customizeClassNames, styles: styles } = props;
    const collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prefixCls, className);
    const [internalActiveKey, setActiveKey] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultActiveKey, rawActiveKey);
    const activeKey = $76e3d230589db3ef$var$getActiveKeysArray(internalActiveKey);
    const triggerActiveKey = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((next)=>{
        const nextKeys = $76e3d230589db3ef$var$getActiveKeysArray(next);
        setActiveKey(nextKeys);
        onChange?.(nextKeys);
    });
    const onItemClick = (key)=>{
        if (accordion) triggerActiveKey(activeKey[0] === key ? [] : [
            key
        ]);
        else triggerActiveKey(activeKey.includes(key) ? activeKey.filter((item)=>item !== key) : [
            ...activeKey,
            key
        ]);
    };
    // ======================== Children ========================
    (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!children, '[rc-collapse] `children` will be removed in next major version. Please use `items` instead.');
    const mergedChildren = (0, $a00e8cb3074552b5$export$2e2bcd8739ae039)(items, children, {
        prefixCls: prefixCls,
        accordion: accordion,
        openMotion: openMotion,
        expandIcon: expandIcon,
        collapsible: collapsible,
        destroyOnHidden: destroyOnHidden,
        onItemClick: onItemClick,
        activeKey: activeKey,
        classNames: customizeClassNames,
        styles: styles
    });
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
        ref: ref,
        className: collapseClassName,
        style: style,
        role: accordion ? 'tablist' : undefined
    }, (0, $297f85de79f8d325$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    })), mergedChildren);
});
var $76e3d230589db3ef$export$2e2bcd8739ae039 = Object.assign($76e3d230589db3ef$var$Collapse, {
    /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */ Panel: (0, $8c34ccd9bbe86fd9$export$2e2bcd8739ae039)
});


var $f51041b43e21addf$export$2e2bcd8739ae039 = (0, $76e3d230589db3ef$export$2e2bcd8739ae039);
const { Panel: $f51041b43e21addf$export$2ddb90ad54e5f587 } = (0, $76e3d230589db3ef$export$2e2bcd8739ae039);






// ================== Collapse Motion ==================
const $32c4c593a0d4aef5$var$getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const $32c4c593a0d4aef5$var$getRealHeight = (node)=>{
    const { scrollHeight: scrollHeight } = node;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
const $32c4c593a0d4aef5$var$getCurrentHeight = (node)=>({
        height: node ? node.offsetHeight : 0
    });
const $32c4c593a0d4aef5$var$skipOpacityTransition = (_, event)=>event?.deadline === true || event.propertyName === 'height';
const $32c4c593a0d4aef5$var$initCollapseMotion = (rootCls = (0, $d13451568443aeb8$export$e4ec87ea71f29b41))=>({
        motionName: `${rootCls}-motion-collapse`,
        onAppearStart: $32c4c593a0d4aef5$var$getCollapsedHeight,
        onEnterStart: $32c4c593a0d4aef5$var$getCollapsedHeight,
        onAppearActive: $32c4c593a0d4aef5$var$getRealHeight,
        onEnterActive: $32c4c593a0d4aef5$var$getRealHeight,
        onLeaveStart: $32c4c593a0d4aef5$var$getCurrentHeight,
        onLeaveActive: $32c4c593a0d4aef5$var$getCollapsedHeight,
        onAppearEnd: $32c4c593a0d4aef5$var$skipOpacityTransition,
        onEnterEnd: $32c4c593a0d4aef5$var$skipOpacityTransition,
        onLeaveEnd: $32c4c593a0d4aef5$var$skipOpacityTransition,
        motionDeadline: 500
    });
const $32c4c593a0d4aef5$var$_SelectPlacements = [
    'bottomLeft',
    'bottomRight',
    'topLeft',
    'topRight'
];
const $32c4c593a0d4aef5$export$27c72201b1d09951 = (rootPrefixCls, motion, transitionName)=>{
    if (transitionName !== undefined) return transitionName;
    return `${rootPrefixCls}-${motion}`;
};
var $32c4c593a0d4aef5$export$2e2bcd8739ae039 = $32c4c593a0d4aef5$var$initCollapseMotion;







var $ltGt3 = parcelRequire("ltGt3");




"use client";
const $a42dde7f146bff57$var$CollapsePanel = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showArrow: showArrow = true } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const collapsePanelClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
        [`${prefixCls}-no-arrow`]: !showArrow
    }, className);
    return /*#__PURE__*/ $ltGt3.createElement((0, $f51041b43e21addf$export$2e2bcd8739ae039).Panel, {
        ref: ref,
        ...props,
        prefixCls: prefixCls,
        className: collapsePanelClassName
    });
});
var $a42dde7f146bff57$export$2e2bcd8739ae039 = $a42dde7f146bff57$var$CollapsePanel;




const $5a999cf2ba92548d$var$genCollapseMotion = (token)=>({
        [token.componentCls]: {
            // For common/openAnimation
            [`${token.antCls}-motion-collapse-legacy`]: {
                overflow: 'hidden',
                '&-active': {
                    transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
                }
            },
            [`${token.antCls}-motion-collapse`]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
            }
        }
    });
var $5a999cf2ba92548d$export$2e2bcd8739ae039 = $5a999cf2ba92548d$var$genCollapseMotion;



const $96ea9978bb26550c$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, contentBg: contentBg, padding: padding, headerBg: headerBg, headerPadding: headerPadding, collapseHeaderPaddingSM: collapseHeaderPaddingSM, collapseHeaderPaddingLG: collapseHeaderPaddingLG, collapsePanelBorderRadius: collapsePanelBorderRadius, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, colorText: colorText, colorTextHeading: colorTextHeading, colorTextDisabled: colorTextDisabled, fontSizeLG: fontSizeLG, lineHeight: lineHeight, lineHeightLG: lineHeightLG, marginSM: marginSM, paddingSM: paddingSM, paddingLG: paddingLG, paddingXS: paddingXS, motionDurationSlow: motionDurationSlow, fontSizeIcon: fontSizeIcon, contentPadding: contentPadding, fontHeight: fontHeight, fontHeightLG: fontHeightLG } = token;
    const borderBase = `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`;
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            backgroundColor: headerBg,
            border: borderBase,
            borderRadius: collapsePanelBorderRadius,
            '&-rtl': {
                direction: 'rtl'
            },
            [`& > ${componentCls}-item`]: {
                borderBottom: borderBase,
                '&:first-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(collapsePanelBorderRadius)} 0 0`
                    }
                },
                '&:last-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                    }
                },
                [`> ${componentCls}-header`]: {
                    position: 'relative',
                    // Compatible with old version of antd, should remove in next version
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                    padding: headerPadding,
                    color: colorTextHeading,
                    lineHeight: lineHeight,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}, visibility 0s`,
                    ...(0, $945cb0d2b7017a11$export$a44db842bcb28231)(token),
                    [`> ${componentCls}-title`]: {
                        flex: 'auto'
                    },
                    // >>>>> Arrow
                    [`${componentCls}-expand-icon`]: {
                        height: fontHeight,
                        display: 'flex',
                        alignItems: 'center',
                        marginInlineEnd: marginSM
                    },
                    [`${componentCls}-arrow`]: {
                        ...(0, $945cb0d2b7017a11$export$171ccda7bc085e59)(),
                        fontSize: fontSizeIcon,
                        // when `transform: rotate()` is applied to icon's root element
                        transition: `transform ${motionDurationSlow}`,
                        // when `transform: rotate()` is applied to icon's child element
                        svg: {
                            transition: `transform ${motionDurationSlow}`
                        }
                    },
                    // >>>>> Text
                    [`${componentCls}-title`]: {
                        marginInlineEnd: 'auto'
                    }
                },
                [`${componentCls}-collapsible-header`]: {
                    cursor: 'default',
                    [`${componentCls}-title`]: {
                        flex: 'none',
                        cursor: 'pointer'
                    },
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                },
                [`${componentCls}-collapsible-icon`]: {
                    cursor: 'unset',
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                }
            },
            [`${componentCls}-panel`]: {
                color: colorText,
                backgroundColor: contentBg,
                borderTop: borderBase,
                [`& > ${componentCls}-body`]: {
                    padding: contentPadding
                },
                '&-hidden': {
                    display: 'none'
                }
            },
            '&-small': {
                [`> ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingSM,
                        paddingInlineStart: paddingXS,
                        [`> ${componentCls}-expand-icon`]: {
                            // Arrow offset
                            marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
                        }
                    },
                    [`> ${componentCls}-panel > ${componentCls}-body`]: {
                        padding: paddingSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-item`]: {
                    fontSize: fontSizeLG,
                    lineHeight: lineHeightLG,
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingLG,
                        paddingInlineStart: padding,
                        [`> ${componentCls}-expand-icon`]: {
                            height: fontHeightLG,
                            // Arrow offset
                            marginInlineStart: token.calc(paddingLG).sub(padding).equal()
                        }
                    },
                    [`> ${componentCls}-panel > ${componentCls}-body`]: {
                        padding: paddingLG
                    }
                }
            },
            [`${componentCls}-item:last-child`]: {
                borderBottom: 0,
                [`> ${componentCls}-panel`]: {
                    borderRadius: `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                }
            },
            [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
                [`
          &,
          & > .arrow
        `]: {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            // ========================== Icon Placement ==========================
            [`&${componentCls}-icon-placement-end`]: {
                [`& > ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        [`${componentCls}-expand-icon`]: {
                            order: 1,
                            marginInlineEnd: 0,
                            marginInlineStart: marginSM
                        }
                    }
                }
            }
        }
    };
};
const $96ea9978bb26550c$var$genArrowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
    return {
        [`${componentCls}-rtl`]: {
            [fixedSelector]: {
                transform: `rotate(180deg)`
            }
        }
    };
};
const $96ea9978bb26550c$var$genBorderlessStyle = (token)=>{
    const { componentCls: componentCls, headerBg: headerBg, borderlessContentPadding: borderlessContentPadding, borderlessContentBg: borderlessContentBg, colorBorder: colorBorder } = token;
    return {
        [`${componentCls}-borderless`]: {
            backgroundColor: headerBg,
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: `1px solid ${colorBorder}`
            },
            [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
                borderRadius: 0
            },
            [`> ${componentCls}-item:last-child`]: {
                borderBottom: 0
            },
            [`> ${componentCls}-item > ${componentCls}-panel`]: {
                backgroundColor: borderlessContentBg,
                borderTop: 0
            },
            [`> ${componentCls}-item > ${componentCls}-panel > ${componentCls}-body`]: {
                padding: borderlessContentPadding
            }
        }
    };
};
const $96ea9978bb26550c$var$genGhostStyle = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    return {
        [`${componentCls}-ghost`]: {
            backgroundColor: 'transparent',
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: 0,
                [`> ${componentCls}-panel`]: {
                    backgroundColor: 'transparent',
                    border: 0,
                    [`> ${componentCls}-body`]: {
                        paddingBlock: paddingSM
                    }
                }
            }
        }
    };
};
const $96ea9978bb26550c$export$9ca1be8807fe0675 = (token)=>({
        headerPadding: `${token.paddingSM}px ${token.padding}px`,
        headerBg: token.colorFillAlter,
        contentPadding: `${token.padding}px 16px`,
        // Fixed Value
        contentBg: token.colorBgContainer,
        borderlessContentPadding: `${token.paddingXXS}px 16px ${token.padding}px`,
        borderlessContentBg: 'transparent'
    });
var $96ea9978bb26550c$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Collapse', (token)=>{
    const collapseToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        collapseHeaderPaddingSM: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingXS)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingSM)}`,
        collapseHeaderPaddingLG: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.padding)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingLG)}`,
        collapsePanelBorderRadius: token.borderRadiusLG
    });
    return [
        $96ea9978bb26550c$export$5ca74f7be820a85(collapseToken),
        $96ea9978bb26550c$var$genBorderlessStyle(collapseToken),
        $96ea9978bb26550c$var$genGhostStyle(collapseToken),
        $96ea9978bb26550c$var$genArrowStyle(collapseToken),
        (0, $5a999cf2ba92548d$export$2e2bcd8739ae039)(collapseToken)
    ];
}, $96ea9978bb26550c$export$9ca1be8807fe0675);


"use client";
const $5e3657bc55b6f04c$var$Collapse = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, expandIcon: contextExpandIcon, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('collapse');
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, bordered: bordered = true, ghost: ghost, size: customizeSize, expandIconPlacement: expandIconPlacement, expandIconPosition: expandIconPosition, children: children, destroyInactivePanel: destroyInactivePanel, destroyOnHidden: destroyOnHidden, expandIcon: expandIcon, classNames: classNames, styles: styles } = props;
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? ctx ?? 'middle');
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [hashId, cssVarCls] = (0, $96ea9978bb26550c$export$2e2bcd8739ae039)(prefixCls);
    const mergedPlacement = expandIconPlacement ?? expandIconPosition ?? 'start';
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: mergedSize,
        bordered: bordered,
        expandIconPlacement: mergedPlacement
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const mergedExpandIcon = expandIcon ?? contextExpandIcon;
    var deprecatedName, newName;
    const renderExpandIcon = $ltGt3.useCallback((panelProps = {})=>{
        const icon = typeof mergedExpandIcon === 'function' ? mergedExpandIcon(panelProps) : /*#__PURE__*/ $ltGt3.createElement((0, $a9490449fe252e7b$export$2e2bcd8739ae039), {
            rotate: panelProps.isActive ? direction === 'rtl' ? -90 : 90 : undefined,
            "aria-label": panelProps.isActive ? 'expanded' : 'collapsed'
        });
        return (0, $66d38239e1a27993$export$e530037191fcd5d7)(icon, ()=>({
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(icon?.props?.className, `${prefixCls}-arrow`)
            }));
    }, [
        mergedExpandIcon,
        prefixCls,
        direction
    ]);
    const collapseClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-icon-placement-${mergedPlacement}`, {
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-ghost`]: !!ghost,
        [`${prefixCls}-${mergedSize}`]: mergedSize !== 'middle'
    }, contextClassName, className, rootClassName, hashId, cssVarCls, mergedClassNames.root);
    const openMotion = $ltGt3.useMemo(()=>({
            ...(0, $32c4c593a0d4aef5$export$2e2bcd8739ae039)(rootPrefixCls),
            motionAppear: false,
            leavedClassName: `${prefixCls}-panel-hidden`
        }), [
        rootPrefixCls,
        prefixCls
    ]);
    const items = $ltGt3.useMemo(()=>{
        if (children) return (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children).map((child)=>child);
        return null;
    }, [
        children
    ]);
    return(/*#__PURE__*/ // @ts-ignore
    $ltGt3.createElement((0, $f51041b43e21addf$export$2e2bcd8739ae039), {
        ref: ref,
        openMotion: openMotion,
        ...(0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(props, [
            'rootClassName'
        ]),
        expandIcon: renderExpandIcon,
        prefixCls: prefixCls,
        className: collapseClassName,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        classNames: mergedClassNames,
        styles: mergedStyles,
        destroyOnHidden: destroyOnHidden ?? destroyInactivePanel
    }, items));
});
var $5e3657bc55b6f04c$export$2e2bcd8739ae039 = Object.assign($5e3657bc55b6f04c$var$Collapse, {
    Panel: (0, $a42dde7f146bff57$export$2e2bcd8739ae039)
});


"use client";
var $f7961d3e6a10fa4b$export$2e2bcd8739ae039 = (0, $5e3657bc55b6f04c$export$2e2bcd8739ae039);







const $7b39b87e9e2a171b$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $fdef9a771b8d4d72$export$e8cc8a2e87e145b4)) return color;
    return new (0, $fdef9a771b8d4d72$export$e8cc8a2e87e145b4)(color);
};
const $7b39b87e9e2a171b$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $7b39b87e9e2a171b$export$3c8ae3c73ab0e52a = (color)=>$7b39b87e9e2a171b$export$8d6531175688484b(color.toHsb().a * 100);
const $7b39b87e9e2a171b$export$f04e5f54cfbb466c = (color, alpha)=>{
    const rgba = color.toRgb();
    // Color from hsb input may get `rgb` is (0/0/0) when `hsb.b` is 0
    // So if rgb is empty, we should get from hsb
    if (!rgba.r && !rgba.g && !rgba.b) {
        const hsba = color.toHsb();
        hsba.a = alpha || 1;
        return $7b39b87e9e2a171b$export$c844f5d21427d1ab(hsba);
    }
    rgba.a = alpha || 1;
    return $7b39b87e9e2a171b$export$c844f5d21427d1ab(rgba);
};
const $7b39b87e9e2a171b$export$9dd6bfe648e14e97 = (colors, percent)=>{
    const filledColors = [
        {
            percent: 0,
            color: colors[0].color
        }
    ].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(colors), [
        {
            percent: 100,
            color: colors[colors.length - 1].color
        }
    ]);
    for(let i = 0; i < filledColors.length - 1; i += 1){
        const startPtg = filledColors[i].percent;
        const endPtg = filledColors[i + 1].percent;
        const startColor = filledColors[i].color;
        const endColor = filledColors[i + 1].color;
        if (startPtg <= percent && percent <= endPtg) {
            const dist = endPtg - startPtg;
            if (dist === 0) return startColor;
            const ratio = (percent - startPtg) / dist * 100;
            const startRcColor = new (0, $8b1eacdaa2bcd088$export$892596cec99bc70e)(startColor);
            const endRcColor = new (0, $8b1eacdaa2bcd088$export$892596cec99bc70e)(endColor);
            return startRcColor.mix(endRcColor, ratio).toRgbString();
        }
    }
    // This will never reach
    /* istanbul ignore next */ return '';
};


"use client";
const $41c95c5c86b3c331$var$genPresetColor = (list)=>list.map((value)=>{
        value.colors = value.colors.map((0, $7b39b87e9e2a171b$export$c844f5d21427d1ab));
        return value;
    });
const $41c95c5c86b3c331$export$6341b37cb79161da = (value, bgColorToken)=>{
    const { r: r, g: g, b: b, a: a } = value.toRgb();
    const hsv = new (0, $8b1eacdaa2bcd088$export$892596cec99bc70e)(value.toRgbString()).onBackground(bgColorToken).toHsv();
    if (a <= 0.5) // Adapted to dark mode
    return hsv.v > 0.5;
    return r * 0.299 + g * 0.587 + b * 0.114 > 192;
};
const $41c95c5c86b3c331$var$genCollapsePanelKey = (preset, index)=>{
    const mergedKey = preset.key ?? index;
    return `panel-${mergedKey}`;
};
const $41c95c5c86b3c331$var$ColorPresets = ({ prefixCls: prefixCls, presets: presets, value: color, onChange: onChange })=>{
    const [locale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('ColorPicker');
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const presetsValue = (0, $ltGt3.useMemo)(()=>$41c95c5c86b3c331$var$genPresetColor(presets), [
        presets
    ]);
    const colorPresetsPrefixCls = `${prefixCls}-presets`;
    const activeKeys = (0, $ltGt3.useMemo)(()=>presetsValue.reduce((acc, preset, index)=>{
            const { defaultOpen: defaultOpen = true } = preset;
            if (defaultOpen) acc.push($41c95c5c86b3c331$var$genCollapsePanelKey(preset, index));
            return acc;
        }, []), [
        presetsValue
    ]);
    const handleClick = (colorValue)=>{
        onChange?.(colorValue);
    };
    const items = presetsValue.map((preset, index)=>({
            key: $41c95c5c86b3c331$var$genCollapsePanelKey(preset, index),
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
                className: `${colorPresetsPrefixCls}-label`
            }, preset?.label),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
                className: `${colorPresetsPrefixCls}-items`
            }, Array.isArray(preset?.colors) && preset.colors?.length > 0 ? preset.colors.map((presetColor, index)=>{
                const colorInst = (0, $7b39b87e9e2a171b$export$c844f5d21427d1ab)(presetColor);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $1e685787d51afb93$export$2e2bcd8739ae039), {
                    // eslint-disable-next-line react/no-array-index-key
                    key: `preset-${index}-${presetColor.toHexString()}`,
                    color: colorInst.toCssString(),
                    prefixCls: prefixCls,
                    className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${colorPresetsPrefixCls}-color`, {
                        [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toCssString() === color?.toCssString(),
                        [`${colorPresetsPrefixCls}-color-bright`]: $41c95c5c86b3c331$export$6341b37cb79161da(presetColor, token.colorBgElevated)
                    }),
                    onClick: ()=>handleClick(presetColor)
                });
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
                className: `${colorPresetsPrefixCls}-empty`
            }, locale.presetEmpty))
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: colorPresetsPrefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $f7961d3e6a10fa4b$export$2e2bcd8739ae039), {
        defaultActiveKey: activeKeys,
        ghost: true,
        items: items
    }));
};
var $41c95c5c86b3c331$export$2e2bcd8739ae039 = $41c95c5c86b3c331$var$ColorPresets;





const $cc3be3e591e49378$export$362fb92a8f81bbf9 = (token)=>{
    const { paddingInline: paddingInline, onlyIconSize: onlyIconSize, borderColorDisabled: borderColorDisabled } = token;
    const buttonToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: 0,
        buttonIconOnlyFontSize: onlyIconSize,
        colorBorderDisabled: borderColorDisabled
    });
    return buttonToken;
};
const $cc3be3e591e49378$export$9ca1be8807fe0675 = (token)=>{
    const contentFontSize = token.contentFontSize ?? token.fontSize;
    const contentFontSizeSM = token.contentFontSizeSM ?? token.fontSize;
    const contentFontSizeLG = token.contentFontSizeLG ?? token.fontSizeLG;
    const contentLineHeight = token.contentLineHeight ?? (0, $5240a85e491ca83a$export$56204a27a2958a55)(contentFontSize);
    const contentLineHeightSM = token.contentLineHeightSM ?? (0, $5240a85e491ca83a$export$56204a27a2958a55)(contentFontSizeSM);
    const contentLineHeightLG = token.contentLineHeightLG ?? (0, $5240a85e491ca83a$export$56204a27a2958a55)(contentFontSizeLG);
    const solidTextColor = (0, $41c95c5c86b3c331$export$6341b37cb79161da)(new (0, $fdef9a771b8d4d72$export$e8cc8a2e87e145b4)(token.colorBgSolid), '#fff') ? '#000' : '#fff';
    const shadowColorTokens = (0, $e1e3919c46d634bc$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>({
            ...prev,
            [`${colorKey}ShadowColor`]: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.controlOutlineWidth)} 0 ${(0, $064c376cd2d0e87b$export$2e2bcd8739ae039)(token[`${colorKey}1`], token.colorBgContainer)}`
        }), {});
    const defaultBgDisabled = token.colorBgContainerDisabled;
    const dashedBgDisabled = token.colorBgContainerDisabled;
    return {
        ...shadowColorTokens,
        fontWeight: 400,
        iconGap: token.marginXS,
        defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
        primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
        dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorderDisabled,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: 'transparent',
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        onlyIconSize: 'inherit',
        onlyIconSizeSM: 'inherit',
        onlyIconSizeLG: 'inherit',
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: 'transparent',
        textTextColor: token.colorText,
        textTextHoverColor: token.colorText,
        textTextActiveColor: token.colorText,
        textHoverBg: token.colorFillTertiary,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        defaultHoverBg: token.colorBgContainer,
        defaultHoverColor: token.colorPrimaryHover,
        defaultHoverBorderColor: token.colorPrimaryHover,
        defaultActiveBg: token.colorBgContainer,
        defaultActiveColor: token.colorPrimaryActive,
        defaultActiveBorderColor: token.colorPrimaryActive,
        solidTextColor: solidTextColor,
        contentFontSize: contentFontSize,
        contentFontSizeSM: contentFontSizeSM,
        contentFontSizeLG: contentFontSizeLG,
        contentLineHeight: contentLineHeight,
        contentLineHeightSM: contentLineHeightSM,
        contentLineHeightLG: contentLineHeightLG,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0),
        defaultBgDisabled: defaultBgDisabled,
        dashedBgDisabled: dashedBgDisabled
    };
};




const $40740242cffb8829$var$genVariantStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    // Default: '--ant-btn-'
    const getCssVar = (0, $2acdd5777733fef1$export$d82b8f66c5649e14)(antCls, 'btn');
    return {
        [componentCls]: [
            // ==============================================================
            // ==                         Variable                         ==
            // ==============================================================
            {
                // Border
                [getCssVar('border-width')]: '1px',
                [getCssVar('border-color')]: '#000',
                [getCssVar('border-color-hover')]: `var(${getCssVar('border-color')})`,
                [getCssVar('border-color-active')]: `var(${getCssVar('border-color')})`,
                [getCssVar('border-color-disabled')]: `var(${getCssVar('border-color')})`,
                [getCssVar('border-style')]: 'solid',
                // Text
                [getCssVar('text-color')]: '#000',
                [getCssVar('text-color-hover')]: `var(${getCssVar('text-color')})`,
                [getCssVar('text-color-active')]: `var(${getCssVar('text-color')})`,
                [getCssVar('text-color-disabled')]: `var(${getCssVar('text-color')})`,
                // Background
                [getCssVar('bg-color')]: '#ddd',
                [getCssVar('bg-color-hover')]: `var(${getCssVar('bg-color')})`,
                [getCssVar('bg-color-active')]: `var(${getCssVar('bg-color')})`,
                [getCssVar('bg-color-disabled')]: token.colorBgContainerDisabled,
                [getCssVar('bg-color-container')]: token.colorBgContainer,
                // Shadow
                [getCssVar('shadow')]: 'none'
            },
            // ==============================================================
            // ==                         Template                         ==
            // ==============================================================
            {
                // Basic
                border: `var(${getCssVar('border-width')}) var(${getCssVar('border-style')}) var(${getCssVar('border-color')})`,
                color: `var(${getCssVar('text-color')})`,
                backgroundColor: `var(${getCssVar('bg-color')})`,
                // Status
                [`&:not(:disabled):not(${componentCls}-disabled)`]: {
                    // Hover
                    '&:hover': {
                        border: `var(${getCssVar('border-width')}) var(${getCssVar('border-style')}) var(${getCssVar('border-color-hover')})`,
                        color: `var(${getCssVar('text-color-hover')})`,
                        backgroundColor: `var(${getCssVar('bg-color-hover')})`
                    },
                    // Active
                    '&:active': {
                        border: `var(${getCssVar('border-width')}) var(${getCssVar('border-style')}) var(${getCssVar('border-color-active')})`,
                        color: `var(${getCssVar('text-color-active')})`,
                        backgroundColor: `var(${getCssVar('bg-color-active')})`
                    }
                }
            },
            // ==============================================================
            // ==                         Variants                         ==
            // ==============================================================
            {
                // >>>>> Solid
                [`&${componentCls}-variant-solid`]: {
                    // Solid Variables
                    [getCssVar('solid-bg-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('solid-bg-color-hover')]: `var(${getCssVar('color-hover')})`,
                    [getCssVar('solid-bg-color-active')]: `var(${getCssVar('color-active')})`,
                    // Variables
                    [getCssVar('border-color')]: 'transparent',
                    [getCssVar('text-color')]: token.colorTextLightSolid,
                    [getCssVar('bg-color')]: `var(${getCssVar('solid-bg-color')})`,
                    [getCssVar('bg-color-hover')]: `var(${getCssVar('solid-bg-color-hover')})`,
                    [getCssVar('bg-color-active')]: `var(${getCssVar('solid-bg-color-active')})`,
                    // Box Shadow
                    boxShadow: `var(${getCssVar('shadow')})`
                },
                // >>>>> Outlined & Dashed
                [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                    [getCssVar('border-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('border-color-hover')]: `var(${getCssVar('color-hover')})`,
                    [getCssVar('border-color-active')]: `var(${getCssVar('color-active')})`,
                    [getCssVar('bg-color')]: `var(${getCssVar('bg-color-container')})`,
                    [getCssVar('text-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('text-color-hover')]: `var(${getCssVar('color-hover')})`,
                    [getCssVar('text-color-active')]: `var(${getCssVar('color-active')})`,
                    // Box Shadow
                    boxShadow: `var(${getCssVar('shadow')})`
                },
                // >>>>> Dashed
                [`&${componentCls}-variant-dashed`]: {
                    [getCssVar('border-style')]: 'dashed',
                    [getCssVar('bg-color-disabled')]: token.dashedBgDisabled
                },
                // >>>>> Filled
                [`&${componentCls}-variant-filled`]: {
                    [getCssVar('border-color')]: 'transparent',
                    [getCssVar('text-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('bg-color')]: `var(${getCssVar('color-light')})`,
                    [getCssVar('bg-color-hover')]: `var(${getCssVar('color-light-hover')})`,
                    [getCssVar('bg-color-active')]: `var(${getCssVar('color-light-active')})`
                },
                // >>>>> Text & Link
                [`&${componentCls}-variant-text, &${componentCls}-variant-link`]: {
                    [getCssVar('border-color')]: 'transparent',
                    [getCssVar('text-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('text-color-hover')]: `var(${getCssVar('color-hover')})`,
                    [getCssVar('text-color-active')]: `var(${getCssVar('color-active')})`,
                    [getCssVar('bg-color')]: 'transparent',
                    [getCssVar('bg-color-hover')]: 'transparent',
                    [getCssVar('bg-color-active')]: 'transparent',
                    [`&:disabled, &${token.componentCls}-disabled`]: {
                        background: 'transparent',
                        borderColor: 'transparent'
                    }
                },
                // >>>>> Text
                [`&${componentCls}-variant-text`]: {
                    [getCssVar('bg-color-hover')]: `var(${getCssVar('color-light')})`,
                    [getCssVar('bg-color-active')]: `var(${getCssVar('color-light-active')})`
                }
            },
            // ==============================================================
            // ==                          Colors                          ==
            // ==============================================================
            {
                // ======================== By Default ========================
                // >>>>> Link
                [`&${componentCls}-variant-link`]: {
                    [getCssVar('color-base')]: token.colorLink,
                    [getCssVar('color-hover')]: token.colorLinkHover,
                    [getCssVar('color-active')]: token.colorLinkActive
                },
                // ======================== Compatible ========================
                // >>>>> Primary
                [`&${componentCls}-color-primary`]: {
                    [getCssVar('color-base')]: token.colorPrimary,
                    [getCssVar('color-hover')]: token.colorPrimaryHover,
                    [getCssVar('color-active')]: token.colorPrimaryActive,
                    [getCssVar('color-light')]: token.colorPrimaryBg,
                    [getCssVar('color-light-hover')]: token.colorPrimaryBgHover,
                    [getCssVar('color-light-active')]: token.colorPrimaryBorder,
                    [getCssVar('shadow')]: token.primaryShadow
                },
                // >>>>> Danger
                [`&${componentCls}-color-dangerous`]: {
                    [getCssVar('color-base')]: token.colorError,
                    [getCssVar('color-hover')]: token.colorErrorHover,
                    [getCssVar('color-active')]: token.colorErrorActive,
                    [getCssVar('color-light')]: token.colorErrorBg,
                    [getCssVar('color-light-hover')]: token.colorErrorBgFilledHover,
                    [getCssVar('color-light-active')]: token.colorErrorBgActive,
                    [getCssVar('shadow')]: token.dangerShadow
                },
                // >>>>> Default
                [`&${componentCls}-color-default`]: {
                    [getCssVar('solid-bg-color')]: token.colorBgSolid,
                    [getCssVar('solid-bg-color-hover')]: token.colorBgSolidHover,
                    [getCssVar('solid-bg-color-active')]: token.colorBgSolidActive,
                    [getCssVar('color-base')]: token.defaultBorderColor,
                    [getCssVar('color-hover')]: token.defaultHoverBorderColor,
                    [getCssVar('color-active')]: token.defaultActiveBorderColor,
                    [getCssVar('color-light')]: token.colorFillTertiary,
                    [getCssVar('color-light-hover')]: token.colorFillSecondary,
                    [getCssVar('color-light-active')]: token.colorFill,
                    [getCssVar('text-color')]: token.colorText,
                    [getCssVar('text-color-hover')]: token.defaultHoverBorderColor,
                    [getCssVar('text-color-active')]: token.defaultActiveBorderColor,
                    [getCssVar('shadow')]: token.defaultShadow,
                    [`&${componentCls}-variant-solid`]: {
                        [getCssVar('text-color')]: token.solidTextColor
                    },
                    [`&${componentCls}-variant-filled, &${componentCls}-variant-text`]: {
                        [getCssVar('text-color-hover')]: `var(${getCssVar('text-color')})`,
                        [getCssVar('text-color-active')]: `var(${getCssVar('text-color')})`
                    },
                    [`&${componentCls}-background-ghost`]: {
                        [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                            [getCssVar('text-color')]: token.defaultGhostColor,
                            [getCssVar('border-color')]: token.defaultGhostBorderColor
                        }
                    }
                }
            },
            // >>>>> Preset Colors
            (0, $e1e3919c46d634bc$export$6d4fe3a00a1811ad).map((colorKey)=>{
                const darkColor = token[`${colorKey}6`];
                const lightColor = token[`${colorKey}1`];
                const hoverColor = token[`${colorKey}5`];
                const lightHoverColor = token[`${colorKey}2`];
                const lightActiveColor = token[`${colorKey}3`];
                const activeColor = token[`${colorKey}7`];
                const shadowColor = token[`${colorKey}ShadowColor`];
                return {
                    [`&${componentCls}-color-${colorKey}`]: {
                        [getCssVar('color-base')]: darkColor,
                        [getCssVar('color-hover')]: hoverColor,
                        [getCssVar('color-active')]: activeColor,
                        [getCssVar('color-light')]: lightColor,
                        [getCssVar('color-light-hover')]: lightHoverColor,
                        [getCssVar('color-light-active')]: lightActiveColor,
                        [getCssVar('shadow')]: shadowColor
                    }
                };
            }),
            // ==============================================================
            // ==                         Disabled                         ==
            // ==============================================================
            {
                // Disabled
                [`&:disabled, &${token.componentCls}-disabled`]: {
                    cursor: 'not-allowed',
                    borderColor: token.colorBorderDisabled,
                    background: `var(${getCssVar('bg-color-disabled')})`,
                    color: token.colorTextDisabled,
                    boxShadow: 'none'
                }
            },
            // ==============================================================
            // ==                          Ghost                           ==
            // ==============================================================
            {
                // Ghost
                [`&${componentCls}-background-ghost`]: {
                    [getCssVar('bg-color')]: 'transparent',
                    [getCssVar('shadow')]: 'none'
                }
            }
        ]
    };
};
var $40740242cffb8829$export$2e2bcd8739ae039 = $40740242cffb8829$var$genVariantStyle;


// ============================== Shared ==============================
const $c4d7b51b79600087$var$genSharedButtonStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontWeight: fontWeight, opacityLoading: opacityLoading, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, iconGap: iconGap, calc: calc } = token;
    return {
        [componentCls]: {
            outline: 'none',
            position: 'relative',
            display: 'inline-flex',
            gap: iconGap,
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: fontWeight,
            whiteSpace: 'nowrap',
            textAlign: 'center',
            backgroundImage: 'none',
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
            userSelect: 'none',
            touchAction: 'manipulation',
            '&:disabled > *': {
                pointerEvents: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/51380
            [`${componentCls}-icon > svg`]: (0, $945cb0d2b7017a11$export$171ccda7bc085e59)(),
            '> a': {
                color: 'currentColor'
            },
            '&:not(:disabled)': (0, $945cb0d2b7017a11$export$a44db842bcb28231)(token),
            [`&${componentCls}-two-chinese-chars::first-letter`]: {
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
                marginInlineEnd: '-0.34em',
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-icon-only`]: {
                paddingInline: 0,
                // make `btn-icon-only` not too narrow
                [`&${componentCls}-compact-item`]: {
                    flex: 'none'
                }
            },
            // Loading
            [`&${componentCls}-loading`]: {
                opacity: opacityLoading,
                cursor: 'default'
            },
            [`${componentCls}-loading-icon`]: {
                transition: [
                    'width',
                    'opacity',
                    'margin'
                ].map((transition)=>`${transition} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
            },
            // iconPlacement
            [`&:not(${componentCls}-icon-end)`]: {
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineEnd: calc(iconGap).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineEnd: 0
                    },
                    '&-leave-start': {
                        marginInlineEnd: 0
                    },
                    '&-leave-active': {
                        marginInlineEnd: calc(iconGap).mul(-1).equal()
                    }
                }
            },
            '&-icon-end': {
                flexDirection: 'row-reverse',
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineStart: calc(iconGap).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineStart: 0
                    },
                    '&-leave-start': {
                        marginInlineStart: 0
                    },
                    '&-leave-active': {
                        marginInlineStart: calc(iconGap).mul(-1).equal()
                    }
                }
            }
        }
    };
};
// ============================== Shape ===============================
const $c4d7b51b79600087$var$genCircleButtonStyle = (token)=>({
        minWidth: token.controlHeight,
        paddingInline: 0,
        borderRadius: '50%'
    });
// =============================== Size ===============================
const $c4d7b51b79600087$var$genButtonStyle = (token, prefixCls = '')=>{
    const { componentCls: componentCls, controlHeight: controlHeight, fontSize: fontSize, borderRadius: borderRadius, buttonPaddingHorizontal: buttonPaddingHorizontal, iconCls: iconCls, buttonPaddingVertical: buttonPaddingVertical, buttonIconOnlyFontSize: buttonIconOnlyFontSize } = token;
    return [
        {
            [prefixCls]: {
                fontSize: fontSize,
                height: controlHeight,
                padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(buttonPaddingVertical)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(buttonPaddingHorizontal)}`,
                borderRadius: borderRadius,
                [`&${componentCls}-icon-only`]: {
                    width: controlHeight,
                    [iconCls]: {
                        fontSize: buttonIconOnlyFontSize
                    }
                }
            }
        },
        // Shape - patch prefixCls again to override solid border radius style
        {
            [`${componentCls}${componentCls}-circle${prefixCls}`]: $c4d7b51b79600087$var$genCircleButtonStyle(token)
        },
        {
            [`${componentCls}${componentCls}-round${prefixCls}`]: {
                borderRadius: token.controlHeight,
                [`&:not(${componentCls}-icon-only)`]: {
                    paddingInline: token.buttonPaddingHorizontal
                }
            }
        }
    ];
};
const $c4d7b51b79600087$var$genSizeBaseButtonStyle = (token)=>{
    const baseToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        fontSize: token.contentFontSize
    });
    return $c4d7b51b79600087$var$genButtonStyle(baseToken, token.componentCls);
};
const $c4d7b51b79600087$var$genSizeSmallButtonStyle = (token)=>{
    const smallToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return $c4d7b51b79600087$var$genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const $c4d7b51b79600087$var$genSizeLargeButtonStyle = (token)=>{
    const largeToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return $c4d7b51b79600087$var$genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const $c4d7b51b79600087$var$genBlockButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            [`&${componentCls}-block`]: {
                width: '100%'
            }
        }
    };
};
var // ============================== Export ==============================
$c4d7b51b79600087$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Button', (token)=>{
    const buttonToken = (0, $cc3be3e591e49378$export$362fb92a8f81bbf9)(token);
    return [
        // Shared
        $c4d7b51b79600087$var$genSharedButtonStyle(buttonToken),
        // Size
        $c4d7b51b79600087$var$genSizeBaseButtonStyle(buttonToken),
        $c4d7b51b79600087$var$genSizeSmallButtonStyle(buttonToken),
        $c4d7b51b79600087$var$genSizeLargeButtonStyle(buttonToken),
        // Block
        $c4d7b51b79600087$var$genBlockButtonStyle(buttonToken),
        // Variant
        (0, $40740242cffb8829$export$2e2bcd8739ae039)(buttonToken),
        // Button Group
        (0, $a4a00f80930a83ce$export$2e2bcd8739ae039)(buttonToken)
    ];
}, (0, $cc3be3e591e49378$export$9ca1be8807fe0675), {
    unitless: {
        fontWeight: true,
        contentLineHeight: true,
        contentLineHeightSM: true,
        contentLineHeightLG: true
    }
});


// handle border collapse
function $f96147db005a8a82$var$compactItemBorder(token, parentCls, options, prefixCls) {
    const { focusElCls: focusElCls, focus: focus, borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? '> *' : '';
    const hoverEffects = [
        'hover',
        focus ? 'focus' : null,
        'active'
    ].filter(Boolean).map((n)=>`&:${n} ${childCombinator}`).join(',');
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        '&-item': {
            [hoverEffects]: {
                zIndex: 3
            },
            ...focusElCls ? {
                [`&${focusElCls}`]: {
                    zIndex: 3
                }
            } : {},
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        }
    };
}
// handle border-radius
function $f96147db005a8a82$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : '';
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function $f96147db005a8a82$export$b1208b23589b4b73(token, options = {
    focus: true
}) {
    const { componentCls: componentCls } = token;
    const { componentCls: customizePrefixCls } = options;
    const mergedComponentCls = customizePrefixCls || componentCls;
    const compactCls = `${mergedComponentCls}-compact`;
    return {
        [compactCls]: {
            ...$f96147db005a8a82$var$compactItemBorder(token, compactCls, options, mergedComponentCls),
            ...$f96147db005a8a82$var$compactItemBorderRadius(mergedComponentCls, compactCls, options)
        }
    };
}


function $55a946fd8da57877$var$compactItemVerticalBorder(token, parentCls, prefixCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        '&-item': {
            '&:hover,&:focus,&:active': {
                zIndex: 3
            },
            '&[disabled]': {
                zIndex: 0
            }
        }
    };
}
function $55a946fd8da57877$var$compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0
            }
        }
    };
}
function $55a946fd8da57877$export$4dc87cb8ebf78ac6(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: {
            ...$55a946fd8da57877$var$compactItemVerticalBorder(token, compactCls, token.componentCls),
            ...$55a946fd8da57877$var$compactItemBorderVerticalRadius(token.componentCls, compactCls)
        }
    };
}




const $adf912b49aee333c$var$genButtonCompactStyle = (token)=>{
    const { componentCls: componentCls, colorPrimaryHover: colorPrimaryHover, lineWidth: lineWidth, calc: calc } = token;
    const insetOffset = calc(lineWidth).mul(-1).equal();
    const getCompactBorderStyle = (vertical)=>{
        const itemCls = `${componentCls}-compact${vertical ? '-vertical' : ''}-item`;
        const selector = `${itemCls}${componentCls}-primary:not([disabled])`;
        return {
            // TODO: Border color transition should be not cover when has color.
            [itemCls]: {
                transition: `none`
            },
            [`${selector} + ${selector}::before`]: {
                position: 'absolute',
                top: vertical ? insetOffset : 0,
                insetInlineStart: vertical ? 0 : insetOffset,
                backgroundColor: colorPrimaryHover,
                content: '""',
                width: vertical ? '100%' : lineWidth,
                height: vertical ? lineWidth : '100%'
            }
        };
    };
    // Special styles for Primary Button
    return {
        ...getCompactBorderStyle(),
        ...getCompactBorderStyle(true)
    };
};
var // ============================== Export ==============================
$adf912b49aee333c$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$1537386bc155ea56)([
    'Button',
    'compact'
], (token)=>{
    const buttonToken = (0, $cc3be3e591e49378$export$362fb92a8f81bbf9)(token);
    return [
        // Space Compact
        (0, $f96147db005a8a82$export$b1208b23589b4b73)(buttonToken),
        (0, $55a946fd8da57877$export$4dc87cb8ebf78ac6)(buttonToken),
        $adf912b49aee333c$var$genButtonCompactStyle(buttonToken)
    ];
}, (0, $cc3be3e591e49378$export$9ca1be8807fe0675));


"use client";
function $230b8e672ca26588$var$getLoadingConfig(loading) {
    if (typeof loading === 'object' && loading) {
        let delay = loading?.delay;
        delay = !Number.isNaN(delay) && typeof delay === 'number' ? delay : 0;
        return {
            loading: delay <= 0,
            delay: delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
const $230b8e672ca26588$var$ButtonTypeMap = {
    default: [
        'default',
        'outlined'
    ],
    primary: [
        'primary',
        'solid'
    ],
    dashed: [
        'default',
        'dashed'
    ],
    // `link` is not a real color but we should compatible with it
    link: [
        'link',
        'link'
    ],
    text: [
        'default',
        'text'
    ]
};
const $230b8e672ca26588$var$InternalCompoundedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    const { _skipSemantic: _skipSemantic, loading: loading = false, prefixCls: customizePrefixCls, color: color, variant: variant, type: type, danger: danger = false, shape: customizeShape, size: customizeSize, disabled: customDisabled, className: className, rootClassName: rootClassName, children: children, icon: icon, iconPosition: iconPosition, iconPlacement: iconPlacement, ghost: ghost = false, block: block = false, htmlType: // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = 'button', classNames: classNames, styles: styles, style: style, autoInsertSpace: autoInsertSpace, autoFocus: autoFocus, ...rest } = props;
    const childNodes = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children);
    // https://github.com/ant-design/ant-design/issues/47605
    // Compatible with original `type` behavior
    const mergedType = type || 'default';
    const { button: button } = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const shape = customizeShape || button?.shape || 'default';
    const [parsedColor, parsedVariant] = (0, $ltGt3.useMemo)(()=>{
        // >>>>> Local
        // Color & Variant
        if (color && variant) return [
            color,
            variant
        ];
        // Sugar syntax
        if (type || danger) {
            const colorVariantPair = $230b8e672ca26588$var$ButtonTypeMap[mergedType] || [];
            if (danger) return [
                'danger',
                colorVariantPair[1]
            ];
            return colorVariantPair;
        }
        // >>> Context fallback
        if (button?.color && button?.variant) return [
            button.color,
            button.variant
        ];
        return [
            'default',
            'outlined'
        ];
    }, [
        color,
        variant,
        type,
        danger,
        button?.color,
        button?.variant,
        mergedType
    ]);
    const [mergedColor, mergedVariant] = (0, $ltGt3.useMemo)(()=>{
        if (ghost && parsedVariant === 'solid') return [
            parsedColor,
            'outlined'
        ];
        return [
            parsedColor,
            parsedVariant
        ];
    }, [
        parsedColor,
        parsedVariant,
        ghost
    ]);
    const isDanger = mergedColor === 'danger';
    const mergedColorText = isDanger ? 'dangerous' : mergedColor;
    const { getPrefixCls: getPrefixCls, direction: direction, autoInsertSpace: contextAutoInsertSpace, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('button');
    const mergedInsertSpace = autoInsertSpace ?? contextAutoInsertSpace ?? true;
    const prefixCls = getPrefixCls('btn', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $c4d7b51b79600087$export$2e2bcd8739ae039)(prefixCls);
    const disabled = (0, $ltGt3.useContext)((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const groupSize = (0, $ltGt3.useContext)((0, $d5ab9674fddc9572$export$ed0cc8bd1f617d6d));
    const loadingOrDelay = (0, $ltGt3.useMemo)(()=>$230b8e672ca26588$var$getLoadingConfig(loading), [
        loading
    ]);
    const [innerLoading, setLoading] = (0, $ltGt3.useState)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, $ltGt3.useState)(false);
    const buttonRef = (0, $ltGt3.useRef)(null);
    const mergedRef = (0, $22ff46e28c8066e1$export$1d1c999670a1285d)(ref, buttonRef);
    const needInserted = childNodes.length === 1 && !icon && !(0, $ea3450de0c6c5939$export$b120bc11c0d9c214)(mergedVariant);
    // ========================= Mount ==========================
    // Record for mount status.
    // This will help to no to show the animation of loading on the first mount.
    const isMountRef = (0, $ltGt3.useRef)(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(()=>{
        isMountRef.current = false;
        return ()=>{
            isMountRef.current = true;
        };
    }, []);
    // ========================= Effect =========================
    // Loading. Should use `useLayoutEffect` to avoid low perf multiple click issue.
    // https://github.com/ant-design/ant-design/issues/51325
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        let delayTimer = null;
        if (loadingOrDelay.delay > 0) delayTimer = setTimeout(()=>{
            delayTimer = null;
            setLoading(true);
        }, loadingOrDelay.delay);
        else setLoading(loadingOrDelay.loading);
        function cleanupTimer() {
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }
        return cleanupTimer;
    }, [
        loadingOrDelay.delay,
        loadingOrDelay.loading
    ]);
    // Two chinese characters check
    (0, $ltGt3.useEffect)(()=>{
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef.current || !mergedInsertSpace) return;
        const buttonText = buttonRef.current.textContent || '';
        if (needInserted && (0, $ea3450de0c6c5939$export$c5dca2bf412dea0d)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    });
    // Auto focus
    (0, $ltGt3.useEffect)(()=>{
        if (autoFocus && buttonRef.current) buttonRef.current.focus();
    }, []);
    // ========================= Events =========================
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useCallback((e)=>{
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        props.onClick?.('href' in props ? e : e);
    }, [
        props.onClick,
        innerLoading,
        mergedDisabled
    ]);
    // ========================== Size ==========================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $8eabd28975be2fa5$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const sizeClassNameMap = {
        large: 'lg',
        small: 'sm',
        middle: undefined
    };
    const sizeFullName = (0, $7bb31c172903861d$export$2e2bcd8739ae039)((ctxSize)=>customizeSize ?? compactSize ?? groupSize ?? ctxSize);
    const sizeCls = sizeFullName ? sizeClassNameMap[sizeFullName] ?? '' : '';
    const iconType = innerLoading ? 'loading' : icon;
    const mergedIconPlacement = iconPlacement ?? iconPosition ?? 'start';
    const linkButtonRestProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(rest, [
        'navigate'
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        type: mergedType,
        color: mergedColor,
        variant: mergedVariant,
        danger: isDanger,
        shape: shape,
        size: sizeFullName,
        disabled: mergedDisabled,
        loading: innerLoading,
        iconPlacement: mergedIconPlacement
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        _skipSemantic ? undefined : contextClassNames,
        classNames
    ], [
        _skipSemantic ? undefined : contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ========================= Render =========================
    const classes = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, hashId, cssVarCls, {
        [`${prefixCls}-${shape}`]: shape !== 'default' && shape !== 'square' && shape,
        // Compatible with versions earlier than 5.21.0
        [`${prefixCls}-${mergedType}`]: mergedType,
        [`${prefixCls}-dangerous`]: danger,
        [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
        [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
        [`${prefixCls}-background-ghost`]: ghost && !(0, $ea3450de0c6c5939$export$b120bc11c0d9c214)(mergedVariant),
        [`${prefixCls}-loading`]: innerLoading,
        [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-icon-end`]: mergedIconPlacement === 'end'
    }, compactItemClassnames, className, rootClassName, contextClassName, mergedClassNames.root);
    const fullStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    const iconSharedProps = {
        className: mergedClassNames.icon,
        style: mergedStyles.icon
    };
    /**
   * Extract icon node
   * If there is a custom icon and not in loading state: show custom icon
   */ const iconWrapperElement = (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $2f56ad87fbaf2282$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            ...iconSharedProps
        }, child);
    const defaultLoadingIconElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $f16e2853fe7524e6$export$2e2bcd8739ae039), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: innerLoading,
        mount: isMountRef.current,
        ...iconSharedProps
    });
    /**
   * Using if-else statements can improve code readability without affecting future expansion.
   */ let iconNode;
    if (icon && !innerLoading) iconNode = iconWrapperElement(icon);
    else if (loading && typeof loading === 'object' && loading.icon) iconNode = iconWrapperElement(loading.icon);
    else iconNode = defaultLoadingIconElement;
    const contentNode = (0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(children) ? (0, $ea3450de0c6c5939$export$b6ee00a7e7908bc)(children, needInserted && mergedInsertSpace, mergedStyles.content, mergedClassNames.content) : null;
    if (linkButtonRestProps.href !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("a", {
        ...linkButtonRestProps,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(classes, {
            [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: fullStyle,
        onClick: handleClick,
        ref: mergedRef,
        tabIndex: mergedDisabled ? -1 : 0,
        "aria-disabled": mergedDisabled
    }, iconNode, contentNode);
    let buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("button", {
        ...rest,
        type: htmlType,
        className: classes,
        style: fullStyle,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: mergedRef
    }, iconNode, contentNode, compactItemClassnames && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $adf912b49aee333c$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
    if (!(0, $ea3450de0c6c5939$export$b120bc11c0d9c214)(mergedVariant)) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $b5f0e609aabb59e2$export$2e2bcd8739ae039), {
        component: "Button",
        disabled: innerLoading
    }, buttonNode);
    return buttonNode;
});
const $230b8e672ca26588$var$Button = $230b8e672ca26588$var$InternalCompoundedButton;
$230b8e672ca26588$var$Button.Group = (0, $d5ab9674fddc9572$export$2e2bcd8739ae039);
$230b8e672ca26588$var$Button.__ANT_BUTTON = true;
var $230b8e672ca26588$export$2e2bcd8739ae039 = $230b8e672ca26588$var$Button;



"use client";
var $f0f3fa344d92230d$export$2e2bcd8739ae039 = (0, $230b8e672ca26588$export$2e2bcd8739ae039);





const $463dc94f0ca244d6$var$getDesignToken = (config)=>{
    const theme = config?.algorithm ? (0, $db382206ce669921$export$2e2bcd8739ae039)(config.algorithm) : (0, $d39bb1bcbe47a548$export$2e2bcd8739ae039);
    const mergedToken = {
        ...(0, $cd7243c61a6df828$export$2e2bcd8739ae039),
        ...config?.token
    };
    return (0, $8cff302f4c2cd4b3$export$18602cb46ae80b62)(mergedToken, {
        override: config?.token
    }, theme, (0, $792d423ebfd5ec4b$export$2e2bcd8739ae039));
};
var $463dc94f0ca244d6$export$2e2bcd8739ae039 = $463dc94f0ca244d6$var$getDesignToken;






function $d5b67793ad02f6e4$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    const compactSizeStep = sizeStep - 2;
    return {
        sizeXXL: sizeUnit * (compactSizeStep + 10),
        sizeXL: sizeUnit * (compactSizeStep + 6),
        sizeLG: sizeUnit * (compactSizeStep + 2),
        sizeMD: sizeUnit * (compactSizeStep + 2),
        sizeMS: sizeUnit * (compactSizeStep + 1),
        size: sizeUnit * compactSizeStep,
        sizeSM: sizeUnit * compactSizeStep,
        sizeXS: sizeUnit * (compactSizeStep - 1),
        sizeXXS: sizeUnit * (compactSizeStep - 1)
    };
}


const $7d4b04a681a3ab3d$var$derivative = (token, mapToken)=>{
    const mergedMapToken = mapToken ?? (0, $51a383b93ff0b6f9$export$2e2bcd8739ae039)(token);
    const fontSize = mergedMapToken.fontSizeSM; // Smaller size font-size as base
    const controlHeight = mergedMapToken.controlHeight - 4;
    return {
        ...mergedMapToken,
        ...(0, $d5b67793ad02f6e4$export$2e2bcd8739ae039)(mapToken ?? token),
        // font
        ...(0, $4f185511e189c842$export$2e2bcd8739ae039)(fontSize),
        controlHeight: // controlHeight
        controlHeight,
        ...(0, $589f08f7fb89b1c5$export$2e2bcd8739ae039)({
            ...mergedMapToken,
            controlHeight: controlHeight
        })
    };
};
var $7d4b04a681a3ab3d$export$2e2bcd8739ae039 = $7d4b04a681a3ab3d$var$derivative;








const $25f2c282f2ad5506$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(baseColor).setA(alpha).toRgbString();
const $25f2c282f2ad5506$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(baseColor);
    return instance.lighten(brightness).toHexString();
};


const $d1ab6f6cd56c65a5$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $5a714eb5c7b9ddd8$export$2e2bcd8739ae039)(baseColor, {
        theme: 'dark'
    });
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[6],
        6: colors[5],
        7: colors[4],
        8: colors[6],
        9: colors[5],
        10: colors[4]
    };
};
const $d1ab6f6cd56c65a5$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || '#000';
    const colorTextBase = textBaseColor || '#fff';
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $25f2c282f2ad5506$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorTextSecondary: (0, $25f2c282f2ad5506$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $25f2c282f2ad5506$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $25f2c282f2ad5506$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $25f2c282f2ad5506$export$31f6399ba7ce6bea)(colorTextBase, 0.18),
        colorFillSecondary: (0, $25f2c282f2ad5506$export$31f6399ba7ce6bea)(colorTextBase, 0.12),
        colorFillTertiary: (0, $25f2c282f2ad5506$export$31f6399ba7ce6bea)(colorTextBase, 0.08),
        colorFillQuaternary: (0, $25f2c282f2ad5506$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorBgSolid: (0, $25f2c282f2ad5506$export$31f6399ba7ce6bea)(colorTextBase, 0.95),
        colorBgSolidHover: (0, $25f2c282f2ad5506$export$31f6399ba7ce6bea)(colorTextBase, 1),
        colorBgSolidActive: (0, $25f2c282f2ad5506$export$31f6399ba7ce6bea)(colorTextBase, 0.9),
        colorBgElevated: (0, $25f2c282f2ad5506$export$7003a8a990e79359)(colorBgBase, 12),
        colorBgContainer: (0, $25f2c282f2ad5506$export$7003a8a990e79359)(colorBgBase, 8),
        colorBgLayout: (0, $25f2c282f2ad5506$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $25f2c282f2ad5506$export$7003a8a990e79359)(colorBgBase, 26),
        colorBgBlur: (0, $25f2c282f2ad5506$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorBorder: (0, $25f2c282f2ad5506$export$7003a8a990e79359)(colorBgBase, 26),
        colorBorderDisabled: (0, $25f2c282f2ad5506$export$7003a8a990e79359)(colorBgBase, 26),
        colorBorderSecondary: (0, $25f2c282f2ad5506$export$7003a8a990e79359)(colorBgBase, 19)
    };
};


const $d94046a876d44be9$var$derivative = (token, mapToken)=>{
    const colorPalettes = Object.keys((0, $cd7243c61a6df828$export$37e27b43af4d16eb)).map((colorKey)=>{
        const colors = (0, $5a714eb5c7b9ddd8$export$2e2bcd8739ae039)(token[colorKey], {
            theme: 'dark'
        });
        return Array.from({
            length: 10
        }, ()=>1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        prev = {
            ...prev,
            ...cur
        };
        return prev;
    }, {});
    const mergedMapToken = mapToken ?? (0, $51a383b93ff0b6f9$export$2e2bcd8739ae039)(token);
    const colorMapToken = (0, $d6cac2b9a1937bee$export$2e2bcd8739ae039)(token, {
        generateColorPalettes: $d1ab6f6cd56c65a5$export$da275153033f4ec1,
        generateNeutralColorPalettes: $d1ab6f6cd56c65a5$export$3e0cb0c1d9c1b691
    });
    return {
        ...mergedMapToken,
        // Dark tokens
        ...colorPalettes,
        // Colors
        ...colorMapToken,
        // Customize selected item background color
        // https://github.com/ant-design/ant-design/issues/30524#issuecomment-871961867
        colorPrimaryBg: colorMapToken.colorPrimaryBorder,
        colorPrimaryBgHover: colorMapToken.colorPrimaryBorderHover
    };
};
var $d94046a876d44be9$export$2e2bcd8739ae039 = $d94046a876d44be9$var$derivative;



"use client";
// ZombieJ: We export as object to user but array in internal.
// This is used to minimize the bundle size for antd package but safe to refactor as object also.
// Please do not export internal `useToken` directly to avoid something export unexpected.
/** Get current context Design Token. Will be different if you are using nest theme config. */ function $dab4aa82f341ad46$var$useToken() {
    const [theme, token, hashId, cssVar] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    return {
        theme: theme,
        token: token,
        hashId: hashId,
        cssVar: cssVar
    };
}
var $dab4aa82f341ad46$export$2e2bcd8739ae039 = {
    /** Default seedToken */ defaultSeed: (0, $d628a3c0642cff3d$export$f84bd70098573c5c).token,
    useToken: $dab4aa82f341ad46$var$useToken,
    defaultAlgorithm: $51a383b93ff0b6f9$export$2e2bcd8739ae039,
    darkAlgorithm: $d94046a876d44be9$export$2e2bcd8739ae039,
    compactAlgorithm: $7d4b04a681a3ab3d$export$2e2bcd8739ae039,
    getDesignToken: $463dc94f0ca244d6$export$2e2bcd8739ae039,
    defaultConfig: /**
   * @private Private variable
   * @warring 🔥 Do not use in production. 🔥
   */ $d628a3c0642cff3d$export$f84bd70098573c5c,
    /**
   * @private Private variable
   * @warring 🔥 Do not use in production. 🔥
   */ _internalContext: (0, $d628a3c0642cff3d$export$69b0ebb9efcddb30)
};


var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $94cc47b542d38284$var$EditOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    "name": "edit",
    "theme": "outlined"
};
var $94cc47b542d38284$export$2e2bcd8739ae039 = $94cc47b542d38284$var$EditOutlined;



function $6ff101c7149aa3d0$var$_extends() {
    $6ff101c7149aa3d0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ff101c7149aa3d0$var$_extends.apply(this, arguments);
}
const $6ff101c7149aa3d0$var$EditOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $6ff101c7149aa3d0$var$_extends({}, props, {
        ref: ref,
        icon: (0, $94cc47b542d38284$export$2e2bcd8739ae039)
    }));
/**![edit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1Ny43IDc1MmMyIDAgNC0uMiA2LS41TDQzMS45IDcyMmMyLS40IDMuOS0xLjMgNS4zLTIuOGw0MjMuOS00MjMuOWE5Ljk2IDkuOTYgMCAwMDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAwOS40IDI5LjhjNi42IDYuNCAxNC45IDkuOSAyMy44IDkuOXptNjcuNC0xNzQuNEw2ODcuOCAyMTVsNzMuMyA3My4zLTM2Mi43IDM2Mi42LTg4LjkgMTUuNyAxNS42LTg5ek04ODAgODM2SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MzZjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTM2YzAtMTcuNy0xNC4zLTMyLTMyLTMyeiIgLz48L3N2Zz4=) */ const $6ff101c7149aa3d0$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($6ff101c7149aa3d0$var$EditOutlined);
var $6ff101c7149aa3d0$export$2e2bcd8739ae039 = $6ff101c7149aa3d0$var$RefIcon;








const $abe1f49eefe140f3$var$isStyleNameSupport = (styleName)=>{
    if ((0, $19612225313d4e36$export$2e2bcd8739ae039)() && window.document.documentElement) {
        const styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        const { documentElement: documentElement } = window.document;
        return styleNameList.some((name)=>name in documentElement.style);
    }
    return false;
};
const $abe1f49eefe140f3$var$isStyleValueSupport = (styleName, value)=>{
    if (!$abe1f49eefe140f3$var$isStyleNameSupport(styleName)) return false;
    const ele = document.createElement('div');
    const origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $abe1f49eefe140f3$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $abe1f49eefe140f3$var$isStyleValueSupport(styleName, styleValue);
    return $abe1f49eefe140f3$var$isStyleNameSupport(styleName);
}





var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
const $57b616b1a2d66246$var$Popup = (props)=>{
    const { children: children, prefixCls: prefixCls, id: id, classNames: classNames, styles: styles, className: className, style: style } = props;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-container`, classNames?.container, className),
        style: {
            ...styles?.container,
            ...style
        },
        role: "tooltip"
    }, typeof children === 'function' ? children() : children);
};
var $57b616b1a2d66246$export$2e2bcd8739ae039 = $57b616b1a2d66246$var$Popup;






var $ltGt3 = parcelRequire("ltGt3");
const $835d2e4f2e3f4797$var$autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
const $835d2e4f2e3f4797$var$autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
const $835d2e4f2e3f4797$var$targetOffset = [
    0,
    0
];
const $835d2e4f2e3f4797$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $835d2e4f2e3f4797$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $835d2e4f2e3f4797$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $835d2e4f2e3f4797$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $835d2e4f2e3f4797$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $835d2e4f2e3f4797$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $835d2e4f2e3f4797$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $835d2e4f2e3f4797$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $835d2e4f2e3f4797$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $835d2e4f2e3f4797$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $835d2e4f2e3f4797$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $835d2e4f2e3f4797$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $835d2e4f2e3f4797$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $835d2e4f2e3f4797$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $835d2e4f2e3f4797$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $835d2e4f2e3f4797$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $835d2e4f2e3f4797$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $835d2e4f2e3f4797$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $835d2e4f2e3f4797$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $835d2e4f2e3f4797$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $835d2e4f2e3f4797$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $835d2e4f2e3f4797$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $835d2e4f2e3f4797$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $835d2e4f2e3f4797$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $835d2e4f2e3f4797$var$targetOffset
    }
};
var $835d2e4f2e3f4797$export$2e2bcd8739ae039 = $835d2e4f2e3f4797$export$803cd8101b6c182b;



function $40230d599720afa3$var$_extends() {
    $40230d599720afa3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $40230d599720afa3$var$_extends.apply(this, arguments);
}
const $40230d599720afa3$var$Tooltip = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { trigger: trigger = [
        'hover'
    ], mouseEnterDelay: mouseEnterDelay = 0, mouseLeaveDelay: mouseLeaveDelay = 0.1, prefixCls: prefixCls = 'rc-tooltip', children: children, onVisibleChange: onVisibleChange, afterVisibleChange: afterVisibleChange, motion: motion, placement: placement = 'right', align: align = {}, destroyOnHidden: destroyOnHidden = false, defaultVisible: defaultVisible, getTooltipContainer: getTooltipContainer, arrowContent: arrowContent, overlay: overlay, id: id, showArrow: showArrow = true, classNames: classNames, styles: styles, ...restProps } = props;
    const mergedId = (0, $1fb03482b73301f3$export$2e2bcd8739ae039)(id);
    const triggerRef = (0, $ltGt3.useRef)(null);
    (0, $ltGt3.useImperativeHandle)(ref, ()=>triggerRef.current);
    const extraProps = {
        ...restProps
    };
    if ('visible' in props) extraProps.popupVisible = props.visible;
    // ========================= Arrow ==========================
    // Process arrow configuration
    const mergedArrow = $ltGt3.useMemo(()=>{
        if (!showArrow) return false;
        // Convert true to object for unified processing
        const arrowConfig = showArrow === true ? {} : showArrow;
        // Apply semantic styles with unified logic
        return {
            ...arrowConfig,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(arrowConfig.className, classNames?.arrow),
            style: {
                ...arrowConfig.style,
                ...styles?.arrow
            },
            content: arrowConfig.content ?? arrowContent
        };
    }, [
        showArrow,
        classNames?.arrow,
        styles?.arrow,
        arrowContent
    ]);
    // ======================== Children ========================
    const getChildren = ()=>{
        const child = $ltGt3.Children.only(children);
        const originalProps = child?.props || {};
        const childProps = {
            ...originalProps,
            'aria-describedby': overlay ? mergedId : null
        };
        return /*#__PURE__*/ $ltGt3.cloneElement(children, childProps);
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $1b29c21fa1aa3a55$export$2e2bcd8739ae039), $40230d599720afa3$var$_extends({
        popupClassName: classNames?.root,
        prefixCls: prefixCls,
        popup: /*#__PURE__*/ $ltGt3.createElement((0, $57b616b1a2d66246$export$2e2bcd8739ae039), {
            key: "content",
            prefixCls: prefixCls,
            id: mergedId,
            classNames: classNames,
            styles: styles
        }, overlay),
        action: trigger,
        builtinPlacements: (0, $835d2e4f2e3f4797$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onOpenChange: onVisibleChange,
        afterOpenChange: afterVisibleChange,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyOnHidden,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: styles?.root,
        mouseEnterDelay: mouseEnterDelay,
        arrow: mergedArrow,
        uniqueContainerClassName: classNames?.uniqueContainer,
        uniqueContainerStyle: styles?.uniqueContainer
    }, extraProps), getChildren());
});
var $40230d599720afa3$export$2e2bcd8739ae039 = $40230d599720afa3$var$Tooltip;


var $7641515d641df2dc$export$2e2bcd8739ae039 = (0, $40230d599720afa3$export$2e2bcd8739ae039);





var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
const $1acae32ef7ef7c71$export$24829b7c0e49e9f7 = 'RC_FORM_INTERNAL_HOOKS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1acae32ef7ef7c71$var$warningFunc = ()=>{
    (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
const $1acae32ef7ef7c71$var$Context = /*#__PURE__*/ $ltGt3.createContext({
    getFieldValue: $1acae32ef7ef7c71$var$warningFunc,
    getFieldsValue: $1acae32ef7ef7c71$var$warningFunc,
    getFieldError: $1acae32ef7ef7c71$var$warningFunc,
    getFieldWarning: $1acae32ef7ef7c71$var$warningFunc,
    getFieldsError: $1acae32ef7ef7c71$var$warningFunc,
    isFieldsTouched: $1acae32ef7ef7c71$var$warningFunc,
    isFieldTouched: $1acae32ef7ef7c71$var$warningFunc,
    isFieldValidating: $1acae32ef7ef7c71$var$warningFunc,
    isFieldsValidating: $1acae32ef7ef7c71$var$warningFunc,
    resetFields: $1acae32ef7ef7c71$var$warningFunc,
    setFields: $1acae32ef7ef7c71$var$warningFunc,
    setFieldValue: $1acae32ef7ef7c71$var$warningFunc,
    setFieldsValue: $1acae32ef7ef7c71$var$warningFunc,
    validateFields: $1acae32ef7ef7c71$var$warningFunc,
    submit: $1acae32ef7ef7c71$var$warningFunc,
    getInternalHooks: ()=>{
        $1acae32ef7ef7c71$var$warningFunc();
        return {
            dispatch: $1acae32ef7ef7c71$var$warningFunc,
            initEntityValue: $1acae32ef7ef7c71$var$warningFunc,
            registerField: $1acae32ef7ef7c71$var$warningFunc,
            useSubscribe: $1acae32ef7ef7c71$var$warningFunc,
            setInitialValues: $1acae32ef7ef7c71$var$warningFunc,
            destroyForm: $1acae32ef7ef7c71$var$warningFunc,
            setCallbacks: $1acae32ef7ef7c71$var$warningFunc,
            registerWatch: $1acae32ef7ef7c71$var$warningFunc,
            getFields: $1acae32ef7ef7c71$var$warningFunc,
            setValidateMessages: $1acae32ef7ef7c71$var$warningFunc,
            setPreserve: $1acae32ef7ef7c71$var$warningFunc,
            getInitialValue: $1acae32ef7ef7c71$var$warningFunc,
            setBatchUpdate: $1acae32ef7ef7c71$var$warningFunc
        };
    }
});
var $1acae32ef7ef7c71$export$2e2bcd8739ae039 = $1acae32ef7ef7c71$var$Context;



var $ltGt3 = parcelRequire("ltGt3");
const $676ce4da8497bef1$var$ListContext = /*#__PURE__*/ $ltGt3.createContext(null);
var $676ce4da8497bef1$export$2e2bcd8739ae039 = $676ce4da8497bef1$var$ListContext;


function $38393154317a30c8$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $38393154317a30c8$export$717b316e73068e8d(form) {
    return form && !!form._init;
}








function $c483a37b034616a0$export$f77fd0c3b25d8534() {
    return {
        default: 'Validation error on field %s',
        required: '%s is required',
        enum: '%s must be one of %s',
        whitespace: '%s cannot be empty',
        date: {
            format: '%s date %s is invalid for format %s',
            parse: '%s date could not be parsed, %s is invalid ',
            invalid: '%s date %s is invalid'
        },
        types: {
            string: '%s is not a %s',
            method: '%s is not a %s (function)',
            array: '%s is not an %s',
            object: '%s is not an %s',
            number: '%s is not a %s',
            date: '%s is not a %s',
            boolean: '%s is not a %s',
            integer: '%s is not an %s',
            float: '%s is not a %s',
            regexp: '%s is not a valid %s',
            email: '%s is not a valid %s',
            url: '%s is not a valid %s',
            hex: '%s is not a valid %s'
        },
        string: {
            len: '%s must be exactly %s characters',
            min: '%s must be at least %s characters',
            max: '%s cannot be longer than %s characters',
            range: '%s must be between %s and %s characters'
        },
        number: {
            len: '%s must equal %s',
            min: '%s cannot be less than %s',
            max: '%s cannot be greater than %s',
            range: '%s must be between %s and %s'
        },
        array: {
            len: '%s must be exactly %s in length',
            min: '%s cannot be less than %s in length',
            max: '%s cannot be greater than %s in length',
            range: '%s must be between %s and %s in length'
        },
        pattern: {
            mismatch: '%s value %s does not match pattern %s'
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $c483a37b034616a0$export$defe85febe8b728c = $c483a37b034616a0$export$f77fd0c3b25d8534();











function $c9113f58609e61d9$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}




function $cf5b5817f68225e8$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $d3a6f09ccec9fd7e$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $b4bc9016f3e318e4$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $35a6b77c9cee3bc8$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $35a6b77c9cee3bc8$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $c9113f58609e61d9$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $cf5b5817f68225e8$export$2e2bcd8739ae039)(t, arguments, (0, $842b6e0da6891434$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $b4bc9016f3e318e4$export$2e2bcd8739ae039)(Wrapper, t);
    }, $35a6b77c9cee3bc8$export$2e2bcd8739ae039(t);
}




/* eslint no-console:0 */ var $2f87921a30a93974$var$formatRegExp = /%[sdj%]/g;
var $2f87921a30a93974$export$491112666e282270 = function warning() {};
function $2f87921a30a93974$export$e85887f5ceeacced(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $2f87921a30a93974$export$d9468344d3651243(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === 'function') // eslint-disable-next-line prefer-spread
    return template.apply(null, args);
    if (typeof template === 'string') {
        var str = template.replace($2f87921a30a93974$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $2f87921a30a93974$var$isNativeStringType(type) {
    return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}
function $2f87921a30a93974$export$141eca273a04dc3e(value, type) {
    if (value === undefined || value === null) return true;
    if (type === 'array' && Array.isArray(value) && !value.length) return true;
    if ($2f87921a30a93974$var$isNativeStringType(type) && typeof value === 'string' && !value) return true;
    return false;
}
function $2f87921a30a93974$export$83b788b1a3698c03(obj) {
    return Object.keys(obj).length === 0;
}
function $2f87921a30a93974$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, (0, $83d01b7684a01087$export$2e2bcd8739ae039)(errors || []));
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $2f87921a30a93974$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $2f87921a30a93974$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, (0, $83d01b7684a01087$export$2e2bcd8739ae039)(objArr[k] || []));
    });
    return ret;
}
var $2f87921a30a93974$export$188f48b73534b6f0 = /*#__PURE__*/ function(_Error) {
    (0, $56605f2979837676$export$2e2bcd8739ae039)(AsyncValidationError, _Error);
    var _super = (0, $784fa0189d62810b$export$2e2bcd8739ae039)(AsyncValidationError);
    function AsyncValidationError(errors, fields) {
        var _this;
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, AsyncValidationError);
        _this = _super.call(this, 'Async Validation Error');
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $b9857b0719ab1f8f$export$2e2bcd8739ae039)(_this), "errors", void 0);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $b9857b0719ab1f8f$export$2e2bcd8739ae039)(_this), "fields", void 0);
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(AsyncValidationError);
}(/*#__PURE__*/ (0, $35a6b77c9cee3bc8$export$2e2bcd8739ae039)(Error));
function $2f87921a30a93974$export$707ee4c4c95d39e3(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $2f87921a30a93974$export$188f48b73534b6f0(errors, $2f87921a30a93974$export$e85887f5ceeacced(errors))) : resolve(source);
            };
            var flattenArr = $2f87921a30a93974$var$flattenObjArr(objArr);
            $2f87921a30a93974$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending.catch(function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            // eslint-disable-next-line prefer-spread
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $2f87921a30a93974$export$188f48b73534b6f0(results, $2f87921a30a93974$export$e85887f5ceeacced(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $2f87921a30a93974$var$asyncSerialArray(arr, func, next);
            else $2f87921a30a93974$var$asyncParallelArray(arr, func, next);
        });
    });
    pending.catch(function(e) {
        return e;
    });
    return pending;
}
function $2f87921a30a93974$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $2f87921a30a93974$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $2f87921a30a93974$export$34d5fe50d2616cee(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $2f87921a30a93974$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($2f87921a30a93974$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === 'function' ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $2f87921a30a93974$export$6969335ea1e4e77c(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if ((0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(value) === 'object' && (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(target[s]) === 'object') target[s] = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, target[s]), value);
            else target[s] = value;
        }
    }
    return target;
}



var $3b1e77a067155847$var$ENUM = 'enum';
var $3b1e77a067155847$var$enumerable = function enumerable(rule, value, source, errors, options) {
    rule[$3b1e77a067155847$var$ENUM] = Array.isArray(rule[$3b1e77a067155847$var$ENUM]) ? rule[$3b1e77a067155847$var$ENUM] : [];
    if (rule[$3b1e77a067155847$var$ENUM].indexOf(value) === -1) errors.push((0, $2f87921a30a93974$export$d9468344d3651243)(options.messages[$3b1e77a067155847$var$ENUM], rule.fullField, rule[$3b1e77a067155847$var$ENUM].join(', ')));
};
var $3b1e77a067155847$export$2e2bcd8739ae039 = $3b1e77a067155847$var$enumerable;



var $ace56d82c9e18bbb$var$pattern = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push((0, $2f87921a30a93974$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === 'string') {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push((0, $2f87921a30a93974$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $ace56d82c9e18bbb$export$2e2bcd8739ae039 = $ace56d82c9e18bbb$var$pattern;



var $c06167b4e619e03a$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === 'number';
    var min = typeof rule.min === 'number';
    var max = typeof rule.max === 'number';
    // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === 'number';
    var str = typeof value === 'string';
    var arr = Array.isArray(value);
    if (num) key = 'number';
    else if (str) key = 'string';
    else if (arr) key = 'array';
    // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".length !== 3
    val = value.replace(spRegexp, '_').length;
    if (len) {
        if (val !== rule.len) errors.push((0, $2f87921a30a93974$export$d9468344d3651243)(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push((0, $2f87921a30a93974$export$d9468344d3651243)(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push((0, $2f87921a30a93974$export$d9468344d3651243)(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push((0, $2f87921a30a93974$export$d9468344d3651243)(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $c06167b4e619e03a$export$2e2bcd8739ae039 = $c06167b4e619e03a$var$range;



var $4f3a13873dbc1810$var$required = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || (0, $2f87921a30a93974$export$141eca273a04dc3e)(value, type || rule.type))) errors.push((0, $2f87921a30a93974$export$d9468344d3651243)(options.messages.required, rule.fullField));
};
var $4f3a13873dbc1810$export$2e2bcd8739ae039 = $4f3a13873dbc1810$var$required;





// https://github.com/kevva/url-regex/blob/master/index.js
var $8c73e5dfb6e858d0$var$urlReg;
var $8c73e5dfb6e858d0$export$2e2bcd8739ae039 = function() {
    if ($8c73e5dfb6e858d0$var$urlReg) return $8c73e5dfb6e858d0$var$urlReg;
    var word = '[a-fA-F\\d:]';
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : '';
    };
    var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
    var v6seg = '[a-fA-F\\d]{1,4}';
    var v6List = [
        "(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){5}(?::").concat(v4, "|(?::").concat(v6seg, "){1,2}|:)"),
        "(?:".concat(v6seg, ":){4}(?:(?::").concat(v6seg, "){0,1}:").concat(v4, "|(?::").concat(v6seg, "){1,3}|:)"),
        "(?:".concat(v6seg, ":){3}(?:(?::").concat(v6seg, "){0,2}:").concat(v4, "|(?::").concat(v6seg, "){1,4}|:)"),
        "(?:".concat(v6seg, ":){2}(?:(?::").concat(v6seg, "){0,3}:").concat(v4, "|(?::").concat(v6seg, "){1,5}|:)"),
        "(?:".concat(v6seg, ":){1}(?:(?::").concat(v6seg, "){0,4}:").concat(v4, "|(?::").concat(v6seg, "){1,6}|:)"),
        "(?::(?:(?::".concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))") // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
    ];
    var v6Eth0 = "(?:%[0-9a-zA-Z]{1,})?"; // %eth0            %1
    var v6 = "(?:".concat(v6List.join('|'), ")").concat(v6Eth0);
    // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
    var v4exact = new RegExp("^".concat(v4, "$"));
    var v6exact = new RegExp("^".concat(v6, "$"));
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), 'g');
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), 'g');
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), 'g');
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = '(?:\\S+(?::\\S*)?@)?';
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = '(?::\\d{2,5})?';
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:".concat(protocol, "|www\\.)").concat(auth, "(?:localhost|").concat(ipv4, "|").concat(ipv6, "|").concat(host).concat(domain).concat(tld, ")").concat(port).concat(path);
    $8c73e5dfb6e858d0$var$urlReg = new RegExp("(?:^".concat(regex, "$)"), 'i');
    return $8c73e5dfb6e858d0$var$urlReg;
};


/* eslint max-len:0 */ var $c48754f7cc6687ac$var$pattern = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $c48754f7cc6687ac$var$types = {
    integer: function integer(value) {
        return $c48754f7cc6687ac$var$types.number(value) && parseInt(value, 10) === value;
    },
    float: function float(value) {
        return $c48754f7cc6687ac$var$types.number(value) && !$c48754f7cc6687ac$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === 'number';
    },
    object: function object(value) {
        return (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(value) === 'object' && !$c48754f7cc6687ac$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === 'function';
    },
    email: function email(value) {
        return typeof value === 'string' && value.length <= 320 && !!value.match($c48754f7cc6687ac$var$pattern.email);
    },
    url: function url(value) {
        return typeof value === 'string' && value.length <= 2048 && !!value.match((0, $8c73e5dfb6e858d0$export$2e2bcd8739ae039)());
    },
    hex: function hex(value) {
        return typeof value === 'string' && !!value.match($c48754f7cc6687ac$var$pattern.hex);
    }
};
var $c48754f7cc6687ac$var$type = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        (0, $4f3a13873dbc1810$export$2e2bcd8739ae039)(rule, value, source, errors, options);
        return;
    }
    var custom = [
        'integer',
        'float',
        'array',
        'regexp',
        'object',
        'method',
        'email',
        'number',
        'date',
        'url',
        'hex'
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$c48754f7cc6687ac$var$types[ruleType](value)) errors.push((0, $2f87921a30a93974$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
    } else if (ruleType && (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(value) !== rule.type) errors.push((0, $2f87921a30a93974$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $c48754f7cc6687ac$export$2e2bcd8739ae039 = $c48754f7cc6687ac$var$type;



/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $9bfd28e02704514e$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === '') errors.push((0, $2f87921a30a93974$export$d9468344d3651243)(options.messages.whitespace, rule.fullField));
};
var $9bfd28e02704514e$export$2e2bcd8739ae039 = $9bfd28e02704514e$var$whitespace;


var $2d17a9ce229fea19$export$2e2bcd8739ae039 = {
    required: (0, $4f3a13873dbc1810$export$2e2bcd8739ae039),
    whitespace: (0, $9bfd28e02704514e$export$2e2bcd8739ae039),
    type: (0, $c48754f7cc6687ac$export$2e2bcd8739ae039),
    range: (0, $c06167b4e619e03a$export$2e2bcd8739ae039),
    enum: (0, $3b1e77a067155847$export$2e2bcd8739ae039),
    pattern: (0, $ace56d82c9e18bbb$export$2e2bcd8739ae039)
};



var $ae352dd521124777$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $ae352dd521124777$export$2e2bcd8739ae039 = $ae352dd521124777$var$any;



var $db5bec08a6dca90b$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options, 'array');
        if (value !== undefined && value !== null) {
            (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $db5bec08a6dca90b$export$2e2bcd8739ae039 = $db5bec08a6dca90b$var$array;




var $78242bfba3244285$var$boolean = function boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $78242bfba3244285$export$2e2bcd8739ae039 = $78242bfba3244285$var$boolean;




var $93da07ce0e55a311$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    // console.log('validate on %s value', value);
    if (validate) {
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value, 'date') && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $2f87921a30a93974$export$141eca273a04dc3e)(value, 'date')) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).type(rule, dateObject, source, errors, options);
            if (dateObject) (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $93da07ce0e55a311$export$2e2bcd8739ae039 = $93da07ce0e55a311$var$date;




var $8cd1624292034817$var$ENUM = 'enum';
var $8cd1624292034817$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $2d17a9ce229fea19$export$2e2bcd8739ae039)[$8cd1624292034817$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $8cd1624292034817$export$2e2bcd8739ae039 = $8cd1624292034817$var$enumerable;




var $7f1deab8ee4f9eb8$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $7f1deab8ee4f9eb8$export$2e2bcd8739ae039 = $7f1deab8ee4f9eb8$var$floatFn;




var $9d27659bd0b780fb$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $9d27659bd0b780fb$export$2e2bcd8739ae039 = $9d27659bd0b780fb$var$integer;




var $55ea41f175848513$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $55ea41f175848513$export$2e2bcd8739ae039 = $55ea41f175848513$var$method;




var $475e849ff0586d83$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === '') // eslint-disable-next-line no-param-reassign
        value = undefined;
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $475e849ff0586d83$export$2e2bcd8739ae039 = $475e849ff0586d83$var$number;




var $e8e4e00c453d21a8$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $e8e4e00c453d21a8$export$2e2bcd8739ae039 = $e8e4e00c453d21a8$var$object;




var $87942df6e7ac296c$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value, 'string') && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $2f87921a30a93974$export$141eca273a04dc3e)(value, 'string')) (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $87942df6e7ac296c$export$2e2bcd8739ae039 = $87942df6e7ac296c$var$pattern;




var $81f6755529c68ef5$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $2f87921a30a93974$export$141eca273a04dc3e)(value)) (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $81f6755529c68ef5$export$2e2bcd8739ae039 = $81f6755529c68ef5$var$regexp;




var $445cb619d1279fdc$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? 'array' : (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(value);
    (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options, type);
    callback(errors);
};
var $445cb619d1279fdc$export$2e2bcd8739ae039 = $445cb619d1279fdc$var$required;




var $1591b0643be4b00a$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value, 'string') && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options, 'string');
        if (!(0, $2f87921a30a93974$export$141eca273a04dc3e)(value, 'string')) {
            (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
            (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $1591b0643be4b00a$export$2e2bcd8739ae039 = $1591b0643be4b00a$var$string;




var $0b9dc912eae38c33$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $2f87921a30a93974$export$141eca273a04dc3e)(value, ruleType) && !rule.required) return callback();
        (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).required(rule, value, source, errors, options, ruleType);
        if (!(0, $2f87921a30a93974$export$141eca273a04dc3e)(value, ruleType)) (0, $2d17a9ce229fea19$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $0b9dc912eae38c33$export$2e2bcd8739ae039 = $0b9dc912eae38c33$var$type;


var $cf4b7a368184be55$export$2e2bcd8739ae039 = {
    string: (0, $1591b0643be4b00a$export$2e2bcd8739ae039),
    method: (0, $55ea41f175848513$export$2e2bcd8739ae039),
    number: (0, $475e849ff0586d83$export$2e2bcd8739ae039),
    boolean: (0, $78242bfba3244285$export$2e2bcd8739ae039),
    regexp: (0, $81f6755529c68ef5$export$2e2bcd8739ae039),
    integer: (0, $9d27659bd0b780fb$export$2e2bcd8739ae039),
    float: (0, $7f1deab8ee4f9eb8$export$2e2bcd8739ae039),
    array: (0, $db5bec08a6dca90b$export$2e2bcd8739ae039),
    object: (0, $e8e4e00c453d21a8$export$2e2bcd8739ae039),
    enum: (0, $8cd1624292034817$export$2e2bcd8739ae039),
    pattern: (0, $87942df6e7ac296c$export$2e2bcd8739ae039),
    date: (0, $93da07ce0e55a311$export$2e2bcd8739ae039),
    url: (0, $0b9dc912eae38c33$export$2e2bcd8739ae039),
    hex: (0, $0b9dc912eae38c33$export$2e2bcd8739ae039),
    email: (0, $0b9dc912eae38c33$export$2e2bcd8739ae039),
    required: (0, $445cb619d1279fdc$export$2e2bcd8739ae039),
    any: (0, $ae352dd521124777$export$2e2bcd8739ae039)
};




/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $54fb35114bac59c6$var$Schema = /*#__PURE__*/ function() {
    function Schema(descriptor) {
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, Schema);
        // ======================== Instance ========================
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "rules", null);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "_messages", (0, $c483a37b034616a0$export$defe85febe8b728c));
        this.define(descriptor);
    }
    (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(Schema, [
        {
            key: "define",
            value: function define(rules) {
                var _this = this;
                if (!rules) throw new Error('Cannot configure a schema with no rules');
                if ((0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(rules) !== 'object' || Array.isArray(rules)) throw new Error('Rules must be an object');
                this.rules = {};
                Object.keys(rules).forEach(function(name) {
                    var item = rules[name];
                    _this.rules[name] = Array.isArray(item) ? item : [
                        item
                    ];
                });
            }
        },
        {
            key: "messages",
            value: function messages(_messages) {
                if (_messages) this._messages = (0, $2f87921a30a93974$export$6969335ea1e4e77c)((0, $c483a37b034616a0$export$f77fd0c3b25d8534)(), _messages);
                return this._messages;
            }
        },
        {
            key: "validate",
            value: function validate(source_) {
                var _this2 = this;
                var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {};
                var source = source_;
                var options = o;
                var callback = oc;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!this.rules || Object.keys(this.rules).length === 0) {
                    if (callback) callback(null, source);
                    return Promise.resolve(source);
                }
                function complete(results) {
                    var errors = [];
                    var fields = {};
                    function add(e) {
                        if (Array.isArray(e)) {
                            var _errors;
                            errors = (_errors = errors).concat.apply(_errors, (0, $83d01b7684a01087$export$2e2bcd8739ae039)(e));
                        } else errors.push(e);
                    }
                    for(var i = 0; i < results.length; i++)add(results[i]);
                    if (!errors.length) callback(null, source);
                    else {
                        fields = (0, $2f87921a30a93974$export$e85887f5ceeacced)(errors);
                        callback(errors, fields);
                    }
                }
                if (options.messages) {
                    var messages = this.messages();
                    if (messages === (0, $c483a37b034616a0$export$defe85febe8b728c)) messages = (0, $c483a37b034616a0$export$f77fd0c3b25d8534)();
                    (0, $2f87921a30a93974$export$6969335ea1e4e77c)(messages, options.messages);
                    options.messages = messages;
                } else options.messages = this.messages();
                var series = {};
                var keys = options.keys || Object.keys(this.rules);
                keys.forEach(function(z) {
                    var arr = _this2.rules[z];
                    var value = source[z];
                    arr.forEach(function(r) {
                        var rule = r;
                        if (typeof rule.transform === 'function') {
                            if (source === source_) source = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, source);
                            value = source[z] = rule.transform(value);
                            if (value !== undefined && value !== null) rule.type = rule.type || (Array.isArray(value) ? 'array' : (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(value));
                        }
                        if (typeof rule === 'function') rule = {
                            validator: rule
                        };
                        else rule = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, rule);
                        // Fill validator. Skip if nothing need to validate
                        rule.validator = _this2.getValidationMethod(rule);
                        if (!rule.validator) return;
                        rule.field = z;
                        rule.fullField = rule.fullField || z;
                        rule.type = _this2.getType(rule);
                        series[z] = series[z] || [];
                        series[z].push({
                            rule: rule,
                            value: value,
                            source: source,
                            field: z
                        });
                    });
                });
                var errorFields = {};
                return (0, $2f87921a30a93974$export$707ee4c4c95d39e3)(series, options, function(data, doIt) {
                    var rule = data.rule;
                    var deep = (rule.type === 'object' || rule.type === 'array') && ((0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(rule.fields) === 'object' || (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(rule.defaultField) === 'object');
                    deep = deep && (rule.required || !rule.required && data.value);
                    rule.field = data.field;
                    function addFullField(key, schema) {
                        return (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, schema), {}, {
                            fullField: "".concat(rule.fullField, ".").concat(key),
                            fullFields: rule.fullFields ? [].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(rule.fullFields), [
                                key
                            ]) : [
                                key
                            ]
                        });
                    }
                    function cb() {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var errorList = Array.isArray(e) ? e : [
                            e
                        ];
                        if (!options.suppressWarning && errorList.length) Schema.warning('async-validator:', errorList);
                        if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                        // Fill error info
                        var filledErrors = errorList.map((0, $2f87921a30a93974$export$34d5fe50d2616cee)(rule, source));
                        if (options.first && filledErrors.length) {
                            errorFields[rule.field] = 1;
                            return doIt(filledErrors);
                        }
                        if (!deep) doIt(filledErrors);
                        else {
                            // if rule is required but the target object
                            // does not exist fail at the rule level and don't
                            // go deeper
                            if (rule.required && !data.value) {
                                if (rule.message !== undefined) filledErrors = [].concat(rule.message).map((0, $2f87921a30a93974$export$34d5fe50d2616cee)(rule, source));
                                else if (options.error) filledErrors = [
                                    options.error(rule, (0, $2f87921a30a93974$export$d9468344d3651243)(options.messages.required, rule.field))
                                ];
                                return doIt(filledErrors);
                            }
                            var fieldsSchema = {};
                            if (rule.defaultField) Object.keys(data.value).map(function(key) {
                                fieldsSchema[key] = rule.defaultField;
                            });
                            fieldsSchema = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, fieldsSchema), data.rule.fields);
                            var paredFieldsSchema = {};
                            Object.keys(fieldsSchema).forEach(function(field) {
                                var fieldSchema = fieldsSchema[field];
                                var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                                    fieldSchema
                                ];
                                paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                            });
                            var schema = new Schema(paredFieldsSchema);
                            schema.messages(options.messages);
                            if (data.rule.options) {
                                data.rule.options.messages = options.messages;
                                data.rule.options.error = options.error;
                            }
                            schema.validate(data.value, data.rule.options || options, function(errs) {
                                var finalErrors = [];
                                if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, (0, $83d01b7684a01087$export$2e2bcd8739ae039)(filledErrors));
                                if (errs && errs.length) finalErrors.push.apply(finalErrors, (0, $83d01b7684a01087$export$2e2bcd8739ae039)(errs));
                                doIt(finalErrors.length ? finalErrors : null);
                            });
                        }
                    }
                    var res;
                    if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
                    else if (rule.validator) {
                        try {
                            res = rule.validator(rule, data.value, cb, data.source, options);
                        } catch (error) {
                            var _console$error, _console;
                            (_console$error = (_console = console).error) === null || _console$error === void 0 || _console$error.call(_console, error);
                            // rethrow to report error
                            if (!options.suppressValidatorError) setTimeout(function() {
                                throw error;
                            }, 0);
                            cb(error.message);
                        }
                        if (res === true) cb();
                        else if (res === false) cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || "".concat(rule.fullField || rule.field, " fails"));
                        else if (res instanceof Array) cb(res);
                        else if (res instanceof Error) cb(res.message);
                    }
                    if (res && res.then) res.then(function() {
                        return cb();
                    }, function(e) {
                        return cb(e);
                    });
                }, function(results) {
                    complete(results);
                }, source);
            }
        },
        {
            key: "getType",
            value: function getType(rule) {
                if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = 'pattern';
                if (typeof rule.validator !== 'function' && rule.type && !(0, $cf4b7a368184be55$export$2e2bcd8739ae039).hasOwnProperty(rule.type)) throw new Error((0, $2f87921a30a93974$export$d9468344d3651243)('Unknown rule type %s', rule.type));
                return rule.type || 'string';
            }
        },
        {
            key: "getValidationMethod",
            value: function getValidationMethod(rule) {
                if (typeof rule.validator === 'function') return rule.validator;
                var keys = Object.keys(rule);
                var messageIndex = keys.indexOf('message');
                if (messageIndex !== -1) keys.splice(messageIndex, 1);
                if (keys.length === 1 && keys[0] === 'required') return (0, $cf4b7a368184be55$export$2e2bcd8739ae039).required;
                return (0, $cf4b7a368184be55$export$2e2bcd8739ae039)[this.getType(rule)] || undefined;
            }
        }
    ]);
    return Schema;
}();
// ========================= Static =========================
(0, $db13280b58f1be94$export$2e2bcd8739ae039)($54fb35114bac59c6$var$Schema, "register", function register(type, validator) {
    if (typeof validator !== 'function') throw new Error('Cannot register a validator by type, validator is not a function');
    (0, $cf4b7a368184be55$export$2e2bcd8739ae039)[type] = validator;
});
(0, $db13280b58f1be94$export$2e2bcd8739ae039)($54fb35114bac59c6$var$Schema, "warning", (0, $2f87921a30a93974$export$491112666e282270));
(0, $db13280b58f1be94$export$2e2bcd8739ae039)($54fb35114bac59c6$var$Schema, "messages", (0, $c483a37b034616a0$export$defe85febe8b728c));
(0, $db13280b58f1be94$export$2e2bcd8739ae039)($54fb35114bac59c6$var$Schema, "validators", (0, $cf4b7a368184be55$export$2e2bcd8739ae039));
var $54fb35114bac59c6$export$2e2bcd8739ae039 = $54fb35114bac59c6$var$Schema;



var $ltGt3 = parcelRequire("ltGt3");

const $2c6f0e4f3dd8c53a$var$typeTemplate = "'${name}' is not a valid ${type}";
const $2c6f0e4f3dd8c53a$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $2c6f0e4f3dd8c53a$var$typeTemplate,
        method: $2c6f0e4f3dd8c53a$var$typeTemplate,
        array: $2c6f0e4f3dd8c53a$var$typeTemplate,
        object: $2c6f0e4f3dd8c53a$var$typeTemplate,
        number: $2c6f0e4f3dd8c53a$var$typeTemplate,
        date: $2c6f0e4f3dd8c53a$var$typeTemplate,
        boolean: $2c6f0e4f3dd8c53a$var$typeTemplate,
        integer: $2c6f0e4f3dd8c53a$var$typeTemplate,
        float: $2c6f0e4f3dd8c53a$var$typeTemplate,
        regexp: $2c6f0e4f3dd8c53a$var$typeTemplate,
        email: $2c6f0e4f3dd8c53a$var$typeTemplate,
        url: $2c6f0e4f3dd8c53a$var$typeTemplate,
        hex: $2c6f0e4f3dd8c53a$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};



// Remove incorrect original ts define
const $dfb9a923321f9576$var$AsyncValidator = (0, $54fb35114bac59c6$export$2e2bcd8739ae039);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $dfb9a923321f9576$var$replaceMessage(template, kv) {
    return template.replace(/\\?\$\{\w+\}/g, (str)=>{
        if (str.startsWith('\\')) return str.slice(1);
        const key = str.slice(2, -1);
        return kv[key];
    });
}
const $dfb9a923321f9576$var$CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';
async function $dfb9a923321f9576$var$validateRule(name, value, rule, options, messageVariables) {
    const cloneRule = {
        ...rule
    };
    // Bug of `async-validator`
    // https://github.com/react-component/field-form/issues/316
    // https://github.com/react-component/field-form/issues/313
    delete cloneRule.ruleIndex;
    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
    $dfb9a923321f9576$var$AsyncValidator.warning = ()=>void 0;
    if (cloneRule.validator) {
        const originValidator = cloneRule.validator;
        cloneRule.validator = (...args)=>{
            try {
                return originValidator(...args);
            } catch (error) {
                console.error(error);
                return Promise.reject($dfb9a923321f9576$var$CODE_LOGIC_ERROR);
            }
        };
    }
    // We should special handle array validate
    let subRuleField = null;
    if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
        subRuleField = cloneRule.defaultField;
        delete cloneRule.defaultField;
    }
    const validator = new $dfb9a923321f9576$var$AsyncValidator({
        [name]: [
            cloneRule
        ]
    });
    const messages = (0, $33746bcbc33b48dc$export$4950aa0f605343fb)((0, $2c6f0e4f3dd8c53a$export$c86b939816b8fbf8), options.validateMessages);
    validator.messages(messages);
    let result = [];
    try {
        await Promise.resolve(validator.validate({
            [name]: value
        }, {
            ...options
        }));
    } catch (errObj) {
        if (errObj.errors) result = errObj.errors.map(({ message: message }, index)=>{
            const mergedMessage = message === $dfb9a923321f9576$var$CODE_LOGIC_ERROR ? messages.default : message;
            return /*#__PURE__*/ $ltGt3.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
            $ltGt3.cloneElement(mergedMessage, {
                key: `error_${index}`
            }) : mergedMessage;
        });
    }
    if (!result.length && subRuleField && Array.isArray(value) && value.length > 0) {
        const subResults = await Promise.all(value.map((subValue, i)=>$dfb9a923321f9576$var$validateRule(`${name}.${i}`, subValue, subRuleField, options, messageVariables)));
        return subResults.reduce((prev, errors)=>[
                ...prev,
                ...errors
            ], []);
    }
    // Replace message with variables
    const kv = {
        ...rule,
        name: name,
        enum: (rule.enum || []).join(', '),
        ...messageVariables
    };
    const fillVariableResult = result.map((error)=>{
        if (typeof error === 'string') return $dfb9a923321f9576$var$replaceMessage(error, kv);
        return error;
    });
    return fillVariableResult;
}
function $dfb9a923321f9576$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    const name = namePath.join('.');
    // Fill rule with context
    const filledRules = rules.map((currentRule, ruleIndex)=>{
        const originValidatorFunc = currentRule.validator;
        const cloneRule = {
            ...currentRule,
            ruleIndex: ruleIndex
        };
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = (rule, val, callback)=>{
            let hasPromise = false;
            // Wrap callback only accept when promise not provided
            const wrappedCallback = (...args)=>{
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(()=>{
                    (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');
                    if (!hasPromise) callback(...args);
                });
            };
            // Get promise
            const promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $474154b5a64067c8$export$2e2bcd8739ae039)(hasPromise, '`callback` is deprecated. Please return a promise instead.');
            if (hasPromise) promise.then(()=>{
                callback();
            }).catch((err)=>{
                callback(err || ' ');
            });
        };
        return cloneRule;
    }).sort(({ warningOnly: w1, ruleIndex: i1 }, { warningOnly: w2, ruleIndex: i2 })=>{
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    let summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(async (resolve, reject)=>{
        /* eslint-disable no-await-in-loop */ for(let i = 0; i < filledRules.length; i += 1){
            const rule = filledRules[i];
            const errors = await $dfb9a923321f9576$var$validateRule(name, value, rule, options, messageVariables);
            if (errors.length) {
                reject([
                    {
                        errors: errors,
                        rule: rule
                    }
                ]);
                return;
            }
        }
        /* eslint-enable */ resolve([]);
    });
    else {
        // >>>>> Validate by parallel
        const rulePromises = filledRules.map((rule)=>$dfb9a923321f9576$var$validateRule(name, value, rule, options, messageVariables).then((errors)=>({
                    errors: errors,
                    rule: rule
                })));
        summaryPromise = (validateFirst ? $dfb9a923321f9576$var$finishOnFirstFailed(rulePromises) : $dfb9a923321f9576$var$finishOnAllFailed(rulePromises)).then((errors)=>{
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch((e)=>e);
    return summaryPromise;
}
async function $dfb9a923321f9576$var$finishOnAllFailed(rulePromises) {
    return Promise.all(rulePromises).then((errorsList)=>{
        const errors = [].concat(...errorsList);
        return errors;
    });
}
async function $dfb9a923321f9576$var$finishOnFirstFailed(rulePromises) {
    let count = 0;
    return new Promise((resolve)=>{
        rulePromises.forEach((promise)=>{
            promise.then((ruleError)=>{
                if (ruleError.errors.length) resolve([
                    ruleError
                ]);
                count += 1;
                if (count === rulePromises.length) resolve([]);
            });
        });
    });
}





function $d58d34b77e6933ea$export$f877b3cb4cb4ccf9(path) {
    return (0, $38393154317a30c8$export$45b10814cc054894)(path);
}
function $d58d34b77e6933ea$export$f5be6dfb30403c59(store, namePathList) {
    let newStore = {};
    namePathList.forEach((namePath)=>{
        const value = (0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(store, namePath);
        newStore = (0, $33746bcbc33b48dc$export$2e2bcd8739ae039)(newStore, namePath, value);
    });
    return newStore;
}
function $d58d34b77e6933ea$export$646d5504364ae55b(namePathList, namePath, partialMatch = false) {
    return namePathList && namePathList.some((path)=>$d58d34b77e6933ea$export$325a4bd0e71bdc3a(namePath, path, partialMatch));
}
function $d58d34b77e6933ea$export$325a4bd0e71bdc3a(namePath, subNamePath, partialMatch = false) {
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every((nameUnit, i)=>namePath[i] === nameUnit);
}
function $d58d34b77e6933ea$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || typeof source !== 'object' || typeof target !== 'object') return false;
    const sourceKeys = Object.keys(source);
    const targetKeys = Object.keys(target);
    const keys = new Set([
        ...sourceKeys,
        ...targetKeys
    ]);
    return [
        ...keys
    ].every((key)=>{
        const sourceValue = source[key];
        const targetValue = target[key];
        if (typeof sourceValue === 'function' && typeof targetValue === 'function') return true;
        return sourceValue === targetValue;
    });
}
function $d58d34b77e6933ea$export$6eeac3c5b406fb30(valuePropName, ...args) {
    const event = args[0];
    if (event && event.target && typeof event.target === 'object' && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $d58d34b77e6933ea$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    const { length: length } = array;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    const item = array[moveIndex];
    const diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [
        ...array.slice(0, toIndex),
        item,
        ...array.slice(toIndex, moveIndex),
        ...array.slice(moveIndex + 1, length)
    ];
    if (diff < 0) // move right
    return [
        ...array.slice(0, moveIndex),
        ...array.slice(moveIndex + 1, toIndex + 1),
        item,
        ...array.slice(toIndex + 1, length)
    ];
    return array;
}


function $62bb5a895295f340$var$_extends() {
    $62bb5a895295f340$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $62bb5a895295f340$var$_extends.apply(this, arguments);
}
const $62bb5a895295f340$var$EMPTY_ERRORS = [];
const $62bb5a895295f340$var$EMPTY_WARNINGS = [];
function $62bb5a895295f340$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === 'function') return shouldUpdate(prev, next, 'source' in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
class $62bb5a895295f340$var$Field extends $ltGt3.Component {
    static contextType = (0, $1acae32ef7ef7c71$export$2e2bcd8739ae039);
    state = {
        resetCount: 0
    };
    cancelRegisterFunc = null;
    mounted = false;
    /**
   * Follow state should not management in State since it will async update by React.
   * This makes first render of form can not get correct state value.
   */ touched = false;
    /**
   * Mark when touched & validated. Currently only used for `dependencies`.
   * Note that we do not think field with `initialValue` is dirty
   * but this will be by `isFieldDirty` func.
   */ dirty = false;
    validatePromise;
    prevValidating;
    errors = $62bb5a895295f340$var$EMPTY_ERRORS;
    warnings = $62bb5a895295f340$var$EMPTY_WARNINGS;
    // ============================== Subscriptions ==============================
    constructor(props){
        super(props);
        // Register on init
        if (props.fieldContext) {
            const { getInternalHooks: getInternalHooks } = props.fieldContext;
            const { initEntityValue: initEntityValue } = getInternalHooks((0, $1acae32ef7ef7c71$export$24829b7c0e49e9f7));
            initEntityValue(this);
        }
    }
    componentDidMount() {
        const { shouldUpdate: shouldUpdate, fieldContext: fieldContext } = this.props;
        this.mounted = true;
        // Register on init
        if (fieldContext) {
            const { getInternalHooks: getInternalHooks } = fieldContext;
            const { registerField: registerField } = getInternalHooks((0, $1acae32ef7ef7c71$export$24829b7c0e49e9f7));
            this.cancelRegisterFunc = registerField(this);
        }
        // One more render for component in case fields not ready
        if (shouldUpdate === true) this.reRender();
    }
    componentWillUnmount() {
        this.cancelRegister();
        this.triggerMetaEvent(true);
        this.mounted = false;
    }
    cancelRegister = ()=>{
        const { preserve: preserve, isListField: isListField, name: name } = this.props;
        if (this.cancelRegisterFunc) this.cancelRegisterFunc(isListField, preserve, (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(name));
        this.cancelRegisterFunc = null;
    };
    // ================================== Utils ==================================
    getNamePath = ()=>{
        const { name: name, fieldContext: fieldContext } = this.props;
        const { prefixName: prefixName = [] } = fieldContext;
        return name !== undefined ? [
            ...prefixName,
            ...name
        ] : [];
    };
    getRules = ()=>{
        const { rules: rules = [], fieldContext: fieldContext } = this.props;
        return rules.map((rule)=>{
            if (typeof rule === 'function') return rule(fieldContext);
            return rule;
        });
    };
    reRender() {
        if (!this.mounted) return;
        this.forceUpdate();
    }
    refresh = ()=>{
        if (!this.mounted) return;
        /**
     * Clean up current node.
     */ this.setState(({ resetCount: resetCount })=>({
                resetCount: resetCount + 1
            }));
    };
    // Event should only trigger when meta changed
    metaCache = null;
    triggerMetaEvent = (destroy)=>{
        const { onMetaChange: onMetaChange } = this.props;
        if (onMetaChange) {
            const meta = {
                ...this.getMeta(),
                destroy: destroy
            };
            if (!(0, $003c57daacb79f0c$export$2e2bcd8739ae039)(this.metaCache, meta)) onMetaChange(meta);
            this.metaCache = meta;
        } else this.metaCache = null;
    };
    // ========================= Field Entity Interfaces =========================
    // Trigger by store update. Check if need update the component
    onStoreChange = (prevStore, namePathList, info)=>{
        const { shouldUpdate: shouldUpdate, dependencies: dependencies = [], onReset: onReset } = this.props;
        const { store: store } = info;
        const namePath = this.getNamePath();
        const prevValue = this.getValue(prevStore);
        const curValue = this.getValue(store);
        const namePathMatch = namePathList && (0, $d58d34b77e6933ea$export$646d5504364ae55b)(namePathList, namePath);
        // `setFieldsValue` is a quick access to update related status
        if (info.type === 'valueUpdate' && info.source === 'external' && !(0, $003c57daacb79f0c$export$2e2bcd8739ae039)(prevValue, curValue)) {
            this.touched = true;
            this.dirty = true;
            this.validatePromise = null;
            this.errors = $62bb5a895295f340$var$EMPTY_ERRORS;
            this.warnings = $62bb5a895295f340$var$EMPTY_WARNINGS;
            this.triggerMetaEvent();
        }
        switch(info.type){
            case 'reset':
                if (!namePathList || namePathMatch) {
                    // Clean up state
                    this.touched = false;
                    this.dirty = false;
                    this.validatePromise = undefined;
                    this.errors = $62bb5a895295f340$var$EMPTY_ERRORS;
                    this.warnings = $62bb5a895295f340$var$EMPTY_WARNINGS;
                    this.triggerMetaEvent();
                    onReset?.();
                    this.refresh();
                    return;
                }
                break;
            /**
       * In case field with `preserve = false` nest deps like:
       * - A = 1 => show B
       * - B = 1 => show C
       * - Reset A, need clean B, C
       */ case 'remove':
                if (shouldUpdate && $62bb5a895295f340$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                    this.reRender();
                    return;
                }
                break;
            case 'setField':
                {
                    const { data: data } = info;
                    if (namePathMatch) {
                        if ('touched' in data) this.touched = data.touched;
                        if ('validating' in data && !('originRCField' in data)) this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ('errors' in data) this.errors = data.errors || $62bb5a895295f340$var$EMPTY_ERRORS;
                        if ('warnings' in data) this.warnings = data.warnings || $62bb5a895295f340$var$EMPTY_WARNINGS;
                        this.dirty = true;
                        this.triggerMetaEvent();
                        this.reRender();
                        return;
                    } else if ('value' in data && (0, $d58d34b77e6933ea$export$646d5504364ae55b)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $62bb5a895295f340$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        this.reRender();
                        return;
                    }
                    break;
                }
            case 'dependenciesUpdate':
                {
                    /**
           * Trigger when marked `dependencies` updated. Related fields will all update
           */ const dependencyList = dependencies.map((0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some((dependency)=>(0, $d58d34b77e6933ea$export$646d5504364ae55b)(info.relatedFields, dependency))) {
                        this.reRender();
                        return;
                    }
                    break;
                }
            default:
                // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                //      For example <List name="list"><Field name={['list', 0]}></List>
                //      If `namePathList` is [['list']] (List value update), Field should be updated
                //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                // 2.
                //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                //       is not provided
                //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                //       else to check if value changed
                if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $62bb5a895295f340$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                    this.reRender();
                    return;
                }
                break;
        }
        if (shouldUpdate === true) this.reRender();
    };
    validateRules = (options)=>{
        // We should fixed namePath & value to avoid developer change then by form function
        const namePath = this.getNamePath();
        const currentValue = this.getValue();
        const { triggerName: triggerName, validateOnly: validateOnly = false } = options || {};
        // Force change to async to avoid rule OOD under renderProps field
        const rootPromise = Promise.resolve().then(async ()=>{
            if (!this.mounted) return [];
            const { validateFirst: validateFirst = false, messageVariables: messageVariables, validateDebounce: validateDebounce } = this.props;
            // Start validate
            let filteredRules = this.getRules();
            if (triggerName) filteredRules = filteredRules.filter((rule)=>rule).filter((rule)=>{
                const { validateTrigger: validateTrigger } = rule;
                if (!validateTrigger) return true;
                const triggerList = (0, $38393154317a30c8$export$45b10814cc054894)(validateTrigger);
                return triggerList.includes(triggerName);
            });
            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
            if (validateDebounce && triggerName) {
                await new Promise((resolve)=>{
                    setTimeout(resolve, validateDebounce);
                });
                // Skip since out of date
                if (this.validatePromise !== rootPromise) return [];
            }
            const promise = (0, $dfb9a923321f9576$export$e1fc4b442d0297dd)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
            promise.catch((e)=>e).then((ruleErrors = $62bb5a895295f340$var$EMPTY_ERRORS)=>{
                if (this.validatePromise === rootPromise) {
                    this.validatePromise = null;
                    // Get errors & warnings
                    const nextErrors = [];
                    const nextWarnings = [];
                    ruleErrors.forEach?.(({ rule: { warningOnly: warningOnly }, errors: errors = $62bb5a895295f340$var$EMPTY_ERRORS })=>{
                        if (warningOnly) nextWarnings.push(...errors);
                        else nextErrors.push(...errors);
                    });
                    this.errors = nextErrors;
                    this.warnings = nextWarnings;
                    this.triggerMetaEvent();
                    this.reRender();
                }
            });
            return promise;
        });
        if (validateOnly) return rootPromise;
        this.validatePromise = rootPromise;
        this.dirty = true;
        this.errors = $62bb5a895295f340$var$EMPTY_ERRORS;
        this.warnings = $62bb5a895295f340$var$EMPTY_WARNINGS;
        this.triggerMetaEvent();
        // Force trigger re-render since we need sync renderProps with new meta
        this.reRender();
        return rootPromise;
    };
    isFieldValidating = ()=>!!this.validatePromise;
    isFieldTouched = ()=>this.touched;
    isFieldDirty = ()=>{
        // Touched or validate or has initialValue
        if (this.dirty || this.props.initialValue !== undefined) return true;
        // Form set initialValue
        const { fieldContext: fieldContext } = this.props;
        const { getInitialValue: getInitialValue } = fieldContext.getInternalHooks((0, $1acae32ef7ef7c71$export$24829b7c0e49e9f7));
        if (getInitialValue(this.getNamePath()) !== undefined) return true;
        return false;
    };
    getErrors = ()=>this.errors;
    getWarnings = ()=>this.warnings;
    isListField = ()=>this.props.isListField;
    isList = ()=>this.props.isList;
    isPreserve = ()=>this.props.preserve;
    // ============================= Child Component =============================
    getMeta = ()=>{
        // Make error & validating in cache to save perf
        this.prevValidating = this.isFieldValidating();
        const meta = {
            touched: this.isFieldTouched(),
            validating: this.prevValidating,
            errors: this.errors,
            warnings: this.warnings,
            name: this.getNamePath(),
            validated: this.validatePromise === null
        };
        return meta;
    };
    // Only return validate child node. If invalidate, will do nothing about field.
    getOnlyChild = (children)=>{
        // Support render props
        if (typeof children === 'function') {
            const meta = this.getMeta();
            return {
                ...this.getOnlyChild(children(this.getControlled(), meta, this.props.fieldContext)),
                isFunction: true
            };
        }
        // Filed element only
        const childList = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children);
        if (childList.length !== 1 || !/*#__PURE__*/ $ltGt3.isValidElement(childList[0])) return {
            child: childList,
            isFunction: false
        };
        return {
            child: childList[0],
            isFunction: false
        };
    };
    // ============================== Field Control ==============================
    getValue = (store)=>{
        const { getFieldsValue: getFieldsValue } = this.props.fieldContext;
        const namePath = this.getNamePath();
        return (0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(store || getFieldsValue(true), namePath);
    };
    getControlled = (childProps = {})=>{
        const { name: name, trigger: trigger = 'onChange', validateTrigger: validateTrigger, getValueFromEvent: getValueFromEvent, normalize: normalize, valuePropName: valuePropName = 'value', getValueProps: getValueProps, fieldContext: fieldContext } = this.props;
        const mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
        const namePath = this.getNamePath();
        const { getInternalHooks: getInternalHooks, getFieldsValue: getFieldsValue } = fieldContext;
        const { dispatch: dispatch } = getInternalHooks((0, $1acae32ef7ef7c71$export$24829b7c0e49e9f7));
        const value = this.getValue();
        const mergedGetValueProps = getValueProps || ((val)=>({
                [valuePropName]: val
            }));
        const originTriggerFunc = childProps[trigger];
        const valueProps = name !== undefined ? mergedGetValueProps(value) : {};
        var key;
        const control = {
            ...childProps,
            ...valueProps
        };
        // Add trigger
        control[trigger] = (...args)=>{
            // Mark as touched
            this.touched = true;
            this.dirty = true;
            this.triggerMetaEvent();
            let newValue;
            if (getValueFromEvent) newValue = getValueFromEvent(...args);
            else newValue = (0, $d58d34b77e6933ea$export$6eeac3c5b406fb30)(valuePropName, ...args);
            if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
            if (newValue !== value) dispatch({
                type: 'updateValue',
                namePath: namePath,
                value: newValue
            });
            if (originTriggerFunc) originTriggerFunc(...args);
        };
        // Add validateTrigger
        const validateTriggerList = (0, $38393154317a30c8$export$45b10814cc054894)(mergedValidateTrigger || []);
        validateTriggerList.forEach((triggerName)=>{
            // Wrap additional function of component, so that we can get latest value from store
            const originTrigger = control[triggerName];
            control[triggerName] = (...args)=>{
                if (originTrigger) originTrigger(...args);
                // Always use latest rules
                const { rules: rules } = this.props;
                if (rules && rules.length) // We dispatch validate to root,
                // since it will update related data with other field with same name
                dispatch({
                    type: 'validateField',
                    namePath: namePath,
                    triggerName: triggerName
                });
            };
        });
        return control;
    };
    render() {
        const { resetCount: resetCount } = this.state;
        const { children: children } = this.props;
        const { child: child, isFunction: isFunction } = this.getOnlyChild(children);
        // Not need to `cloneElement` since user can handle this in render function self
        let returnChildNode;
        if (isFunction) returnChildNode = child;
        else if (/*#__PURE__*/ $ltGt3.isValidElement(child)) returnChildNode = /*#__PURE__*/ $ltGt3.cloneElement(child, this.getControlled(child.props));
        else {
            (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!child, '`children` of Field is not validate ReactElement.');
            returnChildNode = child;
        }
        return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, {
            key: resetCount
        }, returnChildNode);
    }
}
function $62bb5a895295f340$var$WrapperField({ name: name, ...restProps }) {
    const fieldContext = $ltGt3.useContext((0, $1acae32ef7ef7c71$export$2e2bcd8739ae039));
    const listContext = $ltGt3.useContext((0, $676ce4da8497bef1$export$2e2bcd8739ae039));
    const namePath = name !== undefined ? (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(name) : undefined;
    const isMergedListField = restProps.isListField ?? !!listContext;
    let key = 'keep';
    if (!isMergedListField) key = `_${(namePath || []).join('_')}`;
    return /*#__PURE__*/ $ltGt3.createElement($62bb5a895295f340$var$Field, $62bb5a895295f340$var$_extends({
        key: key,
        name: namePath,
        isListField: isMergedListField
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $62bb5a895295f340$export$2e2bcd8739ae039 = $62bb5a895295f340$var$WrapperField;



var $ltGt3 = parcelRequire("ltGt3");





function $027e12733387be9a$var$List({ name: name, initialValue: initialValue, children: children, rules: rules, validateTrigger: validateTrigger, isListField: isListField }) {
    const context = $ltGt3.useContext((0, $1acae32ef7ef7c71$export$2e2bcd8739ae039));
    const wrapperListContext = $ltGt3.useContext((0, $676ce4da8497bef1$export$2e2bcd8739ae039));
    const keyRef = $ltGt3.useRef({
        keys: [],
        id: 0
    });
    const keyManager = keyRef.current;
    const prefixName = $ltGt3.useMemo(()=>{
        const parentPrefixName = (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(context.prefixName) || [];
        return [
            ...parentPrefixName,
            ...(0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(name)
        ];
    }, [
        context.prefixName,
        name
    ]);
    const fieldContext = $ltGt3.useMemo(()=>({
            ...context,
            prefixName: prefixName
        }), [
        context,
        prefixName
    ]);
    // List context
    const listContext = $ltGt3.useMemo(()=>({
            getKey: (namePath)=>{
                const len = prefixName.length;
                const pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        }), [
        keyManager,
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== 'function') {
        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, 'Form.List only accepts function as children.');
        return null;
    }
    const shouldUpdate = (prevValue, nextValue, { source: source })=>{
        if (source === 'internal') return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $ltGt3.createElement((0, $676ce4da8497bef1$export$2e2bcd8739ae039).Provider, {
        value: listContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $1acae32ef7ef7c71$export$2e2bcd8739ae039).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $62bb5a895295f340$export$2e2bcd8739ae039), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField ?? !!wrapperListContext
    }, ({ value: value = [], onChange: onChange }, meta)=>{
        const { getFieldValue: getFieldValue } = context;
        const getNewValue = ()=>{
            const values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ const operations = {
            add: (defaultValue, index)=>{
                // Mapping keys
                const newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [
                        ...keyManager.keys.slice(0, index),
                        keyManager.id,
                        ...keyManager.keys.slice(index)
                    ];
                    onChange([
                        ...newValue.slice(0, index),
                        defaultValue,
                        ...newValue.slice(index)
                    ]);
                } else {
                    keyManager.keys = [
                        ...keyManager.keys,
                        keyManager.id
                    ];
                    onChange([
                        ...newValue,
                        defaultValue
                    ]);
                }
                keyManager.id += 1;
            },
            remove: (index)=>{
                const newValue = getNewValue();
                const indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter((_, keysIndex)=>!indexSet.has(keysIndex));
                // Trigger store change
                onChange(newValue.filter((_, valueIndex)=>!indexSet.has(valueIndex)));
            },
            move (from, to) {
                if (from === to) return;
                const newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $d58d34b77e6933ea$export$d947e5f4f4c48d48)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $d58d34b77e6933ea$export$d947e5f4f4c48d48)(newValue, from, to));
            }
        };
        let listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map((__, index)=>{
            let key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $027e12733387be9a$export$2e2bcd8739ae039 = $027e12733387be9a$var$List;





var $ltGt3 = parcelRequire("ltGt3");

function $94ac770596b7f420$export$6152adfdcc6be2b5(promiseList) {
    let hasError = false;
    let count = promiseList.length;
    const results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise((resolve, reject)=>{
        promiseList.forEach((promise, index)=>{
            promise.catch((e)=>{
                hasError = true;
                return e;
            }).then((result)=>{
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}



const $199a674a2451f3cf$var$SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $199a674a2451f3cf$var$normalize(namePath) {
    return namePath.map((cell)=>`${typeof cell}:${cell}`)// Magic split
    .join($199a674a2451f3cf$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ class $199a674a2451f3cf$var$NameMap {
    kvs = new Map();
    set(key, value) {
        this.kvs.set($199a674a2451f3cf$var$normalize(key), value);
    }
    get(key) {
        return this.kvs.get($199a674a2451f3cf$var$normalize(key));
    }
    update(key, updater) {
        const origin = this.get(key);
        const next = updater(origin);
        if (!next) this.delete(key);
        else this.set(key, next);
    }
    delete(key) {
        this.kvs.delete($199a674a2451f3cf$var$normalize(key));
    }
    // Since we only use this in test, let simply realize this
    map(callback) {
        return [
            ...this.kvs.entries()
        ].map(([key, value])=>{
            const cells = key.split($199a674a2451f3cf$var$SPLIT);
            return callback({
                key: cells.map((cell)=>{
                    const [, type, unit] = cell.match(/^([^:]*):(.*)$/);
                    return type === 'number' ? Number(unit) : unit;
                }),
                value: value
            });
        });
    }
    toJSON() {
        const json = {};
        this.map(({ key: key, value: value })=>{
            json[key.join('.')] = value;
            return null;
        });
        return json;
    }
}
var $199a674a2451f3cf$export$2e2bcd8739ae039 = $199a674a2451f3cf$var$NameMap;



class $7a9a0ec87f59ad35$export$75ff1ab1187e691 {
    formHooked = false;
    forceRootUpdate;
    subscribable = true;
    store = {};
    fieldEntities = [];
    initialValues = {};
    callbacks = {};
    validateMessages = null;
    preserve = null;
    lastValidatePromise = null;
    constructor(forceRootUpdate){
        this.forceRootUpdate = forceRootUpdate;
    }
    getForm = ()=>({
            getFieldValue: this.getFieldValue,
            getFieldsValue: this.getFieldsValue,
            getFieldError: this.getFieldError,
            getFieldWarning: this.getFieldWarning,
            getFieldsError: this.getFieldsError,
            isFieldsTouched: this.isFieldsTouched,
            isFieldTouched: this.isFieldTouched,
            isFieldValidating: this.isFieldValidating,
            isFieldsValidating: this.isFieldsValidating,
            resetFields: this.resetFields,
            setFields: this.setFields,
            setFieldValue: this.setFieldValue,
            setFieldsValue: this.setFieldsValue,
            validateFields: this.validateFields,
            submit: this.submit,
            _init: true,
            getInternalHooks: this.getInternalHooks
        });
    // ======================== Internal Hooks ========================
    getInternalHooks = (key)=>{
        if (key === (0, $1acae32ef7ef7c71$export$24829b7c0e49e9f7)) {
            this.formHooked = true;
            return {
                dispatch: this.dispatch,
                initEntityValue: this.initEntityValue,
                registerField: this.registerField,
                useSubscribe: this.useSubscribe,
                setInitialValues: this.setInitialValues,
                destroyForm: this.destroyForm,
                setCallbacks: this.setCallbacks,
                setValidateMessages: this.setValidateMessages,
                getFields: this.getFields,
                setPreserve: this.setPreserve,
                getInitialValue: this.getInitialValue,
                registerWatch: this.registerWatch,
                setBatchUpdate: this.setBatchUpdate
            };
        }
        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, '`getInternalHooks` is internal usage. Should not call directly.');
        return null;
    };
    useSubscribe = (subscribable)=>{
        this.subscribable = subscribable;
    };
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ prevWithoutPreserves = null;
    /**
   * First time `setInitialValues` should update store with initial value
   */ setInitialValues = (initialValues, init)=>{
        this.initialValues = initialValues || {};
        if (init) {
            let nextStore = (0, $33746bcbc33b48dc$export$4950aa0f605343fb)(initialValues, this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            this.prevWithoutPreserves?.map(({ key: namePath })=>{
                nextStore = (0, $33746bcbc33b48dc$export$2e2bcd8739ae039)(nextStore, namePath, (0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(initialValues, namePath));
            });
            this.prevWithoutPreserves = null;
            this.updateStore(nextStore);
        }
    };
    destroyForm = (clearOnDestroy)=>{
        if (clearOnDestroy) // destroy form reset store
        this.updateStore({});
        else {
            // Fill preserve fields
            const prevWithoutPreserves = new (0, $199a674a2451f3cf$export$2e2bcd8739ae039)();
            this.getFieldEntities(true).forEach((entity)=>{
                if (!this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
            });
            this.prevWithoutPreserves = prevWithoutPreserves;
        }
    };
    getInitialValue = (namePath)=>{
        const initValue = (0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $33746bcbc33b48dc$export$4950aa0f605343fb)(initValue) : initValue;
    };
    setCallbacks = (callbacks)=>{
        this.callbacks = callbacks;
    };
    setValidateMessages = (validateMessages)=>{
        this.validateMessages = validateMessages;
    };
    setPreserve = (preserve)=>{
        this.preserve = preserve;
    };
    // ============================= Watch ============================
    watchList = [];
    registerWatch = (callback)=>{
        this.watchList.push(callback);
        return ()=>{
            this.watchList = this.watchList.filter((fn)=>fn !== callback);
        };
    };
    notifyWatch = (namePath = [])=>{
        // No need to cost perf when nothing need to watch
        if (this.watchList.length) {
            const values = this.getFieldsValue();
            const allValues = this.getFieldsValue(true);
            this.watchList.forEach((callback)=>{
                callback(values, allValues, namePath);
            });
        }
    };
    notifyWatchNamePathList = [];
    batchNotifyWatch = (namePath)=>{
        this.notifyWatchNamePathList.push(namePath);
        this.batch('notifyWatch', ()=>{
            this.notifyWatch(this.notifyWatchNamePathList);
            this.notifyWatchNamePathList = [];
        });
    };
    // ============================= Batch ============================
    batchUpdate;
    setBatchUpdate = (batchUpdate)=>{
        this.batchUpdate = batchUpdate;
    };
    // Batch call the task, only last will be called
    batch = (key, callback)=>{
        this.batchUpdate(key, callback);
    };
    // ========================== Dev Warning =========================
    timeoutId = null;
    warningUnhooked = ()=>{};
    // ============================ Store =============================
    updateStore = (nextStore)=>{
        this.store = nextStore;
    };
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ getFieldEntities = (pure = false)=>{
        if (!pure) return this.fieldEntities;
        return this.fieldEntities.filter((field)=>field.getNamePath().length);
    };
    getFieldsMap = (pure = false)=>{
        const cache = new (0, $199a674a2451f3cf$export$2e2bcd8739ae039)();
        this.getFieldEntities(pure).forEach((field)=>{
            const namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    };
    getFieldEntitiesForNamePathList = (nameList)=>{
        if (!nameList) return this.getFieldEntities(true);
        const cache = this.getFieldsMap(true);
        return nameList.map((name)=>{
            const namePath = (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(name)
            };
        });
    };
    getFieldsValue = (nameList, filterFunc)=>{
        this.warningUnhooked();
        // Fill args
        let mergedNameList;
        let mergedFilterFunc;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && typeof nameList === 'object') mergedFilterFunc = nameList.filter;
        if (mergedNameList === true && !mergedFilterFunc) return this.store;
        const fieldEntities = this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        const filteredNameList = [];
        const listNamePaths = [];
        fieldEntities.forEach((entity)=>{
            const namePath = entity.INVALIDATE_NAME_PATH || entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (entity.isList?.()) {
                listNamePaths.push(namePath);
                return;
            }
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                const meta = 'getMeta' in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        let mergedValues = (0, $d58d34b77e6933ea$export$f5be6dfb30403c59)(this.store, filteredNameList.map((0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)));
        // We need fill the list as [] if Form.List is empty
        listNamePaths.forEach((namePath)=>{
            if (!(0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(mergedValues, namePath)) mergedValues = (0, $33746bcbc33b48dc$export$2e2bcd8739ae039)(mergedValues, namePath, []);
        });
        return mergedValues;
    };
    getFieldValue = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(name);
        return (0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(this.store, namePath);
    };
    getFieldsError = (nameList)=>{
        this.warningUnhooked();
        const fieldEntities = this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map((entity, index)=>{
            if (entity && !entity.INVALIDATE_NAME_PATH) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    };
    getFieldError = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(name);
        const fieldError = this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    };
    getFieldWarning = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(name);
        const fieldError = this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    };
    isFieldsTouched = (...args)=>{
        this.warningUnhooked();
        const [arg0, arg1] = args;
        let namePathList;
        let isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9));
            isAllFieldsTouched = arg1;
        }
        const fieldEntities = this.getFieldEntities(true);
        const isFieldTouched = (field)=>field.isFieldTouched();
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every((entity)=>isFieldTouched(entity) || entity.isList()) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        const map = new (0, $199a674a2451f3cf$export$2e2bcd8739ae039)();
        namePathList.forEach((shortNamePath)=>{
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach((field)=>{
            const fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach((shortNamePath)=>{
                if (shortNamePath.every((nameUnit, i)=>fieldNamePath[i] === nameUnit)) map.update(shortNamePath, (list)=>[
                        ...list,
                        field
                    ]);
            });
        });
        // Check if NameMap value is touched
        const isNamePathListTouched = (entities)=>entities.some(isFieldTouched);
        const namePathListEntities = map.map(({ value: value })=>value);
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    };
    isFieldTouched = (name)=>{
        this.warningUnhooked();
        return this.isFieldsTouched([
            name
        ]);
    };
    isFieldsValidating = (nameList)=>{
        this.warningUnhooked();
        const fieldEntities = this.getFieldEntities();
        if (!nameList) return fieldEntities.some((testField)=>testField.isFieldValidating());
        const namePathList = nameList.map((0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9));
        return fieldEntities.some((testField)=>{
            const fieldNamePath = testField.getNamePath();
            return (0, $d58d34b77e6933ea$export$646d5504364ae55b)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    };
    isFieldValidating = (name)=>{
        this.warningUnhooked();
        return this.isFieldsValidating([
            name
        ]);
    };
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ resetWithFieldInitialValue = (info = {})=>{
        // Create cache
        const cache = new (0, $199a674a2451f3cf$export$2e2bcd8739ae039)();
        const fieldEntities = this.getFieldEntities(true);
        fieldEntities.forEach((field)=>{
            const { initialValue: initialValue } = field.props;
            const namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                const records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        const resetWithFields = (entities)=>{
            entities.forEach((field)=>{
                const { initialValue: initialValue } = field.props;
                if (initialValue !== undefined) {
                    const namePath = field.getNamePath();
                    const formInitialValue = this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, `Form already set 'initialValues' with path '${namePath.join('.')}'. Field can not overwrite it.`);
                    else {
                        const records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, `Multiple Field with path '${namePath.join('.')}' set 'initialValue'. Can not decide which one to pick.`);
                        else if (records) {
                            const originValue = this.getFieldValue(namePath);
                            const isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) this.updateStore((0, $33746bcbc33b48dc$export$2e2bcd8739ae039)(this.store, namePath, [
                                ...records
                            ][0].value));
                        }
                    }
                }
            });
        };
        let requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach((namePath)=>{
                const records = cache.get(namePath);
                if (records) requiredFieldEntities.push(...[
                    ...records
                ].map((r)=>r.entity));
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    };
    resetFields = (nameList)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        if (!nameList) {
            this.updateStore((0, $33746bcbc33b48dc$export$4950aa0f605343fb)(this.initialValues));
            this.resetWithFieldInitialValue();
            this.notifyObservers(prevStore, null, {
                type: 'reset'
            });
            this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        const namePathList = nameList.map((0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9));
        namePathList.forEach((namePath)=>{
            const initialValue = this.getInitialValue(namePath);
            this.updateStore((0, $33746bcbc33b48dc$export$2e2bcd8739ae039)(this.store, namePath, initialValue));
        });
        this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        this.notifyObservers(prevStore, namePathList, {
            type: 'reset'
        });
        this.notifyWatch(namePathList);
    };
    setFields = (fields)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        const namePathList = [];
        fields.forEach((fieldData)=>{
            const { name: name, ...data } = fieldData;
            const namePath = (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(name);
            namePathList.push(namePath);
            // Value
            if ('value' in data) this.updateStore((0, $33746bcbc33b48dc$export$2e2bcd8739ae039)(this.store, namePath, data.value));
            this.notifyObservers(prevStore, [
                namePath
            ], {
                type: 'setField',
                data: fieldData
            });
        });
        this.notifyWatch(namePathList);
    };
    getFields = ()=>{
        const entities = this.getFieldEntities(true);
        const fields = entities.map((field)=>{
            const namePath = field.getNamePath();
            const meta = field.getMeta();
            const fieldData = {
                ...meta,
                name: namePath,
                value: this.getFieldValue(namePath)
            };
            Object.defineProperty(fieldData, 'originRCField', {
                value: true
            });
            return fieldData;
        });
        return fields;
    };
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ initEntityValue = (entity)=>{
        const { initialValue: initialValue } = entity.props;
        if (initialValue !== undefined) {
            const namePath = entity.getNamePath();
            const prevValue = (0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(this.store, namePath);
            if (prevValue === undefined) this.updateStore((0, $33746bcbc33b48dc$export$2e2bcd8739ae039)(this.store, namePath, initialValue));
        }
    };
    isMergedPreserve = (fieldPreserve)=>{
        const mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : this.preserve;
        return mergedPreserve ?? true;
    };
    registerField = (entity)=>{
        this.fieldEntities.push(entity);
        const namePath = entity.getNamePath();
        this.batchNotifyWatch(namePath);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            const prevStore = this.store;
            this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: 'valueUpdate',
                source: 'internal'
            });
        }
        // un-register field callback
        return (isListField, preserve, subNamePath = [])=>{
            this.fieldEntities = this.fieldEntities.filter((item)=>item !== entity);
            // Clean up store value if not preserve
            if (!this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                const defaultValue = isListField ? undefined : this.getInitialValue(namePath);
                if (namePath.length && this.getFieldValue(namePath) !== defaultValue && this.fieldEntities.every((field)=>// Only reset when no namePath exist
                    !(0, $d58d34b77e6933ea$export$325a4bd0e71bdc3a)(field.getNamePath(), namePath))) {
                    const prevStore = this.store;
                    this.updateStore((0, $33746bcbc33b48dc$export$2e2bcd8739ae039)(prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    this.notifyObservers(prevStore, [
                        namePath
                    ], {
                        type: 'remove'
                    });
                    // Dependencies update
                    this.triggerDependenciesUpdate(prevStore, namePath);
                }
            }
            this.batchNotifyWatch(namePath);
        };
    };
    dispatch = (action)=>{
        switch(action.type){
            case 'updateValue':
                {
                    const { namePath: namePath, value: value } = action;
                    this.updateValue(namePath, value);
                    break;
                }
            case 'validateField':
                {
                    const { namePath: namePath, triggerName: triggerName } = action;
                    this.validateFields([
                        namePath
                    ], {
                        triggerName: triggerName
                    });
                    break;
                }
            default:
        }
    };
    notifyObservers = (prevStore, namePathList, info)=>{
        if (this.subscribable) {
            const mergedInfo = {
                ...info,
                store: this.getFieldsValue(true)
            };
            this.getFieldEntities().forEach(({ onStoreChange: onStoreChange })=>{
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else this.forceRootUpdate();
    };
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ triggerDependenciesUpdate = (prevStore, namePath)=>{
        const childrenFields = this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) this.validateFields(childrenFields);
        this.notifyObservers(prevStore, childrenFields, {
            type: 'dependenciesUpdate',
            relatedFields: [
                namePath,
                ...childrenFields
            ]
        });
        return childrenFields;
    };
    updateValue = (name, value)=>{
        const namePath = (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(name);
        const prevStore = this.store;
        this.updateStore((0, $33746bcbc33b48dc$export$2e2bcd8739ae039)(this.store, namePath, value));
        this.notifyObservers(prevStore, [
            namePath
        ], {
            type: 'valueUpdate',
            source: 'internal'
        });
        this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        const childrenFields = this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        const { onValuesChange: onValuesChange } = this.callbacks;
        if (onValuesChange) {
            const changedValues = (0, $d58d34b77e6933ea$export$f5be6dfb30403c59)(this.store, [
                namePath
            ]);
            const allValues = this.getFieldsValue();
            // Merge changedValues into allValues to ensure allValues contains the latest changes
            const mergedAllValues = (0, $33746bcbc33b48dc$export$4950aa0f605343fb)(allValues, changedValues);
            onValuesChange(changedValues, mergedAllValues);
        }
        this.triggerOnFieldsChange([
            namePath,
            ...childrenFields
        ]);
    };
    // Let all child Field get update.
    setFieldsValue = (store)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        if (store) {
            const nextStore = (0, $33746bcbc33b48dc$export$4950aa0f605343fb)(this.store, store);
            this.updateStore(nextStore);
        }
        this.notifyObservers(prevStore, null, {
            type: 'valueUpdate',
            source: 'external'
        });
        this.notifyWatch();
    };
    setFieldValue = (name, value)=>{
        this.setFields([
            {
                name: name,
                value: value,
                errors: [],
                warnings: [],
                touched: true
            }
        ]);
    };
    getDependencyChildrenFields = (rootNamePath)=>{
        const children = new Set();
        const childrenFields = [];
        const dependencies2fields = new (0, $199a674a2451f3cf$export$2e2bcd8739ae039)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ this.getFieldEntities().forEach((field)=>{
            const { dependencies: dependencies } = field.props;
            (dependencies || []).forEach((dependency)=>{
                const dependencyNamePath = (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(dependency);
                dependencies2fields.update(dependencyNamePath, (fields = new Set())=>{
                    fields.add(field);
                    return fields;
                });
            });
        });
        const fillChildren = (namePath)=>{
            const fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach((field)=>{
                if (!children.has(field)) {
                    children.add(field);
                    const fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    };
    triggerOnFieldsChange = (namePathList, filedErrors)=>{
        const { onFieldsChange: onFieldsChange } = this.callbacks;
        if (onFieldsChange) {
            const fields = this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                const cache = new (0, $199a674a2451f3cf$export$2e2bcd8739ae039)();
                filedErrors.forEach(({ name: name, errors: errors })=>{
                    cache.set(name, errors);
                });
                fields.forEach((field)=>{
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            const changedFields = fields.filter(({ name: fieldName })=>(0, $d58d34b77e6933ea$export$646d5504364ae55b)(namePathList, fieldName));
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    };
    // =========================== Validate ===========================
    validateFields = (arg1, arg2)=>{
        this.warningUnhooked();
        let nameList;
        let options;
        if (Array.isArray(arg1) || typeof arg1 === 'string' || typeof arg2 === 'string') {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        const provideNameList = !!nameList;
        const namePathList = provideNameList ? nameList.map((0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)) : [];
        // Same namePathList, but does not include Form.List name
        const finalValueNamePathList = [
            ...namePathList
        ];
        // Collect result in promise list
        const promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        const TMP_SPLIT = String(Date.now());
        const validateNamePathList = new Set();
        const { recursive: recursive, dirty: dirty } = options || {};
        this.getFieldEntities(true).forEach((field)=>{
            const fieldNamePath = field.getNamePath();
            // Add field if not provide `nameList`
            if (!provideNameList) {
                if (// If is field, pass directly
                !field.isList() || // If is list, do not add if already exist sub field in the namePathList
                !namePathList.some((name)=>(0, $d58d34b77e6933ea$export$325a4bd0e71bdc3a)(name, fieldNamePath, true))) finalValueNamePathList.push(fieldNamePath);
                namePathList.push(fieldNamePath);
            }
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $d58d34b77e6933ea$export$646d5504364ae55b)(namePathList, fieldNamePath, recursive)) {
                const promise = field.validateRules({
                    validateMessages: {
                        ...(0, $2c6f0e4f3dd8c53a$export$c86b939816b8fbf8),
                        ...this.validateMessages
                    },
                    ...options
                });
                // Wrap promise with field
                promiseList.push(promise.then(()=>({
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    })).catch((ruleErrors)=>{
                    const mergedErrors = [];
                    const mergedWarnings = [];
                    ruleErrors.forEach?.(({ rule: { warningOnly: warningOnly }, errors: errors })=>{
                        if (warningOnly) mergedWarnings.push(...errors);
                        else mergedErrors.push(...errors);
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        const summaryPromise = (0, $94ac770596b7f420$export$6152adfdcc6be2b5)(promiseList);
        this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch((results)=>results).then((results)=>{
            const resultNamePathList = results.map(({ name: name })=>name);
            this.notifyObservers(this.store, resultNamePathList, {
                type: 'validateFinish'
            });
            this.triggerOnFieldsChange(resultNamePathList, results);
        });
        const returnPromise = summaryPromise.then(()=>{
            if (this.lastValidatePromise === summaryPromise) return Promise.resolve(this.getFieldsValue(finalValueNamePathList));
            return Promise.reject([]);
        }).catch((results)=>{
            const errorList = results.filter((result)=>result && result.errors.length);
            const errorMessage = errorList[0]?.errors?.[0];
            return Promise.reject({
                message: errorMessage,
                values: this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch((e)=>e);
        // `validating` changed. Trigger `onFieldsChange`
        const triggerNamePathList = namePathList.filter((namePath)=>validateNamePathList.has(namePath.join(TMP_SPLIT)));
        this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    };
    // ============================ Submit ============================
    submit = ()=>{
        this.warningUnhooked();
        this.validateFields().then((values)=>{
            const { onFinish: onFinish } = this.callbacks;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch((e)=>{
            const { onFinishFailed: onFinishFailed } = this.callbacks;
            if (onFinishFailed) onFinishFailed(e);
        });
    };
}
function $7a9a0ec87f59ad35$var$useForm(form) {
    const formRef = $ltGt3.useRef(null);
    const [, forceUpdate] = $ltGt3.useState({});
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            const forceReRender = ()=>{
                forceUpdate({});
            };
            const formStore = new $7a9a0ec87f59ad35$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $7a9a0ec87f59ad35$export$2e2bcd8739ae039 = $7a9a0ec87f59ad35$var$useForm;



var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
const $a269b471a616a6fa$var$FormContext = /*#__PURE__*/ $ltGt3.createContext({
    triggerFormChange: ()=>{},
    triggerFormFinish: ()=>{},
    registerForm: ()=>{},
    unregisterForm: ()=>{}
});
const $a269b471a616a6fa$export$8ce1ff4f94d08846 = ({ validateMessages: validateMessages, onFormChange: onFormChange, onFormFinish: onFormFinish, children: children })=>{
    const formContext = $ltGt3.useContext($a269b471a616a6fa$var$FormContext);
    const formsRef = $ltGt3.useRef({});
    return /*#__PURE__*/ $ltGt3.createElement($a269b471a616a6fa$var$FormContext.Provider, {
        value: {
            ...formContext,
            validateMessages: {
                ...formContext.validateMessages,
                ...validateMessages
            },
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: (name, changedFields)=>{
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: (name, values)=>{
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: (name, form)=>{
                if (name) formsRef.current = {
                    ...formsRef.current,
                    [name]: form
                };
                formContext.registerForm(name, form);
            },
            unregisterForm: (name)=>{
                const newForms = {
                    ...formsRef.current
                };
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        }
    }, children);
};
var $a269b471a616a6fa$export$2e2bcd8739ae039 = $a269b471a616a6fa$var$FormContext;





var $ltGt3 = parcelRequire("ltGt3");
const $5a216d933be83112$var$BatchUpdate = /*#__PURE__*/ $ltGt3.forwardRef((_, ref)=>{
    const [batchInfo, setBatchInfo] = $ltGt3.useState({});
    $ltGt3.useLayoutEffect(()=>{
        const keys = Object.keys(batchInfo);
        if (keys.length) {
            keys.forEach((key)=>{
                batchInfo[key]?.();
            });
            setBatchInfo({});
        }
    }, [
        batchInfo
    ]);
    $ltGt3.useImperativeHandle(ref, ()=>({
            batch: (key, callback)=>{
                setBatchInfo((ori)=>({
                        ...ori,
                        [key]: callback
                    }));
            }
        }));
    return null;
});
var $5a216d933be83112$export$2e2bcd8739ae039 = $5a216d933be83112$var$BatchUpdate;


function $d2fcb0daa192bcb0$var$_extends() {
    $d2fcb0daa192bcb0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d2fcb0daa192bcb0$var$_extends.apply(this, arguments);
}
const $d2fcb0daa192bcb0$var$Form = ({ name: name, initialValues: initialValues, fields: fields, form: form, preserve: preserve, children: children, component: Component = 'form', validateMessages: validateMessages, validateTrigger: validateTrigger = 'onChange', onValuesChange: onValuesChange, onFieldsChange: onFieldsChange, onFinish: onFinish, onFinishFailed: onFinishFailed, clearOnDestroy: clearOnDestroy, ...restProps }, ref)=>{
    const nativeElementRef = $ltGt3.useRef(null);
    const formContext = $ltGt3.useContext((0, $a269b471a616a6fa$export$2e2bcd8739ae039));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    const [formInstance] = (0, $7a9a0ec87f59ad35$export$2e2bcd8739ae039)(form);
    const { useSubscribe: useSubscribe, setInitialValues: setInitialValues, setCallbacks: setCallbacks, setValidateMessages: setValidateMessages, setPreserve: setPreserve, destroyForm: destroyForm, setBatchUpdate: setBatchUpdate } = formInstance.getInternalHooks((0, $1acae32ef7ef7c71$export$24829b7c0e49e9f7));
    // Pass ref with form instance
    $ltGt3.useImperativeHandle(ref, ()=>({
            ...formInstance,
            nativeElement: nativeElementRef.current
        }));
    // Register form into Context
    $ltGt3.useEffect(()=>{
        formContext.registerForm(name, formInstance);
        return ()=>{
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages({
        ...formContext.validateMessages,
        ...validateMessages
    });
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: (changedFields, ...rest)=>{
            formContext.triggerFormChange(name, changedFields);
            if (onFieldsChange) onFieldsChange(changedFields, ...rest);
        },
        onFinish: (values)=>{
            formContext.triggerFormFinish(name, values);
            if (onFinish) onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    const mountRef = $ltGt3.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    // ======================== Batch Update ========================
    // zombieJ:
    // To avoid Form self re-render,
    // We create a sub component `BatchUpdate` to handle batch update logic.
    // When the call with do not change immediate, we will batch the update
    // and flush it in `useLayoutEffect` for next tick.
    // Set batch update ref
    const batchUpdateRef = $ltGt3.useRef(null);
    const batchUpdateTasksRef = $ltGt3.useRef([]);
    const tryFlushBatch = ()=>{
        if (batchUpdateRef.current) {
            batchUpdateTasksRef.current.forEach(([key, fn])=>{
                batchUpdateRef.current.batch(key, fn);
            });
            batchUpdateTasksRef.current = [];
        }
    };
    // Ref update
    const setBatchUpdateRef = $ltGt3.useCallback((batchUpdate)=>{
        batchUpdateRef.current = batchUpdate;
        tryFlushBatch();
    }, []);
    // Task list
    const batchUpdate = (key, callback)=>{
        batchUpdateTasksRef.current.push([
            key,
            callback
        ]);
        tryFlushBatch();
    };
    setBatchUpdate(batchUpdate);
    // ========================== Unmount ===========================
    $ltGt3.useEffect(()=>()=>destroyForm(clearOnDestroy), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    let childrenNode;
    const childrenRenderProps = typeof children === 'function';
    if (childrenRenderProps) {
        const values = formInstance.getFieldsValue(true);
        childrenNode = children(values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    const prevFieldsRef = $ltGt3.useRef(null);
    $ltGt3.useEffect(()=>{
        if (!(0, $d58d34b77e6933ea$export$dfcec05bb7372a54)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    // =========================== Render ===========================
    const formContextValue = $ltGt3.useMemo(()=>({
            ...formInstance,
            validateTrigger: validateTrigger
        }), [
        formInstance,
        validateTrigger
    ]);
    const wrapperNode = /*#__PURE__*/ $ltGt3.createElement((0, $676ce4da8497bef1$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $ltGt3.createElement((0, $1acae32ef7ef7c71$export$2e2bcd8739ae039).Provider, {
        value: formContextValue
    }, childrenNode), /*#__PURE__*/ $ltGt3.createElement((0, $5a216d933be83112$export$2e2bcd8739ae039), {
        ref: setBatchUpdateRef
    }));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $ltGt3.createElement(Component, $d2fcb0daa192bcb0$var$_extends({}, restProps, {
        ref: nativeElementRef,
        onSubmit: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: (event)=>{
            event.preventDefault();
            formInstance.resetFields();
            restProps.onReset?.(event);
        }
    }), wrapperNode);
};
var $d2fcb0daa192bcb0$export$2e2bcd8739ae039 = $d2fcb0daa192bcb0$var$Form;







var $ltGt3 = parcelRequire("ltGt3");




function $6714b6aec552dc79$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch  {
        return Math.random();
    }
}
// ------- selector type -------
// ------- selector type end -------
function $6714b6aec552dc79$var$useWatch(...args) {
    const [dependencies, _form = {}] = args;
    const options = (0, $38393154317a30c8$export$717b316e73068e8d)(_form) ? {
        form: _form
    } : _form;
    const form = options.form;
    const [value, setValue] = (0, $ltGt3.useState)(()=>typeof dependencies === 'function' ? dependencies({}) : undefined);
    const valueStr = (0, $ltGt3.useMemo)(()=>$6714b6aec552dc79$export$fac44ee5b035f737(value), [
        value
    ]);
    const valueStrRef = (0, $ltGt3.useRef)(valueStr);
    valueStrRef.current = valueStr;
    const fieldContext = (0, $ltGt3.useContext)((0, $1acae32ef7ef7c71$export$2e2bcd8739ae039));
    const formInstance = form || fieldContext;
    const isValidForm = formInstance && formInstance._init;
    // ============================== Form ==============================
    const { getFieldsValue: getFieldsValue, getInternalHooks: getInternalHooks } = formInstance;
    const { registerWatch: registerWatch } = getInternalHooks((0, $1acae32ef7ef7c71$export$24829b7c0e49e9f7));
    // ============================= Update =============================
    const triggerUpdate = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((values, allValues)=>{
        const watchValue = options.preserve ? allValues ?? getFieldsValue(true) : values ?? getFieldsValue();
        const nextValue = typeof dependencies === 'function' ? dependencies(watchValue) : (0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(watchValue, (0, $d58d34b77e6933ea$export$f877b3cb4cb4ccf9)(dependencies));
        if ($6714b6aec552dc79$export$fac44ee5b035f737(value) !== $6714b6aec552dc79$export$fac44ee5b035f737(nextValue)) setValue(nextValue);
    });
    // ============================= Effect =============================
    const flattenDeps = typeof dependencies === 'function' ? dependencies : JSON.stringify(dependencies);
    // Deps changed
    (0, $ltGt3.useEffect)(()=>{
        // Skip if not exist form instance
        if (!isValidForm) return;
        triggerUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidForm,
        flattenDeps
    ]);
    // Value changed
    (0, $ltGt3.useEffect)(()=>{
        // Skip if not exist form instance
        if (!isValidForm) return;
        const cancelRegister = registerWatch((values, allValues)=>{
            triggerUpdate(values, allValues);
        });
        return cancelRegister;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidForm
    ]);
    return value;
}
var $6714b6aec552dc79$export$2e2bcd8739ae039 = $6714b6aec552dc79$var$useWatch;


const $757c8c4a45ed0b19$var$InternalForm = /*#__PURE__*/ $ltGt3.forwardRef((0, $d2fcb0daa192bcb0$export$2e2bcd8739ae039));
const $757c8c4a45ed0b19$var$RefForm = $757c8c4a45ed0b19$var$InternalForm;
$757c8c4a45ed0b19$var$RefForm.FormProvider = (0, $a269b471a616a6fa$export$8ce1ff4f94d08846);
$757c8c4a45ed0b19$var$RefForm.Field = (0, $62bb5a895295f340$export$2e2bcd8739ae039);
$757c8c4a45ed0b19$var$RefForm.List = (0, $027e12733387be9a$export$2e2bcd8739ae039);
$757c8c4a45ed0b19$var$RefForm.useForm = (0, $7a9a0ec87f59ad35$export$2e2bcd8739ae039);
$757c8c4a45ed0b19$var$RefForm.useWatch = (0, $6714b6aec552dc79$export$2e2bcd8739ae039);
var $757c8c4a45ed0b19$export$2e2bcd8739ae039 = $757c8c4a45ed0b19$var$RefForm;



"use client";
const $2fc8703031980156$export$c24727297075ec6a = /*#__PURE__*/ $ltGt3.createContext({
    labelAlign: 'right',
    layout: 'horizontal',
    itemRef: ()=>{}
});
const $2fc8703031980156$export$d718247e9f9b0b9e = /*#__PURE__*/ $ltGt3.createContext(null);
const $2fc8703031980156$export$8ce1ff4f94d08846 = (props)=>{
    const providerProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $a269b471a616a6fa$export$8ce1ff4f94d08846), {
        ...providerProps
    });
};
const $2fc8703031980156$export$fb6582d3042cc879 = /*#__PURE__*/ $ltGt3.createContext({
    prefixCls: ''
});
const $2fc8703031980156$export$bbb5553c6c7a14ed = /*#__PURE__*/ $ltGt3.createContext({});
const $2fc8703031980156$export$80e4c53cb85dcab1 = ({ children: children, status: status, override: override })=>{
    const formItemInputContext = $ltGt3.useContext($2fc8703031980156$export$bbb5553c6c7a14ed);
    const newFormItemInputContext = $ltGt3.useMemo(()=>{
        const newContext = {
            ...formItemInputContext
        };
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $ltGt3.createElement($2fc8703031980156$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};
const $2fc8703031980156$export$6f0555dad42725fb = /*#__PURE__*/ $ltGt3.createContext(undefined);



"use client";
const $31ba6c57c6d43aeb$var$ContextIsolator = (props)=>{
    const { space: space, form: form, children: children } = props;
    if (children === undefined || children === null) return null;
    let result = children;
    if (form) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $2fc8703031980156$export$80e4c53cb85dcab1), {
        override: true,
        status: true
    }, result);
    if (space) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $8eabd28975be2fa5$export$5f56e610a4afb685), null, result);
    return result;
};
var $31ba6c57c6d43aeb$export$2e2bcd8739ae039 = $31ba6c57c6d43aeb$var$ContextIsolator;



var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
const $cba857b93cac085e$var$zIndexContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createContext(undefined);
var $cba857b93cac085e$export$2e2bcd8739ae039 = $cba857b93cac085e$var$zIndexContext;


// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const $ad5b6b465efa8f67$var$CONTAINER_OFFSET = 100;
const $ad5b6b465efa8f67$var$CONTAINER_OFFSET_MAX_COUNT = 10;
const $ad5b6b465efa8f67$export$33ada7d8845f7e5 = $ad5b6b465efa8f67$var$CONTAINER_OFFSET * $ad5b6b465efa8f67$var$CONTAINER_OFFSET_MAX_COUNT;
/**
 * Static function will default be the `CONTAINER_MAX_OFFSET`.
 * But it still may have children component like Select, Dropdown.
 * So the warning zIndex should exceed the `CONTAINER_MAX_OFFSET`.
 */ const $ad5b6b465efa8f67$var$CONTAINER_MAX_OFFSET_WITH_CHILDREN = $ad5b6b465efa8f67$export$33ada7d8845f7e5 + $ad5b6b465efa8f67$var$CONTAINER_OFFSET;
const $ad5b6b465efa8f67$export$1658852af8bb2a55 = {
    Modal: $ad5b6b465efa8f67$var$CONTAINER_OFFSET,
    Drawer: $ad5b6b465efa8f67$var$CONTAINER_OFFSET,
    Popover: $ad5b6b465efa8f67$var$CONTAINER_OFFSET,
    Popconfirm: $ad5b6b465efa8f67$var$CONTAINER_OFFSET,
    Tooltip: $ad5b6b465efa8f67$var$CONTAINER_OFFSET,
    Tour: $ad5b6b465efa8f67$var$CONTAINER_OFFSET,
    FloatButton: $ad5b6b465efa8f67$var$CONTAINER_OFFSET
};
const $ad5b6b465efa8f67$export$3f7a364c708f940b = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
const $ad5b6b465efa8f67$var$isContainerType = (type)=>{
    return type in $ad5b6b465efa8f67$export$1658852af8bb2a55;
};
const $ad5b6b465efa8f67$export$3e7906d4075187a4 = (componentType, customZIndex)=>{
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const parentZIndex = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $cba857b93cac085e$export$2e2bcd8739ae039));
    const isContainer = $ad5b6b465efa8f67$var$isContainerType(componentType);
    let result;
    if (customZIndex !== undefined) result = [
        customZIndex,
        customZIndex
    ];
    else {
        let zIndex = parentZIndex ?? 0;
        if (isContainer) zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        $ad5b6b465efa8f67$export$1658852af8bb2a55[componentType];
        else zIndex += $ad5b6b465efa8f67$export$3f7a364c708f940b[componentType];
        result = [
            parentZIndex === undefined ? customZIndex : zIndex,
            zIndex
        ];
    }
    return result;
};





function $bf6e216ed4fab7a5$export$87e38ee403661ccc(token) {
    const { sizePopupArrow: sizePopupArrow, borderRadiusXS: borderRadiusXS, borderRadiusOuter: borderRadiusOuter } = token;
    const unitWidth = sizePopupArrow / 2;
    const ax = 0;
    const ay = unitWidth;
    const bx = borderRadiusOuter * 1 / Math.sqrt(2);
    const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
    const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
    const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
    const dx = 2 * unitWidth - cx;
    const dy = cy;
    const ex = 2 * unitWidth - bx;
    const ey = by;
    const fx = 2 * unitWidth - ax;
    const fy = ay;
    const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
    const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
    const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
    const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
    return {
        arrowShadowWidth: shadowWidth,
        arrowPath: arrowPath,
        arrowPolygon: arrowPolygon
    };
}
const $bf6e216ed4fab7a5$export$601fa0375eb80eec = (token, bgColor, boxShadow)=>{
    const { sizePopupArrow: sizePopupArrow, arrowPolygon: arrowPolygon, arrowPath: arrowPath, arrowShadowWidth: arrowShadowWidth, borderRadiusXS: borderRadiusXS, calc: calc } = token;
    return {
        pointerEvents: 'none',
        width: sizePopupArrow,
        height: sizePopupArrow,
        overflow: 'hidden',
        '&::before': {
            position: 'absolute',
            bottom: 0,
            insetInlineStart: 0,
            width: sizePopupArrow,
            height: calc(sizePopupArrow).div(2).equal(),
            background: bgColor,
            clipPath: {
                _multi_value_: true,
                value: [
                    arrowPolygon,
                    arrowPath
                ]
            },
            content: '""'
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            width: arrowShadowWidth,
            height: arrowShadowWidth,
            bottom: 0,
            insetInline: 0,
            margin: 'auto',
            borderRadius: {
                _skip_check_: true,
                value: `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(borderRadiusXS)} 0`
            },
            transform: 'translateY(50%) rotate(-135deg)',
            boxShadow: boxShadow,
            zIndex: 0,
            background: 'transparent'
        }
    };
};


const $f61b43f1533e9f98$export$de6e4ffc9ec3c089 = 8;
function $f61b43f1533e9f98$export$bddc192327bb9823(options) {
    const { contentRadius: contentRadius, limitVerticalRadius: limitVerticalRadius } = options;
    const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    const arrowOffsetVertical = limitVerticalRadius ? $f61b43f1533e9f98$export$de6e4ffc9ec3c089 : arrowOffset;
    return {
        arrowOffsetHorizontal: arrowOffset,
        arrowOffsetVertical: arrowOffsetVertical
    };
}
function $f61b43f1533e9f98$var$isInject(valid, code) {
    if (!valid) return {};
    return code;
}
function $f61b43f1533e9f98$export$2e2bcd8739ae039(token, colorBg, options) {
    const { componentCls: componentCls, boxShadowPopoverArrow: boxShadowPopoverArrow, arrowOffsetVertical: arrowOffsetVertical, arrowOffsetHorizontal: arrowOffsetHorizontal } = token;
    const { arrowDistance: arrowDistance = 0, arrowPlacement: arrowPlacement = {
        left: true,
        right: true,
        top: true,
        bottom: true
    } } = options || {};
    return {
        [componentCls]: {
            // ============================ Basic ============================
            [`${componentCls}-arrow`]: [
                {
                    position: 'absolute',
                    zIndex: 1,
                    // lift it up so the menu wouldn't cask shadow on it
                    display: 'block',
                    ...(0, $bf6e216ed4fab7a5$export$601fa0375eb80eec)(token, colorBg, boxShadowPopoverArrow),
                    '&:before': {
                        background: colorBg
                    }
                }
            ],
            // ========================== Placement ==========================
            // Here handle the arrow position and rotate stuff
            // >>>>> Top
            ...$f61b43f1533e9f98$var$isInject(!!arrowPlacement.top, {
                [[
                    `&-placement-top > ${componentCls}-arrow`,
                    `&-placement-topLeft > ${componentCls}-arrow`,
                    `&-placement-topRight > ${componentCls}-arrow`
                ].join(',')]: {
                    bottom: arrowDistance,
                    transform: 'translateY(100%) rotate(180deg)'
                },
                [`&-placement-top > ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translateX(-50%) translateY(100%) rotate(180deg)'
                },
                '&-placement-topLeft': {
                    '--arrow-offset-horizontal': arrowOffsetHorizontal,
                    [`> ${componentCls}-arrow`]: {
                        left: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                },
                '&-placement-topRight': {
                    '--arrow-offset-horizontal': `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(arrowOffsetHorizontal)})`,
                    [`> ${componentCls}-arrow`]: {
                        right: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                }
            }),
            // >>>>> Bottom
            ...$f61b43f1533e9f98$var$isInject(!!arrowPlacement.bottom, {
                [[
                    `&-placement-bottom > ${componentCls}-arrow`,
                    `&-placement-bottomLeft > ${componentCls}-arrow`,
                    `&-placement-bottomRight > ${componentCls}-arrow`
                ].join(',')]: {
                    top: arrowDistance,
                    transform: `translateY(-100%)`
                },
                [`&-placement-bottom > ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: `translateX(-50%) translateY(-100%)`
                },
                '&-placement-bottomLeft': {
                    '--arrow-offset-horizontal': arrowOffsetHorizontal,
                    [`> ${componentCls}-arrow`]: {
                        left: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                },
                '&-placement-bottomRight': {
                    '--arrow-offset-horizontal': `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(arrowOffsetHorizontal)})`,
                    [`> ${componentCls}-arrow`]: {
                        right: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                }
            }),
            // >>>>> Left
            ...$f61b43f1533e9f98$var$isInject(!!arrowPlacement.left, {
                [[
                    `&-placement-left > ${componentCls}-arrow`,
                    `&-placement-leftTop > ${componentCls}-arrow`,
                    `&-placement-leftBottom > ${componentCls}-arrow`
                ].join(',')]: {
                    right: {
                        _skip_check_: true,
                        value: arrowDistance
                    },
                    transform: 'translateX(100%) rotate(90deg)'
                },
                [`&-placement-left > ${componentCls}-arrow`]: {
                    top: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translateY(-50%) translateX(100%) rotate(90deg)'
                },
                [`&-placement-leftTop > ${componentCls}-arrow`]: {
                    top: arrowOffsetVertical
                },
                [`&-placement-leftBottom > ${componentCls}-arrow`]: {
                    bottom: arrowOffsetVertical
                }
            }),
            // >>>>> Right
            ...$f61b43f1533e9f98$var$isInject(!!arrowPlacement.right, {
                [[
                    `&-placement-right > ${componentCls}-arrow`,
                    `&-placement-rightTop > ${componentCls}-arrow`,
                    `&-placement-rightBottom > ${componentCls}-arrow`
                ].join(',')]: {
                    left: {
                        _skip_check_: true,
                        value: arrowDistance
                    },
                    transform: 'translateX(-100%) rotate(-90deg)'
                },
                [`&-placement-right > ${componentCls}-arrow`]: {
                    top: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translateY(-50%) translateX(-100%) rotate(-90deg)'
                },
                [`&-placement-rightTop > ${componentCls}-arrow`]: {
                    top: arrowOffsetVertical
                },
                [`&-placement-rightBottom > ${componentCls}-arrow`]: {
                    bottom: arrowOffsetVertical
                }
            })
        }
    };
}


function $a4d52b87871d5972$export$fde75e5b410c093f(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) return {
        adjustX: false,
        adjustY: false
    };
    const overflow = autoAdjustOverflow && typeof autoAdjustOverflow === 'object' ? autoAdjustOverflow : {};
    const baseOverflow = {};
    switch(placement){
        case 'top':
        case 'bottom':
            baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
            baseOverflow.shiftY = true;
            baseOverflow.adjustY = true;
            break;
        case 'left':
        case 'right':
            baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
            baseOverflow.shiftX = true;
            baseOverflow.adjustX = true;
            break;
    }
    const mergedOverflow = {
        ...baseOverflow,
        ...overflow
    };
    // Support auto shift
    if (!mergedOverflow.shiftX) mergedOverflow.adjustX = true;
    if (!mergedOverflow.shiftY) mergedOverflow.adjustY = true;
    return mergedOverflow;
}
const $a4d52b87871d5972$var$PlacementAlignMap = {
    left: {
        points: [
            'cr',
            'cl'
        ]
    },
    right: {
        points: [
            'cl',
            'cr'
        ]
    },
    top: {
        points: [
            'bc',
            'tc'
        ]
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ]
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tr'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ]
    }
};
const $a4d52b87871d5972$var$ArrowCenterPlacementAlignMap = {
    topLeft: {
        points: [
            'bl',
            'tc'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'cl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tc'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'cr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'bc'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'cr'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bc'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'cl'
        ]
    }
};
const $a4d52b87871d5972$var$DisableAutoArrowList = new Set([
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom'
]);
function $a4d52b87871d5972$export$2e2bcd8739ae039(config) {
    const { arrowWidth: arrowWidth, autoAdjustOverflow: autoAdjustOverflow, arrowPointAtCenter: arrowPointAtCenter, offset: offset, borderRadius: borderRadius, visibleFirst: visibleFirst } = config;
    const halfArrowWidth = arrowWidth / 2;
    const placementMap = {};
    // Dynamic offset
    const arrowOffset = (0, $f61b43f1533e9f98$export$bddc192327bb9823)({
        contentRadius: borderRadius,
        limitVerticalRadius: true
    });
    Object.keys($a4d52b87871d5972$var$PlacementAlignMap).forEach((key)=>{
        const template = arrowPointAtCenter && $a4d52b87871d5972$var$ArrowCenterPlacementAlignMap[key] || $a4d52b87871d5972$var$PlacementAlignMap[key];
        const placementInfo = {
            ...template,
            offset: [
                0,
                0
            ],
            dynamicInset: true
        };
        placementMap[key] = placementInfo;
        // Disable autoArrow since design is fixed position
        if ($a4d52b87871d5972$var$DisableAutoArrowList.has(key)) placementInfo.autoArrow = false;
        // Static offset
        switch(key){
            case 'top':
            case 'topLeft':
            case 'topRight':
                placementInfo.offset[1] = -halfArrowWidth - offset;
                break;
            case 'bottom':
            case 'bottomLeft':
            case 'bottomRight':
                placementInfo.offset[1] = halfArrowWidth + offset;
                break;
            case 'left':
            case 'leftTop':
            case 'leftBottom':
                placementInfo.offset[0] = -halfArrowWidth - offset;
                break;
            case 'right':
            case 'rightTop':
            case 'rightBottom':
                placementInfo.offset[0] = halfArrowWidth + offset;
                break;
        }
        if (arrowPointAtCenter) switch(key){
            case 'topLeft':
            case 'bottomLeft':
                placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case 'topRight':
            case 'bottomRight':
                placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
            case 'leftTop':
            case 'rightTop':
                placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal * 2 + halfArrowWidth;
                break;
            case 'leftBottom':
            case 'rightBottom':
                placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal * 2 - halfArrowWidth;
                break;
        }
        // Overflow
        placementInfo.overflow = $a4d52b87871d5972$export$fde75e5b410c093f(key, arrowOffset, arrowWidth, autoAdjustOverflow);
        // VisibleFirst
        if (visibleFirst) placementInfo.htmlRegion = 'visibleFirst';
    });
    return placementMap;
}






/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */ const $7422cbcd731d5b67$var$useCSSVarCls = (prefixCls)=>`${prefixCls}-css-var`;
var $7422cbcd731d5b67$export$2e2bcd8739ae039 = $7422cbcd731d5b67$var$useCSSVarCls;




var $ltGt3 = parcelRequire("ltGt3");
const $3707a18e8e736900$var$useMergedArrow = (providedArrow, providedContextArrow)=>{
    const toConfig = (arrow)=>typeof arrow === 'boolean' ? {
            show: arrow
        } : arrow || {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        const arrowConfig = toConfig(providedArrow);
        const contextArrowConfig = toConfig(providedContextArrow);
        return {
            ...contextArrowConfig,
            ...arrowConfig,
            show: arrowConfig.show ?? contextArrowConfig.show ?? true
        };
    }, [
        providedArrow,
        providedContextArrow
    ]);
};
var $3707a18e8e736900$export$2e2bcd8739ae039 = $3707a18e8e736900$var$useMergedArrow;



var $ltGt3 = parcelRequire("ltGt3");








const $ce8f91b8b06c1cd8$var$initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const $ce8f91b8b06c1cd8$var$initMotionCommonLeave = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
const $ce8f91b8b06c1cd8$export$83e1da9e09ec9112 = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false)=>{
    const sameLevelPrefix = sameLevel ? '&' : '';
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: {
            ...$ce8f91b8b06c1cd8$var$initMotionCommon(duration),
            animationPlayState: 'paused'
        },
        [`${sameLevelPrefix}${motionCls}-leave`]: {
            ...$ce8f91b8b06c1cd8$var$initMotionCommonLeave(duration),
            animationPlayState: 'paused'
        },
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: 'running'
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: 'running',
            pointerEvents: 'none'
        }
    };
};


const $0aa79fac63008607$export$82e6205b15e6c637 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antFadeIn', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
const $0aa79fac63008607$export$c091916f1530334c = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antFadeOut', {
    '0%': {
        opacity: 1
    },
    '100%': {
        opacity: 0
    }
});
const $0aa79fac63008607$export$2909268c8354a12 = (token, sameLevel = false)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? '&' : '';
    return [
        (0, $ce8f91b8b06c1cd8$export$83e1da9e09ec9112)(motionCls, $0aa79fac63008607$export$82e6205b15e6c637, $0aa79fac63008607$export$c091916f1530334c, token.motionDurationMid, sameLevel),
        {
            [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: 'linear'
            },
            [`${sameLevelPrefix}${motionCls}-leave`]: {
                animationTimingFunction: 'linear'
            }
        }
    ];
};



const $29a43b27eddd598a$export$3b71758b3ed5255f = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomIn', {
    '0%': {
        transform: 'scale(0.2)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $29a43b27eddd598a$export$9fdb0a49c6b4b521 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.2)',
        opacity: 0
    }
});
const $29a43b27eddd598a$export$be061d573c42e33a = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomBigIn', {
    '0%': {
        transform: 'scale(0.8)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $29a43b27eddd598a$export$582d93d613303da3 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomBigOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.8)',
        opacity: 0
    }
});
const $29a43b27eddd598a$export$45eddd18c599b827 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomUpIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    }
});
const $29a43b27eddd598a$export$a85c97750adaa37a = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomUpOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    }
});
const $29a43b27eddd598a$export$bd2378f7814f5f1a = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomLeftIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    }
});
const $29a43b27eddd598a$export$e58f88c751c4f04e = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomLeftOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    }
});
const $29a43b27eddd598a$export$fee1456954aef331 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomRightIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    }
});
const $29a43b27eddd598a$export$811ba6d3e2adb730 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomRightOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    }
});
const $29a43b27eddd598a$export$633a68aa72dec21c = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomDownIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    }
});
const $29a43b27eddd598a$export$1cf46a906e8dede4 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomDownOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    }
});
const $29a43b27eddd598a$var$zoomMotion = {
    zoom: {
        inKeyframes: $29a43b27eddd598a$export$3b71758b3ed5255f,
        outKeyframes: $29a43b27eddd598a$export$9fdb0a49c6b4b521
    },
    'zoom-big': {
        inKeyframes: $29a43b27eddd598a$export$be061d573c42e33a,
        outKeyframes: $29a43b27eddd598a$export$582d93d613303da3
    },
    'zoom-big-fast': {
        inKeyframes: $29a43b27eddd598a$export$be061d573c42e33a,
        outKeyframes: $29a43b27eddd598a$export$582d93d613303da3
    },
    'zoom-left': {
        inKeyframes: $29a43b27eddd598a$export$bd2378f7814f5f1a,
        outKeyframes: $29a43b27eddd598a$export$e58f88c751c4f04e
    },
    'zoom-right': {
        inKeyframes: $29a43b27eddd598a$export$fee1456954aef331,
        outKeyframes: $29a43b27eddd598a$export$811ba6d3e2adb730
    },
    'zoom-up': {
        inKeyframes: $29a43b27eddd598a$export$45eddd18c599b827,
        outKeyframes: $29a43b27eddd598a$export$a85c97750adaa37a
    },
    'zoom-down': {
        inKeyframes: $29a43b27eddd598a$export$633a68aa72dec21c,
        outKeyframes: $29a43b27eddd598a$export$1cf46a906e8dede4
    }
};
const $29a43b27eddd598a$export$f5d123412490d9dc = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $29a43b27eddd598a$var$zoomMotion[motionName];
    return [
        (0, $ce8f91b8b06c1cd8$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, motionName === 'zoom-big-fast' ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: 'scale(0)',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                '&-prepare': {
                    transform: 'none'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};





function $a6826a70be89cfee$export$2e2bcd8739ae039(token, genCss) {
    return (0, $e1e3919c46d634bc$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>{
        const lightColor = token[`${colorKey}1`];
        const lightBorderColor = token[`${colorKey}3`];
        const darkColor = token[`${colorKey}6`];
        const textColor = token[`${colorKey}7`];
        return {
            ...prev,
            ...genCss(colorKey, {
                lightColor: lightColor,
                lightBorderColor: lightBorderColor,
                darkColor: darkColor,
                textColor: textColor
            })
        };
    }, {});
}


const $e01da0a106a01385$var$genTooltipStyle = (token)=>{
    const { calc: calc, componentCls: componentCls, tooltipMaxWidth: // ant-tooltip
    tooltipMaxWidth, tooltipColor: tooltipColor, tooltipBg: tooltipBg, tooltipBorderRadius: tooltipBorderRadius, zIndexPopup: zIndexPopup, controlHeight: controlHeight, boxShadowSecondary: boxShadowSecondary, paddingSM: paddingSM, paddingXS: paddingXS, arrowOffsetHorizontal: arrowOffsetHorizontal, sizePopupArrow: sizePopupArrow } = token;
    // arrowOffsetHorizontal + arrowWidth + borderRadius
    const edgeAlignMinWidth = calc(tooltipBorderRadius).add(sizePopupArrow).add(arrowOffsetHorizontal).equal();
    // borderRadius * 2 + arrowWidth
    const centerAlignMinWidth = calc(tooltipBorderRadius).mul(2).add(sizePopupArrow).equal();
    const sharedBodyStyle = {
        minWidth: centerAlignMinWidth,
        minHeight: controlHeight,
        padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(paddingSM).div(2).equal())} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)}`,
        color: `var(--ant-tooltip-color, ${tooltipColor})`,
        textAlign: 'start',
        textDecoration: 'none',
        wordWrap: 'break-word',
        backgroundColor: tooltipBg,
        borderRadius: tooltipBorderRadius,
        boxShadow: boxShadowSecondary,
        boxSizing: 'border-box'
    };
    const sharedTransformOrigin = {
        // When use `autoArrow`, origin will follow the arrow position
        '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
        transformOrigin: [
            `var(--valid-offset-x, 50%)`,
            `var(--arrow-y, 50%)`
        ].join(' ')
    };
    return [
        {
            [componentCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                position: 'absolute',
                zIndex: zIndexPopup,
                display: 'block',
                width: 'max-content',
                maxWidth: tooltipMaxWidth,
                visibility: 'visible',
                ...sharedTransformOrigin,
                '&-hidden': {
                    display: 'none'
                },
                '--antd-arrow-background-color': tooltipBg,
                // Wrapper for the tooltip content
                [`${componentCls}-container`]: [
                    sharedBodyStyle,
                    (0, $0aa79fac63008607$export$2909268c8354a12)(token, true)
                ],
                [`&:has(~ ${componentCls}-unique-container)`]: {
                    [`${componentCls}-container`]: {
                        border: 'none',
                        background: 'transparent',
                        boxShadow: 'none'
                    }
                },
                // Align placement should have another min width
                [[
                    `&-placement-topLeft`,
                    `&-placement-topRight`,
                    `&-placement-bottomLeft`,
                    `&-placement-bottomRight`
                ].join(',')]: {
                    minWidth: edgeAlignMinWidth
                },
                // Limit left and right placement radius
                [[
                    `&-placement-left`,
                    `&-placement-leftTop`,
                    `&-placement-leftBottom`,
                    `&-placement-right`,
                    `&-placement-rightTop`,
                    `&-placement-rightBottom`
                ].join(',')]: {
                    [`${componentCls}-inner`]: {
                        borderRadius: token.min(tooltipBorderRadius, (0, $f61b43f1533e9f98$export$de6e4ffc9ec3c089))
                    }
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                },
                // generator for preset color
                ...(0, $a6826a70be89cfee$export$2e2bcd8739ae039)(token, (colorKey, { darkColor: darkColor })=>({
                        [`&${componentCls}-${colorKey}`]: {
                            [`${componentCls}-container`]: {
                                backgroundColor: darkColor
                            },
                            [`${componentCls}-arrow`]: {
                                '--antd-arrow-background-color': darkColor
                            }
                        }
                    })),
                // RTL
                '&-rtl': {
                    direction: 'rtl'
                }
            }
        },
        // Arrow Style
        (0, $f61b43f1533e9f98$export$2e2bcd8739ae039)(token, 'var(--antd-arrow-background-color)'),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow
            }
        },
        // Unique Body
        {
            [`${componentCls}-unique-container`]: {
                ...sharedBodyStyle,
                ...sharedTransformOrigin,
                position: 'absolute',
                zIndex: calc(zIndexPopup).sub(1).equal(),
                '&-hidden': {
                    display: 'none'
                },
                '&-visible': {
                    transition: `all ${token.motionDurationSlow}`
                }
            }
        }
    ];
};
const $e01da0a106a01385$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 70,
        ...(0, $f61b43f1533e9f98$export$bddc192327bb9823)({
            contentRadius: token.borderRadius,
            limitVerticalRadius: true
        }),
        ...(0, $bf6e216ed4fab7a5$export$87e38ee403661ccc)((0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
            borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
        }))
    });
var $e01da0a106a01385$export$2e2bcd8739ae039 = (prefixCls, rootCls, injectStyle = true)=>{
    const useStyle = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Tooltip', (token)=>{
        const { borderRadius: borderRadius, colorTextLightSolid: colorTextLightSolid, colorBgSpotlight: colorBgSpotlight } = token;
        const TooltipToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
            // default variables
            tooltipMaxWidth: 250,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: borderRadius,
            tooltipBg: colorBgSpotlight
        });
        return [
            $e01da0a106a01385$var$genTooltipStyle(TooltipToken),
            (0, $29a43b27eddd598a$export$f5d123412490d9dc)(token, 'zoom-big-fast')
        ];
    }, $e01da0a106a01385$export$9ca1be8807fe0675, {
        resetStyle: false,
        injectStyle: // Popover use Tooltip as internal component. We do not need to handle this.
        injectStyle
    });
    return useStyle(prefixCls, rootCls);
};





const $af9f1fd0e95fb060$var$inverseColors = (0, $e1e3919c46d634bc$export$6d4fe3a00a1811ad).map((color)=>`${color}-inverse`);
const $af9f1fd0e95fb060$export$2c43cb57a48fae33 = [
    'success',
    'processing',
    'error',
    'default',
    'warning'
];
function $af9f1fd0e95fb060$export$ee62ebd6a58c4884(color, includeInverse = true) {
    if (includeInverse) return [].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)($af9f1fd0e95fb060$var$inverseColors), (0, $83d01b7684a01087$export$2e2bcd8739ae039)((0, $e1e3919c46d634bc$export$6d4fe3a00a1811ad))).includes(color);
    return (0, $e1e3919c46d634bc$export$6d4fe3a00a1811ad).includes(color);
}
function $af9f1fd0e95fb060$export$88a0ba1f7d1ea40e(color) {
    return $af9f1fd0e95fb060$export$2c43cb57a48fae33.includes(color);
}



function $947c8836ff28eb23$export$6e865ea70d7724f(prefixCls, color) {
    const isInternalColor = (0, $af9f1fd0e95fb060$export$ee62ebd6a58c4884)(color);
    const className = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
        [`${prefixCls}-${color}`]: color && isInternalColor
    });
    const overlayStyle = {};
    const arrowStyle = {};
    const rgb = (0, $7b39b87e9e2a171b$export$c844f5d21427d1ab)(color).toRgb();
    const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
    const textColor = luminance < 0.5 ? '#FFF' : '#000';
    if (color && !isInternalColor) {
        overlayStyle.background = color;
        overlayStyle['--ant-tooltip-color'] = textColor;
        // @ts-ignore
        arrowStyle['--antd-arrow-background-color'] = color;
    }
    return {
        className: className,
        overlayStyle: overlayStyle,
        arrowStyle: arrowStyle
    };
}


"use client";
/** @private Internal Component. Do not use in your production. */ const $4941a1c9087dcf56$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, placement: placement = 'top', title: title, color: color, overlayInnerStyle: overlayInnerStyle, classNames: classNames, styles: styles } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $e01da0a106a01385$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // Color
    const colorInfo = (0, $947c8836ff28eb23$export$6e865ea70d7724f)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const innerStyles = $ltGt3.useMemo(()=>{
        const mergedStyle = {
            ...overlayInnerStyle,
            ...colorInfo.overlayStyle
        };
        return {
            container: mergedStyle
        };
    }, [
        overlayInnerStyle,
        colorInfo.overlayStyle
    ]);
    const mergedProps = {
        ...props,
        placement: placement
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        classNames
    ], [
        innerStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(rootCls, hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: rootClassName,
        style: arrowContentStyle
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $ltGt3.createElement((0, $57b616b1a2d66246$export$2e2bcd8739ae039), {
        ...props,
        className: hashId,
        prefixCls: prefixCls,
        classNames: mergedClassNames,
        styles: mergedStyles
    }, title));
};
var $4941a1c9087dcf56$export$2e2bcd8739ae039 = $4941a1c9087dcf56$var$PurePanel;





"use client";
const $450c77e4cd681750$var$InternalTooltip = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, openClassName: openClassName, getTooltipContainer: getTooltipContainer, color: color, children: children, afterOpenChange: afterOpenChange, arrow: tooltipArrow, destroyTooltipOnHide: destroyTooltipOnHide, destroyOnHidden: destroyOnHidden, title: title, overlay: overlay, builtinPlacements: builtinPlacements, autoAdjustOverflow: autoAdjustOverflow = true, motion: motion, getPopupContainer: getPopupContainer, placement: placement = 'top', mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, rootClassName: rootClassName, styles: styles, classNames: classNames, onOpenChange: onOpenChange, overlayInnerStyle: // Legacy
    overlayInnerStyle, overlayStyle: overlayStyle, overlayClassName: overlayClassName, ...restProps } = props;
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('tooltip');
    const mergedArrow = (0, $3707a18e8e736900$export$2e2bcd8739ae039)(tooltipArrow, contextArrow);
    const mergedShowArrow = mergedArrow.show;
    // ============================== Ref ===============================
    const warning = (0, $9530c27c700696d0$export$cf977aa92c751e61)('Tooltip');
    const tooltipRef = $ltGt3.useRef(null);
    const forceAlign = ()=>{
        tooltipRef.current?.forceAlign();
    };
    $ltGt3.useImperativeHandle(ref, ()=>({
            forceAlign: forceAlign,
            nativeElement: tooltipRef.current?.nativeElement,
            popupElement: tooltipRef.current?.popupElement
        }));
    var deprecatedName, newName;
    // ============================== Open ==============================
    const [open, setOpen] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(props.defaultOpen ?? false, props.open);
    const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
    const onInternalOpenChange = (vis)=>{
        setOpen(noTitle ? false : vis);
        if (!noTitle && onOpenChange) onOpenChange(vis);
    };
    const tooltipPlacements = $ltGt3.useMemo(()=>{
        return builtinPlacements || (0, $a4d52b87871d5972$export$2e2bcd8739ae039)({
            arrowPointAtCenter: mergedArrow?.pointAtCenter ?? false,
            autoAdjustOverflow: autoAdjustOverflow,
            arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
            borderRadius: token.borderRadius,
            offset: token.marginXXS,
            visibleFirst: true
        });
    }, [
        mergedArrow,
        builtinPlacements,
        token,
        mergedShowArrow,
        autoAdjustOverflow
    ]);
    const memoOverlay = $ltGt3.useMemo(()=>{
        if (title === 0) return title;
        return overlay || title || '';
    }, [
        overlay,
        title
    ]);
    const memoOverlayWrapper = /*#__PURE__*/ $ltGt3.createElement((0, $31ba6c57c6d43aeb$export$2e2bcd8739ae039), {
        space: true
    }, typeof memoOverlay === 'function' ? memoOverlay() : memoOverlay);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        color: color,
        placement: placement,
        builtinPlacements: builtinPlacements,
        openClassName: openClassName,
        arrow: tooltipArrow,
        autoAdjustOverflow: autoAdjustOverflow,
        getPopupContainer: getPopupContainer,
        children: children,
        destroyTooltipOnHide: destroyTooltipOnHide,
        destroyOnHidden: destroyOnHidden
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const injectFromPopover = props['data-popover-inject'];
    let tempOpen = open;
    // Hide tooltip when there is no title
    if (!('open' in props) && noTitle) tempOpen = false;
    // ============================= Render =============================
    const child = /*#__PURE__*/ $ltGt3.isValidElement(children) && !(0, $66d38239e1a27993$export$9522e17588c12572)(children) ? children : /*#__PURE__*/ $ltGt3.createElement("span", null, children);
    const childProps = child.props;
    const childCls = !childProps.className || typeof childProps.className === 'string' ? (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
    // Style
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $e01da0a106a01385$export$2e2bcd8739ae039)(prefixCls, rootCls, !injectFromPopover);
    // Color
    const colorInfo = (0, $947c8836ff28eb23$export$6e865ea70d7724f)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const themeCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(rootCls, hashId, cssVarCls);
    const rootClassNames = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(overlayClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, colorInfo.className, rootClassName, themeCls, contextClassName, mergedClassNames.root);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $ad5b6b465efa8f67$export$3e7906d4075187a4)('Tooltip', restProps.zIndex);
    const containerStyle = {
        ...mergedStyles.container,
        ...overlayInnerStyle,
        ...colorInfo.overlayStyle
    };
    const content = /*#__PURE__*/ $ltGt3.createElement((0, $7641515d641df2dc$export$2e2bcd8739ae039), {
        unique: true,
        ...restProps,
        zIndex: zIndex,
        showArrow: mergedShowArrow,
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow,
            uniqueContainer: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(themeCls, mergedClassNames.container)
        },
        styles: {
            root: {
                ...arrowContentStyle,
                ...mergedStyles.root,
                ...contextStyle,
                ...overlayStyle
            },
            container: containerStyle,
            uniqueContainer: containerStyle,
            arrow: mergedStyles.arrow
        },
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: tooltipRef,
        builtinPlacements: tooltipPlacements,
        overlay: memoOverlayWrapper,
        visible: tempOpen,
        onVisibleChange: onInternalOpenChange,
        afterVisibleChange: afterOpenChange,
        arrowContent: /*#__PURE__*/ $ltGt3.createElement("span", {
            className: `${prefixCls}-arrow-content`
        }),
        motion: {
            motionName: (0, $32c4c593a0d4aef5$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big-fast', typeof motion?.motionName === 'string' ? motion?.motionName : undefined),
            motionDeadline: 1000
        },
        destroyOnHidden: destroyOnHidden ?? !!destroyTooltipOnHide
    }, tempOpen ? (0, $66d38239e1a27993$export$e530037191fcd5d7)(child, {
        className: childCls
    }) : child);
    return /*#__PURE__*/ $ltGt3.createElement((0, $cba857b93cac085e$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, content);
});
const $450c77e4cd681750$var$Tooltip = $450c77e4cd681750$var$InternalTooltip;
$450c77e4cd681750$var$Tooltip._InternalPanelDoNotUseOrYouWillBeFired = (0, $4941a1c9087dcf56$export$2e2bcd8739ae039);
$450c77e4cd681750$var$Tooltip.UniqueProvider = (0, $4b1ad0676c1397a3$export$2e2bcd8739ae039);
var $450c77e4cd681750$export$2e2bcd8739ae039 = $450c77e4cd681750$var$Tooltip;



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $a852a0cd7782dc27$var$EnterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "enter",
    "theme": "outlined"
};
var $a852a0cd7782dc27$export$2e2bcd8739ae039 = $a852a0cd7782dc27$var$EnterOutlined;



function $10ed8d5d0b268d49$var$_extends() {
    $10ed8d5d0b268d49$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $10ed8d5d0b268d49$var$_extends.apply(this, arguments);
}
const $10ed8d5d0b268d49$var$EnterOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $10ed8d5d0b268d49$var$_extends({}, props, {
        ref: ref,
        icon: (0, $a852a0cd7782dc27$export$2e2bcd8739ae039)
    }));
/**![enter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2NCAxNzBoLTYwYy00LjQgMC04IDMuNi04IDh2NTE4SDMxMHYtNzNjMC02LjctNy44LTEwLjUtMTMtNi4zbC0xNDEuOSAxMTJhOCA4IDAgMDAwIDEyLjZsMTQxLjkgMTEyYzUuMyA0LjIgMTMgLjQgMTMtNi4zdi03NWg0OThjMzUuMyAwIDY0LTI4LjcgNjQtNjRWMTc4YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $10ed8d5d0b268d49$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($10ed8d5d0b268d49$var$EnterOutlined);
var $10ed8d5d0b268d49$export$2e2bcd8739ae039 = $10ed8d5d0b268d49$var$RefIcon;






var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
function $8b819dd5d9662c2c$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $8b819dd5d9662c2c$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
// TODO: It's better to use `Proxy` replace the `element.value`. But we still need support IE11.
function $8b819dd5d9662c2c$var$cloneEvent(event, target, value) {
    // A bug report filed on WebKit's Bugzilla tracker, dating back to 2009, specifically addresses the issue of cloneNode() not copying files of <input type="file"> elements.
    // As of the last update, this bug was still marked as "NEW," indicating that it might not have been resolved yet​​.
    // https://bugs.webkit.org/show_bug.cgi?id=28123
    const currentTarget = target.cloneNode(true);
    // click clear icon
    const newEvent = Object.create(event, {
        target: {
            value: currentTarget
        },
        currentTarget: {
            value: currentTarget
        }
    });
    // Fill data
    currentTarget.value = value;
    // Fill selection. Some type like `email` not support selection
    // https://github.com/ant-design/ant-design/issues/47833
    if (typeof target.selectionStart === 'number' && typeof target.selectionEnd === 'number') {
        currentTarget.selectionStart = target.selectionStart;
        currentTarget.selectionEnd = target.selectionEnd;
    }
    currentTarget.setSelectionRange = (...args)=>{
        target.setSelectionRange(...args);
    };
    return newEvent;
}
function $8b819dd5d9662c2c$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    let event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        event = $8b819dd5d9662c2c$var$cloneEvent(e, target, '');
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    // https://github.com/ant-design/ant-design/issues/45737
    // https://github.com/ant-design/ant-design/issues/46598
    if (target.type !== 'file' && targetValue !== undefined) {
        event = $8b819dd5d9662c2c$var$cloneEvent(e, target, targetValue);
        onChange(event);
        return;
    }
    onChange(event);
}


function $bc77bee4ffb26026$var$_extends() {
    $bc77bee4ffb26026$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc77bee4ffb26026$var$_extends.apply(this, arguments);
}
const $bc77bee4ffb26026$var$BaseInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    const { inputElement: inputEl, children: children, prefixCls: prefixCls, prefix: prefix, suffix: suffix, addonBefore: addonBefore, addonAfter: addonAfter, className: className, style: style, disabled: disabled, readOnly: readOnly, focused: focused, triggerFocus: triggerFocus, allowClear: allowClear, value: value, handleReset: handleReset, hidden: hidden, classes: classes, classNames: classNames, dataAttrs: dataAttrs, styles: styles, components: components, onClear: onClear } = props;
    const inputElement = children ?? inputEl;
    const AffixWrapperComponent = components?.affixWrapper || 'span';
    const GroupWrapperComponent = components?.groupWrapper || 'span';
    const WrapperComponent = components?.wrapper || 'span';
    const GroupAddonComponent = components?.groupAddon || 'span';
    const containerRef = (0, $ltGt3.useRef)(null);
    const onInputClick = (e)=>{
        if (containerRef.current?.contains(e.target)) triggerFocus?.();
    };
    const hasAffix = (0, $8b819dd5d9662c2c$export$a19010aeeaa0c7a)(props);
    let element = /*#__PURE__*/ (0, $ltGt3.cloneElement)(inputElement, {
        value: value,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(inputElement.props?.className, !hasAffix && classNames?.variant) || null
    });
    // ======================== Ref ======================== //
    const groupRef = (0, $ltGt3.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useImperativeHandle(ref, ()=>({
            nativeElement: groupRef.current || containerRef.current
        }));
    // ================== Prefix & Suffix ================== //
    if (hasAffix) {
        // ================== Clear Icon ================== //
        let clearIcon = null;
        if (allowClear) {
            const needClear = !disabled && !readOnly && value;
            const clearIconCls = `${prefixCls}-clear-icon`;
            const iconNode = typeof allowClear === 'object' && allowClear?.clearIcon ? allowClear.clearIcon : "\u2716";
            clearIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("button", {
                type: "button",
                tabIndex: -1,
                onClick: (event)=>{
                    handleReset?.(event);
                    onClear?.();
                },
                onMouseDown: (e)=>e.preventDefault(),
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(clearIconCls, {
                    [`${clearIconCls}-hidden`]: !needClear,
                    [`${clearIconCls}-has-suffix`]: !!suffix
                })
            }, iconNode);
        }
        const affixWrapperPrefixCls = `${prefixCls}-affix-wrapper`;
        const affixWrapperCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(affixWrapperPrefixCls, {
            [`${prefixCls}-disabled`]: disabled,
            [`${affixWrapperPrefixCls}-disabled`]: disabled,
            // Not used, but keep it
            [`${affixWrapperPrefixCls}-focused`]: focused,
            // Not used, but keep it
            [`${affixWrapperPrefixCls}-readonly`]: readOnly,
            [`${affixWrapperPrefixCls}-input-with-clear-btn`]: suffix && allowClear && value
        }, classes?.affixWrapper, classNames?.affixWrapper, classNames?.variant);
        const suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, classNames?.suffix),
            style: styles?.suffix
        }, clearIcon, suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(AffixWrapperComponent, $bc77bee4ffb26026$var$_extends({
            className: affixWrapperCls,
            style: styles?.affixWrapper,
            onClick: onInputClick
        }, dataAttrs?.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
            style: styles?.prefix
        }, prefix), element, suffixNode);
    }
    // ================== Addon ================== //
    if ((0, $8b819dd5d9662c2c$export$ae6255aa850a31d1)(props)) {
        const wrapperCls = `${prefixCls}-group`;
        const addonCls = `${wrapperCls}-addon`;
        const groupWrapperCls = `${wrapperCls}-wrapper`;
        const mergedWrapperClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, wrapperCls, classes?.wrapper, classNames?.wrapper);
        const mergedGroupClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(groupWrapperCls, {
            [`${groupWrapperCls}-disabled`]: disabled
        }, classes?.group, classNames?.groupWrapper);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            ref: groupRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), element, addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    // `className` and `style` are always on the root element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(element, {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(element.props?.className, className) || null,
        style: {
            ...element.props?.style,
            ...style
        },
        hidden: hidden
    });
});
var $bc77bee4ffb26026$export$2e2bcd8739ae039 = $bc77bee4ffb26026$var$BaseInput;






var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
function $5413e091c0c23ceb$export$7a29f0d5cac613ba(value, countConfig) {
    if (!countConfig.max) return true;
    const count = countConfig.strategy(value);
    return count <= countConfig.max;
}
function $5413e091c0c23ceb$export$2e2bcd8739ae039(count, showCount) {
    return $ltGt3.useMemo(()=>{
        let mergedConfig = {};
        if (showCount) mergedConfig.show = typeof showCount === 'object' && showCount.formatter ? showCount.formatter : !!showCount;
        mergedConfig = {
            ...mergedConfig,
            ...count
        };
        const { show: show, ...rest } = mergedConfig;
        return {
            ...rest,
            show: !!show,
            showFormatter: typeof show === 'function' ? show : undefined,
            strategy: rest.strategy || ((value)=>value.length)
        };
    }, [
        count,
        showCount
    ]);
}




function $2dfb8bf1ce337715$var$focusable(node, includePositive = false) {
    if ((0, $d3c89c1e130d7e35$export$2e2bcd8739ae039)(node)) {
        const nodeName = node.nodeName.toLowerCase();
        const isFocusableElement = // Focusable element
        [
            'input',
            'select',
            'textarea',
            'button'
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === 'a' && !!node.getAttribute('href');
        // Get tabIndex
        const tabIndexAttr = node.getAttribute('tabindex');
        const tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        let tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function $2dfb8bf1ce337715$export$bbc7b5f11aba534b(node, includePositive = false) {
    const res = [
        ...node.querySelectorAll('*')
    ].filter((child)=>{
        return $2dfb8bf1ce337715$var$focusable(child, includePositive);
    });
    if ($2dfb8bf1ce337715$var$focusable(node, includePositive)) res.unshift(node);
    return res;
}
let $2dfb8bf1ce337715$var$lastFocusElement = null;
function $2dfb8bf1ce337715$export$79fea02f7a83293d() {
    $2dfb8bf1ce337715$var$lastFocusElement = document.activeElement;
}
function $2dfb8bf1ce337715$export$8785654047fe7352() {
    $2dfb8bf1ce337715$var$lastFocusElement = null;
}
function $2dfb8bf1ce337715$export$fac0a9974415d98f() {
    if ($2dfb8bf1ce337715$var$lastFocusElement) try {
        // 元素可能已经被移动了
        $2dfb8bf1ce337715$var$lastFocusElement.focus();
    /* eslint-disable no-empty */ } catch (e) {
    // empty
    }
}
function $2dfb8bf1ce337715$export$5717027f63f8addb(node, e) {
    if (e.keyCode === 9) {
        const tabNodeList = $2dfb8bf1ce337715$export$bbc7b5f11aba534b(node);
        const lastTabNode = tabNodeList[e.shiftKey ? 0 : tabNodeList.length - 1];
        const leavingTab = lastTabNode === document.activeElement || node === document.activeElement;
        if (leavingTab) {
            const target = tabNodeList[e.shiftKey ? tabNodeList.length - 1 : 0];
            target.focus();
            e.preventDefault();
        }
    }
}
function $2dfb8bf1ce337715$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    const { cursor: cursor } = option || {};
    if (cursor && (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement)) {
        const len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}


function $cac1b3da3ba031ce$var$_extends() {
    $cac1b3da3ba031ce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cac1b3da3ba031ce$var$_extends.apply(this, arguments);
}
const $cac1b3da3ba031ce$var$Input = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
    const { autoComplete: autoComplete, onChange: onChange, onFocus: onFocus, onBlur: onBlur, onPressEnter: onPressEnter, onKeyDown: onKeyDown, onKeyUp: onKeyUp, prefixCls: prefixCls = 'rc-input', disabled: disabled, htmlSize: htmlSize, className: className, maxLength: maxLength, suffix: suffix, showCount: showCount, count: count, type: type = 'text', classes: classes, classNames: classNames, styles: styles, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, ...rest } = props;
    const [focused, setFocused] = (0, $ltGt3.useState)(false);
    const compositionRef = (0, $ltGt3.useRef)(false);
    const keyLockRef = (0, $ltGt3.useRef)(false);
    const inputRef = (0, $ltGt3.useRef)(null);
    const holderRef = (0, $ltGt3.useRef)(null);
    const focus = (option)=>{
        if (inputRef.current) (0, $2dfb8bf1ce337715$export$2b92016deb0b7aad)(inputRef.current, option);
    };
    // ====================== Value =======================
    const [value, setValue] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(props.defaultValue, props.value);
    const formatValue = value === undefined || value === null ? '' : String(value);
    // =================== Select Range ===================
    const [selection, setSelection] = (0, $ltGt3.useState)(null);
    // ====================== Count =======================
    const countConfig = (0, $5413e091c0c23ceb$export$2e2bcd8739ae039)(count, showCount);
    const mergedMax = countConfig.max || maxLength;
    const valueLength = countConfig.strategy(formatValue);
    const isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ======================= Ref ========================
    (0, $ltGt3.useImperativeHandle)(ref, ()=>({
            focus: focus,
            blur: ()=>{
                inputRef.current?.blur();
            },
            setSelectionRange: (start, end, direction)=>{
                inputRef.current?.setSelectionRange(start, end, direction);
            },
            select: ()=>{
                inputRef.current?.select();
            },
            input: inputRef.current,
            nativeElement: holderRef.current?.nativeElement || inputRef.current
        }));
    (0, $ltGt3.useEffect)(()=>{
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused((prev)=>prev && disabled ? false : prev);
    }, [
        disabled
    ]);
    const triggerChange = (e, currentValue, info)=>{
        let cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                inputRef.current?.selectionStart || 0,
                inputRef.current?.selectionEnd || 0
            ]);
        } else if (info.source === 'compositionEnd') // Avoid triggering twice
        // https://github.com/ant-design/ant-design/issues/46587
        return;
        setValue(cutValue);
        if (inputRef.current) (0, $8b819dd5d9662c2c$export$c28984794956ddc0)(inputRef.current, e, onChange, cutValue);
    };
    (0, $ltGt3.useEffect)(()=>{
        if (selection) inputRef.current?.setSelectionRange(...selection);
    }, [
        selection
    ]);
    const onInternalChange = (e)=>{
        triggerChange(e, e.target.value, {
            source: 'change'
        });
    };
    const onInternalCompositionEnd = (e)=>{
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value, {
            source: 'compositionEnd'
        });
        onCompositionEnd?.(e);
    };
    const handleKeyDown = (e)=>{
        if (onPressEnter && e.key === 'Enter' && !keyLockRef.current && !e.nativeEvent.isComposing) {
            keyLockRef.current = true;
            onPressEnter(e);
        }
        onKeyDown?.(e);
    };
    const handleKeyUp = (e)=>{
        if (e.key === 'Enter') keyLockRef.current = false;
        onKeyUp?.(e);
    };
    const handleFocus = (e)=>{
        setFocused(true);
        onFocus?.(e);
    };
    const handleBlur = (e)=>{
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused(false);
        onBlur?.(e);
    };
    const handleReset = (e)=>{
        setValue('');
        focus();
        if (inputRef.current) (0, $8b819dd5d9662c2c$export$c28984794956ddc0)(inputRef.current, e, onChange);
    };
    // ====================== Input =======================
    const outOfRangeCls = isOutOfRange && `${prefixCls}-out-of-range`;
    const getInputElement = ()=>{
        // Fix https://fb.me/react-unknown-prop
        const otherProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(props, [
            'prefixCls',
            'onPressEnter',
            'addonBefore',
            'addonAfter',
            'prefix',
            'suffix',
            'allowClear',
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            'defaultValue',
            'showCount',
            'count',
            'classes',
            'htmlSize',
            'styles',
            'classNames',
            'onClear'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("input", $cac1b3da3ba031ce$var$_extends({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, {
                [`${prefixCls}-disabled`]: disabled
            }, classNames?.input),
            style: styles?.input,
            ref: inputRef,
            size: htmlSize,
            type: type,
            onCompositionStart: (e)=>{
                compositionRef.current = true;
                onCompositionStart?.(e);
            },
            onCompositionEnd: onInternalCompositionEnd
        }));
    };
    const getSuffix = ()=>{
        // Max length value
        const hasMaxLength = Number(mergedMax) > 0;
        if (suffix || countConfig.show) {
            const dataCount = countConfig.showFormatter ? countConfig.showFormatter({
                value: formatValue,
                count: valueLength,
                maxLength: mergedMax
            }) : `${valueLength}${hasMaxLength ? ` / ${mergedMax}` : ''}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Fragment, null, countConfig.show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-show-count-suffix`, {
                    [`${prefixCls}-show-count-has-suffix`]: !!suffix
                }, classNames?.count),
                style: {
                    ...styles?.count
                }
            }, dataCount), suffix);
        }
        return null;
    };
    // ====================== Render ======================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $bc77bee4ffb26026$export$2e2bcd8739ae039), $cac1b3da3ba031ce$var$_extends({}, rest, {
        prefixCls: prefixCls,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, outOfRangeCls),
        handleReset: handleReset,
        value: formatValue,
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles,
        ref: holderRef
    }), getInputElement());
});
var $cac1b3da3ba031ce$export$2e2bcd8739ae039 = $cac1b3da3ba031ce$var$Input;


var $15112d9813cc317d$export$2e2bcd8739ae039 = (0, $cac1b3da3ba031ce$export$2e2bcd8739ae039);







var $ltGt3 = parcelRequire("ltGt3");






var $ltGt3 = parcelRequire("ltGt3");
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ const $7c1ba8f374e2338c$var$HIDDEN_TEXTAREA_STYLE = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`;
const $7c1ba8f374e2338c$var$SIZING_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'font-variant',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
    'word-break',
    'white-space'
];
const $7c1ba8f374e2338c$var$computedStyleCache = {};
let $7c1ba8f374e2338c$var$hiddenTextarea;
function $7c1ba8f374e2338c$export$1a56dc6a39385a18(node, useCache = false) {
    const nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
    if (useCache && $7c1ba8f374e2338c$var$computedStyleCache[nodeRef]) return $7c1ba8f374e2338c$var$computedStyleCache[nodeRef];
    const style = window.getComputedStyle(node);
    const boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
    const paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
    const borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
    const sizingStyle = $7c1ba8f374e2338c$var$SIZING_STYLE.map((name)=>`${name}:${style.getPropertyValue(name)}`).join(';');
    const nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $7c1ba8f374e2338c$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $7c1ba8f374e2338c$export$2e2bcd8739ae039(uiTextNode, useCache = false, minRows = null, maxRows = null) {
    if (!$7c1ba8f374e2338c$var$hiddenTextarea) {
        $7c1ba8f374e2338c$var$hiddenTextarea = document.createElement('textarea');
        $7c1ba8f374e2338c$var$hiddenTextarea.setAttribute('tab-index', '-1');
        $7c1ba8f374e2338c$var$hiddenTextarea.setAttribute('aria-hidden', 'true');
        // fix: A form field element should have an id or name attribute
        // A form field element has neither an id nor a name attribute. This might prevent the browser from correctly autofilling the form.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
        $7c1ba8f374e2338c$var$hiddenTextarea.setAttribute('name', 'hiddenTextarea');
        document.body.appendChild($7c1ba8f374e2338c$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) $7c1ba8f374e2338c$var$hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    else $7c1ba8f374e2338c$var$hiddenTextarea.removeAttribute('wrap');
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    const { paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing, sizingStyle: sizingStyle } = $7c1ba8f374e2338c$export$1a56dc6a39385a18(uiTextNode, useCache);
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $7c1ba8f374e2338c$var$hiddenTextarea.setAttribute('style', `${sizingStyle};${$7c1ba8f374e2338c$var$HIDDEN_TEXTAREA_STYLE}`);
    $7c1ba8f374e2338c$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    let minHeight = undefined;
    let maxHeight = undefined;
    let overflowY;
    let height = $7c1ba8f374e2338c$var$hiddenTextarea.scrollHeight;
    if (boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === 'content-box') // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $7c1ba8f374e2338c$var$hiddenTextarea.value = ' ';
        const singleRowHeight = $7c1ba8f374e2338c$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    const style = {
        height: height,
        overflowY: overflowY,
        resize: 'none'
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}


function $7c62916a21798107$var$_extends() {
    $7c62916a21798107$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7c62916a21798107$var$_extends.apply(this, arguments);
}
const $7c62916a21798107$var$RESIZE_START = 0;
const $7c62916a21798107$var$RESIZE_MEASURING = 1;
const $7c62916a21798107$var$RESIZE_STABLE = 2;
const $7c62916a21798107$var$ResizableTextArea = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, defaultValue: defaultValue, value: value, autoSize: autoSize, onResize: onResize, className: className, style: style, disabled: disabled, onChange: onChange, onInternalAutoSize: // Test only
    onInternalAutoSize, ...restProps } = props;
    // =============================== Value ================================
    const [internalValue, setMergedValue] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultValue, value);
    const mergedValue = internalValue ?? '';
    const onInternalChange = (event)=>{
        setMergedValue(event.target.value);
        onChange?.(event);
    };
    // ================================ Ref =================================
    const textareaRef = $ltGt3.useRef();
    $ltGt3.useImperativeHandle(ref, ()=>({
            textArea: textareaRef.current
        }));
    // ============================== AutoSize ==============================
    const [minRows, maxRows] = $ltGt3.useMemo(()=>{
        if (autoSize && typeof autoSize === 'object') return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]);
    const needAutoSize = !!autoSize;
    // =============================== Resize ===============================
    const [resizeState, setResizeState] = $ltGt3.useState($7c62916a21798107$var$RESIZE_STABLE);
    const [autoSizeStyle, setAutoSizeStyle] = $ltGt3.useState();
    const startResize = ()=>{
        setResizeState($7c62916a21798107$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (resizeState === $7c62916a21798107$var$RESIZE_START) setResizeState($7c62916a21798107$var$RESIZE_MEASURING);
        else if (resizeState === $7c62916a21798107$var$RESIZE_MEASURING) {
            const textareaStyles = (0, $7c1ba8f374e2338c$export$2e2bcd8739ae039)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState($7c62916a21798107$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        }
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    const resizeRafRef = $ltGt3.useRef();
    const cleanRaf = ()=>{
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(resizeRafRef.current);
    };
    const onInternalResize = (size)=>{
        if (resizeState === $7c62916a21798107$var$RESIZE_STABLE) {
            onResize?.(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
                    startResize();
                });
            }
        }
    };
    $ltGt3.useEffect(()=>cleanRaf, []);
    // =============================== Render ===============================
    const mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    const mergedStyle = {
        ...style,
        ...mergedAutoSizeStyle
    };
    if (resizeState === $7c62916a21798107$var$RESIZE_START || resizeState === $7c62916a21798107$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = 'hidden';
        mergedStyle.overflowX = 'hidden';
    }
    return /*#__PURE__*/ $ltGt3.createElement((0, $9ed13185b45d829d$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $ltGt3.createElement("textarea", $7c62916a21798107$var$_extends({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, className, {
            [`${prefixCls}-disabled`]: disabled
        }),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $7c62916a21798107$export$2e2bcd8739ae039 = $7c62916a21798107$var$ResizableTextArea;


function $33415a0b466402e9$var$_extends() {
    $33415a0b466402e9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $33415a0b466402e9$var$_extends.apply(this, arguments);
}
const $33415a0b466402e9$var$TextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef(({ defaultValue: defaultValue, value: customValue, onFocus: onFocus, onBlur: onBlur, onChange: onChange, allowClear: allowClear, maxLength: maxLength, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, suffix: suffix, prefixCls: prefixCls = 'rc-textarea', showCount: showCount, count: count, className: className, style: style, disabled: disabled, hidden: hidden, classNames: classNames, styles: styles, onResize: onResize, onClear: onClear, onPressEnter: onPressEnter, readOnly: readOnly, autoSize: autoSize, onKeyDown: onKeyDown, ...rest }, ref)=>{
    const [value, setValue] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultValue, customValue);
    const formatValue = value === undefined || value === null ? '' : String(value);
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(false);
    const compositionRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(false);
    const [textareaResized, setTextareaResized] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(null);
    // =============================== Ref ================================
    const holderRef = (0, $ltGt3.useRef)(null);
    const resizableTextAreaRef = (0, $ltGt3.useRef)(null);
    const getTextArea = ()=>resizableTextAreaRef.current?.textArea;
    const focus = ()=>{
        getTextArea().focus();
    };
    (0, $ltGt3.useImperativeHandle)(ref, ()=>({
            resizableTextArea: resizableTextAreaRef.current,
            focus: focus,
            blur: ()=>{
                getTextArea().blur();
            },
            nativeElement: holderRef.current?.nativeElement || getTextArea()
        }));
    (0, $ltGt3.useEffect)(()=>{
        setFocused((prev)=>!disabled && prev);
    }, [
        disabled
    ]);
    // =========================== Select Range ===========================
    const [selection, setSelection] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(()=>{
        if (selection) getTextArea().setSelectionRange(...selection);
    }, [
        selection
    ]);
    // ============================== Count ===============================
    const countConfig = (0, $5413e091c0c23ceb$export$2e2bcd8739ae039)(count, showCount);
    const mergedMax = countConfig.max ?? maxLength;
    // Max length value
    const hasMaxLength = Number(mergedMax) > 0;
    const valueLength = countConfig.strategy(formatValue);
    const isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ============================== Change ==============================
    const triggerChange = (e, currentValue)=>{
        let cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                getTextArea().selectionStart || 0,
                getTextArea().selectionEnd || 0
            ]);
        }
        setValue(cutValue);
        (0, $8b819dd5d9662c2c$export$c28984794956ddc0)(e.currentTarget, e, onChange, cutValue);
    };
    // =========================== Value Update ===========================
    const onInternalCompositionStart = (e)=>{
        compositionRef.current = true;
        onCompositionStart?.(e);
    };
    const onInternalCompositionEnd = (e)=>{
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd?.(e);
    };
    const onInternalChange = (e)=>{
        triggerChange(e, e.target.value);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && onPressEnter && !e.nativeEvent.isComposing) onPressEnter(e);
        onKeyDown?.(e);
    };
    const handleFocus = (e)=>{
        setFocused(true);
        onFocus?.(e);
    };
    const handleBlur = (e)=>{
        setFocused(false);
        onBlur?.(e);
    };
    // ============================== Reset ===============================
    const handleReset = (e)=>{
        setValue('');
        focus();
        (0, $8b819dd5d9662c2c$export$c28984794956ddc0)(getTextArea(), e, onChange);
    };
    let suffixNode = suffix;
    let dataCount;
    if (countConfig.show) {
        if (countConfig.showFormatter) dataCount = countConfig.showFormatter({
            value: formatValue,
            count: valueLength,
            maxLength: mergedMax
        });
        else dataCount = `${valueLength}${hasMaxLength ? ` / ${mergedMax}` : ''}`;
        suffixNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Fragment, null, suffixNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-data-count`, classNames?.count),
            style: styles?.count
        }, dataCount));
    }
    const handleResize = (size)=>{
        onResize?.(size);
        if (getTextArea()?.style.height) setTextareaResized(true);
    };
    const isPureTextArea = !autoSize && !showCount && !allowClear;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $bc77bee4ffb26026$export$2e2bcd8739ae039), {
        ref: holderRef,
        value: formatValue,
        allowClear: allowClear,
        handleReset: handleReset,
        suffix: suffixNode,
        prefixCls: prefixCls,
        classNames: {
            ...classNames,
            affixWrapper: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(classNames?.affixWrapper, {
                [`${prefixCls}-show-count`]: showCount,
                [`${prefixCls}-textarea-allow-clear`]: allowClear
            })
        },
        disabled: disabled,
        focused: focused,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, isOutOfRange && `${prefixCls}-out-of-range`),
        style: {
            ...style,
            ...textareaResized && !isPureTextArea ? {
                height: 'auto'
            } : {}
        },
        dataAttrs: {
            affixWrapper: {
                'data-count': typeof dataCount === 'string' ? dataCount : undefined
            }
        },
        hidden: hidden,
        readOnly: readOnly,
        onClear: onClear
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $7c62916a21798107$export$2e2bcd8739ae039), $33415a0b466402e9$var$_extends({}, rest, {
        autoSize: autoSize,
        maxLength: maxLength,
        onKeyDown: handleKeyDown,
        onChange: onInternalChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onCompositionStart: onInternalCompositionStart,
        onCompositionEnd: onInternalCompositionEnd,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(classNames?.textarea),
        style: {
            resize: style?.resize,
            ...styles?.textarea
        },
        disabled: disabled,
        prefixCls: prefixCls,
        onResize: handleResize,
        ref: resizableTextAreaRef,
        readOnly: readOnly
    })));
});
var $33415a0b466402e9$export$2e2bcd8739ae039 = $33415a0b466402e9$var$TextArea;



var $7715a1e24ee75718$export$2e2bcd8739ae039 = (0, $33415a0b466402e9$export$2e2bcd8739ae039);




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $f49a9385939e2176$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $f49a9385939e2176$export$2e2bcd8739ae039 = $f49a9385939e2176$var$CloseCircleFilled;



function $332936b0d9ac1f65$var$_extends() {
    $332936b0d9ac1f65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $332936b0d9ac1f65$var$_extends.apply(this, arguments);
}
const $332936b0d9ac1f65$var$CloseCircleFilled = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $332936b0d9ac1f65$var$_extends({}, props, {
        ref: ref,
        icon: (0, $f49a9385939e2176$export$2e2bcd8739ae039)
    }));
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */ const $332936b0d9ac1f65$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($332936b0d9ac1f65$var$CloseCircleFilled);
var $332936b0d9ac1f65$export$2e2bcd8739ae039 = $332936b0d9ac1f65$var$RefIcon;


"use client";
const $b2f9ce3768b9adcc$var$getAllowClear = (allowClear)=>{
    let mergedAllowClear;
    if (typeof allowClear === 'object' && allowClear?.clearIcon) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $332936b0d9ac1f65$export$2e2bcd8739ae039), null)
    };
    return mergedAllowClear;
};
var $b2f9ce3768b9adcc$export$2e2bcd8739ae039 = $b2f9ce3768b9adcc$var$getAllowClear;




const $7b7bdeafff468875$var$_InputStatuses = [
    'warning',
    'error',
    '',
    'success',
    'validating'
];
const $7b7bdeafff468875$export$b08e7b47149942a2 = (prefixCls, status, hasFeedback)=>{
    return (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
        [`${prefixCls}-status-success`]: status === 'success',
        [`${prefixCls}-status-warning`]: status === 'warning',
        [`${prefixCls}-status-error`]: status === 'error',
        [`${prefixCls}-status-validating`]: status === 'validating',
        [`${prefixCls}-has-feedback`]: hasFeedback
    });
};
const $7b7bdeafff468875$export$314e193082d7ba49 = (contextStatus, customStatus)=>customStatus || contextStatus;









var $ltGt3 = parcelRequire("ltGt3");


/**
 * Compatible for legacy `bordered` prop.
 */ const $714175bf01098e4f$var$useVariant = (component, variant, legacyBordered)=>{
    const { variant: configVariant, [component]: componentConfig } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const ctxVariant = $ltGt3.useContext((0, $2fc8703031980156$export$6f0555dad42725fb));
    const configComponentVariant = componentConfig?.variant;
    let mergedVariant;
    if (typeof variant !== 'undefined') mergedVariant = variant;
    else if (legacyBordered === false) mergedVariant = 'borderless';
    else // form variant > component global variant > global variant
    mergedVariant = ctxVariant ?? configComponentVariant ?? configVariant ?? 'outlined';
    const enableVariantCls = (0, $d13451568443aeb8$export$fa216ce2679a073b).includes(mergedVariant);
    return [
        mergedVariant,
        enableVariantCls
    ];
};
var $714175bf01098e4f$export$2e2bcd8739ae039 = $714175bf01098e4f$var$useVariant;









function $84cc1914d3f028b8$export$a157d95850191a12(token) {
    return (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
const $84cc1914d3f028b8$export$bd8b682992bc9781 = (token)=>{
    const { controlHeight: controlHeight, fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, paddingSM: paddingSM, controlPaddingHorizontalSM: controlPaddingHorizontalSM, controlPaddingHorizontal: controlPaddingHorizontal, colorFillAlter: colorFillAlter, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutlineWidth: controlOutlineWidth, controlOutline: controlOutline, colorErrorOutline: colorErrorOutline, colorWarningOutline: colorWarningOutline, colorBgContainer: colorBgContainer, inputFontSize: inputFontSize, inputFontSizeLG: inputFontSizeLG, inputFontSizeSM: inputFontSizeSM } = token;
    const mergedFontSize = inputFontSize || fontSize;
    const mergedFontSizeSM = inputFontSizeSM || mergedFontSize;
    const mergedFontSizeLG = inputFontSizeLG || fontSizeLG;
    const paddingBlock = Math.round((controlHeight - mergedFontSize * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockSM = Math.round((controlHeightSM - mergedFontSizeSM * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockLG = Math.ceil((controlHeightLG - mergedFontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth;
    return {
        paddingBlock: Math.max(paddingBlock, 0),
        paddingBlockSM: Math.max(paddingBlockSM, 0),
        paddingBlockLG: Math.max(paddingBlockLG, 0),
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
        errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
        warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
        hoverBg: colorBgContainer,
        activeBg: colorBgContainer,
        inputFontSize: mergedFontSize,
        inputFontSizeLG: mergedFontSizeLG,
        inputFontSizeSM: mergedFontSizeSM
    };
};




const $2e2c91ed88c5ebaa$export$bf820fba296f2fd8 = (token)=>({
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    });
const $2e2c91ed88c5ebaa$export$12789f962d420a93 = (token)=>({
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
        'input[disabled], textarea[disabled]': {
            cursor: 'not-allowed'
        },
        '&:hover:not([disabled])': {
            ...$2e2c91ed88c5ebaa$export$bf820fba296f2fd8((0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
                hoverBorderColor: token.colorBorder,
                hoverBg: token.colorBgContainerDisabled
            }))
        }
    });
const $2e2c91ed88c5ebaa$export$8c569e4cc3fd115f = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: options.borderColor,
        '&:hover': {
            borderColor: options.hoverBorderColor,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: options.activeBorderColor,
            boxShadow: options.activeShadow,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $2e2c91ed88c5ebaa$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$2e2c91ed88c5ebaa$export$8c569e4cc3fd115f(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        },
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: options.borderColor
        }
    });
const $2e2c91ed88c5ebaa$export$53795bafd774ce02 = (token, extraStyles)=>({
        '&-outlined': {
            ...$2e2c91ed88c5ebaa$export$8c569e4cc3fd115f(token, {
                borderColor: token.colorBorder,
                hoverBorderColor: token.hoverBorderColor,
                activeBorderColor: token.activeBorderColor,
                activeShadow: token.activeShadow
            }),
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                ...$2e2c91ed88c5ebaa$export$12789f962d420a93(token)
            },
            ...$2e2c91ed88c5ebaa$var$genOutlinedStatusStyle(token, {
                status: 'error',
                borderColor: token.colorError,
                hoverBorderColor: token.colorErrorBorderHover,
                activeBorderColor: token.colorError,
                activeShadow: token.errorActiveShadow,
                affixColor: token.colorError
            }),
            ...$2e2c91ed88c5ebaa$var$genOutlinedStatusStyle(token, {
                status: 'warning',
                borderColor: token.colorWarning,
                hoverBorderColor: token.colorWarningBorderHover,
                activeBorderColor: token.colorWarning,
                activeShadow: token.warningActiveShadow,
                affixColor: token.colorWarning
            }),
            ...extraStyles
        }
    });
const $2e2c91ed88c5ebaa$var$genOutlinedGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                borderColor: options.addonBorderColor,
                color: options.addonColor
            }
        }
    });
const $2e2c91ed88c5ebaa$export$8f88f32c046ff727 = (token)=>({
        '&-outlined': {
            [`${token.componentCls}-group`]: {
                '&-addon': {
                    background: token.addonBg,
                    border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                '&-addon:first-child': {
                    borderInlineEnd: 0
                },
                '&-addon:last-child': {
                    borderInlineStart: 0
                }
            },
            ...$2e2c91ed88c5ebaa$var$genOutlinedGroupStatusStyle(token, {
                status: 'error',
                addonBorderColor: token.colorError,
                addonColor: token.colorErrorText
            }),
            ...$2e2c91ed88c5ebaa$var$genOutlinedGroupStatusStyle(token, {
                status: 'warning',
                addonBorderColor: token.colorWarning,
                addonColor: token.colorWarningText
            }),
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group-addon`]: {
                    ...$2e2c91ed88c5ebaa$export$12789f962d420a93(token)
                }
            }
        }
    });
const $2e2c91ed88c5ebaa$export$b6de5da7f39edfcb = (token, extraStyles)=>{
    const { componentCls: componentCls } = token;
    return {
        '&-borderless': {
            background: 'transparent',
            border: 'none',
            '&:focus, &:focus-within': {
                outline: 'none'
            },
            // >>>>> Disabled
            [`&${componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            // >>>>> Status
            [`&${componentCls}-status-error`]: {
                '&, & input, & textarea': {
                    color: token.colorError
                }
            },
            [`&${componentCls}-status-warning`]: {
                '&, & input, & textarea': {
                    color: token.colorWarning
                }
            },
            ...extraStyles
        }
    };
};
/* ============== Filled ============== */ const $2e2c91ed88c5ebaa$var$genBaseFilledStyle = (token, options)=>({
        background: options.bg,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: 'transparent',
        'input&, & input, textarea&, & textarea': {
            color: options?.inputColor ?? 'unset'
        },
        '&:hover': {
            background: options.hoverBg
        },
        '&:focus, &:focus-within': {
            outline: 0,
            borderColor: options.activeBorderColor,
            backgroundColor: token.activeBg
        }
    });
const $2e2c91ed88c5ebaa$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$2e2c91ed88c5ebaa$var$genBaseFilledStyle(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }
    });
const $2e2c91ed88c5ebaa$export$b8365cd7e6671d79 = (token, extraStyles)=>({
        '&-filled': {
            ...$2e2c91ed88c5ebaa$var$genBaseFilledStyle(token, {
                bg: token.colorFillTertiary,
                hoverBg: token.colorFillSecondary,
                activeBorderColor: token.activeBorderColor
            }),
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                ...$2e2c91ed88c5ebaa$export$12789f962d420a93(token)
            },
            ...$2e2c91ed88c5ebaa$var$genFilledStatusStyle(token, {
                status: 'error',
                bg: token.colorErrorBg,
                hoverBg: token.colorErrorBgHover,
                activeBorderColor: token.colorError,
                inputColor: token.colorErrorText,
                affixColor: token.colorError
            }),
            ...$2e2c91ed88c5ebaa$var$genFilledStatusStyle(token, {
                status: 'warning',
                bg: token.colorWarningBg,
                hoverBg: token.colorWarningBgHover,
                activeBorderColor: token.colorWarning,
                inputColor: token.colorWarningText,
                affixColor: token.colorWarning
            }),
            ...extraStyles
        }
    });
const $2e2c91ed88c5ebaa$var$genFilledGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                background: options.addonBg,
                color: options.addonColor
            }
        }
    });
const $2e2c91ed88c5ebaa$export$542c0fce51b1d515 = (token)=>({
        '&-filled': {
            [`${token.componentCls}-group-addon`]: {
                background: token.colorFillTertiary,
                '&:last-child': {
                    position: 'static'
                }
            },
            ...$2e2c91ed88c5ebaa$var$genFilledGroupStatusStyle(token, {
                status: 'error',
                addonBg: token.colorErrorBg,
                addonColor: token.colorErrorText
            }),
            ...$2e2c91ed88c5ebaa$var$genFilledGroupStatusStyle(token, {
                status: 'warning',
                addonBg: token.colorWarningBg,
                addonColor: token.colorWarningText
            }),
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group`]: {
                    '&-addon': {
                        background: token.colorFillTertiary,
                        color: token.colorTextDisabled
                    },
                    '&-addon:first-child': {
                        borderInlineStart: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    },
                    '&-addon:last-child': {
                        borderInlineEnd: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    }
                }
            }
        }
    });
const $2e2c91ed88c5ebaa$export$7617a11352d704b9 = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} 0`,
        borderStyle: `${token.lineType} none`,
        borderColor: `transparent transparent ${options.borderColor} transparent`,
        borderRadius: 0,
        '&:hover': {
            borderColor: `transparent transparent ${options.hoverBorderColor} transparent`,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: `transparent transparent ${options.activeBorderColor} transparent`,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $2e2c91ed88c5ebaa$var$genUnderlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$2e2c91ed88c5ebaa$export$7617a11352d704b9(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        },
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: `transparent transparent ${options.borderColor} transparent`
        }
    });
const $2e2c91ed88c5ebaa$export$34771e60e0439351 = (token, extraStyles)=>({
        '&-underlined': {
            ...$2e2c91ed88c5ebaa$export$7617a11352d704b9(token, {
                borderColor: token.colorBorder,
                hoverBorderColor: token.hoverBorderColor,
                activeBorderColor: token.activeBorderColor,
                activeShadow: token.activeShadow
            }),
            // >>>>> Disabled
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                boxShadow: 'none',
                cursor: 'not-allowed',
                '&:hover': {
                    borderColor: `transparent transparent ${token.colorBorder} transparent`
                }
            },
            'input[disabled], textarea[disabled]': {
                cursor: 'not-allowed'
            },
            ...$2e2c91ed88c5ebaa$var$genUnderlinedStatusStyle(token, {
                status: 'error',
                borderColor: token.colorError,
                hoverBorderColor: token.colorErrorBorderHover,
                activeBorderColor: token.colorError,
                activeShadow: token.errorActiveShadow,
                affixColor: token.colorError
            }),
            ...$2e2c91ed88c5ebaa$var$genUnderlinedStatusStyle(token, {
                status: 'warning',
                borderColor: token.colorWarning,
                hoverBorderColor: token.colorWarningBorderHover,
                activeBorderColor: token.colorWarning,
                activeShadow: token.warningActiveShadow,
                affixColor: token.colorWarning
            }),
            ...extraStyles
        }
    });


const $ec12a8e9ea12e1d5$export$92095d0f4c77bd56 = (color)=>({
        // Firefox
        '&::-moz-placeholder': {
            opacity: 1
        },
        '&::placeholder': {
            color: color,
            userSelect: 'none' // https://github.com/ant-design/ant-design/pull/32639
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        }
    });
const $ec12a8e9ea12e1d5$export$3fe86db3643510f9 = (token)=>({
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    });
const $ec12a8e9ea12e1d5$var$genInputLargeStyle = (token)=>{
    const { paddingBlockLG: paddingBlockLG, lineHeightLG: lineHeightLG, borderRadiusLG: borderRadiusLG, paddingInlineLG: paddingInlineLG } = token;
    return {
        padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingBlockLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingInlineLG)}`,
        fontSize: token.inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
const $ec12a8e9ea12e1d5$export$bb047f62c5a56f90 = (token)=>({
        padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingBlockSM)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingInlineSM)}`,
        fontSize: token.inputFontSizeSM,
        borderRadius: token.borderRadiusSM
    });
const $ec12a8e9ea12e1d5$export$8c9a381315f3ebcd = (token, option = {})=>({
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        minWidth: 0,
        padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingBlock)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingInline)}`,
        color: token.colorText,
        fontSize: token.inputFontSize,
        lineHeight: token.lineHeight,
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationMid}`,
        ...$ec12a8e9ea12e1d5$export$92095d0f4c77bd56(token.colorTextPlaceholder),
        // Size
        '&-lg': {
            ...$ec12a8e9ea12e1d5$var$genInputLargeStyle(token),
            ...option.largeStyle
        },
        '&-sm': {
            ...$ec12a8e9ea12e1d5$export$bb047f62c5a56f90(token),
            ...option.smallStyle
        },
        // RTL
        '&-rtl, &-textarea-rtl': {
            direction: 'rtl'
        }
    });
const $ec12a8e9ea12e1d5$export$ffe8b2a9bd2e5cfe = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        position: 'relative',
        display: 'table',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        // Undo padding and float of grid classes
        "&[class*='col-']": {
            paddingInlineEnd: token.paddingXS,
            '&:last-child': {
                paddingInlineEnd: 0
            }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: {
            ...$ec12a8e9ea12e1d5$var$genInputLargeStyle(token)
        },
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: {
            ...$ec12a8e9ea12e1d5$export$bb047f62c5a56f90(token)
        },
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single`]: {
            height: token.controlHeightLG
        },
        [`&-sm ${antCls}-select-single`]: {
            height: token.controlHeightSM
        },
        [`> ${componentCls}`]: {
            display: 'table-cell',
            '&:not(:first-child):not(:last-child)': {
                borderRadius: 0
            }
        },
        [`${componentCls}-group`]: {
            '&-addon, &-wrap': {
                display: 'table-cell',
                width: 1,
                whiteSpace: 'nowrap',
                verticalAlign: 'middle',
                '&:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                }
            },
            '&-wrap > *': {
                display: 'block !important'
            },
            '&-addon': {
                position: 'relative',
                padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingInline)}`,
                color: token.colorText,
                fontWeight: 'normal',
                fontSize: token.inputFontSize,
                textAlign: 'center',
                borderRadius: token.borderRadius,
                transition: `all ${token.motionDurationSlow}`,
                lineHeight: 1,
                // Reset Select's style in addon
                [`${antCls}-select`]: {
                    margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                        backgroundColor: 'inherit',
                        border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                        boxShadow: 'none'
                    }
                },
                // https://github.com/ant-design/ant-design/issues/31333
                [`${antCls}-cascader-picker`]: {
                    margin: `-9px ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    backgroundColor: 'transparent',
                    [`${antCls}-cascader-input`]: {
                        textAlign: 'start',
                        border: 0,
                        boxShadow: 'none'
                    }
                }
            }
        },
        [componentCls]: {
            width: '100%',
            marginBottom: 0,
            textAlign: 'inherit',
            '&:focus': {
                zIndex: 1,
                // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
                borderInlineEndWidth: 1
            },
            '&:hover': {
                zIndex: 1,
                borderInlineEndWidth: 1
            }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}-affix-wrapper`]: {
            [`&:not(:first-child) ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            },
            [`&:not(:last-child) ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`${componentCls}-affix-wrapper`]: {
            '&:not(:last-child)': {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            },
            [`&:not(:first-child)`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&${componentCls}-group-compact`]: {
            display: 'block',
            ...(0, $945cb0d2b7017a11$export$8c467e8859fdef13)(),
            [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
                '&:not(:first-child):not(:last-child)': {
                    borderInlineEndWidth: token.lineWidth,
                    '&:hover, &:focus': {
                        zIndex: 1
                    }
                }
            },
            '& > *': {
                display: 'inline-flex',
                float: 'none',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design-pro/issues/139
                borderRadius: 0
            },
            [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
                display: 'inline-flex'
            },
            '& > *:not(:last-child)': {
                marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                borderInlineEndWidth: token.lineWidth
            },
            // Undo float for .ant-input-group .ant-input
            [componentCls]: {
                float: 'none'
            },
            // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
            [`& > ${antCls}-select,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderRadius: 0,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            [`& > ${antCls}-select-focused`]: {
                zIndex: 1
            },
            // update z-index for arrow icon
            [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
                zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
            },
            [`& > *:first-child,
      & > ${antCls}-select:first-child,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
                borderStartStartRadius: token.borderRadius,
                borderEndStartRadius: token.borderRadius
            },
            [`& > *:last-child,
      & > ${antCls}-select:last-child,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderStartEndRadius: token.borderRadius,
                borderEndEndRadius: token.borderRadius
            },
            // https://github.com/ant-design/ant-design/issues/12493
            [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
                verticalAlign: 'top'
            },
            [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                [`${componentCls}-affix-wrapper`]: {
                }
            }
        }
    };
};
const $ec12a8e9ea12e1d5$export$9a752c3888370836 = (token)=>{
    const { componentCls: componentCls, controlHeightSM: controlHeightSM, lineWidth: lineWidth, calc: calc } = token;
    const FIXED_CHROME_COLOR_HEIGHT = 16;
    const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            ...$ec12a8e9ea12e1d5$export$8c9a381315f3ebcd(token),
            // Variants
            ...(0, $2e2c91ed88c5ebaa$export$53795bafd774ce02)(token),
            ...(0, $2e2c91ed88c5ebaa$export$b8365cd7e6671d79)(token),
            ...(0, $2e2c91ed88c5ebaa$export$b6de5da7f39edfcb)(token),
            ...(0, $2e2c91ed88c5ebaa$export$34771e60e0439351)(token),
            '&[type="color"]': {
                height: token.controlHeight,
                [`&${componentCls}-lg`]: {
                    height: token.controlHeightLG
                },
                [`&${componentCls}-sm`]: {
                    height: controlHeightSM,
                    paddingTop: colorSmallPadding,
                    paddingBottom: colorSmallPadding
                }
            },
            '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
                appearance: 'none'
            }
        }
    };
};
const $ec12a8e9ea12e1d5$var$genAllowClearStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
            margin: 0,
            padding: 0,
            lineHeight: 0,
            color: token.colorTextQuaternary,
            fontSize: token.fontSizeIcon,
            verticalAlign: -1,
            // https://github.com/ant-design/ant-design/pull/18151
            // https://codesandbox.io/s/wizardly-sun-u10br
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            border: 'none',
            outline: 'none',
            backgroundColor: 'transparent',
            '&:hover': {
                color: token.colorIcon
            },
            '&:active': {
                color: token.colorText
            },
            '&-hidden': {
                visibility: 'hidden'
            },
            '&-has-suffix': {
                margin: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.inputAffixPadding)}`
            }
        }
    };
};
const $ec12a8e9ea12e1d5$export$77a75da75a374eb9 = (token)=>{
    const { componentCls: componentCls, inputAffixPadding: inputAffixPadding, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorIconHover: colorIconHover, iconCls: iconCls } = token;
    const affixCls = `${componentCls}-affix-wrapper`;
    const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
    return {
        [affixCls]: {
            ...$ec12a8e9ea12e1d5$export$8c9a381315f3ebcd(token),
            display: 'inline-flex',
            '&-focused, &:focus': {
                zIndex: 1
            },
            [`> input${componentCls}`]: {
                padding: 0
            },
            [`> input${componentCls}, > textarea${componentCls}`]: {
                fontSize: 'inherit',
                border: 'none',
                borderRadius: 0,
                outline: 'none',
                background: 'transparent',
                color: 'inherit',
                '&::-ms-reveal': {
                    display: 'none'
                },
                '&:focus': {
                    boxShadow: 'none !important'
                }
            },
            '&::before': {
                display: 'inline-block',
                width: 0,
                visibility: 'hidden',
                content: '"\\a0"'
            },
            [componentCls]: {
                '&-prefix, &-suffix': {
                    display: 'flex',
                    flex: 'none',
                    alignItems: 'center',
                    '> *:not(:last-child)': {
                        marginInlineEnd: token.paddingXS
                    }
                },
                '&-show-count-suffix': {
                    color: colorTextDescription,
                    direction: 'ltr'
                },
                '&-show-count-has-suffix': {
                    marginInlineEnd: token.paddingXXS
                },
                '&-prefix': {
                    marginInlineEnd: inputAffixPadding
                },
                '&-suffix': {
                    marginInlineStart: inputAffixPadding
                }
            },
            ...$ec12a8e9ea12e1d5$var$genAllowClearStyle(token),
            // password
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'pointer',
                transition: `all ${motionDurationSlow}`,
                '&:hover': {
                    color: colorIconHover
                }
            }
        },
        // 覆盖 affix-wrapper borderRadius！
        [`${componentCls}-underlined`]: {
            borderRadius: 0
        },
        [affixClsDisabled]: {
            // password disabled
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'not-allowed',
                '&:hover': {
                    color: colorIcon
                }
            }
        }
    };
};
const $ec12a8e9ea12e1d5$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM } = token;
    return {
        [`${componentCls}-group`]: {
            // Style for input-group: input with label, with button or dropdown...
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            ...$ec12a8e9ea12e1d5$export$ffe8b2a9bd2e5cfe(token),
            '&-rtl': {
                direction: 'rtl'
            },
            '&-wrapper': {
                display: 'inline-block',
                width: '100%',
                textAlign: 'start',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design/issues/6403
                '&-rtl': {
                    direction: 'rtl'
                },
                // Size
                '&-lg': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusLG,
                        fontSize: token.inputFontSizeLG
                    }
                },
                '&-sm': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusSM
                    }
                },
                // Variants
                ...(0, $2e2c91ed88c5ebaa$export$8f88f32c046ff727)(token),
                ...(0, $2e2c91ed88c5ebaa$export$542c0fce51b1d515)(token),
                // '&-disabled': {
                //   [`${componentCls}-group-addon`]: {
                //     ...genDisabledStyle(token),
                //   },
                // },
                // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/42122
                [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                },
                // Fix the issue of input use show-count param in space compact mode
                // https://github.com/ant-design/ant-design/issues/46872
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                // Fix the issue of input use `addonAfter` param in space compact mode
                // https://github.com/ant-design/ant-design/issues/52483
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                }
            }
        }
    };
};
// ============================== Range ===============================
const $ec12a8e9ea12e1d5$var$genRangeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-out-of-range`]: {
            [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
                color: token.colorError
            }
        }
    };
};
const $ec12a8e9ea12e1d5$export$de732caeaad5f68e = (0, $2acdd5777733fef1$export$51ec95de45185b42)([
    'Input',
    'Shared'
], (token)=>{
    const inputToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, (0, $84cc1914d3f028b8$export$a157d95850191a12)(token));
    return [
        $ec12a8e9ea12e1d5$export$9a752c3888370836(inputToken),
        $ec12a8e9ea12e1d5$export$77a75da75a374eb9(inputToken)
    ];
}, (0, $84cc1914d3f028b8$export$bd8b682992bc9781), {
    resetFont: false
});
var $ec12a8e9ea12e1d5$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)([
    'Input',
    'Component'
], (token)=>{
    const inputToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, (0, $84cc1914d3f028b8$export$a157d95850191a12)(token));
    return [
        $ec12a8e9ea12e1d5$var$genGroupStyle(inputToken),
        $ec12a8e9ea12e1d5$var$genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $f96147db005a8a82$export$b1208b23589b4b73)(inputToken)
    ];
}, (0, $84cc1914d3f028b8$export$bd8b682992bc9781), {
    resetFont: false
});




const $37210c0cc46446ee$var$genTextAreaStyle = (token)=>{
    const { componentCls: componentCls, paddingLG: paddingLG } = token;
    const textareaPrefixCls = `${componentCls}-textarea`;
    return {
        // Raw Textarea
        [`textarea${componentCls}`]: {
            maxWidth: '100%',
            // prevent textarea resize from coming out of its container
            height: 'auto',
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: 'bottom',
            transition: `all ${token.motionDurationSlow}`,
            resize: 'vertical',
            [`&${componentCls}-mouse-active`]: {
                transition: `all ${token.motionDurationSlow}, height 0s, width 0s`
            }
        },
        // Wrapper for resize
        [`${componentCls}-textarea-affix-wrapper-resize-dirty`]: {
            width: 'auto'
        },
        [textareaPrefixCls]: {
            position: 'relative',
            '&-show-count': {
                [`${componentCls}-data-count`]: {
                    position: 'absolute',
                    bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
                    insetInlineEnd: 0,
                    color: token.colorTextDescription,
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none'
                }
            },
            [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
                paddingInlineEnd: paddingLG
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
                padding: 0,
                [`> textarea${componentCls}`]: {
                    fontSize: 'inherit',
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    minHeight: token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal(),
                    '&:focus': {
                        boxShadow: 'none !important'
                    }
                },
                [`${componentCls}-suffix`]: {
                    margin: 0,
                    '> *:not(:last-child)': {
                        marginInline: 0
                    },
                    // Clear Icon
                    [`${componentCls}-clear-icon`]: {
                        position: 'absolute',
                        insetInlineEnd: token.paddingInline,
                        insetBlockStart: token.paddingXS
                    },
                    // Feedback Icon
                    [`${textareaPrefixCls}-suffix`]: {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.paddingInline,
                        bottom: 0,
                        zIndex: 1,
                        display: 'inline-flex',
                        alignItems: 'center',
                        margin: 'auto',
                        pointerEvents: 'none'
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-rtl`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-data-count`]: {
                        direction: 'ltr',
                        insetInlineStart: 0
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-clear-icon`]: {
                        insetInlineEnd: token.paddingInlineSM
                    }
                }
            }
        }
    };
};
var // ============================== Export ==============================
$37210c0cc46446ee$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)([
    'Input',
    'TextArea'
], (token)=>{
    const inputToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, (0, $84cc1914d3f028b8$export$a157d95850191a12)(token));
    return $37210c0cc46446ee$var$genTextAreaStyle(inputToken);
}, (0, $84cc1914d3f028b8$export$bd8b682992bc9781), {
    resetFont: false
});


"use client";
const $b25fe3380ecdfadc$var$TextArea = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered = true, size: customizeSize, disabled: customDisabled, status: customStatus, allowClear: allowClear, classNames: classNames, rootClassName: rootClassName, className: className, style: style, styles: styles, variant: customVariant, showCount: showCount, onMouseDown: onMouseDown, onResize: onResize, ...rest } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('textArea');
    // =================== Disabled ===================
    const disabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // ==================== Status ====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = $ltGt3.useContext((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $7b7bdeafff468875$export$314e193082d7ba49)(contextStatus, customStatus);
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    // ===================== Ref ======================
    const innerRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, ()=>({
            resizableTextArea: innerRef.current?.resizableTextArea,
            focus: (option)=>{
                (0, $2dfb8bf1ce337715$export$2b92016deb0b7aad)(innerRef.current?.resizableTextArea?.textArea, option);
            },
            blur: ()=>innerRef.current?.blur()
        }));
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    // ==================== Style =====================
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $ec12a8e9ea12e1d5$export$de732caeaad5f68e)(prefixCls, rootClassName);
    (0, $37210c0cc46446ee$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ================= Compact Item =================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $8eabd28975be2fa5$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const [variant, enableVariantCls] = (0, $714175bf01098e4f$export$2e2bcd8739ae039)('textArea', customVariant, bordered);
    const mergedAllowClear = (0, $b2f9ce3768b9adcc$export$2e2bcd8739ae039)(allowClear ?? contextAllowClear);
    // ==================== Resize ====================
    // https://github.com/ant-design/ant-design/issues/51594
    const [isMouseDown, setIsMouseDown] = $ltGt3.useState(false);
    // When has wrapper, resize will make as dirty for `resize: both` style
    const [resizeDirty, setResizeDirty] = $ltGt3.useState(false);
    const onInternalMouseDown = (e)=>{
        setIsMouseDown(true);
        onMouseDown?.(e);
        const onMouseUp = ()=>{
            setIsMouseDown(false);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mouseup', onMouseUp);
    };
    const onInternalResize = (size)=>{
        onResize?.(size);
        // Change to dirty since this maybe from the `resize: both` style
        if (isMouseDown && typeof getComputedStyle === 'function') {
            const ele = innerRef.current?.nativeElement?.querySelector('textarea');
            if (ele && getComputedStyle(ele).resize === 'both') setResizeDirty(true);
        }
    };
    // ==================== Render ====================
    return /*#__PURE__*/ $ltGt3.createElement((0, $7715a1e24ee75718$export$2e2bcd8739ae039), {
        autoComplete: contextAutoComplete,
        ...rest,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        styles: mergedStyles,
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(cssVarCls, rootCls, className, rootClassName, compactItemClassnames, contextClassName, mergedClassNames.root, // Only for wrapper
        {
            [`${prefixCls}-textarea-affix-wrapper-resize-dirty`]: resizeDirty
        }),
        classNames: {
            ...mergedClassNames,
            textarea: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large'
            }, hashId, mergedClassNames.textarea, isMouseDown && `${prefixCls}-mouse-active`),
            variant: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $7b7bdeafff468875$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-textarea-affix-wrapper`, {
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-textarea-show-count`]: showCount || props.count?.show
            }, hashId)
        },
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ $ltGt3.createElement("span", {
            className: `${prefixCls}-textarea-suffix`
        }, feedbackIcon),
        showCount: showCount,
        ref: innerRef,
        onResize: onInternalResize,
        onMouseDown: onInternalMouseDown
    });
});
var $b25fe3380ecdfadc$export$2e2bcd8739ae039 = $b25fe3380ecdfadc$var$TextArea;




/*
.typography-title(@fontSize; @fontWeight; @lineHeight; @headingColor; @headingMarginBottom;) {
 margin-bottom: @headingMarginBottom;
 color: @headingColor;
 font-weight: @fontWeight;
 fontSize: @fontSize;
 line-height: @lineHeight;
}
*/ 

const $26666f8b6bf1f3cb$var$getTitleStyle = (fontSize, lineHeight, color, token)=>{
    const { titleMarginBottom: titleMarginBottom, fontWeightStrong: fontWeightStrong } = token;
    return {
        marginBottom: titleMarginBottom,
        color: color,
        fontWeight: fontWeightStrong,
        fontSize: fontSize,
        lineHeight: lineHeight
    };
};
const $26666f8b6bf1f3cb$export$83146cf7d1bec659 = (token)=>{
    const headings = [
        1,
        2,
        3,
        4,
        5
    ];
    const styles = {};
    headings.forEach((headingLevel)=>{
        styles[`
      h${headingLevel}&,
      div&-h${headingLevel},
      div&-h${headingLevel} > textarea,
      h${headingLevel}
    `] = $26666f8b6bf1f3cb$var$getTitleStyle(token[`fontSizeHeading${headingLevel}`], token[`lineHeightHeading${headingLevel}`], token.colorTextHeading, token);
    });
    return styles;
};
const $26666f8b6bf1f3cb$export$566f4066c7caac18 = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        'a&, a': {
            ...(0, $945cb0d2b7017a11$export$9a16e7694a707ab4)(token),
            userSelect: 'text',
            [`&[disabled], &${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                '&:active, &:hover': {
                    color: token.colorTextDisabled
                },
                '&:active': {
                    pointerEvents: 'none'
                }
            }
        }
    };
};
const $26666f8b6bf1f3cb$export$977383a86f45014b = (token)=>({
        code: {
            margin: '0 0.2em',
            paddingInline: '0.4em',
            paddingBlock: '0.2em 0.1em',
            fontSize: '85%',
            fontFamily: token.fontFamilyCode,
            background: 'rgba(150, 150, 150, 0.1)',
            border: '1px solid rgba(100, 100, 100, 0.2)',
            borderRadius: 3
        },
        kbd: {
            margin: '0 0.2em',
            paddingInline: '0.4em',
            paddingBlock: '0.15em 0.1em',
            fontSize: '90%',
            fontFamily: token.fontFamilyCode,
            background: 'rgba(150, 150, 150, 0.06)',
            border: '1px solid rgba(100, 100, 100, 0.2)',
            borderBottomWidth: 2,
            borderRadius: 3
        },
        mark: {
            padding: 0,
            // FIXME hardcode in v4
            backgroundColor: (0, $1bd835bbb2d9f8c1$export$c24201f7fe3571d8)[2]
        },
        'u, ins': {
            textDecoration: 'underline',
            textDecorationSkipInk: 'auto'
        },
        's, del': {
            textDecoration: 'line-through'
        },
        strong: {
            fontWeight: token.fontWeightStrong
        },
        // list
        'ul, ol': {
            marginInline: 0,
            marginBlock: '0 1em',
            padding: 0,
            li: {
                marginInline: '20px 0',
                marginBlock: 0,
                paddingInline: '4px 0',
                paddingBlock: 0
            }
        },
        ul: {
            listStyleType: 'circle',
            ul: {
                listStyleType: 'disc'
            }
        },
        ol: {
            listStyleType: 'decimal'
        },
        // pre & block
        'pre, blockquote': {
            margin: '1em 0'
        },
        pre: {
            padding: '0.4em 0.6em',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            background: 'rgba(150, 150, 150, 0.1)',
            border: '1px solid rgba(100, 100, 100, 0.2)',
            borderRadius: 3,
            fontFamily: token.fontFamilyCode,
            // Compatible for marked
            code: {
                display: 'inline',
                margin: 0,
                padding: 0,
                fontSize: 'inherit',
                fontFamily: 'inherit',
                background: 'transparent',
                border: 0
            }
        },
        blockquote: {
            paddingInline: '0.6em 0',
            paddingBlock: 0,
            borderInlineStart: '4px solid rgba(100, 100, 100, 0.2)',
            opacity: 0.85
        }
    });
const $26666f8b6bf1f3cb$export$2667badb03518972 = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    const inputShift = paddingSM;
    return {
        '&-edit-content': {
            position: 'relative',
            'div&': {
                insetInlineStart: token.calc(token.paddingSM).mul(-1).equal(),
                insetBlockStart: token.calc(inputShift).div(-2).add(1).equal(),
                marginBottom: token.calc(inputShift).div(2).sub(2).equal()
            },
            [`${componentCls}-edit-content-confirm`]: {
                position: 'absolute',
                insetInlineEnd: token.calc(token.marginXS).add(2).equal(),
                insetBlockEnd: token.marginXS,
                color: token.colorIcon,
                // default style
                fontWeight: 'normal',
                fontSize: token.fontSize,
                fontStyle: 'normal',
                pointerEvents: 'none'
            },
            textarea: {
                margin: '0!important',
                // Fix Editable Textarea flash in Firefox
                MozTransition: 'none',
                height: '1em'
            }
        }
    };
};
const $26666f8b6bf1f3cb$export$34755446404037a5 = (token)=>({
        [`${token.componentCls}-copy-success`]: {
            [`
    &,
    &:hover,
    &:focus`]: {
                color: token.colorSuccess
            }
        },
        [`${token.componentCls}-copy-icon-only`]: {
            marginInlineStart: 0
        }
    });
const $26666f8b6bf1f3cb$export$d9556a50eba3003b = ()=>({
        [`
  a&-ellipsis,
  span&-ellipsis
  `]: {
            display: 'inline-block',
            maxWidth: '100%'
        },
        '&-ellipsis-single-line': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            // https://blog.csdn.net/iefreer/article/details/50421025
            'a&, span&': {
                verticalAlign: 'bottom'
            },
            '> code': {
                paddingBlock: 0,
                maxWidth: 'calc(100% - 1.2em)',
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                verticalAlign: 'bottom',
                // https://github.com/ant-design/ant-design/issues/45953
                boxSizing: 'content-box'
            }
        },
        '&-ellipsis-multiple-line': {
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical'
        }
    });


const $96d9cb8eecf45f28$var$genTypographyStyle = (token)=>{
    const { componentCls: componentCls, titleMarginTop: titleMarginTop } = token;
    return {
        [componentCls]: {
            color: token.colorText,
            wordBreak: 'break-word',
            lineHeight: token.lineHeight,
            [`&${componentCls}-secondary`]: {
                color: token.colorTextDescription
            },
            [`&${componentCls}-success`]: {
                color: token.colorSuccessText
            },
            [`&${componentCls}-warning`]: {
                color: token.colorWarningText
            },
            [`&${componentCls}-danger`]: {
                color: token.colorErrorText,
                'a&:active, a&:focus': {
                    color: token.colorErrorTextActive
                },
                'a&:hover': {
                    color: token.colorErrorTextHover
                }
            },
            [`&${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                userSelect: 'none'
            },
            [`
        div&,
        p
      `]: {
                marginBottom: '1em'
            },
            ...(0, $26666f8b6bf1f3cb$export$83146cf7d1bec659)(token),
            [`
      & + h1${componentCls},
      & + h2${componentCls},
      & + h3${componentCls},
      & + h4${componentCls},
      & + h5${componentCls}
      `]: {
                marginTop: titleMarginTop
            },
            [`
      div,
      ul,
      li,
      p,
      h1,
      h2,
      h3,
      h4,
      h5`]: {
                [`
        + h1,
        + h2,
        + h3,
        + h4,
        + h5
        `]: {
                    marginTop: titleMarginTop
                }
            },
            ...(0, $26666f8b6bf1f3cb$export$977383a86f45014b)(token),
            ...(0, $26666f8b6bf1f3cb$export$566f4066c7caac18)(token),
            // Operation
            [`
        ${componentCls}-expand,
        ${componentCls}-collapse,
        ${componentCls}-edit,
        ${componentCls}-copy
      `]: {
                ...(0, $945cb0d2b7017a11$export$9a16e7694a707ab4)(token),
                marginInlineStart: token.marginXXS
            },
            ...(0, $26666f8b6bf1f3cb$export$2667badb03518972)(token),
            ...(0, $26666f8b6bf1f3cb$export$34755446404037a5)(token),
            ...(0, $26666f8b6bf1f3cb$export$d9556a50eba3003b)(),
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
const $96d9cb8eecf45f28$export$9ca1be8807fe0675 = ()=>({
        titleMarginTop: '1.2em',
        titleMarginBottom: '0.5em'
    });
var // ============================== Export ==============================
$96d9cb8eecf45f28$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Typography', $96d9cb8eecf45f28$var$genTypographyStyle, $96d9cb8eecf45f28$export$9ca1be8807fe0675);


"use client";
const $c99581e56ddc4456$var$Editable = (props)=>{
    const { prefixCls: prefixCls, 'aria-label': ariaLabel, className: className, style: style, direction: direction, maxLength: maxLength, autoSize: autoSize = true, value: value, onSave: onSave, onCancel: onCancel, onEnd: onEnd, component: component, enterIcon: enterIcon = /*#__PURE__*/ $ltGt3.createElement((0, $10ed8d5d0b268d49$export$2e2bcd8739ae039), null) } = props;
    const ref = $ltGt3.useRef(null);
    const inComposition = $ltGt3.useRef(false);
    const lastKeyCode = $ltGt3.useRef(null);
    const [current, setCurrent] = $ltGt3.useState(value);
    $ltGt3.useEffect(()=>{
        setCurrent(value);
    }, [
        value
    ]);
    $ltGt3.useEffect(()=>{
        if (ref.current?.resizableTextArea) {
            const { textArea: textArea } = ref.current.resizableTextArea;
            textArea.focus();
            const { length: length } = textArea.value;
            textArea.setSelectionRange(length, length);
        }
    }, []);
    const onChange = ({ target: target })=>{
        setCurrent(target.value.replace(/[\n\r]/g, ''));
    };
    const onCompositionStart = ()=>{
        inComposition.current = true;
    };
    const onCompositionEnd = ()=>{
        inComposition.current = false;
    };
    const onKeyDown = ({ keyCode: keyCode })=>{
        // We don't record keyCode when IME is using
        if (inComposition.current) return;
        lastKeyCode.current = keyCode;
    };
    const confirmChange = ()=>{
        onSave(current.trim());
    };
    const onKeyUp = ({ keyCode: keyCode, ctrlKey: ctrlKey, altKey: altKey, metaKey: metaKey, shiftKey: shiftKey })=>{
        // Check if it's a real key
        if (lastKeyCode.current !== keyCode || inComposition.current || ctrlKey || altKey || metaKey || shiftKey) return;
        if (keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER) {
            confirmChange();
            onEnd?.();
        } else if (keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ESC) onCancel();
    };
    const onBlur = ()=>{
        confirmChange();
    };
    const [hashId, cssVarCls] = (0, $96d9cb8eecf45f28$export$2e2bcd8739ae039)(prefixCls);
    const textAreaClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-edit-content`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${component}`]: !!component
    }, className, hashId, cssVarCls);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: textAreaClassName,
        style: style
    }, /*#__PURE__*/ $ltGt3.createElement((0, $b25fe3380ecdfadc$export$2e2bcd8739ae039), {
        ref: ref,
        maxLength: maxLength,
        value: current,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBlur: onBlur,
        "aria-label": ariaLabel,
        rows: 1,
        autoSize: autoSize
    }), enterIcon !== null ? (0, $66d38239e1a27993$export$e530037191fcd5d7)(enterIcon, {
        className: `${prefixCls}-edit-content-confirm`
    }) : null);
};
var $c99581e56ddc4456$export$2e2bcd8739ae039 = $c99581e56ddc4456$var$Editable;



var $ltGt3 = parcelRequire("ltGt3");


const $44c26ebbdd060e02$var$execCopy = (text, isHtmlFormat)=>{
    let copySuccess = false;
    const onCopy = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        event.clipboardData?.clearData();
        event.clipboardData?.setData('text/plain', text);
        if (isHtmlFormat) event.clipboardData?.setData('text/html', text);
        copySuccess = true;
    };
    try {
        document.addEventListener('copy', onCopy, {
            capture: true
        });
        document.execCommand('copy');
        return copySuccess;
    } catch  {
        return false;
    } finally{
        document.removeEventListener('copy', onCopy, {
            capture: true
        });
    }
};
const $44c26ebbdd060e02$var$asyncCopy = async (text, isHtmlFormat)=>{
    try {
        if (isHtmlFormat) await navigator.clipboard.write([
            new ClipboardItem({
                'text/html': new Blob([
                    text
                ], {
                    type: 'text/html'
                }),
                'text/plain': new Blob([
                    text
                ], {
                    type: 'text/plain'
                })
            })
        ]);
        else await navigator.clipboard.writeText(text);
        return true;
    } catch  {
        return false;
    }
};
async function $44c26ebbdd060e02$var$copy(text, config) {
    if (typeof text !== 'string') return false;
    const isHtmlFormat = config?.format === 'text/html';
    if (await $44c26ebbdd060e02$var$asyncCopy(text, isHtmlFormat)) return true;
    if ($44c26ebbdd060e02$var$execCopy(text, isHtmlFormat)) return true;
    return false;
}
var $44c26ebbdd060e02$export$2e2bcd8739ae039 = $44c26ebbdd060e02$var$copy;


const $8ea1250e825022d5$var$toList = (candidate, skipEmpty = false)=>{
    if (skipEmpty && (candidate === undefined || candidate === null)) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
};
var $8ea1250e825022d5$export$2e2bcd8739ae039 = $8ea1250e825022d5$var$toList;


const $f56e1e8a4cc3fe9d$var$useCopyClick = ({ copyConfig: copyConfig, children: children })=>{
    const [copied, setCopied] = $ltGt3.useState(false);
    const [copyLoading, setCopyLoading] = $ltGt3.useState(false);
    const copyIdRef = $ltGt3.useRef(null);
    const cleanCopyId = ()=>{
        if (copyIdRef.current) clearTimeout(copyIdRef.current);
    };
    const copyOptions = {};
    if (copyConfig.format) copyOptions.format = copyConfig.format;
    $ltGt3.useEffect(()=>cleanCopyId, []);
    // Keep copy action up to date
    const onClick = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(async (e)=>{
        e?.preventDefault();
        e?.stopPropagation();
        setCopyLoading(true);
        try {
            const text = typeof copyConfig.text === 'function' ? await copyConfig.text() : copyConfig.text;
            await (0, $44c26ebbdd060e02$export$2e2bcd8739ae039)(text || (0, $8ea1250e825022d5$export$2e2bcd8739ae039)(children, true).join('') || '', copyOptions);
            setCopyLoading(false);
            setCopied(true);
            // Trigger tips update
            cleanCopyId();
            copyIdRef.current = setTimeout(()=>{
                setCopied(false);
            }, 3000);
            copyConfig.onCopy?.(e);
        } catch (error) {
            setCopyLoading(false);
            throw error;
        }
    });
    return {
        copied: copied,
        copyLoading: copyLoading,
        onClick: onClick
    };
};
var $f56e1e8a4cc3fe9d$export$2e2bcd8739ae039 = $f56e1e8a4cc3fe9d$var$useCopyClick;



var $ltGt3 = parcelRequire("ltGt3");
function $295907ddfc3180a1$export$2e2bcd8739ae039(propConfig, templateConfig) {
    return $ltGt3.useMemo(()=>{
        const support = !!propConfig;
        return [
            support,
            {
                ...templateConfig,
                ...support && typeof propConfig === 'object' ? propConfig : null
            }
        ];
    }, [
        propConfig
    ]);
}



var $ltGt3 = parcelRequire("ltGt3");
const $6b10970592b7c1bc$var$usePrevious = (value)=>{
    const ref = (0, $ltGt3.useRef)(undefined);
    (0, $ltGt3.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $6b10970592b7c1bc$export$2e2bcd8739ae039 = $6b10970592b7c1bc$var$usePrevious;



var $ltGt3 = parcelRequire("ltGt3");
const $680af5988b7815c7$var$useTooltipProps = (tooltip, editConfigText, children)=>(0, $ltGt3.useMemo)(()=>{
        if (tooltip === true) return {
            title: editConfigText ?? children
        };
        if (/*#__PURE__*/ (0, $ltGt3.isValidElement)(tooltip)) return {
            title: tooltip
        };
        if (typeof tooltip === 'object') return {
            title: editConfigText ?? children,
            ...tooltip
        };
        return {
            title: tooltip
        };
    }, [
        tooltip,
        editConfigText,
        children
    ]);
var $680af5988b7815c7$export$2e2bcd8739ae039 = $680af5988b7815c7$var$useTooltipProps;



var $ltGt3 = parcelRequire("ltGt3");



"use client";
const $7a11e31df34d2f7a$var$Typography = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, component: Component = 'article', className: className, rootClassName: rootClassName, children: children, direction: typographyDirection, style: style, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: contextDirection, className: contextClassName, style: contextStyle } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('typography');
    const direction = typographyDirection ?? contextDirection;
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $96d9cb8eecf45f28$export$2e2bcd8739ae039)(prefixCls);
    const componentClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, contextClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, hashId, cssVarCls);
    const mergedStyle = {
        ...contextStyle,
        ...style
    };
    return(/*#__PURE__*/ // @ts-expect-error: Expression produces a union type that is too complex to represent.
    $ltGt3.createElement(Component, {
        className: componentClassName,
        style: mergedStyle,
        ref: ref,
        ...restProps
    }, children));
});
var $7a11e31df34d2f7a$export$2e2bcd8739ae039 = $7a11e31df34d2f7a$var$Typography;



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $99a3077f6acc8f83$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
var $99a3077f6acc8f83$export$2e2bcd8739ae039 = $99a3077f6acc8f83$var$CheckOutlined;



function $69caf2b39a25e974$var$_extends() {
    $69caf2b39a25e974$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $69caf2b39a25e974$var$_extends.apply(this, arguments);
}
const $69caf2b39a25e974$var$CheckOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $69caf2b39a25e974$var$_extends({}, props, {
        ref: ref,
        icon: (0, $99a3077f6acc8f83$export$2e2bcd8739ae039)
    }));
/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */ const $69caf2b39a25e974$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($69caf2b39a25e974$var$CheckOutlined);
var $69caf2b39a25e974$export$2e2bcd8739ae039 = $69caf2b39a25e974$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $4cfbfff1eb489073$var$CopyOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    },
    "name": "copy",
    "theme": "outlined"
};
var $4cfbfff1eb489073$export$2e2bcd8739ae039 = $4cfbfff1eb489073$var$CopyOutlined;



function $14085413c538e164$var$_extends() {
    $14085413c538e164$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $14085413c538e164$var$_extends.apply(this, arguments);
}
const $14085413c538e164$var$CopyOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $14085413c538e164$var$_extends({}, props, {
        ref: ref,
        icon: (0, $4cfbfff1eb489073$export$2e2bcd8739ae039)
    }));
/**![copy](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgyOTZjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNDk2djY4OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04Vjk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MDQgMTkySDE5MmMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NTMwLjdjMCA4LjUgMy40IDE2LjYgOS40IDIyLjZsMTczLjMgMTczLjNjMi4yIDIuMiA0LjcgNCA3LjQgNS41djEuOWg0LjJjMy41IDEuMyA3LjIgMiAxMSAySDcwNGMxNy43IDAgMzItMTQuMyAzMi0zMlYyMjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTM1MCA4NTYuMkwyNjMuOSA3NzBIMzUwdjg2LjJ6TTY2NCA4ODhINDE0Vjc0NmMwLTIyLjEtMTcuOS00MC00MC00MEgyMzJWMjY0aDQzMnY2MjR6IiAvPjwvc3ZnPg==) */ const $14085413c538e164$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($14085413c538e164$var$CopyOutlined);
var $14085413c538e164$export$2e2bcd8739ae039 = $14085413c538e164$var$RefIcon;





function $23ed24f1bac504ff$export$effcdbd76139450(val) {
    if (val === false) return [
        false,
        false
    ];
    return Array.isArray(val) ? val : [
        val
    ];
}
function $23ed24f1bac504ff$export$3f778c4e796a1f9c(dom, defaultNode, needDom) {
    if (dom === true || dom === undefined) return defaultNode;
    return dom || needDom && defaultNode;
}
function $23ed24f1bac504ff$export$5714fcf57d9d6988(ele) {
    // Create a new div to get the size
    const childDiv = document.createElement('em');
    ele.appendChild(childDiv);
    const rect = ele.getBoundingClientRect();
    const childRect = childDiv.getBoundingClientRect();
    // Reset
    ele.removeChild(childDiv);
    // Range checker
    return(// Horizontal out of range
    rect.left > childRect.left || childRect.right > rect.right || // Vertical out of range
    rect.top > childRect.top || childRect.bottom > rect.bottom);
}
const $23ed24f1bac504ff$export$a748c1acb7702f51 = (val)=>[
        'string',
        'number'
    ].includes(typeof val);


"use client";
const $e6d8b1ecd5f79057$var$CopyBtn = ({ prefixCls: prefixCls, copied: copied, locale: locale, iconOnly: iconOnly, tooltips: tooltips, icon: icon, tabIndex: tabIndex, onCopy: onCopy, loading: btnLoading })=>{
    const tooltipNodes = (0, $23ed24f1bac504ff$export$effcdbd76139450)(tooltips);
    const iconNodes = (0, $23ed24f1bac504ff$export$effcdbd76139450)(icon);
    const { copied: copiedText, copy: copyText } = locale ?? {};
    const systemStr = copied ? copiedText : copyText;
    const copyTitle = (0, $23ed24f1bac504ff$export$3f778c4e796a1f9c)(tooltipNodes[copied ? 1 : 0], systemStr);
    const ariaLabel = typeof copyTitle === 'string' ? copyTitle : systemStr;
    return /*#__PURE__*/ $ltGt3.createElement((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
        title: copyTitle
    }, /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-copy`, {
            [`${prefixCls}-copy-success`]: copied,
            [`${prefixCls}-copy-icon-only`]: iconOnly
        }),
        onClick: onCopy,
        "aria-label": ariaLabel,
        tabIndex: tabIndex
    }, copied ? (0, $23ed24f1bac504ff$export$3f778c4e796a1f9c)(iconNodes[1], /*#__PURE__*/ $ltGt3.createElement((0, $69caf2b39a25e974$export$2e2bcd8739ae039), null), true) : (0, $23ed24f1bac504ff$export$3f778c4e796a1f9c)(iconNodes[0], btnLoading ? /*#__PURE__*/ $ltGt3.createElement((0, $8ede40f9e9e4f5c2$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $14085413c538e164$export$2e2bcd8739ae039), null), true)));
};
var $e6d8b1ecd5f79057$export$2e2bcd8739ae039 = $e6d8b1ecd5f79057$var$CopyBtn;




var $ltGt3 = parcelRequire("ltGt3");



"use client";
const $f0a21deb0c1bbab3$var$MeasureText = /*#__PURE__*/ $ltGt3.forwardRef(({ style: style, children: children }, ref)=>{
    const spanRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, ()=>({
            isExceed: ()=>{
                const span = spanRef.current;
                return span.scrollHeight > span.clientHeight;
            },
            getHeight: ()=>spanRef.current.clientHeight
        }));
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        "aria-hidden": true,
        ref: spanRef,
        style: {
            position: 'fixed',
            display: 'block',
            left: 0,
            top: 0,
            pointerEvents: 'none',
            backgroundColor: 'rgba(255, 0, 0, 0.65)',
            ...style
        }
    }, children);
});
const $f0a21deb0c1bbab3$var$getNodesLen = (nodeList)=>nodeList.reduce((totalLen, node)=>totalLen + ((0, $23ed24f1bac504ff$export$a748c1acb7702f51)(node) ? String(node).length : 1), 0);
function $f0a21deb0c1bbab3$var$sliceNodes(nodeList, len) {
    let currLen = 0;
    const currentNodeList = [];
    for(let i = 0; i < nodeList.length; i += 1){
        // Match to return
        if (currLen === len) return currentNodeList;
        const node = nodeList[i];
        const canCut = (0, $23ed24f1bac504ff$export$a748c1acb7702f51)(node);
        const nodeLen = canCut ? String(node).length : 1;
        const nextLen = currLen + nodeLen;
        // Exceed but current not which means we need cut this
        // This will not happen on validate ReactElement
        if (nextLen > len) {
            const restLen = len - currLen;
            currentNodeList.push(String(node).slice(0, restLen));
            return currentNodeList;
        }
        currentNodeList.push(node);
        currLen = nextLen;
    }
    return nodeList;
}
// Measure for the `text` is exceed the `rows` or not
const $f0a21deb0c1bbab3$var$STATUS_MEASURE_NONE = 0;
const $f0a21deb0c1bbab3$var$STATUS_MEASURE_PREPARE = 1;
const $f0a21deb0c1bbab3$var$STATUS_MEASURE_START = 2;
const $f0a21deb0c1bbab3$var$STATUS_MEASURE_NEED_ELLIPSIS = 3;
const $f0a21deb0c1bbab3$var$STATUS_MEASURE_NO_NEED_ELLIPSIS = 4;
const $f0a21deb0c1bbab3$var$lineClipStyle = {
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
};
function $f0a21deb0c1bbab3$export$2e2bcd8739ae039(props) {
    const { enableMeasure: enableMeasure, width: width, text: text, children: children, rows: rows, expanded: expanded, miscDeps: miscDeps, onEllipsis: onEllipsis } = props;
    const nodeList = $ltGt3.useMemo(()=>(0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(text), [
        text
    ]);
    const nodeLen = $ltGt3.useMemo(()=>$f0a21deb0c1bbab3$var$getNodesLen(nodeList), [
        text
    ]);
    // ========================= Full Content =========================
    // Used for measure only, which means it's always render as no need ellipsis
    const fullContent = $ltGt3.useMemo(()=>children(nodeList, false), [
        text
    ]);
    // ========================= Cut Content ==========================
    const [ellipsisCutIndex, setEllipsisCutIndex] = $ltGt3.useState(null);
    const cutMidRef = $ltGt3.useRef(null);
    // ========================= NeedEllipsis =========================
    const measureWhiteSpaceRef = $ltGt3.useRef(null);
    const needEllipsisRef = $ltGt3.useRef(null);
    // Measure for `rows-1` height, to avoid operation exceed the line height
    const descRowsEllipsisRef = $ltGt3.useRef(null);
    const symbolRowEllipsisRef = $ltGt3.useRef(null);
    const [canEllipsis, setCanEllipsis] = $ltGt3.useState(false);
    const [needEllipsis, setNeedEllipsis] = $ltGt3.useState($f0a21deb0c1bbab3$var$STATUS_MEASURE_NONE);
    const [ellipsisHeight, setEllipsisHeight] = $ltGt3.useState(0);
    const [parentWhiteSpace, setParentWhiteSpace] = $ltGt3.useState(null);
    // Trigger start measure
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (enableMeasure && width && nodeLen) setNeedEllipsis($f0a21deb0c1bbab3$var$STATUS_MEASURE_PREPARE);
        else setNeedEllipsis($f0a21deb0c1bbab3$var$STATUS_MEASURE_NONE);
    }, [
        width,
        text,
        rows,
        enableMeasure,
        nodeList
    ]);
    // Measure process
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (needEllipsis === $f0a21deb0c1bbab3$var$STATUS_MEASURE_PREPARE) {
            setNeedEllipsis($f0a21deb0c1bbab3$var$STATUS_MEASURE_START);
            // Parent ref `white-space`
            const nextWhiteSpace = measureWhiteSpaceRef.current && getComputedStyle(measureWhiteSpaceRef.current).whiteSpace;
            setParentWhiteSpace(nextWhiteSpace);
        } else if (needEllipsis === $f0a21deb0c1bbab3$var$STATUS_MEASURE_START) {
            const isOverflow = !!needEllipsisRef.current?.isExceed();
            setNeedEllipsis(isOverflow ? $f0a21deb0c1bbab3$var$STATUS_MEASURE_NEED_ELLIPSIS : $f0a21deb0c1bbab3$var$STATUS_MEASURE_NO_NEED_ELLIPSIS);
            setEllipsisCutIndex(isOverflow ? [
                0,
                nodeLen
            ] : null);
            setCanEllipsis(isOverflow);
            // Get the basic height of ellipsis rows
            const baseRowsEllipsisHeight = needEllipsisRef.current?.getHeight() || 0;
            // Get the height of `rows - 1` + symbol height
            const descRowsEllipsisHeight = rows === 1 ? 0 : descRowsEllipsisRef.current?.getHeight() || 0;
            const symbolRowEllipsisHeight = symbolRowEllipsisRef.current?.getHeight() || 0;
            const maxRowsHeight = Math.max(baseRowsEllipsisHeight, // height of rows with ellipsis
            descRowsEllipsisHeight + symbolRowEllipsisHeight);
            setEllipsisHeight(maxRowsHeight + 1);
            onEllipsis(isOverflow);
        }
    }, [
        needEllipsis
    ]);
    // ========================= Cut Measure ==========================
    const cutMidIndex = ellipsisCutIndex ? Math.ceil((ellipsisCutIndex[0] + ellipsisCutIndex[1]) / 2) : 0;
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        const [minIndex, maxIndex] = ellipsisCutIndex || [
            0,
            0
        ];
        if (minIndex !== maxIndex) {
            const midHeight = cutMidRef.current?.getHeight() || 0;
            const isOverflow = midHeight > ellipsisHeight;
            let targetMidIndex = cutMidIndex;
            if (maxIndex - minIndex === 1) targetMidIndex = isOverflow ? minIndex : maxIndex;
            setEllipsisCutIndex(isOverflow ? [
                minIndex,
                targetMidIndex
            ] : [
                targetMidIndex,
                maxIndex
            ]);
        }
    }, [
        ellipsisCutIndex,
        cutMidIndex
    ]);
    // ========================= Text Content =========================
    const finalContent = $ltGt3.useMemo(()=>{
        // Skip everything if `enableMeasure` is disabled
        if (!enableMeasure) return children(nodeList, false);
        if (needEllipsis !== $f0a21deb0c1bbab3$var$STATUS_MEASURE_NEED_ELLIPSIS || !ellipsisCutIndex || ellipsisCutIndex[0] !== ellipsisCutIndex[1]) {
            const content = children(nodeList, false);
            // Limit the max line count to avoid scrollbar blink unless no need ellipsis
            // https://github.com/ant-design/ant-design/issues/42958
            if ([
                $f0a21deb0c1bbab3$var$STATUS_MEASURE_NO_NEED_ELLIPSIS,
                $f0a21deb0c1bbab3$var$STATUS_MEASURE_NONE
            ].includes(needEllipsis)) return content;
            return /*#__PURE__*/ $ltGt3.createElement("span", {
                style: {
                    ...$f0a21deb0c1bbab3$var$lineClipStyle,
                    WebkitLineClamp: rows
                }
            }, content);
        }
        return children(expanded ? nodeList : $f0a21deb0c1bbab3$var$sliceNodes(nodeList, ellipsisCutIndex[0]), canEllipsis);
    }, [
        expanded,
        needEllipsis,
        ellipsisCutIndex,
        nodeList
    ].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(miscDeps)));
    // ============================ Render ============================
    const measureStyle = {
        width: width,
        margin: 0,
        padding: 0,
        whiteSpace: parentWhiteSpace === 'nowrap' ? 'normal' : 'inherit'
    };
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, finalContent, needEllipsis === $f0a21deb0c1bbab3$var$STATUS_MEASURE_START && /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement($f0a21deb0c1bbab3$var$MeasureText, {
        style: {
            ...measureStyle,
            ...$f0a21deb0c1bbab3$var$lineClipStyle,
            WebkitLineClamp: rows
        },
        ref: needEllipsisRef
    }, fullContent), /*#__PURE__*/ $ltGt3.createElement($f0a21deb0c1bbab3$var$MeasureText, {
        style: {
            ...measureStyle,
            ...$f0a21deb0c1bbab3$var$lineClipStyle,
            WebkitLineClamp: rows - 1
        },
        ref: descRowsEllipsisRef
    }, fullContent), /*#__PURE__*/ $ltGt3.createElement($f0a21deb0c1bbab3$var$MeasureText, {
        style: {
            ...measureStyle,
            ...$f0a21deb0c1bbab3$var$lineClipStyle,
            WebkitLineClamp: 1
        },
        ref: symbolRowEllipsisRef
    }, children([], true))), needEllipsis === $f0a21deb0c1bbab3$var$STATUS_MEASURE_NEED_ELLIPSIS && ellipsisCutIndex && ellipsisCutIndex[0] !== ellipsisCutIndex[1] && /*#__PURE__*/ $ltGt3.createElement($f0a21deb0c1bbab3$var$MeasureText, {
        style: {
            ...measureStyle,
            top: 400
        },
        ref: cutMidRef
    }, children($f0a21deb0c1bbab3$var$sliceNodes(nodeList, cutMidIndex), true)), needEllipsis === $f0a21deb0c1bbab3$var$STATUS_MEASURE_PREPARE && /*#__PURE__*/ $ltGt3.createElement("span", {
        style: {
            whiteSpace: 'inherit'
        },
        ref: measureWhiteSpaceRef
    }));
}



var $ltGt3 = parcelRequire("ltGt3");

"use client";
const $fb611bf590000c01$var$EllipsisTooltip = ({ enableEllipsis: enableEllipsis, isEllipsis: isEllipsis, children: children, tooltipProps: tooltipProps })=>{
    if (!tooltipProps?.title || !enableEllipsis) return children;
    return /*#__PURE__*/ $ltGt3.createElement((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
        open: isEllipsis ? undefined : false,
        ...tooltipProps
    }, children);
};
var $fb611bf590000c01$export$2e2bcd8739ae039 = $fb611bf590000c01$var$EllipsisTooltip;



"use client";
function $66a958aba01257b9$var$wrapperDecorations({ mark: mark, code: code, underline: underline, delete: del, strong: strong, keyboard: keyboard, italic: italic }, content) {
    let currentContent = content;
    function wrap(tag, needed) {
        if (!needed) return;
        currentContent = /*#__PURE__*/ $ltGt3.createElement(tag, {}, currentContent);
    }
    wrap('strong', strong);
    wrap('u', underline);
    wrap('del', del);
    wrap('code', code);
    wrap('mark', mark);
    wrap('kbd', keyboard);
    wrap('i', italic);
    return currentContent;
}
const $66a958aba01257b9$var$ELLIPSIS_STR = '...';
const $66a958aba01257b9$var$DECORATION_PROPS = [
    'delete',
    'mark',
    'code',
    'underline',
    'strong',
    'keyboard',
    'italic'
];
const $66a958aba01257b9$var$Base = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, style: style, type: type, disabled: disabled, children: children, ellipsis: ellipsis, editable: editable, copyable: copyable, component: component, title: title, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const [textLocale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Text');
    const typographyRef = $ltGt3.useRef(null);
    const editIconRef = $ltGt3.useRef(null);
    // ============================ MISC ============================
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    const textProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(restProps, $66a958aba01257b9$var$DECORATION_PROPS);
    // ========================== Editable ==========================
    const [enableEdit, editConfig] = (0, $295907ddfc3180a1$export$2e2bcd8739ae039)(editable);
    const [editing, setEditing] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(false, editConfig.editing);
    const { triggerType: triggerType = [
        'icon'
    ] } = editConfig;
    const triggerEdit = (edit)=>{
        if (edit) editConfig.onStart?.();
        setEditing(edit);
    };
    // Focus edit icon when back
    const prevEditing = (0, $6b10970592b7c1bc$export$2e2bcd8739ae039)(editing);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (!editing && prevEditing) editIconRef.current?.focus();
    }, [
        editing
    ]);
    const onEditClick = (e)=>{
        e?.preventDefault();
        triggerEdit(true);
    };
    const onEditChange = (value)=>{
        editConfig.onChange?.(value);
        triggerEdit(false);
    };
    const onEditCancel = ()=>{
        editConfig.onCancel?.();
        triggerEdit(false);
    };
    // ========================== Copyable ==========================
    const [enableCopy, copyConfig] = (0, $295907ddfc3180a1$export$2e2bcd8739ae039)(copyable);
    const { copied: copied, copyLoading: copyLoading, onClick: onCopyClick } = (0, $f56e1e8a4cc3fe9d$export$2e2bcd8739ae039)({
        copyConfig: copyConfig,
        children: children
    });
    // ========================== Ellipsis ==========================
    const [isLineClampSupport, setIsLineClampSupport] = $ltGt3.useState(false);
    const [isTextOverflowSupport, setIsTextOverflowSupport] = $ltGt3.useState(false);
    const [isJsEllipsis, setIsJsEllipsis] = $ltGt3.useState(false);
    const [isNativeEllipsis, setIsNativeEllipsis] = $ltGt3.useState(false);
    const [isNativeVisible, setIsNativeVisible] = $ltGt3.useState(true);
    const [enableEllipsis, ellipsisConfig] = (0, $295907ddfc3180a1$export$2e2bcd8739ae039)(ellipsis, {
        expandable: false,
        symbol: (isExpanded)=>isExpanded ? textLocale?.collapse : textLocale?.expand
    });
    const [expanded, setExpanded] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(ellipsisConfig.defaultExpanded || false, ellipsisConfig.expanded);
    const mergedEnableEllipsis = enableEllipsis && (!expanded || ellipsisConfig.expandable === 'collapsible');
    // Shared prop to reduce bundle size
    const { rows: rows = 1 } = ellipsisConfig;
    const needMeasureEllipsis = $ltGt3.useMemo(()=>// Disable ellipsis
        mergedEnableEllipsis && // Provide suffix
        (ellipsisConfig.suffix !== undefined || ellipsisConfig.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
        ellipsisConfig.expandable || enableEdit || enableCopy), [
        mergedEnableEllipsis,
        ellipsisConfig,
        enableEdit,
        enableCopy
    ]);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (enableEllipsis && !needMeasureEllipsis) {
            setIsLineClampSupport((0, $abe1f49eefe140f3$export$d616d7831008e86c)('webkitLineClamp'));
            setIsTextOverflowSupport((0, $abe1f49eefe140f3$export$d616d7831008e86c)('textOverflow'));
        }
    }, [
        needMeasureEllipsis,
        enableEllipsis
    ]);
    const [cssEllipsis, setCssEllipsis] = $ltGt3.useState(mergedEnableEllipsis);
    const canUseCssEllipsis = $ltGt3.useMemo(()=>{
        if (needMeasureEllipsis) return false;
        if (rows === 1) return isTextOverflowSupport;
        return isLineClampSupport;
    }, [
        needMeasureEllipsis,
        isTextOverflowSupport,
        isLineClampSupport
    ]);
    // We use effect to change from css ellipsis to js ellipsis.
    // To make SSR still can see the ellipsis.
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        setCssEllipsis(canUseCssEllipsis && mergedEnableEllipsis);
    }, [
        canUseCssEllipsis,
        mergedEnableEllipsis
    ]);
    const isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? isNativeEllipsis : isJsEllipsis);
    const cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
    const cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
    // >>>>> Expand
    const onExpandClick = (e, info)=>{
        setExpanded(info.expanded);
        ellipsisConfig.onExpand?.(e, info);
    };
    const [ellipsisWidth, setEllipsisWidth] = $ltGt3.useState(0);
    const onResize = ({ offsetWidth: offsetWidth })=>{
        setEllipsisWidth(offsetWidth);
    };
    // >>>>> JS Ellipsis
    const onJsEllipsis = (jsEllipsis)=>{
        setIsJsEllipsis(jsEllipsis);
        // Trigger if changed
        if (isJsEllipsis !== jsEllipsis) ellipsisConfig.onEllipsis?.(jsEllipsis);
    };
    // >>>>> Native ellipsis
    $ltGt3.useEffect(()=>{
        const textEle = typographyRef.current;
        if (enableEllipsis && cssEllipsis && textEle) {
            const currentEllipsis = (0, $23ed24f1bac504ff$export$5714fcf57d9d6988)(textEle);
            if (isNativeEllipsis !== currentEllipsis) setIsNativeEllipsis(currentEllipsis);
        }
    }, [
        enableEllipsis,
        cssEllipsis,
        children,
        cssLineClamp,
        isNativeVisible,
        ellipsisWidth
    ]);
    // https://github.com/ant-design/ant-design/issues/36786
    // Use IntersectionObserver to check if element is invisible
    $ltGt3.useEffect(()=>{
        const textEle = typographyRef.current;
        if (typeof IntersectionObserver === 'undefined' || !textEle || !cssEllipsis || !mergedEnableEllipsis) return;
        /* eslint-disable-next-line compat/compat */ const observer = new IntersectionObserver(()=>{
            setIsNativeVisible(!!textEle.offsetParent);
        });
        observer.observe(textEle);
        return ()=>{
            observer.disconnect();
        };
    }, [
        cssEllipsis,
        mergedEnableEllipsis
    ]);
    // ========================== Tooltip ===========================
    const tooltipProps = (0, $680af5988b7815c7$export$2e2bcd8739ae039)(ellipsisConfig.tooltip, editConfig.text, children);
    const topAriaLabel = $ltGt3.useMemo(()=>{
        if (!enableEllipsis || cssEllipsis) return undefined;
        return [
            editConfig.text,
            children,
            title,
            tooltipProps.title
        ].find((0, $23ed24f1bac504ff$export$a748c1acb7702f51));
    }, [
        enableEllipsis,
        cssEllipsis,
        title,
        tooltipProps.title,
        isMergedEllipsis
    ]);
    // =========================== Render ===========================
    // >>>>>>>>>>> Editing input
    if (editing) return /*#__PURE__*/ $ltGt3.createElement((0, $c99581e56ddc4456$export$2e2bcd8739ae039), {
        value: editConfig.text ?? (typeof children === 'string' ? children : ''),
        onSave: onEditChange,
        onCancel: onEditCancel,
        onEnd: editConfig.onEnd,
        prefixCls: prefixCls,
        className: className,
        style: style,
        direction: direction,
        component: component,
        maxLength: editConfig.maxLength,
        autoSize: editConfig.autoSize,
        enterIcon: editConfig.enterIcon
    });
    // >>>>>>>>>>> Typography
    // Expand
    const renderExpand = ()=>{
        const { expandable: expandable, symbol: symbol } = ellipsisConfig;
        return expandable ? /*#__PURE__*/ $ltGt3.createElement("button", {
            type: "button",
            key: "expand",
            className: `${prefixCls}-${expanded ? 'collapse' : 'expand'}`,
            onClick: (e)=>onExpandClick(e, {
                    expanded: !expanded
                }),
            "aria-label": expanded ? textLocale.collapse : textLocale?.expand
        }, typeof symbol === 'function' ? symbol(expanded) : symbol) : null;
    };
    // Edit
    const renderEdit = ()=>{
        if (!enableEdit) return;
        const { icon: icon, tooltip: tooltip, tabIndex: tabIndex } = editConfig;
        const editTitle = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(tooltip)[0] || textLocale?.edit;
        const ariaLabel = typeof editTitle === 'string' ? editTitle : '';
        return triggerType.includes('icon') ? /*#__PURE__*/ $ltGt3.createElement((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
            key: "edit",
            title: tooltip === false ? '' : editTitle
        }, /*#__PURE__*/ $ltGt3.createElement("button", {
            type: "button",
            ref: editIconRef,
            className: `${prefixCls}-edit`,
            onClick: onEditClick,
            "aria-label": ariaLabel,
            tabIndex: tabIndex
        }, icon || /*#__PURE__*/ $ltGt3.createElement((0, $6ff101c7149aa3d0$export$2e2bcd8739ae039), {
            role: "button"
        }))) : null;
    };
    // Copy
    const renderCopy = ()=>{
        if (!enableCopy) return null;
        return /*#__PURE__*/ $ltGt3.createElement((0, $e6d8b1ecd5f79057$export$2e2bcd8739ae039), {
            key: "copy",
            ...copyConfig,
            prefixCls: prefixCls,
            copied: copied,
            locale: textLocale,
            onCopy: onCopyClick,
            loading: copyLoading,
            iconOnly: children === null || children === undefined
        });
    };
    const renderOperations = (canEllipsis)=>[
            canEllipsis && renderExpand(),
            renderEdit(),
            renderCopy()
        ];
    const renderEllipsis = (canEllipsis)=>[
            canEllipsis && !expanded && /*#__PURE__*/ $ltGt3.createElement("span", {
                "aria-hidden": true,
                key: "ellipsis"
            }, $66a958aba01257b9$var$ELLIPSIS_STR),
            ellipsisConfig.suffix,
            renderOperations(canEllipsis)
        ];
    return /*#__PURE__*/ $ltGt3.createElement((0, $9ed13185b45d829d$export$2e2bcd8739ae039), {
        onResize: onResize,
        disabled: !mergedEnableEllipsis
    }, (resizeRef)=>/*#__PURE__*/ $ltGt3.createElement((0, $fb611bf590000c01$export$2e2bcd8739ae039), {
            tooltipProps: tooltipProps,
            enableEllipsis: mergedEnableEllipsis,
            isEllipsis: isMergedEllipsis
        }, /*#__PURE__*/ $ltGt3.createElement((0, $7a11e31df34d2f7a$export$2e2bcd8739ae039), {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${type}`]: type,
                [`${prefixCls}-disabled`]: disabled,
                [`${prefixCls}-ellipsis`]: enableEllipsis,
                [`${prefixCls}-ellipsis-single-line`]: cssTextOverflow,
                [`${prefixCls}-ellipsis-multiple-line`]: cssLineClamp
            }, className),
            prefixCls: customizePrefixCls,
            style: {
                ...style,
                WebkitLineClamp: cssLineClamp ? rows : undefined
            },
            component: component,
            ref: (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(resizeRef, typographyRef, ref),
            direction: direction,
            onClick: triggerType.includes('text') ? onEditClick : undefined,
            "aria-label": topAriaLabel?.toString(),
            title: title,
            ...textProps
        }, /*#__PURE__*/ $ltGt3.createElement((0, $f0a21deb0c1bbab3$export$2e2bcd8739ae039), {
            enableMeasure: mergedEnableEllipsis && !cssEllipsis,
            text: children,
            rows: rows,
            width: ellipsisWidth,
            onEllipsis: onJsEllipsis,
            expanded: expanded,
            miscDeps: [
                copied,
                expanded,
                copyLoading,
                enableEdit,
                enableCopy,
                textLocale
            ].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)($66a958aba01257b9$var$DECORATION_PROPS.map((key)=>props[key])))
        }, (node, canEllipsis)=>$66a958aba01257b9$var$wrapperDecorations(props, /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, node.length > 0 && canEllipsis && !expanded && topAriaLabel ? /*#__PURE__*/ $ltGt3.createElement("span", {
                key: "show-content",
                "aria-hidden": true
            }, node) : node, renderEllipsis(canEllipsis)))))));
});
var $66a958aba01257b9$export$2e2bcd8739ae039 = $66a958aba01257b9$var$Base;


"use client";
const $fcd774851192bc9c$var$Link = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { ellipsis: ellipsis, rel: rel, children: children, // @ts-expect-error: https://github.com/ant-design/ant-design/issues/26622
    navigate: _navigate, ...restProps } = props;
    const mergedProps = {
        ...restProps,
        rel: rel === undefined && restProps.target === '_blank' ? 'noopener noreferrer' : rel
    };
    return /*#__PURE__*/ $ltGt3.createElement((0, $66a958aba01257b9$export$2e2bcd8739ae039), {
        ...mergedProps,
        ref: ref,
        ellipsis: !!ellipsis,
        component: "a"
    }, children);
});
var $fcd774851192bc9c$export$2e2bcd8739ae039 = $fcd774851192bc9c$var$Link;



var $ltGt3 = parcelRequire("ltGt3");

"use client";
const $a636c48205219178$var$Paragraph = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { children: children, ...restProps } = props;
    return /*#__PURE__*/ $ltGt3.createElement((0, $66a958aba01257b9$export$2e2bcd8739ae039), {
        ref: ref,
        ...restProps,
        component: "div"
    }, children);
});
var $a636c48205219178$export$2e2bcd8739ae039 = $a636c48205219178$var$Paragraph;



var $ltGt3 = parcelRequire("ltGt3");



"use client";
const $a81dadaf70a50142$var$Text = (props, ref)=>{
    const { ellipsis: ellipsis, children: children, ...restProps } = props;
    const mergedEllipsis = $ltGt3.useMemo(()=>{
        if (ellipsis && typeof ellipsis === 'object') return (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(ellipsis, [
            'expandable',
            'rows'
        ]);
        return ellipsis;
    }, [
        ellipsis
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $66a958aba01257b9$export$2e2bcd8739ae039), {
        ref: ref,
        ...restProps,
        ellipsis: mergedEllipsis,
        component: "span"
    }, children);
};
var $a81dadaf70a50142$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.forwardRef($a81dadaf70a50142$var$Text);



var $ltGt3 = parcelRequire("ltGt3");


"use client";
const $5e98db070755ea74$var$TITLE_ELE_LIST = [
    1,
    2,
    3,
    4,
    5
];
const $5e98db070755ea74$var$Title = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { level: level = 1, children: children, ...restProps } = props;
    const component = $5e98db070755ea74$var$TITLE_ELE_LIST.includes(level) ? `h${level}` : `h1`;
    return /*#__PURE__*/ $ltGt3.createElement((0, $66a958aba01257b9$export$2e2bcd8739ae039), {
        ref: ref,
        ...restProps,
        component: component
    }, children);
});
var $5e98db070755ea74$export$2e2bcd8739ae039 = $5e98db070755ea74$var$Title;



"use client";
const $4e2a56a3190d5290$var$Typography = (0, $7a11e31df34d2f7a$export$2e2bcd8739ae039);
$4e2a56a3190d5290$var$Typography.Text = (0, $a81dadaf70a50142$export$2e2bcd8739ae039);
$4e2a56a3190d5290$var$Typography.Link = (0, $fcd774851192bc9c$export$2e2bcd8739ae039);
$4e2a56a3190d5290$var$Typography.Title = (0, $5e98db070755ea74$export$2e2bcd8739ae039);
$4e2a56a3190d5290$var$Typography.Paragraph = (0, $a636c48205219178$export$2e2bcd8739ae039);
var $4e2a56a3190d5290$export$2e2bcd8739ae039 = $4e2a56a3190d5290$var$Typography;


parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
/**
 * React Router DOM v6.8.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $ltGt3 = parcelRequire("ltGt3");
/**
 * @remix-run/router v1.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $16791ace69c4cf4f$var$_extends() {
    $16791ace69c4cf4f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $16791ace69c4cf4f$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $16791ace69c4cf4f$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($16791ace69c4cf4f$export$e19cd5f9376f8cee || ($16791ace69c4cf4f$export$e19cd5f9376f8cee = {}));
const $16791ace69c4cf4f$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $16791ace69c4cf4f$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $16791ace69c4cf4f$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $16791ace69c4cf4f$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $16791ace69c4cf4f$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $16791ace69c4cf4f$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $16791ace69c4cf4f$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $16791ace69c4cf4f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $16791ace69c4cf4f$export$fe53371bee54353d(to);
    }
    return $16791ace69c4cf4f$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $16791ace69c4cf4f$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $16791ace69c4cf4f$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $16791ace69c4cf4f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $16791ace69c4cf4f$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $16791ace69c4cf4f$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $16791ace69c4cf4f$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $16791ace69c4cf4f$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $16791ace69c4cf4f$var$warning$1(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $16791ace69c4cf4f$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $16791ace69c4cf4f$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $16791ace69c4cf4f$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $16791ace69c4cf4f$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $16791ace69c4cf4f$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $16791ace69c4cf4f$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $16791ace69c4cf4f$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $16791ace69c4cf4f$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $16791ace69c4cf4f$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($16791ace69c4cf4f$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Push;
        let location = $16791ace69c4cf4f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $16791ace69c4cf4f$var$getHistoryState(location, index);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Replace;
        let location = $16791ace69c4cf4f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $16791ace69c4cf4f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $16791ace69c4cf4f$export$fe53371bee54353d(to);
        $16791ace69c4cf4f$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($16791ace69c4cf4f$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($16791ace69c4cf4f$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $16791ace69c4cf4f$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($16791ace69c4cf4f$var$ResultType || ($16791ace69c4cf4f$var$ResultType = {}));
function $16791ace69c4cf4f$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $16791ace69c4cf4f$export$4a6d22b32134ea5d(routes, parentPath, allIds) {
    if (parentPath === void 0) parentPath = [];
    if (allIds === void 0) allIds = new Set();
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $16791ace69c4cf4f$export$f5708dca728d7177(route.index !== true || !route.children, "Cannot specify children on an index route");
        $16791ace69c4cf4f$export$f5708dca728d7177(!allIds.has(id), "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        allIds.add(id);
        if ($16791ace69c4cf4f$var$isIndexRoute(route)) {
            let indexRoute = $16791ace69c4cf4f$var$_extends({}, route, {
                id: id
            });
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $16791ace69c4cf4f$var$_extends({}, route, {
                id: id,
                children: route.children ? $16791ace69c4cf4f$export$4a6d22b32134ea5d(route.children, treePath, allIds) : undefined
            });
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $16791ace69c4cf4f$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $16791ace69c4cf4f$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $16791ace69c4cf4f$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $16791ace69c4cf4f$var$flattenRoutes(routes);
    $16791ace69c4cf4f$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $16791ace69c4cf4f$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $16791ace69c4cf4f$var$safelyDecodeURI(pathname));
    return matches;
}
function $16791ace69c4cf4f$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $16791ace69c4cf4f$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $16791ace69c4cf4f$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $16791ace69c4cf4f$export$f5708dca728d7177(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $16791ace69c4cf4f$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $16791ace69c4cf4f$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $16791ace69c4cf4f$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $16791ace69c4cf4f$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $16791ace69c4cf4f$var$explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $16791ace69c4cf4f$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $16791ace69c4cf4f$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $16791ace69c4cf4f$var$paramRe = /^:\w+$/;
const $16791ace69c4cf4f$var$dynamicSegmentValue = 3;
const $16791ace69c4cf4f$var$indexRouteValue = 2;
const $16791ace69c4cf4f$var$emptySegmentValue = 1;
const $16791ace69c4cf4f$var$staticSegmentValue = 10;
const $16791ace69c4cf4f$var$splatPenalty = -2;
const $16791ace69c4cf4f$var$isSplat = (s)=>s === "*";
function $16791ace69c4cf4f$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($16791ace69c4cf4f$var$isSplat)) initialScore += $16791ace69c4cf4f$var$splatPenalty;
    if (index) initialScore += $16791ace69c4cf4f$var$indexRouteValue;
    return segments.filter((s)=>!$16791ace69c4cf4f$var$isSplat(s)).reduce((score, segment)=>score + ($16791ace69c4cf4f$var$paramRe.test(segment) ? $16791ace69c4cf4f$var$dynamicSegmentValue : segment === "" ? $16791ace69c4cf4f$var$emptySegmentValue : $16791ace69c4cf4f$var$staticSegmentValue), initialScore);
}
function $16791ace69c4cf4f$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $16791ace69c4cf4f$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $16791ace69c4cf4f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $16791ace69c4cf4f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $16791ace69c4cf4f$export$a5c6d149b50c1d86($16791ace69c4cf4f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $16791ace69c4cf4f$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $16791ace69c4cf4f$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $16791ace69c4cf4f$export$491112666e282270(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    return path.replace(/^:(\w+)(\??)/g, (_, key, optional)=>{
        let param = params[key];
        if (optional === "?") return param == null ? "" : param;
        if (param == null) $16791ace69c4cf4f$export$f5708dca728d7177(false, "Missing \":" + key + "\" param");
        return param;
    }).replace(/\/:(\w+)(\??)/g, (_, key, optional)=>{
        let param = params[key];
        if (optional === "?") return param == null ? "" : "/" + param;
        if (param == null) $16791ace69c4cf4f$export$f5708dca728d7177(false, "Missing \":" + key + "\" param");
        return "/" + param;
    }) // Remove any optional markers from optional static segments
    .replace(/\?/g, "").replace(/(\/?)\*/, (_, prefix, __, str)=>{
        const star = "*";
        if (params[star] == null) // If no splat was provided, trim the trailing slash _unless_ it's
        // the entire path
        return str === "/*" ? "/" : "";
         // Apply the splat
        return "" + prefix + params[star];
    });
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $16791ace69c4cf4f$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $16791ace69c4cf4f$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $16791ace69c4cf4f$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $16791ace69c4cf4f$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $16791ace69c4cf4f$export$491112666e282270(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $16791ace69c4cf4f$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $16791ace69c4cf4f$export$491112666e282270(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $16791ace69c4cf4f$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $16791ace69c4cf4f$export$491112666e282270(false, "The value for the URL param \"" + paramName + "\" will not be decoded because" + (" the string \"" + value + "\" is a malformed URL segment. This is probably") + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $16791ace69c4cf4f$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * @private
 */ function $16791ace69c4cf4f$export$491112666e282270(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging @remix-run/router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $16791ace69c4cf4f$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $16791ace69c4cf4f$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $16791ace69c4cf4f$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $16791ace69c4cf4f$var$normalizeSearch(search),
        hash: $16791ace69c4cf4f$var$normalizeHash(hash)
    };
}
function $16791ace69c4cf4f$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $16791ace69c4cf4f$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $16791ace69c4cf4f$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $16791ace69c4cf4f$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $16791ace69c4cf4f$export$8ccf933b0513f8d0(toArg);
    else {
        to = $16791ace69c4cf4f$var$_extends({}, toArg);
        $16791ace69c4cf4f$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $16791ace69c4cf4f$var$getInvalidPathError("?", "pathname", "search", to));
        $16791ace69c4cf4f$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $16791ace69c4cf4f$var$getInvalidPathError("#", "pathname", "hash", to));
        $16791ace69c4cf4f$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $16791ace69c4cf4f$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $16791ace69c4cf4f$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $16791ace69c4cf4f$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $16791ace69c4cf4f$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $16791ace69c4cf4f$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $16791ace69c4cf4f$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $16791ace69c4cf4f$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $16791ace69c4cf4f$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $16791ace69c4cf4f$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $16791ace69c4cf4f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $16791ace69c4cf4f$export$42a99a7a4bc0e76a extends Error {
}
class $16791ace69c4cf4f$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $16791ace69c4cf4f$export$f5708dca728d7177(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $16791ace69c4cf4f$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $16791ace69c4cf4f$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $16791ace69c4cf4f$export$f5708dca728d7177(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $16791ace69c4cf4f$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $16791ace69c4cf4f$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $16791ace69c4cf4f$var$unwrapTrackedPromise(value) {
    if (!$16791ace69c4cf4f$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $16791ace69c4cf4f$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $16791ace69c4cf4f$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $16791ace69c4cf4f$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $16791ace69c4cf4f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $16791ace69c4cf4f$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $16791ace69c4cf4f$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $16791ace69c4cf4f$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $16791ace69c4cf4f$var$validMutationMethods = new Set($16791ace69c4cf4f$var$validMutationMethodsArr);
const $16791ace69c4cf4f$var$validRequestMethodsArr = [
    "get",
    ...$16791ace69c4cf4f$var$validMutationMethodsArr
];
const $16791ace69c4cf4f$var$validRequestMethods = new Set($16791ace69c4cf4f$var$validRequestMethodsArr);
const $16791ace69c4cf4f$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $16791ace69c4cf4f$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $16791ace69c4cf4f$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $16791ace69c4cf4f$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $16791ace69c4cf4f$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $16791ace69c4cf4f$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $16791ace69c4cf4f$var$isServer = !$16791ace69c4cf4f$var$isBrowser; //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $16791ace69c4cf4f$export$baddd0131ee8c05b(init) {
    $16791ace69c4cf4f$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let dataRoutes = $16791ace69c4cf4f$export$4a6d22b32134ea5d(init.routes); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $16791ace69c4cf4f$export$2708184779ceb39d(dataRoutes, init.history.location, init.basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $16791ace69c4cf4f$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $16791ace69c4cf4f$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = !initialMatches.some((m)=>m.route.loader) || init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $16791ace69c4cf4f$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // We ony support a single active blocker at the moment since we don't have
    // any compelling use cases for multi-blocker yet
    let activeBlocker = null; // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $16791ace69c4cf4f$export$491112666e282270(activeBlocker != null && delta === null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        if (!state.initialized) startNavigation($16791ace69c4cf4f$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $16791ace69c4cf4f$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $16791ace69c4cf4f$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $16791ace69c4cf4f$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
         // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $16791ace69c4cf4f$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        updateState($16791ace69c4cf4f$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $16791ace69c4cf4f$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $16791ace69c4cf4f$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $16791ace69c4cf4f$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $16791ace69c4cf4f$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let { path: path, submission: submission, error: error } = $16791ace69c4cf4f$var$normalizeNavigateOptions(to, opts);
        let currentLocation = state.location;
        let nextLocation = $16791ace69c4cf4f$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $16791ace69c4cf4f$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $16791ace69c4cf4f$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    }); // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $16791ace69c4cf4f$export$2708184779ceb39d(dataRoutes, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $16791ace69c4cf4f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $16791ace69c4cf4f$var$getShortCircuitMatches(dataRoutes); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change and not a mutation submission
        // For example, on /page#hash and submit a <Form method="post"> which will
        // default to a navigation to /page
        if ($16791ace69c4cf4f$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $16791ace69c4cf4f$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $16791ace69c4cf4f$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$16791ace69c4cf4f$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $16791ace69c4cf4f$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $16791ace69c4cf4f$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $16791ace69c4cf4f$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $16791ace69c4cf4f$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $16791ace69c4cf4f$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action) result = {
            type: $16791ace69c4cf4f$var$ResultType.error,
            error: $16791ace69c4cf4f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $16791ace69c4cf4f$var$callLoaderOrAction("action", request, actionMatch, matches, router.basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($16791ace69c4cf4f$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($16791ace69c4cf4f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $16791ace69c4cf4f$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $16791ace69c4cf4f$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($16791ace69c4cf4f$var$isDeferredResult(result)) throw $16791ace69c4cf4f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $16791ace69c4cf4f$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission ? submission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let [matchesToLoad, revalidatingFetchers] = $16791ace69c4cf4f$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            completeNavigation(location, $16791ace69c4cf4f$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($16791ace69c4cf4f$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>fetchControllers.set(rf.key, pendingNavigationController));
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key)); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $16791ace69c4cf4f$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $16791ace69c4cf4f$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        return $16791ace69c4cf4f$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $16791ace69c4cf4f$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($16791ace69c4cf4f$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let matches = $16791ace69c4cf4f$export$2708184779ceb39d(dataRoutes, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, $16791ace69c4cf4f$var$getInternalRouterError(404, {
                pathname: href
            }));
            return;
        }
        let { path: path, submission: submission } = $16791ace69c4cf4f$var$normalizeNavigateOptions(href, opts, true);
        let match = $16791ace69c4cf4f$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $16791ace69c4cf4f$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path,
            match: match,
            matches: matches
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action) {
            let error = $16791ace69c4cf4f$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $16791ace69c4cf4f$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $16791ace69c4cf4f$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $16791ace69c4cf4f$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, router.basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($16791ace69c4cf4f$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $16791ace69c4cf4f$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if ($16791ace69c4cf4f$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($16791ace69c4cf4f$var$isDeferredResult(actionResult)) throw $16791ace69c4cf4f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $16791ace69c4cf4f$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? $16791ace69c4cf4f$export$2708184779ceb39d(dataRoutes, state.navigation.location, init.basename) : state.matches;
        $16791ace69c4cf4f$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $16791ace69c4cf4f$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $16791ace69c4cf4f$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, {
            [match.route.id]: actionResult.data
        }, undefined, fetchLoadMatches); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            fetchControllers.set(staleKey, abortController);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $16791ace69c4cf4f$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $16791ace69c4cf4f$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $16791ace69c4cf4f$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($16791ace69c4cf4f$var$_extends({
                errors: errors,
                loaderData: $16791ace69c4cf4f$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = $16791ace69c4cf4f$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $16791ace69c4cf4f$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $16791ace69c4cf4f$var$callLoaderOrAction("loader", fetchRequest, match, matches, router.basename); // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($16791ace69c4cf4f$var$isDeferredResult(result)) result = await $16791ace69c4cf4f$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by ou our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($16791ace69c4cf4f$var$isRedirectResult(result)) {
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($16791ace69c4cf4f$var$isErrorResult(result)) {
            let boundaryMatch = $16791ace69c4cf4f$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $16791ace69c4cf4f$export$f5708dca728d7177(!$16791ace69c4cf4f$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $16791ace69c4cf4f$var$createLocation(state.location, redirect.location, $16791ace69c4cf4f$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $16791ace69c4cf4f$export$f5708dca728d7177(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an external redirect that goes to a new origin
        if ($16791ace69c4cf4f$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let newOrigin = init.history.createURL(redirect.location).origin;
            if (window.location.origin !== newOrigin) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $16791ace69c4cf4f$export$e19cd5f9376f8cee.Replace : $16791ace69c4cf4f$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($16791ace69c4cf4f$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $16791ace69c4cf4f$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $16791ace69c4cf4f$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$16791ace69c4cf4f$var$callLoaderOrAction("loader", request, match, matches, router.basename)),
            ...fetchersToLoad.map((f)=>$16791ace69c4cf4f$var$callLoaderOrAction("loader", $16791ace69c4cf4f$var$createClientSideRequest(init.history, f.path, request.signal), f.match, f.matches, router.basename))
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $16791ace69c4cf4f$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
            $16791ace69c4cf4f$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, request.signal, true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $16791ace69c4cf4f$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $16791ace69c4cf4f$export$f5708dca728d7177(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $16791ace69c4cf4f$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $16791ace69c4cf4f$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $16791ace69c4cf4f$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) {
            blockerFunctions.set(key, fn);
            if (activeBlocker == null) // This is now the active blocker
            activeBlocker = key;
            else if (key !== activeBlocker) $16791ace69c4cf4f$export$491112666e282270(false, "A router only supports one blocker at a time");
        }
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
        if (activeBlocker === key) activeBlocker = null;
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $16791ace69c4cf4f$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $16791ace69c4cf4f$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (activeBlocker == null) return;
         // We only allow a single blocker at the moment.  This will need to be
        // updated if we enhance to support multiple blockers in the future
        let blockerFunction = blockerFunctions.get(activeBlocker);
        $16791ace69c4cf4f$export$f5708dca728d7177(blockerFunction, "Could not find a function for the active blocker");
        let blocker = state.blockers.get(activeBlocker);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return activeBlocker;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $16791ace69c4cf4f$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$16791ace69c4cf4f$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$16791ace69c4cf4f$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $16791ace69c4cf4f$export$4d0306f8f6a4585b = Symbol("deferred");
function $16791ace69c4cf4f$export$3336b097a6fbc59a(routes, opts) {
    $16791ace69c4cf4f$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let dataRoutes = $16791ace69c4cf4f$export$4a6d22b32134ea5d(routes);
    let basename = (opts ? opts.basename : null) || "/";
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = $16791ace69c4cf4f$var$createLocation("", $16791ace69c4cf4f$export$fe53371bee54353d(url), null, "default");
        let matches = $16791ace69c4cf4f$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$16791ace69c4cf4f$var$isValidMethod(method) && method !== "head") {
            let error = $16791ace69c4cf4f$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $16791ace69c4cf4f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $16791ace69c4cf4f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $16791ace69c4cf4f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($16791ace69c4cf4f$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $16791ace69c4cf4f$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = $16791ace69c4cf4f$var$createLocation("", $16791ace69c4cf4f$export$fe53371bee54353d(url), null, "default");
        let matches = $16791ace69c4cf4f$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$16791ace69c4cf4f$var$isValidMethod(method) && method !== "head" && method !== "options") throw $16791ace69c4cf4f$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $16791ace69c4cf4f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $16791ace69c4cf4f$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $16791ace69c4cf4f$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $16791ace69c4cf4f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($16791ace69c4cf4f$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$16791ace69c4cf4f$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $16791ace69c4cf4f$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($16791ace69c4cf4f$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $16791ace69c4cf4f$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $16791ace69c4cf4f$var$isResponse(result) ? result : $16791ace69c4cf4f$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($16791ace69c4cf4f$var$isQueryRouteResponse(e)) {
                if (e.type === $16791ace69c4cf4f$var$ResultType.error && !$16791ace69c4cf4f$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($16791ace69c4cf4f$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action) {
            let error = $16791ace69c4cf4f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $16791ace69c4cf4f$var$ResultType.error,
                error: error
            };
        } else {
            result = await $16791ace69c4cf4f$var$callLoaderOrAction("action", request, actionMatch, matches, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($16791ace69c4cf4f$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($16791ace69c4cf4f$var$isDeferredResult(result)) {
            let error = $16791ace69c4cf4f$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $16791ace69c4cf4f$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($16791ace69c4cf4f$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($16791ace69c4cf4f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $16791ace69c4cf4f$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $16791ace69c4cf4f$var$_extends({}, context, {
                statusCode: $16791ace69c4cf4f$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $16791ace69c4cf4f$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $16791ace69c4cf4f$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $16791ace69c4cf4f$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader)) throw $16791ace69c4cf4f$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $16791ace69c4cf4f$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$16791ace69c4cf4f$var$callLoaderOrAction("loader", request, match, matches, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $16791ace69c4cf4f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $16791ace69c4cf4f$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $16791ace69c4cf4f$export$fec11da027c70692(routes, context, error) {
    let newContext = $16791ace69c4cf4f$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $16791ace69c4cf4f$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $16791ace69c4cf4f$var$normalizeNavigateOptions(to, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    let path = typeof to === "string" ? to : $16791ace69c4cf4f$export$fe53371bee54353d(to); // Return location verbatim on non-submission navigations
    if (!opts || !$16791ace69c4cf4f$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$16791ace69c4cf4f$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $16791ace69c4cf4f$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        submission = {
            formMethod: opts.formMethod || "get",
            formAction: $16791ace69c4cf4f$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($16791ace69c4cf4f$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $16791ace69c4cf4f$export$8ccf933b0513f8d0(path);
    let searchParams = $16791ace69c4cf4f$var$convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
    // navigation GET submissions which run all loaders), we need to preserve
    // any incoming ?index params
    if (isFetcher && parsedPath.search && $16791ace69c4cf4f$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $16791ace69c4cf4f$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $16791ace69c4cf4f$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $16791ace69c4cf4f$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let defaultShouldRevalidate = isRevalidationRequired || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search; // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $16791ace69c4cf4f$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if ($16791ace69c4cf4f$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $16791ace69c4cf4f$var$shouldRevalidateLoader(match, $16791ace69c4cf4f$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate || $16791ace69c4cf4f$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches && fetchLoadMatches.forEach((f, key)=>{
        if (!matches.some((m)=>m.route.id === f.routeId)) // This fetcher is not going to be present in the subsequent render so
        // there's no need to revalidate it
        return;
        else if (cancelledFetcherLoads.includes(key)) // This fetcher was cancelled from a prior action submission - force reload
        revalidatingFetchers.push($16791ace69c4cf4f$var$_extends({
            key: key
        }, f));
        else {
            // Revalidating fetchers are decoupled from the route matches since they
            // hit a static href, so they _always_ check shouldRevalidate and the
            // default is strictly if a revalidation is explicitly required (action
            // submissions, useRevalidator, X-Remix-Revalidate).
            let shouldRevalidate = $16791ace69c4cf4f$var$shouldRevalidateLoader(f.match, $16791ace69c4cf4f$var$_extends({
                currentUrl: currentUrl,
                currentParams: state.matches[state.matches.length - 1].params,
                nextUrl: nextUrl,
                nextParams: matches[matches.length - 1].params
            }, submission, {
                actionResult: actionResult,
                defaultShouldRevalidate: defaultShouldRevalidate
            }));
            if (shouldRevalidate) revalidatingFetchers.push($16791ace69c4cf4f$var$_extends({
                key: key
            }, f));
        }
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $16791ace69c4cf4f$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $16791ace69c4cf4f$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $16791ace69c4cf4f$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
async function $16791ace69c4cf4f$var$callLoaderOrAction(type, request, match, matches, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (basename === void 0) basename = "/";
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result; // Setup a promise we can race against so that abort signals short circuit
    let reject;
    let abortPromise = new Promise((_, r)=>reject = r);
    let onReject = ()=>reject();
    request.signal.addEventListener("abort", onReject);
    try {
        let handler = match.route[type];
        $16791ace69c4cf4f$export$f5708dca728d7177(handler, "Could not find the " + type + " to run on the \"" + match.route.id + "\" route");
        result = await Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
        $16791ace69c4cf4f$export$f5708dca728d7177(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $16791ace69c4cf4f$var$ResultType.error;
        result = e;
    } finally{
        request.signal.removeEventListener("abort", onReject);
    }
    if ($16791ace69c4cf4f$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($16791ace69c4cf4f$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $16791ace69c4cf4f$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            let isAbsolute = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(location); // Support relative routing in internal redirects
            if (!isAbsolute) {
                let activeMatches = matches.slice(0, matches.indexOf(match) + 1);
                let routePathnames = $16791ace69c4cf4f$export$90ba53ce1c7fdff2(activeMatches).map((match)=>match.pathnameBase);
                let resolvedLocation = $16791ace69c4cf4f$export$cae722b0cc860f13(location, routePathnames, new URL(request.url).pathname);
                $16791ace69c4cf4f$export$f5708dca728d7177($16791ace69c4cf4f$export$fe53371bee54353d(resolvedLocation), "Unable to resolve redirect location: " + location); // Prepend the basename to the redirect location if we have one
                if (basename) {
                    let path = resolvedLocation.pathname;
                    resolvedLocation.pathname = path === "/" ? basename : $16791ace69c4cf4f$export$86d9a7913e44197e([
                        basename,
                        path
                    ]);
                }
                location = $16791ace69c4cf4f$export$fe53371bee54353d(resolvedLocation);
            } else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin absolute redirects.
                // If this is a static reques, we can let it go back to the browser
                // as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                if (url.origin === currentUrl.origin) location = url.pathname + url.search + url.hash;
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $16791ace69c4cf4f$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $16791ace69c4cf4f$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $16791ace69c4cf4f$var$ResultType.error) return {
            type: resultType,
            error: new $16791ace69c4cf4f$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $16791ace69c4cf4f$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $16791ace69c4cf4f$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if (result instanceof $16791ace69c4cf4f$export$61d759255b4eec65) return {
        type: $16791ace69c4cf4f$var$ResultType.deferred,
        deferredData: result
    };
    return {
        type: $16791ace69c4cf4f$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $16791ace69c4cf4f$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($16791ace69c4cf4f$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $16791ace69c4cf4f$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission;
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $16791ace69c4cf4f$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $16791ace69c4cf4f$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $16791ace69c4cf4f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $16791ace69c4cf4f$export$f5708dca728d7177(!$16791ace69c4cf4f$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($16791ace69c4cf4f$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $16791ace69c4cf4f$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $16791ace69c4cf4f$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($16791ace69c4cf4f$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $16791ace69c4cf4f$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $16791ace69c4cf4f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match } = revalidatingFetchers[index];
        $16791ace69c4cf4f$export$f5708dca728d7177(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if ($16791ace69c4cf4f$var$isErrorResult(result)) {
            let boundaryMatch = $16791ace69c4cf4f$var$findNearestBoundary(state.matches, match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $16791ace69c4cf4f$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($16791ace69c4cf4f$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $16791ace69c4cf4f$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else if ($16791ace69c4cf4f$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $16791ace69c4cf4f$export$f5708dca728d7177(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $16791ace69c4cf4f$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $16791ace69c4cf4f$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $16791ace69c4cf4f$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $16791ace69c4cf4f$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $16791ace69c4cf4f$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $16791ace69c4cf4f$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $16791ace69c4cf4f$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($16791ace69c4cf4f$var$isRedirectResult(result)) return result;
    }
}
function $16791ace69c4cf4f$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $16791ace69c4cf4f$export$8ccf933b0513f8d0(path) : path;
    return $16791ace69c4cf4f$export$fe53371bee54353d($16791ace69c4cf4f$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $16791ace69c4cf4f$var$isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function $16791ace69c4cf4f$var$isDeferredResult(result) {
    return result.type === $16791ace69c4cf4f$var$ResultType.deferred;
}
function $16791ace69c4cf4f$var$isErrorResult(result) {
    return result.type === $16791ace69c4cf4f$var$ResultType.error;
}
function $16791ace69c4cf4f$var$isRedirectResult(result) {
    return (result && result.type) === $16791ace69c4cf4f$var$ResultType.redirect;
}
function $16791ace69c4cf4f$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $16791ace69c4cf4f$var$isRedirectResponse(result) {
    if (!$16791ace69c4cf4f$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $16791ace69c4cf4f$var$isQueryRouteResponse(obj) {
    return obj && $16791ace69c4cf4f$var$isResponse(obj.response) && (obj.type === $16791ace69c4cf4f$var$ResultType.data || $16791ace69c4cf4f$var$ResultType.error);
}
function $16791ace69c4cf4f$var$isValidMethod(method) {
    return $16791ace69c4cf4f$var$validRequestMethods.has(method);
}
function $16791ace69c4cf4f$var$isMutationMethod(method) {
    return $16791ace69c4cf4f$var$validMutationMethods.has(method);
}
async function $16791ace69c4cf4f$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$16791ace69c4cf4f$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($16791ace69c4cf4f$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $16791ace69c4cf4f$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
            if (result) results[index] = result || results[index];
        });
    }
}
async function $16791ace69c4cf4f$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $16791ace69c4cf4f$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $16791ace69c4cf4f$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $16791ace69c4cf4f$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $16791ace69c4cf4f$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $16791ace69c4cf4f$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $16791ace69c4cf4f$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $16791ace69c4cf4f$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $16791ace69c4cf4f$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $16791ace69c4cf4f$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

/**
 * React Router v6.8.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $ltGt3 = parcelRequire("ltGt3");
function $493cbc5b00d91baa$var$_extends() {
    $493cbc5b00d91baa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $493cbc5b00d91baa$var$_extends.apply(this, arguments);
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $493cbc5b00d91baa$var$isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
const $493cbc5b00d91baa$var$is = typeof Object.is === "function" ? Object.is : $493cbc5b00d91baa$var$isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
const { useState: $493cbc5b00d91baa$var$useState, useEffect: $493cbc5b00d91baa$var$useEffect, useLayoutEffect: $493cbc5b00d91baa$var$useLayoutEffect, useDebugValue: $493cbc5b00d91baa$var$useDebugValue } = $ltGt3;
let $493cbc5b00d91baa$var$didWarnOld18Alpha = false;
let $493cbc5b00d91baa$var$didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function $493cbc5b00d91baa$var$useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst: inst }, forceUpdate] = $493cbc5b00d91baa$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }); // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    $493cbc5b00d91baa$var$useLayoutEffect(()=>{
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($493cbc5b00d91baa$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $493cbc5b00d91baa$var$useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($493cbc5b00d91baa$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        const handleStoreChange = ()=>{
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($493cbc5b00d91baa$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    $493cbc5b00d91baa$var$useDebugValue(value);
    return value;
}
function $493cbc5b00d91baa$var$checkIfSnapshotChanged(inst) {
    const latestGetSnapshot = inst.getSnapshot;
    const prevValue = inst.value;
    try {
        const nextValue = latestGetSnapshot();
        return !$493cbc5b00d91baa$var$is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function $493cbc5b00d91baa$var$useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ const $493cbc5b00d91baa$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $493cbc5b00d91baa$var$isServerEnvironment = !$493cbc5b00d91baa$var$canUseDOM;
const $493cbc5b00d91baa$var$shim = $493cbc5b00d91baa$var$isServerEnvironment ? $493cbc5b00d91baa$var$useSyncExternalStore$1 : $493cbc5b00d91baa$var$useSyncExternalStore$2;
const $493cbc5b00d91baa$var$useSyncExternalStore = "useSyncExternalStore" in $ltGt3 ? ((module)=>module.useSyncExternalStore)($ltGt3) : $493cbc5b00d91baa$var$shim;
const $493cbc5b00d91baa$export$3add0d5dce533e2e = /*#__PURE__*/ $ltGt3.createContext(null);
const $493cbc5b00d91baa$export$145dfa71566a64dc = /*#__PURE__*/ $ltGt3.createContext(null);
const $493cbc5b00d91baa$var$AwaitContext = /*#__PURE__*/ $ltGt3.createContext(null);
const $493cbc5b00d91baa$export$26749e8557646306 = /*#__PURE__*/ $ltGt3.createContext(null);
const $493cbc5b00d91baa$export$c7914228fb69b0f5 = /*#__PURE__*/ $ltGt3.createContext(null);
const $493cbc5b00d91baa$export$9072aa6dd1f93057 = /*#__PURE__*/ $ltGt3.createContext({
    outlet: null,
    matches: []
});
const $493cbc5b00d91baa$var$RouteErrorContext = /*#__PURE__*/ $ltGt3.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $493cbc5b00d91baa$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$493cbc5b00d91baa$export$9c954a9d03d32f4a() && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    let { basename: basename, navigator: navigator } = $ltGt3.useContext($493cbc5b00d91baa$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $493cbc5b00d91baa$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $16791ace69c4cf4f$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $493cbc5b00d91baa$export$9c954a9d03d32f4a() {
    return $ltGt3.useContext($493cbc5b00d91baa$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $493cbc5b00d91baa$export$45d76561a5302f2b() {
    !$493cbc5b00d91baa$export$9c954a9d03d32f4a() && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    return $ltGt3.useContext($493cbc5b00d91baa$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $493cbc5b00d91baa$export$1b3f31771c5d07c() {
    return $ltGt3.useContext($493cbc5b00d91baa$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $493cbc5b00d91baa$export$6c330e8992e8a295(pattern) {
    !$493cbc5b00d91baa$export$9c954a9d03d32f4a() && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    let { pathname: pathname } = $493cbc5b00d91baa$export$45d76561a5302f2b();
    return $ltGt3.useMemo(()=>(0, $16791ace69c4cf4f$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $493cbc5b00d91baa$export$9770f232ac06a008() {
    !$493cbc5b00d91baa$export$9c954a9d03d32f4a() && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    let { basename: basename, navigator: navigator } = $ltGt3.useContext($493cbc5b00d91baa$export$26749e8557646306);
    let { matches: matches } = $ltGt3.useContext($493cbc5b00d91baa$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $493cbc5b00d91baa$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $16791ace69c4cf4f$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $ltGt3.useRef(false);
    $ltGt3.useEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $ltGt3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $16791ace69c4cf4f$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $16791ace69c4cf4f$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $493cbc5b00d91baa$var$OutletContext = /*#__PURE__*/ $ltGt3.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $493cbc5b00d91baa$export$4138103a3ae699cc() {
    return $ltGt3.useContext($493cbc5b00d91baa$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $493cbc5b00d91baa$export$a3be3530d8e40d0b(context) {
    let outlet = $ltGt3.useContext($493cbc5b00d91baa$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $493cbc5b00d91baa$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $ltGt3.useContext($493cbc5b00d91baa$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $493cbc5b00d91baa$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $ltGt3.useContext($493cbc5b00d91baa$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $493cbc5b00d91baa$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $16791ace69c4cf4f$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $ltGt3.useMemo(()=>(0, $16791ace69c4cf4f$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $493cbc5b00d91baa$export$5d3fca4a98652595(routes, locationArg) {
    !$493cbc5b00d91baa$export$9c954a9d03d32f4a() && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    let { navigator: navigator } = $ltGt3.useContext($493cbc5b00d91baa$export$26749e8557646306);
    let dataRouterStateContext = $ltGt3.useContext($493cbc5b00d91baa$export$145dfa71566a64dc);
    let { matches: parentMatches } = $ltGt3.useContext($493cbc5b00d91baa$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $493cbc5b00d91baa$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $16791ace69c4cf4f$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $16791ace69c4cf4f$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $493cbc5b00d91baa$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $16791ace69c4cf4f$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $16791ace69c4cf4f$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $493cbc5b00d91baa$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $16791ace69c4cf4f$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $493cbc5b00d91baa$var$DefaultErrorElement() {
    let error = $493cbc5b00d91baa$export$ed527bf60f6e05f2();
    let message = (0, $16791ace69c4cf4f$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $ltGt3.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $ltGt3.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
class $493cbc5b00d91baa$var$RenderErrorBoundary extends $ltGt3.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location) return {
            error: props.error,
            location: props.location
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $493cbc5b00d91baa$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $ltGt3.useContext($493cbc5b00d91baa$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && match.route.errorElement) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $493cbc5b00d91baa$var$_renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = dataRouterState ? match.route.errorElement || /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$var$DefaultErrorElement, null) : null;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>/*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches
                }
            }, error ? errorElement : match.route.element !== undefined ? match.route.element : outlet); // Only wrap in an error boundary within data router usages when we have an
        // errorElement on this route.  Otherwise let it bubble up to an ancestor
        // errorElement
        return dataRouterState && (match.route.errorElement || index === 0) ? /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches
            }
        }) : getChildren();
    }, null);
}
var $493cbc5b00d91baa$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})($493cbc5b00d91baa$var$DataRouterHook || ($493cbc5b00d91baa$var$DataRouterHook = {}));
var $493cbc5b00d91baa$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
})($493cbc5b00d91baa$var$DataRouterStateHook || ($493cbc5b00d91baa$var$DataRouterStateHook = {}));
function $493cbc5b00d91baa$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $493cbc5b00d91baa$var$useDataRouterContext(hookName) {
    let ctx = $ltGt3.useContext($493cbc5b00d91baa$export$3add0d5dce533e2e);
    !ctx && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    return ctx;
}
function $493cbc5b00d91baa$var$useDataRouterState(hookName) {
    let state = $ltGt3.useContext($493cbc5b00d91baa$export$145dfa71566a64dc);
    !state && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    return state;
}
function $493cbc5b00d91baa$var$useRouteContext(hookName) {
    let route = $ltGt3.useContext($493cbc5b00d91baa$export$9072aa6dd1f93057);
    !route && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    return route;
}
function $493cbc5b00d91baa$var$useCurrentRouteId(hookName) {
    let route = $493cbc5b00d91baa$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    return thisRoute.route.id;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $493cbc5b00d91baa$export$d0fd4b7106de2769() {
    let state = $493cbc5b00d91baa$var$useDataRouterState($493cbc5b00d91baa$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $493cbc5b00d91baa$export$600dc272ed516c15() {
    let dataRouterContext = $493cbc5b00d91baa$var$useDataRouterContext($493cbc5b00d91baa$var$DataRouterHook.UseRevalidator);
    let state = $493cbc5b00d91baa$var$useDataRouterState($493cbc5b00d91baa$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $493cbc5b00d91baa$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $493cbc5b00d91baa$var$useDataRouterState($493cbc5b00d91baa$var$DataRouterStateHook.UseMatches);
    return $ltGt3.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $493cbc5b00d91baa$export$1448a5050d252c4d() {
    let state = $493cbc5b00d91baa$var$useDataRouterState($493cbc5b00d91baa$var$DataRouterStateHook.UseLoaderData);
    let routeId = $493cbc5b00d91baa$var$useCurrentRouteId($493cbc5b00d91baa$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $493cbc5b00d91baa$export$fd5d37484eab868d(routeId) {
    let state = $493cbc5b00d91baa$var$useDataRouterState($493cbc5b00d91baa$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $493cbc5b00d91baa$export$fdc00f3f26066d5e() {
    let state = $493cbc5b00d91baa$var$useDataRouterState($493cbc5b00d91baa$var$DataRouterStateHook.UseActionData);
    let route = $ltGt3.useContext($493cbc5b00d91baa$export$9072aa6dd1f93057);
    !route && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * errorElement to display a proper error message.
 */ function $493cbc5b00d91baa$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $ltGt3.useContext($493cbc5b00d91baa$var$RouteErrorContext);
    let state = $493cbc5b00d91baa$var$useDataRouterState($493cbc5b00d91baa$var$DataRouterStateHook.UseRouteError);
    let routeId = $493cbc5b00d91baa$var$useCurrentRouteId($493cbc5b00d91baa$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $493cbc5b00d91baa$export$78a72ddb39bdd145() {
    let value = $ltGt3.useContext($493cbc5b00d91baa$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $493cbc5b00d91baa$export$17f53340677d5831() {
    let value = $ltGt3.useContext($493cbc5b00d91baa$var$AwaitContext);
    return value == null ? void 0 : value._error;
} // useBlocker() is a singleton for now since we don't have any compelling use
// cases for multi-blocker yet
let $493cbc5b00d91baa$var$blockerKey = "blocker-singleton";
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $493cbc5b00d91baa$export$2af03a1de5c0910(shouldBlock) {
    let { router: router } = $493cbc5b00d91baa$var$useDataRouterContext($493cbc5b00d91baa$var$DataRouterHook.UseBlocker);
    let blockerFunction = $ltGt3.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker($493cbc5b00d91baa$var$blockerKey, blockerFunction); // Cleanup on unmount
    $ltGt3.useEffect(()=>()=>router.deleteBlocker($493cbc5b00d91baa$var$blockerKey), [
        router
    ]);
    return blocker;
}
const $493cbc5b00d91baa$var$alreadyWarned = {};
function $493cbc5b00d91baa$var$warningOnce(key, cond, message) {
    if (!cond && !$493cbc5b00d91baa$var$alreadyWarned[key]) $493cbc5b00d91baa$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $493cbc5b00d91baa$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    // Sync router state to our component state to force re-renders
    let state = $493cbc5b00d91baa$var$useSyncExternalStore(router.subscribe, ()=>router.state, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    ()=>router.state);
    let navigator = $ltGt3.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/"; // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$export$3add0d5dce533e2e.Provider, {
        value: {
            router: router,
            navigator: navigator,
            static: false,
            basename: // Do we need this?
            basename
        }
    }, /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$export$3565eb3d00ca5a74, null) : fallbackElement))), null);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $493cbc5b00d91baa$export$ae46f04cfaffe093(_ref2) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref2;
    let historyRef = $ltGt3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $16791ace69c4cf4f$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $ltGt3.useState({
        action: history.action,
        location: history.location
    });
    $ltGt3.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $493cbc5b00d91baa$export$444b3ab0cb9aec40(_ref3) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref3;
    !$493cbc5b00d91baa$export$9c954a9d03d32f4a() && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    let dataRouterState = $ltGt3.useContext($493cbc5b00d91baa$export$145dfa71566a64dc);
    let navigate = $493cbc5b00d91baa$export$9770f232ac06a008();
    $ltGt3.useEffect(()=>{
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace: replace,
            state: state,
            relative: relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $493cbc5b00d91baa$export$910ae8079b2c2852(props) {
    return $493cbc5b00d91baa$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $493cbc5b00d91baa$export$e7b0ac011bb776c6(_props) {
    (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $493cbc5b00d91baa$export$55185c17a0fcbe46(_ref4) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $16791ace69c4cf4f$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref4;
    !!$493cbc5b00d91baa$export$9c954a9d03d32f4a() && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $ltGt3.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $16791ace69c4cf4f$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = $ltGt3.useMemo(()=>{
        let trailingPathname = (0, $16791ace69c4cf4f$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $493cbc5b00d91baa$export$3565eb3d00ca5a74(_ref5) {
    let { children: children, location: location } = _ref5;
    let dataRouterContext = $ltGt3.useContext($493cbc5b00d91baa$export$3add0d5dce533e2e); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    let routes = dataRouterContext && !children ? dataRouterContext.router.routes : $493cbc5b00d91baa$export$16da398f5434bdec(children);
    return $493cbc5b00d91baa$export$5d3fca4a98652595(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $493cbc5b00d91baa$export$6ddabde395c8c576(_ref6) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref6;
    return /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$var$ResolveAwait, null, children));
}
var $493cbc5b00d91baa$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($493cbc5b00d91baa$var$AwaitRenderStatus || ($493cbc5b00d91baa$var$AwaitRenderStatus = {}));
const $493cbc5b00d91baa$var$neverSettledPromise = new Promise(()=>{});
class $493cbc5b00d91baa$var$AwaitErrorBoundary extends $ltGt3.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $493cbc5b00d91baa$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $493cbc5b00d91baa$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $493cbc5b00d91baa$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $493cbc5b00d91baa$var$AwaitRenderStatus.error : promise._data !== undefined ? $493cbc5b00d91baa$var$AwaitRenderStatus.success : $493cbc5b00d91baa$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $493cbc5b00d91baa$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $493cbc5b00d91baa$var$AwaitRenderStatus.error && promise._error instanceof (0, $16791ace69c4cf4f$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $493cbc5b00d91baa$var$neverSettledPromise;
        if (status === $493cbc5b00d91baa$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $493cbc5b00d91baa$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $493cbc5b00d91baa$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $ltGt3.createElement($493cbc5b00d91baa$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $493cbc5b00d91baa$var$ResolveAwait(_ref7) {
    let { children: children } = _ref7;
    let data = $493cbc5b00d91baa$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $493cbc5b00d91baa$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $ltGt3.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $ltGt3.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === $ltGt3.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $493cbc5b00d91baa$export$16da398f5434bdec(element.props.children, parentPath));
            return;
        }
        !(element.type === $493cbc5b00d91baa$export$e7b0ac011bb776c6) && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
        !(!element.props.index || !element.props.children) && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
        let treePath = [
            ...parentPath,
            index
        ];
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            hasErrorBoundary: element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle
        };
        if (element.props.children) route.children = $493cbc5b00d91baa$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $493cbc5b00d91baa$export$daf73786167a7f72(matches) {
    return $493cbc5b00d91baa$var$_renderMatches(matches);
}
/**
 * @private
 * Walk the route tree and add hasErrorBoundary if it's not provided, so that
 * users providing manual route arrays can just specify errorElement
 */ function $493cbc5b00d91baa$export$c7b301c52f838c5f(routes) {
    return routes.map((route)=>{
        let routeClone = $493cbc5b00d91baa$var$_extends({}, route);
        if (routeClone.hasErrorBoundary == null) routeClone.hasErrorBoundary = routeClone.errorElement != null;
        if (routeClone.children) routeClone.children = $493cbc5b00d91baa$export$c7b301c52f838c5f(routeClone.children);
        return routeClone;
    });
}
function $493cbc5b00d91baa$export$f30f7e456d254e83(routes, opts) {
    return (0, $16791ace69c4cf4f$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $16791ace69c4cf4f$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: $493cbc5b00d91baa$export$c7b301c52f838c5f(routes)
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////



function $6816d30a3e97278a$var$_extends() {
    $6816d30a3e97278a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6816d30a3e97278a$var$_extends.apply(this, arguments);
}
function $6816d30a3e97278a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $6816d30a3e97278a$var$defaultMethod = "get";
const $6816d30a3e97278a$var$defaultEncType = "application/x-www-form-urlencoded";
function $6816d30a3e97278a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $6816d30a3e97278a$var$isButtonElement(object) {
    return $6816d30a3e97278a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $6816d30a3e97278a$var$isFormElement(object) {
    return $6816d30a3e97278a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $6816d30a3e97278a$var$isInputElement(object) {
    return $6816d30a3e97278a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $6816d30a3e97278a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $6816d30a3e97278a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$6816d30a3e97278a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $6816d30a3e97278a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $6816d30a3e97278a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $6816d30a3e97278a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $6816d30a3e97278a$var$getFormSubmissionInfo(target, defaultAction, options) {
    let method;
    let action;
    let encType;
    let formData;
    if ($6816d30a3e97278a$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || $6816d30a3e97278a$var$defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || $6816d30a3e97278a$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($6816d30a3e97278a$var$isButtonElement(target) || $6816d30a3e97278a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $6816d30a3e97278a$var$defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $6816d30a3e97278a$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($6816d30a3e97278a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $6816d30a3e97278a$var$defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || $6816d30a3e97278a$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    let { protocol: protocol, host: host } = window.location;
    let url = new URL(action, protocol + "//" + host);
    return {
        url: url,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $6816d30a3e97278a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $6816d30a3e97278a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $6816d30a3e97278a$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
//#region Routers
////////////////////////////////////////////////////////////////////////////////
function $6816d30a3e97278a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $16791ace69c4cf4f$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $16791ace69c4cf4f$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $6816d30a3e97278a$var$parseHydrationData(),
        routes: (0, $493cbc5b00d91baa$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $6816d30a3e97278a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $16791ace69c4cf4f$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $16791ace69c4cf4f$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $6816d30a3e97278a$var$parseHydrationData(),
        routes: (0, $493cbc5b00d91baa$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $6816d30a3e97278a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $6816d30a3e97278a$var$_extends({}, state, {
        errors: $6816d30a3e97278a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $6816d30a3e97278a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $16791ace69c4cf4f$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $6816d30a3e97278a$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $ltGt3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $16791ace69c4cf4f$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $ltGt3.useState({
        action: history.action,
        location: history.location
    });
    $ltGt3.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $493cbc5b00d91baa$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $6816d30a3e97278a$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $ltGt3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $16791ace69c4cf4f$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $ltGt3.useState({
        action: history.action,
        location: history.location
    });
    $ltGt3.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $493cbc5b00d91baa$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $6816d30a3e97278a$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $ltGt3.useState({
        action: history.action,
        location: history.location
    });
    $ltGt3.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $493cbc5b00d91baa$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $6816d30a3e97278a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
/**
 * The public API for rendering a history-aware <a>.
 */ const $6816d30a3e97278a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $ltGt3.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $6816d30a3e97278a$var$_objectWithoutPropertiesLoose(_ref4, $6816d30a3e97278a$var$_excluded);
    // `location` is the unaltered href we will render in the <a> tag for absolute URLs
    let location = typeof to === "string" ? to : (0, $16791ace69c4cf4f$export$fe53371bee54353d)(to);
    let isAbsolute = /^[a-z+]+:\/\//i.test(location) || location.startsWith("//"); // Location to use in the click handler
    let navigationLocation = location;
    let isExternal = false;
    if ($6816d30a3e97278a$var$isBrowser && isAbsolute) {
        let currentUrl = new URL(window.location.href);
        let targetUrl = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
        if (targetUrl.origin === currentUrl.origin) // Strip the protocol/origin for same-origin absolute URLs
        navigationLocation = targetUrl.pathname + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } // `href` is what we render in the <a> tag for relative URLs
    let href = (0, $493cbc5b00d91baa$export$b66bb29c5006f12f)(navigationLocation, {
        relative: relative
    });
    let internalOnClick = $6816d30a3e97278a$export$67621102c14d847(navigationLocation, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $ltGt3.createElement("a", $6816d30a3e97278a$var$_extends({}, rest, {
        href: isAbsolute ? location : href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $6816d30a3e97278a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $ltGt3.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $6816d30a3e97278a$var$_objectWithoutPropertiesLoose(_ref5, $6816d30a3e97278a$var$_excluded2);
    let path = (0, $493cbc5b00d91baa$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $493cbc5b00d91baa$export$45d76561a5302f2b)();
    let routerState = $ltGt3.useContext((0, $493cbc5b00d91baa$export$145dfa71566a64dc));
    let { navigator: navigator } = $ltGt3.useContext((0, $493cbc5b00d91baa$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $ltGt3.createElement($6816d30a3e97278a$export$a6c7ac8248d6e38a, $6816d30a3e97278a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $6816d30a3e97278a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $ltGt3.createElement($6816d30a3e97278a$var$FormImpl, $6816d30a3e97278a$var$_extends({}, props, {
        ref: ref
    }));
});
const $6816d30a3e97278a$var$FormImpl = /*#__PURE__*/ $ltGt3.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $6816d30a3e97278a$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $6816d30a3e97278a$var$_objectWithoutPropertiesLoose(_ref6, $6816d30a3e97278a$var$_excluded3);
    let submit = $6816d30a3e97278a$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $6816d30a3e97278a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $ltGt3.createElement("form", $6816d30a3e97278a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $6816d30a3e97278a$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $6816d30a3e97278a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $6816d30a3e97278a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($6816d30a3e97278a$var$DataRouterHook || ($6816d30a3e97278a$var$DataRouterHook = {}));
var $6816d30a3e97278a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($6816d30a3e97278a$var$DataRouterStateHook || ($6816d30a3e97278a$var$DataRouterStateHook = {}));
function $6816d30a3e97278a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $6816d30a3e97278a$var$useDataRouterContext(hookName) {
    let ctx = $ltGt3.useContext((0, $493cbc5b00d91baa$export$3add0d5dce533e2e));
    !ctx && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    return ctx;
}
function $6816d30a3e97278a$var$useDataRouterState(hookName) {
    let state = $ltGt3.useContext((0, $493cbc5b00d91baa$export$145dfa71566a64dc));
    !state && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $6816d30a3e97278a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    let location = (0, $493cbc5b00d91baa$export$45d76561a5302f2b)();
    let path = (0, $493cbc5b00d91baa$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $ltGt3.useCallback((event)=>{
        if ($6816d30a3e97278a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $16791ace69c4cf4f$export$fe53371bee54353d)(location) === (0, $16791ace69c4cf4f$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $6816d30a3e97278a$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $ltGt3.useRef($6816d30a3e97278a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $ltGt3.useRef(false);
    let location = (0, $493cbc5b00d91baa$export$45d76561a5302f2b)();
    let searchParams = $ltGt3.useMemo(()=>// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $6816d30a3e97278a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    let setSearchParams = $ltGt3.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $6816d30a3e97278a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $6816d30a3e97278a$export$47c85c6e3a081d3() {
    return $6816d30a3e97278a$var$useSubmitImpl();
}
function $6816d30a3e97278a$var$useSubmitImpl(fetcherKey, routeId) {
    let { router: router } = $6816d30a3e97278a$var$useDataRouterContext($6816d30a3e97278a$var$DataRouterHook.UseSubmitImpl);
    let defaultAction = $6816d30a3e97278a$export$89a6bd6db0d97c56();
    return $ltGt3.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { method: method, encType: encType, formData: formData, url: url } = $6816d30a3e97278a$var$getFormSubmissionInfo(target, defaultAction, options);
        let href = url.pathname + url.search;
        let opts = {
            replace: options.replace,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function $6816d30a3e97278a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $ltGt3.useContext((0, $493cbc5b00d91baa$export$26749e8557646306));
    let routeContext = $ltGt3.useContext((0, $493cbc5b00d91baa$export$9072aa6dd1f93057));
    !routeContext && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $6816d30a3e97278a$var$_extends({}, (0, $493cbc5b00d91baa$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $493cbc5b00d91baa$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $16791ace69c4cf4f$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $16791ace69c4cf4f$export$fe53371bee54353d)(path);
}
function $6816d30a3e97278a$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $ltGt3.createElement($6816d30a3e97278a$var$FormImpl, $6816d30a3e97278a$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $6816d30a3e97278a$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $6816d30a3e97278a$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $6816d30a3e97278a$var$useDataRouterContext($6816d30a3e97278a$var$DataRouterHook.UseFetcher);
    let route = $ltGt3.useContext((0, $493cbc5b00d91baa$export$9072aa6dd1f93057));
    !route && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
    let [fetcherKey] = $ltGt3.useState(()=>String(++$6816d30a3e97278a$var$fetcherId));
    let [Form] = $ltGt3.useState(()=>{
        !routeId && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
        return $6816d30a3e97278a$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $ltGt3.useState(()=>(href)=>{
            !router && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
            !routeId && (0, $16791ace69c4cf4f$export$f5708dca728d7177)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $6816d30a3e97278a$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $ltGt3.useMemo(()=>$6816d30a3e97278a$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $ltGt3.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $6816d30a3e97278a$export$fa996778a3a31087() {
    let state = $6816d30a3e97278a$var$useDataRouterState($6816d30a3e97278a$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $6816d30a3e97278a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $6816d30a3e97278a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $6816d30a3e97278a$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $6816d30a3e97278a$var$useDataRouterContext($6816d30a3e97278a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $6816d30a3e97278a$var$useDataRouterState($6816d30a3e97278a$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $493cbc5b00d91baa$export$45d76561a5302f2b)();
    let matches = (0, $493cbc5b00d91baa$export$2378eb7f5ff86053)();
    let navigation = (0, $493cbc5b00d91baa$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $ltGt3.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    $6816d30a3e97278a$var$usePageHide($ltGt3.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $6816d30a3e97278a$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $6816d30a3e97278a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($6816d30a3e97278a$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $ltGt3.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $6816d30a3e97278a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $6816d30a3e97278a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $ltGt3.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($6816d30a3e97278a$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $ltGt3.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $6816d30a3e97278a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $ltGt3.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $6816d30a3e97278a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $ltGt3.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $6816d30a3e97278a$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $493cbc5b00d91baa$export$2af03a1de5c0910)(when);
    $ltGt3.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $ltGt3.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}
////////////////////////////////////////////////////////////////////////////////
//#region Utils
////////////////////////////////////////////////////////////////////////////////
function $6816d30a3e97278a$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} //#endregion


function $d433dc3c3e640619$export$3901076af3749fa9() {
    const { user: user } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('root') || {};
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    (0, $ltGt3.useEffect)(()=>{
        if (!user) navigate('/');
    }, [
        user
    ]);
    return user;
}





var $ltGt3 = parcelRequire("ltGt3");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $d92d5619ced5d58e$var$extendStatics = function(d, b) {
    $d92d5619ced5d58e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $d92d5619ced5d58e$var$extendStatics(d, b);
};
function $d92d5619ced5d58e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $d92d5619ced5d58e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d92d5619ced5d58e$export$18ce0697a983be9b = function() {
    $d92d5619ced5d58e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d92d5619ced5d58e$export$18ce0697a983be9b.apply(this, arguments);
};
function $d92d5619ced5d58e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d92d5619ced5d58e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d92d5619ced5d58e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d92d5619ced5d58e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $d92d5619ced5d58e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $d92d5619ced5d58e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $d92d5619ced5d58e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $d92d5619ced5d58e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d92d5619ced5d58e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d92d5619ced5d58e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $d92d5619ced5d58e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $d92d5619ced5d58e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $d92d5619ced5d58e$export$45d3717a4c69092e(o, m, p);
}
function $d92d5619ced5d58e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d92d5619ced5d58e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d92d5619ced5d58e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d92d5619ced5d58e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d92d5619ced5d58e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d92d5619ced5d58e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $d92d5619ced5d58e$export$10c90e4f7922046c(v) {
    return this instanceof $d92d5619ced5d58e$export$10c90e4f7922046c ? (this.v = v, this) : new $d92d5619ced5d58e$export$10c90e4f7922046c(v);
}
function $d92d5619ced5d58e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d92d5619ced5d58e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d92d5619ced5d58e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d92d5619ced5d58e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $d92d5619ced5d58e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d92d5619ced5d58e$export$19a8beecd37a4c45 === "function" ? $d92d5619ced5d58e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d92d5619ced5d58e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $d92d5619ced5d58e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $d92d5619ced5d58e$var$ownKeys = function(o) {
    $d92d5619ced5d58e$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $d92d5619ced5d58e$var$ownKeys(o);
};
function $d92d5619ced5d58e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $d92d5619ced5d58e$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $d92d5619ced5d58e$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $d92d5619ced5d58e$var$__setModuleDefault(result, mod);
    return result;
}
function $d92d5619ced5d58e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d92d5619ced5d58e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $d92d5619ced5d58e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $d92d5619ced5d58e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $d92d5619ced5d58e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $d92d5619ced5d58e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $d92d5619ced5d58e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $d92d5619ced5d58e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $d92d5619ced5d58e$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $d92d5619ced5d58e$export$2e2bcd8739ae039 = {
    __extends: $d92d5619ced5d58e$export$a8ba968b8961cb8a,
    __assign: $d92d5619ced5d58e$export$18ce0697a983be9b,
    __rest: $d92d5619ced5d58e$export$3c9a16f847548506,
    __decorate: $d92d5619ced5d58e$export$29e00dfd3077644b,
    __param: $d92d5619ced5d58e$export$d5ad3fd78186038f,
    __esDecorate: $d92d5619ced5d58e$export$3a84e1ae4e97e9b0,
    __runInitializers: $d92d5619ced5d58e$export$d831c04e792af3d,
    __propKey: $d92d5619ced5d58e$export$6a2a36740a146cb8,
    __setFunctionName: $d92d5619ced5d58e$export$d1a06452d3489bc7,
    __metadata: $d92d5619ced5d58e$export$f1db080c865becb9,
    __awaiter: $d92d5619ced5d58e$export$1050f835b63b671e,
    __generator: $d92d5619ced5d58e$export$67ebef60e6f28a6,
    __createBinding: $d92d5619ced5d58e$export$45d3717a4c69092e,
    __exportStar: $d92d5619ced5d58e$export$f33643c0debef087,
    __values: $d92d5619ced5d58e$export$19a8beecd37a4c45,
    __read: $d92d5619ced5d58e$export$8d051b38c9118094,
    __spread: $d92d5619ced5d58e$export$afc72e2116322959,
    __spreadArrays: $d92d5619ced5d58e$export$6388937ca91ccae8,
    __spreadArray: $d92d5619ced5d58e$export$1216008129fb82ed,
    __await: $d92d5619ced5d58e$export$10c90e4f7922046c,
    __asyncGenerator: $d92d5619ced5d58e$export$e427f37a30a4de9b,
    __asyncDelegator: $d92d5619ced5d58e$export$bbd80228419bb833,
    __asyncValues: $d92d5619ced5d58e$export$e3b29a3d6162315f,
    __makeTemplateObject: $d92d5619ced5d58e$export$4fb47efe1390b86f,
    __importStar: $d92d5619ced5d58e$export$c21735bcef00d192,
    __importDefault: $d92d5619ced5d58e$export$da59b14a69baef04,
    __classPrivateFieldGet: $d92d5619ced5d58e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $d92d5619ced5d58e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $d92d5619ced5d58e$export$81fdc39f203e4e04,
    __addDisposableResource: $d92d5619ced5d58e$export$88ac25d8e944e405,
    __disposeResources: $d92d5619ced5d58e$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $d92d5619ced5d58e$export$889dfb5d17574b0b
};



var $ltGt3 = parcelRequire("ltGt3");
var $5d5544ef3ac155d4$exports = {};
'use strict';
var $1a234edde98fef1a$exports = {};
'use strict';

$1a234edde98fef1a$exports = (parcelRequire("3cXNn"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $5d5544ef3ac155d4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $5d5544ef3ac155d4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $5d5544ef3ac155d4$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $5d5544ef3ac155d4$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $5d5544ef3ac155d4$var$TYPE_STATICS = {};
$5d5544ef3ac155d4$var$TYPE_STATICS[$1a234edde98fef1a$exports.ForwardRef] = $5d5544ef3ac155d4$var$FORWARD_REF_STATICS;
$5d5544ef3ac155d4$var$TYPE_STATICS[$1a234edde98fef1a$exports.Memo] = $5d5544ef3ac155d4$var$MEMO_STATICS;
function $5d5544ef3ac155d4$var$getStatics(component) {
    // React v16.11 and below
    if ($1a234edde98fef1a$exports.isMemo(component)) return $5d5544ef3ac155d4$var$MEMO_STATICS;
     // React v16.12 and above
    return $5d5544ef3ac155d4$var$TYPE_STATICS[component['$$typeof']] || $5d5544ef3ac155d4$var$REACT_STATICS;
}
var $5d5544ef3ac155d4$var$defineProperty = Object.defineProperty;
var $5d5544ef3ac155d4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $5d5544ef3ac155d4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5d5544ef3ac155d4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $5d5544ef3ac155d4$var$getPrototypeOf = Object.getPrototypeOf;
var $5d5544ef3ac155d4$var$objectPrototype = Object.prototype;
function $5d5544ef3ac155d4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($5d5544ef3ac155d4$var$objectPrototype) {
            var inheritedComponent = $5d5544ef3ac155d4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $5d5544ef3ac155d4$var$objectPrototype) $5d5544ef3ac155d4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $5d5544ef3ac155d4$var$getOwnPropertyNames(sourceComponent);
        if ($5d5544ef3ac155d4$var$getOwnPropertySymbols) keys = keys.concat($5d5544ef3ac155d4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $5d5544ef3ac155d4$var$getStatics(targetComponent);
        var sourceStatics = $5d5544ef3ac155d4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$5d5544ef3ac155d4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $5d5544ef3ac155d4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $5d5544ef3ac155d4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$5d5544ef3ac155d4$exports = $5d5544ef3ac155d4$var$hoistNonReactStatics;




var $ltGt3 = parcelRequire("ltGt3");
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $5ce90fd99210cb3b$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $5ce90fd99210cb3b$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $5ce90fd99210cb3b$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $5ce90fd99210cb3b$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $5ce90fd99210cb3b$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $5ce90fd99210cb3b$export$3fae2929ed23c202(map, pl, field) {
    return $5ce90fd99210cb3b$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $5ce90fd99210cb3b$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $5ce90fd99210cb3b$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $5ce90fd99210cb3b$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $5ce90fd99210cb3b$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $5ce90fd99210cb3b$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}



/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 

var $a72c7f112375066b$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($a72c7f112375066b$export$896afd8541959ee5 || ($a72c7f112375066b$export$896afd8541959ee5 = {}));




var $7586ed0c7ce7f1de$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($7586ed0c7ce7f1de$export$b87f371cbc396fcf || ($7586ed0c7ce7f1de$export$b87f371cbc396fcf = {}));
var $7586ed0c7ce7f1de$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($7586ed0c7ce7f1de$export$906452485466fa53 || ($7586ed0c7ce7f1de$export$906452485466fa53 = {}));
function $7586ed0c7ce7f1de$export$cfa10c5697238752(el) {
    return el.type === $7586ed0c7ce7f1de$export$b87f371cbc396fcf.literal;
}
function $7586ed0c7ce7f1de$export$4f55724281bdfaf9(el) {
    return el.type === $7586ed0c7ce7f1de$export$b87f371cbc396fcf.argument;
}
function $7586ed0c7ce7f1de$export$e11187b219e191e1(el) {
    return el.type === $7586ed0c7ce7f1de$export$b87f371cbc396fcf.number;
}
function $7586ed0c7ce7f1de$export$32d811605da75f40(el) {
    return el.type === $7586ed0c7ce7f1de$export$b87f371cbc396fcf.date;
}
function $7586ed0c7ce7f1de$export$34ec46f596b1702f(el) {
    return el.type === $7586ed0c7ce7f1de$export$b87f371cbc396fcf.time;
}
function $7586ed0c7ce7f1de$export$dcfe1c11d168b5a1(el) {
    return el.type === $7586ed0c7ce7f1de$export$b87f371cbc396fcf.select;
}
function $7586ed0c7ce7f1de$export$6c796d116f0a4fbc(el) {
    return el.type === $7586ed0c7ce7f1de$export$b87f371cbc396fcf.plural;
}
function $7586ed0c7ce7f1de$export$c0ece297bdd0c082(el) {
    return el.type === $7586ed0c7ce7f1de$export$b87f371cbc396fcf.pound;
}
function $7586ed0c7ce7f1de$export$5c83de34745812b(el) {
    return el.type === $7586ed0c7ce7f1de$export$b87f371cbc396fcf.tag;
}
function $7586ed0c7ce7f1de$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $7586ed0c7ce7f1de$export$906452485466fa53.number);
}
function $7586ed0c7ce7f1de$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $7586ed0c7ce7f1de$export$906452485466fa53.dateTime);
}
function $7586ed0c7ce7f1de$export$f0ac572c1121c662(value) {
    return {
        type: $7586ed0c7ce7f1de$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $7586ed0c7ce7f1de$export$425e864b0ba114f1(value, style) {
    return {
        type: $7586ed0c7ce7f1de$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $79e38e7b0cdf22c5$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $79e38e7b0cdf22c5$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $1766c5c136936172$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $1766c5c136936172$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($1766c5c136936172$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}



// @generated from regex-gen.ts
var $1c84c35f9e80f32c$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $77248f5ae5c2c59d$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $1c84c35f9e80f32c$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $77248f5ae5c2c59d$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $77248f5ae5c2c59d$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $77248f5ae5c2c59d$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $77248f5ae5c2c59d$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $77248f5ae5c2c59d$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $77248f5ae5c2c59d$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($77248f5ae5c2c59d$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $77248f5ae5c2c59d$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $77248f5ae5c2c59d$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$77248f5ae5c2c59d$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $77248f5ae5c2c59d$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $77248f5ae5c2c59d$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $77248f5ae5c2c59d$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $77248f5ae5c2c59d$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, all), $77248f5ae5c2c59d$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, all), $77248f5ae5c2c59d$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($77248f5ae5c2c59d$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($77248f5ae5c2c59d$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($77248f5ae5c2c59d$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($77248f5ae5c2c59d$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, result), $77248f5ae5c2c59d$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($77248f5ae5c2c59d$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, result), $77248f5ae5c2c59d$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $77248f5ae5c2c59d$var$parseSign(token.stem);
        if (signOpts) result = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $77248f5ae5c2c59d$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $1a5c19292770541a$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};


function $42c88fab34876591$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $42c88fab34876591$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $42c88fab34876591$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $1a5c19292770541a$export$a8c9209db4084317)[regionTag || ''] || (0, $1a5c19292770541a$export$a8c9209db4084317)[languageTag || ''] || (0, $1a5c19292770541a$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $1a5c19292770541a$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $3dcfcaf65896d801$var$_a;
var $3dcfcaf65896d801$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $79e38e7b0cdf22c5$export$523451f94304dd6c).source, "*"));
var $3dcfcaf65896d801$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $79e38e7b0cdf22c5$export$523451f94304dd6c).source, "*$"));
function $3dcfcaf65896d801$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $3dcfcaf65896d801$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $3dcfcaf65896d801$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $3dcfcaf65896d801$var$hasNativeFromEntries = !!Object.fromEntries;
var $3dcfcaf65896d801$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $3dcfcaf65896d801$var$hasTrimStart = !!String.prototype.trimStart;
var $3dcfcaf65896d801$var$hasTrimEnd = !!String.prototype.trimEnd;
var $3dcfcaf65896d801$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $3dcfcaf65896d801$var$isSafeInteger = $3dcfcaf65896d801$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $3dcfcaf65896d801$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $3dcfcaf65896d801$var$re = $3dcfcaf65896d801$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $3dcfcaf65896d801$var$REGEX_SUPPORTS_U_AND_Y = (($3dcfcaf65896d801$var$_a = $3dcfcaf65896d801$var$re.exec('a')) === null || $3dcfcaf65896d801$var$_a === void 0 ? void 0 : $3dcfcaf65896d801$var$_a[0]) === 'a';
} catch (_) {
    $3dcfcaf65896d801$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $3dcfcaf65896d801$var$startsWith = $3dcfcaf65896d801$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $3dcfcaf65896d801$var$fromCodePoint = $3dcfcaf65896d801$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $3dcfcaf65896d801$var$fromEntries = // native
$3dcfcaf65896d801$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $3dcfcaf65896d801$var$codePointAt = $3dcfcaf65896d801$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $3dcfcaf65896d801$var$trimStart = $3dcfcaf65896d801$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($3dcfcaf65896d801$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $3dcfcaf65896d801$var$trimEnd = $3dcfcaf65896d801$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($3dcfcaf65896d801$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $3dcfcaf65896d801$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $3dcfcaf65896d801$var$matchIdentifierAtIndex;
if ($3dcfcaf65896d801$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $3dcfcaf65896d801$var$IDENTIFIER_PREFIX_RE_1 = $3dcfcaf65896d801$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $3dcfcaf65896d801$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $3dcfcaf65896d801$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $3dcfcaf65896d801$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$3dcfcaf65896d801$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $3dcfcaf65896d801$var$codePointAt(s, index);
        if (c === undefined || $3dcfcaf65896d801$var$_isWhiteSpace(c) || $3dcfcaf65896d801$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $3dcfcaf65896d801$var$fromCodePoint.apply(void 0, match);
};
var $3dcfcaf65896d801$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).pound,
                    location: $3dcfcaf65896d801$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $3dcfcaf65896d801$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $3dcfcaf65896d801$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $3dcfcaf65896d801$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$3dcfcaf65896d801$var$_isAlpha(this.char())) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).INVALID_TAG, $3dcfcaf65896d801$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $3dcfcaf65896d801$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).INVALID_TAG, $3dcfcaf65896d801$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $3dcfcaf65896d801$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).UNCLOSED_TAG, $3dcfcaf65896d801$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).INVALID_TAG, $3dcfcaf65896d801$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $3dcfcaf65896d801$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $3dcfcaf65896d801$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$3dcfcaf65896d801$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $3dcfcaf65896d801$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $3dcfcaf65896d801$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $3dcfcaf65896d801$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).EMPTY_ARGUMENT, $3dcfcaf65896d801$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).MALFORMED_ARGUMENT, $3dcfcaf65896d801$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $3dcfcaf65896d801$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $3dcfcaf65896d801$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $3dcfcaf65896d801$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).MALFORMED_ARGUMENT, $3dcfcaf65896d801$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $3dcfcaf65896d801$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $3dcfcaf65896d801$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $3dcfcaf65896d801$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $3dcfcaf65896d801$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $3dcfcaf65896d801$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $3dcfcaf65896d801$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $3dcfcaf65896d801$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $3dcfcaf65896d801$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $3dcfcaf65896d801$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $42c88fab34876591$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $7586ed0c7ce7f1de$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $1766c5c136936172$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).date : (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).date : (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $3dcfcaf65896d801$var$createLocation(typeEndPosition_1, (0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $3dcfcaf65896d801$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $a72c7f112375066b$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $3dcfcaf65896d801$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $3dcfcaf65896d801$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $3dcfcaf65896d801$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $3dcfcaf65896d801$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $3dcfcaf65896d801$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $3dcfcaf65896d801$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $77248f5ae5c2c59d$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $7586ed0c7ce7f1de$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $77248f5ae5c2c59d$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $a72c7f112375066b$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $3dcfcaf65896d801$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $a72c7f112375066b$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $a72c7f112375066b$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $3dcfcaf65896d801$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $3dcfcaf65896d801$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $a72c7f112375066b$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $3dcfcaf65896d801$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $a72c7f112375066b$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $3dcfcaf65896d801$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $3dcfcaf65896d801$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$3dcfcaf65896d801$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $3dcfcaf65896d801$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($3dcfcaf65896d801$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $3dcfcaf65896d801$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $3dcfcaf65896d801$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $3dcfcaf65896d801$var$_isAlphaOrSlash(codepoint) {
    return $3dcfcaf65896d801$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $3dcfcaf65896d801$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $3dcfcaf65896d801$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $3dcfcaf65896d801$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $f1d8f5504c202835$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $7586ed0c7ce7f1de$export$dcfe1c11d168b5a1)(el) || (0, $7586ed0c7ce7f1de$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $f1d8f5504c202835$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $7586ed0c7ce7f1de$export$e11187b219e191e1)(el) && (0, $7586ed0c7ce7f1de$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $7586ed0c7ce7f1de$export$32d811605da75f40)(el) || (0, $7586ed0c7ce7f1de$export$34ec46f596b1702f)(el)) && (0, $7586ed0c7ce7f1de$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $7586ed0c7ce7f1de$export$5c83de34745812b)(el)) $f1d8f5504c202835$var$pruneLocation(el.children);
    });
}
function $f1d8f5504c202835$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $3dcfcaf65896d801$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $a72c7f112375066b$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $f1d8f5504c202835$var$pruneLocation(result.val);
    return result.val;
}
var $f1d8f5504c202835$export$d3c1bfa0f7d806e9 = (0, $3dcfcaf65896d801$export$7acfa6ed01010e37);


//
// Main
//
function $ec1c5e6c4c0c64d4$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $ec1c5e6c4c0c64d4$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $ec1c5e6c4c0c64d4$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $ec1c5e6c4c0c64d4$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $ec1c5e6c4c0c64d4$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $ec1c5e6c4c0c64d4$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $ec1c5e6c4c0c64d4$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $ec1c5e6c4c0c64d4$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $ec1c5e6c4c0c64d4$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $ec1c5e6c4c0c64d4$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $ec1c5e6c4c0c64d4$var$monadic : $ec1c5e6c4c0c64d4$var$variadic;
    return $ec1c5e6c4c0c64d4$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $ec1c5e6c4c0c64d4$var$strategyVariadic(fn, options) {
    return $ec1c5e6c4c0c64d4$var$assemble(fn, this, $ec1c5e6c4c0c64d4$var$variadic, options.cache.create(), options.serializer);
}
function $ec1c5e6c4c0c64d4$var$strategyMonadic(fn, options) {
    return $ec1c5e6c4c0c64d4$var$assemble(fn, this, $ec1c5e6c4c0c64d4$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $ec1c5e6c4c0c64d4$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $ec1c5e6c4c0c64d4$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$ec1c5e6c4c0c64d4$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$ec1c5e6c4c0c64d4$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $ec1c5e6c4c0c64d4$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $ec1c5e6c4c0c64d4$var$ObjectWithoutPrototypeCache();
    }
};
var $ec1c5e6c4c0c64d4$export$c5491a8691a23b9e = {
    variadic: $ec1c5e6c4c0c64d4$var$strategyVariadic,
    monadic: $ec1c5e6c4c0c64d4$var$strategyMonadic
};




var $54a41c29fe456628$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($54a41c29fe456628$export$d4e71bc0b80dc0fb || ($54a41c29fe456628$export$d4e71bc0b80dc0fb = {}));
var $54a41c29fe456628$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $d92d5619ced5d58e$export$a8ba968b8961cb8a)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $54a41c29fe456628$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $d92d5619ced5d58e$export$a8ba968b8961cb8a)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $54a41c29fe456628$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($54a41c29fe456628$export$7369836851cc1329);
var $54a41c29fe456628$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $d92d5619ced5d58e$export$a8ba968b8961cb8a)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $54a41c29fe456628$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($54a41c29fe456628$export$7369836851cc1329);
var $54a41c29fe456628$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $d92d5619ced5d58e$export$a8ba968b8961cb8a)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $54a41c29fe456628$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($54a41c29fe456628$export$7369836851cc1329);


var $5704e94fd88393f9$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($5704e94fd88393f9$export$49694c2877b44c57 || ($5704e94fd88393f9$export$49694c2877b44c57 = {}));
function $5704e94fd88393f9$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $5704e94fd88393f9$export$49694c2877b44c57.literal || part.type !== $5704e94fd88393f9$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $5704e94fd88393f9$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $5704e94fd88393f9$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $7586ed0c7ce7f1de$export$cfa10c5697238752)(els[0])) return [
        {
            type: $5704e94fd88393f9$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $7586ed0c7ce7f1de$export$cfa10c5697238752)(el)) {
            result.push({
                type: $5704e94fd88393f9$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $7586ed0c7ce7f1de$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $5704e94fd88393f9$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $54a41c29fe456628$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $7586ed0c7ce7f1de$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $5704e94fd88393f9$export$49694c2877b44c57.literal : $5704e94fd88393f9$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $7586ed0c7ce7f1de$export$32d811605da75f40)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $7586ed0c7ce7f1de$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $5704e94fd88393f9$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $7586ed0c7ce7f1de$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $7586ed0c7ce7f1de$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $5704e94fd88393f9$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $7586ed0c7ce7f1de$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $7586ed0c7ce7f1de$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $5704e94fd88393f9$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $7586ed0c7ce7f1de$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$5704e94fd88393f9$export$df0c12a2d414a163(formatFn)) throw new (0, $54a41c29fe456628$export$cbc0db47c750f7c9)(value_1, 'function', originalMessage);
            var parts = $5704e94fd88393f9$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $5704e94fd88393f9$export$49694c2877b44c57.literal : $5704e94fd88393f9$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $7586ed0c7ce7f1de$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $54a41c29fe456628$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $5704e94fd88393f9$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $7586ed0c7ce7f1de$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $54a41c29fe456628$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $54a41c29fe456628$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $54a41c29fe456628$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $5704e94fd88393f9$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $5704e94fd88393f9$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $d9fb39cdb8f28949$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $d9fb39cdb8f28949$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $d9fb39cdb8f28949$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, defaultConfig));
}
function $d9fb39cdb8f28949$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $d9fb39cdb8f28949$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $ec1c5e6c4c0c64d4$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $d92d5619ced5d58e$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $d9fb39cdb8f28949$var$createFastMemoizeCache(cache.number),
            strategy: (0, $ec1c5e6c4c0c64d4$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $ec1c5e6c4c0c64d4$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $d92d5619ced5d58e$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $d9fb39cdb8f28949$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $ec1c5e6c4c0c64d4$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $ec1c5e6c4c0c64d4$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $d92d5619ced5d58e$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $d9fb39cdb8f28949$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $ec1c5e6c4c0c64d4$export$c5491a8691a23b9e).variadic
        })
    };
}
var $d9fb39cdb8f28949$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $5704e94fd88393f9$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $5704e94fd88393f9$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $d92d5619ced5d58e$export$3c9a16f847548506)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $d9fb39cdb8f28949$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $d9fb39cdb8f28949$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $f1d8f5504c202835$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();




var $6e50856a3f9e8f8c$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($6e50856a3f9e8f8c$export$557d6acb76e8a244 || ($6e50856a3f9e8f8c$export$557d6acb76e8a244 = {}));
var $6e50856a3f9e8f8c$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $d92d5619ced5d58e$export$a8ba968b8961cb8a)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $6e50856a3f9e8f8c$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $d92d5619ced5d58e$export$a8ba968b8961cb8a)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $6e50856a3f9e8f8c$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($6e50856a3f9e8f8c$export$c016d36112f6ddf8);
var $6e50856a3f9e8f8c$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $d92d5619ced5d58e$export$a8ba968b8961cb8a)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $6e50856a3f9e8f8c$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($6e50856a3f9e8f8c$export$c016d36112f6ddf8);
var $6e50856a3f9e8f8c$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $d92d5619ced5d58e$export$a8ba968b8961cb8a)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $6e50856a3f9e8f8c$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($6e50856a3f9e8f8c$export$c016d36112f6ddf8);
var $6e50856a3f9e8f8c$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $d92d5619ced5d58e$export$a8ba968b8961cb8a)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $6e50856a3f9e8f8c$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($6e50856a3f9e8f8c$export$c016d36112f6ddf8);
var $6e50856a3f9e8f8c$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $d92d5619ced5d58e$export$a8ba968b8961cb8a)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($6e50856a3f9e8f8c$export$e3b7eee1dbc44895);
var $6e50856a3f9e8f8c$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $d92d5619ced5d58e$export$a8ba968b8961cb8a)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $6e50856a3f9e8f8c$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($6e50856a3f9e8f8c$export$c016d36112f6ddf8);


function $6bfecfb8d11a0816$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $6bfecfb8d11a0816$var$defaultErrorHandler = function(error) {};
var $6bfecfb8d11a0816$var$defaultWarnHandler = function(warning) {};
var $6bfecfb8d11a0816$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $6bfecfb8d11a0816$var$defaultErrorHandler,
    onWarn: $6bfecfb8d11a0816$var$defaultWarnHandler
};
function $6bfecfb8d11a0816$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $6bfecfb8d11a0816$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $6bfecfb8d11a0816$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $6bfecfb8d11a0816$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $ec1c5e6c4c0c64d4$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $d92d5619ced5d58e$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $6bfecfb8d11a0816$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $ec1c5e6c4c0c64d4$export$c5491a8691a23b9e).variadic
    });
    var getNumberFormat = (0, $ec1c5e6c4c0c64d4$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $d92d5619ced5d58e$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $6bfecfb8d11a0816$var$createFastMemoizeCache(cache.number),
        strategy: (0, $ec1c5e6c4c0c64d4$export$c5491a8691a23b9e).variadic
    });
    var getPluralRules = (0, $ec1c5e6c4c0c64d4$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $d92d5619ced5d58e$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $6bfecfb8d11a0816$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $ec1c5e6c4c0c64d4$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $ec1c5e6c4c0c64d4$export$fc10aeed3a532e2a)(function(message, locales, overrideFormats, opts) {
            return new (0, $d9fb39cdb8f28949$export$d342343268debc40)(message, locales, overrideFormats, (0, $d92d5619ced5d58e$export$18ce0697a983be9b)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $6bfecfb8d11a0816$var$createFastMemoizeCache(cache.message),
            strategy: (0, $ec1c5e6c4c0c64d4$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $ec1c5e6c4c0c64d4$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $d92d5619ced5d58e$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $6bfecfb8d11a0816$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $ec1c5e6c4c0c64d4$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $ec1c5e6c4c0c64d4$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $d92d5619ced5d58e$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $6bfecfb8d11a0816$var$createFastMemoizeCache(cache.list),
            strategy: (0, $ec1c5e6c4c0c64d4$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $ec1c5e6c4c0c64d4$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $d92d5619ced5d58e$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $6bfecfb8d11a0816$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $ec1c5e6c4c0c64d4$export$c5491a8691a23b9e).variadic
        })
    };
}
function $6bfecfb8d11a0816$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $6e50856a3f9e8f8c$export$549f97e137a05c90)("No ".concat(type, " format named: ").concat(name)));
}


function $854e3ebeaed1c3ee$export$45c4bbf6e55bba1f(intl) {
    (0, $5ce90fd99210cb3b$export$f5708dca728d7177)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $854e3ebeaed1c3ee$export$b52f8d6fc0d47415 = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, (0, $6bfecfb8d11a0816$export$b52f8d6fc0d47415)), {
    textComponent: $ltGt3.Fragment
});
function $854e3ebeaed1c3ee$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($ltGt3.Children.toArray(parts));
    };
}
function $854e3ebeaed1c3ee$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}


function $bc0361bb479b8e2e$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $bc0361bb479b8e2e$var$IntlContext = typeof window !== 'undefined' ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $ltGt3.createContext(null)) : $ltGt3.createContext(null);
var $bc0361bb479b8e2e$var$IntlConsumer = $bc0361bb479b8e2e$var$IntlContext.Consumer, $bc0361bb479b8e2e$var$IntlProvider = $bc0361bb479b8e2e$var$IntlContext.Provider;
var $bc0361bb479b8e2e$export$2881499e37b75b9a = $bc0361bb479b8e2e$var$IntlProvider;
var $bc0361bb479b8e2e$export$841858b892ce1f4c = $bc0361bb479b8e2e$var$IntlContext;
function $bc0361bb479b8e2e$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $ltGt3.createElement($bc0361bb479b8e2e$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $854e3ebeaed1c3ee$export$45c4bbf6e55bba1f)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $ltGt3.createElement(WrappedComponent, (0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($bc0361bb479b8e2e$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($5d5544ef3ac155d4$exports)))($ltGt3.forwardRef(function(props, ref) {
        return $ltGt3.createElement(WithIntl, (0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5d5544ef3ac155d4$exports)))(WithIntl, WrappedComponent);
}



function $f383e3fcbf2e13f1$export$2e2bcd8739ae039() {
    var intl = $ltGt3.useContext((0, $bc0361bb479b8e2e$export$841858b892ce1f4c));
    (0, $854e3ebeaed1c3ee$export$45c4bbf6e55bba1f)(intl);
    return intl;
}




var $ltGt3 = parcelRequire("ltGt3");








var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");

"use client";
const $beedce2c3d16da68$var$Element = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, size: size, shape: shape } = props;
    const sizeCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-sm`]: size === 'small'
    });
    const shapeCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
        [`${prefixCls}-circle`]: shape === 'circle',
        [`${prefixCls}-square`]: shape === 'square',
        [`${prefixCls}-round`]: shape === 'round'
    });
    const sizeStyle = $ltGt3.useMemo(()=>typeof size === 'number' ? {
            width: size,
            height: size,
            lineHeight: `${size}px`
        } : {}, [
        size
    ]);
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, sizeCls, shapeCls, className),
        style: {
            ...sizeStyle,
            ...style
        }
    });
};
var $beedce2c3d16da68$export$2e2bcd8739ae039 = $beedce2c3d16da68$var$Element;




const $bbf206a989c97b7f$var$skeletonClsLoading = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)(`ant-skeleton-loading`, {
    '0%': {
        backgroundPosition: '100% 50%'
    },
    '100%': {
        backgroundPosition: '0 50%'
    }
});
const $bbf206a989c97b7f$var$genSkeletonElementCommonSize = (size)=>({
        height: size,
        lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(size)
    });
const $bbf206a989c97b7f$var$genSkeletonElementSize = (size)=>({
        width: size,
        ...$bbf206a989c97b7f$var$genSkeletonElementCommonSize(size)
    });
const $bbf206a989c97b7f$var$genSkeletonColor = (token)=>({
        background: token.skeletonLoadingBackground,
        backgroundSize: '400% 100%',
        animationName: $bbf206a989c97b7f$var$skeletonClsLoading,
        animationDuration: token.skeletonLoadingMotionDuration,
        animationTimingFunction: 'ease',
        animationIterationCount: 'infinite'
    });
const $bbf206a989c97b7f$var$genSkeletonElementInputSize = (size, calc)=>({
        width: calc(size).mul(5).equal(),
        minWidth: calc(size).mul(5).equal(),
        ...$bbf206a989c97b7f$var$genSkeletonElementCommonSize(size)
    });
const $bbf206a989c97b7f$var$genSkeletonElementAvatar = (token)=>{
    const { skeletonAvatarCls: skeletonAvatarCls, gradientFromColor: gradientFromColor, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM } = token;
    return {
        [skeletonAvatarCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            ...$bbf206a989c97b7f$var$genSkeletonElementSize(controlHeight)
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
            borderRadius: '50%'
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: {
            ...$bbf206a989c97b7f$var$genSkeletonElementSize(controlHeightLG)
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: {
            ...$bbf206a989c97b7f$var$genSkeletonElementSize(controlHeightSM)
        }
    };
};
const $bbf206a989c97b7f$var$genSkeletonElementInput = (token)=>{
    const { controlHeight: controlHeight, borderRadiusSM: borderRadiusSM, skeletonInputCls: skeletonInputCls, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonInputCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            ...$bbf206a989c97b7f$var$genSkeletonElementInputSize(controlHeight, calc)
        },
        [`${skeletonInputCls}-lg`]: {
            ...$bbf206a989c97b7f$var$genSkeletonElementInputSize(controlHeightLG, calc)
        },
        [`${skeletonInputCls}-sm`]: {
            ...$bbf206a989c97b7f$var$genSkeletonElementInputSize(controlHeightSM, calc)
        }
    };
};
const $bbf206a989c97b7f$var$genSkeletonElementShape = (token)=>{
    const { gradientFromColor: gradientFromColor, borderRadiusSM: borderRadiusSM, imageSizeBase: imageSizeBase, calc: calc } = token;
    return {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        background: gradientFromColor,
        borderRadius: borderRadiusSM,
        ...$bbf206a989c97b7f$var$genSkeletonElementSize(calc(imageSizeBase).mul(2).equal())
    };
};
const $bbf206a989c97b7f$var$genSkeletonElementNode = (token)=>{
    return {
        [token.skeletonNodeCls]: {
            ...$bbf206a989c97b7f$var$genSkeletonElementShape(token)
        }
    };
};
const $bbf206a989c97b7f$var$genSkeletonElementImage = (token)=>{
    const { skeletonImageCls: skeletonImageCls, imageSizeBase: imageSizeBase, calc: calc } = token;
    return {
        [skeletonImageCls]: {
            ...$bbf206a989c97b7f$var$genSkeletonElementShape(token),
            [`${skeletonImageCls}-path`]: {
                fill: '#bfbfbf'
            },
            [`${skeletonImageCls}-svg`]: {
                ...$bbf206a989c97b7f$var$genSkeletonElementSize(imageSizeBase),
                maxWidth: calc(imageSizeBase).mul(4).equal(),
                maxHeight: calc(imageSizeBase).mul(4).equal()
            },
            [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
                borderRadius: '50%'
            }
        },
        [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
            borderRadius: '50%'
        }
    };
};
const $bbf206a989c97b7f$var$genSkeletonElementButtonShape = (token, size, buttonCls)=>{
    const { skeletonButtonCls: skeletonButtonCls } = token;
    return {
        [`${buttonCls}${skeletonButtonCls}-circle`]: {
            width: size,
            minWidth: size,
            borderRadius: '50%'
        },
        [`${buttonCls}${skeletonButtonCls}-round`]: {
            borderRadius: size
        }
    };
};
const $bbf206a989c97b7f$var$genSkeletonElementButtonSize = (size, calc)=>({
        width: calc(size).mul(2).equal(),
        minWidth: calc(size).mul(2).equal(),
        ...$bbf206a989c97b7f$var$genSkeletonElementCommonSize(size)
    });
const $bbf206a989c97b7f$var$genSkeletonElementButton = (token)=>{
    const { borderRadiusSM: borderRadiusSM, skeletonButtonCls: skeletonButtonCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonButtonCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            width: calc(controlHeight).mul(2).equal(),
            minWidth: calc(controlHeight).mul(2).equal(),
            ...$bbf206a989c97b7f$var$genSkeletonElementButtonSize(controlHeight, calc)
        },
        ...$bbf206a989c97b7f$var$genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls),
        [`${skeletonButtonCls}-lg`]: {
            ...$bbf206a989c97b7f$var$genSkeletonElementButtonSize(controlHeightLG, calc)
        },
        ...$bbf206a989c97b7f$var$genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`),
        [`${skeletonButtonCls}-sm`]: {
            ...$bbf206a989c97b7f$var$genSkeletonElementButtonSize(controlHeightSM, calc)
        },
        ...$bbf206a989c97b7f$var$genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`)
    };
};
// =============================== Base ===============================
const $bbf206a989c97b7f$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, skeletonAvatarCls: skeletonAvatarCls, skeletonTitleCls: skeletonTitleCls, skeletonParagraphCls: skeletonParagraphCls, skeletonButtonCls: skeletonButtonCls, skeletonInputCls: skeletonInputCls, skeletonNodeCls: skeletonNodeCls, skeletonImageCls: skeletonImageCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, padding: padding, marginSM: marginSM, borderRadius: borderRadius, titleHeight: titleHeight, blockRadius: blockRadius, paragraphLiHeight: paragraphLiHeight, controlHeightXS: controlHeightXS, paragraphMarginTop: paragraphMarginTop } = token;
    return {
        [componentCls]: {
            display: 'table',
            width: '100%',
            [`${componentCls}-header`]: {
                display: 'table-cell',
                paddingInlineEnd: padding,
                verticalAlign: 'top',
                // Avatar
                [skeletonAvatarCls]: {
                    display: 'inline-block',
                    verticalAlign: 'top',
                    background: gradientFromColor,
                    ...$bbf206a989c97b7f$var$genSkeletonElementSize(controlHeight)
                },
                [`${skeletonAvatarCls}-circle`]: {
                    borderRadius: '50%'
                },
                [`${skeletonAvatarCls}-lg`]: {
                    ...$bbf206a989c97b7f$var$genSkeletonElementSize(controlHeightLG)
                },
                [`${skeletonAvatarCls}-sm`]: {
                    ...$bbf206a989c97b7f$var$genSkeletonElementSize(controlHeightSM)
                }
            },
            [`${componentCls}-section`]: {
                display: 'table-cell',
                width: '100%',
                verticalAlign: 'top',
                // Title
                [skeletonTitleCls]: {
                    width: '100%',
                    height: titleHeight,
                    background: gradientFromColor,
                    borderRadius: blockRadius,
                    [`+ ${skeletonParagraphCls}`]: {
                        marginBlockStart: controlHeightSM
                    }
                },
                // paragraph
                [skeletonParagraphCls]: {
                    padding: 0,
                    '> li': {
                        width: '100%',
                        height: paragraphLiHeight,
                        listStyle: 'none',
                        background: gradientFromColor,
                        borderRadius: blockRadius,
                        '+ li': {
                            marginBlockStart: controlHeightXS
                        }
                    }
                },
                [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
                    width: '61%'
                }
            },
            [`&-round ${componentCls}-section`]: {
                [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
                    borderRadius: borderRadius
                }
            }
        },
        [`${componentCls}-with-avatar ${componentCls}-section`]: {
            // Title
            [skeletonTitleCls]: {
                marginBlockStart: marginSM,
                [`+ ${skeletonParagraphCls}`]: {
                    marginBlockStart: paragraphMarginTop
                }
            }
        },
        // Skeleton with element
        [`${componentCls}${componentCls}-element`]: {
            display: 'inline-block',
            width: 'auto',
            ...$bbf206a989c97b7f$var$genSkeletonElementButton(token),
            ...$bbf206a989c97b7f$var$genSkeletonElementAvatar(token),
            ...$bbf206a989c97b7f$var$genSkeletonElementInput(token),
            ...$bbf206a989c97b7f$var$genSkeletonElementNode(token),
            ...$bbf206a989c97b7f$var$genSkeletonElementImage(token)
        },
        // Skeleton Block Button, Input
        [`${componentCls}${componentCls}-block`]: {
            width: '100%',
            [skeletonButtonCls]: {
                width: '100%'
            },
            [skeletonInputCls]: {
                width: '100%'
            }
        },
        // With active animation
        [`${componentCls}${componentCls}-active`]: {
            [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonNodeCls},
        ${skeletonImageCls}
      `]: {
                ...$bbf206a989c97b7f$var$genSkeletonColor(token)
            }
        }
    };
};
const $bbf206a989c97b7f$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillContent: colorFillContent, colorFill: colorFill } = token;
    const gradientFromColor = colorFillContent;
    const gradientToColor = colorFill;
    return {
        color: gradientFromColor,
        colorGradientEnd: gradientToColor,
        gradientFromColor: gradientFromColor,
        gradientToColor: gradientToColor,
        titleHeight: token.controlHeight / 2,
        blockRadius: token.borderRadiusSM,
        paragraphMarginTop: token.marginLG + token.marginXXS,
        paragraphLiHeight: token.controlHeight / 2
    };
};
var $bbf206a989c97b7f$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Skeleton', (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    const skeletonToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        skeletonAvatarCls: `${componentCls}-avatar`,
        skeletonTitleCls: `${componentCls}-title`,
        skeletonParagraphCls: `${componentCls}-paragraph`,
        skeletonButtonCls: `${componentCls}-button`,
        skeletonInputCls: `${componentCls}-input`,
        skeletonNodeCls: `${componentCls}-node`,
        skeletonImageCls: `${componentCls}-image`,
        imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
        borderRadius: 100,
        // Large number to make capsule shape
        skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
        skeletonLoadingMotionDuration: '1.4s'
    });
    return $bbf206a989c97b7f$var$genBaseStyle(skeletonToken);
}, $bbf206a989c97b7f$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            'color',
            'gradientFromColor'
        ],
        [
            'colorGradientEnd',
            'gradientToColor'
        ]
    ]
});


"use client";
const $c3f378f8813b910d$var$SkeletonAvatar = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, active: active, style: style, styles: styles, shape: shape = 'circle', size: size = 'default', ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $bbf206a989c97b7f$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $ltGt3.createElement((0, $beedce2c3d16da68$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-avatar`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        shape: shape,
        size: size,
        ...rest
    }));
};
var $c3f378f8813b910d$export$2e2bcd8739ae039 = $c3f378f8813b910d$var$SkeletonAvatar;



var $ltGt3 = parcelRequire("ltGt3");




"use client";
const $698d705fccccd419$var$SkeletonButton = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, classNames: classNames, active: active, style: style, styles: styles, block: block = false, size: size = 'default', ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $bbf206a989c97b7f$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $ltGt3.createElement((0, $beedce2c3d16da68$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-button`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        size: size,
        ...rest
    }));
};
var $698d705fccccd419$export$2e2bcd8739ae039 = $698d705fccccd419$var$SkeletonButton;




var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");



"use client";
const $6c3c73b9b4ca3dc1$var$SkeletonNode = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, internalClassName: internalClassName, style: style, styles: styles, active: active, children: children } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $bbf206a989c97b7f$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, hashId, classNames?.root, className, rootClassName, cssVarCls);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(classNames?.content, internalClassName || `${prefixCls}-node`),
        style: {
            ...styles?.content,
            ...style
        }
    }, children));
};
var $6c3c73b9b4ca3dc1$export$2e2bcd8739ae039 = $6c3c73b9b4ca3dc1$var$SkeletonNode;


"use client";
const $3e77e9038821d5e6$var$path = 'M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z';
const $3e77e9038821d5e6$var$SkeletonImage = (props)=>{
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', props.prefixCls);
    return /*#__PURE__*/ $ltGt3.createElement((0, $6c3c73b9b4ca3dc1$export$2e2bcd8739ae039), {
        ...props,
        internalClassName: `${prefixCls}-image`
    }, /*#__PURE__*/ $ltGt3.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${prefixCls}-image-svg`
    }, /*#__PURE__*/ $ltGt3.createElement("title", null, "Image placeholder"), /*#__PURE__*/ $ltGt3.createElement("path", {
        d: $3e77e9038821d5e6$var$path,
        className: `${prefixCls}-image-path`
    })));
};
var $3e77e9038821d5e6$export$2e2bcd8739ae039 = $3e77e9038821d5e6$var$SkeletonImage;



var $ltGt3 = parcelRequire("ltGt3");




"use client";
const $77bda7feafdc4d68$var$SkeletonInput = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, active: active, block: block, style: style, styles: styles, size: size = 'default', ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $bbf206a989c97b7f$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $ltGt3.createElement((0, $beedce2c3d16da68$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-input`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        size: size,
        ...rest
    }));
};
var $77bda7feafdc4d68$export$2e2bcd8739ae039 = $77bda7feafdc4d68$var$SkeletonInput;




var $ltGt3 = parcelRequire("ltGt3");

"use client";
const $a4636856f1f615bf$var$getWidth = (index, props)=>{
    const { width: width, rows: rows = 2 } = props;
    if (Array.isArray(width)) return width[index];
    // last paragraph
    if (rows - 1 === index) return width;
    return undefined;
};
const $a4636856f1f615bf$var$Paragraph = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, rows: rows = 0 } = props;
    const rowList = Array.from({
        length: rows
    }).map((_, index)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $ltGt3.createElement("li", {
            key: index,
            style: {
                width: $a4636856f1f615bf$var$getWidth(index, props)
            }
        }));
    return /*#__PURE__*/ $ltGt3.createElement("ul", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, className),
        style: style
    }, rowList);
};
var $a4636856f1f615bf$export$2e2bcd8739ae039 = $a4636856f1f615bf$var$Paragraph;




var $ltGt3 = parcelRequire("ltGt3");

"use client";
const $776a222278518119$var$Title = ({ prefixCls: prefixCls, className: className, width: width, style: style })=>/*#__PURE__*/ // biome-ignore lint/a11y/useHeadingContent: HOC here
    $ltGt3.createElement("h3", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, className),
        style: {
            width: width,
            ...style
        }
    });
var $776a222278518119$export$2e2bcd8739ae039 = $776a222278518119$var$Title;


"use client";
function $6060a56be46f566a$var$getComponentProps(prop) {
    if (prop && typeof prop === 'object') return prop;
    return {};
}
function $6060a56be46f566a$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: 'large',
        shape: 'square'
    };
    return {
        size: 'large',
        shape: 'circle'
    };
}
function $6060a56be46f566a$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: '38%'
    };
    if (hasAvatar && hasParagraph) return {
        width: '50%'
    };
    return {};
}
function $6060a56be46f566a$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    const basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = '61%';
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
// Tips: ctx.classNames.root < ctx.className < cpns.classNames.root < cpns.className < rootClassName
const $6060a56be46f566a$var$Skeleton = (props)=>{
    const { prefixCls: customizePrefixCls, loading: loading, className: className, rootClassName: rootClassName, classNames: classNames, style: style, styles: styles, children: children, avatar: avatar = false, title: title = true, paragraph: paragraph = true, active: active, round: round } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('skeleton');
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $bbf206a989c97b7f$export$2e2bcd8739ae039)(prefixCls);
    const mergedProps = {
        ...props,
        avatar: avatar,
        title: title,
        paragraph: paragraph
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    if (loading || !('loading' in props)) {
        const hasAvatar = !!avatar;
        const hasTitle = !!title;
        const hasParagraph = !!paragraph;
        // Avatar
        let avatarNode;
        if (hasAvatar) {
            const avatarProps = {
                className: mergedClassNames.avatar,
                prefixCls: `${prefixCls}-avatar`,
                ...$6060a56be46f566a$var$getAvatarBasicProps(hasTitle, hasParagraph),
                ...$6060a56be46f566a$var$getComponentProps(avatar),
                style: mergedStyles.avatar
            };
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ $ltGt3.createElement("div", {
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassNames.header, `${prefixCls}-header`),
                style: mergedStyles.header
            }, /*#__PURE__*/ $ltGt3.createElement((0, $beedce2c3d16da68$export$2e2bcd8739ae039), {
                ...avatarProps
            }));
        }
        let contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            let $title;
            if (hasTitle) {
                const titleProps = {
                    className: mergedClassNames.title,
                    prefixCls: `${prefixCls}-title`,
                    ...$6060a56be46f566a$var$getTitleBasicProps(hasAvatar, hasParagraph),
                    ...$6060a56be46f566a$var$getComponentProps(title),
                    style: mergedStyles.title
                };
                $title = /*#__PURE__*/ $ltGt3.createElement((0, $776a222278518119$export$2e2bcd8739ae039), {
                    ...titleProps
                });
            }
            // Paragraph
            let paragraphNode;
            if (hasParagraph) {
                const paragraphProps = {
                    className: mergedClassNames.paragraph,
                    prefixCls: `${prefixCls}-paragraph`,
                    ...$6060a56be46f566a$var$getParagraphBasicProps(hasAvatar, hasTitle),
                    ...$6060a56be46f566a$var$getComponentProps(paragraph),
                    style: mergedStyles.paragraph
                };
                paragraphNode = /*#__PURE__*/ $ltGt3.createElement((0, $a4636856f1f615bf$export$2e2bcd8739ae039), {
                    ...paragraphProps
                });
            }
            contentNode = /*#__PURE__*/ $ltGt3.createElement("div", {
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassNames.section, `${prefixCls}-section`),
                style: mergedStyles.section
            }, $title, paragraphNode);
        }
        const cls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-with-avatar`]: hasAvatar,
            [`${prefixCls}-active`]: active,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-round`]: round
        }, mergedClassNames.root, contextClassName, className, rootClassName, hashId, cssVarCls);
        return /*#__PURE__*/ $ltGt3.createElement("div", {
            className: cls,
            style: {
                ...mergedStyles.root,
                ...contextStyle,
                ...style
            }
        }, avatarNode, contentNode);
    }
    return children ?? null;
};
$6060a56be46f566a$var$Skeleton.Button = (0, $698d705fccccd419$export$2e2bcd8739ae039);
$6060a56be46f566a$var$Skeleton.Avatar = (0, $c3f378f8813b910d$export$2e2bcd8739ae039);
$6060a56be46f566a$var$Skeleton.Input = (0, $77bda7feafdc4d68$export$2e2bcd8739ae039);
$6060a56be46f566a$var$Skeleton.Image = (0, $3e77e9038821d5e6$export$2e2bcd8739ae039);
$6060a56be46f566a$var$Skeleton.Node = (0, $6c3c73b9b4ca3dc1$export$2e2bcd8739ae039);
var $6060a56be46f566a$export$2e2bcd8739ae039 = $6060a56be46f566a$var$Skeleton;


"use client";
var $bbc46c63198736c0$export$2e2bcd8739ae039 = (0, $6060a56be46f566a$export$2e2bcd8739ae039);



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $71b60cba26c9f93f$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $71b60cba26c9f93f$export$2e2bcd8739ae039 = $71b60cba26c9f93f$var$CloseOutlined;



function $7448fa8744d68ce1$var$_extends() {
    $7448fa8744d68ce1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7448fa8744d68ce1$var$_extends.apply(this, arguments);
}
const $7448fa8744d68ce1$var$CloseOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $7448fa8744d68ce1$var$_extends({}, props, {
        ref: ref,
        icon: (0, $71b60cba26c9f93f$export$2e2bcd8739ae039)
    }));
/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */ const $7448fa8744d68ce1$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($7448fa8744d68ce1$var$CloseOutlined);
var $7448fa8744d68ce1$export$2e2bcd8739ae039 = $7448fa8744d68ce1$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $d8a788c27fbc5de4$var$EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
var $d8a788c27fbc5de4$export$2e2bcd8739ae039 = $d8a788c27fbc5de4$var$EllipsisOutlined;



function $21a25bcc3e8ef68c$var$_extends() {
    $21a25bcc3e8ef68c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $21a25bcc3e8ef68c$var$_extends.apply(this, arguments);
}
const $21a25bcc3e8ef68c$var$EllipsisOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $21a25bcc3e8ef68c$var$_extends({}, props, {
        ref: ref,
        icon: (0, $d8a788c27fbc5de4$export$2e2bcd8739ae039)
    }));
/**![ellipsis](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3NiA1MTFhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTI4MCAwYTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAwem0yODAgMGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHoiIC8+PC9zdmc+) */ const $21a25bcc3e8ef68c$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($21a25bcc3e8ef68c$var$EllipsisOutlined);
var $21a25bcc3e8ef68c$export$2e2bcd8739ae039 = $21a25bcc3e8ef68c$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $5650f03a968134d9$var$PlusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    "name": "plus",
    "theme": "outlined"
};
var $5650f03a968134d9$export$2e2bcd8739ae039 = $5650f03a968134d9$var$PlusOutlined;



function $44fddb3bd1473a4a$var$_extends() {
    $44fddb3bd1473a4a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $44fddb3bd1473a4a$var$_extends.apply(this, arguments);
}
const $44fddb3bd1473a4a$var$PlusOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $44fddb3bd1473a4a$var$_extends({}, props, {
        ref: ref,
        icon: (0, $5650f03a968134d9$export$2e2bcd8739ae039)
    }));
/**![plus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4MiAxNTJoNjBxOCAwIDggOHY3MDRxMCA4LTggOGgtNjBxLTggMC04LThWMTYwcTAtOCA4LTh6IiAvPjxwYXRoIGQ9Ik0xOTIgNDc0aDY3MnE4IDAgOCA4djYwcTAgOC04IDhIMTYwcS04IDAtOC04di02MHEwLTggOC04eiIgLz48L3N2Zz4=) */ const $44fddb3bd1473a4a$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($44fddb3bd1473a4a$var$PlusOutlined);
var $44fddb3bd1473a4a$export$2e2bcd8739ae039 = $44fddb3bd1473a4a$var$RefIcon;




var $3290356e57e80d87$exports = {};
'use strict';
$3290356e57e80d87$exports = $3290356e57e80d87$var$isMobile;
$3290356e57e80d87$exports.isMobile = $3290356e57e80d87$var$isMobile;
$3290356e57e80d87$exports.default = $3290356e57e80d87$var$isMobile;
const $3290356e57e80d87$var$mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|redmi|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const $3290356e57e80d87$var$notMobileRE = /CrOS/;
const $3290356e57e80d87$var$tabletRE = /android|ipad|playbook|silk/i;
function $3290356e57e80d87$var$isMobile(opts) {
    if (!opts) opts = {};
    let ua = opts.ua;
    if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') ua = ua.headers['user-agent'];
    if (typeof ua !== 'string') return false;
    let result = $3290356e57e80d87$var$mobileRE.test(ua) && !$3290356e57e80d87$var$notMobileRE.test(ua) || !!opts.tablet && $3290356e57e80d87$var$tabletRE.test(ua);
    if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf('Macintosh') !== -1 && ua.indexOf('Safari') !== -1) result = true;
    return result;
}


let $34be7dad9a9027c0$var$cached;
var $34be7dad9a9027c0$export$2e2bcd8739ae039 = ()=>{
    if (typeof $34be7dad9a9027c0$var$cached === 'undefined') $34be7dad9a9027c0$var$cached = (0, (/*@__PURE__*/$parcel$interopDefault($3290356e57e80d87$exports)))();
    return $34be7dad9a9027c0$var$cached;
};



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
var $57d8810d7e9dcee6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ltGt3.createContext)(null);


// zombieJ: To compatible with `renderTabBar` usage.

var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
const $b8ddb59731357800$var$useIndicator = (options)=>{
    const { activeTabOffset: activeTabOffset, horizontal: horizontal, rtl: rtl, indicator: indicator = {} } = options;
    const { size: size, align: align = 'center' } = indicator;
    const [inkStyle, setInkStyle] = (0, $ltGt3.useState)();
    const inkBarRafRef = (0, $ltGt3.useRef)();
    const getLength = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useCallback((origin)=>{
        if (typeof size === 'function') return size(origin);
        if (typeof size === 'number') return size;
        return origin;
    }, [
        size
    ]);
    // Delay set ink style to avoid remove tab blink
    function cleanInkBarRaf() {
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(inkBarRafRef.current);
    }
    (0, $ltGt3.useEffect)(()=>{
        const newInkStyle = {};
        if (activeTabOffset) {
            if (horizontal) {
                newInkStyle.width = getLength(activeTabOffset.width);
                const key = rtl ? 'right' : 'left';
                if (align === 'start') newInkStyle[key] = activeTabOffset[key];
                if (align === 'center') {
                    newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width / 2;
                    newInkStyle.transform = rtl ? 'translateX(50%)' : 'translateX(-50%)';
                }
                if (align === 'end') {
                    newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width;
                    newInkStyle.transform = 'translateX(-100%)';
                }
            } else {
                newInkStyle.height = getLength(activeTabOffset.height);
                if (align === 'start') newInkStyle.top = activeTabOffset.top;
                if (align === 'center') {
                    newInkStyle.top = activeTabOffset.top + activeTabOffset.height / 2;
                    newInkStyle.transform = 'translateY(-50%)';
                }
                if (align === 'end') {
                    newInkStyle.top = activeTabOffset.top + activeTabOffset.height;
                    newInkStyle.transform = 'translateY(-100%)';
                }
            }
        }
        cleanInkBarRaf();
        inkBarRafRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
            // Avoid jitter caused by tiny numerical differences
            // fix https://github.com/ant-design/ant-design/issues/53378
            const isEqual = inkStyle && newInkStyle && Object.keys(newInkStyle).every((key)=>{
                const newValue = newInkStyle[key];
                const oldValue = inkStyle[key];
                return typeof newValue === 'number' && typeof oldValue === 'number' ? Math.round(newValue) === Math.round(oldValue) : newValue === oldValue;
            });
            if (!isEqual) setInkStyle(newInkStyle);
        });
        return cleanInkBarRaf;
    }, [
        JSON.stringify(activeTabOffset),
        horizontal,
        rtl,
        align,
        getLength
    ]);
    return {
        style: inkStyle
    };
};
var $b8ddb59731357800$export$2e2bcd8739ae039 = $b8ddb59731357800$var$useIndicator;



var $ltGt3 = parcelRequire("ltGt3");
const $f5c4e662aab62140$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0
};
function $f5c4e662aab62140$export$2e2bcd8739ae039(tabs, tabSizes, holderScrollWidth) {
    return (0, $ltGt3.useMemo)(()=>{
        const map = new Map();
        const lastOffset = tabSizes.get(tabs[0]?.key) || $f5c4e662aab62140$var$DEFAULT_SIZE;
        const rightOffset = lastOffset.left + lastOffset.width;
        for(let i = 0; i < tabs.length; i += 1){
            const { key: key } = tabs[i];
            let data = tabSizes.get(key);
            // Reuse last one when not exist yet
            if (!data) data = tabSizes.get(tabs[i - 1]?.key) || $f5c4e662aab62140$var$DEFAULT_SIZE;
            const entity = map.get(key) || {
                ...data
            };
            // Right
            entity.right = rightOffset - entity.left - entity.width;
            // Update entity
            map.set(key, entity);
        }
        return map;
    }, [
        tabs.map((tab)=>tab.key).join('_'),
        tabSizes,
        holderScrollWidth
    ]);
}



var $ltGt3 = parcelRequire("ltGt3");
function $a1d1757bfe60887a$export$2e2bcd8739ae039(defaultState, onChange) {
    const stateRef = $ltGt3.useRef(defaultState);
    const [, forceUpdate] = $ltGt3.useState({});
    function setState(updater) {
        const newValue = typeof updater === 'function' ? updater(stateRef.current) : updater;
        if (newValue !== stateRef.current) onChange(newValue, stateRef.current);
        stateRef.current = newValue;
        forceUpdate({});
    }
    return [
        stateRef.current,
        setState
    ];
}



var $ltGt3 = parcelRequire("ltGt3");
const $28a5d16eaccae07e$var$MIN_SWIPE_DISTANCE = 0.1;
const $28a5d16eaccae07e$var$STOP_SWIPE_DISTANCE = 0.01;
const $28a5d16eaccae07e$var$REFRESH_INTERVAL = 20;
const $28a5d16eaccae07e$var$SPEED_OFF_MULTIPLE = 0.995 ** $28a5d16eaccae07e$var$REFRESH_INTERVAL;
function $28a5d16eaccae07e$export$2e2bcd8739ae039(ref, onOffset) {
    const [touchPosition, setTouchPosition] = (0, $ltGt3.useState)();
    const [lastTimestamp, setLastTimestamp] = (0, $ltGt3.useState)(0);
    const [lastTimeDiff, setLastTimeDiff] = (0, $ltGt3.useState)(0);
    const [lastOffset, setLastOffset] = (0, $ltGt3.useState)();
    const motionRef = (0, $ltGt3.useRef)();
    // ========================= Events =========================
    // >>> Touch events
    function onTouchStart(e) {
        const { screenX: screenX, screenY: screenY } = e.touches[0];
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        window.clearInterval(motionRef.current);
    }
    function onTouchMove(e) {
        if (!touchPosition) return;
        // e.preventDefault();
        const { screenX: screenX, screenY: screenY } = e.touches[0];
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        const offsetX = screenX - touchPosition.x;
        const offsetY = screenY - touchPosition.y;
        onOffset(offsetX, offsetY);
        const now = Date.now();
        setLastTimestamp(now);
        setLastTimeDiff(now - lastTimestamp);
        setLastOffset({
            x: offsetX,
            y: offsetY
        });
    }
    function onTouchEnd() {
        if (!touchPosition) return;
        setTouchPosition(null);
        setLastOffset(null);
        // Swipe if needed
        if (lastOffset) {
            const distanceX = lastOffset.x / lastTimeDiff;
            const distanceY = lastOffset.y / lastTimeDiff;
            const absX = Math.abs(distanceX);
            const absY = Math.abs(distanceY);
            // Skip swipe if low distance
            if (Math.max(absX, absY) < $28a5d16eaccae07e$var$MIN_SWIPE_DISTANCE) return;
            let currentX = distanceX;
            let currentY = distanceY;
            motionRef.current = window.setInterval(()=>{
                if (Math.abs(currentX) < $28a5d16eaccae07e$var$STOP_SWIPE_DISTANCE && Math.abs(currentY) < $28a5d16eaccae07e$var$STOP_SWIPE_DISTANCE) {
                    window.clearInterval(motionRef.current);
                    return;
                }
                currentX *= $28a5d16eaccae07e$var$SPEED_OFF_MULTIPLE;
                currentY *= $28a5d16eaccae07e$var$SPEED_OFF_MULTIPLE;
                onOffset(currentX * $28a5d16eaccae07e$var$REFRESH_INTERVAL, currentY * $28a5d16eaccae07e$var$REFRESH_INTERVAL);
            }, $28a5d16eaccae07e$var$REFRESH_INTERVAL);
        }
    }
    // >>> Wheel event
    const lastWheelDirectionRef = (0, $ltGt3.useRef)();
    function onWheel(e) {
        const { deltaX: deltaX, deltaY: deltaY } = e;
        // Convert both to x & y since wheel only happened on PC
        let mixed = 0;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);
        if (absX === absY) mixed = lastWheelDirectionRef.current === 'x' ? deltaX : deltaY;
        else if (absX > absY) {
            mixed = deltaX;
            lastWheelDirectionRef.current = 'x';
        } else {
            mixed = deltaY;
            lastWheelDirectionRef.current = 'y';
        }
        if (onOffset(-mixed, -mixed)) e.preventDefault();
    }
    // ========================= Effect =========================
    const touchEventsRef = (0, $ltGt3.useRef)(null);
    touchEventsRef.current = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onWheel: onWheel
    };
    $ltGt3.useEffect(()=>{
        function onProxyTouchStart(e) {
            touchEventsRef.current.onTouchStart(e);
        }
        function onProxyTouchMove(e) {
            touchEventsRef.current.onTouchMove(e);
        }
        function onProxyTouchEnd(e) {
            touchEventsRef.current.onTouchEnd(e);
        }
        function onProxyWheel(e) {
            touchEventsRef.current.onWheel(e);
        }
        document.addEventListener('touchmove', onProxyTouchMove, {
            passive: false
        });
        document.addEventListener('touchend', onProxyTouchEnd, {
            passive: true
        });
        // No need to clean up since element removed
        ref.current.addEventListener('touchstart', onProxyTouchStart, {
            passive: true
        });
        ref.current.addEventListener('wheel', onProxyWheel, {
            passive: false
        });
        return ()=>{
            document.removeEventListener('touchmove', onProxyTouchMove);
            document.removeEventListener('touchend', onProxyTouchEnd);
        };
    }, []);
}




var $ltGt3 = parcelRequire("ltGt3");
function $ef8644fe96249ce0$export$2e2bcd8739ae039(callback) {
    const [count, setCount] = (0, $ltGt3.useState)(0);
    const effectRef = (0, $ltGt3.useRef)(0);
    const callbackRef = (0, $ltGt3.useRef)();
    callbackRef.current = callback;
    // Trigger on `useLayoutEffect`
    (0, $b51fc3415a3f1104$export$9283e56bae2f7b0f)(()=>{
        callbackRef.current?.();
    }, [
        count
    ]);
    // Trigger to update count
    return ()=>{
        if (effectRef.current !== count) return;
        effectRef.current += 1;
        setCount(effectRef.current);
    };
}
function $ef8644fe96249ce0$export$aefd2a30eb6d999e(defaultState) {
    const batchRef = (0, $ltGt3.useRef)([]);
    const [, forceUpdate] = (0, $ltGt3.useState)({});
    const state = (0, $ltGt3.useRef)(typeof defaultState === 'function' ? defaultState() : defaultState);
    const flushUpdate = $ef8644fe96249ce0$export$2e2bcd8739ae039(()=>{
        let current = state.current;
        batchRef.current.forEach((callback)=>{
            current = callback(current);
        });
        batchRef.current = [];
        state.current = current;
        forceUpdate({});
    });
    function updater(callback) {
        batchRef.current.push(callback);
        flushUpdate();
    }
    return [
        state.current,
        updater
    ];
}



var $ltGt3 = parcelRequire("ltGt3");
const $fe42cb7928856538$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    right: 0
};
function $fe42cb7928856538$export$2e2bcd8739ae039(tabOffsets, visibleTabContentValue, transform, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, { tabs: tabs, tabPosition: tabPosition, rtl: rtl }) {
    let charUnit;
    let position;
    let transformSize;
    if ([
        'top',
        'bottom'
    ].includes(tabPosition)) {
        charUnit = 'width';
        position = rtl ? 'right' : 'left';
        transformSize = Math.abs(transform);
    } else {
        charUnit = 'height';
        position = 'top';
        transformSize = -transform;
    }
    return (0, $ltGt3.useMemo)(()=>{
        if (!tabs.length) return [
            0,
            0
        ];
        const len = tabs.length;
        let endIndex = len;
        for(let i = 0; i < len; i += 1){
            const offset = tabOffsets.get(tabs[i].key) || $fe42cb7928856538$var$DEFAULT_SIZE;
            if (Math.floor(offset[position] + offset[charUnit]) > Math.floor(transformSize + visibleTabContentValue)) {
                endIndex = i - 1;
                break;
            }
        }
        let startIndex = 0;
        for(let i = len - 1; i >= 0; i -= 1){
            const offset = tabOffsets.get(tabs[i].key) || $fe42cb7928856538$var$DEFAULT_SIZE;
            if (offset[position] < transformSize) {
                startIndex = i + 1;
                break;
            }
        }
        return startIndex > endIndex ? [
            0,
            -1
        ] : [
            startIndex,
            endIndex
        ];
    }, [
        tabOffsets,
        visibleTabContentValue,
        tabContentSizeValue,
        addNodeSizeValue,
        operationNodeSizeValue,
        transformSize,
        tabPosition,
        tabs.map((tab)=>tab.key).join('_'),
        rtl
    ]);
}


/**
 * We trade Map as deps which may change with same value but different ref object.
 * We should make it as hash for deps
 * */ function $a49f2c3ed81bc09f$export$fac44ee5b035f737(obj) {
    let tgt;
    if (obj instanceof Map) {
        tgt = {};
        obj.forEach((v, k)=>{
            tgt[k] = v;
        });
    } else tgt = obj;
    return JSON.stringify(tgt);
}
const $a49f2c3ed81bc09f$var$RC_TABS_DOUBLE_QUOTE = 'TABS_DQ';
function $a49f2c3ed81bc09f$export$c55417729a96230c(key) {
    return String(key).replace(/"/g, $a49f2c3ed81bc09f$var$RC_TABS_DOUBLE_QUOTE);
}
function $a49f2c3ed81bc09f$export$eab31ca11b8b073(closable, closeIcon, editable, disabled) {
    if (// Only editable tabs can be removed
    !editable || // Tabs cannot be removed when disabled
    disabled || // closable is false
    closable === false || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    closable === undefined && (closeIcon === false || closeIcon === null)) return false;
    return true;
}



var $ltGt3 = parcelRequire("ltGt3");
const $4db3af34792de2c6$var$AddButton = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, editable: editable, locale: locale, style: style } = props;
    if (!editable || editable.showAdd === false) return null;
    return /*#__PURE__*/ $ltGt3.createElement("button", {
        ref: ref,
        type: "button",
        className: `${prefixCls}-nav-add`,
        style: style,
        "aria-label": locale?.addAriaLabel || 'Add tab',
        onClick: (event)=>{
            editable.onEdit('add', {
                event: event
            });
        }
    }, editable.addIcon || '+');
});
var $4db3af34792de2c6$export$2e2bcd8739ae039 = $4db3af34792de2c6$var$AddButton;



var $ltGt3 = parcelRequire("ltGt3");
const $78cf86ca41636a29$var$ExtraContent = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { position: position, prefixCls: prefixCls, extra: extra } = props;
    if (!extra) return null;
    let content;
    // Parse extra
    let assertExtra = {};
    if (typeof extra === 'object' && !/*#__PURE__*/ $ltGt3.isValidElement(extra)) assertExtra = extra;
    else assertExtra.right = extra;
    if (position === 'right') content = assertExtra.right;
    if (position === 'left') content = assertExtra.left;
    return content ? /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-extra-content`,
        ref: ref
    }, content) : null;
});
var $78cf86ca41636a29$export$2e2bcd8739ae039 = $78cf86ca41636a29$var$ExtraContent;







var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
const { ESC: $0bf1d563d8bf7d08$var$ESC, TAB: $0bf1d563d8bf7d08$var$TAB } = (0, $b0616a5421b43292$export$2e2bcd8739ae039);
function $0bf1d563d8bf7d08$export$2e2bcd8739ae039({ visible: visible, triggerRef: triggerRef, onVisibleChange: onVisibleChange, autoFocus: autoFocus, overlayRef: overlayRef }) {
    const focusMenuRef = $ltGt3.useRef(false);
    const handleCloseMenuAndReturnFocus = ()=>{
        if (visible) {
            triggerRef.current?.focus?.();
            onVisibleChange?.(false);
        }
    };
    const focusMenu = ()=>{
        if (overlayRef.current?.focus) {
            overlayRef.current.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    const handleKeyDown = (event)=>{
        switch(event.keyCode){
            case $0bf1d563d8bf7d08$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $0bf1d563d8bf7d08$var$TAB:
                {
                    let focusResult = false;
                    if (!focusMenuRef.current) focusResult = focusMenu();
                    if (focusResult) event.preventDefault();
                    else handleCloseMenuAndReturnFocus();
                    break;
                }
        }
    };
    $ltGt3.useEffect(()=>{
        if (visible) {
            window.addEventListener('keydown', handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(focusMenu, 3);
            return ()=>{
                window.removeEventListener('keydown', handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return ()=>{
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}




var $ltGt3 = parcelRequire("ltGt3");
const $f3e0dd395e98964c$var$Overlay = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
    const { overlay: overlay, arrow: arrow, prefixCls: prefixCls } = props;
    const overlayNode = (0, $ltGt3.useMemo)(()=>{
        let overlayElement;
        if (typeof overlay === 'function') overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    }, [
        overlay
    ]);
    const composedRef = (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(ref, (0, $22ff46e28c8066e1$export$7465e5c0bf44f19a)(overlayNode));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Fragment, null, arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(overlayNode, {
        ref: (0, $22ff46e28c8066e1$export$c1cec34af06bcf7)(overlayNode) ? composedRef : undefined
    }));
});
var $f3e0dd395e98964c$export$2e2bcd8739ae039 = $f3e0dd395e98964c$var$Overlay;


const $3b82e2efe60683c8$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const $3b82e2efe60683c8$var$targetOffset = [
    0,
    0
];
const $3b82e2efe60683c8$var$placements = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $3b82e2efe60683c8$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $3b82e2efe60683c8$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $3b82e2efe60683c8$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $3b82e2efe60683c8$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $3b82e2efe60683c8$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $3b82e2efe60683c8$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $3b82e2efe60683c8$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $3b82e2efe60683c8$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $3b82e2efe60683c8$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $3b82e2efe60683c8$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $3b82e2efe60683c8$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $3b82e2efe60683c8$var$targetOffset
    }
};
var $3b82e2efe60683c8$export$2e2bcd8739ae039 = $3b82e2efe60683c8$var$placements;


function $ae294233f8ddf3e9$var$_extends() {
    $ae294233f8ddf3e9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ae294233f8ddf3e9$var$_extends.apply(this, arguments);
}
function $ae294233f8ddf3e9$var$Dropdown(props, ref) {
    const { arrow: arrow = false, prefixCls: prefixCls = 'rc-dropdown', transitionName: transitionName, animation: animation, align: align, placement: placement = 'bottomLeft', placements: placements = (0, $3b82e2efe60683c8$export$2e2bcd8739ae039), getPopupContainer: getPopupContainer, showAction: showAction, hideAction: hideAction, overlayClassName: overlayClassName, overlayStyle: overlayStyle, visible: visible, trigger: trigger = [
        'hover'
    ], autoFocus: autoFocus, overlay: overlay, children: children, onVisibleChange: onVisibleChange, ...otherProps } = props;
    const [triggerVisible, setTriggerVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState();
    const mergedVisible = 'visible' in props ? visible : triggerVisible;
    const mergedMotionName = animation ? `${prefixCls}-${animation}` : transitionName;
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    const overlayRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    const childRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useImperativeHandle(ref, ()=>triggerRef.current);
    const handleVisibleChange = (newVisible)=>{
        setTriggerVisible(newVisible);
        onVisibleChange?.(newVisible);
    };
    (0, $0bf1d563d8bf7d08$export$2e2bcd8739ae039)({
        visible: mergedVisible,
        triggerRef: childRef,
        onVisibleChange: handleVisibleChange,
        autoFocus: autoFocus,
        overlayRef: overlayRef
    });
    const onClick = (e)=>{
        const { onOverlayClick: onOverlayClick } = props;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    const getMenuElement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $f3e0dd395e98964c$export$2e2bcd8739ae039), {
            ref: overlayRef,
            overlay: overlay,
            prefixCls: prefixCls,
            arrow: arrow
        });
    const getMenuElementOrLambda = ()=>{
        if (typeof overlay === 'function') return getMenuElement;
        return getMenuElement();
    };
    const getMinOverlayWidthMatchTrigger = ()=>{
        const { minOverlayWidthMatchTrigger: minOverlayWidthMatchTrigger, alignPoint: alignPoint } = props;
        if ('minOverlayWidthMatchTrigger' in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    const getOpenClassName = ()=>{
        const { openClassName: openClassName } = props;
        if (openClassName !== undefined) return openClassName;
        return `${prefixCls}-open`;
    };
    const childrenNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(children, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(children.props?.className, mergedVisible && getOpenClassName()),
        ref: (0, $22ff46e28c8066e1$export$c1cec34af06bcf7)(children) ? (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(childRef, (0, $22ff46e28c8066e1$export$7465e5c0bf44f19a)(children)) : undefined
    });
    let triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) triggerHideAction = [
        'click'
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $1b29c21fa1aa3a55$export$2e2bcd8739ae039), $ae294233f8ddf3e9$var$_extends({
        builtinPlacements: placements
    }, otherProps, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(overlayClassName, {
            [`${prefixCls}-show-arrow`]: arrow
        }),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction,
        popupPlacement: placement,
        popupAlign: align,
        popupMotion: {
            motionName: mergedMotionName
        },
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? 'minWidth' : '',
        popup: getMenuElementOrLambda(),
        onPopupVisibleChange: handleVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), childrenNode);
}
var $ae294233f8ddf3e9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef($ae294233f8ddf3e9$var$Dropdown);


var $14028894932dc2c5$export$2e2bcd8739ae039 = (0, $ae294233f8ddf3e9$export$2e2bcd8739ae039);






function $21c7efdc35469ab5$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $289081aecb178230$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $21c7efdc35469ab5$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
function $a81d8b97e944e43c$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($a81d8b97e944e43c$export$2e2bcd8739ae039(child));
        else if ((0, $14266d390b9ba209$export$2e2bcd8739ae039)(child) && child.props) ret = ret.concat($a81d8b97e944e43c$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}







var $ltGt3 = parcelRequire("ltGt3");

function $faa9bc51eaaa34e5$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $faa9bc51eaaa34e5$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(node) === 'object' && $faa9bc51eaaa34e5$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($faa9bc51eaaa34e5$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $faa9bc51eaaa34e5$export$2e2bcd8739ae039(node) {
    var domNode = $faa9bc51eaaa34e5$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($35c0fb1a856c78db$exports))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($35c0fb1a856c78db$exports))), node);
    }
    return null;
}




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
var $13c878cace4a1582$export$db36075d98ba73d3 = /*#__PURE__*/ $ltGt3.createContext(null);
function $13c878cace4a1582$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $ltGt3.useRef(0);
    var resizeInfosRef = $ltGt3.useRef([]);
    var onCollectionResize = $ltGt3.useContext($13c878cace4a1582$export$db36075d98ba73d3);
    var onResize = $ltGt3.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $ltGt3.createElement($13c878cace4a1582$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}


/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $abb744758b801129$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $abb744758b801129$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $abb744758b801129$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $abb744758b801129$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($abb744758b801129$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $abb744758b801129$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $abb744758b801129$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $abb744758b801129$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $abb744758b801129$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $abb744758b801129$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $abb744758b801129$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $abb744758b801129$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $abb744758b801129$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $abb744758b801129$var$throttle(this.refresh.bind(this), $abb744758b801129$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$abb744758b801129$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($abb744758b801129$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$abb744758b801129$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $abb744758b801129$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $abb744758b801129$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $abb744758b801129$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $abb744758b801129$var$global$1;
};
// Placeholder of an empty content rectangle.
var $abb744758b801129$var$emptyRect = $abb744758b801129$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $abb744758b801129$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $abb744758b801129$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $abb744758b801129$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $abb744758b801129$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $abb744758b801129$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $abb744758b801129$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $abb744758b801129$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $abb744758b801129$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $abb744758b801129$var$emptyRect;
    var styles = $abb744758b801129$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $abb744758b801129$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $abb744758b801129$var$toFloat(styles.width), height = $abb744758b801129$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $abb744758b801129$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $abb744758b801129$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$abb744758b801129$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $abb744758b801129$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $abb744758b801129$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $abb744758b801129$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $abb744758b801129$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $abb744758b801129$var$isDocumentElement(target) {
    return target === $abb744758b801129$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $abb744758b801129$var$getContentRect(target) {
    if (!$abb744758b801129$var$isBrowser) return $abb744758b801129$var$emptyRect;
    if ($abb744758b801129$var$isSVGGraphicsElement(target)) return $abb744758b801129$var$getSVGContentRect(target);
    return $abb744758b801129$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $abb744758b801129$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $abb744758b801129$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $abb744758b801129$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $abb744758b801129$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $abb744758b801129$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $abb744758b801129$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $abb744758b801129$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $abb744758b801129$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $abb744758b801129$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $abb744758b801129$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $abb744758b801129$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $abb744758b801129$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $abb744758b801129$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $abb744758b801129$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $abb744758b801129$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $abb744758b801129$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $abb744758b801129$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $abb744758b801129$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $abb744758b801129$var$ResizeObserverController.getInstance();
        var observer = new $abb744758b801129$var$ResizeObserverSPI(callback, controller, this);
        $abb744758b801129$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $abb744758b801129$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $abb744758b801129$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $abb744758b801129$var$index = function() {
    // Export existing implementation if available.
    if (typeof $abb744758b801129$var$global$1.ResizeObserver !== 'undefined') return $abb744758b801129$var$global$1.ResizeObserver;
    return $abb744758b801129$var$ResizeObserver;
}();
var $abb744758b801129$export$2e2bcd8739ae039 = $abb744758b801129$var$index;


// =============================== Const ===============================
var $c1166f2bb3f3fd7c$var$elementListeners = new Map();
function $c1166f2bb3f3fd7c$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $c1166f2bb3f3fd7c$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $c1166f2bb3f3fd7c$var$resizeObserver = new (0, $abb744758b801129$export$2e2bcd8739ae039)($c1166f2bb3f3fd7c$var$onResize);
var $c1166f2bb3f3fd7c$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $c1166f2bb3f3fd7c$export$524f0fd3b47831a = null; // eslint-disable-line
function $c1166f2bb3f3fd7c$export$d1203567a167490e(element, callback) {
    if (!$c1166f2bb3f3fd7c$var$elementListeners.has(element)) {
        $c1166f2bb3f3fd7c$var$elementListeners.set(element, new Set());
        $c1166f2bb3f3fd7c$var$resizeObserver.observe(element);
    }
    $c1166f2bb3f3fd7c$var$elementListeners.get(element).add(callback);
}
function $c1166f2bb3f3fd7c$export$23a2283368c55ea2(element, callback) {
    if ($c1166f2bb3f3fd7c$var$elementListeners.has(element)) {
        $c1166f2bb3f3fd7c$var$elementListeners.get(element).delete(callback);
        if (!$c1166f2bb3f3fd7c$var$elementListeners.get(element).size) {
            $c1166f2bb3f3fd7c$var$resizeObserver.unobserve(element);
            $c1166f2bb3f3fd7c$var$elementListeners.delete(element);
        }
    }
}







var $ltGt3 = parcelRequire("ltGt3");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $76a6d2d8e24ad05a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $56605f2979837676$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $784fa0189d62810b$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($ltGt3.Component);


function $e1de416c1dd7cecb$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $ltGt3.useRef(null);
    var wrapperRef = $ltGt3.useRef(null);
    var onCollectionResize = $ltGt3.useContext((0, $13c878cace4a1582$export$db36075d98ba73d3));
    // =========================== Children ===========================
    var isRenderProps = typeof children === 'function';
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $ltGt3.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $ltGt3.isValidElement(mergedChildren) && (0, $7f1d8365b696a16b$export$c1cec34af06bcf7)(mergedChildren);
    var originRef = canRef ? (0, $7f1d8365b696a16b$export$7465e5c0bf44f19a)(mergedChildren) : null;
    var mergedRef = (0, $7f1d8365b696a16b$export$1d1c999670a1285d)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $faa9bc51eaaa34e5$export$2e2bcd8739ae039)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(elementRef.current) === 'object' ? (0, $faa9bc51eaaa34e5$export$2e2bcd8739ae039)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $faa9bc51eaaa34e5$export$2e2bcd8739ae039)(wrapperRef.current);
    };
    $ltGt3.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $ltGt3.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $ltGt3.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $ltGt3.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $c1166f2bb3f3fd7c$export$d1203567a167490e)(currentElement, onInternalResize);
        return function() {
            return (0, $c1166f2bb3f3fd7c$export$23a2283368c55ea2)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $ltGt3.createElement((0, $76a6d2d8e24ad05a$export$2e2bcd8739ae039), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $ltGt3.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $e1de416c1dd7cecb$var$RefSingleObserver = /*#__PURE__*/ $ltGt3.forwardRef($e1de416c1dd7cecb$var$SingleObserver);
var $e1de416c1dd7cecb$export$2e2bcd8739ae039 = $e1de416c1dd7cecb$var$RefSingleObserver;




var $c0ae8c1f3442c045$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $c0ae8c1f3442c045$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === 'function' ? [
        children
    ] : (0, $a81d8b97e944e43c$export$2e2bcd8739ae039)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($c0ae8c1f3442c045$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $ltGt3.createElement((0, $e1de416c1dd7cecb$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $c0ae8c1f3442c045$var$RefResizeObserver = /*#__PURE__*/ $ltGt3.forwardRef($c0ae8c1f3442c045$var$ResizeObserver);
$c0ae8c1f3442c045$var$RefResizeObserver.Collection = (0, $13c878cace4a1582$export$fb8073518f34e6ec);
var $c0ae8c1f3442c045$export$2e2bcd8739ae039 = $c0ae8c1f3442c045$var$RefResizeObserver;







var $ltGt3 = parcelRequire("ltGt3");


var $f783d438a1d00cfc$var$_excluded = [
    "prefixCls",
    "invalidate",
    "item",
    "renderItem",
    "responsive",
    "responsiveDisabled",
    "registerSize",
    "itemKey",
    "className",
    "style",
    "children",
    "display",
    "order",
    "component"
];
// Use shared variable to save bundle size
var $f783d438a1d00cfc$var$UNDEFINED = undefined;
function $f783d438a1d00cfc$var$InternalItem(props, ref) {
    var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey = props.itemKey, className = props.className, style = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, restProps = (0, $289081aecb178230$export$2e2bcd8739ae039)(props, $f783d438a1d00cfc$var$_excluded);
    var mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $ltGt3.useEffect(function() {
        return function() {
            internalRegisterSize(null);
        };
    }, []);
    // ================================ Render ================================
    var childNode = renderItem && item !== $f783d438a1d00cfc$var$UNDEFINED ? renderItem(item, {
        index: order
    }) : children;
    var overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $f783d438a1d00cfc$var$UNDEFINED,
        overflowY: mergedHidden ? 'hidden' : $f783d438a1d00cfc$var$UNDEFINED,
        order: responsive ? order : $f783d438a1d00cfc$var$UNDEFINED,
        pointerEvents: mergedHidden ? 'none' : $f783d438a1d00cfc$var$UNDEFINED,
        position: mergedHidden ? 'absolute' : $f783d438a1d00cfc$var$UNDEFINED
    };
    var overflowProps = {};
    if (mergedHidden) overflowProps['aria-hidden'] = true;
    var itemNode = /*#__PURE__*/ $ltGt3.createElement(Component, (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(!invalidate && prefixCls, className),
        style: (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, overflowStyle), style)
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $ltGt3.createElement((0, $c0ae8c1f3442c045$export$2e2bcd8739ae039), {
        onResize: function onResize(_ref) {
            var offsetWidth = _ref.offsetWidth;
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
var $f783d438a1d00cfc$var$Item = /*#__PURE__*/ $ltGt3.forwardRef($f783d438a1d00cfc$var$InternalItem);
$f783d438a1d00cfc$var$Item.displayName = 'Item';
var $f783d438a1d00cfc$export$2e2bcd8739ae039 = $f783d438a1d00cfc$var$Item;





var $ltGt3 = parcelRequire("ltGt3");

var $58a270f25a81b367$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $58a270f25a81b367$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $58a270f25a81b367$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $58a270f25a81b367$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $58a270f25a81b367$var$rafUUID = 0;
var $58a270f25a81b367$var$rafIds = new Map();
function $58a270f25a81b367$var$cleanup(id) {
    $58a270f25a81b367$var$rafIds.delete(id);
}
var $58a270f25a81b367$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $58a270f25a81b367$var$rafUUID += 1;
    var id = $58a270f25a81b367$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $58a270f25a81b367$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $58a270f25a81b367$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $58a270f25a81b367$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$58a270f25a81b367$var$wrapperRaf.cancel = function(id) {
    var realId = $58a270f25a81b367$var$rafIds.get(id);
    $58a270f25a81b367$var$cleanup(id);
    return $58a270f25a81b367$var$caf(realId);
};
var $58a270f25a81b367$export$2e2bcd8739ae039 = $58a270f25a81b367$var$wrapperRaf;


function $d918c8071b92277b$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === 'undefined') (0, $58a270f25a81b367$export$2e2bcd8739ae039)(callback);
    else {
        var channel = new MessageChannel();
        channel.port1.onmessage = function() {
            return callback();
        };
        channel.port2.postMessage(undefined);
    }
}


function $7a83ef9803fbe825$export$eedf51fe9d751c7a() {
    // Updater Trigger
    var updateFuncRef = $ltGt3.useRef(null);
    // Notify update
    var notifyEffectUpdate = function notifyEffectUpdate(callback) {
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $d918c8071b92277b$export$2e2bcd8739ae039)(function() {
                (0, $35c0fb1a856c78db$exports.unstable_batchedUpdates)(function() {
                    updateFuncRef.current.forEach(function(fn) {
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $7a83ef9803fbe825$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    var _React$useState = $ltGt3.useState(defaultValue), _React$useState2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
    // Set State
    var setEffectVal = (0, $a7f17bc7a54333b8$export$2e2bcd8739ae039)(function(nextValue) {
        notifyEffectUpdate(function() {
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}





var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
var $97ecb6559d0a309b$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createContext(null);


var $42a5b62ab20c0fe8$var$_excluded = [
    "component"
], $42a5b62ab20c0fe8$var$_excluded2 = [
    "className"
], $42a5b62ab20c0fe8$var$_excluded3 = [
    "className"
];
var $42a5b62ab20c0fe8$var$InternalRawItem = function InternalRawItem(props, ref) {
    var context = $ltGt3.useContext((0, $97ecb6559d0a309b$export$79f16dd643143c25));
    // Render directly when context not provided
    if (!context) {
        var _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _restProps = (0, $289081aecb178230$export$2e2bcd8739ae039)(props, $42a5b62ab20c0fe8$var$_excluded);
        return /*#__PURE__*/ $ltGt3.createElement(Component, (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, _restProps, {
            ref: ref
        }));
    }
    var contextClassName = context.className, restContext = (0, $289081aecb178230$export$2e2bcd8739ae039)(context, $42a5b62ab20c0fe8$var$_excluded2);
    var className = props.className, restProps = (0, $289081aecb178230$export$2e2bcd8739ae039)(props, $42a5b62ab20c0fe8$var$_excluded3);
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $ltGt3.createElement((0, $97ecb6559d0a309b$export$79f16dd643143c25).Provider, {
        value: null
    }, /*#__PURE__*/ $ltGt3.createElement((0, $f783d438a1d00cfc$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(contextClassName, className)
    }, restContext, restProps)));
};
var $42a5b62ab20c0fe8$var$RawItem = /*#__PURE__*/ $ltGt3.forwardRef($42a5b62ab20c0fe8$var$InternalRawItem);
$42a5b62ab20c0fe8$var$RawItem.displayName = 'RawItem';
var $42a5b62ab20c0fe8$export$2e2bcd8739ae039 = $42a5b62ab20c0fe8$var$RawItem;



var $15d23127e28d8dfb$var$_excluded = [
    "prefixCls",
    "data",
    "renderItem",
    "renderRawItem",
    "itemKey",
    "itemWidth",
    "ssr",
    "style",
    "className",
    "maxCount",
    "renderRest",
    "renderRawRest",
    "prefix",
    "suffix",
    "component",
    "itemComponent",
    "onVisibleChange"
];
var $15d23127e28d8dfb$var$RESPONSIVE = 'responsive';
var $15d23127e28d8dfb$var$INVALIDATE = 'invalidate';
function $15d23127e28d8dfb$var$defaultRenderRest(omittedItems) {
    return "+ ".concat(omittedItems.length, " ...");
}
function $15d23127e28d8dfb$var$Overflow(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-overflow' : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style = props.style, className = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, prefix = props.prefix, suffix = props.suffix, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = (0, $289081aecb178230$export$2e2bcd8739ae039)(props, $15d23127e28d8dfb$var$_excluded);
    var fullySSR = ssr === 'full';
    var notifyEffectUpdate = (0, $7a83ef9803fbe825$export$eedf51fe9d751c7a)();
    var _useEffectState = (0, $7a83ef9803fbe825$export$2e2bcd8739ae039)(notifyEffectUpdate, null), _useEffectState2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
    var mergedContainerWidth = containerWidth || 0;
    var _useEffectState3 = (0, $7a83ef9803fbe825$export$2e2bcd8739ae039)(notifyEffectUpdate, new Map()), _useEffectState4 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
    var _useEffectState5 = (0, $7a83ef9803fbe825$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState6 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
    var _useEffectState7 = (0, $7a83ef9803fbe825$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState8 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
    var _useEffectState9 = (0, $7a83ef9803fbe825$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState10 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useEffectState9, 2), prefixWidth = _useEffectState10[0], setPrefixWidth = _useEffectState10[1];
    var _useEffectState11 = (0, $7a83ef9803fbe825$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState12 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useEffectState11, 2), suffixWidth = _useEffectState12[0], setSuffixWidth = _useEffectState12[1];
    var _useState = (0, $ltGt3.useState)(null), _useState2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
    var _useState3 = (0, $ltGt3.useState)(null), _useState4 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
    var mergedDisplayCount = $ltGt3.useMemo(function() {
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    var _useState5 = (0, $ltGt3.useState)(false), _useState6 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
    var itemPrefixCls = "".concat(prefixCls, "-item");
    // Always use the max width to avoid blink
    var mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    var isResponsive = maxCount === $15d23127e28d8dfb$var$RESPONSIVE;
    var shouldResponsive = data.length && isResponsive;
    var invalidate = maxCount === $15d23127e28d8dfb$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ var showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
    var mergedData = (0, $ltGt3.useMemo)(function() {
        var items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === 'number') items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    var omittedItems = (0, $ltGt3.useMemo)(function() {
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    var getKey = (0, $ltGt3.useCallback)(function(item, index) {
        var _ref;
        if (typeof itemKey === 'function') return itemKey(item);
        return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
    }, [
        itemKey
    ]);
    var mergedRenderItem = (0, $ltGt3.useCallback)(renderItem || function(item) {
        return item;
    }, [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths(function(origin) {
            var clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerPrefixSize(_, width) {
        setPrefixWidth(width);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $956f158068638b56$export$2e2bcd8739ae039)(function() {
        if (mergedContainerWidth && typeof mergedRestWidth === 'number' && mergedData) {
            var totalWidth = prefixWidth + suffixWidth;
            var len = mergedData.length;
            var lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(var i = 0; i < len; i += 1){
                var currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        prefixWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    var displayRest = restReady && !!omittedItems.length;
    var suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: 'absolute',
        left: suffixFixedStart,
        top: 0
    };
    var itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    var internalRenderItemNode = renderRawItem ? function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $ltGt3.createElement((0, $97ecb6559d0a309b$export$79f16dd643143c25).Provider, {
            key: key,
            value: (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, itemSharedProps), {}, {
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            })
        }, renderRawItem(item, index));
    } : function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $ltGt3.createElement((0, $f783d438a1d00cfc$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    var restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
    };
    var mergedRenderRest = renderRest || $15d23127e28d8dfb$var$defaultRenderRest;
    var restNode = renderRawRest ? /*#__PURE__*/ $ltGt3.createElement((0, $97ecb6559d0a309b$export$79f16dd643143c25).Provider, {
        value: (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems)) : /*#__PURE__*/ $ltGt3.createElement((0, $f783d438a1d00cfc$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
    var overflowNode = /*#__PURE__*/ $ltGt3.createElement(Component, (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), prefix && /*#__PURE__*/ $ltGt3.createElement((0, $f783d438a1d00cfc$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: -1,
        className: "".concat(itemPrefixCls, "-prefix"),
        registerSize: registerPrefixSize,
        display: true
    }), prefix), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $ltGt3.createElement((0, $f783d438a1d00cfc$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: "".concat(itemPrefixCls, "-suffix"),
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    return isResponsive ? /*#__PURE__*/ $ltGt3.createElement((0, $c0ae8c1f3442c045$export$2e2bcd8739ae039), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode) : overflowNode;
}
var $15d23127e28d8dfb$var$ForwardOverflow = /*#__PURE__*/ $ltGt3.forwardRef($15d23127e28d8dfb$var$Overflow);
$15d23127e28d8dfb$var$ForwardOverflow.displayName = 'Overflow';
$15d23127e28d8dfb$var$ForwardOverflow.Item = (0, $42a5b62ab20c0fe8$export$2e2bcd8739ae039);
$15d23127e28d8dfb$var$ForwardOverflow.RESPONSIVE = $15d23127e28d8dfb$var$RESPONSIVE;
$15d23127e28d8dfb$var$ForwardOverflow.INVALIDATE = $15d23127e28d8dfb$var$INVALIDATE;
var // Convert to generic type
$15d23127e28d8dfb$export$2e2bcd8739ae039 = $15d23127e28d8dfb$var$ForwardOverflow;


var $a8c8240385950b5a$export$2e2bcd8739ae039 = (0, $15d23127e28d8dfb$export$2e2bcd8739ae039);







var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
const $99b999b7ded2fe5d$export$26537912ea160acd = /*#__PURE__*/ $ltGt3.createContext(null);
function $99b999b7ded2fe5d$export$80c871fe8d6b896(uuid, eventKey) {
    return `${uuid}-${eventKey}`;
}
function $99b999b7ded2fe5d$export$a276eb4e9be640f8(eventKey) {
    const id = $ltGt3.useContext($99b999b7ded2fe5d$export$26537912ea160acd);
    return $99b999b7ded2fe5d$export$80c871fe8d6b896(id, eventKey);
}



var $ltGt3 = parcelRequire("ltGt3");


const $45b26eb36dafba06$export$c7e742effb1c51e2 = /*#__PURE__*/ $ltGt3.createContext(null);
function $45b26eb36dafba06$var$mergeProps(origin, target) {
    const clone = {
        ...origin
    };
    Object.keys(target).forEach((key)=>{
        const value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function $45b26eb36dafba06$export$2e2bcd8739ae039({ children: children, locked: locked, ...restProps }) {
    const context = $ltGt3.useContext($45b26eb36dafba06$export$c7e742effb1c51e2);
    const inheritableContext = (0, $dcca1fcd5fa22f3b$export$2e2bcd8739ae039)(()=>$45b26eb36dafba06$var$mergeProps(context, restProps), [
        context,
        restProps
    ], (prev, next)=>!locked && (prev[0] !== next[0] || !(0, $003c57daacb79f0c$export$2e2bcd8739ae039)(prev[1], next[1], true)));
    return /*#__PURE__*/ $ltGt3.createElement($45b26eb36dafba06$export$c7e742effb1c51e2.Provider, {
        value: inheritableContext
    }, children);
}



var $ltGt3 = parcelRequire("ltGt3");
const $c620ec0876f76e52$var$EmptyList = [];
const $c620ec0876f76e52$export$d9ffb5bfd108b003 = /*#__PURE__*/ $ltGt3.createContext(null);
function $c620ec0876f76e52$export$e295b0c537d32d7d() {
    return $ltGt3.useContext($c620ec0876f76e52$export$d9ffb5bfd108b003);
}
const $c620ec0876f76e52$export$54d9e16aa4c8a7fa = /*#__PURE__*/ $ltGt3.createContext($c620ec0876f76e52$var$EmptyList);
function $c620ec0876f76e52$export$d3d2d0a05677870a(eventKey) {
    const parentKeyPath = $ltGt3.useContext($c620ec0876f76e52$export$54d9e16aa4c8a7fa);
    return $ltGt3.useMemo(()=>eventKey !== undefined ? [
            ...parentKeyPath,
            eventKey
        ] : parentKeyPath, [
        parentKeyPath,
        eventKey
    ]);
}
const $c620ec0876f76e52$export$f0b9e0db98edfa53 = /*#__PURE__*/ $ltGt3.createContext(null);



var $ltGt3 = parcelRequire("ltGt3");
const $208abd1532956dce$var$PrivateContext = /*#__PURE__*/ $ltGt3.createContext({});
var $208abd1532956dce$export$2e2bcd8739ae039 = $208abd1532956dce$var$PrivateContext;






var $ltGt3 = parcelRequire("ltGt3");

// destruct to reduce minify size
const { LEFT: $fb04bab5484466c5$var$LEFT, RIGHT: $fb04bab5484466c5$var$RIGHT, UP: $fb04bab5484466c5$var$UP, DOWN: $fb04bab5484466c5$var$DOWN, ENTER: $fb04bab5484466c5$var$ENTER, ESC: $fb04bab5484466c5$var$ESC, HOME: $fb04bab5484466c5$var$HOME, END: $fb04bab5484466c5$var$END } = (0, $b0616a5421b43292$export$2e2bcd8739ae039);
const $fb04bab5484466c5$var$ArrowKeys = [
    $fb04bab5484466c5$var$UP,
    $fb04bab5484466c5$var$DOWN,
    $fb04bab5484466c5$var$LEFT,
    $fb04bab5484466c5$var$RIGHT
];
function $fb04bab5484466c5$var$getOffset(mode, isRootLevel, isRtl, which) {
    const prev = 'prev';
    const next = 'next';
    const children = 'children';
    const parent = 'parent';
    // Inline enter is special that we use unique operation
    if (mode === 'inline' && which === $fb04bab5484466c5$var$ENTER) return {
        inlineTrigger: true
    };
    const inline = {
        [$fb04bab5484466c5$var$UP]: prev,
        [$fb04bab5484466c5$var$DOWN]: next
    };
    const horizontal = {
        [$fb04bab5484466c5$var$LEFT]: isRtl ? next : prev,
        [$fb04bab5484466c5$var$RIGHT]: isRtl ? prev : next,
        [$fb04bab5484466c5$var$DOWN]: children,
        [$fb04bab5484466c5$var$ENTER]: children
    };
    const vertical = {
        [$fb04bab5484466c5$var$UP]: prev,
        [$fb04bab5484466c5$var$DOWN]: next,
        [$fb04bab5484466c5$var$ENTER]: children,
        [$fb04bab5484466c5$var$ESC]: parent,
        [$fb04bab5484466c5$var$LEFT]: isRtl ? children : parent,
        [$fb04bab5484466c5$var$RIGHT]: isRtl ? parent : children
    };
    const offsets = {
        inline: inline,
        horizontal: horizontal,
        vertical: vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    const type = offsets[`${mode}${isRootLevel ? '' : 'Sub'}`]?.[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function $fb04bab5484466c5$var$findContainerUL(element) {
    let current = element;
    while(current){
        if (current.getAttribute('data-menu-list')) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function $fb04bab5484466c5$var$getFocusElement(activeElement, elements) {
    let current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
function $fb04bab5484466c5$export$433aaa1f216cf32d(container, elements) {
    const list = (0, $2dfb8bf1ce337715$export$bbc7b5f11aba534b)(container, true);
    return list.filter((ele)=>elements.has(ele));
}
function $fb04bab5484466c5$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offset = 1) {
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    const sameLevelFocusableMenuElementList = $fb04bab5484466c5$export$433aaa1f216cf32d(parentQueryContainer, elements);
    // Find next focus index
    const count = sameLevelFocusableMenuElementList.length;
    let focusIndex = sameLevelFocusableMenuElementList.findIndex((ele)=>focusMenuElement === ele);
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
const $fb04bab5484466c5$export$20827b68c762d23 = (keys, id)=>{
    const elements = new Set();
    const key2element = new Map();
    const element2key = new Map();
    keys.forEach((key)=>{
        const element = document.querySelector(`[data-menu-id='${(0, $99b999b7ded2fe5d$export$80c871fe8d6b896)(id, key)}']`);
        if (element) {
            elements.add(element);
            element2key.set(element, key);
            key2element.set(key, element);
        }
    });
    return {
        elements: elements,
        key2element: key2element,
        element2key: element2key
    };
};
function $fb04bab5484466c5$export$aa6de64279d64603(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    const rafRef = $ltGt3.useRef();
    const activeRef = $ltGt3.useRef();
    activeRef.current = activeKey;
    const cleanRaf = ()=>{
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(rafRef.current);
    };
    $ltGt3.useEffect(()=>()=>{
            cleanRaf();
        }, []);
    return (e)=>{
        const { which: which } = e;
        if ([
            ...$fb04bab5484466c5$var$ArrowKeys,
            $fb04bab5484466c5$var$ENTER,
            $fb04bab5484466c5$var$ESC,
            $fb04bab5484466c5$var$HOME,
            $fb04bab5484466c5$var$END
        ].includes(which)) {
            const keys = getKeys();
            let refreshedElements = $fb04bab5484466c5$export$20827b68c762d23(keys, id);
            const { elements: elements, key2element: key2element, element2key: element2key } = refreshedElements;
            // First we should find current focused MenuItem/SubMenu element
            const activeElement = key2element.get(activeKey);
            const focusMenuElement = $fb04bab5484466c5$var$getFocusElement(activeElement, elements);
            const focusMenuKey = element2key.get(focusMenuElement);
            const offsetObj = $fb04bab5484466c5$var$getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== $fb04bab5484466c5$var$HOME && which !== $fb04bab5484466c5$var$END) return;
            // Arrow prevent default to avoid page scroll
            if ($fb04bab5484466c5$var$ArrowKeys.includes(which) || [
                $fb04bab5484466c5$var$HOME,
                $fb04bab5484466c5$var$END
            ].includes(which)) e.preventDefault();
            const tryFocus = (menuElement)=>{
                if (menuElement) {
                    let focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    const link = menuElement.querySelector('a');
                    if (link?.getAttribute('href')) focusTargetElement = link;
                    const targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                $fb04bab5484466c5$var$HOME,
                $fb04bab5484466c5$var$END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                let parentQueryContainer;
                if (!focusMenuElement || mode === 'inline') parentQueryContainer = containerRef.current;
                else parentQueryContainer = $fb04bab5484466c5$var$findContainerUL(focusMenuElement);
                // Get next focus element
                let targetElement;
                const focusableElements = $fb04bab5484466c5$export$433aaa1f216cf32d(parentQueryContainer, elements);
                if (which === $fb04bab5484466c5$var$HOME) targetElement = focusableElements[0];
                else if (which === $fb04bab5484466c5$var$END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = $fb04bab5484466c5$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
                    // Async should resync elements
                    refreshedElements = $fb04bab5484466c5$export$20827b68c762d23(keys, id);
                    const controlId = focusMenuElement.getAttribute('aria-controls');
                    const subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    const targetElement = $fb04bab5484466c5$var$getNextFocusElement(subQueryContainer, refreshedElements.elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                const keyPath = getKeyPath(focusMenuKey, true);
                const parentKey = keyPath[keyPath.length - 2];
                const parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown?.(e);
    };
}



var $ltGt3 = parcelRequire("ltGt3");

function $f84998707613039a$export$7693db51ef834b40(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}


const $15579ef20361b65b$var$PATH_SPLIT = '__RC_UTIL_PATH_SPLIT__';
const $15579ef20361b65b$var$getPathStr = (keyPath)=>keyPath.join($15579ef20361b65b$var$PATH_SPLIT);
const $15579ef20361b65b$var$getPathKeys = (keyPathStr)=>keyPathStr.split($15579ef20361b65b$var$PATH_SPLIT);
const $15579ef20361b65b$export$20a0132c46ce5b04 = 'rc-menu-more';
function $15579ef20361b65b$export$2e2bcd8739ae039() {
    const [, internalForceUpdate] = $ltGt3.useState({});
    const key2pathRef = (0, $ltGt3.useRef)(new Map());
    const path2keyRef = (0, $ltGt3.useRef)(new Map());
    const [overflowKeys, setOverflowKeys] = $ltGt3.useState([]);
    const updateRef = (0, $ltGt3.useRef)(0);
    const destroyRef = (0, $ltGt3.useRef)(false);
    const forceUpdate = ()=>{
        if (!destroyRef.current) internalForceUpdate({});
    };
    const registerPath = (0, $ltGt3.useCallback)((key, keyPath)=>{
        // Fill map
        const connectedPath = $15579ef20361b65b$var$getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        const id = updateRef.current;
        (0, $f84998707613039a$export$7693db51ef834b40)(()=>{
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    const unregisterPath = (0, $ltGt3.useCallback)((key, keyPath)=>{
        const connectedPath = $15579ef20361b65b$var$getPathStr(keyPath);
        path2keyRef.current.delete(connectedPath);
        key2pathRef.current.delete(key);
    }, []);
    const refreshOverflowKeys = (0, $ltGt3.useCallback)((keys)=>{
        setOverflowKeys(keys);
    }, []);
    const getKeyPath = (0, $ltGt3.useCallback)((eventKey, includeOverflow)=>{
        const fullPath = key2pathRef.current.get(eventKey) || '';
        const keys = $15579ef20361b65b$var$getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift($15579ef20361b65b$export$20a0132c46ce5b04);
        return keys;
    }, [
        overflowKeys
    ]);
    const isSubPathKey = (0, $ltGt3.useCallback)((pathKeys, eventKey)=>pathKeys.filter((item)=>item !== undefined).some((pathKey)=>{
            const pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        }), [
        getKeyPath
    ]);
    const getKeys = ()=>{
        const keys = [
            ...key2pathRef.current.keys()
        ];
        if (overflowKeys.length) keys.push($15579ef20361b65b$export$20a0132c46ce5b04);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ const getSubPathKeys = (0, $ltGt3.useCallback)((key)=>{
        const connectedPath = `${key2pathRef.current.get(key)}${$15579ef20361b65b$var$PATH_SPLIT}`;
        const pathKeys = new Set();
        [
            ...path2keyRef.current.keys()
        ].forEach((pathKey)=>{
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    $ltGt3.useEffect(()=>()=>{
            destroyRef.current = true;
        }, []);
    return {
        registerPath: // Register
        registerPath,
        unregisterPath: unregisterPath,
        refreshOverflowKeys: refreshOverflowKeys,
        isSubPathKey: // Util
        isSubPathKey,
        getKeyPath: getKeyPath,
        getKeys: getKeys,
        getSubPathKeys: getSubPathKeys
    };
}



var $ltGt3 = parcelRequire("ltGt3");
function $b0d03a0b1c810026$export$2e2bcd8739ae039(func) {
    const funRef = $ltGt3.useRef(func);
    funRef.current = func;
    const callback = $ltGt3.useCallback((...args)=>funRef.current?.(...args), []);
    return func ? callback : undefined;
}









var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");

function $2c47aad0dcee034e$export$2e2bcd8739ae039(eventKey, disabled, onMouseEnter, onMouseLeave) {
    const { activeKey: // Active
    activeKey, onActive: onActive, onInactive: onInactive } = $ltGt3.useContext((0, $45b26eb36dafba06$export$c7e742effb1c51e2));
    const ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = (domEvent)=>{
            onMouseEnter?.({
                key: eventKey,
                domEvent: domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = (domEvent)=>{
            onMouseLeave?.({
                key: eventKey,
                domEvent: domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}



var $ltGt3 = parcelRequire("ltGt3");

function $cd61efd936c37d58$export$2e2bcd8739ae039(level) {
    const { mode: mode, rtl: rtl, inlineIndent: inlineIndent } = $ltGt3.useContext((0, $45b26eb36dafba06$export$c7e742effb1c51e2));
    if (mode !== 'inline') return null;
    const len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}



var $ltGt3 = parcelRequire("ltGt3");
function $ce2b9da0469452a8$export$2e2bcd8739ae039({ icon: icon, props: props, children: children }) {
    let iconNode;
    if (icon === null || icon === false) return null;
    if (typeof icon === 'function') iconNode = /*#__PURE__*/ $ltGt3.createElement(icon, {
        ...props
    });
    else if (typeof icon !== "boolean") // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}



function $ba7e2ad089916409$export$e189bcd94b66c1db({ item: item, ...restInfo }) {
    Object.defineProperty(restInfo, 'item', {
        get: ()=>{
            (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, '`info.item` is deprecated since we will move to function component that not provides React Node instance in future.');
            return item;
        }
    });
    return restInfo;
}


function $12413d0256c31ec0$var$_extends() {
    $12413d0256c31ec0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $12413d0256c31ec0$var$_extends.apply(this, arguments);
}
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
class $12413d0256c31ec0$var$LegacyMenuItem extends $ltGt3.Component {
    render() {
        const { title: title, attribute: attribute, elementRef: elementRef, ...restProps } = this.props;
        // Here the props are eventually passed to the DOM element.
        // React does not recognize non-standard attributes.
        // Therefore, remove the props that is not used here.
        // ref: https://github.com/ant-design/ant-design/issues/41395
        const passedProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(restProps, [
            'eventKey',
            'popupClassName',
            'popupOffset',
            'onTitleClick'
        ]);
        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!attribute, '`attribute` of Menu.Item is deprecated. Please pass attribute directly.');
        return /*#__PURE__*/ $ltGt3.createElement((0, $a8c8240385950b5a$export$2e2bcd8739ae039).Item, $12413d0256c31ec0$var$_extends({}, attribute, {
            title: typeof title === 'string' ? title : undefined
        }, passedProps, {
            ref: elementRef
        }));
    }
}
/**
 * Real Menu Item component
 */ const $12413d0256c31ec0$var$InternalMenuItem = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { style: style, className: className, eventKey: eventKey, warnKey: warnKey, disabled: disabled, itemIcon: itemIcon, children: children, role: // Aria
    role, onMouseEnter: // Active
    onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, ...restProps } = props;
    const domDataId = (0, $99b999b7ded2fe5d$export$a276eb4e9be640f8)(eventKey);
    const { prefixCls: prefixCls, onItemClick: onItemClick, disabled: contextDisabled, overflowDisabled: overflowDisabled, // Icon
    itemIcon: contextItemIcon, selectedKeys: // Select
    selectedKeys, onActive: // Active
    onActive } = $ltGt3.useContext((0, $45b26eb36dafba06$export$c7e742effb1c51e2));
    const { _internalRenderMenuItem: _internalRenderMenuItem } = $ltGt3.useContext((0, $208abd1532956dce$export$2e2bcd8739ae039));
    const itemCls = `${prefixCls}-item`;
    const legacyMenuItemRef = $ltGt3.useRef();
    const elementRef = $ltGt3.useRef();
    const mergedDisabled = contextDisabled || disabled;
    const mergedEleRef = (0, $22ff46e28c8066e1$export$1d1c999670a1285d)(ref, elementRef);
    const connectedKeys = (0, $c620ec0876f76e52$export$d3d2d0a05677870a)(eventKey);
    // ============================= Info =============================
    const getEventInfo = (e)=>{
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: [
                ...connectedKeys
            ].reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e
        };
    };
    // ============================= Icon =============================
    const mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    const { active: active, ...activeProps } = (0, $2c47aad0dcee034e$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave);
    // ============================ Select ============================
    const selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    const directionStyle = (0, $cd61efd936c37d58$export$2e2bcd8739ae039)(connectedKeys.length);
    // ============================ Events ============================
    const onInternalClick = (e)=>{
        if (mergedDisabled) return;
        const info = getEventInfo(e);
        onClick?.((0, $ba7e2ad089916409$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    };
    const onInternalKeyDown = (e)=>{
        onKeyDown?.(e);
        if (e.which === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER) {
            const info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick?.((0, $ba7e2ad089916409$export$e189bcd94b66c1db)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ const onInternalFocus = (e)=>{
        onActive(eventKey);
        onFocus?.(e);
    };
    // ============================ Render ============================
    const optionRoleProps = {};
    if (props.role === 'option') optionRoleProps['aria-selected'] = selected;
    let renderNode = /*#__PURE__*/ $ltGt3.createElement($12413d0256c31ec0$var$LegacyMenuItem, $12413d0256c31ec0$var$_extends({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? 'none' : role || 'menuitem',
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(restProps, [
        'extra'
    ]), activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: {
            ...directionStyle,
            ...style
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(itemCls, {
            [`${itemCls}-active`]: active,
            [`${itemCls}-selected`]: selected,
            [`${itemCls}-disabled`]: mergedDisabled
        }, className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ $ltGt3.createElement((0, $ce2b9da0469452a8$export$2e2bcd8739ae039), {
        props: {
            ...props,
            isSelected: selected
        },
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected: selected
    });
    return renderNode;
});
function $12413d0256c31ec0$var$MenuItem(props, ref) {
    const { eventKey: eventKey } = props;
    // ==================== Record KeyPath ====================
    const measure = (0, $c620ec0876f76e52$export$e295b0c537d32d7d)();
    const connectedKeyPath = (0, $c620ec0876f76e52$export$d3d2d0a05677870a)(eventKey);
    // eslint-disable-next-line consistent-return
    $ltGt3.useEffect(()=>{
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return ()=>{
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ $ltGt3.createElement($12413d0256c31ec0$var$InternalMenuItem, $12413d0256c31ec0$var$_extends({}, props, {
        ref: ref
    }));
}
var $12413d0256c31ec0$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.forwardRef($12413d0256c31ec0$var$MenuItem);



var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");


function $090721863f8f7b5b$var$_extends() {
    $090721863f8f7b5b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $090721863f8f7b5b$var$_extends.apply(this, arguments);
}
const $090721863f8f7b5b$var$InternalSubMenuList = ({ className: className, children: children, ...restProps }, ref)=>{
    const { prefixCls: prefixCls, mode: mode, rtl: rtl } = $ltGt3.useContext((0, $45b26eb36dafba06$export$c7e742effb1c51e2));
    return /*#__PURE__*/ $ltGt3.createElement("ul", $090721863f8f7b5b$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prefixCls, rtl && `${prefixCls}-rtl`, `${prefixCls}-sub`, `${prefixCls}-${mode === 'inline' ? 'inline' : 'vertical'}`, className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
const $090721863f8f7b5b$var$SubMenuList = /*#__PURE__*/ $ltGt3.forwardRef($090721863f8f7b5b$var$InternalSubMenuList);
$090721863f8f7b5b$var$SubMenuList.displayName = 'SubMenuList';
var $090721863f8f7b5b$export$2e2bcd8739ae039 = $090721863f8f7b5b$var$SubMenuList;




var $ltGt3 = parcelRequire("ltGt3");
function $0e9255700a1e99fb$export$cd230e97e668be9(children, keyPath) {
    return (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children).map((child, index)=>{
        if (/*#__PURE__*/ $ltGt3.isValidElement(child)) {
            const { key: key } = child;
            let eventKey = child.props?.eventKey ?? key;
            const emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = `tmp_key-${[
                ...keyPath,
                index
            ].join('-')}`;
            const cloneProps = {
                key: eventKey,
                eventKey: eventKey
            };
            return /*#__PURE__*/ $ltGt3.cloneElement(child, cloneProps);
        }
        return child;
    });
}





var $ltGt3 = parcelRequire("ltGt3");




const $a96efe41af7ec211$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const $a96efe41af7ec211$export$803cd8101b6c182b = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    }
};
const $a96efe41af7ec211$export$e2b3f69b0a16e1f = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $a96efe41af7ec211$var$autoAdjustOverflow
    }
};
var $a96efe41af7ec211$export$2e2bcd8739ae039 = $a96efe41af7ec211$export$803cd8101b6c182b;


function $a10777504fb7fea3$export$7b8936ddc277a29a(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}


const $d310e283fcb53661$var$popupPlacementMap = {
    horizontal: 'bottomLeft',
    vertical: 'rightTop',
    'vertical-left': 'rightTop',
    'vertical-right': 'leftTop'
};
function $d310e283fcb53661$export$2e2bcd8739ae039({ prefixCls: prefixCls, visible: visible, children: children, popup: popup, popupStyle: popupStyle, popupClassName: popupClassName, popupOffset: popupOffset, disabled: disabled, mode: mode, onVisibleChange: onVisibleChange }) {
    const { getPopupContainer: getPopupContainer, rtl: rtl, subMenuOpenDelay: subMenuOpenDelay, subMenuCloseDelay: subMenuCloseDelay, builtinPlacements: builtinPlacements, triggerSubMenuAction: triggerSubMenuAction, forceSubMenuRender: forceSubMenuRender, rootClassName: rootClassName, motion: // Motion
    motion, defaultMotions: defaultMotions } = $ltGt3.useContext((0, $45b26eb36dafba06$export$c7e742effb1c51e2));
    const [innerVisible, setInnerVisible] = $ltGt3.useState(false);
    const placement = rtl ? {
        ...(0, $a96efe41af7ec211$export$e2b3f69b0a16e1f),
        ...builtinPlacements
    } : {
        ...(0, $a96efe41af7ec211$export$803cd8101b6c182b),
        ...builtinPlacements
    };
    const popupPlacement = $d310e283fcb53661$var$popupPlacementMap[mode];
    const targetMotion = (0, $a10777504fb7fea3$export$7b8936ddc277a29a)(mode, motion, defaultMotions);
    const targetMotionRef = $ltGt3.useRef(targetMotion);
    if (mode !== 'inline') /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    const mergedMotion = {
        ...targetMotionRef.current,
        leavedClassName: `${prefixCls}-hidden`,
        removeOnLeave: false,
        motionAppear: true
    };
    // Delay to change visible
    const visibleRef = $ltGt3.useRef();
    $ltGt3.useEffect(()=>{
        visibleRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
            setInnerVisible(visible);
        });
        return ()=>{
            (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $1b29c21fa1aa3a55$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-popup`, {
            [`${prefixCls}-rtl`]: rtl
        }, popupClassName, rootClassName),
        stretch: mode === 'horizontal' ? 'minWidth' : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupStyle: popupStyle,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion,
        fresh: true
    }, children);
}







var $ltGt3 = parcelRequire("ltGt3");




function $2cac279fb3f9f2b8$var$_extends() {
    $2cac279fb3f9f2b8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2cac279fb3f9f2b8$var$_extends.apply(this, arguments);
}
function $2cac279fb3f9f2b8$export$2e2bcd8739ae039({ id: id, open: open, keyPath: keyPath, children: children }) {
    const fixedMode = 'inline';
    const { prefixCls: prefixCls, forceSubMenuRender: forceSubMenuRender, motion: motion, defaultMotions: defaultMotions, mode: mode } = $ltGt3.useContext((0, $45b26eb36dafba06$export$c7e742effb1c51e2));
    // Always use latest mode check
    const sameModeRef = $ltGt3.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    const [destroy, setDestroy] = $ltGt3.useState(!sameModeRef.current);
    const mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    $ltGt3.useEffect(()=>{
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    const mergedMotion = {
        ...(0, $a10777504fb7fea3$export$7b8936ddc277a29a)(fixedMode, motion, defaultMotions)
    };
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    const originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = (newVisible)=>{
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged?.(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ $ltGt3.createElement((0, $45b26eb36dafba06$export$2e2bcd8739ae039), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), $2cac279fb3f9f2b8$var$_extends({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: `${prefixCls}-hidden`
    }), ({ className: motionClassName, style: motionStyle })=>{
        return /*#__PURE__*/ $ltGt3.createElement((0, $090721863f8f7b5b$export$2e2bcd8739ae039), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}





function $89eb96ac34878e76$var$_extends() {
    $89eb96ac34878e76$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $89eb96ac34878e76$var$_extends.apply(this, arguments);
}
const $89eb96ac34878e76$var$InternalSubMenu = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { style: style, className: className, styles: styles, classNames: menuClassNames, title: title, eventKey: eventKey, warnKey: warnKey, disabled: disabled, internalPopupClose: internalPopupClose, children: children, itemIcon: // Icons
    itemIcon, expandIcon: expandIcon, popupClassName: // Popup
    popupClassName, popupOffset: popupOffset, popupStyle: popupStyle, onClick: // Events
    onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTitleClick: onTitleClick, onTitleMouseEnter: onTitleMouseEnter, onTitleMouseLeave: onTitleMouseLeave, popupRender: propsPopupRender, ...restProps } = props;
    const domDataId = (0, $99b999b7ded2fe5d$export$a276eb4e9be640f8)(eventKey);
    const { prefixCls: prefixCls, mode: mode, openKeys: openKeys, // Disabled
    disabled: contextDisabled, overflowDisabled: overflowDisabled, activeKey: // ActiveKey
    activeKey, selectedKeys: // SelectKey
    selectedKeys, // Icon
    itemIcon: contextItemIcon, expandIcon: contextExpandIcon, onItemClick: // Events
    onItemClick, onOpenChange: onOpenChange, onActive: onActive, popupRender: contextPopupRender } = $ltGt3.useContext((0, $45b26eb36dafba06$export$c7e742effb1c51e2));
    const { _internalRenderSubMenuItem: _internalRenderSubMenuItem } = $ltGt3.useContext((0, $208abd1532956dce$export$2e2bcd8739ae039));
    const { isSubPathKey: isSubPathKey } = $ltGt3.useContext((0, $c620ec0876f76e52$export$f0b9e0db98edfa53));
    const connectedPath = (0, $c620ec0876f76e52$export$d3d2d0a05677870a)();
    const subMenuPrefixCls = `${prefixCls}-submenu`;
    const mergedDisabled = contextDisabled || disabled;
    const elementRef = $ltGt3.useRef();
    const popupRef = $ltGt3.useRef();
    // ================================ Icon ================================
    const mergedItemIcon = itemIcon ?? contextItemIcon;
    const mergedExpandIcon = expandIcon ?? contextExpandIcon;
    // ================================ Open ================================
    const originOpen = openKeys.includes(eventKey);
    const open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    const childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    const { active: active, ...activeProps } = (0, $2c47aad0dcee034e$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave);
    // Fallback of active check to avoid hover on menu title or disabled item
    const [childrenActive, setChildrenActive] = $ltGt3.useState(false);
    const triggerChildrenActive = (newActive)=>{
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    const onInternalMouseEnter = (domEvent)=>{
        triggerChildrenActive(true);
        onMouseEnter?.({
            key: eventKey,
            domEvent: domEvent
        });
    };
    const onInternalMouseLeave = (domEvent)=>{
        triggerChildrenActive(false);
        onMouseLeave?.({
            key: eventKey,
            domEvent: domEvent
        });
    };
    const mergedActive = $ltGt3.useMemo(()=>{
        if (active) return active;
        if (mode !== 'inline') return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    const directionStyle = (0, $cd61efd936c37d58$export$2e2bcd8739ae039)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    const onInternalTitleClick = (e)=>{
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick?.({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === 'inline') onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    const onMergedItemClick = (0, $b0d03a0b1c810026$export$2e2bcd8739ae039)((info)=>{
        onClick?.((0, $ba7e2ad089916409$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    const onPopupVisibleChange = (newVisible)=>{
        if (mode !== 'inline') onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ const onInternalFocus = ()=>{
        onActive(eventKey);
    };
    // =============================== Render ===============================
    const popupId = domDataId && `${domDataId}-popup`;
    const expandIconNode = $ltGt3.useMemo(()=>/*#__PURE__*/ $ltGt3.createElement((0, $ce2b9da0469452a8$export$2e2bcd8739ae039), {
            icon: mode !== 'horizontal' ? mergedExpandIcon : undefined,
            props: {
                ...props,
                isOpen: open,
                // [Legacy] Not sure why need this mark
                isSubMenu: true
            }
        }, /*#__PURE__*/ $ltGt3.createElement("i", {
            className: `${subMenuPrefixCls}-arrow`
        })), [
        mode,
        mergedExpandIcon,
        props,
        open,
        subMenuPrefixCls
    ]);
    // >>>>> Title
    let titleNode = /*#__PURE__*/ $ltGt3.createElement("div", $89eb96ac34878e76$var$_extends({
        role: "menuitem",
        style: directionStyle,
        className: `${subMenuPrefixCls}-title`,
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: typeof title === 'string' ? title : null,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, expandIconNode);
    // Cache mode if it change to `inline` which do not have popup motion
    const triggerModeRef = $ltGt3.useRef(mode);
    if (mode !== 'inline' && connectedPath.length > 1) triggerModeRef.current = 'vertical';
    else triggerModeRef.current = mode;
    const popupContentTriggerMode = triggerModeRef.current;
    const renderPopupContent = $ltGt3.useMemo(()=>{
        const originNode = /*#__PURE__*/ $ltGt3.createElement((0, $45b26eb36dafba06$export$2e2bcd8739ae039), {
            classNames: menuClassNames,
            styles: styles,
            mode: popupContentTriggerMode === 'horizontal' ? 'vertical' : popupContentTriggerMode
        }, /*#__PURE__*/ $ltGt3.createElement((0, $090721863f8f7b5b$export$2e2bcd8739ae039), {
            id: popupId,
            ref: popupRef
        }, children));
        const mergedPopupRender = propsPopupRender || contextPopupRender;
        if (mergedPopupRender) {
            const node = mergedPopupRender(originNode, {
                item: props,
                keys: connectedPath
            });
            return node;
        }
        return originNode;
    }, [
        propsPopupRender,
        contextPopupRender,
        connectedPath,
        popupId,
        children,
        props,
        popupContentTriggerMode
    ]);
    if (!overflowDisabled) {
        const triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ $ltGt3.createElement((0, $d310e283fcb53661$export$2e2bcd8739ae039), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== 'inline',
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popupStyle: popupStyle,
            popup: renderPopupContent,
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    let listNode = /*#__PURE__*/ $ltGt3.createElement((0, $a8c8240385950b5a$export$2e2bcd8739ae039).Item, $89eb96ac34878e76$var$_extends({
        ref: ref,
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(subMenuPrefixCls, `${subMenuPrefixCls}-${mode}`, className, {
            [`${subMenuPrefixCls}-open`]: open,
            [`${subMenuPrefixCls}-active`]: mergedActive,
            [`${subMenuPrefixCls}-selected`]: childrenSelected,
            [`${subMenuPrefixCls}-disabled`]: mergedDisabled
        }),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ $ltGt3.createElement((0, $2cac279fb3f9f2b8$export$2e2bcd8739ae039), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open: open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ $ltGt3.createElement((0, $45b26eb36dafba06$export$2e2bcd8739ae039), {
        classNames: menuClassNames,
        styles: styles,
        onItemClick: onMergedItemClick,
        mode: mode === 'horizontal' ? 'vertical' : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
});
const $89eb96ac34878e76$var$SubMenu = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { eventKey: eventKey, children: children } = props;
    const connectedKeyPath = (0, $c620ec0876f76e52$export$d3d2d0a05677870a)(eventKey);
    const childList = (0, $0e9255700a1e99fb$export$cd230e97e668be9)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    const measure = (0, $c620ec0876f76e52$export$e295b0c537d32d7d)();
    // eslint-disable-next-line consistent-return
    $ltGt3.useEffect(()=>{
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return ()=>{
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    let renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ $ltGt3.createElement($89eb96ac34878e76$var$InternalSubMenu, $89eb96ac34878e76$var$_extends({
        ref: ref
    }, props), childList);
    return /*#__PURE__*/ $ltGt3.createElement((0, $c620ec0876f76e52$export$54d9e16aa4c8a7fa).Provider, {
        value: connectedKeyPath
    }, renderNode);
});
var $89eb96ac34878e76$export$2e2bcd8739ae039 = $89eb96ac34878e76$var$SubMenu;



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");



function $1982b9fe98a708c6$export$2e2bcd8739ae039({ className: className, style: style }) {
    const { prefixCls: prefixCls } = $ltGt3.useContext((0, $45b26eb36dafba06$export$c7e742effb1c51e2));
    const measure = (0, $c620ec0876f76e52$export$e295b0c537d32d7d)();
    if (measure) return null;
    return /*#__PURE__*/ $ltGt3.createElement("li", {
        role: "separator",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-item-divider`, className),
        style: style
    });
}






var $ltGt3 = parcelRequire("ltGt3");



function $a2ba66be90976991$var$_extends() {
    $a2ba66be90976991$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a2ba66be90976991$var$_extends.apply(this, arguments);
}
const $a2ba66be90976991$var$InternalMenuItemGroup = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { className: className, title: title, eventKey: eventKey, children: children, ...restProps } = props;
    const { prefixCls: prefixCls, classNames: menuClassNames, styles: styles } = $ltGt3.useContext((0, $45b26eb36dafba06$export$c7e742effb1c51e2));
    const groupPrefixCls = `${prefixCls}-item-group`;
    return /*#__PURE__*/ $ltGt3.createElement("li", $a2ba66be90976991$var$_extends({
        ref: ref,
        role: "presentation"
    }, restProps, {
        onClick: (e)=>e.stopPropagation(),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(groupPrefixCls, className)
    }), /*#__PURE__*/ $ltGt3.createElement("div", {
        role: "presentation",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${groupPrefixCls}-title`, menuClassNames?.listTitle),
        style: styles?.listTitle,
        title: typeof title === 'string' ? title : undefined
    }, title), /*#__PURE__*/ $ltGt3.createElement("ul", {
        role: "group",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${groupPrefixCls}-list`, menuClassNames?.list),
        style: styles?.list
    }, children));
});
const $a2ba66be90976991$var$MenuItemGroup = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { eventKey: eventKey, children: children } = props;
    const connectedKeyPath = (0, $c620ec0876f76e52$export$d3d2d0a05677870a)(eventKey);
    const childList = (0, $0e9255700a1e99fb$export$cd230e97e668be9)(children, connectedKeyPath);
    const measure = (0, $c620ec0876f76e52$export$e295b0c537d32d7d)();
    if (measure) return childList;
    return /*#__PURE__*/ $ltGt3.createElement($a2ba66be90976991$var$InternalMenuItemGroup, $a2ba66be90976991$var$_extends({
        ref: ref
    }, (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(props, [
        'warnKey'
    ])), childList);
});
var $a2ba66be90976991$export$2e2bcd8739ae039 = $a2ba66be90976991$var$MenuItemGroup;




function $941fe2d6a7f904f7$var$_extends() {
    $941fe2d6a7f904f7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $941fe2d6a7f904f7$var$_extends.apply(this, arguments);
}
function $941fe2d6a7f904f7$var$convertItemsToNodes(list, components, prefixCls) {
    const { item: MergedMenuItem, group: MergedMenuItemGroup, submenu: MergedSubMenu, divider: MergedDivider } = components;
    return (list || []).map((opt, index)=>{
        if (opt && typeof opt === 'object') {
            const { label: label, children: children, key: key, type: type, extra: extra, ...restProps } = opt;
            const mergedKey = key ?? `tmp-${index}`;
            // MenuItemGroup & SubMenuItem
            if (children || type === 'group') {
                if (type === 'group') // Group
                return /*#__PURE__*/ $ltGt3.createElement(MergedMenuItemGroup, $941fe2d6a7f904f7$var$_extends({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $941fe2d6a7f904f7$var$convertItemsToNodes(children, components, prefixCls));
                // Sub Menu
                return /*#__PURE__*/ $ltGt3.createElement(MergedSubMenu, $941fe2d6a7f904f7$var$_extends({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $941fe2d6a7f904f7$var$convertItemsToNodes(children, components, prefixCls));
            }
            // MenuItem & Divider
            if (type === 'divider') return /*#__PURE__*/ $ltGt3.createElement(MergedDivider, $941fe2d6a7f904f7$var$_extends({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $ltGt3.createElement(MergedMenuItem, $941fe2d6a7f904f7$var$_extends({
                key: mergedKey
            }, restProps, {
                extra: extra
            }), label, (!!extra || extra === 0) && /*#__PURE__*/ $ltGt3.createElement("span", {
                className: `${prefixCls}-item-extra`
            }, extra));
        }
        return null;
    }).filter((opt)=>opt);
}
function $941fe2d6a7f904f7$export$50458dc1a9a0f894(children, items, keyPath, components, prefixCls) {
    let childNodes = children;
    const mergedComponents = {
        divider: (0, $1982b9fe98a708c6$export$2e2bcd8739ae039),
        item: (0, $12413d0256c31ec0$export$2e2bcd8739ae039),
        group: (0, $a2ba66be90976991$export$2e2bcd8739ae039),
        submenu: (0, $89eb96ac34878e76$export$2e2bcd8739ae039),
        ...components
    };
    if (items) childNodes = $941fe2d6a7f904f7$var$convertItemsToNodes(items, mergedComponents, prefixCls);
    return (0, $0e9255700a1e99fb$export$cd230e97e668be9)(childNodes, keyPath);
}



function $28f94d8707387e6d$var$_extends() {
    $28f94d8707387e6d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $28f94d8707387e6d$var$_extends.apply(this, arguments);
}
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
const $28f94d8707387e6d$var$EMPTY_LIST = [];
const $28f94d8707387e6d$var$Menu = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-menu', rootClassName: rootClassName, style: style, className: className, styles: styles, classNames: menuClassNames, tabIndex: tabIndex = 0, items: items, children: children, direction: direction, id: id, mode: // Mode
    mode = 'vertical', inlineCollapsed: inlineCollapsed, disabled: // Disabled
    disabled, disabledOverflow: disabledOverflow, subMenuOpenDelay: // Open
    subMenuOpenDelay = 0.1, subMenuCloseDelay: subMenuCloseDelay = 0.1, forceSubMenuRender: forceSubMenuRender, defaultOpenKeys: defaultOpenKeys, openKeys: openKeys, activeKey: // Active
    activeKey, defaultActiveFirst: defaultActiveFirst, selectable: // Selection
    selectable = true, multiple: multiple = false, defaultSelectedKeys: defaultSelectedKeys, selectedKeys: selectedKeys, onSelect: onSelect, onDeselect: onDeselect, inlineIndent: // Level
    inlineIndent = 24, motion: // Motion
    motion, defaultMotions: defaultMotions, triggerSubMenuAction: // Popup
    triggerSubMenuAction = 'hover', builtinPlacements: builtinPlacements, itemIcon: // Icon
    itemIcon, expandIcon: expandIcon, overflowedIndicator: overflowedIndicator = '...', overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName, getPopupContainer: // Function
    getPopupContainer, onClick: // Events
    onClick, onOpenChange: onOpenChange, onKeyDown: onKeyDown, openAnimation: // Deprecated
    openAnimation, openTransitionName: openTransitionName, _internalRenderMenuItem: // Internal
    _internalRenderMenuItem, _internalRenderSubMenuItem: _internalRenderSubMenuItem, _internalComponents: _internalComponents, popupRender: popupRender, ...restProps } = props;
    const [childList, measureChildList] = $ltGt3.useMemo(()=>[
            (0, $941fe2d6a7f904f7$export$50458dc1a9a0f894)(children, items, $28f94d8707387e6d$var$EMPTY_LIST, _internalComponents, prefixCls),
            (0, $941fe2d6a7f904f7$export$50458dc1a9a0f894)(children, items, $28f94d8707387e6d$var$EMPTY_LIST, {}, prefixCls)
        ], [
        children,
        items,
        _internalComponents
    ]);
    const [mounted, setMounted] = $ltGt3.useState(false);
    const containerRef = $ltGt3.useRef();
    const uuid = (0, $1fb03482b73301f3$export$2e2bcd8739ae039)(id ? `rc-menu-uuid-${id}` : 'rc-menu-uuid');
    const isRtl = direction === 'rtl';
    // ========================= Open =========================
    const [innerOpenKeys, setMergedOpenKeys] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultOpenKeys, openKeys);
    const mergedOpenKeys = innerOpenKeys || $28f94d8707387e6d$var$EMPTY_LIST;
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    const triggerOpenKeys = (keys, forceFlush = false)=>{
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange?.(keys);
        }
        if (forceFlush) (0, $35c0fb1a856c78db$exports.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    const [inlineCacheOpenKeys, setInlineCacheOpenKeys] = $ltGt3.useState(mergedOpenKeys);
    const mountRef = $ltGt3.useRef(false);
    // ========================= Mode =========================
    const [mergedMode, mergedInlineCollapsed] = $ltGt3.useMemo(()=>{
        if ((mode === 'inline' || mode === 'vertical') && inlineCollapsed) return [
            'vertical',
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]);
    const isInlineMode = mergedMode === 'inline';
    const [internalMode, setInternalMode] = $ltGt3.useState(mergedMode);
    const [internalInlineCollapsed, setInternalInlineCollapsed] = $ltGt3.useState(mergedInlineCollapsed);
    $ltGt3.useEffect(()=>{
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys($28f94d8707387e6d$var$EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    const [lastVisibleIndex, setLastVisibleIndex] = $ltGt3.useState(0);
    const allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== 'horizontal' || disabledOverflow;
    // Cache
    $ltGt3.useEffect(()=>{
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    $ltGt3.useEffect(()=>{
        mountRef.current = true;
        return ()=>{
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    const { registerPath: registerPath, unregisterPath: unregisterPath, refreshOverflowKeys: refreshOverflowKeys, isSubPathKey: isSubPathKey, getKeyPath: getKeyPath, getKeys: getKeys, getSubPathKeys: getSubPathKeys } = (0, $15579ef20361b65b$export$2e2bcd8739ae039)();
    const registerPathContext = $ltGt3.useMemo(()=>({
            registerPath: registerPath,
            unregisterPath: unregisterPath
        }), [
        registerPath,
        unregisterPath
    ]);
    const pathUserContext = $ltGt3.useMemo(()=>({
            isSubPathKey: isSubPathKey
        }), [
        isSubPathKey
    ]);
    $ltGt3.useEffect(()=>{
        refreshOverflowKeys(allVisible ? $28f94d8707387e6d$var$EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map((child)=>child.key));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    const [mergedActiveKey, setMergedActiveKey] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(activeKey || defaultActiveFirst && childList[0]?.key, activeKey);
    const onActive = (0, $b0d03a0b1c810026$export$2e2bcd8739ae039)((key)=>{
        setMergedActiveKey(key);
    });
    const onInactive = (0, $b0d03a0b1c810026$export$2e2bcd8739ae039)(()=>{
        setMergedActiveKey(undefined);
    });
    (0, $ltGt3.useImperativeHandle)(ref, ()=>{
        return {
            list: containerRef.current,
            focus: (options)=>{
                const keys = getKeys();
                const { elements: elements, key2element: key2element, element2key: element2key } = (0, $fb04bab5484466c5$export$20827b68c762d23)(keys, uuid);
                const focusableElements = (0, $fb04bab5484466c5$export$433aaa1f216cf32d)(containerRef.current, elements);
                let shouldFocusKey;
                if (mergedActiveKey && keys.includes(mergedActiveKey)) shouldFocusKey = mergedActiveKey;
                else shouldFocusKey = focusableElements[0] ? element2key.get(focusableElements[0]) : childList.find((node)=>!node.props.disabled)?.key;
                const elementToFocus = key2element.get(shouldFocusKey);
                if (shouldFocusKey && elementToFocus) elementToFocus?.focus?.(options);
            },
            findItem: ({ key: itemKey })=>{
                const keys = getKeys();
                const { key2element: key2element } = (0, $fb04bab5484466c5$export$20827b68c762d23)(keys, uuid);
                return key2element.get(itemKey) || null;
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    const [internalSelectKeys, setMergedSelectKeys] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultSelectedKeys || [], selectedKeys);
    const mergedSelectKeys = $ltGt3.useMemo(()=>{
        if (Array.isArray(internalSelectKeys)) return internalSelectKeys;
        if (internalSelectKeys === null || internalSelectKeys === undefined) return $28f94d8707387e6d$var$EMPTY_LIST;
        return [
            internalSelectKeys
        ];
    }, [
        internalSelectKeys
    ]);
    // >>>>> Trigger select
    const triggerSelection = (info)=>{
        if (selectable) {
            // Insert or Remove
            const { key: targetKey } = info;
            const exist = mergedSelectKeys.includes(targetKey);
            let newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter((key)=>key !== targetKey);
                else newSelectKeys = [
                    ...mergedSelectKeys,
                    targetKey
                ];
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            const selectInfo = {
                ...info,
                selectedKeys: newSelectKeys
            };
            if (exist) onDeselect?.(selectInfo);
            else onSelect?.(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== 'inline') triggerOpenKeys($28f94d8707387e6d$var$EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ const onInternalClick = (0, $b0d03a0b1c810026$export$2e2bcd8739ae039)((info)=>{
        onClick?.((0, $ba7e2ad089916409$export$e189bcd94b66c1db)(info));
        triggerSelection(info);
    });
    const onInternalOpenChange = (0, $b0d03a0b1c810026$export$2e2bcd8739ae039)((key, open)=>{
        let newOpenKeys = mergedOpenKeys.filter((k)=>k !== key);
        if (open) newOpenKeys.push(key);
        else if (internalMode !== 'inline') {
            // We need find all related popup to close
            const subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter((k)=>!subPathKeys.has(k));
        }
        if (!(0, $003c57daacb79f0c$export$2e2bcd8739ae039)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    // ==================== Accessibility =====================
    const triggerAccessibilityOpen = (key, open)=>{
        const nextOpen = open ?? !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    const onInternalKeyDown = (0, $fb04bab5484466c5$export$aa6de64279d64603)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    $ltGt3.useEffect(()=>{
        setMounted(true);
    }, []);
    // ======================= Context ========================
    const privateContext = $ltGt3.useMemo(()=>({
            _internalRenderMenuItem: _internalRenderMenuItem,
            _internalRenderSubMenuItem: _internalRenderSubMenuItem
        }), [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    const wrappedChildList = internalMode !== 'horizontal' || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map((child, index)=>/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        $ltGt3.createElement((0, $45b26eb36dafba06$export$2e2bcd8739ae039), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex,
            classNames: menuClassNames,
            styles: styles
        }, child));
    // >>>>> Container
    const container = /*#__PURE__*/ $ltGt3.createElement((0, $a8c8240385950b5a$export$2e2bcd8739ae039), $28f94d8707387e6d$var$_extends({
        id: id,
        ref: containerRef,
        prefixCls: `${prefixCls}-overflow`,
        component: "ul",
        itemComponent: (0, $12413d0256c31ec0$export$2e2bcd8739ae039),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prefixCls, `${prefixCls}-root`, `${prefixCls}-${internalMode}`, className, {
            [`${prefixCls}-inline-collapsed`]: internalInlineCollapsed,
            [`${prefixCls}-rtl`]: isRtl
        }, rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: (node)=>node,
        renderRawRest: (omitItems)=>{
            // We use origin list since wrapped list use context to prevent open
            const len = omitItems.length;
            const originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ $ltGt3.createElement((0, $89eb96ac34878e76$export$2e2bcd8739ae039), {
                eventKey: (0, $15579ef20361b65b$export$20a0132c46ce5b04),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== 'horizontal' || disabledOverflow ? (0, $a8c8240385950b5a$export$2e2bcd8739ae039).INVALIDATE : (0, $a8c8240385950b5a$export$2e2bcd8739ae039).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: (newLastIndex)=>{
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ $ltGt3.createElement((0, $208abd1532956dce$export$2e2bcd8739ae039).Provider, {
        value: privateContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $99b999b7ded2fe5d$export$26537912ea160acd).Provider, {
        value: uuid
    }, /*#__PURE__*/ $ltGt3.createElement((0, $45b26eb36dafba06$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        classNames: menuClassNames,
        styles: styles,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange,
        popupRender: popupRender
    }, /*#__PURE__*/ $ltGt3.createElement((0, $c620ec0876f76e52$export$f0b9e0db98edfa53).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ $ltGt3.createElement("div", {
        style: {
            display: 'none'
        },
        "aria-hidden": true
    }, /*#__PURE__*/ $ltGt3.createElement((0, $c620ec0876f76e52$export$d9ffb5bfd108b003).Provider, {
        value: registerPathContext
    }, measureChildList)))));
});
var $28f94d8707387e6d$export$2e2bcd8739ae039 = $28f94d8707387e6d$var$Menu;







const $ac5bef0095eb3e01$var$ExportMenu = (0, $28f94d8707387e6d$export$2e2bcd8739ae039);
$ac5bef0095eb3e01$var$ExportMenu.Item = (0, $12413d0256c31ec0$export$2e2bcd8739ae039);
$ac5bef0095eb3e01$var$ExportMenu.SubMenu = (0, $89eb96ac34878e76$export$2e2bcd8739ae039);
$ac5bef0095eb3e01$var$ExportMenu.ItemGroup = (0, $a2ba66be90976991$export$2e2bcd8739ae039);
$ac5bef0095eb3e01$var$ExportMenu.Divider = (0, $1982b9fe98a708c6$export$2e2bcd8739ae039);
var $ac5bef0095eb3e01$export$2e2bcd8739ae039 = $ac5bef0095eb3e01$var$ExportMenu;




var $ltGt3 = parcelRequire("ltGt3");


function $04986477f0a5807b$var$_extends() {
    $04986477f0a5807b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $04986477f0a5807b$var$_extends.apply(this, arguments);
}
const $04986477f0a5807b$var$OperationNode = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, id: id, tabs: tabs, locale: locale, mobile: mobile, more: moreProps = {}, style: style, className: className, editable: editable, tabBarGutter: tabBarGutter, rtl: rtl, removeAriaLabel: removeAriaLabel, onTabClick: onTabClick, getPopupContainer: getPopupContainer, popupClassName: popupClassName, popupStyle: popupStyle } = props;
    // ======================== Dropdown ========================
    const [open, setOpen] = (0, $ltGt3.useState)(false);
    const [selectedKey, setSelectedKey] = (0, $ltGt3.useState)(null);
    const { icon: moreIcon = 'More' } = moreProps;
    const popupId = `${id}-more-popup`;
    const dropdownPrefix = `${prefixCls}-dropdown`;
    const selectedItemId = selectedKey !== null ? `${popupId}-${selectedKey}` : null;
    const dropdownAriaLabel = locale?.dropdownAriaLabel;
    function onRemoveTab(event, key) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key: key,
            event: event
        });
    }
    const menu = /*#__PURE__*/ $ltGt3.createElement((0, $ac5bef0095eb3e01$export$2e2bcd8739ae039), {
        onClick: ({ key: key, domEvent: domEvent })=>{
            onTabClick(key, domEvent);
            setOpen(false);
        },
        prefixCls: `${dropdownPrefix}-menu`,
        id: popupId,
        tabIndex: -1,
        role: "listbox",
        "aria-activedescendant": selectedItemId,
        selectedKeys: [
            selectedKey
        ],
        "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : 'expanded dropdown'
    }, tabs.map((tab)=>{
        const { closable: closable, disabled: disabled, closeIcon: closeIcon, key: key, label: label } = tab;
        const removable = (0, $a49f2c3ed81bc09f$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
        return /*#__PURE__*/ $ltGt3.createElement((0, $12413d0256c31ec0$export$2e2bcd8739ae039), {
            key: key,
            id: `${popupId}-${key}`,
            role: "option",
            "aria-controls": id && `${id}-panel-${key}`,
            disabled: disabled
        }, /*#__PURE__*/ $ltGt3.createElement("span", null, label), removable && /*#__PURE__*/ $ltGt3.createElement("button", {
            type: "button",
            "aria-label": removeAriaLabel || 'remove',
            tabIndex: 0,
            className: `${dropdownPrefix}-menu-item-remove`,
            onClick: (e)=>{
                e.stopPropagation();
                onRemoveTab(e, key);
            }
        }, closeIcon || editable.removeIcon || "\xd7"));
    }));
    function selectOffset(offset) {
        const enabledTabs = tabs.filter((tab)=>!tab.disabled);
        let selectedIndex = enabledTabs.findIndex((tab)=>tab.key === selectedKey) || 0;
        const len = enabledTabs.length;
        for(let i = 0; i < len; i += 1){
            selectedIndex = (selectedIndex + offset + len) % len;
            const tab = enabledTabs[selectedIndex];
            if (!tab.disabled) {
                setSelectedKey(tab.key);
                return;
            }
        }
    }
    function onKeyDown(e) {
        const { which: which } = e;
        if (!open) {
            if ([
                (0, $b0616a5421b43292$export$2e2bcd8739ae039).DOWN,
                (0, $b0616a5421b43292$export$2e2bcd8739ae039).SPACE,
                (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER
            ].includes(which)) {
                setOpen(true);
                e.preventDefault();
            }
            return;
        }
        switch(which){
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).UP:
                selectOffset(-1);
                e.preventDefault();
                break;
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).DOWN:
                selectOffset(1);
                e.preventDefault();
                break;
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).ESC:
                setOpen(false);
                break;
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).SPACE:
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER:
                if (selectedKey !== null) onTabClick(selectedKey, e);
                break;
        }
    }
    // ========================= Effect =========================
    (0, $ltGt3.useEffect)(()=>{
        // We use query element here to avoid React strict warning
        const ele = document.getElementById(selectedItemId);
        if (ele?.scrollIntoView) ele.scrollIntoView(false);
    }, [
        selectedItemId,
        selectedKey
    ]);
    (0, $ltGt3.useEffect)(()=>{
        if (!open) setSelectedKey(null);
    }, [
        open
    ]);
    // ========================= Render =========================
    const moreStyle = {
        marginInlineStart: tabBarGutter
    };
    if (!tabs.length) {
        moreStyle.visibility = 'hidden';
        moreStyle.order = 1;
    }
    const overlayClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(popupClassName, {
        [`${dropdownPrefix}-rtl`]: rtl
    });
    const moreNode = mobile ? null : /*#__PURE__*/ $ltGt3.createElement((0, $14028894932dc2c5$export$2e2bcd8739ae039), $04986477f0a5807b$var$_extends({
        prefixCls: dropdownPrefix,
        overlay: menu,
        visible: tabs.length ? open : false,
        onVisibleChange: setOpen,
        overlayClassName: overlayClassName,
        overlayStyle: popupStyle,
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        getPopupContainer: getPopupContainer
    }, moreProps), /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        className: `${prefixCls}-nav-more`,
        style: moreStyle,
        "aria-haspopup": "listbox",
        "aria-controls": popupId,
        id: `${id}-more`,
        "aria-expanded": open,
        onKeyDown: onKeyDown
    }, moreIcon));
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-nav-operations`, className),
        style: style,
        ref: ref
    }, moreNode, /*#__PURE__*/ $ltGt3.createElement((0, $4db3af34792de2c6$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        locale: locale,
        editable: editable
    }));
});
var $04986477f0a5807b$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.memo($04986477f0a5807b$var$OperationNode, (_, next)=>// https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    next.tabMoving);




var $ltGt3 = parcelRequire("ltGt3");

const $b6782b4ec43f472e$var$TabNode = (props)=>{
    const { prefixCls: prefixCls, id: id, active: active, focus: focus, tab: { key: key, label: label, disabled: disabled, closeIcon: closeIcon, icon: icon }, closable: closable, renderWrapper: renderWrapper, removeAriaLabel: removeAriaLabel, editable: editable, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onMouseUp: onMouseUp, style: style, className: className, tabCount: tabCount, currentPosition: currentPosition } = props;
    const tabPrefix = `${prefixCls}-tab`;
    const removable = (0, $a49f2c3ed81bc09f$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
    function onInternalClick(e) {
        if (disabled) return;
        onClick(e);
    }
    function onRemoveTab(event) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key: key,
            event: event
        });
    }
    const labelNode = $ltGt3.useMemo(()=>icon && typeof label === 'string' ? /*#__PURE__*/ $ltGt3.createElement("span", null, label) : label, [
        label,
        icon
    ]);
    const btnRef = $ltGt3.useRef(null);
    $ltGt3.useEffect(()=>{
        if (focus && btnRef.current) btnRef.current.focus();
    }, [
        focus
    ]);
    const node = /*#__PURE__*/ $ltGt3.createElement("div", {
        key: key,
        "data-node-key": (0, $a49f2c3ed81bc09f$export$c55417729a96230c)(key),
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(tabPrefix, className, {
            [`${tabPrefix}-with-remove`]: removable,
            [`${tabPrefix}-active`]: active,
            [`${tabPrefix}-disabled`]: disabled,
            [`${tabPrefix}-focus`]: focus
        }),
        style: style,
        onClick: onInternalClick
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: btnRef,
        role: "tab",
        "aria-selected": active,
        id: id && `${id}-tab-${key}`,
        className: `${tabPrefix}-btn`,
        "aria-controls": id && `${id}-panel-${key}`,
        "aria-disabled": disabled,
        tabIndex: disabled ? null : active ? 0 : -1,
        onClick: (e)=>{
            e.stopPropagation();
            onInternalClick(e);
        },
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onFocus: onFocus,
        onBlur: onBlur
    }, focus && /*#__PURE__*/ $ltGt3.createElement("div", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        }
    }, `Tab ${currentPosition} of ${tabCount}`), icon && /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${tabPrefix}-icon`
    }, icon), label && labelNode), removable && /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        "aria-label": removeAriaLabel || 'remove',
        tabIndex: active ? 0 : -1,
        className: `${tabPrefix}-remove`,
        onClick: (e)=>{
            e.stopPropagation();
            onRemoveTab(e);
        }
    }, closeIcon || editable.removeIcon || "\xd7"));
    return renderWrapper ? renderWrapper(node) : node;
};
var $b6782b4ec43f472e$export$2e2bcd8739ae039 = $b6782b4ec43f472e$var$TabNode;


function $5cb545904353bdba$var$_extends() {
    $5cb545904353bdba$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5cb545904353bdba$var$_extends.apply(this, arguments);
}
const $5cb545904353bdba$var$getTabSize = (tab, containerRect)=>{
    // tabListRef
    const { offsetWidth: offsetWidth, offsetHeight: offsetHeight, offsetTop: offsetTop, offsetLeft: offsetLeft } = tab;
    const { width: width, height: height, left: left, top: top } = tab.getBoundingClientRect();
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (Math.abs(width - offsetWidth) < 1) return [
        width,
        height,
        left - containerRect.left,
        top - containerRect.top
    ];
    return [
        offsetWidth,
        offsetHeight,
        offsetLeft,
        offsetTop
    ];
};
const $5cb545904353bdba$var$getSize = (refObj)=>{
    const { offsetWidth: offsetWidth = 0, offsetHeight: offsetHeight = 0 } = refObj.current || {};
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (refObj.current) {
        const { width: width, height: height } = refObj.current.getBoundingClientRect();
        if (Math.abs(width - offsetWidth) < 1) return [
            width,
            height
        ];
    }
    return [
        offsetWidth,
        offsetHeight
    ];
};
/**
 * Convert `SizeInfo` to unit value. Such as [123, 456] with `top` position get `123`
 */ const $5cb545904353bdba$var$getUnitValue = (size, tabPositionTopOrBottom)=>{
    return size[tabPositionTopOrBottom ? 0 : 1];
};
const $5cb545904353bdba$var$TabNavList = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { className: className, style: style, id: id, animated: animated, activeKey: activeKey, rtl: rtl, extra: extra, editable: editable, locale: locale, tabPosition: tabPosition, tabBarGutter: tabBarGutter, children: children, onTabClick: onTabClick, onTabScroll: onTabScroll, indicator: indicator, classNames: tabsClassNames, styles: styles } = props;
    const { prefixCls: prefixCls, tabs: tabs } = $ltGt3.useContext((0, $57d8810d7e9dcee6$export$2e2bcd8739ae039));
    const containerRef = (0, $ltGt3.useRef)(null);
    const extraLeftRef = (0, $ltGt3.useRef)(null);
    const extraRightRef = (0, $ltGt3.useRef)(null);
    const tabsWrapperRef = (0, $ltGt3.useRef)(null);
    const tabListRef = (0, $ltGt3.useRef)(null);
    const operationsRef = (0, $ltGt3.useRef)(null);
    const innerAddButtonRef = (0, $ltGt3.useRef)(null);
    const tabPositionTopOrBottom = tabPosition === 'top' || tabPosition === 'bottom';
    const [transformLeft, setTransformLeft] = (0, $a1d1757bfe60887a$export$2e2bcd8739ae039)(0, (next, prev)=>{
        if (tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? 'left' : 'right'
        });
    });
    const [transformTop, setTransformTop] = (0, $a1d1757bfe60887a$export$2e2bcd8739ae039)(0, (next, prev)=>{
        if (!tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? 'top' : 'bottom'
        });
    });
    const [containerExcludeExtraSize, setContainerExcludeExtraSize] = (0, $ltGt3.useState)([
        0,
        0
    ]);
    const [tabContentSize, setTabContentSize] = (0, $ltGt3.useState)([
        0,
        0
    ]);
    const [addSize, setAddSize] = (0, $ltGt3.useState)([
        0,
        0
    ]);
    const [operationSize, setOperationSize] = (0, $ltGt3.useState)([
        0,
        0
    ]);
    const [tabSizes, setTabSizes] = (0, $ef8644fe96249ce0$export$aefd2a30eb6d999e)(new Map());
    const tabOffsets = (0, $f5c4e662aab62140$export$2e2bcd8739ae039)(tabs, tabSizes, tabContentSize[0]);
    // ========================== Unit =========================
    const containerExcludeExtraSizeValue = $5cb545904353bdba$var$getUnitValue(containerExcludeExtraSize, tabPositionTopOrBottom);
    const tabContentSizeValue = $5cb545904353bdba$var$getUnitValue(tabContentSize, tabPositionTopOrBottom);
    const addSizeValue = $5cb545904353bdba$var$getUnitValue(addSize, tabPositionTopOrBottom);
    const operationSizeValue = $5cb545904353bdba$var$getUnitValue(operationSize, tabPositionTopOrBottom);
    const needScroll = Math.floor(containerExcludeExtraSizeValue) < Math.floor(tabContentSizeValue + addSizeValue);
    const visibleTabContentValue = needScroll ? containerExcludeExtraSizeValue - operationSizeValue : containerExcludeExtraSizeValue - addSizeValue;
    // ========================== Util =========================
    const operationsHiddenClassName = `${prefixCls}-nav-operations-hidden`;
    let transformMin = 0;
    let transformMax = 0;
    if (!tabPositionTopOrBottom) {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    } else if (rtl) {
        transformMin = 0;
        transformMax = Math.max(0, tabContentSizeValue - visibleTabContentValue);
    } else {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    }
    function alignInRange(value) {
        if (value < transformMin) return transformMin;
        if (value > transformMax) return transformMax;
        return value;
    }
    // ========================= Mobile ========================
    const touchMovingRef = (0, $ltGt3.useRef)(null);
    const [lockAnimation, setLockAnimation] = (0, $ltGt3.useState)();
    function doLockAnimation() {
        setLockAnimation(Date.now());
    }
    function clearTouchMoving() {
        if (touchMovingRef.current) clearTimeout(touchMovingRef.current);
    }
    (0, $28a5d16eaccae07e$export$2e2bcd8739ae039)(tabsWrapperRef, (offsetX, offsetY)=>{
        function doMove(setState, offset) {
            setState((value)=>{
                const newValue = alignInRange(value + offset);
                return newValue;
            });
        }
        // Skip scroll if place is enough
        if (!needScroll) return false;
        if (tabPositionTopOrBottom) doMove(setTransformLeft, offsetX);
        else doMove(setTransformTop, offsetY);
        clearTouchMoving();
        doLockAnimation();
        return true;
    });
    (0, $ltGt3.useEffect)(()=>{
        clearTouchMoving();
        if (lockAnimation) touchMovingRef.current = setTimeout(()=>{
            setLockAnimation(0);
        }, 100);
        return clearTouchMoving;
    }, [
        lockAnimation
    ]);
    // ===================== Visible Range =====================
    // Render tab node & collect tab offset
    const [visibleStart, visibleEnd] = (0, $fe42cb7928856538$export$2e2bcd8739ae039)(tabOffsets, // Container
    visibleTabContentValue, // Transform
    tabPositionTopOrBottom ? transformLeft : transformTop, // Tabs
    tabContentSizeValue, // Add
    addSizeValue, // Operation
    operationSizeValue, {
        ...props,
        tabs: tabs
    });
    // ========================= Scroll ========================
    const scrollToTab = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((key = activeKey)=>{
        const tabOffset = tabOffsets.get(key) || {
            width: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0
        };
        if (tabPositionTopOrBottom) {
            // ============ Align with top & bottom ============
            let newTransform = transformLeft;
            // RTL
            if (rtl) {
                if (tabOffset.right < transformLeft) newTransform = tabOffset.right;
                else if (tabOffset.right + tabOffset.width > transformLeft + visibleTabContentValue) newTransform = tabOffset.right + tabOffset.width - visibleTabContentValue;
            } else if (tabOffset.left < -transformLeft) newTransform = -tabOffset.left;
            else if (tabOffset.left + tabOffset.width > -transformLeft + visibleTabContentValue) newTransform = -(tabOffset.left + tabOffset.width - visibleTabContentValue);
            setTransformTop(0);
            setTransformLeft(alignInRange(newTransform));
        } else {
            // ============ Align with left & right ============
            let newTransform = transformTop;
            if (tabOffset.top < -transformTop) newTransform = -tabOffset.top;
            else if (tabOffset.top + tabOffset.height > -transformTop + visibleTabContentValue) newTransform = -(tabOffset.top + tabOffset.height - visibleTabContentValue);
            setTransformLeft(0);
            setTransformTop(alignInRange(newTransform));
        }
    });
    // ========================= Focus =========================
    const [focusKey, setFocusKey] = (0, $ltGt3.useState)();
    const [isMouse, setIsMouse] = (0, $ltGt3.useState)(false);
    const enabledTabs = tabs.filter((tab)=>!tab.disabled).map((tab)=>tab.key);
    const onOffset = (offset)=>{
        const currentIndex = enabledTabs.indexOf(focusKey || activeKey);
        const len = enabledTabs.length;
        const nextIndex = (currentIndex + offset + len) % len;
        const newKey = enabledTabs[nextIndex];
        setFocusKey(newKey);
    };
    const handleRemoveTab = (removalTabKey, e)=>{
        const removeIndex = enabledTabs.indexOf(removalTabKey);
        const removeTab = tabs.find((tab)=>tab.key === removalTabKey);
        const removable = (0, $a49f2c3ed81bc09f$export$eab31ca11b8b073)(removeTab?.closable, removeTab?.closeIcon, editable, removeTab?.disabled);
        if (removable) {
            e.preventDefault();
            e.stopPropagation();
            editable.onEdit('remove', {
                key: removalTabKey,
                event: e
            });
            // when remove last tab, focus previous tab
            if (removeIndex === enabledTabs.length - 1) onOffset(-1);
            else onOffset(1);
        }
    };
    const handleMouseDown = (key, e)=>{
        setIsMouse(true);
        // Middle mouse button
        if (e.button === 1) handleRemoveTab(key, e);
    };
    const handleKeyDown = (e)=>{
        const { code: code } = e;
        const isRTL = rtl && tabPositionTopOrBottom;
        const firstEnabledTab = enabledTabs[0];
        const lastEnabledTab = enabledTabs[enabledTabs.length - 1];
        switch(code){
            // LEFT
            case 'ArrowLeft':
                if (tabPositionTopOrBottom) onOffset(isRTL ? 1 : -1);
                break;
            // RIGHT
            case 'ArrowRight':
                if (tabPositionTopOrBottom) onOffset(isRTL ? -1 : 1);
                break;
            // UP
            case 'ArrowUp':
                e.preventDefault();
                if (!tabPositionTopOrBottom) onOffset(-1);
                break;
            // DOWN
            case 'ArrowDown':
                e.preventDefault();
                if (!tabPositionTopOrBottom) onOffset(1);
                break;
            // HOME
            case 'Home':
                e.preventDefault();
                setFocusKey(firstEnabledTab);
                break;
            // END
            case 'End':
                e.preventDefault();
                setFocusKey(lastEnabledTab);
                break;
            // Enter & Space
            case 'Enter':
            case 'Space':
                e.preventDefault();
                onTabClick(focusKey ?? activeKey, e);
                break;
            // Backspace
            case 'Backspace':
            case 'Delete':
                handleRemoveTab(focusKey, e);
                break;
        }
    };
    // ========================== Tab ==========================
    const tabNodeStyle = {};
    if (tabPositionTopOrBottom) tabNodeStyle.marginInlineStart = tabBarGutter;
    else tabNodeStyle.marginTop = tabBarGutter;
    const tabNodes = tabs.map((tab, i)=>{
        const { key: key } = tab;
        return /*#__PURE__*/ $ltGt3.createElement((0, $b6782b4ec43f472e$export$2e2bcd8739ae039), {
            id: id,
            prefixCls: prefixCls,
            key: key,
            tab: tab,
            className: tabsClassNames?.item,
            style: i === 0 ? styles?.item : {
                ...tabNodeStyle,
                ...styles?.item
            },
            closable: tab.closable,
            editable: editable,
            active: key === activeKey,
            focus: key === focusKey,
            renderWrapper: children,
            removeAriaLabel: locale?.removeAriaLabel,
            tabCount: enabledTabs.length,
            currentPosition: i + 1,
            onClick: (e)=>{
                onTabClick(key, e);
            },
            onKeyDown: handleKeyDown,
            onFocus: ()=>{
                if (!isMouse) setFocusKey(key);
                scrollToTab(key);
                doLockAnimation();
                if (!tabsWrapperRef.current) return;
                // Focus element will make scrollLeft change which we should reset back
                if (!rtl) tabsWrapperRef.current.scrollLeft = 0;
                tabsWrapperRef.current.scrollTop = 0;
            },
            onBlur: ()=>{
                setFocusKey(undefined);
            },
            onMouseDown: (e)=>handleMouseDown(key, e),
            onMouseUp: ()=>{
                setIsMouse(false);
            }
        });
    });
    // Update buttons records
    const updateTabSizes = ()=>setTabSizes(()=>{
            const newSizes = new Map();
            const listRect = tabListRef.current?.getBoundingClientRect();
            tabs.forEach(({ key: key })=>{
                const btnNode = tabListRef.current?.querySelector(`[data-node-key="${(0, $a49f2c3ed81bc09f$export$c55417729a96230c)(key)}"]`);
                if (btnNode) {
                    const [width, height, left, top] = $5cb545904353bdba$var$getTabSize(btnNode, listRect);
                    newSizes.set(key, {
                        width: width,
                        height: height,
                        left: left,
                        top: top
                    });
                }
            });
            return newSizes;
        });
    (0, $ltGt3.useEffect)(()=>{
        updateTabSizes();
    }, [
        tabs.map((tab)=>tab.key).join('_')
    ]);
    const onListHolderResize = (0, $ef8644fe96249ce0$export$2e2bcd8739ae039)(()=>{
        // Update wrapper records
        const containerSize = $5cb545904353bdba$var$getSize(containerRef);
        const extraLeftSize = $5cb545904353bdba$var$getSize(extraLeftRef);
        const extraRightSize = $5cb545904353bdba$var$getSize(extraRightRef);
        setContainerExcludeExtraSize([
            containerSize[0] - extraLeftSize[0] - extraRightSize[0],
            containerSize[1] - extraLeftSize[1] - extraRightSize[1]
        ]);
        const newAddSize = $5cb545904353bdba$var$getSize(innerAddButtonRef);
        setAddSize(newAddSize);
        const newOperationSize = $5cb545904353bdba$var$getSize(operationsRef);
        setOperationSize(newOperationSize);
        // Which includes add button size
        const tabContentFullSize = $5cb545904353bdba$var$getSize(tabListRef);
        setTabContentSize([
            tabContentFullSize[0] - newAddSize[0],
            tabContentFullSize[1] - newAddSize[1]
        ]);
        // Update buttons records
        updateTabSizes();
    });
    // ======================== Dropdown =======================
    const startHiddenTabs = tabs.slice(0, visibleStart);
    const endHiddenTabs = tabs.slice(visibleEnd + 1);
    const hiddenTabs = [
        ...startHiddenTabs,
        ...endHiddenTabs
    ];
    // =================== Link & Operations ===================
    const activeTabOffset = tabOffsets.get(activeKey);
    const { style: indicatorStyle } = (0, $b8ddb59731357800$export$2e2bcd8739ae039)({
        activeTabOffset: activeTabOffset,
        horizontal: tabPositionTopOrBottom,
        indicator: indicator,
        rtl: rtl
    });
    // ========================= Effect ========================
    (0, $ltGt3.useEffect)(()=>{
        scrollToTab();
    }, [
        activeKey,
        transformMin,
        transformMax,
        (0, $a49f2c3ed81bc09f$export$fac44ee5b035f737)(activeTabOffset),
        (0, $a49f2c3ed81bc09f$export$fac44ee5b035f737)(tabOffsets),
        tabPositionTopOrBottom
    ]);
    // Should recalculate when rtl changed
    (0, $ltGt3.useEffect)(()=>{
        onListHolderResize();
    // eslint-disable-next-line
    }, [
        rtl
    ]);
    // ========================= Render ========================
    const hasDropdown = !!hiddenTabs.length;
    const wrapPrefix = `${prefixCls}-nav-wrap`;
    let pingLeft;
    let pingRight;
    let pingTop;
    let pingBottom;
    if (tabPositionTopOrBottom) {
        if (rtl) {
            pingRight = transformLeft > 0;
            pingLeft = transformLeft !== transformMax;
        } else {
            pingLeft = transformLeft < 0;
            pingRight = transformLeft !== transformMin;
        }
    } else {
        pingTop = transformTop < 0;
        pingBottom = transformTop !== transformMin;
    }
    return /*#__PURE__*/ $ltGt3.createElement((0, $9ed13185b45d829d$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: (0, $22ff46e28c8066e1$export$1d1c999670a1285d)(ref, containerRef),
        role: "tablist",
        "aria-orientation": tabPositionTopOrBottom ? 'horizontal' : 'vertical',
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-nav`, className, tabsClassNames?.header),
        style: {
            ...styles?.header,
            ...style
        },
        onKeyDown: ()=>{
            // No need animation when use keyboard
            doLockAnimation();
        }
    }, /*#__PURE__*/ $ltGt3.createElement((0, $78cf86ca41636a29$export$2e2bcd8739ae039), {
        ref: extraLeftRef,
        position: "left",
        extra: extra,
        prefixCls: prefixCls
    }), /*#__PURE__*/ $ltGt3.createElement((0, $9ed13185b45d829d$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(wrapPrefix, {
            [`${wrapPrefix}-ping-left`]: pingLeft,
            [`${wrapPrefix}-ping-right`]: pingRight,
            [`${wrapPrefix}-ping-top`]: pingTop,
            [`${wrapPrefix}-ping-bottom`]: pingBottom
        }),
        ref: tabsWrapperRef
    }, /*#__PURE__*/ $ltGt3.createElement((0, $9ed13185b45d829d$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: tabListRef,
        className: `${prefixCls}-nav-list`,
        style: {
            transform: `translate(${transformLeft}px, ${transformTop}px)`,
            transition: lockAnimation ? 'none' : undefined
        }
    }, tabNodes, /*#__PURE__*/ $ltGt3.createElement((0, $4db3af34792de2c6$export$2e2bcd8739ae039), {
        ref: innerAddButtonRef,
        prefixCls: prefixCls,
        locale: locale,
        editable: editable,
        style: {
            ...tabNodes.length === 0 ? undefined : tabNodeStyle,
            visibility: hasDropdown ? 'hidden' : null
        }
    }), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-ink-bar`, tabsClassNames?.indicator, {
            [`${prefixCls}-ink-bar-animated`]: animated.inkBar
        }),
        style: {
            ...indicatorStyle,
            ...styles?.indicator
        }
    }))))), /*#__PURE__*/ $ltGt3.createElement((0, $04986477f0a5807b$export$2e2bcd8739ae039), $5cb545904353bdba$var$_extends({}, props, {
        removeAriaLabel: locale?.removeAriaLabel,
        ref: operationsRef,
        prefixCls: prefixCls,
        tabs: hiddenTabs,
        className: !hasDropdown && operationsHiddenClassName,
        popupStyle: styles?.popup,
        tabMoving: !!lockAnimation
    })), /*#__PURE__*/ $ltGt3.createElement((0, $78cf86ca41636a29$export$2e2bcd8739ae039), {
        ref: extraRightRef,
        position: "right",
        extra: extra,
        prefixCls: prefixCls
    })));
/* eslint-enable */ });
var $5cb545904353bdba$export$2e2bcd8739ae039 = $5cb545904353bdba$var$TabNavList;


// We have to create a TabNavList components.
const $c1bc7c085b0b3005$var$TabNavListWrapper = ({ renderTabBar: renderTabBar, ...restProps })=>{
    if (renderTabBar) return renderTabBar(restProps, (0, $5cb545904353bdba$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $ltGt3.createElement((0, $5cb545904353bdba$export$2e2bcd8739ae039), restProps);
};
var $c1bc7c085b0b3005$export$2e2bcd8739ae039 = $c1bc7c085b0b3005$var$TabNavListWrapper;





var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
const $8e05701b5c4ca5f5$var$TabPane = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, id: id, active: active, tabKey: tabKey, children: children } = props;
    const hasContent = $ltGt3.Children.count(children) > 0;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        id: id && `${id}-panel-${tabKey}`,
        role: "tabpanel",
        tabIndex: active && hasContent ? 0 : -1,
        "aria-labelledby": id && `${id}-tab-${tabKey}`,
        "aria-hidden": !active,
        style: style,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, active && `${prefixCls}-active`, className),
        ref: ref
    }, children);
});
var $8e05701b5c4ca5f5$export$2e2bcd8739ae039 = $8e05701b5c4ca5f5$var$TabPane;


function $e17bfb860ead58f3$var$_extends() {
    $e17bfb860ead58f3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e17bfb860ead58f3$var$_extends.apply(this, arguments);
}
const $e17bfb860ead58f3$var$TabPanelList = (props)=>{
    const { id: id, activeKey: activeKey, animated: animated, tabPosition: tabPosition, destroyOnHidden: destroyOnHidden, contentStyle: contentStyle, contentClassName: contentClassName } = props;
    const { prefixCls: prefixCls, tabs: tabs } = $ltGt3.useContext((0, $57d8810d7e9dcee6$export$2e2bcd8739ae039));
    const tabPaneAnimated = animated.tabPane;
    const tabPanePrefixCls = `${prefixCls}-tabpane`;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-content-holder`)
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-content`, `${prefixCls}-content-${tabPosition}`, {
            [`${prefixCls}-content-animated`]: tabPaneAnimated
        })
    }, tabs.map((item)=>{
        const { key: key, forceRender: forceRender, style: paneStyle, className: paneClassName, destroyOnHidden: itemDestroyOnHidden, ...restTabProps } = item;
        const active = key === activeKey;
        return /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), $e17bfb860ead58f3$var$_extends({
            key: key,
            visible: active,
            forceRender: forceRender,
            removeOnLeave: !!(destroyOnHidden ?? itemDestroyOnHidden),
            leavedClassName: `${tabPanePrefixCls}-hidden`
        }, animated.tabPaneMotion), ({ style: motionStyle, className: motionClassName }, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $8e05701b5c4ca5f5$export$2e2bcd8739ae039), $e17bfb860ead58f3$var$_extends({}, restTabProps, {
                prefixCls: tabPanePrefixCls,
                id: id,
                tabKey: key,
                animated: tabPaneAnimated,
                active: active,
                style: {
                    ...contentStyle,
                    ...paneStyle,
                    ...motionStyle
                },
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(contentClassName, paneClassName, motionClassName),
                ref: ref
            })));
    })));
};
var $e17bfb860ead58f3$export$2e2bcd8739ae039 = $e17bfb860ead58f3$var$TabPanelList;



function $254445916eaa6a96$export$2e2bcd8739ae039(animated = {
    inkBar: true,
    tabPane: false
}) {
    let mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: false
    };
    else mergedAnimated = {
        inkBar: true,
        ...typeof animated === 'object' ? animated : {}
    };
    // Enable tabPane animation if provide motion
    if (mergedAnimated.tabPaneMotion && mergedAnimated.tabPane === undefined) mergedAnimated.tabPane = true;
    if (!mergedAnimated.tabPaneMotion && mergedAnimated.tabPane) mergedAnimated.tabPane = false;
    return mergedAnimated;
}


function $e30fe062ef6f01cf$var$_extends() {
    $e30fe062ef6f01cf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e30fe062ef6f01cf$var$_extends.apply(this, arguments);
}
/**
 * Should added antd:
 * - type
 *
 * Removed:
 * - onNextClick
 * - onPrevClick
 * - keyboard
 */ // Used for accessibility
let $e30fe062ef6f01cf$var$uuid = 0;
const $e30fe062ef6f01cf$var$Tabs = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { id: id, prefixCls: prefixCls = 'rc-tabs', className: className, items: items, direction: direction, activeKey: activeKey, defaultActiveKey: defaultActiveKey, editable: editable, animated: animated, tabPosition: tabPosition = 'top', tabBarGutter: tabBarGutter, tabBarStyle: tabBarStyle, tabBarExtraContent: tabBarExtraContent, locale: locale, more: more, destroyOnHidden: destroyOnHidden, renderTabBar: renderTabBar, onChange: onChange, onTabClick: onTabClick, onTabScroll: onTabScroll, getPopupContainer: getPopupContainer, popupClassName: popupClassName, indicator: indicator, classNames: tabsClassNames, styles: styles, ...restProps } = props;
    const tabs = $ltGt3.useMemo(()=>(items || []).filter((item)=>item && typeof item === 'object' && 'key' in item), [
        items
    ]);
    const rtl = direction === 'rtl';
    const mergedAnimated = (0, $254445916eaa6a96$export$2e2bcd8739ae039)(animated);
    // ======================== Mobile ========================
    const [mobile, setMobile] = (0, $ltGt3.useState)(false);
    (0, $ltGt3.useEffect)(()=>{
        // Only update on the client side
        setMobile((0, $34be7dad9a9027c0$export$2e2bcd8739ae039)());
    }, []);
    // ====================== Active Key ======================
    const [mergedActiveKey, setMergedActiveKey] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultActiveKey ?? tabs[0]?.key, activeKey);
    const [activeIndex, setActiveIndex] = (0, $ltGt3.useState)(()=>tabs.findIndex((tab)=>tab.key === mergedActiveKey));
    // Reset active key if not exist anymore
    (0, $ltGt3.useEffect)(()=>{
        let newActiveIndex = tabs.findIndex((tab)=>tab.key === mergedActiveKey);
        if (newActiveIndex === -1) {
            newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
            setMergedActiveKey(tabs[newActiveIndex]?.key);
        }
        setActiveIndex(newActiveIndex);
    }, [
        tabs.map((tab)=>tab.key).join('_'),
        mergedActiveKey,
        activeIndex
    ]);
    // ===================== Accessibility ====================
    const [mergedId, setMergedId] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(null, id);
    // Async generate id to avoid ssr mapping failed
    (0, $ltGt3.useEffect)(()=>{
        if (!id) {
            setMergedId(`rc-tabs-${$e30fe062ef6f01cf$var$uuid}`);
            $e30fe062ef6f01cf$var$uuid += 1;
        }
    }, []);
    // ======================== Events ========================
    function onInternalTabClick(key, e) {
        onTabClick?.(key, e);
        const isActiveChanged = key !== mergedActiveKey;
        setMergedActiveKey(key);
        if (isActiveChanged) onChange?.(key);
    }
    // ======================== Render ========================
    const sharedProps = {
        id: mergedId,
        activeKey: mergedActiveKey,
        animated: mergedAnimated,
        tabPosition: tabPosition,
        rtl: rtl,
        mobile: mobile
    };
    const tabNavBarProps = {
        ...sharedProps,
        editable: editable,
        locale: locale,
        more: more,
        tabBarGutter: tabBarGutter,
        onTabClick: onInternalTabClick,
        onTabScroll: onTabScroll,
        extra: tabBarExtraContent,
        style: tabBarStyle,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(popupClassName, tabsClassNames?.popup),
        indicator: indicator,
        styles: styles,
        classNames: tabsClassNames
    };
    const memoizedValue = $ltGt3.useMemo(()=>{
        return {
            tabs: tabs,
            prefixCls: prefixCls
        };
    }, [
        tabs,
        prefixCls
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $57d8810d7e9dcee6$export$2e2bcd8739ae039).Provider, {
        value: memoizedValue
    }, /*#__PURE__*/ $ltGt3.createElement("div", $e30fe062ef6f01cf$var$_extends({
        ref: ref,
        id: id,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${tabPosition}`, {
            [`${prefixCls}-mobile`]: mobile,
            [`${prefixCls}-editable`]: editable,
            [`${prefixCls}-rtl`]: rtl
        }, className)
    }, restProps), /*#__PURE__*/ $ltGt3.createElement((0, $c1bc7c085b0b3005$export$2e2bcd8739ae039), $e30fe062ef6f01cf$var$_extends({}, tabNavBarProps, {
        renderTabBar: renderTabBar
    })), /*#__PURE__*/ $ltGt3.createElement((0, $e17bfb860ead58f3$export$2e2bcd8739ae039), $e30fe062ef6f01cf$var$_extends({
        destroyOnHidden: destroyOnHidden
    }, sharedProps, {
        contentStyle: styles?.content,
        contentClassName: tabsClassNames?.content,
        animated: mergedAnimated
    }))));
});
var $e30fe062ef6f01cf$export$2e2bcd8739ae039 = $e30fe062ef6f01cf$var$Tabs;


var $47cdc91da93164c4$export$2e2bcd8739ae039 = (0, $e30fe062ef6f01cf$export$2e2bcd8739ae039);










const $0ce51141321b505c$var$motion = {
    motionAppear: false,
    motionEnter: true,
    motionLeave: true
};
function $0ce51141321b505c$export$2e2bcd8739ae039(prefixCls, animated = {
    inkBar: true,
    tabPane: false
}) {
    let mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: true
    };
    else mergedAnimated = {
        inkBar: true,
        ...typeof animated === 'object' ? animated : {}
    };
    if (mergedAnimated.tabPane) mergedAnimated.tabPaneMotion = {
        ...$0ce51141321b505c$var$motion,
        motionName: (0, $32c4c593a0d4aef5$export$27c72201b1d09951)(prefixCls, 'switch')
    };
    return mergedAnimated;
}



var $ltGt3 = parcelRequire("ltGt3");


function $2ebbb9bf8a9235b9$var$filter(items) {
    return items.filter((item)=>item);
}
function $2ebbb9bf8a9235b9$var$useLegacyItems(items, children) {
    if (items) return items.map((item)=>({
            ...item,
            destroyOnHidden: item.destroyOnHidden ?? item.destroyInactiveTabPane
        }));
    const childrenItems = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children).map((node)=>{
        if (/*#__PURE__*/ $ltGt3.isValidElement(node)) {
            const { key: key, props: props } = node;
            const { tab: tab, ...restProps } = props || {};
            const item = {
                key: String(key),
                ...restProps,
                label: tab
            };
            return item;
        }
        return null;
    });
    return $2ebbb9bf8a9235b9$var$filter(childrenItems);
}
var $2ebbb9bf8a9235b9$export$2e2bcd8739ae039 = $2ebbb9bf8a9235b9$var$useLegacyItems;







const $e613b8e902d5a10c$export$e801b802b037de6a = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antSlideUpIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $e613b8e902d5a10c$export$f40f41df328ebc38 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antSlideUpOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $e613b8e902d5a10c$export$dd9f089fa5e819fe = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antSlideDownIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    }
});
const $e613b8e902d5a10c$export$f7243fdb9c27c3b7 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antSlideDownOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    }
});
const $e613b8e902d5a10c$export$2ad3a07c3513a54 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antSlideLeftIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $e613b8e902d5a10c$export$486fbda27512d5a9 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antSlideLeftOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $e613b8e902d5a10c$export$dd03ad46dbbcd7e0 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antSlideRightIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    }
});
const $e613b8e902d5a10c$export$db8e3c9b93664f34 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antSlideRightOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    }
});
const $e613b8e902d5a10c$var$slideMotion = {
    'slide-up': {
        inKeyframes: $e613b8e902d5a10c$export$e801b802b037de6a,
        outKeyframes: $e613b8e902d5a10c$export$f40f41df328ebc38
    },
    'slide-down': {
        inKeyframes: $e613b8e902d5a10c$export$dd9f089fa5e819fe,
        outKeyframes: $e613b8e902d5a10c$export$f7243fdb9c27c3b7
    },
    'slide-left': {
        inKeyframes: $e613b8e902d5a10c$export$2ad3a07c3513a54,
        outKeyframes: $e613b8e902d5a10c$export$486fbda27512d5a9
    },
    'slide-right': {
        inKeyframes: $e613b8e902d5a10c$export$dd03ad46dbbcd7e0,
        outKeyframes: $e613b8e902d5a10c$export$db8e3c9b93664f34
    }
};
const $e613b8e902d5a10c$export$9018e60daecf7a6c = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $e613b8e902d5a10c$var$slideMotion[motionName];
    return [
        (0, $ce8f91b8b06c1cd8$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
                transform: 'scale(0)',
                transformOrigin: '0% 0%',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutQuint,
                '&-prepare': {
                    transform: 'scale(1)'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInQuint
            }
        }
    ];
};


const $9a256bbf4696eebb$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    return [
        {
            [componentCls]: {
                [`${componentCls}-switch`]: {
                    '&-appear, &-enter': {
                        transition: 'none',
                        '&-start': {
                            opacity: 0
                        },
                        '&-active': {
                            opacity: 1,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    },
                    '&-leave': {
                        position: 'absolute',
                        transition: 'none',
                        inset: 0,
                        '&-start': {
                            opacity: 1
                        },
                        '&-active': {
                            opacity: 0,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, $e613b8e902d5a10c$export$9018e60daecf7a6c)(token, 'slide-up'),
            (0, $e613b8e902d5a10c$export$9018e60daecf7a6c)(token, 'slide-down')
        ]
    ];
};
var $9a256bbf4696eebb$export$2e2bcd8739ae039 = $9a256bbf4696eebb$var$genMotionStyle;


const $2d68c29f53af1f84$var$genCardStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardBg: cardBg, cardGutter: cardGutter, colorBorderSecondary: colorBorderSecondary, itemSelectedColor: itemSelectedColor } = token;
    return {
        [`${componentCls}-card`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: 0,
                    padding: tabsCardPadding,
                    background: cardBg,
                    border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`
                },
                [`${componentCls}-tab-active`]: {
                    color: itemSelectedColor,
                    background: token.colorBgContainer
                },
                [`${componentCls}-tab-focus:has(${componentCls}-tab-btn:focus-visible)`]: (0, $945cb0d2b7017a11$export$6539948f0a737e39)(token, -3),
                [`& ${componentCls}-tab${componentCls}-tab-focus ${componentCls}-tab-btn:focus-visible`]: {
                    outline: 'none'
                },
                [`${componentCls}-ink-bar`]: {
                    visibility: 'hidden'
                }
            },
            // ========================== Top & Bottom ==========================
            [`&${componentCls}-top, &${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(cardGutter)
                        }
                    }
                }
            },
            [`&${componentCls}-top`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderBottomColor: token.colorBgContainer
                    }
                }
            },
            [`&${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)}`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderTopColor: token.colorBgContainer
                    }
                }
            },
            // ========================== Left & Right ==========================
            [`&${componentCls}-left, &${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginTop: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(cardGutter)
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)}`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderRightColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} 0`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderLeftColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            }
        }
    };
};
const $2d68c29f53af1f84$var$genDropdownStyle = (token)=>{
    const { componentCls: componentCls, itemHoverColor: itemHoverColor, dropdownEdgeChildVerticalPadding: dropdownEdgeChildVerticalPadding } = token;
    return {
        [`${componentCls}-dropdown`]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            position: 'absolute',
            top: -9999,
            left: {
                _skip_check_: true,
                value: -9999
            },
            zIndex: token.zIndexPopup,
            display: 'block',
            '&-hidden': {
                display: 'none'
            },
            [`${componentCls}-dropdown-menu`]: {
                maxHeight: token.tabsDropdownHeight,
                margin: 0,
                padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(dropdownEdgeChildVerticalPadding)} 0`,
                overflowX: 'hidden',
                overflowY: 'auto',
                textAlign: {
                    _skip_check_: true,
                    value: 'left'
                },
                listStyleType: 'none',
                backgroundColor: token.colorBgContainer,
                backgroundClip: 'padding-box',
                borderRadius: token.borderRadiusLG,
                outline: 'none',
                boxShadow: token.boxShadowSecondary,
                '&-item': {
                    ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: token.tabsDropdownWidth,
                    margin: 0,
                    padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingXXS)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingSM)}`,
                    color: token.colorText,
                    fontWeight: 'normal',
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    cursor: 'pointer',
                    transition: `all ${token.motionDurationSlow}`,
                    '> span': {
                        flex: 1,
                        whiteSpace: 'nowrap'
                    },
                    '&-remove': {
                        flex: 'none',
                        marginLeft: {
                            _skip_check_: true,
                            value: token.marginSM
                        },
                        color: token.colorIcon,
                        fontSize: token.fontSizeSM,
                        background: 'transparent',
                        border: 0,
                        cursor: 'pointer',
                        '&:hover': {
                            color: itemHoverColor
                        }
                    },
                    '&:hover': {
                        background: token.controlItemBgHover
                    },
                    '&-disabled': {
                        '&, &:hover': {
                            color: token.colorTextDisabled,
                            background: 'transparent',
                            cursor: 'not-allowed'
                        }
                    }
                }
            }
        }
    };
};
const $2d68c29f53af1f84$var$genPositionStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, colorBorderSecondary: colorBorderSecondary, horizontalMargin: horizontalMargin, verticalItemPadding: verticalItemPadding, verticalItemMargin: verticalItemMargin, calc: calc } = token;
    return {
        // ========================== Top & Bottom ==========================
        [`${componentCls}-top, ${componentCls}-bottom`]: {
            flexDirection: 'column',
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                margin: horizontalMargin,
                '&::before': {
                    position: 'absolute',
                    right: {
                        _skip_check_: true,
                        value: 0
                    },
                    left: {
                        _skip_check_: true,
                        value: 0
                    },
                    borderBottom: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    content: "''"
                },
                [`${componentCls}-ink-bar`]: {
                    height: token.lineWidthBold,
                    '&-animated': {
                        transition: `width ${token.motionDurationSlow}, left ${token.motionDurationSlow},
            right ${token.motionDurationSlow}`
                    }
                },
                [`${componentCls}-nav-wrap`]: {
                    '&::before, &::after': {
                        top: 0,
                        bottom: 0,
                        width: token.controlHeight
                    },
                    '&::before': {
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowLeft
                    },
                    '&::after': {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowRight
                    },
                    [`&${componentCls}-nav-wrap-ping-left::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-right::after`]: {
                        opacity: 1
                    }
                }
            }
        },
        [`${componentCls}-top`]: {
            [`> ${componentCls}-nav,
        > div > ${componentCls}-nav`]: {
                '&::before': {
                    bottom: 0
                },
                [`${componentCls}-ink-bar`]: {
                    bottom: 0
                }
            }
        },
        [`${componentCls}-bottom`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                marginTop: margin,
                marginBottom: 0,
                '&::before': {
                    top: 0
                },
                [`${componentCls}-ink-bar`]: {
                    top: 0
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                order: 0
            }
        },
        // ========================== Left & Right ==========================
        [`${componentCls}-left, ${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                flexDirection: 'column',
                minWidth: calc(token.controlHeight).mul(1.25).equal(),
                // >>>>>>>>>>> Tab
                [`${componentCls}-tab`]: {
                    padding: verticalItemPadding,
                    textAlign: 'center'
                },
                [`${componentCls}-tab + ${componentCls}-tab`]: {
                    margin: verticalItemMargin
                },
                // >>>>>>>>>>> Nav
                [`${componentCls}-nav-wrap`]: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.controlHeight
                    },
                    '&::before': {
                        top: 0,
                        boxShadow: token.boxShadowTabsOverflowTop
                    },
                    '&::after': {
                        bottom: 0,
                        boxShadow: token.boxShadowTabsOverflowBottom
                    },
                    [`&${componentCls}-nav-wrap-ping-top::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-bottom::after`]: {
                        opacity: 1
                    }
                },
                // >>>>>>>>>>> Ink Bar
                [`${componentCls}-ink-bar`]: {
                    width: token.lineWidthBold,
                    '&-animated': {
                        transition: `height ${token.motionDurationSlow}, top ${token.motionDurationSlow}`
                    }
                },
                [`${componentCls}-nav-list, ${componentCls}-nav-operations`]: {
                    flex: '1 0 auto',
                    // fix safari scroll problem
                    flexDirection: 'column'
                }
            }
        },
        [`${componentCls}-left`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-ink-bar`]: {
                    right: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                marginLeft: {
                    _skip_check_: true,
                    value: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(token.lineWidth).mul(-1).equal())
                },
                borderLeft: {
                    _skip_check_: true,
                    value: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
                    paddingLeft: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        },
        [`${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                [`${componentCls}-ink-bar`]: {
                    left: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                order: 0,
                marginRight: {
                    _skip_check_: true,
                    value: calc(token.lineWidth).mul(-1).equal()
                },
                borderRight: {
                    _skip_check_: true,
                    value: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
                    paddingRight: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        }
    };
};
const $2d68c29f53af1f84$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, cardPaddingSM: cardPaddingSM, cardPaddingLG: cardPaddingLG, cardHeightSM: cardHeightSM, cardHeightLG: cardHeightLG, horizontalItemPaddingSM: horizontalItemPaddingSM, horizontalItemPaddingLG: horizontalItemPaddingLG } = token;
    return {
        // >>>>> shared
        [componentCls]: {
            '&-small': {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingSM,
                        fontSize: token.titleFontSizeSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingLG,
                        fontSize: token.titleFontSizeLG,
                        lineHeight: token.lineHeightLG
                    }
                }
            }
        },
        // >>>>> card
        [`${componentCls}-card`]: {
            // Small
            [`&${componentCls}-small`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingSM
                    },
                    [`${componentCls}-nav-add`]: {
                        minWidth: cardHeightSM,
                        minHeight: cardHeightSM
                    }
                },
                [`&${componentCls}-bottom`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadius)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadius)}`
                    }
                },
                [`&${componentCls}-top`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadius)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadius)} 0 0`
                    }
                },
                [`&${componentCls}-right`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadius)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadius)} 0`
                        }
                    }
                },
                [`&${componentCls}-left`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadius)} 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadius)}`
                        }
                    }
                }
            },
            // Large
            [`&${componentCls}-large`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingLG
                    },
                    [`${componentCls}-nav-add`]: {
                        minWidth: cardHeightLG,
                        minHeight: cardHeightLG
                    }
                }
            }
        }
    };
};
const $2d68c29f53af1f84$var$genTabStyle = (token)=>{
    const { componentCls: componentCls, itemActiveColor: itemActiveColor, itemHoverColor: itemHoverColor, iconCls: iconCls, tabsHorizontalItemMargin: tabsHorizontalItemMargin, horizontalItemPadding: horizontalItemPadding, itemSelectedColor: itemSelectedColor, itemColor: itemColor } = token;
    const tabCls = `${componentCls}-tab`;
    return {
        [tabCls]: {
            position: 'relative',
            WebkitTouchCallout: 'none',
            WebkitTapHighlightColor: 'transparent',
            display: 'inline-flex',
            alignItems: 'center',
            padding: horizontalItemPadding,
            fontSize: token.titleFontSize,
            background: 'transparent',
            border: 0,
            outline: 'none',
            cursor: 'pointer',
            color: itemColor,
            '&-btn, &-remove': {
                '&:focus:not(:focus-visible), &:active': {
                    color: itemActiveColor
                }
            },
            '&-btn': {
                outline: 'none',
                transition: `all ${token.motionDurationSlow}`,
                [`${tabCls}-icon:not(:last-child)`]: {
                    marginInlineEnd: token.marginSM
                }
            },
            '&-remove': {
                flex: 'none',
                lineHeight: 1,
                marginRight: {
                    _skip_check_: true,
                    value: token.calc(token.marginXXS).mul(-1).equal()
                },
                marginLeft: {
                    _skip_check_: true,
                    value: token.marginXS
                },
                color: token.colorIcon,
                fontSize: token.fontSizeSM,
                background: 'transparent',
                border: 'none',
                outline: 'none',
                cursor: 'pointer',
                transition: `all ${token.motionDurationSlow}`,
                '&:hover': {
                    color: token.colorTextHeading
                },
                ...(0, $945cb0d2b7017a11$export$a44db842bcb28231)(token)
            },
            '&:hover': {
                color: itemHoverColor
            },
            [`&${tabCls}-active ${tabCls}-btn`]: {
                color: itemSelectedColor
            },
            [`&${tabCls}-focus ${tabCls}-btn:focus-visible`]: (0, $945cb0d2b7017a11$export$6539948f0a737e39)(token),
            [`&${tabCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            [`&${tabCls}-disabled ${tabCls}-btn, &${tabCls}-disabled ${componentCls}-remove`]: {
                '&:focus, &:active': {
                    color: token.colorTextDisabled
                }
            },
            [`& ${tabCls}-remove ${iconCls}`]: {
                margin: 0,
                verticalAlign: 'middle'
            },
            [`${iconCls}:not(:last-child)`]: {
                marginRight: {
                    _skip_check_: true,
                    value: token.marginSM
                }
            }
        },
        [`${tabCls} + ${tabCls}`]: {
            margin: {
                _skip_check_: true,
                value: tabsHorizontalItemMargin
            }
        }
    };
};
const $2d68c29f53af1f84$var$genRtlStyle = (token)=>{
    const { componentCls: componentCls, tabsHorizontalItemMarginRTL: tabsHorizontalItemMarginRTL, iconCls: iconCls, cardGutter: cardGutter, calc: calc } = token;
    const rtlCls = `${componentCls}-rtl`;
    return {
        [rtlCls]: {
            direction: 'rtl',
            [`${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: {
                        _skip_check_: true,
                        value: tabsHorizontalItemMarginRTL
                    },
                    [`${componentCls}-tab:last-of-type`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    },
                    [iconCls]: {
                        marginRight: {
                            _skip_check_: true,
                            value: 0
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.marginSM)
                        }
                    },
                    [`${componentCls}-tab-remove`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.marginXS)
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(token.marginXXS).mul(-1).equal())
                        },
                        [iconCls]: {
                            margin: 0
                        }
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav`]: {
                    order: 1
                },
                [`> ${componentCls}-content-holder`]: {
                    order: 0
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav`]: {
                    order: 0
                },
                [`> ${componentCls}-content-holder`]: {
                    order: 1
                }
            },
            // ====================== Card ======================
            [`&${componentCls}-card${componentCls}-top, &${componentCls}-card${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: cardGutter
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    }
                }
            }
        },
        [`${componentCls}-dropdown-rtl`]: {
            direction: 'rtl'
        },
        [`${componentCls}-menu-item`]: {
            [`${componentCls}-dropdown-rtl`]: {
                textAlign: {
                    _skip_check_: true,
                    value: 'right'
                }
            }
        }
    };
};
const $2d68c29f53af1f84$var$genTabsStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardHeight: cardHeight, cardGutter: cardGutter, itemHoverColor: itemHoverColor, itemActiveColor: itemActiveColor, colorBorderSecondary: colorBorderSecondary } = token;
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            display: 'flex',
            // ========================== Navigation ==========================
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                position: 'relative',
                display: 'flex',
                flex: 'none',
                alignItems: 'center',
                [`${componentCls}-nav-wrap`]: {
                    position: 'relative',
                    display: 'flex',
                    flex: 'auto',
                    alignSelf: 'stretch',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    transform: 'translate(0)',
                    // Fix chrome render bug
                    // >>>>> Ping shadow
                    '&::before, &::after': {
                        position: 'absolute',
                        zIndex: 1,
                        opacity: 0,
                        transition: `opacity ${token.motionDurationSlow}`,
                        content: "''",
                        pointerEvents: 'none'
                    }
                },
                [`${componentCls}-nav-list`]: {
                    position: 'relative',
                    display: 'flex',
                    transition: `opacity ${token.motionDurationSlow}`
                },
                // >>>>>>>> Operations
                [`${componentCls}-nav-operations`]: {
                    display: 'flex',
                    alignSelf: 'stretch'
                },
                [`${componentCls}-nav-operations-hidden`]: {
                    position: 'absolute',
                    visibility: 'hidden',
                    pointerEvents: 'none'
                },
                [`${componentCls}-nav-more`]: {
                    position: 'relative',
                    padding: tabsCardPadding,
                    background: 'transparent',
                    border: 0,
                    color: token.colorText,
                    '&::after': {
                        position: 'absolute',
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        bottom: 0,
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.calc(token.controlHeightLG).div(8).equal(),
                        transform: 'translateY(100%)',
                        content: "''"
                    }
                },
                [`${componentCls}-nav-add`]: {
                    minWidth: cardHeight,
                    minHeight: cardHeight,
                    marginLeft: {
                        _skip_check_: true,
                        value: cardGutter
                    },
                    background: 'transparent',
                    border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    borderRadius: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
                    outline: 'none',
                    cursor: 'pointer',
                    color: token.colorText,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                    '&:hover': {
                        color: itemHoverColor
                    },
                    '&:active, &:focus:not(:focus-visible)': {
                        color: itemActiveColor
                    },
                    ...(0, $945cb0d2b7017a11$export$a44db842bcb28231)(token, -3)
                }
            },
            [`${componentCls}-extra-content`]: {
                flex: 'none'
            },
            // ============================ InkBar ============================
            [`${componentCls}-ink-bar`]: {
                position: 'absolute',
                background: token.inkBarColor,
                pointerEvents: 'none'
            },
            // ============================= Tabs =============================
            ...$2d68c29f53af1f84$var$genTabStyle(token),
            // =========================== TabPanes ===========================
            [`${componentCls}-content`]: {
                position: 'relative',
                width: '100%'
            },
            [`${componentCls}-content-holder`]: {
                flex: 'auto',
                minWidth: 0,
                minHeight: 0
            },
            [`${componentCls}-tabpane`]: {
                ...(0, $945cb0d2b7017a11$export$a44db842bcb28231)(token),
                '&-hidden': {
                    display: 'none'
                }
            }
        },
        [`${componentCls}-centered`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-nav-wrap`]: {
                    [`&:not([class*='${componentCls}-nav-wrap-ping']) > ${componentCls}-nav-list`]: {
                        margin: 'auto'
                    }
                }
            }
        }
    };
};
const $2d68c29f53af1f84$export$9ca1be8807fe0675 = (token)=>{
    const { cardHeight: cardHeight, cardHeightSM: cardHeightSM, cardHeightLG: cardHeightLG, controlHeight: controlHeight, controlHeightLG: controlHeightLG } = token;
    const mergedCardHeight = cardHeight || controlHeightLG;
    const mergedCardHeightSM = cardHeightSM || controlHeight;
    // `controlHeight` missing XL variable, so we directly write it here:
    const mergedCardHeightLG = cardHeightLG || controlHeightLG + 8;
    return {
        zIndexPopup: token.zIndexPopupBase + 50,
        cardBg: token.colorFillAlter,
        // We can not pass this as valid value,
        // Since `cardHeight` will lock nav add button height.
        cardHeight: mergedCardHeight,
        cardHeightSM: mergedCardHeightSM,
        cardHeightLG: mergedCardHeightLG,
        // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
        cardPadding: `${(mergedCardHeight - token.fontHeight) / 2 - token.lineWidth}px ${token.padding}px`,
        cardPaddingSM: `${(mergedCardHeightSM - token.fontHeight) / 2 - token.lineWidth}px ${token.paddingXS}px`,
        cardPaddingLG: `${(mergedCardHeightLG - token.fontHeightLG) / 2 - token.lineWidth}px ${token.padding}px`,
        titleFontSize: token.fontSize,
        titleFontSizeLG: token.fontSizeLG,
        titleFontSizeSM: token.fontSize,
        inkBarColor: token.colorPrimary,
        horizontalMargin: `0 0 ${token.margin}px 0`,
        horizontalItemGutter: 32,
        // Fixed Value
        // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
        horizontalItemMargin: ``,
        horizontalItemMarginRTL: ``,
        horizontalItemPadding: `${token.paddingSM}px 0`,
        horizontalItemPaddingSM: `${token.paddingXS}px 0`,
        horizontalItemPaddingLG: `${token.padding}px 0`,
        verticalItemPadding: `${token.paddingXS}px ${token.paddingLG}px`,
        verticalItemMargin: `${token.margin}px 0 0 0`,
        itemColor: token.colorText,
        itemSelectedColor: token.colorPrimary,
        itemHoverColor: token.colorPrimaryHover,
        itemActiveColor: token.colorPrimaryActive,
        cardGutter: token.marginXXS / 2
    };
};
var // ============================== Export ==============================
$2d68c29f53af1f84$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Tabs', (token)=>{
    const tabsToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
        tabsCardPadding: token.cardPadding,
        dropdownEdgeChildVerticalPadding: token.paddingXXS,
        tabsDropdownHeight: 200,
        tabsDropdownWidth: 120,
        tabsHorizontalItemMargin: `0 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.horizontalItemGutter)}`,
        tabsHorizontalItemMarginRTL: `0 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.horizontalItemGutter)}`
    });
    return [
        $2d68c29f53af1f84$var$genSizeStyle(tabsToken),
        $2d68c29f53af1f84$var$genRtlStyle(tabsToken),
        $2d68c29f53af1f84$var$genPositionStyle(tabsToken),
        $2d68c29f53af1f84$var$genDropdownStyle(tabsToken),
        $2d68c29f53af1f84$var$genCardStyle(tabsToken),
        $2d68c29f53af1f84$var$genTabsStyle(tabsToken),
        (0, $9a256bbf4696eebb$export$2e2bcd8739ae039)(tabsToken)
    ];
}, $2d68c29f53af1f84$export$9ca1be8807fe0675);


const $231d38e0bcd86d7e$var$TabPane = ()=>null;
var $231d38e0bcd86d7e$export$2e2bcd8739ae039 = $231d38e0bcd86d7e$var$TabPane;


"use client";
const $77eacb4b734e6c42$var$InternalTabs = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { type: type, className: className, rootClassName: rootClassName, size: customSize, onEdit: onEdit, hideAdd: hideAdd, centered: centered, addIcon: addIcon, removeIcon: removeIcon, moreIcon: moreIcon, more: more, popupClassName: popupClassName, children: children, items: items, animated: animated, style: style, indicatorSize: indicatorSize, indicator: indicator, classNames: classNames, styles: styles, destroyInactiveTabPane: destroyInactiveTabPane, destroyOnHidden: destroyOnHidden, tabPlacement: tabPlacement, tabPosition: tabPosition, ...restProps } = props;
    const { prefixCls: customizePrefixCls } = restProps;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('tabs');
    const { tabs: tabs } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('tabs', customizePrefixCls);
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $2d68c29f53af1f84$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const tabsRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, ()=>({
            nativeElement: tabsRef.current
        }));
    let editable;
    if (type === 'editable-card') editable = {
        onEdit: (editType, { key: key, event: event })=>{
            onEdit?.(editType === 'add' ? event : key, editType);
        },
        removeIcon: removeIcon ?? tabs?.removeIcon ?? /*#__PURE__*/ $ltGt3.createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), null),
        addIcon: (addIcon ?? tabs?.addIcon) || /*#__PURE__*/ $ltGt3.createElement((0, $44fddb3bd1473a4a$export$2e2bcd8739ae039), null),
        showAdd: hideAdd !== true
    };
    const rootPrefixCls = getPrefixCls();
    var deprecatedName, newName, item;
    const size = (0, $7bb31c172903861d$export$2e2bcd8739ae039)(customSize);
    const mergedItems = (0, $2ebbb9bf8a9235b9$export$2e2bcd8739ae039)(items, children);
    const mergedAnimated = (0, $0ce51141321b505c$export$2e2bcd8739ae039)(prefixCls, animated);
    const mergedIndicator = {
        align: indicator?.align ?? tabs?.indicator?.align,
        size: indicator?.size ?? indicatorSize ?? tabs?.indicator?.size ?? tabs?.indicatorSize
    };
    const mergedPlacement = $ltGt3.useMemo(()=>{
        const placement = tabPlacement ?? tabPosition ?? undefined;
        const isRTL = direction === 'rtl';
        switch(placement){
            case 'start':
                return isRTL ? 'right' : 'left';
            case 'end':
                return isRTL ? 'left' : 'right';
            default:
                return placement;
        }
    }, [
        tabPlacement,
        tabPosition,
        direction
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: size,
        tabPlacement: mergedPlacement,
        items: mergedItems
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        }
    });
    return /*#__PURE__*/ $ltGt3.createElement((0, $47cdc91da93164c4$export$2e2bcd8739ae039), {
        ref: tabsRef,
        direction: direction,
        getPopupContainer: getPopupContainer,
        ...restProps,
        items: mergedItems,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
            [`${prefixCls}-${size}`]: size,
            [`${prefixCls}-card`]: [
                'card',
                'editable-card'
            ].includes(type),
            [`${prefixCls}-editable-card`]: type === 'editable-card',
            [`${prefixCls}-centered`]: centered
        }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls, rootCls),
        classNames: {
            ...mergedClassNames,
            popup: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(popupClassName, hashId, cssVarCls, rootCls, mergedClassNames.popup?.root)
        },
        styles: mergedStyles,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        editable: editable,
        more: {
            icon: tabs?.more?.icon ?? tabs?.moreIcon ?? moreIcon ?? /*#__PURE__*/ $ltGt3.createElement((0, $21a25bcc3e8ef68c$export$2e2bcd8739ae039), null),
            transitionName: `${rootPrefixCls}-slide-up`,
            ...more
        },
        prefixCls: prefixCls,
        animated: mergedAnimated,
        indicator: mergedIndicator,
        destroyOnHidden: destroyOnHidden ?? destroyInactiveTabPane,
        tabPosition: mergedPlacement
    });
});
const $77eacb4b734e6c42$var$Tabs = $77eacb4b734e6c42$var$InternalTabs;
$77eacb4b734e6c42$var$Tabs.TabPane = (0, $231d38e0bcd86d7e$export$2e2bcd8739ae039);
var $77eacb4b734e6c42$export$2e2bcd8739ae039 = $77eacb4b734e6c42$var$Tabs;



var $ltGt3 = parcelRequire("ltGt3");


"use client";
const $6430631ceb7b2189$var$Grid = ({ prefixCls: prefixCls, className: className, hoverable: hoverable = true, ...props })=>{
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls('card', prefixCls);
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefix}-grid`, className, {
        [`${prefix}-grid-hoverable`]: hoverable
    });
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ...props,
        className: classString
    });
};
var $6430631ceb7b2189$export$2e2bcd8739ae039 = $6430631ceb7b2189$var$Grid;





// ============================== Styles ==============================
// ============================== Head ==============================
const $9a780d58d50e8c74$var$genCardHeadStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, headerHeight: headerHeight, headerPadding: headerPadding, tabsMarginBottom: tabsMarginBottom } = token;
    return {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        minHeight: headerHeight,
        marginBottom: -1,
        // Fix card grid overflow bug: https://gw.alipayobjects.com/zos/rmsportal/XonYxBikwpgbqIQBeuhk.png
        padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(headerPadding)}`,
        color: token.colorTextHeading,
        fontWeight: token.fontWeightStrong,
        fontSize: token.headerFontSize,
        background: token.headerBg,
        borderBottom: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`,
        borderRadius: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
        ...(0, $945cb0d2b7017a11$export$8c467e8859fdef13)(),
        '&-wrapper': {
            width: '100%',
            display: 'flex',
            alignItems: 'center'
        },
        '&-title': {
            display: 'inline-block',
            flex: 1,
            ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
            [`
          > ${componentCls}-typography,
          > ${componentCls}-typography-edit-content
        `]: {
                insetInlineStart: 0,
                marginTop: 0,
                marginBottom: 0
            }
        },
        [`${antCls}-tabs-top`]: {
            clear: 'both',
            marginBottom: tabsMarginBottom,
            color: token.colorText,
            fontWeight: 'normal',
            fontSize: token.fontSize,
            '&-bar': {
                borderBottom: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`
            }
        }
    };
};
// ============================== Grid ==============================
const $9a780d58d50e8c74$var$genCardGridStyle = (token)=>{
    const { cardPaddingBase: cardPaddingBase, colorBorderSecondary: colorBorderSecondary, cardShadow: cardShadow, lineWidth: lineWidth } = token;
    return {
        width: '33.33%',
        padding: cardPaddingBase,
        border: 0,
        borderRadius: 0,
        boxShadow: `
      ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} 0 0 0 ${colorBorderSecondary},
      0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} 0 0 0 ${colorBorderSecondary} inset,
      0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} 0 0 ${colorBorderSecondary} inset;
    `,
        transition: `all ${token.motionDurationMid}`,
        '&-hoverable:hover': {
            position: 'relative',
            zIndex: 1,
            boxShadow: cardShadow
        }
    };
};
// ============================== Actions ==============================
const $9a780d58d50e8c74$var$genCardActionsStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, actionsLiMargin: actionsLiMargin, cardActionsIconSize: cardActionsIconSize, colorBorderSecondary: colorBorderSecondary, actionsBg: actionsBg } = token;
    return {
        margin: 0,
        padding: 0,
        listStyle: 'none',
        background: actionsBg,
        borderTop: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
        display: 'flex',
        borderRadius: `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)}`,
        ...(0, $945cb0d2b7017a11$export$8c467e8859fdef13)(),
        '& > li': {
            margin: actionsLiMargin,
            color: token.colorTextDescription,
            textAlign: 'center',
            '> span': {
                position: 'relative',
                display: 'block',
                minWidth: token.calc(token.cardActionsIconSize).mul(2).equal(),
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                cursor: 'pointer',
                '&:hover': {
                    color: token.colorPrimary,
                    transition: `color ${token.motionDurationMid}`
                },
                [`a:not(${componentCls}-btn), > ${iconCls}`]: {
                    display: 'inline-block',
                    width: '100%',
                    color: token.colorIcon,
                    lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.fontHeight),
                    transition: `color ${token.motionDurationMid}`,
                    '&:hover': {
                        color: token.colorPrimary
                    }
                },
                [`> ${iconCls}`]: {
                    fontSize: cardActionsIconSize,
                    lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(cardActionsIconSize).mul(token.lineHeight).equal())
                }
            },
            '&:not(:last-child)': {
                borderInlineEnd: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`
            }
        }
    };
};
// ============================== Meta ==============================
const $9a780d58d50e8c74$var$genCardMetaStyle = (token)=>({
        margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(token.marginXXS).mul(-1).equal())} 0`,
        display: 'flex',
        ...(0, $945cb0d2b7017a11$export$8c467e8859fdef13)(),
        '&-avatar': {
            paddingInlineEnd: token.padding
        },
        '&-section': {
            overflow: 'hidden',
            flex: 1,
            '> div:not(:last-child)': {
                marginBottom: token.marginXS
            }
        },
        '&-title': {
            color: token.colorTextHeading,
            fontWeight: token.fontWeightStrong,
            fontSize: token.fontSizeLG,
            ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629)
        },
        '&-description': {
            color: token.colorTextDescription
        }
    });
// ============================== Inner ==============================
const $9a780d58d50e8c74$var$genCardTypeInnerStyle = (token)=>{
    const { componentCls: componentCls, colorFillAlter: colorFillAlter, headerPadding: headerPadding, bodyPadding: bodyPadding } = token;
    return {
        [`${componentCls}-head`]: {
            padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(headerPadding)}`,
            background: colorFillAlter,
            '&-title': {
                fontSize: token.fontSize
            }
        },
        [`${componentCls}-body`]: {
            padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.padding)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(bodyPadding)}`
        }
    };
};
// ============================== Loading ==============================
const $9a780d58d50e8c74$var$genCardLoadingStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        overflow: 'hidden',
        [`${componentCls}-body`]: {
            userSelect: 'none'
        }
    };
};
// ============================== Basic ==============================
const $9a780d58d50e8c74$var$genCardStyle = (token)=>{
    const { componentCls: componentCls, cardShadow: cardShadow, cardHeadPadding: cardHeadPadding, colorBorderSecondary: colorBorderSecondary, boxShadowTertiary: boxShadowTertiary, bodyPadding: bodyPadding, extraColor: extraColor } = token;
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            position: 'relative',
            background: token.colorBgContainer,
            borderRadius: token.borderRadiusLG,
            [`&:not(${componentCls}-bordered)`]: {
                boxShadow: boxShadowTertiary
            },
            [`${componentCls}-head`]: $9a780d58d50e8c74$var$genCardHeadStyle(token),
            [`${componentCls}-extra`]: {
                // https://stackoverflow.com/a/22429853/3040605
                marginInlineStart: 'auto',
                color: extraColor,
                fontWeight: 'normal',
                fontSize: token.fontSize
            },
            [`${componentCls}-body`]: {
                padding: bodyPadding,
                borderRadius: `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)}`
            },
            [`${componentCls}-grid`]: $9a780d58d50e8c74$var$genCardGridStyle(token),
            [`${componentCls}-cover`]: {
                '> *': {
                    display: 'block',
                    width: '100%',
                    borderRadius: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`
                }
            },
            [`${componentCls}-actions`]: $9a780d58d50e8c74$var$genCardActionsStyle(token),
            [`${componentCls}-meta`]: $9a780d58d50e8c74$var$genCardMetaStyle(token)
        },
        [`${componentCls}-bordered`]: {
            border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
            [`${componentCls}-cover`]: {
                marginTop: -1,
                marginInlineStart: -1,
                marginInlineEnd: -1
            }
        },
        [`${componentCls}-hoverable`]: {
            cursor: 'pointer',
            transition: `box-shadow ${token.motionDurationMid}, border-color ${token.motionDurationMid}`,
            '&:hover': {
                borderColor: 'transparent',
                boxShadow: cardShadow
            }
        },
        [`${componentCls}-contain-grid`]: {
            borderRadius: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} 0 0 `,
            [`${componentCls}-body`]: {
                display: 'flex',
                flexWrap: 'wrap'
            },
            [`&:not(${componentCls}-loading) ${componentCls}-body`]: {
                marginBlockStart: token.calc(token.lineWidth).mul(-1).equal(),
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                padding: 0
            }
        },
        [`${componentCls}-contain-tabs`]: {
            [`> div${componentCls}-head`]: {
                minHeight: 0,
                [`${componentCls}-head-title, ${componentCls}-extra`]: {
                    paddingTop: cardHeadPadding
                }
            }
        },
        [`${componentCls}-type-inner`]: $9a780d58d50e8c74$var$genCardTypeInnerStyle(token),
        [`${componentCls}-loading`]: $9a780d58d50e8c74$var$genCardLoadingStyle(token),
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        }
    };
};
// ============================== Size ==============================
const $9a780d58d50e8c74$var$genCardSizeStyle = (token)=>{
    const { componentCls: componentCls, bodyPaddingSM: bodyPaddingSM, headerPaddingSM: headerPaddingSM, headerHeightSM: headerHeightSM, headerFontSizeSM: headerFontSizeSM } = token;
    return {
        [`${componentCls}-small`]: {
            [`> ${componentCls}-head`]: {
                minHeight: headerHeightSM,
                padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(headerPaddingSM)}`,
                fontSize: headerFontSizeSM,
                [`> ${componentCls}-head-wrapper`]: {
                    [`> ${componentCls}-extra`]: {
                        fontSize: token.fontSize
                    }
                }
            },
            [`> ${componentCls}-body`]: {
                padding: bodyPaddingSM
            }
        },
        [`${componentCls}-small${componentCls}-contain-tabs`]: {
            [`> ${componentCls}-head`]: {
                [`${componentCls}-head-title, ${componentCls}-extra`]: {
                    paddingTop: 0,
                    display: 'flex',
                    alignItems: 'center'
                }
            }
        }
    };
};
const $9a780d58d50e8c74$export$9ca1be8807fe0675 = (token)=>({
        headerBg: 'transparent',
        headerFontSize: token.fontSizeLG,
        headerFontSizeSM: token.fontSize,
        headerHeight: token.fontSizeLG * token.lineHeightLG + token.padding * 2,
        headerHeightSM: token.fontSize * token.lineHeight + token.paddingXS * 2,
        actionsBg: token.colorBgContainer,
        actionsLiMargin: `${token.paddingSM}px 0`,
        tabsMarginBottom: -token.padding - token.lineWidth,
        extraColor: token.colorText,
        bodyPaddingSM: 12,
        // Fixed padding.
        headerPaddingSM: 12,
        bodyPadding: token.bodyPadding ?? token.paddingLG,
        headerPadding: token.headerPadding ?? token.paddingLG
    });
var // ============================== Export ==============================
$9a780d58d50e8c74$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Card', (token)=>{
    const cardToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        cardShadow: token.boxShadowCard,
        cardHeadPadding: token.padding,
        cardPaddingBase: token.paddingLG,
        cardActionsIconSize: token.fontSize
    });
    return [
        // Style
        $9a780d58d50e8c74$var$genCardStyle(cardToken),
        // Size
        $9a780d58d50e8c74$var$genCardSizeStyle(cardToken)
    ];
}, $9a780d58d50e8c74$export$9ca1be8807fe0675);


"use client";
const $8c7ed93924632ad7$var$ActionNode = (props)=>{
    const { actionClasses: actionClasses, actions: actions = [], actionStyle: actionStyle } = props;
    return /*#__PURE__*/ $ltGt3.createElement("ul", {
        className: actionClasses,
        style: actionStyle
    }, actions.map((action, index)=>{
        // Move this out since eslint not allow index key
        // And eslint-disable makes conflict with rollup
        // ref https://github.com/ant-design/ant-design/issues/46022
        const key = `action-${index}`;
        return /*#__PURE__*/ $ltGt3.createElement("li", {
            style: {
                width: `${100 / actions.length}%`
            },
            key: key
        }, /*#__PURE__*/ $ltGt3.createElement("span", null, action));
    }));
};
const $8c7ed93924632ad7$var$Card = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, extra: extra, headStyle: headStyle = {}, bodyStyle: bodyStyle = {}, title: title, loading: loading, bordered: bordered, variant: customVariant, size: customizeSize, type: type, cover: cover, actions: actions, tabList: tabList, children: children, activeTabKey: activeTabKey, defaultActiveTabKey: defaultActiveTabKey, tabBarExtraContent: tabBarExtraContent, hoverable: hoverable, tabProps: tabProps = {}, classNames: classNames, styles: styles, ...rest } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('card');
    const [variant] = (0, $714175bf01098e4f$export$2e2bcd8739ae039)('card', customVariant, bordered);
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)(customizeSize);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        variant: variant,
        loading: loading
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    var deprecatedName, newName;
    const onTabChange = (key)=>{
        props.onTabChange?.(key);
    };
    const isContainGrid = $ltGt3.useMemo(()=>{
        const childNodes = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children);
        return childNodes.some((child)=>/*#__PURE__*/ $ltGt3.isValidElement(child) && child.type === (0, $6430631ceb7b2189$export$2e2bcd8739ae039));
    }, [
        children
    ]);
    const prefixCls = getPrefixCls('card', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $9a780d58d50e8c74$export$2e2bcd8739ae039)(prefixCls);
    const loadingBlock = /*#__PURE__*/ $ltGt3.createElement((0, $bbc46c63198736c0$export$2e2bcd8739ae039), {
        loading: true,
        active: true,
        paragraph: {
            rows: 4
        },
        title: false
    }, children);
    const hasActiveTabKey = activeTabKey !== undefined;
    const extraProps = {
        ...tabProps,
        [hasActiveTabKey ? 'activeKey' : 'defaultActiveKey']: hasActiveTabKey ? activeTabKey : defaultActiveTabKey,
        tabBarExtraContent: tabBarExtraContent
    };
    let head;
    const tabSize = !mergedSize || mergedSize === 'default' ? 'large' : mergedSize;
    const tabs = tabList ? /*#__PURE__*/ $ltGt3.createElement((0, $77eacb4b734e6c42$export$2e2bcd8739ae039), {
        size: tabSize,
        ...extraProps,
        className: `${prefixCls}-head-tabs`,
        onChange: onTabChange,
        items: tabList.map(({ tab: tab, ...item })=>({
                label: tab,
                ...item
            }))
    }) : null;
    if (title || extra || tabs) {
        const headClasses = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-head`, mergedClassNames.header);
        const titleClasses = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-head-title`, mergedClassNames.title);
        const extraClasses = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-extra`, mergedClassNames.extra);
        const mergedHeadStyle = {
            ...headStyle,
            ...mergedStyles.header
        };
        head = /*#__PURE__*/ $ltGt3.createElement("div", {
            className: headClasses,
            style: mergedHeadStyle
        }, /*#__PURE__*/ $ltGt3.createElement("div", {
            className: `${prefixCls}-head-wrapper`
        }, title && /*#__PURE__*/ $ltGt3.createElement("div", {
            className: titleClasses,
            style: mergedStyles.title
        }, title), extra && /*#__PURE__*/ $ltGt3.createElement("div", {
            className: extraClasses,
            style: mergedStyles.extra
        }, extra)), tabs);
    }
    const coverClasses = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-cover`, mergedClassNames.cover);
    const coverDom = cover ? /*#__PURE__*/ $ltGt3.createElement("div", {
        className: coverClasses,
        style: mergedStyles.cover
    }, cover) : null;
    const bodyClasses = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-body`, mergedClassNames.body);
    const mergedBodyStyle = {
        ...bodyStyle,
        ...mergedStyles.body
    };
    const body = /*#__PURE__*/ $ltGt3.createElement("div", {
        className: bodyClasses,
        style: mergedBodyStyle
    }, loading ? loadingBlock : children);
    const actionClasses = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, mergedClassNames.actions);
    const actionDom = actions?.length ? /*#__PURE__*/ $ltGt3.createElement($8c7ed93924632ad7$var$ActionNode, {
        actionClasses: actionClasses,
        actionStyle: mergedStyles.actions,
        actions: actions
    }) : null;
    const divProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(rest, [
        'onTabChange'
    ]);
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, contextClassName, {
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-bordered`]: variant !== 'borderless',
        [`${prefixCls}-hoverable`]: hoverable,
        [`${prefixCls}-contain-grid`]: isContainGrid,
        [`${prefixCls}-contain-tabs`]: tabList?.length,
        [`${prefixCls}-${mergedSize}`]: mergedSize,
        [`${prefixCls}-type-${type}`]: !!type,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, hashId, cssVarCls, mergedClassNames.root);
    const mergedStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: ref,
        ...divProps,
        className: classString,
        style: mergedStyle
    }, head, coverDom, body, actionDom);
});
var $8c7ed93924632ad7$export$2e2bcd8739ae039 = $8c7ed93924632ad7$var$Card;




var $ltGt3 = parcelRequire("ltGt3");



"use client";
const $fcc52aefc624de30$var$Meta = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, avatar: avatar, title: title, description: description, style: style, classNames: cardMetaClassNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('cardMeta');
    const prefixCls = getPrefixCls('card', customizePrefixCls);
    const metaPrefixCls = `${prefixCls}-meta`;
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        cardMetaClassNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    const rootClassNames = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(metaPrefixCls, className, contextClassName, mergedClassNames.root);
    const rootStyles = {
        ...contextStyle,
        ...mergedStyles.root,
        ...style
    };
    const avatarClassNames = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${metaPrefixCls}-avatar`, mergedClassNames.avatar);
    const titleClassNames = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${metaPrefixCls}-title`, mergedClassNames.title);
    const descriptionClassNames = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${metaPrefixCls}-description`, mergedClassNames.description);
    const sectionClassNames = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${metaPrefixCls}-section`, mergedClassNames.section);
    const avatarDom = avatar ? /*#__PURE__*/ $ltGt3.createElement("div", {
        className: avatarClassNames,
        style: mergedStyles.avatar
    }, avatar) : null;
    const titleDom = title ? /*#__PURE__*/ $ltGt3.createElement("div", {
        className: titleClassNames,
        style: mergedStyles.title
    }, title) : null;
    const descriptionDom = description ? /*#__PURE__*/ $ltGt3.createElement("div", {
        className: descriptionClassNames,
        style: mergedStyles.description
    }, description) : null;
    const MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/ $ltGt3.createElement("div", {
        className: sectionClassNames,
        style: mergedStyles.section
    }, titleDom, descriptionDom) : null;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ...restProps,
        className: rootClassNames,
        style: rootStyles
    }, avatarDom, MetaDetail);
};
var $fcc52aefc624de30$export$2e2bcd8739ae039 = $fcc52aefc624de30$var$Meta;


"use client";
const $ad1c3304c519fac5$var$Card = (0, $8c7ed93924632ad7$export$2e2bcd8739ae039);
$ad1c3304c519fac5$var$Card.Grid = (0, $6430631ceb7b2189$export$2e2bcd8739ae039);
$ad1c3304c519fac5$var$Card.Meta = (0, $fcc52aefc624de30$export$2e2bcd8739ae039);
var $ad1c3304c519fac5$export$2e2bcd8739ae039 = $ad1c3304c519fac5$var$Card;


parcelRequire("ltGt3");
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */ function $d532fef32f3917d6$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $d532fef32f3917d6$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $d532fef32f3917d6$export$bcc6e673dfa14d36(v) {
    return $d532fef32f3917d6$export$837ba5c449269406($d532fef32f3917d6$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $d532fef32f3917d6$export$869b26d4e1bbdb63(v) {
    return $d532fef32f3917d6$export$837ba5c449269406($d532fef32f3917d6$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $d532fef32f3917d6$export$ed9bd8dcaeba14f6(v) {
    return $d532fef32f3917d6$export$837ba5c449269406($d532fef32f3917d6$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $d532fef32f3917d6$export$dbf961a8d278dbef(v) {
    return $d532fef32f3917d6$export$837ba5c449269406($d532fef32f3917d6$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $d532fef32f3917d6$export$aa35ef1f24408ab9(v) {
    return $d532fef32f3917d6$export$837ba5c449269406($d532fef32f3917d6$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $d532fef32f3917d6$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $d532fef32f3917d6$var$hex = [
    ...'0123456789ABCDEF'
];
const $d532fef32f3917d6$var$h1 = (b)=>$d532fef32f3917d6$var$hex[b & 0xF];
const $d532fef32f3917d6$var$h2 = (b)=>$d532fef32f3917d6$var$hex[(b & 0xF0) >> 4] + $d532fef32f3917d6$var$hex[b & 0xF];
const $d532fef32f3917d6$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $d532fef32f3917d6$var$isShort = (v)=>$d532fef32f3917d6$var$eq(v.r) && $d532fef32f3917d6$var$eq(v.g) && $d532fef32f3917d6$var$eq(v.b) && $d532fef32f3917d6$var$eq(v.a);
function $d532fef32f3917d6$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $d532fef32f3917d6$var$map$1[str[1]] * 17,
            g: 255 & $d532fef32f3917d6$var$map$1[str[2]] * 17,
            b: 255 & $d532fef32f3917d6$var$map$1[str[3]] * 17,
            a: len === 5 ? $d532fef32f3917d6$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $d532fef32f3917d6$var$map$1[str[1]] << 4 | $d532fef32f3917d6$var$map$1[str[2]],
            g: $d532fef32f3917d6$var$map$1[str[3]] << 4 | $d532fef32f3917d6$var$map$1[str[4]],
            b: $d532fef32f3917d6$var$map$1[str[5]] << 4 | $d532fef32f3917d6$var$map$1[str[6]],
            a: len === 9 ? $d532fef32f3917d6$var$map$1[str[7]] << 4 | $d532fef32f3917d6$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $d532fef32f3917d6$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $d532fef32f3917d6$export$1b06654353ef9f67(v) {
    var f = $d532fef32f3917d6$var$isShort(v) ? $d532fef32f3917d6$var$h1 : $d532fef32f3917d6$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $d532fef32f3917d6$var$alpha(v.a, f) : undefined;
}
const $d532fef32f3917d6$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $d532fef32f3917d6$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $d532fef32f3917d6$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $d532fef32f3917d6$var$hwb2rgbn(h, w, b) {
    const rgb = $d532fef32f3917d6$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $d532fef32f3917d6$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $d532fef32f3917d6$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $d532fef32f3917d6$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $d532fef32f3917d6$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($d532fef32f3917d6$export$ed9bd8dcaeba14f6);
}
function $d532fef32f3917d6$export$4c15bd42559b811d(h, s, l) {
    return $d532fef32f3917d6$var$calln($d532fef32f3917d6$var$hsl2rgbn, h, s, l);
}
function $d532fef32f3917d6$export$e2710022c70fc9ee(h, w, b) {
    return $d532fef32f3917d6$var$calln($d532fef32f3917d6$var$hwb2rgbn, h, w, b);
}
function $d532fef32f3917d6$export$b785a357c84e4a04(h, s, v) {
    return $d532fef32f3917d6$var$calln($d532fef32f3917d6$var$hsv2rgbn, h, s, v);
}
function $d532fef32f3917d6$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $d532fef32f3917d6$export$5e91288c399be4f9(str) {
    const m = $d532fef32f3917d6$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $d532fef32f3917d6$export$bcc6e673dfa14d36(+m[5]) : $d532fef32f3917d6$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $d532fef32f3917d6$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $d532fef32f3917d6$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $d532fef32f3917d6$export$b785a357c84e4a04(h, p1, p2);
    else v = $d532fef32f3917d6$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $d532fef32f3917d6$export$bb628a54ab399bc9(v, deg) {
    var h = $d532fef32f3917d6$export$b5ba70b240f8f7f(v);
    h[0] = $d532fef32f3917d6$var$hue(h[0] + deg);
    h = $d532fef32f3917d6$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $d532fef32f3917d6$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $d532fef32f3917d6$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $d532fef32f3917d6$export$aa35ef1f24408ab9(a[1]);
    const l = $d532fef32f3917d6$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$d532fef32f3917d6$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $d532fef32f3917d6$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $d532fef32f3917d6$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $d532fef32f3917d6$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($d532fef32f3917d6$var$names$1);
    const tkeys = Object.keys($d532fef32f3917d6$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $d532fef32f3917d6$var$map[k]);
        }
        k = parseInt($d532fef32f3917d6$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $d532fef32f3917d6$var$names;
function $d532fef32f3917d6$export$b2f06b640faad956(str) {
    if (!$d532fef32f3917d6$var$names) {
        $d532fef32f3917d6$var$names = $d532fef32f3917d6$var$unpack();
        $d532fef32f3917d6$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $d532fef32f3917d6$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $d532fef32f3917d6$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $d532fef32f3917d6$export$91aedb20f296e541(str) {
    const m = $d532fef32f3917d6$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $d532fef32f3917d6$export$bcc6e673dfa14d36(v) : $d532fef32f3917d6$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $d532fef32f3917d6$export$bcc6e673dfa14d36(r) : $d532fef32f3917d6$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $d532fef32f3917d6$export$bcc6e673dfa14d36(g) : $d532fef32f3917d6$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $d532fef32f3917d6$export$bcc6e673dfa14d36(b) : $d532fef32f3917d6$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $d532fef32f3917d6$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$d532fef32f3917d6$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $d532fef32f3917d6$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $d532fef32f3917d6$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $d532fef32f3917d6$var$interpolate(rgb1, rgb2, t) {
    const r = $d532fef32f3917d6$var$from($d532fef32f3917d6$export$dbf961a8d278dbef(rgb1.r));
    const g = $d532fef32f3917d6$var$from($d532fef32f3917d6$export$dbf961a8d278dbef(rgb1.g));
    const b = $d532fef32f3917d6$var$from($d532fef32f3917d6$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $d532fef32f3917d6$export$ed9bd8dcaeba14f6($d532fef32f3917d6$var$to(r + t * ($d532fef32f3917d6$var$from($d532fef32f3917d6$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $d532fef32f3917d6$export$ed9bd8dcaeba14f6($d532fef32f3917d6$var$to(g + t * ($d532fef32f3917d6$var$from($d532fef32f3917d6$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $d532fef32f3917d6$export$ed9bd8dcaeba14f6($d532fef32f3917d6$var$to(b + t * ($d532fef32f3917d6$var$from($d532fef32f3917d6$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $d532fef32f3917d6$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $d532fef32f3917d6$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $d532fef32f3917d6$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $d532fef32f3917d6$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $d532fef32f3917d6$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $d532fef32f3917d6$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $d532fef32f3917d6$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $d532fef32f3917d6$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $d532fef32f3917d6$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $d532fef32f3917d6$export$91aedb20f296e541(str);
    return $d532fef32f3917d6$export$5e91288c399be4f9(str);
}
class $d532fef32f3917d6$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $d532fef32f3917d6$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $d532fef32f3917d6$var$fromObject(input);
        else if (type === 'string') v = $d532fef32f3917d6$export$625a38b961e8b5e9(input) || $d532fef32f3917d6$export$b2f06b640faad956(input) || $d532fef32f3917d6$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $d532fef32f3917d6$var$clone(this._rgb);
        if (v) v.a = $d532fef32f3917d6$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $d532fef32f3917d6$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $d532fef32f3917d6$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $d532fef32f3917d6$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $d532fef32f3917d6$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $d532fef32f3917d6$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $d532fef32f3917d6$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $d532fef32f3917d6$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $d532fef32f3917d6$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $d532fef32f3917d6$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $d532fef32f3917d6$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $d532fef32f3917d6$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $d532fef32f3917d6$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $d532fef32f3917d6$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $d532fef32f3917d6$export$2e2bcd8739ae039(input) {
    return new $d532fef32f3917d6$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $8ae8a8807b0eb9f4$export$cf2f7c5792f80b46() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $8ae8a8807b0eb9f4$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $8ae8a8807b0eb9f4$export$342063e11d6c3cad(value) {
    return value === null || typeof value === 'undefined';
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $8ae8a8807b0eb9f4$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $8ae8a8807b0eb9f4$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $8ae8a8807b0eb9f4$export$c4ce752e73470fba(value, defaultValue) {
    return $8ae8a8807b0eb9f4$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $8ae8a8807b0eb9f4$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $8ae8a8807b0eb9f4$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $8ae8a8807b0eb9f4$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $8ae8a8807b0eb9f4$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $8ae8a8807b0eb9f4$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($8ae8a8807b0eb9f4$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($8ae8a8807b0eb9f4$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $8ae8a8807b0eb9f4$export$995eb9fca571757(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $8ae8a8807b0eb9f4$export$d377dcb2b61d6c4e(source) {
    if ($8ae8a8807b0eb9f4$export$8b22cf2602fb60ce(source)) return source.map($8ae8a8807b0eb9f4$export$d377dcb2b61d6c4e);
    if ($8ae8a8807b0eb9f4$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $8ae8a8807b0eb9f4$export$d377dcb2b61d6c4e(source[keys[k]]);
        return target;
    }
    return source;
}
function $8ae8a8807b0eb9f4$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $8ae8a8807b0eb9f4$export$667d3bf0c5f83305(key, target, source, options) {
    if (!$8ae8a8807b0eb9f4$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($8ae8a8807b0eb9f4$export$23f2a1d2818174ef(tval) && $8ae8a8807b0eb9f4$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $8ae8a8807b0eb9f4$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $8ae8a8807b0eb9f4$export$d377dcb2b61d6c4e(sval);
}
function $8ae8a8807b0eb9f4$export$efca4cbe5dd06740(target, source, options) {
    const sources = $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$8ae8a8807b0eb9f4$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $8ae8a8807b0eb9f4$export$667d3bf0c5f83305;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$8ae8a8807b0eb9f4$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $8ae8a8807b0eb9f4$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $8ae8a8807b0eb9f4$export$efca4cbe5dd06740(target, source, {
        merger: $8ae8a8807b0eb9f4$export$317a3d46287192d8
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $8ae8a8807b0eb9f4$export$317a3d46287192d8(key, target, source) {
    if (!$8ae8a8807b0eb9f4$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($8ae8a8807b0eb9f4$export$23f2a1d2818174ef(tval) && $8ae8a8807b0eb9f4$export$23f2a1d2818174ef(sval)) $8ae8a8807b0eb9f4$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $8ae8a8807b0eb9f4$export$d377dcb2b61d6c4e(sval);
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$1ee57be6f6687d2c(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $8ae8a8807b0eb9f4$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$9d0e2d13d04f7070(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $8ae8a8807b0eb9f4$var$_getKeyResolver(key) {
    const keys = $8ae8a8807b0eb9f4$export$9d0e2d13d04f7070(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $8ae8a8807b0eb9f4$export$2d1720544b23b823(obj, key) {
    const resolver = $8ae8a8807b0eb9f4$var$keyResolvers[key] || ($8ae8a8807b0eb9f4$var$keyResolvers[key] = $8ae8a8807b0eb9f4$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $8ae8a8807b0eb9f4$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $8ae8a8807b0eb9f4$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $8ae8a8807b0eb9f4$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $8ae8a8807b0eb9f4$export$f38c853ae54ed474(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $8ae8a8807b0eb9f4$export$56c0d5a1e737357d = Math.PI;
const $8ae8a8807b0eb9f4$export$971d5caa766a69d7 = 2 * $8ae8a8807b0eb9f4$export$56c0d5a1e737357d;
const $8ae8a8807b0eb9f4$export$d29e374196577086 = $8ae8a8807b0eb9f4$export$971d5caa766a69d7 + $8ae8a8807b0eb9f4$export$56c0d5a1e737357d;
const $8ae8a8807b0eb9f4$export$2ec5befb9e6c97d4 = Number.POSITIVE_INFINITY;
const $8ae8a8807b0eb9f4$export$53c86fa97d611818 = $8ae8a8807b0eb9f4$export$56c0d5a1e737357d / 180;
const $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd = $8ae8a8807b0eb9f4$export$56c0d5a1e737357d / 2;
const $8ae8a8807b0eb9f4$export$39c1cc7c062529d4 = $8ae8a8807b0eb9f4$export$56c0d5a1e737357d / 4;
const $8ae8a8807b0eb9f4$export$7a0bdf7d4a91ea88 = $8ae8a8807b0eb9f4$export$56c0d5a1e737357d * 2 / 3;
const $8ae8a8807b0eb9f4$export$9f4f30ee63539e24 = Math.log10;
const $8ae8a8807b0eb9f4$export$2408f22a0fab9ae5 = Math.sign;
function $8ae8a8807b0eb9f4$export$a05254e7c3aeba6e(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $8ae8a8807b0eb9f4$export$a33b77bbdbb8366c(range) {
    const roundedRange = Math.round(range);
    range = $8ae8a8807b0eb9f4$export$a05254e7c3aeba6e(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($8ae8a8807b0eb9f4$export$9f4f30ee63539e24(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $8ae8a8807b0eb9f4$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $8ae8a8807b0eb9f4$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $8ae8a8807b0eb9f4$export$b9a6b53f9be3734(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$53a70dd1ebbae346(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $8ae8a8807b0eb9f4$export$625550452a3fa3ec(degrees) {
    return degrees * ($8ae8a8807b0eb9f4$export$56c0d5a1e737357d / 180);
}
function $8ae8a8807b0eb9f4$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $8ae8a8807b0eb9f4$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $8ae8a8807b0eb9f4$export$23ebac1979863676(x) {
    if (!$8ae8a8807b0eb9f4$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $8ae8a8807b0eb9f4$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $8ae8a8807b0eb9f4$export$56c0d5a1e737357d) angle += $8ae8a8807b0eb9f4$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $8ae8a8807b0eb9f4$export$158acd800e1ef08b(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $8ae8a8807b0eb9f4$export$c18d01048907ea92(a, b) {
    return (a - b + $8ae8a8807b0eb9f4$export$d29e374196577086) % $8ae8a8807b0eb9f4$export$971d5caa766a69d7 - $8ae8a8807b0eb9f4$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $8ae8a8807b0eb9f4$export$28f7fcd39efa255(a) {
    return (a % $8ae8a8807b0eb9f4$export$971d5caa766a69d7 + $8ae8a8807b0eb9f4$export$971d5caa766a69d7) % $8ae8a8807b0eb9f4$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $8ae8a8807b0eb9f4$export$28f7fcd39efa255(angle);
    const s = $8ae8a8807b0eb9f4$export$28f7fcd39efa255(start);
    const e = $8ae8a8807b0eb9f4$export$28f7fcd39efa255(end);
    const angleToStart = $8ae8a8807b0eb9f4$export$28f7fcd39efa255(s - a);
    const angleToEnd = $8ae8a8807b0eb9f4$export$28f7fcd39efa255(e - a);
    const startToAngle = $8ae8a8807b0eb9f4$export$28f7fcd39efa255(a - s);
    const endToAngle = $8ae8a8807b0eb9f4$export$28f7fcd39efa255(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $8ae8a8807b0eb9f4$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $8ae8a8807b0eb9f4$export$71cec2538cb2c617(value) {
    return $8ae8a8807b0eb9f4$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $8ae8a8807b0eb9f4$export$3b513254972cfc9c(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $8ae8a8807b0eb9f4$export$2ed0fc6709e59212(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $8ae8a8807b0eb9f4$export$ef35774e6d314e91 = (table, key, value, last)=>$8ae8a8807b0eb9f4$export$2ed0fc6709e59212(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $8ae8a8807b0eb9f4$export$ebd11618f299a286 = (table, key, value)=>$8ae8a8807b0eb9f4$export$2ed0fc6709e59212(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $8ae8a8807b0eb9f4$export$c03999cb2f36933f(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $8ae8a8807b0eb9f4$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $8ae8a8807b0eb9f4$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $8ae8a8807b0eb9f4$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $8ae8a8807b0eb9f4$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $8ae8a8807b0eb9f4$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $8ae8a8807b0eb9f4$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $8ae8a8807b0eb9f4$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $8ae8a8807b0eb9f4$export$fef3dfd9bad05307(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $8ae8a8807b0eb9f4$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $8ae8a8807b0eb9f4$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $8ae8a8807b0eb9f4$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $8ae8a8807b0eb9f4$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $8ae8a8807b0eb9f4$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $8ae8a8807b0eb9f4$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $8ae8a8807b0eb9f4$export$9d398bebfec1c039 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $8ae8a8807b0eb9f4$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $8ae8a8807b0eb9f4$export$25ce5a424b770e84(Math.min($8ae8a8807b0eb9f4$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $8ae8a8807b0eb9f4$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $8ae8a8807b0eb9f4$export$25ce5a424b770e84(Math.max($8ae8a8807b0eb9f4$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $8ae8a8807b0eb9f4$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $8ae8a8807b0eb9f4$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $8ae8a8807b0eb9f4$var$atEdge = (t)=>t === 0 || t === 1;
const $8ae8a8807b0eb9f4$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $8ae8a8807b0eb9f4$export$971d5caa766a69d7 / p));
const $8ae8a8807b0eb9f4$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $8ae8a8807b0eb9f4$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $8ae8a8807b0eb9f4$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($8ae8a8807b0eb9f4$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$8ae8a8807b0eb9f4$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$8ae8a8807b0eb9f4$var$atEdge(t) ? t : $8ae8a8807b0eb9f4$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$8ae8a8807b0eb9f4$var$atEdge(t) ? t : $8ae8a8807b0eb9f4$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $8ae8a8807b0eb9f4$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $8ae8a8807b0eb9f4$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $8ae8a8807b0eb9f4$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $8ae8a8807b0eb9f4$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $8ae8a8807b0eb9f4$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $8ae8a8807b0eb9f4$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $8ae8a8807b0eb9f4$export$f96d196f7728bb5(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $8ae8a8807b0eb9f4$export$db3b6bfb95261072(value) {
    return $8ae8a8807b0eb9f4$export$f96d196f7728bb5(value) ? value : new (0, $d532fef32f3917d6$export$892596cec99bc70e)(value);
}
function $8ae8a8807b0eb9f4$export$738ab4df8bf92ae9(value) {
    return $8ae8a8807b0eb9f4$export$f96d196f7728bb5(value) ? value : new (0, $d532fef32f3917d6$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $8ae8a8807b0eb9f4$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $8ae8a8807b0eb9f4$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $8ae8a8807b0eb9f4$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $8ae8a8807b0eb9f4$var$colors
        },
        numbers: {
            type: 'number',
            properties: $8ae8a8807b0eb9f4$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $8ae8a8807b0eb9f4$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $8ae8a8807b0eb9f4$var$intlCache = new Map();
function $8ae8a8807b0eb9f4$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $8ae8a8807b0eb9f4$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $8ae8a8807b0eb9f4$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $8ae8a8807b0eb9f4$export$ae1af26003f05816(num, locale, options) {
    return $8ae8a8807b0eb9f4$var$getNumberFormat(locale, options).format(num);
}
const $8ae8a8807b0eb9f4$var$formatters = {
    values (value) {
        return $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $8ae8a8807b0eb9f4$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $8ae8a8807b0eb9f4$export$9f4f30ee63539e24(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $8ae8a8807b0eb9f4$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($8ae8a8807b0eb9f4$export$9f4f30ee63539e24(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $8ae8a8807b0eb9f4$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $8ae8a8807b0eb9f4$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $8ae8a8807b0eb9f4$export$91477dc880baac21 = {
    formatters: $8ae8a8807b0eb9f4$var$formatters
};
function $8ae8a8807b0eb9f4$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $8ae8a8807b0eb9f4$export$91477dc880baac21.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $8ae8a8807b0eb9f4$export$6559d589eb85fbb6 = Object.create(null);
const $8ae8a8807b0eb9f4$export$2e2af4578d910ddf = Object.create(null);
function $8ae8a8807b0eb9f4$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $8ae8a8807b0eb9f4$var$set(root, scope, values) {
    if (typeof scope === 'string') return $8ae8a8807b0eb9f4$export$efca4cbe5dd06740($8ae8a8807b0eb9f4$var$getScope$1(root, scope), values);
    return $8ae8a8807b0eb9f4$export$efca4cbe5dd06740($8ae8a8807b0eb9f4$var$getScope$1(root, ''), scope);
}
class $8ae8a8807b0eb9f4$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$8ae8a8807b0eb9f4$export$738ab4df8bf92ae9(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$8ae8a8807b0eb9f4$export$738ab4df8bf92ae9(options.borderColor);
        this.hoverColor = (ctx, options)=>$8ae8a8807b0eb9f4$export$738ab4df8bf92ae9(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $8ae8a8807b0eb9f4$var$set(this, scope, values);
    }
    get(scope) {
        return $8ae8a8807b0eb9f4$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $8ae8a8807b0eb9f4$var$set($8ae8a8807b0eb9f4$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $8ae8a8807b0eb9f4$var$set($8ae8a8807b0eb9f4$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $8ae8a8807b0eb9f4$var$getScope$1(this, scope);
        const targetScopeObject = $8ae8a8807b0eb9f4$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($8ae8a8807b0eb9f4$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $8ae8a8807b0eb9f4$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $8ae8a8807b0eb9f4$export$4368d992c4eafac0 = /* #__PURE__ */ new $8ae8a8807b0eb9f4$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $8ae8a8807b0eb9f4$var$applyAnimationsDefaults,
    $8ae8a8807b0eb9f4$var$applyLayoutsDefaults,
    $8ae8a8807b0eb9f4$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $8ae8a8807b0eb9f4$export$1a8f5705751d8277(font) {
    if (!font || $8ae8a8807b0eb9f4$export$342063e11d6c3cad(font.size) || $8ae8a8807b0eb9f4$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $8ae8a8807b0eb9f4$export$faec65b429be379(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$8ae8a8807b0eb9f4$export$8b22cf2602fb60ce(thing)) longest = $8ae8a8807b0eb9f4$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($8ae8a8807b0eb9f4$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$8ae8a8807b0eb9f4$export$8b22cf2602fb60ce(nestedThing)) longest = $8ae8a8807b0eb9f4$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $8ae8a8807b0eb9f4$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $8ae8a8807b0eb9f4$export$c9170ad7d4cd7e57(canvas, ctx) {
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $8ae8a8807b0eb9f4$export$493d36ec626b6698(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $8ae8a8807b0eb9f4$export$24baa2b76016ce0e(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $8ae8a8807b0eb9f4$export$24baa2b76016ce0e(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $8ae8a8807b0eb9f4$export$53c86fa97d611818;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $8ae8a8807b0eb9f4$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $8ae8a8807b0eb9f4$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $8ae8a8807b0eb9f4$export$39c1cc7c062529d4) * size;
            xOffsetW = Math.cos(rad + $8ae8a8807b0eb9f4$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $8ae8a8807b0eb9f4$export$39c1cc7c062529d4) * size;
            yOffsetW = Math.sin(rad + $8ae8a8807b0eb9f4$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $8ae8a8807b0eb9f4$export$56c0d5a1e737357d, rad - $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd, rad + $8ae8a8807b0eb9f4$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $8ae8a8807b0eb9f4$export$39c1cc7c062529d4;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $8ae8a8807b0eb9f4$export$39c1cc7c062529d4;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $8ae8a8807b0eb9f4$export$39c1cc7c062529d4;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $8ae8a8807b0eb9f4$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $8ae8a8807b0eb9f4$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $8ae8a8807b0eb9f4$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$d24c54395ce0c509(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$6554612db691658e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $8ae8a8807b0eb9f4$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$8ae8a8807b0eb9f4$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $8ae8a8807b0eb9f4$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $8ae8a8807b0eb9f4$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $8ae8a8807b0eb9f4$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $8ae8a8807b0eb9f4$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $8ae8a8807b0eb9f4$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$8ae8a8807b0eb9f4$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $8ae8a8807b0eb9f4$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $8ae8a8807b0eb9f4$export$1fbe638ecf81657e(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $8ae8a8807b0eb9f4$export$56c0d5a1e737357d, $8ae8a8807b0eb9f4$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $8ae8a8807b0eb9f4$export$56c0d5a1e737357d, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $8ae8a8807b0eb9f4$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $8ae8a8807b0eb9f4$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $8ae8a8807b0eb9f4$export$8c78c7c36408ea29(value, size) {
    const matches = ('' + value).match($8ae8a8807b0eb9f4$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $8ae8a8807b0eb9f4$var$numberOrZero = (v)=>+v || 0;
function $8ae8a8807b0eb9f4$export$21579262ef46735b(value, props) {
    const ret = {};
    const objProps = $8ae8a8807b0eb9f4$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $8ae8a8807b0eb9f4$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$8ae8a8807b0eb9f4$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $8ae8a8807b0eb9f4$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $8ae8a8807b0eb9f4$export$d66dc83d8cfc8dd(value) {
    return $8ae8a8807b0eb9f4$export$21579262ef46735b(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $8ae8a8807b0eb9f4$export$92108d983e8ee699(value) {
    return $8ae8a8807b0eb9f4$export$21579262ef46735b(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca(value) {
    const obj = $8ae8a8807b0eb9f4$export$d66dc83d8cfc8dd(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $8ae8a8807b0eb9f4$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $8ae8a8807b0eb9f4$export$4368d992c4eafac0.font;
    let size = $8ae8a8807b0eb9f4$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $8ae8a8807b0eb9f4$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($8ae8a8807b0eb9f4$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $8ae8a8807b0eb9f4$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $8ae8a8807b0eb9f4$export$8c78c7c36408ea29($8ae8a8807b0eb9f4$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $8ae8a8807b0eb9f4$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $8ae8a8807b0eb9f4$export$1a8f5705751d8277(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $8ae8a8807b0eb9f4$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $8ae8a8807b0eb9f4$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $8ae8a8807b0eb9f4$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $8ae8a8807b0eb9f4$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $8ae8a8807b0eb9f4$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $8ae8a8807b0eb9f4$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$8ae8a8807b0eb9f4$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $8ae8a8807b0eb9f4$var$_cached(target, prop, ()=>$8ae8a8807b0eb9f4$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $8ae8a8807b0eb9f4$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $8ae8a8807b0eb9f4$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $8ae8a8807b0eb9f4$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $8ae8a8807b0eb9f4$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$8ae8a8807b0eb9f4$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$8ae8a8807b0eb9f4$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $8ae8a8807b0eb9f4$var$_cached(target, prop, ()=>$8ae8a8807b0eb9f4$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $8ae8a8807b0eb9f4$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $8ae8a8807b0eb9f4$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $8ae8a8807b0eb9f4$var$readKey = (prefix, name)=>prefix ? prefix + $8ae8a8807b0eb9f4$export$a8550f7dbe79f93a(name) : name;
const $8ae8a8807b0eb9f4$var$needsSubResolver = (prop, value)=>$8ae8a8807b0eb9f4$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $8ae8a8807b0eb9f4$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $8ae8a8807b0eb9f4$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($8ae8a8807b0eb9f4$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $8ae8a8807b0eb9f4$var$_resolveScriptable(prop, value, target, receiver);
    if ($8ae8a8807b0eb9f4$export$8b22cf2602fb60ce(value) && value.length) value = $8ae8a8807b0eb9f4$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($8ae8a8807b0eb9f4$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $8ae8a8807b0eb9f4$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $8ae8a8807b0eb9f4$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($8ae8a8807b0eb9f4$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $8ae8a8807b0eb9f4$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $8ae8a8807b0eb9f4$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($8ae8a8807b0eb9f4$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $8ae8a8807b0eb9f4$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($8ae8a8807b0eb9f4$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $8ae8a8807b0eb9f4$var$resolveFallback(fallback, prop, value) {
    return $8ae8a8807b0eb9f4$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $8ae8a8807b0eb9f4$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $8ae8a8807b0eb9f4$export$2d1720544b23b823(parent, key) : undefined;
function $8ae8a8807b0eb9f4$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $8ae8a8807b0eb9f4$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $8ae8a8807b0eb9f4$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $8ae8a8807b0eb9f4$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $8ae8a8807b0eb9f4$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $8ae8a8807b0eb9f4$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $8ae8a8807b0eb9f4$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $8ae8a8807b0eb9f4$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$8ae8a8807b0eb9f4$var$subGetTarget(resolver, prop, value));
}
function $8ae8a8807b0eb9f4$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $8ae8a8807b0eb9f4$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $8ae8a8807b0eb9f4$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($8ae8a8807b0eb9f4$export$8b22cf2602fb60ce(target) && $8ae8a8807b0eb9f4$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $8ae8a8807b0eb9f4$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $8ae8a8807b0eb9f4$var$_resolve($8ae8a8807b0eb9f4$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $8ae8a8807b0eb9f4$var$needsSubResolver(prop, value) ? $8ae8a8807b0eb9f4$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $8ae8a8807b0eb9f4$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $8ae8a8807b0eb9f4$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $8ae8a8807b0eb9f4$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $8ae8a8807b0eb9f4$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $8ae8a8807b0eb9f4$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($8ae8a8807b0eb9f4$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $8ae8a8807b0eb9f4$var$EPSILON = Number.EPSILON || 1e-14;
const $8ae8a8807b0eb9f4$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $8ae8a8807b0eb9f4$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $8ae8a8807b0eb9f4$export$e171bab687b50e0(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $8ae8a8807b0eb9f4$export$158acd800e1ef08b(current, previous);
    const d12 = $8ae8a8807b0eb9f4$export$158acd800e1ef08b(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $8ae8a8807b0eb9f4$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $8ae8a8807b0eb9f4$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $8ae8a8807b0eb9f4$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($8ae8a8807b0eb9f4$export$a05254e7c3aeba6e(deltaK[i], 0, $8ae8a8807b0eb9f4$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $8ae8a8807b0eb9f4$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $8ae8a8807b0eb9f4$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $8ae8a8807b0eb9f4$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $8ae8a8807b0eb9f4$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $8ae8a8807b0eb9f4$export$527e9aa3390079e9(points, indexAxis = 'x') {
    const valueAxis = $8ae8a8807b0eb9f4$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $8ae8a8807b0eb9f4$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $8ae8a8807b0eb9f4$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $8ae8a8807b0eb9f4$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $8ae8a8807b0eb9f4$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $8ae8a8807b0eb9f4$var$monotoneAdjust(points, deltaK, mK);
    $8ae8a8807b0eb9f4$var$monotoneCompute(points, mK, indexAxis);
}
function $8ae8a8807b0eb9f4$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $8ae8a8807b0eb9f4$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $8ae8a8807b0eb9f4$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $8ae8a8807b0eb9f4$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $8ae8a8807b0eb9f4$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $8ae8a8807b0eb9f4$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $8ae8a8807b0eb9f4$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $8ae8a8807b0eb9f4$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$ab83b03e4111b1d0(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $8ae8a8807b0eb9f4$export$527e9aa3390079e9(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $8ae8a8807b0eb9f4$export$e171bab687b50e0(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $8ae8a8807b0eb9f4$var$capBezierPoints(points, area);
}
/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
 * @private
 */ function $8ae8a8807b0eb9f4$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $8ae8a8807b0eb9f4$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $8ae8a8807b0eb9f4$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $8ae8a8807b0eb9f4$export$a17c37559e1db147(el, property) {
    return $8ae8a8807b0eb9f4$var$getComputedStyle(el).getPropertyValue(property);
}
const $8ae8a8807b0eb9f4$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $8ae8a8807b0eb9f4$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $8ae8a8807b0eb9f4$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $8ae8a8807b0eb9f4$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $8ae8a8807b0eb9f4$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($8ae8a8807b0eb9f4$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $8ae8a8807b0eb9f4$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $8ae8a8807b0eb9f4$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $8ae8a8807b0eb9f4$var$getPositionedStyle(style, 'padding');
    const borders = $8ae8a8807b0eb9f4$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $8ae8a8807b0eb9f4$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $8ae8a8807b0eb9f4$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $8ae8a8807b0eb9f4$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $8ae8a8807b0eb9f4$var$getComputedStyle(container);
            const containerBorder = $8ae8a8807b0eb9f4$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $8ae8a8807b0eb9f4$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $8ae8a8807b0eb9f4$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $8ae8a8807b0eb9f4$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $8ae8a8807b0eb9f4$export$2ec5befb9e6c97d4,
        maxHeight: maxHeight || $8ae8a8807b0eb9f4$export$2ec5befb9e6c97d4
    };
}
const $8ae8a8807b0eb9f4$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $8ae8a8807b0eb9f4$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $8ae8a8807b0eb9f4$var$getComputedStyle(canvas);
    const margins = $8ae8a8807b0eb9f4$var$getPositionedStyle(style, 'margin');
    const maxWidth = $8ae8a8807b0eb9f4$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $8ae8a8807b0eb9f4$export$2ec5befb9e6c97d4;
    const maxHeight = $8ae8a8807b0eb9f4$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $8ae8a8807b0eb9f4$export$2ec5befb9e6c97d4;
    const containerSize = $8ae8a8807b0eb9f4$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $8ae8a8807b0eb9f4$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $8ae8a8807b0eb9f4$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $8ae8a8807b0eb9f4$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $8ae8a8807b0eb9f4$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $8ae8a8807b0eb9f4$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $8ae8a8807b0eb9f4$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $8ae8a8807b0eb9f4$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $8ae8a8807b0eb9f4$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($8ae8a8807b0eb9f4$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $8ae8a8807b0eb9f4$export$b4171a6734a65d42(element, property) {
    const value = $8ae8a8807b0eb9f4$export$a17c37559e1db147(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$7a38258bbe170828(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $8ae8a8807b0eb9f4$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $8ae8a8807b0eb9f4$export$8a5498727ef6be21(p1, cp1, t);
    const b = $8ae8a8807b0eb9f4$export$8a5498727ef6be21(cp1, cp2, t);
    const c = $8ae8a8807b0eb9f4$export$8a5498727ef6be21(cp2, p2, t);
    const d = $8ae8a8807b0eb9f4$export$8a5498727ef6be21(a, b, t);
    const e = $8ae8a8807b0eb9f4$export$8a5498727ef6be21(b, c, t);
    return $8ae8a8807b0eb9f4$export$8a5498727ef6be21(d, e, t);
}
const $8ae8a8807b0eb9f4$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $8ae8a8807b0eb9f4$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $8ae8a8807b0eb9f4$export$3d12bd131bb975d1(rtl, rectX, width) {
    return rtl ? $8ae8a8807b0eb9f4$var$getRightToLeftAdapter(rectX, width) : $8ae8a8807b0eb9f4$var$getLeftToRightAdapter();
}
function $8ae8a8807b0eb9f4$export$91c6e00c14e7e6fd(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $8ae8a8807b0eb9f4$export$890c4ad488842ce7(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $8ae8a8807b0eb9f4$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $8ae8a8807b0eb9f4$export$ffb5f4729a158638,
        compare: $8ae8a8807b0eb9f4$export$c18d01048907ea92,
        normalize: $8ae8a8807b0eb9f4$export$28f7fcd39efa255
    };
    return {
        between: $8ae8a8807b0eb9f4$export$3b513254972cfc9c,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $8ae8a8807b0eb9f4$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $8ae8a8807b0eb9f4$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $8ae8a8807b0eb9f4$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $8ae8a8807b0eb9f4$export$9fa96a7d116ea3ce(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $8ae8a8807b0eb9f4$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $8ae8a8807b0eb9f4$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($8ae8a8807b0eb9f4$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($8ae8a8807b0eb9f4$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $8ae8a8807b0eb9f4$export$306ddfe3a8403e2(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $8ae8a8807b0eb9f4$export$9fa96a7d116ea3ce(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $8ae8a8807b0eb9f4$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $8ae8a8807b0eb9f4$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $8ae8a8807b0eb9f4$export$1a82df3d29112e01(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $8ae8a8807b0eb9f4$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $8ae8a8807b0eb9f4$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $8ae8a8807b0eb9f4$var$splitByStyles(line, $8ae8a8807b0eb9f4$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $8ae8a8807b0eb9f4$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $8ae8a8807b0eb9f4$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $8ae8a8807b0eb9f4$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $8ae8a8807b0eb9f4$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $8ae8a8807b0eb9f4$var$readStyle(segmentOptions.setContext($8ae8a8807b0eb9f4$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($8ae8a8807b0eb9f4$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $8ae8a8807b0eb9f4$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $8ae8a8807b0eb9f4$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$8ae8a8807b0eb9f4$export$f96d196f7728bb5(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}



class $e10a891308f0349c$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $8ae8a8807b0eb9f4$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $e10a891308f0349c$export$a424a0aa8f687495 = /* #__PURE__ */ new $e10a891308f0349c$var$Animator();
const $e10a891308f0349c$var$transparent = 'transparent';
const $e10a891308f0349c$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $8ae8a8807b0eb9f4$export$db3b6bfb95261072)(from || $e10a891308f0349c$var$transparent);
        const c1 = c0.valid && (0, $8ae8a8807b0eb9f4$export$db3b6bfb95261072)(to || $e10a891308f0349c$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $e10a891308f0349c$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $8ae8a8807b0eb9f4$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $8ae8a8807b0eb9f4$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $e10a891308f0349c$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $8ae8a8807b0eb9f4$export$f1e1789686576879)[cfg.easing] || (0, $8ae8a8807b0eb9f4$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $8ae8a8807b0eb9f4$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $8ae8a8807b0eb9f4$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $e10a891308f0349c$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $e10a891308f0349c$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $e10a891308f0349c$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $e10a891308f0349c$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $e10a891308f0349c$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $e10a891308f0349c$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $e10a891308f0349c$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $e10a891308f0349c$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $e10a891308f0349c$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $e10a891308f0349c$var$scaleClip(xScale, allowedOverflow);
    const y = $e10a891308f0349c$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $e10a891308f0349c$var$toClip(value) {
    let t, r, b, l;
    if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $e10a891308f0349c$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $e10a891308f0349c$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $8ae8a8807b0eb9f4$export$2408f22a0fab9ae5)(value) === (0, $8ae8a8807b0eb9f4$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    return value;
}
function $e10a891308f0349c$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $e10a891308f0349c$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $e10a891308f0349c$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $e10a891308f0349c$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $e10a891308f0349c$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $e10a891308f0349c$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $e10a891308f0349c$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $e10a891308f0349c$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $e10a891308f0349c$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $e10a891308f0349c$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $e10a891308f0349c$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $e10a891308f0349c$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $e10a891308f0349c$var$createDatasetContext(parent, index) {
    return (0, $8ae8a8807b0eb9f4$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $e10a891308f0349c$var$createDataContext(parent, index, element) {
    return (0, $8ae8a8807b0eb9f4$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $e10a891308f0349c$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $e10a891308f0349c$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $e10a891308f0349c$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $e10a891308f0349c$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $e10a891308f0349c$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $e10a891308f0349c$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $e10a891308f0349c$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $e10a891308f0349c$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(dataset.xAxisID, $e10a891308f0349c$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(dataset.yAxisID, $e10a891308f0349c$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(dataset.rAxisID, $e10a891308f0349c$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $8ae8a8807b0eb9f4$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $e10a891308f0349c$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(data)) this._data = $e10a891308f0349c$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $8ae8a8807b0eb9f4$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $e10a891308f0349c$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $8ae8a8807b0eb9f4$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $e10a891308f0349c$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $e10a891308f0349c$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $e10a891308f0349c$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $e10a891308f0349c$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $8ae8a8807b0eb9f4$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $8ae8a8807b0eb9f4$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $e10a891308f0349c$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $e10a891308f0349c$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $e10a891308f0349c$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $e10a891308f0349c$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $e10a891308f0349c$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $e10a891308f0349c$var$toClip((0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(this.options.clip, $e10a891308f0349c$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $e10a891308f0349c$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $e10a891308f0349c$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $8ae8a8807b0eb9f4$export$dda1d9f60106f0e9)(index);
        if (cached) return $e10a891308f0349c$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($e10a891308f0349c$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $e10a891308f0349c$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $e10a891308f0349c$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($e10a891308f0349c$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$e10a891308f0349c$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $e10a891308f0349c$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $e10a891308f0349c$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $8ae8a8807b0eb9f4$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $e10a891308f0349c$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $e10a891308f0349c$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $8ae8a8807b0eb9f4$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $e10a891308f0349c$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $e10a891308f0349c$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $e10a891308f0349c$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $e10a891308f0349c$var$parseValue(entry, item, vScale, i) {
    if ((0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(entry)) $e10a891308f0349c$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $e10a891308f0349c$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($e10a891308f0349c$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $e10a891308f0349c$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $e10a891308f0349c$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $8ae8a8807b0eb9f4$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $e10a891308f0349c$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $e10a891308f0349c$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $e10a891308f0349c$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$e10a891308f0349c$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$e10a891308f0349c$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $e10a891308f0349c$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $e10a891308f0349c$var$swap(edge, a, b);
        edge = $e10a891308f0349c$var$startEnd(edge, b, a);
    } else edge = $e10a891308f0349c$var$startEnd(edge, a, b);
    return edge;
}
function $e10a891308f0349c$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $e10a891308f0349c$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $e10a891308f0349c$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $e10a891308f0349c$export$e97d5dc64e999004 extends $e10a891308f0349c$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $e10a891308f0349c$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $e10a891308f0349c$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $8ae8a8807b0eb9f4$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($e10a891308f0349c$var$parseValue((0, $8ae8a8807b0eb9f4$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $e10a891308f0349c$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $e10a891308f0349c$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $e10a891308f0349c$var$setBorderSkipped(properties, options, stack, index);
            $e10a891308f0349c$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $e10a891308f0349c$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $e10a891308f0349c$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $8ae8a8807b0eb9f4$export$2408f22a0fab9ae5)(value) !== (0, $8ae8a8807b0eb9f4$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $e10a891308f0349c$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $8ae8a8807b0eb9f4$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $e10a891308f0349c$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $e10a891308f0349c$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
class $e10a891308f0349c$export$19b5c4773f17abe extends $e10a891308f0349c$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $e10a891308f0349c$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $8ae8a8807b0eb9f4$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $8ae8a8807b0eb9f4$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $8ae8a8807b0eb9f4$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $8ae8a8807b0eb9f4$export$56c0d5a1e737357d) + (0, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $e10a891308f0349c$export$e04603e7d8b77172 extends $e10a891308f0349c$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $8ae8a8807b0eb9f4$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $8ae8a8807b0eb9f4$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $8ae8a8807b0eb9f4$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7);
        let max = -(0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $8ae8a8807b0eb9f4$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $e10a891308f0349c$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $8ae8a8807b0eb9f4$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $8ae8a8807b0eb9f4$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $e10a891308f0349c$export$3c9b5d28c11cbfd0 extends $e10a891308f0349c$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $8ae8a8807b0eb9f4$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $8ae8a8807b0eb9f4$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $8ae8a8807b0eb9f4$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $e10a891308f0349c$export$2a270b3a0d973c85 extends $e10a891308f0349c$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $8ae8a8807b0eb9f4$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $8ae8a8807b0eb9f4$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $8ae8a8807b0eb9f4$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $8ae8a8807b0eb9f4$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $e10a891308f0349c$export$b21a3f1286706191 extends $e10a891308f0349c$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $e10a891308f0349c$export$48dbc6ac651bf8be extends $e10a891308f0349c$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $8ae8a8807b0eb9f4$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $e10a891308f0349c$export$b2f2bae6713db87 extends $e10a891308f0349c$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $8ae8a8807b0eb9f4$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $8ae8a8807b0eb9f4$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $8ae8a8807b0eb9f4$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $e10a891308f0349c$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $e10a891308f0349c$export$e97d5dc64e999004,
    BubbleController: $e10a891308f0349c$export$19b5c4773f17abe,
    DoughnutController: $e10a891308f0349c$export$e04603e7d8b77172,
    LineController: $e10a891308f0349c$export$3c9b5d28c11cbfd0,
    PieController: $e10a891308f0349c$export$b21a3f1286706191,
    PolarAreaController: $e10a891308f0349c$export$2a270b3a0d973c85,
    RadarController: $e10a891308f0349c$export$48dbc6ac651bf8be,
    ScatterController: $e10a891308f0349c$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $e10a891308f0349c$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $e10a891308f0349c$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($e10a891308f0349c$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $e10a891308f0349c$var$abstract();
    }
    parse() {
        return $e10a891308f0349c$var$abstract();
    }
    format() {
        return $e10a891308f0349c$var$abstract();
    }
    add() {
        return $e10a891308f0349c$var$abstract();
    }
    diff() {
        return $e10a891308f0349c$var$abstract();
    }
    startOf() {
        return $e10a891308f0349c$var$abstract();
    }
    endOf() {
        return $e10a891308f0349c$var$abstract();
    }
}
var $e10a891308f0349c$export$f32766ea09ec8bc4 = {
    _date: $e10a891308f0349c$var$DateAdapterBase
};
function $e10a891308f0349c$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $8ae8a8807b0eb9f4$export$ebd11618f299a286) : (0, $8ae8a8807b0eb9f4$export$ef35774e6d314e91);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $e10a891308f0349c$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $e10a891308f0349c$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $e10a891308f0349c$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $e10a891308f0349c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $8ae8a8807b0eb9f4$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $e10a891308f0349c$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $e10a891308f0349c$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $8ae8a8807b0eb9f4$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $8ae8a8807b0eb9f4$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $e10a891308f0349c$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $e10a891308f0349c$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $e10a891308f0349c$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $e10a891308f0349c$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $e10a891308f0349c$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $e10a891308f0349c$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $e10a891308f0349c$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $e10a891308f0349c$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $e10a891308f0349c$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $e10a891308f0349c$export$a13296960cae0384 = {
    evaluateInteractionItems: $e10a891308f0349c$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $8ae8a8807b0eb9f4$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $e10a891308f0349c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $e10a891308f0349c$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $8ae8a8807b0eb9f4$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $e10a891308f0349c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $e10a891308f0349c$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $8ae8a8807b0eb9f4$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $e10a891308f0349c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $8ae8a8807b0eb9f4$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $e10a891308f0349c$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $8ae8a8807b0eb9f4$export$df995fae86a55f06)(e, chart);
            return $e10a891308f0349c$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $8ae8a8807b0eb9f4$export$df995fae86a55f06)(e, chart);
            return $e10a891308f0349c$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $e10a891308f0349c$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $e10a891308f0349c$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $e10a891308f0349c$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$e10a891308f0349c$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $e10a891308f0349c$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $e10a891308f0349c$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $e10a891308f0349c$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$e10a891308f0349c$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $e10a891308f0349c$var$setLayoutDims(layouts, params) {
    const stacks = $e10a891308f0349c$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $e10a891308f0349c$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $e10a891308f0349c$var$wrapBoxes(boxes);
    const fullSize = $e10a891308f0349c$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $e10a891308f0349c$var$sortByWeight($e10a891308f0349c$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $e10a891308f0349c$var$sortByWeight($e10a891308f0349c$var$filterByPosition(layoutBoxes, 'right'));
    const top = $e10a891308f0349c$var$sortByWeight($e10a891308f0349c$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $e10a891308f0349c$var$sortByWeight($e10a891308f0349c$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $e10a891308f0349c$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $e10a891308f0349c$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $e10a891308f0349c$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $e10a891308f0349c$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $e10a891308f0349c$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $e10a891308f0349c$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $e10a891308f0349c$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $e10a891308f0349c$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $e10a891308f0349c$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $e10a891308f0349c$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $e10a891308f0349c$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $e10a891308f0349c$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $e10a891308f0349c$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $e10a891308f0349c$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $e10a891308f0349c$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $e10a891308f0349c$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $e10a891308f0349c$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $8ae8a8807b0eb9f4$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $e10a891308f0349c$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $e10a891308f0349c$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $8ae8a8807b0eb9f4$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $e10a891308f0349c$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $e10a891308f0349c$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $e10a891308f0349c$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $e10a891308f0349c$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $e10a891308f0349c$var$updateMaxPadding(maxPadding, (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $e10a891308f0349c$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $e10a891308f0349c$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $e10a891308f0349c$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($e10a891308f0349c$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $e10a891308f0349c$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $e10a891308f0349c$var$handleMaxPadding(chartArea);
        $e10a891308f0349c$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $e10a891308f0349c$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $e10a891308f0349c$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $e10a891308f0349c$export$a40a96b24b46cf35 extends $e10a891308f0349c$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $e10a891308f0349c$var$EXPANDO_KEY = '$chartjs';
const $e10a891308f0349c$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $e10a891308f0349c$var$isNullOrEmpty = (value)=>value === null || value === '';
function $e10a891308f0349c$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$e10a891308f0349c$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($e10a891308f0349c$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $8ae8a8807b0eb9f4$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($e10a891308f0349c$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $8ae8a8807b0eb9f4$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $e10a891308f0349c$var$eventListenerOptions = (0, $8ae8a8807b0eb9f4$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $e10a891308f0349c$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $e10a891308f0349c$var$eventListenerOptions);
}
function $e10a891308f0349c$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $e10a891308f0349c$var$eventListenerOptions);
}
function $e10a891308f0349c$var$fromNativeEvent(event, chart) {
    const type = $e10a891308f0349c$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $8ae8a8807b0eb9f4$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $e10a891308f0349c$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $e10a891308f0349c$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $e10a891308f0349c$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$e10a891308f0349c$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $e10a891308f0349c$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $e10a891308f0349c$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$e10a891308f0349c$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $e10a891308f0349c$var$drpListeningCharts = new Map();
let $e10a891308f0349c$var$oldDevicePixelRatio = 0;
function $e10a891308f0349c$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $e10a891308f0349c$var$oldDevicePixelRatio) return;
    $e10a891308f0349c$var$oldDevicePixelRatio = dpr;
    $e10a891308f0349c$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $e10a891308f0349c$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$e10a891308f0349c$var$drpListeningCharts.size) window.addEventListener('resize', $e10a891308f0349c$var$onWindowResize);
    $e10a891308f0349c$var$drpListeningCharts.set(chart, resize);
}
function $e10a891308f0349c$var$unlistenDevicePixelRatioChanges(chart) {
    $e10a891308f0349c$var$drpListeningCharts.delete(chart);
    if (!$e10a891308f0349c$var$drpListeningCharts.size) window.removeEventListener('resize', $e10a891308f0349c$var$onWindowResize);
}
function $e10a891308f0349c$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $8ae8a8807b0eb9f4$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $8ae8a8807b0eb9f4$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $e10a891308f0349c$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $e10a891308f0349c$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $e10a891308f0349c$var$unlistenDevicePixelRatioChanges(chart);
}
function $e10a891308f0349c$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $8ae8a8807b0eb9f4$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($e10a891308f0349c$var$fromNativeEvent(event, chart));
    }, chart);
    $e10a891308f0349c$var$addListener(canvas, type, proxy);
    return proxy;
}
class $e10a891308f0349c$export$f02da7f882cf6b2e extends $e10a891308f0349c$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $e10a891308f0349c$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$e10a891308f0349c$var$EXPANDO_KEY]) return false;
        const initial = canvas[$e10a891308f0349c$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$e10a891308f0349c$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $e10a891308f0349c$var$createAttachObserver,
            detach: $e10a891308f0349c$var$createDetachObserver,
            resize: $e10a891308f0349c$var$createResizeObserver
        };
        const handler = handlers[type] || $e10a891308f0349c$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $e10a891308f0349c$var$releaseObserver,
            detach: $e10a891308f0349c$var$releaseObserver,
            resize: $e10a891308f0349c$var$releaseObserver
        };
        const handler = handlers[type] || $e10a891308f0349c$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $8ae8a8807b0eb9f4$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $8ae8a8807b0eb9f4$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $e10a891308f0349c$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $8ae8a8807b0eb9f4$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $e10a891308f0349c$export$a40a96b24b46cf35;
    return $e10a891308f0349c$export$f02da7f882cf6b2e;
}
class $e10a891308f0349c$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $8ae8a8807b0eb9f4$export$d141bba7fdc215a3)(this.x) && (0, $8ae8a8807b0eb9f4$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $e10a891308f0349c$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $e10a891308f0349c$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $e10a891308f0349c$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $e10a891308f0349c$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $e10a891308f0349c$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $e10a891308f0349c$var$skip(ticks, newTicks, spacing, (0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$e10a891308f0349c$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $e10a891308f0349c$var$skip(ticks, newTicks, spacing, last, (0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $e10a891308f0349c$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $e10a891308f0349c$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $e10a891308f0349c$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $e10a891308f0349c$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $8ae8a8807b0eb9f4$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $e10a891308f0349c$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $e10a891308f0349c$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $e10a891308f0349c$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $e10a891308f0349c$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $e10a891308f0349c$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $e10a891308f0349c$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $e10a891308f0349c$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $e10a891308f0349c$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $e10a891308f0349c$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $e10a891308f0349c$var$garbageCollect(caches, length) {
    (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $e10a891308f0349c$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $e10a891308f0349c$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $e10a891308f0349c$var$createScaleContext(parent, scale) {
    return (0, $8ae8a8807b0eb9f4$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $e10a891308f0349c$var$createTickContext(parent, index, tick) {
    return (0, $8ae8a8807b0eb9f4$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $e10a891308f0349c$var$titleAlign(align, position, reverse) {
    let ret = (0, $8ae8a8807b0eb9f4$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $e10a891308f0349c$var$reverseAlign(ret);
    return ret;
}
function $e10a891308f0349c$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $e10a891308f0349c$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $e10a891308f0349c$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd) : (0, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $e10a891308f0349c$export$d60cfc58d3c358b6 extends $e10a891308f0349c$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(min, (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(max, min)),
            max: (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(max, (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $8ae8a8807b0eb9f4$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $e10a891308f0349c$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $e10a891308f0349c$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $e10a891308f0349c$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $e10a891308f0349c$var$getTickMarkLength(options.grid) - tickOpts.padding - $e10a891308f0349c$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $8ae8a8807b0eb9f4$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $e10a891308f0349c$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $e10a891308f0349c$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $e10a891308f0349c$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $8ae8a8807b0eb9f4$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $e10a891308f0349c$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $e10a891308f0349c$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(label) && !(0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(label)) {
                width = (0, $8ae8a8807b0eb9f4$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(nestedLabel) && !(0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $8ae8a8807b0eb9f4$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $e10a891308f0349c$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $8ae8a8807b0eb9f4$export$71cec2538cb2c617)(this._alignToPixels ? (0, $8ae8a8807b0eb9f4$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $e10a891308f0349c$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $e10a891308f0349c$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $8ae8a8807b0eb9f4$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $e10a891308f0349c$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $8ae8a8807b0eb9f4$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $e10a891308f0349c$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $8ae8a8807b0eb9f4$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $e10a891308f0349c$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $8ae8a8807b0eb9f4$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $8ae8a8807b0eb9f4$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $8ae8a8807b0eb9f4$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $8ae8a8807b0eb9f4$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $8ae8a8807b0eb9f4$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $8ae8a8807b0eb9f4$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $8ae8a8807b0eb9f4$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $8ae8a8807b0eb9f4$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $8ae8a8807b0eb9f4$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(title.font);
        const padding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $e10a891308f0349c$var$titleArgs(this, offset, position, align);
        (0, $8ae8a8807b0eb9f4$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $e10a891308f0349c$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $e10a891308f0349c$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $e10a891308f0349c$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($e10a891308f0349c$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $e10a891308f0349c$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0)[scope]) {
            delete (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $8ae8a8807b0eb9f4$export$6559d589eb85fbb6)[id];
        }
    }
}
function $e10a891308f0349c$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $8ae8a8807b0eb9f4$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $e10a891308f0349c$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $e10a891308f0349c$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $e10a891308f0349c$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $e10a891308f0349c$var$Registry {
    constructor(){
        this.controllers = new $e10a891308f0349c$var$TypedRegistry($e10a891308f0349c$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $e10a891308f0349c$var$TypedRegistry($e10a891308f0349c$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $e10a891308f0349c$var$TypedRegistry(Object, 'plugins');
        this.scales = new $e10a891308f0349c$var$TypedRegistry($e10a891308f0349c$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $8ae8a8807b0eb9f4$export$a8550f7dbe79f93a)(method);
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $e10a891308f0349c$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $e10a891308f0349c$var$Registry();
class $e10a891308f0349c$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $e10a891308f0349c$var$allPlugins(config);
        return options === false && !all ? [] : $e10a891308f0349c$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $e10a891308f0349c$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($e10a891308f0349c$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($e10a891308f0349c$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $e10a891308f0349c$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $e10a891308f0349c$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $e10a891308f0349c$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $e10a891308f0349c$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $e10a891308f0349c$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $e10a891308f0349c$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $e10a891308f0349c$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $e10a891308f0349c$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $e10a891308f0349c$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $e10a891308f0349c$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $e10a891308f0349c$var$determineAxis(id, ...scaleOptions) {
    if ($e10a891308f0349c$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $e10a891308f0349c$var$axisFromPosition(opts.position) || id.length > 1 && $e10a891308f0349c$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $e10a891308f0349c$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $e10a891308f0349c$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $e10a891308f0349c$var$getAxisFromDataset(id, 'x', boundDs[0]) || $e10a891308f0349c$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $e10a891308f0349c$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $8ae8a8807b0eb9f4$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $e10a891308f0349c$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $e10a891308f0349c$var$determineAxis(id, scaleConf, $e10a891308f0349c$var$retrieveAxisFromDatasets(id, config), (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $e10a891308f0349c$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $8ae8a8807b0eb9f4$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $e10a891308f0349c$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $8ae8a8807b0eb9f4$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $e10a891308f0349c$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $8ae8a8807b0eb9f4$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $8ae8a8807b0eb9f4$export$555508cbc6add439)(scale, [
            (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).scales[scale.type],
            (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $e10a891308f0349c$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $e10a891308f0349c$var$mergeScaleConfig(config, options);
}
function $e10a891308f0349c$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $e10a891308f0349c$var$initConfig(config) {
    config = config || {};
    config.data = $e10a891308f0349c$var$initData(config.data);
    $e10a891308f0349c$var$initOptions(config);
    return config;
}
const $e10a891308f0349c$var$keyCache = new Map();
const $e10a891308f0349c$var$keysCached = new Set();
function $e10a891308f0349c$var$cachedKeys(cacheKey, generate) {
    let keys = $e10a891308f0349c$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $e10a891308f0349c$var$keyCache.set(cacheKey, keys);
        $e10a891308f0349c$var$keysCached.add(keys);
    }
    return keys;
}
const $e10a891308f0349c$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $8ae8a8807b0eb9f4$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $e10a891308f0349c$var$Config {
    constructor(config){
        this._config = $e10a891308f0349c$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $e10a891308f0349c$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $e10a891308f0349c$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $e10a891308f0349c$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $e10a891308f0349c$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $e10a891308f0349c$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $e10a891308f0349c$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$e10a891308f0349c$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$e10a891308f0349c$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$e10a891308f0349c$var$addIfFound(scopes, (0, $8ae8a8807b0eb9f4$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$e10a891308f0349c$var$addIfFound(scopes, (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$e10a891308f0349c$var$addIfFound(scopes, (0, $8ae8a8807b0eb9f4$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($e10a891308f0349c$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $8ae8a8807b0eb9f4$export$6559d589eb85fbb6)[type] || {},
            (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0),
            (0, $8ae8a8807b0eb9f4$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $e10a891308f0349c$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($e10a891308f0349c$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $8ae8a8807b0eb9f4$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $8ae8a8807b0eb9f4$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $e10a891308f0349c$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(context) ? (0, $8ae8a8807b0eb9f4$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $e10a891308f0349c$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $8ae8a8807b0eb9f4$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $e10a891308f0349c$var$hasFunction = (value)=>(0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $8ae8a8807b0eb9f4$export$a93c5207d687da10)(value[key]));
function $e10a891308f0349c$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $8ae8a8807b0eb9f4$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $8ae8a8807b0eb9f4$export$a93c5207d687da10)(value) || $e10a891308f0349c$var$hasFunction(value)) || indexable && (0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $e10a891308f0349c$var$version = "4.4.2";
const $e10a891308f0349c$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $e10a891308f0349c$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $e10a891308f0349c$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $e10a891308f0349c$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $e10a891308f0349c$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $e10a891308f0349c$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $e10a891308f0349c$var$getCanvas(item) {
    if ((0, $8ae8a8807b0eb9f4$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $e10a891308f0349c$var$instances = {};
const $e10a891308f0349c$var$getChart = (key)=>{
    const canvas = $e10a891308f0349c$var$getCanvas(key);
    return Object.values($e10a891308f0349c$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $e10a891308f0349c$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $e10a891308f0349c$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
function $e10a891308f0349c$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $e10a891308f0349c$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $e10a891308f0349c$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $e10a891308f0349c$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $e10a891308f0349c$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $e10a891308f0349c$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
class $e10a891308f0349c$export$acaa6426d77a227e {
    static defaults = (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0);
    static instances = $e10a891308f0349c$var$instances;
    static overrides = (0, $8ae8a8807b0eb9f4$export$6559d589eb85fbb6);
    static registry = $e10a891308f0349c$export$4bb7493d241fd8a5;
    static version = $e10a891308f0349c$var$version;
    static getChart = $e10a891308f0349c$var$getChart;
    static register(...items) {
        $e10a891308f0349c$export$4bb7493d241fd8a5.add(...items);
        $e10a891308f0349c$var$invalidatePlugins();
    }
    static unregister(...items) {
        $e10a891308f0349c$export$4bb7493d241fd8a5.remove(...items);
        $e10a891308f0349c$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $e10a891308f0349c$var$Config(userConfig);
        const initialCanvas = $e10a891308f0349c$var$getCanvas(item);
        const existingChart = $e10a891308f0349c$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $e10a891308f0349c$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $8ae8a8807b0eb9f4$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $e10a891308f0349c$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $8ae8a8807b0eb9f4$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $e10a891308f0349c$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $e10a891308f0349c$export$a424a0aa8f687495.listen(this, 'complete', $e10a891308f0349c$var$onAnimationsComplete);
        $e10a891308f0349c$export$a424a0aa8f687495.listen(this, 'progress', $e10a891308f0349c$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $e10a891308f0349c$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $8ae8a8807b0eb9f4$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $8ae8a8807b0eb9f4$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $e10a891308f0349c$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$e10a891308f0349c$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $8ae8a8807b0eb9f4$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $e10a891308f0349c$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $e10a891308f0349c$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $e10a891308f0349c$var$positionIsHorizontal(scaleOptions.position, axis) !== $e10a891308f0349c$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $e10a891308f0349c$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(scales, (scale)=>{
            $e10a891308f0349c$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $e10a891308f0349c$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($e10a891308f0349c$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $e10a891308f0349c$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $e10a891308f0349c$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $e10a891308f0349c$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $e10a891308f0349c$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($e10a891308f0349c$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(this.scales, (scale)=>{
            $e10a891308f0349c$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $8ae8a8807b0eb9f4$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $e10a891308f0349c$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $8ae8a8807b0eb9f4$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $e10a891308f0349c$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $8ae8a8807b0eb9f4$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($e10a891308f0349c$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$e10a891308f0349c$export$a424a0aa8f687495.running(this)) $e10a891308f0349c$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $e10a891308f0349c$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = $e10a891308f0349c$var$getDatasetArea(meta, this.chartArea);
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (useClip) (0, $8ae8a8807b0eb9f4$export$8743009a87fcb00f)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $8ae8a8807b0eb9f4$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $8ae8a8807b0eb9f4$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $e10a891308f0349c$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $8ae8a8807b0eb9f4$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $8ae8a8807b0eb9f4$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $e10a891308f0349c$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $8ae8a8807b0eb9f4$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $e10a891308f0349c$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $8ae8a8807b0eb9f4$export$995eb9fca571757)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $8ae8a8807b0eb9f4$export$f38c853ae54ed474)(e);
        const lastEvent = $e10a891308f0349c$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $8ae8a8807b0eb9f4$export$995eb9fca571757)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $e10a891308f0349c$var$invalidatePlugins() {
    return (0, $8ae8a8807b0eb9f4$export$d66501df72047452)($e10a891308f0349c$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $e10a891308f0349c$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd), startAngle - (0, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $e10a891308f0349c$var$toRadiusCorners(value) {
    return (0, $8ae8a8807b0eb9f4$export$21579262ef46735b)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $e10a891308f0349c$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $e10a891308f0349c$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $e10a891308f0349c$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $e10a891308f0349c$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $8ae8a8807b0eb9f4$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $e10a891308f0349c$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $e10a891308f0349c$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $e10a891308f0349c$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $e10a891308f0349c$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $e10a891308f0349c$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $e10a891308f0349c$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $e10a891308f0349c$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $e10a891308f0349c$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $e10a891308f0349c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7) || (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7));
    }
    $e10a891308f0349c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $e10a891308f0349c$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $e10a891308f0349c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7) || (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7));
    }
    if (inner) $e10a891308f0349c$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $e10a891308f0349c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $e10a891308f0349c$export$d48203c759d6a1fc extends $e10a891308f0349c$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $8ae8a8807b0eb9f4$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7) || (0, $8ae8a8807b0eb9f4$export$ffb5f4729a158638)(angle, startAngle, endAngle);
        const withinRadius = (0, $8ae8a8807b0eb9f4$export$3b513254972cfc9c)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $8ae8a8807b0eb9f4$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $e10a891308f0349c$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $e10a891308f0349c$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $e10a891308f0349c$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $e10a891308f0349c$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $e10a891308f0349c$var$getLineMethod(options) {
    if (options.stepped) return 0, $8ae8a8807b0eb9f4$export$d24c54395ce0c509;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $8ae8a8807b0eb9f4$export$6554612db691658e;
    return $e10a891308f0349c$var$lineTo;
}
function $e10a891308f0349c$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $e10a891308f0349c$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $e10a891308f0349c$var$pathVars(points, segment, params);
    const lineMethod = $e10a891308f0349c$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $e10a891308f0349c$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $e10a891308f0349c$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $e10a891308f0349c$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $e10a891308f0349c$var$fastPathSegment : $e10a891308f0349c$var$pathSegment;
}
function $e10a891308f0349c$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $8ae8a8807b0eb9f4$export$7a38258bbe170828;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $8ae8a8807b0eb9f4$export$2f6ca3d3b1f80bf5;
    return 0, $8ae8a8807b0eb9f4$export$8a5498727ef6be21;
}
function $e10a891308f0349c$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $e10a891308f0349c$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $e10a891308f0349c$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $e10a891308f0349c$var$_getSegmentMethod(line);
    for (const segment of segments){
        $e10a891308f0349c$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $e10a891308f0349c$var$usePath2D = typeof Path2D === 'function';
function $e10a891308f0349c$var$draw(ctx, line, start, count) {
    if ($e10a891308f0349c$var$usePath2D && !line.options.segment) $e10a891308f0349c$var$strokePathWithCache(ctx, line, start, count);
    else $e10a891308f0349c$var$strokePathDirect(ctx, line, start, count);
}
class $e10a891308f0349c$export$55e463fa7bcd3469 extends $e10a891308f0349c$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $8ae8a8807b0eb9f4$export$ab83b03e4111b1d0)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $8ae8a8807b0eb9f4$export$1a82df3d29112e01)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $8ae8a8807b0eb9f4$export$306ddfe3a8403e2)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $e10a891308f0349c$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $e10a891308f0349c$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $e10a891308f0349c$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $e10a891308f0349c$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $e10a891308f0349c$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $e10a891308f0349c$export$bd159b522b230b7a extends $e10a891308f0349c$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $e10a891308f0349c$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $e10a891308f0349c$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $8ae8a8807b0eb9f4$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $8ae8a8807b0eb9f4$export$493d36ec626b6698)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $e10a891308f0349c$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $e10a891308f0349c$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)(value, min, max);
}
function $e10a891308f0349c$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $8ae8a8807b0eb9f4$export$d66dc83d8cfc8dd)(value);
    return {
        t: $e10a891308f0349c$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $e10a891308f0349c$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $e10a891308f0349c$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $e10a891308f0349c$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $e10a891308f0349c$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $8ae8a8807b0eb9f4$export$92108d983e8ee699)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $e10a891308f0349c$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $e10a891308f0349c$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $e10a891308f0349c$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $e10a891308f0349c$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $e10a891308f0349c$var$boundingRects(bar) {
    const bounds = $e10a891308f0349c$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $e10a891308f0349c$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $e10a891308f0349c$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $e10a891308f0349c$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $e10a891308f0349c$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $8ae8a8807b0eb9f4$export$3b513254972cfc9c)(x, bounds.left, bounds.right)) && (skipY || (0, $8ae8a8807b0eb9f4$export$3b513254972cfc9c)(y, bounds.top, bounds.bottom));
}
function $e10a891308f0349c$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $e10a891308f0349c$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $e10a891308f0349c$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $e10a891308f0349c$export$a16ed71bf4b07672 extends $e10a891308f0349c$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $e10a891308f0349c$var$boundingRects(this);
        const addRectPath = $e10a891308f0349c$var$hasRadius(outer.radius) ? (0, $8ae8a8807b0eb9f4$export$1fbe638ecf81657e) : $e10a891308f0349c$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $e10a891308f0349c$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $e10a891308f0349c$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $e10a891308f0349c$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $e10a891308f0349c$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $e10a891308f0349c$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $e10a891308f0349c$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $e10a891308f0349c$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $e10a891308f0349c$export$d48203c759d6a1fc,
    BarElement: $e10a891308f0349c$export$a16ed71bf4b07672,
    LineElement: $e10a891308f0349c$export$55e463fa7bcd3469,
    PointElement: $e10a891308f0349c$export$bd159b522b230b7a
});
const $e10a891308f0349c$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $e10a891308f0349c$var$BACKGROUND_COLORS = /* #__PURE__ */ $e10a891308f0349c$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $e10a891308f0349c$var$getBorderColor(i) {
    return $e10a891308f0349c$var$BORDER_COLORS[i % $e10a891308f0349c$var$BORDER_COLORS.length];
}
function $e10a891308f0349c$var$getBackgroundColor(i) {
    return $e10a891308f0349c$var$BACKGROUND_COLORS[i % $e10a891308f0349c$var$BACKGROUND_COLORS.length];
}
function $e10a891308f0349c$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $e10a891308f0349c$var$getBorderColor(i);
    dataset.backgroundColor = $e10a891308f0349c$var$getBackgroundColor(i);
    return ++i;
}
function $e10a891308f0349c$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$e10a891308f0349c$var$getBorderColor(i++));
    return i;
}
function $e10a891308f0349c$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$e10a891308f0349c$var$getBackgroundColor(i++));
    return i;
}
function $e10a891308f0349c$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $e10a891308f0349c$export$e04603e7d8b77172) i = $e10a891308f0349c$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $e10a891308f0349c$export$2a270b3a0d973c85) i = $e10a891308f0349c$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $e10a891308f0349c$var$colorizeDefaultDataset(dataset, i);
    };
}
function $e10a891308f0349c$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $e10a891308f0349c$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
var $e10a891308f0349c$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        if (!options.forceOverride && ($e10a891308f0349c$var$containsColorsDefinitions(datasets) || $e10a891308f0349c$var$containsColorsDefinition(chartOptions) || elements && $e10a891308f0349c$var$containsColorsDefinitions(elements))) return;
        const colorizer = $e10a891308f0349c$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $e10a891308f0349c$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $e10a891308f0349c$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(minIndex) && !(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $e10a891308f0349c$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $e10a891308f0349c$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $e10a891308f0349c$var$cleanDecimatedDataset(dataset);
    });
}
function $e10a891308f0349c$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)((0, $8ae8a8807b0eb9f4$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)((0, $8ae8a8807b0eb9f4$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $e10a891308f0349c$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $e10a891308f0349c$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $8ae8a8807b0eb9f4$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $e10a891308f0349c$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $e10a891308f0349c$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $e10a891308f0349c$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $e10a891308f0349c$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $e10a891308f0349c$var$cleanDecimatedData(chart);
    }
};
function $e10a891308f0349c$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $e10a891308f0349c$var$_findSegmentEnd(start, end, points);
        const bounds = $e10a891308f0349c$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $8ae8a8807b0eb9f4$export$306ddfe3a8403e2)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $e10a891308f0349c$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $8ae8a8807b0eb9f4$export$9fa96a7d116ea3ce)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $e10a891308f0349c$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $e10a891308f0349c$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $e10a891308f0349c$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $8ae8a8807b0eb9f4$export$28f7fcd39efa255)(start);
        end = (0, $8ae8a8807b0eb9f4$export$28f7fcd39efa255)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $e10a891308f0349c$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $e10a891308f0349c$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $e10a891308f0349c$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $e10a891308f0349c$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $e10a891308f0349c$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $e10a891308f0349c$var$_pointsFromSegments(boundary, line);
    return points.length ? new $e10a891308f0349c$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $e10a891308f0349c$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $e10a891308f0349c$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $e10a891308f0349c$var$_decodeFill(line, index, count) {
    const fill = $e10a891308f0349c$var$parseFillOption(line);
    if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $e10a891308f0349c$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $e10a891308f0349c$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $e10a891308f0349c$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $e10a891308f0349c$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $e10a891308f0349c$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $e10a891308f0349c$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $e10a891308f0349c$var$getLinesBelow(scale, index);
    linesBelow.push($e10a891308f0349c$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$e10a891308f0349c$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $e10a891308f0349c$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $e10a891308f0349c$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $e10a891308f0349c$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $e10a891308f0349c$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $e10a891308f0349c$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $8ae8a8807b0eb9f4$export$3b513254972cfc9c)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $e10a891308f0349c$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $e10a891308f0349c$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(fill)) return $e10a891308f0349c$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $e10a891308f0349c$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $e10a891308f0349c$var$computeBoundary(source);
    if (boundary instanceof $e10a891308f0349c$var$simpleArc) return boundary;
    return $e10a891308f0349c$var$_createBoundaryLine(boundary, line);
}
function $e10a891308f0349c$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $e10a891308f0349c$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $e10a891308f0349c$var$computeCircularBoundary(source);
    return $e10a891308f0349c$var$computeLinearBoundary(source);
}
function $e10a891308f0349c$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $e10a891308f0349c$var$_getTargetPixel(fill, scale);
    if ((0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $e10a891308f0349c$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $e10a891308f0349c$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $e10a891308f0349c$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $e10a891308f0349c$var$_drawfill(ctx, source, area) {
    const target = $e10a891308f0349c$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $8ae8a8807b0eb9f4$export$8743009a87fcb00f)(ctx, area);
        $e10a891308f0349c$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $8ae8a8807b0eb9f4$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $e10a891308f0349c$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        $e10a891308f0349c$var$clipVertical(ctx, target, area.top);
        $e10a891308f0349c$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $e10a891308f0349c$var$clipVertical(ctx, target, area.bottom);
    }
    $e10a891308f0349c$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $e10a891308f0349c$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$e10a891308f0349c$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $e10a891308f0349c$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $e10a891308f0349c$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $e10a891308f0349c$var$clipBounds(ctx, scale, notShape && $e10a891308f0349c$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $e10a891308f0349c$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $e10a891308f0349c$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $e10a891308f0349c$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x') {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $e10a891308f0349c$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $e10a891308f0349c$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $e10a891308f0349c$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $e10a891308f0349c$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $e10a891308f0349c$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $e10a891308f0349c$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($e10a891308f0349c$var$_shouldApplyFill(source)) $e10a891308f0349c$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$e10a891308f0349c$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $e10a891308f0349c$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $e10a891308f0349c$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $e10a891308f0349c$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $e10a891308f0349c$var$Legend extends $e10a891308f0349c$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $e10a891308f0349c$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $e10a891308f0349c$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $8ae8a8807b0eb9f4$export$3d12bd131bb975d1)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $8ae8a8807b0eb9f4$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $8ae8a8807b0eb9f4$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $8ae8a8807b0eb9f4$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const labelFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $e10a891308f0349c$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $8ae8a8807b0eb9f4$export$24baa2b76016ce0e)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $8ae8a8807b0eb9f4$export$92108d983e8ee699)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $8ae8a8807b0eb9f4$export$1fbe638ecf81657e)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $8ae8a8807b0eb9f4$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $8ae8a8807b0eb9f4$export$91c6e00c14e7e6fd)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $8ae8a8807b0eb9f4$export$9d398bebfec1c039)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $e10a891308f0349c$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $8ae8a8807b0eb9f4$export$890c4ad488842ce7)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $8ae8a8807b0eb9f4$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $8ae8a8807b0eb9f4$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $8ae8a8807b0eb9f4$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $8ae8a8807b0eb9f4$export$3b513254972cfc9c)(x, this.left, this.right) && (0, $8ae8a8807b0eb9f4$export$3b513254972cfc9c)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $8ae8a8807b0eb9f4$export$3b513254972cfc9c)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $8ae8a8807b0eb9f4$export$3b513254972cfc9c)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$e10a891308f0349c$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $e10a891308f0349c$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $e10a891308f0349c$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $e10a891308f0349c$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $e10a891308f0349c$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $e10a891308f0349c$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $e10a891308f0349c$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $e10a891308f0349c$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $e10a891308f0349c$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $e10a891308f0349c$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $e10a891308f0349c$export$ed247974535929c7 = {
    id: 'legend',
    _element: $e10a891308f0349c$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $e10a891308f0349c$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $e10a891308f0349c$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $e10a891308f0349c$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $e10a891308f0349c$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $e10a891308f0349c$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $e10a891308f0349c$var$Title extends $e10a891308f0349c$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $8ae8a8807b0eb9f4$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $8ae8a8807b0eb9f4$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $8ae8a8807b0eb9f4$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $8ae8a8807b0eb9f4$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $8ae8a8807b0eb9f4$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $e10a891308f0349c$var$createTitle(chart, titleOpts) {
    const title = new $e10a891308f0349c$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $e10a891308f0349c$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $e10a891308f0349c$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $e10a891308f0349c$export$f99233281efd08a0 = {
    id: 'title',
    _element: $e10a891308f0349c$var$Title,
    start (chart, _args, options) {
        $e10a891308f0349c$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $e10a891308f0349c$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $e10a891308f0349c$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $e10a891308f0349c$var$map = new WeakMap();
var $e10a891308f0349c$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $e10a891308f0349c$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $e10a891308f0349c$export$1ecca0613f5e56d2.configure(chart, title, options);
        $e10a891308f0349c$export$1ecca0613f5e56d2.addBox(chart, title);
        $e10a891308f0349c$var$map.set(chart, title);
    },
    stop (chart) {
        $e10a891308f0349c$export$1ecca0613f5e56d2.removeBox(chart, $e10a891308f0349c$var$map.get(chart));
        $e10a891308f0349c$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $e10a891308f0349c$var$map.get(chart);
        $e10a891308f0349c$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $e10a891308f0349c$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $8ae8a8807b0eb9f4$export$158acd800e1ef08b)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $e10a891308f0349c$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $e10a891308f0349c$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $e10a891308f0349c$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $e10a891308f0349c$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $e10a891308f0349c$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $e10a891308f0349c$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $e10a891308f0349c$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($e10a891308f0349c$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $e10a891308f0349c$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $e10a891308f0349c$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $e10a891308f0349c$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $e10a891308f0349c$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $e10a891308f0349c$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $e10a891308f0349c$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $8ae8a8807b0eb9f4$export$92108d983e8ee699)(cornerRadius);
    let x = $e10a891308f0349c$var$alignX(size, xAlign);
    const y = $e10a891308f0349c$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $e10a891308f0349c$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $e10a891308f0349c$var$getBeforeAfterBodyLines(callback) {
    return $e10a891308f0349c$var$pushOrConcat([], $e10a891308f0349c$var$splitNewlines(callback));
}
function $e10a891308f0349c$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $8ae8a8807b0eb9f4$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $e10a891308f0349c$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $e10a891308f0349c$var$defaultCallbacks = {
    beforeTitle: (0, $8ae8a8807b0eb9f4$export$cf2f7c5792f80b46),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $8ae8a8807b0eb9f4$export$cf2f7c5792f80b46),
    beforeBody: (0, $8ae8a8807b0eb9f4$export$cf2f7c5792f80b46),
    beforeLabel: (0, $8ae8a8807b0eb9f4$export$cf2f7c5792f80b46),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $8ae8a8807b0eb9f4$export$cf2f7c5792f80b46),
    afterBody: (0, $8ae8a8807b0eb9f4$export$cf2f7c5792f80b46),
    beforeFooter: (0, $8ae8a8807b0eb9f4$export$cf2f7c5792f80b46),
    footer: (0, $8ae8a8807b0eb9f4$export$cf2f7c5792f80b46),
    afterFooter: (0, $8ae8a8807b0eb9f4$export$cf2f7c5792f80b46)
};
function $e10a891308f0349c$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $e10a891308f0349c$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $e10a891308f0349c$var$Tooltip extends $e10a891308f0349c$export$db77ccec0bb4ccac {
    static positioners = $e10a891308f0349c$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $e10a891308f0349c$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $e10a891308f0349c$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $e10a891308f0349c$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $e10a891308f0349c$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $e10a891308f0349c$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $e10a891308f0349c$var$pushOrConcat(lines, $e10a891308f0349c$var$splitNewlines(beforeTitle));
        lines = $e10a891308f0349c$var$pushOrConcat(lines, $e10a891308f0349c$var$splitNewlines(title));
        lines = $e10a891308f0349c$var$pushOrConcat(lines, $e10a891308f0349c$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $e10a891308f0349c$var$getBeforeAfterBodyLines($e10a891308f0349c$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $e10a891308f0349c$var$overrideCallbacks(callbacks, context);
            $e10a891308f0349c$var$pushOrConcat(bodyItem.before, $e10a891308f0349c$var$splitNewlines($e10a891308f0349c$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $e10a891308f0349c$var$pushOrConcat(bodyItem.lines, $e10a891308f0349c$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $e10a891308f0349c$var$pushOrConcat(bodyItem.after, $e10a891308f0349c$var$splitNewlines($e10a891308f0349c$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $e10a891308f0349c$var$getBeforeAfterBodyLines($e10a891308f0349c$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $e10a891308f0349c$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $e10a891308f0349c$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $e10a891308f0349c$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $e10a891308f0349c$var$pushOrConcat(lines, $e10a891308f0349c$var$splitNewlines(beforeFooter));
        lines = $e10a891308f0349c$var$pushOrConcat(lines, $e10a891308f0349c$var$splitNewlines(footer));
        lines = $e10a891308f0349c$var$pushOrConcat(lines, $e10a891308f0349c$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($e10a891308f0349c$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $e10a891308f0349c$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($e10a891308f0349c$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($e10a891308f0349c$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($e10a891308f0349c$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $e10a891308f0349c$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $e10a891308f0349c$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $e10a891308f0349c$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $e10a891308f0349c$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $8ae8a8807b0eb9f4$export$92108d983e8ee699)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $8ae8a8807b0eb9f4$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $e10a891308f0349c$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(options.bodyFont);
        const colorX = $e10a891308f0349c$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $8ae8a8807b0eb9f4$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $8ae8a8807b0eb9f4$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $8ae8a8807b0eb9f4$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $8ae8a8807b0eb9f4$export$92108d983e8ee699)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $8ae8a8807b0eb9f4$export$1fbe638ecf81657e)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $8ae8a8807b0eb9f4$export$1fbe638ecf81657e)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $8ae8a8807b0eb9f4$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $e10a891308f0349c$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $8ae8a8807b0eb9f4$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $8ae8a8807b0eb9f4$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $e10a891308f0349c$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $8ae8a8807b0eb9f4$export$92108d983e8ee699)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $e10a891308f0349c$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $e10a891308f0349c$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $e10a891308f0349c$var$determineAlignment(chart, options, positionAndSize);
            const point = $e10a891308f0349c$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $8ae8a8807b0eb9f4$export$91c6e00c14e7e6fd)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $8ae8a8807b0eb9f4$export$890c4ad488842ce7)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $8ae8a8807b0eb9f4$export$995eb9fca571757)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $8ae8a8807b0eb9f4$export$995eb9fca571757)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $e10a891308f0349c$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $e10a891308f0349c$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $e10a891308f0349c$var$Tooltip,
    positioners: $e10a891308f0349c$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $e10a891308f0349c$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $e10a891308f0349c$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $e10a891308f0349c$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $e10a891308f0349c$export$c537fa0d021d010b,
    Decimation: $e10a891308f0349c$export$be17f937e9aa7533,
    Filler: $e10a891308f0349c$export$d19ba4d812bed757,
    Legend: $e10a891308f0349c$export$ed247974535929c7,
    SubTitle: $e10a891308f0349c$export$d5c56664638992a4,
    Title: $e10a891308f0349c$export$f99233281efd08a0,
    Tooltip: $e10a891308f0349c$export$28c660c63b792dea
});
const $e10a891308f0349c$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $e10a891308f0349c$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $e10a891308f0349c$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $e10a891308f0349c$var$validIndex = (index, max)=>index === null ? null : (0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $e10a891308f0349c$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $e10a891308f0349c$export$29e663ba4d09fe7 extends $e10a891308f0349c$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $e10a891308f0349c$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $e10a891308f0349c$var$findOrAddLabel(labels, raw, (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $e10a891308f0349c$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $e10a891308f0349c$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $e10a891308f0349c$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $8ae8a8807b0eb9f4$export$a33b77bbdbb8366c)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $8ae8a8807b0eb9f4$export$a33b77bbdbb8366c)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $8ae8a8807b0eb9f4$export$b9a6b53f9be3734)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $8ae8a8807b0eb9f4$export$a05254e7c3aeba6e)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $8ae8a8807b0eb9f4$export$23ebac1979863676)(spacing), (0, $8ae8a8807b0eb9f4$export$23ebac1979863676)(niceMin));
    factor = Math.pow(10, (0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $8ae8a8807b0eb9f4$export$a05254e7c3aeba6e)(Math.round((niceMin + j * spacing) * factor) / factor, min, $e10a891308f0349c$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $8ae8a8807b0eb9f4$export$a05254e7c3aeba6e)(ticks[ticks.length - 1].value, max, $e10a891308f0349c$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $e10a891308f0349c$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $8ae8a8807b0eb9f4$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $e10a891308f0349c$var$LinearScaleBase extends $e10a891308f0349c$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $8ae8a8807b0eb9f4$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $8ae8a8807b0eb9f4$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $e10a891308f0349c$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $8ae8a8807b0eb9f4$export$53a70dd1ebbae346)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $8ae8a8807b0eb9f4$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $e10a891308f0349c$export$e7f4e5e8656f0b93 extends $e10a891308f0349c$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $8ae8a8807b0eb9f4$export$91477dc880baac21).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $8ae8a8807b0eb9f4$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $e10a891308f0349c$var$log10Floor = (v)=>Math.floor((0, $8ae8a8807b0eb9f4$export$9f4f30ee63539e24)(v));
const $e10a891308f0349c$var$changeExponent = (v, m)=>Math.pow(10, $e10a891308f0349c$var$log10Floor(v) + m);
function $e10a891308f0349c$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $e10a891308f0349c$var$log10Floor(tickVal));
    return remain === 1;
}
function $e10a891308f0349c$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $e10a891308f0349c$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $e10a891308f0349c$var$log10Floor(range);
    while($e10a891308f0349c$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($e10a891308f0349c$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $e10a891308f0349c$var$log10Floor(min));
}
function $e10a891308f0349c$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $e10a891308f0349c$var$log10Floor(min);
    let exp = $e10a891308f0349c$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $e10a891308f0349c$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $8ae8a8807b0eb9f4$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $e10a891308f0349c$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $e10a891308f0349c$export$85295eaf7cb3ac3e extends $e10a891308f0349c$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $8ae8a8807b0eb9f4$export$91477dc880baac21).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $e10a891308f0349c$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(this._userMin)) this.min = min === $e10a891308f0349c$var$changeExponent(this.min, 0) ? $e10a891308f0349c$var$changeExponent(this.min, -1) : $e10a891308f0349c$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($e10a891308f0349c$var$changeExponent(min, -1));
                setMax($e10a891308f0349c$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($e10a891308f0349c$var$changeExponent(max, -1));
        if (max <= 0) setMax($e10a891308f0349c$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $e10a891308f0349c$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $8ae8a8807b0eb9f4$export$53a70dd1ebbae346)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $8ae8a8807b0eb9f4$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $8ae8a8807b0eb9f4$export$9f4f30ee63539e24)(start);
        this._valueRange = (0, $8ae8a8807b0eb9f4$export$9f4f30ee63539e24)(this.max) - (0, $8ae8a8807b0eb9f4$export$9f4f30ee63539e24)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $8ae8a8807b0eb9f4$export$9f4f30ee63539e24)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $e10a891308f0349c$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $8ae8a8807b0eb9f4$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $e10a891308f0349c$var$measureLabelSize(ctx, font, label) {
    label = (0, $8ae8a8807b0eb9f4$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $8ae8a8807b0eb9f4$export$faec65b429be379)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $e10a891308f0349c$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $e10a891308f0349c$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $8ae8a8807b0eb9f4$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(opts.font);
        const textSize = $e10a891308f0349c$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $8ae8a8807b0eb9f4$export$28f7fcd39efa255)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $8ae8a8807b0eb9f4$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $e10a891308f0349c$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $e10a891308f0349c$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $e10a891308f0349c$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $e10a891308f0349c$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $e10a891308f0349c$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $e10a891308f0349c$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $8ae8a8807b0eb9f4$export$3a6d5c9ae78a2c08)((0, $8ae8a8807b0eb9f4$export$28f7fcd39efa255)(pointLabelPosition.angle + (0, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd))));
    const y = $e10a891308f0349c$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $e10a891308f0349c$var$getTextAlignForAngle(angle);
    const left = $e10a891308f0349c$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $e10a891308f0349c$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $8ae8a8807b0eb9f4$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $8ae8a8807b0eb9f4$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $8ae8a8807b0eb9f4$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $8ae8a8807b0eb9f4$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $e10a891308f0349c$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $e10a891308f0349c$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $8ae8a8807b0eb9f4$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $e10a891308f0349c$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $e10a891308f0349c$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $e10a891308f0349c$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $e10a891308f0349c$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $e10a891308f0349c$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $e10a891308f0349c$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $8ae8a8807b0eb9f4$export$92108d983e8ee699)(opts.borderRadius);
        const padding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $8ae8a8807b0eb9f4$export$1fbe638ecf81657e)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $e10a891308f0349c$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $e10a891308f0349c$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $8ae8a8807b0eb9f4$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $e10a891308f0349c$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $e10a891308f0349c$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $e10a891308f0349c$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $e10a891308f0349c$var$createPointLabelContext(parent, index, label) {
    return (0, $8ae8a8807b0eb9f4$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $e10a891308f0349c$export$cfafc36d95386d38 extends $e10a891308f0349c$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $8ae8a8807b0eb9f4$export$91477dc880baac21).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)($e10a891308f0349c$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $e10a891308f0349c$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $e10a891308f0349c$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $e10a891308f0349c$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $8ae8a8807b0eb9f4$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $8ae8a8807b0eb9f4$export$28f7fcd39efa255)(index * angleMultiplier + (0, $8ae8a8807b0eb9f4$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $e10a891308f0349c$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $8ae8a8807b0eb9f4$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $e10a891308f0349c$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $e10a891308f0349c$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $e10a891308f0349c$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $8ae8a8807b0eb9f4$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $8ae8a8807b0eb9f4$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $8ae8a8807b0eb9f4$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $e10a891308f0349c$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $e10a891308f0349c$var$UNITS = /* #__PURE__ */ Object.keys($e10a891308f0349c$var$INTERVALS);
function $e10a891308f0349c$var$sorter(a, b) {
    return a - b;
}
function $e10a891308f0349c$var$parse(scale, input) {
    if ((0, $8ae8a8807b0eb9f4$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $8ae8a8807b0eb9f4$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $e10a891308f0349c$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $e10a891308f0349c$var$UNITS.length;
    for(let i = $e10a891308f0349c$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $e10a891308f0349c$var$INTERVALS[$e10a891308f0349c$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $e10a891308f0349c$var$UNITS[i];
    }
    return $e10a891308f0349c$var$UNITS[ilen - 1];
}
function $e10a891308f0349c$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $e10a891308f0349c$var$UNITS.length - 1; i >= $e10a891308f0349c$var$UNITS.indexOf(minUnit); i--){
        const unit = $e10a891308f0349c$var$UNITS[i];
        if ($e10a891308f0349c$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $e10a891308f0349c$var$UNITS[minUnit ? $e10a891308f0349c$var$UNITS.indexOf(minUnit) : 0];
}
function $e10a891308f0349c$var$determineMajorUnit(unit) {
    for(let i = $e10a891308f0349c$var$UNITS.indexOf(unit) + 1, ilen = $e10a891308f0349c$var$UNITS.length; i < ilen; ++i){
        if ($e10a891308f0349c$var$INTERVALS[$e10a891308f0349c$var$UNITS[i]].common) return $e10a891308f0349c$var$UNITS[i];
    }
}
function $e10a891308f0349c$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $8ae8a8807b0eb9f4$export$2ed0fc6709e59212)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $e10a891308f0349c$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $e10a891308f0349c$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $e10a891308f0349c$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $e10a891308f0349c$export$a894c72689ff3ec extends $e10a891308f0349c$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $e10a891308f0349c$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $8ae8a8807b0eb9f4$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $e10a891308f0349c$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $8ae8a8807b0eb9f4$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $8ae8a8807b0eb9f4$export$c03999cb2f36933f)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $e10a891308f0349c$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $e10a891308f0349c$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $e10a891308f0349c$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $e10a891308f0349c$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $8ae8a8807b0eb9f4$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $e10a891308f0349c$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $8ae8a8807b0eb9f4$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $8ae8a8807b0eb9f4$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$e10a891308f0349c$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $e10a891308f0349c$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($e10a891308f0349c$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $8ae8a8807b0eb9f4$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $8ae8a8807b0eb9f4$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $e10a891308f0349c$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($e10a891308f0349c$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $8ae8a8807b0eb9f4$export$71511d61b312f219)(values.sort($e10a891308f0349c$var$sorter));
    }
}
function $e10a891308f0349c$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $8ae8a8807b0eb9f4$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $8ae8a8807b0eb9f4$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $e10a891308f0349c$export$85df64a8eb6dc986 extends $e10a891308f0349c$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $e10a891308f0349c$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $e10a891308f0349c$var$interpolate(table, this.min);
        this._tableRange = $e10a891308f0349c$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($e10a891308f0349c$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $e10a891308f0349c$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $e10a891308f0349c$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $e10a891308f0349c$export$29e663ba4d09fe7,
    LinearScale: $e10a891308f0349c$export$e7f4e5e8656f0b93,
    LogarithmicScale: $e10a891308f0349c$export$85295eaf7cb3ac3e,
    RadialLinearScale: $e10a891308f0349c$export$cfafc36d95386d38,
    TimeScale: $e10a891308f0349c$export$a894c72689ff3ec,
    TimeSeriesScale: $e10a891308f0349c$export$85df64a8eb6dc986
});
const $e10a891308f0349c$export$e8959e79e3af550f = [
    $e10a891308f0349c$export$a6506504f799c5d5,
    $e10a891308f0349c$export$7a5d735b2ab6389d,
    $e10a891308f0349c$export$8b3ca321c77fdea6,
    $e10a891308f0349c$export$bcac1c16f1530ec2
];


(0, $e10a891308f0349c$export$acaa6426d77a227e).register(...(0, $e10a891308f0349c$export$e8959e79e3af550f));
var $2cef44f2ff510d02$export$2e2bcd8739ae039 = (0, $e10a891308f0349c$export$acaa6426d77a227e);



var $ltGt3 = parcelRequire("ltGt3");

const $f364623c23d5ae9f$var$defaultDatasetIdKey = "label";
function $f364623c23d5ae9f$var$reforwardRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $f364623c23d5ae9f$var$setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function $f364623c23d5ae9f$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $f364623c23d5ae9f$var$setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $f364623c23d5ae9f$var$defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $f364623c23d5ae9f$var$cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $f364623c23d5ae9f$var$defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    $f364623c23d5ae9f$var$setLabels(nextData, data.labels);
    $f364623c23d5ae9f$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $f364623c23d5ae9f$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $f364623c23d5ae9f$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $f364623c23d5ae9f$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}
function $f364623c23d5ae9f$var$ChartComponent(props, ref) {
    const { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode, ...canvasProps } = props;
    const canvasRef = (0, $ltGt3.useRef)(null);
    const chartRef = (0, $ltGt3.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $e10a891308f0349c$export$acaa6426d77a227e)(canvasRef.current, {
            type: type,
            data: $f364623c23d5ae9f$var$cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins: plugins
        });
        $f364623c23d5ae9f$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $f364623c23d5ae9f$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $ltGt3.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $f364623c23d5ae9f$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $ltGt3.useEffect)(()=>{
        if (!redraw && chartRef.current) $f364623c23d5ae9f$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $ltGt3.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $f364623c23d5ae9f$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $ltGt3.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $ltGt3.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $ltGt3.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, canvasProps), fallbackContent);
}
const $f364623c23d5ae9f$export$acaa6426d77a227e = /*#__PURE__*/ (0, $ltGt3.forwardRef)($f364623c23d5ae9f$var$ChartComponent);
function $f364623c23d5ae9f$var$createTypedChart(type, registerables) {
    (0, $e10a891308f0349c$export$acaa6426d77a227e).register(registerables);
    return /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement($f364623c23d5ae9f$export$acaa6426d77a227e, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const $f364623c23d5ae9f$export$17d680238e50603e = /* #__PURE__ */ $f364623c23d5ae9f$var$createTypedChart("line", (0, $e10a891308f0349c$export$3c9b5d28c11cbfd0));
const $f364623c23d5ae9f$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $f364623c23d5ae9f$var$createTypedChart("bar", (0, $e10a891308f0349c$export$e97d5dc64e999004));
const $f364623c23d5ae9f$export$bace472c466fdd25 = /* #__PURE__ */ $f364623c23d5ae9f$var$createTypedChart("radar", (0, $e10a891308f0349c$export$48dbc6ac651bf8be));
const $f364623c23d5ae9f$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $f364623c23d5ae9f$var$createTypedChart("doughnut", (0, $e10a891308f0349c$export$e04603e7d8b77172));
const $f364623c23d5ae9f$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $f364623c23d5ae9f$var$createTypedChart("polarArea", (0, $e10a891308f0349c$export$2a270b3a0d973c85));
const $f364623c23d5ae9f$export$646feb54fbadbe06 = /* #__PURE__ */ $f364623c23d5ae9f$var$createTypedChart("bubble", (0, $e10a891308f0349c$export$19b5c4773f17abe));
const $f364623c23d5ae9f$export$2ae8800cf67c848c = /* #__PURE__ */ $f364623c23d5ae9f$var$createTypedChart("pie", (0, $e10a891308f0349c$export$b21a3f1286706191));
const $f364623c23d5ae9f$export$1c460fb4285edadc = /* #__PURE__ */ $f364623c23d5ae9f$var$createTypedChart("scatter", (0, $e10a891308f0349c$export$b2f2bae6713db87));




var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
const $6b5bbb3e8684bfc1$var$RowContext = /*#__PURE__*/ (0, $ltGt3.createContext)({});
var $6b5bbb3e8684bfc1$export$2e2bcd8739ae039 = $6b5bbb3e8684bfc1$var$RowContext;




// ============================== Row-Shared ==============================
const $46ef034ddbcf7413$var$genGridRowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            display: 'flex',
            flexFlow: 'row wrap',
            minWidth: 0,
            '&::before, &::after': {
                display: 'flex'
            },
            '&-no-wrap': {
                flexWrap: 'nowrap'
            },
            // The origin of the X-axis
            '&-start': {
                justifyContent: 'flex-start'
            },
            // The center of the X-axis
            '&-center': {
                justifyContent: 'center'
            },
            // The opposite of the X-axis
            '&-end': {
                justifyContent: 'flex-end'
            },
            '&-space-between': {
                justifyContent: 'space-between'
            },
            '&-space-around': {
                justifyContent: 'space-around'
            },
            '&-space-evenly': {
                justifyContent: 'space-evenly'
            },
            // Align at the top
            '&-top': {
                alignItems: 'flex-start'
            },
            // Align at the center
            '&-middle': {
                alignItems: 'center'
            },
            '&-bottom': {
                alignItems: 'flex-end'
            }
        }
    };
};
// ============================== Col-Shared ==============================
const $46ef034ddbcf7413$var$genGridColStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            position: 'relative',
            maxWidth: '100%',
            // Prevent columns from collapsing when empty
            minHeight: 1
        }
    };
};
const $46ef034ddbcf7413$var$genLoopGridColumnsStyle = (token, sizeCls)=>{
    const { prefixCls: prefixCls, componentCls: componentCls, gridColumns: gridColumns } = token;
    const gridColumnsStyle = {};
    for(let i = gridColumns; i >= 0; i--)if (i === 0) {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
            display: 'none'
        };
        gridColumnsStyle[`${componentCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: 0
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: 0
        };
    } else {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
            // https://github.com/ant-design/ant-design/issues/44456
            // Form set `display: flex` on Col which will override `display: block`.
            // Let's get it from css variable to support override.
            {
                ['--ant-display']: 'block',
                // Fallback to display if variable not support
                display: 'block'
            },
            {
                display: 'var(--ant-display)',
                flex: `0 0 ${i / gridColumns * 100}%`,
                maxWidth: `${i / gridColumns * 100}%`
            }
        ];
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: i
        };
    }
    // Flex CSS Var
    gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
        flex: `var(--${prefixCls}${sizeCls}-flex)`
    };
    return gridColumnsStyle;
};
const $46ef034ddbcf7413$var$genGridStyle = (token, sizeCls)=>$46ef034ddbcf7413$var$genLoopGridColumnsStyle(token, sizeCls);
const $46ef034ddbcf7413$var$genGridMediaStyle = (token, screenSize, sizeCls)=>({
        [`@media (min-width: ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(screenSize)})`]: {
            ...$46ef034ddbcf7413$var$genGridStyle(token, sizeCls)
        }
    });
const $46ef034ddbcf7413$export$519f4f378a4f8e85 = ()=>({});
const $46ef034ddbcf7413$export$5504d86ab3175593 = ()=>({});
const $46ef034ddbcf7413$export$b0d9c6b8be4e14cd = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Grid', $46ef034ddbcf7413$var$genGridRowStyle, $46ef034ddbcf7413$export$519f4f378a4f8e85);
const $46ef034ddbcf7413$export$6353f655434817c5 = (token)=>{
    const mediaSizesMap = {
        xs: token.screenXSMin,
        sm: token.screenSMMin,
        md: token.screenMDMin,
        lg: token.screenLGMin,
        xl: token.screenXLMin,
        xxl: token.screenXXLMin
    };
    return mediaSizesMap;
};
const $46ef034ddbcf7413$export$4d3e83959861592f = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Grid', (token)=>{
    const gridToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        gridColumns: 24 // Row is divided into 24 parts in Grid
    });
    const gridMediaSizesMap = $46ef034ddbcf7413$export$6353f655434817c5(gridToken);
    delete gridMediaSizesMap.xs;
    return [
        $46ef034ddbcf7413$var$genGridColStyle(gridToken),
        $46ef034ddbcf7413$var$genGridStyle(gridToken, ''),
        $46ef034ddbcf7413$var$genGridStyle(gridToken, '-xs'),
        Object.keys(gridMediaSizesMap).map((key)=>$46ef034ddbcf7413$var$genGridMediaStyle(gridToken, gridMediaSizesMap[key], `-${key}`)).reduce((pre, cur)=>({
                ...pre,
                ...cur
            }), {})
    ];
}, $46ef034ddbcf7413$export$5504d86ab3175593);


"use client";
function $4f41537f122e579d$var$parseFlex(flex) {
    if (flex === 'auto') return '1 1 auto';
    if (typeof flex === 'number') return `${flex} ${flex} auto`;
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) return `0 0 ${flex}`;
    return flex;
}
const $4f41537f122e579d$var$sizes = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
];
const $4f41537f122e579d$var$Col = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { gutter: gutter, wrap: wrap } = $ltGt3.useContext((0, $6b5bbb3e8684bfc1$export$2e2bcd8739ae039));
    const { prefixCls: customizePrefixCls, span: span, order: order, offset: offset, push: push, pull: pull, className: className, children: children, flex: flex, style: style, ...others } = props;
    const prefixCls = getPrefixCls('col', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $46ef034ddbcf7413$export$4d3e83959861592f)(prefixCls);
    // ===================== Size ======================
    const sizeStyle = {};
    let sizeClassObj = {};
    $4f41537f122e579d$var$sizes.forEach((size)=>{
        let sizeProps = {};
        const propSize = props[size];
        if (typeof propSize === 'number') sizeProps.span = propSize;
        else if (typeof propSize === 'object') sizeProps = propSize || {};
        delete others[size];
        sizeClassObj = {
            ...sizeClassObj,
            [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== undefined,
            [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
            [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
            [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
            [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        };
        // Responsive flex layout
        if (sizeProps.flex) {
            sizeClassObj[`${prefixCls}-${size}-flex`] = true;
            sizeStyle[`--${prefixCls}-${size}-flex`] = $4f41537f122e579d$var$parseFlex(sizeProps.flex);
        }
    });
    // ==================== Normal =====================
    const classes = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-${span}`]: span !== undefined,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull
    }, className, sizeClassObj, hashId, cssVarCls);
    const mergedStyle = {};
    // Horizontal gutter use padding
    if (gutter?.[0]) {
        const horizontalGutter = typeof gutter[0] === 'number' ? `${gutter[0] / 2}px` : `calc(${gutter[0]} / 2)`;
        mergedStyle.paddingInline = horizontalGutter;
    }
    if (flex) {
        mergedStyle.flex = $4f41537f122e579d$var$parseFlex(flex);
        // Hack for Firefox to avoid size issue
        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
        if (wrap === false && !mergedStyle.minWidth) mergedStyle.minWidth = 0;
    }
    // ==================== Render =====================
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ...others,
        style: {
            ...mergedStyle,
            ...style,
            ...sizeStyle
        },
        className: classes,
        ref: ref
    }, children);
});
var $4f41537f122e579d$export$2e2bcd8739ae039 = $4f41537f122e579d$var$Col;


"use client";
var $d4ae9b90c2a44432$export$2e2bcd8739ae039 = (0, $4f41537f122e579d$export$2e2bcd8739ae039);


var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");

const $86b5776d49437dca$export$74c1bf8296b1541f = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $86b5776d49437dca$var$getResponsiveMap = (token)=>({
        xs: `(max-width: ${token.screenXSMax}px)`,
        sm: `(min-width: ${token.screenSM}px)`,
        md: `(min-width: ${token.screenMD}px)`,
        lg: `(min-width: ${token.screenLG}px)`,
        xl: `(min-width: ${token.screenXL}px)`,
        xxl: `(min-width: ${token.screenXXL}px)`
    });
/**
 * Ensures that the breakpoints token are valid, in good order
 * For each breakpoint : screenMin <= screen <= screenMax and screenMax <= nextScreenMin
 */ const $86b5776d49437dca$var$validateBreakpoints = (token)=>{
    const indexableToken = token;
    const revBreakpoints = [].concat($86b5776d49437dca$export$74c1bf8296b1541f).reverse();
    revBreakpoints.forEach((breakpoint, i)=>{
        const breakpointUpper = breakpoint.toUpperCase();
        const screenMin = `screen${breakpointUpper}Min`;
        const screen = `screen${breakpointUpper}`;
        if (!(indexableToken[screenMin] <= indexableToken[screen])) throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
        if (i < revBreakpoints.length - 1) {
            const screenMax = `screen${breakpointUpper}Max`;
            if (!(indexableToken[screen] <= indexableToken[screenMax])) throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
            const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
            const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
            if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
        }
    });
    return token;
};
const $86b5776d49437dca$export$862220c15691d248 = (screens, screenSizes)=>{
    if (!screenSizes) return;
    for (const breakpoint of $86b5776d49437dca$export$74c1bf8296b1541f){
        if (screens[breakpoint] && screenSizes?.[breakpoint] !== undefined) return screenSizes[breakpoint];
    }
};
const $86b5776d49437dca$var$useResponsiveObserver = ()=>{
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const responsiveMap = $86b5776d49437dca$var$getResponsiveMap($86b5776d49437dca$var$validateBreakpoints(token));
    // To avoid repeat create instance, we add `useMemo` here.
    return (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        const subscribers = new Map();
        let subUid = -1;
        let screens = {};
        return {
            responsiveMap: responsiveMap,
            matchHandlers: {},
            dispatch (pointMap) {
                screens = pointMap;
                subscribers.forEach((func)=>func(screens));
                return subscribers.size >= 1;
            },
            subscribe (func) {
                if (!subscribers.size) this.register();
                subUid += 1;
                subscribers.set(subUid, func);
                func(screens);
                return subUid;
            },
            unsubscribe (paramToken) {
                subscribers.delete(paramToken);
                if (!subscribers.size) this.unregister();
            },
            register () {
                Object.entries(responsiveMap).forEach(([screen, mediaQuery])=>{
                    const listener = ({ matches: matches })=>{
                        this.dispatch({
                            ...screens,
                            [screen]: matches
                        });
                    };
                    const mql = window.matchMedia(mediaQuery);
                    if (typeof mql?.addEventListener === 'function') mql.addEventListener('change', listener);
                    this.matchHandlers[mediaQuery] = {
                        mql: mql,
                        listener: listener
                    };
                    listener(mql);
                });
            },
            unregister () {
                Object.values(responsiveMap).forEach((mediaQuery)=>{
                    const handler = this.matchHandlers[mediaQuery];
                    if (typeof handler?.mql?.removeEventListener === 'function') handler.mql.removeEventListener('change', handler?.listener);
                });
                subscribers.clear();
            }
        };
    }, [
        responsiveMap
    ]);
};
var $86b5776d49437dca$export$2e2bcd8739ae039 = $86b5776d49437dca$var$useResponsiveObserver;




var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
const $a4dbd33868ca5b2a$export$91db9bc4f8ac944a = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useReducer((ori)=>ori + 1, 0);
};



"use client";
function $ec3b57b710702d4d$var$useBreakpoint(refreshOnChange = true, defaultScreens = {}) {
    const screensRef = (0, $ltGt3.useRef)(defaultScreens);
    const [, forceUpdate] = (0, $a4dbd33868ca5b2a$export$91db9bc4f8ac944a)();
    const responsiveObserver = (0, $86b5776d49437dca$export$2e2bcd8739ae039)();
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        const token = responsiveObserver.subscribe((supportScreens)=>{
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return ()=>responsiveObserver.unsubscribe(token);
    }, []);
    return screensRef.current;
}
var $ec3b57b710702d4d$export$2e2bcd8739ae039 = $ec3b57b710702d4d$var$useBreakpoint;



function $a00ac3d3591b89fb$export$2e2bcd8739ae039(gutter, screens) {
    const results = [
        undefined,
        undefined
    ];
    const normalizedGutter = Array.isArray(gutter) ? gutter : [
        gutter,
        undefined
    ];
    // By default use as `xs`
    const mergedScreens = screens || {
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true
    };
    normalizedGutter.forEach((g, index)=>{
        if (typeof g === 'object' && g !== null) for(let i = 0; i < (0, $86b5776d49437dca$export$74c1bf8296b1541f).length; i++){
            const breakpoint = (0, $86b5776d49437dca$export$74c1bf8296b1541f)[i];
            if (mergedScreens[breakpoint] && g[breakpoint] !== undefined) {
                results[index] = g[breakpoint];
                break;
            }
        }
        else results[index] = g;
    });
    return results;
}




"use client";
const $bd486463f4fb682b$var$_RowAligns = [
    'top',
    'middle',
    'bottom',
    'stretch'
];
const $bd486463f4fb682b$var$_RowJustify = [
    'start',
    'end',
    'center',
    'space-around',
    'space-between',
    'space-evenly'
];
function $bd486463f4fb682b$var$useMergedPropByScreen(oriProp, screen) {
    const [prop, setProp] = $ltGt3.useState(typeof oriProp === 'string' ? oriProp : '');
    const calcMergedAlignOrJustify = ()=>{
        if (typeof oriProp === 'string') setProp(oriProp);
        if (typeof oriProp !== 'object') return;
        for(let i = 0; i < (0, $86b5776d49437dca$export$74c1bf8296b1541f).length; i++){
            const breakpoint = (0, $86b5776d49437dca$export$74c1bf8296b1541f)[i];
            // if do not match, do nothing
            if (!screen || !screen[breakpoint]) continue;
            const curVal = oriProp[breakpoint];
            if (curVal !== undefined) {
                setProp(curVal);
                return;
            }
        }
    };
    $ltGt3.useEffect(()=>{
        calcMergedAlignOrJustify();
    }, [
        JSON.stringify(oriProp),
        screen
    ]);
    return prop;
}
const $bd486463f4fb682b$var$Row = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, justify: justify, align: align, className: className, style: style, children: children, gutter: gutter = 0, wrap: wrap, ...others } = props;
    const { getPrefixCls: getPrefixCls, direction: direction } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const screens = (0, $ec3b57b710702d4d$export$2e2bcd8739ae039)(true, null);
    const mergedAlign = $bd486463f4fb682b$var$useMergedPropByScreen(align, screens);
    const mergedJustify = $bd486463f4fb682b$var$useMergedPropByScreen(justify, screens);
    const prefixCls = getPrefixCls('row', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $46ef034ddbcf7413$export$b0d9c6b8be4e14cd)(prefixCls);
    const gutters = (0, $a00ac3d3591b89fb$export$2e2bcd8739ae039)(gutter, screens);
    const classes = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-no-wrap`]: wrap === false,
        [`${prefixCls}-${mergedJustify}`]: mergedJustify,
        [`${prefixCls}-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId, cssVarCls);
    // Add gutter related style
    const rowStyle = {};
    if (gutters?.[0]) {
        const horizontalGutter = typeof gutters[0] === 'number' ? `${gutters[0] / -2}px` : `calc(${gutters[0]} / -2)`;
        rowStyle.marginInline = horizontalGutter;
    }
    // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
    // So we deconstruct "gutters" variable here.
    const [gutterH, gutterV] = gutters;
    rowStyle.rowGap = gutterV;
    const rowContext = $ltGt3.useMemo(()=>({
            gutter: [
                gutterH,
                gutterV
            ],
            wrap: wrap
        }), [
        gutterH,
        gutterV,
        wrap
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $6b5bbb3e8684bfc1$export$2e2bcd8739ae039).Provider, {
        value: rowContext
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        ...others,
        className: classes,
        style: {
            ...rowStyle,
            ...style
        },
        ref: ref
    }, children));
});
var $bd486463f4fb682b$export$2e2bcd8739ae039 = $bd486463f4fb682b$var$Row;


"use client";
var $2e3ea5da034cc5f6$export$2e2bcd8739ae039 = (0, $bd486463f4fb682b$export$2e2bcd8739ae039);


parcelRequire("ltGt3");

var $0affa3efcfc57f8a$exports = {};
$0affa3efcfc57f8a$exports = import.meta.resolve("4pB69");




function $efbfba7bbb733f04$export$c7ba05ed26d2c55(props) {
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "back",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "background-image",
                style: {
                    backgroundImage: `url(${props?.weather ? props.weather.backImage : (0, (/*@__PURE__*/$parcel$interopDefault($0affa3efcfc57f8a$exports)))})`
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    className: "background-image__gradient-overlay"
                })
            }),
            props.weather && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                        className: "current",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                                className: "current__place-date",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "current__place",
                                    children: [
                                        props.weather.locationName.split(',').map((s, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                children: s
                                            }, index)),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                            children: props.weather.date
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                                className: "current__weather",
                                children: [
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                        className: "current__weather__temp",
                                        children: [
                                            props.weather.currentTempreture,
                                            "\xb0"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                        className: "current__weather__icon",
                                        children: props.weather.icon
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                        className: "current__weather__desc",
                                        children: props.weather.description
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                        className: "week",
                        children: props.weather.nextDaysWeather.map((weather, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                className: "week__day",
                                children: [
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                        children: weather.dayOfWeek
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                        className: "week__day__icon",
                                        children: weather.icon
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                        children: [
                                            weather.dayTemp,
                                            "\xb0"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                        children: [
                                            weather.nightTemp,
                                            "\xb0"
                                        ]
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            !props.weather && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "without-weather",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                    ghost: true,
                    onClick: ()=>{
                        navigate(`/projects/${props.projectId}/edit`);
                    },
                    children: intl.formatMessage({
                        id: 'toDisplayWeather'
                    })
                })
            })
        ]
    });
}





/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ /**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */ function $84232b8a7694f93d$export$b0e60b43d1d059f0(n, max) {
    if ($84232b8a7694f93d$export$7bf7d6849640691b(n)) n = '100%';
    var isPercent = $84232b8a7694f93d$export$d86432a85610ea90(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) n = parseInt(String(n * max), 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    if (max === 360) // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
    else // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
    return n;
}
function $84232b8a7694f93d$export$5c5ee632c52bc4a2(val) {
    return Math.min(1, Math.max(0, val));
}
function $84232b8a7694f93d$export$7bf7d6849640691b(n) {
    return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
}
function $84232b8a7694f93d$export$d86432a85610ea90(n) {
    return typeof n === 'string' && n.indexOf('%') !== -1;
}
function $84232b8a7694f93d$export$3ae665204365318d(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
function $84232b8a7694f93d$export$8ba0754c08bd5ca8(n) {
    if (n <= 1) return "".concat(Number(n) * 100, "%");
    return n;
}
function $84232b8a7694f93d$export$9decc9dc70e2c76f(c) {
    return c.length === 1 ? '0' + c : String(c);
}


function $4e2643d0408869b9$export$1a0d7f039f803cb(r, g, b) {
    return {
        r: (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(r, 255) * 255,
        g: (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(g, 255) * 255,
        b: (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(b, 255) * 255
    };
}
function $4e2643d0408869b9$export$c85ca4f4753af384(r, g, b) {
    r = (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max === min) {
        s = 0;
        h = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $4e2643d0408869b9$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * (6 * t);
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $4e2643d0408869b9$export$29fb7152bd3f781a(h, s, l) {
    var r;
    var g;
    var b;
    h = (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(h, 360);
    s = (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(s, 100);
    l = (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = $4e2643d0408869b9$var$hue2rgb(p, q, h + 1 / 3);
        g = $4e2643d0408869b9$var$hue2rgb(p, q, h);
        b = $4e2643d0408869b9$var$hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $4e2643d0408869b9$export$f76e85ca00a47f5c(r, g, b) {
    r = (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
function $4e2643d0408869b9$export$210753cfeec758a5(h, s, v) {
    h = (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(h, 360) * 6;
    s = (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(s, 100);
    v = (0, $84232b8a7694f93d$export$b0e60b43d1d059f0)(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod];
    var g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod];
    var b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $4e2643d0408869b9$export$34d09c4a771c46ef(r, g, b, allow3Char) {
    var hex = [
        (0, $84232b8a7694f93d$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $84232b8a7694f93d$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $84232b8a7694f93d$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join('');
}
function $4e2643d0408869b9$export$ffee5509a14af63d(r, g, b, a, allow4Char) {
    var hex = [
        (0, $84232b8a7694f93d$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $84232b8a7694f93d$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $84232b8a7694f93d$export$9decc9dc70e2c76f)(Math.round(b).toString(16)),
        (0, $84232b8a7694f93d$export$9decc9dc70e2c76f)($4e2643d0408869b9$export$51dcdea396f3aff6(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join('');
}
function $4e2643d0408869b9$export$ce6645f7d73030f4(r, g, b, a) {
    var hex = [
        (0, $84232b8a7694f93d$export$9decc9dc70e2c76f)($4e2643d0408869b9$export$51dcdea396f3aff6(a)),
        (0, $84232b8a7694f93d$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $84232b8a7694f93d$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $84232b8a7694f93d$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    return hex.join('');
}
function $4e2643d0408869b9$export$51dcdea396f3aff6(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
function $4e2643d0408869b9$export$616da979ad1c2414(h) {
    return $4e2643d0408869b9$export$262b3ba788b4d07c(h) / 255;
}
function $4e2643d0408869b9$export$262b3ba788b4d07c(val) {
    return parseInt(val, 16);
}
function $4e2643d0408869b9$export$4076ec82b665900d(color) {
    return {
        r: color >> 16,
        g: (color & 0xff00) >> 8,
        b: color & 0xff
    };
}


// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */ var $04c22b48a3117e91$export$e4b2ac9215619f8d = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    goldenrod: '#daa520',
    gold: '#ffd700',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavenderblush: '#fff0f5',
    lavender: '#e6e6fa',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};



function $2fa37706dfe4f618$export$87de337d8199f22c(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === 'string') color = $2fa37706dfe4f618$export$56237d872eed15a0(color);
    if (typeof color === 'object') {
        if ($2fa37706dfe4f618$export$80d4d71a83d4526d(color.r) && $2fa37706dfe4f618$export$80d4d71a83d4526d(color.g) && $2fa37706dfe4f618$export$80d4d71a83d4526d(color.b)) {
            rgb = (0, $4e2643d0408869b9$export$1a0d7f039f803cb)(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === '%' ? 'prgb' : 'rgb';
        } else if ($2fa37706dfe4f618$export$80d4d71a83d4526d(color.h) && $2fa37706dfe4f618$export$80d4d71a83d4526d(color.s) && $2fa37706dfe4f618$export$80d4d71a83d4526d(color.v)) {
            s = (0, $84232b8a7694f93d$export$8ba0754c08bd5ca8)(color.s);
            v = (0, $84232b8a7694f93d$export$8ba0754c08bd5ca8)(color.v);
            rgb = (0, $4e2643d0408869b9$export$210753cfeec758a5)(color.h, s, v);
            ok = true;
            format = 'hsv';
        } else if ($2fa37706dfe4f618$export$80d4d71a83d4526d(color.h) && $2fa37706dfe4f618$export$80d4d71a83d4526d(color.s) && $2fa37706dfe4f618$export$80d4d71a83d4526d(color.l)) {
            s = (0, $84232b8a7694f93d$export$8ba0754c08bd5ca8)(color.s);
            l = (0, $84232b8a7694f93d$export$8ba0754c08bd5ca8)(color.l);
            rgb = (0, $4e2643d0408869b9$export$29fb7152bd3f781a)(color.h, s, l);
            ok = true;
            format = 'hsl';
        }
        if (Object.prototype.hasOwnProperty.call(color, 'a')) a = color.a;
    }
    a = (0, $84232b8a7694f93d$export$3ae665204365318d)(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var $2fa37706dfe4f618$var$CSS_INTEGER = '[-\\+]?\\d+%?';
// <http://www.w3.org/TR/css3-values/#number-value>
var $2fa37706dfe4f618$var$CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?';
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var $2fa37706dfe4f618$var$CSS_UNIT = "(?:".concat($2fa37706dfe4f618$var$CSS_NUMBER, ")|(?:").concat($2fa37706dfe4f618$var$CSS_INTEGER, ")");
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var $2fa37706dfe4f618$var$PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat($2fa37706dfe4f618$var$CSS_UNIT, ")[,|\\s]+(").concat($2fa37706dfe4f618$var$CSS_UNIT, ")[,|\\s]+(").concat($2fa37706dfe4f618$var$CSS_UNIT, ")\\s*\\)?");
var $2fa37706dfe4f618$var$PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat($2fa37706dfe4f618$var$CSS_UNIT, ")[,|\\s]+(").concat($2fa37706dfe4f618$var$CSS_UNIT, ")[,|\\s]+(").concat($2fa37706dfe4f618$var$CSS_UNIT, ")[,|\\s]+(").concat($2fa37706dfe4f618$var$CSS_UNIT, ")\\s*\\)?");
var $2fa37706dfe4f618$var$matchers = {
    CSS_UNIT: new RegExp($2fa37706dfe4f618$var$CSS_UNIT),
    rgb: new RegExp('rgb' + $2fa37706dfe4f618$var$PERMISSIVE_MATCH3),
    rgba: new RegExp('rgba' + $2fa37706dfe4f618$var$PERMISSIVE_MATCH4),
    hsl: new RegExp('hsl' + $2fa37706dfe4f618$var$PERMISSIVE_MATCH3),
    hsla: new RegExp('hsla' + $2fa37706dfe4f618$var$PERMISSIVE_MATCH4),
    hsv: new RegExp('hsv' + $2fa37706dfe4f618$var$PERMISSIVE_MATCH3),
    hsva: new RegExp('hsva' + $2fa37706dfe4f618$var$PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $2fa37706dfe4f618$export$56237d872eed15a0(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) return false;
    var named = false;
    if ((0, $04c22b48a3117e91$export$e4b2ac9215619f8d)[color]) {
        color = (0, $04c22b48a3117e91$export$e4b2ac9215619f8d)[color];
        named = true;
    } else if (color === 'transparent') return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: 'name'
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = $2fa37706dfe4f618$var$matchers.rgb.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    match = $2fa37706dfe4f618$var$matchers.rgba.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    match = $2fa37706dfe4f618$var$matchers.hsl.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    match = $2fa37706dfe4f618$var$matchers.hsla.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    match = $2fa37706dfe4f618$var$matchers.hsv.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    match = $2fa37706dfe4f618$var$matchers.hsva.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    match = $2fa37706dfe4f618$var$matchers.hex8.exec(color);
    if (match) return {
        r: (0, $4e2643d0408869b9$export$262b3ba788b4d07c)(match[1]),
        g: (0, $4e2643d0408869b9$export$262b3ba788b4d07c)(match[2]),
        b: (0, $4e2643d0408869b9$export$262b3ba788b4d07c)(match[3]),
        a: (0, $4e2643d0408869b9$export$616da979ad1c2414)(match[4]),
        format: named ? 'name' : 'hex8'
    };
    match = $2fa37706dfe4f618$var$matchers.hex6.exec(color);
    if (match) return {
        r: (0, $4e2643d0408869b9$export$262b3ba788b4d07c)(match[1]),
        g: (0, $4e2643d0408869b9$export$262b3ba788b4d07c)(match[2]),
        b: (0, $4e2643d0408869b9$export$262b3ba788b4d07c)(match[3]),
        format: named ? 'name' : 'hex'
    };
    match = $2fa37706dfe4f618$var$matchers.hex4.exec(color);
    if (match) return {
        r: (0, $4e2643d0408869b9$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $4e2643d0408869b9$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $4e2643d0408869b9$export$262b3ba788b4d07c)(match[3] + match[3]),
        a: (0, $4e2643d0408869b9$export$616da979ad1c2414)(match[4] + match[4]),
        format: named ? 'name' : 'hex8'
    };
    match = $2fa37706dfe4f618$var$matchers.hex3.exec(color);
    if (match) return {
        r: (0, $4e2643d0408869b9$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $4e2643d0408869b9$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $4e2643d0408869b9$export$262b3ba788b4d07c)(match[3] + match[3]),
        format: named ? 'name' : 'hex'
    };
    return false;
}
function $2fa37706dfe4f618$export$80d4d71a83d4526d(color) {
    return Boolean($2fa37706dfe4f618$var$matchers.CSS_UNIT.exec(String(color)));
}


var $6205d9ff2fce7a51$var$hueStep = 2; // 色相阶梯
var $6205d9ff2fce7a51$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $6205d9ff2fce7a51$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $6205d9ff2fce7a51$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $6205d9ff2fce7a51$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $6205d9ff2fce7a51$var$lightColorCount = 5; // 浅色数量，主色上
var $6205d9ff2fce7a51$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $6205d9ff2fce7a51$var$darkColorMap = [
    {
        index: 7,
        opacity: 0.15
    },
    {
        index: 6,
        opacity: 0.25
    },
    {
        index: 5,
        opacity: 0.3
    },
    {
        index: 5,
        opacity: 0.45
    },
    {
        index: 5,
        opacity: 0.65
    },
    {
        index: 5,
        opacity: 0.85
    },
    {
        index: 4,
        opacity: 0.9
    },
    {
        index: 3,
        opacity: 0.95
    },
    {
        index: 2,
        opacity: 0.97
    },
    {
        index: 1,
        opacity: 0.98
    }
];
// Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`
function $6205d9ff2fce7a51$var$toHsv(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var hsv = (0, $4e2643d0408869b9$export$f76e85ca00a47f5c)(r, g, b);
    return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v
    };
}
// Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`
function $6205d9ff2fce7a51$var$toHex(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b;
    return "#".concat((0, $4e2643d0408869b9$export$34d09c4a771c46ef)(r, g, b, false));
}
// Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.
function $6205d9ff2fce7a51$var$mix(rgb1, rgb2, amount) {
    var p = amount / 100;
    var rgb = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b
    };
    return rgb;
}
function $6205d9ff2fce7a51$var$getHue(hsv, i, light) {
    var hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $6205d9ff2fce7a51$var$hueStep * i : Math.round(hsv.h) + $6205d9ff2fce7a51$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $6205d9ff2fce7a51$var$hueStep * i : Math.round(hsv.h) - $6205d9ff2fce7a51$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $6205d9ff2fce7a51$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $6205d9ff2fce7a51$var$saturationStep * i;
    else if (i === $6205d9ff2fce7a51$var$darkColorCount) saturation = hsv.s + $6205d9ff2fce7a51$var$saturationStep;
    else saturation = hsv.s + $6205d9ff2fce7a51$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $6205d9ff2fce7a51$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Number(saturation.toFixed(2));
}
function $6205d9ff2fce7a51$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $6205d9ff2fce7a51$var$brightnessStep1 * i;
    else value = hsv.v - $6205d9ff2fce7a51$var$brightnessStep2 * i;
    if (value > 1) value = 1;
    return Number(value.toFixed(2));
}
function $6205d9ff2fce7a51$export$2e2bcd8739ae039(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = (0, $2fa37706dfe4f618$export$87de337d8199f22c)(color);
    for(var i = $6205d9ff2fce7a51$var$lightColorCount; i > 0; i -= 1){
        var hsv = $6205d9ff2fce7a51$var$toHsv(pColor);
        var colorString = $6205d9ff2fce7a51$var$toHex((0, $2fa37706dfe4f618$export$87de337d8199f22c)({
            h: $6205d9ff2fce7a51$var$getHue(hsv, i, true),
            s: $6205d9ff2fce7a51$var$getSaturation(hsv, i, true),
            v: $6205d9ff2fce7a51$var$getValue(hsv, i, true)
        }));
        patterns.push(colorString);
    }
    patterns.push($6205d9ff2fce7a51$var$toHex(pColor));
    for(var _i = 1; _i <= $6205d9ff2fce7a51$var$darkColorCount; _i += 1){
        var _hsv = $6205d9ff2fce7a51$var$toHsv(pColor);
        var _colorString = $6205d9ff2fce7a51$var$toHex((0, $2fa37706dfe4f618$export$87de337d8199f22c)({
            h: $6205d9ff2fce7a51$var$getHue(_hsv, _i),
            s: $6205d9ff2fce7a51$var$getSaturation(_hsv, _i),
            v: $6205d9ff2fce7a51$var$getValue(_hsv, _i)
        }));
        patterns.push(_colorString);
    }
    // dark theme patterns
    if (opts.theme === 'dark') return $6205d9ff2fce7a51$var$darkColorMap.map(function(_ref3) {
        var index = _ref3.index, opacity = _ref3.opacity;
        var darkColorString = $6205d9ff2fce7a51$var$toHex($6205d9ff2fce7a51$var$mix((0, $2fa37706dfe4f618$export$87de337d8199f22c)(opts.backgroundColor || '#141414'), (0, $2fa37706dfe4f618$export$87de337d8199f22c)(patterns[index]), opacity * 100));
        return darkColorString;
    });
    return patterns;
}


// Generated by script. Do NOT modify!
var $f9b009df50b30ac5$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
var $f9b009df50b30ac5$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$f9b009df50b30ac5$export$a90204d1394caf30.primary = $f9b009df50b30ac5$export$a90204d1394caf30[5];
var $f9b009df50b30ac5$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$f9b009df50b30ac5$export$e63a1643b2f79b16.primary = $f9b009df50b30ac5$export$e63a1643b2f79b16[5];
var $f9b009df50b30ac5$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$f9b009df50b30ac5$export$ad766f34ace1cafd.primary = $f9b009df50b30ac5$export$ad766f34ace1cafd[5];
var $f9b009df50b30ac5$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$f9b009df50b30ac5$export$c24201f7fe3571d8.primary = $f9b009df50b30ac5$export$c24201f7fe3571d8[5];
var $f9b009df50b30ac5$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$f9b009df50b30ac5$export$594c5a8758200c32.primary = $f9b009df50b30ac5$export$594c5a8758200c32[5];
var $f9b009df50b30ac5$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$f9b009df50b30ac5$export$221d31baf2636aad.primary = $f9b009df50b30ac5$export$221d31baf2636aad[5];
var $f9b009df50b30ac5$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$f9b009df50b30ac5$export$955a2ebd2fb142ae.primary = $f9b009df50b30ac5$export$955a2ebd2fb142ae[5];
var $f9b009df50b30ac5$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$f9b009df50b30ac5$export$7474046f446842ee.primary = $f9b009df50b30ac5$export$7474046f446842ee[5];
var $f9b009df50b30ac5$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$f9b009df50b30ac5$export$2aa0182783e7e9de.primary = $f9b009df50b30ac5$export$2aa0182783e7e9de[5];
var $f9b009df50b30ac5$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$f9b009df50b30ac5$export$4138d3aeddcbf415.primary = $f9b009df50b30ac5$export$4138d3aeddcbf415[5];
var $f9b009df50b30ac5$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$f9b009df50b30ac5$export$e13cce2a2d16a9d4.primary = $f9b009df50b30ac5$export$e13cce2a2d16a9d4[5];
var $f9b009df50b30ac5$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$f9b009df50b30ac5$export$2a9ca2e383622e18.primary = $f9b009df50b30ac5$export$2a9ca2e383622e18[5];
var $f9b009df50b30ac5$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$f9b009df50b30ac5$export$e4c89085febbc618.primary = $f9b009df50b30ac5$export$e4c89085febbc618[5];
var $f9b009df50b30ac5$export$3e2c219d3ab79d01 = $f9b009df50b30ac5$export$e4c89085febbc618;
var $f9b009df50b30ac5$export$36ad6df0f83f284d = {
    red: $f9b009df50b30ac5$export$a90204d1394caf30,
    volcano: $f9b009df50b30ac5$export$e63a1643b2f79b16,
    orange: $f9b009df50b30ac5$export$ad766f34ace1cafd,
    gold: $f9b009df50b30ac5$export$c24201f7fe3571d8,
    yellow: $f9b009df50b30ac5$export$594c5a8758200c32,
    lime: $f9b009df50b30ac5$export$221d31baf2636aad,
    green: $f9b009df50b30ac5$export$955a2ebd2fb142ae,
    cyan: $f9b009df50b30ac5$export$7474046f446842ee,
    blue: $f9b009df50b30ac5$export$2aa0182783e7e9de,
    geekblue: $f9b009df50b30ac5$export$4138d3aeddcbf415,
    purple: $f9b009df50b30ac5$export$e13cce2a2d16a9d4,
    magenta: $f9b009df50b30ac5$export$2a9ca2e383622e18,
    grey: $f9b009df50b30ac5$export$e4c89085febbc618
};
var $f9b009df50b30ac5$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$f9b009df50b30ac5$export$e984d34fc144caa1.primary = $f9b009df50b30ac5$export$e984d34fc144caa1[5];
var $f9b009df50b30ac5$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$f9b009df50b30ac5$export$360e10f78e17a865.primary = $f9b009df50b30ac5$export$360e10f78e17a865[5];
var $f9b009df50b30ac5$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$f9b009df50b30ac5$export$d5a12c698b31fa45.primary = $f9b009df50b30ac5$export$d5a12c698b31fa45[5];
var $f9b009df50b30ac5$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$f9b009df50b30ac5$export$2330427fb6a6af6f.primary = $f9b009df50b30ac5$export$2330427fb6a6af6f[5];
var $f9b009df50b30ac5$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$f9b009df50b30ac5$export$67d203119f0ecec.primary = $f9b009df50b30ac5$export$67d203119f0ecec[5];
var $f9b009df50b30ac5$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$f9b009df50b30ac5$export$51ed2a10d86576ed.primary = $f9b009df50b30ac5$export$51ed2a10d86576ed[5];
var $f9b009df50b30ac5$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$f9b009df50b30ac5$export$76a3d804058f9b5f.primary = $f9b009df50b30ac5$export$76a3d804058f9b5f[5];
var $f9b009df50b30ac5$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$f9b009df50b30ac5$export$dee6c7c6683c0d88.primary = $f9b009df50b30ac5$export$dee6c7c6683c0d88[5];
var $f9b009df50b30ac5$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$f9b009df50b30ac5$export$10e0fd027e632624.primary = $f9b009df50b30ac5$export$10e0fd027e632624[5];
var $f9b009df50b30ac5$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$f9b009df50b30ac5$export$abdd57ab473bba66.primary = $f9b009df50b30ac5$export$abdd57ab473bba66[5];
var $f9b009df50b30ac5$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$f9b009df50b30ac5$export$7a65e68792738764.primary = $f9b009df50b30ac5$export$7a65e68792738764[5];
var $f9b009df50b30ac5$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$f9b009df50b30ac5$export$d260a9321db4ab86.primary = $f9b009df50b30ac5$export$d260a9321db4ab86[5];
var $f9b009df50b30ac5$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$f9b009df50b30ac5$export$515283ba400ffa6c.primary = $f9b009df50b30ac5$export$515283ba400ffa6c[5];
var $f9b009df50b30ac5$export$24617255e4daf647 = {
    red: $f9b009df50b30ac5$export$e984d34fc144caa1,
    volcano: $f9b009df50b30ac5$export$360e10f78e17a865,
    orange: $f9b009df50b30ac5$export$d5a12c698b31fa45,
    gold: $f9b009df50b30ac5$export$2330427fb6a6af6f,
    yellow: $f9b009df50b30ac5$export$67d203119f0ecec,
    lime: $f9b009df50b30ac5$export$51ed2a10d86576ed,
    green: $f9b009df50b30ac5$export$76a3d804058f9b5f,
    cyan: $f9b009df50b30ac5$export$dee6c7c6683c0d88,
    blue: $f9b009df50b30ac5$export$10e0fd027e632624,
    geekblue: $f9b009df50b30ac5$export$abdd57ab473bba66,
    purple: $f9b009df50b30ac5$export$7a65e68792738764,
    magenta: $f9b009df50b30ac5$export$d260a9321db4ab86,
    grey: $f9b009df50b30ac5$export$515283ba400ffa6c
};






function $1d18f8f472bfe471$export$328518dfd47a58e9(props) {
    const typeLabels = [];
    const typeData = [];
    Object.entries(props.projectStatistics.plantedPlantsTypes).forEach(([key, value])=>{
        typeLabels.push(key);
        typeData.push(value);
    });
    const attractivenessFactorsLabels = [];
    const attractivenessFactorsData = [];
    if (props.projectStatistics.plantedPlantsAttractivenessFactors) Object.entries(props.projectStatistics.plantedPlantsAttractivenessFactors).forEach(([key, value])=>{
        attractivenessFactorsLabels.push(key);
        attractivenessFactorsData.push(value);
    });
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $ad1c3304c519fac5$export$2e2bcd8739ae039), {
        variant: "borderless",
        style: {
            borderRadius: 12,
            boxShadow: '0 2px 14px rgba(0,0,0,0.06)',
            overflow: 'hidden',
            height: '100%'
        },
        styles: {
            body: {
                padding: 0,
                display: 'grid',
                minHeight: '200px'
            }
        },
        className: "project-panel",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                to: `/projects/${props.projectStatistics.id}`,
                className: "project-panel__name",
                style: {
                    color: (0, $f9b009df50b30ac5$export$ad766f34ace1cafd)[5]
                },
                children: props.projectStatistics.name
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "info",
                children: [
                    intl.formatMessage({
                        id: 'totalPlantsInTheProject'
                    }),
                    ":",
                    ' ',
                    props.projectStatistics.plantedPlantsAmount,
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "doughnut",
                        children: [
                            props.projectStatistics.plantedPlantsAmount === 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "project__without-plants",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    ghost: true,
                                    danger: true,
                                    id: "button-no-todos",
                                    onClick: ()=>{
                                        navigate(`/projects/${props.projectStatistics.id}/plants/new`);
                                    },
                                    children: intl.formatMessage({
                                        id: 'createTheFirstPlantInTheProject'
                                    })
                                })
                            }),
                            typeData.length !== 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f364623c23d5ae9f$export$b8b3cfdc3fe36b10), {
                                    options: {
                                        responsive: true,
                                        plugins: {
                                            legend: {
                                                display: false
                                            }
                                        }
                                    },
                                    data: {
                                        labels: typeLabels,
                                        datasets: [
                                            {
                                                data: typeData,
                                                borderWidth: 1,
                                                backgroundColor: [
                                                    'rgb(160, 122, 108)',
                                                    'rgb(245, 242, 83)',
                                                    'rgb(245, 129, 83)',
                                                    'rgb(53, 171, 151)',
                                                    'rgb(154, 83, 245)',
                                                    'rgb(223, 206, 198)',
                                                    'rgb(215, 214, 153)',
                                                    'rgb(215, 171, 153)',
                                                    'rgb(210, 226, 222)',
                                                    'rgb(182,155,218)'
                                                ]
                                            }
                                        ]
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "weather",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $efbfba7bbb733f04$export$c7ba05ed26d2c55), {
                    weather: props.projectStatistics.weather,
                    projectId: props.projectStatistics.id
                })
            })
        ]
    });
}





var $ltGt3 = parcelRequire("ltGt3");






var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");




function $40cefbb323433535$var$mergeProps(...items) {
    const ret = {};
    items.forEach((item)=>{
        if (item) Object.keys(item).forEach((key)=>{
            if (item[key] !== undefined) ret[key] = item[key];
        });
    });
    return ret;
}
var $40cefbb323433535$export$2e2bcd8739ae039 = $40cefbb323433535$var$mergeProps;



"use client";
const $dd7ac7131208b252$export$51ad9c30389f050b = (context)=>{
    if (!context) return undefined;
    const { closable: closable, closeIcon: closeIcon } = context;
    return {
        closable: closable,
        closeIcon: closeIcon
    };
};
const $dd7ac7131208b252$var$EmptyFallbackCloseCollection = {};
const $dd7ac7131208b252$var$computeClosableConfig = (closable, closeIcon)=>{
    if (!closable && (closable === false || closeIcon === false || closeIcon === null)) return false;
    if (closable === undefined && closeIcon === undefined) return null;
    let closableConfig = {
        closeIcon: typeof closeIcon !== 'boolean' && closeIcon !== null ? closeIcon : undefined
    };
    if (closable && typeof closable === 'object') closableConfig = {
        ...closableConfig,
        ...closable
    };
    return closableConfig;
};
const $dd7ac7131208b252$var$mergeClosableConfigs = (propConfig, contextConfig, fallbackConfig)=>{
    if (propConfig === false) return false;
    if (propConfig) return (0, $40cefbb323433535$export$2e2bcd8739ae039)(fallbackConfig, contextConfig, propConfig);
    if (contextConfig === false) return false;
    if (contextConfig) return (0, $40cefbb323433535$export$2e2bcd8739ae039)(fallbackConfig, contextConfig);
    return fallbackConfig.closable ? fallbackConfig : false;
};
const $dd7ac7131208b252$var$computeCloseIcon = (mergedConfig, fallbackCloseCollection, closeLabel)=>{
    const { closeIconRender: closeIconRender } = fallbackCloseCollection;
    const { closeIcon: closeIcon, ...restConfig } = mergedConfig;
    let finalCloseIcon = closeIcon;
    const ariaOrDataProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(restConfig, true);
    if ((0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(finalCloseIcon)) {
        if (closeIconRender) finalCloseIcon = closeIconRender(finalCloseIcon);
        finalCloseIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).isValidElement(finalCloseIcon) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(finalCloseIcon, {
            'aria-label': closeLabel,
            ...finalCloseIcon.props,
            ...ariaOrDataProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            "aria-label": closeLabel,
            ...ariaOrDataProps
        }, finalCloseIcon);
    }
    return [
        finalCloseIcon,
        ariaOrDataProps
    ];
};
const $dd7ac7131208b252$export$41ed0597a5c42f8 = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = $dd7ac7131208b252$var$EmptyFallbackCloseCollection, closeLabel = 'Close')=>{
    const propConfig = $dd7ac7131208b252$var$computeClosableConfig(propCloseCollection?.closable, propCloseCollection?.closeIcon);
    const contextConfig = $dd7ac7131208b252$var$computeClosableConfig(contextCloseCollection?.closable, contextCloseCollection?.closeIcon);
    const mergedFallback = {
        closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), null),
        ...fallbackCloseCollection
    };
    const mergedConfig = $dd7ac7131208b252$var$mergeClosableConfigs(propConfig, contextConfig, mergedFallback);
    const closeBtnIsDisabled = typeof mergedConfig !== 'boolean' ? !!mergedConfig?.disabled : false;
    if (mergedConfig === false) return [
        false,
        null,
        closeBtnIsDisabled,
        {}
    ];
    const [closeIcon, ariaProps] = $dd7ac7131208b252$var$computeCloseIcon(mergedConfig, mergedFallback, closeLabel);
    return [
        true,
        closeIcon,
        closeBtnIsDisabled,
        ariaProps
    ];
};
const $dd7ac7131208b252$export$aa101db403ccf5f3 = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = $dd7ac7131208b252$var$EmptyFallbackCloseCollection)=>{
    const [contextLocale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('global', (0, $29f4f00e8825a41b$export$2e2bcd8739ae039).global);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        return $dd7ac7131208b252$export$41ed0597a5c42f8(propCloseCollection, contextCloseCollection, {
            closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), null),
            ...fallbackCloseCollection
        }, contextLocale.close);
    }, [
        propCloseCollection,
        contextCloseCollection,
        fallbackCloseCollection,
        contextLocale.close
    ]);
};









var $ltGt3 = parcelRequire("ltGt3");









// ============================== Styles ==============================
const $439b5f0a793dd468$var$genBaseStyle = (token)=>{
    const { paddingXXS: paddingXXS, lineWidth: lineWidth, tagPaddingHorizontal: tagPaddingHorizontal, componentCls: componentCls, calc: calc } = token;
    const paddingInline = calc(tagPaddingHorizontal).sub(lineWidth).equal();
    const iconMarginInline = calc(paddingXXS).sub(lineWidth).equal();
    return {
        // Result
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            display: 'inline-block',
            height: 'auto',
            paddingInline: paddingInline,
            fontSize: token.tagFontSize,
            lineHeight: token.tagLineHeight,
            whiteSpace: 'nowrap',
            backgroundColor: token.defaultBg,
            border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
            borderRadius: token.borderRadiusSM,
            opacity: 1,
            transition: `all ${token.motionDurationMid}`,
            textAlign: 'start',
            position: 'relative',
            // RTL
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            },
            '&, a, a:hover': {
                color: token.defaultColor
            },
            [`${componentCls}-close-icon`]: {
                marginInlineStart: iconMarginInline,
                fontSize: token.tagIconSize,
                color: token.colorIcon,
                cursor: 'pointer',
                transition: `all ${token.motionDurationMid}`,
                '&:hover': {
                    color: token.colorTextHeading
                }
            },
            '&-checkable': {
                backgroundColor: 'transparent',
                borderColor: 'transparent',
                cursor: 'pointer',
                [`&:not(${componentCls}-checkable-checked):hover`]: {
                    color: token.colorPrimary,
                    backgroundColor: token.colorFillSecondary
                },
                '&:active, &-checked': {
                    color: token.colorTextLightSolid
                },
                '&-checked': {
                    backgroundColor: token.colorPrimary,
                    '&:hover': {
                        backgroundColor: token.colorPrimaryHover
                    }
                },
                '&:active': {
                    backgroundColor: token.colorPrimaryActive
                },
                '&-disabled': {
                    cursor: 'not-allowed',
                    [`&:not(${componentCls}-checkable-checked)`]: {
                        color: token.colorTextDisabled,
                        '&:hover': {
                            backgroundColor: 'transparent'
                        }
                    },
                    [`&${componentCls}-checkable-checked`]: {
                        color: token.colorTextDisabled,
                        backgroundColor: token.colorBgContainerDisabled
                    },
                    '&:hover, &:active': {
                        backgroundColor: token.colorBgContainerDisabled,
                        color: token.colorTextDisabled
                    },
                    [`&:not(${componentCls}-checkable-checked):hover`]: {
                        color: token.colorTextDisabled
                    }
                },
                '&-group': {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: token.paddingXS
                }
            },
            '&-hidden': {
                display: 'none'
            },
            // To ensure that a space will be placed between character and `Icon`.
            [`> ${token.iconCls} + span, > span + ${token.iconCls}`]: {
                marginInlineStart: paddingInline
            }
        },
        [`&${token.componentCls}-solid`]: {
            borderColor: 'transparent',
            color: token.colorTextLightSolid,
            backgroundColor: token.colorBgSolid,
            [`&${componentCls}-default`]: {
                color: token.solidTextColor
            }
        },
        [`${componentCls}-filled`]: {
            borderColor: 'transparent',
            backgroundColor: token.tagBorderlessBg
        },
        [`&${componentCls}-disabled`]: {
            color: token.colorTextDisabled,
            cursor: 'not-allowed',
            backgroundColor: token.colorBgContainerDisabled,
            a: {
                cursor: 'not-allowed',
                pointerEvents: 'none',
                color: token.colorTextDisabled,
                '&:hover': {
                    color: token.colorTextDisabled
                }
            },
            'a&': {
                '&:hover, &:active': {
                    color: token.colorTextDisabled
                }
            },
            [`&${componentCls}-outlined`]: {
                borderColor: token.colorBorderDisabled
            },
            [`&${componentCls}-solid, &${componentCls}-filled`]: {
                color: token.colorTextDisabled,
                [`${componentCls}-close-icon`]: {
                    color: token.colorTextDisabled
                }
            },
            [`${componentCls}-close-icon`]: {
                cursor: 'not-allowed',
                color: token.colorTextDisabled,
                '&:hover': {
                    color: token.colorTextDisabled
                }
            }
        }
    };
};
const $439b5f0a793dd468$export$362fb92a8f81bbf9 = (token)=>{
    const { lineWidth: lineWidth, fontSizeIcon: fontSizeIcon, calc: calc } = token;
    const tagFontSize = token.fontSizeSM;
    const tagToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        tagFontSize: tagFontSize,
        tagLineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(token.lineHeightSM).mul(tagFontSize).equal()),
        tagIconSize: calc(fontSizeIcon).sub(calc(lineWidth).mul(2)).equal(),
        // Tag icon is much smaller
        tagPaddingHorizontal: 8,
        // Fixed padding.
        tagBorderlessBg: token.defaultBg
    });
    return tagToken;
};
const $439b5f0a793dd468$export$9ca1be8807fe0675 = (token)=>{
    const solidTextColor = (0, $41c95c5c86b3c331$export$6341b37cb79161da)(new (0, $fdef9a771b8d4d72$export$e8cc8a2e87e145b4)(token.colorBgSolid), '#fff') ? '#000' : '#fff';
    return {
        defaultBg: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(token.colorFillQuaternary).onBackground(token.colorBgContainer).toHexString(),
        defaultColor: token.colorText,
        solidTextColor: solidTextColor
    };
};
var $439b5f0a793dd468$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Tag', (token)=>{
    const tagToken = $439b5f0a793dd468$export$362fb92a8f81bbf9(token);
    return $439b5f0a793dd468$var$genBaseStyle(tagToken);
}, $439b5f0a793dd468$export$9ca1be8807fe0675);


"use client";
const $b7f646f017dba869$var$CheckableTag = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, style: style, className: className, checked: checked, children: children, icon: icon, onChange: onChange, onClick: onClick, disabled: customDisabled, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, tag: tag } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const disabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const handleClick = (e)=>{
        if (mergedDisabled) return;
        onChange?.(!checked);
        onClick?.(e);
    };
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $439b5f0a793dd468$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-checkable`, {
        [`${prefixCls}-checkable-checked`]: checked,
        [`${prefixCls}-checkable-disabled`]: mergedDisabled
    }, tag?.className, className, hashId, cssVarCls);
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        ...restProps,
        ref: ref,
        style: {
            ...style,
            ...tag?.style
        },
        className: cls,
        onClick: handleClick
    }, icon, /*#__PURE__*/ $ltGt3.createElement("span", null, children));
});
var $b7f646f017dba869$export$2e2bcd8739ae039 = $b7f646f017dba869$var$CheckableTag;




var $ltGt3 = parcelRequire("ltGt3");








"use client";
function $222c532d411b1ddf$var$CheckableTagGroup(props, ref) {
    const { id: id, prefixCls: customizePrefixCls, rootClassName: rootClassName, className: className, style: style, classNames: classNames, styles: styles, disabled: disabled, options: options, value: value, defaultValue: defaultValue, onChange: onChange, multiple: multiple, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('tag');
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-checkable-group`;
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $439b5f0a793dd468$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ====================== Styles ======================
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    // =============================== Option ===============================
    const parsedOptions = (0, $ltGt3.useMemo)(()=>(options || []).map((option)=>{
            if (option && typeof option === 'object') return option;
            return {
                value: option,
                label: option
            };
        }), [
        options
    ]);
    // =============================== Values ===============================
    const [mergedValue, setMergedValue] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultValue, value);
    const handleChange = (checked, option)=>{
        let newValue = null;
        if (multiple) {
            const valueList = mergedValue || [];
            newValue = checked ? [].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(valueList), [
                option.value
            ]) : valueList.filter((item)=>item !== option.value);
        } else newValue = checked ? option.value : null;
        setMergedValue(newValue);
        onChange?.(newValue); // TS not support generic type in function call
    };
    // ================================ Refs ================================
    const divRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    (0, $ltGt3.useImperativeHandle)(ref, ()=>({
            nativeElement: divRef.current
        }));
    // ================================ ARIA ================================
    const ariaProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(restProps, {
        aria: true,
        data: true
    });
    // =============================== Render ===============================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        ...ariaProps,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(groupPrefixCls, contextClassName, rootClassName, {
            [`${groupPrefixCls}-disabled`]: disabled,
            [`${groupPrefixCls}-rtl`]: direction === 'rtl'
        }, hashId, cssVarCls, className, mergedClassNames.root),
        style: {
            ...contextStyle,
            ...mergedStyles.root,
            ...style
        },
        id: id,
        ref: divRef
    }, parsedOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $b7f646f017dba869$export$2e2bcd8739ae039), {
            key: option.value,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${groupPrefixCls}-item`, mergedClassNames.item),
            style: mergedStyles.item,
            checked: multiple ? (mergedValue || []).includes(option.value) : mergedValue === option.value,
            onChange: (checked)=>handleChange(checked, option),
            disabled: disabled
        }, option.label)));
}
const $222c532d411b1ddf$var$ForwardCheckableTagGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef($222c532d411b1ddf$var$CheckableTagGroup);
var $222c532d411b1ddf$export$2e2bcd8739ae039 = $222c532d411b1ddf$var$ForwardCheckableTagGroup;



var $ltGt3 = parcelRequire("ltGt3");


function $ada6337d6dff2984$export$2e2bcd8739ae039(props, contextVariant) {
    const { color: color, variant: variant, bordered: bordered } = props;
    return $ltGt3.useMemo(()=>{
        const isInverseColor = color?.endsWith('-inverse');
        // =================== Variant ===================
        let nextVariant;
        if (variant) // `variant` first
        nextVariant = variant;
        else if (isInverseColor) // Fallback if using inverse color
        nextVariant = 'solid';
        else if (bordered === false) // Fallback if using filled
        nextVariant = 'filled';
        else // Finally not conflict, use context
        nextVariant = contextVariant || 'filled';
        // ==================== Color ====================
        const nextColor = isInverseColor ? color?.replace('-inverse', '') : color;
        // =============== Preset & Status ===============
        const nextIsPreset = (0, $af9f1fd0e95fb060$export$ee62ebd6a58c4884)(color);
        const nextIsStatus = (0, $af9f1fd0e95fb060$export$88a0ba1f7d1ea40e)(color);
        // ================== Customize ==================
        // When `color` is not preset color,
        // dynamic calculate the color pair.
        const tagStyle = {};
        if (!nextIsPreset && !nextIsStatus && nextColor) {
            if (nextVariant === 'solid') tagStyle.backgroundColor = color;
            else {
                const hsl = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(nextColor).toHsl();
                hsl.l = 0.95;
                tagStyle.backgroundColor = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(hsl).toHexString();
                tagStyle.color = color;
                if (nextVariant === 'outlined') tagStyle.borderColor = color;
            }
        }
        return [
            nextVariant,
            nextColor,
            nextIsPreset,
            nextIsStatus,
            tagStyle
        ];
    }, [
        color,
        variant,
        bordered,
        contextVariant
    ]);
}



// Style as status component


// ============================== Preset ==============================
const $8218fad2c5511a88$var$genPresetStyle = (token)=>(0, $a6826a70be89cfee$export$2e2bcd8739ae039)(token, (colorKey, { textColor: textColor, lightBorderColor: lightBorderColor, lightColor: lightColor, darkColor: darkColor })=>({
            [`${token.componentCls}${token.componentCls}-${colorKey}:not(${token.componentCls}-disabled)`]: {
                [`&${token.componentCls}-outlined`]: {
                    backgroundColor: lightColor,
                    borderColor: lightBorderColor,
                    color: textColor
                },
                [`&${token.componentCls}-solid`]: {
                    backgroundColor: darkColor,
                    borderColor: darkColor,
                    color: token.colorTextLightSolid
                },
                [`&${token.componentCls}-filled`]: {
                    backgroundColor: lightColor,
                    color: textColor
                }
            }
        }));
var // ============================== Export ==============================
$8218fad2c5511a88$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$1537386bc155ea56)([
    'Tag',
    'preset'
], (token)=>{
    const tagToken = (0, $439b5f0a793dd468$export$362fb92a8f81bbf9)(token);
    return $8218fad2c5511a88$var$genPresetStyle(tagToken);
}, (0, $439b5f0a793dd468$export$9ca1be8807fe0675));



function $46b0e6eb7abdf10d$export$2e2bcd8739ae039(str) {
    if (typeof str !== 'string') return str;
    const ret = str.charAt(0).toUpperCase() + str.slice(1);
    return ret;
}



const $f181f66d6eb33bec$var$genTagStatusStyle = (token, status, cssVariableType)=>{
    const capitalizedCssVariableType = (0, $46b0e6eb7abdf10d$export$2e2bcd8739ae039)(cssVariableType);
    return {
        [`${token.componentCls}${token.componentCls}-${status}:not(${token.componentCls}-disabled)`]: {
            [`&${token.componentCls}-outlined`]: {
                backgroundColor: token[`color${capitalizedCssVariableType}Bg`],
                borderColor: token[`color${capitalizedCssVariableType}Border`],
                color: token[`color${cssVariableType}`]
            },
            [`&${token.componentCls}-solid`]: {
                backgroundColor: token[`color${cssVariableType}`],
                borderColor: token[`color${cssVariableType}`]
            },
            [`&${token.componentCls}-filled`]: {
                backgroundColor: token[`color${capitalizedCssVariableType}Bg`],
                color: token[`color${cssVariableType}`]
            }
        }
    };
};
var // ============================== Export ==============================
$f181f66d6eb33bec$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$1537386bc155ea56)([
    'Tag',
    'status'
], (token)=>{
    const tagToken = (0, $439b5f0a793dd468$export$362fb92a8f81bbf9)(token);
    return [
        $f181f66d6eb33bec$var$genTagStatusStyle(tagToken, 'success', 'Success'),
        $f181f66d6eb33bec$var$genTagStatusStyle(tagToken, 'processing', 'Info'),
        $f181f66d6eb33bec$var$genTagStatusStyle(tagToken, 'error', 'Error'),
        $f181f66d6eb33bec$var$genTagStatusStyle(tagToken, 'warning', 'Warning')
    ];
}, (0, $439b5f0a793dd468$export$9ca1be8807fe0675));


"use client";
const $275a14ee9b85c941$var$InternalTag = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, children: children, icon: icon, color: color, variant: _variant, onClose: onClose, bordered: bordered, disabled: customDisabled, href: href, target: target, styles: styles, classNames: classNames, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, variant: contextVariant, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('tag');
    // ====================== Colors ======================
    const [mergedVariant, mergedColor, isPreset, isStatus, customTagStyle] = (0, $ada6337d6dff2984$export$2e2bcd8739ae039)(props, contextVariant);
    const isInternalColor = isPreset || isStatus;
    // ===================== Disabled =====================
    const disabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const { tag: tagContext } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const [visible, setVisible] = $ltGt3.useState(true);
    const domProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(restProps, [
        'closeIcon',
        'closable'
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        color: mergedColor,
        variant: mergedVariant,
        disabled: mergedDisabled,
        href: href,
        target: target,
        icon: icon
    };
    // ====================== Styles ======================
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const tagStyle = $ltGt3.useMemo(()=>{
        let nextTagStyle = {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        };
        if (!mergedDisabled) nextTagStyle = {
            ...customTagStyle,
            ...nextTagStyle
        };
        return nextTagStyle;
    }, [
        mergedStyles.root,
        contextStyle,
        style,
        customTagStyle,
        mergedDisabled
    ]);
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $439b5f0a793dd468$export$2e2bcd8739ae039)(prefixCls);
    const tagClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, contextClassName, mergedClassNames.root, `${prefixCls}-${mergedVariant}`, {
        [`${prefixCls}-${mergedColor}`]: isInternalColor,
        [`${prefixCls}-hidden`]: !visible,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-disabled`]: mergedDisabled
    }, className, rootClassName, hashId, cssVarCls);
    // ===================== Closable =====================
    const handleCloseClick = (e)=>{
        if (mergedDisabled) return;
        e.stopPropagation();
        onClose?.(e);
        if (e.defaultPrevented) return;
        setVisible(false);
    };
    const [, mergedCloseIcon] = (0, $dd7ac7131208b252$export$aa101db403ccf5f3)((0, $dd7ac7131208b252$export$51ad9c30389f050b)(props), (0, $dd7ac7131208b252$export$51ad9c30389f050b)(tagContext), {
        closable: false,
        closeIconRender: (iconNode)=>{
            const replacement = /*#__PURE__*/ $ltGt3.createElement("span", {
                className: `${prefixCls}-close-icon`,
                onClick: handleCloseClick
            }, iconNode);
            return (0, $66d38239e1a27993$export$2dfe578f95754f6a)(iconNode, replacement, (originProps)=>({
                    onClick: (e)=>{
                        originProps?.onClick?.(e);
                        handleCloseClick(e);
                    },
                    className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(originProps?.className, `${prefixCls}-close-icon`)
                }));
        }
    });
    // ====================== Render ======================
    const isNeedWave = typeof restProps.onClick === 'function' || children && children.type === 'a';
    const iconNode = (0, $66d38239e1a27993$export$e530037191fcd5d7)(icon, {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(/*#__PURE__*/ $ltGt3.isValidElement(icon) ? icon.props?.className : '', mergedClassNames.icon),
        style: mergedStyles.icon
    });
    const child = iconNode ? /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, iconNode, children && /*#__PURE__*/ $ltGt3.createElement("span", {
        className: mergedClassNames.content,
        style: mergedStyles.content
    }, children)) : children;
    const TagWrapper = href ? 'a' : 'span';
    const tagNode = /*#__PURE__*/ $ltGt3.createElement(TagWrapper, {
        ...domProps,
        // @ts-expect-error
        ref: ref,
        className: tagClassName,
        style: tagStyle,
        href: mergedDisabled ? undefined : href,
        target: target,
        onClick: mergedDisabled ? undefined : domProps.onClick,
        ...href && mergedDisabled ? {
            'aria-disabled': true
        } : {}
    }, child, mergedCloseIcon, isPreset && /*#__PURE__*/ $ltGt3.createElement((0, $8218fad2c5511a88$export$2e2bcd8739ae039), {
        key: "preset",
        prefixCls: prefixCls
    }), isStatus && /*#__PURE__*/ $ltGt3.createElement((0, $f181f66d6eb33bec$export$2e2bcd8739ae039), {
        key: "status",
        prefixCls: prefixCls
    }));
    return isNeedWave ? /*#__PURE__*/ $ltGt3.createElement((0, $b5f0e609aabb59e2$export$2e2bcd8739ae039), {
        component: "Tag"
    }, tagNode) : tagNode;
});
const $275a14ee9b85c941$var$Tag = $275a14ee9b85c941$var$InternalTag;
$275a14ee9b85c941$var$Tag.CheckableTag = (0, $b7f646f017dba869$export$2e2bcd8739ae039);
$275a14ee9b85c941$var$Tag.CheckableTagGroup = (0, $222c532d411b1ddf$export$2e2bcd8739ae039);
var $275a14ee9b85c941$export$2e2bcd8739ae039 = $275a14ee9b85c941$var$Tag;


parcelRequire("ltGt3");
var $f0a4ffbb486b57b4$exports = {};
$f0a4ffbb486b57b4$exports = import.meta.resolve("NFdj9");




var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $c97e10c6cd070738$var$CalendarOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"
                }
            }
        ]
    },
    "name": "calendar",
    "theme": "outlined"
};
var $c97e10c6cd070738$export$2e2bcd8739ae039 = $c97e10c6cd070738$var$CalendarOutlined;







var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
var $ac80fa56ea650082$var$IconContext = /*#__PURE__*/ (0, $ltGt3.createContext)({});
var $ac80fa56ea650082$export$2e2bcd8739ae039 = $ac80fa56ea650082$var$IconContext;





var $ltGt3 = parcelRequire("ltGt3");




function $55b5af4f290ac7b5$var$getRoot(ele) {
    var _ele$getRootNode;
    return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
function $55b5af4f290ac7b5$export$cca82218ea4431a(ele) {
    return $55b5af4f290ac7b5$var$getRoot(ele) instanceof ShadowRoot;
}
function $55b5af4f290ac7b5$export$70e8259662bb498b(ele) {
    return $55b5af4f290ac7b5$export$cca82218ea4431a(ele) ? $55b5af4f290ac7b5$var$getRoot(ele) : null;
}




var $ltGt3 = parcelRequire("ltGt3");

function $1ef8ac8368ead61f$var$camelCase(input) {
    return input.replace(/-(.)/g, function(match, g) {
        return g.toUpperCase();
    });
}
function $1ef8ac8368ead61f$export$491112666e282270(valid, message) {
    (0, $a18317b8bba7a6b2$export$2e2bcd8739ae039)(valid, "[@ant-design/icons] ".concat(message));
}
function $1ef8ac8368ead61f$export$ab652842c37578f4(target) {
    return (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && ((0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(target.icon) === 'object' || typeof target.icon === 'function');
}
function $1ef8ac8368ead61f$export$9f5073e7201cc21c() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$1ef8ac8368ead61f$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $1ef8ac8368ead61f$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(node.tag, (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({
        key: key
    }, $1ef8ac8368ead61f$export$9f5073e7201cc21c(node.attrs)), (node.children || []).map(function(child, index) {
        return $1ef8ac8368ead61f$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(node.tag, (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({
        key: key
    }, $1ef8ac8368ead61f$export$9f5073e7201cc21c(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $1ef8ac8368ead61f$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $1ef8ac8368ead61f$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $6205d9ff2fce7a51$export$2e2bcd8739ae039)(primaryColor)[0];
}
function $1ef8ac8368ead61f$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
var $1ef8ac8368ead61f$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
var $1ef8ac8368ead61f$export$2c99b98b77550cb4 = "\n.anticon {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $1ef8ac8368ead61f$export$938b1f86b61613d0 = function useInsertStyles(eleRef) {
    var _useContext = (0, $ltGt3.useContext)((0, $ac80fa56ea650082$export$2e2bcd8739ae039)), csp = _useContext.csp, prefixCls = _useContext.prefixCls;
    var mergedStyleStr = $1ef8ac8368ead61f$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    (0, $ltGt3.useEffect)(function() {
        var ele = eleRef.current;
        var shadowRoot = (0, $55b5af4f290ac7b5$export$70e8259662bb498b)(ele);
        (0, $d058379f2019d619$export$4d99a2890bb989f0)(mergedStyleStr, '@ant-design-icons', {
            prepend: true,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


var $3336ec847b639994$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $3336ec847b639994$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $3336ec847b639994$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $3336ec847b639994$var$twoToneColorPalette.primaryColor = primaryColor;
    $3336ec847b639994$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $1ef8ac8368ead61f$export$b71c93f469694483)(primaryColor);
    $3336ec847b639994$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $3336ec847b639994$var$getTwoToneColors() {
    return (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, $3336ec847b639994$var$twoToneColorPalette);
}
var $3336ec847b639994$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $289081aecb178230$export$2e2bcd8739ae039)(props, $3336ec847b639994$var$_excluded);
    var svgRef = $ltGt3.useRef();
    var colors = $3336ec847b639994$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $1ef8ac8368ead61f$export$b71c93f469694483)(primaryColor)
    };
    (0, $1ef8ac8368ead61f$export$938b1f86b61613d0)(svgRef);
    (0, $1ef8ac8368ead61f$export$491112666e282270)((0, $1ef8ac8368ead61f$export$ab652842c37578f4)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $1ef8ac8368ead61f$export$ab652842c37578f4)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === 'function') target = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $1ef8ac8368ead61f$export$80d376111cc09ad7)(target.icon, "svg-".concat(target.name), (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true'
    }, restProps), {}, {
        ref: svgRef
    }));
};
$3336ec847b639994$var$IconBase.displayName = 'IconReact';
$3336ec847b639994$var$IconBase.getTwoToneColors = $3336ec847b639994$var$getTwoToneColors;
$3336ec847b639994$var$IconBase.setTwoToneColors = $3336ec847b639994$var$setTwoToneColors;
var $3336ec847b639994$export$2e2bcd8739ae039 = $3336ec847b639994$var$IconBase;





function $6a9c9dd2897a00a2$export$8a145f34580ff02b(twoToneColor) {
    var _normalizeTwoToneColo = (0, $1ef8ac8368ead61f$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return (0, $3336ec847b639994$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $6a9c9dd2897a00a2$export$abc7c554784cb4a7() {
    var colors = (0, $3336ec847b639994$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



'use client';
var $bbfd9d0fd6e02593$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $6a9c9dd2897a00a2$export$8a145f34580ff02b)((0, $f9b009df50b30ac5$export$2aa0182783e7e9de).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
var $bbfd9d0fd6e02593$var$Icon = /*#__PURE__*/ $ltGt3.forwardRef(function(props, ref) {
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $289081aecb178230$export$2e2bcd8739ae039)(props, $bbfd9d0fd6e02593$var$_excluded);
    var _React$useContext = $ltGt3.useContext((0, $ac80fa56ea650082$export$2e2bcd8739ae039)), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(rootClassName, prefixCls, (0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $db13280b58f1be94$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $1ef8ac8368ead61f$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $ltGt3.createElement("span", (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $ltGt3.createElement((0, $3336ec847b639994$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$bbfd9d0fd6e02593$var$Icon.displayName = 'AntdIcon';
$bbfd9d0fd6e02593$var$Icon.getTwoToneColor = (0, $6a9c9dd2897a00a2$export$abc7c554784cb4a7);
$bbfd9d0fd6e02593$var$Icon.setTwoToneColor = (0, $6a9c9dd2897a00a2$export$8a145f34580ff02b);
var $bbfd9d0fd6e02593$export$2e2bcd8739ae039 = $bbfd9d0fd6e02593$var$Icon;


var $9c348dd92383621c$var$CalendarOutlined = function CalendarOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $c97e10c6cd070738$export$2e2bcd8739ae039)
    }));
};
/**![calendar](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAxODRINzEydi02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMzg0di02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY2NjRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjIxNmMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDY1NkgxODRWNDYwaDY1NnYzODB6TTE4NCAzOTJWMjU2aDEyOHY0OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04di00OGgyNTZ2NDhjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOHYtNDhoMTI4djEzNkgxODR6IiAvPjwvc3ZnPg==) */ var $9c348dd92383621c$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($9c348dd92383621c$var$CalendarOutlined);
var $9c348dd92383621c$export$2e2bcd8739ae039 = $9c348dd92383621c$var$RefIcon;






var $Ohofd = parcelRequire("Ohofd");
const { Meta: $c9649eef890008f4$var$Meta } = (0, $ad1c3304c519fac5$export$2e2bcd8739ae039);
function $c9649eef890008f4$export$327c00f32b963e04(props) {
    const coverH = props.isFirst ? 240 : 110;
    const cardHeight = props.isFirst ? 420 : 200;
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const photoURL = props.news.titlePhotoURL ? props.news.titlePhotoURL : (0, (/*@__PURE__*/$parcel$interopDefault($f0a4ffbb486b57b4$exports)));
    const Cover = /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        style: {
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    height: coverH
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                    className: "home-layout__news-list__news-card__img",
                    src: photoURL,
                    alt: props.news.newsName
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "home-layout__news-list__news-card__tags",
                children: (props.news.tags || []).slice(0, 2).map((t)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                        className: "home-layout__news-list__news-card__tags__tag",
                        style: {
                            color: t.color ? t.color : '#f58153'
                        },
                        children: intl.locale === 'en' ? t.tagName : t.tagNameRu
                    }, t.id))
            })
        ]
    });
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ad1c3304c519fac5$export$2e2bcd8739ae039), {
            //className="news-card"
            hoverable: true,
            cover: Cover,
            styles: {
                body: {
                    padding: props.isFirst ? 16 : 14,
                    height: cardHeight - coverH
                }
            },
            style: {
                borderRadius: 12,
                overflow: 'hidden',
                boxShadow: '0 1px 8px rgba(0,0,0,0.06)'
            },
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                style: {
                    width: '100%'
                },
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "home-layout__news-list__news-card__title",
                        style: {
                            fontWeight: 800,
                            fontSize: props.isFirst ? 24 : 18
                        },
                        children: intl.locale === 'en' ? props.news.newsName : props.news.newsNameRU
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                            className: "news-list-page__list__news__calendar",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9c348dd92383621c$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                    className: "news-list-page__list__news__calendar__text",
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(props.news.dateOfCreating).format('ll')
                                })
                            ]
                        })
                    }),
                    props.isFirst && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "home-layout__news-list__news-card__text",
                        children: `${intl.locale === 'en' ? props.news.text : props.news.textRU}...`
                    })
                ]
            })
        })
    });
}


const { Meta: $6daff296b3f07dd7$var$Meta } = (0, $ad1c3304c519fac5$export$2e2bcd8739ae039);
// these must match home.less (.home-layout__news-list): the first card track,
// the small card width and the gap between them. Overestimating how many cards
// fit makes the right column wrap into extra rows and overlap the content below.
const $6daff296b3f07dd7$var$firstCardWidth = 480;
const $6daff296b3f07dd7$var$cardWidth = 280;
const $6daff296b3f07dd7$var$cardGap = 24;
const $6daff296b3f07dd7$var$fullCardWidth = $6daff296b3f07dd7$var$cardWidth + $6daff296b3f07dd7$var$cardGap;
function $6daff296b3f07dd7$export$25b7c75712b6b29(props) {
    const [firstCardIndex, setFirstCardIndex] = (0, $ltGt3.useState)(0);
    const newsListContainerRef = (0, $ltGt3.useRef)(null);
    const [newsPerView, setNewsPerView] = (0, $ltGt3.useState)(1);
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const recalculateNewsPerView = (0, $ltGt3.useCallback)(()=>{
        if (!newsListContainerRef.current) return;
        const containerWidth = newsListContainerRef.current.clientWidth;
        const cardsToDisplay = Math.floor((containerWidth - $6daff296b3f07dd7$var$firstCardWidth) / $6daff296b3f07dd7$var$fullCardWidth) * 2 + 1;
        setNewsPerView(cardsToDisplay < 1 ? 1 : cardsToDisplay);
    }, [
        setNewsPerView
    ]);
    (0, $ltGt3.useEffect)(()=>{
        const callback = recalculateNewsPerView;
        callback();
        window.addEventListener('resize', callback);
        return ()=>window.removeEventListener('resize', callback);
    }, []);
    const newsToDisplay = [];
    for(let i = 0; i < newsPerView; i++){
        let currentIndex = (i + firstCardIndex) % props.newsList.length;
        newsToDisplay.push(props.newsList[currentIndex]);
    }
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "home-layout__news-list",
        // style={{
        //   display: 'flex',
        //   flexDirection: 'row',
        //   overflowX: 'hidden',
        //   overflowY: 'visible',
        //   padding: `10px 0`,
        // }}
        ref: newsListContainerRef,
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                to: '/home/news/' + newsToDisplay[0].url,
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    className: "home-layout__news-list__first-news-card",
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $c9649eef890008f4$export$327c00f32b963e04), {
                        news: newsToDisplay[0],
                        isFirst: true
                    })
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "home-layout__news-list__right",
                children: newsToDisplay.splice(1)?.map((news, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                        to: '/home/news/' + news.url,
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            className: "home-layout__news-list__news-card",
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $c9649eef890008f4$export$327c00f32b963e04), {
                                news: news,
                                isFirst: false
                            })
                        })
                    }, index))
            })
        ]
    });
}


var $de8c74995637f2ce$exports = {};
$de8c74995637f2ce$exports = import.meta.resolve("1FZVK");




var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $1a6c273df850099c$var$ArrowDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z"
                }
            }
        ]
    },
    "name": "arrow-down",
    "theme": "outlined"
};
var $1a6c273df850099c$export$2e2bcd8739ae039 = $1a6c273df850099c$var$ArrowDownOutlined;



var $3511e38a5bf0c930$var$ArrowDownOutlined = function ArrowDownOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $1a6c273df850099c$export$2e2bcd8739ae039)
    }));
};
/**![arrow-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2MiA0NjUuM2gtODFjLTQuNiAwLTkgMi0xMi4xIDUuNUw1NTAgNzIzLjFWMTYwYzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHY1NjMuMUwyNTUuMSA0NzAuOGMtMy0zLjUtNy40LTUuNS0xMi4xLTUuNWgtODFjLTYuOCAwLTEwLjUgOC4xLTYgMTMuMkw0ODcuOSA4NjFhMzEuOTYgMzEuOTYgMCAwMDQ4LjMgMEw4NjggNDc4LjVjNC41LTUuMi44LTEzLjItNi0xMy4yeiIgLz48L3N2Zz4=) */ var $3511e38a5bf0c930$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($3511e38a5bf0c930$var$ArrowDownOutlined);
var $3511e38a5bf0c930$export$2e2bcd8739ae039 = $3511e38a5bf0c930$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");


var $b22ab34d306c7e4e$var$CheckOutlined = function CheckOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $99a3077f6acc8f83$export$2e2bcd8739ae039)
    }));
};
/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */ var $b22ab34d306c7e4e$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($b22ab34d306c7e4e$var$CheckOutlined);
var $b22ab34d306c7e4e$export$2e2bcd8739ae039 = $b22ab34d306c7e4e$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");


var $532bc1903b13fec2$var$RightOutlined = function RightOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $1c6445eeac3cccf5$export$2e2bcd8739ae039)
    }));
};
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ var $532bc1903b13fec2$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($532bc1903b13fec2$var$RightOutlined);
var $532bc1903b13fec2$export$2e2bcd8739ae039 = $532bc1903b13fec2$var$RefIcon;


const { Title: $fc259b96ee86e762$var$Title } = (0, $4e2a56a3190d5290$export$2e2bcd8739ae039);
function $fc259b96ee86e762$export$b94310965bed44e6() {
    const { newsList: newsList, projectStatistics: projectStatistics, plantedPlantsNamesWithId: plantedPlantsNamesWithId } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('home');
    const user = (0, $d433dc3c3e640619$export$3901076af3749fa9)();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const newsListNews = newsList?.filter((n)=>n.newsType === 'news') || [];
    const newsListTutorials = newsList?.filter((n)=>n.newsType === 'tutorials') || [];
    const { token: { controlHeightSM: controlHeightSM } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    if (!user) return null;
    const navigation = (0, $493cbc5b00d91baa$export$d0fd4b7106de2769)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "home-layout__content",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "home-layout__title home-layout__project-overview",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                        children: intl.formatMessage({
                            id: 'projectOverview'
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "home-top__title__buttons",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                className: "home-top__link",
                                to: "/projects",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    className: "home-top__button home-top__action-button",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3511e38a5bf0c930$export$2e2bcd8739ae039), {
                                            className: "home-top__button__icon-add-plant"
                                        }),
                                        intl.formatMessage({
                                            id: 'addPlant'
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                className: "home-top__link",
                                to: "/projects",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    className: "home-top__button home-top__action-button",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b22ab34d306c7e4e$export$2e2bcd8739ae039), {
                                            className: "home-top__button__icon-add-task"
                                        }),
                                        intl.formatMessage({
                                            id: 'addTask'
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                className: "home-top__link",
                                to: "/projects",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    className: "home-top__button",
                                    children: [
                                        intl.formatMessage({
                                            id: 'allProjects'
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $532bc1903b13fec2$export$2e2bcd8739ae039), {})
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "home-top",
                children: [
                    projectStatistics && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9d004cf64875b9d1$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1d18f8f472bfe471$export$328518dfd47a58e9), {
                            projectStatistics: projectStatistics,
                            plantedPlantsNamesWithId: plantedPlantsNamesWithId
                        })
                    }),
                    !projectStatistics && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "home-top__first-project-list",
                                children: [
                                    intl.formatMessage({
                                        id: 'createYourFirstProjectDescription1'
                                    }),
                                    intl.formatMessage({
                                        id: 'createYourFirstProjectDescription2'
                                    }),
                                    intl.formatMessage({
                                        id: 'createYourFirstProjectDescription4'
                                    })
                                ].map((text, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                        className: "planner__list__item",
                                        children: [
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($de8c74995637f2ce$exports)))
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                children: text
                                            })
                                        ]
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                className: "home-top__first-project-link",
                                to: "/projects/new",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    className: "home-top__first-project-button",
                                    children: intl.formatMessage({
                                        id: 'createFirstProject'
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "home-layout__materials",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "home-layout__title",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                                children: intl.formatMessage({
                                    id: 'usefulMaterials'
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                className: "home-top__link",
                                to: "/home/news",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    className: "home-top__button",
                                    children: [
                                        intl.formatMessage({
                                            id: 'allUsefulMaterials'
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $532bc1903b13fec2$export$2e2bcd8739ae039), {})
                                    ]
                                })
                            })
                        ]
                    }),
                    newsListTutorials.length != 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6daff296b3f07dd7$export$25b7c75712b6b29), {
                        newsList: newsListTutorials,
                        type: "tutorials"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "home-layout__news",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "home-layout__title",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                                children: intl.formatMessage({
                                    id: 'news'
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                className: "home-top__link",
                                to: "/home/news",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    className: "home-top__button",
                                    children: [
                                        intl.formatMessage({
                                            id: 'allNews'
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $532bc1903b13fec2$export$2e2bcd8739ae039), {})
                                    ]
                                })
                            })
                        ]
                    }),
                    newsListNews.length != 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6daff296b3f07dd7$export$25b7c75712b6b29), {
                        newsList: newsListNews,
                        type: "news"
                    })
                ]
            })
        ]
    });
}




var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $3cf76e1ffa693476$var$LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
var $3cf76e1ffa693476$export$2e2bcd8739ae039 = $3cf76e1ffa693476$var$LeftOutlined;



function $4fcbd32442f5797e$var$_extends() {
    $4fcbd32442f5797e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4fcbd32442f5797e$var$_extends.apply(this, arguments);
}
const $4fcbd32442f5797e$var$LeftOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $4fcbd32442f5797e$var$_extends({}, props, {
        ref: ref,
        icon: (0, $3cf76e1ffa693476$export$2e2bcd8739ae039)
    }));
/**![left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcyNCAyMTguM1YxNDFjMC02LjctNy43LTEwLjQtMTIuOS02LjNMMjYwLjMgNDg2LjhhMzEuODYgMzEuODYgMCAwMDAgNTAuM2w0NTAuOCAzNTIuMWM1LjMgNC4xIDEyLjkuNCAxMi45LTYuM3YtNzcuM2MwLTQuOS0yLjMtOS42LTYuMS0xMi42bC0zNjAtMjgxIDM2MC0yODEuMWMzLjgtMyA2LjEtNy43IDYuMS0xMi42eiIgLz48L3N2Zz4=) */ const $4fcbd32442f5797e$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($4fcbd32442f5797e$var$LeftOutlined);
var $4fcbd32442f5797e$export$2e2bcd8739ae039 = $4fcbd32442f5797e$var$RefIcon;







const $0f4dc13c42912ebb$var$isPrimitive = (value)=>typeof value !== 'object' && typeof value !== 'function' || value === null;
var $0f4dc13c42912ebb$export$2e2bcd8739ae039 = $0f4dc13c42912ebb$var$isPrimitive;




var $ltGt3 = parcelRequire("ltGt3");


"use client";
function $c64d2291d230fcde$export$29e2a8c3cdb34b03(Component) {
    return (props)=>/*#__PURE__*/ $ltGt3.createElement((0, $3f88559997256af7$export$2e2bcd8739ae039), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ $ltGt3.createElement(Component, {
            ...props
        }));
}
/* istanbul ignore next */ const $c64d2291d230fcde$var$genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls)=>{
    const PurePanel = (props)=>{
        const { prefixCls: customizePrefixCls, style: style } = props;
        const holderRef = $ltGt3.useRef(null);
        const [popupHeight, setPopupHeight] = $ltGt3.useState(0);
        const [popupWidth, setPopupWidth] = $ltGt3.useState(0);
        const [open, setOpen] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(false, props.open);
        const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
        const prefixCls = getPrefixCls(defaultPrefixCls || 'select', customizePrefixCls);
        $ltGt3.useEffect(()=>{
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== 'undefined') {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                const interval = setInterval(()=>{
                    const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
                    const popup = holderRef.current?.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return ()=>{
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, [
            prefixCls
        ]);
        let mergedProps = {
            ...props,
            style: {
                ...style,
                margin: 0
            },
            open: open,
            getPopupContainer: ()=>holderRef.current
        };
        if (postProps) mergedProps = postProps(mergedProps);
        if (alignPropName) Object.assign(mergedProps, {
            [alignPropName]: {
                overflow: {
                    adjustX: false,
                    adjustY: false
                }
            }
        });
        const mergedStyle = {
            paddingBottom: popupHeight,
            position: 'relative',
            minWidth: popupWidth
        };
        return /*#__PURE__*/ $ltGt3.createElement("div", {
            ref: holderRef,
            style: mergedStyle
        }, /*#__PURE__*/ $ltGt3.createElement(Component, {
            ...mergedProps
        }));
    };
    return $c64d2291d230fcde$export$29e2a8c3cdb34b03(PurePanel);
};
var $c64d2291d230fcde$export$2e2bcd8739ae039 = $c64d2291d230fcde$var$genPurePanel;








var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $7a04c2ce63979857$var$BarsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "bars",
    "theme": "outlined"
};
var $7a04c2ce63979857$export$2e2bcd8739ae039 = $7a04c2ce63979857$var$BarsOutlined;



function $4fd716325eafbf98$var$_extends() {
    $4fd716325eafbf98$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4fd716325eafbf98$var$_extends.apply(this, arguments);
}
const $4fd716325eafbf98$var$BarsOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $4fd716325eafbf98$var$_extends({}, props, {
        ref: ref,
        icon: (0, $7a04c2ce63979857$export$2e2bcd8739ae039)
    }));
/**![bars](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTJIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMTA0IDIyOGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHptMCAyODRhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */ const $4fd716325eafbf98$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($4fd716325eafbf98$var$BarsOutlined);
var $4fd716325eafbf98$export$2e2bcd8739ae039 = $4fd716325eafbf98$var$RefIcon;








var $ltGt3 = parcelRequire("ltGt3");
const $ff386455706ae565$export$964282a2c3979546 = /*#__PURE__*/ $ltGt3.createContext({
    siderHook: {
        addSider: ()=>null,
        removeSider: ()=>null
    }
});





const $c8620c9d5e4623c1$var$genLayoutStyle = (token)=>{
    const { antCls: antCls, componentCls: // .ant
    componentCls, colorText: // .ant-layout
    colorText, footerBg: footerBg, headerHeight: headerHeight, headerPadding: headerPadding, headerColor: headerColor, footerPadding: footerPadding, fontSize: fontSize, bodyBg: bodyBg, headerBg: headerBg } = token;
    return {
        [componentCls]: {
            display: 'flex',
            flex: 'auto',
            flexDirection: 'column',
            /* fix firefox can't set height smaller than content on flex item */ minHeight: 0,
            background: bodyBg,
            '&, *': {
                boxSizing: 'border-box'
            },
            [`&${componentCls}-has-sider`]: {
                flexDirection: 'row',
                [`> ${componentCls}, > ${componentCls}-content`]: {
                    // https://segmentfault.com/a/1190000019498300
                    width: 0
                }
            },
            [`${componentCls}-header, &${componentCls}-footer`]: {
                flex: '0 0 auto'
            },
            // RTL
            '&-rtl': {
                direction: 'rtl'
            }
        },
        // ==================== Header ====================
        [`${componentCls}-header`]: {
            height: headerHeight,
            padding: headerPadding,
            color: headerColor,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(headerHeight),
            background: headerBg,
            // Other components/menu/style/index.less line:686
            // Integration with header element so menu items have the same height
            [`${antCls}-menu`]: {
                lineHeight: 'inherit'
            }
        },
        // ==================== Footer ====================
        [`${componentCls}-footer`]: {
            padding: footerPadding,
            color: colorText,
            fontSize: fontSize,
            background: footerBg
        },
        // =================== Content ====================
        [`${componentCls}-content`]: {
            flex: 'auto',
            color: colorText,
            // fix firefox can't set height smaller than content on flex item
            minHeight: 0
        }
    };
};
const $c8620c9d5e4623c1$export$9ca1be8807fe0675 = (token)=>{
    const { colorBgLayout: colorBgLayout, controlHeight: controlHeight, controlHeightLG: controlHeightLG, colorText: colorText, controlHeightSM: controlHeightSM, marginXXS: marginXXS, colorTextLightSolid: colorTextLightSolid, colorBgContainer: colorBgContainer } = token;
    const paddingInline = controlHeightLG * 1.25;
    return {
        // Deprecated
        colorBgHeader: '#001529',
        colorBgBody: colorBgLayout,
        colorBgTrigger: '#002140',
        bodyBg: colorBgLayout,
        headerBg: '#001529',
        headerHeight: controlHeight * 2,
        headerPadding: `0 ${paddingInline}px`,
        headerColor: colorText,
        footerPadding: `${controlHeightSM}px ${paddingInline}px`,
        footerBg: colorBgLayout,
        siderBg: '#001529',
        triggerHeight: controlHeightLG + marginXXS * 2,
        triggerBg: '#002140',
        triggerColor: colorTextLightSolid,
        zeroTriggerWidth: controlHeightLG,
        zeroTriggerHeight: controlHeightLG,
        lightSiderBg: colorBgContainer,
        lightTriggerBg: colorBgContainer,
        lightTriggerColor: colorText
    };
};
const $c8620c9d5e4623c1$export$da0be9ab56e785fc = [
    [
        'colorBgBody',
        'bodyBg'
    ],
    [
        'colorBgHeader',
        'headerBg'
    ],
    [
        'colorBgTrigger',
        'triggerBg'
    ]
];
var $c8620c9d5e4623c1$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Layout', $c8620c9d5e4623c1$var$genLayoutStyle, $c8620c9d5e4623c1$export$9ca1be8807fe0675, {
    deprecatedTokens: $c8620c9d5e4623c1$export$da0be9ab56e785fc
});



const $a8c22834a05a73a5$var$genSiderStyle = (token)=>{
    const { componentCls: componentCls, siderBg: siderBg, motionDurationMid: motionDurationMid, motionDurationSlow: motionDurationSlow, antCls: antCls, triggerHeight: triggerHeight, triggerColor: triggerColor, triggerBg: triggerBg, headerHeight: headerHeight, zeroTriggerWidth: zeroTriggerWidth, zeroTriggerHeight: zeroTriggerHeight, borderRadiusLG: borderRadiusLG, lightSiderBg: lightSiderBg, lightTriggerColor: lightTriggerColor, lightTriggerBg: lightTriggerBg, bodyBg: bodyBg } = token;
    return {
        [componentCls]: {
            position: 'relative',
            // fix firefox can't set width smaller than content on flex item
            minWidth: 0,
            background: siderBg,
            transition: `all ${motionDurationMid}, background 0s`,
            '&-has-trigger': {
                paddingBottom: triggerHeight
            },
            '&-right': {
                order: 1
            },
            [`${componentCls}-children`]: {
                height: '100%',
                // Hack for fixing margin collapse bug
                // https://github.com/ant-design/ant-design/issues/7967
                // solution from https://stackoverflow.com/a/33132624/3040605
                marginTop: -0.1,
                paddingTop: 0.1,
                [`${antCls}-menu${antCls}-menu-inline-collapsed`]: {
                    width: 'auto'
                }
            },
            [`&-zero-width ${componentCls}-children`]: {
                overflow: 'hidden'
            },
            [`${componentCls}-trigger`]: {
                position: 'fixed',
                bottom: 0,
                zIndex: 1,
                height: triggerHeight,
                color: triggerColor,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(triggerHeight),
                textAlign: 'center',
                background: triggerBg,
                cursor: 'pointer',
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-zero-width-trigger`]: {
                position: 'absolute',
                top: headerHeight,
                insetInlineEnd: token.calc(zeroTriggerWidth).mul(-1).equal(),
                zIndex: 1,
                width: zeroTriggerWidth,
                height: zeroTriggerHeight,
                color: triggerColor,
                fontSize: token.fontSizeXL,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: siderBg,
                borderRadius: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(borderRadiusLG)} 0`,
                cursor: 'pointer',
                transition: `background ${motionDurationSlow} ease`,
                '&::after': {
                    position: 'absolute',
                    inset: 0,
                    background: 'transparent',
                    transition: `all ${motionDurationSlow}`,
                    content: '""'
                },
                '&:hover::after': {
                    background: `rgba(255, 255, 255, 0.2)`
                },
                '&-right': {
                    insetInlineStart: token.calc(zeroTriggerWidth).mul(-1).equal(),
                    borderRadius: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(borderRadiusLG)} 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(borderRadiusLG)}`
                }
            },
            // Light
            '&-light': {
                background: lightSiderBg,
                [`${componentCls}-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg
                },
                [`${componentCls}-zero-width-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg,
                    border: `1px solid ${bodyBg}`,
                    // Safe to modify to any other color
                    borderInlineStart: 0
                }
            }
        }
    };
};
var $a8c22834a05a73a5$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)([
    'Layout',
    'Sider'
], $a8c22834a05a73a5$var$genSiderStyle, (0, $c8620c9d5e4623c1$export$9ca1be8807fe0675), {
    deprecatedTokens: (0, $c8620c9d5e4623c1$export$da0be9ab56e785fc)
});


"use client";
const $945fab49c4f4b0f1$var$dimensionMaxMap = {
    xs: '479.98px',
    sm: '575.98px',
    md: '767.98px',
    lg: '991.98px',
    xl: '1199.98px',
    xxl: '1599.98px'
};
const $945fab49c4f4b0f1$var$isNumeric = (val)=>!Number.isNaN(Number.parseFloat(val)) && Number.isFinite(Number(val));
const $945fab49c4f4b0f1$export$63554aebd2a6d54c = /*#__PURE__*/ $ltGt3.createContext({});
const $945fab49c4f4b0f1$var$generateId = (()=>{
    let i = 0;
    return (prefix = '')=>{
        i += 1;
        return `${prefix}${i}`;
    };
})();
const $945fab49c4f4b0f1$var$Sider = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, trigger: trigger, children: children, defaultCollapsed: defaultCollapsed = false, theme: theme = 'dark', style: style = {}, collapsible: collapsible = false, reverseArrow: reverseArrow = false, width: width = 200, collapsedWidth: collapsedWidth = 80, zeroWidthTriggerStyle: zeroWidthTriggerStyle, breakpoint: breakpoint, onCollapse: onCollapse, onBreakpoint: onBreakpoint, ...otherProps } = props;
    const { siderHook: siderHook } = (0, $ltGt3.useContext)((0, $ff386455706ae565$export$964282a2c3979546));
    const [collapsed, setCollapsed] = (0, $ltGt3.useState)('collapsed' in props ? props.collapsed : defaultCollapsed);
    const [below, setBelow] = (0, $ltGt3.useState)(false);
    (0, $ltGt3.useEffect)(()=>{
        if ('collapsed' in props) setCollapsed(props.collapsed);
    }, [
        props.collapsed
    ]);
    const handleSetCollapsed = (value, type)=>{
        if (!('collapsed' in props)) setCollapsed(value);
        onCollapse?.(value, type);
    };
    // =========================== Prefix ===========================
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $a8c22834a05a73a5$export$2e2bcd8739ae039)(prefixCls);
    // ========================= Responsive =========================
    const responsiveHandlerRef = (0, $ltGt3.useRef)(null);
    responsiveHandlerRef.current = (mql)=>{
        setBelow(mql.matches);
        onBreakpoint?.(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, 'responsive');
    };
    (0, $ltGt3.useEffect)(()=>{
        function responsiveHandler(mql) {
            return responsiveHandlerRef.current?.(mql);
        }
        let mql;
        if (typeof window?.matchMedia !== 'undefined' && breakpoint && breakpoint in $945fab49c4f4b0f1$var$dimensionMaxMap) {
            mql = window.matchMedia(`screen and (max-width: ${$945fab49c4f4b0f1$var$dimensionMaxMap[breakpoint]})`);
            if (typeof mql?.addEventListener === 'function') mql.addEventListener('change', responsiveHandler);
            responsiveHandler(mql);
        }
        return ()=>{
            if (typeof mql?.removeEventListener === 'function') mql.removeEventListener('change', responsiveHandler);
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, $ltGt3.useEffect)(()=>{
        const uniqueId = $945fab49c4f4b0f1$var$generateId('ant-sider-');
        siderHook.addSider(uniqueId);
        return ()=>siderHook.removeSider(uniqueId);
    }, []);
    const toggle = ()=>{
        handleSetCollapsed(!collapsed, 'clickTrigger');
    };
    const divProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(otherProps, [
        'collapsed'
    ]);
    const rawWidth = collapsed ? collapsedWidth : width;
    // use "px" as fallback unit for width
    const siderWidth = $945fab49c4f4b0f1$var$isNumeric(rawWidth) ? `${rawWidth}px` : String(rawWidth);
    // special trigger when collapsedWidth == 0
    const zeroWidthTrigger = Number.parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ $ltGt3.createElement("span", {
        onClick: toggle,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-zero-width-trigger`, `${prefixCls}-zero-width-trigger-${reverseArrow ? 'right' : 'left'}`),
        style: zeroWidthTriggerStyle
    }, trigger || /*#__PURE__*/ $ltGt3.createElement((0, $4fd716325eafbf98$export$2e2bcd8739ae039), null)) : null;
    const reverseIcon = direction === 'rtl' === !reverseArrow;
    const iconObj = {
        expanded: reverseIcon ? /*#__PURE__*/ $ltGt3.createElement((0, $a9490449fe252e7b$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $4fcbd32442f5797e$export$2e2bcd8739ae039), null),
        collapsed: reverseIcon ? /*#__PURE__*/ $ltGt3.createElement((0, $4fcbd32442f5797e$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $a9490449fe252e7b$export$2e2bcd8739ae039), null)
    };
    const status = collapsed ? 'collapsed' : 'expanded';
    const defaultTrigger = iconObj[status];
    const triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-trigger`,
        onClick: toggle,
        style: {
            width: siderWidth
        }
    }, trigger || defaultTrigger) : null;
    const divStyle = {
        ...style,
        flex: `0 0 ${siderWidth}`,
        maxWidth: siderWidth,
        // Fix width transition bug in IE11
        minWidth: siderWidth,
        // https://github.com/ant-design/ant-design/issues/6349
        width: siderWidth
    };
    const siderCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${theme}`, {
        [`${prefixCls}-collapsed`]: !!collapsed,
        [`${prefixCls}-has-trigger`]: collapsible && trigger !== null && !zeroWidthTrigger,
        [`${prefixCls}-below`]: !!below,
        [`${prefixCls}-zero-width`]: Number.parseFloat(siderWidth) === 0
    }, className, hashId, cssVarCls);
    const contextValue = $ltGt3.useMemo(()=>({
            siderCollapsed: collapsed
        }), [
        collapsed
    ]);
    return /*#__PURE__*/ $ltGt3.createElement($945fab49c4f4b0f1$export$63554aebd2a6d54c.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $ltGt3.createElement("aside", {
        className: siderCls,
        ...divProps,
        style: divStyle,
        ref: ref
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-children`
    }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null));
});
var $945fab49c4f4b0f1$export$2e2bcd8739ae039 = $945fab49c4f4b0f1$var$Sider;



var $ltGt3 = parcelRequire("ltGt3");












var $ltGt3 = parcelRequire("ltGt3");
"use client";
const $4301eb43ed83536d$var$MenuContext = /*#__PURE__*/ (0, $ltGt3.createContext)({
    prefixCls: '',
    firstLevel: true,
    inlineCollapsed: false,
    styles: null,
    classNames: null
});
var $4301eb43ed83536d$export$2e2bcd8739ae039 = $4301eb43ed83536d$var$MenuContext;



var $ltGt3 = parcelRequire("ltGt3");



"use client";
const $73a9e8e7bffd86a4$var$MenuDivider = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, dashed: dashed, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('menu', customizePrefixCls);
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
        [`${prefixCls}-item-divider-dashed`]: !!dashed
    }, className);
    return /*#__PURE__*/ $ltGt3.createElement((0, $1982b9fe98a708c6$export$2e2bcd8739ae039), {
        className: classString,
        ...restProps
    });
};
var $73a9e8e7bffd86a4$export$2e2bcd8739ae039 = $73a9e8e7bffd86a4$var$MenuDivider;



var $ltGt3 = parcelRequire("ltGt3");







"use client";
const $7f11dd29a3bed229$var$MenuItem = (props)=>{
    const { className: className, children: children, icon: icon, title: title, danger: danger, extra: extra } = props;
    const { prefixCls: prefixCls, firstLevel: firstLevel, direction: direction, disableMenuItemTitleTooltip: disableMenuItemTitleTooltip, inlineCollapsed: isInlineCollapsed, styles: styles, classNames: classNames } = $ltGt3.useContext((0, $4301eb43ed83536d$export$2e2bcd8739ae039));
    const renderItemChildren = (inlineCollapsed)=>{
        const label = children?.[0];
        const wrapNode = /*#__PURE__*/ $ltGt3.createElement("span", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-title-content`, firstLevel ? classNames.itemContent : classNames.subMenu.itemContent, {
                [`${prefixCls}-title-content-with-extra`]: !!extra || extra === 0
            }),
            style: firstLevel ? styles.itemContent : styles.subMenu.itemContent
        }, children);
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        if (!icon || /*#__PURE__*/ $ltGt3.isValidElement(children) && children.type === 'span') {
            if (children && inlineCollapsed && firstLevel && typeof label === 'string') return /*#__PURE__*/ $ltGt3.createElement("div", {
                className: `${prefixCls}-inline-collapsed-noicon`
            }, label.charAt(0));
        }
        return wrapNode;
    };
    const { siderCollapsed: siderCollapsed } = $ltGt3.useContext((0, $945fab49c4f4b0f1$export$63554aebd2a6d54c));
    let tooltipTitle = title;
    if (typeof title === 'undefined') tooltipTitle = firstLevel ? children : '';
    else if (title === false) tooltipTitle = '';
    const tooltipProps = {
        title: tooltipTitle
    };
    if (!siderCollapsed && !isInlineCollapsed) {
        tooltipProps.title = null;
        // Reset `open` to fix control mode tooltip display not correct
        // ref: https://github.com/ant-design/ant-design/issues/16742
        tooltipProps.open = false;
    }
    const childrenLength = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children).length;
    let returnNode = /*#__PURE__*/ $ltGt3.createElement((0, $12413d0256c31ec0$export$2e2bcd8739ae039), {
        ...(0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(props, [
            'title',
            'icon',
            'danger'
        ]),
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(firstLevel ? classNames.item : classNames.subMenu.item, {
            [`${prefixCls}-item-danger`]: danger,
            [`${prefixCls}-item-only-child`]: (icon ? childrenLength + 1 : childrenLength) === 1
        }, className),
        style: firstLevel ? styles.item : styles.subMenu.item,
        title: typeof title === 'string' ? title : undefined
    }, (0, $66d38239e1a27993$export$e530037191fcd5d7)(icon, (oriProps)=>({
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(oriProps.className, `${prefixCls}-item-icon`, firstLevel ? classNames.itemIcon : classNames.subMenu.itemIcon),
            style: {
                ...oriProps.style,
                ...firstLevel ? styles.itemIcon : styles.subMenu.itemIcon
            }
        })), renderItemChildren(isInlineCollapsed));
    if (!disableMenuItemTitleTooltip) returnNode = /*#__PURE__*/ $ltGt3.createElement((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
        ...tooltipProps,
        placement: direction === 'rtl' ? 'left' : 'right',
        classNames: {
            root: `${prefixCls}-inline-collapsed-tooltip`
        }
    }, returnNode);
    return returnNode;
};
var $7f11dd29a3bed229$export$2e2bcd8739ae039 = $7f11dd29a3bed229$var$MenuItem;



var $ltGt3 = parcelRequire("ltGt3");


"use client";
const $0c0f4dfb7618b339$var$OverrideContext = /*#__PURE__*/ $ltGt3.createContext(null);
const $0c0f4dfb7618b339$export$9bd434816b0530d0 = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { children: children, ...restProps } = props;
    const override = $ltGt3.useContext($0c0f4dfb7618b339$var$OverrideContext);
    const context = $ltGt3.useMemo(()=>({
            ...override,
            ...restProps
        }), [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable,
        restProps.rootClassName
    ]);
    const canRef = (0, $22ff46e28c8066e1$export$b51ae67c7882a242)(children);
    const mergedRef = (0, $22ff46e28c8066e1$export$1d1c999670a1285d)(ref, canRef ? (0, $22ff46e28c8066e1$export$7465e5c0bf44f19a)(children) : null);
    return /*#__PURE__*/ $ltGt3.createElement($0c0f4dfb7618b339$var$OverrideContext.Provider, {
        value: context
    }, /*#__PURE__*/ $ltGt3.createElement((0, $31ba6c57c6d43aeb$export$2e2bcd8739ae039), {
        space: true
    }, canRef ? /*#__PURE__*/ $ltGt3.cloneElement(children, {
        ref: mergedRef
    }) : children));
});
var /** @internal Only used for Dropdown component. Do not use this in your production. */ $0c0f4dfb7618b339$export$2e2bcd8739ae039 = $0c0f4dfb7618b339$var$OverrideContext;








const $aea477580f67f097$var$getHorizontalStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, horizontalLineHeight: horizontalLineHeight, colorSplit: colorSplit, lineWidth: lineWidth, lineType: lineType, itemPaddingInline: itemPaddingInline } = token;
    return {
        [`${componentCls}-horizontal`]: {
            lineHeight: horizontalLineHeight,
            border: 0,
            borderBottom: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
            boxShadow: 'none',
            '&::after': {
                display: 'block',
                clear: 'both',
                height: 0,
                content: '"\\20"'
            },
            // ======================= Item =======================
            [`${componentCls}-item, ${componentCls}-submenu`]: {
                position: 'relative',
                display: 'inline-block',
                verticalAlign: 'bottom',
                paddingInline: itemPaddingInline
            },
            [`> ${componentCls}-item:hover,
        > ${componentCls}-item-active,
        > ${componentCls}-submenu ${componentCls}-submenu-title:hover`]: {
                backgroundColor: 'transparent'
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                transition: [
                    `border-color ${motionDurationSlow}`,
                    `background ${motionDurationSlow}`
                ].join(',')
            },
            // ===================== Sub Menu =====================
            [`${componentCls}-submenu-arrow`]: {
                display: 'none'
            }
        }
    };
};
var $aea477580f67f097$export$2e2bcd8739ae039 = $aea477580f67f097$var$getHorizontalStyle;



const $a733a93da0f5d5d1$var$getRTLStyle = ({ componentCls: componentCls, menuArrowOffset: menuArrowOffset, calc: calc })=>({
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        },
        [`${componentCls}-submenu-rtl`]: {
            transformOrigin: '100% 0'
        },
        // Vertical Arrow
        [`${componentCls}-rtl${componentCls}-vertical,
    ${componentCls}-submenu-rtl ${componentCls}-vertical`]: {
            [`${componentCls}-submenu-arrow`]: {
                '&::before': {
                    transform: `rotate(-45deg) translateY(${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(45deg) translateY(${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(menuArrowOffset)})`
                }
            }
        }
    });
var $a733a93da0f5d5d1$export$2e2bcd8739ae039 = $a733a93da0f5d5d1$var$getRTLStyle;




const $6421712cc3a4b64c$var$accessibilityFocus = (token)=>(0, $945cb0d2b7017a11$export$6539948f0a737e39)(token);
const $6421712cc3a4b64c$var$getThemeStyle = (token, themeSuffix)=>{
    const { componentCls: componentCls, itemColor: itemColor, itemSelectedColor: itemSelectedColor, subMenuItemSelectedColor: subMenuItemSelectedColor, groupTitleColor: groupTitleColor, itemBg: itemBg, subMenuItemBg: subMenuItemBg, itemSelectedBg: itemSelectedBg, activeBarHeight: activeBarHeight, activeBarWidth: activeBarWidth, activeBarBorderWidth: activeBarBorderWidth, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, itemPaddingInline: itemPaddingInline, motionDurationMid: motionDurationMid, itemHoverColor: itemHoverColor, lineType: lineType, colorSplit: colorSplit, itemDisabledColor: // Disabled
    itemDisabledColor, dangerItemColor: // Danger
    dangerItemColor, dangerItemHoverColor: dangerItemHoverColor, dangerItemSelectedColor: dangerItemSelectedColor, dangerItemActiveBg: dangerItemActiveBg, dangerItemSelectedBg: dangerItemSelectedBg, popupBg: // Bg
    popupBg, itemHoverBg: itemHoverBg, itemActiveBg: itemActiveBg, menuSubMenuBg: menuSubMenuBg, horizontalItemSelectedColor: // Horizontal
    horizontalItemSelectedColor, horizontalItemSelectedBg: horizontalItemSelectedBg, horizontalItemBorderRadius: horizontalItemBorderRadius, horizontalItemHoverBg: horizontalItemHoverBg } = token;
    return {
        [`${componentCls}-${themeSuffix}, ${componentCls}-${themeSuffix} > ${componentCls}`]: {
            color: itemColor,
            background: itemBg,
            [`&${componentCls}-root:focus-visible`]: {
                ...$6421712cc3a4b64c$var$accessibilityFocus(token)
            },
            // ======================== Item ========================
            [`${componentCls}-item`]: {
                '&-group-title, &-extra': {
                    color: groupTitleColor
                }
            },
            [`${componentCls}-submenu-selected > ${componentCls}-submenu-title`]: {
                color: subMenuItemSelectedColor
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                color: itemColor,
                [`&:not(${componentCls}-item-disabled):focus-visible`]: {
                    ...$6421712cc3a4b64c$var$accessibilityFocus(token)
                }
            },
            // Disabled
            [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
                color: `${itemDisabledColor} !important`
            },
            // Hover
            [`${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                [`&:hover, > ${componentCls}-submenu-title:hover`]: {
                    color: itemHoverColor
                }
            },
            [`&:not(${componentCls}-horizontal)`]: {
                [`${componentCls}-item:not(${componentCls}-item-selected)`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                },
                [`${componentCls}-submenu-title`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                }
            },
            // Danger - only Item has
            [`${componentCls}-item-danger`]: {
                color: dangerItemColor,
                [`&${componentCls}-item:hover`]: {
                    [`&:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                        color: dangerItemHoverColor
                    }
                },
                [`&${componentCls}-item:active`]: {
                    background: dangerItemActiveBg
                }
            },
            [`${componentCls}-item a`]: {
                '&, &:hover': {
                    color: 'inherit'
                }
            },
            [`${componentCls}-item-selected`]: {
                color: itemSelectedColor,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    color: dangerItemSelectedColor
                },
                'a, a:hover': {
                    color: 'inherit'
                }
            },
            [`& ${componentCls}-item-selected`]: {
                backgroundColor: itemSelectedBg,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    backgroundColor: dangerItemSelectedBg
                }
            },
            [`&${componentCls}-submenu > ${componentCls}`]: {
                backgroundColor: menuSubMenuBg
            },
            // ===== 设置浮层的颜色 =======
            // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
            [`&${componentCls}-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            [`&${componentCls}-submenu-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            // ===== 设置浮层的颜色 end =======
            // ====================== Horizontal ======================
            [`&${componentCls}-horizontal`]: {
                ...themeSuffix === 'dark' ? {
                    borderBottom: 0
                } : {},
                [`> ${componentCls}-item, > ${componentCls}-submenu`]: {
                    top: activeBarBorderWidth,
                    marginTop: token.calc(activeBarBorderWidth).mul(-1).equal(),
                    marginBottom: 0,
                    borderRadius: horizontalItemBorderRadius,
                    '&::after': {
                        position: 'absolute',
                        insetInline: itemPaddingInline,
                        bottom: 0,
                        borderBottom: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(activeBarHeight)} solid transparent`,
                        transition: `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        content: '""'
                    },
                    '&:hover, &-active, &-open': {
                        background: horizontalItemHoverBg,
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    },
                    '&-selected': {
                        color: horizontalItemSelectedColor,
                        backgroundColor: horizontalItemSelectedBg,
                        '&:hover': {
                            backgroundColor: horizontalItemSelectedBg
                        },
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    }
                }
            },
            // ================== Inline & Vertical ===================
            //
            [`&${componentCls}-root`]: {
                [`&${componentCls}-inline, &${componentCls}-vertical`]: {
                    borderInlineEnd: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(activeBarBorderWidth)} ${lineType} ${colorSplit}`
                }
            },
            // ======================== Inline ========================
            [`&${componentCls}-inline`]: {
                // Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    background: subMenuItemBg
                },
                [`${componentCls}-item`]: {
                    position: 'relative',
                    '&::after': {
                        position: 'absolute',
                        insetBlock: 0,
                        insetInlineEnd: 0,
                        borderInlineEnd: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(activeBarWidth)} solid ${itemSelectedColor}`,
                        transform: 'scaleY(0.0001)',
                        opacity: 0,
                        transition: [
                            `transform ${motionDurationMid} ${motionEaseOut}`,
                            `opacity ${motionDurationMid} ${motionEaseOut}`
                        ].join(','),
                        content: '""'
                    },
                    // Danger
                    [`&${componentCls}-item-danger`]: {
                        '&::after': {
                            borderInlineEndColor: dangerItemSelectedColor
                        }
                    }
                },
                [`${componentCls}-selected, ${componentCls}-item-selected`]: {
                    '&::after': {
                        transform: 'scaleY(1)',
                        opacity: 1,
                        transition: [
                            `transform ${motionDurationMid} ${motionEaseInOut}`,
                            `opacity ${motionDurationMid} ${motionEaseInOut}`
                        ].join(',')
                    }
                }
            }
        }
    };
};
var $6421712cc3a4b64c$export$2e2bcd8739ae039 = $6421712cc3a4b64c$var$getThemeStyle;




const $3132508a0aefd794$var$getVerticalInlineStyle = (token)=>{
    const { componentCls: componentCls, itemHeight: itemHeight, itemMarginInline: itemMarginInline, padding: padding, menuArrowSize: menuArrowSize, marginXS: marginXS, itemMarginBlock: itemMarginBlock, itemWidth: itemWidth, itemPaddingInline: itemPaddingInline } = token;
    const paddingWithArrow = token.calc(menuArrowSize).add(padding).add(marginXS).equal();
    return {
        [`${componentCls}-item`]: {
            position: 'relative',
            overflow: 'hidden'
        },
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(itemHeight),
            paddingInline: itemPaddingInline,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            marginInline: itemMarginInline,
            marginBlock: itemMarginBlock,
            width: itemWidth
        },
        [`> ${componentCls}-item,
            > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(itemHeight)
        },
        [`${componentCls}-item-group-list ${componentCls}-submenu-title,
            ${componentCls}-submenu-title`]: {
            paddingInlineEnd: paddingWithArrow
        }
    };
};
const $3132508a0aefd794$var$getVerticalStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, itemHeight: itemHeight, colorTextLightSolid: colorTextLightSolid, dropdownWidth: dropdownWidth, controlHeightLG: controlHeightLG, motionEaseOut: motionEaseOut, paddingXL: paddingXL, itemMarginInline: itemMarginInline, fontSizeLG: fontSizeLG, motionDurationFast: motionDurationFast, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, boxShadowSecondary: boxShadowSecondary, collapsedWidth: collapsedWidth, collapsedIconSize: collapsedIconSize } = token;
    const inlineItemStyle = {
        height: itemHeight,
        lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(itemHeight),
        listStylePosition: 'inside',
        listStyleType: 'disc'
    };
    return [
        {
            [componentCls]: {
                '&-inline, &-vertical': {
                    [`&${componentCls}-root`]: {
                        boxShadow: 'none'
                    },
                    ...$3132508a0aefd794$var$getVerticalInlineStyle(token)
                }
            },
            [`${componentCls}-submenu-popup`]: {
                [`${componentCls}-vertical`]: {
                    ...$3132508a0aefd794$var$getVerticalInlineStyle(token),
                    boxShadow: boxShadowSecondary
                }
            }
        },
        // Vertical only
        {
            [`${componentCls}-submenu-popup ${componentCls}-vertical${componentCls}-sub`]: {
                minWidth: dropdownWidth,
                maxHeight: `calc(100vh - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(controlHeightLG).mul(2.5).equal())})`,
                padding: '0',
                overflow: 'hidden',
                borderInlineEnd: 0,
                // https://github.com/ant-design/ant-design/issues/22244
                // https://github.com/ant-design/ant-design/issues/26812
                "&:not([class*='-active'])": {
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }
            }
        },
        // Inline Only
        {
            [`${componentCls}-inline`]: {
                width: '100%',
                // Motion enhance for first level
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                        display: 'flex',
                        alignItems: 'center',
                        transition: [
                            `border-color ${motionDurationSlow}`,
                            `background ${motionDurationSlow}`,
                            `padding ${motionDurationFast} ${motionEaseOut}`
                        ].join(','),
                        [`> ${componentCls}-title-content`]: {
                            flex: 'auto',
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        '> *': {
                            flex: 'none'
                        }
                    }
                },
                // >>>>> Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    padding: 0,
                    border: 0,
                    borderRadius: 0,
                    boxShadow: 'none',
                    [`& > ${componentCls}-submenu > ${componentCls}-submenu-title`]: inlineItemStyle,
                    [`& ${componentCls}-item-group-title`]: {
                        paddingInlineStart: paddingXL
                    }
                },
                // >>>>> Item
                [`${componentCls}-item`]: inlineItemStyle
            }
        },
        // Inline Collapse Only
        {
            [`${componentCls}-inline-collapsed`]: {
                width: collapsedWidth,
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu ${componentCls}-submenu-title`]: {
                        [`> ${componentCls}-inline-collapsed-noicon`]: {
                            fontSize: fontSizeLG,
                            textAlign: 'center'
                        }
                    }
                },
                [`> ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-submenu > ${componentCls}-submenu-title,
          > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                    insetInlineStart: 0,
                    paddingInline: `calc(50% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(collapsedIconSize).div(2).equal())} - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(itemMarginInline)})`,
                    textOverflow: 'clip',
                    [`
            ${componentCls}-submenu-arrow,
            ${componentCls}-submenu-expand-icon
          `]: {
                        opacity: 0
                    },
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        margin: 0,
                        fontSize: collapsedIconSize,
                        lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(itemHeight),
                        '+ span': {
                            display: 'inline-block',
                            opacity: 0
                        }
                    }
                },
                [`${componentCls}-item-icon, ${iconCls}`]: {
                    display: 'inline-block'
                },
                '&-tooltip': {
                    pointerEvents: 'none',
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        display: 'none'
                    },
                    'a, a:hover': {
                        color: colorTextLightSolid
                    }
                },
                [`${componentCls}-item-group-title`]: {
                    ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
                    paddingInline: paddingXS
                }
            }
        }
    ];
};
var $3132508a0aefd794$export$2e2bcd8739ae039 = $3132508a0aefd794$var$getVerticalStyle;


const $09627815423cc890$var$genMenuItemStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, iconCls: iconCls, iconSize: iconSize, iconMarginInlineEnd: iconMarginInlineEnd } = token;
    return {
        // >>>>> Item
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            position: 'relative',
            display: 'block',
            margin: 0,
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            transition: [
                `border-color ${motionDurationSlow}`,
                `background ${motionDurationSlow}`,
                `padding calc(${motionDurationSlow} + 0.1s) ${motionEaseInOut}`
            ].join(','),
            [`${componentCls}-item-icon, ${iconCls}`]: {
                minWidth: iconSize,
                fontSize: iconSize,
                transition: [
                    `font-size ${motionDurationMid} ${motionEaseOut}`,
                    `margin ${motionDurationSlow} ${motionEaseInOut}`,
                    `color ${motionDurationSlow}`
                ].join(','),
                '+ span': {
                    marginInlineStart: iconMarginInlineEnd,
                    opacity: 1,
                    transition: [
                        `opacity ${motionDurationSlow} ${motionEaseInOut}`,
                        `margin ${motionDurationSlow}`,
                        `color ${motionDurationSlow}`
                    ].join(',')
                }
            },
            [`${componentCls}-item-icon`]: {
                ...(0, $945cb0d2b7017a11$export$171ccda7bc085e59)()
            },
            [`&${componentCls}-item-only-child`]: {
                [`> ${iconCls}, > ${componentCls}-item-icon`]: {
                    marginInlineEnd: 0
                }
            }
        },
        // Disabled state sets text to gray and nukes hover/tab effects
        [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
            background: 'none !important',
            cursor: 'not-allowed',
            '&::after': {
                borderColor: 'transparent !important'
            },
            a: {
                color: 'inherit !important',
                cursor: 'not-allowed',
                pointerEvents: 'none'
            },
            [`> ${componentCls}-submenu-title`]: {
                color: 'inherit !important',
                cursor: 'not-allowed'
            }
        }
    };
};
const $09627815423cc890$var$genSubMenuArrowStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, borderRadius: borderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset } = token;
    return {
        [`${componentCls}-submenu`]: {
            '&-expand-icon, &-arrow': {
                position: 'absolute',
                top: '50%',
                insetInlineEnd: token.margin,
                width: menuArrowSize,
                color: 'currentcolor',
                transform: 'translateY(-50%)',
                transition: `transform ${motionDurationSlow} ${motionEaseInOut}, opacity ${motionDurationSlow}`
            },
            '&-arrow': {
                // →
                '&::before, &::after': {
                    position: 'absolute',
                    width: token.calc(menuArrowSize).mul(0.6).equal(),
                    height: token.calc(menuArrowSize).mul(0.15).equal(),
                    backgroundColor: 'currentcolor',
                    borderRadius: borderRadius,
                    transition: [
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `transform ${motionDurationSlow} ${motionEaseInOut}`,
                        `top ${motionDurationSlow} ${motionEaseInOut}`,
                        `color ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(','),
                    content: '""'
                },
                '&::before': {
                    transform: `rotate(45deg) translateY(${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(-45deg) translateY(${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(menuArrowOffset)})`
                }
            }
        }
    };
};
// =============================== Base ===============================
const $09627815423cc890$var$getBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, fontSize: fontSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, paddingXS: paddingXS, padding: padding, colorSplit: colorSplit, lineWidth: lineWidth, zIndexPopup: zIndexPopup, borderRadiusLG: borderRadiusLG, subMenuItemBorderRadius: subMenuItemBorderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset, lineType: lineType, groupTitleLineHeight: groupTitleLineHeight, groupTitleFontSize: groupTitleFontSize } = token;
    return [
        // Misc
        {
            '': {
                [componentCls]: {
                    ...(0, $945cb0d2b7017a11$export$8c467e8859fdef13)(),
                    // Hidden
                    '&-hidden': {
                        display: 'none'
                    }
                }
            },
            [`${componentCls}-submenu-hidden`]: {
                display: 'none'
            }
        },
        {
            [componentCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                ...(0, $945cb0d2b7017a11$export$8c467e8859fdef13)(),
                marginBottom: 0,
                paddingInlineStart: 0,
                fontSize: // Override default ul/ol
                fontSize,
                lineHeight: 0,
                // Fix display inline-block gap
                listStyle: 'none',
                outline: 'none',
                // Magic cubic here but smooth transition
                transition: `width ${motionDurationSlow} cubic-bezier(0.2, 0, 0, 1) 0s`,
                'ul, ol': {
                    margin: 0,
                    padding: 0,
                    listStyle: 'none'
                },
                // Overflow ellipsis
                '&-overflow': {
                    display: 'flex',
                    [`${componentCls}-item`]: {
                        flex: 'none'
                    }
                },
                [`${componentCls}-item, ${componentCls}-submenu, ${componentCls}-submenu-title`]: {
                    borderRadius: token.itemBorderRadius
                },
                [`${componentCls}-item-group-title`]: {
                    padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(padding)}`,
                    fontSize: groupTitleFontSize,
                    lineHeight: groupTitleLineHeight,
                    transition: `all ${motionDurationSlow}`
                },
                [`&-horizontal ${componentCls}-submenu`]: {
                    transition: [
                        `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        `background ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-submenu, ${componentCls}-submenu-inline`]: {
                    transition: [
                        `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `padding ${motionDurationMid} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-submenu ${componentCls}-sub`]: {
                    cursor: 'initial',
                    transition: [
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `padding ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-title-content`]: {
                    transition: `color ${motionDurationSlow}`,
                    '&-with-extra': {
                        display: 'inline-flex',
                        alignItems: 'center',
                        width: '100%'
                    },
                    // https://github.com/ant-design/ant-design/issues/41143
                    [`> ${antCls}-typography-ellipsis-single-line`]: {
                        display: 'inline',
                        verticalAlign: 'unset'
                    },
                    [`${componentCls}-item-extra`]: {
                        marginInlineStart: 'auto',
                        paddingInlineStart: token.padding
                    }
                },
                [`${componentCls}-item a`]: {
                    '&::before': {
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: 'transparent',
                        content: '""'
                    }
                },
                // Removed a Badge related style seems it's safe
                // https://github.com/ant-design/ant-design/issues/19809
                // >>>>> Divider
                [`${componentCls}-item-divider`]: {
                    overflow: 'hidden',
                    lineHeight: 0,
                    borderColor: colorSplit,
                    borderStyle: lineType,
                    borderWidth: 0,
                    borderTopWidth: lineWidth,
                    marginBlock: lineWidth,
                    padding: 0,
                    '&-dashed': {
                        borderStyle: 'dashed'
                    }
                },
                // Item
                ...$09627815423cc890$var$genMenuItemStyle(token),
                [`${componentCls}-item-group`]: {
                    [`${componentCls}-item-group-list`]: {
                        margin: 0,
                        padding: 0,
                        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                            paddingInline: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(fontSize).mul(2).equal())} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(padding)}`
                        }
                    }
                },
                // ======================= Sub Menu =======================
                '&-submenu': {
                    '&-popup': {
                        position: 'absolute',
                        zIndex: zIndexPopup,
                        borderRadius: borderRadiusLG,
                        boxShadow: 'none',
                        transformOrigin: '0 0',
                        [`&${componentCls}-submenu`]: {
                            background: 'transparent'
                        },
                        // https://github.com/ant-design/ant-design/issues/13955
                        '&::before': {
                            position: 'absolute',
                            inset: 0,
                            zIndex: -1,
                            width: '100%',
                            height: '100%',
                            opacity: 0,
                            content: '""'
                        },
                        [`> ${componentCls}`]: {
                            borderRadius: borderRadiusLG,
                            ...$09627815423cc890$var$genMenuItemStyle(token),
                            ...$09627815423cc890$var$genSubMenuArrowStyle(token),
                            [`${componentCls}-item, ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                                borderRadius: subMenuItemBorderRadius
                            },
                            [`${componentCls}-submenu-title::after`]: {
                                transition: `transform ${motionDurationSlow} ${motionEaseInOut}`
                            }
                        }
                    },
                    [`
          &-placement-leftTop,
          &-placement-bottomRight,
          `]: {
                        transformOrigin: '100% 0'
                    },
                    [`
          &-placement-leftBottom,
          &-placement-topRight,
          `]: {
                        transformOrigin: '100% 100%'
                    },
                    [`
          &-placement-rightBottom,
          &-placement-topLeft,
          `]: {
                        transformOrigin: '0 100%'
                    },
                    [`
          &-placement-bottomLeft,
          &-placement-rightTop,
          `]: {
                        transformOrigin: '0 0'
                    },
                    [`
          &-placement-leftTop,
          &-placement-leftBottom
          `]: {
                        paddingInlineEnd: token.paddingXS
                    },
                    [`
          &-placement-rightTop,
          &-placement-rightBottom
          `]: {
                        paddingInlineStart: token.paddingXS
                    },
                    [`
          &-placement-topRight,
          &-placement-topLeft
          `]: {
                        paddingBottom: token.paddingXS
                    },
                    [`
          &-placement-bottomRight,
          &-placement-bottomLeft
          `]: {
                        paddingTop: token.paddingXS
                    }
                },
                ...$09627815423cc890$var$genSubMenuArrowStyle(token),
                [`&-inline-collapsed ${componentCls}-submenu-arrow,
        &-inline ${componentCls}-submenu-arrow`]: {
                    // ↓
                    '&::before': {
                        transform: `rotate(-45deg) translateX(${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(menuArrowOffset)})`
                    },
                    '&::after': {
                        transform: `rotate(45deg) translateX(${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    }
                },
                [`${componentCls}-submenu-open${componentCls}-submenu-inline > ${componentCls}-submenu-title > ${componentCls}-submenu-arrow`]: {
                    // ↑
                    transform: `translateY(${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(menuArrowSize).mul(0.2).mul(-1).equal())})`,
                    '&::after': {
                        transform: `rotate(-45deg) translateX(${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    },
                    '&::before': {
                        transform: `rotate(45deg) translateX(${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(menuArrowOffset)})`
                    }
                }
            }
        },
        // Integration with header element so menu items have the same height
        {
            [`${antCls}-layout-header`]: {
                [componentCls]: {
                    lineHeight: 'inherit'
                }
            }
        }
    ];
};
const $09627815423cc890$export$9ca1be8807fe0675 = (token)=>{
    const { colorPrimary: colorPrimary, colorError: colorError, colorTextDisabled: colorTextDisabled, colorErrorBg: colorErrorBg, colorText: colorText, colorTextDescription: colorTextDescription, colorBgContainer: colorBgContainer, colorFillAlter: colorFillAlter, colorFillContent: colorFillContent, lineWidth: lineWidth, lineWidthBold: lineWidthBold, controlItemBgActive: controlItemBgActive, colorBgTextHover: colorBgTextHover, controlHeightLG: controlHeightLG, lineHeight: lineHeight, colorBgElevated: colorBgElevated, marginXXS: marginXXS, padding: padding, fontSize: fontSize, controlHeightSM: controlHeightSM, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, colorErrorHover: colorErrorHover } = token;
    const activeBarWidth = token.activeBarWidth ?? 0;
    const activeBarBorderWidth = token.activeBarBorderWidth ?? lineWidth;
    const itemMarginInline = token.itemMarginInline ?? token.marginXXS;
    const colorTextDark = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(colorTextLightSolid).setA(0.65).toRgbString();
    return {
        dropdownWidth: 160,
        zIndexPopup: token.zIndexPopupBase + 50,
        radiusItem: token.borderRadiusLG,
        itemBorderRadius: token.borderRadiusLG,
        radiusSubMenuItem: token.borderRadiusSM,
        subMenuItemBorderRadius: token.borderRadiusSM,
        colorItemText: colorText,
        itemColor: colorText,
        colorItemTextHover: colorText,
        itemHoverColor: colorText,
        colorItemTextHoverHorizontal: colorPrimary,
        horizontalItemHoverColor: colorPrimary,
        colorGroupTitle: colorTextDescription,
        groupTitleColor: colorTextDescription,
        colorItemTextSelected: colorPrimary,
        itemSelectedColor: colorPrimary,
        subMenuItemSelectedColor: colorPrimary,
        colorItemTextSelectedHorizontal: colorPrimary,
        horizontalItemSelectedColor: colorPrimary,
        colorItemBg: colorBgContainer,
        itemBg: colorBgContainer,
        colorItemBgHover: colorBgTextHover,
        itemHoverBg: colorBgTextHover,
        colorItemBgActive: colorFillContent,
        itemActiveBg: controlItemBgActive,
        colorSubItemBg: colorFillAlter,
        subMenuItemBg: colorFillAlter,
        colorItemBgSelected: controlItemBgActive,
        itemSelectedBg: controlItemBgActive,
        colorItemBgSelectedHorizontal: 'transparent',
        horizontalItemSelectedBg: 'transparent',
        colorActiveBarWidth: 0,
        activeBarWidth: activeBarWidth,
        colorActiveBarHeight: lineWidthBold,
        activeBarHeight: lineWidthBold,
        colorActiveBarBorderSize: lineWidth,
        activeBarBorderWidth: activeBarBorderWidth,
        // Disabled
        colorItemTextDisabled: colorTextDisabled,
        itemDisabledColor: colorTextDisabled,
        // Danger
        colorDangerItemText: colorError,
        dangerItemColor: colorError,
        colorDangerItemTextHover: colorError,
        dangerItemHoverColor: colorError,
        colorDangerItemTextSelected: colorError,
        dangerItemSelectedColor: colorError,
        colorDangerItemBgActive: colorErrorBg,
        dangerItemActiveBg: colorErrorBg,
        colorDangerItemBgSelected: colorErrorBg,
        dangerItemSelectedBg: colorErrorBg,
        itemMarginInline: itemMarginInline,
        horizontalItemBorderRadius: 0,
        horizontalItemHoverBg: 'transparent',
        itemHeight: controlHeightLG,
        groupTitleLineHeight: lineHeight,
        collapsedWidth: controlHeightLG * 2,
        popupBg: colorBgElevated,
        itemMarginBlock: marginXXS,
        itemPaddingInline: padding,
        horizontalLineHeight: `${controlHeightLG * 1.15}px`,
        iconSize: fontSize,
        iconMarginInlineEnd: controlHeightSM - fontSize,
        collapsedIconSize: fontSizeLG,
        groupTitleFontSize: fontSize,
        // Disabled
        darkItemDisabledColor: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(colorTextLightSolid).setA(0.25).toRgbString(),
        // Dark
        darkItemColor: colorTextDark,
        darkDangerItemColor: colorError,
        darkItemBg: '#001529',
        darkPopupBg: '#001529',
        darkSubMenuItemBg: '#000c17',
        darkItemSelectedColor: colorTextLightSolid,
        darkItemSelectedBg: colorPrimary,
        darkDangerItemSelectedBg: colorError,
        darkItemHoverBg: 'transparent',
        darkGroupTitleColor: colorTextDark,
        darkItemHoverColor: colorTextLightSolid,
        darkDangerItemHoverColor: colorErrorHover,
        darkDangerItemSelectedColor: colorTextLightSolid,
        darkDangerItemActiveBg: colorError,
        // internal
        itemWidth: activeBarWidth ? `calc(100% + ${activeBarBorderWidth}px)` : `calc(100% - ${itemMarginInline * 2}px)`
    };
};
var // ============================== Export ==============================
$09627815423cc890$export$2e2bcd8739ae039 = (prefixCls, rootCls = prefixCls, injectStyle = true)=>{
    const useStyle = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Menu', (token)=>{
        const { colorBgElevated: colorBgElevated, controlHeightLG: controlHeightLG, fontSize: fontSize, darkItemColor: darkItemColor, darkDangerItemColor: darkDangerItemColor, darkItemBg: darkItemBg, darkSubMenuItemBg: darkSubMenuItemBg, darkItemSelectedColor: darkItemSelectedColor, darkItemSelectedBg: darkItemSelectedBg, darkDangerItemSelectedBg: darkDangerItemSelectedBg, darkItemHoverBg: darkItemHoverBg, darkGroupTitleColor: darkGroupTitleColor, darkItemHoverColor: darkItemHoverColor, darkItemDisabledColor: darkItemDisabledColor, darkDangerItemHoverColor: darkDangerItemHoverColor, darkDangerItemSelectedColor: darkDangerItemSelectedColor, darkDangerItemActiveBg: darkDangerItemActiveBg, popupBg: popupBg, darkPopupBg: darkPopupBg } = token;
        const menuArrowSize = token.calc(fontSize).div(7).mul(5).equal();
        // Menu Token
        const menuToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
            menuArrowSize: menuArrowSize,
            menuHorizontalHeight: token.calc(controlHeightLG).mul(1.15).equal(),
            menuArrowOffset: token.calc(menuArrowSize).mul(0.25).equal(),
            menuSubMenuBg: colorBgElevated,
            calc: token.calc,
            popupBg: popupBg
        });
        const menuDarkToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(menuToken, {
            itemColor: darkItemColor,
            itemHoverColor: darkItemHoverColor,
            groupTitleColor: darkGroupTitleColor,
            itemSelectedColor: darkItemSelectedColor,
            subMenuItemSelectedColor: darkItemSelectedColor,
            itemBg: darkItemBg,
            popupBg: darkPopupBg,
            subMenuItemBg: darkSubMenuItemBg,
            itemActiveBg: 'transparent',
            itemSelectedBg: darkItemSelectedBg,
            activeBarHeight: 0,
            activeBarBorderWidth: 0,
            itemHoverBg: darkItemHoverBg,
            // Disabled
            itemDisabledColor: darkItemDisabledColor,
            // Danger
            dangerItemColor: darkDangerItemColor,
            dangerItemHoverColor: darkDangerItemHoverColor,
            dangerItemSelectedColor: darkDangerItemSelectedColor,
            dangerItemActiveBg: darkDangerItemActiveBg,
            dangerItemSelectedBg: darkDangerItemSelectedBg,
            menuSubMenuBg: darkSubMenuItemBg,
            // Horizontal
            horizontalItemSelectedColor: darkItemSelectedColor,
            horizontalItemSelectedBg: darkItemSelectedBg
        });
        return [
            // Basic
            $09627815423cc890$var$getBaseStyle(menuToken),
            // Horizontal
            (0, $aea477580f67f097$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Vertical
            (0, $3132508a0aefd794$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Theme
            (0, $6421712cc3a4b64c$export$2e2bcd8739ae039)(menuToken, 'light'),
            (0, $6421712cc3a4b64c$export$2e2bcd8739ae039)(menuDarkToken, 'dark'),
            // RTL
            (0, $a733a93da0f5d5d1$export$2e2bcd8739ae039)(menuToken),
            // Motion
            (0, $5a999cf2ba92548d$export$2e2bcd8739ae039)(menuToken),
            (0, $e613b8e902d5a10c$export$9018e60daecf7a6c)(menuToken, 'slide-up'),
            (0, $e613b8e902d5a10c$export$9018e60daecf7a6c)(menuToken, 'slide-down'),
            (0, $29a43b27eddd598a$export$f5d123412490d9dc)(menuToken, 'zoom-big')
        ];
    }, $09627815423cc890$export$9ca1be8807fe0675, {
        deprecatedTokens: [
            [
                'colorGroupTitle',
                'groupTitleColor'
            ],
            [
                'radiusItem',
                'itemBorderRadius'
            ],
            [
                'radiusSubMenuItem',
                'subMenuItemBorderRadius'
            ],
            [
                'colorItemText',
                'itemColor'
            ],
            [
                'colorItemTextHover',
                'itemHoverColor'
            ],
            [
                'colorItemTextHoverHorizontal',
                'horizontalItemHoverColor'
            ],
            [
                'colorItemTextSelected',
                'itemSelectedColor'
            ],
            [
                'colorItemTextSelectedHorizontal',
                'horizontalItemSelectedColor'
            ],
            [
                'colorItemTextDisabled',
                'itemDisabledColor'
            ],
            [
                'colorDangerItemText',
                'dangerItemColor'
            ],
            [
                'colorDangerItemTextHover',
                'dangerItemHoverColor'
            ],
            [
                'colorDangerItemTextSelected',
                'dangerItemSelectedColor'
            ],
            [
                'colorDangerItemBgActive',
                'dangerItemActiveBg'
            ],
            [
                'colorDangerItemBgSelected',
                'dangerItemSelectedBg'
            ],
            [
                'colorItemBg',
                'itemBg'
            ],
            [
                'colorItemBgHover',
                'itemHoverBg'
            ],
            [
                'colorSubItemBg',
                'subMenuItemBg'
            ],
            [
                'colorItemBgActive',
                'itemActiveBg'
            ],
            [
                'colorItemBgSelectedHorizontal',
                'horizontalItemSelectedBg'
            ],
            [
                'colorActiveBarWidth',
                'activeBarWidth'
            ],
            [
                'colorActiveBarHeight',
                'activeBarHeight'
            ],
            [
                'colorActiveBarBorderSize',
                'activeBarBorderWidth'
            ],
            [
                'colorItemBgSelected',
                'itemSelectedBg'
            ]
        ],
        injectStyle: // Dropdown will handle menu style self. We do not need to handle this.
        injectStyle,
        unitless: {
            groupTitleLineHeight: true
        }
    });
    return useStyle(prefixCls, rootCls);
};



var $ltGt3 = parcelRequire("ltGt3");






"use client";
const $0314e4583d0eca80$var$SubMenu = (props)=>{
    const { popupClassName: popupClassName, icon: icon, title: title, theme: customTheme } = props;
    const context = $ltGt3.useContext((0, $4301eb43ed83536d$export$2e2bcd8739ae039));
    const { prefixCls: prefixCls, inlineCollapsed: inlineCollapsed, theme: contextTheme, classNames: classNames, styles: styles } = context;
    const parentPath = (0, $c620ec0876f76e52$export$d3d2d0a05677870a)();
    let titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === 'string' ? /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-inline-collapsed-noicon`
    }, title.charAt(0)) : /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-title-content`
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        const titleIsSpan = /*#__PURE__*/ $ltGt3.isValidElement(title) && title.type === 'span';
        titleNode = /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, (0, $66d38239e1a27993$export$e530037191fcd5d7)(icon, (oriProps)=>({
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(oriProps.className, `${prefixCls}-item-icon`, classNames.itemIcon),
                style: {
                    ...oriProps.style,
                    ...styles.itemIcon
                }
            })), titleIsSpan ? title : /*#__PURE__*/ $ltGt3.createElement("span", {
            className: `${prefixCls}-title-content`
        }, title));
    }
    const contextValue = $ltGt3.useMemo(()=>({
            ...context,
            firstLevel: false
        }), [
        context
    ]);
    // ============================ zIndex ============================
    const [zIndex] = (0, $ad5b6b465efa8f67$export$3e7906d4075187a4)('Menu');
    return /*#__PURE__*/ $ltGt3.createElement((0, $4301eb43ed83536d$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $ltGt3.createElement((0, $89eb96ac34878e76$export$2e2bcd8739ae039), {
        ...(0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(props, [
            'icon'
        ]),
        title: titleNode,
        classNames: {
            list: classNames.subMenu.list,
            listTitle: classNames.subMenu.itemTitle
        },
        styles: {
            list: styles.subMenu.list,
            listTitle: styles.subMenu.itemTitle
        },
        popupClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, popupClassName, classNames.popup.root, `${prefixCls}-${customTheme || contextTheme}`),
        popupStyle: {
            zIndex: zIndex,
            // fix: https://github.com/ant-design/ant-design/issues/47826#issuecomment-2360737237
            ...props.popupStyle,
            ...styles.popup.root
        }
    }));
};
var $0314e4583d0eca80$export$2e2bcd8739ae039 = $0314e4583d0eca80$var$SubMenu;


"use client";
function $e621418180f953a0$var$isEmptyIcon(icon) {
    return icon === null || icon === false;
}
const $e621418180f953a0$var$MENU_COMPONENTS = {
    item: (0, $7f11dd29a3bed229$export$2e2bcd8739ae039),
    submenu: (0, $0314e4583d0eca80$export$2e2bcd8739ae039),
    divider: (0, $73a9e8e7bffd86a4$export$2e2bcd8739ae039)
};
const $e621418180f953a0$var$InternalMenu = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
    const override = $ltGt3.useContext((0, $0c0f4dfb7618b339$export$2e2bcd8739ae039));
    const overrideObj = override || {};
    const { prefixCls: customizePrefixCls, className: className, style: style, theme: theme = 'light', expandIcon: expandIcon, _internalDisableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip, inlineCollapsed: inlineCollapsed, siderCollapsed: siderCollapsed, rootClassName: rootClassName, mode: mode, selectable: selectable, onClick: onClick, overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName, classNames: classNames, styles: styles, ...restProps } = props;
    const { menu: menu } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('menu');
    const rootPrefixCls = getPrefixCls();
    const passedProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(restProps, [
        'collapsedWidth'
    ]);
    overrideObj.validator?.({
        mode: mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    const onItemClick = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((...args)=>{
        onClick?.(...args);
        overrideObj.onClick?.();
    });
    // ========================== Mode ===========================
    const mergedMode = overrideObj.mode || mode;
    // ======================= Selectable ========================
    const mergedSelectable = selectable ?? overrideObj.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    const mergedInlineCollapsed = inlineCollapsed ?? siderCollapsed;
    // ================ Merged Props for Semantic ================
    const mergedProps = {
        ...props,
        mode: mergedMode,
        inlineCollapsed: mergedInlineCollapsed,
        selectable: mergedSelectable,
        theme: theme
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        },
        subMenu: {
            _default: 'item'
        }
    });
    const defaultMotions = {
        horizontal: {
            motionName: `${rootPrefixCls}-slide-up`
        },
        inline: (0, $32c4c593a0d4aef5$export$2e2bcd8739ae039)(rootPrefixCls),
        other: {
            motionName: `${rootPrefixCls}-zoom-big`
        }
    };
    const prefixCls = getPrefixCls('menu', customizePrefixCls || overrideObj.prefixCls);
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $09627815423cc890$export$2e2bcd8739ae039)(prefixCls, rootCls, !override);
    const menuClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-${theme}`, contextClassName, className);
    // ====================== ExpandIcon ========================
    const mergedExpandIcon = $ltGt3.useMemo(()=>{
        if (typeof expandIcon === 'function' || $e621418180f953a0$var$isEmptyIcon(expandIcon)) return expandIcon || null;
        if (typeof overrideObj.expandIcon === 'function' || $e621418180f953a0$var$isEmptyIcon(overrideObj.expandIcon)) return overrideObj.expandIcon || null;
        if (typeof menu?.expandIcon === 'function' || $e621418180f953a0$var$isEmptyIcon(menu?.expandIcon)) return menu?.expandIcon || null;
        const mergedIcon = expandIcon ?? overrideObj?.expandIcon ?? menu?.expandIcon;
        return (0, $66d38239e1a27993$export$e530037191fcd5d7)(mergedIcon, {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-submenu-expand-icon`, /*#__PURE__*/ $ltGt3.isValidElement(mergedIcon) ? mergedIcon.props?.className : undefined)
        });
    }, [
        expandIcon,
        overrideObj?.expandIcon,
        menu?.expandIcon,
        prefixCls
    ]);
    // ======================== Context ==========================
    const contextValue = $ltGt3.useMemo(()=>({
            prefixCls: prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            direction: direction,
            firstLevel: true,
            theme: theme,
            mode: mergedMode,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        prefixCls,
        mergedInlineCollapsed,
        direction,
        _internalDisableMenuItemTitleTooltip,
        theme,
        mergedMode,
        mergedClassNames,
        mergedStyles
    ]);
    // ========================= Render ==========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $0c0f4dfb7618b339$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $ltGt3.createElement((0, $4301eb43ed83536d$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $ltGt3.createElement((0, $ac5bef0095eb3e01$export$2e2bcd8739ae039), {
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ $ltGt3.createElement((0, $21a25bcc3e8ef68c$export$2e2bcd8739ae039), null),
        overflowedIndicatorPopupClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${theme}`, overflowedIndicatorPopupClassName),
        classNames: {
            list: mergedClassNames.list,
            listTitle: mergedClassNames.itemTitle
        },
        styles: {
            list: mergedStyles.list,
            listTitle: mergedStyles.itemTitle
        },
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick,
        ...passedProps,
        inlineCollapsed: mergedInlineCollapsed,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref,
        rootClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(rootClassName, hashId, overrideObj.rootClassName, cssVarCls, rootCls, mergedClassNames.root),
        _internalComponents: $e621418180f953a0$var$MENU_COMPONENTS
    })));
});
var $e621418180f953a0$export$2e2bcd8739ae039 = $e621418180f953a0$var$InternalMenu;





"use client";
const $ad53fe0065acc0ef$var$Menu = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
    const menuRef = (0, $ltGt3.useRef)(null);
    const context = $ltGt3.useContext((0, $945fab49c4f4b0f1$export$63554aebd2a6d54c));
    (0, $ltGt3.useImperativeHandle)(ref, ()=>({
            menu: menuRef.current,
            focus: (options)=>{
                menuRef.current?.focus(options);
            }
        }));
    return /*#__PURE__*/ $ltGt3.createElement((0, $e621418180f953a0$export$2e2bcd8739ae039), {
        ref: menuRef,
        ...props,
        ...context
    });
});
$ad53fe0065acc0ef$var$Menu.Item = (0, $7f11dd29a3bed229$export$2e2bcd8739ae039);
$ad53fe0065acc0ef$var$Menu.SubMenu = (0, $0314e4583d0eca80$export$2e2bcd8739ae039);
$ad53fe0065acc0ef$var$Menu.Divider = (0, $73a9e8e7bffd86a4$export$2e2bcd8739ae039);
$ad53fe0065acc0ef$var$Menu.ItemGroup = (0, $a2ba66be90976991$export$2e2bcd8739ae039);
var $ad53fe0065acc0ef$export$2e2bcd8739ae039 = $ad53fe0065acc0ef$var$Menu;








const $96f7793622fd94de$export$c81b62e088da1305 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antMoveDownIn', {
    '0%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $96f7793622fd94de$export$6c1eca72ac4f6672 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antMoveDownOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $96f7793622fd94de$export$8dd54688d033571 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antMoveLeftIn', {
    '0%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $96f7793622fd94de$export$be161c4e647bea9b = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antMoveLeftOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $96f7793622fd94de$export$a984c43131c7d145 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antMoveRightIn', {
    '0%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $96f7793622fd94de$export$e141ac6798b476df = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antMoveRightOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $96f7793622fd94de$export$ab676201eaaca05 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antMoveUpIn', {
    '0%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $96f7793622fd94de$export$ec1b91b8ec2f6331 = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antMoveUpOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $96f7793622fd94de$var$moveMotion = {
    'move-up': {
        inKeyframes: $96f7793622fd94de$export$ab676201eaaca05,
        outKeyframes: $96f7793622fd94de$export$ec1b91b8ec2f6331
    },
    'move-down': {
        inKeyframes: $96f7793622fd94de$export$c81b62e088da1305,
        outKeyframes: $96f7793622fd94de$export$6c1eca72ac4f6672
    },
    'move-left': {
        inKeyframes: $96f7793622fd94de$export$8dd54688d033571,
        outKeyframes: $96f7793622fd94de$export$be161c4e647bea9b
    },
    'move-right': {
        inKeyframes: $96f7793622fd94de$export$a984c43131c7d145,
        outKeyframes: $96f7793622fd94de$export$e141ac6798b476df
    }
};
const $96f7793622fd94de$export$913b1b7e3288c319 = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $96f7793622fd94de$var$moveMotion[motionName];
    return [
        (0, $ce8f91b8b06c1cd8$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};





const $500e0589952a2b5e$var$genStatusStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, colorError: colorError, colorTextLightSolid: colorTextLightSolid } = token;
    const itemCls = `${menuCls}-item`;
    return {
        [`${componentCls}, ${componentCls}-menu-submenu`]: {
            [`${menuCls} ${itemCls}`]: {
                [`&${itemCls}-danger:not(${itemCls}-disabled)`]: {
                    color: colorError,
                    '&:hover': {
                        color: colorTextLightSolid,
                        backgroundColor: colorError
                    }
                }
            }
        }
    };
};
var $500e0589952a2b5e$export$2e2bcd8739ae039 = $500e0589952a2b5e$var$genStatusStyle;


// =============================== Base ===============================
const $00d5e9f94275d28b$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, zIndexPopup: zIndexPopup, dropdownArrowDistance: dropdownArrowDistance, sizePopupArrow: sizePopupArrow, antCls: antCls, iconCls: iconCls, motionDurationMid: motionDurationMid, paddingBlock: paddingBlock, fontSize: fontSize, dropdownEdgeChildPadding: dropdownEdgeChildPadding, colorTextDisabled: colorTextDisabled, fontSizeIcon: fontSizeIcon, controlPaddingHorizontal: controlPaddingHorizontal, colorBgElevated: colorBgElevated } = token;
    return [
        {
            [componentCls]: {
                position: 'absolute',
                top: -9999,
                left: {
                    _skip_check_: true,
                    value: -9999
                },
                zIndex: zIndexPopup,
                display: 'block',
                // A placeholder out of dropdown visible range to avoid close when user moving
                '&::before': {
                    position: 'absolute',
                    insetBlock: token.calc(sizePopupArrow).div(2).sub(dropdownArrowDistance).equal(),
                    // insetInlineStart: -7, // FIXME: Seems not work for hidden element
                    zIndex: -9999,
                    opacity: 0.0001,
                    content: '""'
                },
                // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
                '&-menu-vertical': {
                    maxHeight: '100vh',
                    overflowY: 'auto'
                },
                [`&-trigger${antCls}-btn`]: {
                    [`& > ${iconCls}-down, & > ${antCls}-btn-icon > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    }
                },
                [`${componentCls}-wrap`]: {
                    position: 'relative',
                    [`${antCls}-btn > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    },
                    [`${iconCls}-down::before`]: {
                        transition: `transform ${motionDurationMid}`
                    }
                },
                [`${componentCls}-wrap-open`]: {
                    [`${iconCls}-down::before`]: {
                        transform: `rotate(180deg)`
                    }
                },
                [`
        &-hidden,
        &-menu-hidden,
        &-menu-submenu-hidden
      `]: {
                    display: 'none'
                },
                // =============================================================
                // ==                         Motion                          ==
                // =============================================================
                // When position is not enough for dropdown, the placement will revert.
                // We will handle this with revert motion name.
                [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomRight,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $e613b8e902d5a10c$export$e801b802b037de6a)
                },
                [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-top,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-top,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $e613b8e902d5a10c$export$dd9f089fa5e819fe)
                },
                [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $e613b8e902d5a10c$export$f40f41df328ebc38)
                },
                [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-top,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $e613b8e902d5a10c$export$f7243fdb9c27c3b7)
                }
            }
        },
        // =============================================================
        // ==                        Arrow style                      ==
        // =============================================================
        (0, $f61b43f1533e9f98$export$2e2bcd8739ae039)(token, colorBgElevated, {
            arrowPlacement: {
                top: true,
                bottom: true
            }
        }),
        {
            // =============================================================
            // ==                          Menu                           ==
            // =============================================================
            [`${componentCls} ${menuCls}`]: {
                position: 'relative',
                margin: 0
            },
            [`${menuCls}-submenu-popup`]: {
                position: 'absolute',
                zIndex: zIndexPopup,
                background: 'transparent',
                boxShadow: 'none',
                transformOrigin: '0 0',
                'ul, li': {
                    listStyle: 'none',
                    margin: 0
                }
            },
            [`${componentCls}, ${componentCls}-menu-submenu`]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                [menuCls]: {
                    padding: dropdownEdgeChildPadding,
                    listStyleType: 'none',
                    backgroundColor: colorBgElevated,
                    backgroundClip: 'padding-box',
                    borderRadius: token.borderRadiusLG,
                    outline: 'none',
                    boxShadow: token.boxShadowSecondary,
                    ...(0, $945cb0d2b7017a11$export$a44db842bcb28231)(token),
                    '&:empty': {
                        padding: 0,
                        boxShadow: 'none'
                    },
                    [`${menuCls}-item-group-title`]: {
                        padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingBlock)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(controlPaddingHorizontal)}`,
                        color: token.colorTextDescription,
                        transition: `all ${motionDurationMid}`
                    },
                    // ======================= Item Content =======================
                    [`${menuCls}-item`]: {
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center'
                    },
                    [`${menuCls}-item-icon`]: {
                        minWidth: fontSize,
                        marginInlineEnd: token.marginXS,
                        fontSize: token.fontSizeSM
                    },
                    [`${menuCls}-title-content`]: {
                        flex: 'auto',
                        '&-with-extra': {
                            display: 'inline-flex',
                            alignItems: 'center',
                            width: '100%'
                        },
                        '> a': {
                            color: 'inherit',
                            transition: `all ${motionDurationMid}`,
                            '&:hover': {
                                color: 'inherit'
                            },
                            '&::after': {
                                position: 'absolute',
                                inset: 0,
                                content: '""'
                            }
                        },
                        [`${menuCls}-item-extra`]: {
                            paddingInlineStart: token.padding,
                            marginInlineStart: 'auto',
                            fontSize: token.fontSizeSM,
                            color: token.colorTextDescription
                        }
                    },
                    // =========================== Item ===========================
                    [`${menuCls}-item, ${menuCls}-submenu-title`]: {
                        display: 'flex',
                        margin: 0,
                        padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingBlock)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(controlPaddingHorizontal)}`,
                        color: token.colorText,
                        fontWeight: 'normal',
                        fontSize: fontSize,
                        lineHeight: token.lineHeight,
                        cursor: 'pointer',
                        transition: `all ${motionDurationMid}`,
                        borderRadius: token.borderRadiusSM,
                        '&:hover, &-active': {
                            backgroundColor: token.controlItemBgHover
                        },
                        ...(0, $945cb0d2b7017a11$export$a44db842bcb28231)(token),
                        '&-selected': {
                            color: token.colorPrimary,
                            backgroundColor: token.controlItemBgActive,
                            '&:hover, &-active': {
                                backgroundColor: token.controlItemBgActiveHover
                            }
                        },
                        '&-disabled': {
                            color: colorTextDisabled,
                            cursor: 'not-allowed',
                            '&:hover': {
                                color: colorTextDisabled,
                                backgroundColor: colorBgElevated,
                                cursor: 'not-allowed'
                            },
                            a: {
                                pointerEvents: 'none'
                            }
                        },
                        '&-divider': {
                            height: 1,
                            // By design
                            margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.marginXXS)} 0`,
                            overflow: 'hidden',
                            lineHeight: 0,
                            backgroundColor: token.colorSplit
                        },
                        [`${componentCls}-menu-submenu-expand-icon`]: {
                            position: 'absolute',
                            insetInlineEnd: token.paddingXS,
                            [`${componentCls}-menu-submenu-arrow-icon`]: {
                                marginInlineEnd: '0 !important',
                                color: token.colorIcon,
                                fontSize: fontSizeIcon,
                                fontStyle: 'normal'
                            }
                        }
                    },
                    [`${menuCls}-item-group-list`]: {
                        margin: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.marginXS)}`,
                        padding: 0,
                        listStyle: 'none'
                    },
                    [`${menuCls}-submenu-title`]: {
                        paddingInlineEnd: token.calc(controlPaddingHorizontal).add(token.fontSizeSM).equal()
                    },
                    [`${menuCls}-submenu-vertical`]: {
                        position: 'relative'
                    },
                    [`${menuCls}-submenu${menuCls}-submenu-disabled ${componentCls}-menu-submenu-title`]: {
                        [`&, ${componentCls}-menu-submenu-arrow-icon`]: {
                            color: colorTextDisabled,
                            backgroundColor: colorBgElevated,
                            cursor: 'not-allowed'
                        }
                    },
                    // https://github.com/ant-design/ant-design/issues/19264
                    [`${menuCls}-submenu-selected ${componentCls}-menu-submenu-title`]: {
                        color: token.colorPrimary
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, $e613b8e902d5a10c$export$9018e60daecf7a6c)(token, 'slide-up'),
            (0, $e613b8e902d5a10c$export$9018e60daecf7a6c)(token, 'slide-down'),
            (0, $96f7793622fd94de$export$913b1b7e3288c319)(token, 'move-up'),
            (0, $96f7793622fd94de$export$913b1b7e3288c319)(token, 'move-down'),
            (0, $29a43b27eddd598a$export$f5d123412490d9dc)(token, 'zoom-big')
        ]
    ];
};
const $00d5e9f94275d28b$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 50,
        paddingBlock: (token.controlHeight - token.fontSize * token.lineHeight) / 2,
        ...(0, $f61b43f1533e9f98$export$bddc192327bb9823)({
            contentRadius: token.borderRadiusLG,
            limitVerticalRadius: true
        }),
        ...(0, $bf6e216ed4fab7a5$export$87e38ee403661ccc)(token)
    });
var $00d5e9f94275d28b$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Dropdown', (token)=>{
    const { marginXXS: marginXXS, sizePopupArrow: sizePopupArrow, paddingXXS: paddingXXS, componentCls: componentCls } = token;
    const dropdownToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        menuCls: `${componentCls}-menu`,
        dropdownArrowDistance: token.calc(sizePopupArrow).div(2).add(marginXXS).equal(),
        dropdownEdgeChildPadding: paddingXXS
    });
    return [
        $00d5e9f94275d28b$var$genBaseStyle(dropdownToken),
        (0, $500e0589952a2b5e$export$2e2bcd8739ae039)(dropdownToken)
    ];
}, $00d5e9f94275d28b$export$9ca1be8807fe0675, {
    resetStyle: false
});


"use client";
const $f566a3986be68274$var$_Placements = [
    'topLeft',
    'topCenter',
    'topRight',
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
    'top',
    'bottom'
];
const $f566a3986be68274$var$Dropdown = (props)=>{
    const { menu: menu, arrow: arrow, prefixCls: customizePrefixCls, children: children, trigger: trigger, disabled: disabled, dropdownRender: dropdownRender, popupRender: popupRender, getPopupContainer: getPopupContainer, overlayClassName: overlayClassName, rootClassName: rootClassName, overlayStyle: overlayStyle, open: open, onOpenChange: onOpenChange, mouseEnterDelay: mouseEnterDelay = 0.15, mouseLeaveDelay: mouseLeaveDelay = 0.1, autoAdjustOverflow: autoAdjustOverflow = true, placement: placement = '', transitionName: transitionName, classNames: classNames, styles: styles, destroyPopupOnHide: destroyPopupOnHide, destroyOnHidden: destroyOnHidden } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getContextPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('dropdown');
    const mergedProps = {
        ...props,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        autoAdjustOverflow: autoAdjustOverflow
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const mergedRootStyles = {
        ...contextStyle,
        ...overlayStyle,
        ...mergedStyles.root
    };
    const mergedPopupRender = popupRender || dropdownRender;
    // =================== Warning =====================
    const warning = (0, $9530c27c700696d0$export$cf977aa92c751e61)('Dropdown');
    var deprecatedName, newName;
    const memoTransitionName = $ltGt3.useMemo(()=>{
        const rootPrefixCls = getPrefixCls();
        if (transitionName !== undefined) return transitionName;
        if (placement.includes('top')) return `${rootPrefixCls}-slide-down`;
        return `${rootPrefixCls}-slide-up`;
    }, [
        getPrefixCls,
        placement,
        transitionName
    ]);
    const memoPlacement = $ltGt3.useMemo(()=>{
        if (!placement) return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
        if (placement.includes('Center')) return placement.slice(0, placement.indexOf('Center'));
        return placement;
    }, [
        placement,
        direction
    ]);
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $00d5e9f94275d28b$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const child = $ltGt3.Children.only((0, $0f4dc13c42912ebb$export$2e2bcd8739ae039)(children) ? /*#__PURE__*/ $ltGt3.createElement("span", null, children) : children);
    const popupTrigger = (0, $66d38239e1a27993$export$e530037191fcd5d7)(child, {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-trigger`, {
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, child.props.className),
        disabled: child.props.disabled ?? disabled
    });
    const triggerActions = disabled ? [] : trigger;
    const alignPoint = !!triggerActions?.includes('contextMenu');
    // =========================== Open ============================
    const [mergedOpen, setOpen] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(false, open);
    const onInnerOpenChange = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((nextOpen)=>{
        onOpenChange?.(nextOpen, {
            source: 'trigger'
        });
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    const overlayClassNameCustomized = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(overlayClassName, rootClassName, hashId, cssVarCls, rootCls, contextClassName, mergedClassNames.root, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    });
    const builtinPlacements = (0, $a4d52b87871d5972$export$2e2bcd8739ae039)({
        arrowPointAtCenter: typeof arrow === 'object' && arrow.pointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow,
        offset: token.marginXXS,
        arrowWidth: arrow ? token.sizePopupArrow : 0,
        borderRadius: token.borderRadius
    });
    const onMenuClick = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(()=>{
        if (menu?.selectable && menu?.multiple) return;
        onOpenChange?.(false, {
            source: 'menu'
        });
        setOpen(false);
    });
    const renderOverlay = ()=>{
        // @rc-component/dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to @rc-component/dropdown.
        const menuClassNames = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(mergedClassNames, [
            'root'
        ]);
        const menuStyles = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(mergedStyles, [
            'root'
        ]);
        let overlayNode;
        if (menu?.items) overlayNode = /*#__PURE__*/ $ltGt3.createElement((0, $ad53fe0065acc0ef$export$2e2bcd8739ae039), {
            ...menu,
            classNames: {
                ...menuClassNames,
                subMenu: {
                    ...menuClassNames
                }
            },
            styles: {
                ...menuStyles,
                subMenu: {
                    ...menuStyles
                }
            }
        });
        if (mergedPopupRender) overlayNode = mergedPopupRender(overlayNode);
        overlayNode = $ltGt3.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/ $ltGt3.createElement("span", null, overlayNode) : overlayNode);
        return /*#__PURE__*/ $ltGt3.createElement((0, $0c0f4dfb7618b339$export$9bd434816b0530d0), {
            prefixCls: `${prefixCls}-menu`,
            rootClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(cssVarCls, rootCls),
            expandIcon: /*#__PURE__*/ $ltGt3.createElement("span", {
                className: `${prefixCls}-menu-submenu-arrow`
            }, direction === 'rtl' ? /*#__PURE__*/ $ltGt3.createElement((0, $4fcbd32442f5797e$export$2e2bcd8739ae039), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            }) : /*#__PURE__*/ $ltGt3.createElement((0, $a9490449fe252e7b$export$2e2bcd8739ae039), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: ({ mode: mode })=>{}
        }, overlayNode);
    };
    // =========================== zIndex ============================
    const [zIndex, contextZIndex] = (0, $ad5b6b465efa8f67$export$3e7906d4075187a4)('Dropdown', mergedRootStyles.zIndex);
    // ============================ Render ============================
    let renderNode = /*#__PURE__*/ $ltGt3.createElement((0, $14028894932dc2c5$export$2e2bcd8739ae039), {
        alignPoint: alignPoint,
        ...(0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(props, [
            'rootClassName',
            'onOpenChange'
        ]),
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: memoTransitionName,
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: memoPlacement,
        onVisibleChange: onInnerOpenChange,
        overlayStyle: {
            ...mergedRootStyles,
            zIndex: zIndex
        },
        autoDestroy: destroyOnHidden ?? destroyPopupOnHide
    }, popupTrigger);
    if (zIndex) renderNode = /*#__PURE__*/ $ltGt3.createElement((0, $cba857b93cac085e$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, renderNode);
    return renderNode;
};
// We don't care debug panel
const $f566a3986be68274$var$PurePanel = (0, $c64d2291d230fcde$export$2e2bcd8739ae039)($f566a3986be68274$var$Dropdown, 'align', undefined, 'dropdown', (prefixCls)=>prefixCls);
/* istanbul ignore next */ const $f566a3986be68274$var$WrapPurePanel = (props)=>/*#__PURE__*/ $ltGt3.createElement($f566a3986be68274$var$PurePanel, {
        ...props
    }, /*#__PURE__*/ $ltGt3.createElement("span", null));
$f566a3986be68274$var$Dropdown._InternalPanelDoNotUseOrYouWillBeFired = $f566a3986be68274$var$WrapPurePanel;
var $f566a3986be68274$export$2e2bcd8739ae039 = $f566a3986be68274$var$Dropdown;



var $ltGt3 = parcelRequire("ltGt3");






var $ltGt3 = parcelRequire("ltGt3");


function $a6411b9fbddad0a8$export$f5153c3888a6824e(size) {
    return [
        'small',
        'middle',
        'large'
    ].includes(size);
}
function $a6411b9fbddad0a8$export$1b502d0a9135d42b(size) {
    if (!size) // The case of size = 0 is deliberately excluded here, because the default value of the gap attribute in CSS is 0, so if the user passes 0 in, we can directly ignore it.
    return false;
    return typeof size === 'number' && !Number.isNaN(size);
}








var $ltGt3 = parcelRequire("ltGt3");






const $d8ab250e6b41420d$var$genSpaceAddonStyle = (token)=>{
    const { componentCls: componentCls, borderRadius: borderRadius, paddingSM: paddingSM, colorBorder: colorBorder, paddingXS: paddingXS, fontSizeLG: fontSizeLG, fontSizeSM: fontSizeSM, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM, colorBgContainerDisabled: colorBgContainerDisabled, lineWidth: lineWidth } = token;
    return {
        [componentCls]: [
            // ==========================================================
            // ==                         Base                         ==
            // ==========================================================
            {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0,
                paddingInline: paddingSM,
                margin: 0,
                borderWidth: lineWidth,
                borderStyle: 'solid',
                borderRadius: borderRadius,
                '&:hover': {
                    zIndex: 0
                },
                [`&${componentCls}-disabled`]: {
                    color: token.colorTextDisabled
                },
                '&-large': {
                    fontSize: fontSizeLG,
                    borderRadius: borderRadiusLG
                },
                '&-small': {
                    paddingInline: paddingXS,
                    borderRadius: borderRadiusSM,
                    fontSize: fontSizeSM
                },
                '&-compact-last-item': {
                    borderEndStartRadius: 0,
                    borderStartStartRadius: 0
                },
                '&-compact-first-item': {
                    borderEndEndRadius: 0,
                    borderStartEndRadius: 0
                },
                '&-compact-item:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                },
                '&-compact-item:not(:last-child)': {
                    borderInlineEndWidth: 0
                },
                '&-compact-item:not(:first-child)': {
                    borderInlineStartWidth: 0
                }
            },
            // ==========================================================
            // ==                       Variants                       ==
            // ==========================================================
            {
                '--space-addon-border-color': colorBorder,
                '--space-addon-background': colorBgContainerDisabled,
                // Filled
                '--space-addon-border-color-outlined': colorBorder,
                '--space-addon-background-filled': colorBgContainerDisabled,
                borderColor: 'var(--space-addon-border-color)',
                background: 'var(--space-addon-background)',
                // ======================= Outlined =======================
                [`&-variant-outlined`]: {
                    '--space-addon-border-color': 'var(--space-addon-border-color-outlined)'
                },
                // ======================== Filled ========================
                [`&-variant-filled`]: {
                    '--space-addon-border-color': 'transparent',
                    '--space-addon-background': 'var(--space-addon-background-filled)',
                    // Disabled
                    [`&${componentCls}-disabled`]: {
                        '--space-addon-border-color': colorBorder,
                        '--space-addon-background': colorBgContainerDisabled
                    }
                },
                // ====================== Borderless ======================
                [`&-variant-borderless`]: {
                    border: 'none',
                    background: 'transparent'
                },
                // ====================== Underlined ======================
                [`&-variant-underlined`]: {
                    border: 'none',
                    background: 'transparent'
                }
            },
            // ==========================================================
            // ==                        Status                        ==
            // ==========================================================
            {
                '&-status-error': {
                    '--space-addon-border-color-outlined': token.colorError,
                    '--space-addon-background-filled': token.colorErrorBg,
                    color: token.colorError
                },
                '&-status-warning': {
                    '--space-addon-border-color-outlined': token.colorWarning,
                    '--space-addon-background-filled': token.colorWarningBg,
                    color: token.colorWarning
                }
            }
        ]
    };
};
var // ============================== Export ==============================
$d8ab250e6b41420d$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)([
    'Space',
    'Addon'
], (token)=>[
        $d8ab250e6b41420d$var$genSpaceAddonStyle(token),
        (0, $f96147db005a8a82$export$b1208b23589b4b73)(token, {
            focus: false
        })
    ]);


"use client";
const $2e05741c744aa06e$var$SpaceAddon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    const { className: className, children: children, style: style, prefixCls: customizePrefixCls, variant: variant = 'outlined', disabled: disabled, status: status, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('space-addon', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $d8ab250e6b41420d$export$2e2bcd8739ae039)(prefixCls);
    const { compactItemClassnames: compactItemClassnames, compactSize: compactSize } = (0, $8eabd28975be2fa5$export$cd8cf9d7bab8dd4)(prefixCls, directionConfig);
    const statusCls = (0, $7b7bdeafff468875$export$b08e7b47149942a2)(prefixCls, status);
    const classes = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, hashId, compactItemClassnames, cssVarCls, `${prefixCls}-variant-${variant}`, statusCls, {
        [`${prefixCls}-${compactSize}`]: compactSize,
        [`${prefixCls}-disabled`]: disabled
    }, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        ref: ref,
        className: classes,
        style: style,
        ...restProps
    }, children);
});
var $2e05741c744aa06e$export$2e2bcd8739ae039 = $2e05741c744aa06e$var$SpaceAddon;



var $ltGt3 = parcelRequire("ltGt3");
const $42d08b974f3e47a7$export$853f607fd5cc208b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createContext({
    latestIndex: 0
});
const $42d08b974f3e47a7$export$2bbf36e6e96e17f9 = $42d08b974f3e47a7$export$853f607fd5cc208b.Provider;



var $ltGt3 = parcelRequire("ltGt3");


"use client";
const $a2ddee97915e2003$var$Item = (props)=>{
    const { className: className, prefix: prefix, index: index, children: children, separator: separator, style: style, classNames: classNames, styles: styles } = props;
    const { latestIndex: latestIndex } = $ltGt3.useContext((0, $42d08b974f3e47a7$export$853f607fd5cc208b));
    if (children === null || children === undefined) return null;
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && separator && /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefix}-item-separator`, classNames.separator),
        style: styles.separator
    }, separator));
};
var $a2ddee97915e2003$export$2e2bcd8739ae039 = $a2ddee97915e2003$var$Item;



const $19fa2a2a09e4d30d$var$genSpaceStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-rtl': {
                direction: 'rtl'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-align': {
                flexDirection: 'column',
                '&-center': {
                    alignItems: 'center'
                },
                '&-start': {
                    alignItems: 'flex-start'
                },
                '&-end': {
                    alignItems: 'flex-end'
                },
                '&-baseline': {
                    alignItems: 'baseline'
                }
            },
            [`${componentCls}-item:empty`]: {
                display: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/47875
            [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
                display: 'block'
            }
        }
    };
};
const $19fa2a2a09e4d30d$var$genSpaceGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-gap-row-small': {
                rowGap: token.spaceGapSmallSize
            },
            '&-gap-row-middle': {
                rowGap: token.spaceGapMiddleSize
            },
            '&-gap-row-large': {
                rowGap: token.spaceGapLargeSize
            },
            '&-gap-col-small': {
                columnGap: token.spaceGapSmallSize
            },
            '&-gap-col-middle': {
                columnGap: token.spaceGapMiddleSize
            },
            '&-gap-col-large': {
                columnGap: token.spaceGapLargeSize
            }
        }
    };
};
const $19fa2a2a09e4d30d$export$9ca1be8807fe0675 = ()=>({});
var $19fa2a2a09e4d30d$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Space', (token)=>{
    const spaceToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        $19fa2a2a09e4d30d$var$genSpaceStyle(spaceToken),
        $19fa2a2a09e4d30d$var$genSpaceGapStyle(spaceToken)
    ];
}, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
const $d029ee757225a242$var$InternalSpace = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig, size: contextSize, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('space');
    const { size: size = contextSize ?? 'small', align: align, className: className, rootClassName: rootClassName, children: children, direction: direction, orientation: orientation, prefixCls: customizePrefixCls, split: split, separator: separator, style: style, vertical: vertical, wrap: wrap = false, classNames: classNames, styles: styles, ...restProps } = props;
    const [horizontalSize, verticalSize] = Array.isArray(size) ? size : [
        size,
        size
    ];
    const isPresetVerticalSize = (0, $a6411b9fbddad0a8$export$f5153c3888a6824e)(verticalSize);
    const isPresetHorizontalSize = (0, $a6411b9fbddad0a8$export$f5153c3888a6824e)(horizontalSize);
    const isValidVerticalSize = (0, $a6411b9fbddad0a8$export$1b502d0a9135d42b)(verticalSize);
    const isValidHorizontalSize = (0, $a6411b9fbddad0a8$export$1b502d0a9135d42b)(horizontalSize);
    const childNodes = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children, {
        keepEmpty: true
    });
    const [mergedOrientation, mergedVertical] = (0, $15bdf1069fb84d0c$export$550084c67147f6c4)(orientation, vertical, direction);
    const mergedAlign = align === undefined && !mergedVertical ? 'center' : align;
    const mergedSeparator = separator ?? split;
    const prefixCls = getPrefixCls('space', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $19fa2a2a09e4d30d$export$2e2bcd8739ae039)(prefixCls);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: size,
        orientation: mergedOrientation,
        align: mergedAlign
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, contextClassName, hashId, `${prefixCls}-${mergedOrientation}`, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-align-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-gap-row-${verticalSize}`]: isPresetVerticalSize,
        [`${prefixCls}-gap-col-${horizontalSize}`]: isPresetHorizontalSize
    }, className, rootClassName, cssVarCls, mergedClassNames.root);
    const itemClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-item`, mergedClassNames.item);
    // Calculate latest one
    const renderedItems = childNodes.map((child, i)=>{
        const key = child?.key || `${itemClassName}-${i}`;
        return /*#__PURE__*/ $ltGt3.createElement((0, $a2ddee97915e2003$export$2e2bcd8739ae039), {
            prefix: prefixCls,
            classNames: mergedClassNames,
            styles: mergedStyles,
            className: itemClassName,
            key: key,
            index: i,
            separator: mergedSeparator,
            style: mergedStyles.item
        }, child);
    });
    var deprecatedName, newName;
    const memoizedSpaceContext = $ltGt3.useMemo(()=>{
        const calcLatestIndex = childNodes.reduce((latest, child, i)=>(0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(child) ? i : latest, 0);
        return {
            latestIndex: calcLatestIndex
        };
    }, [
        childNodes
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    const gapStyle = {};
    if (wrap) gapStyle.flexWrap = 'wrap';
    if (!isPresetHorizontalSize && isValidHorizontalSize) gapStyle.columnGap = horizontalSize;
    if (!isPresetVerticalSize && isValidVerticalSize) gapStyle.rowGap = verticalSize;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: ref,
        className: rootClassNames,
        style: {
            ...gapStyle,
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        ...restProps
    }, /*#__PURE__*/ $ltGt3.createElement((0, $42d08b974f3e47a7$export$2bbf36e6e96e17f9), {
        value: memoizedSpaceContext
    }, renderedItems));
});
const $d029ee757225a242$var$Space = $d029ee757225a242$var$InternalSpace;
$d029ee757225a242$var$Space.Compact = (0, $8eabd28975be2fa5$export$2e2bcd8739ae039);
$d029ee757225a242$var$Space.Addon = (0, $2e05741c744aa06e$export$2e2bcd8739ae039);
var $d029ee757225a242$export$2e2bcd8739ae039 = $d029ee757225a242$var$Space;




"use client";
/** @deprecated Please use Space.Compact + Dropdown + Button instead */ const $7ce9a80e72d917e6$var$DropdownButton = (props)=>{
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, type: type = 'default', danger: danger, disabled: disabled, loading: loading, onClick: onClick, htmlType: htmlType, children: children, className: className, menu: menu, arrow: arrow, autoFocus: autoFocus, trigger: trigger, align: align, open: open, onOpenChange: onOpenChange, placement: placement, getPopupContainer: getPopupContainer, href: href, icon: icon = /*#__PURE__*/ $ltGt3.createElement((0, $21a25bcc3e8ef68c$export$2e2bcd8739ae039), null), title: title, buttonsRender: buttonsRender = (buttons)=>buttons, mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, overlayClassName: overlayClassName, overlayStyle: overlayStyle, destroyOnHidden: destroyOnHidden, destroyPopupOnHide: destroyPopupOnHide, dropdownRender: dropdownRender, popupRender: popupRender, ...restProps } = props;
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const buttonPrefixCls = `${prefixCls}-button`;
    const mergedPopupRender = popupRender || dropdownRender;
    const dropdownProps = {
        menu: menu,
        arrow: arrow,
        autoFocus: autoFocus,
        align: align,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onOpenChange: onOpenChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        classNames: {
            root: overlayClassName
        },
        styles: {
            root: overlayStyle
        },
        destroyOnHidden: destroyOnHidden,
        popupRender: mergedPopupRender
    };
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $8eabd28975be2fa5$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const classes = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(buttonPrefixCls, compactItemClassnames, className);
    if ('destroyPopupOnHide' in props) dropdownProps.destroyPopupOnHide = destroyPopupOnHide;
    if ('open' in props) dropdownProps.open = open;
    if ('placement' in props) dropdownProps.placement = placement;
    else dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
    const leftButton = /*#__PURE__*/ $ltGt3.createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        disabled: disabled,
        loading: loading,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
    }, children);
    const rightButton = /*#__PURE__*/ $ltGt3.createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        icon: icon
    });
    const [leftButtonToRender, rightButtonToRender] = buttonsRender([
        leftButton,
        rightButton
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $d029ee757225a242$export$2e2bcd8739ae039).Compact, {
        className: classes,
        size: compactSize,
        block: true,
        ...restProps
    }, leftButtonToRender, /*#__PURE__*/ $ltGt3.createElement((0, $f566a3986be68274$export$2e2bcd8739ae039), {
        ...dropdownProps
    }, rightButtonToRender));
};
$7ce9a80e72d917e6$var$DropdownButton.__ANT_BUTTON = true;
var $7ce9a80e72d917e6$export$2e2bcd8739ae039 = $7ce9a80e72d917e6$var$DropdownButton;


"use client";
const $fdbae0f0e90936fe$var$Dropdown = (0, $f566a3986be68274$export$2e2bcd8739ae039);
/** @deprecated Please use Space.Compact + Dropdown + Button instead */ $fdbae0f0e90936fe$var$Dropdown.Button = (0, $7ce9a80e72d917e6$export$2e2bcd8739ae039);
var $fdbae0f0e90936fe$export$2e2bcd8739ae039 = $fdbae0f0e90936fe$var$Dropdown;



var $ltGt3 = parcelRequire("ltGt3");







function $b6384d46b9e72afd$export$2e2bcd8739ae039(siders, children, hasSider) {
    if (typeof hasSider === 'boolean') return hasSider;
    if (siders.length) return true;
    const childNodes = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children);
    return childNodes.some((node)=>node.type === (0, $945fab49c4f4b0f1$export$2e2bcd8739ae039));
}



"use client";
function $12941e5fc9e33808$var$generator({ suffixCls: suffixCls, tagName: tagName, displayName: displayName }) {
    return (BasicComponent)=>{
        const Adapter = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>/*#__PURE__*/ $ltGt3.createElement(BasicComponent, {
                ref: ref,
                suffixCls: suffixCls,
                tagName: tagName,
                ...props
            }));
        return Adapter;
    };
}
const $12941e5fc9e33808$var$Basic = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, suffixCls: suffixCls, className: className, tagName: TagName, ...others } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('layout', customizePrefixCls);
    const [hashId] = (0, $c8620c9d5e4623c1$export$2e2bcd8739ae039)(prefixCls);
    const prefixWithSuffixCls = suffixCls ? `${prefixCls}-${suffixCls}` : prefixCls;
    return /*#__PURE__*/ $ltGt3.createElement(TagName, {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(customizePrefixCls || prefixWithSuffixCls, className, hashId),
        ref: ref,
        ...others
    });
});
const $12941e5fc9e33808$var$BasicLayout = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { direction: direction } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const [siders, setSiders] = $ltGt3.useState([]);
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, hasSider: hasSider, tagName: Tag, style: style, ...others } = props;
    const passedProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(others, [
        'suffixCls'
    ]);
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('layout');
    const prefixCls = getPrefixCls('layout', customizePrefixCls);
    const mergedHasSider = (0, $b6384d46b9e72afd$export$2e2bcd8739ae039)(siders, children, hasSider);
    const [hashId, cssVarCls] = (0, $c8620c9d5e4623c1$export$2e2bcd8739ae039)(prefixCls);
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-has-sider`]: mergedHasSider,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, contextClassName, className, rootClassName, hashId, cssVarCls);
    const contextValue = $ltGt3.useMemo(()=>({
            siderHook: {
                addSider: (id)=>{
                    setSiders((prev)=>[].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(prev), [
                            id
                        ]));
                },
                removeSider: (id)=>{
                    setSiders((prev)=>prev.filter((currentId)=>currentId !== id));
                }
            }
        }), []);
    return /*#__PURE__*/ $ltGt3.createElement((0, $ff386455706ae565$export$964282a2c3979546).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $ltGt3.createElement(Tag, {
        ref: ref,
        className: classString,
        style: {
            ...contextStyle,
            ...style
        },
        ...passedProps
    }, children));
});
const $12941e5fc9e33808$var$Layout = $12941e5fc9e33808$var$generator({
    tagName: 'div',
    displayName: 'Layout'
})($12941e5fc9e33808$var$BasicLayout);
const $12941e5fc9e33808$export$8b251419efc915eb = $12941e5fc9e33808$var$generator({
    suffixCls: 'header',
    tagName: 'header',
    displayName: 'Header'
})($12941e5fc9e33808$var$Basic);
const $12941e5fc9e33808$export$a06f1c675e846f6f = $12941e5fc9e33808$var$generator({
    suffixCls: 'footer',
    tagName: 'footer',
    displayName: 'Footer'
})($12941e5fc9e33808$var$Basic);
const $12941e5fc9e33808$export$7c6e2c02157bb7d2 = $12941e5fc9e33808$var$generator({
    suffixCls: 'content',
    tagName: 'main',
    displayName: 'Content'
})($12941e5fc9e33808$var$Basic);
var $12941e5fc9e33808$export$2e2bcd8739ae039 = $12941e5fc9e33808$var$Layout;



"use client";
const $9c8ed792d8f73a33$var$Layout = (0, $12941e5fc9e33808$export$2e2bcd8739ae039);
$9c8ed792d8f73a33$var$Layout.Header = (0, $12941e5fc9e33808$export$8b251419efc915eb);
$9c8ed792d8f73a33$var$Layout.Footer = (0, $12941e5fc9e33808$export$a06f1c675e846f6f);
$9c8ed792d8f73a33$var$Layout.Content = (0, $12941e5fc9e33808$export$7c6e2c02157bb7d2);
$9c8ed792d8f73a33$var$Layout.Sider = (0, $945fab49c4f4b0f1$export$2e2bcd8739ae039);
$9c8ed792d8f73a33$var$Layout._InternalSiderContext = (0, $945fab49c4f4b0f1$export$63554aebd2a6d54c);
var $9c8ed792d8f73a33$export$2e2bcd8739ae039 = $9c8ed792d8f73a33$var$Layout;




var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $6418b473aa6e7018$var$BookOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z"
                }
            }
        ]
    },
    "name": "book",
    "theme": "outlined"
};
var $6418b473aa6e7018$export$2e2bcd8739ae039 = $6418b473aa6e7018$var$BookOutlined;



var $c52eec455c68ab77$var$BookOutlined = function BookOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $6418b473aa6e7018$export$2e2bcd8739ae039)
    }));
};
/**![book](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWOTZjMC0xNy43LTE0LjMtMzItMzItMzJ6bS0yNjAgNzJoOTZ2MjA5LjlMNjIxLjUgMzEyIDU3MiAzNDcuNFYxMzZ6bTIyMCA3NTJIMjMyVjEzNmgyODB2Mjk2LjljMCAzLjMgMSA2LjYgMyA5LjNhMTUuOSAxNS45IDAgMDAyMi4zIDMuN2w4My44LTU5LjkgODEuNCA1OS40YzIuNyAyIDYgMy4xIDkuNCAzLjEgOC44IDAgMTYtNy4yIDE2LTE2VjEzNmg2NHY3NTJ6IiAvPjwvc3ZnPg==) */ var $c52eec455c68ab77$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($c52eec455c68ab77$var$BookOutlined);
var $c52eec455c68ab77$export$2e2bcd8739ae039 = $c52eec455c68ab77$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $16de7bd8c48162fa$var$EnvironmentOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"
                }
            }
        ]
    },
    "name": "environment",
    "theme": "outlined"
};
var $16de7bd8c48162fa$export$2e2bcd8739ae039 = $16de7bd8c48162fa$var$EnvironmentOutlined;



var $76d16a8a647518f3$var$EnvironmentOutlined = function EnvironmentOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $16de7bd8c48162fa$export$2e2bcd8739ae039)
    }));
};
/**![environment](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OS4xYTM2Mi40OSAzNjIuNDkgMCAwMC03OS45LTExNS43IDM3MC44MyAzNzAuODMgMCAwMC0xMTguMi03Ny44QzYxMC43IDc2LjYgNTYyLjEgNjcgNTEyIDY3Yy01MC4xIDAtOTguNyA5LjYtMTQ0LjUgMjguNS00NC4zIDE4LjMtODQgNDQuNS0xMTguMiA3Ny44QTM2My42IDM2My42IDAgMDAxNjkuNCAyODljLTE5LjUgNDUtMjkuNCA5Mi44LTI5LjQgMTQyIDAgNzAuNiAxNi45IDE0MC45IDUwLjEgMjA4LjcgMjYuNyA1NC41IDY0IDEwNy42IDExMSAxNTguMSA4MC4zIDg2LjIgMTY0LjUgMTM4LjkgMTg4LjQgMTUzYTQzLjkgNDMuOSAwIDAwMjIuNCA2LjFjNy44IDAgMTUuNS0yIDIyLjQtNi4xIDIzLjktMTQuMSAxMDguMS02Ni44IDE4OC40LTE1MyA0Ny01MC40IDg0LjMtMTAzLjYgMTExLTE1OC4xQzg2Ny4xIDU3MiA4ODQgNTAxLjggODg0IDQzMS4xYzAtNDkuMi05LjktOTctMjkuNC0xNDJ6TTUxMiA4ODAuMmMtNjUuOS00MS45LTMwMC0yMDcuOC0zMDAtNDQ5LjEgMC03Ny45IDMxLjEtMTUxLjEgODcuNi0yMDYuM0MzNTYuMyAxNjkuNSA0MzEuNyAxMzkgNTEyIDEzOXMxNTUuNyAzMC41IDIxMi40IDg1LjlDNzgwLjkgMjgwIDgxMiAzNTMuMiA4MTIgNDMxLjFjMCAyNDEuMy0yMzQuMSA0MDcuMi0zMDAgNDQ5LjF6bTAtNjE3LjJjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em03OS4yIDI1NS4yQTExMS42IDExMS42IDAgMDE1MTIgNTUxYy0yOS45IDAtNTgtMTEuNy03OS4yLTMyLjhBMTExLjYgMTExLjYgMCAwMTQwMCA0MzljMC0yOS45IDExLjctNTggMzIuOC03OS4yQzQ1NCAzMzguNiA0ODIuMSAzMjcgNTEyIDMyN2MyOS45IDAgNTggMTEuNiA3OS4yIDMyLjhDNjEyLjQgMzgxIDYyNCA0MDkuMSA2MjQgNDM5YzAgMjkuOS0xMS42IDU4LTMyLjggNzkuMnoiIC8+PC9zdmc+) */ var $76d16a8a647518f3$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($76d16a8a647518f3$var$EnvironmentOutlined);
var $76d16a8a647518f3$export$2e2bcd8739ae039 = $76d16a8a647518f3$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $a4a17807324bd7d6$var$GlobalOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0010-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 003.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 00-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 01887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 01-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 01115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 01540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 00540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 01-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 00-81.5 55.9A373.86 373.86 0 01137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 01-107.6 69.2z"
                }
            }
        ]
    },
    "name": "global",
    "theme": "outlined"
};
var $a4a17807324bd7d6$export$2e2bcd8739ae039 = $a4a17807324bd7d6$var$GlobalOutlined;



var $faae94e2180ec81a$var$GlobalOutlined = function GlobalOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $a4a17807324bd7d6$export$2e2bcd8739ae039)
    }));
};
/**![global](data:image/svg+xml;base64,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) */ var $faae94e2180ec81a$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($faae94e2180ec81a$var$GlobalOutlined);
var $faae94e2180ec81a$export$2e2bcd8739ae039 = $faae94e2180ec81a$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $1c57c27925c0e863$var$HomeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"
                }
            }
        ]
    },
    "name": "home",
    "theme": "outlined"
};
var $1c57c27925c0e863$export$2e2bcd8739ae039 = $1c57c27925c0e863$var$HomeOutlined;



var $802a5a63ccf25a2f$var$HomeOutlined = function HomeOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $1c57c27925c0e863$export$2e2bcd8739ae039)
    }));
};
/**![home](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Ni41IDUwNUw1NjAuMSAxMTguOGwtMjUuOS0yNS45YTMxLjUgMzEuNSAwIDAwLTQ0LjQgMEw3Ny41IDUwNWE2My45IDYzLjkgMCAwMC0xOC44IDQ2Yy40IDM1LjIgMjkuNyA2My4zIDY0LjkgNjMuM2g0Mi41Vjk0MGg2OTEuOFY2MTQuM2g0My40YzE3LjEgMCAzMy4yLTYuNyA0NS4zLTE4LjhhNjMuNiA2My42IDAgMDAxOC43LTQ1LjNjMC0xNy02LjctMzMuMS0xOC44LTQ1LjJ6TTU2OCA4NjhINDU2VjY2NGgxMTJ2MjA0em0yMTcuOS0zMjUuN1Y4NjhINjMyVjY0MGMwLTIyLjEtMTcuOS00MC00MC00MEg0MzJjLTIyLjEgMC00MCAxNy45LTQwIDQwdjIyOEgyMzguMVY1NDIuM2gtOTZsMzcwLTM2OS43IDIzLjEgMjMuMUw4ODIgNTQyLjNoLTk2LjF6IiAvPjwvc3ZnPg==) */ var $802a5a63ccf25a2f$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($802a5a63ccf25a2f$var$HomeOutlined);
var $802a5a63ccf25a2f$export$2e2bcd8739ae039 = $802a5a63ccf25a2f$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $518e5de51ab33fd5$var$MenuOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "menu",
    "theme": "outlined"
};
var $518e5de51ab33fd5$export$2e2bcd8739ae039 = $518e5de51ab33fd5$var$MenuOutlined;



var $d145441113989bb5$var$MenuOutlined = function MenuOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $518e5de51ab33fd5$export$2e2bcd8739ae039)
    }));
};
/**![menu](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwNCAxNjBIMTIwYy00LjQgMC04IDMuNi04IDh2NjRjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTY0YzAtNC40LTMuNi04LTgtOHptMCA2MjRIMTIwYy00LjQgMC04IDMuNi04IDh2NjRjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTY0YzAtNC40LTMuNi04LTgtOHptMC0zMTJIMTIwYy00LjQgMC04IDMuNi04IDh2NjRjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTY0YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ var $d145441113989bb5$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($d145441113989bb5$var$MenuOutlined);
var $d145441113989bb5$export$2e2bcd8739ae039 = $d145441113989bb5$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $f01229cfc7d43623$var$ProjectOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "project",
    "theme": "outlined"
};
var $f01229cfc7d43623$export$2e2bcd8739ae039 = $f01229cfc7d43623$var$ProjectOutlined;



var $e4dda58ea3df6d87$var$ProjectOutlined = function ProjectOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $f01229cfc7d43623$export$2e2bcd8739ae039)
    }));
};
/**![project](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4MCA3NTJoODBjNC40IDAgOC0zLjYgOC04VjI4MGMwLTQuNC0zLjYtOC04LThoLTgwYy00LjQgMC04IDMuNi04IDh2NDY0YzAgNC40IDMuNiA4IDggOHptMTkyLTI4MGg4MGM0LjQgMCA4LTMuNiA4LThWMjgwYzAtNC40LTMuNi04LTgtOGgtODBjLTQuNCAwLTggMy42LTggOHYxODRjMCA0LjQgMy42IDggOCA4em0xOTIgNzJoODBjNC40IDAgOC0zLjYgOC04VjI4MGMwLTQuNC0zLjYtOC04LThoLTgwYy00LjQgMC04IDMuNi04IDh2MjU2YzAgNC40IDMuNiA4IDggOHptMjE2LTQzMkgxNDRjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjczNmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg3MzZjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTQ0YzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNzI4SDE4NFYxODRoNjU2djY1NnoiIC8+PC9zdmc+) */ var $e4dda58ea3df6d87$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($e4dda58ea3df6d87$var$ProjectOutlined);
var $e4dda58ea3df6d87$export$2e2bcd8739ae039 = $e4dda58ea3df6d87$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $d20e1df6542566a8$var$UnorderedListOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "unordered-list",
    "theme": "outlined"
};
var $d20e1df6542566a8$export$2e2bcd8739ae039 = $d20e1df6542566a8$var$UnorderedListOutlined;



var $c3e8af9f728fda01$var$UnorderedListOutlined = function UnorderedListOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $d20e1df6542566a8$export$2e2bcd8739ae039)
    }));
};
/**![unordered-list](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTJIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMTA0IDIyOGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHptMCAyODRhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */ var $c3e8af9f728fda01$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($c3e8af9f728fda01$var$UnorderedListOutlined);
var $c3e8af9f728fda01$export$2e2bcd8739ae039 = $c3e8af9f728fda01$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $6cf48b4d5dd16096$var$UserOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
                }
            }
        ]
    },
    "name": "user",
    "theme": "outlined"
};
var $6cf48b4d5dd16096$export$2e2bcd8739ae039 = $6cf48b4d5dd16096$var$UserOutlined;



var $c3a5f6dca0f6325d$var$UserOutlined = function UserOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $6cf48b4d5dd16096$export$2e2bcd8739ae039)
    }));
};
/**![user](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OC41IDc2My42YTM3NCAzNzQgMCAwMC04MC42LTExOS41IDM3NS42MyAzNzUuNjMgMCAwMC0xMTkuNS04MC42Yy0uNC0uMi0uOC0uMy0xLjItLjVDNzE5LjUgNTE4IDc2MCA0NDQuNyA3NjAgMzYyYzAtMTM3LTExMS0yNDgtMjQ4LTI0OFMyNjQgMjI1IDI2NCAzNjJjMCA4Mi43IDQwLjUgMTU2IDEwMi44IDIwMS4xLS40LjItLjguMy0xLjIuNS00NC44IDE4LjktODUgNDYtMTE5LjUgODAuNmEzNzUuNjMgMzc1LjYzIDAgMDAtODAuNiAxMTkuNUEzNzEuNyAzNzEuNyAwIDAwMTM2IDkwMS44YTggOCAwIDAwOCA4LjJoNjBjNC40IDAgNy45LTMuNSA4LTcuOCAyLTc3LjIgMzMtMTQ5LjUgODcuOC0yMDQuMyA1Ni43LTU2LjcgMTMyLTg3LjkgMjEyLjItODcuOXMxNTUuNSAzMS4yIDIxMi4yIDg3LjlDNzc5IDc1Mi43IDgxMCA4MjUgODEyIDkwMi4yYy4xIDQuNCAzLjYgNy44IDggNy44aDYwYTggOCAwIDAwOC04LjJjLTEtNDcuOC0xMC45LTk0LjMtMjkuNS0xMzguMnpNNTEyIDUzNGMtNDUuOSAwLTg5LjEtMTcuOS0xMjEuNi01MC40UzM0MCA0MDcuOSAzNDAgMzYyYzAtNDUuOSAxNy45LTg5LjEgNTAuNC0xMjEuNlM0NjYuMSAxOTAgNTEyIDE5MHM4OS4xIDE3LjkgMTIxLjYgNTAuNFM2ODQgMzE2LjEgNjg0IDM2MmMwIDQ1LjktMTcuOSA4OS4xLTUwLjQgMTIxLjZTNTU3LjkgNTM0IDUxMiA1MzR6IiAvPjwvc3ZnPg==) */ var $c3a5f6dca0f6325d$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($c3a5f6dca0f6325d$var$UserOutlined);
var $c3a5f6dca0f6325d$export$2e2bcd8739ae039 = $c3a5f6dca0f6325d$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
function $1e104381209dd9b4$export$78a72ddb39bdd145(initialValue, factory, dependencies = [], fetchOnRender = true) {
    const [value, setValue] = (0, $ltGt3.useState)(initialValue);
    const [isLoading, setLoading] = (0, $ltGt3.useState)(fetchOnRender);
    const [error, setError] = (0, $ltGt3.useState)(null);
    const [reloadToken, setReloadToken] = (0, $ltGt3.useState)(0);
    const reload = (0, $ltGt3.useCallback)(()=>{
        setReloadToken((current)=>current + 1);
    }, [
        setReloadToken
    ]);
    const renderedOnceRef = (0, $ltGt3.useRef)(false);
    (0, $ltGt3.useEffect)(()=>{
        (async ()=>{
            if (!fetchOnRender && !renderedOnceRef.current) {
                renderedOnceRef.current = true;
                return;
            }
            renderedOnceRef.current = true;
            try {
                setLoading(true);
                const newValue = await factory();
                setValue(newValue);
            } catch (e) {
                setError(e);
            } finally{
                setLoading(false);
            }
        })();
    }, [
        ...dependencies || [],
        reloadToken
    ]);
    return {
        value: value,
        isLoading: isLoading,
        error: error,
        reload: reload
    };
}




var $ltGt3 = parcelRequire("ltGt3");
var $4bf604d50b431616$exports = {};

$4bf604d50b431616$exports = (parcelRequire("8oPqs"));


var $c5a54efdf8fca20e$exports = {};

$c5a54efdf8fca20e$exports = (parcelRequire("aNuJT"));


var $4de911ea3c5e8845$exports = {};

!function(e, a) {
    $4de911ea3c5e8845$exports = a((parcelRequire("Ohofd")));
}($4de911ea3c5e8845$exports, function(e) {
    "use strict";
    function a(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = a(e), _ = {
        name: "en-gb",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekStart: 1,
        yearStart: 4,
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        },
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        ordinal: function(e) {
            var a = [
                "th",
                "st",
                "nd",
                "rd"
            ], t = e % 100;
            return "[" + e + (a[(t - 20) % 10] || a[t] || a[0]) + "]";
        }
    };
    return t.default.locale(_, null, !0), _;
});


var $70e304448ffa6654$exports = {};

!function(_, t) {
    $70e304448ffa6654$exports = t((parcelRequire("Ohofd")));
}($70e304448ffa6654$exports, function(_) {
    "use strict";
    function t(_) {
        return _ && "object" == typeof _ && "default" in _ ? _ : {
            default: _
        };
    }
    var e = t(_), n = "\u044F\u043D\u0432\u0430\u0440\u044F_\u0444\u0435\u0432\u0440\u0430\u043B\u044F_\u043C\u0430\u0440\u0442\u0430_\u0430\u043F\u0440\u0435\u043B\u044F_\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F_\u043E\u043A\u0442\u044F\u0431\u0440\u044F_\u043D\u043E\u044F\u0431\u0440\u044F_\u0434\u0435\u043A\u0430\u0431\u0440\u044F".split("_"), s = "\u044F\u043D\u0432\u0430\u0440\u044C_\u0444\u0435\u0432\u0440\u0430\u043B\u044C_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B\u044C_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C_\u043E\u043A\u0442\u044F\u0431\u0440\u044C_\u043D\u043E\u044F\u0431\u0440\u044C_\u0434\u0435\u043A\u0430\u0431\u0440\u044C".split("_"), r = "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440._\u0430\u043F\u0440._\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split("_"), o = "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440\u0442_\u0430\u043F\u0440._\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split("_"), i = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;
    function d(_, t, e) {
        var n, s;
        return "m" === e ? t ? "\u043C\u0438\u043D\u0443\u0442\u0430" : "\u043C\u0438\u043D\u0443\u0442\u0443" : _ + " " + (n = +_, s = ({
            mm: t ? "\u043C\u0438\u043D\u0443\u0442\u0430_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442" : "\u043C\u0438\u043D\u0443\u0442\u0443_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442",
            hh: "\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043E\u0432",
            dd: "\u0434\u0435\u043D\u044C_\u0434\u043D\u044F_\u0434\u043D\u0435\u0439",
            MM: "\u043C\u0435\u0441\u044F\u0446_\u043C\u0435\u0441\u044F\u0446\u0430_\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            yy: "\u0433\u043E\u0434_\u0433\u043E\u0434\u0430_\u043B\u0435\u0442"
        })[e].split("_"), n % 10 == 1 && n % 100 != 11 ? s[0] : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? s[1] : s[2]);
    }
    var u = function(_, t) {
        return i.test(t) ? n[_.month()] : s[_.month()];
    };
    u.s = s, u.f = n;
    var a = function(_, t) {
        return i.test(t) ? r[_.month()] : o[_.month()];
    };
    a.s = o, a.f = r;
    var m = {
        name: "ru",
        weekdays: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043E\u0442\u0430".split("_"),
        weekdaysShort: "\u0432\u0441\u043A_\u043F\u043D\u0434_\u0432\u0442\u0440_\u0441\u0440\u0434_\u0447\u0442\u0432_\u043F\u0442\u043D_\u0441\u0431\u0442".split("_"),
        weekdaysMin: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
        months: u,
        monthsShort: a,
        weekStart: 1,
        yearStart: 4,
        formats: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY \u0433.",
            LLL: "D MMMM YYYY \u0433., H:mm",
            LLLL: "dddd, D MMMM YYYY \u0433., H:mm"
        },
        relativeTime: {
            future: "\u0447\u0435\u0440\u0435\u0437 %s",
            past: "%s \u043D\u0430\u0437\u0430\u0434",
            s: "\u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434",
            m: d,
            mm: d,
            h: "\u0447\u0430\u0441",
            hh: d,
            d: "\u0434\u0435\u043D\u044C",
            dd: d,
            M: "\u043C\u0435\u0441\u044F\u0446",
            MM: d,
            y: "\u0433\u043E\u0434",
            yy: d
        },
        ordinal: function(_) {
            return _;
        },
        meridiem: function(_) {
            return _ < 4 ? "\u043D\u043E\u0447\u0438" : _ < 12 ? "\u0443\u0442\u0440\u0430" : _ < 17 ? "\u0434\u043D\u044F" : "\u0432\u0435\u0447\u0435\u0440\u0430";
        }
    };
    return e.default.locale(m, null, !0), m;
});


const $17695373636e29e1$export$8e1c4644f466949c = {
    en: {
        antd: (0, (/*@__PURE__*/$parcel$interopDefault($4bf604d50b431616$exports))),
        dayjs: 'en-gb'
    },
    ru: {
        antd: (0, (/*@__PURE__*/$parcel$interopDefault($c5a54efdf8fca20e$exports))),
        dayjs: 'ru'
    }
};
const $17695373636e29e1$export$51216bcc3983e55d = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createContext({
    setLocale: ()=>{},
    getLocale: ()=>'en'
});
function $17695373636e29e1$export$3013d29b72c2d37b() {
    const localizationContext = (0, $ltGt3.useContext)($17695373636e29e1$export$51216bcc3983e55d);
    return (newLocale)=>{
        localStorage.setItem('locale', newLocale);
        localizationContext.setLocale(newLocale);
    };
}
function $17695373636e29e1$export$43bb16f9c6d9e3f7() {
    const localizationContext = (0, $ltGt3.useContext)($17695373636e29e1$export$51216bcc3983e55d);
    return localizationContext.getLocale();
}



parcelRequire("ltGt3");

const $80c993b8dfae0759$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("ixUGO"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};


class $907c552e5e595bf3$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class $907c552e5e595bf3$export$14f2b6540d498ce extends $907c552e5e595bf3$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $907c552e5e595bf3$export$d08a45df86040161 extends $907c552e5e595bf3$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $907c552e5e595bf3$export$761f8c0e0fa4624f extends $907c552e5e595bf3$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $907c552e5e595bf3$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($907c552e5e595bf3$export$9b19f1a5abf91e06 || ($907c552e5e595bf3$export$9b19f1a5abf91e06 = {}));


var $fdaae3ad682b2eb6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $fdaae3ad682b2eb6$export$1d0b400bf8a0fa55 {
    constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $907c552e5e595bf3$export$9b19f1a5abf91e06).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $80c993b8dfae0759$export$98d92b1aa79f8cc7)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     */ invoke(functionName, options = {}) {
        var _a;
        return $fdaae3ad682b2eb6$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const { headers: headers, method: method, body: functionArgs } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                if (region && region !== 'any') _headers['x-region'] = region;
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                }
                const response = yield this.fetch(`${this.url}/${functionName}`, {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body
                }).catch((fetchError)=>{
                    throw new (0, $907c552e5e595bf3$export$14f2b6540d498ce)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $907c552e5e595bf3$export$d08a45df86040161)(response);
                if (!response.ok) throw new (0, $907c552e5e595bf3$export$761f8c0e0fa4624f)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                return {
                    data: null,
                    error: error
                };
            }
        });
    }
}


var $5f7a2a82ea9041a0$exports = {};
"use strict";
var $5f7a2a82ea9041a0$var$__importDefault = $5f7a2a82ea9041a0$exports && $5f7a2a82ea9041a0$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($5f7a2a82ea9041a0$exports, "__esModule", {
    value: true
});
$5f7a2a82ea9041a0$exports.PostgrestError = $5f7a2a82ea9041a0$exports.PostgrestBuilder = $5f7a2a82ea9041a0$exports.PostgrestTransformBuilder = $5f7a2a82ea9041a0$exports.PostgrestFilterBuilder = $5f7a2a82ea9041a0$exports.PostgrestQueryBuilder = $5f7a2a82ea9041a0$exports.PostgrestClient = void 0;

// Always update wrapper.mjs when updating this file.
const $5f7a2a82ea9041a0$var$PostgrestClient_1 = $5f7a2a82ea9041a0$var$__importDefault((parcelRequire("aslHJ")));
$5f7a2a82ea9041a0$exports.PostgrestClient = $5f7a2a82ea9041a0$var$PostgrestClient_1.default;

const $5f7a2a82ea9041a0$var$PostgrestQueryBuilder_1 = $5f7a2a82ea9041a0$var$__importDefault((parcelRequire("bjLOO")));
$5f7a2a82ea9041a0$exports.PostgrestQueryBuilder = $5f7a2a82ea9041a0$var$PostgrestQueryBuilder_1.default;

const $5f7a2a82ea9041a0$var$PostgrestFilterBuilder_1 = $5f7a2a82ea9041a0$var$__importDefault((parcelRequire("iQEar")));
$5f7a2a82ea9041a0$exports.PostgrestFilterBuilder = $5f7a2a82ea9041a0$var$PostgrestFilterBuilder_1.default;

const $5f7a2a82ea9041a0$var$PostgrestTransformBuilder_1 = $5f7a2a82ea9041a0$var$__importDefault((parcelRequire("9IjEd")));
$5f7a2a82ea9041a0$exports.PostgrestTransformBuilder = $5f7a2a82ea9041a0$var$PostgrestTransformBuilder_1.default;

const $5f7a2a82ea9041a0$var$PostgrestBuilder_1 = $5f7a2a82ea9041a0$var$__importDefault((parcelRequire("frFkG")));
$5f7a2a82ea9041a0$exports.PostgrestBuilder = $5f7a2a82ea9041a0$var$PostgrestBuilder_1.default;

const $5f7a2a82ea9041a0$var$PostgrestError_1 = $5f7a2a82ea9041a0$var$__importDefault((parcelRequire("ca6un")));
$5f7a2a82ea9041a0$exports.PostgrestError = $5f7a2a82ea9041a0$var$PostgrestError_1.default;
$5f7a2a82ea9041a0$exports.default = {
    PostgrestClient: $5f7a2a82ea9041a0$var$PostgrestClient_1.default,
    PostgrestQueryBuilder: $5f7a2a82ea9041a0$var$PostgrestQueryBuilder_1.default,
    PostgrestFilterBuilder: $5f7a2a82ea9041a0$var$PostgrestFilterBuilder_1.default,
    PostgrestTransformBuilder: $5f7a2a82ea9041a0$var$PostgrestTransformBuilder_1.default,
    PostgrestBuilder: $5f7a2a82ea9041a0$var$PostgrestBuilder_1.default,
    PostgrestError: $5f7a2a82ea9041a0$var$PostgrestError_1.default
};


const { PostgrestClient: $f81529bab7110c2a$export$796f32e2ee984aaa, PostgrestQueryBuilder: $f81529bab7110c2a$export$a81993b50ca081ad, PostgrestFilterBuilder: $f81529bab7110c2a$export$3158317c13bdc93a, PostgrestTransformBuilder: $f81529bab7110c2a$export$7b4361bb87e3030c, PostgrestBuilder: $f81529bab7110c2a$export$3106e21688a06353 } = (0, (/*@__PURE__*/$parcel$interopDefault($5f7a2a82ea9041a0$exports)));
var // compatibility with CJS output
$f81529bab7110c2a$export$2e2bcd8739ae039 = {
    PostgrestClient: $f81529bab7110c2a$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $f81529bab7110c2a$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $f81529bab7110c2a$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $f81529bab7110c2a$export$7b4361bb87e3030c,
    PostgrestBuilder: $f81529bab7110c2a$export$3106e21688a06353
};


const $70ffb0c876147a8a$export$83d89fbfd8236492 = '2.10.9';


const $0f2eb56e3a4f7422$export$88a84136db6a4b64 = {
    'X-Client-Info': `realtime-js/${(0, $70ffb0c876147a8a$export$83d89fbfd8236492)}`
};
const $0f2eb56e3a4f7422$export$df3f558bb9a9c991 = '1.0.0';
const $0f2eb56e3a4f7422$export$7bd623b29ec8e1eb = 10000;
const $0f2eb56e3a4f7422$export$5e80cf62e56a877b = 1000;
var $0f2eb56e3a4f7422$export$a6d0320a1563d49e;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})($0f2eb56e3a4f7422$export$a6d0320a1563d49e || ($0f2eb56e3a4f7422$export$a6d0320a1563d49e = {}));
var $0f2eb56e3a4f7422$export$b83816118db74fe7;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})($0f2eb56e3a4f7422$export$b83816118db74fe7 || ($0f2eb56e3a4f7422$export$b83816118db74fe7 = {}));
var $0f2eb56e3a4f7422$export$8db7548e65d6ea55;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})($0f2eb56e3a4f7422$export$8db7548e65d6ea55 || ($0f2eb56e3a4f7422$export$8db7548e65d6ea55 = {}));
var $0f2eb56e3a4f7422$export$b2688bfb999f5751;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})($0f2eb56e3a4f7422$export$b2688bfb999f5751 || ($0f2eb56e3a4f7422$export$b2688bfb999f5751 = {}));
var $0f2eb56e3a4f7422$export$deda39003d27273;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})($0f2eb56e3a4f7422$export$deda39003d27273 || ($0f2eb56e3a4f7422$export$deda39003d27273 = {}));


// This file draws heavily from https://github.com/phoenixframework/phoenix/commit/cf098e9cf7a44ee6479d31d911a97d3c7430c6fe
// License: https://github.com/phoenixframework/phoenix/blob/master/LICENSE.md
class $870c26e6c605d348$export$2e2bcd8739ae039 {
    constructor(){
        this.HEADER_LENGTH = 1;
    }
    decode(rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this._binaryDecode(rawPayload));
        if (typeof rawPayload === 'string') return callback(JSON.parse(rawPayload));
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const decoder = new TextDecoder();
        return this._decodeBroadcast(buffer, view, decoder);
    }
    _decodeBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        const data = JSON.parse(decoder.decode(buffer.slice(offset, buffer.byteLength)));
        return {
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
}


/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ class $2109b85324f2a797$export$2e2bcd8739ae039 {
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    // Cancels any previous scheduleTimeout and schedules callback
    scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
}


/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $2543c97c434d499e$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($2543c97c434d499e$export$4d213a7d364021dc || ($2543c97c434d499e$export$4d213a7d364021dc = {}));
const $2543c97c434d499e$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $2543c97c434d499e$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $2543c97c434d499e$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $2543c97c434d499e$export$3df02a362b86a91(colType, value);
    return $2543c97c434d499e$var$noop(value);
};
const $2543c97c434d499e$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $2543c97c434d499e$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $2543c97c434d499e$export$4d213a7d364021dc.bool:
            return $2543c97c434d499e$export$3c2e6d1b7583eee6(value);
        case $2543c97c434d499e$export$4d213a7d364021dc.float4:
        case $2543c97c434d499e$export$4d213a7d364021dc.float8:
        case $2543c97c434d499e$export$4d213a7d364021dc.int2:
        case $2543c97c434d499e$export$4d213a7d364021dc.int4:
        case $2543c97c434d499e$export$4d213a7d364021dc.int8:
        case $2543c97c434d499e$export$4d213a7d364021dc.numeric:
        case $2543c97c434d499e$export$4d213a7d364021dc.oid:
            return $2543c97c434d499e$export$a0a81dc3380ce7d3(value);
        case $2543c97c434d499e$export$4d213a7d364021dc.json:
        case $2543c97c434d499e$export$4d213a7d364021dc.jsonb:
            return $2543c97c434d499e$export$d5b7a8bf56ee1fe2(value);
        case $2543c97c434d499e$export$4d213a7d364021dc.timestamp:
            return $2543c97c434d499e$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $2543c97c434d499e$export$4d213a7d364021dc.abstime:
        case $2543c97c434d499e$export$4d213a7d364021dc.date:
        case $2543c97c434d499e$export$4d213a7d364021dc.daterange:
        case $2543c97c434d499e$export$4d213a7d364021dc.int4range:
        case $2543c97c434d499e$export$4d213a7d364021dc.int8range:
        case $2543c97c434d499e$export$4d213a7d364021dc.money:
        case $2543c97c434d499e$export$4d213a7d364021dc.reltime:
        case $2543c97c434d499e$export$4d213a7d364021dc.text:
        case $2543c97c434d499e$export$4d213a7d364021dc.time:
        case $2543c97c434d499e$export$4d213a7d364021dc.timestamptz:
        case $2543c97c434d499e$export$4d213a7d364021dc.timetz:
        case $2543c97c434d499e$export$4d213a7d364021dc.tsrange:
        case $2543c97c434d499e$export$4d213a7d364021dc.tstzrange:
            return $2543c97c434d499e$var$noop(value);
        default:
            // Return the value for remaining types
            return $2543c97c434d499e$var$noop(value);
    }
};
const $2543c97c434d499e$var$noop = (value)=>{
    return value;
};
const $2543c97c434d499e$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $2543c97c434d499e$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $2543c97c434d499e$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON parse error: ${error}`);
        return value;
    }
    return value;
};
const $2543c97c434d499e$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$2543c97c434d499e$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $2543c97c434d499e$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $2543c97c434d499e$export$976fda7151b30cae = (socketUrl)=>{
    let url = socketUrl;
    url = url.replace(/^ws/i, 'http');
    url = url.replace(/(\/socket\/websocket|\/socket|\/websocket)\/?$/i, '');
    return url.replace(/\/+$/, '');
};




class $5e605c4aa8e0840f$export$2e2bcd8739ae039 {
    /**
     * Initializes the Push
     *
     * @param channel The Channel
     * @param event The event, for example `"phx_join"`
     * @param payload The payload, for example `{user_id: 123}`
     * @param timeout The push timeout in milliseconds
     */ constructor(channel, event, payload = {}, timeout = (0, $0f2eb56e3a4f7422$export$7bd623b29ec8e1eb)){
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = '';
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
    }
    resend(timeout) {
        this.timeout = timeout;
        this._cancelRefEvent();
        this.ref = '';
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
    }
    send() {
        if (this._hasReceived('timeout')) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload,
            ref: this.ref,
            join_ref: this.channel._joinRef()
        });
    }
    updatePayload(payload) {
        this.payload = Object.assign(Object.assign({}, this.payload), payload);
    }
    receive(status, callback) {
        var _a;
        if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    startTimeout() {
        if (this.timeoutTimer) return;
        this.ref = this.channel.socket._makeRef();
        this.refEvent = this.channel._replyEventName(this.ref);
        const callback = (payload)=>{
            this._cancelRefEvent();
            this._cancelTimeout();
            this.receivedResp = payload;
            this._matchReceive(payload);
        };
        this.channel._on(this.refEvent, {}, callback);
        this.timeoutTimer = setTimeout(()=>{
            this.trigger('timeout', {});
        }, this.timeout);
    }
    trigger(status, response) {
        if (this.refEvent) this.channel._trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
    destroy() {
        this._cancelRefEvent();
        this._cancelTimeout();
    }
    _cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel._off(this.refEvent, {});
    }
    _cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = undefined;
    }
    _matchReceive({ status: status, response: response }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    _hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
}



/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ var $81ee282306d6d76d$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($81ee282306d6d76d$export$f1ce049df2794fb4 || ($81ee282306d6d76d$export$f1ce049df2794fb4 = {}));
class $81ee282306d6d76d$export$2e2bcd8739ae039 {
    /**
     * Initializes the Presence.
     *
     * @param channel - The RealtimeChannel
     * @param opts - The options,
     *        for example `{events: {state: 'state', diff: 'diff'}}`
     */ constructor(channel, opts){
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.caller = {
            onJoin: ()=>{},
            onLeave: ()=>{},
            onSync: ()=>{}
        };
        const events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: 'presence_state',
            diff: 'presence_diff'
        };
        this.channel._on(events.state, {}, (newState)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel._joinRef();
            this.state = $81ee282306d6d76d$export$2e2bcd8739ae039.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = $81ee282306d6d76d$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, (diff)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = $81ee282306d6d76d$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin((key, currentPresences, newPresences)=>{
            this.channel._trigger('presence', {
                event: 'join',
                key: key,
                currentPresences: currentPresences,
                newPresences: newPresences
            });
        });
        this.onLeave((key, currentPresences, leftPresences)=>{
            this.channel._trigger('presence', {
                event: 'leave',
                key: key,
                currentPresences: currentPresences,
                leftPresences: leftPresences
            });
        });
        this.onSync(()=>{
            this.channel._trigger('presence', {
                event: 'sync'
            });
        });
    }
    /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ static syncState(currentState, newState, onJoin, onLeave) {
        const state = this.cloneDeep(currentState);
        const transformedState = this.transformState(newState);
        const joins = {};
        const leaves = {};
        this.map(state, (key, presences)=>{
            if (!transformedState[key]) leaves[key] = presences;
        });
        this.map(transformedState, (key, newPresences)=>{
            const currentPresences = state[key];
            if (currentPresences) {
                const newPresenceRefs = newPresences.map((m)=>m.presence_ref);
                const curPresenceRefs = currentPresences.map((m)=>m.presence_ref);
                const joinedPresences = newPresences.filter((m)=>curPresenceRefs.indexOf(m.presence_ref) < 0);
                const leftPresences = currentPresences.filter((m)=>newPresenceRefs.indexOf(m.presence_ref) < 0);
                if (joinedPresences.length > 0) joins[key] = joinedPresences;
                if (leftPresences.length > 0) leaves[key] = leftPresences;
            } else joins[key] = newPresences;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ static syncDiff(state, diff, onJoin, onLeave) {
        const { joins: joins, leaves: leaves } = {
            joins: this.transformState(diff.joins),
            leaves: this.transformState(diff.leaves)
        };
        if (!onJoin) onJoin = ()=>{};
        if (!onLeave) onLeave = ()=>{};
        this.map(joins, (key, newPresences)=>{
            var _a;
            const currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
            state[key] = this.cloneDeep(newPresences);
            if (currentPresences.length > 0) {
                const joinedPresenceRefs = state[key].map((m)=>m.presence_ref);
                const curPresences = currentPresences.filter((m)=>joinedPresenceRefs.indexOf(m.presence_ref) < 0);
                state[key].unshift(...curPresences);
            }
            onJoin(key, currentPresences, newPresences);
        });
        this.map(leaves, (key, leftPresences)=>{
            let currentPresences = state[key];
            if (!currentPresences) return;
            const presenceRefsToRemove = leftPresences.map((m)=>m.presence_ref);
            currentPresences = currentPresences.filter((m)=>presenceRefsToRemove.indexOf(m.presence_ref) < 0);
            state[key] = currentPresences;
            onLeave(key, currentPresences, leftPresences);
            if (currentPresences.length === 0) delete state[key];
        });
        return state;
    }
    /** @internal */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ static transformState(state) {
        state = this.cloneDeep(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            if ('metas' in presences) newState[key] = presences.metas.map((presence)=>{
                presence['presence_ref'] = presence['phx_ref'];
                delete presence['phx_ref'];
                delete presence['phx_ref_prev'];
                return presence;
            });
            else newState[key] = presences;
            return newState;
        }, {});
    }
    /** @internal */ static cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /** @internal */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /** @internal */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /** @internal */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /** @internal */ inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel._joinRef();
    }
}



var $1e05442bbcf9446b$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($1e05442bbcf9446b$export$bc171c571098b6c4 || ($1e05442bbcf9446b$export$bc171c571098b6c4 = {}));
var $1e05442bbcf9446b$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($1e05442bbcf9446b$export$9e3fe8e487ef792e || ($1e05442bbcf9446b$export$9e3fe8e487ef792e = {}));
var $1e05442bbcf9446b$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($1e05442bbcf9446b$export$a6885b926af646a2 || ($1e05442bbcf9446b$export$a6885b926af646a2 = {}));
const $1e05442bbcf9446b$export$154db638d9c0559e = (0, $0f2eb56e3a4f7422$export$b83816118db74fe7);
class $1e05442bbcf9446b$export$2e2bcd8739ae039 {
    constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, $0f2eb56e3a4f7422$export$b83816118db74fe7).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: ''
            },
            private: false
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, $5e605c4aa8e0840f$export$2e2bcd8739ae039)(this, (0, $0f2eb56e3a4f7422$export$8db7548e65d6ea55).join, this.params, this.timeout);
        this.rejoinTimer = new (0, $2109b85324f2a797$export$2e2bcd8739ae039)(()=>this._rejoinUntilConnected(), this.socket.reconnectAfterMs);
        this.joinPush.receive('ok', ()=>{
            this.state = (0, $0f2eb56e3a4f7422$export$b83816118db74fe7).joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this._onClose(()=>{
            this.rejoinTimer.reset();
            this.socket.log('channel', `close ${this.topic} ${this._joinRef()}`);
            this.state = (0, $0f2eb56e3a4f7422$export$b83816118db74fe7).closed;
            this.socket._remove(this);
        });
        this._onError((reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log('channel', `error ${this.topic}`, reason);
            this.state = (0, $0f2eb56e3a4f7422$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('timeout', ()=>{
            if (!this._isJoining()) return;
            this.socket.log('channel', `timeout ${this.topic}`, this.joinPush.timeout);
            this.state = (0, $0f2eb56e3a4f7422$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, $0f2eb56e3a4f7422$export$8db7548e65d6ea55).reply, {}, (payload, ref)=>{
            this._trigger(this._replyEventName(ref), payload);
        });
        this.presence = new (0, $81ee282306d6d76d$export$2e2bcd8739ae039)(this);
        this.broadcastEndpointURL = (0, $2543c97c434d499e$export$976fda7151b30cae)(this.socket.endPoint) + '/api/broadcast';
        this.private = this.params.config.private || false;
    }
    /** Subscribe registers your client with the server */ subscribe(callback, timeout = this.timeout) {
        var _a, _b;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.joinedOnce) throw `tried to subscribe multiple times. 'subscribe' can only be called a single time per channel instance`;
        else {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            this._onError((e)=>callback && callback('CHANNEL_ERROR', e));
            this._onClose(()=>callback && callback('CLOSED'));
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: presence,
                postgres_changes: (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [],
                private: isPrivate
            };
            if (this.socket.accessToken) accessTokenPayload.access_token = this.socket.accessToken;
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this.joinedOnce = true;
            this._rejoin(timeout);
            this.joinPush.receive('ok', ({ postgres_changes: serverPostgresFilters })=>{
                var _a;
                this.socket.accessToken && this.socket.setAuth(this.socket.accessToken);
                if (serverPostgresFilters === undefined) {
                    callback && callback('SUBSCRIBED');
                    return;
                } else {
                    const clientPostgresBindings = this.bindings.postgres_changes;
                    const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                    const newPostgresBindings = [];
                    for(let i = 0; i < bindingsLen; i++){
                        const clientPostgresBinding = clientPostgresBindings[i];
                        const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
                        const serverPostgresFilter = serverPostgresFilters && serverPostgresFilters[i];
                        if (serverPostgresFilter && serverPostgresFilter.event === event && serverPostgresFilter.schema === schema && serverPostgresFilter.table === table && serverPostgresFilter.filter === filter) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                            id: serverPostgresFilter.id
                        }));
                        else {
                            this.unsubscribe();
                            callback && callback('CHANNEL_ERROR', new Error('mismatch between server and client bindings for postgres changes'));
                            return;
                        }
                    }
                    this.bindings.postgres_changes = newPostgresBindings;
                    callback && callback('SUBSCRIBED');
                    return;
                }
            }).receive('error', (error)=>{
                callback && callback('CHANNEL_ERROR', new Error(JSON.stringify(Object.values(error).join(', ') || 'error')));
                return;
            }).receive('timeout', ()=>{
                callback && callback('TIMED_OUT');
                return;
            });
        }
        return this;
    }
    presenceState() {
        return this.presence.state;
    }
    async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts.timeout || this.timeout);
    }
    async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    on(type, filter, callback) {
        return this._on(type, filter, callback);
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this._canPush() && args.type === 'broadcast') {
            const { event: event, payload: endpoint_payload } = args;
            const options = {
                method: 'POST',
                headers: {
                    Authorization: this.socket.accessToken ? `Bearer ${this.socket.accessToken}` : '',
                    apikey: this.socket.apiKey ? this.socket.apiKey : '',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this._push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    updateJoinPayload(payload) {
        this.joinPush.updatePayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ unsubscribe(timeout = this.timeout) {
        this.state = (0, $0f2eb56e3a4f7422$export$b83816118db74fe7).leaving;
        const onClose = ()=>{
            this.socket.log('channel', `leave ${this.topic}`);
            this._trigger((0, $0f2eb56e3a4f7422$export$8db7548e65d6ea55).close, 'leave', this._joinRef());
        };
        this.rejoinTimer.reset();
        // Destroy joinPush to avoid connection timeouts during unscription phase
        this.joinPush.destroy();
        return new Promise((resolve)=>{
            const leavePush = new (0, $5e605c4aa8e0840f$export$2e2bcd8739ae039)(this, (0, $0f2eb56e3a4f7422$export$8db7548e65d6ea55).leave, {}, timeout);
            leavePush.receive('ok', ()=>{
                onClose();
                resolve('ok');
            }).receive('timeout', ()=>{
                onClose();
                resolve('timed out');
            }).receive('error', ()=>{
                resolve('error');
            });
            leavePush.send();
            if (!this._canPush()) leavePush.trigger('ok', {});
        });
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _push(event, payload, timeout = this.timeout) {
        if (!this.joinedOnce) throw `tried to push '${event}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
        let pushEvent = new (0, $5e605c4aa8e0840f$export$2e2bcd8739ae039)(this, event, payload, timeout);
        if (this._canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ _onMessage(_event, payload, _ref) {
        return payload;
    }
    /** @internal */ _isMember(topic) {
        return this.topic === topic;
    }
    /** @internal */ _joinRef() {
        return this.joinPush.ref;
    }
    /** @internal */ _trigger(type, payload, ref) {
        var _a, _b;
        const typeLower = type.toLocaleLowerCase();
        const { close: close, error: error, leave: leave, join: join } = (0, $0f2eb56e3a4f7422$export$8db7548e65d6ea55);
        const events = [
            close,
            error,
            leave,
            join
        ];
        if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
        let handledPayload = this._onMessage(typeLower, payload, ref);
        if (payload && !handledPayload) throw 'channel onMessage callbacks must return the payload, modified or unmodified';
        if ([
            'insert',
            'update',
            'delete'
        ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter((bind)=>{
            var _a, _b, _c;
            return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === '*' || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
        }).map((bind)=>bind.callback(handledPayload, ref));
        else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter((bind)=>{
            var _a, _b, _c, _d, _e, _f;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                    return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        }).map((bind)=>{
            if (typeof handledPayload === 'object' && 'ids' in handledPayload) {
                const postgresChanges = handledPayload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                handledPayload = Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            bind.callback(handledPayload, ref);
        });
    }
    /** @internal */ _isClosed() {
        return this.state === (0, $0f2eb56e3a4f7422$export$b83816118db74fe7).closed;
    }
    /** @internal */ _isJoined() {
        return this.state === (0, $0f2eb56e3a4f7422$export$b83816118db74fe7).joined;
    }
    /** @internal */ _isJoining() {
        return this.state === (0, $0f2eb56e3a4f7422$export$b83816118db74fe7).joining;
    }
    /** @internal */ _isLeaving() {
        return this.state === (0, $0f2eb56e3a4f7422$export$b83816118db74fe7).leaving;
    }
    /** @internal */ _replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        return this;
    }
    /** @internal */ _off(type, filter) {
        const typeLower = type.toLocaleLowerCase();
        this.bindings[typeLower] = this.bindings[typeLower].filter((bind)=>{
            var _a;
            return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && $1e05442bbcf9446b$export$2e2bcd8739ae039.isEqual(bind.filter, filter));
        });
        return this;
    }
    /** @internal */ static isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for(const k in obj1){
            if (obj1[k] !== obj2[k]) return false;
        }
        return true;
    }
    /** @internal */ _rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) this._rejoin();
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this._on((0, $0f2eb56e3a4f7422$export$8db7548e65d6ea55).close, {}, callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this._on((0, $0f2eb56e3a4f7422$export$8db7548e65d6ea55).error, {}, (reason)=>callback(reason));
    }
    /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ _canPush() {
        return this.socket.isConnected() && this._isJoined();
    }
    /** @internal */ _rejoin(timeout = this.timeout) {
        if (this._isLeaving()) return;
        this.socket._leaveOpenTopic(this.topic);
        this.state = (0, $0f2eb56e3a4f7422$export$b83816118db74fe7).joining;
        this.joinPush.resend(timeout);
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $2543c97c434d499e$export$20ce708a1f594c5e(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $2543c97c434d499e$export$20ce708a1f594c5e(payload.columns, payload.old_record);
        return records;
    }
}


const $da4299f5ff06d7dc$var$noop = ()=>{};
const $da4299f5ff06d7dc$var$NATIVE_WEBSOCKET_AVAILABLE = typeof WebSocket !== 'undefined';
const $da4299f5ff06d7dc$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;


class $da4299f5ff06d7dc$export$2e2bcd8739ae039 {
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket.
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers The optional headers to pass when connecting.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     */ constructor(endPoint, options){
        var _a;
        this.accessToken = null;
        this.apiKey = null;
        this.channels = [];
        this.endPoint = '';
        this.httpEndpoint = '';
        this.headers = (0, $0f2eb56e3a4f7422$export$88a84136db6a4b64);
        this.params = {};
        this.timeout = (0, $0f2eb56e3a4f7422$export$7bd623b29ec8e1eb);
        this.heartbeatIntervalMs = 30000;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.ref = 0;
        this.logger = $da4299f5ff06d7dc$var$noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, $870c26e6c605d348$export$2e2bcd8739ae039)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            let _fetch;
            if (customFetch) _fetch = customFetch;
            else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("ixUGO"))).then(({ default: fetch1 })=>fetch1(...args));
            else _fetch = fetch;
            return (...args)=>_fetch(...args);
        };
        this.endPoint = `${endPoint}/${(0, $0f2eb56e3a4f7422$export$b2688bfb999f5751).websocket}`;
        this.httpEndpoint = (0, $2543c97c434d499e$export$976fda7151b30cae)(endPoint);
        if (options === null || options === void 0 ? void 0 : options.transport) this.transport = options.transport;
        else this.transport = null;
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.headers) this.headers = Object.assign(Object.assign({}, this.headers), options.headers);
        if (options === null || options === void 0 ? void 0 : options.timeout) this.timeout = options.timeout;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if (options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) this.heartbeatIntervalMs = options.heartbeatIntervalMs;
        const accessToken = (_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey;
        if (accessToken) {
            this.accessToken = accessToken;
            this.apiKey = accessToken;
        }
        this.reconnectAfterMs = (options === null || options === void 0 ? void 0 : options.reconnectAfterMs) ? options.reconnectAfterMs : (tries)=>{
            return [
                1000,
                2000,
                5000,
                10000
            ][tries - 1] || 10000;
        };
        this.encode = (options === null || options === void 0 ? void 0 : options.encode) ? options.encode : (payload, callback)=>{
            return callback(JSON.stringify(payload));
        };
        this.decode = (options === null || options === void 0 ? void 0 : options.decode) ? options.decode : this.serializer.decode.bind(this.serializer);
        this.reconnectTimer = new (0, $2109b85324f2a797$export$2e2bcd8739ae039)(async ()=>{
            this.disconnect();
            this.connect();
        }, this.reconnectAfterMs);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
        if (options === null || options === void 0 ? void 0 : options.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.worker = (options === null || options === void 0 ? void 0 : options.worker) || false;
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
        }
    }
    /**
     * Connects the socket, unless already connected.
     */ connect() {
        if (this.conn) return;
        if (this.transport) {
            this.conn = new this.transport(this._endPointURL(), undefined, {
                headers: this.headers
            });
            return;
        }
        if ($da4299f5ff06d7dc$var$NATIVE_WEBSOCKET_AVAILABLE) {
            this.conn = new WebSocket(this._endPointURL());
            this.setupConnection();
            return;
        }
        this.conn = new $da4299f5ff06d7dc$var$WSWebSocketDummy(this._endPointURL(), undefined, {
            close: ()=>{
                this.conn = null;
            }
        });
        (parcelRequire("gL8Hc")).then(({ default: WS })=>{
            this.conn = new WS(this._endPointURL(), undefined, {
                headers: this.headers
            });
            this.setupConnection();
        });
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ disconnect(code, reason) {
        if (this.conn) {
            this.conn.onclose = function() {}; // noop
            if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : '');
            else this.conn.close();
            this.conn = null;
            // remove open handles
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.reconnectTimer.reset();
        }
    }
    /**
     * Returns all created channels
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (this.channels.length === 0) this.disconnect();
        return status;
    }
    /**
     * Unsubscribes and removes all channels
     */ async removeAllChannels() {
        const values_1 = await Promise.all(this.channels.map((channel)=>channel.unsubscribe()));
        this.disconnect();
        return values_1;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case (0, $0f2eb56e3a4f7422$export$a6d0320a1563d49e).connecting:
                return (0, $0f2eb56e3a4f7422$export$deda39003d27273).Connecting;
            case (0, $0f2eb56e3a4f7422$export$a6d0320a1563d49e).open:
                return (0, $0f2eb56e3a4f7422$export$deda39003d27273).Open;
            case (0, $0f2eb56e3a4f7422$export$a6d0320a1563d49e).closing:
                return (0, $0f2eb56e3a4f7422$export$deda39003d27273).Closing;
            default:
                return (0, $0f2eb56e3a4f7422$export$deda39003d27273).Closed;
        }
    }
    /**
     * Returns `true` is the connection is open.
     */ isConnected() {
        return this.connectionState() === (0, $0f2eb56e3a4f7422$export$deda39003d27273).Open;
    }
    channel(topic, params = {
        config: {}
    }) {
        const chan = new (0, $1e05442bbcf9446b$export$2e2bcd8739ae039)(`realtime:${topic}`, params, this);
        this.channels.push(chan);
        return chan;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ push(data) {
        const { topic: topic, event: event, payload: payload, ref: ref } = data;
        const callback = ()=>{
            this.encode(data, (result)=>{
                var _a;
                (_a = this.conn) === null || _a === void 0 || _a.send(result);
            });
        };
        this.log('push', `${topic} ${event} (${ref})`, payload);
        if (this.isConnected()) callback();
        else this.sendBuffer.push(callback);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * @param token A JWT string.
     */ setAuth(token) {
        if (token) {
            let parsed = null;
            try {
                parsed = JSON.parse(atob(token.split('.')[1]));
            } catch (_error) {}
            if (parsed && parsed.exp) {
                let now = Math.floor(Date.now() / 1000);
                let valid = now - parsed.exp < 0;
                if (!valid) {
                    this.log('auth', `InvalidJWTToken: Invalid value for JWT claim "exp" with value ${parsed.exp}`);
                    return;
                }
            }
        }
        this.accessToken = token;
        this.channels.forEach((channel)=>{
            token && channel.updateJoinPayload({
                access_token: token
            });
            if (channel.joinedOnce && channel._isJoined()) channel._push((0, $0f2eb56e3a4f7422$export$8db7548e65d6ea55).access_token, {
                access_token: token
            });
        });
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ _leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c._isJoined() || c._isJoining()));
        if (dupChannel) {
            this.log('transport', `leaving duplicate topic "${topic}"`);
            dupChannel.unsubscribe();
        }
    }
    /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c._joinRef() !== channel._joinRef());
    }
    /**
     * Sets up connection handlers.
     *
     * @internal
     */ setupConnection() {
        if (this.conn) {
            this.conn.binaryType = 'arraybuffer';
            this.conn.onopen = ()=>this._onConnOpen();
            this.conn.onerror = (error)=>this._onConnError(error);
            this.conn.onmessage = (event)=>this._onConnMessage(event);
            this.conn.onclose = (event)=>this._onConnClose(event);
        }
    }
    /**
     * Returns the URL of the websocket.
     *
     * @internal
     */ _endPointURL() {
        return this._appendParams(this.endPoint, Object.assign({}, this.params, {
            vsn: (0, $0f2eb56e3a4f7422$export$df3f558bb9a9c991)
        }));
    }
    /** @internal */ _onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef || event === (payload === null || payload === void 0 ? void 0 : payload.type)) this.pendingHeartbeatRef = null;
            this.log('receive', `${payload.status || ''} ${topic} ${event} ${ref && '(' + ref + ')' || ''}`, payload);
            this.channels.filter((channel)=>channel._isMember(topic)).forEach((channel)=>channel._trigger(event, payload, ref));
            this.stateChangeCallbacks.message.forEach((callback)=>callback(msg));
        });
    }
    /** @internal */ async _onConnOpen() {
        this.log('transport', `connected to ${this._endPointURL()}`);
        this._flushSendBuffer();
        this.reconnectTimer.reset();
        if (!this.worker) {
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.heartbeatTimer = setInterval(()=>this._sendHeartbeat(), this.heartbeatIntervalMs);
        } else {
            if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
            else this.log('worker', `starting default worker`);
            const objectUrl = this._workerObjectUrl(this.workerUrl);
            this.workerRef = new Worker(objectUrl);
            this.workerRef.onerror = (error)=>{
                this.log('worker', 'worker error', error.message);
                this.workerRef.terminate();
            };
            this.workerRef.onmessage = (event)=>{
                if (event.data.event === 'keepAlive') this._sendHeartbeat();
            };
            this.workerRef.postMessage({
                event: 'start',
                interval: this.heartbeatIntervalMs
            });
        }
        this.stateChangeCallbacks.open.forEach((callback)=>callback());
    }
    /** @internal */ _onConnClose(event) {
        this.log('transport', 'close', event);
        this._triggerChanError();
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.reconnectTimer.scheduleTimeout();
        this.stateChangeCallbacks.close.forEach((callback)=>callback(event));
    }
    /** @internal */ _onConnError(error) {
        this.log('transport', error.message);
        this._triggerChanError();
        this.stateChangeCallbacks.error.forEach((callback)=>callback(error));
    }
    /** @internal */ _triggerChanError() {
        this.channels.forEach((channel)=>channel._trigger((0, $0f2eb56e3a4f7422$export$8db7548e65d6ea55).error));
    }
    /** @internal */ _appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        const prefix = url.match(/\?/) ? '&' : '?';
        const query = new URLSearchParams(params);
        return `${url}${prefix}${query}`;
    }
    /** @internal */ _flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /** @internal */ _sendHeartbeat() {
        var _a;
        if (!this.isConnected()) return;
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.log('transport', 'heartbeat timeout. Attempting to re-establish connection');
            (_a = this.conn) === null || _a === void 0 || _a.close((0, $0f2eb56e3a4f7422$export$5e80cf62e56a877b), 'hearbeat timeout');
            return;
        }
        this.pendingHeartbeatRef = this._makeRef();
        this.push({
            topic: 'phoenix',
            event: 'heartbeat',
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        this.setAuth(this.accessToken);
    }
    _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $da4299f5ff06d7dc$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
}
class $da4299f5ff06d7dc$var$WSWebSocketDummy {
    constructor(address, _protocols, options){
        this.binaryType = 'arraybuffer';
        this.onclose = ()=>{};
        this.onerror = ()=>{};
        this.onmessage = ()=>{};
        this.onopen = ()=>{};
        this.readyState = (0, $0f2eb56e3a4f7422$export$a6d0320a1563d49e).connecting;
        this.send = ()=>{};
        this.url = null;
        this.url = address;
        this.close = options.close;
    }
}






class $d007a2eddccb67ed$export$697502632950e9d3 extends Error {
    constructor(message){
        super(message);
        this.__isStorageError = true;
        this.name = 'StorageError';
    }
}
function $d007a2eddccb67ed$export$5a322e77e5eb0561(error) {
    return typeof error === 'object' && error !== null && '__isStorageError' in error;
}
class $d007a2eddccb67ed$export$ca9ecfd959b3871c extends $d007a2eddccb67ed$export$697502632950e9d3 {
    constructor(message, status){
        super(message);
        this.name = 'StorageApiError';
        this.status = status;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
}
class $d007a2eddccb67ed$export$29127ca2e1a271d extends $d007a2eddccb67ed$export$697502632950e9d3 {
    constructor(message, originalError){
        super(message);
        this.name = 'StorageUnknownError';
        this.originalError = originalError;
    }
}



var $6c6303fb88ebc98e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $6c6303fb88ebc98e$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("ixUGO"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};

const $6c6303fb88ebc98e$export$ace1d6afc438cf26 = ()=>$6c6303fb88ebc98e$var$__awaiter(void 0, void 0, void 0, function*() {
        if (typeof Response === 'undefined') // @ts-ignore
        return (yield Promise.resolve((parcelRequire("ixUGO")))).Response;
        return Response;
    });
const $6c6303fb88ebc98e$export$69d519e35e6fc3d4 = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$6c6303fb88ebc98e$export$69d519e35e6fc3d4(el));
    else if (typeof item === 'function' || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ''));
        result[newKey] = $6c6303fb88ebc98e$export$69d519e35e6fc3d4(value);
    });
    return result;
};


var $24f090cab6cd5bfb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $24f090cab6cd5bfb$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $24f090cab6cd5bfb$var$handleError = (error, reject, options)=>$24f090cab6cd5bfb$var$__awaiter(void 0, void 0, void 0, function*() {
        const Res = yield (0, $6c6303fb88ebc98e$export$ace1d6afc438cf26)();
        if (error instanceof Res && !(options === null || options === void 0 ? void 0 : options.noResolveJson)) error.json().then((err)=>{
            reject(new (0, $d007a2eddccb67ed$export$ca9ecfd959b3871c)($24f090cab6cd5bfb$var$_getErrorMessage(err), error.status || 500));
        }).catch((err)=>{
            reject(new (0, $d007a2eddccb67ed$export$29127ca2e1a271d)($24f090cab6cd5bfb$var$_getErrorMessage(err), err));
        });
        else reject(new (0, $d007a2eddccb67ed$export$29127ca2e1a271d)($24f090cab6cd5bfb$var$_getErrorMessage(error), error));
    });
const $24f090cab6cd5bfb$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json'
    }, options === null || options === void 0 ? void 0 : options.headers);
    if (body) params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
function $24f090cab6cd5bfb$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    return $24f090cab6cd5bfb$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            fetcher(url, $24f090cab6cd5bfb$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
                if (!result.ok) throw result;
                if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
                return result.json();
            }).then((data)=>resolve(data)).catch((error)=>$24f090cab6cd5bfb$var$handleError(error, reject, options));
        });
    });
}
function $24f090cab6cd5bfb$export$3988ae62b71be9a3(fetcher, url, options, parameters) {
    return $24f090cab6cd5bfb$var$__awaiter(this, void 0, void 0, function*() {
        return $24f090cab6cd5bfb$var$_handleRequest(fetcher, 'GET', url, options, parameters);
    });
}
function $24f090cab6cd5bfb$export$299ba2dee77727e9(fetcher, url, body, options, parameters) {
    return $24f090cab6cd5bfb$var$__awaiter(this, void 0, void 0, function*() {
        return $24f090cab6cd5bfb$var$_handleRequest(fetcher, 'POST', url, options, parameters, body);
    });
}
function $24f090cab6cd5bfb$export$327f7b26ebf455db(fetcher, url, body, options, parameters) {
    return $24f090cab6cd5bfb$var$__awaiter(this, void 0, void 0, function*() {
        return $24f090cab6cd5bfb$var$_handleRequest(fetcher, 'PUT', url, options, parameters, body);
    });
}
function $24f090cab6cd5bfb$export$5fd5031fecdacec3(fetcher, url, options, parameters) {
    return $24f090cab6cd5bfb$var$__awaiter(this, void 0, void 0, function*() {
        return $24f090cab6cd5bfb$var$_handleRequest(fetcher, 'HEAD', url, Object.assign(Object.assign({}, options), {
            noResolveJson: true
        }), parameters);
    });
}
function $24f090cab6cd5bfb$export$cd7f480d6b8286c3(fetcher, url, body, options, parameters) {
    return $24f090cab6cd5bfb$var$__awaiter(this, void 0, void 0, function*() {
        return $24f090cab6cd5bfb$var$_handleRequest(fetcher, 'DELETE', url, options, parameters, body);
    });
}



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3086b1a00f25d0bc$export$a143d493d941bafc;
var $3086b1a00f25d0bc$export$e4cf37d7f6fb9e0a;
var $3086b1a00f25d0bc$export$f99ded8fe4b79145;
var $3086b1a00f25d0bc$export$599f31c3813fae4d;
'use strict';
var $62c418de6b1c5919$export$a48f0734ac7c2329;
var $62c418de6b1c5919$export$d622b2ad8d90c771;
var $62c418de6b1c5919$export$6100ba28696e12de;
'use strict';
$62c418de6b1c5919$export$a48f0734ac7c2329 = $62c418de6b1c5919$var$byteLength;
$62c418de6b1c5919$export$d622b2ad8d90c771 = $62c418de6b1c5919$var$toByteArray;
$62c418de6b1c5919$export$6100ba28696e12de = $62c418de6b1c5919$var$fromByteArray;
var $62c418de6b1c5919$var$lookup = [];
var $62c418de6b1c5919$var$revLookup = [];
var $62c418de6b1c5919$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $62c418de6b1c5919$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $62c418de6b1c5919$var$i = 0, $62c418de6b1c5919$var$len = $62c418de6b1c5919$var$code.length; $62c418de6b1c5919$var$i < $62c418de6b1c5919$var$len; ++$62c418de6b1c5919$var$i){
    $62c418de6b1c5919$var$lookup[$62c418de6b1c5919$var$i] = $62c418de6b1c5919$var$code[$62c418de6b1c5919$var$i];
    $62c418de6b1c5919$var$revLookup[$62c418de6b1c5919$var$code.charCodeAt($62c418de6b1c5919$var$i)] = $62c418de6b1c5919$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$62c418de6b1c5919$var$revLookup['-'.charCodeAt(0)] = 62;
$62c418de6b1c5919$var$revLookup['_'.charCodeAt(0)] = 63;
function $62c418de6b1c5919$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $62c418de6b1c5919$var$byteLength(b64) {
    var lens = $62c418de6b1c5919$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $62c418de6b1c5919$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $62c418de6b1c5919$var$toByteArray(b64) {
    var tmp;
    var lens = $62c418de6b1c5919$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $62c418de6b1c5919$var$Arr($62c418de6b1c5919$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $62c418de6b1c5919$var$revLookup[b64.charCodeAt(i)] << 18 | $62c418de6b1c5919$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $62c418de6b1c5919$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $62c418de6b1c5919$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $62c418de6b1c5919$var$revLookup[b64.charCodeAt(i)] << 2 | $62c418de6b1c5919$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $62c418de6b1c5919$var$revLookup[b64.charCodeAt(i)] << 10 | $62c418de6b1c5919$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $62c418de6b1c5919$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $62c418de6b1c5919$var$tripletToBase64(num) {
    return $62c418de6b1c5919$var$lookup[num >> 18 & 0x3F] + $62c418de6b1c5919$var$lookup[num >> 12 & 0x3F] + $62c418de6b1c5919$var$lookup[num >> 6 & 0x3F] + $62c418de6b1c5919$var$lookup[num & 0x3F];
}
function $62c418de6b1c5919$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($62c418de6b1c5919$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $62c418de6b1c5919$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($62c418de6b1c5919$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($62c418de6b1c5919$var$lookup[tmp >> 2] + $62c418de6b1c5919$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($62c418de6b1c5919$var$lookup[tmp >> 10] + $62c418de6b1c5919$var$lookup[tmp >> 4 & 0x3F] + $62c418de6b1c5919$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $eaa00c563b5daf01$export$aafa59e2e03f2942;
var $eaa00c563b5daf01$export$68d8715fc104d294;
$eaa00c563b5daf01$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$eaa00c563b5daf01$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $3086b1a00f25d0bc$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$3086b1a00f25d0bc$export$a143d493d941bafc = $3086b1a00f25d0bc$var$Buffer;
$3086b1a00f25d0bc$export$e4cf37d7f6fb9e0a = $3086b1a00f25d0bc$var$SlowBuffer;
$3086b1a00f25d0bc$export$f99ded8fe4b79145 = 50;
const $3086b1a00f25d0bc$var$K_MAX_LENGTH = 0x7fffffff;
$3086b1a00f25d0bc$export$599f31c3813fae4d = $3086b1a00f25d0bc$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $3086b1a00f25d0bc$var$Buffer.TYPED_ARRAY_SUPPORT = $3086b1a00f25d0bc$var$typedArraySupport();
if (!$3086b1a00f25d0bc$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $3086b1a00f25d0bc$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($3086b1a00f25d0bc$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$3086b1a00f25d0bc$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($3086b1a00f25d0bc$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$3086b1a00f25d0bc$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $3086b1a00f25d0bc$var$createBuffer(length) {
    if (length > $3086b1a00f25d0bc$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $3086b1a00f25d0bc$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3086b1a00f25d0bc$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $3086b1a00f25d0bc$var$allocUnsafe(arg);
    }
    return $3086b1a00f25d0bc$var$from(arg, encodingOrOffset, length);
}
$3086b1a00f25d0bc$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $3086b1a00f25d0bc$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $3086b1a00f25d0bc$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $3086b1a00f25d0bc$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($3086b1a00f25d0bc$var$isInstance(value, ArrayBuffer) || value && $3086b1a00f25d0bc$var$isInstance(value.buffer, ArrayBuffer)) return $3086b1a00f25d0bc$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($3086b1a00f25d0bc$var$isInstance(value, SharedArrayBuffer) || value && $3086b1a00f25d0bc$var$isInstance(value.buffer, SharedArrayBuffer))) return $3086b1a00f25d0bc$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $3086b1a00f25d0bc$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $3086b1a00f25d0bc$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $3086b1a00f25d0bc$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3086b1a00f25d0bc$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3086b1a00f25d0bc$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($3086b1a00f25d0bc$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($3086b1a00f25d0bc$var$Buffer, Uint8Array);
function $3086b1a00f25d0bc$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $3086b1a00f25d0bc$var$alloc(size, fill, encoding) {
    $3086b1a00f25d0bc$var$assertSize(size);
    if (size <= 0) return $3086b1a00f25d0bc$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $3086b1a00f25d0bc$var$createBuffer(size).fill(fill, encoding) : $3086b1a00f25d0bc$var$createBuffer(size).fill(fill);
    return $3086b1a00f25d0bc$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3086b1a00f25d0bc$var$Buffer.alloc = function(size, fill, encoding) {
    return $3086b1a00f25d0bc$var$alloc(size, fill, encoding);
};
function $3086b1a00f25d0bc$var$allocUnsafe(size) {
    $3086b1a00f25d0bc$var$assertSize(size);
    return $3086b1a00f25d0bc$var$createBuffer(size < 0 ? 0 : $3086b1a00f25d0bc$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3086b1a00f25d0bc$var$Buffer.allocUnsafe = function(size) {
    return $3086b1a00f25d0bc$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3086b1a00f25d0bc$var$Buffer.allocUnsafeSlow = function(size) {
    return $3086b1a00f25d0bc$var$allocUnsafe(size);
};
function $3086b1a00f25d0bc$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$3086b1a00f25d0bc$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $3086b1a00f25d0bc$var$byteLength(string, encoding) | 0;
    let buf = $3086b1a00f25d0bc$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $3086b1a00f25d0bc$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $3086b1a00f25d0bc$var$checked(array.length) | 0;
    const buf = $3086b1a00f25d0bc$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $3086b1a00f25d0bc$var$fromArrayView(arrayView) {
    if ($3086b1a00f25d0bc$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $3086b1a00f25d0bc$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $3086b1a00f25d0bc$var$fromArrayLike(arrayView);
}
function $3086b1a00f25d0bc$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $3086b1a00f25d0bc$var$Buffer.prototype);
    return buf;
}
function $3086b1a00f25d0bc$var$fromObject(obj) {
    if ($3086b1a00f25d0bc$var$Buffer.isBuffer(obj)) {
        const len = $3086b1a00f25d0bc$var$checked(obj.length) | 0;
        const buf = $3086b1a00f25d0bc$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $3086b1a00f25d0bc$var$numberIsNaN(obj.length)) return $3086b1a00f25d0bc$var$createBuffer(0);
        return $3086b1a00f25d0bc$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $3086b1a00f25d0bc$var$fromArrayLike(obj.data);
}
function $3086b1a00f25d0bc$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3086b1a00f25d0bc$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3086b1a00f25d0bc$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $3086b1a00f25d0bc$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3086b1a00f25d0bc$var$Buffer.alloc(+length);
}
$3086b1a00f25d0bc$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $3086b1a00f25d0bc$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$3086b1a00f25d0bc$var$Buffer.compare = function compare(a, b) {
    if ($3086b1a00f25d0bc$var$isInstance(a, Uint8Array)) a = $3086b1a00f25d0bc$var$Buffer.from(a, a.offset, a.byteLength);
    if ($3086b1a00f25d0bc$var$isInstance(b, Uint8Array)) b = $3086b1a00f25d0bc$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$3086b1a00f25d0bc$var$Buffer.isBuffer(a) || !$3086b1a00f25d0bc$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3086b1a00f25d0bc$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$3086b1a00f25d0bc$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3086b1a00f25d0bc$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $3086b1a00f25d0bc$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($3086b1a00f25d0bc$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$3086b1a00f25d0bc$var$Buffer.isBuffer(buf)) buf = $3086b1a00f25d0bc$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$3086b1a00f25d0bc$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3086b1a00f25d0bc$var$byteLength(string, encoding) {
    if ($3086b1a00f25d0bc$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $3086b1a00f25d0bc$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $3086b1a00f25d0bc$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $3086b1a00f25d0bc$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $3086b1a00f25d0bc$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3086b1a00f25d0bc$var$Buffer.byteLength = $3086b1a00f25d0bc$var$byteLength;
function $3086b1a00f25d0bc$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $3086b1a00f25d0bc$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $3086b1a00f25d0bc$var$utf8Slice(this, start, end);
        case 'ascii':
            return $3086b1a00f25d0bc$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $3086b1a00f25d0bc$var$latin1Slice(this, start, end);
        case 'base64':
            return $3086b1a00f25d0bc$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3086b1a00f25d0bc$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$3086b1a00f25d0bc$var$Buffer.prototype._isBuffer = true;
function $3086b1a00f25d0bc$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3086b1a00f25d0bc$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$3086b1a00f25d0bc$var$swap(this, i, i + 1);
    return this;
};
$3086b1a00f25d0bc$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $3086b1a00f25d0bc$var$swap(this, i, i + 3);
        $3086b1a00f25d0bc$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3086b1a00f25d0bc$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $3086b1a00f25d0bc$var$swap(this, i, i + 7);
        $3086b1a00f25d0bc$var$swap(this, i + 1, i + 6);
        $3086b1a00f25d0bc$var$swap(this, i + 2, i + 5);
        $3086b1a00f25d0bc$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3086b1a00f25d0bc$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $3086b1a00f25d0bc$var$utf8Slice(this, 0, length);
    return $3086b1a00f25d0bc$var$slowToString.apply(this, arguments);
};
$3086b1a00f25d0bc$var$Buffer.prototype.toLocaleString = $3086b1a00f25d0bc$var$Buffer.prototype.toString;
$3086b1a00f25d0bc$var$Buffer.prototype.equals = function equals(b) {
    if (!$3086b1a00f25d0bc$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $3086b1a00f25d0bc$var$Buffer.compare(this, b) === 0;
};
$3086b1a00f25d0bc$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $3086b1a00f25d0bc$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($3086b1a00f25d0bc$var$customInspectSymbol) $3086b1a00f25d0bc$var$Buffer.prototype[$3086b1a00f25d0bc$var$customInspectSymbol] = $3086b1a00f25d0bc$var$Buffer.prototype.inspect;
$3086b1a00f25d0bc$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($3086b1a00f25d0bc$var$isInstance(target, Uint8Array)) target = $3086b1a00f25d0bc$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$3086b1a00f25d0bc$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3086b1a00f25d0bc$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($3086b1a00f25d0bc$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $3086b1a00f25d0bc$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3086b1a00f25d0bc$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3086b1a00f25d0bc$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3086b1a00f25d0bc$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $3086b1a00f25d0bc$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3086b1a00f25d0bc$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3086b1a00f25d0bc$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3086b1a00f25d0bc$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3086b1a00f25d0bc$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3086b1a00f25d0bc$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3086b1a00f25d0bc$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($3086b1a00f25d0bc$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3086b1a00f25d0bc$var$utf8Write(buf, string, offset, length) {
    return $3086b1a00f25d0bc$var$blitBuffer($3086b1a00f25d0bc$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3086b1a00f25d0bc$var$asciiWrite(buf, string, offset, length) {
    return $3086b1a00f25d0bc$var$blitBuffer($3086b1a00f25d0bc$var$asciiToBytes(string), buf, offset, length);
}
function $3086b1a00f25d0bc$var$base64Write(buf, string, offset, length) {
    return $3086b1a00f25d0bc$var$blitBuffer($3086b1a00f25d0bc$var$base64ToBytes(string), buf, offset, length);
}
function $3086b1a00f25d0bc$var$ucs2Write(buf, string, offset, length) {
    return $3086b1a00f25d0bc$var$blitBuffer($3086b1a00f25d0bc$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3086b1a00f25d0bc$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $3086b1a00f25d0bc$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $3086b1a00f25d0bc$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $3086b1a00f25d0bc$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $3086b1a00f25d0bc$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3086b1a00f25d0bc$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3086b1a00f25d0bc$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3086b1a00f25d0bc$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $62c418de6b1c5919$export$6100ba28696e12de(buf);
    else return $62c418de6b1c5919$export$6100ba28696e12de(buf.slice(start, end));
}
function $3086b1a00f25d0bc$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3086b1a00f25d0bc$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $3086b1a00f25d0bc$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3086b1a00f25d0bc$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $3086b1a00f25d0bc$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3086b1a00f25d0bc$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3086b1a00f25d0bc$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3086b1a00f25d0bc$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3086b1a00f25d0bc$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $3086b1a00f25d0bc$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $3086b1a00f25d0bc$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3086b1a00f25d0bc$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $3086b1a00f25d0bc$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3086b1a00f25d0bc$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$3086b1a00f25d0bc$var$Buffer.prototype.readUintLE = $3086b1a00f25d0bc$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3086b1a00f25d0bc$var$Buffer.prototype.readUintBE = $3086b1a00f25d0bc$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3086b1a00f25d0bc$var$Buffer.prototype.readUint8 = $3086b1a00f25d0bc$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3086b1a00f25d0bc$var$Buffer.prototype.readUint16LE = $3086b1a00f25d0bc$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3086b1a00f25d0bc$var$Buffer.prototype.readUint16BE = $3086b1a00f25d0bc$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3086b1a00f25d0bc$var$Buffer.prototype.readUint32LE = $3086b1a00f25d0bc$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3086b1a00f25d0bc$var$Buffer.prototype.readUint32BE = $3086b1a00f25d0bc$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3086b1a00f25d0bc$var$Buffer.prototype.readBigUInt64LE = $3086b1a00f25d0bc$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $3086b1a00f25d0bc$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3086b1a00f25d0bc$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$3086b1a00f25d0bc$var$Buffer.prototype.readBigUInt64BE = $3086b1a00f25d0bc$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $3086b1a00f25d0bc$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3086b1a00f25d0bc$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$3086b1a00f25d0bc$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3086b1a00f25d0bc$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3086b1a00f25d0bc$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3086b1a00f25d0bc$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3086b1a00f25d0bc$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3086b1a00f25d0bc$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3086b1a00f25d0bc$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3086b1a00f25d0bc$var$Buffer.prototype.readBigInt64LE = $3086b1a00f25d0bc$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $3086b1a00f25d0bc$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3086b1a00f25d0bc$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$3086b1a00f25d0bc$var$Buffer.prototype.readBigInt64BE = $3086b1a00f25d0bc$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $3086b1a00f25d0bc$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3086b1a00f25d0bc$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$3086b1a00f25d0bc$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 4, this.length);
    return $eaa00c563b5daf01$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$3086b1a00f25d0bc$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 4, this.length);
    return $eaa00c563b5daf01$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$3086b1a00f25d0bc$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 8, this.length);
    return $eaa00c563b5daf01$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$3086b1a00f25d0bc$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkOffset(offset, 8, this.length);
    return $eaa00c563b5daf01$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $3086b1a00f25d0bc$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3086b1a00f25d0bc$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$3086b1a00f25d0bc$var$Buffer.prototype.writeUintLE = $3086b1a00f25d0bc$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3086b1a00f25d0bc$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeUintBE = $3086b1a00f25d0bc$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3086b1a00f25d0bc$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeUint8 = $3086b1a00f25d0bc$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeUint16LE = $3086b1a00f25d0bc$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeUint16BE = $3086b1a00f25d0bc$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeUint32LE = $3086b1a00f25d0bc$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeUint32BE = $3086b1a00f25d0bc$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $3086b1a00f25d0bc$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $3086b1a00f25d0bc$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $3086b1a00f25d0bc$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $3086b1a00f25d0bc$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$3086b1a00f25d0bc$var$Buffer.prototype.writeBigUInt64LE = $3086b1a00f25d0bc$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $3086b1a00f25d0bc$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3086b1a00f25d0bc$var$Buffer.prototype.writeBigUInt64BE = $3086b1a00f25d0bc$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $3086b1a00f25d0bc$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3086b1a00f25d0bc$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3086b1a00f25d0bc$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3086b1a00f25d0bc$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeBigInt64LE = $3086b1a00f25d0bc$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $3086b1a00f25d0bc$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$3086b1a00f25d0bc$var$Buffer.prototype.writeBigInt64BE = $3086b1a00f25d0bc$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $3086b1a00f25d0bc$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $3086b1a00f25d0bc$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $3086b1a00f25d0bc$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $eaa00c563b5daf01$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3086b1a00f25d0bc$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3086b1a00f25d0bc$var$writeFloat(this, value, offset, true, noAssert);
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3086b1a00f25d0bc$var$writeFloat(this, value, offset, false, noAssert);
};
function $3086b1a00f25d0bc$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3086b1a00f25d0bc$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $eaa00c563b5daf01$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3086b1a00f25d0bc$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3086b1a00f25d0bc$var$writeDouble(this, value, offset, true, noAssert);
};
$3086b1a00f25d0bc$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3086b1a00f25d0bc$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3086b1a00f25d0bc$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$3086b1a00f25d0bc$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3086b1a00f25d0bc$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$3086b1a00f25d0bc$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $3086b1a00f25d0bc$var$Buffer.isBuffer(val) ? val : $3086b1a00f25d0bc$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $3086b1a00f25d0bc$var$errors = {};
function $3086b1a00f25d0bc$var$E(sym, getMessage, Base) {
    $3086b1a00f25d0bc$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$3086b1a00f25d0bc$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$3086b1a00f25d0bc$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$3086b1a00f25d0bc$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $3086b1a00f25d0bc$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $3086b1a00f25d0bc$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $3086b1a00f25d0bc$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $3086b1a00f25d0bc$var$checkBounds(buf, offset, byteLength) {
    $3086b1a00f25d0bc$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $3086b1a00f25d0bc$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $3086b1a00f25d0bc$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $3086b1a00f25d0bc$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $3086b1a00f25d0bc$var$checkBounds(buf, offset, byteLength);
}
function $3086b1a00f25d0bc$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $3086b1a00f25d0bc$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $3086b1a00f25d0bc$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $3086b1a00f25d0bc$var$validateNumber(value, type);
        throw new $3086b1a00f25d0bc$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $3086b1a00f25d0bc$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $3086b1a00f25d0bc$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $3086b1a00f25d0bc$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $3086b1a00f25d0bc$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($3086b1a00f25d0bc$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $3086b1a00f25d0bc$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $3086b1a00f25d0bc$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3086b1a00f25d0bc$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3086b1a00f25d0bc$var$base64ToBytes(str) {
    return $62c418de6b1c5919$export$d622b2ad8d90c771($3086b1a00f25d0bc$var$base64clean(str));
}
function $3086b1a00f25d0bc$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $3086b1a00f25d0bc$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $3086b1a00f25d0bc$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $3086b1a00f25d0bc$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $3086b1a00f25d0bc$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $3086b1a00f25d0bc$var$BufferBigIntNotDefined : fn;
}
function $3086b1a00f25d0bc$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $7b5430a64999b067$require$Buffer = $3086b1a00f25d0bc$export$a143d493d941bafc;
var $7b5430a64999b067$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $7b5430a64999b067$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: 'name',
        order: 'asc'
    }
};
const $7b5430a64999b067$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: '3600',
    contentType: 'text/plain;charset=UTF-8',
    upsert: false
};
class $7b5430a64999b067$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, bucketId, fetch){
        this.url = url;
        this.headers = headers;
        this.bucketId = bucketId;
        this.fetch = (0, $6c6303fb88ebc98e$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
     *
     * @param method HTTP method.
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadOrUpdate(method, path, fileBody, fileOptions) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let body;
                const options = Object.assign(Object.assign({}, $7b5430a64999b067$var$DEFAULT_FILE_OPTIONS), fileOptions);
                let headers = Object.assign(Object.assign({}, this.headers), method === 'POST' && {
                    'x-upsert': String(options.upsert)
                });
                const metadata = options.metadata;
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                    if (metadata) headers['x-metadata'] = this.toBase64(this.encodeMetadata(metadata));
                }
                if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) headers = Object.assign(Object.assign({}, headers), fileOptions.headers);
                const cleanPath = this._removeEmptyFolders(path);
                const _path = this._getFinalPath(cleanPath);
                const res = yield this.fetch(`${this.url}/object/${_path}`, Object.assign({
                    method: method,
                    body: body,
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}));
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        id: data.Id,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ upload(path, fileBody, fileOptions) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('POST', path, fileBody, fileOptions);
        });
    }
    /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadToSignedUrl(path, token, fileBody, fileOptions) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            const cleanPath = this._removeEmptyFolders(path);
            const _path = this._getFinalPath(cleanPath);
            const url = new URL(this.url + `/object/upload/sign/${_path}`);
            url.searchParams.set('token', token);
            try {
                let body;
                const options = Object.assign({
                    upsert: $7b5430a64999b067$var$DEFAULT_FILE_OPTIONS.upsert
                }, fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), {
                    'x-upsert': String(options.upsert)
                });
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                }
                const res = yield this.fetch(url.toString(), {
                    method: 'PUT',
                    body: body,
                    headers: headers
                });
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for 2 hours.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param options.upsert If set to true, allows the file to be overwritten if it already exists.
     */ createSignedUploadUrl(path, options) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                const headers = Object.assign({}, this.headers);
                if (options === null || options === void 0 ? void 0 : options.upsert) headers['x-upsert'] = 'true';
                const data = yield (0, $24f090cab6cd5bfb$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/upload/sign/${_path}`, {}, {
                    headers: headers
                });
                const url = new URL(this.url + data.url);
                const token = url.searchParams.get('token');
                if (!token) throw new (0, $d007a2eddccb67ed$export$697502632950e9d3)('No token returned by API');
                return {
                    data: {
                        signedUrl: url.toString(),
                        path: path,
                        token: token
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */ update(path, fileBody, fileOptions) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('PUT', path, fileBody, fileOptions);
        });
    }
    /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     * @param options The destination options.
     */ move(fromPath, toPath, options) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $24f090cab6cd5bfb$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/move`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     * @param options The destination options.
     */ copy(fromPath, toPath, options) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $24f090cab6cd5bfb$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/copy`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: {
                        path: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ createSignedUrl(path, expiresIn, options) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                let data = yield (0, $24f090cab6cd5bfb$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${_path}`, Object.assign({
                    expiresIn: expiresIn
                }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                    transform: options.transform
                } : {}), {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                const signedUrl = encodeURI(`${this.url}${data.signedURL}${downloadQueryParam}`);
                data = {
                    signedUrl: signedUrl
                };
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */ createSignedUrls(paths, expiresIn, options) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $24f090cab6cd5bfb$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${this.bucketId}`, {
                    expiresIn: expiresIn,
                    paths: paths
                }, {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                return {
                    data: data.map((datum)=>Object.assign(Object.assign({}, datum), {
                            signedUrl: datum.signedURL ? encodeURI(`${this.url}${datum.signedURL}${downloadQueryParam}`) : null
                        })),
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */ download(path, options) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
            const renderPath = wantsTransformation ? 'render/image/authenticated' : 'object';
            const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
            const queryString = transformationQuery ? `?${transformationQuery}` : '';
            try {
                const _path = this._getFinalPath(path);
                const res = yield (0, $24f090cab6cd5bfb$export$3988ae62b71be9a3)(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                    headers: this.headers,
                    noResolveJson: true
                });
                const data = yield res.blob();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing file.
     * @param path
     */ info(path) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                const data = yield (0, $24f090cab6cd5bfb$export$3988ae62b71be9a3)(this.fetch, `${this.url}/object/info/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: (0, $6c6303fb88ebc98e$export$69d519e35e6fc3d4)(data),
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Checks the existence of a file.
     * @param path
     */ exists(path) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                yield (0, $24f090cab6cd5bfb$export$5fd5031fecdacec3)(this.fetch, `${this.url}/object/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: true,
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error) && error instanceof (0, $d007a2eddccb67ed$export$29127ca2e1a271d)) {
                    const originalError = error.originalError;
                    if ([
                        400,
                        404
                    ].includes(originalError === null || originalError === void 0 ? void 0 : originalError.status)) return {
                        data: false,
                        error: error
                    };
                }
                throw error;
            }
        });
    }
    /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? '' : options.download}` : '';
        if (downloadQueryParam !== '') _queryString.push(downloadQueryParam);
        const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
        const renderPath = wantsTransformation ? 'render/image' : 'object';
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== '') _queryString.push(transformationQuery);
        let queryString = _queryString.join('&');
        if (queryString !== '') queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */ remove(paths) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $24f090cab6cd5bfb$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/object/${this.bucketId}`, {
                    prefixes: paths
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */ // async getMetadata(
    //   id: string
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */ // async updateMetadata(
    //   id: string,
    //   meta: Metadata
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await post(
    //       this.fetch,
    //       `${this.url}/metadata/${id}`,
    //       { ...meta },
    //       { headers: this.headers }
    //     )
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     */ list(path, options, parameters) {
        return $7b5430a64999b067$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const body = Object.assign(Object.assign(Object.assign({}, $7b5430a64999b067$var$DEFAULT_SEARCH_OPTIONS), options), {
                    prefix: path || ''
                });
                const data = yield (0, $24f090cab6cd5bfb$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/list/${this.bucketId}`, body, {
                    headers: this.headers
                }, parameters);
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $7b5430a64999b067$require$Buffer !== 'undefined') return $7b5430a64999b067$require$Buffer.from(data).toString('base64');
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, '').replace(/\/+/g, '/');
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join('&');
    }
}


// generated by genversion
const $66bfd211c1c2099c$export$83d89fbfd8236492 = '2.7.1';


const $82466717d917ab70$export$88a84136db6a4b64 = {
    'X-Client-Info': `storage-js/${(0, $66bfd211c1c2099c$export$83d89fbfd8236492)}`
};





var $e7fd483b110ea85d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $e7fd483b110ea85d$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, fetch){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $82466717d917ab70$export$88a84136db6a4b64)), headers);
        this.fetch = (0, $6c6303fb88ebc98e$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Retrieves the details of all Storage buckets within an existing project.
     */ listBuckets() {
        return $e7fd483b110ea85d$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $24f090cab6cd5bfb$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing Storage bucket.
     *
     * @param id The unique identifier of the bucket you would like to retrieve.
     */ getBucket(id) {
        return $e7fd483b110ea85d$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $24f090cab6cd5bfb$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket/${id}`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a new Storage bucket
     *
     * @param id A unique identifier for the bucket you are creating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     * @returns newly created bucket id
     */ createBucket(id, options = {
        public: false
    }) {
        return $e7fd483b110ea85d$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $24f090cab6cd5bfb$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Updates a Storage bucket
     *
     * @param id A unique identifier for the bucket you are updating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     */ updateBucket(id, options) {
        return $e7fd483b110ea85d$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $24f090cab6cd5bfb$export$327f7b26ebf455db)(this.fetch, `${this.url}/bucket/${id}`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Removes all objects inside a single bucket.
     *
     * @param id The unique identifier of the bucket you would like to empty.
     */ emptyBucket(id) {
        return $e7fd483b110ea85d$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $24f090cab6cd5bfb$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket/${id}/empty`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
     * You must first `empty()` the bucket.
     *
     * @param id The unique identifier of the bucket you would like to delete.
     */ deleteBucket(id) {
        return $e7fd483b110ea85d$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $24f090cab6cd5bfb$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/bucket/${id}`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $d007a2eddccb67ed$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
}


class $730c137910a29157$export$6c85f5032e75eff9 extends (0, $e7fd483b110ea85d$export$2e2bcd8739ae039) {
    constructor(url, headers = {}, fetch){
        super(url, headers, fetch);
    }
    /**
     * Perform file operation in a bucket.
     *
     * @param id The bucket id to operate on.
     */ from(id) {
        return new (0, $7b5430a64999b067$export$2e2bcd8739ae039)(this.url, this.headers, id, this.fetch);
    }
}


const $8cc2fa5dfa41ef11$export$83d89fbfd8236492 = '2.47.2';


let $47ee04f2e2c918dd$var$JS_ENV = '';
// @ts-ignore
if (typeof Deno !== 'undefined') $47ee04f2e2c918dd$var$JS_ENV = 'deno';
else if (typeof document !== 'undefined') $47ee04f2e2c918dd$var$JS_ENV = 'web';
else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') $47ee04f2e2c918dd$var$JS_ENV = 'react-native';
else $47ee04f2e2c918dd$var$JS_ENV = 'node';
const $47ee04f2e2c918dd$export$88a84136db6a4b64 = {
    'X-Client-Info': `supabase-js-${$47ee04f2e2c918dd$var$JS_ENV}/${(0, $8cc2fa5dfa41ef11$export$83d89fbfd8236492)}`
};
const $47ee04f2e2c918dd$export$b63a5c3a2e5becd2 = {
    headers: $47ee04f2e2c918dd$export$88a84136db6a4b64
};
const $47ee04f2e2c918dd$export$b31378ae815bea6b = {
    schema: 'public'
};
const $47ee04f2e2c918dd$export$af122550cc2345b3 = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
};
const $47ee04f2e2c918dd$export$59685507ca0a3912 = {};



var $ixUGO = parcelRequire("ixUGO");
var $91d79316d2d59ca4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $91d79316d2d59ca4$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (0, $ixUGO.default);
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $91d79316d2d59ca4$export$3d2cf54f85b7fc8a = ()=>{
    if (typeof Headers === 'undefined') return 0, $ixUGO.Headers;
    return Headers;
};
const $91d79316d2d59ca4$export$651dd5aef824521f = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch1 = $91d79316d2d59ca4$export$98d92b1aa79f8cc7(customFetch);
    const HeadersConstructor = $91d79316d2d59ca4$export$3d2cf54f85b7fc8a();
    return (input, init)=>$91d79316d2d59ca4$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const accessToken = (_a = yield getAccessToken()) !== null && _a !== void 0 ? _a : supabaseKey;
            let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
            if (!headers.has('apikey')) headers.set('apikey', supabaseKey);
            if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${accessToken}`);
            return fetch1(input, Object.assign(Object.assign({}, init), {
                headers: headers
            }));
        });
};


var $dfcfe6ed98948c30$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $dfcfe6ed98948c30$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $dfcfe6ed98948c30$export$d95b4586d238a081(url) {
    return url.replace(/\/$/, '');
}
const $dfcfe6ed98948c30$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined';
function $dfcfe6ed98948c30$export$da186dc3f8eace71(options, defaults) {
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS, auth: DEFAULT_AUTH_OPTIONS, realtime: DEFAULT_REALTIME_OPTIONS, global: DEFAULT_GLOBAL_OPTIONS } = defaults;
    const result = {
        db: Object.assign(Object.assign({}, DEFAULT_DB_OPTIONS), dbOptions),
        auth: Object.assign(Object.assign({}, DEFAULT_AUTH_OPTIONS), authOptions),
        realtime: Object.assign(Object.assign({}, DEFAULT_REALTIME_OPTIONS), realtimeOptions),
        global: Object.assign(Object.assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions),
        accessToken: ()=>$dfcfe6ed98948c30$var$__awaiter(this, void 0, void 0, function*() {
                return '';
            })
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else // hack around Required<>
    delete result.accessToken;
    return result;
}


const $60ec12e6bf090b61$export$83d89fbfd8236492 = '2.66.1';


const $b0ca34c253ff0277$export$7fedf552187f0c3d = 'http://localhost:9999';
const $b0ca34c253ff0277$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $b0ca34c253ff0277$export$2f9161bad044dacb = '';
const $b0ca34c253ff0277$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $60ec12e6bf090b61$export$83d89fbfd8236492)}`
};
const $b0ca34c253ff0277$export$7d4b3a66850dd9bd = 10; // in seconds
const $b0ca34c253ff0277$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $b0ca34c253ff0277$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $b0ca34c253ff0277$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};



function $5cde28e53d00c98e$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $5cde28e53d00c98e$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $5cde28e53d00c98e$export$4e09c449d6c407f7 = ()=>typeof document !== 'undefined';
const $5cde28e53d00c98e$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $5cde28e53d00c98e$export$9ec034ee80211814 = ()=>{
    if (!$5cde28e53d00c98e$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($5cde28e53d00c98e$var$localStorageWriteTests.tested) return $5cde28e53d00c98e$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $5cde28e53d00c98e$var$localStorageWriteTests.tested = true;
        $5cde28e53d00c98e$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $5cde28e53d00c98e$var$localStorageWriteTests.tested = true;
        $5cde28e53d00c98e$var$localStorageWriteTests.writable = false;
    }
    return $5cde28e53d00c98e$var$localStorageWriteTests.writable;
};
function $5cde28e53d00c98e$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}

const $5cde28e53d00c98e$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("ixUGO"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $5cde28e53d00c98e$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $5cde28e53d00c98e$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $5cde28e53d00c98e$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $5cde28e53d00c98e$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
function $5cde28e53d00c98e$export$f0d30a693d94f11c(value) {
    const key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let base64 = '';
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    value = value.replace('-', '+').replace('_', '/');
    while(i < value.length){
        enc1 = key.indexOf(value.charAt(i++));
        enc2 = key.indexOf(value.charAt(i++));
        enc3 = key.indexOf(value.charAt(i++));
        enc4 = key.indexOf(value.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        base64 = base64 + String.fromCharCode(chr1);
        if (enc3 != 64 && chr2 != 0) base64 = base64 + String.fromCharCode(chr2);
        if (enc4 != 64 && chr3 != 0) base64 = base64 + String.fromCharCode(chr3);
    }
    return base64;
}
class $5cde28e53d00c98e$export$85f6557964517f1a {
    constructor(){
        this.promise = new $5cde28e53d00c98e$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$5cde28e53d00c98e$export$85f6557964517f1a.promiseConstructor = Promise;
function $5cde28e53d00c98e$export$cc1c0b988f7b5577(token) {
    // Regex checks for base64url format
    const base64UrlRegex = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}=?$|[a-z0-9_-]{2}(==)?$)$/i;
    const parts = token.split('.');
    if (parts.length !== 3) throw new Error('JWT is not valid: not a JWT structure');
    if (!base64UrlRegex.test(parts[1])) throw new Error('JWT is not valid: payload is not in base64url format');
    const base64Url = parts[1];
    return JSON.parse($5cde28e53d00c98e$export$f0d30a693d94f11c(base64Url));
}
async function $5cde28e53d00c98e$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $5cde28e53d00c98e$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $5cde28e53d00c98e$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $5cde28e53d00c98e$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $5cde28e53d00c98e$var$dec2hex).join('');
}
async function $5cde28e53d00c98e$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
function $5cde28e53d00c98e$var$base64urlencode(str) {
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $5cde28e53d00c98e$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $5cde28e53d00c98e$var$sha256(verifier);
    return $5cde28e53d00c98e$var$base64urlencode(hashed);
}
async function $5cde28e53d00c98e$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $5cde28e53d00c98e$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/PASSWORD_RECOVERY';
    await $5cde28e53d00c98e$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $5cde28e53d00c98e$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $5cde28e53d00c98e$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $5cde28e53d00c98e$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $b0ca34c253ff0277$export$e4f5507f88977535));
    if (!apiVersion) return null;
    if (!apiVersion.match($5cde28e53d00c98e$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e) {
        return null;
    }
}


class $9652d9fd25b74068$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
}
function $9652d9fd25b74068$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $9652d9fd25b74068$export$45fde0b55b14f37b extends $9652d9fd25b74068$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $9652d9fd25b74068$export$4fe744aeb810d543(error) {
    return $9652d9fd25b74068$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $9652d9fd25b74068$export$f7559805d4a50078 extends $9652d9fd25b74068$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $9652d9fd25b74068$export$823c745ae0673c5e extends $9652d9fd25b74068$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $9652d9fd25b74068$export$403b3fc0d3ad5f0c extends $9652d9fd25b74068$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $9652d9fd25b74068$export$3e849aa4db565c1d(error) {
    return $9652d9fd25b74068$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $9652d9fd25b74068$export$7e277b620449c1b4 extends $9652d9fd25b74068$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $9652d9fd25b74068$export$9ef583f0381b4cc extends $9652d9fd25b74068$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $9652d9fd25b74068$export$bf5df8e043856ef5 extends $9652d9fd25b74068$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
function $9652d9fd25b74068$export$45edea3999507afd(error) {
    return $9652d9fd25b74068$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $9652d9fd25b74068$export$39583657eb2a7027 extends $9652d9fd25b74068$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
class $9652d9fd25b74068$export$2423b763f68be1b4 extends $9652d9fd25b74068$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $9652d9fd25b74068$export$a77af358da5fb874(error) {
    return $9652d9fd25b74068$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $9652d9fd25b74068$export$b034076aa04913a6 extends $9652d9fd25b74068$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
}
function $9652d9fd25b74068$export$dac36143fd8a46ef(error) {
    return $9652d9fd25b74068$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}


var $f4f4d43e3e27fbe2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f4f4d43e3e27fbe2$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $f4f4d43e3e27fbe2$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function $f4f4d43e3e27fbe2$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $5cde28e53d00c98e$export$e8ad6599be1036a7)(error)) throw new (0, $9652d9fd25b74068$export$2423b763f68be1b4)($f4f4d43e3e27fbe2$var$_getErrorMessage(error), 0);
    if ($f4f4d43e3e27fbe2$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $9652d9fd25b74068$export$2423b763f68be1b4)($f4f4d43e3e27fbe2$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $9652d9fd25b74068$export$f7559805d4a50078)($f4f4d43e3e27fbe2$var$_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, $5cde28e53d00c98e$export$5f69ecf1c14d56fd)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $b0ca34c253ff0277$export$1f9a66038489bdeb)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $9652d9fd25b74068$export$b034076aa04913a6)($f4f4d43e3e27fbe2$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $9652d9fd25b74068$export$b034076aa04913a6)($f4f4d43e3e27fbe2$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $9652d9fd25b74068$export$403b3fc0d3ad5f0c)();
    throw new (0, $9652d9fd25b74068$export$45fde0b55b14f37b)($f4f4d43e3e27fbe2$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $f4f4d43e3e27fbe2$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $b0ca34c253ff0277$export$e4f5507f88977535]) headers[0, $b0ca34c253ff0277$export$e4f5507f88977535] = (0, $b0ca34c253ff0277$export$1f9a66038489bdeb)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $f4f4d43e3e27fbe2$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $f4f4d43e3e27fbe2$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $f4f4d43e3e27fbe2$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $9652d9fd25b74068$export$2423b763f68be1b4)($f4f4d43e3e27fbe2$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $f4f4d43e3e27fbe2$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $f4f4d43e3e27fbe2$export$d3da1ecaf1206c58(e);
    }
}
function $f4f4d43e3e27fbe2$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($f4f4d43e3e27fbe2$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $5cde28e53d00c98e$export$e02d0a488392f690)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $f4f4d43e3e27fbe2$export$db83aade1c2922c7(data) {
    const response = $f4f4d43e3e27fbe2$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $f4f4d43e3e27fbe2$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $f4f4d43e3e27fbe2$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $f4f4d43e3e27fbe2$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = $f4f4d43e3e27fbe2$var$__rest(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $f4f4d43e3e27fbe2$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $f4f4d43e3e27fbe2$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}




var $6836e1571b60d6a4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $6836e1571b60d6a4$export$2e2bcd8739ae039 {
    constructor({ url: url = '', headers: headers = {}, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $5cde28e53d00c98e$export$98d92b1aa79f8cc7)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ async signOut(jwt, scope = 'global') {
        try {
            await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $f4f4d43e3e27fbe2$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = $6836e1571b60d6a4$var$__rest(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $f4f4d43e3e27fbe2$export$f5eaa950605b2146),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async createUser(attributes) {
        try {
            return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $f4f4d43e3e27fbe2$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $f4f4d43e3e27fbe2$export$7aed01df6e045e31)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async getUserById(uid) {
        try {
            return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $f4f4d43e3e27fbe2$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async updateUserById(uid, attributes) {
        try {
            return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $f4f4d43e3e27fbe2$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async deleteUser(id, shouldSoftDelete = false) {
        try {
            return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $f4f4d43e3e27fbe2$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        try {
            const { data: data, error: error } = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        try {
            const data = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}








const $1a9a837eff1a7fbf$export$bba7b6c94612d04b = {
    getItem: (key)=>{
        if (!(0, $5cde28e53d00c98e$export$9ec034ee80211814)()) return null;
        return globalThis.localStorage.getItem(key);
    },
    setItem: (key, value)=>{
        if (!(0, $5cde28e53d00c98e$export$9ec034ee80211814)()) return;
        globalThis.localStorage.setItem(key, value);
    },
    removeItem: (key)=>{
        if (!(0, $5cde28e53d00c98e$export$9ec034ee80211814)()) return;
        globalThis.localStorage.removeItem(key);
    }
};
function $1a9a837eff1a7fbf$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}


/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $bd2a4fdaa25b46eb$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}




const $182a4662673ed6db$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $5cde28e53d00c98e$export$9ec034ee80211814)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $182a4662673ed6db$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $182a4662673ed6db$export$4aa56776043a4631 extends $182a4662673ed6db$export$23e9464cc010dff9 {
}
class $182a4662673ed6db$export$4b982ee840d3d915 extends $182a4662673ed6db$export$23e9464cc010dff9 {
}
async function $182a4662673ed6db$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($182a4662673ed6db$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    if (acquireTimeout > 0) setTimeout(()=>{
        abortController.abort();
        if ($182a4662673ed6db$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    return await globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
        mode: 'exclusive',
        ifAvailable: true
    } : {
        mode: 'exclusive',
        signal: abortController.signal
    }, async (lock)=>{
        if (lock) {
            if ($182a4662673ed6db$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
            try {
                return await fn();
            } finally{
                if ($182a4662673ed6db$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
            }
        } else if (acquireTimeout === 0) {
            if ($182a4662673ed6db$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
            throw new $182a4662673ed6db$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
        } else {
            if ($182a4662673ed6db$export$e368aba7747330f2.debug) try {
                const result = await globalThis.navigator.locks.query();
                console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
            } catch (e) {
                console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
            }
            // Browser is not following the Navigator LockManager spec, it
            // returned a null lock when we didn't use ifAvailable. So we can
            // pretend the lock is acquired in the name of backward compatibility
            // and user experience and just run the function.
            console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
            return await fn();
        }
    });
}
const $182a4662673ed6db$var$PROCESS_LOCKS = {};
async function $182a4662673ed6db$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $182a4662673ed6db$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    const currentOperation = Promise.race([
        previousOperation.catch(()=>{
            // ignore error of previous operation that we're waiting to finish
            return null;
        }),
        acquireTimeout >= 0 ? new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new $182a4662673ed6db$export$4b982ee840d3d915(`Acquring process lock with name "${name}" timed out`));
            }, acquireTimeout);
        }) : null
    ].filter((x)=>x)).catch((e)=>{
        if (e && e.isAcquireTimeout) throw e;
        return null;
    }).then(async ()=>{
        // previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    });
    $182a4662673ed6db$var$PROCESS_LOCKS[name] = currentOperation.catch(async (e)=>{
        if (e && e.isAcquireTimeout) {
            // if the current operation timed out, it doesn't mean that the previous
            // operation finished, so we need contnue waiting for it to finish
            await previousOperation;
            return null;
        }
        throw e;
    });
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}


(0, $bd2a4fdaa25b46eb$export$ad067ce270531206)(); // Make "globalThis" available
const $e8d7a3d8b651ec92$var$DEFAULT_OPTIONS = {
    url: (0, $b0ca34c253ff0277$export$7fedf552187f0c3d),
    storageKey: (0, $b0ca34c253ff0277$export$86880b4b2e1a2384),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $b0ca34c253ff0277$export$88a84136db6a4b64),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false
};
/** Current session will be checked for refresh at this interval. */ const $e8d7a3d8b651ec92$var$AUTO_REFRESH_TICK_DURATION = 30000;
/**
 * A token refresh will be attempted this many ticks before the current session expires. */ const $e8d7a3d8b651ec92$var$AUTO_REFRESH_TICK_THRESHOLD = 3;
async function $e8d7a3d8b651ec92$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
class $e8d7a3d8b651ec92$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     */ constructor(options){
        var _a, _b;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the the auth state is known and it's save to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        this.instanceID = $e8d7a3d8b651ec92$export$2e2bcd8739ae039.nextInstanceID;
        $e8d7a3d8b651ec92$export$2e2bcd8739ae039.nextInstanceID += 1;
        if (this.instanceID > 0 && (0, $5cde28e53d00c98e$export$4e09c449d6c407f7)()) console.warn('Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.');
        const settings = Object.assign(Object.assign({}, $e8d7a3d8b651ec92$var$DEFAULT_OPTIONS), options);
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        this.persistSession = settings.persistSession;
        this.storageKey = settings.storageKey;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, $6836e1571b60d6a4$export$2e2bcd8739ae039)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $5cde28e53d00c98e$export$98d92b1aa79f8cc7)(settings.fetch);
        this.lock = settings.lock || $e8d7a3d8b651ec92$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        if (settings.lock) this.lock = settings.lock;
        else if ((0, $5cde28e53d00c98e$export$4e09c449d6c407f7)() && ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.locks)) this.lock = (0, $182a4662673ed6db$export$f4ff21938fb7af3c);
        else this.lock = $e8d7a3d8b651ec92$var$lockNoOp;
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $5cde28e53d00c98e$export$9ec034ee80211814)()) this.storage = (0, $1a9a837eff1a7fbf$export$bba7b6c94612d04b);
            else {
                this.memoryStorage = {};
                this.storage = (0, $1a9a837eff1a7fbf$export$d791f66d7e5710cf)(this.memoryStorage);
            }
        } else {
            this.memoryStorage = {};
            this.storage = (0, $1a9a837eff1a7fbf$export$d791f66d7e5710cf)(this.memoryStorage);
        }
        if ((0, $5cde28e53d00c98e$export$4e09c449d6c407f7)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_b = this.broadcastChannel) === null || _b === void 0 || _b.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
            });
        }
        this.initialize();
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(`GoTrueClient@${this.instanceID} (${(0, $60ec12e6bf090b61$export$83d89fbfd8236492)}) ${new Date().toISOString()}`, ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(-1, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            const isPKCEFlow = (0, $5cde28e53d00c98e$export$4e09c449d6c407f7)() ? await this._isPKCEFlow() : false;
            this._debug('#_initialize()', 'begin', 'is PKCE flow', isPKCEFlow);
            if (isPKCEFlow || this.detectSessionInUrl && this._isImplicitGrantFlow()) {
                const { data: data, error: error } = await this._getSessionFromURL(isPKCEFlow);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $9652d9fd25b74068$export$45edea3999507afd)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // failed login attempt via url,
                    // remove old session as in verifyOtp, signUp and signInWith*
                    await this._removeSession();
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                error: error
            };
            return {
                error: new (0, $9652d9fd25b74068$export$f7559805d4a50078)('Unexpected error during initialization', error)
            };
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $f4f4d43e3e27fbe2$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $5cde28e53d00c98e$export$81b177cadfcf873c)(this.storage, this.storageKey);
                res = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $f4f4d43e3e27fbe2$export$273fe4673a018c2e)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $f4f4d43e3e27fbe2$export$273fe4673a018c2e)
                });
            } else throw new (0, $9652d9fd25b74068$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $f4f4d43e3e27fbe2$export$db83aade1c2922c7)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $f4f4d43e3e27fbe2$export$db83aade1c2922c7)
                });
            } else throw new (0, $9652d9fd25b74068$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $9652d9fd25b74068$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $5cde28e53d00c98e$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            const { data: data, error: error } = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $f4f4d43e3e27fbe2$export$273fe4673a018c2e)
            });
            await (0, $5cde28e53d00c98e$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: new (0, $9652d9fd25b74068$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $f4f4d43e3e27fbe2$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $9652d9fd25b74068$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $5cde28e53d00c98e$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { error: error } = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : 'sms'
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $9652d9fd25b74068$export$9ef583f0381b4cc)('You must provide either an email or phone number.');
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $f4f4d43e3e27fbe2$export$273fe4673a018c2e)
            });
            if (error) throw error;
            if (!data) throw new Error('An error occurred on token verification.');
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ async signInWithSSO(params) {
        var _a, _b, _c;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $5cde28e53d00c98e$export$81b177cadfcf873c)(this.storage, this.storageKey);
            return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $f4f4d43e3e27fbe2$export$b04785c46dcd8f8b)
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $9652d9fd25b74068$export$403b3fc0d3ad5f0c)();
                const { error: error } = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $9652d9fd25b74068$export$9ef583f0381b4cc)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $5cde28e53d00c98e$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            const hasExpired = currentSession.expires_at ? currentSession.expires_at <= Date.now() / 1000 : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.storage.isServer) {
                    let suppressWarning = this.suppressGetSessionWarning;
                    const proxySession = new Proxy(currentSession, {
                        get: (target, prop, receiver)=>{
                            if (!suppressWarning && prop === 'user') {
                                // only show warning when the user object is being accessed from the server
                                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                                suppressWarning = true; // keeps this proxy instance from logging additional warnings
                                this.suppressGetSessionWarning = true; // keeps this client's future proxy instances from warning
                            }
                            return Reflect.get(target, prop, receiver);
                        }
                    });
                    currentSession = proxySession;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return {
                data: {
                    session: null
                },
                error: error
            };
            return {
                data: {
                    session: session
                },
                error: null
            };
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return await this._getUser();
        });
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $f4f4d43e3e27fbe2$export$e20f488897843593)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $9652d9fd25b74068$export$403b3fc0d3ad5f0c)()
                };
                return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $f4f4d43e3e27fbe2$export$e20f488897843593)
                });
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) {
                if ((0, $9652d9fd25b74068$export$3e849aa4db565c1d)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, $5cde28e53d00c98e$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return {
                    data: {
                        user: null
                    },
                    error: error
                };
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $9652d9fd25b74068$export$403b3fc0d3ad5f0c)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, $5cde28e53d00c98e$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { data: data, error: userError } = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $f4f4d43e3e27fbe2$export$e20f488897843593)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return {
                    data: {
                        user: session.user
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Decodes a JWT (without performing any validation).
     */ _decodeJWT(jwt) {
        return (0, $5cde28e53d00c98e$export$cc1c0b988f7b5577)(jwt);
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $9652d9fd25b74068$export$403b3fc0d3ad5f0c)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const payload = (0, $5cde28e53d00c98e$export$cc1c0b988f7b5577)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { session: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) throw error;
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $9652d9fd25b74068$export$403b3fc0d3ad5f0c)();
                const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!session) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                return {
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(isPKCEFlow) {
        try {
            if (!(0, $5cde28e53d00c98e$export$4e09c449d6c407f7)()) throw new (0, $9652d9fd25b74068$export$bf5df8e043856ef5)('No browser detected.');
            if (this.flowType === 'implicit' && !this._isImplicitGrantFlow()) throw new (0, $9652d9fd25b74068$export$bf5df8e043856ef5)('Not a valid implicit grant flow url.');
            else if (this.flowType == 'pkce' && !isPKCEFlow) throw new (0, $9652d9fd25b74068$export$39583657eb2a7027)('Not a valid PKCE flow url.');
            const params = (0, $5cde28e53d00c98e$export$7a29392fb778224c)(window.location.href);
            if (isPKCEFlow) {
                if (!params.code) throw new (0, $9652d9fd25b74068$export$39583657eb2a7027)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            if (params.error || params.error_description || params.error_code) throw new (0, $9652d9fd25b74068$export$bf5df8e043856ef5)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $9652d9fd25b74068$export$bf5df8e043856ef5)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= $e8d7a3d8b651ec92$var$AUTO_REFRESH_TICK_DURATION) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return {
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */ _isImplicitGrantFlow() {
        const params = (0, $5cde28e53d00c98e$export$7a29392fb778224c)(window.location.href);
        return !!((0, $5cde28e53d00c98e$export$4e09c449d6c407f7)() && (params.access_token || params.error_description));
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCEFlow() {
        const params = (0, $5cde28e53d00c98e$export$7a29392fb778224c)(window.location.href);
        const currentStorageContent = await (0, $5cde28e53d00c98e$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError) return {
                error: sessionError
            };
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $9652d9fd25b74068$export$4fe744aeb810d543)(error) && (error.status === 404 || error.status === 401 || error.status === 403))) return {
                        error: error
                    };
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, $5cde28e53d00c98e$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return {
                error: null
            };
        });
    }
    /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */ onAuthStateChange(callback) {
        const id = (0, $5cde28e53d00c98e$export$31b40729666a4ae0)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(-1, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $5cde28e53d00c98e$export$81b177cadfcf873c)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return {
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Links an oauth identity to an existing user.
     * This method supports the PKCE flow.
     */ async linkIdentity(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, $5cde28e53d00c98e$export$4e09c449d6c407f7)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return {
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            };
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $5cde28e53d00c98e$export$9e1b8e833f44ff21)(async (attempt)=>{
                if (attempt > 0) await (0, $5cde28e53d00c98e$export$e772c8ff12451969)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $f4f4d43e3e27fbe2$export$273fe4673a018c2e)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $9652d9fd25b74068$export$a77af358da5fb874)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < $e8d7a3d8b651ec92$var$AUTO_REFRESH_TICK_DURATION;
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $5cde28e53d00c98e$export$4e09c449d6c407f7)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $5cde28e53d00c98e$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const timeNow = Math.round(Date.now() / 1000);
            const expiresWithMargin = ((_a = currentSession.expires_at) !== null && _a !== void 0 ? _a : Infinity) < timeNow + (0, $b0ca34c253ff0277$export$7d4b3a66850dd9bd);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $b0ca34c253ff0277$export$7d4b3a66850dd9bd)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $9652d9fd25b74068$export$a77af358da5fb874)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $9652d9fd25b74068$export$403b3fc0d3ad5f0c)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $5cde28e53d00c98e$export$85f6557964517f1a)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $9652d9fd25b74068$export$403b3fc0d3ad5f0c)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                session: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) {
                const result = {
                    session: null,
                    error: error
                };
                if (!(0, $9652d9fd25b74068$export$a77af358da5fb874)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        await (0, $5cde28e53d00c98e$export$e82c36d29078a87f)(this.storage, this.storageKey, session);
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        await (0, $5cde28e53d00c98e$export$d35c645d585317ec)(this.storage, this.storageKey);
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $5cde28e53d00c98e$export$4e09c449d6c407f7)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), $e8d7a3d8b651ec92$var$AUTO_REFRESH_TICK_DURATION);
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / $e8d7a3d8b651ec92$var$AUTO_REFRESH_TICK_DURATION);
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${$e8d7a3d8b651ec92$var$AUTO_REFRESH_TICK_DURATION}ms, refresh threshold is ${$e8d7a3d8b651ec92$var$AUTO_REFRESH_TICK_THRESHOLD} ticks`);
                            if (expiresInTicks <= $e8d7a3d8b651ec92$var$AUTO_REFRESH_TICK_THRESHOLD) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, $182a4662673ed6db$export$23e9464cc010dff9)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $5cde28e53d00c98e$export$4e09c449d6c407f7)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>await this._onVisibilityChanged(false);
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(-1, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, $5cde28e53d00c98e$export$81b177cadfcf873c)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : {
                    issuer: params.issuer
                });
                const { data: data, error: error } = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return {
                    data: null,
                    error: error
                };
                if (params.factorType === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return {
                    data: data,
                    error: null
                };
            });
        } catch (error) {
            if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#verify}
     */ async _verify(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    const { data: data, error: error } = await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: {
                            code: params.code,
                            challenge_id: params.challengeId
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return {
                        data: null,
                        error: error
                    };
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return {
                        data: data,
                        error: error
                    };
                });
            } catch (error) {
                if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challenge}
     */ async _challenge(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    return await (0, $f4f4d43e3e27fbe2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: {
                            channel: params.channel
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                });
            } catch (error) {
                if ((0, $9652d9fd25b74068$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return {
            data: null,
            error: challengeError
        };
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
        const totp = factors.filter((factor)=>factor.factor_type === 'totp' && factor.status === 'verified');
        const phone = factors.filter((factor)=>factor.factor_type === 'phone' && factor.status === 'verified');
        return {
            data: {
                all: factors,
                totp: totp,
                phone: phone
            },
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel() {
        return this._acquireLock(-1, async ()=>{
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                if (!session) return {
                    data: {
                        currentLevel: null,
                        nextLevel: null,
                        currentAuthenticationMethods: []
                    },
                    error: null
                };
                const payload = this._decodeJWT(session.access_token);
                let currentLevel = null;
                if (payload.aal) currentLevel = payload.aal;
                let nextLevel = currentLevel;
                const verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
                if (verifiedFactors.length > 0) nextLevel = 'aal2';
                const currentAuthenticationMethods = payload.amr || [];
                return {
                    data: {
                        currentLevel: currentLevel,
                        nextLevel: nextLevel,
                        currentAuthenticationMethods: currentAuthenticationMethods
                    },
                    error: null
                };
            });
        });
    }
}
$e8d7a3d8b651ec92$export$2e2bcd8739ae039.nextInstanceID = 0;



const $cf1a96abd54f24ad$var$AuthAdminApi = (0, $6836e1571b60d6a4$export$2e2bcd8739ae039);
var $cf1a96abd54f24ad$export$2e2bcd8739ae039 = $cf1a96abd54f24ad$var$AuthAdminApi;



const $cd6ed2faa611285f$var$AuthClient = (0, $e8d7a3d8b651ec92$export$2e2bcd8739ae039);
var $cd6ed2faa611285f$export$2e2bcd8739ae039 = $cd6ed2faa611285f$var$AuthClient;








class $33f2e379812addff$export$8199a418bb09bd56 extends (0, $cd6ed2faa611285f$export$2e2bcd8739ae039) {
    constructor(options){
        super(options);
    }
}


var $c0000f8ecf746878$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $c0000f8ecf746878$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
     * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
     * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
     * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
     * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
     * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
     * @param options.realtime Options passed along to realtime-js constructor.
     * @param options.global.fetch A custom fetch implementation.
     * @param options.global.headers Any additional headers to send with each network request.
     */ constructor(supabaseUrl, supabaseKey, options){
        var _a, _b, _c;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        if (!supabaseUrl) throw new Error('supabaseUrl is required.');
        if (!supabaseKey) throw new Error('supabaseKey is required.');
        const _supabaseUrl = (0, $dfcfe6ed98948c30$export$d95b4586d238a081)(supabaseUrl);
        this.realtimeUrl = `${_supabaseUrl}/realtime/v1`.replace(/^http/i, 'ws');
        this.authUrl = `${_supabaseUrl}/auth/v1`;
        this.storageUrl = `${_supabaseUrl}/storage/v1`;
        this.functionsUrl = `${_supabaseUrl}/functions/v1`;
        // default storage key uses the supabase project ref as a namespace
        const defaultStorageKey = `sb-${new URL(this.authUrl).hostname.split('.')[0]}-auth-token`;
        const DEFAULTS = {
            db: (0, $47ee04f2e2c918dd$export$b31378ae815bea6b),
            realtime: (0, $47ee04f2e2c918dd$export$59685507ca0a3912),
            auth: Object.assign(Object.assign({}, (0, $47ee04f2e2c918dd$export$af122550cc2345b3)), {
                storageKey: defaultStorageKey
            }),
            global: (0, $47ee04f2e2c918dd$export$b63a5c3a2e5becd2)
        };
        const settings = (0, $dfcfe6ed98948c30$export$da186dc3f8eace71)(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_a = settings.auth.storageKey) !== null && _a !== void 0 ? _a : '';
        this.headers = (_b = settings.global.headers) !== null && _b !== void 0 ? _b : {};
        if (!settings.accessToken) this.auth = this._initSupabaseAuthClient((_c = settings.auth) !== null && _c !== void 0 ? _c : {}, this.headers, settings.global.fetch);
        else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = (0, $91d79316d2d59ca4$export$651dd5aef824521f)(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient(Object.assign({
            headers: this.headers
        }, settings.realtime));
        this.rest = new (0, $f81529bab7110c2a$export$796f32e2ee984aaa)(`${_supabaseUrl}/rest/v1`, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch
        });
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
     * Supabase Functions allows you to deploy and invoke edge functions.
     */ get functions() {
        return new (0, $fdaae3ad682b2eb6$export$1d0b400bf8a0fa55)(this.functionsUrl, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
     * Supabase Storage allows you to manage user-generated content, such as photos or videos.
     */ get storage() {
        return new (0, $730c137910a29157$export$6c85f5032e75eff9)(this.storageUrl, this.headers, this.fetch);
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        return this.rest.from(relation);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.schema
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return this.rest.schema(schema);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.rpc
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, options = {}) {
        return this.rest.rpc(fn, args, options);
    }
    /**
     * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
     *
     * @param {string} name - The name of the Realtime channel.
     * @param {Object} opts - The options to pass to the Realtime channel.
     *
     */ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
     * Returns all Realtime channels.
     */ getChannels() {
        return this.realtime.getChannels();
    }
    /**
     * Unsubscribes and removes Realtime channel from Realtime client.
     *
     * @param {RealtimeChannel} channel - The name of the Realtime channel.
     *
     */ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
     * Unsubscribes and removes all Realtime channels from Realtime client.
     */ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    _getAccessToken() {
        var _a, _b;
        return $c0000f8ecf746878$var$__awaiter(this, void 0, void 0, function*() {
            if (this.accessToken) return yield this.accessToken();
            const { data: data } = yield this.auth.getSession();
            return (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : null;
        });
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug }, headers, fetch) {
        var _a;
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new (0, $33f2e379812addff$export$8199a418bb09bd56)({
            url: this.authUrl,
            headers: Object.assign(Object.assign({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            fetch: fetch,
            // auth checks if there is a custom authorizaiton header using this flag
            // so it knows whether to return an error when getUser is called with no session
            hasCustomAuthorizationHeader: (_a = 'Authorization' in this.headers, _a !== void 0) ? _a : false
        });
    }
    _initRealtimeClient(options) {
        return new (0, $da4299f5ff06d7dc$export$2e2bcd8739ae039)(this.realtimeUrl, Object.assign(Object.assign({}, options), {
            params: Object.assign({
                apikey: this.supabaseKey
            }, options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        let data = this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, 'CLIENT', session === null || session === void 0 ? void 0 : session.access_token);
        });
        return data;
    }
    _handleTokenChanged(event, source, token) {
        if ((event === 'TOKEN_REFRESHED' || event === 'SIGNED_IN') && this.changedAccessToken !== token) {
            // Token has changed
            this.realtime.setAuth(token !== null && token !== void 0 ? token : null);
            this.changedAccessToken = token;
        } else if (event === 'SIGNED_OUT') {
            // Token is removed
            this.realtime.setAuth(this.supabaseKey);
            if (source == 'STORAGE') this.auth.signOut();
            this.changedAccessToken = undefined;
        }
    }
}





const $f6cae8ff2a79bc86$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new (0, $c0000f8ecf746878$export$2e2bcd8739ae039)(supabaseUrl, supabaseKey, options);
};


// Create a single supabase client for interacting with your database
const $22d3d943b761a5c9$var$supabaseUrl = 'https://beozideqkbgwtxmymicp.supabase.co';
const $22d3d943b761a5c9$var$supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJlb3ppZGVxa2Jnd3R4bXltaWNwIiwicm9sZSI6ImFub24iLCJpYXQiOjE2Nzg1NDIyMzYsImV4cCI6MTk5NDExODIzNn0.AvO1vN8Cee4ByXU6bcDQ6xZpWzh-h5rPaQJsnQf7poQ';
const $22d3d943b761a5c9$export$a0b632a28672d3c0 = (0, $f6cae8ff2a79bc86$export$5d730b7aed1a3eb0)($22d3d943b761a5c9$var$supabaseUrl, $22d3d943b761a5c9$var$supabaseKey);


const $5f9ff9fded7ff792$export$cf8f628f441da87a = {
    metric: {
        label: 'metric'
    },
    imperial: {
        label: 'imperial'
    }
};
class $5f9ff9fded7ff792$export$a81c579a392aa9d2 {
    async getCurrentUser() {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession();
        if (error || !data.session) return null;
        return {
            id: data.session.user.id,
            name: data.session.user.email
        };
    }
    async signInGoogle() {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.signInWithOAuth({
            provider: 'google',
            options: {
                redirectTo: "https://terrasketch.app/"
            }
        });
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    async signOut() {
        localStorage.clear();
        const { error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.signOut();
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    async signUpEmailPassword(email, password) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.signUp({
            email: email,
            password: password,
            options: {
                emailRedirectTo: window.location.origin
            }
        });
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    async signInEmailPassword(email, password) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.signInWithPassword({
            email: email,
            password: password
        });
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    async resetPassword(email) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.resetPasswordForEmail(email, {
            redirectTo: `${window.location.origin}/change-password`
        });
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    async changePassword(password) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.updateUser({
            password: password
        });
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    async signUpGoogle() {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.signInWithOAuth({
            provider: 'google'
        });
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    async getUserSettings() {
        //проверить тип возвращаемого значения
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('user_settings').select('id, userName, metricSystem').eq('id', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id);
        if (error) return {
            success: false,
            error: error.message
        };
        else if (!data || data.length === 0) return {
            success: true,
            data: {
                userName: '',
                metricSystem: 'metric',
                email: (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.email
            }
        };
        else return {
            success: true,
            data: data[0]
        };
    }
    async changeUserSettings(userSettings) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('user_settings').upsert({
            metricSystem: userSettings.metricSystem,
            userName: userSettings.userName,
            id: (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id
        });
        if (error) return {
            success: false,
            error: error.message
        };
        else return {
            success: true
        };
    }
    async deleteCurrentUser() {
        const userId = (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id;
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).functions.invoke(`delete-user`, {
            body: {
                userId: userId
            }
        });
        if (error) return {
            success: false,
            error: error
        };
        this.signOut();
        return {
            success: true,
            error: error
        };
    }
    // TODO: move locales to a separate type
    getSavedUserLocale() {
        const userDefinedSavedLocale = localStorage.getItem('locale');
        if (userDefinedSavedLocale !== 'ru' && userDefinedSavedLocale !== 'en') return undefined;
        return userDefinedSavedLocale;
    }
}
const $5f9ff9fded7ff792$export$9544d5bb712b01ea = new $5f9ff9fded7ff792$export$a81c579a392aa9d2();



var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");

function $c378429cb65aa056$var$_extends() {
    $c378429cb65aa056$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c378429cb65aa056$var$_extends.apply(this, arguments);
}
const $c378429cb65aa056$var$Notify = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, style: style, className: className, duration: duration = 4.5, showProgress: showProgress, pauseOnHover: pauseOnHover = true, eventKey: eventKey, content: content, closable: closable, props: divProps, onClick: onClick, onNoticeClose: onNoticeClose, times: times, hovering: forcedHovering } = props;
    const [hovering, setHovering] = $ltGt3.useState(false);
    const [percent, setPercent] = $ltGt3.useState(0);
    const [spentTime, setSpentTime] = $ltGt3.useState(0);
    const mergedHovering = forcedHovering || hovering;
    const mergedDuration = typeof duration === 'number' ? duration : 0;
    const mergedShowProgress = mergedDuration > 0 && showProgress;
    // ======================== Close =========================
    const onInternalClose = ()=>{
        onNoticeClose(eventKey);
    };
    const onCloseKeyDown = (e)=>{
        if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER) onInternalClose();
    };
    // ======================== Effect ========================
    $ltGt3.useEffect(()=>{
        if (!mergedHovering && mergedDuration > 0) {
            const start = Date.now() - spentTime;
            const timeout = setTimeout(()=>{
                onInternalClose();
            }, mergedDuration * 1000 - spentTime);
            return ()=>{
                if (pauseOnHover) clearTimeout(timeout);
                setSpentTime(Date.now() - start);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mergedDuration,
        mergedHovering,
        times
    ]);
    $ltGt3.useEffect(()=>{
        if (!mergedHovering && mergedShowProgress && (pauseOnHover || spentTime === 0)) {
            const start = performance.now();
            let animationFrame;
            const calculate = ()=>{
                cancelAnimationFrame(animationFrame);
                animationFrame = requestAnimationFrame((timestamp)=>{
                    const runtime = timestamp + spentTime - start;
                    const progress = Math.min(runtime / (mergedDuration * 1000), 1);
                    setPercent(progress * 100);
                    if (progress < 1) calculate();
                });
            };
            calculate();
            return ()=>{
                if (pauseOnHover) cancelAnimationFrame(animationFrame);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mergedDuration,
        spentTime,
        mergedHovering,
        mergedShowProgress,
        times
    ]);
    // ======================== Closable ========================
    const closableObj = $ltGt3.useMemo(()=>{
        if (typeof closable === 'object' && closable !== null) return closable;
        return {};
    }, [
        closable
    ]);
    const ariaProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(closableObj, true);
    // ======================== Progress ========================
    const validPercent = 100 - (!percent || percent < 0 ? 0 : percent > 100 ? 100 : percent);
    // ======================== Render ========================
    const noticePrefixCls = `${prefixCls}-notice`;
    return /*#__PURE__*/ $ltGt3.createElement("div", $c378429cb65aa056$var$_extends({}, divProps, {
        ref: ref,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(noticePrefixCls, className, {
            [`${noticePrefixCls}-closable`]: closable
        }),
        style: style,
        onMouseEnter: (e)=>{
            setHovering(true);
            divProps?.onMouseEnter?.(e);
        },
        onMouseLeave: (e)=>{
            setHovering(false);
            divProps?.onMouseLeave?.(e);
        },
        onClick: onClick
    }), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${noticePrefixCls}-content`
    }, content), closable && /*#__PURE__*/ $ltGt3.createElement("button", $c378429cb65aa056$var$_extends({
        className: `${noticePrefixCls}-close`,
        onKeyDown: onCloseKeyDown,
        "aria-label": "Close"
    }, ariaProps, {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onInternalClose();
        }
    }), closableObj.closeIcon ?? 'x'), mergedShowProgress && /*#__PURE__*/ $ltGt3.createElement("progress", {
        className: `${noticePrefixCls}-progress`,
        max: "100",
        value: validPercent
    }, validPercent + '%'));
});
var $c378429cb65aa056$export$2e2bcd8739ae039 = $c378429cb65aa056$var$Notify;



var $ltGt3 = parcelRequire("ltGt3");
const $a4373403fd754cbe$export$a6e93d8cb5d50678 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createContext({});
const $a4373403fd754cbe$var$NotificationProvider = ({ children: children, classNames: classNames })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement($a4373403fd754cbe$export$a6e93d8cb5d50678.Provider, {
        value: {
            classNames: classNames
        }
    }, children);
};
var $a4373403fd754cbe$export$2e2bcd8739ae039 = $a4373403fd754cbe$var$NotificationProvider;


const $aa60675a852f5e05$var$DEFAULT_OFFSET = 8;
const $aa60675a852f5e05$var$DEFAULT_THRESHOLD = 3;
const $aa60675a852f5e05$var$DEFAULT_GAP = 16;
const $aa60675a852f5e05$var$useStack = (config)=>{
    const result = {
        offset: $aa60675a852f5e05$var$DEFAULT_OFFSET,
        threshold: $aa60675a852f5e05$var$DEFAULT_THRESHOLD,
        gap: $aa60675a852f5e05$var$DEFAULT_GAP
    };
    if (config && typeof config === 'object') {
        result.offset = config.offset ?? $aa60675a852f5e05$var$DEFAULT_OFFSET;
        result.threshold = config.threshold ?? $aa60675a852f5e05$var$DEFAULT_THRESHOLD;
        result.gap = config.gap ?? $aa60675a852f5e05$var$DEFAULT_GAP;
    }
    return [
        !!config,
        result
    ];
};
var $aa60675a852f5e05$export$2e2bcd8739ae039 = $aa60675a852f5e05$var$useStack;


function $8e44f42c1602a4b8$var$_extends() {
    $8e44f42c1602a4b8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8e44f42c1602a4b8$var$_extends.apply(this, arguments);
}
const $8e44f42c1602a4b8$var$NoticeList = (props)=>{
    const { configList: configList, placement: placement, prefixCls: prefixCls, className: className, style: style, motion: motion, onAllNoticeRemoved: onAllNoticeRemoved, onNoticeClose: onNoticeClose, stack: stackConfig } = props;
    const { classNames: ctxCls } = (0, $ltGt3.useContext)((0, $a4373403fd754cbe$export$a6e93d8cb5d50678));
    const dictRef = (0, $ltGt3.useRef)({});
    const [latestNotice, setLatestNotice] = (0, $ltGt3.useState)(null);
    const [hoverKeys, setHoverKeys] = (0, $ltGt3.useState)([]);
    const keys = configList.map((config)=>({
            config: config,
            key: String(config.key)
        }));
    const [stack, { offset: offset, threshold: threshold, gap: gap }] = (0, $aa60675a852f5e05$export$2e2bcd8739ae039)(stackConfig);
    const expanded = stack && (hoverKeys.length > 0 || keys.length <= threshold);
    const placementMotion = typeof motion === 'function' ? motion(placement) : motion;
    // Clean hover key
    (0, $ltGt3.useEffect)(()=>{
        if (stack && hoverKeys.length > 1) setHoverKeys((prev)=>prev.filter((key)=>keys.some(({ key: dataKey })=>key === dataKey)));
    }, [
        hoverKeys,
        keys,
        stack
    ]);
    // Force update latest notice
    (0, $ltGt3.useEffect)(()=>{
        if (stack && dictRef.current[keys[keys.length - 1]?.key]) setLatestNotice(dictRef.current[keys[keys.length - 1]?.key]);
    }, [
        keys,
        stack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $9073ece020846a7d$export$2e2bcd8739ae039), $8e44f42c1602a4b8$var$_extends({
        key: placement,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${placement}`, ctxCls?.list, className, {
            [`${prefixCls}-stack`]: !!stack,
            [`${prefixCls}-stack-expanded`]: expanded
        }),
        style: style,
        keys: keys,
        motionAppear: true
    }, placementMotion, {
        onAllRemoved: ()=>{
            onAllNoticeRemoved(placement);
        }
    }), ({ config: config, className: motionClassName, style: motionStyle, index: motionIndex }, nodeRef)=>{
        const { key: key, times: times } = config;
        const strKey = String(key);
        const { className: configClassName, style: configStyle, classNames: configClassNames, styles: configStyles, ...restConfig } = config;
        const dataIndex = keys.findIndex((item)=>item.key === strKey);
        // If dataIndex is -1, that means this notice has been removed in data, but still in dom
        // Should minus (motionIndex - 1) to get the correct index because keys.length is not the same as dom length
        const stackStyle = {};
        if (stack) {
            const index = keys.length - 1 - (dataIndex > -1 ? dataIndex : motionIndex - 1);
            const transformX = placement === 'top' || placement === 'bottom' ? '-50%' : '0';
            if (index > 0) {
                stackStyle.height = expanded ? dictRef.current[strKey]?.offsetHeight : latestNotice?.offsetHeight;
                // Transform
                let verticalOffset = 0;
                for(let i = 0; i < index; i++)verticalOffset += dictRef.current[keys[keys.length - 1 - i].key]?.offsetHeight + gap;
                const transformY = (expanded ? verticalOffset : index * offset) * (placement.startsWith('top') ? 1 : -1);
                const scaleX = !expanded && latestNotice?.offsetWidth && dictRef.current[strKey]?.offsetWidth ? (latestNotice?.offsetWidth - offset * 2 * (index < 3 ? index : 3)) / dictRef.current[strKey]?.offsetWidth : 1;
                stackStyle.transform = `translate3d(${transformX}, ${transformY}px, 0) scaleX(${scaleX})`;
            } else stackStyle.transform = `translate3d(${transformX}, 0, 0)`;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
            ref: nodeRef,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-notice-wrapper`, motionClassName, configClassNames?.wrapper),
            style: {
                ...motionStyle,
                ...stackStyle,
                ...configStyles?.wrapper
            },
            onMouseEnter: ()=>setHoverKeys((prev)=>prev.includes(strKey) ? prev : [
                        ...prev,
                        strKey
                    ]),
            onMouseLeave: ()=>setHoverKeys((prev)=>prev.filter((k)=>k !== strKey))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $c378429cb65aa056$export$2e2bcd8739ae039), $8e44f42c1602a4b8$var$_extends({}, restConfig, {
            ref: (node)=>{
                if (dataIndex > -1) dictRef.current[strKey] = node;
                else delete dictRef.current[strKey];
            },
            prefixCls: prefixCls,
            classNames: configClassNames,
            styles: configStyles,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(configClassName, ctxCls?.notice),
            style: configStyle,
            times: times,
            key: key,
            eventKey: key,
            onNoticeClose: onNoticeClose,
            hovering: stack && hoverKeys.length > 0
        })));
    });
};
var $8e44f42c1602a4b8$export$2e2bcd8739ae039 = $8e44f42c1602a4b8$var$NoticeList;


// ant-notification ant-notification-topRight
const $786a9a6143eaa70e$var$Notifications = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-notification', container: container, motion: motion, maxCount: maxCount, className: className, style: style, onAllRemoved: onAllRemoved, stack: stack, renderNotifications: renderNotifications } = props;
    const [configList, setConfigList] = $ltGt3.useState([]);
    // ======================== Close =========================
    const onNoticeClose = (key)=>{
        // Trigger close event
        const config = configList.find((item)=>item.key === key);
        const closable = config?.closable;
        const closableObj = closable && typeof closable === 'object' ? closable : {};
        const { onClose: closableOnClose } = closableObj;
        closableOnClose?.();
        config?.onClose?.();
        setConfigList((list)=>list.filter((item)=>item.key !== key));
    };
    // ========================= Refs =========================
    $ltGt3.useImperativeHandle(ref, ()=>({
            open: (config)=>{
                setConfigList((list)=>{
                    let clone = [
                        ...list
                    ];
                    // Replace if exist
                    const index = clone.findIndex((item)=>item.key === config.key);
                    const innerConfig = {
                        ...config
                    };
                    if (index >= 0) {
                        innerConfig.times = (list[index]?.times || 0) + 1;
                        clone[index] = innerConfig;
                    } else {
                        innerConfig.times = 0;
                        clone.push(innerConfig);
                    }
                    if (maxCount > 0 && clone.length > maxCount) clone = clone.slice(-maxCount);
                    return clone;
                });
            },
            close: (key)=>{
                onNoticeClose(key);
            },
            destroy: ()=>{
                setConfigList([]);
            }
        }));
    // ====================== Placements ======================
    const [placements, setPlacements] = $ltGt3.useState({});
    $ltGt3.useEffect(()=>{
        const nextPlacements = {};
        configList.forEach((config)=>{
            const { placement: placement = 'topRight' } = config;
            if (placement) {
                nextPlacements[placement] = nextPlacements[placement] || [];
                nextPlacements[placement].push(config);
            }
        });
        // Fill exist placements to avoid empty list causing remove without motion
        Object.keys(placements).forEach((placement)=>{
            nextPlacements[placement] = nextPlacements[placement] || [];
        });
        setPlacements(nextPlacements);
    }, [
        configList
    ]);
    // Clean up container if all notices fade out
    const onAllNoticeRemoved = (placement)=>{
        setPlacements((originPlacements)=>{
            const clone = {
                ...originPlacements
            };
            const list = clone[placement] || [];
            if (!list.length) delete clone[placement];
            return clone;
        });
    };
    // Effect tell that placements is empty now
    const emptyRef = $ltGt3.useRef(false);
    $ltGt3.useEffect(()=>{
        if (Object.keys(placements).length > 0) emptyRef.current = true;
        else if (emptyRef.current) {
            // Trigger only when from exist to empty
            onAllRemoved?.();
            emptyRef.current = false;
        }
    }, [
        placements
    ]);
    // ======================== Render ========================
    if (!container) return null;
    const placementList = Object.keys(placements);
    return /*#__PURE__*/ (0, $35c0fb1a856c78db$exports.createPortal)(/*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, placementList.map((placement)=>{
        const placementConfigList = placements[placement];
        const list = /*#__PURE__*/ $ltGt3.createElement((0, $8e44f42c1602a4b8$export$2e2bcd8739ae039), {
            key: placement,
            configList: placementConfigList,
            placement: placement,
            prefixCls: prefixCls,
            className: className?.(placement),
            style: style?.(placement),
            motion: motion,
            onNoticeClose: onNoticeClose,
            onAllNoticeRemoved: onAllNoticeRemoved,
            stack: stack
        });
        return renderNotifications ? renderNotifications(list, {
            prefixCls: prefixCls,
            key: placement
        }) : list;
    })), container);
});
var $786a9a6143eaa70e$export$2e2bcd8739ae039 = $786a9a6143eaa70e$var$Notifications;



const $cf37779611d78bda$var$defaultGetContainer = ()=>document.body;
let $cf37779611d78bda$var$uniqueKey = 0;
function $cf37779611d78bda$var$mergeConfig(...objList) {
    const clone = {};
    objList.forEach((obj)=>{
        if (obj) Object.keys(obj).forEach((key)=>{
            const val = obj[key];
            if (val !== undefined) clone[key] = val;
        });
    });
    return clone;
}
function $cf37779611d78bda$export$2e2bcd8739ae039(rootConfig = {}) {
    const { getContainer: getContainer = $cf37779611d78bda$var$defaultGetContainer, motion: motion, prefixCls: prefixCls, maxCount: maxCount, className: className, style: style, onAllRemoved: onAllRemoved, stack: stack, renderNotifications: renderNotifications, ...shareConfig } = rootConfig;
    const [container, setContainer] = $ltGt3.useState();
    const notificationsRef = $ltGt3.useRef();
    const contextHolder = /*#__PURE__*/ $ltGt3.createElement((0, $786a9a6143eaa70e$export$2e2bcd8739ae039), {
        container: container,
        ref: notificationsRef,
        prefixCls: prefixCls,
        motion: motion,
        maxCount: maxCount,
        className: className,
        style: style,
        onAllRemoved: onAllRemoved,
        stack: stack,
        renderNotifications: renderNotifications
    });
    const [taskQueue, setTaskQueue] = $ltGt3.useState([]);
    const open = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((config)=>{
        const mergedConfig = $cf37779611d78bda$var$mergeConfig(shareConfig, config);
        if (mergedConfig.key === null || mergedConfig.key === undefined) {
            mergedConfig.key = `rc-notification-${$cf37779611d78bda$var$uniqueKey}`;
            $cf37779611d78bda$var$uniqueKey += 1;
        }
        setTaskQueue((queue)=>[
                ...queue,
                {
                    type: 'open',
                    config: mergedConfig
                }
            ]);
    });
    // ========================= Refs =========================
    const api = $ltGt3.useMemo(()=>({
            open: open,
            close: (key)=>{
                setTaskQueue((queue)=>[
                        ...queue,
                        {
                            type: 'close',
                            key: key
                        }
                    ]);
            },
            destroy: ()=>{
                setTaskQueue((queue)=>[
                        ...queue,
                        {
                            type: 'destroy'
                        }
                    ]);
            }
        }), []);
    // ======================= Container ======================
    // React 18 should all in effect that we will check container in each render
    // Which means getContainer should be stable.
    $ltGt3.useEffect(()=>{
        setContainer(getContainer());
    });
    // ======================== Effect ========================
    $ltGt3.useEffect(()=>{
        // Flush task when node ready
        if (notificationsRef.current && taskQueue.length) {
            taskQueue.forEach((task)=>{
                switch(task.type){
                    case 'open':
                        notificationsRef.current.open(task.config);
                        break;
                    case 'close':
                        notificationsRef.current.close(task.key);
                        break;
                    case 'destroy':
                        notificationsRef.current.destroy();
                        break;
                }
            });
            // https://github.com/ant-design/ant-design/issues/52590
            // React `startTransition` will run once `useEffect` but many times `setState`,
            // So `setTaskQueue` with filtered array will cause infinite loop.
            // We cache the first match queue instead.
            let oriTaskQueue;
            let tgtTaskQueue;
            // React 17 will mix order of effect & setState in async
            // - open: setState[0]
            // - effect[0]
            // - open: setState[1]
            // - effect setState([]) * here will clean up [0, 1] in React 17
            setTaskQueue((oriQueue)=>{
                if (oriTaskQueue !== oriQueue || !tgtTaskQueue) {
                    oriTaskQueue = oriQueue;
                    tgtTaskQueue = oriQueue.filter((task)=>!taskQueue.includes(task));
                }
                return tgtTaskQueue;
            });
        }
    }, [
        taskQueue
    ]);
    // ======================== Return ========================
    return [
        api,
        contextHolder
    ];
}













var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $d67bd4aaa5f766fa$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $d67bd4aaa5f766fa$export$2e2bcd8739ae039 = $d67bd4aaa5f766fa$var$CheckCircleFilled;



function $0cb9ffcfb49f2ccf$var$_extends() {
    $0cb9ffcfb49f2ccf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0cb9ffcfb49f2ccf$var$_extends.apply(this, arguments);
}
const $0cb9ffcfb49f2ccf$var$CheckCircleFilled = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $0cb9ffcfb49f2ccf$var$_extends({}, props, {
        ref: ref,
        icon: (0, $d67bd4aaa5f766fa$export$2e2bcd8739ae039)
    }));
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTMuNSAzMDEuN2wtMjEwLjYgMjkyYTMxLjggMzEuOCAwIDAxLTUxLjcgMEwzMTguNSA0ODQuOWMtMy44LTUuMyAwLTEyLjcgNi41LTEyLjdoNDYuOWMxMC4yIDAgMTkuOSA0LjkgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjMgMTUuNi0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi41IDEyLjd6IiAvPjwvc3ZnPg==) */ const $0cb9ffcfb49f2ccf$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($0cb9ffcfb49f2ccf$var$CheckCircleFilled);
var $0cb9ffcfb49f2ccf$export$2e2bcd8739ae039 = $0cb9ffcfb49f2ccf$var$RefIcon;




var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $667d177906f36dff$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $667d177906f36dff$export$2e2bcd8739ae039 = $667d177906f36dff$var$ExclamationCircleFilled;



function $951db5e2b3978281$var$_extends() {
    $951db5e2b3978281$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $951db5e2b3978281$var$_extends.apply(this, arguments);
}
const $951db5e2b3978281$var$ExclamationCircleFilled = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $951db5e2b3978281$var$_extends({}, props, {
        ref: ref,
        icon: (0, $667d177906f36dff$export$2e2bcd8739ae039)
    }));
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const $951db5e2b3978281$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($951db5e2b3978281$var$ExclamationCircleFilled);
var $951db5e2b3978281$export$2e2bcd8739ae039 = $951db5e2b3978281$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $f3bb48244487baad$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $f3bb48244487baad$export$2e2bcd8739ae039 = $f3bb48244487baad$var$InfoCircleFilled;



function $bfd6614352ed1ca0$var$_extends() {
    $bfd6614352ed1ca0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bfd6614352ed1ca0$var$_extends.apply(this, arguments);
}
const $bfd6614352ed1ca0$var$InfoCircleFilled = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $bfd6614352ed1ca0$var$_extends({}, props, {
        ref: ref,
        icon: (0, $f3bb48244487baad$export$2e2bcd8739ae039)
    }));
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const $bfd6614352ed1ca0$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($bfd6614352ed1ca0$var$InfoCircleFilled);
var $bfd6614352ed1ca0$export$2e2bcd8739ae039 = $bfd6614352ed1ca0$var$RefIcon;













const $bd83193387ad7d19$var$genMessageStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, boxShadow: boxShadow, colorText: colorText, colorSuccess: colorSuccess, colorError: colorError, colorWarning: colorWarning, colorInfo: colorInfo, fontSizeLG: fontSizeLG, motionEaseInOutCirc: motionEaseInOutCirc, motionDurationSlow: motionDurationSlow, marginXS: marginXS, paddingXS: paddingXS, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, contentPadding: // Custom token
    contentPadding, contentBg: contentBg } = token;
    const noticeCls = `${componentCls}-notice`;
    const messageMoveIn = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('MessageMoveIn', {
        '0%': {
            padding: 0,
            transform: 'translateY(-100%)',
            opacity: 0
        },
        '100%': {
            padding: paddingXS,
            transform: 'translateY(0)',
            opacity: 1
        }
    });
    const messageMoveOut = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('MessageMoveOut', {
        '0%': {
            maxHeight: token.height,
            padding: paddingXS,
            opacity: 1
        },
        '100%': {
            maxHeight: 0,
            padding: 0,
            opacity: 0
        }
    });
    const noticeStyle = {
        padding: paddingXS,
        textAlign: 'center',
        [`${componentCls}-custom-content`]: {
            display: 'flex',
            alignItems: 'center'
        },
        [`${componentCls}-custom-content > ${iconCls}`]: {
            marginInlineEnd: marginXS,
            // affected by ltr or rtl
            fontSize: fontSizeLG
        },
        [`${noticeCls}-content`]: {
            display: 'inline-block',
            padding: contentPadding,
            background: contentBg,
            borderRadius: borderRadiusLG,
            boxShadow: boxShadow,
            pointerEvents: 'all'
        },
        [`${componentCls}-success > ${iconCls}`]: {
            color: colorSuccess
        },
        [`${componentCls}-error > ${iconCls}`]: {
            color: colorError
        },
        [`${componentCls}-warning > ${iconCls}`]: {
            color: colorWarning
        },
        [`${componentCls}-info > ${iconCls},
      ${componentCls}-loading > ${iconCls}`]: {
            color: colorInfo
        }
    };
    return [
        // ============================ Holder ============================
        {
            [componentCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                color: colorText,
                position: 'fixed',
                top: marginXS,
                width: '100%',
                pointerEvents: 'none',
                zIndex: zIndexPopup,
                [`${componentCls}-move-up`]: {
                    animationFillMode: 'forwards'
                },
                [`
        ${componentCls}-move-up-appear,
        ${componentCls}-move-up-enter
      `]: {
                    animationName: messageMoveIn,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`
        ${componentCls}-move-up-appear${componentCls}-move-up-appear-active,
        ${componentCls}-move-up-enter${componentCls}-move-up-enter-active
      `]: {
                    animationPlayState: 'running'
                },
                [`${componentCls}-move-up-leave`]: {
                    animationName: messageMoveOut,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`${componentCls}-move-up-leave${componentCls}-move-up-leave-active`]: {
                    animationPlayState: 'running'
                },
                '&-rtl': {
                    direction: 'rtl',
                    span: {
                        direction: 'rtl'
                    }
                }
            }
        },
        // ============================ Notice ============================
        {
            [componentCls]: {
                [`${noticeCls}-wrapper`]: {
                    ...noticeStyle
                }
            }
        },
        // ============================= Pure =============================
        {
            [`${componentCls}-notice-pure-panel`]: {
                ...noticeStyle,
                padding: 0,
                textAlign: 'start'
            }
        }
    ];
};
const $bd83193387ad7d19$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, $ad5b6b465efa8f67$export$33ada7d8845f7e5) + 10,
        contentBg: token.colorBgElevated,
        contentPadding: `${(token.controlHeightLG - token.fontSize * token.lineHeight) / 2}px ${token.paddingSM}px`
    });
var // ============================== Export ==============================
$bd83193387ad7d19$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Message', (token)=>{
    // Gen-style functions here
    const combinedToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        height: 150
    });
    return $bd83193387ad7d19$var$genMessageStyle(combinedToken);
}, $bd83193387ad7d19$export$9ca1be8807fe0675);


"use client";
const $ff6220d8b8fa4ca4$export$ad8f8fc3bcd61b4a = {
    info: /*#__PURE__*/ $ltGt3.createElement((0, $bfd6614352ed1ca0$export$2e2bcd8739ae039), null),
    success: /*#__PURE__*/ $ltGt3.createElement((0, $0cb9ffcfb49f2ccf$export$2e2bcd8739ae039), null),
    error: /*#__PURE__*/ $ltGt3.createElement((0, $332936b0d9ac1f65$export$2e2bcd8739ae039), null),
    warning: /*#__PURE__*/ $ltGt3.createElement((0, $951db5e2b3978281$export$2e2bcd8739ae039), null),
    loading: /*#__PURE__*/ $ltGt3.createElement((0, $8ede40f9e9e4f5c2$export$2e2bcd8739ae039), null)
};
const $ff6220d8b8fa4ca4$export$429c001938db3a78 = (props)=>{
    const { prefixCls: prefixCls, type: type, icon: icon, children: children, classNames: pureContentClassNames, styles: styles } = props;
    const iconElement = icon || type && $ff6220d8b8fa4ca4$export$ad8f8fc3bcd61b4a[type];
    const iconNode = (0, $66d38239e1a27993$export$e530037191fcd5d7)(iconElement, (currentProps)=>{
        const mergedStyle = {
            ...currentProps?.style,
            ...styles?.icon
        };
        return {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(currentProps.className, pureContentClassNames?.icon),
            style: mergedStyle
        };
    });
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-custom-content`, `${prefixCls}-${type}`)
    }, iconNode, /*#__PURE__*/ $ltGt3.createElement("span", {
        className: pureContentClassNames?.content,
        style: styles?.content
    }, children));
};
/** @private Internal Component. Do not use in your production. */ const $ff6220d8b8fa4ca4$var$PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, className: className, style: style, type: type, icon: icon, content: content, classNames: messageClassNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('message');
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $bd83193387ad7d19$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        messageClassNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    return /*#__PURE__*/ $ltGt3.createElement((0, $c378429cb65aa056$export$2e2bcd8739ae039), {
        ...restProps,
        prefixCls: prefixCls,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(contextClassName, mergedClassNames.root, className, hashId, `${prefixCls}-notice-pure-panel`, cssVarCls, rootCls),
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        eventKey: "pure",
        duration: null,
        content: /*#__PURE__*/ $ltGt3.createElement($ff6220d8b8fa4ca4$export$429c001938db3a78, {
            prefixCls: prefixCls,
            type: type,
            icon: icon,
            classNames: mergedClassNames,
            styles: mergedStyles
        }, content)
    });
};
var $ff6220d8b8fa4ca4$export$2e2bcd8739ae039 = $ff6220d8b8fa4ca4$var$PurePanel;



function $a0a45d334769b36e$export$7b8936ddc277a29a(prefixCls, transitionName) {
    return {
        motionName: transitionName ?? `${prefixCls}-move-up`
    };
}
function $a0a45d334769b36e$export$52ce770daa307a45(openFn) {
    let closeFn;
    const closePromise = new Promise((resolve)=>{
        closeFn = openFn(()=>{
            resolve(true);
        });
    });
    const result = ()=>{
        closeFn?.();
    };
    result.then = (filled, rejected)=>closePromise.then(filled, rejected);
    result.promise = closePromise;
    return result;
}


"use client";
const $784f9dc2d059291c$var$DEFAULT_OFFSET = 8;
const $784f9dc2d059291c$var$DEFAULT_DURATION = 3;
const $784f9dc2d059291c$var$Wrapper = ({ children: children, prefixCls: prefixCls })=>{
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $bd83193387ad7d19$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return /*#__PURE__*/ $ltGt3.createElement((0, $a4373403fd754cbe$export$2e2bcd8739ae039), {
        classNames: {
            list: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls)
        }
    }, children);
};
const $784f9dc2d059291c$var$renderNotifications = (node, { prefixCls: prefixCls, key: key })=>/*#__PURE__*/ $ltGt3.createElement($784f9dc2d059291c$var$Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
const $784f9dc2d059291c$var$Holder = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { top: top, prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount: maxCount, duration: duration = $784f9dc2d059291c$var$DEFAULT_DURATION, rtl: rtl, transitionName: transitionName, onAllRemoved: onAllRemoved, pauseOnHover: pauseOnHover = true } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('message');
    const { message: message } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    // =============================== Style ===============================
    const getStyle = ()=>({
            left: '50%',
            transform: 'translateX(-50%)',
            top: top ?? $784f9dc2d059291c$var$DEFAULT_OFFSET
        });
    const getClassName = ()=>(0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
            [`${prefixCls}-rtl`]: rtl ?? direction === 'rtl'
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, $a0a45d334769b36e$export$7b8936ddc277a29a)(prefixCls, transitionName);
    // Use useMergeSemantic to merge classNames and styles
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        props?.classNames,
        message?.classNames
    ], [
        props?.styles,
        message?.styles
    ], {
        props: props
    });
    // ============================== Origin ===============================
    const [api, holder] = (0, $cf37779611d78bda$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        // closable=false requires-no closeIcon
        closable: false,
        duration: duration,
        getContainer: ()=>staticGetContainer?.() || getPopupContainer?.() || document.body,
        maxCount: maxCount,
        onAllRemoved: onAllRemoved,
        renderNotifications: $784f9dc2d059291c$var$renderNotifications,
        pauseOnHover: pauseOnHover
    });
    // ================================ Ref ================================
    $ltGt3.useImperativeHandle(ref, ()=>({
            ...api,
            prefixCls: prefixCls,
            message: message,
            classNames: mergedClassNames,
            styles: mergedStyles
        }));
    return holder;
});
// ==============================================================================
// ==                                   Hook                                   ==
// ==============================================================================
let $784f9dc2d059291c$var$keyIndex = 0;
function $784f9dc2d059291c$export$1689db33b6c27d9e(messageConfig) {
    const holderRef = $ltGt3.useRef(null);
    const warning = (0, $9530c27c700696d0$export$cf977aa92c751e61)('Message');
    // ================================ API ================================
    const wrapAPI = $ltGt3.useMemo(()=>{
        // Wrap with notification content
        // >>> close
        const close = (key)=>{
            holderRef.current?.close(key);
        };
        // >>> Open
        const open = (config)=>{
            if (!holderRef.current) {
                const fakeResult = ()=>{};
                // eslint-disable-next-line react-hooks/immutability
                fakeResult.then = ()=>{};
                return fakeResult;
            }
            const { open: originOpen, prefixCls: prefixCls, message: message, classNames: originClassNames, styles: originStyles } = holderRef.current;
            const contextClassName = message?.className || {};
            const contextStyle = message?.style || {};
            const rawContextClassNames = message?.classNames || {};
            const rawContextStyles = message?.styles || {};
            const noticePrefixCls = `${prefixCls}-notice`;
            const { content: content, icon: icon, type: type, key: key, className: className, style: style, onClose: onClose, classNames: configClassNames = {}, styles: styles = {}, ...restConfig } = config;
            let mergedKey = key;
            if (mergedKey === undefined || mergedKey === null) {
                $784f9dc2d059291c$var$keyIndex += 1;
                mergedKey = `antd-message-${$784f9dc2d059291c$var$keyIndex}`;
            }
            const contextConfig = {
                ...messageConfig,
                ...config
            };
            const contextClassNames = (0, $859a31e79ed756e5$export$ccd424010a24474f)(rawContextClassNames, {
                props: contextConfig
            });
            const semanticClassNames = (0, $859a31e79ed756e5$export$ccd424010a24474f)(configClassNames, {
                props: contextConfig
            });
            const contextStyles = (0, $859a31e79ed756e5$export$ccd424010a24474f)(rawContextStyles, {
                props: contextConfig
            });
            const semanticStyles = (0, $859a31e79ed756e5$export$ccd424010a24474f)(styles, {
                props: contextConfig
            });
            const mergedClassNames = (0, $859a31e79ed756e5$export$8bf64cd1c29a1310)(undefined, contextClassNames, semanticClassNames, originClassNames);
            const mergedStyles = (0, $859a31e79ed756e5$export$e618dc39ac9ad607)(contextStyles, semanticStyles, originStyles);
            return (0, $a0a45d334769b36e$export$52ce770daa307a45)((resolve)=>{
                originOpen({
                    ...restConfig,
                    key: mergedKey,
                    content: /*#__PURE__*/ $ltGt3.createElement((0, $ff6220d8b8fa4ca4$export$429c001938db3a78), {
                        prefixCls: prefixCls,
                        type: type,
                        icon: icon,
                        classNames: mergedClassNames,
                        styles: mergedStyles
                    }, content),
                    placement: 'top',
                    className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                        [`${noticePrefixCls}-${type}`]: type
                    }, className, contextClassName, mergedClassNames.root),
                    style: {
                        ...mergedStyles.root,
                        ...contextStyle,
                        ...style
                    },
                    onClose: ()=>{
                        onClose?.();
                        resolve();
                    }
                });
                // Return close function
                return ()=>{
                    close(mergedKey);
                };
            });
        };
        // >>> destroy
        const destroy = (key)=>{
            if (key !== undefined) close(key);
            else holderRef.current?.destroy();
        };
        const clone = {
            open: open,
            destroy: destroy
        };
        const keys = [
            'info',
            'success',
            'warning',
            'error',
            'loading'
        ];
        keys.forEach((type)=>{
            const typeOpen = (jointContent, duration, onClose)=>{
                let config;
                if (jointContent && typeof jointContent === 'object' && 'content' in jointContent) config = jointContent;
                else config = {
                    content: jointContent
                };
                // Params
                let mergedDuration;
                let mergedOnClose;
                if (typeof duration === 'function') mergedOnClose = duration;
                else {
                    mergedDuration = duration;
                    mergedOnClose = onClose;
                }
                const mergedConfig = {
                    onClose: mergedOnClose,
                    duration: mergedDuration,
                    ...config,
                    type: type
                };
                return open(mergedConfig);
            };
            clone[type] = typeOpen;
        });
        return clone;
    }, []);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ $ltGt3.createElement($784f9dc2d059291c$var$Holder, {
            key: "message-holder",
            ...messageConfig,
            ref: holderRef
        })
    ];
}
function $784f9dc2d059291c$export$2e2bcd8739ae039(messageConfig) {
    return $784f9dc2d059291c$export$1689db33b6c27d9e(messageConfig);
}




var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
const $d30d783afd306d17$export$26425c9dd59b4436 = ()=>{
    const [elements, setElements] = $ltGt3.useState([]);
    const patchElement = $ltGt3.useCallback((element)=>{
        // append a new element to elements (and create a new ref)
        setElements((originElements)=>[].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(originElements), [
                element
            ]));
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return ()=>{
            setElements((originElements)=>originElements.filter((ele)=>ele !== element));
        };
    }, []);
    return [
        elements,
        patchElement
    ];
};



var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");













var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");



"use client";
const $34d79cb4b2f20181$var$isThenable = (thing)=>{
    return typeof thing?.then === 'function';
};
const $34d79cb4b2f20181$var$ActionButton = (props)=>{
    const { type: type, children: children, prefixCls: prefixCls, buttonProps: buttonProps, close: close, autoFocus: autoFocus, emitEvent: emitEvent, isSilent: isSilent, quitOnNullishReturnValue: quitOnNullishReturnValue, actionFn: actionFn } = props;
    const clickedRef = $ltGt3.useRef(false);
    const buttonRef = $ltGt3.useRef(null);
    const [loading, setLoading] = (0, $451586bd8fd5d39a$export$2e2bcd8739ae039)(false);
    const onInternalClose = (...args)=>{
        close?.(...args);
    };
    $ltGt3.useEffect(()=>{
        let timeoutId = null;
        if (autoFocus) timeoutId = setTimeout(()=>{
            buttonRef.current?.focus({
                preventScroll: true
            });
        });
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        autoFocus
    ]);
    const handlePromiseOnOk = (returnValueOfOnOk)=>{
        if (!$34d79cb4b2f20181$var$isThenable(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then((...args)=>{
            setLoading(false, true);
            onInternalClose.apply(void 0, args);
            clickedRef.current = false;
        }, (e)=>{
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            // Do not throw if is `await` mode
            if (isSilent?.()) return;
            return Promise.reject(e);
        });
    };
    const onClick = (e)=>{
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        let returnValueOfOnOk;
        if (emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (quitOnNullishReturnValue && !$34d79cb4b2f20181$var$isThenable(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!$34d79cb4b2f20181$var$isThenable(returnValueOfOnOk)) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return /*#__PURE__*/ $ltGt3.createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
        ...(0, $ea3450de0c6c5939$export$19bc9a290855952)(type),
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls,
        ...buttonProps,
        ref: buttonRef
    }, children);
};
var $34d79cb4b2f20181$export$2e2bcd8739ae039 = $34d79cb4b2f20181$var$ActionButton;



var $ltGt3 = parcelRequire("ltGt3");
const $9b2f325fa698619b$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createContext({});
const { Provider: $9b2f325fa698619b$export$7c9538f5f3c365e9 } = $9b2f325fa698619b$export$ab57792b9b6974a6;


"use client";
const $0e803ac75639c26b$var$ConfirmCancelBtn = ()=>{
    const { autoFocusButton: autoFocusButton, cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, isSilent: isSilent, mergedOkCancel: mergedOkCancel, rootPrefixCls: rootPrefixCls, close: close, onCancel: onCancel, onConfirm: onConfirm, onClose: onClose } = (0, $ltGt3.useContext)((0, $9b2f325fa698619b$export$ab57792b9b6974a6));
    return mergedOkCancel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $34d79cb4b2f20181$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        actionFn: onCancel,
        close: (...args)=>{
            close?.(...args);
            onConfirm?.(false);
            onClose?.();
        },
        autoFocus: autoFocusButton === 'cancel',
        buttonProps: cancelButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, cancelTextLocale) : null;
};
var $0e803ac75639c26b$export$2e2bcd8739ae039 = $0e803ac75639c26b$var$ConfirmCancelBtn;



var $ltGt3 = parcelRequire("ltGt3");


"use client";
const $17ee43f6c64dad41$var$ConfirmOkBtn = ()=>{
    const { autoFocusButton: autoFocusButton, close: close, isSilent: isSilent, okButtonProps: okButtonProps, rootPrefixCls: rootPrefixCls, okTextLocale: okTextLocale, okType: okType, onConfirm: onConfirm, onOk: onOk, onClose: onClose } = (0, $ltGt3.useContext)((0, $9b2f325fa698619b$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $34d79cb4b2f20181$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        type: okType || 'primary',
        actionFn: onOk,
        close: (...args)=>{
            close?.(...args);
            onConfirm?.(true);
            onClose?.();
        },
        autoFocus: autoFocusButton === 'ok',
        buttonProps: okButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, okTextLocale);
};
var $17ee43f6c64dad41$export$2e2bcd8739ae039 = $17ee43f6c64dad41$var$ConfirmOkBtn;




var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
const $94045fba7435ea40$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $ltGt3.createContext({});








var $ltGt3 = parcelRequire("ltGt3");
// =============================== Motion ===============================
function $3284d02beae54fc6$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    let motionName = transitionName;
    if (!motionName && animationName) motionName = `${prefixCls}-${animationName}`;
    return motionName;
}
// =============================== Offset ===============================
function $3284d02beae54fc6$var$getScroll(w, top) {
    let ret = w[`page${top ? 'Y' : 'X'}Offset`];
    const method = `scroll${top ? 'Top' : 'Left'}`;
    if (typeof ret !== 'number') {
        const d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') ret = d.body[method];
    }
    return ret;
}
function $3284d02beae54fc6$export$cc800923e997bb8(el) {
    const rect = el.getBoundingClientRect();
    const pos = {
        left: rect.left,
        top: rect.top
    };
    const doc = el.ownerDocument;
    const w = doc.defaultView || doc.parentWindow;
    pos.left += $3284d02beae54fc6$var$getScroll(w);
    pos.top += $3284d02beae54fc6$var$getScroll(w, true);
    return pos;
}



var $ltGt3 = parcelRequire("ltGt3");






var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
var $4a0f8e5d85610b61$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.memo(({ children: children })=>children, (_, { shouldUpdate: shouldUpdate })=>!shouldUpdate);



function $d1685b6dd6bb6981$var$_extends() {
    $d1685b6dd6bb6981$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d1685b6dd6bb6981$var$_extends.apply(this, arguments);
}
const $d1685b6dd6bb6981$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: 'hidden',
    outline: 'none'
};
const $d1685b6dd6bb6981$var$entityStyle = {
    outline: 'none'
};
const $d1685b6dd6bb6981$var$Panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, title: title, ariaId: ariaId, footer: footer, closable: closable, closeIcon: closeIcon, onClose: onClose, children: children, bodyStyle: bodyStyle, bodyProps: bodyProps, modalRender: modalRender, onMouseDown: onMouseDown, onMouseUp: onMouseUp, holderRef: holderRef, visible: visible, forceRender: forceRender, width: width, height: height, classNames: modalClassNames, styles: modalStyles } = props;
    // ================================= Refs =================================
    const { panel: panelRef } = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $94045fba7435ea40$export$ee4e38b469b6f5d1));
    const mergedRef = (0, $22ff46e28c8066e1$export$1d1c999670a1285d)(holderRef, panelRef);
    const sentinelStartRef = (0, $ltGt3.useRef)(null);
    const sentinelEndRef = (0, $ltGt3.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useImperativeHandle(ref, ()=>({
            focus: ()=>{
                sentinelStartRef.current?.focus({
                    preventScroll: true
                });
            },
            changeActive: (next)=>{
                const { activeElement: activeElement } = document;
                if (next && activeElement === sentinelEndRef.current) sentinelStartRef.current.focus({
                    preventScroll: true
                });
                else if (!next && activeElement === sentinelStartRef.current) sentinelEndRef.current.focus({
                    preventScroll: true
                });
            }
        }));
    // ================================ Style =================================
    const contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    const footerNode = footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-footer`, modalClassNames?.footer),
        style: {
            ...modalStyles?.footer
        }
    }, footer) : null;
    const headerNode = title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-header`, modalClassNames?.header),
        style: {
            ...modalStyles?.header
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-title`, modalClassNames?.title),
        id: ariaId,
        style: {
            ...modalStyles?.title
        }
    }, title)) : null;
    const closableObj = (0, $ltGt3.useMemo)(()=>{
        if (typeof closable === 'object' && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
                className: `${prefixCls}-close-x`
            })
        };
        return {};
    }, [
        closable,
        closeIcon,
        prefixCls
    ]);
    const ariaProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(closableObj, true);
    const closeBtnIsDisabled = typeof closable === 'object' && closable.disabled;
    const closerNode = closable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("button", $d1685b6dd6bb6981$var$_extends({
        type: "button",
        onClick: onClose,
        "aria-label": "Close"
    }, ariaProps, {
        className: `${prefixCls}-close`,
        disabled: closeBtnIsDisabled
    }), closableObj.closeIcon) : null;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-container`, modalClassNames?.container),
        style: modalStyles?.container
    }, closerNode, headerNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", $d1685b6dd6bb6981$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-body`, modalClassNames?.body),
        style: {
            ...bodyStyle,
            ...modalStyles?.body
        }
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: mergedRef,
        style: {
            ...style,
            ...contentStyle
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        ref: sentinelStartRef,
        tabIndex: 0,
        style: $d1685b6dd6bb6981$var$entityStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $4a0f8e5d85610b61$export$2e2bcd8739ae039), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $d1685b6dd6bb6981$var$sentinelStyle
    }));
});
var $d1685b6dd6bb6981$export$2e2bcd8739ae039 = $d1685b6dd6bb6981$var$Panel;


function $8d2b15740cd7e629$var$_extends() {
    $8d2b15740cd7e629$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8d2b15740cd7e629$var$_extends.apply(this, arguments);
}
const $8d2b15740cd7e629$var$Content = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, title: title, style: style, className: className, visible: visible, forceRender: forceRender, destroyOnHidden: destroyOnHidden, motionName: motionName, ariaId: ariaId, onVisibleChanged: onVisibleChanged, mousePosition: mousePosition } = props;
    const dialogRef = (0, $ltGt3.useRef)(null);
    const panelRef = (0, $ltGt3.useRef)(null);
    // ============================== Refs ==============================
    $ltGt3.useImperativeHandle(ref, ()=>({
            ...panelRef.current,
            inMotion: dialogRef.current.inMotion,
            enableMotion: dialogRef.current.enableMotion
        }));
    // ============================= Style ==============================
    const [transformOrigin, setTransformOrigin] = $ltGt3.useState();
    const contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        const elementOffset = (0, $3284d02beae54fc6$export$cc800923e997bb8)(dialogRef.current.nativeElement);
        setTransformOrigin(mousePosition && (mousePosition.x || mousePosition.y) ? `${mousePosition.x - elementOffset.left}px ${mousePosition.y - elementOffset.top}px` : '');
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnHidden,
        ref: dialogRef
    }, ({ className: motionClassName, style: motionStyle }, motionRef)=>/*#__PURE__*/ $ltGt3.createElement((0, $d1685b6dd6bb6981$export$2e2bcd8739ae039), $8d2b15740cd7e629$var$_extends({}, props, {
            ref: panelRef,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: {
                ...motionStyle,
                ...style,
                ...contentStyle
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(className, motionClassName)
        })));
});
var $8d2b15740cd7e629$export$2e2bcd8739ae039 = $8d2b15740cd7e629$var$Content;



var $ltGt3 = parcelRequire("ltGt3");


function $0c58e5d1b01acc9b$var$_extends() {
    $0c58e5d1b01acc9b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0c58e5d1b01acc9b$var$_extends.apply(this, arguments);
}
const $0c58e5d1b01acc9b$var$Mask = (props)=>{
    const { prefixCls: prefixCls, style: style, visible: visible, maskProps: maskProps, motionName: motionName, className: className } = props;
    return /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: `${prefixCls}-mask-hidden`
    }, ({ className: motionClassName, style: motionStyle }, ref)=>/*#__PURE__*/ $ltGt3.createElement("div", $0c58e5d1b01acc9b$var$_extends({
            ref: ref,
            style: {
                ...motionStyle,
                ...style
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-mask`, motionClassName, className)
        }, maskProps)));
};
var $0c58e5d1b01acc9b$export$2e2bcd8739ae039 = $0c58e5d1b01acc9b$var$Mask;



function $869d5c8848d0945a$var$_extends() {
    $869d5c8848d0945a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $869d5c8848d0945a$var$_extends.apply(this, arguments);
}
const $869d5c8848d0945a$var$Dialog = (props)=>{
    const { prefixCls: prefixCls = 'rc-dialog', zIndex: zIndex, visible: visible = false, keyboard: keyboard = true, focusTriggerAfterClose: focusTriggerAfterClose = true, wrapStyle: // scrollLocker,
    // Wrapper
    wrapStyle, wrapClassName: wrapClassName, wrapProps: wrapProps, onClose: onClose, afterOpenChange: afterOpenChange, afterClose: afterClose, transitionName: // Dialog
    transitionName, animation: animation, closable: closable = true, mask: // Mask
    mask = true, maskTransitionName: maskTransitionName, maskAnimation: maskAnimation, maskClosable: maskClosable = true, maskStyle: maskStyle, maskProps: maskProps, rootClassName: rootClassName, rootStyle: rootStyle, classNames: modalClassNames, styles: modalStyles } = props;
    var prop;
    const lastOutSideActiveElementRef = (0, $ltGt3.useRef)(null);
    const wrapperRef = (0, $ltGt3.useRef)(null);
    const contentRef = (0, $ltGt3.useRef)(null);
    const [animatedVisible, setAnimatedVisible] = $ltGt3.useState(visible);
    // ========================== Init ==========================
    const ariaId = (0, $1fb03482b73301f3$export$2e2bcd8739ae039)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $cec58e9a999b061e$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $cec58e9a999b061e$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) contentRef.current?.focus();
    }
    // ========================= Events =========================
    // Close action will trigger by:
    //   1. When hide motion end
    //   2. Controlled `open` to `false` immediately after set to `true` which will not trigger motion
    function doClose() {
        // Clean up scroll bar & focus back
        setAnimatedVisible(false);
        if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
            try {
                lastOutSideActiveElementRef.current.focus({
                    preventScroll: true
                });
            } catch (e) {
            // Do nothing
            }
            lastOutSideActiveElementRef.current = null;
        }
        // Trigger afterClose only when change visible from true to false
        if (animatedVisible) afterClose?.();
    }
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else doClose();
        afterOpenChange?.(newVisible);
    }
    function onInternalClose(e) {
        onClose?.(e);
    }
    // >>> Content
    const contentClickRef = (0, $ltGt3.useRef)(false);
    const contentTimeoutRef = (0, $ltGt3.useRef)(null);
    // We need record content click incase content popup out of dialog
    const onContentMouseDown = ()=>{
        clearTimeout(contentTimeoutRef.current);
        contentClickRef.current = true;
    };
    const onContentMouseUp = ()=>{
        contentTimeoutRef.current = setTimeout(()=>{
            contentClickRef.current = false;
        });
    };
    // >>> Wrapper
    // Close only when element not on dialog
    let onWrapperClick = null;
    if (maskClosable) onWrapperClick = (e)=>{
        if (contentClickRef.current) contentClickRef.current = false;
        else if (wrapperRef.current === e.target) onInternalClose(e);
    };
    function onWrapperKeyDown(e) {
        if (keyboard && e.keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ESC) {
            e.stopPropagation();
            onInternalClose(e);
            return;
        }
        // keep focus inside dialog
        if (visible && e.keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).TAB) contentRef.current.changeActive(!e.shiftKey);
    }
    // ========================= Effect =========================
    (0, $ltGt3.useEffect)(()=>{
        if (visible) {
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
        } else if (animatedVisible && contentRef.current.enableMotion() && !contentRef.current.inMotion()) doClose();
    }, [
        visible
    ]);
    // Remove direct should also check the scroll bar update
    (0, $ltGt3.useEffect)(()=>()=>{
            clearTimeout(contentTimeoutRef.current);
        }, []);
    const mergedStyle = {
        zIndex: zIndex,
        ...wrapStyle,
        ...modalStyles?.wrapper,
        display: !animatedVisible ? 'none' : null
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $ltGt3.createElement("div", $869d5c8848d0945a$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-root`, rootClassName),
        style: rootStyle
    }, (0, $297f85de79f8d325$export$2e2bcd8739ae039)(props, {
        data: true
    })), /*#__PURE__*/ $ltGt3.createElement((0, $0c58e5d1b01acc9b$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $3284d02beae54fc6$export$ec1a7ebf4579c1c3)(prefixCls, maskTransitionName, maskAnimation),
        style: {
            zIndex: zIndex,
            ...maskStyle,
            ...modalStyles?.mask
        },
        maskProps: maskProps,
        className: modalClassNames?.mask
    }), /*#__PURE__*/ $ltGt3.createElement("div", $869d5c8848d0945a$var$_extends({
        tabIndex: -1,
        onKeyDown: onWrapperKeyDown,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-wrap`, wrapClassName, modalClassNames?.wrapper),
        ref: wrapperRef,
        onClick: onWrapperClick,
        style: mergedStyle
    }, wrapProps), /*#__PURE__*/ $ltGt3.createElement((0, $8d2b15740cd7e629$export$2e2bcd8739ae039), $869d5c8848d0945a$var$_extends({}, props, {
        onMouseDown: onContentMouseDown,
        onMouseUp: onContentMouseUp,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $3284d02beae54fc6$export$ec1a7ebf4579c1c3)(prefixCls, transitionName, animation)
    }))));
};
var $869d5c8848d0945a$export$2e2bcd8739ae039 = $869d5c8848d0945a$var$Dialog;


function $2a8ca71b8ebfe748$var$_extends() {
    $2a8ca71b8ebfe748$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2a8ca71b8ebfe748$var$_extends.apply(this, arguments);
}
// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ const $2a8ca71b8ebfe748$var$DialogWrap = (props)=>{
    const { visible: visible, getContainer: getContainer, forceRender: forceRender, destroyOnHidden: destroyOnHidden = false, afterClose: afterClose, closable: closable, panelRef: panelRef } = props;
    const [animatedVisible, setAnimatedVisible] = $ltGt3.useState(visible);
    const refContext = $ltGt3.useMemo(()=>({
            panel: panelRef
        }), [
        panelRef
    ]);
    $ltGt3.useEffect(()=>{
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnHidden && !animatedVisible) return null;
    return /*#__PURE__*/ $ltGt3.createElement((0, $94045fba7435ea40$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $0561688d8f19e269$export$2e2bcd8739ae039), {
        open: visible || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: visible || animatedVisible
    }, /*#__PURE__*/ $ltGt3.createElement((0, $869d5c8848d0945a$export$2e2bcd8739ae039), $2a8ca71b8ebfe748$var$_extends({}, props, {
        destroyOnHidden: destroyOnHidden,
        afterClose: ()=>{
            const closableObj = closable && typeof closable === 'object' ? closable : {};
            const { afterClose: closableAfterClose } = closableObj || {};
            closableAfterClose?.();
            afterClose?.();
            setAnimatedVisible(false);
        }
    }))));
};
var $2a8ca71b8ebfe748$export$2e2bcd8739ae039 = $2a8ca71b8ebfe748$var$DialogWrap;



var $e3f1e290a0de4f12$export$2e2bcd8739ae039 = (0, $2a8ca71b8ebfe748$export$2e2bcd8739ae039);






var $ltGt3 = parcelRequire("ltGt3");
const $6bb365da95a17eb7$var$normalizeMaskConfig = (mask)=>{
    if (mask && typeof mask === 'object') return mask;
    if (typeof mask === 'boolean') return {
        enabled: mask,
        blur: mask
    };
    return {};
};
const $6bb365da95a17eb7$export$a4ac1bdd74570410 = (mask, contextMask, prefixCls)=>{
    return (0, $ltGt3.useMemo)(()=>{
        const maskConfig = $6bb365da95a17eb7$var$normalizeMaskConfig(mask);
        const contextMaskConfig = $6bb365da95a17eb7$var$normalizeMaskConfig(contextMask);
        const mergedConfig = {
            ...contextMaskConfig,
            ...maskConfig
        };
        const className = mergedConfig.blur !== false ? `${prefixCls}-mask-blur` : undefined;
        return [
            mergedConfig.enabled !== false,
            {
                mask: className
            }
        ];
    }, [
        mask,
        contextMask,
        prefixCls
    ]);
};





const $083ddb4b3bfb9b48$export$7dbdadf5e9653129 = ()=>(0, $19612225313d4e36$export$2e2bcd8739ae039)() && window.document.documentElement;









var $ltGt3 = parcelRequire("ltGt3");

function $4d993ea8c6f12a52$var$voidFunc() {}
const $4d993ea8c6f12a52$var$WatermarkContext = /*#__PURE__*/ $ltGt3.createContext({
    add: $4d993ea8c6f12a52$var$voidFunc,
    remove: $4d993ea8c6f12a52$var$voidFunc
});
function $4d993ea8c6f12a52$export$94ab53417567be34(panelSelector) {
    const watermark = $ltGt3.useContext($4d993ea8c6f12a52$var$WatermarkContext);
    const panelEleRef = $ltGt3.useRef(null);
    const panelRef = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((ele)=>{
        if (ele) {
            const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
            if (innerContentEle) {
                watermark.add(innerContentEle);
                panelEleRef.current = innerContentEle;
            }
        } else watermark.remove(panelEleRef.current);
    });
    return panelRef;
}
var $4d993ea8c6f12a52$export$2e2bcd8739ae039 = $4d993ea8c6f12a52$var$WatermarkContext;



var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");


"use client";
const $815d6273a972ec42$var$NormalCancelBtn = ()=>{
    const { cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, onCancel: onCancel } = (0, $ltGt3.useContext)((0, $9b2f325fa698619b$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
        onClick: onCancel,
        ...cancelButtonProps
    }, cancelTextLocale);
};
var $815d6273a972ec42$export$2e2bcd8739ae039 = $815d6273a972ec42$var$NormalCancelBtn;



var $ltGt3 = parcelRequire("ltGt3");



"use client";
const $489ca0ee0f410dc8$var$NormalOkBtn = ()=>{
    const { confirmLoading: confirmLoading, okButtonProps: okButtonProps, okType: okType, okTextLocale: okTextLocale, onOk: onOk } = (0, $ltGt3.useContext)((0, $9b2f325fa698619b$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
        ...(0, $ea3450de0c6c5939$export$19bc9a290855952)(okType),
        loading: confirmLoading,
        onClick: onOk,
        ...okButtonProps
    }, okTextLocale);
};
var $489ca0ee0f410dc8$export$2e2bcd8739ae039 = $489ca0ee0f410dc8$var$NormalOkBtn;




"use client";
function $e7c5cc6735448d43$export$97c34646962d356e(prefixCls, closeIcon) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
        className: `${prefixCls}-close-x`
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    }));
}
const $e7c5cc6735448d43$export$a06f1c675e846f6f = (props)=>{
    const { okText: okText, okType: okType = 'primary', cancelText: cancelText, confirmLoading: confirmLoading, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, footer: footer } = props;
    const [locale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Modal', (0, $7122a9fe01bd9900$export$1b6004afda18cd51)());
    // ================== Locale Text ==================
    const okTextLocale = okText || locale?.okText;
    const cancelTextLocale = cancelText || locale?.cancelText;
    const memoizedValue = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        return {
            confirmLoading: confirmLoading,
            okButtonProps: okButtonProps,
            cancelButtonProps: cancelButtonProps,
            okTextLocale: okTextLocale,
            cancelTextLocale: cancelTextLocale,
            okType: okType,
            onOk: onOk,
            onCancel: onCancel
        };
    }, [
        confirmLoading,
        okButtonProps,
        cancelButtonProps,
        okTextLocale,
        cancelTextLocale,
        okType,
        onOk,
        onCancel
    ]);
    let footerNode;
    if (typeof footer === 'function' || typeof footer === 'undefined') {
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $815d6273a972ec42$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $489ca0ee0f410dc8$export$2e2bcd8739ae039), null));
        if (typeof footer === 'function') footerNode = footer(footerNode, {
            OkBtn: (0, $489ca0ee0f410dc8$export$2e2bcd8739ae039),
            CancelBtn: (0, $815d6273a972ec42$export$2e2bcd8739ae039)
        });
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $9b2f325fa698619b$export$7c9538f5f3c365e9), {
            value: memoizedValue
        }, footerNode);
    } else footerNode = footer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $6171cc8a6fbd07d0$export$6adb5f3b918b11bb), {
        disabled: false
    }, footerNode);
};








function $a51958ccdca509b5$var$box(position) {
    return {
        position: position,
        inset: 0
    };
}
const $a51958ccdca509b5$export$8bb6dada04673ddd = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return [
        {
            [`${componentCls}-root`]: {
                [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
                    // reset scale avoid mousePosition bug
                    transform: 'none',
                    opacity: 0,
                    animationDuration: token.motionDurationSlow,
                    // https://github.com/ant-design/ant-design/issues/11777
                    userSelect: 'none'
                },
                // https://github.com/ant-design/ant-design/issues/37329
                // https://github.com/ant-design/ant-design/issues/40272
                [`${componentCls}${antCls}-zoom-leave ${componentCls}-container`]: {
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask`]: {
                    ...$a51958ccdca509b5$var$box('fixed'),
                    zIndex: token.zIndexPopupBase,
                    height: '100%',
                    backgroundColor: token.colorBgMask,
                    pointerEvents: 'none',
                    [`&${componentCls}-mask-blur`]: {
                        ...(0, $945cb0d2b7017a11$export$eb00f0b59fe10024)
                    },
                    [`${componentCls}-hidden`]: {
                        display: 'none'
                    }
                },
                [`${componentCls}-wrap`]: {
                    ...$a51958ccdca509b5$var$box('fixed'),
                    zIndex: token.zIndexPopupBase,
                    overflow: 'auto',
                    outline: 0,
                    WebkitOverflowScrolling: 'touch'
                }
            }
        },
        {
            [`${componentCls}-root`]: (0, $0aa79fac63008607$export$2909268c8354a12)(token)
        }
    ];
};
const $a51958ccdca509b5$var$genModalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        // ======================== Root =========================
        {
            [`${componentCls}-root`]: {
                [`${componentCls}-wrap-rtl`]: {
                    direction: 'rtl'
                },
                [`${componentCls}-centered`]: {
                    textAlign: 'center',
                    '&::before': {
                        display: 'inline-block',
                        width: 0,
                        height: '100%',
                        verticalAlign: 'middle',
                        content: '""'
                    },
                    [componentCls]: {
                        top: 0,
                        display: 'inline-block',
                        paddingBottom: 0,
                        textAlign: 'start',
                        verticalAlign: 'middle'
                    }
                },
                [`@media (max-width: ${token.screenSMMax}px)`]: {
                    [componentCls]: {
                        maxWidth: 'calc(100vw - 16px)',
                        margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.marginXS)} auto`
                    },
                    [`${componentCls}-centered`]: {
                        [componentCls]: {
                            flex: 1
                        }
                    }
                }
            }
        },
        // ======================== Modal ========================
        {
            [componentCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                pointerEvents: 'none',
                position: 'relative',
                top: 100,
                width: 'auto',
                maxWidth: `calc(100vw - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(token.margin).mul(2).equal())})`,
                margin: '0 auto',
                paddingBottom: token.paddingLG,
                [`${componentCls}-title`]: {
                    margin: 0,
                    color: token.titleColor,
                    fontWeight: token.fontWeightStrong,
                    fontSize: token.titleFontSize,
                    lineHeight: token.titleLineHeight,
                    wordWrap: 'break-word'
                },
                [`${componentCls}-container`]: {
                    position: 'relative',
                    backgroundColor: token.contentBg,
                    backgroundClip: 'padding-box',
                    border: 0,
                    borderRadius: token.borderRadiusLG,
                    boxShadow: token.boxShadow,
                    pointerEvents: 'auto',
                    padding: token.contentPadding
                },
                [`${componentCls}-close`]: {
                    position: 'absolute',
                    top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
                    padding: 0,
                    color: token.modalCloseIconColor,
                    fontWeight: token.fontWeightStrong,
                    lineHeight: 1,
                    textDecoration: 'none',
                    background: 'transparent',
                    borderRadius: token.borderRadiusSM,
                    width: token.modalCloseBtnSize,
                    height: token.modalCloseBtnSize,
                    border: 0,
                    outline: 0,
                    cursor: 'pointer',
                    transition: `color ${token.motionDurationMid}, background-color ${token.motionDurationMid}`,
                    '&-x': {
                        display: 'flex',
                        fontSize: token.fontSizeLG,
                        fontStyle: 'normal',
                        lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.modalCloseBtnSize),
                        justifyContent: 'center',
                        textTransform: 'none',
                        textRendering: 'auto'
                    },
                    '&:disabled': {
                        pointerEvents: 'none'
                    },
                    '&:hover': {
                        color: token.modalCloseIconHoverColor,
                        backgroundColor: token.colorBgTextHover,
                        textDecoration: 'none'
                    },
                    '&:active': {
                        backgroundColor: token.colorBgTextActive
                    },
                    ...(0, $945cb0d2b7017a11$export$a44db842bcb28231)(token)
                },
                [`${componentCls}-header`]: {
                    color: token.colorText,
                    background: token.headerBg,
                    borderRadius: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
                    marginBottom: token.headerMarginBottom,
                    padding: token.headerPadding,
                    borderBottom: token.headerBorderBottom
                },
                [`${componentCls}-body`]: {
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    wordWrap: 'break-word',
                    padding: token.bodyPadding,
                    [`${componentCls}-body-skeleton`]: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.margin)} auto`
                    }
                },
                [`${componentCls}-footer`]: {
                    textAlign: 'end',
                    background: token.footerBg,
                    marginTop: token.footerMarginTop,
                    padding: token.footerPadding,
                    borderTop: token.footerBorderTop,
                    borderRadius: token.footerBorderRadius,
                    [`> ${token.antCls}-btn + ${token.antCls}-btn`]: {
                        marginInlineStart: token.marginXS
                    }
                },
                [`${componentCls}-open`]: {
                    overflow: 'hidden'
                }
            }
        },
        // ======================== Pure =========================
        {
            [`${componentCls}-pure-panel`]: {
                top: 'auto',
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                [`${componentCls}-container,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 'auto'
                },
                [`${componentCls}-confirm-body`]: {
                    marginBottom: 'auto'
                }
            }
        }
    ];
};
const $a51958ccdca509b5$var$genRTLStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-root`]: {
            [`${componentCls}-wrap-rtl`]: {
                direction: 'rtl',
                [`${componentCls}-confirm-body`]: {
                    direction: 'rtl'
                }
            }
        }
    };
};
const $a51958ccdca509b5$var$genResponsiveWidthStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const oriGridMediaSizesMap = (0, $46ef034ddbcf7413$export$6353f655434817c5)(token);
    const gridMediaSizesMap = {
        ...oriGridMediaSizesMap
    };
    delete gridMediaSizesMap.xs;
    const cssVarPrefix = `--${componentCls.replace('.', '')}-`;
    const responsiveStyles = Object.keys(gridMediaSizesMap).map((key)=>({
            [`@media (min-width: ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(gridMediaSizesMap[key])})`]: {
                width: `var(${cssVarPrefix}${key}-width)`
            }
        }));
    return {
        [`${componentCls}-root`]: {
            [componentCls]: [].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(Object.keys(oriGridMediaSizesMap).map((currentKey, index)=>{
                const previousKey = Object.keys(oriGridMediaSizesMap)[index - 1];
                return previousKey ? {
                    [`${cssVarPrefix}${currentKey}-width`]: `var(${cssVarPrefix}${previousKey}-width)`
                } : null;
            })), [
                {
                    width: `var(${cssVarPrefix}xs-width)`
                }
            ], (0, $83d01b7684a01087$export$2e2bcd8739ae039)(responsiveStyles))
        }
    };
};
const $a51958ccdca509b5$export$362fb92a8f81bbf9 = (token)=>{
    const headerPaddingVertical = token.padding;
    const headerFontSize = token.fontSizeHeading5;
    const headerLineHeight = token.lineHeightHeading5;
    const modalToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
        modalFooterBorderColorSplit: token.colorSplit,
        modalFooterBorderStyle: token.lineType,
        modalFooterBorderWidth: token.lineWidth,
        modalCloseIconColor: token.colorIcon,
        modalCloseIconHoverColor: token.colorIconHover,
        modalCloseBtnSize: token.controlHeight,
        modalConfirmIconSize: token.fontHeight,
        modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
    });
    return modalToken;
};
const $a51958ccdca509b5$export$9ca1be8807fe0675 = (token)=>({
        footerBg: 'transparent',
        headerBg: 'transparent',
        titleLineHeight: token.lineHeightHeading5,
        titleFontSize: token.fontSizeHeading5,
        contentBg: token.colorBgElevated,
        titleColor: token.colorTextHeading,
        // internal
        contentPadding: token.wireframe ? 0 : `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingMD)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingContentHorizontalLG)}`,
        headerPadding: token.wireframe ? `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.padding)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingLG)}` : 0,
        headerBorderBottom: token.wireframe ? `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        headerMarginBottom: token.wireframe ? 0 : token.marginXS,
        bodyPadding: token.wireframe ? token.paddingLG : 0,
        footerPadding: token.wireframe ? `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingXS)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.padding)}` : 0,
        footerBorderTop: token.wireframe ? `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        footerBorderRadius: token.wireframe ? `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)}` : 0,
        footerMarginTop: token.wireframe ? 0 : token.marginSM,
        confirmBodyPadding: token.wireframe ? `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.padding * 2)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.padding * 2)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingLG)}` : 0,
        confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
        confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM,
        mask: true
    });
var $a51958ccdca509b5$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Modal', (token)=>{
    const modalToken = $a51958ccdca509b5$export$362fb92a8f81bbf9(token);
    return [
        $a51958ccdca509b5$var$genModalStyle(modalToken),
        $a51958ccdca509b5$var$genRTLStyle(modalToken),
        $a51958ccdca509b5$export$8bb6dada04673ddd(modalToken),
        (0, $29a43b27eddd598a$export$f5d123412490d9dc)(modalToken, 'zoom'),
        $a51958ccdca509b5$var$genResponsiveWidthStyle(modalToken)
    ];
}, $a51958ccdca509b5$export$9ca1be8807fe0675, {
    unitless: {
        titleLineHeight: true
    }
});


"use client";
let $584f96c3fae4c0d1$var$mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const $584f96c3fae4c0d1$var$getClickPosition = (e)=>{
    $584f96c3fae4c0d1$var$mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(()=>{
        $584f96c3fae4c0d1$var$mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, $083ddb4b3bfb9b48$export$7dbdadf5e9653129)()) document.documentElement.addEventListener('click', $584f96c3fae4c0d1$var$getClickPosition, true);
const $584f96c3fae4c0d1$var$Modal = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, open: open, wrapClassName: wrapClassName, centered: centered, getContainer: getContainer, focusTriggerAfterClose: focusTriggerAfterClose = true, style: style, width: width = 520, footer: footer, classNames: classNames, styles: styles, children: children, loading: loading, confirmLoading: confirmLoading, zIndex: customizeZIndex, mousePosition: customizeMousePosition, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, destroyOnHidden: destroyOnHidden, destroyOnClose: destroyOnClose, panelRef: panelRef = null, closable: closable, mask: modalMask, modalRender: modalRender, ...restProps } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, centered: contextCentered, cancelButtonProps: contextCancelButtonProps, okButtonProps: contextOkButtonProps, mask: contextMask } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('modal');
    const { modal: modalContext } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const [closableAfterclose, onClose] = $ltGt3.useMemo(()=>{
        if (typeof closable === 'boolean') return [
            undefined,
            undefined
        ];
        return [
            closable?.afterClose,
            closable?.onClose
        ];
    }, [
        closable
    ]);
    const prefixCls = getPrefixCls('modal', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [mergedMask, maskBlurClassName] = (0, $6bb365da95a17eb7$export$a4ac1bdd74570410)(modalMask, contextMask, prefixCls);
    const handleCancel = (e)=>{
        if (confirmLoading) return;
        onCancel?.(e);
        onClose?.();
    };
    const handleOk = (e)=>{
        onOk?.(e);
        onClose?.();
    };
    var deprecatedName, newName;
    // Style
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $a51958ccdca509b5$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const wrapClassNameExtended = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(wrapClassName, {
        [`${prefixCls}-centered`]: centered ?? contextCentered,
        [`${prefixCls}-wrap-rtl`]: direction === 'rtl'
    });
    const dialogFooter = footer !== null && !loading ? /*#__PURE__*/ $ltGt3.createElement((0, $e7c5cc6735448d43$export$a06f1c675e846f6f), {
        ...props,
        okButtonProps: {
            ...contextOkButtonProps,
            ...okButtonProps
        },
        onOk: handleOk,
        cancelButtonProps: {
            ...contextCancelButtonProps,
            ...cancelButtonProps
        },
        onCancel: handleCancel
    }) : null;
    const [rawClosable, mergedCloseIcon, closeBtnIsDisabled, ariaProps] = (0, $dd7ac7131208b252$export$aa101db403ccf5f3)((0, $dd7ac7131208b252$export$51ad9c30389f050b)(props), (0, $dd7ac7131208b252$export$51ad9c30389f050b)(modalContext), {
        closable: true,
        closeIcon: /*#__PURE__*/ $ltGt3.createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), {
            className: `${prefixCls}-close-icon`
        }),
        closeIconRender: (icon)=>(0, $e7c5cc6735448d43$export$97c34646962d356e)(prefixCls, icon)
    });
    const mergedClosable = rawClosable ? {
        disabled: closeBtnIsDisabled,
        closeIcon: mergedCloseIcon,
        afterClose: closableAfterclose,
        ...ariaProps
    } : false;
    // ============================ modalRender ============================
    const mergedModalRender = modalRender ? (node)=>/*#__PURE__*/ $ltGt3.createElement("div", {
            className: `${prefixCls}-render`
        }, modalRender(node)) : undefined;
    // ============================ Refs ============================
    // Select `ant-modal-container` by `panelRef`
    const panelClassName = `.${prefixCls}-${modalRender ? 'render' : 'container'}`;
    const innerPanelRef = (0, $4d993ea8c6f12a52$export$94ab53417567be34)(panelClassName);
    const mergedPanelRef = (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(panelRef, innerPanelRef);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $ad5b6b465efa8f67$export$3e7906d4075187a4)('Modal', customizeZIndex);
    const mergedProps = {
        ...props,
        width: width,
        panelRef: panelRef,
        focusTriggerAfterClose: focusTriggerAfterClose,
        mask: mergedMask,
        zIndex: zIndex
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames,
        maskBlurClassName
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // =========================== Width ============================
    const [numWidth, responsiveWidth] = $ltGt3.useMemo(()=>{
        if (width && typeof width === 'object') return [
            undefined,
            width
        ];
        return [
            width,
            undefined
        ];
    }, [
        width
    ]);
    const responsiveWidthVars = $ltGt3.useMemo(()=>{
        const vars = {};
        if (responsiveWidth) Object.keys(responsiveWidth).forEach((breakpoint)=>{
            const breakpointWidth = responsiveWidth[breakpoint];
            if (breakpointWidth !== undefined) vars[`--${prefixCls}-${breakpoint}-width`] = typeof breakpointWidth === 'number' ? `${breakpointWidth}px` : breakpointWidth;
        });
        return vars;
    }, [
        prefixCls,
        responsiveWidth
    ]);
    // =========================== Render ===========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $31ba6c57c6d43aeb$export$2e2bcd8739ae039), {
        form: true,
        space: true
    }, /*#__PURE__*/ $ltGt3.createElement((0, $cba857b93cac085e$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $ltGt3.createElement((0, $e3f1e290a0de4f12$export$2e2bcd8739ae039), {
        width: numWidth,
        ...restProps,
        zIndex: zIndex,
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        rootClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(hashId, rootClassName, cssVarCls, rootCls, mergedClassNames.root),
        rootStyle: mergedStyles.root,
        footer: dialogFooter,
        visible: open,
        mousePosition: customizeMousePosition ?? $584f96c3fae4c0d1$var$mousePosition,
        onClose: handleCancel,
        closable: mergedClosable,
        closeIcon: mergedCloseIcon,
        focusTriggerAfterClose: focusTriggerAfterClose,
        transitionName: (0, $32c4c593a0d4aef5$export$27c72201b1d09951)(rootPrefixCls, 'zoom', props.transitionName),
        maskTransitionName: (0, $32c4c593a0d4aef5$export$27c72201b1d09951)(rootPrefixCls, 'fade', props.maskTransitionName),
        mask: mergedMask,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(hashId, className, contextClassName),
        style: {
            ...contextStyle,
            ...style,
            ...responsiveWidthVars
        },
        classNames: {
            ...mergedClassNames,
            wrapper: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassNames.wrapper, wrapClassNameExtended)
        },
        styles: mergedStyles,
        panelRef: mergedPanelRef,
        destroyOnHidden: destroyOnHidden ?? destroyOnClose,
        modalRender: mergedModalRender
    }, loading ? /*#__PURE__*/ $ltGt3.createElement((0, $bbc46c63198736c0$export$2e2bcd8739ae039), {
        active: true,
        title: false,
        paragraph: {
            rows: 4
        },
        className: `${prefixCls}-body-skeleton`
    }) : children)));
};
var $584f96c3fae4c0d1$export$2e2bcd8739ae039 = $584f96c3fae4c0d1$var$Modal;


// Style as confirm component




// ============================= Confirm ==============================
const $cca54754e14fea42$var$genModalConfirmStyle = (token)=>{
    const { componentCls: componentCls, titleFontSize: titleFontSize, titleLineHeight: titleLineHeight, modalConfirmIconSize: modalConfirmIconSize, fontSize: fontSize, lineHeight: lineHeight, modalTitleHeight: modalTitleHeight, fontHeight: fontHeight, confirmBodyPadding: confirmBodyPadding } = token;
    const confirmComponentCls = `${componentCls}-confirm`;
    return {
        [confirmComponentCls]: {
            '&-rtl': {
                direction: 'rtl'
            },
            [`${token.antCls}-modal-header`]: {
                display: 'none'
            },
            [`${confirmComponentCls}-body-wrapper`]: {
                ...(0, $945cb0d2b7017a11$export$8c467e8859fdef13)()
            },
            [`&${componentCls} ${componentCls}-body`]: {
                padding: confirmBodyPadding
            },
            // ====================== Body ======================
            [`${confirmComponentCls}-body`]: {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'start',
                [`> ${token.iconCls}`]: {
                    flex: 'none',
                    fontSize: modalConfirmIconSize,
                    marginInlineEnd: token.confirmIconMarginInlineEnd,
                    marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                },
                [`&-has-title > ${token.iconCls}`]: {
                    marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                }
            },
            [`${confirmComponentCls}-paragraph`]: {
                display: 'flex',
                flexDirection: 'column',
                flex: 'auto',
                rowGap: token.marginXS,
                // https://github.com/ant-design/ant-design/issues/51912
                maxWidth: `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.marginSM)})`
            },
            // https://github.com/ant-design/ant-design/issues/48159
            [`${token.iconCls} + ${confirmComponentCls}-paragraph`]: {
                maxWidth: `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal())})`
            },
            [`${confirmComponentCls}-title`]: {
                color: token.colorTextHeading,
                fontWeight: token.fontWeightStrong,
                fontSize: titleFontSize,
                lineHeight: titleLineHeight
            },
            [`${confirmComponentCls}-container`]: {
                color: token.colorText,
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            // ===================== Footer =====================
            [`${confirmComponentCls}-btns`]: {
                textAlign: 'end',
                marginTop: token.confirmBtnsMarginTop,
                [`${token.antCls}-btn + ${token.antCls}-btn`]: {
                    marginBottom: 0,
                    marginInlineStart: token.marginXS
                }
            }
        },
        [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorError
        },
        [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorWarning
        },
        [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorInfo
        },
        [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorSuccess
        }
    };
};
var // ============================== Export ==============================
$cca54754e14fea42$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$1537386bc155ea56)([
    'Modal',
    'confirm'
], (token)=>{
    const modalToken = (0, $a51958ccdca509b5$export$362fb92a8f81bbf9)(token);
    return $cca54754e14fea42$var$genModalConfirmStyle(modalToken);
}, (0, $a51958ccdca509b5$export$9ca1be8807fe0675), {
    // confirm is weak than modal since no conflict here
    order: -1000
});


"use client";
const $d776250abdf93160$export$78cf841dc2c9f0b5 = (props)=>{
    const { prefixCls: prefixCls, icon: icon, okText: okText, cancelText: cancelText, confirmPrefixCls: confirmPrefixCls, type: type, okCancel: okCancel, footer: footer, // Legacy for static function usage
    locale: staticLocale, ...restProps } = props;
    // Icon
    let mergedIcon = icon;
    // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
    if (!icon && icon !== null) switch(type){
        case 'info':
            mergedIcon = /*#__PURE__*/ $ltGt3.createElement((0, $bfd6614352ed1ca0$export$2e2bcd8739ae039), null);
            break;
        case 'success':
            mergedIcon = /*#__PURE__*/ $ltGt3.createElement((0, $0cb9ffcfb49f2ccf$export$2e2bcd8739ae039), null);
            break;
        case 'error':
            mergedIcon = /*#__PURE__*/ $ltGt3.createElement((0, $332936b0d9ac1f65$export$2e2bcd8739ae039), null);
            break;
        default:
            mergedIcon = /*#__PURE__*/ $ltGt3.createElement((0, $951db5e2b3978281$export$2e2bcd8739ae039), null);
    }
    // 默认为 true，保持向下兼容
    const mergedOkCancel = okCancel ?? type === 'confirm';
    const autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
    const [locale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Modal');
    const mergedLocale = staticLocale || locale;
    // ================== Locale Text ==================
    const okTextLocale = okText || (mergedOkCancel ? mergedLocale?.okText : mergedLocale?.justOkText);
    const cancelTextLocale = cancelText || mergedLocale?.cancelText;
    // ================= Context Value =================
    const { closable: closable } = restProps;
    const { onClose: onClose } = closable && typeof closable === 'object' ? closable : {};
    const memoizedValue = $ltGt3.useMemo(()=>{
        return {
            autoFocusButton: autoFocusButton,
            cancelTextLocale: cancelTextLocale,
            okTextLocale: okTextLocale,
            mergedOkCancel: mergedOkCancel,
            onClose: onClose,
            ...restProps
        };
    }, [
        autoFocusButton,
        cancelTextLocale,
        okTextLocale,
        mergedOkCancel,
        onClose,
        restProps
    ]);
    // ====================== Footer Origin Node ======================
    const footerOriginNode = /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement((0, $0e803ac75639c26b$export$2e2bcd8739ae039), null), /*#__PURE__*/ $ltGt3.createElement((0, $17ee43f6c64dad41$export$2e2bcd8739ae039), null));
    const hasTitle = props.title !== undefined && props.title !== null;
    const bodyCls = `${confirmPrefixCls}-body`;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${confirmPrefixCls}-body-wrapper`
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(bodyCls, {
            [`${bodyCls}-has-title`]: hasTitle
        })
    }, mergedIcon, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${confirmPrefixCls}-paragraph`
    }, hasTitle && /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${confirmPrefixCls}-title`
    }, props.title), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${confirmPrefixCls}-content`
    }, props.content))), footer === undefined || typeof footer === 'function' ? /*#__PURE__*/ $ltGt3.createElement((0, $9b2f325fa698619b$export$7c9538f5f3c365e9), {
        value: memoizedValue
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${confirmPrefixCls}-btns`
    }, typeof footer === 'function' ? footer(footerOriginNode, {
        OkBtn: $17ee43f6c64dad41$export$2e2bcd8739ae039,
        CancelBtn: $0e803ac75639c26b$export$2e2bcd8739ae039
    }) : footerOriginNode)) : footer, /*#__PURE__*/ $ltGt3.createElement((0, $cca54754e14fea42$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
};
const $d776250abdf93160$var$ConfirmDialog = (props)=>{
    const { close: close, zIndex: zIndex, maskStyle: maskStyle, direction: direction, prefixCls: prefixCls, wrapClassName: wrapClassName, rootPrefixCls: rootPrefixCls, bodyStyle: bodyStyle, closable: closable = false, onConfirm: onConfirm, styles: styles, title: title, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps } = props;
    const { cancelButtonProps: contextCancelButtonProps, okButtonProps: contextOkButtonProps } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('modal');
    var deprecatedName, newName;
    const confirmPrefixCls = `${prefixCls}-confirm`;
    const width = props.width || 416;
    const style = props.style || {};
    // 默认为 false，保持旧版默认行为
    const maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
        [`${confirmPrefixCls}-rtl`]: direction === 'rtl'
    }, props.className);
    // ========================= zIndex =========================
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const mergedZIndex = $ltGt3.useMemo(()=>{
        if (zIndex !== undefined) return zIndex;
        // Static always use max zIndex
        return token.zIndexPopupBase + (0, $ad5b6b465efa8f67$export$33ada7d8845f7e5);
    }, [
        zIndex,
        token
    ]);
    // ========================= Render =========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $584f96c3fae4c0d1$export$2e2bcd8739ae039), {
        ...props,
        className: classString,
        wrapClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
            [`${confirmPrefixCls}-centered`]: !!props.centered
        }, wrapClassName),
        onCancel: ()=>{
            close?.({
                triggerCancel: true
            });
            onConfirm?.(false);
        },
        title: title,
        footer: null,
        transitionName: (0, $32c4c593a0d4aef5$export$27c72201b1d09951)(rootPrefixCls || '', 'zoom', props.transitionName),
        maskTransitionName: (0, $32c4c593a0d4aef5$export$27c72201b1d09951)(rootPrefixCls || '', 'fade', props.maskTransitionName),
        maskClosable: maskClosable,
        style: style,
        styles: {
            body: bodyStyle,
            mask: maskStyle,
            ...styles
        },
        width: width,
        zIndex: mergedZIndex,
        closable: closable
    }, /*#__PURE__*/ $ltGt3.createElement($d776250abdf93160$export$78cf841dc2c9f0b5, {
        ...props,
        confirmPrefixCls: confirmPrefixCls,
        okButtonProps: {
            ...contextOkButtonProps,
            ...okButtonProps
        },
        cancelButtonProps: {
            ...contextCancelButtonProps,
            ...cancelButtonProps
        }
    }));
};
const $d776250abdf93160$var$ConfirmDialogWrapper = (props)=>{
    const { rootPrefixCls: rootPrefixCls, iconPrefixCls: iconPrefixCls, direction: direction, theme: theme } = props;
    return /*#__PURE__*/ $ltGt3.createElement((0, $3f88559997256af7$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction,
        theme: theme
    }, /*#__PURE__*/ $ltGt3.createElement($d776250abdf93160$var$ConfirmDialog, {
        ...props
    }));
};
var $d776250abdf93160$export$2e2bcd8739ae039 = $d776250abdf93160$var$ConfirmDialogWrapper;


const $85eeaeeecb81dd27$var$destroyFns = [];
var $85eeaeeecb81dd27$export$2e2bcd8739ae039 = $85eeaeeecb81dd27$var$destroyFns;



"use client";
let $a9697cf78e6b64ce$var$defaultRootPrefixCls = '';
function $a9697cf78e6b64ce$var$getRootPrefixCls() {
    return $a9697cf78e6b64ce$var$defaultRootPrefixCls;
}
const $a9697cf78e6b64ce$var$ConfirmDialogWrapper = (props)=>{
    const { prefixCls: customizePrefixCls, getContainer: getContainer, direction: direction } = props;
    const runtimeLocale = (0, $7122a9fe01bd9900$export$1b6004afda18cd51)();
    const config = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const rootPrefixCls = $a9697cf78e6b64ce$var$getRootPrefixCls() || config.getPrefixCls();
    // because Modal.config set rootPrefixCls, which is different from other components
    const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
    let mergedGetContainer = getContainer;
    if (mergedGetContainer === false) mergedGetContainer = undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $d776250abdf93160$export$2e2bcd8739ae039), {
        ...props,
        rootPrefixCls: rootPrefixCls,
        prefixCls: prefixCls,
        iconPrefixCls: config.iconPrefixCls,
        theme: config.theme,
        direction: direction ?? config.direction,
        locale: config.locale?.Modal ?? runtimeLocale,
        getContainer: mergedGetContainer
    });
};
function $a9697cf78e6b64ce$export$2e2bcd8739ae039(config) {
    const global = (0, $3f88559997256af7$export$f9cd1e43211d8a4a)();
    const container = document.createDocumentFragment();
    let currentConfig = {
        ...config,
        close: close,
        open: true
    };
    let timeoutId;
    function destroy(...args) {
        const triggerCancel = args.some((param)=>param?.triggerCancel);
        if (triggerCancel) config.onCancel?.(()=>{}, ...args.slice(1));
        for(let i = 0; i < (0, $85eeaeeecb81dd27$export$2e2bcd8739ae039).length; i++){
            const fn = (0, $85eeaeeecb81dd27$export$2e2bcd8739ae039)[i];
            if (fn === close) {
                (0, $85eeaeeecb81dd27$export$2e2bcd8739ae039).splice(i, 1);
                break;
            }
        }
        (0, $93d215b32898d17a$export$121e2d597d222bad)(container).then(()=>{
        // Do nothing
        });
    }
    const scheduleRender = (props)=>{
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(()=>{
            const rootPrefixCls = global.getPrefixCls(undefined, $a9697cf78e6b64ce$var$getRootPrefixCls());
            const iconPrefixCls = global.getIconPrefixCls();
            const theme = global.getTheme();
            const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement($a9697cf78e6b64ce$var$ConfirmDialogWrapper, {
                ...props
            });
            (0, $93d215b32898d17a$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $3f88559997256af7$export$2e2bcd8739ae039), {
                prefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                theme: theme
            }, typeof global.holderRender === 'function' ? global.holderRender(dom) : dom), container);
        });
    };
    function close(...args) {
        currentConfig = {
            ...currentConfig,
            open: false,
            afterClose: ()=>{
                if (typeof config.afterClose === 'function') config.afterClose();
                // @ts-ignore
                destroy.apply(this, args);
            }
        };
        scheduleRender(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === 'function') currentConfig = configUpdate(currentConfig);
        else currentConfig = {
            ...currentConfig,
            ...configUpdate
        };
        scheduleRender(currentConfig);
    }
    scheduleRender(currentConfig);
    (0, $85eeaeeecb81dd27$export$2e2bcd8739ae039).push(close);
    return {
        destroy: close,
        update: update
    };
}
function $a9697cf78e6b64ce$export$503fa8fed137d104(props) {
    return {
        ...props,
        type: 'warning'
    };
}
function $a9697cf78e6b64ce$export$2f728eab0dacbb2e(props) {
    return {
        ...props,
        type: 'info'
    };
}
function $a9697cf78e6b64ce$export$2b5f8d7f29c805d4(props) {
    return {
        ...props,
        type: 'success'
    };
}
function $a9697cf78e6b64ce$export$60e9e0884ce12b55(props) {
    return {
        ...props,
        type: 'error'
    };
}
function $a9697cf78e6b64ce$export$665b64399d4af99c(props) {
    return {
        ...props,
        type: 'confirm'
    };
}
function $a9697cf78e6b64ce$export$ff0b30c638ae2396({ rootPrefixCls: rootPrefixCls }) {
    $a9697cf78e6b64ce$var$defaultRootPrefixCls = rootPrefixCls;
}




var $ltGt3 = parcelRequire("ltGt3");




"use client";
const $f852274600316970$var$HookModal = ({ afterClose: hookAfterClose, config: config, ...restProps }, ref)=>{
    const [open, setOpen] = $ltGt3.useState(true);
    const [innerConfig, setInnerConfig] = $ltGt3.useState(config);
    const { direction: direction, getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('modal');
    const rootPrefixCls = getPrefixCls();
    const afterClose = ()=>{
        hookAfterClose();
        innerConfig.afterClose?.();
    };
    const close = (...args)=>{
        setOpen(false);
        const triggerCancel = args.some((param)=>param?.triggerCancel);
        if (triggerCancel) innerConfig.onCancel?.(()=>{}, ...args.slice(1));
    };
    $ltGt3.useImperativeHandle(ref, ()=>({
            destroy: close,
            update: (newConfig)=>{
                setInnerConfig((originConfig)=>{
                    const nextConfig = typeof newConfig === 'function' ? newConfig(originConfig) : newConfig;
                    return {
                        ...originConfig,
                        ...nextConfig
                    };
                });
            }
        }));
    const mergedOkCancel = innerConfig.okCancel ?? innerConfig.type === 'confirm';
    const [contextLocale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Modal', (0, $29f4f00e8825a41b$export$2e2bcd8739ae039).Modal);
    return /*#__PURE__*/ $ltGt3.createElement((0, $d776250abdf93160$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootPrefixCls: rootPrefixCls,
        ...innerConfig,
        close: close,
        open: open,
        afterClose: afterClose,
        okText: innerConfig.okText || (mergedOkCancel ? contextLocale?.okText : contextLocale?.justOkText),
        direction: innerConfig.direction || direction,
        cancelText: innerConfig.cancelText || contextLocale?.cancelText,
        ...restProps
    });
};
var $f852274600316970$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.forwardRef($f852274600316970$var$HookModal);


"use client";
let $7539c4586900c4d6$var$uuid = 0;
const $7539c4586900c4d6$var$ElementsHolder = /*#__PURE__*/ $ltGt3.memo(/*#__PURE__*/ $ltGt3.forwardRef((_props, ref)=>{
    const [elements, patchElement] = (0, $d30d783afd306d17$export$26425c9dd59b4436)();
    $ltGt3.useImperativeHandle(ref, ()=>({
            patchElement: patchElement
        }), [
        patchElement
    ]);
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, elements);
}));
function $7539c4586900c4d6$var$useModal() {
    const holderRef = $ltGt3.useRef(null);
    // ========================== Effect ==========================
    const [actionQueue, setActionQueue] = $ltGt3.useState([]);
    $ltGt3.useEffect(()=>{
        if (actionQueue.length) {
            const cloneQueue = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(actionQueue);
            cloneQueue.forEach((action)=>{
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    const getConfirmFunc = $ltGt3.useCallback((withFunc)=>function hookConfirm(config) {
            $7539c4586900c4d6$var$uuid += 1;
            const modalRef = /*#__PURE__*/ $ltGt3.createRef();
            // Proxy to promise with `onClose`
            let resolvePromise;
            const promise = new Promise((resolve)=>{
                resolvePromise = resolve;
            });
            let silent = false;
            let closeFunc;
            const modal = /*#__PURE__*/ $ltGt3.createElement((0, $f852274600316970$export$2e2bcd8739ae039), {
                key: `modal-${$7539c4586900c4d6$var$uuid}`,
                config: withFunc(config),
                ref: modalRef,
                afterClose: ()=>{
                    closeFunc?.();
                },
                isSilent: ()=>silent,
                onConfirm: (confirmed)=>{
                    resolvePromise(confirmed);
                }
            });
            closeFunc = holderRef.current?.patchElement(modal);
            if (closeFunc) (0, $85eeaeeecb81dd27$export$2e2bcd8739ae039).push(closeFunc);
            const instance = {
                destroy: ()=>{
                    function destroyAction() {
                        modalRef.current?.destroy();
                    }
                    if (modalRef.current) destroyAction();
                    else setActionQueue((prev)=>[].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(prev), [
                            destroyAction
                        ]));
                },
                update: (newConfig)=>{
                    function updateAction() {
                        modalRef.current?.update(newConfig);
                    }
                    if (modalRef.current) updateAction();
                    else setActionQueue((prev)=>[].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(prev), [
                            updateAction
                        ]));
                },
                then: (resolve)=>{
                    silent = true;
                    return promise.then(resolve);
                }
            };
            return instance;
        }, []);
    const fns = $ltGt3.useMemo(()=>({
            info: getConfirmFunc((0, $a9697cf78e6b64ce$export$2f728eab0dacbb2e)),
            success: getConfirmFunc((0, $a9697cf78e6b64ce$export$2b5f8d7f29c805d4)),
            error: getConfirmFunc((0, $a9697cf78e6b64ce$export$60e9e0884ce12b55)),
            warning: getConfirmFunc((0, $a9697cf78e6b64ce$export$503fa8fed137d104)),
            confirm: getConfirmFunc((0, $a9697cf78e6b64ce$export$665b64399d4af99c))
        }), [
        getConfirmFunc
    ]);
    return [
        fns,
        /*#__PURE__*/ $ltGt3.createElement($7539c4586900c4d6$var$ElementsHolder, {
            key: "modal-holder",
            ref: holderRef
        })
    ];
}
var $7539c4586900c4d6$export$2e2bcd8739ae039 = $7539c4586900c4d6$var$useModal;



var $ltGt3 = parcelRequire("ltGt3");









var $ltGt3 = parcelRequire("ltGt3");


















const $d97eb159e96783a5$var$genNotificationPlacementStyle = (token)=>{
    const { componentCls: componentCls, notificationMarginEdge: notificationMarginEdge, animationMaxHeight: animationMaxHeight } = token;
    const noticeCls = `${componentCls}-notice`;
    const rightFadeIn = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antNotificationFadeIn', {
        '0%': {
            transform: `translate3d(100%, 0, 0)`,
            opacity: 0
        },
        '100%': {
            transform: `translate3d(0, 0, 0)`,
            opacity: 1
        }
    });
    const topFadeIn = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antNotificationTopFadeIn', {
        '0%': {
            top: -animationMaxHeight,
            opacity: 0
        },
        '100%': {
            top: 0,
            opacity: 1
        }
    });
    const bottomFadeIn = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antNotificationBottomFadeIn', {
        '0%': {
            bottom: token.calc(animationMaxHeight).mul(-1).equal(),
            opacity: 0
        },
        '100%': {
            bottom: 0,
            opacity: 1
        }
    });
    const leftFadeIn = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antNotificationLeftFadeIn', {
        '0%': {
            transform: `translate3d(-100%, 0, 0)`,
            opacity: 0
        },
        '100%': {
            transform: `translate3d(0, 0, 0)`,
            opacity: 1
        }
    });
    return {
        [componentCls]: {
            [`&${componentCls}-top, &${componentCls}-bottom`]: {
                marginInline: 0,
                [noticeCls]: {
                    marginInline: 'auto auto'
                }
            },
            [`&${componentCls}-top`]: {
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: topFadeIn
                }
            },
            [`&${componentCls}-bottom`]: {
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: bottomFadeIn
                }
            },
            [`&${componentCls}-topRight, &${componentCls}-bottomRight`]: {
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: rightFadeIn
                }
            },
            [`&${componentCls}-topLeft, &${componentCls}-bottomLeft`]: {
                marginRight: {
                    value: 0,
                    _skip_check_: true
                },
                marginLeft: {
                    value: notificationMarginEdge,
                    _skip_check_: true
                },
                [noticeCls]: {
                    marginInlineEnd: 'auto',
                    marginInlineStart: 0
                },
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: leftFadeIn
                }
            }
        }
    };
};
var $d97eb159e96783a5$export$2e2bcd8739ae039 = $d97eb159e96783a5$var$genNotificationPlacementStyle;


const $fa78aa51d1a6c1c2$export$617a29b5d3b30216 = [
    'top',
    'topLeft',
    'topRight',
    'bottom',
    'bottomLeft',
    'bottomRight'
];


const $2679e0c8434fee0d$var$placementAlignProperty = {
    topLeft: 'left',
    topRight: 'right',
    bottomLeft: 'left',
    bottomRight: 'right',
    top: 'left',
    bottom: 'left'
};
const $2679e0c8434fee0d$var$genPlacementStackStyle = (token, placement)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-${placement}`]: {
            [`&${componentCls}-stack > ${componentCls}-notice-wrapper`]: {
                [placement.startsWith('top') ? 'top' : 'bottom']: 0,
                [$2679e0c8434fee0d$var$placementAlignProperty[placement]]: {
                    value: 0,
                    _skip_check_: true
                }
            }
        }
    };
};
const $2679e0c8434fee0d$var$genStackChildrenStyle = (token)=>{
    const childrenStyle = {};
    for(let i = 1; i < token.notificationStackLayer; i++)childrenStyle[`&:nth-last-child(${i + 1})`] = {
        overflow: 'hidden',
        [`& > ${token.componentCls}-notice`]: {
            opacity: 0,
            transition: `opacity ${token.motionDurationMid}`
        }
    };
    return {
        [`&:not(:nth-last-child(-n+${token.notificationStackLayer}))`]: {
            opacity: 0,
            overflow: 'hidden',
            color: 'transparent',
            pointerEvents: 'none'
        },
        ...childrenStyle
    };
};
const $2679e0c8434fee0d$var$genStackedNoticeStyle = (token)=>{
    const childrenStyle = {};
    for(let i = 1; i < token.notificationStackLayer; i++)childrenStyle[`&:nth-last-child(${i + 1})`] = {
        background: token.colorBgBlur,
        backdropFilter: 'blur(10px)',
        '-webkit-backdrop-filter': 'blur(10px)'
    };
    return {
        ...childrenStyle
    };
};
const $2679e0c8434fee0d$var$genStackStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-stack`]: {
            [`& > ${componentCls}-notice-wrapper`]: {
                transition: `transform ${token.motionDurationSlow}, backdrop-filter 0s`,
                willChange: 'transform, opacity',
                position: 'absolute',
                ...$2679e0c8434fee0d$var$genStackChildrenStyle(token)
            }
        },
        [`${componentCls}-stack:not(${componentCls}-stack-expanded)`]: {
            [`& > ${componentCls}-notice-wrapper`]: {
                ...$2679e0c8434fee0d$var$genStackedNoticeStyle(token)
            }
        },
        [`${componentCls}-stack${componentCls}-stack-expanded`]: {
            [`& > ${componentCls}-notice-wrapper`]: {
                '&:not(:nth-last-child(-n + 1))': {
                    opacity: 1,
                    overflow: 'unset',
                    color: 'inherit',
                    pointerEvents: 'auto',
                    [`& > ${token.componentCls}-notice`]: {
                        opacity: 1
                    }
                },
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    height: token.margin,
                    width: '100%',
                    insetInline: 0,
                    bottom: token.calc(token.margin).mul(-1).equal(),
                    background: 'transparent',
                    pointerEvents: 'auto'
                }
            }
        },
        ...(0, $fa78aa51d1a6c1c2$export$617a29b5d3b30216).map((placement)=>$2679e0c8434fee0d$var$genPlacementStackStyle(token, placement)).reduce((acc, cur)=>({
                ...acc,
                ...cur
            }), {})
    };
};
var $2679e0c8434fee0d$export$2e2bcd8739ae039 = $2679e0c8434fee0d$var$genStackStyle;


const $fd11c2e4aa6a56e8$export$341e3ef8ee9ea7d6 = (token)=>{
    const { iconCls: iconCls, componentCls: componentCls, boxShadow: // .ant-notification
    boxShadow, fontSizeLG: fontSizeLG, notificationMarginBottom: notificationMarginBottom, borderRadiusLG: borderRadiusLG, colorSuccess: colorSuccess, colorInfo: colorInfo, colorWarning: colorWarning, colorError: colorError, colorTextHeading: colorTextHeading, notificationBg: notificationBg, notificationPadding: notificationPadding, notificationMarginEdge: notificationMarginEdge, progressBg: progressBg, notificationProgressHeight: notificationProgressHeight, fontSize: fontSize, lineHeight: lineHeight, width: width, notificationIconSize: notificationIconSize, colorText: colorText, colorSuccessBg: colorSuccessBg, colorErrorBg: colorErrorBg, colorInfoBg: colorInfoBg, colorWarningBg: colorWarningBg } = token;
    const noticeCls = `${componentCls}-notice`;
    return {
        position: 'relative',
        marginBottom: notificationMarginBottom,
        marginInlineStart: 'auto',
        background: notificationBg,
        borderRadius: borderRadiusLG,
        boxShadow: boxShadow,
        [noticeCls]: {
            padding: notificationPadding,
            width: width,
            maxWidth: `calc(100vw - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(notificationMarginEdge).mul(2).equal())})`,
            lineHeight: lineHeight,
            wordWrap: 'break-word',
            borderRadius: borderRadiusLG,
            overflow: 'hidden',
            // Type-specific background colors
            '&-success': colorSuccessBg ? {
                background: colorSuccessBg
            } : {},
            '&-error': colorErrorBg ? {
                background: colorErrorBg
            } : {},
            '&-info': colorInfoBg ? {
                background: colorInfoBg
            } : {},
            '&-warning': colorWarningBg ? {
                background: colorWarningBg
            } : {}
        },
        [`${noticeCls}-title`]: {
            marginBottom: token.marginXS,
            color: colorTextHeading,
            fontSize: fontSizeLG,
            lineHeight: token.lineHeightLG
        },
        [`${noticeCls}-description`]: {
            fontSize: fontSize,
            color: colorText,
            marginTop: token.marginXS
        },
        [`${noticeCls}-closable ${noticeCls}-title`]: {
            paddingInlineEnd: token.paddingLG
        },
        [`${noticeCls}-with-icon ${noticeCls}-title`]: {
            marginBottom: token.marginXS,
            marginInlineStart: token.calc(token.marginSM).add(notificationIconSize).equal(),
            fontSize: fontSizeLG
        },
        [`${noticeCls}-with-icon ${noticeCls}-description`]: {
            marginInlineStart: token.calc(token.marginSM).add(notificationIconSize).equal(),
            fontSize: fontSize
        },
        // Icon & color style in different selector level
        // https://github.com/ant-design/ant-design/issues/16503
        // https://github.com/ant-design/ant-design/issues/15512
        [`${noticeCls}-icon`]: {
            position: 'absolute',
            fontSize: notificationIconSize,
            lineHeight: 1,
            // icon-font
            [`&-success${iconCls}`]: {
                color: colorSuccess
            },
            [`&-info${iconCls}`]: {
                color: colorInfo
            },
            [`&-warning${iconCls}`]: {
                color: colorWarning
            },
            [`&-error${iconCls}`]: {
                color: colorError
            }
        },
        [`${noticeCls}-close`]: {
            position: 'absolute',
            top: token.notificationPaddingVertical,
            insetInlineEnd: token.notificationPaddingHorizontal,
            color: token.colorIcon,
            outline: 'none',
            width: token.notificationCloseButtonSize,
            height: token.notificationCloseButtonSize,
            borderRadius: token.borderRadiusSM,
            transition: `background-color ${token.motionDurationMid}, color ${token.motionDurationMid}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'none',
            border: 'none',
            '&:hover': {
                color: token.colorIconHover,
                backgroundColor: token.colorBgTextHover
            },
            '&:active': {
                backgroundColor: token.colorBgTextActive
            },
            ...(0, $945cb0d2b7017a11$export$a44db842bcb28231)(token)
        },
        [`${noticeCls}-progress`]: {
            position: 'absolute',
            display: 'block',
            appearance: 'none',
            inlineSize: `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(borderRadiusLG)} * 2)`,
            left: {
                _skip_check_: true,
                value: borderRadiusLG
            },
            right: {
                _skip_check_: true,
                value: borderRadiusLG
            },
            bottom: 0,
            blockSize: notificationProgressHeight,
            border: 0,
            '&, &::-webkit-progress-bar': {
                borderRadius: borderRadiusLG,
                backgroundColor: `rgba(0, 0, 0, 0.04)`
            },
            '&::-moz-progress-bar': {
                background: progressBg
            },
            '&::-webkit-progress-value': {
                borderRadius: borderRadiusLG,
                background: progressBg
            }
        },
        [`${noticeCls}-actions`]: {
            float: 'right',
            marginTop: token.marginSM
        }
    };
};
const $fd11c2e4aa6a56e8$var$genNotificationStyle = (token)=>{
    const { componentCls: componentCls, notificationMarginBottom: // .ant-notification
    notificationMarginBottom, notificationMarginEdge: notificationMarginEdge, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut } = token;
    const noticeCls = `${componentCls}-notice`;
    const fadeOut = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antNotificationFadeOut', {
        '0%': {
            maxHeight: token.animationMaxHeight,
            marginBottom: notificationMarginBottom
        },
        '100%': {
            maxHeight: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0,
            opacity: 0
        }
    });
    return [
        // ============================ Holder ============================
        {
            [componentCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                position: 'fixed',
                zIndex: token.zIndexPopup,
                marginRight: {
                    value: notificationMarginEdge,
                    _skip_check_: true
                },
                [`${componentCls}-hook-holder`]: {
                    position: 'relative'
                },
                //  animation
                [`${componentCls}-fade-appear-prepare`]: {
                    opacity: '0 !important'
                },
                [`${componentCls}-fade-enter, ${componentCls}-fade-appear`]: {
                    animationDuration: token.motionDurationMid,
                    animationTimingFunction: motionEaseInOut,
                    animationFillMode: 'both',
                    opacity: 0,
                    animationPlayState: 'paused'
                },
                [`${componentCls}-fade-leave`]: {
                    animationTimingFunction: motionEaseInOut,
                    animationFillMode: 'both',
                    animationDuration: motionDurationMid,
                    animationPlayState: 'paused'
                },
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationPlayState: 'running'
                },
                [`${componentCls}-fade-leave${componentCls}-fade-leave-active`]: {
                    animationName: fadeOut,
                    animationPlayState: 'running'
                },
                // RTL
                '&-rtl': {
                    direction: 'rtl',
                    [`${noticeCls}-actions`]: {
                        float: 'left'
                    }
                }
            }
        },
        // ============================ Notice ============================
        {
            [componentCls]: {
                [`${noticeCls}-wrapper`]: $fd11c2e4aa6a56e8$export$341e3ef8ee9ea7d6(token)
            }
        }
    ];
};
const $fd11c2e4aa6a56e8$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, $ad5b6b465efa8f67$export$33ada7d8845f7e5) + 50,
        width: 384,
        progressBg: `linear-gradient(90deg, ${token.colorPrimaryBorderHover}, ${token.colorPrimary})`,
        colorSuccessBg: token.colorSuccessBg,
        colorErrorBg: token.colorErrorBg,
        colorInfoBg: token.colorInfoBg,
        colorWarningBg: token.colorWarningBg
    });
const $fd11c2e4aa6a56e8$export$9e25a4f60ca05a04 = (token)=>{
    const notificationPaddingVertical = token.paddingMD;
    const notificationPaddingHorizontal = token.paddingLG;
    const notificationToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        notificationBg: token.colorBgElevated,
        notificationPaddingVertical: notificationPaddingVertical,
        notificationPaddingHorizontal: notificationPaddingHorizontal,
        notificationIconSize: token.calc(token.fontSizeLG).mul(token.lineHeightLG).equal(),
        notificationCloseButtonSize: token.calc(token.controlHeightLG).mul(0.55).equal(),
        notificationMarginBottom: token.margin,
        notificationPadding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingMD)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingContentHorizontalLG)}`,
        notificationMarginEdge: token.marginLG,
        animationMaxHeight: 150,
        notificationStackLayer: 3,
        notificationProgressHeight: 2
    });
    return notificationToken;
};
var $fd11c2e4aa6a56e8$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Notification', (token)=>{
    const notificationToken = $fd11c2e4aa6a56e8$export$9e25a4f60ca05a04(token);
    return [
        $fd11c2e4aa6a56e8$var$genNotificationStyle(notificationToken),
        (0, $d97eb159e96783a5$export$2e2bcd8739ae039)(notificationToken),
        (0, $2679e0c8434fee0d$export$2e2bcd8739ae039)(notificationToken)
    ];
}, $fd11c2e4aa6a56e8$export$9ca1be8807fe0675);





var $2ddf7d201812b12e$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$1537386bc155ea56)([
    'Notification',
    'PurePanel'
], (token)=>{
    const noticeCls = `${token.componentCls}-notice`;
    const notificationToken = (0, $fd11c2e4aa6a56e8$export$9e25a4f60ca05a04)(token);
    return {
        [`${noticeCls}-pure-panel`]: {
            ...(0, $fd11c2e4aa6a56e8$export$341e3ef8ee9ea7d6)(notificationToken),
            width: notificationToken.width,
            maxWidth: `calc(100vw - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(notificationToken.notificationMarginEdge).mul(2).equal())})`,
            margin: 0
        }
    };
}, (0, $fd11c2e4aa6a56e8$export$9ca1be8807fe0675));


"use client";
const $99c952774d747583$export$ad8f8fc3bcd61b4a = {
    info: /*#__PURE__*/ $ltGt3.createElement((0, $bfd6614352ed1ca0$export$2e2bcd8739ae039), null),
    success: /*#__PURE__*/ $ltGt3.createElement((0, $0cb9ffcfb49f2ccf$export$2e2bcd8739ae039), null),
    error: /*#__PURE__*/ $ltGt3.createElement((0, $332936b0d9ac1f65$export$2e2bcd8739ae039), null),
    warning: /*#__PURE__*/ $ltGt3.createElement((0, $951db5e2b3978281$export$2e2bcd8739ae039), null),
    loading: /*#__PURE__*/ $ltGt3.createElement((0, $8ede40f9e9e4f5c2$export$2e2bcd8739ae039), null)
};
function $99c952774d747583$export$a6cccece9dc8d76a(prefixCls, closeIcon) {
    if (closeIcon === null || closeIcon === false) return null;
    return closeIcon || /*#__PURE__*/ $ltGt3.createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    });
}
const $99c952774d747583$var$typeToIcon = {
    success: (0, $0cb9ffcfb49f2ccf$export$2e2bcd8739ae039),
    info: (0, $bfd6614352ed1ca0$export$2e2bcd8739ae039),
    error: (0, $332936b0d9ac1f65$export$2e2bcd8739ae039),
    warning: (0, $951db5e2b3978281$export$2e2bcd8739ae039)
};
const $99c952774d747583$export$429c001938db3a78 = (props)=>{
    const { prefixCls: prefixCls, icon: icon, type: type, title: title, description: description, actions: actions, role: role = 'alert', styles: styles, classNames: pureContentCls } = props;
    let iconNode = null;
    if (icon) iconNode = /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-icon`, pureContentCls.icon),
        style: styles.icon
    }, icon);
    else if (type) iconNode = /*#__PURE__*/ $ltGt3.createElement($99c952774d747583$var$typeToIcon[type] || null, {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-icon`, pureContentCls.icon, `${prefixCls}-icon-${type}`),
        style: styles.icon
    });
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
            [`${prefixCls}-with-icon`]: iconNode
        }),
        role: role
    }, iconNode, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-title`, pureContentCls.title),
        style: styles.title
    }, title), description && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-description`, pureContentCls.description),
        style: styles.description
    }, description), actions && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, pureContentCls.actions),
        style: styles.actions
    }, actions));
};
/** @private Internal Component. Do not use in your production. */ const $99c952774d747583$var$PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, icon: icon, type: type, message: message, title: title, description: description, btn: btn, actions: actions, closeIcon: _closeIcon, className: notificationClassName, style: style, styles: styles, classNames: notificationClassNames, closable: closable, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('notification');
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        notificationClassNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    const { notification: notificationContext } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const mergedActions = actions ?? btn;
    var deprecatedName, newName;
    const mergedTitle = title ?? message;
    const prefixCls = staticPrefixCls || getPrefixCls('notification');
    const noticePrefixCls = `${prefixCls}-notice`;
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $fd11c2e4aa6a56e8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [rawClosable, mergedCloseIcon, , ariaProps] = (0, $dd7ac7131208b252$export$aa101db403ccf5f3)((0, $dd7ac7131208b252$export$51ad9c30389f050b)(props), (0, $dd7ac7131208b252$export$51ad9c30389f050b)(notificationContext), {
        closable: true,
        closeIcon: /*#__PURE__*/ $ltGt3.createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), {
            className: `${prefixCls}-close-icon`
        }),
        closeIconRender: (icon)=>$99c952774d747583$export$a6cccece9dc8d76a(prefixCls, icon)
    });
    const mergedClosable = rawClosable ? {
        onClose: closable && typeof closable === 'object' ? closable?.onClose : undefined,
        closeIcon: mergedCloseIcon,
        ...ariaProps
    } : false;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${noticePrefixCls}-pure-panel`, hashId, notificationClassName, cssVarCls, rootCls, mergedClassNames.root),
        style: mergedStyles.root
    }, /*#__PURE__*/ $ltGt3.createElement((0, $2ddf7d201812b12e$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ $ltGt3.createElement((0, $c378429cb65aa056$export$2e2bcd8739ae039), {
        style: {
            ...contextStyle,
            ...style
        },
        ...restProps,
        prefixCls: prefixCls,
        eventKey: "pure",
        duration: null,
        closable: mergedClosable,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(notificationClassName, contextClassName),
        content: /*#__PURE__*/ $ltGt3.createElement($99c952774d747583$export$429c001938db3a78, {
            classNames: mergedClassNames,
            styles: mergedStyles,
            prefixCls: noticePrefixCls,
            icon: icon,
            type: type,
            title: mergedTitle,
            description: description,
            actions: mergedActions
        })
    }));
};
var $99c952774d747583$export$2e2bcd8739ae039 = $99c952774d747583$var$PurePanel;



function $b3986e4350209d21$export$c3e7864cecc29b16(placement, top, bottom) {
    let style;
    switch(placement){
        case 'top':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: top,
                bottom: 'auto'
            };
            break;
        case 'topLeft':
            style = {
                left: 0,
                top: top,
                bottom: 'auto'
            };
            break;
        case 'topRight':
            style = {
                right: 0,
                top: top,
                bottom: 'auto'
            };
            break;
        case 'bottom':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: 'auto',
                bottom: bottom
            };
            break;
        case 'bottomLeft':
            style = {
                left: 0,
                top: 'auto',
                bottom: bottom
            };
            break;
        default:
            style = {
                right: 0,
                top: 'auto',
                bottom: bottom
            };
            break;
    }
    return style;
}
function $b3986e4350209d21$export$7b8936ddc277a29a(prefixCls) {
    return {
        motionName: `${prefixCls}-fade`
    };
}
function $b3986e4350209d21$export$2c2219e7042654(closeIcon, notificationConfig, notification) {
    if (typeof closeIcon !== 'undefined') return closeIcon;
    if (typeof notificationConfig?.closeIcon !== 'undefined') return notificationConfig.closeIcon;
    return notification?.closeIcon;
}


"use client";
const $de5f148a210cb41b$var$DEFAULT_OFFSET = 24;
const $de5f148a210cb41b$var$DEFAULT_DURATION = 4.5;
const $de5f148a210cb41b$var$DEFAULT_PLACEMENT = 'topRight';
const $de5f148a210cb41b$var$Wrapper = ({ children: children, prefixCls: prefixCls })=>{
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $fd11c2e4aa6a56e8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $a4373403fd754cbe$export$2e2bcd8739ae039), {
        classNames: {
            list: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls)
        }
    }, children);
};
const $de5f148a210cb41b$var$renderNotifications = (node, { prefixCls: prefixCls, key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement($de5f148a210cb41b$var$Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
const $de5f148a210cb41b$var$Holder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    const { top: top, bottom: bottom, prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount: maxCount, rtl: rtl, onAllRemoved: onAllRemoved, stack: stack, duration: duration = $de5f148a210cb41b$var$DEFAULT_DURATION, pauseOnHover: pauseOnHover = true, showProgress: showProgress } = props;
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, direction: direction } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('notification');
    const { notification: notification } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const prefixCls = staticPrefixCls || getPrefixCls('notification');
    const mergedDuration = (0, $ltGt3.useMemo)(()=>typeof duration === 'number' && duration > 0 ? duration : false, [
        duration
    ]);
    // =============================== Style ===============================
    const getStyle = (placement)=>(0, $b3986e4350209d21$export$c3e7864cecc29b16)(placement, top ?? $de5f148a210cb41b$var$DEFAULT_OFFSET, bottom ?? $de5f148a210cb41b$var$DEFAULT_OFFSET);
    const getClassName = ()=>(0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
            [`${prefixCls}-rtl`]: rtl ?? direction === 'rtl'
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, $b3986e4350209d21$export$7b8936ddc277a29a)(prefixCls);
    // ============================== Origin ===============================
    const [api, holder] = (0, $cf37779611d78bda$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        closable: {
            closeIcon: (0, $99c952774d747583$export$a6cccece9dc8d76a)(prefixCls)
        },
        duration: mergedDuration,
        getContainer: ()=>staticGetContainer?.() || getPopupContainer?.() || document.body,
        maxCount: maxCount,
        pauseOnHover: pauseOnHover,
        showProgress: showProgress,
        onAllRemoved: onAllRemoved,
        renderNotifications: $de5f148a210cb41b$var$renderNotifications,
        stack: stack === false ? false : {
            threshold: typeof stack === 'object' ? stack?.threshold : undefined,
            offset: 8,
            gap: token.margin
        }
    });
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        notification?.classNames,
        props?.classNames
    ], [
        notification?.styles,
        props?.styles
    ], {
        props: props
    });
    // ================================ Ref ================================
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useImperativeHandle(ref, ()=>({
            ...api,
            prefixCls: prefixCls,
            notification: notification,
            classNames: mergedClassNames,
            styles: mergedStyles
        }));
    return holder;
});
function $de5f148a210cb41b$export$c5a84bd16043292a(notificationConfig) {
    const holderRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    const warning = (0, $9530c27c700696d0$export$cf977aa92c751e61)('Notification');
    const { notification: notificationContext } = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    // ================================ API ================================
    const wrapAPI = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        // Wrap with notification content
        // >>> Open
        const open = (config)=>{
            if (!holderRef.current) return;
            const { open: originOpen, prefixCls: prefixCls, notification: notification, classNames: originClassNames, styles: originStyles } = holderRef.current;
            const contextClassName = notification?.className || {};
            const contextStyle = notification?.style || {};
            const noticePrefixCls = `${prefixCls}-notice`;
            const { title: title, message: message, description: description, icon: icon, type: type, btn: btn, actions: actions, className: className, style: style, role: role = 'alert', closeIcon: closeIcon, closable: closable, classNames: configClassNames = {}, styles: styles = {}, ...restConfig } = config;
            var deprecatedName, newName;
            const mergedTitle = title ?? message;
            const mergedActions = actions ?? btn;
            const realCloseIcon = (0, $99c952774d747583$export$a6cccece9dc8d76a)(noticePrefixCls, (0, $b3986e4350209d21$export$2c2219e7042654)(closeIcon, notificationConfig, notification));
            const [rawClosable, mergedCloseIcon, , ariaProps] = (0, $dd7ac7131208b252$export$41ed0597a5c42f8)((0, $dd7ac7131208b252$export$51ad9c30389f050b)({
                ...notificationConfig || {},
                ...config
            }), (0, $dd7ac7131208b252$export$51ad9c30389f050b)(notificationContext), {
                closable: true,
                closeIcon: realCloseIcon
            });
            const mergedClosable = rawClosable ? {
                onClose: closable && typeof closable === 'object' ? closable.onClose : undefined,
                closeIcon: mergedCloseIcon,
                ...ariaProps
            } : false;
            const semanticClassNames = (0, $859a31e79ed756e5$export$ccd424010a24474f)(configClassNames, {
                props: config
            });
            const semanticStyles = (0, $859a31e79ed756e5$export$ccd424010a24474f)(styles, {
                props: config
            });
            const mergedClassNames = (0, $859a31e79ed756e5$export$8bf64cd1c29a1310)(undefined, originClassNames, semanticClassNames);
            const mergedStyles = (0, $859a31e79ed756e5$export$e618dc39ac9ad607)(originStyles, semanticStyles);
            return originOpen({
                // use placement from props instead of hard-coding "topRight"
                placement: notificationConfig?.placement ?? $de5f148a210cb41b$var$DEFAULT_PLACEMENT,
                ...restConfig,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $99c952774d747583$export$429c001938db3a78), {
                    prefixCls: noticePrefixCls,
                    icon: icon,
                    type: type,
                    title: mergedTitle,
                    description: description,
                    actions: mergedActions,
                    role: role,
                    classNames: mergedClassNames,
                    styles: mergedStyles
                }),
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                    [`${noticePrefixCls}-${type}`]: type
                }, className, contextClassName, mergedClassNames.root),
                style: {
                    ...contextStyle,
                    ...mergedStyles.root,
                    ...style
                },
                closable: mergedClosable
            });
        };
        // >>> destroy
        const destroy = (key)=>{
            if (key !== undefined) holderRef.current?.close(key);
            else holderRef.current?.destroy();
        };
        const clone = {
            open: open,
            destroy: destroy
        };
        const keys = [
            'success',
            'info',
            'warning',
            'error'
        ];
        keys.forEach((type)=>{
            clone[type] = (config)=>open({
                    ...config,
                    type: type
                });
        });
        return clone;
    }, [
        notificationConfig,
        notificationContext
    ]);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement($de5f148a210cb41b$var$Holder, {
            key: "notification-holder",
            ...notificationConfig,
            ref: holderRef
        })
    ];
}
function $de5f148a210cb41b$export$2e2bcd8739ae039(notificationConfig) {
    return $de5f148a210cb41b$export$c5a84bd16043292a(notificationConfig);
}



var $ltGt3 = parcelRequire("ltGt3");
const $df316434f2d5fdbd$export$264c6064649f9206 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createContext({});
const $df316434f2d5fdbd$var$AppContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createContext({
    message: {},
    notification: {},
    modal: {}
});
var $df316434f2d5fdbd$export$2e2bcd8739ae039 = $df316434f2d5fdbd$var$AppContext;



// =============================== Base ===============================
const $9f0f77c8ed343a82$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, colorText: colorText, fontSize: fontSize, lineHeight: lineHeight, fontFamily: fontFamily } = token;
    return {
        [componentCls]: {
            color: colorText,
            fontSize: fontSize,
            lineHeight: lineHeight,
            fontFamily: fontFamily,
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            }
        }
    };
};
const $9f0f77c8ed343a82$export$9ca1be8807fe0675 = ()=>({});
var // ============================== Export ==============================
$9f0f77c8ed343a82$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('App', $9f0f77c8ed343a82$var$genBaseStyle, $9f0f77c8ed343a82$export$9ca1be8807fe0675);


"use client";
const $8319566b8b70f499$var$App = (props)=>{
    const { prefixCls: customizePrefixCls, children: children, className: className, rootClassName: rootClassName, message: message, notification: notification, style: style, component: component = 'div' } = props;
    const { direction: direction, getPrefixCls: getPrefixCls } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('app', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $9f0f77c8ed343a82$export$2e2bcd8739ae039)(prefixCls);
    const customClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(hashId, prefixCls, className, rootClassName, cssVarCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    });
    const appConfig = (0, $ltGt3.useContext)((0, $df316434f2d5fdbd$export$264c6064649f9206));
    const mergedAppConfig = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>({
            message: {
                ...appConfig.message,
                ...message
            },
            notification: {
                ...appConfig.notification,
                ...notification
            }
        }), [
        message,
        notification,
        appConfig.message,
        appConfig.notification
    ]);
    const [messageApi, messageContextHolder] = (0, $784f9dc2d059291c$export$2e2bcd8739ae039)(mergedAppConfig.message);
    const [notificationApi, notificationContextHolder] = (0, $de5f148a210cb41b$export$2e2bcd8739ae039)(mergedAppConfig.notification);
    const [ModalApi, ModalContextHolder] = (0, $7539c4586900c4d6$export$2e2bcd8739ae039)();
    const memoizedContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>({
            message: messageApi,
            notification: notificationApi,
            modal: ModalApi
        }), [
        messageApi,
        notificationApi,
        ModalApi
    ]);
    // https://github.com/ant-design/ant-design/issues/48802#issuecomment-2097813526
    (0, $9530c27c700696d0$export$cf977aa92c751e61)('App')(!(cssVarCls && component === false), 'usage', 'When using cssVar, ensure `component` is assigned a valid React component string.');
    // ============================ Render ============================
    const Component = component === false ? (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Fragment : component;
    const rootProps = {
        className: customClassName,
        style: style
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $df316434f2d5fdbd$export$2e2bcd8739ae039).Provider, {
        value: memoizedContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $df316434f2d5fdbd$export$264c6064649f9206).Provider, {
        value: mergedAppConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(Component, {
        ...component === false ? undefined : rootProps
    }, ModalContextHolder, messageContextHolder, notificationContextHolder, children)));
};
var $8319566b8b70f499$export$2e2bcd8739ae039 = $8319566b8b70f499$var$App;



var $ltGt3 = parcelRequire("ltGt3");

const $6c26633fc7127316$var$useApp = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $df316434f2d5fdbd$export$2e2bcd8739ae039));
var $6c26633fc7127316$export$2e2bcd8739ae039 = $6c26633fc7127316$var$useApp;


"use client";
const $4f475c9b6cb2d3a2$var$App = (0, $8319566b8b70f499$export$2e2bcd8739ae039);
$4f475c9b6cb2d3a2$var$App.useApp = (0, $6c26633fc7127316$export$2e2bcd8739ae039);
var $4f475c9b6cb2d3a2$export$2e2bcd8739ae039 = $4f475c9b6cb2d3a2$var$App;



var $ltGt3 = parcelRequire("ltGt3");






"use client";
let $0fb9549ff19d4b13$var$message = null;
let $0fb9549ff19d4b13$var$act = (callback)=>callback();
let $0fb9549ff19d4b13$var$taskQueue = [];
let $0fb9549ff19d4b13$var$defaultGlobalConfig = {};
function $0fb9549ff19d4b13$var$getGlobalContext() {
    const { getContainer: getContainer, duration: duration, rtl: rtl, maxCount: maxCount, top: top } = $0fb9549ff19d4b13$var$defaultGlobalConfig;
    const mergedContainer = getContainer?.() || document.body;
    return {
        getContainer: ()=>mergedContainer,
        duration: duration,
        rtl: rtl,
        maxCount: maxCount,
        top: top
    };
}
const $0fb9549ff19d4b13$var$GlobalHolder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    const { messageConfig: messageConfig, sync: sync } = props;
    const { getPrefixCls: getPrefixCls } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = $0fb9549ff19d4b13$var$defaultGlobalConfig.prefixCls || getPrefixCls('message');
    const appConfig = (0, $ltGt3.useContext)((0, $df316434f2d5fdbd$export$264c6064649f9206));
    const [api, holder] = (0, $784f9dc2d059291c$export$1689db33b6c27d9e)({
        ...messageConfig,
        prefixCls: prefixCls,
        ...appConfig.message
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useImperativeHandle(ref, ()=>{
        const instance = {
            ...api
        };
        Object.keys(instance).forEach((method)=>{
            instance[method] = (...args)=>{
                sync();
                return api[method].apply(api, args);
            };
        });
        return {
            instance: instance,
            sync: sync
        };
    });
    return holder;
});
const $0fb9549ff19d4b13$var$GlobalHolderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((_, ref)=>{
    const [messageConfig, setMessageConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState($0fb9549ff19d4b13$var$getGlobalContext);
    const sync = ()=>{
        setMessageConfig($0fb9549ff19d4b13$var$getGlobalContext);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(sync, []);
    const global = (0, $3f88559997256af7$export$f9cd1e43211d8a4a)();
    const rootPrefixCls = global.getRootPrefixCls();
    const rootIconPrefixCls = global.getIconPrefixCls();
    const theme = global.getTheme();
    const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement($0fb9549ff19d4b13$var$GlobalHolder, {
        ref: ref,
        sync: sync,
        messageConfig: messageConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $3f88559997256af7$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: rootIconPrefixCls,
        theme: theme
    }, global.holderRender ? global.holderRender(dom) : dom);
});
const $0fb9549ff19d4b13$var$flushMessageQueue = ()=>{
    if (!$0fb9549ff19d4b13$var$message) {
        const holderFragment = document.createDocumentFragment();
        const newMessage = {
            fragment: holderFragment
        };
        $0fb9549ff19d4b13$var$message = newMessage;
        // Delay render to avoid sync issue
        $0fb9549ff19d4b13$var$act(()=>{
            (0, $93d215b32898d17a$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement($0fb9549ff19d4b13$var$GlobalHolderWrapper, {
                ref: (node)=>{
                    const { instance: instance, sync: sync } = node || {};
                    // React 18 test env will throw if call immediately in ref
                    Promise.resolve().then(()=>{
                        if (!newMessage.instance && instance) {
                            newMessage.instance = instance;
                            newMessage.sync = sync;
                            $0fb9549ff19d4b13$var$flushMessageQueue();
                        }
                    });
                }
            }), holderFragment);
        });
        return;
    }
    // Notification not ready
    if (!$0fb9549ff19d4b13$var$message.instance) return;
    // >>> Execute task
    $0fb9549ff19d4b13$var$taskQueue.forEach((task)=>{
        const { type: type, skipped: skipped } = task;
        // Only `skipped` when user call notice but cancel it immediately
        // and instance not ready
        if (!skipped) switch(type){
            case 'open':
                $0fb9549ff19d4b13$var$act(()=>{
                    const closeFn = $0fb9549ff19d4b13$var$message.instance.open({
                        ...$0fb9549ff19d4b13$var$defaultGlobalConfig,
                        ...task.config
                    });
                    closeFn?.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
                break;
            case 'destroy':
                $0fb9549ff19d4b13$var$act(()=>{
                    $0fb9549ff19d4b13$var$message?.instance.destroy(task.key);
                });
                break;
            // Other type open
            default:
                $0fb9549ff19d4b13$var$act(()=>{
                    var _message$instance;
                    const closeFn = (_message$instance = $0fb9549ff19d4b13$var$message.instance)[type].apply(_message$instance, (0, $83d01b7684a01087$export$2e2bcd8739ae039)(task.args));
                    closeFn?.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
        }
    });
    // Clean up
    $0fb9549ff19d4b13$var$taskQueue = [];
};
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function $0fb9549ff19d4b13$var$setMessageGlobalConfig(config) {
    $0fb9549ff19d4b13$var$defaultGlobalConfig = {
        ...$0fb9549ff19d4b13$var$defaultGlobalConfig,
        ...config
    };
    // Trigger sync for it
    $0fb9549ff19d4b13$var$act(()=>{
        $0fb9549ff19d4b13$var$message?.sync?.();
    });
}
function $0fb9549ff19d4b13$var$open(config) {
    const result = (0, $a0a45d334769b36e$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: 'open',
            config: config,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $0fb9549ff19d4b13$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $0fb9549ff19d4b13$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $0fb9549ff19d4b13$var$flushMessageQueue();
    return result;
}
function $0fb9549ff19d4b13$var$typeOpen(type, args) {
    const global = (0, $3f88559997256af7$export$f9cd1e43211d8a4a)();
    const result = (0, $a0a45d334769b36e$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: type,
            args: args,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $0fb9549ff19d4b13$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $0fb9549ff19d4b13$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $0fb9549ff19d4b13$var$flushMessageQueue();
    return result;
}
const $0fb9549ff19d4b13$var$destroy = (key)=>{
    $0fb9549ff19d4b13$var$taskQueue.push({
        type: 'destroy',
        key: key
    });
    $0fb9549ff19d4b13$var$flushMessageQueue();
};
const $0fb9549ff19d4b13$var$methods = [
    'success',
    'info',
    'warning',
    'error',
    'loading'
];
const $0fb9549ff19d4b13$var$baseStaticMethods = {
    open: $0fb9549ff19d4b13$var$open,
    destroy: $0fb9549ff19d4b13$var$destroy,
    config: $0fb9549ff19d4b13$var$setMessageGlobalConfig,
    useMessage: $784f9dc2d059291c$export$2e2bcd8739ae039,
    _InternalPanelDoNotUseOrYouWillBeFired: (0, $ff6220d8b8fa4ca4$export$2e2bcd8739ae039)
};
const $0fb9549ff19d4b13$var$staticMethods = $0fb9549ff19d4b13$var$baseStaticMethods;
$0fb9549ff19d4b13$var$methods.forEach((type)=>{
    $0fb9549ff19d4b13$var$staticMethods[type] = (...args)=>$0fb9549ff19d4b13$var$typeOpen(type, args);
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const $0fb9549ff19d4b13$var$noop = ()=>{};
let $0fb9549ff19d4b13$var$_actWrapper = $0fb9549ff19d4b13$var$noop;
var $0fb9549ff19d4b13$var$wrapper;
const $0fb9549ff19d4b13$export$71ceb3dabb09f455 = $0fb9549ff19d4b13$var$_actWrapper;
let $0fb9549ff19d4b13$var$_actDestroy = $0fb9549ff19d4b13$var$noop;
const $0fb9549ff19d4b13$export$43de32c50edff050 = $0fb9549ff19d4b13$var$_actDestroy;
var $0fb9549ff19d4b13$export$2e2bcd8739ae039 = $0fb9549ff19d4b13$var$staticMethods;




function $d59e8531745b2278$export$b1ab0447fcf2ad93() {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const app = (0, $4f475c9b6cb2d3a2$export$2e2bcd8739ae039).useApp();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("a", {
        href: "#",
        onClick: async (e)=>{
            e.preventDefault();
            const result = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).signOut();
            if (!result.success) app.message.open({
                type: 'error',
                content: result.error.message
            });
            else navigate('/');
        },
        children: intl.formatMessage({
            id: 'logOut'
        })
    });
}



var $ltGt3 = parcelRequire("ltGt3");
var $e11920ef65296b77$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $e11920ef65296b77$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $e11920ef65296b77$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $e11920ef65296b77$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $e11920ef65296b77$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $e11920ef65296b77$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e11920ef65296b77$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e11920ef65296b77$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e11920ef65296b77$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $e11920ef65296b77$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $e11920ef65296b77$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e11920ef65296b77$var$root = $e11920ef65296b77$var$freeGlobal || $e11920ef65296b77$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $e11920ef65296b77$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e11920ef65296b77$var$objectToString = $e11920ef65296b77$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e11920ef65296b77$var$nativeMax = Math.max, $e11920ef65296b77$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $e11920ef65296b77$var$now = function() {
    return $e11920ef65296b77$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $e11920ef65296b77$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($e11920ef65296b77$var$FUNC_ERROR_TEXT);
    wait = $e11920ef65296b77$var$toNumber(wait) || 0;
    if ($e11920ef65296b77$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $e11920ef65296b77$var$nativeMax($e11920ef65296b77$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $e11920ef65296b77$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $e11920ef65296b77$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($e11920ef65296b77$var$now());
    }
    function debounced() {
        var time = $e11920ef65296b77$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e11920ef65296b77$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e11920ef65296b77$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e11920ef65296b77$var$isSymbol(value) {
    return typeof value == 'symbol' || $e11920ef65296b77$var$isObjectLike(value) && $e11920ef65296b77$var$objectToString.call(value) == $e11920ef65296b77$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e11920ef65296b77$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($e11920ef65296b77$var$isSymbol(value)) return $e11920ef65296b77$var$NAN;
    if ($e11920ef65296b77$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $e11920ef65296b77$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($e11920ef65296b77$var$reTrim, '');
    var isBinary = $e11920ef65296b77$var$reIsBinary.test(value);
    return isBinary || $e11920ef65296b77$var$reIsOctal.test(value) ? $e11920ef65296b77$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e11920ef65296b77$var$reIsBadHex.test(value) ? $e11920ef65296b77$var$NAN : +value;
}
$e11920ef65296b77$exports = $e11920ef65296b77$var$debounce;


// src/useBoolean/useBoolean.ts
function $47aac17136c925a6$export$c32275ecbd12948f(defaultValue = false) {
    if (typeof defaultValue !== "boolean") throw new Error("defaultValue must be `true` or `false`");
    const [value, setValue] = (0, $ltGt3.useState)(defaultValue);
    const setTrue = (0, $ltGt3.useCallback)(()=>{
        setValue(true);
    }, []);
    const setFalse = (0, $ltGt3.useCallback)(()=>{
        setValue(false);
    }, []);
    const toggle = (0, $ltGt3.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $47aac17136c925a6$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $ltGt3.useLayoutEffect) : (0, $ltGt3.useEffect);
// src/useEventListener/useEventListener.ts
function $47aac17136c925a6$export$7080b3e976bc91ab(eventName, handler, element, options) {
    const savedHandler = (0, $ltGt3.useRef)(handler);
    $47aac17136c925a6$export$700979bc83e7db82(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $ltGt3.useEffect)(()=>{
        const targetElement = (element == null ? void 0 : element.current) ?? window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>{
            savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
// src/useClickAnyWhere/useClickAnyWhere.ts
function $47aac17136c925a6$export$5139c081cbc6c8bb(handler) {
    $47aac17136c925a6$export$7080b3e976bc91ab("click", (event)=>{
        handler(event);
    });
}
function $47aac17136c925a6$export$b2199c37e85de4a7() {
    const [copiedText, setCopiedText] = (0, $ltGt3.useState)(null);
    const copy = (0, $ltGt3.useCallback)(async (text)=>{
        if (!(navigator == null ? void 0 : navigator.clipboard)) {
            console.warn("Clipboard not supported");
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    }, []);
    return [
        copiedText,
        copy
    ];
}
function $47aac17136c925a6$export$70c4067197c60e2d(initialValue) {
    const [count, setCount] = (0, $ltGt3.useState)(initialValue ?? 0);
    const increment = (0, $ltGt3.useCallback)(()=>{
        setCount((x)=>x + 1);
    }, []);
    const decrement = (0, $ltGt3.useCallback)(()=>{
        setCount((x)=>x - 1);
    }, []);
    const reset = (0, $ltGt3.useCallback)(()=>{
        setCount(initialValue ?? 0);
    }, [
        initialValue
    ]);
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
function $47aac17136c925a6$export$f4b266cd2aae9cb1(callback, delay) {
    const savedCallback = (0, $ltGt3.useRef)(callback);
    $47aac17136c925a6$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $ltGt3.useEffect)(()=>{
        if (delay === null) return;
        const id = setInterval(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearInterval(id);
        };
    }, [
        delay
    ]);
}
// src/useCountdown/useCountdown.ts
function $47aac17136c925a6$export$8103f7eb37e19f7b({ countStart: countStart, countStop: countStop = 0, intervalMs: intervalMs = 1e3, isIncrement: isIncrement = false }) {
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = $47aac17136c925a6$export$70c4067197c60e2d(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = $47aac17136c925a6$export$c32275ecbd12948f(false);
    const resetCountdown = (0, $ltGt3.useCallback)(()=>{
        stopCountdown();
        resetCounter();
    }, [
        stopCountdown,
        resetCounter
    ]);
    const countdownCallback = (0, $ltGt3.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    $47aac17136c925a6$export$f4b266cd2aae9cb1(countdownCallback, isCountdownRunning ? intervalMs : null);
    return [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
function $47aac17136c925a6$export$ee5b5d04074a389e(fn) {
    const ref = (0, $ltGt3.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    $47aac17136c925a6$export$700979bc83e7db82(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $ltGt3.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
    }, [
        ref
    ]);
}
// src/useLocalStorage/useLocalStorage.ts
var $47aac17136c925a6$var$IS_SERVER = typeof window === "undefined";
function $47aac17136c925a6$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $ltGt3.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $ltGt3.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $ltGt3.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($47aac17136c925a6$var$IS_SERVER) return initialValueToUse;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $ltGt3.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $47aac17136c925a6$export$ee5b5d04074a389e((value)=>{
        if ($47aac17136c925a6$var$IS_SERVER) console.warn(`Tried setting localStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.localStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("local-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting localStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $47aac17136c925a6$export$ee5b5d04074a389e(()=>{
        if ($47aac17136c925a6$var$IS_SERVER) console.warn(`Tried removing localStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.localStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("local-storage", {
            key: key
        }));
    });
    (0, $ltGt3.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $ltGt3.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $47aac17136c925a6$export$7080b3e976bc91ab("storage", handleStorageChange);
    $47aac17136c925a6$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
var $47aac17136c925a6$var$IS_SERVER2 = typeof window === "undefined";
function $47aac17136c925a6$export$32d5543ab307c01(query, { defaultValue: defaultValue = false, initializeWithValue: initializeWithValue = true } = {}) {
    const getMatches = (query2)=>{
        if ($47aac17136c925a6$var$IS_SERVER2) return defaultValue;
        return window.matchMedia(query2).matches;
    };
    const [matches, setMatches] = (0, $ltGt3.useState)(()=>{
        if (initializeWithValue) return getMatches(query);
        return defaultValue;
    });
    function handleChange() {
        setMatches(getMatches(query));
    }
    $47aac17136c925a6$export$700979bc83e7db82(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
// src/useDarkMode/useDarkMode.ts
var $47aac17136c925a6$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
var $47aac17136c925a6$var$LOCAL_STORAGE_KEY = "usehooks-ts-dark-mode";
function $47aac17136c925a6$export$4673cbff94e146e2(options = {}) {
    const { defaultValue: defaultValue, localStorageKey: localStorageKey = $47aac17136c925a6$var$LOCAL_STORAGE_KEY, initializeWithValue: initializeWithValue = true } = options;
    const isDarkOS = $47aac17136c925a6$export$32d5543ab307c01($47aac17136c925a6$var$COLOR_SCHEME_QUERY, {
        initializeWithValue: initializeWithValue,
        defaultValue: defaultValue
    });
    const [isDarkMode, setDarkMode] = $47aac17136c925a6$export$86e2cef2561044ac(localStorageKey, defaultValue ?? isDarkOS ?? false, {
        initializeWithValue: initializeWithValue
    });
    $47aac17136c925a6$export$700979bc83e7db82(()=>{
        if (isDarkOS !== isDarkMode) setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>{
            setDarkMode((prev)=>!prev);
        },
        enable: ()=>{
            setDarkMode(true);
        },
        disable: ()=>{
            setDarkMode(false);
        },
        set: (value)=>{
            setDarkMode(value);
        }
    };
}
function $47aac17136c925a6$export$89e33b3d84d8c331(func) {
    const funcRef = (0, $ltGt3.useRef)(func);
    funcRef.current = func;
    (0, $ltGt3.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}
// src/useDebounceCallback/useDebounceCallback.ts
function $47aac17136c925a6$export$40ae01be0011c1e6(func, delay = 500, options) {
    const debouncedFunc = (0, $ltGt3.useRef)();
    $47aac17136c925a6$export$89e33b3d84d8c331(()=>{
        if (debouncedFunc.current) debouncedFunc.current.cancel();
    });
    const debounced = (0, $ltGt3.useMemo)(()=>{
        const debouncedFuncInstance = (0, (/*@__PURE__*/$parcel$interopDefault($e11920ef65296b77$exports)))(func, delay, options);
        const wrappedFunc = (...args)=>{
            return debouncedFuncInstance(...args);
        };
        wrappedFunc.cancel = ()=>{
            debouncedFuncInstance.cancel();
        };
        wrappedFunc.isPending = ()=>{
            return !!debouncedFunc.current;
        };
        wrappedFunc.flush = ()=>{
            return debouncedFuncInstance.flush();
        };
        return wrappedFunc;
    }, [
        func,
        delay,
        options
    ]);
    (0, $ltGt3.useEffect)(()=>{
        debouncedFunc.current = (0, (/*@__PURE__*/$parcel$interopDefault($e11920ef65296b77$exports)))(func, delay, options);
    }, [
        func,
        delay,
        options
    ]);
    return debounced;
}
function $47aac17136c925a6$export$52bae15610182273(initialValue, delay, options) {
    const eq = (options == null ? void 0 : options.equalityFn) ?? ((left, right)=>left === right);
    const unwrappedInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
    const [debouncedValue, setDebouncedValue] = (0, $ltGt3.useState)(unwrappedInitialValue);
    const previousValueRef = (0, $ltGt3.useRef)(unwrappedInitialValue);
    const updateDebouncedValue = $47aac17136c925a6$export$40ae01be0011c1e6(setDebouncedValue, delay, options);
    if (!eq(previousValueRef.current, unwrappedInitialValue)) {
        updateDebouncedValue(unwrappedInitialValue);
        previousValueRef.current = unwrappedInitialValue;
    }
    return [
        debouncedValue,
        updateDebouncedValue
    ];
}
function $47aac17136c925a6$export$4b208edda918084f(title, options = {}) {
    const { preserveTitleOnUnmount: preserveTitleOnUnmount = true } = options;
    const defaultTitle = (0, $ltGt3.useRef)(null);
    $47aac17136c925a6$export$700979bc83e7db82(()=>{
        defaultTitle.current = window.document.title;
    }, []);
    $47aac17136c925a6$export$700979bc83e7db82(()=>{
        window.document.title = title;
    }, [
        title
    ]);
    $47aac17136c925a6$export$89e33b3d84d8c331(()=>{
        if (!preserveTitleOnUnmount && defaultTitle.current) window.document.title = defaultTitle.current;
    });
}
function $47aac17136c925a6$export$ae780daf29e6d456(elementRef) {
    const [value, setValue] = (0, $ltGt3.useState)(false);
    const handleMouseEnter = ()=>{
        setValue(true);
    };
    const handleMouseLeave = ()=>{
        setValue(false);
    };
    $47aac17136c925a6$export$7080b3e976bc91ab("mouseenter", handleMouseEnter, elementRef);
    $47aac17136c925a6$export$7080b3e976bc91ab("mouseleave", handleMouseLeave, elementRef);
    return value;
}
function $47aac17136c925a6$export$a7395f9832c00176({ threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false, initialIsIntersecting: initialIsIntersecting = false, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = (0, $ltGt3.useState)(null);
    const [state, setState] = (0, $ltGt3.useState)(()=>({
            isIntersecting: initialIsIntersecting,
            entry: void 0
        }));
    const callbackRef = (0, $ltGt3.useRef)();
    callbackRef.current = onChange;
    const frozen = ((_a = state.entry) == null ? void 0 : _a.isIntersecting) && freezeOnceVisible;
    (0, $ltGt3.useEffect)(()=>{
        if (!ref) return;
        if (!("IntersectionObserver" in window)) return;
        if (frozen) return;
        let unobserve;
        const observer = new IntersectionObserver((entries)=>{
            const thresholds = Array.isArray(observer.thresholds) ? observer.thresholds : [
                observer.thresholds
            ];
            entries.forEach((entry)=>{
                const isIntersecting = entry.isIntersecting && thresholds.some((threshold2)=>entry.intersectionRatio >= threshold2);
                setState({
                    isIntersecting: isIntersecting,
                    entry: entry
                });
                if (callbackRef.current) callbackRef.current(isIntersecting, entry);
                if (isIntersecting && freezeOnceVisible && unobserve) {
                    unobserve();
                    unobserve = void 0;
                }
            });
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen,
        freezeOnceVisible
    ]);
    const prevRef = (0, $ltGt3.useRef)(null);
    (0, $ltGt3.useEffect)(()=>{
        var _a2;
        if (!ref && ((_a2 = state.entry) == null ? void 0 : _a2.target) && !freezeOnceVisible && !frozen && prevRef.current !== state.entry.target) {
            prevRef.current = state.entry.target;
            setState({
                isIntersecting: initialIsIntersecting,
                entry: void 0
            });
        }
    }, [
        ref,
        state.entry,
        freezeOnceVisible,
        frozen,
        initialIsIntersecting
    ]);
    const result = [
        setRef,
        !!state.isIntersecting,
        state.entry
    ];
    result.ref = result[0];
    result.isIntersecting = result[1];
    result.entry = result[2];
    return result;
}
function $47aac17136c925a6$export$7c8949515a63d2a1() {
    const [isClient, setClient] = (0, $ltGt3.useState)(false);
    (0, $ltGt3.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
function $47aac17136c925a6$export$80c2a3957bcb42ea() {
    const isMounted = (0, $ltGt3.useRef)(false);
    (0, $ltGt3.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $ltGt3.useCallback)(()=>isMounted.current, []);
}
function $47aac17136c925a6$export$86f8f9f08863e403(initialState = /* @__PURE__ */ new Map()) {
    const [map, setMap] = (0, $ltGt3.useState)(new Map(initialState));
    const actions = {
        set: (0, $ltGt3.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $ltGt3.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $ltGt3.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $ltGt3.useCallback)(()=>{
            setMap(()=>/* @__PURE__ */ new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
// src/useOnClickOutside/useOnClickOutside.ts
function $47aac17136c925a6$export$9afc64c180e82dc4(ref, handler, eventType = "mousedown", eventListenerOptions = {}) {
    $47aac17136c925a6$export$7080b3e976bc91ab(eventType, (event)=>{
        const target = event.target;
        if (!target || !target.isConnected) return;
        const isOutside = Array.isArray(ref) ? ref.filter((r)=>Boolean(r.current)).every((r)=>r.current && !r.current.contains(target)) : ref.current && !ref.current.contains(target);
        if (isOutside) handler(event);
    }, void 0, eventListenerOptions);
}
var $47aac17136c925a6$var$IS_SERVER3 = typeof window === "undefined";
function $47aac17136c925a6$export$558ff211cfc1c1fe(key, options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($47aac17136c925a6$var$IS_SERVER3) initializeWithValue = false;
    const deserializer = (0, $ltGt3.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return null;
        }
        return parsed;
    }, [
        options
    ]);
    const readValue = (0, $ltGt3.useCallback)(()=>{
        if ($47aac17136c925a6$var$IS_SERVER3) return null;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return null;
        }
    }, [
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $ltGt3.useState)(()=>{
        if (initializeWithValue) return readValue();
        return void 0;
    });
    (0, $ltGt3.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $ltGt3.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $47aac17136c925a6$export$7080b3e976bc91ab("storage", handleStorageChange);
    $47aac17136c925a6$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return storedValue;
}
var $47aac17136c925a6$var$initialSize = {
    width: void 0,
    height: void 0
};
function $47aac17136c925a6$export$683480f191c0e3ea(options) {
    const { ref: ref, box: box = "content-box" } = options;
    const [{ width: width, height: height }, setSize] = (0, $ltGt3.useState)($47aac17136c925a6$var$initialSize);
    const isMounted = $47aac17136c925a6$export$80c2a3957bcb42ea();
    const previousSize = (0, $ltGt3.useRef)({
        ...$47aac17136c925a6$var$initialSize
    });
    const onResize = (0, $ltGt3.useRef)(void 0);
    onResize.current = options.onResize;
    (0, $ltGt3.useEffect)(()=>{
        if (!ref.current) return;
        if (typeof window === "undefined" || !("ResizeObserver" in window)) return;
        const observer = new ResizeObserver(([entry])=>{
            const boxProp = box === "border-box" ? "borderBoxSize" : box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
            const newWidth = $47aac17136c925a6$var$extractSize(entry, boxProp, "inlineSize");
            const newHeight = $47aac17136c925a6$var$extractSize(entry, boxProp, "blockSize");
            const hasChanged = previousSize.current.width !== newWidth || previousSize.current.height !== newHeight;
            if (hasChanged) {
                const newSize = {
                    width: newWidth,
                    height: newHeight
                };
                previousSize.current.width = newWidth;
                previousSize.current.height = newHeight;
                if (onResize.current) onResize.current(newSize);
                else if (isMounted()) setSize(newSize);
            }
        });
        observer.observe(ref.current, {
            box: box
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        box,
        ref,
        isMounted
    ]);
    return {
        width: width,
        height: height
    };
}
function $47aac17136c925a6$var$extractSize(entry, box, sizeType) {
    if (!entry[box]) {
        if (box === "contentBoxSize") return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return void 0;
    }
    return Array.isArray(entry[box]) ? entry[box][0][sizeType] : // @ts-ignore Support Firefox's non-standard behavior
    entry[box][sizeType];
}
var $47aac17136c925a6$var$IS_SERVER4 = typeof window === "undefined";
function $47aac17136c925a6$export$654d3fb7a8fef387(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($47aac17136c925a6$var$IS_SERVER4) initializeWithValue = false;
    const readScreen = ()=>{
        if ($47aac17136c925a6$var$IS_SERVER4) return void 0;
        return window.screen;
    };
    const [screen, setScreen] = (0, $ltGt3.useState)(()=>{
        if (initializeWithValue) return readScreen();
        return void 0;
    });
    const debouncedSetScreen = $47aac17136c925a6$export$40ae01be0011c1e6(setScreen, options.debounceDelay);
    function handleSize() {
        const newScreen = readScreen();
        const setSize = options.debounceDelay ? debouncedSetScreen : setScreen;
        if (newScreen) {
            const { width: width, height: height, availHeight: availHeight, availWidth: availWidth, colorDepth: colorDepth, orientation: orientation, pixelDepth: pixelDepth } = newScreen;
            setSize({
                width: width,
                height: height,
                availHeight: availHeight,
                availWidth: availWidth,
                colorDepth: colorDepth,
                orientation: orientation,
                pixelDepth: pixelDepth
            });
        }
    }
    $47aac17136c925a6$export$7080b3e976bc91ab("resize", handleSize);
    $47aac17136c925a6$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return screen;
}
var $47aac17136c925a6$var$cachedScriptStatuses = /* @__PURE__ */ new Map();
function $47aac17136c925a6$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node == null ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $47aac17136c925a6$export$1d3955b0b5cace9c(src, options) {
    const [status, setStatus] = (0, $ltGt3.useState)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return $47aac17136c925a6$var$cachedScriptStatuses.get(src) ?? "loading";
    });
    (0, $ltGt3.useEffect)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $47aac17136c925a6$var$cachedScriptStatuses.get(src);
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $47aac17136c925a6$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            if (options == null ? void 0 : options.id) scriptNode.id = options.id;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode == null || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus(script.status ?? cachedScriptStatus ?? "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $47aac17136c925a6$var$cachedScriptStatuses.set(src, newStatus);
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options == null ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
                $47aac17136c925a6$var$cachedScriptStatuses.delete(src);
            }
        };
    }, [
        src,
        options == null ? void 0 : options.shouldPreventLoad,
        options == null ? void 0 : options.removeOnUnmount,
        options == null ? void 0 : options.id
    ]);
    return status;
}
var $47aac17136c925a6$var$IS_SERVER5 = typeof window === "undefined";
function $47aac17136c925a6$export$e47ba1b900da5d3b(options = {}) {
    const { autoLock: autoLock = true, lockTarget: lockTarget, widthReflow: widthReflow = true } = options;
    const [isLocked, setIsLocked] = (0, $ltGt3.useState)(false);
    const target = (0, $ltGt3.useRef)(null);
    const originalStyle = (0, $ltGt3.useRef)(null);
    const lock = ()=>{
        if (target.current) {
            const { overflow: overflow, paddingRight: paddingRight } = target.current.style;
            originalStyle.current = {
                overflow: overflow,
                paddingRight: paddingRight
            };
            if (widthReflow) {
                const offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                const currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                const scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = `${scrollbarWidth + currentPaddingRight}px`;
            }
            target.current.style.overflow = "hidden";
            setIsLocked(true);
        }
    };
    const unlock = ()=>{
        if (target.current && originalStyle.current) {
            target.current.style.overflow = originalStyle.current.overflow;
            if (widthReflow) target.current.style.paddingRight = originalStyle.current.paddingRight;
        }
        setIsLocked(false);
    };
    $47aac17136c925a6$export$700979bc83e7db82(()=>{
        if ($47aac17136c925a6$var$IS_SERVER5) return;
        if (lockTarget) target.current = typeof lockTarget === "string" ? document.querySelector(lockTarget) : lockTarget;
        if (!target.current) target.current = document.body;
        if (autoLock) lock();
        return ()=>{
            unlock();
        };
    }, [
        autoLock,
        lockTarget,
        widthReflow
    ]);
    return {
        isLocked: isLocked,
        lock: lock,
        unlock: unlock
    };
}
var $47aac17136c925a6$var$IS_SERVER6 = typeof window === "undefined";
function $47aac17136c925a6$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $ltGt3.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $ltGt3.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $ltGt3.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($47aac17136c925a6$var$IS_SERVER6) return initialValueToUse;
        try {
            const raw = window.sessionStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $ltGt3.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $47aac17136c925a6$export$ee5b5d04074a389e((value)=>{
        if ($47aac17136c925a6$var$IS_SERVER6) console.warn(`Tried setting sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.sessionStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("session-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $47aac17136c925a6$export$ee5b5d04074a389e(()=>{
        if ($47aac17136c925a6$var$IS_SERVER6) console.warn(`Tried removing sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.sessionStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("session-storage", {
            key: key
        }));
    });
    (0, $ltGt3.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $ltGt3.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $47aac17136c925a6$export$7080b3e976bc91ab("storage", handleStorageChange);
    $47aac17136c925a6$export$7080b3e976bc91ab("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
function $47aac17136c925a6$export$7896576cb7635832(maxStep) {
    const [currentStep, setCurrentStep] = (0, $ltGt3.useState)(1);
    const canGoToNextStep = currentStep + 1 <= maxStep;
    const canGoToPrevStep = currentStep - 1 > 0;
    const setStep = (0, $ltGt3.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $ltGt3.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $ltGt3.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $ltGt3.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
// src/useTernaryDarkMode/useTernaryDarkMode.ts
var $47aac17136c925a6$var$COLOR_SCHEME_QUERY2 = "(prefers-color-scheme: dark)";
var $47aac17136c925a6$var$LOCAL_STORAGE_KEY2 = "usehooks-ts-ternary-dark-mode";
function $47aac17136c925a6$export$ec561688e440eda6({ defaultValue: defaultValue = "system", localStorageKey: localStorageKey = $47aac17136c925a6$var$LOCAL_STORAGE_KEY2, initializeWithValue: initializeWithValue = true } = {}) {
    const isDarkOS = $47aac17136c925a6$export$32d5543ab307c01($47aac17136c925a6$var$COLOR_SCHEME_QUERY2, {
        initializeWithValue: initializeWithValue
    });
    const [mode, setMode] = $47aac17136c925a6$export$86e2cef2561044ac(localStorageKey, defaultValue, {
        initializeWithValue: initializeWithValue
    });
    const isDarkMode = mode === "dark" || mode === "system" && isDarkOS;
    const toggleTernaryDarkMode = ()=>{
        const modes = [
            "light",
            "system",
            "dark"
        ];
        setMode((prevMode)=>{
            const nextIndex = (modes.indexOf(prevMode) + 1) % modes.length;
            return modes[nextIndex];
        });
    };
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: mode,
        setTernaryDarkMode: setMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
function $47aac17136c925a6$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $ltGt3.useRef)(callback);
    $47aac17136c925a6$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $ltGt3.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        delay
    ]);
}
function $47aac17136c925a6$export$cbe85ee05b554577(defaultValue) {
    const [value, setValue] = (0, $ltGt3.useState)(!!defaultValue);
    const toggle = (0, $ltGt3.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return [
        value,
        toggle,
        setValue
    ];
}
var $47aac17136c925a6$var$IS_SERVER7 = typeof window === "undefined";
function $47aac17136c925a6$export$42c02f33970a2afa(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($47aac17136c925a6$var$IS_SERVER7) initializeWithValue = false;
    const [windowSize, setWindowSize] = (0, $ltGt3.useState)(()=>{
        if (initializeWithValue) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        return {
            width: void 0,
            height: void 0
        };
    });
    const debouncedSetWindowSize = $47aac17136c925a6$export$40ae01be0011c1e6(setWindowSize, options.debounceDelay);
    function handleSize() {
        const setSize = options.debounceDelay ? debouncedSetWindowSize : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }
    $47aac17136c925a6$export$7080b3e976bc91ab("resize", handleSize);
    $47aac17136c925a6$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return windowSize;
}


const { Header: $602b6ac290f4e7f6$var$Header, Sider: $602b6ac290f4e7f6$var$Sider, Content: $602b6ac290f4e7f6$var$Content } = (0, $9c8ed792d8f73a33$export$2e2bcd8739ae039);
async function $602b6ac290f4e7f6$var$getItems(intl, projects) {
    const leftMenuSections = [
        {
            name: intl.formatMessage({
                id: 'home'
            }),
            icon: (0, $802a5a63ccf25a2f$export$2e2bcd8739ae039),
            route: '/'
        },
        {
            name: intl.formatMessage({
                id: 'projects'
            }),
            icon: (0, $e4dda58ea3df6d87$export$2e2bcd8739ae039),
            route: '/projects',
            // getSubItems: async () => {
            //   const projects = await projectsService.getUserProjects()
            //   return projects.map((project) => ({name: project.name, route: `/projects/${project.id}`}))
            // },
            getSubItems: async ()=>{
                return projects.map((project)=>({
                        name: project.name,
                        route: `/projects/${project.id}`
                    }));
            }
        },
        {
            name: intl.formatMessage({
                id: 'todoLists'
            }),
            icon: (0, $c3e8af9f728fda01$export$2e2bcd8739ae039),
            route: '/todos'
        },
        {
            name: intl.formatMessage({
                id: 'plants'
            }),
            icon: (0, $76d16a8a647518f3$export$2e2bcd8739ae039),
            route: '/plants'
        },
        {
            name: intl.formatMessage({
                id: 'journal'
            }),
            icon: (0, $c52eec455c68ab77$export$2e2bcd8739ae039),
            route: '/journal'
        }
    ];
    return Promise.all(leftMenuSections.map(async (section, index)=>{
        const key = String(index + 1);
        return {
            key: `sub${key}`,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(section.icon),
            label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$b0d92dbee9b5b60d), {
                className: ({ isActive: isActive, isPending: isPending })=>(0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))('nav-link', isActive && 'nav-link--active', isPending && 'nav-link--pending'),
                to: section.route,
                children: section.name
            }),
            children: typeof section.getSubItems === 'function' ? (await section.getSubItems()).map((subItem, j)=>{
                const subKey = index * 4 + j + 1;
                return {
                    key: subKey,
                    label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$b0d92dbee9b5b60d), {
                        className: ({ isActive: isActive, isPending: isPending })=>(0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))('nav-link', isActive && 'nav-link--active', isPending && 'nav-link--pending'),
                        to: subItem.route,
                        children: subItem.name
                    })
                };
            }) : undefined
        };
    }));
}
function $602b6ac290f4e7f6$export$c84671f46d6a1ca() {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const navigation = (0, $493cbc5b00d91baa$export$d0fd4b7106de2769)();
    const [collapsed, setCollapsed] = (0, $ltGt3.useState)(true);
    const { token: { colorBgContainer: colorBgContainer } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    const siderRef = (0, $ltGt3.useRef)(null);
    const collapseTriggerRef = (0, $ltGt3.useRef)(null);
    const location = (0, $493cbc5b00d91baa$export$45d76561a5302f2b)();
    // on small screens the sider overlays the page, so hide it after every navigation
    (0, $ltGt3.useEffect)(()=>{
        setCollapsed(true);
    }, [
        location.key
    ]);
    (0, $47aac17136c925a6$export$9afc64c180e82dc4)(siderRef, (evt)=>{
        if (collapseTriggerRef.current && evt.target && (evt.target === collapseTriggerRef.current || collapseTriggerRef.current.contains(evt.target))) return;
        setCollapsed(true);
    });
    const { projectNames: projectNames } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('root') || {
        projectNames: []
    };
    const { value: items, error: error } = (0, $1e104381209dd9b4$export$78a72ddb39bdd145)([], ()=>$602b6ac290f4e7f6$var$getItems(intl, projectNames), [
        intl.locale,
        projectNames
    ]);
    const changeLocale = (0, $17695373636e29e1$export$3013d29b72c2d37b)();
    const locale = (0, $17695373636e29e1$export$43bb16f9c6d9e3f7)();
    const itemsUserIcon = [
        {
            key: '1',
            label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                to: "/user",
                children: intl.formatMessage({
                    id: 'userAccount'
                })
            })
        },
        {
            key: '2',
            label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d59e8531745b2278$export$b1ab0447fcf2ad93), {})
        }
    ];
    const languages = [
        'en',
        'ru'
    ];
    const itemsLanguages = languages.map((l)=>({
            key: l,
            label: l,
            onClick: ()=>changeLocale(l),
            className: locale === l ? 'active' : ''
        }));
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9c8ed792d8f73a33$export$2e2bcd8739ae039), {
        style: {
            minHeight: '100vh'
        },
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3f88559997256af7$export$2e2bcd8739ae039), {
                theme: {
                    token: {
                        colorLink: 'white'
                    }
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($602b6ac290f4e7f6$var$Header, {
                    style: {
                        padding: 0
                    },
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            paddingLeft: 24,
                            alignItems: 'center',
                            justifyContent: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                className: "collapse-trigger",
                                size: "large",
                                type: "link",
                                ref: collapseTriggerRef,
                                onClick: ()=>setCollapsed((current)=>!current),
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d145441113989bb5$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "logo",
                                style: {
                                    position: 'relative',
                                    overflow: 'hidden'
                                },
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h1", {
                                        style: {
                                            margin: 0,
                                            paddingLeft: 0,
                                            color: 'white'
                                        },
                                        children: "TerraSketch"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                style: {
                                    flex: '1 1 0%',
                                    overflow: 'hidden'
                                }
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                style: {
                                    float: 'right',
                                    alignItems: 'center',
                                    paddingRight: '24px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $fdbae0f0e90936fe$export$2e2bcd8739ae039), {
                                        menu: {
                                            items: itemsLanguages
                                        },
                                        placement: "bottomLeft",
                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                            type: "link",
                                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $faae94e2180ec81a$export$2e2bcd8739ae039), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $fdbae0f0e90936fe$export$2e2bcd8739ae039), {
                                        menu: {
                                            items: itemsUserIcon
                                        },
                                        placement: "bottomLeft",
                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                            type: "link",
                                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $c3a5f6dca0f6325d$export$2e2bcd8739ae039), {})
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9c8ed792d8f73a33$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)($602b6ac290f4e7f6$var$Sider, {
                        trigger: null,
                        collapsed: false,
                        style: {
                            background: colorBgContainer
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(collapsed && 'side-menu--collapsed', 'side-menu'),
                        ref: siderRef,
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ad53fe0065acc0ef$export$2e2bcd8739ae039), {
                                mode: "inline",
                                defaultSelectedKeys: [
                                    '1'
                                ],
                                defaultOpenKeys: [
                                    'sub1'
                                ],
                                style: {
                                    borderRight: 0
                                },
                                items: items
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                className: "policy-link",
                                to: "/policies",
                                children: intl.formatMessage({
                                    id: 'policy'
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($602b6ac290f4e7f6$var$Content, {
                        className: "page-content",
                        style: {
                            minHeight: 280,
                            background: colorBgContainer
                        },
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            className: navigation.state === 'loading' ? 'loading' : '',
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $493cbc5b00d91baa$export$910ae8079b2c2852), {})
                        })
                    })
                ]
            })
        ]
    });
}



parcelRequire("ltGt3");

function $74710a0e13b9a10e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $74710a0e13b9a10e$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $74710a0e13b9a10e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $74710a0e13b9a10e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $74710a0e13b9a10e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $74710a0e13b9a10e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $74710a0e13b9a10e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $74710a0e13b9a10e$var$_typeof(obj);
}
function $74710a0e13b9a10e$var$_wrapRegExp() {
    $74710a0e13b9a10e$var$_wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), $74710a0e13b9a10e$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return $74710a0e13b9a10e$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, $74710a0e13b9a10e$var$_wrapRegExp.apply(this, arguments);
}
function $74710a0e13b9a10e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $74710a0e13b9a10e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $74710a0e13b9a10e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $74710a0e13b9a10e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $74710a0e13b9a10e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $74710a0e13b9a10e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $74710a0e13b9a10e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $74710a0e13b9a10e$var$_setPrototypeOf(subClass, superClass);
}
function $74710a0e13b9a10e$var$_setPrototypeOf(o, p) {
    $74710a0e13b9a10e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $74710a0e13b9a10e$var$_setPrototypeOf(o, p);
}
function $74710a0e13b9a10e$var$_slicedToArray(arr, i) {
    return $74710a0e13b9a10e$var$_arrayWithHoles(arr) || $74710a0e13b9a10e$var$_iterableToArrayLimit(arr, i) || $74710a0e13b9a10e$var$_unsupportedIterableToArray(arr, i) || $74710a0e13b9a10e$var$_nonIterableRest();
}
function $74710a0e13b9a10e$var$_toConsumableArray(arr) {
    return $74710a0e13b9a10e$var$_arrayWithoutHoles(arr) || $74710a0e13b9a10e$var$_iterableToArray(arr) || $74710a0e13b9a10e$var$_unsupportedIterableToArray(arr) || $74710a0e13b9a10e$var$_nonIterableSpread();
}
function $74710a0e13b9a10e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $74710a0e13b9a10e$var$_arrayLikeToArray(arr);
}
function $74710a0e13b9a10e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $74710a0e13b9a10e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $74710a0e13b9a10e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $74710a0e13b9a10e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $74710a0e13b9a10e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $74710a0e13b9a10e$var$_arrayLikeToArray(o, minLen);
}
function $74710a0e13b9a10e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $74710a0e13b9a10e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $74710a0e13b9a10e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $74710a0e13b9a10e$var$noop = function noop() {};
var $74710a0e13b9a10e$var$_WINDOW = {};
var $74710a0e13b9a10e$var$_DOCUMENT = {};
var $74710a0e13b9a10e$var$_MUTATION_OBSERVER = null;
var $74710a0e13b9a10e$var$_PERFORMANCE = {
    mark: $74710a0e13b9a10e$var$noop,
    measure: $74710a0e13b9a10e$var$noop
};
try {
    if (typeof window !== 'undefined') $74710a0e13b9a10e$var$_WINDOW = window;
    if (typeof document !== 'undefined') $74710a0e13b9a10e$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $74710a0e13b9a10e$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $74710a0e13b9a10e$var$_PERFORMANCE = performance;
} catch (e) {}
var $74710a0e13b9a10e$var$_ref = $74710a0e13b9a10e$var$_WINDOW.navigator || {}, $74710a0e13b9a10e$var$_ref$userAgent = $74710a0e13b9a10e$var$_ref.userAgent, $74710a0e13b9a10e$var$userAgent = $74710a0e13b9a10e$var$_ref$userAgent === void 0 ? '' : $74710a0e13b9a10e$var$_ref$userAgent;
var $74710a0e13b9a10e$var$WINDOW = $74710a0e13b9a10e$var$_WINDOW;
var $74710a0e13b9a10e$var$DOCUMENT = $74710a0e13b9a10e$var$_DOCUMENT;
var $74710a0e13b9a10e$var$MUTATION_OBSERVER = $74710a0e13b9a10e$var$_MUTATION_OBSERVER;
var $74710a0e13b9a10e$var$PERFORMANCE = $74710a0e13b9a10e$var$_PERFORMANCE;
var $74710a0e13b9a10e$var$IS_BROWSER = !!$74710a0e13b9a10e$var$WINDOW.document;
var $74710a0e13b9a10e$var$IS_DOM = !!$74710a0e13b9a10e$var$DOCUMENT.documentElement && !!$74710a0e13b9a10e$var$DOCUMENT.head && typeof $74710a0e13b9a10e$var$DOCUMENT.addEventListener === 'function' && typeof $74710a0e13b9a10e$var$DOCUMENT.createElement === 'function';
var $74710a0e13b9a10e$var$IS_IE = ~$74710a0e13b9a10e$var$userAgent.indexOf('MSIE') || ~$74710a0e13b9a10e$var$userAgent.indexOf('Trident/');
var $74710a0e13b9a10e$var$_familyProxy, $74710a0e13b9a10e$var$_familyProxy2, $74710a0e13b9a10e$var$_familyProxy3, $74710a0e13b9a10e$var$_familyProxy4, $74710a0e13b9a10e$var$_familyProxy5;
var $74710a0e13b9a10e$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var $74710a0e13b9a10e$var$UNITS_IN_GRID = 16;
var $74710a0e13b9a10e$var$DEFAULT_CSS_PREFIX = 'fa';
var $74710a0e13b9a10e$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var $74710a0e13b9a10e$var$DATA_FA_I2SVG = 'data-fa-i2svg';
var $74710a0e13b9a10e$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var $74710a0e13b9a10e$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var $74710a0e13b9a10e$var$DATA_PREFIX = 'data-prefix';
var $74710a0e13b9a10e$var$DATA_ICON = 'data-icon';
var $74710a0e13b9a10e$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var $74710a0e13b9a10e$var$MUTATION_APPROACH_ASYNC = 'async';
var $74710a0e13b9a10e$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
var $74710a0e13b9a10e$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $74710a0e13b9a10e$var$FAMILY_CLASSIC = 'classic';
var $74710a0e13b9a10e$var$FAMILY_SHARP = 'sharp';
var $74710a0e13b9a10e$var$FAMILIES = [
    $74710a0e13b9a10e$var$FAMILY_CLASSIC,
    $74710a0e13b9a10e$var$FAMILY_SHARP
];
function $74710a0e13b9a10e$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$74710a0e13b9a10e$var$FAMILY_CLASSIC];
        }
    });
}
var $74710a0e13b9a10e$var$PREFIX_TO_STYLE = $74710a0e13b9a10e$var$familyProxy(($74710a0e13b9a10e$var$_familyProxy = {}, $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_familyProxy, $74710a0e13b9a10e$var$FAMILY_CLASSIC, {
    'fa': 'solid',
    'fas': 'solid',
    'fa-solid': 'solid',
    'far': 'regular',
    'fa-regular': 'regular',
    'fal': 'light',
    'fa-light': 'light',
    'fat': 'thin',
    'fa-thin': 'thin',
    'fad': 'duotone',
    'fa-duotone': 'duotone',
    'fab': 'brands',
    'fa-brands': 'brands',
    'fak': 'kit',
    'fa-kit': 'kit'
}), $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_familyProxy, $74710a0e13b9a10e$var$FAMILY_SHARP, {
    'fa': 'solid',
    'fass': 'solid',
    'fa-solid': 'solid'
}), $74710a0e13b9a10e$var$_familyProxy));
var $74710a0e13b9a10e$var$STYLE_TO_PREFIX = $74710a0e13b9a10e$var$familyProxy(($74710a0e13b9a10e$var$_familyProxy2 = {}, $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_familyProxy2, $74710a0e13b9a10e$var$FAMILY_CLASSIC, {
    'solid': 'fas',
    'regular': 'far',
    'light': 'fal',
    'thin': 'fat',
    'duotone': 'fad',
    'brands': 'fab',
    'kit': 'fak'
}), $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_familyProxy2, $74710a0e13b9a10e$var$FAMILY_SHARP, {
    'solid': 'fass'
}), $74710a0e13b9a10e$var$_familyProxy2));
var $74710a0e13b9a10e$var$PREFIX_TO_LONG_STYLE = $74710a0e13b9a10e$var$familyProxy(($74710a0e13b9a10e$var$_familyProxy3 = {}, $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_familyProxy3, $74710a0e13b9a10e$var$FAMILY_CLASSIC, {
    'fab': 'fa-brands',
    'fad': 'fa-duotone',
    'fak': 'fa-kit',
    'fal': 'fa-light',
    'far': 'fa-regular',
    'fas': 'fa-solid',
    'fat': 'fa-thin'
}), $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_familyProxy3, $74710a0e13b9a10e$var$FAMILY_SHARP, {
    'fass': 'fa-solid'
}), $74710a0e13b9a10e$var$_familyProxy3));
var $74710a0e13b9a10e$var$LONG_STYLE_TO_PREFIX = $74710a0e13b9a10e$var$familyProxy(($74710a0e13b9a10e$var$_familyProxy4 = {}, $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_familyProxy4, $74710a0e13b9a10e$var$FAMILY_CLASSIC, {
    'fa-brands': 'fab',
    'fa-duotone': 'fad',
    'fa-kit': 'fak',
    'fa-light': 'fal',
    'fa-regular': 'far',
    'fa-solid': 'fas',
    'fa-thin': 'fat'
}), $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_familyProxy4, $74710a0e13b9a10e$var$FAMILY_SHARP, {
    'fa-solid': 'fass'
}), $74710a0e13b9a10e$var$_familyProxy4));
var $74710a0e13b9a10e$var$ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss)?[\-\ ]/; // eslint-disable-line no-useless-escape
var $74710a0e13b9a10e$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var $74710a0e13b9a10e$var$FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i; // TODO: this needs to support fass
// TODO: do we need to handle font-weight for kit SVG pseudo-elements?
var $74710a0e13b9a10e$var$FONT_WEIGHT_TO_PREFIX = $74710a0e13b9a10e$var$familyProxy(($74710a0e13b9a10e$var$_familyProxy5 = {}, $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_familyProxy5, $74710a0e13b9a10e$var$FAMILY_CLASSIC, {
    '900': 'fas',
    '400': 'far',
    'normal': 'far',
    '300': 'fal',
    '100': 'fat'
}), $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_familyProxy5, $74710a0e13b9a10e$var$FAMILY_SHARP, {
    '900': 'fass'
}), $74710a0e13b9a10e$var$_familyProxy5));
var $74710a0e13b9a10e$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $74710a0e13b9a10e$var$oneToTwenty = $74710a0e13b9a10e$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $74710a0e13b9a10e$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
var $74710a0e13b9a10e$var$DUOTONE_CLASSES = {
    GROUP: 'duotone-group',
    SWAP_OPACITY: 'swap-opacity',
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
};
var $74710a0e13b9a10e$var$prefixes = new Set();
Object.keys($74710a0e13b9a10e$var$STYLE_TO_PREFIX[$74710a0e13b9a10e$var$FAMILY_CLASSIC]).map($74710a0e13b9a10e$var$prefixes.add.bind($74710a0e13b9a10e$var$prefixes));
Object.keys($74710a0e13b9a10e$var$STYLE_TO_PREFIX[$74710a0e13b9a10e$var$FAMILY_SHARP]).map($74710a0e13b9a10e$var$prefixes.add.bind($74710a0e13b9a10e$var$prefixes));
var $74710a0e13b9a10e$var$RESERVED_CLASSES = [].concat($74710a0e13b9a10e$var$FAMILIES, $74710a0e13b9a10e$var$_toConsumableArray($74710a0e13b9a10e$var$prefixes), [
    '2xs',
    'xs',
    'sm',
    'lg',
    'xl',
    '2xl',
    'beat',
    'border',
    'fade',
    'beat-fade',
    'bounce',
    'flip-both',
    'flip-horizontal',
    'flip-vertical',
    'flip',
    'fw',
    'inverse',
    'layers-counter',
    'layers-text',
    'layers',
    'li',
    'pull-left',
    'pull-right',
    'pulse',
    'rotate-180',
    'rotate-270',
    'rotate-90',
    'rotate-by',
    'shake',
    'spin-pulse',
    'spin-reverse',
    'spin',
    'stack-1x',
    'stack-2x',
    'stack',
    'ul',
    $74710a0e13b9a10e$var$DUOTONE_CLASSES.GROUP,
    $74710a0e13b9a10e$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $74710a0e13b9a10e$var$DUOTONE_CLASSES.PRIMARY,
    $74710a0e13b9a10e$var$DUOTONE_CLASSES.SECONDARY
]).concat($74710a0e13b9a10e$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($74710a0e13b9a10e$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $74710a0e13b9a10e$var$initial = $74710a0e13b9a10e$var$WINDOW.FontAwesomeConfig || {};
function $74710a0e13b9a10e$var$getAttrConfig(attr) {
    var element = $74710a0e13b9a10e$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $74710a0e13b9a10e$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($74710a0e13b9a10e$var$DOCUMENT && typeof $74710a0e13b9a10e$var$DOCUMENT.querySelector === 'function') {
    var $74710a0e13b9a10e$var$attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-css-prefix',
            'cssPrefix'
        ],
        [
            'data-family-default',
            'familyDefault'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-auto-a11y',
            'autoA11y'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    $74710a0e13b9a10e$var$attrs.forEach(function(_ref) {
        var _ref2 = $74710a0e13b9a10e$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $74710a0e13b9a10e$var$coerce($74710a0e13b9a10e$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $74710a0e13b9a10e$var$initial[key] = val;
    });
}
var $74710a0e13b9a10e$var$_default = {
    styleDefault: 'solid',
    familyDefault: 'classic',
    cssPrefix: $74710a0e13b9a10e$var$DEFAULT_CSS_PREFIX,
    replacementClass: $74710a0e13b9a10e$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present
if ($74710a0e13b9a10e$var$initial.familyPrefix) $74710a0e13b9a10e$var$initial.cssPrefix = $74710a0e13b9a10e$var$initial.familyPrefix;
var $74710a0e13b9a10e$var$_config = $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, $74710a0e13b9a10e$var$_default), $74710a0e13b9a10e$var$initial);
if (!$74710a0e13b9a10e$var$_config.autoReplaceSvg) $74710a0e13b9a10e$var$_config.observeMutations = false;
var $74710a0e13b9a10e$var$config = {};
Object.keys($74710a0e13b9a10e$var$_default).forEach(function(key) {
    Object.defineProperty($74710a0e13b9a10e$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $74710a0e13b9a10e$var$_config[key] = val;
            $74710a0e13b9a10e$var$_onChangeCb.forEach(function(cb) {
                return cb($74710a0e13b9a10e$var$config);
            });
        },
        get: function get() {
            return $74710a0e13b9a10e$var$_config[key];
        }
    });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($74710a0e13b9a10e$var$config, 'familyPrefix', {
    enumerable: true,
    set: function set(val) {
        $74710a0e13b9a10e$var$_config.cssPrefix = val;
        $74710a0e13b9a10e$var$_onChangeCb.forEach(function(cb) {
            return cb($74710a0e13b9a10e$var$config);
        });
    },
    get: function get() {
        return $74710a0e13b9a10e$var$_config.cssPrefix;
    }
});
$74710a0e13b9a10e$var$WINDOW.FontAwesomeConfig = $74710a0e13b9a10e$var$config;
var $74710a0e13b9a10e$var$_onChangeCb = [];
function $74710a0e13b9a10e$var$onChange(cb) {
    $74710a0e13b9a10e$var$_onChangeCb.push(cb);
    return function() {
        $74710a0e13b9a10e$var$_onChangeCb.splice($74710a0e13b9a10e$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $74710a0e13b9a10e$var$d = $74710a0e13b9a10e$var$UNITS_IN_GRID;
var $74710a0e13b9a10e$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $74710a0e13b9a10e$var$insertCss(css) {
    if (!css || !$74710a0e13b9a10e$var$IS_DOM) return;
    var style = $74710a0e13b9a10e$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    var headChildren = $74710a0e13b9a10e$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $74710a0e13b9a10e$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $74710a0e13b9a10e$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $74710a0e13b9a10e$var$nextUniqueId() {
    var size = 12;
    var id = '';
    while(size-- > 0)id += $74710a0e13b9a10e$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $74710a0e13b9a10e$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $74710a0e13b9a10e$var$classArray(node) {
    if (node.classList) return $74710a0e13b9a10e$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter(function(i) {
        return i;
    });
}
function $74710a0e13b9a10e$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $74710a0e13b9a10e$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, "=\"").concat($74710a0e13b9a10e$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $74710a0e13b9a10e$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function $74710a0e13b9a10e$var$transformIsMeaningful(transform) {
    return transform.size !== $74710a0e13b9a10e$var$meaninglessTransform.size || transform.x !== $74710a0e13b9a10e$var$meaninglessTransform.x || transform.y !== $74710a0e13b9a10e$var$meaninglessTransform.y || transform.rotate !== $74710a0e13b9a10e$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $74710a0e13b9a10e$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $74710a0e13b9a10e$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $74710a0e13b9a10e$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $74710a0e13b9a10e$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = '';
    if (startCentered && $74710a0e13b9a10e$var$IS_IE) val += "translate(".concat(transform.x / $74710a0e13b9a10e$var$d - width / 2, "em, ").concat(transform.y / $74710a0e13b9a10e$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $74710a0e13b9a10e$var$d, "em), calc(-50% + ").concat(transform.y / $74710a0e13b9a10e$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $74710a0e13b9a10e$var$d, "em, ").concat(transform.y / $74710a0e13b9a10e$var$d, "em) ");
    val += "scale(".concat(transform.size / $74710a0e13b9a10e$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $74710a0e13b9a10e$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $74710a0e13b9a10e$var$baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";
function $74710a0e13b9a10e$var$css() {
    var dcp = $74710a0e13b9a10e$var$DEFAULT_CSS_PREFIX;
    var drc = $74710a0e13b9a10e$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $74710a0e13b9a10e$var$config.cssPrefix;
    var rc = $74710a0e13b9a10e$var$config.replacementClass;
    var s = $74710a0e13b9a10e$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
        var rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $74710a0e13b9a10e$var$_cssInserted = false;
function $74710a0e13b9a10e$var$ensureCss() {
    if ($74710a0e13b9a10e$var$config.autoAddCss && !$74710a0e13b9a10e$var$_cssInserted) {
        $74710a0e13b9a10e$var$insertCss($74710a0e13b9a10e$var$css());
        $74710a0e13b9a10e$var$_cssInserted = true;
    }
}
var $74710a0e13b9a10e$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $74710a0e13b9a10e$var$css,
                insertCss: $74710a0e13b9a10e$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $74710a0e13b9a10e$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $74710a0e13b9a10e$var$ensureCss();
            }
        };
    }
};
var $74710a0e13b9a10e$var$w = $74710a0e13b9a10e$var$WINDOW || {};
if (!$74710a0e13b9a10e$var$w[$74710a0e13b9a10e$var$NAMESPACE_IDENTIFIER]) $74710a0e13b9a10e$var$w[$74710a0e13b9a10e$var$NAMESPACE_IDENTIFIER] = {};
if (!$74710a0e13b9a10e$var$w[$74710a0e13b9a10e$var$NAMESPACE_IDENTIFIER].styles) $74710a0e13b9a10e$var$w[$74710a0e13b9a10e$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$74710a0e13b9a10e$var$w[$74710a0e13b9a10e$var$NAMESPACE_IDENTIFIER].hooks) $74710a0e13b9a10e$var$w[$74710a0e13b9a10e$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$74710a0e13b9a10e$var$w[$74710a0e13b9a10e$var$NAMESPACE_IDENTIFIER].shims) $74710a0e13b9a10e$var$w[$74710a0e13b9a10e$var$NAMESPACE_IDENTIFIER].shims = [];
var $74710a0e13b9a10e$var$namespace = $74710a0e13b9a10e$var$w[$74710a0e13b9a10e$var$NAMESPACE_IDENTIFIER];
var $74710a0e13b9a10e$var$functions = [];
var $74710a0e13b9a10e$var$listener = function listener() {
    $74710a0e13b9a10e$var$DOCUMENT.removeEventListener('DOMContentLoaded', listener);
    $74710a0e13b9a10e$var$loaded = 1;
    $74710a0e13b9a10e$var$functions.map(function(fn) {
        return fn();
    });
};
var $74710a0e13b9a10e$var$loaded = false;
if ($74710a0e13b9a10e$var$IS_DOM) {
    $74710a0e13b9a10e$var$loaded = ($74710a0e13b9a10e$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($74710a0e13b9a10e$var$DOCUMENT.readyState);
    if (!$74710a0e13b9a10e$var$loaded) $74710a0e13b9a10e$var$DOCUMENT.addEventListener('DOMContentLoaded', $74710a0e13b9a10e$var$listener);
}
function $74710a0e13b9a10e$var$domready(fn) {
    if (!$74710a0e13b9a10e$var$IS_DOM) return;
    $74710a0e13b9a10e$var$loaded ? setTimeout(fn, 0) : $74710a0e13b9a10e$var$functions.push(fn);
}
function $74710a0e13b9a10e$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === 'string') return $74710a0e13b9a10e$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($74710a0e13b9a10e$var$joinAttributes(attributes), ">").concat(children.map($74710a0e13b9a10e$var$toHtml).join(''), "</").concat(tag, ">");
}
function $74710a0e13b9a10e$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $74710a0e13b9a10e$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $74710a0e13b9a10e$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $74710a0e13b9a10e$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $74710a0e13b9a10e$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $74710a0e13b9a10e$var$toHex(unicode) {
    var decoded = $74710a0e13b9a10e$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $74710a0e13b9a10e$var$codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $74710a0e13b9a10e$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $74710a0e13b9a10e$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $74710a0e13b9a10e$var$normalizeIcons(icons);
    if (typeof $74710a0e13b9a10e$var$namespace.hooks.addPack === 'function' && !skipHooks) $74710a0e13b9a10e$var$namespace.hooks.addPack(prefix, $74710a0e13b9a10e$var$normalizeIcons(icons));
    else $74710a0e13b9a10e$var$namespace.styles[prefix] = $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, $74710a0e13b9a10e$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $74710a0e13b9a10e$var$defineIcons('fa', icons);
}
var $74710a0e13b9a10e$var$duotonePathRe = [
    /*#__PURE__*/ $74710a0e13b9a10e$var$_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $74710a0e13b9a10e$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $74710a0e13b9a10e$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var $74710a0e13b9a10e$var$_LONG_STYLE, $74710a0e13b9a10e$var$_PREFIXES, $74710a0e13b9a10e$var$_PREFIXES_FOR_FAMILY;
var $74710a0e13b9a10e$var$styles = $74710a0e13b9a10e$var$namespace.styles, $74710a0e13b9a10e$var$shims = $74710a0e13b9a10e$var$namespace.shims;
var $74710a0e13b9a10e$var$LONG_STYLE = ($74710a0e13b9a10e$var$_LONG_STYLE = {}, $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_LONG_STYLE, $74710a0e13b9a10e$var$FAMILY_CLASSIC, Object.values($74710a0e13b9a10e$var$PREFIX_TO_LONG_STYLE[$74710a0e13b9a10e$var$FAMILY_CLASSIC])), $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_LONG_STYLE, $74710a0e13b9a10e$var$FAMILY_SHARP, Object.values($74710a0e13b9a10e$var$PREFIX_TO_LONG_STYLE[$74710a0e13b9a10e$var$FAMILY_SHARP])), $74710a0e13b9a10e$var$_LONG_STYLE);
var $74710a0e13b9a10e$var$_defaultUsablePrefix = null;
var $74710a0e13b9a10e$var$_byUnicode = {};
var $74710a0e13b9a10e$var$_byLigature = {};
var $74710a0e13b9a10e$var$_byOldName = {};
var $74710a0e13b9a10e$var$_byOldUnicode = {};
var $74710a0e13b9a10e$var$_byAlias = {};
var $74710a0e13b9a10e$var$PREFIXES = ($74710a0e13b9a10e$var$_PREFIXES = {}, $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_PREFIXES, $74710a0e13b9a10e$var$FAMILY_CLASSIC, Object.keys($74710a0e13b9a10e$var$PREFIX_TO_STYLE[$74710a0e13b9a10e$var$FAMILY_CLASSIC])), $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_PREFIXES, $74710a0e13b9a10e$var$FAMILY_SHARP, Object.keys($74710a0e13b9a10e$var$PREFIX_TO_STYLE[$74710a0e13b9a10e$var$FAMILY_SHARP])), $74710a0e13b9a10e$var$_PREFIXES);
function $74710a0e13b9a10e$var$isReserved(name) {
    return ~$74710a0e13b9a10e$var$RESERVED_CLASSES.indexOf(name);
}
function $74710a0e13b9a10e$var$getIconName(cssPrefix, cls) {
    var parts = cls.split('-');
    var prefix = parts[0];
    var iconName = parts.slice(1).join('-');
    if (prefix === cssPrefix && iconName !== '' && !$74710a0e13b9a10e$var$isReserved(iconName)) return iconName;
    else return null;
}
var $74710a0e13b9a10e$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $74710a0e13b9a10e$var$reduce($74710a0e13b9a10e$var$styles, function(o, style, prefix) {
            o[prefix] = $74710a0e13b9a10e$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $74710a0e13b9a10e$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === 'number';
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $74710a0e13b9a10e$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === 'string';
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $74710a0e13b9a10e$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = 'far' in $74710a0e13b9a10e$var$styles || $74710a0e13b9a10e$var$config.autoFetchSvg;
    var shimLookups = $74710a0e13b9a10e$var$reduce($74710a0e13b9a10e$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $74710a0e13b9a10e$var$_byOldName = shimLookups.names;
    $74710a0e13b9a10e$var$_byOldUnicode = shimLookups.unicodes;
    $74710a0e13b9a10e$var$_defaultUsablePrefix = $74710a0e13b9a10e$var$getCanonicalPrefix($74710a0e13b9a10e$var$config.styleDefault, {
        family: $74710a0e13b9a10e$var$config.familyDefault
    });
};
$74710a0e13b9a10e$var$onChange(function(c) {
    $74710a0e13b9a10e$var$_defaultUsablePrefix = $74710a0e13b9a10e$var$getCanonicalPrefix(c.styleDefault, {
        family: $74710a0e13b9a10e$var$config.familyDefault
    });
});
$74710a0e13b9a10e$var$build();
function $74710a0e13b9a10e$var$byUnicode(prefix, unicode) {
    return ($74710a0e13b9a10e$var$_byUnicode[prefix] || {})[unicode];
}
function $74710a0e13b9a10e$var$byLigature(prefix, ligature) {
    return ($74710a0e13b9a10e$var$_byLigature[prefix] || {})[ligature];
}
function $74710a0e13b9a10e$var$byAlias(prefix, alias) {
    return ($74710a0e13b9a10e$var$_byAlias[prefix] || {})[alias];
}
function $74710a0e13b9a10e$var$byOldName(name) {
    return $74710a0e13b9a10e$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $74710a0e13b9a10e$var$byOldUnicode(unicode) {
    var oldUnicode = $74710a0e13b9a10e$var$_byOldUnicode[unicode];
    var newUnicode = $74710a0e13b9a10e$var$byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $74710a0e13b9a10e$var$getDefaultUsablePrefix() {
    return $74710a0e13b9a10e$var$_defaultUsablePrefix;
}
var $74710a0e13b9a10e$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $74710a0e13b9a10e$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $74710a0e13b9a10e$var$FAMILY_CLASSIC : _params$family;
    var style = $74710a0e13b9a10e$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    var prefix = $74710a0e13b9a10e$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $74710a0e13b9a10e$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $74710a0e13b9a10e$var$namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
var $74710a0e13b9a10e$var$PREFIXES_FOR_FAMILY = ($74710a0e13b9a10e$var$_PREFIXES_FOR_FAMILY = {}, $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_PREFIXES_FOR_FAMILY, $74710a0e13b9a10e$var$FAMILY_CLASSIC, Object.keys($74710a0e13b9a10e$var$PREFIX_TO_LONG_STYLE[$74710a0e13b9a10e$var$FAMILY_CLASSIC])), $74710a0e13b9a10e$var$_defineProperty($74710a0e13b9a10e$var$_PREFIXES_FOR_FAMILY, $74710a0e13b9a10e$var$FAMILY_SHARP, Object.keys($74710a0e13b9a10e$var$PREFIX_TO_LONG_STYLE[$74710a0e13b9a10e$var$FAMILY_SHARP])), $74710a0e13b9a10e$var$_PREFIXES_FOR_FAMILY);
function $74710a0e13b9a10e$var$getCanonicalIcon(values) {
    var _famProps;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var famProps = (_famProps = {}, $74710a0e13b9a10e$var$_defineProperty(_famProps, $74710a0e13b9a10e$var$FAMILY_CLASSIC, "".concat($74710a0e13b9a10e$var$config.cssPrefix, "-").concat($74710a0e13b9a10e$var$FAMILY_CLASSIC)), $74710a0e13b9a10e$var$_defineProperty(_famProps, $74710a0e13b9a10e$var$FAMILY_SHARP, "".concat($74710a0e13b9a10e$var$config.cssPrefix, "-").concat($74710a0e13b9a10e$var$FAMILY_SHARP)), _famProps);
    var givenPrefix = null;
    var family = $74710a0e13b9a10e$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$74710a0e13b9a10e$var$FAMILY_CLASSIC]) || values.some(function(v) {
        return $74710a0e13b9a10e$var$PREFIXES_FOR_FAMILY[$74710a0e13b9a10e$var$FAMILY_CLASSIC].includes(v);
    })) family = $74710a0e13b9a10e$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$74710a0e13b9a10e$var$FAMILY_SHARP]) || values.some(function(v) {
        return $74710a0e13b9a10e$var$PREFIXES_FOR_FAMILY[$74710a0e13b9a10e$var$FAMILY_SHARP].includes(v);
    })) family = $74710a0e13b9a10e$var$FAMILY_SHARP;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = $74710a0e13b9a10e$var$getIconName($74710a0e13b9a10e$var$config.cssPrefix, cls);
        if ($74710a0e13b9a10e$var$styles[cls]) {
            cls = $74710a0e13b9a10e$var$LONG_STYLE[family].includes(cls) ? $74710a0e13b9a10e$var$LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($74710a0e13b9a10e$var$PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $74710a0e13b9a10e$var$getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $74710a0e13b9a10e$var$config.replacementClass && cls !== famProps[$74710a0e13b9a10e$var$FAMILY_CLASSIC] && cls !== famProps[$74710a0e13b9a10e$var$FAMILY_SHARP]) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === 'fa' ? $74710a0e13b9a10e$var$byOldName(acc.iconName) : {};
            var aliasIconName = $74710a0e13b9a10e$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === 'far' && !$74710a0e13b9a10e$var$styles['far'] && $74710a0e13b9a10e$var$styles['fas'] && !$74710a0e13b9a10e$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = 'fas';
        }
        return acc;
    }, $74710a0e13b9a10e$var$emptyCanonicalIcon());
    if (values.includes('fa-brands') || values.includes('fab')) canonical.prefix = 'fab';
    if (values.includes('fa-duotone') || values.includes('fad')) canonical.prefix = 'fad';
    if (!canonical.prefix && family === $74710a0e13b9a10e$var$FAMILY_SHARP && ($74710a0e13b9a10e$var$styles['fass'] || $74710a0e13b9a10e$var$config.autoFetchSvg)) {
        canonical.prefix = 'fass';
        canonical.iconName = $74710a0e13b9a10e$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $74710a0e13b9a10e$var$getDefaultUsablePrefix() || 'fas';
    return canonical;
}
var $74710a0e13b9a10e$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $74710a0e13b9a10e$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $74710a0e13b9a10e$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $74710a0e13b9a10e$var$defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
                    var longPrefix = $74710a0e13b9a10e$var$PREFIX_TO_LONG_STYLE[$74710a0e13b9a10e$var$FAMILY_CLASSIC][key];
                    if (longPrefix) $74710a0e13b9a10e$var$defineIcons(longPrefix, additions[key]);
                    $74710a0e13b9a10e$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === 'string') additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var $74710a0e13b9a10e$var$_plugins = [];
var $74710a0e13b9a10e$var$_hooks = {};
var $74710a0e13b9a10e$var$providers = {};
var $74710a0e13b9a10e$var$defaultProviderKeys = Object.keys($74710a0e13b9a10e$var$providers);
function $74710a0e13b9a10e$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $74710a0e13b9a10e$var$_plugins = nextPlugins;
    $74710a0e13b9a10e$var$_hooks = {};
    Object.keys($74710a0e13b9a10e$var$providers).forEach(function(k) {
        if ($74710a0e13b9a10e$var$defaultProviderKeys.indexOf(k) === -1) delete $74710a0e13b9a10e$var$providers[k];
    });
    $74710a0e13b9a10e$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if ($74710a0e13b9a10e$var$_typeof(mixout[tk]) === 'object') Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$74710a0e13b9a10e$var$_hooks[hook]) $74710a0e13b9a10e$var$_hooks[hook] = [];
                $74710a0e13b9a10e$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($74710a0e13b9a10e$var$providers);
    });
    return obj;
}
function $74710a0e13b9a10e$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $74710a0e13b9a10e$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $74710a0e13b9a10e$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $74710a0e13b9a10e$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $74710a0e13b9a10e$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $74710a0e13b9a10e$var$providers[hook] ? $74710a0e13b9a10e$var$providers[hook].apply(null, args) : undefined;
}
function $74710a0e13b9a10e$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $74710a0e13b9a10e$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $74710a0e13b9a10e$var$byAlias(prefix, iconName) || iconName;
    return $74710a0e13b9a10e$var$iconFromMapping($74710a0e13b9a10e$var$library.definitions, prefix, iconName) || $74710a0e13b9a10e$var$iconFromMapping($74710a0e13b9a10e$var$namespace.styles, prefix, iconName);
}
var $74710a0e13b9a10e$var$library = new $74710a0e13b9a10e$var$Library();
var $74710a0e13b9a10e$var$noAuto = function noAuto() {
    $74710a0e13b9a10e$var$config.autoReplaceSvg = false;
    $74710a0e13b9a10e$var$config.observeMutations = false;
    $74710a0e13b9a10e$var$callHooks('noAuto');
};
var $74710a0e13b9a10e$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($74710a0e13b9a10e$var$IS_DOM) {
            $74710a0e13b9a10e$var$callHooks('beforeI2svg', params);
            $74710a0e13b9a10e$var$callProvided('pseudoElements2svg', params);
            return $74710a0e13b9a10e$var$callProvided('i2svg', params);
        } else return Promise.reject('Operation requires a DOM of some kind.');
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($74710a0e13b9a10e$var$config.autoReplaceSvg === false) $74710a0e13b9a10e$var$config.autoReplaceSvg = true;
        $74710a0e13b9a10e$var$config.observeMutations = true;
        $74710a0e13b9a10e$var$domready(function() {
            $74710a0e13b9a10e$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $74710a0e13b9a10e$var$callHooks('watch', params);
        });
    }
};
var $74710a0e13b9a10e$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($74710a0e13b9a10e$var$_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $74710a0e13b9a10e$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $74710a0e13b9a10e$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $74710a0e13b9a10e$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === 'string' && (_icon.indexOf("".concat($74710a0e13b9a10e$var$config.cssPrefix, "-")) > -1 || _icon.match($74710a0e13b9a10e$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $74710a0e13b9a10e$var$getCanonicalIcon(_icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $74710a0e13b9a10e$var$getDefaultUsablePrefix(),
                iconName: $74710a0e13b9a10e$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === 'string') {
            var _prefix = $74710a0e13b9a10e$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $74710a0e13b9a10e$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $74710a0e13b9a10e$export$644d8ea042df96a6 = {
    noAuto: $74710a0e13b9a10e$var$noAuto,
    config: $74710a0e13b9a10e$var$config,
    dom: $74710a0e13b9a10e$var$dom,
    parse: $74710a0e13b9a10e$var$parse,
    library: $74710a0e13b9a10e$var$library,
    findIconDefinition: $74710a0e13b9a10e$var$findIconDefinition,
    toHtml: $74710a0e13b9a10e$var$toHtml
};
var $74710a0e13b9a10e$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $74710a0e13b9a10e$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($74710a0e13b9a10e$var$namespace.styles).length > 0 || $74710a0e13b9a10e$var$config.autoFetchSvg) && $74710a0e13b9a10e$var$IS_DOM && $74710a0e13b9a10e$var$config.autoReplaceSvg) $74710a0e13b9a10e$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $74710a0e13b9a10e$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function get() {
            return val.abstract.map(function(a) {
                return $74710a0e13b9a10e$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, 'node', {
        get: function get() {
            if (!$74710a0e13b9a10e$var$IS_DOM) return;
            var container = $74710a0e13b9a10e$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $74710a0e13b9a10e$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($74710a0e13b9a10e$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $74710a0e13b9a10e$var$joinStyles($74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $74710a0e13b9a10e$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($74710a0e13b9a10e$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $74710a0e13b9a10e$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === 'fak';
    var attrClass = [
        $74710a0e13b9a10e$var$config.replacementClass,
        iconName ? "".concat($74710a0e13b9a10e$var$config.cssPrefix, "-").concat(iconName) : ''
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== '' || !!c;
    }).concat(extra.classes).join(' ');
    var content = {
        children: [],
        attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$74710a0e13b9a10e$var$DATA_FA_I2SVG] = '';
    if (title) {
        content.children.push({
            tag: 'title',
            attributes: {
                id: content.attributes['aria-labelledby'] || "title-".concat(titleId || $74710a0e13b9a10e$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? $74710a0e13b9a10e$var$callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : $74710a0e13b9a10e$var$callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $74710a0e13b9a10e$var$asSymbol(args);
    else return $74710a0e13b9a10e$var$asIcon(args);
}
function $74710a0e13b9a10e$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    if (watchable) attributes[$74710a0e13b9a10e$var$DATA_FA_I2SVG] = '';
    var styles = $74710a0e13b9a10e$var$_objectSpread2({}, extra.styles);
    if ($74710a0e13b9a10e$var$transformIsMeaningful(transform)) {
        styles['transform'] = $74710a0e13b9a10e$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    var styleString = $74710a0e13b9a10e$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
function $74710a0e13b9a10e$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    var styleString = $74710a0e13b9a10e$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
var $74710a0e13b9a10e$var$styles$1 = $74710a0e13b9a10e$var$namespace.styles;
function $74710a0e13b9a10e$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $74710a0e13b9a10e$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat($74710a0e13b9a10e$var$config.cssPrefix, "-").concat($74710a0e13b9a10e$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat($74710a0e13b9a10e$var$config.cssPrefix, "-").concat($74710a0e13b9a10e$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat($74710a0e13b9a10e$var$config.cssPrefix, "-").concat($74710a0e13b9a10e$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $74710a0e13b9a10e$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $74710a0e13b9a10e$var$maybeNotifyMissing(iconName, prefix) {
    if (!$74710a0e13b9a10e$var$PRODUCTION && !$74710a0e13b9a10e$var$config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function $74710a0e13b9a10e$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === 'fa' && $74710a0e13b9a10e$var$config.styleDefault !== null) prefix = $74710a0e13b9a10e$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $74710a0e13b9a10e$var$callProvided('missingIconAbstract') || {}
        };
        if (givenPrefix === 'fa') {
            var shim = $74710a0e13b9a10e$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $74710a0e13b9a10e$var$styles$1[prefix] && $74710a0e13b9a10e$var$styles$1[prefix][iconName]) {
            var icon = $74710a0e13b9a10e$var$styles$1[prefix][iconName];
            return resolve($74710a0e13b9a10e$var$asFoundIcon(icon));
        }
        $74710a0e13b9a10e$var$maybeNotifyMissing(iconName, prefix);
        resolve($74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, $74710a0e13b9a10e$var$missingIconResolutionMixin), {}, {
            icon: $74710a0e13b9a10e$var$config.showMissingIcons && iconName ? $74710a0e13b9a10e$var$callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
var $74710a0e13b9a10e$var$noop$1 = function noop() {};
var $74710a0e13b9a10e$var$p = $74710a0e13b9a10e$var$config.measurePerformance && $74710a0e13b9a10e$var$PERFORMANCE && $74710a0e13b9a10e$var$PERFORMANCE.mark && $74710a0e13b9a10e$var$PERFORMANCE.measure ? $74710a0e13b9a10e$var$PERFORMANCE : {
    mark: $74710a0e13b9a10e$var$noop$1,
    measure: $74710a0e13b9a10e$var$noop$1
};
var $74710a0e13b9a10e$var$preamble = "FA \"6.2.1\"";
var $74710a0e13b9a10e$var$begin = function begin(name) {
    $74710a0e13b9a10e$var$p.mark("".concat($74710a0e13b9a10e$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $74710a0e13b9a10e$var$end(name);
    };
};
var $74710a0e13b9a10e$var$end = function end(name) {
    $74710a0e13b9a10e$var$p.mark("".concat($74710a0e13b9a10e$var$preamble, " ").concat(name, " ends"));
    $74710a0e13b9a10e$var$p.measure("".concat($74710a0e13b9a10e$var$preamble, " ").concat(name), "".concat($74710a0e13b9a10e$var$preamble, " ").concat(name, " begins"), "".concat($74710a0e13b9a10e$var$preamble, " ").concat(name, " ends"));
};
var $74710a0e13b9a10e$var$perf = {
    begin: $74710a0e13b9a10e$var$begin,
    end: $74710a0e13b9a10e$var$end
};
var $74710a0e13b9a10e$var$noop$2 = function noop() {};
function $74710a0e13b9a10e$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($74710a0e13b9a10e$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $74710a0e13b9a10e$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($74710a0e13b9a10e$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($74710a0e13b9a10e$var$DATA_ICON) : null;
    return prefix && icon;
}
function $74710a0e13b9a10e$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($74710a0e13b9a10e$var$config.replacementClass);
}
function $74710a0e13b9a10e$var$getMutator() {
    if ($74710a0e13b9a10e$var$config.autoReplaceSvg === true) return $74710a0e13b9a10e$var$mutators.replace;
    var mutator = $74710a0e13b9a10e$var$mutators[$74710a0e13b9a10e$var$config.autoReplaceSvg];
    return mutator || $74710a0e13b9a10e$var$mutators.replace;
}
function $74710a0e13b9a10e$var$createElementNS(tag) {
    return $74710a0e13b9a10e$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function $74710a0e13b9a10e$var$createElement(tag) {
    return $74710a0e13b9a10e$var$DOCUMENT.createElement(tag);
}
function $74710a0e13b9a10e$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? $74710a0e13b9a10e$var$createElementNS : $74710a0e13b9a10e$var$createElement : _params$ceFn;
    if (typeof abstractObj === 'string') return $74710a0e13b9a10e$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($74710a0e13b9a10e$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $74710a0e13b9a10e$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $74710a0e13b9a10e$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(abstract) {
                node.parentNode.insertBefore($74710a0e13b9a10e$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($74710a0e13b9a10e$var$DATA_FA_I2SVG) === null && $74710a0e13b9a10e$var$config.keepOriginalSource) {
                var comment = $74710a0e13b9a10e$var$DOCUMENT.createComment($74710a0e13b9a10e$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$74710a0e13b9a10e$var$classArray(node).indexOf($74710a0e13b9a10e$var$config.replacementClass)) return $74710a0e13b9a10e$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($74710a0e13b9a10e$var$config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            var splitClasses = abstract[0].attributes.class.split(' ').reduce(function(acc, cls) {
                if (cls === $74710a0e13b9a10e$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        var newInnerHTML = abstract.map(function(a) {
            return $74710a0e13b9a10e$var$toHtml(a);
        }).join('\n');
        node.setAttribute($74710a0e13b9a10e$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $74710a0e13b9a10e$var$performOperationSync(op) {
    op();
}
function $74710a0e13b9a10e$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === 'function' ? callback : $74710a0e13b9a10e$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $74710a0e13b9a10e$var$performOperationSync;
        if ($74710a0e13b9a10e$var$config.mutateApproach === $74710a0e13b9a10e$var$MUTATION_APPROACH_ASYNC) frame = $74710a0e13b9a10e$var$WINDOW.requestAnimationFrame || $74710a0e13b9a10e$var$performOperationSync;
        frame(function() {
            var mutator = $74710a0e13b9a10e$var$getMutator();
            var mark = $74710a0e13b9a10e$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $74710a0e13b9a10e$var$disabled = false;
function $74710a0e13b9a10e$var$disableObservation() {
    $74710a0e13b9a10e$var$disabled = true;
}
function $74710a0e13b9a10e$var$enableObservation() {
    $74710a0e13b9a10e$var$disabled = false;
}
var $74710a0e13b9a10e$var$mo = null;
function $74710a0e13b9a10e$var$observe(options) {
    if (!$74710a0e13b9a10e$var$MUTATION_OBSERVER) return;
    if (!$74710a0e13b9a10e$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $74710a0e13b9a10e$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $74710a0e13b9a10e$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $74710a0e13b9a10e$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $74710a0e13b9a10e$var$DOCUMENT : _options$observeMutat;
    $74710a0e13b9a10e$var$mo = new $74710a0e13b9a10e$var$MUTATION_OBSERVER(function(objects) {
        if ($74710a0e13b9a10e$var$disabled) return;
        var defaultPrefix = $74710a0e13b9a10e$var$getDefaultUsablePrefix();
        $74710a0e13b9a10e$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$74710a0e13b9a10e$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($74710a0e13b9a10e$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $74710a0e13b9a10e$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === 'attributes' && $74710a0e13b9a10e$var$isWatched(mutationRecord.target) && ~$74710a0e13b9a10e$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && $74710a0e13b9a10e$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $74710a0e13b9a10e$var$getCanonicalIcon($74710a0e13b9a10e$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($74710a0e13b9a10e$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($74710a0e13b9a10e$var$DATA_ICON, iconName);
                } else if ($74710a0e13b9a10e$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$74710a0e13b9a10e$var$IS_DOM) return;
    $74710a0e13b9a10e$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $74710a0e13b9a10e$var$disconnect() {
    if (!$74710a0e13b9a10e$var$mo) return;
    $74710a0e13b9a10e$var$mo.disconnect();
}
function $74710a0e13b9a10e$var$styleParser(node) {
    var style = node.getAttribute('style');
    var val = [];
    if (style) val = style.split(';').reduce(function(acc, style) {
        var styles = style.split(':');
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $74710a0e13b9a10e$var$classParser(node) {
    var existingPrefix = node.getAttribute('data-prefix');
    var existingIconName = node.getAttribute('data-icon');
    var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    var val = $74710a0e13b9a10e$var$getCanonicalIcon($74710a0e13b9a10e$var$classArray(node));
    if (!val.prefix) val.prefix = $74710a0e13b9a10e$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $74710a0e13b9a10e$var$byLigature(val.prefix, node.innerText) || $74710a0e13b9a10e$var$byUnicode(val.prefix, $74710a0e13b9a10e$var$toHex(node.innerText));
    if (!val.iconName && $74710a0e13b9a10e$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $74710a0e13b9a10e$var$attributesParser(node) {
    var extraAttributes = $74710a0e13b9a10e$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute('title');
    var titleId = node.getAttribute('data-fa-title-id');
    if ($74710a0e13b9a10e$var$config.autoA11y) {
        if (title) extraAttributes['aria-labelledby'] = "".concat($74710a0e13b9a10e$var$config.replacementClass, "-title-").concat(titleId || $74710a0e13b9a10e$var$nextUniqueId());
        else {
            extraAttributes['aria-hidden'] = 'true';
            extraAttributes['focusable'] = 'false';
        }
    }
    return extraAttributes;
}
function $74710a0e13b9a10e$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $74710a0e13b9a10e$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $74710a0e13b9a10e$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $74710a0e13b9a10e$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $74710a0e13b9a10e$var$attributesParser(node);
    var pluginMeta = $74710a0e13b9a10e$var$chainHooks('parseNodeAttributes', {}, node);
    var extraStyles = parser.styleParser ? $74710a0e13b9a10e$var$styleParser(node) : [];
    return $74710a0e13b9a10e$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute('title'),
        titleId: node.getAttribute('data-fa-title-id'),
        prefix: prefix,
        transform: $74710a0e13b9a10e$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $74710a0e13b9a10e$var$styles$2 = $74710a0e13b9a10e$var$namespace.styles;
function $74710a0e13b9a10e$var$generateMutation(node) {
    var nodeMeta = $74710a0e13b9a10e$var$config.autoReplaceSvg === 'nest' ? $74710a0e13b9a10e$var$parseMeta(node, {
        styleParser: false
    }) : $74710a0e13b9a10e$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($74710a0e13b9a10e$var$LAYERS_TEXT_CLASSNAME)) return $74710a0e13b9a10e$var$callProvided('generateLayersText', node, nodeMeta);
    else return $74710a0e13b9a10e$var$callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
var $74710a0e13b9a10e$var$knownPrefixes = new Set();
$74710a0e13b9a10e$var$FAMILIES.map(function(family) {
    $74710a0e13b9a10e$var$knownPrefixes.add("fa-".concat(family));
});
Object.keys($74710a0e13b9a10e$var$PREFIX_TO_STYLE[$74710a0e13b9a10e$var$FAMILY_CLASSIC]).map($74710a0e13b9a10e$var$knownPrefixes.add.bind($74710a0e13b9a10e$var$knownPrefixes));
Object.keys($74710a0e13b9a10e$var$PREFIX_TO_STYLE[$74710a0e13b9a10e$var$FAMILY_SHARP]).map($74710a0e13b9a10e$var$knownPrefixes.add.bind($74710a0e13b9a10e$var$knownPrefixes));
$74710a0e13b9a10e$var$knownPrefixes = $74710a0e13b9a10e$var$_toConsumableArray($74710a0e13b9a10e$var$knownPrefixes);
function $74710a0e13b9a10e$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$74710a0e13b9a10e$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $74710a0e13b9a10e$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($74710a0e13b9a10e$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($74710a0e13b9a10e$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $74710a0e13b9a10e$var$config.autoFetchSvg ? $74710a0e13b9a10e$var$knownPrefixes : $74710a0e13b9a10e$var$FAMILIES.map(function(f) {
        return "fa-".concat(f);
    }).concat(Object.keys($74710a0e13b9a10e$var$styles$2));
    if (!prefixes.includes('fa')) prefixes.push('fa');
    var prefixesDomQuery = [
        ".".concat($74710a0e13b9a10e$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($74710a0e13b9a10e$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($74710a0e13b9a10e$var$DATA_FA_I2SVG, "])");
    })).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $74710a0e13b9a10e$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    var mark = $74710a0e13b9a10e$var$perf.begin('onTree');
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $74710a0e13b9a10e$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$74710a0e13b9a10e$var$PRODUCTION) {
                if (e.name === 'MissingIcon') console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $74710a0e13b9a10e$var$perform(resolvedMutations, function() {
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function $74710a0e13b9a10e$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $74710a0e13b9a10e$var$generateMutation(node).then(function(mutation) {
        if (mutation) $74710a0e13b9a10e$var$perform([
            mutation
        ], callback);
    });
}
function $74710a0e13b9a10e$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $74710a0e13b9a10e$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $74710a0e13b9a10e$var$findIconDefinition(mask || {});
        return next(iconDefinition, $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $74710a0e13b9a10e$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $74710a0e13b9a10e$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $74710a0e13b9a10e$var$domVariants($74710a0e13b9a10e$var$_objectSpread2({
        type: 'icon'
    }, iconDefinition), function() {
        $74710a0e13b9a10e$var$callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($74710a0e13b9a10e$var$config.autoA11y) {
            if (title) attributes['aria-labelledby'] = "".concat($74710a0e13b9a10e$var$config.replacementClass, "-title-").concat(titleId || $74710a0e13b9a10e$var$nextUniqueId());
            else {
                attributes['aria-hidden'] = 'true';
                attributes['focusable'] = 'false';
            }
        }
        return $74710a0e13b9a10e$var$makeInlineSvgAbstract({
            icons: {
                main: $74710a0e13b9a10e$var$asFoundIcon(icon),
                mask: mask ? $74710a0e13b9a10e$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, $74710a0e13b9a10e$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $74710a0e13b9a10e$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $74710a0e13b9a10e$var$resolveIcons($74710a0e13b9a10e$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $74710a0e13b9a10e$var$onTree;
                accumulator.nodeCallback = $74710a0e13b9a10e$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $74710a0e13b9a10e$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            return $74710a0e13b9a10e$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $74710a0e13b9a10e$var$findIcon(iconName, prefix),
                    mask.iconName ? $74710a0e13b9a10e$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $74710a0e13b9a10e$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $74710a0e13b9a10e$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $74710a0e13b9a10e$var$joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            var nextChild;
            if ($74710a0e13b9a10e$var$transformIsMeaningful(transform)) nextChild = $74710a0e13b9a10e$var$callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $74710a0e13b9a10e$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $74710a0e13b9a10e$var$domVariants({
                    type: 'layer'
                }, function() {
                    $74710a0e13b9a10e$var$callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat($74710a0e13b9a10e$var$config.cssPrefix, "-layers")
                                ].concat($74710a0e13b9a10e$var$_toConsumableArray(classes)).join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $74710a0e13b9a10e$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $74710a0e13b9a10e$var$domVariants({
                    type: 'counter',
                    content: content
                }, function() {
                    $74710a0e13b9a10e$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $74710a0e13b9a10e$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($74710a0e13b9a10e$var$config.cssPrefix, "-layers-counter")
                            ].concat($74710a0e13b9a10e$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $74710a0e13b9a10e$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $74710a0e13b9a10e$var$meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $74710a0e13b9a10e$var$domVariants({
                    type: 'text',
                    content: content
                }, function() {
                    $74710a0e13b9a10e$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $74710a0e13b9a10e$var$makeLayersTextAbstract({
                        content: content,
                        transform: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, $74710a0e13b9a10e$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($74710a0e13b9a10e$var$config.cssPrefix, "-layers-text")
                            ].concat($74710a0e13b9a10e$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($74710a0e13b9a10e$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($74710a0e13b9a10e$var$config.autoA11y && !title) extra.attributes['aria-hidden'] = 'true';
            return Promise.resolve([
                node,
                $74710a0e13b9a10e$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $74710a0e13b9a10e$var$CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var $74710a0e13b9a10e$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function $74710a0e13b9a10e$var$hexValueFromContent(content) {
    var cleaned = content.replace($74710a0e13b9a10e$var$CLEAN_CONTENT_PATTERN, '');
    var codePoint = $74710a0e13b9a10e$var$codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= $74710a0e13b9a10e$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $74710a0e13b9a10e$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $74710a0e13b9a10e$var$toHex(cleaned[0]) : $74710a0e13b9a10e$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $74710a0e13b9a10e$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($74710a0e13b9a10e$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $74710a0e13b9a10e$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($74710a0e13b9a10e$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $74710a0e13b9a10e$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue('font-family').match($74710a0e13b9a10e$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue('font-weight');
        var content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== 'none' && content !== '') {
            var _content = styles.getPropertyValue('content');
            var family = ~[
                'Sharp'
            ].indexOf(fontFamily[2]) ? $74710a0e13b9a10e$var$FAMILY_SHARP : $74710a0e13b9a10e$var$FAMILY_CLASSIC;
            var prefix = ~[
                'Solid',
                'Regular',
                'Light',
                'Thin',
                'Duotone',
                'Brands',
                'Kit'
            ].indexOf(fontFamily[2]) ? $74710a0e13b9a10e$var$STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : $74710a0e13b9a10e$var$FONT_WEIGHT_TO_PREFIX[family][fontWeight];
            var _hexValueFromContent = $74710a0e13b9a10e$var$hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith('FontAwesome');
            var iconName = $74710a0e13b9a10e$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $74710a0e13b9a10e$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($74710a0e13b9a10e$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($74710a0e13b9a10e$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $74710a0e13b9a10e$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$74710a0e13b9a10e$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $74710a0e13b9a10e$var$findIcon(iconName, prefix).then(function(main) {
                    var abstract = $74710a0e13b9a10e$var$makeInlineSvgAbstract($74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $74710a0e13b9a10e$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $74710a0e13b9a10e$var$DOCUMENT.createElement('svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map(function(a) {
                        return $74710a0e13b9a10e$var$toHtml(a);
                    }).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $74710a0e13b9a10e$var$replace(node) {
    return Promise.all([
        $74710a0e13b9a10e$var$replaceForPosition(node, '::before'),
        $74710a0e13b9a10e$var$replaceForPosition(node, '::after')
    ]);
}
function $74710a0e13b9a10e$var$processable(node) {
    return node.parentNode !== document.head && !~$74710a0e13b9a10e$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($74710a0e13b9a10e$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
function $74710a0e13b9a10e$var$searchPseudoElements(root) {
    if (!$74710a0e13b9a10e$var$IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = $74710a0e13b9a10e$var$toArray(root.querySelectorAll('*')).filter($74710a0e13b9a10e$var$processable).map($74710a0e13b9a10e$var$replace);
        var end = $74710a0e13b9a10e$var$perf.begin('searchPseudoElements');
        $74710a0e13b9a10e$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $74710a0e13b9a10e$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $74710a0e13b9a10e$var$enableObservation();
            reject();
        });
    });
}
var $74710a0e13b9a10e$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $74710a0e13b9a10e$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $74710a0e13b9a10e$var$DOCUMENT : _params$node;
            if ($74710a0e13b9a10e$var$config.searchPseudoElements) $74710a0e13b9a10e$var$searchPseudoElements(node);
        };
    }
};
var $74710a0e13b9a10e$var$_unwatched = false;
var $74710a0e13b9a10e$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $74710a0e13b9a10e$var$disableObservation();
                    $74710a0e13b9a10e$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $74710a0e13b9a10e$var$observe($74710a0e13b9a10e$var$chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto: function noAuto() {
                $74710a0e13b9a10e$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($74710a0e13b9a10e$var$_unwatched) $74710a0e13b9a10e$var$enableObservation();
                else $74710a0e13b9a10e$var$observe($74710a0e13b9a10e$var$chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $74710a0e13b9a10e$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce(function(acc, n) {
        var parts = n.toLowerCase().split('-');
        var first = parts[0];
        var rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $74710a0e13b9a10e$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $74710a0e13b9a10e$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = $74710a0e13b9a10e$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: $74710a0e13b9a10e$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: $74710a0e13b9a10e$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $74710a0e13b9a10e$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $74710a0e13b9a10e$var$fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = 'black';
    return abstract;
}
function $74710a0e13b9a10e$var$deGroup(abstract) {
    if (abstract.tag === 'g') return abstract.children;
    else return [
        abstract
    ];
}
var $74710a0e13b9a10e$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute('data-fa-mask');
                var mask = !maskData ? $74710a0e13b9a10e$var$emptyCanonicalIcon() : $74710a0e13b9a10e$var$getCanonicalIcon(maskData.split(' ').map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $74710a0e13b9a10e$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $74710a0e13b9a10e$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: 'rect',
                attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, $74710a0e13b9a10e$var$ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($74710a0e13b9a10e$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: 'g',
                attributes: $74710a0e13b9a10e$var$_objectSpread2({}, trans.inner),
                children: [
                    $74710a0e13b9a10e$var$fillBlack($74710a0e13b9a10e$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: 'g',
                attributes: $74710a0e13b9a10e$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $74710a0e13b9a10e$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $74710a0e13b9a10e$var$nextUniqueId());
            var maskTag = {
                tag: 'mask',
                attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, $74710a0e13b9a10e$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: $74710a0e13b9a10e$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: $74710a0e13b9a10e$var$_objectSpread2({
                    fill: 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $74710a0e13b9a10e$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $74710a0e13b9a10e$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($74710a0e13b9a10e$var$WINDOW.matchMedia) reduceMotion = $74710a0e13b9a10e$var$WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: 'currentColor'
            };
            var ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            }; // Ring
            gChildren.push({
                tag: 'path',
                attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            var OPACITY_ANIMATE = $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            var dot = {
                tag: 'circle',
                attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: $74710a0e13b9a10e$var$_objectSpread2($74710a0e13b9a10e$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    'class': 'missing'
                },
                children: gChildren
            };
        };
    }
};
var $74710a0e13b9a10e$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute('data-fa-symbol');
                var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var $74710a0e13b9a10e$var$plugins = [
    $74710a0e13b9a10e$var$InjectCSS,
    $74710a0e13b9a10e$var$ReplaceElements,
    $74710a0e13b9a10e$var$Layers,
    $74710a0e13b9a10e$var$LayersCounter,
    $74710a0e13b9a10e$var$LayersText,
    $74710a0e13b9a10e$var$PseudoElements,
    $74710a0e13b9a10e$var$MutationObserver$1,
    $74710a0e13b9a10e$var$PowerTransforms,
    $74710a0e13b9a10e$var$Masks,
    $74710a0e13b9a10e$var$MissingIconIndicator,
    $74710a0e13b9a10e$var$SvgSymbols
];
$74710a0e13b9a10e$var$registerPlugins($74710a0e13b9a10e$var$plugins, {
    mixoutsTo: $74710a0e13b9a10e$export$644d8ea042df96a6
});
var $74710a0e13b9a10e$export$4f8e844b2782642c = $74710a0e13b9a10e$export$644d8ea042df96a6.noAuto;
var $74710a0e13b9a10e$export$e506a1d27d1eaa20 = $74710a0e13b9a10e$export$644d8ea042df96a6.config;
var $74710a0e13b9a10e$export$b839f963c7dc0e34 = $74710a0e13b9a10e$export$644d8ea042df96a6.library;
var $74710a0e13b9a10e$export$df3a06d6289f983e = $74710a0e13b9a10e$export$644d8ea042df96a6.dom;
var $74710a0e13b9a10e$export$98e6a39c04603d36 = $74710a0e13b9a10e$export$644d8ea042df96a6.parse;
var $74710a0e13b9a10e$export$221fed4a47f597a5 = $74710a0e13b9a10e$export$644d8ea042df96a6.findIconDefinition;
var $74710a0e13b9a10e$export$a10125c086a4df16 = $74710a0e13b9a10e$export$644d8ea042df96a6.toHtml;
var $74710a0e13b9a10e$export$1ca1ec8b29a4ce27 = $74710a0e13b9a10e$export$644d8ea042df96a6.icon;
var $74710a0e13b9a10e$export$50a222d9023da98b = $74710a0e13b9a10e$export$644d8ea042df96a6.layer;
var $74710a0e13b9a10e$export$6f093cfa640b7166 = $74710a0e13b9a10e$export$644d8ea042df96a6.text;
var $74710a0e13b9a10e$export$e575061ef2a070eb = $74710a0e13b9a10e$export$644d8ea042df96a6.counter;


var $f9a2809864d1be66$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f9a2809864d1be66$var$ReactIs, $f9a2809864d1be66$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$f9a2809864d1be66$exports = (parcelRequire("6Qyup"))();



var $ltGt3 = parcelRequire("ltGt3");
function $2b2181a84a15541d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2b2181a84a15541d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2b2181a84a15541d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2b2181a84a15541d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2b2181a84a15541d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2b2181a84a15541d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2b2181a84a15541d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2b2181a84a15541d$var$_typeof(obj);
}
function $2b2181a84a15541d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2b2181a84a15541d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2b2181a84a15541d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2b2181a84a15541d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2b2181a84a15541d$var$_toConsumableArray(arr) {
    return $2b2181a84a15541d$var$_arrayWithoutHoles(arr) || $2b2181a84a15541d$var$_iterableToArray(arr) || $2b2181a84a15541d$var$_unsupportedIterableToArray(arr) || $2b2181a84a15541d$var$_nonIterableSpread();
}
function $2b2181a84a15541d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2b2181a84a15541d$var$_arrayLikeToArray(arr);
}
function $2b2181a84a15541d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $2b2181a84a15541d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2b2181a84a15541d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2b2181a84a15541d$var$_arrayLikeToArray(o, minLen);
}
function $2b2181a84a15541d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2b2181a84a15541d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function $2b2181a84a15541d$var$classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        'fa-beat': beat,
        'fa-fade': fade,
        'fa-beat-fade': beatFade,
        'fa-bounce': bounce,
        'fa-shake': shake,
        'fa-flash': flash,
        'fa-spin': spin,
        'fa-spin-reverse': spinReverse,
        'fa-spin-pulse': spinPulse,
        'fa-pulse': pulse,
        'fa-fw': fixedWidth,
        'fa-inverse': inverse,
        'fa-border': border,
        'fa-li': listItem,
        'fa-flip': flip === true,
        'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
        'fa-flip-vertical': flip === 'vertical' || flip === 'both'
    }, $2b2181a84a15541d$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), $2b2181a84a15541d$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), $2b2181a84a15541d$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), $2b2181a84a15541d$var$_defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $2b2181a84a15541d$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $2b2181a84a15541d$var$camelize(string) {
    if ($2b2181a84a15541d$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : '';
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $2b2181a84a15541d$var$_excluded = [
    "style"
];
function $2b2181a84a15541d$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $2b2181a84a15541d$var$styleToObject(style) {
    return style.split(';').map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(':');
        var prop = $2b2181a84a15541d$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith('webkit') ? acc[$2b2181a84a15541d$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $2b2181a84a15541d$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === 'string') return element;
    var children = (element.children || []).map(function(child) {
        return $2b2181a84a15541d$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case 'class':
                acc.attrs['className'] = val;
                delete element.attributes['class'];
                break;
            case 'style':
                acc.attrs['style'] = $2b2181a84a15541d$var$styleToObject(val);
                break;
            default:
                if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$2b2181a84a15541d$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $2b2181a84a15541d$var$_objectWithoutProperties(extraProps, $2b2181a84a15541d$var$_excluded);
    mixins.attrs['style'] = $2b2181a84a15541d$var$_objectSpread2($2b2181a84a15541d$var$_objectSpread2({}, mixins.attrs['style']), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $2b2181a84a15541d$var$_objectSpread2($2b2181a84a15541d$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($2b2181a84a15541d$var$_toConsumableArray(children)));
}
var $2b2181a84a15541d$var$PRODUCTION = false;
try {
    $2b2181a84a15541d$var$PRODUCTION = true;
} catch (e) {}
function $2b2181a84a15541d$var$log() {
    if (!$2b2181a84a15541d$var$PRODUCTION && console && typeof console.error === 'function') {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $2b2181a84a15541d$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $2b2181a84a15541d$var$_typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $74710a0e13b9a10e$export$98e6a39c04603d36).icon) return (0, $74710a0e13b9a10e$export$98e6a39c04603d36).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $2b2181a84a15541d$var$_typeof(icon) === 'object' && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === 'string') return {
        prefix: 'fas',
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $2b2181a84a15541d$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $2b2181a84a15541d$var$_defineProperty({}, key, value) : {};
}
var $2b2181a84a15541d$export$2b9260d4a45c8710 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef(function(props, ref) {
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = $2b2181a84a15541d$var$normalizeIconArgs(iconArgs);
    var classes = $2b2181a84a15541d$var$objectWithKey('classes', [].concat($2b2181a84a15541d$var$_toConsumableArray($2b2181a84a15541d$var$classList(props)), $2b2181a84a15541d$var$_toConsumableArray(className.split(' '))));
    var transform = $2b2181a84a15541d$var$objectWithKey('transform', typeof props.transform === 'string' ? (0, $74710a0e13b9a10e$export$98e6a39c04603d36).transform(props.transform) : props.transform);
    var mask = $2b2181a84a15541d$var$objectWithKey('mask', $2b2181a84a15541d$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $74710a0e13b9a10e$export$1ca1ec8b29a4ce27)(iconLookup, $2b2181a84a15541d$var$_objectSpread2($2b2181a84a15541d$var$_objectSpread2($2b2181a84a15541d$var$_objectSpread2($2b2181a84a15541d$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $2b2181a84a15541d$var$log('Could not find icon', iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: ref
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$2b2181a84a15541d$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $2b2181a84a15541d$var$convertCurry(abstract[0], extraProps);
});
$2b2181a84a15541d$export$2b9260d4a45c8710.displayName = 'FontAwesomeIcon';
$2b2181a84a15541d$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).string,
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).oneOf([
        true,
        false,
        'horizontal',
        'vertical',
        'both'
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).oneOf([
        'right',
        'left'
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).oneOf([
        '2xs',
        'xs',
        'sm',
        'lg',
        'xl',
        '2xl',
        '1x',
        '2x',
        '3x',
        '4x',
        '5x',
        '6x',
        '7x',
        '8x',
        '9x',
        '10x'
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($f9a2809864d1be66$exports))).bool
};
$2b2181a84a15541d$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: '',
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: '',
    titleId: null,
    transform: null,
    swapOpacity: false
};
var $2b2181a84a15541d$var$convertCurry = $2b2181a84a15541d$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement);


var $1113a0aa61ab7765$export$82e9f45cca5ba907 = "fas";
var $1113a0aa61ab7765$export$f22454595d96c106 = {
    prefix: 'fas',
    iconName: '0',
    icon: [
        320,
        512,
        [],
        "30",
        "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 96c-53 0-96 43-96 96V320c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96z"
    ]
};
var $1113a0aa61ab7765$export$8398cb2addc9e182 = {
    prefix: 'fas',
    iconName: '1',
    icon: [
        256,
        512,
        [],
        "31",
        "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z"
    ]
};
var $1113a0aa61ab7765$export$ed1a0ff7bd680a1d = {
    prefix: 'fas',
    iconName: '2',
    icon: [
        320,
        512,
        [],
        "32",
        "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z"
    ]
};
var $1113a0aa61ab7765$export$74b7ff79ce1818d6 = {
    prefix: 'fas',
    iconName: '3',
    icon: [
        448,
        512,
        [],
        "33",
        "M64 64c0-17.7 14.3-32 32-32H336c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L226.3 208H248c75.1 0 136 60.9 136 136s-60.9 136-136 136H169.4c-42.4 0-81.2-24-100.2-61.9l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H248c39.8 0 72-32.2 72-72s-32.2-72-72-72H144c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L253.7 96H96C78.3 96 64 81.7 64 64z"
    ]
};
var $1113a0aa61ab7765$export$969b2215780d58fd = {
    prefix: 'fas',
    iconName: '4',
    icon: [
        384,
        512,
        [],
        "34",
        "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368H256v80c0 17.7 14.3 32 32 32s32-14.3 32-32V368h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V304H82.4L189 77.6z"
    ]
};
var $1113a0aa61ab7765$export$3919f68a5b3825a9 = {
    prefix: 'fas',
    iconName: '5',
    icon: [
        320,
        512,
        [],
        "35",
        "M32.5 58.3C35.3 43.1 48.5 32 64 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H100.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"
    ]
};
var $1113a0aa61ab7765$export$580ac17b31ffb5c3 = {
    prefix: 'fas',
    iconName: '6',
    icon: [
        320,
        512,
        [],
        "36",
        "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3c0 .2 0 .3 0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM64 320c0-53 43-96 96-96s96 43 96 96s-43 96-96 96s-96-43-96-96z"
    ]
};
var $1113a0aa61ab7765$export$ee79cab31be16d23 = {
    prefix: 'fas',
    iconName: '7',
    icon: [
        320,
        512,
        [],
        "37",
        "M0 64C0 46.3 14.3 32 32 32H288c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $1113a0aa61ab7765$export$45d84c4b2c560d2f = {
    prefix: 'fas',
    iconName: '8',
    icon: [
        320,
        512,
        [],
        "38",
        "M304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h15.9c0 0 .1 0 .1 0h32c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0H144c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"
    ]
};
var $1113a0aa61ab7765$export$a120f1e4223629f2 = {
    prefix: 'fas',
    iconName: '9',
    icon: [
        320,
        512,
        [],
        "39",
        "M64 192c0 53 43 96 96 96s96-43 96-96s-43-96-96-96s-96 43-96 96zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"
    ]
};
var $1113a0aa61ab7765$export$38320138fc0262d0 = {
    prefix: 'fas',
    iconName: 'fill-drip',
    icon: [
        576,
        512,
        [],
        "f576",
        "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6H386.7l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"
    ]
};
var $1113a0aa61ab7765$export$917a3d30f6cd766 = {
    prefix: 'fas',
    iconName: 'arrows-to-circle',
    icon: [
        640,
        512,
        [],
        "e4bd",
        "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM384 256c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"
    ]
};
var $1113a0aa61ab7765$export$a39bab13d51abfd0 = {
    prefix: 'fas',
    iconName: 'circle-chevron-right',
    icon: [
        512,
        512,
        [
            "chevron-circle-right"
        ],
        "f138",
        "M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"
    ]
};
var $1113a0aa61ab7765$export$2a5db4f6eba6f2b = $1113a0aa61ab7765$export$a39bab13d51abfd0;
var $1113a0aa61ab7765$export$c115e8063ee02632 = {
    prefix: 'fas',
    iconName: 'at',
    icon: [
        512,
        512,
        [
            61946
        ],
        "40",
        "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $1113a0aa61ab7765$export$864bb8d6c21fb792 = {
    prefix: 'fas',
    iconName: 'trash-can',
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
};
var $1113a0aa61ab7765$export$88df7ff7eb32f9dc = $1113a0aa61ab7765$export$864bb8d6c21fb792;
var $1113a0aa61ab7765$export$3313bce3924ea7da = {
    prefix: 'fas',
    iconName: 'text-height',
    icon: [
        576,
        512,
        [],
        "f034",
        "M32 32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64l0 320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H192l0-320h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H160 32zm470.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var $1113a0aa61ab7765$export$e585697127cda27 = {
    prefix: 'fas',
    iconName: 'user-xmark',
    icon: [
        640,
        512,
        [
            "user-times"
        ],
        "f235",
        "M352 128c0 70.7-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $1113a0aa61ab7765$export$45b996d071667753 = $1113a0aa61ab7765$export$e585697127cda27;
var $1113a0aa61ab7765$export$acb2d72d28cd92d9 = {
    prefix: 'fas',
    iconName: 'stethoscope',
    icon: [
        576,
        512,
        [
            129658
        ],
        "f0f1",
        "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1V192c0 53 43 96 96 96s96-43 96-96V71.1l-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7C334.4 19.1 352 43.5 352 71.1V192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112V265.3c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V336c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192V71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$6563a67224e7f879 = {
    prefix: 'fas',
    iconName: 'message',
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"
    ]
};
var $1113a0aa61ab7765$export$6e96904d9af0ec4a = $1113a0aa61ab7765$export$6563a67224e7f879;
var $1113a0aa61ab7765$export$d469b770895f47ac = {
    prefix: 'fas',
    iconName: 'info',
    icon: [
        192,
        512,
        [],
        "f129",
        "M144 80c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V256H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $1113a0aa61ab7765$export$d56736f5800b3f0d = {
    prefix: 'fas',
    iconName: 'down-left-and-up-right-to-center',
    icon: [
        512,
        512,
        [
            "compress-alt"
        ],
        "f422",
        "M473 7c-9.4-9.4-24.6-9.4-33.9 0l-87 87L313 55c-6.9-6.9-17.2-8.9-26.2-5.2S272 62.3 272 72V216c0 13.3 10.7 24 24 24H440c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-39-39 87-87c9.4-9.4 9.4-24.6 0-33.9L473 7zM216 272H72c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39L7 439c-9.4 9.4-9.4 24.6 0 33.9l32 32c9.4 9.4 24.6 9.4 33.9 0l87-87 39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V296c0-13.3-10.7-24-24-24z"
    ]
};
var $1113a0aa61ab7765$export$a05650ebe54bede = $1113a0aa61ab7765$export$d56736f5800b3f0d;
var $1113a0aa61ab7765$export$36b5fbeae4855055 = {
    prefix: 'fas',
    iconName: 'explosion',
    icon: [
        576,
        512,
        [],
        "e4e9",
        "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H117.8L42.3 363.7c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3L107.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448v0H512v0h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64zM288 0c13.3 0 24 10.7 24 24V72c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"
    ]
};
var $1113a0aa61ab7765$export$ef565d07efe2b5e9 = {
    prefix: 'fas',
    iconName: 'file-lines',
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$243b47dca32bf0b8 = $1113a0aa61ab7765$export$ef565d07efe2b5e9;
var $1113a0aa61ab7765$export$f466100bf9bf37a5 = $1113a0aa61ab7765$export$ef565d07efe2b5e9;
var $1113a0aa61ab7765$export$c38cf504b3bc58a2 = {
    prefix: 'fas',
    iconName: 'wave-square',
    icon: [
        640,
        512,
        [],
        "f83e",
        "M128 64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V416h96V256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96H192V256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64z"
    ]
};
var $1113a0aa61ab7765$export$a95486586631edc7 = {
    prefix: 'fas',
    iconName: 'ring',
    icon: [
        512,
        512,
        [],
        "f70b",
        "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3C443.6 226.7 448 215.8 448 208c0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8v96c0 49.6-39.4 85.8-83.3 107.8C382.9 434.7 321.7 448 256 448s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304V208z"
    ]
};
var $1113a0aa61ab7765$export$fbbc7601eb465ac7 = {
    prefix: 'fas',
    iconName: 'building-un',
    icon: [
        384,
        512,
        [],
        "e4d9",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$221059e0d5fd8958 = {
    prefix: 'fas',
    iconName: 'dice-three',
    icon: [
        448,
        512,
        [
            9858
        ],
        "f527",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 160c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm128 64c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm64 128c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$31c6cf6f5d38dc0 = {
    prefix: 'fas',
    iconName: 'calendar-days',
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"
    ]
};
var $1113a0aa61ab7765$export$cbc139f33cff356 = $1113a0aa61ab7765$export$31c6cf6f5d38dc0;
var $1113a0aa61ab7765$export$8bce49e6ae597af8 = {
    prefix: 'fas',
    iconName: 'anchor-circle-check',
    icon: [
        640,
        512,
        [],
        "e4aa",
        "M256 96c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm85.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM640 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $1113a0aa61ab7765$export$37584b1a5e175b47 = {
    prefix: 'fas',
    iconName: 'building-circle-arrow-right',
    icon: [
        640,
        512,
        [],
        "e4d1",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM640 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM492.7 300.7c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
    ]
};
var $1113a0aa61ab7765$export$cc519c9529a46c5c = {
    prefix: 'fas',
    iconName: 'volleyball',
    icon: [
        512,
        512,
        [
            127952,
            "volleyball-ball"
        ],
        "f45f",
        "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z"
    ]
};
var $1113a0aa61ab7765$export$a15e6fc8e68a76b0 = $1113a0aa61ab7765$export$cc519c9529a46c5c;
var $1113a0aa61ab7765$export$159982ce2622211e = {
    prefix: 'fas',
    iconName: 'arrows-up-to-line',
    icon: [
        640,
        512,
        [],
        "e4c2",
        "M64 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64s14.3 32 32 32zM41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 237.3 128 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0L448 237.3 448 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"
    ]
};
var $1113a0aa61ab7765$export$58e2577a373e7d4 = {
    prefix: 'fas',
    iconName: 'sort-down',
    icon: [
        320,
        512,
        [
            "sort-desc"
        ],
        "f0dd",
        "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
    ]
};
var $1113a0aa61ab7765$export$e24f016f5f78af6a = $1113a0aa61ab7765$export$58e2577a373e7d4;
var $1113a0aa61ab7765$export$d0163707993a8110 = {
    prefix: 'fas',
    iconName: 'circle-minus',
    icon: [
        512,
        512,
        [
            "minus-circle"
        ],
        "f056",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $1113a0aa61ab7765$export$f3979b49bf57313c = $1113a0aa61ab7765$export$d0163707993a8110;
var $1113a0aa61ab7765$export$41821b9a6fd703de = {
    prefix: 'fas',
    iconName: 'door-open',
    icon: [
        576,
        512,
        [],
        "f52b",
        "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480v32h32 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"
    ]
};
var $1113a0aa61ab7765$export$122a80ae0f87f726 = {
    prefix: 'fas',
    iconName: 'right-from-bracket',
    icon: [
        512,
        512,
        [
            "sign-out-alt"
        ],
        "f2f5",
        "M160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96C43 32 0 75 0 128V384c0 53 43 96 96 96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32h64zM504.5 273.4c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22v72H192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32H320v72c0 9.6 5.7 18.2 14.5 22s19 2 26-4.6l144-136z"
    ]
};
var $1113a0aa61ab7765$export$c844d6923b7096c2 = $1113a0aa61ab7765$export$122a80ae0f87f726;
var $1113a0aa61ab7765$export$b5bb295e8ad4ab31 = {
    prefix: 'fas',
    iconName: 'atom',
    icon: [
        448,
        512,
        [
            9883
        ],
        "f5d2",
        "M258.9 412.3c-16.7 33.8-31 35.7-34.9 35.7s-18.1-1.9-34.9-35.7c11.4-3.9 23.1-8.4 34.9-13.5c11.8 5.1 23.4 9.7 34.9 13.5zM252.8 312c-9.7 5.8-19.3 11.2-28.8 16c-9.4-4.8-19-10.2-28.8-16c-12.1-7.3-23.6-14.8-34.2-22.4c-.7-10.8-1-22-1-33.6s.4-22.7 1-33.6c10.6-7.6 22.1-15.1 34.2-22.4c9.7-5.8 19.3-11.2 28.8-16c9.4 4.8 19 10.2 28.8 16c12.1 7.3 23.6 14.8 34.2 22.4c.7 10.8 1 22 1 33.6s-.4 22.7-1 33.6c-10.6 7.6-22.1 15.1-34.2 22.4zm184.8 72c20.7-37.1 9.4-82.8-23.6-128c33-45.2 44.3-90.9 23.6-128c-20.2-36.3-62.5-49.3-115.2-43.2C300.4 32.7 266.8 0 224 0s-76.4 32.7-98.4 84.8c-52.7-6.1-95 6.8-115.2 43.2C-10.3 165.1 1 210.8 34 256C1 301.2-10.3 346.9 10.4 384c20.2 36.3 62.5 49.3 115.2 43.2c22 52.1 55.7 84.8 98.4 84.8s76.4-32.7 98.4-84.8c52.7 6.1 95-6.8 115.2-43.2zm-67.8-79.2c18.9 30.2 14.2 44 11.9 48.1c-1.6 2.9-8.4 13-40.2 11.7c2.8-13.1 5-26.9 6.7-41.2c7.6-6.1 14.8-12.3 21.6-18.6zm11.9-145.7c2.3 4.2 7 17.9-11.9 48.1c-6.8-6.3-14-12.5-21.6-18.6c-1.7-14.3-3.9-28-6.7-41.2c31.8-1.4 38.6 8.7 40.2 11.7zM224 64c3.9 0 18.1 1.9 34.9 35.7c-11.4 3.9-23.1 8.4-34.9 13.5c-11.8-5.1-23.4-9.7-34.9-13.5C205.9 65.9 220.1 64 224 64zM106.5 147.5c-2.8 13.1-5 26.9-6.7 41.2c-7.6 6.1-14.8 12.3-21.6 18.6C59.4 177 64 163.3 66.3 159.1c1.6-2.9 8.4-13 40.2-11.7zM66.3 352.9c-2.3-4.2-7-17.9 11.9-48.1c6.8 6.3 14 12.5 21.6 18.6c1.7 14.2 3.9 28 6.7 41.2c-31.8 1.4-38.6-8.7-40.2-11.7zM224 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$64f1c53b21f310ac = {
    prefix: 'fas',
    iconName: 'soap',
    icon: [
        512,
        512,
        [
            129532
        ],
        "e06e",
        "M208 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM320 256c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM416 32c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0 160c0 27.6-11.7 52.5-30.4 70.1C422.1 275.7 448 310.8 448 352c0 53-43 96-96 96H160c-53 0-96-43-96-96s43-96 96-96h88.4c-15.2-17-24.4-39.4-24.4-64H96c-53 0-96 43-96 96V416c0 53 43 96 96 96H416c53 0 96-43 96-96V288c0-53-43-96-96-96zM160 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H352c35.3 0 64-28.7 64-64s-28.7-64-64-64H320 160z"
    ]
};
var $1113a0aa61ab7765$export$7fe2894454d8eb8a = {
    prefix: 'fas',
    iconName: 'icons',
    icon: [
        576,
        512,
        [
            "heart-music-camera-bolt"
        ],
        "f86d",
        "M532.3 7.3C539.7 13.3 544 22.4 544 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L384 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM106.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2L245.3 304H272c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48h26.7zM224 408c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM510.7 278.3L472.3 368H528c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L423.7 400H368c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L51.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"
    ]
};
var $1113a0aa61ab7765$export$ec74c13cedb0791d = $1113a0aa61ab7765$export$7fe2894454d8eb8a;
var $1113a0aa61ab7765$export$4be1b324ac8a71ba = {
    prefix: 'fas',
    iconName: 'microphone-lines-slash',
    icon: [
        640,
        512,
        [
            "microphone-alt-slash"
        ],
        "f539",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24 16c0 21.2-5.1 41.1-14.2 58.7L416 300.8V256H358.9l-34.5-27c2.9-3.1 7-5 11.6-5h80V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zm362.5 407l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"
    ]
};
var $1113a0aa61ab7765$export$d2a53a388f30780 = $1113a0aa61ab7765$export$4be1b324ac8a71ba;
var $1113a0aa61ab7765$export$ea908d3d80c57d08 = {
    prefix: 'fas',
    iconName: 'bridge-circle-check',
    icon: [
        640,
        512,
        [],
        "e4c9",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM640 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $1113a0aa61ab7765$export$f1b881c73328720c = {
    prefix: 'fas',
    iconName: 'pump-medical',
    icon: [
        448,
        512,
        [],
        "e06a",
        "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$614dc068d88655af = {
    prefix: 'fas',
    iconName: 'fingerprint',
    icon: [
        512,
        512,
        [],
        "f577",
        "M48 256C48 141.1 141.1 48 256 48c69.3 0 130.6 33.8 168.5 86c7.8 10.7 22.8 13.1 33.5 5.3s13.1-22.8 5.3-33.5C416.8 41.7 341.3 0 256 0C114.6 0 0 114.6 0 256v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-18.1-1.9-35.8-5.5-52.9zM222.1 128.2c10.8-2.9 22.1-4.4 33.9-4.4c73 0 132.2 59.2 132.2 132.2c0 31.1-1.9 62.4-3.9 86c-1 11.8-2 21.6-2.7 28.4c-.4 3.4-.7 6.1-.9 7.9l-.2 2-.1 .5 0 .1 0 0 0 0c-1.6 13.2 7.7 25.1 20.8 26.8s25.1-7.7 26.8-20.8l-23.8-3c23.8 3 23.8 3 23.8 3l0 0 0 0 0 0 0-.2 .1-.6 .3-2.2c.2-1.9 .5-4.8 .9-8.3c.8-7.2 1.8-17.4 2.8-29.6c2-24.4 4.1-57.1 4.1-90c0-99.5-80.7-180.2-180.2-180.2c-15.9 0-31.4 2.1-46.2 6c-12.8 3.4-20.5 16.5-17.1 29.3s16.5 20.5 29.3 17.1zm-74.5 52.1c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9C87.9 182 75.8 217.6 75.8 256c0 30.1-3.8 58.6-7.6 79.7c-1.9 10.5-3.8 19.1-5.2 24.9c-.7 2.9-1.3 5.2-1.7 6.7c-.2 .7-.3 1.3-.4 1.6l-.1 .4 0 .1 0 0c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5L83.8 376c23.1 6.6 23.1 6.6 23.1 6.6l0 0 0 0 0-.1 0-.2 .2-.6c.1-.5 .3-1.2 .6-2.1c.5-1.8 1.2-4.4 1.9-7.7c1.6-6.6 3.7-16.1 5.8-27.6c4.2-22.9 8.4-54.4 8.4-88.3c0-28.2 8.8-54.3 23.8-75.7zM256 200c30.9 0 56 25.1 56 56c0 47.1-2.7 86.3-5.5 113.6c-1.4 13.7-2.7 24.3-3.7 31.6c-.5 3.6-.9 6.3-1.2 8.1c-.1 .9-.2 1.6-.3 2l-.1 .5 0 .1 0 0 0 0 0 0c-2.3 13.1 6.5 25.5 19.5 27.8s25.5-6.4 27.8-19.5L324.8 416c23.6 4.1 23.6 4.1 23.6 4.1l0 0 0 0 0-.1 0-.2 .1-.7c.1-.6 .2-1.4 .4-2.4c.3-2.1 .8-5.1 1.3-9c1.1-7.8 2.5-19.1 4-33.4c2.9-28.7 5.7-69.5 5.7-118.4c0-57.4-46.6-104-104-104s-104 46.6-104 104c0 46.7-3.9 83.4-7.7 108.4c-1.9 12.5-3.8 21.9-5.2 28.2c-.7 3.1-1.3 5.5-1.6 6.9c-.2 .7-.3 1.3-.4 1.6l-.1 .3c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5L160 408c23.1 6.6 23.1 6.6 23.1 6.6l0 0 0 0 0-.1 .1-.2 .2-.7c.1-.5 .3-1.3 .6-2.3c.5-2 1.2-4.8 2-8.4c1.6-7.2 3.7-17.8 5.8-31.3c3-19.2 5.9-44.6 7.3-75.3c.6-12.6 .9-26 .9-40.3c0-30.9 25.1-56 56-56zm24 56c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 45.4-2.6 83.4-6.3 114.5L202 478.3l0 0c-5.3 12.1 .1 26.2 12.2 31.6c12.1 5.4 26.3-.1 31.7-12.2L224 488c21.9 9.7 21.9 9.7 21.9 9.7l0 0 0 0 0-.1 .1-.3 .4-.9c.3-.8 .7-1.8 1.2-3.1c1-2.7 2.4-6.5 4-11.5c3.3-10.1 7.5-24.9 11.7-44.7C271.8 397.3 280 337.6 280 256zM225.7 370.5s0 0 0 0L256 232 225.7 370.5zm0 0c-2.7 22.5-5.9 41.3-9.2 56.6c-3.8 18.2-7.6 31.3-10.3 39.8c-1.4 4.2-2.5 7.3-3.2 9.2c-.4 .9-.6 1.6-.8 2l-.1 .4 23.6-107.9z"
    ]
};
var $1113a0aa61ab7765$export$f7bc8714c970afa4 = {
    prefix: 'fas',
    iconName: 'hand-point-right',
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zm64-64c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h48c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32H160C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64v88c0 22.1-17.9 40-40 40s-40-17.9-40-40V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v56c0 39.8 32.2 72 72 72z"
    ]
};
var $1113a0aa61ab7765$export$234a18b2b4d530a3 = {
    prefix: 'fas',
    iconName: 'magnifying-glass-location',
    icon: [
        512,
        512,
        [
            "search-location"
        ],
        "f689",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-48 0c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$c33aba6c251a898a = $1113a0aa61ab7765$export$234a18b2b4d530a3;
var $1113a0aa61ab7765$export$908d699be6717adc = {
    prefix: 'fas',
    iconName: 'forward-step',
    icon: [
        320,
        512,
        [
            "step-forward"
        ],
        "f051",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"
    ]
};
var $1113a0aa61ab7765$export$b303329afce5de18 = $1113a0aa61ab7765$export$908d699be6717adc;
var $1113a0aa61ab7765$export$e3c56ed54f074063 = {
    prefix: 'fas',
    iconName: 'face-smile-beam',
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $1113a0aa61ab7765$export$54ada6dc9690e0ca = $1113a0aa61ab7765$export$e3c56ed54f074063;
var $1113a0aa61ab7765$export$92fad97e19a9fea = {
    prefix: 'fas',
    iconName: 'flag-checkered',
    icon: [
        448,
        512,
        [
            127937
        ],
        "f11e",
        "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1V345.8c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.4-23.7-122.5-13.4L64 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V400 334 64 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9v65.5L64 252.6V318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3V238.7l38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9v66.7l-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8v71.4c21.8 1.9 43.3 6.7 64 14.4V244.2l22.7 6.7c13.5 4 27.3 6.4 41.3 7.4V194c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12v-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8v72.4c-13-.4-26 .8-38.7 3.6L128 173.2V98L64 114v73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2V251.9l-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5v77.4zm64-149.4V115.4c-20.9 6.1-42.4 9.1-64 9.1V194c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"
    ]
};
var $1113a0aa61ab7765$export$e15f65e77f717c29 = {
    prefix: 'fas',
    iconName: 'football',
    icon: [
        512,
        512,
        [
            127944,
            "football-ball"
        ],
        "f44e",
        "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6c-18.3 29.8-30.9 62.3-39.2 95.4L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $1113a0aa61ab7765$export$e8fd664711e31704 = $1113a0aa61ab7765$export$e15f65e77f717c29;
var $1113a0aa61ab7765$export$f629fdee00932a01 = {
    prefix: 'fas',
    iconName: 'school-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e56c",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$afa58590dfb6fca2 = {
    prefix: 'fas',
    iconName: 'crop',
    icon: [
        512,
        512,
        [],
        "f125",
        "M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 160 64v64l178.7 0L128 338.7V32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H173.3L384 173.3 384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-274.7z"
    ]
};
var $1113a0aa61ab7765$export$52783a541b1bb03 = {
    prefix: 'fas',
    iconName: 'angles-down',
    icon: [
        448,
        512,
        [
            "angle-double-down"
        ],
        "f103",
        "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
    ]
};
var $1113a0aa61ab7765$export$fd504117f273ca92 = $1113a0aa61ab7765$export$52783a541b1bb03;
var $1113a0aa61ab7765$export$a28757068b9a3a9a = {
    prefix: 'fas',
    iconName: 'users-rectangle',
    icon: [
        640,
        512,
        [],
        "e594",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H544c53 0 96-43 96-96V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zm159.8 80c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3C119.9 256 96 279.9 96 309.3zM461.2 336h56.1c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47zM512 176c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM320 256c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64z"
    ]
};
var $1113a0aa61ab7765$export$b96e695bdcf3f3f5 = {
    prefix: 'fas',
    iconName: 'people-roof',
    icon: [
        640,
        512,
        [],
        "e537",
        "M335.5 4l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 240c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40zM144 336c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40zm392-40c0 22.1-17.9 40-40 40s-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40zM226.9 491.4L200 441.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V441.5L61.1 491.4c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V441.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V345.5l-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"
    ]
};
var $1113a0aa61ab7765$export$d12c2d6def120efe = {
    prefix: 'fas',
    iconName: 'people-line',
    icon: [
        640,
        512,
        [],
        "e534",
        "M360 72c0-22.1-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40s40-17.9 40-40zM144 208c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM496 208c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V217.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5z"
    ]
};
var $1113a0aa61ab7765$export$b957c27bc5330472 = {
    prefix: 'fas',
    iconName: 'beer-mug-empty',
    icon: [
        512,
        512,
        [
            "beer"
        ],
        "f0fc",
        "M32 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h51.2c42.4 0 76.8 34.4 76.8 76.8V274.9c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V172.8c0-7.1-5.7-12.8-12.8-12.8H384V311.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"
    ]
};
var $1113a0aa61ab7765$export$f74725691538983b = $1113a0aa61ab7765$export$b957c27bc5330472;
var $1113a0aa61ab7765$export$1852c99deca7bee8 = {
    prefix: 'fas',
    iconName: 'diagram-predecessor',
    icon: [
        512,
        512,
        [],
        "e477",
        "M448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c44.2 0 80 35.8 80 80l0 16 38.1 0c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41l38.1 0 0-16c0-8.8-7.2-16-16-16l-80 0 0 64z"
    ]
};
var $1113a0aa61ab7765$export$92c58defe6e4c5a7 = {
    prefix: 'fas',
    iconName: 'arrow-up-long',
    icon: [
        384,
        512,
        [
            "long-arrow-up"
        ],
        "f176",
        "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
    ]
};
var $1113a0aa61ab7765$export$ede1d50ec4b01670 = $1113a0aa61ab7765$export$92c58defe6e4c5a7;
var $1113a0aa61ab7765$export$9ebfff5c90672059 = {
    prefix: 'fas',
    iconName: 'fire-flame-simple',
    icon: [
        384,
        512,
        [
            "burn"
        ],
        "f46a",
        "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"
    ]
};
var $1113a0aa61ab7765$export$80ed4535efc60402 = $1113a0aa61ab7765$export$9ebfff5c90672059;
var $1113a0aa61ab7765$export$e6619e43cb090a16 = {
    prefix: 'fas',
    iconName: 'person',
    icon: [
        320,
        512,
        [
            129485,
            "male"
        ],
        "f183",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152z"
    ]
};
var $1113a0aa61ab7765$export$2e21f9dba1630651 = $1113a0aa61ab7765$export$e6619e43cb090a16;
var $1113a0aa61ab7765$export$c2dee3bd177275a2 = {
    prefix: 'fas',
    iconName: 'laptop',
    icon: [
        640,
        512,
        [
            128187
        ],
        "f109",
        "M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"
    ]
};
var $1113a0aa61ab7765$export$82cea4f586f6ec9 = {
    prefix: 'fas',
    iconName: 'file-csv',
    icon: [
        384,
        512,
        [],
        "f6dd",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 224H96c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H80c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8H96c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H80c-22.1 0-40-17.9-40-40V264c0-22.1 17.9-40 40-40zm72 46.4c0-25.6 20.8-46.4 46.4-46.4H216c8.8 0 16 7.2 16 16s-7.2 16-16 16H198.4c-7.9 0-14.4 6.4-14.4 14.4c0 5.2 2.8 9.9 7.2 12.5l25.4 14.5c14.4 8.3 23.4 23.6 23.4 40.3c0 25.6-20.8 46.4-46.4 46.4H168c-8.8 0-16-7.2-16-16s7.2-16 16-16h25.6c7.9 0 14.4-6.4 14.4-14.4c0-5.2-2.8-9.9-7.2-12.5l-25.4-14.5C160.9 302.4 152 287 152 270.4zM280 240v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V240c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$232452c59d77c56e = {
    prefix: 'fas',
    iconName: 'menorah',
    icon: [
        640,
        512,
        [],
        "f676",
        "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32V288c0 17.7 14.3 32 32 32H288V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320H544c17.7 0 32-14.3 32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 53-43 96-96 96H352v64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V384H96c-53 0-96-43-96-96V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H96V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H192V256 160c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32v96 32H384V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H480V256 160c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$e1d5ceed99060d76 = {
    prefix: 'fas',
    iconName: 'truck-plane',
    icon: [
        640,
        512,
        [],
        "e58f",
        "M200 0c-30.6 0-56 54.7-56 86.1V192.5L7.8 274.3C2.9 277.2 0 282.4 0 288v64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37v81.2l-50 40c-3.8 3-6 7.6-6 12.5v32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15V463.4c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1V408 325.5 184l0-1.1 0 0V86.1C256 54.7 231.5 0 200 0zm88 176V400c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V448H544v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V445.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7H539.7c9.2 0 17.2 6 20.5 14.7L576 304H352l15.8-49.3zM568 400c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zM384 376c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$fe2d5012d9982673 = {
    prefix: 'fas',
    iconName: 'record-vinyl',
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM256 352c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96zm0 32c70.7 0 128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128zm0-96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$1d1fbac384a76a12 = {
    prefix: 'fas',
    iconName: 'face-grin-stars',
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM403 336.5c5.1-11.8-6.9-22.4-19.2-18.7C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7c24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"
    ]
};
var $1113a0aa61ab7765$export$64347a5c8c402ef4 = $1113a0aa61ab7765$export$1d1fbac384a76a12;
var $1113a0aa61ab7765$export$e74974fac77c468e = {
    prefix: 'fas',
    iconName: 'bong',
    icon: [
        512,
        512,
        [],
        "f55c",
        "M192 208.5c0 29.1-15.6 53.9-37.2 67.8c-17.2 11.1-31.5 26.1-41.7 43.7H334.9c-10.2-17.6-24.5-32.6-41.7-43.7c-21.6-13.9-37.2-38.7-37.2-67.8V64H192V208.5zM320 64V208.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L398.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C406 314.1 416 347.9 416 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H108.1c-17.3 0-34.2-7.1-43.8-21.5C43.9 460.1 32 423.4 32 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h16H304h16c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$3c8d5c62d76c33b8 = {
    prefix: 'fas',
    iconName: 'spaghetti-monster-flying',
    icon: [
        640,
        512,
        [
            "pastafarianism"
        ],
        "f67b",
        "M208 64c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1l0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3c-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $1113a0aa61ab7765$export$733efdaec97447be = $1113a0aa61ab7765$export$3c8d5c62d76c33b8;
var $1113a0aa61ab7765$export$9fe0c42ede2dd003 = {
    prefix: 'fas',
    iconName: 'arrow-down-up-across-line',
    icon: [
        576,
        512,
        [],
        "e4af",
        "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H448V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3V224H192 128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192zM448 320H384V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"
    ]
};
var $1113a0aa61ab7765$export$faf854a434ce6d0c = {
    prefix: 'fas',
    iconName: 'spoon',
    icon: [
        512,
        512,
        [
            129348,
            61873,
            "utensil-spoon"
        ],
        "f2e5",
        "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"
    ]
};
var $1113a0aa61ab7765$export$fb7af5d245fb9053 = $1113a0aa61ab7765$export$faf854a434ce6d0c;
var $1113a0aa61ab7765$export$8b503c1d76716ddd = {
    prefix: 'fas',
    iconName: 'jar-wheat',
    icon: [
        320,
        512,
        [],
        "e517",
        "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm112 0H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7zM112 352H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7z"
    ]
};
var $1113a0aa61ab7765$export$dc2cce064a1e70bb = {
    prefix: 'fas',
    iconName: 'envelopes-bulk',
    icon: [
        576,
        512,
        [
            "mail-bulk"
        ],
        "f674",
        "M96 0C78.3 0 64 14.3 64 32V224h96V192c0-35.3 28.7-64 64-64H448V32c0-17.7-14.3-32-32-32H96zM224 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64V416H544c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H224zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM32 256c-17.7 0-32 14.3-32 32v13L155.1 415.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L320 301V288c0-17.7-14.3-32-32-32H32zm288 84.8L184 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L0 340.8V480c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V340.8z"
    ]
};
var $1113a0aa61ab7765$export$dd24f40c5337e2e1 = $1113a0aa61ab7765$export$dc2cce064a1e70bb;
var $1113a0aa61ab7765$export$61fa9809253098e5 = {
    prefix: 'fas',
    iconName: 'file-circle-exclamation',
    icon: [
        576,
        512,
        [],
        "e4eb",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 384c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm0-48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $1113a0aa61ab7765$export$bf5674308c61894f = {
    prefix: 'fas',
    iconName: 'circle-h',
    icon: [
        512,
        512,
        [
            9405,
            "hospital-symbol"
        ],
        "f47e",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM368 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H192l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H320V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$c8a3c78d99c23fed = $1113a0aa61ab7765$export$bf5674308c61894f;
var $1113a0aa61ab7765$export$e1611f373a10a98c = {
    prefix: 'fas',
    iconName: 'pager',
    icon: [
        512,
        512,
        [
            128223
        ],
        "f815",
        "M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"
    ]
};
var $1113a0aa61ab7765$export$853fd1561789e3bb = {
    prefix: 'fas',
    iconName: 'address-book',
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM208 288h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm96-96c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"
    ]
};
var $1113a0aa61ab7765$export$594b5a5d4d2e156b = $1113a0aa61ab7765$export$853fd1561789e3bb;
var $1113a0aa61ab7765$export$eff51ea25b4de135 = {
    prefix: 'fas',
    iconName: 'strikethrough',
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"
    ]
};
var $1113a0aa61ab7765$export$3f85413cb67e7f67 = {
    prefix: 'fas',
    iconName: 'k',
    icon: [
        320,
        512,
        [
            107
        ],
        "4b",
        "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64V328 448c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"
    ]
};
var $1113a0aa61ab7765$export$f4d472cf47be4096 = {
    prefix: 'fas',
    iconName: 'landmark-flag',
    icon: [
        512,
        512,
        [],
        "e51c",
        "M272 0h80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H272v32H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H240V16c0-8.8 7.2-16 16-16h16zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
    ]
};
var $1113a0aa61ab7765$export$c72de95adaca18b8 = {
    prefix: 'fas',
    iconName: 'pencil',
    icon: [
        512,
        512,
        [
            9999,
            61504,
            "pencil-alt"
        ],
        "f303",
        "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $1113a0aa61ab7765$export$8210adc172262df = $1113a0aa61ab7765$export$c72de95adaca18b8;
var $1113a0aa61ab7765$export$ae65f96ea7a4078d = {
    prefix: 'fas',
    iconName: 'backward',
    icon: [
        512,
        512,
        [
            9194
        ],
        "f04a",
        "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3V256v41.7L459.5 440.6zM256 352V256 128 96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V352z"
    ]
};
var $1113a0aa61ab7765$export$f1011352b01c1c0 = {
    prefix: 'fas',
    iconName: 'caret-right',
    icon: [
        256,
        512,
        [],
        "f0da",
        "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"
    ]
};
var $1113a0aa61ab7765$export$932912e74adb8939 = {
    prefix: 'fas',
    iconName: 'comments',
    icon: [
        640,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"
    ]
};
var $1113a0aa61ab7765$export$6f95f90dd1f6d86b = {
    prefix: 'fas',
    iconName: 'paste',
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V256H416c-17.7 0-32-14.3-32-32V128H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm256 88v96h96l-96-96z"
    ]
};
var $1113a0aa61ab7765$export$ca3229c47de163fa = $1113a0aa61ab7765$export$6f95f90dd1f6d86b;
var $1113a0aa61ab7765$export$37576dfab037d8bf = {
    prefix: 'fas',
    iconName: 'code-pull-request',
    icon: [
        512,
        512,
        [],
        "e13c",
        "M305.8 2.1C314.4 5.9 320 14.5 320 24V64h16c70.7 0 128 57.3 128 128V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-35.3-28.7-64-64-64H320v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80c0-13.3-10.7-24-24-24S56 66.7 56 80s10.7 24 24 24s24-10.7 24-24zm8 73.3V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zm328 24c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $1113a0aa61ab7765$export$2c5a9d8548d8810e = {
    prefix: 'fas',
    iconName: 'clipboard-list',
    icon: [
        384,
        512,
        [],
        "f46d",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"
    ]
};
var $1113a0aa61ab7765$export$37396c36c76937bc = {
    prefix: 'fas',
    iconName: 'truck-ramp-box',
    icon: [
        640,
        512,
        [
            "truck-loading"
        ],
        "f4de",
        "M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"
    ]
};
var $1113a0aa61ab7765$export$f00c152db7d44638 = $1113a0aa61ab7765$export$37396c36c76937bc;
var $1113a0aa61ab7765$export$76de2a120043c9f8 = {
    prefix: 'fas',
    iconName: 'user-check',
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M352 128c0 70.7-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $1113a0aa61ab7765$export$a56b2b0a1073620c = {
    prefix: 'fas',
    iconName: 'vial-virus',
    icon: [
        512,
        512,
        [],
        "e597",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V384c0 53 43 96 96 96c28.6 0 54.2-12.5 71.8-32.3c.1-14.2 5.6-28.3 16.4-39.1c.2-.2 .1-.6-.2-.6c-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4 .2-.6c-21.9-21.9-21.9-57.3 0-79.2c2.4-2.4 5-4.6 7.8-6.5V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32zM96 192V96h64v96H96zM216 376c28.8 0 43.2 34.8 22.9 55.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C444.8 410.8 459.2 376 488 376c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.8 259.2 376 244.8 376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-24c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm88 32c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$57f2bcd070bff91a = {
    prefix: 'fas',
    iconName: 'sheet-plastic',
    icon: [
        384,
        512,
        [],
        "e571",
        "M0 448c0 35.3 28.7 64 64 64H224V384c0-17.7 14.3-32 32-32H384V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384H256V512L384 384z"
    ]
};
var $1113a0aa61ab7765$export$890d5e011054935a = {
    prefix: 'fas',
    iconName: 'blog',
    icon: [
        512,
        512,
        [],
        "f781",
        "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144H128v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48V144z"
    ]
};
var $1113a0aa61ab7765$export$a9174995732e03c5 = {
    prefix: 'fas',
    iconName: 'user-ninja',
    icon: [
        448,
        512,
        [
            129399
        ],
        "f504",
        "M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 396 61.3 324.1 142.7 307.6l68.5 91.4c6.4 8.5 19.2 8.5 25.6 0l68.5-91.4C386.7 324.1 448 396 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
    ]
};
var $1113a0aa61ab7765$export$5709329dd2b70bdc = {
    prefix: 'fas',
    iconName: 'person-arrow-up-from-line',
    icon: [
        640,
        512,
        [],
        "e539",
        "M192 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM598.6 121.4l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var $1113a0aa61ab7765$export$4e3fe5b42a6cd494 = {
    prefix: 'fas',
    iconName: 'scroll-torah',
    icon: [
        640,
        512,
        [
            "torah"
        ],
        "f6a0",
        "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32H128V480H512V32zM592 0c-26.5 0-48 14.3-48 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332H214.3c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332H298.8L320 368.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52H284.8l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zM415.8 204H383l16.4 28.2L415.8 204zM320 143.6L298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204H224.2zM257 308l-16.4-28.2L224.2 308H257z"
    ]
};
var $1113a0aa61ab7765$export$54d07baabd8c2acb = $1113a0aa61ab7765$export$4e3fe5b42a6cd494;
var $1113a0aa61ab7765$export$3e1327487ce53231 = {
    prefix: 'fas',
    iconName: 'broom-ball',
    icon: [
        640,
        512,
        [
            "quidditch",
            "quidditch-broom-ball"
        ],
        "f458",
        "M633.3 12.4c10.8 14 8.3 34.1-5.6 44.9l-144 112-72 56L403 232l28.3 36.3c3.7 4.8 4.4 11.2 1.8 16.7s-8.1 9-14.1 9.1l-48 .9L292.3 194.2l12.5-46.3c1.6-5.9 6.3-10.3 12.3-11.5s12 1.1 15.8 5.8l30.8 39.4 8.7-6.8 72-56 144-112c13.9-10.9 34.1-8.3 44.9 5.6zM269.1 476.3c-55.5 43.4-215 34.2-252.3 31.4c-5.1-.4-9.7-2.9-12.8-7s-4.5-9.1-3.6-14.1c.5-3.2 1.3-7.2 2.2-12.1c3-16.5 10.8-31.6 21.9-44.1l73.5-82.5c3.1-3.5 3.2-8.6 .4-12.3s-7.9-4.7-12-2.6L47.3 353.5c-6.3 3.3-13.4-2.7-11-9.4c14.3-39.9 32.7-76.9 55.5-94.7c57.7-45.1 175.3-35.5 175.3-35.5l78.8 100.9s-19.1 116.4-76.8 161.5zM496 512c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $1113a0aa61ab7765$export$c00c446e6db1605f = $1113a0aa61ab7765$export$3e1327487ce53231;
var $1113a0aa61ab7765$export$791bfe29b97b4d42 = $1113a0aa61ab7765$export$3e1327487ce53231;
var $1113a0aa61ab7765$export$d20aaceb882ca545 = {
    prefix: 'fas',
    iconName: 'toggle-off',
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96s43 96 96 96z"
    ]
};
var $1113a0aa61ab7765$export$2a0fcb66c3d79d00 = {
    prefix: 'fas',
    iconName: 'box-archive',
    icon: [
        512,
        512,
        [
            "archive"
        ],
        "f187",
        "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $1113a0aa61ab7765$export$26b3e1c454273f34 = $1113a0aa61ab7765$export$2a0fcb66c3d79d00;
var $1113a0aa61ab7765$export$bac321083217fd4 = {
    prefix: 'fas',
    iconName: 'person-drowning',
    icon: [
        576,
        512,
        [],
        "e545",
        "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V96.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1L400 216.6c-41 9.3-83.7 7.5-123.7-5.2c-50.2-16-84.3-62.6-84.3-115.3V64zM320 192c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM306.5 389.9c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $1113a0aa61ab7765$export$6cc91ce23eb3fae1 = {
    prefix: 'fas',
    iconName: 'arrow-down-9-1',
    icon: [
        576,
        512,
        [
            "sort-numeric-desc",
            "sort-numeric-down-alt"
        ],
        "f886",
        "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM352 320c0 17.7 14.3 32 32 32h16v64H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V320c0-17.7-14.3-32-32-32H384c-17.7 0-32 14.3-32 32zm93.7-171.1c-4.2 2-8.8 3.1-13.7 3.1c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32c0 12.8-7.5 23.8-18.3 28.9zm-40.7 54.9l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
var $1113a0aa61ab7765$export$99f058110e2c82a8 = $1113a0aa61ab7765$export$6cc91ce23eb3fae1;
var $1113a0aa61ab7765$export$857385fda7a5a98e = $1113a0aa61ab7765$export$6cc91ce23eb3fae1;
var $1113a0aa61ab7765$export$8eee2c17ff89e724 = {
    prefix: 'fas',
    iconName: 'face-grin-tongue-squint',
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $1113a0aa61ab7765$export$4edf34c3def09a31 = $1113a0aa61ab7765$export$8eee2c17ff89e724;
var $1113a0aa61ab7765$export$4952c502f544cf85 = {
    prefix: 'fas',
    iconName: 'spray-can',
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80s80-35.8 80-80zM320 64c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zM512 64c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM480 192c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm32 64c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM384 192c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$24b8a0147653649a = {
    prefix: 'fas',
    iconName: 'truck-monster',
    icon: [
        640,
        512,
        [],
        "f63b",
        "M288 64v64H416L368 64H288zM419.2 25.6L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64H288c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H224V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6zM152 256h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C190.1 503.1 180.1 512 168 512H152c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L63.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9c1.7-11.6 11.7-20.6 23.8-20.6zm8 176c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM448.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C510.1 503.1 500.1 512 488 512H472c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C360.9 414.1 352 404.1 352 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM528 384c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
    ]
};
var $1113a0aa61ab7765$export$c7f24bdea332f90a = {
    prefix: 'fas',
    iconName: 'w',
    icon: [
        576,
        512,
        [
            119
        ],
        "57",
        "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"
    ]
};
var $1113a0aa61ab7765$export$11afa141d42099d0 = {
    prefix: 'fas',
    iconName: 'earth-africa',
    icon: [
        512,
        512,
        [
            127757,
            "globe-africa"
        ],
        "f57c",
        "M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.3-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
    ]
};
var $1113a0aa61ab7765$export$64af36f3b403a57c = $1113a0aa61ab7765$export$11afa141d42099d0;
var $1113a0aa61ab7765$export$92ab27739d3a91b2 = {
    prefix: 'fas',
    iconName: 'rainbow',
    icon: [
        640,
        512,
        [
            127752
        ],
        "f75b",
        "M320 96C178.6 96 64 210.6 64 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C0 175.3 143.3 32 320 32s320 143.3 320 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-35.3-28.7-64-64-64zM160 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-88.4-71.6-160-160-160s-160 71.6-160 160z"
    ]
};
var $1113a0aa61ab7765$export$9429fd8df55155d = {
    prefix: 'fas',
    iconName: 'circle-notch',
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
    ]
};
var $1113a0aa61ab7765$export$df1e253fc358ade4 = {
    prefix: 'fas',
    iconName: 'tablet-screen-button',
    icon: [
        448,
        512,
        [
            "tablet-alt"
        ],
        "f3fa",
        "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 448c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM384 64H64V384H384V64z"
    ]
};
var $1113a0aa61ab7765$export$db0cac088255eacc = $1113a0aa61ab7765$export$df1e253fc358ade4;
var $1113a0aa61ab7765$export$7bc6e4d977673e69 = {
    prefix: 'fas',
    iconName: 'paw',
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"
    ]
};
var $1113a0aa61ab7765$export$8bb3c4d5c2f50243 = {
    prefix: 'fas',
    iconName: 'cloud',
    icon: [
        640,
        512,
        [
            9729
        ],
        "f0c2",
        "M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"
    ]
};
var $1113a0aa61ab7765$export$b6c20c10ddbd9898 = {
    prefix: 'fas',
    iconName: 'trowel-bricks',
    icon: [
        512,
        512,
        [],
        "e58a",
        "M240.8 4.8C250.3 10.6 256 20.9 256 32v72h89c3.6-13.8 16.1-24 31-24h88c26.5 0 48 21.5 48 48s-21.5 48-48 48H376c-14.9 0-27.4-10.2-31-24H256v72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256zM32 384h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm192 0H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$ba5dc4287853ecbd = {
    prefix: 'fas',
    iconName: 'face-flushed',
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM176 384c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm-16-88c39.8 0 72-32.2 72-72s-32.2-72-72-72s-72 32.2-72 72s32.2 72 72 72zm264-72c0-39.8-32.2-72-72-72s-72 32.2-72 72s32.2 72 72 72s72-32.2 72-72zm-240 0c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zm192 0c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$dfd2bd012685aeac = $1113a0aa61ab7765$export$ba5dc4287853ecbd;
var $1113a0aa61ab7765$export$684703c93d630cc5 = {
    prefix: 'fas',
    iconName: 'hospital-user',
    icon: [
        576,
        512,
        [],
        "f80d",
        "M48 0C21.5 0 0 21.5 0 48V256H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48H265.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM152 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V152H112c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16zM512 272c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80s80-35.8 80-80zM288 477.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
var $1113a0aa61ab7765$export$fa95eb7418c0e2b8 = {
    prefix: 'fas',
    iconName: 'tent-arrow-left-right',
    icon: [
        640,
        512,
        [],
        "e57f",
        "M520.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L521.5 72 118.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72C34.9 82.7 32 89.2 32 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L118.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM339.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6s14.9 11.1 24.2 11.1H320V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $1113a0aa61ab7765$export$c36fb40057e2c3aa = {
    prefix: 'fas',
    iconName: 'gavel',
    icon: [
        512,
        512,
        [
            "legal"
        ],
        "f0e3",
        "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"
    ]
};
var $1113a0aa61ab7765$export$59d593c2dacb3781 = $1113a0aa61ab7765$export$c36fb40057e2c3aa;
var $1113a0aa61ab7765$export$8a910017964bb8c2 = {
    prefix: 'fas',
    iconName: 'binoculars',
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M128 32h32c17.7 0 32 14.3 32 32V96H96V64c0-17.7 14.3-32 32-32zm64 96V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V388.9c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28H192zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3V448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128h99.8zM320 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96H320V64zm-32 64V288H224V128h64z"
    ]
};
var $1113a0aa61ab7765$export$843f63d64e6f7951 = {
    prefix: 'fas',
    iconName: 'microphone-slash',
    icon: [
        640,
        512,
        [],
        "f131",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM344 430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4z"
    ]
};
var $1113a0aa61ab7765$export$f2adc06617bc0c7 = {
    prefix: 'fas',
    iconName: 'box-tissue',
    icon: [
        512,
        512,
        [],
        "e05b",
        "M92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L409.6 224 384 288H128l-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H418.5l25.6-64H464c26.5 0 48 21.5 48 48V384H0V272c0-26.5 21.5-48 48-48H79zM0 416H512v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416z"
    ]
};
var $1113a0aa61ab7765$export$f26017bdca99338d = {
    prefix: 'fas',
    iconName: 'motorcycle',
    icon: [
        640,
        512,
        [
            127949
        ],
        "f21c",
        "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H459.6c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21H280zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104H187.3zM128 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$e433538b78718fb3 = {
    prefix: 'fas',
    iconName: 'bell-concierge',
    icon: [
        512,
        512,
        [
            128718,
            "concierge-bell"
        ],
        "f562",
        "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
    ]
};
var $1113a0aa61ab7765$export$ad92ffbbfbc0fcf3 = $1113a0aa61ab7765$export$e433538b78718fb3;
var $1113a0aa61ab7765$export$85ba06027671d290 = {
    prefix: 'fas',
    iconName: 'pen-ruler',
    icon: [
        512,
        512,
        [
            "pencil-ruler"
        ],
        "f5ae",
        "M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z"
    ]
};
var $1113a0aa61ab7765$export$e3a7a1affea005f5 = $1113a0aa61ab7765$export$85ba06027671d290;
var $1113a0aa61ab7765$export$804bfc5c390e1a2a = {
    prefix: 'fas',
    iconName: 'people-arrows',
    icon: [
        640,
        512,
        [
            "people-arrows-left-right"
        ],
        "e068",
        "M192 64c0 35.3-28.7 64-64 64s-64-28.7-64-64S92.7 0 128 0s64 28.7 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM576 64c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V391.2l47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240v32h96V240c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V336H272v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"
    ]
};
var $1113a0aa61ab7765$export$da01f044c59e3598 = $1113a0aa61ab7765$export$804bfc5c390e1a2a;
var $1113a0aa61ab7765$export$1dc6221efb867885 = {
    prefix: 'fas',
    iconName: 'mars-and-venus-burst',
    icon: [
        640,
        512,
        [],
        "e523",
        "M504 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59.1 146.7 136.1 158.2c0 .6-.1 1.2-.1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3H352c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l24 0H376c0 13.3 10.7 24 24 24s24-10.7 24-24H400l24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H424v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2-.1-1.8c77-11.6 136.1-78 136.1-158.2c0-31.4-9-60.7-24.7-85.4L560 113.9l39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H504zM400 320c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2L220.3 92.1l-29.4-74z"
    ]
};
var $1113a0aa61ab7765$export$5b1d41cdd118ea6d = {
    prefix: 'fas',
    iconName: 'square-caret-right',
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
var $1113a0aa61ab7765$export$ae86c9de7e0f62fa = $1113a0aa61ab7765$export$5b1d41cdd118ea6d;
var $1113a0aa61ab7765$export$b2a906a5928c6404 = {
    prefix: 'fas',
    iconName: 'scissors',
    icon: [
        512,
        512,
        [
            9984,
            9986,
            9988,
            "cut"
        ],
        "f0c4",
        "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM160 112c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM112 448c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $1113a0aa61ab7765$export$66847f2a71b260e7 = $1113a0aa61ab7765$export$b2a906a5928c6404;
var $1113a0aa61ab7765$export$8db7f2f70484e17e = {
    prefix: 'fas',
    iconName: 'sun-plant-wilt',
    icon: [
        640,
        512,
        [],
        "e57a",
        "M160 0c-6.3 0-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0zm0 224c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm32-64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v8V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H504V280v-8V176z"
    ]
};
var $1113a0aa61ab7765$export$c00f55f36d386cb7 = {
    prefix: 'fas',
    iconName: 'toilets-portable',
    icon: [
        576,
        512,
        [],
        "e584",
        "M32 0H224c17.7 0 32 14.3 32 32V64H0V32C0 14.3 14.3 0 32 0zM0 96H24 232h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM192 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM352 0H544c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32zM320 96h24H552h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H368v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM512 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"
    ]
};
var $1113a0aa61ab7765$export$a274b02dc75663dc = {
    prefix: 'fas',
    iconName: 'hockey-puck',
    icon: [
        512,
        512,
        [],
        "f453",
        "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"
    ]
};
var $1113a0aa61ab7765$export$36583f5d3d5a971f = {
    prefix: 'fas',
    iconName: 'table',
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $1113a0aa61ab7765$export$382d3376c7fc7fc5 = {
    prefix: 'fas',
    iconName: 'magnifying-glass-arrow-right',
    icon: [
        512,
        512,
        [],
        "e521",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H238.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"
    ]
};
var $1113a0aa61ab7765$export$73f2bf302381c86a = {
    prefix: 'fas',
    iconName: 'tachograph-digital',
    icon: [
        640,
        512,
        [
            "digital-tachograph"
        ],
        "f566",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 64H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 320c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm80-16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm80-16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16z"
    ]
};
var $1113a0aa61ab7765$export$b3bf1994f0fefe98 = $1113a0aa61ab7765$export$73f2bf302381c86a;
var $1113a0aa61ab7765$export$b71a093b86e3da1f = {
    prefix: 'fas',
    iconName: 'users-slash',
    icon: [
        640,
        512,
        [],
        "e073",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192H106.7zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c10.5 0 19.5-6 23.9-14.8L324.9 352H261.3zM512 160c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80z"
    ]
};
var $1113a0aa61ab7765$export$57813571c0e10a0a = {
    prefix: 'fas',
    iconName: 'clover',
    icon: [
        448,
        512,
        [],
        "e139",
        "M173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2c-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4 .1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4H61.3C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1c1.2 .2 2.5 .8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2c.2-1.2 .8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3h-4.9c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1c-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34V93.3C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2C205.1 38.5 189.5 32 173.3 32z"
    ]
};
var $1113a0aa61ab7765$export$bb06d4a7bb6736fe = {
    prefix: 'fas',
    iconName: 'reply',
    icon: [
        512,
        512,
        [
            61714,
            "mail-reply"
        ],
        "f3e5",
        "M205 34.8c11.5 5.1 19 16.6 19 29.2v64H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"
    ]
};
var $1113a0aa61ab7765$export$12e45ff70d2646a1 = $1113a0aa61ab7765$export$bb06d4a7bb6736fe;
var $1113a0aa61ab7765$export$cafa834c96ebcb1a = {
    prefix: 'fas',
    iconName: 'star-and-crescent',
    icon: [
        576,
        512,
        [
            9770
        ],
        "f699",
        "M32 256C32 114.6 146.6 0 288 0c33 0 64.6 6.3 93.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C352.6 505.7 321 512 288 512C146.6 512 32 397.4 32 256zM407.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L293 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"
    ]
};
var $1113a0aa61ab7765$export$947ee033a6942aa8 = {
    prefix: 'fas',
    iconName: 'house-fire',
    icon: [
        640,
        512,
        [],
        "e50c",
        "M288 350.1l0 1.9H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L447.3 128.1c-12.3-1-25 3-34.8 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1zM453.5 163.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 56.7 24.2 76.9C640 437.9 568.7 512 480 512c-89.7 0-160-74.2-160-161.9c0-26.4 12.7-58.6 32.4-90.6c20-32.4 48.1-66.1 81.4-95.8c5.6-5 14.2-5 19.8 0zM530 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"
    ]
};
var $1113a0aa61ab7765$export$814c9edba7b84aa4 = {
    prefix: 'fas',
    iconName: 'square-minus',
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $1113a0aa61ab7765$export$ffe9387966b3e681 = $1113a0aa61ab7765$export$814c9edba7b84aa4;
var $1113a0aa61ab7765$export$612d3e1afaf45fa5 = {
    prefix: 'fas',
    iconName: 'helicopter',
    icon: [
        640,
        512,
        [
            128641
        ],
        "f533",
        "M128 32c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H384 304c-10.1 0-19.6-4.7-25.6-12.8L192 256 47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128H320V64H160c-17.7 0-32-14.3-32-32zM384 320H512V288c0-53-43-96-96-96H384V320zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H536.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
var $1113a0aa61ab7765$export$b4d344633433e50e = {
    prefix: 'fas',
    iconName: 'compass',
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$a1ab39cd66c4e50e = {
    prefix: 'fas',
    iconName: 'square-caret-down',
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
var $1113a0aa61ab7765$export$61aea18df1c84401 = $1113a0aa61ab7765$export$a1ab39cd66c4e50e;
var $1113a0aa61ab7765$export$877d3692c1f94bda = {
    prefix: 'fas',
    iconName: 'file-circle-question',
    icon: [
        576,
        512,
        [],
        "e4ef",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 384c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm0-48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
var $1113a0aa61ab7765$export$94100f4c6ee29932 = {
    prefix: 'fas',
    iconName: 'laptop-code',
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $1113a0aa61ab7765$export$c74a20c81b957b6a = {
    prefix: 'fas',
    iconName: 'swatchbook',
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M0 32C0 14.3 14.3 0 32 0H160c17.7 0 32 14.3 32 32V416c0 53-43 96-96 96s-96-43-96-96V32zM223.6 425.9c.3-3.3 .4-6.6 .4-9.9V154l75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192H480c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H182.8zM128 64H64v64h64V64zM64 192v64h64V192H64zM96 440c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $1113a0aa61ab7765$export$214f9ce665590486 = {
    prefix: 'fas',
    iconName: 'prescription-bottle',
    icon: [
        384,
        512,
        [],
        "f485",
        "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V224H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V128z"
    ]
};
var $1113a0aa61ab7765$export$36e9cf7887265da2 = {
    prefix: 'fas',
    iconName: 'bars',
    icon: [
        448,
        512,
        [
            "navicon"
        ],
        "f0c9",
        "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$409fa7bcaa0e4cd9 = $1113a0aa61ab7765$export$36e9cf7887265da2;
var $1113a0aa61ab7765$export$be015e72863c3635 = {
    prefix: 'fas',
    iconName: 'people-group',
    icon: [
        640,
        512,
        [],
        "e533",
        "M184 88c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zM568 88c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm8 157.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 160c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"
    ]
};
var $1113a0aa61ab7765$export$52757ecc5b1e25b9 = {
    prefix: 'fas',
    iconName: 'hourglass-end',
    icon: [
        384,
        512,
        [
            8987,
            "hourglass-3"
        ],
        "f253",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"
    ]
};
var $1113a0aa61ab7765$export$1ec43c81fef8ffd6 = $1113a0aa61ab7765$export$52757ecc5b1e25b9;
var $1113a0aa61ab7765$export$8e521ef33062b00e = {
    prefix: 'fas',
    iconName: 'heart-crack',
    icon: [
        512,
        512,
        [
            128148,
            "heart-broken"
        ],
        "f7a9",
        "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.8c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"
    ]
};
var $1113a0aa61ab7765$export$4a565395cb65b282 = $1113a0aa61ab7765$export$8e521ef33062b00e;
var $1113a0aa61ab7765$export$a47a20ab7bde8c67 = {
    prefix: 'fas',
    iconName: 'square-up-right',
    icon: [
        448,
        512,
        [
            8599,
            "external-link-square-alt"
        ],
        "f360",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l40 40-71 71C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l71-71 40 40c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V176c0-8.8-7.2-16-16-16H160z"
    ]
};
var $1113a0aa61ab7765$export$e4cdf2977151ee26 = $1113a0aa61ab7765$export$a47a20ab7bde8c67;
var $1113a0aa61ab7765$export$eca99665af566fe1 = {
    prefix: 'fas',
    iconName: 'face-kiss-beam',
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $1113a0aa61ab7765$export$d6ff8a73c0812e63 = $1113a0aa61ab7765$export$eca99665af566fe1;
var $1113a0aa61ab7765$export$c03de0cc616e77bb = {
    prefix: 'fas',
    iconName: 'film',
    icon: [
        512,
        512,
        [
            127902
        ],
        "f008",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM48 368v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H416zM48 240v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H416zM48 112v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H416zM160 128v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z"
    ]
};
var $1113a0aa61ab7765$export$46c6347bff3e04a = {
    prefix: 'fas',
    iconName: 'ruler-horizontal',
    icon: [
        640,
        512,
        [],
        "f547",
        "M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z"
    ]
};
var $1113a0aa61ab7765$export$75ce8513e1f1c5c4 = {
    prefix: 'fas',
    iconName: 'people-robbery',
    icon: [
        576,
        512,
        [],
        "e536",
        "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V174.3c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM80 96c26.5 0 48-21.5 48-48s-21.5-48-48-48S32 21.5 32 48s21.5 48 48 48zm-8 32c-35.3 0-64 28.7-64 64v96l0 .6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352H88V480c0 17.7 14.3 32 32 32s32-14.3 32-32V252.7l13 20.5c5.9 9.2 16.1 14.9 27 14.9h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H209.6l-37.4-58.9C157.6 142 132.1 128 104.7 128H72z"
    ]
};
var $1113a0aa61ab7765$export$1e80f89fe84a215b = {
    prefix: 'fas',
    iconName: 'lightbulb',
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
    ]
};
var $1113a0aa61ab7765$export$85a918a11b7643c2 = {
    prefix: 'fas',
    iconName: 'caret-left',
    icon: [
        256,
        512,
        [],
        "f0d9",
        "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
    ]
};
var $1113a0aa61ab7765$export$59573943f9eebbd5 = {
    prefix: 'fas',
    iconName: 'circle-exclamation',
    icon: [
        512,
        512,
        [
            "exclamation-circle"
        ],
        "f06a",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm32 224c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$220e07e14c5d7e5d = $1113a0aa61ab7765$export$59573943f9eebbd5;
var $1113a0aa61ab7765$export$5e17b20e0f6b132b = {
    prefix: 'fas',
    iconName: 'school-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e56d",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
    ]
};
var $1113a0aa61ab7765$export$ca14f1b4d6afb7aa = {
    prefix: 'fas',
    iconName: 'arrow-right-from-bracket',
    icon: [
        576,
        512,
        [
            "sign-out"
        ],
        "f08b",
        "M534.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L434.7 224 224 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-53 0-96 43-96 96l0 256c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"
    ]
};
var $1113a0aa61ab7765$export$33e2b60243ca6d92 = $1113a0aa61ab7765$export$ca14f1b4d6afb7aa;
var $1113a0aa61ab7765$export$aca07924996218d8 = {
    prefix: 'fas',
    iconName: 'circle-chevron-down',
    icon: [
        512,
        512,
        [
            "chevron-circle-down"
        ],
        "f13a",
        "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"
    ]
};
var $1113a0aa61ab7765$export$9926124d75b2ecab = $1113a0aa61ab7765$export$aca07924996218d8;
var $1113a0aa61ab7765$export$c98fdd5082b333ec = {
    prefix: 'fas',
    iconName: 'unlock-keyhole',
    icon: [
        448,
        512,
        [
            "unlock-alt"
        ],
        "f13e",
        "M224 64c-44.2 0-80 35.8-80 80v48H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80V144C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"
    ]
};
var $1113a0aa61ab7765$export$b19f508797f3d9c3 = $1113a0aa61ab7765$export$c98fdd5082b333ec;
var $1113a0aa61ab7765$export$af51c741ee9cc090 = {
    prefix: 'fas',
    iconName: 'cloud-showers-heavy',
    icon: [
        576,
        512,
        [],
        "f740",
        "M128 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C96.7 126.1 96 119.1 96 112C96 50.1 146.1 0 208 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H128zm-14.5 33.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM345.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"
    ]
};
var $1113a0aa61ab7765$export$ca47801915e5a685 = {
    prefix: 'fas',
    iconName: 'headphones-simple',
    icon: [
        512,
        512,
        [
            "headphones-alt"
        ],
        "f58f",
        "M256 80C141.1 80 48 173.1 48 288V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288C0 146.6 114.6 32 256 32s256 114.6 256 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V352zm288-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h16z"
    ]
};
var $1113a0aa61ab7765$export$6f0433fa527dd5be = $1113a0aa61ab7765$export$ca47801915e5a685;
var $1113a0aa61ab7765$export$b2ce5e79d0eccaf8 = {
    prefix: 'fas',
    iconName: 'sitemap',
    icon: [
        576,
        512,
        [],
        "f0e8",
        "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z"
    ]
};
var $1113a0aa61ab7765$export$5f92ac3e804644e3 = {
    prefix: 'fas',
    iconName: 'circle-dollar-to-slot',
    icon: [
        512,
        512,
        [
            "donate"
        ],
        "f4b9",
        "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 91.9c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.8 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V304c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.4-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V112c0-11.1-9-20.1-20.1-20.1zM48 352H64c19.5 25.9 44 47.7 72.2 64H64v32H256 448V416H375.8c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"
    ]
};
var $1113a0aa61ab7765$export$40050ae52860cde7 = $1113a0aa61ab7765$export$5f92ac3e804644e3;
var $1113a0aa61ab7765$export$5f9bd9f6df021f93 = {
    prefix: 'fas',
    iconName: 'memory',
    icon: [
        576,
        512,
        [],
        "f538",
        "M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320H576V248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zM576 352H0v64c0 17.7 14.3 32 32 32H80V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48c17.7 0 32-14.3 32-32V352zM192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$b372a24046126ad8 = {
    prefix: 'fas',
    iconName: 'road-spikes',
    icon: [
        640,
        512,
        [],
        "e568",
        "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256V116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 448 384 320 256 192 64V116.8zM32 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$e4e44f7b1886fef = {
    prefix: 'fas',
    iconName: 'fire-burner',
    icon: [
        640,
        512,
        [],
        "e4f1",
        "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15zM32 288c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32s-14.3 32-32 32v64H544V320c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V288zM320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm160-32c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM192 480c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$6591b1ea509be9da = {
    prefix: 'fas',
    iconName: 'flag',
    icon: [
        448,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z"
    ]
};
var $1113a0aa61ab7765$export$3dcd4ca3f7108a82 = {
    prefix: 'fas',
    iconName: 'hanukiah',
    icon: [
        640,
        512,
        [
            128334
        ],
        "f6e6",
        "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32V320H96c-17.7 0-32-14.3-32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 53 43 96 96 96H288v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H544c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352V144z"
    ]
};
var $1113a0aa61ab7765$export$5e19aea195b31816 = {
    prefix: 'fas',
    iconName: 'feather',
    icon: [
        512,
        512,
        [
            129718
        ],
        "f52d",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h68c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330v55.3L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
var $1113a0aa61ab7765$export$2b1464e7557b18eb = {
    prefix: 'fas',
    iconName: 'volume-low',
    icon: [
        448,
        512,
        [
            128264,
            "volume-down"
        ],
        "f027",
        "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"
    ]
};
var $1113a0aa61ab7765$export$69fdf57632b6cc29 = $1113a0aa61ab7765$export$2b1464e7557b18eb;
var $1113a0aa61ab7765$export$3786a0422a3f33ea = {
    prefix: 'fas',
    iconName: 'comment-slash',
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104-17.9L82.9 161.3C70.7 185.6 64 212.2 64 240z"
    ]
};
var $1113a0aa61ab7765$export$dd9dc9b4227dbe94 = {
    prefix: 'fas',
    iconName: 'cloud-sun-rain',
    icon: [
        640,
        512,
        [
            127782
        ],
        "f743",
        "M137.9 3c-4.5-3.2-10.3-3.9-15.4-1.8s-8.8 6.7-9.7 12.2L98.7 98.7 13.4 112.8c-5.5 .9-10.1 4.6-12.2 9.7S-.2 133.4 3 137.9l50.3 70.3L3 278.5c-3.2 4.5-3.9 10.3-1.8 15.4s6.7 8.8 12.2 9.7l85.3 14.1L112.8 403c.9 5.5 4.6 10.1 9.7 12.2s10.9 1.4 15.4-1.8l55.2-39.5c-19.9-21.9-32.3-50.8-33.1-82.6c-17.6-10.2-32.2-26.1-40.6-46.3c-20.3-49 3-105.1 52-125.4c29.4-12.2 61.4-8.7 86.7 6.7c13.1-21.8 32.5-39.4 55.8-50.3L303.6 13.4c-.9-5.5-4.6-10.1-9.7-12.2S282.9-.2 278.5 3L208.2 53.3 137.9 3zM291.4 415.9c-2.5 .6-5.1 .6-7.6-.1c1.4 0 2.8 .1 4.2 .1h3.5zm-46.3-260c-17.3-12.2-40.4-15.6-61.5-6.9c-32.7 13.5-48.2 51-34.6 83.6c3.6 8.7 8.9 16.1 15.3 22.2c10.6-39.7 39.9-71.8 77.8-86.4c.8-4.3 1.8-8.4 3-12.5zM277.4 420c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm74.5-116.1c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.3 114.6 402.8 96 368 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H559.9c44.2 0 80-35.8 80-80z"
    ]
};
var $1113a0aa61ab7765$export$83632d1150d3541f = {
    prefix: 'fas',
    iconName: 'compress',
    icon: [
        448,
        512,
        [],
        "f066",
        "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
    ]
};
var $1113a0aa61ab7765$export$79d4dac715a51fdf = {
    prefix: 'fas',
    iconName: 'wheat-awn',
    icon: [
        512,
        512,
        [
            "wheat-alt"
        ],
        "e2cd",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3z"
    ]
};
var $1113a0aa61ab7765$export$deaf03a29aa05e3a = $1113a0aa61ab7765$export$79d4dac715a51fdf;
var $1113a0aa61ab7765$export$8736909014b15ca9 = {
    prefix: 'fas',
    iconName: 'ankh',
    icon: [
        320,
        512,
        [
            9765
        ],
        "f644",
        "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H241.2c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"
    ]
};
var $1113a0aa61ab7765$export$bfb254bf3c0bc50b = {
    prefix: 'fas',
    iconName: 'hands-holding-child',
    icon: [
        640,
        512,
        [],
        "e4fa",
        "M320 80c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40zm44.7 84.3L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 104.8 295.3 96 320 96s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
    ]
};
var $1113a0aa61ab7765$export$19eff32c0fd4f99f = {
    prefix: 'fas',
    iconName: 'asterisk',
    icon: [
        384,
        512,
        [
            10033,
            61545
        ],
        "2a",
        "M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$5bb6a0c94ad2f4bb = {
    prefix: 'fas',
    iconName: 'square-check',
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $1113a0aa61ab7765$export$f0c8040f596df7fe = $1113a0aa61ab7765$export$5bb6a0c94ad2f4bb;
var $1113a0aa61ab7765$export$a6f8654bcd49a39f = {
    prefix: 'fas',
    iconName: 'peseta-sign',
    icon: [
        384,
        512,
        [],
        "e221",
        "M64 32C46.3 32 32 46.3 32 64v96c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 96V448c0 17.7 14.3 32 32 32s32-14.3 32-32V352h96c77.4 0 142-55 156.8-128H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-3.2C334 87 269.4 32 192 32H64zM282.5 160H96V96h96c41.8 0 77.4 26.7 90.5 64zM96 224H282.5c-13.2 37.3-48.7 64-90.5 64H96V224z"
    ]
};
var $1113a0aa61ab7765$export$4805b8d175aeb9fb = {
    prefix: 'fas',
    iconName: 'heading',
    icon: [
        448,
        512,
        [
            "header"
        ],
        "f1dc",
        "M0 64C0 46.3 14.3 32 32 32H80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H112V208H336V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H400V240 416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H368 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112V416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V240 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $1113a0aa61ab7765$export$579f9604bb10a61a = $1113a0aa61ab7765$export$4805b8d175aeb9fb;
var $1113a0aa61ab7765$export$1a989eb1919c64c1 = {
    prefix: 'fas',
    iconName: 'ghost',
    icon: [
        384,
        512,
        [
            128123
        ],
        "f6e2",
        "M50.8 452.1L19.2 477.4c-2.1 1.7-4.7 2.6-7.4 2.6C5.3 480 0 474.7 0 468.2V192C0 86 86 0 192 0S384 86 384 192V468.2c0 6.5-5.3 11.8-11.8 11.8c-2.7 0-5.3-.9-7.4-2.6l-31.6-25.3c-3.3-2.7-7.5-4.1-11.8-4.1c-5.9 0-11.5 2.8-15 7.5l-37.6 50.1c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4l-38.4-51.2c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4l-38.4 51.2c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L77.6 455.5c-3.6-4.7-9.1-7.5-15-7.5c-4.3 0-8.4 1.5-11.7 4.1zM160 192c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm96 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$6cfc59842fedbc16 = {
    prefix: 'fas',
    iconName: 'list',
    icon: [
        512,
        512,
        [
            "list-squares"
        ],
        "f03a",
        "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
    ]
};
var $1113a0aa61ab7765$export$e3f160fc949c2b9d = $1113a0aa61ab7765$export$6cfc59842fedbc16;
var $1113a0aa61ab7765$export$b627121801cad756 = {
    prefix: 'fas',
    iconName: 'square-phone-flip',
    icon: [
        448,
        512,
        [
            "phone-square-alt"
        ],
        "f87b",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"
    ]
};
var $1113a0aa61ab7765$export$a41e77f0de98bba7 = $1113a0aa61ab7765$export$b627121801cad756;
var $1113a0aa61ab7765$export$6675e2bf21fdb87e = {
    prefix: 'fas',
    iconName: 'cart-plus',
    icon: [
        576,
        512,
        [],
        "f217",
        "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20V180h44c11 0 20-9 20-20s-9-20-20-20H356V96c0-11-9-20-20-20s-20 9-20 20v44H272c-11 0-20 9-20 20z"
    ]
};
var $1113a0aa61ab7765$export$6a66b1b639455bef = {
    prefix: 'fas',
    iconName: 'gamepad',
    icon: [
        640,
        512,
        [],
        "f11b",
        "M192 64C86 64 0 150 0 256S86 448 192 448H448c106 0 192-86 192-192s-86-192-192-192H192zM496 248c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40zm-24 56c0 22.1-17.9 40-40 40s-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V200z"
    ]
};
var $1113a0aa61ab7765$export$aa13d9234890e8d3 = {
    prefix: 'fas',
    iconName: 'circle-dot',
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm0-160c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96z"
    ]
};
var $1113a0aa61ab7765$export$92bc269cb244d66a = $1113a0aa61ab7765$export$aa13d9234890e8d3;
var $1113a0aa61ab7765$export$635e4d8cc8428961 = {
    prefix: 'fas',
    iconName: 'face-dizzy',
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm0-96c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $1113a0aa61ab7765$export$89a2b10dabc487e8 = $1113a0aa61ab7765$export$635e4d8cc8428961;
var $1113a0aa61ab7765$export$1199a8ce85311ab5 = {
    prefix: 'fas',
    iconName: 'egg',
    icon: [
        384,
        512,
        [
            129370
        ],
        "f7fb",
        "M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"
    ]
};
var $1113a0aa61ab7765$export$bf221f0e8296233e = {
    prefix: 'fas',
    iconName: 'house-medical-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e513",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm22.6-144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
var $1113a0aa61ab7765$export$295287303c0e9c7c = {
    prefix: 'fas',
    iconName: 'campground',
    icon: [
        576,
        512,
        [
            9978
        ],
        "f6bb",
        "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L288 60.8 249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4C4.3 415.4 0 427.7 0 440.4V464c0 26.5 21.5 48 48 48H288 528c26.5 0 48-21.5 48-48V440.4c0-12.7-4.3-25.1-12.3-35L329 112l48-60zM288 448H168.5L288 291.7 407.5 448H288z"
    ]
};
var $1113a0aa61ab7765$export$e18e05ffa2045d3b = {
    prefix: 'fas',
    iconName: 'folder-plus',
    icon: [
        512,
        512,
        [],
        "f65e",
        "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H448c35.3 0 64 28.7 64 64V416zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
    ]
};
var $1113a0aa61ab7765$export$65a345b33858a655 = {
    prefix: 'fas',
    iconName: 'futbol',
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
var $1113a0aa61ab7765$export$51a344ca0a215620 = $1113a0aa61ab7765$export$65a345b33858a655;
var $1113a0aa61ab7765$export$f4a29712c724ba2d = $1113a0aa61ab7765$export$65a345b33858a655;
var $1113a0aa61ab7765$export$7c8b56f3f296a814 = {
    prefix: 'fas',
    iconName: 'paintbrush',
    icon: [
        576,
        512,
        [
            128396,
            "paint-brush"
        ],
        "f1fc",
        "M371.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L600.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S549.7-4.4 531.1 9.6L294.4 187.2c-24 18-38.2 46.1-38.4 76.1L371.3 367.1zm-19.6 25.4l-116-104.4C175.9 290.3 128 339.6 128 400c0 3.9 .2 7.8 .6 11.6c1.8 17.5-10.2 36.4-27.8 36.4H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H240c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"
    ]
};
var $1113a0aa61ab7765$export$594db3339e212bc9 = $1113a0aa61ab7765$export$7c8b56f3f296a814;
var $1113a0aa61ab7765$export$7aa08ad5d562578a = {
    prefix: 'fas',
    iconName: 'lock',
    icon: [
        448,
        512,
        [
            128274
        ],
        "f023",
        "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"
    ]
};
var $1113a0aa61ab7765$export$84666c793cb2a347 = {
    prefix: 'fas',
    iconName: 'gas-pump',
    icon: [
        512,
        512,
        [
            9981
        ],
        "f52f",
        "M32 64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V256h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V96L384 64c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3V168v24 32V376c0 39.8-32.2 72-72 72s-72-32.2-72-72V344c0-22.1-17.9-40-40-40h-8V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64zM96 80v96c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"
    ]
};
var $1113a0aa61ab7765$export$6e6bd68568c17bbf = {
    prefix: 'fas',
    iconName: 'hot-tub-person',
    icon: [
        512,
        512,
        [
            "hot-tub"
        ],
        "f593",
        "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128c35.3 0 64-28.7 64-64S99.3 0 64 0S0 28.7 0 64s28.7 64 64 64z"
    ]
};
var $1113a0aa61ab7765$export$4842af92b516c40b = $1113a0aa61ab7765$export$6e6bd68568c17bbf;
var $1113a0aa61ab7765$export$9a8788ec0e4a9a0b = {
    prefix: 'fas',
    iconName: 'map-location',
    icon: [
        576,
        512,
        [
            "map-marked"
        ],
        "f59f",
        "M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3V152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6V503zM15.1 187.3C6 191 0 199.8 0 209.6V480.4c0 17 17.1 28.6 32.9 22.3L160 451.8V200.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49zM384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77V449.4l192 54.9V255z"
    ]
};
var $1113a0aa61ab7765$export$df04458e7e32352c = $1113a0aa61ab7765$export$9a8788ec0e4a9a0b;
var $1113a0aa61ab7765$export$70fd6006b4e54a5 = {
    prefix: 'fas',
    iconName: 'house-flood-water',
    icon: [
        576,
        512,
        [],
        "e50e",
        "M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zM269.5 309.9C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
var $1113a0aa61ab7765$export$1744430f718caf6b = {
    prefix: 'fas',
    iconName: 'tree',
    icon: [
        448,
        512,
        [
            127794
        ],
        "f1bb",
        "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320H80L5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5H192v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448H424.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"
    ]
};
var $1113a0aa61ab7765$export$cffe7d85a82d8116 = {
    prefix: 'fas',
    iconName: 'bridge-lock',
    icon: [
        640,
        512,
        [],
        "e4cc",
        "M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h-8c-61.9 0-112 50.1-112 112v24.6c-9.9 5.8-18.2 14.1-23.8 24.1c-17.6-20-43.4-32.7-72.2-32.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $1113a0aa61ab7765$export$15854c4475080853 = {
    prefix: 'fas',
    iconName: 'sack-dollar',
    icon: [
        512,
        512,
        [
            128176
        ],
        "f81d",
        "M320 96H192L144.6 24.9C137.5 14.2 145.1 0 157.9 0H354.1c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128H320c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4l0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84.1 96c0-11.1-9-20.1-20.1-20.1s-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.8 4.1c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0 0 0 0 0c-2.2-.8-4.3-1.5-6.3-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V416c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.4-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V224z"
    ]
};
var $1113a0aa61ab7765$export$ba236543926e3569 = {
    prefix: 'fas',
    iconName: 'pen-to-square',
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.8 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"
    ]
};
var $1113a0aa61ab7765$export$7be713e57d023733 = $1113a0aa61ab7765$export$ba236543926e3569;
var $1113a0aa61ab7765$export$6f7218565b1b8d0e = {
    prefix: 'fas',
    iconName: 'car-side',
    icon: [
        640,
        512,
        [
            128663
        ],
        "f5e4",
        "M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127zm-2.9 207c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32c-1.8-5-2.7-10.4-2.7-16c0-26.5 21.5-48 48-48s48 21.5 48 48c0 5.6-1 11-2.7 16zM160 432c-20.9 0-38.7-13.4-45.3-32c-1.8-5-2.7-10.4-2.7-16c0-26.5 21.5-48 48-48s48 21.5 48 48c0 5.6-1 11-2.7 16c-6.6 18.6-24.4 32-45.3 32z"
    ]
};
var $1113a0aa61ab7765$export$cdaf45d4e50ac035 = {
    prefix: 'fas',
    iconName: 'share-nodes',
    icon: [
        448,
        512,
        [
            "share-alt"
        ],
        "f1e0",
        "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
    ]
};
var $1113a0aa61ab7765$export$f8e8bb0b3aa8c658 = $1113a0aa61ab7765$export$cdaf45d4e50ac035;
var $1113a0aa61ab7765$export$24c21c3ca00f3625 = {
    prefix: 'fas',
    iconName: 'heart-circle-minus',
    icon: [
        576,
        512,
        [],
        "e4ff",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$703272eebf5e3eea = {
    prefix: 'fas',
    iconName: 'hourglass-half',
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.2 14.9H112z"
    ]
};
var $1113a0aa61ab7765$export$f1052bbf6bf361c0 = $1113a0aa61ab7765$export$703272eebf5e3eea;
var $1113a0aa61ab7765$export$6a99139787bf9967 = {
    prefix: 'fas',
    iconName: 'microscope',
    icon: [
        512,
        512,
        [
            128300
        ],
        "f610",
        "M168 32c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32h8c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32h-8c0 17.7-14.3 32-32 32H200c-17.7 0-32-14.3-32-32h-8c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32l8 0zM32 448H320c70.7 0 128-57.3 128-128s-57.3-128-128-128V128c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$2a9dda2096ce792e = {
    prefix: 'fas',
    iconName: 'sink',
    icon: [
        512,
        512,
        [],
        "e06d",
        "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96V288H160V264c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H400V264c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-30.9 0-56 25.1-56 56v24H288V96zM480 416V384H32v32c0 53 43 96 96 96H384c53 0 96-43 96-96z"
    ]
};
var $1113a0aa61ab7765$export$b0137b4600e9ab12 = {
    prefix: 'fas',
    iconName: 'bag-shopping',
    icon: [
        448,
        512,
        [
            "shopping-bag"
        ],
        "f290",
        "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 96c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm200-24c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$5745f8adbc11eb01 = $1113a0aa61ab7765$export$b0137b4600e9ab12;
var $1113a0aa61ab7765$export$cf79d63ad07d943a = {
    prefix: 'fas',
    iconName: 'arrow-down-z-a',
    icon: [
        576,
        512,
        [
            "sort-alpha-desc",
            "sort-alpha-down-alt"
        ],
        "f881",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z"
    ]
};
var $1113a0aa61ab7765$export$7caf99612a55d427 = $1113a0aa61ab7765$export$cf79d63ad07d943a;
var $1113a0aa61ab7765$export$e12d23d82d5c8a89 = $1113a0aa61ab7765$export$cf79d63ad07d943a;
var $1113a0aa61ab7765$export$5030322c5fc886d7 = {
    prefix: 'fas',
    iconName: 'mitten',
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M352 384H64L5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0h3.4c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192h2.8c34.9 0 63.3 28.3 63.3 63.3c0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V448z"
    ]
};
var $1113a0aa61ab7765$export$49577f913f0fe4d2 = {
    prefix: 'fas',
    iconName: 'person-rays',
    icon: [
        512,
        512,
        [],
        "e54d",
        "M304 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM248 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H248zM7 7C16.4-2.3 31.6-2.3 41 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
var $1113a0aa61ab7765$export$e5a8f011aef571ac = {
    prefix: 'fas',
    iconName: 'users',
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M144 160c-44.2 0-80-35.8-80-80S99.8 0 144 0s80 35.8 80 80s-35.8 80-80 80zm368 0c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM416 224c0 53-43 96-96 96s-96-43-96-96s43-96 96-96s96 43 96 96zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"
    ]
};
var $1113a0aa61ab7765$export$ed3f2918429d029a = {
    prefix: 'fas',
    iconName: 'eye-slash',
    icon: [
        640,
        512,
        [],
        "f070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zm223.1 298L373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5z"
    ]
};
var $1113a0aa61ab7765$export$a25a266ce0c95019 = {
    prefix: 'fas',
    iconName: 'flask-vial',
    icon: [
        640,
        512,
        [],
        "e4f3",
        "M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V309.9l-49 79.6zM96 64v96h64V64H96zM352 0H480h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V214.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64V224c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64H384z"
    ]
};
var $1113a0aa61ab7765$export$f69db0b876f7d753 = {
    prefix: 'fas',
    iconName: 'hand',
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32z"
    ]
};
var $1113a0aa61ab7765$export$6e6216c8b50471bb = $1113a0aa61ab7765$export$f69db0b876f7d753;
var $1113a0aa61ab7765$export$8de8eb94230028a5 = {
    prefix: 'fas',
    iconName: 'om',
    icon: [
        512,
        512,
        [
            128329
        ],
        "f679",
        "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48H109.8c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H144h16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5 0-.1c-2.6-7.8-10.7-12.3-18.7-10.5C4.4 354.2-.9 361.8 .1 370L16 368C.1 370 .1 370 .1 370l0 0 0 0 0 .1 .1 .4c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.3 0 0c0 0 0 0 0 0c-1.9-7.3-8.6-12.4-16.2-12.1c-7.6 .3-13.9 5.9-15.1 13.4L336 368c-15.8-2.6-15.8-2.6-15.8-2.6l0 0 0 0 0 .1-.1 .3c0 .3-.1 .6-.2 1.1c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96V288c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4H245.2c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4zM280.9 66.7c-6-4-14-3.5-19.5 1.3s-7 12.7-3.7 19.2L272 80c-14.3 7.2-14.3 7.2-14.3 7.2l0 0 0 0 0 .1 .1 .2 .4 .7c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .2-.2 .1-.1 0 0 0 0c0 0 0 0-22.6-22.6l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3c-12.4-12.4-32.6-12.5-45.1-.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2 0 0 0 0 0 0z"
    ]
};
var $1113a0aa61ab7765$export$2571e33fa6c25993 = {
    prefix: 'fas',
    iconName: 'worm',
    icon: [
        448,
        512,
        [],
        "e599",
        "M224 96c0-53 43-96 96-96h38.4C407.9 0 448 40.1 448 89.6V176v16V376c0 75.1-60.9 136-136 136s-136-60.9-136-136V296c0-22.1-17.9-40-40-40s-40 17.9-40 40V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V296c0-75.1 60.9-136 136-136s136 60.9 136 136v80c0 22.1 17.9 40 40 40s40-17.9 40-40V192H320c-53 0-96-43-96-96zm144-8c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $1113a0aa61ab7765$export$423555e8708eb4c7 = {
    prefix: 'fas',
    iconName: 'house-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e50b",
        "M320.7 351.7C329 262.1 404.3 192 496 192c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V480c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32V383.7c0-17.7 14.3-32 32-32h64l.7 0zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $1113a0aa61ab7765$export$cae5752c3e3b6545 = {
    prefix: 'fas',
    iconName: 'plug',
    icon: [
        384,
        512,
        [
            128268
        ],
        "f1e6",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8C297 398 352 333.4 352 256V224c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $1113a0aa61ab7765$export$877e5ae47a854215 = {
    prefix: 'fas',
    iconName: 'chevron-up',
    icon: [
        512,
        512,
        [],
        "f077",
        "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    ]
};
var $1113a0aa61ab7765$export$2262d6b626de1120 = {
    prefix: 'fas',
    iconName: 'hand-spock',
    icon: [
        576,
        512,
        [
            128406
        ],
        "f259",
        "M246.9 23.7C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L156.8 448c43.1 41.1 100.4 64 160 64h10.9 8.2c.1 0 .1-.1 .1-.1s.1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8z"
    ]
};
var $1113a0aa61ab7765$export$b85a7300fc7960b6 = {
    prefix: 'fas',
    iconName: 'stopwatch',
    icon: [
        448,
        512,
        [
            9201
        ],
        "f2f2",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H224 176zm72 192V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$5a54c83033a0a56a = {
    prefix: 'fas',
    iconName: 'face-kiss',
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM208.4 208c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$c762a77aabf64fd0 = $1113a0aa61ab7765$export$5a54c83033a0a56a;
var $1113a0aa61ab7765$export$834071278537f121 = {
    prefix: 'fas',
    iconName: 'bridge-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e4cb",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $1113a0aa61ab7765$export$95a7394c24f57943 = {
    prefix: 'fas',
    iconName: 'face-grin-tongue',
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-16c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $1113a0aa61ab7765$export$ef222816a43a4b3a = $1113a0aa61ab7765$export$95a7394c24f57943;
var $1113a0aa61ab7765$export$a831eedd2f59c62f = {
    prefix: 'fas',
    iconName: 'chess-bishop',
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V416H256V372.7c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32H128zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $1113a0aa61ab7765$export$1dd161850c5bc64e = {
    prefix: 'fas',
    iconName: 'face-grin-wink',
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 240c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$2397fcd34eb12177 = $1113a0aa61ab7765$export$1dd161850c5bc64e;
var $1113a0aa61ab7765$export$c9c5b76ec992eab4 = {
    prefix: 'fas',
    iconName: 'ear-deaf',
    icon: [
        512,
        512,
        [
            "deaf",
            "deafness",
            "hard-of-hearing"
        ],
        "f2a4",
        "M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5c-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176c0 46-17.7 87.9-46.6 119.3c-12 13-17.4 24.8-17.4 34.7V400c0 61.9-50.1 112-112 112c-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48v-6.1c0-32.9 17.4-59.6 34.4-78c18.4-20 29.6-46.6 29.6-75.9c0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"
    ]
};
var $1113a0aa61ab7765$export$4b666adf83f0de01 = $1113a0aa61ab7765$export$c9c5b76ec992eab4;
var $1113a0aa61ab7765$export$85c6a9ab2fa2631e = $1113a0aa61ab7765$export$c9c5b76ec992eab4;
var $1113a0aa61ab7765$export$ebecf90a5676e17a = $1113a0aa61ab7765$export$c9c5b76ec992eab4;
var $1113a0aa61ab7765$export$3f22db9ae9b6be1c = {
    prefix: 'fas',
    iconName: 'road-circle-check',
    icon: [
        640,
        512,
        [],
        "e564",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM640 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-76.7-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $1113a0aa61ab7765$export$d9769fb795c2db82 = {
    prefix: 'fas',
    iconName: 'dice-five',
    icon: [
        448,
        512,
        [
            9860
        ],
        "f523",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 160c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm32 160c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm64-64c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zM352 160c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM320 384c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$97d1903b1e012ff7 = {
    prefix: 'fas',
    iconName: 'square-rss',
    icon: [
        448,
        512,
        [
            "rss-square"
        ],
        "f143",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm64 120c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$89c9b1cca2c11484 = $1113a0aa61ab7765$export$97d1903b1e012ff7;
var $1113a0aa61ab7765$export$567a897fc092e403 = {
    prefix: 'fas',
    iconName: 'land-mine-on',
    icon: [
        640,
        512,
        [],
        "e51b",
        "M344 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32H192V320zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5H482.3c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512H115.8c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"
    ]
};
var $1113a0aa61ab7765$export$7fddf76ec23943d8 = {
    prefix: 'fas',
    iconName: 'i-cursor',
    icon: [
        256,
        512,
        [],
        "f246",
        "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9c21.2 24 51.2 40.1 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V128.3c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7C179.2 3.6 149.2 19.7 128 43.7c-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"
    ]
};
var $1113a0aa61ab7765$export$722e92d2d93ffc68 = {
    prefix: 'fas',
    iconName: 'stamp',
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V413.3c18.6-6.6 32-24.4 32-45.3c0-61.9-50.1-112-112-112H366.2c-29.9 0-54.2-24.3-54.2-54.2zM416 416v32H96V416H416z"
    ]
};
var $1113a0aa61ab7765$export$68b3af7444c89df7 = {
    prefix: 'fas',
    iconName: 'stairs',
    icon: [
        576,
        512,
        [],
        "e289",
        "M384 64c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v96c0 17.7-14.3 32-32 32H320v96c0 17.7-14.3 32-32 32H192v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V320c0-17.7 14.3-32 32-32h96V192c0-17.7 14.3-32 32-32h96V64z"
    ]
};
var $1113a0aa61ab7765$export$aee03ca0815b7c38 = {
    prefix: 'fas',
    iconName: 'i',
    icon: [
        320,
        512,
        [
            105
        ],
        "49",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96h96V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 32z"
    ]
};
var $1113a0aa61ab7765$export$22a9491150c64fef = {
    prefix: 'fas',
    iconName: 'hryvnia-sign',
    icon: [
        384,
        512,
        [
            8372,
            "hryvnia"
        ],
        "f6f2",
        "M121.9 116.2C138.3 103.1 158.7 96 179.6 96H223c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H155.5l-50.6 28.9c-1.7 1-3.4 2-5.1 3.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H52.3c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113h43.4c35.5 0 70-12.1 97.7-34.3L308 441c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2H161c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l50.6-28.9c1.7-1 3.4-2 5.1-3.1H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H331.7c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113H179.6c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"
    ]
};
var $1113a0aa61ab7765$export$33d5f94bd6f75f59 = $1113a0aa61ab7765$export$22a9491150c64fef;
var $1113a0aa61ab7765$export$6380e2ed6e69d350 = {
    prefix: 'fas',
    iconName: 'pills',
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 96c-26.5 0-48 21.5-48 48V256h96V144c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"
    ]
};
var $1113a0aa61ab7765$export$bdbabf493c478cde = {
    prefix: 'fas',
    iconName: 'face-grin-wide',
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM383.8 317.8c12.3-3.7 24.3 7 19.2 18.7c-24.5 56.9-81.1 96.7-147 96.7s-122.5-39.8-147-96.7c-5.1-11.8 6.9-22.4 19.2-18.7C166.7 329.4 210.1 336 256 336s89.3-6.6 127.8-18.2zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
    ]
};
var $1113a0aa61ab7765$export$b4abebfe416d36ba = $1113a0aa61ab7765$export$bdbabf493c478cde;
var $1113a0aa61ab7765$export$3a1fa2d16f90d635 = {
    prefix: 'fas',
    iconName: 'tooth',
    icon: [
        384,
        512,
        [
            129463
        ],
        "f5c9",
        "M154.1 52.1C137.3 39.1 116.7 32 95.5 32C42.7 32 0 74.7 0 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2L80.4 460.2c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C160.2 323.7 175 312 192 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"
    ]
};
var $1113a0aa61ab7765$export$6fb446f784f6b9b3 = {
    prefix: 'fas',
    iconName: 'v',
    icon: [
        448,
        512,
        [
            118
        ],
        "56",
        "M51.7 34.5c16.3-6.8 35 .9 41.8 17.2L224 364.8 354.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7l-160-384c-6.8-16.3 .9-35 17.2-41.8z"
    ]
};
var $1113a0aa61ab7765$export$469d376940e10d37 = {
    prefix: 'fas',
    iconName: 'bangladeshi-taka-sign',
    icon: [
        384,
        512,
        [],
        "e2e6",
        "M36 32.2C18.4 30.1 2.4 42.5 .2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8V160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V384c0 53 43 96 96 96h32c106 0 192-86 192-192V256c0-53-43-96-96-96H272c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c17.7 0 32 14.3 32 32v32c0 70.7-57.3 128-128 128H160c-17.7 0-32-14.3-32-32V224h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V128.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z"
    ]
};
var $1113a0aa61ab7765$export$36cb1885ad7a570f = {
    prefix: 'fas',
    iconName: 'bicycle',
    icon: [
        640,
        512,
        [
            128690
        ],
        "f206",
        "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38C191 99.7 183.7 96 176 96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zM458.6 303.7l32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368h65c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z"
    ]
};
var $1113a0aa61ab7765$export$76d998742bc186eb = {
    prefix: 'fas',
    iconName: 'staff-snake',
    icon: [
        384,
        512,
        [
            "rod-asclepius",
            "rod-snake",
            "staff-aesculapius"
        ],
        "e579",
        "M222.6 43.2l-.2 4.8H288c53 0 96 43 96 96s-43 96-96 96H248V160h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H248 220l-4.5 144H256c53 0 96 43 96 96s-43 96-96 96H240V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H213l-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31H136c-22.1 0-40-17.9-40-40s17.9-40 40-40h36l-1-32H152c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7V256c0 8.8 7.2 16 16 16h16.5L164 128H136 122.6c-9 18.9-28.3 32-50.6 32H56c-30.9 0-56-25.1-56-56S25.1 48 56 48h8 8 89.5l-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $1113a0aa61ab7765$export$f2c3e92ee37a8d89 = $1113a0aa61ab7765$export$76d998742bc186eb;
var $1113a0aa61ab7765$export$5d61dcb598296af0 = $1113a0aa61ab7765$export$76d998742bc186eb;
var $1113a0aa61ab7765$export$97c8a2cdba3b7700 = $1113a0aa61ab7765$export$76d998742bc186eb;
var $1113a0aa61ab7765$export$b293ee8fb8e6b0c4 = {
    prefix: 'fas',
    iconName: 'head-side-cough-slash',
    icon: [
        640,
        512,
        [],
        "e062",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.3 319.8c22.3-2.1 39.7-20.8 39.7-43.7c0-10-3.4-19.6-9.6-27.4l-42-52.6c-8.3-10.3-12.8-23-15-36.1C398.2 69.3 319.2 0 224 0H201.7C157 0 115.7 14.5 82.2 39.2L38.8 5.1zM0 201.7c0 44.8 18.3 91.5 46.5 127.7C56.9 342.8 64 358.8 64 375.8V480c0 17.7 14.3 32 32 32H256c17.7 0 32-14.3 32-32h64c32.8 0 59.9-24.7 63.6-56.6l-9.4-7.4H352c-17.7 0-32-14.3-32-32c0-10.5 5.1-19.9 12.9-25.7L20.8 112.4C7.5 139.3 0 169.6 0 201.7zM632 288c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zm-88 72c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm64 48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $1113a0aa61ab7765$export$fb6bd43f079f72e2 = {
    prefix: 'fas',
    iconName: 'truck-medical',
    icon: [
        640,
        512,
        [
            128657,
            "ambulance"
        ],
        "f0f9",
        "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM208 416c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zm272 48c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zM112 144c0-8.8 7.2-16 16-16h48V80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240v48c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16V192H128c-8.8 0-16-7.2-16-16V144z"
    ]
};
var $1113a0aa61ab7765$export$f5c7042778b51765 = $1113a0aa61ab7765$export$fb6bd43f079f72e2;
var $1113a0aa61ab7765$export$e23367e54f665590 = {
    prefix: 'fas',
    iconName: 'wheat-awn-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e598",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$b23df6bafb174693 = {
    prefix: 'fas',
    iconName: 'snowman',
    icon: [
        576,
        512,
        [
            9731,
            9924
        ],
        "f7d0",
        "M373.1 140.6c-2 3.9-1.6 8.6 1.2 12c7 8.5 12.9 18.1 17.2 28.4L440 160.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3c-1.2 3.8-.1 8 2.8 10.8C428.7 296.9 448 338.2 448 384c0 44.7-18.3 85-47.8 114.1c-9.9 9.7-23.7 13.9-37.5 13.9H213.3c-13.9 0-27.7-4.2-37.5-13.9C146.3 469 128 428.7 128 384c0-45.8 19.3-87.1 50.1-116.3c2.9-2.8 4-6.9 2.8-10.8c-2.7-8.7-4.3-17.9-4.8-27.3l-73.6-31.5-56-24c-12.2-5.2-17.8-19.3-12.6-31.5s19.3-17.8 31.5-12.6L88 139.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v40.2L184.6 181c4.3-10.3 10.1-19.9 17.2-28.4c2.8-3.4 3.3-8.1 1.2-12C196 127.2 192 112.1 192 96c0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM256 96c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm48 128c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm-16 80c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm16 48c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zM320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm-48 24v3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V120c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var $1113a0aa61ab7765$export$55ceb5d0c144580a = {
    prefix: 'fas',
    iconName: 'mortar-pestle',
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160H397.3L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2c-11.1 13.9-19.4 30.3-23.9 48.1C127.6 497.4 142.3 512 160 512H352c17.7 0 32.4-14.6 28.1-31.7c-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $1113a0aa61ab7765$export$f3e925217e396f44 = {
    prefix: 'fas',
    iconName: 'road-barrier',
    icon: [
        640,
        512,
        [],
        "e562",
        "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V266.3L149.2 96H64V64c0-17.7-14.3-32-32-32zM405.2 96H330.8l-5.4 10.7L234.8 288h74.3l5.4-10.7L405.2 96zM362.8 288h74.3l5.4-10.7L533.2 96H458.8l-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96H202.8zm288 192H576V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v53.7L490.8 288z"
    ]
};
var $1113a0aa61ab7765$export$51e9b8434982947d = {
    prefix: 'fas',
    iconName: 'school',
    icon: [
        640,
        512,
        [
            127979
        ],
        "f549",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM256 416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H256V416zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16z"
    ]
};
var $1113a0aa61ab7765$export$4a284575edd6f1af = {
    prefix: 'fas',
    iconName: 'igloo',
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.8V160H48.5C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160V39.1C424.9 55.7 487.2 99.8 527.5 160H352zM29.9 192H96V320H0c0-46 10.8-89.4 29.9-128zM192 320H128V192H448V320H384v32H576v80c0 26.5-21.5 48-48 48H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64V480H48c-26.5 0-48-21.5-48-48V352H192V320zm288 0V192h66.1c19.2 38.6 29.9 82 29.9 128H480z"
    ]
};
var $1113a0aa61ab7765$export$e5a289fb22ffb8cb = {
    prefix: 'fas',
    iconName: 'joint',
    icon: [
        640,
        512,
        [],
        "f595",
        "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43V32zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11zM229.8 360c-4.7-2.3-10-2.7-15.2-2c-37.8 5.6-75.2 14.3-106.9 22.8C81.3 388 58.3 395.1 42 400.4c-8.2 2.7-14.7 4.9-19.2 6.5c-2.3 .8-4 1.4-5.2 1.8l-1.3 .5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3 .5c1.2 .4 3 1.1 5.2 1.8c4.5 1.6 11 3.8 19.2 6.5c16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512h19 51.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352H336 288c-1.1 0-2.3 0-3.4 0c-4.1 0-6.2 5.1-3.5 8.3L383.5 483.2C398.7 501.5 421.2 512 445 512zm-3.9-151.7L543.5 483.2c14.6 17.5 35.9 27.9 58.6 28.7c21.1-1.1 37.9-18.6 37.9-39.9V392c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z"
    ]
};
var $1113a0aa61ab7765$export$6bce1afb61f2eb66 = {
    prefix: 'fas',
    iconName: 'angle-right',
    icon: [
        320,
        512,
        [
            8250
        ],
        "f105",
        "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
    ]
};
var $1113a0aa61ab7765$export$5b05f097fa38352a = {
    prefix: 'fas',
    iconName: 'horse',
    icon: [
        576,
        512,
        [
            128014
        ],
        "f6f0",
        "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128H224 203.2 148.8c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 96c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16z"
    ]
};
var $1113a0aa61ab7765$export$5a2b164552deda9f = {
    prefix: 'fas',
    iconName: 'q',
    icon: [
        512,
        512,
        [
            113
        ],
        "51",
        "M96 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C403.9 325.8 416 292.3 416 256c0-88.4-71.6-160-160-160S96 167.6 96 256zM376.9 444.6C342 467 300.5 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"
    ]
};
var $1113a0aa61ab7765$export$9f5c2b0db8eedeac = {
    prefix: 'fas',
    iconName: 'g',
    icon: [
        448,
        512,
        [
            103
        ],
        "47",
        "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32c0 123.7-100.3 224-224 224S0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"
    ]
};
var $1113a0aa61ab7765$export$b2d79133c81d6697 = {
    prefix: 'fas',
    iconName: 'notes-medical',
    icon: [
        512,
        512,
        [],
        "f481",
        "M96 352V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V293.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7H160c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16H272zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88H296z"
    ]
};
var $1113a0aa61ab7765$export$a3f1d7f13c202adc = {
    prefix: 'fas',
    iconName: 'temperature-half',
    icon: [
        320,
        512,
        [
            127777,
            "temperature-2",
            "thermometer-2",
            "thermometer-half"
        ],
        "f2c9",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V200c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $1113a0aa61ab7765$export$8176e649df45b32c = $1113a0aa61ab7765$export$a3f1d7f13c202adc;
var $1113a0aa61ab7765$export$4dd764ac8d512682 = $1113a0aa61ab7765$export$a3f1d7f13c202adc;
var $1113a0aa61ab7765$export$2090f040324b4449 = $1113a0aa61ab7765$export$a3f1d7f13c202adc;
var $1113a0aa61ab7765$export$18659308f17918a5 = {
    prefix: 'fas',
    iconName: 'dong-sign',
    icon: [
        384,
        512,
        [],
        "e169",
        "M288 32c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V288 128c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM256 288c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $1113a0aa61ab7765$export$ba6fd4a436804a48 = {
    prefix: 'fas',
    iconName: 'capsules',
    icon: [
        576,
        512,
        [],
        "f46b",
        "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256H64V144zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"
    ]
};
var $1113a0aa61ab7765$export$48a38da471b097a2 = {
    prefix: 'fas',
    iconName: 'poo-storm',
    icon: [
        448,
        512,
        [
            "poo-bolt"
        ],
        "f75a",
        "M236.9 .2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1c0 44.3-35.8 80.1-80 80.1c-1.4 0-2.8 .2-4 .5H128c-35.3 0-64 28.7-64 64c0 12.4 3.5 24 9.7 33.8C31.6 234.3 0 271.5 0 316c0 49.1 38.5 89.2 86.9 91.9c-1.8-2.9-3.4-6.1-4.5-9.4c-6-17.5-.5-36.9 13.6-48.5L238.2 233.6c15.6-12.8 37.9-12.7 53.5 .1s20.3 35.1 11.3 53.4l-26 53.2h16.3c18.1 0 34.3 11.7 40.3 29.2c4.5 13.1 2.6 27.3-4.6 38.4h27c50.8 0 92-41.2 92-92c0-44.5-31.6-81.7-73.7-90.2c6.1-9.8 9.7-21.4 9.7-33.8c0-35.3-28.7-64-64-64h-5.7c3.7-10.2 5.7-21.1 5.7-32.6c0-48.7-36.1-88.9-83.1-95.2zm34.2 259.2c-6-4.6-14.3-4.4-20.1 .4l-133.4 112c-5.2 4.3-7 11.4-4.7 17.7s8.3 10.5 15 10.5h54.7l-42.5 89.1c-3.2 6.8-1.3 14.9 4.7 19.5s14.3 4.4 20.1-.4l133.4-112c5.1-4.3 7-11.4 4.7-17.7s-8.3-10.5-15-10.5H233.3l42.5-89.1c3.2-6.8 1.3-14.9-4.7-19.5z"
    ]
};
var $1113a0aa61ab7765$export$9a24e77f74d9cbd9 = $1113a0aa61ab7765$export$48a38da471b097a2;
var $1113a0aa61ab7765$export$c8a28356e07b9ccb = {
    prefix: 'fas',
    iconName: 'face-frown-open',
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM176.4 240c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm-186 174.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"
    ]
};
var $1113a0aa61ab7765$export$c4775e66bed5d96 = $1113a0aa61ab7765$export$c8a28356e07b9ccb;
var $1113a0aa61ab7765$export$cdc9f5e7e94e76da = {
    prefix: 'fas',
    iconName: 'hand-point-up',
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
    ]
};
var $1113a0aa61ab7765$export$608138a7337b5d1a = {
    prefix: 'fas',
    iconName: 'money-bill',
    icon: [
        576,
        512,
        [],
        "f0d6",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 352c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96z"
    ]
};
var $1113a0aa61ab7765$export$4ed9da5c3cca0ef1 = {
    prefix: 'fas',
    iconName: 'bookmark',
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"
    ]
};
var $1113a0aa61ab7765$export$97c42b56d462df72 = {
    prefix: 'fas',
    iconName: 'align-justify',
    icon: [
        448,
        512,
        [],
        "f039",
        "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$20932e4d438e4e4c = {
    prefix: 'fas',
    iconName: 'umbrella-beach',
    icon: [
        576,
        512,
        [
            127958
        ],
        "f5ca",
        "M346.3 271.8l-60.1-21.9L214 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H282.1l64.1-176.2zm121.1-.2l-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4c6.5-78.5-23.9-155.5-80.8-208.5c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM107.2 112.9c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2c-79.6 2.5-154.7 42.2-201.2 108z"
    ]
};
var $1113a0aa61ab7765$export$5e975cb293c48461 = {
    prefix: 'fas',
    iconName: 'helmet-un',
    icon: [
        512,
        512,
        [],
        "e503",
        "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384H200h14.9L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H369.5l-1.5-1.5V288h80 32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.5zM320 417.2l-78-73.7L274.4 288H320V417.2zM285.3 103.1l34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$554720e3bf74fe90 = {
    prefix: 'fas',
    iconName: 'bullseye',
    icon: [
        512,
        512,
        [],
        "f140",
        "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192s192-86 192-192zm64 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM256 336c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zm0 64c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm32-144c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$ab07061fe21a3a8e = {
    prefix: 'fas',
    iconName: 'bacon',
    icon: [
        576,
        512,
        [
            129363
        ],
        "f7e5",
        "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6l0 0 .2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"
    ]
};
var $1113a0aa61ab7765$export$f6dcbf0a940428f4 = {
    prefix: 'fas',
    iconName: 'hand-point-down',
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32V272H32V480zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-64 64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0H162.3C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72z"
    ]
};
var $1113a0aa61ab7765$export$c2af1be14cd87640 = {
    prefix: 'fas',
    iconName: 'arrow-up-from-bracket',
    icon: [
        448,
        512,
        [],
        "e09a",
        "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 53 43 96 96 96H352c53 0 96-43 96-96V352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352z"
    ]
};
var $1113a0aa61ab7765$export$72b780186370e953 = {
    prefix: 'fas',
    iconName: 'folder',
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
    ]
};
var $1113a0aa61ab7765$export$9ef114244d26da0 = $1113a0aa61ab7765$export$72b780186370e953;
var $1113a0aa61ab7765$export$5e0c19cf315ac1bf = {
    prefix: 'fas',
    iconName: 'file-waveform',
    icon: [
        384,
        512,
        [
            "file-medical-alt"
        ],
        "f478",
        "M64 0C28.7 0 0 28.7 0 64V288H112c6.1 0 11.6 3.4 14.3 8.8L144 332.2l49.7-99.4c2.7-5.4 8.2-8.8 14.3-8.8s11.6 3.4 14.3 8.8L249.9 288H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8L208 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L102.1 320H0V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0z"
    ]
};
var $1113a0aa61ab7765$export$ef02a0f5b39aa61f = $1113a0aa61ab7765$export$5e0c19cf315ac1bf;
var $1113a0aa61ab7765$export$4c4e509518093d6d = {
    prefix: 'fas',
    iconName: 'radiation',
    icon: [
        512,
        512,
        [],
        "f7b9",
        "M216 186.7c-23.9 13.8-40 39.7-40 69.3L32 256C14.3 256-.2 241.6 2 224.1C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9c-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80l-144 0c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10c53.6 40.7 90.6 102 99.4 172.1c2.2 17.5-12.4 31.9-30 31.9zM256 304c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $1113a0aa61ab7765$export$8760a1de19ea40b9 = {
    prefix: 'fas',
    iconName: 'chart-simple',
    icon: [
        448,
        512,
        [],
        "e473",
        "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
    ]
};
var $1113a0aa61ab7765$export$aa05fce255a5d269 = {
    prefix: 'fas',
    iconName: 'mars-stroke',
    icon: [
        512,
        512,
        [
            9894
        ],
        "f229",
        "M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H376zm88 48h0v0l0 0zM320 304c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112z"
    ]
};
var $1113a0aa61ab7765$export$aa014b06d2d70598 = {
    prefix: 'fas',
    iconName: 'vial',
    icon: [
        512,
        512,
        [
            129514
        ],
        "f492",
        "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5V416c0 53 43 96 96 96h5.5c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256L352 109.3 402.7 160l-96 96H205.3z"
    ]
};
var $1113a0aa61ab7765$export$dbfb0a9f89ad94a4 = {
    prefix: 'fas',
    iconName: 'gauge',
    icon: [
        512,
        512,
        [
            "dashboard",
            "gauge-med",
            "tachometer-alt-average"
        ],
        "f624",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM320 352c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm-16 80c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm288 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM400 144c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$b7ce24136743d0f1 = $1113a0aa61ab7765$export$dbfb0a9f89ad94a4;
var $1113a0aa61ab7765$export$f948a9dd257979f3 = $1113a0aa61ab7765$export$dbfb0a9f89ad94a4;
var $1113a0aa61ab7765$export$6f22c345e5a92d1a = $1113a0aa61ab7765$export$dbfb0a9f89ad94a4;
var $1113a0aa61ab7765$export$5325fc72e75360b4 = {
    prefix: 'fas',
    iconName: 'wand-magic-sparkles',
    icon: [
        576,
        512,
        [
            "magic-wand-sparkles"
        ],
        "e2ca",
        "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
    ]
};
var $1113a0aa61ab7765$export$c93286938249f0da = $1113a0aa61ab7765$export$5325fc72e75360b4;
var $1113a0aa61ab7765$export$86923e6fe1b42f5e = {
    prefix: 'fas',
    iconName: 'e',
    icon: [
        320,
        512,
        [
            101
        ],
        "45",
        "M32 32C14.3 32 0 46.3 0 64V256 448c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $1113a0aa61ab7765$export$eff4bdcafd3b8d1c = {
    prefix: 'fas',
    iconName: 'pen-clip',
    icon: [
        512,
        512,
        [
            "pen-alt"
        ],
        "f305",
        "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1 0 0-1-1 0 0-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"
    ]
};
var $1113a0aa61ab7765$export$a3d3e92e430d3beb = $1113a0aa61ab7765$export$eff4bdcafd3b8d1c;
var $1113a0aa61ab7765$export$4f25939fdf728c27 = {
    prefix: 'fas',
    iconName: 'bridge-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e4ca",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$f5699fa0844e0188 = {
    prefix: 'fas',
    iconName: 'user',
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"
    ]
};
var $1113a0aa61ab7765$export$c8c95c2f9937bf6a = {
    prefix: 'fas',
    iconName: 'school-circle-check',
    icon: [
        640,
        512,
        [],
        "e56b",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"
    ]
};
var $1113a0aa61ab7765$export$3b934e22d1851a3b = {
    prefix: 'fas',
    iconName: 'dumpster',
    icon: [
        576,
        512,
        [],
        "f793",
        "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0H428.5L402.9 32H304V160zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l25.6 128zM32 192l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H448c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32H32z"
    ]
};
var $1113a0aa61ab7765$export$ecbd233b96906ee1 = {
    prefix: 'fas',
    iconName: 'van-shuttle',
    icon: [
        640,
        512,
        [
            128656,
            "shuttle-van"
        ],
        "f5b6",
        "M64 104v88h96V96H72c-4.4 0-8 3.6-8 8zm482 88L465.1 96H384v96H546zm-226 0V96H224v96h96zM592 384H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V104C0 64.2 32.2 32 72 32H192 352 465.1c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2V336c0 26.5-21.5 48-48 48zm-64 0c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM160 432c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $1113a0aa61ab7765$export$9d63d851db698c09 = $1113a0aa61ab7765$export$ecbd233b96906ee1;
var $1113a0aa61ab7765$export$d65aef1ed7db1dae = {
    prefix: 'fas',
    iconName: 'building-user',
    icon: [
        640,
        512,
        [],
        "e4da",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM576 272c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80s80-35.8 80-80zM352 477.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
var $1113a0aa61ab7765$export$2c5163541229363 = {
    prefix: 'fas',
    iconName: 'square-caret-left',
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
var $1113a0aa61ab7765$export$d0c8ba444f1f9581 = $1113a0aa61ab7765$export$2c5163541229363;
var $1113a0aa61ab7765$export$73801ed54b42fabe = {
    prefix: 'fas',
    iconName: 'highlighter',
    icon: [
        576,
        512,
        [],
        "f591",
        "M331 315l158.4-215L460.1 70.6 245 229 331 315zm-187 5l0 0V248.3c0-15.3 7.2-29.6 19.5-38.6L436.6 8.4C444 2.9 453 0 462.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L350.4 396.5c-9 12.3-23.4 19.5-38.6 19.5H240l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L144 320zM23 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H40c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"
    ]
};
var $1113a0aa61ab7765$export$fa6ecc35e7315db = {
    prefix: 'fas',
    iconName: 'key',
    icon: [
        512,
        512,
        [
            128273
        ],
        "f084",
        "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zm40-176c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40z"
    ]
};
var $1113a0aa61ab7765$export$dacae2b4ec565333 = {
    prefix: 'fas',
    iconName: 'bullhorn',
    icon: [
        512,
        512,
        [
            128226,
            128363
        ],
        "f0a1",
        "M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192 160 64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352l8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4V32zm-64 76.7V240 371.3C357.2 317.8 280.5 288 200.7 288H192V192h8.7c79.8 0 156.5-29.8 215.3-83.3z"
    ]
};
var $1113a0aa61ab7765$export$b1b1cdce4a19c682 = {
    prefix: 'fas',
    iconName: 'globe',
    icon: [
        512,
        512,
        [
            127760
        ],
        "f0ac",
        "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 21 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"
    ]
};
var $1113a0aa61ab7765$export$20d991385719b5b4 = {
    prefix: 'fas',
    iconName: 'synagogue',
    icon: [
        640,
        512,
        [
            128333
        ],
        "f69b",
        "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166V280.1 512H464 352V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H176 160V280.1 166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM512 512V244.5l28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1V448c0 35.3-28.7 64-64 64H512zM128 244.5V512H64c-35.3 0-64-28.7-64-64V316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3L128 244.5zM327 124.3c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1L274.3 192l-16.4 27.8c-3.2 5.4 .7 12.1 7 12.1l32.3-.3L313 259.7c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3 .3c6.2 .1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3 .3L327 124.3z"
    ]
};
var $1113a0aa61ab7765$export$f3d75c19191f1688 = {
    prefix: 'fas',
    iconName: 'person-half-dress',
    icon: [
        320,
        512,
        [],
        "e548",
        "M160 96c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zm8 256V128h6.9c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h0zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3V384h0v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"
    ]
};
var $1113a0aa61ab7765$export$4d6835e7175dec24 = {
    prefix: 'fas',
    iconName: 'road-bridge',
    icon: [
        640,
        512,
        [],
        "e563",
        "M352 0H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM480 200c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V384zM480 40c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zM32 96H288v64H248v64h40v96c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416c0-53-43-96-96-96V224H72V160H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64H120v64h80V160z"
    ]
};
var $1113a0aa61ab7765$export$4ac9c4c370f7b157 = {
    prefix: 'fas',
    iconName: 'location-arrow',
    icon: [
        448,
        512,
        [],
        "f124",
        "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"
    ]
};
var $1113a0aa61ab7765$export$a2c1c457834fc6d8 = {
    prefix: 'fas',
    iconName: 'c',
    icon: [
        384,
        512,
        [
            99
        ],
        "43",
        "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
    ]
};
var $1113a0aa61ab7765$export$2d33c367b2b091ac = {
    prefix: 'fas',
    iconName: 'tablet-button',
    icon: [
        448,
        512,
        [],
        "f10a",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 464c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$6f08294ba8a2459c = {
    prefix: 'fas',
    iconName: 'building-lock',
    icon: [
        576,
        512,
        [],
        "e4d6",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h88.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-30.5 12.2-58.2 32-78.4V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $1113a0aa61ab7765$export$c9f93c4667edc585 = {
    prefix: 'fas',
    iconName: 'pizza-slice',
    icon: [
        512,
        512,
        [],
        "f818",
        "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80c.5 0 1.1 0 1.6 0c176.7 0 320 143.3 320 320c0 .5 0 1.1 0 1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM399.8 410.2c.1-3.4 .2-6.8 .2-10.2c0-159.1-128.9-288-288-288c-3.4 0-6.8 .1-10.2 .2L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L399.8 410.2zM176 272c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm128 64c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM160 384c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$53e23123cc9a6796 = {
    prefix: 'fas',
    iconName: 'money-bill-wave',
    icon: [
        576,
        512,
        [],
        "f53a",
        "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"
    ]
};
var $1113a0aa61ab7765$export$2acab8312b7a999b = {
    prefix: 'fas',
    iconName: 'chart-area',
    icon: [
        512,
        512,
        [
            "area-chart"
        ],
        "f1fe",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm96 288H448c17.7 0 32-14.3 32-32V251.8c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$fc2e595f0e0612cb = $1113a0aa61ab7765$export$2acab8312b7a999b;
var $1113a0aa61ab7765$export$9a3d31c75a465b9a = {
    prefix: 'fas',
    iconName: 'house-flag',
    icon: [
        640,
        512,
        [],
        "e50d",
        "M480 0c-17.7 0-32 14.3-32 32V192 512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512c0-17.7-14.3-32-32-32zM416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288H64V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.7l.2 0h-1V159z"
    ]
};
var $1113a0aa61ab7765$export$d7ccc6651f90f7cc = {
    prefix: 'fas',
    iconName: 'person-circle-minus',
    icon: [
        576,
        512,
        [],
        "e540",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm424 16c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-64 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
    ]
};
var $1113a0aa61ab7765$export$76f704d256def3c7 = {
    prefix: 'fas',
    iconName: 'ban',
    icon: [
        512,
        512,
        [
            128683,
            "cancel"
        ],
        "f05e",
        "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
    ]
};
var $1113a0aa61ab7765$export$6d25ef56192f6d69 = $1113a0aa61ab7765$export$76f704d256def3c7;
var $1113a0aa61ab7765$export$e0ce7d1aba7105e7 = {
    prefix: 'fas',
    iconName: 'camera-rotate',
    icon: [
        512,
        512,
        [],
        "e0d8",
        "M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM384 256c0 8.8-7.2 16-16 16H291.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L307 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L185 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C193.4 172.7 224 160 256 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM128 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L205 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L327 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C318.6 403.3 288 416 256 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z"
    ]
};
var $1113a0aa61ab7765$export$43832c90c10a7a31 = {
    prefix: 'fas',
    iconName: 'spray-can-sparkles',
    icon: [
        512,
        512,
        [
            "air-freshener"
        ],
        "f5d0",
        "M96 32v96H224V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32zm0 128c-53 0-96 43-96 96V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96H96zm64 256c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"
    ]
};
var $1113a0aa61ab7765$export$a5e63e89b5ccee83 = $1113a0aa61ab7765$export$43832c90c10a7a31;
var $1113a0aa61ab7765$export$a3b0eb2cd7942125 = {
    prefix: 'fas',
    iconName: 'star',
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
    ]
};
var $1113a0aa61ab7765$export$cb8434288c91ae83 = {
    prefix: 'fas',
    iconName: 'repeat',
    icon: [
        512,
        512,
        [
            128257
        ],
        "f363",
        "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z"
    ]
};
var $1113a0aa61ab7765$export$9d0a89fcd084abb = {
    prefix: 'fas',
    iconName: 'cross',
    icon: [
        384,
        512,
        [
            128327,
            10013
        ],
        "f654",
        "M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H256V48c0-26.5-21.5-48-48-48H176z"
    ]
};
var $1113a0aa61ab7765$export$6e7cf270cda52323 = {
    prefix: 'fas',
    iconName: 'box',
    icon: [
        448,
        512,
        [
            128230
        ],
        "f466",
        "M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm208 32H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192z"
    ]
};
var $1113a0aa61ab7765$export$63f2d9e5f4689aa8 = {
    prefix: 'fas',
    iconName: 'venus-mars',
    icon: [
        640,
        512,
        [
            9892
        ],
        "f228",
        "M176 288c61.9 0 112-50.1 112-112s-50.1-112-112-112S64 114.1 64 176s50.1 112 112 112zM352 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H208v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0H616c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"
    ]
};
var $1113a0aa61ab7765$export$e4f903bc63db445 = {
    prefix: 'fas',
    iconName: 'arrow-pointer',
    icon: [
        320,
        512,
        [
            "mouse-pointer"
        ],
        "f245",
        "M0 55.2V426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H297.9c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"
    ]
};
var $1113a0aa61ab7765$export$2e19a69cc26b147 = $1113a0aa61ab7765$export$e4f903bc63db445;
var $1113a0aa61ab7765$export$8d2b1b230601e804 = {
    prefix: 'fas',
    iconName: 'maximize',
    icon: [
        448,
        512,
        [
            "expand-arrows-alt"
        ],
        "f31e",
        "M168 32H24C10.7 32 0 42.7 0 56V200c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79L81 335 41 295c-6.9-6.9-17.2-8.9-26.2-5.2S0 302.3 0 312V456c0 13.3 10.7 24 24 24H168c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H424c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H280c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S177.7 32 168 32z"
    ]
};
var $1113a0aa61ab7765$export$6219dcd88b5fa6c2 = $1113a0aa61ab7765$export$8d2b1b230601e804;
var $1113a0aa61ab7765$export$bab2cd86f8c65657 = {
    prefix: 'fas',
    iconName: 'charging-station',
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M96 0C60.7 0 32 28.7 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320V64c0-35.3-28.7-64-64-64H96zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"
    ]
};
var $1113a0aa61ab7765$export$b17d50542d1fc340 = {
    prefix: 'fas',
    iconName: 'shapes',
    icon: [
        512,
        512,
        [
            "triangle-circle-square"
        ],
        "f61f",
        "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2H384c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312V456c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zM128 512c70.7 0 128-57.3 128-128s-57.3-128-128-128S0 313.3 0 384s57.3 128 128 128z"
    ]
};
var $1113a0aa61ab7765$export$34261e5aea24fc1d = $1113a0aa61ab7765$export$b17d50542d1fc340;
var $1113a0aa61ab7765$export$ee94b652453ad208 = {
    prefix: 'fas',
    iconName: 'shuffle',
    icon: [
        512,
        512,
        [
            128256,
            "random"
        ],
        "f074",
        "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"
    ]
};
var $1113a0aa61ab7765$export$8357bf8cc666d5f0 = $1113a0aa61ab7765$export$ee94b652453ad208;
var $1113a0aa61ab7765$export$f48814ae62850c74 = {
    prefix: 'fas',
    iconName: 'person-running',
    icon: [
        448,
        512,
        [
            127939,
            "running"
        ],
        "f70c",
        "M336 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM141.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L153.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L254 299l30.9-82.4 5.1 12.3C305 264.7 339.9 288 378.7 288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H378.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L73.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM107.2 352H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L173 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L107.2 352z"
    ]
};
var $1113a0aa61ab7765$export$5dfd1cb43dc9eadb = $1113a0aa61ab7765$export$f48814ae62850c74;
var $1113a0aa61ab7765$export$7955f08360418647 = {
    prefix: 'fas',
    iconName: 'mobile-retro',
    icon: [
        320,
        512,
        [],
        "e527",
        "M0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 96v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 352c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm24 56c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zm56-56c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm24 56c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zm56-56c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm24 56c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"
    ]
};
var $1113a0aa61ab7765$export$523960de087f5198 = {
    prefix: 'fas',
    iconName: 'grip-lines-vertical',
    icon: [
        192,
        512,
        [],
        "f7a5",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"
    ]
};
var $1113a0aa61ab7765$export$6daa96b1986e2ef0 = {
    prefix: 'fas',
    iconName: 'spider',
    icon: [
        576,
        512,
        [
            128375
        ],
        "f717",
        "M190.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L113.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4-80.4-26.8c-2.4-.8-4.3-2.7-5.1-5.1L78.8 128.4C74.6 115.8 61 109 48.4 113.2S29 131 33.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L148.1 256 87.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L33.2 368.4C29 381 35.8 394.6 48.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8-57.4 57.4c-15.6 15.6-20.6 39-12.7 59.7l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L192 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L462.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L427.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L430.4 15.4C425.6 3 411.8-3.2 399.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L368 174.1V160c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16V101.2c0-10.1-9.4-17.7-18.5-13.4C226.6 100.7 208 128.2 208 160v14.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"
    ]
};
var $1113a0aa61ab7765$export$740142a89118fbc0 = {
    prefix: 'fas',
    iconName: 'hands-bound',
    icon: [
        576,
        512,
        [],
        "e4f9",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V96v59.1 .7V192v21.9c0 14.2 5.1 27.9 14.3 38.7L99.6 352H96c-13.3 0-24 10.7-24 24s10.7 24 24 24h32H256h64H448h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-3.6l85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7V192 155.8v-.7V96 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96v48.8l-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L441 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C329 209.7 320 233.4 320 258.1V320v32H256V320 258.1c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L64 144.8V96 32zm64 448v32H256V480h64v32H448V480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H448 320 256 128 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h32z"
    ]
};
var $1113a0aa61ab7765$export$a3dced32d48cb1ea = {
    prefix: 'fas',
    iconName: 'file-invoice-dollar',
    icon: [
        384,
        512,
        [],
        "f571",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$f201ba865ea1b8dc = {
    prefix: 'fas',
    iconName: 'plane-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e556",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$8cf137aceaaf4de0 = {
    prefix: 'fas',
    iconName: 'x-ray',
    icon: [
        512,
        512,
        [],
        "f497",
        "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16v16H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H240v32H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v32H152c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l32 48C168.5 412 176 416 184 416H328c8 0 15.5-4 20-10.7l32-48c4.9-7.4 5.4-16.8 1.2-24.6S368.9 320 360 320H272V288h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V224H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16zM208 384c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm112-16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$761e747b06ed2e1f = {
    prefix: 'fas',
    iconName: 'spell-check',
    icon: [
        640,
        512,
        [],
        "f891",
        "M144 0c-12.9 0-24.6 7.8-29.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L98.7 224h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C168.6 7.8 156.9 0 144 0zm18.7 160H125.3L144 115.2 162.7 160zM288 32v96 96c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80H320c-17.7 0-32 14.3-32 32zm96 64H352V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H352V160zM598.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L384 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"
    ]
};
var $1113a0aa61ab7765$export$f54d004dd5f1cb5e = {
    prefix: 'fas',
    iconName: 'slash',
    icon: [
        640,
        512,
        [],
        "f715",
        "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"
    ]
};
var $1113a0aa61ab7765$export$72cf138e5ddda6eb = {
    prefix: 'fas',
    iconName: 'computer-mouse',
    icon: [
        384,
        512,
        [
            128433,
            "mouse"
        ],
        "f8cc",
        "M0 192H176V0H160C71.6 0 0 71.6 0 160v32zm0 32V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H192 0zm384-32V160C384 71.6 312.4 0 224 0H208V192H384z"
    ]
};
var $1113a0aa61ab7765$export$198b96b894c66074 = $1113a0aa61ab7765$export$72cf138e5ddda6eb;
var $1113a0aa61ab7765$export$a02c5909359525be = {
    prefix: 'fas',
    iconName: 'arrow-right-to-bracket',
    icon: [
        512,
        512,
        [
            "sign-in"
        ],
        "f090",
        "M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $1113a0aa61ab7765$export$a55eff0ca4f9c3df = $1113a0aa61ab7765$export$a02c5909359525be;
var $1113a0aa61ab7765$export$b3d636689da4a3e5 = {
    prefix: 'fas',
    iconName: 'shop-slash',
    icon: [
        640,
        512,
        [
            "store-alt-slash"
        ],
        "e070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224H512V376L384 275.7V224H320v1.5L277.2 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L74.1 32.8 38.8 5.1zM36.8 192h85L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V398.5l-64-50.4V384z"
    ]
};
var $1113a0aa61ab7765$export$b932a586f6ff48b4 = $1113a0aa61ab7765$export$b3d636689da4a3e5;
var $1113a0aa61ab7765$export$1bf820d499b6202e = {
    prefix: 'fas',
    iconName: 'server',
    icon: [
        512,
        512,
        [],
        "f233",
        "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM344 152c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm96-24c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zM344 408c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm104-24c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$61c2a6b698f55df6 = {
    prefix: 'fas',
    iconName: 'virus-covid-slash',
    icon: [
        640,
        512,
        [],
        "e4a9",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zM149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5H112V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2L149.2 213.5z"
    ]
};
var $1113a0aa61ab7765$export$452410c103c2403b = {
    prefix: 'fas',
    iconName: 'shop-lock',
    icon: [
        640,
        512,
        [],
        "e4a5",
        "M36.8 192H449.6c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224H320V384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 352 224zm144 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $1113a0aa61ab7765$export$f0c28584caa8f4b = {
    prefix: 'fas',
    iconName: 'hourglass-start',
    icon: [
        384,
        512,
        [
            "hourglass-1"
        ],
        "f251",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM288 437v11H96V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9z"
    ]
};
var $1113a0aa61ab7765$export$87929336ab5c59cd = $1113a0aa61ab7765$export$f0c28584caa8f4b;
var $1113a0aa61ab7765$export$f35a116a762ef8fc = {
    prefix: 'fas',
    iconName: 'blender-phone',
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M192 352V48c0-26.5 21.5-48 48-48H534.1c21.1 0 36.4 20.1 30.9 40.4L558.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H549.8l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H523.6l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L480 352H192zm16 32H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2z"
    ]
};
var $1113a0aa61ab7765$export$6c0cfe6d58faf860 = {
    prefix: 'fas',
    iconName: 'building-wheat',
    icon: [
        640,
        512,
        [],
        "e4db",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm384 80v16c0 44.2-35.8 80-80 80H544V272c0-44.2 35.8-80 80-80h16zm0 128c0 44.2-35.8 80-80 80H544V384c0-44.2 35.8-80 80-80h16v16zm0 112c0 44.2-35.8 80-80 80H544V496c0-44.2 35.8-80 80-80h16v16zM512 496v16H496c-44.2 0-80-35.8-80-80V416h16c44.2 0 80 35.8 80 80zm0-96H496c-44.2 0-80-35.8-80-80V304h16c44.2 0 80 35.8 80 80v16zm0-128v16H496c-44.2 0-80-35.8-80-80V192h16c44.2 0 80 35.8 80 80zM528 32c13.3 0 24 10.7 24 24V160c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm96 64v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24z"
    ]
};
var $1113a0aa61ab7765$export$9b94ed8d16d281f9 = {
    prefix: 'fas',
    iconName: 'person-breastfeeding',
    icon: [
        512,
        512,
        [],
        "e53a",
        "M256 160c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80zM468.8 382.8L405.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.7-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L59.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2l67.1-100.6c26.7-40.1 71.7-64.1 119.8-64.1h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM352 332c0-24.3-19.7-44-44-44s-44 19.7-44 44s19.7 44 44 44s44-19.7 44-44z"
    ]
};
var $1113a0aa61ab7765$export$a5fd2acfcb5247c6 = {
    prefix: 'fas',
    iconName: 'right-to-bracket',
    icon: [
        512,
        512,
        [
            "sign-in-alt"
        ],
        "f2f6",
        "M352 96h64c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96-43 96-96V128c0-53-43-96-96-96H352c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-7.5 177.4c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22v72H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H160v72c0 9.6 5.7 18.2 14.5 22s19 2 26-4.6l144-136z"
    ]
};
var $1113a0aa61ab7765$export$e6709746115bd2ea = $1113a0aa61ab7765$export$a5fd2acfcb5247c6;
var $1113a0aa61ab7765$export$f89d028573ffc0a6 = {
    prefix: 'fas',
    iconName: 'venus',
    icon: [
        384,
        512,
        [
            9792
        ],
        "f221",
        "M304 176c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"
    ]
};
var $1113a0aa61ab7765$export$2c31ca0d9bee400f = {
    prefix: 'fas',
    iconName: 'passport',
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8H279.6zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8H129.3c5.3-31.4 25.8-57.6 53.7-70.8zM352 192c0-70.7-57.3-128-128-128S96 121.3 96 192s57.3 128 128 128s128-57.3 128-128zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var $1113a0aa61ab7765$export$a6d8e50dcd4b4294 = {
    prefix: 'fas',
    iconName: 'heart-pulse',
    icon: [
        512,
        512,
        [
            "heartbeat"
        ],
        "f21e",
        "M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31H476.3c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 16.9-2.8 33.5-8.3 49.1z"
    ]
};
var $1113a0aa61ab7765$export$ca880e19206e80aa = $1113a0aa61ab7765$export$a6d8e50dcd4b4294;
var $1113a0aa61ab7765$export$7754cc6d5559ff38 = {
    prefix: 'fas',
    iconName: 'people-carry-box',
    icon: [
        640,
        512,
        [
            "people-carry"
        ],
        "f4ce",
        "M176 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM144 241.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320C54.8 308 48 291.7 48 274.7V186.6c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v76.2l10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51V241.7l-19 28.5c-4.6 7-11 12.6-18.5 16.3l-59.6 29.8c-2.4 1.3-4.9 2.2-7.6 2.8c-2.6 .6-5.3 .9-7.9 .8H256.7c-2.5 .1-5-.2-7.5-.7c-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1L50.1 348.6l49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM512 96c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zm77.9 252.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"
    ]
};
var $1113a0aa61ab7765$export$35fbd4ff1265acd5 = $1113a0aa61ab7765$export$7754cc6d5559ff38;
var $1113a0aa61ab7765$export$15d012277c3ecf9a = {
    prefix: 'fas',
    iconName: 'temperature-high',
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 128c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm0 64c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96s43 96 96 96zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.2 32 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"
    ]
};
var $1113a0aa61ab7765$export$4a7bb4be15f35178 = {
    prefix: 'fas',
    iconName: 'microchip',
    icon: [
        512,
        512,
        [],
        "f2db",
        "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zM160 128H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160V352H352V160z"
    ]
};
var $1113a0aa61ab7765$export$dc1083dcd1d7b9d6 = {
    prefix: 'fas',
    iconName: 'crown',
    icon: [
        576,
        512,
        [
            128081
        ],
        "f521",
        "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"
    ]
};
var $1113a0aa61ab7765$export$43d1fa6671908715 = {
    prefix: 'fas',
    iconName: 'weight-hanging',
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M288 96c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm58.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H346.5z"
    ]
};
var $1113a0aa61ab7765$export$f4595f012786d346 = {
    prefix: 'fas',
    iconName: 'xmarks-lines',
    icon: [
        640,
        512,
        [],
        "e59a",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var $1113a0aa61ab7765$export$a20cb90865b6beb8 = {
    prefix: 'fas',
    iconName: 'file-prescription',
    icon: [
        384,
        512,
        [],
        "f572",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z"
    ]
};
var $1113a0aa61ab7765$export$e521c542d18b85c3 = {
    prefix: 'fas',
    iconName: 'weight-scale',
    icon: [
        512,
        512,
        [
            "weight"
        ],
        "f496",
        "M384 176c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128zm7.8-112C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"
    ]
};
var $1113a0aa61ab7765$export$cf3bafa68a60bae4 = $1113a0aa61ab7765$export$e521c542d18b85c3;
var $1113a0aa61ab7765$export$3d626cfc365a7e36 = {
    prefix: 'fas',
    iconName: 'user-group',
    icon: [
        640,
        512,
        [
            128101,
            "user-friends"
        ],
        "f500",
        "M352 128c0 70.7-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
    ]
};
var $1113a0aa61ab7765$export$46073bec205635d9 = $1113a0aa61ab7765$export$3d626cfc365a7e36;
var $1113a0aa61ab7765$export$fb00fdd8857804c7 = {
    prefix: 'fas',
    iconName: 'arrow-up-a-z',
    icon: [
        576,
        512,
        [
            "sort-alpha-up"
        ],
        "f15e",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176H395.8z"
    ]
};
var $1113a0aa61ab7765$export$3c4115b156be730d = $1113a0aa61ab7765$export$fb00fdd8857804c7;
var $1113a0aa61ab7765$export$861b1f13085cf122 = {
    prefix: 'fas',
    iconName: 'chess-knight',
    icon: [
        384,
        512,
        [
            9822
        ],
        "f441",
        "M32 391.6V416H352V224c0-106-86-192-192-192H12.9C5.8 32 0 37.8 0 44.9c0 2 .5 4 1.4 5.8L16 80 9.4 86.6c-6 6-9.4 14.1-9.4 22.6V242.3c0 13.1 8 24.9 20.1 29.7l46.5 18.6c8.5 3.4 18 3 26.2-1.1l6.6-3.3c8-4 14-11.2 16.5-19.8l8.3-28.9c2.5-8.6 8.4-15.8 16.5-19.8L160 208v40.4c0 24.2-13.7 46.4-35.4 57.2L67.4 334.3C45.7 345.2 32 367.3 32 391.6zM72 148c0 11-9 20-20 20s-20-9-20-20s9-20 20-20s20 9 20 20zM352 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32z"
    ]
};
var $1113a0aa61ab7765$export$67ca89c1ca38d559 = {
    prefix: 'fas',
    iconName: 'face-laugh-squint',
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $1113a0aa61ab7765$export$b206e700cf7084e1 = $1113a0aa61ab7765$export$67ca89c1ca38d559;
var $1113a0aa61ab7765$export$76a9413fbe130a53 = {
    prefix: 'fas',
    iconName: 'wheelchair',
    icon: [
        576,
        512,
        [],
        "f193",
        "M224 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM152.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C75.1 225.1 32 283.5 32 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C272 440 234.8 464 192 464c-61.9 0-112-50.1-112-112c0-47.9 30.1-88.8 72.5-104.8zM291.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h5.1c.4 0 .8 0 1.3 0h94.1c6.7 0 12.6 4.1 15 10.4L434 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H314.2l-9.6-48H368c17.7 0 32-14.3 32-32s-14.3-32-32-32H291.8z"
    ]
};
var $1113a0aa61ab7765$export$a29c8ea43e92771d = {
    prefix: 'fas',
    iconName: 'circle-arrow-up',
    icon: [
        512,
        512,
        [
            "arrow-circle-up"
        ],
        "f0aa",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM385 215c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V177.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 103c9.4-9.4 24.6-9.4 33.9 0L385 215z"
    ]
};
var $1113a0aa61ab7765$export$a2f6f3baa50af0b1 = $1113a0aa61ab7765$export$a29c8ea43e92771d;
var $1113a0aa61ab7765$export$5cffc34afa81e517 = {
    prefix: 'fas',
    iconName: 'toggle-on',
    icon: [
        576,
        512,
        [],
        "f205",
        "M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zM384 352c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96z"
    ]
};
var $1113a0aa61ab7765$export$6af1cc5998ca52bc = {
    prefix: 'fas',
    iconName: 'person-walking',
    icon: [
        320,
        512,
        [
            128694,
            "walking"
        ],
        "f554",
        "M256 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"
    ]
};
var $1113a0aa61ab7765$export$4886811b7174ec35 = $1113a0aa61ab7765$export$6af1cc5998ca52bc;
var $1113a0aa61ab7765$export$be32b10ce70a09df = {
    prefix: 'fas',
    iconName: 'l',
    icon: [
        320,
        512,
        [
            108
        ],
        "4c",
        "M64 32c17.7 0 32 14.3 32 32V416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$7b24b34ef6cc130c = {
    prefix: 'fas',
    iconName: 'fire',
    icon: [
        448,
        512,
        [
            128293
        ],
        "f06d",
        "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-2.8-5.6-5.6-11.2-9.8-16.8l-50.6 58.8s-81.4-103.6-87.1-110.6C133.1 243.8 112 273.2 112 306.8C112 375.4 162.6 416 225.7 416z"
    ]
};
var $1113a0aa61ab7765$export$580ae0d0bbd809fb = {
    prefix: 'fas',
    iconName: 'bed-pulse',
    icon: [
        640,
        512,
        [
            "procedures"
        ],
        "f487",
        "M483.2 9.6L524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24H352c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160H544c53 0 96 43 96 96V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V352H288V192c0-17.7 14.3-32 32-32zM176 320c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $1113a0aa61ab7765$export$5f9e1870e1866dde = $1113a0aa61ab7765$export$580ae0d0bbd809fb;
var $1113a0aa61ab7765$export$76d92e7f30d064c5 = {
    prefix: 'fas',
    iconName: 'shuttle-space',
    icon: [
        640,
        512,
        [
            "space-shuttle"
        ],
        "f197",
        "M130 480c40.6 0 80.4-11 115.2-31.9L352 384l-224 0 0 96h2zM352 128L245.2 63.9C210.4 43 170.6 32 130 32h-2v96l224 0zM96 128l0-96H80C53.5 32 32 53.5 32 80v48h8c-22.1 0-40 17.9-40 40v16V328v16c0 22.1 17.9 40 40 40H32v48c0 26.5 21.5 48 48 48H96l0-96h8c26.2 0 49.4-12.6 64-32H456c69.3 0 135-22.7 179.2-81.6c6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32l-8 0zM512 243.6v24.9c0 19.6-15.9 35.6-35.6 35.6c-2.5 0-4.4-2-4.4-4.4V212.4c0-2.5 2-4.4 4.4-4.4c19.6 0 35.6 15.9 35.6 35.6z"
    ]
};
var $1113a0aa61ab7765$export$4d1c12ba2b4ca565 = $1113a0aa61ab7765$export$76d92e7f30d064c5;
var $1113a0aa61ab7765$export$2f203616c892d415 = {
    prefix: 'fas',
    iconName: 'face-laugh',
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM208.4 192c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$6c74e314e801a4fe = $1113a0aa61ab7765$export$2f203616c892d415;
var $1113a0aa61ab7765$export$ff7e93418af88b78 = {
    prefix: 'fas',
    iconName: 'folder-open',
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224H544c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"
    ]
};
var $1113a0aa61ab7765$export$2a155a6e20f64134 = {
    prefix: 'fas',
    iconName: 'heart-circle-plus',
    icon: [
        576,
        512,
        [],
        "e500",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$f54081bdbf6d4eb5 = {
    prefix: 'fas',
    iconName: 'code-fork',
    icon: [
        448,
        512,
        [],
        "e13b",
        "M80 104c13.3 0 24-10.7 24-24s-10.7-24-24-24S56 66.7 56 80s10.7 24 24 24zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V153.3C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96H256v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288H144c-53 0-96-43-96-96V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zM248 432c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $1113a0aa61ab7765$export$a9947c2888b3c8fd = {
    prefix: 'fas',
    iconName: 'city',
    icon: [
        640,
        512,
        [
            127961
        ],
        "f64f",
        "M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144v96V464c0 26.5 21.5 48 48 48H304h32 96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 416H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM560 256c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zM256 176v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32zM256 304c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$417391ae30b5922e = {
    prefix: 'fas',
    iconName: 'microphone-lines',
    icon: [
        384,
        512,
        [
            127897,
            "microphone-alt"
        ],
        "f3c9",
        "M96 96V256c0 53 43 96 96 96s96-43 96-96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96zM320 240v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24z"
    ]
};
var $1113a0aa61ab7765$export$f08ef94fea14f5ac = $1113a0aa61ab7765$export$417391ae30b5922e;
var $1113a0aa61ab7765$export$4894bf28f771e1f3 = {
    prefix: 'fas',
    iconName: 'pepper-hot',
    icon: [
        512,
        512,
        [
            127798
        ],
        "f816",
        "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24V152c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5L264 160l40 0v80c0 26.5 21.5 48 48 48h76.2l23.9 47.8C372.3 443.9 244.3 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"
    ]
};
var $1113a0aa61ab7765$export$db1382cd406cc506 = {
    prefix: 'fas',
    iconName: 'unlock',
    icon: [
        448,
        512,
        [
            128275
        ],
        "f09c",
        "M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z"
    ]
};
var $1113a0aa61ab7765$export$dec10d4c2c113312 = {
    prefix: 'fas',
    iconName: 'colon-sign',
    icon: [
        384,
        512,
        [],
        "e140",
        "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2L181.9 68.6C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2L177 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8c10.6-14.1 7.8-34.2-6.4-44.8c-1.1-.8-2.2-1.6-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2L277.1 71.5c-9.3-2.7-18.8-4.6-28.6-5.9L255 39.8zM163.2 143.3L117.3 326.8C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5l61.1-244.6c9.9 .7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"
    ]
};
var $1113a0aa61ab7765$export$23b086400a31acfe = {
    prefix: 'fas',
    iconName: 'headset',
    icon: [
        512,
        512,
        [],
        "f590",
        "M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z"
    ]
};
var $1113a0aa61ab7765$export$4ab2f33219630bad = {
    prefix: 'fas',
    iconName: 'store-slash',
    icon: [
        640,
        512,
        [],
        "e071",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V384 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V350.9L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zm73.4 218.1c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7zM160 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H480c12.9 0 24.8-3.8 34.9-10.3L365.5 384H160z"
    ]
};
var $1113a0aa61ab7765$export$2ffc88a4d31e8ffc = {
    prefix: 'fas',
    iconName: 'road-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e566",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm22.6-144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
var $1113a0aa61ab7765$export$d6e17c0df8ed1bf7 = {
    prefix: 'fas',
    iconName: 'user-minus',
    icon: [
        640,
        512,
        [],
        "f503",
        "M352 128c0 70.7-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM472 200H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $1113a0aa61ab7765$export$efc6d53e0dedceee = {
    prefix: 'fas',
    iconName: 'mars-stroke-up',
    icon: [
        320,
        512,
        [
            9896,
            "mars-stroke-v"
        ],
        "f22a",
        "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H184v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H184v24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8V168H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96z"
    ]
};
var $1113a0aa61ab7765$export$ed7aa1c25104f333 = $1113a0aa61ab7765$export$efc6d53e0dedceee;
var $1113a0aa61ab7765$export$7df1926e9eef8cc3 = {
    prefix: 'fas',
    iconName: 'champagne-glasses',
    icon: [
        640,
        512,
        [
            129346,
            "glass-cheers"
        ],
        "f79f",
        "M320 128V49.1L186.6 .3c-11.4-4.2-24 .9-29.5 11.7L71.8 181.1c-30.8 61-8 133.8 48.1 167.4l-28 77.4L32.1 403.9C19.7 399.4 6 405.8 1.4 418.3s1.9 26.3 14.3 30.8l164.6 60.3c12.4 4.5 26.1-1.9 30.6-14.4s-1.9-26.3-14.3-30.8l-59.9-21.9 28-77.3c68.1 11.6 135.7-32.8 150.1-103.6l5.1-24.8 5.1 24.8c14.5 70.8 82 115.2 150.1 103.6l28 77.3-59.9 21.9c-12.4 4.5-18.8 18.3-14.3 30.8s18.2 18.9 30.6 14.4l164.6-60.3c12.4-4.5 18.8-18.3 14.3-30.8s-18.2-18.9-30.6-14.4l-59.9 21.9-28-77.4c56.1-33.6 78.8-106.4 48.1-167.4L482.9 12C477.4 1.1 464.7-3.9 453.4 .3L320 49.1V128h0zm-35.7 44.4L153.9 124.6l36.3-71.9L300.6 93.1l-16.2 79.3zm71.3 0L339.4 93.1 449.8 52.7l36.3 71.9L355.7 172.4z"
    ]
};
var $1113a0aa61ab7765$export$20007d7d74cb98fe = $1113a0aa61ab7765$export$7df1926e9eef8cc3;
var $1113a0aa61ab7765$export$97d84347d71ba297 = {
    prefix: 'fas',
    iconName: 'clipboard',
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$8403e4b31e8aa805 = {
    prefix: 'fas',
    iconName: 'house-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e50a",
        "M320.7 351.7C329 262.1 404.3 192 496 192c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V480c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32V383.7c0-17.7 14.3-32 32-32h64l.7 0zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$929df388c07f293d = {
    prefix: 'fas',
    iconName: 'file-arrow-up',
    icon: [
        384,
        512,
        [
            "file-upload"
        ],
        "f574",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"
    ]
};
var $1113a0aa61ab7765$export$dd55ded1264643d2 = $1113a0aa61ab7765$export$929df388c07f293d;
var $1113a0aa61ab7765$export$1642419fe3db2857 = {
    prefix: 'fas',
    iconName: 'wifi',
    icon: [
        640,
        512,
        [
            "wifi-3",
            "wifi-strong"
        ],
        "f1eb",
        "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $1113a0aa61ab7765$export$2349bb04a04f4b2d = $1113a0aa61ab7765$export$1642419fe3db2857;
var $1113a0aa61ab7765$export$4b3167c852f4c4aa = $1113a0aa61ab7765$export$1642419fe3db2857;
var $1113a0aa61ab7765$export$1ea66a88b8f620c9 = {
    prefix: 'fas',
    iconName: 'bath',
    icon: [
        512,
        512,
        [
            128705,
            "bathtub"
        ],
        "f2cd",
        "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352H32z"
    ]
};
var $1113a0aa61ab7765$export$40ae013b5e6269d8 = $1113a0aa61ab7765$export$1ea66a88b8f620c9;
var $1113a0aa61ab7765$export$22346afd6a3cddf8 = {
    prefix: 'fas',
    iconName: 'underline',
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $1113a0aa61ab7765$export$3842882ea09b25af = {
    prefix: 'fas',
    iconName: 'user-pen',
    icon: [
        640,
        512,
        [
            "user-edit"
        ],
        "f4ff",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"
    ]
};
var $1113a0aa61ab7765$export$a68a6960fc8eef82 = $1113a0aa61ab7765$export$3842882ea09b25af;
var $1113a0aa61ab7765$export$afa7b53ac8ebcb5d = {
    prefix: 'fas',
    iconName: 'signature',
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368H24zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48H616z"
    ]
};
var $1113a0aa61ab7765$export$195780ddabd8e0c6 = {
    prefix: 'fas',
    iconName: 'stroopwafel',
    icon: [
        512,
        512,
        [],
        "f551",
        "M256 496c132.5 0 240-107.5 240-240S388.5 16 256 16S16 123.5 16 256s107.5 240 240 240zM235.3 76.7L256 97.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 120 324 165.4 357.4 132l-16.7-16.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L380 109.4l8.7-8.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-8.7 8.7 16.7 16.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L380 154.6 346.6 188 392 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414.6 256l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L392 278.6 346.6 324 380 357.4l16.7-16.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L402.6 380l8.7 8.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-8.7-8.7-16.7 16.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L357.4 380 324 346.6 278.6 392l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 414.6l-20.7 20.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 392 188 346.6 154.6 380l16.7 16.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L132 402.6l-8.7 8.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l8.7-8.7L92.7 363.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L132 357.4 165.4 324 120 278.6 99.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.4 256 76.7 235.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L120 233.4 165.4 188 132 154.6l-16.7 16.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L109.4 132l-8.7-8.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l8.7 8.7 16.7-16.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L154.6 132 188 165.4 233.4 120 212.7 99.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM210.6 188L256 233.4 301.4 188 256 142.6 210.6 188zm68 68L324 301.4 369.4 256 324 210.6 278.6 256zM256 278.6L210.6 324 256 369.4 301.4 324 256 278.6zM233.4 256L188 210.6 142.6 256 188 301.4 233.4 256z"
    ]
};
var $1113a0aa61ab7765$export$7e0c7fd2a2e88823 = {
    prefix: 'fas',
    iconName: 'bold',
    icon: [
        384,
        512,
        [],
        "f032",
        "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"
    ]
};
var $1113a0aa61ab7765$export$217195c80db39097 = {
    prefix: 'fas',
    iconName: 'anchor-lock',
    icon: [
        640,
        512,
        [],
        "e4ad",
        "M256 96c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm85.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3V446.7c-5.2 .9-10.5 1.3-16 1.3H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $1113a0aa61ab7765$export$374e1dce366a2175 = {
    prefix: 'fas',
    iconName: 'building-ngo',
    icon: [
        384,
        512,
        [],
        "e4d7",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V112zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"
    ]
};
var $1113a0aa61ab7765$export$1ff755b523ab2851 = {
    prefix: 'fas',
    iconName: 'manat-sign',
    icon: [
        384,
        512,
        [],
        "e1d5",
        "M192 32c-17.7 0-32 14.3-32 32V98.7C69.2 113.9 0 192.9 0 288V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-59.6 40.8-109.8 96-124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V164c55.2 14.2 96 64.3 96 124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-95.1-69.2-174.1-160-189.3V64c0-17.7-14.3-32-32-32z"
    ]
};
var $1113a0aa61ab7765$export$6a15ccae09bbaf93 = {
    prefix: 'fas',
    iconName: 'not-equal',
    icon: [
        448,
        512,
        [],
        "f53e",
        "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5l-64 96H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8l-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4L110.9 368H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H153.5l64-96H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H260.2l65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"
    ]
};
var $1113a0aa61ab7765$export$cf897c3e0abd59e4 = {
    prefix: 'fas',
    iconName: 'border-top-left',
    icon: [
        448,
        512,
        [
            "border-style"
        ],
        "f853",
        "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336c0-8.8 7.2-16 16-16l336 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112L0 448zm160 0c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm192 0c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm-96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm192 0c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zm0-128c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$c2867ca78120d644 = $1113a0aa61ab7765$export$cf897c3e0abd59e4;
var $1113a0aa61ab7765$export$757f50b8af780c19 = {
    prefix: 'fas',
    iconName: 'map-location-dot',
    icon: [
        576,
        512,
        [
            "map-marked-alt"
        ],
        "f5a0",
        "M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40z"
    ]
};
var $1113a0aa61ab7765$export$a977d47c74d8e86c = $1113a0aa61ab7765$export$757f50b8af780c19;
var $1113a0aa61ab7765$export$859f204e59641ca4 = {
    prefix: 'fas',
    iconName: 'jedi',
    icon: [
        576,
        512,
        [],
        "f669",
        "M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7c-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48c-4.6-13 10.2-30 21.4-22c53.5 38 92.7 94.8 107.8 160.7c.5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9h26c3.4 0 6.2 2.6 6.3 6c.1 3.3 .2 6.6 .2 10c0 17.5-1.7 34.7-4.8 51.3c-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9H526c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9H64.5c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3C17.7 274.7 16 257.5 16 240c0-3.3 .1-6.7 .2-10c.1-3.4 2.9-6 6.3-6h26c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22c-5.3 15-8.2 31.2-8.2 48c0 46.3 21.9 87.5 55.8 113.9c7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"
    ]
};
var $1113a0aa61ab7765$export$91d747e5aabe6fe8 = {
    prefix: 'fas',
    iconName: 'square-poll-vertical',
    icon: [
        448,
        512,
        [
            "poll"
        ],
        "f681",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM320 288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$bc8ca14ab51f93db = $1113a0aa61ab7765$export$91d747e5aabe6fe8;
var $1113a0aa61ab7765$export$47a822c30184e8af = {
    prefix: 'fas',
    iconName: 'mug-hot',
    icon: [
        512,
        512,
        [
            9749
        ],
        "f7b6",
        "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384V256zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"
    ]
};
var $1113a0aa61ab7765$export$a44d0c11093d9c1e = {
    prefix: 'fas',
    iconName: 'car-battery',
    icon: [
        512,
        512,
        [
            "battery-car"
        ],
        "f5df",
        "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z"
    ]
};
var $1113a0aa61ab7765$export$9133165ca669dd4b = $1113a0aa61ab7765$export$a44d0c11093d9c1e;
var $1113a0aa61ab7765$export$b2727de8ccdbb5ec = {
    prefix: 'fas',
    iconName: 'gift',
    icon: [
        512,
        512,
        [
            127873
        ],
        "f06b",
        "M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H224V288H32zM288 512H432c26.5 0 48-21.5 48-48V288H288V512z"
    ]
};
var $1113a0aa61ab7765$export$4d85df590065572f = {
    prefix: 'fas',
    iconName: 'dice-two',
    icon: [
        448,
        512,
        [
            9857
        ],
        "f528",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM352 352c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM128 192c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$7b8ce73615739d30 = {
    prefix: 'fas',
    iconName: 'chess-queen',
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M312 56c0-30.9-25.1-56-56-56s-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56zM64 480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM34 169.4L9.2 185.8C3.5 189.7 0 196.2 0 203.1c0 3.2 .7 6.4 2.2 9.3L104 416H408L509.8 212.4c1.4-2.9 2.2-6.1 2.2-9.3c0-6.9-3.5-13.4-9.2-17.3L478 169.4c-8.2-5.4-19-4.4-26 2.6c-12.9 12.9-30.9 21.9-48 15.5c-17.9-6.7-28.1-20.1-32.8-35.8C367.5 139 357.3 128 344 128H328c-13.3 0-23.9 11.2-29.6 23.2C292.6 163.4 280.6 176 256 176s-36.6-12.6-42.4-24.8c-5.7-12-16.3-23.2-29.6-23.2H168c-13.3 0-23.5 11-27.3 23.7c-4.7 15.6-14.9 29.1-32.8 35.8c-17 6.4-35.1-2.7-48-15.5c-6.9-6.9-17.8-8-25.9-2.6z"
    ]
};
var $1113a0aa61ab7765$export$58d7d709c0a8ca5f = {
    prefix: 'fas',
    iconName: 'glasses',
    icon: [
        576,
        512,
        [],
        "f530",
        "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-6.3 12.7h0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7h0c-6.3-12.7-6.3-12.7-6.3-12.7l0 0 0 0 .1 0 .2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7v6.7V352v16c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368c0 26.5 21.5 48 48 48h44.3c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5c-17.2-5.4-39.9-10.5-63.6-10.5c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zM512 368V325.4c-2.6-.9-5.5-1.9-8.5-2.9c-17-5.4-39.5-10.5-63.2-10.5c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3H464c26.5 0 48-21.5 48-48z"
    ]
};
var $1113a0aa61ab7765$export$bd301515df6246af = {
    prefix: 'fas',
    iconName: 'chess-board',
    icon: [
        448,
        512,
        [],
        "f43c",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 64v64h64V96h64v64h64V96h64v64H320v64h64v64H320v64h64v64H320V352H256v64H192V352H128v64H64V352h64V288H64V224h64V160H64V96h64zm64 128h64V160H192v64zm0 64V224H128v64h64zm64 0H192v64h64V288zm0 0h64V224H256v64z"
    ]
};
var $1113a0aa61ab7765$export$5559de5f969b9590 = {
    prefix: 'fas',
    iconName: 'building-circle-check',
    icon: [
        640,
        512,
        [],
        "e4d2",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM640 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $1113a0aa61ab7765$export$c9dc1583b207b7ff = {
    prefix: 'fas',
    iconName: 'person-chalkboard',
    icon: [
        640,
        512,
        [],
        "e53d",
        "M192 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V192h56 64 16c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64H576V256H384V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$321e84e6a900c2d6 = {
    prefix: 'fas',
    iconName: 'mars-stroke-right',
    icon: [
        640,
        512,
        [
            9897,
            "mars-stroke-h"
        ],
        "f22b",
        "M208 368c61.9 0 112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152H416V176c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32V176c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V280H464v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H382.4z"
    ]
};
var $1113a0aa61ab7765$export$5cb0daeafbcdabe3 = $1113a0aa61ab7765$export$321e84e6a900c2d6;
var $1113a0aa61ab7765$export$be38a892fe9b4098 = {
    prefix: 'fas',
    iconName: 'hand-back-fist',
    icon: [
        448,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M144 0C117.5 0 96 21.5 96 48V96v28.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V149.3l-9 7.5C40.4 169 32 187 32 206V244c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V176 160 144c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"
    ]
};
var $1113a0aa61ab7765$export$97a81eba394c8c44 = $1113a0aa61ab7765$export$be38a892fe9b4098;
var $1113a0aa61ab7765$export$66068918abb14406 = {
    prefix: 'fas',
    iconName: 'square-caret-up',
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
var $1113a0aa61ab7765$export$307ae80b26533ce5 = $1113a0aa61ab7765$export$66068918abb14406;
var $1113a0aa61ab7765$export$b416056e795d2eac = {
    prefix: 'fas',
    iconName: 'cloud-showers-water',
    icon: [
        576,
        512,
        [],
        "e4e4",
        "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zM140.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM252.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $1113a0aa61ab7765$export$b532f5d25de97633 = {
    prefix: 'fas',
    iconName: 'chart-bar',
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$2d5f754a5e5738b = $1113a0aa61ab7765$export$b532f5d25de97633;
var $1113a0aa61ab7765$export$2f78563e14e49916 = {
    prefix: 'fas',
    iconName: 'hands-bubbles',
    icon: [
        512,
        512,
        [
            "hands-wash"
        ],
        "e05e",
        "M384 64c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm80 160c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zM128 464c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM357.1 157.5c-.3 .7-.7 1.5-1.1 2.2l-17.8 30.9c-11-12.6-27.4-19.8-44.4-19.1l20.7-35.8c6.6-11.5 21.3-15.4 32.8-8.8c10.8 6.2 14.9 19.5 9.9 30.6zm-173.6 47C112.3 227.2 64 293.3 64 368c0 1.5 0 3 .1 4.5C24.3 346.9 0 302.8 0 255.1V131.5c0-13.3 10.7-24 24-24s24 10.7 24 24l0 81.7L164.2 12c6.6-11.5 21.3-15.4 32.8-8.8s15.4 21.3 8.8 32.8l-64 110.9c-2.2 3.8-.9 8.7 2.9 10.9s8.7 .9 10.9-2.9l80-138.6c6.6-11.5 21.3-15.4 32.8-8.8s15.4 21.3 8.8 32.8l-80 138.6c-2.2 3.8-.9 8.7 2.9 10.9s8.7 .9 10.9-2.9L275 76c6.6-11.5 21.3-15.4 32.8-8.8s15.4 21.3 8.8 32.8l-44 76.2-89.1 28.3zM448 483.5c0 12.4-9.4 22.6-21.5 23.9c-.8 .1-1.6 .1-2.5 .1H223.3 216c-22.1 0-42.9-6-60.7-16.5c3-8.5 4.7-17.6 4.7-27c0-38.7-27.5-71-64-78.4c0-.6 0-1.1 0-1.7c0-1.2-.1-2.5-.1-3.7c0-68 44-128.3 108.9-148.9l83.9-26.7c12.6-4 26.1 3 30.1 15.6s-3 26.1-15.6 30.1l-53.8 17.1H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H328c-4.4 0-8 3.6-8 8s3.6 8 8 8H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H328c-4.4 0-8 3.6-8 8s3.6 8 8 8H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H328c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c13.3 0 24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$996b5dea53b124e3 = $1113a0aa61ab7765$export$2f78563e14e49916;
var $1113a0aa61ab7765$export$b2c723344cff0d8 = {
    prefix: 'fas',
    iconName: 'less-than-equal',
    icon: [
        448,
        512,
        [],
        "f537",
        "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192 395.9 93.7zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $1113a0aa61ab7765$export$17cde74bf6f1ee89 = {
    prefix: 'fas',
    iconName: 'train',
    icon: [
        448,
        512,
        [
            128646
        ],
        "f238",
        "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM224 384c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $1113a0aa61ab7765$export$23a892b1a4b994bd = {
    prefix: 'fas',
    iconName: 'eye-low-vision',
    icon: [
        640,
        512,
        [
            "low-vision"
        ],
        "f2a8",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zm223.1 298L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5z"
    ]
};
var $1113a0aa61ab7765$export$7a65d2aa54cb4e93 = $1113a0aa61ab7765$export$23a892b1a4b994bd;
var $1113a0aa61ab7765$export$bfa312207b788ed9 = {
    prefix: 'fas',
    iconName: 'crow',
    icon: [
        640,
        512,
        [],
        "f520",
        "M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384H259.2l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384H352c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192V128v-8l80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32H523.9C507.7 12.5 483.3 0 456 0zm0 112c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $1113a0aa61ab7765$export$e363e74e36cce80c = {
    prefix: 'fas',
    iconName: 'sailboat',
    icon: [
        576,
        512,
        [],
        "e445",
        "M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6H272c-8.8 0-16-7.2-16-16V16zM212.1 96.5c7 1.9 11.9 8.2 11.9 15.5V336c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"
    ]
};
var $1113a0aa61ab7765$export$eccfff9bfd585652 = {
    prefix: 'fas',
    iconName: 'window-restore',
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M432 64H208c-8.8 0-16 7.2-16 16V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V320h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm64 32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"
    ]
};
var $1113a0aa61ab7765$export$eaf727acca5a35e4 = {
    prefix: 'fas',
    iconName: 'square-plus',
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $1113a0aa61ab7765$export$b6359eebfe900c35 = $1113a0aa61ab7765$export$eaf727acca5a35e4;
var $1113a0aa61ab7765$export$75825a4c2b3375e = {
    prefix: 'fas',
    iconName: 'torii-gate',
    icon: [
        512,
        512,
        [
            9961
        ],
        "f6a1",
        "M0 80c0 26.5 21.5 48 48 48H64v64h64V128h96v64h64V128h96v64h64V128h16c26.5 0 48-21.5 48-48V0L440.6 23.8C424.3 29.2 407.2 32 390 32H122c-17.2 0-34.3-2.8-50.6-8.2L0 0V80zM64 288V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64z"
    ]
};
var $1113a0aa61ab7765$export$fe2358263efac504 = {
    prefix: 'fas',
    iconName: 'frog',
    icon: [
        576,
        512,
        [],
        "f52e",
        "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $1113a0aa61ab7765$export$2124c7628e573b84 = {
    prefix: 'fas',
    iconName: 'bucket',
    icon: [
        448,
        512,
        [],
        "e4cf",
        "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8H352v-8c0-57.4-46.6-104-104-104H200C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-5.1L388.5 469c-2.6 24.4-23.2 43-47.7 43H107.2c-24.6 0-45.2-18.5-47.7-43L37.1 256H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $1113a0aa61ab7765$export$7e9f0928967e03b = {
    prefix: 'fas',
    iconName: 'image',
    icon: [
        512,
        512,
        [],
        "f03e",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $1113a0aa61ab7765$export$eed3c491effe6d12 = {
    prefix: 'fas',
    iconName: 'microphone',
    icon: [
        384,
        512,
        [],
        "f130",
        "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"
    ]
};
var $1113a0aa61ab7765$export$1da3b2e53dcafa2d = {
    prefix: 'fas',
    iconName: 'cow',
    icon: [
        640,
        512,
        [
            128004
        ],
        "f6c8",
        "M96 224v32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V327.8c9.9 6.6 20.6 12 32 16.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16V351.1c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16V343.8c11.4-4 22.1-9.4 32-16.1V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H272 256 192 144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4V256 224 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160v64zM592 336c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H361.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"
    ]
};
var $1113a0aa61ab7765$export$7de776bdab4e536d = {
    prefix: 'fas',
    iconName: 'caret-up',
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
var $1113a0aa61ab7765$export$7484ff654cd6474f = {
    prefix: 'fas',
    iconName: 'screwdriver',
    icon: [
        512,
        512,
        [
            129691
        ],
        "f54a",
        "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v54.1l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"
    ]
};
var $1113a0aa61ab7765$export$5e30548b7f8eeb95 = {
    prefix: 'fas',
    iconName: 'folder-closed',
    icon: [
        512,
        512,
        [],
        "e185",
        "M448 480H64c-35.3 0-64-28.7-64-64V192H512V416c0 35.3-28.7 64-64 64zm64-320H0V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H448c35.3 0 64 28.7 64 64z"
    ]
};
var $1113a0aa61ab7765$export$197b9567e88a0b1d = {
    prefix: 'fas',
    iconName: 'house-tsunami',
    icon: [
        576,
        512,
        [],
        "e515",
        "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1l0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0c-22.4 15.5-49.9 26.1-77.4 26.1c0 0-.1 0-.1 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6V265c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
var $1113a0aa61ab7765$export$5498258519fc5b72 = {
    prefix: 'fas',
    iconName: 'square-nfi',
    icon: [
        448,
        512,
        [],
        "e576",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm75.7 64.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"
    ]
};
var $1113a0aa61ab7765$export$cbe485a104805f4f = {
    prefix: 'fas',
    iconName: 'arrow-up-from-ground-water',
    icon: [
        576,
        512,
        [],
        "e4b5",
        "M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"
    ]
};
var $1113a0aa61ab7765$export$98401bb29cff68e0 = {
    prefix: 'fas',
    iconName: 'martini-glass',
    icon: [
        512,
        512,
        [
            127864,
            "glass-martini-alt"
        ],
        "f57b",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM173.3 128l-64-64H402.7l-64 64H173.3z"
    ]
};
var $1113a0aa61ab7765$export$2258439b8f4e7acb = $1113a0aa61ab7765$export$98401bb29cff68e0;
var $1113a0aa61ab7765$export$7adaa412bd8eb08f = {
    prefix: 'fas',
    iconName: 'rotate-left',
    icon: [
        512,
        512,
        [
            "rotate-back",
            "rotate-backward",
            "undo-alt"
        ],
        "f2ea",
        "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"
    ]
};
var $1113a0aa61ab7765$export$9706706f1bc7b12 = $1113a0aa61ab7765$export$7adaa412bd8eb08f;
var $1113a0aa61ab7765$export$4ceb0b05fed961a9 = $1113a0aa61ab7765$export$7adaa412bd8eb08f;
var $1113a0aa61ab7765$export$c8197b992c46c4a6 = $1113a0aa61ab7765$export$7adaa412bd8eb08f;
var $1113a0aa61ab7765$export$ccaa019a3fd4563f = {
    prefix: 'fas',
    iconName: 'table-columns',
    icon: [
        512,
        512,
        [
            "columns"
        ],
        "f0db",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64V416H224V160H64zm384 0H288V416H448V160z"
    ]
};
var $1113a0aa61ab7765$export$bb861166644ac28a = $1113a0aa61ab7765$export$ccaa019a3fd4563f;
var $1113a0aa61ab7765$export$4fbda8f64648f3b5 = {
    prefix: 'fas',
    iconName: 'lemon',
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"
    ]
};
var $1113a0aa61ab7765$export$280300af4baa1a3e = {
    prefix: 'fas',
    iconName: 'head-side-mask',
    icon: [
        512,
        512,
        [],
        "e063",
        "M0 224.2c0-22.2 3.2-43.6 9.2-63.9l227 165.1C228.5 337.8 224 352.4 224 368V512H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm258.6 77.9L21 129.3C56.7 53 134.2 0 224 0h32c95.2 0 174.2 69.3 189.4 160.1c2.2 13 6.7 25.7 15 36.1l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 4.1-.6 8.1-1.6 11.9H304c-16.9 0-32.5 5.2-45.4 14.1zM352 224c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM256 512V368c0-26.5 21.5-48 48-48H512l-16 48H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.3l-10.7 32H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H464l-1.4 4.2c-8.7 26.1-33.2 43.8-60.7 43.8H256z"
    ]
};
var $1113a0aa61ab7765$export$b4c63e9bfc7906f1 = {
    prefix: 'fas',
    iconName: 'handshake',
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM96 128H0V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V128zM48 352c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V128H544zm64 208c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$31ee86ac717db552 = {
    prefix: 'fas',
    iconName: 'gem',
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.6 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"
    ]
};
var $1113a0aa61ab7765$export$5879d0bca1aa497b = {
    prefix: 'fas',
    iconName: 'dolly',
    icon: [
        640,
        512,
        [
            "dolly-box"
        ],
        "f472",
        "M32 32C32 14.3 46.3 0 64 0h72.9c27.5 0 52 17.6 60.7 43.8L289.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L384 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L136.9 64H64C46.3 64 32 49.7 32 32zM276.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L343 79.4l19.8 60.9 60.9-19.8L403.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L366.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L276.8 134.5z"
    ]
};
var $1113a0aa61ab7765$export$461bbb9e92cc531b = $1113a0aa61ab7765$export$5879d0bca1aa497b;
var $1113a0aa61ab7765$export$c4ab83701fc591a5 = {
    prefix: 'fas',
    iconName: 'smoking',
    icon: [
        640,
        512,
        [
            128684
        ],
        "f48d",
        "M448 32V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v11c0 17.7-14.3 32-32 32s-32-14.3-32-32V245c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM576 256V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V32c0-17.7 14.3-32 32-32s32 14.3 32 32V43c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1v11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V416zm224 0v32H384V416H224zm288-64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$e0601b1f239fec74 = {
    prefix: 'fas',
    iconName: 'minimize',
    icon: [
        512,
        512,
        [
            "compress-arrows-alt"
        ],
        "f78c",
        "M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V312c0-13.3 10.7-24 24-24H456zm-256 0c13.3 0 24 10.7 24 24V456c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H200zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V200c0 13.3-10.7 24-24 24H56z"
    ]
};
var $1113a0aa61ab7765$export$39205db0ea980efd = $1113a0aa61ab7765$export$e0601b1f239fec74;
var $1113a0aa61ab7765$export$6f9b0bfc012deb25 = {
    prefix: 'fas',
    iconName: 'monument',
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322H55.9L96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$695fae58f55c3a87 = {
    prefix: 'fas',
    iconName: 'snowplow',
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M298.9 64l68.6 160H256l-64-64V64H298.9zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48V160H96c-17.7 0-32 14.3-32 32V298.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V320 235.2L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288H448V256.7c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48H368zM144 400c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zm216 24c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm-56-24c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zM200 424c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $1113a0aa61ab7765$export$48b60f1720e09944 = {
    prefix: 'fas',
    iconName: 'angles-right',
    icon: [
        512,
        512,
        [
            187,
            "angle-double-right"
        ],
        "f101",
        "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var $1113a0aa61ab7765$export$792931403404faf0 = $1113a0aa61ab7765$export$48b60f1720e09944;
var $1113a0aa61ab7765$export$8ec2f752344b69bd = {
    prefix: 'fas',
    iconName: 'cannabis',
    icon: [
        512,
        512,
        [],
        "f55f",
        "M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V417.2l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"
    ]
};
var $1113a0aa61ab7765$export$86c4e45dc3302d15 = {
    prefix: 'fas',
    iconName: 'circle-play',
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"
    ]
};
var $1113a0aa61ab7765$export$cf04333781061c5e = $1113a0aa61ab7765$export$86c4e45dc3302d15;
var $1113a0aa61ab7765$export$bed2b0ed4ae45e0d = {
    prefix: 'fas',
    iconName: 'tablets',
    icon: [
        640,
        512,
        [],
        "f490",
        "M614.3 247c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7c-7.9 5.2-8.5 16.2-1.8 22.9L591.4 248.8c6.7 6.7 17.8 6.2 22.9-1.8zM567 294.3c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8c-16.3 25-25.7 54.9-25.7 87c0 88.4 71.6 160 160 160c32.1 0 61.9-9.4 87-25.7zM301.5 368H18.5c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5c2-9.3-5.5-17.5-15-17.5zm0-32c9.5 0 16.9-8.2 15-17.5C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5H301.5z"
    ]
};
var $1113a0aa61ab7765$export$6bad2c9f317b52e5 = {
    prefix: 'fas',
    iconName: 'ethernet',
    icon: [
        512,
        512,
        [],
        "f796",
        "M0 224V416c0 17.7 14.3 32 32 32H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448V160c0-17.7-14.3-32-32-32H384V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $1113a0aa61ab7765$export$902a3969bb113dff = {
    prefix: 'fas',
    iconName: 'euro-sign',
    icon: [
        320,
        512,
        [
            8364,
            "eur",
            "euro"
        ],
        "f153",
        "M48.1 240c-.1 2.7-.1 5.3-.1 8v16c0 2.7 0 5.3 .1 8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H60.3C89.9 419.9 170 480 264 480h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264c-57.9 0-108.2-32.4-133.9-80H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c-.1-2.6-.2-5.3-.2-8V248c0-2.7 .1-5.4 .2-8H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c25.7-47.6 76-80 133.9-80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264C170 32 89.9 92.1 60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48.1z"
    ]
};
var $1113a0aa61ab7765$export$4b859160cfeb12ff = $1113a0aa61ab7765$export$902a3969bb113dff;
var $1113a0aa61ab7765$export$bdabbefede2d3a2 = $1113a0aa61ab7765$export$902a3969bb113dff;
var $1113a0aa61ab7765$export$a339864ee3df7e9a = {
    prefix: 'fas',
    iconName: 'chair',
    icon: [
        448,
        512,
        [
            129681
        ],
        "f6c0",
        "M248 48V256h48V58.7c23.9 13.8 40 39.7 40 69.3V256h48V128C384 57.3 326.7 0 256 0H192C121.3 0 64 57.3 64 128V256h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48h48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288H48z"
    ]
};
var $1113a0aa61ab7765$export$c2e9877668862374 = {
    prefix: 'fas',
    iconName: 'circle-check',
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $1113a0aa61ab7765$export$be9e388158c74f29 = $1113a0aa61ab7765$export$c2e9877668862374;
var $1113a0aa61ab7765$export$229de76dfef2687f = {
    prefix: 'fas',
    iconName: 'circle-stop',
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$47af2aad60ab3e7c = $1113a0aa61ab7765$export$229de76dfef2687f;
var $1113a0aa61ab7765$export$aaaddd2cf7e20f64 = {
    prefix: 'fas',
    iconName: 'compass-drafting',
    icon: [
        512,
        512,
        [
            "drafting-compass"
        ],
        "f568",
        "M352 96c0 14.3-3.1 27.9-8.8 40.2L396 227.4c-23.7 25.3-54.2 44.1-88.5 53.6L256 192h0 0l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496V440.6c0-8.4 2.2-16.7 6.5-24.1l60-103.7C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1V496c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$c8c2b127d13b9d79 = $1113a0aa61ab7765$export$aaaddd2cf7e20f64;
var $1113a0aa61ab7765$export$2eff9f6cbe00a643 = {
    prefix: 'fas',
    iconName: 'plate-wheat',
    icon: [
        512,
        512,
        [],
        "e55a",
        "M176 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM56 64h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 136H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48zM400 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm80 160v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80zm-96 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320H484.2c14.8 0 26.2 12.9 24.4 27.6C502.3 397.8 464.2 437 416 446v2c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-2c-48.2-9-86.3-48.2-92.5-98.4z"
    ]
};
var $1113a0aa61ab7765$export$78792ed87d92a3ad = {
    prefix: 'fas',
    iconName: 'icicles',
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H482.4C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"
    ]
};
var $1113a0aa61ab7765$export$d359c2cc7640953c = {
    prefix: 'fas',
    iconName: 'person-shelter',
    icon: [
        512,
        512,
        [],
        "e54f",
        "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160V480c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9 448 178.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40zm-8 280V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $1113a0aa61ab7765$export$771cf879fba0cf93 = {
    prefix: 'fas',
    iconName: 'neuter',
    icon: [
        384,
        512,
        [
            9906
        ],
        "f22c",
        "M304 176c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V349.1z"
    ]
};
var $1113a0aa61ab7765$export$a75288855ea05282 = {
    prefix: 'fas',
    iconName: 'id-badge',
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm96-96c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$e6789173649caa25 = {
    prefix: 'fas',
    iconName: 'marker',
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7 316.3 325.7 481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3L163.7 218.3 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"
    ]
};
var $1113a0aa61ab7765$export$3f2d51c0547bf984 = {
    prefix: 'fas',
    iconName: 'face-laugh-beam',
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM101.6 314c-3.7-13.7 7.5-26 21.7-26H388.7c14.2 0 25.4 12.3 21.7 26C392 382 329.8 432 256 432s-136-50-154.4-118zm116-101.2l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $1113a0aa61ab7765$export$a88d1f4073ea9369 = $1113a0aa61ab7765$export$3f2d51c0547bf984;
var $1113a0aa61ab7765$export$2a66e6044c1f7036 = {
    prefix: 'fas',
    iconName: 'helicopter-symbol',
    icon: [
        512,
        512,
        [],
        "e502",
        "M445.3 224H510C495.6 108.2 403.8 16.4 288 2V66.7C368.4 80.1 431.9 143.6 445.3 224zM510 288H445.3C431.9 368.4 368.4 431.9 288 445.4V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V445.4C143.6 431.9 80.1 368.4 66.7 288H2zm0-64H66.7C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V288h96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H208V160z"
    ]
};
var $1113a0aa61ab7765$export$e119aada7f690d05 = {
    prefix: 'fas',
    iconName: 'universal-access',
    icon: [
        512,
        512,
        [],
        "f29a",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM161.5 169.9c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6V235.5c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40z"
    ]
};
var $1113a0aa61ab7765$export$7b69b3617b84259b = {
    prefix: 'fas',
    iconName: 'circle-chevron-up',
    icon: [
        512,
        512,
        [
            "chevron-circle-up"
        ],
        "f139",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"
    ]
};
var $1113a0aa61ab7765$export$b786cf5db03f2c36 = $1113a0aa61ab7765$export$7b69b3617b84259b;
var $1113a0aa61ab7765$export$d317bc452442782d = {
    prefix: 'fas',
    iconName: 'lari-sign',
    icon: [
        384,
        512,
        [],
        "e1c8",
        "M144 32c17.7 0 32 14.3 32 32V96.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2c3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3V256c0 17.7-14.3 32-32 32s-32-14.3-32-32V161c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32V188.1C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H192 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$bae30a76735500e1 = {
    prefix: 'fas',
    iconName: 'volcano',
    icon: [
        512,
        512,
        [
            127755
        ],
        "f770",
        "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8c19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l9.7-14.6-59-66.3c-9.1-10.2-22.2-16.1-35.9-16.1H235.1c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4L144 352zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"
    ]
};
var $1113a0aa61ab7765$export$a1d09c95bee8043b = {
    prefix: 'fas',
    iconName: 'person-walking-dashed-line-arrow-right',
    icon: [
        640,
        512,
        [],
        "e553",
        "M208 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM392 320c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440z"
    ]
};
var $1113a0aa61ab7765$export$170c56774c8e7961 = {
    prefix: 'fas',
    iconName: 'sterling-sign',
    icon: [
        384,
        512,
        [
            163,
            "gbp",
            "pound-sign"
        ],
        "f154",
        "M144 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L249 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C137.5 32 80 89.5 80 160.4V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H80v44.5c0 17.4-4.7 34.5-13.7 49.4L36.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S52.5 480 64 480H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H120.5l.7-1.1C136.1 390 144 361.5 144 332.5V288H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H144V160.4z"
    ]
};
var $1113a0aa61ab7765$export$3d9479ec1d1ae83e = $1113a0aa61ab7765$export$170c56774c8e7961;
var $1113a0aa61ab7765$export$9ce041dfec8319b = $1113a0aa61ab7765$export$170c56774c8e7961;
var $1113a0aa61ab7765$export$ee194b18f5c6f6b6 = {
    prefix: 'fas',
    iconName: 'viruses',
    icon: [
        640,
        512,
        [],
        "e076",
        "M192 0c13.3 0 24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zm48 224c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm-48-64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$8aaca358568da0e0 = {
    prefix: 'fas',
    iconName: 'square-person-confined',
    icon: [
        448,
        512,
        [],
        "e577",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM256 144c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM240 248c0-30.9 25.1-56 56-56s56 25.1 56 56V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7V248z"
    ]
};
var $1113a0aa61ab7765$export$48c51dda34e9f04c = {
    prefix: 'fas',
    iconName: 'user-tie',
    icon: [
        448,
        512,
        [],
        "f508",
        "M224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 39.5-161.2c77.2 12 136.3 78.8 136.3 159.4c0 17-13.8 30.7-30.7 30.7H265.1 182.9 30.7C13.8 512 0 498.2 0 481.3c0-80.6 59.1-147.4 136.3-159.4l39.5 161.2 33.4-123.9z"
    ]
};
var $1113a0aa61ab7765$export$5977e8de7e65b20 = {
    prefix: 'fas',
    iconName: 'arrow-down-long',
    icon: [
        384,
        512,
        [
            "long-arrow-down"
        ],
        "f175",
        "M224 402.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V402.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7z"
    ]
};
var $1113a0aa61ab7765$export$52ecf90b62f3f030 = $1113a0aa61ab7765$export$5977e8de7e65b20;
var $1113a0aa61ab7765$export$8a4f323f00a91606 = {
    prefix: 'fas',
    iconName: 'tent-arrow-down-to-line',
    icon: [
        640,
        512,
        [],
        "e57e",
        "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5 .2 31.6 14.4 31.6 32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H159.6l.7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448h76.8L384 320V448z"
    ]
};
var $1113a0aa61ab7765$export$a881f37164b11fbf = {
    prefix: 'fas',
    iconName: 'certificate',
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.3-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"
    ]
};
var $1113a0aa61ab7765$export$ca6fd367f31ecbc5 = {
    prefix: 'fas',
    iconName: 'reply-all',
    icon: [
        576,
        512,
        [
            "mail-reply-all"
        ],
        "f122",
        "M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3 .9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V288h32c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H352V64z"
    ]
};
var $1113a0aa61ab7765$export$8274334f3a2c1841 = $1113a0aa61ab7765$export$ca6fd367f31ecbc5;
var $1113a0aa61ab7765$export$60710f3921019268 = {
    prefix: 'fas',
    iconName: 'suitcase',
    icon: [
        512,
        512,
        [
            129523
        ],
        "f0f2",
        "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96v32V480H128V128 96zM64 96H96V480H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM448 480H416V96h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z"
    ]
};
var $1113a0aa61ab7765$export$f3854553fe688388 = {
    prefix: 'fas',
    iconName: 'person-skating',
    icon: [
        448,
        512,
        [
            "skating"
        ],
        "f7c5",
        "M448 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM128 128c0-17.7 14.3-32 32-32H319.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V349.3l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
    ]
};
var $1113a0aa61ab7765$export$21bd1d54bd4f2c5a = $1113a0aa61ab7765$export$f3854553fe688388;
var $1113a0aa61ab7765$export$3300e4b4d1d1936f = {
    prefix: 'fas',
    iconName: 'filter-circle-dollar',
    icon: [
        576,
        512,
        [
            "funnel-dollar"
        ],
        "f662",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM576 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM408.8 335.4c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"
    ]
};
var $1113a0aa61ab7765$export$cebe38ad8f0a143d = $1113a0aa61ab7765$export$3300e4b4d1d1936f;
var $1113a0aa61ab7765$export$41dbdadc07a89b05 = {
    prefix: 'fas',
    iconName: 'camera-retro',
    icon: [
        512,
        512,
        [
            128247
        ],
        "f083",
        "M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM344 304c0 48.6-39.4 88-88 88s-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88z"
    ]
};
var $1113a0aa61ab7765$export$a30c52cde32bec7e = {
    prefix: 'fas',
    iconName: 'circle-arrow-down',
    icon: [
        512,
        512,
        [
            "arrow-circle-down"
        ],
        "f0ab",
        "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM127 297c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 214.1 71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 409c-9.4 9.4-24.6 9.4-33.9 0L127 297z"
    ]
};
var $1113a0aa61ab7765$export$6cfa36bbb3a057 = $1113a0aa61ab7765$export$a30c52cde32bec7e;
var $1113a0aa61ab7765$export$d796c05153b1255c = {
    prefix: 'fas',
    iconName: 'file-import',
    icon: [
        512,
        512,
        [
            "arrow-right-to-file"
        ],
        "f56f",
        "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z"
    ]
};
var $1113a0aa61ab7765$export$32f14beaf6294476 = $1113a0aa61ab7765$export$d796c05153b1255c;
var $1113a0aa61ab7765$export$38150b61dfd06fff = {
    prefix: 'fas',
    iconName: 'square-arrow-up-right',
    icon: [
        448,
        512,
        [
            "external-link-square"
        ],
        "f14c",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"
    ]
};
var $1113a0aa61ab7765$export$e04d83fed5ebcebf = $1113a0aa61ab7765$export$38150b61dfd06fff;
var $1113a0aa61ab7765$export$9010ed816a8b9c97 = {
    prefix: 'fas',
    iconName: 'box-open',
    icon: [
        640,
        512,
        [],
        "f49e",
        "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128h2.2z"
    ]
};
var $1113a0aa61ab7765$export$7c265716d4399676 = {
    prefix: 'fas',
    iconName: 'scroll',
    icon: [
        576,
        512,
        [
            128220
        ],
        "f70e",
        "M0 80v48c0 17.7 14.3 32 32 32H48 96V80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48V384c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7V384c0 53-43 96-96 96H368h96z"
    ]
};
var $1113a0aa61ab7765$export$f9a38ef7b046ab51 = {
    prefix: 'fas',
    iconName: 'spa',
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480H288 267.9C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"
    ]
};
var $1113a0aa61ab7765$export$db853fbb474326cc = {
    prefix: 'fas',
    iconName: 'location-pin-lock',
    icon: [
        512,
        512,
        [],
        "e51f",
        "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3V352c0-23.7 12.9-44.4 32-55.4V272c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 256c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm208-16c17.7 0 32 14.3 32 32v48H368V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $1113a0aa61ab7765$export$da79f048408b1722 = {
    prefix: 'fas',
    iconName: 'pause',
    icon: [
        320,
        512,
        [
            9208
        ],
        "f04c",
        "M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"
    ]
};
var $1113a0aa61ab7765$export$50d11c98c99e3b2d = {
    prefix: 'fas',
    iconName: 'hill-avalanche',
    icon: [
        640,
        512,
        [],
        "e507",
        "M471.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C433.2 261.3 448 236.4 448 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C248.3 46.6 229.9 32 208 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L471.7 401.9zM512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0 128c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM100.3 87C75.1 61.8 32 79.7 32 115.3V432c0 44.2 35.8 80 80 80H428.7c35.6 0 53.5-43.1 28.3-68.3L100.3 87z"
    ]
};
var $1113a0aa61ab7765$export$ac389bf5cc37feb5 = {
    prefix: 'fas',
    iconName: 'temperature-empty',
    icon: [
        320,
        512,
        [
            "temperature-0",
            "thermometer-0",
            "thermometer-empty"
        ],
        "f2cb",
        "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM160 0C98.1 0 48 50.2 48 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C272 50.2 221.9 0 160 0zm0 416c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $1113a0aa61ab7765$export$e99b7d2ccc282383 = $1113a0aa61ab7765$export$ac389bf5cc37feb5;
var $1113a0aa61ab7765$export$4c13a186ecce3b80 = $1113a0aa61ab7765$export$ac389bf5cc37feb5;
var $1113a0aa61ab7765$export$81a2f8298cf523f9 = $1113a0aa61ab7765$export$ac389bf5cc37feb5;
var $1113a0aa61ab7765$export$d59078f6e80b4a67 = {
    prefix: 'fas',
    iconName: 'bomb',
    icon: [
        512,
        512,
        [
            128163
        ],
        "f1e2",
        "M459.1 52.4L442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"
    ]
};
var $1113a0aa61ab7765$export$5f519e9ac15ab8c3 = {
    prefix: 'fas',
    iconName: 'registered',
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM160 152c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64z"
    ]
};
var $1113a0aa61ab7765$export$6ea408c7266ed557 = {
    prefix: 'fas',
    iconName: 'address-card',
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm96-96c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm128-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$4ac51eb0b298b190 = $1113a0aa61ab7765$export$6ea408c7266ed557;
var $1113a0aa61ab7765$export$91228257deb1bf18 = $1113a0aa61ab7765$export$6ea408c7266ed557;
var $1113a0aa61ab7765$export$f4d7840209109993 = {
    prefix: 'fas',
    iconName: 'scale-unbalanced-flip',
    icon: [
        640,
        512,
        [
            "balance-scale-right"
        ],
        "f516",
        "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42zm396.3 211c-.4-.8-1.3-1.3-2.2-1.3s-1.7 .5-2.2 1.3L435.1 416H588.9L514.2 273.3zM512 224c18.8 0 36 10.4 44.7 27l77.8 148.5c3.1 5.8 6.1 14 5.5 23.8c-.7 12.1-4.8 35.2-24.8 55.1C594.9 498.6 562.2 512 512 512s-82.9-13.4-103.2-33.5c-20-20-24.2-43-24.8-55.1c-.6-9.8 2.5-18 5.5-23.8L467.3 251c8.7-16.6 25.9-27 44.7-27zM128 144c-.9 0-1.7 .5-2.2 1.3L51.1 288H204.9L130.2 145.3c-.4-.8-1.3-1.3-2.2-1.3zm44.7-21l77.8 148.5c3.1 5.8 6.1 14 5.5 23.8c-.7 12.1-4.8 35.2-24.8 55.1C210.9 370.6 178.2 384 128 384s-82.9-13.4-103.2-33.5c-20-20-24.2-43-24.8-55.1c-.6-9.8 2.5-18 5.5-23.8L83.3 123C92 106.4 109.2 96 128 96s36 10.4 44.7 27z"
    ]
};
var $1113a0aa61ab7765$export$2238e05f8920005a = $1113a0aa61ab7765$export$f4d7840209109993;
var $1113a0aa61ab7765$export$34c1e678c32ed646 = {
    prefix: 'fas',
    iconName: 'subscript',
    icon: [
        512,
        512,
        [],
        "f12c",
        "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32zM480 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320z"
    ]
};
var $1113a0aa61ab7765$export$99749ac517cbef07 = {
    prefix: 'fas',
    iconName: 'diamond-turn-right',
    icon: [
        512,
        512,
        [
            "directions"
        ],
        "f5eb",
        "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
    ]
};
var $1113a0aa61ab7765$export$6a6973de44442fe5 = $1113a0aa61ab7765$export$99749ac517cbef07;
var $1113a0aa61ab7765$export$ea2986b45ba5d2cf = {
    prefix: 'fas',
    iconName: 'burst',
    icon: [
        512,
        512,
        [],
        "e4dc",
        "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"
    ]
};
var $1113a0aa61ab7765$export$6486d62e77b910 = {
    prefix: 'fas',
    iconName: 'house-laptop',
    icon: [
        640,
        512,
        [
            "laptop-house"
        ],
        "e066",
        "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64V416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304V448H544V304H352zm-48-16c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V448h32c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H544 352 304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16h32V288z"
    ]
};
var $1113a0aa61ab7765$export$efd983de5e4d6ad3 = $1113a0aa61ab7765$export$6486d62e77b910;
var $1113a0aa61ab7765$export$5352cbdc070ce8d = {
    prefix: 'fas',
    iconName: 'face-tired',
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $1113a0aa61ab7765$export$3d016d62cda18371 = $1113a0aa61ab7765$export$5352cbdc070ce8d;
var $1113a0aa61ab7765$export$a822dad6e586ee9e = {
    prefix: 'fas',
    iconName: 'money-bills',
    icon: [
        640,
        512,
        [],
        "e1f3",
        "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64H160V256zM224 96c0 35.3-28.7 64-64 64V96h64zM576 256v64H512c0-35.3 28.7-64 64-64zM512 96h64v64c-35.3 0-64-28.7-64-64zM448 208c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"
    ]
};
var $1113a0aa61ab7765$export$aa11b8edb09fed14 = {
    prefix: 'fas',
    iconName: 'smog',
    icon: [
        640,
        512,
        [],
        "f75f",
        "M32 144c0 79.5 64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144zM616 368H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24zM224 392c0-13.3-10.7-24-24-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24z"
    ]
};
var $1113a0aa61ab7765$export$e94134641c0e2 = {
    prefix: 'fas',
    iconName: 'crutch',
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144l-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1L116.8 342.9c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7c0 0 .1-.1 .1-.1s.1-.1 .1-.1l74.6-74.6-45.3-45.3L336 242.7 269.3 176l52.1-52.1L276.1 78.6l-74.7 74.7zM224 221.3L290.7 288l-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7L224 221.3z"
    ]
};
var $1113a0aa61ab7765$export$aa4baaed1c60f58d = {
    prefix: 'fas',
    iconName: 'font-awesome',
    icon: [
        448,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M448 48V384c-63.1 22.5-82.3 32-119.5 32c-62.8 0-86.6-32-149.3-32c-20.6 0-36.6 3.6-51.2 8.2v-64c14.6-4.6 30.6-8.2 51.2-8.2c62.7 0 86.5 32 149.3 32c20.4 0 35.6-3 55.5-9.3v-208c-19.9 6.3-35.1 9.3-55.5 9.3c-62.8 0-86.6-32-149.3-32c-50.8 0-74.9 20.6-115.2 28.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32s32 14.3 32 32V76.7c40.3-8 64.4-28.7 115.2-28.7c62.7 0 86.5 32 149.3 32c37.1 0 56.4-9.5 119.5-32z"
    ]
};
var $1113a0aa61ab7765$export$102c25fde54d4843 = $1113a0aa61ab7765$export$aa4baaed1c60f58d;
var $1113a0aa61ab7765$export$6e20d421a2e0f320 = $1113a0aa61ab7765$export$aa4baaed1c60f58d;
var $1113a0aa61ab7765$export$3507214fff1cc655 = {
    prefix: 'fas',
    iconName: 'cloud-arrow-up',
    icon: [
        640,
        512,
        [
            62338,
            "cloud-upload",
            "cloud-upload-alt"
        ],
        "f0ee",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
    ]
};
var $1113a0aa61ab7765$export$a48720e6366f5d9a = $1113a0aa61ab7765$export$3507214fff1cc655;
var $1113a0aa61ab7765$export$e73b3e819b9d14a5 = $1113a0aa61ab7765$export$3507214fff1cc655;
var $1113a0aa61ab7765$export$5c390baea5db4f77 = {
    prefix: 'fas',
    iconName: 'palette',
    icon: [
        512,
        512,
        [
            127912
        ],
        "f53f",
        "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0-96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$db9f783f15682c4a = {
    prefix: 'fas',
    iconName: 'arrows-turn-right',
    icon: [
        512,
        512,
        [],
        "e4c0",
        "M329.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 160H160c-35.3 0-64 28.7-64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V224C32 153.3 89.3 96 160 96H370.7L329.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 416H128c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96H274.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $1113a0aa61ab7765$export$c8370e53051a657 = {
    prefix: 'fas',
    iconName: 'vest',
    icon: [
        448,
        512,
        [],
        "e085",
        "M207.1 237.4L151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6V128 54.3 48c0-26.5-21.5-48-48-48h-4.5c-.2 0-.4 0-.6 0c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0c-.2 0-.4 0-.6 0H112C85.5 0 64 21.5 64 48v6.3V128v17.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48H176c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1zM347.3 356.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
    ]
};
var $1113a0aa61ab7765$export$fd312949b97346ae = {
    prefix: 'fas',
    iconName: 'ferry',
    icon: [
        576,
        512,
        [],
        "e4ea",
        "M224 0H352c17.7 0 32 14.3 32 32h75.1c20.6 0 31.6 24.3 18.1 39.8L456 96H120L98.8 71.8C85.3 56.3 96.3 32 116.9 32H192c0-17.7 14.3-32 32-32zM96 128H480c17.7 0 32 14.3 32 32V283.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5c-15.5 10.7-34 18-51 19.9H375.6c-17.1-1.8-35-9-50.8-19.9c-22.1-15.5-51.6-15.5-73.7 0c-14.8 10.2-32.5 18-50.6 19.9H183.9c-17-1.8-35.6-9.2-51-19.9c-1.8-1.3-3.7-2.4-5.6-3.5L75.9 320.7C68.2 309.8 64 296.8 64 283.5V160c0-17.7 14.3-32 32-32zm32 64v96H448V192H128zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $1113a0aa61ab7765$export$cfb044c7d35060bb = {
    prefix: 'fas',
    iconName: 'arrows-down-to-people',
    icon: [
        640,
        512,
        [],
        "e4b9",
        "M144 0c-13.3 0-24 10.7-24 24V142.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zM360 200c0-22.1-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40s40-17.9 40-40zM184 296c0-22.1-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40s40-17.9 40-40zm312 40c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V345.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V142.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
var $1113a0aa61ab7765$export$d7b60b8dbd03cfe4 = {
    prefix: 'fas',
    iconName: 'seedling',
    icon: [
        512,
        512,
        [
            127793,
            "sprout"
        ],
        "f4d8",
        "M512 64c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 78.3 364 32 448 32h32c17.7 0 32 14.3 32 32zM0 128c0-17.7 14.3-32 32-32H64c123.7 0 224 100.3 224 224v32 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C100.3 352 0 251.7 0 128z"
    ]
};
var $1113a0aa61ab7765$export$9f3035e3a8c62323 = $1113a0aa61ab7765$export$d7b60b8dbd03cfe4;
var $1113a0aa61ab7765$export$47d93e9001818ee7 = {
    prefix: 'fas',
    iconName: 'left-right',
    icon: [
        512,
        512,
        [
            8596,
            "arrows-alt-h"
        ],
        "f337",
        "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"
    ]
};
var $1113a0aa61ab7765$export$7937ea574fb1389 = $1113a0aa61ab7765$export$47d93e9001818ee7;
var $1113a0aa61ab7765$export$e81e7f3390fe84fe = {
    prefix: 'fas',
    iconName: 'boxes-packing',
    icon: [
        640,
        512,
        [],
        "e4c7",
        "M256 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H256V48zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V176zm352 80V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256H352zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"
    ]
};
var $1113a0aa61ab7765$export$827fbb87bdbe1028 = {
    prefix: 'fas',
    iconName: 'circle-arrow-left',
    icon: [
        512,
        512,
        [
            "arrow-circle-left"
        ],
        "f0a8",
        "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512s256-114.6 256-256zM215 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L392 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-214.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L103 273c-9.4-9.4-9.4-24.6 0-33.9L215 127z"
    ]
};
var $1113a0aa61ab7765$export$728262abb9f58d0a = $1113a0aa61ab7765$export$827fbb87bdbe1028;
var $1113a0aa61ab7765$export$88a8383ecdd39a54 = {
    prefix: 'fas',
    iconName: 'group-arrows-rotate',
    icon: [
        512,
        512,
        [],
        "e4f6",
        "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5c-21.5 6.4-41.8 15.5-60.6 27C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-11.5 18.7-20.6 39-27 60.6c-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.2-.3c7.5 12.9 13.6 26.8 17.9 41.4c5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.6c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8c6.4 21.5 15.5 41.8 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c18.7 11.5 39 20.6 60.6 27c16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9c.2-2 .3-4.1 .3-6.2c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.2 .3c-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-4.3 14.6-10.4 28.5-17.9 41.4c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.2c-12.9 7.5-26.8 13.6-41.4 17.9c-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.6-27c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c11.5-18.7 20.6-39 27-60.6zM192.8 256.8c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4V163.2c0-5.7-4.7-10.4-10.4-10.4H169.9c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4v60.5c0 5.7 4.7 10.4 10.4 10.4h60.5c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"
    ]
};
var $1113a0aa61ab7765$export$8b89ca3201039376 = {
    prefix: 'fas',
    iconName: 'bowl-food',
    icon: [
        512,
        512,
        [],
        "e4c6",
        "M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"
    ]
};
var $1113a0aa61ab7765$export$14d66ba7571ae0b9 = {
    prefix: 'fas',
    iconName: 'candy-cane',
    icon: [
        512,
        512,
        [],
        "f786",
        "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"
    ]
};
var $1113a0aa61ab7765$export$4229d00802c33062 = {
    prefix: 'fas',
    iconName: 'arrow-down-wide-short',
    icon: [
        576,
        512,
        [
            "sort-amount-asc",
            "sort-amount-down"
        ],
        "f160",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z"
    ]
};
var $1113a0aa61ab7765$export$ddf8b8dd5983367d = $1113a0aa61ab7765$export$4229d00802c33062;
var $1113a0aa61ab7765$export$4b2a02d50e417b5f = $1113a0aa61ab7765$export$4229d00802c33062;
var $1113a0aa61ab7765$export$cdd116afa0309c17 = {
    prefix: 'fas',
    iconName: 'cloud-bolt',
    icon: [
        512,
        512,
        [
            127785,
            "thunderstorm"
        ],
        "f76c",
        "M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320H352h64c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
    ]
};
var $1113a0aa61ab7765$export$bbf9e3d433f8f6de = $1113a0aa61ab7765$export$cdd116afa0309c17;
var $1113a0aa61ab7765$export$ec658c0f040c3e1a = {
    prefix: 'fas',
    iconName: 'text-slash',
    icon: [
        640,
        512,
        [
            "remove-format"
        ],
        "f87d",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l16-64c2.4-9.6 .2-19.7-5.8-27.5S553.9 32 544 32H376.1h-.3H192c-14.7 0-27.5 10-31 24.2l-9.3 37.3L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l-94.5-74.1zM243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1L272.9 311 243.3 416z"
    ]
};
var $1113a0aa61ab7765$export$d91179f327329532 = $1113a0aa61ab7765$export$ec658c0f040c3e1a;
var $1113a0aa61ab7765$export$6143da800b0e6626 = {
    prefix: 'fas',
    iconName: 'face-smile-wink',
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM208.4 208c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm92.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
var $1113a0aa61ab7765$export$f5dbb37f6801ee3f = $1113a0aa61ab7765$export$6143da800b0e6626;
var $1113a0aa61ab7765$export$f0858dff6e769cf6 = {
    prefix: 'fas',
    iconName: 'file-word',
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12.1 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"
    ]
};
var $1113a0aa61ab7765$export$c341daeecdea449a = {
    prefix: 'fas',
    iconName: 'file-powerpoint',
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM136 240h68c42 0 76 34 76 76s-34 76-76 76H160v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V368 264c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28H160v56h44z"
    ]
};
var $1113a0aa61ab7765$export$672e2f590b189583 = {
    prefix: 'fas',
    iconName: 'arrows-left-right',
    icon: [
        512,
        512,
        [
            "arrows-h"
        ],
        "f07e",
        "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var $1113a0aa61ab7765$export$de517642cdb40354 = $1113a0aa61ab7765$export$672e2f590b189583;
var $1113a0aa61ab7765$export$aa54b16c409e882f = {
    prefix: 'fas',
    iconName: 'house-lock',
    icon: [
        640,
        512,
        [],
        "e510",
        "M384 480c0 11.7 3.1 22.6 8.6 32H384c-17.7 0-32-14.3-32-32V383.7c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32V480c0 17.7-14.3 32-32 32H96.1c-17.7 0-32-14.3-32-32V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L490.7 166.3C447.2 181.7 416 223.2 416 272v24.6c-19.1 11.1-32 31.7-32 55.4V480zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $1113a0aa61ab7765$export$542a9676c5286e01 = {
    prefix: 'fas',
    iconName: 'cloud-arrow-down',
    icon: [
        640,
        512,
        [
            62337,
            "cloud-download",
            "cloud-download-alt"
        ],
        "f0ed",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
var $1113a0aa61ab7765$export$b318977f29260464 = $1113a0aa61ab7765$export$542a9676c5286e01;
var $1113a0aa61ab7765$export$351357a14c41f824 = $1113a0aa61ab7765$export$542a9676c5286e01;
var $1113a0aa61ab7765$export$f2819bf60df55912 = {
    prefix: 'fas',
    iconName: 'children',
    icon: [
        640,
        512,
        [],
        "e4e1",
        "M160 128c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM88 480V400H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H152v80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 128c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm-8 256v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9L619.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L552 300.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H472z"
    ]
};
var $1113a0aa61ab7765$export$49a36efd66df775 = {
    prefix: 'fas',
    iconName: 'chalkboard',
    icon: [
        576,
        512,
        [
            "blackboard"
        ],
        "f51b",
        "M96 32C60.7 32 32 60.7 32 96V384H96V96l384 0V384h64V96c0-35.3-28.7-64-64-64H96zM224 384v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"
    ]
};
var $1113a0aa61ab7765$export$f497e01bf522fd9c = $1113a0aa61ab7765$export$49a36efd66df775;
var $1113a0aa61ab7765$export$ae7fc6b7f0534be9 = {
    prefix: 'fas',
    iconName: 'user-large-slash',
    icon: [
        640,
        512,
        [
            "user-alt-slash"
        ],
        "f4fa",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H528L284.3 320z"
    ]
};
var $1113a0aa61ab7765$export$46185fab4772ada6 = $1113a0aa61ab7765$export$ae7fc6b7f0534be9;
var $1113a0aa61ab7765$export$c6c3bd5f7d9b8bf2 = {
    prefix: 'fas',
    iconName: 'envelope-open',
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M64 208.1L256 65.9 448 208.1v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5V208.1zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"
    ]
};
var $1113a0aa61ab7765$export$e99ae494101c5e91 = {
    prefix: 'fas',
    iconName: 'handshake-simple-slash',
    icon: [
        640,
        512,
        [
            "handshake-alt-slash"
        ],
        "e05f",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.4-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM0 176V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6L41.2 128.5C17.9 131.8 0 151.8 0 176z"
    ]
};
var $1113a0aa61ab7765$export$ca302f956ae9f1bf = $1113a0aa61ab7765$export$e99ae494101c5e91;
var $1113a0aa61ab7765$export$f042d3e458efa721 = {
    prefix: 'fas',
    iconName: 'mattress-pillow',
    icon: [
        640,
        512,
        [],
        "e525",
        "M256 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H256V64zm32 384H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H288V448zM64 160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"
    ]
};
var $1113a0aa61ab7765$export$b731a51acb74b00c = {
    prefix: 'fas',
    iconName: 'guarani-sign',
    icon: [
        384,
        512,
        [],
        "e19a",
        "M192 0c-17.7 0-32 14.3-32 32V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c90.8-15.2 160-94.2 160-189.3c0-17.7-14.3-32-32-32H224V132c22.1 5.7 41.8 17.1 57.6 32.6c12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7V32c0-17.7-14.3-32-32-32zM160 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380V288h92c-11.6 45-47 80.4-92 92z"
    ]
};
var $1113a0aa61ab7765$export$2fd091cb98dc8ab8 = {
    prefix: 'fas',
    iconName: 'arrows-rotate',
    icon: [
        512,
        512,
        [
            128472,
            "refresh",
            "sync"
        ],
        "f021",
        "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
    ]
};
var $1113a0aa61ab7765$export$fd4359e93d7b3d14 = $1113a0aa61ab7765$export$2fd091cb98dc8ab8;
var $1113a0aa61ab7765$export$ff87319002e3dae9 = $1113a0aa61ab7765$export$2fd091cb98dc8ab8;
var $1113a0aa61ab7765$export$d75fb6743634a0a = {
    prefix: 'fas',
    iconName: 'fire-extinguisher',
    icon: [
        512,
        512,
        [
            129519
        ],
        "f134",
        "M500.3 7.3C507.7 13.3 512 22.4 512 32v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104H224v34.8c37.8 18 64 56.5 64 101.2V384H64V240c0-44.7 26.2-83.2 64-101.2V110c-36.2 11.1-66 36.9-82.3 70.5c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C26.7 109.8 72.7 72.6 128 60.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V56h65c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM288 416v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V416H288zM176 96c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $1113a0aa61ab7765$export$64dd1b27affb6572 = {
    prefix: 'fas',
    iconName: 'cruzeiro-sign',
    icon: [
        448,
        512,
        [],
        "e152",
        "M96 256c0-88.4 71.6-160 160-160c41 0 78.3 15.4 106.7 40.7c13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57c13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416V320v-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32v55.3V320v82.7C135.5 378 96 321.6 96 256z"
    ]
};
var $1113a0aa61ab7765$export$7bf8dfe2e6661a54 = {
    prefix: 'fas',
    iconName: 'greater-than-equal',
    icon: [
        448,
        512,
        [],
        "f532",
        "M52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416z"
    ]
};
var $1113a0aa61ab7765$export$36e034ccc72554a9 = {
    prefix: 'fas',
    iconName: 'shield-halved',
    icon: [
        512,
        512,
        [
            "shield-alt"
        ],
        "f3ed",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.7 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"
    ]
};
var $1113a0aa61ab7765$export$d6508d18a824f291 = $1113a0aa61ab7765$export$36e034ccc72554a9;
var $1113a0aa61ab7765$export$7fb8daedae341012 = {
    prefix: 'fas',
    iconName: 'book-atlas',
    icon: [
        448,
        512,
        [
            "atlas"
        ],
        "f558",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9H303.5c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128zM145.3 208h31.1c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32H145.3c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"
    ]
};
var $1113a0aa61ab7765$export$380a9050e42fe5d7 = $1113a0aa61ab7765$export$7fb8daedae341012;
var $1113a0aa61ab7765$export$37c67e0b3dc6bd1b = {
    prefix: 'fas',
    iconName: 'virus',
    icon: [
        512,
        512,
        [],
        "e074",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM272 224c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zm32 104c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $1113a0aa61ab7765$export$74d890536dbd21b7 = {
    prefix: 'fas',
    iconName: 'envelope-circle-check',
    icon: [
        640,
        512,
        [],
        "e4e8",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176V384c0 35.3 28.7 64 64 64H360.2C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $1113a0aa61ab7765$export$a137712e11e257dd = {
    prefix: 'fas',
    iconName: 'layer-group',
    icon: [
        576,
        512,
        [],
        "f5fd",
        "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"
    ]
};
var $1113a0aa61ab7765$export$ab3a06d4b53c0fc0 = {
    prefix: 'fas',
    iconName: 'arrows-to-dot',
    icon: [
        512,
        512,
        [],
        "e4be",
        "M256 0c17.7 0 32 14.3 32 32V64h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H288v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H192c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224H64V192c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$d56753dd2eb5c323 = {
    prefix: 'fas',
    iconName: 'archway',
    icon: [
        512,
        512,
        [],
        "f557",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H96h64V352c0-53 43-96 96-96s96 43 96 96V480h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32V128H32V416z"
    ]
};
var $1113a0aa61ab7765$export$5e4b6785eedecc1a = {
    prefix: 'fas',
    iconName: 'heart-circle-check',
    icon: [
        576,
        512,
        [],
        "e4fd",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $1113a0aa61ab7765$export$e824540f5a6a8a57 = {
    prefix: 'fas',
    iconName: 'house-chimney-crack',
    icon: [
        576,
        512,
        [
            "house-damage"
        ],
        "f6f1",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24z"
    ]
};
var $1113a0aa61ab7765$export$8d7e943005ce0b49 = $1113a0aa61ab7765$export$e824540f5a6a8a57;
var $1113a0aa61ab7765$export$7a4a0e4caa1e4e6f = {
    prefix: 'fas',
    iconName: 'file-zipper',
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var $1113a0aa61ab7765$export$bf2047a9946b5c3f = $1113a0aa61ab7765$export$7a4a0e4caa1e4e6f;
var $1113a0aa61ab7765$export$90b4406457aae8cc = {
    prefix: 'fas',
    iconName: 'square',
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
    ]
};
var $1113a0aa61ab7765$export$a8a0de30198815a3 = {
    prefix: 'fas',
    iconName: 'martini-glass-empty',
    icon: [
        512,
        512,
        [
            "glass-martini"
        ],
        "f000",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM256 210.7L109.3 64H402.7L256 210.7z"
    ]
};
var $1113a0aa61ab7765$export$e96f280e39af4a91 = $1113a0aa61ab7765$export$a8a0de30198815a3;
var $1113a0aa61ab7765$export$ce96e32767a7dd51 = {
    prefix: 'fas',
    iconName: 'couch',
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z"
    ]
};
var $1113a0aa61ab7765$export$66c557f70914132c = {
    prefix: 'fas',
    iconName: 'cedi-sign',
    icon: [
        384,
        512,
        [],
        "e0df",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c30.9-5.2 59.2-17.7 83.2-35.8c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6V132c16.4 4.2 31.6 11.6 44.8 21.6c14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8V32zM192 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"
    ]
};
var $1113a0aa61ab7765$export$16e344bae4d495ed = {
    prefix: 'fas',
    iconName: 'italic',
    icon: [
        384,
        512,
        [],
        "f033",
        "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"
    ]
};
var $1113a0aa61ab7765$export$16a3f12c6ae9650 = {
    prefix: 'fas',
    iconName: 'church',
    icon: [
        640,
        512,
        [
            9962
        ],
        "f51d",
        "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V48H264c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V251.2c0-16.9-8.8-32.5-23.3-41.2L344 142.4V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
    ]
};
var $1113a0aa61ab7765$export$d477129b070e5ac4 = {
    prefix: 'fas',
    iconName: 'comments-dollar',
    icon: [
        640,
        512,
        [],
        "f653",
        "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"
    ]
};
var $1113a0aa61ab7765$export$a1672d808fbed0bd = {
    prefix: 'fas',
    iconName: 'democrat',
    icon: [
        640,
        512,
        [],
        "f747",
        "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H480c61.4 0 101.6 24 126.2 50c12 12.6 19.9 25.2 24.9 34.9c2.5 4.8 4.3 9 5.5 12.1c.6 1.5 1.1 2.8 1.4 3.8c.2 .5 .3 .9 .4 1.3l.1 .5 .1 .2 0 .1 0 0c0 0 0 0-30.2 9.1l30.2-9.1c5.1 16.9-4.5 34.8-21.5 39.8c-16.8 5-34.5-4.4-39.7-21.1l0 0c-.1-.2-.2-.6-.5-1.2c-.5-1.3-1.4-3.4-2.8-6.1c-2.8-5.4-7.4-12.8-14.4-20.1c-4.2-4.4-9.4-9-15.8-13.2V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352h96v64 64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V416H288v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416 352h96H448zm129.4-70.8c0 0 0 0 30.6-9.2l-30.6 9.2 0 0zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"
    ]
};
var $1113a0aa61ab7765$export$3481c1aa28972f9b = {
    prefix: 'fas',
    iconName: 'z',
    icon: [
        384,
        512,
        [
            122
        ],
        "5a",
        "M0 64C0 46.3 14.3 32 32 32H352c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $1113a0aa61ab7765$export$5ebd3cd0630e3ae7 = {
    prefix: 'fas',
    iconName: 'person-skiing',
    icon: [
        576,
        512,
        [
            9975,
            "skiing"
        ],
        "f7c9",
        "M508.7 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM34.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L264.7 361.3l46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L321.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L44.9 301.3c-11.8-6.1-16.3-20.6-10.2-32.4zM150.9 65.6L169 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2L183.5 116.7l-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"
    ]
};
var $1113a0aa61ab7765$export$eae1acab6fb96708 = $1113a0aa61ab7765$export$5ebd3cd0630e3ae7;
var $1113a0aa61ab7765$export$b81a894d5bc3eb17 = {
    prefix: 'fas',
    iconName: 'road-lock',
    icon: [
        640,
        512,
        [],
        "e567",
        "M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64h32V352c0-23.7 12.9-44.4 32-55.4V272c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $1113a0aa61ab7765$export$406fe05808a3753e = {
    prefix: 'fas',
    iconName: 'a',
    icon: [
        448,
        512,
        [
            97
        ],
        "41",
        "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384H322.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM296 320H152l72-172.8L296 320z"
    ]
};
var $1113a0aa61ab7765$export$4520eb1840c4e110 = {
    prefix: 'fas',
    iconName: 'temperature-arrow-down',
    icon: [
        512,
        512,
        [
            "temperature-down"
        ],
        "e03f",
        "M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.1 32 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.1 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm336-64H448V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352H352c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8z"
    ]
};
var $1113a0aa61ab7765$export$f0b2aca3866f00f6 = $1113a0aa61ab7765$export$4520eb1840c4e110;
var $1113a0aa61ab7765$export$2a9d3e120019c92d = {
    prefix: 'fas',
    iconName: 'feather-pointed',
    icon: [
        512,
        512,
        [
            "feather-alt"
        ],
        "f56b",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c2.1 7.9 12 9.6 17.8 3.8L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
var $1113a0aa61ab7765$export$68cf766c786bcd78 = $1113a0aa61ab7765$export$2a9d3e120019c92d;
var $1113a0aa61ab7765$export$bcb419f1cd5beac3 = {
    prefix: 'fas',
    iconName: 'p',
    icon: [
        320,
        512,
        [
            112
        ],
        "50",
        "M32 32H64h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 320 288 64C0 46.3 14.3 32 32 32zM64 288h96c53 0 96-43 96-96s-43-96-96-96H64V288z"
    ]
};
var $1113a0aa61ab7765$export$bab8f3647c394f48 = {
    prefix: 'fas',
    iconName: 'snowflake',
    icon: [
        448,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.7 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$d91b374112d4f8c1 = {
    prefix: 'fas',
    iconName: 'newspaper',
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm0 184c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zM160 400c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"
    ]
};
var $1113a0aa61ab7765$export$d0ccaddca9e06d1e = {
    prefix: 'fas',
    iconName: 'rectangle-ad',
    icon: [
        576,
        512,
        [
            "ad"
        ],
        "f641",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280h42.3L208 237.7zM392 256c-13.3 0-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"
    ]
};
var $1113a0aa61ab7765$export$7af266c3465b1ff2 = $1113a0aa61ab7765$export$d0ccaddca9e06d1e;
var $1113a0aa61ab7765$export$2f1e22e081a1ad05 = {
    prefix: 'fas',
    iconName: 'circle-arrow-right',
    icon: [
        512,
        512,
        [
            "arrow-circle-right"
        ],
        "f0a9",
        "M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zM297 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L120 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l214.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L409 239c9.4 9.4 9.4 24.6 0 33.9L297 385z"
    ]
};
var $1113a0aa61ab7765$export$7d3d828103aa3be7 = $1113a0aa61ab7765$export$2f1e22e081a1ad05;
var $1113a0aa61ab7765$export$fb5ab619c34ea613 = {
    prefix: 'fas',
    iconName: 'filter-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e17b",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm59.3-180.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $1113a0aa61ab7765$export$4982360d3b844c19 = {
    prefix: 'fas',
    iconName: 'locust',
    icon: [
        640,
        512,
        [],
        "e520",
        "M344 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4c-9-3.5-18.8-5.4-29-5.4H463.8l-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L247.1 400h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L380 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L515.6 400H528c44.1 0 79.8-35.7 80-79.7c0-.1 0-.2 0-.3V280C608 143 497 32 360 32H344zm50.5 168l17.1 40H365l29.5-40zm-87.7 38.1l-1.4 1.9H257.1l32.7-41.5 16.9 39.5zM120.8 240C89.4 240 64 265.4 64 296.8c0 15.5 6.3 30 16.9 40.4L158.7 240H120.8zM528 320c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16z"
    ]
};
var $1113a0aa61ab7765$export$4941c5969d5399b = {
    prefix: 'fas',
    iconName: 'sort',
    icon: [
        320,
        512,
        [
            "unsorted"
        ],
        "f0dc",
        "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"
    ]
};
var $1113a0aa61ab7765$export$418597748f0fe52d = $1113a0aa61ab7765$export$4941c5969d5399b;
var $1113a0aa61ab7765$export$3db8f67cd0fc963b = {
    prefix: 'fas',
    iconName: 'list-ol',
    icon: [
        512,
        512,
        [
            "list-1-2",
            "list-numeric"
        ],
        "f0cb",
        "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$7e3d894cd55296b = $1113a0aa61ab7765$export$3db8f67cd0fc963b;
var $1113a0aa61ab7765$export$cf51408faadac277 = $1113a0aa61ab7765$export$3db8f67cd0fc963b;
var $1113a0aa61ab7765$export$523180e731928397 = {
    prefix: 'fas',
    iconName: 'person-dress-burst',
    icon: [
        640,
        512,
        [],
        "e544",
        "M528 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM390.2 384H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
var $1113a0aa61ab7765$export$eeb59dd1825c6a65 = {
    prefix: 'fas',
    iconName: 'money-check-dollar',
    icon: [
        576,
        512,
        [
            "money-check-alt"
        ],
        "f53d",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM272 192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zM164.1 160v6.3c6.6 1.2 16.6 3.2 21 4.4c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10 3.6-15.4 4.6V352c0 11.1-9 20.1-20.1 20.1s-20.1-9-20.1-20.1v-6.4c-9.5-2.2-21.9-6.4-29.8-9.1c-1.7-.6-3.2-1.1-4.4-1.5c-10.5-3.5-16.1-14.8-12.7-25.3s14.8-16.1 25.3-12.7c2 .7 4.1 1.4 6.4 2.1l0 0 0 0c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.3-4 15.9-5.1v-6c0-11.1 9-20.1 20.1-20.1s20.1 9 20.1 20.1z"
    ]
};
var $1113a0aa61ab7765$export$8c6ccc9745897cb2 = $1113a0aa61ab7765$export$eeb59dd1825c6a65;
var $1113a0aa61ab7765$export$567d5631a7b0599f = {
    prefix: 'fas',
    iconName: 'vector-square',
    icon: [
        448,
        512,
        [],
        "f5cb",
        "M368 80h32v32H368V80zM352 32c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM96 160c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32V160zM48 400H80v32H48V400zm320 32V400h32v32H368zM48 112V80H80v32H48z"
    ]
};
var $1113a0aa61ab7765$export$d78e8b0681279167 = {
    prefix: 'fas',
    iconName: 'bread-slice',
    icon: [
        512,
        512,
        [],
        "f7ec",
        "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"
    ]
};
var $1113a0aa61ab7765$export$8a7bee49fdf8c954 = {
    prefix: 'fas',
    iconName: 'language',
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"
    ]
};
var $1113a0aa61ab7765$export$611ae61f02de0aa = {
    prefix: 'fas',
    iconName: 'face-kiss-wink-heart',
    icon: [
        512,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 240c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm194.8-6.4c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
    ]
};
var $1113a0aa61ab7765$export$ebba617701dfb917 = $1113a0aa61ab7765$export$611ae61f02de0aa;
var $1113a0aa61ab7765$export$f253a38d7142e29f = {
    prefix: 'fas',
    iconName: 'filter',
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
    ]
};
var $1113a0aa61ab7765$export$d96973f90e8f6e47 = {
    prefix: 'fas',
    iconName: 'question',
    icon: [
        320,
        512,
        [
            10067,
            10068,
            61736
        ],
        "3f",
        "M96 96c-17.7 0-32 14.3-32 32s-14.3 32-32 32s-32-14.3-32-32C0 75 43 32 96 32h97c70.1 0 127 56.9 127 127c0 52.4-32.2 99.4-81 118.4l-63 24.5 0 18.1c0 17.7-14.3 32-32 32s-32-14.3-32-32V301.9c0-26.4 16.2-50.1 40.8-59.6l63-24.5C240 208.3 256 185 256 159c0-34.8-28.2-63-63-63H96zm48 384c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40z"
    ]
};
var $1113a0aa61ab7765$export$d0de575ac166712b = {
    prefix: 'fas',
    iconName: 'file-signature',
    icon: [
        576,
        512,
        [],
        "f573",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V428.7c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4c-.9 .1-1.8 .2-2.7 .2H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8h8.9c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L384 203.6V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM549.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 262.7l-71-71L311.9 321z"
    ]
};
var $1113a0aa61ab7765$export$cd7b22f4e6e3834b = {
    prefix: 'fas',
    iconName: 'up-down-left-right',
    icon: [
        512,
        512,
        [
            "arrows-alt"
        ],
        "f0b2",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var $1113a0aa61ab7765$export$3cdabfff52cfc73a = $1113a0aa61ab7765$export$cd7b22f4e6e3834b;
var $1113a0aa61ab7765$export$1ddbaebce033a0d = {
    prefix: 'fas',
    iconName: 'house-chimney-user',
    icon: [
        576,
        512,
        [],
        "e065",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 288c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"
    ]
};
var $1113a0aa61ab7765$export$97e5ef3e80a0fbef = {
    prefix: 'fas',
    iconName: 'hand-holding-heart',
    icon: [
        576,
        512,
        [],
        "f4be",
        "M148 76.6C148 34.3 182.3 0 224.6 0c20.3 0 39.8 8.1 54.1 22.4l9.3 9.3 9.3-9.3C311.6 8.1 331.1 0 351.4 0C393.7 0 428 34.3 428 76.6c0 20.3-8.1 39.8-22.4 54.1L302.1 234.1c-7.8 7.8-20.5 7.8-28.3 0L170.4 130.7C156.1 116.4 148 96.9 148 76.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $1113a0aa61ab7765$export$7ee0dbd1e92e2859 = {
    prefix: 'fas',
    iconName: 'puzzle-piece',
    icon: [
        512,
        512,
        [
            129513
        ],
        "f12e",
        "M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8c0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2c-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48H279.2c-12.8 0-23.2-10.4-23.2-23.2c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8c0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48H168.8c12.8 0 23.2-10.4 23.2-23.2z"
    ]
};
var $1113a0aa61ab7765$export$be069f641c85d0b3 = {
    prefix: 'fas',
    iconName: 'money-check',
    icon: [
        576,
        512,
        [],
        "f53c",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM376 160h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z"
    ]
};
var $1113a0aa61ab7765$export$3e4892d8bf919edd = {
    prefix: 'fas',
    iconName: 'star-half-stroke',
    icon: [
        576,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M288 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L288.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8 159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7z"
    ]
};
var $1113a0aa61ab7765$export$c13575f42532efb3 = $1113a0aa61ab7765$export$3e4892d8bf919edd;
var $1113a0aa61ab7765$export$eba095993e51cc97 = {
    prefix: 'fas',
    iconName: 'code',
    icon: [
        640,
        512,
        [],
        "f121",
        "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var $1113a0aa61ab7765$export$f1304dd34ea2afbd = {
    prefix: 'fas',
    iconName: 'whiskey-glass',
    icon: [
        512,
        512,
        [
            129347,
            "glass-whiskey"
        ],
        "f7a0",
        "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM87.7 224L69 96H443L424.3 224H87.7z"
    ]
};
var $1113a0aa61ab7765$export$fdec0f5f1a169419 = $1113a0aa61ab7765$export$f1304dd34ea2afbd;
var $1113a0aa61ab7765$export$c49f030b19083ebe = {
    prefix: 'fas',
    iconName: 'building-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e4d3",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$6a1e4cdbb8ca10c5 = {
    prefix: 'fas',
    iconName: 'magnifying-glass-chart',
    icon: [
        512,
        512,
        [],
        "e522",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96V280c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $1113a0aa61ab7765$export$5ad84e891223f2c3 = {
    prefix: 'fas',
    iconName: 'arrow-up-right-from-square',
    icon: [
        512,
        512,
        [
            "external-link"
        ],
        "f08e",
        "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $1113a0aa61ab7765$export$f4c613289034e5ef = $1113a0aa61ab7765$export$5ad84e891223f2c3;
var $1113a0aa61ab7765$export$b1f00c433aabac05 = {
    prefix: 'fas',
    iconName: 'cubes-stacked',
    icon: [
        448,
        512,
        [],
        "e4e6",
        "M192 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7L82.7 207zM288 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H288zm64 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H352zM160 384v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32z"
    ]
};
var $1113a0aa61ab7765$export$51790ddd26e431bc = {
    prefix: 'fas',
    iconName: 'won-sign',
    icon: [
        512,
        512,
        [
            8361,
            "krw",
            "won"
        ],
        "f159",
        "M62.4 53.9C56.8 37.1 38.6 28.1 21.9 33.6S-3.9 57.4 1.6 74.1L51.6 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H72.9l56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288h46L321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224H329L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224h-64L62.4 53.9zm78 234.1H167l-11.4 45.6L140.4 288zM249 224l7-28.1 7 28.1H249zm96 64h26.6l-15.2 45.6L345 288z"
    ]
};
var $1113a0aa61ab7765$export$2f65e07a45b95b50 = $1113a0aa61ab7765$export$51790ddd26e431bc;
var $1113a0aa61ab7765$export$5a1fd3ed9564d7fa = $1113a0aa61ab7765$export$51790ddd26e431bc;
var $1113a0aa61ab7765$export$1df4e031b8ee4f84 = {
    prefix: 'fas',
    iconName: 'virus-covid',
    icon: [
        512,
        512,
        [],
        "e4a8",
        "M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V81.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3H464V216c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H430.4c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V430.4c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280H48v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v16H81.6c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1V48H216c-13.3 0-24-10.7-24-24zm48 200c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm64 104c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $1113a0aa61ab7765$export$299c200ad3db97b4 = {
    prefix: 'fas',
    iconName: 'austral-sign',
    icon: [
        448,
        512,
        [],
        "e0a9",
        "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96L82.7 320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H56L34.5 435.7c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384H322.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H365.3L352 288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H325.3L253.5 51.7zM256 224H192l32-76.8L256 224zm-90.7 64H282.7L296 320H152l13.3-32z"
    ]
};
var $1113a0aa61ab7765$export$a2f384a559654618 = {
    prefix: 'fas',
    iconName: 'f',
    icon: [
        320,
        512,
        [
            102
        ],
        "46",
        "M32 32C14.3 32 0 46.3 0 64V256 448c0 17.7 14.3 32 32 32s32-14.3 32-32V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $1113a0aa61ab7765$export$7c497bae2754a087 = {
    prefix: 'fas',
    iconName: 'leaf',
    icon: [
        512,
        512,
        [],
        "f06c",
        "M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.3 5.4c-25.9 5.9-49.9 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"
    ]
};
var $1113a0aa61ab7765$export$f224567a4851a5e9 = {
    prefix: 'fas',
    iconName: 'road',
    icon: [
        576,
        512,
        [
            128739
        ],
        "f018",
        "M256 32H181.2c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480H256V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64H521.4c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$9958afcdfece1b58 = {
    prefix: 'fas',
    iconName: 'taxi',
    icon: [
        512,
        512,
        [
            128662,
            "cab"
        ],
        "f1ba",
        "M192 0c-17.7 0-32 14.3-32 32V64c0 .1 0 .1 0 .2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288V432v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V432H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V432 288c0-26.7-16.4-49.6-39.6-59.2L437.2 128.3c-12.9-36.8-46.6-62-85.2-64.1c0-.1 0-.1 0-.2V32c0-17.7-14.3-32-32-32H192zM165.4 128H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 224H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 352c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm352-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$7bf12d9380f0971b = $1113a0aa61ab7765$export$9958afcdfece1b58;
var $1113a0aa61ab7765$export$55686b1eb7d00307 = {
    prefix: 'fas',
    iconName: 'person-circle-plus',
    icon: [
        576,
        512,
        [],
        "e541",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm16-208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
    ]
};
var $1113a0aa61ab7765$export$1de7b9cf7d1b153b = {
    prefix: 'fas',
    iconName: 'chart-pie',
    icon: [
        576,
        512,
        [
            "pie-chart"
        ],
        "f200",
        "M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"
    ]
};
var $1113a0aa61ab7765$export$7877286cd337de81 = $1113a0aa61ab7765$export$1de7b9cf7d1b153b;
var $1113a0aa61ab7765$export$b16dcd08f3da1ba2 = {
    prefix: 'fas',
    iconName: 'bolt-lightning',
    icon: [
        384,
        512,
        [],
        "e0b7",
        "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $1113a0aa61ab7765$export$2bad98c38bea5994 = {
    prefix: 'fas',
    iconName: 'sack-xmark',
    icon: [
        512,
        512,
        [],
        "e56a",
        "M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 336l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"
    ]
};
var $1113a0aa61ab7765$export$77cb1a465c4fe84 = {
    prefix: 'fas',
    iconName: 'file-excel',
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
    ]
};
var $1113a0aa61ab7765$export$70fde3f3fdaa6a6a = {
    prefix: 'fas',
    iconName: 'file-contract',
    icon: [
        384,
        512,
        [],
        "f56c",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"
    ]
};
var $1113a0aa61ab7765$export$e7af4f0123222b6f = {
    prefix: 'fas',
    iconName: 'fish-fins',
    icon: [
        576,
        512,
        [],
        "e4f2",
        "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM448 256c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$592422b29ab0a914 = {
    prefix: 'fas',
    iconName: 'building-flag',
    icon: [
        640,
        512,
        [],
        "e4d5",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32V512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480c0-17.7-14.3-32-32-32z"
    ]
};
var $1113a0aa61ab7765$export$3de52eeb00462407 = {
    prefix: 'fas',
    iconName: 'face-grin-beam',
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM383.8 317.8c12.3-3.7 24.3 7 19.2 18.7c-24.5 56.9-81.1 96.7-147 96.7s-122.5-39.8-147-96.7c-5.1-11.8 6.9-22.4 19.2-18.7C166.7 329.4 210.1 336 256 336s89.3-6.6 127.8-18.2zm-166.2-89l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $1113a0aa61ab7765$export$734da5249381ec7e = $1113a0aa61ab7765$export$3de52eeb00462407;
var $1113a0aa61ab7765$export$887f6345573abcac = {
    prefix: 'fas',
    iconName: 'object-ungroup',
    icon: [
        640,
        512,
        [],
        "f248",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H328.6C339.6 12.9 360.3 0 384 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V232.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4V232.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4zm192 384c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V352h64v40.6c9.7 5.6 17.8 13.7 23.4 23.4H520.6c5.6-9.7 13.7-17.8 23.4-23.4V279.4c-9.7-5.6-17.8-13.7-23.4-23.4h-46c-5.4-15.4-14.6-28.9-26.5-39.6V192h72.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H311.4z"
    ]
};
var $1113a0aa61ab7765$export$bb45b6b87d1adf27 = {
    prefix: 'fas',
    iconName: 'poop',
    icon: [
        512,
        512,
        [],
        "f619",
        "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32H352c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z"
    ]
};
var $1113a0aa61ab7765$export$c0b7617de95c0c05 = {
    prefix: 'fas',
    iconName: 'location-pin',
    icon: [
        384,
        512,
        [
            "map-marker"
        ],
        "f041",
        "M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"
    ]
};
var $1113a0aa61ab7765$export$10d360e4f1a554dd = $1113a0aa61ab7765$export$c0b7617de95c0c05;
var $1113a0aa61ab7765$export$ab1408bfbe914cc9 = {
    prefix: 'fas',
    iconName: 'kaaba',
    icon: [
        576,
        512,
        [
            128331
        ],
        "f66b",
        "M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v16 0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2V128 112C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2V182.8l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"
    ]
};
var $1113a0aa61ab7765$export$c8cc083ccc72b17 = {
    prefix: 'fas',
    iconName: 'toilet-paper',
    icon: [
        640,
        512,
        [
            129531
        ],
        "f71e",
        "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0H444.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM144 208c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 16c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm80-16c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $1113a0aa61ab7765$export$aacaf42fba617981 = {
    prefix: 'fas',
    iconName: 'helmet-safety',
    icon: [
        576,
        512,
        [
            "hard-hat",
            "hat-hard"
        ],
        "f807",
        "M256 32c-17.7 0-32 14.3-32 32v2.3 99.6c0 5.6-4.5 10.1-10.1 10.1c-3.6 0-7-1.9-8.8-5.1L157.1 87C83 123.5 32 199.8 32 288v64H544l0-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1c-5.6 0-10.1-4.5-10.1-10.1V66.3 64c0-17.7-14.3-32-32-32H256zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6H16.6z"
    ]
};
var $1113a0aa61ab7765$export$7b72177558a98b6f = $1113a0aa61ab7765$export$aacaf42fba617981;
var $1113a0aa61ab7765$export$c0e235dbf1644a2f = $1113a0aa61ab7765$export$aacaf42fba617981;
var $1113a0aa61ab7765$export$8484041d5b209494 = {
    prefix: 'fas',
    iconName: 'eject',
    icon: [
        448,
        512,
        [
            9167
        ],
        "f052",
        "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"
    ]
};
var $1113a0aa61ab7765$export$1fec48c8bdd69c1d = {
    prefix: 'fas',
    iconName: 'circle-right',
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zm395.3 11.3l-112 112c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-64-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-64c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5l112 112c6.2 6.2 6.2 16.4 0 22.6z"
    ]
};
var $1113a0aa61ab7765$export$88962ffdad8b856d = $1113a0aa61ab7765$export$1fec48c8bdd69c1d;
var $1113a0aa61ab7765$export$9cbf8612c6cadc74 = {
    prefix: 'fas',
    iconName: 'plane-circle-check',
    icon: [
        640,
        512,
        [],
        "e555",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM640 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $1113a0aa61ab7765$export$a6d72a9a068392b5 = {
    prefix: 'fas',
    iconName: 'face-rolling-eyes',
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"
    ]
};
var $1113a0aa61ab7765$export$fdc62a1bea767cc2 = $1113a0aa61ab7765$export$a6d72a9a068392b5;
var $1113a0aa61ab7765$export$40cdac24aa94a57a = {
    prefix: 'fas',
    iconName: 'object-group',
    icon: [
        576,
        512,
        [],
        "f247",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"
    ]
};
var $1113a0aa61ab7765$export$e022f62a119e1d93 = {
    prefix: 'fas',
    iconName: 'chart-line',
    icon: [
        512,
        512,
        [
            "line-chart"
        ],
        "f201",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
    ]
};
var $1113a0aa61ab7765$export$f729617a20de475b = $1113a0aa61ab7765$export$e022f62a119e1d93;
var $1113a0aa61ab7765$export$122c8413a0dc5ff6 = {
    prefix: 'fas',
    iconName: 'mask-ventilator',
    icon: [
        640,
        512,
        [],
        "e524",
        "M159.1 176C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46l-31.8-7.9C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H159.1zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6V393.3c-19.7-16.4-32-40.3-32-66.9c0-49.5 43-134.4 96-134.4c52.5 0 96 84.9 96 134.4c0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 320V512h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $1113a0aa61ab7765$export$b4da69a0247f3620 = {
    prefix: 'fas',
    iconName: 'arrow-right',
    icon: [
        448,
        512,
        [
            8594
        ],
        "f061",
        "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
    ]
};
var $1113a0aa61ab7765$export$905f45f8ffd6b8e5 = {
    prefix: 'fas',
    iconName: 'signs-post',
    icon: [
        512,
        512,
        [
            "map-signs"
        ],
        "f277",
        "M224 32H64C46.3 32 32 46.3 32 64v64c0 17.7 14.3 32 32 32H441.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H288c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32H288V192H224v32H70.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H448c17.7 0 32-14.3 32-32V256zM288 480V384H224v96c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$743f4b1071b3333a = $1113a0aa61ab7765$export$905f45f8ffd6b8e5;
var $1113a0aa61ab7765$export$6357093f67788b33 = {
    prefix: 'fas',
    iconName: 'cash-register',
    icon: [
        512,
        512,
        [],
        "f788",
        "M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V378.4c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160H208V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm48-216c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm72 24c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24zm-24 56c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm120-56c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24zm-24 56c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm120-56c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24zm-24 56c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $1113a0aa61ab7765$export$c8f8a597ffd676c0 = {
    prefix: 'fas',
    iconName: 'person-circle-question',
    icon: [
        576,
        512,
        [],
        "e542",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm0-48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
var $1113a0aa61ab7765$export$d762b7b66d5875e1 = {
    prefix: 'fas',
    iconName: 'h',
    icon: [
        384,
        512,
        [
            104
        ],
        "48",
        "M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z"
    ]
};
var $1113a0aa61ab7765$export$2305b1a41b3f914 = {
    prefix: 'fas',
    iconName: 'tarp',
    icon: [
        576,
        512,
        [],
        "e57b",
        "M576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32H576V128zM448 448L576 320H448l0 128zM96 192c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$158a12f36bbecf9 = {
    prefix: 'fas',
    iconName: 'screwdriver-wrench',
    icon: [
        512,
        512,
        [
            "tools"
        ],
        "f7d9",
        "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM104 432c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$646e4e7a8c6172aa = $1113a0aa61ab7765$export$158a12f36bbecf9;
var $1113a0aa61ab7765$export$9adae865350879af = {
    prefix: 'fas',
    iconName: 'arrows-to-eye',
    icon: [
        640,
        512,
        [],
        "e4bf",
        "M15 15C24.4 5.7 39.6 5.7 49 15l63 63V40c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H78.1L15 49C5.7 39.6 5.7 24.4 15 15zM133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63H600c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24s24 10.7 24 24V78.1l63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V433.9L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0l-63-63V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H561.9l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
var $1113a0aa61ab7765$export$4f3b3144ce966486 = {
    prefix: 'fas',
    iconName: 'plug-circle-bolt',
    icon: [
        576,
        512,
        [],
        "e55b",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var $1113a0aa61ab7765$export$e4b51a47a2f8b9db = {
    prefix: 'fas',
    iconName: 'heart',
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
    ]
};
var $1113a0aa61ab7765$export$808b88e8735e31e8 = {
    prefix: 'fas',
    iconName: 'mars-and-venus',
    icon: [
        512,
        512,
        [
            9893
        ],
        "f224",
        "M337.8 14.8C341.5 5.8 350.3 0 360 0H472c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59.1 146.7-136.1 158.2c0 .6 .1 1.2 .1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-24 0-24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456H208c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2 .1-1.8C155.1 370.7 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48l0 0h0v0zM256 488h24c0 13.3-10.7 24-24 24s-24-10.7-24-24h24zm96-264c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96z"
    ]
};
var $1113a0aa61ab7765$export$9a513ee921e8e885 = {
    prefix: 'fas',
    iconName: 'house-user',
    icon: [
        576,
        512,
        [
            "home-user"
        ],
        "e1b0",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z"
    ]
};
var $1113a0aa61ab7765$export$e732fa55ae5bbdf0 = $1113a0aa61ab7765$export$9a513ee921e8e885;
var $1113a0aa61ab7765$export$25e9b29b3f2230b5 = {
    prefix: 'fas',
    iconName: 'dumpster-fire',
    icon: [
        640,
        512,
        [],
        "f794",
        "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1c1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304V160zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2c-.1-.7-.3-1.4-.5-2.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l12.8 64.2c9.6 1 19 4.9 26.6 11.8c11.7 10.6 23 21.6 33.9 33.1c1.6-1.6 3.3-3.2 5-4.8zM325.2 210.7c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4zm128.4-78.9c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 407.9 390.3 480 480 480c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"
    ]
};
var $1113a0aa61ab7765$export$baa3c215534dbf2a = {
    prefix: 'fas',
    iconName: 'house-crack',
    icon: [
        576,
        512,
        [],
        "e3b1",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H230.4l-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"
    ]
};
var $1113a0aa61ab7765$export$c6e76550bdc0255d = {
    prefix: 'fas',
    iconName: 'martini-glass-citrus',
    icon: [
        576,
        512,
        [
            "cocktail"
        ],
        "f561",
        "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H296.2C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8C5.5 133.8 14.3 128 24 128H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-177 177V464h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H208 120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V345.9L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"
    ]
};
var $1113a0aa61ab7765$export$4be708f1e41d387b = $1113a0aa61ab7765$export$c6e76550bdc0255d;
var $1113a0aa61ab7765$export$c938968e28178994 = {
    prefix: 'fas',
    iconName: 'face-surprise',
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM176.4 240c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM256 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z"
    ]
};
var $1113a0aa61ab7765$export$46647c72213f53ba = $1113a0aa61ab7765$export$c938968e28178994;
var $1113a0aa61ab7765$export$3ee278c67519eeeb = {
    prefix: 'fas',
    iconName: 'bottle-water',
    icon: [
        256,
        512,
        [],
        "e4c5",
        "M88 0h80c13.3 0 24 10.7 24 24V64H64V24C64 10.7 74.7 0 88 0zM0 151.7c0-15.6 9-29.8 23.2-36.5l24.4-11.4c11-5.1 23-7.8 35.1-7.8h90.6c12.1 0 24.1 2.7 35.1 7.8l24.4 11.4c14.2 6.6 23.2 20.8 23.2 36.5c0 14.4-7.5 27-18.9 34.1c11.5 8.8 18.9 22.6 18.9 38.2c0 16.7-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48c0-16.7 8.5-31.4 21.5-40C8.5 415.4 0 400.7 0 384s8.5-31.4 21.5-40C8.5 335.4 0 320.7 0 304s8.5-31.4 21.5-40C8.5 255.4 0 240.7 0 224c0-15.6 7.4-29.4 18.9-38.2C7.5 178.7 0 166.1 0 151.7zM64 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
    ]
};
var $1113a0aa61ab7765$export$fbeef2513e05ad08 = {
    prefix: 'fas',
    iconName: 'circle-pause',
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$d8cf08a0362da8db = $1113a0aa61ab7765$export$fbeef2513e05ad08;
var $1113a0aa61ab7765$export$7a494edbf9b65575 = {
    prefix: 'fas',
    iconName: 'toilet-paper-slash',
    icon: [
        640,
        512,
        [],
        "e072",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6L66.5 148.4zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"
    ]
};
var $1113a0aa61ab7765$export$12de8220d30453a3 = {
    prefix: 'fas',
    iconName: 'apple-whole',
    icon: [
        448,
        512,
        [
            127822,
            127823,
            "apple-alt"
        ],
        "f5d1",
        "M224 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H224zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"
    ]
};
var $1113a0aa61ab7765$export$bcdd94f3977a0884 = $1113a0aa61ab7765$export$12de8220d30453a3;
var $1113a0aa61ab7765$export$64c1570509eaf40d = {
    prefix: 'fas',
    iconName: 'kitchen-set',
    icon: [
        576,
        512,
        [],
        "e51a",
        "M240 144c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM144 208c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm256 32c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zM24 464H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $1113a0aa61ab7765$export$eb4c616de6eef46f = {
    prefix: 'fas',
    iconName: 'r',
    icon: [
        320,
        512,
        [
            114
        ],
        "52",
        "M32 32C14.3 32 0 46.3 0 64V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144H32zM176 256H64V96H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $1113a0aa61ab7765$export$f9d1c19925fd7fa8 = {
    prefix: 'fas',
    iconName: 'temperature-quarter',
    icon: [
        320,
        512,
        [
            "temperature-1",
            "thermometer-1",
            "thermometer-quarter"
        ],
        "f2ca",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $1113a0aa61ab7765$export$d4f1cd380bde2129 = $1113a0aa61ab7765$export$f9d1c19925fd7fa8;
var $1113a0aa61ab7765$export$3f77fbe2dabe285b = $1113a0aa61ab7765$export$f9d1c19925fd7fa8;
var $1113a0aa61ab7765$export$ed05754fcbec6e46 = $1113a0aa61ab7765$export$f9d1c19925fd7fa8;
var $1113a0aa61ab7765$export$973ae4f1e4d2ce78 = {
    prefix: 'fas',
    iconName: 'cube',
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1v-188L288 246.6v188z"
    ]
};
var $1113a0aa61ab7765$export$441bfc8058328ce8 = {
    prefix: 'fas',
    iconName: 'bitcoin-sign',
    icon: [
        320,
        512,
        [],
        "e0b4",
        "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32V64h32V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H41.7C18.7 448 0 429.3 0 406.3V288 265.7 224 101.6C0 80.8 16.8 64 37.6 64H48V32zM64 224H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zm112 64H64v96H208c26.5 0 48-21.5 48-48s-21.5-48-48-48H176z"
    ]
};
var $1113a0aa61ab7765$export$2a5c6f182c0cbcb = {
    prefix: 'fas',
    iconName: 'shield-dog',
    icon: [
        512,
        512,
        [],
        "e573",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64V160h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80H272v50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160h40 8v32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-8.8 7.2-16 16-16zm128 48c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $1113a0aa61ab7765$export$b9c649c5e37017f3 = {
    prefix: 'fas',
    iconName: 'solar-panel',
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M96 0C80.7 0 67.6 10.8 64.6 25.7l-64 320c-1.9 9.4 .6 19.1 6.6 26.6S22.4 384 32 384H288v64H224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H608c9.6 0 18.7-4.3 24.7-11.7s8.5-17.2 6.6-26.6l-64-320C572.4 10.8 559.3 0 544 0H96zm5.4 168L122.2 64h90.4L202.3 168H101.4zm-9.6 48H197.5L187.1 320H71L91.8 216zm153.9 0H394.3l10.4 104H235.3l10.4-104zm196.8 0H548.2L569 320h-116L442.5 216zm96-48H437.7L427.3 64h90.4l20.8 104zm-149.1 0h-139L260.9 64H379.1l10.4 104z"
    ]
};
var $1113a0aa61ab7765$export$84b5acad4436d02a = {
    prefix: 'fas',
    iconName: 'lock-open',
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z"
    ]
};
var $1113a0aa61ab7765$export$c7a833ce065e0ea4 = {
    prefix: 'fas',
    iconName: 'elevator',
    icon: [
        512,
        512,
        [],
        "e16d",
        "M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H208c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm96 192c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V400zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400zM400 272c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"
    ]
};
var $1113a0aa61ab7765$export$1b71392d9effbe = {
    prefix: 'fas',
    iconName: 'money-bill-transfer',
    icon: [
        640,
        512,
        [],
        "e528",
        "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64H337.9c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64h64V320zM320 352c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96s43 96 96 96z"
    ]
};
var $1113a0aa61ab7765$export$18ab80cba7d5044f = {
    prefix: 'fas',
    iconName: 'money-bill-trend-up',
    icon: [
        512,
        512,
        [],
        "e529",
        "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2l0 .1v0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1 84.8 216.3c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0c8.8 0 16.8 3.6 22.6 9.3l.1 .1zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $1113a0aa61ab7765$export$30d3e64480aa266b = {
    prefix: 'fas',
    iconName: 'house-flood-water-circle-arrow-right',
    icon: [
        640,
        512,
        [],
        "e50f",
        "M288 144C288 64.5 223.5 0 144 0S0 64.5 0 144s64.5 144 144 144s144-64.5 144-144zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3c11.8-3.6 23-9.4 33-16.2c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4H576c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128C407.6-2 392.4-2 381.2 6.1L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0C279 325.4 251.5 336 224 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 389.7 191 400 224 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C471.4 325.2 442.9 336 416 336c-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0C279 437.4 251.5 448 224 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 501.7 191 512 224 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C471.4 437.2 442.9 448 416 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $1113a0aa61ab7765$export$287bdd70ab874659 = {
    prefix: 'fas',
    iconName: 'square-poll-horizontal',
    icon: [
        448,
        512,
        [
            "poll-h"
        ],
        "f682",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$456a238f0144d430 = $1113a0aa61ab7765$export$287bdd70ab874659;
var $1113a0aa61ab7765$export$4280b2387fbdad12 = {
    prefix: 'fas',
    iconName: 'circle',
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512z"
    ]
};
var $1113a0aa61ab7765$export$662cbc6ed5a3c5e8 = {
    prefix: 'fas',
    iconName: 'backward-fast',
    icon: [
        512,
        512,
        [
            9198,
            "fast-backward"
        ],
        "f049",
        "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7V416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V214.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96V214.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96V416c0 12.4-7.2 23.7-18.4 29z"
    ]
};
var $1113a0aa61ab7765$export$e6246a3279a379b8 = $1113a0aa61ab7765$export$662cbc6ed5a3c5e8;
var $1113a0aa61ab7765$export$a65c441f12cb6bd = {
    prefix: 'fas',
    iconName: 'recycle',
    icon: [
        576,
        512,
        [
            9842,
            9850,
            9851
        ],
        "f1b8",
        "M206.7 45.1C224.2 17 255 0 288 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L315 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM461.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L352 448v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2v32l96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L68 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17L214 241.2c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3-51.5 82.4c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0c-53.1 0-96.1-43.2-95.8-96.4c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"
    ]
};
var $1113a0aa61ab7765$export$94363e983c225a04 = {
    prefix: 'fas',
    iconName: 'user-astronaut',
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128v64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9V128c0-16.8-12.9-30.5-29.3-31.9zM336 144v16c0 53-43 96-96 96H208c-53 0-96-43-96-96V144c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512H128V448c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64l98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16v48h32V464c0-8.8-7.2-16-16-16zm96 32c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $1113a0aa61ab7765$export$cfee4df0d5df6d21 = {
    prefix: 'fas',
    iconName: 'plane-slash',
    icon: [
        640,
        512,
        [],
        "e069",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320h73.8c34.2 0 93.7-28 93.7-64c0-35-59.5-64-93.7-64l-116.6 0L297.2 16.1C291.5 6.2 280.9 0 269.4 0H213.2c-10.6 0-18.3 10.2-15.4 20.4l40.3 140.9L38.8 5.1zm2.7 123.6C36 130.6 32 135.9 32 142c0 1.3 .2 2.6 .5 3.9L64 256 32.5 366.1c-.4 1.3-.5 2.6-.5 3.9c0 7.8 6.3 14 14 14H88c5 0 9.8-2.4 12.8-6.4L144 320H246.9l-49 171.6c-2.9 10.2 4.8 20.4 15.4 20.4l56.2 0c11.5 0 22.1-6.2 27.8-16.1l65.3-114.3L41.5 128.7z"
    ]
};
var $1113a0aa61ab7765$export$9c9b2fbddd59047d = {
    prefix: 'fas',
    iconName: 'trademark',
    icon: [
        640,
        512,
        [
            8482
        ],
        "f25c",
        "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224l86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-13.8-8.8-26-21.9-30.4s-27.5 .1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32H96V384c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128z"
    ]
};
var $1113a0aa61ab7765$export$44dee69e3a29b0e = {
    prefix: 'fas',
    iconName: 'basketball',
    icon: [
        512,
        512,
        [
            127936,
            "basketball-ball"
        ],
        "f434",
        "M86.6 64C119 35.5 158.6 15 202.3 5.6C206 19.1 208 33.3 208 48c0 38.4-13.5 73.7-36.1 101.3L86.6 64zM64 86.6l85.2 85.2C121.7 194.5 86.4 208 48 208c-14.7 0-28.9-2-42.4-5.7C15 158.6 35.5 119 64 86.6zM256 0c64.9 0 124.2 24.2 169.4 64L256 233.4 194.6 172C222.9 138.5 240 95.3 240 48c0-16.2-2-32-5.8-47.1C241.4 .3 248.7 0 256 0zM48 240c47.3 0 90.5-17.1 124-45.4L233.4 256 64 425.4C24.2 380.2 0 320.9 0 256c0-7.3 .3-14.6 .9-21.8C16 238 31.8 240 48 240zm463.1 37.8C496 274 480.2 272 464 272c-47.3 0-90.5 17.1-124 45.4L278.6 256 448 86.6c39.8 45.1 64 104.4 64 169.4c0 7.3-.3 14.6-.9 21.8zm-4.7 31.9C497 353.4 476.5 393 448 425.4l-85.2-85.2C390.3 317.5 425.6 304 464 304c14.7 0 28.9 2 42.4 5.7zM340.1 362.7L425.4 448C393 476.5 353.4 497 309.7 506.4C306 492.9 304 478.7 304 464c0-38.4 13.5-73.7 36.1-101.3zM317.4 340C289.1 373.5 272 416.7 272 464c0 16.2 2 32 5.8 47.1c-7.2 .6-14.5 .9-21.8 .9c-64.9 0-124.2-24.2-169.4-64L256 278.6 317.4 340z"
    ]
};
var $1113a0aa61ab7765$export$36550ab8ffcc5b28 = $1113a0aa61ab7765$export$44dee69e3a29b0e;
var $1113a0aa61ab7765$export$219ccae0e4da3c92 = {
    prefix: 'fas',
    iconName: 'satellite-dish',
    icon: [
        512,
        512,
        [
            128225
        ],
        "f7c0",
        "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$72ea8a5e4e86cd69 = {
    prefix: 'fas',
    iconName: 'circle-up',
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm11.3-395.3l112 112c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H304v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V256H144c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l112-112c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $1113a0aa61ab7765$export$3747a8ef0995eadf = $1113a0aa61ab7765$export$72ea8a5e4e86cd69;
var $1113a0aa61ab7765$export$da39ed20699ee2d7 = {
    prefix: 'fas',
    iconName: 'mobile-screen-button',
    icon: [
        384,
        512,
        [
            "mobile-alt"
        ],
        "f3cd",
        "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM224 448c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM304 64H80V384H304V64z"
    ]
};
var $1113a0aa61ab7765$export$e9599bc6cd92234d = $1113a0aa61ab7765$export$da39ed20699ee2d7;
var $1113a0aa61ab7765$export$39461921e738be65 = {
    prefix: 'fas',
    iconName: 'volume-high',
    icon: [
        640,
        512,
        [
            128266,
            "volume-up"
        ],
        "f028",
        "M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"
    ]
};
var $1113a0aa61ab7765$export$5940d3e475d90cc4 = $1113a0aa61ab7765$export$39461921e738be65;
var $1113a0aa61ab7765$export$9c0b63b698611d06 = {
    prefix: 'fas',
    iconName: 'users-rays',
    icon: [
        640,
        512,
        [],
        "e593",
        "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM212.1 336c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-.5-1.4-1-2.7-1.6-4c-9.4-22.3-29.8-38.9-54.3-43c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-.8 .1-1.7 .3-2.5 .5c-24.9 5.1-45.1 23-53.4 46.5zM175.8 224c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zM464 224c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $1113a0aa61ab7765$export$79204db8777905c8 = {
    prefix: 'fas',
    iconName: 'wallet',
    icon: [
        512,
        512,
        [],
        "f555",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 336c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$7babcb2c90eb609a = {
    prefix: 'fas',
    iconName: 'clipboard-check',
    icon: [
        384,
        512,
        [],
        "f46c",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $1113a0aa61ab7765$export$b8d24c57c9e64933 = {
    prefix: 'fas',
    iconName: 'file-audio',
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376H80c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h33.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"
    ]
};
var $1113a0aa61ab7765$export$128a6cab12423493 = {
    prefix: 'fas',
    iconName: 'burger',
    icon: [
        512,
        512,
        [
            "hamburger"
        ],
        "f805",
        "M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1H61.1zM144 128c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm240 16c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zM272 96c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zM16 304c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V400z"
    ]
};
var $1113a0aa61ab7765$export$bab3bb9f4f59363 = $1113a0aa61ab7765$export$128a6cab12423493;
var $1113a0aa61ab7765$export$3c6c0c8185296ac5 = {
    prefix: 'fas',
    iconName: 'wrench',
    icon: [
        512,
        512,
        [
            128295
        ],
        "f0ad",
        "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 456c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $1113a0aa61ab7765$export$f5bfd1271b8b71d1 = {
    prefix: 'fas',
    iconName: 'bugs',
    icon: [
        640,
        512,
        [],
        "e4d0",
        "M196.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L160 71.7 133.9 14.1C128.4 2 114.1-3.3 102.1 2.1S84.7 21.9 90.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8s-21.4 15.2-18.8 28.2l8 40C42.7 175.9 52.6 184 64 184H96v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C114.7 274.6 135.8 288 160 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L224 207.3V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L236.3 136h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM528 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L464.8 250c-12.3 1-24.2 5.6-34.1 13.3L416 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L391 322.7 353.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L535.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L598.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"
    ]
};
var $1113a0aa61ab7765$export$8bf9e3f7f57d486a = {
    prefix: 'fas',
    iconName: 'rupee-sign',
    icon: [
        448,
        512,
        [
            8360,
            "rupee"
        ],
        "f156",
        "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9l0 0c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s25-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1l0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.4-13.4-6.6-28-4.4-43.2c8.5-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"
    ]
};
var $1113a0aa61ab7765$export$9da25a46cfcb6fa4 = $1113a0aa61ab7765$export$8bf9e3f7f57d486a;
var $1113a0aa61ab7765$export$6440b286d3cbac9b = {
    prefix: 'fas',
    iconName: 'file-image',
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM128 256c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm88 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6H216 176 128 80c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"
    ]
};
var $1113a0aa61ab7765$export$d7cf0978afd90002 = {
    prefix: 'fas',
    iconName: 'circle-question',
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$5ba67d7f2265c1a5 = $1113a0aa61ab7765$export$d7cf0978afd90002;
var $1113a0aa61ab7765$export$6ccbeeccfea6dc8a = {
    prefix: 'fas',
    iconName: 'plane-departure',
    icon: [
        640,
        512,
        [
            128747
        ],
        "f5b0",
        "M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2H248.4c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48H542.8c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $1113a0aa61ab7765$export$2cef3f81ad90fb76 = {
    prefix: 'fas',
    iconName: 'handshake-slash',
    icon: [
        640,
        512,
        [],
        "e060",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.4-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM96 171.6L40.6 128H0V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V171.6zM413.6 421.9L128 196.9V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM48 352c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V128H544zm64 208c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$3d177ecdf7fc50ec = {
    prefix: 'fas',
    iconName: 'book-bookmark',
    icon: [
        448,
        512,
        [],
        "e0bb",
        "M0 96C0 43 43 0 96 0h96V190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5V0h32 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32z"
    ]
};
var $1113a0aa61ab7765$export$aa054a78ab078db3 = {
    prefix: 'fas',
    iconName: 'code-branch',
    icon: [
        448,
        512,
        [],
        "f126",
        "M80 104c13.3 0 24-10.7 24-24s-10.7-24-24-24S56 66.7 56 80s10.7 24 24 24zm80-24c0 32.8-19.7 61-48 73.3v87.8c18.8-10.9 40.7-17.1 64-17.1h96c35.3 0 64-28.7 64-64v-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V160c0 70.7-57.3 128-128 128H176c-35.3 0-64 28.7-64 64v6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V352 153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zM80 456c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $1113a0aa61ab7765$export$37672611144b857b = {
    prefix: 'fas',
    iconName: 'hat-cowboy',
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9C447.8 272.1 390.9 288 320 288s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"
    ]
};
var $1113a0aa61ab7765$export$f402c7c97f3383f0 = {
    prefix: 'fas',
    iconName: 'bridge',
    icon: [
        576,
        512,
        [],
        "e4c8",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H72v64H0V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96s96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96V160H504V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM456 96v64H376V96h80zM328 96v64H248V96h80zM200 96v64H120V96h80z"
    ]
};
var $1113a0aa61ab7765$export$d86c56ab43eb0deb = {
    prefix: 'fas',
    iconName: 'phone-flip',
    icon: [
        512,
        512,
        [
            128381,
            "phone-alt"
        ],
        "f879",
        "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"
    ]
};
var $1113a0aa61ab7765$export$a07a9b305deebf32 = $1113a0aa61ab7765$export$d86c56ab43eb0deb;
var $1113a0aa61ab7765$export$4a5a13c01d46357c = {
    prefix: 'fas',
    iconName: 'truck-front',
    icon: [
        512,
        512,
        [],
        "e2b7",
        "M0 80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V368c0 26.2-12.6 49.4-32 64v48c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432C12.6 417.4 0 394.2 0 368V80zm129.9 72.2L112 224H400l-17.9-71.8C378.5 138 365.7 128 351 128H161c-14.7 0-27.5 10-31 24.2zM128 320c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm288 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$ab927dada03be4b3 = {
    prefix: 'fas',
    iconName: 'cat',
    icon: [
        512,
        512,
        [
            128008
        ],
        "f6be",
        "M288 192h17.1c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4v4 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L248 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1C10.5 157.6-1.9 141.6 .2 124s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5v0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32h0c-3.7-4.1-7-8.5-9.9-13.2C325.3 164 320 146.6 320 128v0V32 12 10.7C320 4.8 324.7 .1 330.6 0h.2c3.3 0 6.4 1.6 8.4 4.2l0 .1L352 21.3l27.2 36.3L384 64h64l4.8-6.4L480 21.3 492.8 4.3l0-.1c2-2.6 5.1-4.2 8.4-4.2h.2C507.3 .1 512 4.8 512 10.7V12 32v96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM400 128c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 16c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $1113a0aa61ab7765$export$61add9eca991b5ec = {
    prefix: 'fas',
    iconName: 'anchor-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e4ab",
        "M256 96c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm85.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$f4419f7b2e53b340 = {
    prefix: 'fas',
    iconName: 'truck-field',
    icon: [
        640,
        512,
        [],
        "e58d",
        "M32 96c0-35.3 28.7-64 64-64H320c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2H544c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V288c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V96zM384 224h85.9l-42.7-96H384v96zM160 432c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm368-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
    ]
};
var $1113a0aa61ab7765$export$806c0a45a7ecd6e8 = {
    prefix: 'fas',
    iconName: 'route',
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M416 256s96-96 96-160c0-53-43-96-96-96s-96 43-96 96c0 29.4 20.2 65.5 42.1 96H320c-53 0-96 43-96 96s43 96 96 96h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H188.6c-6.2 9.6-12.6 18.8-19 27.2c-10.7 14.2-21.3 26.9-30 36.8H416c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h96zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zM149.9 448c21.9-30.5 42.1-66.6 42.1-96c0-53-43-96-96-96s-96 43-96 96c0 64 96 160 96 160s3.5-3.5 9.2-9.6c.4-.4 .7-.8 1.1-1.2c3.3-3.5 7.1-7.8 11.4-12.8c.2-.2 .4-.4 .6-.6c9.4-10.8 20.7-24.6 31.6-39.8zM96 384c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$d4aa151a4554b74e = {
    prefix: 'fas',
    iconName: 'clipboard-question',
    icon: [
        384,
        512,
        [],
        "e4e3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM105.8 229.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V314.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $1113a0aa61ab7765$export$5dd22dcb6e3ed369 = {
    prefix: 'fas',
    iconName: 'panorama',
    icon: [
        640,
        512,
        [],
        "e209",
        "M45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM160 160c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm208 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"
    ]
};
var $1113a0aa61ab7765$export$101422b773924276 = {
    prefix: 'fas',
    iconName: 'comment-medical',
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272H176c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
    ]
};
var $1113a0aa61ab7765$export$c88ac21fe7c88ae6 = {
    prefix: 'fas',
    iconName: 'teeth-open',
    icon: [
        576,
        512,
        [],
        "f62f",
        "M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96zM224 96c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V144c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V144zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V176c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V176zM96 480H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"
    ]
};
var $1113a0aa61ab7765$export$4b89fabf50a10951 = {
    prefix: 'fas',
    iconName: 'file-circle-minus',
    icon: [
        576,
        512,
        [],
        "e4ed",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM576 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-64 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
    ]
};
var $1113a0aa61ab7765$export$d55778e3ab6c933f = {
    prefix: 'fas',
    iconName: 'tags',
    icon: [
        512,
        512,
        [],
        "f02c",
        "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$e06d6607d3577d6e = {
    prefix: 'fas',
    iconName: 'wine-glass',
    icon: [
        320,
        512,
        [
            127863
        ],
        "f4e3",
        "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM88.1 128l5.3-64H226.6l5.3 64H88.1z"
    ]
};
var $1113a0aa61ab7765$export$dc9cc4280bee320d = {
    prefix: 'fas',
    iconName: 'forward-fast',
    icon: [
        512,
        512,
        [
            9197,
            "fast-forward"
        ],
        "f050",
        "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V214.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96V214.3L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96V416c0 12.4 7.2 23.7 18.4 29z"
    ]
};
var $1113a0aa61ab7765$export$61a8cdc53c2e078d = $1113a0aa61ab7765$export$dc9cc4280bee320d;
var $1113a0aa61ab7765$export$38c072b870a9e4ab = {
    prefix: 'fas',
    iconName: 'face-meh-blank',
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM208.4 208c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm128 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$e945435725f71e88 = $1113a0aa61ab7765$export$38c072b870a9e4ab;
var $1113a0aa61ab7765$export$f2cfa036d76f69ab = {
    prefix: 'fas',
    iconName: 'square-parking',
    icon: [
        448,
        512,
        [
            127359,
            "parking"
        ],
        "f540",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 256h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v64zm48 64H192v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"
    ]
};
var $1113a0aa61ab7765$export$fda29c8f99573a4e = $1113a0aa61ab7765$export$f2cfa036d76f69ab;
var $1113a0aa61ab7765$export$58845db8e7e9a199 = {
    prefix: 'fas',
    iconName: 'house-signal',
    icon: [
        576,
        512,
        [],
        "e012",
        "M314.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c9.7 8.9 12.9 22.9 8.1 35.2S557.2 256 544 256H512V368c0 26.5-21.5 48-48 48H278.1C259.6 350.8 216.8 295.9 160 261.7V256h-9.9c-16.5-9-34-16.2-52.3-21.6c-4.1-12-.8-25.3 8.5-34l208-192zM304 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H304zM24 256c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 256c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zM0 376c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24z"
    ]
};
var $1113a0aa61ab7765$export$ee3a02da18715b2 = {
    prefix: 'fas',
    iconName: 'bars-progress',
    icon: [
        512,
        512,
        [
            "tasks-alt"
        ],
        "f828",
        "M448 160H320V128H448v32zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM448 352v32H192V352H448zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"
    ]
};
var $1113a0aa61ab7765$export$bbc0784fc1578f7f = $1113a0aa61ab7765$export$ee3a02da18715b2;
var $1113a0aa61ab7765$export$7a255960242435f6 = {
    prefix: 'fas',
    iconName: 'faucet-drip',
    icon: [
        512,
        512,
        [
            128688
        ],
        "e006",
        "M224 0c17.7 0 32 14.3 32 32V44l96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32L256 84l-31-3.9-1-.1-1 .1L192 84 96 96C78.3 96 64 81.7 64 64s14.3-32 32-32l96 12V32c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32h96l22.6-22.6c6-6 14.1-9.4 22.6-9.4H192V116.2l32-4 32 4V160h18.7c8.5 0 16.6 3.4 22.6 9.4L320 192h32c88.4 0 160 71.6 160 160c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32s-14.3-32-32-32H315.9c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48H32c-17.7 0-32-14.3-32-32V224zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"
    ]
};
var $1113a0aa61ab7765$export$df587aaf7765e1ce = {
    prefix: 'fas',
    iconName: 'cart-flatbed',
    icon: [
        640,
        512,
        [
            "dolly-flatbed"
        ],
        "f474",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM192 80V272c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H464V176c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V32H240c-26.5 0-48 21.5-48 48z"
    ]
};
var $1113a0aa61ab7765$export$f7c6efb60c53b285 = $1113a0aa61ab7765$export$df587aaf7765e1ce;
var $1113a0aa61ab7765$export$130df7ed74437774 = {
    prefix: 'fas',
    iconName: 'ban-smoking',
    icon: [
        512,
        512,
        [
            128685,
            "smoking-ban"
        ],
        "f54d",
        "M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32H384v32H333.3zm32 32H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H269.3L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM229.5 320l-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H229.5z"
    ]
};
var $1113a0aa61ab7765$export$e50452a49dec29f = $1113a0aa61ab7765$export$130df7ed74437774;
var $1113a0aa61ab7765$export$5e63e8b85b5f119c = {
    prefix: 'fas',
    iconName: 'terminal',
    icon: [
        640,
        512,
        [],
        "f120",
        "M41.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 41.4 86.6zM288 416H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$c93d62849efbdd11 = {
    prefix: 'fas',
    iconName: 'mobile-button',
    icon: [
        384,
        512,
        [],
        "f10b",
        "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zM192 464c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$86c50f517be57a40 = {
    prefix: 'fas',
    iconName: 'house-medical-flag',
    icon: [
        640,
        512,
        [],
        "e514",
        "M480 0c17.7 0 32 14.3 32 32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H512V512H448V192 32c0-17.7 14.3-32 32-32zM276.8 39.7L416 159V512h1l-.2 0H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"
    ]
};
var $1113a0aa61ab7765$export$1d307c13b511e8e1 = {
    prefix: 'fas',
    iconName: 'basket-shopping',
    icon: [
        576,
        512,
        [
            "shopping-basket"
        ],
        "f291",
        "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512H430c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.4L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192H171.7L253.3 35.1zM192 304v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$ca6d443595a6578f = $1113a0aa61ab7765$export$1d307c13b511e8e1;
var $1113a0aa61ab7765$export$b88ed5e1e0eac4c6 = {
    prefix: 'fas',
    iconName: 'tape',
    icon: [
        576,
        512,
        [],
        "f4db",
        "M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H380.8zM224 352c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96zm64-96c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $1113a0aa61ab7765$export$d3724faf0c559353 = {
    prefix: 'fas',
    iconName: 'bus-simple',
    icon: [
        448,
        512,
        [
            "bus-alt"
        ],
        "f55e",
        "M224 0C348.8 0 448 35.2 448 80V96 416c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32V96 80C0 35.2 99.2 0 224 0zM64 128V256c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 400c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$40616edfab6d332a = $1113a0aa61ab7765$export$d3724faf0c559353;
var $1113a0aa61ab7765$export$b8c3e79e8c99c95b = {
    prefix: 'fas',
    iconName: 'eye',
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z"
    ]
};
var $1113a0aa61ab7765$export$e8ea88c55e55be7c = {
    prefix: 'fas',
    iconName: 'face-sad-cry',
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V477.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V493.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
var $1113a0aa61ab7765$export$8e924e6bd422cef9 = $1113a0aa61ab7765$export$e8ea88c55e55be7c;
var $1113a0aa61ab7765$export$b6b464c98c009494 = {
    prefix: 'fas',
    iconName: 'audio-description',
    icon: [
        576,
        512,
        [],
        "f29e",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352z"
    ]
};
var $1113a0aa61ab7765$export$41b1e14a6b0fe11b = {
    prefix: 'fas',
    iconName: 'person-military-to-person',
    icon: [
        512,
        512,
        [],
        "e54c",
        "M71 12.5c-8.6 1-15 8.2-15 16.8c0 9.3 7.5 16.8 16.7 16.9H184.1c8.8-.1 15.9-7.2 15.9-16V16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1H66.5C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256v32c0 17.7 14.3 32 32 32H192c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5V256c0-35.3-28.7-64-64-64H96c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zm-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H352zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376v32l-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0v32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 3 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"
    ]
};
var $1113a0aa61ab7765$export$348a01df65a66c99 = {
    prefix: 'fas',
    iconName: 'file-shield',
    icon: [
        576,
        512,
        [],
        "e4f0",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
    ]
};
var $1113a0aa61ab7765$export$3924ab4d3ef9b5ef = {
    prefix: 'fas',
    iconName: 'user-slash',
    icon: [
        640,
        512,
        [],
        "f506",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z"
    ]
};
var $1113a0aa61ab7765$export$8f4567331fb0d3bc = {
    prefix: 'fas',
    iconName: 'pen',
    icon: [
        512,
        512,
        [
            128394
        ],
        "f304",
        "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"
    ]
};
var $1113a0aa61ab7765$export$5b2f0f631f559d51 = {
    prefix: 'fas',
    iconName: 'tower-observation',
    icon: [
        512,
        512,
        [],
        "e586",
        "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144v80c0 17.7-14.3 32-32 32h-4.9l32 192H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H384.5c-.4 0-.8 0-1.1 0H128.6c-.4 0-.8 0-1.1 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l32-192H128c-17.7 0-32-14.3-32-32V144c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448L256 399.2 197.5 448h117zM197.8 256l-4.7 28.3L256 336.8l62.9-52.5L314.2 256H197.8zm-13.9 83.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
    ]
};
var $1113a0aa61ab7765$export$143d0ca7d2200f20 = {
    prefix: 'fas',
    iconName: 'file-code',
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $1113a0aa61ab7765$export$79046b073b6c584d = {
    prefix: 'fas',
    iconName: 'signal',
    icon: [
        576,
        512,
        [
            128246,
            "signal-5",
            "signal-perfect"
        ],
        "f012",
        "M544 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM416 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM320 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM160 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM64 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$3417071118065933 = $1113a0aa61ab7765$export$79046b073b6c584d;
var $1113a0aa61ab7765$export$1aea50ab3e99cc95 = $1113a0aa61ab7765$export$79046b073b6c584d;
var $1113a0aa61ab7765$export$ce69441578ff2fdb = {
    prefix: 'fas',
    iconName: 'bus',
    icon: [
        512,
        512,
        [
            128653
        ],
        "f207",
        "M256 0C390.4 0 480 35.2 480 80V96l0 32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V448H160v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h0V96h0V80C32 35.2 121.6 0 256 0zM96 160v96c0 17.7 14.3 32 32 32H240V128H128c-17.7 0-32 14.3-32 32zM272 288H384c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H272V288zM112 400c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM352 80c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16z"
    ]
};
var $1113a0aa61ab7765$export$742f89ae2f8d6b20 = {
    prefix: 'fas',
    iconName: 'heart-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e501",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $1113a0aa61ab7765$export$af554427144a7e5c = {
    prefix: 'fas',
    iconName: 'house-chimney',
    icon: [
        576,
        512,
        [
            63499,
            "home-lg"
        ],
        "e3af",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64 24c0 22.1 17.9 40 40 40h24 32.5c1.4 0 2.8 0 4.2-.1c1.1 .1 2.2 .1 3.3 .1h16c22.1 0 40-17.9 40-40V455.8c.3-2.6 .5-5.3 .5-8.1l-.7-160.2h32z"
    ]
};
var $1113a0aa61ab7765$export$dbab81727ec94698 = $1113a0aa61ab7765$export$af554427144a7e5c;
var $1113a0aa61ab7765$export$703cd98be31ec905 = {
    prefix: 'fas',
    iconName: 'window-maximize',
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$e5f78e87efbb0248 = {
    prefix: 'fas',
    iconName: 'face-frown',
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM208.4 208c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$43b7108508aecc5f = $1113a0aa61ab7765$export$e5f78e87efbb0248;
var $1113a0aa61ab7765$export$8767bafb19515ee4 = {
    prefix: 'fas',
    iconName: 'prescription',
    icon: [
        448,
        512,
        [],
        "f5b1",
        "M32 0C14.3 0 0 14.3 0 32V192v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224h50.7l128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0H32zM176 160H64V64H176c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $1113a0aa61ab7765$export$78edc9b98453b6f7 = {
    prefix: 'fas',
    iconName: 'shop',
    icon: [
        640,
        512,
        [
            "store-alt"
        ],
        "f54f",
        "M36.8 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 224H320V384H128V224H64zm448 0V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224H512z"
    ]
};
var $1113a0aa61ab7765$export$1f1871dab9cec9d8 = $1113a0aa61ab7765$export$78edc9b98453b6f7;
var $1113a0aa61ab7765$export$f62f2879ccaea13f = {
    prefix: 'fas',
    iconName: 'floppy-disk',
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z"
    ]
};
var $1113a0aa61ab7765$export$1aaa83ff70706e1e = $1113a0aa61ab7765$export$f62f2879ccaea13f;
var $1113a0aa61ab7765$export$ee4b92e89fe0dfaf = {
    prefix: 'fas',
    iconName: 'vihara',
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9H480v56.1l6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4H544v65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24H576v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H24c-13.3 0-24-10.7-24-24c0-11.4 8-21 18.6-23.4c30-7.6 56.9-23.9 77.4-46.7V288H56.6c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1V176 128h-7.5c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22zM416 128H320 224v64h72 48 72V128zM160 288v64H296h24 24H480V288H344 320h0H296 160z"
    ]
};
var $1113a0aa61ab7765$export$4d10bcc8d068f454 = {
    prefix: 'fas',
    iconName: 'scale-unbalanced',
    icon: [
        640,
        512,
        [
            "balance-scale-left"
        ],
        "f515",
        "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zm-396.3 211c.4-.8 1.3-1.3 2.2-1.3s1.7 .5 2.2 1.3L204.9 416H51.1l74.7-142.7zM128 224c-18.8 0-36 10.4-44.7 27L5.5 399.5c-3.1 5.8-6.1 14-5.5 23.8c.7 12.1 4.8 35.2 24.8 55.1C45.1 498.6 77.8 512 128 512s82.9-13.4 103.2-33.5c20-20 24.2-43 24.8-55.1c.6-9.8-2.5-18-5.5-23.8L172.7 251c-8.7-16.6-25.9-27-44.7-27zm384-80c.9 0 1.7 .5 2.2 1.3L588.9 288H435.1l74.7-142.7c.4-.8 1.3-1.3 2.2-1.3zm-44.7-21L389.5 271.5c-3.1 5.8-6.1 14-5.5 23.8c.7 12.1 4.8 35.2 24.8 55.1C429.1 370.6 461.8 384 512 384s82.9-13.4 103.2-33.5c20-20 24.2-43 24.8-55.1c.6-9.8-2.5-18-5.5-23.8L556.7 123C548 106.4 530.8 96 512 96s-36 10.4-44.7 27z"
    ]
};
var $1113a0aa61ab7765$export$786cb0c775487f19 = $1113a0aa61ab7765$export$4d10bcc8d068f454;
var $1113a0aa61ab7765$export$f9dd5b1410e95035 = {
    prefix: 'fas',
    iconName: 'sort-up',
    icon: [
        320,
        512,
        [
            "sort-asc"
        ],
        "f0de",
        "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
var $1113a0aa61ab7765$export$e4c8c924b1cc43a7 = $1113a0aa61ab7765$export$f9dd5b1410e95035;
var $1113a0aa61ab7765$export$63ffcb3d4e94cb92 = {
    prefix: 'fas',
    iconName: 'comment-dots',
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm160-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$49ee382a2425e89c = $1113a0aa61ab7765$export$63ffcb3d4e94cb92;
var $1113a0aa61ab7765$export$77a38850ff8b0407 = {
    prefix: 'fas',
    iconName: 'plant-wilt',
    icon: [
        512,
        512,
        [],
        "e5aa",
        "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c-29.3 10-48 34.5-48 70.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V120C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120v13c-29.3 10-48 34.5-48 70.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V248c0-30.9 25.1-56 56-56s56 25.1 56 56v32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V280 248 120z"
    ]
};
var $1113a0aa61ab7765$export$f214f827e0023247 = {
    prefix: 'fas',
    iconName: 'diamond',
    icon: [
        512,
        512,
        [
            9830
        ],
        "f219",
        "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"
    ]
};
var $1113a0aa61ab7765$export$5d53da7627754bc6 = {
    prefix: 'fas',
    iconName: 'face-grin-squint',
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM383.8 317.8c12.3-3.7 24.3 7 19.2 18.7c-24.5 56.9-81.1 96.7-147 96.7s-122.5-39.8-147-96.7c-5.1-11.8 6.9-22.4 19.2-18.7C166.7 329.4 210.1 336 256 336s89.3-6.6 127.8-18.2zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $1113a0aa61ab7765$export$243ae757907b1580 = $1113a0aa61ab7765$export$5d53da7627754bc6;
var $1113a0aa61ab7765$export$61a67f5f8ab39be = {
    prefix: 'fas',
    iconName: 'hand-holding-dollar',
    icon: [
        576,
        512,
        [
            "hand-holding-usd"
        ],
        "f4c0",
        "M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $1113a0aa61ab7765$export$47d27bc305b59690 = $1113a0aa61ab7765$export$61a67f5f8ab39be;
var $1113a0aa61ab7765$export$b0babe4230e35ebe = {
    prefix: 'fas',
    iconName: 'bacterium',
    icon: [
        576,
        512,
        [],
        "e05a",
        "M455.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L228 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L135 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7l0 0-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2c-12.7 3.6-20.1 16.9-16.5 29.7s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L247 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L403 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L471 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zm-331 332.7l0 0L176 368l-51.9-4.7zM240 320c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zm32-88c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $1113a0aa61ab7765$export$d97ff927c450c87f = {
    prefix: 'fas',
    iconName: 'hand-pointer',
    icon: [
        448,
        512,
        [],
        "f25a",
        "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v32 64c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"
    ]
};
var $1113a0aa61ab7765$export$48d1206500db2e9d = {
    prefix: 'fas',
    iconName: 'drum-steelpan',
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32c159.1 0 288 48 288 128V352c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"
    ]
};
var $1113a0aa61ab7765$export$c578e919f2c5c135 = {
    prefix: 'fas',
    iconName: 'hand-scissors',
    icon: [
        512,
        512,
        [],
        "f257",
        "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9l0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"
    ]
};
var $1113a0aa61ab7765$export$a96374faedb12593 = {
    prefix: 'fas',
    iconName: 'hands-praying',
    icon: [
        640,
        512,
        [
            "praying-hands"
        ],
        "f684",
        "M351.2 4.8c3.2-2 6.6-3.3 10-4.1c4.7-1 9.6-.9 14.1 .1c7.7 1.8 14.8 6.5 19.4 13.6L514.6 194.2c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5L431 465.9c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V219.1c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3c-1-4.7-1-9.6 .1-14.1c1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32V342.3c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 490 0 480V384c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2V238.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1c3.5 .8 6.9 2.1 10 4.1z"
    ]
};
var $1113a0aa61ab7765$export$95e08e91b0929943 = $1113a0aa61ab7765$export$a96374faedb12593;
var $1113a0aa61ab7765$export$9c58ddc4b3356f98 = {
    prefix: 'fas',
    iconName: 'arrow-rotate-right',
    icon: [
        512,
        512,
        [
            8635,
            "arrow-right-rotate",
            "arrow-rotate-forward",
            "redo"
        ],
        "f01e",
        "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
    ]
};
var $1113a0aa61ab7765$export$ffa1245982c1b28b = $1113a0aa61ab7765$export$9c58ddc4b3356f98;
var $1113a0aa61ab7765$export$89c59b5f47067f4c = $1113a0aa61ab7765$export$9c58ddc4b3356f98;
var $1113a0aa61ab7765$export$3d9f98aa1c24c776 = $1113a0aa61ab7765$export$9c58ddc4b3356f98;
var $1113a0aa61ab7765$export$ae3a453550dec95 = {
    prefix: 'fas',
    iconName: 'biohazard',
    icon: [
        576,
        512,
        [
            9763
        ],
        "f780",
        "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM336 272c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM181.7 417.6c6.3-11.8 9.8-25.1 8.6-39.8c-19.5-18-34-41.4-41.2-67.8c-12.5-8.1-26.2-11.8-40-12.4c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c6.8 12.4 16.7 23.1 30.1 30.3c13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM426.9 310c-7.2 26.4-21.7 49.7-41.2 67.8c-1.2 14.7 2.2 28.1 8.6 39.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-13.8 .6-27.5 4.4-40 12.4z"
    ]
};
var $1113a0aa61ab7765$export$14e1096ad1719098 = {
    prefix: 'fas',
    iconName: 'location-crosshairs',
    icon: [
        512,
        512,
        [
            "location"
        ],
        "f601",
        "M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $1113a0aa61ab7765$export$45e012c32174eb5d = $1113a0aa61ab7765$export$14e1096ad1719098;
var $1113a0aa61ab7765$export$2f8a28204bb4b86f = {
    prefix: 'fas',
    iconName: 'mars-double',
    icon: [
        640,
        512,
        [
            9891
        ],
        "f227",
        "M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312zm88 48h0v0l0 0zM288 304c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112zm80 176c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H504c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .2v.2c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7V168c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1c19.8 7.8 41.4 12 64 12z"
    ]
};
var $1113a0aa61ab7765$export$f31a37ecbfd4e707 = {
    prefix: 'fas',
    iconName: 'child-dress',
    icon: [
        320,
        512,
        [],
        "e59c",
        "M224 64c0-35.3-28.7-64-64-64S96 28.7 96 64s28.7 64 64 64s64-28.7 64-64zM88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400H88z"
    ]
};
var $1113a0aa61ab7765$export$6ea1decf8bb3513d = {
    prefix: 'fas',
    iconName: 'users-between-lines',
    icon: [
        640,
        512,
        [],
        "e591",
        "M0 24C0 10.7 10.7 0 24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM211.2 160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H493.6zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7 .8 21.6 2.4zM563.2 160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM321.6 256c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $1113a0aa61ab7765$export$895159d10626af74 = {
    prefix: 'fas',
    iconName: 'lungs-virus',
    icon: [
        640,
        512,
        [],
        "e067",
        "M320 0c17.7 0 32 14.3 32 32V156.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2V32c0-17.7 14.3-32 32-32zM444.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9c-1.1-1.1-1.4-2-1.5-2.5c-.1-.8-.1-1.8 .4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8c26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8c-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6 .4-1.4 1.5-2.5c18.7-18.7 18.7-49.1 0-67.9zM421.8 421.8c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6zM183.3 491.2l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-18.6-12.4-44-10.3-60.5 6.1c-18.7 18.7-18.7 49.1 0 67.9c1.1 1.1 1.4 2 1.5 2.5c.1 .8 .1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5 .3-1.3 .8-2.9 .8c-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4 .4 2.9 .8c.6 .4 1.3 1.2 1.8 2.3s.5 2.2 .4 2.9c-.1 .6-.4 1.4-1.5 2.5c-18.7 18.7-18.7 49.1 0 67.9c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9zM296 320c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm72 32c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $1113a0aa61ab7765$export$8ac6d81a3d5b40a1 = {
    prefix: 'fas',
    iconName: 'face-grin-tears',
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M548.6 371.4C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c3.6-8.8 6.5-18.4 8.8-27.5c4.6-18.2 7.7-37 9.3-48.2c3.9-26.5-18.8-49.2-45.2-45.4c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-26.5-3.9-49.2 18.8-45.2 45.4c1.6 11.3 4.6 30 9.3 48.2c2.3 9.1 5.2 18.8 8.8 27.5c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.4 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"
    ]
};
var $1113a0aa61ab7765$export$b2f7512221512b5b = $1113a0aa61ab7765$export$8ac6d81a3d5b40a1;
var $1113a0aa61ab7765$export$ddab067855cf34cb = {
    prefix: 'fas',
    iconName: 'phone',
    icon: [
        512,
        512,
        [
            128222,
            128379
        ],
        "f095",
        "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
    ]
};
var $1113a0aa61ab7765$export$3c70ffe5660af060 = {
    prefix: 'fas',
    iconName: 'calendar-xmark',
    icon: [
        448,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"
    ]
};
var $1113a0aa61ab7765$export$99b20d7352fbcf08 = $1113a0aa61ab7765$export$3c70ffe5660af060;
var $1113a0aa61ab7765$export$84a2f9476730c40e = {
    prefix: 'fas',
    iconName: 'child-reaching',
    icon: [
        384,
        512,
        [],
        "e59d",
        "M256 64c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V221.6c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6c-12.6 0-24.9-2-36.6-5.8c-.9-.3-1.8-.7-2.7-.9z"
    ]
};
var $1113a0aa61ab7765$export$5b64b916710da7c7 = {
    prefix: 'fas',
    iconName: 'head-side-virus',
    icon: [
        512,
        512,
        [],
        "e064",
        "M0 224.2C0 100.6 100.2 0 224 0h32c95.2 0 174.2 69.3 189.4 160.1c2.2 13 6.7 25.7 15 36.1l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM240 80c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C161.5 168.1 145 208 112 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C184.1 302.5 224 319 224 352c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C318.5 279.9 335 240 368 240c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C295.9 145.5 256 129 256 96c0-8.8-7.2-16-16-16zM216 224c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm72 32c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$f504a6909b677146 = {
    prefix: 'fas',
    iconName: 'user-gear',
    icon: [
        640,
        512,
        [
            "user-cog"
        ],
        "f4fe",
        "M224 256c-70.7 0-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128s-57.3 128-128 128zm-45.7 48h91.4c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V454.8c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9V218.2zm92.1 133.5c0-26.5-21.5-48-48.1-48s-48.1 21.5-48.1 48s21.5 48 48.1 48s48.1-21.5 48.1-48z"
    ]
};
var $1113a0aa61ab7765$export$474108c2b86e730e = $1113a0aa61ab7765$export$f504a6909b677146;
var $1113a0aa61ab7765$export$bbbff45e04f4abab = {
    prefix: 'fas',
    iconName: 'arrow-up-1-9',
    icon: [
        576,
        512,
        [
            "sort-numeric-up"
        ],
        "f163",
        "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM352 64c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V96H384c-17.7 0-32-14.3-32-32zm93.7 300.9c10.8-5.1 18.3-16.2 18.3-28.9c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c4.9 0 9.6-1.1 13.7-3.1zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
var $1113a0aa61ab7765$export$d213a3ba3cabed48 = $1113a0aa61ab7765$export$bbbff45e04f4abab;
var $1113a0aa61ab7765$export$2c79e1a422528bba = {
    prefix: 'fas',
    iconName: 'door-closed',
    icon: [
        576,
        512,
        [
            128682
        ],
        "f52a",
        "M96 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 144 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V64zM384 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$bea811bbf570f05a = {
    prefix: 'fas',
    iconName: 'shield-virus',
    icon: [
        512,
        512,
        [],
        "e06c",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm72 32c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $1113a0aa61ab7765$export$3397c7b4679acccc = {
    prefix: 'fas',
    iconName: 'dice-six',
    icon: [
        448,
        512,
        [
            9861
        ],
        "f526",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM128 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm32 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM320 192c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm32 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM320 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$f3858ce1b3218e2 = {
    prefix: 'fas',
    iconName: 'mosquito-net',
    icon: [
        640,
        512,
        [],
        "e52c",
        "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4V242.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5V137.9c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-21.7 0-40 14.3-45.9 34.1c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H528v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H448v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V400H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V320H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16zm16 112h48V320H528v48zm0 80h48V400H528v48zM448 320v48h48V320H448zm0 80v48h48V400H448z"
    ]
};
var $1113a0aa61ab7765$export$154e99cb34841765 = {
    prefix: 'fas',
    iconName: 'bridge-water',
    icon: [
        576,
        512,
        [],
        "e4ce",
        "M0 96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v35.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6V352.5c-12.9 0-25.8 3.9-36.8 11.7c-18 12.4-40.1 20.3-59.2 20.3h0l0-.5V256c0-53-43-96-96-96s-96 43-96 96V384l0 .5c-19 0-41.2-7.9-59.1-20.3c-11.1-7.8-24-11.7-36.9-11.7V227.6C96 190.2 65.8 160 28.4 160C12.7 160 0 147.3 0 131.6V96zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $1113a0aa61ab7765$export$2337c975289bdd84 = {
    prefix: 'fas',
    iconName: 'person-booth',
    icon: [
        576,
        512,
        [],
        "f756",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64V32zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM224 512c17.7 0 32-14.3 32-32V320H192V480c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM112 80c0-26.5-21.5-48-48-48S16 53.5 16 80s21.5 48 48 48s48-21.5 48-48zm0 261.3V269.3l4.7 4.7c9 9 21.2 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H157.3l-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6v55.7l0 .9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384l32 42.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V421.3c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"
    ]
};
var $1113a0aa61ab7765$export$d8724cf433389700 = {
    prefix: 'fas',
    iconName: 'text-width',
    icon: [
        448,
        512,
        [],
        "f035",
        "M32 32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96H192l0 128H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l0-128H384v32c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H224 32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V416H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"
    ]
};
var $1113a0aa61ab7765$export$7daa48199dcb2ad1 = {
    prefix: 'fas',
    iconName: 'hat-wizard',
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M64 416L168.6 180.7c15.3-34.4 40.3-63.5 72-83.7l146.9-94c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6v1.6c0 2.6-.5 5.1-1.4 7.5L354.8 176.9c-1.9 4.7-2.8 9.7-2.8 14.7c0 5.5 1.2 11 3.4 16.1L448 416H240.9l11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 276.4 230.9 272 224 272s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 339 144 345.1 144 352s4.4 13 10.9 15.2l40.4 13.5L207.1 416H64zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$8bdfe14ac72a8b17 = {
    prefix: 'fas',
    iconName: 'pen-fancy',
    icon: [
        512,
        512,
        [
            128395,
            10002
        ],
        "f5ac",
        "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"
    ]
};
var $1113a0aa61ab7765$export$f4d483fca19a4604 = {
    prefix: 'fas',
    iconName: 'person-digging',
    icon: [
        576,
        512,
        [
            "digging"
        ],
        "f85e",
        "M304 64c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"
    ]
};
var $1113a0aa61ab7765$export$7bd93e3343bd5671 = $1113a0aa61ab7765$export$f4d483fca19a4604;
var $1113a0aa61ab7765$export$ed8c149a0ea54bb4 = {
    prefix: 'fas',
    iconName: 'trash',
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"
    ]
};
var $1113a0aa61ab7765$export$f3a0a4e6723a86d4 = {
    prefix: 'fas',
    iconName: 'gauge-simple',
    icon: [
        512,
        512,
        [
            "gauge-simple-med",
            "tachometer-average"
        ],
        "f629",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM320 352c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $1113a0aa61ab7765$export$ba8c12ff7cfa2521 = $1113a0aa61ab7765$export$f3a0a4e6723a86d4;
var $1113a0aa61ab7765$export$94fcfd6f6335431b = $1113a0aa61ab7765$export$f3a0a4e6723a86d4;
var $1113a0aa61ab7765$export$6feb44fec53ba30d = {
    prefix: 'fas',
    iconName: 'book-medical',
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM208 112v48H160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16z"
    ]
};
var $1113a0aa61ab7765$export$dd0ede1713d2d2f9 = {
    prefix: 'fas',
    iconName: 'poo',
    icon: [
        512,
        512,
        [
            128169
        ],
        "f2fe",
        "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72H394.3c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 320c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm160-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm0 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3H339.7c6.8 0 12.3 5.5 12.3 12.3z"
    ]
};
var $1113a0aa61ab7765$export$54e3a80c9875b74c = {
    prefix: 'fas',
    iconName: 'quote-right',
    icon: [
        448,
        512,
        [
            8221,
            "quote-right-alt"
        ],
        "f10e",
        "M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"
    ]
};
var $1113a0aa61ab7765$export$dd692f2e88bd4b1a = $1113a0aa61ab7765$export$54e3a80c9875b74c;
var $1113a0aa61ab7765$export$312f2c01c6fedca8 = {
    prefix: 'fas',
    iconName: 'shirt',
    icon: [
        640,
        512,
        [
            128085,
            "t-shirt",
            "tshirt"
        ],
        "f553",
        "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0h12.6c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0h12.6z"
    ]
};
var $1113a0aa61ab7765$export$144e5f8bc4d705a6 = $1113a0aa61ab7765$export$312f2c01c6fedca8;
var $1113a0aa61ab7765$export$36edce3ba87c2b17 = $1113a0aa61ab7765$export$312f2c01c6fedca8;
var $1113a0aa61ab7765$export$30523a9441a31e97 = {
    prefix: 'fas',
    iconName: 'cubes',
    icon: [
        576,
        512,
        [],
        "f1b3",
        "M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5V204.7c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7V413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3V294.7c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3V92.5c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2V152.6L392 121v89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4V354.8L256 323.2v95.9l-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1V354.8L528 323.2v90.7c0 3.2-1.9 6-4.8 7.3z"
    ]
};
var $1113a0aa61ab7765$export$89fa217ec5503ac9 = {
    prefix: 'fas',
    iconName: 'divide',
    icon: [
        448,
        512,
        [
            10135,
            247
        ],
        "f529",
        "M272 96c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm0 320c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H400z"
    ]
};
var $1113a0aa61ab7765$export$c04e864469c1d117 = {
    prefix: 'fas',
    iconName: 'tenge-sign',
    icon: [
        384,
        512,
        [
            8376,
            "tenge"
        ],
        "f7d7",
        "M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM0 192c0-17.7 14.3-32 32-32H192 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $1113a0aa61ab7765$export$af6ebee83047b793 = $1113a0aa61ab7765$export$c04e864469c1d117;
var $1113a0aa61ab7765$export$ad02dd8ca5816958 = {
    prefix: 'fas',
    iconName: 'headphones',
    icon: [
        512,
        512,
        [
            127911
        ],
        "f025",
        "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48c-44.2 0-80-35.8-80-80V384 336 288C0 146.6 114.6 32 256 32s256 114.6 256 256v48 48 16c0 44.2-35.8 80-80 80c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48c10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"
    ]
};
var $1113a0aa61ab7765$export$96891bbcda1dbb7b = {
    prefix: 'fas',
    iconName: 'hands-holding',
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
    ]
};
var $1113a0aa61ab7765$export$765c446e974b5e59 = {
    prefix: 'fas',
    iconName: 'hands-clapping',
    icon: [
        576,
        512,
        [],
        "e1a8",
        "M368 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM167 119c9.4-9.4 24.6-9.4 33.9 0L324.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L39 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L87 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM465.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4zM456.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"
    ]
};
var $1113a0aa61ab7765$export$929518bb4b66a588 = {
    prefix: 'fas',
    iconName: 'republican',
    icon: [
        640,
        512,
        [],
        "f75e",
        "M0 192C0 103.6 71.6 32 160 32H384c88.4 0 160 71.6 160 160v64H0V192zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L466 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L178 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160H320h96 32 64 32v32 80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80V352H448v32 64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384 288H128z"
    ]
};
var $1113a0aa61ab7765$export$b7fac681e7d09400 = {
    prefix: 'fas',
    iconName: 'arrow-left',
    icon: [
        448,
        512,
        [
            8592
        ],
        "f060",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var $1113a0aa61ab7765$export$16c9e0374c346c6e = {
    prefix: 'fas',
    iconName: 'person-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e543",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm59.3-180.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $1113a0aa61ab7765$export$8e90575265a56cfc = {
    prefix: 'fas',
    iconName: 'ruler',
    icon: [
        512,
        512,
        [
            128207
        ],
        "f545",
        "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z"
    ]
};
var $1113a0aa61ab7765$export$e490f662af4d1c78 = {
    prefix: 'fas',
    iconName: 'align-left',
    icon: [
        448,
        512,
        [],
        "f036",
        "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$64bfd48ed353c031 = {
    prefix: 'fas',
    iconName: 'dice-d6',
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M216.3 2c4.8-2.6 10.5-2.6 15.3 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L216.3 2zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14V496c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L8.3 414C3.2 411.2 0 405.9 0 400V184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8V400c0 5.9-3.2 11.2-8.3 14l-176 96c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14l176-96z"
    ]
};
var $1113a0aa61ab7765$export$5fbcef35138741a5 = {
    prefix: 'fas',
    iconName: 'restroom',
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M176 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM120 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H120zM320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM560 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM440 480V384H422.2c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H504v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $1113a0aa61ab7765$export$bbf24078bd1f73e6 = {
    prefix: 'fas',
    iconName: 'j',
    icon: [
        320,
        512,
        [
            106
        ],
        "4a",
        "M288 32c17.7 0 32 14.3 32 32V320c0 88.4-71.6 160-160 160S0 408.4 0 320V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$72b785dcfe44c69b = {
    prefix: 'fas',
    iconName: 'users-viewfinder',
    icon: [
        640,
        512,
        [],
        "e595",
        "M48 48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H32C14.3 0 0 14.3 0 32V136c0 13.3 10.7 24 24 24s24-10.7 24-24V48zM175.8 224c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-80-32c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 17.7 14.3 32 32 32H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H48zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H608c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H504z"
    ]
};
var $1113a0aa61ab7765$export$b44eb38345c6a964 = {
    prefix: 'fas',
    iconName: 'file-video',
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V288zM300.9 397.9L256 368V304l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"
    ]
};
var $1113a0aa61ab7765$export$c1a3ba061b4f60c4 = {
    prefix: 'fas',
    iconName: 'up-right-from-square',
    icon: [
        512,
        512,
        [
            "external-link-alt"
        ],
        "f35d",
        "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $1113a0aa61ab7765$export$d7f107e456ab0306 = $1113a0aa61ab7765$export$c1a3ba061b4f60c4;
var $1113a0aa61ab7765$export$c517dffc18db483f = {
    prefix: 'fas',
    iconName: 'table-cells',
    icon: [
        512,
        512,
        [
            "th"
        ],
        "f00a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 64v64H64V96h88zm56 0h88v64H208V96zm240 0v64H360V96h88zM64 224h88v64H64V224zm232 0v64H208V224h88zm64 0h88v64H360V224zM152 352v64H64V352h88zm56 0h88v64H208V352zm240 0v64H360V352h88z"
    ]
};
var $1113a0aa61ab7765$export$4d383c83efc0c819 = $1113a0aa61ab7765$export$c517dffc18db483f;
var $1113a0aa61ab7765$export$38611f1c776aba73 = {
    prefix: 'fas',
    iconName: 'file-pdf',
    icon: [
        384,
        512,
        [],
        "f1c1",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 224H88c30.9 0 56 25.1 56 56s-25.1 56-56 56H80v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V320 240c0-8.8 7.2-16 16-16zm24 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H80v48h8zm72-64c0-8.8 7.2-16 16-16h24c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V240zm32 112h8c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16h-8v96zm96-128h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H304v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H304v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 240c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$df8194b081d34b27 = {
    prefix: 'fas',
    iconName: 'book-bible',
    icon: [
        448,
        512,
        [
            "bible"
        ],
        "f647",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272V304c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V192H160c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h48V80z"
    ]
};
var $1113a0aa61ab7765$export$2eac809b0670d139 = $1113a0aa61ab7765$export$df8194b081d34b27;
var $1113a0aa61ab7765$export$9db87eabf605857e = {
    prefix: 'fas',
    iconName: 'o',
    icon: [
        448,
        512,
        [
            111
        ],
        "4f",
        "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160s160-71.6 160-160s-71.6-160-160-160zM0 256C0 132.3 100.3 32 224 32s224 100.3 224 224s-100.3 224-224 224S0 379.7 0 256z"
    ]
};
var $1113a0aa61ab7765$export$25ea11267429d202 = {
    prefix: 'fas',
    iconName: 'suitcase-medical',
    icon: [
        512,
        512,
        [
            "medkit"
        ],
        "f0fa",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96v32V480H384V128 96 56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM96 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H96V96zM416 480h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H416V480zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $1113a0aa61ab7765$export$e75f02bae5b7d34b = $1113a0aa61ab7765$export$25ea11267429d202;
var $1113a0aa61ab7765$export$597826232327559b = {
    prefix: 'fas',
    iconName: 'user-secret',
    icon: [
        448,
        512,
        [
            128373
        ],
        "f21b",
        "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48H45.4C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4H342.7c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.7 3.3-8.8 6.1-15.5 6.1zm56 208H267.6c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2H168c-22.1 0-40-17.9-40-40V169.6c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4V184c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"
    ]
};
var $1113a0aa61ab7765$export$743cce3ca4eb1d7d = {
    prefix: 'fas',
    iconName: 'otter',
    icon: [
        640,
        512,
        [
            129446
        ],
        "f700",
        "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V336 320c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6V240c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16v32 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V204.3c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1h0c0 123.7-100.3 224-224 224h-1.1H256h-.6C132 480 32 380 32 256.6V256 216.8c-10.1-14.6-16-32.3-16-51.4V144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4v21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64H320c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6zM96 160c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm144-16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$27f7383b96c3f4b4 = {
    prefix: 'fas',
    iconName: 'person-dress',
    icon: [
        320,
        512,
        [
            "female"
        ],
        "f182",
        "M160 96c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zM88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H152v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
    ]
};
var $1113a0aa61ab7765$export$70e8e75e61dd7169 = $1113a0aa61ab7765$export$27f7383b96c3f4b4;
var $1113a0aa61ab7765$export$7a088030853df12c = {
    prefix: 'fas',
    iconName: 'comment-dollar',
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"
    ]
};
var $1113a0aa61ab7765$export$694b7e88782dec12 = {
    prefix: 'fas',
    iconName: 'business-time',
    icon: [
        640,
        512,
        [
            "briefcase-clock"
        ],
        "f64a",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 352h8.2c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM320 352H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H360.2C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zM496 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$8b00ae94743552ce = $1113a0aa61ab7765$export$694b7e88782dec12;
var $1113a0aa61ab7765$export$d2bcaf492dfb3817 = {
    prefix: 'fas',
    iconName: 'table-cells-large',
    icon: [
        512,
        512,
        [
            "th-large"
        ],
        "f009",
        "M448 96V224H288V96H448zm0 192V416H288V288H448zM224 224H64V96H224V224zM64 288H224V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $1113a0aa61ab7765$export$69782f333e90cdc6 = $1113a0aa61ab7765$export$d2bcaf492dfb3817;
var $1113a0aa61ab7765$export$24c764717169f536 = {
    prefix: 'fas',
    iconName: 'book-tanakh',
    icon: [
        448,
        512,
        [
            "tanakh"
        ],
        "f827",
        "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24H124.9l13.9-24zm-13.9-24L97.1 232c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H305c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24H249.6L221.9 64c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48H111c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0l27.7-48h55.4l27.7 48-27.7 48H180.3l-27.7-48zm0-48l-13.9 24-13.9-24h27.7zm41.6-24L208 88l13.9 24H194.1zm69.3 24h27.7l-13.9 24-13.9-24zm13.9 72l13.9 24H263.4l13.9-24zm-55.4 48L208 280l-13.9-24h27.7z"
    ]
};
var $1113a0aa61ab7765$export$7fd4a58929315448 = $1113a0aa61ab7765$export$24c764717169f536;
var $1113a0aa61ab7765$export$c377f240bb8b5d74 = {
    prefix: 'fas',
    iconName: 'phone-volume',
    icon: [
        512,
        512,
        [
            "volume-control-phone"
        ],
        "f2a0",
        "M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"
    ]
};
var $1113a0aa61ab7765$export$5358d004fa3d3be2 = $1113a0aa61ab7765$export$c377f240bb8b5d74;
var $1113a0aa61ab7765$export$ab6f71fd6878da90 = {
    prefix: 'fas',
    iconName: 'hat-cowboy-side',
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M463.2 71.3c-2.4-12.8-9.8-24.1-20.7-31.3s-24.2-9.7-36.9-6.8l-216 48c-19.8 4.4-34.7 20.8-37.2 40.9l-8.8 70.6c5.3-.4 10.8-.7 16.5-.7c82.9 0 141.9 55.3 197.5 107.5l0 0c3.1 3 6.3 5.9 9.4 8.8C427.1 364.5 486.9 416 576 416c0 0 64 0 64-48c0-96-112-128-144-128h-1.6L463.2 71.3zM576 448c-102.9 0-171.1-60.5-230.9-116.3l-6.5-6C279.9 270.8 229.9 224 160 224c-57.8 0-97.4 28.6-123.1 63.5C10.7 323 0 363.8 0 384c0 35.3 28.7 64 64 64H576z"
    ]
};
var $1113a0aa61ab7765$export$1204f2d171424659 = {
    prefix: 'fas',
    iconName: 'clipboard-user',
    icon: [
        384,
        512,
        [],
        "f7f3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
    ]
};
var $1113a0aa61ab7765$export$60b41e3581d1739a = {
    prefix: 'fas',
    iconName: 'child',
    icon: [
        320,
        512,
        [],
        "f1ae",
        "M224 64c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM144 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H144z"
    ]
};
var $1113a0aa61ab7765$export$f0f37dbc60110b10 = {
    prefix: 'fas',
    iconName: 'lira-sign',
    icon: [
        384,
        512,
        [
            8356
        ],
        "f195",
        "M144 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L249 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C137.5 32 80 89.5 80 160.4V192H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H80v32H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H78c-2.2 10.5-6.1 20.6-11.7 29.9L36.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S52.5 480 64 480H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H120.5l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H144V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H144V160.4z"
    ]
};
var $1113a0aa61ab7765$export$da3f1730d013e224 = {
    prefix: 'fas',
    iconName: 'satellite',
    icon: [
        512,
        512,
        [
            128752
        ],
        "f7bf",
        "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"
    ]
};
var $1113a0aa61ab7765$export$1125ac57be52258c = {
    prefix: 'fas',
    iconName: 'plane-lock',
    icon: [
        640,
        512,
        [],
        "e558",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l101.8 58.2C418 247.6 416 259.6 416 272v24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1V400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v24 18c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $1113a0aa61ab7765$export$cb61f447f29887e = {
    prefix: 'fas',
    iconName: 'tag',
    icon: [
        448,
        512,
        [
            127991
        ],
        "f02b",
        "M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 96c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$805cd88398a70581 = {
    prefix: 'fas',
    iconName: 'comment',
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"
    ]
};
var $1113a0aa61ab7765$export$e4019fe302a972e1 = {
    prefix: 'fas',
    iconName: 'cake-candles',
    icon: [
        448,
        512,
        [
            127874,
            "birthday-cake",
            "cake"
        ],
        "f1fd",
        "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c-35.3 0-64 28.7-64 64v71c8.3 5.2 18.1 9 28.8 9c13.5 0 27.2-6.1 38.4-13.4c5.4-3.5 9.9-7.1 13-9.7c1.5-1.3 2.7-2.4 3.5-3.1c.4-.4 .7-.6 .8-.8l.1-.1 0 0 0 0s0 0 0 0s0 0 0 0c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4l0 0 0 0 .1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8l0 0 0 0 0 0 .1 .1c.2 .2 .4 .4 .8 .8c.8 .7 1.9 1.8 3.5 3.1c3.1 2.6 7.5 6.2 13 9.7c11.2 7.3 24.9 13.4 38.4 13.4c10.7 0 20.5-3.9 28.8-9V288c0-35.3-28.7-64-64-64V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H256V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H128V176zM448 394.6c-8.5 3.3-18.2 5.4-28.8 5.4c-22.5 0-42.4-9.9-55.8-18.6c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5c-3.1 2.4-6.8 5.1-10.9 7.8C71.2 390.1 51.3 400 28.8 400c-10.6 0-20.3-2.2-28.8-5.4V480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V394.6z"
    ]
};
var $1113a0aa61ab7765$export$bdcf98f725a7241a = $1113a0aa61ab7765$export$e4019fe302a972e1;
var $1113a0aa61ab7765$export$707bc1c80c0177c1 = $1113a0aa61ab7765$export$e4019fe302a972e1;
var $1113a0aa61ab7765$export$6f095630677adc = {
    prefix: 'fas',
    iconName: 'envelope',
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
    ]
};
var $1113a0aa61ab7765$export$152ef92a4f9d80a7 = {
    prefix: 'fas',
    iconName: 'angles-up',
    icon: [
        448,
        512,
        [
            "angle-double-up"
        ],
        "f102",
        "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var $1113a0aa61ab7765$export$9bb51e1a2c07db7c = $1113a0aa61ab7765$export$152ef92a4f9d80a7;
var $1113a0aa61ab7765$export$4b24ca1552f410af = {
    prefix: 'fas',
    iconName: 'paperclip',
    icon: [
        512,
        512,
        [
            128206
        ],
        "f0c6",
        "M396.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"
    ]
};
var $1113a0aa61ab7765$export$e201217e5046cd15 = {
    prefix: 'fas',
    iconName: 'arrow-right-to-city',
    icon: [
        640,
        512,
        [],
        "e4b3",
        "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
    ]
};
var $1113a0aa61ab7765$export$838459d11f3971df = {
    prefix: 'fas',
    iconName: 'ribbon',
    icon: [
        448,
        512,
        [
            127895
        ],
        "f4d6",
        "M224 96c39.5 0 66.8 12.2 81.9 21.5L245.6 184l79.3 87.4 36.3-40c14.7-16.2 22.8-37.3 22.8-59.1v-27c0-15.6-4.1-30.8-12-44.3L337.7 42C326.4 22.7 307 6.8 282.1 3.5C267.8 1.6 248.4 0 224 0s-43.8 1.6-58 3.5C141 6.8 121.7 22.7 110.4 42L76 101c-7.8 13.4-12 28.7-12 44.3v27c0 21.9 8.1 42.9 22.8 59.1l57.9 63.8L224 382.6 334.2 504.1c6.4 7 16.3 9.7 25.4 6.6l72-24c7.7-2.6 13.6-8.8 15.6-16.7s0-16.2-5.4-22.2L303.3 295.2 224 207.8l-81.9-90.3C157.3 108.2 184.5 96 224 96zM202.4 406.5L123.2 319 6.3 447.9c-5.4 6-7.5 14.4-5.4 22.2s7.9 14.1 15.6 16.7l72 24c9 3 19 .4 25.4-6.6l88.6-97.7z"
    ]
};
var $1113a0aa61ab7765$export$ba9b387e84727819 = {
    prefix: 'fas',
    iconName: 'lungs',
    icon: [
        640,
        512,
        [
            129729
        ],
        "f604",
        "M320 0c17.7 0 32 14.3 32 32V164.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V325l90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1v-.4l-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1c-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6c0 0 0 0-.1 0c-7.4 4.8-9.6 14.6-4.8 22.1c4.7 7.5 14.6 9.7 22.1 4.9l91.1-58V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v45.5l9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5V32c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$25218e5886296cb9 = {
    prefix: 'fas',
    iconName: 'arrow-up-9-1',
    icon: [
        576,
        512,
        [
            "sort-numeric-up-alt"
        ],
        "f887",
        "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM352 320c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V352H384c-17.7 0-32-14.3-32-32zm93.7-171.1c10.8-5.1 18.3-16.2 18.3-28.9c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c4.9 0 9.6-1.1 13.7-3.1zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
var $1113a0aa61ab7765$export$d41859f1bbb9e086 = $1113a0aa61ab7765$export$25218e5886296cb9;
var $1113a0aa61ab7765$export$4a157bd81dcd8d80 = {
    prefix: 'fas',
    iconName: 'litecoin-sign',
    icon: [
        448,
        512,
        [],
        "e1d3",
        "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V213.6L55.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L96 280.1V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V261.9l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L160 195.3V64z"
    ]
};
var $1113a0aa61ab7765$export$2b488402ec335d97 = {
    prefix: 'fas',
    iconName: 'border-none',
    icon: [
        448,
        512,
        [],
        "f850",
        "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zm96 64c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm0-384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zM320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm0-448c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zm0 256c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM224 416c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zm0-320c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zM416 480c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm0-384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM32 32C14.3 32 0 46.3 0 64S14.3 96 32 96s32-14.3 32-32s-14.3-32-32-32zM416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zM224 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm192-64c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zM32 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM416 128c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zM32 192c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm192-64c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32z"
    ]
};
var $1113a0aa61ab7765$export$de462dd5a18e80d4 = {
    prefix: 'fas',
    iconName: 'circle-nodes',
    icon: [
        512,
        512,
        [],
        "e4e2",
        "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"
    ]
};
var $1113a0aa61ab7765$export$ca9e3368f1d9500a = {
    prefix: 'fas',
    iconName: 'parachute-box',
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16H240V320H208c-7 0-13.7 1.5-19.7 4.2L68.2 192H96.5c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192h6L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2H272V192H383.5z"
    ]
};
var $1113a0aa61ab7765$export$318208bc30aeebcc = {
    prefix: 'fas',
    iconName: 'indent',
    icon: [
        448,
        512,
        [],
        "f03c",
        "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"
    ]
};
var $1113a0aa61ab7765$export$40cb0a4a3a74dc03 = {
    prefix: 'fas',
    iconName: 'truck-field-un',
    icon: [
        640,
        512,
        [],
        "e58e",
        "M96 32C60.7 32 32 60.7 32 96v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38H375.4C364.4 44.9 343.7 32 320 32H96zm288 96h43.2l42.7 96H384V128zM208 384c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zm272 48c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$b9098a890f61e022 = {
    prefix: 'fas',
    iconName: 'hourglass',
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M0 32C0 14.3 14.3 0 32 0H64 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32zM96 64V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64H96zm0 384H288V437c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11z"
    ]
};
var $1113a0aa61ab7765$export$a2f8176a0161e891 = $1113a0aa61ab7765$export$b9098a890f61e022;
var $1113a0aa61ab7765$export$64f9eb99c9749cce = {
    prefix: 'fas',
    iconName: 'mountain',
    icon: [
        512,
        512,
        [
            127956
        ],
        "f6fc",
        "M256 32c12.5 0 24.1 6.4 30.7 17L503.4 394.4c5.6 8.9 8.6 19.2 8.6 29.7c0 30.9-25 55.9-55.9 55.9H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192L256 120.4 176.9 246.5 208 288l48-64h65z"
    ]
};
var $1113a0aa61ab7765$export$9884bf227eeb829 = {
    prefix: 'fas',
    iconName: 'user-doctor',
    icon: [
        448,
        512,
        [
            "user-md"
        ],
        "f0f0",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $1113a0aa61ab7765$export$ab0d33a2c03f1794 = $1113a0aa61ab7765$export$9884bf227eeb829;
var $1113a0aa61ab7765$export$317f99f46b39906e = {
    prefix: 'fas',
    iconName: 'circle-info',
    icon: [
        512,
        512,
        [
            "info-circle"
        ],
        "f05a",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-144c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$aa9288aeadf882fa = $1113a0aa61ab7765$export$317f99f46b39906e;
var $1113a0aa61ab7765$export$5d120e8b87ad33f4 = {
    prefix: 'fas',
    iconName: 'cloud-meatball',
    icon: [
        512,
        512,
        [],
        "f73b",
        "M0 224c0 53 43 96 96 96h44.7c9.5-23.5 32.5-40 59.3-40c2 0 3.9 .1 5.8 .3C217.6 265.5 235.7 256 256 256s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3c26.9 0 49.9 16.5 59.3 40H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1 .1 3.1c-.7-.8-1.4-1.6-2.1-2.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7 .7-1.4 1.5-2.1 2.3c.1-1 .1-2.1 .1-3.1zM48 448c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm416 0c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $1113a0aa61ab7765$export$84ffbd7161ca2008 = {
    prefix: 'fas',
    iconName: 'camera',
    icon: [
        512,
        512,
        [
            62258,
            "camera-alt"
        ],
        "f030",
        "M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 384c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96z"
    ]
};
var $1113a0aa61ab7765$export$8872b5664e88e793 = $1113a0aa61ab7765$export$84ffbd7161ca2008;
var $1113a0aa61ab7765$export$f9409a7b020dbec4 = {
    prefix: 'fas',
    iconName: 'square-virus',
    icon: [
        448,
        512,
        [],
        "e578",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24zM192 256c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm88 32c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $1113a0aa61ab7765$export$1439f0d6365138da = {
    prefix: 'fas',
    iconName: 'meteor',
    icon: [
        512,
        512,
        [
            9732
        ],
        "f753",
        "M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 448c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128zm0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm16 96c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $1113a0aa61ab7765$export$d901d50df5cf8d91 = {
    prefix: 'fas',
    iconName: 'car-on',
    icon: [
        512,
        512,
        [],
        "e4dd",
        "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM185.8 224H326.2c6.8 0 12.8 4.3 15.1 10.6L360.3 288H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344v40 64 32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448H384v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 392c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm280-24c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
    ]
};
var $1113a0aa61ab7765$export$26a8fd1143d2d6c0 = {
    prefix: 'fas',
    iconName: 'sleigh',
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V256c0 53 43 96 96 96v32h64V352H384v32h64V352c53 0 96-43 96-96V160c17.7 0 32-14.3 32-32s-14.3-32-32-32H512 480c-17.7 0-32 14.3-32 32v41.3c0 30.2-24.5 54.7-54.7 54.7c-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7H55 32zM640 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 13.3-10.7 24-24 24H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H552c48.6 0 88-39.4 88-88v-8z"
    ]
};
var $1113a0aa61ab7765$export$9a40d582bd4628fb = {
    prefix: 'fas',
    iconName: 'arrow-down-1-9',
    icon: [
        576,
        512,
        [
            "sort-numeric-asc",
            "sort-numeric-down"
        ],
        "f162",
        "M352 64c0 17.7 14.3 32 32 32h16v64H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V64c0-17.7-14.3-32-32-32H384c-17.7 0-32 14.3-32 32zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM445.7 364.9c-4.2 2-8.8 3.1-13.7 3.1c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32c0 12.8-7.5 23.8-18.3 28.9zm-40.7 54.9l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
var $1113a0aa61ab7765$export$a4fb1aa2cdfb18d7 = $1113a0aa61ab7765$export$9a40d582bd4628fb;
var $1113a0aa61ab7765$export$835db7eb35b3c29b = $1113a0aa61ab7765$export$9a40d582bd4628fb;
var $1113a0aa61ab7765$export$b9c3f9a906f96b82 = {
    prefix: 'fas',
    iconName: 'hand-holding-droplet',
    icon: [
        576,
        512,
        [
            "hand-holding-water"
        ],
        "f4c1",
        "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $1113a0aa61ab7765$export$4265371b99d38b95 = $1113a0aa61ab7765$export$b9c3f9a906f96b82;
var $1113a0aa61ab7765$export$efaeddad0a6e901b = {
    prefix: 'fas',
    iconName: 'water',
    icon: [
        576,
        512,
        [],
        "f773",
        "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 149.7 417 160 384 160c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4C42.8 92.6 61 83.5 75.3 71.6c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288C329 373.4 356.5 384 384 384c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 437.7 417 448 384 448c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 373.2 165.1 384 192 384c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0zm0-144C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $1113a0aa61ab7765$export$5655108e1162ba45 = {
    prefix: 'fas',
    iconName: 'calendar-check',
    icon: [
        448,
        512,
        [],
        "f274",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"
    ]
};
var $1113a0aa61ab7765$export$983e9c27cac7ed1c = {
    prefix: 'fas',
    iconName: 'braille',
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M128 96c0 35.3-28.7 64-64 64S0 131.3 0 96S28.7 32 64 32s64 28.7 64 64zm96 176c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm0 48c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM80 416c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm112 0c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM64 320c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM224 160c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM480 96c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm112 0c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM576 272c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm0 48c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm16 96c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM416 272c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm0 48c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm16 96c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64z"
    ]
};
var $1113a0aa61ab7765$export$99cfe064ff0b71c9 = {
    prefix: 'fas',
    iconName: 'prescription-bottle-medical',
    icon: [
        384,
        512,
        [
            "prescription-bottle-alt"
        ],
        "f486",
        "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM160 240v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $1113a0aa61ab7765$export$65d1c884b8581d1a = $1113a0aa61ab7765$export$99cfe064ff0b71c9;
var $1113a0aa61ab7765$export$2bebc54c51db6505 = {
    prefix: 'fas',
    iconName: 'landmark',
    icon: [
        512,
        512,
        [
            127963
        ],
        "f66f",
        "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1L448 104l0 .9 47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8H32c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9V104l4.4-1.6L240.1 4.2zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
    ]
};
var $1113a0aa61ab7765$export$d7895f386f8bd8b8 = {
    prefix: 'fas',
    iconName: 'truck',
    icon: [
        640,
        512,
        [
            128666,
            9951
        ],
        "f0d1",
        "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM208 416c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zm272 48c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $1113a0aa61ab7765$export$721c101130c40043 = {
    prefix: 'fas',
    iconName: 'crosshairs',
    icon: [
        512,
        512,
        [],
        "f05b",
        "M256 0c17.7 0 32 14.3 32 32V42.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H469.6c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V469.6C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H42.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6C392.1 165.7 346.3 119.9 288 107.4V128c0 17.7-14.3 32-32 32s-32-14.3-32-32V107.4C165.7 119.9 119.9 165.7 107.4 224H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H107.4zM256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$c48422e9da776c1b = {
    prefix: 'fas',
    iconName: 'person-cane',
    icon: [
        448,
        512,
        [],
        "e53c",
        "M272 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm-8 187.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"
    ]
};
var $1113a0aa61ab7765$export$e5075400db564e24 = {
    prefix: 'fas',
    iconName: 'tent',
    icon: [
        576,
        512,
        [],
        "e57d",
        "M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H416L288 288V512H32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"
    ]
};
var $1113a0aa61ab7765$export$750a64470c2e0f3f = {
    prefix: 'fas',
    iconName: 'vest-patches',
    icon: [
        448,
        512,
        [],
        "e086",
        "M151.2 69.7l55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6V128 54.3 48C64 21.5 85.5 0 112 0h4.5c.2 0 .4 0 .6 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c.2 0 .4 0 .6 0H336c26.5 0 48 21.5 48 48v6.3V128v17.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V295.8c0-5.2 .8-10.3 2.5-15.2L296.8 69.7C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280v8 32c0 8.8 7.2 16 16 16h32 8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $1113a0aa61ab7765$export$f178c8c2ad3cc861 = {
    prefix: 'fas',
    iconName: 'check-double',
    icon: [
        512,
        512,
        [],
        "f560",
        "M374.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7 86.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"
    ]
};
var $1113a0aa61ab7765$export$43b642fac7053978 = {
    prefix: 'fas',
    iconName: 'arrow-down-a-z',
    icon: [
        576,
        512,
        [
            "sort-alpha-asc",
            "sort-alpha-down"
        ],
        "f15d",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352H352c-17.7 0-32-14.3-32-32zM416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176h40.4L416 135.6 395.8 176z"
    ]
};
var $1113a0aa61ab7765$export$cb87697f2fa77cfc = $1113a0aa61ab7765$export$43b642fac7053978;
var $1113a0aa61ab7765$export$7658045270aafde3 = $1113a0aa61ab7765$export$43b642fac7053978;
var $1113a0aa61ab7765$export$6a4ef2ef77625063 = {
    prefix: 'fas',
    iconName: 'money-bill-wheat',
    icon: [
        512,
        512,
        [],
        "e52a",
        "M176 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM56 16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 64 32 53.3 32 40s10.7-24 24-24zM24 88H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24S10.7 88 24 88zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $1113a0aa61ab7765$export$b3e64f5f68c6623f = {
    prefix: 'fas',
    iconName: 'cookie',
    icon: [
        512,
        512,
        [
            127850
        ],
        "f563",
        "M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 208c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$89b706873769c180 = {
    prefix: 'fas',
    iconName: 'arrow-rotate-left',
    icon: [
        512,
        512,
        [
            8634,
            "arrow-left-rotate",
            "arrow-rotate-back",
            "arrow-rotate-backward",
            "undo"
        ],
        "f0e2",
        "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
    ]
};
var $1113a0aa61ab7765$export$1aea864c3e1d79b = $1113a0aa61ab7765$export$89b706873769c180;
var $1113a0aa61ab7765$export$a34701878babe5fc = $1113a0aa61ab7765$export$89b706873769c180;
var $1113a0aa61ab7765$export$fce381d12e4535cd = $1113a0aa61ab7765$export$89b706873769c180;
var $1113a0aa61ab7765$export$a5e5ba60b1dfe2b2 = $1113a0aa61ab7765$export$89b706873769c180;
var $1113a0aa61ab7765$export$4cb736b866cbb7ec = {
    prefix: 'fas',
    iconName: 'hard-drive',
    icon: [
        512,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V280.4c-17-15.2-39.4-24.4-64-24.4H64c-24.6 0-47 9.2-64 24.4V96zM64 288H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zM320 416c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm128-32c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$62551e9c5ba7093f = $1113a0aa61ab7765$export$4cb736b866cbb7ec;
var $1113a0aa61ab7765$export$8ff56f5ebb8416a0 = {
    prefix: 'fas',
    iconName: 'face-grin-squint-tears',
    icon: [
        512,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7c-18.5 5-38.8 8.3-50.9 10c-4.9 .8-9.1-2.8-9.5-7.4c-.1-.7 0-1.4 .1-2.1c1.6-11.2 4.6-29.6 9-47c.3-1.3 .7-2.6 1-3.9c4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.7c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zM51.5 410.1c18.5-5 38.8-8.3 50.9-10c.4-.1 .7-.1 1-.1c5.1-.2 9.2 4.3 8.4 9.6c-1.7 12.1-5 32.4-10 50.9C97.6 476.4 92 491 85.2 497.8C66 517 34.5 516.6 14.9 497.1s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.9 209c-4.7-11.9-20.8-11-26.8 .3c-19 35.5-45 70.8-77.5 103.3S244.8 371.1 209.3 390c-11.3 6-12.2 22.1-.3 26.8c57.6 22.9 125.8 11 172.3-35.5s58.4-114.8 35.5-172.3zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.2-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z"
    ]
};
var $1113a0aa61ab7765$export$542206d6a85f3b42 = $1113a0aa61ab7765$export$8ff56f5ebb8416a0;
var $1113a0aa61ab7765$export$56700074cf37be5c = {
    prefix: 'fas',
    iconName: 'dumbbell',
    icon: [
        640,
        512,
        [],
        "f44b",
        "M112 96c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32V224v64V416c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32h48V96zm416 0v32h48c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H528v32c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 96c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"
    ]
};
var $1113a0aa61ab7765$export$1f7600fa9fdb3978 = {
    prefix: 'fas',
    iconName: 'rectangle-list',
    icon: [
        576,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm32-128c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM128 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"
    ]
};
var $1113a0aa61ab7765$export$c6327a203ffc65a3 = $1113a0aa61ab7765$export$1f7600fa9fdb3978;
var $1113a0aa61ab7765$export$1585b7c3c7109751 = {
    prefix: 'fas',
    iconName: 'tarp-droplet',
    icon: [
        576,
        512,
        [],
        "e57c",
        "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128H197.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64V352H448c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM448 512l0-128H576L448 512zM96 256c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$5d08d08f88a96aac = {
    prefix: 'fas',
    iconName: 'house-medical-circle-check',
    icon: [
        640,
        512,
        [],
        "e511",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm320 0c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-76.7-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $1113a0aa61ab7765$export$c8cd1786449517d3 = {
    prefix: 'fas',
    iconName: 'person-skiing-nordic',
    icon: [
        576,
        512,
        [
            "skiing-nordic"
        ],
        "f7ca",
        "M336 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM227.2 160c1.9 0 3.8 .1 5.6 .3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9L291.3 464H202.8l41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464H99.7l54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zM121.4 198.6c.4 .4 .8 .8 1.3 1.2L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H159.3c.4 0 .9 0 1.3 0H319.3c.5 0 1 0 1.4 0H504c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24H434.6l27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7c0-17.7-14.3-32-32-32H426.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4L402.3 464H357.8l21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3C353 264.7 387.9 288 426.7 288h2.7z"
    ]
};
var $1113a0aa61ab7765$export$6ea48260d7d09b1b = $1113a0aa61ab7765$export$c8cd1786449517d3;
var $1113a0aa61ab7765$export$16768a660ae3ca9d = {
    prefix: 'fas',
    iconName: 'calendar-plus',
    icon: [
        448,
        512,
        [],
        "f271",
        "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM224 248c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H144c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V272c0-13.3 10.7-24 24-24z"
    ]
};
var $1113a0aa61ab7765$export$9b2dbe133273f284 = {
    prefix: 'fas',
    iconName: 'plane-arrival',
    icon: [
        640,
        512,
        [
            128748
        ],
        "f5af",
        "M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14-9.3-22.5zM32 448H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160-80c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm64 48c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$5ae86b9da9cca3bd = {
    prefix: 'fas',
    iconName: 'circle-left',
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512s256-114.6 256-256zM116.7 244.7l112-112c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8l0 64 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 64c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-112-112c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $1113a0aa61ab7765$export$5460a5b11a24996f = $1113a0aa61ab7765$export$5ae86b9da9cca3bd;
var $1113a0aa61ab7765$export$cda326cc3bce41c = {
    prefix: 'fas',
    iconName: 'train-subway',
    icon: [
        448,
        512,
        [
            "subway"
        ],
        "f239",
        "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 128c0-17.7 14.3-32 32-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM272 96h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM128 352c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm224 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$4cabc8a12d4e2f9 = $1113a0aa61ab7765$export$cda326cc3bce41c;
var $1113a0aa61ab7765$export$dce43b02b3fe0c18 = {
    prefix: 'fas',
    iconName: 'chart-gantt',
    icon: [
        512,
        512,
        [],
        "e0e4",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm96 64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$1d2b135cc5a2c852 = {
    prefix: 'fas',
    iconName: 'indian-rupee-sign',
    icon: [
        320,
        512,
        [
            "indian-rupee",
            "inr"
        ],
        "e1bc",
        "M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z"
    ]
};
var $1113a0aa61ab7765$export$be886a4def17c565 = $1113a0aa61ab7765$export$1d2b135cc5a2c852;
var $1113a0aa61ab7765$export$12c6d8b3e052490b = $1113a0aa61ab7765$export$1d2b135cc5a2c852;
var $1113a0aa61ab7765$export$c3605731beb92daf = {
    prefix: 'fas',
    iconName: 'crop-simple',
    icon: [
        512,
        512,
        [
            "crop-alt"
        ],
        "f565",
        "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z"
    ]
};
var $1113a0aa61ab7765$export$d932915fde4f1010 = $1113a0aa61ab7765$export$c3605731beb92daf;
var $1113a0aa61ab7765$export$a312c7d58dd44a75 = {
    prefix: 'fas',
    iconName: 'money-bill-1',
    icon: [
        576,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM400 256c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112zM252 208c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
    ]
};
var $1113a0aa61ab7765$export$a35d573395884c3d = $1113a0aa61ab7765$export$a312c7d58dd44a75;
var $1113a0aa61ab7765$export$1db7e2ee10d36035 = {
    prefix: 'fas',
    iconName: 'left-long',
    icon: [
        512,
        512,
        [
            "long-arrow-alt-left"
        ],
        "f30a",
        "M177.5 98c-8.8-3.8-19-2-26 4.6l-144 136C2.7 243.1 0 249.4 0 256s2.7 12.9 7.5 17.4l144 136c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22l0-88 288 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-288 0 0-88c0-9.6-5.7-18.2-14.5-22z"
    ]
};
var $1113a0aa61ab7765$export$a8b3226b2bf323d = $1113a0aa61ab7765$export$1db7e2ee10d36035;
var $1113a0aa61ab7765$export$c062100d54a2da00 = {
    prefix: 'fas',
    iconName: 'dna',
    icon: [
        448,
        512,
        [
            129516
        ],
        "f471",
        "M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9l0 0 0 0 0 0-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5H283.3c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32H384c0-17.7 14.3-32 32-32zM338.6 384H109.4c-10.1 10.6-18.6 21.3-25.5 32H364.1c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128H338.6c10.1-10.7 18.6-21.3 25.5-32H83.9c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5H164.7z"
    ]
};
var $1113a0aa61ab7765$export$c4ff5306c5470939 = {
    prefix: 'fas',
    iconName: 'virus-slash',
    icon: [
        640,
        512,
        [],
        "e075",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM107.5 224H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.2 23.6-52.7 50-55.7L144.7 210c-9.5 8.5-22.2 14-37.2 14z"
    ]
};
var $1113a0aa61ab7765$export$fee0376c250cdef = {
    prefix: 'fas',
    iconName: 'minus',
    icon: [
        448,
        512,
        [
            8211,
            8722,
            10134,
            "subtract"
        ],
        "f068",
        "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$f8cb2531ef1fc4a2 = $1113a0aa61ab7765$export$fee0376c250cdef;
var $1113a0aa61ab7765$export$442fddbbd741c590 = {
    prefix: 'fas',
    iconName: 'chess',
    icon: [
        512,
        512,
        [],
        "f439",
        "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H59.4C48.7 96 40 104.7 40 115.4c0 3 .7 5.9 2 8.7c6 12.4 23.8 50.8 32.8 83.9H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h7.7C78 302.9 69.4 352.7 63.1 384H192.9c-6.4-31.3-14.9-81.1-16.6-128H184c13.3 0 24-10.7 24-24s-10.7-24-24-24h-2.8c9-33.2 26.8-71.5 32.8-83.9c1.3-2.7 2-5.6 2-8.7c0-10.7-8.7-19.4-19.4-19.4H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM25.2 451.4l-8.8 4.4C6.3 460.8 0 471.1 0 482.3C0 498.7 13.3 512 29.7 512H226.3c16.4 0 29.7-13.3 29.7-29.7c0-11.2-6.3-21.5-16.4-26.5l-8.8-4.4c-4.1-2.1-6.8-6.3-6.8-10.9c0-13.5-10.9-24.4-24.4-24.4H56.4C42.9 416 32 426.9 32 440.4c0 4.6-2.6 8.9-6.8 10.9zm279.2 4.4c-10.1 5-16.4 15.3-16.4 26.5c0 16.4 13.3 29.7 29.7 29.7H482.3c16.4 0 29.7-13.3 29.7-29.7c0-11.2-6.3-21.5-16.4-26.5l-8.8-4.4c-4.1-2.1-6.8-6.3-6.8-10.9c0-13.5-10.9-24.4-24.4-24.4H344.4c-13.5 0-24.4 10.9-24.4 24.4c0 4.6-2.6 8.9-6.8 10.9l-8.8 4.4zM304 259.9c0 7.8 2.8 15.3 8 21.1l18.9 21.4c5.4 6.1 8.2 14 8 22.1L337 384H462.5l-2.7-58.7c-.4-8.5 2.6-16.9 8.4-23.1l19.3-21c5.4-5.9 8.5-13.6 8.5-21.7V200c0-4.4-3.6-8-8-8H464c-4.4 0-8 3.6-8 8v16c0 4.4-3.6 8-8 8h-8c-4.4 0-8-3.6-8-8V200c0-4.4-3.6-8-8-8H376c-4.4 0-8 3.6-8 8v16c0 4.4-3.6 8-8 8h-8c-4.4 0-8-3.6-8-8V200c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v59.9zM392 336c-4.4 0-8-3.6-8-8V304c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 4.4-3.6 8-8 8H392z"
    ]
};
var $1113a0aa61ab7765$export$6e5225f0e6c0bacd = {
    prefix: 'fas',
    iconName: 'arrow-left-long',
    icon: [
        512,
        512,
        [
            "long-arrow-left"
        ],
        "f177",
        "M109.3 288L480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288z"
    ]
};
var $1113a0aa61ab7765$export$80896efc906118b4 = $1113a0aa61ab7765$export$6e5225f0e6c0bacd;
var $1113a0aa61ab7765$export$2bd45e99b9afa947 = {
    prefix: 'fas',
    iconName: 'plug-circle-check',
    icon: [
        576,
        512,
        [],
        "e55c",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $1113a0aa61ab7765$export$6aab6c3359c2554c = {
    prefix: 'fas',
    iconName: 'street-view',
    icon: [
        512,
        512,
        [],
        "f21d",
        "M320 64c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"
    ]
};
var $1113a0aa61ab7765$export$acef3e5c2029d285 = {
    prefix: 'fas',
    iconName: 'franc-sign',
    icon: [
        320,
        512,
        [],
        "e18f",
        "M80 32C62.3 32 48 46.3 48 64V224v96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $1113a0aa61ab7765$export$d94ba52e980ea0f1 = {
    prefix: 'fas',
    iconName: 'volume-off',
    icon: [
        320,
        512,
        [],
        "f026",
        "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"
    ]
};
var $1113a0aa61ab7765$export$bc43eb4655c78f49 = {
    prefix: 'fas',
    iconName: 'hands-asl-interpreting',
    icon: [
        640,
        512,
        [
            "american-sign-language-interpreting",
            "asl-interpreting",
            "hands-american-sign-language-interpreting"
        ],
        "f2a3",
        "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7V256c0 70.7 57.3 128 128 128h72 8v-.3c35.2-2.7 65.4-22.8 82.1-51.7c8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20c-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20c8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5L194.9 124.6l81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4L133.6 92.3l23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2V256c0-70.7-57.3-128-128-128H440h-8v.3c-35.2 2.7-65.4 22.8-82.1 51.7c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"
    ]
};
var $1113a0aa61ab7765$export$23a7517099ab1b86 = $1113a0aa61ab7765$export$bc43eb4655c78f49;
var $1113a0aa61ab7765$export$beb51abfb05a4eca = $1113a0aa61ab7765$export$bc43eb4655c78f49;
var $1113a0aa61ab7765$export$82846008645b0301 = $1113a0aa61ab7765$export$bc43eb4655c78f49;
var $1113a0aa61ab7765$export$ec05accb7226d001 = {
    prefix: 'fas',
    iconName: 'gear',
    icon: [
        512,
        512,
        [
            9881,
            "cog"
        ],
        "f013",
        "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80z"
    ]
};
var $1113a0aa61ab7765$export$d6298bbfd1912a78 = $1113a0aa61ab7765$export$ec05accb7226d001;
var $1113a0aa61ab7765$export$1d6c5a49025d720b = {
    prefix: 'fas',
    iconName: 'droplet-slash',
    icon: [
        640,
        512,
        [
            "tint-slash"
        ],
        "f5c7",
        "M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM505.2 370.7c4.4-16.1 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L505.2 370.7zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$5d6f0943039b898f = $1113a0aa61ab7765$export$1d6c5a49025d720b;
var $1113a0aa61ab7765$export$4999586d7e1087fb = {
    prefix: 'fas',
    iconName: 'mosque',
    icon: [
        640,
        512,
        [
            128332
        ],
        "f678",
        "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5l0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6l0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zM288 512V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H560V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H448V454c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58H288zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160H160V296.6c-19.1 11.1-32 31.7-32 55.4V480c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V176 160z"
    ]
};
var $1113a0aa61ab7765$export$67c7a1518d0715ff = {
    prefix: 'fas',
    iconName: 'mosquito',
    icon: [
        640,
        512,
        [],
        "e52b",
        "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3l0-.3L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.1l38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2L402.2 140 352 190.3l0-38.2c0-14.9-10.2-27.4-24-31l0-57.2c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.2c-13.8 3.6-24 16.1-24 31l0 38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1l38.2 50.9-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266l0 .3-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.7l0 63.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.1 24.3 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"
    ]
};
var $1113a0aa61ab7765$export$f823fee3712b2601 = {
    prefix: 'fas',
    iconName: 'star-of-david',
    icon: [
        512,
        512,
        [
            10017
        ],
        "f69a",
        "M404.2 309.5L383.1 344h42.3l-21.1-34.5zM371.4 256l-54-88H194.6l-54 88 54 88H317.4l54-88zm65.7 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88l21.1 34.5L425.4 168H383.1zM283 112L256 68l-27 44h54zM128.9 168H86.6l21.1 34.5L128.9 168zM107.8 309.5L86.6 344h42.3l-21.1-34.5zM229 400l27 44 27-44H229z"
    ]
};
var $1113a0aa61ab7765$export$842b988dae95ccb8 = {
    prefix: 'fas',
    iconName: 'person-military-rifle',
    icon: [
        512,
        512,
        [],
        "e54b",
        "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4V48c0 8.8-7.2 16-16 16H185c-13.8 0-25-11.2-25-25zm17.6 57H334.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L352 369.7V480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9h50.4c15.9 0 31.3 2.8 45.8 7.9L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512H192c-17.7 0-32-14.3-32-32V369.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zM296 320c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $1113a0aa61ab7765$export$c790b41dc166ae13 = {
    prefix: 'fas',
    iconName: 'cart-shopping',
    icon: [
        576,
        512,
        [
            128722,
            "shopping-cart"
        ],
        "f07a",
        "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $1113a0aa61ab7765$export$51da406e5aa1388c = $1113a0aa61ab7765$export$c790b41dc166ae13;
var $1113a0aa61ab7765$export$507e8edd7676b2e9 = {
    prefix: 'fas',
    iconName: 'vials',
    icon: [
        512,
        512,
        [],
        "f493",
        "M0 64C0 46.3 14.3 32 32 32H88h48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96C14.3 96 0 81.7 0 64zM136 96H88V256h48V96zM288 64c0-17.7 14.3-32 32-32h56 48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32zM424 96H376V256h48V96z"
    ]
};
var $1113a0aa61ab7765$export$f193138a7d21971c = {
    prefix: 'fas',
    iconName: 'plug-circle-plus',
    icon: [
        576,
        512,
        [],
        "e55f",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$c5a9302c8c13c79a = {
    prefix: 'fas',
    iconName: 'place-of-worship',
    icon: [
        640,
        512,
        [],
        "f67f",
        "M224 109.3V217.6L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V283.2c0-16.9-8.8-32.5-23.3-41.2L416 217.6V109.3c0-8.5-3.4-16.6-9.4-22.6L331.3 11.3c-6.2-6.2-16.4-6.2-22.6 0L233.4 86.6c-6 6-9.4 14.1-9.4 22.6zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
    ]
};
var $1113a0aa61ab7765$export$cacbd95c283996ec = {
    prefix: 'fas',
    iconName: 'grip-vertical',
    icon: [
        320,
        512,
        [],
        "f58e",
        "M40 352c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm192 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zM40 320l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM232 192c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zM40 160l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 48c0 22.1 17.9 40 40 40zM232 32c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0z"
    ]
};
var $1113a0aa61ab7765$export$2d3ccb9b2099f3fe = {
    prefix: 'fas',
    iconName: 'arrow-turn-up',
    icon: [
        384,
        512,
        [
            "level-up"
        ],
        "f148",
        "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"
    ]
};
var $1113a0aa61ab7765$export$c227d3ba1de97ceb = $1113a0aa61ab7765$export$2d3ccb9b2099f3fe;
var $1113a0aa61ab7765$export$4f39e8dbaf09ea8b = {
    prefix: 'fas',
    iconName: 'u',
    icon: [
        384,
        512,
        [
            117
        ],
        "55",
        "M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$60b44cfa7af18422 = {
    prefix: 'fas',
    iconName: 'square-root-variable',
    icon: [
        576,
        512,
        [
            "square-root-alt"
        ],
        "f698",
        "M289 24.2C292.5 10 305.3 0 320 0H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H345L239 487.8c-3.2 13-14.2 22.6-27.6 24s-26.1-5.5-32.1-17.5L76.2 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c12.1 0 23.2 6.8 28.6 17.7l73.3 146.6L289 24.2zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $1113a0aa61ab7765$export$28e4b96627e00057 = $1113a0aa61ab7765$export$60b44cfa7af18422;
var $1113a0aa61ab7765$export$95b9968e7fceb821 = {
    prefix: 'fas',
    iconName: 'clock',
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $1113a0aa61ab7765$export$9a575facf1cab48f = $1113a0aa61ab7765$export$95b9968e7fceb821;
var $1113a0aa61ab7765$export$5d2b6a700940df16 = {
    prefix: 'fas',
    iconName: 'backward-step',
    icon: [
        320,
        512,
        [
            "step-backward"
        ],
        "f048",
        "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"
    ]
};
var $1113a0aa61ab7765$export$2884e379aed297d4 = $1113a0aa61ab7765$export$5d2b6a700940df16;
var $1113a0aa61ab7765$export$d7ff2047dbc34562 = {
    prefix: 'fas',
    iconName: 'pallet',
    icon: [
        640,
        512,
        [],
        "f482",
        "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 64H288v64H128V384zm224 0H512v64H352V384z"
    ]
};
var $1113a0aa61ab7765$export$a0856b225f3b0614 = {
    prefix: 'fas',
    iconName: 'faucet',
    icon: [
        512,
        512,
        [],
        "e005",
        "M192 96v12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H132.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160H320l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256V180.2l-32-4-32 4V224H173.3c-8.5 0-16.6 3.4-22.6 9.4L128 256H32z"
    ]
};
var $1113a0aa61ab7765$export$59669f486ab41d86 = {
    prefix: 'fas',
    iconName: 'baseball-bat-ball',
    icon: [
        640,
        512,
        [],
        "f432",
        "M550.3 0c-10.9 0-21.4 3.4-30.2 9.8L279.7 184.6c-13.9 10.1-26.8 21.4-38.7 33.8L138.7 325.3c-9.2 9.6-19.3 18.4-30.1 26.3L79.3 372.9c1.3 1.5 2.6 3 3.9 4.7l48 64c1.6 2.2 3.1 4.4 4.4 6.6l27.3-19.9c11.6-8.4 24-15.8 37-21.8l135.3-63.1c16.7-7.8 32.7-17.2 47.6-28.1L619 143.6c13.2-9.6 21-24.9 21-41.2c0-11-3.6-21.8-10.2-30.6L609.6 44.8 591.4 20.6C581.7 7.6 566.5 0 550.3 0zM496 512c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zM57.6 396.8c-10.6-14.1-30.7-17-44.8-6.4s-17 30.7-6.4 44.8l48 64c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-48-64z"
    ]
};
var $1113a0aa61ab7765$export$cb39585371b75720 = {
    prefix: 'fas',
    iconName: 's',
    icon: [
        384,
        512,
        [
            115
        ],
        "53",
        "M131.1 105.4c-20.1 8.6-30.8 21.8-33.9 39.4c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3c-16.8-5.6-25.8-23.7-20.3-40.5s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5-31.5-5.5c7.3-42.5 35.3-71.7 71.8-87.3c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.1 22.7c-11.2-3-48.2-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"
    ]
};
var $1113a0aa61ab7765$export$5e239d90ef904a84 = {
    prefix: 'fas',
    iconName: 'timeline',
    icon: [
        640,
        512,
        [],
        "e29c",
        "M128 120c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm32 49.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288v54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V169.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160V169.3zM536 96c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zM320 440c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $1113a0aa61ab7765$export$fb61df5d98785fa8 = {
    prefix: 'fas',
    iconName: 'keyboard',
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336zM272 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM368 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240zM464 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$f9395ef707603e40 = {
    prefix: 'fas',
    iconName: 'caret-down',
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
    ]
};
var $1113a0aa61ab7765$export$9c73560282dceccd = {
    prefix: 'fas',
    iconName: 'house-chimney-medical',
    icon: [
        576,
        512,
        [
            "clinic-medical"
        ],
        "f7f2",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H320V208c0-8.8-7.2-16-16-16H272z"
    ]
};
var $1113a0aa61ab7765$export$20d8a680febc7434 = $1113a0aa61ab7765$export$9c73560282dceccd;
var $1113a0aa61ab7765$export$7ed2bad15ae6237f = {
    prefix: 'fas',
    iconName: 'temperature-three-quarters',
    icon: [
        320,
        512,
        [
            "temperature-3",
            "thermometer-3",
            "thermometer-three-quarters"
        ],
        "f2c8",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V152c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $1113a0aa61ab7765$export$89def3268ed9b4bc = $1113a0aa61ab7765$export$7ed2bad15ae6237f;
var $1113a0aa61ab7765$export$2f653125f4e6463 = $1113a0aa61ab7765$export$7ed2bad15ae6237f;
var $1113a0aa61ab7765$export$6c632d1dc30d4a77 = $1113a0aa61ab7765$export$7ed2bad15ae6237f;
var $1113a0aa61ab7765$export$8867e7da34bb8bf4 = {
    prefix: 'fas',
    iconName: 'mobile-screen',
    icon: [
        384,
        512,
        [
            "mobile-android-alt"
        ],
        "f3cf",
        "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"
    ]
};
var $1113a0aa61ab7765$export$cb39d7b468ba5838 = $1113a0aa61ab7765$export$8867e7da34bb8bf4;
var $1113a0aa61ab7765$export$a5f2976a01fdc970 = {
    prefix: 'fas',
    iconName: 'plane-up',
    icon: [
        512,
        512,
        [],
        "e22d",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L497.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400V320L21.1 377C10.7 380.4 0 372.7 0 361.8V305.1c0-10.7 5.3-20.7 14.2-26.6L192 160V93.7z"
    ]
};
var $1113a0aa61ab7765$export$46d49a6734c4872a = {
    prefix: 'fas',
    iconName: 'piggy-bank',
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7H256c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96h32l-18.8 75.1c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H512c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H256v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24H68c-11 0-20 9-20 20s9 20 20 20H99.2c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2H384zm64 136c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $1113a0aa61ab7765$export$e6dadc1155c4ee48 = {
    prefix: 'fas',
    iconName: 'battery-half',
    icon: [
        576,
        512,
        [
            "battery-3"
        ],
        "f242",
        "M0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176zm80-16c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zm208 32V320H96V192H288z"
    ]
};
var $1113a0aa61ab7765$export$f9138caac2aedaed = $1113a0aa61ab7765$export$e6dadc1155c4ee48;
var $1113a0aa61ab7765$export$28f06bbf9c17c3af = {
    prefix: 'fas',
    iconName: 'mountain-city',
    icon: [
        640,
        512,
        [],
        "e52e",
        "M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zM224 188.9L283.8 288H223l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"
    ]
};
var $1113a0aa61ab7765$export$bc5da164799a0e = {
    prefix: 'fas',
    iconName: 'coins',
    icon: [
        512,
        512,
        [],
        "f51e",
        "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2l0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4V304v5.7V336zm32 0V304 278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
    ]
};
var $1113a0aa61ab7765$export$8d41d1f1ba3f9217 = {
    prefix: 'fas',
    iconName: 'khanda',
    icon: [
        576,
        512,
        [
            9772
        ],
        "f66d",
        "M277.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l0 0 0 0 0 0 0 0-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C376.9 97.4 400 134 400 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1 0 0 0 0c3.6 6.7 2 15-3.8 19.9L304 343.5v19.8l35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L433.1 80c7.2-14.3 7.2-14.3 7.2-14.3l0 0 0 0 .1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1 0 0 0 0s0 0-10.2-12.3l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L304 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V424.1l-40.3 27.7C229.8 463.3 219.9 472 208 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L144 400c-10.2 12.3-10.2 12.3-10.3 12.3l0 0 0 0-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C58.4 324.5 32 277.1 32 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29c4.8-3.2 8.9-5.7 11.8-7.3c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0 0 0 0 0s0 0 7.2 14.3l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C137.2 119 128 149.5 128 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2L272 362.6V343.5l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l0 0 0 0 0 0 .1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C199.1 254.6 176 218 176 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1 0 0 0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM252.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C259 210.2 264 190.9 264 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C317 141.8 312 161.1 312 176s5 34.2 11.8 53.1z"
    ]
};
var $1113a0aa61ab7765$export$ea6970ed5a15feb6 = {
    prefix: 'fas',
    iconName: 'sliders',
    icon: [
        512,
        512,
        [
            "sliders-h"
        ],
        "f1de",
        "M0 416c0-17.7 14.3-32 32-32l54.7 0c12.3-28.3 40.5-48 73.3-48s61 19.7 73.3 48L480 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-246.7 0c-12.3 28.3-40.5 48-73.3 48s-61-19.7-73.3-48L32 448c-17.7 0-32-14.3-32-32zm192 0c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM384 256c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm-32-80c32.8 0 61 19.7 73.3 48l54.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-54.7 0c-12.3 28.3-40.5 48-73.3 48s-61-19.7-73.3-48L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l246.7 0c12.3-28.3 40.5-48 73.3-48zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zm73.3 0L480 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-214.7 0c-12.3 28.3-40.5 48-73.3 48s-61-19.7-73.3-48L32 128C14.3 128 0 113.7 0 96S14.3 64 32 64l86.7 0C131 35.7 159.2 16 192 16s61 19.7 73.3 48z"
    ]
};
var $1113a0aa61ab7765$export$94d4dcb523f95563 = $1113a0aa61ab7765$export$ea6970ed5a15feb6;
var $1113a0aa61ab7765$export$54d16fa2e445d3fe = {
    prefix: 'fas',
    iconName: 'folder-tree',
    icon: [
        576,
        512,
        [],
        "f802",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96V384c0 35.3 28.7 64 64 64H256V384H64V160H256V96H64V32zM288 192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V192zm0 288c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V480z"
    ]
};
var $1113a0aa61ab7765$export$882cabd11f4943b8 = {
    prefix: 'fas',
    iconName: 'network-wired',
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M256 64H384v64H256V64zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v32H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H192V288H448v32H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V192h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM96 448V384H224v64H96zm320-64H544v64H416V384z"
    ]
};
var $1113a0aa61ab7765$export$184725965b3402dc = {
    prefix: 'fas',
    iconName: 'map-pin',
    icon: [
        320,
        512,
        [
            128205
        ],
        "f276",
        "M320 144c0 79.5-64.5 144-144 144S32 223.5 32 144S96.5 0 176 0s144 64.5 144 144zM176 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM144 480V317.1c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $1113a0aa61ab7765$export$38d20d399463edf9 = {
    prefix: 'fas',
    iconName: 'hamsa',
    icon: [
        512,
        512,
        [],
        "f665",
        "M34.6 288H80c8.8 0 16-7.2 16-16V72c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V40c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V72c0-22.1 17.9-40 40-40s40 17.9 40 40V272c0 8.8 7.2 16 16 16h45.4c19.1 0 34.6 15.5 34.6 34.6c0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zM256 288c-38.4 0-76.8 35.8-90.6 50.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 96c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$875b6c94a4b00ea8 = {
    prefix: 'fas',
    iconName: 'cent-sign',
    icon: [
        384,
        512,
        [],
        "e3f5",
        "M224 0c17.7 0 32 14.3 32 32V66.7c30.9 5.2 59.2 17.7 83.2 35.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3V32c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$f9b579ba06048af = {
    prefix: 'fas',
    iconName: 'flask',
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM192 196.8V64h64V196.8c0 23.7 6.6 46.9 19 67.1L309.5 320h-171L173 263.9c12.4-20.2 19-43.4 19-67.1z"
    ]
};
var $1113a0aa61ab7765$export$e7b4c26b5857fe9c = {
    prefix: 'fas',
    iconName: 'person-pregnant',
    icon: [
        384,
        512,
        [],
        "e31e",
        "M192 96c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zM120 383c-13.8-3.6-24-16.1-24-31V296.9l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1h1.1 12.5H192c1.4 0 2.8 .1 4.1 .3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 264v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384h-8-8v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V383z"
    ]
};
var $1113a0aa61ab7765$export$76cc39f249b6864e = {
    prefix: 'fas',
    iconName: 'wand-sparkles',
    icon: [
        512,
        512,
        [],
        "f72b",
        "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7V176c0 8.8-7.2 16-16 16H384.2c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9V272c0-8.8 7.2-16 16-16h34.6c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM224 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"
    ]
};
var $1113a0aa61ab7765$export$7480721bf113be3e = {
    prefix: 'fas',
    iconName: 'ellipsis-vertical',
    icon: [
        128,
        512,
        [
            "ellipsis-v"
        ],
        "f142",
        "M64 360c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zm0-160c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zM120 96c0 30.9-25.1 56-56 56S8 126.9 8 96S33.1 40 64 40s56 25.1 56 56z"
    ]
};
var $1113a0aa61ab7765$export$e58494c7fcb5380 = $1113a0aa61ab7765$export$7480721bf113be3e;
var $1113a0aa61ab7765$export$3604f15924cf0b98 = {
    prefix: 'fas',
    iconName: 'ticket',
    icon: [
        576,
        512,
        [
            127903
        ],
        "f145",
        "M64 64C28.7 64 0 92.7 0 128v80c26.5 0 48 21.5 48 48s-21.5 48-48 48v80c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V304c-26.5 0-48-21.5-48-48s21.5-48 48-48V128c0-35.3-28.7-64-64-64H64zm64 96l0 192H448V160H128zm-32 0c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z"
    ]
};
var $1113a0aa61ab7765$export$a1cca9928dcf9798 = {
    prefix: 'fas',
    iconName: 'power-off',
    icon: [
        512,
        512,
        [
            9211
        ],
        "f011",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"
    ]
};
var $1113a0aa61ab7765$export$b356b1dbe7d7f736 = {
    prefix: 'fas',
    iconName: 'right-long',
    icon: [
        512,
        512,
        [
            "long-arrow-alt-right"
        ],
        "f30b",
        "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 88L32 208c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l288 0 0 88c0 9.6 5.7 18.2 14.5 22z"
    ]
};
var $1113a0aa61ab7765$export$533e1f578f74c066 = $1113a0aa61ab7765$export$b356b1dbe7d7f736;
var $1113a0aa61ab7765$export$19357abad396e723 = {
    prefix: 'fas',
    iconName: 'flag-usa',
    icon: [
        448,
        512,
        [],
        "f74d",
        "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1v36.1l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9v32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3v33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.4-23.7-122.5-13.4L64 400v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V416 345.5 312.8 249.5 216.8 153.5 120.8 64 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $1113a0aa61ab7765$export$e1046cf83da9b7ef = {
    prefix: 'fas',
    iconName: 'laptop-file',
    icon: [
        640,
        512,
        [],
        "e51d",
        "M192 0H48C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H162.7c6.6-18.6 24.4-32 45.3-32V272c0-44.2 35.8-80 80-80h32V128H224c-17.7 0-32-14.3-32-32V0zm96 224c-26.5 0-48 21.5-48 48v16 96 32H208c-8.8 0-16 7.2-16 16v16c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V432c0-8.8-7.2-16-16-16H592V288c0-35.3-28.7-64-64-64H320 304 288zm32 64H528V416H304V288h16zM224 0V96h96L224 0z"
    ]
};
var $1113a0aa61ab7765$export$7c85aba0f9624b29 = {
    prefix: 'fas',
    iconName: 'tty',
    icon: [
        512,
        512,
        [
            "teletype"
        ],
        "f1e4",
        "M472.7 188.8c-8.5 13.8-26.8 19.6-42.7 13.6L356 174.2c-14-5.3-22.5-18.5-21-32.4l4.6-42.6c-54.1-17.4-113.2-17.4-167.3 0l4.6 42.6c1.5 13.9-7 27.1-21 32.4L82 202.4c-15.9 6.1-34.2 .3-42.7-13.6L4.5 132.5c-7.7-12.4-5.4-28 5.5-38.1c135.9-125.8 356.1-125.8 492 0c10.9 10.1 13.2 25.7 5.5 38.1l-34.8 56.4zM32 272c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V272zm0 192c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V464zM96 352h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V272zm64 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272zm64 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16V368zM336 256h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V272zm16 176h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V464c0-8.8 7.2-16 16-16zM128 464c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V464z"
    ]
};
var $1113a0aa61ab7765$export$14bcd5c43dc736f9 = $1113a0aa61ab7765$export$7c85aba0f9624b29;
var $1113a0aa61ab7765$export$2faddf1690e14e11 = {
    prefix: 'fas',
    iconName: 'diagram-next',
    icon: [
        512,
        512,
        [],
        "e476",
        "M512 160c0 35.3-28.7 64-64 64H280v64h46.1c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41H232V224H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64zM448 416V352H365.3l.4-.4c18.4-18.4 20.4-43.7 11-63.6l71.3 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l71.3 0c-9.4 19.9-7.4 45.2 11 63.6l.4 .4H64v64H210.7l5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7H448z"
    ]
};
var $1113a0aa61ab7765$export$b16df914812cedbe = {
    prefix: 'fas',
    iconName: 'person-rifle',
    icon: [
        576,
        512,
        [],
        "e54e",
        "M265.2 192c25.4 0 49.8 7.1 70.8 19.9V512H144V337.7L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8h50.4zM320 80c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80zM448 0c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7V269.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H484l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16V400H400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V160c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 16z"
    ]
};
var $1113a0aa61ab7765$export$bc50edea6e121df5 = {
    prefix: 'fas',
    iconName: 'house-medical-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e512",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm0-48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $1113a0aa61ab7765$export$8e047801a8603af7 = {
    prefix: 'fas',
    iconName: 'closed-captioning',
    icon: [
        576,
        512,
        [],
        "f20a",
        "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
    ]
};
var $1113a0aa61ab7765$export$baf9f153991b2ea = {
    prefix: 'fas',
    iconName: 'person-hiking',
    icon: [
        384,
        512,
        [
            "hiking"
        ],
        "f6ec",
        "M288 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM243.3 230.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208H336V184c0-13.3 10.7-24 24-24s24 10.7 24 24v55.8c0 .1 0 .2 0 .2s0 .2 0 .2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H296.6c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8z"
    ]
};
var $1113a0aa61ab7765$export$b2ab0105a901499e = $1113a0aa61ab7765$export$baf9f153991b2ea;
var $1113a0aa61ab7765$export$6a6f9cba7a1e5fe4 = {
    prefix: 'fas',
    iconName: 'venus-double',
    icon: [
        640,
        512,
        [
            9890
        ],
        "f226",
        "M192 288c61.9 0 112-50.1 112-112s-50.1-112-112-112S80 114.1 80 176s50.1 112 112 112zM368 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1c-26.6-4.9-51.1-15.7-72-31.1z"
    ]
};
var $1113a0aa61ab7765$export$74f06b41ed2ca28a = {
    prefix: 'fas',
    iconName: 'images',
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H328 280 200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM256 128c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
    ]
};
var $1113a0aa61ab7765$export$693bd40950ed2c3a = {
    prefix: 'fas',
    iconName: 'calculator',
    icon: [
        384,
        512,
        [
            128425
        ],
        "f1ec",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM64 224c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32zM160 320c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zM288 192c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32zM256 320c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$dace56f632fecf6f = {
    prefix: 'fas',
    iconName: 'people-pulling',
    icon: [
        576,
        512,
        [],
        "e535",
        "M80 96c26.5 0 48-21.5 48-48s-21.5-48-48-48S32 21.5 32 48s21.5 48 48 48zM64 128c-35.3 0-64 28.7-64 64V320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7c8.6 3.6 18 3.1 25.9-.7c3.4-1.6 6.6-3.9 9.3-6.7c3.1-3.2 5.5-7 7.1-11.4c.1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128H64zM464 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"
    ]
};
var $1113a0aa61ab7765$export$328a9baf0f9e3405 = {
    prefix: 'fas',
    iconName: 'n',
    icon: [
        384,
        512,
        [
            110
        ],
        "4e",
        "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 50.5 8.4 38.5 21.1 33.9z"
    ]
};
var $1113a0aa61ab7765$export$85cb04eaefaf2d8b = {
    prefix: 'fas',
    iconName: 'cable-car',
    icon: [
        512,
        512,
        [
            128673,
            57551,
            "tram"
        ],
        "f7da",
        "M288 64c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm-64-8c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM32 288c0-35.3 28.7-64 64-64H232V157.5l-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4L280 147.5V224H416c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H96zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H352z"
    ]
};
var $1113a0aa61ab7765$export$a7a36674c079f293 = $1113a0aa61ab7765$export$85cb04eaefaf2d8b;
var $1113a0aa61ab7765$export$a6c308ee087b4ded = {
    prefix: 'fas',
    iconName: 'cloud-rain',
    icon: [
        512,
        512,
        [
            127783,
            9926
        ],
        "f73d",
        "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L249.2 372zm124.9 64.6L409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3z"
    ]
};
var $1113a0aa61ab7765$export$c4c015418a1f24df = {
    prefix: 'fas',
    iconName: 'building-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e4d4",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $1113a0aa61ab7765$export$6c645741140616af = {
    prefix: 'fas',
    iconName: 'ship',
    icon: [
        576,
        512,
        [
            128674
        ],
        "f21a",
        "M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $1113a0aa61ab7765$export$8f2463c7b2fc6ae4 = {
    prefix: 'fas',
    iconName: 'arrows-down-to-line',
    icon: [
        640,
        512,
        [],
        "e4b8",
        "M576 416L64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L512 274.7 512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L192 274.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7L86.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var $1113a0aa61ab7765$export$8f734e51d72ca13a = {
    prefix: 'fas',
    iconName: 'download',
    icon: [
        512,
        512,
        [],
        "f019",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zM432 456c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $1113a0aa61ab7765$export$92292137ef3cf4c8 = {
    prefix: 'fas',
    iconName: 'face-grin',
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208.4 208c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$37e1f10b6de76621 = $1113a0aa61ab7765$export$92292137ef3cf4c8;
var $1113a0aa61ab7765$export$bbcc9e0b6022772b = {
    prefix: 'fas',
    iconName: 'delete-left',
    icon: [
        576,
        512,
        [
            9003,
            "backspace"
        ],
        "f55a",
        "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $1113a0aa61ab7765$export$e43e3f67102fc526 = $1113a0aa61ab7765$export$bbcc9e0b6022772b;
var $1113a0aa61ab7765$export$1bc3e0ad56dc9eb0 = {
    prefix: 'fas',
    iconName: 'eye-dropper',
    icon: [
        512,
        512,
        [
            "eye-dropper-empty",
            "eyedropper"
        ],
        "f1fb",
        "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"
    ]
};
var $1113a0aa61ab7765$export$ef304e9b7524c1f9 = $1113a0aa61ab7765$export$1bc3e0ad56dc9eb0;
var $1113a0aa61ab7765$export$91549a375c0b6d25 = $1113a0aa61ab7765$export$1bc3e0ad56dc9eb0;
var $1113a0aa61ab7765$export$8547e9f3a2ddab5b = {
    prefix: 'fas',
    iconName: 'file-circle-check',
    icon: [
        576,
        512,
        [],
        "e5a0",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM576 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-76.7-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $1113a0aa61ab7765$export$a8710cdb23198d53 = {
    prefix: 'fas',
    iconName: 'forward',
    icon: [
        512,
        512,
        [
            9193
        ],
        "f04e",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3V256v41.7L52.5 440.6zM256 352V256 128 96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V352z"
    ]
};
var $1113a0aa61ab7765$export$59edacfad04cd121 = {
    prefix: 'fas',
    iconName: 'mobile',
    icon: [
        384,
        512,
        [
            128241,
            "mobile-android",
            "mobile-phone"
        ],
        "f3ce",
        "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$82f602311a698c32 = $1113a0aa61ab7765$export$59edacfad04cd121;
var $1113a0aa61ab7765$export$475a9be8da747e57 = $1113a0aa61ab7765$export$59edacfad04cd121;
var $1113a0aa61ab7765$export$dc130582748497c6 = {
    prefix: 'fas',
    iconName: 'face-meh',
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM176.4 240c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$6d2db489aaeeecd2 = $1113a0aa61ab7765$export$dc130582748497c6;
var $1113a0aa61ab7765$export$70e29dd05344623e = {
    prefix: 'fas',
    iconName: 'align-center',
    icon: [
        448,
        512,
        [],
        "f037",
        "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$a57d448e8969ce8a = {
    prefix: 'fas',
    iconName: 'book-skull',
    icon: [
        448,
        512,
        [
            "book-dead"
        ],
        "f6b7",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2V176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V163.2c19.4-11.7 32-30.3 32-51.2zM208 128c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm80-16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zM134.3 209.3c-8.1-3.5-17.5 .3-21 8.4s.3 17.5 8.4 21L199.4 272l-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6 134.3 209.3z"
    ]
};
var $1113a0aa61ab7765$export$b98a3f8c3941a74a = $1113a0aa61ab7765$export$a57d448e8969ce8a;
var $1113a0aa61ab7765$export$782ac893fc22249b = {
    prefix: 'fas',
    iconName: 'id-card',
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 320c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM352 208c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"
    ]
};
var $1113a0aa61ab7765$export$8359c70e609eff64 = $1113a0aa61ab7765$export$782ac893fc22249b;
var $1113a0aa61ab7765$export$e21cfc4f23776bff = {
    prefix: 'fas',
    iconName: 'outdent',
    icon: [
        512,
        512,
        [
            "dedent"
        ],
        "f03b",
        "M32 64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 96 32 81.7 32 64zM224 192c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm32 96H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32zM32 448c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zm.2-179.4c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6V335.3c0 13.3-15.3 20.8-25.8 12.6L32.2 268.6z"
    ]
};
var $1113a0aa61ab7765$export$cbffb369d9299db7 = $1113a0aa61ab7765$export$e21cfc4f23776bff;
var $1113a0aa61ab7765$export$3772719b170306e2 = {
    prefix: 'fas',
    iconName: 'heart-circle-exclamation',
    icon: [
        576,
        512,
        [],
        "e4fe",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$dcadc0d67468dfa8 = {
    prefix: 'fas',
    iconName: 'house',
    icon: [
        576,
        512,
        [
            127968,
            63498,
            63500,
            "home",
            "home-alt",
            "home-lg-alt"
        ],
        "f015",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
    ]
};
var $1113a0aa61ab7765$export$48f10d71ec526479 = $1113a0aa61ab7765$export$dcadc0d67468dfa8;
var $1113a0aa61ab7765$export$279659c4b23dbedb = $1113a0aa61ab7765$export$dcadc0d67468dfa8;
var $1113a0aa61ab7765$export$20d6d52d45f53262 = $1113a0aa61ab7765$export$dcadc0d67468dfa8;
var $1113a0aa61ab7765$export$39be5cb4aed5a521 = {
    prefix: 'fas',
    iconName: 'calendar-week',
    icon: [
        448,
        512,
        [],
        "f784",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    ]
};
var $1113a0aa61ab7765$export$ba2fa38f7bcc6930 = {
    prefix: 'fas',
    iconName: 'laptop-medical',
    icon: [
        640,
        512,
        [],
        "f812",
        "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V272H240c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
    ]
};
var $1113a0aa61ab7765$export$fa30fcd1e0d0d8 = {
    prefix: 'fas',
    iconName: 'b',
    icon: [
        320,
        512,
        [
            98
        ],
        "42",
        "M32 32C14.3 32 0 46.3 0 64V256 448c0 17.7 14.3 32 32 32H192c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128H32zM160 224H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288h96 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64V288z"
    ]
};
var $1113a0aa61ab7765$export$56cbcd962389b090 = {
    prefix: 'fas',
    iconName: 'file-medical',
    icon: [
        384,
        512,
        [],
        "f477",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"
    ]
};
var $1113a0aa61ab7765$export$d91800b7be5303b0 = {
    prefix: 'fas',
    iconName: 'dice-one',
    icon: [
        448,
        512,
        [
            9856
        ],
        "f525",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 288c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$d9933d91e1314d02 = {
    prefix: 'fas',
    iconName: 'kiwi-bird',
    icon: [
        576,
        512,
        [],
        "f535",
        "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1s11.2-8.3 11.2-15.3V224c0-70.7-57.3-128-128-128H392.3c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V410c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24V405.1c12.4-4.4 24.2-10 35.2-16.7zM448 248c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $1113a0aa61ab7765$export$56b6d3d7d0e67a1c = {
    prefix: 'fas',
    iconName: 'arrow-right-arrow-left',
    icon: [
        448,
        512,
        [
            8644,
            "exchange"
        ],
        "f0ec",
        "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"
    ]
};
var $1113a0aa61ab7765$export$1aab915ca61b734a = $1113a0aa61ab7765$export$56b6d3d7d0e67a1c;
var $1113a0aa61ab7765$export$7f465bf410c6eff7 = {
    prefix: 'fas',
    iconName: 'rotate-right',
    icon: [
        512,
        512,
        [
            "redo-alt",
            "rotate-forward"
        ],
        "f2f9",
        "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"
    ]
};
var $1113a0aa61ab7765$export$50c037520c6cfdc1 = $1113a0aa61ab7765$export$7f465bf410c6eff7;
var $1113a0aa61ab7765$export$2507849a0fdd7f64 = $1113a0aa61ab7765$export$7f465bf410c6eff7;
var $1113a0aa61ab7765$export$750d52edc1dafc7 = {
    prefix: 'fas',
    iconName: 'utensils',
    icon: [
        448,
        512,
        [
            127860,
            61685,
            "cutlery"
        ],
        "f2e7",
        "M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"
    ]
};
var $1113a0aa61ab7765$export$7034e54a8036c5c8 = $1113a0aa61ab7765$export$750d52edc1dafc7;
var $1113a0aa61ab7765$export$63f4908401ded049 = {
    prefix: 'fas',
    iconName: 'arrow-up-wide-short',
    icon: [
        576,
        512,
        [
            "sort-amount-up"
        ],
        "f161",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$28ef3e933e4b5364 = $1113a0aa61ab7765$export$63f4908401ded049;
var $1113a0aa61ab7765$export$9b53510cf4010e4d = {
    prefix: 'fas',
    iconName: 'mill-sign',
    icon: [
        384,
        512,
        [],
        "e1ed",
        "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96C14.3 96 0 110.3 0 128v80V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-26.5 21.5-48 48-48s48 21.5 48 48v42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60C168.9 441 179.6 448 192 448c17.7 0 32-14.3 32-32V261.5l35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"
    ]
};
var $1113a0aa61ab7765$export$86079bc65a716451 = {
    prefix: 'fas',
    iconName: 'bowl-rice',
    icon: [
        512,
        512,
        [],
        "e2eb",
        "M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24zm24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176H72c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H104c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $1113a0aa61ab7765$export$138b45e2afb1dfa4 = {
    prefix: 'fas',
    iconName: 'skull',
    icon: [
        512,
        512,
        [
            128128
        ],
        "f54c",
        "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1v64c0 26.5 21.5 48 48 48h48V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48V400c0-.4 0-.7 0-1.1zM224 256c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm128 64c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z"
    ]
};
var $1113a0aa61ab7765$export$fd06ff4ce9799eb0 = {
    prefix: 'fas',
    iconName: 'tower-broadcast',
    icon: [
        576,
        512,
        [
            "broadcast-tower"
        ],
        "f519",
        "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"
    ]
};
var $1113a0aa61ab7765$export$f68b38d51f5c0ed = $1113a0aa61ab7765$export$fd06ff4ce9799eb0;
var $1113a0aa61ab7765$export$f846b848b3ba3064 = {
    prefix: 'fas',
    iconName: 'truck-pickup',
    icon: [
        640,
        512,
        [
            128763
        ],
        "f63c",
        "M368.6 96l76.8 96H288V96h80.6zM224 80V192H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32H65.1c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h66.3c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V224c0-17.7-14.3-32-32-32H527.4L418.6 56c-12.1-15.2-30.5-24-50-24H272c-26.5 0-48 21.5-48 48zM128 368c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48zm288 0c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48z"
    ]
};
var $1113a0aa61ab7765$export$5608156cc81126e7 = {
    prefix: 'fas',
    iconName: 'up-long',
    icon: [
        320,
        512,
        [
            "long-arrow-alt-up"
        ],
        "f30c",
        "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192h88l0 288c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32l0-288h88c9.6 0 18.2-5.7 22-14.5z"
    ]
};
var $1113a0aa61ab7765$export$43c8f2a46326c55f = $1113a0aa61ab7765$export$5608156cc81126e7;
var $1113a0aa61ab7765$export$51577929c676143b = {
    prefix: 'fas',
    iconName: 'stop',
    icon: [
        384,
        512,
        [
            9209
        ],
        "f04d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
    ]
};
var $1113a0aa61ab7765$export$e151fe5abf6db993 = {
    prefix: 'fas',
    iconName: 'code-merge',
    icon: [
        448,
        512,
        [],
        "f387",
        "M80 104c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm32.4 49.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 456c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zM392 272c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$a9578350255b2b79 = {
    prefix: 'fas',
    iconName: 'upload',
    icon: [
        512,
        512,
        [],
        "f093",
        "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $1113a0aa61ab7765$export$4cf54a379be7e59a = {
    prefix: 'fas',
    iconName: 'hurricane',
    icon: [
        384,
        512,
        [],
        "f751",
        "M0 208C0 104.4 75.7 18.5 174.9 2.6C184 1.2 192 8.6 192 17.9V81.2c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4c-9.2 1.5-17.1-5.9-17.1-15.2V430.2c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96zm-96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$ac54ffffdb218383 = {
    prefix: 'fas',
    iconName: 'mound',
    icon: [
        576,
        512,
        [],
        "e52d",
        "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z"
    ]
};
var $1113a0aa61ab7765$export$a3a5de5f6e2513ba = {
    prefix: 'fas',
    iconName: 'toilet-portable',
    icon: [
        320,
        512,
        [],
        "e583",
        "M0 32V64H320V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM24 96H0v24V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H272v8c0 13.3 10.7 24 24 24s24-10.7 24-24V120 96H296 24zM256 240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$84021631df0f831b = {
    prefix: 'fas',
    iconName: 'compact-disc',
    icon: [
        512,
        512,
        [
            128191,
            128192,
            128440
        ],
        "f51f",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM256 224c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32zm-96 32c0 53 43 96 96 96s96-43 96-96s-43-96-96-96s-96 43-96 96zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $1113a0aa61ab7765$export$148bcede94488555 = {
    prefix: 'fas',
    iconName: 'file-arrow-down',
    icon: [
        384,
        512,
        [
            "file-download"
        ],
        "f56d",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 232V334.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$1013b9966d758343 = $1113a0aa61ab7765$export$148bcede94488555;
var $1113a0aa61ab7765$export$afb5d0eee7c1bdb = {
    prefix: 'fas',
    iconName: 'caravan',
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M0 112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0H288c0 53-43 96-96 96s-96-43-96-96H80c-44.2 0-80-35.8-80-80V112zM320 352H448V256H416c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32V352zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zm96 336c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $1113a0aa61ab7765$export$1639f087457d4f58 = {
    prefix: 'fas',
    iconName: 'shield-cat',
    icon: [
        512,
        512,
        [],
        "e572",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4zM216 288c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm96-16c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $1113a0aa61ab7765$export$6869964aa308dd31 = {
    prefix: 'fas',
    iconName: 'bolt',
    icon: [
        448,
        512,
        [
            9889,
            "zap"
        ],
        "f0e7",
        "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"
    ]
};
var $1113a0aa61ab7765$export$d62abb82664f55ca = $1113a0aa61ab7765$export$6869964aa308dd31;
var $1113a0aa61ab7765$export$b80f542550a05ea7 = {
    prefix: 'fas',
    iconName: 'glass-water',
    icon: [
        448,
        512,
        [],
        "e4f4",
        "M64 0C55.1 0 46.6 3.7 40.6 10.2s-9.1 15.2-8.5 24.1L60.9 437.7c3 41.9 37.8 74.3 79.8 74.3H307.3c42 0 76.8-32.4 79.8-74.3L415.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S392.9 0 384 0H64zm41 156.5L98.4 64H349.6L343 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L105 156.5z"
    ]
};
var $1113a0aa61ab7765$export$b69c6757012a2267 = {
    prefix: 'fas',
    iconName: 'oil-well',
    icon: [
        576,
        512,
        [],
        "e532",
        "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L308.5 167.5l-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H406.7L340 257.5l-62.2 16.1L305.3 352H238.7L265 277l-74.6 19.3L137.3 448H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32H327.7l11.2 32H205.1z"
    ]
};
var $1113a0aa61ab7765$export$4689a147513594a7 = {
    prefix: 'fas',
    iconName: 'vault',
    icon: [
        576,
        512,
        [],
        "e2c5",
        "M64 0C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H80l16 32h64l16-32H400l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 320c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zm0 80c-88.4 0-160-71.6-160-160s71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160zM480 221.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"
    ]
};
var $1113a0aa61ab7765$export$a9f5c0b9c1e77a6f = {
    prefix: 'fas',
    iconName: 'mars',
    icon: [
        448,
        512,
        [
            9794
        ],
        "f222",
        "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416c61.9 0 112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112z"
    ]
};
var $1113a0aa61ab7765$export$505476859b9691c0 = {
    prefix: 'fas',
    iconName: 'toilet',
    icon: [
        448,
        512,
        [
            128701
        ],
        "f7d8",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V196.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H352c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8l0 .1 0 .3zM328.2 384l-.2 .5 0-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$94ef668f5108e431 = {
    prefix: 'fas',
    iconName: 'plane-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e557",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $1113a0aa61ab7765$export$30f1437f5a4e991d = {
    prefix: 'fas',
    iconName: 'yen-sign',
    icon: [
        320,
        512,
        [
            165,
            "cny",
            "jpy",
            "rmb",
            "yen"
        ],
        "f157",
        "M58.6 46.2C48.8 31.5 29 27.6 14.2 37.4S-4.4 67 5.4 81.7L100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V288h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H219.8L314.6 81.7c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z"
    ]
};
var $1113a0aa61ab7765$export$268a23eee8f089a2 = $1113a0aa61ab7765$export$30f1437f5a4e991d;
var $1113a0aa61ab7765$export$5460a9192eb79bf5 = $1113a0aa61ab7765$export$30f1437f5a4e991d;
var $1113a0aa61ab7765$export$e2a8016afc962883 = $1113a0aa61ab7765$export$30f1437f5a4e991d;
var $1113a0aa61ab7765$export$cf914b1afb9455a2 = $1113a0aa61ab7765$export$30f1437f5a4e991d;
var $1113a0aa61ab7765$export$1ae0a94c8ba4131a = {
    prefix: 'fas',
    iconName: 'ruble-sign',
    icon: [
        384,
        512,
        [
            8381,
            "rouble",
            "rub",
            "ruble"
        ],
        "f158",
        "M96 32C78.3 32 64 46.3 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H96zM240 256H128V96H240c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $1113a0aa61ab7765$export$c5dc3d98c4d8f2a5 = $1113a0aa61ab7765$export$1ae0a94c8ba4131a;
var $1113a0aa61ab7765$export$9c4d936240e1f0b1 = $1113a0aa61ab7765$export$1ae0a94c8ba4131a;
var $1113a0aa61ab7765$export$6c0cf65134387046 = $1113a0aa61ab7765$export$1ae0a94c8ba4131a;
var $1113a0aa61ab7765$export$2fa35dcbc038dbe9 = {
    prefix: 'fas',
    iconName: 'sun',
    icon: [
        512,
        512,
        [
            9728
        ],
        "f185",
        "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM352 256c0 53-43 96-96 96s-96-43-96-96s43-96 96-96s96 43 96 96zm32 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128z"
    ]
};
var $1113a0aa61ab7765$export$790dd5b32282b6fb = {
    prefix: 'fas',
    iconName: 'guitar',
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 352c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $1113a0aa61ab7765$export$600a1b26b33c3d47 = {
    prefix: 'fas',
    iconName: 'face-laugh-wink',
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM208.4 192c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm92.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
var $1113a0aa61ab7765$export$77ac40095f39933e = $1113a0aa61ab7765$export$600a1b26b33c3d47;
var $1113a0aa61ab7765$export$5bcca85203ebd1e8 = {
    prefix: 'fas',
    iconName: 'horse-head',
    icon: [
        512,
        512,
        [],
        "f7ab",
        "M0 464V316.9C0 208.5 68.3 111.8 170.5 75.6L340.2 15.5C361.6 7.9 384 23.8 384 46.4c0 11-5.5 21.2-14.6 27.3L336 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8H48c-26.5 0-48-21.5-48-48zM328 224c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $1113a0aa61ab7765$export$cd79eeea6201e9d4 = {
    prefix: 'fas',
    iconName: 'bore-hole',
    icon: [
        512,
        512,
        [],
        "e4c3",
        "M256 0c-17.7 0-32 14.3-32 32V296.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H352V352c0 53-43 96-96 96s-96-43-96-96V128H48z"
    ]
};
var $1113a0aa61ab7765$export$5548c3eb51060fa8 = {
    prefix: 'fas',
    iconName: 'industry',
    icon: [
        512,
        512,
        [],
        "f275",
        "M32 32C14.3 32 0 46.3 0 64V304v48 80c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V304 152.2c0-18.2-19.4-29.7-35.4-21.1L320 215.4V152.2c0-18.2-19.4-29.7-35.4-21.1L128 215.4V64c0-17.7-14.3-32-32-32H32z"
    ]
};
var $1113a0aa61ab7765$export$531badb89cf01312 = {
    prefix: 'fas',
    iconName: 'circle-down',
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM244.7 395.3l-112-112c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l64 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 64 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-112 112c-6.2 6.2-16.4 6.2-22.6 0z"
    ]
};
var $1113a0aa61ab7765$export$ff3afbc8c0bc5d59 = $1113a0aa61ab7765$export$531badb89cf01312;
var $1113a0aa61ab7765$export$b9d8fdf63999a76d = {
    prefix: 'fas',
    iconName: 'arrows-turn-to-dots',
    icon: [
        512,
        512,
        [],
        "e4c1",
        "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM512 384c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM64 64c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64S28.7 64 64 64z"
    ]
};
var $1113a0aa61ab7765$export$6248ec7440b2ffcb = {
    prefix: 'fas',
    iconName: 'florin-sign',
    icon: [
        384,
        512,
        [],
        "e184",
        "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H69.3c38.8 0 73.7-23.3 88.6-59.1L213.3 288H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H240l45.1-108.3c5-11.9 16.6-19.7 29.5-19.7H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H314.7z"
    ]
};
var $1113a0aa61ab7765$export$a51c464b699200ae = {
    prefix: 'fas',
    iconName: 'arrow-down-short-wide',
    icon: [
        576,
        512,
        [
            "sort-amount-desc",
            "sort-amount-down-alt"
        ],
        "f884",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$93835bc31892b5c3 = $1113a0aa61ab7765$export$a51c464b699200ae;
var $1113a0aa61ab7765$export$e7d80d8c226cb77 = $1113a0aa61ab7765$export$a51c464b699200ae;
var $1113a0aa61ab7765$export$7f24f1bf98af5411 = {
    prefix: 'fas',
    iconName: 'less-than',
    icon: [
        384,
        512,
        [
            62774
        ],
        "3c",
        "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"
    ]
};
var $1113a0aa61ab7765$export$4b5be0142d10f342 = {
    prefix: 'fas',
    iconName: 'angle-down',
    icon: [
        448,
        512,
        [
            8964
        ],
        "f107",
        "M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var $1113a0aa61ab7765$export$ec5cfe409de2ed37 = {
    prefix: 'fas',
    iconName: 'car-tunnel',
    icon: [
        512,
        512,
        [],
        "e4de",
        "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h64H384h64c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM384 512c-17.7 0-32-14.3-32-32V448H160v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7H313.6c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6V480c0 17.7-14.3 32-32 32zM190.8 277.5L177 320H335l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM168 408c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm200-24c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $1113a0aa61ab7765$export$3cd04b7c1624f598 = {
    prefix: 'fas',
    iconName: 'head-side-cough',
    icon: [
        640,
        512,
        [],
        "e061",
        "M0 201.7C0 90.3 90.3 0 201.7 0H224c95.2 0 174.2 69.3 189.4 160.1c2.2 13 6.7 25.7 15 36.1l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H416v32H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 35.3-28.7 64-64 64H288c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V375.8c0-17-7.1-33-17.5-46.4C18.3 293.2 0 246.5 0 201.7zM336 224c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm272 88c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm-40 24c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zm-64 48c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zm128 0c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zM608 504c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm-40-72c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$1412f35381064d7d = {
    prefix: 'fas',
    iconName: 'grip-lines',
    icon: [
        448,
        512,
        [],
        "f7a4",
        "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
    ]
};
var $1113a0aa61ab7765$export$aba24ca305bbe8c1 = {
    prefix: 'fas',
    iconName: 'thumbs-down',
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-25.3-19.5-46-44.3-47.9c7.7-8.5 12.3-19.8 12.3-32.1c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 320H96c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64V288c0 17.7 14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$d9b89b5872b67a4f = {
    prefix: 'fas',
    iconName: 'user-lock',
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H392.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7H178.3zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $1113a0aa61ab7765$export$becbc35d3541bcc = {
    prefix: 'fas',
    iconName: 'arrow-right-long',
    icon: [
        512,
        512,
        [
            "long-arrow-right"
        ],
        "f178",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $1113a0aa61ab7765$export$7ec6527cf8651899 = $1113a0aa61ab7765$export$becbc35d3541bcc;
var $1113a0aa61ab7765$export$f6773af4219eebd = {
    prefix: 'fas',
    iconName: 'anchor-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e4ac",
        "M256 96c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm85.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $1113a0aa61ab7765$export$37fe3659ba7b6b54 = {
    prefix: 'fas',
    iconName: 'ellipsis',
    icon: [
        448,
        512,
        [
            "ellipsis-h"
        ],
        "f141",
        "M120 256c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm160 0c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm104 56c-30.9 0-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56s-25.1 56-56 56z"
    ]
};
var $1113a0aa61ab7765$export$c9f2fedd4489a2ee = $1113a0aa61ab7765$export$37fe3659ba7b6b54;
var $1113a0aa61ab7765$export$3db75d5ac9e98468 = {
    prefix: 'fas',
    iconName: 'chess-pawn',
    icon: [
        320,
        512,
        [
            9823
        ],
        "f443",
        "M264 136c0 37.1-19.4 69.6-48.6 88H224c17.7 0 32 14.3 32 32s-14.3 32-32 32c0 96 24 128 24 128H72s24-32 24-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h8.5C75.4 205.6 56 173.1 56 136C56 78.6 102.6 32 160 32s104 46.6 104 104zM32 448H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$f04e7a0f1033a0cd = {
    prefix: 'fas',
    iconName: 'kit-medical',
    icon: [
        576,
        512,
        [
            "first-aid"
        ],
        "f479",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H96V32H64zm64 0V480H448V32H128zM512 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480V480h32zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V288H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"
    ]
};
var $1113a0aa61ab7765$export$5b01ccb2da4c4387 = $1113a0aa61ab7765$export$f04e7a0f1033a0cd;
var $1113a0aa61ab7765$export$a77a2f6da72f89e3 = {
    prefix: 'fas',
    iconName: 'person-through-window',
    icon: [
        640,
        512,
        [],
        "e5a9",
        "M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8s0 0 0 0H64V64zm288 0l224 0V384H508.3l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320H379.2l42.7 64H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V400c0 26.5 21.5 48 48 48H308.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48zm-159.5 0H192s0 0 0 0l0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
    ]
};
var $1113a0aa61ab7765$export$b34d64c205c732a9 = {
    prefix: 'fas',
    iconName: 'toolbox',
    icon: [
        512,
        512,
        [
            129520
        ],
        "f552",
        "M176 88v40H336V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V88c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56v40h28.1c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9V304H384V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H192V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H0V227.9c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1H128zM0 416V336H128v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H320v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H512v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z"
    ]
};
var $1113a0aa61ab7765$export$3aa81d0e606b08b6 = {
    prefix: 'fas',
    iconName: 'hands-holding-circle',
    icon: [
        640,
        512,
        [],
        "e4fb",
        "M320 256c-70.7 0-128-57.3-128-128S249.3 0 320 0s128 57.3 128 128s-57.3 128-128 128zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
    ]
};
var $1113a0aa61ab7765$export$a18cfac400116d9f = {
    prefix: 'fas',
    iconName: 'bug',
    icon: [
        512,
        512,
        [],
        "f188",
        "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96.3c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $1113a0aa61ab7765$export$3e7437bf6535bef0 = {
    prefix: 'fas',
    iconName: 'credit-card',
    icon: [
        576,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    ]
};
var $1113a0aa61ab7765$export$5fffe8e3c36964a2 = $1113a0aa61ab7765$export$3e7437bf6535bef0;
var $1113a0aa61ab7765$export$9eefe7fcdf123b76 = {
    prefix: 'fas',
    iconName: 'car',
    icon: [
        512,
        512,
        [
            128664,
            "automobile"
        ],
        "f1b9",
        "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm288 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$240a6c53cf7ac525 = $1113a0aa61ab7765$export$9eefe7fcdf123b76;
var $1113a0aa61ab7765$export$6638511b28df3be5 = {
    prefix: 'fas',
    iconName: 'hand-holding-hand',
    icon: [
        576,
        512,
        [],
        "e4f7",
        "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9L142.9 58.5C166.2 41.3 194.5 32 223.5 32H384 544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H507.2l-44.9 36c-22.7 18.2-50.9 28-80 28H304 288 224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160l0 0 .9 0c-.3 0-.6 0-.9 0zM568.2 304.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 453.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $1113a0aa61ab7765$export$cb6e40528b98a5b = {
    prefix: 'fas',
    iconName: 'book-open-reader',
    icon: [
        512,
        512,
        [
            "book-reader"
        ],
        "f5da",
        "M352 96c0 53-43 96-96 96s-96-43-96-96s43-96 96-96s96 43 96 96zM240 248V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"
    ]
};
var $1113a0aa61ab7765$export$cee14fe33262fa7d = $1113a0aa61ab7765$export$cb6e40528b98a5b;
var $1113a0aa61ab7765$export$af9eaee7db3ba7a9 = {
    prefix: 'fas',
    iconName: 'mountain-sun',
    icon: [
        640,
        512,
        [],
        "e52f",
        "M560 160c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zM55.9 512H381.1h75H578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z"
    ]
};
var $1113a0aa61ab7765$export$a63cecc8a4166c49 = {
    prefix: 'fas',
    iconName: 'arrows-left-right-to-line',
    icon: [
        640,
        512,
        [],
        "e4ba",
        "M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$b06003a02c9055bd = {
    prefix: 'fas',
    iconName: 'dice-d20',
    icon: [
        512,
        512,
        [],
        "f6cf",
        "M64.7 125.8l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L217.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L63.9 98.8c-9.6 6.6-9.2 20.9 .8 26.9zM32 171.7V295.3c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L56.2 158C45.6 151.6 32 159.3 32 171.7zM326.4 12.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L338.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1zM512 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4V171.7zm-49.3 246L302.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5c0-9.3-8.1-16.5-17.3-15.4zM249.2 512c3.7 0 6.8-3 6.8-6.8V452.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4zM57.7 382.9l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L46.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8L418.9 238.1c-6.5-10-21.4-9.6-27.3 .8L306.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H199.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zM190.4 176H353.6c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2h-3.2c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"
    ]
};
var $1113a0aa61ab7765$export$41ce20639e8fef2b = {
    prefix: 'fas',
    iconName: 'truck-droplet',
    icon: [
        640,
        512,
        [],
        "e58c",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm368-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM208 272c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"
    ]
};
var $1113a0aa61ab7765$export$e4686afbe882e24a = {
    prefix: 'fas',
    iconName: 'file-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e5a1",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 384c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm59.3-180.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $1113a0aa61ab7765$export$d7a5da41ce01461d = {
    prefix: 'fas',
    iconName: 'temperature-arrow-up',
    icon: [
        512,
        512,
        [
            "temperature-up"
        ],
        "e040",
        "M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.1 32 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.1 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM448 160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V160z"
    ]
};
var $1113a0aa61ab7765$export$872345a0157330a3 = $1113a0aa61ab7765$export$d7a5da41ce01461d;
var $1113a0aa61ab7765$export$b48a5be96314835a = {
    prefix: 'fas',
    iconName: 'medal',
    icon: [
        512,
        512,
        [
            127941
        ],
        "f5a2",
        "M16 0H144c5.3 0 10.3 2.7 13.3 7.1l81.1 121.6c-49.5 4.1-94 25.6-127.6 58.3L2.7 24.9C-.6 20-.9 13.7 1.9 8.5S10.1 0 16 0zM509.3 24.9L401.2 187.1c-33.5-32.7-78.1-54.2-127.6-58.3L354.7 7.1c3-4.5 8-7.1 13.3-7.1H496c5.9 0 11.3 3.2 14.1 8.5s2.5 11.5-.8 16.4zM432 336c0 97.2-78.8 176-176 176s-176-78.8-176-176s78.8-176 176-176s176 78.8 176 176zM264.4 241.1c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
    ]
};
var $1113a0aa61ab7765$export$f24e0fce77994d4d = {
    prefix: 'fas',
    iconName: 'bed',
    icon: [
        640,
        512,
        [
            128716
        ],
        "f236",
        "M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zM176 288c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $1113a0aa61ab7765$export$51e3c5be06a49e32 = {
    prefix: 'fas',
    iconName: 'square-h',
    icon: [
        448,
        512,
        [
            "h-square"
        ],
        "f0fd",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM336 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H288V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$f08bbcf8f59eafc2 = $1113a0aa61ab7765$export$51e3c5be06a49e32;
var $1113a0aa61ab7765$export$5c0b4709125e92f8 = {
    prefix: 'fas',
    iconName: 'podcast',
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8c0-35.1 31.1-43.8 64-43.8zm0-32c-30.9 0-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56s-25.1 56-56 56z"
    ]
};
var $1113a0aa61ab7765$export$bf4d97a79734997f = {
    prefix: 'fas',
    iconName: 'temperature-full',
    icon: [
        320,
        512,
        [
            "temperature-4",
            "thermometer-4",
            "thermometer-full"
        ],
        "f2c7",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $1113a0aa61ab7765$export$db946f8dc50a57ca = $1113a0aa61ab7765$export$bf4d97a79734997f;
var $1113a0aa61ab7765$export$92b2e2293472dd50 = $1113a0aa61ab7765$export$bf4d97a79734997f;
var $1113a0aa61ab7765$export$74e07083cef79a6f = $1113a0aa61ab7765$export$bf4d97a79734997f;
var $1113a0aa61ab7765$export$9b6162797ab1b255 = {
    prefix: 'fas',
    iconName: 'bell',
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
    ]
};
var $1113a0aa61ab7765$export$4fa56a54e822dd25 = {
    prefix: 'fas',
    iconName: 'superscript',
    icon: [
        512,
        512,
        [],
        "f12b",
        "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V32zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32z"
    ]
};
var $1113a0aa61ab7765$export$12ef959394d63192 = {
    prefix: 'fas',
    iconName: 'plug-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e560",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $1113a0aa61ab7765$export$aa3c4c1c5a47bf98 = {
    prefix: 'fas',
    iconName: 'star-of-life',
    icon: [
        512,
        512,
        [],
        "f621",
        "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32z"
    ]
};
var $1113a0aa61ab7765$export$4c60a3aade08b6c2 = {
    prefix: 'fas',
    iconName: 'phone-slash',
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M228.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 107.4 37.8 206 100.8 283.1L9.2 469.1c-10.4 8.2-12.3 23.3-4.1 33.7s23.3 12.3 33.7 4.1l592-464c10.4-8.2 12.3-23.3 4.1-33.7s-23.3-12.3-33.7-4.1L253 278c-17.8-21.5-32.9-45.2-45-70.7L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96zm96.8 319l-91.3 72C310.7 476 407.1 512 512 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368c-15-7.1-29.3-15.2-43-24.3z"
    ]
};
var $1113a0aa61ab7765$export$d1de8d1b815d6a5 = {
    prefix: 'fas',
    iconName: 'paint-roller',
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 352c0-17.7 14.3-32 32-32V304c0-44.2 35.8-80 80-80H416c17.7 0 32-14.3 32-32V160 69.5c37.3 13.2 64 48.7 64 90.5v32c0 53-43 96-96 96H272c-8.8 0-16 7.2-16 16v16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352z"
    ]
};
var $1113a0aa61ab7765$export$503f458ca5cf64c2 = {
    prefix: 'fas',
    iconName: 'handshake-angle',
    icon: [
        640,
        512,
        [
            "hands-helping"
        ],
        "f4c4",
        "M543.9 251.4c0-1.1 .1-2.2 .1-3.4c0-48.6-39.4-88-88-88l-40 0H320l-16 0 0 0v16 72c0 22.1-17.9 40-40 40s-40-17.9-40-40V128h.4c4-36 34.5-64 71.6-64H408c2.8 0 5.6 .2 8.3 .5l40.1-40.1c21.9-21.9 57.3-21.9 79.2 0l78.1 78.1c21.9 21.9 21.9 57.3 0 79.2l-69.7 69.7zM192 128V248c0 39.8 32.2 72 72 72s72-32.2 72-72V192h80l40 0c30.9 0 56 25.1 56 56c0 27.2-19.4 49.9-45.2 55c8.2 8.6 13.2 20.2 13.2 33c0 26.5-21.5 48-48 48h-2.7c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48H224c-.9 0-1.8 0-2.7-.1l-37.7 37.7c-21.9 21.9-57.3 21.9-79.2 0L26.3 407.6c-21.9-21.9-21.9-57.3 0-79.2L96 258.7V224c0-53 43-96 96-96z"
    ]
};
var $1113a0aa61ab7765$export$287dbb1632da0d44 = $1113a0aa61ab7765$export$503f458ca5cf64c2;
var $1113a0aa61ab7765$export$90a475e93ff4bb8a = {
    prefix: 'fas',
    iconName: 'location-dot',
    icon: [
        384,
        512,
        [
            "map-marker-alt"
        ],
        "f3c5",
        "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 256c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z"
    ]
};
var $1113a0aa61ab7765$export$4be92fa780613f93 = $1113a0aa61ab7765$export$90a475e93ff4bb8a;
var $1113a0aa61ab7765$export$cad54bead856a678 = {
    prefix: 'fas',
    iconName: 'file',
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"
    ]
};
var $1113a0aa61ab7765$export$da07b6bc24a496ca = {
    prefix: 'fas',
    iconName: 'greater-than',
    icon: [
        384,
        512,
        [
            62769
        ],
        "3e",
        "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"
    ]
};
var $1113a0aa61ab7765$export$3fb4da6af843d39f = {
    prefix: 'fas',
    iconName: 'person-swimming',
    icon: [
        576,
        512,
        [
            127946,
            "swimmer"
        ],
        "f5c4",
        "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-26.9 0-52.3 6.6-74.5 18.4zM32 160c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $1113a0aa61ab7765$export$67daf2e2f88c1365 = $1113a0aa61ab7765$export$3fb4da6af843d39f;
var $1113a0aa61ab7765$export$9686eff8d817f770 = {
    prefix: 'fas',
    iconName: 'arrow-down',
    icon: [
        384,
        512,
        [
            8595
        ],
        "f063",
        "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var $1113a0aa61ab7765$export$cc1b6e60cb98fb90 = {
    prefix: 'fas',
    iconName: 'droplet',
    icon: [
        384,
        512,
        [
            128167,
            "tint"
        ],
        "f043",
        "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"
    ]
};
var $1113a0aa61ab7765$export$60dd975bd5938c15 = $1113a0aa61ab7765$export$cc1b6e60cb98fb90;
var $1113a0aa61ab7765$export$e7fc4fe34e767f28 = {
    prefix: 'fas',
    iconName: 'eraser',
    icon: [
        576,
        512,
        [],
        "f12d",
        "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
    ]
};
var $1113a0aa61ab7765$export$9c4218a898614082 = {
    prefix: 'fas',
    iconName: 'earth-americas',
    icon: [
        512,
        512,
        [
            127758,
            "earth",
            "earth-america",
            "globe-americas"
        ],
        "f57d",
        "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zm48 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
    ]
};
var $1113a0aa61ab7765$export$c2118d3775773870 = $1113a0aa61ab7765$export$9c4218a898614082;
var $1113a0aa61ab7765$export$8b0f3a26397cf632 = $1113a0aa61ab7765$export$9c4218a898614082;
var $1113a0aa61ab7765$export$e96bcc7bde9498db = $1113a0aa61ab7765$export$9c4218a898614082;
var $1113a0aa61ab7765$export$ae02241644924482 = {
    prefix: 'fas',
    iconName: 'person-burst',
    icon: [
        640,
        512,
        [],
        "e53b",
        "M480 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
var $1113a0aa61ab7765$export$a1ab1e69a300089f = {
    prefix: 'fas',
    iconName: 'dove',
    icon: [
        512,
        512,
        [
            128330
        ],
        "f4ba",
        "M160.8 96.5c14 17 31 30.9 49.5 42.2c25.9 15.8 53.7 25.9 77.7 31.6V138.8C265.8 108.5 250 71.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8c-13.3 15.4-32.7 44.6-48.4 87.2zM320 144v30.6l0 0v1.3l0 0 0 32.1c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448H320c88.4 0 160-71.6 160-160V128l29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3H400c-44.2 0-80 35.8-80 80zm80 16c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16z"
    ]
};
var $1113a0aa61ab7765$export$1344b64f6e922e12 = {
    prefix: 'fas',
    iconName: 'battery-empty',
    icon: [
        576,
        512,
        [
            "battery-0"
        ],
        "f244",
        "M80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zM64 176c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176z"
    ]
};
var $1113a0aa61ab7765$export$de8d0338927394c1 = $1113a0aa61ab7765$export$1344b64f6e922e12;
var $1113a0aa61ab7765$export$8d36a54dbf1e6bce = {
    prefix: 'fas',
    iconName: 'socks',
    icon: [
        512,
        512,
        [
            129510
        ],
        "f696",
        "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V96H128V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64H288V48c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0H176c-26.5 0-48 21.5-48 48V64zM320 96V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V96H320zM512 64V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V64H512z"
    ]
};
var $1113a0aa61ab7765$export$366b69cbdce46334 = {
    prefix: 'fas',
    iconName: 'inbox',
    icon: [
        512,
        512,
        [],
        "f01c",
        "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"
    ]
};
var $1113a0aa61ab7765$export$a6f4f4a005d91fbd = {
    prefix: 'fas',
    iconName: 'section',
    icon: [
        320,
        512,
        [],
        "e447",
        "M96.9 96c2.1-11.6 8.7-19.8 21.1-25.4c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8c-34.7-5.7-69.4-3.6-98 9.3c-29.8 13.5-52.2 38.6-58 74.1c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c.6 .5 1.3 .9 2 1.4C54.3 194.2 38.5 215.1 33.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31l0 0 3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2l0 0c-4.3-1.5-8.5-2.9-12.3-4.2c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6l0 0 .2 0c34.5 5.4 68.8 3.4 97.2-8.7c29.4-12.6 52.5-36.5 58.5-71.5c3.3-19.3 1.9-37.4-5-53.9c-6.3-15-16.4-26.4-27.6-35.2c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5c-.2-.1-.4-.1-.6-.2l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.9-9.7 7.9-17.3 20.5-22.7c14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"
    ]
};
var $1113a0aa61ab7765$export$d262c1f5912046e6 = {
    prefix: 'fas',
    iconName: 'gauge-high',
    icon: [
        512,
        512,
        [
            62461,
            "tachometer-alt",
            "tachometer-alt-fast"
        ],
        "f625",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM96 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm352-32c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$38dd17b9f064c10f = $1113a0aa61ab7765$export$d262c1f5912046e6;
var $1113a0aa61ab7765$export$e99d8b85f35b8ca5 = $1113a0aa61ab7765$export$d262c1f5912046e6;
var $1113a0aa61ab7765$export$f5c53ce8ec380d11 = {
    prefix: 'fas',
    iconName: 'envelope-open-text',
    icon: [
        512,
        512,
        [],
        "f658",
        "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$7a76c9d35b42d691 = {
    prefix: 'fas',
    iconName: 'hospital',
    icon: [
        640,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M192 48c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48V512H368V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H192V48zM48 96H160V512H48c-26.5 0-48-21.5-48-48V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V224H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V144c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v48H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V464c0 26.5-21.5 48-48 48H480V96H592zM312 64c-8.8 0-16 7.2-16 16v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152h24c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H344V80c0-8.8-7.2-16-16-16H312z"
    ]
};
var $1113a0aa61ab7765$export$cea7736417b94a3b = $1113a0aa61ab7765$export$7a76c9d35b42d691;
var $1113a0aa61ab7765$export$69c8cc0360f017e8 = $1113a0aa61ab7765$export$7a76c9d35b42d691;
var $1113a0aa61ab7765$export$770be8b3d5776043 = {
    prefix: 'fas',
    iconName: 'wine-bottle',
    icon: [
        512,
        512,
        [],
        "f72f",
        "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5L180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l48.8-48.8 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0L99.3 324.7c-6.2 6.2-6.2 16.4 0 22.6z"
    ]
};
var $1113a0aa61ab7765$export$5d65c40a109eb09c = {
    prefix: 'fas',
    iconName: 'chess-rook',
    icon: [
        384,
        512,
        [
            9820
        ],
        "f447",
        "M0 204.2V48c0-8.8 7.2-16 16-16H72c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h56c8.8 0 16 7.2 16 16V204.2c0 12.1-6.8 23.2-17.7 28.6l-28.6 14.3c-10.8 5.4-17.7 16.5-17.5 28.6C322.2 360.7 336 416 336 416H48s13.8-55.3 15.8-140.2c.3-12.1-6.6-23.2-17.5-28.6L17.7 232.8C6.8 227.4 0 216.3 0 204.2zM176 320h32c8.8 0 16-7.2 16-16V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$2f8a7938c06a2142 = {
    prefix: 'fas',
    iconName: 'bars-staggered',
    icon: [
        512,
        512,
        [
            "reorder",
            "stream"
        ],
        "f550",
        "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$75d2bb378a2fc102 = $1113a0aa61ab7765$export$2f8a7938c06a2142;
var $1113a0aa61ab7765$export$ed81ab40fc4e904 = $1113a0aa61ab7765$export$2f8a7938c06a2142;
var $1113a0aa61ab7765$export$45cbd92c28deb2c7 = {
    prefix: 'fas',
    iconName: 'dharmachakra',
    icon: [
        512,
        512,
        [
            9784
        ],
        "f655",
        "M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.6-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$9fae219b4d3ce0be = {
    prefix: 'fas',
    iconName: 'hotdog',
    icon: [
        512,
        512,
        [
            127789
        ],
        "f80f",
        "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9l0 0v0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4l0 0-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"
    ]
};
var $1113a0aa61ab7765$export$2ffee5b2bc935c1f = {
    prefix: 'fas',
    iconName: 'person-walking-with-cane',
    icon: [
        512,
        512,
        [
            "blind"
        ],
        "f29d",
        "M176 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L128 231.6v43.2c0 17 6.7 33.3 18.7 45.3L224 397.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V390.6c0-12.7-5.1-24.9-14.1-33.9L224 306.7V213.3l70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128H167.6zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zM450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9L450.8 505.1z"
    ]
};
var $1113a0aa61ab7765$export$923de21def6ea9b6 = $1113a0aa61ab7765$export$2ffee5b2bc935c1f;
var $1113a0aa61ab7765$export$5b9205e1042594b7 = {
    prefix: 'fas',
    iconName: 'drum',
    icon: [
        576,
        512,
        [
            129345
        ],
        "f569",
        "M533.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L402.2 104.5C367.8 98.7 329 96 288 96C146.6 96 32 128 32 208V368c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24V463.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24V479.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24V446.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM339.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C490.4 181.8 496 197.4 496 208c0 .8-2.7 17.2-46 35.9C411.1 260.7 354 272 288 272s-123.1-11.3-162-28.1C82.7 225.2 80 208.8 80 208c0-10.6 5.6-26.2 44.4-41.3C162.6 151.9 219.8 144 288 144c18 0 35.1 .5 51.4 1.6z"
    ]
};
var $1113a0aa61ab7765$export$dd52741c60cc638f = {
    prefix: 'fas',
    iconName: 'ice-cream',
    icon: [
        384,
        512,
        [
            127848
        ],
        "f810",
        "M335.1 160c.6-5.3 .9-10.6 .9-16C336 64.5 271.5 0 192 0S48 64.5 48 144c0 5.4 .3 10.7 .9 16H48c-26.5 0-48 21.5-48 48s21.5 48 48 48h53.5 181H336c26.5 0 48-21.5 48-48s-21.5-48-48-48h-.9zM64 288L168.8 497.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L320 288H64z"
    ]
};
var $1113a0aa61ab7765$export$2a376a9d0d8fee96 = {
    prefix: 'fas',
    iconName: 'heart-circle-bolt',
    icon: [
        576,
        512,
        [],
        "e4fc",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var $1113a0aa61ab7765$export$b5698497901d7197 = {
    prefix: 'fas',
    iconName: 'fax',
    icon: [
        512,
        512,
        [
            128224,
            128439
        ],
        "f1ac",
        "M128 64v96h64V64H386.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64zM0 160V480c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm480 32H128V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM256 320c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm160-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM384 448c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm-96-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$dec46f8df1860e0 = {
    prefix: 'fas',
    iconName: 'paragraph',
    icon: [
        448,
        512,
        [
            182
        ],
        "f1dd",
        "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"
    ]
};
var $1113a0aa61ab7765$export$6999832247e52c2b = {
    prefix: 'fas',
    iconName: 'check-to-slot',
    icon: [
        576,
        512,
        [
            "vote-yea"
        ],
        "f772",
        "M96 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V384H96V80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48H64V416H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336z"
    ]
};
var $1113a0aa61ab7765$export$e87bb3db1608b850 = $1113a0aa61ab7765$export$6999832247e52c2b;
var $1113a0aa61ab7765$export$228008b5e11032fa = {
    prefix: 'fas',
    iconName: 'star-half',
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8V0zM429.9 512c1.1 .1 2.1 .1 3.2 0h-3.2z"
    ]
};
var $1113a0aa61ab7765$export$2088efcf62cf3b1 = {
    prefix: 'fas',
    iconName: 'boxes-stacked',
    icon: [
        576,
        512,
        [
            62625,
            "boxes",
            "boxes-alt"
        ],
        "f468",
        "M248 0H208c-26.5 0-48 21.5-48 48V160c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V48c0-26.5-21.5-48-48-48H328V80c0 8.8-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V0zM64 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H184v80c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V256H64zM352 512H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H472v80c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V256H352c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2V464c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"
    ]
};
var $1113a0aa61ab7765$export$2007320dd6cde6db = $1113a0aa61ab7765$export$2088efcf62cf3b1;
var $1113a0aa61ab7765$export$e6ef1d896ed63b3e = $1113a0aa61ab7765$export$2088efcf62cf3b1;
var $1113a0aa61ab7765$export$88bc01ff8dbecc55 = {
    prefix: 'fas',
    iconName: 'link',
    icon: [
        640,
        512,
        [
            128279,
            "chain"
        ],
        "f0c1",
        "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
    ]
};
var $1113a0aa61ab7765$export$b5d071e02a25554f = $1113a0aa61ab7765$export$88bc01ff8dbecc55;
var $1113a0aa61ab7765$export$837bc776b490934d = {
    prefix: 'fas',
    iconName: 'ear-listen',
    icon: [
        512,
        512,
        [
            "assistive-listening-systems"
        ],
        "f2a2",
        "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3c-7.9 15.8-1.5 34.9 14.2 42.9l.4 .2c.4 .2 1.1 .6 2.1 1.2c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1-.1 0 0 0c0 0 0 0-14.3 28.6L398.3 3.4zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78V400c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM192 352c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $1113a0aa61ab7765$export$8eeef3dc0035b165 = $1113a0aa61ab7765$export$837bc776b490934d;
var $1113a0aa61ab7765$export$ad95e4f80f98ebe0 = {
    prefix: 'fas',
    iconName: 'tree-city',
    icon: [
        640,
        512,
        [],
        "e587",
        "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80H160V480c0 18-15 32-32 32c-18 0-32-14-32-32V320H80c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"
    ]
};
var $1113a0aa61ab7765$export$436587205947bca5 = {
    prefix: 'fas',
    iconName: 'play',
    icon: [
        384,
        512,
        [
            9654
        ],
        "f04b",
        "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
    ]
};
var $1113a0aa61ab7765$export$a5dc297d3f60936 = {
    prefix: 'fas',
    iconName: 'font',
    icon: [
        448,
        512,
        [],
        "f031",
        "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"
    ]
};
var $1113a0aa61ab7765$export$fe44d4c71644ea0 = {
    prefix: 'fas',
    iconName: 'rupiah-sign',
    icon: [
        512,
        512,
        [],
        "e23d",
        "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256-96h80c61.9 0 112 50.1 112 112s-50.1 112-112 112H352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 192c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96h48z"
    ]
};
var $1113a0aa61ab7765$export$34c8b97060c09ff = {
    prefix: 'fas',
    iconName: 'magnifying-glass',
    icon: [
        512,
        512,
        [
            128269,
            "search"
        ],
        "f002",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"
    ]
};
var $1113a0aa61ab7765$export$871a78837687ffe8 = $1113a0aa61ab7765$export$34c8b97060c09ff;
var $1113a0aa61ab7765$export$eabe53838d45ac6a = {
    prefix: 'fas',
    iconName: 'table-tennis-paddle-ball',
    icon: [
        512,
        512,
        [
            127955,
            "ping-pong-paddle-ball",
            "table-tennis"
        ],
        "f45d",
        "M416 288c-50.1 0-93.6 28.8-114.6 70.8L68.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C471.8 297.6 445 288 416 288zM49.3 151.9L290.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.2 6.2 44.9 16.9 63.7c-3 .2-6.1 .3-9.2 .3H293c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L88.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32C3.1 464.3-.3 455.7 0 446.9s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8C45.5 285.5 32 252.9 32 219v-2.7c0-22.8 6.1-44.9 17.3-64.3zM416 512c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96z"
    ]
};
var $1113a0aa61ab7765$export$ebb246c621751737 = $1113a0aa61ab7765$export$eabe53838d45ac6a;
var $1113a0aa61ab7765$export$f378fbb4e0ef7edf = $1113a0aa61ab7765$export$eabe53838d45ac6a;
var $1113a0aa61ab7765$export$cdcec8ca7ec0d381 = {
    prefix: 'fas',
    iconName: 'person-dots-from-line',
    icon: [
        576,
        512,
        [
            "diagnoses"
        ],
        "f470",
        "M288 176c48.6 0 88-39.4 88-88s-39.4-88-88-88s-88 39.4-88 88s39.4 88 88 88zM78.7 372.9c15-12.5 50-34.4 97.3-50.1V432H400V322.7c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5c-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM272 280c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zm56 104c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zM96 240c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm368 16c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $1113a0aa61ab7765$export$68bad2b52a90d1fa = $1113a0aa61ab7765$export$cdcec8ca7ec0d381;
var $1113a0aa61ab7765$export$60430351cdb4ba89 = {
    prefix: 'fas',
    iconName: 'trash-can-arrow-up',
    icon: [
        448,
        512,
        [
            "trash-restore-alt"
        ],
        "f82a",
        "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
var $1113a0aa61ab7765$export$d075b19b21cb9856 = $1113a0aa61ab7765$export$60430351cdb4ba89;
var $1113a0aa61ab7765$export$58b7558ca9822358 = {
    prefix: 'fas',
    iconName: 'naira-sign',
    icon: [
        448,
        512,
        [],
        "e1f6",
        "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H228.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H262.5L122.6 46.3zM305.1 320H320v22.3L305.1 320zM185.5 256H128V169.7L185.5 256z"
    ]
};
var $1113a0aa61ab7765$export$9206260ff0c0c616 = {
    prefix: 'fas',
    iconName: 'cart-arrow-down',
    icon: [
        576,
        512,
        [],
        "f218",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360V134.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V32H120.1C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $1113a0aa61ab7765$export$8a322f740d64e9fc = {
    prefix: 'fas',
    iconName: 'walkie-talkie',
    icon: [
        384,
        512,
        [],
        "f8ef",
        "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144V300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V371.9c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9V144c0-26.5-21.5-48-48-48H320c0-17.7-14.3-32-32-32s-32 14.3-32 32H224c0-17.7-14.3-32-32-32s-32 14.3-32 32H112V24zm0 136H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$27f34878d8ed7a76 = {
    prefix: 'fas',
    iconName: 'file-pen',
    icon: [
        576,
        512,
        [
            128221,
            "file-edit"
        ],
        "f31c",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V285.7l-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var $1113a0aa61ab7765$export$e343e19f1757c5ae = $1113a0aa61ab7765$export$27f34878d8ed7a76;
var $1113a0aa61ab7765$export$32b0cd6133c2742 = {
    prefix: 'fas',
    iconName: 'receipt',
    icon: [
        384,
        512,
        [
            129534
        ],
        "f543",
        "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.2-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.2 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"
    ]
};
var $1113a0aa61ab7765$export$3643b719db23d46e = {
    prefix: 'fas',
    iconName: 'square-pen',
    icon: [
        448,
        512,
        [
            "pen-square",
            "pencil-square"
        ],
        "f14b",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var $1113a0aa61ab7765$export$fbb231ccb3d960bc = $1113a0aa61ab7765$export$3643b719db23d46e;
var $1113a0aa61ab7765$export$35d253ecd249e771 = $1113a0aa61ab7765$export$3643b719db23d46e;
var $1113a0aa61ab7765$export$957e62a9b80ff4e3 = {
    prefix: 'fas',
    iconName: 'suitcase-rolling',
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72H144V56zm176 72H288V56c0-30.9-25.1-56-56-56H152C121.1 0 96 25.1 96 56v72H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64c0 17.7 14.3 32 32 32s32-14.3 32-32H256c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zM112 224H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$38c8c32017dd9cc = {
    prefix: 'fas',
    iconName: 'person-circle-exclamation',
    icon: [
        576,
        512,
        [],
        "e53f",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm0-48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $1113a0aa61ab7765$export$8db9bc521720fccd = {
    prefix: 'fas',
    iconName: 'chevron-down',
    icon: [
        512,
        512,
        [],
        "f078",
        "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    ]
};
var $1113a0aa61ab7765$export$9338fc4614cfc0cf = {
    prefix: 'fas',
    iconName: 'battery-full',
    icon: [
        576,
        512,
        [
            128267,
            "battery",
            "battery-5"
        ],
        "f240",
        "M0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176zm80-16c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zm368 32V320H96V192H448z"
    ]
};
var $1113a0aa61ab7765$export$214720d39635cea8 = $1113a0aa61ab7765$export$9338fc4614cfc0cf;
var $1113a0aa61ab7765$export$e426617482c711a7 = $1113a0aa61ab7765$export$9338fc4614cfc0cf;
var $1113a0aa61ab7765$export$8717352b90217272 = {
    prefix: 'fas',
    iconName: 'skull-crossbones',
    icon: [
        512,
        512,
        [
            128369,
            9760
        ],
        "f714",
        "M400 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V234.4c-38.6-23-64-62.1-64-106.4C112 57.3 176.5 0 256 0s144 57.3 144 128zM200 176c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm144-32c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM35.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L256 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L327.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L256 419.8 78.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L184.4 384 49.7 316.6c-15.8-7.9-22.2-27.1-14.3-42.9z"
    ]
};
var $1113a0aa61ab7765$export$ca4c5b4dcff58860 = {
    prefix: 'fas',
    iconName: 'code-compare',
    icon: [
        512,
        512,
        [],
        "e13a",
        "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9v40h16c35.3 0 64-28.7 64-64V153.3C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V320c0 70.7-57.3 128-128 128H320v40zM456 80c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9V128H176c-35.3 0-64 28.7-64 64V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-70.7 57.3-128 128-128h16V24zM56 432c0 13.3 10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $1113a0aa61ab7765$export$f8a219cf4f516384 = {
    prefix: 'fas',
    iconName: 'list-ul',
    icon: [
        512,
        512,
        [
            "list-dots"
        ],
        "f0ca",
        "M64 144c26.5 0 48-21.5 48-48s-21.5-48-48-48S16 69.5 16 96s21.5 48 48 48zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm48-208c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
    ]
};
var $1113a0aa61ab7765$export$e6f4ba30d84fa6ea = $1113a0aa61ab7765$export$f8a219cf4f516384;
var $1113a0aa61ab7765$export$8845cce2a763ee07 = {
    prefix: 'fas',
    iconName: 'school-lock',
    icon: [
        640,
        512,
        [],
        "e56f",
        "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96H592c26.5 0 48 21.5 48 48V272c0-61.9-50.1-112-112-112s-112 50.1-112 112v24.6c-19.1 11.1-32 31.7-32 55.4H320.3l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H166.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $1113a0aa61ab7765$export$f4b64c3a138c1b59 = {
    prefix: 'fas',
    iconName: 'tower-cell',
    icon: [
        576,
        512,
        [],
        "e585",
        "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448H398.3l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384H206.8l14.5-32H354.7l14.5 32zM288 205.3L325.6 288H250.4L288 205.3zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"
    ]
};
var $1113a0aa61ab7765$export$e88ba08d4f4d65b6 = {
    prefix: 'fas',
    iconName: 'down-long',
    icon: [
        320,
        512,
        [
            "long-arrow-alt-down"
        ],
        "f309",
        "M318 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26S14.4 320 24 320h88l0-288c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32l0 288h88c9.6 0 18.2 5.7 22 14.5z"
    ]
};
var $1113a0aa61ab7765$export$8b92530ca6418c2f = $1113a0aa61ab7765$export$e88ba08d4f4d65b6;
var $1113a0aa61ab7765$export$e6fd420a918b43b5 = {
    prefix: 'fas',
    iconName: 'ranking-star',
    icon: [
        640,
        512,
        [],
        "e561",
        "M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H256zM32 320c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm416 96v64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"
    ]
};
var $1113a0aa61ab7765$export$d5713874f8fefe1b = {
    prefix: 'fas',
    iconName: 'chess-king',
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M224 0c17.7 0 32 14.3 32 32V48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v48H416c10.3 0 19.9 4.9 26 13.3s7.7 19.1 4.4 28.8L375.1 416H72.9L1.6 202.1C-1.6 192.4 0 181.6 6 173.3s15.7-13.3 26-13.3H192V112H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32zM32 480c0-17.7 14.3-32 32-32H83.6 364.4 384c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128 64c-17.7 0-32-14.3-32-32z"
    ]
};
var $1113a0aa61ab7765$export$dcd74f2821882a49 = {
    prefix: 'fas',
    iconName: 'person-harassing',
    icon: [
        576,
        512,
        [],
        "e549",
        "M192 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM59.4 304.5L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM464 344v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"
    ]
};
var $1113a0aa61ab7765$export$9d355b4e79216962 = {
    prefix: 'fas',
    iconName: 'brazilian-real-sign',
    icon: [
        512,
        512,
        [],
        "e46c",
        "M400 0c17.7 0 32 14.3 32 32V50.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V460.6c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2V32c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256z"
    ]
};
var $1113a0aa61ab7765$export$8a56136f40511e5d = {
    prefix: 'fas',
    iconName: 'landmark-dome',
    icon: [
        512,
        512,
        [
            "landmark-alt"
        ],
        "f752",
        "M248 0h16c13.3 0 24 10.7 24 24V34.7C368.4 48.1 431.9 111.6 445.3 192H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h2.7C80.1 111.6 143.6 48.1 224 34.7V24c0-13.3 10.7-24 24-24zM64 288h64V416h40V288h64V416h48V288h64V416h40V288h64V420.3c.6 .3 1.2 .7 1.7 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V288z"
    ]
};
var $1113a0aa61ab7765$export$8b9c180efffc50ab = $1113a0aa61ab7765$export$8a56136f40511e5d;
var $1113a0aa61ab7765$export$8e144ed4d52eef49 = {
    prefix: 'fas',
    iconName: 'arrow-up',
    icon: [
        384,
        512,
        [
            8593
        ],
        "f062",
        "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
    ]
};
var $1113a0aa61ab7765$export$e0cfed4ba2fe562c = {
    prefix: 'fas',
    iconName: 'tv',
    icon: [
        640,
        512,
        [
            63717,
            "television",
            "tv-alt"
        ],
        "f26c",
        "M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$9803b0176917be28 = $1113a0aa61ab7765$export$e0cfed4ba2fe562c;
var $1113a0aa61ab7765$export$6aa64ad5a1974ad7 = $1113a0aa61ab7765$export$e0cfed4ba2fe562c;
var $1113a0aa61ab7765$export$ac094c06f566cca3 = {
    prefix: 'fas',
    iconName: 'shrimp',
    icon: [
        512,
        512,
        [
            129424
        ],
        "e448",
        "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64h1c3.7 88.9 77 160 167 160h56V128H264 88.8 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM224 456c0 13.3 10.7 24 24 24h72V407.8l-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3v69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415zM336 128H320V320h18.3c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM216 192c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$350a84fd0f833f4d = {
    prefix: 'fas',
    iconName: 'list-check',
    icon: [
        576,
        512,
        [
            "tasks"
        ],
        "f0ae",
        "M184.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L39 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L39 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM256 96c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c-17.7 0-32-14.3-32-32zM192 416c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zM80 464c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $1113a0aa61ab7765$export$2f6d5b2fec286d63 = $1113a0aa61ab7765$export$350a84fd0f833f4d;
var $1113a0aa61ab7765$export$3fe50bd8062cd141 = {
    prefix: 'fas',
    iconName: 'jug-detergent',
    icon: [
        384,
        512,
        [],
        "e519",
        "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88C74.7 96 64 85.3 64 72s10.7-24 24-24h8V24zM0 256c0-70.7 57.3-128 128-128H256c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $1113a0aa61ab7765$export$9a5c11a5e3d7f1e7 = {
    prefix: 'fas',
    iconName: 'circle-user',
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM256 272c39.8 0 72-32.2 72-72s-32.2-72-72-72s-72 32.2-72 72s32.2 72 72 72z"
    ]
};
var $1113a0aa61ab7765$export$be7d974e9e0dba1a = $1113a0aa61ab7765$export$9a5c11a5e3d7f1e7;
var $1113a0aa61ab7765$export$d1886bc596424e6c = {
    prefix: 'fas',
    iconName: 'user-shield',
    icon: [
        640,
        512,
        [],
        "f505",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3H178.3zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8L591.4 312z"
    ]
};
var $1113a0aa61ab7765$export$cc58cb0f2257a6a9 = {
    prefix: 'fas',
    iconName: 'wind',
    icon: [
        512,
        512,
        [],
        "f72e",
        "M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$6d2be7c5d395dd16 = {
    prefix: 'fas',
    iconName: 'car-burst',
    icon: [
        640,
        512,
        [
            "car-crash"
        ],
        "f5e1",
        "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zM268.3 308.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17s20.4 16.6 17 29.4s-16.6 20.4-29.4 17zM545 358.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4s16.6-20.4 29.4-17s20.4 16.6 17 29.4z"
    ]
};
var $1113a0aa61ab7765$export$8ff55566398404cd = $1113a0aa61ab7765$export$6d2be7c5d395dd16;
var $1113a0aa61ab7765$export$b8c4c058fe7d193c = {
    prefix: 'fas',
    iconName: 'y',
    icon: [
        384,
        512,
        [
            121
        ],
        "59",
        "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"
    ]
};
var $1113a0aa61ab7765$export$22c642403aeeaeaf = {
    prefix: 'fas',
    iconName: 'person-snowboarding',
    icon: [
        576,
        512,
        [
            127938,
            "snowboarding"
        ],
        "f7ce",
        "M241.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6H504c13.3 0 24 10.7 24 24s-10.7 24-24 24H475.8c-10.8 0-21.4-2-31.5-5.8L92.1 371.3c-11.5-4.4-22-11.2-30.8-20L39 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L224 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM171 350.1l159 60.9c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.4-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L171 350.1zM464 96c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $1113a0aa61ab7765$export$72683772d587302a = $1113a0aa61ab7765$export$22c642403aeeaeaf;
var $1113a0aa61ab7765$export$27de16299ddd171 = {
    prefix: 'fas',
    iconName: 'truck-fast',
    icon: [
        640,
        512,
        [
            "shipping-fast"
        ],
        "f48b",
        "M112 0C85.5 0 64 21.5 64 48V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 272c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 240c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V416c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H112zM544 237.3V256H416V160h50.7L544 237.3zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zm368-48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48z"
    ]
};
var $1113a0aa61ab7765$export$5e419f47aaeb3c05 = $1113a0aa61ab7765$export$27de16299ddd171;
var $1113a0aa61ab7765$export$24228a855c5f6812 = {
    prefix: 'fas',
    iconName: 'fish',
    icon: [
        576,
        512,
        [
            128031
        ],
        "f578",
        "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$10f5839059d22f7e = {
    prefix: 'fas',
    iconName: 'user-graduate',
    icon: [
        448,
        512,
        [],
        "f501",
        "M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM129.1 323.2l83.2 88.4c6.3 6.7 17 6.7 23.3 0l83.2-88.4c73.7 14.9 129.1 80 129.1 158.1c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-78.1 55.5-143.2 129.1-158.1z"
    ]
};
var $1113a0aa61ab7765$export$625fb3848216f28c = {
    prefix: 'fas',
    iconName: 'circle-half-stroke',
    icon: [
        512,
        512,
        [
            9680,
            "adjust"
        ],
        "f042",
        "M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zm64 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
    ]
};
var $1113a0aa61ab7765$export$cfa06e4b68edca2d = $1113a0aa61ab7765$export$625fb3848216f28c;
var $1113a0aa61ab7765$export$add3b381ced12554 = {
    prefix: 'fas',
    iconName: 'clapperboard',
    icon: [
        512,
        512,
        [],
        "e131",
        "M448 32H361.9l-1 1-127 127h92.1l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40l-104 104H512zM294.1 32H201.9l-1 1L73.9 160h92.1l1-1 127-127zM64 32C28.7 32 0 60.7 0 96v64H6.1l1-1 127-127H64zM512 192H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192z"
    ]
};
var $1113a0aa61ab7765$export$55c8e3afd9f6c0b4 = {
    prefix: 'fas',
    iconName: 'circle-radiation',
    icon: [
        512,
        512,
        [
            9762,
            "radiation-alt"
        ],
        "f7ba",
        "M256 448C150 448 64 362 64 256S150 64 256 64s192 86 192 192s-86 192-192 192zm0 64c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$2f048fa82bbddf6f = $1113a0aa61ab7765$export$55c8e3afd9f6c0b4;
var $1113a0aa61ab7765$export$dc3654cf8a596fbf = {
    prefix: 'fas',
    iconName: 'baseball',
    icon: [
        512,
        512,
        [
            129358,
            9918,
            "baseball-ball"
        ],
        "f433",
        "M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"
    ]
};
var $1113a0aa61ab7765$export$63a3f8ceae07c7f3 = $1113a0aa61ab7765$export$dc3654cf8a596fbf;
var $1113a0aa61ab7765$export$b024a52a4ccf5e69 = {
    prefix: 'fas',
    iconName: 'jet-fighter-up',
    icon: [
        512,
        512,
        [],
        "e518",
        "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2v77l-144 84V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v56 32 24c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H192v32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96V448c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16V480c0-4.6-2-9-5.5-12L320 416.7V384H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24V368 336 280c0-13.3-10.7-24-24-24s-24 10.7-24 24v18.8l-144-84v-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"
    ]
};
var $1113a0aa61ab7765$export$59c351869dc27435 = {
    prefix: 'fas',
    iconName: 'diagram-project',
    icon: [
        576,
        512,
        [
            "project-diagram"
        ],
        "f542",
        "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V96H384V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V160H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336c0-1.7 .1-3.4 .3-5L144 224H48c-26.5 0-48-21.5-48-48V80z"
    ]
};
var $1113a0aa61ab7765$export$30bf9f5b96509df1 = $1113a0aa61ab7765$export$59c351869dc27435;
var $1113a0aa61ab7765$export$e9bd786d30cb716c = {
    prefix: 'fas',
    iconName: 'copy',
    icon: [
        512,
        512,
        [],
        "f0c5",
        "M224 0c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224zM64 160c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64H64V224h64V160H64z"
    ]
};
var $1113a0aa61ab7765$export$28cc565c11db6f2e = {
    prefix: 'fas',
    iconName: 'volume-xmark',
    icon: [
        576,
        512,
        [
            "volume-mute",
            "volume-times"
        ],
        "f6a9",
        "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $1113a0aa61ab7765$export$aa8decd057dfd29b = $1113a0aa61ab7765$export$28cc565c11db6f2e;
var $1113a0aa61ab7765$export$a1c7b36ba71dbeca = $1113a0aa61ab7765$export$28cc565c11db6f2e;
var $1113a0aa61ab7765$export$72e2d874a963de0c = {
    prefix: 'fas',
    iconName: 'hand-sparkles',
    icon: [
        640,
        512,
        [],
        "e05d",
        "M320 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V323.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2L478.9 391C460.6 396.3 448 413 448 432c0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512H348.8c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"
    ]
};
var $1113a0aa61ab7765$export$eb83fb404127db75 = {
    prefix: 'fas',
    iconName: 'grip',
    icon: [
        448,
        512,
        [
            "grip-horizontal"
        ],
        "f58d",
        "M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V136zm0 192c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328z"
    ]
};
var $1113a0aa61ab7765$export$4a45308d6c8decc1 = $1113a0aa61ab7765$export$eb83fb404127db75;
var $1113a0aa61ab7765$export$928280bdd54fa173 = {
    prefix: 'fas',
    iconName: 'share-from-square',
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32V224zM80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z"
    ]
};
var $1113a0aa61ab7765$export$ae9e1434571f373c = $1113a0aa61ab7765$export$928280bdd54fa173;
var $1113a0aa61ab7765$export$f7367a7301f2dc0f = {
    prefix: 'fas',
    iconName: 'child-combatant',
    icon: [
        576,
        512,
        [
            "child-rifle"
        ],
        "e4e0",
        "M176 128c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zm-8 352V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9H169.8c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L104 300.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0H432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16V132.3c-9.6 5.5-16 15.9-16 27.7v32c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32h16v96c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H480V325.3l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16z"
    ]
};
var $1113a0aa61ab7765$export$9b027cdb5db3ae5c = $1113a0aa61ab7765$export$f7367a7301f2dc0f;
var $1113a0aa61ab7765$export$e18f576a7b31ba46 = {
    prefix: 'fas',
    iconName: 'gun',
    icon: [
        576,
        512,
        [],
        "e19b",
        "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H32C14.3 64 0 78.3 0 96V208c0 17.7 14.3 32 32 32H42c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h96c14.7 0 27.5-10 31-24.2L217 352H321.4c23.7 0 44.8-14.9 52.7-37.2L400.9 240H432c8.5 0 16.6-3.4 22.6-9.4L477.3 208H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H528V56zM321.4 304H229l16-64h105l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$318ed022991eef56 = {
    prefix: 'fas',
    iconName: 'square-phone',
    icon: [
        448,
        512,
        [
            "phone-square"
        ],
        "f098",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"
    ]
};
var $1113a0aa61ab7765$export$8ba22605a641ebdf = $1113a0aa61ab7765$export$318ed022991eef56;
var $1113a0aa61ab7765$export$a105e7b44ca0eb9e = {
    prefix: 'fas',
    iconName: 'plus',
    icon: [
        448,
        512,
        [
            10133,
            61543,
            "add"
        ],
        "2b",
        "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
    ]
};
var $1113a0aa61ab7765$export$9e8f9a9d4ad32c0f = $1113a0aa61ab7765$export$a105e7b44ca0eb9e;
var $1113a0aa61ab7765$export$1fe4a9976a241685 = {
    prefix: 'fas',
    iconName: 'expand',
    icon: [
        448,
        512,
        [],
        "f065",
        "M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"
    ]
};
var $1113a0aa61ab7765$export$9835883ce9d0fe78 = {
    prefix: 'fas',
    iconName: 'computer',
    icon: [
        640,
        512,
        [],
        "e4e5",
        "M384 96V320H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H181.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H277.3l-10.7-32H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm464 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16zm32 224c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$e6e44779b2fa1a5c = {
    prefix: 'fas',
    iconName: 'xmark',
    icon: [
        320,
        512,
        [
            128473,
            10005,
            10006,
            10060,
            215,
            "close",
            "multiply",
            "remove",
            "times"
        ],
        "f00d",
        "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
    ]
};
var $1113a0aa61ab7765$export$23c717133fd81476 = $1113a0aa61ab7765$export$e6e44779b2fa1a5c;
var $1113a0aa61ab7765$export$4ed4ff13d4dbc862 = $1113a0aa61ab7765$export$e6e44779b2fa1a5c;
var $1113a0aa61ab7765$export$34810740c1bd6c54 = $1113a0aa61ab7765$export$e6e44779b2fa1a5c;
var $1113a0aa61ab7765$export$174bd7f477b115b4 = $1113a0aa61ab7765$export$e6e44779b2fa1a5c;
var $1113a0aa61ab7765$export$ff9a43e3a9cb653c = {
    prefix: 'fas',
    iconName: 'arrows-up-down-left-right',
    icon: [
        512,
        512,
        [
            "arrows"
        ],
        "f047",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224H109.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H224V402.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288H402.7l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4H288V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
    ]
};
var $1113a0aa61ab7765$export$d5ae09a305d70340 = $1113a0aa61ab7765$export$ff9a43e3a9cb653c;
var $1113a0aa61ab7765$export$fd7622d4b8d3674b = {
    prefix: 'fas',
    iconName: 'chalkboard-user',
    icon: [
        640,
        512,
        [
            "chalkboard-teacher"
        ],
        "f51c",
        "M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 256c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96zm-26.7 32h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"
    ]
};
var $1113a0aa61ab7765$export$443fcf69b0155291 = $1113a0aa61ab7765$export$fd7622d4b8d3674b;
var $1113a0aa61ab7765$export$c8f99b9b5ea83555 = {
    prefix: 'fas',
    iconName: 'peso-sign',
    icon: [
        384,
        512,
        [],
        "e222",
        "M64 32C46.3 32 32 46.3 32 64v64c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c68.4 0 127.7-39 156.8-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.7c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16h.7c17.7 0 32-14.3 32-32s-14.3-32-32-32H332.8C303.7 71 244.4 32 176 32H64zm190.4 96H96V96h80c30.5 0 58.2 12.2 78.4 32zM96 192H286.9c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16H96V192zm158.4 96c-20.2 19.8-47.9 32-78.4 32H96V288H254.4z"
    ]
};
var $1113a0aa61ab7765$export$18ba6a500873dba9 = {
    prefix: 'fas',
    iconName: 'building-shield',
    icon: [
        576,
        512,
        [],
        "e4d8",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V207l-42.4 17H304 272c-8.8 0-16 7.2-16 16v32 24.2V304c0 .9 .1 1.7 .2 2.6c2.3 58.1 24.1 144.8 98.7 201.5c-5.8 2.5-12.2 3.9-18.9 3.9H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
    ]
};
var $1113a0aa61ab7765$export$8afab767536f59ad = {
    prefix: 'fas',
    iconName: 'baby',
    icon: [
        448,
        512,
        [],
        "f77c",
        "M296 88c0 39.8-32.2 72-72 72s-72-32.2-72-72s32.2-72 72-72s72 32.2 72 72zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128V251.7c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"
    ]
};
var $1113a0aa61ab7765$export$d7e538fddb81da68 = {
    prefix: 'fas',
    iconName: 'users-line',
    icon: [
        640,
        512,
        [],
        "e592",
        "M211.2 96c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM32 256c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4H96c-35.3 0-64 28.7-64 64zm461.6 32H576c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4zM391.2 226.4c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM321.6 192c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $1113a0aa61ab7765$export$932a67a1b1a7a724 = {
    prefix: 'fas',
    iconName: 'quote-left',
    icon: [
        448,
        512,
        [
            8220,
            "quote-left-alt"
        ],
        "f10d",
        "M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320 288 216z"
    ]
};
var $1113a0aa61ab7765$export$95bb9ad3aa35c741 = $1113a0aa61ab7765$export$932a67a1b1a7a724;
var $1113a0aa61ab7765$export$e87e41787bbedc98 = {
    prefix: 'fas',
    iconName: 'tractor',
    icon: [
        640,
        512,
        [
            128668
        ],
        "f722",
        "M96 64c0-35.3 28.7-64 64-64H266.3c26.2 0 49.7 15.9 59.4 40.2L373.7 160H480V126.2c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9V160h56c22.1 0 40 17.9 40 40v45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2c-39.3 0-74.1 18.9-96 48H352c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8V480c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6V192 160 64zm170.3 0H160v96h32H304.7L266.3 64zM176 256c-44.2 0-80 35.8-80 80s35.8 80 80 80s80-35.8 80-80s-35.8-80-80-80zM528 448c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c2.7 0 5.3 .1 7.9 .3c44.9 4 80.1 41.7 80.1 87.7c0 48.6-39.4 88-88 88z"
    ]
};
var $1113a0aa61ab7765$export$940cea0f5451895c = {
    prefix: 'fas',
    iconName: 'trash-arrow-up',
    icon: [
        448,
        512,
        [
            "trash-restore"
        ],
        "f829",
        "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
var $1113a0aa61ab7765$export$d32f45a64ed40e8d = $1113a0aa61ab7765$export$940cea0f5451895c;
var $1113a0aa61ab7765$export$fc9f7bd981c34c45 = {
    prefix: 'fas',
    iconName: 'arrow-down-up-lock',
    icon: [
        640,
        512,
        [],
        "e4b0",
        "M150.6 502.6l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7V288H416V272c0-17.2 3.9-33.5 10.8-48H352V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3V224l-128 0H96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H96V402.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64zM288 320V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H288zm240-80c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $1113a0aa61ab7765$export$4d384ffc907ddaff = {
    prefix: 'fas',
    iconName: 'lines-leaning',
    icon: [
        448,
        512,
        [],
        "e51e",
        "M222.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM384 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z"
    ]
};
var $1113a0aa61ab7765$export$613f406c1b5802a8 = {
    prefix: 'fas',
    iconName: 'ruler-combined',
    icon: [
        512,
        512,
        [],
        "f546",
        "M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"
    ]
};
var $1113a0aa61ab7765$export$da61665fff8aebfe = {
    prefix: 'fas',
    iconName: 'copyright',
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"
    ]
};
var $1113a0aa61ab7765$export$a7c5f5e4805fdab = {
    prefix: 'fas',
    iconName: 'equals',
    icon: [
        448,
        512,
        [
            62764
        ],
        "3d",
        "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z"
    ]
};
var $1113a0aa61ab7765$export$db34f7a6de38784f = {
    prefix: 'fas',
    iconName: 'blender',
    icon: [
        512,
        512,
        [],
        "f517",
        "M0 64C0 28.7 28.7 0 64 0h64 32H470.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H459.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zM145.5 192L133.8 64H64V192h81.5zM144 384H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM0 64C0 28.7 28.7 0 64 0h64 32H470.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H459.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zM145.5 192L133.8 64H64V192h81.5zM144 384H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$b4619aeaf0b9d18e = {
    prefix: 'fas',
    iconName: 'teeth',
    icon: [
        576,
        512,
        [],
        "f62e",
        "M0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z"
    ]
};
var $1113a0aa61ab7765$export$3570be7b68efb8db = {
    prefix: 'fas',
    iconName: 'shekel-sign',
    icon: [
        448,
        512,
        [
            8362,
            "ils",
            "shekel",
            "sheqel",
            "sheqel-sign"
        ],
        "f20b",
        "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H192c35.3 0 64 28.7 64 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-70.7-57.3-128-128-128H32zM320 480c70.7 0 128-57.3 128-128V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 35.3-28.7 64-64 64H192V192c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320z"
    ]
};
var $1113a0aa61ab7765$export$ecadeff45b05a451 = $1113a0aa61ab7765$export$3570be7b68efb8db;
var $1113a0aa61ab7765$export$27e0e10e74d98736 = $1113a0aa61ab7765$export$3570be7b68efb8db;
var $1113a0aa61ab7765$export$28b3b26a80030d4e = $1113a0aa61ab7765$export$3570be7b68efb8db;
var $1113a0aa61ab7765$export$d84993fb5e8c6edd = $1113a0aa61ab7765$export$3570be7b68efb8db;
var $1113a0aa61ab7765$export$fc82fb79180cd17c = {
    prefix: 'fas',
    iconName: 'map',
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M384 476.1L192 421.2V35.9L384 90.8V476.1zm32-1.2V88.4L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2V423.6L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"
    ]
};
var $1113a0aa61ab7765$export$b24d84ed5657d89a = {
    prefix: 'fas',
    iconName: 'rocket',
    icon: [
        512,
        512,
        [],
        "f135",
        "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40z"
    ]
};
var $1113a0aa61ab7765$export$ed36ad335b36be22 = {
    prefix: 'fas',
    iconName: 'photo-film',
    icon: [
        640,
        512,
        [
            "photo-video"
        ],
        "f87c",
        "M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z"
    ]
};
var $1113a0aa61ab7765$export$739f6a6a12dfb6ed = $1113a0aa61ab7765$export$ed36ad335b36be22;
var $1113a0aa61ab7765$export$758f1fb3784e4080 = {
    prefix: 'fas',
    iconName: 'folder-minus',
    icon: [
        512,
        512,
        [],
        "f65d",
        "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
    ]
};
var $1113a0aa61ab7765$export$de59c2657a8ace67 = {
    prefix: 'fas',
    iconName: 'store',
    icon: [
        576,
        512,
        [],
        "f54e",
        "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"
    ]
};
var $1113a0aa61ab7765$export$cf36928a9c52e98a = {
    prefix: 'fas',
    iconName: 'arrow-trend-up',
    icon: [
        576,
        512,
        [],
        "e098",
        "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V205.3L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z"
    ]
};
var $1113a0aa61ab7765$export$2a44d62160972254 = {
    prefix: 'fas',
    iconName: 'plug-circle-minus',
    icon: [
        576,
        512,
        [],
        "e55e",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-64 0c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
    ]
};
var $1113a0aa61ab7765$export$5c1f29f4c7cad367 = {
    prefix: 'fas',
    iconName: 'sign-hanging',
    icon: [
        512,
        512,
        [
            "sign"
        ],
        "f4d9",
        "M96 0c17.7 0 32 14.3 32 32V64l352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32C14.3 128 0 113.7 0 96S14.3 64 32 64H64V32C64 14.3 78.3 0 96 0zm96 160H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$d21d0d6c8e9e8bf9 = $1113a0aa61ab7765$export$5c1f29f4c7cad367;
var $1113a0aa61ab7765$export$a527a6267c55a54c = {
    prefix: 'fas',
    iconName: 'bezier-curve',
    icon: [
        640,
        512,
        [],
        "f55b",
        "M296 136V88h48v48H296zM288 32c-26.5 0-48 21.5-48 48v4H121.6C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-3.3c5.9-67 48.5-123.4 107.5-149.1c8.6 12.7 23.2 21.1 39.8 21.1h64c16.6 0 31.1-8.4 39.8-21.1c59 25.7 101.6 82.1 107.5 149.1H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-4.5c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400V80c0-26.5-21.5-48-48-48H288zM88 376h48v48H88V376zm416 48V376h48v48H504z"
    ]
};
var $1113a0aa61ab7765$export$6b31a1e5968b2378 = {
    prefix: 'fas',
    iconName: 'bell-slash',
    icon: [
        640,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6c.5-1.7 .7-3.5 .7-5.4c0-27.6-11-54.1-30.5-73.7L512 320c-20.5-20.5-32-48.3-32-77.3V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM160 242.7c0 29-11.5 56.8-32 77.3l-1.5 1.5C107 341 96 367.5 96 395.2c0 11.5 9.3 20.8 20.8 20.8H406.2L160 222.1v20.7zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
var $1113a0aa61ab7765$export$1c92b67c45a4b4fc = {
    prefix: 'fas',
    iconName: 'tablet',
    icon: [
        448,
        512,
        [
            "tablet-android"
        ],
        "f3fb",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$5eddbb7c71278268 = $1113a0aa61ab7765$export$1c92b67c45a4b4fc;
var $1113a0aa61ab7765$export$9b263780a7312c8c = {
    prefix: 'fas',
    iconName: 'school-flag',
    icon: [
        576,
        512,
        [],
        "e56e",
        "M288 0H400c8.8 0 16 7.2 16 16V64c0 8.8-7.2 16-16 16H320V95.5L410.3 160H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H336V400c0-26.5-21.5-48-48-48s-48 21.5-48 48V512H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H165.7L256 95.5V32c0-17.7 14.3-32 32-32zm48 240c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM80 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm368 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80zm384 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H464z"
    ]
};
var $1113a0aa61ab7765$export$d3c2bcfd3b861e4a = {
    prefix: 'fas',
    iconName: 'fill',
    icon: [
        576,
        512,
        [],
        "f575",
        "M118.6 9.4C106.1-3.1 85.9-3.1 73.4 9.4s-12.5 32.8 0 45.3L154.7 136 62.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L180.1 481.4c37.5 37.5 98.3 37.5 135.8 0L506.3 290.9c28.1-28.1 28.1-73.7 0-101.8L354.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L200 90.7 118.6 9.4zM200 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L245.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L461.1 234.3c3.1 3.1 3.1 8.2 0 11.3L418.7 288H99.5c1.4-5.4 4.2-10.4 8.4-14.6L200 181.3z"
    ]
};
var $1113a0aa61ab7765$export$887340269e6d6cac = {
    prefix: 'fas',
    iconName: 'angle-up',
    icon: [
        448,
        512,
        [
            8963
        ],
        "f106",
        "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
    ]
};
var $1113a0aa61ab7765$export$482976e9a4ab10f3 = {
    prefix: 'fas',
    iconName: 'drumstick-bite',
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4H336c6.3 0 12.4-.3 18.5-1c11.9-1.2 16.4-15.5 10.8-26c-8.5-15.8-13.3-33.8-13.3-53c0-61.9 50.1-112 112-112c8 0 15.7 .8 23.2 2.4c11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0C238.8 0 160 78.8 160 176v89.2z"
    ]
};
var $1113a0aa61ab7765$export$273296afacf93991 = {
    prefix: 'fas',
    iconName: 'holly-berry',
    icon: [
        512,
        512,
        [],
        "f7aa",
        "M256 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-80 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM276.8 383.8c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72v22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8v32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.6c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
    ]
};
var $1113a0aa61ab7765$export$75702e3e3dd44a44 = {
    prefix: 'fas',
    iconName: 'chevron-left',
    icon: [
        384,
        512,
        [
            9001
        ],
        "f053",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
    ]
};
var $1113a0aa61ab7765$export$7fc18cf2d526c341 = {
    prefix: 'fas',
    iconName: 'bacteria',
    icon: [
        640,
        512,
        [],
        "e059",
        "M304.9 .7c-9.6-2.7-19.5 2.8-22.3 12.4l-3.1 11c-7.4-.3-14.9 .4-22.4 2.1c-9 2.1-17.8 4.4-26.2 7l-4.4-10.3c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l3.6 8.5c-16.5 7.1-31.5 15.1-45.2 23.9L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l5.8 8.7c-13.5 11.2-25.3 23.1-35.5 35.3l-10.1-8.1c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L66 155c-1.6 2.4-3.1 4.8-4.5 7.3c-7.1 11.8-12.8 23.2-17.4 34l-7.4-3c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l8.7 3.5c-.2 .8-.4 1.6-.7 2.3c-2.6 9.4-4.2 17.4-5.3 23.5c-.5 3.1-.9 5.7-1.2 7.7c-.1 1-.2 2-.3 2.7l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.4 2.8l0 0-29.4-2.7c-.3 3.8-.4 7.5-.3 11.2l-11 3.1C3.5 285.4-2 295.4 .7 304.9s12.7 15.1 22.3 12.4l10.3-2.9c8 15.5 20.7 28.3 36.4 36.4L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l3.1-11c17.8 .8 34.7-4.1 48.8-13.2l8 8c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-8-8c6.8-10.6 11.3-22.9 12.7-36.2l.1-.6c.2-1.3 .7-3.8 1.7-7.4l.2-.6 9.4 4c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.5-3.6c7.5-11.1 18.7-23.7 36.5-34.5l1.6 5.6c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-3-10.6c5.2-1.7 10.7-3.2 16.6-4.6c9.7-2.2 18.5-6 26.4-11.1l8 8c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-8-8c9.1-14.3 14-31.2 13.2-48.8l11-3.1c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-10.3 2.9c-8.1-15.9-21-28.5-36.4-36.4l2.9-10.3c2.7-9.6-2.8-19.5-12.4-22.3zM106.2 275.8l-37.1-3.4 0 0 37.1 3.4zM128 256c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm96-112c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm98.7 345c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l3.1-11c7.4 .3 14.9-.4 22.4-2.1c9-2.1 17.8-4.4 26.2-7l4.4 10.3c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-3.6-8.5c16.5-7.1 31.5-15.1 45.2-23.9L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-5.8-8.7c13.5-11.2 25.3-23.1 35.5-35.3l10.1 8.1c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574 357c1.6-2.4 3.1-4.8 4.5-7.3c7.1-11.8 12.8-23.2 17.4-34l7.4 3c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-8.7-3.5c.2-.8 .4-1.6 .7-2.3c2.6-9.4 4.2-17.4 5.3-23.5c.5-3.1 .9-5.7 1.2-7.7c.1-1 .2-2 .3-2.7l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.4-2.8l0 0 29.4 2.7c.3-3.8 .4-7.5 .3-11.2l11-3.1c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-10.3 2.9c-8-15.5-20.7-28.3-36.4-36.4l2.9-10.3c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.2 12.4l-3.1 11c-17.8-.8-34.7 4.1-48.8 13.2l-8-8c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l8 8c-6.8 10.6-11.3 22.9-12.7 36.2l-.1 .6c-.2 1.3-.7 3.8-1.7 7.4l-.2 .6-9.4-4c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.5 3.6c-7.5 11.1-18.7 23.7-36.5 34.5l-1.6-5.6c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l3 10.6c-5.2 1.7-10.7 3.2-16.6 4.6c-9.7 2.2-18.5 6-26.4 11.1l-8-8c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l8 8c-9.1 14.2-14 31.2-13.2 48.8l-11 3.1c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l10.3-2.9c8.1 15.9 21 28.5 36.4 36.4l-3 10.3zM570.9 239.5l0 0-37.1-3.4 37.1 3.4zM384 384c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $1113a0aa61ab7765$export$54608d0a883fea4d = {
    prefix: 'fas',
    iconName: 'hand-lizard',
    icon: [
        512,
        512,
        [],
        "f258",
        "M0 112C0 85.5 21.5 64 48 64H160h80 46.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v12 16 48c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V402.2L273.9 352H240 160 112c-26.5 0-48-21.5-48-48s21.5-48 48-48h48 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H160 48c-26.5 0-48-21.5-48-48z"
    ]
};
var $1113a0aa61ab7765$export$3db5bca65a1be8dc = {
    prefix: 'fas',
    iconName: 'notdef',
    icon: [
        384,
        512,
        [],
        "e1fe",
        "M64 390.3L153.5 256 64 121.7V390.3zM102.5 448H281.5L192 313.7 102.5 448zm128-192L320 390.3V121.7L230.5 256zM281.5 64H102.5L192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
    ]
};
var $1113a0aa61ab7765$export$c7675a37487adc45 = {
    prefix: 'fas',
    iconName: 'disease',
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M238.5 53.1C251 39.6 268.6 32 287 32c28.9 0 54.5 18.7 63.2 46.3L366 128.6c7.3 23 25.2 41 48.2 48.3l62.2 19.9c21.2 6.8 35.6 26.5 35.6 48.7c0 17.5-8.9 33.7-23.6 43.1l-85.9 54.8c-10.6 6.8-16.6 18.8-15.7 31.3l2.5 33.9c2.8 38.5-27.7 71.4-66.4 71.4c-13.6 0-26.9-4.2-38.1-12l-48.2-33.6c-14.8-10.3-32.3-15.8-50.3-15.8H170.2c-4.9 0-9.9 .4-14.8 1.2L83.9 432.1c-21.3 3.6-42.8-5.7-54.6-23.9c-11.8-18.1-11.8-41.4 0-59.4L56.5 307c4.9-7.5 7.5-16.3 7.5-25.3c0-9.9-3.2-19.5-9-27.4L11.3 194.6C-6.5 170.3-.7 136.2 24.2 119.2c9.7-6.6 21.2-9.8 32.9-9.1l80.6 4.6c26.1 1.5 51.5-8.7 69.4-27.9l31.5-33.8zM160 256c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm160-48c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zM288 352c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$5000f52ca9819bf5 = {
    prefix: 'fas',
    iconName: 'briefcase-medical',
    icon: [
        512,
        512,
        [],
        "f469",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $1113a0aa61ab7765$export$c093cc22e88981c2 = {
    prefix: 'fas',
    iconName: 'genderless',
    icon: [
        384,
        512,
        [],
        "f22d",
        "M192 368c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112zm0 64c97.2 0 176-78.8 176-176s-78.8-176-176-176S16 158.8 16 256s78.8 176 176 176z"
    ]
};
var $1113a0aa61ab7765$export$930de8c26eb20490 = {
    prefix: 'fas',
    iconName: 'chevron-right',
    icon: [
        384,
        512,
        [
            9002
        ],
        "f054",
        "M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    ]
};
var $1113a0aa61ab7765$export$cebc76f79478e40e = {
    prefix: 'fas',
    iconName: 'retweet',
    icon: [
        576,
        512,
        [],
        "f079",
        "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"
    ]
};
var $1113a0aa61ab7765$export$ff2b8d5628da5f14 = {
    prefix: 'fas',
    iconName: 'car-rear',
    icon: [
        512,
        512,
        [
            "car-alt"
        ],
        "f5de",
        "M165.4 96H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 23.7 12.9 44.4 32 55.4V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H384v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V391.4c19.1-11.1 32-31.7 32-55.4V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24zm360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $1113a0aa61ab7765$export$7937ed2462a665c0 = $1113a0aa61ab7765$export$ff2b8d5628da5f14;
var $1113a0aa61ab7765$export$821aeede187f23c9 = {
    prefix: 'fas',
    iconName: 'pump-soap',
    icon: [
        448,
        512,
        [],
        "e06b",
        "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"
    ]
};
var $1113a0aa61ab7765$export$a714fc79f58cc9ef = {
    prefix: 'fas',
    iconName: 'video-slash',
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9V192 320v5.8l-32-25.1V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM32 128V384c0 35.3 28.7 64 64 64H352c23.4 0 43.9-12.6 55-31.3L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5z"
    ]
};
var $1113a0aa61ab7765$export$acec92052ac2183 = {
    prefix: 'fas',
    iconName: 'battery-quarter',
    icon: [
        576,
        512,
        [
            "battery-2"
        ],
        "f243",
        "M0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176zm80-16c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zm112 32V320H96V192h96z"
    ]
};
var $1113a0aa61ab7765$export$23ca8a94c555576 = $1113a0aa61ab7765$export$acec92052ac2183;
var $1113a0aa61ab7765$export$11b26516cae2104f = {
    prefix: 'fas',
    iconName: 'radio',
    icon: [
        512,
        512,
        [
            128251
        ],
        "f8d7",
        "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v4V304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5L494.8 47zM368 400c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80zM80 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM64 320c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
    ]
};
var $1113a0aa61ab7765$export$3b3ab4d86bad7d26 = {
    prefix: 'fas',
    iconName: 'baby-carriage',
    icon: [
        512,
        512,
        [
            "carriage-baby"
        ],
        "f77d",
        "M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0v64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0V160zM80 512c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zm336-48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48z"
    ]
};
var $1113a0aa61ab7765$export$9f117d92ccd36cf1 = $1113a0aa61ab7765$export$3b3ab4d86bad7d26;
var $1113a0aa61ab7765$export$bf0b19daceaec9c2 = {
    prefix: 'fas',
    iconName: 'traffic-light',
    icon: [
        320,
        512,
        [
            128678
        ],
        "f637",
        "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 320c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48zm-48-80c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48zM160 64c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48z"
    ]
};
var $1113a0aa61ab7765$export$f576739e9b18ea4f = {
    prefix: 'fas',
    iconName: 'thermometer',
    icon: [
        512,
        512,
        [],
        "f491",
        "M96 382.1V293.3c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4H129.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"
    ]
};
var $1113a0aa61ab7765$export$248171cb6dad4307 = {
    prefix: 'fas',
    iconName: 'vr-cardboard',
    icon: [
        640,
        512,
        [],
        "f729",
        "M576 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H184.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM224 240c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm256 64c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z"
    ]
};
var $1113a0aa61ab7765$export$bd40d3a3a16fb147 = {
    prefix: 'fas',
    iconName: 'hand-middle-finger',
    icon: [
        448,
        512,
        [
            128405
        ],
        "f806",
        "M232 0c-22.1 0-40 17.9-40 40V204.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"
    ]
};
var $1113a0aa61ab7765$export$89a1764fbb7ad2cb = {
    prefix: 'fas',
    iconName: 'percent',
    icon: [
        384,
        512,
        [
            62101,
            62785,
            "percentage"
        ],
        "25",
        "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128c0-35.3-28.7-64-64-64S0 92.7 0 128s28.7 64 64 64s64-28.7 64-64zM384 384c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $1113a0aa61ab7765$export$89333857fc063a2e = $1113a0aa61ab7765$export$89a1764fbb7ad2cb;
var $1113a0aa61ab7765$export$a06617a1a4ccea67 = {
    prefix: 'fas',
    iconName: 'truck-moving',
    icon: [
        640,
        512,
        [],
        "f4df",
        "M64 32C28.7 32 0 60.7 0 96V304v80 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16H416h33.6c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.7 0 32-14.3 32-32V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64H64zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 432c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zM240 400c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM80 432c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$b7ae54b4078b2060 = {
    prefix: 'fas',
    iconName: 'glass-water-droplet',
    icon: [
        448,
        512,
        [],
        "e4f5",
        "M64 0C55.1 0 46.6 3.7 40.6 10.2s-9.1 15.2-8.5 24.1L60.9 437.7c3 41.9 37.8 74.3 79.8 74.3H307.3c42 0 76.8-32.4 79.8-74.3L415.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S392.9 0 384 0H64zm51 297.5L98.4 64H349.6L333 297.5 320 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5zM288 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C193.7 125.9 160 172 160 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"
    ]
};
var $1113a0aa61ab7765$export$e9d85839f7751f01 = {
    prefix: 'fas',
    iconName: 'display',
    icon: [
        576,
        512,
        [],
        "e163",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z"
    ]
};
var $1113a0aa61ab7765$export$b5023c446f10324 = {
    prefix: 'fas',
    iconName: 'face-smile',
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM208.4 208c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$c632b2334f0913bc = $1113a0aa61ab7765$export$b5023c446f10324;
var $1113a0aa61ab7765$export$b6314cdc01bb5c43 = {
    prefix: 'fas',
    iconName: 'thumbtack',
    icon: [
        384,
        512,
        [
            128204,
            128392,
            "thumb-tack"
        ],
        "f08d",
        "M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32zM160 384h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
    ]
};
var $1113a0aa61ab7765$export$b63d0c7b519a9aae = $1113a0aa61ab7765$export$b6314cdc01bb5c43;
var $1113a0aa61ab7765$export$29c432d69ccf85a5 = {
    prefix: 'fas',
    iconName: 'trophy',
    icon: [
        576,
        512,
        [
            127942
        ],
        "f091",
        "M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z"
    ]
};
var $1113a0aa61ab7765$export$8ecd436ef91fc02e = {
    prefix: 'fas',
    iconName: 'person-praying',
    icon: [
        448,
        512,
        [
            128720,
            "pray"
        ],
        "f683",
        "M352 64c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432H72c-22.1 0-40 17.9-40 40s17.9 40 40 40H280c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"
    ]
};
var $1113a0aa61ab7765$export$3b32c982141cad51 = $1113a0aa61ab7765$export$8ecd436ef91fc02e;
var $1113a0aa61ab7765$export$6310f315e1ebbca5 = {
    prefix: 'fas',
    iconName: 'hammer',
    icon: [
        576,
        512,
        [
            128296
        ],
        "f6e3",
        "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"
    ]
};
var $1113a0aa61ab7765$export$e49e3cfceea441cc = {
    prefix: 'fas',
    iconName: 'hand-peace',
    icon: [
        512,
        512,
        [
            9996
        ],
        "f25b",
        "M224 0c17.7 0 32 14.3 32 32V240H192V32c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zM93.3 51.2L175.9 240H106.1L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5h69.9H216c22.1 0 40 17.9 40 40s-17.9 40-40 40H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H226.3c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363V336c0-32.7 24.6-59.7 56.3-63.5z"
    ]
};
var $1113a0aa61ab7765$export$decde496a29c5b23 = {
    prefix: 'fas',
    iconName: 'rotate',
    icon: [
        512,
        512,
        [
            128260,
            "sync-alt"
        ],
        "f2f1",
        "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"
    ]
};
var $1113a0aa61ab7765$export$2ff2056be8c281e4 = $1113a0aa61ab7765$export$decde496a29c5b23;
var $1113a0aa61ab7765$export$1025ad641edb49c2 = {
    prefix: 'fas',
    iconName: 'spinner',
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm0 416c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM48 304c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm464-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM142.9 437c18.7-18.7 18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zm0-294.2c18.7-18.7 18.7-49.1 0-67.9S93.7 56.2 75 75s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zM369.1 437c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9z"
    ]
};
var $1113a0aa61ab7765$export$30a5bb4ad3fa716c = {
    prefix: 'fas',
    iconName: 'robot',
    icon: [
        640,
        512,
        [
            129302
        ],
        "f544",
        "M320 0c17.7 0 32 14.3 32 32V96H480c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256c0-22.1-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40s40-17.9 40-40zm152 40c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z"
    ]
};
var $1113a0aa61ab7765$export$8614cb1326eacd7a = {
    prefix: 'fas',
    iconName: 'peace',
    icon: [
        512,
        512,
        [
            9774
        ],
        "f67c",
        "M224 445.3V323.5l-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8V66.7C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5V445.3c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3V240.8L422.8 351.1zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
    ]
};
var $1113a0aa61ab7765$export$4aac79b9ae3cfdb8 = {
    prefix: 'fas',
    iconName: 'gears',
    icon: [
        640,
        512,
        [
            "cogs"
        ],
        "f085",
        "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.7 8.4 166.9 8 160 8s-13.7 .4-20.4 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM208 176c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 400c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $1113a0aa61ab7765$export$af1575770afc9559 = $1113a0aa61ab7765$export$4aac79b9ae3cfdb8;
var $1113a0aa61ab7765$export$e3a174a50618c208 = {
    prefix: 'fas',
    iconName: 'warehouse',
    icon: [
        640,
        512,
        [],
        "f494",
        "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24V432H512l0 56c0 13.3-10.7 24-24 24zM128 400V336H512v64H128zm0-96V224H512l0 80H128z"
    ]
};
var $1113a0aa61ab7765$export$bc804c6ab898f610 = {
    prefix: 'fas',
    iconName: 'arrow-up-right-dots',
    icon: [
        576,
        512,
        [],
        "e4b7",
        "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H160zM576 80c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM448 208c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM400 384c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm48 80c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm128 0c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM272 384c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm48 80c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM144 512c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM576 336c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm-48-80c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $1113a0aa61ab7765$export$d6f21e17ea797702 = {
    prefix: 'fas',
    iconName: 'splotch',
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M287.6 .1c-19.7 0-38.3 9.1-50.4 24.6L205.9 64.9c-17.9 23-46 35.6-75.1 33.7L59.1 94c-13.5-.9-26.9 3.2-37.7 11.6C-1.3 123.2-6.7 155.2 8.8 179.4l44.5 69.2c7.1 11 10.8 23.8 10.8 36.8c0 11.9-3.1 23.5-9 33.8L27.4 367.7c-10 17.5-10 39.1 0 56.6c12.1 21.2 36.4 32.3 60.4 27.7l67-13c5.5-1.1 11.2-1.6 16.8-1.6H180c20.9 0 41 7.4 56.9 20.9l45 38.2c11.8 10 26.9 15.6 42.4 15.6c37.8 0 67.7-31.9 65.4-69.6l-3.1-50.6c-1-16.8 6.6-32.9 20.1-42.8l82.5-60.2c14.2-10.4 22.7-27 22.7-44.6c0-23.2-14.5-43.9-36.3-51.8l-58.2-21.2c-24.4-8.9-42.9-29.1-49.7-54.2L349.3 47.4C341.8 19.5 316.5 .1 287.6 .1z"
    ]
};
var $1113a0aa61ab7765$export$fbb22081b65e4f33 = {
    prefix: 'fas',
    iconName: 'face-grin-hearts',
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM383.8 317.8c12.3-3.7 24.3 7 19.2 18.7c-24.5 56.9-81.1 96.7-147 96.7s-122.5-39.8-147-96.7c-5.1-11.8 6.9-22.4 19.2-18.7C166.7 329.4 210.1 336 256 336s89.3-6.6 127.8-18.2zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
    ]
};
var $1113a0aa61ab7765$export$c56cf0e0c3bc5ed2 = $1113a0aa61ab7765$export$fbb22081b65e4f33;
var $1113a0aa61ab7765$export$2df6451abf70a6ff = {
    prefix: 'fas',
    iconName: 'dice-four',
    icon: [
        448,
        512,
        [
            9859
        ],
        "f524",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM128 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM352 160c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM320 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$3bee83bf278fddbe = {
    prefix: 'fas',
    iconName: 'sim-card',
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M64 0H242.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32v32h64V192H96zM64 352h80 96 80V288H240 144 64v64zM320 224c0-17.7-14.3-32-32-32H256v64h64V224zM160 192v64h64V192H160zM288 448c17.7 0 32-14.3 32-32V384H256v64h32zM160 384v64h64V384H160zM64 416c0 17.7 14.3 32 32 32h32V384H64v32z"
    ]
};
var $1113a0aa61ab7765$export$7e3f1701aa95ef01 = {
    prefix: 'fas',
    iconName: 'transgender',
    icon: [
        512,
        512,
        [
            9895,
            "transgender-alt"
        ],
        "f225",
        "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V414.2C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0h96zM352 256c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96z"
    ]
};
var $1113a0aa61ab7765$export$9c36cf9334c052f = $1113a0aa61ab7765$export$7e3f1701aa95ef01;
var $1113a0aa61ab7765$export$e134ecd00b622a47 = {
    prefix: 'fas',
    iconName: 'mercury',
    icon: [
        384,
        512,
        [
            9791
        ],
        "f223",
        "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V398.4C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112z"
    ]
};
var $1113a0aa61ab7765$export$fd4d6cfd52703f50 = {
    prefix: 'fas',
    iconName: 'arrow-turn-down',
    icon: [
        384,
        512,
        [
            "level-down"
        ],
        "f149",
        "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
    ]
};
var $1113a0aa61ab7765$export$3794c07e7a666c94 = $1113a0aa61ab7765$export$fd4d6cfd52703f50;
var $1113a0aa61ab7765$export$a75569baaf4a6c3a = {
    prefix: 'fas',
    iconName: 'person-falling-burst',
    icon: [
        640,
        512,
        [],
        "e547",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H224l80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80c0-26.5-21.5-48-48-48S0 53.5 0 80s21.5 48 48 48s48-21.5 48-48zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z"
    ]
};
var $1113a0aa61ab7765$export$f8db2747dadd48f7 = {
    prefix: 'fas',
    iconName: 'award',
    icon: [
        384,
        512,
        [],
        "f559",
        "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80s80-35.8 80-80zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
    ]
};
var $1113a0aa61ab7765$export$68ddda3b30ba09f0 = {
    prefix: 'fas',
    iconName: 'ticket-simple',
    icon: [
        576,
        512,
        [
            "ticket-alt"
        ],
        "f3ff",
        "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v80c-26.5 0-48 21.5-48 48s21.5 48 48 48v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V304c26.5 0 48-21.5 48-48s-21.5-48-48-48V128z"
    ]
};
var $1113a0aa61ab7765$export$75e38ba471fd89c4 = $1113a0aa61ab7765$export$68ddda3b30ba09f0;
var $1113a0aa61ab7765$export$f26673f8b10c3d46 = {
    prefix: 'fas',
    iconName: 'building',
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$2ebd565813951f81 = {
    prefix: 'fas',
    iconName: 'angles-left',
    icon: [
        512,
        512,
        [
            171,
            "angle-double-left"
        ],
        "f100",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
    ]
};
var $1113a0aa61ab7765$export$21b0833b3cf929a7 = $1113a0aa61ab7765$export$2ebd565813951f81;
var $1113a0aa61ab7765$export$fc19ca0fe15e73bc = {
    prefix: 'fas',
    iconName: 'qrcode',
    icon: [
        448,
        512,
        [],
        "f029",
        "M48 32C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm80 64v64H64V96h64zM48 288c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48zm80 64v64H64V352h64zM256 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zm64 16h64v64H320V96zm32 352v32h32V448H352zm96 0H416v32h32V448zM416 288v32H352V288H256v96 96h64V384h32v32h96V352 320 288H416z"
    ]
};
var $1113a0aa61ab7765$export$29be1665d1b36a3b = {
    prefix: 'fas',
    iconName: 'clock-rotate-left',
    icon: [
        512,
        512,
        [
            "history"
        ],
        "f1da",
        "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"
    ]
};
var $1113a0aa61ab7765$export$76d1986559ca7b7a = $1113a0aa61ab7765$export$29be1665d1b36a3b;
var $1113a0aa61ab7765$export$2ff38f330c834084 = {
    prefix: 'fas',
    iconName: 'face-grin-beam-sweat',
    icon: [
        512,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5 1.8-11.3 4.6-18.1c.3-.7 .6-1.4 .9-2.1c9-20.2 26.5-44.9 36-57.5c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM383.8 317.8C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7c24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7c5.1-11.8-6.9-22.4-19.2-18.7zm-166.2-89l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"
    ]
};
var $1113a0aa61ab7765$export$14d0ccc54c5b6826 = $1113a0aa61ab7765$export$2ff38f330c834084;
var $1113a0aa61ab7765$export$364f19abcfac1b0a = {
    prefix: 'fas',
    iconName: 'file-export',
    icon: [
        640,
        512,
        [
            "arrow-right-from-file"
        ],
        "f56e",
        "M32 64C32 28.7 60.7 0 96 0H256V128c0 17.7 14.3 32 32 32H416V288H248c-13.3 0-24 10.7-24 24s10.7 24 24 24H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM416 336V288H526.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H416zm0-208H288V0L416 128z"
    ]
};
var $1113a0aa61ab7765$export$b9c76255b38e1df1 = $1113a0aa61ab7765$export$364f19abcfac1b0a;
var $1113a0aa61ab7765$export$8241bd5b9163ca12 = {
    prefix: 'fas',
    iconName: 'shield',
    icon: [
        512,
        512,
        [
            128737,
            "shield-blank"
        ],
        "f132",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.7 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"
    ]
};
var $1113a0aa61ab7765$export$64f54da8fbaba8ee = $1113a0aa61ab7765$export$8241bd5b9163ca12;
var $1113a0aa61ab7765$export$be9d5060a4bc3b4b = {
    prefix: 'fas',
    iconName: 'arrow-up-short-wide',
    icon: [
        576,
        512,
        [
            "sort-amount-up-alt"
        ],
        "f885",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
    ]
};
var $1113a0aa61ab7765$export$6e87844b0f151b6a = $1113a0aa61ab7765$export$be9d5060a4bc3b4b;
var $1113a0aa61ab7765$export$2d077da983246a68 = {
    prefix: 'fas',
    iconName: 'house-medical',
    icon: [
        576,
        512,
        [],
        "e3b2",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $1113a0aa61ab7765$export$14c9f1d85e53ae99 = {
    prefix: 'fas',
    iconName: 'golf-ball-tee',
    icon: [
        384,
        512,
        [
            "golf-ball"
        ],
        "f450",
        "M384 192c0 66.8-34.1 125.6-85.8 160H85.8C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.6-1.1-13.8-3c5.3 11.6 16.9 19.7 30.5 19.7c18.5 0 33.5-15 33.5-33.5c0-13.6-8.1-25.3-19.7-30.5c1.9 4.2 3 8.9 3 13.8zm-52.3-49.3c-4.9 0-9.6-1.1-13.8-3c5.3 11.6 16.9 19.7 30.5 19.7c18.5 0 33.5-15 33.5-33.5c0-13.6-8.1-25.3-19.7-30.5c1.9 4.2 3 8.9 3 13.8c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.6-1.1-13.8-3c5.3 11.6 16.9 19.7 30.5 19.7c18.5 0 33.5-15 33.5-33.5c0-13.6-8.1-25.3-19.7-30.5c1.9 4.2 3 8.9 3 13.8zM96 416c0-17.7 14.3-32 32-32h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V464c0-8.8-7.2-16-16-16H128c-17.7 0-32-14.3-32-32z"
    ]
};
var $1113a0aa61ab7765$export$2251487a9a33c682 = $1113a0aa61ab7765$export$14c9f1d85e53ae99;
var $1113a0aa61ab7765$export$f2b13ad44c03c40f = {
    prefix: 'fas',
    iconName: 'circle-chevron-left',
    icon: [
        512,
        512,
        [
            "chevron-circle-left"
        ],
        "f137",
        "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512s256-114.6 256-256zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"
    ]
};
var $1113a0aa61ab7765$export$4a42c8c2451a33fd = $1113a0aa61ab7765$export$f2b13ad44c03c40f;
var $1113a0aa61ab7765$export$792391babe46862d = {
    prefix: 'fas',
    iconName: 'house-chimney-window',
    icon: [
        576,
        512,
        [],
        "e00d",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H248z"
    ]
};
var $1113a0aa61ab7765$export$a82594dcc75a49f5 = {
    prefix: 'fas',
    iconName: 'pen-nib',
    icon: [
        512,
        512,
        [
            10001
        ],
        "f5ad",
        "M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2L288 94.6z"
    ]
};
var $1113a0aa61ab7765$export$89af87b7d6c15adf = {
    prefix: 'fas',
    iconName: 'tent-arrow-turn-left',
    icon: [
        640,
        512,
        [],
        "e580",
        "M152.1 41.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72C34.9 82.7 32 89.2 32 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L118.5 120 488 120c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24V192c0-66.3-53.7-120-120-120L118.5 72l33.5-30.2zM339.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6s14.9 11.1 24.2 11.1H320V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $1113a0aa61ab7765$export$c93b950e845a4ee7 = {
    prefix: 'fas',
    iconName: 'tents',
    icon: [
        640,
        512,
        [],
        "e582",
        "M396.6 6.5L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512H224V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $1113a0aa61ab7765$export$8282f5f5dcf6b009 = {
    prefix: 'fas',
    iconName: 'wand-magic',
    icon: [
        512,
        512,
        [
            "magic"
        ],
        "f0d0",
        "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z"
    ]
};
var $1113a0aa61ab7765$export$e58f9b502d4dd52d = $1113a0aa61ab7765$export$8282f5f5dcf6b009;
var $1113a0aa61ab7765$export$c6406747800cf702 = {
    prefix: 'fas',
    iconName: 'dog',
    icon: [
        576,
        512,
        [
            128021
        ],
        "f6d3",
        "M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7l-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16H303.8L416 256.1zM464 80c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $1113a0aa61ab7765$export$28e93ec9f5e2ddf3 = {
    prefix: 'fas',
    iconName: 'carrot',
    icon: [
        512,
        512,
        [
            129365
        ],
        "f787",
        "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3 0 .1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"
    ]
};
var $1113a0aa61ab7765$export$c4c2f69a53bab720 = {
    prefix: 'fas',
    iconName: 'moon',
    icon: [
        384,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
    ]
};
var $1113a0aa61ab7765$export$b86d7336e68a3f57 = {
    prefix: 'fas',
    iconName: 'wine-glass-empty',
    icon: [
        320,
        512,
        [
            "wine-glass-alt"
        ],
        "f5ce",
        "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM81.9 203.1L93.4 64H226.6l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"
    ]
};
var $1113a0aa61ab7765$export$b8ff3fe2b78aef2f = $1113a0aa61ab7765$export$b86d7336e68a3f57;
var $1113a0aa61ab7765$export$549b99473b7201e6 = {
    prefix: 'fas',
    iconName: 'cheese',
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M512 240.2V256H0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zm0 47.8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288H512z"
    ]
};
var $1113a0aa61ab7765$export$6ec1acbf3f610b8f = {
    prefix: 'fas',
    iconName: 'yin-yang',
    icon: [
        512,
        512,
        [
            9775
        ],
        "f6ad",
        "M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm32-352c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$fcb0647a5340b5b8 = {
    prefix: 'fas',
    iconName: 'music',
    icon: [
        512,
        512,
        [
            127925
        ],
        "f001",
        "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V147L192 223.8V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V200 128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"
    ]
};
var $1113a0aa61ab7765$export$d5d870c10bc9f1ce = {
    prefix: 'fas',
    iconName: 'code-commit',
    icon: [
        640,
        512,
        [],
        "f386",
        "M320 336c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z"
    ]
};
var $1113a0aa61ab7765$export$9e9af12b90a1abd2 = {
    prefix: 'fas',
    iconName: 'temperature-low',
    icon: [
        512,
        512,
        [],
        "f76b",
        "M448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm64 0c0 53-43 96-96 96s-96-43-96-96s43-96 96-96s96 43 96 96zM144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $1113a0aa61ab7765$export$cf152282d5de300d = {
    prefix: 'fas',
    iconName: 'person-biking',
    icon: [
        640,
        512,
        [
            128692,
            "biking"
        ],
        "f84a",
        "M400 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zM200 384c0 39.8-32.2 72-72 72s-72-32.2-72-72s32.2-72 72-72s72 32.2 72 72zm56 0c0-70.7-57.3-128-128-128S0 313.3 0 384s57.3 128 128 128s128-57.3 128-128zm328 0c0 39.8-32.2 72-72 72s-72-32.2-72-72s32.2-72 72-72s72 32.2 72 72zm56 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128z"
    ]
};
var $1113a0aa61ab7765$export$a5bcf835dbf9c0b = $1113a0aa61ab7765$export$cf152282d5de300d;
var $1113a0aa61ab7765$export$2a533051418ff4ca = {
    prefix: 'fas',
    iconName: 'broom',
    icon: [
        640,
        512,
        [
            129529
        ],
        "f51a",
        "M627.6 57.3c14-10.9 16.5-31 5.6-44.9s-31-16.5-44.9-5.6l-144 112-72 56-8.7 6.8-30.8-39.4c-3.7-4.8-9.8-7-15.8-5.8s-10.7 5.7-12.3 11.5l-12.5 46.3L371.1 295l48-.9c6.1-.1 11.5-3.7 14.1-9.1s1.9-11.9-1.8-16.7L403 231.9l8.6-6.7 72-56 144-112zM16.7 507.7c37.4 2.8 196.8 12 252.3-31.4c57.7-45.1 76.8-161.5 76.8-161.5L267.1 213.9s-117.6-9.6-175.3 35.5C69 267.1 50.5 304.1 36.3 344c-2.4 6.7 4.7 12.8 11 9.4L86.2 333c4.1-2.2 9.2-1.1 12 2.6s2.7 8.8-.4 12.3L24.4 430.4C13.2 442.9 5.5 458.1 2.4 474.5c-.9 4.8-1.6 8.9-2.2 12.1c-.9 5 .5 10.1 3.6 14.1s7.7 6.6 12.8 7z"
    ]
};
var $1113a0aa61ab7765$export$7b96388ca2be471b = {
    prefix: 'fas',
    iconName: 'shield-heart',
    icon: [
        512,
        512,
        [],
        "e574",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
    ]
};
var $1113a0aa61ab7765$export$31f89d8ac1d14ed6 = {
    prefix: 'fas',
    iconName: 'gopuram',
    icon: [
        512,
        512,
        [],
        "f664",
        "M120 0c13.3 0 24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8V64v64c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H416V352H384V224H352V128H320v96h32V352h32V512H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H128V352h32V224h32V128H160v96H128V352H96V512H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V256c0-17.7 14.3-32 32-32V160c0-17.7 14.3-32 32-32V64 32 24c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32v48h64V304c0-17.7-14.3-32-32-32zm-32-80v32h64V192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $1113a0aa61ab7765$export$bd931e906edf2f47 = {
    prefix: 'fas',
    iconName: 'earth-oceania',
    icon: [
        512,
        512,
        [
            "globe-oceania"
        ],
        "e47b",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $1113a0aa61ab7765$export$8ac3f5271448657d = $1113a0aa61ab7765$export$bd931e906edf2f47;
var $1113a0aa61ab7765$export$5a17e58bb7afb1d7 = {
    prefix: 'fas',
    iconName: 'square-xmark',
    icon: [
        448,
        512,
        [
            10062,
            "times-square",
            "xmark-square"
        ],
        "f2d3",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $1113a0aa61ab7765$export$c0248ac97142ea2a = $1113a0aa61ab7765$export$5a17e58bb7afb1d7;
var $1113a0aa61ab7765$export$9a364781d6b7602b = $1113a0aa61ab7765$export$5a17e58bb7afb1d7;
var $1113a0aa61ab7765$export$c92c903bade56844 = {
    prefix: 'fas',
    iconName: 'hashtag',
    icon: [
        448,
        512,
        [
            62098
        ],
        "23",
        "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"
    ]
};
var $1113a0aa61ab7765$export$95457ede07b81517 = {
    prefix: 'fas',
    iconName: 'up-right-and-down-left-from-center',
    icon: [
        512,
        512,
        [
            "expand-alt"
        ],
        "f424",
        "M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM184 496H40c-13.3 0-24-10.7-24-24V328c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"
    ]
};
var $1113a0aa61ab7765$export$bcb8d86a3a1d6eb6 = $1113a0aa61ab7765$export$95457ede07b81517;
var $1113a0aa61ab7765$export$2599126c3a57f727 = {
    prefix: 'fas',
    iconName: 'oil-can',
    icon: [
        640,
        512,
        [],
        "f613",
        "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H144 96 48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H288V128h32zM96 208v86.1L48 272.8V208H96z"
    ]
};
var $1113a0aa61ab7765$export$6e625d2e7790c860 = {
    prefix: 'fas',
    iconName: 't',
    icon: [
        384,
        512,
        [
            116
        ],
        "54",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z"
    ]
};
var $1113a0aa61ab7765$export$d4c909619093de2d = {
    prefix: 'fas',
    iconName: 'hippo',
    icon: [
        640,
        512,
        [
            129435
        ],
        "f6ed",
        "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 26.2-12.6 49.4-32 64v32c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V320H480v16c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V318.4c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V372c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h7.2H256h32c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zm88 24c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zM480 144c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 16c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $1113a0aa61ab7765$export$d01ddcc9efe7b149 = {
    prefix: 'fas',
    iconName: 'chart-column',
    icon: [
        512,
        512,
        [],
        "e0e3",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$a590003279d671b8 = {
    prefix: 'fas',
    iconName: 'infinity',
    icon: [
        640,
        512,
        [
            8734,
            9854
        ],
        "f534",
        "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"
    ]
};
var $1113a0aa61ab7765$export$2db4f9712313eafa = {
    prefix: 'fas',
    iconName: 'vial-circle-check',
    icon: [
        512,
        512,
        [],
        "e596",
        "M0 64C0 46.3 14.3 32 32 32H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V266.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64zM96 96v96h64V96H96zM512 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-76.7-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $1113a0aa61ab7765$export$f9a5161975928326 = {
    prefix: 'fas',
    iconName: 'person-arrow-down-to-line',
    icon: [
        640,
        512,
        [],
        "e538",
        "M192 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM464 64V306.7l-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $1113a0aa61ab7765$export$4f1ce88b2b4cd5cd = {
    prefix: 'fas',
    iconName: 'voicemail',
    icon: [
        640,
        512,
        [],
        "f897",
        "M144 160c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80zM263.8 320c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80H263.8zM496 320c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $1113a0aa61ab7765$export$55145a3dae4f984a = {
    prefix: 'fas',
    iconName: 'fan',
    icon: [
        512,
        512,
        [],
        "f863",
        "M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224H29.4C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32V29.4C288 13.2 274.8 0 258.6 0zM256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$1ae0a37b36ace746 = {
    prefix: 'fas',
    iconName: 'person-walking-luggage',
    icon: [
        576,
        512,
        [],
        "e554",
        "M432 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM347.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L340.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9z"
    ]
};
var $1113a0aa61ab7765$export$e36c32dd5cba9b90 = {
    prefix: 'fas',
    iconName: 'up-down',
    icon: [
        256,
        512,
        [
            8597,
            11021,
            "arrows-alt-v"
        ],
        "f338",
        "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"
    ]
};
var $1113a0aa61ab7765$export$138cb56a3f8f7040 = $1113a0aa61ab7765$export$e36c32dd5cba9b90;
var $1113a0aa61ab7765$export$301c3fab0c4545bd = {
    prefix: 'fas',
    iconName: 'cloud-moon-rain',
    icon: [
        640,
        512,
        [],
        "f73c",
        "M513.2 0C449 0 395.5 46.5 385.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5zM399.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C273.3 114.6 242.8 96 208 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H399.9zM117.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"
    ]
};
var $1113a0aa61ab7765$export$34f5c36a3e80efa2 = {
    prefix: 'fas',
    iconName: 'calendar',
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    ]
};
var $1113a0aa61ab7765$export$3a48b9820e92f5ab = {
    prefix: 'fas',
    iconName: 'trailer',
    icon: [
        640,
        512,
        [],
        "e041",
        "M48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H488h8H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V80c0-26.5-21.5-48-48-48H48zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zm0-48c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$6d636565b3ec36b4 = {
    prefix: 'fas',
    iconName: 'bahai',
    icon: [
        576,
        512,
        [
            "haykal"
        ],
        "f666",
        "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"
    ]
};
var $1113a0aa61ab7765$export$5c15e34e0e43f15c = $1113a0aa61ab7765$export$6d636565b3ec36b4;
var $1113a0aa61ab7765$export$303efb6031da122 = {
    prefix: 'fas',
    iconName: 'sd-card',
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$ae1875ba975aa0e9 = {
    prefix: 'fas',
    iconName: 'dragon',
    icon: [
        640,
        512,
        [
            128009
        ],
        "f6d5",
        "M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4L294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0H416h32 16c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48H538.5c-17 0-33.3-6.7-45.3-18.7L480 160H448v21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1C640 462.9 590.9 512 530.2 512H496 432 32.3c-3.3 0-6.6-.4-9.6-1.4C13.5 507.8 6 501 2.4 492.1C1 488.7 .2 485.2 0 481.4c-.2-3.7 .3-7.3 1.3-10.7c2.8-9.2 9.6-16.7 18.6-20.4c3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1c0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1V181.5v-57zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3v.6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87V227c0 32.8 8.4 64.8 24 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z"
    ]
};
var $1113a0aa61ab7765$export$cdbdd2118099ae07 = {
    prefix: 'fas',
    iconName: 'shoe-prints',
    icon: [
        640,
        512,
        [],
        "f54b",
        "M416 0C352.3 0 256 32 256 32V160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64h32V32H192c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32V480s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64H96V352H64c-35.3 0-64 28.7-64 64z"
    ]
};
var $1113a0aa61ab7765$export$eeda28b8ca4cb18e = {
    prefix: 'fas',
    iconName: 'circle-plus',
    icon: [
        512,
        512,
        [
            "plus-circle"
        ],
        "f055",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $1113a0aa61ab7765$export$d9cc3a81499af48c = $1113a0aa61ab7765$export$eeda28b8ca4cb18e;
var $1113a0aa61ab7765$export$4272e56f2429da88 = {
    prefix: 'fas',
    iconName: 'face-grin-tongue-wink',
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM320 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM336 232c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $1113a0aa61ab7765$export$58099903d50aefb3 = $1113a0aa61ab7765$export$4272e56f2429da88;
var $1113a0aa61ab7765$export$e6094d25274088ab = {
    prefix: 'fas',
    iconName: 'hand-holding',
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2c.3 0 .6 0 .9 0c0 0 0 0 0 0c-.3 0-.6 0-.9 0z"
    ]
};
var $1113a0aa61ab7765$export$d893dd9509763a17 = {
    prefix: 'fas',
    iconName: 'plug-circle-exclamation',
    icon: [
        576,
        512,
        [],
        "e55d",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$22965c7f4d903953 = {
    prefix: 'fas',
    iconName: 'link-slash',
    icon: [
        640,
        512,
        [
            "chain-broken",
            "chain-slash",
            "unlink"
        ],
        "f127",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"
    ]
};
var $1113a0aa61ab7765$export$382551e04f32620a = $1113a0aa61ab7765$export$22965c7f4d903953;
var $1113a0aa61ab7765$export$12f09d657be59586 = $1113a0aa61ab7765$export$22965c7f4d903953;
var $1113a0aa61ab7765$export$2f546f7d8ba01e18 = $1113a0aa61ab7765$export$22965c7f4d903953;
var $1113a0aa61ab7765$export$76c1aa4bf9a39458 = {
    prefix: 'fas',
    iconName: 'clone',
    icon: [
        512,
        512,
        [],
        "f24d",
        "M0 448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H224c-53 0-96-43-96-96V160H64c-35.3 0-64 28.7-64 64V448zm224-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z"
    ]
};
var $1113a0aa61ab7765$export$5a200e8504b7367a = {
    prefix: 'fas',
    iconName: 'person-walking-arrow-loop-left',
    icon: [
        640,
        512,
        [],
        "e551",
        "M208 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384H480c88.4 0 160-71.6 160-160s-71.6-160-160-160L352 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c53 0 96 43 96 96s-43 96-96 96H461.3l25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"
    ]
};
var $1113a0aa61ab7765$export$a0a53d8e3c68e9f1 = {
    prefix: 'fas',
    iconName: 'arrow-up-z-a',
    icon: [
        576,
        512,
        [
            "sort-alpha-up-alt"
        ],
        "f882",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 262.8 428.1 256 416 256zM395.8 400L416 359.6 436.2 400H395.8z"
    ]
};
var $1113a0aa61ab7765$export$95ef20828693fb0f = $1113a0aa61ab7765$export$a0a53d8e3c68e9f1;
var $1113a0aa61ab7765$export$769724fc1434d618 = {
    prefix: 'fas',
    iconName: 'fire-flame-curved',
    icon: [
        384,
        512,
        [
            "fire-alt"
        ],
        "f7e4",
        "M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0C198.4 0 208 9.6 208 21.3V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6C85.9 176 96 186.1 96 198.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7c0-27.7 9-54.8 25.6-76.9z"
    ]
};
var $1113a0aa61ab7765$export$70dc26b4926d0b1b = $1113a0aa61ab7765$export$769724fc1434d618;
var $1113a0aa61ab7765$export$6d274258ba4b0089 = {
    prefix: 'fas',
    iconName: 'tornado',
    icon: [
        448,
        512,
        [
            127786
        ],
        "f76f",
        "M0 32V45.6C0 62.7 1.7 79.6 5 96H357.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32zm352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z"
    ]
};
var $1113a0aa61ab7765$export$430d63b54b1d4009 = {
    prefix: 'fas',
    iconName: 'file-circle-plus',
    icon: [
        576,
        512,
        [
            58606
        ],
        "e494",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 384c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm16-208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
    ]
};
var $1113a0aa61ab7765$export$ad3212bc3fa1595b = {
    prefix: 'fas',
    iconName: 'book-quran',
    icon: [
        448,
        512,
        [
            "quran"
        ],
        "f687",
        "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM274.1 150.2l-8.9 21.4-23.1 1.9c-5.7 .5-8 7.5-3.7 11.2L256 199.8l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9L280 217.2l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9L304 199.8l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8 .7 19 1.9c3.8 .8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7C273.5 71.5 249.6 64 224 64C153.3 64 96 121.3 96 192z"
    ]
};
var $1113a0aa61ab7765$export$46f29ea84ed4c5f1 = $1113a0aa61ab7765$export$ad3212bc3fa1595b;
var $1113a0aa61ab7765$export$12a35719f889cd1 = {
    prefix: 'fas',
    iconName: 'anchor',
    icon: [
        576,
        512,
        [
            9875
        ],
        "f13d",
        "M256 96c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm85.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c88.4 0 160-71.6 160-160v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 53-43 96-96 96H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1z"
    ]
};
var $1113a0aa61ab7765$export$93a5eb721c9c0d25 = {
    prefix: 'fas',
    iconName: 'border-all',
    icon: [
        448,
        512,
        [],
        "f84c",
        "M384 96V224H256V96H384zm0 192V416H256V288H384zM192 224H64V96H192V224zM64 288H192V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $1113a0aa61ab7765$export$67a047c738fb34da = {
    prefix: 'fas',
    iconName: 'face-angry',
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM161.3 382.1c-5.4 12.3 8.7 21.6 21.1 16.4c22.4-9.5 47.4-14.8 73.7-14.8s51.3 5.3 73.7 14.8c12.4 5.2 26.5-4.1 21.1-16.4c-16-36.6-52.4-62.1-94.8-62.1s-78.8 25.6-94.8 62.1zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$3c96c08e234498c5 = $1113a0aa61ab7765$export$67a047c738fb34da;
var $1113a0aa61ab7765$export$317dde8664f7de71 = {
    prefix: 'fas',
    iconName: 'cookie-bite',
    icon: [
        512,
        512,
        [],
        "f564",
        "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 208c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$d2caed5e37174c23 = {
    prefix: 'fas',
    iconName: 'arrow-trend-down',
    icon: [
        576,
        512,
        [],
        "e097",
        "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352H384z"
    ]
};
var $1113a0aa61ab7765$export$7329a1ca27b90c5b = {
    prefix: 'fas',
    iconName: 'rss',
    icon: [
        448,
        512,
        [
            "feed"
        ],
        "f09e",
        "M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM128 416c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$67ad3d0233cd7b33 = $1113a0aa61ab7765$export$7329a1ca27b90c5b;
var $1113a0aa61ab7765$export$df9bd3777d1154d2 = {
    prefix: 'fas',
    iconName: 'draw-polygon',
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1l0 0 32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"
    ]
};
var $1113a0aa61ab7765$export$33fb4280dc20f0dd = {
    prefix: 'fas',
    iconName: 'scale-balanced',
    icon: [
        640,
        512,
        [
            9878,
            "balance-scale"
        ],
        "f24e",
        "M384 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zM125.8 177.3L51.1 320H204.9L130.2 177.3c-.4-.8-1.3-1.3-2.2-1.3s-1.7 .5-2.2 1.3zM128 128c18.8 0 36 10.4 44.7 27l77.8 148.5c3.1 5.8 6.1 14 5.5 23.8c-.7 12.1-4.8 35.2-24.8 55.1C210.9 402.6 178.2 416 128 416s-82.9-13.4-103.2-33.5c-20-20-24.2-43-24.8-55.1c-.6-9.8 2.5-18 5.5-23.8L83.3 155c8.7-16.6 25.9-27 44.7-27zm384 48c-.9 0-1.7 .5-2.2 1.3L435.1 320H588.9L514.2 177.3c-.4-.8-1.3-1.3-2.2-1.3zm-44.7-21c8.7-16.6 25.9-27 44.7-27s36 10.4 44.7 27l77.8 148.5c3.1 5.8 6.1 14 5.5 23.8c-.7 12.1-4.8 35.2-24.8 55.1C594.9 402.6 562.2 416 512 416s-82.9-13.4-103.2-33.5c-20-20-24.2-43-24.8-55.1c-.6-9.8 2.5-18 5.5-23.8L467.3 155z"
    ]
};
var $1113a0aa61ab7765$export$fec323dcfd81d750 = $1113a0aa61ab7765$export$33fb4280dc20f0dd;
var $1113a0aa61ab7765$export$cc4351eb13da27d8 = {
    prefix: 'fas',
    iconName: 'gauge-simple-high',
    icon: [
        512,
        512,
        [
            61668,
            "tachometer",
            "tachometer-fast"
        ],
        "f62a",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM320 352c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $1113a0aa61ab7765$export$362d0f652c3fbca2 = $1113a0aa61ab7765$export$cc4351eb13da27d8;
var $1113a0aa61ab7765$export$375b6a8680f980ed = $1113a0aa61ab7765$export$cc4351eb13da27d8;
var $1113a0aa61ab7765$export$f7f7c15f18cc19a1 = {
    prefix: 'fas',
    iconName: 'shower',
    icon: [
        512,
        512,
        [
            128703
        ],
        "f2cc",
        "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.1-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm64 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0-128c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm64 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0-128c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm64 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm32-32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$6e6ddc253102e596 = {
    prefix: 'fas',
    iconName: 'desktop',
    icon: [
        576,
        512,
        [
            128421,
            61704,
            "desktop-alt"
        ],
        "f390",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"
    ]
};
var $1113a0aa61ab7765$export$ff09a62b9e0fa899 = $1113a0aa61ab7765$export$6e6ddc253102e596;
var $1113a0aa61ab7765$export$bd6a7788954842b5 = {
    prefix: 'fas',
    iconName: 'm',
    icon: [
        448,
        512,
        [
            109
        ],
        "4d",
        "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.2c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V169.7L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 49.9 9.2 37.5 22.7 33.4z"
    ]
};
var $1113a0aa61ab7765$export$6e989c3c7050dbb = {
    prefix: 'fas',
    iconName: 'table-list',
    icon: [
        512,
        512,
        [
            "th-list"
        ],
        "f00b",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z"
    ]
};
var $1113a0aa61ab7765$export$daf2614a457122c0 = $1113a0aa61ab7765$export$6e989c3c7050dbb;
var $1113a0aa61ab7765$export$435fe17e9d6170d6 = {
    prefix: 'fas',
    iconName: 'comment-sms',
    icon: [
        512,
        512,
        [
            "sms"
        ],
        "f7cd",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM202.9 176.8c6.5-2.2 13.7 .1 17.9 5.6L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2zm173.1 38c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.2-.4-23.7-4.4-32.6-7.4l0 0 0 0c-1.4-.5-2.7-.9-4-1.4c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7 .6 3.3 1.1 4.9 1.6l0 0 0 0c9.1 3.1 15.6 5.3 22.6 5.5c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6c-9-5.4-17.7-14.7-17.7-29.4c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c10 .2 19.7 2.3 27.9 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9zm-272 0c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.3-.4-24.2-4.5-33.2-7.6l0 0 0 0c-1.3-.4-2.5-.8-3.6-1.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4 .5 2.7 .9 4 1.4l0 0 0 0 0 0c9.5 3.2 16.5 5.6 23.7 5.8c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4 0 0c-7.2-2.2-16.7-5-24.3-9.6C80.8 239 72.1 229.7 72 215c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c9.5 .1 22.2 2.1 31.1 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9z"
    ]
};
var $1113a0aa61ab7765$export$9dbcc3443daa7323 = $1113a0aa61ab7765$export$435fe17e9d6170d6;
var $1113a0aa61ab7765$export$c9d7ef726d1a8742 = {
    prefix: 'fas',
    iconName: 'book',
    icon: [
        448,
        512,
        [
            128212
        ],
        "f02d",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$4c17261776a709f2 = {
    prefix: 'fas',
    iconName: 'user-plus',
    icon: [
        640,
        512,
        [],
        "f234",
        "M352 128c0 70.7-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $1113a0aa61ab7765$export$62b2c752fccc6a9c = {
    prefix: 'fas',
    iconName: 'check',
    icon: [
        512,
        512,
        [
            10003,
            10004
        ],
        "f00c",
        "M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
var $1113a0aa61ab7765$export$cfb37069d38f379e = {
    prefix: 'fas',
    iconName: 'battery-three-quarters',
    icon: [
        576,
        512,
        [
            "battery-4"
        ],
        "f241",
        "M0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176zm80-16c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zm272 32V320H96V192H352z"
    ]
};
var $1113a0aa61ab7765$export$35ffefed200d123c = $1113a0aa61ab7765$export$cfb37069d38f379e;
var $1113a0aa61ab7765$export$c9382fa3394ef53a = {
    prefix: 'fas',
    iconName: 'house-circle-check',
    icon: [
        640,
        512,
        [],
        "e509",
        "M320.7 351.7C329 262.1 404.3 192 496 192c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V480c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32V383.7c0-17.7 14.3-32 32-32h64l.7 0zM640 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $1113a0aa61ab7765$export$3cbcd1b7e35945d2 = {
    prefix: 'fas',
    iconName: 'angle-left',
    icon: [
        320,
        512,
        [
            8249
        ],
        "f104",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var $1113a0aa61ab7765$export$ff7f40159cadb0ac = {
    prefix: 'fas',
    iconName: 'diagram-successor',
    icon: [
        512,
        512,
        [],
        "e47a",
        "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64z"
    ]
};
var $1113a0aa61ab7765$export$d69fa2b7839ce76 = {
    prefix: 'fas',
    iconName: 'truck-arrow-right',
    icon: [
        640,
        512,
        [],
        "e58b",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm368-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H262.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"
    ]
};
var $1113a0aa61ab7765$export$7df274119d2469d1 = {
    prefix: 'fas',
    iconName: 'arrows-split-up-and-left',
    icon: [
        512,
        512,
        [],
        "e4bc",
        "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64H109.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H224c23.3 0 45.2 6.2 64 17.1V109.3l-41.4 41.4z"
    ]
};
var $1113a0aa61ab7765$export$ca492f58fe30a42f = {
    prefix: 'fas',
    iconName: 'hand-fist',
    icon: [
        384,
        512,
        [
            9994,
            "fist-raised"
        ],
        "f6de",
        "M160 0c17.7 0 32 14.3 32 32V144H128V32c0-17.7 14.3-32 32-32zM32 64c0-17.7 14.3-32 32-32s32 14.3 32 32v80H32V64zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V256c0 52.3-25.1 98.8-64 128v96c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V401.6c-17.3-7.9-33.2-18.8-46.9-32.5L37.5 357.5C13.5 333.5 0 300.9 0 267V240c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
    ]
};
var $1113a0aa61ab7765$export$fa0323a4d7489a8d = $1113a0aa61ab7765$export$ca492f58fe30a42f;
var $1113a0aa61ab7765$export$482eb125aaf0fbc2 = {
    prefix: 'fas',
    iconName: 'cloud-moon',
    icon: [
        640,
        512,
        [],
        "f6c3",
        "M495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-9.3 0-18.4-.7-27.4-1.9c-11.2-22.6-29.8-40.9-52.6-51.7c-2.7-58.5-50.3-105.3-109.2-106.7c-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zM447.9 431.9c0 44.2-35.8 80-80 80H96c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $1113a0aa61ab7765$export$8da450d063b0eb37 = {
    prefix: 'fas',
    iconName: 'briefcase',
    icon: [
        512,
        512,
        [
            128188
        ],
        "f0b1",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"
    ]
};
var $1113a0aa61ab7765$export$e94ab3a30cf4aca5 = {
    prefix: 'fas',
    iconName: 'person-falling',
    icon: [
        512,
        512,
        [],
        "e546",
        "M288 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L304.5 256l87.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320l-96 0h-1.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.2c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32zM112 128c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $1113a0aa61ab7765$export$c23fd8b91a7ed48 = {
    prefix: 'fas',
    iconName: 'image-portrait',
    icon: [
        384,
        512,
        [
            "portrait"
        ],
        "f3e0",
        "M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64l0-384zM256 192c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"
    ]
};
var $1113a0aa61ab7765$export$e3d25f819c7ee7d7 = $1113a0aa61ab7765$export$c23fd8b91a7ed48;
var $1113a0aa61ab7765$export$9eec597148166b36 = {
    prefix: 'fas',
    iconName: 'user-tag',
    icon: [
        640,
        512,
        [],
        "f507",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1v-33c-15.9-4.7-32.8-7.2-50.3-7.2H178.3zM384 224c-17.7 0-32 14.3-32 32v82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7H384zm72 80c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$7cee7480f25f5289 = {
    prefix: 'fas',
    iconName: 'rug',
    icon: [
        640,
        512,
        [],
        "e569",
        "M24 64H56 80V88v88 80 80 88 24H56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V360H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V200H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V112H24C10.7 112 0 101.3 0 88S10.7 64 24 64zm88 0H528V448H112V64zM640 88c0 13.3-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H584 560V424 336 256 176 88 64h24 32c13.3 0 24 10.7 24 24z"
    ]
};
var $1113a0aa61ab7765$export$7adefae4a1be1d97 = {
    prefix: 'fas',
    iconName: 'earth-europe',
    icon: [
        512,
        512,
        [
            "globe-europe"
        ],
        "f7a2",
        "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.6-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $1113a0aa61ab7765$export$5318b8ede86cc96b = $1113a0aa61ab7765$export$7adefae4a1be1d97;
var $1113a0aa61ab7765$export$ab81ff863770d996 = {
    prefix: 'fas',
    iconName: 'cart-flatbed-suitcase',
    icon: [
        640,
        512,
        [
            "luggage-cart"
        ],
        "f59d",
        "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H541.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32zM432 96V56c0-4.4-3.6-8-8-8H344c-4.4 0-8 3.6-8 8V96h96zM288 96V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56V96 320H288V96zM512 320V96h16c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H512zM240 96h16V320H240c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
    ]
};
var $1113a0aa61ab7765$export$bd1e24dd3cde8514 = $1113a0aa61ab7765$export$ab81ff863770d996;
var $1113a0aa61ab7765$export$3896694b3e81fba7 = {
    prefix: 'fas',
    iconName: 'rectangle-xmark',
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $1113a0aa61ab7765$export$eaaf26416a51dc1 = $1113a0aa61ab7765$export$3896694b3e81fba7;
var $1113a0aa61ab7765$export$10147c0014152a3f = $1113a0aa61ab7765$export$3896694b3e81fba7;
var $1113a0aa61ab7765$export$18b7775f78a3e16 = $1113a0aa61ab7765$export$3896694b3e81fba7;
var $1113a0aa61ab7765$export$ffc7123046a28ee = {
    prefix: 'fas',
    iconName: 'baht-sign',
    icon: [
        320,
        512,
        [],
        "e0ac",
        "M144 0c-17.7 0-32 14.3-32 32V64H37.6C16.8 64 0 80.8 0 101.6V224v41.7V288 406.3c0 23 18.7 41.7 41.7 41.7H112v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112V32c0-17.7-14.3-32-32-32zM112 128v96H64V128h48zm64 96V128c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64v96H64V288h48zm64 96V288h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H176z"
    ]
};
var $1113a0aa61ab7765$export$8a3071811b2b7979 = {
    prefix: 'fas',
    iconName: 'book-open',
    icon: [
        576,
        512,
        [
            128214,
            128366
        ],
        "f518",
        "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C87.5 32 35.1 48.6 9 59.9c-5.6 2.4-9 8-9 14V454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V73.9c0-6.1-3.4-11.6-9-14C540.9 48.6 488.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z"
    ]
};
var $1113a0aa61ab7765$export$d3d49030d557a09b = {
    prefix: 'fas',
    iconName: 'book-journal-whills',
    icon: [
        448,
        512,
        [
            "journal-whills"
        ],
        "f66a",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zm90.4-234.4l-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226c2.5 2.1 3.4 5.8 2.3 8.9c-1.3 3-4.1 5.1-7.5 5.1c-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2c-2.2-.1-4.4-1.1-6-2.8c-1.3-1.5-1.9-3.4-2-5.2c.1-2.2 1.1-4.4 2.7-6l37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-10-20.7-26.1-38-46.4-49.2c17 27.1 11 62.8-14 82.6c14.1 14.6 19.1 35.9 13.1 55.2c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6 .4 1.5 .6 2.3 .6c1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4L260 225.4l18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2 .9-2.9 .1-4.1s-2-2-3.5-2l-.1 0c-.7 .1-1.5 .3-2.1 .7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8 .4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2 .6-.5 1.4-.5 2c0 1.1 .5 2.1 1.2 3c.8 .6 1.8 1 2.8 1c.7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-6-19.4-1-40.5 13.1-55.2c-25-19.9-31-55.5-14-82.6c-20.1 11.2-36.4 28.5-46.4 49.2l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"
    ]
};
var $1113a0aa61ab7765$export$66a0d8d45aab6631 = $1113a0aa61ab7765$export$d3d49030d557a09b;
var $1113a0aa61ab7765$export$74d1f89b5feb9d42 = {
    prefix: 'fas',
    iconName: 'handcuffs',
    icon: [
        640,
        512,
        [],
        "e4f8",
        "M304 32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM192 112c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm-32 16c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 320c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96s43 96 96 96zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96zM368 64c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm80 48c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$1cbf6e649ce86166 = {
    prefix: 'fas',
    iconName: 'triangle-exclamation',
    icon: [
        512,
        512,
        [
            9888,
            "exclamation-triangle",
            "warning"
        ],
        "f071",
        "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $1113a0aa61ab7765$export$3d249b63b52cce7c = $1113a0aa61ab7765$export$1cbf6e649ce86166;
var $1113a0aa61ab7765$export$2e470a35c38b096a = $1113a0aa61ab7765$export$1cbf6e649ce86166;
var $1113a0aa61ab7765$export$24680dede86b1883 = {
    prefix: 'fas',
    iconName: 'database',
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z"
    ]
};
var $1113a0aa61ab7765$export$c08b4b0e2b0dc027 = {
    prefix: 'fas',
    iconName: 'share',
    icon: [
        512,
        512,
        [
            "arrow-turn-right",
            "mail-forward"
        ],
        "f064",
        "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"
    ]
};
var $1113a0aa61ab7765$export$f20385ecfa20c36e = $1113a0aa61ab7765$export$c08b4b0e2b0dc027;
var $1113a0aa61ab7765$export$81df7693d3f2f8da = $1113a0aa61ab7765$export$c08b4b0e2b0dc027;
var $1113a0aa61ab7765$export$8f534e1e0ab75bfe = {
    prefix: 'fas',
    iconName: 'bottle-droplet',
    icon: [
        256,
        512,
        [],
        "e4c4",
        "M64 0C50.7 0 40 10.7 40 24s10.7 24 24 24c4.4 0 8 3.6 8 8v64.9c0 12.2-7.2 23.1-17.2 30.1C21.7 174.1 0 212.5 0 256V448c0 35.3 28.7 64 64 64H192c35.3 0 64-28.7 64-64V256c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1V56c0-4.4 3.6-8 8-8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 0 0 0H72l0 0 0 0L64 0zm64 382c-26.5 0-48-20.1-48-45c0-16.8 22.1-48.1 36.3-66.4c6-7.8 17.5-7.8 23.5 0C153.9 288.9 176 320.2 176 337c0 24.9-21.5 45-48 45z"
    ]
};
var $1113a0aa61ab7765$export$140d4da0adbaf435 = {
    prefix: 'fas',
    iconName: 'mask-face',
    icon: [
        640,
        512,
        [],
        "e1d7",
        "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1H144 128 56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H512 496h-9.2c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H96v48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3V176h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    ]
};
var $1113a0aa61ab7765$export$7ec15a32285f6c22 = {
    prefix: 'fas',
    iconName: 'hill-rockslide',
    icon: [
        576,
        512,
        [],
        "e508",
        "M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2H293.4c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9V309.4c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM384 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$a082af56be9786ae = {
    prefix: 'fas',
    iconName: 'right-left',
    icon: [
        512,
        512,
        [
            "exchange-alt"
        ],
        "f362",
        "M32 96l320 0V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64H480z"
    ]
};
var $1113a0aa61ab7765$export$f6c6fb20d374b128 = $1113a0aa61ab7765$export$a082af56be9786ae;
var $1113a0aa61ab7765$export$b5378818301da1be = {
    prefix: 'fas',
    iconName: 'paper-plane',
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"
    ]
};
var $1113a0aa61ab7765$export$79753c2153535b01 = {
    prefix: 'fas',
    iconName: 'road-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e565",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm0-48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $1113a0aa61ab7765$export$1156dc6acb0058bd = {
    prefix: 'fas',
    iconName: 'dungeon',
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3c9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4C430 66.6 410.9 50.6 389.7 37.6c-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1 .2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4C185.5 9.4 178.8 24 184 36.8l30.3 75.8c4.5 11.3 16.8 17.2 29 16c4.2-.4 8.4-.6 12.7-.6s8.6 .2 12.7 .6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6c1.3-1.1 2.6-2.3 4-3.3c9.3-7.5 13.9-20.1 9.5-31.2L154.4 49.2c-5.2-12.9-20.3-18.8-32.1-11.6C101.1 50.6 82 66.6 65.5 85zm314 137.1c.9 3.3 1.7 6.6 2.3 10c2.5 13 13 23.9 26.2 23.9h80c13.3 0 24.1-10.8 22.9-24c-2.5-27.2-9.3-53.2-19.7-77.3c-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24h80c13.3 0 23.8-10.8 26.2-23.9c.6-3.4 1.4-6.7 2.3-10c3.1-11.4-.2-24-10-30.5L53.9 145.8zM104 288H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H408zM24 416c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H24zm384 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H408zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"
    ]
};
var $1113a0aa61ab7765$export$7370f36a39a38737 = {
    prefix: 'fas',
    iconName: 'align-right',
    icon: [
        448,
        512,
        [],
        "f038",
        "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $1113a0aa61ab7765$export$52e3e96cd1564779 = {
    prefix: 'fas',
    iconName: 'money-bill-1-wave',
    icon: [
        576,
        512,
        [
            "money-bill-wave-alt"
        ],
        "f53b",
        "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM128 416H64V352c35.3 0 64 28.7 64 64zM64 224V160h64c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 208c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
    ]
};
var $1113a0aa61ab7765$export$1613858e873cbb3e = $1113a0aa61ab7765$export$52e3e96cd1564779;
var $1113a0aa61ab7765$export$53dd2cacf674142a = {
    prefix: 'fas',
    iconName: 'life-ring',
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm91 .5c33.7-43.3 53.8-97.8 53.8-157s-20.1-113.6-53.8-157l12.4-12.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L413 53.8C369.6 20.1 315.2 0 256 0S142.4 20.1 99 53.8L86.6 41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L53.8 99C20.1 142.4 0 196.8 0 256s20.1 113.6 53.8 157L41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L99 458.2c43.3 33.7 97.8 53.8 157 53.8s113.6-20.1 157-53.8l12.4 12.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L458.2 413zm-45.7-45.7l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM304 256c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48z"
    ]
};
var $1113a0aa61ab7765$export$f9712d0cf5150f0c = {
    prefix: 'fas',
    iconName: 'hands',
    icon: [
        512,
        512,
        [
            "sign-language",
            "signing"
        ],
        "f2a7",
        "M154.9 162c.3 .7 .7 1.5 1.1 2.2l17.8 30.9c11.1-12.6 27.4-19.8 44.4-19.1l-20.7-35.8c-6.6-11.5-21.3-15.4-32.8-8.8c-10.8 6.2-14.9 19.5-9.9 30.6zm173.6 47C399.7 231.7 448 297.8 448 372.5c0 1.5 0 3-.1 4.5c39.7-25.6 64.1-69.7 64.1-117.4V136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 81.7L347.8 16.5C341.2 5 326.5 1.1 315.1 7.7s-15.4 21.3-8.8 32.8l64 110.9c2.2 3.8 .9 8.7-2.9 10.9s-8.7 .9-10.9-2.9l-80-138.6C269.8 9.3 255.1 5.4 243.6 12s-15.4 21.3-8.8 32.8l80 138.6c2.2 3.8 .9 8.7-2.9 10.9s-8.7 .9-10.9-2.9L237 80.5c-6.6-11.5-21.3-15.4-32.8-8.8s-15.4 21.3-8.8 32.8l44 76.2L328.5 209zM64 488c0 12.4 9.4 22.6 21.5 23.9c.8 .1 1.6 .1 2.5 .1H288.7 296c66.3 0 120-53.7 120-120c0-1.2 0-2.4-.1-3.6c0-1.2 .1-2.5 .1-3.7c0-68-44-128.2-108.9-148.9l-83.9-26.7c-12.6-4-26.1 3-30.1 15.6s3 26.1 15.6 30.1L262.6 272H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H184c4.4 0 8 3.6 8 8s-3.6 8-8 8H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H184c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H184c4.4 0 8 3.6 8 8s-3.6 8-8 8H88c-13.3 0-24 10.7-24 24z"
    ]
};
var $1113a0aa61ab7765$export$20993813350f9671 = $1113a0aa61ab7765$export$f9712d0cf5150f0c;
var $1113a0aa61ab7765$export$5cc0e6f5191f4f02 = $1113a0aa61ab7765$export$f9712d0cf5150f0c;
var $1113a0aa61ab7765$export$80968bcfef6481ca = {
    prefix: 'fas',
    iconName: 'calendar-day',
    icon: [
        448,
        512,
        [],
        "f783",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    ]
};
var $1113a0aa61ab7765$export$5930e9bdfd790d77 = {
    prefix: 'fas',
    iconName: 'water-ladder',
    icon: [
        576,
        512,
        [
            "ladder-water",
            "swimming-pool"
        ],
        "f5c5",
        "M128 127.7C128 74.9 170.9 32 223.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V224H384V127.7C384 74.9 426.9 32 479.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V361c-1.6 1-3.3 2-4.8 3.1c-18 12.4-40.1 20.3-59.2 20.3h0V288H192v96.5c-19 0-41.2-7.9-59.1-20.3c-1.6-1.1-3.2-2.2-4.9-3.1V127.7zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $1113a0aa61ab7765$export$c5ea6eeef2db2b3b = $1113a0aa61ab7765$export$5930e9bdfd790d77;
var $1113a0aa61ab7765$export$4dee691631c67d5c = $1113a0aa61ab7765$export$5930e9bdfd790d77;
var $1113a0aa61ab7765$export$64185f27d82c259f = {
    prefix: 'fas',
    iconName: 'arrows-up-down',
    icon: [
        320,
        512,
        [
            "arrows-v"
        ],
        "f07d",
        "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
    ]
};
var $1113a0aa61ab7765$export$cec5f1bc9e068e48 = $1113a0aa61ab7765$export$64185f27d82c259f;
var $1113a0aa61ab7765$export$bd5bd2ef56b793b1 = {
    prefix: 'fas',
    iconName: 'face-grimace',
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm96-112h-8V360l55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344V304h8c23.8 0 43.5 17.3 47.3 40zM328 344H264V304h64v40zm0 56H264V360h64v40zm-80-96v40l-64 0V304h64zm0 56v40H184V360l64 0zm-80-16H112.7c3.8-22.7 23.6-40 47.3-40h8v40zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168v40zm40.4-192c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$3d08cd36ac1ef231 = $1113a0aa61ab7765$export$bd5bd2ef56b793b1;
var $1113a0aa61ab7765$export$1482162f7fe04ac = {
    prefix: 'fas',
    iconName: 'wheelchair-move',
    icon: [
        448,
        512,
        [
            "wheelchair-alt"
        ],
        "e2ce",
        "M416 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288H306.7c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96s43 96 96 96z"
    ]
};
var $1113a0aa61ab7765$export$7db9460785019040 = $1113a0aa61ab7765$export$1482162f7fe04ac;
var $1113a0aa61ab7765$export$b5dc9dd0347bbb6 = {
    prefix: 'fas',
    iconName: 'turn-down',
    icon: [
        384,
        512,
        [
            10549,
            "level-down-alt"
        ],
        "f3be",
        "M178.3 506.3L40.3 368.3C35 363 32 355.8 32 348.3C32 332.7 44.7 320 60.3 320H144V112c0-8.8-7.2-16-16-16H32C14.3 96 0 81.7 0 64V32C0 14.3 14.3 0 32 0h96c61.9 0 112 50.1 112 112V320h83.7c15.6 0 28.3 12.7 28.3 28.3c0 7.5-3 14.7-8.3 20L205.7 506.3C202 510 197.1 512 192 512s-10-2-13.7-5.7z"
    ]
};
var $1113a0aa61ab7765$export$c07eb6ff5a382cbd = $1113a0aa61ab7765$export$b5dc9dd0347bbb6;
var $1113a0aa61ab7765$export$3e15790fe68c095b = {
    prefix: 'fas',
    iconName: 'person-walking-arrow-right',
    icon: [
        640,
        512,
        [],
        "e552",
        "M208 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"
    ]
};
var $1113a0aa61ab7765$export$15da4ef8c0fb20d6 = {
    prefix: 'fas',
    iconName: 'square-envelope',
    icon: [
        448,
        512,
        [
            "envelope-square"
        ],
        "f199",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"
    ]
};
var $1113a0aa61ab7765$export$354e159473e73552 = $1113a0aa61ab7765$export$15da4ef8c0fb20d6;
var $1113a0aa61ab7765$export$4ed8206e6619cc8f = {
    prefix: 'fas',
    iconName: 'dice',
    icon: [
        640,
        512,
        [
            127922
        ],
        "f522",
        "M252.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-184 184c-15.6 15.6-15.6 40.9 0 56.6l184 184c15.6 15.6 40.9 15.6 56.6 0l184-184c15.6-15.6 15.6-40.9 0-56.6l-184-184zM248 224c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zM96 248c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm128 80c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm128-80c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zM224 72c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm96 392c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H472.5c13.4 26.9 8.8 60.5-13.6 82.9L320 413.8V464zm160-88c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $1113a0aa61ab7765$export$5ee2640fe105312d = {
    prefix: 'fas',
    iconName: 'bowling-ball',
    icon: [
        512,
        512,
        [],
        "f436",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM240 144c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm32 64c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$97fa4f4c1006ab1 = {
    prefix: 'fas',
    iconName: 'brain',
    icon: [
        512,
        512,
        [
            129504
        ],
        "f5dc",
        "M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z"
    ]
};
var $1113a0aa61ab7765$export$658a137d3845bca7 = {
    prefix: 'fas',
    iconName: 'bandage',
    icon: [
        640,
        512,
        [
            129657,
            "band-aid"
        ],
        "f462",
        "M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM296 208c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zm72 24c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm-72 72c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zm72 24c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $1113a0aa61ab7765$export$b14a1014df2fdf46 = $1113a0aa61ab7765$export$658a137d3845bca7;
var $1113a0aa61ab7765$export$23e8b4955c2d951b = {
    prefix: 'fas',
    iconName: 'calendar-minus',
    icon: [
        448,
        512,
        [],
        "f272",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM312 376c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-13.3 0-24 10.7-24 24s10.7 24 24 24H312z"
    ]
};
var $1113a0aa61ab7765$export$30262489773a79a3 = {
    prefix: 'fas',
    iconName: 'circle-xmark',
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $1113a0aa61ab7765$export$ab0ec50720a747eb = $1113a0aa61ab7765$export$30262489773a79a3;
var $1113a0aa61ab7765$export$90ac4096df8efdee = $1113a0aa61ab7765$export$30262489773a79a3;
var $1113a0aa61ab7765$export$de9a67b55dbe819a = {
    prefix: 'fas',
    iconName: 'gifts',
    icon: [
        640,
        512,
        [],
        "f79c",
        "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H200.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96H217.8l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v80H416V256h32v96H640V272c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 464c0 26.5 21.5 48 48 48H416V384H224v80zm224 48H592c26.5 0 48-21.5 48-48V384H448V512zm96-312c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"
    ]
};
var $1113a0aa61ab7765$export$c402efcf01d5ca07 = {
    prefix: 'fas',
    iconName: 'hotel',
    icon: [
        512,
        512,
        [
            127976
        ],
        "f594",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H208V448h96v64H480c17.7 0 32-14.3 32-32s-14.3-32-32-32V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V112zM368 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM96 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208zm144-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V208zm-3 152.2c3.3 12.8-7.8 23.8-21 23.8H184c-13.3 0-24.3-10.9-21-23.8c10.6-41.5 48.2-72.2 93-72.2s82.5 30.7 93 72.2z"
    ]
};
var $1113a0aa61ab7765$export$807cdd395fe012cb = {
    prefix: 'fas',
    iconName: 'earth-asia',
    icon: [
        512,
        512,
        [
            127759,
            "globe-asia"
        ],
        "f57e",
        "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM144.5 348.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"
    ]
};
var $1113a0aa61ab7765$export$796fdfc909e603f4 = $1113a0aa61ab7765$export$807cdd395fe012cb;
var $1113a0aa61ab7765$export$31e6961064ddac7b = {
    prefix: 'fas',
    iconName: 'id-card-clip',
    icon: [
        576,
        512,
        [
            "id-card-alt"
        ],
        "f47f",
        "M256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM64 64H192v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64z"
    ]
};
var $1113a0aa61ab7765$export$dc37ebbac31f6c6c = $1113a0aa61ab7765$export$31e6961064ddac7b;
var $1113a0aa61ab7765$export$f48a3ba52a0a9e56 = {
    prefix: 'fas',
    iconName: 'magnifying-glass-plus',
    icon: [
        512,
        512,
        [
            "search-plus"
        ],
        "f00e",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
    ]
};
var $1113a0aa61ab7765$export$378f00e6b1a8185 = $1113a0aa61ab7765$export$f48a3ba52a0a9e56;
var $1113a0aa61ab7765$export$47e4e0d519d33497 = {
    prefix: 'fas',
    iconName: 'thumbs-up',
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 25.3-19.5 46-44.3 47.9c7.7 8.5 12.3 19.8 12.3 32.1c0 23.4-16.8 42.9-38.9 47.1c4.4 7.2 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$b00596a09aa07311 = {
    prefix: 'fas',
    iconName: 'user-clock',
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M224 256c-70.7 0-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128s-57.3 128-128 128zm-45.7 48h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM640 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM496 288c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"
    ]
};
var $1113a0aa61ab7765$export$8846d49caaed1c0a = {
    prefix: 'fas',
    iconName: 'hand-dots',
    icon: [
        512,
        512,
        [
            "allergies"
        ],
        "f461",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zM272 336c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm48 48c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm80-48c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zM352 448c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm-80-16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm-80-16c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16z"
    ]
};
var $1113a0aa61ab7765$export$dcae2101babbffff = $1113a0aa61ab7765$export$8846d49caaed1c0a;
var $1113a0aa61ab7765$export$bef39294aed2281a = {
    prefix: 'fas',
    iconName: 'file-invoice',
    icon: [
        384,
        512,
        [],
        "f570",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $1113a0aa61ab7765$export$26a3f9d2784b90d8 = {
    prefix: 'fas',
    iconName: 'window-minimize',
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $1113a0aa61ab7765$export$60048819854688c5 = {
    prefix: 'fas',
    iconName: 'mug-saucer',
    icon: [
        640,
        512,
        [
            "coffee"
        ],
        "f0f4",
        "M96 64c0-17.7 14.3-32 32-32H448h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H480c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zM480 224h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H480V224zM32 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$1d24a9e457278011 = $1113a0aa61ab7765$export$60048819854688c5;
var $1113a0aa61ab7765$export$5824ffe6f8983c83 = {
    prefix: 'fas',
    iconName: 'brush',
    icon: [
        384,
        512,
        [],
        "f55d",
        "M192 64L160 0H128L96 64 64 0H48C21.5 0 0 21.5 0 48V256H384V48c0-26.5-21.5-48-48-48H224L192 64zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V288H0zM192 464c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16z"
    ]
};
var $1113a0aa61ab7765$export$7b028758c03b9655 = {
    prefix: 'fas',
    iconName: 'mask',
    icon: [
        576,
        512,
        [],
        "f6fa",
        "M288 64C64 64 0 160 0 272S80 448 176 448h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4H400c96 0 176-64 176-176s-64-208-288-208zM224 256c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm192 64c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z"
    ]
};
var $1113a0aa61ab7765$export$56d810b9ab2e30bc = {
    prefix: 'fas',
    iconName: 'magnifying-glass-minus',
    icon: [
        512,
        512,
        [
            "search-minus"
        ],
        "f010",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"
    ]
};
var $1113a0aa61ab7765$export$efca97eef6a7a17d = $1113a0aa61ab7765$export$56d810b9ab2e30bc;
var $1113a0aa61ab7765$export$a6ad5df9d9f29553 = {
    prefix: 'fas',
    iconName: 'ruler-vertical',
    icon: [
        256,
        512,
        [],
        "f548",
        "M0 48C0 21.5 21.5 0 48 0H208c26.5 0 48 21.5 48 48V96H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
    ]
};
var $1113a0aa61ab7765$export$50a28538498238f = {
    prefix: 'fas',
    iconName: 'user-large',
    icon: [
        512,
        512,
        [
            "user-alt"
        ],
        "f406",
        "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0S112 64.5 112 144s64.5 144 144 144zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H481.3c17 0 30.7-13.8 30.7-30.7C512 392.2 439.8 320 350.7 320H161.3z"
    ]
};
var $1113a0aa61ab7765$export$ae9b19c2ac726cfc = $1113a0aa61ab7765$export$50a28538498238f;
var $1113a0aa61ab7765$export$d401d4aeba21cdf3 = {
    prefix: 'fas',
    iconName: 'train-tram',
    icon: [
        448,
        512,
        [
            128650
        ],
        "e5b4",
        "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0H361.2c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.7 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15H248V96h40c53 0 96 43 96 96V352c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1H365.3c-8.5 0-16.6-3.4-22.6-9.4L288 448H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352V192c0-53 43-96 96-96h40V48H86.8zM160 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160zm32 192c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm96 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $1113a0aa61ab7765$export$ab9af5aa013d2162 = {
    prefix: 'fas',
    iconName: 'user-nurse',
    icon: [
        448,
        512,
        [],
        "f82f",
        "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80V160H144v16zM129.1 323.2l83.2 88.4c6.3 6.7 17 6.7 23.3 0l83.2-88.4c73.7 14.9 129.1 80 129.1 158.1c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-78.1 55.5-143.2 129.1-158.1zM208 48V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"
    ]
};
var $1113a0aa61ab7765$export$1aa9423ec6b1d609 = {
    prefix: 'fas',
    iconName: 'syringe',
    icon: [
        512,
        512,
        [
            128137
        ],
        "f48e",
        "M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4H97.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V325.3c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"
    ]
};
var $1113a0aa61ab7765$export$dcaadfd9c98e42a1 = {
    prefix: 'fas',
    iconName: 'cloud-sun',
    icon: [
        640,
        512,
        [
            9925
        ],
        "f6c4",
        "M122.4 1.2C127.6-.9 133.4-.2 137.9 3l70.3 50.3L278.5 3c4.5-3.2 10.3-3.9 15.4-1.8s8.8 6.7 9.7 12.2l14.1 85.3L403 112.8c5.4 .9 10.1 4.6 12.2 9.7s1.4 10.9-1.8 15.4l-38.8 54.3c-2.2-.1-4.3-.2-6.5-.2c-23.2 0-45 6.2-63.8 17c.1-12.5-2.2-25.3-7.3-37.6c-20.3-49-76.4-72.2-125.4-52s-72.2 76.4-52 125.4c18.3 44.3 66 67.5 111.1 56.6c-36.3 18.2-62.8 53.3-69.1 94.9l-23.6 16.9c-4.5 3.2-10.3 3.9-15.4 1.8s-8.8-6.7-9.7-12.2L98.7 317.7 13.4 303.6c-5.5-.9-10.1-4.6-12.2-9.7S-.2 282.9 3 278.5l50.3-70.3L3 137.9c-3.2-4.5-3.9-10.3-1.8-15.4s6.7-8.8 12.2-9.7L98.7 98.7l14.1-85.3c.9-5.5 4.6-10.1 9.7-12.2zM149 232.7c-13.5-32.7 2-70.1 34.6-83.6s70.1 2 83.6 34.6s-2 70.1-34.6 83.6s-70.1-2-83.6-34.6zM639.9 431.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $1113a0aa61ab7765$export$df6244b0501f2112 = {
    prefix: 'fas',
    iconName: 'stopwatch-20',
    icon: [
        448,
        512,
        [],
        "e06f",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176zM288 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52V256c0-28.7 23.3-52 52-52zm-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12V256c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20H128c-11 0-20-9-20-20V368.3c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z"
    ]
};
var $1113a0aa61ab7765$export$7ec6541fee081990 = {
    prefix: 'fas',
    iconName: 'square-full',
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M0 0H512V512H0V0z"
    ]
};
var $1113a0aa61ab7765$export$78932e9c9abea6b7 = {
    prefix: 'fas',
    iconName: 'magnet',
    icon: [
        448,
        512,
        [
            129522
        ],
        "f076",
        "M0 160v96C0 379.7 100.3 480 224 480s224-100.3 224-224V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H0zm0-32H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64zm320 0H448V64c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32v64z"
    ]
};
var $1113a0aa61ab7765$export$53583b459a87a01 = {
    prefix: 'fas',
    iconName: 'jar',
    icon: [
        320,
        512,
        [],
        "e516",
        "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z"
    ]
};
var $1113a0aa61ab7765$export$4a4e034527c933f5 = {
    prefix: 'fas',
    iconName: 'note-sticky',
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H288V368c0-26.5 21.5-48 48-48H448V96c0-35.3-28.7-64-64-64H64zM448 352H402.7 336c-8.8 0-16 7.2-16 16v66.7V480l32-32 64-64 32-32z"
    ]
};
var $1113a0aa61ab7765$export$80889adc5d98bf4a = $1113a0aa61ab7765$export$4a4e034527c933f5;
var $1113a0aa61ab7765$export$fc4dd5feed8df23 = {
    prefix: 'fas',
    iconName: 'bug-slash',
    icon: [
        640,
        512,
        [],
        "e490",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H479.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160H264c-8.3 0-16.3 1-24 2.8L38.8 5.1zM320 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H387.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96zM160.3 256H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V335.5L166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7zM336 479.2c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7V479.2z"
    ]
};
var $1113a0aa61ab7765$export$1a093e7861c5e48f = {
    prefix: 'fas',
    iconName: 'arrow-up-from-water-pump',
    icon: [
        576,
        512,
        [],
        "e4b6",
        "M112 0C85.5 0 64 21.5 64 48V256H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400V304c0-26.5-21.5-48-48-48H480l0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256H288V48c0-26.5-21.5-48-48-48H112zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $1113a0aa61ab7765$export$5902c007d5703f2d = {
    prefix: 'fas',
    iconName: 'bone',
    icon: [
        576,
        512,
        [
            129460
        ],
        "f5d7",
        "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2H384c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z"
    ]
};
var $1113a0aa61ab7765$export$c950c1ba7f227d5b = {
    prefix: 'fas',
    iconName: 'user-injured',
    icon: [
        448,
        512,
        [],
        "f728",
        "M240 80H342.7c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7V512H243.7L181.5 408.2 124 312.4zm33-7.2L204.3 384H272c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48H223.5l57.1 95.2C303 507.2 320 487.6 320 464z"
    ]
};
var $1113a0aa61ab7765$export$8a5a0dbb2a17e253 = {
    prefix: 'fas',
    iconName: 'face-sad-tear',
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM303.6 208c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm-128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$4b5241926f692f91 = $1113a0aa61ab7765$export$8a5a0dbb2a17e253;
var $1113a0aa61ab7765$export$f654c69e66b466c0 = {
    prefix: 'fas',
    iconName: 'plane',
    icon: [
        576,
        512,
        [],
        "f072",
        "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"
    ]
};
var $1113a0aa61ab7765$export$51adfe7c9ee4f428 = {
    prefix: 'fas',
    iconName: 'tent-arrows-down',
    icon: [
        576,
        512,
        [],
        "e581",
        "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V146.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $1113a0aa61ab7765$export$de6218b649cbb6a9 = {
    prefix: 'fas',
    iconName: 'exclamation',
    icon: [
        128,
        512,
        [
            10069,
            10071,
            61738
        ],
        "21",
        "M96 64c0-17.7-14.3-32-32-32S32 46.3 32 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM64 480c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40z"
    ]
};
var $1113a0aa61ab7765$export$7e05388be208e313 = {
    prefix: 'fas',
    iconName: 'arrows-spin',
    icon: [
        448,
        512,
        [],
        "e4bb",
        "M224 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H416c8.8 0 16-7.2 16-16V64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C331.4 52.6 280.1 32 224 32c-10.9 0-21.5 .8-32 2.3V99.2c10.3-2.1 21-3.2 32-3.2zM100.1 154.7l32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V64c0-8.8-7.2-16-16-16H32c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C20.6 148.6 0 199.9 0 256c0 10.9 .8 21.5 2.3 32H67.2c-2.1-10.3-3.2-21-3.2-32c0-38.4 13.5-73.7 36.1-101.3zM445.7 224H380.8c2.1 10.3 3.2 21 3.2 32c0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V448c0 8.8 7.2 16 16 16H416c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C427.4 363.4 448 312.1 448 256c0-10.9-.8-21.5-2.3-32zM224 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H32c-8.8 0-16 7.2-16 16l0 112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C116.6 459.4 167.9 480 224 480c10.9 0 21.5-.8 32-2.3V412.8c-10.3 2.1-21 3.2-32 3.2z"
    ]
};
var $1113a0aa61ab7765$export$ae64371e02ee8e56 = {
    prefix: 'fas',
    iconName: 'print',
    icon: [
        512,
        512,
        [
            128424,
            128438,
            9113
        ],
        "f02f",
        "M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zm-16-88c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $1113a0aa61ab7765$export$b458d393151b6960 = {
    prefix: 'fas',
    iconName: 'turkish-lira-sign',
    icon: [
        448,
        512,
        [
            "try",
            "turkish-lira"
        ],
        "e2bb",
        "M128 32c17.7 0 32 14.3 32 32V99.3L279.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L160 165.9v29.4l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L160 261.9V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C410.5 399.8 326.1 480 223.8 480H128c-17.7 0-32-14.3-32-32V280.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L96 213.6V184.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L96 117.6V64c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$970dda513e46c41f = $1113a0aa61ab7765$export$b458d393151b6960;
var $1113a0aa61ab7765$export$40e66e5966827199 = $1113a0aa61ab7765$export$b458d393151b6960;
var $1113a0aa61ab7765$export$fb420d3e4d8c6a18 = {
    prefix: 'fas',
    iconName: 'dollar-sign',
    icon: [
        320,
        512,
        [
            128178,
            61781,
            "dollar",
            "usd"
        ],
        "24",
        "M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c10.6 1.6 42.1 6.7 55.1 10c17.1 4.3 27.5 21.7 23.2 38.9s-21.7 27.5-38.9 23.2c-9.3-2.4-37.6-7-48.9-8.7c-32.1-4.8-59.6-2.4-78.5 4.9c-18.3 7-25.9 16.9-27.9 28c-1.9 10.7-.5 16.8 1.3 20.6c1.9 4 5.6 8.5 12.9 13.4c16.2 10.8 41.1 17.9 73.3 26.7l2.8 .8c28.4 7.7 63.2 17.2 89 34.3c14.1 9.4 27.3 22.1 35.5 39.7c8.3 17.8 10.1 37.8 6.3 59.1c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.2-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.4 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.7 .5-16.8-1.3-20.6c-1.9-4-5.6-8.5-12.9-13.4c-16.2-10.8-41.1-17.9-73.3-26.7l-2.8-.8c-28.4-7.7-63.2-17.2-89-34.3c-14.1-9.4-27.3-22.1-35.5-39.7c-8.3-17.8-10.1-37.8-6.3-59.1C25 114.1 53 89.3 86 76.7c13-5 27.2-8.2 42-10V32c0-17.7 14.3-32 32-32z"
    ]
};
var $1113a0aa61ab7765$export$a4ffb0775547fcdf = $1113a0aa61ab7765$export$fb420d3e4d8c6a18;
var $1113a0aa61ab7765$export$72cca07d38a28589 = $1113a0aa61ab7765$export$fb420d3e4d8c6a18;
var $1113a0aa61ab7765$export$476af662c0c32cbc = {
    prefix: 'fas',
    iconName: 'x',
    icon: [
        384,
        512,
        [
            120
        ],
        "58",
        "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
    ]
};
var $1113a0aa61ab7765$export$fa4f1ead37dc1dce = {
    prefix: 'fas',
    iconName: 'magnifying-glass-dollar',
    icon: [
        512,
        512,
        [
            "search-dollar"
        ],
        "f688",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"
    ]
};
var $1113a0aa61ab7765$export$65b49a6767630708 = $1113a0aa61ab7765$export$fa4f1ead37dc1dce;
var $1113a0aa61ab7765$export$3a18218720110fc0 = {
    prefix: 'fas',
    iconName: 'users-gear',
    icon: [
        640,
        512,
        [
            "users-cog"
        ],
        "f509",
        "M144 160c44.2 0 80-35.8 80-80s-35.8-80-80-80S64 35.8 64 80s35.8 80 80 80zm368 0c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6v-21c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3L449.6 457c8.9 7.6 19.2 13.6 30.4 17.6v21c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM552 384c0 22.1-17.9 40-40 40s-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40z"
    ]
};
var $1113a0aa61ab7765$export$5e0b06753fc69b81 = $1113a0aa61ab7765$export$3a18218720110fc0;
var $1113a0aa61ab7765$export$50b6dcaa9ec03439 = {
    prefix: 'fas',
    iconName: 'person-military-pointing',
    icon: [
        576,
        512,
        [],
        "e54a",
        "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25H400c8.8 0 16-7.2 16-16V17.4C416 8 408 .7 398.7 1.4L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H241.6c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40H224v89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5H240 72zm345.7 20.9L246.6 416H416V369.7l53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V448H224z"
    ]
};
var $1113a0aa61ab7765$export$a411e7e26cb63d5e = {
    prefix: 'fas',
    iconName: 'building-columns',
    icon: [
        512,
        512,
        [
            "bank",
            "institution",
            "museum",
            "university"
        ],
        "f19c",
        "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8.1-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zm128-96c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $1113a0aa61ab7765$export$6e379b829ea8b99 = $1113a0aa61ab7765$export$a411e7e26cb63d5e;
var $1113a0aa61ab7765$export$1dba320226a34c1f = $1113a0aa61ab7765$export$a411e7e26cb63d5e;
var $1113a0aa61ab7765$export$9b3953adff472ad2 = $1113a0aa61ab7765$export$a411e7e26cb63d5e;
var $1113a0aa61ab7765$export$f2e1460ebe1a8cb0 = $1113a0aa61ab7765$export$a411e7e26cb63d5e;
var $1113a0aa61ab7765$export$9ff64ffae70e08c0 = {
    prefix: 'fas',
    iconName: 'umbrella',
    icon: [
        640,
        512,
        [],
        "f0e9",
        "M320 0c17.7 0 32 14.3 32 32V49.7C483.8 63.4 589.7 161 605.9 285.9c2 15.6-17.3 24.4-27.8 12.7C564.1 283 536.8 272 512 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C391 299.5 358.7 272 320 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C199 299.5 166.7 272 128 272c-24.8 0-52.1 11-66.1 26.7c-10.5 11.7-29.8 2.9-27.8-12.7C50.3 161 156.2 63.4 288 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"
    ]
};
var $1113a0aa61ab7765$export$12ca996a6f686fe1 = {
    prefix: 'fas',
    iconName: 'trowel',
    icon: [
        512,
        512,
        [],
        "e589",
        "M343.9 213.4L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"
    ]
};
var $1113a0aa61ab7765$export$56c73b799aac2555 = {
    prefix: 'fas',
    iconName: 'd',
    icon: [
        384,
        512,
        [
            100
        ],
        "44",
        "M0 64C0 46.3 14.3 32 32 32H160c123.7 0 224 100.3 224 224s-100.3 224-224 224H32c-17.7 0-32-14.3-32-32V64zM64 96V416h96c88.4 0 160-71.6 160-160s-71.6-160-160-160H64z"
    ]
};
var $1113a0aa61ab7765$export$c7e014b7e3ac3d83 = {
    prefix: 'fas',
    iconName: 'stapler',
    icon: [
        640,
        512,
        [],
        "e5af",
        "M640 299.3V304 432c0 26.5-21.5 48-48 48H512 448 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448V368H96c-17.7 0-32-14.3-32-32V219.4L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304V288L128 230.9V304H448z"
    ]
};
var $1113a0aa61ab7765$export$bf5896cc1ce4d55 = {
    prefix: 'fas',
    iconName: 'masks-theater',
    icon: [
        640,
        512,
        [
            127917,
            "theater-masks"
        ],
        "f630",
        "M399.3 509.7c-58.2-8.8-108.2-72.8-137.6-119.7c-20-31.9-25.1-70.3-19.6-107.7L266.3 118c1.4-9.8 5.1-19.2 12.9-25.2c20.2-15.6 72.4-41.5 185.1-24.5s155.2 57.4 170 78.3c5.7 8 6.5 18.1 5.1 27.9L615.2 338.8c-5.5 37.3-21.5 72.6-49.8 97.2c-41.7 36.1-108 82.5-166.1 73.7zm17.1-277.7c.1-.5 .2-1.1 .3-1.6c3.2-21.8-11.6-42-33.1-45.3s-41.5 11.8-44.7 33.5c-.1 .5-.1 1.1-.2 1.6c-.6 5.4 5.2 8.4 10.3 6.7c9-3 18.8-3.9 28.7-2.4s19.1 5.3 26.8 10.8c4.4 3.1 10.8 2 11.8-3.3zm112.6 22.2c4.4 3.1 10.8 2 11.8-3.3c.1-.5 .2-1.1 .3-1.6c3.2-21.8-11.6-42-33.1-45.3s-41.5 11.8-44.7 33.5c-.1 .5-.1 1.1-.2 1.6c-.6 5.4 5.2 8.4 10.3 6.7c9-3 18.8-3.9 28.7-2.4s19.1 5.3 26.8 10.8zm-11.5 85.2c-28.8 12.8-61.4 17.8-94.9 12.8s-63.2-19.5-87-40.3c-6.3-5.5-16.2-1.7-15.2 6.7c5.9 48.5 43 89.1 93 96.7s97.2-20.2 116.8-64.9c3.4-7.7-5-14.3-12.6-10.9zM240.7 446.9c-58.2 8.8-124.5-37.5-166.1-73.7c-28.3-24.5-44.3-59.8-49.8-97.2L.6 111.8C-.8 102 0 91.9 5.7 83.9C20.5 63 63 22.7 175.7 5.6s164.9 8.9 185.1 24.5c.9 .7 1.7 1.4 2.4 2.1c-52.8 4.8-85.1 21-103.6 35.3c-17 13.1-23 32-25 45.9L215.3 244.7c-2.6 .1-5.2 .4-7.9 .8c-35.2 5.3-61.8 32.7-68.2 66.3c-1.6 8.2 8.3 12.2 14.8 7c15.6-12.4 34.1-21.3 54.7-25.4c-3 38.4 4 78.7 25.9 113.6c6.9 11 15 23.1 24.2 35.4c-5.9 2.1-11.9 3.6-18 4.5zM174.1 157c-1-5.3-7.4-6.4-11.8-3.3c-7.7 5.5-16.8 9.3-26.8 10.8s-19.8 .6-28.7-2.4c-5.1-1.7-10.9 1.3-10.3 6.7c.1 .5 .1 1.1 .2 1.6c3.2 21.8 23.2 36.8 44.7 33.5s36.3-23.5 33.1-45.3c-.1-.5-.2-1.1-.3-1.6z"
    ]
};
var $1113a0aa61ab7765$export$3dbedc487b0159ac = $1113a0aa61ab7765$export$bf5896cc1ce4d55;
var $1113a0aa61ab7765$export$a6df39524c41472c = {
    prefix: 'fas',
    iconName: 'kip-sign',
    icon: [
        384,
        512,
        [],
        "e1c4",
        "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H182.5L340.8 88.3z"
    ]
};
var $1113a0aa61ab7765$export$b276ec3dc9760d39 = {
    prefix: 'fas',
    iconName: 'hand-point-left',
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0V96L32 96zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm-64-64c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32H352c88.4 0 160-71.6 160-160V226.3c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64v88c0 22.1 17.9 40 40 40s40-17.9 40-40V160c0-8.8 7.2-16 16-16s16 7.2 16 16v56c0 39.8-32.2 72-72 72z"
    ]
};
var $1113a0aa61ab7765$export$e8485db4dab0ab30 = {
    prefix: 'fas',
    iconName: 'handshake-simple',
    icon: [
        640,
        512,
        [
            129309,
            "handshake-alt"
        ],
        "f4c6",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"
    ]
};
var $1113a0aa61ab7765$export$e9aa3c6f9f47aa1a = $1113a0aa61ab7765$export$e8485db4dab0ab30;
var $1113a0aa61ab7765$export$2130e629ab767ab3 = {
    prefix: 'fas',
    iconName: 'jet-fighter',
    icon: [
        640,
        512,
        [
            "fighter-jet"
        ],
        "f0fb",
        "M160 24c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H280L384 192H500.4c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L522.9 315.9c-7.2 2.7-14.8 4.1-22.5 4.1H384L280 464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V320H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H82.7c8.5 0 16.6 3.4 22.6 9.4L160 192h32V48h-8c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
    ]
};
var $1113a0aa61ab7765$export$102b809faf56e033 = $1113a0aa61ab7765$export$2130e629ab767ab3;
var $1113a0aa61ab7765$export$1bdb0ec5af3fea99 = {
    prefix: 'fas',
    iconName: 'square-share-nodes',
    icon: [
        448,
        512,
        [
            "share-alt-square"
        ],
        "f1e1",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"
    ]
};
var $1113a0aa61ab7765$export$3799c2d8fd7e493b = $1113a0aa61ab7765$export$1bdb0ec5af3fea99;
var $1113a0aa61ab7765$export$3825a842b5afc5aa = {
    prefix: 'fas',
    iconName: 'barcode',
    icon: [
        512,
        512,
        [],
        "f02a",
        "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var $1113a0aa61ab7765$export$37bd38cf96417095 = {
    prefix: 'fas',
    iconName: 'plus-minus',
    icon: [
        384,
        512,
        [],
        "e43c",
        "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H160V320c0 17.7 14.3 32 32 32s32-14.3 32-32V208H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V32zM0 480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $1113a0aa61ab7765$export$5c6bd8729527871b = {
    prefix: 'fas',
    iconName: 'video',
    icon: [
        576,
        512,
        [
            "video-camera"
        ],
        "f03d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
    ]
};
var $1113a0aa61ab7765$export$3a530df752193ccf = $1113a0aa61ab7765$export$5c6bd8729527871b;
var $1113a0aa61ab7765$export$874e305fd7920cce = {
    prefix: 'fas',
    iconName: 'graduation-cap',
    icon: [
        640,
        512,
        [
            127891,
            "mortar-board"
        ],
        "f19d",
        "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"
    ]
};
var $1113a0aa61ab7765$export$dd0a013bf23a9d86 = $1113a0aa61ab7765$export$874e305fd7920cce;
var $1113a0aa61ab7765$export$bb2a6b1b5e852300 = {
    prefix: 'fas',
    iconName: 'hand-holding-medical',
    icon: [
        576,
        512,
        [],
        "e05c",
        "M224 24V80H168c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176h56c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H320V24c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0 0 0c-.3 0-.6 0-.9 0z"
    ]
};
var $1113a0aa61ab7765$export$30294c81ac4031ca = {
    prefix: 'fas',
    iconName: 'person-circle-check',
    icon: [
        576,
        512,
        [],
        "e53e",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm424 16c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-76.7-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $1113a0aa61ab7765$export$314f5cab62fc6968 = {
    prefix: 'fas',
    iconName: 'turn-up',
    icon: [
        384,
        512,
        [
            10548,
            "level-up-alt"
        ],
        "f3bf",
        "M178.3 5.7L40.3 143.7C35 149 32 156.2 32 163.7C32 179.3 44.7 192 60.3 192H144V400c0 8.8-7.2 16-16 16H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h96c61.9 0 112-50.1 112-112V192h83.7c15.6 0 28.3-12.7 28.3-28.3c0-7.5-3-14.7-8.3-20L205.7 5.7C202 2 197.1 0 192 0s-10 2-13.7 5.7z"
    ]
};
var $1113a0aa61ab7765$export$d6f21a309b179c3d = $1113a0aa61ab7765$export$314f5cab62fc6968;
var $1113a0aa61ab7765$export$da048c47c8dcd50a = {
    fa0: $1113a0aa61ab7765$export$f22454595d96c106,
    fa1: $1113a0aa61ab7765$export$8398cb2addc9e182,
    fa2: $1113a0aa61ab7765$export$ed1a0ff7bd680a1d,
    fa3: $1113a0aa61ab7765$export$74b7ff79ce1818d6,
    fa4: $1113a0aa61ab7765$export$969b2215780d58fd,
    fa5: $1113a0aa61ab7765$export$3919f68a5b3825a9,
    fa6: $1113a0aa61ab7765$export$580ac17b31ffb5c3,
    fa7: $1113a0aa61ab7765$export$ee79cab31be16d23,
    fa8: $1113a0aa61ab7765$export$45d84c4b2c560d2f,
    fa9: $1113a0aa61ab7765$export$a120f1e4223629f2,
    faFillDrip: $1113a0aa61ab7765$export$38320138fc0262d0,
    faArrowsToCircle: $1113a0aa61ab7765$export$917a3d30f6cd766,
    faCircleChevronRight: $1113a0aa61ab7765$export$a39bab13d51abfd0,
    faChevronCircleRight: $1113a0aa61ab7765$export$2a5db4f6eba6f2b,
    faAt: $1113a0aa61ab7765$export$c115e8063ee02632,
    faTrashCan: $1113a0aa61ab7765$export$864bb8d6c21fb792,
    faTrashAlt: $1113a0aa61ab7765$export$88df7ff7eb32f9dc,
    faTextHeight: $1113a0aa61ab7765$export$3313bce3924ea7da,
    faUserXmark: $1113a0aa61ab7765$export$e585697127cda27,
    faUserTimes: $1113a0aa61ab7765$export$45b996d071667753,
    faStethoscope: $1113a0aa61ab7765$export$acb2d72d28cd92d9,
    faMessage: $1113a0aa61ab7765$export$6563a67224e7f879,
    faCommentAlt: $1113a0aa61ab7765$export$6e96904d9af0ec4a,
    faInfo: $1113a0aa61ab7765$export$d469b770895f47ac,
    faDownLeftAndUpRightToCenter: $1113a0aa61ab7765$export$d56736f5800b3f0d,
    faCompressAlt: $1113a0aa61ab7765$export$a05650ebe54bede,
    faExplosion: $1113a0aa61ab7765$export$36b5fbeae4855055,
    faFileLines: $1113a0aa61ab7765$export$ef565d07efe2b5e9,
    faFileAlt: $1113a0aa61ab7765$export$243b47dca32bf0b8,
    faFileText: $1113a0aa61ab7765$export$f466100bf9bf37a5,
    faWaveSquare: $1113a0aa61ab7765$export$c38cf504b3bc58a2,
    faRing: $1113a0aa61ab7765$export$a95486586631edc7,
    faBuildingUn: $1113a0aa61ab7765$export$fbbc7601eb465ac7,
    faDiceThree: $1113a0aa61ab7765$export$221059e0d5fd8958,
    faCalendarDays: $1113a0aa61ab7765$export$31c6cf6f5d38dc0,
    faCalendarAlt: $1113a0aa61ab7765$export$cbc139f33cff356,
    faAnchorCircleCheck: $1113a0aa61ab7765$export$8bce49e6ae597af8,
    faBuildingCircleArrowRight: $1113a0aa61ab7765$export$37584b1a5e175b47,
    faVolleyball: $1113a0aa61ab7765$export$cc519c9529a46c5c,
    faVolleyballBall: $1113a0aa61ab7765$export$a15e6fc8e68a76b0,
    faArrowsUpToLine: $1113a0aa61ab7765$export$159982ce2622211e,
    faSortDown: $1113a0aa61ab7765$export$58e2577a373e7d4,
    faSortDesc: $1113a0aa61ab7765$export$e24f016f5f78af6a,
    faCircleMinus: $1113a0aa61ab7765$export$d0163707993a8110,
    faMinusCircle: $1113a0aa61ab7765$export$f3979b49bf57313c,
    faDoorOpen: $1113a0aa61ab7765$export$41821b9a6fd703de,
    faRightFromBracket: $1113a0aa61ab7765$export$122a80ae0f87f726,
    faSignOutAlt: $1113a0aa61ab7765$export$c844d6923b7096c2,
    faAtom: $1113a0aa61ab7765$export$b5bb295e8ad4ab31,
    faSoap: $1113a0aa61ab7765$export$64f1c53b21f310ac,
    faIcons: $1113a0aa61ab7765$export$7fe2894454d8eb8a,
    faHeartMusicCameraBolt: $1113a0aa61ab7765$export$ec74c13cedb0791d,
    faMicrophoneLinesSlash: $1113a0aa61ab7765$export$4be1b324ac8a71ba,
    faMicrophoneAltSlash: $1113a0aa61ab7765$export$d2a53a388f30780,
    faBridgeCircleCheck: $1113a0aa61ab7765$export$ea908d3d80c57d08,
    faPumpMedical: $1113a0aa61ab7765$export$f1b881c73328720c,
    faFingerprint: $1113a0aa61ab7765$export$614dc068d88655af,
    faHandPointRight: $1113a0aa61ab7765$export$f7bc8714c970afa4,
    faMagnifyingGlassLocation: $1113a0aa61ab7765$export$234a18b2b4d530a3,
    faSearchLocation: $1113a0aa61ab7765$export$c33aba6c251a898a,
    faForwardStep: $1113a0aa61ab7765$export$908d699be6717adc,
    faStepForward: $1113a0aa61ab7765$export$b303329afce5de18,
    faFaceSmileBeam: $1113a0aa61ab7765$export$e3c56ed54f074063,
    faSmileBeam: $1113a0aa61ab7765$export$54ada6dc9690e0ca,
    faFlagCheckered: $1113a0aa61ab7765$export$92fad97e19a9fea,
    faFootball: $1113a0aa61ab7765$export$e15f65e77f717c29,
    faFootballBall: $1113a0aa61ab7765$export$e8fd664711e31704,
    faSchoolCircleExclamation: $1113a0aa61ab7765$export$f629fdee00932a01,
    faCrop: $1113a0aa61ab7765$export$afa58590dfb6fca2,
    faAnglesDown: $1113a0aa61ab7765$export$52783a541b1bb03,
    faAngleDoubleDown: $1113a0aa61ab7765$export$fd504117f273ca92,
    faUsersRectangle: $1113a0aa61ab7765$export$a28757068b9a3a9a,
    faPeopleRoof: $1113a0aa61ab7765$export$b96e695bdcf3f3f5,
    faPeopleLine: $1113a0aa61ab7765$export$d12c2d6def120efe,
    faBeerMugEmpty: $1113a0aa61ab7765$export$b957c27bc5330472,
    faBeer: $1113a0aa61ab7765$export$f74725691538983b,
    faDiagramPredecessor: $1113a0aa61ab7765$export$1852c99deca7bee8,
    faArrowUpLong: $1113a0aa61ab7765$export$92c58defe6e4c5a7,
    faLongArrowUp: $1113a0aa61ab7765$export$ede1d50ec4b01670,
    faFireFlameSimple: $1113a0aa61ab7765$export$9ebfff5c90672059,
    faBurn: $1113a0aa61ab7765$export$80ed4535efc60402,
    faPerson: $1113a0aa61ab7765$export$e6619e43cb090a16,
    faMale: $1113a0aa61ab7765$export$2e21f9dba1630651,
    faLaptop: $1113a0aa61ab7765$export$c2dee3bd177275a2,
    faFileCsv: $1113a0aa61ab7765$export$82cea4f586f6ec9,
    faMenorah: $1113a0aa61ab7765$export$232452c59d77c56e,
    faTruckPlane: $1113a0aa61ab7765$export$e1d5ceed99060d76,
    faRecordVinyl: $1113a0aa61ab7765$export$fe2d5012d9982673,
    faFaceGrinStars: $1113a0aa61ab7765$export$1d1fbac384a76a12,
    faGrinStars: $1113a0aa61ab7765$export$64347a5c8c402ef4,
    faBong: $1113a0aa61ab7765$export$e74974fac77c468e,
    faSpaghettiMonsterFlying: $1113a0aa61ab7765$export$3c8d5c62d76c33b8,
    faPastafarianism: $1113a0aa61ab7765$export$733efdaec97447be,
    faArrowDownUpAcrossLine: $1113a0aa61ab7765$export$9fe0c42ede2dd003,
    faSpoon: $1113a0aa61ab7765$export$faf854a434ce6d0c,
    faUtensilSpoon: $1113a0aa61ab7765$export$fb7af5d245fb9053,
    faJarWheat: $1113a0aa61ab7765$export$8b503c1d76716ddd,
    faEnvelopesBulk: $1113a0aa61ab7765$export$dc2cce064a1e70bb,
    faMailBulk: $1113a0aa61ab7765$export$dd24f40c5337e2e1,
    faFileCircleExclamation: $1113a0aa61ab7765$export$61fa9809253098e5,
    faCircleH: $1113a0aa61ab7765$export$bf5674308c61894f,
    faHospitalSymbol: $1113a0aa61ab7765$export$c8a3c78d99c23fed,
    faPager: $1113a0aa61ab7765$export$e1611f373a10a98c,
    faAddressBook: $1113a0aa61ab7765$export$853fd1561789e3bb,
    faContactBook: $1113a0aa61ab7765$export$594b5a5d4d2e156b,
    faStrikethrough: $1113a0aa61ab7765$export$eff51ea25b4de135,
    faK: $1113a0aa61ab7765$export$3f85413cb67e7f67,
    faLandmarkFlag: $1113a0aa61ab7765$export$f4d472cf47be4096,
    faPencil: $1113a0aa61ab7765$export$c72de95adaca18b8,
    faPencilAlt: $1113a0aa61ab7765$export$8210adc172262df,
    faBackward: $1113a0aa61ab7765$export$ae65f96ea7a4078d,
    faCaretRight: $1113a0aa61ab7765$export$f1011352b01c1c0,
    faComments: $1113a0aa61ab7765$export$932912e74adb8939,
    faPaste: $1113a0aa61ab7765$export$6f95f90dd1f6d86b,
    faFileClipboard: $1113a0aa61ab7765$export$ca3229c47de163fa,
    faCodePullRequest: $1113a0aa61ab7765$export$37576dfab037d8bf,
    faClipboardList: $1113a0aa61ab7765$export$2c5a9d8548d8810e,
    faTruckRampBox: $1113a0aa61ab7765$export$37396c36c76937bc,
    faTruckLoading: $1113a0aa61ab7765$export$f00c152db7d44638,
    faUserCheck: $1113a0aa61ab7765$export$76de2a120043c9f8,
    faVialVirus: $1113a0aa61ab7765$export$a56b2b0a1073620c,
    faSheetPlastic: $1113a0aa61ab7765$export$57f2bcd070bff91a,
    faBlog: $1113a0aa61ab7765$export$890d5e011054935a,
    faUserNinja: $1113a0aa61ab7765$export$a9174995732e03c5,
    faPersonArrowUpFromLine: $1113a0aa61ab7765$export$5709329dd2b70bdc,
    faScrollTorah: $1113a0aa61ab7765$export$4e3fe5b42a6cd494,
    faTorah: $1113a0aa61ab7765$export$54d07baabd8c2acb,
    faBroomBall: $1113a0aa61ab7765$export$3e1327487ce53231,
    faQuidditch: $1113a0aa61ab7765$export$c00c446e6db1605f,
    faQuidditchBroomBall: $1113a0aa61ab7765$export$791bfe29b97b4d42,
    faToggleOff: $1113a0aa61ab7765$export$d20aaceb882ca545,
    faBoxArchive: $1113a0aa61ab7765$export$2a0fcb66c3d79d00,
    faArchive: $1113a0aa61ab7765$export$26b3e1c454273f34,
    faPersonDrowning: $1113a0aa61ab7765$export$bac321083217fd4,
    faArrowDown91: $1113a0aa61ab7765$export$6cc91ce23eb3fae1,
    faSortNumericDesc: $1113a0aa61ab7765$export$99f058110e2c82a8,
    faSortNumericDownAlt: $1113a0aa61ab7765$export$857385fda7a5a98e,
    faFaceGrinTongueSquint: $1113a0aa61ab7765$export$8eee2c17ff89e724,
    faGrinTongueSquint: $1113a0aa61ab7765$export$4edf34c3def09a31,
    faSprayCan: $1113a0aa61ab7765$export$4952c502f544cf85,
    faTruckMonster: $1113a0aa61ab7765$export$24b8a0147653649a,
    faW: $1113a0aa61ab7765$export$c7f24bdea332f90a,
    faEarthAfrica: $1113a0aa61ab7765$export$11afa141d42099d0,
    faGlobeAfrica: $1113a0aa61ab7765$export$64af36f3b403a57c,
    faRainbow: $1113a0aa61ab7765$export$92ab27739d3a91b2,
    faCircleNotch: $1113a0aa61ab7765$export$9429fd8df55155d,
    faTabletScreenButton: $1113a0aa61ab7765$export$df1e253fc358ade4,
    faTabletAlt: $1113a0aa61ab7765$export$db0cac088255eacc,
    faPaw: $1113a0aa61ab7765$export$7bc6e4d977673e69,
    faCloud: $1113a0aa61ab7765$export$8bb3c4d5c2f50243,
    faTrowelBricks: $1113a0aa61ab7765$export$b6c20c10ddbd9898,
    faFaceFlushed: $1113a0aa61ab7765$export$ba5dc4287853ecbd,
    faFlushed: $1113a0aa61ab7765$export$dfd2bd012685aeac,
    faHospitalUser: $1113a0aa61ab7765$export$684703c93d630cc5,
    faTentArrowLeftRight: $1113a0aa61ab7765$export$fa95eb7418c0e2b8,
    faGavel: $1113a0aa61ab7765$export$c36fb40057e2c3aa,
    faLegal: $1113a0aa61ab7765$export$59d593c2dacb3781,
    faBinoculars: $1113a0aa61ab7765$export$8a910017964bb8c2,
    faMicrophoneSlash: $1113a0aa61ab7765$export$843f63d64e6f7951,
    faBoxTissue: $1113a0aa61ab7765$export$f2adc06617bc0c7,
    faMotorcycle: $1113a0aa61ab7765$export$f26017bdca99338d,
    faBellConcierge: $1113a0aa61ab7765$export$e433538b78718fb3,
    faConciergeBell: $1113a0aa61ab7765$export$ad92ffbbfbc0fcf3,
    faPenRuler: $1113a0aa61ab7765$export$85ba06027671d290,
    faPencilRuler: $1113a0aa61ab7765$export$e3a7a1affea005f5,
    faPeopleArrows: $1113a0aa61ab7765$export$804bfc5c390e1a2a,
    faPeopleArrowsLeftRight: $1113a0aa61ab7765$export$da01f044c59e3598,
    faMarsAndVenusBurst: $1113a0aa61ab7765$export$1dc6221efb867885,
    faSquareCaretRight: $1113a0aa61ab7765$export$5b1d41cdd118ea6d,
    faCaretSquareRight: $1113a0aa61ab7765$export$ae86c9de7e0f62fa,
    faScissors: $1113a0aa61ab7765$export$b2a906a5928c6404,
    faCut: $1113a0aa61ab7765$export$66847f2a71b260e7,
    faSunPlantWilt: $1113a0aa61ab7765$export$8db7f2f70484e17e,
    faToiletsPortable: $1113a0aa61ab7765$export$c00f55f36d386cb7,
    faHockeyPuck: $1113a0aa61ab7765$export$a274b02dc75663dc,
    faTable: $1113a0aa61ab7765$export$36583f5d3d5a971f,
    faMagnifyingGlassArrowRight: $1113a0aa61ab7765$export$382d3376c7fc7fc5,
    faTachographDigital: $1113a0aa61ab7765$export$73f2bf302381c86a,
    faDigitalTachograph: $1113a0aa61ab7765$export$b3bf1994f0fefe98,
    faUsersSlash: $1113a0aa61ab7765$export$b71a093b86e3da1f,
    faClover: $1113a0aa61ab7765$export$57813571c0e10a0a,
    faReply: $1113a0aa61ab7765$export$bb06d4a7bb6736fe,
    faMailReply: $1113a0aa61ab7765$export$12e45ff70d2646a1,
    faStarAndCrescent: $1113a0aa61ab7765$export$cafa834c96ebcb1a,
    faHouseFire: $1113a0aa61ab7765$export$947ee033a6942aa8,
    faSquareMinus: $1113a0aa61ab7765$export$814c9edba7b84aa4,
    faMinusSquare: $1113a0aa61ab7765$export$ffe9387966b3e681,
    faHelicopter: $1113a0aa61ab7765$export$612d3e1afaf45fa5,
    faCompass: $1113a0aa61ab7765$export$b4d344633433e50e,
    faSquareCaretDown: $1113a0aa61ab7765$export$a1ab39cd66c4e50e,
    faCaretSquareDown: $1113a0aa61ab7765$export$61aea18df1c84401,
    faFileCircleQuestion: $1113a0aa61ab7765$export$877d3692c1f94bda,
    faLaptopCode: $1113a0aa61ab7765$export$94100f4c6ee29932,
    faSwatchbook: $1113a0aa61ab7765$export$c74a20c81b957b6a,
    faPrescriptionBottle: $1113a0aa61ab7765$export$214f9ce665590486,
    faBars: $1113a0aa61ab7765$export$36e9cf7887265da2,
    faNavicon: $1113a0aa61ab7765$export$409fa7bcaa0e4cd9,
    faPeopleGroup: $1113a0aa61ab7765$export$be015e72863c3635,
    faHourglassEnd: $1113a0aa61ab7765$export$52757ecc5b1e25b9,
    faHourglass3: $1113a0aa61ab7765$export$1ec43c81fef8ffd6,
    faHeartCrack: $1113a0aa61ab7765$export$8e521ef33062b00e,
    faHeartBroken: $1113a0aa61ab7765$export$4a565395cb65b282,
    faSquareUpRight: $1113a0aa61ab7765$export$a47a20ab7bde8c67,
    faExternalLinkSquareAlt: $1113a0aa61ab7765$export$e4cdf2977151ee26,
    faFaceKissBeam: $1113a0aa61ab7765$export$eca99665af566fe1,
    faKissBeam: $1113a0aa61ab7765$export$d6ff8a73c0812e63,
    faFilm: $1113a0aa61ab7765$export$c03de0cc616e77bb,
    faRulerHorizontal: $1113a0aa61ab7765$export$46c6347bff3e04a,
    faPeopleRobbery: $1113a0aa61ab7765$export$75ce8513e1f1c5c4,
    faLightbulb: $1113a0aa61ab7765$export$1e80f89fe84a215b,
    faCaretLeft: $1113a0aa61ab7765$export$85a918a11b7643c2,
    faCircleExclamation: $1113a0aa61ab7765$export$59573943f9eebbd5,
    faExclamationCircle: $1113a0aa61ab7765$export$220e07e14c5d7e5d,
    faSchoolCircleXmark: $1113a0aa61ab7765$export$5e17b20e0f6b132b,
    faArrowRightFromBracket: $1113a0aa61ab7765$export$ca14f1b4d6afb7aa,
    faSignOut: $1113a0aa61ab7765$export$33e2b60243ca6d92,
    faCircleChevronDown: $1113a0aa61ab7765$export$aca07924996218d8,
    faChevronCircleDown: $1113a0aa61ab7765$export$9926124d75b2ecab,
    faUnlockKeyhole: $1113a0aa61ab7765$export$c98fdd5082b333ec,
    faUnlockAlt: $1113a0aa61ab7765$export$b19f508797f3d9c3,
    faCloudShowersHeavy: $1113a0aa61ab7765$export$af51c741ee9cc090,
    faHeadphonesSimple: $1113a0aa61ab7765$export$ca47801915e5a685,
    faHeadphonesAlt: $1113a0aa61ab7765$export$6f0433fa527dd5be,
    faSitemap: $1113a0aa61ab7765$export$b2ce5e79d0eccaf8,
    faCircleDollarToSlot: $1113a0aa61ab7765$export$5f92ac3e804644e3,
    faDonate: $1113a0aa61ab7765$export$40050ae52860cde7,
    faMemory: $1113a0aa61ab7765$export$5f9bd9f6df021f93,
    faRoadSpikes: $1113a0aa61ab7765$export$b372a24046126ad8,
    faFireBurner: $1113a0aa61ab7765$export$e4e44f7b1886fef,
    faFlag: $1113a0aa61ab7765$export$6591b1ea509be9da,
    faHanukiah: $1113a0aa61ab7765$export$3dcd4ca3f7108a82,
    faFeather: $1113a0aa61ab7765$export$5e19aea195b31816,
    faVolumeLow: $1113a0aa61ab7765$export$2b1464e7557b18eb,
    faVolumeDown: $1113a0aa61ab7765$export$69fdf57632b6cc29,
    faCommentSlash: $1113a0aa61ab7765$export$3786a0422a3f33ea,
    faCloudSunRain: $1113a0aa61ab7765$export$dd9dc9b4227dbe94,
    faCompress: $1113a0aa61ab7765$export$83632d1150d3541f,
    faWheatAwn: $1113a0aa61ab7765$export$79d4dac715a51fdf,
    faWheatAlt: $1113a0aa61ab7765$export$deaf03a29aa05e3a,
    faAnkh: $1113a0aa61ab7765$export$8736909014b15ca9,
    faHandsHoldingChild: $1113a0aa61ab7765$export$bfb254bf3c0bc50b,
    faAsterisk: $1113a0aa61ab7765$export$19eff32c0fd4f99f,
    faSquareCheck: $1113a0aa61ab7765$export$5bb6a0c94ad2f4bb,
    faCheckSquare: $1113a0aa61ab7765$export$f0c8040f596df7fe,
    faPesetaSign: $1113a0aa61ab7765$export$a6f8654bcd49a39f,
    faHeading: $1113a0aa61ab7765$export$4805b8d175aeb9fb,
    faHeader: $1113a0aa61ab7765$export$579f9604bb10a61a,
    faGhost: $1113a0aa61ab7765$export$1a989eb1919c64c1,
    faList: $1113a0aa61ab7765$export$6cfc59842fedbc16,
    faListSquares: $1113a0aa61ab7765$export$e3f160fc949c2b9d,
    faSquarePhoneFlip: $1113a0aa61ab7765$export$b627121801cad756,
    faPhoneSquareAlt: $1113a0aa61ab7765$export$a41e77f0de98bba7,
    faCartPlus: $1113a0aa61ab7765$export$6675e2bf21fdb87e,
    faGamepad: $1113a0aa61ab7765$export$6a66b1b639455bef,
    faCircleDot: $1113a0aa61ab7765$export$aa13d9234890e8d3,
    faDotCircle: $1113a0aa61ab7765$export$92bc269cb244d66a,
    faFaceDizzy: $1113a0aa61ab7765$export$635e4d8cc8428961,
    faDizzy: $1113a0aa61ab7765$export$89a2b10dabc487e8,
    faEgg: $1113a0aa61ab7765$export$1199a8ce85311ab5,
    faHouseMedicalCircleXmark: $1113a0aa61ab7765$export$bf221f0e8296233e,
    faCampground: $1113a0aa61ab7765$export$295287303c0e9c7c,
    faFolderPlus: $1113a0aa61ab7765$export$e18e05ffa2045d3b,
    faFutbol: $1113a0aa61ab7765$export$65a345b33858a655,
    faFutbolBall: $1113a0aa61ab7765$export$51a344ca0a215620,
    faSoccerBall: $1113a0aa61ab7765$export$f4a29712c724ba2d,
    faPaintbrush: $1113a0aa61ab7765$export$7c8b56f3f296a814,
    faPaintBrush: $1113a0aa61ab7765$export$594db3339e212bc9,
    faLock: $1113a0aa61ab7765$export$7aa08ad5d562578a,
    faGasPump: $1113a0aa61ab7765$export$84666c793cb2a347,
    faHotTubPerson: $1113a0aa61ab7765$export$6e6bd68568c17bbf,
    faHotTub: $1113a0aa61ab7765$export$4842af92b516c40b,
    faMapLocation: $1113a0aa61ab7765$export$9a8788ec0e4a9a0b,
    faMapMarked: $1113a0aa61ab7765$export$df04458e7e32352c,
    faHouseFloodWater: $1113a0aa61ab7765$export$70fd6006b4e54a5,
    faTree: $1113a0aa61ab7765$export$1744430f718caf6b,
    faBridgeLock: $1113a0aa61ab7765$export$cffe7d85a82d8116,
    faSackDollar: $1113a0aa61ab7765$export$15854c4475080853,
    faPenToSquare: $1113a0aa61ab7765$export$ba236543926e3569,
    faEdit: $1113a0aa61ab7765$export$7be713e57d023733,
    faCarSide: $1113a0aa61ab7765$export$6f7218565b1b8d0e,
    faShareNodes: $1113a0aa61ab7765$export$cdaf45d4e50ac035,
    faShareAlt: $1113a0aa61ab7765$export$f8e8bb0b3aa8c658,
    faHeartCircleMinus: $1113a0aa61ab7765$export$24c21c3ca00f3625,
    faHourglassHalf: $1113a0aa61ab7765$export$703272eebf5e3eea,
    faHourglass2: $1113a0aa61ab7765$export$f1052bbf6bf361c0,
    faMicroscope: $1113a0aa61ab7765$export$6a99139787bf9967,
    faSink: $1113a0aa61ab7765$export$2a9dda2096ce792e,
    faBagShopping: $1113a0aa61ab7765$export$b0137b4600e9ab12,
    faShoppingBag: $1113a0aa61ab7765$export$5745f8adbc11eb01,
    faArrowDownZA: $1113a0aa61ab7765$export$cf79d63ad07d943a,
    faSortAlphaDesc: $1113a0aa61ab7765$export$7caf99612a55d427,
    faSortAlphaDownAlt: $1113a0aa61ab7765$export$e12d23d82d5c8a89,
    faMitten: $1113a0aa61ab7765$export$5030322c5fc886d7,
    faPersonRays: $1113a0aa61ab7765$export$49577f913f0fe4d2,
    faUsers: $1113a0aa61ab7765$export$e5a8f011aef571ac,
    faEyeSlash: $1113a0aa61ab7765$export$ed3f2918429d029a,
    faFlaskVial: $1113a0aa61ab7765$export$a25a266ce0c95019,
    faHand: $1113a0aa61ab7765$export$f69db0b876f7d753,
    faHandPaper: $1113a0aa61ab7765$export$6e6216c8b50471bb,
    faOm: $1113a0aa61ab7765$export$8de8eb94230028a5,
    faWorm: $1113a0aa61ab7765$export$2571e33fa6c25993,
    faHouseCircleXmark: $1113a0aa61ab7765$export$423555e8708eb4c7,
    faPlug: $1113a0aa61ab7765$export$cae5752c3e3b6545,
    faChevronUp: $1113a0aa61ab7765$export$877e5ae47a854215,
    faHandSpock: $1113a0aa61ab7765$export$2262d6b626de1120,
    faStopwatch: $1113a0aa61ab7765$export$b85a7300fc7960b6,
    faFaceKiss: $1113a0aa61ab7765$export$5a54c83033a0a56a,
    faKiss: $1113a0aa61ab7765$export$c762a77aabf64fd0,
    faBridgeCircleXmark: $1113a0aa61ab7765$export$834071278537f121,
    faFaceGrinTongue: $1113a0aa61ab7765$export$95a7394c24f57943,
    faGrinTongue: $1113a0aa61ab7765$export$ef222816a43a4b3a,
    faChessBishop: $1113a0aa61ab7765$export$a831eedd2f59c62f,
    faFaceGrinWink: $1113a0aa61ab7765$export$1dd161850c5bc64e,
    faGrinWink: $1113a0aa61ab7765$export$2397fcd34eb12177,
    faEarDeaf: $1113a0aa61ab7765$export$c9c5b76ec992eab4,
    faDeaf: $1113a0aa61ab7765$export$4b666adf83f0de01,
    faDeafness: $1113a0aa61ab7765$export$85c6a9ab2fa2631e,
    faHardOfHearing: $1113a0aa61ab7765$export$ebecf90a5676e17a,
    faRoadCircleCheck: $1113a0aa61ab7765$export$3f22db9ae9b6be1c,
    faDiceFive: $1113a0aa61ab7765$export$d9769fb795c2db82,
    faSquareRss: $1113a0aa61ab7765$export$97d1903b1e012ff7,
    faRssSquare: $1113a0aa61ab7765$export$89c9b1cca2c11484,
    faLandMineOn: $1113a0aa61ab7765$export$567a897fc092e403,
    faICursor: $1113a0aa61ab7765$export$7fddf76ec23943d8,
    faStamp: $1113a0aa61ab7765$export$722e92d2d93ffc68,
    faStairs: $1113a0aa61ab7765$export$68b3af7444c89df7,
    faI: $1113a0aa61ab7765$export$aee03ca0815b7c38,
    faHryvniaSign: $1113a0aa61ab7765$export$22a9491150c64fef,
    faHryvnia: $1113a0aa61ab7765$export$33d5f94bd6f75f59,
    faPills: $1113a0aa61ab7765$export$6380e2ed6e69d350,
    faFaceGrinWide: $1113a0aa61ab7765$export$bdbabf493c478cde,
    faGrinAlt: $1113a0aa61ab7765$export$b4abebfe416d36ba,
    faTooth: $1113a0aa61ab7765$export$3a1fa2d16f90d635,
    faV: $1113a0aa61ab7765$export$6fb446f784f6b9b3,
    faBangladeshiTakaSign: $1113a0aa61ab7765$export$469d376940e10d37,
    faBicycle: $1113a0aa61ab7765$export$36cb1885ad7a570f,
    faStaffSnake: $1113a0aa61ab7765$export$76d998742bc186eb,
    faRodAsclepius: $1113a0aa61ab7765$export$f2c3e92ee37a8d89,
    faRodSnake: $1113a0aa61ab7765$export$5d61dcb598296af0,
    faStaffAesculapius: $1113a0aa61ab7765$export$97c8a2cdba3b7700,
    faHeadSideCoughSlash: $1113a0aa61ab7765$export$b293ee8fb8e6b0c4,
    faTruckMedical: $1113a0aa61ab7765$export$fb6bd43f079f72e2,
    faAmbulance: $1113a0aa61ab7765$export$f5c7042778b51765,
    faWheatAwnCircleExclamation: $1113a0aa61ab7765$export$e23367e54f665590,
    faSnowman: $1113a0aa61ab7765$export$b23df6bafb174693,
    faMortarPestle: $1113a0aa61ab7765$export$55ceb5d0c144580a,
    faRoadBarrier: $1113a0aa61ab7765$export$f3e925217e396f44,
    faSchool: $1113a0aa61ab7765$export$51e9b8434982947d,
    faIgloo: $1113a0aa61ab7765$export$4a284575edd6f1af,
    faJoint: $1113a0aa61ab7765$export$e5a289fb22ffb8cb,
    faAngleRight: $1113a0aa61ab7765$export$6bce1afb61f2eb66,
    faHorse: $1113a0aa61ab7765$export$5b05f097fa38352a,
    faQ: $1113a0aa61ab7765$export$5a2b164552deda9f,
    faG: $1113a0aa61ab7765$export$9f5c2b0db8eedeac,
    faNotesMedical: $1113a0aa61ab7765$export$b2d79133c81d6697,
    faTemperatureHalf: $1113a0aa61ab7765$export$a3f1d7f13c202adc,
    faTemperature2: $1113a0aa61ab7765$export$8176e649df45b32c,
    faThermometer2: $1113a0aa61ab7765$export$4dd764ac8d512682,
    faThermometerHalf: $1113a0aa61ab7765$export$2090f040324b4449,
    faDongSign: $1113a0aa61ab7765$export$18659308f17918a5,
    faCapsules: $1113a0aa61ab7765$export$ba6fd4a436804a48,
    faPooStorm: $1113a0aa61ab7765$export$48a38da471b097a2,
    faPooBolt: $1113a0aa61ab7765$export$9a24e77f74d9cbd9,
    faFaceFrownOpen: $1113a0aa61ab7765$export$c8a28356e07b9ccb,
    faFrownOpen: $1113a0aa61ab7765$export$c4775e66bed5d96,
    faHandPointUp: $1113a0aa61ab7765$export$cdc9f5e7e94e76da,
    faMoneyBill: $1113a0aa61ab7765$export$608138a7337b5d1a,
    faBookmark: $1113a0aa61ab7765$export$4ed9da5c3cca0ef1,
    faAlignJustify: $1113a0aa61ab7765$export$97c42b56d462df72,
    faUmbrellaBeach: $1113a0aa61ab7765$export$20932e4d438e4e4c,
    faHelmetUn: $1113a0aa61ab7765$export$5e975cb293c48461,
    faBullseye: $1113a0aa61ab7765$export$554720e3bf74fe90,
    faBacon: $1113a0aa61ab7765$export$ab07061fe21a3a8e,
    faHandPointDown: $1113a0aa61ab7765$export$f6dcbf0a940428f4,
    faArrowUpFromBracket: $1113a0aa61ab7765$export$c2af1be14cd87640,
    faFolder: $1113a0aa61ab7765$export$72b780186370e953,
    faFolderBlank: $1113a0aa61ab7765$export$9ef114244d26da0,
    faFileWaveform: $1113a0aa61ab7765$export$5e0c19cf315ac1bf,
    faFileMedicalAlt: $1113a0aa61ab7765$export$ef02a0f5b39aa61f,
    faRadiation: $1113a0aa61ab7765$export$4c4e509518093d6d,
    faChartSimple: $1113a0aa61ab7765$export$8760a1de19ea40b9,
    faMarsStroke: $1113a0aa61ab7765$export$aa05fce255a5d269,
    faVial: $1113a0aa61ab7765$export$aa014b06d2d70598,
    faGauge: $1113a0aa61ab7765$export$dbfb0a9f89ad94a4,
    faDashboard: $1113a0aa61ab7765$export$b7ce24136743d0f1,
    faGaugeMed: $1113a0aa61ab7765$export$f948a9dd257979f3,
    faTachometerAltAverage: $1113a0aa61ab7765$export$6f22c345e5a92d1a,
    faWandMagicSparkles: $1113a0aa61ab7765$export$5325fc72e75360b4,
    faMagicWandSparkles: $1113a0aa61ab7765$export$c93286938249f0da,
    faE: $1113a0aa61ab7765$export$86923e6fe1b42f5e,
    faPenClip: $1113a0aa61ab7765$export$eff4bdcafd3b8d1c,
    faPenAlt: $1113a0aa61ab7765$export$a3d3e92e430d3beb,
    faBridgeCircleExclamation: $1113a0aa61ab7765$export$4f25939fdf728c27,
    faUser: $1113a0aa61ab7765$export$f5699fa0844e0188,
    faSchoolCircleCheck: $1113a0aa61ab7765$export$c8c95c2f9937bf6a,
    faDumpster: $1113a0aa61ab7765$export$3b934e22d1851a3b,
    faVanShuttle: $1113a0aa61ab7765$export$ecbd233b96906ee1,
    faShuttleVan: $1113a0aa61ab7765$export$9d63d851db698c09,
    faBuildingUser: $1113a0aa61ab7765$export$d65aef1ed7db1dae,
    faSquareCaretLeft: $1113a0aa61ab7765$export$2c5163541229363,
    faCaretSquareLeft: $1113a0aa61ab7765$export$d0c8ba444f1f9581,
    faHighlighter: $1113a0aa61ab7765$export$73801ed54b42fabe,
    faKey: $1113a0aa61ab7765$export$fa6ecc35e7315db,
    faBullhorn: $1113a0aa61ab7765$export$dacae2b4ec565333,
    faGlobe: $1113a0aa61ab7765$export$b1b1cdce4a19c682,
    faSynagogue: $1113a0aa61ab7765$export$20d991385719b5b4,
    faPersonHalfDress: $1113a0aa61ab7765$export$f3d75c19191f1688,
    faRoadBridge: $1113a0aa61ab7765$export$4d6835e7175dec24,
    faLocationArrow: $1113a0aa61ab7765$export$4ac9c4c370f7b157,
    faC: $1113a0aa61ab7765$export$a2c1c457834fc6d8,
    faTabletButton: $1113a0aa61ab7765$export$2d33c367b2b091ac,
    faBuildingLock: $1113a0aa61ab7765$export$6f08294ba8a2459c,
    faPizzaSlice: $1113a0aa61ab7765$export$c9f93c4667edc585,
    faMoneyBillWave: $1113a0aa61ab7765$export$53e23123cc9a6796,
    faChartArea: $1113a0aa61ab7765$export$2acab8312b7a999b,
    faAreaChart: $1113a0aa61ab7765$export$fc2e595f0e0612cb,
    faHouseFlag: $1113a0aa61ab7765$export$9a3d31c75a465b9a,
    faPersonCircleMinus: $1113a0aa61ab7765$export$d7ccc6651f90f7cc,
    faBan: $1113a0aa61ab7765$export$76f704d256def3c7,
    faCancel: $1113a0aa61ab7765$export$6d25ef56192f6d69,
    faCameraRotate: $1113a0aa61ab7765$export$e0ce7d1aba7105e7,
    faSprayCanSparkles: $1113a0aa61ab7765$export$43832c90c10a7a31,
    faAirFreshener: $1113a0aa61ab7765$export$a5e63e89b5ccee83,
    faStar: $1113a0aa61ab7765$export$a3b0eb2cd7942125,
    faRepeat: $1113a0aa61ab7765$export$cb8434288c91ae83,
    faCross: $1113a0aa61ab7765$export$9d0a89fcd084abb,
    faBox: $1113a0aa61ab7765$export$6e7cf270cda52323,
    faVenusMars: $1113a0aa61ab7765$export$63f2d9e5f4689aa8,
    faArrowPointer: $1113a0aa61ab7765$export$e4f903bc63db445,
    faMousePointer: $1113a0aa61ab7765$export$2e19a69cc26b147,
    faMaximize: $1113a0aa61ab7765$export$8d2b1b230601e804,
    faExpandArrowsAlt: $1113a0aa61ab7765$export$6219dcd88b5fa6c2,
    faChargingStation: $1113a0aa61ab7765$export$bab2cd86f8c65657,
    faShapes: $1113a0aa61ab7765$export$b17d50542d1fc340,
    faTriangleCircleSquare: $1113a0aa61ab7765$export$34261e5aea24fc1d,
    faShuffle: $1113a0aa61ab7765$export$ee94b652453ad208,
    faRandom: $1113a0aa61ab7765$export$8357bf8cc666d5f0,
    faPersonRunning: $1113a0aa61ab7765$export$f48814ae62850c74,
    faRunning: $1113a0aa61ab7765$export$5dfd1cb43dc9eadb,
    faMobileRetro: $1113a0aa61ab7765$export$7955f08360418647,
    faGripLinesVertical: $1113a0aa61ab7765$export$523960de087f5198,
    faSpider: $1113a0aa61ab7765$export$6daa96b1986e2ef0,
    faHandsBound: $1113a0aa61ab7765$export$740142a89118fbc0,
    faFileInvoiceDollar: $1113a0aa61ab7765$export$a3dced32d48cb1ea,
    faPlaneCircleExclamation: $1113a0aa61ab7765$export$f201ba865ea1b8dc,
    faXRay: $1113a0aa61ab7765$export$8cf137aceaaf4de0,
    faSpellCheck: $1113a0aa61ab7765$export$761e747b06ed2e1f,
    faSlash: $1113a0aa61ab7765$export$f54d004dd5f1cb5e,
    faComputerMouse: $1113a0aa61ab7765$export$72cf138e5ddda6eb,
    faMouse: $1113a0aa61ab7765$export$198b96b894c66074,
    faArrowRightToBracket: $1113a0aa61ab7765$export$a02c5909359525be,
    faSignIn: $1113a0aa61ab7765$export$a55eff0ca4f9c3df,
    faShopSlash: $1113a0aa61ab7765$export$b3d636689da4a3e5,
    faStoreAltSlash: $1113a0aa61ab7765$export$b932a586f6ff48b4,
    faServer: $1113a0aa61ab7765$export$1bf820d499b6202e,
    faVirusCovidSlash: $1113a0aa61ab7765$export$61c2a6b698f55df6,
    faShopLock: $1113a0aa61ab7765$export$452410c103c2403b,
    faHourglassStart: $1113a0aa61ab7765$export$f0c28584caa8f4b,
    faHourglass1: $1113a0aa61ab7765$export$87929336ab5c59cd,
    faBlenderPhone: $1113a0aa61ab7765$export$f35a116a762ef8fc,
    faBuildingWheat: $1113a0aa61ab7765$export$6c0cfe6d58faf860,
    faPersonBreastfeeding: $1113a0aa61ab7765$export$9b94ed8d16d281f9,
    faRightToBracket: $1113a0aa61ab7765$export$a5fd2acfcb5247c6,
    faSignInAlt: $1113a0aa61ab7765$export$e6709746115bd2ea,
    faVenus: $1113a0aa61ab7765$export$f89d028573ffc0a6,
    faPassport: $1113a0aa61ab7765$export$2c31ca0d9bee400f,
    faHeartPulse: $1113a0aa61ab7765$export$a6d8e50dcd4b4294,
    faHeartbeat: $1113a0aa61ab7765$export$ca880e19206e80aa,
    faPeopleCarryBox: $1113a0aa61ab7765$export$7754cc6d5559ff38,
    faPeopleCarry: $1113a0aa61ab7765$export$35fbd4ff1265acd5,
    faTemperatureHigh: $1113a0aa61ab7765$export$15d012277c3ecf9a,
    faMicrochip: $1113a0aa61ab7765$export$4a7bb4be15f35178,
    faCrown: $1113a0aa61ab7765$export$dc1083dcd1d7b9d6,
    faWeightHanging: $1113a0aa61ab7765$export$43d1fa6671908715,
    faXmarksLines: $1113a0aa61ab7765$export$f4595f012786d346,
    faFilePrescription: $1113a0aa61ab7765$export$a20cb90865b6beb8,
    faWeightScale: $1113a0aa61ab7765$export$e521c542d18b85c3,
    faWeight: $1113a0aa61ab7765$export$cf3bafa68a60bae4,
    faUserGroup: $1113a0aa61ab7765$export$3d626cfc365a7e36,
    faUserFriends: $1113a0aa61ab7765$export$46073bec205635d9,
    faArrowUpAZ: $1113a0aa61ab7765$export$fb00fdd8857804c7,
    faSortAlphaUp: $1113a0aa61ab7765$export$3c4115b156be730d,
    faChessKnight: $1113a0aa61ab7765$export$861b1f13085cf122,
    faFaceLaughSquint: $1113a0aa61ab7765$export$67ca89c1ca38d559,
    faLaughSquint: $1113a0aa61ab7765$export$b206e700cf7084e1,
    faWheelchair: $1113a0aa61ab7765$export$76a9413fbe130a53,
    faCircleArrowUp: $1113a0aa61ab7765$export$a29c8ea43e92771d,
    faArrowCircleUp: $1113a0aa61ab7765$export$a2f6f3baa50af0b1,
    faToggleOn: $1113a0aa61ab7765$export$5cffc34afa81e517,
    faPersonWalking: $1113a0aa61ab7765$export$6af1cc5998ca52bc,
    faWalking: $1113a0aa61ab7765$export$4886811b7174ec35,
    faL: $1113a0aa61ab7765$export$be32b10ce70a09df,
    faFire: $1113a0aa61ab7765$export$7b24b34ef6cc130c,
    faBedPulse: $1113a0aa61ab7765$export$580ae0d0bbd809fb,
    faProcedures: $1113a0aa61ab7765$export$5f9e1870e1866dde,
    faShuttleSpace: $1113a0aa61ab7765$export$76d92e7f30d064c5,
    faSpaceShuttle: $1113a0aa61ab7765$export$4d1c12ba2b4ca565,
    faFaceLaugh: $1113a0aa61ab7765$export$2f203616c892d415,
    faLaugh: $1113a0aa61ab7765$export$6c74e314e801a4fe,
    faFolderOpen: $1113a0aa61ab7765$export$ff7e93418af88b78,
    faHeartCirclePlus: $1113a0aa61ab7765$export$2a155a6e20f64134,
    faCodeFork: $1113a0aa61ab7765$export$f54081bdbf6d4eb5,
    faCity: $1113a0aa61ab7765$export$a9947c2888b3c8fd,
    faMicrophoneLines: $1113a0aa61ab7765$export$417391ae30b5922e,
    faMicrophoneAlt: $1113a0aa61ab7765$export$f08ef94fea14f5ac,
    faPepperHot: $1113a0aa61ab7765$export$4894bf28f771e1f3,
    faUnlock: $1113a0aa61ab7765$export$db1382cd406cc506,
    faColonSign: $1113a0aa61ab7765$export$dec10d4c2c113312,
    faHeadset: $1113a0aa61ab7765$export$23b086400a31acfe,
    faStoreSlash: $1113a0aa61ab7765$export$4ab2f33219630bad,
    faRoadCircleXmark: $1113a0aa61ab7765$export$2ffc88a4d31e8ffc,
    faUserMinus: $1113a0aa61ab7765$export$d6e17c0df8ed1bf7,
    faMarsStrokeUp: $1113a0aa61ab7765$export$efc6d53e0dedceee,
    faMarsStrokeV: $1113a0aa61ab7765$export$ed7aa1c25104f333,
    faChampagneGlasses: $1113a0aa61ab7765$export$7df1926e9eef8cc3,
    faGlassCheers: $1113a0aa61ab7765$export$20007d7d74cb98fe,
    faClipboard: $1113a0aa61ab7765$export$97d84347d71ba297,
    faHouseCircleExclamation: $1113a0aa61ab7765$export$8403e4b31e8aa805,
    faFileArrowUp: $1113a0aa61ab7765$export$929df388c07f293d,
    faFileUpload: $1113a0aa61ab7765$export$dd55ded1264643d2,
    faWifi: $1113a0aa61ab7765$export$1642419fe3db2857,
    faWifi3: $1113a0aa61ab7765$export$2349bb04a04f4b2d,
    faWifiStrong: $1113a0aa61ab7765$export$4b3167c852f4c4aa,
    faBath: $1113a0aa61ab7765$export$1ea66a88b8f620c9,
    faBathtub: $1113a0aa61ab7765$export$40ae013b5e6269d8,
    faUnderline: $1113a0aa61ab7765$export$22346afd6a3cddf8,
    faUserPen: $1113a0aa61ab7765$export$3842882ea09b25af,
    faUserEdit: $1113a0aa61ab7765$export$a68a6960fc8eef82,
    faSignature: $1113a0aa61ab7765$export$afa7b53ac8ebcb5d,
    faStroopwafel: $1113a0aa61ab7765$export$195780ddabd8e0c6,
    faBold: $1113a0aa61ab7765$export$7e0c7fd2a2e88823,
    faAnchorLock: $1113a0aa61ab7765$export$217195c80db39097,
    faBuildingNgo: $1113a0aa61ab7765$export$374e1dce366a2175,
    faManatSign: $1113a0aa61ab7765$export$1ff755b523ab2851,
    faNotEqual: $1113a0aa61ab7765$export$6a15ccae09bbaf93,
    faBorderTopLeft: $1113a0aa61ab7765$export$cf897c3e0abd59e4,
    faBorderStyle: $1113a0aa61ab7765$export$c2867ca78120d644,
    faMapLocationDot: $1113a0aa61ab7765$export$757f50b8af780c19,
    faMapMarkedAlt: $1113a0aa61ab7765$export$a977d47c74d8e86c,
    faJedi: $1113a0aa61ab7765$export$859f204e59641ca4,
    faSquarePollVertical: $1113a0aa61ab7765$export$91d747e5aabe6fe8,
    faPoll: $1113a0aa61ab7765$export$bc8ca14ab51f93db,
    faMugHot: $1113a0aa61ab7765$export$47a822c30184e8af,
    faCarBattery: $1113a0aa61ab7765$export$a44d0c11093d9c1e,
    faBatteryCar: $1113a0aa61ab7765$export$9133165ca669dd4b,
    faGift: $1113a0aa61ab7765$export$b2727de8ccdbb5ec,
    faDiceTwo: $1113a0aa61ab7765$export$4d85df590065572f,
    faChessQueen: $1113a0aa61ab7765$export$7b8ce73615739d30,
    faGlasses: $1113a0aa61ab7765$export$58d7d709c0a8ca5f,
    faChessBoard: $1113a0aa61ab7765$export$bd301515df6246af,
    faBuildingCircleCheck: $1113a0aa61ab7765$export$5559de5f969b9590,
    faPersonChalkboard: $1113a0aa61ab7765$export$c9dc1583b207b7ff,
    faMarsStrokeRight: $1113a0aa61ab7765$export$321e84e6a900c2d6,
    faMarsStrokeH: $1113a0aa61ab7765$export$5cb0daeafbcdabe3,
    faHandBackFist: $1113a0aa61ab7765$export$be38a892fe9b4098,
    faHandRock: $1113a0aa61ab7765$export$97a81eba394c8c44,
    faSquareCaretUp: $1113a0aa61ab7765$export$66068918abb14406,
    faCaretSquareUp: $1113a0aa61ab7765$export$307ae80b26533ce5,
    faCloudShowersWater: $1113a0aa61ab7765$export$b416056e795d2eac,
    faChartBar: $1113a0aa61ab7765$export$b532f5d25de97633,
    faBarChart: $1113a0aa61ab7765$export$2d5f754a5e5738b,
    faHandsBubbles: $1113a0aa61ab7765$export$2f78563e14e49916,
    faHandsWash: $1113a0aa61ab7765$export$996b5dea53b124e3,
    faLessThanEqual: $1113a0aa61ab7765$export$b2c723344cff0d8,
    faTrain: $1113a0aa61ab7765$export$17cde74bf6f1ee89,
    faEyeLowVision: $1113a0aa61ab7765$export$23a892b1a4b994bd,
    faLowVision: $1113a0aa61ab7765$export$7a65d2aa54cb4e93,
    faCrow: $1113a0aa61ab7765$export$bfa312207b788ed9,
    faSailboat: $1113a0aa61ab7765$export$e363e74e36cce80c,
    faWindowRestore: $1113a0aa61ab7765$export$eccfff9bfd585652,
    faSquarePlus: $1113a0aa61ab7765$export$eaf727acca5a35e4,
    faPlusSquare: $1113a0aa61ab7765$export$b6359eebfe900c35,
    faToriiGate: $1113a0aa61ab7765$export$75825a4c2b3375e,
    faFrog: $1113a0aa61ab7765$export$fe2358263efac504,
    faBucket: $1113a0aa61ab7765$export$2124c7628e573b84,
    faImage: $1113a0aa61ab7765$export$7e9f0928967e03b,
    faMicrophone: $1113a0aa61ab7765$export$eed3c491effe6d12,
    faCow: $1113a0aa61ab7765$export$1da3b2e53dcafa2d,
    faCaretUp: $1113a0aa61ab7765$export$7de776bdab4e536d,
    faScrewdriver: $1113a0aa61ab7765$export$7484ff654cd6474f,
    faFolderClosed: $1113a0aa61ab7765$export$5e30548b7f8eeb95,
    faHouseTsunami: $1113a0aa61ab7765$export$197b9567e88a0b1d,
    faSquareNfi: $1113a0aa61ab7765$export$5498258519fc5b72,
    faArrowUpFromGroundWater: $1113a0aa61ab7765$export$cbe485a104805f4f,
    faMartiniGlass: $1113a0aa61ab7765$export$98401bb29cff68e0,
    faGlassMartiniAlt: $1113a0aa61ab7765$export$2258439b8f4e7acb,
    faRotateLeft: $1113a0aa61ab7765$export$7adaa412bd8eb08f,
    faRotateBack: $1113a0aa61ab7765$export$9706706f1bc7b12,
    faRotateBackward: $1113a0aa61ab7765$export$4ceb0b05fed961a9,
    faUndoAlt: $1113a0aa61ab7765$export$c8197b992c46c4a6,
    faTableColumns: $1113a0aa61ab7765$export$ccaa019a3fd4563f,
    faColumns: $1113a0aa61ab7765$export$bb861166644ac28a,
    faLemon: $1113a0aa61ab7765$export$4fbda8f64648f3b5,
    faHeadSideMask: $1113a0aa61ab7765$export$280300af4baa1a3e,
    faHandshake: $1113a0aa61ab7765$export$b4c63e9bfc7906f1,
    faGem: $1113a0aa61ab7765$export$31ee86ac717db552,
    faDolly: $1113a0aa61ab7765$export$5879d0bca1aa497b,
    faDollyBox: $1113a0aa61ab7765$export$461bbb9e92cc531b,
    faSmoking: $1113a0aa61ab7765$export$c4ab83701fc591a5,
    faMinimize: $1113a0aa61ab7765$export$e0601b1f239fec74,
    faCompressArrowsAlt: $1113a0aa61ab7765$export$39205db0ea980efd,
    faMonument: $1113a0aa61ab7765$export$6f9b0bfc012deb25,
    faSnowplow: $1113a0aa61ab7765$export$695fae58f55c3a87,
    faAnglesRight: $1113a0aa61ab7765$export$48b60f1720e09944,
    faAngleDoubleRight: $1113a0aa61ab7765$export$792931403404faf0,
    faCannabis: $1113a0aa61ab7765$export$8ec2f752344b69bd,
    faCirclePlay: $1113a0aa61ab7765$export$86c4e45dc3302d15,
    faPlayCircle: $1113a0aa61ab7765$export$cf04333781061c5e,
    faTablets: $1113a0aa61ab7765$export$bed2b0ed4ae45e0d,
    faEthernet: $1113a0aa61ab7765$export$6bad2c9f317b52e5,
    faEuroSign: $1113a0aa61ab7765$export$902a3969bb113dff,
    faEur: $1113a0aa61ab7765$export$4b859160cfeb12ff,
    faEuro: $1113a0aa61ab7765$export$bdabbefede2d3a2,
    faChair: $1113a0aa61ab7765$export$a339864ee3df7e9a,
    faCircleCheck: $1113a0aa61ab7765$export$c2e9877668862374,
    faCheckCircle: $1113a0aa61ab7765$export$be9e388158c74f29,
    faCircleStop: $1113a0aa61ab7765$export$229de76dfef2687f,
    faStopCircle: $1113a0aa61ab7765$export$47af2aad60ab3e7c,
    faCompassDrafting: $1113a0aa61ab7765$export$aaaddd2cf7e20f64,
    faDraftingCompass: $1113a0aa61ab7765$export$c8c2b127d13b9d79,
    faPlateWheat: $1113a0aa61ab7765$export$2eff9f6cbe00a643,
    faIcicles: $1113a0aa61ab7765$export$78792ed87d92a3ad,
    faPersonShelter: $1113a0aa61ab7765$export$d359c2cc7640953c,
    faNeuter: $1113a0aa61ab7765$export$771cf879fba0cf93,
    faIdBadge: $1113a0aa61ab7765$export$a75288855ea05282,
    faMarker: $1113a0aa61ab7765$export$e6789173649caa25,
    faFaceLaughBeam: $1113a0aa61ab7765$export$3f2d51c0547bf984,
    faLaughBeam: $1113a0aa61ab7765$export$a88d1f4073ea9369,
    faHelicopterSymbol: $1113a0aa61ab7765$export$2a66e6044c1f7036,
    faUniversalAccess: $1113a0aa61ab7765$export$e119aada7f690d05,
    faCircleChevronUp: $1113a0aa61ab7765$export$7b69b3617b84259b,
    faChevronCircleUp: $1113a0aa61ab7765$export$b786cf5db03f2c36,
    faLariSign: $1113a0aa61ab7765$export$d317bc452442782d,
    faVolcano: $1113a0aa61ab7765$export$bae30a76735500e1,
    faPersonWalkingDashedLineArrowRight: $1113a0aa61ab7765$export$a1d09c95bee8043b,
    faSterlingSign: $1113a0aa61ab7765$export$170c56774c8e7961,
    faGbp: $1113a0aa61ab7765$export$3d9479ec1d1ae83e,
    faPoundSign: $1113a0aa61ab7765$export$9ce041dfec8319b,
    faViruses: $1113a0aa61ab7765$export$ee194b18f5c6f6b6,
    faSquarePersonConfined: $1113a0aa61ab7765$export$8aaca358568da0e0,
    faUserTie: $1113a0aa61ab7765$export$48c51dda34e9f04c,
    faArrowDownLong: $1113a0aa61ab7765$export$5977e8de7e65b20,
    faLongArrowDown: $1113a0aa61ab7765$export$52ecf90b62f3f030,
    faTentArrowDownToLine: $1113a0aa61ab7765$export$8a4f323f00a91606,
    faCertificate: $1113a0aa61ab7765$export$a881f37164b11fbf,
    faReplyAll: $1113a0aa61ab7765$export$ca6fd367f31ecbc5,
    faMailReplyAll: $1113a0aa61ab7765$export$8274334f3a2c1841,
    faSuitcase: $1113a0aa61ab7765$export$60710f3921019268,
    faPersonSkating: $1113a0aa61ab7765$export$f3854553fe688388,
    faSkating: $1113a0aa61ab7765$export$21bd1d54bd4f2c5a,
    faFilterCircleDollar: $1113a0aa61ab7765$export$3300e4b4d1d1936f,
    faFunnelDollar: $1113a0aa61ab7765$export$cebe38ad8f0a143d,
    faCameraRetro: $1113a0aa61ab7765$export$41dbdadc07a89b05,
    faCircleArrowDown: $1113a0aa61ab7765$export$a30c52cde32bec7e,
    faArrowCircleDown: $1113a0aa61ab7765$export$6cfa36bbb3a057,
    faFileImport: $1113a0aa61ab7765$export$d796c05153b1255c,
    faArrowRightToFile: $1113a0aa61ab7765$export$32f14beaf6294476,
    faSquareArrowUpRight: $1113a0aa61ab7765$export$38150b61dfd06fff,
    faExternalLinkSquare: $1113a0aa61ab7765$export$e04d83fed5ebcebf,
    faBoxOpen: $1113a0aa61ab7765$export$9010ed816a8b9c97,
    faScroll: $1113a0aa61ab7765$export$7c265716d4399676,
    faSpa: $1113a0aa61ab7765$export$f9a38ef7b046ab51,
    faLocationPinLock: $1113a0aa61ab7765$export$db853fbb474326cc,
    faPause: $1113a0aa61ab7765$export$da79f048408b1722,
    faHillAvalanche: $1113a0aa61ab7765$export$50d11c98c99e3b2d,
    faTemperatureEmpty: $1113a0aa61ab7765$export$ac389bf5cc37feb5,
    faTemperature0: $1113a0aa61ab7765$export$e99b7d2ccc282383,
    faThermometer0: $1113a0aa61ab7765$export$4c13a186ecce3b80,
    faThermometerEmpty: $1113a0aa61ab7765$export$81a2f8298cf523f9,
    faBomb: $1113a0aa61ab7765$export$d59078f6e80b4a67,
    faRegistered: $1113a0aa61ab7765$export$5f519e9ac15ab8c3,
    faAddressCard: $1113a0aa61ab7765$export$6ea408c7266ed557,
    faContactCard: $1113a0aa61ab7765$export$4ac51eb0b298b190,
    faVcard: $1113a0aa61ab7765$export$91228257deb1bf18,
    faScaleUnbalancedFlip: $1113a0aa61ab7765$export$f4d7840209109993,
    faBalanceScaleRight: $1113a0aa61ab7765$export$2238e05f8920005a,
    faSubscript: $1113a0aa61ab7765$export$34c1e678c32ed646,
    faDiamondTurnRight: $1113a0aa61ab7765$export$99749ac517cbef07,
    faDirections: $1113a0aa61ab7765$export$6a6973de44442fe5,
    faBurst: $1113a0aa61ab7765$export$ea2986b45ba5d2cf,
    faHouseLaptop: $1113a0aa61ab7765$export$6486d62e77b910,
    faLaptopHouse: $1113a0aa61ab7765$export$efd983de5e4d6ad3,
    faFaceTired: $1113a0aa61ab7765$export$5352cbdc070ce8d,
    faTired: $1113a0aa61ab7765$export$3d016d62cda18371,
    faMoneyBills: $1113a0aa61ab7765$export$a822dad6e586ee9e,
    faSmog: $1113a0aa61ab7765$export$aa11b8edb09fed14,
    faCrutch: $1113a0aa61ab7765$export$e94134641c0e2,
    faFontAwesome: $1113a0aa61ab7765$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $1113a0aa61ab7765$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $1113a0aa61ab7765$export$6e20d421a2e0f320,
    faCloudArrowUp: $1113a0aa61ab7765$export$3507214fff1cc655,
    faCloudUpload: $1113a0aa61ab7765$export$a48720e6366f5d9a,
    faCloudUploadAlt: $1113a0aa61ab7765$export$e73b3e819b9d14a5,
    faPalette: $1113a0aa61ab7765$export$5c390baea5db4f77,
    faArrowsTurnRight: $1113a0aa61ab7765$export$db9f783f15682c4a,
    faVest: $1113a0aa61ab7765$export$c8370e53051a657,
    faFerry: $1113a0aa61ab7765$export$fd312949b97346ae,
    faArrowsDownToPeople: $1113a0aa61ab7765$export$cfb044c7d35060bb,
    faSeedling: $1113a0aa61ab7765$export$d7b60b8dbd03cfe4,
    faSprout: $1113a0aa61ab7765$export$9f3035e3a8c62323,
    faLeftRight: $1113a0aa61ab7765$export$47d93e9001818ee7,
    faArrowsAltH: $1113a0aa61ab7765$export$7937ea574fb1389,
    faBoxesPacking: $1113a0aa61ab7765$export$e81e7f3390fe84fe,
    faCircleArrowLeft: $1113a0aa61ab7765$export$827fbb87bdbe1028,
    faArrowCircleLeft: $1113a0aa61ab7765$export$728262abb9f58d0a,
    faGroupArrowsRotate: $1113a0aa61ab7765$export$88a8383ecdd39a54,
    faBowlFood: $1113a0aa61ab7765$export$8b89ca3201039376,
    faCandyCane: $1113a0aa61ab7765$export$14d66ba7571ae0b9,
    faArrowDownWideShort: $1113a0aa61ab7765$export$4229d00802c33062,
    faSortAmountAsc: $1113a0aa61ab7765$export$ddf8b8dd5983367d,
    faSortAmountDown: $1113a0aa61ab7765$export$4b2a02d50e417b5f,
    faCloudBolt: $1113a0aa61ab7765$export$cdd116afa0309c17,
    faThunderstorm: $1113a0aa61ab7765$export$bbf9e3d433f8f6de,
    faTextSlash: $1113a0aa61ab7765$export$ec658c0f040c3e1a,
    faRemoveFormat: $1113a0aa61ab7765$export$d91179f327329532,
    faFaceSmileWink: $1113a0aa61ab7765$export$6143da800b0e6626,
    faSmileWink: $1113a0aa61ab7765$export$f5dbb37f6801ee3f,
    faFileWord: $1113a0aa61ab7765$export$f0858dff6e769cf6,
    faFilePowerpoint: $1113a0aa61ab7765$export$c341daeecdea449a,
    faArrowsLeftRight: $1113a0aa61ab7765$export$672e2f590b189583,
    faArrowsH: $1113a0aa61ab7765$export$de517642cdb40354,
    faHouseLock: $1113a0aa61ab7765$export$aa54b16c409e882f,
    faCloudArrowDown: $1113a0aa61ab7765$export$542a9676c5286e01,
    faCloudDownload: $1113a0aa61ab7765$export$b318977f29260464,
    faCloudDownloadAlt: $1113a0aa61ab7765$export$351357a14c41f824,
    faChildren: $1113a0aa61ab7765$export$f2819bf60df55912,
    faChalkboard: $1113a0aa61ab7765$export$49a36efd66df775,
    faBlackboard: $1113a0aa61ab7765$export$f497e01bf522fd9c,
    faUserLargeSlash: $1113a0aa61ab7765$export$ae7fc6b7f0534be9,
    faUserAltSlash: $1113a0aa61ab7765$export$46185fab4772ada6,
    faEnvelopeOpen: $1113a0aa61ab7765$export$c6c3bd5f7d9b8bf2,
    faHandshakeSimpleSlash: $1113a0aa61ab7765$export$e99ae494101c5e91,
    faHandshakeAltSlash: $1113a0aa61ab7765$export$ca302f956ae9f1bf,
    faMattressPillow: $1113a0aa61ab7765$export$f042d3e458efa721,
    faGuaraniSign: $1113a0aa61ab7765$export$b731a51acb74b00c,
    faArrowsRotate: $1113a0aa61ab7765$export$2fd091cb98dc8ab8,
    faRefresh: $1113a0aa61ab7765$export$fd4359e93d7b3d14,
    faSync: $1113a0aa61ab7765$export$ff87319002e3dae9,
    faFireExtinguisher: $1113a0aa61ab7765$export$d75fb6743634a0a,
    faCruzeiroSign: $1113a0aa61ab7765$export$64dd1b27affb6572,
    faGreaterThanEqual: $1113a0aa61ab7765$export$7bf8dfe2e6661a54,
    faShieldHalved: $1113a0aa61ab7765$export$36e034ccc72554a9,
    faShieldAlt: $1113a0aa61ab7765$export$d6508d18a824f291,
    faBookAtlas: $1113a0aa61ab7765$export$7fb8daedae341012,
    faAtlas: $1113a0aa61ab7765$export$380a9050e42fe5d7,
    faVirus: $1113a0aa61ab7765$export$37c67e0b3dc6bd1b,
    faEnvelopeCircleCheck: $1113a0aa61ab7765$export$74d890536dbd21b7,
    faLayerGroup: $1113a0aa61ab7765$export$a137712e11e257dd,
    faArrowsToDot: $1113a0aa61ab7765$export$ab3a06d4b53c0fc0,
    faArchway: $1113a0aa61ab7765$export$d56753dd2eb5c323,
    faHeartCircleCheck: $1113a0aa61ab7765$export$5e4b6785eedecc1a,
    faHouseChimneyCrack: $1113a0aa61ab7765$export$e824540f5a6a8a57,
    faHouseDamage: $1113a0aa61ab7765$export$8d7e943005ce0b49,
    faFileZipper: $1113a0aa61ab7765$export$7a4a0e4caa1e4e6f,
    faFileArchive: $1113a0aa61ab7765$export$bf2047a9946b5c3f,
    faSquare: $1113a0aa61ab7765$export$90b4406457aae8cc,
    faMartiniGlassEmpty: $1113a0aa61ab7765$export$a8a0de30198815a3,
    faGlassMartini: $1113a0aa61ab7765$export$e96f280e39af4a91,
    faCouch: $1113a0aa61ab7765$export$ce96e32767a7dd51,
    faCediSign: $1113a0aa61ab7765$export$66c557f70914132c,
    faItalic: $1113a0aa61ab7765$export$16e344bae4d495ed,
    faChurch: $1113a0aa61ab7765$export$16a3f12c6ae9650,
    faCommentsDollar: $1113a0aa61ab7765$export$d477129b070e5ac4,
    faDemocrat: $1113a0aa61ab7765$export$a1672d808fbed0bd,
    faZ: $1113a0aa61ab7765$export$3481c1aa28972f9b,
    faPersonSkiing: $1113a0aa61ab7765$export$5ebd3cd0630e3ae7,
    faSkiing: $1113a0aa61ab7765$export$eae1acab6fb96708,
    faRoadLock: $1113a0aa61ab7765$export$b81a894d5bc3eb17,
    faA: $1113a0aa61ab7765$export$406fe05808a3753e,
    faTemperatureArrowDown: $1113a0aa61ab7765$export$4520eb1840c4e110,
    faTemperatureDown: $1113a0aa61ab7765$export$f0b2aca3866f00f6,
    faFeatherPointed: $1113a0aa61ab7765$export$2a9d3e120019c92d,
    faFeatherAlt: $1113a0aa61ab7765$export$68cf766c786bcd78,
    faP: $1113a0aa61ab7765$export$bcb419f1cd5beac3,
    faSnowflake: $1113a0aa61ab7765$export$bab8f3647c394f48,
    faNewspaper: $1113a0aa61ab7765$export$d91b374112d4f8c1,
    faRectangleAd: $1113a0aa61ab7765$export$d0ccaddca9e06d1e,
    faAd: $1113a0aa61ab7765$export$7af266c3465b1ff2,
    faCircleArrowRight: $1113a0aa61ab7765$export$2f1e22e081a1ad05,
    faArrowCircleRight: $1113a0aa61ab7765$export$7d3d828103aa3be7,
    faFilterCircleXmark: $1113a0aa61ab7765$export$fb5ab619c34ea613,
    faLocust: $1113a0aa61ab7765$export$4982360d3b844c19,
    faSort: $1113a0aa61ab7765$export$4941c5969d5399b,
    faUnsorted: $1113a0aa61ab7765$export$418597748f0fe52d,
    faListOl: $1113a0aa61ab7765$export$3db8f67cd0fc963b,
    faList12: $1113a0aa61ab7765$export$7e3d894cd55296b,
    faListNumeric: $1113a0aa61ab7765$export$cf51408faadac277,
    faPersonDressBurst: $1113a0aa61ab7765$export$523180e731928397,
    faMoneyCheckDollar: $1113a0aa61ab7765$export$eeb59dd1825c6a65,
    faMoneyCheckAlt: $1113a0aa61ab7765$export$8c6ccc9745897cb2,
    faVectorSquare: $1113a0aa61ab7765$export$567d5631a7b0599f,
    faBreadSlice: $1113a0aa61ab7765$export$d78e8b0681279167,
    faLanguage: $1113a0aa61ab7765$export$8a7bee49fdf8c954,
    faFaceKissWinkHeart: $1113a0aa61ab7765$export$611ae61f02de0aa,
    faKissWinkHeart: $1113a0aa61ab7765$export$ebba617701dfb917,
    faFilter: $1113a0aa61ab7765$export$f253a38d7142e29f,
    faQuestion: $1113a0aa61ab7765$export$d96973f90e8f6e47,
    faFileSignature: $1113a0aa61ab7765$export$d0de575ac166712b,
    faUpDownLeftRight: $1113a0aa61ab7765$export$cd7b22f4e6e3834b,
    faArrowsAlt: $1113a0aa61ab7765$export$3cdabfff52cfc73a,
    faHouseChimneyUser: $1113a0aa61ab7765$export$1ddbaebce033a0d,
    faHandHoldingHeart: $1113a0aa61ab7765$export$97e5ef3e80a0fbef,
    faPuzzlePiece: $1113a0aa61ab7765$export$7ee0dbd1e92e2859,
    faMoneyCheck: $1113a0aa61ab7765$export$be069f641c85d0b3,
    faStarHalfStroke: $1113a0aa61ab7765$export$3e4892d8bf919edd,
    faStarHalfAlt: $1113a0aa61ab7765$export$c13575f42532efb3,
    faCode: $1113a0aa61ab7765$export$eba095993e51cc97,
    faWhiskeyGlass: $1113a0aa61ab7765$export$f1304dd34ea2afbd,
    faGlassWhiskey: $1113a0aa61ab7765$export$fdec0f5f1a169419,
    faBuildingCircleExclamation: $1113a0aa61ab7765$export$c49f030b19083ebe,
    faMagnifyingGlassChart: $1113a0aa61ab7765$export$6a1e4cdbb8ca10c5,
    faArrowUpRightFromSquare: $1113a0aa61ab7765$export$5ad84e891223f2c3,
    faExternalLink: $1113a0aa61ab7765$export$f4c613289034e5ef,
    faCubesStacked: $1113a0aa61ab7765$export$b1f00c433aabac05,
    faWonSign: $1113a0aa61ab7765$export$51790ddd26e431bc,
    faKrw: $1113a0aa61ab7765$export$2f65e07a45b95b50,
    faWon: $1113a0aa61ab7765$export$5a1fd3ed9564d7fa,
    faVirusCovid: $1113a0aa61ab7765$export$1df4e031b8ee4f84,
    faAustralSign: $1113a0aa61ab7765$export$299c200ad3db97b4,
    faF: $1113a0aa61ab7765$export$a2f384a559654618,
    faLeaf: $1113a0aa61ab7765$export$7c497bae2754a087,
    faRoad: $1113a0aa61ab7765$export$f224567a4851a5e9,
    faTaxi: $1113a0aa61ab7765$export$9958afcdfece1b58,
    faCab: $1113a0aa61ab7765$export$7bf12d9380f0971b,
    faPersonCirclePlus: $1113a0aa61ab7765$export$55686b1eb7d00307,
    faChartPie: $1113a0aa61ab7765$export$1de7b9cf7d1b153b,
    faPieChart: $1113a0aa61ab7765$export$7877286cd337de81,
    faBoltLightning: $1113a0aa61ab7765$export$b16dcd08f3da1ba2,
    faSackXmark: $1113a0aa61ab7765$export$2bad98c38bea5994,
    faFileExcel: $1113a0aa61ab7765$export$77cb1a465c4fe84,
    faFileContract: $1113a0aa61ab7765$export$70fde3f3fdaa6a6a,
    faFishFins: $1113a0aa61ab7765$export$e7af4f0123222b6f,
    faBuildingFlag: $1113a0aa61ab7765$export$592422b29ab0a914,
    faFaceGrinBeam: $1113a0aa61ab7765$export$3de52eeb00462407,
    faGrinBeam: $1113a0aa61ab7765$export$734da5249381ec7e,
    faObjectUngroup: $1113a0aa61ab7765$export$887f6345573abcac,
    faPoop: $1113a0aa61ab7765$export$bb45b6b87d1adf27,
    faLocationPin: $1113a0aa61ab7765$export$c0b7617de95c0c05,
    faMapMarker: $1113a0aa61ab7765$export$10d360e4f1a554dd,
    faKaaba: $1113a0aa61ab7765$export$ab1408bfbe914cc9,
    faToiletPaper: $1113a0aa61ab7765$export$c8cc083ccc72b17,
    faHelmetSafety: $1113a0aa61ab7765$export$aacaf42fba617981,
    faHardHat: $1113a0aa61ab7765$export$7b72177558a98b6f,
    faHatHard: $1113a0aa61ab7765$export$c0e235dbf1644a2f,
    faEject: $1113a0aa61ab7765$export$8484041d5b209494,
    faCircleRight: $1113a0aa61ab7765$export$1fec48c8bdd69c1d,
    faArrowAltCircleRight: $1113a0aa61ab7765$export$88962ffdad8b856d,
    faPlaneCircleCheck: $1113a0aa61ab7765$export$9cbf8612c6cadc74,
    faFaceRollingEyes: $1113a0aa61ab7765$export$a6d72a9a068392b5,
    faMehRollingEyes: $1113a0aa61ab7765$export$fdc62a1bea767cc2,
    faObjectGroup: $1113a0aa61ab7765$export$40cdac24aa94a57a,
    faChartLine: $1113a0aa61ab7765$export$e022f62a119e1d93,
    faLineChart: $1113a0aa61ab7765$export$f729617a20de475b,
    faMaskVentilator: $1113a0aa61ab7765$export$122c8413a0dc5ff6,
    faArrowRight: $1113a0aa61ab7765$export$b4da69a0247f3620,
    faSignsPost: $1113a0aa61ab7765$export$905f45f8ffd6b8e5,
    faMapSigns: $1113a0aa61ab7765$export$743f4b1071b3333a,
    faCashRegister: $1113a0aa61ab7765$export$6357093f67788b33,
    faPersonCircleQuestion: $1113a0aa61ab7765$export$c8f8a597ffd676c0,
    faH: $1113a0aa61ab7765$export$d762b7b66d5875e1,
    faTarp: $1113a0aa61ab7765$export$2305b1a41b3f914,
    faScrewdriverWrench: $1113a0aa61ab7765$export$158a12f36bbecf9,
    faTools: $1113a0aa61ab7765$export$646e4e7a8c6172aa,
    faArrowsToEye: $1113a0aa61ab7765$export$9adae865350879af,
    faPlugCircleBolt: $1113a0aa61ab7765$export$4f3b3144ce966486,
    faHeart: $1113a0aa61ab7765$export$e4b51a47a2f8b9db,
    faMarsAndVenus: $1113a0aa61ab7765$export$808b88e8735e31e8,
    faHouseUser: $1113a0aa61ab7765$export$9a513ee921e8e885,
    faHomeUser: $1113a0aa61ab7765$export$e732fa55ae5bbdf0,
    faDumpsterFire: $1113a0aa61ab7765$export$25e9b29b3f2230b5,
    faHouseCrack: $1113a0aa61ab7765$export$baa3c215534dbf2a,
    faMartiniGlassCitrus: $1113a0aa61ab7765$export$c6e76550bdc0255d,
    faCocktail: $1113a0aa61ab7765$export$4be708f1e41d387b,
    faFaceSurprise: $1113a0aa61ab7765$export$c938968e28178994,
    faSurprise: $1113a0aa61ab7765$export$46647c72213f53ba,
    faBottleWater: $1113a0aa61ab7765$export$3ee278c67519eeeb,
    faCirclePause: $1113a0aa61ab7765$export$fbeef2513e05ad08,
    faPauseCircle: $1113a0aa61ab7765$export$d8cf08a0362da8db,
    faToiletPaperSlash: $1113a0aa61ab7765$export$7a494edbf9b65575,
    faAppleWhole: $1113a0aa61ab7765$export$12de8220d30453a3,
    faAppleAlt: $1113a0aa61ab7765$export$bcdd94f3977a0884,
    faKitchenSet: $1113a0aa61ab7765$export$64c1570509eaf40d,
    faR: $1113a0aa61ab7765$export$eb4c616de6eef46f,
    faTemperatureQuarter: $1113a0aa61ab7765$export$f9d1c19925fd7fa8,
    faTemperature1: $1113a0aa61ab7765$export$d4f1cd380bde2129,
    faThermometer1: $1113a0aa61ab7765$export$3f77fbe2dabe285b,
    faThermometerQuarter: $1113a0aa61ab7765$export$ed05754fcbec6e46,
    faCube: $1113a0aa61ab7765$export$973ae4f1e4d2ce78,
    faBitcoinSign: $1113a0aa61ab7765$export$441bfc8058328ce8,
    faShieldDog: $1113a0aa61ab7765$export$2a5c6f182c0cbcb,
    faSolarPanel: $1113a0aa61ab7765$export$b9c649c5e37017f3,
    faLockOpen: $1113a0aa61ab7765$export$84b5acad4436d02a,
    faElevator: $1113a0aa61ab7765$export$c7a833ce065e0ea4,
    faMoneyBillTransfer: $1113a0aa61ab7765$export$1b71392d9effbe,
    faMoneyBillTrendUp: $1113a0aa61ab7765$export$18ab80cba7d5044f,
    faHouseFloodWaterCircleArrowRight: $1113a0aa61ab7765$export$30d3e64480aa266b,
    faSquarePollHorizontal: $1113a0aa61ab7765$export$287bdd70ab874659,
    faPollH: $1113a0aa61ab7765$export$456a238f0144d430,
    faCircle: $1113a0aa61ab7765$export$4280b2387fbdad12,
    faBackwardFast: $1113a0aa61ab7765$export$662cbc6ed5a3c5e8,
    faFastBackward: $1113a0aa61ab7765$export$e6246a3279a379b8,
    faRecycle: $1113a0aa61ab7765$export$a65c441f12cb6bd,
    faUserAstronaut: $1113a0aa61ab7765$export$94363e983c225a04,
    faPlaneSlash: $1113a0aa61ab7765$export$cfee4df0d5df6d21,
    faTrademark: $1113a0aa61ab7765$export$9c9b2fbddd59047d,
    faBasketball: $1113a0aa61ab7765$export$44dee69e3a29b0e,
    faBasketballBall: $1113a0aa61ab7765$export$36550ab8ffcc5b28,
    faSatelliteDish: $1113a0aa61ab7765$export$219ccae0e4da3c92,
    faCircleUp: $1113a0aa61ab7765$export$72ea8a5e4e86cd69,
    faArrowAltCircleUp: $1113a0aa61ab7765$export$3747a8ef0995eadf,
    faMobileScreenButton: $1113a0aa61ab7765$export$da39ed20699ee2d7,
    faMobileAlt: $1113a0aa61ab7765$export$e9599bc6cd92234d,
    faVolumeHigh: $1113a0aa61ab7765$export$39461921e738be65,
    faVolumeUp: $1113a0aa61ab7765$export$5940d3e475d90cc4,
    faUsersRays: $1113a0aa61ab7765$export$9c0b63b698611d06,
    faWallet: $1113a0aa61ab7765$export$79204db8777905c8,
    faClipboardCheck: $1113a0aa61ab7765$export$7babcb2c90eb609a,
    faFileAudio: $1113a0aa61ab7765$export$b8d24c57c9e64933,
    faBurger: $1113a0aa61ab7765$export$128a6cab12423493,
    faHamburger: $1113a0aa61ab7765$export$bab3bb9f4f59363,
    faWrench: $1113a0aa61ab7765$export$3c6c0c8185296ac5,
    faBugs: $1113a0aa61ab7765$export$f5bfd1271b8b71d1,
    faRupeeSign: $1113a0aa61ab7765$export$8bf9e3f7f57d486a,
    faRupee: $1113a0aa61ab7765$export$9da25a46cfcb6fa4,
    faFileImage: $1113a0aa61ab7765$export$6440b286d3cbac9b,
    faCircleQuestion: $1113a0aa61ab7765$export$d7cf0978afd90002,
    faQuestionCircle: $1113a0aa61ab7765$export$5ba67d7f2265c1a5,
    faPlaneDeparture: $1113a0aa61ab7765$export$6ccbeeccfea6dc8a,
    faHandshakeSlash: $1113a0aa61ab7765$export$2cef3f81ad90fb76,
    faBookBookmark: $1113a0aa61ab7765$export$3d177ecdf7fc50ec,
    faCodeBranch: $1113a0aa61ab7765$export$aa054a78ab078db3,
    faHatCowboy: $1113a0aa61ab7765$export$37672611144b857b,
    faBridge: $1113a0aa61ab7765$export$f402c7c97f3383f0,
    faPhoneFlip: $1113a0aa61ab7765$export$d86c56ab43eb0deb,
    faPhoneAlt: $1113a0aa61ab7765$export$a07a9b305deebf32,
    faTruckFront: $1113a0aa61ab7765$export$4a5a13c01d46357c,
    faCat: $1113a0aa61ab7765$export$ab927dada03be4b3,
    faAnchorCircleExclamation: $1113a0aa61ab7765$export$61add9eca991b5ec,
    faTruckField: $1113a0aa61ab7765$export$f4419f7b2e53b340,
    faRoute: $1113a0aa61ab7765$export$806c0a45a7ecd6e8,
    faClipboardQuestion: $1113a0aa61ab7765$export$d4aa151a4554b74e,
    faPanorama: $1113a0aa61ab7765$export$5dd22dcb6e3ed369,
    faCommentMedical: $1113a0aa61ab7765$export$101422b773924276,
    faTeethOpen: $1113a0aa61ab7765$export$c88ac21fe7c88ae6,
    faFileCircleMinus: $1113a0aa61ab7765$export$4b89fabf50a10951,
    faTags: $1113a0aa61ab7765$export$d55778e3ab6c933f,
    faWineGlass: $1113a0aa61ab7765$export$e06d6607d3577d6e,
    faForwardFast: $1113a0aa61ab7765$export$dc9cc4280bee320d,
    faFastForward: $1113a0aa61ab7765$export$61a8cdc53c2e078d,
    faFaceMehBlank: $1113a0aa61ab7765$export$38c072b870a9e4ab,
    faMehBlank: $1113a0aa61ab7765$export$e945435725f71e88,
    faSquareParking: $1113a0aa61ab7765$export$f2cfa036d76f69ab,
    faParking: $1113a0aa61ab7765$export$fda29c8f99573a4e,
    faHouseSignal: $1113a0aa61ab7765$export$58845db8e7e9a199,
    faBarsProgress: $1113a0aa61ab7765$export$ee3a02da18715b2,
    faTasksAlt: $1113a0aa61ab7765$export$bbc0784fc1578f7f,
    faFaucetDrip: $1113a0aa61ab7765$export$7a255960242435f6,
    faCartFlatbed: $1113a0aa61ab7765$export$df587aaf7765e1ce,
    faDollyFlatbed: $1113a0aa61ab7765$export$f7c6efb60c53b285,
    faBanSmoking: $1113a0aa61ab7765$export$130df7ed74437774,
    faSmokingBan: $1113a0aa61ab7765$export$e50452a49dec29f,
    faTerminal: $1113a0aa61ab7765$export$5e63e8b85b5f119c,
    faMobileButton: $1113a0aa61ab7765$export$c93d62849efbdd11,
    faHouseMedicalFlag: $1113a0aa61ab7765$export$86c50f517be57a40,
    faBasketShopping: $1113a0aa61ab7765$export$1d307c13b511e8e1,
    faShoppingBasket: $1113a0aa61ab7765$export$ca6d443595a6578f,
    faTape: $1113a0aa61ab7765$export$b88ed5e1e0eac4c6,
    faBusSimple: $1113a0aa61ab7765$export$d3724faf0c559353,
    faBusAlt: $1113a0aa61ab7765$export$40616edfab6d332a,
    faEye: $1113a0aa61ab7765$export$b8c3e79e8c99c95b,
    faFaceSadCry: $1113a0aa61ab7765$export$e8ea88c55e55be7c,
    faSadCry: $1113a0aa61ab7765$export$8e924e6bd422cef9,
    faAudioDescription: $1113a0aa61ab7765$export$b6b464c98c009494,
    faPersonMilitaryToPerson: $1113a0aa61ab7765$export$41b1e14a6b0fe11b,
    faFileShield: $1113a0aa61ab7765$export$348a01df65a66c99,
    faUserSlash: $1113a0aa61ab7765$export$3924ab4d3ef9b5ef,
    faPen: $1113a0aa61ab7765$export$8f4567331fb0d3bc,
    faTowerObservation: $1113a0aa61ab7765$export$5b2f0f631f559d51,
    faFileCode: $1113a0aa61ab7765$export$143d0ca7d2200f20,
    faSignal: $1113a0aa61ab7765$export$79046b073b6c584d,
    faSignal5: $1113a0aa61ab7765$export$3417071118065933,
    faSignalPerfect: $1113a0aa61ab7765$export$1aea50ab3e99cc95,
    faBus: $1113a0aa61ab7765$export$ce69441578ff2fdb,
    faHeartCircleXmark: $1113a0aa61ab7765$export$742f89ae2f8d6b20,
    faHouseChimney: $1113a0aa61ab7765$export$af554427144a7e5c,
    faHomeLg: $1113a0aa61ab7765$export$dbab81727ec94698,
    faWindowMaximize: $1113a0aa61ab7765$export$703cd98be31ec905,
    faFaceFrown: $1113a0aa61ab7765$export$e5f78e87efbb0248,
    faFrown: $1113a0aa61ab7765$export$43b7108508aecc5f,
    faPrescription: $1113a0aa61ab7765$export$8767bafb19515ee4,
    faShop: $1113a0aa61ab7765$export$78edc9b98453b6f7,
    faStoreAlt: $1113a0aa61ab7765$export$1f1871dab9cec9d8,
    faFloppyDisk: $1113a0aa61ab7765$export$f62f2879ccaea13f,
    faSave: $1113a0aa61ab7765$export$1aaa83ff70706e1e,
    faVihara: $1113a0aa61ab7765$export$ee4b92e89fe0dfaf,
    faScaleUnbalanced: $1113a0aa61ab7765$export$4d10bcc8d068f454,
    faBalanceScaleLeft: $1113a0aa61ab7765$export$786cb0c775487f19,
    faSortUp: $1113a0aa61ab7765$export$f9dd5b1410e95035,
    faSortAsc: $1113a0aa61ab7765$export$e4c8c924b1cc43a7,
    faCommentDots: $1113a0aa61ab7765$export$63ffcb3d4e94cb92,
    faCommenting: $1113a0aa61ab7765$export$49ee382a2425e89c,
    faPlantWilt: $1113a0aa61ab7765$export$77a38850ff8b0407,
    faDiamond: $1113a0aa61ab7765$export$f214f827e0023247,
    faFaceGrinSquint: $1113a0aa61ab7765$export$5d53da7627754bc6,
    faGrinSquint: $1113a0aa61ab7765$export$243ae757907b1580,
    faHandHoldingDollar: $1113a0aa61ab7765$export$61a67f5f8ab39be,
    faHandHoldingUsd: $1113a0aa61ab7765$export$47d27bc305b59690,
    faBacterium: $1113a0aa61ab7765$export$b0babe4230e35ebe,
    faHandPointer: $1113a0aa61ab7765$export$d97ff927c450c87f,
    faDrumSteelpan: $1113a0aa61ab7765$export$48d1206500db2e9d,
    faHandScissors: $1113a0aa61ab7765$export$c578e919f2c5c135,
    faHandsPraying: $1113a0aa61ab7765$export$a96374faedb12593,
    faPrayingHands: $1113a0aa61ab7765$export$95e08e91b0929943,
    faArrowRotateRight: $1113a0aa61ab7765$export$9c58ddc4b3356f98,
    faArrowRightRotate: $1113a0aa61ab7765$export$ffa1245982c1b28b,
    faArrowRotateForward: $1113a0aa61ab7765$export$89c59b5f47067f4c,
    faRedo: $1113a0aa61ab7765$export$3d9f98aa1c24c776,
    faBiohazard: $1113a0aa61ab7765$export$ae3a453550dec95,
    faLocationCrosshairs: $1113a0aa61ab7765$export$14e1096ad1719098,
    faLocation: $1113a0aa61ab7765$export$45e012c32174eb5d,
    faMarsDouble: $1113a0aa61ab7765$export$2f8a28204bb4b86f,
    faChildDress: $1113a0aa61ab7765$export$f31a37ecbfd4e707,
    faUsersBetweenLines: $1113a0aa61ab7765$export$6ea1decf8bb3513d,
    faLungsVirus: $1113a0aa61ab7765$export$895159d10626af74,
    faFaceGrinTears: $1113a0aa61ab7765$export$8ac6d81a3d5b40a1,
    faGrinTears: $1113a0aa61ab7765$export$b2f7512221512b5b,
    faPhone: $1113a0aa61ab7765$export$ddab067855cf34cb,
    faCalendarXmark: $1113a0aa61ab7765$export$3c70ffe5660af060,
    faCalendarTimes: $1113a0aa61ab7765$export$99b20d7352fbcf08,
    faChildReaching: $1113a0aa61ab7765$export$84a2f9476730c40e,
    faHeadSideVirus: $1113a0aa61ab7765$export$5b64b916710da7c7,
    faUserGear: $1113a0aa61ab7765$export$f504a6909b677146,
    faUserCog: $1113a0aa61ab7765$export$474108c2b86e730e,
    faArrowUp19: $1113a0aa61ab7765$export$bbbff45e04f4abab,
    faSortNumericUp: $1113a0aa61ab7765$export$d213a3ba3cabed48,
    faDoorClosed: $1113a0aa61ab7765$export$2c79e1a422528bba,
    faShieldVirus: $1113a0aa61ab7765$export$bea811bbf570f05a,
    faDiceSix: $1113a0aa61ab7765$export$3397c7b4679acccc,
    faMosquitoNet: $1113a0aa61ab7765$export$f3858ce1b3218e2,
    faBridgeWater: $1113a0aa61ab7765$export$154e99cb34841765,
    faPersonBooth: $1113a0aa61ab7765$export$2337c975289bdd84,
    faTextWidth: $1113a0aa61ab7765$export$d8724cf433389700,
    faHatWizard: $1113a0aa61ab7765$export$7daa48199dcb2ad1,
    faPenFancy: $1113a0aa61ab7765$export$8bdfe14ac72a8b17,
    faPersonDigging: $1113a0aa61ab7765$export$f4d483fca19a4604,
    faDigging: $1113a0aa61ab7765$export$7bd93e3343bd5671,
    faTrash: $1113a0aa61ab7765$export$ed8c149a0ea54bb4,
    faGaugeSimple: $1113a0aa61ab7765$export$f3a0a4e6723a86d4,
    faGaugeSimpleMed: $1113a0aa61ab7765$export$ba8c12ff7cfa2521,
    faTachometerAverage: $1113a0aa61ab7765$export$94fcfd6f6335431b,
    faBookMedical: $1113a0aa61ab7765$export$6feb44fec53ba30d,
    faPoo: $1113a0aa61ab7765$export$dd0ede1713d2d2f9,
    faQuoteRight: $1113a0aa61ab7765$export$54e3a80c9875b74c,
    faQuoteRightAlt: $1113a0aa61ab7765$export$dd692f2e88bd4b1a,
    faShirt: $1113a0aa61ab7765$export$312f2c01c6fedca8,
    faTShirt: $1113a0aa61ab7765$export$144e5f8bc4d705a6,
    faTshirt: $1113a0aa61ab7765$export$36edce3ba87c2b17,
    faCubes: $1113a0aa61ab7765$export$30523a9441a31e97,
    faDivide: $1113a0aa61ab7765$export$89fa217ec5503ac9,
    faTengeSign: $1113a0aa61ab7765$export$c04e864469c1d117,
    faTenge: $1113a0aa61ab7765$export$af6ebee83047b793,
    faHeadphones: $1113a0aa61ab7765$export$ad02dd8ca5816958,
    faHandsHolding: $1113a0aa61ab7765$export$96891bbcda1dbb7b,
    faHandsClapping: $1113a0aa61ab7765$export$765c446e974b5e59,
    faRepublican: $1113a0aa61ab7765$export$929518bb4b66a588,
    faArrowLeft: $1113a0aa61ab7765$export$b7fac681e7d09400,
    faPersonCircleXmark: $1113a0aa61ab7765$export$16c9e0374c346c6e,
    faRuler: $1113a0aa61ab7765$export$8e90575265a56cfc,
    faAlignLeft: $1113a0aa61ab7765$export$e490f662af4d1c78,
    faDiceD6: $1113a0aa61ab7765$export$64bfd48ed353c031,
    faRestroom: $1113a0aa61ab7765$export$5fbcef35138741a5,
    faJ: $1113a0aa61ab7765$export$bbf24078bd1f73e6,
    faUsersViewfinder: $1113a0aa61ab7765$export$72b785dcfe44c69b,
    faFileVideo: $1113a0aa61ab7765$export$b44eb38345c6a964,
    faUpRightFromSquare: $1113a0aa61ab7765$export$c1a3ba061b4f60c4,
    faExternalLinkAlt: $1113a0aa61ab7765$export$d7f107e456ab0306,
    faTableCells: $1113a0aa61ab7765$export$c517dffc18db483f,
    faTh: $1113a0aa61ab7765$export$4d383c83efc0c819,
    faFilePdf: $1113a0aa61ab7765$export$38611f1c776aba73,
    faBookBible: $1113a0aa61ab7765$export$df8194b081d34b27,
    faBible: $1113a0aa61ab7765$export$2eac809b0670d139,
    faO: $1113a0aa61ab7765$export$9db87eabf605857e,
    faSuitcaseMedical: $1113a0aa61ab7765$export$25ea11267429d202,
    faMedkit: $1113a0aa61ab7765$export$e75f02bae5b7d34b,
    faUserSecret: $1113a0aa61ab7765$export$597826232327559b,
    faOtter: $1113a0aa61ab7765$export$743cce3ca4eb1d7d,
    faPersonDress: $1113a0aa61ab7765$export$27f7383b96c3f4b4,
    faFemale: $1113a0aa61ab7765$export$70e8e75e61dd7169,
    faCommentDollar: $1113a0aa61ab7765$export$7a088030853df12c,
    faBusinessTime: $1113a0aa61ab7765$export$694b7e88782dec12,
    faBriefcaseClock: $1113a0aa61ab7765$export$8b00ae94743552ce,
    faTableCellsLarge: $1113a0aa61ab7765$export$d2bcaf492dfb3817,
    faThLarge: $1113a0aa61ab7765$export$69782f333e90cdc6,
    faBookTanakh: $1113a0aa61ab7765$export$24c764717169f536,
    faTanakh: $1113a0aa61ab7765$export$7fd4a58929315448,
    faPhoneVolume: $1113a0aa61ab7765$export$c377f240bb8b5d74,
    faVolumeControlPhone: $1113a0aa61ab7765$export$5358d004fa3d3be2,
    faHatCowboySide: $1113a0aa61ab7765$export$ab6f71fd6878da90,
    faClipboardUser: $1113a0aa61ab7765$export$1204f2d171424659,
    faChild: $1113a0aa61ab7765$export$60b41e3581d1739a,
    faLiraSign: $1113a0aa61ab7765$export$f0f37dbc60110b10,
    faSatellite: $1113a0aa61ab7765$export$da3f1730d013e224,
    faPlaneLock: $1113a0aa61ab7765$export$1125ac57be52258c,
    faTag: $1113a0aa61ab7765$export$cb61f447f29887e,
    faComment: $1113a0aa61ab7765$export$805cd88398a70581,
    faCakeCandles: $1113a0aa61ab7765$export$e4019fe302a972e1,
    faBirthdayCake: $1113a0aa61ab7765$export$bdcf98f725a7241a,
    faCake: $1113a0aa61ab7765$export$707bc1c80c0177c1,
    faEnvelope: $1113a0aa61ab7765$export$6f095630677adc,
    faAnglesUp: $1113a0aa61ab7765$export$152ef92a4f9d80a7,
    faAngleDoubleUp: $1113a0aa61ab7765$export$9bb51e1a2c07db7c,
    faPaperclip: $1113a0aa61ab7765$export$4b24ca1552f410af,
    faArrowRightToCity: $1113a0aa61ab7765$export$e201217e5046cd15,
    faRibbon: $1113a0aa61ab7765$export$838459d11f3971df,
    faLungs: $1113a0aa61ab7765$export$ba9b387e84727819,
    faArrowUp91: $1113a0aa61ab7765$export$25218e5886296cb9,
    faSortNumericUpAlt: $1113a0aa61ab7765$export$d41859f1bbb9e086,
    faLitecoinSign: $1113a0aa61ab7765$export$4a157bd81dcd8d80,
    faBorderNone: $1113a0aa61ab7765$export$2b488402ec335d97,
    faCircleNodes: $1113a0aa61ab7765$export$de462dd5a18e80d4,
    faParachuteBox: $1113a0aa61ab7765$export$ca9e3368f1d9500a,
    faIndent: $1113a0aa61ab7765$export$318208bc30aeebcc,
    faTruckFieldUn: $1113a0aa61ab7765$export$40cb0a4a3a74dc03,
    faHourglass: $1113a0aa61ab7765$export$b9098a890f61e022,
    faHourglassEmpty: $1113a0aa61ab7765$export$a2f8176a0161e891,
    faMountain: $1113a0aa61ab7765$export$64f9eb99c9749cce,
    faUserDoctor: $1113a0aa61ab7765$export$9884bf227eeb829,
    faUserMd: $1113a0aa61ab7765$export$ab0d33a2c03f1794,
    faCircleInfo: $1113a0aa61ab7765$export$317f99f46b39906e,
    faInfoCircle: $1113a0aa61ab7765$export$aa9288aeadf882fa,
    faCloudMeatball: $1113a0aa61ab7765$export$5d120e8b87ad33f4,
    faCamera: $1113a0aa61ab7765$export$84ffbd7161ca2008,
    faCameraAlt: $1113a0aa61ab7765$export$8872b5664e88e793,
    faSquareVirus: $1113a0aa61ab7765$export$f9409a7b020dbec4,
    faMeteor: $1113a0aa61ab7765$export$1439f0d6365138da,
    faCarOn: $1113a0aa61ab7765$export$d901d50df5cf8d91,
    faSleigh: $1113a0aa61ab7765$export$26a8fd1143d2d6c0,
    faArrowDown19: $1113a0aa61ab7765$export$9a40d582bd4628fb,
    faSortNumericAsc: $1113a0aa61ab7765$export$a4fb1aa2cdfb18d7,
    faSortNumericDown: $1113a0aa61ab7765$export$835db7eb35b3c29b,
    faHandHoldingDroplet: $1113a0aa61ab7765$export$b9c3f9a906f96b82,
    faHandHoldingWater: $1113a0aa61ab7765$export$4265371b99d38b95,
    faWater: $1113a0aa61ab7765$export$efaeddad0a6e901b,
    faCalendarCheck: $1113a0aa61ab7765$export$5655108e1162ba45,
    faBraille: $1113a0aa61ab7765$export$983e9c27cac7ed1c,
    faPrescriptionBottleMedical: $1113a0aa61ab7765$export$99cfe064ff0b71c9,
    faPrescriptionBottleAlt: $1113a0aa61ab7765$export$65d1c884b8581d1a,
    faLandmark: $1113a0aa61ab7765$export$2bebc54c51db6505,
    faTruck: $1113a0aa61ab7765$export$d7895f386f8bd8b8,
    faCrosshairs: $1113a0aa61ab7765$export$721c101130c40043,
    faPersonCane: $1113a0aa61ab7765$export$c48422e9da776c1b,
    faTent: $1113a0aa61ab7765$export$e5075400db564e24,
    faVestPatches: $1113a0aa61ab7765$export$750a64470c2e0f3f,
    faCheckDouble: $1113a0aa61ab7765$export$f178c8c2ad3cc861,
    faArrowDownAZ: $1113a0aa61ab7765$export$43b642fac7053978,
    faSortAlphaAsc: $1113a0aa61ab7765$export$cb87697f2fa77cfc,
    faSortAlphaDown: $1113a0aa61ab7765$export$7658045270aafde3,
    faMoneyBillWheat: $1113a0aa61ab7765$export$6a4ef2ef77625063,
    faCookie: $1113a0aa61ab7765$export$b3e64f5f68c6623f,
    faArrowRotateLeft: $1113a0aa61ab7765$export$89b706873769c180,
    faArrowLeftRotate: $1113a0aa61ab7765$export$1aea864c3e1d79b,
    faArrowRotateBack: $1113a0aa61ab7765$export$a34701878babe5fc,
    faArrowRotateBackward: $1113a0aa61ab7765$export$fce381d12e4535cd,
    faUndo: $1113a0aa61ab7765$export$a5e5ba60b1dfe2b2,
    faHardDrive: $1113a0aa61ab7765$export$4cb736b866cbb7ec,
    faHdd: $1113a0aa61ab7765$export$62551e9c5ba7093f,
    faFaceGrinSquintTears: $1113a0aa61ab7765$export$8ff56f5ebb8416a0,
    faGrinSquintTears: $1113a0aa61ab7765$export$542206d6a85f3b42,
    faDumbbell: $1113a0aa61ab7765$export$56700074cf37be5c,
    faRectangleList: $1113a0aa61ab7765$export$1f7600fa9fdb3978,
    faListAlt: $1113a0aa61ab7765$export$c6327a203ffc65a3,
    faTarpDroplet: $1113a0aa61ab7765$export$1585b7c3c7109751,
    faHouseMedicalCircleCheck: $1113a0aa61ab7765$export$5d08d08f88a96aac,
    faPersonSkiingNordic: $1113a0aa61ab7765$export$c8cd1786449517d3,
    faSkiingNordic: $1113a0aa61ab7765$export$6ea48260d7d09b1b,
    faCalendarPlus: $1113a0aa61ab7765$export$16768a660ae3ca9d,
    faPlaneArrival: $1113a0aa61ab7765$export$9b2dbe133273f284,
    faCircleLeft: $1113a0aa61ab7765$export$5ae86b9da9cca3bd,
    faArrowAltCircleLeft: $1113a0aa61ab7765$export$5460a5b11a24996f,
    faTrainSubway: $1113a0aa61ab7765$export$cda326cc3bce41c,
    faSubway: $1113a0aa61ab7765$export$4cabc8a12d4e2f9,
    faChartGantt: $1113a0aa61ab7765$export$dce43b02b3fe0c18,
    faIndianRupeeSign: $1113a0aa61ab7765$export$1d2b135cc5a2c852,
    faIndianRupee: $1113a0aa61ab7765$export$be886a4def17c565,
    faInr: $1113a0aa61ab7765$export$12c6d8b3e052490b,
    faCropSimple: $1113a0aa61ab7765$export$c3605731beb92daf,
    faCropAlt: $1113a0aa61ab7765$export$d932915fde4f1010,
    faMoneyBill1: $1113a0aa61ab7765$export$a312c7d58dd44a75,
    faMoneyBillAlt: $1113a0aa61ab7765$export$a35d573395884c3d,
    faLeftLong: $1113a0aa61ab7765$export$1db7e2ee10d36035,
    faLongArrowAltLeft: $1113a0aa61ab7765$export$a8b3226b2bf323d,
    faDna: $1113a0aa61ab7765$export$c062100d54a2da00,
    faVirusSlash: $1113a0aa61ab7765$export$c4ff5306c5470939,
    faMinus: $1113a0aa61ab7765$export$fee0376c250cdef,
    faSubtract: $1113a0aa61ab7765$export$f8cb2531ef1fc4a2,
    faChess: $1113a0aa61ab7765$export$442fddbbd741c590,
    faArrowLeftLong: $1113a0aa61ab7765$export$6e5225f0e6c0bacd,
    faLongArrowLeft: $1113a0aa61ab7765$export$80896efc906118b4,
    faPlugCircleCheck: $1113a0aa61ab7765$export$2bd45e99b9afa947,
    faStreetView: $1113a0aa61ab7765$export$6aab6c3359c2554c,
    faFrancSign: $1113a0aa61ab7765$export$acef3e5c2029d285,
    faVolumeOff: $1113a0aa61ab7765$export$d94ba52e980ea0f1,
    faHandsAslInterpreting: $1113a0aa61ab7765$export$bc43eb4655c78f49,
    faAmericanSignLanguageInterpreting: $1113a0aa61ab7765$export$23a7517099ab1b86,
    faAslInterpreting: $1113a0aa61ab7765$export$beb51abfb05a4eca,
    faHandsAmericanSignLanguageInterpreting: $1113a0aa61ab7765$export$82846008645b0301,
    faGear: $1113a0aa61ab7765$export$ec05accb7226d001,
    faCog: $1113a0aa61ab7765$export$d6298bbfd1912a78,
    faDropletSlash: $1113a0aa61ab7765$export$1d6c5a49025d720b,
    faTintSlash: $1113a0aa61ab7765$export$5d6f0943039b898f,
    faMosque: $1113a0aa61ab7765$export$4999586d7e1087fb,
    faMosquito: $1113a0aa61ab7765$export$67c7a1518d0715ff,
    faStarOfDavid: $1113a0aa61ab7765$export$f823fee3712b2601,
    faPersonMilitaryRifle: $1113a0aa61ab7765$export$842b988dae95ccb8,
    faCartShopping: $1113a0aa61ab7765$export$c790b41dc166ae13,
    faShoppingCart: $1113a0aa61ab7765$export$51da406e5aa1388c,
    faVials: $1113a0aa61ab7765$export$507e8edd7676b2e9,
    faPlugCirclePlus: $1113a0aa61ab7765$export$f193138a7d21971c,
    faPlaceOfWorship: $1113a0aa61ab7765$export$c5a9302c8c13c79a,
    faGripVertical: $1113a0aa61ab7765$export$cacbd95c283996ec,
    faArrowTurnUp: $1113a0aa61ab7765$export$2d3ccb9b2099f3fe,
    faLevelUp: $1113a0aa61ab7765$export$c227d3ba1de97ceb,
    faU: $1113a0aa61ab7765$export$4f39e8dbaf09ea8b,
    faSquareRootVariable: $1113a0aa61ab7765$export$60b44cfa7af18422,
    faSquareRootAlt: $1113a0aa61ab7765$export$28e4b96627e00057,
    faClock: $1113a0aa61ab7765$export$95b9968e7fceb821,
    faClockFour: $1113a0aa61ab7765$export$9a575facf1cab48f,
    faBackwardStep: $1113a0aa61ab7765$export$5d2b6a700940df16,
    faStepBackward: $1113a0aa61ab7765$export$2884e379aed297d4,
    faPallet: $1113a0aa61ab7765$export$d7ff2047dbc34562,
    faFaucet: $1113a0aa61ab7765$export$a0856b225f3b0614,
    faBaseballBatBall: $1113a0aa61ab7765$export$59669f486ab41d86,
    faS: $1113a0aa61ab7765$export$cb39585371b75720,
    faTimeline: $1113a0aa61ab7765$export$5e239d90ef904a84,
    faKeyboard: $1113a0aa61ab7765$export$fb61df5d98785fa8,
    faCaretDown: $1113a0aa61ab7765$export$f9395ef707603e40,
    faHouseChimneyMedical: $1113a0aa61ab7765$export$9c73560282dceccd,
    faClinicMedical: $1113a0aa61ab7765$export$20d8a680febc7434,
    faTemperatureThreeQuarters: $1113a0aa61ab7765$export$7ed2bad15ae6237f,
    faTemperature3: $1113a0aa61ab7765$export$89def3268ed9b4bc,
    faThermometer3: $1113a0aa61ab7765$export$2f653125f4e6463,
    faThermometerThreeQuarters: $1113a0aa61ab7765$export$6c632d1dc30d4a77,
    faMobileScreen: $1113a0aa61ab7765$export$8867e7da34bb8bf4,
    faMobileAndroidAlt: $1113a0aa61ab7765$export$cb39d7b468ba5838,
    faPlaneUp: $1113a0aa61ab7765$export$a5f2976a01fdc970,
    faPiggyBank: $1113a0aa61ab7765$export$46d49a6734c4872a,
    faBatteryHalf: $1113a0aa61ab7765$export$e6dadc1155c4ee48,
    faBattery3: $1113a0aa61ab7765$export$f9138caac2aedaed,
    faMountainCity: $1113a0aa61ab7765$export$28f06bbf9c17c3af,
    faCoins: $1113a0aa61ab7765$export$bc5da164799a0e,
    faKhanda: $1113a0aa61ab7765$export$8d41d1f1ba3f9217,
    faSliders: $1113a0aa61ab7765$export$ea6970ed5a15feb6,
    faSlidersH: $1113a0aa61ab7765$export$94d4dcb523f95563,
    faFolderTree: $1113a0aa61ab7765$export$54d16fa2e445d3fe,
    faNetworkWired: $1113a0aa61ab7765$export$882cabd11f4943b8,
    faMapPin: $1113a0aa61ab7765$export$184725965b3402dc,
    faHamsa: $1113a0aa61ab7765$export$38d20d399463edf9,
    faCentSign: $1113a0aa61ab7765$export$875b6c94a4b00ea8,
    faFlask: $1113a0aa61ab7765$export$f9b579ba06048af,
    faPersonPregnant: $1113a0aa61ab7765$export$e7b4c26b5857fe9c,
    faWandSparkles: $1113a0aa61ab7765$export$76cc39f249b6864e,
    faEllipsisVertical: $1113a0aa61ab7765$export$7480721bf113be3e,
    faEllipsisV: $1113a0aa61ab7765$export$e58494c7fcb5380,
    faTicket: $1113a0aa61ab7765$export$3604f15924cf0b98,
    faPowerOff: $1113a0aa61ab7765$export$a1cca9928dcf9798,
    faRightLong: $1113a0aa61ab7765$export$b356b1dbe7d7f736,
    faLongArrowAltRight: $1113a0aa61ab7765$export$533e1f578f74c066,
    faFlagUsa: $1113a0aa61ab7765$export$19357abad396e723,
    faLaptopFile: $1113a0aa61ab7765$export$e1046cf83da9b7ef,
    faTty: $1113a0aa61ab7765$export$7c85aba0f9624b29,
    faTeletype: $1113a0aa61ab7765$export$14bcd5c43dc736f9,
    faDiagramNext: $1113a0aa61ab7765$export$2faddf1690e14e11,
    faPersonRifle: $1113a0aa61ab7765$export$b16df914812cedbe,
    faHouseMedicalCircleExclamation: $1113a0aa61ab7765$export$bc50edea6e121df5,
    faClosedCaptioning: $1113a0aa61ab7765$export$8e047801a8603af7,
    faPersonHiking: $1113a0aa61ab7765$export$baf9f153991b2ea,
    faHiking: $1113a0aa61ab7765$export$b2ab0105a901499e,
    faVenusDouble: $1113a0aa61ab7765$export$6a6f9cba7a1e5fe4,
    faImages: $1113a0aa61ab7765$export$74f06b41ed2ca28a,
    faCalculator: $1113a0aa61ab7765$export$693bd40950ed2c3a,
    faPeoplePulling: $1113a0aa61ab7765$export$dace56f632fecf6f,
    faN: $1113a0aa61ab7765$export$328a9baf0f9e3405,
    faCableCar: $1113a0aa61ab7765$export$85cb04eaefaf2d8b,
    faTram: $1113a0aa61ab7765$export$a7a36674c079f293,
    faCloudRain: $1113a0aa61ab7765$export$a6c308ee087b4ded,
    faBuildingCircleXmark: $1113a0aa61ab7765$export$c4c015418a1f24df,
    faShip: $1113a0aa61ab7765$export$6c645741140616af,
    faArrowsDownToLine: $1113a0aa61ab7765$export$8f2463c7b2fc6ae4,
    faDownload: $1113a0aa61ab7765$export$8f734e51d72ca13a,
    faFaceGrin: $1113a0aa61ab7765$export$92292137ef3cf4c8,
    faGrin: $1113a0aa61ab7765$export$37e1f10b6de76621,
    faDeleteLeft: $1113a0aa61ab7765$export$bbcc9e0b6022772b,
    faBackspace: $1113a0aa61ab7765$export$e43e3f67102fc526,
    faEyeDropper: $1113a0aa61ab7765$export$1bc3e0ad56dc9eb0,
    faEyeDropperEmpty: $1113a0aa61ab7765$export$ef304e9b7524c1f9,
    faEyedropper: $1113a0aa61ab7765$export$91549a375c0b6d25,
    faFileCircleCheck: $1113a0aa61ab7765$export$8547e9f3a2ddab5b,
    faForward: $1113a0aa61ab7765$export$a8710cdb23198d53,
    faMobile: $1113a0aa61ab7765$export$59edacfad04cd121,
    faMobileAndroid: $1113a0aa61ab7765$export$82f602311a698c32,
    faMobilePhone: $1113a0aa61ab7765$export$475a9be8da747e57,
    faFaceMeh: $1113a0aa61ab7765$export$dc130582748497c6,
    faMeh: $1113a0aa61ab7765$export$6d2db489aaeeecd2,
    faAlignCenter: $1113a0aa61ab7765$export$70e29dd05344623e,
    faBookSkull: $1113a0aa61ab7765$export$a57d448e8969ce8a,
    faBookDead: $1113a0aa61ab7765$export$b98a3f8c3941a74a,
    faIdCard: $1113a0aa61ab7765$export$782ac893fc22249b,
    faDriversLicense: $1113a0aa61ab7765$export$8359c70e609eff64,
    faOutdent: $1113a0aa61ab7765$export$e21cfc4f23776bff,
    faDedent: $1113a0aa61ab7765$export$cbffb369d9299db7,
    faHeartCircleExclamation: $1113a0aa61ab7765$export$3772719b170306e2,
    faHouse: $1113a0aa61ab7765$export$dcadc0d67468dfa8,
    faHome: $1113a0aa61ab7765$export$48f10d71ec526479,
    faHomeAlt: $1113a0aa61ab7765$export$279659c4b23dbedb,
    faHomeLgAlt: $1113a0aa61ab7765$export$20d6d52d45f53262,
    faCalendarWeek: $1113a0aa61ab7765$export$39be5cb4aed5a521,
    faLaptopMedical: $1113a0aa61ab7765$export$ba2fa38f7bcc6930,
    faB: $1113a0aa61ab7765$export$fa30fcd1e0d0d8,
    faFileMedical: $1113a0aa61ab7765$export$56cbcd962389b090,
    faDiceOne: $1113a0aa61ab7765$export$d91800b7be5303b0,
    faKiwiBird: $1113a0aa61ab7765$export$d9933d91e1314d02,
    faArrowRightArrowLeft: $1113a0aa61ab7765$export$56b6d3d7d0e67a1c,
    faExchange: $1113a0aa61ab7765$export$1aab915ca61b734a,
    faRotateRight: $1113a0aa61ab7765$export$7f465bf410c6eff7,
    faRedoAlt: $1113a0aa61ab7765$export$50c037520c6cfdc1,
    faRotateForward: $1113a0aa61ab7765$export$2507849a0fdd7f64,
    faUtensils: $1113a0aa61ab7765$export$750d52edc1dafc7,
    faCutlery: $1113a0aa61ab7765$export$7034e54a8036c5c8,
    faArrowUpWideShort: $1113a0aa61ab7765$export$63f4908401ded049,
    faSortAmountUp: $1113a0aa61ab7765$export$28ef3e933e4b5364,
    faMillSign: $1113a0aa61ab7765$export$9b53510cf4010e4d,
    faBowlRice: $1113a0aa61ab7765$export$86079bc65a716451,
    faSkull: $1113a0aa61ab7765$export$138b45e2afb1dfa4,
    faTowerBroadcast: $1113a0aa61ab7765$export$fd06ff4ce9799eb0,
    faBroadcastTower: $1113a0aa61ab7765$export$f68b38d51f5c0ed,
    faTruckPickup: $1113a0aa61ab7765$export$f846b848b3ba3064,
    faUpLong: $1113a0aa61ab7765$export$5608156cc81126e7,
    faLongArrowAltUp: $1113a0aa61ab7765$export$43c8f2a46326c55f,
    faStop: $1113a0aa61ab7765$export$51577929c676143b,
    faCodeMerge: $1113a0aa61ab7765$export$e151fe5abf6db993,
    faUpload: $1113a0aa61ab7765$export$a9578350255b2b79,
    faHurricane: $1113a0aa61ab7765$export$4cf54a379be7e59a,
    faMound: $1113a0aa61ab7765$export$ac54ffffdb218383,
    faToiletPortable: $1113a0aa61ab7765$export$a3a5de5f6e2513ba,
    faCompactDisc: $1113a0aa61ab7765$export$84021631df0f831b,
    faFileArrowDown: $1113a0aa61ab7765$export$148bcede94488555,
    faFileDownload: $1113a0aa61ab7765$export$1013b9966d758343,
    faCaravan: $1113a0aa61ab7765$export$afb5d0eee7c1bdb,
    faShieldCat: $1113a0aa61ab7765$export$1639f087457d4f58,
    faBolt: $1113a0aa61ab7765$export$6869964aa308dd31,
    faZap: $1113a0aa61ab7765$export$d62abb82664f55ca,
    faGlassWater: $1113a0aa61ab7765$export$b80f542550a05ea7,
    faOilWell: $1113a0aa61ab7765$export$b69c6757012a2267,
    faVault: $1113a0aa61ab7765$export$4689a147513594a7,
    faMars: $1113a0aa61ab7765$export$a9f5c0b9c1e77a6f,
    faToilet: $1113a0aa61ab7765$export$505476859b9691c0,
    faPlaneCircleXmark: $1113a0aa61ab7765$export$94ef668f5108e431,
    faYenSign: $1113a0aa61ab7765$export$30f1437f5a4e991d,
    faCny: $1113a0aa61ab7765$export$268a23eee8f089a2,
    faJpy: $1113a0aa61ab7765$export$5460a9192eb79bf5,
    faRmb: $1113a0aa61ab7765$export$e2a8016afc962883,
    faYen: $1113a0aa61ab7765$export$cf914b1afb9455a2,
    faRubleSign: $1113a0aa61ab7765$export$1ae0a94c8ba4131a,
    faRouble: $1113a0aa61ab7765$export$c5dc3d98c4d8f2a5,
    faRub: $1113a0aa61ab7765$export$9c4d936240e1f0b1,
    faRuble: $1113a0aa61ab7765$export$6c0cf65134387046,
    faSun: $1113a0aa61ab7765$export$2fa35dcbc038dbe9,
    faGuitar: $1113a0aa61ab7765$export$790dd5b32282b6fb,
    faFaceLaughWink: $1113a0aa61ab7765$export$600a1b26b33c3d47,
    faLaughWink: $1113a0aa61ab7765$export$77ac40095f39933e,
    faHorseHead: $1113a0aa61ab7765$export$5bcca85203ebd1e8,
    faBoreHole: $1113a0aa61ab7765$export$cd79eeea6201e9d4,
    faIndustry: $1113a0aa61ab7765$export$5548c3eb51060fa8,
    faCircleDown: $1113a0aa61ab7765$export$531badb89cf01312,
    faArrowAltCircleDown: $1113a0aa61ab7765$export$ff3afbc8c0bc5d59,
    faArrowsTurnToDots: $1113a0aa61ab7765$export$b9d8fdf63999a76d,
    faFlorinSign: $1113a0aa61ab7765$export$6248ec7440b2ffcb,
    faArrowDownShortWide: $1113a0aa61ab7765$export$a51c464b699200ae,
    faSortAmountDesc: $1113a0aa61ab7765$export$93835bc31892b5c3,
    faSortAmountDownAlt: $1113a0aa61ab7765$export$e7d80d8c226cb77,
    faLessThan: $1113a0aa61ab7765$export$7f24f1bf98af5411,
    faAngleDown: $1113a0aa61ab7765$export$4b5be0142d10f342,
    faCarTunnel: $1113a0aa61ab7765$export$ec5cfe409de2ed37,
    faHeadSideCough: $1113a0aa61ab7765$export$3cd04b7c1624f598,
    faGripLines: $1113a0aa61ab7765$export$1412f35381064d7d,
    faThumbsDown: $1113a0aa61ab7765$export$aba24ca305bbe8c1,
    faUserLock: $1113a0aa61ab7765$export$d9b89b5872b67a4f,
    faArrowRightLong: $1113a0aa61ab7765$export$becbc35d3541bcc,
    faLongArrowRight: $1113a0aa61ab7765$export$7ec6527cf8651899,
    faAnchorCircleXmark: $1113a0aa61ab7765$export$f6773af4219eebd,
    faEllipsis: $1113a0aa61ab7765$export$37fe3659ba7b6b54,
    faEllipsisH: $1113a0aa61ab7765$export$c9f2fedd4489a2ee,
    faChessPawn: $1113a0aa61ab7765$export$3db75d5ac9e98468,
    faKitMedical: $1113a0aa61ab7765$export$f04e7a0f1033a0cd,
    faFirstAid: $1113a0aa61ab7765$export$5b01ccb2da4c4387,
    faPersonThroughWindow: $1113a0aa61ab7765$export$a77a2f6da72f89e3,
    faToolbox: $1113a0aa61ab7765$export$b34d64c205c732a9,
    faHandsHoldingCircle: $1113a0aa61ab7765$export$3aa81d0e606b08b6,
    faBug: $1113a0aa61ab7765$export$a18cfac400116d9f,
    faCreditCard: $1113a0aa61ab7765$export$3e7437bf6535bef0,
    faCreditCardAlt: $1113a0aa61ab7765$export$5fffe8e3c36964a2,
    faCar: $1113a0aa61ab7765$export$9eefe7fcdf123b76,
    faAutomobile: $1113a0aa61ab7765$export$240a6c53cf7ac525,
    faHandHoldingHand: $1113a0aa61ab7765$export$6638511b28df3be5,
    faBookOpenReader: $1113a0aa61ab7765$export$cb6e40528b98a5b,
    faBookReader: $1113a0aa61ab7765$export$cee14fe33262fa7d,
    faMountainSun: $1113a0aa61ab7765$export$af9eaee7db3ba7a9,
    faArrowsLeftRightToLine: $1113a0aa61ab7765$export$a63cecc8a4166c49,
    faDiceD20: $1113a0aa61ab7765$export$b06003a02c9055bd,
    faTruckDroplet: $1113a0aa61ab7765$export$41ce20639e8fef2b,
    faFileCircleXmark: $1113a0aa61ab7765$export$e4686afbe882e24a,
    faTemperatureArrowUp: $1113a0aa61ab7765$export$d7a5da41ce01461d,
    faTemperatureUp: $1113a0aa61ab7765$export$872345a0157330a3,
    faMedal: $1113a0aa61ab7765$export$b48a5be96314835a,
    faBed: $1113a0aa61ab7765$export$f24e0fce77994d4d,
    faSquareH: $1113a0aa61ab7765$export$51e3c5be06a49e32,
    faHSquare: $1113a0aa61ab7765$export$f08bbcf8f59eafc2,
    faPodcast: $1113a0aa61ab7765$export$5c0b4709125e92f8,
    faTemperatureFull: $1113a0aa61ab7765$export$bf4d97a79734997f,
    faTemperature4: $1113a0aa61ab7765$export$db946f8dc50a57ca,
    faThermometer4: $1113a0aa61ab7765$export$92b2e2293472dd50,
    faThermometerFull: $1113a0aa61ab7765$export$74e07083cef79a6f,
    faBell: $1113a0aa61ab7765$export$9b6162797ab1b255,
    faSuperscript: $1113a0aa61ab7765$export$4fa56a54e822dd25,
    faPlugCircleXmark: $1113a0aa61ab7765$export$12ef959394d63192,
    faStarOfLife: $1113a0aa61ab7765$export$aa3c4c1c5a47bf98,
    faPhoneSlash: $1113a0aa61ab7765$export$4c60a3aade08b6c2,
    faPaintRoller: $1113a0aa61ab7765$export$d1de8d1b815d6a5,
    faHandshakeAngle: $1113a0aa61ab7765$export$503f458ca5cf64c2,
    faHandsHelping: $1113a0aa61ab7765$export$287dbb1632da0d44,
    faLocationDot: $1113a0aa61ab7765$export$90a475e93ff4bb8a,
    faMapMarkerAlt: $1113a0aa61ab7765$export$4be92fa780613f93,
    faFile: $1113a0aa61ab7765$export$cad54bead856a678,
    faGreaterThan: $1113a0aa61ab7765$export$da07b6bc24a496ca,
    faPersonSwimming: $1113a0aa61ab7765$export$3fb4da6af843d39f,
    faSwimmer: $1113a0aa61ab7765$export$67daf2e2f88c1365,
    faArrowDown: $1113a0aa61ab7765$export$9686eff8d817f770,
    faDroplet: $1113a0aa61ab7765$export$cc1b6e60cb98fb90,
    faTint: $1113a0aa61ab7765$export$60dd975bd5938c15,
    faEraser: $1113a0aa61ab7765$export$e7fc4fe34e767f28,
    faEarthAmericas: $1113a0aa61ab7765$export$9c4218a898614082,
    faEarth: $1113a0aa61ab7765$export$c2118d3775773870,
    faEarthAmerica: $1113a0aa61ab7765$export$8b0f3a26397cf632,
    faGlobeAmericas: $1113a0aa61ab7765$export$e96bcc7bde9498db,
    faPersonBurst: $1113a0aa61ab7765$export$ae02241644924482,
    faDove: $1113a0aa61ab7765$export$a1ab1e69a300089f,
    faBatteryEmpty: $1113a0aa61ab7765$export$1344b64f6e922e12,
    faBattery0: $1113a0aa61ab7765$export$de8d0338927394c1,
    faSocks: $1113a0aa61ab7765$export$8d36a54dbf1e6bce,
    faInbox: $1113a0aa61ab7765$export$366b69cbdce46334,
    faSection: $1113a0aa61ab7765$export$a6f4f4a005d91fbd,
    faGaugeHigh: $1113a0aa61ab7765$export$d262c1f5912046e6,
    faTachometerAlt: $1113a0aa61ab7765$export$38dd17b9f064c10f,
    faTachometerAltFast: $1113a0aa61ab7765$export$e99d8b85f35b8ca5,
    faEnvelopeOpenText: $1113a0aa61ab7765$export$f5c53ce8ec380d11,
    faHospital: $1113a0aa61ab7765$export$7a76c9d35b42d691,
    faHospitalAlt: $1113a0aa61ab7765$export$cea7736417b94a3b,
    faHospitalWide: $1113a0aa61ab7765$export$69c8cc0360f017e8,
    faWineBottle: $1113a0aa61ab7765$export$770be8b3d5776043,
    faChessRook: $1113a0aa61ab7765$export$5d65c40a109eb09c,
    faBarsStaggered: $1113a0aa61ab7765$export$2f8a7938c06a2142,
    faReorder: $1113a0aa61ab7765$export$75d2bb378a2fc102,
    faStream: $1113a0aa61ab7765$export$ed81ab40fc4e904,
    faDharmachakra: $1113a0aa61ab7765$export$45cbd92c28deb2c7,
    faHotdog: $1113a0aa61ab7765$export$9fae219b4d3ce0be,
    faPersonWalkingWithCane: $1113a0aa61ab7765$export$2ffee5b2bc935c1f,
    faBlind: $1113a0aa61ab7765$export$923de21def6ea9b6,
    faDrum: $1113a0aa61ab7765$export$5b9205e1042594b7,
    faIceCream: $1113a0aa61ab7765$export$dd52741c60cc638f,
    faHeartCircleBolt: $1113a0aa61ab7765$export$2a376a9d0d8fee96,
    faFax: $1113a0aa61ab7765$export$b5698497901d7197,
    faParagraph: $1113a0aa61ab7765$export$dec46f8df1860e0,
    faCheckToSlot: $1113a0aa61ab7765$export$6999832247e52c2b,
    faVoteYea: $1113a0aa61ab7765$export$e87bb3db1608b850,
    faStarHalf: $1113a0aa61ab7765$export$228008b5e11032fa,
    faBoxesStacked: $1113a0aa61ab7765$export$2088efcf62cf3b1,
    faBoxes: $1113a0aa61ab7765$export$2007320dd6cde6db,
    faBoxesAlt: $1113a0aa61ab7765$export$e6ef1d896ed63b3e,
    faLink: $1113a0aa61ab7765$export$88bc01ff8dbecc55,
    faChain: $1113a0aa61ab7765$export$b5d071e02a25554f,
    faEarListen: $1113a0aa61ab7765$export$837bc776b490934d,
    faAssistiveListeningSystems: $1113a0aa61ab7765$export$8eeef3dc0035b165,
    faTreeCity: $1113a0aa61ab7765$export$ad95e4f80f98ebe0,
    faPlay: $1113a0aa61ab7765$export$436587205947bca5,
    faFont: $1113a0aa61ab7765$export$a5dc297d3f60936,
    faRupiahSign: $1113a0aa61ab7765$export$fe44d4c71644ea0,
    faMagnifyingGlass: $1113a0aa61ab7765$export$34c8b97060c09ff,
    faSearch: $1113a0aa61ab7765$export$871a78837687ffe8,
    faTableTennisPaddleBall: $1113a0aa61ab7765$export$eabe53838d45ac6a,
    faPingPongPaddleBall: $1113a0aa61ab7765$export$ebb246c621751737,
    faTableTennis: $1113a0aa61ab7765$export$f378fbb4e0ef7edf,
    faPersonDotsFromLine: $1113a0aa61ab7765$export$cdcec8ca7ec0d381,
    faDiagnoses: $1113a0aa61ab7765$export$68bad2b52a90d1fa,
    faTrashCanArrowUp: $1113a0aa61ab7765$export$60430351cdb4ba89,
    faTrashRestoreAlt: $1113a0aa61ab7765$export$d075b19b21cb9856,
    faNairaSign: $1113a0aa61ab7765$export$58b7558ca9822358,
    faCartArrowDown: $1113a0aa61ab7765$export$9206260ff0c0c616,
    faWalkieTalkie: $1113a0aa61ab7765$export$8a322f740d64e9fc,
    faFilePen: $1113a0aa61ab7765$export$27f34878d8ed7a76,
    faFileEdit: $1113a0aa61ab7765$export$e343e19f1757c5ae,
    faReceipt: $1113a0aa61ab7765$export$32b0cd6133c2742,
    faSquarePen: $1113a0aa61ab7765$export$3643b719db23d46e,
    faPenSquare: $1113a0aa61ab7765$export$fbb231ccb3d960bc,
    faPencilSquare: $1113a0aa61ab7765$export$35d253ecd249e771,
    faSuitcaseRolling: $1113a0aa61ab7765$export$957e62a9b80ff4e3,
    faPersonCircleExclamation: $1113a0aa61ab7765$export$38c8c32017dd9cc,
    faChevronDown: $1113a0aa61ab7765$export$8db9bc521720fccd,
    faBatteryFull: $1113a0aa61ab7765$export$9338fc4614cfc0cf,
    faBattery: $1113a0aa61ab7765$export$214720d39635cea8,
    faBattery5: $1113a0aa61ab7765$export$e426617482c711a7,
    faSkullCrossbones: $1113a0aa61ab7765$export$8717352b90217272,
    faCodeCompare: $1113a0aa61ab7765$export$ca4c5b4dcff58860,
    faListUl: $1113a0aa61ab7765$export$f8a219cf4f516384,
    faListDots: $1113a0aa61ab7765$export$e6f4ba30d84fa6ea,
    faSchoolLock: $1113a0aa61ab7765$export$8845cce2a763ee07,
    faTowerCell: $1113a0aa61ab7765$export$f4b64c3a138c1b59,
    faDownLong: $1113a0aa61ab7765$export$e88ba08d4f4d65b6,
    faLongArrowAltDown: $1113a0aa61ab7765$export$8b92530ca6418c2f,
    faRankingStar: $1113a0aa61ab7765$export$e6fd420a918b43b5,
    faChessKing: $1113a0aa61ab7765$export$d5713874f8fefe1b,
    faPersonHarassing: $1113a0aa61ab7765$export$dcd74f2821882a49,
    faBrazilianRealSign: $1113a0aa61ab7765$export$9d355b4e79216962,
    faLandmarkDome: $1113a0aa61ab7765$export$8a56136f40511e5d,
    faLandmarkAlt: $1113a0aa61ab7765$export$8b9c180efffc50ab,
    faArrowUp: $1113a0aa61ab7765$export$8e144ed4d52eef49,
    faTv: $1113a0aa61ab7765$export$e0cfed4ba2fe562c,
    faTelevision: $1113a0aa61ab7765$export$9803b0176917be28,
    faTvAlt: $1113a0aa61ab7765$export$6aa64ad5a1974ad7,
    faShrimp: $1113a0aa61ab7765$export$ac094c06f566cca3,
    faListCheck: $1113a0aa61ab7765$export$350a84fd0f833f4d,
    faTasks: $1113a0aa61ab7765$export$2f6d5b2fec286d63,
    faJugDetergent: $1113a0aa61ab7765$export$3fe50bd8062cd141,
    faCircleUser: $1113a0aa61ab7765$export$9a5c11a5e3d7f1e7,
    faUserCircle: $1113a0aa61ab7765$export$be7d974e9e0dba1a,
    faUserShield: $1113a0aa61ab7765$export$d1886bc596424e6c,
    faWind: $1113a0aa61ab7765$export$cc58cb0f2257a6a9,
    faCarBurst: $1113a0aa61ab7765$export$6d2be7c5d395dd16,
    faCarCrash: $1113a0aa61ab7765$export$8ff55566398404cd,
    faY: $1113a0aa61ab7765$export$b8c4c058fe7d193c,
    faPersonSnowboarding: $1113a0aa61ab7765$export$22c642403aeeaeaf,
    faSnowboarding: $1113a0aa61ab7765$export$72683772d587302a,
    faTruckFast: $1113a0aa61ab7765$export$27de16299ddd171,
    faShippingFast: $1113a0aa61ab7765$export$5e419f47aaeb3c05,
    faFish: $1113a0aa61ab7765$export$24228a855c5f6812,
    faUserGraduate: $1113a0aa61ab7765$export$10f5839059d22f7e,
    faCircleHalfStroke: $1113a0aa61ab7765$export$625fb3848216f28c,
    faAdjust: $1113a0aa61ab7765$export$cfa06e4b68edca2d,
    faClapperboard: $1113a0aa61ab7765$export$add3b381ced12554,
    faCircleRadiation: $1113a0aa61ab7765$export$55c8e3afd9f6c0b4,
    faRadiationAlt: $1113a0aa61ab7765$export$2f048fa82bbddf6f,
    faBaseball: $1113a0aa61ab7765$export$dc3654cf8a596fbf,
    faBaseballBall: $1113a0aa61ab7765$export$63a3f8ceae07c7f3,
    faJetFighterUp: $1113a0aa61ab7765$export$b024a52a4ccf5e69,
    faDiagramProject: $1113a0aa61ab7765$export$59c351869dc27435,
    faProjectDiagram: $1113a0aa61ab7765$export$30bf9f5b96509df1,
    faCopy: $1113a0aa61ab7765$export$e9bd786d30cb716c,
    faVolumeXmark: $1113a0aa61ab7765$export$28cc565c11db6f2e,
    faVolumeMute: $1113a0aa61ab7765$export$aa8decd057dfd29b,
    faVolumeTimes: $1113a0aa61ab7765$export$a1c7b36ba71dbeca,
    faHandSparkles: $1113a0aa61ab7765$export$72e2d874a963de0c,
    faGrip: $1113a0aa61ab7765$export$eb83fb404127db75,
    faGripHorizontal: $1113a0aa61ab7765$export$4a45308d6c8decc1,
    faShareFromSquare: $1113a0aa61ab7765$export$928280bdd54fa173,
    faShareSquare: $1113a0aa61ab7765$export$ae9e1434571f373c,
    faChildCombatant: $1113a0aa61ab7765$export$f7367a7301f2dc0f,
    faChildRifle: $1113a0aa61ab7765$export$9b027cdb5db3ae5c,
    faGun: $1113a0aa61ab7765$export$e18f576a7b31ba46,
    faSquarePhone: $1113a0aa61ab7765$export$318ed022991eef56,
    faPhoneSquare: $1113a0aa61ab7765$export$8ba22605a641ebdf,
    faPlus: $1113a0aa61ab7765$export$a105e7b44ca0eb9e,
    faAdd: $1113a0aa61ab7765$export$9e8f9a9d4ad32c0f,
    faExpand: $1113a0aa61ab7765$export$1fe4a9976a241685,
    faComputer: $1113a0aa61ab7765$export$9835883ce9d0fe78,
    faXmark: $1113a0aa61ab7765$export$e6e44779b2fa1a5c,
    faClose: $1113a0aa61ab7765$export$23c717133fd81476,
    faMultiply: $1113a0aa61ab7765$export$4ed4ff13d4dbc862,
    faRemove: $1113a0aa61ab7765$export$34810740c1bd6c54,
    faTimes: $1113a0aa61ab7765$export$174bd7f477b115b4,
    faArrowsUpDownLeftRight: $1113a0aa61ab7765$export$ff9a43e3a9cb653c,
    faArrows: $1113a0aa61ab7765$export$d5ae09a305d70340,
    faChalkboardUser: $1113a0aa61ab7765$export$fd7622d4b8d3674b,
    faChalkboardTeacher: $1113a0aa61ab7765$export$443fcf69b0155291,
    faPesoSign: $1113a0aa61ab7765$export$c8f99b9b5ea83555,
    faBuildingShield: $1113a0aa61ab7765$export$18ba6a500873dba9,
    faBaby: $1113a0aa61ab7765$export$8afab767536f59ad,
    faUsersLine: $1113a0aa61ab7765$export$d7e538fddb81da68,
    faQuoteLeft: $1113a0aa61ab7765$export$932a67a1b1a7a724,
    faQuoteLeftAlt: $1113a0aa61ab7765$export$95bb9ad3aa35c741,
    faTractor: $1113a0aa61ab7765$export$e87e41787bbedc98,
    faTrashArrowUp: $1113a0aa61ab7765$export$940cea0f5451895c,
    faTrashRestore: $1113a0aa61ab7765$export$d32f45a64ed40e8d,
    faArrowDownUpLock: $1113a0aa61ab7765$export$fc9f7bd981c34c45,
    faLinesLeaning: $1113a0aa61ab7765$export$4d384ffc907ddaff,
    faRulerCombined: $1113a0aa61ab7765$export$613f406c1b5802a8,
    faCopyright: $1113a0aa61ab7765$export$da61665fff8aebfe,
    faEquals: $1113a0aa61ab7765$export$a7c5f5e4805fdab,
    faBlender: $1113a0aa61ab7765$export$db34f7a6de38784f,
    faTeeth: $1113a0aa61ab7765$export$b4619aeaf0b9d18e,
    faShekelSign: $1113a0aa61ab7765$export$3570be7b68efb8db,
    faIls: $1113a0aa61ab7765$export$ecadeff45b05a451,
    faShekel: $1113a0aa61ab7765$export$27e0e10e74d98736,
    faSheqel: $1113a0aa61ab7765$export$28b3b26a80030d4e,
    faSheqelSign: $1113a0aa61ab7765$export$d84993fb5e8c6edd,
    faMap: $1113a0aa61ab7765$export$fc82fb79180cd17c,
    faRocket: $1113a0aa61ab7765$export$b24d84ed5657d89a,
    faPhotoFilm: $1113a0aa61ab7765$export$ed36ad335b36be22,
    faPhotoVideo: $1113a0aa61ab7765$export$739f6a6a12dfb6ed,
    faFolderMinus: $1113a0aa61ab7765$export$758f1fb3784e4080,
    faStore: $1113a0aa61ab7765$export$de59c2657a8ace67,
    faArrowTrendUp: $1113a0aa61ab7765$export$cf36928a9c52e98a,
    faPlugCircleMinus: $1113a0aa61ab7765$export$2a44d62160972254,
    faSignHanging: $1113a0aa61ab7765$export$5c1f29f4c7cad367,
    faSign: $1113a0aa61ab7765$export$d21d0d6c8e9e8bf9,
    faBezierCurve: $1113a0aa61ab7765$export$a527a6267c55a54c,
    faBellSlash: $1113a0aa61ab7765$export$6b31a1e5968b2378,
    faTablet: $1113a0aa61ab7765$export$1c92b67c45a4b4fc,
    faTabletAndroid: $1113a0aa61ab7765$export$5eddbb7c71278268,
    faSchoolFlag: $1113a0aa61ab7765$export$9b263780a7312c8c,
    faFill: $1113a0aa61ab7765$export$d3c2bcfd3b861e4a,
    faAngleUp: $1113a0aa61ab7765$export$887340269e6d6cac,
    faDrumstickBite: $1113a0aa61ab7765$export$482976e9a4ab10f3,
    faHollyBerry: $1113a0aa61ab7765$export$273296afacf93991,
    faChevronLeft: $1113a0aa61ab7765$export$75702e3e3dd44a44,
    faBacteria: $1113a0aa61ab7765$export$7fc18cf2d526c341,
    faHandLizard: $1113a0aa61ab7765$export$54608d0a883fea4d,
    faNotdef: $1113a0aa61ab7765$export$3db5bca65a1be8dc,
    faDisease: $1113a0aa61ab7765$export$c7675a37487adc45,
    faBriefcaseMedical: $1113a0aa61ab7765$export$5000f52ca9819bf5,
    faGenderless: $1113a0aa61ab7765$export$c093cc22e88981c2,
    faChevronRight: $1113a0aa61ab7765$export$930de8c26eb20490,
    faRetweet: $1113a0aa61ab7765$export$cebc76f79478e40e,
    faCarRear: $1113a0aa61ab7765$export$ff2b8d5628da5f14,
    faCarAlt: $1113a0aa61ab7765$export$7937ed2462a665c0,
    faPumpSoap: $1113a0aa61ab7765$export$821aeede187f23c9,
    faVideoSlash: $1113a0aa61ab7765$export$a714fc79f58cc9ef,
    faBatteryQuarter: $1113a0aa61ab7765$export$acec92052ac2183,
    faBattery2: $1113a0aa61ab7765$export$23ca8a94c555576,
    faRadio: $1113a0aa61ab7765$export$11b26516cae2104f,
    faBabyCarriage: $1113a0aa61ab7765$export$3b3ab4d86bad7d26,
    faCarriageBaby: $1113a0aa61ab7765$export$9f117d92ccd36cf1,
    faTrafficLight: $1113a0aa61ab7765$export$bf0b19daceaec9c2,
    faThermometer: $1113a0aa61ab7765$export$f576739e9b18ea4f,
    faVrCardboard: $1113a0aa61ab7765$export$248171cb6dad4307,
    faHandMiddleFinger: $1113a0aa61ab7765$export$bd40d3a3a16fb147,
    faPercent: $1113a0aa61ab7765$export$89a1764fbb7ad2cb,
    faPercentage: $1113a0aa61ab7765$export$89333857fc063a2e,
    faTruckMoving: $1113a0aa61ab7765$export$a06617a1a4ccea67,
    faGlassWaterDroplet: $1113a0aa61ab7765$export$b7ae54b4078b2060,
    faDisplay: $1113a0aa61ab7765$export$e9d85839f7751f01,
    faFaceSmile: $1113a0aa61ab7765$export$b5023c446f10324,
    faSmile: $1113a0aa61ab7765$export$c632b2334f0913bc,
    faThumbtack: $1113a0aa61ab7765$export$b6314cdc01bb5c43,
    faThumbTack: $1113a0aa61ab7765$export$b63d0c7b519a9aae,
    faTrophy: $1113a0aa61ab7765$export$29c432d69ccf85a5,
    faPersonPraying: $1113a0aa61ab7765$export$8ecd436ef91fc02e,
    faPray: $1113a0aa61ab7765$export$3b32c982141cad51,
    faHammer: $1113a0aa61ab7765$export$6310f315e1ebbca5,
    faHandPeace: $1113a0aa61ab7765$export$e49e3cfceea441cc,
    faRotate: $1113a0aa61ab7765$export$decde496a29c5b23,
    faSyncAlt: $1113a0aa61ab7765$export$2ff2056be8c281e4,
    faSpinner: $1113a0aa61ab7765$export$1025ad641edb49c2,
    faRobot: $1113a0aa61ab7765$export$30a5bb4ad3fa716c,
    faPeace: $1113a0aa61ab7765$export$8614cb1326eacd7a,
    faGears: $1113a0aa61ab7765$export$4aac79b9ae3cfdb8,
    faCogs: $1113a0aa61ab7765$export$af1575770afc9559,
    faWarehouse: $1113a0aa61ab7765$export$e3a174a50618c208,
    faArrowUpRightDots: $1113a0aa61ab7765$export$bc804c6ab898f610,
    faSplotch: $1113a0aa61ab7765$export$d6f21e17ea797702,
    faFaceGrinHearts: $1113a0aa61ab7765$export$fbb22081b65e4f33,
    faGrinHearts: $1113a0aa61ab7765$export$c56cf0e0c3bc5ed2,
    faDiceFour: $1113a0aa61ab7765$export$2df6451abf70a6ff,
    faSimCard: $1113a0aa61ab7765$export$3bee83bf278fddbe,
    faTransgender: $1113a0aa61ab7765$export$7e3f1701aa95ef01,
    faTransgenderAlt: $1113a0aa61ab7765$export$9c36cf9334c052f,
    faMercury: $1113a0aa61ab7765$export$e134ecd00b622a47,
    faArrowTurnDown: $1113a0aa61ab7765$export$fd4d6cfd52703f50,
    faLevelDown: $1113a0aa61ab7765$export$3794c07e7a666c94,
    faPersonFallingBurst: $1113a0aa61ab7765$export$a75569baaf4a6c3a,
    faAward: $1113a0aa61ab7765$export$f8db2747dadd48f7,
    faTicketSimple: $1113a0aa61ab7765$export$68ddda3b30ba09f0,
    faTicketAlt: $1113a0aa61ab7765$export$75e38ba471fd89c4,
    faBuilding: $1113a0aa61ab7765$export$f26673f8b10c3d46,
    faAnglesLeft: $1113a0aa61ab7765$export$2ebd565813951f81,
    faAngleDoubleLeft: $1113a0aa61ab7765$export$21b0833b3cf929a7,
    faQrcode: $1113a0aa61ab7765$export$fc19ca0fe15e73bc,
    faClockRotateLeft: $1113a0aa61ab7765$export$29be1665d1b36a3b,
    faHistory: $1113a0aa61ab7765$export$76d1986559ca7b7a,
    faFaceGrinBeamSweat: $1113a0aa61ab7765$export$2ff38f330c834084,
    faGrinBeamSweat: $1113a0aa61ab7765$export$14d0ccc54c5b6826,
    faFileExport: $1113a0aa61ab7765$export$364f19abcfac1b0a,
    faArrowRightFromFile: $1113a0aa61ab7765$export$b9c76255b38e1df1,
    faShield: $1113a0aa61ab7765$export$8241bd5b9163ca12,
    faShieldBlank: $1113a0aa61ab7765$export$64f54da8fbaba8ee,
    faArrowUpShortWide: $1113a0aa61ab7765$export$be9d5060a4bc3b4b,
    faSortAmountUpAlt: $1113a0aa61ab7765$export$6e87844b0f151b6a,
    faHouseMedical: $1113a0aa61ab7765$export$2d077da983246a68,
    faGolfBallTee: $1113a0aa61ab7765$export$14c9f1d85e53ae99,
    faGolfBall: $1113a0aa61ab7765$export$2251487a9a33c682,
    faCircleChevronLeft: $1113a0aa61ab7765$export$f2b13ad44c03c40f,
    faChevronCircleLeft: $1113a0aa61ab7765$export$4a42c8c2451a33fd,
    faHouseChimneyWindow: $1113a0aa61ab7765$export$792391babe46862d,
    faPenNib: $1113a0aa61ab7765$export$a82594dcc75a49f5,
    faTentArrowTurnLeft: $1113a0aa61ab7765$export$89af87b7d6c15adf,
    faTents: $1113a0aa61ab7765$export$c93b950e845a4ee7,
    faWandMagic: $1113a0aa61ab7765$export$8282f5f5dcf6b009,
    faMagic: $1113a0aa61ab7765$export$e58f9b502d4dd52d,
    faDog: $1113a0aa61ab7765$export$c6406747800cf702,
    faCarrot: $1113a0aa61ab7765$export$28e93ec9f5e2ddf3,
    faMoon: $1113a0aa61ab7765$export$c4c2f69a53bab720,
    faWineGlassEmpty: $1113a0aa61ab7765$export$b86d7336e68a3f57,
    faWineGlassAlt: $1113a0aa61ab7765$export$b8ff3fe2b78aef2f,
    faCheese: $1113a0aa61ab7765$export$549b99473b7201e6,
    faYinYang: $1113a0aa61ab7765$export$6ec1acbf3f610b8f,
    faMusic: $1113a0aa61ab7765$export$fcb0647a5340b5b8,
    faCodeCommit: $1113a0aa61ab7765$export$d5d870c10bc9f1ce,
    faTemperatureLow: $1113a0aa61ab7765$export$9e9af12b90a1abd2,
    faPersonBiking: $1113a0aa61ab7765$export$cf152282d5de300d,
    faBiking: $1113a0aa61ab7765$export$a5bcf835dbf9c0b,
    faBroom: $1113a0aa61ab7765$export$2a533051418ff4ca,
    faShieldHeart: $1113a0aa61ab7765$export$7b96388ca2be471b,
    faGopuram: $1113a0aa61ab7765$export$31f89d8ac1d14ed6,
    faEarthOceania: $1113a0aa61ab7765$export$bd931e906edf2f47,
    faGlobeOceania: $1113a0aa61ab7765$export$8ac3f5271448657d,
    faSquareXmark: $1113a0aa61ab7765$export$5a17e58bb7afb1d7,
    faTimesSquare: $1113a0aa61ab7765$export$c0248ac97142ea2a,
    faXmarkSquare: $1113a0aa61ab7765$export$9a364781d6b7602b,
    faHashtag: $1113a0aa61ab7765$export$c92c903bade56844,
    faUpRightAndDownLeftFromCenter: $1113a0aa61ab7765$export$95457ede07b81517,
    faExpandAlt: $1113a0aa61ab7765$export$bcb8d86a3a1d6eb6,
    faOilCan: $1113a0aa61ab7765$export$2599126c3a57f727,
    faT: $1113a0aa61ab7765$export$6e625d2e7790c860,
    faHippo: $1113a0aa61ab7765$export$d4c909619093de2d,
    faChartColumn: $1113a0aa61ab7765$export$d01ddcc9efe7b149,
    faInfinity: $1113a0aa61ab7765$export$a590003279d671b8,
    faVialCircleCheck: $1113a0aa61ab7765$export$2db4f9712313eafa,
    faPersonArrowDownToLine: $1113a0aa61ab7765$export$f9a5161975928326,
    faVoicemail: $1113a0aa61ab7765$export$4f1ce88b2b4cd5cd,
    faFan: $1113a0aa61ab7765$export$55145a3dae4f984a,
    faPersonWalkingLuggage: $1113a0aa61ab7765$export$1ae0a37b36ace746,
    faUpDown: $1113a0aa61ab7765$export$e36c32dd5cba9b90,
    faArrowsAltV: $1113a0aa61ab7765$export$138cb56a3f8f7040,
    faCloudMoonRain: $1113a0aa61ab7765$export$301c3fab0c4545bd,
    faCalendar: $1113a0aa61ab7765$export$34f5c36a3e80efa2,
    faTrailer: $1113a0aa61ab7765$export$3a48b9820e92f5ab,
    faBahai: $1113a0aa61ab7765$export$6d636565b3ec36b4,
    faHaykal: $1113a0aa61ab7765$export$5c15e34e0e43f15c,
    faSdCard: $1113a0aa61ab7765$export$303efb6031da122,
    faDragon: $1113a0aa61ab7765$export$ae1875ba975aa0e9,
    faShoePrints: $1113a0aa61ab7765$export$cdbdd2118099ae07,
    faCirclePlus: $1113a0aa61ab7765$export$eeda28b8ca4cb18e,
    faPlusCircle: $1113a0aa61ab7765$export$d9cc3a81499af48c,
    faFaceGrinTongueWink: $1113a0aa61ab7765$export$4272e56f2429da88,
    faGrinTongueWink: $1113a0aa61ab7765$export$58099903d50aefb3,
    faHandHolding: $1113a0aa61ab7765$export$e6094d25274088ab,
    faPlugCircleExclamation: $1113a0aa61ab7765$export$d893dd9509763a17,
    faLinkSlash: $1113a0aa61ab7765$export$22965c7f4d903953,
    faChainBroken: $1113a0aa61ab7765$export$382551e04f32620a,
    faChainSlash: $1113a0aa61ab7765$export$12f09d657be59586,
    faUnlink: $1113a0aa61ab7765$export$2f546f7d8ba01e18,
    faClone: $1113a0aa61ab7765$export$76c1aa4bf9a39458,
    faPersonWalkingArrowLoopLeft: $1113a0aa61ab7765$export$5a200e8504b7367a,
    faArrowUpZA: $1113a0aa61ab7765$export$a0a53d8e3c68e9f1,
    faSortAlphaUpAlt: $1113a0aa61ab7765$export$95ef20828693fb0f,
    faFireFlameCurved: $1113a0aa61ab7765$export$769724fc1434d618,
    faFireAlt: $1113a0aa61ab7765$export$70dc26b4926d0b1b,
    faTornado: $1113a0aa61ab7765$export$6d274258ba4b0089,
    faFileCirclePlus: $1113a0aa61ab7765$export$430d63b54b1d4009,
    faBookQuran: $1113a0aa61ab7765$export$ad3212bc3fa1595b,
    faQuran: $1113a0aa61ab7765$export$46f29ea84ed4c5f1,
    faAnchor: $1113a0aa61ab7765$export$12a35719f889cd1,
    faBorderAll: $1113a0aa61ab7765$export$93a5eb721c9c0d25,
    faFaceAngry: $1113a0aa61ab7765$export$67a047c738fb34da,
    faAngry: $1113a0aa61ab7765$export$3c96c08e234498c5,
    faCookieBite: $1113a0aa61ab7765$export$317dde8664f7de71,
    faArrowTrendDown: $1113a0aa61ab7765$export$d2caed5e37174c23,
    faRss: $1113a0aa61ab7765$export$7329a1ca27b90c5b,
    faFeed: $1113a0aa61ab7765$export$67ad3d0233cd7b33,
    faDrawPolygon: $1113a0aa61ab7765$export$df9bd3777d1154d2,
    faScaleBalanced: $1113a0aa61ab7765$export$33fb4280dc20f0dd,
    faBalanceScale: $1113a0aa61ab7765$export$fec323dcfd81d750,
    faGaugeSimpleHigh: $1113a0aa61ab7765$export$cc4351eb13da27d8,
    faTachometer: $1113a0aa61ab7765$export$362d0f652c3fbca2,
    faTachometerFast: $1113a0aa61ab7765$export$375b6a8680f980ed,
    faShower: $1113a0aa61ab7765$export$f7f7c15f18cc19a1,
    faDesktop: $1113a0aa61ab7765$export$6e6ddc253102e596,
    faDesktopAlt: $1113a0aa61ab7765$export$ff09a62b9e0fa899,
    faM: $1113a0aa61ab7765$export$bd6a7788954842b5,
    faTableList: $1113a0aa61ab7765$export$6e989c3c7050dbb,
    faThList: $1113a0aa61ab7765$export$daf2614a457122c0,
    faCommentSms: $1113a0aa61ab7765$export$435fe17e9d6170d6,
    faSms: $1113a0aa61ab7765$export$9dbcc3443daa7323,
    faBook: $1113a0aa61ab7765$export$c9d7ef726d1a8742,
    faUserPlus: $1113a0aa61ab7765$export$4c17261776a709f2,
    faCheck: $1113a0aa61ab7765$export$62b2c752fccc6a9c,
    faBatteryThreeQuarters: $1113a0aa61ab7765$export$cfb37069d38f379e,
    faBattery4: $1113a0aa61ab7765$export$35ffefed200d123c,
    faHouseCircleCheck: $1113a0aa61ab7765$export$c9382fa3394ef53a,
    faAngleLeft: $1113a0aa61ab7765$export$3cbcd1b7e35945d2,
    faDiagramSuccessor: $1113a0aa61ab7765$export$ff7f40159cadb0ac,
    faTruckArrowRight: $1113a0aa61ab7765$export$d69fa2b7839ce76,
    faArrowsSplitUpAndLeft: $1113a0aa61ab7765$export$7df274119d2469d1,
    faHandFist: $1113a0aa61ab7765$export$ca492f58fe30a42f,
    faFistRaised: $1113a0aa61ab7765$export$fa0323a4d7489a8d,
    faCloudMoon: $1113a0aa61ab7765$export$482eb125aaf0fbc2,
    faBriefcase: $1113a0aa61ab7765$export$8da450d063b0eb37,
    faPersonFalling: $1113a0aa61ab7765$export$e94ab3a30cf4aca5,
    faImagePortrait: $1113a0aa61ab7765$export$c23fd8b91a7ed48,
    faPortrait: $1113a0aa61ab7765$export$e3d25f819c7ee7d7,
    faUserTag: $1113a0aa61ab7765$export$9eec597148166b36,
    faRug: $1113a0aa61ab7765$export$7cee7480f25f5289,
    faEarthEurope: $1113a0aa61ab7765$export$7adefae4a1be1d97,
    faGlobeEurope: $1113a0aa61ab7765$export$5318b8ede86cc96b,
    faCartFlatbedSuitcase: $1113a0aa61ab7765$export$ab81ff863770d996,
    faLuggageCart: $1113a0aa61ab7765$export$bd1e24dd3cde8514,
    faRectangleXmark: $1113a0aa61ab7765$export$3896694b3e81fba7,
    faRectangleTimes: $1113a0aa61ab7765$export$eaaf26416a51dc1,
    faTimesRectangle: $1113a0aa61ab7765$export$10147c0014152a3f,
    faWindowClose: $1113a0aa61ab7765$export$18b7775f78a3e16,
    faBahtSign: $1113a0aa61ab7765$export$ffc7123046a28ee,
    faBookOpen: $1113a0aa61ab7765$export$8a3071811b2b7979,
    faBookJournalWhills: $1113a0aa61ab7765$export$d3d49030d557a09b,
    faJournalWhills: $1113a0aa61ab7765$export$66a0d8d45aab6631,
    faHandcuffs: $1113a0aa61ab7765$export$74d1f89b5feb9d42,
    faTriangleExclamation: $1113a0aa61ab7765$export$1cbf6e649ce86166,
    faExclamationTriangle: $1113a0aa61ab7765$export$3d249b63b52cce7c,
    faWarning: $1113a0aa61ab7765$export$2e470a35c38b096a,
    faDatabase: $1113a0aa61ab7765$export$24680dede86b1883,
    faShare: $1113a0aa61ab7765$export$c08b4b0e2b0dc027,
    faArrowTurnRight: $1113a0aa61ab7765$export$f20385ecfa20c36e,
    faMailForward: $1113a0aa61ab7765$export$81df7693d3f2f8da,
    faBottleDroplet: $1113a0aa61ab7765$export$8f534e1e0ab75bfe,
    faMaskFace: $1113a0aa61ab7765$export$140d4da0adbaf435,
    faHillRockslide: $1113a0aa61ab7765$export$7ec15a32285f6c22,
    faRightLeft: $1113a0aa61ab7765$export$a082af56be9786ae,
    faExchangeAlt: $1113a0aa61ab7765$export$f6c6fb20d374b128,
    faPaperPlane: $1113a0aa61ab7765$export$b5378818301da1be,
    faRoadCircleExclamation: $1113a0aa61ab7765$export$79753c2153535b01,
    faDungeon: $1113a0aa61ab7765$export$1156dc6acb0058bd,
    faAlignRight: $1113a0aa61ab7765$export$7370f36a39a38737,
    faMoneyBill1Wave: $1113a0aa61ab7765$export$52e3e96cd1564779,
    faMoneyBillWaveAlt: $1113a0aa61ab7765$export$1613858e873cbb3e,
    faLifeRing: $1113a0aa61ab7765$export$53dd2cacf674142a,
    faHands: $1113a0aa61ab7765$export$f9712d0cf5150f0c,
    faSignLanguage: $1113a0aa61ab7765$export$20993813350f9671,
    faSigning: $1113a0aa61ab7765$export$5cc0e6f5191f4f02,
    faCalendarDay: $1113a0aa61ab7765$export$80968bcfef6481ca,
    faWaterLadder: $1113a0aa61ab7765$export$5930e9bdfd790d77,
    faLadderWater: $1113a0aa61ab7765$export$c5ea6eeef2db2b3b,
    faSwimmingPool: $1113a0aa61ab7765$export$4dee691631c67d5c,
    faArrowsUpDown: $1113a0aa61ab7765$export$64185f27d82c259f,
    faArrowsV: $1113a0aa61ab7765$export$cec5f1bc9e068e48,
    faFaceGrimace: $1113a0aa61ab7765$export$bd5bd2ef56b793b1,
    faGrimace: $1113a0aa61ab7765$export$3d08cd36ac1ef231,
    faWheelchairMove: $1113a0aa61ab7765$export$1482162f7fe04ac,
    faWheelchairAlt: $1113a0aa61ab7765$export$7db9460785019040,
    faTurnDown: $1113a0aa61ab7765$export$b5dc9dd0347bbb6,
    faLevelDownAlt: $1113a0aa61ab7765$export$c07eb6ff5a382cbd,
    faPersonWalkingArrowRight: $1113a0aa61ab7765$export$3e15790fe68c095b,
    faSquareEnvelope: $1113a0aa61ab7765$export$15da4ef8c0fb20d6,
    faEnvelopeSquare: $1113a0aa61ab7765$export$354e159473e73552,
    faDice: $1113a0aa61ab7765$export$4ed8206e6619cc8f,
    faBowlingBall: $1113a0aa61ab7765$export$5ee2640fe105312d,
    faBrain: $1113a0aa61ab7765$export$97fa4f4c1006ab1,
    faBandage: $1113a0aa61ab7765$export$658a137d3845bca7,
    faBandAid: $1113a0aa61ab7765$export$b14a1014df2fdf46,
    faCalendarMinus: $1113a0aa61ab7765$export$23e8b4955c2d951b,
    faCircleXmark: $1113a0aa61ab7765$export$30262489773a79a3,
    faTimesCircle: $1113a0aa61ab7765$export$ab0ec50720a747eb,
    faXmarkCircle: $1113a0aa61ab7765$export$90ac4096df8efdee,
    faGifts: $1113a0aa61ab7765$export$de9a67b55dbe819a,
    faHotel: $1113a0aa61ab7765$export$c402efcf01d5ca07,
    faEarthAsia: $1113a0aa61ab7765$export$807cdd395fe012cb,
    faGlobeAsia: $1113a0aa61ab7765$export$796fdfc909e603f4,
    faIdCardClip: $1113a0aa61ab7765$export$31e6961064ddac7b,
    faIdCardAlt: $1113a0aa61ab7765$export$dc37ebbac31f6c6c,
    faMagnifyingGlassPlus: $1113a0aa61ab7765$export$f48a3ba52a0a9e56,
    faSearchPlus: $1113a0aa61ab7765$export$378f00e6b1a8185,
    faThumbsUp: $1113a0aa61ab7765$export$47e4e0d519d33497,
    faUserClock: $1113a0aa61ab7765$export$b00596a09aa07311,
    faHandDots: $1113a0aa61ab7765$export$8846d49caaed1c0a,
    faAllergies: $1113a0aa61ab7765$export$dcae2101babbffff,
    faFileInvoice: $1113a0aa61ab7765$export$bef39294aed2281a,
    faWindowMinimize: $1113a0aa61ab7765$export$26a3f9d2784b90d8,
    faMugSaucer: $1113a0aa61ab7765$export$60048819854688c5,
    faCoffee: $1113a0aa61ab7765$export$1d24a9e457278011,
    faBrush: $1113a0aa61ab7765$export$5824ffe6f8983c83,
    faMask: $1113a0aa61ab7765$export$7b028758c03b9655,
    faMagnifyingGlassMinus: $1113a0aa61ab7765$export$56d810b9ab2e30bc,
    faSearchMinus: $1113a0aa61ab7765$export$efca97eef6a7a17d,
    faRulerVertical: $1113a0aa61ab7765$export$a6ad5df9d9f29553,
    faUserLarge: $1113a0aa61ab7765$export$50a28538498238f,
    faUserAlt: $1113a0aa61ab7765$export$ae9b19c2ac726cfc,
    faTrainTram: $1113a0aa61ab7765$export$d401d4aeba21cdf3,
    faUserNurse: $1113a0aa61ab7765$export$ab9af5aa013d2162,
    faSyringe: $1113a0aa61ab7765$export$1aa9423ec6b1d609,
    faCloudSun: $1113a0aa61ab7765$export$dcaadfd9c98e42a1,
    faStopwatch20: $1113a0aa61ab7765$export$df6244b0501f2112,
    faSquareFull: $1113a0aa61ab7765$export$7ec6541fee081990,
    faMagnet: $1113a0aa61ab7765$export$78932e9c9abea6b7,
    faJar: $1113a0aa61ab7765$export$53583b459a87a01,
    faNoteSticky: $1113a0aa61ab7765$export$4a4e034527c933f5,
    faStickyNote: $1113a0aa61ab7765$export$80889adc5d98bf4a,
    faBugSlash: $1113a0aa61ab7765$export$fc4dd5feed8df23,
    faArrowUpFromWaterPump: $1113a0aa61ab7765$export$1a093e7861c5e48f,
    faBone: $1113a0aa61ab7765$export$5902c007d5703f2d,
    faUserInjured: $1113a0aa61ab7765$export$c950c1ba7f227d5b,
    faFaceSadTear: $1113a0aa61ab7765$export$8a5a0dbb2a17e253,
    faSadTear: $1113a0aa61ab7765$export$4b5241926f692f91,
    faPlane: $1113a0aa61ab7765$export$f654c69e66b466c0,
    faTentArrowsDown: $1113a0aa61ab7765$export$51adfe7c9ee4f428,
    faExclamation: $1113a0aa61ab7765$export$de6218b649cbb6a9,
    faArrowsSpin: $1113a0aa61ab7765$export$7e05388be208e313,
    faPrint: $1113a0aa61ab7765$export$ae64371e02ee8e56,
    faTurkishLiraSign: $1113a0aa61ab7765$export$b458d393151b6960,
    faTry: $1113a0aa61ab7765$export$970dda513e46c41f,
    faTurkishLira: $1113a0aa61ab7765$export$40e66e5966827199,
    faDollarSign: $1113a0aa61ab7765$export$fb420d3e4d8c6a18,
    faDollar: $1113a0aa61ab7765$export$a4ffb0775547fcdf,
    faUsd: $1113a0aa61ab7765$export$72cca07d38a28589,
    faX: $1113a0aa61ab7765$export$476af662c0c32cbc,
    faMagnifyingGlassDollar: $1113a0aa61ab7765$export$fa4f1ead37dc1dce,
    faSearchDollar: $1113a0aa61ab7765$export$65b49a6767630708,
    faUsersGear: $1113a0aa61ab7765$export$3a18218720110fc0,
    faUsersCog: $1113a0aa61ab7765$export$5e0b06753fc69b81,
    faPersonMilitaryPointing: $1113a0aa61ab7765$export$50b6dcaa9ec03439,
    faBuildingColumns: $1113a0aa61ab7765$export$a411e7e26cb63d5e,
    faBank: $1113a0aa61ab7765$export$6e379b829ea8b99,
    faInstitution: $1113a0aa61ab7765$export$1dba320226a34c1f,
    faMuseum: $1113a0aa61ab7765$export$9b3953adff472ad2,
    faUniversity: $1113a0aa61ab7765$export$f2e1460ebe1a8cb0,
    faUmbrella: $1113a0aa61ab7765$export$9ff64ffae70e08c0,
    faTrowel: $1113a0aa61ab7765$export$12ca996a6f686fe1,
    faD: $1113a0aa61ab7765$export$56c73b799aac2555,
    faStapler: $1113a0aa61ab7765$export$c7e014b7e3ac3d83,
    faMasksTheater: $1113a0aa61ab7765$export$bf5896cc1ce4d55,
    faTheaterMasks: $1113a0aa61ab7765$export$3dbedc487b0159ac,
    faKipSign: $1113a0aa61ab7765$export$a6df39524c41472c,
    faHandPointLeft: $1113a0aa61ab7765$export$b276ec3dc9760d39,
    faHandshakeSimple: $1113a0aa61ab7765$export$e8485db4dab0ab30,
    faHandshakeAlt: $1113a0aa61ab7765$export$e9aa3c6f9f47aa1a,
    faJetFighter: $1113a0aa61ab7765$export$2130e629ab767ab3,
    faFighterJet: $1113a0aa61ab7765$export$102b809faf56e033,
    faSquareShareNodes: $1113a0aa61ab7765$export$1bdb0ec5af3fea99,
    faShareAltSquare: $1113a0aa61ab7765$export$3799c2d8fd7e493b,
    faBarcode: $1113a0aa61ab7765$export$3825a842b5afc5aa,
    faPlusMinus: $1113a0aa61ab7765$export$37bd38cf96417095,
    faVideo: $1113a0aa61ab7765$export$5c6bd8729527871b,
    faVideoCamera: $1113a0aa61ab7765$export$3a530df752193ccf,
    faGraduationCap: $1113a0aa61ab7765$export$874e305fd7920cce,
    faMortarBoard: $1113a0aa61ab7765$export$dd0a013bf23a9d86,
    faHandHoldingMedical: $1113a0aa61ab7765$export$bb2a6b1b5e852300,
    faPersonCircleCheck: $1113a0aa61ab7765$export$30294c81ac4031ca,
    faTurnUp: $1113a0aa61ab7765$export$314f5cab62fc6968,
    faLevelUpAlt: $1113a0aa61ab7765$export$d6f21a309b179c3d
};






const { Meta: $73b9d62da83bfae6$var$Meta } = (0, $ad1c3304c519fac5$export$2e2bcd8739ae039);
function $73b9d62da83bfae6$export$ca6fbb51b35e375c({ isSnapshot: isSnapshot = false }) {
    const projects = (0, $493cbc5b00d91baa$export$1448a5050d252c4d)();
    const navigation = (0, $493cbc5b00d91baa$export$d0fd4b7106de2769)();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "projects",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                className: "projects",
                children: isSnapshot ? intl.formatMessage({
                    id: 'mySnapshots'
                }) : intl.formatMessage({
                    id: 'myProjects'
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "projects__list",
                children: [
                    projects.map((project)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                            to: (isSnapshot ? 'snapshots/' : '') + project.id,
                            className: "projects__link",
                            style: {
                                paddingBottom: '20px'
                            },
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ad1c3304c519fac5$export$2e2bcd8739ae039), {
                                className: "projects__card",
                                hoverable: true,
                                style: {
                                    width: 400,
                                    minHeight: 300,
                                    margin: 10,
                                    height: '100%'
                                },
                                cover: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                                    className: "projects__cover",
                                    style: {
                                        width: 400,
                                        height: 200
                                    },
                                    alt: "image",
                                    src: project.photo ? `http://${window.location.host}${project.photo}` : (0, (/*@__PURE__*/$parcel$interopDefault($f0a4ffbb486b57b4$exports)))
                                }),
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($73b9d62da83bfae6$var$Meta, {
                                    title: project.name,
                                    description: project.description
                                })
                            })
                        }, project.id)),
                    !isSnapshot && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                        to: '/projects/new',
                        className: "projects__link",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ad1c3304c519fac5$export$2e2bcd8739ae039), {
                            className: "projects__card",
                            hoverable: true,
                            style: {
                                width: 400,
                                minHeight: 300,
                                margin: 10,
                                height: '100%'
                            },
                            cover: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                className: "projects__cover",
                                style: {
                                    width: 400,
                                    height: 200,
                                    color: '#ffd591'
                                },
                                icon: $1113a0aa61ab7765$export$a105e7b44ca0eb9e
                            }),
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($73b9d62da83bfae6$var$Meta, {
                                title: intl.formatMessage({
                                    id: 'createNewProject'
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}






parcelRequire("ltGt3");


function $14aea88a2e71fbc9$export$c120a0e80fd44ca6(props) {
    const error = (0, $493cbc5b00d91baa$export$ed527bf60f6e05f2)();
    console.error(error);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        id: "error-page",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h1", {
                children: "Oops!"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "Sorry, an unexpected error has occurred."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("i", {
                    children: error.statusText || error.message
                })
            }),
            props.showLogout && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d59e8531745b2278$export$b1ab0447fcf2ad93), {})
        ]
    });
}





parcelRequire("ltGt3");
var $747546f7ae3f8842$exports = {};
$747546f7ae3f8842$exports = import.meta.resolve("FtVTQ");


var $48b2c1be3e7fcbde$exports = {};
$48b2c1be3e7fcbde$exports = import.meta.resolve("lrbMD");


var $7f9cb80af2efdb5b$exports = {};
$7f9cb80af2efdb5b$exports = import.meta.resolve("i1gPY");


var $1a95048697c0260b$exports = {};
$1a95048697c0260b$exports = import.meta.resolve("7F7qL");


var $1f69669545b296bf$exports = {};
$1f69669545b296bf$exports = import.meta.resolve("k4pUJ");


var $149a1711618e54e3$exports = {};
$149a1711618e54e3$exports = import.meta.resolve("dhK1O");


const $0b79c81a92888b7f$export$548d0356db7f67bf = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
const $0b79c81a92888b7f$export$bf93b541325766f8 = {
    0: {
        description: 'Clear sky',
        descriptionShort: 'Sunny',
        icon: 'fa-regular fa-sun',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$2fa35dcbc038dbe9
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($747546f7ae3f8842$exports)))
    },
    1: {
        description: 'Mainly clear, partly cloudy, and overcast',
        descriptionShort: 'Mainly Sunny',
        icon: 'fa-solid fa-cloud-sun',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$dcaadfd9c98e42a1
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($7f9cb80af2efdb5b$exports)))
    },
    2: {
        description: 'Mainly clear, partly cloudy, and overcast',
        descriptionShort: 'Partly Cloudy',
        icon: 'fa-solid fa-cloud-sun',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$dcaadfd9c98e42a1
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($7f9cb80af2efdb5b$exports)))
    },
    3: {
        description: 'Mainly clear, partly cloudy, and overcast',
        descriptionShort: 'Cloudy',
        icon: 'fa-solid fa-cloud-sun',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$dcaadfd9c98e42a1
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($7f9cb80af2efdb5b$exports)))
    },
    45: {
        description: 'Fog and depositing rime fog',
        descriptionShort: 'Foggy',
        icon: 'fa-solid fa-smog',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$aa11b8edb09fed14
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($48b2c1be3e7fcbde$exports)))
    },
    48: {
        description: 'Fog and depositing rime fog',
        descriptionShort: 'Rime Fog',
        icon: 'fa-solid fa-smog',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$aa11b8edb09fed14
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($48b2c1be3e7fcbde$exports)))
    },
    51: {
        description: 'Drizzle: Light, moderate, and dense intensity',
        descriptionShort: 'Light Drizzle',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    53: {
        description: 'Drizzle: Light, moderate, and dense intensity',
        descriptionShort: 'Drizzle',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    55: {
        description: 'Drizzle: Light, moderate, and dense intensity',
        descriptionShort: 'Heavy Drizzle',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    56: {
        description: 'Freezing Drizzle: Light and dense intensity',
        descriptionShort: 'Light Freezing Drizzle',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    57: {
        description: 'Freezing Drizzle: Light and dense intensity',
        descriptionShort: 'Freezing Drizzle',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    61: {
        description: 'Rain: Slight, moderate and heavy intensity',
        descriptionShort: 'Light Rain',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    63: {
        description: 'Rain: Slight, moderate and heavy intensity',
        descriptionShort: 'Rain',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    65: {
        description: 'Rain: Slight, moderate and heavy intensity',
        descriptionShort: 'Heavy Rain',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    66: {
        description: 'Freezing Rain: Light and heavy intensity',
        descriptionShort: 'Light Freezing Rain',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    67: {
        description: 'Freezing Rain: Light and heavy intensity',
        descriptionShort: 'Freezing Rain',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    71: {
        description: 'Snow fall: Slight, moderate, and heavy intensity',
        descriptionShort: 'Light Snow',
        icon: 'fa-solid fa-snowflake',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$bab8f3647c394f48
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1a95048697c0260b$exports)))
    },
    73: {
        description: 'Snow fall: Slight, moderate, and heavy intensity',
        descriptionShort: 'Snow',
        icon: 'fa-solid fa-snowflake',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$bab8f3647c394f48
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1a95048697c0260b$exports)))
    },
    75: {
        description: 'Snow fall: Slight, moderate, and heavy intensity',
        descriptionShort: 'Heavy Snow',
        icon: 'fa-solid fa-snowflake',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$bab8f3647c394f48
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1a95048697c0260b$exports)))
    },
    77: {
        description: 'Snow grains',
        descriptionShort: 'Snow Grains',
        icon: 'fa-solid fa-snowflake',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$bab8f3647c394f48
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1a95048697c0260b$exports)))
    },
    80: {
        description: 'Rain showers: Slight, moderate, and violent',
        descriptionShort: 'Light Showers',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    81: {
        description: 'Rain showers: Slight, moderate, and violent',
        descriptionShort: 'Showers',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    82: {
        description: 'Rain showers: Slight, moderate, and violent',
        descriptionShort: 'Heavy Showers',
        icon: 'fa-cloud-showers-heavy',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$af51c741ee9cc090
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1f69669545b296bf$exports)))
    },
    85: {
        description: 'Snow showers slight and heavy',
        descriptionShort: 'Light Snow Showers',
        icon: 'fa-solid fa-snowflake',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$bab8f3647c394f48
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1a95048697c0260b$exports)))
    },
    86: {
        description: 'Snow showers slight and heavy',
        descriptionShort: 'Snow Showers',
        icon: 'fa-solid fa-snowflake',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$bab8f3647c394f48
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($1a95048697c0260b$exports)))
    },
    95: {
        description: 'Thunderstorm: Slight or moderate',
        descriptionShort: 'Thunderstorm',
        icon: 'fa-solid fa-cloud-bolt',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$cdd116afa0309c17
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($149a1711618e54e3$exports)))
    },
    96: {
        description: 'Thunderstorm with slight and heavy hail',
        descriptionShort: 'Light Thunderstorms With Hail',
        icon: 'fa-solid fa-bolt',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$6869964aa308dd31
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($149a1711618e54e3$exports)))
    },
    99: {
        description: 'Thunderstorm with slight and heavy hail',
        descriptionShort: 'Thunderstorm With Hail',
        icon: 'fa-solid fa-bolt',
        weatherIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$6869964aa308dd31
        }),
        imageBack: (0, (/*@__PURE__*/$parcel$interopDefault($149a1711618e54e3$exports)))
    }
};



let $f72b095965a02692$var$forceRevalidate = true;
function $f72b095965a02692$export$355b0b6aff080555() {
    $f72b095965a02692$var$forceRevalidate = true;
}
const $f72b095965a02692$export$32ba182c8dac3e61 = ({ currentParams: currentParams, nextParams: nextParams, formMethod: formMethod })=>{
    if (formMethod === 'post' || formMethod === 'delete') return true;
    if ($f72b095965a02692$var$forceRevalidate) {
        $f72b095965a02692$var$forceRevalidate = false;
        return true;
    }
    return currentParams.projectId != nextParams.projectId;
};


function $54fd325d6e6ebc1d$export$24bc7e761c190a9f(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
    // create a view into the buffer
    var ia = new Uint8Array(ab);
    // set the bytes of the buffer to the correct values
    for(var i = 0; i < byteString.length; i++)ia[i] = byteString.charCodeAt(i);
    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([
        ab
    ], {
        type: mimeString
    });
    return blob;
}



const $309a8477a77bc963$export$1c2c8674a5fbafd = [
    'ru',
    'en'
];
const $309a8477a77bc963$var$ruLocale = [
    'ru',
    'ru-BY',
    'ru-KG',
    'ru-KZ',
    'ru-MD',
    'ru-RU',
    'ru-UA',
    'be',
    'be-BY'
];
const $309a8477a77bc963$var$browserLanguageLocale = $309a8477a77bc963$var$ruLocale.includes(navigator.language) ? 'ru' : 'en';
const $309a8477a77bc963$var$userDefinedSavedLocale = (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).getSavedUserLocale();
const $309a8477a77bc963$export$d7f512c98c859244 = $309a8477a77bc963$var$userDefinedSavedLocale || $309a8477a77bc963$var$browserLanguageLocale;


function $0023026720e9f6ec$export$3f063810d7bf01bd(values, keyFinder) {
    return values.reduce((groups, value)=>{
        const key = typeof keyFinder === 'function' ? keyFinder(value) : value[keyFinder];
        if (!groups[key]) groups[key] = [
            value
        ];
        else groups[key] = [
            ...groups[key],
            value
        ];
        return groups;
    }, {});
}
function $0023026720e9f6ec$export$5693503523434e2b(x, y) {
    if (Array.isArray(x) && Array.isArray(y)) {
        if (x.length !== y.length) return false;
        const xSet = new Set(x.map((e)=>typeof e === 'string' ? e.toLowerCase() : e));
        return y.every((element)=>xSet.has(typeof element === 'string' ? element.toLowerCase() : element));
    }
    return x === y;
}
function $0023026720e9f6ec$export$ade7a147f5129058(fn) {
    let pendingPromise = null;
    const functionWithCache = async ()=>{
        if (functionWithCache._cachedValue != null) return functionWithCache._cachedValue;
        if (pendingPromise === null) pendingPromise = fn();
        const result = await pendingPromise;
        functionWithCache._cachedValue = result;
        pendingPromise = null;
        return result;
    };
    functionWithCache._cachedValue = null;
    functionWithCache.clearCache = ()=>{
        pendingPromise = null;
        functionWithCache._cachedValue = null;
    };
    return functionWithCache;
}
function $0023026720e9f6ec$export$2ca41f3dca67d8b9(fn) {
    let pendingPromises = new Map();
    let cachedValues = new Map();
    const functionWithCache = async (id, language)=>{
        const cacheKey = language ? `${id}-${language}` : id;
        if (cachedValues.has(cacheKey)) // has() guarantees a value; Map.get cannot express that
        return cachedValues.get(cacheKey);
        if (!pendingPromises.has(cacheKey)) pendingPromises.set(cacheKey, fn(id, language));
        const result = await pendingPromises.get(cacheKey);
        cachedValues.set(cacheKey, result);
        pendingPromises.delete(cacheKey);
        return result;
    };
    functionWithCache.clearCachedById = (id)=>{
        pendingPromises.delete(id);
        for (const language of (0, $309a8477a77bc963$export$1c2c8674a5fbafd))pendingPromises.delete(`${id}-${language}`);
        cachedValues.delete(id);
        for (const language of (0, $309a8477a77bc963$export$1c2c8674a5fbafd))cachedValues.delete(`${id}-${language}`);
    };
    functionWithCache.clearAllCached = ()=>{
        pendingPromises.clear();
        cachedValues.clear();
    };
    return functionWithCache;
}


const $db1b4356c7e82244$var$months = [
    "\u044F\u043D\u0432\u0430\u0440\u044C",
    "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
    "\u043C\u0430\u0440\u0442",
    "\u0430\u043F\u0440\u0435\u043B\u044C",
    "\u043C\u0430\u0439",
    "\u0438\u044E\u043D\u044C",
    "\u0438\u044E\u043B\u044C",
    "\u0430\u0432\u0433\u0443\u0441\u0442",
    "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
    "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
    "\u043D\u043E\u044F\u0431\u0440\u044C",
    "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
];
const $db1b4356c7e82244$export$c3fd80e8823fb50c = {
    "\u041E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435": {
        type: 'text',
        group: 'main',
        translationId: 'commonName'
    },
    // Сорт_eng: {
    //   type: 'text-composition',
    //   group: 'main',
    //   translationId: 'varietyEng',
    // },
    // Сорт_ru: {
    //   type: 'text-composition',
    //   group: 'main',
    //   translationId: 'varietyRu',
    // },
    \u0421\u043E\u0440\u0442: {
        type: 'text',
        group: 'main',
        translationId: 'variety',
        getValueFromDbRecord (fields, context) {
            if (fields["\u0421\u043E\u0440\u0442_eng"] && !fields["\u0421\u043E\u0440\u0442_ru"]) return fields["\u0421\u043E\u0440\u0442_eng"];
            else if (!fields["\u0421\u043E\u0440\u0442_eng"] && fields["\u0421\u043E\u0440\u0442_ru"]) return fields["\u0421\u043E\u0440\u0442_ru"];
            else if (fields["\u0421\u043E\u0440\u0442_eng"] && fields["\u0421\u043E\u0440\u0442_ru"] && context.language === 'ru') return `${fields["\u0421\u043E\u0440\u0442_eng"]} / ${fields["\u0421\u043E\u0440\u0442_ru"]}`;
            return fields["\u0421\u043E\u0440\u0442_eng"];
        }
    },
    "\u0423\u0442\u043E\u0447\u043D\u044F\u044E\u0449\u0430\u044F \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0430": {
        type: 'text',
        group: 'main',
        translationId: 'specification'
    },
    "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F": {
        type: 'photo',
        group: 'main',
        translationId: 'plantPhotos'
    },
    "\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F": {
        type: 'text',
        group: 'main',
        translationId: 'otherNames',
        getValueFromDbRecord (fields, context) {
            return fields["\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F"] && fields["\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F"].split('\n').join(', ');
        }
    },
    "\u041D\u0430\u0443\u0447\u043D\u043E\u0435 (\u043B\u0430\u0442\u0438\u043D\u0441\u043A\u043E\u0435) \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435": {
        type: 'text',
        group: 'main',
        translationId: 'scienceName'
    },
    "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0441\u043E\u0440\u0442\u0430": {
        type: 'text',
        group: 'overview',
        translationId: 'description'
    },
    // Семейство_ru: {
    //   type: 'text-composition',
    //   group: 'main',
    //   translationId: 'familyRu',
    // },
    // Семейство_la: {
    //   type: 'text-composition',
    //   group: 'main',
    //   translationId: 'familyLa',
    // },
    \u0421\u0435\u043C\u0435\u0439\u0441\u0442\u0432\u043E: {
        type: 'text',
        group: 'main',
        translationId: 'family',
        getValueFromDbRecord (fields, context) {
            if (context.language === 'ru' && fields["\u0421\u0435\u043C\u0435\u0439\u0441\u0442\u0432\u043E_ru"]) return `${fields["\u0421\u0435\u043C\u0435\u0439\u0441\u0442\u0432\u043E_ru"]} / ${fields["\u0421\u0435\u043C\u0435\u0439\u0441\u0442\u0432\u043E_la"]}`;
            else return fields["\u0421\u0435\u043C\u0435\u0439\u0441\u0442\u0432\u043E_la"];
        }
    },
    "\u0417\u043E\u043D\u044B \u043C\u043E\u0440\u043E\u0437\u043E\u0441\u0442\u043E\u0439\u043A\u043E\u0441\u0442\u0438 (USDA-\u0437\u043E\u043D\u044B)": {
        type: 'enum-dropdown',
        options: [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12'
        ],
        multiple: true,
        group: 'growing-conditions',
        translationId: 'uSDA',
        tooltip: true
    },
    "\u0414\u043E\u0441\u0442\u043E\u0438\u043D\u0441\u0442\u0432\u0430 \u0441\u043E\u0440\u0442\u0430": {
        type: 'text',
        group: 'overview',
        translationId: 'advantages'
    },
    "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043A\u0438 \u0441\u043E\u0440\u0442\u0430": {
        type: 'text',
        group: 'overview',
        translationId: 'disadvantages'
    },
    "\u0421\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0443\u0445\u043E\u0434\u0430": {
        type: 'enum-dropdown',
        options: [
            "\u043D\u0438\u0437\u043A\u0430\u044F",
            "\u0441\u0440\u0435\u0434\u043D\u044F\u044F",
            "\u0432\u044B\u0441\u043E\u043A\u0430\u044F"
        ],
        multiple: false,
        group: 'care',
        translationId: 'careDifficulty'
    },
    "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043B\u0438\u0441\u0442\u044C\u0435\u0432": {
        type: 'photo',
        group: 'common',
        translationId: 'leafPhotos'
    },
    "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0446\u0432\u0435\u0442\u043E\u0432": {
        type: 'photo',
        group: 'common',
        translationId: 'flowersPhotos'
    },
    "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043F\u043B\u043E\u0434\u043E\u0432": {
        type: 'photo',
        group: 'common',
        translationId: 'fruitsPhotos'
    },
    "\u041D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435/\u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435": {
        type: 'enum-dropdown',
        options: [
            "\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440\u043D\u043E\u0435",
            "\u043A\u043E\u043C\u043D\u0430\u0442\u043D\u043E\u0435",
            "\u0443\u043B\u0438\u0447\u043D\u043E\u0435",
            "\u0441\u0435\u0437\u043E\u043D\u043D\u043E\u0435"
        ],
        multiple: true,
        group: 'growing-conditions',
        translationId: 'purposeLocation'
    },
    "\u0416\u0438\u0437\u043D\u0435\u043D\u043D\u044B\u0439 \u0446\u0438\u043A\u043B": {
        type: 'enum-dropdown',
        options: [
            "\u043C\u043D\u043E\u0433\u043E\u043B\u0435\u0442\u043D\u0435\u0435",
            "\u0434\u0432\u0443\u0445\u043B\u0435\u0442\u043D\u0435\u0435",
            "\u043E\u0434\u043D\u043E\u043B\u0435\u0442\u043D\u0435\u0435"
        ],
        multiple: true,
        group: 'overview',
        translationId: 'lifeCycle'
    },
    \u041F\u043E\u043B\u0438\u0432: {
        type: 'enum-dropdown',
        options: [
            "\u0447\u0430\u0441\u0442\u044B\u0439",
            "1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E",
            "2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E",
            "\u0443\u043C\u0435\u0440\u0435\u043D\u043D\u044B\u0439",
            "\u0440\u0435\u0434\u043A\u0438\u0439",
            "\u043F\u043E \u043C\u0435\u0440\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438",
            "\u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u0438\u0432\u0430",
            "\u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u043E \u0432\u043B\u0430\u0436\u043D\u0430\u044F \u043F\u043E\u0447\u0432\u0430"
        ],
        multiple: false,
        group: 'care',
        translationId: 'watering'
    },
    "\u041E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0435 \u043A \u043E\u0441\u0432\u0435\u0449\u0435\u043D\u043D\u043E\u0441\u0442\u0438": {
        type: 'enum-dropdown',
        options: [
            "\u0441\u043E\u043B\u043D\u0446\u0435",
            "\u043F\u043E\u043B\u0443\u0442\u0435\u043D\u044C",
            "\u0442\u0435\u043D\u044C",
            "\u043B\u0435\u0433\u043A\u0430\u044F \u043F\u043E\u043B\u0443\u0442\u0435\u043D\u044C",
            "\u0440\u0430\u0441\u0441\u0435\u044F\u043D\u043D\u044B\u0439 \u0441\u0432\u0435\u0442",
            "\u044F\u0440\u043A\u0438\u0439 \u0440\u0430\u0441\u0441\u0435\u044F\u043D\u043D\u044B\u0439 \u0441\u0432\u0435\u0442"
        ],
        multiple: true,
        group: 'growing-conditions',
        translationId: 'attitudeToLight'
    },
    "\u0412\u044B\u0441\u043E\u0442\u0430 \u043E\u0442 (\u043C)": {
        type: 'range-start',
        rangeId: 'height-rangeField',
        group: 'size-appearance',
        translationId: 'heightFrom'
    },
    "\u0412\u044B\u0441\u043E\u0442\u0430 \u0434\u043E (\u043C)": {
        type: 'range-end',
        rangeId: 'height-rangeField',
        group: 'size-appearance',
        translationId: 'heightTo'
    },
    "\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u043E\u0442 (\u043C)": {
        type: 'range-start',
        rangeId: 'spreading-rangeField',
        group: 'size-appearance',
        translationId: 'spreadingFrom'
    },
    "\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u0434\u043E (\u043C)": {
        type: 'range-end',
        rangeId: 'spreading-rangeField',
        group: 'size-appearance',
        translationId: 'spreadingTo'
    },
    "\u0412\u0440\u0435\u043C\u044F \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u044F": {
        type: 'enum-dropdown',
        options: $db1b4356c7e82244$var$months,
        multiple: true,
        group: 'size-appearance',
        translationId: 'bloomingTime',
        monthsOptions: true
    },
    "\u0426\u0432\u0435\u0442 \u0446\u0432\u0435\u0442\u043E\u0432": {
        type: 'text',
        group: 'size-appearance',
        translationId: 'flowerColor'
    },
    "\u0420\u0430\u0437\u043C\u0435\u0440 \u0446\u0432\u0435\u0442\u043E\u0432 \u043E\u0442 (\u0441\u043C)": {
        type: 'range-start',
        rangeId: 'flowerSize-rangeField',
        group: 'size-appearance',
        translationId: 'flowerSize'
    },
    "\u0420\u0430\u0437\u043C\u0435\u0440 \u0446\u0432\u0435\u0442\u043E\u0432 \u0434\u043E (\u0441\u043C)": {
        type: 'range-end',
        rangeId: 'flowerSize-rangeField',
        group: 'size-appearance',
        translationId: 'flowerSize'
    },
    "\u0426\u0432\u0435\u0442 \u043B\u0438\u0441\u0442\u044C\u0435\u0432": {
        type: 'text',
        group: 'size-appearance',
        translationId: 'leafColor'
    },
    "\u041C\u0430\u0441\u0441\u0430 \u043F\u043B\u043E\u0434\u043E\u0432 (\u0433)": {
        type: 'text',
        group: 'size-appearance',
        translationId: 'fruitMass'
    },
    \u0421\u044A\u0435\u0434\u043E\u0431\u043D\u043E\u0441\u0442\u044C: {
        type: 'enum-dropdown',
        options: [
            "\u0431\u0443\u0442\u043E\u043D\u044B",
            "\u043A\u043B\u0443\u0431\u043D\u0438",
            "\u043A\u043E\u0440\u043D\u0438",
            "\u043B\u0438\u0441\u0442\u044C\u044F",
            "\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430",
            "\u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430",
            "\u043C\u043E\u043B\u043E\u0434\u044B\u0435 \u043F\u043E\u0431\u0435\u0433\u0438",
            "\u043E\u0432\u043E\u0449\u0438",
            "\u043F\u043B\u043E\u0434\u044B",
            "\u0441\u0435\u043C\u0435\u043D\u0430",
            "\u0441\u043E\u0446\u0432\u0435\u0442\u0438\u044F",
            "\u0444\u0440\u0443\u043A\u0442\u044B",
            "\u044F\u0433\u043E\u0434\u044B"
        ],
        multiple: true,
        group: 'properties',
        translationId: 'edibility'
    },
    "\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430": {
        type: 'text',
        group: 'properties',
        translationId: 'medicalProperties'
    },
    \u042F\u0434\u043E\u0432\u0438\u0442\u043E\u0441\u0442\u044C: {
        type: 'enum-dropdown',
        options: [
            "\u0432\u0441\u0435 \u0447\u0430\u0441\u0442\u0438",
            "\u043A\u043E\u0440\u0430",
            "\u043A\u043E\u0440\u043D\u0438",
            "\u043B\u0438\u0441\u0442\u044C\u044F",
            "\u043F\u043B\u043E\u0434\u044B",
            "\u0441\u043E\u043A",
            "\u0441\u0442\u0435\u0431\u0435\u043B\u044C",
            "\u0446\u0432\u0435\u0442\u044B",
            "\u044F\u0434\u043E\u0432\u0438\u0442\u043E\u0435"
        ],
        multiple: true,
        group: 'properties',
        translationId: 'toxicity'
    },
    \u0422\u0438\u043F: {
        type: 'enum-dropdown',
        options: [
            "\u0432\u0435\u0440\u0435\u0441\u043A",
            "\u0432\u043E\u0434\u043D\u043E\u0435",
            "\u0432\u044C\u044E\u0449\u0438\u0435\u0441\u044F \u0438 \u043B\u0438\u0430\u043D\u044B",
            "\u0434\u0435\u0440\u0435\u0432\u043E",
            "\u043A\u0430\u043A\u0442\u0443\u0441\u044B \u0438 \u0441\u0443\u043A\u043A\u0443\u043B\u0435\u043D\u0442\u044B",
            "\u043A\u043B\u0443\u0431\u043D\u0435\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u043E\u0435",
            "\u043A\u0443\u0441\u0442\u0430\u0440\u043D\u0438\u043A",
            "\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u043E\u0435",
            "\u043F\u0430\u043B\u044C\u043C\u043E\u0432\u044B\u0435 \u0438 \u0441\u0430\u0433\u043E\u0432\u043D\u0438\u043A\u043E\u0432\u044B\u0435",
            "\u043F\u0430\u043F\u043E\u0440\u043E\u0442\u043D\u0438\u043A",
            "\u043F\u043B\u043E\u0442\u043E\u044F\u0434\u043D\u043E\u0435",
            "\u043F\u043E\u043B\u0443\u043A\u0443\u0441\u0442\u0430\u0440\u043D\u0438\u043A",
            "\u0442\u0440\u0430\u0432\u044F\u043D\u0438\u0441\u0442\u043E\u0435",
            "\u0446\u0432\u0435\u0442\u0443\u0449\u0435\u0435",
            "\u043D\u0435\u0431\u043E\u043B\u044C\u0448\u043E\u0435 \u0434\u0435\u0440\u0435\u0432\u043E"
        ],
        multiple: true,
        group: 'overview',
        translationId: 'type'
    },
    "\u0424\u0430\u043A\u0442\u043E\u0440\u044B \u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438": {
        type: 'enum-dropdown',
        options: [
            "\u0430\u043C\u043F\u0435\u043B\u044C\u043D\u043E\u0435",
            "\u0431\u044B\u0441\u0442\u0440\u043E\u0440\u0430\u0441\u0442\u0443\u0449\u0435\u0435",
            "\u0432\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u0430\u044F \u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C",
            "\u0433\u0438\u0433\u0440\u043E\u0444\u0438\u0442",
            "\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u043A\u043E\u0440\u0430",
            "\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u0444\u043E\u0440\u043C\u0430 \u043A\u0440\u043E\u043D\u044B",
            "\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u043F\u043B\u043E\u0434\u043E\u043D\u043E\u0448\u0435\u043D\u0438\u0435",
            "\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435",
            "\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u043B\u0438\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435",
            "\u043A\u0441\u0435\u0440\u043E\u0444\u0438\u0442",
            "\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E\u0440\u0430\u0441\u0442\u0443\u0449\u0435\u0435",
            "\u043C\u043E\u0440\u043E\u0437\u043E\u0441\u0442\u043E\u0439\u043A\u043E\u0435",
            "\u043E\u0447\u0438\u0449\u0430\u0435\u0442 \u0432\u043E\u0437\u0434\u0443\u0445",
            "\u043F\u043B\u0435\u0442\u0443\u0449\u0435\u0435\u0441\u044F",
            "\u043F\u043E\u0447\u0432\u043E\u043F\u043E\u043A\u0440\u043E\u0432\u043D\u043E\u0435",
            "\u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u044E\u0449\u0435\u0435 \u043E\u043F\u044B\u043B\u0438\u0442\u0435\u043B\u0435\u0439",
            "\u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435",
            "\u0441\u044A\u0435\u0434\u043E\u0431\u043D\u043E\u0435",
            "\u0442\u0435\u043D\u0435\u0432\u044B\u043D\u043E\u0441\u043B\u0438\u0432\u043E\u0435",
            "\u0442\u0435\u043D\u0435\u043B\u044E\u0431\u0438\u0432\u043E\u0435",
            "\u0442\u043E\u043F\u0438\u0430\u0440\u043D\u044B\u0435 \u0444\u043E\u0440\u043C\u044B",
            "\u0445\u0432\u043E\u0439\u043D\u043E\u0435",
            "\u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435 \u0432 \u0440\u0430\u043D\u043D\u0435\u0432\u0435\u0441\u0435\u043D\u043D\u0438\u0439 \u043F\u0435\u0440\u0438\u043E\u0434",
            "\u044D\u043A\u0437\u043E\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0432\u043D\u0435\u0448\u043D\u0438\u0439 \u0432\u0438\u0434"
        ],
        multiple: true,
        group: 'common',
        translationId: 'attractionFactors'
    },
    "\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432\u044B\u0440\u0430\u0449\u0438\u0432\u0430\u043D\u0438\u044F": {
        type: 'enum-dropdown',
        options: [
            "\u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442",
            "\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0430 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443",
            "\u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u043E\u0440\u0430\u0449\u0438\u0435\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0443\u0431\u043D\u0435\u0439",
            "\u0441\u0442\u0440\u0430\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430",
            "\u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430",
            "\u0435\u0441\u0442\u044C \u043F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u043A\u043E\u044F",
            "\u0432\u043E\u0437\u043C\u043E\u0436\u0435\u043D \u043F\u043E\u0441\u0435\u0432 \u0441\u0435\u043C\u044F\u043D \u0432 \u0433\u0440\u0443\u043D\u0442 \u043F\u043E\u0434 \u0437\u0438\u043C\u0443",
            "\u0441\u043A\u0430\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0441\u0435\u043C\u044F\u043D \u043F\u0440\u0438 \u043F\u043E\u0441\u0430\u0434\u043A\u0435 \u0432\u0435\u0441\u043D\u043E\u0439"
        ],
        multiple: true,
        group: 'care',
        translationId: 'featuresOfCultivation'
    },
    "\u0421\u043F\u043E\u0441\u043E\u0431\u044B \u0440\u0430\u0437\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u044F": {
        type: 'enum-dropdown',
        options: [
            "\u0431\u043E\u043A\u043E\u0432\u044B\u043C\u0438 \u043F\u043E\u0431\u0435\u0433\u0430\u043C\u0438",
            "\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u043B\u0443\u0431\u043D\u044F",
            "\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u043E\u0440\u043D\u0435\u0432\u0438\u0449\u0430",
            "\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u0443\u0441\u0442\u0430",
            "\u043A\u043B\u0443\u0431\u043D\u0435\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430\u043C\u0438",
            "\u043A\u043B\u0443\u0431\u043D\u0435\u043F\u043E\u0447\u043A\u0430\u043C\u0438",
            "\u043B\u0438\u0441\u0442\u043E\u043C",
            "\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430\u043C\u0438",
            "\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u044B\u043C\u0438 \u0447\u0435\u0448\u0443\u0439\u043A\u0430\u043C\u0438",
            "\u043E\u0442\u0432\u043E\u0434\u043A\u0430\u043C\u0438",
            "\u043F\u0440\u0438\u0432\u0438\u0432\u043A\u043E\u0439",
            "\u0441\u0435\u043C\u0435\u043D\u0430\u043C\u0438",
            "\u0441\u043F\u043E\u0440\u0430\u043C\u0438",
            "\u0447\u0430\u0441\u0442\u044C\u044E \u043B\u0438\u0441\u0442\u0430",
            "\u0447\u0435\u0440\u0435\u043D\u043A\u043E\u0432\u0430\u043D\u0438\u0435\u043C"
        ],
        multiple: true,
        group: 'propagation-planting',
        translationId: 'reproductionMethods'
    },
    "\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0438 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442": {
        type: 'enum-dropdown',
        options: $db1b4356c7e82244$var$months,
        multiple: true,
        group: 'propagation-planting',
        translationId: 'timeForPlantingSeedlingsInClosedGround',
        monthsOptions: true
    },
    "\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0438 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442": {
        type: 'enum-dropdown',
        options: [
            ...$db1b4356c7e82244$var$months,
            "\u043F\u043E\u0441\u043B\u0435 \u043C\u0438\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0433\u0440\u043E\u0437\u044B \u0437\u0430\u043C\u043E\u0440\u043E\u0437\u043A\u043E\u0432"
        ],
        multiple: true,
        group: 'propagation-planting',
        translationId: 'timeForPlantingSeedlingsInOpenedGround',
        monthsOptions: true
    },
    "\u0413\u043B\u0443\u0431\u0438\u043D\u0430 \u043F\u043E\u0441\u0430\u0434\u043A\u0438 (\u0441\u043C)": {
        type: 'text',
        group: 'propagation-planting',
        translationId: 'plantingDepth'
    },
    "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043F\u043E \u0443\u0445\u043E\u0434\u0443": {
        type: 'enum-dropdown',
        options: [
            "\u043E\u0431\u0440\u0435\u0437\u043A\u0430 \u043D\u0430 \u0437\u0438\u043C\u0443",
            "\u043E\u043C\u043E\u043B\u0430\u0436\u0438\u0432\u0430\u044E\u0449\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430",
            "\u043F\u043E\u043B\u043B\u0430\u0440\u0434\u0438\u043D\u0433",
            "\u043F\u0440\u0438\u0449\u0438\u043F\u044B\u0432\u0430\u043D\u0438\u0435",
            "\u0441\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430",
            "\u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0443\u0432\u044F\u0434\u0448\u0438\u0445 \u0446\u0432\u0435\u0442\u043E\u0432",
            "\u0443\u043A\u0440\u044B\u0442\u0438\u0435 \u043D\u0430 \u0437\u0438\u043C\u0443",
            "\u0444\u043E\u0440\u043C\u043E\u0432\u043E\u0447\u043D\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430",
            "\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0437\u0438\u043C\u043E\u0439 \u0432 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0438"
        ],
        multiple: true,
        group: 'care',
        translationId: 'additionalCareSteps'
    },
    "\u0412\u0440\u0435\u043C\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0438": {
        type: 'enum-dropdown',
        options: $db1b4356c7e82244$var$months,
        multiple: true,
        group: 'care',
        translationId: 'trimTime',
        monthsOptions: true
    },
    "\u041F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0432 \u0434\u0438\u0437\u0430\u0439\u043D\u0435": {
        type: 'enum-dropdown',
        options: [
            "\u0430\u043A\u0432\u0430\u0440\u0438\u0443\u043C",
            "\u0430\u043B\u043B\u0435\u044F",
            "\u0430\u043B\u044C\u043F\u0438\u0439\u0441\u043A\u0430\u044F \u0433\u043E\u0440\u043A\u0430 (\u0430\u043B\u044C\u043F\u0438\u043D\u0430\u0440\u0438\u0439)",
            "\u0431\u0430\u043B\u043A\u043E\u043D",
            "\u0431\u0435\u0440\u0441\u043E",
            "\u0431\u043E\u043D\u0441\u0430\u0439",
            "\u0431\u043E\u0440\u0434\u044E\u0440",
            "\u0432 \u0438\u043D\u0442\u0435\u0440\u044C\u0435\u0440\u0435",
            "\u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435 \u043E\u0437\u0435\u043B\u0435\u043D\u0435\u043D\u0438\u0435",
            "\u0433\u0435\u0440\u0431\u0430\u0440\u0438\u0439",
            "\u0433\u0440\u0443\u043F\u043F\u043E\u0432\u0430\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0430",
            "\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u043C\u0438\u043D\u0438-\u0432\u043E\u0434\u043E\u0435\u043C",
            "\u0436\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C",
            "\u043A\u0430\u0448\u043F\u043E",
            "\u043A\u043B\u0443\u043C\u0431\u0430",
            "\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440",
            "\u043A\u0443\u043B\u0438\u0441\u044B",
            "\u043C\u0438\u043A\u0441\u0431\u043E\u0440\u0434\u0435\u0440",
            "\u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u0443\u0434\u0438\u043A",
            "\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0431\u0443\u043A\u0435\u0442\u0430",
            "\u043F\u0430\u043B\u044C\u043C\u0435\u0442\u0442\u0430",
            "\u0440\u0430\u0431\u0430\u0442\u043A\u0430",
            "\u0440\u043E\u043A\u0430\u0440\u0438\u0439",
            "\u0441\u043E\u043B\u0438\u0442\u0435\u0440 (\u043E\u0434\u0438\u043D\u043E\u0447\u043D\u043E\u0435)",
            "\u0441\u0440\u0435\u0437\u043A\u0430",
            "\u0441\u0443\u0445\u043E\u0439 \u0431\u0443\u043A\u0435\u0442",
            "\u0442\u043E\u043F\u0438\u0430\u0440\u043D\u044B\u0435 \u0444\u0438\u0433\u0443\u0440\u044B",
            "\u0444\u0438\u0442\u043E\u043F\u043B\u0430\u0441\u0442\u0438\u043A\u0430",
            "\u0444\u043B\u043E\u0440\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0434\u0438\u0437\u0430\u0439\u043D",
            "\u0448\u043F\u0430\u043B\u0435\u0440\u0430",
            "\u044F\u043F\u043E\u043D\u0441\u043A\u0438\u0439 \u0441\u0430\u0434"
        ],
        multiple: true,
        group: 'common',
        translationId: 'applicationInDesign'
    },
    "\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C \u0440\u043E\u0441\u0442\u0430": {
        type: 'text',
        group: 'overview',
        translationId: 'growthRate'
    },
    "\u041F\u043E\u0447\u0432\u0430 (\u0441\u0443\u0431\u0441\u0442\u0440\u0430\u0442)": {
        type: 'text',
        group: 'propagation-planting',
        translationId: 'soil'
    },
    \u0423\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u044F: {
        type: 'text',
        group: 'plant-health',
        translationId: 'fertilizers'
    },
    "\u0427\u0430\u0441\u0442\u043E\u0442\u0430 \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0443\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0439": {
        type: 'enum-dropdown',
        options: [
            "1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E",
            "2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E",
            "1 \u0440\u0430\u0437 \u0432 2 \u043D\u0435\u0434\u0435\u043B\u0438",
            "1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446",
            "2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446",
            "1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446 \u0432 \u0432\u0435\u0433\u0435\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434",
            "2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446 \u0432 \u0432\u0435\u0433\u0435\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434",
            "1 \u0440\u0430\u0437 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D",
            "2 \u0440\u0430\u0437\u0430 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D",
            "3-4 \u0440\u0430\u0437\u0430 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D",
            "\u043F\u0440\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445"
        ],
        multiple: true,
        group: 'plant-health',
        translationId: 'fertilizerFrequency'
    },
    \u0411\u043E\u043B\u0435\u0437\u043D\u0438: {
        type: 'enum-dropdown',
        options: [
            "\u0430\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0440\u0438\u043E\u0437",
            "\u0430\u043D\u0442\u0440\u0430\u043A\u043D\u043E\u0437",
            "\u0430\u0441\u0442\u0440\u043E\u0432\u044B\u0439 \u0432\u0438\u043B\u0442",
            "\u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0436\u043E\u0433",
            "\u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0440\u044F\u0431\u0443\u0445\u0430",
            "\u0431\u0435\u043B\u0430\u044F \u0433\u043D\u0438\u043B\u044C",
            "\u0431\u0435\u043B\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C",
            "\u0431\u0438\u0430\u0442\u043E\u0440\u0435\u043B\u043B\u043E\u0432\u044B\u0439 \u0440\u0430\u043A \u0442\u0438\u0441\u0430",
            "\u0431\u0443\u0440\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C",
            "\u0432\u0435\u0440\u0442\u0438\u0446\u0438\u043B\u043B\u0435\u0437",
            "\u0432\u0435\u0440\u0448\u0438\u043D\u043D\u0430\u044F \u0433\u043D\u0438\u043B\u044C",
            "\u0432\u0438\u0440\u0443\u0441 \u043B\u044E\u0446\u0435\u0440\u043D\u043E\u0432\u043E\u0439 \u043C\u043E\u0437\u0430\u0438\u043A\u0438",
            "\u0432\u0438\u0440\u0443\u0441 \u043C\u043E\u0437\u0430\u0438\u043A\u0438",
            "\u0432\u0438\u0440\u0443\u0441 \u043D\u0435\u043A\u0440\u043E\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u043B\u043E\u0441\u0430\u0442\u043E\u0441\u0442\u0438 \u043B\u0438\u043B\u0438\u0438",
            "\u0432\u0438\u0440\u0443\u0441 \u0445\u043E\u0441\u0442\u044B X",
            "\u0432\u043E\u0434\u044F\u043D\u0438\u0441\u0442\u0430\u044F \u0433\u043D\u0438\u043B\u044C",
            "\u0433\u043D\u0438\u043B\u044C \u0441\u0442\u0435\u0431\u043B\u044F",
            "\u0433\u0440\u0438\u0431\u043A\u043E\u0432\u044B\u0435 \u0437\u0430\u0431\u043E\u043B\u0435\u0432\u0430\u043D\u0438\u044F",
            "\u043A\u0438\u043B\u0430 \u043A\u0430\u043F\u0443\u0441\u0442\u043D\u044B\u0445",
            "\u043A\u043B\u044F\u0441\u0442\u0435\u0440\u043E\u0441\u043F\u043E\u0440\u0438\u043E\u0437",
            "\u043A\u043E\u0440\u043D\u0435\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C",
            "\u043A\u043E\u0440\u043D\u0435\u0432\u043E\u0439 \u0440\u0430\u043A",
            "\u043B\u043E\u0436\u043D\u0430\u044F \u043C\u0443\u0447\u043D\u0438\u0441\u0442\u0430\u044F \u0440\u043E\u0441\u0430",
            "\u043C\u043E\u0437\u0430\u0438\u0447\u043D\u0430\u044F \u0431\u043E\u043B\u0435\u0437\u043D\u044C \u043B\u0438\u0441\u0442\u044C\u0435\u0432",
            "\u043C\u043E\u043A\u0440\u0430\u044F \u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0433\u043D\u0438\u043B\u044C",
            "\u043C\u043E\u043D\u0442\u0430\u0440\u044C",
            "\u043C\u0443\u0447\u043D\u0438\u0441\u0442\u0430\u044F \u0440\u043E\u0441\u0430",
            "\u043E\u0433\u0443\u0440\u0435\u0447\u043D\u0430\u044F \u043C\u043E\u0437\u0430\u0438\u043A\u0430",
            "\u043E\u0438\u0434\u0438\u0443\u043C \u0432\u0438\u043D\u043E\u0433\u0440\u0430\u0434\u0430",
            "\u043F\u0430\u0440\u0448\u0430",
            "\u043F\u0435\u043D\u0438\u0446\u0438\u043B\u043B\u0435\u0437",
            "\u043F\u0435\u0441\u0442\u0430\u043B\u043E\u0446\u0438\u0435\u0432\u044B\u0439 \u043D\u0435\u043A\u0440\u043E\u0437",
            "\u043F\u0435\u0441\u0442\u0440\u043E\u043B\u0435\u043F\u0435\u0441\u0442\u043D\u043E\u0441\u0442\u044C",
            "\u043F\u043B\u043E\u0434\u043E\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C (\u043C\u043E\u043D\u0438\u043B\u0438\u043E\u0437)",
            "\u043F\u043E\u0434\u0433\u0430\u0440 \u0442\u0430\u0431\u0430\u043A\u0430",
            "\u043F\u043E\u0436\u0438\u043B\u043A\u043E\u0432\u044B\u0439 \u0445\u043B\u043E\u0440\u043E\u0437",
            "\u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u043B\u0438\u0441\u0442\u044C\u0435\u0432",
            "\u0440\u0430\u0441\u0441\u0430\u0434\u043D\u0430\u044F (\u0441\u0442\u0435\u0431\u043B\u0435\u0432\u0430\u044F) \u0433\u043D\u0438\u043B\u044C",
            "\u0440\u0435\u0432\u0435\u0440\u0441\u0438\u044F \u0447\u0435\u0440\u043D\u043E\u0439 \u0441\u043C\u043E\u0440\u043E\u0434\u0438\u043D\u044B",
            "\u0440\u0436\u0430\u0432\u0447\u0438\u043D\u0430",
            "\u0440\u0438\u0437\u043E\u043A\u0442\u043E\u043D\u0438\u043E\u0437 (\u0431\u0443\u0440\u0430\u044F \u0433\u043D\u0438\u043B\u044C)",
            "\u0441\u0430\u0436\u0438\u0441\u0442\u044B\u0439 \u0433\u0440\u0438\u0431",
            "\u0441\u0435\u0440\u0430\u044F \u0433\u043D\u0438\u043B\u044C",
            "\u0441\u0435\u0440\u0430\u044F \u043F\u043B\u0435\u0441\u0435\u043D\u044C",
            "\u0441\u0442\u0430\u0433\u0430\u043D\u043E\u0441\u043F\u043E\u0440\u043E\u0437",
            "\u0441\u0442\u0432\u043E\u043B\u043E\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C",
            "\u0442\u0430\u0431\u0430\u0447\u043D\u0430\u044F \u043C\u043E\u0437\u0430\u0438\u043A\u0430",
            "\u0443- \u0432\u0438\u0440\u0443\u0441 \u043A\u0430\u0440\u0442\u043E\u0444\u0435\u043B\u044F (\u0431\u0435\u043B\u0430\u044F \u043F\u0435\u0441\u0442\u0440\u0438\u0446\u0430)",
            "\u0444\u0438\u0442\u043E\u0444\u0442\u043E\u0440\u043E\u0437",
            "\u0444\u043E\u043C\u043E\u0437",
            "\u0444\u043E\u043C\u043E\u0437 \u0442\u0438\u0441\u0430",
            "\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437",
            "\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437\u043D\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C",
            "\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437\u043D\u043E\u0435 \u0443\u0432\u044F\u0434\u0430\u043D\u0438\u0435",
            "\u0445\u043B\u043E\u0440\u043E\u0437",
            "\u0446\u0435\u0440\u043A\u043E\u0441\u043F\u043E\u0440\u043E\u0437",
            "\u0447\u0435\u0440\u043D\u0430\u044F \u043D\u043E\u0436\u043A\u0430",
            "\u0447\u0435\u0440\u043D\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C",
            "\u0447\u0435\u0440\u043D\u044C",
            "\u0448\u044E\u0442\u0442\u0435 \u0431\u0443\u0440\u043E\u0435"
        ],
        multiple: true,
        group: 'plant-health',
        translationId: 'disease'
    },
    \u0412\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u0438: {
        type: 'enum-dropdown',
        options: [
            "\u0431\u0435\u043B\u043E\u043A\u0440\u044B\u043B\u043A\u0430",
            "\u0431\u043B\u043E\u0448\u043A\u0430 \u043A\u0440\u0435\u0441\u0442\u043E\u0446\u0432\u0435\u0442\u043D\u0430\u044F",
            "\u0432\u043E\u0439\u043B\u043E\u0447\u043D\u044B\u0439 \u043E\u0440\u0435\u0445\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449",
            "\u0433\u0430\u043B\u043B\u0438\u0446\u044B",
            "\u0433\u043E\u0440\u043E\u0445\u043E\u0432\u0430\u044F \u0437\u0435\u0440\u043D\u043E\u0432\u043A\u0430",
            "\u0433\u0443\u0441\u0435\u043D\u0438\u0446\u044B",
            "\u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0441\u0438\u043A",
            "\u0435\u043B\u043E\u0432\u0430\u044F \u043B\u0438\u0441\u0442\u043E\u0432\u0435\u0440\u0442\u043A\u0430-\u0438\u0433\u043B\u043E\u0435\u0434",
            "\u0437\u043E\u043D\u0442\u0438\u0447\u043D\u0430\u044F \u043C\u043E\u043B\u044C",
            "\u043A\u0430\u043F\u0443\u0441\u0442\u043D\u0430\u044F \u0433\u0443\u0441\u0435\u043D\u0438\u0446\u0430",
            "\u043A\u0430\u043F\u0443\u0441\u0442\u043D\u0430\u044F \u043C\u0443\u0445\u0430",
            "\u043A\u043B\u043E\u043F \u0432\u043E\u043D\u044E\u0447\u0438\u0439",
            "\u043A\u043E\u043B\u043E\u0440\u0430\u0434\u0441\u043A\u0438\u0439 \u0436\u0443\u043A",
            "\u043A\u043E\u043C\u0430\u0440\u044B-\u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0436\u043A\u0438",
            "\u043A\u043E\u0440\u043D\u0435\u0432\u043E\u0439 \u043B\u0443\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449",
            "\u043A\u0440\u0435\u0441\u0442\u043E\u0446\u0432\u0435\u0442\u043D\u0430\u044F \u0431\u043B\u043E\u0448\u043A\u0430",
            "\u043A\u0440\u043E\u0442",
            "\u043B\u0438\u043B\u0435\u0439\u043D\u0430\u044F \u043C\u0443\u0445\u0430",
            "\u043B\u0438\u043B\u0435\u0439\u043D\u044B\u0439 \u0436\u0443\u043A",
            "\u043B\u0438\u0441\u0442\u043E\u0431\u043B\u043E\u0448\u043A\u0430",
            "\u043B\u0438\u0441\u0442\u043E\u0432\u0430\u044F \u0431\u043B\u043E\u0448\u043A\u0430",
            "\u043B\u0438\u0441\u0442\u043E\u0432\u0435\u0440\u0442\u043A\u0430",
            "\u043B\u0438\u0441\u0442\u043E\u0435\u0434\u044B",
            "\u043B\u0443\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449",
            "\u043B\u0443\u043A\u043E\u0432\u0430\u044F \u0436\u0443\u0440\u0447\u0430\u043B\u043A\u0430",
            "\u043B\u0443\u043A\u043E\u0432\u0430\u044F \u043C\u0443\u0445\u0430",
            "\u043C\u0430\u043B\u0438\u043D\u043D\u044B\u0439 \u0436\u0443\u043A",
            "\u043C\u0435\u0434\u0432\u0435\u0434\u043A\u0430",
            "\u043C\u043E\u0440\u043A\u043E\u0432\u043D\u0430\u044F \u043C\u0443\u0445\u0430",
            "\u043C\u0438\u043D\u0438\u0440\u0443\u044E\u0449\u0430\u044F \u043C\u0443\u0445\u0430",
            "\u043C\u0443\u0440\u0430\u0432\u044C\u0438",
            "\u043C\u0443\u0447\u043D\u0438\u0441\u0442\u044B\u0439 \u0447\u0435\u0440\u0432\u0435\u0446",
            "\u043C\u044F\u0433\u043A\u0430\u044F \u043B\u043E\u0436\u043D\u043E\u0449\u0438\u0442\u043E\u0432\u043A\u0430",
            "\u043D\u0435\u043C\u0430\u0442\u043E\u0434\u044B",
            "\u043E\u0433\u043D\u0435\u0432\u043A\u0430",
            "\u043F\u0430\u0443\u0442\u0438\u043D\u043D\u044B\u0439 \u043A\u043B\u0435\u0449",
            "\u043F\u0438\u043B\u0438\u043B\u044C\u0449\u0438\u043A",
            "\u043F\u043B\u043E\u0434\u043E\u0436\u043E\u0440\u043A\u0430",
            "\u043F\u043E\u043B\u0435\u0432\u0430\u044F \u043C\u044B\u0448\u044C",
            "\u043F\u043E\u043B\u0435\u0432\u043E\u0439 \u043A\u043B\u043E\u043F",
            "\u043F\u043E\u043B\u043E\u0441\u0430\u0442\u044B\u0439 \u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0441\u0438\u043A",
            "\u043F\u043E\u0447\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449",
            "\u043F\u0440\u043E\u0432\u043E\u043B\u043E\u0447\u043D\u0438\u043A",
            "\u0440\u0430\u0441\u0442\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u044F\u0434\u043D\u044B\u0439 \u043A\u043B\u0435\u0449",
            "\u0441\u0430\u043C\u0448\u0438\u0442\u043E\u0432\u0430\u044F \u043E\u0433\u043D\u0435\u0432\u043A\u0430",
            "\u0441\u0435\u043B\u044C\u0434\u0435\u0440\u0435\u0439\u043D\u0430\u044F \u043C\u0443\u0445\u0430",
            "\u0441\u043B\u0438\u0437\u043D\u0438",
            "\u0441\u043B\u044E\u043D\u044F\u0432\u0430\u044F \u043F\u0435\u043D\u043D\u0438\u0446\u0430",
            "\u0441\u0442\u0435\u0431\u043B\u0435\u0432\u0430\u044F \u043D\u0435\u043C\u0430\u0442\u043E\u0434\u0430",
            "\u0442\u0430\u0431\u0430\u0447\u043D\u044B\u0439 \u043F\u0440\u043E\u0432\u043E\u043B\u043E\u0447\u043D\u0438\u043A",
            "\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u0433\u0430\u043B\u043B\u0438\u0446\u0430",
            "\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u043B\u043E\u0436\u043D\u043E\u0449\u0438\u0442\u043E\u0432\u043A\u0430",
            "\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u043F\u043B\u043E\u0441\u043A\u043E\u0442\u0435\u043B\u043A\u0430",
            "\u0442\u0438\u0441\u043E\u0432\u044B\u0439 \u043F\u043E\u0447\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449",
            "\u0442\u043B\u044F",
            "\u0442\u0440\u0438\u043F\u0441\u044B",
            "\u0442\u044E\u043B\u044C\u043F\u0430\u043D\u043E\u0432\u0430\u044F \u043E\u0433\u043D\u0451\u0432\u043A\u0430",
            "\u0443\u043B\u0438\u0442\u043A\u0438",
            "\u0444\u0430\u0441\u043E\u043B\u0435\u0432\u0430\u044F \u0437\u0435\u0440\u043D\u043E\u0432\u043A\u0430",
            "\u0445\u0440\u0443\u0449",
            "\u0446\u0432\u0435\u0442\u043E\u0447\u043D\u0430\u044F \u043F\u044F\u0434\u0435\u043D\u0438\u0446\u0430",
            "\u0449\u0438\u0442\u043E\u0432\u043A\u0430"
        ],
        multiple: true,
        group: 'plant-health',
        translationId: 'pests'
    },
    \u041F\u0435\u0441\u0442\u0438\u0446\u0438\u0434\u044B: {
        type: 'text',
        group: 'plant-health',
        translationId: 'pesticides'
    },
    "\u0427\u0430\u0441\u0442\u043E\u0442\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0441\u0442\u0438\u0446\u0438\u0434\u0430\u043C\u0438": {
        type: 'enum-dropdown',
        options: [
            "1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E",
            "2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E",
            "1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446",
            "2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446",
            "1 \u0440\u0430\u0437 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D",
            "\u043F\u043E \u043C\u0435\u0440\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438",
            "\u043F\u0440\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445"
        ],
        multiple: false,
        group: 'plant-health',
        translationId: 'pesticideTreatmentFrequency'
    },
    "\u0412\u0440\u0435\u043C\u044F \u043F\u043B\u043E\u0434\u043E\u043D\u043E\u0448\u0435\u043D\u0438\u044F": {
        type: 'enum-dropdown',
        options: $db1b4356c7e82244$var$months,
        multiple: true,
        group: 'fruiting',
        translationId: 'fruitingTime',
        monthsOptions: true
    },
    "\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u043B\u043E\u0434\u043E\u0432": {
        type: 'text',
        group: 'fruiting',
        translationId: 'featuresOfFruitStorage'
    },
    "\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430": {
        type: 'text',
        group: 'propagation-planting',
        translationId: 'featuresOfStoringPlantingMaterial'
    }
};
const $db1b4356c7e82244$export$b4d1d5ccd59b78e3 = $db1b4356c7e82244$export$c3fd80e8823fb50c;





var $Ohofd = parcelRequire("Ohofd");


var $Ohofd = parcelRequire("Ohofd");

function $a51e1674cf6e98df$export$ad88ac17e7818b7(values, predefinedTypeFieldName = 'type', customTypeName = 'custom', customTypeIdFieldName = 'custom_type_id') {
    if (!values) return [];
    const customEventTypeIds = [];
    const predefinedEventTypeNames = [];
    let hasNull = false;
    for (const eventType of values){
        if (eventType === null) hasNull = true;
        else if (typeof eventType === 'number') customEventTypeIds.push(eventType);
        else predefinedEventTypeNames.push(eventType);
    }
    const combinedFilter = [];
    if (hasNull) combinedFilter.push(`${predefinedTypeFieldName}.is.null`);
    if (predefinedEventTypeNames.length > 0) combinedFilter.push(`${predefinedTypeFieldName}.in.(${predefinedEventTypeNames.map((option)=>`"${option}"`).join(',')})`);
    if (customEventTypeIds.length > 0) combinedFilter.push(`and(type.eq.${customTypeName},${customTypeIdFieldName}.in.(${customEventTypeIds.map((option)=>`${option}`).join(',')}))`);
    return combinedFilter;
}


const $48c8ca5db8a0a10e$export$932e3268a6a07271 = `id,creationDateUtc,startDateUtc,endDateUtc,comment,plant:plantId (id, name), plantFilter:plantId(name), deletedPlantName,project:projectId (id, name),deletedProjectName, type, customEventType:customEventTypes(id,name,icon), actualCompletionDateUtc`;
function $48c8ca5db8a0a10e$export$3f40e8c44448be30(databaseEventRecord) {
    const { type: type, customEventType: customEventType, ...rest } = databaseEventRecord;
    return {
        id: databaseEventRecord.id,
        startDateUtc: databaseEventRecord.startDateUtc,
        eventId: databaseEventRecord.id,
        plant: databaseEventRecord.deletedPlantName ? {
            id: null,
            name: databaseEventRecord.deletedPlantName
        } : Array.isArray(databaseEventRecord.plant) ? databaseEventRecord.plant[0] : databaseEventRecord.plant,
        project: databaseEventRecord.deletedProjectName ? {
            id: null,
            name: databaseEventRecord.deletedProjectName
        } : Array.isArray(databaseEventRecord.project) ? databaseEventRecord.project[0] : databaseEventRecord.project,
        creationDateUtc: databaseEventRecord.creationDateUtc,
        actualCompletionDateUtc: databaseEventRecord.actualCompletionDateUtc,
        type: type === 'custom' ? {
            type: type,
            customJournalEventType: customEventType
        } : {
            type: type
        },
        comment: databaseEventRecord.comment
    };
// if (type === 'custom') {
//   return {
//     ...databaseEventRecord,
//     type: {
//       type,
//       customEventType,
//     },
//   }
// } else {
//   return {
//     ...databaseEventRecord,
//     type: {
//       type: type,
//     },
//   }
// }
}
class $48c8ca5db8a0a10e$export$9ee21e7caad2a3c1 {
    async getUserJournalRecords({ page: page, perPage: perPage, filters: filters, sort: sort }) {
        let query = (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('journalEvents').select($48c8ca5db8a0a10e$export$932e3268a6a07271, {
            count: 'exact'
        });
        // if (filters.eventCategory) {
        //   query = query.filter('eventCategory', 'eq', filters.eventCategory)
        // }
        const eventTypeFilter = (0, $a51e1674cf6e98df$export$ad88ac17e7818b7)(filters.eventType);
        if (eventTypeFilter.length > 0) query = query.or(eventTypeFilter.join(','));
        if (filters.project) query = query.filter('projectId', 'in', `(${filters.project.map((e)=>`"${e}"`).join(',')})`);
        if (filters.plant) query = query.ilike('plantFilter.name', `%${filters.plant}%`).or(`plantFilter.not.is.null,deletedPlantName.ilike.%${filters.plant}%`);
        if (filters.actualCompletionDateUtc && filters.actualCompletionDateUtc.startDate && !filters.actualCompletionDateUtc.endDate) query = query.filter('actualCompletionDateUtc', 'gte', (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(filters.actualCompletionDateUtc.startDate).format('YYYY-MM-DD'));
        if (filters.actualCompletionDateUtc && filters.actualCompletionDateUtc.endDate && !filters.actualCompletionDateUtc.startDate) query = query.filter('actualCompletionDateUtc', 'lte', (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(filters.actualCompletionDateUtc.endDate).format('YYYY-MM-DD'));
        if (filters.actualCompletionDateUtc && filters.actualCompletionDateUtc.endDate && filters.actualCompletionDateUtc.startDate) query = query.filter('actualCompletionDateUtc', 'lte', (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(filters.actualCompletionDateUtc.endDate).format('YYYY-MM-DD')).filter('actualCompletionDateUtc', 'gte', (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(filters.actualCompletionDateUtc.startDate).format('YYYY-MM-DD'));
        if (sort && sort.field === 'plant') query = query.order('plant(name)', {
            ascending: sort.direction === 'asc'
        });
        else if (sort && sort.field !== 'plant') query = query.order(sort.field, {
            ascending: sort.direction === 'asc'
        });
        else query = query.order('startDateUtc', {
            ascending: false
        });
        query = query.range((page - 1) * perPage, page * perPage - 1);
        const { data: plantEvents, count: count, error: error } = await query;
        if (error) throw error;
        // return toDoEvents.map((e) => ({
        //   eventCategory: 'finishedToDo',
        //   date: e.targetStartDateUtc,
        //   eventId: e.id,
        //   name: e.name,
        // }))
        return {
            data: plantEvents.map((e)=>({
                    id: e.id,
                    startDateUtc: e.startDateUtc,
                    eventId: e.id,
                    plant: e.deletedPlantName ? {
                        id: null,
                        name: e.deletedPlantName
                    } : Array.isArray(e.plant) ? e.plant[0] : e.plant,
                    project: e.deletedProjectName ? {
                        id: null,
                        name: e.deletedProjectName
                    } : Array.isArray(e.project) ? e.project[0] : e.project,
                    creationDateUtc: e.creationDateUtc,
                    actualCompletionDateUtc: e.actualCompletionDateUtc,
                    type: e.type === 'custom' ? {
                        type: 'custom',
                        customJournalEventType: e.customEventType
                    } : {
                        type: e.type
                    },
                    comment: e.comment
                })),
            count: count
        };
    }
    async getUserJournalRecordById(id) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('journalEvents').select($48c8ca5db8a0a10e$export$932e3268a6a07271).eq('id', id);
        if (error) return {
            success: false,
            error: error
        };
        else if (data.length === 0) return {
            success: false,
            error: 'notFound'
        };
        else return {
            success: true,
            data: $48c8ca5db8a0a10e$export$3f40e8c44448be30(data[0])
        };
    }
    async getUserJournalEventTypes() {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('customEventTypes').select('id, name, icon').eq('owner_id', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session?.user.id);
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true,
            data: data.map((type)=>({
                    type: 'custom',
                    customJournalEventType: type
                }))
        };
    }
    async createUserJournalEventType(name, icon) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('customEventTypes').insert([
            {
                name: name,
                icon: icon,
                owner_id: (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session?.user.id
            }
        ]).select('id, name, icon');
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true,
            data: data[0]
        };
    }
    async editUserJournalEventType(newType) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('customEventTypes').update({
            name: newType.name,
            icon: newType.icon
        }).eq('id', newType.id).eq('owner_id', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session?.user.id).select('id, name, icon');
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true,
            data: data[0]
        };
    }
    async deleteUserJournalEventType(id) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('customEventTypes').delete().eq('id', id).eq('owner_id', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session?.user.id);
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true,
            data: data
        };
    }
    async getJournalEventsByPlantId(plantId) {
        let { data: plantTimeEvents, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('journalEvents').select($48c8ca5db8a0a10e$export$932e3268a6a07271).eq('plantId', plantId);
        return plantTimeEvents.map((event)=>({
                id: event.id,
                creationDateUtc: event.creationDateUtc,
                startDateUtc: event.startDateUtc,
                endDateUtc: event.endDateUtc,
                actualCompletionDateUtc: event.actualCompletionDateUtc,
                plant: {
                    id: event.plant.id,
                    name: event.plant.id ? event.plant.name : event.deletedPlantName
                },
                //photos: event.photos,
                comment: event.comment,
                type: event.type === 'custom' ? {
                    type: 'custom',
                    customJournalEventType: event.customEventType
                } : {
                    type: event.type
                }
            }));
    }
    async createJournalEvent(newEvent, newPhotos = []) {
        const userId = (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session?.user.id;
        // if (newPhotos) {
        //   let result = await this.addPlantEventPhotos(newPhotos, userId, newPlantEvent.plant.id)
        //   if (result.success === false) {
        //     return {success: false, error: result.errors.map((e) => e.message).join(', ')}
        //   } else {
        //     newPlantEvent.photos = result.photos
        //   }
        // }
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('journalEvents').insert([
            {
                creationDateUtc: (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(Date.now()).format('YYYY-MM-DD'),
                plantId: newEvent.plant.id,
                //photos: newPlantEvent.photos,
                startDateUtc: newEvent.startDateUtc,
                endDateUtc: newEvent.endDateUtc,
                comment: newEvent.comment,
                ownerId: userId,
                type: newEvent.type.type,
                custom_type_id: newEvent.type.type === 'custom' ? newEvent.type.customJournalEventType.id : null,
                actualCompletionDateUtc: newEvent.actualCompletionDateUtc
            }
        ]);
        if (error) return {
            success: false,
            error: error.message
        };
        else return {
            success: true,
            data: data
        };
    }
    async editJournalEvent(currentJournalEvent, newPhotos = [], photos) {
        // if (photos && photos.length < currentPlantEvent.photos.length) {
        //   let deletedPhotos = currentPlantEvent.photos.map((photo, index) => {
        //     if (!photos.includes(photo)) {
        //       return photo
        //     }
        //   })
        //   let result = await this.deletePlantEventPhotos(
        //     deletedPhotos,
        //     userId,
        //     currentPlantEvent.plant.id
        //   )
        //   if (result.success === false) {
        //     return {success: false, error: result.error.message}
        //   } else {
        //     currentPlantEvent.photos = photos
        //   }
        // }
        // if (newPhotos) {
        //   let result = await this.addPlantEventPhotos(newPhotos, userId, currentPlantEvent.plant.id)
        //   if (result.success === false) {
        //     return {success: false, error: result.errors.map((e) => e.message).join(', ')}
        //   } else {
        //     currentPlantEvent.photos = [...(currentPlantEvent?.photos || []), ...result.photos]
        //   }
        // }
        const { plant: plant, type: type, ...journalEvent } = currentJournalEvent;
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('journalEvents').update([
            {
                ...journalEvent,
                plantId: plant.id,
                type: type.type,
                custom_type_id: type.type === 'custom' ? type.customJournalEventType.id : null
            }
        ]).eq('id', currentJournalEvent.id);
        if (error) return {
            success: false,
            error: error.message
        };
        else return {
            success: true,
            data: data
        };
    }
    async deleteJournalEvent(currentEvent) {
        // if (currentEvent.photos.length > 0) {
        //   let result = await this.deletePlantEventPhotos(
        //     currentEvent.photos,
        //     (
        //       await supabase.auth.getSession()
        //     ).data.session.user.id,
        //     currentEvent.plant.id
        //   )
        //   if (result.success === false) {
        //     return {success: false, error: result.error.message}
        //   }
        // }
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('journalEvents').delete().eq('id', currentEvent.id);
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
}
const $48c8ca5db8a0a10e$export$9544d5bb712b01ea = new $48c8ca5db8a0a10e$export$9ee21e7caad2a3c1();



const $e0eda949f811dcf3$var$commonNameField = "\u041E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435";
const $e0eda949f811dcf3$var$varietyField = "\u0421\u043E\u0440\u0442_eng";
const $e0eda949f811dcf3$var$varietyFieldLocal = "\u0421\u043E\u0440\u0442_ru";
const $e0eda949f811dcf3$var$queryFields = [
    $e0eda949f811dcf3$var$commonNameField,
    $e0eda949f811dcf3$var$varietyField,
    $e0eda949f811dcf3$var$varietyFieldLocal,
    "\u041D\u0430\u0443\u0447\u043D\u043E\u0435 (\u043B\u0430\u0442\u0438\u043D\u0441\u043A\u043E\u0435) \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
    "\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F"
];
const $e0eda949f811dcf3$export$965cd5f3a2d1fc05 = [
    'plantedDate',
    'name',
    'project'
];
function $e0eda949f811dcf3$export$d26cb2701d7c037f(fieldName, basePlantFields, context) {
    const fieldMetadata = (0, $db1b4356c7e82244$export$b4d1d5ccd59b78e3)[fieldName];
    // the stored record also carries '[EN] …'/'[PL] …' translation columns, and PlantFields
    // adds Семейство/Сорт - none of which the declared field list models
    const fields = basePlantFields;
    let basePlantFieldValue = null;
    if (context.language === 'en' && Object.keys(basePlantFields).includes(`[EN] ${fieldName}`)) basePlantFieldValue = fields[`[EN] ${fieldName}`];
    else if (context.language === 'en' && Object.keys(basePlantFields).includes(`[PL] ${fieldName}`)) basePlantFieldValue = fields[`[PL] ${fieldName}`];
    else basePlantFieldValue = fieldMetadata?.getValueFromDbRecord?.(basePlantFields, context) ?? fields[fieldName];
    return basePlantFieldValue;
}
function $e0eda949f811dcf3$export$4e4b0a0660d01171(plantFields, basePlantFields, context, includeMatchingFields = false) {
    const result = {};
    for (const key of Object.keys((0, $db1b4356c7e82244$export$b4d1d5ccd59b78e3))){
        const basePlantFieldValue = $e0eda949f811dcf3$export$d26cb2701d7c037f(key, basePlantFields, context);
        const newFieldValue = plantFields[key];
        if (includeMatchingFields) {
            if (newFieldValue) result[key] = newFieldValue;
            else result[key] = basePlantFieldValue;
        } else if (newFieldValue && !(0, $0023026720e9f6ec$export$5693503523434e2b)(newFieldValue, basePlantFieldValue)) //сравнение массивов
        result[key] = newFieldValue;
    }
    return result;
}
function $e0eda949f811dcf3$export$2f387f690230eab4(filters) {
    return {
        date: filters.dateOfPlantingUtc?.[0] && filters.dateOfPlantingUtc?.[1] ? {
            startDate: new Date(filters.dateOfPlantingUtc[0]),
            endDate: new Date(filters.dateOfPlantingUtc[1])
        } : undefined,
        plantName: filters.name ? filters.name[0] : undefined,
        projects: filters.project,
        collections: filters.collections
    };
}
// every caller below runs behind an authenticated route, so a session is always present
async function $e0eda949f811dcf3$var$currentUserId() {
    return (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id;
}
class $e0eda949f811dcf3$export$d2c7c89f5167baea {
    async getUserFilteredPlants({ page: page, perPage: perPage, filters: filters, sort: sort }, language) {
        let query = (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('planted_plants_data').select(`id, name, plantedDate, photos, comment, plantBaseId, basePlant:plantBaseId( id, fields, image_id ), basePlantForFilter:plantBaseId(fields), overwrittenBaseFields, projectId, template, coordinates, userId, project:projectId( name ), collections:plantedPlantsVSCollection( ...plantedPlantsCollections(id, color, name) ), collectionsForFilter:plantedPlantsVSCollection( ...plantedPlantsCollections(id, color, name) ), test:plantBaseId(test:fields->"\u{416}\u{438}\u{437}\u{43D}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{446}\u{438}\u{43A}\u{43B}")`, {
            count: 'exact'
        }).eq('userId', await $e0eda949f811dcf3$var$currentUserId())//.eq('isPlantDeleted', false)
        //.eq('journalEvents.type', 'planting')
        .range((page - 1) * perPage, page * perPage - 1);
        if (filters.projects) query = query.filter('projectId', 'in', `(${filters.projects.map((e)=>`"${e}"`).join(',')})`);
        if (filters.plantName) {
            const plantNameQueryTerms = filters.plantName.split(' ').filter(Boolean);
            const nameFilterClauses = [];
            for (const term of plantNameQueryTerms){
                const orQueryForTerm = $e0eda949f811dcf3$var$queryFields.map((field)=>`fields->>"${field}".ilike.%${term}%`).join(',');
                nameFilterClauses.push(orQueryForTerm);
            }
            query['url'].searchParams.append('basePlantForFilter.or', `(${nameFilterClauses.join(',')})`);
            query = query.or(`basePlantForFilter.not.is.null,name.ilike.%${filters.plantName}%`);
        }
        if (filters.startPlantingDate && !filters.endPlantingDate) query = query.filter('plantedDate', 'gte', (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(filters.startPlantingDate).format('YYYY-MM-DD'));
        if (filters.endPlantingDate && !filters.startPlantingDate) query = query.filter('plantedDate', 'lte', (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(filters.endPlantingDate).format('YYYY-MM-DD'));
        if (filters.startPlantingDate && filters.endPlantingDate) query = query.filter('plantedDate', 'lte', (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(filters.endPlantingDate).format('YYYY-MM-DD')).filter('plantedDate', 'gte', (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(filters.startPlantingDate).format('YYYY-MM-DD'));
        if (filters.collections && filters.collections.length > 0) query = query.filter('collectionsForFilter.plantedPlantsCollections.id', 'in', `(${filters.collections.map(String).join(',')})`).filter('collectionsForFilter', 'not.is', 'null').filter('collectionsForFilter.plantedPlantsCollections', 'not.is', 'null');
        const lifecycle = filters.lifecycle || {};
        const lifecycleFilter = Object.keys(lifecycle).filter((key)=>lifecycle[key]);
        if (lifecycleFilter.length > 0) {
            const field = "\u0416\u0438\u0437\u043D\u0435\u043D\u043D\u044B\u0439 \u0446\u0438\u043A\u043B";
            const inFilter = `{${lifecycleFilter.map((n)=>`"${n}"`).join(',')}}`;
            // query = query.or(
            //   `overwrittenBaseFields->>'${field}'.${inFilter},basePlant.fields->>'${field}'.${inFilter}`
            // )
            //query = query.filter(`overwrittenBaseFields->>'${field}'`, 'in', inFilter)
            // query = query.or(
            //   `and(overwrittenBaseFields->>'${field}'.not.is.null,overwrittenBaseFields->>'${field}'.in.${inFilter}),basePlant=fields->>'${field}'.in.${inFilter}`
            // )
            //query = query.filter(`basePlant.fields->'${field}'?|[${inFilter}]`, 'is', 'true')
            // query.or(`basePlant.not.is.null,overwrittenBaseFields->'${field}'?|
            //   [${inFilter}].is.true`)
            //query = query.filter(`basePlant.fields->"Жизненный цикл"`, 'ov', inFilter)
            query = query.overlaps(`basePlant.fields->"\u{416}\u{438}\u{437}\u{43D}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{446}\u{438}\u{43A}\u{43B}"`, lifecycleFilter);
        }
        if (filters.hideGardenPlanVariantPlants) {
            const { data: gardenPlanVariantPlantIds } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').select('id').eq('userId', await $e0eda949f811dcf3$var$currentUserId()).not('gardenPlanVariantId', 'is', null);
            if (gardenPlanVariantPlantIds?.length) query = query.not('id', 'in', `(${gardenPlanVariantPlantIds.map((p)=>p.id).join(',')})`);
        }
        if (sort?.field === 'project') query = query.order('project(name)', {
            ascending: sort.direction === 'asc'
        });
        else if (sort) query = query.order(sort.field, {
            ascending: sort.direction === 'asc'
        });
        else query = query.order('name', {
            ascending: false
        });
        query = query.order('id');
        const { data: plantedPlantsWithProjectName, count: count, error: error } = await query;
        // the planted_plants_data view has no gardenPlanVariantId column
        const { data: gardenPlanVariantPlants } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').select('id, gardenPlanVariantId').in('id', (plantedPlantsWithProjectName ?? []).map((plant)=>plant.id)).not('gardenPlanVariantId', 'is', null);
        const gardenPlanVariantIdByPlantId = new Map((gardenPlanVariantPlants ?? []).map((plant)=>[
                plant.id,
                plant.gardenPlanVariantId
            ]));
        const { data: gardenPlanVariants } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('gardenPlantVariants').select('id, name').in('id', [
            ...new Set(gardenPlanVariantIdByPlantId.values())
        ]);
        const gardenPlanVariantNameById = new Map((gardenPlanVariants ?? []).map((variant)=>[
                variant.id,
                variant.name
            ]));
        const plants = plantedPlantsWithProjectName?.map(({ basePlant: basePlant, project: project, plantedDate: plantedDate, ...plant })=>{
            const userPlantFields = plant.overwrittenBaseFields || {};
            const basePlantFields = (basePlant || {})?.fields || {};
            const combinedPlantFields = $e0eda949f811dcf3$export$4e4b0a0660d01171(userPlantFields, basePlantFields, {
                language: language
            }, true);
            return {
                ...plant,
                projectName: project?.name,
                titlePhotoName: basePlant?.image_id,
                fields: combinedPlantFields,
                dateOfPlantingUtc: plantedDate,
                gardenPlanVariantId: gardenPlanVariantIdByPlantId.get(plant.id) ?? null,
                gardenPlanVariantName: gardenPlanVariantNameById.get(gardenPlanVariantIdByPlantId.get(plant.id))
            };
        });
        return {
            plants: plants,
            totalCount: count ?? 0
        };
    }
    clearPlantListCaches() {
        this.getPlantById.clearAllCached();
        this.getProjectPlants.clearAllCached();
        this.getUserPlants.clearCache();
        this.getUserPlantsNamesWithId.clearCache();
        (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).getUserProjectMaxPlantsInfoStatistics.clearCache();
        (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).getUserProjectsInfoStatistics.clearCache();
    }
    clearPlantCaches(plantId, projectId) {
        this.getPlantById.clearCachedById(plantId);
        if (projectId) {
            this.getProjectPlants.clearCachedById(projectId);
            (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).getUserProjectById.clearCachedById(projectId);
        }
    }
    async createPlant(newPlant, newPhotos = [], language, basePlantId) {
        let plantPhotos = [];
        if (newPhotos) {
            let result = await this.addPlantPhotos(newPhotos, newPlant.userId);
            if (result.success === false) return {
                success: false,
                error: result.errors.map((e)=>e.message).join(', ')
            };
            plantPhotos = result.photos;
        }
        let basePlantFields = {};
        if (basePlantId) {
            const basePlantResponse = await this.getPlantFromPlantDatabaseById(basePlantId);
            if (basePlantResponse.status === 'found') basePlantFields = basePlantResponse.data.fields;
        }
        // newPlant.plantBaseId = currentBasePlant.id
        const overwrittenBaseFields = $e0eda949f811dcf3$export$4e4b0a0660d01171(newPlant.overwrittenBaseFields ?? {}, basePlantFields, {
            language: language
        });
        const result = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').insert([
            {
                name: newPlant.name,
                //dateOfPlantingUtc: newPlant.dateOfPlantingUtc,
                photos: plantPhotos,
                comment: newPlant.comment,
                projectId: newPlant.projectId,
                gardenPlanVariantId: newPlant.gardenPlanVariantId || null,
                userId: await $e0eda949f811dcf3$var$currentUserId(),
                elementId: newPlant.elementId,
                plantBaseId: basePlantId,
                overwrittenBaseFields: overwrittenBaseFields
            }
        ]).select('id');
        //await new Promise((resolve) => setTimeout(resolve, 2000))
        if (result.error !== null) return {
            success: false,
            error: result.error.message
        };
        else {
            if (newPlant.dateOfPlantingUtc) {
                const resultPlantingEvent = await (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).createJournalEvent({
                    type: {
                        type: 'planting'
                    },
                    actualCompletionDateUtc: (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(newPlant.dateOfPlantingUtc).utc(true),
                    plant: {
                        id: result.data[0].id,
                        name: ''
                    }
                });
            } //нет проверки на случай ошибки при создании ивента
            this.clearPlantListCaches();
            return {
                success: true,
                id: result.data[0].id
            };
        }
    }
    async editPlant(currentPlant, language, photos, newPhotos = []) {
        // TODO: what if one photo removed but other is added?
        let basePlantFields = {};
        if (currentPlant.plantBaseId) {
            const basePlantResponse = await this.getPlantFromPlantDatabaseById(currentPlant.plantBaseId);
            if (basePlantResponse.status === 'found') basePlantFields = basePlantResponse.data.fields;
        }
        const plant = {
            id: currentPlant.id,
            name: currentPlant.name,
            comment: currentPlant.comment,
            coordinates: currentPlant.coordinates,
            dateOfPlantingUtc: currentPlant.dateOfPlantingUtc,
            elementId: currentPlant.elementId,
            overwrittenBaseFields: $e0eda949f811dcf3$export$4e4b0a0660d01171(currentPlant.overwrittenBaseFields ?? {}, basePlantFields, {
                language: language
            }),
            photos: currentPlant.photos || [],
            plantBaseId: currentPlant.plantBaseId,
            projectId: currentPlant.projectId,
            userId: currentPlant.userId,
            confidenceInPlantVariety: currentPlant.confidenceInPlantVariety
        };
        if (photos && currentPlant.photos && photos.length < currentPlant.photos.length) {
            let deletedPhotos = currentPlant.photos.filter((photo)=>!photos.includes(photo));
            let result = await this.deletePlantPhotos(deletedPhotos, currentPlant.userId, currentPlant.id);
            if (result.success === false) return {
                success: false,
                error: result.error.message
            };
            else plant.photos = photos;
        }
        if (newPhotos) {
            let result = await this.addPlantPhotos(newPhotos, currentPlant.userId);
            if (result.success === false) return {
                success: false,
                error: result.errors.map((e)=>e.message).join(', ')
            };
            else plant.photos = [
                ...plant.photos ?? [],
                ...result.photos
            ];
        }
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').update([
            plant
        ]).eq('id', currentPlant.id);
        if (error) return {
            success: false,
            error: error.message
        };
        else {
            this.clearPlantListCaches();
            this.clearPlantCaches(plant.id, plant.projectId);
            return {
                success: true
            };
        }
    }
    async editConfidenceInPlantVarietyByPlantId(plantId, confidense) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').update({
            confidenceInPlantVariety: confidense
        }).eq('id', plantId);
        if (error) return {
            success: false,
            error: error.message
        };
        else {
            this.getPlantById.clearCachedById(plantId);
            return {
                success: true
            };
        }
    }
    async editPlantTemplateByPlantId(plantId, tempateId) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').update({
            template: tempateId
        }).eq('id', plantId);
        if (error) return {
            success: false,
            error: error.message
        };
        else {
            this.getPlantById.clearCachedById(plantId);
            this.clearPlantListCaches();
            return {
                success: true
            };
        }
    }
    async editPlantProjectByPlantId(plantId, projectId) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').update({
            projectId: projectId,
            elementId: null,
            coordinates: []
        }).eq('id', plantId);
        if (error) return {
            success: false,
            error: error.message
        };
        else {
            this.getPlantById.clearCachedById(plantId);
            this.clearPlantListCaches();
            return {
                success: true
            };
        }
    }
    async deletePlant(currentPlantId, isDeletePlantEvents, projectId) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).functions.invoke(`delete-plant`, {
            body: {
                plantId: currentPlantId,
                alsoRemoveEvents: isDeletePlantEvents
            }
        });
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.clearPlantListCaches();
            this.clearPlantCaches(currentPlantId, projectId);
            return {
                success: true
            };
        }
    }
    // public async deletePlantsByProjectId(projectId: number) {
    //   const {data, error} = await supabase
    //     .from('plantedPlants')
    //     .update({isPlantDeleted: true})
    //     .eq('projectId', projectId)
    //   if (error) {
    //     return {success: false, error}
    //   } else {
    //     this.clearPlantListCaches()
    //     return {success: true}
    //   }
    // }
    async placePlantOnCanvas(currentPlantId) {
        //переписать
        // const {data, error} = await supabase.from('plantedPlants').delete().eq('id', currentPlantId)
        // if (error) {
        //   return {success: false, error}
        // } else {
        //   return {success: true}
        // }
        return {
            success: true,
            error: null
        };
    }
    async removePlantFromCanvas(currentPlantId, currentPlantCoordinates, specimenNumber) {
        const newCoordinates = typeof specimenNumber === 'number' ? currentPlantCoordinates.map((coords, index)=>index === specimenNumber ? {} : coords) : currentPlantCoordinates.length > 1 ? currentPlantCoordinates.map((coords)=>({})) : [];
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').update({
            coordinates: newCoordinates
        }).eq('id', currentPlantId);
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.clearPlantListCaches();
            this.getPlantById.clearCachedById(currentPlantId);
            return {
                success: true
            };
        }
    }
    async connectSolitariusTemplateToPlant(solitariusTemplateElement, plantId, projectId, projectPlants, elements) {
        const connectedPlantOldCoordinates = projectPlants.find((plant)=>plant.id === plantId)?.coordinates;
        let newCoordinates = null;
        if (!connectedPlantOldCoordinates || connectedPlantOldCoordinates.length === 0) newCoordinates = [
            {
                x: solitariusTemplateElement.props.x,
                y: solitariusTemplateElement.props.y,
                width: solitariusTemplateElement.props.width,
                height: solitariusTemplateElement.props.height
            }
        ];
        else newCoordinates = [
            ...connectedPlantOldCoordinates,
            {
                x: solitariusTemplateElement.props.x,
                y: solitariusTemplateElement.props.y,
                width: solitariusTemplateElement.props.width,
                height: solitariusTemplateElement.props.height
            }
        ];
        const newProjectElements = elements.filter((element)=>element.elementId !== solitariusTemplateElement.elementId);
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').update({
            template: solitariusTemplateElement.elementId,
            coordinates: newCoordinates
        }).eq('id', plantId);
        if (error) return {
            success: false,
            error: error.message
        };
        else {
            const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('projects').update({
                elements: newProjectElements
            }).eq('id', projectId);
            if (error) return {
                success: false,
                error: error.message
            };
            else {
                this.clearPlantListCaches();
                this.clearPlantCaches(plantId, projectId);
                return {
                    success: true
                };
            }
        }
    }
    async addPlantSpecimen(currentPlantId, currentPlantProjectId, currentPlantCoordinates, newSpecimenCoordinates) {
        const newCoordinates = newSpecimenCoordinates ? [
            ...currentPlantCoordinates,
            ...newSpecimenCoordinates
        ] : currentPlantCoordinates.length !== 0 ? [
            ...currentPlantCoordinates,
            {}
        ] : [
            {},
            {}
        ];
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').update({
            coordinates: newCoordinates
        }).eq('id', currentPlantId);
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.clearPlantListCaches();
            this.clearPlantCaches(currentPlantId, currentPlantProjectId);
            return {
                success: true
            };
        }
    }
    async removePlantSpecimen(currentPlantId, currentPlantProjectId, currentPlantCoordinates, specimenNumber) {
        const newCoordinates = typeof specimenNumber === 'number' ? currentPlantCoordinates : [];
        newCoordinates.splice(specimenNumber, 1);
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').update({
            coordinates: newCoordinates
        }).eq('id', currentPlantId);
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.clearPlantListCaches();
            this.clearPlantCaches(currentPlantId, currentPlantProjectId);
            return {
                success: true
            };
        }
    }
    async movePlantOnCanvas(currentPlantId) {
        //переписать
        // const {data, error} = await supabase.from('plantedPlants').delete().eq('id', currentPlantId)
        // if (error) {
        //   return {success: false, error}
        // } else {
        //   return {success: true}
        // }
        return {
            success: true,
            error: null
        };
    }
    async getPlantImageURLs(plantNames = []) {
        if (plantNames.length === 0) return {
            success: true,
            urls: []
        };
        const userId = await $e0eda949f811dcf3$var$currentUserId();
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('photos').createSignedUrls(plantNames.map((plantName)=>`${userId}/${plantName}`), 60);
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true,
            urls: data.map((element)=>element.signedUrl)
        };
    }
    async getPlantDatabaseImageURLs(plantBaseId, plantNames = []) {
        if (plantNames.length === 0) return {
            success: true,
            urls: []
        };
        const plantNamesPaths = plantNames.map((name)=>`${plantBaseId}/${name}`);
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).functions.invoke(`plants-db-get-link-bulk`, {
            body: {
                paths: plantNamesPaths
            }
        });
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true,
            urls: data.map((element)=>element.url)
        };
    }
    async addPlantPhotos(plantPhoto, userId) {
        const errors = [];
        const photosNames = [];
        if (plantPhoto.length != 0) for (let photo of plantPhoto){
            const name = Date.now().toString();
            photosNames.push(name);
            const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('photos').upload(userId + '/' + name, photo.originFileObj, {
                cacheControl: '3600',
                upsert: false
            });
            if (error) errors.push(error);
        }
        if (errors.length !== 0) return {
            success: false,
            errors: errors
        };
        else return {
            success: true,
            photos: photosNames
        };
    }
    async deletePlantPhotos(plantPhoto, userId, plantId) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('photos').remove(plantPhoto.map((photo)=>userId + '/' + photo));
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    async getTitlePlantPhoto(plantTitlePhotoName, userPlantPhoto) {
        if (userPlantPhoto) {
            const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('photos').createSignedUrl(`${await $e0eda949f811dcf3$var$currentUserId()}/${userPlantPhoto}`, 60);
            if (error) return 0, (/*@__PURE__*/$parcel$interopDefault($f0a4ffbb486b57b4$exports));
            else return data.signedUrl;
        } else if (plantTitlePhotoName) return (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('plant_db_thumbnails').getPublicUrl(plantTitlePhotoName).data.publicUrl;
        else return 0, (/*@__PURE__*/$parcel$interopDefault($f0a4ffbb486b57b4$exports));
    }
    async createPlantCollection(plantCollectionName) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlantsCollections').insert([
            {
                name: plantCollectionName,
                userId: await $e0eda949f811dcf3$var$currentUserId()
            }
        ]).select();
        //await new Promise((resolve) => setTimeout(resolve, 2000))
        if (error) return {
            success: false,
            error: error.message
        };
        else return {
            success: true,
            newCollection: data[0]
        };
    }
    async deletePlantCollection(deletedPlantCollectionId) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlantsCollections').delete().eq('id', deletedPlantCollectionId);
        if (error) return {
            success: false,
            error: error.message
        };
        else {
            this.clearPlantListCaches();
            return {
                success: true
            };
        }
    }
    async getUserPlantCollections() {
        let { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlantsCollections').select('id, name, color, userId').eq('userId', await $e0eda949f811dcf3$var$currentUserId());
        return data;
    }
    async getUserPlantCollectionsWithPlantsIds() {
        let { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlantsCollections').select('id, name, color, userId, plantsIds:plantedPlantsVSCollection( plantedPlantsId)').eq('userId', await $e0eda949f811dcf3$var$currentUserId());
        return data;
    }
    async changePlantCollections(plantId, newPlantCollectionsIds, oldPlantCollectionsIds) {
        // TODO: use edge function for that because we need to insert/delete multiple records in one transaction
        if (newPlantCollectionsIds.length > oldPlantCollectionsIds.length) {
            let plantIdcolId = {
                plantedPlantsId: plantId,
                collectionId: newPlantCollectionsIds[newPlantCollectionsIds.length - 1]
            };
            const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlantsVSCollection').insert(plantIdcolId);
            if (error) return {
                success: false,
                error: error.message
            };
            else {
                this.clearPlantCaches(plantId);
                return {
                    success: true
                };
            }
        } else if (newPlantCollectionsIds.length < oldPlantCollectionsIds.length) {
            const deletedCollectionId = oldPlantCollectionsIds.filter((value)=>{
                if (!newPlantCollectionsIds.includes(value)) return value;
            });
            const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlantsVSCollection').delete().eq('plantedPlantsId', plantId).eq('collectionId', deletedCollectionId);
            //await new Promise((resolve) => setTimeout(resolve, 2000))
            if (error) return {
                success: false,
                error: error.message
            };
            else {
                this.clearPlantCaches(plantId);
                return {
                    success: true
                };
            }
        }
    }
    async searchPlantsDatabase(query) {
        const queryTerms = query.split(' ').filter(Boolean);
        let databaseQuery = (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plant_database').select('id,fields,image_id,image_bucket');
        for (const term of queryTerms){
            const orQueryForTerm = $e0eda949f811dcf3$var$queryFields.map((field)=>`fields->>"${field}".ilike.%${term}%`).join(',');
            databaseQuery.or(orQueryForTerm);
        }
        const { data: data, error: error } = await databaseQuery;
        if (error) return {
            success: false,
            error: error.message
        };
        else return {
            success: true,
            data: {
                data: {
                    records: data.map((element)=>({
                            id: element.id,
                            fields: element.fields,
                            thumbnailUrl: (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from(element.image_bucket).getPublicUrl(element.image_id).data.publicUrl
                        })).sort((x, y)=>{
                        const xVarietyLength = x.fields[$e0eda949f811dcf3$var$varietyField]?.length || 0;
                        const yVarietyLength = y.fields[$e0eda949f811dcf3$var$varietyField]?.length || 0;
                        const varietyComparison = xVarietyLength - yVarietyLength;
                        if (varietyComparison != 0) return varietyComparison;
                        const xCommonNameLength = x.fields[$e0eda949f811dcf3$var$commonNameField]?.length || 0;
                        const yCommonNameLength = y.fields[$e0eda949f811dcf3$var$commonNameField]?.length || 0;
                        return xCommonNameLength - yCommonNameLength;
                    })
                }
            }
        };
    }
    constructor(){
        this.DEFAULT_PER_PAGE = 12;
        this.getProjectPlants = (0, $0023026720e9f6ec$export$2ca41f3dca67d8b9)(async (projectId, language)=>{
            let { data: plantedPlantsFromDB, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').select(`id, name, dateOfPlantingUtc, photos, comment, plantBaseId, overwrittenBaseFields, projectId, coordinates, userId, confidenceInPlantVariety, isPlantDeleted, template, basePlant:plantBaseId( id, fields, image_id ), project:projectId( name ), gardenPlanVariantId, collections:plantedPlantsVSCollection( ...plantedPlantsCollections(id, color, name) ), todos:plantedPlantsVSToDos(...toDos(id))`).eq('projectId', projectId).eq('isPlantDeleted', false).order('name');
            const plantedPlants = (plantedPlantsFromDB ?? []).map((plantFromDB)=>{
                const { basePlant: basePlant, project: project, ...plant } = plantFromDB;
                const userPlantFields = plant.overwrittenBaseFields || {};
                const basePlantFields = (basePlant || {})?.fields || {};
                const combinedPlantFields = $e0eda949f811dcf3$export$4e4b0a0660d01171(userPlantFields, basePlantFields, {
                    language: language
                }, true);
                const processedPlant = {
                    ...plant,
                    titlePhotoName: basePlant?.image_id,
                    fields: combinedPlantFields,
                    projectName: project?.name
                };
                return processedPlant;
            });
            return plantedPlants;
        });
        this.getPlantById = (0, $0023026720e9f6ec$export$2ca41f3dca67d8b9)(async (plantId, language)=>{
            let { data: plants, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').select('id, name, dateOfPlantingUtc, photos, comment, plantBaseId, overwrittenBaseFields, projectId, coordinates, userId, confidenceInPlantVariety, isPlantDeleted, template, basePlant:plantBaseId( id, fields, image_id ), project:projectId( name ), gardenPlanVariantId, collections:plantedPlantsVSCollection( ...plantedPlantsCollections(id, color, name) ), todos:plantedPlantsVSToDos(...toDos(id))').eq('id', plantId);
            const firstPlant = plants[0];
            if (!firstPlant) return {
                success: false,
                error: 'notFound'
            };
            const { basePlant: basePlant, project: project, ...userPlant } = firstPlant;
            basePlant;
            const userPlantFields = userPlant.overwrittenBaseFields || {};
            const basePlantFields = (basePlant || {})?.fields || {};
            const combinedPlantFields = $e0eda949f811dcf3$export$4e4b0a0660d01171(userPlantFields, basePlantFields, {
                language: language
            }, true);
            const plant = {
                ...userPlant,
                titlePhotoName: basePlant?.image_id,
                fields: combinedPlantFields,
                projectName: project?.name
            };
            return {
                success: true,
                plant: plant
            };
        });
        this.getUserPlants = (0, $0023026720e9f6ec$export$ade7a147f5129058)(async ()=>{
            let { data: plantedPlantsWithProjectName, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').select('id, name, dateOfPlantingUtc, photos, comment, plantBaseId, overwrittenBaseFields, projectId, coordinates, userId, confidenceInPlantVariety, isPlantDeleted, template, basePlant:plantBaseId( id, fields, image_id ), project:projectId( name ), gardenPlanVariantId, collections:plantedPlantsVSCollection( ...plantedPlantsCollections(id, color, name) )').eq('userId', await $e0eda949f811dcf3$var$currentUserId()).eq('isPlantDeleted', false);
            return (plantedPlantsWithProjectName ?? []).map(({ basePlant: basePlant, project: project, ...plant })=>({
                    ...plant,
                    projectName: project?.name,
                    titlePhotoName: basePlant?.image_id,
                    fields: {}
                }));
        });
        this.getUserPlantsNamesWithId = (0, $0023026720e9f6ec$export$ade7a147f5129058)(async ()=>{
            let { data: plantedPlantsNamesWithId, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plantedPlants').select('id, name, gardenPlanVariantId').eq('userId', await $e0eda949f811dcf3$var$currentUserId()).eq('isPlantDeleted', false);
            return plantedPlantsNamesWithId ?? [];
        });
        this.getPlantFromPlantDatabaseById = (0, $0023026720e9f6ec$export$2ca41f3dca67d8b9)(async (id)=>{
            const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('plant_database').select('id, fields, image_id, image_bucket').eq('id', id);
            if (error) return {
                status: 'error',
                error: error.message
            };
            else if (data.length !== 1) return {
                status: 'notFound'
            };
            else return {
                status: 'found',
                data: {
                    id: data[0].id,
                    fields: data[0].fields,
                    thumbnailUrl: (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from(data[0].image_bucket).getPublicUrl(data[0].image_id).data.publicUrl
                }
            };
        });
    }
}
const $e0eda949f811dcf3$export$63a75ecf7f0afbfa = [
    "\u044F\u043D\u0432\u0430\u0440\u044C",
    "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
    "\u043C\u0430\u0440\u0442",
    "\u0430\u043F\u0440\u0435\u043B\u044C",
    "\u043C\u0430\u0439",
    "\u0438\u044E\u043D\u044C",
    "\u0438\u044E\u043B\u044C",
    "\u0430\u0432\u0433\u0443\u0441\u0442",
    "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
    "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
    "\u043D\u043E\u044F\u0431\u0440\u044C",
    "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
];
const $e0eda949f811dcf3$export$9544d5bb712b01ea = new $e0eda949f811dcf3$export$d2c7c89f5167baea();


function $9b35792dcb248bd5$var$generateProjectMapFileName(userId, projectId) {
    return `${userId}/projectMap-${projectId}.jpg`;
}
class $9b35792dcb248bd5$export$52e15361974fd6ce {
    async getProjectLocation(lon, lat) {
        const locationAPICall = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}`;
        let locationName;
        try {
            const response = await fetch(locationAPICall);
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            locationName = `${data.city},${data.locality}`;
        } catch (error) {
            console.error('Error:', error);
        }
        return locationName;
    }
    async searchLocation(query) {
        let locationNames;
        const locationAPICall = `https://geocode.maps.co/search?q=${query}&api_key=66431a03acd0e847129730tba878cce`;
        try {
            const response = await fetch(locationAPICall);
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            locationNames = data.map((a)=>({
                    addressName: a.display_name,
                    latitude: a.lat,
                    longtitude: a.lon
                }));
        } catch (error) {
            console.error('Error:', error);
        }
        return locationNames;
    }
    async getUserLocation() {
        let location;
        const locationAPICall = `https://free.freeipapi.com/api/json`;
        try {
            const response = await fetch(locationAPICall);
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            location = {
                addressName: `${data.countryName}, ${data.regionName}, ${data.cityName}`,
                latitude: data.latitude,
                longtitude: data.longitude
            };
        } catch (error) {
            console.error('Error:', error);
        }
        return location;
    }
    async getProjectWeather(lon, lat) {
        const weatherAPICall = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current=temperature_2m,is_day,weather_code&hourly=temperature_2m&daily=weather_code,temperature_2m_max,temperature_2m_min&wind_speed_unit=ms`;
        let weather;
        try {
            const response = await fetch(weatherAPICall);
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            const currentDate = new Date();
            weather = {
                ...weather,
                currentTempreture: data.current.temperature_2m,
                icon: (0, $0b79c81a92888b7f$export$bf93b541325766f8)[data.current.weather_code].weatherIcon,
                description: (0, $0b79c81a92888b7f$export$bf93b541325766f8)[data.current.weather_code].descriptionShort,
                nextDaysWeather: [],
                locationName: await this.getProjectLocation(lon, lat),
                date: currentDate.toLocaleDateString(),
                backImage: (0, $0b79c81a92888b7f$export$bf93b541325766f8)[data.current.weather_code].imageBack
            };
            for(let i = 0; i < 7; i++)weather.nextDaysWeather.push({
                dayOfWeek: (0, $0b79c81a92888b7f$export$548d0356db7f67bf)[currentDate.getDay() + i > 6 ? currentDate.getDay() + i - 7 : currentDate.getDay() + i],
                icon: (0, $0b79c81a92888b7f$export$bf93b541325766f8)[data.daily.weather_code[i]].weatherIcon,
                dayTemp: data.daily.temperature_2m_max[i],
                nightTemp: data.daily.temperature_2m_min[i]
            });
        } catch (error) {
            console.error('Error:', error);
        }
        return weather;
    }
    async uploadProjectMap(projectId, mapImage) {
        const userId = (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session?.user.id;
        const name = $9b35792dcb248bd5$var$generateProjectMapFileName(userId, projectId);
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('photos').upload(name, (0, $54fd325d6e6ebc1d$export$24bc7e761c190a9f)(mapImage.srcUrl), {
            cacheControl: '3600',
            upsert: true
        });
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    clearProjectListCaches() {
        this.getUserProjects.clearCache();
        this.getUserProjectsInfoStatistics.clearCache();
        this.getUserProjectsNames.clearCache();
        this.getUserProjectMaxPlantsInfoStatistics.clearCache();
        this.getUserProjectsInfoStatistics.clearCache();
        (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getPlantById.clearAllCached();
    }
    async createProject(newProject, mapImage) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('projects').insert([
            newProject
        ]).select('id').maybeSingle();
        if (error) return {
            success: false,
            error: error
        };
        const projectId = data.id;
        if (mapImage) {
            const result = await this.uploadProjectMap(projectId, mapImage);
            if (result.success === false) return result;
        }
        this.clearProjectListCaches();
        return {
            success: true,
            id: projectId
        };
    }
    async editProject(currentProject, mapImage) {
        if (mapImage) {
            const result = await this.uploadProjectMap(currentProject.id, mapImage);
            if (result.success === false) return result;
        }
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('projects').update([
            currentProject
        ]).eq('id', currentProject.id).select('id').maybeSingle();
        if (error) return {
            success: false,
            error: error
        };
        else {
            (0, $f72b095965a02692$export$355b0b6aff080555)();
            this.clearProjectListCaches();
            this.getUserProjectById.clearCachedById(currentProject.id);
            this.getUserProjectElements.clearCachedById(currentProject.id);
            return {
                success: true,
                id: data.id
            };
        }
    }
    async deleteProject(currentProjectId, isAlsoRemovePlants, isAlsoRemovePlantsEvents) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).functions.invoke(`delete-project`, {
            body: {
                projectId: currentProjectId,
                alsoRemovePlants: isAlsoRemovePlants,
                alsoRemovePlantsEvents: isAlsoRemovePlantsEvents
            }
        });
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.clearProjectListCaches();
            return {
                success: true
            };
        }
    }
    async getUserSnapshots() {
        let { data: projects, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('projects').select('*').eq('ownerId', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session?.user.id).eq('isSnapshot', true);
        return projects;
    }
    async makeProjectSnapshot(currentProjectId) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).rpc('createProjectSnapshot', {
            projectid: currentProjectId
        });
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    constructor(){
        this.getUserProjects = (0, $0023026720e9f6ec$export$ade7a147f5129058)(async ()=>{
            let { data: projects, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('projects').select('*').eq('ownerId', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session?.user.id).eq('isSnapshot', false);
            return projects;
        });
        this.getUserProjectsInfoStatistics = (0, $0023026720e9f6ec$export$ade7a147f5129058)(async ()=>{
            let { data: projects, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('projects').select('id, name, photo, location, plantedPlantsAmount:planted_plants_data(count), planted_plants_data(projectId, overwrittenBaseFields, basePlant:plantBaseId( id, fields, image_id ))').eq('ownerId', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session?.user.id).eq('isSnapshot', false);
            const projectsStatistics = projects.map((project)=>{
                let projectPlantTypes = {};
                let projectPlantAttractivenessFactors = {};
                for (const plant of project.planted_plants_data){
                    let plantTypes = [];
                    if (plant.overwrittenBaseFields["\u0422\u0438\u043F"]) plantTypes = plant.overwrittenBaseFields["\u0422\u0438\u043F"];
                    else if (plant.basePlant?.fields["\u0422\u0438\u043F"]) plantTypes = plant.basePlant?.fields["\u0422\u0438\u043F"];
                    for (const type of plantTypes)projectPlantTypes[type] ? projectPlantTypes[type]++ : projectPlantTypes[type] = 1;
                    const plantAttractivenessFactors = (plant.overwrittenBaseFields["\u0424\u0430\u043A\u0442\u043E\u0440\u044B \u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438"] ? plant.overwrittenBaseFields["\u0424\u0430\u043A\u0442\u043E\u0440\u044B \u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438"] : plant.basePlant?.fields["\u0424\u0430\u043A\u0442\u043E\u0440\u044B \u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438"]) || [];
                    for (const factor of plantAttractivenessFactors)projectPlantAttractivenessFactors[factor] ? projectPlantAttractivenessFactors[factor]++ : projectPlantAttractivenessFactors[factor] = 1;
                }
                return {
                    id: project.id,
                    name: project.name,
                    plantedPlantsAmount: project.plantedPlantsAmount[0].count,
                    plantedPlantsTypes: projectPlantTypes,
                    plantedPlantsAttractivenessFactors: projectPlantAttractivenessFactors,
                    photo: project.photo,
                    coordinates: project.location ? [
                        project.location.longtitude,
                        project.location.latitude
                    ] : null
                };
            });
            return projectsStatistics;
        });
        this.getUserProjectMaxPlantsInfoStatistics = (0, $0023026720e9f6ec$export$ade7a147f5129058)(async ()=>{
            const projectsStatistics = await this.getUserProjectsInfoStatistics();
            if (projectsStatistics.length === 0) return null;
            let max = -1;
            let index = 0;
            projectsStatistics.forEach(function(v, k) {
                if (max < v.plantedPlantsAmount) {
                    max = v.plantedPlantsAmount;
                    index = k;
                }
            });
            if (projectsStatistics[index].coordinates) projectsStatistics[index].weather = await this.getProjectWeather(projectsStatistics[index].coordinates[0], projectsStatistics[index].coordinates[1]);
            else projectsStatistics[index].weather = null;
            // projectsStatistics[index].mainToDos = await toDoService.getUserUnfinishedToDos(3, {
            //   projectId: projectsStatistics[index].id,
            // })
            return projectsStatistics[index];
        });
        this.getUserProjectElements = (0, $0023026720e9f6ec$export$2ca41f3dca67d8b9)(async (id)=>{
            const project = await this.getUserProjectById(id);
            return project.elements || [];
        });
        this.getUserProjectsNames = (0, $0023026720e9f6ec$export$ade7a147f5129058)(async ()=>{
            let { data: projects, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('projects').select('id, name').eq('ownerId', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session?.user.id).eq('isSnapshot', false);
            return projects;
        });
        this.getUserProjectById = (0, $0023026720e9f6ec$export$2ca41f3dca67d8b9)(async (id)=>{
            let { data: project, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('projects').select('*').eq('id', id).maybeSingle();
            return project;
        });
        this.getProjectMapUrl = (0, $0023026720e9f6ec$export$2ca41f3dca67d8b9)(async (projectId)=>{
            const userId = (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session?.user.id;
            const name = $9b35792dcb248bd5$var$generateProjectMapFileName(userId, projectId);
            const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('photos').createSignedUrl(name, 60);
            if (error) return {
                success: false,
                error: error
            };
            else return {
                success: true,
                url: data.signedUrl
            };
        });
        this.getProjectMapAttributes = (0, $0023026720e9f6ec$export$2ca41f3dca67d8b9)(async (id)=>{
            let { data: location, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('projects').select('location').eq('id', id).maybeSingle();
            return location.location.map || null;
        });
    }
}
const $9b35792dcb248bd5$export$9544d5bb712b01ea = new $9b35792dcb248bd5$export$52e15361974fd6ce();




let $6139c0a58835b448$var$forceRevalidate = true;
function $6139c0a58835b448$export$f5708c5af9a60b0c() {
    $6139c0a58835b448$var$forceRevalidate = true;
}
const $6139c0a58835b448$export$7d2dde62355c39dc = ({ currentParams: currentParams, nextParams: nextParams, formMethod: formMethod })=>{
    if (formMethod === 'post' || formMethod === 'delete') return true;
    if ($6139c0a58835b448$var$forceRevalidate) {
        $6139c0a58835b448$var$forceRevalidate = false;
        return true;
    }
    return currentParams.plantId != nextParams.plantId;
};



const $b6a40c35fe89493a$export$fc8eed1fd79f2728 = `id, creationDateUtc, targetStartDateUtc, targetEndDateUtc, comment, type, importance, plants:plantedPlantsVSToDos( ...plantedPlants(id, name) ), customToDoType:customToDoTypes(id,name,icon)`;
// only a custom type has an id of its own, and a deleted one has lost it
function $b6a40c35fe89493a$var$customTypeIdOf(type) {
    if (!type || type.type !== 'custom' || !type.customToDoType) return null;
    return type.customToDoType.id;
}
function $b6a40c35fe89493a$export$5e399755b593b482(databaseToDoRecord) {
    const { type: type, customToDoType: customToDoType, ...rest } = databaseToDoRecord;
    if (type === 'custom') return {
        ...databaseToDoRecord,
        type: {
            type: type,
            customToDoType: customToDoType
        }
    };
    else return {
        ...databaseToDoRecord,
        type: {
            type: type
        }
    };
}
class $b6a40c35fe89493a$export$c0e758c3bc9fb46c {
    async upsertToDo(newToDo) {
        const { plants: plants, type: type, ...toDo } = newToDo;
        if (plants && plants.length > 0) {
            (0, $6139c0a58835b448$export$f5708c5af9a60b0c)();
            for (const plant of plants)(0, $e0eda949f811dcf3$export$9544d5bb712b01ea).clearPlantCaches(plant.id);
        }
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).functions.invoke('upsert-todo-with-plant-links', {
            method: 'POST',
            body: JSON.stringify({
                ...newToDo,
                type: type?.type,
                customTypeId: $b6a40c35fe89493a$var$customTypeIdOf(type)
            })
        });
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.clearTodoCaches();
            return {
                success: true
            };
        }
    }
    async createToDoList(newToDoList) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('toDoLists').insert([
            newToDoList
        ]);
        // await new Promise((resolve) => setTimeout(resolve, 2000))
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    async createUserToDoType(newToDoTypeName, newToDoTypeIcon) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('customToDoTypes').insert([
            {
                name: newToDoTypeName,
                icon: newToDoTypeIcon,
                owner_id: (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id
            }
        ]).select('id, name, icon');
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.getUserToDoTypes.clearCache();
            return {
                success: true,
                data: data[0]
            };
        }
    }
    async editUserToDoType(newToDoType) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('customToDoTypes').update({
            name: newToDoType.name,
            icon: newToDoType.icon
        }).eq('id', newToDoType.id).eq('owner_id', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id).select('id, name, icon');
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.getUserToDoTypes.clearCache();
            this.clearTodoCaches();
            return {
                success: true,
                data: data[0]
            };
        }
    }
    async deleteUserToDoType(id) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('customToDoTypes').delete().eq('id', id).eq('owner_id', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id);
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.getUserToDoTypes.clearCache();
            this.clearTodoCaches();
            return {
                success: true
            };
        }
    }
    async editToDo(currentToDo) {
        const { plants: plants, type: type, ...toDo } = currentToDo;
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).functions.invoke('upsert-todo-with-plant-links', {
            method: 'POST',
            body: JSON.stringify({
                ...currentToDo,
                type: type?.type ? type.type : null,
                customTypeId: $b6a40c35fe89493a$var$customTypeIdOf(type)
            })
        });
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.clearTodoCaches();
            return {
                success: true,
                data: data
            };
        }
    }
    async finishToDo(currentToDo, completionDate, eventType, projectId) {
        const userId = (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id;
        // generate a separate event for every plant
        const events = currentToDo.plants.length === 0 ? {
            projectId: projectId,
            type: eventType.id ? 'custom' : eventType.name,
            custom_type_id: eventType.id ? eventType.id : null,
            creationDateUtc: currentToDo.creationDateUtc || new Date(),
            startDateUtc: currentToDo.targetStartDateUtc,
            endDateUtc: currentToDo.targetEndDateUtc,
            actualCompletionDateUtc: completionDate,
            comment: currentToDo.comment,
            ownerId: userId
        } : currentToDo.plants.map((plant)=>({
                projectId: projectId,
                type: eventType.id ? 'custom' : eventType.name,
                custom_type_id: eventType.id ? eventType.id : null,
                creationDateUtc: currentToDo.creationDateUtc || new Date(),
                startDateUtc: currentToDo.targetStartDateUtc,
                endDateUtc: currentToDo.targetEndDateUtc,
                actualCompletionDateUtc: completionDate,
                comment: currentToDo.comment,
                plantId: plant.id,
                ownerId: userId
            }));
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('journalEvents').insert(events);
        if (error) return {
            success: false,
            error: error
        };
        else {
            await this.deleteToDo(currentToDo.id);
            this.clearTodoCaches();
            return {
                success: true
            };
        }
    }
    async editToDoList(currentToDoList) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('toDoLists').update([
            currentToDoList
        ]).eq('id', currentToDoList.id);
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.clearTodoCaches();
            return {
                success: true
            };
        }
    }
    async deleteToDo(id) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('toDos').delete().eq('id', id);
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.clearTodoCaches();
            return {
                success: true
            };
        }
    }
    async deleteToDoList(id) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('toDoLists').delete().eq('id', id);
        if (error) return {
            success: false,
            error: error
        };
        else {
            this.clearTodoCaches();
            return {
                success: true
            };
        }
    }
    constructor(){
        this.getUserToDoLists = (0, $0023026720e9f6ec$export$ade7a147f5129058)(async ()=>{
            let { data: toDoListsWithToDos, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('toDoLists').select('id, ownerId, name, projectId, toDos(*)').eq('ownerId', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id);
            return toDoListsWithToDos;
        });
        this.getUserUnfinishedToDoLists = (0, $0023026720e9f6ec$export$ade7a147f5129058)(async ()=>{
            let { data: toDoListsWithToDos, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('toDoLists').select('id, ownerId, name, projectId, toDos(*)').eq('ownerId', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id);
            return toDoListsWithToDos;
        });
        this.getUserUnfinishedToDos = (0, $0023026720e9f6ec$export$ade7a147f5129058)(async ()=>{
            let query = (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('toDos').select($b6a40c35fe89493a$export$fc8eed1fd79f2728);
            const { data: toDos, error: error } = await query.order('targetStartDateUtc', {
                ascending: true
            }).order('type', {
                ascending: true
            });
            return toDos ? toDos.map($b6a40c35fe89493a$export$5e399755b593b482) : [];
        });
        this.getUserUnfinishedPlantsToDos = (0, $0023026720e9f6ec$export$ade7a147f5129058)(async ()=>{
            let query = (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('toDos').select($b6a40c35fe89493a$export$fc8eed1fd79f2728).is('toDoListId', null);
            const { data: toDos, error: error } = await query;
            return toDos.map($b6a40c35fe89493a$export$5e399755b593b482);
        });
        this.getUserUnfinishedPlantsToDosByPlantId = (0, $0023026720e9f6ec$export$2ca41f3dca67d8b9)(async (plantId)=>{
            let query = (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('toDos').select(`id, creationDateUtc, targetStartDateUtc, targetEndDateUtc, comment, type, importance, plants:plantedPlantsVSToDos!inner( ...plantedPlants(id, name) ), customToDoType:customToDoTypes(id,name,icon)`).eq('plants.plantId', plantId);
            const { data: toDos, error: error } = await query;
            return toDos.map($b6a40c35fe89493a$export$5e399755b593b482);
        });
        this.getUserFinishedToDos = (0, $0023026720e9f6ec$export$ade7a147f5129058)(async ()=>{
            let { data: toDos, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('journalEvents').select('*').eq('type', 'finishedToDo');
            return toDos;
        });
        // public async getUserFinishedToDoById(id: number): Promise<JournalRecord> {
        //   let {data: toDoRecord, error} = await supabase
        //     .from('journalEvents')
        //     .select('id, name, startDateUtc, comment, elementId, comment, eventCategory')
        //     .eq('id', id)
        //   return {
        //     eventCategory: toDoRecord[0].eventCategory,
        //     id: toDoRecord[0].id,
        //     name: toDoRecord[0].name,
        //     startDateUtc: toDoRecord[0].startDateUtc,
        //   } as JournalRecord
        // }
        this.getProjectUnfinishedToDos = (0, $0023026720e9f6ec$export$2ca41f3dca67d8b9)(async (projectId)=>{
            // let {data: toDos, error} = await supabase.from('toDos').select('*').eq('projectId', projectId)
            let { data: toDoLists, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('toDoLists').select(`id, ownerId, projectId, name, toDos(${$b6a40c35fe89493a$export$fc8eed1fd79f2728})`).eq('ownerId', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id).eq('projectId', projectId);
            if (!error) return toDoLists.flatMap((l)=>l.toDos);
            return [];
        });
        this.clearTodoCaches = ()=>{
            this.getProjectUnfinishedToDos.clearAllCached();
            this.getUserFinishedToDos.clearCache();
            this.getUserUnfinishedPlantsToDosByPlantId.clearAllCached();
            this.getUserUnfinishedPlantsToDos.clearCache();
            this.getUserUnfinishedToDoLists.clearCache();
            this.getUserUnfinishedToDos.clearCache();
        };
        this.getUserToDoTypes = (0, $0023026720e9f6ec$export$ade7a147f5129058)(async ()=>{
            const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('customToDoTypes').select('id, name, icon').eq('owner_id', (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id);
            if (error) return {
                success: false,
                error: error
            };
            else return {
                success: true,
                data: data.map((type)=>({
                        type: 'custom',
                        customToDoType: type
                    }))
            };
        });
    }
}
const $b6a40c35fe89493a$export$9544d5bb712b01ea = new $b6a40c35fe89493a$export$c0e758c3bc9fb46c();






const $0270799cdc102f8c$export$16afd5012a6dc147 = 'id, news_title, news_title_ru, news_title_pl, news_text, news_text_ru, news_text_pl, title_photo, type, URL, created_at, tags:tagsVSNews( ...newsTags(id, tag_name, tag_name_ru, tag_name_pl, color) )';
class $0270799cdc102f8c$export$ec6705ec81c3a093 {
    async getNewsLists(newsCount = 10) {
        let { data: newsList, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('news').select($0270799cdc102f8c$export$16afd5012a6dc147).eq('draft', false).order('created_at', {
            ascending: false
        }).limit(newsCount);
        return newsList?.map((news)=>{
            const titlePhotoURL = (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('news').getPublicUrl(`/${news.title_photo}`);
            return {
                id: news.id,
                newsName: news.news_title,
                newsNameRU: news.news_title_ru,
                newsNamePL: news.news_title_pl,
                text: news.news_text?.slice(0, 200),
                textPL: news.news_text_pl?.slice(0, 200),
                textRU: news.news_text_ru?.slice(0, 200),
                dateOfCreating: news.created_at,
                titlePhotoURL: news.title_photo ? titlePhotoURL.data.publicUrl : (0, (/*@__PURE__*/$parcel$interopDefault($f0a4ffbb486b57b4$exports))),
                newsType: news.type,
                url: news.URL,
                tags: news.tags.map((t)=>({
                        id: t.id,
                        tagName: t.tag_name,
                        tagNameRu: t.tag_name_ru,
                        tagNamePl: t.tag_name_pl,
                        color: t.color
                    }))
            };
        });
    }
    async getFilteredNewsLists({ page: page, perPage: perPage, searchQuery: searchQuery, tagFilters: tagFilters }, language) {
        let query = (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('news').select('id, news_title, news_title_ru, news_title_pl, title_photo, news_text, news_text_ru, news_text_pl, type, URL, created_at', {
            count: 'exact'
        }).eq('draft', false).order('created_at', {
            ascending: false
        }).range((page - 1) * perPage, page * perPage - 1);
        if (tagFilters && tagFilters.length > 0) query = query.filter('type', 'in', `(${tagFilters})`);
        if (searchQuery) query = query.filter(language === 'ru' ? 'news_title_ru' : 'news_title', 'ilike', `%${searchQuery}%`);
        let { data: newsList, count: count, error: error } = await query;
        const filteredNewsList = newsList?.map((news)=>{
            const titlePhotoURL = (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('news').getPublicUrl(`/${news.title_photo}`);
            return {
                id: news.id,
                newsName: news.news_title,
                newsNameRU: news.news_title_ru,
                newsNamePL: news.news_title_pl,
                dateOfCreating: news.created_at,
                titlePhotoURL: news.title_photo ? titlePhotoURL.data.publicUrl : (0, (/*@__PURE__*/$parcel$interopDefault($f0a4ffbb486b57b4$exports))),
                newsType: news.type,
                text: news.news_text?.slice(0, 200),
                textPL: news.news_text_pl?.slice(0, 200),
                textRU: news.news_text_ru?.slice(0, 200),
                url: news.URL
            };
        });
        return {
            newsList: filteredNewsList,
            totalCount: count
        };
    }
    async getNewsById(newsURL) {
        let { data: newsById, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('news').select('id, news_title, news_title_ru, news_title_pl, title_photo, news_text, news_text_ru, news_text_pl, type, URL, created_at').eq('draft', false).eq('URL', newsURL);
        const titlePhotoURL = (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('news').getPublicUrl(`/${newsById[0].title_photo}`);
        return {
            id: newsById[0].id,
            newsName: newsById[0].news_title,
            newsNameRU: newsById[0].news_title_ru,
            newsNamePL: newsById[0].news_title_pl,
            dateOfCreating: newsById[0].created_at,
            titlePhotoURL: newsById[0].title_photo ? titlePhotoURL.data.publicUrl : (0, (/*@__PURE__*/$parcel$interopDefault($f0a4ffbb486b57b4$exports))),
            newsType: newsById[0].type,
            text: newsById[0].news_text,
            textPL: newsById[0].news_text_pl,
            textRU: newsById[0].news_text_ru,
            url: newsById[0].URL
        };
    }
    constructor(){
        this.DEFAULT_PER_PAGE = 10;
    }
}
const $0270799cdc102f8c$export$9544d5bb712b01ea = new $0270799cdc102f8c$export$ec6705ec81c3a093();



class $5fab5f2ee6cc184e$export$8ea6f5c947842af {
    async getProjectGardenPlanVariants(projectId) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('gardenPlantVariants').select().eq('projectId', projectId).order('name');
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true,
            projectGardenPlanVariants: data
        };
    }
    async createGardenPlanVariant(newGardenVariant) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('gardenPlantVariants').insert([
            newGardenVariant
        ]).select('id').maybeSingle();
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true,
            id: data?.id
        };
    }
    async deleteGardenPlanVariant(currentGardenVariantId) {
        const { error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('gardenPlantVariants').delete().eq('id', currentGardenVariantId);
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    async editGardenPlanVariantName(newGardenPlanVariant) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('gardenPlantVariants').update({
            name: newGardenPlanVariant.name
        }).eq('id', newGardenPlanVariant.id).select('id, name, projectId');
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true,
            data: data[0]
        };
    }
    async applyGardenPlanVariantToProject(currentGardenVariantId) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).functions.invoke(`apply-garden-plan-variant-to-project`, {
            body: {
                planId: currentGardenVariantId
            }
        });
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
}
const $5fab5f2ee6cc184e$export$9544d5bb712b01ea = new $5fab5f2ee6cc184e$export$8ea6f5c947842af();




parcelRequire("ltGt3");

function $927e51d10bec7c73$export$b6032183171af19f() {
    const { token: { controlHeightSM: controlHeightSM } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    // const project = projectsService.database[0]
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $493cbc5b00d91baa$export$910ae8079b2c2852), {})
    });
}




var $ltGt3 = parcelRequire("ltGt3");








// ============================== Size ================================
const $6e26d892d0a290a3$var$genSizeDividerStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-horizontal': {
                [`&${componentCls}`]: {
                    '&-sm': {
                        marginBlock: token.marginXS
                    },
                    '&-md': {
                        marginBlock: token.margin
                    }
                }
            }
        }
    };
};
// ============================== Shared ==============================
const $6e26d892d0a290a3$var$genSharedDividerStyle = (token)=>{
    const { componentCls: componentCls, sizePaddingEdgeHorizontal: sizePaddingEdgeHorizontal, colorSplit: colorSplit, lineWidth: lineWidth, textPaddingInline: textPaddingInline, orientationMargin: orientationMargin, verticalMarginInline: verticalMarginInline } = token;
    const railCls = `${componentCls}-rail`;
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            borderBlockStart: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} solid ${colorSplit}`,
            [railCls]: {
                borderBlockStart: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} solid ${colorSplit}`
            },
            // vertical
            '&-vertical': {
                position: 'relative',
                top: '-0.06em',
                display: 'inline-block',
                height: '0.9em',
                marginInline: verticalMarginInline,
                marginBlock: 0,
                verticalAlign: 'middle',
                borderTop: 0,
                borderInlineStart: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} solid ${colorSplit}`
            },
            '&-horizontal': {
                display: 'flex',
                clear: 'both',
                width: '100%',
                minWidth: '100%',
                // Fix https://github.com/ant-design/ant-design/issues/10914
                margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.marginLG)} 0`
            },
            [`&-horizontal${componentCls}-with-text`]: {
                display: 'flex',
                alignItems: 'center',
                margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.dividerHorizontalWithTextGutterMargin)} 0`,
                color: token.colorTextHeading,
                fontWeight: 500,
                fontSize: token.fontSizeLG,
                whiteSpace: 'nowrap',
                textAlign: 'center',
                borderBlockStart: `0 ${colorSplit}`,
                [`${railCls}-start, ${railCls}-end`]: {
                    width: '50%',
                    // Chrome not accept `inherit` in `border-top`
                    borderBlockStartColor: 'inherit',
                    borderBlockEnd: 0,
                    content: "''"
                }
            },
            [`&-horizontal${componentCls}-with-text-start`]: {
                [`${railCls}-start`]: {
                    width: `calc(${orientationMargin} * 100%)`
                },
                [`${railCls}-end`]: {
                    width: `calc(100% - ${orientationMargin} * 100%)`
                }
            },
            [`&-horizontal${componentCls}-with-text-end`]: {
                [`${railCls}-start`]: {
                    width: `calc(100% - ${orientationMargin} * 100%)`
                },
                [`${railCls}-end`]: {
                    width: `calc(${orientationMargin} * 100%)`
                }
            },
            [`${componentCls}-inner-text`]: {
                display: 'inline-block',
                paddingBlock: 0,
                paddingInline: textPaddingInline
            },
            '&-dashed': {
                background: 'none',
                borderColor: colorSplit,
                borderStyle: 'dashed',
                borderWidth: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} 0 0`,
                [railCls]: {
                    borderBlockStart: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} dashed ${colorSplit}`
                }
            },
            [`&-horizontal${componentCls}-with-text${componentCls}-dashed`]: {
                [`${railCls}-start, ${railCls}-end`]: {
                    borderStyle: 'dashed none none'
                }
            },
            [`&-vertical${componentCls}-dashed`]: {
                borderInlineStartWidth: lineWidth,
                borderInlineEnd: 0,
                borderBlockStart: 0,
                borderBlockEnd: 0
            },
            '&-dotted': {
                background: 'none',
                borderColor: colorSplit,
                borderStyle: 'dotted',
                borderWidth: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} 0 0`,
                [railCls]: {
                    borderBlockStart: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} dotted ${colorSplit}`
                }
            },
            [`&-horizontal${componentCls}-with-text${componentCls}-dotted`]: {
                '&::before, &::after': {
                    borderStyle: 'dotted none none'
                }
            },
            [`&-vertical${componentCls}-dotted`]: {
                borderInlineStartWidth: lineWidth,
                borderInlineEnd: 0,
                borderBlockStart: 0,
                borderBlockEnd: 0
            },
            [`&-plain${componentCls}-with-text`]: {
                color: token.colorText,
                fontWeight: 'normal',
                fontSize: token.fontSize
            },
            [`&-horizontal${componentCls}-with-text-start${componentCls}-no-default-orientation-margin-start`]: {
                [`${railCls}-start`]: {
                    width: 0
                },
                [`${railCls}-end`]: {
                    width: '100%'
                },
                [`${componentCls}-inner-text`]: {
                    paddingInlineStart: sizePaddingEdgeHorizontal
                }
            },
            [`&-horizontal${componentCls}-with-text-end${componentCls}-no-default-orientation-margin-end`]: {
                [`${railCls}-start`]: {
                    width: '100%'
                },
                [`${railCls}-end`]: {
                    width: 0
                },
                [`${componentCls}-inner-text`]: {
                    paddingInlineEnd: sizePaddingEdgeHorizontal
                }
            }
        }
    };
};
const $6e26d892d0a290a3$export$9ca1be8807fe0675 = (token)=>({
        textPaddingInline: '1em',
        orientationMargin: 0.05,
        verticalMarginInline: token.marginXS
    });
var // ============================== Export ==============================
$6e26d892d0a290a3$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Divider', (token)=>{
    const dividerToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        dividerHorizontalWithTextGutterMargin: token.margin,
        sizePaddingEdgeHorizontal: 0
    });
    return [
        $6e26d892d0a290a3$var$genSharedDividerStyle(dividerToken),
        $6e26d892d0a290a3$var$genSizeDividerStyle(dividerToken)
    ];
}, $6e26d892d0a290a3$export$9ca1be8807fe0675, {
    unitless: {
        orientationMargin: true
    }
});


"use client";
const $638ba0bcda633638$var$titlePlacementList = [
    'left',
    'right',
    'center',
    'start',
    'end'
];
const $638ba0bcda633638$var$sizeClassNameMap = {
    small: 'sm',
    middle: 'md'
};
const $638ba0bcda633638$var$Divider = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('divider');
    const { prefixCls: customizePrefixCls, type: type, orientation: orientation, vertical: vertical, titlePlacement: titlePlacement, orientationMargin: orientationMargin, className: className, rootClassName: rootClassName, children: children, dashed: dashed, variant: variant = 'solid', plain: plain, style: style, size: customSize, classNames: classNames, styles: styles, ...restProps } = props;
    const prefixCls = getPrefixCls('divider', customizePrefixCls);
    const railCls = `${prefixCls}-rail`;
    const [hashId, cssVarCls] = (0, $6e26d892d0a290a3$export$2e2bcd8739ae039)(prefixCls);
    const sizeFullName = (0, $7bb31c172903861d$export$2e2bcd8739ae039)(customSize);
    const sizeCls = $638ba0bcda633638$var$sizeClassNameMap[sizeFullName];
    const hasChildren = !!children;
    const validTitlePlacement = $638ba0bcda633638$var$titlePlacementList.includes(orientation || '');
    const mergedTitlePlacement = $ltGt3.useMemo(()=>{
        const placement = titlePlacement ?? (validTitlePlacement ? orientation : 'center');
        if (placement === 'left') return direction === 'rtl' ? 'end' : 'start';
        if (placement === 'right') return direction === 'rtl' ? 'start' : 'end';
        return placement;
    }, [
        direction,
        orientation,
        titlePlacement,
        validTitlePlacement
    ]);
    const hasMarginStart = mergedTitlePlacement === 'start' && orientationMargin != null;
    const hasMarginEnd = mergedTitlePlacement === 'end' && orientationMargin != null;
    const [mergedOrientation, mergedVertical] = (0, $15bdf1069fb84d0c$export$550084c67147f6c4)(orientation, vertical, type);
    // ========================= Semantic =========================
    const mergedProps = {
        ...props,
        orientation: mergedOrientation,
        titlePlacement: mergedTitlePlacement,
        size: sizeFullName
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, contextClassName, hashId, cssVarCls, `${prefixCls}-${mergedOrientation}`, {
        [`${prefixCls}-with-text`]: hasChildren,
        [`${prefixCls}-with-text-${mergedTitlePlacement}`]: hasChildren,
        [`${prefixCls}-dashed`]: !!dashed,
        [`${prefixCls}-${variant}`]: variant !== 'solid',
        [`${prefixCls}-plain`]: !!plain,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-no-default-orientation-margin-start`]: hasMarginStart,
        [`${prefixCls}-no-default-orientation-margin-end`]: hasMarginEnd,
        [`${prefixCls}-${sizeCls}`]: !!sizeCls,
        [railCls]: !children,
        [mergedClassNames.rail]: mergedClassNames.rail && !children
    }, className, rootClassName, mergedClassNames.root);
    const memoizedPlacementMargin = $ltGt3.useMemo(()=>{
        if (typeof orientationMargin === 'number') return orientationMargin;
        if (/^\d+$/.test(orientationMargin)) return Number(orientationMargin);
        return orientationMargin;
    }, [
        orientationMargin
    ]);
    const innerStyle = {
        marginInlineStart: hasMarginStart ? memoizedPlacementMargin : undefined,
        marginInlineEnd: hasMarginEnd ? memoizedPlacementMargin : undefined
    };
    var deprecatedName, newName;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: classString,
        style: {
            ...contextStyle,
            ...mergedStyles.root,
            ...children ? {} : mergedStyles.rail,
            ...style
        },
        ...restProps,
        role: "separator"
    }, children && !mergedVertical && /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(railCls, `${railCls}-start`, mergedClassNames.rail),
        style: mergedStyles.rail
    }), /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-inner-text`, mergedClassNames.content),
        style: {
            ...innerStyle,
            ...mergedStyles.content
        }
    }, children), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(railCls, `${railCls}-end`, mergedClassNames.rail),
        style: mergedStyles.rail
    })));
};
var $638ba0bcda633638$export$2e2bcd8739ae039 = $638ba0bcda633638$var$Divider;


parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");







var $ltGt3 = parcelRequire("ltGt3");
function $23b575dfbfba8f66$export$2e2bcd8739ae039(value) {
    const [cacheValue, setCacheValue] = $ltGt3.useState(value);
    $ltGt3.useEffect(()=>{
        const timeout = setTimeout(()=>{
            setCacheValue(value);
        }, value.length ? 0 : 10);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        value
    ]);
    return cacheValue;
}






const $ff31b917511a72fb$var$genFormValidateMotionStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const helpCls = `${componentCls}-show-help`;
    const helpItemCls = `${componentCls}-show-help-item`;
    return {
        [helpCls]: {
            // Explain holder
            transition: `opacity ${token.motionDurationFast} ${token.motionEaseInOut}`,
            '&-appear, &-enter': {
                opacity: 0,
                '&-active': {
                    opacity: 1
                }
            },
            '&-leave': {
                opacity: 1,
                '&-active': {
                    opacity: 0
                }
            },
            // Explain
            [helpItemCls]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationFast} ${token.motionEaseInOut},
                     opacity ${token.motionDurationFast} ${token.motionEaseInOut},
                     transform ${token.motionDurationFast} ${token.motionEaseInOut} !important`,
                [`&${helpItemCls}-appear, &${helpItemCls}-enter`]: {
                    transform: `translateY(-5px)`,
                    opacity: 0,
                    '&-active': {
                        transform: 'translateY(0)',
                        opacity: 1
                    }
                },
                [`&${helpItemCls}-leave-active`]: {
                    transform: `translateY(-5px)`
                }
            }
        }
    };
};
var $ff31b917511a72fb$export$2e2bcd8739ae039 = $ff31b917511a72fb$var$genFormValidateMotionStyle;


const $d7b26b1c51d43fd8$var$resetForm = (token)=>({
        legend: {
            display: 'block',
            width: '100%',
            marginBottom: token.marginLG,
            padding: 0,
            color: token.colorTextDescription,
            fontSize: token.fontSizeLG,
            lineHeight: 'inherit',
            border: 0,
            borderBottom: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        },
        'input[type="search"]': {
            boxSizing: 'border-box'
        },
        // Position radios and checkboxes better
        'input[type="radio"], input[type="checkbox"]': {
            lineHeight: 'normal'
        },
        'input[type="file"]': {
            display: 'block'
        },
        // Make range inputs behave like textual form controls
        'input[type="range"]': {
            display: 'block',
            width: '100%'
        },
        // Make multiple select elements height not fixed
        'select[multiple], select[size]': {
            height: 'auto'
        },
        // Focus for file, radio, and checkbox
        [`input[type='file']:focus,
  input[type='radio']:focus,
  input[type='checkbox']:focus`]: {
            outline: 0,
            boxShadow: `0 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.controlOutlineWidth)} ${token.controlOutline}`
        },
        // Adjust output element
        output: {
            display: 'block',
            paddingTop: 15,
            color: token.colorText,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight
        }
    });
const $d7b26b1c51d43fd8$var$genFormSize = (token, height)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [formItemCls]: {
            [`${formItemCls}-label > label`]: {
                height: height
            },
            [`${formItemCls}-control-input`]: {
                minHeight: height
            }
        }
    };
};
const $d7b26b1c51d43fd8$var$genFormStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [token.componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            ...$d7b26b1c51d43fd8$var$resetForm(token),
            [`${componentCls}-text`]: {
                display: 'inline-block',
                paddingInlineEnd: token.paddingSM
            },
            // ================================================================
            // =                             Size                             =
            // ================================================================
            '&-small': {
                ...$d7b26b1c51d43fd8$var$genFormSize(token, token.controlHeightSM)
            },
            '&-large': {
                ...$d7b26b1c51d43fd8$var$genFormSize(token, token.controlHeightLG)
            }
        }
    };
};
const $d7b26b1c51d43fd8$var$genFormItemStyle = (token)=>{
    const { formItemCls: formItemCls, iconCls: iconCls, rootPrefixCls: rootPrefixCls, antCls: antCls, labelRequiredMarkColor: labelRequiredMarkColor, labelColor: labelColor, labelFontSize: labelFontSize, labelHeight: labelHeight, labelColonMarginInlineStart: labelColonMarginInlineStart, labelColonMarginInlineEnd: labelColonMarginInlineEnd, itemMarginBottom: itemMarginBottom } = token;
    return {
        [formItemCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            marginBottom: itemMarginBottom,
            verticalAlign: 'top',
            '&-with-help': {
                transition: 'none'
            },
            [`&-hidden,
        &-hidden${antCls}-row`]: {
                // https://github.com/ant-design/ant-design/issues/26141
                display: 'none'
            },
            '&-has-warning': {
                [`${formItemCls}-split`]: {
                    color: token.colorError
                }
            },
            '&-has-error': {
                [`${formItemCls}-split`]: {
                    color: token.colorWarning
                }
            },
            // ==============================================================
            // =                            Label                           =
            // ==============================================================
            [`${formItemCls}-label`]: {
                flexGrow: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textAlign: 'end',
                verticalAlign: 'middle',
                '&-left': {
                    textAlign: 'start'
                },
                '&-wrap': {
                    overflow: 'unset',
                    lineHeight: token.lineHeight,
                    whiteSpace: 'unset',
                    '> label': {
                        verticalAlign: 'middle',
                        textWrap: 'balance'
                    }
                },
                '> label': {
                    position: 'relative',
                    display: 'inline-flex',
                    alignItems: 'center',
                    maxWidth: '100%',
                    height: labelHeight,
                    color: labelColor,
                    fontSize: labelFontSize,
                    [`> ${iconCls}`]: {
                        fontSize: token.fontSize,
                        verticalAlign: 'top'
                    },
                    [`&${formItemCls}-required`]: {
                        '&::before': {
                            display: 'inline-block',
                            marginInlineEnd: token.marginXXS,
                            color: labelRequiredMarkColor,
                            fontSize: token.fontSize,
                            fontFamily: 'SimSun, sans-serif',
                            lineHeight: 1,
                            content: '"*"'
                        },
                        [`&${formItemCls}-required-mark-hidden, &${formItemCls}-required-mark-optional`]: {
                            '&::before': {
                                display: 'none'
                            }
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-optional`]: {
                        display: 'inline-block',
                        marginInlineStart: token.marginXXS,
                        color: token.colorTextDescription,
                        [`&${formItemCls}-required-mark-hidden`]: {
                            display: 'none'
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-tooltip`]: {
                        color: token.colorTextDescription,
                        cursor: 'help',
                        writingMode: 'horizontal-tb',
                        marginInlineStart: token.marginXXS
                    },
                    '&::after': {
                        content: '":"',
                        position: 'relative',
                        marginBlock: 0,
                        marginInlineStart: labelColonMarginInlineStart,
                        marginInlineEnd: labelColonMarginInlineEnd
                    },
                    [`&${formItemCls}-no-colon::after`]: {
                        content: '"\\a0"'
                    }
                }
            },
            // ==============================================================
            // =                            Input                           =
            // ==============================================================
            [`${formItemCls}-control`]: {
                ['--ant-display']: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                [`&:first-child:not([class^="'${rootPrefixCls}-col-'"]):not([class*="' ${rootPrefixCls}-col-'"])`]: {
                    width: '100%'
                },
                '&-input': {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: token.controlHeight,
                    '&-content': {
                        flex: 'auto',
                        maxWidth: '100%',
                        // Fix https://github.com/ant-design/ant-design/issues/54042
                        // Remove impact of whitespaces
                        [`&:has(> ${antCls}-switch:only-child, > ${antCls}-rate:only-child)`]: {
                            display: 'flex',
                            alignItems: 'center'
                        }
                    }
                }
            },
            // ==============================================================
            // =                           Explain                          =
            // ==============================================================
            [formItemCls]: {
                '&-additional': {
                    display: 'flex',
                    flexDirection: 'column'
                },
                '&-explain, &-extra': {
                    clear: 'both',
                    color: token.colorTextDescription,
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight
                },
                '&-explain-connected': {
                    width: '100%'
                },
                '&-extra': {
                    minHeight: token.controlHeightSM,
                    transition: `color ${token.motionDurationMid} ${token.motionEaseOut}` // sync input color transition
                },
                '&-explain': {
                    '&-error': {
                        color: token.colorError
                    },
                    '&-warning': {
                        color: token.colorWarning
                    }
                }
            },
            [`&-with-help ${formItemCls}-explain`]: {
                height: 'auto',
                opacity: 1
            },
            // ==============================================================
            // =                        Feedback Icon                       =
            // ==============================================================
            [`${formItemCls}-feedback-icon`]: {
                fontSize: token.fontSize,
                textAlign: 'center',
                visibility: 'visible',
                animationName: (0, $29a43b27eddd598a$export$3b71758b3ed5255f),
                animationDuration: token.motionDurationMid,
                animationTimingFunction: token.motionEaseOutBack,
                pointerEvents: 'none',
                '&-success': {
                    color: token.colorSuccess
                },
                '&-error': {
                    color: token.colorError
                },
                '&-warning': {
                    color: token.colorWarning
                },
                '&-validating': {
                    color: token.colorPrimary
                }
            }
        }
    };
};
const $d7b26b1c51d43fd8$var$makeVerticalLayoutLabel = (token)=>({
        padding: token.verticalLabelPadding,
        margin: token.verticalLabelMargin,
        whiteSpace: 'initial',
        textAlign: 'start',
        '> label': {
            margin: 0,
            '&::after': {
                // https://github.com/ant-design/ant-design/issues/43538
                visibility: 'hidden'
            }
        }
    });
const $d7b26b1c51d43fd8$var$genHorizontalStyle = (token)=>{
    const { antCls: antCls, formItemCls: formItemCls } = token;
    return {
        [`${formItemCls}-horizontal`]: {
            [`${formItemCls}-label`]: {
                flexGrow: 0
            },
            [`${formItemCls}-control`]: {
                flex: '1 1 0',
                // https://github.com/ant-design/ant-design/issues/32777
                // https://github.com/ant-design/ant-design/issues/33773
                minWidth: 0
            },
            // Do not change this to `ant-col-24`! `-24` match all the responsive rules
            // https://github.com/ant-design/ant-design/issues/32980
            // https://github.com/ant-design/ant-design/issues/34903
            // https://github.com/ant-design/ant-design/issues/44538
            [`${formItemCls}-label[class$='-24'], ${formItemCls}-label[class*='-24 ']`]: {
                [`& + ${formItemCls}-control`]: {
                    minWidth: 'unset'
                }
            },
            [`${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: $d7b26b1c51d43fd8$var$makeVerticalLayoutLabel(token)
        }
    };
};
const $d7b26b1c51d43fd8$var$genInlineStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, inlineItemMarginBottom: inlineItemMarginBottom } = token;
    return {
        [`${componentCls}-inline`]: {
            display: 'flex',
            flexWrap: 'wrap',
            [`${formItemCls}-inline`]: {
                flex: 'none',
                marginInlineEnd: token.margin,
                marginBottom: inlineItemMarginBottom,
                '&-row': {
                    flexWrap: 'nowrap'
                },
                [`> ${formItemCls}-label,
        > ${formItemCls}-control`]: {
                    display: 'inline-block',
                    verticalAlign: 'top'
                },
                [`> ${formItemCls}-label`]: {
                    flex: 'none'
                },
                [`${componentCls}-text`]: {
                    display: 'inline-block'
                },
                [`${formItemCls}-has-feedback`]: {
                    display: 'inline-block'
                }
            }
        }
    };
};
const $d7b26b1c51d43fd8$var$makeVerticalLayout = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, rootPrefixCls: rootPrefixCls } = token;
    return {
        [`${formItemCls} ${formItemCls}-label`]: $d7b26b1c51d43fd8$var$makeVerticalLayoutLabel(token),
        // ref: https://github.com/ant-design/ant-design/issues/45122
        [`${componentCls}:not(${componentCls}-inline)`]: {
            [formItemCls]: {
                flexWrap: 'wrap',
                [`${formItemCls}-label, ${formItemCls}-control`]: {
                    // When developer pass `xs: { span }`,
                    // It should follow the `xs` screen config
                    // ref: https://github.com/ant-design/ant-design/issues/44386
                    [`&:not([class*=" ${rootPrefixCls}-col-xs"])`]: {
                        flex: '0 0 100%',
                        maxWidth: '100%'
                    }
                }
            }
        }
    };
};
const $d7b26b1c51d43fd8$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, antCls: antCls } = token;
    return {
        [`${formItemCls}-vertical`]: {
            [`${formItemCls}-row`]: {
                flexDirection: 'column'
            },
            [`${formItemCls}-label > label`]: {
                height: 'auto'
            },
            [`${formItemCls}-control`]: {
                width: '100%'
            },
            [`${formItemCls}-label,
        ${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: $d7b26b1c51d43fd8$var$makeVerticalLayoutLabel(token)
        },
        [`@media (max-width: ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.screenXSMax)})`]: [
            $d7b26b1c51d43fd8$var$makeVerticalLayout(token),
            {
                [componentCls]: {
                    [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                        [`${antCls}-col-xs-24${formItemCls}-label`]: $d7b26b1c51d43fd8$var$makeVerticalLayoutLabel(token)
                    }
                }
            }
        ],
        [`@media (max-width: ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.screenSMMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-sm-24${formItemCls}-label`]: $d7b26b1c51d43fd8$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.screenMDMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-md-24${formItemCls}-label`]: $d7b26b1c51d43fd8$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.screenLGMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-lg-24${formItemCls}-label`]: $d7b26b1c51d43fd8$var$makeVerticalLayoutLabel(token)
                }
            }
        }
    };
};
const $d7b26b1c51d43fd8$export$9ca1be8807fe0675 = (token)=>({
        labelRequiredMarkColor: token.colorError,
        labelColor: token.colorTextHeading,
        labelFontSize: token.fontSize,
        labelHeight: token.controlHeight,
        labelColonMarginInlineStart: token.marginXXS / 2,
        labelColonMarginInlineEnd: token.marginXS,
        itemMarginBottom: token.marginLG,
        verticalLabelPadding: `0 0 ${token.paddingXS}px`,
        verticalLabelMargin: 0,
        inlineItemMarginBottom: 0
    });
const $d7b26b1c51d43fd8$export$362fb92a8f81bbf9 = (token, rootPrefixCls)=>{
    const formToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        formItemCls: `${token.componentCls}-item`,
        rootPrefixCls: rootPrefixCls
    });
    return formToken;
};
var $d7b26b1c51d43fd8$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Form', (token, { rootPrefixCls: rootPrefixCls })=>{
    const formToken = $d7b26b1c51d43fd8$export$362fb92a8f81bbf9(token, rootPrefixCls);
    return [
        $d7b26b1c51d43fd8$var$genFormStyle(formToken),
        $d7b26b1c51d43fd8$var$genFormItemStyle(formToken),
        (0, $ff31b917511a72fb$export$2e2bcd8739ae039)(formToken),
        $d7b26b1c51d43fd8$var$genHorizontalStyle(formToken),
        $d7b26b1c51d43fd8$var$genInlineStyle(formToken),
        $d7b26b1c51d43fd8$var$genVerticalStyle(formToken),
        (0, $5a999cf2ba92548d$export$2e2bcd8739ae039)(formToken),
        (0, $29a43b27eddd598a$export$3b71758b3ed5255f)
    ];
}, $d7b26b1c51d43fd8$export$9ca1be8807fe0675, {
    // Let From style before the Grid
    // ref https://github.com/ant-design/ant-design/issues/44386
    order: -1000
});


"use client";
const $a4eade0f345373da$var$EMPTY_LIST = [];
function $a4eade0f345373da$var$toErrorEntity(error, prefix, errorStatus, index = 0) {
    return {
        key: typeof error === 'string' ? error : `${prefix}-${index}`,
        error: error,
        errorStatus: errorStatus
    };
}
const $a4eade0f345373da$var$ErrorList = ({ help: help, helpStatus: helpStatus, errors: errors = $a4eade0f345373da$var$EMPTY_LIST, warnings: warnings = $a4eade0f345373da$var$EMPTY_LIST, className: rootClassName, fieldId: fieldId, onVisibleChanged: onVisibleChanged })=>{
    const { prefixCls: prefixCls } = $ltGt3.useContext((0, $2fc8703031980156$export$fb6582d3042cc879));
    const baseClassName = `${prefixCls}-item-explain`;
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $d7b26b1c51d43fd8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const collapseMotion = $ltGt3.useMemo(()=>(0, $32c4c593a0d4aef5$export$2e2bcd8739ae039)(prefixCls), [
        prefixCls
    ]);
    // We have to debounce here again since somewhere use ErrorList directly still need no shaking
    // ref: https://github.com/ant-design/ant-design/issues/36336
    const debounceErrors = (0, $23b575dfbfba8f66$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $23b575dfbfba8f66$export$2e2bcd8739ae039)(warnings);
    const fullKeyList = $ltGt3.useMemo(()=>{
        if ((0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(help)) return [
            $a4eade0f345373da$var$toErrorEntity(help, 'help', helpStatus)
        ];
        return [].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(debounceErrors.map((error, index)=>$a4eade0f345373da$var$toErrorEntity(error, 'error', 'error', index))), (0, $83d01b7684a01087$export$2e2bcd8739ae039)(debounceWarnings.map((warning, index)=>$a4eade0f345373da$var$toErrorEntity(warning, 'warning', 'warning', index))));
    }, [
        help,
        helpStatus,
        debounceErrors,
        debounceWarnings
    ]);
    const filledKeyFullKeyList = $ltGt3.useMemo(()=>{
        const keysCount = {};
        fullKeyList.forEach(({ key: key })=>{
            keysCount[key] = (keysCount[key] || 0) + 1;
        });
        return fullKeyList.map((entity, index)=>({
                ...entity,
                key: keysCount[entity.key] > 1 ? `${entity.key}-fallback-${index}` : entity.key
            }));
    }, [
        fullKeyList
    ]);
    const helpProps = {};
    if (fieldId) helpProps.id = `${fieldId}_help`;
    return /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), {
        motionDeadline: collapseMotion.motionDeadline,
        motionName: `${prefixCls}-show-help`,
        visible: !!filledKeyFullKeyList.length,
        onVisibleChanged: onVisibleChanged
    }, (holderProps)=>{
        const { className: holderClassName, style: holderStyle } = holderProps;
        return /*#__PURE__*/ $ltGt3.createElement("div", {
            ...helpProps,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(baseClassName, holderClassName, cssVarCls, rootCls, rootClassName, hashId),
            style: holderStyle
        }, /*#__PURE__*/ $ltGt3.createElement((0, $9073ece020846a7d$export$2e2bcd8739ae039), {
            keys: filledKeyFullKeyList,
            ...(0, $32c4c593a0d4aef5$export$2e2bcd8739ae039)(prefixCls),
            motionName: `${prefixCls}-show-help-item`,
            component: false
        }, (itemProps)=>{
            const { key: key, error: error, errorStatus: errorStatus, className: itemClassName, style: itemStyle } = itemProps;
            return /*#__PURE__*/ $ltGt3.createElement("div", {
                key: key,
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(itemClassName, {
                    [`${baseClassName}-${errorStatus}`]: errorStatus
                }),
                style: itemStyle
            }, error);
        }));
    });
};
var $a4eade0f345373da$export$2e2bcd8739ae039 = $a4eade0f345373da$var$ErrorList;



var $ltGt3 = parcelRequire("ltGt3");










var $ltGt3 = parcelRequire("ltGt3");


const $9c5e401636ebfaee$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $9c5e401636ebfaee$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $9c5e401636ebfaee$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $9c5e401636ebfaee$var$e(o.overflowY, n) || $9c5e401636ebfaee$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $9c5e401636ebfaee$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $9c5e401636ebfaee$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $9c5e401636ebfaee$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$9c5e401636ebfaee$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $9c5e401636ebfaee$var$t(W) && p(W);){
        if (W = $9c5e401636ebfaee$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $9c5e401636ebfaee$var$n(W) && !$9c5e401636ebfaee$var$n(document.documentElement) || null != W && $9c5e401636ebfaee$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: n, width: l, top: r, right: i, bottom: s, left: d } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && x >= r && I <= s && R >= d && C <= i) return L;
        const h = getComputedStyle(e), a = parseInt(h.borderLeftWidth, 10), g = parseInt(h.borderTopWidth, 10), p = parseInt(h.borderRightWidth, 10), W = parseInt(h.borderBottomWidth, 10);
        let T = 0, B = 0;
        const F = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - a - p : 0, V = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - g - W : 0, S = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : l / e.offsetWidth : 0, X = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : n / e.offsetHeight : 0;
        if (m === e) T = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $9c5e401636ebfaee$var$o(M, M + H, H, g, W, M + k, M + k + v, v) : k - H / 2, B = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $9c5e401636ebfaee$var$o(y, y + b, b, a, p, y + D, y + D + E, E), T = Math.max(0, T + M), B = Math.max(0, B + y);
        else {
            T = "start" === f ? k - r - g : "end" === f ? k - s + W + V : "nearest" === f ? $9c5e401636ebfaee$var$o(r, s, n, g, W + V, k, k + v, v) : k - (r + n / 2) + V / 2, B = "start" === u ? D - d - a : "center" === u ? D - (d + l / 2) + F / 2 : "end" === u ? D - i + p + F : $9c5e401636ebfaee$var$o(d, i, l, a, p + F, D, D + E, E);
            const { scrollLeft: t, scrollTop: h } = e;
            T = 0 === X ? 0 : Math.max(0, Math.min(h + T / X, e.scrollHeight - n / X + V)), B = 0 === S ? 0 : Math.max(0, Math.min(t + B / S, e.scrollWidth - l / S + F)), k += h - T, D += t - B;
        }
        L.push({
            el: e,
            top: T,
            left: B
        });
    }
    return L;
};


const $c670cb6ff550593e$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $c670cb6ff550593e$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $9c5e401636ebfaee$export$3b12cb22b12b954b)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $9c5e401636ebfaee$export$3b12cb22b12b954b)(e, $c670cb6ff550593e$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}


// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
const $0cd7baa5d7ff73a0$var$formItemNameBlackList = [
    'parentNode'
];
// default form item id prefix.
const $0cd7baa5d7ff73a0$var$defaultItemNamePrefixCls = 'form_item';
function $0cd7baa5d7ff73a0$export$45b10814cc054894(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function $0cd7baa5d7ff73a0$export$f4457e83c74ac000(namePath, formName) {
    if (!namePath.length) return undefined;
    const mergedId = namePath.join('_');
    if (formName) return `${formName}_${mergedId}`;
    const isIllegalName = $0cd7baa5d7ff73a0$var$formItemNameBlackList.includes(mergedId);
    return isIllegalName ? `${$0cd7baa5d7ff73a0$var$defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
function $0cd7baa5d7ff73a0$export$b70265791d2079d4(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
    let status = defaultValidateStatus;
    if (validateStatus !== undefined) status = validateStatus;
    else if (meta.validating) status = 'validating';
    else if (errors.length) status = 'error';
    else if (warnings.length) status = 'warning';
    else if (meta.touched || hasFeedback && meta.validated) // success feedback should display when pass hasFeedback prop and current value is valid value
    status = 'success';
    return status;
}


function $f920ebb7dca9d6d3$export$368b682c15953eea(name) {
    const namePath = (0, $0cd7baa5d7ff73a0$export$45b10814cc054894)(name);
    return namePath.join('_');
}
function $f920ebb7dca9d6d3$var$getFieldDOMNode(name, wrapForm) {
    const field = wrapForm.getFieldInstance(name);
    const fieldDom = (0, $8e3ff42e4a468fd4$export$9aa546fdc20ae5b3)(field);
    if (fieldDom) return fieldDom;
    const fieldId = (0, $0cd7baa5d7ff73a0$export$f4457e83c74ac000)((0, $0cd7baa5d7ff73a0$export$45b10814cc054894)(name), wrapForm.__INTERNAL__.name);
    if (fieldId) return document.getElementById(fieldId);
}
function $f920ebb7dca9d6d3$export$2e2bcd8739ae039(form) {
    const [rcForm] = (0, $7a9a0ec87f59ad35$export$2e2bcd8739ae039)();
    const itemsRef = $ltGt3.useRef({});
    const wrapForm = $ltGt3.useMemo(()=>form ?? {
            ...rcForm,
            __INTERNAL__: {
                itemRef: (name)=>(node)=>{
                        const namePathStr = $f920ebb7dca9d6d3$export$368b682c15953eea(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    }
            },
            scrollToField: (name, options = {})=>{
                const { focus: focus, ...restOpt } = options;
                const node = $f920ebb7dca9d6d3$var$getFieldDOMNode(name, wrapForm);
                if (node) {
                    (0, $c670cb6ff550593e$export$2e2bcd8739ae039)(node, {
                        scrollMode: 'if-needed',
                        block: 'nearest',
                        ...restOpt
                    });
                    // Focus if scroll success
                    if (focus) wrapForm.focusField(name);
                }
            },
            focusField: (name)=>{
                const itemRef = wrapForm.getFieldInstance(name);
                if (typeof itemRef?.focus === 'function') itemRef.focus();
                else $f920ebb7dca9d6d3$var$getFieldDOMNode(name, wrapForm)?.focus?.();
            },
            getFieldInstance: (name)=>{
                const namePathStr = $f920ebb7dca9d6d3$export$368b682c15953eea(name);
                return itemsRef.current[namePathStr];
            }
        }, [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}





"use client";
const $10b9397f1233f569$var$InternalForm = (props, ref)=>{
    const contextDisabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const { getPrefixCls: getPrefixCls, direction: direction, requiredMark: contextRequiredMark, colon: contextColon, scrollToFirstError: contextScrollToFirstError, className: contextClassName, style: contextStyle, styles: contextStyles, classNames: contextClassNames } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('form');
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, size: size, disabled: disabled = contextDisabled, form: form, colon: colon, labelAlign: labelAlign, labelWrap: labelWrap, labelCol: labelCol, wrapperCol: wrapperCol, layout: layout = 'horizontal', scrollToFirstError: scrollToFirstError, requiredMark: requiredMark, onFinishFailed: onFinishFailed, name: name, style: style, feedbackIcons: feedbackIcons, variant: variant, classNames: classNames, styles: styles, ...restFormProps } = props;
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)(size);
    const contextValidateMessages = $ltGt3.useContext((0, $f58ba1999f6a7d10$export$2e2bcd8739ae039));
    /* eslint-enable */ const mergedRequiredMark = $ltGt3.useMemo(()=>{
        if (requiredMark !== undefined) return requiredMark;
        if (contextRequiredMark !== undefined) return contextRequiredMark;
        return true;
    }, [
        requiredMark,
        contextRequiredMark
    ]);
    const mergedColon = colon ?? contextColon;
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $d7b26b1c51d43fd8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: disabled,
        layout: layout,
        colon: mergedColon,
        requiredMark: mergedRequiredMark
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const formClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${layout}`, {
        [`${prefixCls}-hide-required-mark`]: mergedRequiredMark === false,
        // todo: remove in next major version
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${mergedSize}`]: mergedSize
    }, cssVarCls, rootCls, hashId, contextClassName, className, rootClassName, mergedClassNames.root);
    const [wrapForm] = (0, $f920ebb7dca9d6d3$export$2e2bcd8739ae039)(form);
    const { __INTERNAL__: __INTERNAL__ } = wrapForm;
    __INTERNAL__.name = name;
    const formContextValue = $ltGt3.useMemo(()=>({
            name: name,
            labelAlign: labelAlign,
            labelCol: labelCol,
            labelWrap: labelWrap,
            wrapperCol: wrapperCol,
            layout: layout,
            colon: mergedColon,
            requiredMark: mergedRequiredMark,
            itemRef: __INTERNAL__.itemRef,
            form: wrapForm,
            feedbackIcons: feedbackIcons,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        name,
        labelAlign,
        labelCol,
        wrapperCol,
        layout,
        mergedColon,
        mergedRequiredMark,
        wrapForm,
        feedbackIcons,
        mergedClassNames,
        mergedStyles
    ]);
    const nativeElementRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, ()=>({
            ...wrapForm,
            nativeElement: nativeElementRef.current?.nativeElement
        }));
    const scrollToField = (options, fieldName)=>{
        if (options) {
            let defaultScrollToFirstError = {
                block: 'nearest'
            };
            if (typeof options === 'object') defaultScrollToFirstError = {
                ...defaultScrollToFirstError,
                ...options
            };
            wrapForm.scrollToField(fieldName, defaultScrollToFirstError);
        }
    };
    const onInternalFinishFailed = (errorInfo)=>{
        onFinishFailed?.(errorInfo);
        if (errorInfo.errorFields.length) {
            const fieldName = errorInfo.errorFields[0].name;
            if (scrollToFirstError !== undefined) {
                scrollToField(scrollToFirstError, fieldName);
                return;
            }
            if (contextScrollToFirstError !== undefined) scrollToField(contextScrollToFirstError, fieldName);
        }
    };
    return /*#__PURE__*/ $ltGt3.createElement((0, $2fc8703031980156$export$6f0555dad42725fb).Provider, {
        value: variant
    }, /*#__PURE__*/ $ltGt3.createElement((0, $6171cc8a6fbd07d0$export$6adb5f3b918b11bb), {
        disabled: disabled
    }, /*#__PURE__*/ $ltGt3.createElement((0, $9a9e608887097e77$export$2e2bcd8739ae039).Provider, {
        value: mergedSize
    }, /*#__PURE__*/ $ltGt3.createElement((0, $2fc8703031980156$export$8ce1ff4f94d08846), {
        // This is not list in API, we pass with spread
        validateMessages: contextValidateMessages
    }, /*#__PURE__*/ $ltGt3.createElement((0, $2fc8703031980156$export$c24727297075ec6a).Provider, {
        value: formContextValue
    }, /*#__PURE__*/ $ltGt3.createElement((0, $2fc8703031980156$export$80e4c53cb85dcab1), {
        status: true
    }, /*#__PURE__*/ $ltGt3.createElement((0, $757c8c4a45ed0b19$export$2e2bcd8739ae039), {
        id: name,
        ...restFormProps,
        name: name,
        onFinishFailed: onInternalFinishFailed,
        form: wrapForm,
        ref: nativeElementRef,
        style: {
            ...mergedStyles?.root,
            ...contextStyle,
            ...style
        },
        className: formClassName
    })))))));
};
const $10b9397f1233f569$var$Form = /*#__PURE__*/ $ltGt3.forwardRef($10b9397f1233f569$var$InternalForm);
var $10b9397f1233f569$export$2e2bcd8739ae039 = $10b9397f1233f569$var$Form;




var $ltGt3 = parcelRequire("ltGt3");










function $b7653788dec1657f$export$2e2bcd8739ae039(children) {
    if (typeof children === 'function') return children;
    const childList = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children);
    return childList.length <= 1 ? childList[0] : childList;
}



var $ltGt3 = parcelRequire("ltGt3");


const $d942408b2fbbf1a3$var$useFormItemStatus = ()=>{
    const { status: status, errors: errors = [], warnings: warnings = [] } = $ltGt3.useContext((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    return {
        status: status,
        errors: errors,
        warnings: warnings
    };
};
// Only used for compatible package. Not promise this will work on future version.
$d942408b2fbbf1a3$var$useFormItemStatus.Context = (0, $2fc8703031980156$export$bbb5553c6c7a14ed);
var $d942408b2fbbf1a3$export$2e2bcd8739ae039 = $d942408b2fbbf1a3$var$useFormItemStatus;



var $ltGt3 = parcelRequire("ltGt3");

function $acf7a15e340cbf46$export$2e2bcd8739ae039(defaultValue) {
    const [value, setValue] = $ltGt3.useState(defaultValue);
    const frameRef = $ltGt3.useRef(null);
    const batchRef = $ltGt3.useRef([]);
    const destroyRef = $ltGt3.useRef(false);
    $ltGt3.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
            (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(frameRef.current);
            frameRef.current = null;
        };
    }, []);
    function setFrameValue(updater) {
        if (destroyRef.current) return;
        if (frameRef.current === null) {
            batchRef.current = [];
            frameRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
                frameRef.current = null;
                setValue((prevValue)=>{
                    let current = prevValue;
                    batchRef.current.forEach((func)=>{
                        current = func(current);
                    });
                    return current;
                });
            });
        }
        batchRef.current.push(updater);
    }
    return [
        value,
        setFrameValue
    ];
}



var $ltGt3 = parcelRequire("ltGt3");


function $e0c776f305e87e66$export$2e2bcd8739ae039() {
    const { itemRef: itemRef } = $ltGt3.useContext((0, $2fc8703031980156$export$c24727297075ec6a));
    const cacheRef = $ltGt3.useRef({});
    function getRef(name, children) {
        // Outer caller already check the `supportRef`
        const childrenRef = children && typeof children === 'object' && (0, $22ff46e28c8066e1$export$7465e5c0bf44f19a)(children);
        const nameStr = name.join('_');
        if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
            cacheRef.current.name = nameStr;
            cacheRef.current.originRef = childrenRef;
            cacheRef.current.ref = (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(itemRef(name), childrenRef);
        }
        return cacheRef.current.ref;
    }
    return getRef;
}





var $ltGt3 = parcelRequire("ltGt3");








var $ltGt3 = parcelRequire("ltGt3");






/**
 * Fallback of IE.
 * Safe to remove.
 */ // Style as inline component


// ============================= Fallback =============================
const $fbc55f2b28503050$var$genFallbackStyle = (token)=>{
    const { formItemCls: formItemCls } = token;
    return {
        '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
            // Fallback for IE, safe to remove we not support it anymore
            [`${formItemCls}-control`]: {
                display: 'flex'
            }
        }
    };
};
var // ============================== Export ==============================
$fbc55f2b28503050$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$1537386bc155ea56)([
    'Form',
    'item-item'
], (token, { rootPrefixCls: rootPrefixCls })=>{
    const formToken = (0, $d7b26b1c51d43fd8$export$362fb92a8f81bbf9)(token, rootPrefixCls);
    return $fbc55f2b28503050$var$genFallbackStyle(formToken);
});


"use client";
const $1d8597d00c7a42cc$var$GRID_MAX = 24;
const $1d8597d00c7a42cc$var$FormItemInput = (props)=>{
    const { prefixCls: prefixCls, status: status, labelCol: labelCol, wrapperCol: wrapperCol, children: children, errors: errors, warnings: warnings, _internalItemRender: formItemRender, extra: extra, help: help, fieldId: fieldId, marginBottom: marginBottom, onErrorVisibleChanged: onErrorVisibleChanged, label: label } = props;
    const baseClassName = `${prefixCls}-item`;
    const formContext = $ltGt3.useContext((0, $2fc8703031980156$export$c24727297075ec6a));
    const { classNames: contextClassNames, styles: contextStyles } = formContext;
    const mergedWrapperCol = $ltGt3.useMemo(()=>{
        let mergedWrapper = {
            ...wrapperCol || formContext.wrapperCol || {}
        };
        if (label === null && !labelCol && !wrapperCol && formContext.labelCol) {
            const list = [
                undefined,
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'xxl'
            ];
            list.forEach((size)=>{
                const _size = size ? [
                    size
                ] : [];
                const formLabel = (0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(formContext.labelCol, _size);
                const formLabelObj = typeof formLabel === 'object' ? formLabel : {};
                const wrapper = (0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(mergedWrapper, _size);
                const wrapperObj = typeof wrapper === 'object' ? wrapper : {};
                if ('span' in formLabelObj && !('offset' in wrapperObj) && formLabelObj.span < $1d8597d00c7a42cc$var$GRID_MAX) mergedWrapper = (0, $33746bcbc33b48dc$export$2e2bcd8739ae039)(mergedWrapper, [].concat(_size, [
                    'offset'
                ]), formLabelObj.span);
            });
        }
        return mergedWrapper;
    }, [
        wrapperCol,
        formContext.wrapperCol,
        formContext.labelCol,
        label,
        labelCol
    ]);
    const className = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${baseClassName}-control`, mergedWrapperCol.className);
    // Pass to sub FormItem should not with col info
    const subFormContext = $ltGt3.useMemo(()=>{
        const { labelCol: _labelCol, wrapperCol: _wrapperCol, ...rest } = formContext;
        return rest;
    }, [
        formContext
    ]);
    const extraRef = $ltGt3.useRef(null);
    const [extraHeight, setExtraHeight] = $ltGt3.useState(0);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (extra && extraRef.current) setExtraHeight(extraRef.current.clientHeight);
        else setExtraHeight(0);
    }, [
        extra
    ]);
    const inputDom = /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${baseClassName}-control-input`
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${baseClassName}-control-input-content`, contextClassNames?.content),
        style: contextStyles?.content
    }, children));
    const formItemContext = $ltGt3.useMemo(()=>({
            prefixCls: prefixCls,
            status: status
        }), [
        prefixCls,
        status
    ]);
    const errorListDom = marginBottom !== null || errors.length || warnings.length ? /*#__PURE__*/ $ltGt3.createElement((0, $2fc8703031980156$export$fb6582d3042cc879).Provider, {
        value: formItemContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $a4eade0f345373da$export$2e2bcd8739ae039), {
        fieldId: fieldId,
        errors: errors,
        warnings: warnings,
        help: help,
        helpStatus: status,
        className: `${baseClassName}-explain-connected`,
        onVisibleChanged: onErrorVisibleChanged
    })) : null;
    const extraProps = {};
    if (fieldId) extraProps.id = `${fieldId}_extra`;
    // If extra = 0, && will goes wrong
    // 0&&error -> 0
    const extraDom = extra ? /*#__PURE__*/ $ltGt3.createElement("div", {
        ...extraProps,
        className: `${baseClassName}-extra`,
        ref: extraRef
    }, extra) : null;
    const additionalDom = errorListDom || extraDom ? /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${baseClassName}-additional`,
        style: marginBottom ? {
            minHeight: marginBottom + extraHeight
        } : {}
    }, errorListDom, extraDom) : null;
    const dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? formItemRender.render(props, {
        input: inputDom,
        errorList: errorListDom,
        extra: extraDom
    }) : /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, inputDom, additionalDom);
    return /*#__PURE__*/ $ltGt3.createElement((0, $2fc8703031980156$export$c24727297075ec6a).Provider, {
        value: subFormContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $4f41537f122e579d$export$2e2bcd8739ae039), {
        ...mergedWrapperCol,
        className: className
    }, dom), /*#__PURE__*/ $ltGt3.createElement((0, $fbc55f2b28503050$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
};
var $1d8597d00c7a42cc$export$2e2bcd8739ae039 = $1d8597d00c7a42cc$var$FormItemInput;



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $aff2e98d038295c5$var$QuestionCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "question-circle",
    "theme": "outlined"
};
var $aff2e98d038295c5$export$2e2bcd8739ae039 = $aff2e98d038295c5$var$QuestionCircleOutlined;



function $ed13c8bcd8d3389d$var$_extends() {
    $ed13c8bcd8d3389d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ed13c8bcd8d3389d$var$_extends.apply(this, arguments);
}
const $ed13c8bcd8d3389d$var$QuestionCircleOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $ed13c8bcd8d3389d$var$_extends({}, props, {
        ref: ref,
        icon: (0, $aff2e98d038295c5$export$2e2bcd8739ae039)
    }));
/**![question-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTYyMy42IDMxNi43QzU5My42IDI5MC40IDU1NCAyNzYgNTEyIDI3NnMtODEuNiAxNC41LTExMS42IDQwLjdDMzY5LjIgMzQ0IDM1MiAzODAuNyAzNTIgNDIwdjcuNmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjQyMGMwLTQ0LjEgNDMuMS04MCA5Ni04MHM5NiAzNS45IDk2IDgwYzAgMzEuMS0yMiA1OS42LTU2LjEgNzIuNy0yMS4yIDguMS0zOS4yIDIyLjMtNTIuMSA0MC45LTEzLjEgMTktMTkuOSA0MS44LTE5LjkgNjQuOVY2MjBjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOHYtMjIuN2E0OC4zIDQ4LjMgMCAwMTMwLjktNDQuOGM1OS0yMi43IDk3LjEtNzQuNyA5Ny4xLTEzMi41LjEtMzkuMy0xNy4xLTc2LTQ4LjMtMTAzLjN6TTQ3MiA3MzJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAweiIgLz48L3N2Zz4=) */ const $ed13c8bcd8d3389d$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($ed13c8bcd8d3389d$var$QuestionCircleOutlined);
var $ed13c8bcd8d3389d$export$2e2bcd8739ae039 = $ed13c8bcd8d3389d$var$RefIcon;




var $ltGt3 = parcelRequire("ltGt3");
function $ed1fe97635615a66$var$convertToTooltipProps(tooltip) {
    // isNil
    if (tooltip === undefined || tooltip === null) return null;
    if (typeof tooltip === 'object' && !/*#__PURE__*/ (0, $ltGt3.isValidElement)(tooltip)) return tooltip;
    return {
        title: tooltip
    };
}
var $ed1fe97635615a66$export$2e2bcd8739ae039 = $ed1fe97635615a66$var$convertToTooltipProps;







"use client";
const $41e91bf3e8c6c99e$var$FormItemLabel = ({ prefixCls: prefixCls, label: label, htmlFor: htmlFor, labelCol: labelCol, labelAlign: labelAlign, colon: colon, required: required, requiredMark: requiredMark, tooltip: tooltip, vertical: vertical })=>{
    const [formLocale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Form');
    const { labelAlign: contextLabelAlign, labelCol: contextLabelCol, labelWrap: labelWrap, colon: contextColon, classNames: contextClassNames, styles: contextStyles } = $ltGt3.useContext((0, $2fc8703031980156$export$c24727297075ec6a));
    if (!label) return null;
    const mergedLabelCol = labelCol || contextLabelCol || {};
    const mergedLabelAlign = labelAlign || contextLabelAlign;
    const labelClsBasic = `${prefixCls}-item-label`;
    const labelColClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(labelClsBasic, mergedLabelAlign === 'left' && `${labelClsBasic}-left`, mergedLabelCol.className, {
        [`${labelClsBasic}-wrap`]: !!labelWrap
    });
    let labelChildren = label;
    // Keep label is original where there should have no colon
    const computedColon = colon === true || contextColon !== false && colon !== false;
    const haveColon = computedColon && !vertical;
    // Remove duplicated user input colon
    if (haveColon && typeof label === 'string' && label.trim()) labelChildren = label.replace(/[:|：]\s*$/, '');
    // Tooltip
    const tooltipProps = (0, $ed1fe97635615a66$export$2e2bcd8739ae039)(tooltip);
    if (tooltipProps) {
        const { icon: icon = /*#__PURE__*/ $ltGt3.createElement((0, $ed13c8bcd8d3389d$export$2e2bcd8739ae039), null), ...restTooltipProps } = tooltipProps;
        const tooltipNode = /*#__PURE__*/ $ltGt3.createElement((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
            ...restTooltipProps
        }, /*#__PURE__*/ $ltGt3.cloneElement(icon, {
            className: `${prefixCls}-item-tooltip`,
            title: '',
            onClick: (e)=>{
                // Prevent label behavior in tooltip icon
                // https://github.com/ant-design/ant-design/issues/46154
                e.preventDefault();
            },
            tabIndex: null
        }));
        labelChildren = /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, labelChildren, tooltipNode);
    }
    // Required Mark
    const isOptionalMark = requiredMark === 'optional';
    const isRenderMark = typeof requiredMark === 'function';
    const hideRequiredMark = requiredMark === false;
    if (isRenderMark) labelChildren = requiredMark(labelChildren, {
        required: !!required
    });
    else if (isOptionalMark && !required) labelChildren = /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, labelChildren, /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-item-optional`,
        title: ""
    }, formLocale?.optional || (0, $29f4f00e8825a41b$export$2e2bcd8739ae039).Form?.optional));
    // https://github.com/ant-design/ant-design/pull/52950#discussion_r1980880316
    let markType;
    if (hideRequiredMark) markType = 'hidden';
    else if (isOptionalMark || isRenderMark) markType = 'optional';
    const labelClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(contextClassNames?.label, {
        [`${prefixCls}-item-required`]: required,
        [`${prefixCls}-item-required-mark-${markType}`]: markType,
        [`${prefixCls}-item-no-colon`]: !computedColon
    });
    return /*#__PURE__*/ $ltGt3.createElement((0, $4f41537f122e579d$export$2e2bcd8739ae039), {
        ...mergedLabelCol,
        className: labelColClassName
    }, /*#__PURE__*/ $ltGt3.createElement("label", {
        htmlFor: htmlFor,
        className: labelClassName,
        style: contextStyles?.label,
        title: typeof label === 'string' ? label : ''
    }, labelChildren));
};
var $41e91bf3e8c6c99e$export$2e2bcd8739ae039 = $41e91bf3e8c6c99e$var$FormItemLabel;





var $ltGt3 = parcelRequire("ltGt3");







"use client";
const $d6c14f77a430ee1a$var$iconMap = {
    success: (0, $0cb9ffcfb49f2ccf$export$2e2bcd8739ae039),
    warning: (0, $951db5e2b3978281$export$2e2bcd8739ae039),
    error: (0, $332936b0d9ac1f65$export$2e2bcd8739ae039),
    validating: (0, $8ede40f9e9e4f5c2$export$2e2bcd8739ae039)
};
function $d6c14f77a430ee1a$var$StatusProvider({ children: children, errors: errors, warnings: warnings, hasFeedback: hasFeedback, validateStatus: validateStatus, prefixCls: prefixCls, meta: meta, noStyle: noStyle, name: name }) {
    const itemPrefixCls = `${prefixCls}-item`;
    const { feedbackIcons: feedbackIcons } = $ltGt3.useContext((0, $2fc8703031980156$export$c24727297075ec6a));
    const mergedValidateStatus = (0, $0cd7baa5d7ff73a0$export$b70265791d2079d4)(errors, warnings, meta, null, !!hasFeedback, validateStatus);
    const { isFormItemInput: parentIsFormItemInput, status: parentStatus, hasFeedback: parentHasFeedback, feedbackIcon: parentFeedbackIcon, name: parentName } = $ltGt3.useContext((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    // ====================== Context =======================
    const formItemStatusContext = $ltGt3.useMemo(()=>{
        let feedbackIcon;
        if (hasFeedback) {
            const customIcons = hasFeedback !== true && hasFeedback.icons || feedbackIcons;
            const customIconNode = mergedValidateStatus && customIcons?.({
                status: mergedValidateStatus,
                errors: errors,
                warnings: warnings
            })?.[mergedValidateStatus];
            const IconNode = mergedValidateStatus ? $d6c14f77a430ee1a$var$iconMap[mergedValidateStatus] : null;
            feedbackIcon = customIconNode !== false && IconNode ? /*#__PURE__*/ $ltGt3.createElement("span", {
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${itemPrefixCls}-feedback-icon`, `${itemPrefixCls}-feedback-icon-${mergedValidateStatus}`)
            }, customIconNode || /*#__PURE__*/ $ltGt3.createElement(IconNode, null)) : null;
        }
        const context = {
            status: mergedValidateStatus || '',
            errors: errors,
            warnings: warnings,
            hasFeedback: !!hasFeedback,
            feedbackIcon: feedbackIcon,
            isFormItemInput: true,
            name: name
        };
        // No style will follow parent context
        if (noStyle) {
            context.status = (mergedValidateStatus ?? parentStatus) || '';
            context.isFormItemInput = parentIsFormItemInput;
            context.hasFeedback = !!(hasFeedback ?? parentHasFeedback);
            context.feedbackIcon = hasFeedback !== undefined ? context.feedbackIcon : parentFeedbackIcon;
            context.name = name ?? parentName;
        }
        return context;
    }, [
        mergedValidateStatus,
        hasFeedback,
        noStyle,
        parentIsFormItemInput,
        parentStatus
    ]);
    // ======================= Render =======================
    return /*#__PURE__*/ $ltGt3.createElement((0, $2fc8703031980156$export$bbb5553c6c7a14ed).Provider, {
        value: formItemStatusContext
    }, children);
}
var $d6c14f77a430ee1a$export$2e2bcd8739ae039 = $d6c14f77a430ee1a$var$StatusProvider;


"use client";
function $db15a10549bdbb27$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, className: className, rootClassName: rootClassName, style: style, help: help, errors: errors, warnings: warnings, validateStatus: validateStatus, meta: meta, hasFeedback: hasFeedback, hidden: hidden, children: children, fieldId: fieldId, required: required, isRequired: isRequired, onSubItemMetaChange: onSubItemMetaChange, layout: propsLayout, name: name, ...restProps } = props;
    const itemPrefixCls = `${prefixCls}-item`;
    const { requiredMark: requiredMark, layout: formLayout } = $ltGt3.useContext((0, $2fc8703031980156$export$c24727297075ec6a));
    const layout = propsLayout || formLayout;
    const vertical = layout === 'vertical';
    // ======================== Margin ========================
    const itemRef = $ltGt3.useRef(null);
    const debounceErrors = (0, $23b575dfbfba8f66$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $23b575dfbfba8f66$export$2e2bcd8739ae039)(warnings);
    const hasHelp = (0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(help);
    const hasError = !!(hasHelp || errors.length || warnings.length);
    const isOnScreen = !!itemRef.current && (0, $d3c89c1e130d7e35$export$2e2bcd8739ae039)(itemRef.current);
    const [marginBottom, setMarginBottom] = $ltGt3.useState(null);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (hasError && itemRef.current) {
            // The element must be part of the DOMTree to use getComputedStyle
            // https://stackoverflow.com/questions/35360711/getcomputedstyle-returns-a-cssstyledeclaration-but-all-properties-are-empty-on-a
            const itemStyle = getComputedStyle(itemRef.current);
            setMarginBottom(Number.parseInt(itemStyle.marginBottom, 10));
        }
    }, [
        hasError,
        isOnScreen
    ]);
    const onErrorVisibleChanged = (nextVisible)=>{
        if (!nextVisible) setMarginBottom(null);
    };
    // ======================== Status ========================
    const getValidateState = (isDebounce = false)=>{
        const _errors = isDebounce ? debounceErrors : meta.errors;
        const _warnings = isDebounce ? debounceWarnings : meta.warnings;
        return (0, $0cd7baa5d7ff73a0$export$b70265791d2079d4)(_errors, _warnings, meta, '', !!hasFeedback, validateStatus);
    };
    const mergedValidateStatus = getValidateState();
    // ======================== Render ========================
    const itemClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(itemPrefixCls, className, rootClassName, {
        [`${itemPrefixCls}-with-help`]: hasHelp || debounceErrors.length || debounceWarnings.length,
        // Status
        [`${itemPrefixCls}-has-feedback`]: mergedValidateStatus && hasFeedback,
        [`${itemPrefixCls}-has-success`]: mergedValidateStatus === 'success',
        [`${itemPrefixCls}-has-warning`]: mergedValidateStatus === 'warning',
        [`${itemPrefixCls}-has-error`]: mergedValidateStatus === 'error',
        [`${itemPrefixCls}-is-validating`]: mergedValidateStatus === 'validating',
        [`${itemPrefixCls}-hidden`]: hidden,
        // Layout
        [`${itemPrefixCls}-${layout}`]: layout
    });
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: itemClassName,
        style: style,
        ref: itemRef
    }, /*#__PURE__*/ $ltGt3.createElement((0, $bd486463f4fb682b$export$2e2bcd8739ae039), {
        className: `${itemPrefixCls}-row`,
        ...(0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(restProps, [
            '_internalItemRender',
            'colon',
            'dependencies',
            'extra',
            'fieldKey',
            'getValueFromEvent',
            'getValueProps',
            'htmlFor',
            'id',
            // It is deprecated because `htmlFor` is its replacement.
            'initialValue',
            'isListField',
            'label',
            'labelAlign',
            'labelCol',
            'labelWrap',
            'messageVariables',
            'name',
            'normalize',
            'noStyle',
            'preserve',
            'requiredMark',
            'rules',
            'shouldUpdate',
            'trigger',
            'tooltip',
            'validateFirst',
            'validateTrigger',
            'valuePropName',
            'wrapperCol',
            'validateDebounce'
        ])
    }, /*#__PURE__*/ $ltGt3.createElement((0, $41e91bf3e8c6c99e$export$2e2bcd8739ae039), {
        htmlFor: fieldId,
        ...props,
        requiredMark: requiredMark,
        required: required ?? isRequired,
        prefixCls: prefixCls,
        vertical: vertical
    }), /*#__PURE__*/ $ltGt3.createElement((0, $1d8597d00c7a42cc$export$2e2bcd8739ae039), {
        ...props,
        ...meta,
        errors: debounceErrors,
        warnings: debounceWarnings,
        prefixCls: prefixCls,
        status: mergedValidateStatus,
        help: help,
        marginBottom: marginBottom,
        onErrorVisibleChanged: onErrorVisibleChanged
    }, /*#__PURE__*/ $ltGt3.createElement((0, $2fc8703031980156$export$d718247e9f9b0b9e).Provider, {
        value: onSubItemMetaChange
    }, /*#__PURE__*/ $ltGt3.createElement((0, $d6c14f77a430ee1a$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        meta: meta,
        errors: meta.errors,
        warnings: meta.warnings,
        hasFeedback: hasFeedback,
        // Already calculated
        validateStatus: mergedValidateStatus,
        name: name
    }, children)))), !!marginBottom && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${itemPrefixCls}-margin-offset`,
        style: {
            marginBottom: -marginBottom
        }
    }));
}



"use client";
const $ac9020c01dcb899f$var$NAME_SPLIT = '__SPLIT__';
const $ac9020c01dcb899f$var$_ValidateStatuses = [
    'success',
    'warning',
    'error',
    'validating',
    ''
];
// https://github.com/ant-design/ant-design/issues/46417
// `getValueProps` may modify the value props name,
// we should check if the control is similar.
function $ac9020c01dcb899f$var$isSimilarControl(a, b) {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    return keysA.length === keysB.length && keysA.every((key)=>{
        const propValueA = a[key];
        const propValueB = b[key];
        return propValueA === propValueB || typeof propValueA === 'function' || typeof propValueB === 'function';
    });
}
const $ac9020c01dcb899f$var$MemoInput = /*#__PURE__*/ $ltGt3.memo(({ children: children })=>children, (prev, next)=>$ac9020c01dcb899f$var$isSimilarControl(prev.control, next.control) && prev.update === next.update && prev.childProps.length === next.childProps.length && prev.childProps.every((value, index)=>value === next.childProps[index]));
function $ac9020c01dcb899f$var$genEmptyMeta() {
    return {
        errors: [],
        warnings: [],
        touched: false,
        validating: false,
        name: [],
        validated: false
    };
}
function $ac9020c01dcb899f$var$InternalFormItem(props) {
    const { name: name, noStyle: noStyle, className: className, dependencies: dependencies, prefixCls: customizePrefixCls, shouldUpdate: shouldUpdate, rules: rules, children: children, required: required, label: label, messageVariables: messageVariables, trigger: trigger = 'onChange', validateTrigger: validateTrigger, hidden: hidden, help: help, layout: layout } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { name: formName } = $ltGt3.useContext((0, $2fc8703031980156$export$c24727297075ec6a));
    const mergedChildren = (0, $b7653788dec1657f$export$2e2bcd8739ae039)(children);
    const isRenderProps = typeof mergedChildren === 'function';
    const notifyParentMetaChange = $ltGt3.useContext((0, $2fc8703031980156$export$d718247e9f9b0b9e));
    const { validateTrigger: contextValidateTrigger } = $ltGt3.useContext((0, $1acae32ef7ef7c71$export$2e2bcd8739ae039));
    const mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : contextValidateTrigger;
    const hasName = !(name === undefined || name === null);
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $d7b26b1c51d43fd8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ========================= Warn =========================
    const warning = (0, $9530c27c700696d0$export$cf977aa92c751e61)('Form.Item');
    // ========================= MISC =========================
    // Get `noStyle` required info
    const listContext = $ltGt3.useContext((0, $676ce4da8497bef1$export$2e2bcd8739ae039));
    const fieldKeyPathRef = $ltGt3.useRef(null);
    // ======================== Errors ========================
    // >>>>> Collect sub field errors
    const [subFieldErrors, setSubFieldErrors] = (0, $acf7a15e340cbf46$export$2e2bcd8739ae039)({});
    // >>>>> Current field errors
    const [meta, setMeta] = (0, $451586bd8fd5d39a$export$2e2bcd8739ae039)(()=>$ac9020c01dcb899f$var$genEmptyMeta());
    const onMetaChange = (nextMeta)=>{
        // This keyInfo is not correct when field is removed
        // Since origin keyManager no longer keep the origin key anymore
        // Which means we need cache origin one and reuse when removed
        const keyInfo = listContext?.getKey(nextMeta.name);
        // Destroy will reset all the meta
        setMeta(nextMeta.destroy ? $ac9020c01dcb899f$var$genEmptyMeta() : nextMeta, true);
        // Bump to parent since noStyle
        if (noStyle && help !== false && notifyParentMetaChange) {
            let namePath = nextMeta.name;
            if (!nextMeta.destroy) {
                if (keyInfo !== undefined) {
                    const [fieldKey, restPath] = keyInfo;
                    namePath = [
                        fieldKey
                    ].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(restPath));
                    fieldKeyPathRef.current = namePath;
                }
            } else // Use origin cache data
            namePath = fieldKeyPathRef.current || namePath;
            notifyParentMetaChange(nextMeta, namePath);
        }
    };
    // >>>>> Collect noStyle Field error to the top FormItem
    const onSubItemMetaChange = (subMeta, uniqueKeys)=>{
        // Only `noStyle` sub item will trigger
        setSubFieldErrors((prevSubFieldErrors)=>{
            const clone = {
                ...prevSubFieldErrors
            };
            // name: ['user', 1] + key: [4] = ['user', 4]
            const mergedNamePath = [].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(subMeta.name.slice(0, -1)), (0, $83d01b7684a01087$export$2e2bcd8739ae039)(uniqueKeys));
            const mergedNameKey = mergedNamePath.join($ac9020c01dcb899f$var$NAME_SPLIT);
            if (subMeta.destroy) // Remove
            delete clone[mergedNameKey];
            else // Update
            clone[mergedNameKey] = subMeta;
            return clone;
        });
    };
    // >>>>> Get merged errors
    const [mergedErrors, mergedWarnings] = $ltGt3.useMemo(()=>{
        const errorList = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(meta.errors);
        const warningList = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(meta.warnings);
        Object.values(subFieldErrors).forEach((subFieldError)=>{
            errorList.push.apply(errorList, (0, $83d01b7684a01087$export$2e2bcd8739ae039)(subFieldError.errors || []));
            warningList.push.apply(warningList, (0, $83d01b7684a01087$export$2e2bcd8739ae039)(subFieldError.warnings || []));
        });
        return [
            errorList,
            warningList
        ];
    }, [
        subFieldErrors,
        meta.errors,
        meta.warnings
    ]);
    // ===================== Children Ref =====================
    const getItemRef = (0, $e0c776f305e87e66$export$2e2bcd8739ae039)();
    // ======================== Render ========================
    function renderLayout(baseChildren, fieldId, isRequired) {
        if (noStyle && !hidden) return /*#__PURE__*/ $ltGt3.createElement((0, $d6c14f77a430ee1a$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            hasFeedback: props.hasFeedback,
            validateStatus: props.validateStatus,
            meta: meta,
            errors: mergedErrors,
            warnings: mergedWarnings,
            noStyle: true,
            name: name
        }, baseChildren);
        return /*#__PURE__*/ $ltGt3.createElement((0, $db15a10549bdbb27$export$2e2bcd8739ae039), {
            key: "row",
            ...props,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, cssVarCls, rootCls, hashId),
            prefixCls: prefixCls,
            fieldId: fieldId,
            isRequired: isRequired,
            errors: mergedErrors,
            warnings: mergedWarnings,
            meta: meta,
            onSubItemMetaChange: onSubItemMetaChange,
            layout: layout,
            name: name
        }, baseChildren);
    }
    if (!hasName && !isRenderProps && !dependencies) return renderLayout(mergedChildren);
    let variables = {};
    if (typeof label === 'string') variables.label = label;
    else if (name) variables.label = String(name);
    if (messageVariables) variables = {
        ...variables,
        ...messageVariables
    };
    // >>>>> With Field
    return /*#__PURE__*/ $ltGt3.createElement((0, $62bb5a895295f340$export$2e2bcd8739ae039), {
        ...props,
        messageVariables: variables,
        trigger: trigger,
        validateTrigger: mergedValidateTrigger,
        onMetaChange: onMetaChange
    }, (control, renderMeta, context)=>{
        const mergedName = (0, $0cd7baa5d7ff73a0$export$45b10814cc054894)(name).length && renderMeta ? renderMeta.name : [];
        const fieldId = (0, $0cd7baa5d7ff73a0$export$f4457e83c74ac000)(mergedName, formName);
        const isRequired = required !== undefined ? required : !!rules?.some((rule)=>{
            if (rule && typeof rule === 'object' && rule.required && !rule.warningOnly) return true;
            if (typeof rule === 'function') {
                const ruleEntity = rule(context);
                return ruleEntity?.required && !ruleEntity?.warningOnly;
            }
            return false;
        });
        // ======================= Children =======================
        const mergedControl = {
            ...control
        };
        let childNode = null;
        if (Array.isArray(mergedChildren) && hasName) childNode = mergedChildren;
        else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) ;
        else if (dependencies && !isRenderProps && !hasName) ;
        else if (/*#__PURE__*/ $ltGt3.isValidElement(mergedChildren)) {
            const childProps = {
                ...mergedChildren.props,
                ...mergedControl
            };
            if (!childProps.id) childProps.id = fieldId;
            if (help || mergedErrors.length > 0 || mergedWarnings.length > 0 || props.extra) {
                const describedbyArr = [];
                if (help || mergedErrors.length > 0) describedbyArr.push(`${fieldId}_help`);
                if (props.extra) describedbyArr.push(`${fieldId}_extra`);
                childProps['aria-describedby'] = describedbyArr.join(' ');
            }
            if (mergedErrors.length > 0) childProps['aria-invalid'] = 'true';
            if (isRequired) childProps['aria-required'] = 'true';
            if ((0, $22ff46e28c8066e1$export$c1cec34af06bcf7)(mergedChildren)) childProps.ref = getItemRef(mergedName, mergedChildren);
            // We should keep user origin event handler
            const triggers = new Set([].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)((0, $0cd7baa5d7ff73a0$export$45b10814cc054894)(trigger)), (0, $83d01b7684a01087$export$2e2bcd8739ae039)((0, $0cd7baa5d7ff73a0$export$45b10814cc054894)(mergedValidateTrigger))));
            triggers.forEach((eventName)=>{
                childProps[eventName] = (...args)=>{
                    mergedControl[eventName]?.(...args);
                    mergedChildren.props[eventName]?.(...args);
                };
            });
            // List of props that need to be watched for changes -> if changes are detected in MemoInput -> rerender
            const watchingChildProps = [
                childProps['aria-required'],
                childProps['aria-invalid'],
                childProps['aria-describedby']
            ];
            childNode = /*#__PURE__*/ $ltGt3.createElement($ac9020c01dcb899f$var$MemoInput, {
                control: mergedControl,
                update: mergedChildren,
                childProps: watchingChildProps
            }, (0, $66d38239e1a27993$export$e530037191fcd5d7)(mergedChildren, childProps));
        } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) childNode = mergedChildren(context);
        else childNode = mergedChildren;
        return renderLayout(childNode, fieldId, isRequired);
    });
}
const $ac9020c01dcb899f$var$FormItem = $ac9020c01dcb899f$var$InternalFormItem;
$ac9020c01dcb899f$var$FormItem.useStatus = (0, $d942408b2fbbf1a3$export$2e2bcd8739ae039);
var $ac9020c01dcb899f$export$2e2bcd8739ae039 = $ac9020c01dcb899f$var$FormItem;



var $ltGt3 = parcelRequire("ltGt3");




"use client";
const $6e4f2720ca7dd21f$var$FormList = ({ prefixCls: customizePrefixCls, children: children, ...props })=>{
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    const contextValue = $ltGt3.useMemo(()=>({
            prefixCls: prefixCls,
            status: 'error'
        }), [
        prefixCls
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $027e12733387be9a$export$2e2bcd8739ae039), {
        ...props
    }, (fields, operation, meta)=>/*#__PURE__*/ $ltGt3.createElement((0, $2fc8703031980156$export$fb6582d3042cc879).Provider, {
            value: contextValue
        }, children(fields.map((field)=>({
                ...field,
                fieldKey: field.key
            })), operation, {
            errors: meta.errors,
            warnings: meta.warnings
        })));
};
var $6e4f2720ca7dd21f$export$2e2bcd8739ae039 = $6e4f2720ca7dd21f$var$FormList;



var $ltGt3 = parcelRequire("ltGt3");

function $408c83825f51e23f$export$2e2bcd8739ae039() {
    const { form: form } = $ltGt3.useContext((0, $2fc8703031980156$export$c24727297075ec6a));
    return form;
}


"use client";
const $b56d75f9dce54730$var$Form = (0, $10b9397f1233f569$export$2e2bcd8739ae039);
$b56d75f9dce54730$var$Form.Item = (0, $ac9020c01dcb899f$export$2e2bcd8739ae039);
$b56d75f9dce54730$var$Form.List = (0, $6e4f2720ca7dd21f$export$2e2bcd8739ae039);
$b56d75f9dce54730$var$Form.ErrorList = (0, $a4eade0f345373da$export$2e2bcd8739ae039);
$b56d75f9dce54730$var$Form.useForm = (0, $f920ebb7dca9d6d3$export$2e2bcd8739ae039);
$b56d75f9dce54730$var$Form.useFormInstance = (0, $408c83825f51e23f$export$2e2bcd8739ae039);
$b56d75f9dce54730$var$Form.useWatch = (0, $6714b6aec552dc79$export$2e2bcd8739ae039);
$b56d75f9dce54730$var$Form.Provider = (0, $2fc8703031980156$export$8ce1ff4f94d08846);
var $b56d75f9dce54730$export$2e2bcd8739ae039 = $b56d75f9dce54730$var$Form;


var $ltGt3 = parcelRequire("ltGt3");






"use client";
/** @deprecated Please use `Space.Compact` */ const $80f1b5d9824f10f5$var$Group = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className } = props;
    const prefixCls = getPrefixCls('input-group', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input');
    const [hashId, cssVarCls] = (0, $ec12a8e9ea12e1d5$export$2e2bcd8739ae039)(inputPrefixCls);
    const cls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, cssVarCls, {
        [`${prefixCls}-lg`]: props.size === 'large',
        [`${prefixCls}-sm`]: props.size === 'small',
        [`${prefixCls}-compact`]: props.compact,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, className);
    const formItemContext = (0, $ltGt3.useContext)((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    const groupFormItemContext = (0, $ltGt3.useMemo)(()=>({
            ...formItemContext,
            isFormItemInput: false
        }), [
        formItemContext
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $2fc8703031980156$export$bbb5553c6c7a14ed).Provider, {
        value: groupFormItemContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $d029ee757225a242$export$2e2bcd8739ae039).Compact, {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, props.children));
};
var $80f1b5d9824f10f5$export$2e2bcd8739ae039 = $80f1b5d9824f10f5$var$Group;



var $ltGt3 = parcelRequire("ltGt3");

















var $ltGt3 = parcelRequire("ltGt3");
function $a54a0b5c176d40a3$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, $ltGt3.useRef)([]);
    const removePasswordTimeout = ()=>{
        removePasswordTimeoutRef.current.push(setTimeout(()=>{
            if (inputRef.current?.input && inputRef.current?.input.getAttribute('type') === 'password' && inputRef.current?.input.hasAttribute('value')) inputRef.current?.input.removeAttribute('value');
        }));
    };
    (0, $ltGt3.useEffect)(()=>{
        if (triggerOnMount) removePasswordTimeout();
        return ()=>removePasswordTimeoutRef.current.forEach((timer)=>{
                if (timer) clearTimeout(timer);
            });
    }, []);
    return removePasswordTimeout;
}



function $a23bab29f3b40933$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}


"use client";
const $3ef8aed3a0e2360a$var$Input = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered = true, status: customStatus, size: customSize, disabled: customDisabled, onBlur: onBlur, onFocus: onFocus, suffix: suffix, allowClear: allowClear, addonAfter: addonAfter, addonBefore: addonBefore, className: className, style: style, styles: styles, rootClassName: rootClassName, onChange: onChange, classNames: classNames, variant: customVariant, ...rest } = props;
    var prop, newProp;
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('input');
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    const inputRef = (0, $ltGt3.useRef)(null);
    // Style
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $ec12a8e9ea12e1d5$export$de732caeaad5f68e)(prefixCls, rootClassName);
    (0, $ec12a8e9ea12e1d5$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ===================== Compact Item =====================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $8eabd28975be2fa5$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)((ctx)=>customSize ?? compactSize ?? ctx);
    // ===================== Disabled =====================
    const disabled = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: mergedDisabled
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = (0, $ltGt3.useContext)((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $7b7bdeafff468875$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    const inputHasPrefixSuffix = (0, $a23bab29f3b40933$export$a19010aeeaa0c7a)(props) || !!hasFeedback;
    const prevHasPrefixSuffix = (0, $ltGt3.useRef)(inputHasPrefixSuffix);
    /* eslint-enable */ // ===================== Remove Password value =====================
    const removePasswordTimeout = (0, $a54a0b5c176d40a3$export$2e2bcd8739ae039)(inputRef, true);
    const handleBlur = (e)=>{
        removePasswordTimeout();
        onBlur?.(e);
    };
    const handleFocus = (e)=>{
        removePasswordTimeout();
        onFocus?.(e);
    };
    const handleChange = (e)=>{
        removePasswordTimeout();
        onChange?.(e);
    };
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    const mergedAllowClear = (0, $b2f9ce3768b9adcc$export$2e2bcd8739ae039)(allowClear ?? contextAllowClear);
    const [variant, enableVariantCls] = (0, $714175bf01098e4f$export$2e2bcd8739ae039)('input', customVariant, bordered);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $15112d9813cc317d$export$2e2bcd8739ae039), {
        ref: (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: contextAutoComplete,
        ...rest,
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        styles: mergedStyles,
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, contextClassName, mergedClassNames.root),
        onChange: handleChange,
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $31ba6c57c6d43aeb$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $31ba6c57c6d43aeb$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonAfter),
        classNames: {
            ...mergedClassNames,
            input: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large',
                [`${prefixCls}-rtl`]: direction === 'rtl'
            }, mergedClassNames.input, hashId),
            variant: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $7b7bdeafff468875$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl'
            }, hashId),
            wrapper: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                [`${prefixCls}-group-rtl`]: direction === 'rtl'
            }, hashId),
            groupWrapper: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, $7b7bdeafff468875$export$b08e7b47149942a2)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        }
    });
});
var $3ef8aed3a0e2360a$export$2e2bcd8739ae039 = $3ef8aed3a0e2360a$var$Input;




var $ltGt3 = parcelRequire("ltGt3");











// =============================== OTP ================================
const $24efc7af4bf4da2b$var$genOTPStyle = (token)=>{
    const { componentCls: componentCls, paddingXS: paddingXS } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            columnGap: paddingXS,
            [`${componentCls}-input-wrapper`]: {
                position: 'relative',
                [`${componentCls}-mask-icon`]: {
                    position: 'absolute',
                    zIndex: '1',
                    top: '50%',
                    right: '50%',
                    transform: 'translate(50%, -50%)',
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask-input`]: {
                    color: 'transparent',
                    caretColor: token.colorText
                },
                [`${componentCls}-mask-input[type=number]::-webkit-inner-spin-button`]: {
                    '-webkit-appearance': 'none',
                    margin: 0
                },
                [`${componentCls}-mask-input[type=number]`]: {
                    '-moz-appearance': 'textfield'
                }
            },
            '&-rtl': {
                direction: 'rtl'
            },
            [`${componentCls}-input`]: {
                textAlign: 'center',
                paddingInline: token.paddingXXS
            },
            // ================= Size =================
            [`&${componentCls}-sm ${componentCls}-input`]: {
                paddingInline: token.calc(token.paddingXXS).div(2).equal()
            },
            [`&${componentCls}-lg ${componentCls}-input`]: {
                paddingInline: token.paddingXS
            }
        }
    };
};
var // ============================== Export ==============================
$24efc7af4bf4da2b$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)([
    'Input',
    'OTP'
], (token)=>{
    const inputToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, (0, $84cc1914d3f028b8$export$a157d95850191a12)(token));
    return $24efc7af4bf4da2b$var$genOTPStyle(inputToken);
}, (0, $84cc1914d3f028b8$export$bd8b682992bc9781));



var $ltGt3 = parcelRequire("ltGt3");




"use client";
const $8df6300c3e7ab659$var$OTPInput = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { className: className, value: value, onChange: onChange, onActiveChange: onActiveChange, index: index, mask: mask, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('otp');
    const maskValue = typeof mask === 'string' ? mask : value;
    // ========================== Ref ===========================
    const inputRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, ()=>inputRef.current);
    // ========================= Input ==========================
    const onInternalChange = (e)=>{
        onChange(index, e.target.value);
    };
    // ========================= Focus ==========================
    const syncSelection = ()=>{
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
            const inputEle = inputRef.current?.input;
            if (document.activeElement === inputEle && inputEle) inputEle.select();
        });
    };
    // ======================== Keyboard ========================
    const onInternalKeyDown = (event)=>{
        const { key: key, ctrlKey: ctrlKey, metaKey: metaKey } = event;
        if (key === 'ArrowLeft') onActiveChange(index - 1);
        else if (key === 'ArrowRight') onActiveChange(index + 1);
        else if (key === 'z' && (ctrlKey || metaKey)) event.preventDefault();
        else if (key === 'Backspace' && !value) onActiveChange(index - 1);
        syncSelection();
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-input-wrapper`,
        role: "presentation"
    }, mask && value !== '' && value !== undefined && /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-mask-icon`,
        "aria-hidden": "true"
    }, maskValue), /*#__PURE__*/ $ltGt3.createElement((0, $3ef8aed3a0e2360a$export$2e2bcd8739ae039), {
        "aria-label": `OTP Input ${index + 1}`,
        type: mask === true ? 'password' : 'text',
        ...restProps,
        ref: inputRef,
        value: value,
        onInput: onInternalChange,
        onFocus: syncSelection,
        onKeyDown: onInternalKeyDown,
        onMouseDown: syncSelection,
        onMouseUp: syncSelection,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, {
            [`${prefixCls}-mask-input`]: mask
        })
    }));
});
var $8df6300c3e7ab659$export$2e2bcd8739ae039 = $8df6300c3e7ab659$var$OTPInput;


"use client";
function $2836ed1c9186c286$var$strToArr(str) {
    return (str || '').split('');
}
const $2836ed1c9186c286$var$Separator = (props)=>{
    const { index: index, prefixCls: prefixCls, separator: separator, className: semanticClassName, style: semanticStyle } = props;
    const separatorNode = typeof separator === 'function' ? separator(index) : separator;
    if (!separatorNode) return null;
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-separator`, semanticClassName),
        style: semanticStyle
    }, separatorNode);
};
const $2836ed1c9186c286$var$OTP = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, length: length = 6, size: customSize, defaultValue: defaultValue, value: value, onChange: onChange, formatter: formatter, separator: separator, variant: variant, disabled: disabled, status: customStatus, autoFocus: autoFocus, mask: mask, type: type, onInput: onInput, inputMode: inputMode, classNames: classNames, styles: styles, className: className, style: style, ...restProps } = props;
    const { classNames: contextClassNames, styles: contextStyles, getPrefixCls: getPrefixCls, direction: direction, style: contextStyle, className: contextClassName } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('otp');
    const prefixCls = getPrefixCls('otp', customizePrefixCls);
    const mergedProps = {
        ...props,
        length: length
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const domAttrs = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(restProps, {
        aria: true,
        data: true,
        attr: true
    });
    // ========================= Root =========================
    // Style
    const [hashId, cssVarCls] = (0, $24efc7af4bf4da2b$export$2e2bcd8739ae039)(prefixCls);
    // ========================= Size =========================
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    // ======================== Status ========================
    const formContext = $ltGt3.useContext((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $7b7bdeafff468875$export$314e193082d7ba49)(formContext.status, customStatus);
    const proxyFormContext = $ltGt3.useMemo(()=>({
            ...formContext,
            status: mergedStatus,
            hasFeedback: false,
            feedbackIcon: null
        }), [
        formContext,
        mergedStatus
    ]);
    // ========================= Refs =========================
    const containerRef = $ltGt3.useRef(null);
    const refs = $ltGt3.useRef({});
    $ltGt3.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                refs.current[0]?.focus();
            },
            blur: ()=>{
                for(let i = 0; i < length; i += 1)refs.current[i]?.blur();
            },
            nativeElement: containerRef.current
        }));
    // ======================= Formatter ======================
    const internalFormatter = (txt)=>formatter ? formatter(txt) : txt;
    // ======================== Values ========================
    const [valueCells, setValueCells] = $ltGt3.useState(()=>$2836ed1c9186c286$var$strToArr(internalFormatter(defaultValue || '')));
    $ltGt3.useEffect(()=>{
        if (value !== undefined) setValueCells($2836ed1c9186c286$var$strToArr(value));
    }, [
        value
    ]);
    const triggerValueCellsChange = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((nextValueCells)=>{
        setValueCells(nextValueCells);
        if (onInput) onInput(nextValueCells);
        // Trigger if all cells are filled
        if (onChange && nextValueCells.length === length && nextValueCells.every((c)=>c) && nextValueCells.some((c, index)=>valueCells[index] !== c)) onChange(nextValueCells.join(''));
    });
    const patchValue = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((index, txt)=>{
        let nextCells = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(valueCells);
        // Fill cells till index
        for(let i = 0; i < index; i += 1)if (!nextCells[i]) nextCells[i] = '';
        if (txt.length <= 1) nextCells[index] = txt;
        else nextCells = nextCells.slice(0, index).concat($2836ed1c9186c286$var$strToArr(txt));
        nextCells = nextCells.slice(0, length);
        // Clean the last empty cell
        for(let i = nextCells.length - 1; i >= 0; i -= 1){
            if (nextCells[i]) break;
            nextCells.pop();
        }
        // Format if needed
        const formattedValue = internalFormatter(nextCells.map((c)=>c || ' ').join(''));
        nextCells = $2836ed1c9186c286$var$strToArr(formattedValue).map((c, i)=>{
            if (c === ' ' && !nextCells[i]) return nextCells[i];
            return c;
        });
        return nextCells;
    });
    // ======================== Change ========================
    const onInputChange = (index, txt)=>{
        const nextCells = patchValue(index, txt);
        const nextIndex = Math.min(index + txt.length, length - 1);
        if (nextIndex !== index && nextCells[index] !== undefined) refs.current[nextIndex]?.focus();
        triggerValueCellsChange(nextCells);
    };
    const onInputActiveChange = (nextIndex)=>{
        refs.current[nextIndex]?.focus();
    };
    // ======================== Render ========================
    const inputSharedProps = {
        variant: variant,
        disabled: disabled,
        status: mergedStatus,
        mask: mask,
        type: type,
        inputMode: inputMode
    };
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ...domAttrs,
        ref: containerRef,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === 'small',
            [`${prefixCls}-lg`]: mergedSize === 'large',
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, cssVarCls, hashId, contextClassName, mergedClassNames.root),
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        role: "group"
    }, /*#__PURE__*/ $ltGt3.createElement((0, $2fc8703031980156$export$bbb5553c6c7a14ed).Provider, {
        value: proxyFormContext
    }, Array.from({
        length: length
    }).map((_, index)=>{
        const key = `otp-${index}`;
        const singleValue = valueCells[index] || '';
        return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, {
            key: key
        }, /*#__PURE__*/ $ltGt3.createElement((0, $8df6300c3e7ab659$export$2e2bcd8739ae039), {
            ref: (inputEle)=>{
                refs.current[index] = inputEle;
            },
            index: index,
            size: mergedSize,
            htmlSize: 1,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassNames.input, `${prefixCls}-input`),
            style: mergedStyles.input,
            onChange: onInputChange,
            value: singleValue,
            onActiveChange: onInputActiveChange,
            autoFocus: index === 0 && autoFocus,
            ...inputSharedProps
        }), index < length - 1 && /*#__PURE__*/ $ltGt3.createElement($2836ed1c9186c286$var$Separator, {
            separator: separator,
            index: index,
            prefixCls: prefixCls,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassNames.separator),
            style: mergedStyles.separator
        }));
    })));
});
var $2836ed1c9186c286$export$2e2bcd8739ae039 = $2836ed1c9186c286$var$OTP;



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $8da5c664ebae8d1b$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
var $8da5c664ebae8d1b$export$2e2bcd8739ae039 = $8da5c664ebae8d1b$var$EyeInvisibleOutlined;



function $52c719c573e469b6$var$_extends() {
    $52c719c573e469b6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $52c719c573e469b6$var$_extends.apply(this, arguments);
}
const $52c719c573e469b6$var$EyeInvisibleOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $52c719c573e469b6$var$_extends({}, props, {
        ref: ref,
        icon: (0, $8da5c664ebae8d1b$export$2e2bcd8739ae039)
    }));
/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */ const $52c719c573e469b6$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($52c719c573e469b6$var$EyeInvisibleOutlined);
var $52c719c573e469b6$export$2e2bcd8739ae039 = $52c719c573e469b6$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $ede23975c723e724$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $ede23975c723e724$export$2e2bcd8739ae039 = $ede23975c723e724$var$EyeOutlined;



function $a9c157c452686d79$var$_extends() {
    $a9c157c452686d79$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9c157c452686d79$var$_extends.apply(this, arguments);
}
const $a9c157c452686d79$var$EyeOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $a9c157c452686d79$var$_extends({}, props, {
        ref: ref,
        icon: (0, $ede23975c723e724$export$2e2bcd8739ae039)
    }));
/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */ const $a9c157c452686d79$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($a9c157c452686d79$var$EyeOutlined);
var $a9c157c452686d79$export$2e2bcd8739ae039 = $a9c157c452686d79$var$RefIcon;









"use client";
const $d3ac237522f5588d$var$defaultIconRender = (visible)=>visible ? /*#__PURE__*/ $ltGt3.createElement((0, $a9c157c452686d79$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $52c719c573e469b6$export$2e2bcd8739ae039), null);
const $d3ac237522f5588d$var$actionMap = {
    click: 'onClick',
    hover: 'onMouseOver'
};
const $d3ac237522f5588d$var$Password = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { disabled: customDisabled, action: action = 'click', visibilityToggle: visibilityToggle = true, iconRender: iconRender = $d3ac237522f5588d$var$defaultIconRender, suffix: suffix } = props;
    // ===================== Disabled =====================
    const disabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const visibilityControlled = typeof visibilityToggle === 'object' && visibilityToggle.visible !== undefined;
    const [visible, setVisible] = (0, $ltGt3.useState)(()=>visibilityControlled ? visibilityToggle.visible : false);
    const inputRef = (0, $ltGt3.useRef)(null);
    $ltGt3.useEffect(()=>{
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    const removePasswordTimeout = (0, $a54a0b5c176d40a3$export$2e2bcd8739ae039)(inputRef);
    const onVisibleChange = ()=>{
        if (mergedDisabled) return;
        if (visible) removePasswordTimeout();
        const nextVisible = !visible;
        setVisible(nextVisible);
        if (typeof visibilityToggle === 'object') visibilityToggle.onVisibleChange?.(nextVisible);
    };
    const getIcon = (prefixCls)=>{
        const iconTrigger = $d3ac237522f5588d$var$actionMap[action] || '';
        const icon = iconRender(visible);
        const iconProps = {
            [iconTrigger]: onVisibleChange,
            className: `${prefixCls}-icon`,
            key: 'passwordIcon',
            onMouseDown: (e)=>{
                // Prevent focused state lost
                // https://github.com/ant-design/ant-design/issues/15173
                e.preventDefault();
            },
            onMouseUp: (e)=>{
                // Prevent caret position change
                // https://github.com/ant-design/ant-design/issues/23524
                e.preventDefault();
            }
        };
        return /*#__PURE__*/ $ltGt3.cloneElement(/*#__PURE__*/ $ltGt3.isValidElement(icon) ? icon : /*#__PURE__*/ $ltGt3.createElement("span", null, icon), iconProps);
    };
    const { className: className, prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, size: size, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const prefixCls = getPrefixCls('input-password', customizePrefixCls);
    const suffixIcon = visibilityToggle && getIcon(prefixCls);
    const inputClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-${size}`]: !!size
    });
    const omittedProps = {
        ...(0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(restProps, [
            'suffix',
            'iconRender',
            'visibilityToggle'
        ]),
        type: visible ? 'text' : 'password',
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, suffixIcon, suffix)
    };
    if (size) omittedProps.size = size;
    return /*#__PURE__*/ $ltGt3.createElement((0, $3ef8aed3a0e2360a$export$2e2bcd8739ae039), {
        ref: (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(ref, inputRef),
        ...omittedProps
    });
});
var $d3ac237522f5588d$export$2e2bcd8739ae039 = $d3ac237522f5588d$var$Password;



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $f194bf0d5b744bcd$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
var $f194bf0d5b744bcd$export$2e2bcd8739ae039 = $f194bf0d5b744bcd$var$SearchOutlined;



function $84123a67634fb0f3$var$_extends() {
    $84123a67634fb0f3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $84123a67634fb0f3$var$_extends.apply(this, arguments);
}
const $84123a67634fb0f3$var$SearchOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $84123a67634fb0f3$var$_extends({}, props, {
        ref: ref,
        icon: (0, $f194bf0d5b744bcd$export$2e2bcd8739ae039)
    }));
/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */ const $84123a67634fb0f3$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($84123a67634fb0f3$var$SearchOutlined);
var $84123a67634fb0f3$export$2e2bcd8739ae039 = $84123a67634fb0f3$var$RefIcon;














const $b68b1f1e5706c1e0$var$genSearchStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const btnCls = `${componentCls}-btn`;
    return {
        [componentCls]: {
            width: '100%',
            // =========================== Button ===========================
            [btnCls]: {
                '&-filled': {
                    background: token.colorFillTertiary,
                    '&:not(:disabled)': {
                        '&:hover': {
                            background: token.colorFillSecondary
                        },
                        '&:active': {
                            background: token.colorFill
                        }
                    }
                }
            }
        }
    };
};
var $b68b1f1e5706c1e0$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)([
    'Input',
    'Search'
], (token)=>{
    return [
        $b68b1f1e5706c1e0$var$genSearchStyle(token)
    ];
});


"use client";
const $0d9bda8d03b7de4e$var$Search = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, className: className, size: customizeSize, style: style, enterButton: enterButton = false, addonAfter: addonAfter, loading: loading, disabled: disabled, onSearch: customOnSearch, onChange: customOnChange, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, variant: variant, onPressEnter: customOnPressEnter, classNames: classNames, styles: styles, hidden: hidden, ...restProps } = props;
    const { direction: direction, getPrefixCls: getPrefixCls, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('inputSearch');
    const mergedProps = {
        ...props,
        enterButton: enterButton
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        button: {
            _default: 'root'
        }
    });
    const composedRef = $ltGt3.useRef(false);
    const prefixCls = getPrefixCls('input-search', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const [hashId, cssVarCls] = (0, $b68b1f1e5706c1e0$export$2e2bcd8739ae039)(prefixCls);
    const { compactSize: compactSize } = (0, $8eabd28975be2fa5$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const size = (0, $7bb31c172903861d$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const inputRef = $ltGt3.useRef(null);
    const onChange = (e)=>{
        if (e?.target && e.type === 'click' && customOnSearch) customOnSearch(e.target.value, e, {
            source: 'clear'
        });
        customOnChange?.(e);
    };
    const onMouseDown = (e)=>{
        if (document.activeElement === inputRef.current?.input) e.preventDefault();
    };
    const onSearch = (e)=>{
        if (customOnSearch) customOnSearch(inputRef.current?.input?.value, e, {
            source: 'input'
        });
    };
    const onPressEnter = (e)=>{
        if (composedRef.current || loading) return;
        customOnPressEnter?.(e);
        onSearch(e);
    };
    const searchIcon = typeof enterButton === 'boolean' ? /*#__PURE__*/ $ltGt3.createElement((0, $84123a67634fb0f3$export$2e2bcd8739ae039), null) : null;
    const btnPrefixCls = `${prefixCls}-btn`;
    const btnClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(btnPrefixCls, {
        [`${btnPrefixCls}-${variant}`]: variant
    });
    let button;
    const enterButtonAsElement = enterButton || {};
    const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === 'button') button = (0, $66d38239e1a27993$export$e530037191fcd5d7)(enterButtonAsElement, {
        onMouseDown: onMouseDown,
        onClick: (e)=>{
            enterButtonAsElement?.props?.onClick?.(e);
            onSearch(e);
        },
        key: 'enterButton',
        ...isAntdButton ? {
            className: btnClassName,
            size: size
        } : {}
    });
    else button = /*#__PURE__*/ $ltGt3.createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
        classNames: mergedClassNames.button,
        styles: mergedStyles.button,
        className: btnClassName,
        color: enterButton ? 'primary' : 'default',
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon,
        variant: variant === 'borderless' || variant === 'filled' || variant === 'underlined' ? 'text' : enterButton ? 'solid' : undefined
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $66d38239e1a27993$export$e530037191fcd5d7)(addonAfter, {
            key: 'addonAfter'
        })
    ];
    const mergedClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, cssVarCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${size}`]: !!size,
        [`${prefixCls}-with-button`]: !!enterButton
    }, className, hashId, mergedClassNames.root);
    const handleOnCompositionStart = (e)=>{
        composedRef.current = true;
        onCompositionStart?.(e);
    };
    const handleOnCompositionEnd = (e)=>{
        composedRef.current = false;
        onCompositionEnd?.(e);
    };
    // ========================== Render ==========================
    // >>> Root Props
    const rootProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(restProps, {
        data: true
    });
    const inputProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)({
        ...restProps,
        classNames: (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(mergedClassNames, [
            'button',
            'root'
        ]),
        styles: (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(mergedStyles, [
            'button',
            'root'
        ]),
        prefixCls: inputPrefixCls,
        type: 'search',
        size: size,
        variant: variant,
        onPressEnter: onPressEnter,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        onChange: onChange,
        disabled: disabled
    }, Object.keys(rootProps));
    return /*#__PURE__*/ $ltGt3.createElement((0, $8eabd28975be2fa5$export$2e2bcd8739ae039), {
        className: mergedClassName,
        style: {
            ...style,
            ...mergedStyles.root
        },
        ...rootProps,
        hidden: hidden
    }, /*#__PURE__*/ $ltGt3.createElement((0, $3ef8aed3a0e2360a$export$2e2bcd8739ae039), {
        ref: (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(inputRef, ref),
        ...inputProps
    }), button);
});
var $0d9bda8d03b7de4e$export$2e2bcd8739ae039 = $0d9bda8d03b7de4e$var$Search;



"use client";
const $a57f5862981f5e9d$var$Input = (0, $3ef8aed3a0e2360a$export$2e2bcd8739ae039);
$a57f5862981f5e9d$var$Input.Group = (0, $80f1b5d9824f10f5$export$2e2bcd8739ae039);
$a57f5862981f5e9d$var$Input.Search = (0, $0d9bda8d03b7de4e$export$2e2bcd8739ae039);
$a57f5862981f5e9d$var$Input.TextArea = (0, $b25fe3380ecdfadc$export$2e2bcd8739ae039);
$a57f5862981f5e9d$var$Input.Password = (0, $d3ac237522f5588d$export$2e2bcd8739ae039);
$a57f5862981f5e9d$var$Input.OTP = (0, $2836ed1c9186c286$export$2e2bcd8739ae039);
var $a57f5862981f5e9d$export$2e2bcd8739ae039 = $a57f5862981f5e9d$var$Input;



var $ltGt3 = parcelRequire("ltGt3");







var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");

var $2cfb8da4aa0faed4$export$2e2bcd8739ae039 = (file, acceptedFiles)=>{
    if (file && acceptedFiles) {
        const acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        const fileName = file.name || '';
        const mimeType = file.type || '';
        const baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some((type)=>{
            const validType = type.trim();
            // This is something like */*,*  allow all files
            if (/^\*(\/\*)?$/.test(type)) return true;
            // like .jpg, .png
            if (validType.charAt(0) === '.') {
                const lowerFileName = fileName.toLowerCase();
                const lowerType = validType.toLowerCase();
                let affixList = [
                    lowerType
                ];
                if (lowerType === '.jpg' || lowerType === '.jpeg') affixList = [
                    '.jpg',
                    '.jpeg'
                ];
                return affixList.some((affix)=>lowerFileName.endsWith(affix));
            }
            // This is something like a image/* mime type
            if (/\/\*$/.test(validType)) return baseMimeType === validType.replace(/\/.*$/, '');
            // Full match
            if (mimeType === validType) return true;
            // Invalidate type should skip
            if (/^\w+$/.test(validType)) {
                (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, `Upload takes an invalidate 'accept' type '${validType}'.Skip for check.`);
                return true;
            }
            return false;
        });
    }
    return true;
};


function $d644965308bdc327$var$getError(option, xhr) {
    const msg = `cannot ${option.method} ${option.action} ${xhr.status}'`;
    const err = new Error(msg);
    err.status = xhr.status;
    err.method = option.method;
    err.url = option.action;
    return err;
}
function $d644965308bdc327$var$getBody(xhr) {
    const text = xhr.responseText || xhr.response;
    if (!text) return text;
    try {
        return JSON.parse(text);
    } catch (e) {
        return text;
    }
}
function $d644965308bdc327$export$2e2bcd8739ae039(option) {
    // eslint-disable-next-line no-undef
    const xhr = new XMLHttpRequest();
    if (option.onProgress && xhr.upload) xhr.upload.onprogress = function progress(e) {
        if (e.total > 0) e.percent = e.loaded / e.total * 100;
        option.onProgress(e);
    };
    // eslint-disable-next-line no-undef
    const formData = new FormData();
    if (option.data) Object.keys(option.data).forEach((key)=>{
        const value = option.data[key];
        // support key-value array data
        if (Array.isArray(value)) {
            value.forEach((item)=>{
                // { list: [ 11, 22 ] }
                // formData.append('list[]', 11);
                formData.append(`${key}[]`, item);
            });
            return;
        }
        formData.append(key, value);
    });
    // eslint-disable-next-line no-undef
    if (option.file instanceof Blob) formData.append(option.filename, option.file, option.file.name);
    else formData.append(option.filename, option.file);
    xhr.onerror = function error(e) {
        option.onError(e);
    };
    xhr.onload = function onload() {
        // allow success when 2xx status
        // see https://github.com/react-component/upload/issues/34
        if (xhr.status < 200 || xhr.status >= 300) return option.onError($d644965308bdc327$var$getError(option, xhr), $d644965308bdc327$var$getBody(xhr));
        return option.onSuccess($d644965308bdc327$var$getBody(xhr), xhr);
    };
    xhr.open(option.method, option.action, true);
    // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
    if (option.withCredentials && 'withCredentials' in xhr) xhr.withCredentials = true;
    const headers = option.headers || {};
    // when set headers['X-Requested-With'] = null , can close default XHR header
    // see https://github.com/react-component/upload/issues/33
    if (headers['X-Requested-With'] !== null) xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    Object.keys(headers).forEach((h)=>{
        if (headers[h] !== null) xhr.setRequestHeader(h, headers[h]);
    });
    xhr.send(formData);
    return {
        abort () {
            xhr.abort();
        }
    };
}


// https://github.com/ant-design/ant-design/issues/50080
const $c02f95b577a93721$var$traverseFileTree = async (files, isAccepted)=>{
    const flattenFileList = [];
    const progressFileList = [];
    files.forEach((file)=>progressFileList.push(file.webkitGetAsEntry()));
    async function readDirectory(directory) {
        const dirReader = directory.createReader();
        const entries = [];
        while(true){
            const results = await new Promise((resolve)=>{
                dirReader.readEntries(resolve, ()=>resolve([]));
            });
            const n = results.length;
            if (!n) break;
            for(let i = 0; i < n; i++)entries.push(results[i]);
        }
        return entries;
    }
    async function readFile(item) {
        return new Promise((reslove)=>{
            item.file((file)=>{
                if (isAccepted(file)) {
                    // https://github.com/ant-design/ant-design/issues/16426
                    if (item.fullPath && !file.webkitRelativePath) {
                        Object.defineProperties(file, {
                            webkitRelativePath: {
                                writable: true
                            }
                        });
                        // eslint-disable-next-line no-param-reassign
                        file.webkitRelativePath = item.fullPath.replace(/^\//, '');
                        Object.defineProperties(file, {
                            webkitRelativePath: {
                                writable: false
                            }
                        });
                    }
                    reslove(file);
                } else reslove(null);
            });
        });
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const _traverseFileTree = async (item, path)=>{
        if (!item) return;
        // eslint-disable-next-line no-param-reassign
        item.path = path || '';
        if (item.isFile) {
            const file = await readFile(item);
            if (file) flattenFileList.push(file);
        } else if (item.isDirectory) {
            const entries = await readDirectory(item);
            progressFileList.push(...entries);
        }
    };
    let wipIndex = 0;
    while(wipIndex < progressFileList.length){
        await _traverseFileTree(progressFileList[wipIndex]);
        wipIndex++;
    }
    return flattenFileList;
};
var $c02f95b577a93721$export$2e2bcd8739ae039 = $c02f95b577a93721$var$traverseFileTree;


const $c362c0bf1c3d33f1$var$now = +new Date();
let $c362c0bf1c3d33f1$var$index = 0;
function $c362c0bf1c3d33f1$export$2e2bcd8739ae039() {
    // eslint-disable-next-line no-plusplus
    return `rc-upload-${$c362c0bf1c3d33f1$var$now}-${++$c362c0bf1c3d33f1$var$index}`;
}


function $aba110aa2be20c86$var$_extends() {
    $aba110aa2be20c86$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aba110aa2be20c86$var$_extends.apply(this, arguments);
}
class $aba110aa2be20c86$var$AjaxUploader extends (0, $ltGt3.Component) {
    state = {
        uid: (0, $c362c0bf1c3d33f1$export$2e2bcd8739ae039)()
    };
    reqs = {};
    fileInput;
    _isMounted;
    filterFile = (file, force = false)=>{
        const { accept: accept, directory: directory } = this.props;
        let filterFn;
        let acceptFormat;
        if (typeof accept === 'string') acceptFormat = accept;
        else {
            const { filter: filter, format: format } = accept || {};
            acceptFormat = format;
            if (filter === 'native') filterFn = ()=>true;
            else filterFn = filter;
        }
        const mergedFilter = filterFn || (directory || force ? (currentFile)=>(0, $2cfb8da4aa0faed4$export$2e2bcd8739ae039)(currentFile, acceptFormat) : ()=>true);
        return mergedFilter(file);
    };
    onChange = (e)=>{
        const { files: files } = e.target;
        const acceptedFiles = [
            ...files
        ].filter((file)=>this.filterFile(file));
        this.uploadFiles(acceptedFiles);
        this.reset();
    };
    onClick = (event)=>{
        const el = this.fileInput;
        if (!el) return;
        const target = event.target;
        const { onClick: onClick } = this.props;
        if (target && target.tagName === 'BUTTON') {
            const parent = el.parentNode;
            parent.focus();
            target.blur();
        }
        el.click();
        if (onClick) onClick(event);
    };
    onKeyDown = (e)=>{
        if (e.key === 'Enter') this.onClick(e);
    };
    onDataTransferFiles = async (dataTransfer, existFileCallback)=>{
        const { multiple: multiple, directory: directory } = this.props;
        const items = [
            ...dataTransfer.items || []
        ];
        let files = [
            ...dataTransfer.files || []
        ];
        if (files.length > 0 || items.some((item)=>item.kind === 'file')) existFileCallback?.();
        if (directory) {
            files = await (0, $c02f95b577a93721$export$2e2bcd8739ae039)(Array.prototype.slice.call(items), this.filterFile);
            this.uploadFiles(files);
        } else {
            let acceptFiles = [
                ...files
            ].filter((file)=>this.filterFile(file, true));
            if (multiple === false) acceptFiles = files.slice(0, 1);
            this.uploadFiles(acceptFiles);
        }
    };
    onFilePaste = async (e)=>{
        const { pastable: pastable } = this.props;
        if (!pastable) return;
        if (e.type === 'paste') {
            const clipboardData = e.clipboardData;
            return this.onDataTransferFiles(clipboardData, ()=>{
                e.preventDefault();
            });
        }
    };
    onFileDragOver = (e)=>{
        e.preventDefault();
    };
    onFileDrop = async (e)=>{
        e.preventDefault();
        if (e.type === 'drop') {
            const dataTransfer = e.dataTransfer;
            return this.onDataTransferFiles(dataTransfer);
        }
    };
    componentDidMount() {
        this._isMounted = true;
        const { pastable: pastable } = this.props;
        if (pastable) document.addEventListener('paste', this.onFilePaste);
    }
    componentWillUnmount() {
        this._isMounted = false;
        this.abort();
        document.removeEventListener('paste', this.onFilePaste);
    }
    componentDidUpdate(prevProps) {
        const { pastable: pastable } = this.props;
        if (pastable && !prevProps.pastable) document.addEventListener('paste', this.onFilePaste);
        else if (!pastable && prevProps.pastable) document.removeEventListener('paste', this.onFilePaste);
    }
    uploadFiles = (files)=>{
        const originFiles = [
            ...files
        ];
        const postFiles = originFiles.map((file)=>{
            // eslint-disable-next-line no-param-reassign
            file.uid = (0, $c362c0bf1c3d33f1$export$2e2bcd8739ae039)();
            return this.processFile(file, originFiles);
        });
        // Batch upload files
        Promise.all(postFiles).then((fileList)=>{
            const { onBatchStart: onBatchStart } = this.props;
            onBatchStart?.(fileList.map(({ origin: origin, parsedFile: parsedFile })=>({
                    file: origin,
                    parsedFile: parsedFile
                })));
            fileList.filter((file)=>file.parsedFile !== null).forEach((file)=>{
                this.post(file);
            });
        });
    };
    /**
   * Process file before upload. When all the file is ready, we start upload.
   */ processFile = async (file, fileList)=>{
        const { beforeUpload: beforeUpload } = this.props;
        let transformedFile = file;
        if (beforeUpload) {
            try {
                transformedFile = await beforeUpload(file, fileList);
            } catch (e) {
                // Rejection will also trade as false
                transformedFile = false;
            }
            if (transformedFile === false) return {
                origin: file,
                parsedFile: null,
                action: null,
                data: null
            };
        }
        // Get latest action
        const { action: action } = this.props;
        let mergedAction;
        if (typeof action === 'function') mergedAction = await action(file);
        else mergedAction = action;
        // Get latest data
        const { data: data } = this.props;
        let mergedData;
        if (typeof data === 'function') mergedData = await data(file);
        else mergedData = data;
        const parsedData = // string type is from legacy `transformFile`.
        // Not sure if this will work since no related test case works with it
        (typeof transformedFile === 'object' || typeof transformedFile === 'string') && transformedFile ? transformedFile : file;
        let parsedFile;
        if (parsedData instanceof File) parsedFile = parsedData;
        else parsedFile = new File([
            parsedData
        ], file.name, {
            type: file.type
        });
        const mergedParsedFile = parsedFile;
        mergedParsedFile.uid = file.uid;
        return {
            origin: file,
            data: mergedData,
            parsedFile: mergedParsedFile,
            action: mergedAction
        };
    };
    post({ data: data, origin: origin, action: action, parsedFile: parsedFile }) {
        if (!this._isMounted) return;
        const { onStart: onStart, customRequest: customRequest, name: name, headers: headers, withCredentials: withCredentials, method: method } = this.props;
        const { uid: uid } = origin;
        const request = customRequest || (0, $d644965308bdc327$export$2e2bcd8739ae039);
        const requestOption = {
            action: action,
            filename: name,
            data: data,
            file: parsedFile,
            headers: headers,
            withCredentials: withCredentials,
            method: method || 'post',
            onProgress: (e)=>{
                const { onProgress: onProgress } = this.props;
                onProgress?.(e, parsedFile);
            },
            onSuccess: (ret, xhr)=>{
                const { onSuccess: onSuccess } = this.props;
                onSuccess?.(ret, parsedFile, xhr);
                delete this.reqs[uid];
            },
            onError: (err, ret)=>{
                const { onError: onError } = this.props;
                onError?.(err, ret, parsedFile);
                delete this.reqs[uid];
            }
        };
        onStart(origin);
        this.reqs[uid] = request(requestOption, {
            defaultRequest: $d644965308bdc327$export$2e2bcd8739ae039
        });
    }
    reset() {
        this.setState({
            uid: (0, $c362c0bf1c3d33f1$export$2e2bcd8739ae039)()
        });
    }
    abort(file) {
        const { reqs: reqs } = this;
        if (file) {
            const uid = file.uid ? file.uid : file;
            if (reqs[uid] && reqs[uid].abort) reqs[uid].abort();
            delete reqs[uid];
        } else Object.keys(reqs).forEach((uid)=>{
            if (reqs[uid] && reqs[uid].abort) reqs[uid].abort();
            delete reqs[uid];
        });
    }
    saveFileInput = (node)=>{
        this.fileInput = node;
    };
    render() {
        const { component: Tag, prefixCls: prefixCls, className: className, classNames: classNames = {}, disabled: disabled, id: id, name: name, style: style, styles: styles = {}, multiple: multiple, accept: accept, capture: capture, children: children, directory: directory, openFileDialogOnClick: openFileDialogOnClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, hasControlInside: hasControlInside, ...otherProps } = this.props;
        // Extract accept format for input element
        const acceptFormat = typeof accept === 'string' ? accept : accept?.format;
        const cls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-disabled`]: disabled,
            [className]: className
        });
        // because input don't have directory/webkitdirectory type declaration
        const dirProps = directory ? {
            directory: 'directory',
            webkitdirectory: 'webkitdirectory'
        } : {};
        const events = disabled ? {} : {
            onClick: openFileDialogOnClick ? this.onClick : ()=>{},
            onKeyDown: openFileDialogOnClick ? this.onKeyDown : ()=>{},
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onDrop: this.onFileDrop,
            onDragOver: this.onFileDragOver,
            tabIndex: hasControlInside ? undefined : '0'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(Tag, $aba110aa2be20c86$var$_extends({}, events, {
            className: cls,
            role: hasControlInside ? undefined : 'button',
            style: style
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("input", $aba110aa2be20c86$var$_extends({}, (0, $297f85de79f8d325$export$2e2bcd8739ae039)(otherProps, {
            aria: true,
            data: true
        }), {
            id: id,
            name: name,
            disabled: disabled,
            type: "file",
            ref: this.saveFileInput,
            onClick: (e)=>e.stopPropagation() // https://github.com/ant-design/ant-design/issues/19948
            ,
            key: this.state.uid,
            style: {
                display: 'none',
                ...styles.input
            },
            className: classNames.input,
            accept: acceptFormat
        }, dirProps, {
            multiple: multiple,
            onChange: this.onChange
        }, capture != null ? {
            capture: capture
        } : {})), children);
    }
}
var $aba110aa2be20c86$export$2e2bcd8739ae039 = $aba110aa2be20c86$var$AjaxUploader;


function $bc3f452c3d07d907$var$_extends() {
    $bc3f452c3d07d907$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc3f452c3d07d907$var$_extends.apply(this, arguments);
}
function $bc3f452c3d07d907$var$empty() {}
class $bc3f452c3d07d907$var$Upload extends (0, $ltGt3.Component) {
    static defaultProps = {
        component: 'span',
        prefixCls: 'rc-upload',
        data: {},
        headers: {},
        name: 'file',
        multipart: false,
        onStart: $bc3f452c3d07d907$var$empty,
        onError: $bc3f452c3d07d907$var$empty,
        onSuccess: $bc3f452c3d07d907$var$empty,
        multiple: false,
        beforeUpload: null,
        customRequest: null,
        withCredentials: false,
        openFileDialogOnClick: true,
        hasControlInside: false
    };
    uploader;
    abort(file) {
        this.uploader.abort(file);
    }
    saveUploader = (node)=>{
        this.uploader = node;
    };
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $aba110aa2be20c86$export$2e2bcd8739ae039), $bc3f452c3d07d907$var$_extends({}, this.props, {
            ref: this.saveUploader
        }));
    }
}
var $bc3f452c3d07d907$export$2e2bcd8739ae039 = $bc3f452c3d07d907$var$Upload;


var $24b8f844caa705b2$export$2e2bcd8739ae039 = (0, $bc3f452c3d07d907$export$2e2bcd8739ae039);














const $5a1b8e13bdb17cf6$var$genDraggerStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-drag`]: {
                position: 'relative',
                width: '100%',
                height: '100%',
                textAlign: 'center',
                background: token.colorFillAlter,
                border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} dashed ${token.colorBorder}`,
                borderRadius: token.borderRadiusLG,
                cursor: 'pointer',
                transition: `border-color ${token.motionDurationSlow}`,
                [componentCls]: {
                    padding: token.padding
                },
                [`${componentCls}-btn`]: {
                    display: 'table',
                    width: '100%',
                    height: '100%',
                    outline: 'none',
                    borderRadius: token.borderRadiusLG,
                    '&:focus-visible': {
                        outline: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`
                    }
                },
                [`${componentCls}-drag-container`]: {
                    display: 'table-cell',
                    verticalAlign: 'middle'
                },
                [`
          &:not(${componentCls}-disabled):hover,
          &-hover:not(${componentCls}-disabled)
        `]: {
                    borderColor: token.colorPrimaryHover
                },
                [`p${componentCls}-drag-icon`]: {
                    marginBottom: token.margin,
                    [iconCls]: {
                        color: token.colorPrimary,
                        fontSize: token.uploadThumbnailSize
                    }
                },
                [`p${componentCls}-text`]: {
                    margin: `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.marginXXS)}`,
                    color: token.colorTextHeading,
                    fontSize: token.fontSizeLG
                },
                [`p${componentCls}-hint`]: {
                    color: token.colorTextDescription,
                    fontSize: token.fontSize
                },
                // ===================== Disabled =====================
                [`&${componentCls}-disabled`]: {
                    [`p${componentCls}-drag-icon ${iconCls},
            p${componentCls}-text,
            p${componentCls}-hint
          `]: {
                        color: token.colorTextDisabled
                    }
                }
            }
        }
    };
};
var $5a1b8e13bdb17cf6$export$2e2bcd8739ae039 = $5a1b8e13bdb17cf6$var$genDraggerStyle;




const $106ce218cb1c59f3$var$genListStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontSize: fontSize, lineHeight: lineHeight, calc: calc } = token;
    const itemCls = `${componentCls}-list-item`;
    const actionsCls = `${itemCls}-actions`;
    const actionCls = `${itemCls}-action`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-list`]: {
                ...(0, $945cb0d2b7017a11$export$8c467e8859fdef13)(),
                lineHeight: token.lineHeight,
                [itemCls]: {
                    position: 'relative',
                    height: calc(token.lineHeight).mul(fontSize).equal(),
                    marginTop: token.marginXS,
                    fontSize: fontSize,
                    display: 'flex',
                    alignItems: 'center',
                    transition: `background-color ${token.motionDurationSlow}`,
                    borderRadius: token.borderRadiusSM,
                    '&:hover': {
                        backgroundColor: token.controlItemBgHover
                    },
                    [`${itemCls}-name`]: {
                        ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
                        padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingXS)}`,
                        lineHeight: lineHeight,
                        flex: 'auto',
                        transition: `all ${token.motionDurationSlow}`
                    },
                    [actionsCls]: {
                        whiteSpace: 'nowrap',
                        [actionCls]: {
                            opacity: 0
                        },
                        [iconCls]: {
                            color: token.actionsColor,
                            transition: `all ${token.motionDurationSlow}`
                        },
                        [`
              ${actionCls}:focus-visible,
              &.picture ${actionCls}
            `]: {
                            opacity: 1
                        }
                    },
                    [`${componentCls}-icon ${iconCls}`]: {
                        color: token.colorIcon,
                        fontSize: fontSize
                    },
                    [`${itemCls}-progress`]: {
                        position: 'absolute',
                        bottom: token.calc(token.uploadProgressOffset).mul(-1).equal(),
                        width: '100%',
                        paddingInlineStart: calc(fontSize).add(token.paddingXS).equal(),
                        fontSize: fontSize,
                        lineHeight: 0,
                        pointerEvents: 'none',
                        '> div': {
                            margin: 0
                        }
                    }
                },
                [`${itemCls}:hover ${actionCls}`]: {
                    opacity: 1
                },
                [`${itemCls}-error`]: {
                    color: token.colorError,
                    [`${itemCls}-name, ${componentCls}-icon ${iconCls}`]: {
                        color: token.colorError
                    },
                    [actionsCls]: {
                        [`${iconCls}, ${iconCls}:hover`]: {
                            color: token.colorError
                        },
                        [actionCls]: {
                            opacity: 1
                        }
                    }
                },
                [`${componentCls}-list-item-container`]: {
                    transition: `opacity ${token.motionDurationSlow}, height ${token.motionDurationSlow}`,
                    // For smooth removing animation
                    '&::before': {
                        display: 'table',
                        width: 0,
                        height: 0,
                        content: '""'
                    }
                }
            }
        }
    };
};
var $106ce218cb1c59f3$export$2e2bcd8739ae039 = $106ce218cb1c59f3$var$genListStyle;




// =========================== Motion ===========================
const $a4f43429fecdbe12$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const uploadAnimateInlineIn = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('uploadAnimateInlineIn', {
        from: {
            width: 0,
            height: 0,
            padding: 0,
            opacity: 0,
            margin: token.calc(token.marginXS).div(-2).equal()
        }
    });
    const uploadAnimateInlineOut = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('uploadAnimateInlineOut', {
        to: {
            width: 0,
            height: 0,
            padding: 0,
            opacity: 0,
            margin: token.calc(token.marginXS).div(-2).equal()
        }
    });
    const inlineCls = `${componentCls}-animate-inline`;
    return [
        {
            [`${componentCls}-wrapper`]: {
                [`${inlineCls}-appear, ${inlineCls}-enter, ${inlineCls}-leave`]: {
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseInOutCirc,
                    animationFillMode: 'forwards'
                },
                [`${inlineCls}-appear, ${inlineCls}-enter`]: {
                    animationName: uploadAnimateInlineIn
                },
                [`${inlineCls}-leave`]: {
                    animationName: uploadAnimateInlineOut
                }
            }
        },
        {
            [`${componentCls}-wrapper`]: (0, $0aa79fac63008607$export$2909268c8354a12)(token)
        },
        uploadAnimateInlineIn,
        uploadAnimateInlineOut
    ];
};
var $a4f43429fecdbe12$export$2e2bcd8739ae039 = $a4f43429fecdbe12$var$genMotionStyle;





const $ad660ba045675647$export$353fdbacdd19997a = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, uploadThumbnailSize: uploadThumbnailSize, uploadProgressOffset: uploadProgressOffset, calc: calc } = token;
    const listCls = `${componentCls}-list`;
    const itemCls = `${listCls}-item`;
    return {
        [`${componentCls}-wrapper`]: {
            // ${listCls} 增加优先级
            [`
        ${listCls}${listCls}-picture,
        ${listCls}${listCls}-picture-card,
        ${listCls}${listCls}-picture-circle
      `]: {
                [itemCls]: {
                    position: 'relative',
                    height: calc(uploadThumbnailSize).add(calc(token.lineWidth).mul(2)).add(calc(token.paddingXS).mul(2)).equal(),
                    padding: token.paddingXS,
                    border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadiusLG,
                    '&:hover': {
                        background: 'transparent'
                    },
                    [`${itemCls}-thumbnail`]: {
                        ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
                        width: uploadThumbnailSize,
                        height: uploadThumbnailSize,
                        lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(uploadThumbnailSize).add(token.paddingSM).equal()),
                        textAlign: 'center',
                        flex: 'none',
                        [iconCls]: {
                            fontSize: token.fontSizeHeading2,
                            color: token.colorPrimary
                        },
                        img: {
                            display: 'block',
                            width: '100%',
                            height: '100%',
                            overflow: 'hidden'
                        }
                    },
                    [`${itemCls}-progress`]: {
                        bottom: uploadProgressOffset,
                        width: `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(token.paddingSM).mul(2).equal())})`,
                        marginTop: 0,
                        paddingInlineStart: calc(uploadThumbnailSize).add(token.paddingXS).equal()
                    }
                },
                [`${itemCls}-error`]: {
                    borderColor: token.colorError,
                    // Adjust the color of the error icon : https://github.com/ant-design/ant-design/pull/24160
                    [`${itemCls}-thumbnail ${iconCls}`]: {
                        [`svg path[fill='${(0, $1bd835bbb2d9f8c1$export$2aa0182783e7e9de)[0]}']`]: {
                            fill: token.colorErrorBg
                        },
                        [`svg path[fill='${(0, $1bd835bbb2d9f8c1$export$2aa0182783e7e9de).primary}']`]: {
                            fill: token.colorError
                        }
                    }
                },
                [`${itemCls}-uploading`]: {
                    borderStyle: 'dashed',
                    [`${itemCls}-name`]: {
                        marginBottom: uploadProgressOffset
                    }
                }
            },
            [`${listCls}${listCls}-picture-circle ${itemCls}`]: {
                [`&, &::before, ${itemCls}-thumbnail`]: {
                    borderRadius: '50%'
                }
            }
        }
    };
};
const $ad660ba045675647$export$31311f200c99910f = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, calc: calc } = token;
    const listCls = `${componentCls}-list`;
    const itemCls = `${listCls}-item`;
    const uploadPictureCardSize = token.uploadPicCardSize;
    return {
        [`
      ${componentCls}-wrapper${componentCls}-picture-card-wrapper,
      ${componentCls}-wrapper${componentCls}-picture-circle-wrapper
    `]: {
            ...(0, $945cb0d2b7017a11$export$8c467e8859fdef13)(),
            display: 'block',
            [`${componentCls}${componentCls}-select`]: {
                width: uploadPictureCardSize,
                height: uploadPictureCardSize,
                textAlign: 'center',
                verticalAlign: 'top',
                backgroundColor: token.colorFillAlter,
                border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} dashed ${token.colorBorder}`,
                borderRadius: token.borderRadiusLG,
                cursor: 'pointer',
                transition: `border-color ${token.motionDurationSlow}`,
                [`> ${componentCls}`]: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    textAlign: 'center'
                },
                [`&:not(${componentCls}-disabled):hover`]: {
                    borderColor: token.colorPrimary
                }
            },
            // list
            [`${listCls}${listCls}-picture-card, ${listCls}${listCls}-picture-circle`]: {
                display: 'flex',
                flexWrap: 'wrap',
                '@supports not (gap: 1px)': {
                    '& > *': {
                        marginBlockEnd: token.marginXS,
                        marginInlineEnd: token.marginXS
                    }
                },
                '@supports (gap: 1px)': {
                    gap: token.marginXS
                },
                [`${listCls}-item-container`]: {
                    display: 'inline-block',
                    width: uploadPictureCardSize,
                    height: uploadPictureCardSize,
                    verticalAlign: 'top'
                },
                '&::after': {
                    display: 'none'
                },
                '&::before': {
                    display: 'none'
                },
                [itemCls]: {
                    height: '100%',
                    margin: 0,
                    '&::before': {
                        position: 'absolute',
                        zIndex: 1,
                        width: `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`,
                        height: `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`,
                        backgroundColor: token.colorBgMask,
                        opacity: 0,
                        transition: `all ${token.motionDurationSlow}`,
                        content: '" "'
                    }
                },
                [`${itemCls}:hover`]: {
                    [`&::before, ${itemCls}-actions`]: {
                        opacity: 1
                    }
                },
                [`${itemCls}-actions`]: {
                    position: 'absolute',
                    insetInlineStart: 0,
                    zIndex: 10,
                    width: '100%',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                    opacity: 0,
                    transition: `all ${token.motionDurationSlow}`,
                    [`
            ${iconCls}-eye,
            ${iconCls}-download,
            ${iconCls}-delete
          `]: {
                        zIndex: 10,
                        width: fontSizeLG,
                        margin: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.marginXXS)}`,
                        fontSize: fontSizeLG,
                        cursor: 'pointer',
                        transition: `all ${token.motionDurationSlow}`,
                        color: colorTextLightSolid,
                        '&:hover': {
                            color: colorTextLightSolid
                        },
                        svg: {
                            verticalAlign: 'baseline'
                        }
                    }
                },
                [`${itemCls}-thumbnail, ${itemCls}-thumbnail img`]: {
                    position: 'static',
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                },
                [`${itemCls}-name`]: {
                    display: 'none',
                    textAlign: 'center'
                },
                [`${itemCls}-file + ${itemCls}-name`]: {
                    position: 'absolute',
                    bottom: token.margin,
                    display: 'block',
                    width: `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`
                },
                [`${itemCls}-uploading`]: {
                    [`&${itemCls}`]: {
                        backgroundColor: token.colorFillAlter
                    },
                    [`&::before, ${iconCls}-eye, ${iconCls}-download, ${iconCls}-delete`]: {
                        display: 'none'
                    }
                },
                [`${itemCls}-progress`]: {
                    bottom: token.marginXL,
                    width: `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`,
                    paddingInlineStart: 0
                }
            }
        },
        [`${componentCls}-wrapper${componentCls}-picture-circle-wrapper`]: {
            [`${componentCls}${componentCls}-select`]: {
                borderRadius: '50%'
            }
        }
    };
};


// =========================== Motion ===========================
const $d8a9f86b9c67e1cd$var$genRtlStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        }
    };
};
var $d8a9f86b9c67e1cd$export$2e2bcd8739ae039 = $d8a9f86b9c67e1cd$var$genRtlStyle;


const $7bc90afee5d790cc$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, colorTextDisabled: colorTextDisabled } = token;
    return {
        [`${componentCls}-wrapper`]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            [componentCls]: {
                outline: 0,
                "input[type='file']": {
                    cursor: 'pointer'
                }
            },
            [`${componentCls}-select`]: {
                display: 'inline-block'
            },
            [`${componentCls}-hidden`]: {
                display: 'none'
            },
            [`${componentCls}-disabled`]: {
                color: colorTextDisabled,
                cursor: 'not-allowed'
            }
        }
    };
};
const $7bc90afee5d790cc$export$9ca1be8807fe0675 = (token)=>({
        actionsColor: token.colorIcon,
        pictureCardSize: token.controlHeightLG * 2.55
    });
var // ============================== Export ==============================
$7bc90afee5d790cc$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Upload', (token)=>{
    const { fontSizeHeading3: fontSizeHeading3, fontHeight: fontHeight, lineWidth: lineWidth, pictureCardSize: pictureCardSize, calc: calc } = token;
    const uploadToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        uploadThumbnailSize: calc(fontSizeHeading3).mul(2).equal(),
        uploadProgressOffset: calc(calc(fontHeight).div(2)).add(lineWidth).equal(),
        uploadPicCardSize: pictureCardSize
    });
    return [
        $7bc90afee5d790cc$var$genBaseStyle(uploadToken),
        (0, $5a1b8e13bdb17cf6$export$2e2bcd8739ae039)(uploadToken),
        (0, $ad660ba045675647$export$353fdbacdd19997a)(uploadToken),
        (0, $ad660ba045675647$export$31311f200c99910f)(uploadToken),
        (0, $106ce218cb1c59f3$export$2e2bcd8739ae039)(uploadToken),
        (0, $a4f43429fecdbe12$export$2e2bcd8739ae039)(uploadToken),
        (0, $d8a9f86b9c67e1cd$export$2e2bcd8739ae039)(uploadToken),
        (0, $5a999cf2ba92548d$export$2e2bcd8739ae039)(uploadToken)
    ];
}, $7bc90afee5d790cc$export$9ca1be8807fe0675);




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $0d1fbebb5230d360$var$FileTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "file",
    "theme": "twotone"
};
var $0d1fbebb5230d360$export$2e2bcd8739ae039 = $0d1fbebb5230d360$var$FileTwoTone;



function $7656787a205f5290$var$_extends() {
    $7656787a205f5290$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7656787a205f5290$var$_extends.apply(this, arguments);
}
const $7656787a205f5290$var$FileTwoTone = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $7656787a205f5290$var$_extends({}, props, {
        ref: ref,
        icon: (0, $0d1fbebb5230d360$export$2e2bcd8739ae039)
    }));
/**![file](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzNCAzNTJWMTM2SDIzMnY3NTJoNTYwVjM5NEg1NzZhNDIgNDIgMCAwMS00Mi00MnoiIGZpbGw9IiNlNmY0ZmYiIC8+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTYwMiAxMzcuOEw3OTAuMiAzMjZINjAyVjEzNy44ek03OTIgODg4SDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIGZpbGw9IiMxNjc3ZmYiIC8+PC9zdmc+) */ const $7656787a205f5290$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($7656787a205f5290$var$FileTwoTone);
var $7656787a205f5290$export$2e2bcd8739ae039 = $7656787a205f5290$var$RefIcon;




var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $94fbb8c5bc33683f$var$PaperClipOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
                }
            }
        ]
    },
    "name": "paper-clip",
    "theme": "outlined"
};
var $94fbb8c5bc33683f$export$2e2bcd8739ae039 = $94fbb8c5bc33683f$var$PaperClipOutlined;



function $a966100085b287e7$var$_extends() {
    $a966100085b287e7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a966100085b287e7$var$_extends.apply(this, arguments);
}
const $a966100085b287e7$var$PaperClipOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $a966100085b287e7$var$_extends({}, props, {
        ref: ref,
        icon: (0, $94fbb8c5bc33683f$export$2e2bcd8739ae039)
    }));
/**![paper-clip](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc3OS4zIDE5Ni42Yy05NC4yLTk0LjItMjQ3LjYtOTQuMi0zNDEuNyAwbC0yNjEgMjYwLjhjLTEuNyAxLjctMi42IDQtMi42IDYuNHMuOSA0LjcgMi42IDYuNGwzNi45IDM2LjlhOSA5IDAgMDAxMi43IDBsMjYxLTI2MC44YzMyLjQtMzIuNCA3NS41LTUwLjIgMTIxLjMtNTAuMnM4OC45IDE3LjggMTIxLjIgNTAuMmMzMi40IDMyLjQgNTAuMiA3NS41IDUwLjIgMTIxLjIgMCA0NS44LTE3LjggODguOC01MC4yIDEyMS4ybC0yNjYgMjY1LjktNDMuMSA0My4xYy00MC4zIDQwLjMtMTA1LjggNDAuMy0xNDYuMSAwLTE5LjUtMTkuNS0zMC4yLTQ1LjQtMzAuMi03M3MxMC43LTUzLjUgMzAuMi03M2wyNjMuOS0yNjMuOGM2LjctNi42IDE1LjUtMTAuMyAyNC45LTEwLjNoLjFjOS40IDAgMTguMSAzLjcgMjQuNyAxMC4zIDYuNyA2LjcgMTAuMyAxNS41IDEwLjMgMjQuOSAwIDkuMy0zLjcgMTguMS0xMC4zIDI0LjdMMzcyLjQgNjUzYy0xLjcgMS43LTIuNiA0LTIuNiA2LjRzLjkgNC43IDIuNiA2LjRsMzYuOSAzNi45YTkgOSAwIDAwMTIuNyAwbDIxNS42LTIxNS42YzE5LjktMTkuOSAzMC44LTQ2LjMgMzAuOC03NC40cy0xMS01NC42LTMwLjgtNzQuNGMtNDEuMS00MS4xLTEwNy45LTQxLTE0OSAwTDQ2MyAzNjQgMjI0LjggNjAyLjFBMTcyLjIyIDE3Mi4yMiAwIDAwMTc0IDcyNC44YzAgNDYuMyAxOC4xIDg5LjggNTAuOCAxMjIuNSAzMy45IDMzLjggNzguMyA1MC43IDEyMi43IDUwLjcgNDQuNCAwIDg4LjgtMTYuOSAxMjIuNi01MC43bDMwOS4yLTMwOUM4MjQuOCA0OTIuNyA4NTAgNDMyIDg1MCAzNjcuNWMuMS02NC42LTI1LjEtMTI1LjMtNzAuNy0xNzAuOXoiIC8+PC9zdmc+) */ const $a966100085b287e7$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($a966100085b287e7$var$PaperClipOutlined);
var $a966100085b287e7$export$2e2bcd8739ae039 = $a966100085b287e7$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $6ee157f8afe527b7$var$PictureTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "picture",
    "theme": "twotone"
};
var $6ee157f8afe527b7$export$2e2bcd8739ae039 = $6ee157f8afe527b7$var$PictureTwoTone;



function $8fd2111afa7cc48a$var$_extends() {
    $8fd2111afa7cc48a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8fd2111afa7cc48a$var$_extends.apply(this, arguments);
}
const $8fd2111afa7cc48a$var$PictureTwoTone = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $8fd2111afa7cc48a$var$_extends({}, props, {
        ref: ref,
        icon: (0, $6ee157f8afe527b7$export$2e2bcd8739ae039)
    }));
/**![picture](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNjMySDEzNnYtMzkuOWwxMzguNS0xNjQuMyAxNTAuMSAxNzhMNjU4LjEgNDg5IDg4OCA3NjEuNlY3OTJ6bTAtMTI5LjhMNjY0LjIgMzk2LjhjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDQyNC42IDY2Ni40bC0xNDQtMTcwLjdjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDEzNiA2NTIuN1YyMzJoNzUydjQzMC4yeiIgZmlsbD0iIzE2NzdmZiIgLz48cGF0aCBkPSJNNDI0LjYgNzY1LjhsLTE1MC4xLTE3OEwxMzYgNzUyLjFWNzkyaDc1MnYtMzAuNEw2NTguMSA0ODl6IiBmaWxsPSIjZTZmNGZmIiAvPjxwYXRoIGQ9Ik0xMzYgNjUyLjdsMTMyLjQtMTU3YzMuMi0zLjggOS0zLjggMTIuMiAwbDE0NCAxNzAuN0w2NTIgMzk2LjhjMy4yLTMuOCA5LTMuOCAxMi4yIDBMODg4IDY2Mi4yVjIzMkgxMzZ2NDIwLjd6TTMwNCAyODBhODggODggMCAxMTAgMTc2IDg4IDg4IDAgMDEwLTE3NnoiIGZpbGw9IiNlNmY0ZmYiIC8+PHBhdGggZD0iTTI3NiAzNjhhMjggMjggMCAxMDU2IDAgMjggMjggMCAxMC01NiAweiIgZmlsbD0iI2U2ZjRmZiIgLz48cGF0aCBkPSJNMzA0IDQ1NmE4OCA4OCAwIDEwMC0xNzYgODggODggMCAwMDAgMTc2em0wLTExNmMxNS41IDAgMjggMTIuNSAyOCAyOHMtMTIuNSAyOC0yOCAyOC0yOC0xMi41LTI4LTI4IDEyLjUtMjggMjgtMjh6IiBmaWxsPSIjMTY3N2ZmIiAvPjwvc3ZnPg==) */ const $8fd2111afa7cc48a$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($8fd2111afa7cc48a$var$PictureTwoTone);
var $8fd2111afa7cc48a$export$2e2bcd8739ae039 = $8fd2111afa7cc48a$var$RefIcon;











function $4ed4e55488d43d6a$export$6dc848fd109e803d(file) {
    return {
        ...file,
        lastModified: file.lastModified,
        lastModifiedDate: file.lastModifiedDate,
        name: file.name,
        size: file.size,
        type: file.type,
        uid: file.uid,
        percent: 0,
        originFileObj: file
    };
}
function $4ed4e55488d43d6a$export$65c2063f64290f37(file, fileList) {
    const nextFileList = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(fileList);
    const fileIndex = nextFileList.findIndex(({ uid: uid })=>uid === file.uid);
    if (fileIndex === -1) nextFileList.push(file);
    else nextFileList[fileIndex] = file;
    return nextFileList;
}
function $4ed4e55488d43d6a$export$1165ac073f485fae(file, fileList) {
    const matchKey = file.uid !== undefined ? 'uid' : 'name';
    return fileList.filter((item)=>item[matchKey] === file[matchKey])[0];
}
function $4ed4e55488d43d6a$export$f3bced642db28a96(file, fileList) {
    const matchKey = file.uid !== undefined ? 'uid' : 'name';
    const removed = fileList.filter((item)=>item[matchKey] !== file[matchKey]);
    if (removed.length === fileList.length) return null;
    return removed;
}
// ==================== Default Image Preview ====================
const $4ed4e55488d43d6a$var$extname = (url = '')=>{
    const temp = url.split('/');
    const filename = temp[temp.length - 1];
    const filenameWithoutSuffix = filename.split(/#|\?/)[0];
    return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [
        ''
    ])[0];
};
const $4ed4e55488d43d6a$var$isImageFileType = (type)=>type.indexOf('image/') === 0;
const $4ed4e55488d43d6a$export$431d13c2db3f6781 = (file)=>{
    if (file.type && !file.thumbUrl) return $4ed4e55488d43d6a$var$isImageFileType(file.type);
    const url = file.thumbUrl || file.url || '';
    const extension = $4ed4e55488d43d6a$var$extname(url);
    if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|heic|heif)$/i.test(extension)) return true;
    if (/^data:/.test(url)) // other file types of base64
    return false;
    if (extension) // other file types which have extension
    return false;
    return true;
};
const $4ed4e55488d43d6a$var$MEASURE_SIZE = 200;
function $4ed4e55488d43d6a$export$b5db251096956c0d(file) {
    return new Promise((resolve)=>{
        if (!file.type || !$4ed4e55488d43d6a$var$isImageFileType(file.type)) {
            resolve('');
            return;
        }
        const canvas = document.createElement('canvas');
        canvas.width = $4ed4e55488d43d6a$var$MEASURE_SIZE;
        canvas.height = $4ed4e55488d43d6a$var$MEASURE_SIZE;
        canvas.style.cssText = `position: fixed; left: 0; top: 0; width: ${$4ed4e55488d43d6a$var$MEASURE_SIZE}px; height: ${$4ed4e55488d43d6a$var$MEASURE_SIZE}px; z-index: 9999; display: none;`;
        document.body.appendChild(canvas);
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.onload = ()=>{
            const { width: width, height: height } = img;
            let drawWidth = $4ed4e55488d43d6a$var$MEASURE_SIZE;
            let drawHeight = $4ed4e55488d43d6a$var$MEASURE_SIZE;
            let offsetX = 0;
            let offsetY = 0;
            if (width > height) {
                drawHeight = height * ($4ed4e55488d43d6a$var$MEASURE_SIZE / width);
                offsetY = -(drawHeight - drawWidth) / 2;
            } else {
                drawWidth = width * ($4ed4e55488d43d6a$var$MEASURE_SIZE / height);
                offsetX = -(drawWidth - drawHeight) / 2;
            }
            ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
            const dataURL = canvas.toDataURL();
            document.body.removeChild(canvas);
            window.URL.revokeObjectURL(img.src);
            resolve(dataURL);
        };
        img.crossOrigin = 'anonymous';
        if (file.type.startsWith('image/svg+xml')) {
            const reader = new FileReader();
            reader.onload = ()=>{
                if (reader.result && typeof reader.result === 'string') img.src = reader.result;
            };
            reader.readAsDataURL(file);
        } else if (file.type.startsWith('image/gif')) {
            const reader = new FileReader();
            reader.onload = ()=>{
                if (reader.result) resolve(reader.result);
            };
            reader.readAsDataURL(file);
        } else img.src = window.URL.createObjectURL(file);
    });
}



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $f0cb76f7105de4ab$var$DeleteOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    },
    "name": "delete",
    "theme": "outlined"
};
var $f0cb76f7105de4ab$export$2e2bcd8739ae039 = $f0cb76f7105de4ab$var$DeleteOutlined;



function $d924582d8f73e28a$var$_extends() {
    $d924582d8f73e28a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d924582d8f73e28a$var$_extends.apply(this, arguments);
}
const $d924582d8f73e28a$var$DeleteOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $d924582d8f73e28a$var$_extends({}, props, {
        ref: ref,
        icon: (0, $f0cb76f7105de4ab$export$2e2bcd8739ae039)
    }));
/**![delete](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2MCAxODRoLThjNC40IDAgOC0zLjYgOC04djhoMzA0di04YzAgNC40IDMuNiA4IDggOGgtOHY3Mmg3MnYtODBjMC0zNS4zLTI4LjctNjQtNjQtNjRIMzUyYy0zNS4zIDAtNjQgMjguNy02NCA2NHY4MGg3MnYtNzJ6bTUwNCA3MkgxNjBjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjMyYzAgNC40IDMuNiA4IDggOGg2MC40bDI0LjcgNTIzYzEuNiAzNC4xIDI5LjggNjEgNjMuOSA2MWg0NTRjMzQuMiAwIDYyLjMtMjYuOCA2My45LTYxbDI0LjctNTIzSDg4OGM0LjQgMCA4LTMuNiA4LTh2LTMyYzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MzEuMyA4NDBIMjkyLjdsLTI0LjItNTEyaDQ4N2wtMjQuMiA1MTJ6IiAvPjwvc3ZnPg==) */ const $d924582d8f73e28a$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($d924582d8f73e28a$var$DeleteOutlined);
var $d924582d8f73e28a$export$2e2bcd8739ae039 = $d924582d8f73e28a$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $33787546712c7579$var$DownloadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "download",
    "theme": "outlined"
};
var $33787546712c7579$export$2e2bcd8739ae039 = $33787546712c7579$var$DownloadOutlined;



function $b8d15d60eb12302d$var$_extends() {
    $b8d15d60eb12302d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8d15d60eb12302d$var$_extends.apply(this, arguments);
}
const $b8d15d60eb12302d$var$DownloadOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $b8d15d60eb12302d$var$_extends({}, props, {
        ref: ref,
        icon: (0, $33787546712c7579$export$2e2bcd8739ae039)
    }));
/**![download](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUwNS43IDY2MWE4IDggMCAwMDEyLjYgMGwxMTItMTQxLjdjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc0LjFWMTY4YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYzMzguM0g0MDBjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45bDExMiAxNDEuOHpNODc4IDYyNmgtNjBjLTQuNCAwLTggMy42LTggOHYxNTRIMjE0VjYzNGMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTk4YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDY4NGMxNy43IDAgMzItMTQuMyAzMi0zMlY2MzRjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ const $b8d15d60eb12302d$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($b8d15d60eb12302d$var$DownloadOutlined);
var $b8d15d60eb12302d$export$2e2bcd8739ae039 = $b8d15d60eb12302d$var$RefIcon;







var $ltGt3 = parcelRequire("ltGt3");











var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
const $85a1a51d0ad5ffd6$export$9c21a3269931e1e6 = {
    percent: 0,
    prefixCls: 'rc-progress',
    strokeColor: '#2db7f5',
    strokeLinecap: 'round',
    strokeWidth: 1,
    railColor: '#D9D9D9',
    railWidth: 1,
    gapPosition: 'bottom',
    loading: false
};
const $85a1a51d0ad5ffd6$export$7685006d504ecf0b = ()=>{
    const pathsRef = (0, $ltGt3.useRef)([]);
    const prevTimeStamp = (0, $ltGt3.useRef)(null);
    (0, $ltGt3.useEffect)(()=>{
        const now = Date.now();
        let updated = false;
        pathsRef.current.forEach((path)=>{
            if (!path) return;
            updated = true;
            const pathStyle = path.style;
            pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';
            if (prevTimeStamp.current && now - prevTimeStamp.current < 100) pathStyle.transitionDuration = '0s, 0s';
        });
        if (updated) prevTimeStamp.current = Date.now();
    });
    return pathsRef.current;
};



var $ltGt3 = parcelRequire("ltGt3");
var $1cc199c79f220736$export$2e2bcd8739ae039 = (options)=>{
    const { id: id, percent: percent, strokeLinecap: strokeLinecap, strokeWidth: strokeWidth, loading: loading } = options;
    if (!loading) return {
        indeterminateStyleProps: {},
        indeterminateStyleAnimation: null
    };
    const animationName = `${id}-indeterminate-animate`;
    const strokeDashOffset = 100 - (percent + (strokeLinecap === 'round' ? strokeWidth : 0));
    return {
        indeterminateStyleProps: {
            strokeDasharray: `${percent} 100`,
            animation: `${animationName} .6s linear alternate infinite`,
            strokeDashoffset: 0
        },
        indeterminateStyleAnimation: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("style", null, `@keyframes ${animationName} {
            0% { stroke-dashoffset: 0; }
            100% { stroke-dashoffset: -${strokeDashOffset};
          }`)
    };
};



function $9d5c47d778c4248c$var$_extends() {
    $9d5c47d778c4248c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9d5c47d778c4248c$var$_extends.apply(this, arguments);
}
const $9d5c47d778c4248c$var$Line = (props)=>{
    const { id: id, className: className, percent: percent, prefixCls: prefixCls, strokeColor: strokeColor, strokeLinecap: strokeLinecap, strokeWidth: strokeWidth, style: style, railColor: railColor, railWidth: railWidth, transition: transition, loading: loading, ...restProps } = {
        ...(0, $85a1a51d0ad5ffd6$export$9c21a3269931e1e6),
        ...props
    };
    const mergedId = (0, $1fb03482b73301f3$export$2e2bcd8739ae039)(id);
    // eslint-disable-next-line no-param-reassign
    delete restProps.gapPosition;
    const percentList = Array.isArray(percent) ? percent : [
        percent
    ];
    const strokeColorList = Array.isArray(strokeColor) ? strokeColor : [
        strokeColor
    ];
    const paths = (0, $85a1a51d0ad5ffd6$export$7685006d504ecf0b)();
    const center = strokeWidth / 2;
    const right = 100 - strokeWidth / 2;
    const pathString = `M ${strokeLinecap === 'round' ? center : 0},${center}
         L ${strokeLinecap === 'round' ? right : 100},${center}`;
    const viewBoxString = `0 0 100 ${strokeWidth}`;
    let stackPtg = 0;
    const { indeterminateStyleProps: indeterminateStyleProps, indeterminateStyleAnimation: indeterminateStyleAnimation } = (0, $1cc199c79f220736$export$2e2bcd8739ae039)({
        id: mergedId,
        loading: loading,
        percent: percentList[0],
        strokeLinecap: strokeLinecap,
        strokeWidth: strokeWidth
    });
    return /*#__PURE__*/ $ltGt3.createElement("svg", $9d5c47d778c4248c$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-line`, className),
        viewBox: viewBoxString,
        preserveAspectRatio: "none",
        style: style
    }, restProps), /*#__PURE__*/ $ltGt3.createElement("path", {
        className: `${prefixCls}-line-rail`,
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: railColor,
        strokeWidth: railWidth || strokeWidth,
        fillOpacity: "0"
    }), percentList.map((ptg, index)=>{
        let dashPercent = 1;
        switch(strokeLinecap){
            case 'round':
                dashPercent = 1 - strokeWidth / 100;
                break;
            case 'square':
                dashPercent = 1 - strokeWidth / 2 / 100;
                break;
            default:
                dashPercent = 1;
                break;
        }
        const pathStyle = {
            strokeDasharray: `${ptg * dashPercent}px, 100px`,
            strokeDashoffset: `-${stackPtg}px`,
            transition: transition || 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear',
            ...indeterminateStyleProps
        };
        const color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
        stackPtg += ptg;
        return /*#__PURE__*/ $ltGt3.createElement("path", {
            key: index,
            className: `${prefixCls}-line-path`,
            d: pathString,
            strokeLinecap: strokeLinecap,
            stroke: color,
            strokeWidth: strokeWidth,
            fillOpacity: "0",
            ref: (elem)=>{
                // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
                // React will call the ref callback with the DOM element when the component mounts,
                // and call it with `null` when it unmounts.
                // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.
                paths[index] = elem;
            },
            style: pathStyle
        });
    }), indeterminateStyleAnimation);
};
var $9d5c47d778c4248c$export$2e2bcd8739ae039 = $9d5c47d778c4248c$var$Line;



var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");

const $3ae16afab935a268$var$Block = ({ bg: bg, children: children })=>/*#__PURE__*/ $ltGt3.createElement("div", {
        style: {
            width: '100%',
            height: '100%',
            background: bg
        }
    }, children);
function $3ae16afab935a268$var$getPtgColors(color, scale) {
    return Object.keys(color).map((key)=>{
        const parsedKey = parseFloat(key);
        const ptgKey = `${Math.floor(parsedKey * scale)}%`;
        return `${color[key]} ${ptgKey}`;
    });
}
const $3ae16afab935a268$var$PtgCircle = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, color: color, gradientId: gradientId, radius: radius, className: className, style: circleStyleForStack, ptg: ptg, strokeLinecap: strokeLinecap, strokeWidth: strokeWidth, size: size, gapDegree: gapDegree } = props;
    const isGradient = color && typeof color === 'object';
    const stroke = isGradient ? `#FFF` : undefined;
    // ========================== Circle ==========================
    const halfSize = size / 2;
    const circleNode = /*#__PURE__*/ $ltGt3.createElement("circle", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-circle-path`, className),
        r: radius,
        cx: halfSize,
        cy: halfSize,
        stroke: stroke,
        strokeLinecap: strokeLinecap,
        strokeWidth: strokeWidth,
        opacity: ptg === 0 ? 0 : 1,
        style: circleStyleForStack,
        ref: ref
    });
    // ========================== Render ==========================
    if (!isGradient) return circleNode;
    const maskId = `${gradientId}-conic`;
    const fromDeg = gapDegree ? `${180 + gapDegree / 2}deg` : '0deg';
    const conicColors = $3ae16afab935a268$var$getPtgColors(color, (360 - gapDegree) / 360);
    const linearColors = $3ae16afab935a268$var$getPtgColors(color, 1);
    const conicColorBg = `conic-gradient(from ${fromDeg}, ${conicColors.join(', ')})`;
    const linearColorBg = `linear-gradient(to ${gapDegree ? 'bottom' : 'top'}, ${linearColors.join(', ')})`;
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement("mask", {
        id: maskId
    }, circleNode), /*#__PURE__*/ $ltGt3.createElement("foreignObject", {
        x: 0,
        y: 0,
        width: size,
        height: size,
        mask: `url(#${maskId})`
    }, /*#__PURE__*/ $ltGt3.createElement($3ae16afab935a268$var$Block, {
        bg: linearColorBg
    }, /*#__PURE__*/ $ltGt3.createElement($3ae16afab935a268$var$Block, {
        bg: conicColorBg
    }))));
});
var $3ae16afab935a268$export$2e2bcd8739ae039 = $3ae16afab935a268$var$PtgCircle;


const $7822cd459ecf1d55$export$b8239b3abadfb141 = 100;
const $7822cd459ecf1d55$export$b0aaf64d8cc0f6db = (perimeter, perimeterWithoutGap, offset, percent, rotateDeg, gapDegree, gapPosition, strokeColor, strokeLinecap, strokeWidth, stepSpace = 0)=>{
    const offsetDeg = offset / 100 * 360 * ((360 - gapDegree) / 360);
    const positionDeg = gapDegree === 0 ? 0 : ({
        bottom: 0,
        top: 180,
        left: 90,
        right: -90
    })[gapPosition];
    let strokeDashoffset = (100 - percent) / 100 * perimeterWithoutGap;
    // Fix percent accuracy when strokeLinecap is round
    // https://github.com/ant-design/ant-design/issues/35009
    if (strokeLinecap === 'round' && percent !== 100) {
        strokeDashoffset += strokeWidth / 2;
        // when percent is small enough (<= 1%), keep smallest value to avoid it's disappearance
        if (strokeDashoffset >= perimeterWithoutGap) strokeDashoffset = perimeterWithoutGap - 0.01;
    }
    const halfSize = $7822cd459ecf1d55$export$b8239b3abadfb141 / 2;
    return {
        stroke: typeof strokeColor === 'string' ? strokeColor : undefined,
        strokeDasharray: `${perimeterWithoutGap}px ${perimeter}`,
        strokeDashoffset: strokeDashoffset + stepSpace,
        transform: `rotate(${rotateDeg + offsetDeg + positionDeg}deg)`,
        transformOrigin: `${halfSize}px ${halfSize}px`,
        transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s',
        fillOpacity: 0
    };
};



var $ltGt3 = parcelRequire("ltGt3");
var $6e03bef1c6050c07$export$2e2bcd8739ae039 = ({ id: id, loading: loading })=>{
    if (!loading) return {
        indeterminateStyleProps: {},
        indeterminateStyleAnimation: null
    };
    const animationName = `${id}-indeterminate-animate`;
    return {
        indeterminateStyleProps: {
            transform: 'rotate(0deg)',
            animation: `${animationName} 1s linear infinite`
        },
        indeterminateStyleAnimation: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("style", null, `@keyframes ${animationName} {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }`)
    };
};


function $e9783ad78872cffb$var$_extends() {
    $e9783ad78872cffb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e9783ad78872cffb$var$_extends.apply(this, arguments);
}
function $e9783ad78872cffb$var$toArray(value) {
    const mergedValue = value ?? [];
    return Array.isArray(mergedValue) ? mergedValue : [
        mergedValue
    ];
}
const $e9783ad78872cffb$var$Circle = (props)=>{
    const { id: id, prefixCls: prefixCls, classNames: classNames = {}, styles: styles = {}, steps: steps, strokeWidth: strokeWidth, railWidth: railWidth, gapDegree: gapDegree = 0, gapPosition: gapPosition, railColor: railColor, strokeLinecap: strokeLinecap, style: style, className: className, strokeColor: strokeColor, percent: percent, loading: loading, ...restProps } = {
        ...(0, $85a1a51d0ad5ffd6$export$9c21a3269931e1e6),
        ...props
    };
    const halfSize = (0, $7822cd459ecf1d55$export$b8239b3abadfb141) / 2;
    const mergedId = (0, $1fb03482b73301f3$export$2e2bcd8739ae039)(id);
    const gradientId = `${mergedId}-gradient`;
    const radius = halfSize - strokeWidth / 2;
    const perimeter = Math.PI * 2 * radius;
    const rotateDeg = gapDegree > 0 ? 90 + gapDegree / 2 : -90;
    const perimeterWithoutGap = perimeter * ((360 - gapDegree) / 360);
    const { count: stepCount, gap: stepGap } = typeof steps === 'object' ? steps : {
        count: steps,
        gap: 2
    };
    const percentList = $e9783ad78872cffb$var$toArray(percent);
    const strokeColorList = $e9783ad78872cffb$var$toArray(strokeColor);
    const gradient = strokeColorList.find((color)=>color && typeof color === 'object');
    const isConicGradient = gradient && typeof gradient === 'object';
    const mergedStrokeLinecap = isConicGradient ? 'butt' : strokeLinecap;
    const { indeterminateStyleProps: indeterminateStyleProps, indeterminateStyleAnimation: indeterminateStyleAnimation } = (0, $6e03bef1c6050c07$export$2e2bcd8739ae039)({
        id: mergedId,
        loading: loading
    });
    const circleStyle = (0, $7822cd459ecf1d55$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, 0, 100, rotateDeg, gapDegree, gapPosition, railColor, mergedStrokeLinecap, strokeWidth);
    const paths = (0, $85a1a51d0ad5ffd6$export$7685006d504ecf0b)();
    const getStokeList = ()=>{
        let stackPtg = 0;
        return percentList.map((ptg, index)=>{
            const color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
            const circleStyleForStack = (0, $7822cd459ecf1d55$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, stackPtg, ptg, rotateDeg, gapDegree, gapPosition, color, mergedStrokeLinecap, strokeWidth);
            stackPtg += ptg;
            return /*#__PURE__*/ $ltGt3.createElement((0, $3ae16afab935a268$export$2e2bcd8739ae039), {
                key: index,
                color: color,
                ptg: ptg,
                radius: radius,
                prefixCls: prefixCls,
                gradientId: gradientId,
                className: classNames.track,
                style: {
                    ...circleStyleForStack,
                    ...indeterminateStyleProps,
                    ...styles.track
                },
                strokeLinecap: mergedStrokeLinecap,
                strokeWidth: strokeWidth,
                gapDegree: gapDegree,
                ref: (elem)=>{
                    // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
                    // React will call the ref callback with the DOM element when the component mounts,
                    // and call it with `null` when it unmounts.
                    // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.
                    paths[index] = elem;
                },
                size: (0, $7822cd459ecf1d55$export$b8239b3abadfb141)
            });
        }).reverse();
    };
    const getStepStokeList = ()=>{
        // only show the first percent when pass steps
        const current = Math.round(stepCount * (percentList[0] / 100));
        const stepPtg = 100 / stepCount;
        let stackPtg = 0;
        return new Array(stepCount).fill(null).map((_, index)=>{
            const color = index <= current - 1 ? strokeColorList[0] : railColor;
            const stroke = color && typeof color === 'object' ? `url(#${gradientId})` : undefined;
            const circleStyleForStack = (0, $7822cd459ecf1d55$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, stackPtg, stepPtg, rotateDeg, gapDegree, gapPosition, color, 'butt', strokeWidth, stepGap);
            stackPtg += (perimeterWithoutGap - circleStyleForStack.strokeDashoffset + stepGap) * 100 / perimeterWithoutGap;
            return /*#__PURE__*/ $ltGt3.createElement("circle", {
                key: index,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-circle-path`, classNames.track),
                r: radius,
                cx: halfSize,
                cy: halfSize,
                stroke: stroke,
                strokeWidth: strokeWidth,
                opacity: 1,
                style: {
                    ...circleStyleForStack,
                    ...styles.track
                },
                ref: (elem)=>{
                    paths[index] = elem;
                }
            });
        });
    };
    return /*#__PURE__*/ $ltGt3.createElement("svg", $e9783ad78872cffb$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-circle`, classNames.root, className),
        viewBox: `0 0 ${(0, $7822cd459ecf1d55$export$b8239b3abadfb141)} ${(0, $7822cd459ecf1d55$export$b8239b3abadfb141)}`,
        style: {
            ...styles.root,
            ...style
        },
        id: id,
        role: "presentation"
    }, restProps), !stepCount && /*#__PURE__*/ $ltGt3.createElement("circle", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-circle-rail`, classNames.rail),
        r: radius,
        cx: halfSize,
        cy: halfSize,
        stroke: railColor,
        strokeLinecap: mergedStrokeLinecap,
        strokeWidth: railWidth || strokeWidth,
        style: {
            ...circleStyle,
            ...styles.rail
        }
    }), stepCount ? getStepStokeList() : getStokeList(), indeterminateStyleAnimation);
};
var $e9783ad78872cffb$export$2e2bcd8739ae039 = $e9783ad78872cffb$var$Circle;









function $8d821d5272772a12$export$2caef35201f951a0(progress) {
    if (!progress || progress < 0) return 0;
    if (progress > 100) return 100;
    return progress;
}
function $8d821d5272772a12$export$4ab1c09ce4ee99b({ success: success }) {
    let percent;
    if (success && 'percent' in success) percent = success.percent;
    return percent;
}
const $8d821d5272772a12$export$6712e0f6cd0ea03 = ({ percent: percent, success: success })=>{
    const realSuccessPercent = $8d821d5272772a12$export$2caef35201f951a0($8d821d5272772a12$export$4ab1c09ce4ee99b({
        success: success
    }));
    return [
        realSuccessPercent,
        $8d821d5272772a12$export$2caef35201f951a0($8d821d5272772a12$export$2caef35201f951a0(percent) - realSuccessPercent)
    ];
};
const $8d821d5272772a12$export$a73db48ef11a2bc3 = ({ success: success = {}, strokeColor: strokeColor })=>{
    const { strokeColor: successColor } = success;
    return [
        successColor || (0, $1bd835bbb2d9f8c1$export$3968a3afc810b5f5).green,
        strokeColor || null
    ];
};
const $8d821d5272772a12$export$31b21d0167753bb4 = (size, type, extra)=>{
    let width = -1;
    let height = -1;
    if (type === 'step') {
        const steps = extra.steps;
        const strokeWidth = extra.strokeWidth;
        if (typeof size === 'string' || typeof size === 'undefined') {
            width = size === 'small' ? 2 : 14;
            height = strokeWidth ?? 8;
        } else if (typeof size === 'number') [width, height] = [
            size,
            size
        ];
        else [width = 14, height = 8] = Array.isArray(size) ? size : [
            size.width,
            size.height
        ];
        width *= steps;
    } else if (type === 'line') {
        const strokeWidth = extra?.strokeWidth;
        if (typeof size === 'string' || typeof size === 'undefined') height = strokeWidth || (size === 'small' ? 6 : 8);
        else if (typeof size === 'number') [width, height] = [
            size,
            size
        ];
        else [width = -1, height = 8] = Array.isArray(size) ? size : [
            size.width,
            size.height
        ];
    } else if (type === 'circle' || type === 'dashboard') {
        if (typeof size === 'string' || typeof size === 'undefined') [width, height] = size === 'small' ? [
            60,
            60
        ] : [
            120,
            120
        ];
        else if (typeof size === 'number') [width, height] = [
            size,
            size
        ];
        else if (Array.isArray(size)) {
            width = size[0] ?? size[1] ?? 120;
            height = size[0] ?? size[1] ?? 120;
        }
    }
    return [
        width,
        height
    ];
};


"use client";
const $625fec60274ea83a$var$CIRCLE_MIN_STROKE_WIDTH = 3;
const $625fec60274ea83a$var$getMinPercent = (width)=>$625fec60274ea83a$var$CIRCLE_MIN_STROKE_WIDTH / width * 100;
const $625fec60274ea83a$var$OMIT_SEMANTIC_NAMES = [
    'root',
    'body',
    'indicator'
];
const $625fec60274ea83a$var$Circle = (props)=>{
    const { prefixCls: prefixCls, classNames: classNames, styles: styles, railColor: railColor, trailColor: trailColor, strokeLinecap: strokeLinecap = 'round', gapPosition: gapPosition, gapPlacement: gapPlacement, gapDegree: gapDegree, width: originWidth = 120, type: type, children: children, success: success, size: size = originWidth, steps: steps } = props;
    const { direction: direction } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('progress');
    const mergedRailColor = railColor ?? trailColor;
    const [width, height] = (0, $8d821d5272772a12$export$31b21d0167753bb4)(size, 'circle');
    let { strokeWidth: strokeWidth } = props;
    if (strokeWidth === undefined) strokeWidth = Math.max($625fec60274ea83a$var$getMinPercent(width), 6);
    const circleStyle = {
        width: width,
        height: height,
        fontSize: width * 0.15 + 6
    };
    const realGapDegree = $ltGt3.useMemo(()=>{
        // Support gapDeg = 0 when type = 'dashboard'
        if (gapDegree || gapDegree === 0) return gapDegree;
        if (type === 'dashboard') return 75;
        return undefined;
    }, [
        gapDegree,
        type
    ]);
    const percentArray = (0, $8d821d5272772a12$export$6712e0f6cd0ea03)(props);
    const gapPos = $ltGt3.useMemo(()=>{
        const mergedPlacement = (gapPlacement ?? gapPosition) || type === 'dashboard' && 'bottom' || undefined;
        const isRTL = direction === 'rtl';
        switch(mergedPlacement){
            case 'start':
                return isRTL ? 'right' : 'left';
            case 'end':
                return isRTL ? 'left' : 'right';
            default:
                return mergedPlacement;
        }
    }, [
        direction,
        gapPlacement,
        gapPosition,
        type
    ]);
    // using className to style stroke color
    const isGradient = Object.prototype.toString.call(props.strokeColor) === '[object Object]';
    const strokeColor = (0, $8d821d5272772a12$export$a73db48ef11a2bc3)({
        success: success,
        strokeColor: props.strokeColor
    });
    const wrapperClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-body`, {
        [`${prefixCls}-circle-gradient`]: isGradient
    }, classNames.body);
    const circleContent = /*#__PURE__*/ $ltGt3.createElement((0, $e9783ad78872cffb$export$2e2bcd8739ae039), {
        steps: steps,
        percent: steps ? percentArray[1] : percentArray,
        strokeWidth: strokeWidth,
        railWidth: strokeWidth,
        strokeColor: steps ? strokeColor[1] : strokeColor,
        strokeLinecap: strokeLinecap,
        railColor: mergedRailColor,
        prefixCls: prefixCls,
        gapDegree: realGapDegree,
        gapPosition: gapPos,
        classNames: (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(classNames, $625fec60274ea83a$var$OMIT_SEMANTIC_NAMES),
        styles: (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(styles, $625fec60274ea83a$var$OMIT_SEMANTIC_NAMES)
    });
    const smallCircle = width <= 20;
    const node = /*#__PURE__*/ $ltGt3.createElement("div", {
        className: wrapperClassName,
        style: {
            ...circleStyle,
            ...styles.body
        }
    }, circleContent, !smallCircle && children);
    if (smallCircle) return /*#__PURE__*/ $ltGt3.createElement((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
        title: children
    }, node);
    return node;
};
var $625fec60274ea83a$export$2e2bcd8739ae039 = $625fec60274ea83a$var$Circle;



var $ltGt3 = parcelRequire("ltGt3");






const $a03fe1bc94f585ae$export$ce7447cfda329128 = '--progress-line-stroke-color';
const $a03fe1bc94f585ae$var$genAntProgressActive = (isRtl)=>{
    const direction = isRtl ? '100%' : '-100%';
    return new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)(`antProgress${isRtl ? 'RTL' : 'LTR'}Active`, {
        '0%': {
            transform: `translateX(${direction}) scaleX(0)`,
            opacity: 0.1
        },
        '20%': {
            transform: `translateX(${direction}) scaleX(0)`,
            opacity: 0.5
        },
        to: {
            transform: 'translateX(0) scaleX(1)',
            opacity: 0
        }
    });
};
// ====================================================================
// ==                              Base                              ==
// ====================================================================
const $a03fe1bc94f585ae$var$genBaseStyle = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [progressCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            display: 'inline-flex',
            '&-rtl': {
                direction: 'rtl'
            },
            [`${progressCls}-indicator`]: {
                color: token.colorText,
                lineHeight: 1,
                whiteSpace: 'nowrap',
                verticalAlign: 'middle',
                wordBreak: 'normal',
                [iconPrefixCls]: {
                    fontSize: token.fontSize
                }
            },
            [`&${progressCls}-status-exception`]: {
                [`${progressCls}-indicator`]: {
                    color: token.colorError
                }
            },
            [`&${progressCls}-status-success`]: {
                [`${progressCls}-indicator`]: {
                    color: token.colorSuccess
                }
            }
        }
    };
};
// ====================================================================
// ==                              Line                              ==
// ====================================================================
const $a03fe1bc94f585ae$var$genLineStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-line`]: {
            position: 'relative',
            width: '100%',
            fontSize: token.fontSize,
            [`${componentCls}-body`]: {
                display: 'inline-flex',
                alignItems: 'center',
                width: '100%',
                gap: token.marginXS
            },
            [`${componentCls}-rail`]: {
                flex: 'auto',
                background: token.remainingColor,
                borderRadius: token.lineBorderRadius,
                position: 'relative',
                width: '100%'
            },
            [`&${componentCls}-status-active`]: {
                [`${componentCls}-track:after`]: {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: token.colorBgContainer,
                    borderRadius: 'inherit',
                    opacity: 0,
                    animationName: $a03fe1bc94f585ae$var$genAntProgressActive(),
                    animationDuration: token.progressActiveMotionDuration,
                    animationTimingFunction: token.motionEaseOutQuint,
                    animationIterationCount: 'infinite'
                }
            },
            [`${componentCls}-track`]: {
                position: 'absolute',
                insetInlineStart: 0,
                insetBlock: 0,
                borderRadius: 'inherit',
                background: token.defaultColor,
                transition: `all ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
                minWidth: 'max-content',
                display: 'flex',
                alignItems: 'center',
                '&-success': {
                    background: token.colorSuccess
                }
            },
            [`&${componentCls}-status-exception`]: {
                [`${componentCls}-track`]: {
                    background: token.colorError
                }
            },
            [`&${componentCls}-status-success`]: {
                [`${componentCls}-track`]: {
                    background: token.colorSuccess
                }
            },
            // >>>>> indicator
            // >>> Outer
            [`${componentCls}-indicator-outer`]: {
                [`&${componentCls}-indicator-start`]: {
                    order: -1
                }
            },
            [`${componentCls}-body-layout-bottom`]: {
                flexDirection: 'column',
                alignItems: 'center',
                gap: token.marginXXS
            },
            // >>> Inner
            [`${componentCls}-indicator${componentCls}-indicator-inner`]: {
                color: token.colorWhite,
                paddingInline: token.paddingXXS,
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                [`&${componentCls}-indicator-end`]: {
                    justifyContent: 'end'
                },
                [`&${componentCls}-indicator-start`]: {
                    justifyContent: 'start'
                },
                [`&${componentCls}-indicator-bright`]: {
                    color: 'rgba(0, 0, 0, 0.45)'
                }
            }
        }
    };
};
// ====================================================================
// ==                             Circle                             ==
// ====================================================================
const $a03fe1bc94f585ae$var$genCircleStyle = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [`${progressCls}-circle`]: {
            [`${progressCls}-circle-rail`]: {
                stroke: token.remainingColor
            },
            [`${progressCls}-body:not(${progressCls}-circle-gradient)`]: {
                [`${progressCls}-circle-path`]: {
                    stroke: token.defaultColor
                }
            },
            [`${progressCls}-body`]: {
                position: 'relative',
                lineHeight: 1,
                backgroundColor: 'transparent'
            },
            [`${progressCls}-indicator`]: {
                position: 'absolute',
                insetBlockStart: '50%',
                insetInlineStart: 0,
                width: '100%',
                margin: 0,
                padding: 0,
                color: token.circleTextColor,
                fontSize: token.circleTextFontSize,
                lineHeight: 1,
                whiteSpace: 'normal',
                textAlign: 'center',
                transform: 'translateY(-50%)',
                [iconPrefixCls]: {
                    fontSize: token.circleIconFontSize
                }
            },
            [`&${progressCls}-status-exception`]: {
                [`${progressCls}-body:not(${progressCls}-circle-gradient)`]: {
                    [`${progressCls}-circle-path`]: {
                        stroke: token.colorError
                    }
                }
            },
            [`&${progressCls}-status-success`]: {
                [`${progressCls}-body:not(${progressCls}-circle-gradient)`]: {
                    [`${progressCls}-circle-path`]: {
                        stroke: token.colorSuccess
                    }
                }
            }
        },
        [`${progressCls}-inline-circle`]: {
            lineHeight: 1,
            [`${progressCls}-inner`]: {
                verticalAlign: 'bottom'
            }
        }
    };
};
// ====================================================================
// ==                              Step                              ==
// ====================================================================
const $a03fe1bc94f585ae$var$genStepStyle = (token)=>{
    const { componentCls: progressCls } = token;
    return {
        [progressCls]: {
            [`${progressCls}-steps`]: {
                display: 'inline-block',
                '&-body': {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: token.progressStepMarginInlineEnd,
                    [`${progressCls}-indicator`]: {
                        marginInlineStart: token.marginXS
                    }
                },
                '&-item': {
                    flexShrink: 0,
                    minWidth: token.progressStepMinWidth,
                    backgroundColor: token.remainingColor,
                    transition: `all ${token.motionDurationSlow}`,
                    '&-active': {
                        backgroundColor: token.defaultColor
                    }
                }
            }
        }
    };
};
// ====================================================================
// ==                           Small Line                           ==
// ====================================================================
const $a03fe1bc94f585ae$var$genSmallLine = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [progressCls]: {
            [`${progressCls}-small&-line, ${progressCls}-small&-line ${progressCls}-indicator ${iconPrefixCls}`]: {
                fontSize: token.fontSizeSM
            }
        }
    };
};
const $a03fe1bc94f585ae$export$9ca1be8807fe0675 = (token)=>({
        circleTextColor: token.colorText,
        defaultColor: token.colorInfo,
        remainingColor: token.colorFillSecondary,
        lineBorderRadius: 100,
        // magic for capsule shape, should be a very large number
        circleTextFontSize: '1em',
        circleIconFontSize: `${token.fontSize / token.fontSizeSM}em`
    });
var $a03fe1bc94f585ae$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Progress', (token)=>{
    const progressStepMarginInlineEnd = token.calc(token.marginXXS).div(2).equal();
    const progressToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        progressStepMarginInlineEnd: progressStepMarginInlineEnd,
        progressStepMinWidth: progressStepMarginInlineEnd,
        progressActiveMotionDuration: '2.4s'
    });
    return [
        $a03fe1bc94f585ae$var$genBaseStyle(progressToken),
        $a03fe1bc94f585ae$var$genLineStyle(progressToken),
        $a03fe1bc94f585ae$var$genCircleStyle(progressToken),
        $a03fe1bc94f585ae$var$genStepStyle(progressToken),
        $a03fe1bc94f585ae$var$genSmallLine(progressToken)
    ];
}, $a03fe1bc94f585ae$export$9ca1be8807fe0675);



"use client";
const $fabd604ab74b0d44$export$8947b167cf78cbe = (gradients)=>{
    let tempArr = [];
    Object.keys(gradients).forEach((key)=>{
        const formattedKey = Number.parseFloat(key.replace(/%/g, ''));
        if (!Number.isNaN(formattedKey)) tempArr.push({
            key: formattedKey,
            value: gradients[key]
        });
    });
    tempArr = tempArr.sort((a, b)=>a.key - b.key);
    return tempArr.map(({ key: key, value: value })=>`${value} ${key}%`).join(', ');
};
const $fabd604ab74b0d44$export$22b6122229807a9f = (strokeColor, directionConfig)=>{
    const { from: from = (0, $1bd835bbb2d9f8c1$export$3968a3afc810b5f5).blue, to: to = (0, $1bd835bbb2d9f8c1$export$3968a3afc810b5f5).blue, direction: direction = directionConfig === 'rtl' ? 'to left' : 'to right', ...rest } = strokeColor;
    if (Object.keys(rest).length !== 0) {
        const sortedGradients = $fabd604ab74b0d44$export$8947b167cf78cbe(rest);
        const background = `linear-gradient(${direction}, ${sortedGradients})`;
        return {
            background: background,
            [(0, $a03fe1bc94f585ae$export$ce7447cfda329128)]: background
        };
    }
    const background = `linear-gradient(${direction}, ${from}, ${to})`;
    return {
        background: background,
        [(0, $a03fe1bc94f585ae$export$ce7447cfda329128)]: background
    };
};
const $fabd604ab74b0d44$var$Line = (props)=>{
    const { prefixCls: prefixCls, classNames: classNames, styles: styles, direction: directionConfig, percent: percent, size: size, strokeWidth: strokeWidth, strokeColor: strokeColor, strokeLinecap: strokeLinecap = 'round', children: children, railColor: railColor, trailColor: trailColor, percentPosition: percentPosition, success: success } = props;
    const { align: infoAlign, type: infoPosition } = percentPosition;
    const mergedRailColor = railColor ?? trailColor;
    const borderRadius = strokeLinecap === 'square' || strokeLinecap === 'butt' ? 0 : undefined;
    // ========================= Size =========================
    const mergedSize = size ?? [
        -1,
        strokeWidth || (size === 'small' ? 6 : 8)
    ];
    const [width, height] = (0, $8d821d5272772a12$export$31b21d0167753bb4)(mergedSize, 'line', {
        strokeWidth: strokeWidth
    });
    // ========================= Rail =========================
    const railStyle = {
        backgroundColor: mergedRailColor || undefined,
        borderRadius: borderRadius,
        height: height
    };
    // ======================== Tracks ========================
    const trackCls = `${prefixCls}-track`;
    const backgroundProps = strokeColor && typeof strokeColor !== 'string' ? $fabd604ab74b0d44$export$22b6122229807a9f(strokeColor, directionConfig) : {
        [(0, $a03fe1bc94f585ae$export$ce7447cfda329128)]: strokeColor,
        background: strokeColor
    };
    const percentTrackStyle = {
        width: `${(0, $8d821d5272772a12$export$2caef35201f951a0)(percent)}%`,
        height: height,
        borderRadius: borderRadius,
        ...backgroundProps
    };
    const successPercent = (0, $8d821d5272772a12$export$4ab1c09ce4ee99b)(props);
    const successTrackStyle = {
        width: `${(0, $8d821d5272772a12$export$2caef35201f951a0)(successPercent)}%`,
        height: height,
        borderRadius: borderRadius,
        backgroundColor: success?.strokeColor
    };
    // ======================== Render ========================
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-body`, classNames.body, {
            [`${prefixCls}-body-layout-bottom`]: infoAlign === 'center' && infoPosition === 'outer'
        }),
        style: {
            width: width > 0 ? width : '100%',
            ...styles.body
        }
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-rail`, classNames.rail),
        style: {
            ...railStyle,
            ...styles.rail
        }
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(trackCls, classNames.track),
        style: {
            ...percentTrackStyle,
            ...styles.track
        }
    }, infoPosition === 'inner' && children), successPercent !== undefined && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(trackCls, `${trackCls}-success`, classNames.track),
        style: {
            ...successTrackStyle,
            ...styles.track
        }
    })), infoPosition === 'outer' && children);
};
var $fabd604ab74b0d44$export$2e2bcd8739ae039 = $fabd604ab74b0d44$var$Line;



var $ltGt3 = parcelRequire("ltGt3");


"use client";
const $6b530e4bf261a3fe$var$Steps = (props)=>{
    const { classNames: classNames, styles: styles, size: size, steps: steps, rounding: customRounding = Math.round, percent: percent = 0, strokeWidth: strokeWidth = 8, strokeColor: strokeColor, railColor: railColor, trailColor: trailColor, prefixCls: prefixCls, children: children } = props;
    const current = customRounding(steps * (percent / 100));
    const stepWidth = size === 'small' ? 2 : 14;
    const mergedSize = size ?? [
        stepWidth,
        strokeWidth
    ];
    const [width, height] = (0, $8d821d5272772a12$export$31b21d0167753bb4)(mergedSize, 'step', {
        steps: steps,
        strokeWidth: strokeWidth
    });
    const unitWidth = width / steps;
    const styledSteps = Array.from({
        length: steps
    });
    const mergedRailColor = railColor ?? trailColor;
    for(let i = 0; i < steps; i++){
        const color = Array.isArray(strokeColor) ? strokeColor[i] : strokeColor;
        styledSteps[i] = /*#__PURE__*/ $ltGt3.createElement("div", {
            key: i,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-steps-item`, {
                [`${prefixCls}-steps-item-active`]: i <= current - 1
            }, classNames.track),
            style: {
                backgroundColor: i <= current - 1 ? color : mergedRailColor,
                width: unitWidth,
                height: height,
                ...styles.track
            }
        });
    }
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-steps-body`, classNames.body),
        style: styles.body
    }, styledSteps, children);
};
var $6b530e4bf261a3fe$export$2e2bcd8739ae039 = $6b530e4bf261a3fe$var$Steps;




"use client";
const $1a8900927142e57f$export$e54ebc7fe4b5dc4e = [
    'line',
    'circle',
    'dashboard'
];
const $1a8900927142e57f$var$ProgressStatuses = [
    'normal',
    'exception',
    'active',
    'success'
];
const $1a8900927142e57f$var$Progress = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, classNames: classNames, styles: styles, steps: steps, strokeColor: strokeColor, percent: percent = 0, size: size = 'default', showInfo: showInfo = true, type: type = 'line', status: status, format: format, style: style, percentPosition: percentPosition = {}, ...restProps } = props;
    // ========================= MISC =========================
    const { align: infoAlign = 'end', type: infoPosition = 'outer' } = percentPosition;
    const strokeColorNotArray = Array.isArray(strokeColor) ? strokeColor[0] : strokeColor;
    const strokeColorNotGradient = typeof strokeColor === 'string' || Array.isArray(strokeColor) ? strokeColor : undefined;
    const strokeColorIsBright = $ltGt3.useMemo(()=>{
        if (strokeColorNotArray) {
            const color = typeof strokeColorNotArray === 'string' ? strokeColorNotArray : Object.values(strokeColorNotArray)[0];
            return new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(color).isLight();
        }
        return false;
    }, [
        strokeColor
    ]);
    const percentNumber = $ltGt3.useMemo(()=>{
        const successPercent = (0, $8d821d5272772a12$export$4ab1c09ce4ee99b)(props);
        return Number.parseInt(successPercent !== undefined ? (successPercent ?? 0)?.toString() : (percent ?? 0)?.toString(), 10);
    }, [
        percent,
        props.success
    ]);
    const progressStatus = $ltGt3.useMemo(()=>{
        if (!$1a8900927142e57f$var$ProgressStatuses.includes(status) && percentNumber >= 100) return 'success';
        return status || 'normal';
    }, [
        status,
        percentNumber
    ]);
    // ======================= Context ========================
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('progress');
    const prefixCls = getPrefixCls('progress', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $a03fe1bc94f585ae$export$2e2bcd8739ae039)(prefixCls);
    const mergedProps = {
        ...props,
        percent: percent,
        type: type,
        size: size,
        showInfo: showInfo,
        percentPosition: percentPosition
    };
    // ======================== Styles ========================
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ========================= Info =========================
    const isLineType = type === 'line';
    const isPureLineType = isLineType && !steps;
    const progressInfo = $ltGt3.useMemo(()=>{
        if (!showInfo) return null;
        const successPercent = (0, $8d821d5272772a12$export$4ab1c09ce4ee99b)(props);
        let text;
        const textFormatter = format || ((number)=>`${number}%`);
        const isBrightInnerColor = isLineType && strokeColorIsBright && infoPosition === 'inner';
        if (infoPosition === 'inner' || format || progressStatus !== 'exception' && progressStatus !== 'success') text = textFormatter((0, $8d821d5272772a12$export$2caef35201f951a0)(percent), (0, $8d821d5272772a12$export$2caef35201f951a0)(successPercent));
        else if (progressStatus === 'exception') text = isLineType ? /*#__PURE__*/ $ltGt3.createElement((0, $332936b0d9ac1f65$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), null);
        else if (progressStatus === 'success') text = isLineType ? /*#__PURE__*/ $ltGt3.createElement((0, $0cb9ffcfb49f2ccf$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $69caf2b39a25e974$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ $ltGt3.createElement("span", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-indicator`, {
                [`${prefixCls}-indicator-bright`]: isBrightInnerColor,
                [`${prefixCls}-indicator-${infoAlign}`]: isPureLineType,
                [`${prefixCls}-indicator-${infoPosition}`]: isPureLineType
            }, mergedClassNames.indicator),
            style: mergedStyles.indicator,
            title: typeof text === 'string' ? text : undefined
        }, text);
    }, [
        showInfo,
        percent,
        percentNumber,
        progressStatus,
        type,
        prefixCls,
        format,
        isLineType,
        strokeColorIsBright,
        infoPosition,
        infoAlign,
        isPureLineType,
        mergedClassNames.indicator,
        mergedStyles.indicator
    ]);
    var deprecatedName, newName;
    // ======================== Render ========================
    const sharedProps = {
        ...props,
        classNames: mergedClassNames,
        styles: mergedStyles
    };
    let progress;
    // Render progress shape
    if (type === 'line') progress = steps ? /*#__PURE__*/ $ltGt3.createElement((0, $6b530e4bf261a3fe$export$2e2bcd8739ae039), {
        ...sharedProps,
        strokeColor: strokeColorNotGradient,
        prefixCls: prefixCls,
        steps: typeof steps === 'object' ? steps.count : steps
    }, progressInfo) : /*#__PURE__*/ $ltGt3.createElement((0, $fabd604ab74b0d44$export$2e2bcd8739ae039), {
        ...sharedProps,
        strokeColor: strokeColorNotArray,
        prefixCls: prefixCls,
        direction: direction,
        percentPosition: {
            align: infoAlign,
            type: infoPosition
        }
    }, progressInfo);
    else if (type === 'circle' || type === 'dashboard') progress = /*#__PURE__*/ $ltGt3.createElement((0, $625fec60274ea83a$export$2e2bcd8739ae039), {
        ...sharedProps,
        strokeColor: strokeColorNotArray,
        prefixCls: prefixCls,
        progressStatus: progressStatus
    }, progressInfo);
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-status-${progressStatus}`, {
        [`${prefixCls}-${type === 'dashboard' && 'circle' || type}`]: type !== 'line',
        [`${prefixCls}-inline-circle`]: type === 'circle' && (0, $8d821d5272772a12$export$31b21d0167753bb4)(size, 'circle')[0] <= 20,
        [`${prefixCls}-line`]: isPureLineType,
        [`${prefixCls}-line-align-${infoAlign}`]: isPureLineType,
        [`${prefixCls}-line-position-${infoPosition}`]: isPureLineType,
        [`${prefixCls}-steps`]: steps,
        [`${prefixCls}-show-info`]: showInfo,
        [`${prefixCls}-${size}`]: typeof size === 'string',
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: ref,
        style: {
            ...contextStyle,
            ...mergedStyles.root,
            ...style
        },
        className: classString,
        role: "progressbar",
        "aria-valuenow": percentNumber,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        ...(0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(restProps, [
            'railColor',
            'trailColor',
            'strokeWidth',
            'width',
            'gapDegree',
            'gapPosition',
            'gapPlacement',
            'strokeLinecap',
            'success'
        ])
    }, progress);
});
var $1a8900927142e57f$export$2e2bcd8739ae039 = $1a8900927142e57f$var$Progress;


"use client";
var $48a750ce6bff98b0$export$2e2bcd8739ae039 = (0, $1a8900927142e57f$export$2e2bcd8739ae039);



"use client";
const $692de4b15c67e59d$var$ListItem = /*#__PURE__*/ $ltGt3.forwardRef(({ prefixCls: prefixCls, className: className, style: style, classNames: itemClassNames, styles: styles, locale: locale, listType: listType, file: file, items: items, progress: progressProps, iconRender: iconRender, actionIconRender: actionIconRender, itemRender: itemRender, isImgUrl: isImgUrl, showPreviewIcon: showPreviewIcon, showRemoveIcon: showRemoveIcon, showDownloadIcon: showDownloadIcon, previewIcon: customPreviewIcon, removeIcon: customRemoveIcon, downloadIcon: customDownloadIcon, extra: customExtra, onPreview: onPreview, onDownload: onDownload, onClose: onClose }, ref)=>{
    // Status: which will ignore `removed` status
    const { status: status } = file;
    const [mergedStatus, setMergedStatus] = $ltGt3.useState(status);
    $ltGt3.useEffect(()=>{
        if (status !== 'removed') setMergedStatus(status);
    }, [
        status
    ]);
    // Delay to show the progress bar
    const [showProgress, setShowProgress] = $ltGt3.useState(false);
    $ltGt3.useEffect(()=>{
        const timer = setTimeout(()=>{
            setShowProgress(true);
        }, 300);
        return ()=>{
            clearTimeout(timer);
        };
    }, []);
    const iconNode = iconRender(file);
    let icon = /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-icon`
    }, iconNode);
    if (listType === 'picture' || listType === 'picture-card' || listType === 'picture-circle') {
        if (mergedStatus === 'uploading' || !file.thumbUrl && !file.url) {
            const uploadingClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-thumbnail`, {
                [`${prefixCls}-list-item-file`]: mergedStatus !== 'uploading'
            });
            icon = /*#__PURE__*/ $ltGt3.createElement("div", {
                className: uploadingClassName
            }, iconNode);
        } else {
            const thumbnail = isImgUrl?.(file) ? /*#__PURE__*/ $ltGt3.createElement("img", {
                src: file.thumbUrl || file.url,
                alt: file.name,
                className: `${prefixCls}-list-item-image`,
                crossOrigin: file.crossOrigin
            }) : iconNode;
            const aClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-thumbnail`, {
                [`${prefixCls}-list-item-file`]: isImgUrl && !isImgUrl(file)
            });
            icon = /*#__PURE__*/ $ltGt3.createElement("a", {
                className: aClassName,
                onClick: (e)=>onPreview(file, e),
                href: file.url || file.thumbUrl,
                target: "_blank",
                rel: "noopener noreferrer"
            }, thumbnail);
        }
    }
    const listItemClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-list-item`, `${prefixCls}-list-item-${mergedStatus}`, itemClassNames?.item);
    const linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
    const removeIcon = (typeof showRemoveIcon === 'function' ? showRemoveIcon(file) : showRemoveIcon) ? actionIconRender((typeof customRemoveIcon === 'function' ? customRemoveIcon(file) : customRemoveIcon) || /*#__PURE__*/ $ltGt3.createElement((0, $d924582d8f73e28a$export$2e2bcd8739ae039), null), ()=>onClose(file), prefixCls, locale.removeFile, // acceptUploadDisabled is true, only remove icon will follow Upload disabled prop
    // https://github.com/ant-design/ant-design/issues/46171
    true) : null;
    const downloadIcon = (typeof showDownloadIcon === 'function' ? showDownloadIcon(file) : showDownloadIcon) && mergedStatus === 'done' ? actionIconRender((typeof customDownloadIcon === 'function' ? customDownloadIcon(file) : customDownloadIcon) || /*#__PURE__*/ $ltGt3.createElement((0, $b8d15d60eb12302d$export$2e2bcd8739ae039), null), ()=>onDownload(file), prefixCls, locale.downloadFile) : null;
    const downloadOrDelete = listType !== 'picture-card' && listType !== 'picture-circle' && /*#__PURE__*/ $ltGt3.createElement("span", {
        key: "download-delete",
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-actions`, {
            picture: listType === 'picture'
        })
    }, downloadIcon, removeIcon);
    const extraContent = typeof customExtra === 'function' ? customExtra(file) : customExtra;
    const extra = extraContent && /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-list-item-extra`
    }, extraContent);
    const listItemNameClass = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-name`);
    const fileName = file.url ? /*#__PURE__*/ $ltGt3.createElement("a", {
        key: "view",
        target: "_blank",
        rel: "noopener noreferrer",
        className: listItemNameClass,
        title: file.name,
        ...linkProps,
        href: file.url,
        onClick: (e)=>onPreview(file, e)
    }, file.name, extra) : /*#__PURE__*/ $ltGt3.createElement("span", {
        key: "view",
        className: listItemNameClass,
        onClick: (e)=>onPreview(file, e),
        title: file.name
    }, file.name, extra);
    const previewIcon = (typeof showPreviewIcon === 'function' ? showPreviewIcon(file) : showPreviewIcon) && (file.url || file.thumbUrl) ? /*#__PURE__*/ $ltGt3.createElement("a", {
        href: file.url || file.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: (e)=>onPreview(file, e),
        title: locale.previewFile
    }, typeof customPreviewIcon === 'function' ? customPreviewIcon(file) : customPreviewIcon || /*#__PURE__*/ $ltGt3.createElement((0, $a9c157c452686d79$export$2e2bcd8739ae039), null)) : null;
    const pictureCardActions = (listType === 'picture-card' || listType === 'picture-circle') && mergedStatus !== 'uploading' && /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-list-item-actions`
    }, previewIcon, mergedStatus === 'done' && downloadIcon, removeIcon);
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const dom = /*#__PURE__*/ $ltGt3.createElement("div", {
        className: listItemClassName,
        style: styles?.item
    }, icon, fileName, downloadOrDelete, pictureCardActions, showProgress && /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), {
        motionName: `${rootPrefixCls}-fade`,
        visible: mergedStatus === 'uploading',
        motionDeadline: 2000
    }, ({ className: motionClassName })=>{
        // show loading icon if upload progress listener is disabled
        const loadingProgress = 'percent' in file ? /*#__PURE__*/ $ltGt3.createElement((0, $48a750ce6bff98b0$export$2e2bcd8739ae039), {
            type: "line",
            percent: file.percent,
            "aria-label": file['aria-label'],
            "aria-labelledby": file['aria-labelledby'],
            ...progressProps
        }) : null;
        return /*#__PURE__*/ $ltGt3.createElement("div", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-progress`, motionClassName)
        }, loadingProgress);
    }));
    const message = file.response && typeof file.response === 'string' ? file.response : file.error?.statusText || file.error?.message || locale.uploadError;
    const item = mergedStatus === 'error' ? /*#__PURE__*/ $ltGt3.createElement((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
        title: message,
        getPopupContainer: (node)=>node.parentNode
    }, dom) : dom;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-container`, className),
        style: style,
        ref: ref
    }, itemRender ? itemRender(item, file, items, {
        download: onDownload.bind(null, file),
        preview: onPreview.bind(null, file),
        remove: onClose.bind(null, file)
    }) : item);
});
var $692de4b15c67e59d$export$2e2bcd8739ae039 = $692de4b15c67e59d$var$ListItem;


"use client";
const $4a4a37c948810c20$var$InternalUploadList = (props, ref)=>{
    const { listType: listType = 'text', previewFile: previewFile = (0, $4ed4e55488d43d6a$export$b5db251096956c0d), onPreview: onPreview, onDownload: onDownload, onRemove: onRemove, locale: locale, iconRender: iconRender, isImageUrl: isImgUrl = (0, $4ed4e55488d43d6a$export$431d13c2db3f6781), prefixCls: customizePrefixCls, items: items = [], showPreviewIcon: showPreviewIcon = true, showRemoveIcon: showRemoveIcon = true, showDownloadIcon: showDownloadIcon = false, removeIcon: removeIcon, previewIcon: previewIcon, downloadIcon: downloadIcon, extra: extra, progress: progress = {
        size: [
            -1,
            2
        ],
        showInfo: false
    }, appendAction: appendAction, appendActionVisible: appendActionVisible = true, itemRender: itemRender, disabled: disabled, classNames: uploadListClassNames, styles: styles } = props;
    const [, forceUpdate] = (0, $a4dbd33868ca5b2a$export$91db9bc4f8ac944a)();
    const [motionAppear, setMotionAppear] = $ltGt3.useState(false);
    const isPictureCardOrCirle = [
        'picture-card',
        'picture-circle'
    ].includes(listType);
    // ============================= Effect =============================
    $ltGt3.useEffect(()=>{
        if (!listType.startsWith('picture')) return;
        (items || []).forEach((file)=>{
            if (!(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) return;
            file.thumbUrl = '';
            previewFile?.(file.originFileObj).then((previewDataUrl)=>{
                // Need append '' to avoid dead loop
                file.thumbUrl = previewDataUrl || '';
                forceUpdate();
            });
        });
    }, [
        listType,
        items,
        previewFile
    ]);
    $ltGt3.useEffect(()=>{
        setMotionAppear(true);
    }, []);
    // ============================= Events =============================
    const onInternalPreview = (file, e)=>{
        if (!onPreview) return;
        e?.preventDefault();
        return onPreview(file);
    };
    const onInternalDownload = (file)=>{
        if (typeof onDownload === 'function') onDownload(file);
        else if (file.url) window.open(file.url);
    };
    const onInternalClose = (file)=>{
        onRemove?.(file);
    };
    const internalIconRender = (file)=>{
        if (iconRender) return iconRender(file, listType);
        const isLoading = file.status === 'uploading';
        if (listType.startsWith('picture')) {
            const loadingIcon = listType === 'picture' ? /*#__PURE__*/ $ltGt3.createElement((0, $8ede40f9e9e4f5c2$export$2e2bcd8739ae039), null) : locale.uploading;
            const fileIcon = isImgUrl?.(file) ? /*#__PURE__*/ $ltGt3.createElement((0, $8fd2111afa7cc48a$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $7656787a205f5290$export$2e2bcd8739ae039), null);
            return isLoading ? loadingIcon : fileIcon;
        }
        return isLoading ? /*#__PURE__*/ $ltGt3.createElement((0, $8ede40f9e9e4f5c2$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $a966100085b287e7$export$2e2bcd8739ae039), null);
    };
    const actionIconRender = (customIcon, callback, prefixCls, title, acceptUploadDisabled)=>{
        const btnProps = {
            type: 'text',
            size: 'small',
            title: title,
            onClick: (e)=>{
                callback();
                if (/*#__PURE__*/ $ltGt3.isValidElement(customIcon)) customIcon.props.onClick?.(e);
            },
            className: `${prefixCls}-list-item-action`,
            disabled: acceptUploadDisabled ? disabled : false
        };
        return /*#__PURE__*/ $ltGt3.isValidElement(customIcon) ? /*#__PURE__*/ $ltGt3.createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
            ...btnProps,
            icon: (0, $66d38239e1a27993$export$e530037191fcd5d7)(customIcon, {
                ...customIcon.props,
                onClick: ()=>{}
            })
        }) : /*#__PURE__*/ $ltGt3.createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
            ...btnProps
        }, /*#__PURE__*/ $ltGt3.createElement("span", null, customIcon));
    };
    // ============================== Ref ===============================
    // Test needs
    $ltGt3.useImperativeHandle(ref, ()=>({
            handlePreview: onInternalPreview,
            handleDownload: onInternalDownload
        }));
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    // ============================= Render =============================
    const prefixCls = getPrefixCls('upload', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const listClassNames = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-list`, `${prefixCls}-list-${listType}`, uploadListClassNames?.list);
    const listItemMotion = $ltGt3.useMemo(()=>(0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)((0, $32c4c593a0d4aef5$export$2e2bcd8739ae039)(rootPrefixCls), [
            'onAppearEnd',
            'onEnterEnd',
            'onLeaveEnd'
        ]), [
        rootPrefixCls
    ]);
    const motionConfig = {
        ...isPictureCardOrCirle ? {} : listItemMotion,
        motionDeadline: 2000,
        motionName: `${prefixCls}-${isPictureCardOrCirle ? 'animate-inline' : 'animate'}`,
        keys: (0, $83d01b7684a01087$export$2e2bcd8739ae039)(items.map((file)=>({
                key: file.uid,
                file: file
            }))),
        motionAppear: motionAppear
    };
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: listClassNames,
        style: styles?.list
    }, /*#__PURE__*/ $ltGt3.createElement((0, $9073ece020846a7d$export$2e2bcd8739ae039), {
        ...motionConfig,
        component: false
    }, ({ key: key, file: file, className: motionClassName, style: motionStyle })=>/*#__PURE__*/ $ltGt3.createElement((0, $692de4b15c67e59d$export$2e2bcd8739ae039), {
            key: key,
            locale: locale,
            prefixCls: prefixCls,
            className: motionClassName,
            style: motionStyle,
            classNames: uploadListClassNames,
            styles: styles,
            file: file,
            items: items,
            progress: progress,
            listType: listType,
            isImgUrl: isImgUrl,
            showPreviewIcon: showPreviewIcon,
            showRemoveIcon: showRemoveIcon,
            showDownloadIcon: showDownloadIcon,
            removeIcon: removeIcon,
            previewIcon: previewIcon,
            downloadIcon: downloadIcon,
            extra: extra,
            iconRender: internalIconRender,
            actionIconRender: actionIconRender,
            itemRender: itemRender,
            onPreview: onInternalPreview,
            onDownload: onInternalDownload,
            onClose: onInternalClose
        })), appendAction && /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), {
        ...motionConfig,
        visible: appendActionVisible,
        forceRender: true
    }, ({ className: motionClassName, style: motionStyle })=>(0, $66d38239e1a27993$export$e530037191fcd5d7)(appendAction, (oriProps)=>({
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(oriProps.className, motionClassName),
                style: {
                    ...motionStyle,
                    // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
                    pointerEvents: motionClassName ? 'none' : undefined,
                    ...oriProps.style
                }
            }))));
};
const $4a4a37c948810c20$var$UploadList = /*#__PURE__*/ $ltGt3.forwardRef($4a4a37c948810c20$var$InternalUploadList);
var $4a4a37c948810c20$export$2e2bcd8739ae039 = $4a4a37c948810c20$var$UploadList;



"use client";
const $ee45fe19a433b153$export$8f9bb9ff126b1bf5 = `__LIST_IGNORE_${Date.now()}__`;
const $ee45fe19a433b153$var$InternalUpload = (props, ref)=>{
    const config = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('upload');
    const { fileList: fileList, defaultFileList: defaultFileList, onRemove: onRemove, showUploadList: showUploadList = true, listType: listType = 'text', onPreview: onPreview, onDownload: onDownload, onChange: onChange, onDrop: onDrop, previewFile: previewFile, disabled: customDisabled, locale: propLocale, iconRender: iconRender, isImageUrl: isImageUrl, progress: progress, prefixCls: customizePrefixCls, className: className, type: type = 'select', children: children, style: style, itemRender: itemRender, maxCount: maxCount, data: data = {}, multiple: multiple = false, hasControlInside: hasControlInside = true, action: action = '', accept: accept = '', supportServerRender: supportServerRender = true, rootClassName: rootClassName, styles: styles, classNames: classNames } = props;
    // ===================== Disabled =====================
    const disabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const customRequest = props.customRequest || config.customRequest;
    const [internalFileList, setMergedFileList] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultFileList, fileList);
    const mergedFileList = internalFileList || [];
    const [dragState, setDragState] = $ltGt3.useState('drop');
    const upload = $ltGt3.useRef(null);
    const wrapRef = $ltGt3.useRef(null);
    // Control mode will auto fill file uid if not provided
    $ltGt3.useMemo(()=>{
        // eslint-disable-next-line react-hooks/purity
        const timestamp = Date.now();
        (fileList || []).forEach((file, index)=>{
            if (!file.uid && !Object.isFrozen(file)) file.uid = `__AUTO__${timestamp}_${index}__`;
        });
    }, [
        fileList
    ]);
    const onInternalChange = (file, changedFileList, event)=>{
        let cloneList = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(changedFileList);
        let exceedMaxCount = false;
        // Cut to match count
        if (maxCount === 1) cloneList = cloneList.slice(-1);
        else if (maxCount) {
            exceedMaxCount = cloneList.length > maxCount;
            cloneList = cloneList.slice(0, maxCount);
        }
        // Prevent React18 auto batch since input[upload] trigger process at same time
        // which makes fileList closure problem
        // eslint-disable-next-line react-dom/no-flush-sync
        (0, $35c0fb1a856c78db$exports.flushSync)(()=>{
            setMergedFileList(cloneList);
        });
        const changeInfo = {
            file: file,
            fileList: cloneList
        };
        if (event) changeInfo.event = event;
        if (!exceedMaxCount || file.status === 'removed' || // We should ignore event if current file is exceed `maxCount`
        cloneList.some((f)=>f.uid === file.uid)) // eslint-disable-next-line react-dom/no-flush-sync
        (0, $35c0fb1a856c78db$exports.flushSync)(()=>{
            onChange?.(changeInfo);
        });
    };
    const mergedBeforeUpload = async (file, fileListArgs)=>{
        const { beforeUpload: beforeUpload } = props;
        let parsedFile = file;
        if (beforeUpload) {
            const result = await beforeUpload(file, fileListArgs);
            if (result === false) return false;
            // Hack for LIST_IGNORE, we add additional info to remove from the list
            delete file[$ee45fe19a433b153$export$8f9bb9ff126b1bf5];
            if (result === $ee45fe19a433b153$export$8f9bb9ff126b1bf5) {
                Object.defineProperty(file, $ee45fe19a433b153$export$8f9bb9ff126b1bf5, {
                    value: true,
                    configurable: true
                });
                return false;
            }
            if (typeof result === 'object' && result) parsedFile = result;
        }
        return parsedFile;
    };
    const onBatchStart = (batchFileInfoList)=>{
        // Skip file which marked as `LIST_IGNORE`, these file will not add to file list
        const filteredFileInfoList = batchFileInfoList.filter((info)=>!info.file[$ee45fe19a433b153$export$8f9bb9ff126b1bf5]);
        // Nothing to do since no file need upload
        if (!filteredFileInfoList.length) return;
        const objectFileList = filteredFileInfoList.map((info)=>(0, $4ed4e55488d43d6a$export$6dc848fd109e803d)(info.file));
        // Concat new files with prev files
        let newFileList = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(mergedFileList);
        objectFileList.forEach((fileObj)=>{
            // Replace file if exist
            newFileList = (0, $4ed4e55488d43d6a$export$65c2063f64290f37)(fileObj, newFileList);
        });
        objectFileList.forEach((fileObj, index)=>{
            // Repeat trigger `onChange` event for compatible
            let triggerFileObj = fileObj;
            if (!filteredFileInfoList[index].parsedFile) {
                // `beforeUpload` return false
                const { originFileObj: originFileObj } = fileObj;
                let clone;
                try {
                    clone = new File([
                        originFileObj
                    ], originFileObj.name, {
                        type: originFileObj.type
                    });
                } catch  {
                    clone = new Blob([
                        originFileObj
                    ], {
                        type: originFileObj.type
                    });
                    clone.name = originFileObj.name;
                    clone.lastModifiedDate = new Date();
                    clone.lastModified = new Date().getTime();
                }
                clone.uid = fileObj.uid;
                triggerFileObj = clone;
            } else // Inject `uploading` status
            fileObj.status = 'uploading';
            onInternalChange(triggerFileObj, newFileList);
        });
    };
    const onSuccess = (response, file, xhr)=>{
        try {
            if (typeof response === 'string') response = JSON.parse(response);
        } catch  {
        /* do nothing */ }
        // removed
        if (!(0, $4ed4e55488d43d6a$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $4ed4e55488d43d6a$export$6dc848fd109e803d)(file);
        targetItem.status = 'done';
        targetItem.percent = 100;
        targetItem.response = response;
        targetItem.xhr = xhr;
        const nextFileList = (0, $4ed4e55488d43d6a$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    const onProgress = (e, file)=>{
        // removed
        if (!(0, $4ed4e55488d43d6a$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $4ed4e55488d43d6a$export$6dc848fd109e803d)(file);
        targetItem.status = 'uploading';
        targetItem.percent = e.percent;
        const nextFileList = (0, $4ed4e55488d43d6a$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList, e);
    };
    const onError = (error, response, file)=>{
        // removed
        if (!(0, $4ed4e55488d43d6a$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $4ed4e55488d43d6a$export$6dc848fd109e803d)(file);
        targetItem.error = error;
        targetItem.response = response;
        targetItem.status = 'error';
        const nextFileList = (0, $4ed4e55488d43d6a$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    const handleRemove = (file)=>{
        let currentFile;
        Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then((ret)=>{
            // Prevent removing file
            if (ret === false) return;
            const removedFileList = (0, $4ed4e55488d43d6a$export$f3bced642db28a96)(file, mergedFileList);
            if (removedFileList) {
                currentFile = {
                    ...file,
                    status: 'removed'
                };
                mergedFileList?.forEach((item)=>{
                    const matchKey = currentFile.uid !== undefined ? 'uid' : 'name';
                    if (item[matchKey] === currentFile[matchKey] && !Object.isFrozen(item)) item.status = 'removed';
                });
                upload.current?.abort(currentFile);
                onInternalChange(currentFile, removedFileList);
            }
        });
    };
    const onFileDrop = (e)=>{
        setDragState(e.type);
        if (e.type === 'drop') onDrop?.(e);
    };
    // Test needs
    $ltGt3.useImperativeHandle(ref, ()=>({
            onBatchStart: onBatchStart,
            onSuccess: onSuccess,
            onProgress: onProgress,
            onError: onError,
            fileList: mergedFileList,
            upload: upload.current,
            nativeElement: wrapRef.current
        }));
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('upload');
    const prefixCls = getPrefixCls('upload', customizePrefixCls);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        listType: listType,
        showUploadList: showUploadList,
        type: type,
        multiple: multiple,
        hasControlInside: hasControlInside,
        supportServerRender: supportServerRender,
        disabled: mergedDisabled
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const rcUploadProps = {
        onBatchStart: onBatchStart,
        onError: onError,
        onProgress: onProgress,
        onSuccess: onSuccess,
        ...props,
        customRequest: customRequest,
        data: data,
        multiple: multiple,
        action: action,
        accept: accept,
        supportServerRender: supportServerRender,
        prefixCls: prefixCls,
        disabled: mergedDisabled,
        beforeUpload: mergedBeforeUpload,
        onChange: undefined,
        hasControlInside: hasControlInside
    };
    delete rcUploadProps.className;
    delete rcUploadProps.style;
    // Remove id to avoid open by label when trigger is hidden
    // !children: https://github.com/ant-design/ant-design/issues/14298
    // disabled: https://github.com/ant-design/ant-design/issues/16478
    //           https://github.com/ant-design/ant-design/issues/24197
    if (!children || mergedDisabled) delete rcUploadProps.id;
    const wrapperCls = `${prefixCls}-wrapper`;
    const [hashId, cssVarCls] = (0, $7bc90afee5d790cc$export$2e2bcd8739ae039)(prefixCls, wrapperCls);
    const [contextLocale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Upload', (0, $29f4f00e8825a41b$export$2e2bcd8739ae039).Upload);
    const { showRemoveIcon: showRemoveIcon, showPreviewIcon: showPreviewIcon, showDownloadIcon: showDownloadIcon, removeIcon: removeIcon, previewIcon: previewIcon, downloadIcon: downloadIcon, extra: extra } = typeof showUploadList === 'boolean' ? {} : showUploadList;
    // use showRemoveIcon if it is specified explicitly
    const realShowRemoveIcon = typeof showRemoveIcon === 'undefined' ? !mergedDisabled : showRemoveIcon;
    const renderUploadList = (button, buttonVisible)=>{
        if (!showUploadList) return button;
        return /*#__PURE__*/ $ltGt3.createElement((0, $4a4a37c948810c20$export$2e2bcd8739ae039), {
            classNames: mergedClassNames,
            styles: mergedStyles,
            prefixCls: prefixCls,
            listType: listType,
            items: mergedFileList,
            previewFile: previewFile,
            onPreview: onPreview,
            onDownload: onDownload,
            onRemove: handleRemove,
            showRemoveIcon: realShowRemoveIcon,
            showPreviewIcon: showPreviewIcon,
            showDownloadIcon: showDownloadIcon,
            removeIcon: removeIcon,
            previewIcon: previewIcon,
            downloadIcon: downloadIcon,
            iconRender: iconRender,
            extra: extra,
            locale: {
                ...contextLocale,
                ...propLocale
            },
            isImageUrl: isImageUrl,
            progress: progress,
            appendAction: button,
            appendActionVisible: buttonVisible,
            itemRender: itemRender,
            disabled: mergedDisabled
        });
    };
    const mergedRootCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(wrapperCls, className, rootClassName, hashId, cssVarCls, contextClassName, mergedClassNames.root, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-picture-card-wrapper`]: listType === 'picture-card',
        [`${prefixCls}-picture-circle-wrapper`]: listType === 'picture-circle'
    });
    const mergedRootStyle = {
        ...mergedStyles.root
    };
    const mergedStyle = {
        ...contextStyle,
        ...style
    };
    // ======================== Render ========================
    if (type === 'drag') {
        const dragCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(hashId, prefixCls, `${prefixCls}-drag`, {
            [`${prefixCls}-drag-uploading`]: mergedFileList.some((file)=>file.status === 'uploading'),
            [`${prefixCls}-drag-hover`]: dragState === 'dragover',
            [`${prefixCls}-disabled`]: mergedDisabled,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        });
        return /*#__PURE__*/ $ltGt3.createElement("span", {
            className: mergedRootCls,
            ref: wrapRef,
            style: mergedRootStyle
        }, /*#__PURE__*/ $ltGt3.createElement("div", {
            className: dragCls,
            style: mergedStyle,
            onDrop: onFileDrop,
            onDragOver: onFileDrop,
            onDragLeave: onFileDrop
        }, /*#__PURE__*/ $ltGt3.createElement((0, $24b8f844caa705b2$export$2e2bcd8739ae039), {
            ...rcUploadProps,
            ref: upload,
            className: `${prefixCls}-btn`
        }, /*#__PURE__*/ $ltGt3.createElement("div", {
            className: `${prefixCls}-drag-container`
        }, children))), renderUploadList());
    }
    const uploadBtnCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-select`, {
        [`${prefixCls}-disabled`]: mergedDisabled,
        [`${prefixCls}-hidden`]: !children
    });
    const uploadButton = /*#__PURE__*/ $ltGt3.createElement("div", {
        className: uploadBtnCls,
        style: mergedStyle
    }, /*#__PURE__*/ $ltGt3.createElement((0, $24b8f844caa705b2$export$2e2bcd8739ae039), {
        ...rcUploadProps,
        ref: upload
    }));
    if (listType === 'picture-card' || listType === 'picture-circle') return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: mergedRootCls,
        ref: wrapRef,
        style: mergedRootStyle
    }, renderUploadList(uploadButton, !!children));
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: mergedRootCls,
        ref: wrapRef,
        style: mergedRootStyle
    }, uploadButton, renderUploadList());
};
const $ee45fe19a433b153$var$Upload = /*#__PURE__*/ $ltGt3.forwardRef($ee45fe19a433b153$var$InternalUpload);
var $ee45fe19a433b153$export$2e2bcd8739ae039 = $ee45fe19a433b153$var$Upload;


"use client";
const $f8ac9f91b30764a4$var$Dragger = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { style: style, height: height, hasControlInside: hasControlInside = false, children: children, ...restProps } = props;
    const mergedStyle = {
        ...style,
        height: height
    };
    return /*#__PURE__*/ $ltGt3.createElement((0, $ee45fe19a433b153$export$2e2bcd8739ae039), {
        ref: ref,
        hasControlInside: hasControlInside,
        ...restProps,
        style: mergedStyle,
        type: "drag"
    }, children);
});
var $f8ac9f91b30764a4$export$2e2bcd8739ae039 = $f8ac9f91b30764a4$var$Dragger;



"use client";
const $17454bf909e69d0f$var$Upload = (0, $ee45fe19a433b153$export$2e2bcd8739ae039);
$17454bf909e69d0f$var$Upload.Dragger = (0, $f8ac9f91b30764a4$export$2e2bcd8739ae039);
$17454bf909e69d0f$var$Upload.LIST_IGNORE = (0, $ee45fe19a433b153$export$8f9bb9ff126b1bf5);
var $17454bf909e69d0f$export$2e2bcd8739ae039 = $17454bf909e69d0f$var$Upload;


parcelRequire("ltGt3");

function $a70d8a2055eb4992$export$75471c1fa692787({ urls: urls, selectedUrl: selectedUrl, onUrlSelected: onUrlSelected = ()=>{} }) {
    const { token: { colorPrimary: colorPrimary } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        style: {
            color: colorPrimary
        },
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $17454bf909e69d0f$export$2e2bcd8739ae039), {
            className: "image-select",
            listType: "picture-card",
            fileList: urls.map((url)=>({
                    uid: url,
                    name: url,
                    thumbUrl: url,
                    status: url === selectedUrl ? 'success' : undefined
                })),
            showUploadList: {
                showRemoveIcon: false,
                previewIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b22ab34d306c7e4e$export$2e2bcd8739ae039), {
                    style: {
                        color: 'white',
                        fontSize: 22
                    }
                })
            },
            onPreview: (file)=>onUrlSelected(file.name)
        })
    });
}



var $1baa16c7de040cca$exports = {};
$1baa16c7de040cca$exports = import.meta.resolve("wTTAq");


var $7edbbacfe4b85238$exports = {};
$7edbbacfe4b85238$exports = import.meta.resolve("2EQ8D");


var $4605f3ce2e6c5052$exports = {};
$4605f3ce2e6c5052$exports = import.meta.resolve("brWXX");







var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
const $42ec8993e0fac769$export$9ea6397a890aa3e5 = (prefixCls, displayValues, allowClear, clearIcon, disabled = false, mergedSearchValue, mode)=>{
    // Convert boolean to object first
    const allowClearConfig = (0, $ltGt3.useMemo)(()=>{
        if (typeof allowClear === 'boolean') return {
            allowClear: allowClear
        };
        if (allowClear && typeof allowClear === 'object') return allowClear;
        return {
            allowClear: false
        };
    }, [
        allowClear
    ]);
    return (0, $ltGt3.useMemo)(()=>{
        const mergedAllowClear = !disabled && allowClearConfig.allowClear !== false && (displayValues.length || mergedSearchValue) && !(mode === 'combobox' && mergedSearchValue === '');
        return {
            allowClear: mergedAllowClear,
            clearIcon: mergedAllowClear ? allowClearConfig.clearIcon || clearIcon || "\xd7" : null
        };
    }, [
        allowClearConfig,
        clearIcon,
        disabled,
        displayValues.length,
        mergedSearchValue,
        mode
    ]);
};


/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ 
var $ltGt3 = parcelRequire("ltGt3");
const $4355aa2c171e5629$export$8234047c0aea33cf = /*#__PURE__*/ $ltGt3.createContext(null);
function $4355aa2c171e5629$export$2e2bcd8739ae039() {
    return $ltGt3.useContext($4355aa2c171e5629$export$8234047c0aea33cf);
}



var $ltGt3 = parcelRequire("ltGt3");
function $ad6ddf8b1a04d2b6$export$2e2bcd8739ae039(duration = 250) {
    const lockRef = $ltGt3.useRef(null);
    const timeoutRef = $ltGt3.useRef(null);
    // Clean up
    $ltGt3.useEffect(()=>()=>{
            window.clearTimeout(timeoutRef.current);
        }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(()=>{
            lockRef.current = null;
        }, duration);
    }
    return [
        ()=>lockRef.current,
        doLock
    ];
}



var $ltGt3 = parcelRequire("ltGt3");

function $e1b57023a0a59503$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    const onGlobalMouseDown = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((event)=>{
        // If trigger is customized, Trigger will take control of popupVisible
        if (customizedTrigger) return;
        let target = event.target;
        if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
        if (open && elements().filter((element)=>element).every((element)=>!element.contains(target) && element !== target)) // Should trigger close
        triggerOpen(false);
    });
    $ltGt3.useEffect(()=>{
        window.addEventListener('mousedown', onGlobalMouseDown);
        return ()=>window.removeEventListener('mousedown', onGlobalMouseDown);
    }, [
        onGlobalMouseDown
    ]);
}





var $ltGt3 = parcelRequire("ltGt3");
function $cedcd86b1501e91d$var$_extends() {
    $cedcd86b1501e91d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cedcd86b1501e91d$var$_extends.apply(this, arguments);
}
const $cedcd86b1501e91d$var$getBuiltInPlacements = (popupMatchSelectWidth)=>{
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    const adjustX = popupMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        bottomRight: {
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        topLeft: {
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        topRight: {
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        }
    };
};
const $cedcd86b1501e91d$var$SelectTrigger = (props, ref)=>{
    const { prefixCls: prefixCls, disabled: disabled, visible: visible, children: children, popupElement: popupElement, animation: animation, transitionName: transitionName, popupStyle: popupStyle, popupClassName: popupClassName, direction: direction = 'ltr', placement: placement, builtinPlacements: builtinPlacements, popupMatchSelectWidth: popupMatchSelectWidth, popupRender: popupRender, popupAlign: popupAlign, getPopupContainer: getPopupContainer, empty: empty, onPopupVisibleChange: onPopupVisibleChange, onPopupMouseEnter: onPopupMouseEnter, onPopupMouseDown: onPopupMouseDown, ...restProps } = props;
    // We still use `dropdown` className to keep compatibility
    // This is used for:
    // 1. Styles
    // 2. Animation
    // 3. Theme customization
    // Please do not modify this since it's a breaking change
    const popupPrefixCls = `${prefixCls}-dropdown`;
    let popupNode = popupElement;
    if (popupRender) popupNode = popupRender(popupElement);
    const mergedBuiltinPlacements = $ltGt3.useMemo(()=>builtinPlacements || $cedcd86b1501e91d$var$getBuiltInPlacements(popupMatchSelectWidth), [
        builtinPlacements,
        popupMatchSelectWidth
    ]);
    // ===================== Motion ======================
    const mergedTransitionName = animation ? `${popupPrefixCls}-${animation}` : transitionName;
    // =================== Popup Width ===================
    const isNumberPopupWidth = typeof popupMatchSelectWidth === 'number';
    const stretch = $ltGt3.useMemo(()=>{
        if (isNumberPopupWidth) return null;
        return popupMatchSelectWidth === false ? 'minWidth' : 'width';
    }, [
        popupMatchSelectWidth,
        isNumberPopupWidth
    ]);
    let mergedPopupStyle = popupStyle;
    if (isNumberPopupWidth) mergedPopupStyle = {
        ...popupStyle,
        width: popupMatchSelectWidth
    };
    // ======================= Ref =======================
    const triggerPopupRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, ()=>({
            getPopupElement: ()=>triggerPopupRef.current?.popupElement
        }));
    return /*#__PURE__*/ $ltGt3.createElement((0, $1b29c21fa1aa3a55$export$2e2bcd8739ae039), $cedcd86b1501e91d$var$_extends({}, restProps, {
        showAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        hideAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        popupPlacement: placement || (direction === 'rtl' ? 'bottomRight' : 'bottomLeft'),
        builtinPlacements: mergedBuiltinPlacements,
        prefixCls: popupPrefixCls,
        popupMotion: {
            motionName: mergedTransitionName
        },
        popup: /*#__PURE__*/ $ltGt3.createElement("div", {
            onMouseEnter: onPopupMouseEnter,
            onMouseDown: onPopupMouseDown
        }, popupNode),
        ref: triggerPopupRef,
        stretch: stretch,
        popupAlign: popupAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(popupClassName, {
            [`${popupPrefixCls}-empty`]: empty
        }),
        popupStyle: mergedPopupStyle,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
const $cedcd86b1501e91d$var$RefSelectTrigger = /*#__PURE__*/ $ltGt3.forwardRef($cedcd86b1501e91d$var$SelectTrigger);
var $cedcd86b1501e91d$export$2e2bcd8739ae039 = $cedcd86b1501e91d$var$RefSelectTrigger;



function $14c96dd516b10eb8$var$getKey(data, index) {
    const { key: key } = data;
    let value;
    if ('value' in data) ({ value: value } = data);
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return `rc-index-key-${index}`;
}
function $14c96dd516b10eb8$export$be48fd776273e509(value) {
    return typeof value !== 'undefined' && !Number.isNaN(value);
}
function $14c96dd516b10eb8$export$6c519d302dced239(fieldNames, childrenAsData) {
    const { label: label, value: value, options: options, groupLabel: groupLabel } = fieldNames || {};
    const mergedLabel = label || (childrenAsData ? 'children' : 'label');
    return {
        label: mergedLabel,
        value: value || 'value',
        options: options || 'options',
        groupLabel: groupLabel || mergedLabel
    };
}
function $14c96dd516b10eb8$export$7baa7c13b358b002(options, { fieldNames: fieldNames, childrenAsData: childrenAsData } = {}) {
    const flattenList = [];
    const { label: fieldLabel, value: fieldValue, options: fieldOptions, groupLabel: groupLabel } = $14c96dd516b10eb8$export$6c519d302dced239(fieldNames, false);
    function dig(list, isGroupOption) {
        if (!Array.isArray(list)) return;
        list.forEach((data)=>{
            if (isGroupOption || !(fieldOptions in data)) {
                const value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $14c96dd516b10eb8$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: data[fieldLabel],
                    value: value
                });
            } else {
                let grpLabel = data[groupLabel];
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $14c96dd516b10eb8$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $14c96dd516b10eb8$export$d0b21b213c8c013c(option) {
    const newOption = {
        ...option
    };
    if (!('props' in newOption)) Object.defineProperty(newOption, 'props', {
        get () {
            (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, 'Return type is option instead of Option instance. Please read value directly instead of reading from `props`.');
            return newOption;
        }
    });
    return newOption;
}
const $14c96dd516b10eb8$export$a09ca2a89e052b14 = (text, tokens, end)=>{
    if (!tokens || !tokens.length) return null;
    let match = false;
    const separate = (str, [token, ...restTokens])=>{
        if (!token) return [
            str
        ];
        const list = str.split(token);
        match = match || list.length > 1;
        return list.reduce((prevList, unitStr)=>[
                ...prevList,
                ...separate(unitStr, restTokens)
            ], []).filter(Boolean);
    };
    const list = separate(text, tokens);
    if (match) return typeof end !== 'undefined' ? list.slice(0, end) : list;
    else return null;
};



var $ltGt3 = parcelRequire("ltGt3");
function $8f608e3f689bbb33$export$2e2bcd8739ae039(props) {
    const { visible: visible, values: values } = props;
    if (!visible) return null;
    // Only cut part of values since it's a screen reader
    const MAX_COUNT = 50;
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        }
    }, `${values.slice(0, MAX_COUNT).map(({ label: label, value: value })=>[
            'number',
            'string'
        ].includes(typeof label) ? label : value).join(', ')}`, values.length > MAX_COUNT ? ', ...' : null);
}




var $ltGt3 = parcelRequire("ltGt3");
const $db6a7a97604bab3f$var$internalMacroTask = (fn)=>{
    const channel = new MessageChannel();
    channel.port1.onmessage = fn;
    channel.port2.postMessage(null);
};
const $db6a7a97604bab3f$var$macroTask = (fn, times = 1)=>{
    if (times <= 0) {
        fn();
        return;
    }
    $db6a7a97604bab3f$var$internalMacroTask(()=>{
        $db6a7a97604bab3f$var$macroTask(fn, times - 1);
    });
};
function $db6a7a97604bab3f$export$2e2bcd8739ae039(propOpen, onOpen, postOpen) {
    // SSR not support Portal which means we need delay `open` for the first time render
    const [rendered, setRendered] = (0, $ltGt3.useState)(false);
    (0, $ltGt3.useEffect)(()=>{
        setRendered(true);
    }, []);
    const [stateOpen, internalSetOpen] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(false, propOpen);
    // During SSR, always return false for open state
    const ssrSafeOpen = rendered ? stateOpen : false;
    const mergedOpen = postOpen(ssrSafeOpen);
    const taskIdRef = (0, $ltGt3.useRef)(0);
    const taskLockRef = (0, $ltGt3.useRef)(false);
    const triggerEvent = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((nextOpen)=>{
        if (onOpen && mergedOpen !== nextOpen) onOpen(nextOpen);
        internalSetOpen(nextOpen);
    });
    const toggleOpen = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((nextOpen, config = {})=>{
        const { ignoreNext: ignoreNext = false, lazy: lazy = false } = config;
        taskIdRef.current += 1;
        const id = taskIdRef.current;
        const nextOpenVal = typeof nextOpen === 'boolean' ? nextOpen : !mergedOpen;
        // Since `mergedOpen` is post-processed, we need to check if the value really changed
        if (nextOpenVal || !lazy) {
            if (!taskLockRef.current) {
                triggerEvent(nextOpenVal);
                // Lock if needed
                if (ignoreNext) {
                    taskLockRef.current = ignoreNext;
                    $db6a7a97604bab3f$var$macroTask(()=>{
                        taskLockRef.current = false;
                    }, 2);
                }
            }
            return;
        }
        $db6a7a97604bab3f$var$macroTask(()=>{
            if (id === taskIdRef.current && !taskLockRef.current) triggerEvent(nextOpenVal);
        });
    });
    return [
        mergedOpen,
        toggleOpen
    ];
}




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
function $de25f86d60aa9886$export$2e2bcd8739ae039(props) {
    const { children: children, ...restProps } = props;
    if (!children) return null;
    return /*#__PURE__*/ $ltGt3.createElement("div", restProps, children);
}



var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
const $345f9a9a228dd1cb$var$SelectInputContext = /*#__PURE__*/ $ltGt3.createContext(null);
function $345f9a9a228dd1cb$export$7785dec5a5aec756() {
    return $ltGt3.useContext($345f9a9a228dd1cb$var$SelectInputContext);
}
var $345f9a9a228dd1cb$export$2e2bcd8739ae039 = $345f9a9a228dd1cb$var$SelectInputContext;





const $20d623c8b6b536a1$var$Input = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { onChange: onChange, onKeyDown: onKeyDown, onBlur: onBlur, style: style, syncWidth: syncWidth, value: value, className: className, autoComplete: autoComplete, ...restProps } = props;
    const { prefixCls: prefixCls, mode: mode, onSearch: onSearch, onSearchSubmit: onSearchSubmit, onInputBlur: onInputBlur, autoFocus: autoFocus, tokenWithEnter: tokenWithEnter, placeholder: placeholder, components: { input: InputComponent = 'input' } } = (0, $345f9a9a228dd1cb$export$7785dec5a5aec756)();
    const { id: id, classNames: classNames, styles: styles, open: open, activeDescendantId: activeDescendantId, role: role, disabled: disabled } = (0, $4355aa2c171e5629$export$2e2bcd8739ae039)() || {};
    const inputCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-input`, classNames?.input, className);
    // Used to handle input method composition status
    const compositionStatusRef = $ltGt3.useRef(false);
    // Used to handle paste content, similar to original Selector implementation
    const pastedTextRef = $ltGt3.useRef(null);
    // ============================== Refs ==============================
    const inputRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, ()=>inputRef.current);
    // ============================== Data ==============================
    // Handle input changes
    const handleChange = (event)=>{
        let { value: nextVal } = event.target;
        // Handle pasted text with tokenWithEnter, similar to original Selector implementation
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            const replacedText = pastedTextRef.current.replace(/[\r\n]+$/, '').replace(/\r\n/g, ' ').replace(/[\r\n]/g, ' ');
            nextVal = nextVal.replace(replacedText, pastedTextRef.current);
        }
        // Reset pasted text reference
        pastedTextRef.current = null;
        // Call onSearch callback
        if (onSearch) onSearch(nextVal, true, compositionStatusRef.current);
        // Call original onChange callback
        onChange?.(event);
    };
    // ============================ Keyboard ============================
    // Handle keyboard events
    const handleKeyDown = (event)=>{
        const { key: key } = event;
        const { value: nextVal } = event.currentTarget;
        // Handle Enter key submission - referencing Selector implementation
        if (key === 'Enter' && mode === 'tags' && !compositionStatusRef.current && onSearchSubmit) onSearchSubmit(nextVal);
        // Call original onKeyDown callback
        onKeyDown?.(event);
    };
    // Handle blur events
    const handleBlur = (event)=>{
        // Call onInputBlur callback
        onInputBlur?.();
        // Call original onBlur callback
        onBlur?.(event);
    };
    // Handle input method composition start
    const handleCompositionStart = ()=>{
        compositionStatusRef.current = true;
    };
    // Handle input method composition end
    const handleCompositionEnd = (event)=>{
        compositionStatusRef.current = false;
        // Trigger search when input method composition ends, similar to original Selector
        if (mode !== 'combobox') {
            const { value: nextVal } = event.currentTarget;
            onSearch?.(nextVal, true, false);
        }
    };
    // Handle paste events to track pasted content
    const handlePaste = (event)=>{
        const { clipboardData: clipboardData } = event;
        const pastedValue = clipboardData?.getData('text');
        pastedTextRef.current = pastedValue || '';
    };
    // ============================= Width ==============================
    const [widthCssVar, setWidthCssVar] = $ltGt3.useState(undefined);
    // When syncWidth is enabled, adjust input width based on content
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        const input = inputRef.current;
        if (syncWidth && input) {
            input.style.width = '0px';
            const scrollWidth = input.scrollWidth;
            setWidthCssVar(scrollWidth);
            // Reset input style
            input.style.width = '';
        }
    }, [
        syncWidth,
        value
    ]);
    // ============================= Render =============================
    // Extract shared input props
    const sharedInputProps = {
        id: id,
        type: mode === 'combobox' ? 'text' : 'search',
        ...restProps,
        ref: inputRef,
        style: {
            ...styles?.input,
            ...style,
            '--select-input-width': widthCssVar
        },
        autoFocus: autoFocus,
        autoComplete: autoComplete || 'off',
        className: inputCls,
        disabled: disabled,
        value: value || '',
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        onPaste: handlePaste,
        onCompositionStart: handleCompositionStart,
        onCompositionEnd: handleCompositionEnd,
        // Accessibility attributes
        role: role || 'combobox',
        'aria-expanded': open || false,
        'aria-haspopup': 'listbox',
        'aria-owns': `${id}_list`,
        'aria-autocomplete': 'list',
        'aria-controls': `${id}_list`,
        'aria-activedescendant': open ? activeDescendantId : undefined
    };
    // Handle different InputComponent types
    if (/*#__PURE__*/ $ltGt3.isValidElement(InputComponent)) {
        // If InputComponent is a ReactElement, use cloneElement with merged props
        const existingProps = InputComponent.props || {};
        // Start with shared props as base
        const mergedProps = {
            placeholder: props.placeholder || placeholder,
            ...sharedInputProps,
            ...existingProps
        };
        // Batch update function calls
        Object.keys(existingProps).forEach((key)=>{
            const existingValue = existingProps[key];
            if (typeof existingValue === 'function') // Merge event handlers
            mergedProps[key] = (...args)=>{
                existingValue(...args);
                sharedInputProps[key]?.(...args);
            };
        });
        // Update ref
        mergedProps.ref = (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(InputComponent.ref, sharedInputProps.ref);
        return /*#__PURE__*/ $ltGt3.cloneElement(InputComponent, mergedProps);
    }
    // If InputComponent is a component type, render normally
    const Component = InputComponent;
    return /*#__PURE__*/ $ltGt3.createElement(Component, sharedInputProps);
});
var $20d623c8b6b536a1$export$2e2bcd8739ae039 = $20d623c8b6b536a1$var$Input;





var $ltGt3 = parcelRequire("ltGt3");



function $e62e707fb1a60923$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, placeholder: placeholder, displayValues: displayValues } = (0, $345f9a9a228dd1cb$export$7785dec5a5aec756)();
    const { classNames: classNames, styles: styles } = (0, $4355aa2c171e5629$export$2e2bcd8739ae039)();
    const { show: show = true } = props;
    if (displayValues.length) return null;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-placeholder`, classNames?.placeholder),
        style: {
            visibility: show ? 'visible' : 'hidden',
            ...styles?.placeholder
        }
    }, placeholder);
}



var $ltGt3 = parcelRequire("ltGt3");
// Use any here since we do not get the type during compilation
/**
 * SelectContext is only used for Select. BaseSelect should not consume this context.
 */ const $9d1864f321b932b3$var$SelectContext = /*#__PURE__*/ $ltGt3.createContext(null);
var $9d1864f321b932b3$export$2e2bcd8739ae039 = $9d1864f321b932b3$var$SelectContext;


function $2a6d62b3faa5409a$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
const $2a6d62b3faa5409a$export$7383f122bf48ec30 = typeof window !== 'undefined' && window.document && window.document.documentElement;
const $2a6d62b3faa5409a$export$df7146797a248522 = $2a6d62b3faa5409a$export$7383f122bf48ec30;
function $2a6d62b3faa5409a$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $2a6d62b3faa5409a$export$9d186c3672bb89c6(value) {
    return !value && value !== 0;
}
function $2a6d62b3faa5409a$var$isTitleType(title) {
    return [
        'string',
        'number'
    ].includes(typeof title);
}
function $2a6d62b3faa5409a$export$70d1bf7729efff40(item) {
    let title = undefined;
    if (item) {
        if ($2a6d62b3faa5409a$var$isTitleType(item.title)) title = item.title.toString();
        else if ($2a6d62b3faa5409a$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}


function $91c8347b19ddccce$var$_extends() {
    $91c8347b19ddccce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $91c8347b19ddccce$var$_extends.apply(this, arguments);
}
const $91c8347b19ddccce$var$SingleContent = /*#__PURE__*/ $ltGt3.forwardRef(({ inputProps: inputProps }, ref)=>{
    const { prefixCls: prefixCls, searchValue: searchValue, activeValue: activeValue, displayValues: displayValues, maxLength: maxLength, mode: mode } = (0, $345f9a9a228dd1cb$export$7785dec5a5aec756)();
    const { triggerOpen: triggerOpen, title: rootTitle, showSearch: showSearch, classNames: classNames, styles: styles } = (0, $4355aa2c171e5629$export$2e2bcd8739ae039)();
    const selectContext = $ltGt3.useContext((0, $9d1864f321b932b3$export$2e2bcd8739ae039));
    const [inputChanged, setInputChanged] = $ltGt3.useState(false);
    const combobox = mode === 'combobox';
    const displayValue = displayValues[0];
    // Implement the same logic as the old SingleSelector
    const mergedSearchValue = $ltGt3.useMemo(()=>{
        if (combobox && activeValue && !inputChanged && triggerOpen) return activeValue;
        return showSearch ? searchValue : '';
    }, [
        combobox,
        activeValue,
        inputChanged,
        triggerOpen,
        searchValue,
        showSearch
    ]);
    // Extract option props, excluding label and value, and handle className/style merging
    const optionProps = $ltGt3.useMemo(()=>{
        let restProps = {
            className: `${prefixCls}-content-value`,
            style: {
                visibility: mergedSearchValue ? 'hidden' : 'visible'
            }
        };
        if (displayValue && selectContext?.flattenOptions) {
            const option = selectContext.flattenOptions.find((opt)=>opt.value === displayValue.value);
            if (option?.data) {
                const { label: label, value: value, className: className, style: style, key: key, ...rest } = option.data;
                restProps = {
                    ...restProps,
                    ...rest,
                    title: (0, $2a6d62b3faa5409a$export$70d1bf7729efff40)(option.data),
                    className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(restProps.className, className),
                    style: {
                        ...restProps.style,
                        ...style
                    }
                };
            }
        }
        if (displayValue && !restProps.title) restProps.title = (0, $2a6d62b3faa5409a$export$70d1bf7729efff40)(displayValue);
        if (rootTitle !== undefined) restProps.title = rootTitle;
        return restProps;
    }, [
        displayValue,
        selectContext?.flattenOptions,
        prefixCls,
        mergedSearchValue,
        rootTitle
    ]);
    $ltGt3.useEffect(()=>{
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-content`, classNames?.content),
        style: styles?.content
    }, displayValue ? /*#__PURE__*/ $ltGt3.createElement("div", optionProps, displayValue.label) : /*#__PURE__*/ $ltGt3.createElement((0, $e62e707fb1a60923$export$2e2bcd8739ae039), {
        show: !mergedSearchValue
    }), /*#__PURE__*/ $ltGt3.createElement((0, $20d623c8b6b536a1$export$2e2bcd8739ae039), $91c8347b19ddccce$var$_extends({
        ref: ref
    }, inputProps, {
        value: mergedSearchValue,
        maxLength: mode === 'combobox' ? maxLength : undefined,
        onChange: (e)=>{
            setInputChanged(true);
            inputProps.onChange?.(e);
        }
    })));
});
var $91c8347b19ddccce$export$2e2bcd8739ae039 = $91c8347b19ddccce$var$SingleContent;



var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");

/**
 * Small wrapper for Select icons (clear/arrow/etc.).
 * Prevents default mousedown to avoid blurring or caret moves, and
 * renders a custom icon or a fallback icon span.
 *
 * DOM structure:
 * <span className={className} ...>
 *   { icon || <span className={`${className}-icon`}>{children}</span> }
 * </span>
 */ const $68c5fd9ab6ff895c$var$TransBtn = (props)=>{
    const { className: className, style: style, customizeIcon: customizeIcon, customizeIconProps: customizeIconProps, children: children, onMouseDown: onMouseDown, onClick: onClick } = props;
    const icon = typeof customizeIcon === 'function' ? customizeIcon(customizeIconProps) : customizeIcon;
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: className,
        onMouseDown: (event)=>{
            event.preventDefault();
            onMouseDown?.(event);
        },
        style: {
            userSelect: 'none',
            WebkitUserSelect: 'none',
            ...style
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className.split(/\s+/).map((cls)=>`${cls}-icon`))
    }, children));
};
var $68c5fd9ab6ff895c$export$2e2bcd8739ae039 = $68c5fd9ab6ff895c$var$TransBtn;





function $c6681824c40745c9$var$_extends() {
    $c6681824c40745c9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c6681824c40745c9$var$_extends.apply(this, arguments);
}
function $c6681824c40745c9$var$itemKey(value) {
    return value.key ?? value.value;
}
const $c6681824c40745c9$var$onPreventMouseDown = (event)=>{
    event.preventDefault();
    event.stopPropagation();
};
var $c6681824c40745c9$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.forwardRef(function MultipleContent({ inputProps: inputProps }, ref) {
    const { prefixCls: prefixCls, displayValues: displayValues, searchValue: searchValue, mode: mode, onSelectorRemove: onSelectorRemove, removeIcon: removeIconFromContext } = (0, $345f9a9a228dd1cb$export$7785dec5a5aec756)();
    const { disabled: disabled, showSearch: showSearch, triggerOpen: triggerOpen, toggleOpen: toggleOpen, autoClearSearchValue: autoClearSearchValue, tagRender: tagRenderFromContext, maxTagPlaceholder: maxTagPlaceholderFromContext, maxTagTextLength: maxTagTextLength, maxTagCount: maxTagCount, classNames: classNames, styles: styles } = (0, $4355aa2c171e5629$export$2e2bcd8739ae039)();
    const selectionItemPrefixCls = `${prefixCls}-selection-item`;
    // ===================== Search ======================
    // Apply autoClearSearchValue logic: when dropdown is closed and autoClearSearchValue is not false (default true), clear search value
    let computedSearchValue = searchValue;
    if (!triggerOpen && mode === 'multiple' && autoClearSearchValue !== false) computedSearchValue = '';
    const inputValue = showSearch ? computedSearchValue || '' : '';
    const inputEditable = showSearch && !disabled;
    // Props from context with safe defaults
    const removeIcon = removeIconFromContext ?? "\xd7";
    const maxTagPlaceholder = maxTagPlaceholderFromContext ?? ((omittedValues)=>`+ ${omittedValues.length} ...`);
    const tagRender = tagRenderFromContext;
    const onToggleOpen = (newOpen)=>{
        toggleOpen(newOpen);
    };
    const onRemove = (value)=>{
        onSelectorRemove?.(value);
    };
    // ======================== Item ========================
    // >>> Render Selector Node. Includes Item & Rest
    const defaultRenderSelector = (item, content, itemDisabled, closable, onClose)=>/*#__PURE__*/ $ltGt3.createElement("span", {
            title: (0, $2a6d62b3faa5409a$export$70d1bf7729efff40)(item),
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(selectionItemPrefixCls, {
                [`${selectionItemPrefixCls}-disabled`]: itemDisabled
            }, classNames?.item),
            style: styles?.item
        }, /*#__PURE__*/ $ltGt3.createElement("span", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${selectionItemPrefixCls}-content`, classNames?.itemContent),
            style: styles?.itemContent
        }, content), closable && /*#__PURE__*/ $ltGt3.createElement((0, $68c5fd9ab6ff895c$export$2e2bcd8739ae039), {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${selectionItemPrefixCls}-remove`, classNames?.itemRemove),
            style: styles?.itemRemove,
            onMouseDown: $c6681824c40745c9$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xD7"));
    const customizeRenderSelector = (value, content, itemDisabled, closable, onClose, isMaxTag, info)=>{
        const onMouseDown = (e)=>{
            $c6681824c40745c9$var$onPreventMouseDown(e);
            onToggleOpen(!triggerOpen);
        };
        return /*#__PURE__*/ $ltGt3.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            index: info?.index,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose,
            isMaxTag: !!isMaxTag
        }));
    };
    // ====================== Overflow ======================
    const renderItem = (valueItem, info)=>{
        const { disabled: itemDisabled, label: label, value: value } = valueItem;
        const closable = !disabled && !itemDisabled;
        let displayLabel = label;
        if (typeof maxTagTextLength === 'number') {
            if (typeof label === 'string' || typeof label === 'number') {
                const strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = `${strLabel.slice(0, maxTagTextLength)}...`;
            }
        }
        const onClose = (event)=>{
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === 'function' ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose, undefined, info) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    };
    const renderRest = (omittedValues)=>{
        // https://github.com/ant-design/ant-design/issues/48930
        if (!displayValues.length) return null;
        const content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return typeof tagRender === 'function' ? customizeRenderSelector(undefined, content, false, false, undefined, true) : defaultRenderSelector({
            title: content
        }, content, false);
    };
    // ======================= Render =======================
    return /*#__PURE__*/ $ltGt3.createElement((0, $a8c8240385950b5a$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-content`,
        className: classNames?.content,
        style: styles?.content,
        prefix: !displayValues.length && (!searchValue || !triggerOpen) ? /*#__PURE__*/ $ltGt3.createElement((0, $e62e707fb1a60923$export$2e2bcd8739ae039), null) : null,
        data: displayValues,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: /*#__PURE__*/ $ltGt3.createElement((0, $20d623c8b6b536a1$export$2e2bcd8739ae039), $c6681824c40745c9$var$_extends({
            ref: ref,
            disabled: disabled,
            readOnly: !inputEditable
        }, inputProps, {
            value: inputValue || '',
            syncWidth: true
        })),
        itemKey: $c6681824c40745c9$var$itemKey,
        maxCount: maxTagCount
    });
});




const $e944cb596f2af6d9$var$SelectContent = /*#__PURE__*/ $ltGt3.forwardRef(function SelectContent(_, ref) {
    const { multiple: multiple, onInputKeyDown: onInputKeyDown, tabIndex: tabIndex } = (0, $345f9a9a228dd1cb$export$7785dec5a5aec756)();
    const baseProps = (0, $4355aa2c171e5629$export$2e2bcd8739ae039)();
    const { showSearch: showSearch } = baseProps;
    const ariaProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(baseProps, {
        aria: true
    });
    const sharedInputProps = {
        ...ariaProps,
        onKeyDown: onInputKeyDown,
        readOnly: !showSearch,
        tabIndex: tabIndex
    };
    if (multiple) return /*#__PURE__*/ $ltGt3.createElement((0, $c6681824c40745c9$export$2e2bcd8739ae039), {
        ref: ref,
        inputProps: sharedInputProps
    });
    return /*#__PURE__*/ $ltGt3.createElement((0, $91c8347b19ddccce$export$2e2bcd8739ae039), {
        ref: ref,
        inputProps: sharedInputProps
    });
});
var $e944cb596f2af6d9$export$2e2bcd8739ae039 = $e944cb596f2af6d9$var$SelectContent;







function $675c33ba3a619885$export$48ac81d4a07c29c(currentKeyCode) {
    return(// Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    currentKeyCode && // Other keys
    ![
        // System function button
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).ESC,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).SHIFT,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).BACKSPACE,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).TAB,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).WIN_KEY,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).ALT,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).META,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).WIN_KEY_RIGHT,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).CTRL,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).SEMICOLON,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).EQUALS,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).CAPS_LOCK,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).CONTEXT_MENU,
        // Arrow keys - should not trigger open when navigating in input
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).UP,
        // KeyCode.DOWN,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).LEFT,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).RIGHT,
        // F1-F12
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).F1,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).F2,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).F3,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).F4,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).F5,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).F6,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).F7,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).F8,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).F9,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).F10,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).F11,
        (0, $b0616a5421b43292$export$2e2bcd8739ae039).F12
    ].includes(currentKeyCode));
}





function $be2c730b52319502$var$_extends() {
    $be2c730b52319502$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $be2c730b52319502$var$_extends.apply(this, arguments);
}
const $be2c730b52319502$var$DEFAULT_OMIT_PROPS = [
    'value',
    'onChange',
    'removeIcon',
    'placeholder',
    'maxTagCount',
    'maxTagTextLength',
    'maxTagPlaceholder',
    'choiceTransitionName',
    'onInputKeyDown',
    'onPopupScroll',
    'tabIndex',
    'activeValue',
    'onSelectorRemove',
    'focused'
];
var $be2c730b52319502$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.forwardRef(function SelectInput(props, ref) {
    const { prefixCls: // Style
    prefixCls, className: className, style: style, prefix: // UI
    prefix, suffix: suffix, clearIcon: clearIcon, children: children, multiple: // Data
    multiple, displayValues: displayValues, placeholder: placeholder, mode: mode, searchValue: // Search
    searchValue, onSearch: onSearch, onSearchSubmit: onSearchSubmit, onInputBlur: onInputBlur, maxLength: // Input
    maxLength, autoFocus: autoFocus, onMouseDown: // Events
    onMouseDown, onBlur: onBlur, onClearMouseDown: onClearMouseDown, onInputKeyDown: onInputKeyDown, onSelectorRemove: onSelectorRemove, tokenWithEnter: // Token handling
    tokenWithEnter, components: // Components
    components, ...restProps } = props;
    const { triggerOpen: triggerOpen, toggleOpen: toggleOpen, showSearch: showSearch, disabled: disabled, loading: loading, classNames: classNames, styles: styles } = (0, $4355aa2c171e5629$export$2e2bcd8739ae039)();
    const rootRef = $ltGt3.useRef(null);
    const inputRef = $ltGt3.useRef(null);
    // Handle keyboard events similar to original Selector
    const onInternalInputKeyDown = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((event)=>{
        const { which: which } = event;
        // Compatible with multiple lines in TextArea
        const isTextAreaElement = inputRef.current instanceof HTMLTextAreaElement;
        // Prevent default behavior for up/down arrows when dropdown is open
        if (!isTextAreaElement && triggerOpen && (which === (0, $b0616a5421b43292$export$2e2bcd8739ae039).UP || which === (0, $b0616a5421b43292$export$2e2bcd8739ae039).DOWN)) event.preventDefault();
        // Call the original onInputKeyDown callback
        if (onInputKeyDown) onInputKeyDown(event);
        // Move within the text box for TextArea
        if (isTextAreaElement && !triggerOpen && ~[
            (0, $b0616a5421b43292$export$2e2bcd8739ae039).UP,
            (0, $b0616a5421b43292$export$2e2bcd8739ae039).DOWN,
            (0, $b0616a5421b43292$export$2e2bcd8739ae039).LEFT,
            (0, $b0616a5421b43292$export$2e2bcd8739ae039).RIGHT
        ].indexOf(which)) return;
        // Open dropdown when a valid open key is pressed
        if ((0, $675c33ba3a619885$export$48ac81d4a07c29c)(which)) toggleOpen(true);
    });
    // ====================== Refs ======================
    $ltGt3.useImperativeHandle(ref, ()=>{
        return {
            focus: (options)=>{
                // Focus the inner input if available, otherwise fall back to root div.
                (inputRef.current || rootRef.current).focus?.(options);
            },
            blur: ()=>{
                (inputRef.current || rootRef.current).blur?.();
            },
            nativeElement: rootRef.current
        };
    });
    // ====================== Open ======================
    const onInternalMouseDown = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((event)=>{
        if (!disabled) {
            if (event.target !== (0, $8e3ff42e4a468fd4$export$9aa546fdc20ae5b3)(inputRef.current)) event.preventDefault();
            // Check if we should prevent closing when clicking on selector
            // Don't close if: open && not multiple && (combobox mode || showSearch)
            const shouldPreventClose = triggerOpen && !multiple && (mode === 'combobox' || showSearch);
            if (!event.nativeEvent._select_lazy) {
                inputRef.current?.focus();
                // Only toggle open if we should not prevent close
                if (!shouldPreventClose) toggleOpen();
            } else if (triggerOpen) // Lazy should also close when click clear icon
            toggleOpen(false);
        }
        onMouseDown?.(event);
    });
    const onInternalBlur = (event)=>{
        toggleOpen(false);
        onBlur?.(event);
    };
    // =================== Components ===================
    const { root: RootComponent } = components;
    // ===================== Render =====================
    const domProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(restProps, $be2c730b52319502$var$DEFAULT_OMIT_PROPS);
    // Create context value with wrapped callbacks
    const contextValue = {
        ...props,
        onInputKeyDown: onInternalInputKeyDown
    };
    if (RootComponent) {
        if (/*#__PURE__*/ $ltGt3.isValidElement(RootComponent)) return /*#__PURE__*/ $ltGt3.cloneElement(RootComponent, {
            ...domProps,
            ref: (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(RootComponent.ref, rootRef)
        });
        return /*#__PURE__*/ $ltGt3.createElement(RootComponent, $be2c730b52319502$var$_extends({}, domProps, {
            ref: rootRef
        }));
    }
    return /*#__PURE__*/ $ltGt3.createElement((0, $345f9a9a228dd1cb$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $ltGt3.createElement("div", $be2c730b52319502$var$_extends({}, domProps, {
        // Style
        ref: rootRef,
        className: className,
        style: style,
        onMouseDown: onInternalMouseDown,
        onBlur: onInternalBlur
    }), /*#__PURE__*/ $ltGt3.createElement((0, $de25f86d60aa9886$export$2e2bcd8739ae039), {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
        style: styles?.prefix
    }, prefix), /*#__PURE__*/ $ltGt3.createElement((0, $e944cb596f2af6d9$export$2e2bcd8739ae039), {
        ref: inputRef
    }), /*#__PURE__*/ $ltGt3.createElement((0, $de25f86d60aa9886$export$2e2bcd8739ae039), {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, {
            [`${prefixCls}-suffix-loading`]: loading
        }, classNames?.suffix),
        style: styles?.suffix
    }, suffix), clearIcon && /*#__PURE__*/ $ltGt3.createElement((0, $de25f86d60aa9886$export$2e2bcd8739ae039), {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-clear`, classNames?.clear),
        style: styles?.clear,
        onMouseDown: (e)=>{
            // Mark to tell not trigger open or focus
            e.nativeEvent._select_lazy = true;
            onClearMouseDown?.(e);
        }
    }, clearIcon), children));
});



var $ltGt3 = parcelRequire("ltGt3");
function $5151d37524203046$export$2e2bcd8739ae039(components, getInputElement, getRawInputElement) {
    return $ltGt3.useMemo(()=>{
        let { root: root, input: input } = components || {};
        // root: getRawInputElement
        if (getRawInputElement) root = getRawInputElement();
        // input: getInputElement
        if (getInputElement) input = getInputElement();
        return {
            root: root,
            input: input
        };
    }, [
        components,
        getInputElement,
        getRawInputElement
    ]);
}


function $0212801eed50d95a$var$_extends() {
    $0212801eed50d95a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0212801eed50d95a$var$_extends.apply(this, arguments);
}
const $0212801eed50d95a$export$7f654ad2a77ad2ac = (mode)=>mode === 'tags' || mode === 'multiple';
const $0212801eed50d95a$var$BaseSelect = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { id: id, prefixCls: prefixCls, className: className, styles: styles, classNames: classNames, showSearch: showSearch, tagRender: tagRender, showScrollBar: showScrollBar = 'optional', direction: direction, omitDomProps: omitDomProps, displayValues: // Value
    displayValues, onDisplayValuesChange: onDisplayValuesChange, emptyOptions: emptyOptions, notFoundContent: notFoundContent = 'Not Found', onClear: onClear, maxCount: maxCount, placeholder: placeholder, mode: // Mode
    mode, disabled: // Status
    disabled, loading: loading, getInputElement: // Customize Input
    getInputElement, getRawInputElement: getRawInputElement, open: // Open
    open, defaultOpen: defaultOpen, onPopupVisibleChange: onPopupVisibleChange, activeValue: // Active
    activeValue, onActiveValueChange: onActiveValueChange, activeDescendantId: activeDescendantId, searchValue: // Search
    searchValue, autoClearSearchValue: autoClearSearchValue, onSearch: onSearch, onSearchSplit: onSearchSplit, tokenSeparators: tokenSeparators, allowClear: // Icons
    allowClear, prefix: prefix, suffix: suffix, suffixIcon: suffixIcon, clearIcon: clearIcon, OptionList: // Dropdown
    OptionList, animation: animation, transitionName: transitionName, popupStyle: popupStyle, popupClassName: popupClassName, popupMatchSelectWidth: popupMatchSelectWidth, popupRender: popupRender, popupAlign: popupAlign, placement: placement, builtinPlacements: builtinPlacements, getPopupContainer: getPopupContainer, showAction: // Focus
    showAction = [], onFocus: onFocus, onBlur: onBlur, onKeyUp: // Rest Events
    onKeyUp, onKeyDown: onKeyDown, onMouseDown: onMouseDown, components: // Components
    components, // Rest Props
    ...restProps } = props;
    // ============================== MISC ==============================
    const multiple = $0212801eed50d95a$export$7f654ad2a77ad2ac(mode);
    // ============================== Refs ==============================
    const containerRef = $ltGt3.useRef(null);
    const triggerRef = $ltGt3.useRef(null);
    const listRef = $ltGt3.useRef(null);
    /** Used for component focused management */ const [focused, setFocused] = $ltGt3.useState(false);
    // =========================== Imperative ===========================
    $ltGt3.useImperativeHandle(ref, ()=>({
            focus: containerRef.current?.focus,
            blur: containerRef.current?.blur,
            scrollTo: (arg)=>listRef.current?.scrollTo(arg),
            nativeElement: (0, $8e3ff42e4a468fd4$export$9aa546fdc20ae5b3)(containerRef.current)
        }));
    // =========================== Components ===========================
    const mergedComponents = (0, $5151d37524203046$export$2e2bcd8739ae039)(components, getInputElement, getRawInputElement);
    // ========================== Search Value ==========================
    const mergedSearchValue = $ltGt3.useMemo(()=>{
        if (mode !== 'combobox') return searchValue;
        const val = displayValues[0]?.value;
        return typeof val === 'string' || typeof val === 'number' ? String(val) : '';
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    const customizeInputElement = mode === 'combobox' && typeof getInputElement === 'function' && getInputElement() || null;
    // ============================== Open ==============================
    // Not trigger `open` when `notFoundContent` is empty
    const emptyListContent = !notFoundContent && emptyOptions;
    const [mergedOpen, triggerOpen] = (0, $db6a7a97604bab3f$export$2e2bcd8739ae039)(open, onPopupVisibleChange, (nextOpen)=>disabled || emptyListContent ? false : nextOpen);
    // ============================= Search =============================
    const tokenWithEnter = $ltGt3.useMemo(()=>(tokenSeparators || []).some((tokenSeparator)=>[
                '\n',
                '\r\n'
            ].includes(tokenSeparator)), [
        tokenSeparators
    ]);
    const onInternalSearch = (searchText, fromTyping, isCompositing)=>{
        if (multiple && (0, $14c96dd516b10eb8$export$be48fd776273e509)(maxCount) && displayValues.length >= maxCount) return;
        let ret = true;
        let newSearchText = searchText;
        onActiveValueChange?.(null);
        const separatedList = (0, $14c96dd516b10eb8$export$a09ca2a89e052b14)(searchText, tokenSeparators, (0, $14c96dd516b10eb8$export$be48fd776273e509)(maxCount) ? maxCount - displayValues.length : undefined);
        // Check if match the `tokenSeparators`
        const patchLabels = isCompositing ? null : separatedList;
        // Ignore combobox since it's not split-able
        if (mode !== 'combobox' && patchLabels) {
            newSearchText = '';
            onSearchSplit?.(patchLabels);
            // Should close when paste finish
            triggerOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? 'typing' : 'effect'
        });
        // Open if from typing
        if (searchText && fromTyping && ret) triggerOpen(true);
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    const onInternalSearchSubmit = (searchText)=>{
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: 'submit'
        });
    };
    // Close will clean up single mode search text
    $ltGt3.useEffect(()=>{
        if (!mergedOpen && !multiple && mode !== 'combobox') onInternalSearch('', false, false);
    }, [
        mergedOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $ltGt3.useEffect(()=>{
        // After onBlur is triggered, the focused does not need to be reset
        if (disabled) {
            triggerOpen(false);
            setFocused(false);
        }
    }, [
        disabled,
        mergedOpen
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ const [getClearLock, setClearLock] = (0, $ad6ddf8b1a04d2b6$export$2e2bcd8739ae039)();
    const keyLockRef = $ltGt3.useRef(false);
    // KeyDown
    const onInternalKeyDown = (event)=>{
        const clearLock = getClearLock();
        const { key: key } = event;
        const isEnterKey = key === 'Enter';
        if (isEnterKey) {
            // Do not submit form when type in the input
            if (mode !== 'combobox') event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) triggerOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (key === 'Backspace' && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            const cloneDisplayValues = [
                ...displayValues
            ];
            let removedDisplayValue = null;
            for(let i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                const current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: 'remove',
                values: [
                    removedDisplayValue
                ]
            });
        }
        if (mergedOpen && (!isEnterKey || !keyLockRef.current)) {
            // Lock the Enter key after it is pressed to avoid repeated triggering of the onChange event.
            if (isEnterKey) keyLockRef.current = true;
            listRef.current?.onKeyDown(event);
        }
        onKeyDown?.(event);
    };
    // KeyUp
    const onInternalKeyUp = (event, ...rest)=>{
        if (mergedOpen) listRef.current?.onKeyUp(event, ...rest);
        if (event.key === 'Enter') keyLockRef.current = false;
        onKeyUp?.(event, ...rest);
    };
    // ============================ Selector ============================
    const onSelectorRemove = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((val)=>{
        const newValues = displayValues.filter((i)=>i !== val);
        onDisplayValuesChange(newValues, {
            type: 'remove',
            values: [
                val
            ]
        });
    });
    const onInputBlur = ()=>{
        // Unlock the Enter key after the input blur; otherwise, the Enter key needs to be pressed twice to trigger the correct effect.
        keyLockRef.current = false;
    };
    // ========================== Focus / Blur ==========================
    /** Record real focus status */ // const focusRef = React.useRef<boolean>(false);
    const onInternalFocus = (event)=>{
        setFocused(true);
        if (!disabled) {
            // `showAction` should handle `focus` if set
            if (showAction.includes('focus')) triggerOpen(true);
            onFocus?.(event);
        }
    };
    const onInternalBlur = (event)=>{
        setFocused(false);
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === 'tags') onSearch(mergedSearchValue, {
                source: 'submit'
            });
            else if (mode === 'multiple') // `multiple` mode only clean the search value but not trigger event
            onSearch('', {
                source: 'blur'
            });
        }
        if (!disabled) {
            triggerOpen(false, {
                lazy: true
            });
            onBlur?.(event);
        }
    };
    const onInternalMouseDown = (event, ...restArgs)=>{
        const { target: target } = event;
        const popupElement = triggerRef.current?.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement?.contains(target) && triggerOpen) // Tell `open` not to close since it's safe in the popup
        triggerOpen(true, {
            ignoreNext: true
        });
        onMouseDown?.(event, ...restArgs);
    };
    // ============================ Dropdown ============================
    const [, forceUpdate] = $ltGt3.useState({});
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    // Used for raw custom input trigger
    let onTriggerVisibleChange;
    if (!!mergedComponents.root) onTriggerVisibleChange = (newOpen)=>{
        triggerOpen(newOpen);
    };
    // Close when click on non-select element
    (0, $e1b57023a0a59503$export$2e2bcd8739ae039)(()=>[
            (0, $8e3ff42e4a468fd4$export$9aa546fdc20ae5b3)(containerRef.current),
            triggerRef.current?.getPopupElement()
        ], mergedOpen, triggerOpen, !!mergedComponents.root);
    // ============================ Context =============================
    const baseSelectContext = $ltGt3.useMemo(()=>({
            ...props,
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: mergedOpen,
            id: id,
            showSearch: showSearch,
            multiple: multiple,
            toggleOpen: triggerOpen,
            showScrollBar: showScrollBar,
            styles: styles,
            classNames: classNames
        }), [
        props,
        notFoundContent,
        triggerOpen,
        id,
        showSearch,
        multiple,
        mergedOpen,
        showScrollBar,
        styles,
        classNames
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Suffix =============================
    const mergedSuffixIcon = $ltGt3.useMemo(()=>{
        const nextSuffix = suffix ?? suffixIcon;
        if (typeof nextSuffix === 'function') return nextSuffix({
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: focused,
            showSearch: showSearch,
            loading: loading
        });
        return nextSuffix;
    }, [
        suffix,
        suffixIcon,
        mergedSearchValue,
        mergedOpen,
        focused,
        showSearch,
        loading
    ]);
    // ============================= Clear ==============================
    const onClearMouseDown = ()=>{
        onClear?.();
        containerRef.current?.focus();
        onDisplayValuesChange([], {
            type: 'clear',
            values: displayValues
        });
        onInternalSearch('', false, false);
    };
    const { allowClear: mergedAllowClear, clearIcon: clearNode } = (0, $42ec8993e0fac769$export$9ea6397a890aa3e5)(prefixCls, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode);
    // =========================== OptionList ===========================
    const optionList = /*#__PURE__*/ $ltGt3.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    const mergedClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-focused`]: focused,
        [`${prefixCls}-multiple`]: multiple,
        [`${prefixCls}-single`]: !multiple,
        [`${prefixCls}-allow-clear`]: mergedAllowClear,
        [`${prefixCls}-show-arrow`]: mergedSuffixIcon !== undefined && mergedSuffixIcon !== null,
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-open`]: mergedOpen,
        [`${prefixCls}-customize-input`]: customizeInputElement,
        [`${prefixCls}-show-search`]: showSearch
    });
    // >>> Render
    let renderNode = /*#__PURE__*/ $ltGt3.createElement((0, $be2c730b52319502$export$2e2bcd8739ae039), $0212801eed50d95a$var$_extends({}, restProps, {
        // Ref
        ref: containerRef,
        prefixCls: prefixCls,
        className: mergedClassName,
        focused: focused,
        prefix: prefix,
        suffix: mergedSuffixIcon,
        clearIcon: clearNode,
        multiple: multiple,
        mode: mode,
        displayValues: displayValues,
        placeholder: placeholder,
        searchValue: mergedSearchValue,
        activeValue: activeValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onInputBlur: onInputBlur,
        onFocus: onInternalFocus,
        onBlur: onInternalBlur,
        onClearMouseDown: onClearMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onSelectorRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter,
        onMouseDown: onInternalMouseDown,
        components: mergedComponents
    }));
    renderNode = /*#__PURE__*/ $ltGt3.createElement((0, $cedcd86b1501e91d$export$2e2bcd8739ae039), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: mergedOpen,
        popupElement: optionList,
        animation: animation,
        transitionName: transitionName,
        popupStyle: popupStyle,
        popupClassName: popupClassName,
        direction: direction,
        popupMatchSelectWidth: popupMatchSelectWidth,
        popupRender: popupRender,
        popupAlign: popupAlign,
        placement: placement,
        builtinPlacements: builtinPlacements,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter,
        onPopupMouseDown: onInternalMouseDown
    }, renderNode);
    return /*#__PURE__*/ $ltGt3.createElement((0, $4355aa2c171e5629$export$8234047c0aea33cf).Provider, {
        value: baseSelectContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $8f608e3f689bbb33$export$2e2bcd8739ae039), {
        visible: focused && !mergedOpen,
        values: displayValues
    }), renderNode);
});
var $0212801eed50d95a$export$2e2bcd8739ae039 = $0212801eed50d95a$var$BaseSelect;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ const $54bdc5481d013c5f$var$OptGroup = ()=>null;
$54bdc5481d013c5f$var$OptGroup.isSelectOptGroup = true;
var $54bdc5481d013c5f$export$2e2bcd8739ae039 = $54bdc5481d013c5f$var$OptGroup;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ const $eb61c81cc9919308$var$Option = ()=>null;
$eb61c81cc9919308$var$Option.isSelectOption = true;
var $eb61c81cc9919308$export$2e2bcd8739ae039 = $eb61c81cc9919308$var$Option;


















var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");


/**
 * Fill component to provided the scroll content real height.
 */ var $3cb592791f3f1114$var$Filler = /*#__PURE__*/ $ltGt3.forwardRef(function(_ref, ref) {
    var height = _ref.height, offsetY = _ref.offsetY, offsetX = _ref.offsetX, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize, innerProps = _ref.innerProps, rtl = _ref.rtl, extra = _ref.extra;
    var outerStyle = {};
    var innerStyle = {
        display: 'flex',
        flexDirection: 'column'
    };
    if (offsetY !== undefined) {
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: 'relative',
            overflow: 'hidden'
        };
        innerStyle = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, innerStyle), {}, (0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $db13280b58f1be94$export$2e2bcd8739ae039)({
            transform: "translateY(".concat(offsetY, "px)")
        }, rtl ? 'marginRight' : 'marginLeft', -offsetX), "position", 'absolute'), "left", 0), "right", 0), "top", 0));
    }
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $ltGt3.createElement((0, $c0ae8c1f3442c045$export$2e2bcd8739ae039), {
        onResize: function onResize(_ref2) {
            var offsetHeight = _ref2.offsetHeight;
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $ltGt3.createElement("div", (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
        style: innerStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))((0, $db13280b58f1be94$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
        ref: ref
    }, innerProps), children, extra)));
});
$3cb592791f3f1114$var$Filler.displayName = 'Filler';
var $3cb592791f3f1114$export$2e2bcd8739ae039 = $3cb592791f3f1114$var$Filler;



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
function $f5ff9856465372ba$export$6d08773d2e66f8f2(_ref) {
    var children = _ref.children, setRef = _ref.setRef;
    var refFunc = $ltGt3.useCallback(function(node) {
        setRef(node);
    }, []);
    return /*#__PURE__*/ $ltGt3.cloneElement(children, {
        ref: refFunc
    });
}


function $f4beb0710991ef99$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, _ref) {
    var getKey = _ref.getKey;
    return list.slice(startIndex, endIndex + 1).map(function(item, index) {
        var eleIndex = startIndex + index;
        var node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            },
            offsetX: offsetX
        });
        var key = getKey(item);
        return /*#__PURE__*/ $ltGt3.createElement((0, $f5ff9856465372ba$export$6d08773d2e66f8f2), {
            key: key,
            setRef: function setRef(ele) {
                return setNodeRef(item, ele);
            }
        }, node);
    });
}




var $ltGt3 = parcelRequire("ltGt3");
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $fd5fea9b01a99774$export$38f9023d45dd4a23(min, max, start, index) {
    var beforeCount = start - min;
    var afterCount = max - start;
    var balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        var stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $fd5fea9b01a99774$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    var originLen = originList.length;
    var targetLen = targetList.length;
    var shortList;
    var longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    var notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    var diffIndex = null;
    var multiple = Math.abs(originLen - targetLen) !== 1;
    for(var i = 0; i < longList.length; i += 1){
        var shortKey = getItemKey(shortList[i]);
        var longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}


function $444d6d2030aac184$export$2e2bcd8739ae039(data, getKey, onDiff) {
    var _React$useState = $ltGt3.useState(data), _React$useState2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
    var _React$useState3 = $ltGt3.useState(null), _React$useState4 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
    $ltGt3.useEffect(function() {
        var diff = (0, $fd5fea9b01a99774$export$418b8d8b03eefdf5)(prevData || [], data || [], getKey);
        if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
            onDiff === null || onDiff === void 0 || onDiff(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}




var $ltGt3 = parcelRequire("ltGt3");

var $6475df8f2c735901$var$isFF = (typeof navigator === "undefined" ? "undefined" : (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(navigator)) === 'object' && /Firefox/i.test(navigator.userAgent);
var $6475df8f2c735901$export$2e2bcd8739ae039 = $6475df8f2c735901$var$isFF;



var $ltGt3 = parcelRequire("ltGt3");
var $9283d8aa93996fa2$export$2e2bcd8739ae039 = function(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight) {
    // Do lock for a wheel when scrolling
    var lockRef = (0, $ltGt3.useRef)(false);
    var lockTimeoutRef = (0, $ltGt3.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(function() {
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    var scrollPingRef = (0, $ltGt3.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom,
        left: isScrollAtLeft,
        right: isScrollAtRight
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    scrollPingRef.current.left = isScrollAtLeft;
    scrollPingRef.current.right = isScrollAtRight;
    return function(isHorizontal, delta) {
        var smoothOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var originScroll = isHorizontal ? // Pass origin wheel when on the left
        delta < 0 && scrollPingRef.current.left || // Pass origin wheel when on the right
        delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
         : delta < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        delta > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};


function $a553db67a0110465$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    var offsetRef = (0, $ltGt3.useRef)(0);
    var nextFrameRef = (0, $ltGt3.useRef)(null);
    // Firefox patch
    var wheelValueRef = (0, $ltGt3.useRef)(null);
    var isMouseScrollRef = (0, $ltGt3.useRef)(false);
    // Scroll status sync
    var originScroll = (0, $9283d8aa93996fa2$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    function onWheelY(e, deltaY) {
        (0, $58a270f25a81b367$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(false, deltaY)) return;
        // Skip if nest List has handled this event
        var event = e;
        if (!event._virtualHandled) event._virtualHandled = true;
        else return;
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Proxy of scroll events
        if (!(0, $6475df8f2c735901$export$2e2bcd8739ae039)) event.preventDefault();
        nextFrameRef.current = (0, $58a270f25a81b367$export$2e2bcd8739ae039)(function() {
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            var patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple, false);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $6475df8f2c735901$export$2e2bcd8739ae039)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    var wheelDirectionRef = (0, $ltGt3.useRef)(null);
    var wheelDirectionCleanRef = (0, $ltGt3.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $58a270f25a81b367$export$2e2bcd8739ae039).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $58a270f25a81b367$export$2e2bcd8739ae039)(function() {
            wheelDirectionRef.current = null;
        }, 2);
        var deltaX = event.deltaX, deltaY = event.deltaY, shiftKey = event.shiftKey;
        var mergedDeltaX = deltaX;
        var mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === 'sx' || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = 'sx';
        }
        var absX = Math.abs(mergedDeltaX);
        var absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? 'x' : 'y';
        if (wheelDirectionRef.current === 'y') onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}




var $ltGt3 = parcelRequire("ltGt3");
function $e6a06d861bce5530$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    var _React$useMemo = $ltGt3.useMemo(function() {
        return [
            new Map(),
            []
        ];
    }, [
        mergedData,
        heights.id,
        itemHeight
    ]), _React$useMemo2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_React$useMemo, 2), key2Index = _React$useMemo2[0], bottomList = _React$useMemo2[1];
    var getSize = function getSize(startKey) {
        var endKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startKey;
        // Get from cache first
        var startIndex = key2Index.get(startKey);
        var endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            var dataLen = mergedData.length;
            for(var i = bottomList.length; i < dataLen; i += 1){
                var _heights$get;
                var item = mergedData[i];
                var key = getKey(item);
                key2Index.set(key, i);
                var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}




var $ltGt3 = parcelRequire("ltGt3");



// Firefox has low performance of map.
var $7bbeddc4a72e4ad4$var$CacheMap = /*#__PURE__*/ function() {
    function CacheMap() {
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, CacheMap);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "maps", void 0);
        // Used for cache key
        // `useMemo` no need to update if `id` not change
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "id", 0);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "diffRecords", new Map());
        this.maps = Object.create(null);
    }
    (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(CacheMap, [
        {
            key: "set",
            value: function set(key, value) {
                // Record prev value
                this.diffRecords.set(key, this.maps[key]);
                this.maps[key] = value;
                this.id += 1;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.maps[key];
            }
        },
        {
            key: "resetRecord",
            value: function resetRecord() {
                this.diffRecords.clear();
            }
        },
        {
            key: "getRecord",
            value: function getRecord() {
                return this.diffRecords;
            }
        }
    ]);
    return CacheMap;
}();
var $7bbeddc4a72e4ad4$export$2e2bcd8739ae039 = $7bbeddc4a72e4ad4$var$CacheMap;


function $3bd78506ec72a06d$var$parseNumber(value) {
    var num = parseFloat(value);
    return isNaN(num) ? 0 : num;
}
function $3bd78506ec72a06d$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    var _React$useState = $ltGt3.useState(0), _React$useState2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
    var instanceRef = (0, $ltGt3.useRef)(new Map());
    var heightsRef = (0, $ltGt3.useRef)(new (0, $7bbeddc4a72e4ad4$export$2e2bcd8739ae039)());
    var promiseIdRef = (0, $ltGt3.useRef)(0);
    function cancelRaf() {
        promiseIdRef.current += 1;
    }
    function collectHeight() {
        var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        cancelRaf();
        var doCollect = function doCollect() {
            var changed = false;
            instanceRef.current.forEach(function(element, key) {
                if (element && element.offsetParent) {
                    var offsetHeight = element.offsetHeight;
                    var _getComputedStyle = getComputedStyle(element), marginTop = _getComputedStyle.marginTop, marginBottom = _getComputedStyle.marginBottom;
                    var marginTopNum = $3bd78506ec72a06d$var$parseNumber(marginTop);
                    var marginBottomNum = $3bd78506ec72a06d$var$parseNumber(marginBottom);
                    var totalHeight = offsetHeight + marginTopNum + marginBottomNum;
                    if (heightsRef.current.get(key) !== totalHeight) {
                        heightsRef.current.set(key, totalHeight);
                        changed = true;
                    }
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            if (changed) setUpdatedMark(function(c) {
                return c + 1;
            });
        };
        if (sync) doCollect();
        else {
            promiseIdRef.current += 1;
            var id = promiseIdRef.current;
            Promise.resolve().then(function() {
                if (id === promiseIdRef.current) doCollect();
            });
        }
    }
    function setInstanceRef(item, instance) {
        var key = getKey(item);
        var origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current.delete(key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd === null || onItemAdd === void 0 || onItemAdd(item);
            else onItemRemove === null || onItemRemove === void 0 || onItemRemove(item);
        }
    }
    (0, $ltGt3.useEffect)(function() {
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}




var $ltGt3 = parcelRequire("ltGt3");
var $03c7b0bde6220255$var$SMOOTH_PTG = 14 / 15;
function $03c7b0bde6220255$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    var touchedRef = (0, $ltGt3.useRef)(false);
    var touchXRef = (0, $ltGt3.useRef)(0);
    var touchYRef = (0, $ltGt3.useRef)(0);
    var elementRef = (0, $ltGt3.useRef)(null);
    // Smooth scroll
    var intervalRef = (0, $ltGt3.useRef)(null);
    /* eslint-disable prefer-const */ var cleanUpEvents;
    var onTouchMove = function onTouchMove(e) {
        if (touchedRef.current) {
            var currentX = Math.ceil(e.touches[0].pageX);
            var currentY = Math.ceil(e.touches[0].pageY);
            var offsetX = touchXRef.current - currentX;
            var offsetY = touchYRef.current - currentY;
            var _isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
            if (_isHorizontal) touchXRef.current = currentX;
            else touchYRef.current = currentY;
            var scrollHandled = callback(_isHorizontal, _isHorizontal ? offsetX : offsetY, false, e);
            if (scrollHandled) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            if (scrollHandled) intervalRef.current = setInterval(function() {
                if (_isHorizontal) offsetX *= $03c7b0bde6220255$var$SMOOTH_PTG;
                else offsetY *= $03c7b0bde6220255$var$SMOOTH_PTG;
                var offset = Math.floor(_isHorizontal ? offsetX : offsetY);
                if (!callback(_isHorizontal, offset, true) || Math.abs(offset) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    var onTouchEnd = function onTouchEnd() {
        touchedRef.current = false;
        cleanUpEvents();
    };
    var onTouchStart = function onTouchStart(e) {
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchXRef.current = Math.ceil(e.touches[0].pageX);
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener('touchmove', onTouchMove, {
                passive: false
            });
            elementRef.current.addEventListener('touchend', onTouchEnd, {
                passive: true
            });
        }
    };
    cleanUpEvents = function cleanUpEvents() {
        if (elementRef.current) {
            elementRef.current.removeEventListener('touchmove', onTouchMove);
            elementRef.current.removeEventListener('touchend', onTouchEnd);
        }
    };
    (0, $956f158068638b56$export$2e2bcd8739ae039)(function() {
        if (inVirtual) listRef.current.addEventListener('touchstart', onTouchStart, {
            passive: true
        });
        return function() {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener('touchstart', onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}





var $ltGt3 = parcelRequire("ltGt3");
function $00ba94275d34c889$var$smoothScrollOffset(offset) {
    return Math.floor(Math.pow(offset, 0.5));
}
function $00ba94275d34c889$export$dbd0143e191dc2e5(e, horizontal) {
    var obj = 'touches' in e ? e.touches[0] : e;
    return obj[horizontal ? 'pageX' : 'pageY'] - window[horizontal ? 'scrollX' : 'scrollY'];
}
function $00ba94275d34c889$export$2e2bcd8739ae039(inVirtual, componentRef, onScrollOffset) {
    $ltGt3.useEffect(function() {
        var ele = componentRef.current;
        if (inVirtual && ele) {
            var mouseDownLock = false;
            var rafId;
            var _offset;
            var stopScroll = function stopScroll() {
                (0, $58a270f25a81b367$export$2e2bcd8739ae039).cancel(rafId);
            };
            var continueScroll = function continueScroll() {
                stopScroll();
                rafId = (0, $58a270f25a81b367$export$2e2bcd8739ae039)(function() {
                    onScrollOffset(_offset);
                    continueScroll();
                });
            };
            var clearDragState = function clearDragState() {
                mouseDownLock = false;
                stopScroll();
            };
            var onMouseDown = function onMouseDown(e) {
                // Skip if element set draggable
                if (e.target.draggable || e.button !== 0) return;
                // Skip if nest List has handled this event
                var event = e;
                if (!event._virtualHandled) {
                    event._virtualHandled = true;
                    mouseDownLock = true;
                }
            };
            var onMouseMove = function onMouseMove(e) {
                if (mouseDownLock) {
                    var mouseY = $00ba94275d34c889$export$dbd0143e191dc2e5(e, false);
                    var _ele$getBoundingClien = ele.getBoundingClientRect(), top = _ele$getBoundingClien.top, bottom = _ele$getBoundingClien.bottom;
                    if (mouseY <= top) {
                        var diff = top - mouseY;
                        _offset = -$00ba94275d34c889$var$smoothScrollOffset(diff);
                        continueScroll();
                    } else if (mouseY >= bottom) {
                        var _diff = mouseY - bottom;
                        _offset = $00ba94275d34c889$var$smoothScrollOffset(_diff);
                        continueScroll();
                    } else stopScroll();
                }
            };
            ele.addEventListener('mousedown', onMouseDown);
            ele.ownerDocument.addEventListener('mouseup', clearDragState);
            ele.ownerDocument.addEventListener('mousemove', onMouseMove);
            ele.ownerDocument.addEventListener('dragend', clearDragState);
            return function() {
                ele.removeEventListener('mousedown', onMouseDown);
                ele.ownerDocument.removeEventListener('mouseup', clearDragState);
                ele.ownerDocument.removeEventListener('mousemove', onMouseMove);
                ele.ownerDocument.removeEventListener('dragend', clearDragState);
                stopScroll();
            };
        }
    }, [
        inVirtual
    ]);
}






var $ltGt3 = parcelRequire("ltGt3");



var $496c4c702e604045$var$MAX_TIMES = 10;
function $496c4c702e604045$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
    var scrollRef = $ltGt3.useRef();
    var _React$useState = $ltGt3.useState(null), _React$useState2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_React$useState, 2), syncState = _React$useState2[0], setSyncState = _React$useState2[1];
    // ========================== Sync Scroll ==========================
    (0, $956f158068638b56$export$2e2bcd8739ae039)(function() {
        if (syncState && syncState.times < $496c4c702e604045$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState(function(ori) {
                    return (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, ori);
                });
                return;
            }
            collectHeight();
            var targetAlign = syncState.targetAlign, originAlign = syncState.originAlign, index = syncState.index, offset = syncState.offset;
            var height = containerRef.current.clientHeight;
            var needCollectHeight = false;
            var newTargetAlign = targetAlign;
            var targetTop = null;
            // Go to next frame if height not exist
            if (height) {
                var mergedAlign = targetAlign || originAlign;
                // Get top & bottom
                var stackTop = 0;
                var itemTop = 0;
                var itemBottom = 0;
                var maxLen = Math.min(data.length - 1, index);
                for(var i = 0; i <= maxLen; i += 1){
                    var key = getKey(data[i]);
                    itemTop = stackTop;
                    var cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                var leftHeight = mergedAlign === 'top' ? offset : height - offset;
                for(var _i = maxLen; _i >= 0; _i -= 1){
                    var _key = getKey(data[_i]);
                    var _cacheHeight = heights.get(_key);
                    if (_cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= _cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case 'top':
                        targetTop = itemTop - offset;
                        break;
                    case 'bottom':
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        var scrollTop = containerRef.current.scrollTop;
                        var scrollBottom = scrollTop + height;
                        if (itemTop < scrollTop) newTargetAlign = 'top';
                        else if (itemBottom > scrollBottom) newTargetAlign = 'bottom';
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, syncState), {}, {
                times: syncState.times + 1,
                targetAlign: newTargetAlign,
                lastTop: targetTop
            }));
        }
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return function(arg) {
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $58a270f25a81b367$export$2e2bcd8739ae039).cancel(scrollRef.current);
        if (typeof arg === 'number') syncScrollTop(arg);
        else if (arg && (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(arg) === 'object') {
            var index;
            var align = arg.align;
            if ('index' in arg) index = arg.index;
            else index = data.findIndex(function(item) {
                return getKey(item) === arg.key;
            });
            var _arg$offset = arg.offset, offset = _arg$offset === void 0 ? 0 : _arg$offset;
            setSyncState({
                times: 0,
                index: index,
                offset: offset,
                originAlign: align
            });
        }
    };
}








var $ltGt3 = parcelRequire("ltGt3");

var $1b9751af6332b8a4$var$ScrollBar = /*#__PURE__*/ $ltGt3.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, rtl = props.rtl, scrollOffset = props.scrollOffset, scrollRange = props.scrollRange, onStartMove = props.onStartMove, onStopMove = props.onStopMove, onScroll = props.onScroll, horizontal = props.horizontal, spinSize = props.spinSize, containerSize = props.containerSize, style = props.style, propsThumbStyle = props.thumbStyle, showScrollBar = props.showScrollBar;
    var _React$useState = $ltGt3.useState(false), _React$useState2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_React$useState, 2), dragging = _React$useState2[0], setDragging = _React$useState2[1];
    var _React$useState3 = $ltGt3.useState(null), _React$useState4 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_React$useState3, 2), pageXY = _React$useState4[0], setPageXY = _React$useState4[1];
    var _React$useState5 = $ltGt3.useState(null), _React$useState6 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_React$useState5, 2), startTop = _React$useState6[0], setStartTop = _React$useState6[1];
    var isLTR = !rtl;
    // ========================= Refs =========================
    var scrollbarRef = $ltGt3.useRef();
    var thumbRef = $ltGt3.useRef();
    // ======================= Visible ========================
    var _React$useState7 = $ltGt3.useState(showScrollBar), _React$useState8 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_React$useState7, 2), visible = _React$useState8[0], setVisible = _React$useState8[1];
    var visibleTimeoutRef = $ltGt3.useRef();
    var delayHidden = function delayHidden() {
        if (showScrollBar === true || showScrollBar === false) return;
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(function() {
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    var enableScrollRange = scrollRange - containerSize || 0;
    var enableOffsetRange = containerSize - spinSize || 0;
    // ========================= Top ==========================
    var top = $ltGt3.useMemo(function() {
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        var ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    var onContainerMouseDown = function onContainerMouseDown(e) {
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Thumb =========================
    var stateRef = $ltGt3.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    var onThumbMouseDown = function onThumbMouseDown(e) {
        setDragging(true);
        setPageXY((0, $00ba94275d34c889$export$dbd0143e191dc2e5)(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $ltGt3.useEffect(function() {
        var onScrollbarTouchStart = function onScrollbarTouchStart(e) {
            e.preventDefault();
        };
        var scrollbarEle = scrollbarRef.current;
        var thumbEle = thumbRef.current;
        scrollbarEle.addEventListener('touchstart', onScrollbarTouchStart, {
            passive: false
        });
        thumbEle.addEventListener('touchstart', onThumbMouseDown, {
            passive: false
        });
        return function() {
            scrollbarEle.removeEventListener('touchstart', onScrollbarTouchStart);
            thumbEle.removeEventListener('touchstart', onThumbMouseDown);
        };
    }, []);
    // Pass to effect
    var enableScrollRangeRef = $ltGt3.useRef();
    enableScrollRangeRef.current = enableScrollRange;
    var enableOffsetRangeRef = $ltGt3.useRef();
    enableOffsetRangeRef.current = enableOffsetRange;
    $ltGt3.useEffect(function() {
        if (dragging) {
            var moveRafId;
            var onMouseMove = function onMouseMove(e) {
                var _stateRef$current = stateRef.current, stateDragging = _stateRef$current.dragging, statePageY = _stateRef$current.pageY, stateStartTop = _stateRef$current.startTop;
                (0, $58a270f25a81b367$export$2e2bcd8739ae039).cancel(moveRafId);
                var rect = scrollbarRef.current.getBoundingClientRect();
                var scale = containerSize / (horizontal ? rect.width : rect.height);
                if (stateDragging) {
                    var offset = ((0, $00ba94275d34c889$export$dbd0143e191dc2e5)(e, horizontal) - statePageY) * scale;
                    var newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    var tmpEnableScrollRange = enableScrollRangeRef.current;
                    var tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
                    var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
                    newScrollTop = Math.max(newScrollTop, 0);
                    newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
                    moveRafId = (0, $58a270f25a81b367$export$2e2bcd8739ae039)(function() {
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            var onMouseUp = function onMouseUp() {
                setDragging(false);
                onStopMove();
            };
            window.addEventListener('mousemove', onMouseMove, {
                passive: true
            });
            window.addEventListener('touchmove', onMouseMove, {
                passive: true
            });
            window.addEventListener('mouseup', onMouseUp, {
                passive: true
            });
            window.addEventListener('touchend', onMouseUp, {
                passive: true
            });
            return function() {
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('touchmove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
                window.removeEventListener('touchend', onMouseUp);
                (0, $58a270f25a81b367$export$2e2bcd8739ae039).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $ltGt3.useEffect(function() {
        delayHidden();
        return function() {
            clearTimeout(visibleTimeoutRef.current);
        };
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $ltGt3.useImperativeHandle(ref, function() {
        return {
            delayHidden: delayHidden
        };
    });
    // ======================== Render ========================
    var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
    var containerStyle = {
        position: 'absolute',
        visibility: visible ? null : 'hidden'
    };
    var thumbStyle = {
        position: 'absolute',
        borderRadius: 99,
        background: 'var(--rc-virtual-list-scrollbar-bg, rgba(0, 0, 0, 0.5))',
        cursor: 'pointer',
        userSelect: 'none'
    };
    if (horizontal) {
        Object.assign(containerStyle, {
            height: 8,
            left: 0,
            right: 0,
            bottom: 0
        });
        Object.assign(thumbStyle, (0, $db13280b58f1be94$export$2e2bcd8739ae039)({
            height: '100%',
            width: spinSize
        }, isLTR ? 'left' : 'right', top));
    } else {
        Object.assign(containerStyle, (0, $db13280b58f1be94$export$2e2bcd8739ae039)({
            width: 8,
            top: 0,
            bottom: 0
        }, isLTR ? 'right' : 'left', 0));
        Object.assign(thumbStyle, {
            width: '100%',
            height: spinSize,
            top: top
        });
    }
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: scrollbarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(scrollbarPrefixCls, (0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $db13280b58f1be94$export$2e2bcd8739ae039)((0, $db13280b58f1be94$export$2e2bcd8739ae039)({}, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), "".concat(scrollbarPrefixCls, "-visible"), visible)),
        style: (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, containerStyle), style),
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: thumbRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))("".concat(scrollbarPrefixCls, "-thumb"), (0, $db13280b58f1be94$export$2e2bcd8739ae039)({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
        style: (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, thumbStyle), propsThumbStyle),
        onMouseDown: onThumbMouseDown
    }));
});
var $1b9751af6332b8a4$export$2e2bcd8739ae039 = $1b9751af6332b8a4$var$ScrollBar;


var $d91956f51945fca6$var$MIN_SIZE = 20;
function $d91956f51945fca6$export$f2ca68955ab35ace() {
    var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var baseSize = containerSize / scrollRange * containerSize;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $d91956f51945fca6$var$MIN_SIZE);
    return Math.floor(baseSize);
}


var $9560b977f10d74d2$var$_excluded = [
    "prefixCls",
    "className",
    "height",
    "itemHeight",
    "fullHeight",
    "style",
    "data",
    "children",
    "itemKey",
    "virtual",
    "direction",
    "scrollWidth",
    "component",
    "onScroll",
    "onVirtualScroll",
    "onVisibleChange",
    "innerProps",
    "extraRender",
    "styles",
    "showScrollBar"
];
var $9560b977f10d74d2$var$EMPTY_DATA = [];
var $9560b977f10d74d2$var$ScrollStyle = {
    overflowY: 'auto',
    overflowAnchor: 'none'
};
function $9560b977f10d74d2$export$cc3be4e46e8486ed(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-virtual-list' : _props$prefixCls, className = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style = props.style, data = props.data, children = props.children, itemKey = props.itemKey, virtual = props.virtual, direction = props.direction, scrollWidth = props.scrollWidth, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, onScroll = props.onScroll, onVirtualScroll = props.onVirtualScroll, onVisibleChange = props.onVisibleChange, innerProps = props.innerProps, extraRender = props.extraRender, styles = props.styles, _props$showScrollBar = props.showScrollBar, showScrollBar = _props$showScrollBar === void 0 ? 'optional' : _props$showScrollBar, restProps = (0, $289081aecb178230$export$2e2bcd8739ae039)(props, $9560b977f10d74d2$var$_excluded);
    // =============================== Item Key ===============================
    var getKey = $ltGt3.useCallback(function(item) {
        if (typeof itemKey === 'function') return itemKey(item);
        return item === null || item === void 0 ? void 0 : item[itemKey];
    }, [
        itemKey
    ]);
    // ================================ Height ================================
    var _useHeights = (0, $3bd78506ec72a06d$export$2e2bcd8739ae039)(getKey, null, null), _useHeights2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
    // ================================= MISC =================================
    var useVirtual = !!(virtual !== false && height && itemHeight);
    var containerHeight = $ltGt3.useMemo(function() {
        return Object.values(heights.maps).reduce(function(total, curr) {
            return total + curr;
        }, 0);
    }, [
        heights.id,
        heights.maps
    ]);
    var inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
    var isRTL = direction === 'rtl';
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prefixCls, (0, $db13280b58f1be94$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-rtl"), isRTL), className);
    var mergedData = data || $9560b977f10d74d2$var$EMPTY_DATA;
    var componentRef = (0, $ltGt3.useRef)();
    var fillerInnerRef = (0, $ltGt3.useRef)();
    var containerRef = (0, $ltGt3.useRef)();
    // =============================== Item Key ===============================
    var _useState = (0, $ltGt3.useState)(0), _useState2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useState, 2), offsetTop = _useState2[0], setOffsetTop = _useState2[1];
    var _useState3 = (0, $ltGt3.useState)(0), _useState4 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useState3, 2), offsetLeft = _useState4[0], setOffsetLeft = _useState4[1];
    var _useState5 = (0, $ltGt3.useState)(false), _useState6 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useState5, 2), scrollMoving = _useState6[0], setScrollMoving = _useState6[1];
    var onScrollbarStartMove = function onScrollbarStartMove() {
        setScrollMoving(true);
    };
    var onScrollbarStopMove = function onScrollbarStopMove() {
        setScrollMoving(false);
    };
    var sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop(function(origin) {
            var value;
            if (typeof newTop === 'function') value = newTop(origin);
            else value = newTop;
            var alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    var rangeRef = (0, $ltGt3.useRef)({
        start: 0,
        end: mergedData.length
    });
    var diffItemRef = (0, $ltGt3.useRef)();
    var _useDiffItem = (0, $444d6d2030aac184$export$2e2bcd8739ae039)(mergedData, getKey), _useDiffItem2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useDiffItem, 1), diffItem = _useDiffItem2[0];
    diffItemRef.current = diffItem;
    // ========================== Visible Calculation =========================
    var _React$useMemo = $ltGt3.useMemo(function() {
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) {
            var _fillerInnerRef$curre;
            return {
                scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
                start: 0,
                end: mergedData.length - 1,
                offset: undefined
            };
        }
        var itemTop = 0;
        var startIndex;
        var startOffset;
        var endIndex;
        var dataLen = mergedData.length;
        for(var i = 0; i < dataLen; i += 1){
            var _item = mergedData[i];
            var key = getKey(_item);
            var cacheHeight = heights.get(key);
            var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, fillerOffset = _React$useMemo.offset;
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // When scroll up, first visible item get real height may not same as `itemHeight`,
    // Which will make scroll jump.
    // Let's sync scroll top to avoid jump
    $ltGt3.useLayoutEffect(function() {
        var changedRecord = heights.getRecord();
        if (changedRecord.size === 1) {
            var recordKey = Array.from(changedRecord.keys())[0];
            var prevCacheHeight = changedRecord.get(recordKey);
            // Quick switch data may cause `start` not in `mergedData` anymore
            var startItem = mergedData[start];
            if (startItem && prevCacheHeight === undefined) {
                var startIndexKey = getKey(startItem);
                if (startIndexKey === recordKey) {
                    var realStartHeight = heights.get(recordKey);
                    var diffHeight = realStartHeight - itemHeight;
                    syncScrollTop(function(ori) {
                        return ori + diffHeight;
                    });
                }
            }
        }
        heights.resetRecord();
    }, [
        scrollHeight
    ]);
    // ================================= Size =================================
    var _React$useState = $ltGt3.useState({
        width: 0,
        height: height
    }), _React$useState2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_React$useState, 2), size = _React$useState2[0], setSize = _React$useState2[1];
    var onHolderResize = function onHolderResize(sizeInfo) {
        setSize({
            width: sizeInfo.offsetWidth,
            height: sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    var verticalScrollBarRef = (0, $ltGt3.useRef)();
    var horizontalScrollBarRef = (0, $ltGt3.useRef)();
    var horizontalScrollBarSpinSize = $ltGt3.useMemo(function() {
        return (0, $d91956f51945fca6$export$f2ca68955ab35ace)(size.width, scrollWidth);
    }, [
        size.width,
        scrollWidth
    ]);
    var verticalScrollBarSpinSize = $ltGt3.useMemo(function() {
        return (0, $d91956f51945fca6$export$f2ca68955ab35ace)(size.height, scrollHeight);
    }, [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    var maxScrollHeight = scrollHeight - height;
    var maxScrollHeightRef = (0, $ltGt3.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        var newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    var isScrollAtTop = offsetTop <= 0;
    var isScrollAtBottom = offsetTop >= maxScrollHeight;
    var isScrollAtLeft = offsetLeft <= 0;
    var isScrollAtRight = offsetLeft >= scrollWidth;
    var originScroll = (0, $9283d8aa93996fa2$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    // ================================ Scroll ================================
    var getVirtualScrollInfo = function getVirtualScrollInfo() {
        return {
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        };
    };
    var lastVirtualScrollInfoRef = (0, $ltGt3.useRef)(getVirtualScrollInfo());
    var triggerScroll = (0, $a7f17bc7a54333b8$export$2e2bcd8739ae039)(function(params) {
        if (onVirtualScroll) {
            var nextInfo = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, getVirtualScrollInfo()), params);
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        var newOffset = newScrollOffset;
        if (horizontal) {
            (0, $35c0fb1a856c78db$exports.flushSync)(function() {
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        var newScrollTop = e.currentTarget.scrollTop;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll === null || onScroll === void 0 || onScroll(e);
        triggerScroll();
    }
    var keepInHorizontalRange = function keepInHorizontalRange(nextOffsetLeft) {
        var tmpOffsetLeft = nextOffsetLeft;
        var max = !!scrollWidth ? scrollWidth - size.width : 0;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    var onWheelDelta = (0, $a7f17bc7a54333b8$export$2e2bcd8739ae039)(function(offsetXY, fromHorizontal) {
        if (fromHorizontal) {
            (0, $35c0fb1a856c78db$exports.flushSync)(function() {
                setOffsetLeft(function(left) {
                    var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop(function(top) {
            var newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    var _useFrameWheel = (0, $a553db67a0110465$export$2e2bcd8739ae039)(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta), _useFrameWheel2 = (0, $d8ac74b6587c5b61$export$2e2bcd8739ae039)(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
    // Mobile touch move
    (0, $03c7b0bde6220255$export$2e2bcd8739ae039)(useVirtual, componentRef, function(isHorizontal, delta, smoothOffset, e) {
        var event = e;
        if (originScroll(isHorizontal, delta, smoothOffset)) return false;
        // Fix nest List trigger TouchMove event
        if (!event || !event._virtualHandled) {
            if (event) event._virtualHandled = true;
            onRawWheel({
                preventDefault: function preventDefault() {},
                deltaX: isHorizontal ? delta : 0,
                deltaY: isHorizontal ? 0 : delta
            });
            return true;
        }
        return false;
    });
    // MouseDown drag for scroll
    (0, $00ba94275d34c889$export$2e2bcd8739ae039)(inVirtual, componentRef, function(offset) {
        syncScrollTop(function(top) {
            return top + offset;
        });
    });
    (0, $956f158068638b56$export$2e2bcd8739ae039)(function() {
        // Firefox only
        function onMozMousePixelScroll(e) {
            // scrolling at top/bottom limit
            var scrollingUpAtTop = isScrollAtTop && e.detail < 0;
            var scrollingDownAtBottom = isScrollAtBottom && e.detail > 0;
            if (useVirtual && !scrollingUpAtTop && !scrollingDownAtBottom) e.preventDefault();
        }
        var componentEle = componentRef.current;
        componentEle.addEventListener('wheel', onRawWheel, {
            passive: false
        });
        componentEle.addEventListener('DOMMouseScroll', onFireFoxScroll, {
            passive: true
        });
        componentEle.addEventListener('MozMousePixelScroll', onMozMousePixelScroll, {
            passive: false
        });
        return function() {
            componentEle.removeEventListener('wheel', onRawWheel);
            componentEle.removeEventListener('DOMMouseScroll', onFireFoxScroll);
            componentEle.removeEventListener('MozMousePixelScroll', onMozMousePixelScroll);
        };
    }, [
        useVirtual,
        isScrollAtTop,
        isScrollAtBottom
    ]);
    // Sync scroll left
    (0, $956f158068638b56$export$2e2bcd8739ae039)(function() {
        if (scrollWidth) {
            var newOffsetLeft = keepInHorizontalRange(offsetLeft);
            setOffsetLeft(newOffsetLeft);
            triggerScroll({
                x: newOffsetLeft
            });
        }
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    var delayHideScrollBar = function delayHideScrollBar() {
        var _verticalScrollBarRef, _horizontalScrollBarR;
        (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
        (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
    };
    var _scrollTo = (0, $496c4c702e604045$export$2e2bcd8739ae039)(componentRef, mergedData, heights, itemHeight, getKey, function() {
        return collectHeight(true);
    }, syncScrollTop, delayHideScrollBar);
    $ltGt3.useImperativeHandle(ref, function() {
        return {
            nativeElement: containerRef.current,
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: function scrollTo(config) {
                function isPosScroll(arg) {
                    return arg && (0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(arg) === 'object' && ('left' in arg || 'top' in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    _scrollTo(config.top);
                } else _scrollTo(config);
            }
        };
    });
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $956f158068638b56$export$2e2bcd8739ae039)(function() {
        if (onVisibleChange) {
            var renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    var getSize = (0, $e6a06d861bce5530$export$a1d82723752af087)(mergedData, getKey, heights, itemHeight);
    var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    var listChildren = (0, $f4beb0710991ef99$export$2e2bcd8739ae039)(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
    var componentStyle = null;
    if (height) {
        componentStyle = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $db13280b58f1be94$export$2e2bcd8739ae039)({}, fullHeight ? 'height' : 'maxHeight', height), $9560b977f10d74d2$var$ScrollStyle);
        if (useVirtual) {
            componentStyle.overflowY = 'hidden';
            if (scrollWidth) componentStyle.overflowX = 'hidden';
            if (scrollMoving) componentStyle.pointerEvents = 'none';
        }
    }
    var containerProps = {};
    if (isRTL) containerProps.dir = 'rtl';
    return /*#__PURE__*/ $ltGt3.createElement("div", (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
        ref: containerRef,
        style: (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, style), {}, {
            position: 'relative'
        }),
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $ltGt3.createElement((0, $c0ae8c1f3442c045$export$2e2bcd8739ae039), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $ltGt3.createElement(Component, {
        className: "".concat(prefixCls, "-holder"),
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $ltGt3.createElement((0, $3cb592791f3f1114$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $ltGt3.createElement((0, $1b9751af6332b8a4$export$2e2bcd8739ae039), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb,
        showScrollBar: showScrollBar
    }), inVirtual && scrollWidth > size.width && /*#__PURE__*/ $ltGt3.createElement((0, $1b9751af6332b8a4$export$2e2bcd8739ae039), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb,
        showScrollBar: showScrollBar
    }));
}
var $9560b977f10d74d2$var$List = /*#__PURE__*/ $ltGt3.forwardRef($9560b977f10d74d2$export$cc3be4e46e8486ed);
$9560b977f10d74d2$var$List.displayName = 'List';
var $9560b977f10d74d2$export$2e2bcd8739ae039 = $9560b977f10d74d2$var$List;


var $8ef74e3e8155f759$export$2e2bcd8739ae039 = (0, $9560b977f10d74d2$export$2e2bcd8739ae039);



var $ltGt3 = parcelRequire("ltGt3");



/* istanbul ignore file */ function $af63eece12f7518c$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}



function $157b239b0ae4f4e2$var$_extends() {
    $157b239b0ae4f4e2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $157b239b0ae4f4e2$var$_extends.apply(this, arguments);
}
// export interface OptionListProps<OptionsType extends object[]> {
function $157b239b0ae4f4e2$var$isTitleType(content) {
    return typeof content === 'string' || typeof content === 'number';
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ const $157b239b0ae4f4e2$var$OptionList = (_, ref)=>{
    const { prefixCls: prefixCls, id: id, open: open, multiple: multiple, mode: mode, searchValue: searchValue, toggleOpen: toggleOpen, notFoundContent: notFoundContent, onPopupScroll: onPopupScroll, showScrollBar: showScrollBar } = (0, $4355aa2c171e5629$export$2e2bcd8739ae039)();
    const { maxCount: maxCount, flattenOptions: flattenOptions, onActiveValue: onActiveValue, defaultActiveFirstOption: defaultActiveFirstOption, onSelect: onSelect, menuItemSelectedIcon: menuItemSelectedIcon, rawValues: rawValues, fieldNames: fieldNames, virtual: virtual, direction: direction, listHeight: listHeight, listItemHeight: listItemHeight, optionRender: optionRender, classNames: contextClassNames, styles: contextStyles } = $ltGt3.useContext((0, $9d1864f321b932b3$export$2e2bcd8739ae039));
    const itemPrefixCls = `${prefixCls}-item`;
    const memoFlattenOptions = (0, $dcca1fcd5fa22f3b$export$2e2bcd8739ae039)(()=>flattenOptions, [
        open,
        flattenOptions
    ], (prev, next)=>next[0] && prev[1] !== next[1]);
    // =========================== List ===========================
    const listRef = $ltGt3.useRef(null);
    const overMaxCount = $ltGt3.useMemo(()=>multiple && (0, $14c96dd516b10eb8$export$be48fd776273e509)(maxCount) && rawValues?.size >= maxCount, [
        multiple,
        maxCount,
        rawValues?.size
    ]);
    const onListMouseDown = (event)=>{
        event.preventDefault();
    };
    const scrollIntoView = (args)=>{
        listRef.current?.scrollTo(typeof args === 'number' ? {
            index: args
        } : args);
    };
    // https://github.com/ant-design/ant-design/issues/34975
    const isSelected = $ltGt3.useCallback((value)=>{
        if (mode === 'combobox') return false;
        return rawValues.has(value);
    }, [
        mode,
        [
            ...rawValues
        ].toString(),
        rawValues.size
    ]);
    // ========================== Active ==========================
    const getEnabledActiveIndex = (index, offset = 1)=>{
        const len = memoFlattenOptions.length;
        for(let i = 0; i < len; i += 1){
            const current = (index + i * offset + len) % len;
            const { group: group, data: data } = memoFlattenOptions[current] || {};
            if (!group && !data?.disabled && (isSelected(data.value) || !overMaxCount)) return current;
        }
        return -1;
    };
    const [activeIndex, setActiveIndex] = $ltGt3.useState(()=>getEnabledActiveIndex(0));
    const setActive = (index, fromKeyboard = false)=>{
        setActiveIndex(index);
        const info = {
            source: fromKeyboard ? 'keyboard' : 'mouse'
        };
        // Trigger active event
        const flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $ltGt3.useEffect)(()=>{
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/48036
    const isAriaSelected = $ltGt3.useCallback((value)=>{
        if (mode === 'combobox') return String(value).toLowerCase() === searchValue.toLowerCase();
        return rawValues.has(value);
    }, [
        mode,
        searchValue,
        [
            ...rawValues
        ].toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $ltGt3.useEffect)(()=>{
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ let timeoutId;
        if (!multiple && open && rawValues.size === 1) {
            const value = Array.from(rawValues)[0];
            // Scroll to the option closest to the searchValue if searching.
            const index = memoFlattenOptions.findIndex(({ data: data })=>searchValue ? String(data.value).startsWith(searchValue) : data.value === value);
            if (index !== -1) {
                setActive(index);
                timeoutId = setTimeout(()=>{
                    scrollIntoView(index);
                });
            }
        }
        // Force trigger scrollbar visible when open
        if (open) listRef.current?.scrollTo(undefined);
        return ()=>clearTimeout(timeoutId);
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    const onSelectValue = (value)=>{
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $ltGt3.useImperativeHandle(ref, ()=>({
            onKeyDown: (event)=>{
                const { which: which, ctrlKey: ctrlKey } = event;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $b0616a5421b43292$export$2e2bcd8739ae039).N:
                    case (0, $b0616a5421b43292$export$2e2bcd8739ae039).P:
                    case (0, $b0616a5421b43292$export$2e2bcd8739ae039).UP:
                    case (0, $b0616a5421b43292$export$2e2bcd8739ae039).DOWN:
                        {
                            let offset = 0;
                            if (which === (0, $b0616a5421b43292$export$2e2bcd8739ae039).UP) offset = -1;
                            else if (which === (0, $b0616a5421b43292$export$2e2bcd8739ae039).DOWN) offset = 1;
                            else if ((0, $af63eece12f7518c$export$3bbcfec016973a77)() && ctrlKey) {
                                if (which === (0, $b0616a5421b43292$export$2e2bcd8739ae039).N) offset = 1;
                                else if (which === (0, $b0616a5421b43292$export$2e2bcd8739ae039).P) offset = -1;
                            }
                            if (offset !== 0) {
                                const nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                                scrollIntoView(nextActiveIndex);
                                setActive(nextActiveIndex, true);
                            }
                            break;
                        }
                    // >>> Select (Tab / Enter)
                    case (0, $b0616a5421b43292$export$2e2bcd8739ae039).TAB:
                    case (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER:
                        {
                            // value
                            const item = memoFlattenOptions[activeIndex];
                            if (!item || item.data.disabled) return onSelectValue(undefined);
                            if (!overMaxCount || rawValues.has(item.value)) onSelectValue(item.value);
                            else onSelectValue(undefined);
                            if (open) event.preventDefault();
                            break;
                        }
                    // >>> Close
                    case (0, $b0616a5421b43292$export$2e2bcd8739ae039).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: ()=>{},
            scrollTo: (index)=>{
                scrollIntoView(index);
            }
        }));
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $ltGt3.createElement("div", {
        role: "listbox",
        id: `${id}_list`,
        className: `${itemPrefixCls}-empty`,
        onMouseDown: onListMouseDown
    }, notFoundContent);
    const omitFieldNameList = Object.keys(fieldNames).map((key)=>fieldNames[key]);
    const getLabel = (item)=>item.label;
    function getItemAriaProps(item, index) {
        const { group: group } = item;
        return {
            role: group ? 'presentation' : 'option',
            id: `${id}_list_${index}`
        };
    }
    const renderItem = (index)=>{
        const item = memoFlattenOptions[index];
        if (!item) return null;
        const itemData = item.data || {};
        const { value: value } = itemData;
        const { group: group } = item;
        const attrs = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(itemData, true);
        const mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $ltGt3.createElement("div", $157b239b0ae4f4e2$var$_extends({
            "aria-label": typeof mergedLabel === 'string' && !group ? mergedLabel : null
        }, attrs, {
            key: index
        }, getItemAriaProps(item, index), {
            "aria-selected": isAriaSelected(value)
        }), value) : null;
    };
    const a11yProps = {
        role: 'listbox',
        id: `${id}_list`
    };
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, virtual && /*#__PURE__*/ $ltGt3.createElement("div", $157b239b0ae4f4e2$var$_extends({}, a11yProps, {
        style: {
            height: 0,
            width: 0,
            overflow: 'hidden'
        }
    }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $ltGt3.createElement((0, $8ef74e3e8155f759$export$2e2bcd8739ae039), {
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual,
        direction: direction,
        innerProps: virtual ? null : a11yProps,
        showScrollBar: showScrollBar,
        className: contextClassNames?.popup?.list,
        style: contextStyles?.popup?.list
    }, (item, itemIndex)=>{
        const { group: group, groupOption: groupOption, data: data, label: label, value: value } = item;
        const { key: key } = data;
        // Group
        if (group) {
            const groupTitle = data.title ?? ($157b239b0ae4f4e2$var$isTitleType(label) ? label.toString() : undefined);
            return /*#__PURE__*/ $ltGt3.createElement("div", {
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(itemPrefixCls, `${itemPrefixCls}-group`, data.className),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        const { disabled: disabled, title: title, children: children, style: style, className: className, ...otherProps } = data;
        const passedProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(otherProps, omitFieldNameList);
        // Option
        const selected = isSelected(value);
        const mergedDisabled = disabled || !selected && overMaxCount;
        const optionPrefixCls = `${itemPrefixCls}-option`;
        const optionClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(itemPrefixCls, optionPrefixCls, className, contextClassNames?.popup?.listItem, {
            [`${optionPrefixCls}-grouped`]: groupOption,
            [`${optionPrefixCls}-active`]: activeIndex === itemIndex && !mergedDisabled,
            [`${optionPrefixCls}-disabled`]: mergedDisabled,
            [`${optionPrefixCls}-selected`]: selected
        });
        const mergedLabel = getLabel(item);
        const iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === 'function' || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        const content = typeof mergedLabel === 'number' ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        let optionTitle = $157b239b0ae4f4e2$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $ltGt3.createElement("div", $157b239b0ae4f4e2$var$_extends({}, (0, $297f85de79f8d325$export$2e2bcd8739ae039)(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
            "aria-selected": virtual ? undefined : isAriaSelected(value),
            className: optionClassName,
            title: optionTitle,
            onMouseMove: ()=>{
                if (activeIndex === itemIndex || mergedDisabled) return;
                setActive(itemIndex);
            },
            onClick: ()=>{
                if (!mergedDisabled) onSelectValue(value);
            },
            style: {
                ...contextStyles?.popup?.listItem,
                ...style
            }
        }), /*#__PURE__*/ $ltGt3.createElement("div", {
            className: `${optionPrefixCls}-content`
        }, typeof optionRender === 'function' ? optionRender(item, {
            index: itemIndex
        }) : content), /*#__PURE__*/ $ltGt3.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $ltGt3.createElement((0, $68c5fd9ab6ff895c$export$2e2bcd8739ae039), {
            className: `${itemPrefixCls}-option-state`,
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                value: value,
                disabled: mergedDisabled,
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
const $157b239b0ae4f4e2$var$RefOptionList = /*#__PURE__*/ $ltGt3.forwardRef($157b239b0ae4f4e2$var$OptionList);
var $157b239b0ae4f4e2$export$2e2bcd8739ae039 = $157b239b0ae4f4e2$var$RefOptionList;




var $ltGt3 = parcelRequire("ltGt3");
var /**
 * Cache `value` related LabeledValue & options.
 */ $95986de7b1167786$export$2e2bcd8739ae039 = (labeledValues, valueOptions)=>{
    const cacheRef = $ltGt3.useRef({
        values: new Map(),
        options: new Map()
    });
    const filledLabeledValues = $ltGt3.useMemo(()=>{
        const { values: prevValueCache, options: prevOptionCache } = cacheRef.current;
        // Fill label by cache
        const patchedValues = labeledValues.map((item)=>{
            if (item.label === undefined) return {
                ...item,
                label: prevValueCache.get(item.value)?.label
            };
            return item;
        });
        // Refresh cache
        const valueCache = new Map();
        const optionCache = new Map();
        patchedValues.forEach((item)=>{
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    const getOption = $ltGt3.useCallback((val)=>valueOptions.get(val) || cacheRef.current.options.get(val), [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};



var $ltGt3 = parcelRequire("ltGt3");


function $2d6d8b97b888e2fe$var$includes(test, search) {
    return (0, $2a6d62b3faa5409a$export$45b10814cc054894)(test).join('').toUpperCase().includes(search);
}
var $2d6d8b97b888e2fe$export$2e2bcd8739ae039 = (options, fieldNames, searchValue, filterOption, optionFilterProp)=>$ltGt3.useMemo(()=>{
        if (!searchValue || filterOption === false) return options;
        const { options: fieldOptions, label: fieldLabel, value: fieldValue } = fieldNames;
        const filteredOptions = [];
        const customizeFilter = typeof filterOption === 'function';
        const upperSearch = searchValue.toUpperCase();
        const filterFunc = customizeFilter ? filterOption : (_, option)=>{
            // Use provided `optionFilterProp`
            if (optionFilterProp) return $2d6d8b97b888e2fe$var$includes(option[optionFilterProp], upperSearch);
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $2d6d8b97b888e2fe$var$includes(option[fieldLabel !== 'children' ? fieldLabel : 'label'], upperSearch);
            return $2d6d8b97b888e2fe$var$includes(option[fieldValue], upperSearch);
        };
        const wrapOption = customizeFilter ? (opt)=>(0, $14c96dd516b10eb8$export$d0b21b213c8c013c)(opt) : (opt)=>opt;
        options.forEach((item)=>{
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                const matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    const subOptions = item[fieldOptions].filter((subItem)=>filterFunc(searchValue, wrapOption(subItem)));
                    if (subOptions.length) filteredOptions.push({
                        ...item,
                        [fieldOptions]: subOptions
                    });
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");

function $e2e96c7cb09f2659$var$convertNodeToOption(node) {
    const { key: key, props: { children: children, value: value, ...restProps } } = node;
    return {
        key: key,
        value: value !== undefined ? value : key,
        children: children,
        ...restProps
    };
}
function $e2e96c7cb09f2659$export$3beca35db74c3985(nodes, optionOnly = false) {
    return (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(nodes).map((node, index)=>{
        if (!/*#__PURE__*/ $ltGt3.isValidElement(node) || !node.type) return null;
        const { type: { isSelectOptGroup: isSelectOptGroup }, key: key, props: { children: children, ...restProps } } = node;
        if (optionOnly || !isSelectOptGroup) return $e2e96c7cb09f2659$var$convertNodeToOption(node);
        return {
            key: `__RC_SELECT_GRP__${key === null ? index : key}__`,
            label: key,
            ...restProps,
            options: $e2e96c7cb09f2659$export$3beca35db74c3985(children)
        };
    }).filter((data)=>data);
}


/**
 * Parse `children` to `options` if `options` is not provided.
 * Then flatten the `options`.
 */ const $1ca551bf2174be67$var$useOptions = (options, children, fieldNames, optionFilterProp, optionLabelProp)=>{
    return $ltGt3.useMemo(()=>{
        let mergedOptions = options;
        const childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $e2e96c7cb09f2659$export$3beca35db74c3985)(children);
        const valueOptions = new Map();
        const labelOptions = new Map();
        const setLabelOptions = (labelOptionsMap, option, key)=>{
            if (key && typeof key === 'string') labelOptionsMap.set(option[key], option);
        };
        const dig = (optionList, isChildren = false)=>{
            // for loop to speed up collection speed
            for(let i = 0; i < optionList.length; i += 1){
                const option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    setLabelOptions(labelOptions, option, optionFilterProp);
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        };
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
};
var $1ca551bf2174be67$export$2e2bcd8739ae039 = $1ca551bf2174be67$var$useOptions;



var $ltGt3 = parcelRequire("ltGt3");
function $80f2bdade211b9a3$export$2e2bcd8739ae039(callback) {
    const funcRef = $ltGt3.useRef();
    funcRef.current = callback;
    const cacheFn = $ltGt3.useCallback((...args)=>{
        return funcRef.current(...args);
    }, []);
    return cacheFn;
}







var $ltGt3 = parcelRequire("ltGt3");



function $1b982d8b27373b11$var$warningProps(props) {
    const { mode: mode, options: options, children: children, backfill: backfill, allowClear: allowClear, placeholder: placeholder, getInputElement: getInputElement, showSearch: showSearch, onSearch: onSearch, defaultOpen: defaultOpen, autoFocus: autoFocus, labelInValue: labelInValue, value: value, optionLabelProp: optionLabelProp } = props;
    const multiple = (0, $0212801eed50d95a$export$7f654ad2a77ad2ac)(mode);
    const mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === 'combobox';
    const mergedOptions = options || (0, $e2e96c7cb09f2659$export$3beca35db74c3985)(children);
    // `tags` should not set option as disabled
    (0, $474154b5a64067c8$export$2e2bcd8739ae039)(mode !== 'tags' || mergedOptions.every((opt)=>!opt.disabled), 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');
    // `combobox` & `tags` should option be `string` type
    if (mode === 'tags' || mode === 'combobox') {
        const hasNumberValue = mergedOptions.some((item)=>{
            if (item.options) return item.options.some((opt)=>typeof ('value' in opt ? opt.value : opt.key) === 'number');
            return typeof ('value' in item ? item.value : item.key) === 'number';
        });
        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!hasNumberValue, '`value` of Option should not use number type when `mode` is `tags` or `combobox`.');
    }
    // `combobox` should not use `optionLabelProp`
    (0, $474154b5a64067c8$export$2e2bcd8739ae039)(mode !== 'combobox' || !optionLabelProp, '`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.');
    // Only `combobox` support `backfill`
    (0, $474154b5a64067c8$export$2e2bcd8739ae039)(mode === 'combobox' || !backfill, '`backfill` only works with `combobox` mode.');
    // Only `combobox` support `getInputElement`
    (0, $474154b5a64067c8$export$2e2bcd8739ae039)(mode === 'combobox' || !getInputElement, '`getInputElement` only work with `combobox` mode.');
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $474154b5a64067c8$export$89ff31684837bbbf)(mode !== 'combobox' || !getInputElement || !allowClear || !placeholder, 'Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.');
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== 'combobox' && mode !== 'tags') (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, '`onSearch` should work with `showSearch` instead of use alone.');
    (0, $474154b5a64067c8$export$89ff31684837bbbf)(!defaultOpen || autoFocus, '`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.');
    if (value !== undefined && value !== null) {
        const values = (0, $2a6d62b3faa5409a$export$45b10814cc054894)(value);
        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!labelInValue || values.every((val)=>typeof val === 'object' && ('key' in val || 'value' in val)), '`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`');
        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!multiple || Array.isArray(value), '`value` should be array when `mode` is `multiple` or `tags`');
    }
    // Syntactic sugar should use correct children type
    if (children) {
        let invalidateChildType = null;
        (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children).some((node)=>{
            if (!/*#__PURE__*/ $ltGt3.isValidElement(node) || !node.type) return false;
            const { type: type } = node;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                const allChildrenValid = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(node.props.children).every((subNode)=>{
                    if (!/*#__PURE__*/ $ltGt3.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, `\`children\` should be \`Select.Option\` or \`Select.OptGroup\` instead of \`${invalidateChildType.displayName || invalidateChildType.name || invalidateChildType}\`.`);
    }
}
function $1b982d8b27373b11$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        const recursiveOptions = (optionsList, inGroup = false)=>{
            for(let i = 0; i < optionsList.length; i++){
                const option = optionsList[i];
                if (option[fieldNames?.value] === null) {
                    (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, '`value` in Select options should not be `null`.');
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames?.options]) && recursiveOptions(option[fieldNames?.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $1b982d8b27373b11$export$2e2bcd8739ae039 = $1b982d8b27373b11$var$warningProps;



var $ltGt3 = parcelRequire("ltGt3");
function $d2e3985f005ccb4b$export$2e2bcd8739ae039(showSearch, props, mode) {
    const { filterOption: filterOption, searchValue: searchValue, optionFilterProp: optionFilterProp, filterSort: filterSort, onSearch: onSearch, autoClearSearchValue: autoClearSearchValue } = props;
    return $ltGt3.useMemo(()=>{
        const isObject = typeof showSearch === 'object';
        const searchConfig = {
            filterOption: filterOption,
            searchValue: searchValue,
            optionFilterProp: optionFilterProp,
            filterSort: filterSort,
            onSearch: onSearch,
            autoClearSearchValue: autoClearSearchValue,
            ...isObject ? showSearch : {}
        };
        return [
            isObject || mode === 'combobox' || mode === 'tags' || mode === 'multiple' && showSearch === undefined ? true : showSearch,
            searchConfig
        ];
    }, [
        mode,
        showSearch,
        filterOption,
        searchValue,
        optionFilterProp,
        filterSort,
        onSearch,
        autoClearSearchValue
    ]);
}


function $f27f470688391bf9$var$_extends() {
    $f27f470688391bf9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f27f470688391bf9$var$_extends.apply(this, arguments);
}
const $f27f470688391bf9$var$OMIT_DOM_PROPS = [
    'inputValue'
];
function $f27f470688391bf9$var$isRawValue(value) {
    return !value || typeof value !== 'object';
}
const $f27f470688391bf9$var$Select = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { id: id, mode: mode, prefixCls: prefixCls = 'rc-select', backfill: backfill, fieldNames: fieldNames, showSearch: // Search
    showSearch, searchValue: legacySearchValue, onSearch: legacyOnSearch, autoClearSearchValue: legacyAutoClearSearchValue, filterOption: legacyFilterOption, optionFilterProp: legacyOptionFilterProp, filterSort: legacyFilterSort, onSelect: // Select
    onSelect, onDeselect: onDeselect, onActive: onActive, popupMatchSelectWidth: popupMatchSelectWidth = true, optionLabelProp: optionLabelProp, options: options, optionRender: optionRender, children: children, defaultActiveFirstOption: defaultActiveFirstOption, menuItemSelectedIcon: menuItemSelectedIcon, virtual: virtual, direction: direction, listHeight: listHeight = 200, listItemHeight: listItemHeight = 20, labelRender: labelRender, value: // Value
    value, defaultValue: defaultValue, labelInValue: labelInValue, onChange: onChange, maxCount: maxCount, classNames: classNames, styles: styles, ...restProps } = props;
    const searchProps = {
        searchValue: legacySearchValue,
        onSearch: legacyOnSearch,
        autoClearSearchValue: legacyAutoClearSearchValue,
        filterOption: legacyFilterOption,
        optionFilterProp: legacyOptionFilterProp,
        filterSort: legacyFilterSort
    };
    const [mergedShowSearch, searchConfig] = (0, $d2e3985f005ccb4b$export$2e2bcd8739ae039)(showSearch, searchProps, mode);
    const { filterOption: filterOption, searchValue: searchValue, optionFilterProp: optionFilterProp, filterSort: filterSort, onSearch: onSearch, autoClearSearchValue: autoClearSearchValue = true } = searchConfig;
    const mergedId = (0, $1fb03482b73301f3$export$2e2bcd8739ae039)(id);
    const multiple = (0, $0212801eed50d95a$export$7f654ad2a77ad2ac)(mode);
    const childrenAsData = !!(!options && children);
    const mergedFilterOption = $ltGt3.useMemo(()=>{
        if (filterOption === undefined && mode === 'combobox') return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    const mergedFieldNames = $ltGt3.useMemo(()=>(0, $14c96dd516b10eb8$export$6c519d302dced239)(fieldNames, childrenAsData), /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    const [internalSearchValue, setSearchValue] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)('', searchValue);
    const mergedSearchValue = internalSearchValue || '';
    // =========================== Option ===========================
    const parsedOptions = (0, $1ca551bf2174be67$export$2e2bcd8739ae039)(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
    const { valueOptions: valueOptions, labelOptions: labelOptions, options: mergedOptions } = parsedOptions;
    // ========================= Wrap Value =========================
    const convert2LabelValues = $ltGt3.useCallback((draftValues)=>{
        // Convert to array
        const valueList = (0, $2a6d62b3faa5409a$export$45b10814cc054894)(draftValues);
        // Convert to labelInValue type
        return valueList.map((val)=>{
            let rawValue;
            let rawLabel;
            let rawDisabled;
            let rawTitle;
            // Fill label & value
            if ($f27f470688391bf9$var$isRawValue(val)) rawValue = val;
            else {
                rawLabel = val.label;
                rawValue = val.value;
            }
            const option = valueOptions.get(rawValue);
            if (option) {
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option?.[optionLabelProp || mergedFieldNames.label];
                rawDisabled = option?.disabled;
                rawTitle = option?.title;
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawValue,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    const [internalValue, setInternalValue] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultValue, value);
    // Merged value with LabelValueType
    const rawLabeledValues = $ltGt3.useMemo(()=>{
        const newInternalValue = multiple && internalValue === null ? [] : internalValue;
        const values = convert2LabelValues(newInternalValue);
        // combobox no need save value when it's no value (exclude value equal 0)
        if (mode === 'combobox' && (0, $2a6d62b3faa5409a$export$9d186c3672bb89c6)(values[0]?.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode,
        multiple
    ]);
    // Fill label with cache to avoid option remove
    const [mergedValues, getMixedOption] = (0, $95986de7b1167786$export$2e2bcd8739ae039)(rawLabeledValues, valueOptions);
    const displayValues = $ltGt3.useMemo(()=>{
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            const firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map((item)=>({
                ...item,
                label: (typeof labelRender === 'function' ? labelRender(item) : item.label) ?? item.value
            }));
    }, [
        mode,
        mergedValues,
        labelRender
    ]);
    /** Convert `displayValues` to raw value type set */ const rawValues = $ltGt3.useMemo(()=>new Set(mergedValues.map((val)=>val.value)), [
        mergedValues
    ]);
    $ltGt3.useEffect(()=>{
        if (mode === 'combobox') {
            const strValue = mergedValues[0]?.value;
            setSearchValue((0, $2a6d62b3faa5409a$export$96bdbc84526f3739)(strValue) ? String(strValue) : '');
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    const createTagOption = (0, $80f2bdade211b9a3$export$2e2bcd8739ae039)((val, label)=>{
        const mergedLabel = label ?? val;
        return {
            [mergedFieldNames.value]: val,
            [mergedFieldNames.label]: mergedLabel
        };
    });
    // Fill tag as option if mode is `tags`
    const filledTagOptions = $ltGt3.useMemo(()=>{
        if (mode !== 'tags') return mergedOptions;
        // >>> Tag mode
        const cloneOptions = [
            ...mergedOptions
        ];
        // Check if value exist in options (include new patch item)
        const existOptions = (val)=>valueOptions.has(val);
        // Fill current value as option
        [
            ...mergedValues
        ].sort((a, b)=>a.value < b.value ? -1 : 1).forEach((item)=>{
            const val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    const filteredOptions = (0, $2d6d8b97b888e2fe$export$2e2bcd8739ae039)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);
    // Fill options with search value if needed
    const filledSearchOptions = $ltGt3.useMemo(()=>{
        if (mode !== 'tags' || !mergedSearchValue || filteredOptions.some((item)=>item[optionFilterProp || 'value'] === mergedSearchValue)) return filteredOptions;
        // ignore when search value equal select input value
        if (filteredOptions.some((item)=>item[mergedFieldNames.value] === mergedSearchValue)) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue),
            ...filteredOptions
        ];
    }, [
        createTagOption,
        optionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue,
        mergedFieldNames
    ]);
    const sorter = (inputOptions)=>{
        const sortedOptions = [
            ...inputOptions
        ].sort((a, b)=>filterSort(a, b, {
                searchValue: mergedSearchValue
            }));
        return sortedOptions.map((item)=>{
            if (Array.isArray(item.options)) return {
                ...item,
                options: item.options.length > 0 ? sorter(item.options) : item.options
            };
            return item;
        });
    };
    const orderedFilteredOptions = $ltGt3.useMemo(()=>{
        if (!filterSort) return filledSearchOptions;
        return sorter(filledSearchOptions);
    }, [
        filledSearchOptions,
        filterSort,
        mergedSearchValue
    ]);
    const displayOptions = $ltGt3.useMemo(()=>(0, $14c96dd516b10eb8$export$7baa7c13b358b002)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        }), [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    const triggerChange = (values)=>{
        const labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some((newVal, index)=>mergedValues[index]?.value !== newVal?.value))) {
            const returnValues = labelInValue ? labeledValues.map(({ label: l, value: v })=>({
                    label: l,
                    value: v
                })) : labeledValues.map((v)=>v.value);
            const returnOptions = labeledValues.map((v)=>(0, $14c96dd516b10eb8$export$d0b21b213c8c013c)(getMixedOption(v.value)));
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    const [activeValue, setActiveValue] = $ltGt3.useState(null);
    const [accessibilityIndex, setAccessibilityIndex] = $ltGt3.useState(0);
    const mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== 'combobox';
    const activeEventRef = $ltGt3.useRef();
    const onActiveValue = $ltGt3.useCallback((active, index, { source: source = 'keyboard' } = {})=>{
        setAccessibilityIndex(index);
        if (backfill && mode === 'combobox' && active !== null && source === 'keyboard') setActiveValue(String(active));
        // Active will call multiple times.
        // We only need trigger the last one.
        const promise = Promise.resolve().then(()=>{
            if (activeEventRef.current === promise) onActive?.(active);
        });
        activeEventRef.current = promise;
    }, [
        backfill,
        mode,
        onActive
    ]);
    // ========================= OptionList =========================
    const triggerSelect = (val, selected, type)=>{
        const getSelectEnt = ()=>{
            const option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option?.[mergedFieldNames.label],
                    value: val
                } : val,
                (0, $14c96dd516b10eb8$export$d0b21b213c8c013c)(option)
            ];
        };
        if (selected && onSelect) {
            const [wrappedValue, option] = getSelectEnt();
            onSelect(wrappedValue, option);
        } else if (!selected && onDeselect && type !== 'clear') {
            const [wrappedValue, option] = getSelectEnt();
            onDeselect(wrappedValue, option);
        }
    };
    // Used for OptionList selection
    const onInternalSelect = (0, $80f2bdade211b9a3$export$2e2bcd8739ae039)((val, info)=>{
        let cloneValues;
        // Single mode always trigger select only with option list
        const mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [
            ...mergedValues,
            val
        ] : [
            val
        ];
        else cloneValues = mergedValues.filter((v)=>v.value !== val);
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === 'combobox') setActiveValue('');
        else if (!(0, $0212801eed50d95a$export$7f654ad2a77ad2ac) || autoClearSearchValue) {
            setSearchValue('');
            setActiveValue('');
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    const onDisplayValuesChange = (nextValues, info)=>{
        triggerChange(nextValues);
        const { type: type, values: values } = info;
        if (type === 'remove' || type === 'clear') values.forEach((item)=>{
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    const onInternalSearch = (searchText, info)=>{
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === 'submit') {
            const formatted = (searchText || '').trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                const newRawValues = Array.from(new Set([
                    ...rawValues,
                    formatted
                ]));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue('');
            }
            return;
        }
        if (info.source !== 'blur') {
            if (mode === 'combobox') triggerChange(searchText);
            onSearch?.(searchText);
        }
    };
    const onInternalSearchSplit = (words)=>{
        let patchValues = words;
        if (mode !== 'tags') patchValues = words.map((word)=>{
            const opt = labelOptions.get(word);
            return opt?.value;
        }).filter((val)=>val !== undefined);
        const newRawValues = Array.from(new Set([
            ...rawValues,
            ...patchValues
        ]));
        triggerChange(newRawValues);
        newRawValues.forEach((newRawValue)=>{
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    const selectContext = $ltGt3.useMemo(()=>{
        const realVirtual = virtual !== false && popupMatchSelectWidth !== false;
        return {
            ...parsedOptions,
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            direction: direction,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData,
            maxCount: maxCount,
            optionRender: optionRender,
            classNames: classNames,
            styles: styles
        };
    }, [
        maxCount,
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        popupMatchSelectWidth,
        direction,
        listHeight,
        listItemHeight,
        childrenAsData,
        optionRender,
        classNames,
        styles
    ]);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $ltGt3.createElement((0, $9d1864f321b932b3$export$2e2bcd8739ae039).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $0212801eed50d95a$export$2e2bcd8739ae039), $f27f470688391bf9$var$_extends({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $f27f470688391bf9$var$OMIT_DOM_PROPS,
        mode: mode,
        classNames: classNames,
        styles: styles,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        maxCount: maxCount,
        direction: direction,
        showSearch: mergedShowSearch,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        popupMatchSelectWidth: popupMatchSelectWidth,
        OptionList: (0, $157b239b0ae4f4e2$export$2e2bcd8739ae039),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: `${mergedId}_list_${accessibilityIndex}`
    })));
});
const $f27f470688391bf9$var$TypedSelect = $f27f470688391bf9$var$Select;
$f27f470688391bf9$var$TypedSelect.Option = (0, $eb61c81cc9919308$export$2e2bcd8739ae039);
$f27f470688391bf9$var$TypedSelect.OptGroup = (0, $54bdc5481d013c5f$export$2e2bcd8739ae039);
var $f27f470688391bf9$export$2e2bcd8739ae039 = $f27f470688391bf9$var$TypedSelect;






var $aa74d02ab8b95e62$export$2e2bcd8739ae039 = (0, $f27f470688391bf9$export$2e2bcd8739ae039);












var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");






var $ltGt3 = parcelRequire("ltGt3");



"use client";
const $415e52e79276a25e$var$Empty = ()=>{
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const [locale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Empty');
    const bgColor = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(token.colorBgBase);
    // Dark Theme need more dark of this
    const themeStyle = bgColor.toHsl().l < 0.5 ? {
        opacity: 0.65
    } : {};
    return /*#__PURE__*/ $ltGt3.createElement("svg", {
        style: themeStyle,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $ltGt3.createElement("title", null, locale?.description || 'Empty'), /*#__PURE__*/ $ltGt3.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $ltGt3.createElement("g", {
        transform: "translate(24 31.67)"
    }, /*#__PURE__*/ $ltGt3.createElement("ellipse", {
        fillOpacity: ".8",
        fill: "#F5F5F7",
        cx: "67.797",
        cy: "106.89",
        rx: "67.797",
        ry: "12.668"
    }), /*#__PURE__*/ $ltGt3.createElement("path", {
        d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
        fill: "#AEB8C2"
    }), /*#__PURE__*/ $ltGt3.createElement("path", {
        d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
        fill: "url(#linearGradient-1)",
        transform: "translate(13.56)"
    }), /*#__PURE__*/ $ltGt3.createElement("path", {
        d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
        fill: "#F5F5F7"
    }), /*#__PURE__*/ $ltGt3.createElement("path", {
        d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
        fill: "#DCE0E6"
    })), /*#__PURE__*/ $ltGt3.createElement("path", {
        d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
        fill: "#DCE0E6"
    }), /*#__PURE__*/ $ltGt3.createElement("g", {
        transform: "translate(149.65 15.383)",
        fill: "#FFF"
    }, /*#__PURE__*/ $ltGt3.createElement("ellipse", {
        cx: "20.654",
        cy: "3.167",
        rx: "2.849",
        ry: "2.815"
    }), /*#__PURE__*/ $ltGt3.createElement("path", {
        d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
};
var $415e52e79276a25e$export$2e2bcd8739ae039 = $415e52e79276a25e$var$Empty;



var $ltGt3 = parcelRequire("ltGt3");



"use client";
const $b8acd26b54c020df$var$Simple = ()=>{
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const [locale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Empty');
    const { colorFill: colorFill, colorFillTertiary: colorFillTertiary, colorFillQuaternary: colorFillQuaternary, colorBgContainer: colorBgContainer } = token;
    const { borderColor: borderColor, shadowColor: shadowColor, contentColor: contentColor } = (0, $ltGt3.useMemo)(()=>({
            borderColor: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(colorFill).onBackground(colorBgContainer).toHexString(),
            shadowColor: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(colorFillTertiary).onBackground(colorBgContainer).toHexString(),
            contentColor: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(colorFillQuaternary).onBackground(colorBgContainer).toHexString()
        }), [
        colorFill,
        colorFillTertiary,
        colorFillQuaternary,
        colorBgContainer
    ]);
    return /*#__PURE__*/ $ltGt3.createElement("svg", {
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $ltGt3.createElement("title", null, locale?.description || 'Empty'), /*#__PURE__*/ $ltGt3.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $ltGt3.createElement("ellipse", {
        fill: shadowColor,
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $ltGt3.createElement("g", {
        fillRule: "nonzero",
        stroke: borderColor
    }, /*#__PURE__*/ $ltGt3.createElement("path", {
        d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), /*#__PURE__*/ $ltGt3.createElement("path", {
        d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
        fill: contentColor
    }))));
};
var $b8acd26b54c020df$export$2e2bcd8739ae039 = $b8acd26b54c020df$var$Simple;



// ============================== Shared ==============================
const $e32ba70cdff29016$var$genSharedEmptyStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, marginXS: marginXS, marginXL: marginXL, fontSize: fontSize, lineHeight: lineHeight } = token;
    return {
        [componentCls]: {
            marginInline: marginXS,
            fontSize: fontSize,
            lineHeight: lineHeight,
            textAlign: 'center',
            // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-image`]: {
                height: token.emptyImgHeight,
                marginBottom: marginXS,
                opacity: token.opacityImage,
                img: {
                    height: '100%'
                },
                svg: {
                    maxWidth: '100%',
                    height: '100%',
                    margin: 'auto'
                }
            },
            [`${componentCls}-description`]: {
                color: token.colorTextDescription
            },
            // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-footer`]: {
                marginTop: margin
            },
            '&-normal': {
                marginBlock: marginXL,
                color: token.colorTextDescription,
                [`${componentCls}-description`]: {
                    color: token.colorTextDescription
                },
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightMD
                }
            },
            '&-small': {
                marginBlock: marginXS,
                color: token.colorTextDescription,
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightSM
                }
            }
        }
    };
};
var // ============================== Export ==============================
$e32ba70cdff29016$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Empty', (token)=>{
    const { componentCls: componentCls, controlHeightLG: controlHeightLG, calc: calc } = token;
    const emptyToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        emptyImgCls: `${componentCls}-img`,
        emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
        emptyImgHeightMD: controlHeightLG,
        emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
    });
    return $e32ba70cdff29016$var$genSharedEmptyStyle(emptyToken);
});


"use client";
const $d84476b6e9011da3$var$defaultEmptyImg = /*#__PURE__*/ $ltGt3.createElement((0, $415e52e79276a25e$export$2e2bcd8739ae039), null);
const $d84476b6e9011da3$var$simpleEmptyImg = /*#__PURE__*/ $ltGt3.createElement((0, $b8acd26b54c020df$export$2e2bcd8739ae039), null);
const $d84476b6e9011da3$var$Empty = (props)=>{
    const { className: className, rootClassName: rootClassName, prefixCls: customizePrefixCls, image: image, description: description, children: children, imageStyle: imageStyle, style: style, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, image: contextImage } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('empty');
    const prefixCls = getPrefixCls('empty', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $e32ba70cdff29016$export$2e2bcd8739ae039)(prefixCls);
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    const [locale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Empty');
    const des = typeof description !== 'undefined' ? description : locale?.description;
    const alt = typeof des === 'string' ? des : 'empty';
    const mergedImage = image ?? contextImage ?? $d84476b6e9011da3$var$defaultEmptyImg;
    let imageNode = null;
    if (typeof mergedImage === 'string') imageNode = /*#__PURE__*/ $ltGt3.createElement("img", {
        draggable: false,
        alt: alt,
        src: mergedImage
    });
    else imageNode = mergedImage;
    var deprecatedName, newName;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(hashId, cssVarCls, prefixCls, contextClassName, {
            [`${prefixCls}-normal`]: mergedImage === $d84476b6e9011da3$var$simpleEmptyImg,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, className, rootClassName, mergedClassNames.root),
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        ...restProps
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-image`, mergedClassNames.image),
        style: {
            ...imageStyle,
            ...mergedStyles.image
        }
    }, imageNode), des && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-description`, mergedClassNames.description),
        style: mergedStyles.description
    }, des), children && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, mergedClassNames.footer),
        style: mergedStyles.footer
    }, children));
};
$d84476b6e9011da3$var$Empty.PRESENTED_IMAGE_DEFAULT = $d84476b6e9011da3$var$defaultEmptyImg;
$d84476b6e9011da3$var$Empty.PRESENTED_IMAGE_SIMPLE = $d84476b6e9011da3$var$simpleEmptyImg;
var $d84476b6e9011da3$export$2e2bcd8739ae039 = $d84476b6e9011da3$var$Empty;


"use client";
const $48027d4a9fb402d4$var$DefaultRenderEmpty = (props)=>{
    const { componentName: componentName } = props;
    const { getPrefixCls: getPrefixCls } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls('empty');
    switch(componentName){
        case 'Table':
        case 'List':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $d84476b6e9011da3$export$2e2bcd8739ae039), {
                image: (0, $d84476b6e9011da3$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
            });
        case 'Select':
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $d84476b6e9011da3$export$2e2bcd8739ae039), {
                image: (0, $d84476b6e9011da3$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                className: `${prefix}-small`
            });
        /**
     * This type of component should satisfy the nullish coalescing operator(??) on the left-hand side.
     * to let the component itself implement the logic.
     * For example `Table.filter`.
     */ case 'Table.filter':
            // why `null`? legacy react16 node type `undefined` is not allowed.
            return null;
        default:
            // Should never hit if we take all the component into consider.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $d84476b6e9011da3$export$2e2bcd8739ae039), null);
    }
};
var $48027d4a9fb402d4$export$2e2bcd8739ae039 = $48027d4a9fb402d4$var$DefaultRenderEmpty;









const $4cd173922f72de4d$var$getBuiltInPlacements = (popupOverflow)=>{
    const htmlRegion = popupOverflow === 'scroll' ? 'scroll' : 'visible';
    const sharedConfig = {
        overflow: {
            adjustX: true,
            adjustY: true,
            shiftY: true
        },
        htmlRegion: htmlRegion,
        dynamicInset: true
    };
    return {
        bottomLeft: {
            ...sharedConfig,
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ]
        },
        bottomRight: {
            ...sharedConfig,
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ]
        },
        topLeft: {
            ...sharedConfig,
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ]
        },
        topRight: {
            ...sharedConfig,
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ]
        }
    };
};
function $4cd173922f72de4d$var$mergedBuiltinPlacements(buildInPlacements, popupOverflow) {
    return buildInPlacements || $4cd173922f72de4d$var$getBuiltInPlacements(popupOverflow);
}
var $4cd173922f72de4d$export$2e2bcd8739ae039 = $4cd173922f72de4d$var$mergedBuiltinPlacements;







const $69c0a11aedd7ff4d$var$genItemStyle = (token)=>{
    const { optionHeight: optionHeight, optionFontSize: optionFontSize, optionLineHeight: optionLineHeight, optionPadding: optionPadding } = token;
    return {
        position: 'relative',
        display: 'block',
        minHeight: optionHeight,
        padding: optionPadding,
        color: token.colorText,
        fontWeight: 'normal',
        fontSize: optionFontSize,
        lineHeight: optionLineHeight,
        boxSizing: 'border-box'
    };
};
const $69c0a11aedd7ff4d$var$genSingleStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls } = token;
    const selectItemCls = `${componentCls}-item`;
    const slideUpEnterActive = `&${antCls}-slide-up-enter${antCls}-slide-up-enter-active`;
    const slideUpAppearActive = `&${antCls}-slide-up-appear${antCls}-slide-up-appear-active`;
    const slideUpLeaveActive = `&${antCls}-slide-up-leave${antCls}-slide-up-leave-active`;
    const dropdownPlacementCls = `${componentCls}-dropdown-placement-`;
    const selectedItemCls = `${selectItemCls}-option-selected`;
    return [
        {
            [`${componentCls}-dropdown`]: {
                // ========================== Popup ==========================
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                position: 'absolute',
                top: -9999,
                zIndex: token.zIndexPopup,
                boxSizing: 'border-box',
                padding: token.paddingXXS,
                overflow: 'hidden',
                fontSize: token.fontSize,
                // Fix select render lag of long text in chrome
                // https://github.com/ant-design/ant-design/issues/11456
                // https://github.com/ant-design/ant-design/issues/11843
                fontVariant: 'initial',
                backgroundColor: token.colorBgElevated,
                borderRadius: token.borderRadiusLG,
                outline: 'none',
                boxShadow: token.boxShadowSecondary,
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}bottomLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}bottomLeft
        `]: {
                    animationName: (0, $e613b8e902d5a10c$export$e801b802b037de6a)
                },
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}topLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}topLeft,
          ${slideUpEnterActive}${dropdownPlacementCls}topRight,
          ${slideUpAppearActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $e613b8e902d5a10c$export$dd9f089fa5e819fe)
                },
                [`${slideUpLeaveActive}${dropdownPlacementCls}bottomLeft`]: {
                    animationName: (0, $e613b8e902d5a10c$export$f40f41df328ebc38)
                },
                [`
          ${slideUpLeaveActive}${dropdownPlacementCls}topLeft,
          ${slideUpLeaveActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $e613b8e902d5a10c$export$f7243fdb9c27c3b7)
                },
                '&-hidden': {
                    display: 'none'
                },
                [selectItemCls]: {
                    ...$69c0a11aedd7ff4d$var$genItemStyle(token),
                    cursor: 'pointer',
                    transition: `background ${token.motionDurationSlow} ease`,
                    borderRadius: token.borderRadiusSM,
                    // =========== Group ============
                    '&-group': {
                        color: token.colorTextDescription,
                        fontSize: token.fontSizeSM,
                        cursor: 'default'
                    },
                    // =========== Option ===========
                    '&-option': {
                        display: 'flex',
                        '&-content': {
                            flex: 'auto',
                            ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629)
                        },
                        '&-state': {
                            flex: 'none',
                            display: 'flex',
                            alignItems: 'center'
                        },
                        [`&-active:not(${selectItemCls}-option-disabled)`]: {
                            backgroundColor: token.optionActiveBg
                        },
                        [`&-selected:not(${selectItemCls}-option-disabled)`]: {
                            color: token.optionSelectedColor,
                            fontWeight: token.optionSelectedFontWeight,
                            backgroundColor: token.optionSelectedBg,
                            [`${selectItemCls}-option-state`]: {
                                color: token.colorPrimary
                            }
                        },
                        '&-disabled': {
                            [`&${selectItemCls}-option-selected`]: {
                                backgroundColor: token.colorBgContainerDisabled
                            },
                            color: token.colorTextDisabled,
                            cursor: 'not-allowed'
                        },
                        '&-grouped': {
                            paddingInlineStart: token.calc(token.controlPaddingHorizontal).mul(2).equal()
                        }
                    },
                    '&-empty': {
                        ...$69c0a11aedd7ff4d$var$genItemStyle(token),
                        color: token.colorTextDisabled
                    }
                },
                // https://github.com/ant-design/ant-design/pull/46646
                [`${selectedItemCls}:has(+ ${selectedItemCls})`]: {
                    borderEndStartRadius: 0,
                    borderEndEndRadius: 0,
                    [`& + ${selectedItemCls}`]: {
                        borderStartStartRadius: 0,
                        borderStartEndRadius: 0
                    }
                },
                // =========================== RTL ===========================
                '&-rtl': {
                    direction: 'rtl'
                }
            }
        },
        // Follow code may reuse in other components
        (0, $e613b8e902d5a10c$export$9018e60daecf7a6c)(token, 'slide-up'),
        (0, $e613b8e902d5a10c$export$9018e60daecf7a6c)(token, 'slide-down'),
        (0, $96f7793622fd94de$export$913b1b7e3288c319)(token, 'move-up'),
        (0, $96f7793622fd94de$export$913b1b7e3288c319)(token, 'move-down')
    ];
};
var $69c0a11aedd7ff4d$export$2e2bcd8739ae039 = $69c0a11aedd7ff4d$var$genSingleStyle;




const $dc34cd1702972206$var$genSelectInputCustomizeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-customize`]: {
            border: 0,
            padding: 0,
            fontSize: 'inherit',
            lineHeight: 'inherit',
            [`${componentCls}-placeholder`]: {
                display: 'none'
            },
            [`${componentCls}-content`]: {
                margin: 0,
                padding: 0,
                '&-value': {
                    display: 'none'
                }
            }
        }
    };
};
var $dc34cd1702972206$export$2e2bcd8739ae039 = $dc34cd1702972206$var$genSelectInputCustomizeStyle;



const $b352e6895eae4019$var$FIXED_INPUT_MIN_WIDTH = 4;
const $b352e6895eae4019$var$genSelectInputMultipleStyle = (token)=>{
    const { componentCls: componentCls, calc: calc, iconCls: iconCls, paddingXS: paddingXS, paddingXXS: paddingXXS, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN, lineWidth: lineWidth, colorIcon: colorIcon, colorIconHover: colorIconHover, inputPaddingHorizontalBase: inputPaddingHorizontalBase } = token;
    return {
        '&-multiple': {
            '--select-multi-item-background': token.multipleItemBg,
            '--select-multi-item-border-color': 'transparent',
            '--select-multi-item-border-radius': token.borderRadiusSM,
            '--select-multi-item-height': token.multipleItemHeight,
            '--select-multi-padding-base': `calc((var(--select-height) - var(--select-multi-item-height)) / 2)`,
            '--select-multi-padding-vertical': `calc(var(--select-multi-padding-base) - ${INTERNAL_FIXED_ITEM_MARGIN} - ${lineWidth})`,
            '--select-multi-item-padding-horizontal': `calc(${inputPaddingHorizontalBase} - var(--select-multi-padding-vertical) - ${lineWidth} * 2)`,
            // ========================================================
            // ==                        Base                        ==
            // ========================================================
            // ========================= Root =========================
            paddingBlock: `var(--select-multi-padding-vertical)`,
            paddingInlineStart: `calc(var(--select-multi-padding-base) - ${lineWidth})`,
            // ======================== Prefix ========================
            [`${componentCls}-prefix`]: {
                marginInlineStart: 'var(--select-multi-item-padding-horizontal)'
            },
            [`${componentCls}-prefix + ${componentCls}-content`]: {
                [`${componentCls}-placeholder`]: {
                    insetInlineStart: 0
                },
                [`${componentCls}-content-item${componentCls}-content-item-suffix`]: {
                    marginInlineStart: 0
                }
            },
            // ===================== Placeholder ======================
            [`${componentCls}-placeholder`]: {
                position: 'absolute',
                lineHeight: 'var(--select-line-height)',
                insetInlineStart: 'var(--select-multi-item-padding-horizontal)',
                width: 'calc(100% - var(--select-multi-item-padding-horizontal))',
                top: '50%',
                transform: 'translateY(-50%)'
            },
            // ======================= Content ========================
            [`${componentCls}-content`]: {
                flexWrap: 'wrap',
                alignItems: 'center',
                lineHeight: 1,
                '&-item-prefix': {
                    height: 'var(--select-font-size)'
                },
                '&-item': {
                    lineHeight: 1,
                    maxWidth: `calc(100% - ${$b352e6895eae4019$var$FIXED_INPUT_MIN_WIDTH}px)`
                },
                [`${componentCls}-content-item-prefix + ${componentCls}-content-item-suffix,
          ${componentCls}-content-item-suffix:first-child`]: {
                    marginInlineStart: 'var(--select-multi-item-padding-horizontal)'
                },
                [`${componentCls}-selection-item`]: {
                    lineHeight: `calc(var(--select-multi-item-height) - ${lineWidth} * 2)`,
                    border: `${lineWidth} solid var(--select-multi-item-border-color)`,
                    display: 'flex',
                    marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
                    marginInlineEnd: calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
                    background: `var(--select-multi-item-background)`,
                    borderRadius: `var(--select-multi-item-border-radius)`,
                    paddingInlineStart: paddingXS,
                    paddingInlineEnd: paddingXXS,
                    transition: [
                        'height',
                        'line-height',
                        'padding'
                    ].map((key)=>`${key} ${token.motionDurationSlow}`).join(','),
                    // >>> Content
                    '&-content': {
                        ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
                        marginInlineEnd: paddingXXS
                    },
                    // >>> Remove
                    '&-remove': {
                        ...(0, $945cb0d2b7017a11$export$171ccda7bc085e59)(),
                        display: 'inline-flex',
                        alignItems: 'center',
                        color: colorIcon,
                        fontWeight: 'bold',
                        fontSize: 10,
                        lineHeight: 'inherit',
                        cursor: 'pointer',
                        [`> ${iconCls}`]: {
                            verticalAlign: '-0.2em'
                        },
                        '&:hover': {
                            color: colorIconHover
                        }
                    }
                },
                [`${componentCls}-input`]: {
                    lineHeight: calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).add('var(--select-multi-item-height)').equal(),
                    width: 'calc(var(--select-input-width, 0) * 1px)',
                    minWidth: $b352e6895eae4019$var$FIXED_INPUT_MIN_WIDTH,
                    maxWidth: '100%',
                    transition: `line-height ${token.motionDurationSlow}`
                }
            },
            // ========================================================
            // ==                        Size                        ==
            // ========================================================
            [`&${componentCls}-sm`]: {
                '--select-multi-item-height': token.multipleItemHeightSM,
                '--select-multi-item-border-radius': token.borderRadiusXS
            },
            [`&${componentCls}-lg`]: {
                '--select-multi-item-height': token.multipleItemHeightLG,
                '--select-multi-item-border-radius': token.borderRadius
            },
            // ========================================================
            // ==                      Variants                      ==
            // ========================================================
            [`&${componentCls}-filled`]: {
                '--select-multi-item-border-color': token.colorSplit,
                '--select-multi-item-background': token.colorBgContainer,
                [`&${componentCls}-disabled`]: {
                    '--select-multi-item-border-color': 'transparent'
                }
            }
        }
    };
};
var $b352e6895eae4019$export$2e2bcd8739ae039 = $b352e6895eae4019$var$genSelectInputMultipleStyle;


/** Set CSS variables and hover/focus styles for a Select input based on provided colors. */ const $073b1321ad8cedb2$var$genSelectInputVariableStyle = (token, colors)=>{
    const { componentCls: componentCls } = token;
    const { border: border, borderHover: borderHover, borderActive: borderActive, borderOutline: borderOutline } = colors;
    const baseBG = colors.background || token.colorBgContainer;
    return {
        '--select-border-color': border,
        '--select-background': baseBG,
        '--select-color': colors.color || token.colorText,
        [`&:not(${componentCls}-disabled)`]: {
            '&:hover': {
                '--select-border-color': borderHover,
                '--select-background': colors.backgroundHover || baseBG
            },
            [`&${componentCls}-focused`]: {
                '--select-border-color': borderActive,
                '--select-background': colors.backgroundActive || baseBG,
                boxShadow: `0 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.controlOutlineWidth)} ${borderOutline}`
            }
        },
        [`&${componentCls}-disabled`]: {
            '--select-border-color': colors.borderDisabled || colors.border,
            '--select-background': colors.backgroundDisabled || colors.background
        }
    };
};
/** Generate variant-scoped variable styles and status overrides for a Select input. */ const $073b1321ad8cedb2$var$genSelectInputVariantStyle = (token, variant, colors, errorColors = {}, warningColors = {}, patchStyle)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-${variant}`]: [
            $073b1321ad8cedb2$var$genSelectInputVariableStyle(token, colors),
            {
                [`&${componentCls}-status-error`]: $073b1321ad8cedb2$var$genSelectInputVariableStyle(token, {
                    ...colors,
                    color: errorColors.color || token.colorError,
                    ...errorColors
                }),
                [`&${componentCls}-status-warning`]: $073b1321ad8cedb2$var$genSelectInputVariableStyle(token, {
                    ...colors,
                    color: warningColors.color || token.colorWarning,
                    ...warningColors
                })
            },
            patchStyle
        ]
    };
};
const $073b1321ad8cedb2$var$genSelectInputStyle = (token)=>{
    const { componentCls: componentCls, calc: calc, fontHeight: fontHeight, controlHeight: controlHeight, iconCls: iconCls } = token;
    return {
        [componentCls]: [
            {
                // Border
                '--select-border-radius': token.borderRadius,
                '--select-border-color': '#000',
                '--select-border-size': token.lineWidth,
                // Background
                '--select-background': token.colorBgContainer,
                // Font
                '--select-font-size': token.fontSize,
                '--select-line-height': token.lineHeight,
                '--select-font-height': fontHeight,
                '--select-color': token.colorText,
                // Size
                '--select-height': controlHeight,
                '--select-padding-horizontal': calc(token.paddingSM).sub(token.lineWidth).equal(),
                '--select-padding-vertical': 'calc((var(--select-height) - var(--select-font-height)) / 2 - var(--select-border-size))',
                // ==========================================================
                // ==                         Base                         ==
                // ==========================================================
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token, true),
                display: 'inline-flex',
                // gap: calc(token.paddingXXS).mul(1.5).equal(),
                flexWrap: 'nowrap',
                position: 'relative',
                transition: `all ${token.motionDurationSlow}`,
                alignItems: 'flex-start',
                outline: 0,
                cursor: 'pointer',
                // Border
                borderRadius: 'var(--select-border-radius)',
                borderWidth: 'var(--select-border-size)',
                borderStyle: token.lineType,
                borderColor: 'var(--select-border-color)',
                // Background
                background: 'var(--select-background)',
                // Font
                fontSize: 'var(--select-font-size)',
                lineHeight: 'var(--select-line-height)',
                color: 'var(--select-color)',
                // Padding
                paddingInline: 'var(--select-padding-horizontal)',
                paddingBlock: 'var(--select-padding-vertical)',
                // ========================= Prefix =========================
                [`${componentCls}-prefix`]: {
                    flex: 'none',
                    lineHeight: 1
                },
                // ====================== Placeholder =======================
                [`${componentCls}-placeholder`]: {
                    ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
                    color: token.colorTextPlaceholder,
                    pointerEvents: 'none',
                    zIndex: 1
                },
                // ======================== Content =========================
                [`${componentCls}-content`]: {
                    flex: 'auto',
                    minWidth: 0,
                    position: 'relative',
                    display: 'flex',
                    marginInlineEnd: calc(token.paddingXXS).mul(1.5).equal(),
                    '&:before': {
                        content: '"\\a0"',
                        width: 0,
                        overflow: 'hidden'
                    },
                    // >>> Value
                    '&-value': {
                        ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
                        transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
                        zIndex: 1
                    },
                    // >>> Input: should only take effect for not customize mode
                    // input element with readOnly use cursor pointer
                    'input[readonly]': {
                        cursor: 'inherit'
                    }
                },
                [`&-open ${componentCls}-content-value`]: {
                    color: token.colorTextPlaceholder
                },
                // ========================= Suffix =========================
                [`${componentCls}-suffix`]: {
                    flex: 'none',
                    color: token.colorTextQuaternary,
                    fontSize: token.fontSizeIcon,
                    lineHeight: 1,
                    '> :not(:last-child)': {
                        marginInlineEnd: token.marginXS
                    }
                },
                [`${componentCls}-prefix, ${componentCls}-suffix`]: {
                    alignSelf: 'center',
                    [iconCls]: {
                        verticalAlign: 'top'
                    }
                },
                // ==========================================================
                // ==                       Disabled                       ==
                // ==========================================================
                '&-disabled': {
                    background: token.colorBgContainerDisabled,
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                },
                // ==========================================================
                // ==                         Size                         ==
                // ==========================================================
                '&-sm': {
                    '--select-height': token.controlHeightSM,
                    '--select-padding-horizontal': calc(token.paddingXS).sub(token.lineWidth).equal(),
                    '--select-border-radius': token.borderRadiusSM
                },
                '&-lg': {
                    '--select-height': token.controlHeightLG,
                    '--select-font-size': token.fontSizeLG,
                    '--select-line-height': token.lineHeightLG,
                    '--select-font-height': token.fontHeightLG,
                    '--select-border-radius': token.borderRadiusLG
                }
            },
            // ============================================================
            // ==                         Input                          ==
            // ============================================================
            {
                [`&:not(${componentCls}-customize)`]: {
                    [`${componentCls}-input`]: {
                        outline: 'none',
                        background: 'transparent',
                        appearance: 'none',
                        border: 0,
                        margin: 0,
                        padding: 0,
                        '&::-webkit-search-cancel-button': {
                            display: 'none',
                            appearance: 'none'
                        }
                    }
                }
            },
            // ============================================================
            // ==                         Single                         ==
            // ============================================================
            {
                [`&-single:not(${componentCls}-customize)`]: {
                    [`${componentCls}-input`]: {
                        position: 'absolute',
                        insetInline: 0,
                        insetBlock: 'calc(var(--select-padding-vertical) * -1)',
                        lineHeight: 'calc(var(--select-font-height) + var(--select-padding-vertical) * 2)'
                    },
                    // Content center align
                    [`${componentCls}-content`]: {
                        alignSelf: 'center'
                    }
                }
            },
            // ============================================================
            // ==                        Multiple                        ==
            // ============================================================
            (0, $b352e6895eae4019$export$2e2bcd8739ae039)(token),
            // ========================= Variant ==========================
            // >>> Outlined
            $073b1321ad8cedb2$var$genSelectInputVariantStyle(token, 'outlined', {
                border: token.colorBorder,
                borderHover: token.hoverBorderColor,
                borderActive: token.activeBorderColor,
                borderOutline: token.activeOutlineColor,
                borderDisabled: token.colorBorderDisabled
            }, // Error
            {
                border: token.colorError,
                borderHover: token.colorErrorHover,
                borderActive: token.colorError,
                borderOutline: token.colorErrorOutline
            }, // Warning
            {
                border: token.colorWarning,
                borderHover: token.colorWarningHover,
                borderActive: token.colorWarning,
                borderOutline: token.colorWarningOutline
            }),
            // >>> Filled
            $073b1321ad8cedb2$var$genSelectInputVariantStyle(token, 'filled', {
                border: 'transparent',
                borderHover: 'transparent',
                borderActive: token.activeBorderColor,
                borderOutline: 'transparent',
                borderDisabled: token.colorBorderDisabled,
                background: token.colorFillTertiary,
                backgroundHover: token.colorFillSecondary,
                backgroundActive: token.colorBgContainer
            }, // Error
            {
                background: token.colorErrorBg,
                backgroundHover: token.colorErrorBgHover,
                borderActive: token.colorError
            }, // Warning
            {
                background: token.colorWarningBg,
                backgroundHover: token.colorWarningBgHover,
                borderActive: token.colorWarning
            }),
            // >>> Borderless
            $073b1321ad8cedb2$var$genSelectInputVariantStyle(token, 'borderless', {
                border: 'transparent',
                borderHover: 'transparent',
                borderActive: 'transparent',
                borderOutline: 'transparent',
                background: 'transparent'
            }),
            // Underlined
            $073b1321ad8cedb2$var$genSelectInputVariantStyle(token, 'underlined', {
                border: token.colorBorder,
                borderHover: token.hoverBorderColor,
                borderActive: token.activeBorderColor,
                borderOutline: 'transparent'
            }, // Error
            {
                border: token.colorError,
                borderHover: token.colorErrorHover,
                borderActive: token.colorError
            }, // Warning
            {
                border: token.colorWarning,
                borderHover: token.colorWarningHover,
                borderActive: token.colorWarning
            }, {
                borderRadius: 0,
                borderTopColor: 'transparent',
                borderRightColor: 'transparent',
                borderLeftColor: 'transparent'
            }),
            // ============================================================
            // ==                         Custom                         ==
            // ============================================================
            (0, $dc34cd1702972206$export$2e2bcd8739ae039)(token)
        ]
    };
};
var $073b1321ad8cedb2$export$2e2bcd8739ae039 = $073b1321ad8cedb2$var$genSelectInputStyle;


const $fc1ba295d2644401$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeight: controlHeight, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, paddingXXS: paddingXXS, controlPaddingHorizontal: controlPaddingHorizontal, zIndexPopupBase: zIndexPopupBase, colorText: colorText, fontWeightStrong: fontWeightStrong, controlItemBgActive: controlItemBgActive, controlItemBgHover: controlItemBgHover, colorBgContainer: colorBgContainer, colorFillSecondary: colorFillSecondary, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutline: controlOutline } = token;
    // Item height default use `controlHeight - 2 * paddingXXS`,
    // but some case `paddingXXS=0`.
    // Let's fallback it.
    const dblPaddingXXS = paddingXXS * 2;
    const dblLineWidth = lineWidth * 2;
    const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
    const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
    const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
    // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
    const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
    return {
        INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN,
        zIndexPopup: zIndexPopupBase + 50,
        optionSelectedColor: colorText,
        optionSelectedFontWeight: fontWeightStrong,
        optionSelectedBg: controlItemBgActive,
        optionActiveBg: controlItemBgHover,
        optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
        optionFontSize: fontSize,
        optionLineHeight: lineHeight,
        optionHeight: controlHeight,
        selectorBg: colorBgContainer,
        clearBg: colorBgContainer,
        singleItemHeightLG: controlHeightLG,
        multipleItemBg: colorFillSecondary,
        multipleItemBorderColor: 'transparent',
        multipleItemHeight: multipleItemHeight,
        multipleItemHeightSM: multipleItemHeightSM,
        multipleItemHeightLG: multipleItemHeightLG,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: colorTextDisabled,
        multipleItemBorderColorDisabled: 'transparent',
        showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25),
        hoverBorderColor: colorPrimaryHover,
        activeBorderColor: colorPrimary,
        activeOutlineColor: controlOutline,
        selectAffixPadding: paddingXXS
    };
};


// =============================== Base ===============================
const $f3a4459ff19beab0$var$genBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, inputPaddingHorizontalBase: inputPaddingHorizontalBase } = token;
    const hoverShowClearStyle = {
        [`${componentCls}-clear`]: {
            opacity: 1,
            background: token.colorBgBase,
            borderRadius: '50%'
        }
    };
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            // ======================== Selection ========================
            [`${componentCls}-selection-item`]: {
                flex: 1,
                fontWeight: 'normal',
                position: 'relative',
                userSelect: 'none',
                ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
                // https://github.com/ant-design/ant-design/issues/40421
                [`> ${antCls}-typography`]: {
                    display: 'inline'
                }
            },
            // ========================= Prefix ==========================
            [`${componentCls}-prefix`]: {
                flex: 'none',
                marginInlineEnd: token.selectAffixPadding
            },
            // ========================== Clear ==========================
            [`${componentCls}-clear`]: {
                position: 'absolute',
                top: '50%',
                insetInlineStart: 'auto',
                insetInlineEnd: inputPaddingHorizontalBase,
                zIndex: 1,
                display: 'inline-block',
                width: token.fontSizeIcon,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                fontStyle: 'normal',
                lineHeight: 1,
                textAlign: 'center',
                textTransform: 'none',
                cursor: 'pointer',
                opacity: 0,
                transition: `color ${token.motionDurationMid} ease, opacity ${token.motionDurationSlow} ease`,
                textRendering: 'auto',
                // https://github.com/ant-design/ant-design/issues/54205
                // Force GPU compositing on Safari to prevent flickering on opacity/transform transitions
                transform: 'translateZ(0)',
                '&:before': {
                    display: 'block'
                },
                '&:hover': {
                    color: token.colorIcon
                }
            },
            '@media(hover:none)': hoverShowClearStyle,
            '&:hover': hoverShowClearStyle
        },
        // ========================= Feedback ==========================
        [`${componentCls}-status`]: {
            '&-error, &-warning, &-success, &-validating': {
                [`&${componentCls}-has-feedback`]: {
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
                    }
                }
            }
        }
    };
};
// ============================== Styles ==============================
const $f3a4459ff19beab0$var$genSelectStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        {
            [componentCls]: {
                // ==================== In Form ====================
                [`&${componentCls}-in-form-item`]: {
                    width: '100%'
                }
            }
        },
        // =====================================================
        // ==                       LTR                       ==
        // =====================================================
        // Base
        $f3a4459ff19beab0$var$genBaseStyle(token),
        // Dropdown
        (0, $69c0a11aedd7ff4d$export$2e2bcd8739ae039)(token),
        // =====================================================
        // ==                       RTL                       ==
        // =====================================================
        {
            [`${componentCls}-rtl`]: {
                direction: 'rtl'
            }
        },
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $f96147db005a8a82$export$b1208b23589b4b73)(token, {
            focusElCls: `${componentCls}-focused`
        })
    ];
};
var // ============================== Export ==============================
$f3a4459ff19beab0$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Select', (token, { rootPrefixCls: rootPrefixCls })=>{
    const selectToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        rootPrefixCls: rootPrefixCls,
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(token.lineWidth).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        $f3a4459ff19beab0$var$genSelectStyle(selectToken),
        (0, $073b1321ad8cedb2$export$2e2bcd8739ae039)(selectToken)
    ];
}, (0, $fc1ba295d2644401$export$9ca1be8807fe0675), {
    unitless: {
        optionLineHeight: true,
        optionSelectedFontWeight: true
    }
});



var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $58e38707396c6245$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
var $58e38707396c6245$export$2e2bcd8739ae039 = $58e38707396c6245$var$DownOutlined;



function $a3f64d9a77de028d$var$_extends() {
    $a3f64d9a77de028d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a3f64d9a77de028d$var$_extends.apply(this, arguments);
}
const $a3f64d9a77de028d$var$DownOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $a3f64d9a77de028d$var$_extends({}, props, {
        ref: ref,
        icon: (0, $58e38707396c6245$export$2e2bcd8739ae039)
    }));
/**![down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NCAyNTZoLTc1Yy01LjEgMC05LjkgMi41LTEyLjkgNi42TDUxMiA2NTQuMiAyMjcuOSAyNjIuNmMtMy00LjEtNy44LTYuNi0xMi45LTYuNmgtNzVjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDM1Mi42IDQ4Ni4xYzEyLjggMTcuNiAzOSAxNy42IDUxLjcgMGwzNTIuNi00ODYuMWMzLjktNS4zLjEtMTIuNy02LjQtMTIuN3oiIC8+PC9zdmc+) */ const $a3f64d9a77de028d$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($a3f64d9a77de028d$var$DownOutlined);
var $a3f64d9a77de028d$export$2e2bcd8739ae039 = $a3f64d9a77de028d$var$RefIcon;





"use client";
function $6bc1cdde7926dc7f$export$2e2bcd8739ae039({ suffixIcon: suffixIcon, clearIcon: clearIcon, menuItemSelectedIcon: menuItemSelectedIcon, removeIcon: removeIcon, loading: loading, multiple: multiple, hasFeedback: hasFeedback, showSuffixIcon: showSuffixIcon, feedbackIcon: feedbackIcon, showArrow: showArrow, componentName: componentName }) {
    // Clear Icon
    const mergedClearIcon = clearIcon ?? /*#__PURE__*/ $ltGt3.createElement((0, $332936b0d9ac1f65$export$2e2bcd8739ae039), null);
    // Validation Feedback Icon
    const getSuffixIconNode = (arrowIcon)=>{
        if (suffixIcon === null && !hasFeedback && !showArrow) return null;
        return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    let mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/ $ltGt3.createElement((0, $8ede40f9e9e4f5c2$export$2e2bcd8739ae039), {
        spin: true
    }));
    else mergedSuffixIcon = ({ open: open, showSearch: showSearch })=>{
        if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ $ltGt3.createElement((0, $84123a67634fb0f3$export$2e2bcd8739ae039), null));
        return getSuffixIconNode(/*#__PURE__*/ $ltGt3.createElement((0, $a3f64d9a77de028d$export$2e2bcd8739ae039), null));
    };
    // Checked item icon
    let mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ $ltGt3.createElement((0, $69caf2b39a25e974$export$2e2bcd8739ae039), null);
    else mergedItemIcon = null;
    let mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ $ltGt3.createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), null);
    return {
        // TODO: remove as when all the deps bumped
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}



var $ltGt3 = parcelRequire("ltGt3");

"use client";
function $bc6eef43893492ab$var$usePopupRender(renderFn) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        if (!renderFn) return undefined;
        return (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $31ba6c57c6d43aeb$export$2e2bcd8739ae039), {
                space: true
            }, renderFn.apply(void 0, args));
    }, [
        renderFn
    ]);
}
var $bc6eef43893492ab$export$2e2bcd8739ae039 = $bc6eef43893492ab$var$usePopupRender;


/**
 * Since Select, TreeSelect, Cascader is same Select like component.
 * We just use same hook to handle this logic.
 *
 * If `suffixIcon` is not equal to `null`, always show it.
 */ function $6447e8f62a847790$export$2e2bcd8739ae039(suffixIcon, showArrow) {
    return showArrow !== undefined ? showArrow : suffixIcon !== null;
}


"use client";
const $833302d2cabce31e$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
const $833302d2cabce31e$var$InternalSelect = (props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered, className: className, rootClassName: rootClassName, getPopupContainer: getPopupContainer, popupClassName: popupClassName, dropdownClassName: dropdownClassName, listHeight: listHeight = 256, placement: placement, listItemHeight: customListItemHeight, size: customizeSize, disabled: customDisabled, notFoundContent: notFoundContent, status: customStatus, builtinPlacements: builtinPlacements, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, direction: propDirection, style: style, allowClear: allowClear, variant: customizeVariant, popupStyle: popupStyle, dropdownStyle: dropdownStyle, transitionName: transitionName, tagRender: tagRender, maxCount: maxCount, prefix: prefix, dropdownRender: dropdownRender, popupRender: /**
     * @since 5.25.0
     */ popupRender, onDropdownVisibleChange: onDropdownVisibleChange, onOpenChange: onOpenChange, styles: styles, classNames: classNames, ...rest } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, renderEmpty: renderEmpty, direction: contextDirection, virtual: virtual, popupMatchSelectWidth: contextPopupMatchSelectWidth, popupOverflow: popupOverflow } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { showSearch: showSearch, style: contextStyle, styles: contextStyles, className: contextClassName, classNames: contextClassNames } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('select');
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const listItemHeight = customListItemHeight ?? token?.controlHeight;
    const prefixCls = getPrefixCls('select', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const direction = propDirection ?? contextDirection;
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $8eabd28975be2fa5$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const [variant, enableVariantCls] = (0, $714175bf01098e4f$export$2e2bcd8739ae039)('select', customizeVariant, bordered);
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $f3a4459ff19beab0$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mode = $ltGt3.useMemo(()=>{
        const { mode: m } = props;
        if (m === 'combobox') return undefined;
        if (m === $833302d2cabce31e$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return 'combobox';
        return m;
    }, [
        props.mode
    ]);
    const isMultiple = mode === 'multiple' || mode === 'tags';
    const showSuffixIcon = (0, $6447e8f62a847790$export$2e2bcd8739ae039)(props.suffixIcon, props.showArrow);
    const mergedPopupMatchSelectWidth = popupMatchSelectWidth ?? dropdownMatchSelectWidth ?? contextPopupMatchSelectWidth;
    const mergedPopupRender = (0, $bc6eef43893492ab$export$2e2bcd8739ae039)(popupRender || dropdownRender);
    const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
    // ===================== Form Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $ltGt3.useContext((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $7b7bdeafff468875$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Empty =====================
    let mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === 'combobox') mergedNotFound = null;
    else mergedNotFound = renderEmpty?.('Select') || /*#__PURE__*/ $ltGt3.createElement((0, $48027d4a9fb402d4$export$2e2bcd8739ae039), {
        componentName: "Select"
    });
    // ===================== Icons =====================
    const { suffixIcon: suffixIcon, itemIcon: itemIcon, removeIcon: removeIcon, clearIcon: clearIcon } = (0, $6bc1cdde7926dc7f$export$2e2bcd8739ae039)({
        ...rest,
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showSuffixIcon: showSuffixIcon,
        prefixCls: prefixCls,
        componentName: 'Select'
    });
    const mergedAllowClear = allowClear === true ? {
        clearIcon: clearIcon
    } : allowClear;
    const selectProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(rest, [
        'suffixIcon',
        'itemIcon'
    ]);
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    // ===================== Disabled =====================
    const disabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // ========== Merged Props for Semantic ==================
    const mergedProps = {
        ...props,
        variant: variant,
        status: mergedStatus,
        disabled: mergedDisabled,
        size: mergedSize
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        }
    });
    const mergedPopupClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassNames.popup?.root, popupClassName, dropdownClassName, {
        [`${prefixCls}-dropdown-${direction}`]: direction === 'rtl'
    }, rootClassName, cssVarCls, rootCls, hashId);
    const mergedPopupStyle = {
        ...mergedStyles.popup?.root,
        ...popupStyle ?? dropdownStyle
    };
    const mergedClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
        [`${prefixCls}-lg`]: mergedSize === 'large',
        [`${prefixCls}-sm`]: mergedSize === 'small',
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${variant}`]: enableVariantCls,
        [`${prefixCls}-in-form-item`]: isFormItemInput
    }, (0, $7b7bdeafff468875$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, contextClassName, className, mergedClassNames.root, rootClassName, cssVarCls, rootCls, hashId);
    // ===================== Placement =====================
    const memoPlacement = $ltGt3.useMemo(()=>{
        if (placement !== undefined) return placement;
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    }, [
        placement,
        direction
    ]);
    var oldProp, newProp;
    // ====================== zIndex =========================
    const [zIndex] = (0, $ad5b6b465efa8f67$export$3e7906d4075187a4)('SelectLike', mergedStyles.popup?.root?.zIndex ?? mergedPopupStyle?.zIndex);
    // ====================== Render =======================
    return /*#__PURE__*/ $ltGt3.createElement((0, $aa74d02ab8b95e62$export$2e2bcd8739ae039), {
        ref: ref,
        virtual: virtual,
        classNames: mergedClassNames,
        styles: mergedStyles,
        showSearch: showSearch,
        ...selectProps,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        popupMatchSelectWidth: mergedPopupMatchSelectWidth,
        transitionName: (0, $32c4c593a0d4aef5$export$27c72201b1d09951)(rootPrefixCls, 'slide-up', transitionName),
        builtinPlacements: (0, $4cd173922f72de4d$export$2e2bcd8739ae039)(builtinPlacements, popupOverflow),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: memoPlacement,
        direction: direction,
        prefix: prefix,
        suffixIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        allowClear: mergedAllowClear,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        popupClassName: mergedPopupClassName,
        disabled: mergedDisabled,
        popupStyle: {
            ...mergedStyles.popup?.root,
            ...mergedPopupStyle,
            zIndex: zIndex
        },
        maxCount: isMultiple ? maxCount : undefined,
        tagRender: isMultiple ? tagRender : undefined,
        popupRender: mergedPopupRender,
        onPopupVisibleChange: mergedOnOpenChange
    });
};
const $833302d2cabce31e$var$Select = /*#__PURE__*/ $ltGt3.forwardRef($833302d2cabce31e$var$InternalSelect);
// We don't care debug panel
/* istanbul ignore next */ const $833302d2cabce31e$var$PurePanel = (0, $c64d2291d230fcde$export$2e2bcd8739ae039)($833302d2cabce31e$var$Select, 'popupAlign');
$833302d2cabce31e$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $833302d2cabce31e$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$833302d2cabce31e$var$Select.Option = (0, $eb61c81cc9919308$export$2e2bcd8739ae039);
$833302d2cabce31e$var$Select.OptGroup = (0, $54bdc5481d013c5f$export$2e2bcd8739ae039);
$833302d2cabce31e$var$Select._InternalPanelDoNotUseOrYouWillBeFired = $833302d2cabce31e$var$PurePanel;
var $833302d2cabce31e$export$2e2bcd8739ae039 = $833302d2cabce31e$var$Select;



var $ltGt3 = parcelRequire("ltGt3");






"use client";
const { Option: $989bbbbcc966b970$var$Option } = (0, $833302d2cabce31e$export$2e2bcd8739ae039);
function $989bbbbcc966b970$var$isSelectOptionOrSelectOptGroup(child) {
    return child?.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
}
const $989bbbbcc966b970$var$AutoComplete = (props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, style: style, popupClassName: popupClassName, dropdownClassName: dropdownClassName, children: children, dataSource: dataSource, rootClassName: rootClassName, dropdownStyle: dropdownStyle, dropdownRender: dropdownRender, popupRender: popupRender, onDropdownVisibleChange: onDropdownVisibleChange, onOpenChange: onOpenChange, styles: styles, classNames: classNames } = props;
    const childNodes = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children);
    const mergedPopupRender = popupRender || dropdownRender;
    const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
    // ============================= Input =============================
    let customizeInput;
    if (childNodes.length === 1 && /*#__PURE__*/ $ltGt3.isValidElement(childNodes[0]) && !$989bbbbcc966b970$var$isSelectOptionOrSelectOptGroup(childNodes[0])) [customizeInput] = childNodes;
    const getInputElement = customizeInput ? ()=>customizeInput : undefined;
    // ============================ Options ============================
    let optionChildren;
    // [Legacy] convert `children` or `dataSource` into option children
    if (childNodes.length && $989bbbbcc966b970$var$isSelectOptionOrSelectOptGroup(childNodes[0])) optionChildren = children;
    else optionChildren = dataSource ? dataSource.map((item)=>{
        if (/*#__PURE__*/ $ltGt3.isValidElement(item)) return item;
        switch(typeof item){
            case 'string':
                return /*#__PURE__*/ $ltGt3.createElement($989bbbbcc966b970$var$Option, {
                    key: item,
                    value: item
                }, item);
            case 'object':
                {
                    const { value: optionValue } = item;
                    return /*#__PURE__*/ $ltGt3.createElement($989bbbbcc966b970$var$Option, {
                        key: optionValue,
                        value: optionValue
                    }, item.text);
                }
            default:
                return undefined;
        }
    }) : [];
    var oldProp, newProp;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('select', customizePrefixCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        dataSource: dataSource,
        status: props.status,
        popupMatchSelectWidth: props.popupMatchSelectWidth || props.dropdownMatchSelectWidth,
        popupRender: mergedPopupRender,
        onOpenChange: mergedOnOpenChange
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        classNames
    ], [
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        }
    });
    const finalClassNames = $ltGt3.useMemo(()=>({
            root: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-auto-complete`, className, rootClassName, mergedClassNames.root, {
                [`${prefixCls}-customize`]: customizeInput
            }),
            prefix: mergedClassNames.prefix,
            input: mergedClassNames.input,
            placeholder: mergedClassNames.placeholder,
            content: mergedClassNames.content,
            popup: {
                root: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(popupClassName, dropdownClassName, mergedClassNames.popup?.root),
                list: mergedClassNames.popup?.list,
                listItem: mergedClassNames.popup?.listItem
            }
        }), [
        prefixCls,
        className,
        rootClassName,
        mergedClassNames,
        popupClassName,
        dropdownClassName
    ]);
    const finalStyles = $ltGt3.useMemo(()=>({
            root: {
                ...mergedStyles.root,
                ...style
            },
            input: mergedStyles.input,
            prefix: mergedStyles.prefix,
            placeholder: mergedStyles.placeholder,
            content: mergedStyles.content,
            popup: {
                root: {
                    ...dropdownStyle,
                    ...mergedStyles.popup?.root
                },
                list: mergedStyles.popup?.list,
                listItem: mergedStyles.popup?.listItem
            }
        }), [
        mergedStyles,
        style,
        dropdownStyle
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
        ref: ref,
        suffixIcon: null,
        ...(0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(props, [
            'dataSource',
            'dropdownClassName',
            'popupClassName'
        ]),
        prefixCls: prefixCls,
        classNames: finalClassNames,
        styles: finalStyles,
        mode: (0, $833302d2cabce31e$export$2e2bcd8739ae039).SECRET_COMBOBOX_MODE_DO_NOT_USE,
        popupRender: mergedPopupRender,
        onPopupVisibleChange: mergedOnOpenChange,
        getInputElement: // Internal api
        getInputElement
    }, optionChildren);
};
const $989bbbbcc966b970$var$RefAutoComplete = /*#__PURE__*/ $ltGt3.forwardRef($989bbbbcc966b970$var$AutoComplete);
var $989bbbbcc966b970$export$2e2bcd8739ae039 = $989bbbbcc966b970$var$RefAutoComplete;


"use client";
const { Option: $85df14811ac73e37$var$Option } = (0, $833302d2cabce31e$export$2e2bcd8739ae039);
// We don't care debug panel
/* istanbul ignore next */ const $85df14811ac73e37$var$PurePanel = (0, $c64d2291d230fcde$export$2e2bcd8739ae039)((0, $989bbbbcc966b970$export$2e2bcd8739ae039), 'popupAlign', (props)=>(0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(props, [
        'visible'
    ]));
const $85df14811ac73e37$var$AutoComplete = (0, $989bbbbcc966b970$export$2e2bcd8739ae039);
$85df14811ac73e37$var$AutoComplete.Option = $85df14811ac73e37$var$Option;
$85df14811ac73e37$var$AutoComplete._InternalPanelDoNotUseOrYouWillBeFired = $85df14811ac73e37$var$PurePanel;
var $85df14811ac73e37$export$2e2bcd8739ae039 = $85df14811ac73e37$var$AutoComplete;


var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
function $5be58c811ab7b572$var$_extends() {
    $5be58c811ab7b572$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5be58c811ab7b572$var$_extends.apply(this, arguments);
}
const $5be58c811ab7b572$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-checkbox', className: className, style: style, checked: checked, disabled: disabled, defaultChecked: defaultChecked = false, type: type = 'checkbox', title: title, onChange: onChange, ...inputProps } = props;
    const inputRef = (0, $ltGt3.useRef)(null);
    const holderRef = (0, $ltGt3.useRef)(null);
    const [rawValue, setRawValue] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultChecked, checked);
    (0, $ltGt3.useImperativeHandle)(ref, ()=>({
            focus: (options)=>{
                inputRef.current?.focus(options);
            },
            blur: ()=>{
                inputRef.current?.blur();
            },
            input: inputRef.current,
            nativeElement: holderRef.current
        }));
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prefixCls, className, {
        [`${prefixCls}-checked`]: rawValue,
        [`${prefixCls}-disabled`]: disabled
    });
    const handleChange = (e)=>{
        if (disabled) return;
        if (!('checked' in props)) setRawValue(e.target.checked);
        onChange?.({
            target: {
                ...props,
                type: type,
                checked: e.target.checked
            },
            stopPropagation () {
                e.stopPropagation();
            },
            preventDefault () {
                e.preventDefault();
            },
            nativeEvent: e.nativeEvent
        });
    };
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: classString,
        title: title,
        style: style,
        ref: holderRef
    }, /*#__PURE__*/ $ltGt3.createElement("input", $5be58c811ab7b572$var$_extends({}, inputProps, {
        className: `${prefixCls}-input`,
        ref: inputRef,
        onChange: handleChange,
        disabled: disabled,
        checked: !!rawValue,
        type: type
    })), /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-inner`
    }));
});
var $5be58c811ab7b572$export$2e2bcd8739ae039 = $5be58c811ab7b572$export$48513f6b9f8ce62d;














var $ltGt3 = parcelRequire("ltGt3");
const $9f0894a3518ffde6$var$GroupContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createContext(null);
var $9f0894a3518ffde6$export$2e2bcd8739ae039 = $9f0894a3518ffde6$var$GroupContext;





const $2c6e5f034ccbdb08$export$92a97fe1d1148438 = (token)=>{
    const { checkboxCls: checkboxCls } = token;
    const wrapperCls = `${checkboxCls}-wrapper`;
    return [
        // ===================== Basic =====================
        {
            // Group
            [`${checkboxCls}-group`]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                display: 'inline-flex',
                flexWrap: 'wrap',
                columnGap: token.marginXS,
                // Group > Grid
                [`> ${token.antCls}-row`]: {
                    flex: 1
                }
            },
            // Wrapper
            [wrapperCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                display: 'inline-flex',
                alignItems: 'baseline',
                cursor: 'pointer',
                // Fix checkbox & radio in flex align #30260
                '&:after': {
                    display: 'inline-block',
                    width: 0,
                    overflow: 'hidden',
                    content: "'\\a0'"
                },
                // Checkbox near checkbox
                [`& + ${wrapperCls}`]: {
                    marginInlineStart: 0
                },
                [`&${wrapperCls}-in-form-item`]: {
                    'input[type="checkbox"]': {
                        width: 14,
                        // FIXME: magic
                        height: 14 // FIXME: magic
                    }
                }
            },
            // Wrapper > Checkbox
            [checkboxCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                position: 'relative',
                whiteSpace: 'nowrap',
                lineHeight: 1,
                cursor: 'pointer',
                borderRadius: token.borderRadiusSM,
                // To make alignment right when `controlHeight` is changed
                // Ref: https://github.com/ant-design/ant-design/issues/41564
                alignSelf: 'center',
                // Wrapper > Checkbox > input
                [`${checkboxCls}-input`]: {
                    position: 'absolute',
                    // Since baseline align will get additional space offset,
                    // we need to move input to top to make it align with text.
                    // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
                    inset: 0,
                    zIndex: 1,
                    cursor: 'pointer',
                    opacity: 0,
                    margin: 0,
                    [`&:focus-visible + ${checkboxCls}-inner`]: (0, $945cb0d2b7017a11$export$6539948f0a737e39)(token)
                },
                // Wrapper > Checkbox > inner
                [`${checkboxCls}-inner`]: {
                    boxSizing: 'border-box',
                    display: 'block',
                    width: token.checkboxSize,
                    height: token.checkboxSize,
                    direction: 'ltr',
                    backgroundColor: token.colorBgContainer,
                    border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadiusSM,
                    borderCollapse: 'separate',
                    transition: `all ${token.motionDurationSlow}`,
                    '&:after': {
                        boxSizing: 'border-box',
                        position: 'absolute',
                        top: '50%',
                        insetInlineStart: '25%',
                        display: 'table',
                        width: token.calc(token.checkboxSize).div(14).mul(5).equal(),
                        height: token.calc(token.checkboxSize).div(14).mul(8).equal(),
                        border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidthBold)} solid ${token.colorWhite}`,
                        borderTop: 0,
                        borderInlineStart: 0,
                        transform: 'rotate(45deg) scale(0) translate(-50%,-50%)',
                        opacity: 0,
                        content: '""',
                        transition: `all ${token.motionDurationFast} ${token.motionEaseInBack}, opacity ${token.motionDurationFast}`
                    }
                },
                // Wrapper > Checkbox + Text
                '& + span': {
                    paddingInlineStart: token.paddingXS,
                    paddingInlineEnd: token.paddingXS
                }
            }
        },
        // ===================== Hover =====================
        {
            // Wrapper & Wrapper > Checkbox
            [`
        ${wrapperCls}:not(${wrapperCls}-disabled),
        ${checkboxCls}:not(${checkboxCls}-disabled)
      `]: {
                [`&:hover ${checkboxCls}-inner`]: {
                    borderColor: token.colorPrimary
                }
            },
            [`${wrapperCls}:not(${wrapperCls}-disabled)`]: {
                [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled) ${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimaryHover,
                    borderColor: 'transparent'
                },
                [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled):after`]: {
                    borderColor: token.colorPrimaryHover
                }
            }
        },
        // ==================== Checked ====================
        {
            // Wrapper > Checkbox
            [`${checkboxCls}-checked`]: {
                [`${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimary,
                    borderColor: token.colorPrimary,
                    '&:after': {
                        opacity: 1,
                        transform: 'rotate(45deg) scale(1) translate(-50%,-50%)',
                        transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack} ${token.motionDurationFast}`
                    }
                }
            },
            [`
        ${wrapperCls}-checked:not(${wrapperCls}-disabled),
        ${checkboxCls}-checked:not(${checkboxCls}-disabled)
      `]: {
                [`&:hover ${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimaryHover,
                    borderColor: 'transparent'
                }
            }
        },
        // ================= Indeterminate =================
        {
            [checkboxCls]: {
                '&-indeterminate': {
                    '&': {
                        // Wrapper > Checkbox > inner
                        [`${checkboxCls}-inner`]: {
                            backgroundColor: `${token.colorBgContainer}`,
                            borderColor: `${token.colorBorder}`,
                            '&:after': {
                                top: '50%',
                                insetInlineStart: '50%',
                                width: token.calc(token.fontSizeLG).div(2).equal(),
                                height: token.calc(token.fontSizeLG).div(2).equal(),
                                backgroundColor: token.colorPrimary,
                                border: 0,
                                transform: 'translate(-50%, -50%) scale(1)',
                                opacity: 1,
                                content: '""'
                            }
                        },
                        // https://github.com/ant-design/ant-design/issues/50074
                        [`&:hover ${checkboxCls}-inner`]: {
                            backgroundColor: `${token.colorBgContainer}`,
                            borderColor: `${token.colorPrimary}`
                        }
                    }
                }
            }
        },
        // ==================== Disable ====================
        {
            // Wrapper
            [`${wrapperCls}-disabled`]: {
                cursor: 'not-allowed'
            },
            // Wrapper > Checkbox
            [`${checkboxCls}-disabled`]: {
                // Wrapper > Checkbox > input
                [`&, ${checkboxCls}-input`]: {
                    cursor: 'not-allowed',
                    // Disabled for native input to enable Tooltip event handler
                    // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
                    pointerEvents: 'none'
                },
                // Wrapper > Checkbox > inner
                [`${checkboxCls}-inner`]: {
                    background: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    '&:after': {
                        borderColor: token.colorTextDisabled
                    }
                },
                '&:after': {
                    display: 'none'
                },
                '& + span': {
                    color: token.colorTextDisabled
                },
                [`&${checkboxCls}-indeterminate ${checkboxCls}-inner::after`]: {
                    background: token.colorTextDisabled
                }
            }
        }
    ];
};
function $2c6e5f034ccbdb08$export$3d2f074408bd1b82(prefixCls, token) {
    const checkboxToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        checkboxCls: `.${prefixCls}`,
        checkboxSize: token.controlInteractiveSize
    });
    return $2c6e5f034ccbdb08$export$92a97fe1d1148438(checkboxToken);
}
var $2c6e5f034ccbdb08$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Checkbox', (token, { prefixCls: prefixCls })=>[
        $2c6e5f034ccbdb08$export$3d2f074408bd1b82(prefixCls, token)
    ]);



var $ltGt3 = parcelRequire("ltGt3");

function $34cfb5e7803229c1$export$2e2bcd8739ae039(onOriginInputClick) {
    const labelClickLockRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    const clearLock = ()=>{
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(labelClickLockRef.current);
        labelClickLockRef.current = null;
    };
    const onLabelClick = ()=>{
        clearLock();
        labelClickLockRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
            labelClickLockRef.current = null;
        });
    };
    const onInputClick = (e)=>{
        if (labelClickLockRef.current) {
            e.stopPropagation();
            clearLock();
        }
        onOriginInputClick?.(e);
    };
    return [
        onLabelClick,
        onInputClick
    ];
}


"use client";
const $2f59d78c816cbf43$var$InternalCheckbox = (props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, indeterminate: indeterminate = false, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, skipGroup: skipGroup = false, disabled: disabled, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('checkbox');
    const checkboxGroup = $ltGt3.useContext((0, $9f0894a3518ffde6$export$2e2bcd8739ae039));
    const { isFormItemInput: isFormItemInput } = $ltGt3.useContext((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    const contextDisabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = (checkboxGroup?.disabled || disabled) ?? contextDisabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        indeterminate: indeterminate,
        disabled: mergedDisabled
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const prevValue = $ltGt3.useRef(restProps.value);
    const checkboxRef = $ltGt3.useRef(null);
    const mergedRef = (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(ref, checkboxRef);
    $ltGt3.useEffect(()=>{
        checkboxGroup?.registerValue(restProps.value);
    }, []);
    $ltGt3.useEffect(()=>{
        if (skipGroup) return;
        if (restProps.value !== prevValue.current) {
            checkboxGroup?.cancelValue(prevValue.current);
            checkboxGroup?.registerValue(restProps.value);
            prevValue.current = restProps.value;
        }
        return ()=>checkboxGroup?.cancelValue(restProps.value);
    }, [
        restProps.value
    ]);
    $ltGt3.useEffect(()=>{
        if (checkboxRef.current?.input) checkboxRef.current.input.indeterminate = indeterminate;
    }, [
        indeterminate
    ]);
    const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $2c6e5f034ccbdb08$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const checkboxProps = {
        ...restProps
    };
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = (...args)=>{
            if (restProps.onChange) restProps.onChange.apply(restProps, args);
            if (checkboxGroup.toggleOption) checkboxGroup.toggleOption({
                label: children,
                value: restProps.value
            });
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.includes(restProps.value);
    }
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-wrapper-checked`]: checkboxProps.checked,
        [`${prefixCls}-wrapper-disabled`]: mergedDisabled,
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput
    }, contextClassName, className, mergedClassNames.root, rootClassName, cssVarCls, rootCls, hashId);
    const checkboxClass = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassNames.icon, {
        [`${prefixCls}-indeterminate`]: indeterminate
    }, (0, $59c6657b0a346860$export$23466a5792b7a5d3), hashId);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, $34cfb5e7803229c1$export$2e2bcd8739ae039)(checkboxProps.onClick);
    // ============================== Render ==============================
    return /*#__PURE__*/ $ltGt3.createElement((0, $b5f0e609aabb59e2$export$2e2bcd8739ae039), {
        component: "Checkbox",
        disabled: mergedDisabled
    }, /*#__PURE__*/ $ltGt3.createElement("label", {
        className: classString,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onLabelClick
    }, /*#__PURE__*/ $ltGt3.createElement((0, $5be58c811ab7b572$export$2e2bcd8739ae039), {
        ...checkboxProps,
        onClick: onInputClick,
        prefixCls: prefixCls,
        className: checkboxClass,
        style: mergedStyles.icon,
        disabled: mergedDisabled,
        ref: mergedRef
    }), (0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(children) && /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-label`, mergedClassNames.label),
        style: mergedStyles.label
    }, children)));
};
const $2f59d78c816cbf43$var$Checkbox = /*#__PURE__*/ $ltGt3.forwardRef($2f59d78c816cbf43$var$InternalCheckbox);
var $2f59d78c816cbf43$export$2e2bcd8739ae039 = $2f59d78c816cbf43$var$Checkbox;




var $ltGt3 = parcelRequire("ltGt3");







"use client";
const $5f52b67a8a6a5c79$var$CheckboxGroup = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { defaultValue: defaultValue, children: children, options: options = [], prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, onChange: onChange, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const [value, setValue] = $ltGt3.useState(restProps.value || defaultValue || []);
    const [registeredValues, setRegisteredValues] = $ltGt3.useState([]);
    $ltGt3.useEffect(()=>{
        if ('value' in restProps) setValue(restProps.value || []);
    }, [
        restProps.value
    ]);
    const memoizedOptions = $ltGt3.useMemo(()=>options.map((option)=>{
            if (typeof option === 'string' || typeof option === 'number') return {
                label: option,
                value: option
            };
            return option;
        }), [
        options
    ]);
    const cancelValue = (val)=>{
        setRegisteredValues((prevValues)=>prevValues.filter((v)=>v !== val));
    };
    const registerValue = (val)=>{
        setRegisteredValues((prevValues)=>[].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(prevValues), [
                val
            ]));
    };
    const toggleOption = (option)=>{
        const optionIndex = value.indexOf(option.value);
        const newValue = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(value);
        if (optionIndex === -1) newValue.push(option.value);
        else newValue.splice(optionIndex, 1);
        if (!('value' in restProps)) setValue(newValue);
        onChange?.(newValue.filter((val)=>registeredValues.includes(val)).sort((a, b)=>{
            const indexA = memoizedOptions.findIndex((opt)=>opt.value === a);
            const indexB = memoizedOptions.findIndex((opt)=>opt.value === b);
            return indexA - indexB;
        }));
    };
    const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $2c6e5f034ccbdb08$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const domProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(restProps, [
        'value',
        'disabled'
    ]);
    const childrenNode = options.length ? memoizedOptions.map((option)=>/*#__PURE__*/ $ltGt3.createElement((0, $2f59d78c816cbf43$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : restProps.disabled,
            value: option.value,
            checked: value.includes(option.value),
            onChange: option.onChange,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${groupPrefixCls}-item`, option.className),
            style: option.style,
            title: option.title,
            id: option.id,
            required: option.required
        }, option.label)) : children;
    const memoizedContext = $ltGt3.useMemo(()=>({
            toggleOption: toggleOption,
            value: value,
            disabled: restProps.disabled,
            name: restProps.name,
            registerValue: // https://github.com/ant-design/ant-design/issues/16376
            registerValue,
            cancelValue: cancelValue
        }), [
        toggleOption,
        value,
        restProps.disabled,
        restProps.name,
        registerValue,
        cancelValue
    ]);
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(groupPrefixCls, {
        [`${groupPrefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, cssVarCls, rootCls, hashId);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: classString,
        style: style,
        ...domProps,
        ref: ref
    }, /*#__PURE__*/ $ltGt3.createElement((0, $9f0894a3518ffde6$export$2e2bcd8739ae039).Provider, {
        value: memoizedContext
    }, childrenNode));
});
var $5f52b67a8a6a5c79$export$2e2bcd8739ae039 = $5f52b67a8a6a5c79$var$CheckboxGroup;


"use client";
const $0fa8595e616a52f3$var$Checkbox = (0, $2f59d78c816cbf43$export$2e2bcd8739ae039);
$0fa8595e616a52f3$var$Checkbox.Group = (0, $5f52b67a8a6a5c79$export$2e2bcd8739ae039);
$0fa8595e616a52f3$var$Checkbox.__ANT_CHECKBOX = true;
var $0fa8595e616a52f3$export$2e2bcd8739ae039 = $0fa8595e616a52f3$var$Checkbox;





var $ltGt3 = parcelRequire("ltGt3");








"use client";
const $ba633a3d0eb7f790$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, closeIcon: closeIcon, closable: closable, type: type, title: title, children: children, footer: footer, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const prefixCls = customizePrefixCls || getPrefixCls('modal');
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(rootPrefixCls);
    const [hashId, cssVarCls] = (0, $a51958ccdca509b5$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const confirmPrefixCls = `${prefixCls}-confirm`;
    // Choose target props by confirm mark
    let additionalProps = {};
    if (type) additionalProps = {
        closable: closable ?? false,
        title: '',
        footer: '',
        children: /*#__PURE__*/ $ltGt3.createElement((0, $d776250abdf93160$export$78cf841dc2c9f0b5), {
            ...props,
            prefixCls: prefixCls,
            confirmPrefixCls: confirmPrefixCls,
            rootPrefixCls: rootPrefixCls,
            content: children
        })
    };
    else additionalProps = {
        closable: closable ?? true,
        title: title,
        footer: footer !== null && /*#__PURE__*/ $ltGt3.createElement((0, $e7c5cc6735448d43$export$a06f1c675e846f6f), {
            ...props
        }),
        children: children
    };
    return /*#__PURE__*/ $ltGt3.createElement((0, $d1685b6dd6bb6981$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(hashId, `${prefixCls}-pure-panel`, type && confirmPrefixCls, type && `${confirmPrefixCls}-${type}`, className, cssVarCls, rootCls),
        ...restProps,
        closeIcon: (0, $e7c5cc6735448d43$export$97c34646962d356e)(prefixCls, closeIcon),
        closable: closable,
        ...additionalProps
    });
};
var $ba633a3d0eb7f790$export$2e2bcd8739ae039 = (0, $c64d2291d230fcde$export$29e2a8c3cdb34b03)($ba633a3d0eb7f790$var$PurePanel);



"use client";
function $f189c84ec54ae7cf$var$modalWarn(props) {
    return (0, $a9697cf78e6b64ce$export$2e2bcd8739ae039)((0, $a9697cf78e6b64ce$export$503fa8fed137d104)(props));
}
const $f189c84ec54ae7cf$var$Modal = (0, $584f96c3fae4c0d1$export$2e2bcd8739ae039);
$f189c84ec54ae7cf$var$Modal.useModal = (0, $7539c4586900c4d6$export$2e2bcd8739ae039);
$f189c84ec54ae7cf$var$Modal.info = function infoFn(props) {
    return (0, $a9697cf78e6b64ce$export$2e2bcd8739ae039)((0, $a9697cf78e6b64ce$export$2f728eab0dacbb2e)(props));
};
$f189c84ec54ae7cf$var$Modal.success = function successFn(props) {
    return (0, $a9697cf78e6b64ce$export$2e2bcd8739ae039)((0, $a9697cf78e6b64ce$export$2b5f8d7f29c805d4)(props));
};
$f189c84ec54ae7cf$var$Modal.error = function errorFn(props) {
    return (0, $a9697cf78e6b64ce$export$2e2bcd8739ae039)((0, $a9697cf78e6b64ce$export$60e9e0884ce12b55)(props));
};
$f189c84ec54ae7cf$var$Modal.warning = $f189c84ec54ae7cf$var$modalWarn;
$f189c84ec54ae7cf$var$Modal.warn = $f189c84ec54ae7cf$var$modalWarn;
$f189c84ec54ae7cf$var$Modal.confirm = function confirmFn(props) {
    return (0, $a9697cf78e6b64ce$export$2e2bcd8739ae039)((0, $a9697cf78e6b64ce$export$665b64399d4af99c)(props));
};
$f189c84ec54ae7cf$var$Modal.destroyAll = function destroyAllFn() {
    while((0, $85eeaeeecb81dd27$export$2e2bcd8739ae039).length){
        const close = (0, $85eeaeeecb81dd27$export$2e2bcd8739ae039).pop();
        if (close) close();
    }
};
$f189c84ec54ae7cf$var$Modal.config = (0, $a9697cf78e6b64ce$export$ff0b30c638ae2396);
$f189c84ec54ae7cf$var$Modal._InternalPanelDoNotUseOrYouWillBeFired = (0, $ba633a3d0eb7f790$export$2e2bcd8739ae039);
var $f189c84ec54ae7cf$export$2e2bcd8739ae039 = $f189c84ec54ae7cf$var$Modal;


var $ltGt3 = parcelRequire("ltGt3");



const $428795e0a4a9e60b$export$15e5fca53711d340 = (propValue)=>{
    if (!propValue) return null;
    return typeof propValue === 'function' ? propValue() : propValue;
};









var $ltGt3 = parcelRequire("ltGt3");










const $882f51503f9f9673$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, popoverColor: popoverColor, titleMinWidth: titleMinWidth, fontWeightStrong: fontWeightStrong, innerPadding: innerPadding, boxShadowSecondary: boxShadowSecondary, colorTextHeading: colorTextHeading, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, titleMarginBottom: titleMarginBottom, colorBgElevated: colorBgElevated, popoverBg: popoverBg, titleBorderBottom: titleBorderBottom, innerContentPadding: innerContentPadding, titlePadding: titlePadding } = token;
    return [
        {
            [componentCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                position: 'absolute',
                top: 0,
                // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
                left: {
                    _skip_check_: true,
                    value: 0
                },
                zIndex: zIndexPopup,
                fontWeight: 'normal',
                whiteSpace: 'normal',
                textAlign: 'start',
                cursor: 'auto',
                userSelect: 'text',
                // When use `autoArrow`, origin will follow the arrow position
                '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
                transformOrigin: [
                    `var(--valid-offset-x, 50%)`,
                    `var(--arrow-y, 50%)`
                ].join(' '),
                '--antd-arrow-background-color': colorBgElevated,
                width: 'max-content',
                maxWidth: '100vw',
                '&-rtl': {
                    direction: 'rtl'
                },
                '&-hidden': {
                    display: 'none'
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                },
                [`${componentCls}-container`]: {
                    backgroundColor: popoverBg,
                    backgroundClip: 'padding-box',
                    borderRadius: borderRadiusLG,
                    boxShadow: boxShadowSecondary,
                    padding: innerPadding
                },
                [`${componentCls}-title`]: {
                    minWidth: titleMinWidth,
                    marginBottom: titleMarginBottom,
                    color: colorTextHeading,
                    fontWeight: fontWeightStrong,
                    borderBottom: titleBorderBottom,
                    padding: titlePadding
                },
                [`${componentCls}-content`]: {
                    color: popoverColor,
                    padding: innerContentPadding
                }
            }
        },
        // Arrow Style
        (0, $f61b43f1533e9f98$export$2e2bcd8739ae039)(token, 'var(--antd-arrow-background-color)'),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow,
                display: 'inline-block'
            }
        }
    ];
};
const $882f51503f9f9673$var$genColorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: (0, $e1e3919c46d634bc$export$6d4fe3a00a1811ad).map((colorKey)=>{
            const lightColor = token[`${colorKey}6`];
            return {
                [`&${componentCls}-${colorKey}`]: {
                    '--antd-arrow-background-color': lightColor,
                    [`${componentCls}-inner`]: {
                        backgroundColor: lightColor
                    },
                    [`${componentCls}-arrow`]: {
                        background: 'transparent'
                    }
                }
            };
        })
    };
};
const $882f51503f9f9673$export$9ca1be8807fe0675 = (token)=>{
    const { lineWidth: lineWidth, controlHeight: controlHeight, fontHeight: fontHeight, padding: padding, wireframe: wireframe, zIndexPopupBase: zIndexPopupBase, borderRadiusLG: borderRadiusLG, marginXS: marginXS, lineType: lineType, colorSplit: colorSplit, paddingSM: paddingSM } = token;
    const titlePaddingBlockDist = controlHeight - fontHeight;
    const popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
    const popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
    const popoverPaddingHorizontal = padding;
    return {
        titleMinWidth: 177,
        zIndexPopup: zIndexPopupBase + 30,
        ...(0, $bf6e216ed4fab7a5$export$87e38ee403661ccc)(token),
        ...(0, $f61b43f1533e9f98$export$bddc192327bb9823)({
            contentRadius: borderRadiusLG,
            limitVerticalRadius: true
        }),
        // internal
        innerPadding: wireframe ? 0 : 12,
        titleMarginBottom: wireframe ? 0 : marginXS,
        titlePadding: wireframe ? `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px` : 0,
        titleBorderBottom: wireframe ? `${lineWidth}px ${lineType} ${colorSplit}` : 'none',
        innerContentPadding: wireframe ? `${paddingSM}px ${popoverPaddingHorizontal}px` : 0
    };
};
var $882f51503f9f9673$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Popover', (token)=>{
    const { colorBgElevated: colorBgElevated, colorText: colorText } = token;
    const popoverToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        popoverBg: colorBgElevated,
        popoverColor: colorText
    });
    return [
        $882f51503f9f9673$var$genBaseStyle(popoverToken),
        $882f51503f9f9673$var$genColorStyle(popoverToken),
        (0, $29a43b27eddd598a$export$f5d123412490d9dc)(popoverToken, 'zoom-big')
    ];
}, $882f51503f9f9673$export$9ca1be8807fe0675, {
    resetStyle: false,
    deprecatedTokens: [
        [
            'width',
            'titleMinWidth'
        ],
        [
            'minWidth',
            'titleMinWidth'
        ]
    ]
});


"use client";
const $1208369eb14302c3$export$c6fdb837b070b4ff = (props)=>{
    const { title: title, content: content, prefixCls: prefixCls, classNames: classNames, styles: styles } = props;
    if (!title && !content) return null;
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, title && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-title`, classNames?.title),
        style: styles?.title
    }, title), content && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-content`, classNames?.content),
        style: styles?.content
    }, content));
};
const $1208369eb14302c3$export$c40925af82c95d5b = (props)=>{
    const { hashId: hashId, prefixCls: prefixCls, className: className, style: style, placement: placement = 'top', title: title, content: content, children: children, classNames: classNames, styles: styles } = props;
    const titleNode = (0, $428795e0a4a9e60b$export$15e5fca53711d340)(title);
    const contentNode = (0, $428795e0a4a9e60b$export$15e5fca53711d340)(content);
    const mergedProps = {
        ...props,
        placement: placement
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        classNames
    ], [
        styles
    ], {
        props: mergedProps
    });
    const rootClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: rootClassName,
        style: style
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $ltGt3.createElement((0, $57b616b1a2d66246$export$2e2bcd8739ae039), {
        ...props,
        className: hashId,
        prefixCls: prefixCls,
        classNames: mergedClassNames,
        styles: mergedStyles
    }, children || /*#__PURE__*/ $ltGt3.createElement($1208369eb14302c3$export$c6fdb837b070b4ff, {
        prefixCls: prefixCls,
        title: titleNode,
        content: contentNode,
        classNames: mergedClassNames,
        styles: mergedStyles
    })));
};
const $1208369eb14302c3$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $882f51503f9f9673$export$2e2bcd8739ae039)(prefixCls);
    return /*#__PURE__*/ $ltGt3.createElement($1208369eb14302c3$export$c40925af82c95d5b, {
        ...restProps,
        prefixCls: prefixCls,
        hashId: hashId,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, cssVarCls)
    });
};
var $1208369eb14302c3$export$2e2bcd8739ae039 = $1208369eb14302c3$var$PurePanel;



"use client";
const $6425aad248c6262a$var$InternalPopover = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, title: title, content: content, overlayClassName: overlayClassName, placement: placement = 'top', trigger: trigger = 'hover', children: children, mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, onOpenChange: onOpenChange, overlayStyle: overlayStyle = {}, styles: styles, classNames: classNames, motion: motion, arrow: popoverArrow, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('popover');
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $882f51503f9f9673$export$2e2bcd8739ae039)(prefixCls);
    const rootPrefixCls = getPrefixCls();
    const mergedArrow = (0, $3707a18e8e736900$export$2e2bcd8739ae039)(popoverArrow, contextArrow);
    // ============================= Styles =============================
    const mergedProps = {
        ...props,
        placement: placement,
        trigger: trigger,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        overlayStyle: overlayStyle,
        styles: styles,
        classNames: classNames
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(overlayClassName, hashId, cssVarCls, contextClassName, mergedClassNames.root);
    const [open, setOpen] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(props.defaultOpen ?? false, props.open);
    const settingOpen = (value, e)=>{
        setOpen(value);
        onOpenChange?.(value, e);
    };
    const onKeyDown = (e)=>{
        if (e.keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ESC) settingOpen(false, e);
    };
    const onInternalOpenChange = (value)=>{
        settingOpen(value);
    };
    const titleNode = (0, $428795e0a4a9e60b$export$15e5fca53711d340)(title);
    const contentNode = (0, $428795e0a4a9e60b$export$15e5fca53711d340)(content);
    return /*#__PURE__*/ $ltGt3.createElement((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
        unique: false,
        arrow: mergedArrow,
        placement: placement,
        trigger: trigger,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        ...restProps,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow
        },
        styles: {
            root: {
                ...mergedStyles.root,
                ...contextStyle,
                ...overlayStyle
            },
            container: mergedStyles.container,
            arrow: mergedStyles.arrow
        },
        ref: ref,
        open: open,
        onOpenChange: onInternalOpenChange,
        overlay: titleNode || contentNode ? /*#__PURE__*/ $ltGt3.createElement((0, $1208369eb14302c3$export$c6fdb837b070b4ff), {
            prefixCls: prefixCls,
            title: titleNode,
            content: contentNode,
            classNames: mergedClassNames,
            styles: mergedStyles
        }) : null,
        motion: {
            motionName: (0, $32c4c593a0d4aef5$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big', typeof motion?.motionName === 'string' ? motion?.motionName : undefined)
        },
        "data-popover-inject": true
    }, (0, $66d38239e1a27993$export$e530037191fcd5d7)(children, {
        onKeyDown: (e)=>{
            if (/*#__PURE__*/ (0, $ltGt3.isValidElement)(children)) children?.props.onKeyDown?.(e);
            onKeyDown(e);
        }
    }));
});
const $6425aad248c6262a$var$Popover = $6425aad248c6262a$var$InternalPopover;
$6425aad248c6262a$var$Popover._InternalPanelDoNotUseOrYouWillBeFired = (0, $1208369eb14302c3$export$2e2bcd8739ae039);
var $6425aad248c6262a$export$2e2bcd8739ae039 = $6425aad248c6262a$var$Popover;


var $ltGt3 = parcelRequire("ltGt3");

/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $ce01a065a9be66f3$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false;
    // Keep track of the last time `callback` was executed.
    var lastExec = 0;
    // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    }
    // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
        // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel;
    // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $ce01a065a9be66f3$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $ce01a065a9be66f3$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}






var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");


"use client";
const $630120afe1683780$var$viewSize = 100;
const $630120afe1683780$var$borderWidth = $630120afe1683780$var$viewSize / 5;
const $630120afe1683780$var$radius = $630120afe1683780$var$viewSize / 2 - $630120afe1683780$var$borderWidth / 2;
const $630120afe1683780$var$circumference = $630120afe1683780$var$radius * 2 * Math.PI;
const $630120afe1683780$var$position = 50;
const $630120afe1683780$var$CustomCircle = (props)=>{
    const { dotClassName: dotClassName, style: style, hasCircleCls: hasCircleCls } = props;
    return /*#__PURE__*/ $ltGt3.createElement("circle", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${dotClassName}-circle`, {
            [`${dotClassName}-circle-bg`]: hasCircleCls
        }),
        r: $630120afe1683780$var$radius,
        cx: $630120afe1683780$var$position,
        cy: $630120afe1683780$var$position,
        strokeWidth: $630120afe1683780$var$borderWidth,
        style: style
    });
};
const $630120afe1683780$var$Progress = ({ percent: percent, prefixCls: prefixCls })=>{
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    const [render, setRender] = $ltGt3.useState(false);
    // ==================== Visible =====================
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (percent !== 0) setRender(true);
    }, [
        percent !== 0
    ]);
    // ==================== Progress ====================
    const safePtg = Math.max(Math.min(percent, 100), 0);
    // ===================== Render =====================
    if (!render) return null;
    const circleStyle = {
        strokeDashoffset: `${$630120afe1683780$var$circumference / 4}`,
        strokeDasharray: `${$630120afe1683780$var$circumference * safePtg / 100} ${$630120afe1683780$var$circumference * (100 - safePtg) / 100}`
    };
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(holderClassName, `${dotClassName}-progress`, safePtg <= 0 && hideClassName)
    }, /*#__PURE__*/ $ltGt3.createElement("svg", {
        viewBox: `0 0 ${$630120afe1683780$var$viewSize} ${$630120afe1683780$var$viewSize}`,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": safePtg
    }, /*#__PURE__*/ $ltGt3.createElement($630120afe1683780$var$CustomCircle, {
        dotClassName: dotClassName,
        hasCircleCls: true
    }), /*#__PURE__*/ $ltGt3.createElement($630120afe1683780$var$CustomCircle, {
        dotClassName: dotClassName,
        style: circleStyle
    })));
};
var $630120afe1683780$export$2e2bcd8739ae039 = $630120afe1683780$var$Progress;


"use client";
function $13289a536fbb102b$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, percent: percent = 0, className: className, style: style } = props;
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    // ===================== Render =====================
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(holderClassName, className, percent > 0 && hideClassName),
        style: style
    }, /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(dotClassName, `${prefixCls}-dot-spin`)
    }, [
        1,
        2,
        3,
        4
    ].map((i)=>/*#__PURE__*/ $ltGt3.createElement("i", {
            className: `${prefixCls}-dot-item`,
            key: i
        })))), /*#__PURE__*/ $ltGt3.createElement((0, $630120afe1683780$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent
    }));
}


"use client";
function $44f388c9348f671b$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, indicator: indicator, percent: percent, className: className, style: style } = props;
    const dotClassName = `${prefixCls}-dot`;
    if (indicator && /*#__PURE__*/ $ltGt3.isValidElement(indicator)) return (0, $66d38239e1a27993$export$e530037191fcd5d7)(indicator, (currentProps)=>({
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(currentProps.className, dotClassName, className),
            style: {
                ...currentProps.style,
                ...style
            },
            percent: percent
        }));
    return /*#__PURE__*/ $ltGt3.createElement((0, $13289a536fbb102b$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent,
        className: className,
        style: style
    });
}





const $ed361b6998deb269$var$antSpinMove = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antSpinMove', {
    to: {
        opacity: 1
    }
});
const $ed361b6998deb269$var$antRotate = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antRotate', {
    to: {
        transform: 'rotate(405deg)'
    }
});
const $ed361b6998deb269$var$genSpinStyle = (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            position: 'absolute',
            display: 'none',
            color: token.colorPrimary,
            fontSize: 0,
            textAlign: 'center',
            verticalAlign: 'middle',
            opacity: 0,
            transition: `transform ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
            '&-spinning': {
                position: 'relative',
                display: 'inline-block',
                opacity: 1
            },
            [`${componentCls}-text`]: {
                fontSize: token.fontSize,
                paddingTop: calc(calc(token.dotSize).sub(token.fontSize)).div(2).add(2).equal()
            },
            '&-fullscreen': {
                position: 'fixed',
                width: '100vw',
                height: '100vh',
                backgroundColor: token.colorBgMask,
                zIndex: token.zIndexPopupBase,
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                opacity: 0,
                visibility: 'hidden',
                transition: `all ${token.motionDurationMid}`,
                '&-show': {
                    opacity: 1,
                    visibility: 'visible'
                },
                [componentCls]: {
                    [`${componentCls}-dot-holder`]: {
                        color: token.colorWhite
                    },
                    [`${componentCls}-text`]: {
                        color: token.colorTextLightSolid
                    }
                }
            },
            '&-nested-loading': {
                position: 'relative',
                [`> div > ${componentCls}`]: {
                    position: 'absolute',
                    top: 0,
                    insetInlineStart: 0,
                    zIndex: 4,
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    maxHeight: token.contentHeight,
                    [`${componentCls}-dot`]: {
                        position: 'absolute',
                        top: '50%',
                        insetInlineStart: '50%',
                        margin: calc(token.dotSize).mul(-1).div(2).equal()
                    },
                    [`${componentCls}-text`]: {
                        position: 'absolute',
                        top: '50%',
                        width: '100%',
                        textShadow: `0 1px 2px ${token.colorBgContainer}` // FIXME: shadow
                    },
                    [`&${componentCls}-show-text ${componentCls}-dot`]: {
                        marginTop: calc(token.dotSize).div(2).mul(-1).sub(10).equal()
                    },
                    '&-sm': {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeSM).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeSM).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeSM).div(2).mul(-1).sub(10).equal()
                        }
                    },
                    '&-lg': {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeLG).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeLG).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeLG).div(2).mul(-1).sub(10).equal()
                        }
                    }
                },
                [`${componentCls}-container`]: {
                    position: 'relative',
                    transition: `opacity ${token.motionDurationSlow}`,
                    '&::after': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        zIndex: 10,
                        width: '100%',
                        height: '100%',
                        background: token.colorBgContainer,
                        opacity: 0,
                        transition: `all ${token.motionDurationSlow}`,
                        content: '""',
                        pointerEvents: 'none'
                    }
                },
                [`${componentCls}-blur`]: {
                    clear: 'both',
                    opacity: 0.5,
                    userSelect: 'none',
                    pointerEvents: 'none',
                    '&::after': {
                        opacity: 0.4,
                        pointerEvents: 'auto'
                    }
                }
            },
            // tip
            // ------------------------------
            '&-tip': {
                color: token.spinDotDefault
            },
            // holder
            // ------------------------------
            [`${componentCls}-dot-holder`]: {
                width: '1em',
                height: '1em',
                fontSize: token.dotSize,
                display: 'inline-block',
                transition: `transform ${token.motionDurationSlow} ease, opacity ${token.motionDurationSlow} ease`,
                transformOrigin: '50% 50%',
                lineHeight: 1,
                color: token.colorPrimary,
                '&-hidden': {
                    transform: 'scale(0.3)',
                    opacity: 0
                }
            },
            // progress
            // ------------------------------
            [`${componentCls}-dot-progress`]: {
                position: 'absolute',
                inset: 0
            },
            // dots
            // ------------------------------
            [`${componentCls}-dot`]: {
                position: 'relative',
                display: 'inline-block',
                fontSize: token.dotSize,
                width: '1em',
                height: '1em',
                '&-item': {
                    position: 'absolute',
                    display: 'block',
                    width: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    height: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    background: 'currentColor',
                    borderRadius: '100%',
                    transform: 'scale(0.75)',
                    transformOrigin: '50% 50%',
                    opacity: 0.3,
                    animationName: $ed361b6998deb269$var$antSpinMove,
                    animationDuration: '1s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear',
                    animationDirection: 'alternate',
                    '&:nth-child(1)': {
                        top: 0,
                        insetInlineStart: 0,
                        animationDelay: '0s'
                    },
                    '&:nth-child(2)': {
                        top: 0,
                        insetInlineEnd: 0,
                        animationDelay: '0.4s'
                    },
                    '&:nth-child(3)': {
                        insetInlineEnd: 0,
                        bottom: 0,
                        animationDelay: '0.8s'
                    },
                    '&:nth-child(4)': {
                        bottom: 0,
                        insetInlineStart: 0,
                        animationDelay: '1.2s'
                    }
                },
                '&-spin': {
                    transform: 'rotate(45deg)',
                    animationName: $ed361b6998deb269$var$antRotate,
                    animationDuration: '1.2s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear'
                },
                '&-circle': {
                    strokeLinecap: 'round',
                    transition: [
                        'stroke-dashoffset',
                        'stroke-dasharray',
                        'stroke',
                        'stroke-width',
                        'opacity'
                    ].map((item)=>`${item} ${token.motionDurationSlow} ease`).join(','),
                    fillOpacity: 0,
                    stroke: 'currentcolor'
                },
                '&-circle-bg': {
                    stroke: token.colorFillSecondary
                }
            },
            // small
            [`&-sm ${componentCls}-dot`]: {
                '&, &-holder': {
                    fontSize: token.dotSizeSM
                }
            },
            [`&-sm ${componentCls}-dot-holder`]: {
                i: {
                    width: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal(),
                    height: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal()
                }
            },
            // large
            [`&-lg ${componentCls}-dot`]: {
                '&, &-holder': {
                    fontSize: token.dotSizeLG
                }
            },
            [`&-lg ${componentCls}-dot-holder`]: {
                i: {
                    width: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal(),
                    height: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal()
                }
            },
            [`&${componentCls}-show-text ${componentCls}-text`]: {
                display: 'block'
            }
        }
    };
};
const $ed361b6998deb269$export$9ca1be8807fe0675 = (token)=>{
    const { controlHeightLG: controlHeightLG, controlHeight: controlHeight } = token;
    return {
        contentHeight: 400,
        dotSize: controlHeightLG / 2,
        dotSizeSM: controlHeightLG * 0.35,
        dotSizeLG: controlHeight
    };
};
var // ============================== Export ==============================
$ed361b6998deb269$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Spin', (token)=>{
    const spinToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        spinDotDefault: token.colorTextDescription
    });
    return $ed361b6998deb269$var$genSpinStyle(spinToken);
}, $ed361b6998deb269$export$9ca1be8807fe0675);



var $ltGt3 = parcelRequire("ltGt3");
const $f19782394d430d98$var$AUTO_INTERVAL = 200;
const $f19782394d430d98$var$STEP_BUCKETS = [
    [
        30,
        0.05
    ],
    [
        70,
        0.03
    ],
    [
        96,
        0.01
    ]
];
function $f19782394d430d98$export$2e2bcd8739ae039(spinning, percent) {
    const [mockPercent, setMockPercent] = $ltGt3.useState(0);
    const mockIntervalRef = $ltGt3.useRef(null);
    const isAuto = percent === 'auto';
    $ltGt3.useEffect(()=>{
        if (isAuto && spinning) {
            setMockPercent(0);
            mockIntervalRef.current = setInterval(()=>{
                setMockPercent((prev)=>{
                    const restPTG = 100 - prev;
                    for(let i = 0; i < $f19782394d430d98$var$STEP_BUCKETS.length; i += 1){
                        const [limit, stepPtg] = $f19782394d430d98$var$STEP_BUCKETS[i];
                        if (prev <= limit) return prev + restPTG * stepPtg;
                    }
                    return prev;
                });
            }, $f19782394d430d98$var$AUTO_INTERVAL);
        }
        return ()=>{
            if (mockIntervalRef.current) {
                clearInterval(mockIntervalRef.current);
                mockIntervalRef.current = null;
            }
        };
    }, [
        isAuto,
        spinning
    ]);
    return isAuto ? mockPercent : percent;
}


"use client";
const $f5e177132d6f3f0f$var$_SpinSizes = [
    'small',
    'default',
    'large'
];
// Render indicator
let $f5e177132d6f3f0f$var$defaultIndicator;
function $f5e177132d6f3f0f$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !Number.isNaN(Number(delay));
}
const $f5e177132d6f3f0f$var$Spin = (props)=>{
    const { prefixCls: customizePrefixCls, spinning: customSpinning = true, delay: delay = 0, className: className, rootClassName: rootClassName, size: size = 'default', tip: tip, wrapperClassName: wrapperClassName, style: style, children: children, fullscreen: fullscreen = false, indicator: indicator, percent: percent, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, indicator: contextIndicator, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('spin');
    const prefixCls = getPrefixCls('spin', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ed361b6998deb269$export$2e2bcd8739ae039)(prefixCls);
    const [spinning, setSpinning] = $ltGt3.useState(()=>customSpinning && !$f5e177132d6f3f0f$var$shouldDelay(customSpinning, delay));
    const mergedPercent = (0, $f19782394d430d98$export$2e2bcd8739ae039)(spinning, percent);
    $ltGt3.useEffect(()=>{
        if (customSpinning) {
            const showSpinning = (0, $ce01a065a9be66f3$export$61fc7d43ac8f84b0)(delay, ()=>{
                setSpinning(true);
            });
            showSpinning();
            return ()=>{
                showSpinning?.cancel?.();
            };
        }
        setSpinning(false);
    }, [
        delay,
        customSpinning
    ]);
    const isNestedPattern = $ltGt3.useMemo(()=>typeof children !== 'undefined' && !fullscreen, [
        children,
        fullscreen
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: size,
        spinning: spinning,
        tip: tip,
        fullscreen: fullscreen,
        children: children,
        percent: mergedPercent
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const spinClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, contextClassName, {
        [`${prefixCls}-sm`]: size === 'small',
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-spinning`]: spinning,
        [`${prefixCls}-show-text`]: !!tip,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, !fullscreen && rootClassName, !fullscreen && mergedClassNames.root, hashId, cssVarCls);
    const containerClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-container`, {
        [`${prefixCls}-blur`]: spinning
    });
    const mergedIndicator = indicator ?? contextIndicator ?? $f5e177132d6f3f0f$var$defaultIndicator;
    const mergedStyle = {
        ...contextStyle,
        ...style
    };
    const spinElement = /*#__PURE__*/ $ltGt3.createElement("div", {
        ...restProps,
        style: fullscreen ? mergedStyle : {
            ...mergedStyles.root,
            ...mergedStyle
        },
        className: spinClassName,
        "aria-live": "polite",
        "aria-busy": spinning
    }, /*#__PURE__*/ $ltGt3.createElement((0, $44f388c9348f671b$export$2e2bcd8739ae039), {
        className: mergedClassNames.indicator,
        style: mergedStyles.indicator,
        prefixCls: prefixCls,
        indicator: mergedIndicator,
        percent: mergedPercent
    }), tip && (isNestedPattern || fullscreen) ? /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-text`, mergedClassNames.tip),
        style: mergedStyles.tip
    }, tip) : null);
    if (isNestedPattern) return /*#__PURE__*/ $ltGt3.createElement("div", {
        ...restProps,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-nested-loading`, wrapperClassName, mergedClassNames.wrapper, hashId, cssVarCls),
        style: mergedStyles.wrapper
    }, spinning && /*#__PURE__*/ $ltGt3.createElement("div", {
        key: "loading"
    }, spinElement), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: containerClassName,
        key: "container"
    }, children));
    if (fullscreen) return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-fullscreen`, {
            [`${prefixCls}-fullscreen-show`]: spinning
        }, rootClassName, hashId, cssVarCls, mergedClassNames.mask),
        style: mergedStyles.mask
    }, spinElement);
    return spinElement;
};
$f5e177132d6f3f0f$var$Spin.setDefaultIndicator = (indicator)=>{
    $f5e177132d6f3f0f$var$defaultIndicator = indicator;
};
var $f5e177132d6f3f0f$export$2e2bcd8739ae039 = $f5e177132d6f3f0f$var$Spin;



var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");


var $8397f586b179aba6$var$SearchOutlined = function SearchOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $f194bf0d5b744bcd$export$2e2bcd8739ae039)
    }));
};
/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */ var $8397f586b179aba6$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($8397f586b179aba6$var$SearchOutlined);
var $8397f586b179aba6$export$2e2bcd8739ae039 = $8397f586b179aba6$var$RefIcon;




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
const $ba07af6bf309700b$export$b8efcc4bff45e15b = 1;
function $ba07af6bf309700b$export$fb237fa819e17281(map) {
    return Object.freeze({
        __version: $ba07af6bf309700b$export$b8efcc4bff45e15b,
        map: map
    });
}
function $ba07af6bf309700b$export$9efaf186a2224858(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const $ba07af6bf309700b$export$7de1b54b0142048f = (0, $ltGt3.createContext)(null);
const $ba07af6bf309700b$export$a24c9fc2f87814b2 = $ba07af6bf309700b$export$7de1b54b0142048f.Provider;
function $ba07af6bf309700b$export$ea59151b8430a4e9() {
    const context = (0, $ltGt3.useContext)($ba07af6bf309700b$export$7de1b54b0142048f);
    if (context == null) throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    return context;
}


var $667e111c775e8897$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($667e111c775e8897$exports);
})($667e111c775e8897$exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});



var $ltGt3 = parcelRequire("ltGt3");
function $f089108b59bac9df$var$_extends() {
    $f089108b59bac9df$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f089108b59bac9df$var$_extends.apply(this, arguments);
}
function $f089108b59bac9df$var$MapContainerComponent({ bounds: bounds, boundsOptions: boundsOptions, center: center, children: children, className: className, id: id, placeholder: placeholder, style: style, whenReady: whenReady, zoom: zoom, ...options }, forwardedRef) {
    const [props] = (0, $ltGt3.useState)({
        className: className,
        id: id,
        style: style
    });
    const [context, setContext] = (0, $ltGt3.useState)(null);
    (0, $ltGt3.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    const mapRef = (0, $ltGt3.useCallback)((node)=>{
        if (node !== null && context === null) {
            const map = new (0, $667e111c775e8897$exports.Map)(node, options);
            if (center != null && zoom != null) map.setView(center, zoom);
            else if (bounds != null) map.fitBounds(bounds, boundsOptions);
            if (whenReady != null) map.whenReady(whenReady);
            setContext((0, $ba07af6bf309700b$export$fb237fa819e17281)(map));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $ltGt3.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $ba07af6bf309700b$export$a24c9fc2f87814b2), {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", $f089108b59bac9df$var$_extends({}, props, {
        ref: mapRef
    }), contents);
}
const $f089108b59bac9df$export$23f3dfd47374502b = /*#__PURE__*/ (0, $ltGt3.forwardRef)($f089108b59bac9df$var$MapContainerComponent);


var $ltGt3 = parcelRequire("ltGt3");
function $93fd1c622e86bd88$export$a080ff44e8067a44(instance, context, container) {
    return Object.freeze({
        instance: instance,
        context: context,
        container: container
    });
}
function $93fd1c622e86bd88$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        const elementRef = (0, $ltGt3.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        return elementRef;
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $ltGt3.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0, $ltGt3.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $ltGt3.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}


var $ltGt3 = parcelRequire("ltGt3");


function $bf1bae5400ad4149$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $ltGt3.useImperativeHandle)(forwardedRef, ()=>instance);
        return props.children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $ba07af6bf309700b$export$a24c9fc2f87814b2), {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0, $ltGt3.forwardRef)(ContainerComponent);
}
function $bf1bae5400ad4149$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0, $ltGt3.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $ltGt3.useImperativeHandle)(forwardedRef, ()=>instance);
        (0, $ltGt3.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $35c0fb1a856c78db$exports.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $ltGt3.forwardRef)(OverlayComponent);
}
function $bf1bae5400ad4149$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance: instance } = useElement(props).current;
        (0, $ltGt3.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $ltGt3.forwardRef)(LeafComponent);
}



var $ltGt3 = parcelRequire("ltGt3");

function $af2d11af9fda5103$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $ba07af6bf309700b$export$ea59151b8430a4e9)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $ltGt3.useRef)(props.position);
        const { position: position } = props;
        (0, $ltGt3.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $ltGt3.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
function $cb7bdbeec1f29d00$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $ltGt3.useRef)(attribution);
    (0, $ltGt3.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}




var $ltGt3 = parcelRequire("ltGt3");
function $8e3d6a98d0991653$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $ltGt3.useRef)();
    (0, $ltGt3.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}


function $265fccf03aa685d0$export$6ee5d263358f5c0e(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}


function $4a5c04f8e9fc4fe0$export$cd00a227f8cfb2c2(element, context) {
    (0, $ltGt3.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $4a5c04f8e9fc4fe0$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $ba07af6bf309700b$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $265fccf03aa685d0$export$6ee5d263358f5c0e)(props, context), context);
        (0, $cb7bdbeec1f29d00$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $8e3d6a98d0991653$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        $4a5c04f8e9fc4fe0$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}






function $e7d11202c2f600fd$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $ba07af6bf309700b$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $265fccf03aa685d0$export$6ee5d263358f5c0e)(props, context), context);
        (0, $cb7bdbeec1f29d00$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $8e3d6a98d0991653$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}



var $ltGt3 = parcelRequire("ltGt3");




function $17f38a58a03bf0d2$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $ltGt3.useRef)();
    (0, $ltGt3.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $17f38a58a03bf0d2$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $ba07af6bf309700b$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $265fccf03aa685d0$export$6ee5d263358f5c0e)(props, context), context);
        (0, $8e3d6a98d0991653$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        (0, $4a5c04f8e9fc4fe0$export$cd00a227f8cfb2c2)(elementRef.current, context);
        $17f38a58a03bf0d2$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}


function $976deef9fc8fe00d$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return (0, $93fd1c622e86bd88$export$a080ff44e8067a44)(createInstance(props), context);
    }
    const useElement = (0, $93fd1c622e86bd88$export$2e66ec8a7fb1892f)(createElement);
    const useControl = (0, $af2d11af9fda5103$export$28d24ab3914549cd)(useElement);
    return (0, $bf1bae5400ad4149$export$18af5c7a9e9b3664)(useControl);
}
function $976deef9fc8fe00d$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $93fd1c622e86bd88$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $4a5c04f8e9fc4fe0$export$73f852c6a5abdefa)(useElement);
    return (0, $bf1bae5400ad4149$export$96eac748c3f41e82)(useLayer);
}
function $976deef9fc8fe00d$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $93fd1c622e86bd88$export$2e66ec8a7fb1892f)(createElement);
    const useOverlay = (0, $e7d11202c2f600fd$export$d5eca53b0accc0e0)(useElement, useLifecycle);
    return (0, $bf1bae5400ad4149$export$bc37ddc24ed05446)(useOverlay);
}
function $976deef9fc8fe00d$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $93fd1c622e86bd88$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const usePath = (0, $17f38a58a03bf0d2$export$5fea2fe6048fc3db)(useElement);
    return (0, $bf1bae5400ad4149$export$96eac748c3f41e82)(usePath);
}
function $976deef9fc8fe00d$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $93fd1c622e86bd88$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $4a5c04f8e9fc4fe0$export$73f852c6a5abdefa)(useElement);
    return (0, $bf1bae5400ad4149$export$18af5c7a9e9b3664)(useLayer);
}

function $c58f4e64068be655$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}



const $78beab327f93d7c6$export$f52ee31d61d0b27b = (0, $976deef9fc8fe00d$export$4f432c6de5c4ddb8)(function createTileLayer({ url: url, ...options }, context) {
    const layer = new (0, $667e111c775e8897$exports.TileLayer)(url, (0, $265fccf03aa685d0$export$6ee5d263358f5c0e)(options, context));
    return (0, $93fd1c622e86bd88$export$a080ff44e8067a44)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    (0, $c58f4e64068be655$export$b39104a5f1b9296f)(layer, props, prevProps);
    const { url: url } = props;
    if (url != null && url !== prevProps.url) layer.setUrl(url);
});



var $ltGt3 = parcelRequire("ltGt3");
function $9ce1a4f96ddeca9f$export$86f8f9f08863e403() {
    return (0, $ba07af6bf309700b$export$ea59151b8430a4e9)().map;
}
function $9ce1a4f96ddeca9f$export$4c2959913f5c7962(type, handler) {
    const map = $9ce1a4f96ddeca9f$export$86f8f9f08863e403();
    (0, $ltGt3.useEffect)(function addMapEventHandler() {
        // @ts-ignore event type
        map.on(type, handler);
        return function removeMapEventHandler() {
            // @ts-ignore event type
            map.off(type, handler);
        };
    }, [
        map,
        type,
        handler
    ]);
    return map;
}
function $9ce1a4f96ddeca9f$export$1c51e2c234152172(handlers) {
    const map = $9ce1a4f96ddeca9f$export$86f8f9f08863e403();
    (0, $ltGt3.useEffect)(function addMapEventHandlers() {
        map.on(handlers);
        return function removeMapEventHandlers() {
            map.off(handlers);
        };
    }, [
        map,
        handlers
    ]);
    return map;
}




var $f22015d93e97b9e3$exports = {};
/*! dom-to-image-more 14-02-2024 */ !function(s) {
    "use strict";
    const d = function() {
        let e = 0;
        return {
            escape: function(e) {
                return e.replace(/([.*+?^${}()|[]\/\\])/g, "\\$1");
            },
            isDataUrl: function(e) {
                return -1 !== e.search(/^(data:)/);
            },
            canvasToBlob: function(t) {
                if (t.toBlob) return new Promise(function(e) {
                    t.toBlob(e);
                });
                return function(i) {
                    return new Promise(function(e) {
                        var t = u(i.toDataURL().split(",")[1]), n = t.length, o = new Uint8Array(n);
                        for(let e = 0; e < n; e++)o[e] = t.charCodeAt(e);
                        e(new Blob([
                            o
                        ], {
                            type: "image/png"
                        }));
                    });
                }(t);
            },
            resolveUrl: function(e, t) {
                var n = document.implementation.createHTMLDocument(), o = n.createElement("base"), i = (n.head.appendChild(o), n.createElement("a"));
                return n.body.appendChild(i), o.href = t, i.href = e, i.href;
            },
            getAndEncode: function(u) {
                let e = c.impl.urlCache.find(function(e) {
                    return e.url === u;
                });
                e || (e = {
                    url: u,
                    promise: null
                }, c.impl.urlCache.push(e));
                null === e.promise && (c.impl.options.cacheBust && (u += (/\?/.test(u) ? "&" : "?") + (new Date).getTime()), e.promise = new Promise(function(t) {
                    const e = c.impl.options.httpTimeout, n = new XMLHttpRequest;
                    if (n.onreadystatechange = function() {
                        if (4 === n.readyState) {
                            if (300 <= n.status) i ? t(i) : r(`cannot fetch resource: ${u}, status: ` + n.status);
                            else {
                                const e = new FileReader;
                                e.onloadend = function() {
                                    t(e.result);
                                }, e.readAsDataURL(n.response);
                            }
                        }
                    }, n.ontimeout = function() {
                        i ? t(i) : r(`timeout of ${e}ms occured while fetching resource: ` + u);
                    }, n.responseType = "blob", n.timeout = e, 0 < c.impl.options.useCredentialsFilters.length && (c.impl.options.useCredentials = 0 < c.impl.options.useCredentialsFilters.filter((e)=>0 <= u.search(e)).length), c.impl.options.useCredentials && (n.withCredentials = !0), c.impl.options.corsImg && 0 === u.indexOf("http") && -1 === u.indexOf(window.location.origin)) {
                        var o = "POST" === (c.impl.options.corsImg.method || "GET").toUpperCase() ? "POST" : "GET";
                        n.open(o, (c.impl.options.corsImg.url || "").replace("#{cors}", u), !0);
                        let t = !1;
                        const s = c.impl.options.corsImg.headers || {}, l = (Object.keys(s).forEach(function(e) {
                            -1 !== s[e].indexOf("application/json") && (t = !0), n.setRequestHeader(e, s[e]);
                        }), function(e) {
                            try {
                                return JSON.parse(JSON.stringify(e));
                            } catch (e) {
                                r("corsImg.data is missing or invalid");
                            }
                        }(c.impl.options.corsImg.data || ""));
                        Object.keys(l).forEach(function(e) {
                            "string" == typeof l[e] && (l[e] = l[e].replace("#{cors}", u));
                        }), n.send(t ? JSON.stringify(l) : l);
                    } else n.open("GET", u, !0), n.send();
                    let i;
                    function r(e) {
                        console.error(e), t("");
                    }
                    c.impl.options.imagePlaceholder && (o = c.impl.options.imagePlaceholder.split(/,/)) && o[1] && (i = o[1]);
                }));
                return e.promise;
            },
            uid: function() {
                return "u" + ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4) + e++;
            },
            delay: function(n) {
                return function(t) {
                    return new Promise(function(e) {
                        setTimeout(function() {
                            e(t);
                        }, n);
                    });
                };
            },
            asArray: function(t) {
                var n = [], o = t.length;
                for(let e = 0; e < o; e++)n.push(t[e]);
                return n;
            },
            escapeXhtml: function(e) {
                return e.replace(/%/g, "%25").replace(/#/g, "%23").replace(/\n/g, "%0A");
            },
            makeImage: function(o) {
                return "data:," !== o ? new Promise(function(e, t) {
                    const n = new Image;
                    c.impl.options.useCredentials && (n.crossOrigin = "use-credentials"), n.onload = function() {
                        window && window.requestAnimationFrame ? window.requestAnimationFrame(function() {
                            e(n);
                        }) : e(n);
                    }, n.onerror = t, n.src = o;
                }) : Promise.resolve();
            },
            width: function(e) {
                var t = r(e, "width");
                if (!isNaN(t)) return t;
                var t = r(e, "border-left-width"), n = r(e, "border-right-width");
                return e.scrollWidth + t + n;
            },
            height: function(e) {
                var t = r(e, "height");
                if (!isNaN(t)) return t;
                var t = r(e, "border-top-width"), n = r(e, "border-bottom-width");
                return e.scrollHeight + t + n;
            },
            getWindow: t,
            isElement: i,
            isElementHostForOpenShadowRoot: function(e) {
                return i(e) && null !== e.shadowRoot;
            },
            isShadowRoot: n,
            isInShadowRoot: o,
            isHTMLElement: function(e) {
                return e instanceof t(e).HTMLElement;
            },
            isHTMLCanvasElement: function(e) {
                return e instanceof t(e).HTMLCanvasElement;
            },
            isHTMLInputElement: function(e) {
                return e instanceof t(e).HTMLInputElement;
            },
            isHTMLImageElement: function(e) {
                return e instanceof t(e).HTMLImageElement;
            },
            isHTMLLinkElement: function(e) {
                return e instanceof t(e).HTMLLinkElement;
            },
            isHTMLScriptElement: function(e) {
                return e instanceof t(e).HTMLScriptElement;
            },
            isHTMLStyleElement: function(e) {
                return e instanceof t(e).HTMLStyleElement;
            },
            isHTMLTextAreaElement: function(e) {
                return e instanceof t(e).HTMLTextAreaElement;
            },
            isShadowSlotElement: function(e) {
                return o(e) && e instanceof t(e).HTMLSlotElement;
            },
            isSVGElement: function(e) {
                return e instanceof t(e).SVGElement;
            },
            isSVGRectElement: function(e) {
                return e instanceof t(e).SVGRectElement;
            },
            isDimensionMissing: function(e) {
                return isNaN(e) || e <= 0;
            }
        };
        function t(e) {
            e = e ? e.ownerDocument : void 0;
            return (e ? e.defaultView : void 0) || s || window;
        }
        function n(e) {
            return e instanceof t(e).ShadowRoot;
        }
        function o(e) {
            return null !== e && Object.prototype.hasOwnProperty.call(e, "getRootNode") && n(e.getRootNode());
        }
        function i(e) {
            return e instanceof t(e).Element;
        }
        function r(t, n) {
            if (t.nodeType === a) {
                let e = m(t).getPropertyValue(n);
                if ("px" === e.slice(-2)) return e = e.slice(0, -2), parseFloat(e);
            }
            return NaN;
        }
    }(), i = function() {
        const o = /url\(['"]?([^'"]+?)['"]?\)/g;
        return {
            inlineAll: function(t, o, i) {
                if (!e(t)) return Promise.resolve(t);
                return Promise.resolve(t).then(n).then(function(e) {
                    let n = Promise.resolve(t);
                    return e.forEach(function(t) {
                        n = n.then(function(e) {
                            return r(e, t, o, i);
                        });
                    }), n;
                });
            },
            shouldProcess: e,
            impl: {
                readUrls: n,
                inline: r
            }
        };
        function e(e) {
            return -1 !== e.search(o);
        }
        function n(e) {
            for(var t, n = []; null !== (t = o.exec(e));)n.push(t[1]);
            return n.filter(function(e) {
                return !d.isDataUrl(e);
            });
        }
        function r(n, o, t, e) {
            return Promise.resolve(o).then(function(e) {
                return t ? d.resolveUrl(e, t) : e;
            }).then(e || d.getAndEncode).then(function(e) {
                var t;
                return n.replace((t = o, new RegExp(`(url\\(['"]?)(${d.escape(t)})(['"]?\\))`, "g")), `$1${e}$3`);
            });
        }
    }(), e = {
        resolveAll: function() {
            return t().then(function(e) {
                return Promise.all(e.map(function(e) {
                    return e.resolve();
                }));
            }).then(function(e) {
                return e.join("\n");
            });
        },
        impl: {
            readAll: t
        }
    };
    function t() {
        return Promise.resolve(d.asArray(document.styleSheets)).then(function(e) {
            const n = [];
            return e.forEach(function(t) {
                if (Object.prototype.hasOwnProperty.call(Object.getPrototypeOf(t), "cssRules")) try {
                    d.asArray(t.cssRules || []).forEach(n.push.bind(n));
                } catch (e) {
                    console.error("domtoimage: Error while reading CSS rules from " + t.href, e.toString());
                }
            }), n;
        }).then(function(e) {
            return e.filter(function(e) {
                return e.type === CSSRule.FONT_FACE_RULE;
            }).filter(function(e) {
                return i.shouldProcess(e.style.getPropertyValue("src"));
            });
        }).then(function(e) {
            return e.map(t);
        });
        function t(t) {
            return {
                resolve: function() {
                    var e = (t.parentStyleSheet || {}).href;
                    return i.inlineAll(t.cssText, e);
                },
                src: function() {
                    return t.style.getPropertyValue("src");
                }
            };
        }
    }
    const n = {
        inlineAll: function t(e) {
            if (!d.isElement(e)) return Promise.resolve(e);
            return n(e).then(function() {
                return d.isHTMLImageElement(e) ? o(e).inline() : Promise.all(d.asArray(e.childNodes).map(function(e) {
                    return t(e);
                }));
            });
            function n(o) {
                const e = [
                    "background",
                    "background-image"
                ], t = e.map(function(t) {
                    const e = o.style.getPropertyValue(t), n = o.style.getPropertyPriority(t);
                    return e ? i.inlineAll(e).then(function(e) {
                        o.style.setProperty(t, e, n);
                    }) : Promise.resolve();
                });
                return Promise.all(t).then(function() {
                    return o;
                });
            }
        },
        impl: {
            newImage: o
        }
    };
    function o(n) {
        return {
            inline: function(e) {
                if (d.isDataUrl(n.src)) return Promise.resolve();
                return Promise.resolve(n.src).then(e || d.getAndEncode).then(function(t) {
                    return new Promise(function(e) {
                        n.onload = e, n.onerror = e, n.src = t;
                    });
                });
            }
        };
    }
    const l = {
        copyDefaultStyles: !0,
        imagePlaceholder: void 0,
        cacheBust: !1,
        useCredentials: !1,
        useCredentialsFilters: [],
        httpTimeout: 3e4,
        styleCaching: "strict",
        corsImg: void 0,
        adjustClonedNode: void 0
    }, c = {
        toSvg: f,
        toPng: function(e, t) {
            return r(e, t).then(function(e) {
                return e.toDataURL();
            });
        },
        toJpeg: function(e, t) {
            return r(e, t).then(function(e) {
                return e.toDataURL("image/jpeg", (t ? t.quality : void 0) || 1);
            });
        },
        toBlob: function(e, t) {
            return r(e, t).then(d.canvasToBlob);
        },
        toPixelData: function(t, e) {
            return r(t, e).then(function(e) {
                return e.getContext("2d").getImageData(0, 0, d.width(t), d.height(t)).data;
            });
        },
        toCanvas: r,
        impl: {
            fontFaces: e,
            images: n,
            util: d,
            inliner: i,
            urlCache: [],
            options: {}
        }
    }, a = ($f22015d93e97b9e3$exports = c, ("undefined" != typeof Node ? Node.ELEMENT_NODE : void 0) || 1), m = (void 0 !== s ? s.getComputedStyle : void 0) || ("undefined" != typeof window ? window.getComputedStyle : void 0) || globalThis.getComputedStyle, u = (void 0 !== s ? s.atob : void 0) || ("undefined" != typeof window ? window.atob : void 0) || globalThis.atob;
    function f(e, i) {
        const t = c.impl.util.getWindow(e);
        var n = i = i || {};
        void 0 === n.copyDefaultStyles ? c.impl.options.copyDefaultStyles = l.copyDefaultStyles : c.impl.options.copyDefaultStyles = n.copyDefaultStyles, void 0 === n.imagePlaceholder ? c.impl.options.imagePlaceholder = l.imagePlaceholder : c.impl.options.imagePlaceholder = n.imagePlaceholder, void 0 === n.cacheBust ? c.impl.options.cacheBust = l.cacheBust : c.impl.options.cacheBust = n.cacheBust, void 0 === n.corsImg ? c.impl.options.corsImg = l.corsImg : c.impl.options.corsImg = n.corsImg, void 0 === n.useCredentials ? c.impl.options.useCredentials = l.useCredentials : c.impl.options.useCredentials = n.useCredentials, void 0 === n.useCredentialsFilters ? c.impl.options.useCredentialsFilters = l.useCredentialsFilters : c.impl.options.useCredentialsFilters = n.useCredentialsFilters, void 0 === n.httpTimeout ? c.impl.options.httpTimeout = l.httpTimeout : c.impl.options.httpTimeout = n.httpTimeout, void 0 === n.styleCaching ? c.impl.options.styleCaching = l.styleCaching : c.impl.options.styleCaching = n.styleCaching;
        let r = [];
        return Promise.resolve(e).then(function(e) {
            if (e.nodeType === a) return e;
            var t = e, n = e.parentNode, o = document.createElement("span");
            return n.replaceChild(o, t), o.append(e), r.push({
                parent: n,
                child: t,
                wrapper: o
            }), o;
        }).then(function(e) {
            return function l(t, a, i, u) {
                const e = a.filter;
                if (t === h || d.isHTMLScriptElement(t) || d.isHTMLStyleElement(t) || d.isHTMLLinkElement(t) || null !== i && e && !e(t)) return Promise.resolve();
                return Promise.resolve(t).then(n).then(o).then(function(e) {
                    return c(e, s(t));
                }).then(r).then(function(e) {
                    return f(e, t);
                });
                function n(e) {
                    return d.isHTMLCanvasElement(e) ? d.makeImage(e.toDataURL()) : e.cloneNode(!1);
                }
                function o(e) {
                    return a.adjustClonedNode && a.adjustClonedNode(t, e, !1), Promise.resolve(e);
                }
                function r(e) {
                    return a.adjustClonedNode && a.adjustClonedNode(t, e, !0), Promise.resolve(e);
                }
                function s(e) {
                    return d.isElementHostForOpenShadowRoot(e) ? e.shadowRoot : e;
                }
                function c(t, e) {
                    const n = r(e);
                    let o = Promise.resolve();
                    if (0 !== n.length) {
                        const s = m(i(e));
                        d.asArray(n).forEach(function(e) {
                            o = o.then(function() {
                                return l(e, a, s, u).then(function(e) {
                                    e && t.appendChild(e);
                                });
                            });
                        });
                    }
                    return o.then(function() {
                        return t;
                    });
                    function i(e) {
                        return d.isShadowRoot(e) ? e.host : e;
                    }
                    function r(e) {
                        return d.isShadowSlotElement(e) ? e.assignedNodes() : e.childNodes;
                    }
                }
                function f(u, c) {
                    return !d.isElement(u) || d.isShadowSlotElement(c) ? Promise.resolve(u) : Promise.resolve().then(e).then(t).then(n).then(o).then(function() {
                        return u;
                    });
                    function e() {
                        function o(e, t) {
                            t.font = e.font, t.fontFamily = e.fontFamily, t.fontFeatureSettings = e.fontFeatureSettings, t.fontKerning = e.fontKerning, t.fontSize = e.fontSize, t.fontStretch = e.fontStretch, t.fontStyle = e.fontStyle, t.fontVariant = e.fontVariant, t.fontVariantCaps = e.fontVariantCaps, t.fontVariantEastAsian = e.fontVariantEastAsian, t.fontVariantLigatures = e.fontVariantLigatures, t.fontVariantNumeric = e.fontVariantNumeric, t.fontVariationSettings = e.fontVariationSettings, t.fontWeight = e.fontWeight;
                        }
                        function e(e, t) {
                            const n = m(e);
                            n.cssText ? (t.style.cssText = n.cssText, o(n, t.style)) : (y(a, e, n, i, t), null === i && ([
                                "inset-block",
                                "inset-block-start",
                                "inset-block-end"
                            ].forEach((e)=>t.style.removeProperty(e)), [
                                "left",
                                "right",
                                "top",
                                "bottom"
                            ].forEach((e)=>{
                                t.style.getPropertyValue(e) && t.style.setProperty(e, "0px");
                            })));
                        }
                        e(c, u);
                    }
                    function t() {
                        const l = d.uid();
                        function t(i) {
                            const r = m(c, i), s = r.getPropertyValue("content");
                            if ("" !== s && "none" !== s) {
                                const t = u.getAttribute("class") || "", n = (u.setAttribute("class", t + " " + l), document.createElement("style"));
                                function e() {
                                    const e = `.${l}:` + i, t = (r.cssText ? n : o)();
                                    return document.createTextNode(e + `{${t}}`);
                                    function n() {
                                        return `${r.cssText} content: ${s};`;
                                    }
                                    function o() {
                                        const e = d.asArray(r).map(t).join("; ");
                                        return e + ";";
                                        function t(e) {
                                            const t = r.getPropertyValue(e), n = r.getPropertyPriority(e) ? " !important" : "";
                                            return e + ": " + t + n;
                                        }
                                    }
                                }
                                n.appendChild(e()), u.appendChild(n);
                            }
                        }
                        [
                            ":before",
                            ":after"
                        ].forEach(function(e) {
                            t(e);
                        });
                    }
                    function n() {
                        d.isHTMLTextAreaElement(c) && (u.innerHTML = c.value), d.isHTMLInputElement(c) && u.setAttribute("value", c.value);
                    }
                    function o() {
                        d.isSVGElement(u) && (u.setAttribute("xmlns", "http://www.w3.org/2000/svg"), d.isSVGRectElement(u)) && [
                            "width",
                            "height"
                        ].forEach(function(e) {
                            const t = u.getAttribute(e);
                            t && u.style.setProperty(e, t);
                        });
                    }
                }
            }(e, i, null, t);
        }).then(p).then(g).then(function(t) {
            i.bgcolor && (t.style.backgroundColor = i.bgcolor);
            i.width && (t.style.width = i.width + "px");
            i.height && (t.style.height = i.height + "px");
            i.style && Object.keys(i.style).forEach(function(e) {
                t.style[e] = i.style[e];
            });
            let e = null;
            "function" == typeof i.onclone && (e = i.onclone(t));
            return Promise.resolve(e).then(function() {
                return t;
            });
        }).then(function(e) {
            let n = i.width || d.width(e), o = i.height || d.height(e);
            return Promise.resolve(e).then(function(e) {
                return e.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), (new XMLSerializer).serializeToString(e);
            }).then(d.escapeXhtml).then(function(e) {
                var t = (d.isDimensionMissing(n) ? ' width="100%"' : ` width="${n}"`) + (d.isDimensionMissing(o) ? ' height="100%"' : ` height="${o}"`);
                return `<svg xmlns="http://www.w3.org/2000/svg"${(d.isDimensionMissing(n) ? "" : ` width="${n}"`) + (d.isDimensionMissing(o) ? "" : ` height="${o}"`)}><foreignObject${t}>${e}</foreignObject></svg>`;
            }).then(function(e) {
                return "data:image/svg+xml;charset=utf-8," + e;
            });
        }).then(function(e) {
            for(; 0 < r.length;){
                var t = r.pop();
                t.parent.replaceChild(t.child, t.wrapper);
            }
            return e;
        }).then(function(e) {
            return c.impl.urlCache = [], function() {
                h && (document.body.removeChild(h), h = null);
                w && clearTimeout(w);
                w = setTimeout(()=>{
                    w = null, v = {};
                }, 2e4);
            }(), e;
        });
    }
    function r(i, r) {
        return f(i, r = r || {}).then(d.makeImage).then(function(e) {
            var t = "number" != typeof r.scale ? 1 : r.scale, n = function(e, t) {
                let n = r.width || d.width(e), o = r.height || d.height(e);
                d.isDimensionMissing(n) && (n = d.isDimensionMissing(o) ? 300 : 2 * o);
                d.isDimensionMissing(o) && (o = n / 2);
                e = document.createElement("canvas");
                e.width = n * t, e.height = o * t, r.bgcolor && ((t = e.getContext("2d")).fillStyle = r.bgcolor, t.fillRect(0, 0, e.width, e.height));
                return e;
            }(i, t), o = n.getContext("2d");
            return o.msImageSmoothingEnabled = !1, o.imageSmoothingEnabled = !1, e && (o.scale(t, t), o.drawImage(e, 0, 0)), n;
        });
    }
    let h = null;
    function p(n) {
        return e.resolveAll().then(function(e) {
            var t;
            return "" !== e && (t = document.createElement("style"), n.appendChild(t), t.appendChild(document.createTextNode(e))), n;
        });
    }
    function g(e) {
        return n.inlineAll(e).then(function() {
            return e;
        });
    }
    function y(e, t, r, s, n) {
        const l = c.impl.options.copyDefaultStyles ? function(t, e) {
            var e = function(e) {
                var t = [];
                do if (e.nodeType === a) {
                    var n = e.tagName;
                    if (t.push(n), E.includes(n)) break;
                }
                while (e = e.parentNode, e);
                return t;
            }(e), n = function(e) {
                return ("relaxed" !== t.styleCaching ? e : e.filter((e, t, n)=>0 === t || t === n.length - 1)).join(">");
            }(e);
            if (v[n]) return v[n];
            var o = function() {
                if (h) return h.contentWindow;
                var e = document.characterSet || "UTF-8", t = document.doctype, t = t ? (`<!DOCTYPE ${n(t.name)} ${n(t.publicId)} ` + n(t.systemId)).trim() + ">" : "";
                return (h = document.createElement("iframe")).id = "domtoimage-sandbox-" + d.uid(), h.style.visibility = "hidden", h.style.position = "fixed", document.body.appendChild(h), function(e, t, n, o) {
                    try {
                        return e.contentWindow.document.write(t + `<html><head><meta charset='${n}'><title>${o}</title></head><body></body></html>`), e.contentWindow;
                    } catch (e) {}
                    var i = document.createElement("meta");
                    i.setAttribute("charset", n);
                    try {
                        var r = document.implementation.createHTMLDocument(o), s = (r.head.appendChild(i), t + r.documentElement.outerHTML);
                        return e.setAttribute("srcdoc", s), e.contentWindow;
                    } catch (e) {}
                    return e.contentDocument.head.appendChild(i), e.contentDocument.title = o, e.contentWindow;
                }(h, t, e, "domtoimage-sandbox");
                function n(e) {
                    var t;
                    return e ? ((t = document.createElement("div")).innerText = e, t.innerHTML) : "";
                }
            }(), e = function(e, t) {
                let n = e.body;
                do {
                    var o = t.pop(), o = e.createElement(o);
                    n.appendChild(o), n = o;
                }while (0 < t.length);
                return n.textContent = "\u200B", n;
            }(o.document, e), o = function(e, t) {
                const n = {}, o = e.getComputedStyle(t);
                return d.asArray(o).forEach(function(e) {
                    n[e] = "width" === e || "height" === e ? "auto" : o.getPropertyValue(e);
                }), n;
            }(o, e);
            return function(e) {
                do {
                    var t = e.parentElement;
                    null !== t && t.removeChild(e), e = t;
                }while (e && "BODY" !== e.tagName);
            }(e), v[n] = o;
        }(e, t) : {}, u = n.style;
        d.asArray(r).forEach(function(e) {
            var t, n = r.getPropertyValue(e), o = l[e], i = s ? s.getPropertyValue(e) : void 0;
            (n !== o || s && n !== i) && (o = r.getPropertyPriority(e), i = u, n, o, t = 0 <= [
                "background-clip"
            ].indexOf(e), o ? (i.setProperty(e, n, o), t && i.setProperty("-webkit-" + e, n, o)) : (i.setProperty(e, n), t && i.setProperty("-webkit-" + e, n)));
        });
    }
    let w = null, v = {};
    const E = [
        "ADDRESS",
        "ARTICLE",
        "ASIDE",
        "BLOCKQUOTE",
        "DETAILS",
        "DIALOG",
        "DD",
        "DIV",
        "DL",
        "DT",
        "FIELDSET",
        "FIGCAPTION",
        "FIGURE",
        "FOOTER",
        "FORM",
        "H1",
        "H2",
        "H3",
        "H4",
        "H5",
        "H6",
        "HEADER",
        "HGROUP",
        "HR",
        "LI",
        "MAIN",
        "NAV",
        "OL",
        "P",
        "PRE",
        "SECTION",
        "SVG",
        "TABLE",
        "UL",
        "math",
        "svg",
        "BODY",
        "HEAD",
        "HTML"
    ];
}($f22015d93e97b9e3$exports);


window.domtoimage = (0, (/*@__PURE__*/$parcel$interopDefault($f22015d93e97b9e3$exports)));
function $03106ecd9555496d$export$44019a90d4607192({ onMapReady: onMapReady, onMapPositionUpdated: onMapPositionUpdated }) {
    const map = (0, $9ce1a4f96ddeca9f$export$86f8f9f08863e403)();
    const updateMapPosition = (0, $ltGt3.useCallback)(()=>{
        const { lat: lat, lng: lng } = map.getCenter();
        onMapPositionUpdated({
            latitude: lat,
            longtitude: lng,
            zoomLevel: map.getZoom(),
            mapMetersPerPixel: $03106ecd9555496d$export$c2d063f4f44f1def(map)
        });
    }, [
        map,
        onMapPositionUpdated
    ]);
    (0, $9ce1a4f96ddeca9f$export$1c51e2c234152172)({
        dragend: updateMapPosition,
        zoomend: updateMapPosition
    });
    (0, $ltGt3.useEffect)(()=>{
        onMapReady(map);
    }, [
        map
    ]);
    return null;
}
function $03106ecd9555496d$export$50fac37f0fdf8ea({ mapPosition: mapPosition, onMapPositionUpdated: onMapPositionUpdated, onMapImageExtractorReady: onMapImageExtractorReady, onMetersPerPixelExtractorReady: onMetersPerPixelExtractorReady }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [map, setMap] = (0, $ltGt3.useState)(null);
    const { latitude: latitude, longtitude: longtitude, zoomLevel: zoomLevel } = mapPosition;
    (0, $ltGt3.useEffect)(()=>{
        if (!mapPosition || !map) return;
        map.setView([
            latitude,
            longtitude
        ], zoomLevel || map.getZoom());
    }, [
        latitude,
        longtitude,
        zoomLevel
    ]);
    // TODO: move up
    // if (!mapPosition) {
    //   return <div>{intl.formatMessage({id: 'noInformationAboutProjectLocation'})}</div>
    // }
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f089108b59bac9df$export$23f3dfd47374502b), {
        style: {
            height: '500px'
        },
        center: [
            latitude,
            longtitude
        ],
        zoom: mapPosition.zoomLevel,
        scrollWheelZoom: false,
        attributionControl: false,
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $78beab327f93d7c6$export$f52ee31d61d0b27b), {
                attribution: '\xa9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($03106ecd9555496d$export$44019a90d4607192, {
                onMapReady: (m)=>{
                    setMap(m);
                    if (typeof onMapImageExtractorReady === 'function') onMapImageExtractorReady(async ()=>{
                        const container = m.getContainer();
                        const { clientWidth: width, clientHeight: height } = container;
                        const pane = m.getPane('mapPane');
                        const paneCloned = pane.cloneNode(true);
                        paneCloned.style.opacity = '0';
                        document.body.appendChild(paneCloned);
                        const imageDataUrl = await (0, (/*@__PURE__*/$parcel$interopDefault($f22015d93e97b9e3$exports))).toJpeg(paneCloned, {
                            width: width,
                            height: height,
                            quality: 0.95,
                            style: {
                                opacity: '1'
                            }
                        });
                        document.body.removeChild(paneCloned);
                        return {
                            srcUrl: imageDataUrl
                        };
                    });
                    if (typeof onMetersPerPixelExtractorReady === 'function') onMetersPerPixelExtractorReady(()=>$03106ecd9555496d$export$c2d063f4f44f1def(m));
                },
                onMapPositionUpdated: onMapPositionUpdated
            })
        ]
    });
}
function $03106ecd9555496d$export$c2d063f4f44f1def(map) {
    const centerLatLng = map.getCenter() // get map center
    ;
    const pointC = map.latLngToContainerPoint(centerLatLng) // convert to containerpoint (pixels)
    ;
    const pointX = [
        pointC.x + 1,
        pointC.y
    ]// add one pixel to x
    ;
    const pointY = [
        pointC.x,
        pointC.y + 1
    ]// add one pixel to y
    ;
    // convert containerpoints to latlng's
    const latLngC = map.containerPointToLatLng(pointC);
    const latLngX = map.containerPointToLatLng(pointX);
    const latLngY = map.containerPointToLatLng(pointY);
    const distanceX = latLngC.distanceTo(latLngX) // calculate distance between c and x (latitude)
    ;
    const distanceY = latLngC.distanceTo(latLngY) // calculate distance between c and y (longitude)
    ;
    return (distanceX + distanceY) / 2;
}


function $f84fc681d1e48319$export$203858d4b9cfcc1a(address) {
    return {
        latitude: address.latitude,
        longtitude: address.longtitude,
        zoomLevel: 18
    };
}
async function $f84fc681d1e48319$export$93902291fcaf1a64(intl, currentLocation, newLocation) {
    let result = {
        ...newLocation
    };
    if (!currentLocation?.map) return result;
    if (currentLocation.map) {
        const mapBehavior = await new Promise((resolve)=>{
            const { destroy: destroy } = (0, $f189c84ec54ae7cf$export$2e2bcd8739ae039).confirm({
                title: intl.formatMessage({
                    id: 'confirm'
                }),
                content: intl.formatMessage({
                    id: 'mapCoordinatesWillBeReset'
                }),
                onOk () {
                    resolve('overwrite');
                },
                onCancel () {
                    resolve('cancel');
                },
                footer: (_, { OkBtn: OkBtn, CancelBtn: CancelBtn })=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)(CancelBtn, {}),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                type: "primary",
                                onClick: ()=>{
                                    destroy();
                                    resolve('preserve');
                                },
                                children: intl.formatMessage({
                                    id: 'preserveMapCoordinates'
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)(OkBtn, {})
                        ]
                    })
            });
        });
        if (mapBehavior === 'cancel') // no update to location or map - new location is actually the old one
        newLocation = currentLocation;
        else if (mapBehavior === 'preserve') // location is updated, but map is used from the old one
        newLocation.map = currentLocation.map;
        else // both location and map are updated
        newLocation.map = $f84fc681d1e48319$export$203858d4b9cfcc1a(newLocation);
        return newLocation;
    }
}
const $f84fc681d1e48319$var$requiredSearchQueryLength = 5;
function $f84fc681d1e48319$export$e744156e6a8ee6da({ debounceTimeout: // currentLocation,
debounceTimeout = 500, onChange: onChosenLocationChange, chosenLocation: chosenLocation, onMapImageExtractorReady: onMapImageExtractorReady }) {
    const { token: { colorPrimary: colorPrimary, colorTextSecondary: colorTextSecondary } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const fetchRef = (0, $ltGt3.useRef)(0);
    const [isSelectorVisible, setSelectorVisible] = (0, $ltGt3.useState)(false);
    const [loading, setLoading] = (0, $ltGt3.useState)(false);
    const [options, setOptions] = (0, $ltGt3.useState)([]);
    const [searchText, setSearchText] = (0, $ltGt3.useState)('');
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [suggestionsListOpen, setSuggestionsListOpen] = (0, $ltGt3.useState)(false);
    const mapMetersPerPixelExtractorRef = (0, $ltGt3.useRef)(null);
    const loadOptions = async ()=>{
        fetchRef.current += 1;
        const fetchId = fetchRef.current;
        if (!searchText || searchText.length < $f84fc681d1e48319$var$requiredSearchQueryLength) {
            setLoading(false);
            setOptions([]);
            return;
        }
        setOptions([]);
        setLoading(true);
        await new Promise((resolve)=>setTimeout(resolve, 1000));
        const searchResult = /*[
      {
        addressName: 'test 1',
        latitude: 0,
        longtitude: 0,
      },
      {
        addressName: searchText,
        latitude: 0,
        longtitude: 0,
      },
    ]*/ await (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).searchLocation(searchText);
        if (fetchId != fetchRef.current) return;
        setLoading(false);
        setOptions(searchResult) //setOptions(searchResult.data?.data?.records || [])
        ;
        setSuggestionsListOpen(true);
    };
    const renderLocationSelectPopover = (content)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6425aad248c6262a$export$2e2bcd8739ae039), {
            destroyTooltipOnHide: true,
            content: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $85df14811ac73e37$export$2e2bcd8739ae039), {
                /*disabled={loading}*/ style: {
                    width: 400
                },
                // ref={(e) => requestAnimationFrame(() => e?.focus())}
                filterOption: false,
                open: suggestionsListOpen,
                autoFocus: true,
                onFocus: ()=>setSuggestionsListOpen(true),
                onChange: setSearchText,
                autoClearSearchValue: false,
                notFoundContent: loading ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f5e177132d6f3f0f$export$2e2bcd8739ae039), {
                    size: "small"
                }) : null,
                onSelect: async (_, option)=>{
                    let newLocation = {
                        addressName: option.label,
                        latitude: option.latitude,
                        longtitude: option.longtitude
                    };
                    const newLocationWithMap = await $f84fc681d1e48319$export$93902291fcaf1a64(intl, chosenLocation, newLocation);
                    if (typeof mapMetersPerPixelExtractorRef.current === 'function') newLocationWithMap.map.mapMetersPerPixel = mapMetersPerPixelExtractorRef.current();
                    onChosenLocationChange(newLocationWithMap);
                    setSuggestionsListOpen(false);
                    setSelectorVisible(false);
                },
                value: searchText,
                placeholder: intl.formatMessage({
                    id: 'searchForLocation'
                }),
                options: (options || []).map((option, index)=>({
                        value: String(index),
                        label: option.addressName,
                        latitude: option.latitude,
                        longtitude: option.longtitude
                    })),
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).Search, {
                    enterButton: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        disabled: searchText.length < $f84fc681d1e48319$var$requiredSearchQueryLength,
                        loading: loading,
                        type: "primary",
                        icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $8397f586b179aba6$export$2e2bcd8739ae039), {}),
                        onClick: loadOptions
                    }),
                    loading: loading,
                    onKeyDown: (e)=>{
                        if (e.key === 'Enter') loadOptions();
                    }
                })
            }),
            trigger: "click",
            open: isSelectorVisible,
            onOpenChange: setSelectorVisible,
            placement: "topLeft",
            children: content
        });
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        style: {
            color: colorPrimary
        },
        children: [
            chosenLocation && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        children: chosenLocation.addressName
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        style: {
                            color: colorTextSecondary
                        },
                        children: [
                            "(",
                            chosenLocation.latitude,
                            "; ",
                            chosenLocation.longtitude,
                            ")"
                        ]
                    })
                ]
            }),
            renderLocationSelectPopover(/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                children: chosenLocation // currentLocation
                 ? intl.formatMessage({
                    id: 'changeProjectLocation'
                }) : intl.formatMessage({
                    id: 'enterProjectLocation'
                })
            })),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                style: {
                    margin: '0 10px'
                },
                onClick: async ()=>{
                    const userLocation = await (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).getUserLocation();
                    const newLocationWithMap = await $f84fc681d1e48319$export$93902291fcaf1a64(intl, chosenLocation, userLocation);
                    if (typeof mapMetersPerPixelExtractorRef.current === 'function') newLocationWithMap.map.mapMetersPerPixel = mapMetersPerPixelExtractorRef.current();
                    onChosenLocationChange(newLocationWithMap);
                    revalidator.revalidate();
                },
                children: intl.formatMessage({
                    id: 'useMyCurrentLocation'
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                checked: Boolean(chosenLocation?.map),
                disabled: !chosenLocation,
                onChange: (e)=>{
                    const map = e.target.checked ? $f84fc681d1e48319$export$203858d4b9cfcc1a(chosenLocation) : null;
                    onChosenLocationChange({
                        ...chosenLocation,
                        map: map
                    });
                },
                children: intl.formatMessage({
                    id: 'useMapForProjectCreating'
                })
            }),
            chosenLocation && chosenLocation.map && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        children: intl.formatMessage({
                            id: 'placeTheMap'
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $03106ecd9555496d$export$50fac37f0fdf8ea), {
                        mapPosition: chosenLocation.map,
                        onMapPositionUpdated: (position)=>onChosenLocationChange({
                                ...chosenLocation,
                                map: position
                            }),
                        onMapImageExtractorReady: onMapImageExtractorReady,
                        onMetersPerPixelExtractorReady: (extractor)=>{
                            mapMetersPerPixelExtractorRef.current = extractor;
                            onChosenLocationChange({
                                ...chosenLocation,
                                map: {
                                    ...chosenLocation.map,
                                    mapMetersPerPixel: extractor()
                                }
                            });
                        }
                    })
                ]
            })
        ]
    });
}




var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $861aedfeaeb59ad2$var$InfoCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "outlined"
};
var $861aedfeaeb59ad2$export$2e2bcd8739ae039 = $861aedfeaeb59ad2$var$InfoCircleOutlined;



var $35775a005ce7c86e$var$InfoCircleOutlined = function InfoCircleOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $861aedfeaeb59ad2$export$2e2bcd8739ae039)
    }));
};
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTQ2NCAzMzZhNDggNDggMCAxMDk2IDAgNDggNDggMCAxMC05NiAwem03MiAxMTJoLTQ4Yy00LjQgMC04IDMuNi04IDh2MjcyYzAgNC40IDMuNiA4IDggOGg0OGM0LjQgMCA4LTMuNiA4LThWNDU2YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ var $35775a005ce7c86e$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($35775a005ce7c86e$var$InfoCircleOutlined);
var $35775a005ce7c86e$export$2e2bcd8739ae039 = $35775a005ce7c86e$var$RefIcon;


const $e8a81dc5c286a0b4$var$getLocalization = (local)=>{
    return local;
};
function $e8a81dc5c286a0b4$export$b0a6aac4fb7b7221({ project: project }) {
    const [form] = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useForm();
    const user = (0, $d433dc3c3e640619$export$3901076af3749fa9)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const imageExtractorRef = (0, $ltGt3.useRef)(null);
    const validateMessages = {
        required: intl.formatMessage({
            id: 'requiredField'
        })
    };
    (0, $ltGt3.useEffect)(()=>{
        form.setFieldsValue(project === null ? {} : {
            name: project?.name,
            description: project?.description,
            projectImage: project?.photo,
            //coordinates: project?.coordinates,
            location: project?.location
        });
    }, [
        project
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        style: {
            padding: '15px'
        },
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $b56d75f9dce54730$export$2e2bcd8739ae039), {
                form: form,
                labelCol: {
                    span: 16,
                    flex: '150px'
                },
                wrapperCol: {
                    span: 48,
                    flex: 1
                },
                layout: "horizontal",
                style: {
                    width: 800,
                    backgroundColor: 'white',
                    border: 'double 6px #fa8c16',
                    padding: '15px'
                },
                name: "wrap",
                labelAlign: "left",
                labelWrap: true,
                colon: false,
                validateMessages: validateMessages,
                onFinish: async (formState)=>{
                    let result;
                    const editedProject = {
                        name: formState.name,
                        description: formState.description,
                        ownerId: user.id,
                        elements: project ? project.elements : [],
                        photo: formState.projectImage ? formState.projectImage.slice(formState.projectImage.lastIndexOf('/')) : null,
                        //coordinates: formState.coordinates,
                        location: formState.location
                    };
                    let image = undefined;
                    if (imageExtractorRef.current && formState.location.map) image = await imageExtractorRef.current();
                    if (project) result = await (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).editProject({
                        ...project,
                        ...editedProject
                    }, image);
                    else result = await (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).createProject(editedProject, image);
                    if (result.success) {
                        submit(result.id ? {
                            id: String(result.id)
                        } : null, {
                            method: 'post'
                        });
                        // submit(null, {method: 'post', action: `/projects/${result.id}/edit/plot`})
                        revalidator.revalidate();
                    } else if (result.success === false) messageApi.open({
                        type: 'error',
                        content: result.error?.message
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        className: "editor-fields-name",
                        name: "name",
                        label: intl.formatMessage({
                            id: 'projectName'
                        }),
                        rules: [
                            {
                                required: true
                            }
                        ],
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        className: "editor-fields-name",
                        name: "description",
                        label: intl.formatMessage({
                            id: 'projectDescription'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).TextArea, {})
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        className: "editor-fields-name",
                        label: intl.formatMessage({
                            id: 'chooseProjectImage'
                        }),
                        name: "projectImage",
                        valuePropName: "selectedUrl",
                        trigger: "onUrlSelected",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a70d8a2055eb4992$export$75471c1fa692787), {
                            urls: [
                                (0, (/*@__PURE__*/$parcel$interopDefault($f0a4ffbb486b57b4$exports))),
                                (0, (/*@__PURE__*/$parcel$interopDefault($1baa16c7de040cca$exports))),
                                (0, (/*@__PURE__*/$parcel$interopDefault($7edbbacfe4b85238$exports))),
                                (0, (/*@__PURE__*/$parcel$interopDefault($4605f3ce2e6c5052$exports)))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        className: "editor-fields-location",
                        label: intl.formatMessage({
                            id: 'locationReference'
                        }),
                        name: "location",
                        valuePropName: "chosenLocation",
                        getValueFromEvent: $e8a81dc5c286a0b4$var$getLocalization,
                        tooltip: {
                            title: intl.formatMessage({
                                id: 'locationReferenceInfo'
                            }),
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $35775a005ce7c86e$export$2e2bcd8739ae039), {})
                        },
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f84fc681d1e48319$export$e744156e6a8ee6da), {
                            // currentLocation={project?.location}
                            onMapImageExtractorReady: (extractor)=>{
                                imageExtractorRef.current = extractor;
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            htmlType: "submit",
                            type: "primary",
                            children: intl.formatMessage({
                                id: 'save'
                            })
                        })
                    })
                ]
            })
        ]
    });
}



function $d345b195f03a6bb2$export$7d3b6c592d61741e() {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                            style: {
                                display: 'inline'
                            },
                            children: intl.formatMessage({
                                id: 'creatingOfNewProject'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                        style: {
                            height: 'auto'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e8a81dc5c286a0b4$export$b0a6aac4fb7b7221), {
                    project: null
                })
            })
        ]
    });
}





var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $9d9ee865dfc0d330$var$CameraOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                }
            }
        ]
    },
    "name": "camera",
    "theme": "outlined"
};
var $9d9ee865dfc0d330$export$2e2bcd8739ae039 = $9d9ee865dfc0d330$var$CameraOutlined;



var $a246c3fe19a7f5f4$var$CameraOutlined = function CameraOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $9d9ee865dfc0d330$export$2e2bcd8739ae039)
    }));
};
/**![camera](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2NCAyNDhINzI4bC0zMi40LTkwLjhhMzIuMDcgMzIuMDcgMCAwMC0zMC4yLTIxLjJIMzU4LjZjLTEzLjUgMC0yNS42IDguNS0zMC4xIDIxLjJMMjk2IDI0OEgxNjBjLTQ0LjIgMC04MCAzNS44LTgwIDgwdjQ1NmMwIDQ0LjIgMzUuOCA4MCA4MCA4MGg3MDRjNDQuMiAwIDgwLTM1LjggODAtODBWMzI4YzAtNDQuMi0zNS44LTgwLTgwLTgwem04IDUzNmMwIDQuNC0zLjYgOC04IDhIMTYwYy00LjQgMC04LTMuNi04LThWMzI4YzAtNC40IDMuNi04IDgtOGgxODYuN2wxNy4xLTQ3LjggMjIuOS02NC4yaDI1MC41bDIyLjkgNjQuMiAxNy4xIDQ3LjhIODY0YzQuNCAwIDggMy42IDggOHY0NTZ6TTUxMiAzODRjLTg4LjQgMC0xNjAgNzEuNi0xNjAgMTYwczcxLjYgMTYwIDE2MCAxNjAgMTYwLTcxLjYgMTYwLTE2MC03MS42LTE2MC0xNjAtMTYwem0wIDI1NmMtNTMgMC05Ni00My05Ni05NnM0My05NiA5Ni05NiA5NiA0MyA5NiA5Ni00MyA5Ni05NiA5NnoiIC8+PC9zdmc+) */ var $a246c3fe19a7f5f4$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($a246c3fe19a7f5f4$var$CameraOutlined);
var $a246c3fe19a7f5f4$export$2e2bcd8739ae039 = $a246c3fe19a7f5f4$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $77237cfc757f6333$var$SettingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z"
                }
            }
        ]
    },
    "name": "setting",
    "theme": "outlined"
};
var $77237cfc757f6333$export$2e2bcd8739ae039 = $77237cfc757f6333$var$SettingOutlined;



var $ebfc7c0b6e3488d8$var$SettingOutlined = function SettingOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $77237cfc757f6333$export$2e2bcd8739ae039)
    }));
};
/**![setting](data:image/svg+xml;base64,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) */ var $ebfc7c0b6e3488d8$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($ebfc7c0b6e3488d8$var$SettingOutlined);
var $ebfc7c0b6e3488d8$export$2e2bcd8739ae039 = $ebfc7c0b6e3488d8$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");

















const $05d55999f342abd5$var$genAlertTypeStyle = (bgColor, borderColor, iconColor, token, alertCls)=>({
        background: bgColor,
        border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${borderColor}`,
        [`${alertCls}-icon`]: {
            color: iconColor
        }
    });
const $05d55999f342abd5$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: duration, marginXS: marginXS, marginSM: marginSM, fontSize: fontSize, fontSizeLG: fontSizeLG, lineHeight: lineHeight, borderRadiusLG: borderRadius, motionEaseInOutCirc: motionEaseInOutCirc, withDescriptionIconSize: withDescriptionIconSize, colorText: colorText, colorTextHeading: colorTextHeading, withDescriptionPadding: withDescriptionPadding, defaultPadding: defaultPadding } = token;
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            padding: defaultPadding,
            wordWrap: 'break-word',
            borderRadius: borderRadius,
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            },
            [`${componentCls}-section`]: {
                flex: 1,
                minWidth: 0
            },
            [`${componentCls}-icon`]: {
                marginInlineEnd: marginXS,
                lineHeight: 0
            },
            '&-description': {
                display: 'none',
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            '&-title': {
                color: colorTextHeading
            },
            [`&${componentCls}-motion-leave`]: {
                overflow: 'hidden',
                opacity: 1,
                transition: `max-height ${duration} ${motionEaseInOutCirc}, opacity ${duration} ${motionEaseInOutCirc},
        padding-top ${duration} ${motionEaseInOutCirc}, padding-bottom ${duration} ${motionEaseInOutCirc},
        margin-bottom ${duration} ${motionEaseInOutCirc}`
            },
            [`&${componentCls}-motion-leave-active`]: {
                maxHeight: 0,
                marginBottom: '0 !important',
                paddingTop: 0,
                paddingBottom: 0,
                opacity: 0
            }
        },
        [`${componentCls}-with-description`]: {
            alignItems: 'flex-start',
            padding: withDescriptionPadding,
            [`${componentCls}-icon`]: {
                marginInlineEnd: marginSM,
                fontSize: withDescriptionIconSize,
                lineHeight: 0
            },
            [`${componentCls}-title`]: {
                display: 'block',
                marginBottom: marginXS,
                color: colorTextHeading,
                fontSize: fontSizeLG
            },
            [`${componentCls}-description`]: {
                display: 'block',
                color: colorText
            }
        },
        [`${componentCls}-banner`]: {
            marginBottom: 0,
            border: '0 !important',
            borderRadius: 0
        }
    };
};
const $05d55999f342abd5$export$289eb6d482898146 = (token)=>{
    const { componentCls: componentCls, colorSuccess: colorSuccess, colorSuccessBorder: colorSuccessBorder, colorSuccessBg: colorSuccessBg, colorWarning: colorWarning, colorWarningBorder: colorWarningBorder, colorWarningBg: colorWarningBg, colorError: colorError, colorErrorBorder: colorErrorBorder, colorErrorBg: colorErrorBg, colorInfo: colorInfo, colorInfoBorder: colorInfoBorder, colorInfoBg: colorInfoBg } = token;
    return {
        [componentCls]: {
            '&-success': $05d55999f342abd5$var$genAlertTypeStyle(colorSuccessBg, colorSuccessBorder, colorSuccess, token, componentCls),
            '&-info': $05d55999f342abd5$var$genAlertTypeStyle(colorInfoBg, colorInfoBorder, colorInfo, token, componentCls),
            '&-warning': $05d55999f342abd5$var$genAlertTypeStyle(colorWarningBg, colorWarningBorder, colorWarning, token, componentCls),
            '&-error': {
                ...$05d55999f342abd5$var$genAlertTypeStyle(colorErrorBg, colorErrorBorder, colorError, token, componentCls),
                [`${componentCls}-description > pre`]: {
                    margin: 0,
                    padding: 0
                }
            }
        }
    };
};
const $05d55999f342abd5$export$5ecc051c674d512 = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, motionDurationMid: motionDurationMid, marginXS: marginXS, fontSizeIcon: fontSizeIcon, colorIcon: colorIcon, colorIconHover: colorIconHover } = token;
    return {
        [componentCls]: {
            '&-actions': {
                marginInlineStart: marginXS
            },
            [`${componentCls}-close-icon`]: {
                marginInlineStart: marginXS,
                padding: 0,
                overflow: 'hidden',
                fontSize: fontSizeIcon,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(fontSizeIcon),
                backgroundColor: 'transparent',
                border: 'none',
                outline: 'none',
                cursor: 'pointer',
                [`${iconCls}-close`]: {
                    color: colorIcon,
                    transition: `color ${motionDurationMid}`,
                    '&:hover': {
                        color: colorIconHover
                    }
                }
            },
            '&-close-text': {
                color: colorIcon,
                transition: `color ${motionDurationMid}`,
                '&:hover': {
                    color: colorIconHover
                }
            }
        }
    };
};
const $05d55999f342abd5$export$9ca1be8807fe0675 = (token)=>{
    const paddingHorizontal = 12; // Fixed value here.
    return {
        withDescriptionIconSize: token.fontSizeHeading3,
        defaultPadding: `${token.paddingContentVerticalSM}px ${paddingHorizontal}px`,
        withDescriptionPadding: `${token.paddingMD}px ${token.paddingContentHorizontalLG}px`
    };
};
var $05d55999f342abd5$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Alert', (token)=>[
        $05d55999f342abd5$export$5ca74f7be820a85(token),
        $05d55999f342abd5$export$289eb6d482898146(token),
        $05d55999f342abd5$export$5ecc051c674d512(token)
    ], $05d55999f342abd5$export$9ca1be8807fe0675);


"use client";
const $cfe7431e954f992a$var$iconMapFilled = {
    success: (0, $0cb9ffcfb49f2ccf$export$2e2bcd8739ae039),
    info: (0, $bfd6614352ed1ca0$export$2e2bcd8739ae039),
    error: (0, $332936b0d9ac1f65$export$2e2bcd8739ae039),
    warning: (0, $951db5e2b3978281$export$2e2bcd8739ae039)
};
const $cfe7431e954f992a$var$IconNode = (props)=>{
    const { icon: icon, prefixCls: prefixCls, type: type, className: className, style: style } = props;
    const iconType = $cfe7431e954f992a$var$iconMapFilled[type] || null;
    if (icon) return (0, $66d38239e1a27993$export$2dfe578f95754f6a)(icon, /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-icon`
    }, icon), ()=>({
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(icon.props.className, className),
            style: style
        }));
    return /*#__PURE__*/ $ltGt3.createElement(iconType, {
        className: className,
        style: style
    });
};
const $cfe7431e954f992a$var$CloseIconNode = (props)=>{
    const { isClosable: isClosable, prefixCls: prefixCls, closeIcon: closeIcon, handleClose: handleClose, ariaProps: ariaProps } = props;
    const mergedCloseIcon = closeIcon === true || closeIcon === undefined ? /*#__PURE__*/ $ltGt3.createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), null) : closeIcon;
    return isClosable ? /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        onClick: handleClose,
        className: `${prefixCls}-close-icon`,
        tabIndex: 0,
        ...ariaProps
    }, mergedCloseIcon) : null;
};
const $cfe7431e954f992a$var$Alert = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { description: description, prefixCls: customizePrefixCls, message: message, title: title, banner: banner, className: className, rootClassName: rootClassName, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, afterClose: afterClose, showIcon: showIcon, closable: closable, closeText: closeText, closeIcon: closeIcon, action: action, id: id, styles: styles, classNames: classNames, ...otherProps } = props;
    const mergedTitle = title ?? message;
    const [closed, setClosed] = $ltGt3.useState(false);
    var deprecatedName, newName;
    const internalRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, ()=>({
            nativeElement: internalRef.current
        }));
    const { getPrefixCls: getPrefixCls, direction: direction, closable: contextClosable, closeIcon: contextCloseIcon, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('alert');
    const prefixCls = getPrefixCls('alert', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $05d55999f342abd5$export$2e2bcd8739ae039)(prefixCls);
    const { onClose: closableOnClose, afterClose: closableAfterClose } = closable && typeof closable === 'object' ? closable : {};
    const handleClose = (e)=>{
        setClosed(true);
        (closableOnClose ?? props.onClose)?.(e);
    };
    const type = $ltGt3.useMemo(()=>{
        if (props.type !== undefined) return props.type;
        // banner mode defaults to 'warning'
        return banner ? 'warning' : 'info';
    }, [
        props.type,
        banner
    ]);
    // closeable when closeText or closeIcon is assigned
    const isClosable = $ltGt3.useMemo(()=>{
        if (typeof closable === 'object' && closable.closeIcon) return true;
        if (closeText) return true;
        if (typeof closable === 'boolean') return closable;
        // should be true when closeIcon is 0 or ''
        if (closeIcon !== false && (0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(closeIcon)) return true;
        return !!contextClosable;
    }, [
        closeText,
        closeIcon,
        closable,
        contextClosable
    ]);
    // banner mode defaults to Icon
    const isShowIcon = banner && showIcon === undefined ? true : showIcon;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        prefixCls: prefixCls,
        type: type,
        showIcon: isShowIcon,
        closable: isClosable
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const alertCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${type}`, {
        [`${prefixCls}-with-description`]: !!description,
        [`${prefixCls}-no-icon`]: !isShowIcon,
        [`${prefixCls}-banner`]: !!banner,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, contextClassName, className, rootClassName, mergedClassNames.root, cssVarCls, hashId);
    const restProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(otherProps, {
        aria: true,
        data: true
    });
    const mergedCloseIcon = $ltGt3.useMemo(()=>{
        if (typeof closable === 'object' && closable.closeIcon) return closable.closeIcon;
        if (closeText) return closeText;
        if (closeIcon !== undefined) return closeIcon;
        if (typeof contextClosable === 'object' && contextClosable.closeIcon) return contextClosable.closeIcon;
        return contextCloseIcon;
    }, [
        closeIcon,
        closable,
        contextClosable,
        closeText,
        contextCloseIcon
    ]);
    const mergedAriaProps = $ltGt3.useMemo(()=>{
        const merged = closable ?? contextClosable;
        if (typeof merged === 'object') return (0, $297f85de79f8d325$export$2e2bcd8739ae039)(merged, {
            data: true,
            aria: true
        });
        return {};
    }, [
        closable,
        contextClosable
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), {
        visible: !closed,
        motionName: `${prefixCls}-motion`,
        motionAppear: false,
        motionEnter: false,
        onLeaveStart: (node)=>({
                maxHeight: node.offsetHeight
            }),
        onLeaveEnd: closableAfterClose ?? afterClose
    }, ({ className: motionClassName, style: motionStyle }, setRef)=>/*#__PURE__*/ $ltGt3.createElement("div", {
            id: id,
            ref: (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(internalRef, setRef),
            "data-show": !closed,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(alertCls, motionClassName),
            style: {
                ...mergedStyles.root,
                ...contextStyle,
                ...style,
                ...motionStyle
            },
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            role: "alert",
            ...restProps
        }, isShowIcon ? /*#__PURE__*/ $ltGt3.createElement($cfe7431e954f992a$var$IconNode, {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-icon`, mergedClassNames.icon),
            style: mergedStyles.icon,
            description: description,
            icon: props.icon,
            prefixCls: prefixCls,
            type: type
        }) : null, /*#__PURE__*/ $ltGt3.createElement("div", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-section`, mergedClassNames.section),
            style: mergedStyles.section
        }, mergedTitle ? /*#__PURE__*/ $ltGt3.createElement("div", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-title`, mergedClassNames.title),
            style: mergedStyles.title
        }, mergedTitle) : null, description ? /*#__PURE__*/ $ltGt3.createElement("div", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-description`, mergedClassNames.description),
            style: mergedStyles.description
        }, description) : null), action ? /*#__PURE__*/ $ltGt3.createElement("div", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, mergedClassNames.actions),
            style: mergedStyles.actions
        }, action) : null, /*#__PURE__*/ $ltGt3.createElement($cfe7431e954f992a$var$CloseIconNode, {
            isClosable: isClosable,
            prefixCls: prefixCls,
            closeIcon: mergedCloseIcon,
            handleClose: handleClose,
            ariaProps: mergedAriaProps
        })));
});
var $cfe7431e954f992a$export$2e2bcd8739ae039 = $cfe7431e954f992a$var$Alert;









var $ltGt3 = parcelRequire("ltGt3");

"use client";
function $1ae832b8b1bffb7f$var$_callSuper(t, o, e) {
    return o = (0, $842b6e0da6891434$export$2e2bcd8739ae039)(o), (0, $72c3cf5bc8600437$export$2e2bcd8739ae039)(t, (0, $d3a6f09ccec9fd7e$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $842b6e0da6891434$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
let $1ae832b8b1bffb7f$var$ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    function ErrorBoundary() {
        var _this;
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, ErrorBoundary);
        _this = $1ae832b8b1bffb7f$var$_callSuper(this, ErrorBoundary, arguments);
        _this.state = {
            error: undefined,
            info: {
                componentStack: ''
            }
        };
        return _this;
    }
    (0, $56605f2979837676$export$2e2bcd8739ae039)(ErrorBoundary, _React$Component);
    return (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, info) {
                this.setState({
                    error: error,
                    info: info
                });
            }
        },
        {
            key: "render",
            value: function render() {
                const { message: message, title: title, description: description, id: id, children: children } = this.props;
                const { error: error, info: info } = this.state;
                const mergedTitle = title ?? message;
                const componentStack = info?.componentStack || null;
                const errorMessage = typeof mergedTitle === 'undefined' ? (error || '').toString() : mergedTitle;
                const errorDescription = typeof description === 'undefined' ? componentStack : description;
                if (error) return /*#__PURE__*/ $ltGt3.createElement((0, $cfe7431e954f992a$export$2e2bcd8739ae039), {
                    id: id,
                    type: "error",
                    title: errorMessage,
                    description: /*#__PURE__*/ $ltGt3.createElement("pre", {
                        style: {
                            fontSize: '0.9em',
                            overflowX: 'auto'
                        }
                    }, errorDescription)
                });
                return children;
            }
        }
    ]);
}($ltGt3.Component);
var $1ae832b8b1bffb7f$export$2e2bcd8739ae039 = $1ae832b8b1bffb7f$var$ErrorBoundary;


"use client";
const $3336d90a99ceb065$var$Alert = (0, $cfe7431e954f992a$export$2e2bcd8739ae039);
$3336d90a99ceb065$var$Alert.ErrorBoundary = (0, $1ae832b8b1bffb7f$export$2e2bcd8739ae039);
var $3336d90a99ceb065$export$2e2bcd8739ae039 = $3336d90a99ceb065$var$Alert;


var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");
function $e4debbac3fe1126a$var$isConfigObj(closable) {
    return closable !== null && typeof closable === 'object';
}
/**
 * Convert `closable` to ClosableConfig.
 * When `preset` is true, will auto fill ClosableConfig with default value.
 */ function $e4debbac3fe1126a$var$getClosableConfig(closable, closeIcon, preset) {
    if (closable === false || closeIcon === false && (!$e4debbac3fe1126a$var$isConfigObj(closable) || !closable.closeIcon)) return null;
    const mergedCloseIcon = typeof closeIcon !== 'boolean' ? closeIcon : undefined;
    if ($e4debbac3fe1126a$var$isConfigObj(closable)) return {
        ...closable,
        closeIcon: closable.closeIcon ?? mergedCloseIcon
    };
    // When StepClosable no need auto fill, but RootClosable need this.
    return preset || closable || closeIcon ? {
        closeIcon: mergedCloseIcon
    } : 'empty';
}
function $e4debbac3fe1126a$export$aa101db403ccf5f3(stepClosable, stepCloseIcon, closable, closeIcon) {
    return $ltGt3.useMemo(()=>{
        const stepClosableConfig = $e4debbac3fe1126a$var$getClosableConfig(stepClosable, stepCloseIcon, false);
        const rootClosableConfig = $e4debbac3fe1126a$var$getClosableConfig(closable, closeIcon, true);
        if (stepClosableConfig !== 'empty') return stepClosableConfig;
        return rootClosableConfig;
    }, [
        closable,
        closeIcon,
        stepClosable,
        stepCloseIcon
    ]);
}





var $ltGt3 = parcelRequire("ltGt3");
function $2491dfab1344b39c$export$76f0e7f1de35b75e(element) {
    const viewWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewHeight = window.innerHeight || document.documentElement.clientHeight;
    const { top: top, right: right, bottom: bottom, left: left } = element.getBoundingClientRect();
    return top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight;
}
function $2491dfab1344b39c$export$a9fe23cfa43a7b55(targetElement, placement, stepPlacement) {
    return stepPlacement ?? placement ?? (targetElement === null ? 'center' : 'bottom');
}


function $1e25e67836f2f828$var$isValidNumber(val) {
    return typeof val === 'number' && !Number.isNaN(val);
}
function $1e25e67836f2f828$export$2e2bcd8739ae039(target, open, gap, scrollIntoViewOptions, inlineMode, placeholderRef) {
    // ========================= Target =========================
    // We trade `undefined` as not get target by function yet.
    // `null` as empty target.
    const [targetElement, setTargetElement] = (0, $ltGt3.useState)(undefined);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        const nextElement = typeof target === 'function' ? target() : target;
        setTargetElement(nextElement || null);
    });
    // ========================= Align ==========================
    const [posInfo, setPosInfo] = (0, $ltGt3.useState)(null);
    const updatePos = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(()=>{
        if (targetElement) {
            // Exist target element. We should scroll and get target position
            if (!inlineMode && !(0, $2491dfab1344b39c$export$76f0e7f1de35b75e)(targetElement) && open) targetElement.scrollIntoView(scrollIntoViewOptions);
            const { left: left, top: top, width: width, height: height } = targetElement.getBoundingClientRect();
            const nextPosInfo = {
                left: left,
                top: top,
                width: width,
                height: height,
                radius: 0
            };
            // If `inlineMode` we need cut off parent offset
            if (inlineMode) {
                const parentRect = placeholderRef.current?.parentElement?.getBoundingClientRect();
                if (parentRect) {
                    nextPosInfo.left -= parentRect.left;
                    nextPosInfo.top -= parentRect.top;
                }
            }
            setPosInfo((origin)=>{
                if (JSON.stringify(origin) !== JSON.stringify(nextPosInfo)) return nextPosInfo;
                return origin;
            });
        } else // Not exist target which means we just show in center
        setPosInfo(null);
    });
    const getGapOffset = (index)=>(Array.isArray(gap?.offset) ? gap?.offset[index] : gap?.offset) ?? 6;
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        updatePos();
        // update when window resize
        window.addEventListener('resize', updatePos);
        // update when `document.body.style.overflow` is set to visible
        // by default, it will be set to hidden
        window.addEventListener('scroll', updatePos);
        return ()=>{
            window.removeEventListener('resize', updatePos);
            window.removeEventListener('scroll', updatePos);
        };
    }, [
        targetElement,
        open,
        updatePos
    ]);
    // ======================== PosInfo =========================
    const mergedPosInfo = (0, $ltGt3.useMemo)(()=>{
        if (!posInfo) return posInfo;
        const gapOffsetX = getGapOffset(0);
        const gapOffsetY = getGapOffset(1);
        const gapRadius = $1e25e67836f2f828$var$isValidNumber(gap?.radius) ? gap?.radius : 2;
        return {
            left: posInfo.left - gapOffsetX,
            top: posInfo.top - gapOffsetY,
            width: posInfo.width + gapOffsetX * 2,
            height: posInfo.height + gapOffsetY * 2,
            radius: gapRadius
        };
    }, [
        posInfo,
        gap
    ]);
    return [
        mergedPosInfo,
        targetElement
    ];
}



var $ltGt3 = parcelRequire("ltGt3");



function $1f0b7afff92caa5f$var$_extends() {
    $1f0b7afff92caa5f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1f0b7afff92caa5f$var$_extends.apply(this, arguments);
}
const $1f0b7afff92caa5f$var$COVER_PROPS = {
    fill: 'transparent',
    pointerEvents: 'auto'
};
const $1f0b7afff92caa5f$var$Mask = (props)=>{
    const { prefixCls: prefixCls, rootClassName: rootClassName, pos: pos, showMask: showMask, style: style = {}, fill: fill = 'rgba(0,0,0,0.5)', open: open, animated: animated, zIndex: zIndex, disabledInteraction: disabledInteraction, styles: styles, classNames: tourClassNames, getPopupContainer: getPopupContainer } = props;
    const id = (0, $1fb03482b73301f3$export$2e2bcd8739ae039)();
    const maskId = `${prefixCls}-mask-${id}`;
    const mergedAnimated = typeof animated === 'object' ? animated?.placeholder : animated;
    const isSafari = typeof navigator !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const maskRectSize = isSafari ? {
        width: '100%',
        height: '100%'
    } : {
        width: '100vw',
        height: '100vh'
    };
    const inlineMode = getPopupContainer === false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $0561688d8f19e269$export$2e2bcd8739ae039), {
        open: open,
        autoLock: !inlineMode,
        getContainer: getPopupContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-mask`, rootClassName, tourClassNames?.mask),
        style: {
            position: inlineMode ? 'absolute' : 'fixed',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: zIndex,
            pointerEvents: pos && !disabledInteraction ? 'none' : 'auto',
            ...style,
            ...styles?.mask
        }
    }, showMask ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("svg", {
        style: {
            width: '100%',
            height: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("mask", {
        id: maskId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("rect", $1f0b7afff92caa5f$var$_extends({
        x: "0",
        y: "0"
    }, maskRectSize, {
        fill: "white"
    })), pos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("rect", {
        x: pos.left,
        y: pos.top,
        rx: pos.radius,
        width: pos.width,
        height: pos.height,
        fill: "black",
        className: mergedAnimated ? `${prefixCls}-placeholder-animated` : ''
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: fill,
        mask: `url(#${maskId})`
    }), pos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("rect", $1f0b7afff92caa5f$var$_extends({}, $1f0b7afff92caa5f$var$COVER_PROPS, {
        x: "0",
        y: "0",
        width: "100%",
        height: Math.max(pos.top, 0)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("rect", $1f0b7afff92caa5f$var$_extends({}, $1f0b7afff92caa5f$var$COVER_PROPS, {
        x: "0",
        y: "0",
        width: Math.max(pos.left, 0),
        height: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("rect", $1f0b7afff92caa5f$var$_extends({}, $1f0b7afff92caa5f$var$COVER_PROPS, {
        x: "0",
        y: pos.top + pos.height,
        width: "100%",
        height: `calc(100% - ${pos.top + pos.height}px)`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("rect", $1f0b7afff92caa5f$var$_extends({}, $1f0b7afff92caa5f$var$COVER_PROPS, {
        x: pos.left + pos.width,
        y: "0",
        width: `calc(100% - ${pos.left + pos.width}px)`,
        height: "100%"
    })))) : null));
};
var $1f0b7afff92caa5f$export$2e2bcd8739ae039 = $1f0b7afff92caa5f$var$Mask;


const $9f5e7509d983d3a7$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const $9f5e7509d983d3a7$var$targetOffset = [
    0,
    0
];
const $9f5e7509d983d3a7$var$basePlacements = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        offset: [
            -8,
            0
        ]
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        offset: [
            8,
            0
        ]
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        offset: [
            0,
            -8
        ]
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        offset: [
            0,
            8
        ]
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        offset: [
            0,
            -8
        ]
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        offset: [
            -8,
            0
        ]
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        offset: [
            0,
            -8
        ]
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        offset: [
            8,
            0
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        offset: [
            0,
            8
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        offset: [
            8,
            0
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        offset: [
            0,
            8
        ]
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        offset: [
            -8,
            0
        ]
    }
};
function $9f5e7509d983d3a7$export$96c026b6f86bc999(arrowPointAtCenter = false) {
    const placements = {};
    Object.keys($9f5e7509d983d3a7$var$basePlacements).forEach((key)=>{
        placements[key] = {
            ...$9f5e7509d983d3a7$var$basePlacements[key],
            autoArrow: arrowPointAtCenter,
            targetOffset: $9f5e7509d983d3a7$var$targetOffset
        };
    });
    return placements;
}
const $9f5e7509d983d3a7$export$803cd8101b6c182b = $9f5e7509d983d3a7$export$96c026b6f86bc999();



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");


function $19ff6c2a64f58d4e$var$_extends() {
    $19ff6c2a64f58d4e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $19ff6c2a64f58d4e$var$_extends.apply(this, arguments);
}
function $19ff6c2a64f58d4e$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, current: current, total: total, title: title, description: description, onClose: onClose, onPrev: onPrev, onNext: onNext, onFinish: onFinish, className: className, closable: closable, classNames: tourClassNames, styles: styles } = props;
    const ariaProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(closable || {}, true);
    const closeIcon = closable?.closeIcon ?? /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-close-x`
    }, "\xD7");
    const mergedClosable = !!closable;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-panel`, className)
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-section`, tourClassNames?.section),
        style: styles?.section
    }, mergedClosable && /*#__PURE__*/ $ltGt3.createElement("button", $19ff6c2a64f58d4e$var$_extends({
        type: "button",
        onClick: onClose,
        "aria-label": "Close"
    }, ariaProps, {
        className: `${prefixCls}-close`
    }), closeIcon), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-header`, tourClassNames?.header),
        style: styles?.header
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-title`, tourClassNames?.title),
        style: styles?.title
    }, title)), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-description`, tourClassNames?.description),
        style: styles?.description
    }, description), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-footer`, tourClassNames?.footer),
        style: styles?.footer
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-sliders`
    }, total > 1 ? [
        ...Array.from({
            length: total
        }).keys()
    ].map((item, index)=>{
        return /*#__PURE__*/ $ltGt3.createElement("span", {
            key: item,
            className: index === current ? 'active' : ''
        });
    }) : null), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-actions`, tourClassNames?.actions),
        style: styles?.actions
    }, current !== 0 ? /*#__PURE__*/ $ltGt3.createElement("button", {
        className: `${prefixCls}-prev-btn`,
        onClick: onPrev
    }, "Prev") : null, current === total - 1 ? /*#__PURE__*/ $ltGt3.createElement("button", {
        className: `${prefixCls}-finish-btn`,
        onClick: onFinish
    }, "Finish") : /*#__PURE__*/ $ltGt3.createElement("button", {
        className: `${prefixCls}-next-btn`,
        onClick: onNext
    }, "Next")))));
}


const $a7fa28695d370db6$var$TourStep = (props)=>{
    const { current: current, renderPanel: renderPanel } = props;
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, typeof renderPanel === 'function' ? renderPanel(props, current) : /*#__PURE__*/ $ltGt3.createElement((0, $19ff6c2a64f58d4e$export$2e2bcd8739ae039), props));
};
var $a7fa28695d370db6$export$2e2bcd8739ae039 = $a7fa28695d370db6$var$TourStep;





var $ltGt3 = parcelRequire("ltGt3");
const $49ae1a02fe8ad556$var$Placeholder = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { open: open, autoLock: autoLock, getContainer: getContainer, domRef: domRef, className: className, style: style, fallbackDOM: fallbackDOM } = props;
    $ltGt3.useImperativeHandle(ref, ()=>domRef.current || fallbackDOM());
    return /*#__PURE__*/ $ltGt3.createElement((0, $0561688d8f19e269$export$2e2bcd8739ae039), {
        open: open,
        autoLock: autoLock,
        getContainer: getContainer
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: domRef,
        className: className,
        style: style
    }));
});
var $49ae1a02fe8ad556$export$2e2bcd8739ae039 = $49ae1a02fe8ad556$var$Placeholder;


function $4e0870864dc86946$var$_extends() {
    $4e0870864dc86946$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4e0870864dc86946$var$_extends.apply(this, arguments);
}
const $4e0870864dc86946$var$CENTER_PLACEHOLDER = {
    left: '50%',
    top: '50%',
    width: 1,
    height: 1
};
const $4e0870864dc86946$var$defaultScrollIntoViewOptions = {
    block: 'center',
    inline: 'center'
};
const $4e0870864dc86946$var$Tour = (props)=>{
    const { prefixCls: prefixCls = 'rc-tour', steps: steps = [], defaultCurrent: defaultCurrent, current: current, onChange: onChange, onClose: onClose, onFinish: onFinish, open: open, defaultOpen: defaultOpen, mask: mask = true, arrow: arrow = true, rootClassName: rootClassName, placement: placement, renderPanel: renderPanel, gap: gap, animated: animated, scrollIntoViewOptions: scrollIntoViewOptions = $4e0870864dc86946$var$defaultScrollIntoViewOptions, zIndex: zIndex = 1001, closeIcon: closeIcon, closable: closable, builtinPlacements: builtinPlacements, disabledInteraction: disabledInteraction, styles: styles, classNames: tourClassNames, className: className, style: style, getPopupContainer: getPopupContainer, ...restProps } = props;
    const triggerRef = $ltGt3.useRef();
    const [mergedCurrent, setMergedCurrent] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultCurrent || 0, current);
    const [internalOpen, setMergedOpen] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultOpen, open);
    const mergedOpen = mergedCurrent < 0 || mergedCurrent >= steps.length ? false : internalOpen ?? true;
    // Record if already rended in the DOM to avoid `findDOMNode` issue
    const [hasOpened, setHasOpened] = $ltGt3.useState(mergedOpen);
    const openRef = $ltGt3.useRef(mergedOpen);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (mergedOpen) {
            if (!openRef.current) setMergedCurrent(0);
            setHasOpened(true);
        }
        openRef.current = mergedOpen;
    }, [
        mergedOpen
    ]);
    const { target: target, placement: stepPlacement, style: stepStyle, arrow: stepArrow, className: stepClassName, mask: stepMask, scrollIntoViewOptions: stepScrollIntoViewOptions = $4e0870864dc86946$var$defaultScrollIntoViewOptions, closeIcon: stepCloseIcon, closable: stepClosable } = steps[mergedCurrent] || {};
    const mergedClosable = (0, $e4debbac3fe1126a$export$aa101db403ccf5f3)(stepClosable, stepCloseIcon, closable, closeIcon);
    const mergedMask = mergedOpen && (stepMask ?? mask);
    const mergedScrollIntoViewOptions = stepScrollIntoViewOptions ?? scrollIntoViewOptions;
    // ====================== Align Target ======================
    const placeholderRef = $ltGt3.useRef(null);
    const inlineMode = getPopupContainer === false;
    const [posInfo, targetElement] = (0, $1e25e67836f2f828$export$2e2bcd8739ae039)(target, open, gap, mergedScrollIntoViewOptions, inlineMode, placeholderRef);
    const mergedPlacement = (0, $2491dfab1344b39c$export$a9fe23cfa43a7b55)(targetElement, placement, stepPlacement);
    // ========================= arrow =========================
    const mergedArrow = targetElement ? typeof stepArrow === 'undefined' ? arrow : stepArrow : false;
    const arrowPointAtCenter = typeof mergedArrow === 'object' ? mergedArrow.pointAtCenter : false;
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        triggerRef.current?.forceAlign();
    }, [
        arrowPointAtCenter,
        mergedCurrent
    ]);
    // ========================= Change =========================
    const onInternalChange = (nextCurrent)=>{
        setMergedCurrent(nextCurrent);
        onChange?.(nextCurrent);
    };
    const mergedBuiltinPlacements = (0, $ltGt3.useMemo)(()=>{
        if (builtinPlacements) return typeof builtinPlacements === 'function' ? builtinPlacements({
            arrowPointAtCenter: arrowPointAtCenter
        }) : builtinPlacements;
        return (0, $9f5e7509d983d3a7$export$96c026b6f86bc999)(arrowPointAtCenter);
    }, [
        builtinPlacements,
        arrowPointAtCenter
    ]);
    // ========================= Render =========================
    // Skip if not init yet
    if (targetElement === undefined || !hasOpened) return null;
    const handleClose = ()=>{
        setMergedOpen(false);
        onClose?.(mergedCurrent);
    };
    const getPopupElement = ()=>/*#__PURE__*/ $ltGt3.createElement((0, $a7fa28695d370db6$export$2e2bcd8739ae039), $4e0870864dc86946$var$_extends({
            styles: styles,
            classNames: tourClassNames,
            arrow: mergedArrow,
            key: "content",
            prefixCls: prefixCls,
            total: steps.length,
            renderPanel: renderPanel,
            onPrev: ()=>{
                onInternalChange(mergedCurrent - 1);
            },
            onNext: ()=>{
                onInternalChange(mergedCurrent + 1);
            },
            onClose: handleClose,
            current: mergedCurrent,
            onFinish: ()=>{
                handleClose();
                onFinish?.();
            }
        }, steps[mergedCurrent], {
            closable: mergedClosable
        }));
    const mergedShowMask = typeof mergedMask === 'boolean' ? mergedMask : !!mergedMask;
    const mergedMaskStyle = typeof mergedMask === 'boolean' ? undefined : mergedMask;
    // when targetElement is not exist, use body as triggerDOMNode
    const fallbackDOM = ()=>{
        return targetElement || document.body;
    };
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement((0, $1f0b7afff92caa5f$export$2e2bcd8739ae039), {
        getPopupContainer: getPopupContainer,
        styles: styles,
        classNames: tourClassNames,
        zIndex: zIndex,
        prefixCls: prefixCls,
        pos: posInfo,
        showMask: mergedShowMask,
        style: mergedMaskStyle?.style,
        fill: mergedMaskStyle?.color,
        open: mergedOpen,
        animated: animated,
        rootClassName: rootClassName,
        disabledInteraction: disabledInteraction
    }), /*#__PURE__*/ $ltGt3.createElement((0, $1b29c21fa1aa3a55$export$2e2bcd8739ae039), $4e0870864dc86946$var$_extends({}, restProps, {
        // `rc-portal` def bug not support `false` but does support and in used.
        getPopupContainer: getPopupContainer,
        builtinPlacements: mergedBuiltinPlacements,
        ref: triggerRef,
        popupStyle: stepStyle,
        popupPlacement: mergedPlacement,
        popupVisible: mergedOpen,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(rootClassName, stepClassName),
        prefixCls: prefixCls,
        popup: getPopupElement,
        forceRender: false,
        autoDestroy: true,
        zIndex: zIndex,
        arrow: !!mergedArrow
    }), /*#__PURE__*/ $ltGt3.createElement((0, $49ae1a02fe8ad556$export$2e2bcd8739ae039), {
        open: mergedOpen,
        autoLock: !inlineMode,
        getContainer: getPopupContainer,
        domRef: placeholderRef,
        fallbackDOM: fallbackDOM,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(className, rootClassName, `${prefixCls}-target-placeholder`),
        style: {
            ...posInfo || $4e0870864dc86946$var$CENTER_PLACEHOLDER,
            position: inlineMode ? 'absolute' : 'fixed',
            pointerEvents: 'none',
            ...style
        }
    })));
};
var $4e0870864dc86946$export$2e2bcd8739ae039 = $4e0870864dc86946$var$Tour;


var $138f9c62ba2545c8$export$2e2bcd8739ae039 = (0, $4e0870864dc86946$export$2e2bcd8739ae039);










var $ltGt3 = parcelRequire("ltGt3");







"use client";
// Due to the independent design of Panel, it will be too coupled to put in rc-tour,
// so a set of Panel logic is implemented separately in antd.
const $2d45f05365a9cf51$var$TourPanel = (props)=>{
    const { stepProps: stepProps, current: current, type: type, indicatorsRender: indicatorsRender, actionsRender: actionsRender } = props;
    const { prefixCls: prefixCls, total: total = 1, title: title, onClose: onClose, onPrev: onPrev, onNext: onNext, onFinish: onFinish, cover: cover, description: description, nextButtonProps: nextButtonProps, prevButtonProps: prevButtonProps, type: stepType, closable: closable, classNames: classNames = {}, styles: styles = {} } = stepProps;
    const mergedType = stepType ?? type;
    const ariaProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(closable ?? {}, true);
    const [contextLocaleGlobal] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('global', (0, $29f4f00e8825a41b$export$2e2bcd8739ae039).global);
    const [contextLocaleTour] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Tour', (0, $29f4f00e8825a41b$export$2e2bcd8739ae039).Tour);
    const mergedCloseIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("button", {
        type: "button",
        onClick: onClose,
        className: `${prefixCls}-close`,
        "aria-label": contextLocaleGlobal?.close,
        ...ariaProps
    }, closable?.closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    }));
    const isLastStep = current === total - 1;
    const prevBtnClick = ()=>{
        onPrev?.();
        prevButtonProps?.onClick?.();
    };
    const nextBtnClick = ()=>{
        if (isLastStep) onFinish?.();
        else onNext?.();
        nextButtonProps?.onClick?.();
    };
    const headerNode = (0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(title) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-header`, classNames.header),
        style: styles.header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-title`, classNames.title),
        style: styles.title
    }, title)) : null;
    const descriptionNode = (0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(description) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-description`, classNames.description),
        style: styles.description
    }, description) : null;
    const coverNode = (0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(cover) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-cover`, classNames.cover),
        style: styles.cover
    }, cover) : null;
    let mergedIndicatorNode;
    if (indicatorsRender) mergedIndicatorNode = indicatorsRender(current, total);
    else mergedIndicatorNode = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(Array.from({
        length: total
    }).keys()).map((stepItem, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            key: stepItem,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(index === current && `${prefixCls}-indicator-active`, `${prefixCls}-indicator`, classNames.indicator),
            style: styles.indicator
        }));
    const mainBtnType = mergedType === 'primary' ? 'default' : 'primary';
    const secondaryBtnProps = {
        type: 'default',
        ghost: mergedType === 'primary'
    };
    const defaultActionsNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Fragment, null, current !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
        size: "small",
        ...secondaryBtnProps,
        ...prevButtonProps,
        onClick: prevBtnClick,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-prev-btn`, prevButtonProps?.className)
    }, prevButtonProps?.children ?? contextLocaleTour?.Previous) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
        size: "small",
        type: mainBtnType,
        ...nextButtonProps,
        onClick: nextBtnClick,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-next-btn`, nextButtonProps?.className)
    }, nextButtonProps?.children ?? (isLastStep ? contextLocaleTour?.Finish : contextLocaleTour?.Next)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: `${prefixCls}-panel`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-section`, classNames.section),
        style: styles.section
    }, closable && mergedCloseIcon, coverNode, headerNode, descriptionNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, classNames.footer),
        style: styles.footer
    }, total > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-indicators`, classNames.indicators),
        style: styles.indicators
    }, mergedIndicatorNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, classNames.actions),
        style: styles.actions
    }, actionsRender ? actionsRender(defaultActionsNode, {
        current: current,
        total: total
    }) : defaultActionsNode))));
};
var $2d45f05365a9cf51$export$2e2bcd8739ae039 = $2d45f05365a9cf51$var$TourPanel;



var $ltGt3 = parcelRequire("ltGt3");













// =============================== Base ===============================
const $264e86323fd7343b$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, padding: padding, paddingXS: paddingXS, borderRadius: borderRadius, borderRadiusXS: borderRadiusXS, colorPrimary: colorPrimary, colorFill: colorFill, indicatorHeight: indicatorHeight, indicatorWidth: indicatorWidth, boxShadowTertiary: boxShadowTertiary, zIndexPopup: zIndexPopup, colorBgElevated: colorBgElevated, fontWeightStrong: fontWeightStrong, marginXS: marginXS, colorTextLightSolid: colorTextLightSolid, tourBorderRadius: tourBorderRadius, colorWhite: colorWhite, primaryNextBtnHoverBg: primaryNextBtnHoverBg, closeBtnSize: closeBtnSize, motionDurationSlow: motionDurationSlow, antCls: antCls, primaryPrevBtnBg: primaryPrevBtnBg } = token;
    return [
        {
            [componentCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                position: 'absolute',
                zIndex: zIndexPopup,
                maxWidth: 'fit-content',
                visibility: 'visible',
                width: 520,
                '--antd-arrow-background-color': colorBgElevated,
                '&-pure': {
                    maxWidth: '100%',
                    position: 'relative'
                },
                [`&${componentCls}-hidden`]: {
                    display: 'none'
                },
                // ============================= panel content ============================
                [`${componentCls}-panel`]: {
                    position: 'relative'
                },
                [`${componentCls}-section`]: {
                    textAlign: 'start',
                    textDecoration: 'none',
                    borderRadius: tourBorderRadius,
                    boxShadow: boxShadowTertiary,
                    position: 'relative',
                    backgroundColor: colorBgElevated,
                    border: 'none',
                    backgroundClip: 'padding-box',
                    [`${componentCls}-close`]: {
                        position: 'absolute',
                        top: padding,
                        insetInlineEnd: padding,
                        color: token.colorIcon,
                        background: 'none',
                        border: 'none',
                        width: closeBtnSize,
                        height: closeBtnSize,
                        borderRadius: token.borderRadiusSM,
                        transition: `background-color ${token.motionDurationMid}, color ${token.motionDurationMid}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        '&:hover': {
                            color: token.colorIconHover,
                            backgroundColor: token.colorBgTextHover
                        },
                        '&:active': {
                            backgroundColor: token.colorBgTextActive
                        },
                        ...(0, $945cb0d2b7017a11$export$a44db842bcb28231)(token)
                    },
                    [`${componentCls}-cover`]: {
                        textAlign: 'center',
                        padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(padding).add(closeBtnSize).add(paddingXS).equal())} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(padding)} 0`,
                        img: {
                            width: '100%'
                        }
                    },
                    [`${componentCls}-header`]: {
                        padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(padding)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(padding)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)}`,
                        width: `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(closeBtnSize)})`,
                        wordBreak: 'break-word',
                        [`${componentCls}-title`]: {
                            fontWeight: fontWeightStrong
                        }
                    },
                    [`${componentCls}-description`]: {
                        padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(padding)}`,
                        wordWrap: 'break-word'
                    },
                    [`${componentCls}-footer`]: {
                        padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(padding)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(padding)}`,
                        textAlign: 'end',
                        borderRadius: `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(borderRadiusXS)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(borderRadiusXS)}`,
                        display: 'flex',
                        [`${componentCls}-indicators`]: {
                            display: 'inline-block',
                            [`${componentCls}-indicator`]: {
                                width: indicatorWidth,
                                height: indicatorHeight,
                                display: 'inline-block',
                                borderRadius: '50%',
                                background: colorFill,
                                '&:not(:last-child)': {
                                    marginInlineEnd: indicatorHeight
                                },
                                '&-active': {
                                    background: colorPrimary
                                }
                            }
                        },
                        [`${componentCls}-actions`]: {
                            marginInlineStart: 'auto',
                            [`${antCls}-btn`]: {
                                marginInlineStart: marginXS
                            }
                        }
                    }
                },
                // =============================  primary type  ===========================
                // `$` for panel, `&$` for pure panel
                [`${componentCls}-primary, &${componentCls}-primary`]: {
                    '--antd-arrow-background-color': colorPrimary,
                    [`${componentCls}-section`]: {
                        color: colorTextLightSolid,
                        textAlign: 'start',
                        textDecoration: 'none',
                        backgroundColor: colorPrimary,
                        borderRadius: borderRadius,
                        boxShadow: boxShadowTertiary,
                        [`${componentCls}-close`]: {
                            color: colorTextLightSolid
                        },
                        [`${componentCls}-indicators`]: {
                            [`${componentCls}-indicator`]: {
                                background: primaryPrevBtnBg,
                                '&-active': {
                                    background: colorTextLightSolid
                                }
                            }
                        },
                        [`${componentCls}-prev-btn`]: {
                            color: colorTextLightSolid,
                            borderColor: primaryPrevBtnBg,
                            backgroundColor: colorPrimary,
                            '&:hover': {
                                backgroundColor: primaryPrevBtnBg,
                                borderColor: 'transparent'
                            }
                        },
                        [`${componentCls}-next-btn`]: {
                            color: colorPrimary,
                            borderColor: 'transparent',
                            background: colorWhite,
                            '&:hover': {
                                background: primaryNextBtnHoverBg
                            }
                        }
                    }
                }
            },
            // ============================= mask ===========================
            [`${componentCls}-mask`]: {
                [`${componentCls}-placeholder-animated`]: {
                    transition: `all ${motionDurationSlow}`
                }
            },
            // =========== Limit left and right placement radius ==============
            [[
                '&-placement-left',
                '&-placement-leftTop',
                '&-placement-leftBottom',
                '&-placement-right',
                '&-placement-rightTop',
                '&-placement-rightBottom'
            ].join(',')]: {
                [`${componentCls}-section`]: {
                    borderRadius: token.min(tourBorderRadius, (0, $f61b43f1533e9f98$export$de6e4ffc9ec3c089))
                }
            }
        },
        // ============================= Arrow ===========================
        (0, $f61b43f1533e9f98$export$2e2bcd8739ae039)(token, 'var(--antd-arrow-background-color)')
    ];
};
const $264e86323fd7343b$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 70,
        closeBtnSize: token.fontSize * token.lineHeight,
        primaryPrevBtnBg: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(token.colorTextLightSolid).setA(0.15).toRgbString(),
        primaryNextBtnHoverBg: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(token.colorBgTextHover).onBackground(token.colorWhite).toRgbString(),
        ...(0, $f61b43f1533e9f98$export$bddc192327bb9823)({
            contentRadius: token.borderRadiusLG,
            limitVerticalRadius: true
        }),
        ...(0, $bf6e216ed4fab7a5$export$87e38ee403661ccc)(token)
    });
var $264e86323fd7343b$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Tour', (token)=>{
    const { borderRadiusLG: borderRadiusLG } = token;
    const TourToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        indicatorWidth: 6,
        indicatorHeight: 6,
        tourBorderRadius: borderRadiusLG
    });
    return $264e86323fd7343b$var$genBaseStyle(TourToken);
}, $264e86323fd7343b$export$9ca1be8807fe0675);


"use client";
const $77ad263b9ab484b7$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, current: current = 0, total: total = 6, className: className, style: style, type: type, closable: closable, closeIcon: closeIcon, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('tour', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $264e86323fd7343b$export$2e2bcd8739ae039)(prefixCls);
    const [mergedClosable, mergedCloseIcon] = (0, $dd7ac7131208b252$export$aa101db403ccf5f3)({
        closable: closable,
        closeIcon: closeIcon
    }, null, {
        closable: true,
        closeIconRender: (icon)=>/*#__PURE__*/ $ltGt3.isValidElement(icon) ? (0, $66d38239e1a27993$export$e530037191fcd5d7)(icon, {
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(icon.props?.className, `${prefixCls}-close-icon`)
            }) : icon
    });
    return /*#__PURE__*/ $ltGt3.createElement((0, $1208369eb14302c3$export$c40925af82c95d5b), {
        prefixCls: prefixCls,
        hashId: hashId,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, `${prefixCls}-pure`, type && `${prefixCls}-${type}`, cssVarCls),
        style: style
    }, /*#__PURE__*/ $ltGt3.createElement((0, $2d45f05365a9cf51$export$2e2bcd8739ae039), {
        stepProps: {
            ...restProps,
            prefixCls: prefixCls,
            total: total,
            closable: mergedClosable ? {
                closeIcon: mergedCloseIcon
            } : undefined
        },
        current: current,
        type: type
    }));
};
var $77ad263b9ab484b7$export$2e2bcd8739ae039 = (0, $c64d2291d230fcde$export$29e2a8c3cdb34b03)($77ad263b9ab484b7$var$PurePanel);



"use client";
const $eabf9c7db89c7211$var$Tour = (props)=>{
    const { prefixCls: customizePrefixCls, type: type, rootClassName: rootClassName, indicatorsRender: indicatorsRender, actionsRender: actionsRender, steps: steps, closeIcon: closeIcon, classNames: classNames, styles: styles, className: className, style: style, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, closeIcon: contextCloseIcon, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('tour');
    const prefixCls = getPrefixCls('tour', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $264e86323fd7343b$export$2e2bcd8739ae039)(prefixCls);
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const mergedSteps = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>steps?.map((step)=>({
                ...step,
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(step.className, {
                    [`${prefixCls}-primary`]: (step.type ?? type) === 'primary'
                })
            })), [
        prefixCls,
        steps,
        type
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        steps: mergedSteps
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const builtinPlacements = (config)=>(0, $a4d52b87871d5972$export$2e2bcd8739ae039)({
            arrowPointAtCenter: config?.arrowPointAtCenter ?? true,
            autoAdjustOverflow: true,
            offset: token.marginXXS,
            arrowWidth: token.sizePopupArrow,
            borderRadius: token.borderRadius
        });
    const mergedRootClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, cssVarCls, rootClassName, contextClassName, mergedClassNames.root, className);
    const semanticStyles = {
        ...mergedStyles,
        mask: {
            ...mergedStyles.root,
            ...mergedStyles.mask,
            ...contextStyle,
            ...style
        }
    };
    const mergedRenderPanel = (stepProps, stepCurrent)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $2d45f05365a9cf51$export$2e2bcd8739ae039), {
            styles: semanticStyles,
            classNames: mergedClassNames,
            type: type,
            stepProps: stepProps,
            current: stepCurrent,
            indicatorsRender: indicatorsRender,
            actionsRender: actionsRender
        });
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $ad5b6b465efa8f67$export$3e7906d4075187a4)('Tour', restProps.zIndex);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $cba857b93cac085e$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $138f9c62ba2545c8$export$2e2bcd8739ae039), {
        ...restProps,
        styles: semanticStyles,
        classNames: mergedClassNames,
        closeIcon: closeIcon ?? contextCloseIcon,
        zIndex: zIndex,
        rootClassName: mergedRootClassName,
        prefixCls: prefixCls,
        animated: true,
        renderPanel: mergedRenderPanel,
        builtinPlacements: builtinPlacements,
        steps: mergedSteps
    }));
};
$eabf9c7db89c7211$var$Tour._InternalPanelDoNotUseOrYouWillBeFired = (0, $77ad263b9ab484b7$export$2e2bcd8739ae039);
var $eabf9c7db89c7211$export$2e2bcd8739ae039 = $eabf9c7db89c7211$var$Tour;



var $ltGt3 = parcelRequire("ltGt3");



var $Ohofd = parcelRequire("Ohofd");
var $89358fe654dbfc1b$exports = {};
!function(e, t) {
    $89358fe654dbfc1b$exports = t();
}($89358fe654dbfc1b$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.weekday = function(e) {
            var t = this.$locale().weekStart || 0, i = this.$W, n = (i < t ? i + 7 : i) - t;
            return this.$utils().u(e) ? n : this.subtract(n, "day").add(e, "day");
        };
    };
});


var $a1e897d5470d5c7c$exports = {};
!function(n, e) {
    $a1e897d5470d5c7c$exports = e();
}($a1e897d5470d5c7c$exports, function() {
    "use strict";
    return function(n, e, t) {
        var r = e.prototype, o = function(n) {
            return n && (n.indexOf ? n : n.s);
        }, u = function(n, e, t, r, u) {
            var i = n.name ? n : n.$locale(), a = o(i[e]), s = o(i[t]), f = a || s.map(function(n) {
                return n.slice(0, r);
            });
            if (!u) return f;
            var d = i.weekStart;
            return f.map(function(n, e) {
                return f[(e + (d || 0)) % 7];
            });
        }, i = function() {
            return t.Ls[t.locale()];
        }, a = function(n, e) {
            return n.formats[e] || function(n) {
                return n.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(n, e, t) {
                    return e || t.slice(1);
                });
            }(n.formats[e.toUpperCase()]);
        }, s = function() {
            var n = this;
            return {
                months: function(e) {
                    return e ? e.format("MMMM") : u(n, "months");
                },
                monthsShort: function(e) {
                    return e ? e.format("MMM") : u(n, "monthsShort", "months", 3);
                },
                firstDayOfWeek: function() {
                    return n.$locale().weekStart || 0;
                },
                weekdays: function(e) {
                    return e ? e.format("dddd") : u(n, "weekdays");
                },
                weekdaysMin: function(e) {
                    return e ? e.format("dd") : u(n, "weekdaysMin", "weekdays", 2);
                },
                weekdaysShort: function(e) {
                    return e ? e.format("ddd") : u(n, "weekdaysShort", "weekdays", 3);
                },
                longDateFormat: function(e) {
                    return a(n.$locale(), e);
                },
                meridiem: this.$locale().meridiem,
                ordinal: this.$locale().ordinal
            };
        };
        r.localeData = function() {
            return s.bind(this)();
        }, t.localeData = function() {
            var n = i();
            return {
                firstDayOfWeek: function() {
                    return n.weekStart || 0;
                },
                weekdays: function() {
                    return t.weekdays();
                },
                weekdaysShort: function() {
                    return t.weekdaysShort();
                },
                weekdaysMin: function() {
                    return t.weekdaysMin();
                },
                months: function() {
                    return t.months();
                },
                monthsShort: function() {
                    return t.monthsShort();
                },
                longDateFormat: function(e) {
                    return a(n, e);
                },
                meridiem: n.meridiem,
                ordinal: n.ordinal
            };
        }, t.months = function() {
            return u(i(), "months");
        }, t.monthsShort = function() {
            return u(i(), "monthsShort", "months", 3);
        }, t.weekdays = function(n) {
            return u(i(), "weekdays", null, null, n);
        }, t.weekdaysShort = function(n) {
            return u(i(), "weekdaysShort", "weekdays", 3, n);
        }, t.weekdaysMin = function(n) {
            return u(i(), "weekdaysMin", "weekdays", 2, n);
        };
    };
});


var $6bff2c1731d8cac6$exports = {};
!function(e, t) {
    $6bff2c1731d8cac6$exports = t();
}($6bff2c1731d8cac6$exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});


var $b1ffce7315fe944f$exports = {};
!function(e, t) {
    $b1ffce7315fe944f$exports = t();
}($b1ffce7315fe944f$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.weekYear = function() {
            var e = this.month(), t = this.week(), n = this.year();
            return 1 === t && 11 === e ? n + 1 : 0 === e && t >= 52 ? n - 1 : n;
        };
    };
});


var $26fa3fb32f2c7760$exports = {};
!function(e, t) {
    $26fa3fb32f2c7760$exports = t();
}($26fa3fb32f2c7760$exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});


var $b193533705215597$exports = {};
!function(e, t) {
    $b193533705215597$exports = t();
}($b193533705215597$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).extend((0, (/*@__PURE__*/$parcel$interopDefault($b193533705215597$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).extend((0, (/*@__PURE__*/$parcel$interopDefault($26fa3fb32f2c7760$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).extend((0, (/*@__PURE__*/$parcel$interopDefault($89358fe654dbfc1b$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).extend((0, (/*@__PURE__*/$parcel$interopDefault($a1e897d5470d5c7c$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).extend((0, (/*@__PURE__*/$parcel$interopDefault($6bff2c1731d8cac6$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).extend((0, (/*@__PURE__*/$parcel$interopDefault($b1ffce7315fe944f$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).extend(function(o, c) {
    // todo support Wo (ISO week)
    var proto = c.prototype;
    var oldFormat = proto.format;
    proto.format = function f(formatStr) {
        var str = (formatStr || '').replace('Wo', 'wo');
        return oldFormat.bind(this)(str);
    };
});
var $a9d33dc0563db000$var$localeMap = {
    // ar_EG:
    // az_AZ:
    // bg_BG:
    bn_BD: 'bn-bd',
    by_BY: 'be',
    // ca_ES:
    // cs_CZ:
    // da_DK:
    // de_DE:
    // el_GR:
    en_GB: 'en-gb',
    en_US: 'en',
    // es_ES:
    // et_EE:
    // fa_IR:
    // fi_FI:
    fr_BE: 'fr',
    // todo: dayjs has no fr_BE locale, use fr at present
    fr_CA: 'fr-ca',
    // fr_FR:
    // ga_IE:
    // gl_ES:
    // he_IL:
    // hi_IN:
    // hr_HR:
    // hu_HU:
    hy_AM: 'hy-am',
    // id_ID:
    // is_IS:
    // it_IT:
    // ja_JP:
    // ka_GE:
    // kk_KZ:
    // km_KH:
    kmr_IQ: 'ku',
    // kn_IN:
    // ko_KR:
    // ku_IQ: // previous ku in antd
    // lt_LT:
    // lv_LV:
    // mk_MK:
    // ml_IN:
    // mn_MN:
    // ms_MY:
    // nb_NO:
    // ne_NP:
    nl_BE: 'nl-be',
    // nl_NL:
    // pl_PL:
    pt_BR: 'pt-br',
    // pt_PT:
    // ro_RO:
    // ru_RU:
    // sk_SK:
    // sl_SI:
    // sr_RS:
    // sv_SE:
    // ta_IN:
    // th_TH:
    // tr_TR:
    // uk_UA:
    // ur_PK:
    // vi_VN:
    zh_CN: 'zh-cn',
    zh_HK: 'zh-hk',
    zh_TW: 'zh-tw'
};
var $a9d33dc0563db000$var$parseLocale = function parseLocale(locale) {
    var mapLocale = $a9d33dc0563db000$var$localeMap[locale];
    return mapLocale || locale.split('_')[0];
};
/* istanbul ignore next */ var $a9d33dc0563db000$var$parseNoMatchNotice = function parseNoMatchNotice() {
// zombieJ:
// When user typing, its always miss match format.
// This check is meaningless.
// https://github.com/ant-design/ant-design/issues/51839
// noteOnce(false, 'Not match any format. Please help to fire a issue about this.');
};
var $a9d33dc0563db000$var$generateConfig = {
    // get
    getNow: function getNow() {
        var now = (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))();
        // https://github.com/ant-design/ant-design/discussions/50934
        if (typeof now.tz === 'function') return now.tz(); // use default timezone
        return now;
    },
    getFixedDate: function getFixedDate(string) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(string, [
            'YYYY-M-DD',
            'YYYY-MM-DD'
        ]);
    },
    getEndDate: function getEndDate(date) {
        return date.endOf('month');
    },
    getWeekDay: function getWeekDay(date) {
        var clone = date.locale('en');
        return clone.weekday() + clone.localeData().firstDayOfWeek();
    },
    getYear: function getYear(date) {
        return date.year();
    },
    getMonth: function getMonth(date) {
        return date.month();
    },
    getDate: function getDate(date) {
        return date.date();
    },
    getHour: function getHour(date) {
        return date.hour();
    },
    getMinute: function getMinute(date) {
        return date.minute();
    },
    getSecond: function getSecond(date) {
        return date.second();
    },
    getMillisecond: function getMillisecond(date) {
        return date.millisecond();
    },
    // set
    addYear: function addYear(date, diff) {
        return date.add(diff, 'year');
    },
    addMonth: function addMonth(date, diff) {
        return date.add(diff, 'month');
    },
    addDate: function addDate(date, diff) {
        return date.add(diff, 'day');
    },
    setYear: function setYear(date, year) {
        return date.year(year);
    },
    setMonth: function setMonth(date, month) {
        return date.month(month);
    },
    setDate: function setDate(date, num) {
        return date.date(num);
    },
    setHour: function setHour(date, hour) {
        return date.hour(hour);
    },
    setMinute: function setMinute(date, minute) {
        return date.minute(minute);
    },
    setSecond: function setSecond(date, second) {
        return date.second(second);
    },
    setMillisecond: function setMillisecond(date, milliseconds) {
        return date.millisecond(milliseconds);
    },
    // Compare
    isAfter: function isAfter(date1, date2) {
        return date1.isAfter(date2);
    },
    isValidate: function isValidate(date) {
        return date.isValid();
    },
    locale: {
        getWeekFirstDay: function getWeekFirstDay(locale) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().locale($a9d33dc0563db000$var$parseLocale(locale)).localeData().firstDayOfWeek();
        },
        getWeekFirstDate: function getWeekFirstDate(locale, date) {
            return date.locale($a9d33dc0563db000$var$parseLocale(locale)).weekday(0);
        },
        getWeek: function getWeek(locale, date) {
            return date.locale($a9d33dc0563db000$var$parseLocale(locale)).week();
        },
        getShortWeekDays: function getShortWeekDays(locale) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().locale($a9d33dc0563db000$var$parseLocale(locale)).localeData().weekdaysMin();
        },
        getShortMonths: function getShortMonths(locale) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().locale($a9d33dc0563db000$var$parseLocale(locale)).localeData().monthsShort();
        },
        format: function format(locale, date, _format) {
            return date.locale($a9d33dc0563db000$var$parseLocale(locale)).format(_format);
        },
        parse: function parse(locale, text, formats) {
            var localeStr = $a9d33dc0563db000$var$parseLocale(locale);
            for(var i = 0; i < formats.length; i += 1){
                var format = formats[i];
                var formatText = text;
                if (format.includes('wo') || format.includes('Wo')) {
                    // parse Wo
                    var year = formatText.split('-')[0];
                    var weekStr = formatText.split('-')[1];
                    var firstWeek = (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(year, 'YYYY').startOf('year').locale(localeStr);
                    for(var j = 0; j <= 52; j += 1){
                        var nextWeek = firstWeek.add(j, 'week');
                        if (nextWeek.format('Wo') === weekStr) return nextWeek;
                    }
                    $a9d33dc0563db000$var$parseNoMatchNotice();
                    return null;
                }
                var date = (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(formatText, format, true).locale(localeStr);
                if (date.isValid()) return date;
            }
            if (text) $a9d33dc0563db000$var$parseNoMatchNotice();
            return null;
        }
    }
};
var $a9d33dc0563db000$export$2e2bcd8739ae039 = $a9d33dc0563db000$var$generateConfig;



var $ltGt3 = parcelRequire("ltGt3");
/**
 * What's new?
 * - Common
 *  - [Break] Support special year format, all the year will follow the locale config.
 *  - Blur all of field will trigger `onChange` if validate
 *  - Support `preserveInvalidOnBlur` to not to clean input if invalid and remove `changeOnBlur`
 *  - `pickerValue` is now full controlled
 *    - `defaultPickerValue` will take effect on every field active with popup opening.
 *  - [Break] clear button return the event with `onClick`
 *
 * - Locale
 *  - Remove `dateFormat` since it's never used
 *  - Remove `dateTimeFormat` since it's never used
 *
 * - Picker
 *  - TimePicker support `changeOnScroll`
 *  - TimePicker support `millisecond`
 *  - Support cellMeridiemFormat for AM/PM
 *  - Get correct `disabledHours` when set `use12Hours`
 *  - Support `showWeek`
 *
 * - RangePicker
 *  - [Break] RangePicker is now not limit the range of clicked field.
 *  - Trigger `onCalendarChange` when type correct
 *  - [Break] Not order `value` if given `value` is wrong order.
 *  - Hover `presets` will show date in input field.
 *  - [Break] RangePicker go to end field, `pickerValue` will follow the start field if not controlled.
 */ 






var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
// ====================== Mode ======================
function $4f10d5b61b75323d$export$a8767447b6867aa6(placement, rtl) {
    if (placement !== undefined) return placement;
    return rtl ? 'bottomRight' : 'bottomLeft';
}



var $ltGt3 = parcelRequire("ltGt3");
var $6158ac241550cb6d$var$PickerContext = /*#__PURE__*/ $ltGt3.createContext(null);
var $6158ac241550cb6d$export$2e2bcd8739ae039 = $6158ac241550cb6d$var$PickerContext;


function $a361cd0d3ae96847$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a361cd0d3ae96847$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a361cd0d3ae96847$var$_typeof(o);
}
function $a361cd0d3ae96847$var$_defineProperty(obj, key, value) {
    key = $a361cd0d3ae96847$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a361cd0d3ae96847$var$_toPropertyKey(t) {
    var i = $a361cd0d3ae96847$var$_toPrimitive(t, "string");
    return "symbol" == $a361cd0d3ae96847$var$_typeof(i) ? i : String(i);
}
function $a361cd0d3ae96847$var$_toPrimitive(t, r) {
    if ("object" != $a361cd0d3ae96847$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a361cd0d3ae96847$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a361cd0d3ae96847$var$BUILT_IN_PLACEMENTS = {
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        offset: [
            0,
            4
        ],
        overflow: {
            adjustX: 1,
            adjustY: 1
        }
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        offset: [
            0,
            4
        ],
        overflow: {
            adjustX: 1,
            adjustY: 1
        }
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        offset: [
            0,
            -4
        ],
        overflow: {
            adjustX: 0,
            adjustY: 1
        }
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        offset: [
            0,
            -4
        ],
        overflow: {
            adjustX: 0,
            adjustY: 1
        }
    }
};
function $a361cd0d3ae96847$var$PickerTrigger(_ref) {
    var popupElement = _ref.popupElement, popupStyle = _ref.popupStyle, popupClassName = _ref.popupClassName, popupAlign = _ref.popupAlign, transitionName = _ref.transitionName, getPopupContainer = _ref.getPopupContainer, children = _ref.children, range = _ref.range, placement = _ref.placement, _ref$builtinPlacement = _ref.builtinPlacements, builtinPlacements = _ref$builtinPlacement === void 0 ? $a361cd0d3ae96847$var$BUILT_IN_PLACEMENTS : _ref$builtinPlacement, direction = _ref.direction, visible = _ref.visible, onClose = _ref.onClose;
    var _React$useContext = $ltGt3.useContext((0, $6158ac241550cb6d$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls;
    var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
    var realPlacement = (0, $4f10d5b61b75323d$export$a8767447b6867aa6)(placement, direction === 'rtl');
    return /*#__PURE__*/ $ltGt3.createElement((0, $1b29c21fa1aa3a55$export$2e2bcd8739ae039), {
        showAction: [],
        hideAction: [
            'click'
        ],
        popupPlacement: realPlacement,
        builtinPlacements: builtinPlacements,
        prefixCls: dropdownPrefixCls,
        popupMotion: {
            motionName: transitionName
        },
        popup: popupElement,
        popupAlign: popupAlign,
        popupVisible: visible,
        popupClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(popupClassName, $a361cd0d3ae96847$var$_defineProperty($a361cd0d3ae96847$var$_defineProperty({}, "".concat(dropdownPrefixCls, "-range"), range), "".concat(dropdownPrefixCls, "-rtl"), direction === 'rtl')),
        popupStyle: popupStyle,
        stretch: "minWidth",
        getPopupContainer: getPopupContainer,
        onPopupVisibleChange: function onPopupVisibleChange(nextVisible) {
            if (!nextVisible) onClose();
        }
    }, children);
}
var $a361cd0d3ae96847$export$2e2bcd8739ae039 = $a361cd0d3ae96847$var$PickerTrigger;


function $4eaa081548444891$var$_toConsumableArray(arr) {
    return $4eaa081548444891$var$_arrayWithoutHoles(arr) || $4eaa081548444891$var$_iterableToArray(arr) || $4eaa081548444891$var$_unsupportedIterableToArray(arr) || $4eaa081548444891$var$_nonIterableSpread();
}
function $4eaa081548444891$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4eaa081548444891$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4eaa081548444891$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4eaa081548444891$var$_arrayLikeToArray(o, minLen);
}
function $4eaa081548444891$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4eaa081548444891$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4eaa081548444891$var$_arrayLikeToArray(arr);
}
function $4eaa081548444891$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4eaa081548444891$export$cbb503201166aab7(str, length) {
    var fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    var current = String(str);
    while(current.length < length)current = "".concat(fill).concat(current);
    return current;
}
function $4eaa081548444891$export$45b10814cc054894(val) {
    if (val === null || val === undefined) return [];
    return Array.isArray(val) ? val : [
        val
    ];
}
function $4eaa081548444891$export$4284846c29a21d02(ori, index, value) {
    var clone = $4eaa081548444891$var$_toConsumableArray(ori);
    clone[index] = value;
    return clone;
}
function $4eaa081548444891$export$1b696fb20abaa06c(props, keys) {
    var clone = {};
    var mergedKeys = keys || Object.keys(props);
    mergedKeys.forEach(function(key) {
        if (props[key] !== undefined) clone[key] = props[key];
    });
    return clone;
}
function $4eaa081548444891$export$58de47dfcd2733ec(picker, locale, format) {
    if (format) return format;
    switch(picker){
        // All from the `locale.fieldXXXFormat` first
        case 'time':
            return locale.fieldTimeFormat;
        case 'datetime':
            return locale.fieldDateTimeFormat;
        case 'month':
            return locale.fieldMonthFormat;
        case 'year':
            return locale.fieldYearFormat;
        case 'quarter':
            return locale.fieldQuarterFormat;
        case 'week':
            return locale.fieldWeekFormat;
        default:
            return locale.fieldDateFormat;
    }
}
function $4eaa081548444891$export$25071452d0014c32(calendarValues, activeIndexList, activeIndex) {
    var mergedActiveIndex = activeIndex !== undefined ? activeIndex : activeIndexList[activeIndexList.length - 1];
    var firstValuedIndex = activeIndexList.find(function(index) {
        return calendarValues[index];
    });
    return mergedActiveIndex !== firstValuedIndex ? calendarValues[firstValuedIndex] : undefined;
}


function $ca229a7f6958f601$export$a11cc4b953869c91(props) {
    return (0, $4eaa081548444891$export$1b696fb20abaa06c)(props, [
        'placement',
        'builtinPlacements',
        'popupAlign',
        'getPopupContainer',
        'transitionName',
        'direction'
    ]);
}






var $ltGt3 = parcelRequire("ltGt3");
function $8fa10cb8931a057d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8fa10cb8931a057d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8fa10cb8931a057d$var$_typeof(o);
}
function $8fa10cb8931a057d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8fa10cb8931a057d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8fa10cb8931a057d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8fa10cb8931a057d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8fa10cb8931a057d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8fa10cb8931a057d$var$_defineProperty(obj, key, value) {
    key = $8fa10cb8931a057d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8fa10cb8931a057d$var$_toPropertyKey(t) {
    var i = $8fa10cb8931a057d$var$_toPrimitive(t, "string");
    return "symbol" == $8fa10cb8931a057d$var$_typeof(i) ? i : String(i);
}
function $8fa10cb8931a057d$var$_toPrimitive(t, r) {
    if ("object" != $8fa10cb8931a057d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8fa10cb8931a057d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8fa10cb8931a057d$export$2e2bcd8739ae039(cellRender, dateRender, monthCellRender, range) {
    // ======================== Render ========================
    // Merged render
    var mergedCellRender = $ltGt3.useMemo(function() {
        if (cellRender) return cellRender;
        return function(current, info) {
            var date = current;
            if (dateRender && info.type === 'date') return dateRender(date, info.today);
            if (monthCellRender && info.type === 'month') return monthCellRender(date, info.locale);
            return info.originNode;
        };
    }, [
        cellRender,
        monthCellRender,
        dateRender
    ]);
    // Cell render
    var onInternalCellRender = $ltGt3.useCallback(function(date, info) {
        return mergedCellRender(date, $8fa10cb8931a057d$var$_objectSpread($8fa10cb8931a057d$var$_objectSpread({}, info), {}, {
            range: range
        }));
    }, [
        mergedCellRender,
        range
    ]);
    return onInternalCellRender;
}




var $ltGt3 = parcelRequire("ltGt3");
function $a847d18fd6b89adc$var$_slicedToArray(arr, i) {
    return $a847d18fd6b89adc$var$_arrayWithHoles(arr) || $a847d18fd6b89adc$var$_iterableToArrayLimit(arr, i) || $a847d18fd6b89adc$var$_unsupportedIterableToArray(arr, i) || $a847d18fd6b89adc$var$_nonIterableRest();
}
function $a847d18fd6b89adc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a847d18fd6b89adc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a847d18fd6b89adc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a847d18fd6b89adc$var$_arrayLikeToArray(o, minLen);
}
function $a847d18fd6b89adc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a847d18fd6b89adc$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a847d18fd6b89adc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a847d18fd6b89adc$export$2e2bcd8739ae039(calendarValue, isInvalidateDate) {
    var allowEmpty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var _React$useState = $ltGt3.useState([
        false,
        false
    ]), _React$useState2 = $a847d18fd6b89adc$var$_slicedToArray(_React$useState, 2), fieldsInvalidates = _React$useState2[0], setFieldsInvalidates = _React$useState2[1];
    var onSelectorInvalid = function onSelectorInvalid(invalid, index) {
        setFieldsInvalidates(function(ori) {
            return (0, $4eaa081548444891$export$4284846c29a21d02)(ori, index, invalid);
        });
    };
    /**
   * For the Selector Input to mark as `aria-disabled`
   */ var submitInvalidates = $ltGt3.useMemo(function() {
        return fieldsInvalidates.map(function(invalid, index) {
            // If typing invalidate
            if (invalid) return true;
            var current = calendarValue[index];
            // Not check if all empty
            if (!current) return false;
            // Not allow empty
            if (!allowEmpty[index] && !current) return true;
            // Invalidate
            if (current && isInvalidateDate(current, {
                activeIndex: index
            })) return true;
            return false;
        });
    }, [
        calendarValue,
        fieldsInvalidates,
        isInvalidateDate,
        allowEmpty
    ]);
    return [
        submitInvalidates,
        onSelectorInvalid
    ];
}




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
function $c0aff2e3bc189b4c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c0aff2e3bc189b4c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c0aff2e3bc189b4c$var$_typeof(o);
}
function $c0aff2e3bc189b4c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c0aff2e3bc189b4c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c0aff2e3bc189b4c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c0aff2e3bc189b4c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c0aff2e3bc189b4c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c0aff2e3bc189b4c$var$_defineProperty(obj, key, value) {
    key = $c0aff2e3bc189b4c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c0aff2e3bc189b4c$var$_toPropertyKey(t) {
    var i = $c0aff2e3bc189b4c$var$_toPrimitive(t, "string");
    return "symbol" == $c0aff2e3bc189b4c$var$_typeof(i) ? i : String(i);
}
function $c0aff2e3bc189b4c$var$_toPrimitive(t, r) {
    if ("object" != $c0aff2e3bc189b4c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c0aff2e3bc189b4c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c0aff2e3bc189b4c$export$e1dd595565d70a51(showHour, showMinute, showSecond, showMillisecond, showMeridiem) {
    var timeFormat = '';
    // Base HH:mm:ss
    var cells = [];
    if (showHour) cells.push(showMeridiem ? 'hh' : 'HH');
    if (showMinute) cells.push('mm');
    if (showSecond) cells.push('ss');
    timeFormat = cells.join(':');
    // Millisecond
    if (showMillisecond) timeFormat += '.SSS';
    // Meridiem
    if (showMeridiem) timeFormat += ' A';
    return timeFormat;
}
/**
 * Used for `useFilledProps` since it already in the React.useMemo
 */ function $c0aff2e3bc189b4c$var$fillLocale(locale, showHour, showMinute, showSecond, showMillisecond, use12Hours) {
    // Not fill `monthFormat` since `locale.shortMonths` handle this
    // Not fill `cellMeridiemFormat` since AM & PM by default
    var fieldDateTimeFormat = locale.fieldDateTimeFormat, fieldDateFormat = locale.fieldDateFormat, fieldTimeFormat = locale.fieldTimeFormat, fieldMonthFormat = locale.fieldMonthFormat, fieldYearFormat = locale.fieldYearFormat, fieldWeekFormat = locale.fieldWeekFormat, fieldQuarterFormat = locale.fieldQuarterFormat, yearFormat = locale.yearFormat, cellYearFormat = locale.cellYearFormat, cellQuarterFormat = locale.cellQuarterFormat, dayFormat = locale.dayFormat, cellDateFormat = locale.cellDateFormat;
    var timeFormat = $c0aff2e3bc189b4c$export$e1dd595565d70a51(showHour, showMinute, showSecond, showMillisecond, use12Hours);
    return $c0aff2e3bc189b4c$var$_objectSpread($c0aff2e3bc189b4c$var$_objectSpread({}, locale), {}, {
        fieldDateTimeFormat: fieldDateTimeFormat || "YYYY-MM-DD ".concat(timeFormat),
        fieldDateFormat: fieldDateFormat || 'YYYY-MM-DD',
        fieldTimeFormat: fieldTimeFormat || timeFormat,
        fieldMonthFormat: fieldMonthFormat || 'YYYY-MM',
        fieldYearFormat: fieldYearFormat || 'YYYY',
        fieldWeekFormat: fieldWeekFormat || 'gggg-wo',
        fieldQuarterFormat: fieldQuarterFormat || 'YYYY-[Q]Q',
        yearFormat: yearFormat || 'YYYY',
        cellYearFormat: cellYearFormat || 'YYYY',
        cellQuarterFormat: cellQuarterFormat || '[Q]Q',
        cellDateFormat: cellDateFormat || dayFormat || 'D'
    });
}
function $c0aff2e3bc189b4c$export$2e2bcd8739ae039(locale, showProps) {
    var showHour = showProps.showHour, showMinute = showProps.showMinute, showSecond = showProps.showSecond, showMillisecond = showProps.showMillisecond, use12Hours = showProps.use12Hours;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(function() {
        return $c0aff2e3bc189b4c$var$fillLocale(locale, showHour, showMinute, showSecond, showMillisecond, use12Hours);
    }, [
        locale,
        showHour,
        showMinute,
        showSecond,
        showMillisecond,
        use12Hours
    ]);
}




function $43ac09fd9f4907ea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43ac09fd9f4907ea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43ac09fd9f4907ea$var$ownKeys(Object(t), !0).forEach(function(r) {
            $43ac09fd9f4907ea$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43ac09fd9f4907ea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $43ac09fd9f4907ea$var$_defineProperty(obj, key, value) {
    key = $43ac09fd9f4907ea$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $43ac09fd9f4907ea$var$_toPropertyKey(t) {
    var i = $43ac09fd9f4907ea$var$_toPrimitive(t, "string");
    return "symbol" == $43ac09fd9f4907ea$var$_typeof(i) ? i : String(i);
}
function $43ac09fd9f4907ea$var$_toPrimitive(t, r) {
    if ("object" != $43ac09fd9f4907ea$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $43ac09fd9f4907ea$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $43ac09fd9f4907ea$var$_slicedToArray(arr, i) {
    return $43ac09fd9f4907ea$var$_arrayWithHoles(arr) || $43ac09fd9f4907ea$var$_iterableToArrayLimit(arr, i) || $43ac09fd9f4907ea$var$_unsupportedIterableToArray(arr, i) || $43ac09fd9f4907ea$var$_nonIterableRest();
}
function $43ac09fd9f4907ea$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $43ac09fd9f4907ea$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $43ac09fd9f4907ea$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $43ac09fd9f4907ea$var$_arrayLikeToArray(o, minLen);
}
function $43ac09fd9f4907ea$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $43ac09fd9f4907ea$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $43ac09fd9f4907ea$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $43ac09fd9f4907ea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $43ac09fd9f4907ea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $43ac09fd9f4907ea$var$_typeof(o);
}
function $43ac09fd9f4907ea$var$checkShow(format, keywords, show) {
    return show !== null && show !== void 0 ? show : keywords.some(function(keyword) {
        return format.includes(keyword);
    });
}
var $43ac09fd9f4907ea$var$showTimeKeys = [
    // 'format',
    'showNow',
    'showHour',
    'showMinute',
    'showSecond',
    'showMillisecond',
    'use12Hours',
    'hourStep',
    'minuteStep',
    'secondStep',
    'millisecondStep',
    'hideDisabledOptions',
    'defaultValue',
    'disabledHours',
    'disabledMinutes',
    'disabledSeconds',
    'disabledMilliseconds',
    'disabledTime',
    'changeOnScroll',
    'defaultOpenValue'
];
/**
 * Get SharedTimeProps from props.
 */ function $43ac09fd9f4907ea$var$pickTimeProps(props) {
    var timeProps = (0, $4eaa081548444891$export$1b696fb20abaa06c)(props, $43ac09fd9f4907ea$var$showTimeKeys);
    var format = props.format, picker = props.picker;
    var propFormat = null;
    if (format) {
        propFormat = format;
        if (Array.isArray(propFormat)) propFormat = propFormat[0];
        propFormat = $43ac09fd9f4907ea$var$_typeof(propFormat) === 'object' ? propFormat.format : propFormat;
    }
    if (picker === 'time') timeProps.format = propFormat;
    return [
        timeProps,
        propFormat
    ];
}
function $43ac09fd9f4907ea$var$isStringFormat(format) {
    return format && typeof format === 'string';
}
/** Check if all the showXXX is `undefined` */ function $43ac09fd9f4907ea$var$existShowConfig(showHour, showMinute, showSecond, showMillisecond) {
    return [
        showHour,
        showMinute,
        showSecond,
        showMillisecond
    ].some(function(show) {
        return show !== undefined;
    });
}
/** Fill the showXXX if needed */ function $43ac09fd9f4907ea$var$fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond) {
    var parsedShowHour = showHour;
    var parsedShowMinute = showMinute;
    var parsedShowSecond = showSecond;
    if (!hasShowConfig && !parsedShowHour && !parsedShowMinute && !parsedShowSecond && !showMillisecond) {
        parsedShowHour = true;
        parsedShowMinute = true;
        parsedShowSecond = true;
    } else if (hasShowConfig) {
        var _parsedShowHour, _parsedShowMinute, _parsedShowSecond;
        var existFalse = [
            parsedShowHour,
            parsedShowMinute,
            parsedShowSecond
        ].some(function(show) {
            return show === false;
        });
        var existTrue = [
            parsedShowHour,
            parsedShowMinute,
            parsedShowSecond
        ].some(function(show) {
            return show === true;
        });
        var defaultShow = existFalse ? true : !existTrue;
        parsedShowHour = (_parsedShowHour = parsedShowHour) !== null && _parsedShowHour !== void 0 ? _parsedShowHour : defaultShow;
        parsedShowMinute = (_parsedShowMinute = parsedShowMinute) !== null && _parsedShowMinute !== void 0 ? _parsedShowMinute : defaultShow;
        parsedShowSecond = (_parsedShowSecond = parsedShowSecond) !== null && _parsedShowSecond !== void 0 ? _parsedShowSecond : defaultShow;
    }
    return [
        parsedShowHour,
        parsedShowMinute,
        parsedShowSecond,
        showMillisecond
    ];
}
function $43ac09fd9f4907ea$export$6c7e3619a08d795a(componentProps) {
    var showTime = componentProps.showTime;
    var _pickTimeProps = $43ac09fd9f4907ea$var$pickTimeProps(componentProps), _pickTimeProps2 = $43ac09fd9f4907ea$var$_slicedToArray(_pickTimeProps, 2), pickedProps = _pickTimeProps2[0], propFormat = _pickTimeProps2[1];
    var showTimeConfig = showTime && $43ac09fd9f4907ea$var$_typeof(showTime) === 'object' ? showTime : {};
    var timeConfig = $43ac09fd9f4907ea$var$_objectSpread($43ac09fd9f4907ea$var$_objectSpread({
        defaultOpenValue: showTimeConfig.defaultOpenValue || showTimeConfig.defaultValue
    }, pickedProps), showTimeConfig);
    var showMillisecond = timeConfig.showMillisecond;
    var showHour = timeConfig.showHour, showMinute = timeConfig.showMinute, showSecond = timeConfig.showSecond;
    var hasShowConfig = $43ac09fd9f4907ea$var$existShowConfig(showHour, showMinute, showSecond, showMillisecond);
    var _fillShowConfig = $43ac09fd9f4907ea$var$fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond);
    var _fillShowConfig2 = $43ac09fd9f4907ea$var$_slicedToArray(_fillShowConfig, 3);
    showHour = _fillShowConfig2[0];
    showMinute = _fillShowConfig2[1];
    showSecond = _fillShowConfig2[2];
    return [
        timeConfig,
        $43ac09fd9f4907ea$var$_objectSpread($43ac09fd9f4907ea$var$_objectSpread({}, timeConfig), {}, {
            showHour: showHour,
            showMinute: showMinute,
            showSecond: showSecond,
            showMillisecond: showMillisecond
        }),
        timeConfig.format,
        propFormat
    ];
}
function $43ac09fd9f4907ea$export$901cd53a4926b425(picker, showTimeFormat, propFormat, timeConfig, locale) {
    var isTimePicker = picker === 'time';
    if (picker === 'datetime' || isTimePicker) {
        var pickedProps = timeConfig;
        // ====================== BaseFormat ======================
        var defaultLocaleFormat = (0, $4eaa081548444891$export$58de47dfcd2733ec)(picker, locale, null);
        var baselineFormat = defaultLocaleFormat;
        var formatList = [
            showTimeFormat,
            propFormat
        ];
        for(var i = 0; i < formatList.length; i += 1){
            var format = (0, $4eaa081548444891$export$45b10814cc054894)(formatList[i])[0];
            if ($43ac09fd9f4907ea$var$isStringFormat(format)) {
                baselineFormat = format;
                break;
            }
        }
        // ========================= Show =========================
        var showHour = pickedProps.showHour, showMinute = pickedProps.showMinute, showSecond = pickedProps.showSecond, showMillisecond = pickedProps.showMillisecond;
        var use12Hours = pickedProps.use12Hours;
        var showMeridiem = $43ac09fd9f4907ea$var$checkShow(baselineFormat, [
            'a',
            'A',
            'LT',
            'LLL',
            'LTS'
        ], use12Hours);
        var hasShowConfig = $43ac09fd9f4907ea$var$existShowConfig(showHour, showMinute, showSecond, showMillisecond);
        // Fill with format, if needed
        if (!hasShowConfig) {
            showHour = $43ac09fd9f4907ea$var$checkShow(baselineFormat, [
                'H',
                'h',
                'k',
                'LT',
                'LLL'
            ]);
            showMinute = $43ac09fd9f4907ea$var$checkShow(baselineFormat, [
                'm',
                'LT',
                'LLL'
            ]);
            showSecond = $43ac09fd9f4907ea$var$checkShow(baselineFormat, [
                's',
                'LTS'
            ]);
            showMillisecond = $43ac09fd9f4907ea$var$checkShow(baselineFormat, [
                'SSS'
            ]);
        }
        // Fallback if all can not see
        // ======================== Format ========================
        var _fillShowConfig3 = $43ac09fd9f4907ea$var$fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond);
        var _fillShowConfig4 = $43ac09fd9f4907ea$var$_slicedToArray(_fillShowConfig3, 3);
        showHour = _fillShowConfig4[0];
        showMinute = _fillShowConfig4[1];
        showSecond = _fillShowConfig4[2];
        var timeFormat = showTimeFormat || (0, $c0aff2e3bc189b4c$export$e1dd595565d70a51)(showHour, showMinute, showSecond, showMillisecond, showMeridiem);
        // ======================== Props =========================
        return $43ac09fd9f4907ea$var$_objectSpread($43ac09fd9f4907ea$var$_objectSpread({}, pickedProps), {}, {
            // Format
            format: timeFormat,
            // Show Config
            showHour: showHour,
            showMinute: showMinute,
            showSecond: showSecond,
            showMillisecond: showMillisecond,
            use12Hours: showMeridiem
        });
    }
    return null;
}





var $ltGt3 = parcelRequire("ltGt3");
function $f0f2e416996ba66d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f0f2e416996ba66d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f0f2e416996ba66d$var$_typeof(o);
}
function $f0f2e416996ba66d$export$cd2d9d0fa9dec03f(prefixCls, allowClear, clearIcon) {
    if (allowClear === false) return null;
    var config = allowClear && $f0f2e416996ba66d$var$_typeof(allowClear) === 'object' ? allowClear : {};
    return config.clearIcon || clearIcon || /*#__PURE__*/ $ltGt3.createElement("span", {
        className: "".concat(prefixCls, "-clear-btn")
    });
}



var $f655def3c887f075$export$fe62c2dddb4d77ea = 7;
/**
 * Wrap the compare logic.
 * This will compare the each of value is empty first.
 * 1. All is empty, return true.
 * 2. One is empty, return false.
 * 3. return customize compare logic.
 */ function $f655def3c887f075$var$nullableCompare(value1, value2, oriCompareFn) {
    if (!value1 && !value2 || value1 === value2) return true;
    if (!value1 || !value2) return false;
    return oriCompareFn();
}
function $f655def3c887f075$export$22ab546651b3be18(generateConfig, decade1, decade2) {
    return $f655def3c887f075$var$nullableCompare(decade1, decade2, function() {
        var num1 = Math.floor(generateConfig.getYear(decade1) / 10);
        var num2 = Math.floor(generateConfig.getYear(decade2) / 10);
        return num1 === num2;
    });
}
function $f655def3c887f075$export$5841f9eb9773f25f(generateConfig, year1, year2) {
    return $f655def3c887f075$var$nullableCompare(year1, year2, function() {
        return generateConfig.getYear(year1) === generateConfig.getYear(year2);
    });
}
function $f655def3c887f075$export$de90a4bb31c25221(generateConfig, date) {
    var quota = Math.floor(generateConfig.getMonth(date) / 3);
    return quota + 1;
}
function $f655def3c887f075$export$5c60e4190867161c(generateConfig, quarter1, quarter2) {
    return $f655def3c887f075$var$nullableCompare(quarter1, quarter2, function() {
        return $f655def3c887f075$export$5841f9eb9773f25f(generateConfig, quarter1, quarter2) && $f655def3c887f075$export$de90a4bb31c25221(generateConfig, quarter1) === $f655def3c887f075$export$de90a4bb31c25221(generateConfig, quarter2);
    });
}
function $f655def3c887f075$export$a18c89cbd24170ff(generateConfig, month1, month2) {
    return $f655def3c887f075$var$nullableCompare(month1, month2, function() {
        return $f655def3c887f075$export$5841f9eb9773f25f(generateConfig, month1, month2) && generateConfig.getMonth(month1) === generateConfig.getMonth(month2);
    });
}
function $f655def3c887f075$export$a8b2a21161763694(generateConfig, date1, date2) {
    return $f655def3c887f075$var$nullableCompare(date1, date2, function() {
        return $f655def3c887f075$export$5841f9eb9773f25f(generateConfig, date1, date2) && $f655def3c887f075$export$a18c89cbd24170ff(generateConfig, date1, date2) && generateConfig.getDate(date1) === generateConfig.getDate(date2);
    });
}
function $f655def3c887f075$export$dd2b4b46b4a2f5c9(generateConfig, time1, time2) {
    return $f655def3c887f075$var$nullableCompare(time1, time2, function() {
        return generateConfig.getHour(time1) === generateConfig.getHour(time2) && generateConfig.getMinute(time1) === generateConfig.getMinute(time2) && generateConfig.getSecond(time1) === generateConfig.getSecond(time2);
    });
}
function $f655def3c887f075$export$730a188731b5a146(generateConfig, time1, time2) {
    return $f655def3c887f075$var$nullableCompare(time1, time2, function() {
        return $f655def3c887f075$export$a8b2a21161763694(generateConfig, time1, time2) && $f655def3c887f075$export$dd2b4b46b4a2f5c9(generateConfig, time1, time2) && generateConfig.getMillisecond(time1) === generateConfig.getMillisecond(time2);
    });
}
function $f655def3c887f075$export$6ea683876c36b8d2(generateConfig, locale, date1, date2) {
    return $f655def3c887f075$var$nullableCompare(date1, date2, function() {
        var weekStartDate1 = generateConfig.locale.getWeekFirstDate(locale, date1);
        var weekStartDate2 = generateConfig.locale.getWeekFirstDate(locale, date2);
        return $f655def3c887f075$export$5841f9eb9773f25f(generateConfig, weekStartDate1, weekStartDate2) && generateConfig.locale.getWeek(locale, date1) === generateConfig.locale.getWeek(locale, date2);
    });
}
function $f655def3c887f075$export$18ac18efd9e98d41(generateConfig, locale, source, target, type) {
    switch(type){
        case 'date':
            return $f655def3c887f075$export$a8b2a21161763694(generateConfig, source, target);
        case 'week':
            return $f655def3c887f075$export$6ea683876c36b8d2(generateConfig, locale.locale, source, target);
        case 'month':
            return $f655def3c887f075$export$a18c89cbd24170ff(generateConfig, source, target);
        case 'quarter':
            return $f655def3c887f075$export$5c60e4190867161c(generateConfig, source, target);
        case 'year':
            return $f655def3c887f075$export$5841f9eb9773f25f(generateConfig, source, target);
        case 'decade':
            return $f655def3c887f075$export$22ab546651b3be18(generateConfig, source, target);
        case 'time':
            return $f655def3c887f075$export$dd2b4b46b4a2f5c9(generateConfig, source, target);
        default:
            return $f655def3c887f075$export$730a188731b5a146(generateConfig, source, target);
    }
}
function $f655def3c887f075$export$6dabbcb26357acf4(generateConfig, startDate, endDate, current) {
    if (!startDate || !endDate || !current) return false;
    return generateConfig.isAfter(current, startDate) && generateConfig.isAfter(endDate, current);
}
function $f655def3c887f075$export$a663815b3d4a2ed6(generateConfig, locale, date1, date2, type) {
    if ($f655def3c887f075$export$18ac18efd9e98d41(generateConfig, locale, date1, date2, type)) return true;
    return generateConfig.isAfter(date1, date2);
}
function $f655def3c887f075$export$e91829c600881133(locale, generateConfig, value) {
    var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale);
    var monthStartDate = generateConfig.setDate(value, 1);
    var startDateWeekDay = generateConfig.getWeekDay(monthStartDate);
    var alignStartDate = generateConfig.addDate(monthStartDate, weekFirstDay - startDateWeekDay);
    if (generateConfig.getMonth(alignStartDate) === generateConfig.getMonth(value) && generateConfig.getDate(alignStartDate) > 1) alignStartDate = generateConfig.addDate(alignStartDate, -7);
    return alignStartDate;
}
function $f655def3c887f075$export$7c4d25c0c3217d8c(value, _ref) {
    var generateConfig = _ref.generateConfig, locale = _ref.locale, format = _ref.format;
    if (!value) return '';
    return typeof format === 'function' ? format(value) : generateConfig.locale.format(locale.locale, value, format);
}
function $f655def3c887f075$export$48199fabfd385f2f(generateConfig, date, time) {
    var tmpDate = date;
    var getFn = [
        'getHour',
        'getMinute',
        'getSecond',
        'getMillisecond'
    ];
    var setFn = [
        'setHour',
        'setMinute',
        'setSecond',
        'setMillisecond'
    ];
    setFn.forEach(function(fn, index) {
        if (time) tmpDate = generateConfig[fn](tmpDate, generateConfig[getFn[index]](time));
        else tmpDate = generateConfig[fn](tmpDate, 0);
    });
    return tmpDate;
}


function $5a747fba57355373$export$2e2bcd8739ae039(generateConfig, locale, disabledDate, minDate, maxDate) {
    var mergedDisabledDate = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(date, info) {
        if (disabledDate && disabledDate(date, info)) return true;
        if (minDate && generateConfig.isAfter(minDate, date) && !(0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, minDate, date, info.type)) return true;
        if (maxDate && generateConfig.isAfter(date, maxDate) && !(0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, maxDate, date, info.type)) return true;
        return false;
    });
    return mergedDisabledDate;
}



var $ltGt3 = parcelRequire("ltGt3");

function $02ad80d7d722dbbb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $02ad80d7d722dbbb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $02ad80d7d722dbbb$var$_typeof(o);
}
function $02ad80d7d722dbbb$export$3880d22e26eb363c(picker, locale, format) {
    return $ltGt3.useMemo(function() {
        var rawFormat = (0, $4eaa081548444891$export$58de47dfcd2733ec)(picker, locale, format);
        var formatList = (0, $4eaa081548444891$export$45b10814cc054894)(rawFormat);
        var firstFormat = formatList[0];
        var maskFormat = $02ad80d7d722dbbb$var$_typeof(firstFormat) === 'object' && firstFormat.type === 'mask' ? firstFormat.format : null;
        return [
            // Format list
            formatList.map(function(config) {
                return typeof config === 'string' || typeof config === 'function' ? config : config.format;
            }),
            // Mask Format
            maskFormat
        ];
    }, [
        picker,
        locale,
        format
    ]);
}


function $9a257ed9b2bb07ea$export$2e2bcd8739ae039(formatList, inputReadOnly, multiple) {
    if (typeof formatList[0] === 'function' || multiple) return true;
    return inputReadOnly;
}



function $045ce866dee89269$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $045ce866dee89269$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $045ce866dee89269$var$_typeof(o);
}
function $045ce866dee89269$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $045ce866dee89269$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $045ce866dee89269$var$ownKeys(Object(t), !0).forEach(function(r) {
            $045ce866dee89269$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $045ce866dee89269$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $045ce866dee89269$var$_defineProperty(obj, key, value) {
    key = $045ce866dee89269$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $045ce866dee89269$var$_toPropertyKey(t) {
    var i = $045ce866dee89269$var$_toPrimitive(t, "string");
    return "symbol" == $045ce866dee89269$var$_typeof(i) ? i : String(i);
}
function $045ce866dee89269$var$_toPrimitive(t, r) {
    if ("object" != $045ce866dee89269$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $045ce866dee89269$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $045ce866dee89269$export$2e2bcd8739ae039(generateConfig, picker, disabledDate, showTime) {
    // Check disabled date
    var isInvalidate = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(date, info) {
        var outsideInfo = $045ce866dee89269$var$_objectSpread({
            type: picker
        }, info);
        delete outsideInfo.activeIndex;
        if (// Date object is invalid
        !generateConfig.isValidate(date) || // Date is disabled by `disabledDate`
        disabledDate && disabledDate(date, outsideInfo)) return true;
        if ((picker === 'date' || picker === 'time') && showTime) {
            var _showTime$disabledTim;
            var range = info && info.activeIndex === 1 ? 'end' : 'start';
            var _ref = ((_showTime$disabledTim = showTime.disabledTime) === null || _showTime$disabledTim === void 0 ? void 0 : _showTime$disabledTim.call(showTime, date, range, {
                from: outsideInfo.from
            })) || {}, disabledHours = _ref.disabledHours, disabledMinutes = _ref.disabledMinutes, disabledSeconds = _ref.disabledSeconds, disabledMilliseconds = _ref.disabledMilliseconds;
            var legacyDisabledHours = showTime.disabledHours, legacyDisabledMinutes = showTime.disabledMinutes, legacyDisabledSeconds = showTime.disabledSeconds;
            var mergedDisabledHours = disabledHours || legacyDisabledHours;
            var mergedDisabledMinutes = disabledMinutes || legacyDisabledMinutes;
            var mergedDisabledSeconds = disabledSeconds || legacyDisabledSeconds;
            var hour = generateConfig.getHour(date);
            var minute = generateConfig.getMinute(date);
            var second = generateConfig.getSecond(date);
            var millisecond = generateConfig.getMillisecond(date);
            if (mergedDisabledHours && mergedDisabledHours().includes(hour)) return true;
            if (mergedDisabledMinutes && mergedDisabledMinutes(hour).includes(minute)) return true;
            if (mergedDisabledSeconds && mergedDisabledSeconds(hour, minute).includes(second)) return true;
            if (disabledMilliseconds && disabledMilliseconds(hour, minute, second).includes(millisecond)) return true;
        }
        return false;
    });
    return isInvalidate;
}


function $d29755e463bdcbb2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d29755e463bdcbb2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d29755e463bdcbb2$var$_typeof(o);
}
function $d29755e463bdcbb2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d29755e463bdcbb2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d29755e463bdcbb2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d29755e463bdcbb2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d29755e463bdcbb2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d29755e463bdcbb2$var$_defineProperty(obj, key, value) {
    key = $d29755e463bdcbb2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d29755e463bdcbb2$var$_toPropertyKey(t) {
    var i = $d29755e463bdcbb2$var$_toPrimitive(t, "string");
    return "symbol" == $d29755e463bdcbb2$var$_typeof(i) ? i : String(i);
}
function $d29755e463bdcbb2$var$_toPrimitive(t, r) {
    if ("object" != $d29755e463bdcbb2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d29755e463bdcbb2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d29755e463bdcbb2$var$_slicedToArray(arr, i) {
    return $d29755e463bdcbb2$var$_arrayWithHoles(arr) || $d29755e463bdcbb2$var$_iterableToArrayLimit(arr, i) || $d29755e463bdcbb2$var$_unsupportedIterableToArray(arr, i) || $d29755e463bdcbb2$var$_nonIterableRest();
}
function $d29755e463bdcbb2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d29755e463bdcbb2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d29755e463bdcbb2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d29755e463bdcbb2$var$_arrayLikeToArray(o, minLen);
}
function $d29755e463bdcbb2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d29755e463bdcbb2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d29755e463bdcbb2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d29755e463bdcbb2$var$useList(value) {
    var fillMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var values = $ltGt3.useMemo(function() {
        var list = value ? (0, $4eaa081548444891$export$45b10814cc054894)(value) : value;
        if (fillMode && list) list[1] = list[1] || list[0];
        return list;
    }, [
        value,
        fillMode
    ]);
    return values;
}
function $d29755e463bdcbb2$export$2e2bcd8739ae039(props, updater) {
    var generateConfig = props.generateConfig, locale = props.locale, _props$picker = props.picker, picker = _props$picker === void 0 ? 'date' : _props$picker, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls, _props$previewValue = props.previewValue, previewValue = _props$previewValue === void 0 ? 'hover' : _props$previewValue, _props$styles = props.styles, styles = _props$styles === void 0 ? {} : _props$styles, _props$classNames = props.classNames, classNames = _props$classNames === void 0 ? {} : _props$classNames, _props$order = props.order, order = _props$order === void 0 ? true : _props$order, _props$components = props.components, components = _props$components === void 0 ? {} : _props$components, inputRender = props.inputRender, allowClear = props.allowClear, clearIcon = props.clearIcon, needConfirm = props.needConfirm, multiple = props.multiple, format = props.format, inputReadOnly = props.inputReadOnly, disabledDate = props.disabledDate, minDate = props.minDate, maxDate = props.maxDate, showTime = props.showTime, value = props.value, defaultValue = props.defaultValue, pickerValue = props.pickerValue, defaultPickerValue = props.defaultPickerValue;
    var values = $d29755e463bdcbb2$var$useList(value);
    var defaultValues = $d29755e463bdcbb2$var$useList(defaultValue);
    var pickerValues = $d29755e463bdcbb2$var$useList(pickerValue);
    var defaultPickerValues = $d29755e463bdcbb2$var$useList(defaultPickerValue);
    // ======================== Picker ========================
    /** Almost same as `picker`, but add `datetime` for `date` with `showTime` */ var internalPicker = picker === 'date' && showTime ? 'datetime' : picker;
    /** The picker is `datetime` or `time` */ var multipleInteractivePicker = internalPicker === 'time' || internalPicker === 'datetime';
    var complexPicker = multipleInteractivePicker || multiple;
    var mergedNeedConfirm = needConfirm !== null && needConfirm !== void 0 ? needConfirm : multipleInteractivePicker;
    // ========================== Time ==========================
    // Auto `format` need to check `showTime.showXXX` first.
    // And then merge the `locale` into `mergedShowTime`.
    var _getTimeProps = (0, $43ac09fd9f4907ea$export$6c7e3619a08d795a)(props), _getTimeProps2 = $d29755e463bdcbb2$var$_slicedToArray(_getTimeProps, 4), timeProps = _getTimeProps2[0], localeTimeProps = _getTimeProps2[1], showTimeFormat = _getTimeProps2[2], propFormat = _getTimeProps2[3];
    // ======================= Locales ========================
    var mergedLocale = (0, $c0aff2e3bc189b4c$export$2e2bcd8739ae039)(locale, localeTimeProps);
    var mergedShowTime = $ltGt3.useMemo(function() {
        return (0, $43ac09fd9f4907ea$export$901cd53a4926b425)(internalPicker, showTimeFormat, propFormat, timeProps, mergedLocale);
    }, [
        internalPicker,
        showTimeFormat,
        propFormat,
        timeProps,
        mergedLocale
    ]);
    // ======================== Props =========================
    var filledProps = $ltGt3.useMemo(function() {
        return $d29755e463bdcbb2$var$_objectSpread($d29755e463bdcbb2$var$_objectSpread({}, props), {}, {
            previewValue: previewValue,
            prefixCls: prefixCls,
            locale: mergedLocale,
            picker: picker,
            styles: styles,
            classNames: classNames,
            order: order,
            components: $d29755e463bdcbb2$var$_objectSpread({
                input: inputRender
            }, components),
            clearIcon: (0, $f0f2e416996ba66d$export$cd2d9d0fa9dec03f)(prefixCls, allowClear, clearIcon),
            showTime: mergedShowTime,
            value: values,
            defaultValue: defaultValues,
            pickerValue: pickerValues,
            defaultPickerValue: defaultPickerValues
        }, updater === null || updater === void 0 ? void 0 : updater());
    }, [
        props
    ]);
    // ======================== Format ========================
    var _useFieldFormat = (0, $02ad80d7d722dbbb$export$3880d22e26eb363c)(internalPicker, mergedLocale, format), _useFieldFormat2 = $d29755e463bdcbb2$var$_slicedToArray(_useFieldFormat, 2), formatList = _useFieldFormat2[0], maskFormat = _useFieldFormat2[1];
    // ======================= ReadOnly =======================
    var mergedInputReadOnly = (0, $9a257ed9b2bb07ea$export$2e2bcd8739ae039)(formatList, inputReadOnly, multiple);
    // ======================= Boundary =======================
    var disabledBoundaryDate = (0, $5a747fba57355373$export$2e2bcd8739ae039)(generateConfig, locale, disabledDate, minDate, maxDate);
    // ====================== Invalidate ======================
    var isInvalidateDate = (0, $045ce866dee89269$export$2e2bcd8739ae039)(generateConfig, picker, disabledBoundaryDate, mergedShowTime);
    // ======================== Merged ========================
    var mergedProps = $ltGt3.useMemo(function() {
        return $d29755e463bdcbb2$var$_objectSpread($d29755e463bdcbb2$var$_objectSpread({}, filledProps), {}, {
            needConfirm: mergedNeedConfirm,
            inputReadOnly: mergedInputReadOnly,
            disabledDate: disabledBoundaryDate
        });
    }, [
        filledProps,
        mergedNeedConfirm,
        mergedInputReadOnly,
        disabledBoundaryDate
    ]);
    return [
        mergedProps,
        internalPicker,
        complexPicker,
        formatList,
        maskFormat,
        isInvalidateDate
    ];
}





var $ltGt3 = parcelRequire("ltGt3");
function $05976fb2699ac91b$var$_slicedToArray(arr, i) {
    return $05976fb2699ac91b$var$_arrayWithHoles(arr) || $05976fb2699ac91b$var$_iterableToArrayLimit(arr, i) || $05976fb2699ac91b$var$_unsupportedIterableToArray(arr, i) || $05976fb2699ac91b$var$_nonIterableRest();
}
function $05976fb2699ac91b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $05976fb2699ac91b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $05976fb2699ac91b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $05976fb2699ac91b$var$_arrayLikeToArray(o, minLen);
}
function $05976fb2699ac91b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $05976fb2699ac91b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $05976fb2699ac91b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $05976fb2699ac91b$export$2e2bcd8739ae039(value, defaultValue, onChange) {
    var _useControlledState = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultValue, value), _useControlledState2 = $05976fb2699ac91b$var$_slicedToArray(_useControlledState, 2), state = _useControlledState2[0], setState = _useControlledState2[1];
    // Need force update to ensure React re-render
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState({}), _React$useState2 = $05976fb2699ac91b$var$_slicedToArray(_React$useState, 2), forceUpdate = _React$useState2[1];
    var triggerUpdate = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(nextState) {
        setState(nextState);
        forceUpdate({});
    });
    var nextValueRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(value);
    // ============================= Update =============================
    var rafRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef();
    var cancelRaf = function cancelRaf() {
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(rafRef.current);
    };
    var doUpdate = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function() {
        triggerUpdate(nextValueRef.current);
        if (onChange && state !== nextValueRef.current) onChange(nextValueRef.current);
    });
    var updateValue = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(next, immediately) {
        cancelRaf();
        nextValueRef.current = next;
        if (next || immediately) doUpdate();
        else rafRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(doUpdate);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(function() {
        return cancelRaf;
    }, []);
    return [
        state,
        updateValue
    ];
}


function $67b23fc684b71686$var$_slicedToArray(arr, i) {
    return $67b23fc684b71686$var$_arrayWithHoles(arr) || $67b23fc684b71686$var$_iterableToArrayLimit(arr, i) || $67b23fc684b71686$var$_unsupportedIterableToArray(arr, i) || $67b23fc684b71686$var$_nonIterableRest();
}
function $67b23fc684b71686$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $67b23fc684b71686$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $67b23fc684b71686$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $67b23fc684b71686$var$_arrayLikeToArray(o, minLen);
}
function $67b23fc684b71686$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $67b23fc684b71686$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $67b23fc684b71686$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $67b23fc684b71686$export$2e2bcd8739ae039(open, defaultOpen) {
    var disabledList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var onOpenChange = arguments.length > 3 ? arguments[3] : undefined;
    var mergedOpen = disabledList.every(function(disabled) {
        return disabled;
    }) ? false : open;
    // Delay for handle the open state, in case fast shift from `open` -> `close` -> `open`
    // const [rafOpen, setRafOpen] = useLockState(open, defaultOpen || false, onOpenChange);
    var _useDelayState = (0, $05976fb2699ac91b$export$2e2bcd8739ae039)(mergedOpen, defaultOpen || false, onOpenChange), _useDelayState2 = $67b23fc684b71686$var$_slicedToArray(_useDelayState, 2), rafOpen = _useDelayState2[0], setRafOpen = _useDelayState2[1];
    function setOpen(next) {
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!config.inherit || rafOpen) setRafOpen(next, config.force);
    }
    return [
        rafOpen,
        setOpen
    ];
}



var $ltGt3 = parcelRequire("ltGt3");
function $ede354abeea92cfa$export$2e2bcd8739ae039(ref) {
    var selectorRef = $ltGt3.useRef();
    $ltGt3.useImperativeHandle(ref, function() {
        var _selectorRef$current;
        return {
            nativeElement: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.nativeElement,
            focus: function focus(options) {
                var _selectorRef$current2;
                (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 || _selectorRef$current2.focus(options);
            },
            blur: function blur() {
                var _selectorRef$current3;
                (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.blur();
            }
        };
    });
    return selectorRef;
}



var $ltGt3 = parcelRequire("ltGt3");

function $a9785ec601c9c81e$var$_slicedToArray(arr, i) {
    return $a9785ec601c9c81e$var$_arrayWithHoles(arr) || $a9785ec601c9c81e$var$_iterableToArrayLimit(arr, i) || $a9785ec601c9c81e$var$_unsupportedIterableToArray(arr, i) || $a9785ec601c9c81e$var$_nonIterableRest();
}
function $a9785ec601c9c81e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a9785ec601c9c81e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a9785ec601c9c81e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a9785ec601c9c81e$var$_arrayLikeToArray(o, minLen);
}
function $a9785ec601c9c81e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a9785ec601c9c81e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a9785ec601c9c81e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a9785ec601c9c81e$export$2e2bcd8739ae039(presets, legacyRanges) {
    return $ltGt3.useMemo(function() {
        if (presets) return presets;
        if (legacyRanges) {
            (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, '`ranges` is deprecated. Please use `presets` instead.');
            return Object.entries(legacyRanges).map(function(_ref) {
                var _ref2 = $a9785ec601c9c81e$var$_slicedToArray(_ref, 2), label = _ref2[0], value = _ref2[1];
                return {
                    label: label,
                    value: value
                };
            });
        }
        return [];
    }, [
        presets,
        legacyRanges
    ]);
}



var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
function $5282d4a7d1ae4971$export$2e2bcd8739ae039(condition, callback) {
    var delayFrames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var callbackRef = $ltGt3.useRef(callback);
    callbackRef.current = callback;
    (0, $b51fc3415a3f1104$export$9283e56bae2f7b0f)(function() {
        if (condition) callbackRef.current(condition);
        else {
            var id = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(function() {
                callbackRef.current(condition);
            }, delayFrames);
            return function() {
                (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(id);
            };
        }
    }, [
        condition
    ]);
}


function $1bf818719e58cbff$var$_slicedToArray(arr, i) {
    return $1bf818719e58cbff$var$_arrayWithHoles(arr) || $1bf818719e58cbff$var$_iterableToArrayLimit(arr, i) || $1bf818719e58cbff$var$_unsupportedIterableToArray(arr, i) || $1bf818719e58cbff$var$_nonIterableRest();
}
function $1bf818719e58cbff$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1bf818719e58cbff$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1bf818719e58cbff$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1bf818719e58cbff$var$_arrayLikeToArray(o, minLen);
}
function $1bf818719e58cbff$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1bf818719e58cbff$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $1bf818719e58cbff$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1bf818719e58cbff$export$2e2bcd8739ae039(disabled) {
    var empty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var mergedOpen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _React$useState = $ltGt3.useState(0), _React$useState2 = $1bf818719e58cbff$var$_slicedToArray(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
    var _React$useState3 = $ltGt3.useState(false), _React$useState4 = $1bf818719e58cbff$var$_slicedToArray(_React$useState3, 2), focused = _React$useState4[0], setFocused = _React$useState4[1];
    var activeListRef = $ltGt3.useRef([]);
    var submitIndexRef = $ltGt3.useRef(null);
    var lastOperationRef = $ltGt3.useRef(null);
    var updateSubmitIndex = function updateSubmitIndex(index) {
        submitIndexRef.current = index;
    };
    var hasActiveSubmitValue = function hasActiveSubmitValue(index) {
        return submitIndexRef.current === index;
    };
    var triggerFocus = function triggerFocus(nextFocus) {
        setFocused(nextFocus);
    };
    // ============================= Record =============================
    var lastOperation = function lastOperation(type) {
        if (type) lastOperationRef.current = type;
        return lastOperationRef.current;
    };
    // ============================ Strategy ============================
    // Trigger when input enter or input blur or panel close
    var nextActiveIndex = function nextActiveIndex(nextValue) {
        var list = activeListRef.current;
        var filledActiveSet = new Set(list.filter(function(index) {
            return nextValue[index] || empty[index];
        }));
        var nextIndex = list[list.length - 1] === 0 ? 1 : 0;
        if (filledActiveSet.size >= 2 || disabled[nextIndex]) return null;
        return nextIndex;
    };
    // ============================= Effect =============================
    // Wait in case it's from the click outside to blur
    (0, $5282d4a7d1ae4971$export$2e2bcd8739ae039)(focused || mergedOpen, function() {
        if (!focused) {
            activeListRef.current = [];
            updateSubmitIndex(null);
        }
    });
    $ltGt3.useEffect(function() {
        if (focused) activeListRef.current.push(activeIndex);
    }, [
        focused,
        activeIndex
    ]);
    return [
        focused,
        triggerFocus,
        lastOperation,
        activeIndex,
        setActiveIndex,
        nextActiveIndex,
        activeListRef.current,
        updateSubmitIndex,
        hasActiveSubmitValue
    ];
}




function $b9225b38da7f1f79$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b9225b38da7f1f79$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b9225b38da7f1f79$var$_typeof(o);
}
function $b9225b38da7f1f79$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b9225b38da7f1f79$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b9225b38da7f1f79$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b9225b38da7f1f79$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b9225b38da7f1f79$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b9225b38da7f1f79$var$_defineProperty(obj, key, value) {
    key = $b9225b38da7f1f79$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b9225b38da7f1f79$var$_toPropertyKey(t) {
    var i = $b9225b38da7f1f79$var$_toPrimitive(t, "string");
    return "symbol" == $b9225b38da7f1f79$var$_typeof(i) ? i : String(i);
}
function $b9225b38da7f1f79$var$_toPrimitive(t, r) {
    if ("object" != $b9225b38da7f1f79$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b9225b38da7f1f79$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b9225b38da7f1f79$var$_slicedToArray(arr, i) {
    return $b9225b38da7f1f79$var$_arrayWithHoles(arr) || $b9225b38da7f1f79$var$_iterableToArrayLimit(arr, i) || $b9225b38da7f1f79$var$_unsupportedIterableToArray(arr, i) || $b9225b38da7f1f79$var$_nonIterableRest();
}
function $b9225b38da7f1f79$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b9225b38da7f1f79$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b9225b38da7f1f79$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b9225b38da7f1f79$var$_arrayLikeToArray(o, minLen);
}
function $b9225b38da7f1f79$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b9225b38da7f1f79$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b9225b38da7f1f79$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b9225b38da7f1f79$export$2e2bcd8739ae039(values, disabled, activeIndexList, generateConfig, locale, disabledDate) {
    var activeIndex = activeIndexList[activeIndexList.length - 1];
    var rangeDisabledDate = function rangeDisabledDate(date, info) {
        var _values = $b9225b38da7f1f79$var$_slicedToArray(values, 2), start = _values[0], end = _values[1];
        var mergedInfo = $b9225b38da7f1f79$var$_objectSpread($b9225b38da7f1f79$var$_objectSpread({}, info), {}, {
            from: (0, $4eaa081548444891$export$25071452d0014c32)(values, activeIndexList)
        });
        // ============================ Disabled ============================
        // Should not select days before the start date
        if (activeIndex === 1 && disabled[0] && start && // Same date isOK
        !(0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, start, date, mergedInfo.type) && // Before start date
        generateConfig.isAfter(start, date)) return true;
        // Should not select days after the end date
        if (activeIndex === 0 && disabled[1] && end && // Same date isOK
        !(0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, end, date, mergedInfo.type) && // After end date
        generateConfig.isAfter(date, end)) return true;
        // ============================= Origin =============================
        return disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date, mergedInfo);
    };
    return rangeDisabledDate;
}





var $ltGt3 = parcelRequire("ltGt3");

function $7b84215c9fa9f92b$var$_slicedToArray(arr, i) {
    return $7b84215c9fa9f92b$var$_arrayWithHoles(arr) || $7b84215c9fa9f92b$var$_iterableToArrayLimit(arr, i) || $7b84215c9fa9f92b$var$_unsupportedIterableToArray(arr, i) || $7b84215c9fa9f92b$var$_nonIterableRest();
}
function $7b84215c9fa9f92b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7b84215c9fa9f92b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7b84215c9fa9f92b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7b84215c9fa9f92b$var$_arrayLikeToArray(o, minLen);
}
function $7b84215c9fa9f92b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7b84215c9fa9f92b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7b84215c9fa9f92b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7b84215c9fa9f92b$export$b0e4aff419ae4233(generateConfig, picker, date, offset) {
    switch(picker){
        case 'date':
        case 'week':
            return generateConfig.addMonth(date, offset);
        case 'month':
        case 'quarter':
            return generateConfig.addYear(date, offset);
        case 'year':
            return generateConfig.addYear(date, offset * 10);
        case 'decade':
            return generateConfig.addYear(date, offset * 100);
        default:
            return date;
    }
}
var $7b84215c9fa9f92b$var$EMPTY_LIST = [];
function $7b84215c9fa9f92b$export$2e2bcd8739ae039(generateConfig, locale, calendarValue, modes, open, activeIndex, pickerMode, multiplePanel) {
    var defaultPickerValue = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : $7b84215c9fa9f92b$var$EMPTY_LIST;
    var pickerValue = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : $7b84215c9fa9f92b$var$EMPTY_LIST;
    var timeDefaultValue = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : $7b84215c9fa9f92b$var$EMPTY_LIST;
    var onPickerValueChange = arguments.length > 11 ? arguments[11] : undefined;
    var minDate = arguments.length > 12 ? arguments[12] : undefined;
    var maxDate = arguments.length > 13 ? arguments[13] : undefined;
    var isTimePicker = pickerMode === 'time';
    // ======================== Active ========================
    // `activeIndex` must be valid to avoid getting empty `pickerValue`
    var mergedActiveIndex = activeIndex || 0;
    // ===================== Picker Value =====================
    var getDefaultPickerValue = function getDefaultPickerValue(index) {
        var now = generateConfig.getNow();
        if (isTimePicker) now = (0, $f655def3c887f075$export$48199fabfd385f2f)(generateConfig, now);
        return defaultPickerValue[index] || calendarValue[index] || now;
    };
    // Align `pickerValue` with `showTime.defaultValue`
    var _pickerValue = $7b84215c9fa9f92b$var$_slicedToArray(pickerValue, 2), startPickerValue = _pickerValue[0], endPickerValue = _pickerValue[1];
    // PickerValue state
    var _useControlledState = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(function() {
        return getDefaultPickerValue(0);
    }, startPickerValue), _useControlledState2 = $7b84215c9fa9f92b$var$_slicedToArray(_useControlledState, 2), mergedStartPickerValue = _useControlledState2[0], setStartPickerValue = _useControlledState2[1];
    var _useControlledState3 = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(function() {
        return getDefaultPickerValue(1);
    }, endPickerValue), _useControlledState4 = $7b84215c9fa9f92b$var$_slicedToArray(_useControlledState3, 2), mergedEndPickerValue = _useControlledState4[0], setEndPickerValue = _useControlledState4[1];
    // Current PickerValue
    var currentPickerValue = $ltGt3.useMemo(function() {
        var current = [
            mergedStartPickerValue,
            mergedEndPickerValue
        ][mergedActiveIndex];
        // Merge the `showTime.defaultValue` into `pickerValue`
        return isTimePicker ? current : (0, $f655def3c887f075$export$48199fabfd385f2f)(generateConfig, current, timeDefaultValue[mergedActiveIndex]);
    }, [
        isTimePicker,
        mergedStartPickerValue,
        mergedEndPickerValue,
        mergedActiveIndex,
        generateConfig,
        timeDefaultValue
    ]);
    var setCurrentPickerValue = function setCurrentPickerValue(nextPickerValue) {
        var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'panel';
        var updater = [
            setStartPickerValue,
            setEndPickerValue
        ][mergedActiveIndex];
        updater(nextPickerValue);
        var clone = [
            mergedStartPickerValue,
            mergedEndPickerValue
        ];
        clone[mergedActiveIndex] = nextPickerValue;
        if (onPickerValueChange && (!(0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, mergedStartPickerValue, clone[0], pickerMode) || !(0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, mergedEndPickerValue, clone[1], pickerMode))) onPickerValueChange(clone, {
            source: source,
            range: mergedActiveIndex === 1 ? 'end' : 'start',
            mode: modes
        });
    };
    // ======================== Effect ========================
    /**
   * EndDate pickerValue is little different. It should be:
   * - If date picker (without time), endDate is not same year & month as startDate
   *   - pickerValue minus one month
   * - Else pass directly
   */ var getEndDatePickerValue = function getEndDatePickerValue(startDate, endDate) {
        if (multiplePanel) {
            // Basic offset
            var SAME_CHECKER = {
                date: 'month',
                week: 'month',
                month: 'year',
                quarter: 'year'
            };
            var mode = SAME_CHECKER[pickerMode];
            if (mode && !(0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, startDate, endDate, mode)) return $7b84215c9fa9f92b$export$b0e4aff419ae4233(generateConfig, pickerMode, endDate, -1);
            // Year offset
            if (pickerMode === 'year' && startDate) {
                var srcYear = Math.floor(generateConfig.getYear(startDate) / 10);
                var tgtYear = Math.floor(generateConfig.getYear(endDate) / 10);
                if (srcYear !== tgtYear) return $7b84215c9fa9f92b$export$b0e4aff419ae4233(generateConfig, pickerMode, endDate, -1);
            }
        }
        return endDate;
    };
    // >>> When switch field, reset the picker value as prev field picker value
    var prevActiveIndexRef = $ltGt3.useRef(null);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(function() {
        if (open) {
            if (!defaultPickerValue[mergedActiveIndex]) {
                var nextPickerValue = isTimePicker ? null : generateConfig.getNow();
                /**
         * 1. If has prevActiveIndex, use it to avoid panel jump
         * 2. If current field has value
         *    - If `activeIndex` is 1 and `calendarValue[0]` is not same panel as `calendarValue[1]`,
         *      offset `calendarValue[1]` and set it
         *    - Else use `calendarValue[activeIndex]`
         * 3. If current field has no value but another field has value, use another field value
         * 4. Else use now (not any `calendarValue` can ref)
         */ if (prevActiveIndexRef.current !== null && prevActiveIndexRef.current !== mergedActiveIndex) // If from another field, not jump picker value
                nextPickerValue = [
                    mergedStartPickerValue,
                    mergedEndPickerValue
                ][mergedActiveIndex ^ 1];
                else if (calendarValue[mergedActiveIndex]) // Current field has value
                nextPickerValue = mergedActiveIndex === 0 ? calendarValue[0] : getEndDatePickerValue(calendarValue[0], calendarValue[1]);
                else if (calendarValue[mergedActiveIndex ^ 1]) // Current field has no value but another field has value
                nextPickerValue = calendarValue[mergedActiveIndex ^ 1];
                // Only sync when has value, this will sync in the `min-max` logic
                if (nextPickerValue) {
                    // nextPickerValue < minDate
                    if (minDate && generateConfig.isAfter(minDate, nextPickerValue)) nextPickerValue = minDate;
                    // maxDate < nextPickerValue
                    var offsetPickerValue = multiplePanel ? $7b84215c9fa9f92b$export$b0e4aff419ae4233(generateConfig, pickerMode, nextPickerValue, 1) : nextPickerValue;
                    if (maxDate && generateConfig.isAfter(offsetPickerValue, maxDate)) nextPickerValue = multiplePanel ? $7b84215c9fa9f92b$export$b0e4aff419ae4233(generateConfig, pickerMode, maxDate, -1) : maxDate;
                    setCurrentPickerValue(nextPickerValue, 'reset');
                }
            }
        }
    }, [
        open,
        mergedActiveIndex,
        calendarValue[mergedActiveIndex]
    ]);
    // >>> Reset prevActiveIndex when panel closed
    $ltGt3.useEffect(function() {
        if (open) prevActiveIndexRef.current = mergedActiveIndex;
        else prevActiveIndexRef.current = null;
    }, [
        open,
        mergedActiveIndex
    ]);
    // >>> defaultPickerValue: Resync to `defaultPickerValue` for each panel focused
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(function() {
        if (open && defaultPickerValue) {
            if (defaultPickerValue[mergedActiveIndex]) setCurrentPickerValue(defaultPickerValue[mergedActiveIndex], 'reset');
        }
    }, [
        open,
        mergedActiveIndex
    ]);
    return [
        currentPickerValue,
        setCurrentPickerValue
    ];
}




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
function $e49fe3d55faa4d8f$var$_slicedToArray(arr, i) {
    return $e49fe3d55faa4d8f$var$_arrayWithHoles(arr) || $e49fe3d55faa4d8f$var$_iterableToArrayLimit(arr, i) || $e49fe3d55faa4d8f$var$_unsupportedIterableToArray(arr, i) || $e49fe3d55faa4d8f$var$_nonIterableRest();
}
function $e49fe3d55faa4d8f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e49fe3d55faa4d8f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e49fe3d55faa4d8f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e49fe3d55faa4d8f$var$_arrayLikeToArray(o, minLen);
}
function $e49fe3d55faa4d8f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e49fe3d55faa4d8f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e49fe3d55faa4d8f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e49fe3d55faa4d8f$export$2e2bcd8739ae039(defaultValue, controlledValue) {
    var valueRef = $ltGt3.useRef(defaultValue);
    var _React$useState = $ltGt3.useState({}), _React$useState2 = $e49fe3d55faa4d8f$var$_slicedToArray(_React$useState, 2), forceUpdate = _React$useState2[1];
    var getter = function getter(useControlledValueFirst) {
        return useControlledValueFirst && controlledValue !== undefined ? controlledValue : valueRef.current;
    };
    var setter = function setter(nextValue) {
        valueRef.current = nextValue;
        forceUpdate({});
    };
    return [
        getter,
        setter,
        getter(true)
    ];
}





function $e51efeefa4dc71b9$var$_slicedToArray(arr, i) {
    return $e51efeefa4dc71b9$var$_arrayWithHoles(arr) || $e51efeefa4dc71b9$var$_iterableToArrayLimit(arr, i) || $e51efeefa4dc71b9$var$_unsupportedIterableToArray(arr, i) || $e51efeefa4dc71b9$var$_nonIterableRest();
}
function $e51efeefa4dc71b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e51efeefa4dc71b9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e51efeefa4dc71b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e51efeefa4dc71b9$var$_toConsumableArray(arr) {
    return $e51efeefa4dc71b9$var$_arrayWithoutHoles(arr) || $e51efeefa4dc71b9$var$_iterableToArray(arr) || $e51efeefa4dc71b9$var$_unsupportedIterableToArray(arr) || $e51efeefa4dc71b9$var$_nonIterableSpread();
}
function $e51efeefa4dc71b9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e51efeefa4dc71b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e51efeefa4dc71b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e51efeefa4dc71b9$var$_arrayLikeToArray(o, minLen);
}
function $e51efeefa4dc71b9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e51efeefa4dc71b9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e51efeefa4dc71b9$var$_arrayLikeToArray(arr);
}
function $e51efeefa4dc71b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $e51efeefa4dc71b9$var$EMPTY_VALUE = [];
// Submit Logic:
// * ✅ Value:
//    * merged value using controlled value, if not, use stateValue
//    * When merged value change, [1] resync calendar value and submit value
// * ✅ Calender Value:
//    * 💻 When user typing is validate, change the calendar value
//    * 🌅 When user click on the panel, change the calendar value
// * Submit Value:
//    * 💻 When user blur the input, flush calendar value to submit value
//    * 🌅 When user click on the panel is no needConfirm, flush calendar value to submit value
//    * 🌅 When user click on the panel is needConfirm and click OK, flush calendar value to submit value
// * Blur logic & close logic:
//    * ✅ For value, always try flush submit
//    * ✅ If `needConfirm`, reset as [1]
//    * Else (`!needConfirm`)
//      * If has another index field, active another index
// * ✅ Flush submit:
//    * If all the start & end field is confirmed or all blur or panel closed
//    * Update `needSubmit` mark to true
//    * trigger onChange by `needSubmit` and update stateValue
function $e51efeefa4dc71b9$var$useUtil(generateConfig, locale, formatList) {
    var getDateTexts = function getDateTexts(dates) {
        return dates.map(function(date) {
            return (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(date, {
                generateConfig: generateConfig,
                locale: locale,
                format: formatList[0]
            });
        });
    };
    var isSameDates = function isSameDates(source, target) {
        var maxLen = Math.max(source.length, target.length);
        var diffIndex = -1;
        for(var i = 0; i < maxLen; i += 1){
            var prev = source[i] || null;
            var next = target[i] || null;
            if (prev !== next && !(0, $f655def3c887f075$export$730a188731b5a146)(generateConfig, prev, next)) {
                diffIndex = i;
                break;
            }
        }
        return [
            diffIndex < 0,
            diffIndex !== 0
        ];
    };
    return [
        getDateTexts,
        isSameDates
    ];
}
function $e51efeefa4dc71b9$var$orderDates(dates, generateConfig) {
    return $e51efeefa4dc71b9$var$_toConsumableArray(dates).sort(function(a, b) {
        return generateConfig.isAfter(a, b) ? 1 : -1;
    });
}
/**
 * Used for internal value management.
 * It should always use `mergedValue` in render logic
 */ function $e51efeefa4dc71b9$var$useCalendarValue(mergedValue) {
    var _useSyncState = (0, $e49fe3d55faa4d8f$export$2e2bcd8739ae039)(mergedValue), _useSyncState2 = $e51efeefa4dc71b9$var$_slicedToArray(_useSyncState, 2), calendarValue = _useSyncState2[0], setCalendarValue = _useSyncState2[1];
    /** Sync calendarValue & submitValue back with value */ var syncWithValue = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function() {
        setCalendarValue(mergedValue);
    });
    $ltGt3.useEffect(function() {
        syncWithValue();
    }, [
        mergedValue
    ]);
    return [
        calendarValue,
        setCalendarValue
    ];
}
function $e51efeefa4dc71b9$export$eef0e5a163935805(generateConfig, locale, formatList, /** Used for RangePicker. `true` means [DateType, DateType] or will be DateType[] */ rangeValue, /**
 * Trigger order when trigger calendar value change.
 * This should only used in SinglePicker with `multiple` mode.
 * So when `rangeValue` is `true`, order will be ignored.
 */ order, defaultValue, value, onCalendarChange, onOk) {
    // This is the root value which will sync with controlled or uncontrolled value
    var _useControlledState = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultValue, value), _useControlledState2 = $e51efeefa4dc71b9$var$_slicedToArray(_useControlledState, 2), innerValue = _useControlledState2[0], setInnerValue = _useControlledState2[1];
    var mergedValue = innerValue || $e51efeefa4dc71b9$var$EMPTY_VALUE;
    // ========================= Inner Values =========================
    var _useCalendarValue = $e51efeefa4dc71b9$var$useCalendarValue(mergedValue), _useCalendarValue2 = $e51efeefa4dc71b9$var$_slicedToArray(_useCalendarValue, 2), calendarValue = _useCalendarValue2[0], setCalendarValue = _useCalendarValue2[1];
    // ============================ Change ============================
    var _useUtil = $e51efeefa4dc71b9$var$useUtil(generateConfig, locale, formatList), _useUtil2 = $e51efeefa4dc71b9$var$_slicedToArray(_useUtil, 2), getDateTexts = _useUtil2[0], isSameDates = _useUtil2[1];
    var triggerCalendarChange = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(nextCalendarValues) {
        var clone = $e51efeefa4dc71b9$var$_toConsumableArray(nextCalendarValues);
        if (rangeValue) for(var i = 0; i < 2; i += 1)clone[i] = clone[i] || null;
        else if (order) clone = $e51efeefa4dc71b9$var$orderDates(clone.filter(function(date) {
            return date;
        }), generateConfig);
        // Update merged value
        var _isSameDates = isSameDates(calendarValue(), clone), _isSameDates2 = $e51efeefa4dc71b9$var$_slicedToArray(_isSameDates, 2), isSameMergedDates = _isSameDates2[0], isSameStart = _isSameDates2[1];
        if (!isSameMergedDates) {
            setCalendarValue(clone);
            // Trigger calendar change event
            if (onCalendarChange) {
                var cellTexts = getDateTexts(clone);
                onCalendarChange(clone, cellTexts, {
                    range: isSameStart ? 'end' : 'start'
                });
            }
        }
    });
    var triggerOk = function triggerOk() {
        if (onOk) onOk(calendarValue());
    };
    return [
        mergedValue,
        setInnerValue,
        calendarValue,
        triggerCalendarChange,
        triggerOk
    ];
}
function $e51efeefa4dc71b9$export$2e2bcd8739ae039(info, mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, disabled, formatList, focused, open, isInvalidateDate) {
    var generateConfig = info.generateConfig, locale = info.locale, picker = info.picker, onChange = info.onChange, allowEmpty = info.allowEmpty, order = info.order;
    var orderOnChange = disabled.some(function(d) {
        return d;
    }) ? false : order;
    // ============================= Util =============================
    var _useUtil3 = $e51efeefa4dc71b9$var$useUtil(generateConfig, locale, formatList), _useUtil4 = $e51efeefa4dc71b9$var$_slicedToArray(_useUtil3, 2), getDateTexts = _useUtil4[0], isSameDates = _useUtil4[1];
    // ============================ Values ============================
    // Used for trigger `onChange` event.
    // Record current value which is wait for submit.
    var _useSyncState3 = (0, $e49fe3d55faa4d8f$export$2e2bcd8739ae039)(mergedValue), _useSyncState4 = $e51efeefa4dc71b9$var$_slicedToArray(_useSyncState3, 2), submitValue = _useSyncState4[0], setSubmitValue = _useSyncState4[1];
    /** Sync calendarValue & submitValue back with value */ var syncWithValue = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function() {
        setSubmitValue(mergedValue);
    });
    $ltGt3.useEffect(function() {
        syncWithValue();
    }, [
        mergedValue
    ]);
    // ============================ Submit ============================
    var triggerSubmit = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(nextValue) {
        var isNullValue = nextValue === null;
        var clone = $e51efeefa4dc71b9$var$_toConsumableArray(nextValue || submitValue());
        // Fill null value
        if (isNullValue) {
            var maxLen = Math.max(disabled.length, clone.length);
            for(var i = 0; i < maxLen; i += 1)if (!disabled[i]) clone[i] = null;
        }
        // Only when exist value to sort
        if (orderOnChange && clone[0] && clone[1]) clone = $e51efeefa4dc71b9$var$orderDates(clone, generateConfig);
        // Sync `calendarValue`
        triggerCalendarChange(clone);
        // ========= Validate check =========
        var _clone = clone, _clone2 = $e51efeefa4dc71b9$var$_slicedToArray(_clone, 2), start = _clone2[0], end = _clone2[1];
        // >>> Empty
        var startEmpty = !start;
        var endEmpty = !end;
        var validateEmptyDateRange = allowEmpty ? // Validate empty start
        (!startEmpty || allowEmpty[0]) && // Validate empty end
        (!endEmpty || allowEmpty[1]) : true;
        // >>> Order
        var validateOrder = !order || startEmpty || endEmpty || (0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, start, end, picker) || generateConfig.isAfter(end, start);
        // >>> Invalid
        var validateDates = // Validate start
        (disabled[0] || !start || !isInvalidateDate(start, {
            activeIndex: 0
        })) && // Validate end
        (disabled[1] || !end || !isInvalidateDate(end, {
            from: start,
            activeIndex: 1
        }));
        // >>> Result
        var allPassed = // Null value is from clear button
        isNullValue || // Normal check
        validateEmptyDateRange && validateOrder && validateDates;
        if (allPassed) {
            // Sync value with submit value
            setInnerValue(clone);
            var _isSameDates3 = isSameDates(clone, mergedValue), _isSameDates4 = $e51efeefa4dc71b9$var$_slicedToArray(_isSameDates3, 1), isSameMergedDates = _isSameDates4[0];
            // Trigger `onChange` if needed
            if (onChange && !isSameMergedDates) {
                var everyEmpty = clone.every(function(val) {
                    return !val;
                });
                onChange(// Return null directly if all date are empty
                isNullValue && everyEmpty ? null : clone, everyEmpty ? null : getDateTexts(clone));
            }
        }
        return allPassed;
    });
    // ========================= Flush Submit =========================
    var flushSubmit = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(index, needTriggerChange) {
        var nextSubmitValue = (0, $4eaa081548444891$export$4284846c29a21d02)(submitValue(), index, getCalendarValue()[index]);
        setSubmitValue(nextSubmitValue);
        if (needTriggerChange) triggerSubmit();
    });
    // ============================ Effect ============================
    // All finished action trigger after 2 frames
    var interactiveFinished = !focused && !open;
    (0, $5282d4a7d1ae4971$export$2e2bcd8739ae039)(!interactiveFinished, function() {
        if (interactiveFinished) {
            // Always try to trigger submit first
            triggerSubmit();
            // Trigger calendar change since this is a effect reset
            // https://github.com/ant-design/ant-design/issues/22351
            triggerCalendarChange(mergedValue);
            // Sync with value anyway
            syncWithValue();
        }
    }, 2);
    // ============================ Return ============================
    return [
        flushSubmit,
        triggerSubmit
    ];
}


function $f404cb186cc1602e$export$2e2bcd8739ae039(picker, mode, showNow, showToday, rangePicker) {
    if (mode !== 'date' && mode !== 'time') return false;
    if (showNow !== undefined) return showNow;
    // Compatible with old version `showToday`
    if (showToday !== undefined) return showToday;
    return !rangePicker && (picker === 'date' || picker === 'time');
}





var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
function $c13fdb5f31ec0cf0$var$_toConsumableArray(arr) {
    return $c13fdb5f31ec0cf0$var$_arrayWithoutHoles(arr) || $c13fdb5f31ec0cf0$var$_iterableToArray(arr) || $c13fdb5f31ec0cf0$var$_unsupportedIterableToArray(arr) || $c13fdb5f31ec0cf0$var$_nonIterableSpread();
}
function $c13fdb5f31ec0cf0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c13fdb5f31ec0cf0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c13fdb5f31ec0cf0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c13fdb5f31ec0cf0$var$_arrayLikeToArray(o, minLen);
}
function $c13fdb5f31ec0cf0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c13fdb5f31ec0cf0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c13fdb5f31ec0cf0$var$_arrayLikeToArray(arr);
}
function $c13fdb5f31ec0cf0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c13fdb5f31ec0cf0$export$fda2dbcfb6a1d654(date, getHourUnits, getMinuteUnits, getSecondUnits, getMillisecondUnits, generateConfig) {
    var nextDate = date;
    function alignValidate(getUnitValue, setUnitValue, units) {
        var nextValue = generateConfig[getUnitValue](nextDate);
        var nextUnit = units.find(function(unit) {
            return unit.value === nextValue;
        });
        if (!nextUnit || nextUnit.disabled) {
            // Find most closest unit
            var validateUnits = units.filter(function(unit) {
                return !unit.disabled;
            });
            var reverseEnabledUnits = $c13fdb5f31ec0cf0$var$_toConsumableArray(validateUnits).reverse();
            var validateUnit = reverseEnabledUnits.find(function(unit) {
                return unit.value <= nextValue;
            }) || validateUnits[0];
            if (validateUnit) {
                nextValue = validateUnit.value;
                nextDate = generateConfig[setUnitValue](nextDate, nextValue);
            }
        }
        return nextValue;
    }
    // Find validate hour
    var nextHour = alignValidate('getHour', 'setHour', getHourUnits());
    // Find validate minute
    var nextMinute = alignValidate('getMinute', 'setMinute', getMinuteUnits(nextHour));
    // Find validate second
    var nextSecond = alignValidate('getSecond', 'setSecond', getSecondUnits(nextHour, nextMinute));
    // Find validate millisecond
    alignValidate('getMillisecond', 'setMillisecond', getMillisecondUnits(nextHour, nextMinute, nextSecond));
    return nextDate;
}



function $2a8c5b6c5644a15c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2a8c5b6c5644a15c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2a8c5b6c5644a15c$var$_typeof(o);
}
function $2a8c5b6c5644a15c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a8c5b6c5644a15c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a8c5b6c5644a15c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2a8c5b6c5644a15c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a8c5b6c5644a15c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2a8c5b6c5644a15c$var$_defineProperty(obj, key, value) {
    key = $2a8c5b6c5644a15c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a8c5b6c5644a15c$var$_toPropertyKey(t) {
    var i = $2a8c5b6c5644a15c$var$_toPrimitive(t, "string");
    return "symbol" == $2a8c5b6c5644a15c$var$_typeof(i) ? i : String(i);
}
function $2a8c5b6c5644a15c$var$_toPrimitive(t, r) {
    if ("object" != $2a8c5b6c5644a15c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2a8c5b6c5644a15c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2a8c5b6c5644a15c$var$_slicedToArray(arr, i) {
    return $2a8c5b6c5644a15c$var$_arrayWithHoles(arr) || $2a8c5b6c5644a15c$var$_iterableToArrayLimit(arr, i) || $2a8c5b6c5644a15c$var$_unsupportedIterableToArray(arr, i) || $2a8c5b6c5644a15c$var$_nonIterableRest();
}
function $2a8c5b6c5644a15c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2a8c5b6c5644a15c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2a8c5b6c5644a15c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2a8c5b6c5644a15c$var$_arrayLikeToArray(o, minLen);
}
function $2a8c5b6c5644a15c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2a8c5b6c5644a15c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2a8c5b6c5644a15c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2a8c5b6c5644a15c$var$emptyDisabled() {
    return [];
}
function $2a8c5b6c5644a15c$var$generateUnits(start, end) {
    var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var hideDisabledOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var disabledUnits = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var pad = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2;
    var units = [];
    var integerStep = step >= 1 ? step | 0 : 1;
    for(var i = start; i <= end; i += integerStep){
        var disabled = disabledUnits.includes(i);
        if (!disabled || !hideDisabledOptions) units.push({
            label: (0, $4eaa081548444891$export$cbb503201166aab7)(i, pad),
            value: i,
            disabled: disabled
        });
    }
    return units;
}
function $2a8c5b6c5644a15c$export$2e2bcd8739ae039(generateConfig) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var date = arguments.length > 2 ? arguments[2] : undefined;
    var _ref = props || {}, use12Hours = _ref.use12Hours, _ref$hourStep = _ref.hourStep, hourStep = _ref$hourStep === void 0 ? 1 : _ref$hourStep, _ref$minuteStep = _ref.minuteStep, minuteStep = _ref$minuteStep === void 0 ? 1 : _ref$minuteStep, _ref$secondStep = _ref.secondStep, secondStep = _ref$secondStep === void 0 ? 1 : _ref$secondStep, _ref$millisecondStep = _ref.millisecondStep, millisecondStep = _ref$millisecondStep === void 0 ? 100 : _ref$millisecondStep, hideDisabledOptions = _ref.hideDisabledOptions, disabledTime = _ref.disabledTime, disabledHours = _ref.disabledHours, disabledMinutes = _ref.disabledMinutes, disabledSeconds = _ref.disabledSeconds;
    var mergedDate = $ltGt3.useMemo(function() {
        return date || generateConfig.getNow();
    }, [
        date,
        generateConfig
    ]);
    var isHourStepValid, isMinuteStepValid, isSecondStepValid;
    // ======================== Disabled ========================
    var getDisabledTimes = $ltGt3.useCallback(function(targetDate) {
        var disabledConfig = (disabledTime === null || disabledTime === void 0 ? void 0 : disabledTime(targetDate)) || {};
        return [
            disabledConfig.disabledHours || disabledHours || $2a8c5b6c5644a15c$var$emptyDisabled,
            disabledConfig.disabledMinutes || disabledMinutes || $2a8c5b6c5644a15c$var$emptyDisabled,
            disabledConfig.disabledSeconds || disabledSeconds || $2a8c5b6c5644a15c$var$emptyDisabled,
            disabledConfig.disabledMilliseconds || $2a8c5b6c5644a15c$var$emptyDisabled
        ];
    }, [
        disabledTime,
        disabledHours,
        disabledMinutes,
        disabledSeconds
    ]);
    var _React$useMemo = $ltGt3.useMemo(function() {
        return getDisabledTimes(mergedDate);
    }, [
        mergedDate,
        getDisabledTimes
    ]), _React$useMemo2 = $2a8c5b6c5644a15c$var$_slicedToArray(_React$useMemo, 4), mergedDisabledHours = _React$useMemo2[0], mergedDisabledMinutes = _React$useMemo2[1], mergedDisabledSeconds = _React$useMemo2[2], mergedDisabledMilliseconds = _React$useMemo2[3];
    // ========================= Column =========================
    var getAllUnits = $ltGt3.useCallback(function(getDisabledHours, getDisabledMinutes, getDisabledSeconds, getDisabledMilliseconds) {
        var hours = $2a8c5b6c5644a15c$var$generateUnits(0, 23, hourStep, hideDisabledOptions, getDisabledHours());
        // Hours
        var rowHourUnits = use12Hours ? hours.map(function(unit) {
            return $2a8c5b6c5644a15c$var$_objectSpread($2a8c5b6c5644a15c$var$_objectSpread({}, unit), {}, {
                label: (0, $4eaa081548444891$export$cbb503201166aab7)(unit.value % 12 || 12, 2)
            });
        }) : hours;
        // Minutes
        var getMinuteUnits = function getMinuteUnits(nextHour) {
            return $2a8c5b6c5644a15c$var$generateUnits(0, 59, minuteStep, hideDisabledOptions, getDisabledMinutes(nextHour));
        };
        // Seconds
        var getSecondUnits = function getSecondUnits(nextHour, nextMinute) {
            return $2a8c5b6c5644a15c$var$generateUnits(0, 59, secondStep, hideDisabledOptions, getDisabledSeconds(nextHour, nextMinute));
        };
        // Milliseconds
        var getMillisecondUnits = function getMillisecondUnits(nextHour, nextMinute, nextSecond) {
            return $2a8c5b6c5644a15c$var$generateUnits(0, 999, millisecondStep, hideDisabledOptions, getDisabledMilliseconds(nextHour, nextMinute, nextSecond), 3);
        };
        return [
            rowHourUnits,
            getMinuteUnits,
            getSecondUnits,
            getMillisecondUnits
        ];
    }, [
        hideDisabledOptions,
        hourStep,
        use12Hours,
        millisecondStep,
        minuteStep,
        secondStep
    ]);
    var _React$useMemo3 = $ltGt3.useMemo(function() {
        return getAllUnits(mergedDisabledHours, mergedDisabledMinutes, mergedDisabledSeconds, mergedDisabledMilliseconds);
    }, [
        getAllUnits,
        mergedDisabledHours,
        mergedDisabledMinutes,
        mergedDisabledSeconds,
        mergedDisabledMilliseconds
    ]), _React$useMemo4 = $2a8c5b6c5644a15c$var$_slicedToArray(_React$useMemo3, 4), rowHourUnits = _React$useMemo4[0], getMinuteUnits = _React$useMemo4[1], getSecondUnits = _React$useMemo4[2], getMillisecondUnits = _React$useMemo4[3];
    // ======================== Validate ========================
    /**
   * Get validate time with `disabledTime`, `certainDate` to specific the date need to check
   */ var getValidTime = function getValidTime(nextTime, certainDate) {
        var getCheckHourUnits = function getCheckHourUnits() {
            return rowHourUnits;
        };
        var getCheckMinuteUnits = getMinuteUnits;
        var getCheckSecondUnits = getSecondUnits;
        var getCheckMillisecondUnits = getMillisecondUnits;
        if (certainDate) {
            var _getDisabledTimes = getDisabledTimes(certainDate), _getDisabledTimes2 = $2a8c5b6c5644a15c$var$_slicedToArray(_getDisabledTimes, 4), targetDisabledHours = _getDisabledTimes2[0], targetDisabledMinutes = _getDisabledTimes2[1], targetDisabledSeconds = _getDisabledTimes2[2], targetDisabledMilliseconds = _getDisabledTimes2[3];
            var _getAllUnits = getAllUnits(targetDisabledHours, targetDisabledMinutes, targetDisabledSeconds, targetDisabledMilliseconds), _getAllUnits2 = $2a8c5b6c5644a15c$var$_slicedToArray(_getAllUnits, 4), targetRowHourUnits = _getAllUnits2[0], targetGetMinuteUnits = _getAllUnits2[1], targetGetSecondUnits = _getAllUnits2[2], targetGetMillisecondUnits = _getAllUnits2[3];
            getCheckHourUnits = function getCheckHourUnits() {
                return targetRowHourUnits;
            };
            getCheckMinuteUnits = targetGetMinuteUnits;
            getCheckSecondUnits = targetGetSecondUnits;
            getCheckMillisecondUnits = targetGetMillisecondUnits;
        }
        var validateDate = (0, $c13fdb5f31ec0cf0$export$fda2dbcfb6a1d654)(nextTime, getCheckHourUnits, getCheckMinuteUnits, getCheckSecondUnits, getCheckMillisecondUnits, generateConfig);
        return validateDate;
    };
    return [
        // getValidTime
        getValidTime,
        // Units
        rowHourUnits,
        getMinuteUnits,
        getSecondUnits,
        getMillisecondUnits
    ];
}



function $f4794cf85a0d1f9d$var$_slicedToArray(arr, i) {
    return $f4794cf85a0d1f9d$var$_arrayWithHoles(arr) || $f4794cf85a0d1f9d$var$_iterableToArrayLimit(arr, i) || $f4794cf85a0d1f9d$var$_unsupportedIterableToArray(arr, i) || $f4794cf85a0d1f9d$var$_nonIterableRest();
}
function $f4794cf85a0d1f9d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f4794cf85a0d1f9d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f4794cf85a0d1f9d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f4794cf85a0d1f9d$var$_arrayLikeToArray(o, minLen);
}
function $f4794cf85a0d1f9d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f4794cf85a0d1f9d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f4794cf85a0d1f9d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f4794cf85a0d1f9d$export$2e2bcd8739ae039(props) {
    var mode = props.mode, internalMode = props.internalMode, renderExtraFooter = props.renderExtraFooter, showNow = props.showNow, showTime = props.showTime, onSubmit = props.onSubmit, onNow = props.onNow, invalid = props.invalid, needConfirm = props.needConfirm, generateConfig = props.generateConfig, disabledDate = props.disabledDate;
    var _React$useContext = $ltGt3.useContext((0, $6158ac241550cb6d$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, locale = _React$useContext.locale, _React$useContext$but = _React$useContext.button, Button = _React$useContext$but === void 0 ? 'button' : _React$useContext$but, classNames = _React$useContext.classNames, styles = _React$useContext.styles;
    // >>> Now
    var now = generateConfig.getNow();
    var _useTimeInfo = (0, $2a8c5b6c5644a15c$export$2e2bcd8739ae039)(generateConfig, showTime, now), _useTimeInfo2 = $f4794cf85a0d1f9d$var$_slicedToArray(_useTimeInfo, 1), getValidTime = _useTimeInfo2[0];
    // ======================== Extra =========================
    var extraNode = renderExtraFooter === null || renderExtraFooter === void 0 ? void 0 : renderExtraFooter(mode);
    // ======================== Ranges ========================
    var nowDisabled = disabledDate(now, {
        type: mode
    });
    var onInternalNow = function onInternalNow() {
        if (!nowDisabled) {
            var validateNow = getValidTime(now);
            onNow(validateNow);
        }
    };
    var nowPrefixCls = "".concat(prefixCls, "-now");
    var nowBtnPrefixCls = "".concat(nowPrefixCls, "-btn");
    var presetNode = showNow && /*#__PURE__*/ $ltGt3.createElement("li", {
        className: nowPrefixCls
    }, /*#__PURE__*/ $ltGt3.createElement("a", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(nowBtnPrefixCls, nowDisabled && "".concat(nowBtnPrefixCls, "-disabled")),
        "aria-disabled": nowDisabled,
        onClick: onInternalNow
    }, internalMode === 'date' ? locale.today : locale.now));
    // >>> OK
    var okNode = needConfirm && /*#__PURE__*/ $ltGt3.createElement("li", {
        className: "".concat(prefixCls, "-ok")
    }, /*#__PURE__*/ $ltGt3.createElement(Button, {
        disabled: invalid,
        onClick: onSubmit
    }, locale.ok));
    var rangeNode = (presetNode || okNode) && /*#__PURE__*/ $ltGt3.createElement("ul", {
        className: "".concat(prefixCls, "-ranges")
    }, presetNode, okNode);
    // ======================== Render ========================
    if (!extraNode && !rangeNode) return null;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)("".concat(prefixCls, "-footer"), classNames.popup.footer),
        style: styles.popup.footer
    }, extraNode && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra")
    }, extraNode), rangeNode);
}



var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");



function $12b886ce4241df5e$var$_toConsumableArray(arr) {
    return $12b886ce4241df5e$var$_arrayWithoutHoles(arr) || $12b886ce4241df5e$var$_iterableToArray(arr) || $12b886ce4241df5e$var$_unsupportedIterableToArray(arr) || $12b886ce4241df5e$var$_nonIterableSpread();
}
function $12b886ce4241df5e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $12b886ce4241df5e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $12b886ce4241df5e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $12b886ce4241df5e$var$_arrayLikeToArray(o, minLen);
}
function $12b886ce4241df5e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $12b886ce4241df5e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $12b886ce4241df5e$var$_arrayLikeToArray(arr);
}
function $12b886ce4241df5e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $12b886ce4241df5e$export$2e2bcd8739ae039(generateConfig, locale, panelMode) {
    function toggleDates(list, target) {
        var index = list.findIndex(function(date) {
            return (0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, date, target, panelMode);
        });
        if (index === -1) return [].concat($12b886ce4241df5e$var$_toConsumableArray(list), [
            target
        ]);
        var sliceList = $12b886ce4241df5e$var$_toConsumableArray(list);
        sliceList.splice(index, 1);
        return sliceList;
    }
    return toggleDates;
}







var $ltGt3 = parcelRequire("ltGt3");
var $5925c1ba9cf7332a$export$d1173f47489c79e4 = /*#__PURE__*/ $ltGt3.createContext(null);
var $5925c1ba9cf7332a$export$f34532ac99e32150 = /*#__PURE__*/ $ltGt3.createContext(null);
function $5925c1ba9cf7332a$export$2fe6b5e489926495() {
    return $ltGt3.useContext($5925c1ba9cf7332a$export$f34532ac99e32150);
}
function $5925c1ba9cf7332a$export$2ae76d51704c9302(props, panelType) {
    // TODO: this is not good to get from each props.
    // Should move to `SharedPanelContext` instead.
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, disabledDate = props.disabledDate, minDate = props.minDate, maxDate = props.maxDate, cellRender = props.cellRender, hoverValue = props.hoverValue, hoverRangeValue = props.hoverRangeValue, onHover = props.onHover, values = props.values, pickerValue = props.pickerValue, onSelect = props.onSelect, prevIcon = props.prevIcon, nextIcon = props.nextIcon, superPrevIcon = props.superPrevIcon, superNextIcon = props.superNextIcon;
    // ======================= Context ========================
    var _React$useContext = $ltGt3.useContext($5925c1ba9cf7332a$export$d1173f47489c79e4), classNames = _React$useContext.classNames, styles = _React$useContext.styles;
    // ========================= MISC =========================
    var now = generateConfig.getNow();
    // ========================= Info =========================
    var info = {
        now: now,
        values: values,
        pickerValue: pickerValue,
        prefixCls: prefixCls,
        classNames: classNames,
        styles: styles,
        disabledDate: disabledDate,
        minDate: minDate,
        maxDate: maxDate,
        cellRender: cellRender,
        hoverValue: hoverValue,
        hoverRangeValue: hoverRangeValue,
        onHover: onHover,
        locale: locale,
        generateConfig: generateConfig,
        onSelect: onSelect,
        panelType: panelType,
        // Icons
        prevIcon: prevIcon,
        nextIcon: nextIcon,
        superPrevIcon: superPrevIcon,
        superNextIcon: superNextIcon
    };
    return [
        info,
        now
    ];
}
var $5925c1ba9cf7332a$export$c3f9070e5d88313b = /*#__PURE__*/ $ltGt3.createContext({});




var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");


function $3ac1346aa446b916$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3ac1346aa446b916$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3ac1346aa446b916$var$_typeof(o);
}
function $3ac1346aa446b916$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3ac1346aa446b916$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3ac1346aa446b916$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3ac1346aa446b916$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3ac1346aa446b916$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3ac1346aa446b916$var$_defineProperty(obj, key, value) {
    key = $3ac1346aa446b916$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3ac1346aa446b916$var$_toPropertyKey(t) {
    var i = $3ac1346aa446b916$var$_toPrimitive(t, "string");
    return "symbol" == $3ac1346aa446b916$var$_typeof(i) ? i : String(i);
}
function $3ac1346aa446b916$var$_toPrimitive(t, r) {
    if ("object" != $3ac1346aa446b916$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3ac1346aa446b916$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3ac1346aa446b916$var$_slicedToArray(arr, i) {
    return $3ac1346aa446b916$var$_arrayWithHoles(arr) || $3ac1346aa446b916$var$_iterableToArrayLimit(arr, i) || $3ac1346aa446b916$var$_unsupportedIterableToArray(arr, i) || $3ac1346aa446b916$var$_nonIterableRest();
}
function $3ac1346aa446b916$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3ac1346aa446b916$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3ac1346aa446b916$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3ac1346aa446b916$var$_arrayLikeToArray(o, minLen);
}
function $3ac1346aa446b916$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3ac1346aa446b916$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3ac1346aa446b916$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3ac1346aa446b916$export$2e2bcd8739ae039(props) {
    var rowNum = props.rowNum, colNum = props.colNum, baseDate = props.baseDate, getCellDate = props.getCellDate, prefixColumn = props.prefixColumn, rowClassName = props.rowClassName, titleFormat = props.titleFormat, getCellText = props.getCellText, getCellClassName = props.getCellClassName, headerCells = props.headerCells, _props$cellSelection = props.cellSelection, cellSelection = _props$cellSelection === void 0 ? true : _props$cellSelection, disabledDate = props.disabledDate;
    var _usePanelContext = (0, $5925c1ba9cf7332a$export$2fe6b5e489926495)(), prefixCls = _usePanelContext.prefixCls, classNames = _usePanelContext.classNames, styles = _usePanelContext.styles, type = _usePanelContext.panelType, now = _usePanelContext.now, contextDisabledDate = _usePanelContext.disabledDate, cellRender = _usePanelContext.cellRender, onHover = _usePanelContext.onHover, hoverValue = _usePanelContext.hoverValue, hoverRangeValue = _usePanelContext.hoverRangeValue, generateConfig = _usePanelContext.generateConfig, values = _usePanelContext.values, locale = _usePanelContext.locale, onSelect = _usePanelContext.onSelect;
    var mergedDisabledDate = disabledDate || contextDisabledDate;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    // ============================= Context ==============================
    var _React$useContext = $ltGt3.useContext((0, $5925c1ba9cf7332a$export$c3f9070e5d88313b)), onCellDblClick = _React$useContext.onCellDblClick;
    // ============================== Value ===============================
    var matchValues = function matchValues(date) {
        return values.some(function(singleValue) {
            return singleValue && (0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, date, singleValue, type);
        });
    };
    // =============================== Body ===============================
    var rows = [];
    for(var row = 0; row < rowNum; row += 1){
        var rowNode = [];
        var rowStartDate = void 0;
        var _loop = function _loop() {
            var offset = row * colNum + col;
            var currentDate = getCellDate(baseDate, offset);
            var disabled = mergedDisabledDate === null || mergedDisabledDate === void 0 ? void 0 : mergedDisabledDate(currentDate, {
                type: type
            });
            // Row Start Cell
            if (col === 0) {
                rowStartDate = currentDate;
                if (prefixColumn) rowNode.push(prefixColumn(rowStartDate));
            }
            // Range
            var inRange = false;
            var rangeStart = false;
            var rangeEnd = false;
            if (cellSelection && hoverRangeValue) {
                var _hoverRangeValue = $3ac1346aa446b916$var$_slicedToArray(hoverRangeValue, 2), hoverStart = _hoverRangeValue[0], hoverEnd = _hoverRangeValue[1];
                inRange = (0, $f655def3c887f075$export$6dabbcb26357acf4)(generateConfig, hoverStart, hoverEnd, currentDate);
                rangeStart = (0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, currentDate, hoverStart, type);
                rangeEnd = (0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, currentDate, hoverEnd, type);
            }
            // Title
            var title = titleFormat ? (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(currentDate, {
                locale: locale,
                format: titleFormat,
                generateConfig: generateConfig
            }) : undefined;
            // Render
            var inner = /*#__PURE__*/ $ltGt3.createElement("div", {
                className: "".concat(cellPrefixCls, "-inner")
            }, getCellText(currentDate));
            rowNode.push(/*#__PURE__*/ $ltGt3.createElement("td", {
                key: col,
                title: title,
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(cellPrefixCls, classNames.item, $3ac1346aa446b916$var$_objectSpread($3ac1346aa446b916$var$_defineProperty($3ac1346aa446b916$var$_defineProperty($3ac1346aa446b916$var$_defineProperty($3ac1346aa446b916$var$_defineProperty($3ac1346aa446b916$var$_defineProperty($3ac1346aa446b916$var$_defineProperty({}, "".concat(cellPrefixCls, "-disabled"), disabled), "".concat(cellPrefixCls, "-hover"), (hoverValue || []).some(function(date) {
                    return (0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, currentDate, date, type);
                })), "".concat(cellPrefixCls, "-in-range"), inRange && !rangeStart && !rangeEnd), "".concat(cellPrefixCls, "-range-start"), rangeStart), "".concat(cellPrefixCls, "-range-end"), rangeEnd), "".concat(prefixCls, "-cell-selected"), !hoverRangeValue && // WeekPicker use row instead
                type !== 'week' && matchValues(currentDate)), getCellClassName(currentDate))),
                style: styles.item,
                onClick: function onClick() {
                    if (!disabled) onSelect(currentDate);
                },
                onDoubleClick: function onDoubleClick() {
                    if (!disabled && onCellDblClick) onCellDblClick();
                },
                onMouseEnter: function onMouseEnter() {
                    if (!disabled) onHover === null || onHover === void 0 || onHover(currentDate);
                },
                onMouseLeave: function onMouseLeave() {
                    if (!disabled) onHover === null || onHover === void 0 || onHover(null);
                }
            }, cellRender ? cellRender(currentDate, {
                prefixCls: prefixCls,
                originNode: inner,
                today: now,
                type: type,
                locale: locale
            }) : inner));
        };
        for(var col = 0; col < colNum; col += 1)_loop();
        rows.push(/*#__PURE__*/ $ltGt3.createElement("tr", {
            key: row,
            className: rowClassName === null || rowClassName === void 0 ? void 0 : rowClassName(rowStartDate)
        }, rowNode));
    }
    // ============================== Render ==============================
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)("".concat(prefixCls, "-body"), classNames.body),
        style: styles.body
    }, /*#__PURE__*/ $ltGt3.createElement("table", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)("".concat(prefixCls, "-content"), classNames.content),
        style: styles.content
    }, headerCells && /*#__PURE__*/ $ltGt3.createElement("thead", null, /*#__PURE__*/ $ltGt3.createElement("tr", null, headerCells)), /*#__PURE__*/ $ltGt3.createElement("tbody", null, rows)));
}




var $ltGt3 = parcelRequire("ltGt3");


var $08f158eee58ed6be$var$HIDDEN_STYLE = {
    visibility: 'hidden'
};
function $08f158eee58ed6be$var$PanelHeader(props) {
    var offset = props.offset, superOffset = props.superOffset, onChange = props.onChange, getStart = props.getStart, getEnd = props.getEnd, children = props.children;
    var _usePanelContext = (0, $5925c1ba9cf7332a$export$2fe6b5e489926495)(), prefixCls = _usePanelContext.prefixCls, classNames = _usePanelContext.classNames, styles = _usePanelContext.styles, _usePanelContext$prev = _usePanelContext.prevIcon, prevIcon = _usePanelContext$prev === void 0 ? "\u2039" : _usePanelContext$prev, _usePanelContext$next = _usePanelContext.nextIcon, nextIcon = _usePanelContext$next === void 0 ? "\u203A" : _usePanelContext$next, _usePanelContext$supe = _usePanelContext.superPrevIcon, superPrevIcon = _usePanelContext$supe === void 0 ? "\xAB" : _usePanelContext$supe, _usePanelContext$supe2 = _usePanelContext.superNextIcon, superNextIcon = _usePanelContext$supe2 === void 0 ? "\xBB" : _usePanelContext$supe2, minDate = _usePanelContext.minDate, maxDate = _usePanelContext.maxDate, generateConfig = _usePanelContext.generateConfig, locale = _usePanelContext.locale, pickerValue = _usePanelContext.pickerValue, type = _usePanelContext.panelType;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    var _React$useContext = $ltGt3.useContext((0, $5925c1ba9cf7332a$export$c3f9070e5d88313b)), hidePrev = _React$useContext.hidePrev, hideNext = _React$useContext.hideNext, hideHeader = _React$useContext.hideHeader;
    // ======================= Limitation =======================
    var disabledOffsetPrev = $ltGt3.useMemo(function() {
        if (!minDate || !offset || !getEnd) return false;
        var prevPanelLimitDate = getEnd(offset(-1, pickerValue));
        return !(0, $f655def3c887f075$export$a663815b3d4a2ed6)(generateConfig, locale, prevPanelLimitDate, minDate, type);
    }, [
        minDate,
        offset,
        pickerValue,
        getEnd,
        generateConfig,
        locale,
        type
    ]);
    var disabledSuperOffsetPrev = $ltGt3.useMemo(function() {
        if (!minDate || !superOffset || !getEnd) return false;
        var prevPanelLimitDate = getEnd(superOffset(-1, pickerValue));
        return !(0, $f655def3c887f075$export$a663815b3d4a2ed6)(generateConfig, locale, prevPanelLimitDate, minDate, type);
    }, [
        minDate,
        superOffset,
        pickerValue,
        getEnd,
        generateConfig,
        locale,
        type
    ]);
    var disabledOffsetNext = $ltGt3.useMemo(function() {
        if (!maxDate || !offset || !getStart) return false;
        var nextPanelLimitDate = getStart(offset(1, pickerValue));
        return !(0, $f655def3c887f075$export$a663815b3d4a2ed6)(generateConfig, locale, maxDate, nextPanelLimitDate, type);
    }, [
        maxDate,
        offset,
        pickerValue,
        getStart,
        generateConfig,
        locale,
        type
    ]);
    var disabledSuperOffsetNext = $ltGt3.useMemo(function() {
        if (!maxDate || !superOffset || !getStart) return false;
        var nextPanelLimitDate = getStart(superOffset(1, pickerValue));
        return !(0, $f655def3c887f075$export$a663815b3d4a2ed6)(generateConfig, locale, maxDate, nextPanelLimitDate, type);
    }, [
        maxDate,
        superOffset,
        pickerValue,
        getStart,
        generateConfig,
        locale,
        type
    ]);
    // ========================= Offset =========================
    var onOffset = function onOffset(distance) {
        if (offset) onChange(offset(distance, pickerValue));
    };
    var onSuperOffset = function onSuperOffset(distance) {
        if (superOffset) onChange(superOffset(distance, pickerValue));
    };
    // ========================= Render =========================
    if (hideHeader) return null;
    var prevBtnCls = "".concat(headerPrefixCls, "-prev-btn");
    var nextBtnCls = "".concat(headerPrefixCls, "-next-btn");
    var superPrevBtnCls = "".concat(headerPrefixCls, "-super-prev-btn");
    var superNextBtnCls = "".concat(headerPrefixCls, "-super-next-btn");
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(headerPrefixCls, classNames.header),
        style: styles.header
    }, superOffset && /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        "aria-label": locale.previousYear,
        onClick: function onClick() {
            return onSuperOffset(-1);
        },
        tabIndex: -1,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(superPrevBtnCls, disabledSuperOffsetPrev && "".concat(superPrevBtnCls, "-disabled")),
        disabled: disabledSuperOffsetPrev,
        style: hidePrev ? $08f158eee58ed6be$var$HIDDEN_STYLE : {}
    }, superPrevIcon), offset && /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        "aria-label": locale.previousMonth,
        onClick: function onClick() {
            return onOffset(-1);
        },
        tabIndex: -1,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prevBtnCls, disabledOffsetPrev && "".concat(prevBtnCls, "-disabled")),
        disabled: disabledOffsetPrev,
        style: hidePrev ? $08f158eee58ed6be$var$HIDDEN_STYLE : {}
    }, prevIcon), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: "".concat(headerPrefixCls, "-view")
    }, children), offset && /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        "aria-label": locale.nextMonth,
        onClick: function onClick() {
            return onOffset(1);
        },
        tabIndex: -1,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(nextBtnCls, disabledOffsetNext && "".concat(nextBtnCls, "-disabled")),
        disabled: disabledOffsetNext,
        style: hideNext ? $08f158eee58ed6be$var$HIDDEN_STYLE : {}
    }, nextIcon), superOffset && /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        "aria-label": locale.nextYear,
        onClick: function onClick() {
            return onSuperOffset(1);
        },
        tabIndex: -1,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(superNextBtnCls, disabledSuperOffsetNext && "".concat(superNextBtnCls, "-disabled")),
        disabled: disabledSuperOffsetNext,
        style: hideNext ? $08f158eee58ed6be$var$HIDDEN_STYLE : {}
    }, superNextIcon));
}
var $08f158eee58ed6be$export$2e2bcd8739ae039 = $08f158eee58ed6be$var$PanelHeader;


function $eec75e95fa043f08$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $eec75e95fa043f08$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $eec75e95fa043f08$var$_typeof(o);
}
function $eec75e95fa043f08$var$_extends() {
    $eec75e95fa043f08$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eec75e95fa043f08$var$_extends.apply(this, arguments);
}
function $eec75e95fa043f08$var$_defineProperty(obj, key, value) {
    key = $eec75e95fa043f08$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $eec75e95fa043f08$var$_toPropertyKey(t) {
    var i = $eec75e95fa043f08$var$_toPrimitive(t, "string");
    return "symbol" == $eec75e95fa043f08$var$_typeof(i) ? i : String(i);
}
function $eec75e95fa043f08$var$_toPrimitive(t, r) {
    if ("object" != $eec75e95fa043f08$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $eec75e95fa043f08$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $eec75e95fa043f08$var$_slicedToArray(arr, i) {
    return $eec75e95fa043f08$var$_arrayWithHoles(arr) || $eec75e95fa043f08$var$_iterableToArrayLimit(arr, i) || $eec75e95fa043f08$var$_unsupportedIterableToArray(arr, i) || $eec75e95fa043f08$var$_nonIterableRest();
}
function $eec75e95fa043f08$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $eec75e95fa043f08$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $eec75e95fa043f08$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $eec75e95fa043f08$var$_arrayLikeToArray(o, minLen);
}
function $eec75e95fa043f08$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $eec75e95fa043f08$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $eec75e95fa043f08$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $eec75e95fa043f08$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, _props$panelName = props.panelName, panelName = _props$panelName === void 0 ? 'date' : _props$panelName, locale = props.locale, generateConfig = props.generateConfig, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, onModeChange = props.onModeChange, _props$mode = props.mode, mode = _props$mode === void 0 ? 'date' : _props$mode, disabledDate = props.disabledDate, onSelect = props.onSelect, onHover = props.onHover, showWeek = props.showWeek;
    var panelPrefixCls = "".concat(prefixCls, "-").concat(panelName, "-panel");
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var isWeek = mode === 'week';
    // ========================== Base ==========================
    var _useInfo = (0, $5925c1ba9cf7332a$export$2ae76d51704c9302)(props, mode), _useInfo2 = $eec75e95fa043f08$var$_slicedToArray(_useInfo, 2), info = _useInfo2[0], now = _useInfo2[1];
    var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale.locale);
    var monthStartDate = generateConfig.setDate(pickerValue, 1);
    var baseDate = (0, $f655def3c887f075$export$e91829c600881133)(locale.locale, generateConfig, monthStartDate);
    var month = generateConfig.getMonth(pickerValue);
    // =========================== PrefixColumn ===========================
    var showPrefixColumn = showWeek === undefined ? isWeek : showWeek;
    var prefixColumn = showPrefixColumn ? function(date) {
        // >>> Additional check for disabled
        var disabled = disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date, {
            type: 'week'
        });
        return /*#__PURE__*/ $ltGt3.createElement("td", {
            key: "week",
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(cellPrefixCls, "".concat(cellPrefixCls, "-week"), $eec75e95fa043f08$var$_defineProperty({}, "".concat(cellPrefixCls, "-disabled"), disabled)),
            onClick: function onClick() {
                if (!disabled) onSelect(date);
            },
            onMouseEnter: function onMouseEnter() {
                if (!disabled) onHover === null || onHover === void 0 || onHover(date);
            },
            onMouseLeave: function onMouseLeave() {
                if (!disabled) onHover === null || onHover === void 0 || onHover(null);
            }
        }, /*#__PURE__*/ $ltGt3.createElement("div", {
            className: "".concat(cellPrefixCls, "-inner")
        }, generateConfig.locale.getWeek(locale.locale, date)));
    } : null;
    // ========================= Cells ==========================
    // >>> Header Cells
    var headerCells = [];
    var weekDaysLocale = locale.shortWeekDays || (generateConfig.locale.getShortWeekDays ? generateConfig.locale.getShortWeekDays(locale.locale) : []);
    if (prefixColumn) headerCells.push(/*#__PURE__*/ $ltGt3.createElement("th", {
        key: "empty"
    }, /*#__PURE__*/ $ltGt3.createElement("span", {
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        }
    }, locale.week)));
    for(var i = 0; i < (0, $f655def3c887f075$export$fe62c2dddb4d77ea); i += 1)headerCells.push(/*#__PURE__*/ $ltGt3.createElement("th", {
        key: i
    }, weekDaysLocale[(i + weekFirstDay) % (0, $f655def3c887f075$export$fe62c2dddb4d77ea)]));
    // >>> Body Cells
    var getCellDate = function getCellDate(date, offset) {
        return generateConfig.addDate(date, offset);
    };
    var getCellText = function getCellText(date) {
        return (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(date, {
            locale: locale,
            format: locale.cellDateFormat,
            generateConfig: generateConfig
        });
    };
    var getCellClassName = function getCellClassName(date) {
        var classObj = $eec75e95fa043f08$var$_defineProperty($eec75e95fa043f08$var$_defineProperty({}, "".concat(prefixCls, "-cell-in-view"), (0, $f655def3c887f075$export$a18c89cbd24170ff)(generateConfig, date, pickerValue)), "".concat(prefixCls, "-cell-today"), (0, $f655def3c887f075$export$a8b2a21161763694)(generateConfig, date, now));
        return classObj;
    };
    // ========================= Header =========================
    var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
    var yearNode = /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        "aria-label": locale.yearSelect,
        key: "year",
        onClick: function onClick() {
            onModeChange('year', pickerValue);
        },
        tabIndex: -1,
        className: "".concat(prefixCls, "-year-btn")
    }, (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(pickerValue, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    var monthNode = /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        "aria-label": locale.monthSelect,
        key: "month",
        onClick: function onClick() {
            onModeChange('month', pickerValue);
        },
        tabIndex: -1,
        className: "".concat(prefixCls, "-month-btn")
    }, locale.monthFormat ? (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(pickerValue, {
        locale: locale,
        format: locale.monthFormat,
        generateConfig: generateConfig
    }) : monthsLocale[month]);
    var monthYearNodes = locale.monthBeforeYear ? [
        monthNode,
        yearNode
    ] : [
        yearNode,
        monthNode
    ];
    // ========================= Render =========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $5925c1ba9cf7332a$export$f34532ac99e32150).Provider, {
        value: info
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(panelPrefixCls, showWeek && "".concat(panelPrefixCls, "-show-week"))
    }, /*#__PURE__*/ $ltGt3.createElement((0, $08f158eee58ed6be$export$2e2bcd8739ae039), {
        offset: function offset(distance) {
            return generateConfig.addMonth(pickerValue, distance);
        },
        superOffset: function superOffset(distance) {
            return generateConfig.addYear(pickerValue, distance);
        },
        onChange: onPickerValueChange,
        getStart: function getStart(date) {
            return generateConfig.setDate(date, 1);
        },
        getEnd: function getEnd(date) {
            var clone = generateConfig.setDate(date, 1);
            clone = generateConfig.addMonth(clone, 1);
            return generateConfig.addDate(clone, -1);
        }
    }, monthYearNodes), /*#__PURE__*/ $ltGt3.createElement((0, $3ac1346aa446b916$export$2e2bcd8739ae039), $eec75e95fa043f08$var$_extends({
        titleFormat: locale.fieldDateFormat
    }, props, {
        colNum: (0, $f655def3c887f075$export$fe62c2dddb4d77ea),
        rowNum: 6,
        baseDate: baseDate,
        headerCells: headerCells,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName,
        prefixColumn: prefixColumn,
        cellSelection: !isWeek
    }))));
}



var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");






var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");
var $b562207d730cae0a$var$SPEED_PTG = 1 / 3;
function $b562207d730cae0a$export$2e2bcd8739ae039(ulRef, value) {
    // ========================= Scroll =========================
    var scrollingRef = $ltGt3.useRef(false);
    var scrollRafRef = $ltGt3.useRef(null);
    var scrollDistRef = $ltGt3.useRef(null);
    var isScrolling = function isScrolling() {
        return scrollingRef.current;
    };
    var stopScroll = function stopScroll() {
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(scrollRafRef.current);
        scrollingRef.current = false;
    };
    var scrollRafTimesRef = $ltGt3.useRef();
    var startScroll = function startScroll() {
        var ul = ulRef.current;
        scrollDistRef.current = null;
        scrollRafTimesRef.current = 0;
        if (ul) {
            var targetLi = ul.querySelector("[data-value=\"".concat(value, "\"]"));
            var firstLi = ul.querySelector("li");
            var doScroll = function doScroll() {
                stopScroll();
                scrollingRef.current = true;
                scrollRafTimesRef.current += 1;
                var currentTop = ul.scrollTop;
                var firstLiTop = firstLi.offsetTop;
                var targetLiTop = targetLi.offsetTop;
                var targetTop = targetLiTop - firstLiTop;
                // Wait for element exist. 5 frames is enough
                if (targetLiTop === 0 && targetLi !== firstLi || !(0, $d3c89c1e130d7e35$export$2e2bcd8739ae039)(ul)) {
                    if (scrollRafTimesRef.current <= 5) scrollRafRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(doScroll);
                    return;
                }
                var nextTop = currentTop + (targetTop - currentTop) * $b562207d730cae0a$var$SPEED_PTG;
                var dist = Math.abs(targetTop - nextTop);
                // Break if dist get larger, which means user is scrolling
                if (scrollDistRef.current !== null && scrollDistRef.current < dist) {
                    stopScroll();
                    return;
                }
                scrollDistRef.current = dist;
                // Stop when dist is less than 1
                if (dist <= 1) {
                    ul.scrollTop = targetTop;
                    stopScroll();
                    return;
                }
                // IE not support `scrollTo`
                ul.scrollTop = nextTop;
                scrollRafRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(doScroll);
            };
            if (targetLi && firstLi) doScroll();
        }
    };
    // ======================== Trigger =========================
    var syncScroll = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(startScroll);
    return [
        syncScroll,
        stopScroll,
        isScrolling
    ];
}


function $f1f195b5786fa765$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f1f195b5786fa765$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f1f195b5786fa765$var$_typeof(o);
}
function $f1f195b5786fa765$var$_defineProperty(obj, key, value) {
    key = $f1f195b5786fa765$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f1f195b5786fa765$var$_toPropertyKey(t) {
    var i = $f1f195b5786fa765$var$_toPrimitive(t, "string");
    return "symbol" == $f1f195b5786fa765$var$_typeof(i) ? i : String(i);
}
function $f1f195b5786fa765$var$_toPrimitive(t, r) {
    if ("object" != $f1f195b5786fa765$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f1f195b5786fa765$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f1f195b5786fa765$var$_toConsumableArray(arr) {
    return $f1f195b5786fa765$var$_arrayWithoutHoles(arr) || $f1f195b5786fa765$var$_iterableToArray(arr) || $f1f195b5786fa765$var$_unsupportedIterableToArray(arr) || $f1f195b5786fa765$var$_nonIterableSpread();
}
function $f1f195b5786fa765$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f1f195b5786fa765$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f1f195b5786fa765$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f1f195b5786fa765$var$_arrayLikeToArray(arr);
}
function $f1f195b5786fa765$var$_slicedToArray(arr, i) {
    return $f1f195b5786fa765$var$_arrayWithHoles(arr) || $f1f195b5786fa765$var$_iterableToArrayLimit(arr, i) || $f1f195b5786fa765$var$_unsupportedIterableToArray(arr, i) || $f1f195b5786fa765$var$_nonIterableRest();
}
function $f1f195b5786fa765$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f1f195b5786fa765$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f1f195b5786fa765$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f1f195b5786fa765$var$_arrayLikeToArray(o, minLen);
}
function $f1f195b5786fa765$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f1f195b5786fa765$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f1f195b5786fa765$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $f1f195b5786fa765$var$SCROLL_DELAY = 300;
// Not use JSON.stringify to avoid dead loop
function $f1f195b5786fa765$var$flattenUnits(units) {
    return units.map(function(_ref) {
        var value = _ref.value, label = _ref.label, disabled = _ref.disabled;
        return [
            value,
            label,
            disabled
        ].join(',');
    }).join(';');
}
function $f1f195b5786fa765$export$2e2bcd8739ae039(props) {
    var units = props.units, value = props.value, optionalValue = props.optionalValue, type = props.type, onChange = props.onChange, onHover = props.onHover, onDblClick = props.onDblClick, changeOnScroll = props.changeOnScroll;
    var _usePanelContext = (0, $5925c1ba9cf7332a$export$2fe6b5e489926495)(), prefixCls = _usePanelContext.prefixCls, cellRender = _usePanelContext.cellRender, now = _usePanelContext.now, locale = _usePanelContext.locale, classNames = _usePanelContext.classNames, styles = _usePanelContext.styles;
    var panelPrefixCls = "".concat(prefixCls, "-time-panel");
    var cellPrefixCls = "".concat(prefixCls, "-time-panel-cell");
    // ========================== Refs ==========================
    var ulRef = $ltGt3.useRef(null);
    // ========================= Scroll =========================
    var checkDelayRef = $ltGt3.useRef();
    var clearDelayCheck = function clearDelayCheck() {
        clearTimeout(checkDelayRef.current);
    };
    // ========================== Sync ==========================
    var _useScrollTo = (0, $b562207d730cae0a$export$2e2bcd8739ae039)(ulRef, value !== null && value !== void 0 ? value : optionalValue), _useScrollTo2 = $f1f195b5786fa765$var$_slicedToArray(_useScrollTo, 3), syncScroll = _useScrollTo2[0], stopScroll = _useScrollTo2[1], isScrolling = _useScrollTo2[2];
    // Effect sync value scroll
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(function() {
        syncScroll();
        clearDelayCheck();
        return function() {
            stopScroll();
            clearDelayCheck();
        };
    }, [
        value,
        optionalValue,
        $f1f195b5786fa765$var$flattenUnits(units)
    ]);
    // ========================= Change =========================
    // Scroll event if sync onScroll
    var onInternalScroll = function onInternalScroll(event) {
        clearDelayCheck();
        var target = event.target;
        if (!isScrolling() && changeOnScroll) checkDelayRef.current = setTimeout(function() {
            var ul = ulRef.current;
            var firstLiTop = ul.querySelector("li").offsetTop;
            var liList = Array.from(ul.querySelectorAll("li"));
            var liTopList = liList.map(function(li) {
                return li.offsetTop - firstLiTop;
            });
            var liDistList = liTopList.map(function(top, index) {
                if (units[index].disabled) return Number.MAX_SAFE_INTEGER;
                return Math.abs(top - target.scrollTop);
            });
            // Find min distance index
            var minDist = Math.min.apply(Math, $f1f195b5786fa765$var$_toConsumableArray(liDistList));
            var minDistIndex = liDistList.findIndex(function(dist) {
                return dist === minDist;
            });
            var targetUnit = units[minDistIndex];
            if (targetUnit && !targetUnit.disabled) onChange(targetUnit.value);
        }, $f1f195b5786fa765$var$SCROLL_DELAY);
    };
    // ========================= Render =========================
    var columnPrefixCls = "".concat(panelPrefixCls, "-column");
    return /*#__PURE__*/ $ltGt3.createElement("ul", {
        className: columnPrefixCls,
        ref: ulRef,
        "data-type": type,
        onScroll: onInternalScroll
    }, units.map(function(_ref2) {
        var label = _ref2.label, unitValue = _ref2.value, disabled = _ref2.disabled;
        var inner = /*#__PURE__*/ $ltGt3.createElement("div", {
            className: "".concat(cellPrefixCls, "-inner")
        }, label);
        return /*#__PURE__*/ $ltGt3.createElement("li", {
            key: unitValue,
            style: styles.item,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(cellPrefixCls, classNames.item, $f1f195b5786fa765$var$_defineProperty($f1f195b5786fa765$var$_defineProperty({}, "".concat(cellPrefixCls, "-selected"), value === unitValue), "".concat(cellPrefixCls, "-disabled"), disabled)),
            onClick: function onClick() {
                if (!disabled) onChange(unitValue);
            },
            onDoubleClick: function onDoubleClick() {
                if (!disabled && onDblClick) onDblClick();
            },
            onMouseEnter: function onMouseEnter() {
                onHover(unitValue);
            },
            onMouseLeave: function onMouseLeave() {
                onHover(null);
            },
            "data-value": unitValue
        }, cellRender ? cellRender(unitValue, {
            prefixCls: prefixCls,
            originNode: inner,
            today: now,
            type: 'time',
            subType: type,
            locale: locale
        }) : inner);
    }));
}



function $08b5f60da35b0ddb$var$_extends() {
    $08b5f60da35b0ddb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $08b5f60da35b0ddb$var$_extends.apply(this, arguments);
}
function $08b5f60da35b0ddb$var$_slicedToArray(arr, i) {
    return $08b5f60da35b0ddb$var$_arrayWithHoles(arr) || $08b5f60da35b0ddb$var$_iterableToArrayLimit(arr, i) || $08b5f60da35b0ddb$var$_unsupportedIterableToArray(arr, i) || $08b5f60da35b0ddb$var$_nonIterableRest();
}
function $08b5f60da35b0ddb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $08b5f60da35b0ddb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $08b5f60da35b0ddb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $08b5f60da35b0ddb$var$_arrayLikeToArray(o, minLen);
}
function $08b5f60da35b0ddb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $08b5f60da35b0ddb$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $08b5f60da35b0ddb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $08b5f60da35b0ddb$var$isAM(hour) {
    return hour < 12;
}
function $08b5f60da35b0ddb$export$2e2bcd8739ae039(props) {
    var showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, showMillisecond = props.showMillisecond, showMeridiem = props.use12Hours, changeOnScroll = props.changeOnScroll;
    var _usePanelContext = (0, $5925c1ba9cf7332a$export$2fe6b5e489926495)(), prefixCls = _usePanelContext.prefixCls, classNames = _usePanelContext.classNames, styles = _usePanelContext.styles, values = _usePanelContext.values, generateConfig = _usePanelContext.generateConfig, locale = _usePanelContext.locale, onSelect = _usePanelContext.onSelect, _usePanelContext$onHo = _usePanelContext.onHover, onHover = _usePanelContext$onHo === void 0 ? function() {} : _usePanelContext$onHo, pickerValue = _usePanelContext.pickerValue;
    var value = (values === null || values === void 0 ? void 0 : values[0]) || null;
    var _React$useContext = $ltGt3.useContext((0, $5925c1ba9cf7332a$export$c3f9070e5d88313b)), onCellDblClick = _React$useContext.onCellDblClick;
    // ========================== Info ==========================
    var _useTimeInfo = (0, $2a8c5b6c5644a15c$export$2e2bcd8739ae039)(generateConfig, props, value), _useTimeInfo2 = $08b5f60da35b0ddb$var$_slicedToArray(_useTimeInfo, 5), getValidTime = _useTimeInfo2[0], rowHourUnits = _useTimeInfo2[1], getMinuteUnits = _useTimeInfo2[2], getSecondUnits = _useTimeInfo2[3], getMillisecondUnits = _useTimeInfo2[4];
    // ========================= Value ==========================
    // PickerValue will tell which one to align on the top
    var getUnitValue = function getUnitValue(func) {
        var valueUnitVal = value && generateConfig[func](value);
        var pickerUnitValue = pickerValue && generateConfig[func](pickerValue);
        return [
            valueUnitVal,
            pickerUnitValue
        ];
    };
    var _getUnitValue = getUnitValue('getHour'), _getUnitValue2 = $08b5f60da35b0ddb$var$_slicedToArray(_getUnitValue, 2), hour = _getUnitValue2[0], pickerHour = _getUnitValue2[1];
    var _getUnitValue3 = getUnitValue('getMinute'), _getUnitValue4 = $08b5f60da35b0ddb$var$_slicedToArray(_getUnitValue3, 2), minute = _getUnitValue4[0], pickerMinute = _getUnitValue4[1];
    var _getUnitValue5 = getUnitValue('getSecond'), _getUnitValue6 = $08b5f60da35b0ddb$var$_slicedToArray(_getUnitValue5, 2), second = _getUnitValue6[0], pickerSecond = _getUnitValue6[1];
    var _getUnitValue7 = getUnitValue('getMillisecond'), _getUnitValue8 = $08b5f60da35b0ddb$var$_slicedToArray(_getUnitValue7, 2), millisecond = _getUnitValue8[0], pickerMillisecond = _getUnitValue8[1];
    var meridiem = hour === null ? null : $08b5f60da35b0ddb$var$isAM(hour) ? 'am' : 'pm';
    // ========================= Column =========================
    // Hours
    var hourUnits = $ltGt3.useMemo(function() {
        if (!showMeridiem) return rowHourUnits;
        return $08b5f60da35b0ddb$var$isAM(hour) ? rowHourUnits.filter(function(h) {
            return $08b5f60da35b0ddb$var$isAM(h.value);
        }) : rowHourUnits.filter(function(h) {
            return !$08b5f60da35b0ddb$var$isAM(h.value);
        });
    }, [
        hour,
        rowHourUnits,
        showMeridiem
    ]);
    // >>> Pick Fallback
    var getEnabled = function getEnabled(units, val) {
        var _enabledUnits$;
        var enabledUnits = units.filter(function(unit) {
            return !unit.disabled;
        });
        return val !== null && val !== void 0 ? val : enabledUnits === null || enabledUnits === void 0 || (_enabledUnits$ = enabledUnits[0]) === null || _enabledUnits$ === void 0 ? void 0 : _enabledUnits$.value;
    };
    // >>> Minutes
    var validHour = getEnabled(rowHourUnits, hour);
    var minuteUnits = $ltGt3.useMemo(function() {
        return getMinuteUnits(validHour);
    }, [
        getMinuteUnits,
        validHour
    ]);
    // >>> Seconds
    var validMinute = getEnabled(minuteUnits, minute);
    var secondUnits = $ltGt3.useMemo(function() {
        return getSecondUnits(validHour, validMinute);
    }, [
        getSecondUnits,
        validHour,
        validMinute
    ]);
    // >>> Milliseconds
    var validSecond = getEnabled(secondUnits, second);
    var millisecondUnits = $ltGt3.useMemo(function() {
        return getMillisecondUnits(validHour, validMinute, validSecond);
    }, [
        getMillisecondUnits,
        validHour,
        validMinute,
        validSecond
    ]);
    var validMillisecond = getEnabled(millisecondUnits, millisecond);
    // Meridiem
    var meridiemUnits = $ltGt3.useMemo(function() {
        if (!showMeridiem) return [];
        var base = generateConfig.getNow();
        var amDate = generateConfig.setHour(base, 6);
        var pmDate = generateConfig.setHour(base, 18);
        var formatMeridiem = function formatMeridiem(date, defaultLabel) {
            var cellMeridiemFormat = locale.cellMeridiemFormat;
            return cellMeridiemFormat ? (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(date, {
                generateConfig: generateConfig,
                locale: locale,
                format: cellMeridiemFormat
            }) : defaultLabel;
        };
        return [
            {
                label: formatMeridiem(amDate, 'AM'),
                value: 'am',
                disabled: rowHourUnits.every(function(h) {
                    return h.disabled || !$08b5f60da35b0ddb$var$isAM(h.value);
                })
            },
            {
                label: formatMeridiem(pmDate, 'PM'),
                value: 'pm',
                disabled: rowHourUnits.every(function(h) {
                    return h.disabled || $08b5f60da35b0ddb$var$isAM(h.value);
                })
            }
        ];
    }, [
        rowHourUnits,
        showMeridiem,
        generateConfig,
        locale
    ]);
    // ========================= Change =========================
    /**
   * Check if time is validate or will match to validate one
   */ var triggerChange = function triggerChange(nextDate) {
        var validateDate = getValidTime(nextDate);
        onSelect(validateDate);
    };
    // ========================= Column =========================
    // Create a template date for the trigger change event
    var triggerDateTmpl = $ltGt3.useMemo(function() {
        var tmpl = value || pickerValue || generateConfig.getNow();
        var isNotNull = function isNotNull(num) {
            return num !== null && num !== undefined;
        };
        if (isNotNull(hour)) {
            tmpl = generateConfig.setHour(tmpl, hour);
            tmpl = generateConfig.setMinute(tmpl, minute);
            tmpl = generateConfig.setSecond(tmpl, second);
            tmpl = generateConfig.setMillisecond(tmpl, millisecond);
        } else if (isNotNull(pickerHour)) {
            tmpl = generateConfig.setHour(tmpl, pickerHour);
            tmpl = generateConfig.setMinute(tmpl, pickerMinute);
            tmpl = generateConfig.setSecond(tmpl, pickerSecond);
            tmpl = generateConfig.setMillisecond(tmpl, pickerMillisecond);
        } else if (isNotNull(validHour)) {
            tmpl = generateConfig.setHour(tmpl, validHour);
            tmpl = generateConfig.setMinute(tmpl, validMinute);
            tmpl = generateConfig.setSecond(tmpl, validSecond);
            tmpl = generateConfig.setMillisecond(tmpl, validMillisecond);
        }
        return tmpl;
    }, [
        value,
        pickerValue,
        hour,
        minute,
        second,
        millisecond,
        validHour,
        validMinute,
        validSecond,
        validMillisecond,
        pickerHour,
        pickerMinute,
        pickerSecond,
        pickerMillisecond,
        generateConfig
    ]);
    // ===================== Columns Change =====================
    var fillColumnValue = function fillColumnValue(val, func) {
        if (val === null) return null;
        return generateConfig[func](triggerDateTmpl, val);
    };
    var getNextHourTime = function getNextHourTime(val) {
        return fillColumnValue(val, 'setHour');
    };
    var getNextMinuteTime = function getNextMinuteTime(val) {
        return fillColumnValue(val, 'setMinute');
    };
    var getNextSecondTime = function getNextSecondTime(val) {
        return fillColumnValue(val, 'setSecond');
    };
    var getNextMillisecondTime = function getNextMillisecondTime(val) {
        return fillColumnValue(val, 'setMillisecond');
    };
    var getMeridiemTime = function getMeridiemTime(val) {
        if (val === null) return null;
        if (val === 'am' && !$08b5f60da35b0ddb$var$isAM(hour)) return generateConfig.setHour(triggerDateTmpl, hour - 12);
        else if (val === 'pm' && $08b5f60da35b0ddb$var$isAM(hour)) return generateConfig.setHour(triggerDateTmpl, hour + 12);
        return triggerDateTmpl;
    };
    var onHourChange = function onHourChange(val) {
        triggerChange(getNextHourTime(val));
    };
    var onMinuteChange = function onMinuteChange(val) {
        triggerChange(getNextMinuteTime(val));
    };
    var onSecondChange = function onSecondChange(val) {
        triggerChange(getNextSecondTime(val));
    };
    var onMillisecondChange = function onMillisecondChange(val) {
        triggerChange(getNextMillisecondTime(val));
    };
    var onMeridiemChange = function onMeridiemChange(val) {
        triggerChange(getMeridiemTime(val));
    };
    // ====================== Column Hover ======================
    var onHourHover = function onHourHover(val) {
        onHover(getNextHourTime(val));
    };
    var onMinuteHover = function onMinuteHover(val) {
        onHover(getNextMinuteTime(val));
    };
    var onSecondHover = function onSecondHover(val) {
        onHover(getNextSecondTime(val));
    };
    var onMillisecondHover = function onMillisecondHover(val) {
        onHover(getNextMillisecondTime(val));
    };
    var onMeridiemHover = function onMeridiemHover(val) {
        onHover(getMeridiemTime(val));
    };
    // ========================= Render =========================
    var sharedColumnProps = {
        onDblClick: onCellDblClick,
        changeOnScroll: changeOnScroll
    };
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)("".concat(prefixCls, "-content"), classNames.content),
        style: styles.content
    }, showHour && /*#__PURE__*/ $ltGt3.createElement((0, $f1f195b5786fa765$export$2e2bcd8739ae039), $08b5f60da35b0ddb$var$_extends({
        units: hourUnits,
        value: hour,
        optionalValue: pickerHour,
        type: "hour",
        onChange: onHourChange,
        onHover: onHourHover
    }, sharedColumnProps)), showMinute && /*#__PURE__*/ $ltGt3.createElement((0, $f1f195b5786fa765$export$2e2bcd8739ae039), $08b5f60da35b0ddb$var$_extends({
        units: minuteUnits,
        value: minute,
        optionalValue: pickerMinute,
        type: "minute",
        onChange: onMinuteChange,
        onHover: onMinuteHover
    }, sharedColumnProps)), showSecond && /*#__PURE__*/ $ltGt3.createElement((0, $f1f195b5786fa765$export$2e2bcd8739ae039), $08b5f60da35b0ddb$var$_extends({
        units: secondUnits,
        value: second,
        optionalValue: pickerSecond,
        type: "second",
        onChange: onSecondChange,
        onHover: onSecondHover
    }, sharedColumnProps)), showMillisecond && /*#__PURE__*/ $ltGt3.createElement((0, $f1f195b5786fa765$export$2e2bcd8739ae039), $08b5f60da35b0ddb$var$_extends({
        units: millisecondUnits,
        value: millisecond,
        optionalValue: pickerMillisecond,
        type: "millisecond",
        onChange: onMillisecondChange,
        onHover: onMillisecondHover
    }, sharedColumnProps)), showMeridiem && /*#__PURE__*/ $ltGt3.createElement((0, $f1f195b5786fa765$export$2e2bcd8739ae039), $08b5f60da35b0ddb$var$_extends({
        units: meridiemUnits,
        value: meridiem,
        type: "meridiem",
        onChange: onMeridiemChange,
        onHover: onMeridiemHover
    }, sharedColumnProps)));
}


function $cbcdfdff47ad8f87$var$_slicedToArray(arr, i) {
    return $cbcdfdff47ad8f87$var$_arrayWithHoles(arr) || $cbcdfdff47ad8f87$var$_iterableToArrayLimit(arr, i) || $cbcdfdff47ad8f87$var$_unsupportedIterableToArray(arr, i) || $cbcdfdff47ad8f87$var$_nonIterableRest();
}
function $cbcdfdff47ad8f87$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cbcdfdff47ad8f87$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cbcdfdff47ad8f87$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cbcdfdff47ad8f87$var$_arrayLikeToArray(o, minLen);
}
function $cbcdfdff47ad8f87$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cbcdfdff47ad8f87$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $cbcdfdff47ad8f87$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $cbcdfdff47ad8f87$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, value = props.value, locale = props.locale, generateConfig = props.generateConfig, showTime = props.showTime;
    var _ref = showTime || {}, format = _ref.format;
    var panelPrefixCls = "".concat(prefixCls, "-time-panel");
    // ========================== Base ==========================
    var _useInfo = (0, $5925c1ba9cf7332a$export$2ae76d51704c9302)(props, 'time'), _useInfo2 = $cbcdfdff47ad8f87$var$_slicedToArray(_useInfo, 1), info = _useInfo2[0];
    // ========================= Render =========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $5925c1ba9cf7332a$export$f34532ac99e32150).Provider, {
        value: info
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(panelPrefixCls)
    }, /*#__PURE__*/ $ltGt3.createElement((0, $08f158eee58ed6be$export$2e2bcd8739ae039), null, value ? (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(value, {
        locale: locale,
        format: format,
        generateConfig: generateConfig
    }) : "\xA0"), /*#__PURE__*/ $ltGt3.createElement((0, $08b5f60da35b0ddb$export$2e2bcd8739ae039), showTime)));
}


function $2a197409df2385e2$var$_extends() {
    $2a197409df2385e2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2a197409df2385e2$var$_extends.apply(this, arguments);
}
function $2a197409df2385e2$var$_slicedToArray(arr, i) {
    return $2a197409df2385e2$var$_arrayWithHoles(arr) || $2a197409df2385e2$var$_iterableToArrayLimit(arr, i) || $2a197409df2385e2$var$_unsupportedIterableToArray(arr, i) || $2a197409df2385e2$var$_nonIterableRest();
}
function $2a197409df2385e2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2a197409df2385e2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2a197409df2385e2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2a197409df2385e2$var$_arrayLikeToArray(o, minLen);
}
function $2a197409df2385e2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2a197409df2385e2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2a197409df2385e2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2a197409df2385e2$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, showTime = props.showTime, onSelect = props.onSelect, value = props.value, pickerValue = props.pickerValue, onHover = props.onHover;
    var panelPrefixCls = "".concat(prefixCls, "-datetime-panel");
    // =============================== Time ===============================
    var _useTimeInfo = (0, $2a8c5b6c5644a15c$export$2e2bcd8739ae039)(generateConfig, showTime), _useTimeInfo2 = $2a197409df2385e2$var$_slicedToArray(_useTimeInfo, 1), getValidTime = _useTimeInfo2[0];
    // Merge the time info from `value` or `pickerValue`
    var mergeTime = function mergeTime(date) {
        if (value) return (0, $f655def3c887f075$export$48199fabfd385f2f)(generateConfig, date, value);
        return (0, $f655def3c887f075$export$48199fabfd385f2f)(generateConfig, date, pickerValue);
    };
    // ============================== Hover ===============================
    var onDateHover = function onDateHover(date) {
        onHover === null || onHover === void 0 || onHover(date ? mergeTime(date) : date);
    };
    // ============================== Select ==============================
    var onDateSelect = function onDateSelect(date) {
        // Merge with current time
        var cloneDate = mergeTime(date);
        onSelect(getValidTime(cloneDate, cloneDate));
    };
    // ============================== Render ==============================
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $ltGt3.createElement((0, $eec75e95fa043f08$export$2e2bcd8739ae039), $2a197409df2385e2$var$_extends({}, props, {
        onSelect: onDateSelect,
        onHover: onDateHover
    })), /*#__PURE__*/ $ltGt3.createElement((0, $cbcdfdff47ad8f87$export$2e2bcd8739ae039), props));
}



var $ltGt3 = parcelRequire("ltGt3");




function $9901303ab1d0a088$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9901303ab1d0a088$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9901303ab1d0a088$var$_typeof(o);
}
function $9901303ab1d0a088$var$_extends() {
    $9901303ab1d0a088$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9901303ab1d0a088$var$_extends.apply(this, arguments);
}
function $9901303ab1d0a088$var$_defineProperty(obj, key, value) {
    key = $9901303ab1d0a088$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9901303ab1d0a088$var$_toPropertyKey(t) {
    var i = $9901303ab1d0a088$var$_toPrimitive(t, "string");
    return "symbol" == $9901303ab1d0a088$var$_typeof(i) ? i : String(i);
}
function $9901303ab1d0a088$var$_toPrimitive(t, r) {
    if ("object" != $9901303ab1d0a088$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9901303ab1d0a088$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9901303ab1d0a088$var$_slicedToArray(arr, i) {
    return $9901303ab1d0a088$var$_arrayWithHoles(arr) || $9901303ab1d0a088$var$_iterableToArrayLimit(arr, i) || $9901303ab1d0a088$var$_unsupportedIterableToArray(arr, i) || $9901303ab1d0a088$var$_nonIterableRest();
}
function $9901303ab1d0a088$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9901303ab1d0a088$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9901303ab1d0a088$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9901303ab1d0a088$var$_arrayLikeToArray(o, minLen);
}
function $9901303ab1d0a088$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9901303ab1d0a088$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9901303ab1d0a088$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9901303ab1d0a088$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, locale = props.locale, generateConfig = props.generateConfig, pickerValue = props.pickerValue, disabledDate = props.disabledDate, onPickerValueChange = props.onPickerValueChange;
    var panelPrefixCls = "".concat(prefixCls, "-decade-panel");
    // ========================== Base ==========================
    var _useInfo = (0, $5925c1ba9cf7332a$export$2ae76d51704c9302)(props, 'decade'), _useInfo2 = $9901303ab1d0a088$var$_slicedToArray(_useInfo, 1), info = _useInfo2[0];
    var getStartYear = function getStartYear(date) {
        var startYear = Math.floor(generateConfig.getYear(date) / 100) * 100;
        return generateConfig.setYear(date, startYear);
    };
    var getEndYear = function getEndYear(date) {
        var startYear = getStartYear(date);
        return generateConfig.addYear(startYear, 99);
    };
    var startYearDate = getStartYear(pickerValue);
    var endYearDate = getEndYear(pickerValue);
    var baseDate = generateConfig.addYear(startYearDate, -10);
    // ========================= Cells ==========================
    var getCellDate = function getCellDate(date, offset) {
        return generateConfig.addYear(date, offset * 10);
    };
    var getCellText = function getCellText(date) {
        var cellYearFormat = locale.cellYearFormat;
        var startYearStr = (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(date, {
            locale: locale,
            format: cellYearFormat,
            generateConfig: generateConfig
        });
        var endYearStr = (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(generateConfig.addYear(date, 9), {
            locale: locale,
            format: cellYearFormat,
            generateConfig: generateConfig
        });
        return "".concat(startYearStr, "-").concat(endYearStr);
    };
    var getCellClassName = function getCellClassName(date) {
        return $9901303ab1d0a088$var$_defineProperty({}, "".concat(prefixCls, "-cell-in-view"), (0, $f655def3c887f075$export$22ab546651b3be18)(generateConfig, date, startYearDate) || (0, $f655def3c887f075$export$22ab546651b3be18)(generateConfig, date, endYearDate) || (0, $f655def3c887f075$export$6dabbcb26357acf4)(generateConfig, startYearDate, endYearDate, date));
    };
    // ======================== Disabled ========================
    var mergedDisabledDate = disabledDate ? function(currentDate, disabledInfo) {
        // Start
        var baseStartDate = generateConfig.setDate(currentDate, 1);
        var baseStartMonth = generateConfig.setMonth(baseStartDate, 0);
        var baseStartYear = generateConfig.setYear(baseStartMonth, Math.floor(generateConfig.getYear(baseStartMonth) / 10) * 10);
        // End
        var baseEndYear = generateConfig.addYear(baseStartYear, 10);
        var baseEndDate = generateConfig.addDate(baseEndYear, -1);
        return disabledDate(baseStartYear, disabledInfo) && disabledDate(baseEndDate, disabledInfo);
    } : null;
    // ========================= Header =========================
    var yearNode = "".concat((0, $f655def3c887f075$export$7c4d25c0c3217d8c)(startYearDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }), "-").concat((0, $f655def3c887f075$export$7c4d25c0c3217d8c)(endYearDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    // ========================= Render =========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $5925c1ba9cf7332a$export$f34532ac99e32150).Provider, {
        value: info
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $ltGt3.createElement((0, $08f158eee58ed6be$export$2e2bcd8739ae039), {
        superOffset: function superOffset(distance) {
            return generateConfig.addYear(pickerValue, distance * 100);
        },
        onChange: onPickerValueChange,
        getStart: getStartYear,
        getEnd: getEndYear
    }, yearNode), /*#__PURE__*/ $ltGt3.createElement((0, $3ac1346aa446b916$export$2e2bcd8739ae039), $9901303ab1d0a088$var$_extends({}, props, {
        disabledDate: mergedDisabledDate,
        colNum: 3,
        rowNum: 4,
        baseDate: baseDate,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName
    }))));
}



var $ltGt3 = parcelRequire("ltGt3");




function $6f93617de5a22cd0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6f93617de5a22cd0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6f93617de5a22cd0$var$_typeof(o);
}
function $6f93617de5a22cd0$var$_extends() {
    $6f93617de5a22cd0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6f93617de5a22cd0$var$_extends.apply(this, arguments);
}
function $6f93617de5a22cd0$var$_defineProperty(obj, key, value) {
    key = $6f93617de5a22cd0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6f93617de5a22cd0$var$_toPropertyKey(t) {
    var i = $6f93617de5a22cd0$var$_toPrimitive(t, "string");
    return "symbol" == $6f93617de5a22cd0$var$_typeof(i) ? i : String(i);
}
function $6f93617de5a22cd0$var$_toPrimitive(t, r) {
    if ("object" != $6f93617de5a22cd0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6f93617de5a22cd0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6f93617de5a22cd0$var$_slicedToArray(arr, i) {
    return $6f93617de5a22cd0$var$_arrayWithHoles(arr) || $6f93617de5a22cd0$var$_iterableToArrayLimit(arr, i) || $6f93617de5a22cd0$var$_unsupportedIterableToArray(arr, i) || $6f93617de5a22cd0$var$_nonIterableRest();
}
function $6f93617de5a22cd0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6f93617de5a22cd0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6f93617de5a22cd0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6f93617de5a22cd0$var$_arrayLikeToArray(o, minLen);
}
function $6f93617de5a22cd0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6f93617de5a22cd0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6f93617de5a22cd0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6f93617de5a22cd0$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, locale = props.locale, generateConfig = props.generateConfig, pickerValue = props.pickerValue, disabledDate = props.disabledDate, onPickerValueChange = props.onPickerValueChange, onModeChange = props.onModeChange;
    var panelPrefixCls = "".concat(prefixCls, "-month-panel");
    // ========================== Base ==========================
    var _useInfo = (0, $5925c1ba9cf7332a$export$2ae76d51704c9302)(props, 'month'), _useInfo2 = $6f93617de5a22cd0$var$_slicedToArray(_useInfo, 1), info = _useInfo2[0];
    var baseDate = generateConfig.setMonth(pickerValue, 0);
    // ========================= Month ==========================
    var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
    // ========================= Cells ==========================
    var getCellDate = function getCellDate(date, offset) {
        return generateConfig.addMonth(date, offset);
    };
    var getCellText = function getCellText(date) {
        var month = generateConfig.getMonth(date);
        return locale.monthFormat ? (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(date, {
            locale: locale,
            format: locale.monthFormat,
            generateConfig: generateConfig
        }) : monthsLocale[month];
    };
    var getCellClassName = function getCellClassName() {
        return $6f93617de5a22cd0$var$_defineProperty({}, "".concat(prefixCls, "-cell-in-view"), true);
    };
    // ======================== Disabled ========================
    var mergedDisabledDate = disabledDate ? function(currentDate, disabledInfo) {
        var startDate = generateConfig.setDate(currentDate, 1);
        var nextMonthStartDate = generateConfig.setMonth(startDate, generateConfig.getMonth(startDate) + 1);
        var endDate = generateConfig.addDate(nextMonthStartDate, -1);
        return disabledDate(startDate, disabledInfo) && disabledDate(endDate, disabledInfo);
    } : null;
    // ========================= Header =========================
    var yearNode = /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        key: "year",
        "aria-label": locale.yearSelect,
        onClick: function onClick() {
            onModeChange('year');
        },
        tabIndex: -1,
        className: "".concat(prefixCls, "-year-btn")
    }, (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(pickerValue, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    // ========================= Render =========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $5925c1ba9cf7332a$export$f34532ac99e32150).Provider, {
        value: info
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $ltGt3.createElement((0, $08f158eee58ed6be$export$2e2bcd8739ae039), {
        superOffset: function superOffset(distance) {
            return generateConfig.addYear(pickerValue, distance);
        },
        onChange: onPickerValueChange,
        getStart: function getStart(date) {
            return generateConfig.setMonth(date, 0);
        },
        getEnd: function getEnd(date) {
            return generateConfig.setMonth(date, 11);
        }
    }, yearNode), /*#__PURE__*/ $ltGt3.createElement((0, $3ac1346aa446b916$export$2e2bcd8739ae039), $6f93617de5a22cd0$var$_extends({}, props, {
        disabledDate: mergedDisabledDate,
        titleFormat: locale.fieldMonthFormat,
        colNum: 3,
        rowNum: 4,
        baseDate: baseDate,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName
    }))));
}



var $ltGt3 = parcelRequire("ltGt3");




function $24bd22e0a521dccb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $24bd22e0a521dccb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $24bd22e0a521dccb$var$_typeof(o);
}
function $24bd22e0a521dccb$var$_extends() {
    $24bd22e0a521dccb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $24bd22e0a521dccb$var$_extends.apply(this, arguments);
}
function $24bd22e0a521dccb$var$_defineProperty(obj, key, value) {
    key = $24bd22e0a521dccb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $24bd22e0a521dccb$var$_toPropertyKey(t) {
    var i = $24bd22e0a521dccb$var$_toPrimitive(t, "string");
    return "symbol" == $24bd22e0a521dccb$var$_typeof(i) ? i : String(i);
}
function $24bd22e0a521dccb$var$_toPrimitive(t, r) {
    if ("object" != $24bd22e0a521dccb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $24bd22e0a521dccb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $24bd22e0a521dccb$var$_slicedToArray(arr, i) {
    return $24bd22e0a521dccb$var$_arrayWithHoles(arr) || $24bd22e0a521dccb$var$_iterableToArrayLimit(arr, i) || $24bd22e0a521dccb$var$_unsupportedIterableToArray(arr, i) || $24bd22e0a521dccb$var$_nonIterableRest();
}
function $24bd22e0a521dccb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $24bd22e0a521dccb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $24bd22e0a521dccb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $24bd22e0a521dccb$var$_arrayLikeToArray(o, minLen);
}
function $24bd22e0a521dccb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $24bd22e0a521dccb$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $24bd22e0a521dccb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $24bd22e0a521dccb$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, locale = props.locale, generateConfig = props.generateConfig, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, onModeChange = props.onModeChange;
    var panelPrefixCls = "".concat(prefixCls, "-quarter-panel");
    // ========================== Base ==========================
    var _useInfo = (0, $5925c1ba9cf7332a$export$2ae76d51704c9302)(props, 'quarter'), _useInfo2 = $24bd22e0a521dccb$var$_slicedToArray(_useInfo, 1), info = _useInfo2[0];
    var baseDate = generateConfig.setMonth(pickerValue, 0);
    // ========================= Cells ==========================
    var getCellDate = function getCellDate(date, offset) {
        return generateConfig.addMonth(date, offset * 3);
    };
    var getCellText = function getCellText(date) {
        return (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(date, {
            locale: locale,
            format: locale.cellQuarterFormat,
            generateConfig: generateConfig
        });
    };
    var getCellClassName = function getCellClassName() {
        return $24bd22e0a521dccb$var$_defineProperty({}, "".concat(prefixCls, "-cell-in-view"), true);
    };
    // ========================= Header =========================
    var yearNode = /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        key: "year",
        "aria-label": locale.yearSelect,
        onClick: function onClick() {
            onModeChange('year');
        },
        tabIndex: -1,
        className: "".concat(prefixCls, "-year-btn")
    }, (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(pickerValue, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    // ========================= Render =========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $5925c1ba9cf7332a$export$f34532ac99e32150).Provider, {
        value: info
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $ltGt3.createElement((0, $08f158eee58ed6be$export$2e2bcd8739ae039), {
        superOffset: function superOffset(distance) {
            return generateConfig.addYear(pickerValue, distance);
        },
        onChange: onPickerValueChange,
        getStart: function getStart(date) {
            return generateConfig.setMonth(date, 0);
        },
        getEnd: function getEnd(date) {
            return generateConfig.setMonth(date, 11);
        }
    }, yearNode), /*#__PURE__*/ $ltGt3.createElement((0, $3ac1346aa446b916$export$2e2bcd8739ae039), $24bd22e0a521dccb$var$_extends({}, props, {
        titleFormat: locale.fieldQuarterFormat,
        colNum: 4,
        rowNum: 1,
        baseDate: baseDate,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName
    }))));
}





var $ltGt3 = parcelRequire("ltGt3");


function $671f9fa87bb95d72$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $671f9fa87bb95d72$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $671f9fa87bb95d72$var$_typeof(o);
}
function $671f9fa87bb95d72$var$_extends() {
    $671f9fa87bb95d72$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $671f9fa87bb95d72$var$_extends.apply(this, arguments);
}
function $671f9fa87bb95d72$var$_defineProperty(obj, key, value) {
    key = $671f9fa87bb95d72$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $671f9fa87bb95d72$var$_toPropertyKey(t) {
    var i = $671f9fa87bb95d72$var$_toPrimitive(t, "string");
    return "symbol" == $671f9fa87bb95d72$var$_typeof(i) ? i : String(i);
}
function $671f9fa87bb95d72$var$_toPrimitive(t, r) {
    if ("object" != $671f9fa87bb95d72$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $671f9fa87bb95d72$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $671f9fa87bb95d72$var$_slicedToArray(arr, i) {
    return $671f9fa87bb95d72$var$_arrayWithHoles(arr) || $671f9fa87bb95d72$var$_iterableToArrayLimit(arr, i) || $671f9fa87bb95d72$var$_unsupportedIterableToArray(arr, i) || $671f9fa87bb95d72$var$_nonIterableRest();
}
function $671f9fa87bb95d72$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $671f9fa87bb95d72$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $671f9fa87bb95d72$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $671f9fa87bb95d72$var$_arrayLikeToArray(o, minLen);
}
function $671f9fa87bb95d72$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $671f9fa87bb95d72$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $671f9fa87bb95d72$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $671f9fa87bb95d72$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, value = props.value, hoverValue = props.hoverValue, hoverRangeValue = props.hoverRangeValue;
    // =============================== Row ================================
    var localeName = locale.locale;
    var rowPrefixCls = "".concat(prefixCls, "-week-panel-row");
    var rowClassName = function rowClassName(currentDate) {
        var rangeCls = {};
        if (hoverRangeValue) {
            var _hoverRangeValue = $671f9fa87bb95d72$var$_slicedToArray(hoverRangeValue, 2), rangeStart = _hoverRangeValue[0], rangeEnd = _hoverRangeValue[1];
            var isRangeStart = (0, $f655def3c887f075$export$6ea683876c36b8d2)(generateConfig, localeName, rangeStart, currentDate);
            var isRangeEnd = (0, $f655def3c887f075$export$6ea683876c36b8d2)(generateConfig, localeName, rangeEnd, currentDate);
            rangeCls["".concat(rowPrefixCls, "-range-start")] = isRangeStart;
            rangeCls["".concat(rowPrefixCls, "-range-end")] = isRangeEnd;
            rangeCls["".concat(rowPrefixCls, "-range-hover")] = !isRangeStart && !isRangeEnd && (0, $f655def3c887f075$export$6dabbcb26357acf4)(generateConfig, rangeStart, rangeEnd, currentDate);
        }
        if (hoverValue) rangeCls["".concat(rowPrefixCls, "-hover")] = hoverValue.some(function(date) {
            return (0, $f655def3c887f075$export$6ea683876c36b8d2)(generateConfig, localeName, currentDate, date);
        });
        return (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(rowPrefixCls, $671f9fa87bb95d72$var$_defineProperty({}, "".concat(rowPrefixCls, "-selected"), !hoverRangeValue && (0, $f655def3c887f075$export$6ea683876c36b8d2)(generateConfig, localeName, value, currentDate)), // Patch for hover range
        rangeCls);
    };
    // ============================== Render ==============================
    return /*#__PURE__*/ $ltGt3.createElement((0, $eec75e95fa043f08$export$2e2bcd8739ae039), $671f9fa87bb95d72$var$_extends({}, props, {
        mode: "week",
        panelName: "week",
        rowClassName: rowClassName
    }));
}



var $ltGt3 = parcelRequire("ltGt3");




function $dea35cc53d8ba87d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dea35cc53d8ba87d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dea35cc53d8ba87d$var$_typeof(o);
}
function $dea35cc53d8ba87d$var$_extends() {
    $dea35cc53d8ba87d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dea35cc53d8ba87d$var$_extends.apply(this, arguments);
}
function $dea35cc53d8ba87d$var$_defineProperty(obj, key, value) {
    key = $dea35cc53d8ba87d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dea35cc53d8ba87d$var$_toPropertyKey(t) {
    var i = $dea35cc53d8ba87d$var$_toPrimitive(t, "string");
    return "symbol" == $dea35cc53d8ba87d$var$_typeof(i) ? i : String(i);
}
function $dea35cc53d8ba87d$var$_toPrimitive(t, r) {
    if ("object" != $dea35cc53d8ba87d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dea35cc53d8ba87d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $dea35cc53d8ba87d$var$_slicedToArray(arr, i) {
    return $dea35cc53d8ba87d$var$_arrayWithHoles(arr) || $dea35cc53d8ba87d$var$_iterableToArrayLimit(arr, i) || $dea35cc53d8ba87d$var$_unsupportedIterableToArray(arr, i) || $dea35cc53d8ba87d$var$_nonIterableRest();
}
function $dea35cc53d8ba87d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dea35cc53d8ba87d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dea35cc53d8ba87d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dea35cc53d8ba87d$var$_arrayLikeToArray(o, minLen);
}
function $dea35cc53d8ba87d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dea35cc53d8ba87d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $dea35cc53d8ba87d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $dea35cc53d8ba87d$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, locale = props.locale, generateConfig = props.generateConfig, pickerValue = props.pickerValue, disabledDate = props.disabledDate, onPickerValueChange = props.onPickerValueChange, onModeChange = props.onModeChange;
    var panelPrefixCls = "".concat(prefixCls, "-year-panel");
    // ========================== Base ==========================
    var _useInfo = (0, $5925c1ba9cf7332a$export$2ae76d51704c9302)(props, 'year'), _useInfo2 = $dea35cc53d8ba87d$var$_slicedToArray(_useInfo, 1), info = _useInfo2[0];
    var getStartYear = function getStartYear(date) {
        var startYear = Math.floor(generateConfig.getYear(date) / 10) * 10;
        return generateConfig.setYear(date, startYear);
    };
    var getEndYear = function getEndYear(date) {
        var startYear = getStartYear(date);
        return generateConfig.addYear(startYear, 9);
    };
    var startYearDate = getStartYear(pickerValue);
    var endYearDate = getEndYear(pickerValue);
    var baseDate = generateConfig.addYear(startYearDate, -1);
    // ========================= Cells ==========================
    var getCellDate = function getCellDate(date, offset) {
        return generateConfig.addYear(date, offset);
    };
    var getCellText = function getCellText(date) {
        return (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(date, {
            locale: locale,
            format: locale.cellYearFormat,
            generateConfig: generateConfig
        });
    };
    var getCellClassName = function getCellClassName(date) {
        return $dea35cc53d8ba87d$var$_defineProperty({}, "".concat(prefixCls, "-cell-in-view"), (0, $f655def3c887f075$export$5841f9eb9773f25f)(generateConfig, date, startYearDate) || (0, $f655def3c887f075$export$5841f9eb9773f25f)(generateConfig, date, endYearDate) || (0, $f655def3c887f075$export$6dabbcb26357acf4)(generateConfig, startYearDate, endYearDate, date));
    };
    // ======================== Disabled ========================
    var mergedDisabledDate = disabledDate ? function(currentDate, disabledInfo) {
        // Start
        var startMonth = generateConfig.setMonth(currentDate, 0);
        var startDate = generateConfig.setDate(startMonth, 1);
        // End
        var endMonth = generateConfig.addYear(startDate, 1);
        var endDate = generateConfig.addDate(endMonth, -1);
        return disabledDate(startDate, disabledInfo) && disabledDate(endDate, disabledInfo);
    } : null;
    // ========================= Header =========================
    var yearNode = /*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        key: "decade",
        "aria-label": locale.decadeSelect,
        onClick: function onClick() {
            onModeChange('decade');
        },
        tabIndex: -1,
        className: "".concat(prefixCls, "-decade-btn")
    }, (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(startYearDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }), "-", (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(endYearDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    // ========================= Render =========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $5925c1ba9cf7332a$export$f34532ac99e32150).Provider, {
        value: info
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $ltGt3.createElement((0, $08f158eee58ed6be$export$2e2bcd8739ae039), {
        superOffset: function superOffset(distance) {
            return generateConfig.addYear(pickerValue, distance * 10);
        },
        onChange: onPickerValueChange,
        getStart: getStartYear,
        getEnd: getEndYear
    }, yearNode), /*#__PURE__*/ $ltGt3.createElement((0, $3ac1346aa446b916$export$2e2bcd8739ae039), $dea35cc53d8ba87d$var$_extends({}, props, {
        disabledDate: mergedDisabledDate,
        titleFormat: locale.fieldYearFormat,
        colNum: 3,
        rowNum: 4,
        baseDate: baseDate,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName
    }))));
}


function $b32474a64c1e9ff7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b32474a64c1e9ff7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b32474a64c1e9ff7$var$_typeof(o);
}
function $b32474a64c1e9ff7$var$_extends() {
    $b32474a64c1e9ff7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b32474a64c1e9ff7$var$_extends.apply(this, arguments);
}
function $b32474a64c1e9ff7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b32474a64c1e9ff7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b32474a64c1e9ff7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b32474a64c1e9ff7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b32474a64c1e9ff7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b32474a64c1e9ff7$var$_defineProperty(obj, key, value) {
    key = $b32474a64c1e9ff7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b32474a64c1e9ff7$var$_toPropertyKey(t) {
    var i = $b32474a64c1e9ff7$var$_toPrimitive(t, "string");
    return "symbol" == $b32474a64c1e9ff7$var$_typeof(i) ? i : String(i);
}
function $b32474a64c1e9ff7$var$_toPrimitive(t, r) {
    if ("object" != $b32474a64c1e9ff7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b32474a64c1e9ff7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b32474a64c1e9ff7$var$_toConsumableArray(arr) {
    return $b32474a64c1e9ff7$var$_arrayWithoutHoles(arr) || $b32474a64c1e9ff7$var$_iterableToArray(arr) || $b32474a64c1e9ff7$var$_unsupportedIterableToArray(arr) || $b32474a64c1e9ff7$var$_nonIterableSpread();
}
function $b32474a64c1e9ff7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b32474a64c1e9ff7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b32474a64c1e9ff7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b32474a64c1e9ff7$var$_arrayLikeToArray(arr);
}
function $b32474a64c1e9ff7$var$_slicedToArray(arr, i) {
    return $b32474a64c1e9ff7$var$_arrayWithHoles(arr) || $b32474a64c1e9ff7$var$_iterableToArrayLimit(arr, i) || $b32474a64c1e9ff7$var$_unsupportedIterableToArray(arr, i) || $b32474a64c1e9ff7$var$_nonIterableRest();
}
function $b32474a64c1e9ff7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b32474a64c1e9ff7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b32474a64c1e9ff7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b32474a64c1e9ff7$var$_arrayLikeToArray(o, minLen);
}
function $b32474a64c1e9ff7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b32474a64c1e9ff7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b32474a64c1e9ff7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $b32474a64c1e9ff7$var$DefaultComponents = {
    date: (0, $eec75e95fa043f08$export$2e2bcd8739ae039),
    datetime: (0, $2a197409df2385e2$export$2e2bcd8739ae039),
    week: (0, $671f9fa87bb95d72$export$2e2bcd8739ae039),
    month: (0, $6f93617de5a22cd0$export$2e2bcd8739ae039),
    quarter: (0, $24bd22e0a521dccb$export$2e2bcd8739ae039),
    year: (0, $dea35cc53d8ba87d$export$2e2bcd8739ae039),
    decade: (0, $9901303ab1d0a088$export$2e2bcd8739ae039),
    time: (0, $cbcdfdff47ad8f87$export$2e2bcd8739ae039)
};
function $b32474a64c1e9ff7$var$PickerPanel(props, ref) {
    var panelClassNames = props.classNames, panelStyles = props.styles, locale = props.locale, generateConfig = props.generateConfig, direction = props.direction, prefixCls = props.prefixCls, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, multiple = props.multiple, defaultValue = props.defaultValue, value = props.value, onChange = props.onChange, onSelect = props.onSelect, defaultPickerValue = props.defaultPickerValue, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, mode = props.mode, onPanelChange = props.onPanelChange, _props$picker = props.picker, picker = _props$picker === void 0 ? 'date' : _props$picker, showTime = props.showTime, hoverValue = props.hoverValue, hoverRangeValue = props.hoverRangeValue, cellRender = props.cellRender, dateRender = props.dateRender, monthCellRender = props.monthCellRender, _props$components = props.components, components = _props$components === void 0 ? {} : _props$components, hideHeader = props.hideHeader;
    // ======================== Context ========================
    var _ref = $ltGt3.useContext((0, $6158ac241550cb6d$export$2e2bcd8739ae039)) || {}, contextPrefixCls = _ref.prefixCls, pickerClassNames = _ref.classNames, pickerStyles = _ref.styles;
    // ======================== prefixCls ========================
    var mergedPrefixCls = contextPrefixCls || prefixCls || 'rc-picker';
    // ========================== Refs ==========================
    var rootRef = $ltGt3.useRef();
    $ltGt3.useImperativeHandle(ref, function() {
        return {
            nativeElement: rootRef.current
        };
    });
    // ========================== Time ==========================
    // Auto `format` need to check `showTime.showXXX` first.
    // And then merge the `locale` into `mergedShowTime`.
    var _getTimeProps = (0, $43ac09fd9f4907ea$export$6c7e3619a08d795a)(props), _getTimeProps2 = $b32474a64c1e9ff7$var$_slicedToArray(_getTimeProps, 4), timeProps = _getTimeProps2[0], localeTimeProps = _getTimeProps2[1], showTimeFormat = _getTimeProps2[2], propFormat = _getTimeProps2[3];
    // ========================= Locale =========================
    var filledLocale = (0, $c0aff2e3bc189b4c$export$2e2bcd8739ae039)(locale, localeTimeProps);
    // ========================= Picker =========================
    var internalPicker = picker === 'date' && showTime ? 'datetime' : picker;
    // ======================== ShowTime ========================
    var mergedShowTime = $ltGt3.useMemo(function() {
        return (0, $43ac09fd9f4907ea$export$901cd53a4926b425)(internalPicker, showTimeFormat, propFormat, timeProps, filledLocale);
    }, [
        internalPicker,
        showTimeFormat,
        propFormat,
        timeProps,
        filledLocale
    ]);
    // ========================== Now ===========================
    var now = generateConfig.getNow();
    // ========================== Mode ==========================
    var _useControlledState = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(picker || 'date', mode), _useControlledState2 = $b32474a64c1e9ff7$var$_slicedToArray(_useControlledState, 2), mergedMode = _useControlledState2[0], setMergedMode = _useControlledState2[1];
    var internalMode = mergedMode === 'date' && mergedShowTime ? 'datetime' : mergedMode;
    // ========================= Toggle =========================
    var toggleDates = (0, $12b886ce4241df5e$export$2e2bcd8739ae039)(generateConfig, locale, internalPicker);
    // ========================= Value ==========================
    // >>> Real value
    // Interactive with `onChange` event which only trigger when the `mode` is `picker`
    var _useControlledState3 = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultValue, value), _useControlledState4 = $b32474a64c1e9ff7$var$_slicedToArray(_useControlledState3, 2), innerValue = _useControlledState4[0], setMergedValue = _useControlledState4[1];
    var mergedValue = $ltGt3.useMemo(function() {
        // Clean up `[null]`
        var values = (0, $4eaa081548444891$export$45b10814cc054894)(innerValue).filter(function(val) {
            return val;
        });
        return multiple ? values : values.slice(0, 1);
    }, [
        innerValue,
        multiple
    ]);
    // Sync value and only trigger onChange event when changed
    var triggerChange = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(nextValue) {
        setMergedValue(nextValue);
        if (onChange && (nextValue === null || mergedValue.length !== nextValue.length || mergedValue.some(function(ori, index) {
            return !(0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, ori, nextValue[index], internalPicker);
        }))) onChange === null || onChange === void 0 || onChange(multiple ? nextValue : nextValue[0]);
    });
    // >>> CalendarValue
    // CalendarValue is a temp value for user operation
    // which will only trigger `onCalendarChange` but not `onChange`
    var onInternalSelect = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(newDate) {
        onSelect === null || onSelect === void 0 || onSelect(newDate);
        if (mergedMode === picker) {
            var nextValues = multiple ? toggleDates(mergedValue, newDate) : [
                newDate
            ];
            triggerChange(nextValues);
        }
    });
    // >>> PickerValue
    // PickerValue is used to control the current displaying panel
    var _useControlledState5 = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultPickerValue || mergedValue[0] || now, pickerValue), _useControlledState6 = $b32474a64c1e9ff7$var$_slicedToArray(_useControlledState5, 2), mergedPickerValue = _useControlledState6[0], setInternalPickerValue = _useControlledState6[1];
    $ltGt3.useEffect(function() {
        if (mergedValue[0] && !pickerValue) setInternalPickerValue(mergedValue[0]);
    }, [
        mergedValue[0]
    ]);
    // Both trigger when manually pickerValue or mode change
    var triggerPanelChange = function triggerPanelChange(viewDate, nextMode) {
        onPanelChange === null || onPanelChange === void 0 || onPanelChange(viewDate || pickerValue, nextMode || mergedMode);
    };
    var setPickerValue = function setPickerValue(nextPickerValue) {
        var triggerPanelEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setInternalPickerValue(nextPickerValue);
        onPickerValueChange === null || onPickerValueChange === void 0 || onPickerValueChange(nextPickerValue);
        if (triggerPanelEvent) triggerPanelChange(nextPickerValue);
    };
    var triggerModeChange = function triggerModeChange(nextMode, viewDate) {
        setMergedMode(nextMode);
        if (viewDate) setPickerValue(viewDate);
        triggerPanelChange(viewDate, nextMode);
    };
    var onPanelValueSelect = function onPanelValueSelect(nextValue) {
        onInternalSelect(nextValue);
        setPickerValue(nextValue);
        // Update mode if needed
        if (mergedMode !== picker) {
            var decadeYearQueue = [
                'decade',
                'year'
            ];
            var decadeYearMonthQueue = [].concat(decadeYearQueue, [
                'month'
            ]);
            var pickerQueue = {
                quarter: [].concat(decadeYearQueue, [
                    'quarter'
                ]),
                week: [].concat($b32474a64c1e9ff7$var$_toConsumableArray(decadeYearMonthQueue), [
                    'week'
                ]),
                date: [].concat($b32474a64c1e9ff7$var$_toConsumableArray(decadeYearMonthQueue), [
                    'date'
                ])
            };
            var queue = pickerQueue[picker] || decadeYearMonthQueue;
            var index = queue.indexOf(mergedMode);
            var nextMode = queue[index + 1];
            if (nextMode) triggerModeChange(nextMode, nextValue);
        }
    };
    // ======================= Hover Date =======================
    var hoverRangeDate = $ltGt3.useMemo(function() {
        var start;
        var end;
        if (Array.isArray(hoverRangeValue)) {
            var _hoverRangeValue = $b32474a64c1e9ff7$var$_slicedToArray(hoverRangeValue, 2);
            start = _hoverRangeValue[0];
            end = _hoverRangeValue[1];
        } else start = hoverRangeValue;
        // Return for not exist
        if (!start && !end) return null;
        // Fill if has empty
        start = start || end;
        end = end || start;
        return generateConfig.isAfter(start, end) ? [
            end,
            start
        ] : [
            start,
            end
        ];
    }, [
        hoverRangeValue,
        generateConfig
    ]);
    // ======================= Components =======================
    // >>> cellRender
    var onInternalCellRender = (0, $8fa10cb8931a057d$export$2e2bcd8739ae039)(cellRender, dateRender, monthCellRender);
    // ======================= Components =======================
    var PanelComponent = components[internalMode] || $b32474a64c1e9ff7$var$DefaultComponents[internalMode] || (0, $eec75e95fa043f08$export$2e2bcd8739ae039);
    // ======================== Context =========================
    var sharedPanelContext = $ltGt3.useMemo(function() {
        var _ref2, _pickerClassNames$pop, _ref3, _pickerStyles$popup;
        return {
            classNames: (_ref2 = (_pickerClassNames$pop = pickerClassNames === null || pickerClassNames === void 0 ? void 0 : pickerClassNames.popup) !== null && _pickerClassNames$pop !== void 0 ? _pickerClassNames$pop : panelClassNames) !== null && _ref2 !== void 0 ? _ref2 : {},
            styles: (_ref3 = (_pickerStyles$popup = pickerStyles === null || pickerStyles === void 0 ? void 0 : pickerStyles.popup) !== null && _pickerStyles$popup !== void 0 ? _pickerStyles$popup : panelStyles) !== null && _ref3 !== void 0 ? _ref3 : {}
        };
    }, [
        pickerClassNames,
        panelClassNames,
        pickerStyles,
        panelStyles
    ]);
    var parentHackContext = $ltGt3.useContext((0, $5925c1ba9cf7332a$export$c3f9070e5d88313b));
    var pickerPanelContext = $ltGt3.useMemo(function() {
        return $b32474a64c1e9ff7$var$_objectSpread($b32474a64c1e9ff7$var$_objectSpread({}, parentHackContext), {}, {
            hideHeader: hideHeader
        });
    }, [
        parentHackContext,
        hideHeader
    ]);
    // ========================= Render =========================
    var panelCls = "".concat(mergedPrefixCls, "-panel");
    var panelProps = (0, $4eaa081548444891$export$1b696fb20abaa06c)(props, [
        // Week
        'showWeek',
        // Icons
        'prevIcon',
        'nextIcon',
        'superPrevIcon',
        'superNextIcon',
        // Disabled
        'disabledDate',
        'minDate',
        'maxDate',
        // Hover
        'onHover'
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $5925c1ba9cf7332a$export$d1173f47489c79e4).Provider, {
        value: sharedPanelContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $5925c1ba9cf7332a$export$c3f9070e5d88313b).Provider, {
        value: pickerPanelContext
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: rootRef,
        tabIndex: tabIndex,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(panelCls, $b32474a64c1e9ff7$var$_defineProperty({}, "".concat(panelCls, "-rtl"), direction === 'rtl'))
    }, /*#__PURE__*/ $ltGt3.createElement(PanelComponent, $b32474a64c1e9ff7$var$_extends({}, panelProps, {
        // Time
        showTime: mergedShowTime,
        prefixCls: mergedPrefixCls,
        locale: filledLocale,
        generateConfig: generateConfig,
        onModeChange: triggerModeChange,
        pickerValue: mergedPickerValue,
        onPickerValueChange: function onPickerValueChange(nextPickerValue) {
            setPickerValue(nextPickerValue, true);
        },
        value: mergedValue[0],
        onSelect: onPanelValueSelect,
        values: mergedValue,
        cellRender: onInternalCellRender,
        hoverRangeValue: hoverRangeDate,
        hoverValue: hoverValue
    })))));
}
var $b32474a64c1e9ff7$var$RefPanelPicker = /*#__PURE__*/ $ltGt3.memo(/*#__PURE__*/ $ltGt3.forwardRef($b32474a64c1e9ff7$var$PickerPanel));
var // Make support generic
$b32474a64c1e9ff7$export$2e2bcd8739ae039 = $b32474a64c1e9ff7$var$RefPanelPicker;





function $9c407119b03bb838$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9c407119b03bb838$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9c407119b03bb838$var$_typeof(o);
}
function $9c407119b03bb838$var$_extends() {
    $9c407119b03bb838$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9c407119b03bb838$var$_extends.apply(this, arguments);
}
function $9c407119b03bb838$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9c407119b03bb838$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9c407119b03bb838$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9c407119b03bb838$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9c407119b03bb838$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9c407119b03bb838$var$_defineProperty(obj, key, value) {
    key = $9c407119b03bb838$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9c407119b03bb838$var$_toPropertyKey(t) {
    var i = $9c407119b03bb838$var$_toPrimitive(t, "string");
    return "symbol" == $9c407119b03bb838$var$_typeof(i) ? i : String(i);
}
function $9c407119b03bb838$var$_toPrimitive(t, r) {
    if ("object" != $9c407119b03bb838$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9c407119b03bb838$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9c407119b03bb838$export$2e2bcd8739ae039(props) {
    var picker = props.picker, multiplePanel = props.multiplePanel, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, needConfirm = props.needConfirm, onSubmit = props.onSubmit, range = props.range, hoverValue = props.hoverValue;
    var _React$useContext = $ltGt3.useContext((0, $6158ac241550cb6d$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, generateConfig = _React$useContext.generateConfig;
    // ======================== Offset ========================
    var internalOffsetDate = $ltGt3.useCallback(function(date, offset) {
        return (0, $7b84215c9fa9f92b$export$b0e4aff419ae4233)(generateConfig, picker, date, offset);
    }, [
        generateConfig,
        picker
    ]);
    var nextPickerValue = $ltGt3.useMemo(function() {
        return internalOffsetDate(pickerValue, 1);
    }, [
        pickerValue,
        internalOffsetDate
    ]);
    // Outside
    var onSecondPickerValueChange = function onSecondPickerValueChange(nextDate) {
        onPickerValueChange(internalOffsetDate(nextDate, -1));
    };
    // ======================= Context ========================
    var sharedContext = {
        onCellDblClick: function onCellDblClick() {
            if (needConfirm) onSubmit();
        }
    };
    var hideHeader = picker === 'time';
    // ======================== Props =========================
    var pickerProps = $9c407119b03bb838$var$_objectSpread($9c407119b03bb838$var$_objectSpread({}, props), {}, {
        hoverValue: null,
        hoverRangeValue: null,
        hideHeader: hideHeader
    });
    if (range) pickerProps.hoverRangeValue = hoverValue;
    else pickerProps.hoverValue = hoverValue;
    // ======================== Render ========================
    // Multiple
    if (multiplePanel) return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: "".concat(prefixCls, "-panels")
    }, /*#__PURE__*/ $ltGt3.createElement((0, $5925c1ba9cf7332a$export$c3f9070e5d88313b).Provider, {
        value: $9c407119b03bb838$var$_objectSpread($9c407119b03bb838$var$_objectSpread({}, sharedContext), {}, {
            hideNext: true
        })
    }, /*#__PURE__*/ $ltGt3.createElement((0, $b32474a64c1e9ff7$export$2e2bcd8739ae039), pickerProps)), /*#__PURE__*/ $ltGt3.createElement((0, $5925c1ba9cf7332a$export$c3f9070e5d88313b).Provider, {
        value: $9c407119b03bb838$var$_objectSpread($9c407119b03bb838$var$_objectSpread({}, sharedContext), {}, {
            hidePrev: true
        })
    }, /*#__PURE__*/ $ltGt3.createElement((0, $b32474a64c1e9ff7$export$2e2bcd8739ae039), $9c407119b03bb838$var$_extends({}, pickerProps, {
        pickerValue: nextPickerValue,
        onPickerValueChange: onSecondPickerValueChange
    }))));
    // Single
    return /*#__PURE__*/ $ltGt3.createElement((0, $5925c1ba9cf7332a$export$c3f9070e5d88313b).Provider, {
        value: $9c407119b03bb838$var$_objectSpread({}, sharedContext)
    }, /*#__PURE__*/ $ltGt3.createElement((0, $b32474a64c1e9ff7$export$2e2bcd8739ae039), pickerProps));
}



var $ltGt3 = parcelRequire("ltGt3");
function $064e6a7ea945da16$var$executeValue(value) {
    return typeof value === 'function' ? value() : value;
}
function $064e6a7ea945da16$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, presets = props.presets, _onClick = props.onClick, onHover = props.onHover;
    if (!presets.length) return null;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: "".concat(prefixCls, "-presets")
    }, /*#__PURE__*/ $ltGt3.createElement("ul", null, presets.map(function(_ref, index) {
        var label = _ref.label, value = _ref.value;
        return /*#__PURE__*/ $ltGt3.createElement("li", {
            key: index,
            onClick: function onClick() {
                _onClick($064e6a7ea945da16$var$executeValue(value));
            },
            onMouseEnter: function onMouseEnter() {
                onHover($064e6a7ea945da16$var$executeValue(value));
            },
            onMouseLeave: function onMouseLeave() {
                onHover(null);
            }
        }, label);
    })));
}


function $3b229d2234afad92$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3b229d2234afad92$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3b229d2234afad92$var$_typeof(o);
}
function $3b229d2234afad92$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b229d2234afad92$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b229d2234afad92$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3b229d2234afad92$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b229d2234afad92$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3b229d2234afad92$var$_defineProperty(obj, key, value) {
    key = $3b229d2234afad92$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3b229d2234afad92$var$_toPropertyKey(t) {
    var i = $3b229d2234afad92$var$_toPrimitive(t, "string");
    return "symbol" == $3b229d2234afad92$var$_typeof(i) ? i : String(i);
}
function $3b229d2234afad92$var$_toPrimitive(t, r) {
    if ("object" != $3b229d2234afad92$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3b229d2234afad92$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3b229d2234afad92$var$_extends() {
    $3b229d2234afad92$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3b229d2234afad92$var$_extends.apply(this, arguments);
}
function $3b229d2234afad92$var$_slicedToArray(arr, i) {
    return $3b229d2234afad92$var$_arrayWithHoles(arr) || $3b229d2234afad92$var$_iterableToArrayLimit(arr, i) || $3b229d2234afad92$var$_unsupportedIterableToArray(arr, i) || $3b229d2234afad92$var$_nonIterableRest();
}
function $3b229d2234afad92$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3b229d2234afad92$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3b229d2234afad92$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3b229d2234afad92$var$_arrayLikeToArray(o, minLen);
}
function $3b229d2234afad92$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3b229d2234afad92$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3b229d2234afad92$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3b229d2234afad92$export$2e2bcd8739ae039(props) {
    var _classNames$popup, _styles$popup;
    var panelRender = props.panelRender, internalMode = props.internalMode, picker = props.picker, showNow = props.showNow, range = props.range, multiple = props.multiple, _props$activeInfo = props.activeInfo, activeInfo = _props$activeInfo === void 0 ? [
        0,
        0,
        0
    ] : _props$activeInfo, presets = props.presets, onPresetHover = props.onPresetHover, onPresetSubmit = props.onPresetSubmit, onFocus = props.onFocus, onBlur = props.onBlur, onPanelMouseDown = props.onPanelMouseDown, direction = props.direction, value = props.value, onSelect = props.onSelect, isInvalid = props.isInvalid, defaultOpenValue = props.defaultOpenValue, onOk = props.onOk, onSubmit = props.onSubmit, classNames = props.classNames, styles = props.styles;
    var _React$useContext = $ltGt3.useContext((0, $6158ac241550cb6d$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls;
    var panelPrefixCls = "".concat(prefixCls, "-panel");
    var rtl = direction === 'rtl';
    // ========================= Refs =========================
    var arrowRef = $ltGt3.useRef(null);
    var wrapperRef = $ltGt3.useRef(null);
    // ======================== Offset ========================
    var _React$useState = $ltGt3.useState(0), _React$useState2 = $3b229d2234afad92$var$_slicedToArray(_React$useState, 2), containerWidth = _React$useState2[0], setContainerWidth = _React$useState2[1];
    var _React$useState3 = $ltGt3.useState(0), _React$useState4 = $3b229d2234afad92$var$_slicedToArray(_React$useState3, 2), containerOffset = _React$useState4[0], setContainerOffset = _React$useState4[1];
    var _React$useState5 = $ltGt3.useState(0), _React$useState6 = $3b229d2234afad92$var$_slicedToArray(_React$useState5, 2), arrowOffset = _React$useState6[0], setArrowOffset = _React$useState6[1];
    var onResize = function onResize(info) {
        if (info.width) setContainerWidth(info.width);
    };
    var _activeInfo = $3b229d2234afad92$var$_slicedToArray(activeInfo, 3), activeInputLeft = _activeInfo[0], activeInputRight = _activeInfo[1], selectorWidth = _activeInfo[2];
    var _React$useState7 = $ltGt3.useState(0), _React$useState8 = $3b229d2234afad92$var$_slicedToArray(_React$useState7, 2), retryTimes = _React$useState8[0], setRetryTimes = _React$useState8[1];
    $ltGt3.useEffect(function() {
        setRetryTimes(10);
    }, [
        activeInputLeft
    ]);
    $ltGt3.useEffect(function() {
        // `activeOffset` is always align with the active input element
        // So we need only check container contains the `activeOffset`
        if (range && wrapperRef.current) {
            var _arrowRef$current;
            // Offset in case container has border radius
            var arrowWidth = ((_arrowRef$current = arrowRef.current) === null || _arrowRef$current === void 0 ? void 0 : _arrowRef$current.offsetWidth) || 0;
            // Arrow Offset
            var wrapperRect = wrapperRef.current.getBoundingClientRect();
            if (!wrapperRect.height || wrapperRect.right < 0) {
                setRetryTimes(function(times) {
                    return Math.max(0, times - 1);
                });
                return;
            }
            var nextArrowOffset = (rtl ? activeInputRight - arrowWidth : activeInputLeft) - wrapperRect.left;
            setArrowOffset(nextArrowOffset);
            // Container Offset
            if (containerWidth && containerWidth < selectorWidth) {
                var offset = rtl ? wrapperRect.right - (activeInputRight - arrowWidth + containerWidth) : activeInputLeft + arrowWidth - wrapperRect.left - containerWidth;
                var safeOffset = Math.max(0, offset);
                setContainerOffset(safeOffset);
            } else setContainerOffset(0);
        }
    }, [
        retryTimes,
        rtl,
        containerWidth,
        activeInputLeft,
        activeInputRight,
        selectorWidth,
        range
    ]);
    // ======================== Custom ========================
    function filterEmpty(list) {
        return list.filter(function(item) {
            return item;
        });
    }
    var valueList = $ltGt3.useMemo(function() {
        return filterEmpty((0, $4eaa081548444891$export$45b10814cc054894)(value));
    }, [
        value
    ]);
    var isTimePickerEmptyValue = picker === 'time' && !valueList.length;
    var footerSubmitValue = $ltGt3.useMemo(function() {
        if (isTimePickerEmptyValue) return filterEmpty([
            defaultOpenValue
        ]);
        return valueList;
    }, [
        isTimePickerEmptyValue,
        valueList,
        defaultOpenValue
    ]);
    var popupPanelValue = isTimePickerEmptyValue ? defaultOpenValue : valueList;
    var disableSubmit = $ltGt3.useMemo(function() {
        // Empty is invalid
        if (!footerSubmitValue.length) return true;
        return footerSubmitValue.some(function(val) {
            return isInvalid(val);
        });
    }, [
        footerSubmitValue,
        isInvalid
    ]);
    var onFooterSubmit = function onFooterSubmit() {
        // For TimePicker, we will additional trigger the value update
        if (isTimePickerEmptyValue) onSelect(defaultOpenValue);
        onOk();
        onSubmit();
    };
    var mergedNodes = /*#__PURE__*/ $ltGt3.createElement("div", {
        className: "".concat(prefixCls, "-panel-layout")
    }, /*#__PURE__*/ $ltGt3.createElement((0, $064e6a7ea945da16$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        presets: presets,
        onClick: onPresetSubmit,
        onHover: onPresetHover
    }), /*#__PURE__*/ $ltGt3.createElement("div", null, /*#__PURE__*/ $ltGt3.createElement((0, $9c407119b03bb838$export$2e2bcd8739ae039), $3b229d2234afad92$var$_extends({}, props, {
        value: popupPanelValue
    })), /*#__PURE__*/ $ltGt3.createElement((0, $f4794cf85a0d1f9d$export$2e2bcd8739ae039), $3b229d2234afad92$var$_extends({}, props, {
        showNow: multiple ? false : showNow,
        invalid: disableSubmit,
        onSubmit: onFooterSubmit
    }))));
    if (panelRender) mergedNodes = panelRender(mergedNodes);
    // ======================== Render ========================
    var containerPrefixCls = "".concat(panelPrefixCls, "-container");
    var marginLeft = 'marginLeft';
    var marginRight = 'marginRight';
    // Container
    var renderNode = /*#__PURE__*/ $ltGt3.createElement("div", {
        onMouseDown: onPanelMouseDown,
        tabIndex: -1,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(containerPrefixCls, "".concat(prefixCls, "-").concat(internalMode, "-panel-container"), classNames === null || classNames === void 0 || (_classNames$popup = classNames.popup) === null || _classNames$popup === void 0 ? void 0 : _classNames$popup.container),
        style: $3b229d2234afad92$var$_objectSpread($3b229d2234afad92$var$_defineProperty($3b229d2234afad92$var$_defineProperty({}, rtl ? marginRight : marginLeft, containerOffset), rtl ? marginLeft : marginRight, 'auto'), styles === null || styles === void 0 || (_styles$popup = styles.popup) === null || _styles$popup === void 0 ? void 0 : _styles$popup.container),
        onFocus: onFocus,
        onBlur: onBlur
    }, mergedNodes);
    if (range) renderNode = /*#__PURE__*/ $ltGt3.createElement("div", {
        onMouseDown: onPanelMouseDown,
        ref: wrapperRef,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)("".concat(prefixCls, "-range-wrapper"), "".concat(prefixCls, "-").concat(picker, "-range-wrapper"))
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: arrowRef,
        className: "".concat(prefixCls, "-range-arrow"),
        style: {
            left: arrowOffset
        }
    }), /*#__PURE__*/ $ltGt3.createElement((0, $9ed13185b45d829d$export$2e2bcd8739ae039), {
        onResize: onResize
    }, renderNode));
    return renderNode;
}






var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");

function $ec4a2baedee9fa3d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ec4a2baedee9fa3d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ec4a2baedee9fa3d$var$_typeof(o);
}
function $ec4a2baedee9fa3d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec4a2baedee9fa3d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec4a2baedee9fa3d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ec4a2baedee9fa3d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec4a2baedee9fa3d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ec4a2baedee9fa3d$var$_defineProperty(obj, key, value) {
    key = $ec4a2baedee9fa3d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ec4a2baedee9fa3d$var$_toPropertyKey(t) {
    var i = $ec4a2baedee9fa3d$var$_toPrimitive(t, "string");
    return "symbol" == $ec4a2baedee9fa3d$var$_typeof(i) ? i : String(i);
}
function $ec4a2baedee9fa3d$var$_toPrimitive(t, r) {
    if ("object" != $ec4a2baedee9fa3d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ec4a2baedee9fa3d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ec4a2baedee9fa3d$export$2e2bcd8739ae039(props, /** Used for SinglePicker */ postProps) {
    var format = props.format, maskFormat = props.maskFormat, generateConfig = props.generateConfig, locale = props.locale, preserveInvalidOnBlur = props.preserveInvalidOnBlur, inputReadOnly = props.inputReadOnly, required = props.required, ariaRequired = props['aria-required'], onSubmit = props.onSubmit, _onFocus = props.onFocus, _onBlur = props.onBlur, onInputChange = props.onInputChange, onInvalid = props.onInvalid, open = props.open, onOpenChange = props.onOpenChange, _onKeyDown = props.onKeyDown, _onChange = props.onChange, activeHelp = props.activeHelp, name = props.name, autoComplete = props.autoComplete, id = props.id, value = props.value, invalid = props.invalid, placeholder = props.placeholder, disabled = props.disabled, activeIndex = props.activeIndex, allHelp = props.allHelp, picker = props.picker;
    // ======================== Parser ========================
    var parseDate = function parseDate(str, formatStr) {
        var parsed = generateConfig.locale.parse(locale.locale, str, [
            formatStr
        ]);
        return parsed && generateConfig.isValidate(parsed) ? parsed : null;
    };
    // ========================= Text =========================
    var firstFormat = format[0];
    var getText = $ltGt3.useCallback(function(date) {
        return (0, $f655def3c887f075$export$7c4d25c0c3217d8c)(date, {
            locale: locale,
            format: firstFormat,
            generateConfig: generateConfig
        });
    }, [
        locale,
        generateConfig,
        firstFormat
    ]);
    var valueTexts = $ltGt3.useMemo(function() {
        return value.map(getText);
    }, [
        value,
        getText
    ]);
    // ========================= Size =========================
    var size = $ltGt3.useMemo(function() {
        var defaultSize = picker === 'time' ? 8 : 10;
        var length = typeof firstFormat === 'function' ? firstFormat(generateConfig.getNow()).length : firstFormat.length;
        return Math.max(defaultSize, length) + 2;
    }, [
        firstFormat,
        picker,
        generateConfig
    ]);
    // ======================= Validate =======================
    var _validateFormat = function validateFormat(text) {
        for(var i = 0; i < format.length; i += 1){
            var singleFormat = format[i];
            // Only support string type
            if (typeof singleFormat === 'string') {
                var parsed = parseDate(text, singleFormat);
                if (parsed) return parsed;
            }
        }
        return false;
    };
    // ======================== Input =========================
    var getInputProps = function getInputProps(index) {
        function getProp(propValue) {
            return index !== undefined ? propValue[index] : propValue;
        }
        var pickedAttrs = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(props, {
            aria: true,
            data: true
        });
        var inputProps = $ec4a2baedee9fa3d$var$_objectSpread($ec4a2baedee9fa3d$var$_objectSpread({}, pickedAttrs), {}, {
            // ============== Shared ==============
            format: maskFormat,
            validateFormat: function validateFormat(text) {
                return !!_validateFormat(text);
            },
            preserveInvalidOnBlur: preserveInvalidOnBlur,
            readOnly: inputReadOnly,
            required: required,
            'aria-required': ariaRequired,
            name: name,
            autoComplete: autoComplete,
            size: size,
            // ============= By Index =============
            id: getProp(id),
            value: getProp(valueTexts) || '',
            invalid: getProp(invalid),
            placeholder: getProp(placeholder),
            active: activeIndex === index,
            helped: allHelp || activeHelp && activeIndex === index,
            disabled: getProp(disabled),
            onFocus: function onFocus(event) {
                _onFocus(event, index);
            },
            onBlur: function onBlur(event) {
                // Blur do not trigger close
                // Since it may focus to the popup panel
                _onBlur(event, index);
            },
            onSubmit: onSubmit,
            // Get validate text value
            onChange: function onChange(text) {
                onInputChange();
                var parsed = _validateFormat(text);
                if (parsed) {
                    onInvalid(false, index);
                    _onChange(parsed, index);
                    return;
                }
                // Tell outer that the value typed is invalid.
                // If text is empty, it means valid.
                onInvalid(!!text, index);
            },
            onHelp: function onHelp() {
                onOpenChange(true, {
                    index: index
                });
            },
            onKeyDown: function onKeyDown(event) {
                var prevented = false;
                _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(event, function() {
                    prevented = true;
                });
                if (!event.defaultPrevented && !prevented) switch(event.key){
                    case 'Escape':
                        onOpenChange(false, {
                            index: index
                        });
                        break;
                    case 'Enter':
                        if (!open) onOpenChange(true);
                        break;
                }
            }
        }, postProps === null || postProps === void 0 ? void 0 : postProps({
            valueTexts: valueTexts
        }));
        // ============== Clean Up ==============
        Object.keys(inputProps).forEach(function(key) {
            if (inputProps[key] === undefined) delete inputProps[key];
        });
        return inputProps;
    };
    return [
        getInputProps,
        getText
    ];
}



var $ltGt3 = parcelRequire("ltGt3");

var $56250a77f611428b$var$propNames = [
    'onMouseEnter',
    'onMouseLeave'
];
function $56250a77f611428b$export$2e2bcd8739ae039(props) {
    return $ltGt3.useMemo(function() {
        return (0, $4eaa081548444891$export$1b696fb20abaa06c)(props, $56250a77f611428b$var$propNames);
    }, [
        props
    ]);
}



var $ltGt3 = parcelRequire("ltGt3");


var $88c200921d22d915$var$_excluded = [
    "icon",
    "type"
], $88c200921d22d915$var$_excluded2 = [
    "onClear"
];
function $88c200921d22d915$var$_extends() {
    $88c200921d22d915$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $88c200921d22d915$var$_extends.apply(this, arguments);
}
function $88c200921d22d915$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $88c200921d22d915$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $88c200921d22d915$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $88c200921d22d915$export$2e2bcd8739ae039(props) {
    var icon = props.icon, type = props.type, restProps = $88c200921d22d915$var$_objectWithoutProperties(props, $88c200921d22d915$var$_excluded);
    var _React$useContext = $ltGt3.useContext((0, $6158ac241550cb6d$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, classNames = _React$useContext.classNames, styles = _React$useContext.styles;
    return icon ? /*#__PURE__*/ $ltGt3.createElement("span", $88c200921d22d915$var$_extends({
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)("".concat(prefixCls, "-").concat(type), classNames.suffix),
        style: styles.suffix
    }, restProps), icon) : null;
}
function $88c200921d22d915$export$cefbac224a47f32(_ref) {
    var onClear = _ref.onClear, restProps = $88c200921d22d915$var$_objectWithoutProperties(_ref, $88c200921d22d915$var$_excluded2);
    return /*#__PURE__*/ $ltGt3.createElement($88c200921d22d915$export$2e2bcd8739ae039, $88c200921d22d915$var$_extends({}, restProps, {
        type: "clear",
        role: "button",
        onMouseDown: function onMouseDown(e) {
            e.preventDefault();
        },
        onClick: function onClick(e) {
            e.stopPropagation();
            onClear();
        }
    }));
}







var $ltGt3 = parcelRequire("ltGt3");




function $5a1f4941ea3a4f70$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5a1f4941ea3a4f70$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5a1f4941ea3a4f70$var$_typeof(o);
}
function $5a1f4941ea3a4f70$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5a1f4941ea3a4f70$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5a1f4941ea3a4f70$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5a1f4941ea3a4f70$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5a1f4941ea3a4f70$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5a1f4941ea3a4f70$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5a1f4941ea3a4f70$var$_defineProperty(obj, key, value) {
    key = $5a1f4941ea3a4f70$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5a1f4941ea3a4f70$var$_toPropertyKey(t) {
    var i = $5a1f4941ea3a4f70$var$_toPrimitive(t, "string");
    return "symbol" == $5a1f4941ea3a4f70$var$_typeof(i) ? i : String(i);
}
function $5a1f4941ea3a4f70$var$_toPrimitive(t, r) {
    if ("object" != $5a1f4941ea3a4f70$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5a1f4941ea3a4f70$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $5a1f4941ea3a4f70$var$FORMAT_KEYS = [
    'YYYY',
    'MM',
    'DD',
    'HH',
    'mm',
    'ss',
    'SSS'
];
// Use Chinese character to avoid conflict with the mask format
var $5a1f4941ea3a4f70$var$REPLACE_KEY = "\u9867";
var $5a1f4941ea3a4f70$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function MaskFormat(format) {
        $5a1f4941ea3a4f70$var$_classCallCheck(this, MaskFormat);
        $5a1f4941ea3a4f70$var$_defineProperty(this, "format", void 0);
        $5a1f4941ea3a4f70$var$_defineProperty(this, "maskFormat", void 0);
        $5a1f4941ea3a4f70$var$_defineProperty(this, "cells", void 0);
        $5a1f4941ea3a4f70$var$_defineProperty(this, "maskCells", void 0);
        this.format = format;
        // Generate mask format
        var replaceKeys = $5a1f4941ea3a4f70$var$FORMAT_KEYS.map(function(key) {
            return "(".concat(key, ")");
        }).join('|');
        var replaceReg = new RegExp(replaceKeys, 'g');
        this.maskFormat = format.replace(replaceReg, // Use Chinese character to avoid user use it in format
        function(key) {
            return $5a1f4941ea3a4f70$var$REPLACE_KEY.repeat(key.length);
        });
        // Generate cells
        var cellReg = new RegExp("(".concat($5a1f4941ea3a4f70$var$FORMAT_KEYS.join('|'), ")"));
        var strCells = (format.split(cellReg) || []).filter(function(str) {
            return str;
        });
        var offset = 0;
        this.cells = strCells.map(function(text) {
            var mask = $5a1f4941ea3a4f70$var$FORMAT_KEYS.includes(text);
            var start = offset;
            var end = offset + text.length;
            offset = end;
            return {
                text: text,
                mask: mask,
                start: start,
                end: end
            };
        });
        // Mask cells
        this.maskCells = this.cells.filter(function(cell) {
            return cell.mask;
        });
    }
    $5a1f4941ea3a4f70$var$_createClass(MaskFormat, [
        {
            key: "getSelection",
            value: function getSelection(maskCellIndex) {
                var _ref = this.maskCells[maskCellIndex] || {}, start = _ref.start, end = _ref.end;
                return [
                    start || 0,
                    end || 0
                ];
            }
        },
        {
            key: "match",
            value: function match(text) {
                for(var i = 0; i < this.maskFormat.length; i += 1){
                    var maskChar = this.maskFormat[i];
                    var textChar = text[i];
                    if (!textChar || maskChar !== $5a1f4941ea3a4f70$var$REPLACE_KEY && maskChar !== textChar) return false;
                }
                return true;
            }
        },
        {
            key: "size",
            value: function size() {
                return this.maskCells.length;
            }
        },
        {
            key: "getMaskCellIndex",
            value: function getMaskCellIndex(anchorIndex) {
                var closetDist = Number.MAX_SAFE_INTEGER;
                var closetIndex = 0;
                for(var i = 0; i < this.maskCells.length; i += 1){
                    var _this$maskCells$i = this.maskCells[i], start = _this$maskCells$i.start, end = _this$maskCells$i.end;
                    if (anchorIndex >= start && anchorIndex <= end) return i;
                    var dist = Math.min(Math.abs(anchorIndex - start), Math.abs(anchorIndex - end));
                    if (dist < closetDist) {
                        closetDist = dist;
                        closetIndex = i;
                    }
                }
                return closetIndex;
            }
        }
    ]);
    return MaskFormat;
}();


function $9ada578b6c286f1e$export$8272b5e4a0ae610e(key) {
    var PresetRange = {
        YYYY: [
            0,
            9999,
            new Date().getFullYear()
        ],
        MM: [
            1,
            12
        ],
        DD: [
            1,
            31
        ],
        HH: [
            0,
            23
        ],
        mm: [
            0,
            59
        ],
        ss: [
            0,
            59
        ],
        SSS: [
            0,
            999
        ]
    };
    return PresetRange[key];
}


function $ef28e89ecf767faa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ef28e89ecf767faa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ef28e89ecf767faa$var$_typeof(o);
}
var $ef28e89ecf767faa$var$_excluded = [
    "className",
    "active",
    "showActiveCls",
    "suffixIcon",
    "format",
    "validateFormat",
    "onChange",
    "onInput",
    "helped",
    "onHelp",
    "onSubmit",
    "onKeyDown",
    "preserveInvalidOnBlur",
    "invalid",
    "clearIcon"
];
function $ef28e89ecf767faa$var$_extends() {
    $ef28e89ecf767faa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ef28e89ecf767faa$var$_extends.apply(this, arguments);
}
function $ef28e89ecf767faa$var$_defineProperty(obj, key, value) {
    key = $ef28e89ecf767faa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ef28e89ecf767faa$var$_toPropertyKey(t) {
    var i = $ef28e89ecf767faa$var$_toPrimitive(t, "string");
    return "symbol" == $ef28e89ecf767faa$var$_typeof(i) ? i : String(i);
}
function $ef28e89ecf767faa$var$_toPrimitive(t, r) {
    if ("object" != $ef28e89ecf767faa$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ef28e89ecf767faa$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ef28e89ecf767faa$var$_slicedToArray(arr, i) {
    return $ef28e89ecf767faa$var$_arrayWithHoles(arr) || $ef28e89ecf767faa$var$_iterableToArrayLimit(arr, i) || $ef28e89ecf767faa$var$_unsupportedIterableToArray(arr, i) || $ef28e89ecf767faa$var$_nonIterableRest();
}
function $ef28e89ecf767faa$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ef28e89ecf767faa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ef28e89ecf767faa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ef28e89ecf767faa$var$_arrayLikeToArray(o, minLen);
}
function $ef28e89ecf767faa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ef28e89ecf767faa$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ef28e89ecf767faa$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ef28e89ecf767faa$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ef28e89ecf767faa$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ef28e89ecf767faa$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Format logic
//
// First time on focus:
//  1. check if the text is valid, if not fill with format
//  2. set highlight cell to the first cell
// Cells
//  1. Selection the index cell, set inner `cacheValue` to ''
//  2. Key input filter non-number char, patch after the `cacheValue`
//    1. Replace the `cacheValue` with input align the cell length
//    2. Re-selection the mask cell
//  3. If `cacheValue` match the limit length or cell format (like 1 ~ 12 month), go to next cell
var $ef28e89ecf767faa$var$Input = /*#__PURE__*/ $ltGt3.forwardRef(function(props, ref) {
    var className = props.className, active = props.active, _props$showActiveCls = props.showActiveCls, showActiveCls = _props$showActiveCls === void 0 ? true : _props$showActiveCls, suffixIcon = props.suffixIcon, format = props.format, validateFormat = props.validateFormat, onChange = props.onChange, onInput = props.onInput, helped = props.helped, onHelp = props.onHelp, onSubmit = props.onSubmit, onKeyDown = props.onKeyDown, _props$preserveInvali = props.preserveInvalidOnBlur, preserveInvalidOnBlur = _props$preserveInvali === void 0 ? false : _props$preserveInvali, invalid = props.invalid, clearIcon = props.clearIcon, restProps = $ef28e89ecf767faa$var$_objectWithoutProperties(props, $ef28e89ecf767faa$var$_excluded);
    var value = props.value, onFocus = props.onFocus, onBlur = props.onBlur, onMouseUp = props.onMouseUp;
    var _React$useContext = $ltGt3.useContext((0, $6158ac241550cb6d$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, _React$useContext$inp = _React$useContext.input, Component = _React$useContext$inp === void 0 ? 'input' : _React$useContext$inp, classNames = _React$useContext.classNames, styles = _React$useContext.styles;
    var inputPrefixCls = "".concat(prefixCls, "-input");
    // ======================== Value =========================
    var _React$useState = $ltGt3.useState(false), _React$useState2 = $ef28e89ecf767faa$var$_slicedToArray(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
    var _React$useState3 = $ltGt3.useState(value), _React$useState4 = $ef28e89ecf767faa$var$_slicedToArray(_React$useState3, 2), internalInputValue = _React$useState4[0], setInputValue = _React$useState4[1];
    var _React$useState5 = $ltGt3.useState(''), _React$useState6 = $ef28e89ecf767faa$var$_slicedToArray(_React$useState5, 2), focusCellText = _React$useState6[0], setFocusCellText = _React$useState6[1];
    var _React$useState7 = $ltGt3.useState(null), _React$useState8 = $ef28e89ecf767faa$var$_slicedToArray(_React$useState7, 2), focusCellIndex = _React$useState8[0], setFocusCellIndex = _React$useState8[1];
    var _React$useState9 = $ltGt3.useState(null), _React$useState10 = $ef28e89ecf767faa$var$_slicedToArray(_React$useState9, 2), forceSelectionSyncMark = _React$useState10[0], forceSelectionSync = _React$useState10[1];
    var inputValue = internalInputValue || '';
    // Sync value if needed
    $ltGt3.useEffect(function() {
        setInputValue(value);
    }, [
        value
    ]);
    // ========================= Refs =========================
    var holderRef = $ltGt3.useRef(null);
    var inputRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, function() {
        return {
            nativeElement: holderRef.current,
            inputElement: inputRef.current,
            focus: function focus(options) {
                inputRef.current.focus(options);
            },
            blur: function blur() {
                inputRef.current.blur();
            }
        };
    });
    // ======================== Format ========================
    var maskFormat = $ltGt3.useMemo(function() {
        return new (0, $5a1f4941ea3a4f70$export$2e2bcd8739ae039)(format || '');
    }, [
        format
    ]);
    var _React$useMemo = $ltGt3.useMemo(function() {
        if (helped) return [
            0,
            0
        ];
        return maskFormat.getSelection(focusCellIndex);
    }, [
        maskFormat,
        focusCellIndex,
        helped
    ]), _React$useMemo2 = $ef28e89ecf767faa$var$_slicedToArray(_React$useMemo, 2), selectionStart = _React$useMemo2[0], selectionEnd = _React$useMemo2[1];
    // ======================== Modify ========================
    // When input modify content, trigger `onHelp` if is not the format
    var onModify = function onModify(text) {
        if (text && text !== format && text !== value) onHelp();
    };
    // ======================== Change ========================
    /**
   * Triggered by paste, keyDown and focus to show format
   */ var triggerInputChange = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(text) {
        if (validateFormat(text)) onChange(text);
        setInputValue(text);
        onModify(text);
    });
    // Directly trigger `onChange` if `format` is empty
    var onInternalChange = function onInternalChange(event) {
        // Hack `onChange` with format to do nothing
        if (!format) {
            var text = event.target.value;
            onModify(text);
            setInputValue(text);
            onChange(text);
        }
    };
    var onFormatPaste = function onFormatPaste(event) {
        // Get paste text
        var pasteText = event.clipboardData.getData('text');
        if (validateFormat(pasteText)) triggerInputChange(pasteText);
    };
    // ======================== Mouse =========================
    // When `mouseDown` get focus, it's better to not to change the selection
    // Since the up position maybe not is the first cell
    var mouseDownRef = $ltGt3.useRef(false);
    var onFormatMouseDown = function onFormatMouseDown() {
        mouseDownRef.current = true;
    };
    var onFormatMouseUp = function onFormatMouseUp(event) {
        var _ref = event.target, start = _ref.selectionStart;
        var closeMaskIndex = maskFormat.getMaskCellIndex(start);
        setFocusCellIndex(closeMaskIndex);
        // Force update the selection
        forceSelectionSync({});
        onMouseUp === null || onMouseUp === void 0 || onMouseUp(event);
        mouseDownRef.current = false;
    };
    // ====================== Focus Blur ======================
    var onFormatFocus = function onFormatFocus(event) {
        setFocused(true);
        setFocusCellIndex(0);
        setFocusCellText('');
        onFocus(event);
    };
    var onSharedBlur = function onSharedBlur(event) {
        onBlur(event);
    };
    var onFormatBlur = function onFormatBlur(event) {
        setFocused(false);
        onSharedBlur(event);
    };
    // ======================== Active ========================
    // Check if blur need reset input value
    (0, $5282d4a7d1ae4971$export$2e2bcd8739ae039)(active, function() {
        if (!active && !preserveInvalidOnBlur) setInputValue(value);
    });
    // ======================= Keyboard =======================
    var onSharedKeyDown = function onSharedKeyDown(event) {
        if (event.key === 'Enter' && validateFormat(inputValue)) onSubmit();
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);
    };
    var onFormatKeyDown = function onFormatKeyDown(event) {
        onSharedKeyDown(event);
        var key = event.key;
        // Save the cache with cell text
        var nextCellText = null;
        // Fill in the input
        var nextFillText = null;
        var maskCellLen = selectionEnd - selectionStart;
        var cellFormat = format.slice(selectionStart, selectionEnd);
        // Cell Index
        var offsetCellIndex = function offsetCellIndex(offset) {
            setFocusCellIndex(function(idx) {
                var nextIndex = idx + offset;
                nextIndex = Math.max(nextIndex, 0);
                nextIndex = Math.min(nextIndex, maskFormat.size() - 1);
                return nextIndex;
            });
        };
        // Range
        var offsetCellValue = function offsetCellValue(offset) {
            var _getMaskRange = (0, $9ada578b6c286f1e$export$8272b5e4a0ae610e)(cellFormat), _getMaskRange2 = $ef28e89ecf767faa$var$_slicedToArray(_getMaskRange, 3), rangeStart = _getMaskRange2[0], rangeEnd = _getMaskRange2[1], rangeDefault = _getMaskRange2[2];
            var currentText = inputValue.slice(selectionStart, selectionEnd);
            var currentTextNum = Number(currentText);
            if (isNaN(currentTextNum)) return String(rangeDefault ? rangeDefault : offset > 0 ? rangeStart : rangeEnd);
            var num = currentTextNum + offset;
            var range = rangeEnd - rangeStart + 1;
            return String(rangeStart + (range + num - rangeStart) % range);
        };
        switch(key){
            // =============== Remove ===============
            case 'Backspace':
            case 'Delete':
                nextCellText = '';
                nextFillText = cellFormat;
                break;
            // =============== Arrows ===============
            // Left key
            case 'ArrowLeft':
                nextCellText = '';
                offsetCellIndex(-1);
                break;
            // Right key
            case 'ArrowRight':
                nextCellText = '';
                offsetCellIndex(1);
                break;
            // Up key
            case 'ArrowUp':
                nextCellText = '';
                nextFillText = offsetCellValue(1);
                break;
            // Down key
            case 'ArrowDown':
                nextCellText = '';
                nextFillText = offsetCellValue(-1);
                break;
            // =============== Number ===============
            default:
                if (!isNaN(Number(key))) {
                    nextCellText = focusCellText + key;
                    nextFillText = nextCellText;
                }
                break;
        }
        // Update cell text
        if (nextCellText !== null) {
            setFocusCellText(nextCellText);
            if (nextCellText.length >= maskCellLen) {
                // Go to next cell
                offsetCellIndex(1);
                setFocusCellText('');
            }
        }
        // Update the input text
        if (nextFillText !== null) {
            // Replace selection range with `nextCellText`
            var nextFocusValue = // before
            inputValue.slice(0, selectionStart) + // replace
            (0, $4eaa081548444891$export$cbb503201166aab7)(nextFillText, maskCellLen) + // after
            inputValue.slice(selectionEnd);
            triggerInputChange(nextFocusValue.slice(0, format.length));
        }
        // Always trigger selection sync after key down
        forceSelectionSync({});
    };
    // ======================== Format ========================
    var rafRef = $ltGt3.useRef();
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(function() {
        if (!focused || !format || mouseDownRef.current) return;
        // Reset with format if not match
        if (!maskFormat.match(inputValue)) {
            triggerInputChange(format);
            return;
        }
        // Match the selection range
        inputRef.current.setSelectionRange(selectionStart, selectionEnd);
        // Chrome has the bug anchor position looks not correct but actually correct
        rafRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(function() {
            inputRef.current.setSelectionRange(selectionStart, selectionEnd);
        });
        return function() {
            (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(rafRef.current);
        };
    }, [
        maskFormat,
        format,
        focused,
        inputValue,
        focusCellIndex,
        selectionStart,
        selectionEnd,
        forceSelectionSyncMark,
        triggerInputChange
    ]);
    // ======================== Render ========================
    // Input props for format
    var inputProps = format ? {
        onFocus: onFormatFocus,
        onBlur: onFormatBlur,
        onKeyDown: onFormatKeyDown,
        onMouseDown: onFormatMouseDown,
        onMouseUp: onFormatMouseUp,
        onPaste: onFormatPaste
    } : {};
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: holderRef,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(inputPrefixCls, $ef28e89ecf767faa$var$_defineProperty($ef28e89ecf767faa$var$_defineProperty({}, "".concat(inputPrefixCls, "-active"), active && showActiveCls), "".concat(inputPrefixCls, "-placeholder"), helped), className)
    }, /*#__PURE__*/ $ltGt3.createElement(Component, $ef28e89ecf767faa$var$_extends({
        ref: inputRef,
        "aria-invalid": invalid,
        autoComplete: "off"
    }, restProps, {
        onKeyDown: onSharedKeyDown,
        onBlur: onSharedBlur
    }, inputProps, {
        // Value
        value: inputValue,
        onChange: onInternalChange,
        className: classNames.input,
        style: styles.input
    })), /*#__PURE__*/ $ltGt3.createElement((0, $88c200921d22d915$export$2e2bcd8739ae039), {
        type: "suffix",
        icon: suffixIcon
    }), clearIcon);
});
var $ef28e89ecf767faa$export$2e2bcd8739ae039 = $ef28e89ecf767faa$var$Input;


var $080dfef780a79a72$var$_excluded = [
    "id",
    "prefix",
    "clearIcon",
    "suffixIcon",
    "separator",
    "activeIndex",
    "activeHelp",
    "allHelp",
    "focused",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "locale",
    "generateConfig",
    "placeholder",
    "className",
    "style",
    "onClick",
    "onClear",
    "value",
    "onChange",
    "onSubmit",
    "onInputChange",
    "format",
    "maskFormat",
    "preserveInvalidOnBlur",
    "onInvalid",
    "disabled",
    "invalid",
    "inputReadOnly",
    "direction",
    "onOpenChange",
    "onActiveInfo",
    "placement",
    "onMouseDown",
    "required",
    "aria-required",
    "autoFocus",
    "tabIndex"
], $080dfef780a79a72$var$_excluded2 = [
    "index"
];
function $080dfef780a79a72$var$_extends() {
    $080dfef780a79a72$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $080dfef780a79a72$var$_extends.apply(this, arguments);
}
function $080dfef780a79a72$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $080dfef780a79a72$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $080dfef780a79a72$var$ownKeys(Object(t), !0).forEach(function(r) {
            $080dfef780a79a72$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $080dfef780a79a72$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $080dfef780a79a72$var$_defineProperty(obj, key, value) {
    key = $080dfef780a79a72$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $080dfef780a79a72$var$_toPropertyKey(t) {
    var i = $080dfef780a79a72$var$_toPrimitive(t, "string");
    return "symbol" == $080dfef780a79a72$var$_typeof(i) ? i : String(i);
}
function $080dfef780a79a72$var$_toPrimitive(t, r) {
    if ("object" != $080dfef780a79a72$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $080dfef780a79a72$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $080dfef780a79a72$var$_slicedToArray(arr, i) {
    return $080dfef780a79a72$var$_arrayWithHoles(arr) || $080dfef780a79a72$var$_iterableToArrayLimit(arr, i) || $080dfef780a79a72$var$_unsupportedIterableToArray(arr, i) || $080dfef780a79a72$var$_nonIterableRest();
}
function $080dfef780a79a72$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $080dfef780a79a72$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $080dfef780a79a72$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $080dfef780a79a72$var$_arrayLikeToArray(o, minLen);
}
function $080dfef780a79a72$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $080dfef780a79a72$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $080dfef780a79a72$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $080dfef780a79a72$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $080dfef780a79a72$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $080dfef780a79a72$var$_typeof(o);
}
function $080dfef780a79a72$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $080dfef780a79a72$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $080dfef780a79a72$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $080dfef780a79a72$var$RangeSelector(props, ref) {
    var id = props.id, prefix = props.prefix, clearIcon = props.clearIcon, suffixIcon = props.suffixIcon, _props$separator = props.separator, separator = _props$separator === void 0 ? '~' : _props$separator, activeIndex = props.activeIndex, activeHelp = props.activeHelp, allHelp = props.allHelp, focused = props.focused, onFocus = props.onFocus, onBlur = props.onBlur, onKeyDown = props.onKeyDown, locale = props.locale, generateConfig = props.generateConfig, placeholder = props.placeholder, className = props.className, style = props.style, onClick = props.onClick, onClear = props.onClear, value = props.value, onChange = props.onChange, onSubmit = props.onSubmit, onInputChange = props.onInputChange, format = props.format, maskFormat = props.maskFormat, preserveInvalidOnBlur = props.preserveInvalidOnBlur, onInvalid = props.onInvalid, disabled = props.disabled, invalid = props.invalid, inputReadOnly = props.inputReadOnly, direction = props.direction, onOpenChange = props.onOpenChange, onActiveInfo = props.onActiveInfo, placement = props.placement, _onMouseDown = props.onMouseDown, required = props.required, ariaRequired = props['aria-required'], autoFocus = props.autoFocus, tabIndex = props.tabIndex, restProps = $080dfef780a79a72$var$_objectWithoutProperties(props, $080dfef780a79a72$var$_excluded);
    var rtl = direction === 'rtl';
    // ======================== Prefix ========================
    var _React$useContext = $ltGt3.useContext((0, $6158ac241550cb6d$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, classNames = _React$useContext.classNames, styles = _React$useContext.styles;
    // ========================== Id ==========================
    var ids = $ltGt3.useMemo(function() {
        if (typeof id === 'string') return [
            id
        ];
        var mergedId = id || {};
        return [
            mergedId.start,
            mergedId.end
        ];
    }, [
        id
    ]);
    // ========================= Refs =========================
    var rootRef = $ltGt3.useRef();
    var inputStartRef = $ltGt3.useRef();
    var inputEndRef = $ltGt3.useRef();
    var getInput = function getInput(index) {
        var _index;
        return (_index = [
            inputStartRef,
            inputEndRef
        ][index]) === null || _index === void 0 ? void 0 : _index.current;
    };
    $ltGt3.useImperativeHandle(ref, function() {
        return {
            nativeElement: rootRef.current,
            focus: function focus(options) {
                if ($080dfef780a79a72$var$_typeof(options) === 'object') {
                    var _getInput;
                    var _ref = options || {}, _ref$index = _ref.index, _index2 = _ref$index === void 0 ? 0 : _ref$index, rest = $080dfef780a79a72$var$_objectWithoutProperties(_ref, $080dfef780a79a72$var$_excluded2);
                    (_getInput = getInput(_index2)) === null || _getInput === void 0 || _getInput.focus(rest);
                } else {
                    var _getInput2;
                    (_getInput2 = getInput(options !== null && options !== void 0 ? options : 0)) === null || _getInput2 === void 0 || _getInput2.focus();
                }
            },
            blur: function blur() {
                var _getInput3, _getInput4;
                (_getInput3 = getInput(0)) === null || _getInput3 === void 0 || _getInput3.blur();
                (_getInput4 = getInput(1)) === null || _getInput4 === void 0 || _getInput4.blur();
            }
        };
    });
    // ======================== Props =========================
    var rootProps = (0, $56250a77f611428b$export$2e2bcd8739ae039)(restProps);
    // ===================== Placeholder ======================
    var mergedPlaceholder = $ltGt3.useMemo(function() {
        return Array.isArray(placeholder) ? placeholder : [
            placeholder,
            placeholder
        ];
    }, [
        placeholder
    ]);
    // ======================== Inputs ========================
    var _useInputProps = (0, $ec4a2baedee9fa3d$export$2e2bcd8739ae039)($080dfef780a79a72$var$_objectSpread($080dfef780a79a72$var$_objectSpread({}, props), {}, {
        id: ids,
        placeholder: mergedPlaceholder
    })), _useInputProps2 = $080dfef780a79a72$var$_slicedToArray(_useInputProps, 1), getInputProps = _useInputProps2[0];
    // ====================== ActiveBar =======================
    var _React$useState = $ltGt3.useState({
        position: 'absolute',
        width: 0
    }), _React$useState2 = $080dfef780a79a72$var$_slicedToArray(_React$useState, 2), activeBarStyle = _React$useState2[0], setActiveBarStyle = _React$useState2[1];
    var syncActiveOffset = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function() {
        var input = getInput(activeIndex);
        if (input) {
            var inputRect = input.nativeElement.getBoundingClientRect();
            var parentRect = rootRef.current.getBoundingClientRect();
            var rectOffset = inputRect.left - parentRect.left;
            setActiveBarStyle(function(ori) {
                return $080dfef780a79a72$var$_objectSpread($080dfef780a79a72$var$_objectSpread({}, ori), {}, {
                    width: inputRect.width,
                    left: rectOffset
                });
            });
            onActiveInfo([
                inputRect.left,
                inputRect.right,
                parentRect.width
            ]);
        }
    });
    $ltGt3.useEffect(function() {
        syncActiveOffset();
    }, [
        activeIndex
    ]);
    // ======================== Clear =========================
    var showClear = clearIcon && (value[0] && !disabled[0] || value[1] && !disabled[1]);
    // ======================= Disabled =======================
    var startAutoFocus = autoFocus && !disabled[0];
    var endAutoFocus = autoFocus && !startAutoFocus && !disabled[1];
    // ======================== Render ========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $9ed13185b45d829d$export$2e2bcd8739ae039), {
        onResize: syncActiveOffset
    }, /*#__PURE__*/ $ltGt3.createElement("div", $080dfef780a79a72$var$_extends({}, rootProps, {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, "".concat(prefixCls, "-range"), $080dfef780a79a72$var$_defineProperty($080dfef780a79a72$var$_defineProperty($080dfef780a79a72$var$_defineProperty($080dfef780a79a72$var$_defineProperty({}, "".concat(prefixCls, "-focused"), focused), "".concat(prefixCls, "-disabled"), disabled.every(function(i) {
            return i;
        })), "".concat(prefixCls, "-invalid"), invalid.some(function(i) {
            return i;
        })), "".concat(prefixCls, "-rtl"), rtl), className),
        style: style,
        ref: rootRef,
        onClick: onClick,
        onMouseDown: function onMouseDown(e) {
            var target = e.target;
            if (target !== inputStartRef.current.inputElement && target !== inputEndRef.current.inputElement) e.preventDefault();
            _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(e);
        }
    }), prefix && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)("".concat(prefixCls, "-prefix"), classNames.prefix),
        style: styles.prefix
    }, prefix), /*#__PURE__*/ $ltGt3.createElement((0, $ef28e89ecf767faa$export$2e2bcd8739ae039), $080dfef780a79a72$var$_extends({
        ref: inputStartRef
    }, getInputProps(0), {
        className: "".concat(prefixCls, "-input-start"),
        autoFocus: startAutoFocus,
        tabIndex: tabIndex,
        "date-range": "start"
    })), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: "".concat(prefixCls, "-range-separator")
    }, separator), /*#__PURE__*/ $ltGt3.createElement((0, $ef28e89ecf767faa$export$2e2bcd8739ae039), $080dfef780a79a72$var$_extends({
        ref: inputEndRef
    }, getInputProps(1), {
        className: "".concat(prefixCls, "-input-end"),
        autoFocus: endAutoFocus,
        tabIndex: tabIndex,
        "date-range": "end"
    })), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: "".concat(prefixCls, "-active-bar"),
        style: activeBarStyle
    }), /*#__PURE__*/ $ltGt3.createElement((0, $88c200921d22d915$export$2e2bcd8739ae039), {
        type: "suffix",
        icon: suffixIcon
    }), showClear && /*#__PURE__*/ $ltGt3.createElement((0, $88c200921d22d915$export$cefbac224a47f32), {
        icon: clearIcon,
        onClear: onClear
    })));
}
var $080dfef780a79a72$var$RefRangeSelector = /*#__PURE__*/ $ltGt3.forwardRef($080dfef780a79a72$var$RangeSelector);
var $080dfef780a79a72$export$2e2bcd8739ae039 = $080dfef780a79a72$var$RefRangeSelector;



var $ltGt3 = parcelRequire("ltGt3");
function $0c0cc01c9f4b3431$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0c0cc01c9f4b3431$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0c0cc01c9f4b3431$var$_typeof(o);
}
function $0c0cc01c9f4b3431$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c0cc01c9f4b3431$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c0cc01c9f4b3431$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0c0cc01c9f4b3431$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c0cc01c9f4b3431$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0c0cc01c9f4b3431$var$_defineProperty(obj, key, value) {
    key = $0c0cc01c9f4b3431$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0c0cc01c9f4b3431$var$_toPropertyKey(t) {
    var i = $0c0cc01c9f4b3431$var$_toPrimitive(t, "string");
    return "symbol" == $0c0cc01c9f4b3431$var$_typeof(i) ? i : String(i);
}
function $0c0cc01c9f4b3431$var$_toPrimitive(t, r) {
    if ("object" != $0c0cc01c9f4b3431$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0c0cc01c9f4b3431$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0c0cc01c9f4b3431$export$2e2bcd8739ae039(classNames, styles) {
    return (0, $ltGt3.useMemo)(function() {
        var mergedClassNames = $0c0cc01c9f4b3431$var$_objectSpread($0c0cc01c9f4b3431$var$_objectSpread({}, classNames), {}, {
            popup: (classNames === null || classNames === void 0 ? void 0 : classNames.popup) || {}
        });
        var mergedStyles = $0c0cc01c9f4b3431$var$_objectSpread($0c0cc01c9f4b3431$var$_objectSpread({}, styles), {}, {
            popup: (styles === null || styles === void 0 ? void 0 : styles.popup) || {}
        });
        return [
            mergedClassNames,
            mergedStyles
        ];
    }, [
        classNames,
        styles
    ]);
}


function $2ffff18146ce6002$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ffff18146ce6002$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ffff18146ce6002$var$_typeof(o);
}
function $2ffff18146ce6002$var$_extends() {
    $2ffff18146ce6002$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2ffff18146ce6002$var$_extends.apply(this, arguments);
}
function $2ffff18146ce6002$var$_toConsumableArray(arr) {
    return $2ffff18146ce6002$var$_arrayWithoutHoles(arr) || $2ffff18146ce6002$var$_iterableToArray(arr) || $2ffff18146ce6002$var$_unsupportedIterableToArray(arr) || $2ffff18146ce6002$var$_nonIterableSpread();
}
function $2ffff18146ce6002$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2ffff18146ce6002$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $2ffff18146ce6002$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2ffff18146ce6002$var$_arrayLikeToArray(arr);
}
function $2ffff18146ce6002$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ffff18146ce6002$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ffff18146ce6002$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2ffff18146ce6002$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ffff18146ce6002$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2ffff18146ce6002$var$_defineProperty(obj, key, value) {
    key = $2ffff18146ce6002$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2ffff18146ce6002$var$_toPropertyKey(t) {
    var i = $2ffff18146ce6002$var$_toPrimitive(t, "string");
    return "symbol" == $2ffff18146ce6002$var$_typeof(i) ? i : String(i);
}
function $2ffff18146ce6002$var$_toPrimitive(t, r) {
    if ("object" != $2ffff18146ce6002$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2ffff18146ce6002$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2ffff18146ce6002$var$_slicedToArray(arr, i) {
    return $2ffff18146ce6002$var$_arrayWithHoles(arr) || $2ffff18146ce6002$var$_iterableToArrayLimit(arr, i) || $2ffff18146ce6002$var$_unsupportedIterableToArray(arr, i) || $2ffff18146ce6002$var$_nonIterableRest();
}
function $2ffff18146ce6002$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2ffff18146ce6002$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2ffff18146ce6002$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2ffff18146ce6002$var$_arrayLikeToArray(o, minLen);
}
function $2ffff18146ce6002$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2ffff18146ce6002$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2ffff18146ce6002$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2ffff18146ce6002$var$separateConfig(config, defaultConfig) {
    var singleConfig = config !== null && config !== void 0 ? config : defaultConfig;
    if (Array.isArray(singleConfig)) return singleConfig;
    return [
        singleConfig,
        singleConfig
    ];
}
/** Used for change event, it should always be not undefined */ function $2ffff18146ce6002$var$getActiveRange(activeIndex) {
    return activeIndex === 1 ? 'end' : 'start';
}
function $2ffff18146ce6002$var$RangePicker(props, ref) {
    // ========================= Prop =========================
    var _useFilledProps = (0, $d29755e463bdcbb2$export$2e2bcd8739ae039)(props, function() {
        var disabled = props.disabled, allowEmpty = props.allowEmpty;
        var mergedDisabled = $2ffff18146ce6002$var$separateConfig(disabled, false);
        var mergedAllowEmpty = $2ffff18146ce6002$var$separateConfig(allowEmpty, false);
        return {
            disabled: mergedDisabled,
            allowEmpty: mergedAllowEmpty
        };
    }), _useFilledProps2 = $2ffff18146ce6002$var$_slicedToArray(_useFilledProps, 6), filledProps = _useFilledProps2[0], internalPicker = _useFilledProps2[1], complexPicker = _useFilledProps2[2], formatList = _useFilledProps2[3], maskFormat = _useFilledProps2[4], isInvalidateDate = _useFilledProps2[5];
    var prefixCls = filledProps.prefixCls, rootClassName = filledProps.rootClassName, propStyles = filledProps.styles, propClassNames = filledProps.classNames, previewValue = filledProps.previewValue, defaultValue = filledProps.defaultValue, value = filledProps.value, needConfirm = filledProps.needConfirm, onKeyDown = filledProps.onKeyDown, disabled = filledProps.disabled, allowEmpty = filledProps.allowEmpty, disabledDate = filledProps.disabledDate, minDate = filledProps.minDate, maxDate = filledProps.maxDate, defaultOpen = filledProps.defaultOpen, open = filledProps.open, onOpenChange = filledProps.onOpenChange, locale = filledProps.locale, generateConfig = filledProps.generateConfig, picker = filledProps.picker, showNow = filledProps.showNow, showToday = filledProps.showToday, showTime = filledProps.showTime, mode = filledProps.mode, onPanelChange = filledProps.onPanelChange, onCalendarChange = filledProps.onCalendarChange, onOk = filledProps.onOk, defaultPickerValue = filledProps.defaultPickerValue, pickerValue = filledProps.pickerValue, onPickerValueChange = filledProps.onPickerValueChange, inputReadOnly = filledProps.inputReadOnly, suffixIcon = filledProps.suffixIcon, onFocus = filledProps.onFocus, onBlur = filledProps.onBlur, presets = filledProps.presets, ranges = filledProps.ranges, components = filledProps.components, cellRender = filledProps.cellRender, dateRender = filledProps.dateRender, monthCellRender = filledProps.monthCellRender, onClick = filledProps.onClick;
    // ========================= Refs =========================
    var selectorRef = (0, $ede354abeea92cfa$export$2e2bcd8739ae039)(ref);
    // ======================= Semantic =======================
    var _useSemantic = (0, $0c0cc01c9f4b3431$export$2e2bcd8739ae039)(propClassNames, propStyles), _useSemantic2 = $2ffff18146ce6002$var$_slicedToArray(_useSemantic, 2), mergedClassNames = _useSemantic2[0], mergedStyles = _useSemantic2[1];
    // ========================= Open =========================
    var _useOpen = (0, $67b23fc684b71686$export$2e2bcd8739ae039)(open, defaultOpen, disabled, onOpenChange), _useOpen2 = $2ffff18146ce6002$var$_slicedToArray(_useOpen, 2), mergedOpen = _useOpen2[0], setMergeOpen = _useOpen2[1];
    var triggerOpen = function triggerOpen(nextOpen, config) {
        // No need to open if all disabled
        if (disabled.some(function(fieldDisabled) {
            return !fieldDisabled;
        }) || !nextOpen) setMergeOpen(nextOpen, config);
    };
    // ======================== Values ========================
    var _useInnerValue = (0, $e51efeefa4dc71b9$export$eef0e5a163935805)(generateConfig, locale, formatList, true, false, defaultValue, value, onCalendarChange, onOk), _useInnerValue2 = $2ffff18146ce6002$var$_slicedToArray(_useInnerValue, 5), mergedValue = _useInnerValue2[0], setInnerValue = _useInnerValue2[1], getCalendarValue = _useInnerValue2[2], triggerCalendarChange = _useInnerValue2[3], triggerOk = _useInnerValue2[4];
    var calendarValue = getCalendarValue();
    // ======================== Active ========================
    var _useRangeActive = (0, $1bf818719e58cbff$export$2e2bcd8739ae039)(disabled, allowEmpty, mergedOpen), _useRangeActive2 = $2ffff18146ce6002$var$_slicedToArray(_useRangeActive, 9), focused = _useRangeActive2[0], triggerFocus = _useRangeActive2[1], lastOperation = _useRangeActive2[2], activeIndex = _useRangeActive2[3], setActiveIndex = _useRangeActive2[4], nextActiveIndex = _useRangeActive2[5], activeIndexList = _useRangeActive2[6], updateSubmitIndex = _useRangeActive2[7], hasActiveSubmitValue = _useRangeActive2[8];
    var onSharedFocus = function onSharedFocus(event, index) {
        triggerFocus(true);
        onFocus === null || onFocus === void 0 || onFocus(event, {
            range: $2ffff18146ce6002$var$getActiveRange(index !== null && index !== void 0 ? index : activeIndex)
        });
    };
    var onSharedBlur = function onSharedBlur(event, index) {
        triggerFocus(false);
        onBlur === null || onBlur === void 0 || onBlur(event, {
            range: $2ffff18146ce6002$var$getActiveRange(index !== null && index !== void 0 ? index : activeIndex)
        });
    };
    // ======================= ShowTime =======================
    /** Used for Popup panel */ var mergedShowTime = $ltGt3.useMemo(function() {
        if (!showTime) return null;
        var disabledTime = showTime.disabledTime;
        var proxyDisabledTime = disabledTime ? function(date) {
            var range = $2ffff18146ce6002$var$getActiveRange(activeIndex);
            var fromDate = (0, $4eaa081548444891$export$25071452d0014c32)(calendarValue, activeIndexList, activeIndex);
            return disabledTime(date, range, {
                from: fromDate
            });
        } : undefined;
        return $2ffff18146ce6002$var$_objectSpread($2ffff18146ce6002$var$_objectSpread({}, showTime), {}, {
            disabledTime: proxyDisabledTime
        });
    }, [
        showTime,
        activeIndex,
        calendarValue,
        activeIndexList
    ]);
    // ========================= Mode =========================
    var _useControlledState = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)([
        picker,
        picker
    ], mode), _useControlledState2 = $2ffff18146ce6002$var$_slicedToArray(_useControlledState, 2), modes = _useControlledState2[0], setModes = _useControlledState2[1];
    var mergedMode = modes[activeIndex] || picker;
    /** Extends from `mergedMode` to patch `datetime` mode */ var internalMode = mergedMode === 'date' && mergedShowTime ? 'datetime' : mergedMode;
    // ====================== PanelCount ======================
    var multiplePanel = internalMode === picker && internalMode !== 'time';
    // ======================= Show Now =======================
    var mergedShowNow = (0, $f404cb186cc1602e$export$2e2bcd8739ae039)(picker, mergedMode, showNow, showToday, true);
    // ======================== Value =========================
    var _useRangeValue = (0, $e51efeefa4dc71b9$export$2e2bcd8739ae039)(filledProps, mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, disabled, formatList, focused, mergedOpen, isInvalidateDate), _useRangeValue2 = $2ffff18146ce6002$var$_slicedToArray(_useRangeValue, 2), /** Trigger `onChange` by check `disabledDate` */ flushSubmit = _useRangeValue2[0], /** Trigger `onChange` directly without check `disabledDate` */ triggerSubmitChange = _useRangeValue2[1];
    // ===================== DisabledDate =====================
    var mergedDisabledDate = (0, $b9225b38da7f1f79$export$2e2bcd8739ae039)(calendarValue, disabled, activeIndexList, generateConfig, locale, disabledDate);
    // ======================= Validate =======================
    var _useFieldsInvalidate = (0, $a847d18fd6b89adc$export$2e2bcd8739ae039)(calendarValue, isInvalidateDate, allowEmpty), _useFieldsInvalidate2 = $2ffff18146ce6002$var$_slicedToArray(_useFieldsInvalidate, 2), submitInvalidates = _useFieldsInvalidate2[0], onSelectorInvalid = _useFieldsInvalidate2[1];
    // ===================== Picker Value =====================
    var _useRangePickerValue = (0, $7b84215c9fa9f92b$export$2e2bcd8739ae039)(generateConfig, locale, calendarValue, modes, mergedOpen, activeIndex, internalPicker, multiplePanel, defaultPickerValue, pickerValue, mergedShowTime === null || mergedShowTime === void 0 ? void 0 : mergedShowTime.defaultOpenValue, onPickerValueChange, minDate, maxDate), _useRangePickerValue2 = $2ffff18146ce6002$var$_slicedToArray(_useRangePickerValue, 2), currentPickerValue = _useRangePickerValue2[0], setCurrentPickerValue = _useRangePickerValue2[1];
    // >>> Mode need wait for `pickerValue`
    var triggerModeChange = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(nextPickerValue, nextMode, triggerEvent) {
        var clone = (0, $4eaa081548444891$export$4284846c29a21d02)(modes, activeIndex, nextMode);
        if (clone[0] !== modes[0] || clone[1] !== modes[1]) setModes(clone);
        // Compatible with `onPanelChange`
        if (onPanelChange && triggerEvent !== false) {
            var clonePickerValue = $2ffff18146ce6002$var$_toConsumableArray(calendarValue);
            if (nextPickerValue) clonePickerValue[activeIndex] = nextPickerValue;
            onPanelChange(clonePickerValue, clone);
        }
    });
    // ======================== Change ========================
    var fillCalendarValue = function fillCalendarValue(date, index) {
        return(// Trigger change only when date changed
        (0, $4eaa081548444891$export$4284846c29a21d02)(calendarValue, index, date));
    };
    // ======================== Submit ========================
    /**
   * Trigger by confirm operation.
   * This function has already handle the `needConfirm` check logic.
   * - Selector: enter key
   * - Panel: OK button
   */ var triggerPartConfirm = function triggerPartConfirm(date, skipFocus) {
        var nextValue = calendarValue;
        if (date) nextValue = fillCalendarValue(date, activeIndex);
        updateSubmitIndex(activeIndex);
        // Get next focus index
        var nextIndex = nextActiveIndex(nextValue);
        // Change calendar value and tell flush it
        triggerCalendarChange(nextValue);
        flushSubmit(activeIndex, nextIndex === null);
        if (nextIndex === null) triggerOpen(false, {
            force: true
        });
        else if (!skipFocus) selectorRef.current.focus({
            index: nextIndex
        });
    };
    // ======================== Click =========================
    var onSelectorClick = function onSelectorClick(event) {
        var _activeElement;
        var rootNode = event.target.getRootNode();
        if (!selectorRef.current.nativeElement.contains((_activeElement = rootNode.activeElement) !== null && _activeElement !== void 0 ? _activeElement : document.activeElement)) {
            // Click to focus the enabled input
            var enabledIndex = disabled.findIndex(function(d) {
                return !d;
            });
            if (enabledIndex >= 0) selectorRef.current.focus({
                index: enabledIndex
            });
        }
        triggerOpen(true);
        onClick === null || onClick === void 0 || onClick(event);
    };
    var onSelectorClear = function onSelectorClear() {
        triggerSubmitChange(null);
        triggerOpen(false, {
            force: true
        });
    };
    // ======================== Hover =========================
    var _React$useState = $ltGt3.useState(null), _React$useState2 = $2ffff18146ce6002$var$_slicedToArray(_React$useState, 2), hoverSource = _React$useState2[0], setHoverSource = _React$useState2[1];
    var _React$useState3 = $ltGt3.useState(null), _React$useState4 = $2ffff18146ce6002$var$_slicedToArray(_React$useState3, 2), internalHoverValues = _React$useState4[0], setInternalHoverValues = _React$useState4[1];
    var hoverValues = $ltGt3.useMemo(function() {
        return internalHoverValues || calendarValue;
    }, [
        calendarValue,
        internalHoverValues
    ]);
    // Clean up `internalHoverValues` when closed
    $ltGt3.useEffect(function() {
        if (!mergedOpen) setInternalHoverValues(null);
    }, [
        mergedOpen
    ]);
    // ========================================================
    // ==                       Panels                       ==
    // ========================================================
    // Save the offset with active bar position
    // const [activeOffset, setActiveOffset] = React.useState(0);
    var _React$useState5 = $ltGt3.useState([
        0,
        0,
        0
    ]), _React$useState6 = $2ffff18146ce6002$var$_slicedToArray(_React$useState5, 2), activeInfo = _React$useState6[0], setActiveInfo = _React$useState6[1];
    var onSetHover = function onSetHover(date, source) {
        if (previewValue !== 'hover') return;
        setInternalHoverValues(date);
        setHoverSource(source);
    };
    // ======================= Presets ========================
    var presetList = (0, $a9785ec601c9c81e$export$2e2bcd8739ae039)(presets, ranges);
    var onPresetHover = function onPresetHover(nextValues) {
        onSetHover(nextValues, 'preset');
    };
    var onPresetSubmit = function onPresetSubmit(nextValues) {
        var passed = triggerSubmitChange(nextValues);
        if (passed) triggerOpen(false, {
            force: true
        });
    };
    var onNow = function onNow(now) {
        triggerPartConfirm(now);
    };
    // ======================== Panel =========================
    var onPanelHover = function onPanelHover(date) {
        onSetHover(date ? fillCalendarValue(date, activeIndex) : null, 'cell');
    };
    // >>> Focus
    var onPanelFocus = function onPanelFocus(event) {
        triggerOpen(true);
        onSharedFocus(event);
    };
    // >>> MouseDown
    var onPanelMouseDown = function onPanelMouseDown() {
        lastOperation('panel');
    };
    // >>> Calendar
    var onPanelSelect = function onPanelSelect(date) {
        var clone = (0, $4eaa081548444891$export$4284846c29a21d02)(calendarValue, activeIndex, date);
        // Only trigger calendar event but not update internal `calendarValue` state
        triggerCalendarChange(clone);
        // >>> Trigger next active if !needConfirm
        // Fully logic check `useRangeValue` hook
        if (!needConfirm && !complexPicker && internalPicker === internalMode) triggerPartConfirm(date);
    };
    // >>> Close
    var onPopupClose = function onPopupClose() {
        // Close popup
        triggerOpen(false);
    };
    // >>> cellRender
    var onInternalCellRender = (0, $8fa10cb8931a057d$export$2e2bcd8739ae039)(cellRender, dateRender, monthCellRender, $2ffff18146ce6002$var$getActiveRange(activeIndex));
    // >>> Value
    var panelValue = calendarValue[activeIndex] || null;
    // >>> invalid
    var isPopupInvalidateDate = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(date) {
        return isInvalidateDate(date, {
            activeIndex: activeIndex
        });
    });
    var panelProps = $ltGt3.useMemo(function() {
        var domProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(filledProps, false);
        var restProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(filledProps, [].concat($2ffff18146ce6002$var$_toConsumableArray(Object.keys(domProps)), [
            'onChange',
            'onCalendarChange',
            'style',
            'className',
            'onPanelChange',
            'disabledTime',
            'classNames',
            'styles'
        ]));
        return restProps;
    }, [
        filledProps
    ]);
    // >>> Render
    var panel = /*#__PURE__*/ $ltGt3.createElement((0, $3b229d2234afad92$export$2e2bcd8739ae039), $2ffff18146ce6002$var$_extends({}, panelProps, {
        showNow: mergedShowNow,
        showTime: mergedShowTime,
        range: true,
        multiplePanel: multiplePanel,
        activeInfo: activeInfo,
        disabledDate: mergedDisabledDate,
        onFocus: onPanelFocus,
        onBlur: onSharedBlur,
        onPanelMouseDown: onPanelMouseDown,
        picker: picker,
        mode: mergedMode,
        internalMode: internalMode,
        onPanelChange: triggerModeChange,
        format: maskFormat,
        value: panelValue,
        isInvalid: isPopupInvalidateDate,
        onChange: null,
        onSelect: onPanelSelect,
        pickerValue: currentPickerValue,
        defaultOpenValue: (0, $4eaa081548444891$export$45b10814cc054894)(showTime === null || showTime === void 0 ? void 0 : showTime.defaultOpenValue)[activeIndex],
        onPickerValueChange: setCurrentPickerValue,
        hoverValue: hoverValues,
        onHover: onPanelHover,
        needConfirm: needConfirm,
        onSubmit: triggerPartConfirm,
        onOk: triggerOk,
        presets: presetList,
        onPresetHover: onPresetHover,
        onPresetSubmit: onPresetSubmit,
        onNow: onNow,
        cellRender: onInternalCellRender,
        classNames: mergedClassNames,
        styles: mergedStyles
    }));
    // ========================================================
    // ==                      Selector                      ==
    // ========================================================
    // ======================== Change ========================
    var onSelectorChange = function onSelectorChange(date, index) {
        var clone = fillCalendarValue(date, index);
        triggerCalendarChange(clone);
    };
    var onSelectorInputChange = function onSelectorInputChange() {
        lastOperation('input');
    };
    // ======================= Selector =======================
    var onSelectorFocus = function onSelectorFocus(event, index) {
        // Check if `needConfirm` but user not submit yet
        var activeListLen = activeIndexList.length;
        var lastActiveIndex = activeIndexList[activeListLen - 1];
        if (activeListLen && lastActiveIndex !== index && needConfirm && // Not change index if is not filled
        !allowEmpty[lastActiveIndex] && !hasActiveSubmitValue(lastActiveIndex) && calendarValue[lastActiveIndex]) {
            selectorRef.current.focus({
                index: lastActiveIndex
            });
            return;
        }
        lastOperation('input');
        triggerOpen(true, {
            inherit: true
        });
        // When click input to switch the field, it will not trigger close.
        // Which means it will lose the part confirm and we need fill back.
        // ref: https://github.com/ant-design/ant-design/issues/49512
        if (activeIndex !== index && mergedOpen && !needConfirm && complexPicker) triggerPartConfirm(null, true);
        setActiveIndex(index);
        onSharedFocus(event, index);
    };
    var onSelectorBlur = function onSelectorBlur(event, index) {
        triggerOpen(false);
        if (!needConfirm && lastOperation() === 'input') {
            var nextIndex = nextActiveIndex(calendarValue);
            flushSubmit(activeIndex, nextIndex === null);
        }
        onSharedBlur(event, index);
    };
    var onSelectorKeyDown = function onSelectorKeyDown(event, preventDefault) {
        if (event.key === 'Tab') triggerPartConfirm(null, true);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(event, preventDefault);
    };
    // ======================= Context ========================
    var context = $ltGt3.useMemo(function() {
        return {
            prefixCls: prefixCls,
            locale: locale,
            generateConfig: generateConfig,
            button: components.button,
            input: components.input,
            classNames: mergedClassNames,
            styles: mergedStyles
        };
    }, [
        prefixCls,
        locale,
        generateConfig,
        components.button,
        components.input,
        mergedClassNames,
        mergedStyles
    ]);
    // ======================== Effect ========================
    // >>> Mode
    // Reset for every active
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(function() {
        if (mergedOpen && activeIndex !== undefined) // Legacy compatible. This effect update should not trigger `onPanelChange`
        triggerModeChange(null, picker, false);
    }, [
        mergedOpen,
        activeIndex,
        picker
    ]);
    // >>> For complex picker, we need check if need to focus next one
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(function() {
        var lastOp = lastOperation();
        // Trade as confirm on field leave
        if (!mergedOpen && lastOp === 'input') {
            triggerOpen(false);
            triggerPartConfirm(null, true);
        }
        // Submit with complex picker
        if (!mergedOpen && complexPicker && !needConfirm && lastOp === 'panel') {
            triggerOpen(true);
            triggerPartConfirm();
        }
    }, [
        mergedOpen
    ]);
    var isIndexEmpty;
    // ======================== Render ========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $6158ac241550cb6d$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $ltGt3.createElement((0, $a361cd0d3ae96847$export$2e2bcd8739ae039), $2ffff18146ce6002$var$_extends({}, (0, $ca229a7f6958f601$export$a11cc4b953869c91)(filledProps), {
        popupElement: panel,
        popupStyle: mergedStyles.popup.root,
        popupClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(rootClassName, mergedClassNames.popup.root),
        visible: mergedOpen,
        onClose: onPopupClose,
        range: true
    }), /*#__PURE__*/ $ltGt3.createElement((0, $080dfef780a79a72$export$2e2bcd8739ae039), $2ffff18146ce6002$var$_extends({}, filledProps, {
        // Ref
        ref: selectorRef,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(filledProps.className, rootClassName, mergedClassNames.root),
        style: $2ffff18146ce6002$var$_objectSpread($2ffff18146ce6002$var$_objectSpread({}, mergedStyles.root), filledProps.style),
        suffixIcon: suffixIcon,
        activeIndex: focused || mergedOpen ? activeIndex : null,
        activeHelp: !!internalHoverValues,
        allHelp: !!internalHoverValues && hoverSource === 'preset',
        focused: focused,
        onFocus: onSelectorFocus,
        onBlur: onSelectorBlur,
        onKeyDown: onSelectorKeyDown,
        onSubmit: triggerPartConfirm,
        value: hoverValues,
        maskFormat: maskFormat,
        onChange: onSelectorChange,
        onInputChange: onSelectorInputChange,
        format: formatList,
        inputReadOnly: inputReadOnly,
        disabled: disabled,
        open: mergedOpen,
        onOpenChange: triggerOpen,
        onClick: onSelectorClick,
        onClear: onSelectorClear,
        invalid: submitInvalidates,
        onInvalid: onSelectorInvalid,
        onActiveInfo: setActiveInfo
    }))));
}
var $2ffff18146ce6002$var$RefRangePicker = /*#__PURE__*/ $ltGt3.forwardRef($2ffff18146ce6002$var$RangePicker);
var $2ffff18146ce6002$export$2e2bcd8739ae039 = $2ffff18146ce6002$var$RefRangePicker;








var $ltGt3 = parcelRequire("ltGt3");


















var $ltGt3 = parcelRequire("ltGt3");









var $ltGt3 = parcelRequire("ltGt3");
function $e99623e01ed5ec00$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, value = props.value, onRemove = props.onRemove, _props$removeIcon = props.removeIcon, removeIcon = _props$removeIcon === void 0 ? "\xd7" : _props$removeIcon, formatDate = props.formatDate, disabled = props.disabled, maxTagCount = props.maxTagCount, placeholder = props.placeholder;
    var selectorCls = "".concat(prefixCls, "-selector");
    var selectionCls = "".concat(prefixCls, "-selection");
    var overflowCls = "".concat(selectionCls, "-overflow");
    // ========================= Item =========================
    function renderSelector(content, onClose) {
        return /*#__PURE__*/ $ltGt3.createElement("span", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)("".concat(selectionCls, "-item")),
            title: typeof content === 'string' ? content : null
        }, /*#__PURE__*/ $ltGt3.createElement("span", {
            className: "".concat(selectionCls, "-item-content")
        }, content), !disabled && onClose && /*#__PURE__*/ $ltGt3.createElement("span", {
            onMouseDown: function onMouseDown(e) {
                e.preventDefault();
            },
            onClick: onClose,
            className: "".concat(selectionCls, "-item-remove")
        }, removeIcon));
    }
    function renderItem(date) {
        var displayLabel = formatDate(date);
        var onClose = function onClose(event) {
            if (event) event.stopPropagation();
            onRemove(date);
        };
        return renderSelector(displayLabel, onClose);
    }
    // ========================= Rest =========================
    function renderRest(omittedValues) {
        var content = "+ ".concat(omittedValues.length, " ...");
        return renderSelector(content);
    }
    // ======================== Render ========================
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: selectorCls
    }, /*#__PURE__*/ $ltGt3.createElement((0, $a8c8240385950b5a$export$2e2bcd8739ae039), {
        prefixCls: overflowCls,
        data: value,
        renderItem: renderItem,
        renderRest: renderRest,
        itemKey: function itemKey(date) {
            return formatDate(date);
        },
        maxCount: maxTagCount
    }), !value.length && /*#__PURE__*/ $ltGt3.createElement("span", {
        className: "".concat(prefixCls, "-selection-placeholder")
    }, placeholder));
}


function $f78017728af75b29$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f78017728af75b29$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f78017728af75b29$var$_typeof(o);
}
var $f78017728af75b29$var$_excluded = [
    "id",
    "open",
    "prefix",
    "clearIcon",
    "suffixIcon",
    "activeHelp",
    "allHelp",
    "focused",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "locale",
    "generateConfig",
    "placeholder",
    "className",
    "style",
    "onClick",
    "onClear",
    "internalPicker",
    "value",
    "onChange",
    "onSubmit",
    "onInputChange",
    "multiple",
    "maxTagCount",
    "format",
    "maskFormat",
    "preserveInvalidOnBlur",
    "onInvalid",
    "disabled",
    "invalid",
    "inputReadOnly",
    "direction",
    "onOpenChange",
    "onMouseDown",
    "required",
    "aria-required",
    "autoFocus",
    "tabIndex",
    "removeIcon"
];
function $f78017728af75b29$var$_extends() {
    $f78017728af75b29$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f78017728af75b29$var$_extends.apply(this, arguments);
}
function $f78017728af75b29$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f78017728af75b29$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f78017728af75b29$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f78017728af75b29$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f78017728af75b29$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f78017728af75b29$var$_defineProperty(obj, key, value) {
    key = $f78017728af75b29$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f78017728af75b29$var$_toPropertyKey(t) {
    var i = $f78017728af75b29$var$_toPrimitive(t, "string");
    return "symbol" == $f78017728af75b29$var$_typeof(i) ? i : String(i);
}
function $f78017728af75b29$var$_toPrimitive(t, r) {
    if ("object" != $f78017728af75b29$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f78017728af75b29$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f78017728af75b29$var$_slicedToArray(arr, i) {
    return $f78017728af75b29$var$_arrayWithHoles(arr) || $f78017728af75b29$var$_iterableToArrayLimit(arr, i) || $f78017728af75b29$var$_unsupportedIterableToArray(arr, i) || $f78017728af75b29$var$_nonIterableRest();
}
function $f78017728af75b29$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f78017728af75b29$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f78017728af75b29$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f78017728af75b29$var$_arrayLikeToArray(o, minLen);
}
function $f78017728af75b29$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f78017728af75b29$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f78017728af75b29$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f78017728af75b29$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f78017728af75b29$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f78017728af75b29$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f78017728af75b29$var$SingleSelector(props, ref) {
    var id = props.id, open = props.open, prefix = props.prefix, clearIcon = props.clearIcon, suffixIcon = props.suffixIcon, activeHelp = props.activeHelp, allHelp = props.allHelp, focused = props.focused, onFocus = props.onFocus, onBlur = props.onBlur, onKeyDown = props.onKeyDown, locale = props.locale, generateConfig = props.generateConfig, placeholder = props.placeholder, className = props.className, style = props.style, onClick = props.onClick, onClear = props.onClear, internalPicker = props.internalPicker, value = props.value, onChange = props.onChange, onSubmit = props.onSubmit, onInputChange = props.onInputChange, multiple = props.multiple, maxTagCount = props.maxTagCount, format = props.format, maskFormat = props.maskFormat, preserveInvalidOnBlur = props.preserveInvalidOnBlur, onInvalid = props.onInvalid, disabled = props.disabled, invalid = props.invalid, inputReadOnly = props.inputReadOnly, direction = props.direction, onOpenChange = props.onOpenChange, _onMouseDown = props.onMouseDown, required = props.required, ariaRequired = props['aria-required'], autoFocus = props.autoFocus, tabIndex = props.tabIndex, removeIcon = props.removeIcon, restProps = $f78017728af75b29$var$_objectWithoutProperties(props, $f78017728af75b29$var$_excluded);
    var rtl = direction === 'rtl';
    // ======================== Prefix ========================
    var _React$useContext = $ltGt3.useContext((0, $6158ac241550cb6d$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, classNames = _React$useContext.classNames, styles = _React$useContext.styles;
    // ========================= Refs =========================
    var rootRef = $ltGt3.useRef();
    var inputRef = $ltGt3.useRef();
    $ltGt3.useImperativeHandle(ref, function() {
        return {
            nativeElement: rootRef.current,
            focus: function focus(options) {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus(options);
            },
            blur: function blur() {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
            }
        };
    });
    // ======================== Props =========================
    var rootProps = (0, $56250a77f611428b$export$2e2bcd8739ae039)(restProps);
    // ======================== Change ========================
    var onSingleChange = function onSingleChange(date) {
        onChange([
            date
        ]);
    };
    var onMultipleRemove = function onMultipleRemove(date) {
        var nextValues = value.filter(function(oriDate) {
            return oriDate && !(0, $f655def3c887f075$export$18ac18efd9e98d41)(generateConfig, locale, oriDate, date, internalPicker);
        });
        onChange(nextValues);
        // When `open`, it means user is operating the
        if (!open) onSubmit();
    };
    // ======================== Inputs ========================
    var _useInputProps = (0, $ec4a2baedee9fa3d$export$2e2bcd8739ae039)($f78017728af75b29$var$_objectSpread($f78017728af75b29$var$_objectSpread({}, props), {}, {
        onChange: onSingleChange
    }), function(_ref) {
        var valueTexts = _ref.valueTexts;
        return {
            value: valueTexts[0] || '',
            active: focused
        };
    }), _useInputProps2 = $f78017728af75b29$var$_slicedToArray(_useInputProps, 2), getInputProps = _useInputProps2[0], getText = _useInputProps2[1];
    // ======================== Clear =========================
    var showClear = !!(clearIcon && value.length && !disabled);
    // ======================= Multiple =======================
    var selectorNode = multiple ? /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement((0, $e99623e01ed5ec00$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        value: value,
        onRemove: onMultipleRemove,
        formatDate: getText,
        maxTagCount: maxTagCount,
        disabled: disabled,
        removeIcon: removeIcon,
        placeholder: placeholder
    }), /*#__PURE__*/ $ltGt3.createElement("input", {
        className: "".concat(prefixCls, "-multiple-input"),
        value: value.map(getText).join(','),
        ref: inputRef,
        readOnly: true,
        autoFocus: autoFocus,
        tabIndex: tabIndex
    }), /*#__PURE__*/ $ltGt3.createElement((0, $88c200921d22d915$export$2e2bcd8739ae039), {
        type: "suffix",
        icon: suffixIcon
    }), showClear && /*#__PURE__*/ $ltGt3.createElement((0, $88c200921d22d915$export$cefbac224a47f32), {
        icon: clearIcon,
        onClear: onClear
    })) : /*#__PURE__*/ $ltGt3.createElement((0, $ef28e89ecf767faa$export$2e2bcd8739ae039), $f78017728af75b29$var$_extends({
        ref: inputRef
    }, getInputProps(), {
        autoFocus: autoFocus,
        tabIndex: tabIndex,
        suffixIcon: suffixIcon,
        clearIcon: showClear && /*#__PURE__*/ $ltGt3.createElement((0, $88c200921d22d915$export$cefbac224a47f32), {
            icon: clearIcon,
            onClear: onClear
        }),
        showActiveCls: false
    }));
    // ======================== Render ========================
    return /*#__PURE__*/ $ltGt3.createElement("div", $f78017728af75b29$var$_extends({}, rootProps, {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, $f78017728af75b29$var$_defineProperty($f78017728af75b29$var$_defineProperty($f78017728af75b29$var$_defineProperty($f78017728af75b29$var$_defineProperty($f78017728af75b29$var$_defineProperty({}, "".concat(prefixCls, "-multiple"), multiple), "".concat(prefixCls, "-focused"), focused), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-invalid"), invalid), "".concat(prefixCls, "-rtl"), rtl), className),
        style: style,
        ref: rootRef,
        onClick: onClick,
        onMouseDown: function onMouseDown(e) {
            var _inputRef$current3;
            var target = e.target;
            if (target !== ((_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.inputElement)) e.preventDefault();
            _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(e);
        }
    }), prefix && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)("".concat(prefixCls, "-prefix"), classNames.prefix),
        style: styles.prefix
    }, prefix), selectorNode);
}
var $f78017728af75b29$var$RefSingleSelector = /*#__PURE__*/ $ltGt3.forwardRef($f78017728af75b29$var$SingleSelector);
var $f78017728af75b29$export$2e2bcd8739ae039 = $f78017728af75b29$var$RefSingleSelector;



function $9981b8e7d94e95a0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9981b8e7d94e95a0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9981b8e7d94e95a0$var$_typeof(o);
}
function $9981b8e7d94e95a0$var$_extends() {
    $9981b8e7d94e95a0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9981b8e7d94e95a0$var$_extends.apply(this, arguments);
}
function $9981b8e7d94e95a0$var$_toConsumableArray(arr) {
    return $9981b8e7d94e95a0$var$_arrayWithoutHoles(arr) || $9981b8e7d94e95a0$var$_iterableToArray(arr) || $9981b8e7d94e95a0$var$_unsupportedIterableToArray(arr) || $9981b8e7d94e95a0$var$_nonIterableSpread();
}
function $9981b8e7d94e95a0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9981b8e7d94e95a0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9981b8e7d94e95a0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9981b8e7d94e95a0$var$_arrayLikeToArray(arr);
}
function $9981b8e7d94e95a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9981b8e7d94e95a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9981b8e7d94e95a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9981b8e7d94e95a0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9981b8e7d94e95a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9981b8e7d94e95a0$var$_defineProperty(obj, key, value) {
    key = $9981b8e7d94e95a0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9981b8e7d94e95a0$var$_toPropertyKey(t) {
    var i = $9981b8e7d94e95a0$var$_toPrimitive(t, "string");
    return "symbol" == $9981b8e7d94e95a0$var$_typeof(i) ? i : String(i);
}
function $9981b8e7d94e95a0$var$_toPrimitive(t, r) {
    if ("object" != $9981b8e7d94e95a0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9981b8e7d94e95a0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9981b8e7d94e95a0$var$_slicedToArray(arr, i) {
    return $9981b8e7d94e95a0$var$_arrayWithHoles(arr) || $9981b8e7d94e95a0$var$_iterableToArrayLimit(arr, i) || $9981b8e7d94e95a0$var$_unsupportedIterableToArray(arr, i) || $9981b8e7d94e95a0$var$_nonIterableRest();
}
function $9981b8e7d94e95a0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9981b8e7d94e95a0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9981b8e7d94e95a0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9981b8e7d94e95a0$var$_arrayLikeToArray(o, minLen);
}
function $9981b8e7d94e95a0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9981b8e7d94e95a0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9981b8e7d94e95a0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
// TODO: isInvalidateDate with showTime.disabledTime should not provide `range` prop
/** Internal usage. For cross function get same aligned props */ function $9981b8e7d94e95a0$var$Picker(props, ref) {
    // ========================= Prop =========================
    var _useFilledProps = (0, $d29755e463bdcbb2$export$2e2bcd8739ae039)(props), _useFilledProps2 = $9981b8e7d94e95a0$var$_slicedToArray(_useFilledProps, 6), filledProps = _useFilledProps2[0], internalPicker = _useFilledProps2[1], complexPicker = _useFilledProps2[2], formatList = _useFilledProps2[3], maskFormat = _useFilledProps2[4], isInvalidateDate = _useFilledProps2[5];
    var _ref = filledProps, prefixCls = _ref.prefixCls, rootClassName = _ref.rootClassName, propStyles = _ref.styles, propClassNames = _ref.classNames, previewValue = _ref.previewValue, order = _ref.order, defaultValue = _ref.defaultValue, value = _ref.value, needConfirm = _ref.needConfirm, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, disabled = _ref.disabled, disabledDate = _ref.disabledDate, minDate = _ref.minDate, maxDate = _ref.maxDate, defaultOpen = _ref.defaultOpen, open = _ref.open, onOpenChange = _ref.onOpenChange, locale = _ref.locale, generateConfig = _ref.generateConfig, picker = _ref.picker, showNow = _ref.showNow, showToday = _ref.showToday, showTime = _ref.showTime, mode = _ref.mode, onPanelChange = _ref.onPanelChange, onCalendarChange = _ref.onCalendarChange, onOk = _ref.onOk, multiple = _ref.multiple, defaultPickerValue = _ref.defaultPickerValue, pickerValue = _ref.pickerValue, onPickerValueChange = _ref.onPickerValueChange, inputReadOnly = _ref.inputReadOnly, suffixIcon = _ref.suffixIcon, removeIcon = _ref.removeIcon, onFocus = _ref.onFocus, onBlur = _ref.onBlur, presets = _ref.presets, components = _ref.components, cellRender = _ref.cellRender, dateRender = _ref.dateRender, monthCellRender = _ref.monthCellRender, onClick = _ref.onClick;
    // ========================= Refs =========================
    var selectorRef = (0, $ede354abeea92cfa$export$2e2bcd8739ae039)(ref);
    // ========================= Util =========================
    function pickerParam(values) {
        if (values === null) return null;
        return multiple ? values : values[0];
    }
    var toggleDates = (0, $12b886ce4241df5e$export$2e2bcd8739ae039)(generateConfig, locale, internalPicker);
    // ======================= Semantic =======================
    var _useSemantic = (0, $0c0cc01c9f4b3431$export$2e2bcd8739ae039)(propClassNames, propStyles), _useSemantic2 = $9981b8e7d94e95a0$var$_slicedToArray(_useSemantic, 2), mergedClassNames = _useSemantic2[0], mergedStyles = _useSemantic2[1];
    // ========================= Open =========================
    var _useOpen = (0, $67b23fc684b71686$export$2e2bcd8739ae039)(open, defaultOpen, [
        disabled
    ], onOpenChange), _useOpen2 = $9981b8e7d94e95a0$var$_slicedToArray(_useOpen, 2), mergedOpen = _useOpen2[0], triggerOpen = _useOpen2[1];
    // ======================= Calendar =======================
    var onInternalCalendarChange = function onInternalCalendarChange(dates, dateStrings, info) {
        if (onCalendarChange) {
            var filteredInfo = $9981b8e7d94e95a0$var$_objectSpread({}, info);
            delete filteredInfo.range;
            onCalendarChange(pickerParam(dates), pickerParam(dateStrings), filteredInfo);
        }
    };
    var onInternalOk = function onInternalOk(dates) {
        onOk === null || onOk === void 0 || onOk(pickerParam(dates));
    };
    // ======================== Values ========================
    var _useInnerValue = (0, $e51efeefa4dc71b9$export$eef0e5a163935805)(generateConfig, locale, formatList, false, order, defaultValue, value, onInternalCalendarChange, onInternalOk), _useInnerValue2 = $9981b8e7d94e95a0$var$_slicedToArray(_useInnerValue, 5), mergedValue = _useInnerValue2[0], setInnerValue = _useInnerValue2[1], getCalendarValue = _useInnerValue2[2], triggerCalendarChange = _useInnerValue2[3], triggerOk = _useInnerValue2[4];
    var calendarValue = getCalendarValue();
    // ======================== Active ========================
    // In SinglePicker, we will always get `activeIndex` is 0.
    var _useRangeActive = (0, $1bf818719e58cbff$export$2e2bcd8739ae039)([
        disabled
    ]), _useRangeActive2 = $9981b8e7d94e95a0$var$_slicedToArray(_useRangeActive, 4), focused = _useRangeActive2[0], triggerFocus = _useRangeActive2[1], lastOperation = _useRangeActive2[2], activeIndex = _useRangeActive2[3];
    var onSharedFocus = function onSharedFocus(event) {
        triggerFocus(true);
        onFocus === null || onFocus === void 0 || onFocus(event, {});
    };
    var onSharedBlur = function onSharedBlur(event) {
        triggerFocus(false);
        onBlur === null || onBlur === void 0 || onBlur(event, {});
    };
    // ========================= Mode =========================
    var _useControlledState = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(picker, mode), _useControlledState2 = $9981b8e7d94e95a0$var$_slicedToArray(_useControlledState, 2), mergedMode = _useControlledState2[0], setMode = _useControlledState2[1];
    /** Extends from `mergedMode` to patch `datetime` mode */ var internalMode = mergedMode === 'date' && showTime ? 'datetime' : mergedMode;
    // ======================= Show Now =======================
    var mergedShowNow = (0, $f404cb186cc1602e$export$2e2bcd8739ae039)(picker, mergedMode, showNow, showToday);
    // ======================== Value =========================
    var onInternalChange = onChange && function(dates, dateStrings) {
        onChange(pickerParam(dates), pickerParam(dateStrings));
    };
    var _useRangeValue = (0, $e51efeefa4dc71b9$export$2e2bcd8739ae039)($9981b8e7d94e95a0$var$_objectSpread($9981b8e7d94e95a0$var$_objectSpread({}, filledProps), {}, {
        onChange: onInternalChange
    }), mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, [], //disabled,
    formatList, focused, mergedOpen, isInvalidateDate), _useRangeValue2 = $9981b8e7d94e95a0$var$_slicedToArray(_useRangeValue, 2), /** Trigger `onChange` directly without check `disabledDate` */ triggerSubmitChange = _useRangeValue2[1];
    // ======================= Validate =======================
    var _useFieldsInvalidate = (0, $a847d18fd6b89adc$export$2e2bcd8739ae039)(calendarValue, isInvalidateDate), _useFieldsInvalidate2 = $9981b8e7d94e95a0$var$_slicedToArray(_useFieldsInvalidate, 2), submitInvalidates = _useFieldsInvalidate2[0], onSelectorInvalid = _useFieldsInvalidate2[1];
    var submitInvalidate = $ltGt3.useMemo(function() {
        return submitInvalidates.some(function(invalidated) {
            return invalidated;
        });
    }, [
        submitInvalidates
    ]);
    // ===================== Picker Value =====================
    // Proxy to single pickerValue
    var onInternalPickerValueChange = function onInternalPickerValueChange(dates, info) {
        if (onPickerValueChange) {
            var cleanInfo = $9981b8e7d94e95a0$var$_objectSpread($9981b8e7d94e95a0$var$_objectSpread({}, info), {}, {
                mode: info.mode[0]
            });
            delete cleanInfo.range;
            onPickerValueChange(dates[0], cleanInfo);
        }
    };
    var _useRangePickerValue = (0, $7b84215c9fa9f92b$export$2e2bcd8739ae039)(generateConfig, locale, calendarValue, [
        mergedMode
    ], mergedOpen, activeIndex, internalPicker, false, // multiplePanel,
    defaultPickerValue, pickerValue, (0, $4eaa081548444891$export$45b10814cc054894)(showTime === null || showTime === void 0 ? void 0 : showTime.defaultOpenValue), onInternalPickerValueChange, minDate, maxDate), _useRangePickerValue2 = $9981b8e7d94e95a0$var$_slicedToArray(_useRangePickerValue, 2), currentPickerValue = _useRangePickerValue2[0], setCurrentPickerValue = _useRangePickerValue2[1];
    // >>> Mode need wait for `pickerValue`
    var triggerModeChange = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(function(nextPickerValue, nextMode, triggerEvent) {
        setMode(nextMode);
        // Compatible with `onPanelChange`
        if (onPanelChange && triggerEvent !== false) {
            var lastPickerValue = nextPickerValue || calendarValue[calendarValue.length - 1];
            onPanelChange(lastPickerValue, nextMode);
        }
    });
    // ======================== Submit ========================
    /**
   * Different with RangePicker, confirm should check `multiple` logic.
   * This will never provide `date` instead.
   */ var triggerConfirm = function triggerConfirm() {
        triggerSubmitChange(getCalendarValue());
        triggerOpen(false, {
            force: true
        });
    };
    // ======================== Click =========================
    var onSelectorClick = function onSelectorClick(event) {
        if (!disabled && !selectorRef.current.nativeElement.contains(document.activeElement)) // Click to focus the enabled input
        selectorRef.current.focus();
        triggerOpen(true);
        onClick === null || onClick === void 0 || onClick(event);
    };
    var onSelectorClear = function onSelectorClear() {
        triggerSubmitChange(null);
        triggerOpen(false, {
            force: true
        });
    };
    // ======================== Hover =========================
    var _React$useState = $ltGt3.useState(null), _React$useState2 = $9981b8e7d94e95a0$var$_slicedToArray(_React$useState, 2), hoverSource = _React$useState2[0], setHoverSource = _React$useState2[1];
    var _React$useState3 = $ltGt3.useState(null), _React$useState4 = $9981b8e7d94e95a0$var$_slicedToArray(_React$useState3, 2), internalHoverValue = _React$useState4[0], setInternalHoverValue = _React$useState4[1];
    var hoverValues = $ltGt3.useMemo(function() {
        var values = [
            internalHoverValue
        ].concat($9981b8e7d94e95a0$var$_toConsumableArray(calendarValue)).filter(function(date) {
            return date;
        });
        return multiple ? values : values.slice(0, 1);
    }, [
        calendarValue,
        internalHoverValue,
        multiple
    ]);
    // Selector values is different with RangePicker
    // which can not use `hoverValue` directly
    var selectorValues = $ltGt3.useMemo(function() {
        if (!multiple && internalHoverValue) return [
            internalHoverValue
        ];
        return calendarValue.filter(function(date) {
            return date;
        });
    }, [
        calendarValue,
        internalHoverValue,
        multiple
    ]);
    // Clean up `internalHoverValues` when closed
    $ltGt3.useEffect(function() {
        if (!mergedOpen) setInternalHoverValue(null);
    }, [
        mergedOpen
    ]);
    var onSetHover = function onSetHover(date, source) {
        if (previewValue !== 'hover') return;
        setInternalHoverValue(date);
        setHoverSource(source);
    };
    // ========================================================
    // ==                       Panels                       ==
    // ========================================================
    // ======================= Presets ========================
    var presetList = (0, $a9785ec601c9c81e$export$2e2bcd8739ae039)(presets);
    var onPresetHover = function onPresetHover(nextValue) {
        onSetHover(nextValue, 'preset');
    };
    // TODO: handle this
    var onPresetSubmit = function onPresetSubmit(nextValue) {
        var nextCalendarValues = multiple ? toggleDates(getCalendarValue(), nextValue) : [
            nextValue
        ];
        var passed = triggerSubmitChange(nextCalendarValues);
        if (passed && !multiple) triggerOpen(false, {
            force: true
        });
    };
    var onNow = function onNow(now) {
        onPresetSubmit(now);
    };
    // ======================== Panel =========================
    var onPanelHover = function onPanelHover(date) {
        onSetHover(date, 'cell');
    };
    // >>> Focus
    var onPanelFocus = function onPanelFocus(event) {
        triggerOpen(true);
        onSharedFocus(event);
    };
    // >>> Calendar
    var onPanelSelect = function onPanelSelect(date) {
        lastOperation('panel');
        // Not change values if multiple and current panel is to match with picker
        if (multiple && internalMode !== picker) return;
        var nextValues = multiple ? toggleDates(getCalendarValue(), date) : [
            date
        ];
        // Only trigger calendar event but not update internal `calendarValue` state
        triggerCalendarChange(nextValues);
        // >>> Trigger next active if !needConfirm
        // Fully logic check `useRangeValue` hook
        if (!needConfirm && !complexPicker && internalPicker === internalMode) triggerConfirm();
    };
    // >>> Close
    var onPopupClose = function onPopupClose() {
        // Close popup
        triggerOpen(false);
    };
    // >>> cellRender
    var onInternalCellRender = (0, $8fa10cb8931a057d$export$2e2bcd8739ae039)(cellRender, dateRender, monthCellRender);
    // >>> invalid
    var panelProps = $ltGt3.useMemo(function() {
        var domProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(filledProps, false);
        var restProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(filledProps, [].concat($9981b8e7d94e95a0$var$_toConsumableArray(Object.keys(domProps)), [
            'onChange',
            'onCalendarChange',
            'style',
            'className',
            'onPanelChange',
            'classNames',
            'styles'
        ]));
        return $9981b8e7d94e95a0$var$_objectSpread($9981b8e7d94e95a0$var$_objectSpread({}, restProps), {}, {
            multiple: filledProps.multiple
        });
    }, [
        filledProps
    ]);
    // >>> Render
    var panel = /*#__PURE__*/ $ltGt3.createElement((0, $3b229d2234afad92$export$2e2bcd8739ae039), $9981b8e7d94e95a0$var$_extends({}, panelProps, {
        showNow: mergedShowNow,
        showTime: showTime,
        disabledDate: disabledDate,
        onFocus: onPanelFocus,
        onBlur: onSharedBlur,
        picker: picker,
        mode: mergedMode,
        internalMode: internalMode,
        onPanelChange: triggerModeChange,
        format: maskFormat,
        value: calendarValue,
        isInvalid: isInvalidateDate,
        onChange: null,
        onSelect: onPanelSelect,
        pickerValue: currentPickerValue,
        defaultOpenValue: showTime === null || showTime === void 0 ? void 0 : showTime.defaultOpenValue,
        onPickerValueChange: setCurrentPickerValue,
        hoverValue: hoverValues,
        onHover: onPanelHover,
        needConfirm: needConfirm,
        onSubmit: triggerConfirm,
        onOk: triggerOk,
        presets: presetList,
        onPresetHover: onPresetHover,
        onPresetSubmit: onPresetSubmit,
        onNow: onNow,
        cellRender: onInternalCellRender,
        classNames: mergedClassNames,
        styles: mergedStyles
    }));
    // ========================================================
    // ==                      Selector                      ==
    // ========================================================
    // ======================== Change ========================
    var onSelectorChange = function onSelectorChange(date) {
        triggerCalendarChange(date);
    };
    var onSelectorInputChange = function onSelectorInputChange() {
        lastOperation('input');
    };
    // ======================= Selector =======================
    var onSelectorFocus = function onSelectorFocus(event) {
        lastOperation('input');
        triggerOpen(true, {
            inherit: true
        });
        // setActiveIndex(index);
        onSharedFocus(event);
    };
    var onSelectorBlur = function onSelectorBlur(event) {
        triggerOpen(false);
        onSharedBlur(event);
    };
    var onSelectorKeyDown = function onSelectorKeyDown(event, preventDefault) {
        if (event.key === 'Tab') triggerConfirm();
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(event, preventDefault);
    };
    // ======================= Context ========================
    var context = $ltGt3.useMemo(function() {
        return {
            prefixCls: prefixCls,
            locale: locale,
            generateConfig: generateConfig,
            button: components.button,
            input: components.input,
            classNames: mergedClassNames,
            styles: mergedStyles
        };
    }, [
        prefixCls,
        locale,
        generateConfig,
        components.button,
        components.input,
        mergedClassNames,
        mergedStyles
    ]);
    // ======================== Effect ========================
    // >>> Mode
    // Reset for every active
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(function() {
        if (mergedOpen && activeIndex !== undefined) // Legacy compatible. This effect update should not trigger `onPanelChange`
        triggerModeChange(null, picker, false);
    }, [
        mergedOpen,
        activeIndex,
        picker
    ]);
    // >>> For complex picker, we need check if need to focus next one
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(function() {
        var lastOp = lastOperation();
        // Trade as confirm on field leave
        if (!mergedOpen && lastOp === 'input') {
            triggerOpen(false);
            triggerConfirm();
        }
        // Submit with complex picker
        if (!mergedOpen && complexPicker && !needConfirm && lastOp === 'panel') triggerConfirm();
    }, [
        mergedOpen
    ]);
    // ======================== Render ========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $6158ac241550cb6d$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $ltGt3.createElement((0, $a361cd0d3ae96847$export$2e2bcd8739ae039), $9981b8e7d94e95a0$var$_extends({}, (0, $ca229a7f6958f601$export$a11cc4b953869c91)(filledProps), {
        popupElement: panel,
        popupStyle: mergedStyles.popup.root,
        popupClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(rootClassName, mergedClassNames.popup.root),
        visible: mergedOpen,
        onClose: onPopupClose
    }), /*#__PURE__*/ $ltGt3.createElement((0, $f78017728af75b29$export$2e2bcd8739ae039), $9981b8e7d94e95a0$var$_extends({}, filledProps, {
        // Ref
        ref: selectorRef,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(filledProps.className, rootClassName, mergedClassNames.root),
        style: $9981b8e7d94e95a0$var$_objectSpread($9981b8e7d94e95a0$var$_objectSpread({}, mergedStyles.root), filledProps.style),
        suffixIcon: suffixIcon,
        removeIcon: removeIcon,
        activeHelp: !!internalHoverValue,
        allHelp: !!internalHoverValue && hoverSource === 'preset',
        focused: focused,
        onFocus: onSelectorFocus,
        onBlur: onSelectorBlur,
        onKeyDown: onSelectorKeyDown,
        onSubmit: triggerConfirm,
        value: selectorValues,
        maskFormat: maskFormat,
        onChange: onSelectorChange,
        onInputChange: onSelectorInputChange,
        internalPicker: internalPicker,
        format: formatList,
        inputReadOnly: inputReadOnly,
        disabled: disabled,
        open: mergedOpen,
        onOpenChange: triggerOpen,
        onClick: onSelectorClick,
        onClear: onSelectorClear,
        invalid: submitInvalidate,
        onInvalid: function onInvalid(invalid) {
            // Only `single` mode support type date.
            // `multiple` mode can not typing.
            onSelectorInvalid(invalid, 0);
        }
    }))));
}
var $9981b8e7d94e95a0$var$RefPicker = /*#__PURE__*/ $ltGt3.forwardRef($9981b8e7d94e95a0$var$Picker);
var $9981b8e7d94e95a0$export$2e2bcd8739ae039 = $9981b8e7d94e95a0$var$RefPicker;



var $28b44cb19d9b3cf6$export$2e2bcd8739ae039 = (0, $9981b8e7d94e95a0$export$2e2bcd8739ae039);









var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");











var $ltGt3 = parcelRequire("ltGt3");
const $2956ebc156e93027$var$RadioGroupContext = /*#__PURE__*/ $ltGt3.createContext(null);
const $2956ebc156e93027$export$67d4730aee04efd2 = $2956ebc156e93027$var$RadioGroupContext.Provider;
var $2956ebc156e93027$export$2e2bcd8739ae039 = $2956ebc156e93027$var$RadioGroupContext;
const $2956ebc156e93027$export$4fbd9581b41e971f = /*#__PURE__*/ $ltGt3.createContext(null);
const $2956ebc156e93027$export$1b5d1f64a577990e = $2956ebc156e93027$export$4fbd9581b41e971f.Provider;



var $ltGt3 = parcelRequire("ltGt3");
















// ============================== Styles ==============================
// styles from RadioGroup only
const $3e008762e760e8f0$var$getGroupRadioStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const groupPrefixCls = `${componentCls}-group`;
    return {
        [groupPrefixCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            display: 'inline-block',
            fontSize: 0,
            // RTL
            [`&${groupPrefixCls}-rtl`]: {
                direction: 'rtl'
            },
            [`&${groupPrefixCls}-block`]: {
                display: 'flex'
            },
            [`${antCls}-badge ${antCls}-badge-count`]: {
                zIndex: 1
            },
            [`> ${antCls}-badge:not(:first-child) > ${antCls}-button-wrapper`]: {
                borderInlineStart: 'none'
            },
            '&-vertical': {
                display: 'flex',
                flexDirection: 'column',
                rowGap: token.marginXS
            }
        }
    };
};
// Styles from radio-wrapper
const $3e008762e760e8f0$var$getRadioBasicStyle = (token)=>{
    const { componentCls: componentCls, wrapperMarginInlineEnd: wrapperMarginInlineEnd, colorPrimary: colorPrimary, radioSize: radioSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOutCirc: motionEaseInOutCirc, colorBgContainer: colorBgContainer, colorBorder: colorBorder, lineWidth: lineWidth, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, paddingXS: paddingXS, dotColorDisabled: dotColorDisabled, lineType: lineType, radioColor: radioColor, radioBgColor: radioBgColor, calc: calc } = token;
    const radioInnerPrefixCls = `${componentCls}-inner`;
    const dotPadding = 4;
    const radioDotDisabledSize = calc(radioSize).sub(calc(dotPadding).mul(2));
    const radioSizeCalc = calc(1).mul(radioSize).equal({
        unit: true
    });
    return {
        [`${componentCls}-wrapper`]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            display: 'inline-flex',
            alignItems: 'baseline',
            marginInlineStart: 0,
            marginInlineEnd: wrapperMarginInlineEnd,
            cursor: 'pointer',
            '&:last-child': {
                marginInlineEnd: 0
            },
            // RTL
            [`&${componentCls}-wrapper-rtl`]: {
                direction: 'rtl'
            },
            '&-disabled': {
                cursor: 'not-allowed',
                color: token.colorTextDisabled
            },
            '&::after': {
                display: 'inline-block',
                width: 0,
                overflow: 'hidden',
                content: '"\\a0"'
            },
            '&-block': {
                flex: 1,
                justifyContent: 'center'
            },
            // hashId 在 wrapper 上，只能铺平
            [`${componentCls}-checked::after`]: {
                position: 'absolute',
                insetBlockStart: 0,
                insetInlineStart: 0,
                width: '100%',
                height: '100%',
                border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorPrimary}`,
                borderRadius: '50%',
                visibility: 'hidden',
                opacity: 0,
                content: '""'
            },
            [componentCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                position: 'relative',
                display: 'inline-block',
                outline: 'none',
                cursor: 'pointer',
                alignSelf: 'center',
                borderRadius: '50%'
            },
            [`${componentCls}-wrapper:hover &,
        &:hover ${radioInnerPrefixCls}`]: {
                borderColor: colorPrimary
            },
            [`${componentCls}-input:focus-visible + ${radioInnerPrefixCls}`]: (0, $945cb0d2b7017a11$export$6539948f0a737e39)(token),
            [`${componentCls}:hover::after, ${componentCls}-wrapper:hover &::after`]: {
                visibility: 'visible'
            },
            [`${componentCls}-inner`]: {
                '&::after': {
                    boxSizing: 'border-box',
                    position: 'absolute',
                    insetBlockStart: '50%',
                    insetInlineStart: '50%',
                    display: 'block',
                    width: radioSizeCalc,
                    height: radioSizeCalc,
                    marginBlockStart: calc(1).mul(radioSize).div(-2).equal({
                        unit: true
                    }),
                    marginInlineStart: calc(1).mul(radioSize).div(-2).equal({
                        unit: true
                    }),
                    backgroundColor: radioColor,
                    borderBlockStart: 0,
                    borderInlineStart: 0,
                    borderRadius: radioSizeCalc,
                    transform: 'scale(0)',
                    opacity: 0,
                    transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`,
                    content: '""'
                },
                boxSizing: 'border-box',
                position: 'relative',
                insetBlockStart: 0,
                insetInlineStart: 0,
                display: 'block',
                width: radioSizeCalc,
                height: radioSizeCalc,
                backgroundColor: colorBgContainer,
                borderColor: colorBorder,
                borderStyle: 'solid',
                borderWidth: lineWidth,
                borderRadius: '50%',
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-input`]: {
                position: 'absolute',
                inset: 0,
                zIndex: 1,
                cursor: 'pointer',
                opacity: 0
            },
            // 选中状态
            [`${componentCls}-checked`]: {
                [radioInnerPrefixCls]: {
                    borderColor: colorPrimary,
                    backgroundColor: radioBgColor,
                    '&::after': {
                        transform: `scale(${token.calc(token.dotSize).div(radioSize).equal()})`,
                        opacity: 1,
                        transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`
                    }
                }
            },
            [`${componentCls}-disabled`]: {
                cursor: 'not-allowed',
                [radioInnerPrefixCls]: {
                    backgroundColor: colorBgContainerDisabled,
                    borderColor: colorBorder,
                    cursor: 'not-allowed',
                    '&::after': {
                        backgroundColor: dotColorDisabled
                    }
                },
                [`${componentCls}-input`]: {
                    cursor: 'not-allowed'
                },
                [`${componentCls}-disabled + span`]: {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                },
                [`&${componentCls}-checked`]: {
                    [radioInnerPrefixCls]: {
                        '&::after': {
                            transform: `scale(${calc(radioDotDisabledSize).div(radioSize).equal()})`
                        }
                    }
                }
            },
            [`span${componentCls} + *`]: {
                paddingInlineStart: paddingXS,
                paddingInlineEnd: paddingXS
            }
        }
    };
};
// Styles from radio-button
const $3e008762e760e8f0$var$getRadioButtonStyle = (token)=>{
    const { buttonColor: buttonColor, controlHeight: controlHeight, componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, motionDurationMid: motionDurationMid, buttonPaddingInline: buttonPaddingInline, fontSize: fontSize, buttonBg: buttonBg, fontSizeLG: fontSizeLG, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, paddingXS: paddingXS, borderRadius: borderRadius, borderRadiusSM: borderRadiusSM, borderRadiusLG: borderRadiusLG, buttonCheckedBg: buttonCheckedBg, buttonSolidCheckedColor: buttonSolidCheckedColor, colorTextDisabled: colorTextDisabled, colorBgContainerDisabled: colorBgContainerDisabled, buttonCheckedBgDisabled: buttonCheckedBgDisabled, buttonCheckedColorDisabled: buttonCheckedColorDisabled, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, colorPrimaryActive: colorPrimaryActive, buttonSolidCheckedBg: buttonSolidCheckedBg, buttonSolidCheckedHoverBg: buttonSolidCheckedHoverBg, buttonSolidCheckedActiveBg: buttonSolidCheckedActiveBg, calc: calc } = token;
    return {
        [`${componentCls}-button-wrapper`]: {
            position: 'relative',
            display: 'inline-block',
            height: controlHeight,
            margin: 0,
            paddingInline: buttonPaddingInline,
            paddingBlock: 0,
            color: buttonColor,
            fontSize: fontSize,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(controlHeight).sub(calc(lineWidth).mul(2)).equal()),
            background: buttonBg,
            border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`,
            // strange align fix for chrome but works
            // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
            borderBlockStartWidth: calc(lineWidth).add(0.02).equal(),
            borderInlineEndWidth: lineWidth,
            cursor: 'pointer',
            transition: [
                `color ${motionDurationMid}`,
                `background ${motionDurationMid}`,
                `box-shadow ${motionDurationMid}`
            ].join(','),
            a: {
                color: buttonColor
            },
            [`> ${componentCls}-button`]: {
                position: 'absolute',
                insetBlockStart: 0,
                insetInlineStart: 0,
                zIndex: -1,
                width: '100%',
                height: '100%'
            },
            '&:not(:last-child)': {
                marginInlineEnd: calc(lineWidth).mul(-1).equal()
            },
            '&:first-child': {
                borderInlineStart: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`,
                borderStartStartRadius: borderRadius,
                borderEndStartRadius: borderRadius
            },
            '&:last-child': {
                borderStartEndRadius: borderRadius,
                borderEndEndRadius: borderRadius
            },
            '&:first-child:last-child': {
                borderRadius: borderRadius
            },
            [`${componentCls}-group-large &`]: {
                height: controlHeightLG,
                fontSize: fontSizeLG,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal()),
                '&:first-child': {
                    borderStartStartRadius: borderRadiusLG,
                    borderEndStartRadius: borderRadiusLG
                },
                '&:last-child': {
                    borderStartEndRadius: borderRadiusLG,
                    borderEndEndRadius: borderRadiusLG
                }
            },
            [`${componentCls}-group-small &`]: {
                height: controlHeightSM,
                paddingInline: calc(paddingXS).sub(lineWidth).equal(),
                paddingBlock: 0,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal()),
                '&:first-child': {
                    borderStartStartRadius: borderRadiusSM,
                    borderEndStartRadius: borderRadiusSM
                },
                '&:last-child': {
                    borderStartEndRadius: borderRadiusSM,
                    borderEndEndRadius: borderRadiusSM
                }
            },
            '&:hover': {
                position: 'relative',
                color: colorPrimary
            },
            '&:has(:focus-visible)': (0, $945cb0d2b7017a11$export$6539948f0a737e39)(token),
            [`${componentCls}-inner, input[type='checkbox'], input[type='radio']`]: {
                width: 0,
                height: 0,
                opacity: 0,
                pointerEvents: 'none'
            },
            [`&-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                zIndex: 1,
                color: colorPrimary,
                background: buttonCheckedBg,
                borderColor: colorPrimary,
                '&::before': {
                    backgroundColor: colorPrimary
                },
                '&:first-child': {
                    borderColor: colorPrimary
                },
                '&:hover': {
                    color: colorPrimaryHover,
                    borderColor: colorPrimaryHover,
                    '&::before': {
                        backgroundColor: colorPrimaryHover
                    }
                },
                '&:active': {
                    color: colorPrimaryActive,
                    borderColor: colorPrimaryActive,
                    '&::before': {
                        backgroundColor: colorPrimaryActive
                    }
                }
            },
            [`${componentCls}-group-solid &-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                color: buttonSolidCheckedColor,
                background: buttonSolidCheckedBg,
                borderColor: buttonSolidCheckedBg,
                '&:hover': {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedHoverBg,
                    borderColor: buttonSolidCheckedHoverBg
                },
                '&:active': {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedActiveBg,
                    borderColor: buttonSolidCheckedActiveBg
                }
            },
            '&-disabled': {
                color: colorTextDisabled,
                backgroundColor: colorBgContainerDisabled,
                borderColor: colorBorder,
                cursor: 'not-allowed',
                '&:first-child, &:hover': {
                    color: colorTextDisabled,
                    backgroundColor: colorBgContainerDisabled,
                    borderColor: colorBorder
                }
            },
            [`&-disabled${componentCls}-button-wrapper-checked`]: {
                color: buttonCheckedColorDisabled,
                backgroundColor: buttonCheckedBgDisabled,
                borderColor: colorBorder,
                boxShadow: 'none'
            },
            '&-block': {
                flex: 1,
                textAlign: 'center'
            }
        }
    };
};
const $3e008762e760e8f0$export$9ca1be8807fe0675 = (token)=>{
    const { wireframe: wireframe, padding: padding, marginXS: marginXS, lineWidth: lineWidth, fontSizeLG: fontSizeLG, colorText: colorText, colorBgContainer: colorBgContainer, colorTextDisabled: colorTextDisabled, controlItemBgActiveDisabled: controlItemBgActiveDisabled, colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, colorPrimaryActive: colorPrimaryActive, colorWhite: colorWhite } = token;
    const dotPadding = 4; // Fixed value
    const radioSize = fontSizeLG;
    const radioDotSize = wireframe ? radioSize - dotPadding * 2 : radioSize - (dotPadding + lineWidth) * 2;
    return {
        radioSize: // Radio
        radioSize,
        dotSize: radioDotSize,
        dotColorDisabled: colorTextDisabled,
        // Radio buttons
        buttonSolidCheckedColor: colorTextLightSolid,
        buttonSolidCheckedBg: colorPrimary,
        buttonSolidCheckedHoverBg: colorPrimaryHover,
        buttonSolidCheckedActiveBg: colorPrimaryActive,
        buttonBg: colorBgContainer,
        buttonCheckedBg: colorBgContainer,
        buttonColor: colorText,
        buttonCheckedBgDisabled: controlItemBgActiveDisabled,
        buttonCheckedColorDisabled: colorTextDisabled,
        buttonPaddingInline: padding - lineWidth,
        wrapperMarginInlineEnd: marginXS,
        // internal
        radioColor: wireframe ? colorPrimary : colorWhite,
        radioBgColor: wireframe ? colorBgContainer : colorPrimary
    };
};
var $3e008762e760e8f0$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Radio', (token)=>{
    const { controlOutline: controlOutline, controlOutlineWidth: controlOutlineWidth } = token;
    const radioFocusShadow = `0 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(controlOutlineWidth)} ${controlOutline}`;
    const radioButtonFocusShadow = radioFocusShadow;
    const radioToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        radioFocusShadow: radioFocusShadow,
        radioButtonFocusShadow: radioButtonFocusShadow
    });
    return [
        $3e008762e760e8f0$var$getGroupRadioStyle(radioToken),
        $3e008762e760e8f0$var$getRadioBasicStyle(radioToken),
        $3e008762e760e8f0$var$getRadioButtonStyle(radioToken)
    ];
}, $3e008762e760e8f0$export$9ca1be8807fe0675, {
    unitless: {
        radioSize: true,
        dotSize: true
    }
});


"use client";
const $df533901028154a9$var$InternalRadio = (props, ref)=>{
    const groupContext = $ltGt3.useContext((0, $2956ebc156e93027$export$2e2bcd8739ae039));
    const radioOptionTypeContext = $ltGt3.useContext((0, $2956ebc156e93027$export$4fbd9581b41e971f));
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('radio');
    const innerRef = $ltGt3.useRef(null);
    const mergedRef = (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(ref, innerRef);
    const { isFormItemInput: isFormItemInput } = $ltGt3.useContext((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    const onChange = (e)=>{
        props.onChange?.(e);
        groupContext?.onChange?.(e);
    };
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, style: style, title: title, classNames: classNames, styles: styles, ...restProps } = props;
    const radioPrefixCls = getPrefixCls('radio', customizePrefixCls);
    const isButtonType = (groupContext?.optionType || radioOptionTypeContext) === 'button';
    const prefixCls = isButtonType ? `${radioPrefixCls}-button` : radioPrefixCls;
    // Style
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(radioPrefixCls);
    const [hashId, cssVarCls] = (0, $3e008762e760e8f0$export$2e2bcd8739ae039)(radioPrefixCls, rootCls);
    const radioProps = {
        ...restProps
    };
    // ===================== Disabled =====================
    const disabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    if (groupContext) {
        radioProps.name = groupContext.name;
        radioProps.onChange = onChange;
        radioProps.checked = props.value === groupContext.value;
        radioProps.disabled = radioProps.disabled ?? groupContext.disabled;
    }
    radioProps.disabled = radioProps.disabled ?? disabled;
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        ...radioProps
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const wrapperClassString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, {
        [`${prefixCls}-wrapper-checked`]: radioProps.checked,
        [`${prefixCls}-wrapper-disabled`]: radioProps.disabled,
        [`${prefixCls}-wrapper-rtl`]: direction === 'rtl',
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput,
        [`${prefixCls}-wrapper-block`]: !!groupContext?.block
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls, rootCls);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, $34cfb5e7803229c1$export$2e2bcd8739ae039)(radioProps.onClick);
    // ============================== Render ==============================
    return /*#__PURE__*/ $ltGt3.createElement((0, $b5f0e609aabb59e2$export$2e2bcd8739ae039), {
        component: "Radio",
        disabled: radioProps.disabled
    }, /*#__PURE__*/ $ltGt3.createElement("label", {
        className: wrapperClassString,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        title: title,
        onClick: onLabelClick
    }, /*#__PURE__*/ $ltGt3.createElement((0, $5be58c811ab7b572$export$2e2bcd8739ae039), {
        ...radioProps,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassNames.icon, {
            [(0, $59c6657b0a346860$export$23466a5792b7a5d3)]: !isButtonType
        }),
        style: mergedStyles.icon,
        type: "radio",
        prefixCls: prefixCls,
        ref: mergedRef,
        onClick: onInputClick
    }), children !== undefined ? /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-label`, mergedClassNames.label),
        style: mergedStyles.label
    }, children) : null));
};
const $df533901028154a9$var$Radio = /*#__PURE__*/ $ltGt3.forwardRef($df533901028154a9$var$InternalRadio);
var $df533901028154a9$export$2e2bcd8739ae039 = $df533901028154a9$var$Radio;



"use client";
const $543009a187333b81$var$RadioGroup = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { name: formItemName } = $ltGt3.useContext((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    const defaultName = (0, $1fb03482b73301f3$export$2e2bcd8739ae039)((0, $f920ebb7dca9d6d3$export$368b682c15953eea)(formItemName));
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, options: options, buttonStyle: buttonStyle = 'outline', disabled: disabled, children: children, size: customizeSize, style: style, id: id, optionType: optionType, name: name = defaultName, defaultValue: defaultValue, value: customizedValue, block: block = false, onChange: onChange, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, orientation: orientation, vertical: vertical } = props;
    const [value, setValue] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultValue, customizedValue);
    const onRadioChange = $ltGt3.useCallback((event)=>{
        const lastValue = value;
        const val = event.target.value;
        if (!('value' in props)) setValue(val);
        if (val !== lastValue) onChange?.(event);
    }, [
        value,
        setValue,
        onChange
    ]);
    const prefixCls = getPrefixCls('radio', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    // Style
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $3e008762e760e8f0$export$2e2bcd8739ae039)(prefixCls, rootCls);
    let childrenToRender = children;
    // 如果存在 options, 优先使用
    if (options && options.length > 0) childrenToRender = options.map((option)=>{
        if (typeof option === 'string' || typeof option === 'number') // 此处类型自动推导为 string
        return /*#__PURE__*/ $ltGt3.createElement((0, $df533901028154a9$export$2e2bcd8739ae039), {
            key: option.toString(),
            prefixCls: prefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
        }, option);
        // 此处类型自动推导为 { label: string value: string }
        return /*#__PURE__*/ $ltGt3.createElement((0, $df533901028154a9$export$2e2bcd8739ae039), {
            key: `radio-group-value-options-${option.value}`,
            prefixCls: prefixCls,
            disabled: option.disabled || disabled,
            value: option.value,
            checked: value === option.value,
            title: option.title,
            style: option.style,
            className: option.className,
            id: option.id,
            required: option.required
        }, option.label);
    });
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)(customizeSize);
    const [, mergedVertical] = (0, $15bdf1069fb84d0c$export$550084c67147f6c4)(orientation, vertical);
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(groupPrefixCls, `${groupPrefixCls}-${buttonStyle}`, {
        [`${groupPrefixCls}-${mergedSize}`]: mergedSize,
        [`${groupPrefixCls}-rtl`]: direction === 'rtl',
        [`${groupPrefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls, rootCls);
    const memoizedValue = $ltGt3.useMemo(()=>({
            onChange: onRadioChange,
            value: value,
            disabled: disabled,
            name: name,
            optionType: optionType,
            block: block
        }), [
        onRadioChange,
        value,
        disabled,
        name,
        optionType,
        block
    ]);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ...(0, $297f85de79f8d325$export$2e2bcd8739ae039)(props, {
            aria: true,
            data: true
        }),
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(classString, {
            [`${prefixCls}-group-vertical`]: mergedVertical
        }),
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        id: id,
        ref: ref
    }, /*#__PURE__*/ $ltGt3.createElement((0, $2956ebc156e93027$export$67d4730aee04efd2), {
        value: memoizedValue
    }, childrenToRender));
});
var $543009a187333b81$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.memo($543009a187333b81$var$RadioGroup);




var $ltGt3 = parcelRequire("ltGt3");



"use client";
const $e4404cb27472b970$var$RadioButton = (props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, ...radioProps } = props;
    const prefixCls = getPrefixCls('radio', customizePrefixCls);
    return /*#__PURE__*/ $ltGt3.createElement((0, $2956ebc156e93027$export$1b5d1f64a577990e), {
        value: "button"
    }, /*#__PURE__*/ $ltGt3.createElement((0, $df533901028154a9$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        ...radioProps,
        type: "radio",
        ref: ref
    }));
};
var $e4404cb27472b970$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.forwardRef($e4404cb27472b970$var$RadioButton);


"use client";
const $e6a2ebed9d2f17f5$var$Radio = (0, $df533901028154a9$export$2e2bcd8739ae039);
$e6a2ebed9d2f17f5$var$Radio.Button = (0, $e4404cb27472b970$export$2e2bcd8739ae039);
$e6a2ebed9d2f17f5$var$Radio.Group = (0, $543009a187333b81$export$2e2bcd8739ae039);
$e6a2ebed9d2f17f5$var$Radio.__ANT_RADIO = true;
var $e6a2ebed9d2f17f5$export$2e2bcd8739ae039 = $e6a2ebed9d2f17f5$var$Radio;



"use client";
const $06523810d11c57ff$var$YEAR_SELECT_OFFSET = 10;
const $06523810d11c57ff$var$YEAR_SELECT_TOTAL = 20;
function $06523810d11c57ff$var$YearSelect(props) {
    const { fullscreen: fullscreen, validRange: validRange, generateConfig: generateConfig, locale: locale, prefixCls: prefixCls, value: value, onChange: onChange, divRef: divRef } = props;
    const year = generateConfig.getYear(value || generateConfig.getNow());
    let start = year - $06523810d11c57ff$var$YEAR_SELECT_OFFSET;
    let end = start + $06523810d11c57ff$var$YEAR_SELECT_TOTAL;
    if (validRange) {
        start = generateConfig.getYear(validRange[0]);
        end = generateConfig.getYear(validRange[1]) + 1;
    }
    const suffix = locale && locale.year === "\u5E74" ? "\u5E74" : '';
    const options = [];
    for(let index = start; index < end; index++)options.push({
        label: `${index}${suffix}`,
        value: index
    });
    return /*#__PURE__*/ $ltGt3.createElement((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
        size: fullscreen ? undefined : 'small',
        options: options,
        value: year,
        className: `${prefixCls}-year-select`,
        onChange: (numYear)=>{
            let newDate = generateConfig.setYear(value, numYear);
            if (validRange) {
                const [startDate, endDate] = validRange;
                const newYear = generateConfig.getYear(newDate);
                const newMonth = generateConfig.getMonth(newDate);
                if (newYear === generateConfig.getYear(endDate) && newMonth > generateConfig.getMonth(endDate)) newDate = generateConfig.setMonth(newDate, generateConfig.getMonth(endDate));
                if (newYear === generateConfig.getYear(startDate) && newMonth < generateConfig.getMonth(startDate)) newDate = generateConfig.setMonth(newDate, generateConfig.getMonth(startDate));
            }
            onChange(newDate);
        },
        getPopupContainer: ()=>divRef.current
    });
}
function $06523810d11c57ff$var$MonthSelect(props) {
    const { prefixCls: prefixCls, fullscreen: fullscreen, validRange: validRange, value: value, generateConfig: generateConfig, locale: locale, onChange: onChange, divRef: divRef } = props;
    const month = generateConfig.getMonth(value || generateConfig.getNow());
    let start = 0;
    let end = 11;
    if (validRange) {
        const [rangeStart, rangeEnd] = validRange;
        const currentYear = generateConfig.getYear(value);
        if (generateConfig.getYear(rangeEnd) === currentYear) end = generateConfig.getMonth(rangeEnd);
        if (generateConfig.getYear(rangeStart) === currentYear) start = generateConfig.getMonth(rangeStart);
    }
    const months = locale.shortMonths || generateConfig.locale.getShortMonths(locale.locale);
    const options = [];
    for(let index = start; index <= end; index += 1)options.push({
        label: months[index],
        value: index
    });
    return /*#__PURE__*/ $ltGt3.createElement((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
        size: fullscreen ? undefined : 'small',
        className: `${prefixCls}-month-select`,
        value: month,
        options: options,
        onChange: (newMonth)=>{
            onChange(generateConfig.setMonth(value, newMonth));
        },
        getPopupContainer: ()=>divRef.current
    });
}
function $06523810d11c57ff$var$ModeSwitch(props) {
    const { prefixCls: prefixCls, locale: locale, mode: mode, fullscreen: fullscreen, onModeChange: onModeChange } = props;
    return /*#__PURE__*/ $ltGt3.createElement((0, $543009a187333b81$export$2e2bcd8739ae039), {
        onChange: ({ target: { value: value } })=>{
            onModeChange(value);
        },
        value: mode,
        size: fullscreen ? undefined : 'small',
        className: `${prefixCls}-mode-switch`
    }, /*#__PURE__*/ $ltGt3.createElement((0, $e4404cb27472b970$export$2e2bcd8739ae039), {
        value: "month"
    }, locale.month), /*#__PURE__*/ $ltGt3.createElement((0, $e4404cb27472b970$export$2e2bcd8739ae039), {
        value: "year"
    }, locale.year));
}
function $06523810d11c57ff$var$CalendarHeader(props) {
    const { prefixCls: prefixCls, fullscreen: fullscreen, mode: mode, onChange: onChange, onModeChange: onModeChange, className: className, style: style } = props;
    const divRef = $ltGt3.useRef(null);
    const formItemInputContext = (0, $ltGt3.useContext)((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    const mergedFormItemInputContext = (0, $ltGt3.useMemo)(()=>({
            ...formItemInputContext,
            isFormItemInput: false
        }), [
        formItemInputContext
    ]);
    const sharedProps = {
        ...props,
        fullscreen: fullscreen,
        divRef: divRef
    };
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-header`, className),
        style: style,
        ref: divRef
    }, /*#__PURE__*/ $ltGt3.createElement((0, $2fc8703031980156$export$bbb5553c6c7a14ed).Provider, {
        value: mergedFormItemInputContext
    }, /*#__PURE__*/ $ltGt3.createElement($06523810d11c57ff$var$YearSelect, {
        ...sharedProps,
        onChange: (v)=>{
            onChange(v, 'year');
        }
    }), mode === 'month' && /*#__PURE__*/ $ltGt3.createElement($06523810d11c57ff$var$MonthSelect, {
        ...sharedProps,
        onChange: (v)=>{
            onChange(v, 'month');
        }
    })), /*#__PURE__*/ $ltGt3.createElement($06523810d11c57ff$var$ModeSwitch, {
        ...sharedProps,
        onModeChange: onModeChange
    }));
}
var $06523810d11c57ff$export$2e2bcd8739ae039 = $06523810d11c57ff$var$CalendarHeader;















const $1bd916d07d7153e4$export$aaa3604bfe071829 = (token)=>{
    const { multipleSelectItemHeight: multipleSelectItemHeight, paddingXXS: paddingXXS, lineWidth: lineWidth, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const basePadding = token.max(token.calc(paddingXXS).sub(lineWidth).equal(), 0);
    const containerPadding = token.max(token.calc(basePadding).sub(INTERNAL_FIXED_ITEM_MARGIN).equal(), 0);
    return {
        basePadding: basePadding,
        containerPadding: containerPadding,
        itemHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(multipleSelectItemHeight),
        itemLineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(multipleSelectItemHeight).sub(token.calc(token.lineWidth).mul(2)).equal())
    };
};
const $1bd916d07d7153e4$export$b4ab9d1500d7d856 = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, borderRadiusSM: borderRadiusSM, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, multipleItemColorDisabled: multipleItemColorDisabled, multipleItemBorderColorDisabled: multipleItemBorderColorDisabled, colorIcon: colorIcon, colorIconHover: colorIconHover, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
    return {
        /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */ // =========================== Overflow ===========================
        [selectOverflowPrefixCls]: {
            position: 'relative',
            display: 'flex',
            flex: 'auto',
            flexWrap: 'wrap',
            maxWidth: '100%',
            '&-item': {
                flex: 'none',
                alignSelf: 'center',
                // https://github.com/ant-design/ant-design/issues/54179
                maxWidth: 'calc(100% - 4px)',
                display: 'inline-flex'
            },
            // ======================== Selections ==========================
            [`${componentCls}-selection-item`]: {
                display: 'flex',
                alignSelf: 'center',
                flex: 'none',
                boxSizing: 'border-box',
                maxWidth: '100%',
                marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
                borderRadius: borderRadiusSM,
                cursor: 'default',
                transition: `font-size ${motionDurationSlow}, line-height ${motionDurationSlow}, height ${motionDurationSlow}`,
                marginInlineEnd: token.calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
                paddingInlineStart: paddingXS,
                paddingInlineEnd: token.calc(paddingXS).div(2).equal(),
                [`${componentCls}-disabled&`]: {
                    color: multipleItemColorDisabled,
                    borderColor: multipleItemBorderColorDisabled,
                    cursor: 'not-allowed'
                },
                // It's ok not to do this, but 24px makes bottom narrow in view should adjust
                '&-content': {
                    display: 'inline-block',
                    marginInlineEnd: token.calc(paddingXS).div(2).equal(),
                    overflow: 'hidden',
                    whiteSpace: 'pre',
                    // fix whitespace wrapping. custom tags display all whitespace within.
                    textOverflow: 'ellipsis'
                },
                '&-remove': {
                    ...(0, $945cb0d2b7017a11$export$171ccda7bc085e59)(),
                    display: 'inline-flex',
                    alignItems: 'center',
                    color: colorIcon,
                    fontWeight: 'bold',
                    fontSize: 10,
                    lineHeight: 'inherit',
                    cursor: 'pointer',
                    [`> ${iconCls}`]: {
                        verticalAlign: '-0.2em'
                    },
                    '&:hover': {
                        color: colorIconHover
                    }
                }
            }
        }
    };
};


const $32b5bc56ebd14fbd$var$genSize = (token, suffix)=>{
    const { componentCls: componentCls, controlHeight: controlHeight } = token;
    const suffixCls = suffix ? `${componentCls}-${suffix}` : '';
    const multipleSelectorUnit = (0, $1bd916d07d7153e4$export$aaa3604bfe071829)(token);
    return [
        // genSelectionStyle(token, suffix),
        {
            [`${componentCls}-multiple${suffixCls}`]: {
                paddingBlock: multipleSelectorUnit.containerPadding,
                paddingInlineStart: multipleSelectorUnit.basePadding,
                minHeight: controlHeight,
                // ======================== Selections ========================
                [`${componentCls}-selection-item`]: {
                    height: multipleSelectorUnit.itemHeight,
                    lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(multipleSelectorUnit.itemLineHeight)
                }
            }
        }
    ];
};
const $32b5bc56ebd14fbd$var$genPickerMultipleStyle = (token)=>{
    const { componentCls: componentCls, calc: calc, lineWidth: lineWidth } = token;
    const smallToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        fontHeight: token.fontSize,
        selectHeight: token.controlHeightSM,
        multipleSelectItemHeight: token.multipleItemHeightSM,
        borderRadius: token.borderRadiusSM,
        borderRadiusSM: token.borderRadiusXS,
        controlHeight: token.controlHeightSM
    });
    const largeToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        fontHeight: calc(token.multipleItemHeightLG).sub(calc(lineWidth).mul(2).equal()).equal(),
        fontSize: token.fontSizeLG,
        selectHeight: token.controlHeightLG,
        multipleSelectItemHeight: token.multipleItemHeightLG,
        borderRadius: token.borderRadiusLG,
        borderRadiusSM: token.borderRadius,
        controlHeight: token.controlHeightLG
    });
    return [
        // ======================== Size ========================
        $32b5bc56ebd14fbd$var$genSize(smallToken, 'small'),
        $32b5bc56ebd14fbd$var$genSize(token),
        $32b5bc56ebd14fbd$var$genSize(largeToken, 'large'),
        // ====================== Selection ======================
        {
            [`${componentCls}${componentCls}-multiple`]: {
                width: '100%',
                cursor: 'text',
                // ==================== Selector =====================
                [`${componentCls}-selector`]: {
                    flex: 'auto',
                    padding: 0,
                    position: 'relative',
                    '&:after': {
                        margin: 0
                    },
                    // ================== placeholder ==================
                    [`${componentCls}-selection-placeholder`]: {
                        position: 'absolute',
                        top: '50%',
                        insetInlineStart: token.inputPaddingHorizontalBase,
                        insetInlineEnd: 0,
                        transform: 'translateY(-50%)',
                        transition: `all ${token.motionDurationSlow}`,
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        flex: 1,
                        color: token.colorTextPlaceholder,
                        pointerEvents: 'none'
                    }
                },
                // ===================== Overflow ====================
                ...(0, $1bd916d07d7153e4$export$b4ab9d1500d7d856)(token),
                // ====================== Input ======================
                // Input is `readonly`, which is used for a11y only
                [`${componentCls}-multiple-input`]: {
                    width: 0,
                    height: 0,
                    border: 0,
                    visibility: 'hidden',
                    position: 'absolute',
                    zIndex: -1
                }
            }
        }
    ];
};
var $32b5bc56ebd14fbd$export$2e2bcd8739ae039 = $32b5bc56ebd14fbd$var$genPickerMultipleStyle;




const $234da4737d7b5ae8$var$genPickerCellInnerStyle = (token)=>{
    const { pickerCellCls: pickerCellCls, pickerCellInnerCls: pickerCellInnerCls, cellHeight: cellHeight, borderRadiusSM: borderRadiusSM, motionDurationMid: motionDurationMid, cellHoverBg: cellHoverBg, lineWidth: lineWidth, lineType: lineType, colorPrimary: colorPrimary, cellActiveWithRangeBg: cellActiveWithRangeBg, colorTextLightSolid: colorTextLightSolid, colorTextDisabled: colorTextDisabled, cellBgDisabled: cellBgDisabled, colorFillSecondary: colorFillSecondary } = token;
    return {
        '&::before': {
            position: 'absolute',
            top: '50%',
            insetInlineStart: 0,
            insetInlineEnd: 0,
            zIndex: 1,
            height: cellHeight,
            transform: 'translateY(-50%)',
            content: '""',
            pointerEvents: 'none'
        },
        // >>> Default
        [pickerCellInnerCls]: {
            position: 'relative',
            zIndex: 2,
            display: 'inline-block',
            minWidth: cellHeight,
            height: cellHeight,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(cellHeight),
            borderRadius: borderRadiusSM,
            transition: `background ${motionDurationMid}`
        },
        // >>> Hover
        [`&:hover:not(${pickerCellCls}-in-view):not(${pickerCellCls}-disabled),
    &:hover:not(${pickerCellCls}-selected):not(${pickerCellCls}-range-start):not(${pickerCellCls}-range-end):not(${pickerCellCls}-disabled)`]: {
            [pickerCellInnerCls]: {
                background: cellHoverBg
            }
        },
        // >>> Today
        [`&-in-view${pickerCellCls}-today ${pickerCellInnerCls}`]: {
            '&::before': {
                position: 'absolute',
                top: 0,
                insetInlineEnd: 0,
                bottom: 0,
                insetInlineStart: 0,
                zIndex: 1,
                border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorPrimary}`,
                borderRadius: borderRadiusSM,
                content: '""'
            }
        },
        // >>> In Range
        [`&-in-view${pickerCellCls}-in-range,
      &-in-view${pickerCellCls}-range-start,
      &-in-view${pickerCellCls}-range-end`]: {
            position: 'relative',
            [`&:not(${pickerCellCls}-disabled):before`]: {
                background: cellActiveWithRangeBg
            }
        },
        // >>> Selected
        [`&-in-view${pickerCellCls}-selected,
      &-in-view${pickerCellCls}-range-start,
      &-in-view${pickerCellCls}-range-end`]: {
            [`&:not(${pickerCellCls}-disabled) ${pickerCellInnerCls}`]: {
                color: colorTextLightSolid,
                background: colorPrimary
            },
            [`&${pickerCellCls}-disabled ${pickerCellInnerCls}`]: {
                background: colorFillSecondary
            }
        },
        [`&-in-view${pickerCellCls}-range-start:not(${pickerCellCls}-disabled):before`]: {
            insetInlineStart: '50%'
        },
        [`&-in-view${pickerCellCls}-range-end:not(${pickerCellCls}-disabled):before`]: {
            insetInlineEnd: '50%'
        },
        // range start border-radius
        [`&-in-view${pickerCellCls}-range-start:not(${pickerCellCls}-range-end) ${pickerCellInnerCls}`]: {
            borderStartStartRadius: borderRadiusSM,
            borderEndStartRadius: borderRadiusSM,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
        },
        // range end border-radius
        [`&-in-view${pickerCellCls}-range-end:not(${pickerCellCls}-range-start) ${pickerCellInnerCls}`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            borderStartEndRadius: borderRadiusSM,
            borderEndEndRadius: borderRadiusSM
        },
        // >>> Disabled
        '&-disabled': {
            color: colorTextDisabled,
            cursor: 'not-allowed',
            [pickerCellInnerCls]: {
                background: 'transparent'
            },
            '&::before': {
                background: cellBgDisabled
            }
        },
        [`&-disabled${pickerCellCls}-today ${pickerCellInnerCls}::before`]: {
            borderColor: colorTextDisabled
        }
    };
};
const $234da4737d7b5ae8$export$da5309fdba1a1b64 = (token)=>{
    const { componentCls: componentCls, pickerCellCls: pickerCellCls, pickerCellInnerCls: pickerCellInnerCls, pickerYearMonthCellWidth: pickerYearMonthCellWidth, pickerControlIconSize: pickerControlIconSize, cellWidth: cellWidth, paddingSM: paddingSM, paddingXS: paddingXS, paddingXXS: paddingXXS, colorBgContainer: colorBgContainer, lineWidth: lineWidth, lineType: lineType, borderRadiusLG: borderRadiusLG, colorPrimary: colorPrimary, colorTextHeading: colorTextHeading, colorSplit: colorSplit, pickerControlIconBorderWidth: pickerControlIconBorderWidth, colorIcon: colorIcon, textHeight: textHeight, motionDurationMid: motionDurationMid, colorIconHover: colorIconHover, fontWeightStrong: fontWeightStrong, cellHeight: cellHeight, pickerCellPaddingVertical: pickerCellPaddingVertical, colorTextDisabled: colorTextDisabled, colorText: colorText, fontSize: fontSize, motionDurationSlow: motionDurationSlow, withoutTimeCellHeight: withoutTimeCellHeight, pickerQuarterPanelContentHeight: pickerQuarterPanelContentHeight, borderRadiusSM: borderRadiusSM, colorTextLightSolid: colorTextLightSolid, cellHoverBg: cellHoverBg, timeColumnHeight: timeColumnHeight, timeColumnWidth: timeColumnWidth, timeCellHeight: timeCellHeight, controlItemBgActive: controlItemBgActive, marginXXS: marginXXS, pickerDatePanelPaddingHorizontal: pickerDatePanelPaddingHorizontal, pickerControlIconMargin: pickerControlIconMargin } = token;
    const pickerPanelWidth = token.calc(cellWidth).mul(7).add(token.calc(pickerDatePanelPaddingHorizontal).mul(2)).equal();
    return {
        [componentCls]: {
            '&-panel': {
                display: 'inline-flex',
                flexDirection: 'column',
                textAlign: 'center',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
                outline: 'none',
                '&-focused': {
                    borderColor: colorPrimary
                },
                '&-rtl': {
                    [`${componentCls}-prev-icon,
              ${componentCls}-super-prev-icon`]: {
                        transform: 'rotate(45deg)'
                    },
                    [`${componentCls}-next-icon,
              ${componentCls}-super-next-icon`]: {
                        transform: 'rotate(-135deg)'
                    },
                    [`${componentCls}-time-panel`]: {
                        [`${componentCls}-content`]: {
                            direction: 'ltr',
                            '> *': {
                                direction: 'rtl'
                            }
                        }
                    }
                }
            },
            // ========================================================
            // =                     Shared Panel                     =
            // ========================================================
            [`&-decade-panel,
        &-year-panel,
        &-quarter-panel,
        &-month-panel,
        &-week-panel,
        &-date-panel,
        &-time-panel`]: {
                display: 'flex',
                flexDirection: 'column',
                width: pickerPanelWidth
            },
            // ======================= Header =======================
            '&-header': {
                display: 'flex',
                padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)}`,
                color: colorTextHeading,
                borderBottom: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
                '> *': {
                    flex: 'none'
                },
                button: {
                    padding: 0,
                    color: colorIcon,
                    lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(textHeight),
                    background: 'transparent',
                    border: 0,
                    cursor: 'pointer',
                    transition: `color ${motionDurationMid}`,
                    fontSize: 'inherit',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:empty': {
                        display: 'none'
                    }
                },
                '> button': {
                    minWidth: '1.6em',
                    fontSize: fontSize,
                    '&:hover': {
                        color: colorIconHover
                    },
                    '&:disabled': {
                        opacity: 0.25,
                        pointerEvents: 'none'
                    }
                },
                '&-view': {
                    flex: 'auto',
                    fontWeight: fontWeightStrong,
                    lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(textHeight),
                    '> button': {
                        color: 'inherit',
                        fontWeight: 'inherit',
                        verticalAlign: 'top',
                        '&:not(:first-child)': {
                            marginInlineStart: paddingXS
                        },
                        '&:hover': {
                            color: colorPrimary
                        }
                    }
                }
            },
            // Arrow button
            [`&-prev-icon,
        &-next-icon,
        &-super-prev-icon,
        &-super-next-icon`]: {
                position: 'relative',
                width: pickerControlIconSize,
                height: pickerControlIconSize,
                '&::before': {
                    position: 'absolute',
                    top: 0,
                    insetInlineStart: 0,
                    width: pickerControlIconSize,
                    height: pickerControlIconSize,
                    border: `0 solid currentcolor`,
                    borderBlockStartWidth: pickerControlIconBorderWidth,
                    borderInlineStartWidth: pickerControlIconBorderWidth,
                    content: '""'
                }
            },
            [`&-super-prev-icon,
        &-super-next-icon`]: {
                '&::after': {
                    position: 'absolute',
                    top: pickerControlIconMargin,
                    insetInlineStart: pickerControlIconMargin,
                    display: 'inline-block',
                    width: pickerControlIconSize,
                    height: pickerControlIconSize,
                    border: '0 solid currentcolor',
                    borderBlockStartWidth: pickerControlIconBorderWidth,
                    borderInlineStartWidth: pickerControlIconBorderWidth,
                    content: '""'
                }
            },
            '&-prev-icon, &-super-prev-icon': {
                transform: 'rotate(-45deg)'
            },
            '&-next-icon, &-super-next-icon': {
                transform: 'rotate(135deg)'
            },
            // ======================== Body ========================
            '&-content': {
                width: '100%',
                tableLayout: 'fixed',
                borderCollapse: 'collapse',
                'th, td': {
                    position: 'relative',
                    minWidth: cellHeight,
                    fontWeight: 'normal'
                },
                th: {
                    height: token.calc(cellHeight).add(token.calc(pickerCellPaddingVertical).mul(2)).equal(),
                    color: colorText,
                    verticalAlign: 'middle'
                }
            },
            '&-cell': {
                padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(pickerCellPaddingVertical)} 0`,
                color: colorTextDisabled,
                cursor: 'pointer',
                // In view
                '&-in-view': {
                    color: colorText
                },
                ...$234da4737d7b5ae8$var$genPickerCellInnerStyle(token)
            },
            [`&-decade-panel,
        &-year-panel,
        &-quarter-panel,
        &-month-panel`]: {
                [`${componentCls}-content`]: {
                    height: token.calc(withoutTimeCellHeight).mul(4).equal()
                },
                [pickerCellInnerCls]: {
                    padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)}`
                }
            },
            '&-quarter-panel': {
                [`${componentCls}-content`]: {
                    height: pickerQuarterPanelContentHeight
                }
            },
            // ========================================================
            // =                       Special                        =
            // ========================================================
            // ===================== Decade Panel =====================
            '&-decade-panel': {
                [pickerCellInnerCls]: {
                    padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(paddingXS).div(2).equal())}`
                },
                [`${componentCls}-cell::before`]: {
                    display: 'none'
                }
            },
            // ============= Year & Quarter & Month Panel =============
            [`&-year-panel,
        &-quarter-panel,
        &-month-panel`]: {
                [`${componentCls}-body`]: {
                    padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)}`
                },
                [pickerCellInnerCls]: {
                    width: pickerYearMonthCellWidth
                }
            },
            // ====================== Date Panel ======================
            '&-date-panel': {
                [`${componentCls}-body`]: {
                    padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(pickerDatePanelPaddingHorizontal)}`
                },
                [`${componentCls}-content th`]: {
                    boxSizing: 'border-box',
                    padding: 0
                }
            },
            // ====================== Week Panel ======================
            '&-week-panel-row': {
                td: {
                    '&:before': {
                        transition: `background ${motionDurationMid}`
                    },
                    '&:first-child:before': {
                        borderStartStartRadius: borderRadiusSM,
                        borderEndStartRadius: borderRadiusSM
                    },
                    '&:last-child:before': {
                        borderStartEndRadius: borderRadiusSM,
                        borderEndEndRadius: borderRadiusSM
                    }
                },
                '&:hover td:before': {
                    background: cellHoverBg
                },
                '&-range-start td, &-range-end td, &-selected td, &-hover td': {
                    // Rise priority to override hover style
                    [`&${pickerCellCls}`]: {
                        '&:before': {
                            background: colorPrimary
                        },
                        [`&${componentCls}-cell-week`]: {
                            color: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(colorTextLightSolid).setA(0.5).toHexString()
                        },
                        [pickerCellInnerCls]: {
                            color: colorTextLightSolid
                        }
                    }
                },
                '&-range-hover td:before': {
                    background: controlItemBgActive
                }
            },
            // >>> ShowWeek
            '&-week-panel, &-date-panel-show-week': {
                [`${componentCls}-body`]: {
                    padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingSM)}`
                },
                [`${componentCls}-content th`]: {
                    width: 'auto'
                }
            },
            // ==================== Datetime Panel ====================
            '&-datetime-panel': {
                display: 'flex',
                [`${componentCls}-time-panel`]: {
                    borderInlineStart: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`
                },
                [`${componentCls}-date-panel,
          ${componentCls}-time-panel`]: {
                    transition: `opacity ${motionDurationSlow}`
                },
                // Keyboard
                '&-active': {
                    [`${componentCls}-date-panel,
            ${componentCls}-time-panel`]: {
                        opacity: 0.3,
                        '&-active': {
                            opacity: 1
                        }
                    }
                }
            },
            // ====================== Time Panel ======================
            '&-time-panel': {
                width: 'auto',
                minWidth: 'auto',
                [`${componentCls}-content`]: {
                    display: 'flex',
                    flex: 'auto',
                    height: timeColumnHeight
                },
                '&-column': {
                    flex: '1 0 auto',
                    width: timeColumnWidth,
                    margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXXS)} 0`,
                    padding: 0,
                    overflowY: 'hidden',
                    textAlign: 'start',
                    listStyle: 'none',
                    transition: `background ${motionDurationMid}`,
                    overflowX: 'hidden',
                    '&::-webkit-scrollbar': {
                        width: 8,
                        backgroundColor: 'transparent'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: token.colorTextTertiary,
                        borderRadius: token.borderRadiusSM
                    },
                    // For Firefox
                    '&': {
                        scrollbarWidth: 'thin',
                        scrollbarColor: `${token.colorTextTertiary} transparent`
                    },
                    '&::after': {
                        display: 'block',
                        height: `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(timeCellHeight)})`,
                        content: '""'
                    },
                    '&:not(:first-child)': {
                        borderInlineStart: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`
                    },
                    '&-active': {
                        background: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(controlItemBgActive).setA(0.2).toHexString()
                    },
                    '&:hover': {
                        overflowY: 'auto'
                    },
                    '> li': {
                        margin: 0,
                        padding: 0,
                        [`&${componentCls}-time-panel-cell`]: {
                            marginInline: marginXXS,
                            [`${componentCls}-time-panel-cell-inner`]: {
                                display: 'block',
                                width: token.calc(timeColumnWidth).sub(token.calc(marginXXS).mul(2)).equal(),
                                height: timeCellHeight,
                                margin: 0,
                                paddingBlock: 0,
                                paddingInlineEnd: 0,
                                paddingInlineStart: token.calc(timeColumnWidth).sub(timeCellHeight).div(2).equal(),
                                color: colorText,
                                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(timeCellHeight),
                                borderRadius: borderRadiusSM,
                                cursor: 'pointer',
                                transition: `background ${motionDurationMid}`,
                                '&:hover': {
                                    background: cellHoverBg
                                }
                            },
                            '&-selected': {
                                [`${componentCls}-time-panel-cell-inner`]: {
                                    background: controlItemBgActive
                                }
                            },
                            '&-disabled': {
                                [`${componentCls}-time-panel-cell-inner`]: {
                                    color: colorTextDisabled,
                                    background: 'transparent',
                                    cursor: 'not-allowed'
                                }
                            }
                        }
                    }
                }
            }
        }
    };
};
const $234da4737d7b5ae8$var$genPickerPanelStyle = (token)=>{
    const { componentCls: componentCls, textHeight: textHeight, lineWidth: lineWidth, paddingSM: paddingSM, antCls: antCls, colorPrimary: colorPrimary, cellActiveWithRangeBg: cellActiveWithRangeBg, colorPrimaryBorder: colorPrimaryBorder, lineType: lineType, colorSplit: colorSplit } = token;
    return {
        [`${componentCls}-dropdown`]: {
            // ======================== Footer ========================
            [`${componentCls}-footer`]: {
                borderTop: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
                '&-extra': {
                    padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingSM)}`,
                    lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(textHeight).sub(token.calc(lineWidth).mul(2)).equal()),
                    textAlign: 'start',
                    '&:not(:last-child)': {
                        borderBottom: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`
                    }
                }
            },
            // ==================== Footer > Ranges ===================
            [`${componentCls}-panels + ${componentCls}-footer ${componentCls}-ranges`]: {
                justifyContent: 'space-between'
            },
            [`${componentCls}-ranges`]: {
                marginBlock: 0,
                paddingInline: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingSM),
                overflow: 'hidden',
                textAlign: 'start',
                listStyle: 'none',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                '> li': {
                    lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(textHeight).sub(token.calc(lineWidth).mul(2)).equal()),
                    display: 'inline-block'
                },
                [`${componentCls}-now-btn-disabled`]: {
                    pointerEvents: 'none',
                    color: token.colorTextDisabled
                },
                // https://github.com/ant-design/ant-design/issues/23687
                [`${componentCls}-preset > ${antCls}-tag-blue`]: {
                    color: colorPrimary,
                    background: cellActiveWithRangeBg,
                    borderColor: colorPrimaryBorder,
                    cursor: 'pointer'
                },
                [`${componentCls}-ok`]: {
                    paddingBlock: token.calc(lineWidth).mul(2).equal(),
                    marginInlineStart: 'auto'
                }
            }
        }
    };
};
var $234da4737d7b5ae8$export$2e2bcd8739ae039 = $234da4737d7b5ae8$var$genPickerPanelStyle;





const $b19cd162546770e1$export$5f48700d53e3ff1 = (token)=>{
    const { componentCls: componentCls, controlHeightLG: controlHeightLG, paddingXXS: paddingXXS, padding: padding } = token;
    return {
        pickerCellCls: `${componentCls}-cell`,
        pickerCellInnerCls: `${componentCls}-cell-inner`,
        pickerYearMonthCellWidth: token.calc(controlHeightLG).mul(1.5).equal(),
        pickerQuarterPanelContentHeight: token.calc(controlHeightLG).mul(1.4).equal(),
        pickerCellPaddingVertical: token.calc(paddingXXS).add(token.calc(paddingXXS).div(2)).equal(),
        pickerCellBorderGap: 2,
        // Magic for gap between cells
        pickerControlIconSize: 7,
        pickerControlIconMargin: 4,
        pickerControlIconBorderWidth: 1.5,
        pickerDatePanelPaddingHorizontal: token.calc(padding).add(token.calc(paddingXXS).div(2)).equal() // 18 in normal
    };
};
const $b19cd162546770e1$export$e39429f333f3edb3 = (token)=>{
    const { colorBgContainerDisabled: colorBgContainerDisabled, controlHeight: controlHeight, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, paddingXXS: paddingXXS, lineWidth: lineWidth } = token;
    // Item height default use `controlHeight - 2 * paddingXXS`,
    // but some case `paddingXXS=0`.
    // Let's fallback it.
    const dblPaddingXXS = paddingXXS * 2;
    const dblLineWidth = lineWidth * 2;
    const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
    const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
    const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
    // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
    const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
    const filledToken = {
        INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN,
        cellHoverBg: token.controlItemBgHover,
        cellActiveWithRangeBg: token.controlItemBgActive,
        cellHoverWithRangeBg: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(token.colorPrimary).lighten(35).toHexString(),
        cellRangeBorderColor: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(token.colorPrimary).lighten(20).toHexString(),
        cellBgDisabled: colorBgContainerDisabled,
        timeColumnWidth: controlHeightLG * 1.4,
        timeColumnHeight: 224,
        timeCellHeight: 28,
        cellWidth: controlHeightSM * 1.5,
        cellHeight: controlHeightSM,
        textHeight: controlHeightLG,
        withoutTimeCellHeight: controlHeightLG * 1.65,
        multipleItemBg: token.colorFillSecondary,
        multipleItemBorderColor: 'transparent',
        multipleItemHeight: multipleItemHeight,
        multipleItemHeightSM: multipleItemHeightSM,
        multipleItemHeightLG: multipleItemHeightLG,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: token.colorTextDisabled,
        multipleItemBorderColorDisabled: 'transparent'
    };
    return filledToken;
};
const $b19cd162546770e1$export$9ca1be8807fe0675 = (token)=>({
        ...(0, $84cc1914d3f028b8$export$bd8b682992bc9781)(token),
        ...$b19cd162546770e1$export$e39429f333f3edb3(token),
        ...(0, $bf6e216ed4fab7a5$export$87e38ee403661ccc)(token),
        presetsWidth: 120,
        presetsMaxWidth: 200,
        zIndexPopup: token.zIndexPopupBase + 50
    });




const $e598ad3c04ab7017$var$genVariantsStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: [
            {
                ...(0, $2e2c91ed88c5ebaa$export$53795bafd774ce02)(token),
                ...(0, $2e2c91ed88c5ebaa$export$34771e60e0439351)(token),
                ...(0, $2e2c91ed88c5ebaa$export$b8365cd7e6671d79)(token),
                ...(0, $2e2c91ed88c5ebaa$export$b6de5da7f39edfcb)(token)
            },
            // ========================= Multiple =========================
            {
                '&-outlined': {
                    [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
                        background: token.multipleItemBg,
                        border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
                    }
                },
                '&-filled': {
                    [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
                        background: token.colorBgContainer,
                        border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
                    }
                },
                '&-borderless': {
                    [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
                        background: token.multipleItemBg,
                        border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
                    }
                },
                '&-underlined': {
                    [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
                        background: token.multipleItemBg,
                        border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
                    }
                }
            }
        ]
    };
};
var $e598ad3c04ab7017$export$2e2bcd8739ae039 = $e598ad3c04ab7017$var$genVariantsStyle;


const $4d618cd3d6169a20$var$genPickerPadding = (paddingBlock, paddingInline)=>{
    return {
        padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingBlock)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingInline)}`
    };
};
const $4d618cd3d6169a20$var$genPickerStatusStyle = (token)=>{
    const { componentCls: componentCls, colorError: colorError, colorWarning: colorWarning } = token;
    return {
        [`${componentCls}:not(${componentCls}-disabled):not([disabled])`]: {
            [`&${componentCls}-status-error`]: {
                [`${componentCls}-active-bar`]: {
                    background: colorError
                }
            },
            [`&${componentCls}-status-warning`]: {
                [`${componentCls}-active-bar`]: {
                    background: colorWarning
                }
            }
        }
    };
};
const $4d618cd3d6169a20$var$genPickerStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, paddingInline: paddingInline, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, borderRadius: borderRadius, motionDurationMid: motionDurationMid, colorTextDisabled: colorTextDisabled, colorTextPlaceholder: colorTextPlaceholder, colorTextQuaternary: colorTextQuaternary, fontSizeLG: fontSizeLG, inputFontSizeLG: inputFontSizeLG, fontSizeSM: fontSizeSM, inputFontSizeSM: inputFontSizeSM, controlHeightSM: controlHeightSM, paddingInlineSM: paddingInlineSM, paddingXS: paddingXS, marginXS: marginXS, colorIcon: colorIcon, lineWidthBold: lineWidthBold, colorPrimary: colorPrimary, motionDurationSlow: motionDurationSlow, zIndexPopup: zIndexPopup, paddingXXS: paddingXXS, sizePopupArrow: sizePopupArrow, colorBgElevated: colorBgElevated, borderRadiusLG: borderRadiusLG, boxShadowSecondary: boxShadowSecondary, borderRadiusSM: borderRadiusSM, colorSplit: colorSplit, cellHoverBg: cellHoverBg, presetsWidth: presetsWidth, presetsMaxWidth: presetsMaxWidth, boxShadowPopoverArrow: boxShadowPopoverArrow, fontHeight: fontHeight, lineHeightLG: lineHeightLG } = token;
    return [
        {
            [componentCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                ...$4d618cd3d6169a20$var$genPickerPadding(token.paddingBlock, token.paddingInline),
                position: 'relative',
                display: 'inline-flex',
                alignItems: 'center',
                lineHeight: 1,
                borderRadius: borderRadius,
                transition: `border ${motionDurationMid}, box-shadow ${motionDurationMid}, background ${motionDurationMid}`,
                [`${componentCls}-prefix`]: {
                    flex: '0 0 auto',
                    marginInlineEnd: token.inputAffixPadding
                },
                // ======================== Input =========================
                [`${componentCls}-input`]: {
                    position: 'relative',
                    display: 'inline-flex',
                    alignItems: 'center',
                    width: '100%',
                    '> input': {
                        position: 'relative',
                        display: 'inline-block',
                        width: '100%',
                        color: 'inherit',
                        fontSize: token.inputFontSize ?? token.fontSize,
                        lineHeight: token.lineHeight,
                        transition: `all ${motionDurationMid}`,
                        ...(0, $ec12a8e9ea12e1d5$export$92095d0f4c77bd56)(colorTextPlaceholder),
                        flex: 'auto',
                        // Fix Firefox flex not correct:
                        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
                        minWidth: 1,
                        height: 'auto',
                        padding: 0,
                        background: 'transparent',
                        border: 0,
                        fontFamily: 'inherit',
                        '&:focus': {
                            boxShadow: 'none',
                            outline: 0
                        },
                        '&[disabled]': {
                            background: 'transparent',
                            color: colorTextDisabled,
                            cursor: 'not-allowed'
                        }
                    },
                    '&-placeholder': {
                        '> input': {
                            color: colorTextPlaceholder
                        }
                    }
                },
                // Size
                '&-large': {
                    ...$4d618cd3d6169a20$var$genPickerPadding(token.paddingBlockLG, token.paddingInlineLG),
                    [`${componentCls}-input > input`]: {
                        fontSize: inputFontSizeLG ?? fontSizeLG,
                        lineHeight: lineHeightLG
                    }
                },
                '&-small': {
                    ...$4d618cd3d6169a20$var$genPickerPadding(token.paddingBlockSM, token.paddingInlineSM),
                    [`${componentCls}-input > input`]: {
                        fontSize: inputFontSizeSM ?? fontSizeSM
                    }
                },
                [`${componentCls}-suffix`]: {
                    display: 'flex',
                    flex: 'none',
                    alignSelf: 'center',
                    marginInlineStart: token.calc(paddingXS).div(2).equal(),
                    color: colorTextQuaternary,
                    lineHeight: 1,
                    pointerEvents: 'none',
                    transition: `opacity ${motionDurationMid}, color ${motionDurationMid}`,
                    '> *': {
                        verticalAlign: 'top',
                        '&:not(:last-child)': {
                            marginInlineEnd: marginXS
                        }
                    }
                },
                [`${componentCls}-clear`]: {
                    position: 'absolute',
                    top: '50%',
                    insetInlineEnd: 0,
                    color: colorTextQuaternary,
                    lineHeight: 1,
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    opacity: 0,
                    transition: `opacity ${motionDurationMid}, color ${motionDurationMid}`,
                    '> *': {
                        verticalAlign: 'top'
                    },
                    '&:hover': {
                        color: colorIcon
                    }
                },
                '&:hover': {
                    [`${componentCls}-clear`]: {
                        opacity: 1
                    },
                    // Should use the following selector, but since `:has` has poor compatibility,
                    // we use `:not(:last-child)` instead, which may cause some problems in some cases.
                    // [`${componentCls}-suffix:has(+ ${componentCls}-clear)`]: {
                    [`${componentCls}-suffix:not(:last-child)`]: {
                        opacity: 0
                    }
                },
                [`${componentCls}-separator`]: {
                    position: 'relative',
                    display: 'inline-block',
                    width: '1em',
                    height: fontSizeLG,
                    color: colorTextQuaternary,
                    fontSize: fontSizeLG,
                    verticalAlign: 'top',
                    cursor: 'default',
                    [`${componentCls}-focused &`]: {
                        color: colorIcon
                    },
                    [`${componentCls}-range-separator &`]: {
                        [`${componentCls}-disabled &`]: {
                            cursor: 'not-allowed'
                        }
                    }
                },
                // ======================== Range =========================
                '&-range': {
                    position: 'relative',
                    display: 'inline-flex',
                    // Active bar
                    [`${componentCls}-active-bar`]: {
                        bottom: token.calc(lineWidth).mul(-1).equal(),
                        height: lineWidthBold,
                        background: colorPrimary,
                        opacity: 0,
                        transition: `all ${motionDurationSlow} ease-out`,
                        pointerEvents: 'none'
                    },
                    [`&${componentCls}-focused`]: {
                        [`${componentCls}-active-bar`]: {
                            opacity: 1
                        }
                    },
                    [`${componentCls}-range-separator`]: {
                        alignItems: 'center',
                        padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)}`,
                        lineHeight: 1
                    }
                },
                // ======================== Clear =========================
                '&-range, &-multiple': {
                    // Clear
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: paddingInline
                    },
                    [`&${componentCls}-small`]: {
                        [`${componentCls}-clear`]: {
                            insetInlineEnd: paddingInlineSM
                        }
                    }
                },
                // ======================= Dropdown =======================
                '&-dropdown': {
                    ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                    ...(0, $234da4737d7b5ae8$export$da5309fdba1a1b64)(token),
                    pointerEvents: 'none',
                    position: 'absolute',
                    // Fix incorrect position of picker popup
                    // https://github.com/ant-design/ant-design/issues/35590
                    top: -9999,
                    left: {
                        _skip_check_: true,
                        value: -9999
                    },
                    zIndex: zIndexPopup,
                    [`&${componentCls}-dropdown-hidden`]: {
                        display: 'none'
                    },
                    '&-rtl': {
                        direction: 'rtl'
                    },
                    [`&${componentCls}-dropdown-placement-bottomLeft,
            &${componentCls}-dropdown-placement-bottomRight`]: {
                        [`${componentCls}-range-arrow`]: {
                            top: 0,
                            display: 'block',
                            transform: 'translateY(-100%)'
                        }
                    },
                    [`&${componentCls}-dropdown-placement-topLeft,
            &${componentCls}-dropdown-placement-topRight`]: {
                        [`${componentCls}-range-arrow`]: {
                            bottom: 0,
                            display: 'block',
                            transform: 'translateY(100%) rotate(180deg)'
                        }
                    },
                    [`&${antCls}-slide-up-appear, &${antCls}-slide-up-enter`]: {
                        [`${componentCls}-range-arrow${componentCls}-range-arrow`]: {
                            transition: 'none'
                        }
                    },
                    [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topRight`]: {
                        animationName: (0, $e613b8e902d5a10c$export$dd9f089fa5e819fe)
                    },
                    [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-bottomRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-bottomRight`]: {
                        animationName: (0, $e613b8e902d5a10c$export$e801b802b037de6a)
                    },
                    // https://github.com/ant-design/ant-design/issues/48727
                    [`&${antCls}-slide-up-leave ${componentCls}-panel-container`]: {
                        pointerEvents: 'none'
                    },
                    [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topRight`]: {
                        animationName: (0, $e613b8e902d5a10c$export$f7243fdb9c27c3b7)
                    },
                    [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-bottomRight`]: {
                        animationName: (0, $e613b8e902d5a10c$export$f40f41df328ebc38)
                    },
                    // Time picker with additional style
                    [`${componentCls}-panel > ${componentCls}-time-panel`]: {
                        paddingTop: paddingXXS
                    },
                    // ======================== Ranges ========================
                    [`${componentCls}-range-wrapper`]: {
                        display: 'flex',
                        position: 'relative'
                    },
                    [`${componentCls}-range-arrow`]: {
                        position: 'absolute',
                        zIndex: 1,
                        display: 'none',
                        paddingInline: token.calc(paddingInline).mul(1.5).equal(),
                        boxSizing: 'content-box',
                        transition: `all ${motionDurationSlow} ease-out`,
                        ...(0, $bf6e216ed4fab7a5$export$601fa0375eb80eec)(token, colorBgElevated, boxShadowPopoverArrow),
                        '&:before': {
                            insetInlineStart: token.calc(paddingInline).mul(1.5).equal()
                        }
                    },
                    [`${componentCls}-panel-container`]: {
                        overflow: 'hidden',
                        verticalAlign: 'top',
                        background: colorBgElevated,
                        borderRadius: borderRadiusLG,
                        boxShadow: boxShadowSecondary,
                        transition: `margin ${motionDurationSlow}`,
                        display: 'inline-block',
                        pointerEvents: 'auto',
                        // ======================== Layout ========================
                        [`${componentCls}-panel-layout`]: {
                            display: 'flex',
                            flexWrap: 'nowrap',
                            alignItems: 'stretch'
                        },
                        // ======================== Preset ========================
                        [`${componentCls}-presets`]: {
                            display: 'flex',
                            flexDirection: 'column',
                            minWidth: presetsWidth,
                            maxWidth: presetsMaxWidth,
                            ul: {
                                height: 0,
                                flex: 'auto',
                                listStyle: 'none',
                                overflow: 'auto',
                                margin: 0,
                                padding: paddingXS,
                                borderInlineEnd: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
                                li: {
                                    ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
                                    borderRadius: borderRadiusSM,
                                    paddingInline: paddingXS,
                                    paddingBlock: token.calc(controlHeightSM).sub(fontHeight).div(2).equal(),
                                    cursor: 'pointer',
                                    transition: `all ${motionDurationSlow}`,
                                    '+ li': {
                                        marginTop: marginXS
                                    },
                                    '&:hover': {
                                        background: cellHoverBg
                                    }
                                }
                            }
                        },
                        // ======================== Panels ========================
                        [`${componentCls}-panels`]: {
                            display: 'inline-flex',
                            flexWrap: 'nowrap',
                            // [`${componentCls}-panel`]: {
                            //   borderWidth: `0 0 ${unit(lineWidth)}`,
                            // },
                            '&:last-child': {
                                [`${componentCls}-panel`]: {
                                    borderWidth: 0
                                }
                            }
                        },
                        [`${componentCls}-panel`]: {
                            verticalAlign: 'top',
                            background: 'transparent',
                            borderRadius: 0,
                            borderWidth: 0,
                            [`${componentCls}-content, table`]: {
                                textAlign: 'center'
                            },
                            '&-focused': {
                                borderColor: colorBorder
                            }
                        }
                    }
                },
                '&-dropdown-range': {
                    padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(sizePopupArrow).mul(2).div(3).equal())} 0`,
                    '&-hidden': {
                        display: 'none'
                    }
                },
                '&-rtl': {
                    direction: 'rtl',
                    [`${componentCls}-separator`]: {
                        transform: 'scale(-1, 1)'
                    },
                    [`${componentCls}-footer`]: {
                        '&-extra': {
                            direction: 'rtl'
                        }
                    }
                }
            }
        },
        // Follow code may reuse in other components
        (0, $e613b8e902d5a10c$export$9018e60daecf7a6c)(token, 'slide-up'),
        (0, $e613b8e902d5a10c$export$9018e60daecf7a6c)(token, 'slide-down'),
        (0, $96f7793622fd94de$export$913b1b7e3288c319)(token, 'move-up'),
        (0, $96f7793622fd94de$export$913b1b7e3288c319)(token, 'move-down')
    ];
};
var // ============================== Export ==============================
$4d618cd3d6169a20$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('DatePicker', (token)=>{
    const pickerToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)((0, $84cc1914d3f028b8$export$a157d95850191a12)(token), (0, $b19cd162546770e1$export$5f48700d53e3ff1)(token), {
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(1).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        (0, $234da4737d7b5ae8$export$2e2bcd8739ae039)(pickerToken),
        $4d618cd3d6169a20$var$genPickerStyle(pickerToken),
        (0, $e598ad3c04ab7017$export$2e2bcd8739ae039)(pickerToken),
        $4d618cd3d6169a20$var$genPickerStatusStyle(pickerToken),
        (0, $32b5bc56ebd14fbd$export$2e2bcd8739ae039)(pickerToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $f96147db005a8a82$export$b1208b23589b4b73)(token, {
            focusElCls: `${token.componentCls}-focused`
        })
    ];
}, (0, $b19cd162546770e1$export$9ca1be8807fe0675));




const $275c9b6a270d31d5$export$790bf6b82163cd8e = (token)=>{
    const { calendarCls: calendarCls, componentCls: componentCls, fullBg: fullBg, fullPanelBg: fullPanelBg, itemActiveBg: itemActiveBg } = token;
    return {
        [calendarCls]: {
            ...(0, $234da4737d7b5ae8$export$da5309fdba1a1b64)(token),
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            background: fullBg,
            '&-rtl': {
                direction: 'rtl'
            },
            [`${calendarCls}-header`]: {
                display: 'flex',
                justifyContent: 'flex-end',
                padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingSM)} 0`,
                [`${calendarCls}-year-select`]: {
                    minWidth: token.yearControlWidth
                },
                [`${calendarCls}-month-select`]: {
                    minWidth: token.monthControlWidth,
                    marginInlineStart: token.marginXS
                },
                [`${calendarCls}-mode-switch`]: {
                    marginInlineStart: token.marginXS
                }
            }
        },
        [`${calendarCls} ${componentCls}-panel`]: {
            background: fullPanelBg,
            border: 0,
            borderTop: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
            borderRadius: 0,
            [`${componentCls}-month-panel, ${componentCls}-date-panel`]: {
                width: 'auto'
            },
            [`${componentCls}-body`]: {
                padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingXS)} 0`
            },
            [`${componentCls}-content`]: {
                width: '100%'
            }
        },
        [`${calendarCls}-mini`]: {
            borderRadius: token.borderRadiusLG,
            [`${calendarCls}-header`]: {
                paddingInlineEnd: token.paddingXS,
                paddingInlineStart: token.paddingXS
            },
            [`${componentCls}-panel`]: {
                borderRadius: `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.borderRadiusLG)}`
            },
            [`${componentCls}-content`]: {
                height: token.miniContentHeight,
                th: {
                    height: 'auto',
                    padding: 0,
                    lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.weekHeight)
                }
            },
            [`${componentCls}-cell::before`]: {
                pointerEvents: 'none'
            }
        },
        [`${calendarCls}${calendarCls}-full`]: {
            [`${componentCls}-panel`]: {
                display: 'block',
                width: '100%',
                textAlign: 'end',
                background: fullBg,
                border: 0,
                [`${componentCls}-body`]: {
                    'th, td': {
                        padding: 0
                    },
                    th: {
                        height: 'auto',
                        paddingInlineEnd: token.paddingSM,
                        paddingBottom: token.paddingXXS,
                        lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.weekHeight)
                    }
                }
            },
            [`${componentCls}-cell-week ${componentCls}-cell-inner`]: {
                display: 'block',
                borderRadius: 0,
                borderTop: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidthBold)} ${token.lineType} ${token.colorSplit}`,
                width: '100%',
                height: token.calc(token.dateValueHeight).add(token.dateContentHeight).add(token.calc(token.paddingXS).div(2)).add(token.lineWidthBold).equal()
            },
            [`${componentCls}-cell`]: {
                '&::before': {
                    display: 'none'
                },
                '&:hover': {
                    [`${calendarCls}-date`]: {
                        background: token.controlItemBgHover
                    }
                },
                [`${calendarCls}-date-today::before`]: {
                    display: 'none'
                },
                // >>> Selected
                [`&-in-view${componentCls}-cell-selected`]: {
                    [`${calendarCls}-date, ${calendarCls}-date-today`]: {
                        background: itemActiveBg
                    }
                },
                '&-selected, &-selected:hover': {
                    [`${calendarCls}-date, ${calendarCls}-date-today`]: {
                        [`${calendarCls}-date-value`]: {
                            color: token.colorPrimary
                        }
                    }
                }
            },
            [`${calendarCls}-date`]: {
                display: 'block',
                width: 'auto',
                height: 'auto',
                margin: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(token.marginXS).div(2).equal())}`,
                padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(token.paddingXS).div(2).equal())} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingXS)} 0`,
                border: 0,
                borderTop: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidthBold)} ${token.lineType} ${token.colorSplit}`,
                borderRadius: 0,
                transition: `background ${token.motionDurationSlow}`,
                '&-value': {
                    lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.dateValueHeight),
                    transition: `color ${token.motionDurationSlow}`
                },
                '&-content': {
                    position: 'static',
                    width: 'auto',
                    height: token.dateContentHeight,
                    overflowY: 'auto',
                    color: token.colorText,
                    lineHeight: token.lineHeight,
                    textAlign: 'start'
                },
                '&-today': {
                    borderColor: token.colorPrimary,
                    [`${calendarCls}-date-value`]: {
                        color: token.colorText
                    }
                }
            }
        },
        [`@media only screen and (max-width: ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.screenXS)}) `]: {
            [calendarCls]: {
                [`${calendarCls}-header`]: {
                    display: 'block',
                    [`${calendarCls}-year-select`]: {
                        width: '50%'
                    },
                    [`${calendarCls}-month-select`]: {
                        width: `calc(50% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingXS)})`
                    },
                    [`${calendarCls}-mode-switch`]: {
                        width: '100%',
                        marginTop: token.marginXS,
                        marginInlineStart: 0,
                        '> label': {
                            width: '50%',
                            textAlign: 'center'
                        }
                    }
                }
            }
        }
    };
};
const $275c9b6a270d31d5$export$9ca1be8807fe0675 = (token)=>({
        fullBg: token.colorBgContainer,
        fullPanelBg: token.colorBgContainer,
        itemActiveBg: token.controlItemBgActive,
        yearControlWidth: 80,
        monthControlWidth: 70,
        miniContentHeight: 256,
        ...(0, $b19cd162546770e1$export$e39429f333f3edb3)(token)
    });
var $275c9b6a270d31d5$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Calendar', (token)=>{
    const calendarCls = `${token.componentCls}-calendar`;
    const calendarToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, (0, $b19cd162546770e1$export$5f48700d53e3ff1)(token), {
        calendarCls: calendarCls,
        pickerCellInnerCls: `${token.componentCls}-cell-inner`,
        dateValueHeight: token.controlHeightSM,
        weekHeight: token.calc(token.controlHeightSM).mul(0.75).equal(),
        dateContentHeight: token.calc(token.calc(token.fontHeightSM).add(token.marginXS)).mul(3).add(token.calc(token.lineWidth).mul(2)).equal()
    });
    return $275c9b6a270d31d5$export$790bf6b82163cd8e(calendarToken);
}, $275c9b6a270d31d5$export$9ca1be8807fe0675);


"use client";
const $eba16865a575da7a$var$isSameYear = (date1, date2, config)=>{
    const { getYear: getYear } = config;
    return date1 && date2 && getYear(date1) === getYear(date2);
};
const $eba16865a575da7a$var$isSameMonth = (date1, date2, config)=>{
    const { getMonth: getMonth } = config;
    return $eba16865a575da7a$var$isSameYear(date1, date2, config) && getMonth(date1) === getMonth(date2);
};
const $eba16865a575da7a$var$isSameDate = (date1, date2, config)=>{
    const { getDate: getDate } = config;
    return $eba16865a575da7a$var$isSameMonth(date1, date2, config) && getDate(date1) === getDate(date2);
};
const $eba16865a575da7a$var$generateCalendar = (generateConfig)=>{
    const Calendar = (props)=>{
        const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, dateFullCellRender: dateFullCellRender, dateCellRender: dateCellRender, monthFullCellRender: monthFullCellRender, monthCellRender: monthCellRender, cellRender: cellRender, fullCellRender: fullCellRender, headerRender: headerRender, value: value, defaultValue: defaultValue, disabledDate: disabledDate, mode: mode, validRange: validRange, fullscreen: fullscreen = true, showWeek: showWeek, onChange: onChange, onPanelChange: onPanelChange, onSelect: onSelect, styles: styles, classNames: classNames } = props;
        const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('calendar');
        // =========== Merged Props for Semantic ===========
        const mergedProps = {
            ...props,
            mode: mode,
            fullscreen: fullscreen,
            showWeek: showWeek
        };
        const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
            contextClassNames,
            classNames
        ], [
            contextStyles,
            styles
        ], {
            props: mergedProps
        });
        const [rootCls, headerCls, panelClassNames, rootStyle, headerStyle, panelStyles] = $ltGt3.useMemo(()=>{
            const { root: nextRootClassName, header: nextHeaderClassName, ...nextPanelClassNames } = mergedClassNames;
            const { root: nextRootStyle, header: nextHeaderStyle, ...nextPanelStyles } = mergedStyles;
            return [
                nextRootClassName,
                nextHeaderClassName,
                nextPanelClassNames,
                nextRootStyle,
                nextHeaderStyle,
                nextPanelStyles
            ];
        }, [
            mergedClassNames,
            mergedStyles
        ]);
        const prefixCls = getPrefixCls('picker', customizePrefixCls);
        const calendarPrefixCls = `${prefixCls}-calendar`;
        const [hashId, cssVarCls] = (0, $275c9b6a270d31d5$export$2e2bcd8739ae039)(prefixCls, calendarPrefixCls);
        const today = generateConfig.getNow();
        var deprecatedName, newName;
        // ====================== State =======================
        // Value
        const [mergedValue, setMergedValue] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(()=>defaultValue || generateConfig.getNow(), value);
        // Mode
        const [mergedMode, setMergedMode] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)('month', mode);
        const panelMode = $ltGt3.useMemo(()=>mergedMode === 'year' ? 'month' : 'date', [
            mergedMode
        ]);
        // Disabled Date
        const mergedDisabledDate = $ltGt3.useCallback((date)=>{
            const notInRange = validRange ? generateConfig.isAfter(validRange[0], date) || generateConfig.isAfter(date, validRange[1]) : false;
            return notInRange || !!disabledDate?.(date);
        }, [
            disabledDate,
            validRange
        ]);
        // ====================== Events ======================
        const triggerPanelChange = (date, newMode)=>{
            onPanelChange?.(date, newMode);
        };
        const triggerChange = (date)=>{
            setMergedValue(date);
            if (!$eba16865a575da7a$var$isSameDate(date, mergedValue, generateConfig)) {
                // Trigger when month panel switch month
                if (panelMode === 'date' && !$eba16865a575da7a$var$isSameMonth(date, mergedValue, generateConfig) || panelMode === 'month' && !$eba16865a575da7a$var$isSameYear(date, mergedValue, generateConfig)) triggerPanelChange(date, mergedMode);
                onChange?.(date);
            }
        };
        const triggerModeChange = (newMode)=>{
            setMergedMode(newMode);
            triggerPanelChange(mergedValue, newMode);
        };
        const onInternalSelect = (date, source)=>{
            triggerChange(date);
            onSelect?.(date, {
                source: source
            });
        };
        // ====================== Render ======================
        const dateRender = $ltGt3.useCallback((date, info)=>{
            if (fullCellRender) return fullCellRender(date, info);
            if (dateFullCellRender) return dateFullCellRender(date);
            return /*#__PURE__*/ $ltGt3.createElement("div", {
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-cell-inner`, `${calendarPrefixCls}-date`, {
                    [`${calendarPrefixCls}-date-today`]: $eba16865a575da7a$var$isSameDate(today, date, generateConfig)
                })
            }, /*#__PURE__*/ $ltGt3.createElement("div", {
                className: `${calendarPrefixCls}-date-value`
            }, String(generateConfig.getDate(date)).padStart(2, '0')), /*#__PURE__*/ $ltGt3.createElement("div", {
                className: `${calendarPrefixCls}-date-content`
            }, typeof cellRender === 'function' ? cellRender(date, info) : dateCellRender?.(date)));
        }, [
            today,
            prefixCls,
            calendarPrefixCls,
            fullCellRender,
            dateFullCellRender,
            cellRender,
            dateCellRender
        ]);
        const monthRender = $ltGt3.useCallback((date, info)=>{
            if (fullCellRender) return fullCellRender(date, info);
            if (monthFullCellRender) return monthFullCellRender(date);
            const months = info.locale.shortMonths || generateConfig.locale.getShortMonths(info.locale.locale);
            return /*#__PURE__*/ $ltGt3.createElement("div", {
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-cell-inner`, `${calendarPrefixCls}-date`, {
                    [`${calendarPrefixCls}-date-today`]: $eba16865a575da7a$var$isSameMonth(today, date, generateConfig)
                })
            }, /*#__PURE__*/ $ltGt3.createElement("div", {
                className: `${calendarPrefixCls}-date-value`
            }, months[generateConfig.getMonth(date)]), /*#__PURE__*/ $ltGt3.createElement("div", {
                className: `${calendarPrefixCls}-date-content`
            }, typeof cellRender === 'function' ? cellRender(date, info) : monthCellRender?.(date)));
        }, [
            today,
            prefixCls,
            calendarPrefixCls,
            fullCellRender,
            monthFullCellRender,
            cellRender,
            monthCellRender
        ]);
        const [contextLocale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Calendar', (0, $09650f76958a02c7$export$2e2bcd8739ae039));
        const locale = {
            ...contextLocale,
            ...props.locale
        };
        const mergedCellRender = (current, info)=>{
            if (info.type === 'date') return dateRender(current, info);
            if (info.type === 'month') return monthRender(current, {
                ...info,
                locale: locale?.lang
            });
        };
        return /*#__PURE__*/ $ltGt3.createElement("div", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(calendarPrefixCls, {
                [`${calendarPrefixCls}-full`]: fullscreen,
                [`${calendarPrefixCls}-mini`]: !fullscreen,
                [`${calendarPrefixCls}-rtl`]: direction === 'rtl'
            }, contextClassName, className, rootClassName, rootCls, hashId, cssVarCls),
            style: {
                ...rootStyle,
                ...contextStyle,
                ...style
            }
        }, headerRender ? headerRender({
            value: mergedValue,
            type: mergedMode,
            onChange: (nextDate)=>{
                onInternalSelect(nextDate, 'customize');
            },
            onTypeChange: triggerModeChange
        }) : /*#__PURE__*/ $ltGt3.createElement((0, $06523810d11c57ff$export$2e2bcd8739ae039), {
            className: headerCls,
            style: headerStyle,
            prefixCls: calendarPrefixCls,
            value: mergedValue,
            generateConfig: generateConfig,
            mode: mergedMode,
            fullscreen: fullscreen,
            locale: locale?.lang,
            validRange: validRange,
            onChange: onInternalSelect,
            onModeChange: triggerModeChange
        }), /*#__PURE__*/ $ltGt3.createElement((0, $b32474a64c1e9ff7$export$2e2bcd8739ae039), {
            classNames: panelClassNames,
            styles: panelStyles,
            value: mergedValue,
            prefixCls: prefixCls,
            locale: locale?.lang,
            generateConfig: generateConfig,
            cellRender: mergedCellRender,
            onSelect: (nextDate)=>{
                onInternalSelect(nextDate, panelMode);
            },
            mode: panelMode,
            picker: panelMode,
            disabledDate: mergedDisabledDate,
            hideHeader: true,
            showWeek: showWeek
        }));
    };
    return Calendar;
};
var $eba16865a575da7a$export$2e2bcd8739ae039 = $eba16865a575da7a$var$generateCalendar;


"use client";
const $cef75346f952412d$var$Calendar = (0, $eba16865a575da7a$export$2e2bcd8739ae039)((0, $a9d33dc0563db000$export$2e2bcd8739ae039));
$cef75346f952412d$var$Calendar.generateCalendar = (0, $eba16865a575da7a$export$2e2bcd8739ae039);
var $cef75346f952412d$export$2e2bcd8739ae039 = $cef75346f952412d$var$Calendar;



var $Ohofd = parcelRequire("Ohofd");
parcelRequire("ltGt3");
const $6dfc071b399cc1b6$export$b406e03ca3884ba = [
    'preplanting',
    'seedsowing',
    'prickingout',
    'hardeningoff',
    'transplanting',
    'planting',
    'repotting',
    'propagation',
    'watering',
    'weeding',
    'fertilizing',
    'chemicals',
    'harvesting',
    'pruning',
    'winter',
    'buying',
    'general'
];
const $6dfc071b399cc1b6$export$5ee9c2f1e4be3781 = [
    'preplanting',
    'seedsowing',
    'seedlingsemerge',
    'trueleaves',
    'prickingout',
    'hardeningoff',
    'transplanting',
    'planting',
    'repotting',
    'propagation',
    'watering',
    'weeding',
    'fertilizing',
    'chemicals',
    'blooming',
    'harvesting',
    'pruning',
    'winter',
    'general'
];
const $6dfc071b399cc1b6$var$toDoTypeColors = [
    'green',
    'purple',
    'brown',
    'yellow',
    'red',
    'blue',
    'gray'
];
const $6dfc071b399cc1b6$export$2a2c75ecbbc622ea = {
    preplanting: {
        name: 'preplanting',
        color: 'brown',
        icon: "\uD83E\uDEDA"
    },
    seedsowing: {
        name: 'seedsowing',
        color: 'brown',
        icon: "\uD83E\uDED8"
    },
    prickingout: {
        name: 'prickingout',
        color: 'green',
        icon: "\uD83E\uDEB4"
    },
    hardeningoff: {
        name: 'hardeningoff',
        color: 'blue',
        icon: "\uD83C\uDF2C\uFE0F"
    },
    transplanting: {
        name: 'transplanting',
        color: 'brown',
        icon: "\uD83C\uDF3C"
    },
    planting: {
        name: 'planting',
        color: 'green',
        icon: "\uD83C\uDF31"
    },
    watering: {
        name: 'watering',
        color: 'blue',
        icon: "\uD83D\uDCA7"
    },
    repotting: {
        name: 'Repotting',
        icon: "\uD83E\uDEB4",
        color: 'green'
    },
    weeding: {
        name: 'weeding',
        color: 'brown',
        icon: "\uD83E\uDDE4"
    },
    fertilizing: {
        name: 'fertilizing',
        color: 'yellow',
        icon: "\uD83D\uDC8A"
    },
    chemicals: {
        name: 'chemicals',
        color: 'red',
        icon: "\uD83D\uDC89"
    },
    propagation: {
        name: 'Propagation',
        icon: "\uD83C\uDF3F",
        color: 'green'
    },
    harvesting: {
        name: 'harvesting',
        color: 'purple',
        icon: "\uD83C\uDF4E"
    },
    pruning: {
        name: 'pruning',
        color: 'green',
        icon: "\uD83C\uDF33"
    },
    winter: {
        name: 'winter',
        color: 'blue',
        icon: "\u2744\uFE0F"
    },
    buying: {
        name: 'buying',
        color: 'purple',
        icon: 'shopping_bags'
    },
    general: {
        name: 'general',
        color: 'green',
        icon: "\u2611\uFE0F"
    }
};
const $6dfc071b399cc1b6$export$84362538fd926f28 = {
    preplanting: {
        name: 'preplanting',
        color: 'brown',
        icon: "\uD83E\uDEDA"
    },
    seedsowing: {
        name: 'seedsowing',
        color: 'brown',
        icon: "\uD83E\uDED8"
    },
    seedlingsemerge: {
        name: 'seedlingsemerge',
        color: 'green',
        icon: "\uD83C\uDF31"
    },
    trueleaves: {
        name: 'trueleaves',
        color: 'green',
        icon: "\uD83C\uDF43"
    },
    prickingout: {
        name: 'prickingout',
        color: 'green',
        icon: "\uD83E\uDEB4"
    },
    hardeningoff: {
        name: 'hardeningoff',
        color: 'blue',
        icon: "\uD83C\uDF2C\uFE0F"
    },
    transplanting: {
        name: 'transplanting',
        color: 'brown',
        icon: "\uD83C\uDF3C"
    },
    planting: {
        name: 'planting',
        color: 'green',
        icon: "\uD83C\uDF31"
    },
    watering: {
        name: 'watering',
        color: 'blue',
        icon: "\uD83D\uDCA7"
    },
    repotting: {
        name: 'Repotting',
        icon: "\uD83E\uDEB4",
        color: 'green'
    },
    propagation: {
        name: 'Propagation',
        icon: "\uD83C\uDF3F",
        color: 'green'
    },
    weeding: {
        name: 'weeding',
        color: 'brown',
        icon: "\uD83E\uDDE4"
    },
    fertilizing: {
        name: 'fertilizing',
        color: 'yellow',
        icon: "\uD83D\uDC8A"
    },
    chemicals: {
        name: 'chemicals',
        color: 'red',
        icon: "\uD83D\uDC89"
    },
    blooming: {
        name: 'blooming',
        color: 'red',
        icon: "\uD83C\uDF3A"
    },
    harvesting: {
        name: 'harvesting',
        color: 'purple',
        icon: "\uD83C\uDF4E"
    },
    pruning: {
        name: 'pruning',
        color: 'green',
        icon: "\uD83C\uDF33"
    },
    winter: {
        name: 'winter',
        color: 'blue',
        icon: "\u2744\uFE0F"
    },
    general: {
        name: 'general',
        color: 'green',
        icon: "\u2611\uFE0F"
    }
};
const $6dfc071b399cc1b6$export$a348c25fe51a3de8 = {
    seedsowing: 'seedsowing',
    prickingout: 'prickingout',
    hardeningoff: 'hardeningoff',
    transplanting: 'transplanting',
    planting: 'planting',
    repotting: 'repotting',
    propagation: 'propagation',
    harvesting: 'harvesting',
    pruning: 'pruning',
    weeding: 'weeding',
    fertilizing: 'fertilizing',
    watering: 'watering',
    chemicals: 'chemicals',
    buying: 'general',
    general: 'general',
    preplanting: 'preplanting',
    winter: 'winter'
};
const $6dfc071b399cc1b6$var$UnknownToDoType = {
    icon: "\uD83D\uDCC4",
    name: '',
    color: 'gray'
};
const $6dfc071b399cc1b6$export$9fdbb4134966a492 = {
    icon: "\uD83D\uDCC4",
    name: 'general',
    color: 'gray'
};
function $6dfc071b399cc1b6$export$bd87dd6af1226f02(type) {
    if (!type || !type.type) return $6dfc071b399cc1b6$var$UnknownToDoType;
    if (type.type === 'custom') {
        if (!type.customToDoType) return $6dfc071b399cc1b6$var$UnknownToDoType;
        else return {
            icon: type.customToDoType.icon,
            name: type.customToDoType.name,
            color: $6dfc071b399cc1b6$var$toDoTypeColors[type.customToDoType.id % $6dfc071b399cc1b6$var$toDoTypeColors.length]
        };
    } else return $6dfc071b399cc1b6$export$2a2c75ecbbc622ea[type.type];
}
function $6dfc071b399cc1b6$export$43852040ec70d1af(type) {
    if (!type || !type.type) return $6dfc071b399cc1b6$export$9fdbb4134966a492;
    if (type.type === 'custom') {
        if (!type.customJournalEventType) return $6dfc071b399cc1b6$export$9fdbb4134966a492;
        else return {
            icon: type.customJournalEventType.icon,
            name: type.customJournalEventType.name,
            color: $6dfc071b399cc1b6$var$toDoTypeColors[type.customJournalEventType.id % $6dfc071b399cc1b6$var$toDoTypeColors.length]
        };
    } else return $6dfc071b399cc1b6$export$84362538fd926f28[type.type];
}




const $75d4ef8c0094c908$var$onPanelChange = (value, mode)=>{
// console.log(value.format('YYYY-MM-DD'), mode)
};
function $75d4ef8c0094c908$var$checkDate(todo, currentDate) {
    if (!todo.targetStartDateUtc) return null;
    else if (!todo.targetEndDateUtc && (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(todo.targetStartDateUtc).isSame(currentDate, 'day')) return (0, $6dfc071b399cc1b6$export$bd87dd6af1226f02)(todo.type).color;
    else if (currentDate >= (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(todo.targetStartDateUtc) && currentDate <= (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(todo.targetEndDateUtc)) return (0, $6dfc071b399cc1b6$export$bd87dd6af1226f02)(todo.type).color;
    else return null;
}
function $75d4ef8c0094c908$export$4cc5481925352c83(props) {
    const { token: token } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const wrapperStyle = {
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadiusLG
    };
    const cellRender = (date, info)=>{
        return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
            placement: "bottom",
            title: getDateToDos(props.todos, date),
            color: 'rgba(245, 129, 83, 0.7)',
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative'
                },
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        children: date.get('date')
                    }),
                    props.todos && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        style: {
                            flexDirection: 'row',
                            position: 'absolute',
                            width: '100%',
                            top: '50%'
                        },
                        children: props.todos.map((currentToDo, index)=>{
                            let todoColor = $75d4ef8c0094c908$var$checkDate(currentToDo, date);
                            if (!todoColor) return null;
                            return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                style: {
                                    color: todoColor
                                },
                                children: "\u25CF"
                            }, index);
                        })
                    })
                ]
            })
        });
    };
    function getDateToDos(todos, currentDate) {
        const dateToDos = todos.filter((todo)=>{
            if (!todo.targetStartDateUtc) return false;
            else if (!todo.targetEndDateUtc && (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(todo.targetStartDateUtc).isSame(currentDate, 'day')) return true;
            else if (currentDate >= (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(todo.targetStartDateUtc) && currentDate <= (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(todo.targetEndDateUtc)) return true;
            else return false;
        });
        if (dateToDos.length === 0) return null;
        return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("ul", {
            children: dateToDos.map((item)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("li", {
                    children: [
                        item.type.type === 'custom' || !item.type.type ? (0, $6dfc071b399cc1b6$export$bd87dd6af1226f02)(item.type).name : intl.formatMessage({
                            id: `eventType-${(0, $6dfc071b399cc1b6$export$bd87dd6af1226f02)(item.type).name}`
                        }),
                        item.plants.length > 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                            children: [
                                `: `,
                                item.plants.map((plant, index)=>index === 0 ? plant.name : `, ${plant.name}`)
                            ]
                        })
                    ]
                }, item.id))
        });
    }
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        className: "calendar-reminders",
        style: wrapperStyle,
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $cef75346f952412d$export$2e2bcd8739ae039), {
            fullCellRender: cellRender,
            fullscreen: false,
            onPanelChange: $75d4ef8c0094c908$var$onPanelChange
        })
    });
}




var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */ var $d3b45fc6e7d35e7f$var$PI_OVER_180 = Math.PI / 180;
function $d3b45fc6e7d35e7f$var$detectBrowser() {
    return typeof window !== 'undefined' && (({}).toString.call(window) === '[object Window]' || ({}).toString.call(window) === '[object global]');
}
const $d3b45fc6e7d35e7f$export$442f1a04865e4790 = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof WorkerGlobalScope !== 'undefined' ? self : {};
const $d3b45fc6e7d35e7f$export$b9f99057a3c7692 = {
    _global: $d3b45fc6e7d35e7f$export$442f1a04865e4790,
    version: '8.4.2',
    isBrowser: $d3b45fc6e7d35e7f$var$detectBrowser(),
    isUnminified: /param/.test((function(param) {}).toString()),
    dblClickWindow: 400,
    getAngle (angle) {
        return $d3b45fc6e7d35e7f$export$b9f99057a3c7692.angleDeg ? angle * $d3b45fc6e7d35e7f$var$PI_OVER_180 : angle;
    },
    enableTrace: false,
    pointerEventsEnabled: true,
    autoDrawEnabled: true,
    hitOnDragEnabled: false,
    capturePointerEventsEnabled: false,
    _mouseListenClick: false,
    _touchListenClick: false,
    _pointerListenClick: false,
    _mouseInDblClickWindow: false,
    _touchInDblClickWindow: false,
    _pointerInDblClickWindow: false,
    _mouseDblClickPointerId: null,
    _touchDblClickPointerId: null,
    _pointerDblClickPointerId: null,
    pixelRatio: typeof window !== 'undefined' && window.devicePixelRatio || 1,
    dragDistance: 3,
    angleDeg: true,
    showWarnings: true,
    dragButtons: [
        0,
        1
    ],
    isDragging () {
        return $d3b45fc6e7d35e7f$export$b9f99057a3c7692['DD'].isDragging;
    },
    isDragReady () {
        return !!$d3b45fc6e7d35e7f$export$b9f99057a3c7692['DD'].node;
    },
    releaseCanvasOnDestroy: true,
    document: $d3b45fc6e7d35e7f$export$442f1a04865e4790.document,
    _injectGlobal (Konva) {
        $d3b45fc6e7d35e7f$export$442f1a04865e4790.Konva = Konva;
    }
};
const $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb = (NodeClass)=>{
    $d3b45fc6e7d35e7f$export$b9f99057a3c7692[NodeClass.prototype.getClassName()] = NodeClass;
};
$d3b45fc6e7d35e7f$export$b9f99057a3c7692._injectGlobal($d3b45fc6e7d35e7f$export$b9f99057a3c7692);



class $6436c4dfb94cdcf1$export$563a914cafbdc389 {
    constructor(m = [
        1,
        0,
        0,
        1,
        0,
        0
    ]){
        this.dirty = false;
        this.m = m && m.slice() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    reset() {
        this.m[0] = 1;
        this.m[1] = 0;
        this.m[2] = 0;
        this.m[3] = 1;
        this.m[4] = 0;
        this.m[5] = 0;
    }
    copy() {
        return new $6436c4dfb94cdcf1$export$563a914cafbdc389(this.m);
    }
    copyInto(tr) {
        tr.m[0] = this.m[0];
        tr.m[1] = this.m[1];
        tr.m[2] = this.m[2];
        tr.m[3] = this.m[3];
        tr.m[4] = this.m[4];
        tr.m[5] = this.m[5];
    }
    point(point) {
        var m = this.m;
        return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5]
        };
    }
    translate(x, y) {
        this.m[4] += this.m[0] * x + this.m[2] * y;
        this.m[5] += this.m[1] * x + this.m[3] * y;
        return this;
    }
    scale(sx, sy) {
        this.m[0] *= sx;
        this.m[1] *= sx;
        this.m[2] *= sy;
        this.m[3] *= sy;
        return this;
    }
    rotate(rad) {
        var c = Math.cos(rad);
        var s = Math.sin(rad);
        var m11 = this.m[0] * c + this.m[2] * s;
        var m12 = this.m[1] * c + this.m[3] * s;
        var m21 = this.m[0] * -s + this.m[2] * c;
        var m22 = this.m[1] * -s + this.m[3] * c;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    getTranslation() {
        return {
            x: this.m[4],
            y: this.m[5]
        };
    }
    skew(sx, sy) {
        var m11 = this.m[0] + this.m[2] * sy;
        var m12 = this.m[1] + this.m[3] * sy;
        var m21 = this.m[2] + this.m[0] * sx;
        var m22 = this.m[3] + this.m[1] * sx;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    multiply(matrix) {
        var m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
        var m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
        var m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
        var m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
        var dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
        var dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        this.m[4] = dx;
        this.m[5] = dy;
        return this;
    }
    invert() {
        var d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
        var m0 = this.m[3] * d;
        var m1 = -this.m[1] * d;
        var m2 = -this.m[2] * d;
        var m3 = this.m[0] * d;
        var m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
        var m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        this.m[0] = m0;
        this.m[1] = m1;
        this.m[2] = m2;
        this.m[3] = m3;
        this.m[4] = m4;
        this.m[5] = m5;
        return this;
    }
    getMatrix() {
        return this.m;
    }
    decompose() {
        var a = this.m[0];
        var b = this.m[1];
        var c = this.m[2];
        var d = this.m[3];
        var e = this.m[4];
        var f = this.m[5];
        var delta = a * d - b * c;
        let result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0
        };
        if (a != 0 || b != 0) {
            var r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b * d) / delta;
            result.skewY = 0;
        } else if (c != 0 || d != 0) {
            var s = Math.sqrt(c * c + d * d);
            result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b * d) / delta;
        }
        result.rotation = $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._getRotation(result.rotation);
        return result;
    }
}
var $6436c4dfb94cdcf1$var$OBJECT_ARRAY = '[object Array]', $6436c4dfb94cdcf1$var$OBJECT_NUMBER = '[object Number]', $6436c4dfb94cdcf1$var$OBJECT_STRING = '[object String]', $6436c4dfb94cdcf1$var$OBJECT_BOOLEAN = '[object Boolean]', $6436c4dfb94cdcf1$var$PI_OVER_DEG180 = Math.PI / 180, $6436c4dfb94cdcf1$var$DEG180_OVER_PI = 180 / Math.PI, $6436c4dfb94cdcf1$var$HASH = '#', $6436c4dfb94cdcf1$var$EMPTY_STRING = '', $6436c4dfb94cdcf1$var$ZERO = '0', $6436c4dfb94cdcf1$var$KONVA_WARNING = 'Konva warning: ', $6436c4dfb94cdcf1$var$KONVA_ERROR = 'Konva error: ', $6436c4dfb94cdcf1$var$RGB_PAREN = 'rgb(', $6436c4dfb94cdcf1$var$COLORS = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        132,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        255,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        203
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        119,
        128,
        144
    ],
    slategrey: [
        119,
        128,
        144
    ],
    snow: [
        255,
        255,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    transparent: [
        255,
        255,
        255,
        0
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        5
    ]
}, $6436c4dfb94cdcf1$var$RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, $6436c4dfb94cdcf1$var$animQueue = [];
const $6436c4dfb94cdcf1$var$req = typeof requestAnimationFrame !== 'undefined' && requestAnimationFrame || function(f) {
    setTimeout(f, 60);
};
const $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd = {
    _isElement (obj) {
        return !!(obj && obj.nodeType == 1);
    },
    _isFunction (obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isPlainObject (obj) {
        return !!obj && obj.constructor === Object;
    },
    _isArray (obj) {
        return Object.prototype.toString.call(obj) === $6436c4dfb94cdcf1$var$OBJECT_ARRAY;
    },
    _isNumber (obj) {
        return Object.prototype.toString.call(obj) === $6436c4dfb94cdcf1$var$OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
    },
    _isString (obj) {
        return Object.prototype.toString.call(obj) === $6436c4dfb94cdcf1$var$OBJECT_STRING;
    },
    _isBoolean (obj) {
        return Object.prototype.toString.call(obj) === $6436c4dfb94cdcf1$var$OBJECT_BOOLEAN;
    },
    isObject (val) {
        return val instanceof Object;
    },
    isValidSelector (selector) {
        if (typeof selector !== 'string') return false;
        var firstChar = selector[0];
        return firstChar === '#' || firstChar === '.' || firstChar === firstChar.toUpperCase();
    },
    _sign (number) {
        if (number === 0) return 1;
        if (number > 0) return 1;
        else return -1;
    },
    requestAnimFrame (callback) {
        $6436c4dfb94cdcf1$var$animQueue.push(callback);
        if ($6436c4dfb94cdcf1$var$animQueue.length === 1) $6436c4dfb94cdcf1$var$req(function() {
            const queue = $6436c4dfb94cdcf1$var$animQueue;
            $6436c4dfb94cdcf1$var$animQueue = [];
            queue.forEach(function(cb) {
                cb();
            });
        });
    },
    createCanvasElement () {
        var canvas = document.createElement('canvas');
        try {
            canvas.style = canvas.style || {};
        } catch (e) {}
        return canvas;
    },
    createImageElement () {
        return document.createElement('img');
    },
    _isInDocument (el) {
        while(el = el.parentNode){
            if (el == document) return true;
        }
        return false;
    },
    _urlToImage (url, callback) {
        var imageObj = $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd.createImageElement();
        imageObj.onload = function() {
            callback(imageObj);
        };
        imageObj.src = url;
    },
    _rgbToHex (r, g, b) {
        return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb (hex) {
        hex = hex.replace($6436c4dfb94cdcf1$var$HASH, $6436c4dfb94cdcf1$var$EMPTY_STRING);
        var bigint = parseInt(hex, 16);
        return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
        };
    },
    getRandomColor () {
        var randColor = (Math.random() * 0xffffff << 0).toString(16);
        while(randColor.length < 6)randColor = $6436c4dfb94cdcf1$var$ZERO + randColor;
        return $6436c4dfb94cdcf1$var$HASH + randColor;
    },
    getRGB (color) {
        var rgb;
        if (color in $6436c4dfb94cdcf1$var$COLORS) {
            rgb = $6436c4dfb94cdcf1$var$COLORS[color];
            return {
                r: rgb[0],
                g: rgb[1],
                b: rgb[2]
            };
        } else if (color[0] === $6436c4dfb94cdcf1$var$HASH) return this._hexToRgb(color.substring(1));
        else if (color.substr(0, 4) === $6436c4dfb94cdcf1$var$RGB_PAREN) {
            rgb = $6436c4dfb94cdcf1$var$RGB_REGEX.exec(color.replace(/ /g, ''));
            return {
                r: parseInt(rgb[1], 10),
                g: parseInt(rgb[2], 10),
                b: parseInt(rgb[3], 10)
            };
        } else return {
            r: 0,
            g: 0,
            b: 0
        };
    },
    colorToRGBA (str) {
        str = str || 'black';
        return $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._namedColorToRBA(str) || $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._hex3ColorToRGBA(str) || $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._hex4ColorToRGBA(str) || $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._hex6ColorToRGBA(str) || $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._hex8ColorToRGBA(str) || $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._rgbColorToRGBA(str) || $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._rgbaColorToRGBA(str) || $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._hslColorToRGBA(str);
    },
    _namedColorToRBA (str) {
        var c = $6436c4dfb94cdcf1$var$COLORS[str.toLowerCase()];
        if (!c) return null;
        return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1
        };
    },
    _rgbColorToRGBA (str) {
        if (str.indexOf('rgb(') === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map(Number);
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: 1
            };
        }
    },
    _rgbaColorToRGBA (str) {
        if (str.indexOf('rgba(') === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map((n, index)=>{
                if (n.slice(-1) === '%') return index === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255;
                return Number(n);
            });
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: parts[3]
            };
        }
    },
    _hex8ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 9) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: parseInt(str.slice(7, 9), 16) / 0xff
        };
    },
    _hex6ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 7) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: 1
        };
    },
    _hex4ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 5) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: parseInt(str[4] + str[4], 16) / 0xff
        };
    },
    _hex3ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 4) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: 1
        };
    },
    _hslColorToRGBA (str) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
            const h = Number(hsl[0]) / 360;
            const s = Number(hsl[1]) / 100;
            const l = Number(hsl[2]) / 100;
            let t2;
            let t3;
            let val;
            if (s === 0) {
                val = l * 255;
                return {
                    r: Math.round(val),
                    g: Math.round(val),
                    b: Math.round(val),
                    a: 1
                };
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            const t1 = 2 * l - t2;
            const rgb = [
                0,
                0,
                0
            ];
            for(let i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return {
                r: Math.round(rgb[0]),
                g: Math.round(rgb[1]),
                b: Math.round(rgb[2]),
                a: 1
            };
        }
    },
    haveIntersection (r1, r2) {
        return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
    },
    cloneObject (obj) {
        var retObj = {};
        for(var key in obj){
            if (this._isPlainObject(obj[key])) retObj[key] = this.cloneObject(obj[key]);
            else if (this._isArray(obj[key])) retObj[key] = this.cloneArray(obj[key]);
            else retObj[key] = obj[key];
        }
        return retObj;
    },
    cloneArray (arr) {
        return arr.slice(0);
    },
    degToRad (deg) {
        return deg * $6436c4dfb94cdcf1$var$PI_OVER_DEG180;
    },
    radToDeg (rad) {
        return rad * $6436c4dfb94cdcf1$var$DEG180_OVER_PI;
    },
    _degToRad (deg) {
        $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd.warn('Util._degToRad is removed. Please use public Util.degToRad instead.');
        return $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd.degToRad(deg);
    },
    _radToDeg (rad) {
        $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd.warn('Util._radToDeg is removed. Please use public Util.radToDeg instead.');
        return $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd.radToDeg(rad);
    },
    _getRotation (radians) {
        return (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).angleDeg ? $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd.radToDeg(radians) : radians;
    },
    _capitalize (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    throw (str) {
        throw new Error($6436c4dfb94cdcf1$var$KONVA_ERROR + str);
    },
    error (str) {
        console.error($6436c4dfb94cdcf1$var$KONVA_ERROR + str);
    },
    warn (str) {
        if (!(0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).showWarnings) return;
        console.warn($6436c4dfb94cdcf1$var$KONVA_WARNING + str);
    },
    each (obj, func) {
        for(var key in obj)func(key, obj[key]);
    },
    _inRange (val, left, right) {
        return left <= val && val < right;
    },
    _getProjectionToSegment (x1, y1, x2, y2, x3, y3) {
        var x, y, dist;
        var pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
        if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
        } else {
            var u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
                x = x1;
                y = y1;
                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            } else if (u > 1.0) {
                x = x2;
                y = y2;
                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            } else {
                x = x1 + u * (x2 - x1);
                y = y1 + u * (y2 - y1);
                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
        }
        return [
            x,
            y,
            dist
        ];
    },
    _getProjectionToLine (pt, line, isClosed) {
        var pc = $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd.cloneObject(pt);
        var dist = Number.MAX_VALUE;
        line.forEach(function(p1, i) {
            if (!isClosed && i === line.length - 1) return;
            var p2 = line[(i + 1) % line.length];
            var proj = $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            var px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
                pc.x = px;
                pc.y = py;
                dist = pdist;
            }
        });
        return pc;
    },
    _prepareArrayForTween (startArray, endArray, isClosed) {
        var n, start = [], end = [];
        if (startArray.length > endArray.length) {
            var temp = endArray;
            endArray = startArray;
            startArray = temp;
        }
        for(n = 0; n < startArray.length; n += 2)start.push({
            x: startArray[n],
            y: startArray[n + 1]
        });
        for(n = 0; n < endArray.length; n += 2)end.push({
            x: endArray[n],
            y: endArray[n + 1]
        });
        var newStart = [];
        end.forEach(function(point) {
            var pr = $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
        });
        return newStart;
    },
    _prepareToStringify (obj) {
        var desc;
        obj.visitedByCircularReferenceRemoval = true;
        for(var key in obj){
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')) continue;
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval || $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._isElement(obj[key])) {
                if (desc.configurable) delete obj[key];
                else return null;
            } else if ($6436c4dfb94cdcf1$export$f8f26dd395d7e1bd._prepareToStringify(obj[key]) === null) {
                if (desc.configurable) delete obj[key];
                else return null;
            }
        }
        delete obj.visitedByCircularReferenceRemoval;
        return obj;
    },
    _assign (target, source) {
        for(var key in source)target[key] = source[key];
        return target;
    },
    _getFirstPointerId (evt) {
        if (!evt.touches) return evt.pointerId || 999;
        else return evt.changedTouches[0].identifier;
    },
    releaseCanvas (...canvases) {
        if (!(0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).releaseCanvasOnDestroy) return;
        canvases.forEach((c)=>{
            c.width = 0;
            c.height = 0;
        });
    },
    drawRoundedRectPath (context, width, height, cornerRadius) {
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.moveTo(topLeft, 0);
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
    }
};






function $2b769617cb7fb124$var$_formatValue(val) {
    if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isString(val)) return '"' + val + '"';
    if (Object.prototype.toString.call(val) === '[object Number]') return val;
    if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isBoolean(val)) return val;
    return Object.prototype.toString.call(val);
}
function $2b769617cb7fb124$export$af51e4581c640b27(val) {
    if (val > 255) return 255;
    else if (val < 0) return 0;
    return Math.round(val);
}
function $2b769617cb7fb124$export$7078afdc21938e7(val) {
    if (val > 1) return 1;
    else if (val < 0.0001) return 0.0001;
    return val;
}
function $2b769617cb7fb124$export$6b1205b9fbe7de2c() {
    if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isNumber(val)) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn($2b769617cb7fb124$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number.');
        return val;
    };
}
function $2b769617cb7fb124$export$7d4ab1842c1b264b(noOfElements) {
    if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        let isNumber = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isNumber(val);
        let isValidArray = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isArray(val) && val.length == noOfElements;
        if (!isNumber && !isValidArray) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn($2b769617cb7fb124$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or Array<number>(' + noOfElements + ')');
        return val;
    };
}
function $2b769617cb7fb124$export$3b7df2720ef33404() {
    if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        var isNumber = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isNumber(val);
        var isAuto = val === 'auto';
        if (!(isNumber || isAuto)) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn($2b769617cb7fb124$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or "auto".');
        return val;
    };
}
function $2b769617cb7fb124$export$5837c5b6cc5b4d63() {
    if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isString(val)) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn($2b769617cb7fb124$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string.');
        return val;
    };
}
function $2b769617cb7fb124$export$9c72f966a828cc68() {
    if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isString = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isString(val);
        const isGradient = Object.prototype.toString.call(val) === '[object CanvasGradient]' || val && val.addColorStop;
        if (!(isString || isGradient)) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn($2b769617cb7fb124$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string or a native gradient.');
        return val;
    };
}
function $2b769617cb7fb124$export$61d6863134de1cd() {
    if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isFunction(val)) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn($2b769617cb7fb124$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a function.');
        return val;
    };
}
function $2b769617cb7fb124$export$42b6f8f340e9a165() {
    if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        if (TypedArray && val instanceof TypedArray) return val;
        if (!(0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isArray(val)) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn($2b769617cb7fb124$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a array of numbers.');
        else val.forEach(function(item) {
            if (!(0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isNumber(item)) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('"' + attr + '" attribute has non numeric element ' + item + '. Make sure that all elements are numbers.');
        });
        return val;
    };
}
function $2b769617cb7fb124$export$147fc8b6cd20fda1() {
    if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        var isBool = val === true || val === false;
        if (!isBool) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn($2b769617cb7fb124$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a boolean.');
        return val;
    };
}
function $2b769617cb7fb124$export$5c1978fb8431d4a1(components) {
    if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (val === undefined || val === null) return val;
        if (!(0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).isObject(val)) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn($2b769617cb7fb124$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be an object with properties ' + components);
        return val;
    };
}


var $43fd669de4de8956$var$GET = 'get', $43fd669de4de8956$var$SET = 'set';
const $43fd669de4de8956$export$8354032f3852ec50 = {
    addGetterSetter (constructor, attr, def, validator, after) {
        $43fd669de4de8956$export$8354032f3852ec50.addGetter(constructor, attr, def);
        $43fd669de4de8956$export$8354032f3852ec50.addSetter(constructor, attr, validator, after);
        $43fd669de4de8956$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter (constructor, attr, def) {
        var method = $43fd669de4de8956$var$GET + (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = constructor.prototype[method] || function() {
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
    },
    addSetter (constructor, attr, validator, after) {
        var method = $43fd669de4de8956$var$SET + (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._capitalize(attr);
        if (!constructor.prototype[method]) $43fd669de4de8956$export$8354032f3852ec50.overWriteSetter(constructor, attr, validator, after);
    },
    overWriteSetter (constructor, attr, validator, after) {
        var method = $43fd669de4de8956$var$SET + (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = function(val) {
            if (validator && val !== undefined && val !== null) val = validator.call(this, val, attr);
            this._setAttr(attr, val);
            if (after) after.call(this);
            return this;
        };
    },
    addComponentsGetterSetter (constructor, attr, components, validator, after) {
        var len = components.length, capitalize = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._capitalize, getter = $43fd669de4de8956$var$GET + capitalize(attr), setter = $43fd669de4de8956$var$SET + capitalize(attr), n, component;
        constructor.prototype[getter] = function() {
            var ret = {};
            for(n = 0; n < len; n++){
                component = components[n];
                ret[component] = this.getAttr(attr + capitalize(component));
            }
            return ret;
        };
        var basicValidator = (0, $2b769617cb7fb124$export$5c1978fb8431d4a1)(components);
        constructor.prototype[setter] = function(val) {
            var oldVal = this.attrs[attr], key;
            if (validator) val = validator.call(this, val);
            if (basicValidator) basicValidator.call(this, val, attr);
            for(key in val){
                if (!val.hasOwnProperty(key)) continue;
                this._setAttr(attr + capitalize(key), val[key]);
            }
            if (!val) components.forEach((component)=>{
                this._setAttr(attr + capitalize(component), undefined);
            });
            this._fireChangeEvent(attr, oldVal, val);
            if (after) after.call(this);
            return this;
        };
        $43fd669de4de8956$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter (constructor, attr) {
        var capitalizedAttr = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._capitalize(attr), setter = $43fd669de4de8956$var$SET + capitalizedAttr, getter = $43fd669de4de8956$var$GET + capitalizedAttr;
        constructor.prototype[attr] = function() {
            if (arguments.length) {
                this[setter](arguments[0]);
                return this;
            }
            return this[getter]();
        };
    },
    addDeprecatedGetterSetter (constructor, attr, def, validator) {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error('Adding deprecated ' + attr);
        var method = $43fd669de4de8956$var$GET + (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._capitalize(attr);
        var message = attr + ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
        constructor.prototype[method] = function() {
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error(message);
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
        $43fd669de4de8956$export$8354032f3852ec50.addSetter(constructor, attr, validator, function() {
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error(message);
        });
        $43fd669de4de8956$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    backCompat (constructor, methods) {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).each(methods, function(oldMethodName, newMethodName) {
            var method = constructor.prototype[newMethodName];
            var oldGetter = $43fd669de4de8956$var$GET + (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            var oldSetter = $43fd669de4de8956$var$SET + (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            function deprecated() {
                method.apply(this, arguments);
                (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error('"' + oldMethodName + '" method is deprecated and will be removed soon. Use ""' + newMethodName + '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
        });
    },
    afterSetFilter () {
        this._filterUpToDate = false;
    }
};





function $19d5ebb13d967905$var$simplifyArray(arr) {
    var retArr = [], len = arr.length, util = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd), n, val;
    for(n = 0; n < len; n++){
        val = arr[n];
        if (util._isNumber(val)) val = Math.round(val * 1000) / 1000;
        else if (!util._isString(val)) val = val + '';
        retArr.push(val);
    }
    return retArr;
}
var $19d5ebb13d967905$var$COMMA = ',', $19d5ebb13d967905$var$OPEN_PAREN = '(', $19d5ebb13d967905$var$CLOSE_PAREN = ')', $19d5ebb13d967905$var$OPEN_PAREN_BRACKET = '([', $19d5ebb13d967905$var$CLOSE_BRACKET_PAREN = '])', $19d5ebb13d967905$var$SEMICOLON = ';', $19d5ebb13d967905$var$DOUBLE_PAREN = '()', $19d5ebb13d967905$var$EQUALS = '=', $19d5ebb13d967905$var$CONTEXT_METHODS = [
    'arc',
    'arcTo',
    'beginPath',
    'bezierCurveTo',
    'clearRect',
    'clip',
    'closePath',
    'createLinearGradient',
    'createPattern',
    'createRadialGradient',
    'drawImage',
    'ellipse',
    'fill',
    'fillText',
    'getImageData',
    'createImageData',
    'lineTo',
    'moveTo',
    'putImageData',
    'quadraticCurveTo',
    'rect',
    'restore',
    'rotate',
    'save',
    'scale',
    'setLineDash',
    'setTransform',
    'stroke',
    'strokeText',
    'transform',
    'translate'
];
var $19d5ebb13d967905$var$CONTEXT_PROPERTIES = [
    'fillStyle',
    'strokeStyle',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'lineCap',
    'lineDashOffset',
    'lineJoin',
    'lineWidth',
    'miterLimit',
    'font',
    'textAlign',
    'textBaseline',
    'globalAlpha',
    'globalCompositeOperation',
    'imageSmoothingEnabled'
];
const $19d5ebb13d967905$var$traceArrMax = 100;
class $19d5ebb13d967905$export$841858b892ce1f4c {
    constructor(canvas){
        this.canvas = canvas;
        if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).enableTrace) {
            this.traceArr = [];
            this._enableTrace();
        }
    }
    fillShape(shape) {
        if (shape.fillEnabled()) this._fill(shape);
    }
    _fill(shape) {}
    strokeShape(shape) {
        if (shape.hasStroke()) this._stroke(shape);
    }
    _stroke(shape) {}
    fillStrokeShape(shape) {
        if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
        } else {
            this.fillShape(shape);
            this.strokeShape(shape);
        }
    }
    getTrace(relaxed, rounded) {
        var traceArr = this.traceArr, len = traceArr.length, str = '', n, trace, method, args;
        for(n = 0; n < len; n++){
            trace = traceArr[n];
            method = trace.method;
            if (method) {
                args = trace.args;
                str += method;
                if (relaxed) str += $19d5ebb13d967905$var$DOUBLE_PAREN;
                else if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isArray(args[0])) str += $19d5ebb13d967905$var$OPEN_PAREN_BRACKET + args.join($19d5ebb13d967905$var$COMMA) + $19d5ebb13d967905$var$CLOSE_BRACKET_PAREN;
                else {
                    if (rounded) args = args.map((a)=>typeof a === 'number' ? Math.floor(a) : a);
                    str += $19d5ebb13d967905$var$OPEN_PAREN + args.join($19d5ebb13d967905$var$COMMA) + $19d5ebb13d967905$var$CLOSE_PAREN;
                }
            } else {
                str += trace.property;
                if (!relaxed) str += $19d5ebb13d967905$var$EQUALS + trace.val;
            }
            str += $19d5ebb13d967905$var$SEMICOLON;
        }
        return str;
    }
    clearTrace() {
        this.traceArr = [];
    }
    _trace(str) {
        var traceArr = this.traceArr, len;
        traceArr.push(str);
        len = traceArr.length;
        if (len >= $19d5ebb13d967905$var$traceArrMax) traceArr.shift();
    }
    reset() {
        var pixelRatio = this.getCanvas().getPixelRatio();
        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    }
    getCanvas() {
        return this.canvas;
    }
    clear(bounds) {
        var canvas = this.getCanvas();
        if (bounds) this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
        else this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
    }
    _applyLineCap(shape) {
        var lineCap = shape.getLineCap();
        if (lineCap) this.setAttr('lineCap', lineCap);
    }
    _applyOpacity(shape) {
        var absOpacity = shape.getAbsoluteOpacity();
        if (absOpacity !== 1) this.setAttr('globalAlpha', absOpacity);
    }
    _applyLineJoin(shape) {
        var lineJoin = shape.attrs.lineJoin;
        if (lineJoin) this.setAttr('lineJoin', lineJoin);
    }
    setAttr(attr, val) {
        this._context[attr] = val;
    }
    arc(a0, a1, a2, a3, a4, a5) {
        this._context.arc(a0, a1, a2, a3, a4, a5);
    }
    arcTo(a0, a1, a2, a3, a4) {
        this._context.arcTo(a0, a1, a2, a3, a4);
    }
    beginPath() {
        this._context.beginPath();
    }
    bezierCurveTo(a0, a1, a2, a3, a4, a5) {
        this._context.bezierCurveTo(a0, a1, a2, a3, a4, a5);
    }
    clearRect(a0, a1, a2, a3) {
        this._context.clearRect(a0, a1, a2, a3);
    }
    clip() {
        this._context.clip();
    }
    closePath() {
        this._context.closePath();
    }
    createImageData(a0, a1) {
        var a = arguments;
        if (a.length === 2) return this._context.createImageData(a0, a1);
        else if (a.length === 1) return this._context.createImageData(a0);
    }
    createLinearGradient(a0, a1, a2, a3) {
        return this._context.createLinearGradient(a0, a1, a2, a3);
    }
    createPattern(a0, a1) {
        return this._context.createPattern(a0, a1);
    }
    createRadialGradient(a0, a1, a2, a3, a4, a5) {
        return this._context.createRadialGradient(a0, a1, a2, a3, a4, a5);
    }
    drawImage(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        var a = arguments, _context = this._context;
        if (a.length === 3) _context.drawImage(a0, a1, a2);
        else if (a.length === 5) _context.drawImage(a0, a1, a2, a3, a4);
        else if (a.length === 9) _context.drawImage(a0, a1, a2, a3, a4, a5, a6, a7, a8);
    }
    ellipse(a0, a1, a2, a3, a4, a5, a6, a7) {
        this._context.ellipse(a0, a1, a2, a3, a4, a5, a6, a7);
    }
    isPointInPath(x, y, path, fillRule) {
        if (path) return this._context.isPointInPath(path, x, y, fillRule);
        return this._context.isPointInPath(x, y, fillRule);
    }
    fill(path2d) {
        if (path2d) this._context.fill(path2d);
        else this._context.fill();
    }
    fillRect(x, y, width, height) {
        this._context.fillRect(x, y, width, height);
    }
    strokeRect(x, y, width, height) {
        this._context.strokeRect(x, y, width, height);
    }
    fillText(text, x, y, maxWidth) {
        if (maxWidth) this._context.fillText(text, x, y, maxWidth);
        else this._context.fillText(text, x, y);
    }
    measureText(text) {
        return this._context.measureText(text);
    }
    getImageData(a0, a1, a2, a3) {
        return this._context.getImageData(a0, a1, a2, a3);
    }
    lineTo(a0, a1) {
        this._context.lineTo(a0, a1);
    }
    moveTo(a0, a1) {
        this._context.moveTo(a0, a1);
    }
    rect(a0, a1, a2, a3) {
        this._context.rect(a0, a1, a2, a3);
    }
    putImageData(a0, a1, a2) {
        this._context.putImageData(a0, a1, a2);
    }
    quadraticCurveTo(a0, a1, a2, a3) {
        this._context.quadraticCurveTo(a0, a1, a2, a3);
    }
    restore() {
        this._context.restore();
    }
    rotate(a0) {
        this._context.rotate(a0);
    }
    save() {
        this._context.save();
    }
    scale(a0, a1) {
        this._context.scale(a0, a1);
    }
    setLineDash(a0) {
        if (this._context.setLineDash) this._context.setLineDash(a0);
        else if ('mozDash' in this._context) this._context['mozDash'] = a0;
        else if ('webkitLineDash' in this._context) this._context['webkitLineDash'] = a0;
    }
    getLineDash() {
        return this._context.getLineDash();
    }
    setTransform(a0, a1, a2, a3, a4, a5) {
        this._context.setTransform(a0, a1, a2, a3, a4, a5);
    }
    stroke(path2d) {
        if (path2d) this._context.stroke(path2d);
        else this._context.stroke();
    }
    strokeText(a0, a1, a2, a3) {
        this._context.strokeText(a0, a1, a2, a3);
    }
    transform(a0, a1, a2, a3, a4, a5) {
        this._context.transform(a0, a1, a2, a3, a4, a5);
    }
    translate(a0, a1) {
        this._context.translate(a0, a1);
    }
    _enableTrace() {
        var that = this, len = $19d5ebb13d967905$var$CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
        var func = function(methodName) {
            var origMethod = that[methodName], ret;
            that[methodName] = function() {
                args = $19d5ebb13d967905$var$simplifyArray(Array.prototype.slice.call(arguments, 0));
                ret = origMethod.apply(that, arguments);
                that._trace({
                    method: methodName,
                    args: args
                });
                return ret;
            };
        };
        for(n = 0; n < len; n++)func($19d5ebb13d967905$var$CONTEXT_METHODS[n]);
        that.setAttr = function() {
            origSetter.apply(that, arguments);
            var prop = arguments[0];
            var val = arguments[1];
            if (prop === 'shadowOffsetX' || prop === 'shadowOffsetY' || prop === 'shadowBlur') val = val / this.canvas.getPixelRatio();
            that._trace({
                property: prop,
                val: val
            });
        };
    }
    _applyGlobalCompositeOperation(node) {
        const op = node.attrs.globalCompositeOperation;
        var def = !op || op === 'source-over';
        if (!def) this.setAttr('globalCompositeOperation', op);
    }
}
$19d5ebb13d967905$var$CONTEXT_PROPERTIES.forEach(function(prop) {
    Object.defineProperty($19d5ebb13d967905$export$841858b892ce1f4c.prototype, prop, {
        get () {
            return this._context[prop];
        },
        set (val) {
            this._context[prop] = val;
        }
    });
});
class $19d5ebb13d967905$export$576380cfa99ddf20 extends $19d5ebb13d967905$export$841858b892ce1f4c {
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext('2d');
    }
    _fillColor(shape) {
        var fill = shape.fill();
        this.setAttr('fillStyle', fill);
        shape._fillFunc(this);
    }
    _fillPattern(shape) {
        this.setAttr('fillStyle', shape._getFillPattern());
        shape._fillFunc(this);
    }
    _fillLinearGradient(shape) {
        var grd = shape._getLinearGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fillRadialGradient(shape) {
        var grd = shape._getRadialGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fill(shape) {
        var hasColor = shape.fill(), fillPriority = shape.getFillPriority();
        if (hasColor && fillPriority === 'color') {
            this._fillColor(shape);
            return;
        }
        var hasPattern = shape.getFillPatternImage();
        if (hasPattern && fillPriority === 'pattern') {
            this._fillPattern(shape);
            return;
        }
        var hasLinearGradient = shape.getFillLinearGradientColorStops();
        if (hasLinearGradient && fillPriority === 'linear-gradient') {
            this._fillLinearGradient(shape);
            return;
        }
        var hasRadialGradient = shape.getFillRadialGradientColorStops();
        if (hasRadialGradient && fillPriority === 'radial-gradient') {
            this._fillRadialGradient(shape);
            return;
        }
        if (hasColor) this._fillColor(shape);
        else if (hasPattern) this._fillPattern(shape);
        else if (hasLinearGradient) this._fillLinearGradient(shape);
        else if (hasRadialGradient) this._fillRadialGradient(shape);
    }
    _strokeLinearGradient(shape) {
        var start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
        if (colorStops) {
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            this.setAttr('strokeStyle', grd);
        }
    }
    _stroke(shape) {
        var dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
                this.setLineDash(dash);
                this.setAttr('lineDashOffset', shape.dashOffset());
            }
            this.setAttr('lineWidth', shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) this.setAttr('shadowColor', 'rgba(0,0,0,0)');
            var hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) this._strokeLinearGradient(shape);
            else this.setAttr('strokeStyle', shape.stroke());
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
    _applyShadow(shape) {
        var _a, _b, _c;
        var color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : 'black', blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
            x: 0,
            y: 0
        }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
        this.setAttr('shadowColor', color);
        this.setAttr('shadowBlur', blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
        this.setAttr('shadowOffsetX', offset.x * scaleX);
        this.setAttr('shadowOffsetY', offset.y * scaleY);
    }
}
class $19d5ebb13d967905$export$85eec7ef35542dce extends $19d5ebb13d967905$export$841858b892ce1f4c {
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently: true
        });
    }
    _fill(shape) {
        this.save();
        this.setAttr('fillStyle', shape.colorKey);
        shape._fillFuncHit(this);
        this.restore();
    }
    strokeShape(shape) {
        if (shape.hasHitStroke()) this._stroke(shape);
    }
    _stroke(shape) {
        if (shape.hasHitStroke()) {
            var strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            var hitStrokeWidth = shape.hitStrokeWidth();
            var strokeWidth = hitStrokeWidth === 'auto' ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr('lineWidth', strokeWidth);
            this.setAttr('strokeStyle', shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
}





var $91aeecb318ae5dc4$var$_pixelRatio;
function $91aeecb318ae5dc4$var$getDevicePixelRatio() {
    if ($91aeecb318ae5dc4$var$_pixelRatio) return $91aeecb318ae5dc4$var$_pixelRatio;
    var canvas = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).createCanvasElement();
    var context = canvas.getContext('2d');
    $91aeecb318ae5dc4$var$_pixelRatio = function() {
        var devicePixelRatio = (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
        return devicePixelRatio / backingStoreRatio;
    }();
    (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).releaseCanvas(canvas);
    return $91aeecb318ae5dc4$var$_pixelRatio;
}
class $91aeecb318ae5dc4$export$8d01c972ee8b14a9 {
    constructor(config){
        this.pixelRatio = 1;
        this.width = 0;
        this.height = 0;
        this.isCache = false;
        var conf = config || {};
        var pixelRatio = conf.pixelRatio || (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).pixelRatio || $91aeecb318ae5dc4$var$getDevicePixelRatio();
        this.pixelRatio = pixelRatio;
        this._canvas = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).createCanvasElement();
        this._canvas.style.padding = '0';
        this._canvas.style.margin = '0';
        this._canvas.style.border = '0';
        this._canvas.style.background = 'transparent';
        this._canvas.style.position = 'absolute';
        this._canvas.style.top = '0';
        this._canvas.style.left = '0';
    }
    getContext() {
        return this.context;
    }
    getPixelRatio() {
        return this.pixelRatio;
    }
    setPixelRatio(pixelRatio) {
        var previousRatio = this.pixelRatio;
        this.pixelRatio = pixelRatio;
        this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
    }
    setWidth(width) {
        this.width = this._canvas.width = width * this.pixelRatio;
        this._canvas.style.width = width + 'px';
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    setHeight(height) {
        this.height = this._canvas.height = height * this.pixelRatio;
        this._canvas.style.height = height + 'px';
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    setSize(width, height) {
        this.setWidth(width || 0);
        this.setHeight(height || 0);
    }
    toDataURL(mimeType, quality) {
        try {
            return this._canvas.toDataURL(mimeType, quality);
        } catch (e) {
            try {
                return this._canvas.toDataURL();
            } catch (err) {
                (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error('Unable to get data URL. ' + err.message + ' For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                return '';
            }
        }
    }
}
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($91aeecb318ae5dc4$export$8d01c972ee8b14a9, 'pixelRatio', undefined, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
class $91aeecb318ae5dc4$export$ee612225bd2e63be extends $91aeecb318ae5dc4$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.context = new (0, $19d5ebb13d967905$export$576380cfa99ddf20)(this);
        this.setSize(config.width, config.height);
    }
}
class $91aeecb318ae5dc4$export$43a2e1456e27dc84 extends $91aeecb318ae5dc4$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.hitCanvas = true;
        this.context = new (0, $19d5ebb13d967905$export$85eec7ef35542dce)(this);
        this.setSize(config.width, config.height);
    }
}





const $b5d29c637453a5f5$export$e34f1b340034d7f = {
    get isDragging () {
        var flag = false;
        $b5d29c637453a5f5$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            if (elem.dragStatus === 'dragging') flag = true;
        });
        return flag;
    },
    justDragged: false,
    get node () {
        var node;
        $b5d29c637453a5f5$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            node = elem.node;
        });
        return node;
    },
    _dragElements: new Map(),
    _drag (evt) {
        const nodesToFireEvents = [];
        $b5d29c637453a5f5$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === undefined) elem.pointerId = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._getFirstPointerId(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus !== 'dragging') {
                var dragDistance = node.dragDistance();
                var distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
                if (distance < dragDistance) return;
                node.startDrag({
                    evt: evt
                });
                if (!node.isDragging()) return;
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
        });
        nodesToFireEvents.forEach((node)=>{
            node.fire('dragmove', {
                type: 'dragmove',
                target: node,
                evt: evt
            }, true);
        });
    },
    _endDragBefore (evt) {
        const drawNodes = [];
        $b5d29c637453a5f5$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            if (evt) stage.setPointersPositions(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus === 'dragging' || elem.dragStatus === 'stopped') {
                $b5d29c637453a5f5$export$e34f1b340034d7f.justDragged = true;
                (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)._mouseListenClick = false;
                (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)._touchListenClick = false;
                (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)._pointerListenClick = false;
                elem.dragStatus = 'stopped';
            }
            const drawNode = elem.node.getLayer() || elem.node instanceof (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)['Stage'] && elem.node;
            if (drawNode && drawNodes.indexOf(drawNode) === -1) drawNodes.push(drawNode);
        });
        drawNodes.forEach((drawNode)=>{
            drawNode.draw();
        });
    },
    _endDragAfter (evt) {
        $b5d29c637453a5f5$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            if (elem.dragStatus === 'stopped') elem.node.fire('dragend', {
                type: 'dragend',
                target: elem.node,
                evt: evt
            }, true);
            if (elem.dragStatus !== 'dragging') $b5d29c637453a5f5$export$e34f1b340034d7f._dragElements.delete(key);
        });
    }
};
if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isBrowser) {
    window.addEventListener('mouseup', $b5d29c637453a5f5$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener('touchend', $b5d29c637453a5f5$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener('mousemove', $b5d29c637453a5f5$export$e34f1b340034d7f._drag);
    window.addEventListener('touchmove', $b5d29c637453a5f5$export$e34f1b340034d7f._drag);
    window.addEventListener('mouseup', $b5d29c637453a5f5$export$e34f1b340034d7f._endDragAfter, false);
    window.addEventListener('touchend', $b5d29c637453a5f5$export$e34f1b340034d7f._endDragAfter, false);
}



var $ea22cf9e3e585277$var$ABSOLUTE_OPACITY = 'absoluteOpacity', $ea22cf9e3e585277$var$ALL_LISTENERS = 'allEventListeners', $ea22cf9e3e585277$var$ABSOLUTE_TRANSFORM = 'absoluteTransform', $ea22cf9e3e585277$var$ABSOLUTE_SCALE = 'absoluteScale', $ea22cf9e3e585277$var$CANVAS = 'canvas', $ea22cf9e3e585277$var$CHANGE = 'Change', $ea22cf9e3e585277$var$CHILDREN = 'children', $ea22cf9e3e585277$var$KONVA = 'konva', $ea22cf9e3e585277$var$LISTENING = 'listening', $ea22cf9e3e585277$var$MOUSEENTER = 'mouseenter', $ea22cf9e3e585277$var$MOUSELEAVE = 'mouseleave', $ea22cf9e3e585277$var$NAME = 'name', $ea22cf9e3e585277$var$SET = 'set', $ea22cf9e3e585277$var$SHAPE = 'Shape', $ea22cf9e3e585277$var$SPACE = ' ', $ea22cf9e3e585277$var$STAGE = 'stage', $ea22cf9e3e585277$var$TRANSFORM = 'transform', $ea22cf9e3e585277$var$UPPER_STAGE = 'Stage', $ea22cf9e3e585277$var$VISIBLE = 'visible', $ea22cf9e3e585277$var$TRANSFORM_CHANGE_STR = [
    'xChange.konva',
    'yChange.konva',
    'scaleXChange.konva',
    'scaleYChange.konva',
    'skewXChange.konva',
    'skewYChange.konva',
    'rotationChange.konva',
    'offsetXChange.konva',
    'offsetYChange.konva',
    'transformsEnabledChange.konva'
].join($ea22cf9e3e585277$var$SPACE);
let $ea22cf9e3e585277$var$idCounter = 1;
class $ea22cf9e3e585277$export$85c928794f8d04d4 {
    constructor(config){
        this._id = $ea22cf9e3e585277$var$idCounter++;
        this.eventListeners = {};
        this.attrs = {};
        this.index = 0;
        this._allEventListeners = null;
        this.parent = null;
        this._cache = new Map();
        this._attachedDepsListeners = new Map();
        this._lastPos = null;
        this._batchingTransformChange = false;
        this._needClearTransformCache = false;
        this._filterUpToDate = false;
        this._isUnderCache = false;
        this._dragEventId = null;
        this._shouldFireChangeEvents = false;
        this.setAttrs(config);
        this._shouldFireChangeEvents = true;
    }
    hasChildren() {
        return false;
    }
    _clearCache(attr) {
        if ((attr === $ea22cf9e3e585277$var$TRANSFORM || attr === $ea22cf9e3e585277$var$ABSOLUTE_TRANSFORM) && this._cache.get(attr)) this._cache.get(attr).dirty = true;
        else if (attr) this._cache.delete(attr);
        else this._cache.clear();
    }
    _getCache(attr, privateGetter) {
        var cache = this._cache.get(attr);
        var isTransform = attr === $ea22cf9e3e585277$var$TRANSFORM || attr === $ea22cf9e3e585277$var$ABSOLUTE_TRANSFORM;
        var invalid = cache === undefined || isTransform && cache.dirty === true;
        if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
        }
        return cache;
    }
    _calculate(name, deps, getter) {
        if (!this._attachedDepsListeners.get(name)) {
            const depsString = deps.map((dep)=>dep + 'Change.konva').join($ea22cf9e3e585277$var$SPACE);
            this.on(depsString, ()=>{
                this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
        }
        return this._getCache(name, getter);
    }
    _getCanvasCache() {
        return this._cache.get($ea22cf9e3e585277$var$CANVAS);
    }
    _clearSelfAndDescendantCache(attr) {
        this._clearCache(attr);
        if (attr === $ea22cf9e3e585277$var$ABSOLUTE_TRANSFORM) this.fire('absoluteTransformChange');
    }
    clearCache() {
        if (this._cache.has($ea22cf9e3e585277$var$CANVAS)) {
            const { scene: scene, filter: filter, hit: hit } = this._cache.get($ea22cf9e3e585277$var$CANVAS);
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).releaseCanvas(scene, filter, hit);
            this._cache.delete($ea22cf9e3e585277$var$CANVAS);
        }
        this._clearSelfAndDescendantCache();
        this._requestDraw();
        return this;
    }
    cache(config) {
        var conf = config || {};
        var rect = {};
        if (conf.x === undefined || conf.y === undefined || conf.width === undefined || conf.height === undefined) rect = this.getClientRect({
            skipTransform: true,
            relativeTo: this.getParent()
        });
        var width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? Math.floor(rect.x) : conf.x, y = conf.y === undefined ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
        if (!width || !height) {
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error('Can not cache the node. Width or height of the node equals 0. Caching is skipped.');
            return;
        }
        width += offset * 2 + 1;
        height += offset * 2 + 1;
        x -= offset;
        y -= offset;
        var cachedSceneCanvas = new (0, $91aeecb318ae5dc4$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: width,
            height: height
        }), cachedFilterCanvas = new (0, $91aeecb318ae5dc4$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: 0,
            height: 0
        }), cachedHitCanvas = new (0, $91aeecb318ae5dc4$export$43a2e1456e27dc84)({
            pixelRatio: hitCanvasPixelRatio,
            width: width,
            height: height
        }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
        cachedHitCanvas.isCache = true;
        cachedSceneCanvas.isCache = true;
        this._cache.delete($ea22cf9e3e585277$var$CANVAS);
        this._filterUpToDate = false;
        if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
        }
        sceneContext.save();
        hitContext.save();
        sceneContext.translate(-x, -y);
        hitContext.translate(-x, -y);
        this._isUnderCache = true;
        this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$ABSOLUTE_SCALE);
        this.drawScene(cachedSceneCanvas, this);
        this.drawHit(cachedHitCanvas, this);
        this._isUnderCache = false;
        sceneContext.restore();
        hitContext.restore();
        if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr('strokeStyle', 'red');
            sceneContext.setAttr('lineWidth', 5);
            sceneContext.stroke();
            sceneContext.restore();
        }
        this._cache.set($ea22cf9e3e585277$var$CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            x: x,
            y: y
        });
        this._requestDraw();
        return this;
    }
    isCached() {
        return this._cache.has($ea22cf9e3e585277$var$CANVAS);
    }
    getClientRect(config) {
        throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(rect, top) {
        var points = [
            {
                x: rect.x,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y + rect.height
            },
            {
                x: rect.x,
                y: rect.y + rect.height
            }
        ];
        var minX, minY, maxX, maxY;
        var trans = this.getAbsoluteTransform(top);
        points.forEach(function(point) {
            var transformed = trans.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    _drawCachedSceneCanvas(context) {
        context.save();
        context._applyOpacity(this);
        context._applyGlobalCompositeOperation(this);
        const canvasCache = this._getCanvasCache();
        context.translate(canvasCache.x, canvasCache.y);
        var cacheCanvas = this._getCachedSceneCanvas();
        var ratio = cacheCanvas.pixelRatio;
        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
        context.restore();
    }
    _drawCachedHitCanvas(context) {
        var canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
        context.save();
        context.translate(canvasCache.x, canvasCache.y);
        context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
        context.restore();
    }
    _getCachedSceneCanvas() {
        var filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
        if (filters) {
            if (!this._filterUpToDate) {
                var ratio = sceneCanvas.pixelRatio;
                filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
                try {
                    len = filters.length;
                    filterContext.clear();
                    filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
                    imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
                    for(n = 0; n < len; n++){
                        filter = filters[n];
                        if (typeof filter !== 'function') {
                            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error('Filter should be type of function, but got ' + typeof filter + ' instead. Please check correct filters');
                            continue;
                        }
                        filter.call(this, imageData);
                        filterContext.putImageData(imageData, 0, 0);
                    }
                } catch (e) {
                    (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error('Unable to apply filter. ' + e.message + ' This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                }
                this._filterUpToDate = true;
            }
            return filterCanvas;
        }
        return sceneCanvas;
    }
    on(evtStr, handler) {
        this._cache && this._cache.delete($ea22cf9e3e585277$var$ALL_LISTENERS);
        if (arguments.length === 3) return this._delegate.apply(this, arguments);
        var events = evtStr.split($ea22cf9e3e585277$var$SPACE), len = events.length, n, event, parts, baseEvent, name;
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1] || '';
            if (!this.eventListeners[baseEvent]) this.eventListeners[baseEvent] = [];
            this.eventListeners[baseEvent].push({
                name: name,
                handler: handler
            });
        }
        return this;
    }
    off(evtStr, callback) {
        var events = (evtStr || '').split($ea22cf9e3e585277$var$SPACE), len = events.length, n, t, event, parts, baseEvent, name;
        this._cache && this._cache.delete($ea22cf9e3e585277$var$ALL_LISTENERS);
        if (!evtStr) for(t in this.eventListeners)this._off(t);
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
                if (this.eventListeners[baseEvent]) this._off(baseEvent, name, callback);
            } else for(t in this.eventListeners)this._off(t, name, callback);
        }
        return this;
    }
    dispatchEvent(evt) {
        var e = {
            target: this,
            type: evt.type,
            evt: evt
        };
        this.fire(evt.type, e);
        return this;
    }
    addEventListener(type, handler) {
        this.on(type, function(evt) {
            handler.call(this, evt.evt);
        });
        return this;
    }
    removeEventListener(type) {
        this.off(type);
        return this;
    }
    _delegate(event, selector, handler) {
        var stopNode = this;
        this.on(event, function(evt) {
            var targets = evt.target.findAncestors(selector, true, stopNode);
            for(var i = 0; i < targets.length; i++){
                evt = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).cloneObject(evt);
                evt.currentTarget = targets[i];
                handler.call(targets[i], evt);
            }
        });
    }
    remove() {
        if (this.isDragging()) this.stopDrag();
        (0, $b5d29c637453a5f5$export$e34f1b340034d7f)._dragElements.delete(this._id);
        this._remove();
        return this;
    }
    _clearCaches() {
        this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$ABSOLUTE_TRANSFORM);
        this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$ABSOLUTE_SCALE);
        this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$STAGE);
        this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$VISIBLE);
        this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$LISTENING);
    }
    _remove() {
        this._clearCaches();
        var parent = this.getParent();
        if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
        }
    }
    destroy() {
        this.remove();
        this.clearCache();
        return this;
    }
    getAttr(attr) {
        var method = 'get' + (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._capitalize(attr);
        if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isFunction(this[method])) return this[method]();
        return this.attrs[attr];
    }
    getAncestors() {
        var parent = this.getParent(), ancestors = [];
        while(parent){
            ancestors.push(parent);
            parent = parent.getParent();
        }
        return ancestors;
    }
    getAttrs() {
        return this.attrs || {};
    }
    setAttrs(config) {
        this._batchTransformChanges(()=>{
            var key, method;
            if (!config) return this;
            for(key in config){
                if (key === $ea22cf9e3e585277$var$CHILDREN) continue;
                method = $ea22cf9e3e585277$var$SET + (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._capitalize(key);
                if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isFunction(this[method])) this[method](config[key]);
                else this._setAttr(key, config[key]);
            }
        });
        return this;
    }
    isListening() {
        return this._getCache($ea22cf9e3e585277$var$LISTENING, this._isListening);
    }
    _isListening(relativeTo) {
        const listening = this.listening();
        if (!listening) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isListening(relativeTo);
        else return true;
    }
    isVisible() {
        return this._getCache($ea22cf9e3e585277$var$VISIBLE, this._isVisible);
    }
    _isVisible(relativeTo) {
        const visible = this.visible();
        if (!visible) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isVisible(relativeTo);
        else return true;
    }
    shouldDrawHit(top, skipDragCheck = false) {
        if (top) return this._isVisible(top) && this._isListening(top);
        var layer = this.getLayer();
        var layerUnderDrag = false;
        (0, $b5d29c637453a5f5$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
            if (elem.dragStatus !== 'dragging') return;
            else if (elem.node.nodeType === 'Stage') layerUnderDrag = true;
            else if (elem.node.getLayer() === layer) layerUnderDrag = true;
        });
        var dragSkip = !skipDragCheck && !(0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).hitOnDragEnabled && layerUnderDrag;
        return this.isListening() && this.isVisible() && !dragSkip;
    }
    show() {
        this.visible(true);
        return this;
    }
    hide() {
        this.visible(false);
        return this;
    }
    getZIndex() {
        return this.index || 0;
    }
    getAbsoluteZIndex() {
        var depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
        function addChildren(children) {
            nodes = [];
            len = children.length;
            for(n = 0; n < len; n++){
                child = children[n];
                index++;
                if (child.nodeType !== $ea22cf9e3e585277$var$SHAPE) nodes = nodes.concat(child.getChildren().slice());
                if (child._id === that._id) n = len;
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) addChildren(nodes);
        }
        if (that.nodeType !== $ea22cf9e3e585277$var$UPPER_STAGE) addChildren(that.getStage().getChildren());
        return index;
    }
    getDepth() {
        var depth = 0, parent = this.parent;
        while(parent){
            depth++;
            parent = parent.parent;
        }
        return depth;
    }
    _batchTransformChanges(func) {
        this._batchingTransformChange = true;
        func();
        this._batchingTransformChange = false;
        if (this._needClearTransformCache) {
            this._clearCache($ea22cf9e3e585277$var$TRANSFORM);
            this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$ABSOLUTE_TRANSFORM);
        }
        this._needClearTransformCache = false;
    }
    setPosition(pos) {
        this._batchTransformChanges(()=>{
            this.x(pos.x);
            this.y(pos.y);
        });
        return this;
    }
    getPosition() {
        return {
            x: this.x(),
            y: this.y()
        };
    }
    getRelativePointerPosition() {
        if (!this.getStage()) return null;
        var pos = this.getStage().getPointerPosition();
        if (!pos) return null;
        var transform = this.getAbsoluteTransform().copy();
        transform.invert();
        return transform.point(pos);
    }
    getAbsolutePosition(top) {
        let haveCachedParent = false;
        let parent = this.parent;
        while(parent){
            if (parent.isCached()) {
                haveCachedParent = true;
                break;
            }
            parent = parent.parent;
        }
        if (haveCachedParent && !top) top = true;
        var absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new (0, $6436c4dfb94cdcf1$export$563a914cafbdc389)(), offset = this.offset();
        absoluteTransform.m = absoluteMatrix.slice();
        absoluteTransform.translate(offset.x, offset.y);
        return absoluteTransform.getTranslation();
    }
    setAbsolutePosition(pos) {
        var origTrans = this._clearTransform();
        this.attrs.x = origTrans.x;
        this.attrs.y = origTrans.y;
        delete origTrans.x;
        delete origTrans.y;
        this._clearCache($ea22cf9e3e585277$var$TRANSFORM);
        var it = this._getAbsoluteTransform().copy();
        it.invert();
        it.translate(pos.x, pos.y);
        pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y
        };
        this._setTransform(origTrans);
        this.setPosition({
            x: pos.x,
            y: pos.y
        });
        this._clearCache($ea22cf9e3e585277$var$TRANSFORM);
        this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$ABSOLUTE_TRANSFORM);
        return this;
    }
    _setTransform(trans) {
        var key;
        for(key in trans)this.attrs[key] = trans[key];
    }
    _clearTransform() {
        var trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
        };
        this.attrs.x = 0;
        this.attrs.y = 0;
        this.attrs.rotation = 0;
        this.attrs.scaleX = 1;
        this.attrs.scaleY = 1;
        this.attrs.offsetX = 0;
        this.attrs.offsetY = 0;
        this.attrs.skewX = 0;
        this.attrs.skewY = 0;
        return trans;
    }
    move(change) {
        var changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
        if (changeX !== undefined) x += changeX;
        if (changeY !== undefined) y += changeY;
        this.setPosition({
            x: x,
            y: y
        });
        return this;
    }
    _eachAncestorReverse(func, top) {
        var family = [], parent = this.getParent(), len, n;
        if (top && top._id === this._id) return;
        family.unshift(this);
        while(parent && (!top || parent._id !== top._id)){
            family.unshift(parent);
            parent = parent.parent;
        }
        len = family.length;
        for(n = 0; n < len; n++)func(family[n]);
    }
    rotate(theta) {
        this.rotation(this.rotation() + theta);
        return this;
    }
    moveToTop() {
        if (!this.parent) {
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Node has no parent. moveToTop function is ignored.');
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveUp() {
        if (!this.parent) {
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Node has no parent. moveUp function is ignored.');
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveDown() {
        if (!this.parent) {
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Node has no parent. moveDown function is ignored.');
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveToBottom() {
        if (!this.parent) {
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Node has no parent. moveToBottom function is ignored.');
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    setZIndex(zIndex) {
        if (!this.parent) {
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Node has no parent. zIndex parameter is ignored.');
            return this;
        }
        if (zIndex < 0 || zIndex >= this.parent.children.length) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Unexpected value ' + zIndex + ' for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to ' + (this.parent.children.length - 1) + '.');
        var index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.splice(zIndex, 0, this);
        this.parent._setChildrenIndices();
        return this;
    }
    getAbsoluteOpacity() {
        return this._getCache($ea22cf9e3e585277$var$ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
        var absOpacity = this.opacity();
        var parent = this.getParent();
        if (parent && !parent._isUnderCache) absOpacity *= parent.getAbsoluteOpacity();
        return absOpacity;
    }
    moveTo(newContainer) {
        if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
        }
        return this;
    }
    toObject() {
        var obj = {}, attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
        obj.attrs = {};
        for(key in attrs){
            val = attrs[key];
            nonPlainObject = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).isObject(val) && !(0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isPlainObject(val) && !(0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isArray(val);
            if (nonPlainObject) continue;
            getter = typeof this[key] === 'function' && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) obj.attrs[key] = val;
        }
        obj.className = this.getClassName();
        return (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._prepareToStringify(obj);
    }
    toJSON() {
        return JSON.stringify(this.toObject());
    }
    getParent() {
        return this.parent;
    }
    findAncestors(selector, includeSelf, stopNode) {
        var res = [];
        if (includeSelf && this._isMatch(selector)) res.push(this);
        var ancestor = this.parent;
        while(ancestor){
            if (ancestor === stopNode) return res;
            if (ancestor._isMatch(selector)) res.push(ancestor);
            ancestor = ancestor.parent;
        }
        return res;
    }
    isAncestorOf(node) {
        return false;
    }
    findAncestor(selector, includeSelf, stopNode) {
        return this.findAncestors(selector, includeSelf, stopNode)[0];
    }
    _isMatch(selector) {
        if (!selector) return false;
        if (typeof selector === 'function') return selector(this);
        var selectorArr = selector.replace(/ /g, '').split(','), len = selectorArr.length, n, sel;
        for(n = 0; n < len; n++){
            sel = selectorArr[n];
            if (!(0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).isValidSelector(sel)) {
                (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Selector "' + sel + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
                (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
                (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Konva is awesome, right?');
            }
            if (sel.charAt(0) === '#') {
                if (this.id() === sel.slice(1)) return true;
            } else if (sel.charAt(0) === '.') {
                if (this.hasName(sel.slice(1))) return true;
            } else if (this.className === sel || this.nodeType === sel) return true;
        }
        return false;
    }
    getLayer() {
        var parent = this.getParent();
        return parent ? parent.getLayer() : null;
    }
    getStage() {
        return this._getCache($ea22cf9e3e585277$var$STAGE, this._getStage);
    }
    _getStage() {
        var parent = this.getParent();
        if (parent) return parent.getStage();
        else return undefined;
    }
    fire(eventType, evt = {}, bubble) {
        evt.target = evt.target || this;
        if (bubble) this._fireAndBubble(eventType, evt);
        else this._fire(eventType, evt);
        return this;
    }
    getAbsoluteTransform(top) {
        if (top) return this._getAbsoluteTransform(top);
        else return this._getCache($ea22cf9e3e585277$var$ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(top) {
        var at;
        if (top) {
            at = new (0, $6436c4dfb94cdcf1$export$563a914cafbdc389)();
            this._eachAncestorReverse(function(node) {
                var transformsEnabled = node.transformsEnabled();
                if (transformsEnabled === 'all') at.multiply(node.getTransform());
                else if (transformsEnabled === 'position') at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
            }, top);
            return at;
        } else {
            at = this._cache.get($ea22cf9e3e585277$var$ABSOLUTE_TRANSFORM) || new (0, $6436c4dfb94cdcf1$export$563a914cafbdc389)();
            if (this.parent) this.parent.getAbsoluteTransform().copyInto(at);
            else at.reset();
            var transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === 'all') at.multiply(this.getTransform());
            else if (transformsEnabled === 'position') {
                const x = this.attrs.x || 0;
                const y = this.attrs.y || 0;
                const offsetX = this.attrs.offsetX || 0;
                const offsetY = this.attrs.offsetY || 0;
                at.translate(x - offsetX, y - offsetY);
            }
            at.dirty = false;
            return at;
        }
    }
    getAbsoluteScale(top) {
        var parent = this;
        while(parent){
            if (parent._isUnderCache) top = parent;
            parent = parent.getParent();
        }
        const transform = this.getAbsoluteTransform(top);
        const attrs = transform.decompose();
        return {
            x: attrs.scaleX,
            y: attrs.scaleY
        };
    }
    getAbsoluteRotation() {
        return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
        return this._getCache($ea22cf9e3e585277$var$TRANSFORM, this._getTransform);
    }
    _getTransform() {
        var _a, _b;
        var m = this._cache.get($ea22cf9e3e585277$var$TRANSFORM) || new (0, $6436c4dfb94cdcf1$export$563a914cafbdc389)();
        m.reset();
        var x = this.x(), y = this.y(), rotation = (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
        if (x !== 0 || y !== 0) m.translate(x, y);
        if (rotation !== 0) m.rotate(rotation);
        if (skewX !== 0 || skewY !== 0) m.skew(skewX, skewY);
        if (scaleX !== 1 || scaleY !== 1) m.scale(scaleX, scaleY);
        if (offsetX !== 0 || offsetY !== 0) m.translate(-1 * offsetX, -1 * offsetY);
        m.dirty = false;
        return m;
    }
    clone(obj) {
        var attrs = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).cloneObject(this.attrs), key, allListeners, len, n, listener;
        for(key in obj)attrs[key] = obj[key];
        var node = new this.constructor(attrs);
        for(key in this.eventListeners){
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for(n = 0; n < len; n++){
                listener = allListeners[n];
                if (listener.name.indexOf($ea22cf9e3e585277$var$KONVA) < 0) {
                    if (!node.eventListeners[key]) node.eventListeners[key] = [];
                    node.eventListeners[key].push(listener);
                }
            }
        }
        return node;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        var box = this.getClientRect();
        var stage = this.getStage(), x = config.x !== undefined ? config.x : Math.floor(box.x), y = config.y !== undefined ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new (0, $91aeecb318ae5dc4$export$ee612225bd2e63be)({
            width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
            height: config.height || Math.ceil(box.height) || (stage ? stage.height() : 0),
            pixelRatio: pixelRatio
        }), context = canvas.getContext();
        if (config.imageSmoothingEnabled === false) context._context.imageSmoothingEnabled = false;
        context.save();
        if (x || y) context.translate(-1 * x, -1 * y);
        this.drawScene(canvas);
        context.restore();
        return canvas;
    }
    toCanvas(config) {
        return this._toKonvaCanvas(config)._canvas;
    }
    toDataURL(config) {
        config = config || {};
        var mimeType = config.mimeType || null, quality = config.quality || null;
        var url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
        if (config.callback) config.callback(url);
        return url;
    }
    toImage(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._urlToImage(this.toDataURL(config), function(img) {
                    resolve(img);
                    callback === null || callback === void 0 || callback(img);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    toBlob(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                this.toCanvas(config).toBlob((blob)=>{
                    resolve(blob);
                    callback === null || callback === void 0 || callback(blob);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    setSize(size) {
        this.width(size.width);
        this.height(size.height);
        return this;
    }
    getSize() {
        return {
            width: this.width(),
            height: this.height()
        };
    }
    getClassName() {
        return this.className || this.nodeType;
    }
    getType() {
        return this.nodeType;
    }
    getDragDistance() {
        if (this.attrs.dragDistance !== undefined) return this.attrs.dragDistance;
        else if (this.parent) return this.parent.getDragDistance();
        else return (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).dragDistance;
    }
    _off(type, name, callback) {
        var evtListeners = this.eventListeners[type], i, evtName, handler;
        for(i = 0; i < evtListeners.length; i++){
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            if ((evtName !== 'konva' || name === 'konva') && (!name || evtName === name) && (!callback || callback === handler)) {
                evtListeners.splice(i, 1);
                if (evtListeners.length === 0) {
                    delete this.eventListeners[type];
                    break;
                }
                i--;
            }
        }
    }
    _fireChangeEvent(attr, oldVal, newVal) {
        this._fire(attr + $ea22cf9e3e585277$var$CHANGE, {
            oldVal: oldVal,
            newVal: newVal
        });
    }
    addName(name) {
        if (!this.hasName(name)) {
            var oldName = this.name();
            var newName = oldName ? oldName + ' ' + name : name;
            this.name(newName);
        }
        return this;
    }
    hasName(name) {
        if (!name) return false;
        const fullName = this.name();
        if (!fullName) return false;
        var names = (fullName || '').split(/\s/g);
        return names.indexOf(name) !== -1;
    }
    removeName(name) {
        var names = (this.name() || '').split(/\s/g);
        var index = names.indexOf(name);
        if (index !== -1) {
            names.splice(index, 1);
            this.name(names.join(' '));
        }
        return this;
    }
    setAttr(attr, val) {
        var func = this[$ea22cf9e3e585277$var$SET + (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._capitalize(attr)];
        if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isFunction(func)) func.call(this, val);
        else this._setAttr(attr, val);
        return this;
    }
    _requestDraw() {
        if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 || drawNode.batchDraw();
        }
    }
    _setAttr(key, val) {
        var oldVal = this.attrs[key];
        if (oldVal === val && !(0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).isObject(val)) return;
        if (val === undefined || val === null) delete this.attrs[key];
        else this.attrs[key] = val;
        if (this._shouldFireChangeEvents) this._fireChangeEvent(key, oldVal, val);
        this._requestDraw();
    }
    _setComponentAttr(key, component, val) {
        var oldVal;
        if (val !== undefined) {
            oldVal = this.attrs[key];
            if (!oldVal) this.attrs[key] = this.getAttr(key);
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
        }
    }
    _fireAndBubble(eventType, evt, compareShape) {
        if (evt && this.nodeType === $ea22cf9e3e585277$var$SHAPE) evt.target = this;
        var shouldStop = (eventType === $ea22cf9e3e585277$var$MOUSEENTER || eventType === $ea22cf9e3e585277$var$MOUSELEAVE) && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === 'Stage' && !compareShape);
        if (!shouldStop) {
            this._fire(eventType, evt);
            var stopBubble = (eventType === $ea22cf9e3e585277$var$MOUSEENTER || eventType === $ea22cf9e3e585277$var$MOUSELEAVE) && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
            if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) {
                if (compareShape && compareShape.parent) this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
                else this._fireAndBubble.call(this.parent, eventType, evt);
            }
        }
    }
    _getProtoListeners(eventType) {
        let listeners = this._cache.get($ea22cf9e3e585277$var$ALL_LISTENERS);
        if (!listeners) {
            listeners = {};
            let obj = Object.getPrototypeOf(this);
            while(obj){
                if (!obj.eventListeners) {
                    obj = Object.getPrototypeOf(obj);
                    continue;
                }
                for(var event in obj.eventListeners){
                    const newEvents = obj.eventListeners[event];
                    const oldEvents = listeners[event] || [];
                    listeners[event] = newEvents.concat(oldEvents);
                }
                obj = Object.getPrototypeOf(obj);
            }
            this._cache.set($ea22cf9e3e585277$var$ALL_LISTENERS, listeners);
        }
        return listeners[eventType];
    }
    _fire(eventType, evt) {
        evt = evt || {};
        evt.currentTarget = this;
        evt.type = eventType;
        const topListeners = this._getProtoListeners(eventType);
        if (topListeners) for(var i = 0; i < topListeners.length; i++)topListeners[i].handler.call(this, evt);
        const selfListeners = this.eventListeners[eventType];
        if (selfListeners) for(var i = 0; i < selfListeners.length; i++)selfListeners[i].handler.call(this, evt);
    }
    draw() {
        this.drawScene();
        this.drawHit();
        return this;
    }
    _createDragElement(evt) {
        var pointerId = evt ? evt.pointerId : undefined;
        var stage = this.getStage();
        var ap = this.getAbsolutePosition();
        var pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
        (0, $b5d29c637453a5f5$export$e34f1b340034d7f)._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
                x: pos.x - ap.x,
                y: pos.y - ap.y
            },
            dragStatus: 'ready',
            pointerId: pointerId
        });
    }
    startDrag(evt, bubbleEvent = true) {
        if (!(0, $b5d29c637453a5f5$export$e34f1b340034d7f)._dragElements.has(this._id)) this._createDragElement(evt);
        const elem = (0, $b5d29c637453a5f5$export$e34f1b340034d7f)._dragElements.get(this._id);
        elem.dragStatus = 'dragging';
        this.fire('dragstart', {
            type: 'dragstart',
            target: this,
            evt: evt && evt.evt
        }, bubbleEvent);
    }
    _setDragPosition(evt, elem) {
        const pos = this.getStage()._getPointerById(elem.pointerId);
        if (!pos) return;
        var newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y
        };
        var dbf = this.dragBoundFunc();
        if (dbf !== undefined) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.');
            else newNodePos = bounded;
        }
        if (!this._lastPos || this._lastPos.x !== newNodePos.x || this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
        }
        this._lastPos = newNodePos;
    }
    stopDrag(evt) {
        const elem = (0, $b5d29c637453a5f5$export$e34f1b340034d7f)._dragElements.get(this._id);
        if (elem) elem.dragStatus = 'stopped';
        (0, $b5d29c637453a5f5$export$e34f1b340034d7f)._endDragBefore(evt);
        (0, $b5d29c637453a5f5$export$e34f1b340034d7f)._endDragAfter(evt);
    }
    setDraggable(draggable) {
        this._setAttr('draggable', draggable);
        this._dragChange();
    }
    isDragging() {
        const elem = (0, $b5d29c637453a5f5$export$e34f1b340034d7f)._dragElements.get(this._id);
        return elem ? elem.dragStatus === 'dragging' : false;
    }
    _listenDrag() {
        this._dragCleanup();
        this.on('mousedown.konva touchstart.konva', function(evt) {
            var shouldCheckButton = evt.evt['button'] !== undefined;
            var canDrag = !shouldCheckButton || (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).dragButtons.indexOf(evt.evt['button']) >= 0;
            if (!canDrag) return;
            if (this.isDragging()) return;
            var hasDraggingChild = false;
            (0, $b5d29c637453a5f5$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
                if (this.isAncestorOf(elem.node)) hasDraggingChild = true;
            });
            if (!hasDraggingChild) this._createDragElement(evt);
        });
    }
    _dragChange() {
        if (this.attrs.draggable) this._listenDrag();
        else {
            this._dragCleanup();
            var stage = this.getStage();
            if (!stage) return;
            const dragElement = (0, $b5d29c637453a5f5$export$e34f1b340034d7f)._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === 'dragging';
            const isReady = dragElement && dragElement.dragStatus === 'ready';
            if (isDragging) this.stopDrag();
            else if (isReady) (0, $b5d29c637453a5f5$export$e34f1b340034d7f)._dragElements.delete(this._id);
        }
    }
    _dragCleanup() {
        this.off('mousedown.konva');
        this.off('touchstart.konva');
    }
    isClientRectOnScreen(margin = {
        x: 0,
        y: 0
    }) {
        const stage = this.getStage();
        if (!stage) return false;
        const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y
        };
        return (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).haveIntersection(screenRect, this.getClientRect());
    }
    static create(data, container) {
        if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isString(data)) data = JSON.parse(data);
        return this._createNode(data, container);
    }
    static _createNode(obj, container) {
        var className = $ea22cf9e3e585277$export$85c928794f8d04d4.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        if (container) obj.attrs.container = container;
        if (!(0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)[className]) {
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Can not find a node with class name "' + className + '". Fallback to "Shape".');
            className = 'Shape';
        }
        const Class = (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)[className];
        no = new Class(obj.attrs);
        if (children) {
            len = children.length;
            for(n = 0; n < len; n++)no.add($ea22cf9e3e585277$export$85c928794f8d04d4._createNode(children[n]));
        }
        return no;
    }
}
$ea22cf9e3e585277$export$85c928794f8d04d4.prototype.nodeType = 'Node';
$ea22cf9e3e585277$export$85c928794f8d04d4.prototype._attrsAffectingSize = [];
$ea22cf9e3e585277$export$85c928794f8d04d4.prototype.eventListeners = {};
$ea22cf9e3e585277$export$85c928794f8d04d4.prototype.on.call($ea22cf9e3e585277$export$85c928794f8d04d4.prototype, $ea22cf9e3e585277$var$TRANSFORM_CHANGE_STR, function() {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = true;
        return;
    }
    this._clearCache($ea22cf9e3e585277$var$TRANSFORM);
    this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$ABSOLUTE_TRANSFORM);
});
$ea22cf9e3e585277$export$85c928794f8d04d4.prototype.on.call($ea22cf9e3e585277$export$85c928794f8d04d4.prototype, 'visibleChange.konva', function() {
    this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$VISIBLE);
});
$ea22cf9e3e585277$export$85c928794f8d04d4.prototype.on.call($ea22cf9e3e585277$export$85c928794f8d04d4.prototype, 'listeningChange.konva', function() {
    this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$LISTENING);
});
$ea22cf9e3e585277$export$85c928794f8d04d4.prototype.on.call($ea22cf9e3e585277$export$85c928794f8d04d4.prototype, 'opacityChange.konva', function() {
    this._clearSelfAndDescendantCache($ea22cf9e3e585277$var$ABSOLUTE_OPACITY);
});
const $ea22cf9e3e585277$var$addGetterSetter = (0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter;
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'zIndex');
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'absolutePosition');
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'position');
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'x', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'y', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'globalCompositeOperation', 'source-over', (0, $2b769617cb7fb124$export$5837c5b6cc5b4d63)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'opacity', 1, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'name', '', (0, $2b769617cb7fb124$export$5837c5b6cc5b4d63)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'id', '', (0, $2b769617cb7fb124$export$5837c5b6cc5b4d63)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'rotation', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'scale', [
    'x',
    'y'
]);
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'scaleX', 1, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'scaleY', 1, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'skew', [
    'x',
    'y'
]);
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'skewX', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'skewY', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'offset', [
    'x',
    'y'
]);
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'offsetX', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'offsetY', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'dragDistance', null, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'width', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'height', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'listening', true, (0, $2b769617cb7fb124$export$147fc8b6cd20fda1)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'preventDefault', true, (0, $2b769617cb7fb124$export$147fc8b6cd20fda1)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'filters', null, function(val) {
    this._filterUpToDate = false;
    return val;
});
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'visible', true, (0, $2b769617cb7fb124$export$147fc8b6cd20fda1)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'transformsEnabled', 'all', (0, $2b769617cb7fb124$export$5837c5b6cc5b4d63)());
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'size');
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'dragBoundFunc');
$ea22cf9e3e585277$var$addGetterSetter($ea22cf9e3e585277$export$85c928794f8d04d4, 'draggable', false, (0, $2b769617cb7fb124$export$147fc8b6cd20fda1)());
(0, $43fd669de4de8956$export$8354032f3852ec50).backCompat($ea22cf9e3e585277$export$85c928794f8d04d4, {
    rotateDeg: 'rotate',
    setRotationDeg: 'setRotation',
    getRotationDeg: 'getRotation'
});





class $1d900f1e946c4516$export$42a852a2b6b56249 extends (0, $ea22cf9e3e585277$export$85c928794f8d04d4) {
    constructor(){
        super(...arguments);
        this.children = [];
    }
    getChildren(filterFunc) {
        if (!filterFunc) return this.children || [];
        const children = this.children || [];
        var results = [];
        children.forEach(function(child) {
            if (filterFunc(child)) results.push(child);
        });
        return results;
    }
    hasChildren() {
        return this.getChildren().length > 0;
    }
    removeChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.remove();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    destroyChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.destroy();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    add(...children) {
        if (children.length === 0) return this;
        if (children.length > 1) {
            for(var i = 0; i < children.length; i++)this.add(children[i]);
            return this;
        }
        const child = children[0];
        if (child.getParent()) {
            child.moveTo(this);
            return this;
        }
        this._validateAdd(child);
        child.index = this.getChildren().length;
        child.parent = this;
        child._clearCaches();
        this.getChildren().push(child);
        this._fire('add', {
            child: child
        });
        this._requestDraw();
        return this;
    }
    destroy() {
        if (this.hasChildren()) this.destroyChildren();
        super.destroy();
        return this;
    }
    find(selector) {
        return this._generalFind(selector, false);
    }
    findOne(selector) {
        var result = this._generalFind(selector, true);
        return result.length > 0 ? result[0] : undefined;
    }
    _generalFind(selector, findOne) {
        var retArr = [];
        this._descendants((node)=>{
            const valid = node._isMatch(selector);
            if (valid) retArr.push(node);
            if (valid && findOne) return true;
            return false;
        });
        return retArr;
    }
    _descendants(fn) {
        let shouldStop = false;
        const children = this.getChildren();
        for (const child of children){
            shouldStop = fn(child);
            if (shouldStop) return true;
            if (!child.hasChildren()) continue;
            shouldStop = child._descendants(fn);
            if (shouldStop) return true;
        }
        return false;
    }
    toObject() {
        var obj = (0, $ea22cf9e3e585277$export$85c928794f8d04d4).prototype.toObject.call(this);
        obj.children = [];
        this.getChildren().forEach((child)=>{
            obj.children.push(child.toObject());
        });
        return obj;
    }
    isAncestorOf(node) {
        var parent = node.getParent();
        while(parent){
            if (parent._id === this._id) return true;
            parent = parent.getParent();
        }
        return false;
    }
    clone(obj) {
        var node = (0, $ea22cf9e3e585277$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        this.getChildren().forEach(function(no) {
            node.add(no.clone());
        });
        return node;
    }
    getAllIntersections(pos) {
        var arr = [];
        this.find('Shape').forEach(function(shape) {
            if (shape.isVisible() && shape.intersects(pos)) arr.push(shape);
        });
        return arr;
    }
    _clearSelfAndDescendantCache(attr) {
        var _a;
        super._clearSelfAndDescendantCache(attr);
        if (this.isCached()) return;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(node) {
            node._clearSelfAndDescendantCache(attr);
        });
    }
    _setChildrenIndices() {
        var _a;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child, n) {
            child.index = n;
        });
        this._requestDraw();
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
        var caching = canvas && canvas.isCache;
        if (!this.isVisible() && !caching) return this;
        if (cachedSceneCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
        } else this._drawChildren('drawScene', canvas, top);
        return this;
    }
    drawHit(can, top) {
        if (!this.shouldDrawHit(top)) return this;
        var layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
        } else this._drawChildren('drawHit', canvas, top);
        return this;
    }
    _drawChildren(drawMethod, canvas, top) {
        var _a;
        var context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = clipWidth && clipHeight || clipFunc;
        const selfCache = top === this;
        if (hasClip) {
            context.save();
            var transform = this.getAbsoluteTransform(top);
            var m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            if (clipFunc) clipFunc.call(this, context, this);
            else {
                var clipX = this.clipX();
                var clipY = this.clipY();
                context.rect(clipX, clipY, clipWidth, clipHeight);
            }
            context.clip();
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        var hasComposition = !selfCache && this.globalCompositeOperation() !== 'source-over' && drawMethod === 'drawScene';
        if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
        }
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            child[drawMethod](canvas, top);
        });
        if (hasComposition) context.restore();
        if (hasClip) context.restore();
    }
    getClientRect(config) {
        var _a;
        config = config || {};
        var skipTransform = config.skipTransform;
        var relativeTo = config.relativeTo;
        var minX, minY, maxX, maxY;
        var selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0
        };
        var that = this;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            if (!child.visible()) return;
            var rect = child.getClientRect({
                relativeTo: that,
                skipShadow: config.skipShadow,
                skipStroke: config.skipStroke
            });
            if (rect.width === 0 && rect.height === 0) return;
            if (minX === undefined) {
                minX = rect.x;
                minY = rect.y;
                maxX = rect.x + rect.width;
                maxY = rect.y + rect.height;
            } else {
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
                maxY = Math.max(maxY, rect.y + rect.height);
            }
        });
        var shapes = this.find('Shape');
        var hasVisible = false;
        for(var i = 0; i < shapes.length; i++){
            var shape = shapes[i];
            if (shape._isVisible(this)) {
                hasVisible = true;
                break;
            }
        }
        if (hasVisible && minX !== undefined) selfRect = {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
        else selfRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (!skipTransform) return this._transformedRect(selfRect, relativeTo);
        return selfRect;
    }
}
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($1d900f1e946c4516$export$42a852a2b6b56249, 'clip', [
    'x',
    'y',
    'width',
    'height'
]);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($1d900f1e946c4516$export$42a852a2b6b56249, 'clipX', undefined, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($1d900f1e946c4516$export$42a852a2b6b56249, 'clipY', undefined, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($1d900f1e946c4516$export$42a852a2b6b56249, 'clipWidth', undefined, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($1d900f1e946c4516$export$42a852a2b6b56249, 'clipHeight', undefined, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($1d900f1e946c4516$export$42a852a2b6b56249, 'clipFunc');









const $411c0a4bd3cb750d$var$Captures = new Map();
const $411c0a4bd3cb750d$var$SUPPORT_POINTER_EVENTS = (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)._global['PointerEvent'] !== undefined;
function $411c0a4bd3cb750d$export$a55e3aaa85f15b00(pointerId) {
    return $411c0a4bd3cb750d$var$Captures.get(pointerId);
}
function $411c0a4bd3cb750d$export$c30017717ce2168e(evt) {
    return {
        evt: evt,
        pointerId: evt.pointerId
    };
}
function $411c0a4bd3cb750d$export$3b42bc7c43025bad(pointerId, shape) {
    return $411c0a4bd3cb750d$var$Captures.get(pointerId) === shape;
}
function $411c0a4bd3cb750d$export$1cab177b65f17c5a(pointerId, shape) {
    $411c0a4bd3cb750d$export$50f687f23c43e4d9(pointerId);
    const stage = shape.getStage();
    if (!stage) return;
    $411c0a4bd3cb750d$var$Captures.set(pointerId, shape);
    if ($411c0a4bd3cb750d$var$SUPPORT_POINTER_EVENTS) shape._fire('gotpointercapture', $411c0a4bd3cb750d$export$c30017717ce2168e(new PointerEvent('gotpointercapture')));
}
function $411c0a4bd3cb750d$export$50f687f23c43e4d9(pointerId, target) {
    const shape = $411c0a4bd3cb750d$var$Captures.get(pointerId);
    if (!shape) return;
    const stage = shape.getStage();
    stage && stage.content;
    $411c0a4bd3cb750d$var$Captures.delete(pointerId);
    if ($411c0a4bd3cb750d$var$SUPPORT_POINTER_EVENTS) shape._fire('lostpointercapture', $411c0a4bd3cb750d$export$c30017717ce2168e(new PointerEvent('lostpointercapture')));
}


var $25b4080d36ce342c$var$STAGE = 'Stage', $25b4080d36ce342c$var$STRING = 'string', $25b4080d36ce342c$var$PX = 'px', $25b4080d36ce342c$var$MOUSEOUT = 'mouseout', $25b4080d36ce342c$var$MOUSELEAVE = 'mouseleave', $25b4080d36ce342c$var$MOUSEOVER = 'mouseover', $25b4080d36ce342c$var$MOUSEENTER = 'mouseenter', $25b4080d36ce342c$var$MOUSEMOVE = 'mousemove', $25b4080d36ce342c$var$MOUSEDOWN = 'mousedown', $25b4080d36ce342c$var$MOUSEUP = 'mouseup', $25b4080d36ce342c$var$POINTERMOVE = 'pointermove', $25b4080d36ce342c$var$POINTERDOWN = 'pointerdown', $25b4080d36ce342c$var$POINTERUP = 'pointerup', $25b4080d36ce342c$var$POINTERCANCEL = 'pointercancel', $25b4080d36ce342c$var$LOSTPOINTERCAPTURE = 'lostpointercapture', $25b4080d36ce342c$var$POINTEROUT = 'pointerout', $25b4080d36ce342c$var$POINTERLEAVE = 'pointerleave', $25b4080d36ce342c$var$POINTEROVER = 'pointerover', $25b4080d36ce342c$var$POINTERENTER = 'pointerenter', $25b4080d36ce342c$var$CONTEXTMENU = 'contextmenu', $25b4080d36ce342c$var$TOUCHSTART = 'touchstart', $25b4080d36ce342c$var$TOUCHEND = 'touchend', $25b4080d36ce342c$var$TOUCHMOVE = 'touchmove', $25b4080d36ce342c$var$TOUCHCANCEL = 'touchcancel', $25b4080d36ce342c$var$WHEEL = 'wheel', $25b4080d36ce342c$var$MAX_LAYERS_NUMBER = 5, $25b4080d36ce342c$var$EVENTS = [
    [
        $25b4080d36ce342c$var$MOUSEENTER,
        '_pointerenter'
    ],
    [
        $25b4080d36ce342c$var$MOUSEDOWN,
        '_pointerdown'
    ],
    [
        $25b4080d36ce342c$var$MOUSEMOVE,
        '_pointermove'
    ],
    [
        $25b4080d36ce342c$var$MOUSEUP,
        '_pointerup'
    ],
    [
        $25b4080d36ce342c$var$MOUSELEAVE,
        '_pointerleave'
    ],
    [
        $25b4080d36ce342c$var$TOUCHSTART,
        '_pointerdown'
    ],
    [
        $25b4080d36ce342c$var$TOUCHMOVE,
        '_pointermove'
    ],
    [
        $25b4080d36ce342c$var$TOUCHEND,
        '_pointerup'
    ],
    [
        $25b4080d36ce342c$var$TOUCHCANCEL,
        '_pointercancel'
    ],
    [
        $25b4080d36ce342c$var$MOUSEOVER,
        '_pointerover'
    ],
    [
        $25b4080d36ce342c$var$WHEEL,
        '_wheel'
    ],
    [
        $25b4080d36ce342c$var$CONTEXTMENU,
        '_contextmenu'
    ],
    [
        $25b4080d36ce342c$var$POINTERDOWN,
        '_pointerdown'
    ],
    [
        $25b4080d36ce342c$var$POINTERMOVE,
        '_pointermove'
    ],
    [
        $25b4080d36ce342c$var$POINTERUP,
        '_pointerup'
    ],
    [
        $25b4080d36ce342c$var$POINTERCANCEL,
        '_pointercancel'
    ],
    [
        $25b4080d36ce342c$var$LOSTPOINTERCAPTURE,
        '_lostpointercapture'
    ]
];
const $25b4080d36ce342c$var$EVENTS_MAP = {
    mouse: {
        [$25b4080d36ce342c$var$POINTEROUT]: $25b4080d36ce342c$var$MOUSEOUT,
        [$25b4080d36ce342c$var$POINTERLEAVE]: $25b4080d36ce342c$var$MOUSELEAVE,
        [$25b4080d36ce342c$var$POINTEROVER]: $25b4080d36ce342c$var$MOUSEOVER,
        [$25b4080d36ce342c$var$POINTERENTER]: $25b4080d36ce342c$var$MOUSEENTER,
        [$25b4080d36ce342c$var$POINTERMOVE]: $25b4080d36ce342c$var$MOUSEMOVE,
        [$25b4080d36ce342c$var$POINTERDOWN]: $25b4080d36ce342c$var$MOUSEDOWN,
        [$25b4080d36ce342c$var$POINTERUP]: $25b4080d36ce342c$var$MOUSEUP,
        [$25b4080d36ce342c$var$POINTERCANCEL]: 'mousecancel',
        pointerclick: 'click',
        pointerdblclick: 'dblclick'
    },
    touch: {
        [$25b4080d36ce342c$var$POINTEROUT]: 'touchout',
        [$25b4080d36ce342c$var$POINTERLEAVE]: 'touchleave',
        [$25b4080d36ce342c$var$POINTEROVER]: 'touchover',
        [$25b4080d36ce342c$var$POINTERENTER]: 'touchenter',
        [$25b4080d36ce342c$var$POINTERMOVE]: $25b4080d36ce342c$var$TOUCHMOVE,
        [$25b4080d36ce342c$var$POINTERDOWN]: $25b4080d36ce342c$var$TOUCHSTART,
        [$25b4080d36ce342c$var$POINTERUP]: $25b4080d36ce342c$var$TOUCHEND,
        [$25b4080d36ce342c$var$POINTERCANCEL]: $25b4080d36ce342c$var$TOUCHCANCEL,
        pointerclick: 'tap',
        pointerdblclick: 'dbltap'
    },
    pointer: {
        [$25b4080d36ce342c$var$POINTEROUT]: $25b4080d36ce342c$var$POINTEROUT,
        [$25b4080d36ce342c$var$POINTERLEAVE]: $25b4080d36ce342c$var$POINTERLEAVE,
        [$25b4080d36ce342c$var$POINTEROVER]: $25b4080d36ce342c$var$POINTEROVER,
        [$25b4080d36ce342c$var$POINTERENTER]: $25b4080d36ce342c$var$POINTERENTER,
        [$25b4080d36ce342c$var$POINTERMOVE]: $25b4080d36ce342c$var$POINTERMOVE,
        [$25b4080d36ce342c$var$POINTERDOWN]: $25b4080d36ce342c$var$POINTERDOWN,
        [$25b4080d36ce342c$var$POINTERUP]: $25b4080d36ce342c$var$POINTERUP,
        [$25b4080d36ce342c$var$POINTERCANCEL]: $25b4080d36ce342c$var$POINTERCANCEL,
        pointerclick: 'pointerclick',
        pointerdblclick: 'pointerdblclick'
    }
};
const $25b4080d36ce342c$var$getEventType = (type)=>{
    if (type.indexOf('pointer') >= 0) return 'pointer';
    if (type.indexOf('touch') >= 0) return 'touch';
    return 'mouse';
};
const $25b4080d36ce342c$var$getEventsMap = (eventType)=>{
    const type = $25b4080d36ce342c$var$getEventType(eventType);
    if (type === 'pointer') return (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).pointerEventsEnabled && $25b4080d36ce342c$var$EVENTS_MAP.pointer;
    if (type === 'touch') return $25b4080d36ce342c$var$EVENTS_MAP.touch;
    if (type === 'mouse') return $25b4080d36ce342c$var$EVENTS_MAP.mouse;
};
function $25b4080d36ce342c$var$checkNoClip(attrs = {}) {
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Stage does not support clipping. Please use clip for Layers or Groups.');
    return attrs;
}
const $25b4080d36ce342c$var$NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
const $25b4080d36ce342c$export$1bfcff8d7c4bf05 = [];
class $25b4080d36ce342c$export$208cd1682bd0e4b6 extends (0, $1d900f1e946c4516$export$42a852a2b6b56249) {
    constructor(config){
        super($25b4080d36ce342c$var$checkNoClip(config));
        this._pointerPositions = [];
        this._changedPointerPositions = [];
        this._buildDOM();
        this._bindContentEvents();
        $25b4080d36ce342c$export$1bfcff8d7c4bf05.push(this);
        this.on('widthChange.konva heightChange.konva', this._resizeDOM);
        this.on('visibleChange.konva', this._checkVisibility);
        this.on('clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva', ()=>{
            $25b4080d36ce342c$var$checkNoClip(this.attrs);
        });
        this._checkVisibility();
    }
    _validateAdd(child) {
        const isLayer = child.getType() === 'Layer';
        const isFastLayer = child.getType() === 'FastLayer';
        const valid = isLayer || isFastLayer;
        if (!valid) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).throw('You may only add layers to the stage.');
    }
    _checkVisibility() {
        if (!this.content) return;
        const style = this.visible() ? '' : 'none';
        this.content.style.display = style;
    }
    setContainer(container) {
        if (typeof container === $25b4080d36ce342c$var$STRING) {
            if (container.charAt(0) === '.') {
                var className = container.slice(1);
                container = document.getElementsByClassName(className)[0];
            } else {
                var id;
                if (container.charAt(0) !== '#') id = container;
                else id = container.slice(1);
                container = document.getElementById(id);
            }
            if (!container) throw 'Can not find container in document with id ' + id;
        }
        this._setAttr('container', container);
        if (this.content) {
            if (this.content.parentElement) this.content.parentElement.removeChild(this.content);
            container.appendChild(this.content);
        }
        return this;
    }
    shouldDrawHit() {
        return true;
    }
    clear() {
        var layers = this.children, len = layers.length, n;
        for(n = 0; n < len; n++)layers[n].clear();
        return this;
    }
    clone(obj) {
        if (!obj) obj = {};
        obj.container = typeof document !== 'undefined' && document.createElement('div');
        return (0, $1d900f1e946c4516$export$42a852a2b6b56249).prototype.clone.call(this, obj);
    }
    destroy() {
        super.destroy();
        var content = this.content;
        if (content && (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isInDocument(content)) this.container().removeChild(content);
        var index = $25b4080d36ce342c$export$1bfcff8d7c4bf05.indexOf(this);
        if (index > -1) $25b4080d36ce342c$export$1bfcff8d7c4bf05.splice(index, 1);
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
        return this;
    }
    getPointerPosition() {
        const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
        if (!pos) {
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn($25b4080d36ce342c$var$NO_POINTERS_MESSAGE);
            return null;
        }
        return {
            x: pos.x,
            y: pos.y
        };
    }
    _getPointerById(id) {
        return this._pointerPositions.find((p)=>p.id === id);
    }
    getPointersPositions() {
        return this._pointerPositions;
    }
    getStage() {
        return this;
    }
    getContent() {
        return this.content;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.x = config.x || 0;
        config.y = config.y || 0;
        config.width = config.width || this.width();
        config.height = config.height || this.height();
        var canvas = new (0, $91aeecb318ae5dc4$export$ee612225bd2e63be)({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1
        });
        var _context = canvas.getContext()._context;
        var layers = this.children;
        if (config.x || config.y) _context.translate(-1 * config.x, -1 * config.y);
        layers.forEach(function(layer) {
            if (!layer.isVisible()) return;
            var layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
        });
        return canvas;
    }
    getIntersection(pos) {
        if (!pos) return null;
        var layers = this.children, len = layers.length, end = len - 1, n;
        for(n = end; n >= 0; n--){
            const shape = layers[n].getIntersection(pos);
            if (shape) return shape;
        }
        return null;
    }
    _resizeDOM() {
        var width = this.width();
        var height = this.height();
        if (this.content) {
            this.content.style.width = width + $25b4080d36ce342c$var$PX;
            this.content.style.height = height + $25b4080d36ce342c$var$PX;
        }
        this.bufferCanvas.setSize(width, height);
        this.bufferHitCanvas.setSize(width, height);
        this.children.forEach((layer)=>{
            layer.setSize({
                width: width,
                height: height
            });
            layer.draw();
        });
    }
    add(layer, ...rest) {
        if (arguments.length > 1) {
            for(var i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        super.add(layer);
        var length = this.children.length;
        if (length > $25b4080d36ce342c$var$MAX_LAYERS_NUMBER) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('The stage has ' + length + ' layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.');
        layer.setSize({
            width: this.width(),
            height: this.height()
        });
        layer.draw();
        if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isBrowser) this.content.appendChild(layer.canvas._canvas);
        return this;
    }
    getParent() {
        return null;
    }
    getLayer() {
        return null;
    }
    hasPointerCapture(pointerId) {
        return $411c0a4bd3cb750d$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $411c0a4bd3cb750d$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $411c0a4bd3cb750d$export$50f687f23c43e4d9(pointerId, this);
    }
    getLayers() {
        return this.children;
    }
    _bindContentEvents() {
        if (!(0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isBrowser) return;
        $25b4080d36ce342c$var$EVENTS.forEach(([event, methodName])=>{
            this.content.addEventListener(event, (evt)=>{
                this[methodName](evt);
            }, {
                passive: false
            });
        });
    }
    _pointerenter(evt) {
        this.setPointersPositions(evt);
        const events = $25b4080d36ce342c$var$getEventsMap(evt.type);
        this._fire(events.pointerenter, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointerover(evt) {
        this.setPointersPositions(evt);
        const events = $25b4080d36ce342c$var$getEventsMap(evt.type);
        this._fire(events.pointerover, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _getTargetShape(evenType) {
        let shape = this[evenType + 'targetShape'];
        if (shape && !shape.getStage()) shape = null;
        return shape;
    }
    _pointerleave(evt) {
        const events = $25b4080d36ce342c$var$getEventsMap(evt.type);
        const eventType = $25b4080d36ce342c$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        var targetShape = this._getTargetShape(eventType);
        var eventsEnabled = !(0, $b5d29c637453a5f5$export$e34f1b340034d7f).isDragging || (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).hitOnDragEnabled;
        if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, {
                evt: evt
            });
            targetShape._fireAndBubble(events.pointerleave, {
                evt: evt
            });
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this[eventType + 'targetShape'] = null;
        } else if (eventsEnabled) {
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this._fire(events.pointerout, {
                evt: evt,
                target: this,
                currentTarget: this
            });
        }
        this.pointerPos = undefined;
        this._pointerPositions = [];
    }
    _pointerdown(evt) {
        const events = $25b4080d36ce342c$var$getEventsMap(evt.type);
        const eventType = $25b4080d36ce342c$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        var triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            var shape = this.getIntersection(pos);
            (0, $b5d29c637453a5f5$export$e34f1b340034d7f).justDragged = false;
            (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)['_' + eventType + 'ListenClick'] = true;
            const hasShape = shape && shape.isListening();
            if (!hasShape) return;
            if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).capturePointerEventsEnabled) shape.setPointerCapture(pos.id);
            this[eventType + 'ClickStartShape'] = shape;
            shape._fireAndBubble(events.pointerdown, {
                evt: evt,
                pointerId: pos.id
            });
            triggeredOnShape = true;
            const isTouch = evt.type.indexOf('touch') >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) evt.preventDefault();
        });
        if (!triggeredOnShape) this._fire(events.pointerdown, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._pointerPositions[0].id
        });
    }
    _pointermove(evt) {
        const events = $25b4080d36ce342c$var$getEventsMap(evt.type);
        const eventType = $25b4080d36ce342c$var$getEventType(evt.type);
        if (!events) return;
        if ((0, $b5d29c637453a5f5$export$e34f1b340034d7f).isDragging && (0, $b5d29c637453a5f5$export$e34f1b340034d7f).node.preventDefault() && evt.cancelable) evt.preventDefault();
        this.setPointersPositions(evt);
        var eventsEnabled = !(0, $b5d29c637453a5f5$export$e34f1b340034d7f).isDragging || (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).hitOnDragEnabled;
        if (!eventsEnabled) return;
        var processedShapesIds = {};
        let triggeredOnShape = false;
        var targetShape = this._getTargetShape(eventType);
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $411c0a4bd3cb750d$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            var differentTarget = targetShape !== shape;
            if (differentTarget && targetShape) {
                targetShape._fireAndBubble(events.pointerout, Object.assign({}, event), shape);
                targetShape._fireAndBubble(events.pointerleave, Object.assign({}, event), shape);
            }
            if (shape) {
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                if (differentTarget) {
                    shape._fireAndBubble(events.pointerover, Object.assign({}, event), targetShape);
                    shape._fireAndBubble(events.pointerenter, Object.assign({}, event), targetShape);
                    this[eventType + 'targetShape'] = shape;
                }
                shape._fireAndBubble(events.pointermove, Object.assign({}, event));
            } else if (targetShape) {
                this._fire(events.pointerover, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                this[eventType + 'targetShape'] = null;
            }
        });
        if (!triggeredOnShape) this._fire(events.pointermove, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
    }
    _pointerup(evt) {
        const events = $25b4080d36ce342c$var$getEventsMap(evt.type);
        const eventType = $25b4080d36ce342c$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const clickStartShape = this[eventType + 'ClickStartShape'];
        const clickEndShape = this[eventType + 'ClickEndShape'];
        var processedShapesIds = {};
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $411c0a4bd3cb750d$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            if (shape) {
                shape.releaseCapture(pos.id);
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            let fireDblClick = false;
            if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)['_' + eventType + 'InDblClickWindow']) {
                fireDblClick = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            } else if (!(0, $b5d29c637453a5f5$export$e34f1b340034d7f).justDragged) {
                (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)['_' + eventType + 'InDblClickWindow'] = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            }
            this[eventType + 'DblTimeout'] = setTimeout(function() {
                (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)['_' + eventType + 'InDblClickWindow'] = false;
            }, (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).dblClickWindow);
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                this[eventType + 'ClickEndShape'] = shape;
                shape._fireAndBubble(events.pointerup, Object.assign({}, event));
                if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)['_' + eventType + 'ListenClick'] && clickStartShape && clickStartShape === shape) {
                    shape._fireAndBubble(events.pointerclick, Object.assign({}, event));
                    if (fireDblClick && clickEndShape && clickEndShape === shape) shape._fireAndBubble(events.pointerdblclick, Object.assign({}, event));
                }
            } else {
                this[eventType + 'ClickEndShape'] = null;
                if ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)['_' + eventType + 'ListenClick']) this._fire(events.pointerclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                if (fireDblClick) this._fire(events.pointerdblclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
            }
        });
        if (!triggeredOnShape) this._fire(events.pointerup, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
        (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)['_' + eventType + 'ListenClick'] = false;
        if (evt.cancelable && eventType !== 'touch') evt.preventDefault();
    }
    _contextmenu(evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($25b4080d36ce342c$var$CONTEXTMENU, {
            evt: evt
        });
        else this._fire($25b4080d36ce342c$var$CONTEXTMENU, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _wheel(evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($25b4080d36ce342c$var$WHEEL, {
            evt: evt
        });
        else this._fire($25b4080d36ce342c$var$WHEEL, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointercancel(evt) {
        this.setPointersPositions(evt);
        const shape = $411c0a4bd3cb750d$export$a55e3aaa85f15b00(evt.pointerId) || this.getIntersection(this.getPointerPosition());
        if (shape) shape._fireAndBubble($25b4080d36ce342c$var$POINTERUP, $411c0a4bd3cb750d$export$c30017717ce2168e(evt));
        $411c0a4bd3cb750d$export$50f687f23c43e4d9(evt.pointerId);
    }
    _lostpointercapture(evt) {
        $411c0a4bd3cb750d$export$50f687f23c43e4d9(evt.pointerId);
    }
    setPointersPositions(evt) {
        var contentPosition = this._getContentPosition(), x = null, y = null;
        evt = evt ? evt : window.event;
        if (evt.touches !== undefined) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch)=>{
                this._pointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch)=>{
                this._changedPointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
        } else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
                x: x,
                y: y
            };
            this._pointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
            this._changedPointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
        }
    }
    _setPointerPosition(evt) {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
        this.setPointersPositions(evt);
    }
    _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect) return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
        };
        var rect = this.content.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1
        };
    }
    _buildDOM() {
        this.bufferCanvas = new (0, $91aeecb318ae5dc4$export$ee612225bd2e63be)({
            width: this.width(),
            height: this.height()
        });
        this.bufferHitCanvas = new (0, $91aeecb318ae5dc4$export$43a2e1456e27dc84)({
            pixelRatio: 1,
            width: this.width(),
            height: this.height()
        });
        if (!(0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).isBrowser) return;
        var container = this.container();
        if (!container) throw 'Stage has no container. A container is required.';
        container.innerHTML = '';
        this.content = document.createElement('div');
        this.content.style.position = 'relative';
        this.content.style.userSelect = 'none';
        this.content.className = 'konvajs-content';
        this.content.setAttribute('role', 'presentation');
        container.appendChild(this.content);
        this._resizeDOM();
    }
    cache() {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.');
        return this;
    }
    clearCache() {
        return this;
    }
    batchDraw() {
        this.getChildren().forEach(function(layer) {
            layer.batchDraw();
        });
        return this;
    }
}
$25b4080d36ce342c$export$208cd1682bd0e4b6.prototype.nodeType = $25b4080d36ce342c$var$STAGE;
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($25b4080d36ce342c$export$208cd1682bd0e4b6);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($25b4080d36ce342c$export$208cd1682bd0e4b6, 'container');














var $7579e2aa10cffa16$var$HAS_SHADOW = 'hasShadow';
var $7579e2aa10cffa16$var$SHADOW_RGBA = 'shadowRGBA';
var $7579e2aa10cffa16$var$patternImage = 'patternImage';
var $7579e2aa10cffa16$var$linearGradient = 'linearGradient';
var $7579e2aa10cffa16$var$radialGradient = 'radialGradient';
let $7579e2aa10cffa16$var$dummyContext;
function $7579e2aa10cffa16$var$getDummyContext() {
    if ($7579e2aa10cffa16$var$dummyContext) return $7579e2aa10cffa16$var$dummyContext;
    $7579e2aa10cffa16$var$dummyContext = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).createCanvasElement().getContext('2d');
    return $7579e2aa10cffa16$var$dummyContext;
}
const $7579e2aa10cffa16$export$4ff7fc6f1af248b5 = {};
function $7579e2aa10cffa16$var$_fillFunc(context) {
    context.fill();
}
function $7579e2aa10cffa16$var$_strokeFunc(context) {
    context.stroke();
}
function $7579e2aa10cffa16$var$_fillFuncHit(context) {
    context.fill();
}
function $7579e2aa10cffa16$var$_strokeFuncHit(context) {
    context.stroke();
}
function $7579e2aa10cffa16$var$_clearHasShadowCache() {
    this._clearCache($7579e2aa10cffa16$var$HAS_SHADOW);
}
function $7579e2aa10cffa16$var$_clearGetShadowRGBACache() {
    this._clearCache($7579e2aa10cffa16$var$SHADOW_RGBA);
}
function $7579e2aa10cffa16$var$_clearFillPatternCache() {
    this._clearCache($7579e2aa10cffa16$var$patternImage);
}
function $7579e2aa10cffa16$var$_clearLinearGradientCache() {
    this._clearCache($7579e2aa10cffa16$var$linearGradient);
}
function $7579e2aa10cffa16$var$_clearRadialGradientCache() {
    this._clearCache($7579e2aa10cffa16$var$radialGradient);
}
class $7579e2aa10cffa16$export$6428a7f2611ef1fa extends (0, $ea22cf9e3e585277$export$85c928794f8d04d4) {
    constructor(config){
        super(config);
        let key;
        while(true){
            key = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).getRandomColor();
            if (key && !(key in $7579e2aa10cffa16$export$4ff7fc6f1af248b5)) break;
        }
        this.colorKey = key;
        $7579e2aa10cffa16$export$4ff7fc6f1af248b5[key] = this;
    }
    getContext() {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('shape.getContext() method is deprecated. Please do not use it.');
        return this.getLayer().getContext();
    }
    getCanvas() {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('shape.getCanvas() method is deprecated. Please do not use it.');
        return this.getLayer().getCanvas();
    }
    getSceneFunc() {
        return this.attrs.sceneFunc || this['_sceneFunc'];
    }
    getHitFunc() {
        return this.attrs.hitFunc || this['_hitFunc'];
    }
    hasShadow() {
        return this._getCache($7579e2aa10cffa16$var$HAS_SHADOW, this._hasShadow);
    }
    _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
    }
    _getFillPattern() {
        return this._getCache($7579e2aa10cffa16$var$patternImage, this.__getFillPattern);
    }
    __getFillPattern() {
        if (this.fillPatternImage()) {
            var ctx = $7579e2aa10cffa16$var$getDummyContext();
            const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || 'repeat');
            if (pattern && pattern.setTransform) {
                const tr = new (0, $6436c4dfb94cdcf1$export$563a914cafbdc389)();
                tr.translate(this.fillPatternX(), this.fillPatternY());
                tr.rotate((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(this.fillPatternRotation()));
                tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
                tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
                const m = tr.getMatrix();
                const matrix = typeof DOMMatrix === 'undefined' ? {
                    a: m[0],
                    b: m[1],
                    c: m[2],
                    d: m[3],
                    e: m[4],
                    f: m[5]
                } : new DOMMatrix(m);
                pattern.setTransform(matrix);
            }
            return pattern;
        }
    }
    _getLinearGradient() {
        return this._getCache($7579e2aa10cffa16$var$linearGradient, this.__getLinearGradient);
    }
    __getLinearGradient() {
        var colorStops = this.fillLinearGradientColorStops();
        if (colorStops) {
            var ctx = $7579e2aa10cffa16$var$getDummyContext();
            var start = this.fillLinearGradientStartPoint();
            var end = this.fillLinearGradientEndPoint();
            var grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    _getRadialGradient() {
        return this._getCache($7579e2aa10cffa16$var$radialGradient, this.__getRadialGradient);
    }
    __getRadialGradient() {
        var colorStops = this.fillRadialGradientColorStops();
        if (colorStops) {
            var ctx = $7579e2aa10cffa16$var$getDummyContext();
            var start = this.fillRadialGradientStartPoint();
            var end = this.fillRadialGradientEndPoint();
            var grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    getShadowRGBA() {
        return this._getCache($7579e2aa10cffa16$var$SHADOW_RGBA, this._getShadowRGBA);
    }
    _getShadowRGBA() {
        if (!this.hasShadow()) return;
        var rgba = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).colorToRGBA(this.shadowColor());
        if (rgba) return 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a * (this.shadowOpacity() || 1) + ')';
    }
    hasFill() {
        return this._calculate('hasFill', [
            'fillEnabled',
            'fill',
            'fillPatternImage',
            'fillLinearGradientColorStops',
            'fillRadialGradientColorStops'
        ], ()=>{
            return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
        });
    }
    hasStroke() {
        return this._calculate('hasStroke', [
            'strokeEnabled',
            'strokeWidth',
            'stroke',
            'strokeLinearGradientColorStops'
        ], ()=>{
            return this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops());
        });
    }
    hasHitStroke() {
        const width = this.hitStrokeWidth();
        if (width === 'auto') return this.hasStroke();
        return this.strokeEnabled() && !!width;
    }
    intersects(point) {
        var stage = this.getStage(), bufferHitCanvas = stage.bufferHitCanvas, p;
        bufferHitCanvas.getContext().clear();
        this.drawHit(bufferHitCanvas, null, true);
        p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
        return p[3] > 0;
    }
    destroy() {
        (0, $ea22cf9e3e585277$export$85c928794f8d04d4).prototype.destroy.call(this);
        delete $7579e2aa10cffa16$export$4ff7fc6f1af248b5[this.colorKey];
        delete this.colorKey;
        return this;
    }
    _useBufferCanvas(forceFill) {
        var _a;
        if (!this.getStage()) return false;
        const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
        if (!perfectDrawEnabled) return false;
        const hasFill = forceFill || this.hasFill();
        const hasStroke = this.hasStroke();
        const isTransparent = this.getAbsoluteOpacity() !== 1;
        if (hasFill && hasStroke && isTransparent) return true;
        const hasShadow = this.hasShadow();
        const strokeForShadow = this.shadowForStrokeEnabled();
        if (hasFill && hasStroke && hasShadow && strokeForShadow) return true;
        return false;
    }
    setStrokeHitEnabled(val) {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.');
        if (val) this.hitStrokeWidth('auto');
        else this.hitStrokeWidth(0);
    }
    getStrokeHitEnabled() {
        if (this.hitStrokeWidth() === 0) return false;
        else return true;
    }
    getSelfRect() {
        var size = this.size();
        return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height
        };
    }
    getClientRect(config = {}) {
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo;
        const fillRect = this.getSelfRect();
        const applyStroke = !config.skipStroke && this.hasStroke();
        const strokeWidth = applyStroke && this.strokeWidth() || 0;
        const fillAndStrokeWidth = fillRect.width + strokeWidth;
        const fillAndStrokeHeight = fillRect.height + strokeWidth;
        const applyShadow = !config.skipShadow && this.hasShadow();
        const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
        const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
        const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
        const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
        const blurRadius = applyShadow && this.shadowBlur() || 0;
        const width = preWidth + blurRadius * 2;
        const height = preHeight + blurRadius * 2;
        const rect = {
            width: width,
            height: height,
            x: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetX, 0) + fillRect.x,
            y: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetY, 0) + fillRect.y
        };
        if (!skipTransform) return this._transformedRect(rect, relativeTo);
        return rect;
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow(), stage, bufferCanvas, bufferContext;
        var skipBuffer = canvas.isCache;
        var cachingSelf = top === this;
        if (!this.isVisible() && !cachingSelf) return this;
        if (cachedCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        if (this._useBufferCanvas() && !skipBuffer) {
            stage = this.getStage();
            bufferCanvas = stage.bufferCanvas;
            bufferContext = bufferCanvas.getContext();
            bufferContext.clear();
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            var o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            var ratio = bufferCanvas.pixelRatio;
            if (hasShadow) context._applyShadow(this);
            context._applyOpacity(this);
            context._applyGlobalCompositeOperation(this);
            context.drawImage(bufferCanvas._canvas, 0, 0, bufferCanvas.width / ratio, bufferCanvas.height / ratio);
        } else {
            context._applyLineJoin(this);
            if (!cachingSelf) {
                var o = this.getAbsoluteTransform(top).getMatrix();
                context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) context._applyShadow(this);
            drawFunc.call(this, context, this);
        }
        context.restore();
        return this;
    }
    drawHit(can, top, skipDragCheck = false) {
        if (!this.shouldDrawHit(top, skipDragCheck)) return this;
        var layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (!this.colorKey) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()');
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        context._applyLineJoin(this);
        const selfCache = this === top;
        if (!selfCache) {
            var o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
        drawFunc.call(this, context, this);
        context.restore();
        return this;
    }
    drawHitFromCache(alphaThreshold = 0) {
        var cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight(), hitImageData, hitData, len, rgbColorKey, i, alpha;
        hitContext.clear();
        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
        try {
            hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            hitData = hitImageData.data;
            len = hitData.length;
            rgbColorKey = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._hexToRgb(this.colorKey);
            for(i = 0; i < len; i += 4){
                alpha = hitData[i + 3];
                if (alpha > alphaThreshold) {
                    hitData[i] = rgbColorKey.r;
                    hitData[i + 1] = rgbColorKey.g;
                    hitData[i + 2] = rgbColorKey.b;
                    hitData[i + 3] = 255;
                } else hitData[i + 3] = 0;
            }
            hitContext.putImageData(hitImageData, 0, 0);
        } catch (e) {
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error('Unable to draw hit graph from cached scene canvas. ' + e.message);
        }
        return this;
    }
    hasPointerCapture(pointerId) {
        return $411c0a4bd3cb750d$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $411c0a4bd3cb750d$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $411c0a4bd3cb750d$export$50f687f23c43e4d9(pointerId, this);
    }
}
$7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype._fillFunc = $7579e2aa10cffa16$var$_fillFunc;
$7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype._strokeFunc = $7579e2aa10cffa16$var$_strokeFunc;
$7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype._fillFuncHit = $7579e2aa10cffa16$var$_fillFuncHit;
$7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype._strokeFuncHit = $7579e2aa10cffa16$var$_strokeFuncHit;
$7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype._centroid = false;
$7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype.nodeType = 'Shape';
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($7579e2aa10cffa16$export$6428a7f2611ef1fa);
$7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype.eventListeners = {};
$7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype.on.call($7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype, 'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $7579e2aa10cffa16$var$_clearHasShadowCache);
$7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype.on.call($7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype, 'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $7579e2aa10cffa16$var$_clearGetShadowRGBACache);
$7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype.on.call($7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype, 'fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva', $7579e2aa10cffa16$var$_clearFillPatternCache);
$7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype.on.call($7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype, 'fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva', $7579e2aa10cffa16$var$_clearLinearGradientCache);
$7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype.on.call($7579e2aa10cffa16$export$6428a7f2611ef1fa.prototype, 'fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva', $7579e2aa10cffa16$var$_clearRadialGradientCache);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'stroke', undefined, (0, $2b769617cb7fb124$export$9c72f966a828cc68)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'strokeWidth', 2, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillAfterStrokeEnabled', false);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'hitStrokeWidth', 'auto', (0, $2b769617cb7fb124$export$3b7df2720ef33404)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'strokeHitEnabled', true, (0, $2b769617cb7fb124$export$147fc8b6cd20fda1)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'perfectDrawEnabled', true, (0, $2b769617cb7fb124$export$147fc8b6cd20fda1)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'shadowForStrokeEnabled', true, (0, $2b769617cb7fb124$export$147fc8b6cd20fda1)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'lineJoin');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'lineCap');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'sceneFunc');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'hitFunc');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'dash');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'dashOffset', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'shadowColor', undefined, (0, $2b769617cb7fb124$export$5837c5b6cc5b4d63)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'shadowBlur', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'shadowOpacity', 1, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'shadowOffset', [
    'x',
    'y'
]);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'shadowOffsetX', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'shadowOffsetY', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillPatternImage');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fill', undefined, (0, $2b769617cb7fb124$export$9c72f966a828cc68)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillPatternX', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillPatternY', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillLinearGradientColorStops');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'strokeLinearGradientColorStops');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillRadialGradientStartRadius', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillRadialGradientEndRadius', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillRadialGradientColorStops');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillPatternRepeat', 'repeat');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillEnabled', true);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'strokeEnabled', true);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'shadowEnabled', true);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'dashEnabled', true);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'strokeScaleEnabled', true);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillPriority', 'color');
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillPatternOffset', [
    'x',
    'y'
]);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillPatternOffsetX', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillPatternOffsetY', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillPatternScale', [
    'x',
    'y'
]);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillPatternScaleX', 1, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillPatternScaleY', 1, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillLinearGradientStartPoint', [
    'x',
    'y'
]);
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPoint', [
    'x',
    'y'
]);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillLinearGradientStartPointX', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPointX', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillLinearGradientStartPointY', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPointY', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillLinearGradientEndPoint', [
    'x',
    'y'
]);
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPoint', [
    'x',
    'y'
]);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillLinearGradientEndPointX', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPointX', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillLinearGradientEndPointY', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPointY', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillRadialGradientStartPoint', [
    'x',
    'y'
]);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillRadialGradientStartPointX', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillRadialGradientStartPointY', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillRadialGradientEndPoint', [
    'x',
    'y'
]);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillRadialGradientEndPointX', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillRadialGradientEndPointY', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($7579e2aa10cffa16$export$6428a7f2611ef1fa, 'fillPatternRotation', 0);
(0, $43fd669de4de8956$export$8354032f3852ec50).backCompat($7579e2aa10cffa16$export$6428a7f2611ef1fa, {
    dashArray: 'dash',
    getDashArray: 'getDash',
    setDashArray: 'getDash',
    drawFunc: 'sceneFunc',
    getDrawFunc: 'getSceneFunc',
    setDrawFunc: 'setSceneFunc',
    drawHitFunc: 'hitFunc',
    getDrawHitFunc: 'getHitFunc',
    setDrawHitFunc: 'setHitFunc'
});



var $6477a7be7f053ca2$var$HASH = '#', $6477a7be7f053ca2$var$BEFORE_DRAW = 'beforeDraw', $6477a7be7f053ca2$var$DRAW = 'draw', $6477a7be7f053ca2$var$INTERSECTION_OFFSETS = [
    {
        x: 0,
        y: 0
    },
    {
        x: -1,
        y: -1
    },
    {
        x: 1,
        y: -1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    }
], $6477a7be7f053ca2$var$INTERSECTION_OFFSETS_LEN = $6477a7be7f053ca2$var$INTERSECTION_OFFSETS.length;
class $6477a7be7f053ca2$export$936d0764594b6eb3 extends (0, $1d900f1e946c4516$export$42a852a2b6b56249) {
    constructor(config){
        super(config);
        this.canvas = new (0, $91aeecb318ae5dc4$export$ee612225bd2e63be)();
        this.hitCanvas = new (0, $91aeecb318ae5dc4$export$43a2e1456e27dc84)({
            pixelRatio: 1
        });
        this._waitingForDraw = false;
        this.on('visibleChange.konva', this._checkVisibility);
        this._checkVisibility();
        this.on('imageSmoothingEnabledChange.konva', this._setSmoothEnabled);
        this._setSmoothEnabled();
    }
    createPNGStream() {
        const c = this.canvas._canvas;
        return c.createPNGStream();
    }
    getCanvas() {
        return this.canvas;
    }
    getNativeCanvasElement() {
        return this.canvas._canvas;
    }
    getHitCanvas() {
        return this.hitCanvas;
    }
    getContext() {
        return this.getCanvas().getContext();
    }
    clear(bounds) {
        this.getContext().clear(bounds);
        this.getHitCanvas().getContext().clear(bounds);
        return this;
    }
    setZIndex(index) {
        super.setZIndex(index);
        var stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            else stage.content.appendChild(this.getNativeCanvasElement());
        }
        return this;
    }
    moveToTop() {
        (0, $ea22cf9e3e585277$export$85c928794f8d04d4).prototype.moveToTop.call(this);
        var stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
        }
        return true;
    }
    moveUp() {
        var moved = (0, $ea22cf9e3e585277$export$85c928794f8d04d4).prototype.moveUp.call(this);
        if (!moved) return false;
        var stage = this.getStage();
        if (!stage || !stage.content) return false;
        stage.content.removeChild(this.getNativeCanvasElement());
        if (this.index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
        else stage.content.appendChild(this.getNativeCanvasElement());
        return true;
    }
    moveDown() {
        if ((0, $ea22cf9e3e585277$export$85c928794f8d04d4).prototype.moveDown.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    moveToBottom() {
        if ((0, $ea22cf9e3e585277$export$85c928794f8d04d4).prototype.moveToBottom.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    getLayer() {
        return this;
    }
    remove() {
        var _canvas = this.getNativeCanvasElement();
        (0, $ea22cf9e3e585277$export$85c928794f8d04d4).prototype.remove.call(this);
        if (_canvas && _canvas.parentNode && (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isInDocument(_canvas)) _canvas.parentNode.removeChild(_canvas);
        return this;
    }
    getStage() {
        return this.parent;
    }
    setSize({ width: width, height: height }) {
        this.canvas.setSize(width, height);
        this.hitCanvas.setSize(width, height);
        this._setSmoothEnabled();
        return this;
    }
    _validateAdd(child) {
        var type = child.getType();
        if (type !== 'Group' && type !== 'Shape') (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).throw('You may only add groups and shapes to a layer.');
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.width = config.width || this.getWidth();
        config.height = config.height || this.getHeight();
        config.x = config.x !== undefined ? config.x : this.x();
        config.y = config.y !== undefined ? config.y : this.y();
        return (0, $ea22cf9e3e585277$export$85c928794f8d04d4).prototype._toKonvaCanvas.call(this, config);
    }
    _checkVisibility() {
        const visible = this.visible();
        if (visible) this.canvas._canvas.style.display = 'block';
        else this.canvas._canvas.style.display = 'none';
    }
    _setSmoothEnabled() {
        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
        if (this.parent) return this.parent.width();
    }
    setWidth() {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
        if (this.parent) return this.parent.height();
    }
    setHeight() {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
        if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).requestAnimFrame(()=>{
                this.draw();
                this._waitingForDraw = false;
            });
        }
        return this;
    }
    getIntersection(pos) {
        if (!this.isListening() || !this.isVisible()) return null;
        var spiralSearchDistance = 1;
        var continueSearch = false;
        while(true){
            for(let i = 0; i < $6477a7be7f053ca2$var$INTERSECTION_OFFSETS_LEN; i++){
                const intersectionOffset = $6477a7be7f053ca2$var$INTERSECTION_OFFSETS[i];
                const obj = this._getIntersection({
                    x: pos.x + intersectionOffset.x * spiralSearchDistance,
                    y: pos.y + intersectionOffset.y * spiralSearchDistance
                });
                const shape = obj.shape;
                if (shape) return shape;
                continueSearch = !!obj.antialiased;
                if (!obj.antialiased) break;
            }
            if (continueSearch) spiralSearchDistance += 1;
            else return null;
        }
    }
    _getIntersection(pos) {
        const ratio = this.hitCanvas.pixelRatio;
        const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
        const p3 = p[3];
        if (p3 === 255) {
            const colorKey = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._rgbToHex(p[0], p[1], p[2]);
            const shape = (0, $7579e2aa10cffa16$export$4ff7fc6f1af248b5)[$6477a7be7f053ca2$var$HASH + colorKey];
            if (shape) return {
                shape: shape
            };
            return {
                antialiased: true
            };
        } else if (p3 > 0) return {
            antialiased: true
        };
        return {};
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
        this._fire($6477a7be7f053ca2$var$BEFORE_DRAW, {
            node: this
        });
        if (this.clearBeforeDraw()) canvas.getContext().clear();
        (0, $1d900f1e946c4516$export$42a852a2b6b56249).prototype.drawScene.call(this, canvas, top);
        this._fire($6477a7be7f053ca2$var$DRAW, {
            node: this
        });
        return this;
    }
    drawHit(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
        if (layer && layer.clearBeforeDraw()) layer.getHitCanvas().getContext().clear();
        (0, $1d900f1e946c4516$export$42a852a2b6b56249).prototype.drawHit.call(this, canvas, top);
        return this;
    }
    enableHitGraph() {
        this.hitGraphEnabled(true);
        return this;
    }
    disableHitGraph() {
        this.hitGraphEnabled(false);
        return this;
    }
    setHitGraphEnabled(val) {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        this.listening(val);
    }
    getHitGraphEnabled(val) {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        return this.listening();
    }
    toggleHitCanvas() {
        if (!this.parent || !this.parent['content']) return;
        var parent = this.parent;
        var added = !!this.hitCanvas._canvas.parentNode;
        if (added) parent.content.removeChild(this.hitCanvas._canvas);
        else parent.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
        return super.destroy();
    }
}
$6477a7be7f053ca2$export$936d0764594b6eb3.prototype.nodeType = 'Layer';
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($6477a7be7f053ca2$export$936d0764594b6eb3);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($6477a7be7f053ca2$export$936d0764594b6eb3, 'imageSmoothingEnabled', true);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($6477a7be7f053ca2$export$936d0764594b6eb3, 'clearBeforeDraw', true);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($6477a7be7f053ca2$export$936d0764594b6eb3, 'hitGraphEnabled', true, (0, $2b769617cb7fb124$export$147fc8b6cd20fda1)());





class $8428ca1be6eb98fb$export$92d64f29192d1118 extends (0, $6477a7be7f053ca2$export$936d0764594b6eb3) {
    constructor(attrs){
        super(attrs);
        this.listening(false);
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
}
$8428ca1be6eb98fb$export$92d64f29192d1118.prototype.nodeType = 'FastLayer';
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($8428ca1be6eb98fb$export$92d64f29192d1118);





class $8a20641017396900$export$eb2fcfdbd7ba97d4 extends (0, $1d900f1e946c4516$export$42a852a2b6b56249) {
    _validateAdd(child) {
        var type = child.getType();
        if (type !== 'Group' && type !== 'Shape') (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).throw('You may only add groups and shapes to groups.');
    }
}
$8a20641017396900$export$eb2fcfdbd7ba97d4.prototype.nodeType = 'Group';
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($8a20641017396900$export$eb2fcfdbd7ba97d4);






var $b75a6e6371f4d78f$var$now = function() {
    if ((0, $d3b45fc6e7d35e7f$export$442f1a04865e4790).performance && (0, $d3b45fc6e7d35e7f$export$442f1a04865e4790).performance.now) return function() {
        return (0, $d3b45fc6e7d35e7f$export$442f1a04865e4790).performance.now();
    };
    return function() {
        return new Date().getTime();
    };
}();
class $b75a6e6371f4d78f$export$c35d437ae5945fcd {
    constructor(func, layers){
        this.id = $b75a6e6371f4d78f$export$c35d437ae5945fcd.animIdCounter++;
        this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: $b75a6e6371f4d78f$var$now(),
            frameRate: 0
        };
        this.func = func;
        this.setLayers(layers);
    }
    setLayers(layers) {
        var lays = [];
        if (!layers) lays = [];
        else if (layers.length > 0) lays = layers;
        else lays = [
            layers
        ];
        this.layers = lays;
        return this;
    }
    getLayers() {
        return this.layers;
    }
    addLayer(layer) {
        var layers = this.layers, len = layers.length, n;
        for(n = 0; n < len; n++){
            if (layers[n]._id === layer._id) return false;
        }
        this.layers.push(layer);
        return true;
    }
    isRunning() {
        var a = $b75a6e6371f4d78f$export$c35d437ae5945fcd, animations = a.animations, len = animations.length, n;
        for(n = 0; n < len; n++){
            if (animations[n].id === this.id) return true;
        }
        return false;
    }
    start() {
        this.stop();
        this.frame.timeDiff = 0;
        this.frame.lastTime = $b75a6e6371f4d78f$var$now();
        $b75a6e6371f4d78f$export$c35d437ae5945fcd._addAnimation(this);
        return this;
    }
    stop() {
        $b75a6e6371f4d78f$export$c35d437ae5945fcd._removeAnimation(this);
        return this;
    }
    _updateFrameObject(time) {
        this.frame.timeDiff = time - this.frame.lastTime;
        this.frame.lastTime = time;
        this.frame.time += this.frame.timeDiff;
        this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
    static _addAnimation(anim) {
        this.animations.push(anim);
        this._handleAnimation();
    }
    static _removeAnimation(anim) {
        var id = anim.id, animations = this.animations, len = animations.length, n;
        for(n = 0; n < len; n++)if (animations[n].id === id) {
            this.animations.splice(n, 1);
            break;
        }
    }
    static _runFrames() {
        var layerHash = {}, animations = this.animations, anim, layers, func, n, i, layersLen, layer, key, needRedraw;
        for(n = 0; n < animations.length; n++){
            anim = animations[n];
            layers = anim.layers;
            func = anim.func;
            anim._updateFrameObject($b75a6e6371f4d78f$var$now());
            layersLen = layers.length;
            if (func) needRedraw = func.call(anim, anim.frame) !== false;
            else needRedraw = true;
            if (!needRedraw) continue;
            for(i = 0; i < layersLen; i++){
                layer = layers[i];
                if (layer._id !== undefined) layerHash[layer._id] = layer;
            }
        }
        for(key in layerHash){
            if (!layerHash.hasOwnProperty(key)) continue;
            layerHash[key].batchDraw();
        }
    }
    static _animationLoop() {
        var Anim = $b75a6e6371f4d78f$export$c35d437ae5945fcd;
        if (Anim.animations.length) {
            Anim._runFrames();
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).requestAnimFrame(Anim._animationLoop);
        } else Anim.animRunning = false;
    }
    static _handleAnimation() {
        if (!this.animRunning) {
            this.animRunning = true;
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).requestAnimFrame(this._animationLoop);
        }
    }
}
$b75a6e6371f4d78f$export$c35d437ae5945fcd.animations = [];
$b75a6e6371f4d78f$export$c35d437ae5945fcd.animIdCounter = 0;
$b75a6e6371f4d78f$export$c35d437ae5945fcd.animRunning = false;






var $1180df2d9753acaa$var$blacklist = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1
}, $1180df2d9753acaa$var$PAUSED = 1, $1180df2d9753acaa$var$PLAYING = 2, $1180df2d9753acaa$var$REVERSING = 3, $1180df2d9753acaa$var$idCounter = 0, $1180df2d9753acaa$var$colorAttrs = [
    'fill',
    'stroke',
    'shadowColor'
];
class $1180df2d9753acaa$var$TweenEngine {
    constructor(prop, propFunc, func, begin, finish, duration, yoyo){
        this.prop = prop;
        this.propFunc = propFunc;
        this.begin = begin;
        this._pos = begin;
        this.duration = duration;
        this._change = 0;
        this.prevPos = 0;
        this.yoyo = yoyo;
        this._time = 0;
        this._position = 0;
        this._startTime = 0;
        this._finish = 0;
        this.func = func;
        this._change = finish - this.begin;
        this.pause();
    }
    fire(str) {
        var handler = this[str];
        if (handler) handler();
    }
    setTime(t) {
        if (t > this.duration) {
            if (this.yoyo) {
                this._time = this.duration;
                this.reverse();
            } else this.finish();
        } else if (t < 0) {
            if (this.yoyo) {
                this._time = 0;
                this.play();
            } else this.reset();
        } else {
            this._time = t;
            this.update();
        }
    }
    getTime() {
        return this._time;
    }
    setPosition(p) {
        this.prevPos = this._pos;
        this.propFunc(p);
        this._pos = p;
    }
    getPosition(t) {
        if (t === undefined) t = this._time;
        return this.func(t, this.begin, this._change, this.duration);
    }
    play() {
        this.state = $1180df2d9753acaa$var$PLAYING;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onPlay');
    }
    reverse() {
        this.state = $1180df2d9753acaa$var$REVERSING;
        this._time = this.duration - this._time;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onReverse');
    }
    seek(t) {
        this.pause();
        this._time = t;
        this.update();
        this.fire('onSeek');
    }
    reset() {
        this.pause();
        this._time = 0;
        this.update();
        this.fire('onReset');
    }
    finish() {
        this.pause();
        this._time = this.duration;
        this.update();
        this.fire('onFinish');
    }
    update() {
        this.setPosition(this.getPosition(this._time));
        this.fire('onUpdate');
    }
    onEnterFrame() {
        var t = this.getTimer() - this._startTime;
        if (this.state === $1180df2d9753acaa$var$PLAYING) this.setTime(t);
        else if (this.state === $1180df2d9753acaa$var$REVERSING) this.setTime(this.duration - t);
    }
    pause() {
        this.state = $1180df2d9753acaa$var$PAUSED;
        this.fire('onPause');
    }
    getTimer() {
        return new Date().getTime();
    }
}
class $1180df2d9753acaa$export$208a41d6b4e37b97 {
    constructor(config){
        var that = this, node = config.node, nodeId = node._id, duration, easing = config.easing || $1180df2d9753acaa$export$ade85cc9682adcc5.Linear, yoyo = !!config.yoyo, key;
        if (typeof config.duration === 'undefined') duration = 0.3;
        else if (config.duration === 0) duration = 0.001;
        else duration = config.duration;
        this.node = node;
        this._id = $1180df2d9753acaa$var$idCounter++;
        var layers = node.getLayer() || (node instanceof (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)['Stage'] ? node.getLayers() : null);
        if (!layers) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error('Tween constructor have `node` that is not in a layer. Please add node into layer first.');
        this.anim = new (0, $b75a6e6371f4d78f$export$c35d437ae5945fcd)(function() {
            that.tween.onEnterFrame();
        }, layers);
        this.tween = new $1180df2d9753acaa$var$TweenEngine(key, function(i) {
            that._tweenFunc(i);
        }, easing, 0, 1, duration * 1000, yoyo);
        this._addListeners();
        if (!$1180df2d9753acaa$export$208a41d6b4e37b97.attrs[nodeId]) $1180df2d9753acaa$export$208a41d6b4e37b97.attrs[nodeId] = {};
        if (!$1180df2d9753acaa$export$208a41d6b4e37b97.attrs[nodeId][this._id]) $1180df2d9753acaa$export$208a41d6b4e37b97.attrs[nodeId][this._id] = {};
        if (!$1180df2d9753acaa$export$208a41d6b4e37b97.tweens[nodeId]) $1180df2d9753acaa$export$208a41d6b4e37b97.tweens[nodeId] = {};
        for(key in config)if ($1180df2d9753acaa$var$blacklist[key] === undefined) this._addAttr(key, config[key]);
        this.reset();
        this.onFinish = config.onFinish;
        this.onReset = config.onReset;
        this.onUpdate = config.onUpdate;
    }
    _addAttr(key, end) {
        var node = this.node, nodeId = node._id, start, diff, tweenId, n, len, trueEnd, trueStart, endRGBA;
        tweenId = $1180df2d9753acaa$export$208a41d6b4e37b97.tweens[nodeId][key];
        if (tweenId) delete $1180df2d9753acaa$export$208a41d6b4e37b97.attrs[nodeId][tweenId][key];
        start = node.getAttr(key);
        if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === 'points' && end.length !== start.length) {
                if (end.length > start.length) {
                    trueStart = start;
                    start = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._prepareArrayForTween(start, end, node.closed());
                } else {
                    trueEnd = end;
                    end = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._prepareArrayForTween(end, start, node.closed());
                }
            }
            if (key.indexOf('fill') === 0) {
                for(n = 0; n < len; n++)if (n % 2 === 0) diff.push(end[n] - start[n]);
                else {
                    var startRGBA = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).colorToRGBA(start[n]);
                    endRGBA = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).colorToRGBA(end[n]);
                    start[n] = startRGBA;
                    diff.push({
                        r: endRGBA.r - startRGBA.r,
                        g: endRGBA.g - startRGBA.g,
                        b: endRGBA.b - startRGBA.b,
                        a: endRGBA.a - startRGBA.a
                    });
                }
            } else for(n = 0; n < len; n++)diff.push(end[n] - start[n]);
        } else if ($1180df2d9753acaa$var$colorAttrs.indexOf(key) !== -1) {
            start = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).colorToRGBA(start);
            endRGBA = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).colorToRGBA(end);
            diff = {
                r: endRGBA.r - start.r,
                g: endRGBA.g - start.g,
                b: endRGBA.b - start.b,
                a: endRGBA.a - start.a
            };
        } else diff = end - start;
        $1180df2d9753acaa$export$208a41d6b4e37b97.attrs[nodeId][this._id][key] = {
            start: start,
            diff: diff,
            end: end,
            trueEnd: trueEnd,
            trueStart: trueStart
        };
        $1180df2d9753acaa$export$208a41d6b4e37b97.tweens[nodeId][key] = this._id;
    }
    _tweenFunc(i) {
        var node = this.node, attrs = $1180df2d9753acaa$export$208a41d6b4e37b97.attrs[node._id][this._id], key, attr, start, diff, newVal, n, len, end;
        for(key in attrs){
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isArray(start)) {
                newVal = [];
                len = Math.max(start.length, end.length);
                if (key.indexOf('fill') === 0) {
                    for(n = 0; n < len; n++)if (n % 2 === 0) newVal.push((start[n] || 0) + diff[n] * i);
                    else newVal.push('rgba(' + Math.round(start[n].r + diff[n].r * i) + ',' + Math.round(start[n].g + diff[n].g * i) + ',' + Math.round(start[n].b + diff[n].b * i) + ',' + (start[n].a + diff[n].a * i) + ')');
                } else for(n = 0; n < len; n++)newVal.push((start[n] || 0) + diff[n] * i);
            } else if ($1180df2d9753acaa$var$colorAttrs.indexOf(key) !== -1) newVal = 'rgba(' + Math.round(start.r + diff.r * i) + ',' + Math.round(start.g + diff.g * i) + ',' + Math.round(start.b + diff.b * i) + ',' + (start.a + diff.a * i) + ')';
            else newVal = start + diff * i;
            node.setAttr(key, newVal);
        }
    }
    _addListeners() {
        this.tween.onPlay = ()=>{
            this.anim.start();
        };
        this.tween.onReverse = ()=>{
            this.anim.start();
        };
        this.tween.onPause = ()=>{
            this.anim.stop();
        };
        this.tween.onFinish = ()=>{
            var node = this.node;
            var attrs = $1180df2d9753acaa$export$208a41d6b4e37b97.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueEnd) node.setAttr('points', attrs.points.trueEnd);
            if (this.onFinish) this.onFinish.call(this);
        };
        this.tween.onReset = ()=>{
            var node = this.node;
            var attrs = $1180df2d9753acaa$export$208a41d6b4e37b97.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueStart) node.points(attrs.points.trueStart);
            if (this.onReset) this.onReset();
        };
        this.tween.onUpdate = ()=>{
            if (this.onUpdate) this.onUpdate.call(this);
        };
    }
    play() {
        this.tween.play();
        return this;
    }
    reverse() {
        this.tween.reverse();
        return this;
    }
    reset() {
        this.tween.reset();
        return this;
    }
    seek(t) {
        this.tween.seek(t * 1000);
        return this;
    }
    pause() {
        this.tween.pause();
        return this;
    }
    finish() {
        this.tween.finish();
        return this;
    }
    destroy() {
        var nodeId = this.node._id, thisId = this._id, attrs = $1180df2d9753acaa$export$208a41d6b4e37b97.tweens[nodeId], key;
        this.pause();
        for(key in attrs)delete $1180df2d9753acaa$export$208a41d6b4e37b97.tweens[nodeId][key];
        delete $1180df2d9753acaa$export$208a41d6b4e37b97.attrs[nodeId][thisId];
    }
}
$1180df2d9753acaa$export$208a41d6b4e37b97.attrs = {};
$1180df2d9753acaa$export$208a41d6b4e37b97.tweens = {};
(0, $ea22cf9e3e585277$export$85c928794f8d04d4).prototype.to = function(params) {
    var onFinish = params.onFinish;
    params.node = this;
    params.onFinish = function() {
        this.destroy();
        if (onFinish) onFinish();
    };
    var tween = new $1180df2d9753acaa$export$208a41d6b4e37b97(params);
    tween.play();
};
const $1180df2d9753acaa$export$ade85cc9682adcc5 = {
    BackEaseIn (t, b, c, d) {
        var s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    BackEaseOut (t, b, c, d) {
        var s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    BackEaseInOut (t, b, c, d) {
        var s = 1.70158;
        if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    ElasticEaseIn (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    ElasticEaseOut (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    ElasticEaseInOut (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d / 2) === 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    },
    BounceEaseOut (t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    },
    BounceEaseIn (t, b, c, d) {
        return c - $1180df2d9753acaa$export$ade85cc9682adcc5.BounceEaseOut(d - t, 0, c, d) + b;
    },
    BounceEaseInOut (t, b, c, d) {
        if (t < d / 2) return $1180df2d9753acaa$export$ade85cc9682adcc5.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
        else return $1180df2d9753acaa$export$ade85cc9682adcc5.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    },
    EaseIn (t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    EaseOut (t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    EaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    StrongEaseIn (t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    StrongEaseOut (t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    StrongEaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    Linear (t, b, c, d) {
        return c * t / d + b;
    }
};




const $37b3e1b602f2ccc4$export$b9f99057a3c7692 = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._assign((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692), {
    Util: $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd,
    Transform: $6436c4dfb94cdcf1$export$563a914cafbdc389,
    Node: $ea22cf9e3e585277$export$85c928794f8d04d4,
    Container: $1d900f1e946c4516$export$42a852a2b6b56249,
    Stage: $25b4080d36ce342c$export$208cd1682bd0e4b6,
    stages: $25b4080d36ce342c$export$1bfcff8d7c4bf05,
    Layer: $6477a7be7f053ca2$export$936d0764594b6eb3,
    FastLayer: $8428ca1be6eb98fb$export$92d64f29192d1118,
    Group: $8a20641017396900$export$eb2fcfdbd7ba97d4,
    DD: $b5d29c637453a5f5$export$e34f1b340034d7f,
    Shape: $7579e2aa10cffa16$export$6428a7f2611ef1fa,
    shapes: $7579e2aa10cffa16$export$4ff7fc6f1af248b5,
    Animation: $b75a6e6371f4d78f$export$c35d437ae5945fcd,
    Tween: $1180df2d9753acaa$export$208a41d6b4e37b97,
    Easings: $1180df2d9753acaa$export$ade85cc9682adcc5,
    Context: $19d5ebb13d967905$export$841858b892ce1f4c,
    Canvas: $91aeecb318ae5dc4$export$8d01c972ee8b14a9
});
var $37b3e1b602f2ccc4$export$2e2bcd8739ae039 = $37b3e1b602f2ccc4$export$b9f99057a3c7692;






class $8467c55359661a31$export$6ef80ffb606dd232 extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var angle = (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(this.angle()), clockwise = this.clockwise();
        context.beginPath();
        context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
        context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
    getSelfRect() {
        const innerRadius = this.innerRadius();
        const outerRadius = this.outerRadius();
        const clockwise = this.clockwise();
        const angle = (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(clockwise ? 360 - this.angle() : this.angle());
        const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
        const boundRightRatio = 1;
        const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), 3 * Math.PI / 2));
        const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
        const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
        const boundRight = boundRightRatio * (boundRightRatio > 0 ? outerRadius : innerRadius);
        const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
        const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
        return {
            x: boundLeft,
            y: clockwise ? -1 * boundBottom : boundTop,
            width: boundRight - boundLeft,
            height: boundBottom - boundTop
        };
    }
}
$8467c55359661a31$export$6ef80ffb606dd232.prototype._centroid = true;
$8467c55359661a31$export$6ef80ffb606dd232.prototype.className = 'Arc';
$8467c55359661a31$export$6ef80ffb606dd232.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($8467c55359661a31$export$6ef80ffb606dd232);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($8467c55359661a31$export$6ef80ffb606dd232, 'innerRadius', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($8467c55359661a31$export$6ef80ffb606dd232, 'outerRadius', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($8467c55359661a31$export$6ef80ffb606dd232, 'angle', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($8467c55359661a31$export$6ef80ffb606dd232, 'clockwise', false, (0, $2b769617cb7fb124$export$147fc8b6cd20fda1)());







function $8924c9b616ae3a6f$var$getControlPoints(x0, y0, x1, y1, x2, y2, t) {
    var d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = t * d01 / (d01 + d12), fb = t * d12 / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
    return [
        p1x,
        p1y,
        p2x,
        p2y
    ];
}
function $8924c9b616ae3a6f$var$expandPoints(p, tension) {
    var len = p.length, allPoints = [], n, cp;
    for(n = 2; n < len - 2; n += 2){
        cp = $8924c9b616ae3a6f$var$getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
        if (isNaN(cp[0])) continue;
        allPoints.push(cp[0]);
        allPoints.push(cp[1]);
        allPoints.push(p[n]);
        allPoints.push(p[n + 1]);
        allPoints.push(cp[2]);
        allPoints.push(cp[3]);
    }
    return allPoints;
}
class $8924c9b616ae3a6f$export$17d680238e50603e extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.on('pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva', function() {
            this._clearCache('tensionPoints');
        });
    }
    _sceneFunc(context) {
        var points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier(), tp, len, n;
        if (!length) return;
        context.beginPath();
        context.moveTo(points[0], points[1]);
        if (tension !== 0 && length > 4) {
            tp = this.getTensionPoints();
            len = tp.length;
            n = closed ? 0 : 4;
            if (!closed) context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
            while(n < len - 2)context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
            if (!closed) context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
        } else if (bezier) {
            n = 2;
            while(n < length)context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
        } else for(n = 2; n < length; n += 2)context.lineTo(points[n], points[n + 1]);
        if (closed) {
            context.closePath();
            context.fillStrokeShape(this);
        } else context.strokeShape(this);
    }
    getTensionPoints() {
        return this._getCache('tensionPoints', this._getTensionPoints);
    }
    _getTensionPoints() {
        if (this.closed()) return this._getTensionPointsClosed();
        else return $8924c9b616ae3a6f$var$expandPoints(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
        var p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = $8924c9b616ae3a6f$var$getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = $8924c9b616ae3a6f$var$getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = $8924c9b616ae3a6f$var$expandPoints(p, tension), tp = [
            firstControlPoints[2],
            firstControlPoints[3]
        ].concat(middle).concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p[len - 2],
            p[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p[0],
            p[1]
        ]);
        return tp;
    }
    getWidth() {
        return this.getSelfRect().width;
    }
    getHeight() {
        return this.getSelfRect().height;
    }
    getSelfRect() {
        var points = this.points();
        if (points.length < 4) return {
            x: points[0] || 0,
            y: points[1] || 0,
            width: 0,
            height: 0
        };
        if (this.tension() !== 0) points = [
            points[0],
            points[1],
            ...this._getTensionPoints(),
            points[points.length - 2],
            points[points.length - 1]
        ];
        else points = this.points();
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
}
$8924c9b616ae3a6f$export$17d680238e50603e.prototype.className = 'Line';
$8924c9b616ae3a6f$export$17d680238e50603e.prototype._attrsAffectingSize = [
    'points',
    'bezier',
    'tension'
];
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($8924c9b616ae3a6f$export$17d680238e50603e);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($8924c9b616ae3a6f$export$17d680238e50603e, 'closed', false);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($8924c9b616ae3a6f$export$17d680238e50603e, 'bezier', false);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($8924c9b616ae3a6f$export$17d680238e50603e, 'tension', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($8924c9b616ae3a6f$export$17d680238e50603e, 'points', [], (0, $2b769617cb7fb124$export$42b6f8f340e9a165)());







class $ad6f67fb366d225a$export$4b2950bdac9b6ee9 extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.dataArray = [];
        this.pathLength = 0;
        this.dataArray = $ad6f67fb366d225a$export$4b2950bdac9b6ee9.parsePathData(this.data());
        this.pathLength = 0;
        for(var i = 0; i < this.dataArray.length; ++i)this.pathLength += this.dataArray[i].pathLength;
        this.on('dataChange.konva', function() {
            this.dataArray = $ad6f67fb366d225a$export$4b2950bdac9b6ee9.parsePathData(this.data());
            this.pathLength = 0;
            for(var i = 0; i < this.dataArray.length; ++i)this.pathLength += this.dataArray[i].pathLength;
        });
    }
    _sceneFunc(context) {
        var ca = this.dataArray;
        context.beginPath();
        var isClosed = false;
        for(var n = 0; n < ca.length; n++){
            var c = ca[n].command;
            var p = ca[n].points;
            switch(c){
                case 'L':
                    context.lineTo(p[0], p[1]);
                    break;
                case 'M':
                    context.moveTo(p[0], p[1]);
                    break;
                case 'C':
                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
                    break;
                case 'Q':
                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
                    break;
                case 'A':
                    var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
                    var r = rx > ry ? rx : ry;
                    var scaleX = rx > ry ? 1 : rx / ry;
                    var scaleY = rx > ry ? ry / rx : 1;
                    context.translate(cx, cy);
                    context.rotate(psi);
                    context.scale(scaleX, scaleY);
                    context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
                    context.scale(1 / scaleX, 1 / scaleY);
                    context.rotate(-psi);
                    context.translate(-cx, -cy);
                    break;
                case 'z':
                    isClosed = true;
                    context.closePath();
                    break;
            }
        }
        if (!isClosed && !this.hasFill()) context.strokeShape(this);
        else context.fillStrokeShape(this);
    }
    getSelfRect() {
        var points = [];
        this.dataArray.forEach(function(data) {
            if (data.command === 'A') {
                var start = data.points[4];
                var dTheta = data.points[5];
                var end = data.points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                if (dTheta < 0) for(let t = start - inc; t > end; t -= inc){
                    const point = $ad6f67fb366d225a$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
                else for(let t = start + inc; t < end; t += inc){
                    const point = $ad6f67fb366d225a$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
            } else if (data.command === 'C') for(let t = 0.0; t <= 1; t += 0.01){
                const point = $ad6f67fb366d225a$export$4b2950bdac9b6ee9.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
                points.push(point.x, point.y);
            }
            else points = points.concat(data.points);
        });
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            if (!isNaN(x)) {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
            }
            if (!isNaN(y)) {
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getLength() {
        return this.pathLength;
    }
    getPointAtLength(length) {
        var point, i = 0, ii = this.dataArray.length;
        if (!ii) return null;
        while(i < ii && length > this.dataArray[i].pathLength){
            length -= this.dataArray[i].pathLength;
            ++i;
        }
        if (i === ii) {
            point = this.dataArray[i - 1].points.slice(-2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        if (length < 0.01) {
            point = this.dataArray[i].points.slice(0, 2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        var cp = this.dataArray[i];
        var p = cp.points;
        switch(cp.command){
            case 'L':
                return $ad6f67fb366d225a$export$4b2950bdac9b6ee9.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
            case 'C':
                return $ad6f67fb366d225a$export$4b2950bdac9b6ee9.getPointOnCubicBezier(length / cp.pathLength, cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
            case 'Q':
                return $ad6f67fb366d225a$export$4b2950bdac9b6ee9.getPointOnQuadraticBezier(length / cp.pathLength, cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
            case 'A':
                var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6];
                theta += dTheta * length / cp.pathLength;
                return $ad6f67fb366d225a$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
        }
        return null;
    }
    static getLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
        if (fromX === undefined) fromX = P1x;
        if (fromY === undefined) fromY = P1y;
        var m = (P2y - P1y) / (P2x - P1x + 0.00000001);
        var run = Math.sqrt(dist * dist / (1 + m * m));
        if (P2x < P1x) run *= -1;
        var rise = m * run;
        var pt;
        if (P2x === P1x) pt = {
            x: fromX,
            y: fromY + rise
        };
        else if ((fromY - P1y) / (fromX - P1x + 0.00000001) === m) pt = {
            x: fromX + run,
            y: fromY + rise
        };
        else {
            var ix, iy;
            var len = this.getLineLength(P1x, P1y, P2x, P2y);
            var u = (fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y);
            u = u / (len * len);
            ix = P1x + u * (P2x - P1x);
            iy = P1y + u * (P2y - P1y);
            var pRise = this.getLineLength(fromX, fromY, ix, iy);
            var pRun = Math.sqrt(dist * dist - pRise * pRise);
            run = Math.sqrt(pRun * pRun / (1 + m * m));
            if (P2x < P1x) run *= -1;
            rise = m * run;
            pt = {
                x: ix + run,
                y: iy + rise
            };
        }
        return pt;
    }
    static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
        function CB1(t) {
            return t * t * t;
        }
        function CB2(t) {
            return 3 * t * t * (1 - t);
        }
        function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
        }
        function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
        }
        var x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
        var y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
        function QB1(t) {
            return t * t;
        }
        function QB2(t) {
            return 2 * t * (1 - t);
        }
        function QB3(t) {
            return (1 - t) * (1 - t);
        }
        var x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
        var y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
        var cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
        var pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
        };
    }
    static parsePathData(data) {
        if (!data) return [];
        var cs = data;
        var cc = [
            'm',
            'M',
            'l',
            'L',
            'v',
            'V',
            'h',
            'H',
            'z',
            'Z',
            'c',
            'C',
            'q',
            'Q',
            't',
            'T',
            's',
            'S',
            'a',
            'A'
        ];
        cs = cs.replace(new RegExp(' ', 'g'), ',');
        for(var n = 0; n < cc.length; n++)cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
        var arr = cs.split('|');
        var ca = [];
        var coords = [];
        var cpx = 0;
        var cpy = 0;
        var re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        var match;
        for(n = 1; n < arr.length; n++){
            var str = arr[n];
            var c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while(match = re.exec(str))coords.push(match[0]);
            var p = [];
            for(var j = 0, jlen = coords.length; j < jlen; j++){
                if (coords[j] === '00') {
                    p.push(0, 0);
                    continue;
                }
                var parsed = parseFloat(coords[j]);
                if (!isNaN(parsed)) p.push(parsed);
                else p.push(0);
            }
            while(p.length > 0){
                if (isNaN(p[0])) break;
                var cmd = null;
                var points = [];
                var startX = cpx, startY = cpy;
                var prevCmd, ctlPtx, ctlPty;
                var rx, ry, psi, fa, fs, x1, y1;
                switch(c){
                    case 'l':
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'L':
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'm':
                        var dx = p.shift();
                        var dy = p.shift();
                        cpx += dx;
                        cpy += dy;
                        cmd = 'M';
                        if (ca.length > 2 && ca[ca.length - 1].command === 'z') {
                            for(var idx = ca.length - 2; idx >= 0; idx--)if (ca[idx].command === 'M') {
                                cpx = ca[idx].points[0] + dx;
                                cpy = ca[idx].points[1] + dy;
                                break;
                            }
                        }
                        points.push(cpx, cpy);
                        c = 'l';
                        break;
                    case 'M':
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'M';
                        points.push(cpx, cpy);
                        c = 'L';
                        break;
                    case 'h':
                        cpx += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'H':
                        cpx = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'v':
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'V':
                        cpy = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'C':
                        points.push(p.shift(), p.shift(), p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'c':
                        points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'S':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 's':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'Q':
                        points.push(p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'q':
                        points.push(cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(cpx, cpy);
                        break;
                    case 'T':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 't':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 'A':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                    case 'a':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                }
                ca.push({
                    command: cmd || c,
                    points: points,
                    start: {
                        x: startX,
                        y: startY
                    },
                    pathLength: this.calcLength(startX, startY, cmd || c, points)
                });
            }
            if (c === 'z' || c === 'Z') ca.push({
                command: 'z',
                points: [],
                start: undefined,
                pathLength: 0
            });
        }
        return ca;
    }
    static calcLength(x, y, cmd, points) {
        var len, p1, p2, t;
        var path = $ad6f67fb366d225a$export$4b2950bdac9b6ee9;
        switch(cmd){
            case 'L':
                return path.getLineLength(x, y, points[0], points[1]);
            case 'C':
                len = 0.0;
                p1 = path.getPointOnCubicBezier(0, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                for(t = 0.01; t <= 1; t += 0.01){
                    p2 = path.getPointOnCubicBezier(t, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                return len;
            case 'Q':
                len = 0.0;
                p1 = path.getPointOnQuadraticBezier(0, x, y, points[0], points[1], points[2], points[3]);
                for(t = 0.01; t <= 1; t += 0.01){
                    p2 = path.getPointOnQuadraticBezier(t, x, y, points[0], points[1], points[2], points[3]);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                return len;
            case 'A':
                len = 0.0;
                var start = points[4];
                var dTheta = points[5];
                var end = points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                if (dTheta < 0) for(t = start - inc; t > end; t -= inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                else for(t = start + inc; t < end; t += inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                return len;
        }
        return 0;
    }
    static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
        var psi = psiDeg * (Math.PI / 180.0);
        var xp = Math.cos(psi) * (x1 - x2) / 2.0 + Math.sin(psi) * (y1 - y2) / 2.0;
        var yp = -1 * Math.sin(psi) * (x1 - x2) / 2.0 + Math.cos(psi) * (y1 - y2) / 2.0;
        var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
        }
        var f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
        if (fa === fs) f *= -1;
        if (isNaN(f)) f = 0;
        var cxp = f * rx * yp / ry;
        var cyp = f * -ry * xp / rx;
        var cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
        var cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
        var vMag = function(v) {
            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
        };
        var vRatio = function(u, v) {
            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
        };
        var vAngle = function(u, v) {
            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
        };
        var theta = vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        var u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        var v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        var dTheta = vAngle(u, v);
        if (vRatio(u, v) <= -1) dTheta = Math.PI;
        if (vRatio(u, v) >= 1) dTheta = 0;
        if (fs === 0 && dTheta > 0) dTheta = dTheta - 2 * Math.PI;
        if (fs === 1 && dTheta < 0) dTheta = dTheta + 2 * Math.PI;
        return [
            cx,
            cy,
            rx,
            ry,
            theta,
            dTheta,
            psi,
            fs
        ];
    }
}
$ad6f67fb366d225a$export$4b2950bdac9b6ee9.prototype.className = 'Path';
$ad6f67fb366d225a$export$4b2950bdac9b6ee9.prototype._attrsAffectingSize = [
    'data'
];
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($ad6f67fb366d225a$export$4b2950bdac9b6ee9);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ad6f67fb366d225a$export$4b2950bdac9b6ee9, 'data');


class $69d2ab2236f98032$export$21b07c8f274aebd5 extends (0, $8924c9b616ae3a6f$export$17d680238e50603e) {
    _sceneFunc(ctx) {
        super._sceneFunc(ctx);
        var PI2 = Math.PI * 2;
        var points = this.points();
        var tp = points;
        var fromTension = this.tension() !== 0 && points.length > 4;
        if (fromTension) tp = this.getTensionPoints();
        var length = this.pointerLength();
        var n = points.length;
        var dx, dy;
        if (fromTension) {
            const lp = [
                tp[tp.length - 4],
                tp[tp.length - 3],
                tp[tp.length - 2],
                tp[tp.length - 1],
                points[n - 2],
                points[n - 1]
            ];
            const lastLength = (0, $ad6f67fb366d225a$export$4b2950bdac9b6ee9).calcLength(tp[tp.length - 4], tp[tp.length - 3], 'C', lp);
            const previous = (0, $ad6f67fb366d225a$export$4b2950bdac9b6ee9).getPointOnQuadraticBezier(Math.min(1, 1 - length / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
            dx = points[n - 2] - previous.x;
            dy = points[n - 1] - previous.y;
        } else {
            dx = points[n - 2] - points[n - 4];
            dy = points[n - 1] - points[n - 3];
        }
        var radians = (Math.atan2(dy, dx) + PI2) % PI2;
        var width = this.pointerWidth();
        if (this.pointerAtEnding()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[n - 2], points[n - 1]);
            ctx.rotate(radians);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
        if (this.pointerAtBeginning()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[0], points[1]);
            if (fromTension) {
                dx = (tp[0] + tp[2]) / 2 - points[0];
                dy = (tp[1] + tp[3]) / 2 - points[1];
            } else {
                dx = points[2] - points[0];
                dy = points[3] - points[1];
            }
            ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
    }
    __fillStroke(ctx) {
        var isDashEnabled = this.dashEnabled();
        if (isDashEnabled) {
            this.attrs.dashEnabled = false;
            ctx.setLineDash([]);
        }
        ctx.fillStrokeShape(this);
        if (isDashEnabled) this.attrs.dashEnabled = true;
    }
    getSelfRect() {
        const lineRect = super.getSelfRect();
        const offset = this.pointerWidth() / 2;
        return {
            x: lineRect.x - offset,
            y: lineRect.y - offset,
            width: lineRect.width + offset * 2,
            height: lineRect.height + offset * 2
        };
    }
}
$69d2ab2236f98032$export$21b07c8f274aebd5.prototype.className = 'Arrow';
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($69d2ab2236f98032$export$21b07c8f274aebd5);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($69d2ab2236f98032$export$21b07c8f274aebd5, 'pointerLength', 10, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($69d2ab2236f98032$export$21b07c8f274aebd5, 'pointerWidth', 10, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($69d2ab2236f98032$export$21b07c8f274aebd5, 'pointerAtBeginning', false);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($69d2ab2236f98032$export$21b07c8f274aebd5, 'pointerAtEnding', true);






class $61a17316c09bc361$export$c89a927ffc67e6fa extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        if (this.radius() !== width / 2) this.radius(width / 2);
    }
    setHeight(height) {
        if (this.radius() !== height / 2) this.radius(height / 2);
    }
}
$61a17316c09bc361$export$c89a927ffc67e6fa.prototype._centroid = true;
$61a17316c09bc361$export$c89a927ffc67e6fa.prototype.className = 'Circle';
$61a17316c09bc361$export$c89a927ffc67e6fa.prototype._attrsAffectingSize = [
    'radius'
];
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($61a17316c09bc361$export$c89a927ffc67e6fa);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($61a17316c09bc361$export$c89a927ffc67e6fa, 'radius', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());






class $4e034defe93312dd$export$80b0269ab108fa11 extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var rx = this.radiusX(), ry = this.radiusY();
        context.beginPath();
        context.save();
        if (rx !== ry) context.scale(1, ry / rx);
        context.arc(0, 0, rx, 0, Math.PI * 2, false);
        context.restore();
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radiusX() * 2;
    }
    getHeight() {
        return this.radiusY() * 2;
    }
    setWidth(width) {
        this.radiusX(width / 2);
    }
    setHeight(height) {
        this.radiusY(height / 2);
    }
}
$4e034defe93312dd$export$80b0269ab108fa11.prototype.className = 'Ellipse';
$4e034defe93312dd$export$80b0269ab108fa11.prototype._centroid = true;
$4e034defe93312dd$export$80b0269ab108fa11.prototype._attrsAffectingSize = [
    'radiusX',
    'radiusY'
];
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($4e034defe93312dd$export$80b0269ab108fa11);
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($4e034defe93312dd$export$80b0269ab108fa11, 'radius', [
    'x',
    'y'
]);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($4e034defe93312dd$export$80b0269ab108fa11, 'radiusX', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($4e034defe93312dd$export$80b0269ab108fa11, 'radiusY', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());







class $9a5a968d6cfaaa88$export$3e431a229df88919 extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    constructor(attrs){
        super(attrs);
        this.on('imageChange.konva', ()=>{
            this._setImageLoad();
        });
        this._setImageLoad();
    }
    _setImageLoad() {
        const image = this.image();
        if (image && image.complete) return;
        if (image && image.readyState === 4) return;
        if (image && image['addEventListener']) image['addEventListener']('load', ()=>{
            this._requestDraw();
        });
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _sceneFunc(context) {
        const width = this.getWidth();
        const height = this.getHeight();
        const cornerRadius = this.cornerRadius();
        const image = this.attrs.image;
        let params;
        if (image) {
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) params = [
                image,
                this.cropX(),
                this.cropY(),
                cropWidth,
                cropHeight,
                0,
                0,
                width,
                height
            ];
            else params = [
                image,
                0,
                0,
                width,
                height
            ];
        }
        if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius ? (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (cornerRadius) context.clip();
            context.drawImage.apply(context, params);
        }
    }
    _hitFunc(context) {
        var width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        var _a, _b;
        return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width;
    }
    getHeight() {
        var _a, _b;
        return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height;
    }
    static fromURL(url, callback, onError = null) {
        var img = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).createImageElement();
        img.onload = function() {
            var image = new $9a5a968d6cfaaa88$export$3e431a229df88919({
                image: img
            });
            callback(image);
        };
        img.onerror = onError;
        img.crossOrigin = 'Anonymous';
        img.src = url;
    }
}
$9a5a968d6cfaaa88$export$3e431a229df88919.prototype.className = 'Image';
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($9a5a968d6cfaaa88$export$3e431a229df88919);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($9a5a968d6cfaaa88$export$3e431a229df88919, 'cornerRadius', 0, (0, $2b769617cb7fb124$export$7d4ab1842c1b264b)(4));
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($9a5a968d6cfaaa88$export$3e431a229df88919, 'image');
(0, $43fd669de4de8956$export$8354032f3852ec50).addComponentsGetterSetter($9a5a968d6cfaaa88$export$3e431a229df88919, 'crop', [
    'x',
    'y',
    'width',
    'height'
]);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($9a5a968d6cfaaa88$export$3e431a229df88919, 'cropX', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($9a5a968d6cfaaa88$export$3e431a229df88919, 'cropY', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($9a5a968d6cfaaa88$export$3e431a229df88919, 'cropWidth', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($9a5a968d6cfaaa88$export$3e431a229df88919, 'cropHeight', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());







var $878039b7ffb52884$var$ATTR_CHANGE_LIST = [
    'fontFamily',
    'fontSize',
    'fontStyle',
    'padding',
    'lineHeight',
    'text',
    'width',
    'height',
    'pointerDirection',
    'pointerWidth',
    'pointerHeight'
], $878039b7ffb52884$var$CHANGE_KONVA = 'Change.konva', $878039b7ffb52884$var$NONE = 'none', $878039b7ffb52884$var$UP = 'up', $878039b7ffb52884$var$RIGHT = 'right', $878039b7ffb52884$var$DOWN = 'down', $878039b7ffb52884$var$LEFT = 'left', $878039b7ffb52884$var$attrChangeListLen = $878039b7ffb52884$var$ATTR_CHANGE_LIST.length;
class $878039b7ffb52884$export$b04be29aa201d4f5 extends (0, $8a20641017396900$export$eb2fcfdbd7ba97d4) {
    constructor(config){
        super(config);
        this.on('add.konva', function(evt) {
            this._addListeners(evt.child);
            this._sync();
        });
    }
    getText() {
        return this.find('Text')[0];
    }
    getTag() {
        return this.find('Tag')[0];
    }
    _addListeners(text) {
        var that = this, n;
        var func = function() {
            that._sync();
        };
        for(n = 0; n < $878039b7ffb52884$var$attrChangeListLen; n++)text.on($878039b7ffb52884$var$ATTR_CHANGE_LIST[n] + $878039b7ffb52884$var$CHANGE_KONVA, func);
    }
    getWidth() {
        return this.getText().width();
    }
    getHeight() {
        return this.getText().height();
    }
    _sync() {
        var text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
        if (text && tag) {
            width = text.width();
            height = text.height();
            pointerDirection = tag.pointerDirection();
            pointerWidth = tag.pointerWidth();
            pointerHeight = tag.pointerHeight();
            x = 0;
            y = 0;
            switch(pointerDirection){
                case $878039b7ffb52884$var$UP:
                    x = width / 2;
                    y = -1 * pointerHeight;
                    break;
                case $878039b7ffb52884$var$RIGHT:
                    x = width + pointerWidth;
                    y = height / 2;
                    break;
                case $878039b7ffb52884$var$DOWN:
                    x = width / 2;
                    y = height + pointerHeight;
                    break;
                case $878039b7ffb52884$var$LEFT:
                    x = -1 * pointerWidth;
                    y = height / 2;
                    break;
            }
            tag.setAttrs({
                x: -1 * x,
                y: -1 * y,
                width: width,
                height: height
            });
            text.setAttrs({
                x: -1 * x,
                y: -1 * y
            });
        }
    }
}
$878039b7ffb52884$export$b04be29aa201d4f5.prototype.className = 'Label';
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($878039b7ffb52884$export$b04be29aa201d4f5);
class $878039b7ffb52884$export$3288d34c523a1192 extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.beginPath();
        context.moveTo(topLeft, 0);
        if (pointerDirection === $878039b7ffb52884$var$UP) {
            context.lineTo((width - pointerWidth) / 2, 0);
            context.lineTo(width / 2, -1 * pointerHeight);
            context.lineTo((width + pointerWidth) / 2, 0);
        }
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        if (pointerDirection === $878039b7ffb52884$var$RIGHT) {
            context.lineTo(width, (height - pointerHeight) / 2);
            context.lineTo(width + pointerWidth, height / 2);
            context.lineTo(width, (height + pointerHeight) / 2);
        }
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        if (pointerDirection === $878039b7ffb52884$var$DOWN) {
            context.lineTo((width + pointerWidth) / 2, height);
            context.lineTo(width / 2, height + pointerHeight);
            context.lineTo((width - pointerWidth) / 2, height);
        }
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        if (pointerDirection === $878039b7ffb52884$var$LEFT) {
            context.lineTo(0, (height + pointerHeight) / 2);
            context.lineTo(-1 * pointerWidth, height / 2);
            context.lineTo(0, (height - pointerHeight) / 2);
        }
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getSelfRect() {
        var x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
        if (direction === $878039b7ffb52884$var$UP) {
            y -= pointerHeight;
            height += pointerHeight;
        } else if (direction === $878039b7ffb52884$var$DOWN) height += pointerHeight;
        else if (direction === $878039b7ffb52884$var$LEFT) {
            x -= pointerWidth * 1.5;
            width += pointerWidth;
        } else if (direction === $878039b7ffb52884$var$RIGHT) width += pointerWidth * 1.5;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
}
$878039b7ffb52884$export$3288d34c523a1192.prototype.className = 'Tag';
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($878039b7ffb52884$export$3288d34c523a1192);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($878039b7ffb52884$export$3288d34c523a1192, 'pointerDirection', $878039b7ffb52884$var$NONE);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($878039b7ffb52884$export$3288d34c523a1192, 'pointerWidth', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($878039b7ffb52884$export$3288d34c523a1192, 'pointerHeight', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($878039b7ffb52884$export$3288d34c523a1192, 'cornerRadius', 0, (0, $2b769617cb7fb124$export$7d4ab1842c1b264b)(4));









class $4cf8612870010584$export$c79fc6492f3af13d extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
}
$4cf8612870010584$export$c79fc6492f3af13d.prototype.className = 'Rect';
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($4cf8612870010584$export$c79fc6492f3af13d);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($4cf8612870010584$export$c79fc6492f3af13d, 'cornerRadius', 0, (0, $2b769617cb7fb124$export$7d4ab1842c1b264b)(4));






class $918bbfc35f663434$export$e2ee866164812ecd extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const points = this._getPoints();
        context.beginPath();
        context.moveTo(points[0].x, points[0].y);
        for(var n = 1; n < points.length; n++)context.lineTo(points[n].x, points[n].y);
        context.closePath();
        context.fillStrokeShape(this);
    }
    _getPoints() {
        const sides = this.attrs.sides;
        const radius = this.attrs.radius || 0;
        const points = [];
        for(var n = 0; n < sides; n++)points.push({
            x: radius * Math.sin(n * 2 * Math.PI / sides),
            y: -1 * radius * Math.cos(n * 2 * Math.PI / sides)
        });
        return points;
    }
    getSelfRect() {
        const points = this._getPoints();
        var minX = points[0].x;
        var maxX = points[0].y;
        var minY = points[0].x;
        var maxY = points[0].y;
        points.forEach((point)=>{
            minX = Math.min(minX, point.x);
            maxX = Math.max(maxX, point.x);
            minY = Math.min(minY, point.y);
            maxY = Math.max(maxY, point.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$918bbfc35f663434$export$e2ee866164812ecd.prototype.className = 'RegularPolygon';
$918bbfc35f663434$export$e2ee866164812ecd.prototype._centroid = true;
$918bbfc35f663434$export$e2ee866164812ecd.prototype._attrsAffectingSize = [
    'radius'
];
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($918bbfc35f663434$export$e2ee866164812ecd);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($918bbfc35f663434$export$e2ee866164812ecd, 'radius', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($918bbfc35f663434$export$e2ee866164812ecd, 'sides', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());






var $3940d1d297e341ba$var$PIx2 = Math.PI * 2;
class $3940d1d297e341ba$export$a6e3577650b6d6d7 extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.innerRadius(), 0, $3940d1d297e341ba$var$PIx2, false);
        context.moveTo(this.outerRadius(), 0);
        context.arc(0, 0, this.outerRadius(), $3940d1d297e341ba$var$PIx2, 0, true);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$3940d1d297e341ba$export$a6e3577650b6d6d7.prototype.className = 'Ring';
$3940d1d297e341ba$export$a6e3577650b6d6d7.prototype._centroid = true;
$3940d1d297e341ba$export$a6e3577650b6d6d7.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($3940d1d297e341ba$export$a6e3577650b6d6d7);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($3940d1d297e341ba$export$a6e3577650b6d6d7, 'innerRadius', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($3940d1d297e341ba$export$a6e3577650b6d6d7, 'outerRadius', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());







class $75d41bd59c068fc0$export$3075603db8e6204c extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this._updated = true;
        this.anim = new (0, $b75a6e6371f4d78f$export$c35d437ae5945fcd)(()=>{
            var updated = this._updated;
            this._updated = false;
            return updated;
        });
        this.on('animationChange.konva', function() {
            this.frameIndex(0);
        });
        this.on('frameIndexChange.konva', function() {
            this._updated = true;
        });
        this.on('frameRateChange.konva', function() {
            if (!this.anim.isRunning()) return;
            clearInterval(this.interval);
            this._setInterval();
        });
    }
    _sceneFunc(context) {
        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
        if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (offsets) {
                var offset = offsets[anim], ix2 = index * 2;
                context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
            } else context.drawImage(image, x, y, width, height, 0, 0, width, height);
        }
    }
    _hitFunc(context) {
        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
        context.beginPath();
        if (offsets) {
            var offset = offsets[anim];
            var ix2 = index * 2;
            context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
        } else context.rect(0, 0, width, height);
        context.closePath();
        context.fillShape(this);
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _setInterval() {
        var that = this;
        this.interval = setInterval(function() {
            that._updateIndex();
        }, 1000 / this.frameRate());
    }
    start() {
        if (this.isRunning()) return;
        var layer = this.getLayer();
        this.anim.setLayers(layer);
        this._setInterval();
        this.anim.start();
    }
    stop() {
        this.anim.stop();
        clearInterval(this.interval);
    }
    isRunning() {
        return this.anim.isRunning();
    }
    _updateIndex() {
        var index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
        if (index < len - 1) this.frameIndex(index + 1);
        else this.frameIndex(0);
    }
}
$75d41bd59c068fc0$export$3075603db8e6204c.prototype.className = 'Sprite';
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($75d41bd59c068fc0$export$3075603db8e6204c);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($75d41bd59c068fc0$export$3075603db8e6204c, 'animation');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($75d41bd59c068fc0$export$3075603db8e6204c, 'animations');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($75d41bd59c068fc0$export$3075603db8e6204c, 'frameOffsets');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($75d41bd59c068fc0$export$3075603db8e6204c, 'image');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($75d41bd59c068fc0$export$3075603db8e6204c, 'frameIndex', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($75d41bd59c068fc0$export$3075603db8e6204c, 'frameRate', 17, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).backCompat($75d41bd59c068fc0$export$3075603db8e6204c, {
    index: 'frameIndex',
    getIndex: 'getFrameIndex',
    setIndex: 'setFrameIndex'
});






class $549e1efa909e0fc3$export$1644ba17714857f1 extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
        context.beginPath();
        context.moveTo(0, 0 - outerRadius);
        for(var n = 1; n < numPoints * 2; n++){
            var radius = n % 2 === 0 ? outerRadius : innerRadius;
            var x = radius * Math.sin(n * Math.PI / numPoints);
            var y = -1 * radius * Math.cos(n * Math.PI / numPoints);
            context.lineTo(x, y);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$549e1efa909e0fc3$export$1644ba17714857f1.prototype.className = 'Star';
$549e1efa909e0fc3$export$1644ba17714857f1.prototype._centroid = true;
$549e1efa909e0fc3$export$1644ba17714857f1.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($549e1efa909e0fc3$export$1644ba17714857f1);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($549e1efa909e0fc3$export$1644ba17714857f1, 'numPoints', 5, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($549e1efa909e0fc3$export$1644ba17714857f1, 'innerRadius', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($549e1efa909e0fc3$export$1644ba17714857f1, 'outerRadius', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());







function $ac5933f2b3817561$export$b9ca061da17f2d30(string) {
    return Array.from(string);
}
var $ac5933f2b3817561$var$AUTO = 'auto', $ac5933f2b3817561$var$CENTER = 'center', $ac5933f2b3817561$var$JUSTIFY = 'justify', $ac5933f2b3817561$var$CHANGE_KONVA = 'Change.konva', $ac5933f2b3817561$var$CONTEXT_2D = '2d', $ac5933f2b3817561$var$DASH = '-', $ac5933f2b3817561$var$LEFT = 'left', $ac5933f2b3817561$var$TEXT = 'text', $ac5933f2b3817561$var$TEXT_UPPER = 'Text', $ac5933f2b3817561$var$TOP = 'top', $ac5933f2b3817561$var$BOTTOM = 'bottom', $ac5933f2b3817561$var$MIDDLE = 'middle', $ac5933f2b3817561$var$NORMAL = 'normal', $ac5933f2b3817561$var$PX_SPACE = 'px ', $ac5933f2b3817561$var$SPACE = ' ', $ac5933f2b3817561$var$RIGHT = 'right', $ac5933f2b3817561$var$WORD = 'word', $ac5933f2b3817561$var$CHAR = 'char', $ac5933f2b3817561$var$NONE = 'none', $ac5933f2b3817561$var$ELLIPSIS = "\u2026", $ac5933f2b3817561$var$ATTR_CHANGE_LIST = [
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontVariant',
    'padding',
    'align',
    'verticalAlign',
    'lineHeight',
    'text',
    'width',
    'height',
    'wrap',
    'ellipsis',
    'letterSpacing'
], $ac5933f2b3817561$var$attrChangeListLen = $ac5933f2b3817561$var$ATTR_CHANGE_LIST.length;
function $ac5933f2b3817561$var$normalizeFontFamily(fontFamily) {
    return fontFamily.split(',').map((family)=>{
        family = family.trim();
        const hasSpace = family.indexOf(' ') >= 0;
        const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
        if (hasSpace && !hasQuotes) family = `"${family}"`;
        return family;
    }).join(', ');
}
var $ac5933f2b3817561$var$dummyContext;
function $ac5933f2b3817561$var$getDummyContext() {
    if ($ac5933f2b3817561$var$dummyContext) return $ac5933f2b3817561$var$dummyContext;
    $ac5933f2b3817561$var$dummyContext = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).createCanvasElement().getContext($ac5933f2b3817561$var$CONTEXT_2D);
    return $ac5933f2b3817561$var$dummyContext;
}
function $ac5933f2b3817561$var$_fillFunc(context) {
    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function $ac5933f2b3817561$var$_strokeFunc(context) {
    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function $ac5933f2b3817561$var$checkDefaultFill(config) {
    config = config || {};
    if (!config.fillLinearGradientColorStops && !config.fillRadialGradientColorStops && !config.fillPatternImage) config.fill = config.fill || 'black';
    return config;
}
class $ac5933f2b3817561$export$5f1af8db9871e1d6 extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    constructor(config){
        super($ac5933f2b3817561$var$checkDefaultFill(config));
        this._partialTextX = 0;
        this._partialTextY = 0;
        for(var n = 0; n < $ac5933f2b3817561$var$attrChangeListLen; n++)this.on($ac5933f2b3817561$var$ATTR_CHANGE_LIST[n] + $ac5933f2b3817561$var$CHANGE_KONVA, this._setTextData);
        this._setTextData();
    }
    _sceneFunc(context) {
        var textArr = this.textArr, textArrLen = textArr.length;
        if (!this.text()) return;
        var padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), fill = this.fill(), textDecoration = this.textDecoration(), shouldUnderline = textDecoration.indexOf('underline') !== -1, shouldLineThrough = textDecoration.indexOf('line-through') !== -1, n;
        var translateY = 0;
        var translateY = lineHeightPx / 2;
        var lineTranslateX = 0;
        var lineTranslateY = 0;
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', $ac5933f2b3817561$var$MIDDLE);
        context.setAttr('textAlign', $ac5933f2b3817561$var$LEFT);
        if (verticalAlign === $ac5933f2b3817561$var$MIDDLE) alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
        else if (verticalAlign === $ac5933f2b3817561$var$BOTTOM) alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
        context.translate(padding, alignY + padding);
        for(n = 0; n < textArrLen; n++){
            var lineTranslateX = 0;
            var lineTranslateY = 0;
            var obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph, spacesNumber, oneWord, lineWidth;
            context.save();
            if (align === $ac5933f2b3817561$var$RIGHT) lineTranslateX += totalWidth - width - padding * 2;
            else if (align === $ac5933f2b3817561$var$CENTER) lineTranslateX += (totalWidth - width - padding * 2) / 2;
            if (shouldUnderline) {
                context.save();
                context.beginPath();
                context.moveTo(lineTranslateX, translateY + lineTranslateY + Math.round(fontSize / 2));
                spacesNumber = text.split(' ').length - 1;
                oneWord = spacesNumber === 0;
                lineWidth = align === $ac5933f2b3817561$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY + Math.round(fontSize / 2));
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            if (shouldLineThrough) {
                context.save();
                context.beginPath();
                context.moveTo(lineTranslateX, translateY + lineTranslateY);
                spacesNumber = text.split(' ').length - 1;
                oneWord = spacesNumber === 0;
                lineWidth = align === $ac5933f2b3817561$var$JUSTIFY && lastLine && !oneWord ? totalWidth - padding * 2 : width;
                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            if (letterSpacing !== 0 || align === $ac5933f2b3817561$var$JUSTIFY) {
                spacesNumber = text.split(' ').length - 1;
                var array = $ac5933f2b3817561$export$b9ca061da17f2d30(text);
                for(var li = 0; li < array.length; li++){
                    var letter = array[li];
                    if (letter === ' ' && !lastLine && align === $ac5933f2b3817561$var$JUSTIFY) lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
                    this._partialTextX = lineTranslateX;
                    this._partialTextY = translateY + lineTranslateY;
                    this._partialText = letter;
                    context.fillStrokeShape(this);
                    lineTranslateX += this.measureSize(letter).width + letterSpacing;
                }
            } else {
                this._partialTextX = lineTranslateX;
                this._partialTextY = translateY + lineTranslateY;
                this._partialText = text;
                context.fillStrokeShape(this);
            }
            context.restore();
            if (textArrLen > 1) translateY += lineHeightPx;
        }
    }
    _hitFunc(context) {
        var width = this.getWidth(), height = this.getHeight();
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
    }
    setText(text) {
        var str = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._isString(text) ? text : text === null || text === undefined ? '' : text + '';
        this._setAttr($ac5933f2b3817561$var$TEXT, str);
        return this;
    }
    getWidth() {
        var isAuto = this.attrs.width === $ac5933f2b3817561$var$AUTO || this.attrs.width === undefined;
        return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
        var isAuto = this.attrs.height === $ac5933f2b3817561$var$AUTO || this.attrs.height === undefined;
        return isAuto ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    measureSize(text) {
        var _context = $ac5933f2b3817561$var$getDummyContext(), fontSize = this.fontSize(), metrics;
        _context.save();
        _context.font = this._getContextFont();
        metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: fontSize
        };
    }
    _getContextFont() {
        return this.fontStyle() + $ac5933f2b3817561$var$SPACE + this.fontVariant() + $ac5933f2b3817561$var$SPACE + (this.fontSize() + $ac5933f2b3817561$var$PX_SPACE) + $ac5933f2b3817561$var$normalizeFontFamily(this.fontFamily());
    }
    _addTextLine(line) {
        const align = this.align();
        if (align === $ac5933f2b3817561$var$JUSTIFY) line = line.trim();
        var width = this._getTextWidth(line);
        return this.textArr.push({
            text: line,
            width: width,
            lastInParagraph: false
        });
    }
    _getTextWidth(text) {
        var letterSpacing = this.letterSpacing();
        var length = text.length;
        return $ac5933f2b3817561$var$getDummyContext().measureText(text).width + (length ? letterSpacing * (length - 1) : 0);
    }
    _setTextData() {
        var lines = this.text().split('\n'), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== $ac5933f2b3817561$var$AUTO && width !== undefined, fixedHeight = height !== $ac5933f2b3817561$var$AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), shouldWrap = wrap !== $ac5933f2b3817561$var$NONE, wrapAtWord = wrap !== $ac5933f2b3817561$var$CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
        this.textArr = [];
        $ac5933f2b3817561$var$getDummyContext().font = this._getContextFont();
        var additionalWidth = shouldAddEllipsis ? this._getTextWidth($ac5933f2b3817561$var$ELLIPSIS) : 0;
        for(var i = 0, max = lines.length; i < max; ++i){
            var line = lines[i];
            var lineWidth = this._getTextWidth(line);
            if (fixedWidth && lineWidth > maxWidth) while(line.length > 0){
                var low = 0, high = line.length, match = '', matchWidth = 0;
                while(low < high){
                    var mid = low + high >>> 1, substr = line.slice(0, mid + 1), substrWidth = this._getTextWidth(substr) + additionalWidth;
                    if (substrWidth <= maxWidth) {
                        low = mid + 1;
                        match = substr;
                        matchWidth = substrWidth;
                    } else high = mid;
                }
                if (match) {
                    if (wrapAtWord) {
                        var wrapIndex;
                        var nextChar = line[match.length];
                        var nextIsSpaceOrDash = nextChar === $ac5933f2b3817561$var$SPACE || nextChar === $ac5933f2b3817561$var$DASH;
                        if (nextIsSpaceOrDash && matchWidth <= maxWidth) wrapIndex = match.length;
                        else wrapIndex = Math.max(match.lastIndexOf($ac5933f2b3817561$var$SPACE), match.lastIndexOf($ac5933f2b3817561$var$DASH)) + 1;
                        if (wrapIndex > 0) {
                            low = wrapIndex;
                            match = match.slice(0, low);
                            matchWidth = this._getTextWidth(match);
                        }
                    }
                    match = match.trimRight();
                    this._addTextLine(match);
                    textWidth = Math.max(textWidth, matchWidth);
                    currentHeightPx += lineHeightPx;
                    var shouldHandleEllipsis = this._shouldHandleEllipsis(currentHeightPx);
                    if (shouldHandleEllipsis) {
                        this._tryToAddEllipsisToLastLine();
                        break;
                    }
                    line = line.slice(low);
                    line = line.trimLeft();
                    if (line.length > 0) {
                        lineWidth = this._getTextWidth(line);
                        if (lineWidth <= maxWidth) {
                            this._addTextLine(line);
                            currentHeightPx += lineHeightPx;
                            textWidth = Math.max(textWidth, lineWidth);
                            break;
                        }
                    }
                } else break;
            }
            else {
                this._addTextLine(line);
                currentHeightPx += lineHeightPx;
                textWidth = Math.max(textWidth, lineWidth);
                if (this._shouldHandleEllipsis(currentHeightPx) && i < max - 1) this._tryToAddEllipsisToLastLine();
            }
            if (this.textArr[this.textArr.length - 1]) this.textArr[this.textArr.length - 1].lastInParagraph = true;
            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) break;
        }
        this.textHeight = fontSize;
        this.textWidth = textWidth;
    }
    _shouldHandleEllipsis(currentHeightPx) {
        var fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== $ac5933f2b3817561$var$AUTO && height !== undefined, padding = this.padding(), maxHeightPx = height - padding * 2, wrap = this.wrap(), shouldWrap = wrap !== $ac5933f2b3817561$var$NONE;
        return !shouldWrap || fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
    }
    _tryToAddEllipsisToLastLine() {
        var width = this.attrs.width, fixedWidth = width !== $ac5933f2b3817561$var$AUTO && width !== undefined, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
        var lastLine = this.textArr[this.textArr.length - 1];
        if (!lastLine || !shouldAddEllipsis) return;
        if (fixedWidth) {
            var haveSpace = this._getTextWidth(lastLine.text + $ac5933f2b3817561$var$ELLIPSIS) < maxWidth;
            if (!haveSpace) lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
        }
        this.textArr.splice(this.textArr.length - 1, 1);
        this._addTextLine(lastLine.text + $ac5933f2b3817561$var$ELLIPSIS);
    }
    getStrokeScaleEnabled() {
        return true;
    }
}
$ac5933f2b3817561$export$5f1af8db9871e1d6.prototype._fillFunc = $ac5933f2b3817561$var$_fillFunc;
$ac5933f2b3817561$export$5f1af8db9871e1d6.prototype._strokeFunc = $ac5933f2b3817561$var$_strokeFunc;
$ac5933f2b3817561$export$5f1af8db9871e1d6.prototype.className = $ac5933f2b3817561$var$TEXT_UPPER;
$ac5933f2b3817561$export$5f1af8db9871e1d6.prototype._attrsAffectingSize = [
    'text',
    'fontSize',
    'padding',
    'wrap',
    'lineHeight',
    'letterSpacing'
];
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($ac5933f2b3817561$export$5f1af8db9871e1d6);
(0, $43fd669de4de8956$export$8354032f3852ec50).overWriteSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'width', (0, $2b769617cb7fb124$export$3b7df2720ef33404)());
(0, $43fd669de4de8956$export$8354032f3852ec50).overWriteSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'height', (0, $2b769617cb7fb124$export$3b7df2720ef33404)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'fontFamily', 'Arial');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'fontSize', 12, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'fontStyle', $ac5933f2b3817561$var$NORMAL);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'fontVariant', $ac5933f2b3817561$var$NORMAL);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'padding', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'align', $ac5933f2b3817561$var$LEFT);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'verticalAlign', $ac5933f2b3817561$var$TOP);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'lineHeight', 1, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'wrap', $ac5933f2b3817561$var$WORD);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'ellipsis', false, (0, $2b769617cb7fb124$export$147fc8b6cd20fda1)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'letterSpacing', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'text', '', (0, $2b769617cb7fb124$export$5837c5b6cc5b4d63)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($ac5933f2b3817561$export$5f1af8db9871e1d6, 'textDecoration', '');









var $acea4bbf0026aba8$var$EMPTY_STRING = '', $acea4bbf0026aba8$var$NORMAL = 'normal';
function $acea4bbf0026aba8$var$_fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
}
function $acea4bbf0026aba8$var$_strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
}
class $acea4bbf0026aba8$export$f7e34a95cc06fac7 extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.dummyCanvas = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).createCanvasElement();
        this.dataArray = [];
        this.dataArray = (0, $ad6f67fb366d225a$export$4b2950bdac9b6ee9).parsePathData(this.attrs.data);
        this.on('dataChange.konva', function() {
            this.dataArray = (0, $ad6f67fb366d225a$export$4b2950bdac9b6ee9).parsePathData(this.attrs.data);
            this._setTextData();
        });
        this.on('textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva', this._setTextData);
        this._setTextData();
    }
    _sceneFunc(context) {
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', this.textBaseline());
        context.setAttr('textAlign', 'left');
        context.save();
        var textDecoration = this.textDecoration();
        var fill = this.fill();
        var fontSize = this.fontSize();
        var glyphInfo = this.glyphInfo;
        if (textDecoration === 'underline') context.beginPath();
        for(var i = 0; i < glyphInfo.length; i++){
            context.save();
            var p0 = glyphInfo[i].p0;
            context.translate(p0.x, p0.y);
            context.rotate(glyphInfo[i].rotation);
            this.partialText = glyphInfo[i].text;
            context.fillStrokeShape(this);
            if (textDecoration === 'underline') {
                if (i === 0) context.moveTo(0, fontSize / 2 + 1);
                context.lineTo(fontSize, fontSize / 2 + 1);
            }
            context.restore();
        }
        if (textDecoration === 'underline') {
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        context.restore();
    }
    _hitFunc(context) {
        context.beginPath();
        var glyphInfo = this.glyphInfo;
        if (glyphInfo.length >= 1) {
            var p0 = glyphInfo[0].p0;
            context.moveTo(p0.x, p0.y);
        }
        for(var i = 0; i < glyphInfo.length; i++){
            var p1 = glyphInfo[i].p1;
            context.lineTo(p1.x, p1.y);
        }
        context.setAttr('lineWidth', this.fontSize());
        context.setAttr('strokeStyle', this.colorKey);
        context.stroke();
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    setText(text) {
        return (0, $ac5933f2b3817561$export$5f1af8db9871e1d6).prototype.setText.call(this, text);
    }
    _getContextFont() {
        return (0, $ac5933f2b3817561$export$5f1af8db9871e1d6).prototype._getContextFont.call(this);
    }
    _getTextSize(text) {
        var dummyCanvas = this.dummyCanvas;
        var _context = dummyCanvas.getContext('2d');
        _context.save();
        _context.font = this._getContextFont();
        var metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: parseInt(this.attrs.fontSize, 10)
        };
    }
    _setTextData() {
        var that = this;
        var size = this._getTextSize(this.attrs.text);
        var letterSpacing = this.letterSpacing();
        var align = this.align();
        var kerningFunc = this.kerningFunc();
        this.textWidth = size.width;
        this.textHeight = size.height;
        var textFullWidth = Math.max(this.textWidth + ((this.attrs.text || '').length - 1) * letterSpacing, 0);
        this.glyphInfo = [];
        var fullPathWidth = 0;
        for(var l = 0; l < that.dataArray.length; l++)if (that.dataArray[l].pathLength > 0) fullPathWidth += that.dataArray[l].pathLength;
        var offset = 0;
        if (align === 'center') offset = Math.max(0, fullPathWidth / 2 - textFullWidth / 2);
        if (align === 'right') offset = Math.max(0, fullPathWidth - textFullWidth);
        var charArr = (0, $ac5933f2b3817561$export$b9ca061da17f2d30)(this.text());
        var spacesNumber = this.text().split(' ').length - 1;
        var p0, p1, pathCmd;
        var pIndex = -1;
        var currentT = 0;
        var getNextPathSegment = function() {
            currentT = 0;
            var pathData = that.dataArray;
            for(var j = pIndex + 1; j < pathData.length; j++){
                if (pathData[j].pathLength > 0) {
                    pIndex = j;
                    return pathData[j];
                } else if (pathData[j].command === 'M') p0 = {
                    x: pathData[j].points[0],
                    y: pathData[j].points[1]
                };
            }
            return {};
        };
        var findSegmentToFitCharacter = function(c) {
            var glyphWidth = that._getTextSize(c).width + letterSpacing;
            if (c === ' ' && align === 'justify') glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
            var currLen = 0;
            var attempts = 0;
            p1 = undefined;
            while(Math.abs(glyphWidth - currLen) / glyphWidth > 0.01 && attempts < 20){
                attempts++;
                var cumulativePathLength = currLen;
                while(pathCmd === undefined){
                    pathCmd = getNextPathSegment();
                    if (pathCmd && cumulativePathLength + pathCmd.pathLength < glyphWidth) {
                        cumulativePathLength += pathCmd.pathLength;
                        pathCmd = undefined;
                    }
                }
                if (Object.keys(pathCmd).length === 0 || p0 === undefined) return undefined;
                var needNewSegment = false;
                switch(pathCmd.command){
                    case 'L':
                        if ((0, $ad6f67fb366d225a$export$4b2950bdac9b6ee9).getLineLength(p0.x, p0.y, pathCmd.points[0], pathCmd.points[1]) > glyphWidth) p1 = (0, $ad6f67fb366d225a$export$4b2950bdac9b6ee9).getPointOnLine(glyphWidth, p0.x, p0.y, pathCmd.points[0], pathCmd.points[1], p0.x, p0.y);
                        else pathCmd = undefined;
                        break;
                    case 'A':
                        var start = pathCmd.points[4];
                        var dTheta = pathCmd.points[5];
                        var end = pathCmd.points[4] + dTheta;
                        if (currentT === 0) currentT = start + 0.00000001;
                        else if (glyphWidth > currLen) currentT += Math.PI / 180.0 * dTheta / Math.abs(dTheta);
                        else currentT -= Math.PI / 360.0 * dTheta / Math.abs(dTheta);
                        if (dTheta < 0 && currentT < end || dTheta >= 0 && currentT > end) {
                            currentT = end;
                            needNewSegment = true;
                        }
                        p1 = (0, $ad6f67fb366d225a$export$4b2950bdac9b6ee9).getPointOnEllipticalArc(pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3], currentT, pathCmd.points[6]);
                        break;
                    case 'C':
                        if (currentT === 0) {
                            if (glyphWidth > pathCmd.pathLength) currentT = 0.00000001;
                            else currentT = glyphWidth / pathCmd.pathLength;
                        } else if (glyphWidth > currLen) currentT += (glyphWidth - currLen) / pathCmd.pathLength / 2;
                        else currentT = Math.max(currentT - (currLen - glyphWidth) / pathCmd.pathLength / 2, 0);
                        if (currentT > 1.0) {
                            currentT = 1.0;
                            needNewSegment = true;
                        }
                        p1 = (0, $ad6f67fb366d225a$export$4b2950bdac9b6ee9).getPointOnCubicBezier(currentT, pathCmd.start.x, pathCmd.start.y, pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3], pathCmd.points[4], pathCmd.points[5]);
                        break;
                    case 'Q':
                        if (currentT === 0) currentT = glyphWidth / pathCmd.pathLength;
                        else if (glyphWidth > currLen) currentT += (glyphWidth - currLen) / pathCmd.pathLength;
                        else currentT -= (currLen - glyphWidth) / pathCmd.pathLength;
                        if (currentT > 1.0) {
                            currentT = 1.0;
                            needNewSegment = true;
                        }
                        p1 = (0, $ad6f67fb366d225a$export$4b2950bdac9b6ee9).getPointOnQuadraticBezier(currentT, pathCmd.start.x, pathCmd.start.y, pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3]);
                        break;
                }
                if (p1 !== undefined) currLen = (0, $ad6f67fb366d225a$export$4b2950bdac9b6ee9).getLineLength(p0.x, p0.y, p1.x, p1.y);
                if (needNewSegment) {
                    needNewSegment = false;
                    pathCmd = undefined;
                }
            }
        };
        var testChar = 'C';
        var glyphWidth = that._getTextSize(testChar).width + letterSpacing;
        var lettersInOffset = offset / glyphWidth - 1;
        for(var k = 0; k < lettersInOffset; k++){
            findSegmentToFitCharacter(testChar);
            if (p0 === undefined || p1 === undefined) break;
            p0 = p1;
        }
        for(var i = 0; i < charArr.length; i++){
            findSegmentToFitCharacter(charArr[i]);
            if (p0 === undefined || p1 === undefined) break;
            var width = (0, $ad6f67fb366d225a$export$4b2950bdac9b6ee9).getLineLength(p0.x, p0.y, p1.x, p1.y);
            var kern = 0;
            if (kerningFunc) try {
                kern = kerningFunc(charArr[i - 1], charArr[i]) * this.fontSize();
            } catch (e) {
                kern = 0;
            }
            p0.x += kern;
            p1.x += kern;
            this.textWidth += kern;
            var midpoint = (0, $ad6f67fb366d225a$export$4b2950bdac9b6ee9).getPointOnLine(kern + width / 2.0, p0.x, p0.y, p1.x, p1.y);
            var rotation = Math.atan2(p1.y - p0.y, p1.x - p0.x);
            this.glyphInfo.push({
                transposeX: midpoint.x,
                transposeY: midpoint.y,
                text: charArr[i],
                rotation: rotation,
                p0: p0,
                p1: p1
            });
            p0 = p1;
        }
    }
    getSelfRect() {
        if (!this.glyphInfo.length) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        var points = [];
        this.glyphInfo.forEach(function(info) {
            points.push(info.p0.x);
            points.push(info.p0.y);
            points.push(info.p1.x);
            points.push(info.p1.y);
        });
        var minX = points[0] || 0;
        var maxX = points[0] || 0;
        var minY = points[1] || 0;
        var maxY = points[1] || 0;
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        var fontSize = this.fontSize();
        return {
            x: minX - fontSize / 2,
            y: minY - fontSize / 2,
            width: maxX - minX + fontSize,
            height: maxY - minY + fontSize
        };
    }
    destroy() {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).releaseCanvas(this.dummyCanvas);
        return super.destroy();
    }
}
$acea4bbf0026aba8$export$f7e34a95cc06fac7.prototype._fillFunc = $acea4bbf0026aba8$var$_fillFunc;
$acea4bbf0026aba8$export$f7e34a95cc06fac7.prototype._strokeFunc = $acea4bbf0026aba8$var$_strokeFunc;
$acea4bbf0026aba8$export$f7e34a95cc06fac7.prototype._fillFuncHit = $acea4bbf0026aba8$var$_fillFunc;
$acea4bbf0026aba8$export$f7e34a95cc06fac7.prototype._strokeFuncHit = $acea4bbf0026aba8$var$_strokeFunc;
$acea4bbf0026aba8$export$f7e34a95cc06fac7.prototype.className = 'TextPath';
$acea4bbf0026aba8$export$f7e34a95cc06fac7.prototype._attrsAffectingSize = [
    'text',
    'fontSize',
    'data'
];
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($acea4bbf0026aba8$export$f7e34a95cc06fac7);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($acea4bbf0026aba8$export$f7e34a95cc06fac7, 'data');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($acea4bbf0026aba8$export$f7e34a95cc06fac7, 'fontFamily', 'Arial');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($acea4bbf0026aba8$export$f7e34a95cc06fac7, 'fontSize', 12, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($acea4bbf0026aba8$export$f7e34a95cc06fac7, 'fontStyle', $acea4bbf0026aba8$var$NORMAL);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($acea4bbf0026aba8$export$f7e34a95cc06fac7, 'align', 'left');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($acea4bbf0026aba8$export$f7e34a95cc06fac7, 'letterSpacing', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($acea4bbf0026aba8$export$f7e34a95cc06fac7, 'textBaseline', 'middle');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($acea4bbf0026aba8$export$f7e34a95cc06fac7, 'fontVariant', $acea4bbf0026aba8$var$NORMAL);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($acea4bbf0026aba8$export$f7e34a95cc06fac7, 'text', $acea4bbf0026aba8$var$EMPTY_STRING);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($acea4bbf0026aba8$export$f7e34a95cc06fac7, 'textDecoration', null);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($acea4bbf0026aba8$export$f7e34a95cc06fac7, 'kerningFunc', null);










var $51a7f1533724cad7$var$EVENTS_NAME = 'tr-konva';
var $51a7f1533724cad7$var$ATTR_CHANGE_LIST = [
    'resizeEnabledChange',
    'rotateAnchorOffsetChange',
    'rotateEnabledChange',
    'enabledAnchorsChange',
    'anchorSizeChange',
    'borderEnabledChange',
    'borderStrokeChange',
    'borderStrokeWidthChange',
    'borderDashChange',
    'anchorStrokeChange',
    'anchorStrokeWidthChange',
    'anchorFillChange',
    'anchorCornerRadiusChange',
    'ignoreStrokeChange'
].map((e)=>e + `.${$51a7f1533724cad7$var$EVENTS_NAME}`).join(' ');
var $51a7f1533724cad7$var$NODES_RECT = 'nodesRect';
var $51a7f1533724cad7$var$TRANSFORM_CHANGE_STR = [
    'widthChange',
    'heightChange',
    'scaleXChange',
    'scaleYChange',
    'skewXChange',
    'skewYChange',
    'rotationChange',
    'offsetXChange',
    'offsetYChange',
    'transformsEnabledChange',
    'strokeWidthChange'
];
var $51a7f1533724cad7$var$ANGLES = {
    'top-left': -45,
    'top-center': 0,
    'top-right': 45,
    'middle-right': -90,
    'middle-left': 90,
    'bottom-left': -135,
    'bottom-center': 180,
    'bottom-right': 135
};
const $51a7f1533724cad7$var$TOUCH_DEVICE = 'ontouchstart' in (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692)._global;
function $51a7f1533724cad7$var$getCursor(anchorName, rad) {
    if (anchorName === 'rotater') return 'crosshair';
    rad += (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).degToRad($51a7f1533724cad7$var$ANGLES[anchorName] || 0);
    var angle = ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).radToDeg(rad) % 360 + 360) % 360;
    if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._inRange(angle, 337.5, 360) || (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._inRange(angle, 0, 22.5)) return 'ns-resize';
    else if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._inRange(angle, 22.5, 67.5)) return 'nesw-resize';
    else if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._inRange(angle, 67.5, 112.5)) return 'ew-resize';
    else if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._inRange(angle, 112.5, 157.5)) return 'nwse-resize';
    else if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._inRange(angle, 157.5, 202.5)) return 'ns-resize';
    else if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._inRange(angle, 202.5, 247.5)) return 'nesw-resize';
    else if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._inRange(angle, 247.5, 292.5)) return 'ew-resize';
    else if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._inRange(angle, 292.5, 337.5)) return 'nwse-resize';
    else {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error('Transformer has unknown angle for cursor detection: ' + angle);
        return 'pointer';
    }
}
var $51a7f1533724cad7$var$ANCHORS_NAMES = [
    'top-left',
    'top-center',
    'top-right',
    'middle-right',
    'middle-left',
    'bottom-left',
    'bottom-center',
    'bottom-right'
];
var $51a7f1533724cad7$var$MAX_SAFE_INTEGER = 100000000;
function $51a7f1533724cad7$var$getCenter(shape) {
    return {
        x: shape.x + shape.width / 2 * Math.cos(shape.rotation) + shape.height / 2 * Math.sin(-shape.rotation),
        y: shape.y + shape.height / 2 * Math.cos(shape.rotation) + shape.width / 2 * Math.sin(shape.rotation)
    };
}
function $51a7f1533724cad7$var$rotateAroundPoint(shape, angleRad, point) {
    const x = point.x + (shape.x - point.x) * Math.cos(angleRad) - (shape.y - point.y) * Math.sin(angleRad);
    const y = point.y + (shape.x - point.x) * Math.sin(angleRad) + (shape.y - point.y) * Math.cos(angleRad);
    return Object.assign(Object.assign({}, shape), {
        rotation: shape.rotation + angleRad,
        x: x,
        y: y
    });
}
function $51a7f1533724cad7$var$rotateAroundCenter(shape, deltaRad) {
    const center = $51a7f1533724cad7$var$getCenter(shape);
    return $51a7f1533724cad7$var$rotateAroundPoint(shape, deltaRad, center);
}
function $51a7f1533724cad7$var$getSnap(snaps, newRotationRad, tol) {
    let snapped = newRotationRad;
    for(let i = 0; i < snaps.length; i++){
        const angle = (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(snaps[i]);
        const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
        const dif = Math.min(absDiff, Math.PI * 2 - absDiff);
        if (dif < tol) snapped = angle;
    }
    return snapped;
}
class $51a7f1533724cad7$export$f993aef960936087 extends (0, $8a20641017396900$export$eb2fcfdbd7ba97d4) {
    constructor(config){
        super(config);
        this._transforming = false;
        this._createElements();
        this._handleMouseMove = this._handleMouseMove.bind(this);
        this._handleMouseUp = this._handleMouseUp.bind(this);
        this.update = this.update.bind(this);
        this.on($51a7f1533724cad7$var$ATTR_CHANGE_LIST, this.update);
        if (this.getNode()) this.update();
    }
    attachTo(node) {
        this.setNode(node);
        return this;
    }
    setNode(node) {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.');
        return this.setNodes([
            node
        ]);
    }
    getNode() {
        return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
        return $51a7f1533724cad7$var$EVENTS_NAME + this._id;
    }
    setNodes(nodes = []) {
        if (this._nodes && this._nodes.length) this.detach();
        this._nodes = nodes;
        if (nodes.length === 1 && this.useSingleNodeRotation()) this.rotation(nodes[0].getAbsoluteRotation());
        else this.rotation(0);
        this._nodes.forEach((node)=>{
            const onChange = ()=>{
                if (this.nodes().length === 1 && this.useSingleNodeRotation()) this.rotation(this.nodes()[0].getAbsoluteRotation());
                this._resetTransformCache();
                if (!this._transforming && !this.isDragging()) this.update();
            };
            const additionalEvents = node._attrsAffectingSize.map((prop)=>prop + 'Change.' + this._getEventNamespace()).join(' ');
            node.on(additionalEvents, onChange);
            node.on($51a7f1533724cad7$var$TRANSFORM_CHANGE_STR.map((e)=>e + `.${this._getEventNamespace()}`).join(' '), onChange);
            node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange);
            this._proxyDrag(node);
        });
        this._resetTransformCache();
        var elementsCreated = !!this.findOne('.top-left');
        if (elementsCreated) this.update();
        return this;
    }
    _proxyDrag(node) {
        let lastPos;
        node.on(`dragstart.${this._getEventNamespace()}`, (e)=>{
            lastPos = node.getAbsolutePosition();
            if (!this.isDragging() && node !== this.findOne('.back')) this.startDrag(e, false);
        });
        node.on(`dragmove.${this._getEventNamespace()}`, (e)=>{
            if (!lastPos) return;
            const abs = node.getAbsolutePosition();
            const dx = abs.x - lastPos.x;
            const dy = abs.y - lastPos.y;
            this.nodes().forEach((otherNode)=>{
                if (otherNode === node) return;
                if (otherNode.isDragging()) return;
                const otherAbs = otherNode.getAbsolutePosition();
                otherNode.setAbsolutePosition({
                    x: otherAbs.x + dx,
                    y: otherAbs.y + dy
                });
                otherNode.startDrag(e);
            });
            lastPos = null;
        });
    }
    getNodes() {
        return this._nodes || [];
    }
    getActiveAnchor() {
        return this._movingAnchorName;
    }
    detach() {
        if (this._nodes) this._nodes.forEach((node)=>{
            node.off('.' + this._getEventNamespace());
        });
        this._nodes = [];
        this._resetTransformCache();
    }
    _resetTransformCache() {
        this._clearCache($51a7f1533724cad7$var$NODES_RECT);
        this._clearCache('transform');
        this._clearSelfAndDescendantCache('absoluteTransform');
    }
    _getNodeRect() {
        return this._getCache($51a7f1533724cad7$var$NODES_RECT, this.__getNodeRect);
    }
    __getNodeShape(node, rot = this.rotation(), relative) {
        var rect = node.getClientRect({
            skipTransform: true,
            skipShadow: true,
            skipStroke: this.ignoreStroke()
        });
        var absScale = node.getAbsoluteScale(relative);
        var absPos = node.getAbsolutePosition(relative);
        var dx = rect.x * absScale.x - node.offsetX() * absScale.x;
        var dy = rect.y * absScale.y - node.offsetY() * absScale.y;
        const rotation = ((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(node.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2);
        const box = {
            x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
            y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
            width: rect.width * absScale.x,
            height: rect.height * absScale.y,
            rotation: rotation
        };
        return $51a7f1533724cad7$var$rotateAroundPoint(box, -(0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(rot), {
            x: 0,
            y: 0
        });
    }
    __getNodeRect() {
        var node = this.getNode();
        if (!node) return {
            x: -$51a7f1533724cad7$var$MAX_SAFE_INTEGER,
            y: -$51a7f1533724cad7$var$MAX_SAFE_INTEGER,
            width: 0,
            height: 0,
            rotation: 0
        };
        const totalPoints = [];
        this.nodes().map((node)=>{
            const box = node.getClientRect({
                skipTransform: true,
                skipShadow: true,
                skipStroke: this.ignoreStroke()
            });
            var points = [
                {
                    x: box.x,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y + box.height
                },
                {
                    x: box.x,
                    y: box.y + box.height
                }
            ];
            var trans = node.getAbsoluteTransform();
            points.forEach(function(point) {
                var transformed = trans.point(point);
                totalPoints.push(transformed);
            });
        });
        const tr = new (0, $6436c4dfb94cdcf1$export$563a914cafbdc389)();
        tr.rotate(-(0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(this.rotation()));
        var minX, minY, maxX, maxY;
        totalPoints.forEach(function(point) {
            var transformed = tr.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        tr.invert();
        const p = tr.point({
            x: minX,
            y: minY
        });
        return {
            x: p.x,
            y: p.y,
            width: maxX - minX,
            height: maxY - minY,
            rotation: (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(this.rotation())
        };
    }
    getX() {
        return this._getNodeRect().x;
    }
    getY() {
        return this._getNodeRect().y;
    }
    getWidth() {
        return this._getNodeRect().width;
    }
    getHeight() {
        return this._getNodeRect().height;
    }
    _createElements() {
        this._createBack();
        $51a7f1533724cad7$var$ANCHORS_NAMES.forEach((function(name) {
            this._createAnchor(name);
        }).bind(this));
        this._createAnchor('rotater');
    }
    _createAnchor(name) {
        var anchor = new (0, $4cf8612870010584$export$c79fc6492f3af13d)({
            stroke: 'rgb(0, 161, 255)',
            fill: 'white',
            strokeWidth: 1,
            name: name + ' _anchor',
            dragDistance: 0,
            draggable: true,
            hitStrokeWidth: $51a7f1533724cad7$var$TOUCH_DEVICE ? 10 : 'auto'
        });
        var self = this;
        anchor.on('mousedown touchstart', function(e) {
            self._handleMouseDown(e);
        });
        anchor.on('dragstart', (e)=>{
            anchor.stopDrag();
            e.cancelBubble = true;
        });
        anchor.on('dragend', (e)=>{
            e.cancelBubble = true;
        });
        anchor.on('mouseenter', ()=>{
            var rad = (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(this.rotation());
            var cursor = $51a7f1533724cad7$var$getCursor(name, rad);
            anchor.getStage().content && (anchor.getStage().content.style.cursor = cursor);
            this._cursorChange = true;
        });
        anchor.on('mouseout', ()=>{
            anchor.getStage().content && (anchor.getStage().content.style.cursor = '');
            this._cursorChange = false;
        });
        this.add(anchor);
    }
    _createBack() {
        var back = new (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa)({
            name: 'back',
            width: 0,
            height: 0,
            draggable: true,
            sceneFunc (ctx) {
                var tr = this.getParent();
                var padding = tr.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, this.width() + padding * 2, this.height() + padding * 2);
                ctx.moveTo(this.width() / 2, -padding);
                if (tr.rotateEnabled()) ctx.lineTo(this.width() / 2, -tr.rotateAnchorOffset() * (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._sign(this.height()) - padding);
                ctx.fillStrokeShape(this);
            },
            hitFunc: (ctx, shape)=>{
                if (!this.shouldOverdrawWholeArea()) return;
                var padding = this.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.fillStrokeShape(shape);
            }
        });
        this.add(back);
        this._proxyDrag(back);
        back.on('dragstart', (e)=>{
            e.cancelBubble = true;
        });
        back.on('dragmove', (e)=>{
            e.cancelBubble = true;
        });
        back.on('dragend', (e)=>{
            e.cancelBubble = true;
        });
        this.on('dragmove', (e)=>{
            this.update();
        });
    }
    _handleMouseDown(e) {
        this._movingAnchorName = e.target.name().split(' ')[0];
        var attrs = this._getNodeRect();
        var width = attrs.width;
        var height = attrs.height;
        var hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
        this.sin = Math.abs(height / hypotenuse);
        this.cos = Math.abs(width / hypotenuse);
        if (typeof window !== 'undefined') {
            window.addEventListener('mousemove', this._handleMouseMove);
            window.addEventListener('touchmove', this._handleMouseMove);
            window.addEventListener('mouseup', this._handleMouseUp, true);
            window.addEventListener('touchend', this._handleMouseUp, true);
        }
        this._transforming = true;
        var ap = e.target.getAbsolutePosition();
        var pos = e.target.getStage().getPointerPosition();
        this._anchorDragOffset = {
            x: pos.x - ap.x,
            y: pos.y - ap.y
        };
        this._fire('transformstart', {
            evt: e.evt,
            target: this.getNode()
        });
        this._nodes.forEach((target)=>{
            target._fire('transformstart', {
                evt: e.evt,
                target: target
            });
        });
    }
    _handleMouseMove(e) {
        var x, y, newHypotenuse;
        var anchorNode = this.findOne('.' + this._movingAnchorName);
        var stage = anchorNode.getStage();
        stage.setPointersPositions(e);
        const pp = stage.getPointerPosition();
        let newNodePos = {
            x: pp.x - this._anchorDragOffset.x,
            y: pp.y - this._anchorDragOffset.y
        };
        const oldAbs = anchorNode.getAbsolutePosition();
        if (this.anchorDragBoundFunc()) newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
        anchorNode.setAbsolutePosition(newNodePos);
        const newAbs = anchorNode.getAbsolutePosition();
        if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) return;
        if (this._movingAnchorName === 'rotater') {
            var attrs = this._getNodeRect();
            x = anchorNode.x() - attrs.width / 2;
            y = -anchorNode.y() + attrs.height / 2;
            let delta = Math.atan2(-y, x) + Math.PI / 2;
            if (attrs.height < 0) delta -= Math.PI;
            var oldRotation = (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(this.rotation());
            const newRotation = oldRotation + delta;
            const tol = (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(this.rotationSnapTolerance());
            const snappedRot = $51a7f1533724cad7$var$getSnap(this.rotationSnaps(), newRotation, tol);
            const diff = snappedRot - attrs.rotation;
            const shape = $51a7f1533724cad7$var$rotateAroundCenter(attrs, diff);
            this._fitNodesInto(shape, e);
            return;
        }
        var keepProportion = this.keepRatio() || e.shiftKey;
        var centeredScaling = this.centeredScaling() || e.altKey;
        if (this._movingAnchorName === 'top-left') {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.bottom-right').x(),
                    y: this.findOne('.bottom-right').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                var reverseX = this.findOne('.top-left').x() > comparePoint.x ? -1 : 1;
                var reverseY = this.findOne('.top-left').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-left').x(comparePoint.x - x);
                this.findOne('.top-left').y(comparePoint.y - y);
            }
        } else if (this._movingAnchorName === 'top-center') this.findOne('.top-left').y(anchorNode.y());
        else if (this._movingAnchorName === 'top-right') {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.bottom-left').x(),
                    y: this.findOne('.bottom-left').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                var reverseX = this.findOne('.top-right').x() < comparePoint.x ? -1 : 1;
                var reverseY = this.findOne('.top-right').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-right').x(comparePoint.x + x);
                this.findOne('.top-right').y(comparePoint.y - y);
            }
            var pos = anchorNode.position();
            this.findOne('.top-left').y(pos.y);
            this.findOne('.bottom-right').x(pos.x);
        } else if (this._movingAnchorName === 'middle-left') this.findOne('.top-left').x(anchorNode.x());
        else if (this._movingAnchorName === 'middle-right') this.findOne('.bottom-right').x(anchorNode.x());
        else if (this._movingAnchorName === 'bottom-left') {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.top-right').x(),
                    y: this.findOne('.top-right').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                var reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
                var reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                anchorNode.x(comparePoint.x - x);
                anchorNode.y(comparePoint.y + y);
            }
            pos = anchorNode.position();
            this.findOne('.top-left').x(pos.x);
            this.findOne('.bottom-right').y(pos.y);
        } else if (this._movingAnchorName === 'bottom-center') this.findOne('.bottom-right').y(anchorNode.y());
        else if (this._movingAnchorName === 'bottom-right') {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.top-left').x(),
                    y: this.findOne('.top-left').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                var reverseX = this.findOne('.bottom-right').x() < comparePoint.x ? -1 : 1;
                var reverseY = this.findOne('.bottom-right').y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.bottom-right').x(comparePoint.x + x);
                this.findOne('.bottom-right').y(comparePoint.y + y);
            }
        } else console.error(new Error('Wrong position argument of selection resizer: ' + this._movingAnchorName));
        var centeredScaling = this.centeredScaling() || e.altKey;
        if (centeredScaling) {
            var topLeft = this.findOne('.top-left');
            var bottomRight = this.findOne('.bottom-right');
            var topOffsetX = topLeft.x();
            var topOffsetY = topLeft.y();
            var bottomOffsetX = this.getWidth() - bottomRight.x();
            var bottomOffsetY = this.getHeight() - bottomRight.y();
            bottomRight.move({
                x: -topOffsetX,
                y: -topOffsetY
            });
            topLeft.move({
                x: bottomOffsetX,
                y: bottomOffsetY
            });
        }
        var absPos = this.findOne('.top-left').getAbsolutePosition();
        x = absPos.x;
        y = absPos.y;
        var width = this.findOne('.bottom-right').x() - this.findOne('.top-left').x();
        var height = this.findOne('.bottom-right').y() - this.findOne('.top-left').y();
        this._fitNodesInto({
            x: x,
            y: y,
            width: width,
            height: height,
            rotation: (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(this.rotation())
        }, e);
    }
    _handleMouseUp(e) {
        this._removeEvents(e);
    }
    getAbsoluteTransform() {
        return this.getTransform();
    }
    _removeEvents(e) {
        if (this._transforming) {
            this._transforming = false;
            if (typeof window !== 'undefined') {
                window.removeEventListener('mousemove', this._handleMouseMove);
                window.removeEventListener('touchmove', this._handleMouseMove);
                window.removeEventListener('mouseup', this._handleMouseUp, true);
                window.removeEventListener('touchend', this._handleMouseUp, true);
            }
            var node = this.getNode();
            this._fire('transformend', {
                evt: e,
                target: node
            });
            if (node) this._nodes.forEach((target)=>{
                target._fire('transformend', {
                    evt: e,
                    target: target
                });
            });
            this._movingAnchorName = null;
        }
    }
    _fitNodesInto(newAttrs, evt) {
        var oldAttrs = this._getNodeRect();
        const minSize = 1;
        if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        if ((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        const allowNegativeScale = this.flipEnabled();
        var t = new (0, $6436c4dfb94cdcf1$export$563a914cafbdc389)();
        t.rotate((0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(this.rotation()));
        if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf('left') >= 0) {
            const offset = t.point({
                x: -this.padding() * 2,
                y: 0
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.width += this.padding() * 2;
            this._movingAnchorName = this._movingAnchorName.replace('left', 'right');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        } else if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf('right') >= 0) {
            const offset = t.point({
                x: this.padding() * 2,
                y: 0
            });
            this._movingAnchorName = this._movingAnchorName.replace('right', 'left');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.width += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        }
        if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf('top') >= 0) {
            const offset = t.point({
                x: 0,
                y: -this.padding() * 2
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            this._movingAnchorName = this._movingAnchorName.replace('top', 'bottom');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        } else if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf('bottom') >= 0) {
            const offset = t.point({
                x: 0,
                y: this.padding() * 2
            });
            this._movingAnchorName = this._movingAnchorName.replace('bottom', 'top');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        }
        if (this.boundBoxFunc()) {
            const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
            if (bounded) newAttrs = bounded;
            else (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('boundBoxFunc returned falsy. You should return new bound rect from it!');
        }
        const baseSize = 10000000;
        const oldTr = new (0, $6436c4dfb94cdcf1$export$563a914cafbdc389)();
        oldTr.translate(oldAttrs.x, oldAttrs.y);
        oldTr.rotate(oldAttrs.rotation);
        oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
        const newTr = new (0, $6436c4dfb94cdcf1$export$563a914cafbdc389)();
        newTr.translate(newAttrs.x, newAttrs.y);
        newTr.rotate(newAttrs.rotation);
        newTr.scale(newAttrs.width / baseSize, newAttrs.height / baseSize);
        const delta = newTr.multiply(oldTr.invert());
        this._nodes.forEach((node)=>{
            var _a;
            const parentTransform = node.getParent().getAbsoluteTransform();
            const localTransform = node.getTransform().copy();
            localTransform.translate(node.offsetX(), node.offsetY());
            const newLocalTransform = new (0, $6436c4dfb94cdcf1$export$563a914cafbdc389)();
            newLocalTransform.multiply(parentTransform.copy().invert()).multiply(delta).multiply(parentTransform).multiply(localTransform);
            const attrs = newLocalTransform.decompose();
            node.setAttrs(attrs);
            this._fire('transform', {
                evt: evt,
                target: node
            });
            node._fire('transform', {
                evt: evt,
                target: node
            });
            (_a = node.getLayer()) === null || _a === void 0 || _a.batchDraw();
        });
        this.rotation((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._getRotation(newAttrs.rotation));
        this._resetTransformCache();
        this.update();
        this.getLayer().batchDraw();
    }
    forceUpdate() {
        this._resetTransformCache();
        this.update();
    }
    _batchChangeChild(selector, attrs) {
        const anchor = this.findOne(selector);
        anchor.setAttrs(attrs);
    }
    update() {
        var _a;
        var attrs = this._getNodeRect();
        this.rotation((0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._getRotation(attrs.rotation));
        var width = attrs.width;
        var height = attrs.height;
        var enabledAnchors = this.enabledAnchors();
        var resizeEnabled = this.resizeEnabled();
        var padding = this.padding();
        var anchorSize = this.anchorSize();
        this.find('._anchor').forEach((node)=>{
            node.setAttrs({
                width: anchorSize,
                height: anchorSize,
                offsetX: anchorSize / 2,
                offsetY: anchorSize / 2,
                stroke: this.anchorStroke(),
                strokeWidth: this.anchorStrokeWidth(),
                fill: this.anchorFill(),
                cornerRadius: this.anchorCornerRadius()
            });
        });
        this._batchChangeChild('.top-left', {
            x: 0,
            y: 0,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-left') >= 0
        });
        this._batchChangeChild('.top-center', {
            x: width / 2,
            y: 0,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-center') >= 0
        });
        this._batchChangeChild('.top-right', {
            x: width,
            y: 0,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-right') >= 0
        });
        this._batchChangeChild('.middle-left', {
            x: 0,
            y: height / 2,
            offsetX: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-left') >= 0
        });
        this._batchChangeChild('.middle-right', {
            x: width,
            y: height / 2,
            offsetX: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-right') >= 0
        });
        this._batchChangeChild('.bottom-left', {
            x: 0,
            y: height,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-left') >= 0
        });
        this._batchChangeChild('.bottom-center', {
            x: width / 2,
            y: height,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-center') >= 0
        });
        this._batchChangeChild('.bottom-right', {
            x: width,
            y: height,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-right') >= 0
        });
        this._batchChangeChild('.rotater', {
            x: width / 2,
            y: -this.rotateAnchorOffset() * (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd)._sign(height) - padding,
            visible: this.rotateEnabled()
        });
        this._batchChangeChild('.back', {
            width: width,
            height: height,
            visible: this.borderEnabled(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            x: 0,
            y: 0
        });
        (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
    }
    isTransforming() {
        return this._transforming;
    }
    stopTransform() {
        if (this._transforming) {
            this._removeEvents();
            var anchorNode = this.findOne('.' + this._movingAnchorName);
            if (anchorNode) anchorNode.stopDrag();
        }
    }
    destroy() {
        if (this.getStage() && this._cursorChange) this.getStage().content && (this.getStage().content.style.cursor = '');
        (0, $8a20641017396900$export$eb2fcfdbd7ba97d4).prototype.destroy.call(this);
        this.detach();
        this._removeEvents();
        return this;
    }
    toObject() {
        return (0, $ea22cf9e3e585277$export$85c928794f8d04d4).prototype.toObject.call(this);
    }
    clone(obj) {
        var node = (0, $ea22cf9e3e585277$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        return node;
    }
    getClientRect() {
        if (this.nodes().length > 0) return super.getClientRect();
        else return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
function $51a7f1533724cad7$var$validateAnchors(val) {
    if (!(val instanceof Array)) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('enabledAnchors value should be an array');
    if (val instanceof Array) val.forEach(function(name) {
        if ($51a7f1533724cad7$var$ANCHORS_NAMES.indexOf(name) === -1) (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).warn('Unknown anchor name: ' + name + '. Available names are: ' + $51a7f1533724cad7$var$ANCHORS_NAMES.join(', '));
    });
    return val || [];
}
$51a7f1533724cad7$export$f993aef960936087.prototype.className = 'Transformer';
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($51a7f1533724cad7$export$f993aef960936087);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'enabledAnchors', $51a7f1533724cad7$var$ANCHORS_NAMES, $51a7f1533724cad7$var$validateAnchors);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'flipEnabled', true, (0, $2b769617cb7fb124$export$147fc8b6cd20fda1)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'resizeEnabled', true);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'anchorSize', 10, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'rotateEnabled', true);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'rotationSnaps', []);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'rotateAnchorOffset', 50, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'rotationSnapTolerance', 5, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'borderEnabled', true);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'anchorStroke', 'rgb(0, 161, 255)');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'anchorStrokeWidth', 1, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'anchorFill', 'white');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'anchorCornerRadius', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'borderStroke', 'rgb(0, 161, 255)');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'borderStrokeWidth', 1, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'borderDash');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'keepRatio', true);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'centeredScaling', false);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'ignoreStroke', false);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'padding', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'node');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'nodes');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'boundBoxFunc');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'anchorDragBoundFunc');
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'shouldOverdrawWholeArea', false);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($51a7f1533724cad7$export$f993aef960936087, 'useSingleNodeRotation', true);
(0, $43fd669de4de8956$export$8354032f3852ec50).backCompat($51a7f1533724cad7$export$f993aef960936087, {
    lineEnabled: 'borderEnabled',
    rotateHandlerOffset: 'rotateAnchorOffset',
    enabledHandlers: 'enabledAnchors'
});






class $664a955a4dc3aaa7$export$28718c7785907330 extends (0, $7579e2aa10cffa16$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.radius(), 0, (0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).getAngle(this.angle()), this.clockwise());
        context.lineTo(0, 0);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$664a955a4dc3aaa7$export$28718c7785907330.prototype.className = 'Wedge';
$664a955a4dc3aaa7$export$28718c7785907330.prototype._centroid = true;
$664a955a4dc3aaa7$export$28718c7785907330.prototype._attrsAffectingSize = [
    'radius'
];
(0, $d3b45fc6e7d35e7f$export$f7a70d87a5e829eb)($664a955a4dc3aaa7$export$28718c7785907330);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($664a955a4dc3aaa7$export$28718c7785907330, 'radius', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($664a955a4dc3aaa7$export$28718c7785907330, 'angle', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)());
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter($664a955a4dc3aaa7$export$28718c7785907330, 'clockwise', false);
(0, $43fd669de4de8956$export$8354032f3852ec50).backCompat($664a955a4dc3aaa7$export$28718c7785907330, {
    angleDeg: 'angle',
    getAngleDeg: 'getAngle',
    setAngleDeg: 'setAngle'
});





function $0861384211612f41$var$BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
}
var $0861384211612f41$var$mul_table = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
];
var $0861384211612f41$var$shg_table = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
function $0861384211612f41$var$filterGaussBlurRGBA(imageData, radius) {
    var pixels = imageData.data, width = imageData.width, height = imageData.height;
    var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
    var div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2, stackStart = new $0861384211612f41$var$BlurStack(), stackEnd = null, stack = stackStart, stackIn = null, stackOut = null, mul_sum = $0861384211612f41$var$mul_table[radius], shg_sum = $0861384211612f41$var$shg_table[radius];
    for(i = 1; i < div; i++){
        stack = stack.next = new $0861384211612f41$var$BlurStack();
        if (i === radiusPlus1) stackEnd = stack;
    }
    stack.next = stackStart;
    yw = yi = 0;
    for(y = 0; y < height; y++){
        r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        for(i = 1; i < radiusPlus1; i++){
            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
            r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for(x = 0; x < width; x++){
            pixels[yi + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa !== 0) {
                pa = 255 / pa;
                pixels[yi] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
            r_in_sum += stackIn.r = pixels[p];
            g_in_sum += stackIn.g = pixels[p + 1];
            b_in_sum += stackIn.b = pixels[p + 2];
            a_in_sum += stackIn.a = pixels[p + 3];
            r_sum += r_in_sum;
            g_sum += g_in_sum;
            b_sum += b_in_sum;
            a_sum += a_in_sum;
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for(x = 0; x < width; x++){
        g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
        yi = x << 2;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        yp = width;
        for(i = 1; i <= radius; i++){
            yi = yp + x << 2;
            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
            if (i < heightMinus1) yp += width;
        }
        yi = x;
        stackIn = stackStart;
        stackOut = stackEnd;
        for(y = 0; y < height; y++){
            p = yi << 2;
            pixels[p + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa > 0) {
                pa = 255 / pa;
                pixels[p] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
            r_sum += r_in_sum += stackIn.r = pixels[p];
            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
            a_sum += a_in_sum += stackIn.a = pixels[p + 3];
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += width;
        }
    }
}
const $0861384211612f41$export$975a268f2c733e4 = function Blur(imageData) {
    var radius = Math.round(this.blurRadius());
    if (radius > 0) $0861384211612f41$var$filterGaussBlurRGBA(imageData, radius);
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'blurRadius', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);





const $4bc9c4272bf02737$export$a2d0d82739cac11f = function(imageData) {
    var brightness = this.brightness() * 255, data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 4){
        data[i] += brightness;
        data[i + 1] += brightness;
        data[i + 2] += brightness;
    }
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'brightness', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);





const $06c7217fafdcf52f$export$656ae42051d0ca86 = function(imageData) {
    var adjust = Math.pow((this.contrast() + 100) / 100, 2);
    var data = imageData.data, nPixels = data.length, red = 150, green = 150, blue = 150, i;
    for(i = 0; i < nPixels; i += 4){
        red = data[i];
        green = data[i + 1];
        blue = data[i + 2];
        red /= 255;
        red -= 0.5;
        red *= adjust;
        red += 0.5;
        red *= 255;
        green /= 255;
        green -= 0.5;
        green *= adjust;
        green += 0.5;
        green *= 255;
        blue /= 255;
        blue -= 0.5;
        blue *= adjust;
        blue += 0.5;
        blue *= 255;
        red = red < 0 ? 0 : red > 255 ? 255 : red;
        green = green < 0 ? 0 : green > 255 ? 255 : green;
        blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
        data[i] = red;
        data[i + 1] = green;
        data[i + 2] = blue;
    }
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'contrast', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);






const $0c18f40b9c0aff43$export$3c8699b389eb838 = function(imageData) {
    var strength = this.embossStrength() * 10, greyLevel = this.embossWhiteLevel() * 255, direction = this.embossDirection(), blend = this.embossBlend(), dirY = 0, dirX = 0, data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
    switch(direction){
        case 'top-left':
            dirY = -1;
            dirX = -1;
            break;
        case 'top':
            dirY = -1;
            dirX = 0;
            break;
        case 'top-right':
            dirY = -1;
            dirX = 1;
            break;
        case 'right':
            dirY = 0;
            dirX = 1;
            break;
        case 'bottom-right':
            dirY = 1;
            dirX = 1;
            break;
        case 'bottom':
            dirY = 1;
            dirX = 0;
            break;
        case 'bottom-left':
            dirY = 1;
            dirX = -1;
            break;
        case 'left':
            dirY = 0;
            dirX = -1;
            break;
        default:
            (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error('Unknown emboss direction: ' + direction);
    }
    do {
        var offsetY = (y - 1) * w4;
        var otherY = dirY;
        if (y + otherY < 1) otherY = 0;
        if (y + otherY > h) otherY = 0;
        var offsetYOther = (y - 1 + otherY) * w * 4;
        var x = w;
        do {
            var offset = offsetY + (x - 1) * 4;
            var otherX = dirX;
            if (x + otherX < 1) otherX = 0;
            if (x + otherX > w) otherX = 0;
            var offsetOther = offsetYOther + (x - 1 + otherX) * 4;
            var dR = data[offset] - data[offsetOther];
            var dG = data[offset + 1] - data[offsetOther + 1];
            var dB = data[offset + 2] - data[offsetOther + 2];
            var dif = dR;
            var absDif = dif > 0 ? dif : -dif;
            var absG = dG > 0 ? dG : -dG;
            var absB = dB > 0 ? dB : -dB;
            if (absG > absDif) dif = dG;
            if (absB > absDif) dif = dB;
            dif *= strength;
            if (blend) {
                var r = data[offset] + dif;
                var g = data[offset + 1] + dif;
                var b = data[offset + 2] + dif;
                data[offset] = r > 255 ? 255 : r < 0 ? 0 : r;
                data[offset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
                data[offset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
            } else {
                var grey = greyLevel - dif;
                if (grey < 0) grey = 0;
                else if (grey > 255) grey = 255;
                data[offset] = data[offset + 1] = data[offset + 2] = grey;
            }
        }while (--x);
    }while (--y);
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'embossStrength', 0.5, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'embossWhiteLevel', 0.5, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'embossDirection', 'top-left', null, (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'embossBlend', false, null, (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);





function $394e1d1cfcb6d78e$var$remap(fromValue, fromMin, fromMax, toMin, toMax) {
    var fromRange = fromMax - fromMin, toRange = toMax - toMin, toValue;
    if (fromRange === 0) return toMin + toRange / 2;
    if (toRange === 0) return toMin;
    toValue = (fromValue - fromMin) / fromRange;
    toValue = toRange * toValue + toMin;
    return toValue;
}
const $394e1d1cfcb6d78e$export$5cb8e8388f951d6f = function(imageData) {
    var data = imageData.data, nSubPixels = data.length, rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b, i;
    var enhanceAmount = this.enhance();
    if (enhanceAmount === 0) return;
    for(i = 0; i < nSubPixels; i += 4){
        r = data[i + 0];
        if (r < rMin) rMin = r;
        else if (r > rMax) rMax = r;
        g = data[i + 1];
        if (g < gMin) gMin = g;
        else if (g > gMax) gMax = g;
        b = data[i + 2];
        if (b < bMin) bMin = b;
        else if (b > bMax) bMax = b;
    }
    if (rMax === rMin) {
        rMax = 255;
        rMin = 0;
    }
    if (gMax === gMin) {
        gMax = 255;
        gMin = 0;
    }
    if (bMax === bMin) {
        bMax = 255;
        bMin = 0;
    }
    var rMid, rGoalMax, rGoalMin, gMid, gGoalMax, gGoalMin, bMid, bGoalMax, bGoalMin;
    if (enhanceAmount > 0) {
        rGoalMax = rMax + enhanceAmount * (255 - rMax);
        rGoalMin = rMin - enhanceAmount * (rMin - 0);
        gGoalMax = gMax + enhanceAmount * (255 - gMax);
        gGoalMin = gMin - enhanceAmount * (gMin - 0);
        bGoalMax = bMax + enhanceAmount * (255 - bMax);
        bGoalMin = bMin - enhanceAmount * (bMin - 0);
    } else {
        rMid = (rMax + rMin) * 0.5;
        rGoalMax = rMax + enhanceAmount * (rMax - rMid);
        rGoalMin = rMin + enhanceAmount * (rMin - rMid);
        gMid = (gMax + gMin) * 0.5;
        gGoalMax = gMax + enhanceAmount * (gMax - gMid);
        gGoalMin = gMin + enhanceAmount * (gMin - gMid);
        bMid = (bMax + bMin) * 0.5;
        bGoalMax = bMax + enhanceAmount * (bMax - bMid);
        bGoalMin = bMin + enhanceAmount * (bMin - bMid);
    }
    for(i = 0; i < nSubPixels; i += 4){
        data[i + 0] = $394e1d1cfcb6d78e$var$remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
        data[i + 1] = $394e1d1cfcb6d78e$var$remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
        data[i + 2] = $394e1d1cfcb6d78e$var$remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
    }
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'enhance', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);


const $e8cf718ad675c9d5$export$e2b0a794e83ca071 = function(imageData) {
    var data = imageData.data, len = data.length, i, brightness;
    for(i = 0; i < len; i += 4){
        brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
        data[i] = brightness;
        data[i + 1] = brightness;
        data[i + 2] = brightness;
    }
};





(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'hue', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'saturation', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'luminance', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);
const $0ea30805e3a68c2d$export$46d8b0f9bc8f87a2 = function(imageData) {
    var data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127, i;
    var vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    var r, g, b, a;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b + l;
        data[i + 1] = gr * r + gg * g + gb * b + l;
        data[i + 2] = br * r + bg * g + bb * b + l;
        data[i + 3] = a;
    }
};





const $0ec95f1e76e8249c$export$d2edaecd208aed43 = function(imageData) {
    var data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, i;
    var vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    var r, g, b, a;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b;
        data[i + 1] = gr * r + gg * g + gb * b;
        data[i + 2] = br * r + bg * g + bb * b;
        data[i + 3] = a;
    }
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'hue', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'saturation', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'value', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);


const $e309bdba40744bbf$export$1073348d81b17440 = function(imageData) {
    var data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 4){
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
    }
};






var $8ed50eb0f6f80009$var$ToPolar = function(src, dst, opt) {
    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, r = 0, g = 0, b = 0, a = 0;
    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    var rSize = ySize, tSize = xSize, radius, theta;
    var conversion = 360 / tSize * Math.PI / 180, sin, cos;
    for(theta = 0; theta < tSize; theta += 1){
        sin = Math.sin(theta * conversion);
        cos = Math.cos(theta * conversion);
        for(radius = 0; radius < rSize; radius += 1){
            x = Math.floor(xMid + rMax * radius / rSize * cos);
            y = Math.floor(yMid + rMax * radius / rSize * sin);
            i = (y * xSize + x) * 4;
            r = srcPixels[i + 0];
            g = srcPixels[i + 1];
            b = srcPixels[i + 2];
            a = srcPixels[i + 3];
            i = (theta + radius * xSize) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
var $8ed50eb0f6f80009$var$FromPolar = function(src, dst, opt) {
    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, dx, dy, r = 0, g = 0, b = 0, a = 0;
    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    var rSize = ySize, tSize = xSize, radius, theta, phaseShift = opt.polarRotation || 0;
    var x1, y1;
    for(x = 0; x < xSize; x += 1)for(y = 0; y < ySize; y += 1){
        dx = x - xMid;
        dy = y - yMid;
        radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
        theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
        theta = theta * tSize / 360;
        x1 = Math.floor(theta);
        y1 = Math.floor(radius);
        i = (y1 * xSize + x1) * 4;
        r = srcPixels[i + 0];
        g = srcPixels[i + 1];
        b = srcPixels[i + 2];
        a = srcPixels[i + 3];
        i = (y * xSize + x) * 4;
        dstPixels[i + 0] = r;
        dstPixels[i + 1] = g;
        dstPixels[i + 2] = b;
        dstPixels[i + 3] = a;
    }
};
const $8ed50eb0f6f80009$export$e731e8a0fd067155 = function(imageData) {
    var xSize = imageData.width, ySize = imageData.height;
    var x, y, xoff, i, r, g, b, a, srcPos, dstPos;
    var power = Math.round(this.kaleidoscopePower());
    var angle = Math.round(this.kaleidoscopeAngle());
    var offset = Math.floor(xSize * (angle % 360) / 360);
    if (power < 1) return;
    var tempCanvas = (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).createCanvasElement();
    tempCanvas.width = xSize;
    tempCanvas.height = ySize;
    var scratchData = tempCanvas.getContext('2d').getImageData(0, 0, xSize, ySize);
    (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).releaseCanvas(tempCanvas);
    $8ed50eb0f6f80009$var$ToPolar(imageData, scratchData, {
        polarCenterX: xSize / 2,
        polarCenterY: ySize / 2
    });
    var minSectionSize = xSize / Math.pow(2, power);
    while(minSectionSize <= 8){
        minSectionSize = minSectionSize * 2;
        power -= 1;
    }
    minSectionSize = Math.ceil(minSectionSize);
    var sectionSize = minSectionSize;
    var xStart = 0, xEnd = sectionSize, xDelta = 1;
    if (offset + minSectionSize > xSize) {
        xStart = sectionSize;
        xEnd = 0;
        xDelta = -1;
    }
    for(y = 0; y < ySize; y += 1)for(x = xStart; x !== xEnd; x += xDelta){
        xoff = Math.round(x + offset) % xSize;
        srcPos = (xSize * y + xoff) * 4;
        r = scratchData.data[srcPos + 0];
        g = scratchData.data[srcPos + 1];
        b = scratchData.data[srcPos + 2];
        a = scratchData.data[srcPos + 3];
        dstPos = (xSize * y + x) * 4;
        scratchData.data[dstPos + 0] = r;
        scratchData.data[dstPos + 1] = g;
        scratchData.data[dstPos + 2] = b;
        scratchData.data[dstPos + 3] = a;
    }
    for(y = 0; y < ySize; y += 1){
        sectionSize = Math.floor(minSectionSize);
        for(i = 0; i < power; i += 1){
            for(x = 0; x < sectionSize + 1; x += 1){
                srcPos = (xSize * y + x) * 4;
                r = scratchData.data[srcPos + 0];
                g = scratchData.data[srcPos + 1];
                b = scratchData.data[srcPos + 2];
                a = scratchData.data[srcPos + 3];
                dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
                scratchData.data[dstPos + 0] = r;
                scratchData.data[dstPos + 1] = g;
                scratchData.data[dstPos + 2] = b;
                scratchData.data[dstPos + 3] = a;
            }
            sectionSize *= 2;
        }
    }
    $8ed50eb0f6f80009$var$FromPolar(scratchData, imageData, {
        polarRotation: 0
    });
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'kaleidoscopePower', 2, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'kaleidoscopeAngle', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);





function $03ac618e3a05eca5$var$pixelAt(idata, x, y) {
    var idx = (y * idata.width + x) * 4;
    var d = [];
    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
    return d;
}
function $03ac618e3a05eca5$var$rgbDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2) + Math.pow(p1[2] - p2[2], 2));
}
function $03ac618e3a05eca5$var$rgbMean(pTab) {
    var m = [
        0,
        0,
        0
    ];
    for(var i = 0; i < pTab.length; i++){
        m[0] += pTab[i][0];
        m[1] += pTab[i][1];
        m[2] += pTab[i][2];
    }
    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;
    return m;
}
function $03ac618e3a05eca5$var$backgroundMask(idata, threshold) {
    var rgbv_no = $03ac618e3a05eca5$var$pixelAt(idata, 0, 0);
    var rgbv_ne = $03ac618e3a05eca5$var$pixelAt(idata, idata.width - 1, 0);
    var rgbv_so = $03ac618e3a05eca5$var$pixelAt(idata, 0, idata.height - 1);
    var rgbv_se = $03ac618e3a05eca5$var$pixelAt(idata, idata.width - 1, idata.height - 1);
    var thres = threshold || 10;
    if ($03ac618e3a05eca5$var$rgbDistance(rgbv_no, rgbv_ne) < thres && $03ac618e3a05eca5$var$rgbDistance(rgbv_ne, rgbv_se) < thres && $03ac618e3a05eca5$var$rgbDistance(rgbv_se, rgbv_so) < thres && $03ac618e3a05eca5$var$rgbDistance(rgbv_so, rgbv_no) < thres) {
        var mean = $03ac618e3a05eca5$var$rgbMean([
            rgbv_ne,
            rgbv_no,
            rgbv_se,
            rgbv_so
        ]);
        var mask = [];
        for(var i = 0; i < idata.width * idata.height; i++){
            var d = $03ac618e3a05eca5$var$rgbDistance(mean, [
                idata.data[i * 4],
                idata.data[i * 4 + 1],
                idata.data[i * 4 + 2]
            ]);
            mask[i] = d < thres ? 0 : 255;
        }
        return mask;
    }
}
function $03ac618e3a05eca5$var$applyMask(idata, mask) {
    for(var i = 0; i < idata.width * idata.height; i++)idata.data[4 * i + 3] = mask[i];
}
function $03ac618e3a05eca5$var$erodeMask(mask, sw, sh) {
    var weights = [
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a === 2040 ? 255 : 0;
    }
    return maskResult;
}
function $03ac618e3a05eca5$var$dilateMask(mask, sw, sh) {
    var weights = [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a >= 1020 ? 255 : 0;
    }
    return maskResult;
}
function $03ac618e3a05eca5$var$smoothEdgeMask(mask, sw, sh) {
    var weights = [
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a;
    }
    return maskResult;
}
const $03ac618e3a05eca5$export$991dcf7284de63d = function(imageData) {
    var threshold = this.threshold(), mask = $03ac618e3a05eca5$var$backgroundMask(imageData, threshold);
    if (mask) {
        mask = $03ac618e3a05eca5$var$erodeMask(mask, imageData.width, imageData.height);
        mask = $03ac618e3a05eca5$var$dilateMask(mask, imageData.width, imageData.height);
        mask = $03ac618e3a05eca5$var$smoothEdgeMask(mask, imageData.width, imageData.height);
        $03ac618e3a05eca5$var$applyMask(imageData, mask);
    }
    return imageData;
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'threshold', 0, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);





const $f841ce5b5d4a9635$export$484d33a0500a4ce1 = function(imageData) {
    var amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2, i;
    for(i = 0; i < nPixels; i += 4){
        data[i + 0] += half - 2 * half * Math.random();
        data[i + 1] += half - 2 * half * Math.random();
        data[i + 2] += half - 2 * half * Math.random();
    }
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'noise', 0.2, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);






const $9bec57d3e90fab84$export$63396595bf5aeaa7 = function(imageData) {
    var pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, x, y, i, red, green, blue, alpha, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), xBinStart, xBinEnd, yBinStart, yBinEnd, xBin, yBin, pixelsInBin, data = imageData.data;
    if (pixelSize <= 0) {
        (0, $6436c4dfb94cdcf1$export$f8f26dd395d7e1bd).error('pixelSize value can not be <= 0');
        return;
    }
    for(xBin = 0; xBin < nBinsX; xBin += 1)for(yBin = 0; yBin < nBinsY; yBin += 1){
        red = 0;
        green = 0;
        blue = 0;
        alpha = 0;
        xBinStart = xBin * pixelSize;
        xBinEnd = xBinStart + pixelSize;
        yBinStart = yBin * pixelSize;
        yBinEnd = yBinStart + pixelSize;
        pixelsInBin = 0;
        for(x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                i = (width * y + x) * 4;
                red += data[i + 0];
                green += data[i + 1];
                blue += data[i + 2];
                alpha += data[i + 3];
                pixelsInBin += 1;
            }
        }
        red = red / pixelsInBin;
        green = green / pixelsInBin;
        blue = blue / pixelsInBin;
        alpha = alpha / pixelsInBin;
        for(x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                i = (width * y + x) * 4;
                data[i + 0] = red;
                data[i + 1] = green;
                data[i + 2] = blue;
                data[i + 3] = alpha;
            }
        }
    }
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'pixelSize', 8, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);





const $ad5c70b625adcfc3$export$ccda2563bc5d1354 = function(imageData) {
    var levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels, i;
    for(i = 0; i < len; i += 1)data[i] = Math.floor(data[i] / scale) * scale;
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'levels', 0.5, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);





const $36c2b059054ee354$export$8f9ece5a47764b93 = function(imageData) {
    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), i, brightness;
    for(i = 0; i < nPixels; i += 4){
        brightness = (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
        data[i] = brightness * red;
        data[i + 1] = brightness * green;
        data[i + 2] = brightness * blue;
        data[i + 3] = data[i + 3];
    }
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'red', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'green', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'blue', 0, (0, $2b769617cb7fb124$export$af51e4581c640b27), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);





const $a424564bf6a9d5b7$export$f50470518fe8f14a = function(imageData) {
    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha(), i, ia;
    for(i = 0; i < nPixels; i += 4){
        ia = 1 - alpha;
        data[i] = red * alpha + data[i] * ia;
        data[i + 1] = green * alpha + data[i + 1] * ia;
        data[i + 2] = blue * alpha + data[i + 2] * ia;
    }
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'red', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'green', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'blue', 0, (0, $2b769617cb7fb124$export$af51e4581c640b27), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'alpha', 1, function(val) {
    this._filterUpToDate = false;
    if (val > 1) return 1;
    else if (val < 0) return 0;
    else return val;
});


const $c57ba51cb4494eae$export$1eeb4741c69006fa = function(imageData) {
    var data = imageData.data, nPixels = data.length, i, r, g, b;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
        data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
        data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
    }
};


const $eaf5f24b0fd5bc70$export$d60d51c3865bca60 = function(imageData) {
    var data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
    do {
        var offsetY = (y - 1) * w4;
        var x = w;
        do {
            var offset = offsetY + (x - 1) * 4;
            var r = data[offset];
            var g = data[offset + 1];
            var b = data[offset + 2];
            if (r > 127) r = 255 - r;
            if (g > 127) g = 255 - g;
            if (b > 127) b = 255 - b;
            data[offset] = r;
            data[offset + 1] = g;
            data[offset + 2] = b;
        }while (--x);
    }while (--y);
};





const $0db8f23b95cb0220$export$14f770b2ce0bb8ad = function(imageData) {
    var level = this.threshold() * 255, data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 1)data[i] = data[i] < level ? 0 : 255;
};
(0, $43fd669de4de8956$export$8354032f3852ec50).addGetterSetter((0, $ea22cf9e3e585277$export$85c928794f8d04d4), 'threshold', 0.5, (0, $2b769617cb7fb124$export$6b1205b9fbe7de2c)(), (0, $43fd669de4de8956$export$8354032f3852ec50).afterSetFilter);


const $605d5ca2be88a805$export$b9f99057a3c7692 = (0, $37b3e1b602f2ccc4$export$b9f99057a3c7692).Util._assign((0, $37b3e1b602f2ccc4$export$b9f99057a3c7692), {
    Arc: $8467c55359661a31$export$6ef80ffb606dd232,
    Arrow: $69d2ab2236f98032$export$21b07c8f274aebd5,
    Circle: $61a17316c09bc361$export$c89a927ffc67e6fa,
    Ellipse: $4e034defe93312dd$export$80b0269ab108fa11,
    Image: $9a5a968d6cfaaa88$export$3e431a229df88919,
    Label: $878039b7ffb52884$export$b04be29aa201d4f5,
    Tag: $878039b7ffb52884$export$3288d34c523a1192,
    Line: $8924c9b616ae3a6f$export$17d680238e50603e,
    Path: $ad6f67fb366d225a$export$4b2950bdac9b6ee9,
    Rect: $4cf8612870010584$export$c79fc6492f3af13d,
    RegularPolygon: $918bbfc35f663434$export$e2ee866164812ecd,
    Ring: $3940d1d297e341ba$export$a6e3577650b6d6d7,
    Sprite: $75d41bd59c068fc0$export$3075603db8e6204c,
    Star: $549e1efa909e0fc3$export$1644ba17714857f1,
    Text: $ac5933f2b3817561$export$5f1af8db9871e1d6,
    TextPath: $acea4bbf0026aba8$export$f7e34a95cc06fac7,
    Transformer: $51a7f1533724cad7$export$f993aef960936087,
    Wedge: $664a955a4dc3aaa7$export$28718c7785907330,
    Filters: {
        Blur: $0861384211612f41$export$975a268f2c733e4,
        Brighten: $4bc9c4272bf02737$export$a2d0d82739cac11f,
        Contrast: $06c7217fafdcf52f$export$656ae42051d0ca86,
        Emboss: $0c18f40b9c0aff43$export$3c8699b389eb838,
        Enhance: $394e1d1cfcb6d78e$export$5cb8e8388f951d6f,
        Grayscale: $e8cf718ad675c9d5$export$e2b0a794e83ca071,
        HSL: $0ea30805e3a68c2d$export$46d8b0f9bc8f87a2,
        HSV: $0ec95f1e76e8249c$export$d2edaecd208aed43,
        Invert: $e309bdba40744bbf$export$1073348d81b17440,
        Kaleidoscope: $8ed50eb0f6f80009$export$e731e8a0fd067155,
        Mask: $03ac618e3a05eca5$export$991dcf7284de63d,
        Noise: $f841ce5b5d4a9635$export$484d33a0500a4ce1,
        Pixelate: $9bec57d3e90fab84$export$63396595bf5aeaa7,
        Posterize: $ad5c70b625adcfc3$export$ccda2563bc5d1354,
        RGB: $36c2b059054ee354$export$8f9ece5a47764b93,
        RGBA: $a424564bf6a9d5b7$export$f50470518fe8f14a,
        Sepia: $c57ba51cb4494eae$export$1eeb4741c69006fa,
        Solarize: $eaf5f24b0fd5bc70$export$d60d51c3865bca60,
        Threshold: $0db8f23b95cb0220$export$14f770b2ce0bb8ad
    }
});


var $a8839d08a3625fc0$export$2e2bcd8739ae039 = (0, $605d5ca2be88a805$export$b9f99057a3c7692);


/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */ 
var $ltGt3 = parcelRequire("ltGt3");

var $3c1917c8988d6dfa$export$2e2bcd8739ae039 = (0, $37b3e1b602f2ccc4$export$b9f99057a3c7692);


var $f613be559085490c$exports = {};
'use strict';

$f613be559085490c$exports = (parcelRequire("c6zfL"));


var $8bde4037a6f58438$exports = {};
'use strict';

$8bde4037a6f58438$exports = (parcelRequire("3Ibga"));


var $35d8004b92e83b95$exports = {};

$parcel$export($35d8004b92e83b95$exports, "appendInitialChild", () => $35d8004b92e83b95$export$b1cefef778e97ee8);
$parcel$export($35d8004b92e83b95$exports, "createInstance", () => $35d8004b92e83b95$export$99152e8d49ca4e7d);
$parcel$export($35d8004b92e83b95$exports, "createTextInstance", () => $35d8004b92e83b95$export$d1ef805cf7083486);
$parcel$export($35d8004b92e83b95$exports, "finalizeInitialChildren", () => $35d8004b92e83b95$export$7bb0b211bcb5abfd);
$parcel$export($35d8004b92e83b95$exports, "getPublicInstance", () => $35d8004b92e83b95$export$d2475cc200518c86);
$parcel$export($35d8004b92e83b95$exports, "prepareForCommit", () => $35d8004b92e83b95$export$ba5994afaabfdb0c);
$parcel$export($35d8004b92e83b95$exports, "preparePortalMount", () => $35d8004b92e83b95$export$e15c8ecd0a0092b2);
$parcel$export($35d8004b92e83b95$exports, "prepareUpdate", () => $35d8004b92e83b95$export$c885331d842f22b5);
$parcel$export($35d8004b92e83b95$exports, "resetAfterCommit", () => $35d8004b92e83b95$export$683e88f306512aed);
$parcel$export($35d8004b92e83b95$exports, "resetTextContent", () => $35d8004b92e83b95$export$2119d6fc5d6f51aa);
$parcel$export($35d8004b92e83b95$exports, "shouldDeprioritizeSubtree", () => $35d8004b92e83b95$export$70ab89a99d11d186);
$parcel$export($35d8004b92e83b95$exports, "getRootHostContext", () => $35d8004b92e83b95$export$dce2ca0b0f5feeb5);
$parcel$export($35d8004b92e83b95$exports, "getChildHostContext", () => $35d8004b92e83b95$export$1236a84b6992d37a);
$parcel$export($35d8004b92e83b95$exports, "scheduleTimeout", () => $35d8004b92e83b95$export$5f4d6617421d489b);
$parcel$export($35d8004b92e83b95$exports, "cancelTimeout", () => $35d8004b92e83b95$export$f78ec70d8091ca88);
$parcel$export($35d8004b92e83b95$exports, "noTimeout", () => $35d8004b92e83b95$export$78506abae4a4951d);
$parcel$export($35d8004b92e83b95$exports, "shouldSetTextContent", () => $35d8004b92e83b95$export$c82139d6d374ec34);
$parcel$export($35d8004b92e83b95$exports, "isPrimaryRenderer", () => $35d8004b92e83b95$export$a5fcb8abea5b71a4);
$parcel$export($35d8004b92e83b95$exports, "warnsIfNotActing", () => $35d8004b92e83b95$export$2516db7323c01bd5);
$parcel$export($35d8004b92e83b95$exports, "supportsMutation", () => $35d8004b92e83b95$export$20f97ad47f9ebeb);
$parcel$export($35d8004b92e83b95$exports, "appendChild", () => $35d8004b92e83b95$export$1b8e57c9ea42f1d2);
$parcel$export($35d8004b92e83b95$exports, "appendChildToContainer", () => $35d8004b92e83b95$export$5e391de19acdf645);
$parcel$export($35d8004b92e83b95$exports, "insertBefore", () => $35d8004b92e83b95$export$86b68c7dbeb53c22);
$parcel$export($35d8004b92e83b95$exports, "insertInContainerBefore", () => $35d8004b92e83b95$export$7ec3655259385e44);
$parcel$export($35d8004b92e83b95$exports, "removeChild", () => $35d8004b92e83b95$export$7ae609f7af59e4f7);
$parcel$export($35d8004b92e83b95$exports, "removeChildFromContainer", () => $35d8004b92e83b95$export$2e4ef5d75a473f1a);
$parcel$export($35d8004b92e83b95$exports, "commitTextUpdate", () => $35d8004b92e83b95$export$50a92d0155bee474);
$parcel$export($35d8004b92e83b95$exports, "commitMount", () => $35d8004b92e83b95$export$fe90794743fbfeb0);
$parcel$export($35d8004b92e83b95$exports, "commitUpdate", () => $35d8004b92e83b95$export$fd8222818e57ec6);
$parcel$export($35d8004b92e83b95$exports, "hideInstance", () => $35d8004b92e83b95$export$6db9fd2b8188b8b7);
$parcel$export($35d8004b92e83b95$exports, "hideTextInstance", () => $35d8004b92e83b95$export$17ed9cbd9cb3aad2);
$parcel$export($35d8004b92e83b95$exports, "unhideInstance", () => $35d8004b92e83b95$export$933e25c2090d1941);
$parcel$export($35d8004b92e83b95$exports, "unhideTextInstance", () => $35d8004b92e83b95$export$8ff685cdcb7326ff);
$parcel$export($35d8004b92e83b95$exports, "clearContainer", () => $35d8004b92e83b95$export$28e08eff11ac64f6);
$parcel$export($35d8004b92e83b95$exports, "detachDeletedInstance", () => $35d8004b92e83b95$export$92ab91999be04e45);
$parcel$export($35d8004b92e83b95$exports, "getCurrentEventPriority", () => $35d8004b92e83b95$export$e23f0d5a7e18b951);
$parcel$export($35d8004b92e83b95$exports, "now", () => (parcelRequire("hZysK")).unstable_now);
$parcel$export($35d8004b92e83b95$exports, "idlePriority", () => (parcelRequire("hZysK")).unstable_IdlePriority);
$parcel$export($35d8004b92e83b95$exports, "run", () => (parcelRequire("hZysK")).unstable_runWithPriority);


const $7d60248576b519c7$var$propsToSkip = {
    children: true,
    ref: true,
    key: true,
    style: true,
    forwardedRef: true,
    unstable_applyCache: true,
    unstable_applyDrawHitFromCache: true
};
let $7d60248576b519c7$var$zIndexWarningShowed = false;
let $7d60248576b519c7$var$dragWarningShowed = false;
const $7d60248576b519c7$export$3a20cc353cdae1b2 = '.react-konva-event';
let $7d60248576b519c7$var$useStrictMode = false;
function $7d60248576b519c7$export$5a38dcef855281ce(value) {
    $7d60248576b519c7$var$useStrictMode = value;
}
const $7d60248576b519c7$var$DRAGGABLE_WARNING = `ReactKonva: You have a Konva node with draggable = true and position defined but no onDragMove or onDragEnd events are handled.
Position of a node will be changed during drag&drop, so you should update state of the react app as well.
Consider to add onDragMove or onDragEnd events.
For more info see: https://github.com/konvajs/react-konva/issues/256
`;
const $7d60248576b519c7$var$Z_INDEX_WARNING = `ReactKonva: You are using "zIndex" attribute for a Konva node.
react-konva may get confused with ordering. Just define correct order of elements in your render function of a component.
For more info see: https://github.com/konvajs/react-konva/issues/194
`;
const $7d60248576b519c7$var$EMPTY_PROPS = {};
function $7d60248576b519c7$export$25d4dd8d7c7a61f6(instance, props, oldProps = $7d60248576b519c7$var$EMPTY_PROPS) {
    // don't use zIndex in react-konva
    if (!$7d60248576b519c7$var$zIndexWarningShowed && 'zIndex' in props) {
        console.warn($7d60248576b519c7$var$Z_INDEX_WARNING);
        $7d60248576b519c7$var$zIndexWarningShowed = true;
    }
    // check correct draggable usage
    if (!$7d60248576b519c7$var$dragWarningShowed && props.draggable) {
        var hasPosition = props.x !== undefined || props.y !== undefined;
        var hasEvents = props.onDragEnd || props.onDragMove;
        if (hasPosition && !hasEvents) {
            console.warn($7d60248576b519c7$var$DRAGGABLE_WARNING);
            $7d60248576b519c7$var$dragWarningShowed = true;
        }
    }
    // check old props
    // we need to unset properties that are not in new props
    // and remove all events
    for(var key in oldProps){
        if ($7d60248576b519c7$var$propsToSkip[key]) continue;
        var isEvent = key.slice(0, 2) === 'on';
        var propChanged = oldProps[key] !== props[key];
        // if that is a changed event, we need to remove it
        if (isEvent && propChanged) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === 'content') eventName = 'content' + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
            instance.off(eventName, oldProps[key]);
        }
        var toRemove = !props.hasOwnProperty(key);
        if (toRemove) instance.setAttr(key, undefined);
    }
    var strictUpdate = $7d60248576b519c7$var$useStrictMode || props._useStrictMode;
    var updatedProps = {};
    var hasUpdates = false;
    const newEvents = {};
    for(var key in props){
        if ($7d60248576b519c7$var$propsToSkip[key]) continue;
        var isEvent = key.slice(0, 2) === 'on';
        var toAdd = oldProps[key] !== props[key];
        if (isEvent && toAdd) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === 'content') eventName = 'content' + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
            // check that event is not undefined
            if (props[key]) newEvents[eventName] = props[key];
        }
        if (!isEvent && (props[key] !== oldProps[key] || strictUpdate && props[key] !== instance.getAttr(key))) {
            hasUpdates = true;
            updatedProps[key] = props[key];
        }
    }
    if (hasUpdates) {
        instance.setAttrs(updatedProps);
        $7d60248576b519c7$export$8d64f55d8bab80d4(instance);
    }
    // subscribe to events AFTER we set attrs
    // we need it to fix https://github.com/konvajs/react-konva/issues/471
    // settings attrs may add events. Like "draggable: true" will add "mousedown" listener
    for(var eventName in newEvents)instance.on(eventName + $7d60248576b519c7$export$3a20cc353cdae1b2, newEvents[eventName]);
}
function $7d60248576b519c7$export$8d64f55d8bab80d4(node) {
    if (!(0, $d3b45fc6e7d35e7f$export$b9f99057a3c7692).autoDrawEnabled) {
        var drawingNode = node.getLayer() || node.getStage();
        drawingNode && drawingNode.batchDraw();
    }
}



var $hZysK = parcelRequire("hZysK");

const $35d8004b92e83b95$var$NO_CONTEXT = {};
const $35d8004b92e83b95$var$UPDATE_SIGNAL = {};
// for react-spring capability
(0, $3c1917c8988d6dfa$export$2e2bcd8739ae039).Node.prototype._applyProps = (0, $7d60248576b519c7$export$25d4dd8d7c7a61f6);
function $35d8004b92e83b95$export$b1cefef778e97ee8(parentInstance, child) {
    if (typeof child === 'string') {
        // Noop for string children of Text (eg <Text>foo</Text>)
        console.error(`Do not use plain text as child of Konva.Node. You are using text: ${child}`);
        return;
    }
    parentInstance.add(child);
    (0, $7d60248576b519c7$export$8d64f55d8bab80d4)(parentInstance);
}
function $35d8004b92e83b95$export$99152e8d49ca4e7d(type, props, internalInstanceHandle) {
    let NodeClass = (0, $3c1917c8988d6dfa$export$2e2bcd8739ae039)[type];
    if (!NodeClass) {
        console.error(`Konva has no node with the type ${type}. Group will be used instead. If you use minimal version of react-konva, just import required nodes into Konva: "import "konva/lib/shapes/${type}"  If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html`);
        NodeClass = (0, $3c1917c8988d6dfa$export$2e2bcd8739ae039).Group;
    }
    // we need to split props into events and non events
    // we we can pass non events into constructor directly
    // that way the performance should be better
    // we we apply change "applyNodeProps"
    // then it will trigger change events on first run
    // but we don't need them!
    const propsWithoutEvents = {};
    const propsWithOnlyEvents = {};
    for(var key in props){
        var isEvent = key.slice(0, 2) === 'on';
        if (isEvent) propsWithOnlyEvents[key] = props[key];
        else propsWithoutEvents[key] = props[key];
    }
    const instance = new NodeClass(propsWithoutEvents);
    (0, $7d60248576b519c7$export$25d4dd8d7c7a61f6)(instance, propsWithOnlyEvents);
    return instance;
}
function $35d8004b92e83b95$export$d1ef805cf7083486(text, rootContainerInstance, internalInstanceHandle) {
    console.error(`Text components are not supported for now in ReactKonva. Your text is: "${text}"`);
}
function $35d8004b92e83b95$export$7bb0b211bcb5abfd(domElement, type, props) {
    return false;
}
function $35d8004b92e83b95$export$d2475cc200518c86(instance) {
    return instance;
}
function $35d8004b92e83b95$export$ba5994afaabfdb0c() {
    return null;
}
function $35d8004b92e83b95$export$e15c8ecd0a0092b2() {
    return null;
}
function $35d8004b92e83b95$export$c885331d842f22b5(domElement, type, oldProps, newProps) {
    return $35d8004b92e83b95$var$UPDATE_SIGNAL;
}
function $35d8004b92e83b95$export$683e88f306512aed() {
// Noop
}
function $35d8004b92e83b95$export$2119d6fc5d6f51aa(domElement) {
// Noop
}
function $35d8004b92e83b95$export$70ab89a99d11d186(type, props) {
    return false;
}
function $35d8004b92e83b95$export$dce2ca0b0f5feeb5() {
    return $35d8004b92e83b95$var$NO_CONTEXT;
}
function $35d8004b92e83b95$export$1236a84b6992d37a() {
    return $35d8004b92e83b95$var$NO_CONTEXT;
}
const $35d8004b92e83b95$export$5f4d6617421d489b = setTimeout;
const $35d8004b92e83b95$export$f78ec70d8091ca88 = clearTimeout;
const $35d8004b92e83b95$export$78506abae4a4951d = -1;
function $35d8004b92e83b95$export$c82139d6d374ec34(type, props) {
    return false;
}
const $35d8004b92e83b95$export$a5fcb8abea5b71a4 = false;
const $35d8004b92e83b95$export$2516db7323c01bd5 = true;
const $35d8004b92e83b95$export$20f97ad47f9ebeb = true;
function $35d8004b92e83b95$export$1b8e57c9ea42f1d2(parentInstance, child) {
    if (child.parent === parentInstance) child.moveToTop();
    else parentInstance.add(child);
    (0, $7d60248576b519c7$export$8d64f55d8bab80d4)(parentInstance);
}
function $35d8004b92e83b95$export$5e391de19acdf645(parentInstance, child) {
    if (child.parent === parentInstance) child.moveToTop();
    else parentInstance.add(child);
    (0, $7d60248576b519c7$export$8d64f55d8bab80d4)(parentInstance);
}
function $35d8004b92e83b95$export$86b68c7dbeb53c22(parentInstance, child, beforeChild) {
    // child._remove() will not stop dragging
    // but child.remove() will stop it, but we don't need it
    // removing will reset zIndexes
    child._remove();
    parentInstance.add(child);
    child.setZIndex(beforeChild.getZIndex());
    (0, $7d60248576b519c7$export$8d64f55d8bab80d4)(parentInstance);
}
function $35d8004b92e83b95$export$7ec3655259385e44(parentInstance, child, beforeChild) {
    $35d8004b92e83b95$export$86b68c7dbeb53c22(parentInstance, child, beforeChild);
}
function $35d8004b92e83b95$export$7ae609f7af59e4f7(parentInstance, child) {
    child.destroy();
    child.off((0, $7d60248576b519c7$export$3a20cc353cdae1b2));
    (0, $7d60248576b519c7$export$8d64f55d8bab80d4)(parentInstance);
}
function $35d8004b92e83b95$export$2e4ef5d75a473f1a(parentInstance, child) {
    child.destroy();
    child.off((0, $7d60248576b519c7$export$3a20cc353cdae1b2));
    (0, $7d60248576b519c7$export$8d64f55d8bab80d4)(parentInstance);
}
function $35d8004b92e83b95$export$50a92d0155bee474(textInstance, oldText, newText) {
    console.error(`Text components are not yet supported in ReactKonva. You text is: "${newText}"`);
}
function $35d8004b92e83b95$export$fe90794743fbfeb0(instance, type, newProps) {
// Noop
}
function $35d8004b92e83b95$export$fd8222818e57ec6(instance, updatePayload, type, oldProps, newProps) {
    (0, $7d60248576b519c7$export$25d4dd8d7c7a61f6)(instance, newProps, oldProps);
}
function $35d8004b92e83b95$export$6db9fd2b8188b8b7(instance) {
    instance.hide();
    (0, $7d60248576b519c7$export$8d64f55d8bab80d4)(instance);
}
function $35d8004b92e83b95$export$17ed9cbd9cb3aad2(textInstance) {
// Noop
}
function $35d8004b92e83b95$export$933e25c2090d1941(instance, props) {
    if (props.visible == null || props.visible) instance.show();
}
function $35d8004b92e83b95$export$8ff685cdcb7326ff(textInstance, text) {
// Noop
}
function $35d8004b92e83b95$export$28e08eff11ac64f6(container) {
// Noop
}
function $35d8004b92e83b95$export$92ab91999be04e45() {}
const $35d8004b92e83b95$export$e23f0d5a7e18b951 = ()=>(0, $8bde4037a6f58438$exports.DefaultEventPriority);




var $ltGt3 = parcelRequire("ltGt3");
var $41fce269d83e40d0$var$__defProp = Object.defineProperty;
var $41fce269d83e40d0$var$__defProps = Object.defineProperties;
var $41fce269d83e40d0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $41fce269d83e40d0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $41fce269d83e40d0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $41fce269d83e40d0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $41fce269d83e40d0$var$__defNormalProp = (obj, key, value)=>key in obj ? $41fce269d83e40d0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $41fce269d83e40d0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($41fce269d83e40d0$var$__hasOwnProp.call(b, prop)) $41fce269d83e40d0$var$__defNormalProp(a, prop, b[prop]);
    if ($41fce269d83e40d0$var$__getOwnPropSymbols) {
        for (var prop of $41fce269d83e40d0$var$__getOwnPropSymbols(b))if ($41fce269d83e40d0$var$__propIsEnum.call(b, prop)) $41fce269d83e40d0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $41fce269d83e40d0$var$__spreadProps = (a, b)=>$41fce269d83e40d0$var$__defProps(a, $41fce269d83e40d0$var$__getOwnPropDescs(b));
var $41fce269d83e40d0$var$_a;
function $41fce269d83e40d0$export$e2f435051054a3fd(fiber, ascending, selector) {
    if (!fiber) return;
    if (selector(fiber) === true) return fiber;
    let child = ascending ? fiber.return : fiber.child;
    while(child){
        const match = $41fce269d83e40d0$export$e2f435051054a3fd(child, ascending, selector);
        if (match) return match;
        child = ascending ? null : child.sibling;
    }
}
function $41fce269d83e40d0$var$wrapContext(context) {
    try {
        return Object.defineProperties(context, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch (_) {
        return context;
    }
}
const $41fce269d83e40d0$var$FiberContext = $41fce269d83e40d0$var$wrapContext($ltGt3.createContext(null));
class $41fce269d83e40d0$export$5a20fcbfd44d38b7 extends $ltGt3.Component {
    render() {
        return /* @__PURE__ */ $ltGt3.createElement($41fce269d83e40d0$var$FiberContext.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
const { ReactCurrentOwner: $41fce269d83e40d0$var$ReactCurrentOwner, ReactCurrentDispatcher: $41fce269d83e40d0$var$ReactCurrentDispatcher } = ($41fce269d83e40d0$var$_a = $ltGt3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) != null ? $41fce269d83e40d0$var$_a : {};
function $41fce269d83e40d0$export$69c8591d5df5c7d6() {
    const root = $ltGt3.useContext($41fce269d83e40d0$var$FiberContext);
    const id = $ltGt3.useId();
    const fiber = $ltGt3.useMemo(()=>{
        var _a2;
        return (_a2 = $41fce269d83e40d0$var$ReactCurrentOwner == null ? void 0 : $41fce269d83e40d0$var$ReactCurrentOwner.current) != null ? _a2 : $41fce269d83e40d0$export$e2f435051054a3fd(root, false, (node)=>{
            let state = node.memoizedState;
            while(state){
                if (state.memoizedState === id) return true;
                state = state.next;
            }
        });
    }, [
        root,
        id
    ]);
    return fiber;
}
function $41fce269d83e40d0$export$b537cf6ebaf7ff54() {
    const fiber = $41fce269d83e40d0$export$69c8591d5df5c7d6();
    const root = $ltGt3.useMemo(()=>$41fce269d83e40d0$export$e2f435051054a3fd(fiber, true, (node)=>{
            var _a2;
            return ((_a2 = node.stateNode) == null ? void 0 : _a2.containerInfo) != null;
        }), [
        fiber
    ]);
    return root == null ? void 0 : root.stateNode.containerInfo;
}
function $41fce269d83e40d0$export$aec415ac1d7388b6(type) {
    const fiber = $41fce269d83e40d0$export$69c8591d5df5c7d6();
    const childRef = $ltGt3.useRef();
    $ltGt3.useLayoutEffect(()=>{
        var _a2;
        childRef.current = (_a2 = $41fce269d83e40d0$export$e2f435051054a3fd(fiber, false, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a2.stateNode;
    }, [
        fiber
    ]);
    return childRef;
}
function $41fce269d83e40d0$export$b57c9fdd1434988b(type) {
    const fiber = $41fce269d83e40d0$export$69c8591d5df5c7d6();
    const parentRef = $ltGt3.useRef();
    $ltGt3.useLayoutEffect(()=>{
        var _a2;
        parentRef.current = (_a2 = $41fce269d83e40d0$export$e2f435051054a3fd(fiber, true, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a2.stateNode;
    }, [
        fiber
    ]);
    return parentRef;
}
function $41fce269d83e40d0$export$39579d26c695d393() {
    var _a2, _b;
    const fiber = $41fce269d83e40d0$export$69c8591d5df5c7d6();
    const [contexts] = $ltGt3.useState(()=>/* @__PURE__ */ new Map());
    contexts.clear();
    let node = fiber;
    while(node){
        const context = (_a2 = node.type) == null ? void 0 : _a2._context;
        if (context && context !== $41fce269d83e40d0$var$FiberContext && !contexts.has(context)) contexts.set(context, (_b = $41fce269d83e40d0$var$ReactCurrentDispatcher == null ? void 0 : $41fce269d83e40d0$var$ReactCurrentDispatcher.current) == null ? void 0 : _b.readContext($41fce269d83e40d0$var$wrapContext(context)));
        node = node.return;
    }
    return $ltGt3.useMemo(()=>Array.from(contexts.keys()).reduce((Prev, context)=>(props)=>/* @__PURE__ */ $ltGt3.createElement(Prev, null, /* @__PURE__ */ $ltGt3.createElement(context.Provider, $41fce269d83e40d0$var$__spreadProps($41fce269d83e40d0$var$__spreadValues({}, props), {
                    value: contexts.get(context)
                }))), (props)=>/* @__PURE__ */ $ltGt3.createElement($41fce269d83e40d0$export$5a20fcbfd44d38b7, $41fce269d83e40d0$var$__spreadValues({}, props))), [
        contexts
    ]);
}


'use strict';
function $05ecbc6bf305678c$var$usePrevious(value) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useLayoutEffect(()=>{
        ref.current = value;
    });
    return ref.current;
}
const $05ecbc6bf305678c$var$StageWrap = (props)=>{
    const container = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef();
    const stage = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef();
    const fiberRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef();
    const oldProps = $05ecbc6bf305678c$var$usePrevious(props);
    const Bridge = (0, $41fce269d83e40d0$export$39579d26c695d393)();
    const _setRef = (stage)=>{
        const { forwardedRef: forwardedRef } = props;
        if (!forwardedRef) return;
        if (typeof forwardedRef === 'function') forwardedRef(stage);
        else forwardedRef.current = stage;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useLayoutEffect(()=>{
        stage.current = new (0, $3c1917c8988d6dfa$export$2e2bcd8739ae039).Stage({
            width: props.width,
            height: props.height,
            container: container.current
        });
        _setRef(stage.current);
        // @ts-ignore
        fiberRef.current = $05ecbc6bf305678c$export$1998d71d1bc35390.createContainer(stage.current, (0, $8bde4037a6f58438$exports.LegacyRoot), false, null);
        $05ecbc6bf305678c$export$1998d71d1bc35390.updateContainer((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(Bridge, {}, props.children), fiberRef.current);
        return ()=>{
            if (!(0, $3c1917c8988d6dfa$export$2e2bcd8739ae039).isBrowser) return;
            _setRef(null);
            $05ecbc6bf305678c$export$1998d71d1bc35390.updateContainer(null, fiberRef.current, null);
            stage.current.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useLayoutEffect(()=>{
        _setRef(stage.current);
        (0, $7d60248576b519c7$export$25d4dd8d7c7a61f6)(stage.current, props, oldProps);
        $05ecbc6bf305678c$export$1998d71d1bc35390.updateContainer((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(Bridge, {}, props.children), fiberRef.current, null);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement('div', {
        ref: container,
        accessKey: props.accessKey,
        className: props.className,
        role: props.role,
        style: props.style,
        tabIndex: props.tabIndex,
        title: props.title
    });
};
const $05ecbc6bf305678c$export$936d0764594b6eb3 = 'Layer';
const $05ecbc6bf305678c$export$92d64f29192d1118 = 'FastLayer';
const $05ecbc6bf305678c$export$eb2fcfdbd7ba97d4 = 'Group';
const $05ecbc6bf305678c$export$b04be29aa201d4f5 = 'Label';
const $05ecbc6bf305678c$export$c79fc6492f3af13d = 'Rect';
const $05ecbc6bf305678c$export$c89a927ffc67e6fa = 'Circle';
const $05ecbc6bf305678c$export$80b0269ab108fa11 = 'Ellipse';
const $05ecbc6bf305678c$export$28718c7785907330 = 'Wedge';
const $05ecbc6bf305678c$export$17d680238e50603e = 'Line';
const $05ecbc6bf305678c$export$3075603db8e6204c = 'Sprite';
const $05ecbc6bf305678c$export$3e431a229df88919 = 'Image';
const $05ecbc6bf305678c$export$5f1af8db9871e1d6 = 'Text';
const $05ecbc6bf305678c$export$f7e34a95cc06fac7 = 'TextPath';
const $05ecbc6bf305678c$export$1644ba17714857f1 = 'Star';
const $05ecbc6bf305678c$export$a6e3577650b6d6d7 = 'Ring';
const $05ecbc6bf305678c$export$6ef80ffb606dd232 = 'Arc';
const $05ecbc6bf305678c$export$3288d34c523a1192 = 'Tag';
const $05ecbc6bf305678c$export$4b2950bdac9b6ee9 = 'Path';
const $05ecbc6bf305678c$export$e2ee866164812ecd = 'RegularPolygon';
const $05ecbc6bf305678c$export$21b07c8f274aebd5 = 'Arrow';
const $05ecbc6bf305678c$export$6428a7f2611ef1fa = 'Shape';
const $05ecbc6bf305678c$export$f993aef960936087 = 'Transformer';
const $05ecbc6bf305678c$export$1998d71d1bc35390 = (0, (/*@__PURE__*/$parcel$interopDefault($f613be559085490c$exports)))($35d8004b92e83b95$exports);
$05ecbc6bf305678c$export$1998d71d1bc35390.injectIntoDevTools({
    // @ts-ignore
    findHostInstanceByFiber: ()=>null,
    bundleType: 0,
    version: (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).version,
    rendererPackageName: 'react-konva'
});
const $05ecbc6bf305678c$export$208cd1682bd0e4b6 = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $41fce269d83e40d0$export$5a20fcbfd44d38b7), {}, (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement($05ecbc6bf305678c$var$StageWrap, {
        ...props,
        forwardedRef: ref
    }));
});
const $05ecbc6bf305678c$export$2e548393fba9b338 = (0, $7d60248576b519c7$export$5a38dcef855281ce);


'use strict';





var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
function $0b74b96b3af31f54$export$8a36538c679950a6(initialValue) {
    const [state, setState] = (0, $ltGt3.useState)(initialValue);
    const ref = (0, $ltGt3.useRef)(initialValue);
    (0, $ltGt3.useEffect)(()=>{
        ref.current = state;
    }, [
        state
    ]);
    return [
        state,
        setState,
        ref
    ];
}


function $83a8040be81947e5$export$79263550b33b988b(node) {
    // the function will return pointer position relative to the passed node
    var transform = node.getStage().getAbsoluteTransform().copy();
    // to detect relative position we need to invert transform
    transform.invert();
    // get pointer (say mouse or touch) position
    var pos = node.getStage().getPointerPosition();
    // now we find relative point
    return transform.point(pos);
}


function $9674c66452d92412$export$b030b56241a00d8a({ onElementDrawn: onElementDrawn }) {
    const [firstPoint, setFirstPoint, firstPointRef] = (0, $0b74b96b3af31f54$export$8a36538c679950a6)(null);
    const [currentPoint, setCurrentPoint, currentPointRef] = (0, $0b74b96b3af31f54$export$8a36538c679950a6)(null);
    const [pointsList, setPointsList, pointsListRef] = (0, $0b74b96b3af31f54$export$8a36538c679950a6)([]);
    const [dimensions, setDimensions, dimensionsRef] = (0, $0b74b96b3af31f54$export$8a36538c679950a6)([]);
    const layerRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    (0, $ltGt3.useEffect)(()=>{
        const onClick = (e)=>{
            const { x: x, y: y } = (0, $83a8040be81947e5$export$79263550b33b988b)(e.target);
            if (!firstPointRef.current) setFirstPoint({
                x: x,
                y: y
            });
            else {
                let xDif = pointsListRef.current[pointsListRef.current.length - 2] - x;
                let yDif = pointsListRef.current[pointsListRef.current.length - 1] - y;
                let side = xDif * xDif + yDif * yDif;
                setDimensions((current)=>[
                        ...current,
                        side
                    ]);
            }
            setPointsList((current)=>[
                    ...current,
                    x,
                    y
                ]);
        //console.log(`mouse down: (${x}, ${y})`)
        };
        const onMouseMove = (e)=>{
            if (!firstPointRef.current) return;
            const { x: mouseX, y: mouseY } = (0, $83a8040be81947e5$export$79263550b33b988b)(e.target);
            setCurrentPoint({
                x: mouseX,
                y: mouseY
            });
        //console.log(`mouse move: ( ${mouseX}, ${mouseY})`)
        };
        const onDblClick = (e)=>{
            setPointsList((current)=>{
                const newPoints = current.slice(0, current.length - 4);
                return newPoints;
            });
            let xDif = pointsListRef.current[pointsListRef.current.length - 2] - pointsListRef.current[0];
            let yDif = pointsListRef.current[pointsListRef.current.length - 1] - pointsListRef.current[1];
            let side = xDif * xDif + yDif * yDif;
            setDimensions((current)=>[
                    ...current,
                    side
                ]);
            onElementDrawn({
                type: 'polygon',
                props: {
                    points: pointsListRef.current,
                    closed: true
                }
            });
            setFirstPoint(null);
            setCurrentPoint(null);
            setPointsList(null);
        };
        const stage = layerRef.current.getStage();
        stage.on('click', onClick);
        stage.on('mousemove', onMouseMove);
        stage.on('dblclick', onDblClick);
        return ()=>{
            if (stage) {
                stage.off('click', onClick);
                stage.off('mousemove', onMouseMove);
                stage.off('dblclick', onDblClick);
            }
        };
    }, [
        onElementDrawn
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $05ecbc6bf305678c$export$936d0764594b6eb3), {
        ref: layerRef,
        opacity: 0.7,
        children: [
            firstPoint && pointsList.length > 1 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$17d680238e50603e), {
                strokeScaleEnabled: false,
                stroke: "blue",
                points: pointsList
            }),
            firstPoint && currentPoint && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$17d680238e50603e), {
                stroke: "blue",
                strokeScaleEnabled: false,
                points: [
                    pointsList[pointsList.length - 2],
                    pointsList[pointsList.length - 1],
                    currentPoint.x,
                    currentPoint.y
                ]
            })
        ]
    });
}




var $ltGt3 = parcelRequire("ltGt3");



function $1d79f0d8a5f07b81$export$fe423fb41d33947e({ onElementDrawn: onElementDrawn }) {
    const [topLeftCorner, setTopLeftCorner, topLeftCornerRef] = (0, $0b74b96b3af31f54$export$8a36538c679950a6)(null);
    const [dimensions, setDimensions, dimensionsRef] = (0, $0b74b96b3af31f54$export$8a36538c679950a6)({
        width: 0,
        height: 0
    });
    const layerRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    (0, $ltGt3.useEffect)(()=>{
        const onMouseDown = (e)=>{
            const { x: x, y: y } = (0, $83a8040be81947e5$export$79263550b33b988b)(e.target);
            setTopLeftCorner({
                x: x,
                y: y
            });
        };
        const onMouseMove = (e)=>{
            if (!topLeftCornerRef.current) return;
            const { x: x, y: y } = topLeftCornerRef.current;
            const { x: mouseX, y: mouseY } = (0, $83a8040be81947e5$export$79263550b33b988b)(e.target);
            const width = mouseX - x;
            const height = mouseY - y;
            const rotation = 0;
            setDimensions({
                width: width,
                height: height
            });
        };
        const onMouseUp = (e)=>{
            if (!topLeftCornerRef.current) return;
            let x1 = topLeftCornerRef.current.x;
            let x2 = x1 + dimensionsRef.current.width;
            let y1 = topLeftCornerRef.current.y;
            let y2 = y1 + dimensionsRef.current.height;
            if (x1 > x2) [x1, x2] = [
                x2,
                x1
            ];
            if (y1 > y2) [y1, y2] = [
                y2,
                y1
            ];
            onElementDrawn({
                type: 'rect',
                props: {
                    x: Math.floor(x1),
                    y: Math.floor(y1),
                    width: Math.floor(x2 - x1),
                    height: Math.floor(y2 - y1)
                }
            });
            setTopLeftCorner(null);
        };
        const stage = layerRef.current.getStage();
        stage.on('mousedown', onMouseDown);
        stage.on('mousemove', onMouseMove);
        stage.on('mouseup', onMouseUp);
        return ()=>{
            if (stage) {
                stage.off('mousedown', onMouseDown);
                stage.off('mousemove', onMouseMove);
                stage.off('mouseup', onMouseUp);
            }
        };
    }, [
        onElementDrawn
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$936d0764594b6eb3), {
        ref: layerRef,
        opacity: 0.7,
        children: topLeftCorner && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$c79fc6492f3af13d), {
            fill: "blue",
            x: topLeftCorner.x,
            y: topLeftCorner.y,
            width: dimensions.width,
            height: dimensions.height
        })
    });
}




var $ltGt3 = parcelRequire("ltGt3");

function $ab516254d88810f8$export$79585ef54c4b94ae(props) {
    const { points: points = [] } = props.element.props;
    const [pointsVisible, setPointsVisible] = (0, $ltGt3.useState)(true);
    const updatePoints = (0, $ltGt3.useCallback)((points)=>{
        props.onChange?.({
            type: props.element.type,
            elementId: props.element.elementId,
            name: props.element.name,
            shapeType: props.element.shapeType,
            props: {
                ...props.element.props,
                points: points
            }
        });
    }, [
        props.onChange
    ]);
    (0, $ltGt3.useEffect)(()=>{
        const handleDragStart = ()=>{
            const shape = props.shapeRef.current;
            const attributes = shape.getAttrs();
            const { x: x, y: y } = attributes;
            console.log(x, y);
            setPointsVisible(false);
        };
        const handleDragEnd = (e)=>{
            const shape = props.shapeRef.current;
            const attributes = shape.getAttrs();
            const { x: x, y: y } = attributes;
            // dirty hack: move changes x and y props, but we instead adjust coordinates, so x and y will need to be reset to 0
            shape.x(0);
            shape.y(0);
            updatePoints(points.map((coordinate, index)=>{
                const isX = index % 2 === 0;
                if (isX) return coordinate + x;
                else return coordinate + y;
            }));
            setPointsVisible(true);
        };
        props.shapeRef.current.on('dragstart', handleDragStart);
        props.shapeRef.current.on('dragend', handleDragEnd);
        return ()=>{
            if (props.shapeRef.current) {
                props.shapeRef.current.off('dragstart', handleDragStart);
                props.shapeRef.current.off('dragend', handleDragEnd);
            }
        };
    }, [
        props.shapeRef.current,
        points
    ]);
    const elements = [];
    for(let i = 0; i < points.length; i += 2){
        const x = points[i];
        const y = points[i + 1];
        const pointIndex = i;
        if (props.mode === 'edit') elements.push(/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$80b0269ab108fa11), {
            stroke: 'blue',
            draggable: true,
            listening: true,
            x: x,
            y: y,
            radiusX: 20,
            radiusY: 20,
            onDragMove: (e)=>{
                const newX = e.target.x();
                const newY = e.target.y();
                updatePoints(points.map((coordinate, index)=>{
                    if (index === pointIndex) return newX;
                    else if (index === pointIndex + 1) return newY;
                    else return coordinate;
                }));
            }
        }, i));
        const prevX = points[i >= 2 ? i - 2 : points.length - 2];
        const prevY = points[i >= 2 ? i - 1 : points.length - 1];
        elements.push(/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$17d680238e50603e), {
            stroke: "blue",
            strokeWidth: 3,
            points: [
                prevX,
                prevY,
                x,
                y
            ]
        }, `line-${i}`));
    }
    console.log('highlighted edge', props.transformerLayerProps?.highlightedEdge);
    if (props.transformerLayerProps?.highlightedEdge) elements.push(/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$17d680238e50603e), {
        points: props.transformerLayerProps?.highlightedEdge,
        stroke: "red",
        strokeWidth: 30
    }, "highlited-edge"));
    if (!pointsVisible) return null;
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$eb2fcfdbd7ba97d4), {
        children: elements
    });
} // export function PolygonTransformerLayer(props: TransformerLayerProps) {
 //   props.element.props.points
 //   const handleChange = (e) => {
 //     const shape = props.shapeRef.current
 //     const attributes = shape.getAttrs()
 //     const newProps: Record<string, any> = {}
 //     for (const attributeName of attributesWhitelist) {
 //       let value = attributes[attributeName]
 //       if (Array.isArray(value) && typeof value[0] === 'number') {
 //         value.map((point) => Math.round(point))
 //       }
 //       newProps[attributeName] = value
 //     }
 //     props.onChange?.({
 //       type: props.element.type,
 //       elementId: props.element.elementId,
 //       name: props.element.name,
 //       shapeType: props.element.shapeType,
 //       props: newProps,
 //     })
 //   }
 //   return (
 //     <Transformer
 //       flipEnabled={false}
 //       rotateEnabled={props.mode === 'edit'}
 //       ref={props.transformerRef}
 //       draggable={props.mode === 'edit'}
 //       borderEnabled={true}
 //       resizeEnabled={props.mode === 'edit'}
 //       onDragMove={handleChange}
 //       onTransform={handleChange}
 //     />
 //   )
 // }




var $ltGt3 = parcelRequire("ltGt3");

const $e6da93d0e2f9e49f$var$attributesWhitelist = [
    'x',
    'y',
    'width',
    'height',
    'rotation'
];
function $e6da93d0e2f9e49f$export$f02fd88a8648f0c5(props) {
    const rotationRef = (0, $ltGt3.useRef)(props.shapeRef.current?.getAttr('rotation'));
    const handleChangeDrag = (e)=>{
        const shape = props.shapeRef.current;
        const attributes = shape.getAttrs();
        const newProps = {};
        for (const attributeName of $e6da93d0e2f9e49f$var$attributesWhitelist){
            let value = attributes[attributeName];
            if (typeof value === 'number') value = Math.round(value);
            newProps[attributeName] = value;
        }
        props.onChange?.({
            type: props.element.type,
            elementId: props.element.elementId,
            name: props.element.name,
            shapeType: props.element.shapeType,
            props: newProps
        });
    };
    const handleChangeTransform = (e)=>{
        const shape = props.shapeRef.current;
        const attributes = shape.getAttrs();
        // fix for bug in Konva - when rotation happens using transformer,
        // it can also change width and height on the element itself (if it was
        // changed previously), so we can't take rotation+width+height every time
        // and need to update rotation alone if it changes. rotationRef is used
        // to track current value to understand if it was changed
        if (rotationRef.current !== attributes.rotation) {
            rotationRef.current = attributes.rotation;
            props.onChange?.({
                type: props.element.type,
                elementId: props.element.elementId,
                name: props.element.name,
                shapeType: props.element.shapeType,
                props: {
                    ...props.element.props,
                    rotation: attributes.rotation,
                    x: attributes.x,
                    y: attributes.y
                }
            });
            return;
        }
        const newProps = {};
        for (const attributeName of $e6da93d0e2f9e49f$var$attributesWhitelist){
            let value = attributes[attributeName];
            if (attributeName === 'width') {
                console.log(value);
                value = value * attributes.scaleX;
            }
            if (attributeName === 'height') value = value * attributes.scaleY;
            if (typeof value === 'number') value = Math.round(value);
            newProps[attributeName] = value;
            shape.setAttr(attributeName, value);
        }
        shape.scaleX(1);
        shape.scaleY(1);
        props.onChange?.({
            type: props.element.type,
            elementId: props.element.elementId,
            name: props.element.name,
            shapeType: props.element.shapeType,
            props: newProps
        });
    };
    // TODO: blinking after resize
    (0, $ltGt3.useEffect)(()=>{
        const shape = props.shapeRef.current;
        shape.scaleX(1);
        shape.scaleY(1);
    }, [
        props.element
    ]);
    const cleanupTransform = (e)=>{
        const shape = props.shapeRef.current;
        const attributes = shape.getAttrs();
        attributes.scaleX = 1;
        attributes.scaleY = 1;
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$f993aef960936087), {
        flipEnabled: false,
        rotateEnabled: props.mode === 'edit',
        ref: props.transformerRef,
        draggable: props.mode === 'edit',
        borderEnabled: true,
        resizeEnabled: props.mode === 'edit',
        onDragMove: handleChangeDrag,
        onTransform: handleChangeTransform
    });
}





var $ltGt3 = parcelRequire("ltGt3");


var $1e0519456d104339$var$DeleteOutlined = function DeleteOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $f0cb76f7105de4ab$export$2e2bcd8739ae039)
    }));
};
/**![delete](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2MCAxODRoLThjNC40IDAgOC0zLjYgOC04djhoMzA0di04YzAgNC40IDMuNiA4IDggOGgtOHY3Mmg3MnYtODBjMC0zNS4zLTI4LjctNjQtNjQtNjRIMzUyYy0zNS4zIDAtNjQgMjguNy02NCA2NHY4MGg3MnYtNzJ6bTUwNCA3MkgxNjBjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjMyYzAgNC40IDMuNiA4IDggOGg2MC40bDI0LjcgNTIzYzEuNiAzNC4xIDI5LjggNjEgNjMuOSA2MWg0NTRjMzQuMiAwIDYyLjMtMjYuOCA2My45LTYxbDI0LjctNTIzSDg4OGM0LjQgMCA4LTMuNiA4LTh2LTMyYzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MzEuMyA4NDBIMjkyLjdsLTI0LjItNTEyaDQ4N2wtMjQuMiA1MTJ6IiAvPjwvc3ZnPg==) */ var $1e0519456d104339$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($1e0519456d104339$var$DeleteOutlined);
var $1e0519456d104339$export$2e2bcd8739ae039 = $1e0519456d104339$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");


var $da40d833ab151490$var$PlusOutlined = function PlusOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $5650f03a968134d9$export$2e2bcd8739ae039)
    }));
};
/**![plus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4MiAxNTJoNjBxOCAwIDggOHY3MDRxMCA4LTggOGgtNjBxLTggMC04LThWMTYwcTAtOCA4LTh6IiAvPjxwYXRoIGQ9Ik0xOTIgNDc0aDY3MnE4IDAgOCA4djYwcTAgOC04IDhIMTYwcS04IDAtOC04di02MHEwLTggOC04eiIgLz48L3N2Zz4=) */ var $da40d833ab151490$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($da40d833ab151490$var$PlusOutlined);
var $da40d833ab151490$export$2e2bcd8739ae039 = $da40d833ab151490$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $d9bcc856a934f3b6$var$MinusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "minus",
    "theme": "outlined"
};
var $d9bcc856a934f3b6$export$2e2bcd8739ae039 = $d9bcc856a934f3b6$var$MinusOutlined;



function $db017825a1be541b$var$_extends() {
    $db017825a1be541b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $db017825a1be541b$var$_extends.apply(this, arguments);
}
const $db017825a1be541b$var$MinusOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $db017825a1be541b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $d9bcc856a934f3b6$export$2e2bcd8739ae039)
    }));
/**![minus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3MiA0NzRIMTUyYy00LjQgMC04IDMuNi04IDh2NjBjMCA0LjQgMy42IDggOCA4aDcyMGM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $db017825a1be541b$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($db017825a1be541b$var$MinusOutlined);
var $db017825a1be541b$export$2e2bcd8739ae039 = $db017825a1be541b$var$RefIcon;




var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $9fdb695b769a9bf3$var$UpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
                }
            }
        ]
    },
    "name": "up",
    "theme": "outlined"
};
var $9fdb695b769a9bf3$export$2e2bcd8739ae039 = $9fdb695b769a9bf3$var$UpOutlined;



function $91b6e7232cccc8f8$var$_extends() {
    $91b6e7232cccc8f8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $91b6e7232cccc8f8$var$_extends.apply(this, arguments);
}
const $91b6e7232cccc8f8$var$UpOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $91b6e7232cccc8f8$var$_extends({}, props, {
        ref: ref,
        icon: (0, $9fdb695b769a9bf3$export$2e2bcd8739ae039)
    }));
/**![up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg5MC41IDc1NS4zTDUzNy45IDI2OS4yYy0xMi44LTE3LjYtMzktMTcuNi01MS43IDBMMTMzLjUgNzU1LjNBOCA4IDAgMDAxNDAgNzY4aDc1YzUuMSAwIDkuOS0yLjUgMTIuOS02LjZMNTEyIDM2OS44bDI4NC4xIDM5MS42YzMgNC4xIDcuOCA2LjYgMTIuOSA2LjZoNzVjNi41IDAgMTAuMy03LjQgNi41LTEyLjd6IiAvPjwvc3ZnPg==) */ const $91b6e7232cccc8f8$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($91b6e7232cccc8f8$var$UpOutlined);
var $91b6e7232cccc8f8$export$2e2bcd8739ae039 = $91b6e7232cccc8f8$var$RefIcon;


/* eslint-disable max-classes-per-file */ 


function $ddc17670d7522011$export$d5c7b2f63580e8f5() {
    return typeof BigInt === 'function';
}


function $323a7d2e40a47c83$export$dd1bc94b04021eeb(value) {
    return !value && value !== 0 && !Number.isNaN(value) || !String(value).trim();
}
function $323a7d2e40a47c83$export$5be79a0015c5ab12(numStr) {
    var str = numStr.trim();
    var negative = str.startsWith('-');
    if (negative) str = str.slice(1);
    str = str// Remove decimal 0. `1.000` => `1.`, `1.100` => `1.1`
    .replace(/(\.\d*[^0])0*$/, '$1')// Remove useless decimal. `1.` => `1`
    .replace(/\.0*$/, '')// Remove integer 0. `0001` => `1`, 000.1' => `.1`
    .replace(/^0+/, '');
    if (str.startsWith('.')) str = "0".concat(str);
    var trimStr = str || '0';
    var splitNumber = trimStr.split('.');
    var integerStr = splitNumber[0] || '0';
    var decimalStr = splitNumber[1] || '0';
    if (integerStr === '0' && decimalStr === '0') negative = false;
    var negativeStr = negative ? '-' : '';
    return {
        negative: negative,
        negativeStr: negativeStr,
        trimStr: trimStr,
        integerStr: integerStr,
        decimalStr: decimalStr,
        fullStr: "".concat(negativeStr).concat(trimStr)
    };
}
function $323a7d2e40a47c83$export$ee6c12ef7f6d8b32(number) {
    var str = String(number);
    return !Number.isNaN(Number(str)) && str.includes('e');
}
function $323a7d2e40a47c83$export$2e56483e4ad90ee6(number) {
    var numStr = String(number);
    if ($323a7d2e40a47c83$export$ee6c12ef7f6d8b32(number)) {
        var precision = Number(numStr.slice(numStr.indexOf('e-') + 2));
        var decimalMatch = numStr.match(/\.(\d+)/);
        if (decimalMatch !== null && decimalMatch !== void 0 && decimalMatch[1]) precision += decimalMatch[1].length;
        return precision;
    }
    return numStr.includes('.') && $323a7d2e40a47c83$export$b3d198e17b370bec(numStr) ? numStr.length - numStr.indexOf('.') - 1 : 0;
}
function $323a7d2e40a47c83$export$fdc98affa95a4322(number) {
    var numStr = String(number);
    if ($323a7d2e40a47c83$export$ee6c12ef7f6d8b32(number)) {
        if (number > Number.MAX_SAFE_INTEGER) return String((0, $ddc17670d7522011$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MAX_SAFE_INTEGER);
        if (number < Number.MIN_SAFE_INTEGER) return String((0, $ddc17670d7522011$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MIN_SAFE_INTEGER);
        numStr = number.toFixed($323a7d2e40a47c83$export$2e56483e4ad90ee6(numStr));
    }
    return $323a7d2e40a47c83$export$5be79a0015c5ab12(numStr).fullStr;
}
function $323a7d2e40a47c83$export$b3d198e17b370bec(num) {
    if (typeof num === 'number') return !Number.isNaN(num);
    // Empty
    if (!num) return false;
    return(// Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(num) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(num));
}


var $3816cfe4bdf968c6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /** BigInt will convert `0009` to `9`. We need record the len of decimal */ function BigIntDecimal(value) {
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, BigIntDecimal);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "origin", '');
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "negative", void 0);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "integer", void 0);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "decimal", void 0);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "decimalLen", void 0);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "empty", void 0);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "nan", void 0);
        if ((0, $323a7d2e40a47c83$export$dd1bc94b04021eeb)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        // Act like Number convert
        if (value === '-' || Number.isNaN(value)) {
            this.nan = true;
            return;
        }
        var mergedValue = value;
        // We need convert back to Number since it require `toFixed` to handle this
        if ((0, $323a7d2e40a47c83$export$ee6c12ef7f6d8b32)(mergedValue)) mergedValue = Number(mergedValue);
        mergedValue = typeof mergedValue === 'string' ? mergedValue : (0, $323a7d2e40a47c83$export$fdc98affa95a4322)(mergedValue);
        if ((0, $323a7d2e40a47c83$export$b3d198e17b370bec)(mergedValue)) {
            var trimRet = (0, $323a7d2e40a47c83$export$5be79a0015c5ab12)(mergedValue);
            this.negative = trimRet.negative;
            var numbers = trimRet.trimStr.split('.');
            this.integer = BigInt(numbers[0]);
            var decimalStr = numbers[1] || '0';
            this.decimal = BigInt(decimalStr);
            this.decimalLen = decimalStr.length;
        } else this.nan = true;
    }
    (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(BigIntDecimal, [
        {
            key: "getMark",
            value: function getMark() {
                return this.negative ? '-' : '';
            }
        },
        {
            key: "getIntegerStr",
            value: function getIntegerStr() {
                return this.integer.toString();
            }
        },
        {
            key: "getDecimalStr",
            value: function getDecimalStr() {
                return this.decimal.toString().padStart(this.decimalLen, '0');
            }
        },
        {
            key: "alignDecimal",
            value: function alignDecimal(decimalLength) {
                var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, '0'));
                return BigInt(str);
            }
        },
        {
            key: "negate",
            value: function negate() {
                var clone = new BigIntDecimal(this.toString());
                clone.negative = !clone.negative;
                return clone;
            }
        },
        {
            key: "cal",
            value: function cal(offset, calculator, calDecimalLen) {
                var maxDecimalLength = Math.max(this.getDecimalStr().length, offset.getDecimalStr().length);
                var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
                var offsetAlignedDecimal = offset.alignDecimal(maxDecimalLength);
                var valueStr = calculator(myAlignedDecimal, offsetAlignedDecimal).toString();
                var nextDecimalLength = calDecimalLen(maxDecimalLength);
                // We need fill string length back to `maxDecimalLength` to avoid parser failed
                var _trimNumber = (0, $323a7d2e40a47c83$export$5be79a0015c5ab12)(valueStr), negativeStr = _trimNumber.negativeStr, trimStr = _trimNumber.trimStr;
                var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(nextDecimalLength + 1, '0'));
                return new BigIntDecimal("".concat(hydrateValueStr.slice(0, -nextDecimalLength), ".").concat(hydrateValueStr.slice(-nextDecimalLength)));
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new BigIntDecimal(value);
                var offset = new BigIntDecimal(value);
                if (offset.isInvalidate()) return this;
                return this.cal(offset, function(num1, num2) {
                    return num1 + num2;
                }, function(len) {
                    return len;
                });
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = new BigIntDecimal(value);
                if (this.isInvalidate() || target.isInvalidate()) return new BigIntDecimal(NaN);
                return this.cal(target, function(num1, num2) {
                    return num1 * num2;
                }, function(len) {
                    return len * 2;
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return this.nan;
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                if (this.isNaN()) return NaN;
                return Number(this.toString());
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return '';
                return (0, $323a7d2e40a47c83$export$5be79a0015c5ab12)("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
            }
        }
    ]);
    return BigIntDecimal;
}();






/**
 * We can remove this when IE not support anymore
 */ var $d93ed387532b594d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function NumberDecimal(value) {
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, NumberDecimal);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "origin", '');
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "number", void 0);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(this, "empty", void 0);
        if ((0, $323a7d2e40a47c83$export$dd1bc94b04021eeb)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        this.number = Number(value);
    }
    (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(NumberDecimal, [
        {
            key: "negate",
            value: function negate() {
                return new NumberDecimal(-this.toNumber());
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new NumberDecimal(value);
                var target = Number(value);
                if (Number.isNaN(target)) return this;
                var number = this.number + target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $323a7d2e40a47c83$export$2e56483e4ad90ee6)(this.number), (0, $323a7d2e40a47c83$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = Number(value);
                if (this.isInvalidate() || Number.isNaN(target)) return new NumberDecimal(NaN);
                var number = this.number * target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $323a7d2e40a47c83$export$2e56483e4ad90ee6)(this.number), (0, $323a7d2e40a47c83$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.number);
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                return this.number;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return '';
                return (0, $323a7d2e40a47c83$export$fdc98affa95a4322)(this.number);
            }
        }
    ]);
    return NumberDecimal;
}();




function $bd8f764ce52ab221$export$2e2bcd8739ae039(value) {
    // We use BigInt here.
    // Will fallback to Number if not support.
    if ((0, $ddc17670d7522011$export$d5c7b2f63580e8f5)()) return new (0, $3816cfe4bdf968c6$export$2e2bcd8739ae039)(value);
    return new (0, $d93ed387532b594d$export$2e2bcd8739ae039)(value);
}
function $bd8f764ce52ab221$export$a81f732198733497(numStr, separatorStr, precision) {
    var cutOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (numStr === '') return '';
    var _trimNumber = (0, $323a7d2e40a47c83$export$5be79a0015c5ab12)(numStr), negativeStr = _trimNumber.negativeStr, integerStr = _trimNumber.integerStr, decimalStr = _trimNumber.decimalStr;
    var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
    var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
    if (precision >= 0) {
        // We will get last + 1 number to check if need advanced number
        var advancedNum = Number(decimalStr[precision]);
        if (advancedNum >= 5 && !cutOnly) {
            var advancedDecimal = $bd8f764ce52ab221$export$2e2bcd8739ae039(numStr).add("".concat(negativeStr, "0.").concat('0'.repeat(precision)).concat(10 - advancedNum));
            return $bd8f764ce52ab221$export$a81f732198733497(advancedDecimal.toString(), separatorStr, precision, cutOnly);
        }
        if (precision === 0) return numberWithoutDecimal;
        return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, '0').slice(0, precision));
    }
    if (precisionDecimalStr === '.0') return numberWithoutDecimal;
    return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}



var $b65a7c1af4ce661f$export$2e2bcd8739ae039 = (0, $bd8f764ce52ab221$export$2e2bcd8739ae039);



/**
 * Proxy object if environment supported
 */ function $e1620977492be570$export$2e2bcd8739ae039(obj, extendProps) {
    if (typeof Proxy !== 'undefined' && obj) return new Proxy(obj, {
        get (target, prop) {
            if (extendProps[prop]) return extendProps[prop];
            // Proxy origin property
            const originProp = target[prop];
            return typeof originProp === 'function' ? originProp.bind(target) : originProp;
        }
    });
    return obj;
}




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");

function $07d6a23d748462c8$export$2e2bcd8739ae039(input, focused) {
    const selectionRef = (0, $ltGt3.useRef)(null);
    function recordCursor() {
        // Record position
        try {
            const { selectionStart: start, selectionEnd: end, value: value } = input;
            const beforeTxt = value.substring(0, start);
            const afterTxt = value.substring(end);
            selectionRef.current = {
                start: start,
                end: end,
                value: value,
                beforeTxt: beforeTxt,
                afterTxt: afterTxt
            };
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    }
    /**
   * Restore logic:
   *  1. back string same
   *  2. start string same
   */ function restoreCursor() {
        if (input && selectionRef.current && focused) try {
            const { value: value } = input;
            const { beforeTxt: beforeTxt, afterTxt: afterTxt, start: start } = selectionRef.current;
            let startPos = value.length;
            if (value.startsWith(beforeTxt)) startPos = beforeTxt.length;
            else if (value.endsWith(afterTxt)) startPos = value.length - selectionRef.current.afterTxt.length;
            else {
                const beforeLastChar = beforeTxt[start - 1];
                const newIndex = value.indexOf(beforeLastChar, start - 1);
                if (newIndex !== -1) startPos = newIndex + 1;
            }
            input.setSelectionRange(startPos, startPos);
        } catch (e) {
            (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, `Something warning of cursor restore. Please fire issue about this: ${e.message}`);
        }
    }
    return [
        recordCursor,
        restoreCursor
    ];
}


/* eslint-disable react/no-unknown-property */ 


var $ltGt3 = parcelRequire("ltGt3");
/**
 * When click and hold on a button - the speed of auto changing the value.
 */ const $c7600ab489b3b007$var$STEP_INTERVAL = 200;
/**
 * When click and hold on a button - the delay before auto changing the value.
 */ const $c7600ab489b3b007$var$STEP_DELAY = 600;
function $c7600ab489b3b007$export$2e2bcd8739ae039({ prefixCls: prefixCls, action: action, children: children, disabled: disabled, className: className, style: style, onStep: onStep }) {
    // ======================== MISC ========================
    const isUpAction = action === 'up';
    // ======================== Step ========================
    const stepTimeoutRef = $ltGt3.useRef();
    const frameIds = $ltGt3.useRef([]);
    const onStopStep = ()=>{
        clearTimeout(stepTimeoutRef.current);
    };
    // We will interval update step when hold mouse down
    const onStepMouseDown = (e)=>{
        e.preventDefault();
        onStopStep();
        onStep(isUpAction, 'handler');
        // Loop step for interval
        function loopStep() {
            onStep(isUpAction, 'handler');
            stepTimeoutRef.current = setTimeout(loopStep, $c7600ab489b3b007$var$STEP_INTERVAL);
        }
        // First time press will wait some time to trigger loop step update
        stepTimeoutRef.current = setTimeout(loopStep, $c7600ab489b3b007$var$STEP_DELAY);
    };
    $ltGt3.useEffect(()=>()=>{
            onStopStep();
            frameIds.current.forEach((id)=>{
                (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(id);
            });
        }, []);
    // ======================= Render =======================
    const actionClassName = `${prefixCls}-action`;
    const mergedClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(actionClassName, `${actionClassName}-${action}`, {
        [`${actionClassName}-${action}-disabled`]: disabled
    }, className);
    // fix: https://github.com/ant-design/ant-design/issues/43088
    // In Safari, When we fire onmousedown and onmouseup events in quick succession,
    // there may be a problem that the onmouseup events are executed first,
    // resulting in a disordered program execution.
    // So, we need to use requestAnimationFrame to ensure that the onmouseup event is executed after the onmousedown event.
    const safeOnStopStep = ()=>frameIds.current.push((0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(onStopStep));
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        unselectable: "on",
        role: "button",
        onMouseUp: safeOnStopStep,
        onMouseLeave: safeOnStopStep,
        onMouseDown: (e)=>{
            onStepMouseDown(e);
        },
        "aria-label": isUpAction ? 'Increase Value' : 'Decrease Value',
        "aria-disabled": disabled,
        className: mergedClassName,
        style: style
    }, children || /*#__PURE__*/ $ltGt3.createElement("span", {
        unselectable: "on",
        className: `${prefixCls}-action-${action}-inner`
    }));
}



function $35c463c47d3b2949$export$d2883c6c6307c415(step) {
    const stepStr = typeof step === 'number' ? (0, $323a7d2e40a47c83$export$fdc98affa95a4322)(step) : (0, $323a7d2e40a47c83$export$5be79a0015c5ab12)(step).fullStr;
    const hasPoint = stepStr.includes('.');
    if (!hasPoint) return step + '0';
    return (0, $323a7d2e40a47c83$export$5be79a0015c5ab12)(stepStr.replace(/(\d)\.(\d)/g, '$1$2.')).fullStr;
}





var $ltGt3 = parcelRequire("ltGt3");

var /**
 * Always trigger latest once when call multiple time
 */ $db9dff346c55f6e7$export$2e2bcd8739ae039 = ()=>{
    const idRef = (0, $ltGt3.useRef)(0);
    const cleanUp = ()=>{
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(idRef.current);
    };
    (0, $ltGt3.useEffect)(()=>cleanUp, []);
    return (callback)=>{
        cleanUp();
        idRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
            callback();
        });
    };
};


function $7c0669208b34fa18$var$_extends() {
    $7c0669208b34fa18$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7c0669208b34fa18$var$_extends.apply(this, arguments);
}
/**
 * We support `stringMode` which need handle correct type when user call in onChange
 * format max or min value
 * 1. if isInvalid return null
 * 2. if precision is undefined, return decimal
 * 3. format with precision
 *    I. if max > 0, round down with precision. Example: max= 3.5, precision=0  afterFormat: 3
 *    II. if max < 0, round up with precision. Example: max= -3.5, precision=0  afterFormat: -4
 *    III. if min > 0, round up with precision. Example: min= 3.5, precision=0  afterFormat: 4
 *    IV. if min < 0, round down with precision. Example: max= -3.5, precision=0  afterFormat: -3
 */ const $7c0669208b34fa18$var$getDecimalValue = (stringMode, decimalValue)=>{
    if (stringMode || decimalValue.isEmpty()) return decimalValue.toString();
    return decimalValue.toNumber();
};
const $7c0669208b34fa18$var$getDecimalIfValidate = (value)=>{
    const decimal = (0, $b65a7c1af4ce661f$export$2e2bcd8739ae039)(value);
    return decimal.isInvalidate() ? null : decimal;
};
const $7c0669208b34fa18$var$InputNumber = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { mode: mode = 'input', prefixCls: prefixCls = 'rc-input-number', className: className, style: style, classNames: classNames, styles: styles, min: min, max: max, step: step = 1, defaultValue: defaultValue, value: value, disabled: disabled, readOnly: readOnly, upHandler: upHandler, downHandler: downHandler, keyboard: keyboard, changeOnWheel: changeOnWheel = false, controls: controls = true, prefix: prefix, suffix: suffix, stringMode: stringMode, parser: parser, formatter: formatter, precision: precision, decimalSeparator: decimalSeparator, onChange: onChange, onInput: onInput, onPressEnter: onPressEnter, onStep: onStep, onMouseDown: // Mouse Events
    onMouseDown, onClick: onClick, onMouseUp: onMouseUp, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onMouseOut: onMouseOut, changeOnBlur: changeOnBlur = true, ...restProps } = props;
    const [focus, setFocus] = $ltGt3.useState(false);
    const userTypingRef = $ltGt3.useRef(false);
    const compositionRef = $ltGt3.useRef(false);
    const shiftKeyRef = $ltGt3.useRef(false);
    // ============================= Refs =============================
    const rootRef = $ltGt3.useRef(null);
    const inputRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, ()=>(0, $e1620977492be570$export$2e2bcd8739ae039)(inputRef.current, {
            focus: (option)=>{
                (0, $2dfb8bf1ce337715$export$2b92016deb0b7aad)(inputRef.current, option);
            },
            blur: ()=>{
                inputRef.current?.blur();
            },
            nativeElement: rootRef.current
        }));
    // ============================ Value =============================
    // Real value control
    const [decimalValue, setDecimalValue] = $ltGt3.useState(()=>(0, $b65a7c1af4ce661f$export$2e2bcd8739ae039)(value ?? defaultValue));
    function setUncontrolledDecimalValue(newDecimal) {
        if (value === undefined) setDecimalValue(newDecimal);
    }
    // ====================== Parser & Formatter ======================
    /**
   * `precision` is used for formatter & onChange.
   * It will auto generate by `value` & `step`.
   * But it will not block user typing.
   *
   * Note: Auto generate `precision` is used for legacy logic.
   * We should remove this since we already support high precision with BigInt.
   *
   * @param number  Provide which number should calculate precision
   * @param userTyping  Change by user typing
   */ const getPrecision = $ltGt3.useCallback((numStr, userTyping)=>{
        if (userTyping) return undefined;
        if (precision >= 0) return precision;
        return Math.max((0, $323a7d2e40a47c83$export$2e56483e4ad90ee6)(numStr), (0, $323a7d2e40a47c83$export$2e56483e4ad90ee6)(step));
    }, [
        precision,
        step
    ]);
    // >>> Parser
    const mergedParser = $ltGt3.useCallback((num)=>{
        const numStr = String(num);
        if (parser) return parser(numStr);
        let parsedStr = numStr;
        if (decimalSeparator) parsedStr = parsedStr.replace(decimalSeparator, '.');
        // [Legacy] We still support auto convert `$ 123,456` to `123456`
        return parsedStr.replace(/[^\w.-]+/g, '');
    }, [
        parser,
        decimalSeparator
    ]);
    // >>> Formatter
    const inputValueRef = $ltGt3.useRef('');
    const mergedFormatter = $ltGt3.useCallback((number, userTyping)=>{
        if (formatter) return formatter(number, {
            userTyping: userTyping,
            input: String(inputValueRef.current)
        });
        let str = typeof number === 'number' ? (0, $323a7d2e40a47c83$export$fdc98affa95a4322)(number) : number;
        // User typing will not auto format with precision directly
        if (!userTyping) {
            const mergedPrecision = getPrecision(str, userTyping);
            if ((0, $323a7d2e40a47c83$export$b3d198e17b370bec)(str) && (decimalSeparator || mergedPrecision >= 0)) {
                // Separator
                const separatorStr = decimalSeparator || '.';
                str = (0, $bd8f764ce52ab221$export$a81f732198733497)(str, separatorStr, mergedPrecision);
            }
        }
        return str;
    }, [
        formatter,
        getPrecision,
        decimalSeparator
    ]);
    // ========================== InputValue ==========================
    /**
   * Input text value control
   *
   * User can not update input content directly. It updates with follow rules by priority:
   *  1. controlled `value` changed
   *    * [SPECIAL] Typing like `1.` should not immediately convert to `1`
   *  2. User typing with format (not precision)
   *  3. Blur or Enter trigger revalidate
   */ const [inputValue, setInternalInputValue] = $ltGt3.useState(()=>{
        const initValue = defaultValue ?? value;
        if (decimalValue.isInvalidate() && [
            'string',
            'number'
        ].includes(typeof initValue)) return Number.isNaN(initValue) ? '' : initValue;
        return mergedFormatter(decimalValue.toString(), false);
    });
    inputValueRef.current = inputValue;
    // Should always be string
    function setInputValue(newValue, userTyping) {
        setInternalInputValue(mergedFormatter(// Invalidate number is sometime passed by external control, we should let it go
        // Otherwise is controlled by internal interactive logic which check by userTyping
        // You can ref 'show limited value when input is not focused' test for more info.
        newValue.isInvalidate() ? newValue.toString(false) : newValue.toString(!userTyping), userTyping));
    }
    // >>> Max & Min limit
    const maxDecimal = $ltGt3.useMemo(()=>$7c0669208b34fa18$var$getDecimalIfValidate(max), [
        max,
        precision
    ]);
    const minDecimal = $ltGt3.useMemo(()=>$7c0669208b34fa18$var$getDecimalIfValidate(min), [
        min,
        precision
    ]);
    const upDisabled = $ltGt3.useMemo(()=>{
        if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return maxDecimal.lessEquals(decimalValue);
    }, [
        maxDecimal,
        decimalValue
    ]);
    const downDisabled = $ltGt3.useMemo(()=>{
        if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return decimalValue.lessEquals(minDecimal);
    }, [
        minDecimal,
        decimalValue
    ]);
    // Cursor controller
    const [recordCursor, restoreCursor] = (0, $07d6a23d748462c8$export$2e2bcd8739ae039)(inputRef.current, focus);
    // ============================= Data =============================
    /**
   * Find target value closet within range.
   * e.g. [11, 28]:
   *    3  => 11
   *    23 => 23
   *    99 => 28
   */ const getRangeValue = (target)=>{
        // target > max
        if (maxDecimal && !target.lessEquals(maxDecimal)) return maxDecimal;
        // target < min
        if (minDecimal && !minDecimal.lessEquals(target)) return minDecimal;
        return null;
    };
    /**
   * Check value is in [min, max] range
   */ const isInRange = (target)=>!getRangeValue(target);
    /**
   * Trigger `onChange` if value validated and not equals of origin.
   * Return the value that re-align in range.
   */ const triggerValueUpdate = (newValue, userTyping)=>{
        let updateValue = newValue;
        let isRangeValidate = isInRange(updateValue) || updateValue.isEmpty();
        // Skip align value when trigger value is empty.
        // We just trigger onChange(null)
        // This should not block user typing
        if (!updateValue.isEmpty() && !userTyping) {
            // Revert value in range if needed
            updateValue = getRangeValue(updateValue) || updateValue;
            isRangeValidate = true;
        }
        if (!readOnly && !disabled && isRangeValidate) {
            const numStr = updateValue.toString();
            const mergedPrecision = getPrecision(numStr, userTyping);
            if (mergedPrecision >= 0) {
                updateValue = (0, $b65a7c1af4ce661f$export$2e2bcd8739ae039)((0, $bd8f764ce52ab221$export$a81f732198733497)(numStr, '.', mergedPrecision));
                // When to fixed. The value may out of min & max range.
                // 4 in [0, 3.8] => 3.8 => 4 (toFixed)
                if (!isInRange(updateValue)) updateValue = (0, $b65a7c1af4ce661f$export$2e2bcd8739ae039)((0, $bd8f764ce52ab221$export$a81f732198733497)(numStr, '.', mergedPrecision, true));
            }
            // Trigger event
            if (!updateValue.equals(decimalValue)) {
                setUncontrolledDecimalValue(updateValue);
                onChange?.(updateValue.isEmpty() ? null : $7c0669208b34fa18$var$getDecimalValue(stringMode, updateValue));
                // Reformat input if value is not controlled
                if (value === undefined) setInputValue(updateValue, userTyping);
            }
            return updateValue;
        }
        return decimalValue;
    };
    // ========================== User Input ==========================
    const onNextPromise = (0, $db9dff346c55f6e7$export$2e2bcd8739ae039)();
    // >>> Collect input value
    const collectInputValue = (inputStr)=>{
        recordCursor();
        // Update inputValue in case input can not parse as number
        // Refresh ref value immediately since it may used by formatter
        inputValueRef.current = inputStr;
        setInternalInputValue(inputStr);
        // Parse number
        if (!compositionRef.current) {
            const finalValue = mergedParser(inputStr);
            const finalDecimal = (0, $b65a7c1af4ce661f$export$2e2bcd8739ae039)(finalValue);
            if (!finalDecimal.isNaN()) triggerValueUpdate(finalDecimal, true);
        }
        // Trigger onInput later to let user customize value if they want to handle something after onChange
        onInput?.(inputStr);
        // optimize for chinese input experience
        // https://github.com/ant-design/ant-design/issues/8196
        onNextPromise(()=>{
            let nextInputStr = inputStr;
            if (!parser) nextInputStr = inputStr.replace(/。/g, '.');
            if (nextInputStr !== inputStr) collectInputValue(nextInputStr);
        });
    };
    // >>> Composition
    const onCompositionStart = ()=>{
        compositionRef.current = true;
    };
    const onCompositionEnd = ()=>{
        compositionRef.current = false;
        collectInputValue(inputRef.current.value);
    };
    // >>> Input
    const onInternalInput = (e)=>{
        collectInputValue(e.target.value);
    };
    // ============================= Step =============================
    const onInternalStep = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((up, emitter)=>{
        // Ignore step since out of range
        if (up && upDisabled || !up && downDisabled) return;
        // Clear typing status since it may be caused by up & down key.
        // We should sync with input value.
        userTypingRef.current = false;
        let stepDecimal = (0, $b65a7c1af4ce661f$export$2e2bcd8739ae039)(shiftKeyRef.current ? (0, $35c463c47d3b2949$export$d2883c6c6307c415)(step) : step);
        if (!up) stepDecimal = stepDecimal.negate();
        const target = (decimalValue || (0, $b65a7c1af4ce661f$export$2e2bcd8739ae039)(0)).add(stepDecimal.toString());
        const updatedValue = triggerValueUpdate(target, false);
        onStep?.($7c0669208b34fa18$var$getDecimalValue(stringMode, updatedValue), {
            offset: shiftKeyRef.current ? (0, $35c463c47d3b2949$export$d2883c6c6307c415)(step) : step,
            type: up ? 'up' : 'down',
            emitter: emitter
        });
        inputRef.current?.focus();
    });
    // ============================ Flush =============================
    /**
   * Flush current input content to trigger value change & re-formatter input if needed.
   * This will always flush input value for update.
   * If it's invalidate, will fallback to last validate value.
   */ const flushInputValue = (userTyping)=>{
        const parsedValue = (0, $b65a7c1af4ce661f$export$2e2bcd8739ae039)(mergedParser(inputValue));
        let formatValue;
        if (!parsedValue.isNaN()) // Only validate value or empty value can be re-fill to inputValue
        // Reassign the formatValue within ranged of trigger control
        formatValue = triggerValueUpdate(parsedValue, userTyping);
        else formatValue = triggerValueUpdate(decimalValue, userTyping);
        if (value !== undefined) // Reset back with controlled value first
        setInputValue(decimalValue, false);
        else if (!formatValue.isNaN()) // Reset input back since no validate value
        setInputValue(formatValue, false);
    };
    // Solve the issue of the event triggering sequence when entering numbers in chinese input (Safari)
    const onBeforeInput = ()=>{
        userTypingRef.current = true;
    };
    const onKeyDown = (event)=>{
        const { key: key, shiftKey: shiftKey } = event;
        userTypingRef.current = true;
        shiftKeyRef.current = shiftKey;
        if (key === 'Enter') {
            if (!compositionRef.current) userTypingRef.current = false;
            flushInputValue(false);
            onPressEnter?.(event);
        }
        if (keyboard === false) return;
        // Do step
        if (!compositionRef.current && [
            'Up',
            'ArrowUp',
            'Down',
            'ArrowDown'
        ].includes(key)) {
            onInternalStep(key === 'Up' || key === 'ArrowUp', 'keyboard');
            event.preventDefault();
        }
    };
    const onKeyUp = ()=>{
        userTypingRef.current = false;
        shiftKeyRef.current = false;
    };
    $ltGt3.useEffect(()=>{
        if (changeOnWheel && focus) {
            const onWheel = (event)=>{
                // moving mouse wheel rises wheel event with deltaY < 0
                // scroll value grows from top to bottom, as screen Y coordinate
                onInternalStep(event.deltaY < 0, 'wheel');
                event.preventDefault();
            };
            const input = inputRef.current;
            if (input) {
                // React onWheel is passive and we can't preventDefault() in it.
                // That's why we should subscribe with DOM listener
                // https://stackoverflow.com/questions/63663025/react-onwheel-handler-cant-preventdefault-because-its-a-passive-event-listenev
                input.addEventListener('wheel', onWheel, {
                    passive: false
                });
                return ()=>input.removeEventListener('wheel', onWheel);
            }
        }
    });
    // >>> Focus & Blur
    const onBlur = ()=>{
        if (changeOnBlur) flushInputValue(false);
        setFocus(false);
        userTypingRef.current = false;
    };
    // >>> Mouse events
    const onInternalMouseDown = (event)=>{
        if (inputRef.current && event.target !== inputRef.current) {
            inputRef.current.focus();
            event.preventDefault();
        }
        onMouseDown?.(event);
    };
    // ========================== Controlled ==========================
    // Input by precision & formatter
    (0, $b51fc3415a3f1104$export$9283e56bae2f7b0f)(()=>{
        if (!decimalValue.isInvalidate()) setInputValue(decimalValue, false);
    }, [
        precision,
        formatter
    ]);
    // Input by value
    (0, $b51fc3415a3f1104$export$9283e56bae2f7b0f)(()=>{
        const newValue = (0, $b65a7c1af4ce661f$export$2e2bcd8739ae039)(value);
        setDecimalValue(newValue);
        const currentParsedValue = (0, $b65a7c1af4ce661f$export$2e2bcd8739ae039)(mergedParser(inputValue));
        // When user typing from `1.2` to `1.`, we should not convert to `1` immediately.
        // But let it go if user set `formatter`
        if (!newValue.equals(currentParsedValue) || !userTypingRef.current || formatter) // Update value as effect
        setInputValue(newValue, userTypingRef.current);
    }, [
        value
    ]);
    // ============================ Cursor ============================
    (0, $b51fc3415a3f1104$export$9283e56bae2f7b0f)(()=>{
        if (formatter) restoreCursor();
    }, [
        inputValue
    ]);
    // ============================ Render ============================
    // >>>>>> Handler
    const sharedHandlerProps = {
        prefixCls: prefixCls,
        onStep: onInternalStep,
        className: classNames?.action,
        style: styles?.action
    };
    const upNode = /*#__PURE__*/ $ltGt3.createElement((0, $c7600ab489b3b007$export$2e2bcd8739ae039), $7c0669208b34fa18$var$_extends({}, sharedHandlerProps, {
        action: "up",
        disabled: upDisabled
    }), upHandler);
    const downNode = /*#__PURE__*/ $ltGt3.createElement((0, $c7600ab489b3b007$export$2e2bcd8739ae039), $7c0669208b34fa18$var$_extends({}, sharedHandlerProps, {
        action: "down",
        disabled: downDisabled
    }), downHandler);
    // >>>>>> Render
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: rootRef,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-mode-${mode}`, className, classNames?.root, {
            [`${prefixCls}-focused`]: focus,
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-readonly`]: readOnly,
            [`${prefixCls}-not-a-number`]: decimalValue.isNaN(),
            [`${prefixCls}-out-of-range`]: !decimalValue.isInvalidate() && !isInRange(decimalValue)
        }),
        style: {
            ...styles?.root,
            ...style
        },
        onMouseDown: onInternalMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        onClick: onClick,
        onFocus: ()=>{
            setFocus(true);
        },
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBeforeInput: onBeforeInput
    }, mode === 'spinner' && controls && downNode, prefix !== undefined && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
        style: styles?.prefix
    }, prefix), /*#__PURE__*/ $ltGt3.createElement("input", $7c0669208b34fa18$var$_extends({
        autoComplete: "off",
        role: "spinbutton",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
        step: step,
        ref: inputRef,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-input`, classNames?.input),
        style: styles?.input,
        value: inputValue,
        onChange: onInternalInput,
        disabled: disabled,
        readOnly: readOnly
    }, restProps)), suffix !== undefined && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, classNames?.suffix),
        style: styles?.suffix
    }, suffix), mode === 'spinner' && controls && upNode, mode === 'input' && controls && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, classNames?.actions),
        style: styles?.actions
    }, upNode, downNode));
});
var $7c0669208b34fa18$export$2e2bcd8739ae039 = $7c0669208b34fa18$var$InputNumber;


var $ebcfdf457585d6d8$export$2e2bcd8739ae039 = (0, $7c0669208b34fa18$export$2e2bcd8739ae039);
























const $75579fed6efaa4a2$export$9ca1be8807fe0675 = (token)=>{
    const handleVisible = token.handleVisible ?? 'auto';
    const handleWidth = token.controlHeightSM - token.lineWidth * 2;
    return {
        ...(0, $84cc1914d3f028b8$export$bd8b682992bc9781)(token),
        controlWidth: 90,
        handleWidth: handleWidth,
        handleFontSize: token.fontSize / 2,
        handleVisible: handleVisible,
        handleActiveBg: token.colorFillAlter,
        handleBg: token.colorBgContainer,
        filledHandleBg: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(token.colorFillSecondary).onBackground(token.colorBgContainer).toHexString(),
        handleHoverColor: token.colorPrimary,
        handleBorderColor: token.colorBorder,
        handleOpacity: handleVisible === true ? 1 : 0,
        handleVisibleWidth: handleVisible === true ? handleWidth : 0
    };
};


const $c717065529a46105$var$genInputNumberStyles = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, borderRadius: borderRadius, inputFontSizeSM: inputFontSizeSM, inputFontSizeLG: inputFontSizeLG, colorError: colorError, paddingInlineSM: paddingInlineSM, paddingBlockSM: paddingBlockSM, paddingBlockLG: paddingBlockLG, paddingInlineLG: paddingInlineLG, colorIcon: colorIcon, motionDurationMid: motionDurationMid, handleHoverColor: handleHoverColor, handleOpacity: handleOpacity, paddingInline: paddingInline, paddingBlock: paddingBlock, handleBg: handleBg, handleActiveBg: handleActiveBg, inputAffixPadding: inputAffixPadding, borderRadiusSM: borderRadiusSM, controlWidth: controlWidth, handleBorderColor: handleBorderColor, filledHandleBg: filledHandleBg, lineHeightLG: lineHeightLG } = token;
    const borderStyle = `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${handleBorderColor}`;
    return [
        // ==========================================================
        // ==                         Base                         ==
        // ==========================================================
        {
            [componentCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                ...(0, $ec12a8e9ea12e1d5$export$8c9a381315f3ebcd)(token),
                '--input-number-input-padding-block': (0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingBlock),
                '--input-number-input-padding-inline': (0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingInline),
                display: 'inline-flex',
                width: controlWidth,
                margin: 0,
                paddingBlock: 0,
                borderRadius: borderRadius,
                // ======================= Variants =======================
                ...(0, $2e2c91ed88c5ebaa$export$53795bafd774ce02)(token, {
                    [`${componentCls}-actions`]: {
                        background: handleBg,
                        [`${componentCls}-action-down`]: {
                            borderBlockStart: borderStyle
                        }
                    }
                }),
                ...(0, $2e2c91ed88c5ebaa$export$b8365cd7e6671d79)(token, {
                    [`${componentCls}-actions`]: {
                        background: filledHandleBg,
                        [`${componentCls}-action-down`]: {
                            borderBlockStart: borderStyle
                        }
                    },
                    '&:focus-within': {
                        [`${componentCls}-actions`]: {
                            background: handleBg
                        }
                    }
                }),
                ...(0, $2e2c91ed88c5ebaa$export$34771e60e0439351)(token, {
                    [`${componentCls}-actions`]: {
                        background: handleBg,
                        [`${componentCls}-action-down`]: {
                            borderBlockStart: borderStyle
                        }
                    }
                }),
                ...(0, $2e2c91ed88c5ebaa$export$b6de5da7f39edfcb)(token),
                // ========================= RTL ==========================
                '&-rtl': {
                    direction: 'rtl',
                    [`${componentCls}-input`]: {
                        direction: 'rtl'
                    }
                },
                // ===================== Out Of Range =====================
                [`&${componentCls}-out-of-range`]: {
                    [`${componentCls}-input`]: {
                        color: colorError
                    }
                },
                // ======================== Input =========================
                [`${componentCls}-input`]: {
                    ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                    width: '100%',
                    paddingBlock: `var(--input-number-input-padding-block)`,
                    textAlign: 'start',
                    backgroundColor: 'transparent',
                    border: 0,
                    borderRadius: borderRadius,
                    outline: 0,
                    transition: `all ${motionDurationMid} linear`,
                    appearance: 'textfield',
                    fontSize: 'inherit',
                    lineHeight: 'inherit',
                    ...(0, $ec12a8e9ea12e1d5$export$92095d0f4c77bd56)(token.colorTextPlaceholder),
                    '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
                        margin: 0,
                        appearance: 'none'
                    }
                },
                [`&:hover ${componentCls}-handler-wrap, &-focused ${componentCls}-handler-wrap`]: {
                    width: token.handleWidth,
                    opacity: 1
                },
                // ======================= Disabled =======================
                [`&-disabled ${componentCls}-input`]: {
                    cursor: 'not-allowed',
                    color: token.colorTextDisabled
                }
            }
        },
        // ==========================================================
        // ==                        Action                        ==
        // ==========================================================
        {
            [componentCls]: {
                // ======================= Shared =======================
                [`
          ${componentCls}-action-up-disabled,
          ${componentCls}-action-down-disabled
        `]: {
                    cursor: 'not-allowed'
                },
                [`${componentCls}-action`]: {
                    ...(0, $945cb0d2b7017a11$export$171ccda7bc085e59)(),
                    userSelect: 'none',
                    overflow: 'hidden',
                    fontWeight: 'bold',
                    lineHeight: 0,
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: `all ${motionDurationMid} linear`,
                    '&:active': {
                        background: handleActiveBg
                    },
                    // Hover
                    '&:hover': {
                        color: handleHoverColor
                    }
                },
                // ===================== Input Mode =====================
                '&-mode-input': {
                    overflow: 'hidden',
                    [`${componentCls}-actions`]: {
                        position: 'absolute',
                        insetBlockStart: 0,
                        insetInlineEnd: 0,
                        width: token.handleVisibleWidth,
                        opacity: handleOpacity,
                        height: '100%',
                        borderRadius: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        transition: `all ${motionDurationMid}`,
                        overflow: 'hidden',
                        // Fix input number inside Menu makes icon too large
                        // We arise the selector priority by nest selector here
                        // https://github.com/ant-design/ant-design/issues/14367
                        [`${componentCls}-action`]: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flex: 'auto',
                            height: '40%',
                            marginInlineEnd: 0,
                            fontSize: token.handleFontSize
                        }
                    },
                    [`&:hover ${componentCls}-actions, &-focused ${componentCls}-actions`]: {
                        width: token.handleWidth,
                        opacity: 1
                    },
                    [`${componentCls}-action`]: {
                        color: colorIcon,
                        height: '50%',
                        borderInlineStart: borderStyle,
                        // Hover
                        '&:hover': {
                            height: `60%`
                        }
                    },
                    [`&${componentCls}-disabled, &${componentCls}-readonly`]: {
                        [`${componentCls}-actions`]: {
                            display: 'none'
                        }
                    }
                },
                // ==================== Spinner Mode ====================
                [`&${componentCls}-mode-spinner`]: {
                    padding: 0,
                    width: 'auto',
                    [`${componentCls}-action`]: {
                        flex: 'none',
                        paddingInline: 'var(--input-number-input-padding-inline)',
                        '&-up': {
                            borderInlineStart: borderStyle
                        },
                        '&-down': {
                            borderInlineEnd: borderStyle
                        }
                    },
                    [`${componentCls}-input`]: {
                        textAlign: 'center',
                        paddingInline: 'var(--input-number-input-padding-inline)'
                    }
                }
            }
        },
        // ==========================================================
        // ==                         Size                         ==
        // ==========================================================
        {
            [componentCls]: {
                '&-lg': {
                    '--input-number-input-padding-block': (0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingBlockLG),
                    '--input-number-input-padding-inline': (0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingInlineLG),
                    paddingBlock: 0,
                    fontSize: inputFontSizeLG,
                    lineHeight: lineHeightLG
                },
                '&-sm': {
                    '--input-number-input-padding-block': (0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingBlockSM),
                    '--input-number-input-padding-inline': (0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingInlineSM),
                    paddingBlock: 0,
                    fontSize: inputFontSizeSM,
                    borderRadius: borderRadiusSM
                }
            }
        },
        // ==========================================================
        // ==                      Pre/Suffix                      ==
        // ==========================================================
        {
            [componentCls]: {
                [`${componentCls}-prefix, ${componentCls}-suffix`]: {
                    display: 'flex',
                    flex: 'none',
                    alignItems: 'center',
                    alignSelf: 'center',
                    pointerEvents: 'none'
                },
                [`${componentCls}-prefix`]: {
                    marginInlineEnd: inputAffixPadding
                },
                [`${componentCls}-suffix`]: {
                    height: '100%',
                    marginInlineStart: inputAffixPadding,
                    transition: `margin ${motionDurationMid}`
                },
                [`&:hover:not(${componentCls}-without-controls)`]: {
                    [`${componentCls}-suffix`]: {
                        marginInlineEnd: token.handleWidth
                    }
                }
            }
        }
    ];
};
const $c717065529a46105$var$genCompatibleStyles = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [`${componentCls}-addon`]: {
            [`&:has(${antCls}-select)`]: {
                border: 0,
                padding: 0
            }
        }
    };
};
var $c717065529a46105$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('InputNumber', (token)=>{
    const inputNumberToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, (0, $84cc1914d3f028b8$export$a157d95850191a12)(token));
    return [
        $c717065529a46105$var$genInputNumberStyles(inputNumberToken),
        $c717065529a46105$var$genCompatibleStyles(inputNumberToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $f96147db005a8a82$export$b1208b23589b4b73)(inputNumberToken)
    ];
}, (0, $75579fed6efaa4a2$export$9ca1be8807fe0675), {
    unitless: {
        handleOpacity: true
    },
    resetFont: false
});


"use client";
const $bbe04e8e6f6789c3$var$InternalInputNumber = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const inputRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, ()=>inputRef.current);
    const { rootClassName: rootClassName, size: customizeSize, disabled: customDisabled, prefixCls: prefixCls, addonBefore: addonBefore, addonAfter: addonAfter, prefix: prefix, suffix: suffix, bordered: bordered, readOnly: readOnly, status: status, controls: controls = true, variant: customVariant, className: className, style: style, classNames: classNames, styles: styles, mode: mode, ...others } = props;
    const { direction: direction, className: contextClassName, style: contextStyle, styles: contextStyles, classNames: contextClassNames } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('inputNumber');
    //controls && !props.disabled && !props.readOnly;
    const mergedControls = $ltGt3.useMemo(()=>{
        if (!controls || props.disabled || props.readOnly) return false;
        return controls;
    }, [
        controls,
        props.disabled,
        props.readOnly
    ]);
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $8eabd28975be2fa5$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    let upIcon = mode === 'spinner' ? /*#__PURE__*/ $ltGt3.createElement((0, $44fddb3bd1473a4a$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $91b6e7232cccc8f8$export$2e2bcd8739ae039), null);
    let downIcon = mode === 'spinner' ? /*#__PURE__*/ $ltGt3.createElement((0, $db017825a1be541b$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $a3f64d9a77de028d$export$2e2bcd8739ae039), null);
    const controlsTemp = typeof mergedControls === 'boolean' ? mergedControls : undefined;
    if (typeof mergedControls === 'object') {
        upIcon = mergedControls.upIcon || upIcon;
        downIcon = mergedControls.downIcon || downIcon;
    }
    const { hasFeedback: hasFeedback, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $ltGt3.useContext((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    // ===================== Disabled =====================
    const disabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const [variant, enableVariantCls] = (0, $714175bf01098e4f$export$2e2bcd8739ae039)('inputNumber', customVariant, bordered);
    const suffixNode = hasFeedback && /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, feedbackIcon);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: mergedDisabled,
        controls: mergedControls
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    return /*#__PURE__*/ $ltGt3.createElement((0, $ebcfdf457585d6d8$export$2e2bcd8739ae039), {
        ref: inputRef,
        mode: mode,
        disabled: mergedDisabled,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, rootClassName, mergedClassNames.root, contextClassName, compactItemClassnames, (0, $7b7bdeafff468875$export$b08e7b47149942a2)(prefixCls, status, hasFeedback), {
            [`${prefixCls}-${variant}`]: enableVariantCls,
            [`${prefixCls}-lg`]: mergedSize === 'large',
            [`${prefixCls}-sm`]: mergedSize === 'small',
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-in-form-item`]: isFormItemInput,
            [`${prefixCls}-without-controls`]: !mergedControls
        }),
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        upHandler: upIcon,
        downHandler: downIcon,
        prefixCls: prefixCls,
        readOnly: readOnly,
        controls: controlsTemp,
        prefix: prefix,
        suffix: suffixNode || suffix,
        classNames: mergedClassNames,
        styles: mergedStyles,
        ...others
    });
});
// ===================================================================
// ==                          InputNumber                          ==
// ===================================================================
const $bbe04e8e6f6789c3$var$InputNumber = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { addonBefore: addonBefore, addonAfter: addonAfter, prefixCls: customizePrefixCls, className: className, status: customStatus, rootClassName: rootClassName, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('inputNumber');
    const prefixCls = getPrefixCls('input-number', customizePrefixCls);
    const { status: contextStatus } = $ltGt3.useContext((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $7b7bdeafff468875$export$314e193082d7ba49)(contextStatus, customStatus);
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $c717065529a46105$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const hasLegacyAddon = addonBefore || addonAfter;
    var prop, newProp;
    // ====================== Render ======================
    const inputNumberNode = /*#__PURE__*/ $ltGt3.createElement($bbe04e8e6f6789c3$var$InternalInputNumber, {
        ref: ref,
        ...rest,
        prefixCls: prefixCls,
        status: mergedStatus,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(cssVarCls, rootCls, hashId, className),
        rootClassName: !hasLegacyAddon ? rootClassName : undefined
    });
    if (hasLegacyAddon) {
        const renderAddon = (node)=>{
            if (!node) return null;
            return /*#__PURE__*/ $ltGt3.createElement((0, $2e05741c744aa06e$export$2e2bcd8739ae039), {
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-addon`, cssVarCls, hashId),
                variant: props.variant,
                disabled: props.disabled,
                status: mergedStatus
            }, /*#__PURE__*/ $ltGt3.createElement((0, $31ba6c57c6d43aeb$export$2e2bcd8739ae039), {
                form: true
            }, node));
        };
        const addonBeforeNode = renderAddon(addonBefore);
        const addonAfterNode = renderAddon(addonAfter);
        return /*#__PURE__*/ $ltGt3.createElement((0, $8eabd28975be2fa5$export$2e2bcd8739ae039), {
            rootClassName: rootClassName
        }, addonBeforeNode, inputNumberNode, addonAfterNode);
    }
    return inputNumberNode;
});
const $bbe04e8e6f6789c3$var$TypedInputNumber = $bbe04e8e6f6789c3$var$InputNumber;
/** @private Internal Component. Do not use in your production. */ const $bbe04e8e6f6789c3$var$PureInputNumber = (props)=>/*#__PURE__*/ $ltGt3.createElement((0, $3f88559997256af7$export$2e2bcd8739ae039), {
        theme: {
            components: {
                InputNumber: {
                    handleVisible: true
                }
            }
        }
    }, /*#__PURE__*/ $ltGt3.createElement($bbe04e8e6f6789c3$var$InputNumber, {
        ...props
    }));
$bbe04e8e6f6789c3$var$TypedInputNumber._InternalPanelDoNotUseOrYouWillBeFired = $bbe04e8e6f6789c3$var$PureInputNumber;
var $bbe04e8e6f6789c3$export$2e2bcd8739ae039 = $bbe04e8e6f6789c3$var$TypedInputNumber;


parcelRequire("ltGt3");

function $0a800a542e777d65$export$3a237247201bb848(points) {
    let edges = [];
    let xDif = 0;
    let yDif = 0;
    for(let i = 0; i < points.length - 1; i += 2){
        if (i === points.length - 2) {
            xDif = points[i] - points[0];
            yDif = points[i + 1] - points[1];
        } else {
            xDif = points[i] - points[i + 2];
            yDif = points[i + 1] - points[i + 3];
        }
        edges.push(Math.sqrt(xDif * xDif + yDif * yDif));
    }
    //console.log(edges)
    return edges;
}
function $0a800a542e777d65$export$ba01cdcd2c18efa9(edgeNumber, points) {
    let newPoints = [
        ...points
    ];
    if ((edgeNumber + 1) * 2 === points.length) newPoints.splice(0, 2);
    else newPoints.splice(edgeNumber * 2 + 2, 2);
    return newPoints;
}
function $0a800a542e777d65$export$7ed91a9c68d5a769(edgeNumber, points) {
    let newPoints = [
        ...points
    ];
    if ((edgeNumber + 1) * 2 === points.length) {
        let x = (points[0] - points[edgeNumber * 2]) / 2 + points[edgeNumber * 2];
        let y = (points[1] - points[edgeNumber * 2 + 1]) / 2 + points[edgeNumber * 2 + 1];
        newPoints.splice(0, 0, x, y);
    } else {
        let x = (points[edgeNumber * 2 + 2] - points[edgeNumber * 2]) / 2 + points[edgeNumber * 2];
        let y = (points[edgeNumber * 2 + 3] - points[edgeNumber * 2 + 1]) / 2 + points[edgeNumber * 2 + 1];
        newPoints.splice(edgeNumber * 2 + 2, 0, x, y);
    }
    return newPoints;
}
function $0a800a542e777d65$export$b466f8c2ed63060e(edgeNumber, newValue, points) {
    let newPoints = [
        ...points
    ];
    if ((edgeNumber + 1) * 2 === points.length) {
        let firstVerticeX = points[edgeNumber * 2];
        let firstVerticeY = points[edgeNumber * 2 + 1];
        let secondVerticeX = points[0];
        let secondVerticeY = points[1];
        let oldLength = Math.sqrt(secondVerticeX - firstVerticeX ^ 2 + (secondVerticeY - firstVerticeY) ^ 2);
        let x = newValue * (secondVerticeX - firstVerticeX) / oldLength + firstVerticeX;
        let y = newValue * (secondVerticeY - firstVerticeY) / oldLength + firstVerticeY;
        newPoints.splice(0, 2, x, y);
    } else {
        let firstVerticeX = points[edgeNumber * 2];
        let firstVerticeY = points[edgeNumber * 2 + 1];
        let secondVerticeX = points[edgeNumber * 2 + 2];
        let secondVerticeY = points[edgeNumber * 2 + 3];
        let oldLength = Math.sqrt((secondVerticeX - firstVerticeX) * (secondVerticeX - firstVerticeX) + (secondVerticeY - firstVerticeY) * (secondVerticeY - firstVerticeY));
        let x = newValue * (secondVerticeX - firstVerticeX) / oldLength + firstVerticeX;
        let y = newValue * (secondVerticeY - firstVerticeY) / oldLength + firstVerticeY;
        newPoints.splice(edgeNumber * 2 + 2, 2, x, y);
    }
    return newPoints;
}
function $0a800a542e777d65$export$3d37c13914dd56b0(props) {
    let sides = $0a800a542e777d65$export$3a237247201bb848(props.element.props.points);
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const highlightEdge = (index, points)=>{
        props.onTransformerPropsChange({
            highlightedEdge: [
                ...points,
                ...points
            ].slice(index * 2, index * 2 + 4)
        });
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d029ee757225a242$export$2e2bcd8739ae039), {
            direction: "vertical",
            children: sides.map((side, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'row'
                    },
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $bbe04e8e6f6789c3$export$2e2bcd8739ae039), {
                            addonBefore: `${intl.formatMessage({
                                id: 'edge'
                            })} ${index + 1}`,
                            addonAfter: intl.formatMessage({
                                id: 'm'
                            }),
                            precision: 2,
                            step: 0.01,
                            value: Math.round(side) / 100,
                            onChange: (value)=>{
                                const newPoints = $0a800a542e777d65$export$b466f8c2ed63060e(index, value * 100, props.element.props.points);
                                props.onChange({
                                    ...props.element,
                                    props: {
                                        ...props.element.props,
                                        points: newPoints
                                    }
                                });
                                highlightEdge(index, newPoints);
                            },
                            onFocus: ()=>highlightEdge(index, props.element.props.points),
                            onBlur: ()=>props.onTransformerPropsChange({
                                    highlightedEdge: null
                                })
                        }),
                        props.element.props.points.length > 6 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            type: "link",
                            style: {
                                float: 'right'
                            },
                            onClick: async ()=>{
                                props.onChange({
                                    ...props.element,
                                    props: {
                                        ...props.element.props,
                                        points: $0a800a542e777d65$export$ba01cdcd2c18efa9(index, props.element.props.points)
                                    }
                                });
                            },
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1e0519456d104339$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            type: "link",
                            style: {
                                float: 'right'
                            },
                            onClick: async ()=>{
                                props.onChange({
                                    ...props.element,
                                    props: {
                                        ...props.element.props,
                                        points: $0a800a542e777d65$export$7ed91a9c68d5a769(index, props.element.props.points)
                                    }
                                });
                            },
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $da40d833ab151490$export$2e2bcd8739ae039), {})
                        })
                    ]
                }, index))
        })
    });
}




parcelRequire("ltGt3");

function $840d6511fc758a0f$export$77318442929b36eb(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d029ee757225a242$export$2e2bcd8739ae039), {
            direction: "vertical",
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $bbe04e8e6f6789c3$export$2e2bcd8739ae039), {
                    style: {
                        width: '100%'
                    },
                    addonBefore: `${intl.formatMessage({
                        id: 'side'
                    })} 1`,
                    addonAfter: intl.formatMessage({
                        id: 'm'
                    }),
                    onChange: (value)=>{
                        props.onChange({
                            ...props.element,
                            props: {
                                ...props.element.props,
                                width: value * 100
                            }
                        });
                    },
                    value: props.element.props.width / 100
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $bbe04e8e6f6789c3$export$2e2bcd8739ae039), {
                    style: {
                        width: '100%'
                    },
                    addonBefore: `${intl.formatMessage({
                        id: 'side'
                    })} 2`,
                    addonAfter: intl.formatMessage({
                        id: 'm'
                    }),
                    onChange: (value)=>{
                        props.onChange({
                            ...props.element,
                            props: {
                                ...props.element.props,
                                height: value * 100
                            }
                        });
                    },
                    value: props.element.props.height / 100
                })
            ]
        })
    });
}




parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");



function $b0615293f6cbc440$export$6a851efde98a38fc({ onElementDrawn: onElementDrawn }) {
    const [ellipseCenter, setEllipseCenter, ellipseCenterRef] = (0, $0b74b96b3af31f54$export$8a36538c679950a6)(null);
    const [dimensions, setDimensions, dimensionsRef] = (0, $0b74b96b3af31f54$export$8a36538c679950a6)({
        radiusX: 0,
        radiusY: 0
    });
    const layerRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    (0, $ltGt3.useEffect)(()=>{
        const onMouseDown = (e)=>{
            const { x: x, y: y } = (0, $83a8040be81947e5$export$79263550b33b988b)(e.target);
            setEllipseCenter({
                x: x,
                y: y
            });
        };
        const onMouseMove = (e)=>{
            if (!ellipseCenterRef.current) return;
            const { x: x, y: y } = ellipseCenterRef.current;
            const { x: mouseX, y: mouseY } = (0, $83a8040be81947e5$export$79263550b33b988b)(e.target);
            const radiusX = Math.abs(mouseX - x);
            const radiusY = Math.abs(mouseY - y);
            setDimensions({
                radiusX: radiusX,
                radiusY: radiusY
            });
        };
        const onMouseUp = (e)=>{
            if (!ellipseCenterRef.current) return;
            let x1 = ellipseCenterRef.current.x;
            let x2 = x1 + dimensionsRef.current.radiusX;
            let y1 = ellipseCenterRef.current.y;
            let y2 = y1 + dimensionsRef.current.radiusY;
            onElementDrawn({
                type: 'ellipse',
                props: {
                    x: Math.floor(x1),
                    y: Math.floor(y1),
                    radiusX: Math.floor(x2 - x1),
                    radiusY: Math.floor(y2 - y1)
                }
            });
            setEllipseCenter(null);
        };
        const stage = layerRef.current.getStage();
        stage.on('mousedown', onMouseDown);
        stage.on('mousemove', onMouseMove);
        stage.on('mouseup', onMouseUp);
        return ()=>{
            if (stage) {
                stage.off('mousedown', onMouseDown);
                stage.off('mousemove', onMouseMove);
                stage.off('mouseup', onMouseUp);
            }
        };
    }, [
        onElementDrawn
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$936d0764594b6eb3), {
        ref: layerRef,
        opacity: 0.7,
        children: ellipseCenter && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$80b0269ab108fa11), {
            fill: "blue",
            x: ellipseCenter.x,
            y: ellipseCenter.y,
            radiusX: dimensions.radiusX,
            radiusY: dimensions.radiusY
        })
    });
}




parcelRequire("ltGt3");

function $42477d7fd452ce56$export$12603a26e9d468d2(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d029ee757225a242$export$2e2bcd8739ae039), {
            direction: "vertical",
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $bbe04e8e6f6789c3$export$2e2bcd8739ae039), {
                    style: {
                        width: '100%'
                    },
                    addonBefore: `${intl.formatMessage({
                        id: 'side'
                    })} 1`,
                    addonAfter: intl.formatMessage({
                        id: 'm'
                    }),
                    onChange: (value)=>{
                        props.onChange({
                            ...props.element,
                            props: {
                                ...props.element.props,
                                radiusX: value * 50
                            }
                        });
                    },
                    value: props.element.props.radiusX / 50
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $bbe04e8e6f6789c3$export$2e2bcd8739ae039), {
                    style: {
                        width: '100%'
                    },
                    addonBefore: `${intl.formatMessage({
                        id: 'side'
                    })} 2`,
                    addonAfter: intl.formatMessage({
                        id: 'm'
                    }),
                    onChange: (value)=>{
                        props.onChange({
                            ...props.element,
                            props: {
                                ...props.element.props,
                                radiusY: value * 50
                            }
                        });
                    },
                    value: props.element.props.radiusY / 50
                })
            ]
        })
    });
}




var $ltGt3 = parcelRequire("ltGt3");

const $805956a52e69383f$var$attributesWhitelist = [
    'x',
    'y',
    'radiusX',
    'radiusY',
    'rotation'
];
function $805956a52e69383f$export$9e05cf153765f82e(props) {
    const rotationRef = (0, $ltGt3.useRef)(props.shapeRef.current?.getAttr('rotation'));
    const handleChangeDrag = (e)=>{
        const shape = props.shapeRef.current;
        const attributes = shape.getAttrs();
        const newProps = {};
        for (const attributeName of $805956a52e69383f$var$attributesWhitelist){
            let value = attributes[attributeName];
            if (typeof value === 'number') value = Math.round(value);
            newProps[attributeName] = value;
        }
        props.onChange?.({
            type: props.element.type,
            elementId: props.element.elementId,
            name: props.element.name,
            shapeType: props.element.shapeType,
            props: newProps
        });
    };
    const handleChangeTransform = (e)=>{
        const shape = props.shapeRef.current;
        const attributes = shape.getAttrs();
        // fix for bug in Konva - when rotation happens using transformer,
        // it can also change width and height on the element itself (if it was
        // changed previously), so we can't take rotation+width+height every time
        // and need to update rotation alone if it changes. rotationRef is used
        // to track current value to understand if it was changed
        if (rotationRef.current !== attributes.rotation) {
            rotationRef.current = attributes.rotation;
            props.onChange?.({
                type: props.element.type,
                elementId: props.element.elementId,
                name: props.element.name,
                shapeType: props.element.shapeType,
                props: {
                    ...props.element.props,
                    rotation: attributes.rotation
                }
            });
            return;
        }
        const newProps = {};
        for (const attributeName of $805956a52e69383f$var$attributesWhitelist){
            let value = attributes[attributeName];
            if (attributeName === 'radiusX') value = value * attributes.scaleX;
            if (attributeName === 'radiusY') value = value * attributes.scaleY;
            if (typeof value === 'number') value = Math.round(value);
            newProps[attributeName] = value;
        }
        props.onChange?.({
            type: props.element.type,
            elementId: props.element.elementId,
            name: props.element.name,
            shapeType: props.element.shapeType,
            props: newProps
        });
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$f993aef960936087), {
        flipEnabled: false,
        rotateEnabled: props.mode === 'edit',
        ref: props.transformerRef,
        draggable: props.mode === 'edit',
        borderEnabled: true,
        resizeEnabled: props.mode === 'edit',
        onDragMove: handleChangeDrag,
        onTransform: handleChangeTransform
    });
}




var $ltGt3 = parcelRequire("ltGt3");


function $f95fe4bf273ecb05$export$f5fb948124ea8231({ onElementDrawn: onElementDrawn }) {
    const layerRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    (0, $ltGt3.useEffect)(()=>{
        const onClick = (e)=>{
            const { x: x, y: y } = (0, $83a8040be81947e5$export$79263550b33b988b)(e.target);
            onElementDrawn({
                type: 'image',
                props: {
                    x: Math.floor(x),
                    y: Math.floor(y),
                    width: 150,
                    height: 150
                }
            });
        };
        const stage = layerRef.current.getStage();
        stage.on('click', onClick);
        return ()=>{
            if (stage) stage.off('click', onClick);
        };
    }, [
        onElementDrawn
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$936d0764594b6eb3), {
        ref: layerRef
    });
}




var $ltGt3 = parcelRequire("ltGt3");



function $d626c61c0c6b6793$export$adeaa9b9f07c936e({ onElementDrawn: onElementDrawn }) {
    const [topLeftCorner, setTopLeftCorner, topLeftCornerRef] = (0, $0b74b96b3af31f54$export$8a36538c679950a6)(null);
    const [dimensions, setDimensions, dimensionsRef] = (0, $0b74b96b3af31f54$export$8a36538c679950a6)({
        width: 0,
        height: 0
    });
    const layerRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    (0, $ltGt3.useEffect)(()=>{
        const onMouseDown = (e)=>{
            const { x: x, y: y } = (0, $83a8040be81947e5$export$79263550b33b988b)(e.target);
            setTopLeftCorner({
                x: x,
                y: y
            });
        };
        const onMouseMove = (e)=>{
            if (!topLeftCornerRef.current) return;
            const { x: x, y: y } = topLeftCornerRef.current;
            const { x: mouseX, y: mouseY } = (0, $83a8040be81947e5$export$79263550b33b988b)(e.target);
            const width = mouseX - x;
            const height = mouseY - y;
            const rotation = 0;
            setDimensions({
                width: width,
                height: height
            });
        };
        const onMouseUp = (e)=>{
            if (!topLeftCornerRef.current) return;
            let x1 = topLeftCornerRef.current.x;
            let x2 = x1 + dimensionsRef.current.width;
            let y1 = topLeftCornerRef.current.y;
            let y2 = y1 + dimensionsRef.current.height;
            if (x1 > x2) [x1, x2] = [
                x2,
                x1
            ];
            if (y1 > y2) [y1, y2] = [
                y2,
                y1
            ];
            onElementDrawn({
                type: 'image',
                props: {
                    x: Math.floor(x1),
                    y: Math.floor(y1),
                    width: Math.floor(x2 - x1),
                    height: Math.floor(y2 - y1)
                }
            });
            setTopLeftCorner(null);
        };
        const stage = layerRef.current.getStage();
        stage.on('mousedown', onMouseDown);
        stage.on('mousemove', onMouseMove);
        stage.on('mouseup', onMouseUp);
        return ()=>{
            if (stage) {
                stage.off('mousedown', onMouseDown);
                stage.off('mousemove', onMouseMove);
                stage.off('mouseup', onMouseUp);
            }
        };
    }, [
        onElementDrawn
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$936d0764594b6eb3), {
        ref: layerRef,
        opacity: 0.7,
        children: topLeftCorner && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$c79fc6492f3af13d), {
            fill: "blue",
            x: topLeftCorner.x,
            y: topLeftCorner.y,
            width: dimensions.width,
            height: dimensions.height
        })
    });
}


var $8bcbbbe5fa546f88$exports = {};
$8bcbbbe5fa546f88$exports = import.meta.resolve("ekGIo");


const $3b2a1dec172ced19$var$centerPointAabb = (element, pixelsPerCm)=>{
    return {
        xFrom: element.props.x,
        xTo: element.props.x,
        yFrom: element.props.y,
        yTo: element.props.y
    };
};
const $3b2a1dec172ced19$export$bbdb2c97169ec0d5 = {
    polygon: {
        toolLayer: (0, $9674c66452d92412$export$b030b56241a00d8a),
        transformerLayer: (0, $ab516254d88810f8$export$79585ef54c4b94ae),
        transformerUI: (0, $0a800a542e777d65$export$3d37c13914dd56b0),
        toolIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$df9bd3777d1154d2
        }),
        canvasShapeType: 'Line',
        getAabb (element, pixelsPerCm) {
            return {
                xFrom: Math.min(element.props.points),
                xTo: Math.max(element.props.points),
                yFrom: Math.min(element.props.points),
                yTo: Math.max(element.props.points)
            };
        }
    },
    rect: {
        toolLayer: (0, $1d79f0d8a5f07b81$export$fe423fb41d33947e),
        transformerLayer: (0, $e6da93d0e2f9e49f$export$f02fd88a8648f0c5),
        transformerUI: (0, $840d6511fc758a0f$export$77318442929b36eb),
        toolIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$90b4406457aae8cc
        }),
        canvasShapeType: 'Rect',
        getAabb (element, pixelsPerCm) {
            return {
                xFrom: element.props.x - (1 - Math.cos(element.props.rotaion ? element.props.rotaion : 0)) * element.props.width,
                xTo: element.props.x + Math.cos(element.props.rotaion ? element.props.rotaion : 0) * element.props.width,
                yFrom: element.props.y,
                yTo: element.props.y + element.props.height
            };
        }
    },
    ellipse: {
        toolLayer: (0, $b0615293f6cbc440$export$6a851efde98a38fc),
        transformerLayer: (0, $805956a52e69383f$export$9e05cf153765f82e),
        transformerUI: (0, $42477d7fd452ce56$export$12603a26e9d468d2),
        toolIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$37fe3659ba7b6b54
        }),
        canvasShapeType: 'Ellipse',
        getAabb (element, pixelsPerCm) {
            return {
                xFrom: element.props.x - (1 - Math.cos(element.props.rotaion)) * element.props.radiusX,
                xTo: element.props.x + Math.cos(element.props.rotaion) * element.props.radiusX,
                yFrom: element.props.y,
                yTo: element.props.y + 2 * element.props.radiusY
            };
        }
    },
    plant: {
        toolLayer: (0, $f95fe4bf273ecb05$export$f5fb948124ea8231),
        transformerLayer: (0, $e6da93d0e2f9e49f$export$f02fd88a8648f0c5),
        transformerUI: undefined,
        toolIcon: '',
        canvasShapeType: 'Image',
        toolCursor: `url("${(0, (/*@__PURE__*/$parcel$interopDefault($8bcbbbe5fa546f88$exports)))}") 10 26, auto`,
        getAabb (element, pixelsPerCm) {
            return {
                xFrom: element.props.x - 10,
                xTo: element.props.x + 10,
                yFrom: element.props.y - 10,
                yTo: element.props.y + 10
            };
        }
    },
    image: {
        toolLayer: (0, $d626c61c0c6b6793$export$adeaa9b9f07c936e),
        transformerLayer: (0, $e6da93d0e2f9e49f$export$f02fd88a8648f0c5),
        transformerUI: (0, $840d6511fc758a0f$export$77318442929b36eb),
        toolIcon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
            icon: $1113a0aa61ab7765$export$90b4406457aae8cc
        }),
        canvasShapeType: 'Image',
        getAabb (element, pixelsPerCm) {
            return {
                xFrom: element.props.x - (1 - Math.cos(element.props.rotaion ? element.props.rotaion : 0)) * element.props.width,
                xTo: element.props.x + Math.cos(element.props.rotaion ? element.props.rotaion : 0) * element.props.width,
                yFrom: element.props.y,
                yTo: element.props.y + element.props.height
            };
        }
    }
};


function $efc2278554982d41$export$11d74a66c53c9999(props) {
    const TransformerLayerComponent = (0, $ltGt3.useMemo)(()=>(0, $3b2a1dec172ced19$export$bbdb2c97169ec0d5)[props.element.shapeType]?.transformerLayer, [
        props.element.shapeType
    ]);
    if (!TransformerLayerComponent) return null;
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)(TransformerLayerComponent, {
        element: props.element,
        mode: props.mode,
        shapeRef: props.shapeRef,
        transformerRef: props.transformerRef,
        onChange: props.onChange,
        transformerLayerProps: props.transformerLayerProps
    });
}



var $cf106a27c1284942$exports = {};

var $ltGt3 = parcelRequire("ltGt3");
$cf106a27c1284942$exports = function useImage(url, crossOrigin, referrerpolicy) {
    // lets use refs for image and status
    // so we can update them during render
    // to have instant update in status/image when new data comes in
    const statusRef = $ltGt3.useRef('loading');
    const imageRef = $ltGt3.useRef();
    // we are not going to use token
    // but we need to just to trigger state update
    const [_, setStateToken] = $ltGt3.useState(0);
    // keep track of old props to trigger changes
    const oldUrl = $ltGt3.useRef();
    const oldCrossOrigin = $ltGt3.useRef();
    const oldReferrerPolicy = $ltGt3.useRef();
    if (oldUrl.current !== url || oldCrossOrigin.current !== crossOrigin || oldReferrerPolicy.current !== referrerpolicy) {
        statusRef.current = 'loading';
        imageRef.current = undefined;
        oldUrl.current = url;
        oldCrossOrigin.current = crossOrigin;
        oldReferrerPolicy.current = referrerpolicy;
    }
    $ltGt3.useLayoutEffect(function() {
        if (!url) return;
        var img = document.createElement('img');
        function onload() {
            statusRef.current = 'loaded';
            imageRef.current = img;
            setStateToken(Math.random());
        }
        function onerror() {
            statusRef.current = 'failed';
            imageRef.current = undefined;
            setStateToken(Math.random());
        }
        img.addEventListener('load', onload);
        img.addEventListener('error', onerror);
        crossOrigin && (img.crossOrigin = crossOrigin);
        referrerpolicy && (img.referrerpolicy = referrerpolicy);
        img.src = url;
        return function cleanup() {
            img.removeEventListener('load', onload);
            img.removeEventListener('error', onerror);
        };
    }, [
        url,
        crossOrigin,
        referrerpolicy
    ]);
    // return array because it it better to use in case of several useImage hooks
    // const [background, backgroundStatus] = useImage(url1);
    // const [patter] = useImage(url2);
    return [
        imageRef.current,
        statusRef.current
    ];
};


var $8702f8f77cdd6b82$exports = {};
$8702f8f77cdd6b82$exports = import.meta.resolve("5gxBt");


var $c7cfc1d4820f7b38$exports = {};
$c7cfc1d4820f7b38$exports = import.meta.resolve("kaAyf");


var $2a9a5da68a6982c2$exports = {};
$2a9a5da68a6982c2$exports = import.meta.resolve("huaQM");


var $1036b696d053ab88$exports = {};
$1036b696d053ab88$exports = import.meta.resolve("h1G2K");


var $b054d95b5139a2ea$exports = {};
$b054d95b5139a2ea$exports = import.meta.resolve("hBsKQ");


var $05ac1e5cd3d9c7b7$exports = {};
$05ac1e5cd3d9c7b7$exports = import.meta.resolve("4q9Wj");


var $989cfa7cddf5dc2d$exports = {};
$989cfa7cddf5dc2d$exports = import.meta.resolve("1FgTN");


var $56e3bb4b7cb5f743$exports = {};
$56e3bb4b7cb5f743$exports = import.meta.resolve("grnMH");


var $4dd8ea7f0bed1022$exports = {};
$4dd8ea7f0bed1022$exports = import.meta.resolve("2GkUL");


var $12ada9c74ceedf0d$exports = {};
$12ada9c74ceedf0d$exports = import.meta.resolve("9zCmM");


var $dd0e97c7829cb9bd$exports = {};
$dd0e97c7829cb9bd$exports = import.meta.resolve("9e9DB");


var $ff2467a5d0cb981c$exports = {};
$ff2467a5d0cb981c$exports = import.meta.resolve("59Fej");


var $821f858fea9da966$exports = {};
$821f858fea9da966$exports = import.meta.resolve("99OOX");


var $91e43b4ed0ca6f57$exports = {};
$91e43b4ed0ca6f57$exports = import.meta.resolve("dxrUl");


var $b86c62aedc588245$exports = {};
$b86c62aedc588245$exports = import.meta.resolve("b9jew");


var $145acf16246ad653$exports = {};
$145acf16246ad653$exports = import.meta.resolve("iVL4E");


var $09e308a7eda53c2e$exports = {};
$09e308a7eda53c2e$exports = import.meta.resolve("c4ym7");


var $6a3eb8ce208f57bd$exports = {};
$6a3eb8ce208f57bd$exports = import.meta.resolve("baLlw");


var $bb72264183dd37ef$exports = {};
$bb72264183dd37ef$exports = import.meta.resolve("2GoSu");


var $d813990a06ffe44d$exports = {};
$d813990a06ffe44d$exports = import.meta.resolve("alhiP");


var $a548ce159d25e403$exports = {};
$a548ce159d25e403$exports = import.meta.resolve("1ClHH");


var $ec4644181ab2c126$exports = {};
$ec4644181ab2c126$exports = import.meta.resolve("5HDqE");


var $48fc16ecb24e1052$exports = {};
$48fc16ecb24e1052$exports = import.meta.resolve("4Pbxi");


var $4df1f1699abc60ae$exports = {};
$4df1f1699abc60ae$exports = import.meta.resolve("3qyNC");


var $3b8d0cac7ff9f473$exports = {};
$3b8d0cac7ff9f473$exports = import.meta.resolve("eDvG1");


var $f5c783112926e843$exports = {};
$f5c783112926e843$exports = import.meta.resolve("c92Pb");


var $867cf9145d2bd3ae$exports = {};
$867cf9145d2bd3ae$exports = import.meta.resolve("3QGdO");


var $b5dbab406c04a729$exports = {};
$b5dbab406c04a729$exports = import.meta.resolve("27pM8");


var $f55ec233d6fffabc$exports = {};
$f55ec233d6fffabc$exports = import.meta.resolve("aNWEP");


var $33e1e14d4b5c86e8$exports = {};
$33e1e14d4b5c86e8$exports = import.meta.resolve("aYxuN");


var $c55663dc10ec7b64$exports = {};
$c55663dc10ec7b64$exports = import.meta.resolve("fhuI0");


var $c97d7fb9a61673dd$exports = {};
$c97d7fb9a61673dd$exports = import.meta.resolve("lA3Jz");


var $2d653c5ad7b73ced$exports = {};
$2d653c5ad7b73ced$exports = import.meta.resolve("gKsRC");


var $aaeab09f6ba52b6a$exports = {};
$aaeab09f6ba52b6a$exports = import.meta.resolve("6PL08");


var $8d22460dc4aecc01$exports = {};
$8d22460dc4aecc01$exports = import.meta.resolve("8C61P");


var $ed207e3a0f331294$exports = {};
$ed207e3a0f331294$exports = import.meta.resolve("coMfb");


var $7716daac4d8c1f59$exports = {};
$7716daac4d8c1f59$exports = import.meta.resolve("1EZuZ");


var $b27110097a8e60f6$exports = {};
$b27110097a8e60f6$exports = import.meta.resolve("6gLvj");


var $7c9047a03f5db7c4$exports = {};
$7c9047a03f5db7c4$exports = import.meta.resolve("8qq7e");


var $053429c5a9425093$exports = {};
$053429c5a9425093$exports = import.meta.resolve("23yKe");


var $bc3620fc51b95a25$exports = {};
$bc3620fc51b95a25$exports = import.meta.resolve("gFL0b");


var $b648de2877c019f2$exports = {};
$b648de2877c019f2$exports = import.meta.resolve("2A9XX");


var $1c5278837aed2233$exports = {};
$1c5278837aed2233$exports = import.meta.resolve("aIrXl");


var $7b71ce726fdc82c2$exports = {};
$7b71ce726fdc82c2$exports = import.meta.resolve("ebjrg");


var $689cfa64cb22a198$exports = {};
$689cfa64cb22a198$exports = import.meta.resolve("g0v2T");


var $2c5f174e977251eb$exports = {};
$2c5f174e977251eb$exports = import.meta.resolve("7daV5");


var $09f5d301db0ed446$exports = {};
$09f5d301db0ed446$exports = import.meta.resolve("jjrkK");


var $925680009f8db998$exports = {};
$925680009f8db998$exports = import.meta.resolve("6S6v7");


var $ac295c0286c1b690$exports = {};
$ac295c0286c1b690$exports = import.meta.resolve("kRAK2");


var $736419d7fc3990b1$exports = {};
$736419d7fc3990b1$exports = import.meta.resolve("3JzeP");


var $dc79f4738b720662$exports = {};
$dc79f4738b720662$exports = import.meta.resolve("dBpM6");


var $146df65089078b72$exports = {};
$146df65089078b72$exports = import.meta.resolve("i6Jw0");


var $caf46e1548907f87$exports = {};
$caf46e1548907f87$exports = import.meta.resolve("7TiIe");


var $1b27ef30cac5c9b0$exports = {};
$1b27ef30cac5c9b0$exports = import.meta.resolve("1fiqt");


var $30f00febed4de909$exports = {};
$30f00febed4de909$exports = import.meta.resolve("5mUT3");


var $394e712011a00491$exports = {};
$394e712011a00491$exports = import.meta.resolve("5fnt7");


var $331d7330fc2fdcf9$exports = {};
$331d7330fc2fdcf9$exports = import.meta.resolve("aQU3W");


var $4da38f3d5e8b0f7d$exports = {};
$4da38f3d5e8b0f7d$exports = import.meta.resolve("9rfx0");


var $8062ae4834ffb758$exports = {};
$8062ae4834ffb758$exports = import.meta.resolve("bwm6p");


var $c0e9bc6fd96d16da$exports = {};
$c0e9bc6fd96d16da$exports = import.meta.resolve("5e6Ec");


var $edd183e22a5bf29c$exports = {};
$edd183e22a5bf29c$exports = import.meta.resolve("ahStb");


var $acd973cf0654c237$exports = {};
$acd973cf0654c237$exports = import.meta.resolve("80F2U");


var $0a25383b77469fe2$exports = {};
$0a25383b77469fe2$exports = import.meta.resolve("cIbvV");


var $8d6e456a85858c02$exports = {};
$8d6e456a85858c02$exports = import.meta.resolve("ayZNr");


var $e2512b365f9178b0$exports = {};
$e2512b365f9178b0$exports = import.meta.resolve("seedS");


var $6c794f8561a893c8$exports = {};
$6c794f8561a893c8$exports = import.meta.resolve("z8oVl");


var $b5473898f9fd6dce$exports = {};
$b5473898f9fd6dce$exports = import.meta.resolve("kPeC1");


var $8f7fa97306954b80$exports = {};
$8f7fa97306954b80$exports = import.meta.resolve("5EcOe");


var $3add8dd6b68a94ea$exports = {};
$3add8dd6b68a94ea$exports = import.meta.resolve("hBg5i");


var $0fd5185be514894f$exports = {};
$0fd5185be514894f$exports = import.meta.resolve("bPEoM");


var $92019450ceae6e50$exports = {};
$92019450ceae6e50$exports = import.meta.resolve("j3I4V");


var $eb0255f674f5c977$exports = {};
$eb0255f674f5c977$exports = import.meta.resolve("cEJSo");


var $bd54e91ad0254ae2$exports = {};
$bd54e91ad0254ae2$exports = import.meta.resolve("6hmUH");


var $6e251ce1cbcf5e6e$exports = {};
$6e251ce1cbcf5e6e$exports = import.meta.resolve("fbjuO");


var $e1b9081c356b449f$exports = {};
$e1b9081c356b449f$exports = import.meta.resolve("76eVI");


var $8df66746e379117b$exports = {};
$8df66746e379117b$exports = import.meta.resolve("gwG0Q");


var $8e1cd09b49bafe87$exports = {};
$8e1cd09b49bafe87$exports = import.meta.resolve("4hp45");


var $e193736f60cca974$exports = {};
$e193736f60cca974$exports = import.meta.resolve("kBcHB");


var $2662597dbd76f116$exports = {};
$2662597dbd76f116$exports = import.meta.resolve("f6qtm");


var $288f60075463cc72$exports = {};
$288f60075463cc72$exports = import.meta.resolve("8ZlWx");


var $70169a1ba23b2f95$exports = {};
$70169a1ba23b2f95$exports = import.meta.resolve("gbDlQ");


var $89dd618cb85cb937$exports = {};
$89dd618cb85cb937$exports = import.meta.resolve("9CW28");


var $413ea6e11462d3dd$exports = {};
$413ea6e11462d3dd$exports = import.meta.resolve("bSVrq");


var $fe14815fece65240$exports = {};
$fe14815fece65240$exports = import.meta.resolve("6277P");


var $ce48d4d65e65c1ba$exports = {};
$ce48d4d65e65c1ba$exports = import.meta.resolve("m0nv0");


var $f786546aed16b634$exports = {};
$f786546aed16b634$exports = import.meta.resolve("kamY2");


var $8b747bcded58714c$exports = {};
$8b747bcded58714c$exports = import.meta.resolve("7zCs4");


var $df5c8d61da954db7$exports = {};
$df5c8d61da954db7$exports = import.meta.resolve("ke8C2");


var $0a080b1f69109635$exports = {};
$0a080b1f69109635$exports = import.meta.resolve("dMDJo");


var $5a0dfc3793e459ce$exports = {};
$5a0dfc3793e459ce$exports = import.meta.resolve("jBJkb");


var $8e87d8f39fc5fae2$exports = {};
$8e87d8f39fc5fae2$exports = import.meta.resolve("ZloVP");


var $3f781d429fb7ba15$exports = {};
$3f781d429fb7ba15$exports = import.meta.resolve("i3Vvh");


var $f7b930da8c972832$exports = {};
$f7b930da8c972832$exports = import.meta.resolve("8X18N");


var $904bb8703731a910$exports = {};
$904bb8703731a910$exports = import.meta.resolve("K8xVL");


var $3f531efd40452b89$exports = {};
$3f531efd40452b89$exports = import.meta.resolve("3LuLF");


var $38b493817acbd945$exports = {};
$38b493817acbd945$exports = import.meta.resolve("5514x");


var $9a06b62d3d5e43b0$exports = {};
$9a06b62d3d5e43b0$exports = import.meta.resolve("6gOI7");


var $61e98db61c9271b8$exports = {};
$61e98db61c9271b8$exports = import.meta.resolve("63P6g");


var $69aed0354af3ec83$exports = {};
$69aed0354af3ec83$exports = import.meta.resolve("7UKJu");


var $a1208160d9f799ef$exports = {};
$a1208160d9f799ef$exports = import.meta.resolve("5bHGF");


var $953184bcf806718f$exports = {};
$953184bcf806718f$exports = import.meta.resolve("a6NgL");


var $7a2332ced9e1552f$exports = {};
$7a2332ced9e1552f$exports = import.meta.resolve("gB0Np");


var $5ebac71384212a6b$exports = {};
$5ebac71384212a6b$exports = import.meta.resolve("7eegt");


var $77e7da783629304e$exports = {};
$77e7da783629304e$exports = import.meta.resolve("8aoZj");


var $aca60e4025bb0e54$exports = {};
$aca60e4025bb0e54$exports = import.meta.resolve("84ELv");


var $9c2a3223ffc91293$exports = {};
$9c2a3223ffc91293$exports = import.meta.resolve("6WbOO");


var $2b045a9a01ecffa0$exports = {};
$2b045a9a01ecffa0$exports = import.meta.resolve("afAad");


var $89dc3ce82fe961fa$exports = {};
$89dc3ce82fe961fa$exports = import.meta.resolve("ghAR4");


var $d01c492a9793051f$exports = {};
$d01c492a9793051f$exports = import.meta.resolve("liSXr");


var $8d76da60421dfa4c$exports = {};
$8d76da60421dfa4c$exports = import.meta.resolve("b1W4c");


var $2ae39bb9c5412900$exports = {};
$2ae39bb9c5412900$exports = import.meta.resolve("6OZPB");


var $8adc237ce30a16d2$exports = {};
$8adc237ce30a16d2$exports = import.meta.resolve("8waSb");


var $2ee3bc73130ef65c$exports = {};
$2ee3bc73130ef65c$exports = import.meta.resolve("j3f1b");


var $1dfb7ae8bc5582d9$exports = {};
$1dfb7ae8bc5582d9$exports = import.meta.resolve("hsAC4");


var $12cc42d630d760c7$exports = {};
$12cc42d630d760c7$exports = import.meta.resolve("klepP");


const $670e204136b37e30$var$baseTemplate = 'tree1';
class $670e204136b37e30$export$8f0f48ce3775b160 {
    getElementTypes() {
        return Object.entries(this.elementTypes).map(([key, value])=>({
                id: key,
                ...value
            }));
    }
    chooseElementTypeTemplate(elementTypeId, templateId) {
        if (!templateId) return $670e204136b37e30$var$baseTemplate;
        return this.elementTypes[elementTypeId].templates[templateId] ? templateId : $670e204136b37e30$var$baseTemplate;
    }
    getElementType(id) {
        if (!this.elementTypes[id]) return null;
        return {
            id: id,
            ...this.elementTypes[id]
        };
    }
    getSectorElementTypes() {
        return [
            'flowerbed',
            'garden',
            'lawn',
            'vegetablegarden',
            'plantcomposition',
            'hedge',
            'plant',
            'greenhouse'
        ];
    }
    getBuildingsElementTypes() {
        return [
            'building',
            'structure',
            'fence',
            'entrance',
            'hedge'
        ];
    }
    getHardscapeElementTypes() {
        return [
            'pathway',
            'terrace',
            'tile',
            'stairs',
            'court',
            'patio'
        ];
    }
    getWaterscapeElementTypes() {
        return [
            'pool',
            'water'
        ];
    }
    getPlantsElementTypes() {
        return [
            'tree'
        ];
    }
    getSolitariusElementTypes() {
        return [
            'tree',
            'bush',
            'flower',
            'vegetable'
        ];
    }
    getOtherElementTypes() {
        return [
            'furniture',
            'lighting',
            'other'
        ];
    }
    getElementTypeTemplates(id) {
        if (!this.elementTypes[id]) return null;
        return this.elementTypes[id].templates;
    }
    constructor(){
        this.elementTypes = {
            building: {
                displayName: 'building',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($bb72264183dd37ef$exports))),
                        shadowBlur: 200
                    }),
                templates: {
                    building1: {
                        width: 1400,
                        height: 700,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2d653c5ad7b73ced$exports))),
                        name: 'building 1'
                    },
                    building2: {
                        width: 1150,
                        height: 650,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($aaeab09f6ba52b6a$exports))),
                        name: 'building 2'
                    },
                    building3: {
                        width: 1400,
                        height: 900,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8d22460dc4aecc01$exports))),
                        name: 'building 3'
                    },
                    building4: {
                        width: 815,
                        height: 805,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ed207e3a0f331294$exports))),
                        name: 'building 4'
                    },
                    building5: {
                        width: 780,
                        height: 780,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7716daac4d8c1f59$exports))),
                        name: 'building 5'
                    },
                    building6: {
                        width: 915,
                        height: 1770,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b27110097a8e60f6$exports))),
                        name: 'building 6'
                    },
                    building7: {
                        width: 1630,
                        height: 290,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7c9047a03f5db7c4$exports))),
                        name: 'building 7'
                    },
                    building8: {
                        width: 1645,
                        height: 1300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($053429c5a9425093$exports))),
                        name: 'building 8'
                    },
                    building9: {
                        width: 1400,
                        height: 720,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bc3620fc51b95a25$exports))),
                        name: 'building 9'
                    },
                    building10: {
                        width: 1150,
                        height: 860,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b648de2877c019f2$exports))),
                        name: 'building 10'
                    },
                    building11: {
                        width: 1150,
                        height: 660,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1c5278837aed2233$exports))),
                        name: 'building 11'
                    },
                    building12: {
                        width: 900,
                        height: 900,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7b71ce726fdc82c2$exports))),
                        name: 'building 12'
                    },
                    building13: {
                        width: 1150,
                        height: 660,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($689cfa64cb22a198$exports))),
                        name: 'building 13'
                    },
                    building14: {
                        width: 990,
                        height: 990,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2c5f174e977251eb$exports))),
                        name: 'building 14'
                    },
                    building15: {
                        width: 1580,
                        height: 1260,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($09f5d301db0ed446$exports))),
                        name: 'building 15'
                    },
                    building16: {
                        width: 1580,
                        height: 820,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($925680009f8db998$exports))),
                        name: 'building 16'
                    },
                    building17: {
                        width: 1400,
                        height: 720,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ac295c0286c1b690$exports))),
                        name: 'building 17'
                    },
                    building18: {
                        width: 1310,
                        height: 1280,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($736419d7fc3990b1$exports))),
                        name: 'building 18'
                    }
                },
                zIndex: 150
            },
            garden: {
                displayName: 'garden',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($4df1f1699abc60ae$exports))),
                        shadowBlur: 100
                    }),
                // templates: {
                //   garden1: {width: 1600, height: 800, src: garden1, name: 'garden 1'},
                // },
                zIndex: 120
            },
            lawn: {
                displayName: 'lawn',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($33e1e14d4b5c86e8$exports)))
                    }),
                zIndex: 20
            },
            flowerbed: {
                displayName: 'flowerbed',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($48fc16ecb24e1052$exports))),
                        stroke: '#aadd98ad',
                        strokeWidth: 50
                    }),
                templates: {
                    flowerbed1: {
                        width: 400,
                        height: 400,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f786546aed16b634$exports))),
                        name: 'flowerbed 1'
                    },
                    flowerbed2: {
                        width: 400,
                        height: 400,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8b747bcded58714c$exports))),
                        name: 'flowerbed 2'
                    },
                    flowerbed11: {
                        width: 400,
                        height: 400,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($df5c8d61da954db7$exports))),
                        name: 'flowerbed 11'
                    },
                    flowerbed22: {
                        width: 400,
                        height: 400,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0a080b1f69109635$exports))),
                        name: 'flowerbed 22'
                    }
                },
                zIndex: 30
            },
            greenhouse: {
                displayName: 'greenhouse',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($c97d7fb9a61673dd$exports)))
                    }),
                templates: {
                    greenhouse1: {
                        width: 1000,
                        height: 300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8adc237ce30a16d2$exports))),
                        name: 'greenhouse 1'
                    }
                },
                zIndex: 40
            },
            vegetablegarden: {
                displayName: 'vegetablegarden',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($3b8d0cac7ff9f473$exports))),
                        stroke: '#997361cc',
                        strokeWidth: 50
                    }),
                templates: {
                    //veggardencabbage: {width: 80, height: 188, src: veggardencabbage1, name: 'cabbage 1'},
                    veggarden11: {
                        width: 80,
                        height: 188,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($92019450ceae6e50$exports))),
                        name: 'veg garden 11'
                    },
                    veggarden12: {
                        width: 80,
                        height: 188,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($eb0255f674f5c977$exports))),
                        name: 'veg garden 12'
                    },
                    //veggarden2: {width: 300, height: 50, src: veggarden2, name: 'veg garden 2'},
                    //veggarden4: {width: 300, height: 100, src: veggarden4, name: 'veg garden 4'},
                    //veggarden7: {width: 300, height: 175, src: veggarden7, name: 'veg garden 7'},
                    veggarden26: {
                        width: 600,
                        height: 200,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($bd54e91ad0254ae2$exports))),
                        name: 'veg garden 26'
                    }
                },
                zIndex: 30
            },
            tile: {
                displayName: 'tile',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($f5c783112926e843$exports)))
                    }),
                templates: {
                    tile1: {
                        width: 600,
                        height: 300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e193736f60cca974$exports))),
                        name: 'tile 1'
                    },
                    tile2: {
                        width: 500,
                        height: 350,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2662597dbd76f116$exports))),
                        name: 'tile 2'
                    },
                    tile3: {
                        width: 400,
                        height: 300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($288f60075463cc72$exports))),
                        name: 'tile 3'
                    },
                    tile4: {
                        width: 370,
                        height: 310,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($70169a1ba23b2f95$exports))),
                        name: 'tile 4'
                    },
                    tile5: {
                        width: 320,
                        height: 320,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($89dd618cb85cb937$exports))),
                        name: 'tile 5'
                    },
                    tile6: {
                        width: 330,
                        height: 330,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($413ea6e11462d3dd$exports))),
                        name: 'tile 6'
                    }
                },
                zIndex: 20
            },
            stairs: {
                displayName: 'stairs',
                availableShapeTypes: [
                    'rect',
                    'polygon'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($867cf9145d2bd3ae$exports)))
                    }),
                templates: {
                    stairs1: {
                        width: 100,
                        height: 200,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fe14815fece65240$exports))),
                        name: 'stairs 1'
                    },
                    stairs2: {
                        width: 150,
                        height: 150,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ce48d4d65e65c1ba$exports))),
                        name: 'stairs 2'
                    }
                },
                zIndex: 20
            },
            terrace: {
                displayName: 'terrace',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($b5dbab406c04a729$exports)))
                    }),
                templates: {
                    terrace1: {
                        width: 500,
                        height: 300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5a0dfc3793e459ce$exports))),
                        name: 'terrace 1'
                    }
                },
                zIndex: 20
            },
            fence: {
                displayName: 'fence',
                availableShapeTypes: [
                    'rect',
                    'polygon'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: 'gray',
                        fillPatternImage: ''
                    }),
                templates: {
                    fence1: {
                        width: 430,
                        height: 31,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3f531efd40452b89$exports))),
                        name: 'fence 1'
                    },
                    fence2: {
                        width: 655,
                        height: 27,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($38b493817acbd945$exports))),
                        name: 'fence 2'
                    },
                    fence3: {
                        width: 320,
                        height: 35,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9a06b62d3d5e43b0$exports))),
                        name: 'fence 3'
                    },
                    fence4: {
                        width: 210,
                        height: 28,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($61e98db61c9271b8$exports))),
                        name: 'fence 4'
                    }
                },
                zIndex: 80
            },
            entrance: {
                displayName: 'entrance',
                availableShapeTypes: [
                    'rect'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: 'gray',
                        fillPatternImage: ''
                    }),
                templates: {
                    gate1: {
                        width: 400,
                        height: 30,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($69aed0354af3ec83$exports))),
                        name: 'gate 1'
                    },
                    gate2: {
                        width: 300,
                        height: 30,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a1208160d9f799ef$exports))),
                        name: 'gate 2'
                    },
                    wicket: {
                        width: 120,
                        height: 20,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($953184bcf806718f$exports))),
                        name: 'wicket'
                    }
                },
                zIndex: 80
            },
            // tree: {
            //   displayName: 'tree',
            //   availableShapeTypes: ['ellipse'],
            //   getShapeFromDisplayProps: (displayProps: NodeConfig) => {
            //     const imageHeight = 300
            //     const imageWidth = 300
            //     return {
            //       fill: '',
            //       fillPatternImage: tree1,
            //       fillPatternRepeat: 'no-repeat',
            //       fillPatternScale: {
            //         x: (2 * displayProps.radiusX) / imageWidth,
            //         y: (2 * displayProps.radiusY) / imageHeight,
            //       },
            //       fillPatternOffset: {x: imageWidth / 2, y: imageHeight / 2},
            //     }
            //   },
            // },
            plantcomposition: {
                displayName: 'plantcomposition',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($d813990a06ffe44d$exports)))
                    }),
                // templates: {
                //   rockery1: {width: 362, height: 207, src: rockery1, name: 'rockery 1'},
                //   rockery2: {width: 296, height: 165, src: rockery2, name: 'rockery 2'},
                //   rockery3: {width: 312, height: 307, src: rockery3, name: 'rockery 3'},
                // },
                zIndex: 50
            },
            plot: {
                displayName: '',
                availableShapeTypes: [
                    'rect',
                    'polygon'
                ],
                getShapeFromDisplayProps: (displayProps)=>{
                    return {
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($6a3eb8ce208f57bd$exports)))
                    };
                },
                zIndex: 0
            },
            plant: {
                displayName: 'solitarius',
                availableShapeTypes: [
                    'image'
                ],
                templates: {
                    tree1: {
                        width: 300,
                        height: 300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($989cfa7cddf5dc2d$exports))),
                        name: 'tree'
                    },
                    treeapple: {
                        width: 300,
                        height: 300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($56e3bb4b7cb5f743$exports))),
                        name: 'apple tree'
                    },
                    bush3: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8702f8f77cdd6b82$exports))),
                        name: 'bush'
                    },
                    bush4: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c7cfc1d4820f7b38$exports))),
                        name: 'bush'
                    },
                    bush6: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2a9a5da68a6982c2$exports))),
                        name: 'bush'
                    },
                    bush7: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1036b696d053ab88$exports))),
                        name: 'bush'
                    },
                    //redBush: {width: 100, height: 100, src: redbush, name: 'red bush'},
                    grass_gray: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($05ac1e5cd3d9c7b7$exports))),
                        name: 'grass'
                    },
                    //bonsai3: {width: 100, height: 100, src: bonsai3, name: 'bonsai3'},
                    carex: {
                        width: 50,
                        height: 50,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b054d95b5139a2ea$exports))),
                        name: 'carex'
                    },
                    bushflowersorange: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4dd8ea7f0bed1022$exports))),
                        name: 'bush'
                    },
                    bushflowersred: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($12ada9c74ceedf0d$exports))),
                        name: 'bush'
                    },
                    boxwoodball: {
                        width: 50,
                        height: 50,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dd0e97c7829cb9bd$exports))),
                        name: 'boxwood'
                    },
                    cabbage: {
                        width: 40,
                        height: 40,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ff2467a5d0cb981c$exports))),
                        name: 'cabbage'
                    },
                    carrot: {
                        width: 5,
                        height: 30,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($91e43b4ed0ca6f57$exports))),
                        name: 'carrot'
                    },
                    eggplant: {
                        width: 22,
                        height: 49,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b86c62aedc588245$exports))),
                        name: 'eggplant'
                    },
                    beet: {
                        width: 36,
                        height: 35,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($821f858fea9da966$exports))),
                        name: 'beet'
                    },
                    onion: {
                        width: 14,
                        height: 66,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($145acf16246ad653$exports))),
                        name: 'onion'
                    },
                    salad: {
                        width: 18,
                        height: 26,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($09e308a7eda53c2e$exports))),
                        name: 'salad'
                    }
                },
                getShapeFromDisplayProps: (displayProps)=>{
                    const imageHeight = 150;
                    const imageWidth = 150;
                    return {
                        x: displayProps.x,
                        y: displayProps.y,
                        // fill: 'red',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($c7cfc1d4820f7b38$exports))),
                        fillPatternRepeat: 'no-repeat',
                        fillPatternScale: {
                            x: 80 / imageWidth,
                            y: 80 / imageHeight
                        },
                        radiusX: imageWidth,
                        radiusY: imageHeight,
                        fillPatternOffset: {
                            x: imageWidth / 2,
                            y: imageHeight / 2
                        }
                    };
                },
                zIndex: 50
            },
            tree: {
                displayName: 'treeCat',
                availableShapeTypes: [
                    'image'
                ],
                templates: {
                    tree1: {
                        width: 300,
                        height: 300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($989cfa7cddf5dc2d$exports))),
                        name: 'tree'
                    },
                    treeapple: {
                        width: 300,
                        height: 300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($56e3bb4b7cb5f743$exports))),
                        name: 'apple tree'
                    }
                },
                getShapeFromDisplayProps: (displayProps)=>{
                    const imageHeight = 150;
                    const imageWidth = 150;
                    return {
                        x: displayProps.x,
                        y: displayProps.y,
                        // fill: 'red',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($c7cfc1d4820f7b38$exports))),
                        fillPatternRepeat: 'no-repeat',
                        fillPatternScale: {
                            x: 80 / imageWidth,
                            y: 80 / imageHeight
                        },
                        radiusX: imageWidth,
                        radiusY: imageHeight,
                        fillPatternOffset: {
                            x: imageWidth / 2,
                            y: imageHeight / 2
                        }
                    };
                },
                zIndex: 50
            },
            bush: {
                displayName: 'bushCat',
                availableShapeTypes: [
                    'image'
                ],
                templates: {
                    bush3: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8702f8f77cdd6b82$exports))),
                        name: 'bush'
                    },
                    bush4: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c7cfc1d4820f7b38$exports))),
                        name: 'bush'
                    },
                    bush6: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2a9a5da68a6982c2$exports))),
                        name: 'bush'
                    },
                    bush7: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1036b696d053ab88$exports))),
                        name: 'bush'
                    },
                    //redBush: {width: 100, height: 100, src: redbush, name: 'red bush'},
                    grass_gray: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($05ac1e5cd3d9c7b7$exports))),
                        name: 'grass'
                    },
                    //bonsai3: {width: 100, height: 100, src: bonsai3, name: 'bonsai3'},
                    carex: {
                        width: 50,
                        height: 50,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b054d95b5139a2ea$exports))),
                        name: 'carex'
                    },
                    bushflowersorange: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4dd8ea7f0bed1022$exports))),
                        name: 'bush'
                    },
                    bushflowersred: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($12ada9c74ceedf0d$exports))),
                        name: 'bush'
                    },
                    boxwoodball: {
                        width: 50,
                        height: 50,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dd0e97c7829cb9bd$exports))),
                        name: 'boxwood'
                    }
                },
                getShapeFromDisplayProps: (displayProps)=>{
                    const imageHeight = 150;
                    const imageWidth = 150;
                    return {
                        x: displayProps.x,
                        y: displayProps.y,
                        // fill: 'red',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($c7cfc1d4820f7b38$exports))),
                        fillPatternRepeat: 'no-repeat',
                        fillPatternScale: {
                            x: 80 / imageWidth,
                            y: 80 / imageHeight
                        },
                        radiusX: imageWidth,
                        radiusY: imageHeight,
                        fillPatternOffset: {
                            x: imageWidth / 2,
                            y: imageHeight / 2
                        }
                    };
                },
                zIndex: 50
            },
            flower: {
                displayName: 'flowerCat',
                availableShapeTypes: [
                    'image'
                ],
                templates: {
                    bushflowersorange: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4dd8ea7f0bed1022$exports))),
                        name: 'bush'
                    },
                    bushflowersred: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($12ada9c74ceedf0d$exports))),
                        name: 'bush'
                    }
                },
                getShapeFromDisplayProps: (displayProps)=>{
                    const imageHeight = 150;
                    const imageWidth = 150;
                    return {
                        x: displayProps.x,
                        y: displayProps.y,
                        // fill: 'red',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($c7cfc1d4820f7b38$exports))),
                        fillPatternRepeat: 'no-repeat',
                        fillPatternScale: {
                            x: 80 / imageWidth,
                            y: 80 / imageHeight
                        },
                        radiusX: imageWidth,
                        radiusY: imageHeight,
                        fillPatternOffset: {
                            x: imageWidth / 2,
                            y: imageHeight / 2
                        }
                    };
                },
                zIndex: 50
            },
            vegetable: {
                displayName: 'vegetableCat',
                availableShapeTypes: [
                    'image'
                ],
                templates: {
                    cabbage: {
                        width: 40,
                        height: 40,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ff2467a5d0cb981c$exports))),
                        name: 'cabbage'
                    },
                    carrot: {
                        width: 5,
                        height: 30,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($91e43b4ed0ca6f57$exports))),
                        name: 'carrot'
                    },
                    eggplant: {
                        width: 22,
                        height: 49,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b86c62aedc588245$exports))),
                        name: 'eggplant'
                    },
                    beet: {
                        width: 36,
                        height: 35,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($821f858fea9da966$exports))),
                        name: 'beet'
                    },
                    onion: {
                        width: 14,
                        height: 66,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($145acf16246ad653$exports))),
                        name: 'onion'
                    },
                    salad: {
                        width: 18,
                        height: 26,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($09e308a7eda53c2e$exports))),
                        name: 'salad'
                    }
                },
                getShapeFromDisplayProps: (displayProps)=>{
                    const imageHeight = 150;
                    const imageWidth = 150;
                    return {
                        x: displayProps.x,
                        y: displayProps.y,
                        // fill: 'red',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($c7cfc1d4820f7b38$exports))),
                        fillPatternRepeat: 'no-repeat',
                        fillPatternScale: {
                            x: 80 / imageWidth,
                            y: 80 / imageHeight
                        },
                        radiusX: imageWidth,
                        radiusY: imageHeight,
                        fillPatternOffset: {
                            x: imageWidth / 2,
                            y: imageHeight / 2
                        }
                    };
                },
                zIndex: 50
            },
            structure: {
                displayName: 'structure',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($ec4644181ab2c126$exports))),
                        shadowBlur: 200
                    }),
                templates: {
                    gazebo1: {
                        width: 540,
                        height: 540,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dc79f4738b720662$exports))),
                        name: 'gazebo 1'
                    }
                },
                zIndex: 150
            },
            pathway: {
                displayName: 'pathway',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($f5c783112926e843$exports)))
                    }),
                templates: {
                    pathway1: {
                        width: 100,
                        height: 250,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($146df65089078b72$exports))),
                        name: 'pathway 1'
                    },
                    pathway2: {
                        width: 230,
                        height: 230,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($caf46e1548907f87$exports))),
                        name: 'pathway 2'
                    },
                    pathway3: {
                        width: 230,
                        height: 250,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1b27ef30cac5c9b0$exports))),
                        name: 'pathway 3'
                    },
                    pathway4: {
                        width: 100,
                        height: 250,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($30f00febed4de909$exports))),
                        name: 'pathway 4'
                    },
                    pathway5: {
                        width: 230,
                        height: 230,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($394e712011a00491$exports))),
                        name: 'pathway 5'
                    },
                    pathway6: {
                        width: 230,
                        height: 250,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($331d7330fc2fdcf9$exports))),
                        name: 'pathway 6'
                    },
                    pathway7: {
                        width: 100,
                        height: 250,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4da38f3d5e8b0f7d$exports))),
                        name: 'pathway 7'
                    },
                    pathway8: {
                        width: 230,
                        height: 230,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8062ae4834ffb758$exports))),
                        name: 'pathway 8'
                    },
                    pathway9: {
                        width: 230,
                        height: 250,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c0e9bc6fd96d16da$exports))),
                        name: 'pathway 9'
                    },
                    //pathway10: {width: 300, height: 300, src: pathway10, name: 'pathway 10'},
                    pathway11: {
                        width: 350,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($edd183e22a5bf29c$exports))),
                        name: 'pathway 11'
                    },
                    pathway12: {
                        width: 1500,
                        height: 300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($acd973cf0654c237$exports))),
                        name: 'pathway 12'
                    },
                    pathway13: {
                        width: 1500,
                        height: 300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0a25383b77469fe2$exports))),
                        name: 'pathway 13'
                    },
                    pathway14: {
                        width: 300,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8d6e456a85858c02$exports))),
                        name: 'pathway 14'
                    }
                },
                zIndex: 20
            },
            court: {
                displayName: 'court',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($f55ec233d6fffabc$exports)))
                    }),
                templates: {
                    court1: {
                        width: 1620,
                        height: 900,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8e87d8f39fc5fae2$exports))),
                        name: 'court 1'
                    },
                    court2: {
                        width: 1620,
                        height: 900,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3f781d429fb7ba15$exports))),
                        name: 'court 2'
                    }
                },
                zIndex: 20
            },
            patio: {
                displayName: 'patio',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($413ea6e11462d3dd$exports)))
                    }),
                templates: {
                    patio1: {
                        width: 300,
                        height: 300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f7b930da8c972832$exports))),
                        name: 'patio 1'
                    },
                    patio2: {
                        width: 300,
                        height: 300,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($904bb8703731a910$exports))),
                        name: 'patio 2'
                    }
                },
                zIndex: 40
            },
            hedge: {
                displayName: 'hedge',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($c55663dc10ec7b64$exports)))
                    }),
                templates: {
                    //hedge1: {width: 240, height: 70, src: hedge1, name: 'hedge 1'},
                    hedge2: {
                        width: 80,
                        height: 210,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6e251ce1cbcf5e6e$exports))),
                        name: 'hedge 2'
                    },
                    hedge3: {
                        width: 100,
                        height: 84,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e1b9081c356b449f$exports))),
                        name: 'hedge 3'
                    },
                    //hedge4: {width: 300, height: 50, src: hedge4, name: 'hedge 4'},
                    hedge5: {
                        width: 650,
                        height: 50,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8df66746e379117b$exports))),
                        name: 'hedge 5'
                    },
                    hedge6: {
                        width: 350,
                        height: 50,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8e1cd09b49bafe87$exports))),
                        name: 'hedge 6'
                    }
                },
                zIndex: 40
            },
            pool: {
                displayName: 'pool',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($a548ce159d25e403$exports))),
                        stroke: '#9cd3db',
                        strokeWidth: 50
                    }),
                templates: {
                    //waterpool1: {width: 366, height: 297, src: waterpool1, name: 'waterpool 1'},
                    waterpool2: {
                        width: 240,
                        height: 240,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e2512b365f9178b0$exports))),
                        name: 'waterpool 2'
                    },
                    waterpool3: {
                        width: 400,
                        height: 500,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6c794f8561a893c8$exports))),
                        name: 'waterpool 3'
                    },
                    waterpool5: {
                        width: 330,
                        height: 200,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8f7fa97306954b80$exports))),
                        name: 'waterpool 5'
                    },
                    waterpool4: {
                        width: 400,
                        height: 200,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b5473898f9fd6dce$exports))),
                        name: 'waterpool 4'
                    }
                },
                zIndex: 40
            },
            water: {
                displayName: 'water',
                availableShapeTypes: [
                    'rect',
                    'polygon',
                    'ellipse'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($a548ce159d25e403$exports))),
                        stroke: '#9cd3db',
                        strokeWidth: 50
                    }),
                templates: {
                    fountain1: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3add8dd6b68a94ea$exports))),
                        name: 'fountain 1'
                    },
                    waterfall1: {
                        width: 200,
                        height: 200,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0fd5185be514894f$exports))),
                        name: 'waterfall 1'
                    }
                },
                zIndex: 40
            },
            furniture: {
                displayName: 'furniture',
                availableShapeTypes: [
                    'image'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($7a2332ced9e1552f$exports)))
                    }),
                templates: {
                    sofa1: {
                        width: 200,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1dfb7ae8bc5582d9$exports))),
                        name: 'sofa'
                    },
                    table1: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2ee3bc73130ef65c$exports))),
                        name: 'table'
                    },
                    chair1: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($12cc42d630d760c7$exports))),
                        name: 'chair'
                    }
                },
                zIndex: 40
            },
            lighting: {
                displayName: 'lighting',
                availableShapeTypes: [
                    'image'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($7a2332ced9e1552f$exports)))
                    }),
                templates: {
                    lampball: {
                        width: 50,
                        height: 50,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d01c492a9793051f$exports))),
                        name: 'lamp ball'
                    },
                    lamp: {
                        width: 50,
                        height: 50,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8d76da60421dfa4c$exports))),
                        name: 'lamp'
                    },
                    spotlight: {
                        width: 40,
                        height: 40,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2ae39bb9c5412900$exports))),
                        name: 'spotlight'
                    }
                },
                zIndex: 40
            },
            other: {
                displayName: 'other',
                availableShapeTypes: [
                    'image'
                ],
                getShapeFromDisplayProps: (displayProps)=>({
                        fill: '',
                        fillPatternImage: (0, (/*@__PURE__*/$parcel$interopDefault($7a2332ced9e1552f$exports)))
                    }),
                templates: {
                    stone1: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7a2332ced9e1552f$exports))),
                        name: 'stone 1'
                    },
                    stone2: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5ebac71384212a6b$exports))),
                        name: 'stone 2'
                    },
                    stone3: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($77e7da783629304e$exports))),
                        name: 'stone 3'
                    },
                    stone4: {
                        width: 100,
                        height: 100,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($aca60e4025bb0e54$exports))),
                        name: 'stone 4'
                    },
                    flowerpot1: {
                        width: 40,
                        height: 30,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($89dc3ce82fe961fa$exports))),
                        name: 'flower pot'
                    },
                    turtle: {
                        width: 50,
                        height: 50,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9c2a3223ffc91293$exports))),
                        name: 'turtle'
                    },
                    car1: {
                        width: 320,
                        height: 170,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2b045a9a01ecffa0$exports))),
                        name: 'car'
                    }
                },
                zIndex: 40
            }
        };
    }
}
const $670e204136b37e30$export$9544d5bb712b01ea = new $670e204136b37e30$export$8f0f48ce3775b160();


function $0019b24ff2e88e39$export$79e859bd6760835(props) {
    const shapeRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef();
    const transformerRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(()=>{
        if (props.isSelected) {
            // we need to attach transformer manually
            transformerRef.current?.nodes([
                shapeRef.current
            ]);
            transformerRef.current?.getLayer().batchDraw();
            transformerRef.current?.zIndex?.(1000);
        }
    }, [
        props.isSelected
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(()=>{
        const handler = ()=>props.onTwiceClick();
        shapeRef.current?.on('dblclick dbltap', handler);
        return ()=>{
            if (shapeRef.current) shapeRef.current.off('dblclick dbltap', handler);
        };
    }, [
        props.onTwiceClick
    ]);
    const elementInfo = (0, $670e204136b37e30$export$9544d5bb712b01ea).getElementType(props.element.type);
    const templateInfo = elementInfo.templates?.[props.element.template];
    const displayProps = templateInfo ? {
        //image: templateInfo.src,
        // fill: '',
        fillPatternImage: templateInfo.src
    } : elementInfo?.getShapeFromDisplayProps(props.element.props);
    let [fillPatternImage] = (0, (/*@__PURE__*/$parcel$interopDefault($cf106a27c1284942$exports)))(displayProps?.fillPatternImage);
    let [templateImage] = (0, (/*@__PURE__*/$parcel$interopDefault($cf106a27c1284942$exports)))(displayProps?.image);
    if (templateInfo && fillPatternImage) displayProps.fillPatternScale = {
        x: props.element.props.width / fillPatternImage.width,
        y: props.element.props.height / fillPatternImage.height
    };
    if (!props.element.shapeType) return null;
    let canvasShapeType = (0, $3b2a1dec172ced19$export$bbdb2c97169ec0d5)[props.element.shapeType]?.canvasShapeType;
    if (!canvasShapeType) return null;
    if (!elementInfo) return null;
    let fill = displayProps.fill;
    if (props.isTwiceSelected) fill = 'blue';
    const shapeProps = {
        ...props.element.props,
        draggable: props.isEditable && props.isSelected,
        ...displayProps,
        fill: fill,
        fillPatternImage: fillPatternImage,
        image: templateImage,
        onClick: props.isEditable || props.isSelectable ? ()=>{
            props.onSelect();
            props.setCursor('move');
        } : undefined,
        onDoubleClick: props.isEditable ? props.onTwiceClick : undefined,
        ref: shapeRef,
        onMouseEnter: props.isEditable || props.isSelectable ? ()=>{
            if (props.isSelected) props.setCursor('move');
            else props.setCursor('pointer');
        } : undefined,
        // zIndex: elementInfo.zIndex || 10,
        onMouseLeave: props.resetCursor
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(canvasShapeType, shapeProps),
            props.isSelected && props.isEditable && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $efc2278554982d41$export$11d74a66c53c9999), {
                element: props.element,
                mode: "edit",
                transformerRef: transformerRef,
                shapeRef: shapeRef,
                onChange: props.onChange,
                transformerLayerProps: props.transformerLayerProps
            }),
            props.isSelected && !props.isEditable && props.isSelectable && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $efc2278554982d41$export$11d74a66c53c9999), {
                element: props.element,
                mode: "selection",
                transformerRef: transformerRef,
                shapeRef: shapeRef,
                onChange: props.onChange,
                transformerLayerProps: props.transformerLayerProps
            })
        ]
    });
}





var $ltGt3 = parcelRequire("ltGt3");


var $55d49ed7f7b6dd4e$var$MinusOutlined = function MinusOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $d9bcc856a934f3b6$export$2e2bcd8739ae039)
    }));
};
/**![minus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3MiA0NzRIMTUyYy00LjQgMC04IDMuNi04IDh2NjBjMCA0LjQgMy42IDggOCA4aDcyMGM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ var $55d49ed7f7b6dd4e$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($55d49ed7f7b6dd4e$var$MinusOutlined);
var $55d49ed7f7b6dd4e$export$2e2bcd8739ae039 = $55d49ed7f7b6dd4e$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");






var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");

function $a2ca40df0f5f705c$export$622cea445a1c5b7d(value, min, max) {
    return (value - min) / (max - min);
}
function $a2ca40df0f5f705c$export$a41628415415e6e(direction, value, min, max) {
    const offset = $a2ca40df0f5f705c$export$622cea445a1c5b7d(value, min, max);
    const positionStyle = {};
    switch(direction){
        case 'rtl':
            positionStyle.right = `${offset * 100}%`;
            positionStyle.transform = 'translateX(50%)';
            break;
        case 'btt':
            positionStyle.bottom = `${offset * 100}%`;
            positionStyle.transform = 'translateY(50%)';
            break;
        case 'ttb':
            positionStyle.top = `${offset * 100}%`;
            positionStyle.transform = 'translateY(-50%)';
            break;
        default:
            positionStyle.left = `${offset * 100}%`;
            positionStyle.transform = 'translateX(-50%)';
            break;
    }
    return positionStyle;
}
function $a2ca40df0f5f705c$export$ddfa24987dade61b(value, index) {
    return Array.isArray(value) ? value[index] : value;
}





var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
const $f7c874757575f40c$var$SliderContext = /*#__PURE__*/ $ltGt3.createContext({
    min: 0,
    max: 0,
    direction: 'ltr',
    step: 1,
    includedStart: 0,
    includedEnd: 0,
    tabIndex: 0,
    keyboard: true,
    styles: {},
    classNames: {}
});
var $f7c874757575f40c$export$2e2bcd8739ae039 = $f7c874757575f40c$var$SliderContext;
const $f7c874757575f40c$export$e508d6f1a100e5dd = /*#__PURE__*/ $ltGt3.createContext({});



function $0003519d4e39b400$var$_extends() {
    $0003519d4e39b400$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0003519d4e39b400$var$_extends.apply(this, arguments);
}
const $0003519d4e39b400$var$Handle = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, value: value, valueIndex: valueIndex, onStartMove: onStartMove, onDelete: onDelete, style: style, render: render, dragging: dragging, draggingDelete: draggingDelete, onOffsetChange: onOffsetChange, onChangeComplete: onChangeComplete, onFocus: onFocus, onMouseEnter: onMouseEnter, ...restProps } = props;
    const { min: min, max: max, direction: direction, disabled: disabled, keyboard: keyboard, range: range, tabIndex: tabIndex, ariaLabelForHandle: ariaLabelForHandle, ariaLabelledByForHandle: ariaLabelledByForHandle, ariaRequired: ariaRequired, ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle, styles: styles, classNames: classNames } = $ltGt3.useContext((0, $f7c874757575f40c$export$2e2bcd8739ae039));
    const handlePrefixCls = `${prefixCls}-handle`;
    // ============================ Events ============================
    const onInternalStartMove = (e)=>{
        if (!disabled) onStartMove(e, valueIndex);
    };
    const onInternalFocus = (e)=>{
        onFocus?.(e, valueIndex);
    };
    const onInternalMouseEnter = (e)=>{
        onMouseEnter(e, valueIndex);
    };
    // =========================== Keyboard ===========================
    const onKeyDown = (e)=>{
        if (!disabled && keyboard) {
            let offset = null;
            // Change the value
            switch(e.which || e.keyCode){
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).LEFT:
                    offset = direction === 'ltr' || direction === 'btt' ? -1 : 1;
                    break;
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).RIGHT:
                    offset = direction === 'ltr' || direction === 'btt' ? 1 : -1;
                    break;
                // Up is plus
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).UP:
                    offset = direction !== 'ttb' ? 1 : -1;
                    break;
                // Down is minus
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).DOWN:
                    offset = direction !== 'ttb' ? -1 : 1;
                    break;
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).HOME:
                    offset = 'min';
                    break;
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).END:
                    offset = 'max';
                    break;
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).PAGE_UP:
                    offset = 2;
                    break;
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).PAGE_DOWN:
                    offset = -2;
                    break;
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).BACKSPACE:
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).DELETE:
                    onDelete?.(valueIndex);
                    break;
            }
            if (offset !== null) {
                e.preventDefault();
                onOffsetChange(offset, valueIndex);
            }
        }
    };
    const handleKeyUp = (e)=>{
        switch(e.which || e.keyCode){
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).LEFT:
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).RIGHT:
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).UP:
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).DOWN:
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).HOME:
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).END:
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).PAGE_UP:
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).PAGE_DOWN:
                onChangeComplete?.();
                break;
        }
    };
    // ============================ Offset ============================
    const positionStyle = (0, $a2ca40df0f5f705c$export$a41628415415e6e)(direction, value, min, max);
    // ============================ Render ============================
    let divProps = {};
    if (valueIndex !== null) divProps = {
        tabIndex: disabled ? null : (0, $a2ca40df0f5f705c$export$ddfa24987dade61b)(tabIndex, valueIndex),
        role: 'slider',
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': disabled,
        'aria-label': (0, $a2ca40df0f5f705c$export$ddfa24987dade61b)(ariaLabelForHandle, valueIndex),
        'aria-labelledby': (0, $a2ca40df0f5f705c$export$ddfa24987dade61b)(ariaLabelledByForHandle, valueIndex),
        'aria-required': (0, $a2ca40df0f5f705c$export$ddfa24987dade61b)(ariaRequired, valueIndex),
        'aria-valuetext': (0, $a2ca40df0f5f705c$export$ddfa24987dade61b)(ariaValueTextFormatterForHandle, valueIndex)?.(value),
        'aria-orientation': direction === 'ltr' || direction === 'rtl' ? 'horizontal' : 'vertical',
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove,
        onFocus: onInternalFocus,
        onMouseEnter: onInternalMouseEnter,
        onKeyDown: onKeyDown,
        onKeyUp: handleKeyUp
    };
    let handleNode = /*#__PURE__*/ $ltGt3.createElement("div", $0003519d4e39b400$var$_extends({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(handlePrefixCls, {
            [`${handlePrefixCls}-${valueIndex + 1}`]: valueIndex !== null && range,
            [`${handlePrefixCls}-dragging`]: dragging,
            [`${handlePrefixCls}-dragging-delete`]: draggingDelete
        }, classNames.handle),
        style: {
            ...positionStyle,
            ...style,
            ...styles.handle
        }
    }, divProps, restProps));
    // Customize
    if (render) handleNode = render(handleNode, {
        index: valueIndex,
        prefixCls: prefixCls,
        value: value,
        dragging: dragging,
        draggingDelete: draggingDelete
    });
    return handleNode;
});
var $0003519d4e39b400$export$2e2bcd8739ae039 = $0003519d4e39b400$var$Handle;


function $b259976025edeb33$var$_extends() {
    $b259976025edeb33$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b259976025edeb33$var$_extends.apply(this, arguments);
}
const $b259976025edeb33$var$Handles = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, style: style, onStartMove: onStartMove, onOffsetChange: onOffsetChange, values: values, handleRender: handleRender, activeHandleRender: activeHandleRender, draggingIndex: draggingIndex, draggingDelete: draggingDelete, onFocus: onFocus, ...restProps } = props;
    const handlesRef = $ltGt3.useRef({});
    // =========================== Active ===========================
    const [activeVisible, setActiveVisible] = $ltGt3.useState(false);
    const [activeIndex, setActiveIndex] = $ltGt3.useState(-1);
    const onActive = (index)=>{
        setActiveIndex(index);
        setActiveVisible(true);
    };
    const onHandleFocus = (e, index)=>{
        onActive(index);
        onFocus?.(e);
    };
    const onHandleMouseEnter = (e, index)=>{
        onActive(index);
    };
    // =========================== Render ===========================
    $ltGt3.useImperativeHandle(ref, ()=>({
            focus: (index)=>{
                handlesRef.current[index]?.focus();
            },
            hideHelp: ()=>{
                (0, $35c0fb1a856c78db$exports.flushSync)(()=>{
                    setActiveVisible(false);
                });
            }
        }));
    // =========================== Render ===========================
    // Handle Props
    const handleProps = {
        prefixCls: prefixCls,
        onStartMove: onStartMove,
        onOffsetChange: onOffsetChange,
        render: handleRender,
        onFocus: onHandleFocus,
        onMouseEnter: onHandleMouseEnter,
        ...restProps
    };
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, values.map((value, index)=>{
        const dragging = draggingIndex === index;
        return /*#__PURE__*/ $ltGt3.createElement((0, $0003519d4e39b400$export$2e2bcd8739ae039), $b259976025edeb33$var$_extends({
            ref: (node)=>{
                if (!node) delete handlesRef.current[index];
                else handlesRef.current[index] = node;
            },
            dragging: dragging,
            draggingDelete: dragging && draggingDelete,
            style: (0, $a2ca40df0f5f705c$export$ddfa24987dade61b)(style, index),
            key: index,
            value: value,
            valueIndex: index
        }, handleProps));
    }), activeHandleRender && activeVisible && /*#__PURE__*/ $ltGt3.createElement((0, $0003519d4e39b400$export$2e2bcd8739ae039), $b259976025edeb33$var$_extends({
        key: "a11y"
    }, handleProps, {
        value: values[activeIndex],
        valueIndex: null,
        dragging: draggingIndex !== -1,
        draggingDelete: draggingDelete,
        render: activeHandleRender,
        style: {
            pointerEvents: 'none'
        },
        tabIndex: null,
        "aria-hidden": true
    })));
});
var $b259976025edeb33$export$2e2bcd8739ae039 = $b259976025edeb33$var$Handles;



var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");


const $1e02e6ba9f8a0dc2$var$Mark = (props)=>{
    const { prefixCls: prefixCls, style: style, children: children, value: value, onClick: onClick } = props;
    const { min: min, max: max, direction: direction, includedStart: includedStart, includedEnd: includedEnd, included: included } = $ltGt3.useContext((0, $f7c874757575f40c$export$2e2bcd8739ae039));
    const textCls = `${prefixCls}-text`;
    // ============================ Offset ============================
    const positionStyle = (0, $a2ca40df0f5f705c$export$a41628415415e6e)(direction, value, min, max);
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(textCls, {
            [`${textCls}-active`]: included && includedStart <= value && value <= includedEnd
        }),
        style: {
            ...positionStyle,
            ...style
        },
        onMouseDown: (e)=>{
            e.stopPropagation();
        },
        onClick: ()=>{
            onClick(value);
        }
    }, children);
};
var $1e02e6ba9f8a0dc2$export$2e2bcd8739ae039 = $1e02e6ba9f8a0dc2$var$Mark;


const $15af5d085a96306f$var$Marks = (props)=>{
    const { prefixCls: prefixCls, marks: marks, onClick: onClick } = props;
    const markPrefixCls = `${prefixCls}-mark`;
    // Not render mark if empty
    if (!marks.length) return null;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: markPrefixCls
    }, marks.map(({ value: value, style: style, label: label })=>/*#__PURE__*/ $ltGt3.createElement((0, $1e02e6ba9f8a0dc2$export$2e2bcd8739ae039), {
            key: value,
            prefixCls: markPrefixCls,
            style: style,
            value: value,
            onClick: onClick
        }, label)));
};
var $15af5d085a96306f$export$2e2bcd8739ae039 = $15af5d085a96306f$var$Marks;



var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");


const $b6957ff404c8d14b$var$Dot = (props)=>{
    const { prefixCls: prefixCls, value: value, style: style, activeStyle: activeStyle } = props;
    const { min: min, max: max, direction: direction, included: included, includedStart: includedStart, includedEnd: includedEnd } = $ltGt3.useContext((0, $f7c874757575f40c$export$2e2bcd8739ae039));
    const dotClassName = `${prefixCls}-dot`;
    const active = included && includedStart <= value && value <= includedEnd;
    // ============================ Offset ============================
    let mergedStyle = {
        ...(0, $a2ca40df0f5f705c$export$a41628415415e6e)(direction, value, min, max),
        ...typeof style === 'function' ? style(value) : style
    };
    if (active) mergedStyle = {
        ...mergedStyle,
        ...typeof activeStyle === 'function' ? activeStyle(value) : activeStyle
    };
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(dotClassName, {
            [`${dotClassName}-active`]: active
        }),
        style: mergedStyle
    });
};
var $b6957ff404c8d14b$export$2e2bcd8739ae039 = $b6957ff404c8d14b$var$Dot;


const $c7219734e62a32ca$var$Steps = (props)=>{
    const { prefixCls: prefixCls, marks: marks, dots: dots, style: style, activeStyle: activeStyle } = props;
    const { min: min, max: max, step: step } = $ltGt3.useContext((0, $f7c874757575f40c$export$2e2bcd8739ae039));
    const stepDots = $ltGt3.useMemo(()=>{
        const dotSet = new Set();
        // Add marks
        marks.forEach((mark)=>{
            dotSet.add(mark.value);
        });
        // Fill dots
        if (dots && step !== null) {
            let current = min;
            while(current <= max){
                dotSet.add(current);
                current += step;
            }
        }
        return Array.from(dotSet);
    }, [
        min,
        max,
        step,
        dots,
        marks
    ]);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-step`
    }, stepDots.map((dotValue)=>/*#__PURE__*/ $ltGt3.createElement((0, $b6957ff404c8d14b$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: dotValue,
            value: dotValue,
            style: style,
            activeStyle: activeStyle
        })));
};
var $c7219734e62a32ca$export$2e2bcd8739ae039 = $c7219734e62a32ca$var$Steps;




var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");


const $689ba38fd8862d52$var$Track = (props)=>{
    const { prefixCls: prefixCls, style: style, start: start, end: end, index: index, onStartMove: onStartMove, replaceCls: replaceCls } = props;
    const { direction: direction, min: min, max: max, disabled: disabled, range: range, classNames: classNames } = $ltGt3.useContext((0, $f7c874757575f40c$export$2e2bcd8739ae039));
    const trackPrefixCls = `${prefixCls}-track`;
    const offsetStart = (0, $a2ca40df0f5f705c$export$622cea445a1c5b7d)(start, min, max);
    const offsetEnd = (0, $a2ca40df0f5f705c$export$622cea445a1c5b7d)(end, min, max);
    // ============================ Events ============================
    const onInternalStartMove = (e)=>{
        if (!disabled && onStartMove) onStartMove(e, -1);
    };
    // ============================ Render ============================
    const positionStyle = {};
    switch(direction){
        case 'rtl':
            positionStyle.right = `${offsetStart * 100}%`;
            positionStyle.width = `${offsetEnd * 100 - offsetStart * 100}%`;
            break;
        case 'btt':
            positionStyle.bottom = `${offsetStart * 100}%`;
            positionStyle.height = `${offsetEnd * 100 - offsetStart * 100}%`;
            break;
        case 'ttb':
            positionStyle.top = `${offsetStart * 100}%`;
            positionStyle.height = `${offsetEnd * 100 - offsetStart * 100}%`;
            break;
        default:
            positionStyle.left = `${offsetStart * 100}%`;
            positionStyle.width = `${offsetEnd * 100 - offsetStart * 100}%`;
    }
    const className = replaceCls || (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(trackPrefixCls, {
        [`${trackPrefixCls}-${index + 1}`]: index !== null && range,
        [`${prefixCls}-track-draggable`]: onStartMove
    }, classNames.track);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: className,
        style: {
            ...positionStyle,
            ...style
        },
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove
    });
};
var $689ba38fd8862d52$export$2e2bcd8739ae039 = $689ba38fd8862d52$var$Track;


const $6eb5ad5afabbcfd5$var$Tracks = (props)=>{
    const { prefixCls: prefixCls, style: style, values: values, startPoint: startPoint, onStartMove: onStartMove } = props;
    const { included: included, range: range, min: min, styles: styles, classNames: classNames } = $ltGt3.useContext((0, $f7c874757575f40c$export$2e2bcd8739ae039));
    // =========================== List ===========================
    const trackList = $ltGt3.useMemo(()=>{
        if (!range) {
            // null value do not have track
            if (values.length === 0) return [];
            const startValue = startPoint ?? min;
            const endValue = values[0];
            return [
                {
                    start: Math.min(startValue, endValue),
                    end: Math.max(startValue, endValue)
                }
            ];
        }
        // Multiple
        const list = [];
        for(let i = 0; i < values.length - 1; i += 1)list.push({
            start: values[i],
            end: values[i + 1]
        });
        return list;
    }, [
        values,
        range,
        startPoint,
        min
    ]);
    if (!included) return null;
    // ========================== Render ==========================
    const tracksNode = trackList?.length && (classNames.tracks || styles.tracks) ? /*#__PURE__*/ $ltGt3.createElement((0, $689ba38fd8862d52$export$2e2bcd8739ae039), {
        index: null,
        prefixCls: prefixCls,
        start: trackList[0].start,
        end: trackList[trackList.length - 1].end,
        replaceCls: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(classNames.tracks, `${prefixCls}-tracks`),
        style: styles.tracks
    }) : null;
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, tracksNode, trackList.map(({ start: start, end: end }, index)=>/*#__PURE__*/ $ltGt3.createElement((0, $689ba38fd8862d52$export$2e2bcd8739ae039), {
            index: index,
            prefixCls: prefixCls,
            style: {
                ...(0, $a2ca40df0f5f705c$export$ddfa24987dade61b)(style, index),
                ...styles.track
            },
            start: start,
            end: end,
            key: index,
            onStartMove: onStartMove
        })));
};
var $6eb5ad5afabbcfd5$export$2e2bcd8739ae039 = $6eb5ad5afabbcfd5$var$Tracks;




var $ltGt3 = parcelRequire("ltGt3");



/** Drag to delete offset. It's a user experience number for dragging out */ const $33a843f5c7e85e09$var$REMOVE_DIST = 130;
function $33a843f5c7e85e09$var$getPosition(e) {
    const obj = 'targetTouches' in e ? e.targetTouches[0] : e;
    return {
        pageX: obj.pageX,
        pageY: obj.pageY
    };
}
function $33a843f5c7e85e09$var$useDrag(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues, editable, minCount) {
    const [draggingValue, setDraggingValue] = $ltGt3.useState(null);
    const [draggingIndex, setDraggingIndex] = $ltGt3.useState(-1);
    const [draggingDelete, setDraggingDelete] = $ltGt3.useState(false);
    const [cacheValues, setCacheValues] = $ltGt3.useState(rawValues);
    const [originValues, setOriginValues] = $ltGt3.useState(rawValues);
    const mouseMoveEventRef = $ltGt3.useRef(null);
    const mouseUpEventRef = $ltGt3.useRef(null);
    const touchEventTargetRef = $ltGt3.useRef(null);
    const { onDragStart: onDragStart, onDragChange: onDragChange } = $ltGt3.useContext((0, $f7c874757575f40c$export$e508d6f1a100e5dd));
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (draggingIndex === -1) setCacheValues(rawValues);
    }, [
        rawValues,
        draggingIndex
    ]);
    // Clean up event
    $ltGt3.useEffect(()=>()=>{
            document.removeEventListener('mousemove', mouseMoveEventRef.current);
            document.removeEventListener('mouseup', mouseUpEventRef.current);
            if (touchEventTargetRef.current) {
                touchEventTargetRef.current.removeEventListener('touchmove', mouseMoveEventRef.current);
                touchEventTargetRef.current.removeEventListener('touchend', mouseUpEventRef.current);
            }
        }, []);
    const flushValues = (nextValues, nextValue, deleteMark)=>{
        // Perf: Only update state when value changed
        if (nextValue !== undefined) setDraggingValue(nextValue);
        setCacheValues(nextValues);
        let changeValues = nextValues;
        if (deleteMark) changeValues = nextValues.filter((_, i)=>i !== draggingIndex);
        triggerChange(changeValues);
        if (onDragChange) onDragChange({
            rawValues: nextValues,
            deleteIndex: deleteMark ? draggingIndex : -1,
            draggingIndex: draggingIndex,
            draggingValue: nextValue
        });
    };
    const updateCacheValue = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((valueIndex, offsetPercent, deleteMark)=>{
        if (valueIndex === -1) {
            // >>>> Dragging on the track
            const startValue = originValues[0];
            const endValue = originValues[originValues.length - 1];
            const maxStartOffset = min - startValue;
            const maxEndOffset = max - endValue;
            // Get valid offset
            let offset = offsetPercent * (max - min);
            offset = Math.max(offset, maxStartOffset);
            offset = Math.min(offset, maxEndOffset);
            // Use first value to revert back of valid offset (like steps marks)
            const formatStartValue = formatValue(startValue + offset);
            offset = formatStartValue - startValue;
            const cloneCacheValues = originValues.map((val)=>val + offset);
            flushValues(cloneCacheValues);
        } else {
            // >>>> Dragging on the handle
            const offsetDist = (max - min) * offsetPercent;
            // Always start with the valueIndex origin value
            const cloneValues = [
                ...cacheValues
            ];
            cloneValues[valueIndex] = originValues[valueIndex];
            const next = offsetValues(cloneValues, offsetDist, valueIndex, 'dist');
            flushValues(next.values, next.value, deleteMark);
        }
    });
    const onStartMove = (e, valueIndex, startValues)=>{
        e.stopPropagation();
        // 如果是点击 track 触发的，需要传入变化后的初始值，而不能直接用 rawValues
        const initialValues = startValues || rawValues;
        const originValue = initialValues[valueIndex];
        setDraggingIndex(valueIndex);
        setDraggingValue(originValue);
        setOriginValues(initialValues);
        setCacheValues(initialValues);
        setDraggingDelete(false);
        const { pageX: startX, pageY: startY } = $33a843f5c7e85e09$var$getPosition(e);
        // We declare it here since closure can't get outer latest value
        let deleteMark = false;
        // Internal trigger event
        if (onDragStart) onDragStart({
            rawValues: initialValues,
            draggingIndex: valueIndex,
            draggingValue: originValue
        });
        // Moving
        const onMouseMove = (event)=>{
            event.preventDefault();
            const { pageX: moveX, pageY: moveY } = $33a843f5c7e85e09$var$getPosition(event);
            const offsetX = moveX - startX;
            const offsetY = moveY - startY;
            const { width: width, height: height } = containerRef.current.getBoundingClientRect();
            let offSetPercent;
            let removeDist;
            switch(direction){
                case 'btt':
                    offSetPercent = -offsetY / height;
                    removeDist = offsetX;
                    break;
                case 'ttb':
                    offSetPercent = offsetY / height;
                    removeDist = offsetX;
                    break;
                case 'rtl':
                    offSetPercent = -offsetX / width;
                    removeDist = offsetY;
                    break;
                default:
                    offSetPercent = offsetX / width;
                    removeDist = offsetY;
            }
            // Check if need mark remove
            deleteMark = editable ? Math.abs(removeDist) > $33a843f5c7e85e09$var$REMOVE_DIST && minCount < cacheValues.length : false;
            setDraggingDelete(deleteMark);
            updateCacheValue(valueIndex, offSetPercent, deleteMark);
        };
        // End
        const onMouseUp = (event)=>{
            event.preventDefault();
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('mousemove', onMouseMove);
            if (touchEventTargetRef.current) {
                touchEventTargetRef.current.removeEventListener('touchmove', mouseMoveEventRef.current);
                touchEventTargetRef.current.removeEventListener('touchend', mouseUpEventRef.current);
            }
            mouseMoveEventRef.current = null;
            mouseUpEventRef.current = null;
            touchEventTargetRef.current = null;
            finishChange(deleteMark);
            setDraggingIndex(-1);
            setDraggingDelete(false);
        };
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('mousemove', onMouseMove);
        e.currentTarget.addEventListener('touchend', onMouseUp);
        e.currentTarget.addEventListener('touchmove', onMouseMove);
        mouseMoveEventRef.current = onMouseMove;
        mouseUpEventRef.current = onMouseUp;
        touchEventTargetRef.current = e.currentTarget;
    };
    // Only return cache value when it mapping with rawValues
    const returnValues = $ltGt3.useMemo(()=>{
        const sourceValues = [
            ...rawValues
        ].sort((a, b)=>a - b);
        const targetValues = [
            ...cacheValues
        ].sort((a, b)=>a - b);
        const counts = {};
        targetValues.forEach((val)=>{
            counts[val] = (counts[val] || 0) + 1;
        });
        sourceValues.forEach((val)=>{
            counts[val] = (counts[val] || 0) - 1;
        });
        const maxDiffCount = editable ? 1 : 0;
        const diffCount = Object.values(counts).reduce((prev, next)=>prev + Math.abs(next), 0);
        return diffCount <= maxDiffCount ? cacheValues : rawValues;
    }, [
        rawValues,
        cacheValues,
        editable
    ]);
    return [
        draggingIndex,
        draggingValue,
        draggingDelete,
        returnValues,
        onStartMove
    ];
}
var $33a843f5c7e85e09$export$2e2bcd8739ae039 = $33a843f5c7e85e09$var$useDrag;



var $ltGt3 = parcelRequire("ltGt3");
function $8a124f63f69f0242$export$2e2bcd8739ae039(min, max, step, markList, allowCross, pushable) {
    const formatRangeValue = $ltGt3.useCallback((val)=>Math.max(min, Math.min(max, val)), [
        min,
        max
    ]);
    const formatStepValue = $ltGt3.useCallback((val)=>{
        if (step !== null) {
            const stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step;
            // Cut number in case to be like 0.30000000000000004
            const getDecimal = (num)=>(String(num).split('.')[1] || '').length;
            const maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
            const fixedValue = Number(stepValue.toFixed(maxDecimal));
            return min <= fixedValue && fixedValue <= max ? fixedValue : null;
        }
        return null;
    }, [
        step,
        min,
        max,
        formatRangeValue
    ]);
    const formatValue = $ltGt3.useCallback((val)=>{
        const formatNextValue = formatRangeValue(val);
        // List align values
        const alignValues = markList.map((mark)=>mark.value);
        if (step !== null) alignValues.push(formatStepValue(val));
        // min & max
        alignValues.push(min, max);
        // Align with marks
        let closeValue = alignValues[0];
        let closeDist = max - min;
        alignValues.forEach((alignValue)=>{
            const dist = Math.abs(formatNextValue - alignValue);
            if (dist <= closeDist) {
                closeValue = alignValue;
                closeDist = dist;
            }
        });
        return closeValue;
    }, [
        min,
        max,
        markList,
        step,
        formatRangeValue,
        formatStepValue
    ]);
    // ========================== Offset ==========================
    // Single Value
    const offsetValue = (values, offset, valueIndex, mode = 'unit')=>{
        if (typeof offset === 'number') {
            let nextValue;
            const originValue = values[valueIndex];
            // Only used for `dist` mode
            const targetDistValue = originValue + offset;
            // Compare next step value & mark value which is best match
            let potentialValues = [];
            markList.forEach((mark)=>{
                potentialValues.push(mark.value);
            });
            // Min & Max
            potentialValues.push(min, max);
            // In case origin value is align with mark but not with step
            potentialValues.push(formatStepValue(originValue));
            // Put offset step value also
            const sign = offset > 0 ? 1 : -1;
            if (mode === 'unit') potentialValues.push(formatStepValue(originValue + sign * step));
            else potentialValues.push(formatStepValue(targetDistValue));
            // Find close one
            potentialValues = potentialValues.filter((val)=>val !== null)// Remove reverse value
            .filter((val)=>offset < 0 ? val <= originValue : val >= originValue);
            if (mode === 'unit') // `unit` mode can not contain itself
            potentialValues = potentialValues.filter((val)=>val !== originValue);
            const compareValue = mode === 'unit' ? originValue : targetDistValue;
            nextValue = potentialValues[0];
            let valueDist = Math.abs(nextValue - compareValue);
            potentialValues.forEach((potentialValue)=>{
                const dist = Math.abs(potentialValue - compareValue);
                if (dist < valueDist) {
                    nextValue = potentialValue;
                    valueDist = dist;
                }
            });
            // Out of range will back to range
            if (nextValue === undefined) return offset < 0 ? min : max;
            // `dist` mode
            if (mode === 'dist') return nextValue;
            // `unit` mode may need another round
            if (Math.abs(offset) > 1) {
                const cloneValues = [
                    ...values
                ];
                cloneValues[valueIndex] = nextValue;
                return offsetValue(cloneValues, offset - sign, valueIndex, mode);
            }
            return nextValue;
        } else if (offset === 'min') return min;
        else if (offset === 'max') return max;
    };
    /** Same as `offsetValue` but return `changed` mark to tell value changed */ const offsetChangedValue = (values, offset, valueIndex, mode = 'unit')=>{
        const originValue = values[valueIndex];
        const nextValue = offsetValue(values, offset, valueIndex, mode);
        return {
            value: nextValue,
            changed: nextValue !== originValue
        };
    };
    const needPush = (dist)=>{
        return pushable === null && dist === 0 || typeof pushable === 'number' && dist < pushable;
    };
    // Values
    const offsetValues = (values, offset, valueIndex, mode = 'unit')=>{
        const nextValues = values.map(formatValue);
        const originValue = nextValues[valueIndex];
        const nextValue = offsetValue(nextValues, offset, valueIndex, mode);
        nextValues[valueIndex] = nextValue;
        if (allowCross === false) {
            // >>>>> Allow Cross
            const pushNum = pushable || 0;
            // ============ AllowCross ===============
            if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
            if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
        } else if (typeof pushable === 'number' || pushable === null) {
            // >>>>> Pushable
            // =============== Push ==================
            // >>>>>> Basic push
            // End values
            for(let i = valueIndex + 1; i < nextValues.length; i += 1){
                let changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed)({ value: nextValues[i], changed: changed } = offsetChangedValue(nextValues, 1, i));
            }
            // Start values
            for(let i = valueIndex; i > 0; i -= 1){
                let changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed)({ value: nextValues[i - 1], changed: changed } = offsetChangedValue(nextValues, -1, i - 1));
            }
            // >>>>> Revert back to safe push range
            // End to Start
            for(let i = nextValues.length - 1; i > 0; i -= 1){
                let changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed)({ value: nextValues[i - 1], changed: changed } = offsetChangedValue(nextValues, -1, i - 1));
            }
            // Start to End
            for(let i = 0; i < nextValues.length - 1; i += 1){
                let changed = true;
                while(needPush(nextValues[i + 1] - nextValues[i]) && changed)({ value: nextValues[i + 1], changed: changed } = offsetChangedValue(nextValues, 1, i + 1));
            }
        }
        return {
            value: nextValues[valueIndex],
            values: nextValues
        };
    };
    return [
        formatValue,
        offsetValues
    ];
}




var $ltGt3 = parcelRequire("ltGt3");
function $25fda669c697811c$export$2e2bcd8739ae039(range) {
    return (0, $ltGt3.useMemo)(()=>{
        if (range === true || !range) return [
            !!range,
            false,
            false,
            0
        ];
        const { editable: editable, draggableTrack: draggableTrack, minCount: minCount, maxCount: maxCount } = range;
        return [
            true,
            editable,
            !editable && draggableTrack,
            minCount || 0,
            maxCount
        ];
    }, [
        range
    ]);
}


/**
 * New:
 * - click mark to update range value
 * - handleRender
 * - Fix handle with count not correct
 * - Fix pushable not work in some case
 * - No more FindDOMNode
 * - Move all position related style into inline style
 * - Key: up is plus, down is minus
 * - fix Key with step = null not align with marks
 * - Change range should not trigger onChange
 * - keyboard support pushable
 */ const $cb17957202625e17$var$Slider = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = 'rc-slider', className: className, style: style, classNames: classNames, styles: styles, id: id, disabled: // Status
    disabled = false, keyboard: keyboard = true, autoFocus: autoFocus, onFocus: onFocus, onBlur: onBlur, min: // Value
    min = 0, max: max = 100, step: step = 1, value: value, defaultValue: defaultValue, range: range, count: count, onChange: onChange, onBeforeChange: onBeforeChange, onAfterChange: onAfterChange, onChangeComplete: onChangeComplete, allowCross: // Cross
    allowCross = true, pushable: pushable = false, reverse: // Direction
    reverse, vertical: vertical, included: // Style
    included = true, startPoint: startPoint, trackStyle: trackStyle, handleStyle: handleStyle, railStyle: railStyle, dotStyle: dotStyle, activeDotStyle: activeDotStyle, marks: // Decorations
    marks, dots: dots, handleRender: // Components
    handleRender, activeHandleRender: activeHandleRender, track: track, tabIndex: // Accessibility
    tabIndex = 0, ariaLabelForHandle: ariaLabelForHandle, ariaLabelledByForHandle: ariaLabelledByForHandle, ariaRequired: ariaRequired, ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle } = props;
    const handlesRef = $ltGt3.useRef(null);
    const containerRef = $ltGt3.useRef(null);
    const direction = $ltGt3.useMemo(()=>{
        if (vertical) return reverse ? 'ttb' : 'btt';
        return reverse ? 'rtl' : 'ltr';
    }, [
        reverse,
        vertical
    ]);
    // ============================ Range =============================
    const [rangeEnabled, rangeEditable, rangeDraggableTrack, minCount, maxCount] = (0, $25fda669c697811c$export$2e2bcd8739ae039)(range);
    const mergedMin = $ltGt3.useMemo(()=>isFinite(min) ? min : 0, [
        min
    ]);
    const mergedMax = $ltGt3.useMemo(()=>isFinite(max) ? max : 100, [
        max
    ]);
    // ============================= Step =============================
    const mergedStep = $ltGt3.useMemo(()=>step !== null && step <= 0 ? 1 : step, [
        step
    ]);
    // ============================= Push =============================
    const mergedPush = $ltGt3.useMemo(()=>{
        if (typeof pushable === 'boolean') return pushable ? mergedStep : false;
        return pushable >= 0 ? pushable : false;
    }, [
        pushable,
        mergedStep
    ]);
    // ============================ Marks =============================
    const markList = $ltGt3.useMemo(()=>{
        return Object.keys(marks || {}).map((key)=>{
            const mark = marks[key];
            const markObj = {
                value: Number(key)
            };
            if (mark && typeof mark === 'object' && !/*#__PURE__*/ $ltGt3.isValidElement(mark) && ('label' in mark || 'style' in mark)) {
                markObj.style = mark.style;
                markObj.label = mark.label;
            } else markObj.label = mark;
            return markObj;
        }).filter(({ label: label })=>label || typeof label === 'number').sort((a, b)=>a.value - b.value);
    }, [
        marks
    ]);
    // ============================ Format ============================
    const [formatValue, offsetValues] = (0, $8a124f63f69f0242$export$2e2bcd8739ae039)(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush);
    // ============================ Values ============================
    const [mergedValue, setValue] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultValue, value);
    const rawValues = $ltGt3.useMemo(()=>{
        const valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [
            mergedValue
        ];
        const [val0 = mergedMin] = valueList;
        let returnValues = mergedValue === null ? [] : [
            val0
        ];
        // Format as range
        if (rangeEnabled) {
            returnValues = [
                ...valueList
            ];
            // When count provided or value is `undefined`, we fill values
            if (count || mergedValue === undefined) {
                const pointCount = count >= 0 ? count + 1 : 2;
                returnValues = returnValues.slice(0, pointCount);
                // Fill with count
                while(returnValues.length < pointCount)returnValues.push(returnValues[returnValues.length - 1] ?? mergedMin);
            }
            returnValues.sort((a, b)=>a - b);
        }
        // Align in range
        returnValues.forEach((val, index)=>{
            returnValues[index] = formatValue(val);
        });
        return returnValues;
    }, [
        mergedValue,
        rangeEnabled,
        mergedMin,
        count,
        formatValue
    ]);
    // =========================== onChange ===========================
    const getTriggerValue = (triggerValues)=>rangeEnabled ? triggerValues : triggerValues[0];
    const triggerChange = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((nextValues)=>{
        // Order first
        const cloneNextValues = [
            ...nextValues
        ].sort((a, b)=>a - b);
        // Trigger event if needed
        if (onChange && !(0, $003c57daacb79f0c$export$2e2bcd8739ae039)(cloneNextValues, rawValues, true)) onChange(getTriggerValue(cloneNextValues));
        // We set this later since it will re-render component immediately
        setValue(cloneNextValues);
    });
    const finishChange = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((draggingDelete)=>{
        // Trigger from `useDrag` will tell if it's a delete action
        if (draggingDelete) handlesRef.current.hideHelp();
        const finishValue = getTriggerValue(rawValues);
        onAfterChange?.(finishValue);
        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
        onChangeComplete?.(finishValue);
    });
    const onDelete = (index)=>{
        if (disabled || !rangeEditable || rawValues.length <= minCount) return;
        const cloneNextValues = [
            ...rawValues
        ];
        cloneNextValues.splice(index, 1);
        onBeforeChange?.(getTriggerValue(cloneNextValues));
        triggerChange(cloneNextValues);
        const nextFocusIndex = Math.max(0, index - 1);
        handlesRef.current.hideHelp();
        handlesRef.current.focus(nextFocusIndex);
    };
    const [draggingIndex, draggingValue, draggingDelete, cacheValues, onStartDrag] = (0, $33a843f5c7e85e09$export$2e2bcd8739ae039)(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues, rangeEditable, minCount);
    /**
   * When `rangeEditable` will insert a new value in the values array.
   * Else it will replace the value in the values array.
   */ const changeToCloseValue = (newValue, e)=>{
        if (!disabled) {
            // Create new values
            const cloneNextValues = [
                ...rawValues
            ];
            let valueIndex = 0;
            let valueBeforeIndex = 0; // Record the index which value < newValue
            let valueDist = mergedMax - mergedMin;
            rawValues.forEach((val, index)=>{
                const dist = Math.abs(newValue - val);
                if (dist <= valueDist) {
                    valueDist = dist;
                    valueIndex = index;
                }
                if (val < newValue) valueBeforeIndex = index;
            });
            let focusIndex = valueIndex;
            if (rangeEditable && valueDist !== 0 && (!maxCount || rawValues.length < maxCount)) {
                cloneNextValues.splice(valueBeforeIndex + 1, 0, newValue);
                focusIndex = valueBeforeIndex + 1;
            } else cloneNextValues[valueIndex] = newValue;
            // Fill value to match default 2 (only when `rawValues` is empty)
            if (rangeEnabled && !rawValues.length && count === undefined) cloneNextValues.push(newValue);
            const nextValue = getTriggerValue(cloneNextValues);
            onBeforeChange?.(nextValue);
            triggerChange(cloneNextValues);
            if (e) {
                document.activeElement?.blur?.();
                handlesRef.current.focus(focusIndex);
                onStartDrag(e, focusIndex, cloneNextValues);
            } else {
                // https://github.com/ant-design/ant-design/issues/49997
                onAfterChange?.(nextValue);
                (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
                onChangeComplete?.(nextValue);
            }
        }
    };
    // ============================ Click =============================
    const onSliderMouseDown = (e)=>{
        e.preventDefault();
        const { width: width, height: height, left: left, top: top, bottom: bottom, right: right } = containerRef.current.getBoundingClientRect();
        const { clientX: clientX, clientY: clientY } = e;
        let percent;
        switch(direction){
            case 'btt':
                percent = (bottom - clientY) / height;
                break;
            case 'ttb':
                percent = (clientY - top) / height;
                break;
            case 'rtl':
                percent = (right - clientX) / width;
                break;
            default:
                percent = (clientX - left) / width;
        }
        const nextValue = mergedMin + percent * (mergedMax - mergedMin);
        changeToCloseValue(formatValue(nextValue), e);
    };
    // =========================== Keyboard ===========================
    const [keyboardValue, setKeyboardValue] = $ltGt3.useState(null);
    const onHandleOffsetChange = (offset, valueIndex)=>{
        if (!disabled) {
            const next = offsetValues(rawValues, offset, valueIndex);
            onBeforeChange?.(getTriggerValue(rawValues));
            triggerChange(next.values);
            setKeyboardValue(next.value);
        }
    };
    $ltGt3.useEffect(()=>{
        if (keyboardValue !== null) {
            const valueIndex = rawValues.indexOf(keyboardValue);
            if (valueIndex >= 0) handlesRef.current.focus(valueIndex);
        }
        setKeyboardValue(null);
    }, [
        keyboardValue
    ]);
    // ============================= Drag =============================
    const mergedDraggableTrack = $ltGt3.useMemo(()=>{
        if (rangeDraggableTrack && mergedStep === null) return false;
        return rangeDraggableTrack;
    }, [
        rangeDraggableTrack,
        mergedStep
    ]);
    const onStartMove = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((e, valueIndex)=>{
        onStartDrag(e, valueIndex);
        onBeforeChange?.(getTriggerValue(rawValues));
    });
    // Auto focus for updated handle
    const dragging = draggingIndex !== -1;
    $ltGt3.useEffect(()=>{
        if (!dragging) {
            const valueIndex = rawValues.lastIndexOf(draggingValue);
            handlesRef.current.focus(valueIndex);
        }
    }, [
        dragging
    ]);
    // =========================== Included ===========================
    const sortedCacheValues = $ltGt3.useMemo(()=>[
            ...cacheValues
        ].sort((a, b)=>a - b), [
        cacheValues
    ]);
    // Provide a range values with included [min, max]
    // Used for Track, Mark & Dot
    const [includedStart, includedEnd] = $ltGt3.useMemo(()=>{
        if (!rangeEnabled) return [
            mergedMin,
            sortedCacheValues[0]
        ];
        return [
            sortedCacheValues[0],
            sortedCacheValues[sortedCacheValues.length - 1]
        ];
    }, [
        sortedCacheValues,
        rangeEnabled,
        mergedMin
    ]);
    // ============================= Refs =============================
    $ltGt3.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                handlesRef.current.focus(0);
            },
            blur: ()=>{
                const { activeElement: activeElement } = document;
                if (containerRef.current?.contains(activeElement)) activeElement?.blur();
            }
        }));
    // ========================== Auto Focus ==========================
    $ltGt3.useEffect(()=>{
        if (autoFocus) handlesRef.current.focus(0);
    }, []);
    // =========================== Context ============================
    const context = $ltGt3.useMemo(()=>({
            min: mergedMin,
            max: mergedMax,
            direction: direction,
            disabled: disabled,
            keyboard: keyboard,
            step: mergedStep,
            included: included,
            includedStart: includedStart,
            includedEnd: includedEnd,
            range: rangeEnabled,
            tabIndex: tabIndex,
            ariaLabelForHandle: ariaLabelForHandle,
            ariaLabelledByForHandle: ariaLabelledByForHandle,
            ariaRequired: ariaRequired,
            ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle,
            styles: styles || {},
            classNames: classNames || {}
        }), [
        mergedMin,
        mergedMax,
        direction,
        disabled,
        keyboard,
        mergedStep,
        included,
        includedStart,
        includedEnd,
        rangeEnabled,
        tabIndex,
        ariaLabelForHandle,
        ariaLabelledByForHandle,
        ariaRequired,
        ariaValueTextFormatterForHandle,
        styles,
        classNames
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $ltGt3.createElement((0, $f7c874757575f40c$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prefixCls, className, {
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-vertical`]: vertical,
            [`${prefixCls}-horizontal`]: !vertical,
            [`${prefixCls}-with-marks`]: markList.length
        }),
        style: style,
        onMouseDown: onSliderMouseDown,
        id: id
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-rail`, classNames?.rail),
        style: {
            ...railStyle,
            ...styles?.rail
        }
    }), track !== false && /*#__PURE__*/ $ltGt3.createElement((0, $6eb5ad5afabbcfd5$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        style: trackStyle,
        values: rawValues,
        startPoint: startPoint,
        onStartMove: mergedDraggableTrack ? onStartMove : undefined
    }), /*#__PURE__*/ $ltGt3.createElement((0, $c7219734e62a32ca$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        dots: dots,
        style: dotStyle,
        activeStyle: activeDotStyle
    }), /*#__PURE__*/ $ltGt3.createElement((0, $b259976025edeb33$export$2e2bcd8739ae039), {
        ref: handlesRef,
        prefixCls: prefixCls,
        style: handleStyle,
        values: cacheValues,
        draggingIndex: draggingIndex,
        draggingDelete: draggingDelete,
        onStartMove: onStartMove,
        onOffsetChange: onHandleOffsetChange,
        onFocus: onFocus,
        onBlur: onBlur,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: finishChange,
        onDelete: rangeEditable ? onDelete : undefined
    }), /*#__PURE__*/ $ltGt3.createElement((0, $15af5d085a96306f$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        onClick: changeToCloseValue
    })));
});
var $cb17957202625e17$export$2e2bcd8739ae039 = $cb17957202625e17$var$Slider;



var $9e894e86bb24c6ba$export$2e2bcd8739ae039 = (0, $cb17957202625e17$export$2e2bcd8739ae039);









var $ltGt3 = parcelRequire("ltGt3");
/** @private Internal context. Do not use in your production. */ const $aa80359e7d4b0cfb$var$SliderInternalContext = /*#__PURE__*/ (0, $ltGt3.createContext)({});
var $aa80359e7d4b0cfb$export$2e2bcd8739ae039 = $aa80359e7d4b0cfb$var$SliderInternalContext;



var $ltGt3 = parcelRequire("ltGt3");



"use client";
const $db736636bfa5ad52$var$SliderTooltip = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { open: open, draggingDelete: draggingDelete, value: value } = props;
    const innerRef = (0, $ltGt3.useRef)(null);
    const mergedOpen = open && !draggingDelete;
    const rafRef = (0, $ltGt3.useRef)(null);
    function cancelKeepAlign() {
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(rafRef.current);
        rafRef.current = null;
    }
    function keepAlign() {
        rafRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
            innerRef.current?.forceAlign();
            rafRef.current = null;
        });
    }
    $ltGt3.useEffect(()=>{
        if (mergedOpen) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        mergedOpen,
        props.title,
        value
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
        ref: (0, $22ff46e28c8066e1$export$ab452c34e8e05029)(innerRef, ref),
        ...props,
        open: mergedOpen
    });
});
var $db736636bfa5ad52$export$2e2bcd8739ae039 = $db736636bfa5ad52$var$SliderTooltip;






// =============================== Base ===============================
const $bf9a6de2f8942024$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, controlSize: controlSize, dotSize: dotSize, marginFull: marginFull, marginPart: marginPart, colorFillContentHover: colorFillContentHover, handleColorDisabled: handleColorDisabled, calc: calc, handleSize: handleSize, handleSizeHover: handleSizeHover, handleActiveColor: handleActiveColor, handleActiveOutlineColor: handleActiveOutlineColor, handleLineWidth: handleLineWidth, handleLineWidthHover: handleLineWidthHover, motionDurationMid: motionDurationMid } = token;
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            position: 'relative',
            height: controlSize,
            margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(marginPart)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(marginFull)}`,
            padding: 0,
            cursor: 'pointer',
            touchAction: 'none',
            '&-vertical': {
                margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(marginFull)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(marginPart)}`
            },
            [`${componentCls}-rail`]: {
                position: 'absolute',
                backgroundColor: token.railBg,
                borderRadius: token.borderRadiusXS,
                transition: `background-color ${motionDurationMid}`
            },
            [`${componentCls}-track,${componentCls}-tracks`]: {
                position: 'absolute',
                transition: `background-color ${motionDurationMid}`
            },
            [`${componentCls}-track`]: {
                backgroundColor: token.trackBg,
                borderRadius: token.borderRadiusXS
            },
            [`${componentCls}-track-draggable`]: {
                boxSizing: 'content-box',
                backgroundClip: 'content-box',
                border: 'solid rgba(0,0,0,0)'
            },
            '&:hover': {
                [`${componentCls}-rail`]: {
                    backgroundColor: token.railHoverBg
                },
                [`${componentCls}-track`]: {
                    backgroundColor: token.trackHoverBg
                },
                [`${componentCls}-dot`]: {
                    borderColor: colorFillContentHover
                },
                [`${componentCls}-handle::after`]: {
                    boxShadow: `0 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(handleLineWidth)} ${token.colorPrimaryBorderHover}`
                },
                [`${componentCls}-dot-active`]: {
                    borderColor: token.dotActiveBorderColor
                }
            },
            [`${componentCls}-handle`]: {
                position: 'absolute',
                width: handleSize,
                height: handleSize,
                outline: 'none',
                userSelect: 'none',
                // Dragging status
                '&-dragging-delete': {
                    opacity: 0
                },
                // 扩大选区
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    insetInlineStart: calc(handleLineWidth).mul(-1).equal(),
                    insetBlockStart: calc(handleLineWidth).mul(-1).equal(),
                    width: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
                    height: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
                    backgroundColor: 'transparent'
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    insetBlockStart: 0,
                    insetInlineStart: 0,
                    width: handleSize,
                    height: handleSize,
                    backgroundColor: token.colorBgElevated,
                    boxShadow: `0 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(handleLineWidth)} ${token.handleColor}`,
                    outline: `0px solid transparent`,
                    borderRadius: '50%',
                    cursor: 'pointer',
                    transition: `
            inset-inline-start ${motionDurationMid},
            inset-block-start ${motionDurationMid},
            width ${motionDurationMid},
            height ${motionDurationMid},
            box-shadow ${motionDurationMid},
            outline ${motionDurationMid}
          `
                },
                '&:hover, &:active, &:focus': {
                    '&::before': {
                        insetInlineStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
                        insetBlockStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
                        width: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal(),
                        height: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal()
                    },
                    '&::after': {
                        boxShadow: `0 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(handleLineWidthHover)} ${handleActiveColor}`,
                        outline: `6px solid ${handleActiveOutlineColor}`,
                        width: handleSizeHover,
                        height: handleSizeHover,
                        insetInlineStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal(),
                        insetBlockStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal()
                    }
                }
            },
            [`&-lock ${componentCls}-handle`]: {
                '&::before, &::after': {
                    transition: 'none'
                }
            },
            [`${componentCls}-mark`]: {
                position: 'absolute',
                fontSize: token.fontSize
            },
            [`${componentCls}-mark-text`]: {
                position: 'absolute',
                display: 'inline-block',
                color: token.colorTextDescription,
                textAlign: 'center',
                wordBreak: 'keep-all',
                cursor: 'pointer',
                userSelect: 'none',
                '&-active': {
                    color: token.colorText
                }
            },
            [`${componentCls}-step`]: {
                position: 'absolute',
                background: 'transparent',
                pointerEvents: 'none'
            },
            [`${componentCls}-dot`]: {
                position: 'absolute',
                width: dotSize,
                height: dotSize,
                backgroundColor: token.colorBgElevated,
                border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(handleLineWidth)} solid ${token.dotBorderColor}`,
                borderRadius: '50%',
                cursor: 'pointer',
                transition: `border-color ${token.motionDurationSlow}`,
                pointerEvents: 'auto',
                '&-active': {
                    borderColor: token.dotActiveBorderColor
                }
            },
            [`&${componentCls}-disabled`]: {
                cursor: 'not-allowed',
                [`${componentCls}-rail`]: {
                    backgroundColor: `${token.railBg} !important`
                },
                [`${componentCls}-track`]: {
                    backgroundColor: `${token.trackBgDisabled} !important`
                },
                [`
          ${componentCls}-dot
        `]: {
                    backgroundColor: token.colorBgElevated,
                    borderColor: token.trackBgDisabled,
                    boxShadow: 'none',
                    cursor: 'not-allowed'
                },
                [`${componentCls}-handle::after`]: {
                    backgroundColor: token.colorBgElevated,
                    cursor: 'not-allowed',
                    width: handleSize,
                    height: handleSize,
                    boxShadow: `0 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(handleLineWidth)} ${handleColorDisabled}`,
                    insetInlineStart: 0,
                    insetBlockStart: 0
                },
                [`
          ${componentCls}-mark-text,
          ${componentCls}-dot
        `]: {
                    cursor: `not-allowed !important`
                }
            },
            [`&-tooltip ${antCls}-tooltip-container`]: {
                minWidth: 'unset'
            }
        }
    };
};
// ============================ Horizontal ============================
const $bf9a6de2f8942024$var$genDirectionStyle = (token, horizontal)=>{
    const { componentCls: componentCls, railSize: railSize, handleSize: handleSize, dotSize: dotSize, marginFull: marginFull, calc: calc } = token;
    const railPadding = horizontal ? 'paddingBlock' : 'paddingInline';
    const full = horizontal ? 'width' : 'height';
    const part = horizontal ? 'height' : 'width';
    const handlePos = horizontal ? 'insetBlockStart' : 'insetInlineStart';
    const markInset = horizontal ? 'top' : 'insetInlineStart';
    const handlePosSize = calc(railSize).mul(3).sub(handleSize).div(2).equal();
    const draggableBorderSize = calc(handleSize).sub(railSize).div(2).equal();
    const draggableBorder = horizontal ? {
        borderWidth: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(draggableBorderSize)} 0`,
        transform: `translateY(${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(draggableBorderSize).mul(-1).equal())})`
    } : {
        borderWidth: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(draggableBorderSize)}`,
        transform: `translateX(${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(draggableBorderSize).mul(-1).equal())})`
    };
    return {
        [railPadding]: railSize,
        [part]: calc(railSize).mul(3).equal(),
        [`${componentCls}-rail`]: {
            [full]: '100%',
            [part]: railSize
        },
        [`${componentCls}-track,${componentCls}-tracks`]: {
            [part]: railSize
        },
        [`${componentCls}-track-draggable`]: {
            ...draggableBorder
        },
        [`${componentCls}-handle`]: {
            [handlePos]: handlePosSize
        },
        [`${componentCls}-mark`]: {
            // Reset all
            insetInlineStart: 0,
            top: 0,
            // https://github.com/ant-design/ant-design/issues/43731
            [markInset]: calc(railSize).mul(3).add(horizontal ? 0 : marginFull).equal(),
            [full]: '100%'
        },
        [`${componentCls}-step`]: {
            // Reset all
            insetInlineStart: 0,
            top: 0,
            [markInset]: railSize,
            [full]: '100%',
            [part]: railSize
        },
        [`${componentCls}-dot`]: {
            position: 'absolute',
            [handlePos]: calc(railSize).sub(dotSize).div(2).equal()
        }
    };
};
// ============================ Horizontal ============================
const $bf9a6de2f8942024$var$genHorizontalStyle = (token)=>{
    const { componentCls: componentCls, marginPartWithMark: marginPartWithMark } = token;
    return {
        [`${componentCls}-horizontal`]: {
            ...$bf9a6de2f8942024$var$genDirectionStyle(token, true),
            [`&${componentCls}-with-marks`]: {
                marginBottom: marginPartWithMark
            }
        }
    };
};
// ============================= Vertical =============================
const $bf9a6de2f8942024$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-vertical`]: {
            ...$bf9a6de2f8942024$var$genDirectionStyle(token, false),
            height: '100%'
        }
    };
};
const $bf9a6de2f8942024$export$9ca1be8807fe0675 = (token)=>{
    // Handle line width is always width-er 1px
    const increaseHandleWidth = 1;
    const controlSize = token.controlHeightLG / 4;
    const controlSizeHover = token.controlHeightSM / 2;
    const handleLineWidth = token.lineWidth + increaseHandleWidth;
    const handleLineWidthHover = token.lineWidth + increaseHandleWidth * 1.5;
    const handleActiveColor = token.colorPrimary;
    const handleActiveOutlineColor = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(handleActiveColor).setA(0.2).toRgbString();
    return {
        controlSize: controlSize,
        railSize: 4,
        handleSize: controlSize,
        handleSizeHover: controlSizeHover,
        dotSize: 8,
        handleLineWidth: handleLineWidth,
        handleLineWidthHover: handleLineWidthHover,
        railBg: token.colorFillTertiary,
        railHoverBg: token.colorFillSecondary,
        trackBg: token.colorPrimaryBorder,
        trackHoverBg: token.colorPrimaryBorderHover,
        handleColor: token.colorPrimaryBorder,
        handleActiveColor: handleActiveColor,
        handleActiveOutlineColor: handleActiveOutlineColor,
        handleColorDisabled: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(token.colorTextDisabled).onBackground(token.colorBgContainer).toHexString(),
        dotBorderColor: token.colorBorderSecondary,
        dotActiveBorderColor: token.colorPrimaryBorder,
        trackBgDisabled: token.colorBgContainerDisabled
    };
};
var $bf9a6de2f8942024$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Slider', (token)=>{
    const sliderToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        marginPart: token.calc(token.controlHeight).sub(token.controlSize).div(2).equal(),
        marginFull: token.calc(token.controlSize).div(2).equal(),
        marginPartWithMark: token.calc(token.controlHeightLG).sub(token.controlSize).equal()
    });
    return [
        $bf9a6de2f8942024$var$genBaseStyle(sliderToken),
        $bf9a6de2f8942024$var$genHorizontalStyle(sliderToken),
        $bf9a6de2f8942024$var$genVerticalStyle(sliderToken)
    ];
}, $bf9a6de2f8942024$export$9ca1be8807fe0675);



var $ltGt3 = parcelRequire("ltGt3");

function $1bab87addb8aa691$export$2e2bcd8739ae039() {
    const [state, setState] = $ltGt3.useState(false);
    const rafRef = $ltGt3.useRef(null);
    const cleanup = ()=>{
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(rafRef.current);
    };
    const setDelayState = (nextState)=>{
        cleanup();
        if (nextState) setState(nextState);
        else rafRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
            setState(nextState);
        });
    };
    $ltGt3.useEffect(()=>cleanup, []);
    return [
        state,
        setDelayState
    ];
}


"use client";
function $7f8d64a48a49ed0b$var$getTipFormatter(tipFormatter) {
    if (tipFormatter || tipFormatter === null) return tipFormatter;
    return (val)=>typeof val === 'number' ? val.toString() : '';
}
const $7f8d64a48a49ed0b$var$Slider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, range: range, className: className, rootClassName: rootClassName, style: style, disabled: disabled, tooltip: // Deprecated Props
    tooltip = {}, onChangeComplete: onChangeComplete, classNames: classNames, styles: styles, vertical: vertical, orientation: orientation, ...restProps } = props;
    const [, mergedVertical] = (0, $15bdf1069fb84d0c$export$550084c67147f6c4)(orientation, vertical);
    const { getPrefixCls: getPrefixCls, direction: contextDirection, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, getPopupContainer: getPopupContainer } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('slider');
    const contextDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = disabled ?? contextDisabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        disabled: mergedDisabled,
        vertical: mergedVertical
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ============================= Context ==============================
    const { handleRender: contextHandleRender, direction: internalContextDirection } = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $aa80359e7d4b0cfb$export$2e2bcd8739ae039));
    const mergedDirection = internalContextDirection || contextDirection;
    const isRTL = mergedDirection === 'rtl';
    // =============================== Open ===============================
    const [hoverOpen, setHoverOpen] = (0, $1bab87addb8aa691$export$2e2bcd8739ae039)();
    const [focusOpen, setFocusOpen] = (0, $1bab87addb8aa691$export$2e2bcd8739ae039)();
    const tooltipProps = {
        ...tooltip
    };
    const { open: tooltipOpen, placement: tooltipPlacement, getPopupContainer: getTooltipPopupContainer, prefixCls: customizeTooltipPrefixCls, formatter: tipFormatter } = tooltipProps;
    const lockOpen = tooltipOpen;
    const activeOpen = (hoverOpen || focusOpen) && lockOpen !== false;
    const mergedTipFormatter = $7f8d64a48a49ed0b$var$getTipFormatter(tipFormatter);
    // ============================= Change ==============================
    const [dragging, setDragging] = (0, $1bab87addb8aa691$export$2e2bcd8739ae039)();
    const onInternalChangeComplete = (nextValues)=>{
        onChangeComplete?.(nextValues);
        setDragging(false);
    };
    // ============================ Placement ============================
    const getTooltipPlacement = (placement, vert)=>{
        if (placement) return placement;
        if (!vert) return 'top';
        return isRTL ? 'left' : 'right';
    };
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('slider', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $bf9a6de2f8942024$export$2e2bcd8739ae039)(prefixCls);
    const rootClassNames = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, contextClassName, mergedClassNames.root, rootClassName, {
        [`${prefixCls}-rtl`]: isRTL,
        [`${prefixCls}-lock`]: dragging
    }, hashId, cssVarCls);
    // make reverse default on rtl direction
    if (isRTL && !mergedVertical) restProps.reverse = !restProps.reverse;
    var deprecatedName, newName;
    // ============================== Handle ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(()=>{
        const onMouseUp = ()=>{
            // Delay for 1 frame to make the click to enable hide tooltip
            // even when the handle is focused
            (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
                setFocusOpen(false);
            }, 1);
        };
        document.addEventListener('mouseup', onMouseUp);
        return ()=>{
            document.removeEventListener('mouseup', onMouseUp);
        };
    }, []);
    const useActiveTooltipHandle = range && !lockOpen;
    const handleRender = contextHandleRender || ((node, info)=>{
        const { index: index } = info;
        const nodeProps = node.props;
        function proxyEvent(eventName, event, triggerRestPropsEvent) {
            if (triggerRestPropsEvent) restProps[eventName]?.(event);
            nodeProps[eventName]?.(event);
        }
        const passedProps = {
            ...nodeProps,
            onMouseEnter: (e)=>{
                setHoverOpen(true);
                proxyEvent('onMouseEnter', e);
            },
            onMouseLeave: (e)=>{
                setHoverOpen(false);
                proxyEvent('onMouseLeave', e);
            },
            onMouseDown: (e)=>{
                setFocusOpen(true);
                setDragging(true);
                proxyEvent('onMouseDown', e);
            },
            onFocus: (e)=>{
                setFocusOpen(true);
                restProps.onFocus?.(e);
                proxyEvent('onFocus', e, true);
            },
            onBlur: (e)=>{
                setFocusOpen(false);
                restProps.onBlur?.(e);
                proxyEvent('onBlur', e, true);
            }
        };
        const cloneNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(node, passedProps);
        const open = (!!lockOpen || activeOpen) && mergedTipFormatter !== null;
        // Wrap on handle with Tooltip when is single mode or multiple with all show tooltip
        if (!useActiveTooltipHandle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $db736636bfa5ad52$export$2e2bcd8739ae039), {
            ...tooltipProps,
            prefixCls: getPrefixCls('tooltip', customizeTooltipPrefixCls),
            title: mergedTipFormatter ? mergedTipFormatter(info.value) : '',
            value: info.value,
            open: open,
            placement: getTooltipPlacement(tooltipPlacement, mergedVertical),
            key: index,
            classNames: {
                root: `${prefixCls}-tooltip`
            },
            getPopupContainer: getTooltipPopupContainer || getPopupContainer
        }, cloneNode);
        return cloneNode;
    });
    // ========================== Active Handle ===========================
    const activeHandleRender = useActiveTooltipHandle ? (handle, info)=>{
        const cloneNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(handle, {
            style: {
                ...handle.props.style,
                visibility: 'hidden'
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $db736636bfa5ad52$export$2e2bcd8739ae039), {
            ...tooltipProps,
            prefixCls: getPrefixCls('tooltip', customizeTooltipPrefixCls),
            title: mergedTipFormatter ? mergedTipFormatter(info.value) : '',
            open: mergedTipFormatter !== null && activeOpen,
            placement: getTooltipPlacement(tooltipPlacement, mergedVertical),
            key: "tooltip",
            classNames: {
                root: `${prefixCls}-tooltip`
            },
            getPopupContainer: getTooltipPopupContainer || getPopupContainer,
            draggingDelete: info.draggingDelete
        }, cloneNode);
    } : undefined;
    // ============================== Render ==============================
    const rootStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    return(/*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $9e894e86bb24c6ba$export$2e2bcd8739ae039), {
        ...restProps,
        classNames: mergedClassNames,
        styles: mergedStyles,
        step: restProps.step,
        range: range,
        className: rootClassNames,
        style: rootStyle,
        disabled: mergedDisabled,
        vertical: mergedVertical,
        ref: ref,
        prefixCls: prefixCls,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: onInternalChangeComplete
    }));
});
var $7f8d64a48a49ed0b$export$2e2bcd8739ae039 = $7f8d64a48a49ed0b$var$Slider;



var $ltGt3 = parcelRequire("ltGt3");
function $4a88ff4b49571f8f$export$92ae4c4d246b10be({ step: step, min: min, max: max, steps: steps }) {
    if (step === steps) return 1;
    if (step > steps) {
        const numberOfStepsUp = step - steps;
        const fractionOfStepsUp = numberOfStepsUp / steps;
        const space = max - 1;
        return 1 + space * fractionOfStepsUp;
    }
    if (step < steps) {
        const numberOfStepsDown = steps - step;
        const fractionOfStepsDown = numberOfStepsDown / steps;
        const space = 1 - min;
        return 1 - space * fractionOfStepsDown;
    }
}
function $4a88ff4b49571f8f$export$576428ae79ec2a5e({ min: min = 0.1, max: max = 3, steps: steps = 10 } = {}) {
    const [step, setStep] = (0, $ltGt3.useState)(steps);
    const zoomCoefficient = (0, $ltGt3.useMemo)(()=>$4a88ff4b49571f8f$export$92ae4c4d246b10be({
            step: step,
            steps: steps,
            min: min,
            max: max
        }), [
        step,
        steps,
        min,
        max
    ]);
    const setStepWithLimits = (0, $ltGt3.useCallback)((newValue)=>{
        if (newValue < 0 || newValue > steps * 2) return;
        setStep(Math.floor(newValue));
    }, [
        steps,
        setStep
    ]);
    return [
        step,
        setStepWithLimits,
        zoomCoefficient
    ];
}
function $4a88ff4b49571f8f$export$c7a86018194a5999({ step: step, setStep: setStep, steps: steps, min: min, max: max }) {
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            height: 200,
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'all'
        },
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                size: "small",
                shape: "circle",
                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $da40d833ab151490$export$2e2bcd8739ae039), {}),
                type: "link",
                onClick: ()=>setStep(step + 1)
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7f8d64a48a49ed0b$export$2e2bcd8739ae039), {
                vertical: true,
                style: {
                    flex: '1 1 auto'
                },
                value: step,
                onChange: setStep,
                max: steps * 2,
                min: 0,
                marks: {
                    [steps]: {
                        label: ' '
                    }
                },
                tooltip: {
                    formatter: (value)=>{
                        const coefficient = $4a88ff4b49571f8f$export$92ae4c4d246b10be({
                            step: value,
                            min: min,
                            max: max,
                            steps: steps
                        });
                        const rounded = Math.round(coefficient * 100) / 100;
                        return `x${rounded}`;
                    }
                }
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                size: "small",
                shape: "circle",
                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $55d49ed7f7b6dd4e$export$2e2bcd8739ae039), {}),
                type: "link",
                onClick: ()=>setStep(step - 1)
            })
        ]
    });
}
const $4a88ff4b49571f8f$export$9d9d7317c3abcbc0 = /*#__PURE__*/ (0, $ltGt3.memo)($4a88ff4b49571f8f$export$c7a86018194a5999);




parcelRequire("ltGt3");


const $67f23e2e13bc5bbc$var$zoomScaleLineReferences = [
    {}
];
function $67f23e2e13bc5bbc$var$calculateScaleReference(scaleWidth, scaleReferencesInCm, pixelsPerCm) {
    for(let index = 0; index < scaleReferencesInCm.length; ++index){
        if (scaleWidth / (scaleReferencesInCm[index] * pixelsPerCm) > 2) return {
            m: scaleReferencesInCm[index] / 100,
            pixels: scaleReferencesInCm[index] * pixelsPerCm
        };
    }
    return {
        m: '<1',
        pixels: scaleWidth
    };
}
function $67f23e2e13bc5bbc$export$b6a40bc1c4783f({ pixelsPerCm: pixelsPerCm }) {
    const scaleWidth = 250;
    const scaleWidthInCm = scaleWidth * pixelsPerCm;
    const scaleReferenceInCm = 100;
    const scaleReferencesInCm = [
        10000,
        5000,
        1000,
        500,
        400,
        300,
        200,
        100
    ];
    const scaleReferenceWidthInPixels = scaleReferenceInCm * pixelsPerCm;
    const maxScaleReferenceWidth = $67f23e2e13bc5bbc$var$calculateScaleReference(scaleWidth, scaleReferencesInCm, pixelsPerCm);
    let fullScaleReferencesThatFit = Math.ceil(scaleWidth / maxScaleReferenceWidth.pixels);
    if (fullScaleReferencesThatFit === Infinity) fullScaleReferencesThatFit = 1;
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const { token: { colorPrimary: colorPrimary, colorPrimaryBorder: colorPrimaryBorder, borderRadiusXS: borderRadiusXS } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        style: {
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    width: scaleWidth + 4,
                    height: 7,
                    border: `1px solid ${colorPrimaryBorder}`,
                    borderRadius: borderRadiusXS
                }
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    position: 'absolute',
                    left: 2,
                    top: 2,
                    height: 3,
                    right: 2,
                    display: 'flex',
                    flexDirection: 'row',
                    overflowX: 'clip'
                },
                children: Array.from({
                    length: fullScaleReferencesThatFit
                }, (_, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "zoom-scale__segment",
                        style: {
                            width: maxScaleReferenceWidth.pixels,
                            background: index % 2 === 0 ? colorPrimary : 'transparent',
                            boxSizing: 'border-box',
                            border: index % 2 !== 0 ? `1px solid ${colorPrimary}` : undefined,
                            flex: '0 0 auto'
                        },
                        children: index === 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                            className: "zoom-scale__segment__text",
                            children: [
                                maxScaleReferenceWidth.m,
                                " ",
                                intl.formatMessage({
                                    id: 'm'
                                })
                            ]
                        })
                    }, index))
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    color: colorPrimary
                }
            })
        ]
    });
}




var $ltGt3 = parcelRequire("ltGt3");




function $72ce89dd530774f3$export$eb48ad26464a3d3(props) {
    const shapeRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef();
    const transformerRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(()=>{
        if (props.isSelected) {
            // we need to attach transformer manually
            transformerRef.current?.nodes([
                shapeRef.current
            ]);
            transformerRef.current?.getLayer().batchDraw();
        }
    }, [
        props.isSelected
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(()=>{
        const handler = ()=>props.onTwiceClick();
        shapeRef.current?.on('dblclick dbltap', handler);
        return ()=>{
            if (shapeRef.current) shapeRef.current.off('dblclick dbltap', handler);
        };
    }, [
        props.onTwiceClick
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(()=>{
        console.log(`rendering coordinates for plant ${props.plant.id}: [${props.plant.coordinates.map((c)=>`(x:${c.x}, y:${c.y}, w:${c.width}, h:${c.height})`).join(' ')}]`);
    }, [
        props.plant.coordinates
    ]);
    const canvasShapeType = (0, $3b2a1dec172ced19$export$bbdb2c97169ec0d5)['plant']?.canvasShapeType;
    if (!canvasShapeType) return null;
    const elementInfo = (0, $670e204136b37e30$export$9544d5bb712b01ea).getElementType('plant');
    if (!elementInfo) return null;
    const displayProps = {
        image: elementInfo.templates[(0, $670e204136b37e30$export$9544d5bb712b01ea).chooseElementTypeTemplate('plant', props.plant.template)].src
    };
    let [templateImage] = (0, (/*@__PURE__*/$parcel$interopDefault($cf106a27c1284942$exports)))(displayProps?.image);
    const elementProps = props.plant.coordinates[props.specimenIndex || 0];
    const plantAsElement = {
        elementId: props.plant.id,
        name: props.plant.name,
        shapeType: 'plant',
        props: elementProps,
        type: 'plant'
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(canvasShapeType, {
                ...elementProps,
                draggable: props.isEditable && props.isSelected,
                ...displayProps,
                image: templateImage,
                onClick: props.isEditable || props.isSelectable ? (evt)=>{
                    props.onSelect(evt);
                    props.setCursor('move');
                } : undefined,
                onDoubleClick: props.isEditable ? props.onTwiceClick : undefined,
                ref: (element)=>{
                    if (!element) return;
                    element['_plantId'] = props.plant.id;
                    element['_specimenIndex'] = props.specimenIndex;
                    shapeRef.current = element;
                },
                // zIndex: /*props.isSelected && props.isEditable ? 100 :*/ elementInfo.zIndex,
                onMouseEnter: props.isEditable || props.isSelectable ? ()=>{
                    if (props.isSelected) props.setCursor('move');
                    else props.setCursor('pointer');
                } : undefined
            }),
            props.isSelected && props.isEditable && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $efc2278554982d41$export$11d74a66c53c9999), {
                element: plantAsElement,
                mode: "edit",
                transformerRef: transformerRef,
                shapeRef: shapeRef,
                onChange: props.onChange
            }),
            props.isSelected && !props.isEditable && props.isSelectable && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $efc2278554982d41$export$11d74a66c53c9999), {
                element: plantAsElement,
                mode: "selection",
                transformerRef: transformerRef,
                shapeRef: shapeRef,
                onChange: props.onChange
            })
        ]
    });
}




parcelRequire("ltGt3");
var $9f9adaea3938c22e$exports = {};
$9f9adaea3938c22e$exports = import.meta.resolve("eUqBs");


function $03e34e21fee84f40$export$87ae43576cc53e22({ rotationAngle: rotationAngle }) {
    const { token: { colorPrimary: colorPrimary, colorPrimaryBorder: colorPrimaryBorder, borderRadiusXS: borderRadiusXS } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        style: {
            position: 'absolute',
            top: 0,
            right: 0,
            display: 'flex'
        },
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
            style: {
                height: '35px',
                width: '35px'
            },
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9f9adaea3938c22e$exports)))
        })
    });
}





var $ltGt3 = parcelRequire("ltGt3");


function $3d687273e09d5357$var$svgToURL(s) {
    const uri = window.btoa(unescape(encodeURIComponent(s)));
    return 'data:image/svg+xml;base64,' + uri;
}
function $3d687273e09d5357$export$3b2364b911db251c(props) {
    const layerRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    const gridRectRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    const gridImageUrl = (0, $ltGt3.useMemo)(()=>{
        const x = props.gridStepInPx;
        const svg = `
      <svg width="${x}" height="${x}"  xmlns="http://www.w3.org/2000/svg">
        <line x1="0" y1="0" x2="0" y2="${x}" stroke="black" stroke-width="10"/>
        <line x1="0" y1="0" x2="${x}" y2="0" stroke="black" stroke-width="10"/>
      </svg>
    `;
        return $3d687273e09d5357$var$svgToURL(svg);
    }, [
        props.gridStepInPx
    ]);
    const [gridImage] = (0, (/*@__PURE__*/$parcel$interopDefault($cf106a27c1284942$exports)))(gridImageUrl);
    (0, $ltGt3.useEffect)(()=>{
        const stage = layerRef.current.getStage();
        const updateBackground = ()=>{
            const background = gridRectRef.current;
            const { width: width, height: height } = stage.getSize();
            background.absolutePosition({
                x: 0,
                y: 0
            });
            background.size({
                width: width / stage.scaleX(),
                height: height / stage.scaleY()
            });
            const stageOffset = {
                x: -stage.x() / stage.scaleX(),
                y: -stage.y() / stage.scaleY()
            };
            background.fillPatternOffset(stageOffset);
        };
        const stageEventHandler = (e)=>{
            if (e.currentTarget !== stage) return;
            updateBackground();
        };
        updateBackground();
        stage.on('scaleXChange', stageEventHandler);
        // theoretically scale is uniform, so if X changes, y changes as well
        // stage.on('scaleYChange', stageEventHandler)
        stage.on('dragmove', stageEventHandler);
        return ()=>{
            if (stage) {
                stage.off('scaleXChange', stageEventHandler);
                // stage.off('scaleYChange', stageEventHandler)
                stage.off('dragmove', stageEventHandler);
            }
        };
    }, [
        gridImage
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$936d0764594b6eb3), {
        ref: layerRef,
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$c79fc6492f3af13d), {
            ref: gridRectRef,
            strokeScaleEnabled: false,
            fillPatternImage: gridImage,
            listening: false
        })
    });
}




var $ltGt3 = parcelRequire("ltGt3");




function $91f5e78a9e89edee$var$svgToURL(s) {
    const uri = window.btoa(unescape(encodeURIComponent(s)));
    return 'data:image/svg+xml;base64,' + uri;
}
function $91f5e78a9e89edee$export$ac0f232dc50c5905(props) {
    const layerRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    const { value: projectMapImageUrl, isLoading: isLoading } = (0, $1e104381209dd9b4$export$78a72ddb39bdd145)(null, async ()=>{
        const projectMapUrlResponse = await (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).getProjectMapUrl(props.projectId);
        if (!projectMapUrlResponse.success) {
            props.onMapNotFound();
            return null;
        }
        return projectMapUrlResponse.url;
    }, [
        props.projectId
    ]);
    const { value: projectMapAttributes } = (0, $1e104381209dd9b4$export$78a72ddb39bdd145)(null, async ()=>{
        const projectMapAttributes = await (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).getProjectMapAttributes(props.projectId);
        return projectMapAttributes;
    }, [
        props.projectId
    ]);
    const [mapImage] = (0, (/*@__PURE__*/$parcel$interopDefault($cf106a27c1284942$exports)))(projectMapImageUrl);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$936d0764594b6eb3), {
        ref: layerRef,
        children: mapImage && projectMapAttributes && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$3e431a229df88919), {
            image: mapImage,
            width: mapImage.width * projectMapAttributes.mapMetersPerPixel * 100,
            height: mapImage.height * projectMapAttributes.mapMetersPerPixel * 100,
            x: 0,
            y: 0
        })
    });
}





var $ltGt3 = parcelRequire("ltGt3");



function $3344c409c0becd6d$export$5f6747e1eff75f1c(props) {
    const layerRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    const [startPoint, setStartPoint, startPointRef] = (0, $0b74b96b3af31f54$export$8a36538c679950a6)(null);
    const [endPoint, setEndPoint, endPointRef] = (0, $0b74b96b3af31f54$export$8a36538c679950a6)(null);
    const length = startPoint && endPoint ? Math.sqrt((startPoint.x - endPoint.x) * (startPoint.x - endPoint.x) + (startPoint.y - endPoint.y) * (startPoint.y - endPoint.y)) : null;
    (0, $ltGt3.useEffect)(()=>{
        const onMouseDown = (e)=>{
            const { x: x, y: y } = (0, $83a8040be81947e5$export$79263550b33b988b)(e.target);
            setStartPoint({
                x: x,
                y: y
            });
        };
        const onMouseMove = (e)=>{
            if (!startPointRef.current) return;
            const { x: mouseX, y: mouseY } = (0, $83a8040be81947e5$export$79263550b33b988b)(e.target);
            setEndPoint({
                x: mouseX,
                y: mouseY
            });
        };
        const onMouseUp = (e)=>{
            setStartPoint(null);
            setEndPoint(null);
        };
        const stage = layerRef.current.getStage();
        stage.on('mousedown', onMouseDown);
        stage.on('mousemove', onMouseMove);
        stage.on('mouseup', onMouseUp);
        return ()=>{
            if (stage) {
                stage.off('mousedown', onMouseDown);
                stage.off('mousemove', onMouseMove);
                stage.off('mouseup', onMouseUp);
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$936d0764594b6eb3), {
        ref: layerRef,
        opacity: 0.7,
        children: startPoint && endPoint && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$21b07c8f274aebd5), {
                    stroke: "black",
                    fill: "red",
                    stsrokeWidth: 25 / props.canvasPixelsPerM,
                    strokeScaleEnabled: false,
                    points: [
                        startPoint.x,
                        startPoint.y,
                        endPoint.x,
                        endPoint.y
                    ]
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$5f1af8db9871e1d6), {
                    x: endPoint.x,
                    y: endPoint.y,
                    text: length.toFixed(2).toString(),
                    fontSize: 25 / props.canvasPixelsPerM
                })
            ]
        })
    });
}







parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");


var $792ee1d77f42b361$var$EditOutlined = function EditOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $94cc47b542d38284$export$2e2bcd8739ae039)
    }));
};
/**![edit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1Ny43IDc1MmMyIDAgNC0uMiA2LS41TDQzMS45IDcyMmMyLS40IDMuOS0xLjMgNS4zLTIuOGw0MjMuOS00MjMuOWE5Ljk2IDkuOTYgMCAwMDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAwOS40IDI5LjhjNi42IDYuNCAxNC45IDkuOSAyMy44IDkuOXptNjcuNC0xNzQuNEw2ODcuOCAyMTVsNzMuMyA3My4zLTM2Mi43IDM2Mi42LTg4LjkgMTUuNyAxNS42LTg5ek04ODAgODM2SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MzZjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTM2YzAtMTcuNy0xNC4zLTMyLTMyLTMyeiIgLz48L3N2Zz4=) */ var $792ee1d77f42b361$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($792ee1d77f42b361$var$EditOutlined);
var $792ee1d77f42b361$export$2e2bcd8739ae039 = $792ee1d77f42b361$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $93903a16a1e0f362$var$UploadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "upload",
    "theme": "outlined"
};
var $93903a16a1e0f362$export$2e2bcd8739ae039 = $93903a16a1e0f362$var$UploadOutlined;



var $5e27bf0dcee8b62c$var$UploadOutlined = function UploadOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $93903a16a1e0f362$export$2e2bcd8739ae039)
    }));
};
/**![upload](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQwMCAzMTcuN2g3My45VjY1NmMwIDQuNCAzLjYgOCA4IDhoNjBjNC40IDAgOC0zLjYgOC04VjMxNy43SDYyNGM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1MTguMyAxNjNhOCA4IDAgMDAtMTIuNiAwbC0xMTIgMTQxLjdjLTQuMSA1LjMtLjQgMTMgNi4zIDEzek04NzggNjI2aC02MGMtNC40IDAtOCAzLjYtOCA4djE1NEgyMTRWNjM0YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYxOThjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjg0YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjYzNGMwLTQuNC0zLjYtOC04LTh6IiAvPjwvc3ZnPg==) */ var $5e27bf0dcee8b62c$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($5e27bf0dcee8b62c$var$UploadOutlined);
var $5e27bf0dcee8b62c$export$2e2bcd8739ae039 = $5e27bf0dcee8b62c$var$RefIcon;



function $23b8abc34b52def4$export$e6c38ea441bba19f(props) {
    const { token: { colorPrimary: colorPrimary, colorPrimaryBorder: colorPrimaryBorder, borderRadiusXS: borderRadiusXS } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 5,
            marginLeft: 3
        },
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                placement: "right",
                title: intl.formatMessage({
                    id: 'openPlantDescription'
                }),
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $792ee1d77f42b361$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        props.openPlantById(props.plantId);
                    }
                })
            }),
            !props.isLocked && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                        placement: "right",
                        title: intl.formatMessage({
                            id: 'digUpAllPlantSpecimens'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $5e27bf0dcee8b62c$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                props.digUpPlant(props.plantId, props.specimenNumber);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                        placement: "right",
                        title: intl.formatMessage({
                            id: 'duplicatePlant'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $da40d833ab151490$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                props.duplicatePlant(props.plantId, props.specimenNumber, 1, 'right');
                            }
                        })
                    })
                ]
            })
        ]
    });
}



var $ltGt3 = parcelRequire("ltGt3");
function $d6ffe22cb7c5e16a$export$cd008ed3c7cf65a0(stageRef, stageContainerRef) {
    const [stageSize, setStageSize] = (0, $ltGt3.useState)({
        width: 550,
        height: 400
    });
    const adjustStage = (0, $ltGt3.useCallback)(()=>{
        if (!stageRef.current || !stageContainerRef.current) return;
        setStageSize({
            width: stageContainerRef.current.clientWidth,
            height: stageContainerRef.current.clientHeight
        });
    }, [
        stageRef,
        stageContainerRef
    ]);
    (0, $ltGt3.useEffect)(()=>{
        const callback = adjustStage;
        window.addEventListener('resize', callback);
        callback();
        return ()=>window.removeEventListener('resize', callback);
    }, []);
    return stageSize;
}



var $ltGt3 = parcelRequire("ltGt3");
function $0ffc20caa9d28ab8$export$2fcaf6c4fcf334b2(factory, dependencies) {
    const [memoState, setMemoState] = (0, $ltGt3.useState)(null);
    (0, $ltGt3.useLayoutEffect)(()=>{
        setMemoState(factory());
    }, dependencies);
    return memoState;
}


const $c6ef91034d0fe7ff$export$7ed706c01c506751 = 0.2;
function $c6ef91034d0fe7ff$var$calculateCanvasCenter(elements, plotShape, canvasPixelsPerCm) {
    if (!plotShape && elements.length === 0) return [
        0,
        0
    ];
    else {
        const aabbs = elements.map((el)=>(0, $3b2a1dec172ced19$export$bbdb2c97169ec0d5)[el.shapeType].getAabb(el, canvasPixelsPerCm));
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;
        if (plotShape) {
            let plotAabb = (0, $3b2a1dec172ced19$export$bbdb2c97169ec0d5)[plotShape.shapeType].getAabb(plotShape, canvasPixelsPerCm);
            minX = plotAabb.xFrom;
            maxX = plotAabb.xTo;
            minY = plotAabb.yFrom;
            maxY = plotAabb.yTo;
        }
        for (const { xFrom: xFrom, xTo: xTo, yFrom: yFrom, yTo: yTo } of aabbs){
            if (xFrom < minX) minX = xFrom;
            if (xTo > maxX) maxX = xTo;
            if (yFrom < minY) minY = yFrom;
            if (yTo > maxY) maxY = yTo;
        }
        const centerX = minX + (maxX - minX) / 2;
        const centerY = minY + (maxY - minY) / 2;
        return [
            centerX,
            centerY
        ];
    }
}
function $c6ef91034d0fe7ff$export$e11337932570a9ce({ projectId: projectId, plotShape: plotShape, elements: elements, plants: plants, selectable: selectable = false, plotShapeEditable: plotShapeEditable, onPlotShapeChanged: onPlotShapeChanged, currentMode: currentMode = null, editableTypes: editableTypes = [], lockedPlantIds: lockedPlantIds = [], toolLayer: toolLayer = null, toolCursor: toolCursor = null, selectedPlant: selectedPlant = null, setSelectedPlant: setSelectedPlant = ()=>{}, selectedElementId: selectedElementId = null, setSelectedElementId: setSelectedElementId = ()=>{}, onElementChanged: onElementChanged = ()=>{}, hasMap: hasMap, transformerLayerProps: transformerLayerProps, activeDraggableElement: activeDraggableElement, onDraggableElementChange: onDraggableElementChange = ()=>{}, onDragEnd: onDragEnd = ()=>{}, onMouseUp: onMouseUp = ()=>{}, digUpPlant: digUpPlant = (diggingPlantId, diggingPlantSpecimenNumber)=>{}, openPlantById: openPlantById = (id)=>{}, duplicatePlant: duplicatePlant = (duplicatingPlantId, specimenNumber, specimenQuantity, direction)=>{} }) {
    //const [selectedElementIndex, setSelectedElementIndex] = React.useState(null as number | null)
    const [twiceSelectedElementIndex, setTwiceSelectedElementIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(null);
    const [cursor, setCursor] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState('grab');
    const resetCursor = ()=>setCursor('grab');
    // const [mousePosition, setMousePosition] = useState({
    //   x: undefined as undefined | number,
    //   y: undefined as undefined | number,
    // })
    const [isVisibleMap, setVisibleMap] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(false);
    const [isGridVisible, setGridVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(false);
    const [gridSpacing, setGridSpacing] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(5);
    const [isRulerActive, setRulerActive] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(false);
    const [isMouseDown, setMouseDown] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(false);
    const stageRef = (0, $ltGt3.useRef)(null);
    const elementsLayerRef = (0, $ltGt3.useRef)(null);
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const actualCursor = Boolean(toolLayer) ? toolCursor || 'crosshair' : cursor;
    const [zoomPixelsPerCm, setZoomPixelsPerCm] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState($c6ef91034d0fe7ff$export$7ed706c01c506751);
    const zoomSliderSteps = 10;
    const zoomSliderMin = 0.1;
    const zoomSliderMax = 10;
    const [zoomStep, setZoomStep, zoomCoefficient] = (0, $4a88ff4b49571f8f$export$576428ae79ec2a5e)({
        steps: 10,
        min: zoomSliderMin,
        max: zoomSliderMax
    });
    const { token: { controlHeightSM: controlHeightSM, colorTextTertiary: colorTextTertiary } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    const canvasPixelsPerCm = zoomCoefficient * zoomPixelsPerCm;
    const checkDeselect = (e)=>{
        // deselect when clicked on empty area
        const clickedOnEmpty = e.target === e.target.getStage();
        if (clickedOnEmpty) {
            setSelectedElementId(null);
            setTwiceSelectedElementIndex(null);
        }
    };
    const stageContainerRef = (0, $ltGt3.useRef)(null);
    // const stageWidth = window.innerWidth - 900 > 550 ? window.innerWidth - 900 : 550
    // const stageHeight = window.innerHeight / 2 > 400 ? window.innerHeight / 2 : 400
    // useEffect(() => {
    //   if (stageRef.current) {
    //     // window['stageRef'] = stageRef.current
    //     console.log(`stage reset position: ${stageRef?.current.x()}, ${stageRef?.current.y()}`)
    //     const centerCoordintes = calculateCanvasCenter(elements, plotShape, canvasPixelsPerCm)
    //     const stageX = centerCoordintes[0] * canvasPixelsPerCm //- stageWidth / 2
    //     const stageY = centerCoordintes[1] * canvasPixelsPerCm //- stageHeight / 2
    //     console.log(`stageX: ${stageX}, stageY: ${stageY}, center: {${centerCoordintes.join(',')}}`)
    //     console.log(`plotShapeProps: ${JSON.stringify(plotShape?.props)}`)
    //     //stageRef.current.x(stageX)
    //     //stageRef.current.y(stageY)
    //     console.log(`stage after reset position: ${stageRef?.current.x()}, ${stageRef?.current.y()}`)
    //   }
    // }, [projectId, plotShape])
    const language = intl.locale;
    function createNewPlantSpecimen(plant, specimenIndex) {
        const oldCoordinates = plant.coordinates[specimenIndex];
        const newCoordinates = {
            x: oldCoordinates.x + oldCoordinates.width,
            y: oldCoordinates.y,
            width: oldCoordinates.width,
            height: oldCoordinates.height
        };
        const newPlant = {
            ...plant,
            coordinates: [
                ...plant.coordinates,
                newCoordinates
            ]
        };
        (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).editPlant(newPlant, language);
    }
    function deletePlantSpecimen(plant, specimenIndex) {
        const oldCoordinates = plant.coordinates[specimenIndex];
        const newCoordinates = oldCoordinates.slice(0, specimenIndex).concat(oldCoordinates.slice(specimenIndex));
        const newPlant = {
            ...plant,
            coordinates: newCoordinates
        };
        (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).editPlant(newPlant, language);
    }
    const centerCanvas = (0, $ltGt3.useCallback)(()=>{
        if (!elementsLayerRef.current || !stageRef.current) return;
        let stageAabb = elementsLayerRef.current.getClientRect({
            skipTransform: true
        });
        let zoomStageX = stageAabb.width === 0 ? $c6ef91034d0fe7ff$export$7ed706c01c506751 : stageRef.current.attrs.width / stageAabb.width;
        let zoomStageY = stageAabb.height === 0 ? $c6ef91034d0fe7ff$export$7ed706c01c506751 : stageRef.current.attrs.height / stageAabb.height;
        const newZoom = Math.min(zoomStageX, zoomStageY);
        const newZoomPixelsPerCm = newZoom / zoomCoefficient;
        setZoomPixelsPerCm(newZoomPixelsPerCm);
        if (zoomStageX > zoomStageY) {
            const x = stageAabb.x + stageAabb.width / 2 - stageRef.current.attrs.width / zoomStageY / 2;
            const y = stageAabb.y;
            stageRef.current.x(-x * newZoom);
            stageRef.current.y(-y * newZoom);
        } else {
            const y = stageAabb.y + stageAabb.height / 2 - stageRef.current.attrs.height / zoomStageX / 2;
            const x = stageAabb.x;
            stageRef.current.x(-x * newZoom);
            stageRef.current.y(-y * newZoom);
        }
        const event = {
            type: 'dragmove',
            target: stageRef.current,
            evt: undefined,
            currentTarget: stageRef.current,
            cancelBubble: false
        };
        stageRef.current.dispatchEvent(event);
    }, [
        zoomCoefficient
    ]);
    const { width: stageWidth, height: stageHeight } = (0, $d6ffe22cb7c5e16a$export$cd008ed3c7cf65a0)(stageRef, stageContainerRef);
    (0, $ltGt3.useEffect)(()=>{
        if (stageRef.current) centerCanvas();
    }, [
        projectId,
        stageWidth,
        stageHeight
    ]);
    (0, $ltGt3.useEffect)(()=>{
        const onDragTemplateEnd = (e)=>{
            if (!activeDraggableElement) return;
            const { x: x, y: y } = (0, $83a8040be81947e5$export$79263550b33b988b)(e.target);
            const template = (0, $670e204136b37e30$export$9544d5bb712b01ea).getElementTypeTemplates(activeDraggableElement.elementTypeId)?.[activeDraggableElement.temaplateId];
            if (!template) return;
            onDragEnd(x, y, template.width, template.height, activeDraggableElement.temaplateId);
            onDraggableElementChange(null);
        };
        const stage = stageRef.current;
        stage.on('mousemove', onDragTemplateEnd);
        return ()=>{
            if (stage) stage.off('mousemove', onDragTemplateEnd);
        };
    }, [
        activeDraggableElement
    ]);
    const selectedPlantCoordinates = (0, $0ffc20caa9d28ab8$export$2fcaf6c4fcf334b2)(()=>{
        if (isMouseDown) return null;
        if (!elementsLayerRef.current || !selectedPlant) return null;
        const elements = elementsLayerRef.current.children[0]['children'];
        if (!elements) return null;
        const selectedPlantElement = elements.find((e)=>e['_plantId'] === selectedPlant.id && e['_specimenIndex'] === selectedPlant.specimenIndex);
        if (!selectedPlantElement) return null;
        const scale = selectedPlantElement.getAbsoluteScale();
        const size = selectedPlantElement.getSize();
        const absolutePosition = selectedPlantElement.getAbsolutePosition();
        return {
            x: absolutePosition.x,
            y: absolutePosition.y,
            width: size.width * scale.x,
            height: size.height * scale.y
        };
    // const plantElements = elementsLayerRef
    }, [
        selectedPlant,
        plants,
        zoomCoefficient,
        isMouseDown
    ]);
    // const [image] = useImage(dots2)
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $ad1c3304c519fac5$export$2e2bcd8739ae039), {
        style: {
            position: 'relative',
            minHeight: '100%',
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'stretch'
        },
        styles: {
            body: {
                minHeight: '100%',
                width: '100%'
            }
        },
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "setting-box",
                style: {},
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "movement-buttons",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                onClick: centerCanvas,
                                children: intl.formatMessage({
                                    id: 'center'
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                type: isRulerActive ? 'primary' : 'default',
                                onClick: (e)=>setRulerActive(!isRulerActive),
                                children: intl.formatMessage({
                                    id: 'ruler'
                                })
                            })
                        ]
                    }),
                    hasMap && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                        checked: isVisibleMap,
                        onChange: (e)=>setVisibleMap(e.target.checked),
                        children: intl.formatMessage({
                            id: 'showMap'
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                        className: "grid-spacing-checkbox",
                        checked: isGridVisible,
                        onChange: (e)=>setGridVisible(e.target.checked),
                        style: {
                            display: 'flex',
                            alignItems: 'baseline'
                        },
                        children: [
                            intl.formatMessage({
                                id: 'showGridWithSpacing'
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039), {
                                        type: "number",
                                        style: {
                                            width: '75px'
                                        },
                                        disabled: !isGridVisible,
                                        value: gridSpacing,
                                        onChange: (e)=>setGridSpacing(Number.parseInt(e.target.value, 10))
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                        className: "grid-spacing-checkbox-units",
                                        children: intl.formatMessage({
                                            id: 'm'
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    position: 'relative',
                    height: '100%',
                    overflow: 'hidden'
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    style: {
                        position: 'absolute',
                        inset: 0
                    },
                    ref: stageContainerRef,
                    children: [
                        selectedPlant && selectedPlantCoordinates && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            style: {
                                position: 'absolute',
                                left: selectedPlantCoordinates.x + selectedPlantCoordinates.width,
                                top: selectedPlantCoordinates.y,
                                // height: selectedPlantCoordinates.height,
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'flex-end',
                                gap: controlHeightSM,
                                cursor: 'pointer',
                                pointerEvents: 'all',
                                zIndex: 1000
                            },
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $23b8abc34b52def4$export$e6c38ea441bba19f), {
                                plantId: selectedPlant.id,
                                specimenNumber: selectedPlant.specimenIndex,
                                openPlantById: openPlantById,
                                digUpPlant: digUpPlant,
                                duplicatePlant: duplicatePlant,
                                isLocked: lockedPlantIds.includes(selectedPlant.id)
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $05ecbc6bf305678c$export$208cd1682bd0e4b6), {
                            width: stageWidth,
                            height: stageHeight,
                            onMouseDown: (e)=>{
                                setMouseDown(true);
                                checkDeselect(e);
                            },
                            onMouseUp: (e)=>{
                                setMouseDown(false);
                                onMouseUp();
                            },
                            onTouchStart: checkDeselect,
                            // onMouseMove={(e) => {
                            //   const pointerPosition = stageRef.current?.getRelativePointerPosition()
                            //   setMousePosition(pointerPosition || {x: undefined, y: undefined})
                            // }}
                            draggable: !Boolean(toolLayer) && !isRulerActive,
                            style: {
                                cursor: actualCursor
                            },
                            scaleX: canvasPixelsPerCm,
                            scaleY: canvasPixelsPerCm,
                            ref: stageRef,
                            onDragMove: ()=>{
                            // console.log(`stage move: ${stageRef?.current.x()}, ${stageRef?.current.y()}`)
                            },
                            onWheel: (e)=>{
                                e.evt.preventDefault();
                                const stage = e.target.getStage();
                                const oldScale = stage.scaleX();
                                const pointerPosition = stage.getPointerPosition();
                                const mousePointTo = {
                                    x: pointerPosition.x / oldScale - stage.x() / oldScale,
                                    y: pointerPosition.y / oldScale - stage.y() / oldScale
                                };
                                const isZoomIn = e.evt.deltaY < 0;
                                if (isZoomIn) setZoomStep(zoomStep + 1);
                                else setZoomStep(zoomStep - 1);
                                setTimeout(()=>{
                                    const newScale = stage.scaleX();
                                    const newPos = {
                                        x: -(mousePointTo.x - pointerPosition.x / newScale) * newScale,
                                        y: -(mousePointTo.y - pointerPosition.y / newScale) * newScale
                                    };
                                    stage.position(newPos);
                                    stage.batchDraw();
                                }, 0);
                            },
                            children: [
                                isVisibleMap && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $91f5e78a9e89edee$export$ac0f232dc50c5905), {
                                    projectId: projectId,
                                    onMapNotFound: ()=>{
                                        setVisibleMap(false);
                                        (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).warning(intl.formatMessage({
                                            id: 'mapNotFound'
                                        }));
                                    },
                                    canvasPixelsPerM: canvasPixelsPerCm * 100
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $05ecbc6bf305678c$export$936d0764594b6eb3), {
                                    ref: elementsLayerRef,
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $05ecbc6bf305678c$export$eb2fcfdbd7ba97d4), {
                                        children: [
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0019b24ff2e88e39$export$79e859bd6760835), {
                                                element: {
                                                    type: 'plot',
                                                    ...plotShape,
                                                    props: {
                                                        ...plotShape?.props,
                                                        //     fillPatternImage: image,
                                                        fillPatternScale: {
                                                            x: 1 / canvasPixelsPerCm,
                                                            y: 1 / canvasPixelsPerCm
                                                        }
                                                    }
                                                },
                                                isEditable: plotShapeEditable,
                                                isSelectable: true,
                                                rotatable: false,
                                                isSelected: selectedElementId === -1,
                                                isTwiceSelected: twiceSelectedElementIndex === -1,
                                                onSelect: ()=>{
                                                    setSelectedElementId(-1);
                                                    setTwiceSelectedElementIndex(null);
                                                },
                                                onChange: onPlotShapeChanged,
                                                onTwiceClick: ()=>{
                                                    setTwiceSelectedElementIndex(-1);
                                                },
                                                setCursor: setCursor,
                                                resetCursor: resetCursor,
                                                transformerLayerProps: transformerLayerProps
                                            }),
                                            elements?.map((element, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0019b24ff2e88e39$export$79e859bd6760835), {
                                                    element: {
                                                        ...element,
                                                        props: {
                                                            ...element?.props
                                                        }
                                                    },
                                                    isEditable: editableTypes?.includes(element.type) || false,
                                                    isSelectable: true,
                                                    isSelected: element.elementId === selectedElementId,
                                                    isTwiceSelected: index === twiceSelectedElementIndex,
                                                    rotatable: true,
                                                    onSelect: ()=>{
                                                        setSelectedElementId(element.elementId);
                                                        setTwiceSelectedElementIndex(null);
                                                        setSelectedPlant(null);
                                                    },
                                                    onChange: (modified)=>{
                                                        onElementChanged({
                                                            ...modified,
                                                            elementId: element.elementId
                                                        });
                                                    },
                                                    onTwiceClick: ()=>{
                                                        setTwiceSelectedElementIndex(index);
                                                    },
                                                    setCursor: setCursor,
                                                    resetCursor: resetCursor,
                                                    transformerLayerProps: transformerLayerProps
                                                }, index)),
                                            plants?.map((plant, index)=>plant.coordinates//.filter((coord) => Object.keys(coord).length !== 0)
                                                .map((plantSpecimenCoordinates, specimenIndex)=>Object.keys(plantSpecimenCoordinates).length !== 0 ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $72ce89dd530774f3$export$eb48ad26464a3d3), {
                                                        plant: plant,
                                                        specimenIndex: plant.coordinates.length === 1 ? undefined : specimenIndex,
                                                        isEditable: editableTypes?.includes('plant') && !lockedPlantIds.includes(plant.id) || false,
                                                        isSelectable: true,
                                                        isSelected: plant.id === selectedPlant?.id && (typeof selectedPlant.specimenIndex === 'undefined' || selectedPlant.specimenIndex === specimenIndex),
                                                        rotatable: true,
                                                        onSelect: (evt)=>{
                                                            setSelectedPlant({
                                                                id: plant.id,
                                                                specimenIndex: specimenIndex
                                                            });
                                                        },
                                                        onChange: (modified)=>{
                                                            onElementChanged({
                                                                ...modified,
                                                                elementId: plant.id,
                                                                specimenIndex: specimenIndex
                                                            });
                                                        },
                                                        onTwiceClick: ()=>{
                                                            openPlantById(plant.id);
                                                        //setSelectedPlant(null)
                                                        //setTwiceSelectedElementIndex(index)
                                                        },
                                                        setCursor: setCursor,
                                                        resetCursor: resetCursor
                                                    }, `${index}-${specimenIndex}`) : null))
                                        ]
                                    })
                                }),
                                toolLayer,
                                isGridVisible && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3d687273e09d5357$export$3b2364b911db251c), {
                                    gridStepInPx: gridSpacing * 100
                                }),
                                isRulerActive && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3344c409c0becd6d$export$5f6747e1eff75f1c), {
                                    canvasPixelsPerM: canvasPixelsPerCm,
                                    setCursor: setCursor,
                                    resetCursor: resetCursor
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    position: 'absolute',
                    right: '20px',
                    top: '20px',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-end',
                    pointerEvents: 'none'
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $03e34e21fee84f40$export$87ae43576cc53e22), {
                    rotationAngle: 0
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "zoom-scale",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $67f23e2e13bc5bbc$export$b6a40bc1c4783f), {
                        pixelsPerCm: canvasPixelsPerCm
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4a88ff4b49571f8f$export$9d9d7317c3abcbc0), {
                        step: zoomStep,
                        setStep: setZoomStep,
                        steps: zoomSliderSteps,
                        min: zoomSliderMin,
                        max: zoomSliderMax
                    })
                ]
            })
        ]
    });
}



function $395d89d67d098b23$export$e3d016329f8674e7(props) {
    const elementRegistryInfo = (0, $ltGt3.useMemo)(()=>(0, $3b2a1dec172ced19$export$bbdb2c97169ec0d5)[props.tool], [
        props.tool
    ]);
    const { toolCursor: toolCursor = 'crosshair', toolLayer: ToolLayerComponent } = elementRegistryInfo || {};
    let toolLayer = ToolLayerComponent ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)(ToolLayerComponent, {
        onElementDrawn: props.onElementDrawn
    }) : null;
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        style: {
            position: 'relative',
            height: '100%'
        },
        children: [
            props.tool && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    background: 'rgba(0, 0, 0, 0.2)',
                    padding: '4px 8px'
                },
                children: props.tool
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $c6ef91034d0fe7ff$export$e11337932570a9ce), {
                ...props.canvasEditorProps,
                toolLayer: toolLayer,
                toolCursor: toolCursor,
                onDragEnd: (x, y, width, height)=>{
                    props.onElementDrawn({
                        type: 'image',
                        props: {
                            x: Math.floor(x),
                            y: Math.floor(y),
                            width: Math.floor(width),
                            height: Math.floor(height)
                        }
                    });
                }
            })
        ]
    });
}






var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $2e476c38123066cf$var$DragOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.3 506.3L781.7 405.6a7.23 7.23 0 00-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 00-11.3 0L405.6 242.3a7.23 7.23 0 005.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 00.1-11.4z"
                }
            }
        ]
    },
    "name": "drag",
    "theme": "outlined"
};
var $2e476c38123066cf$export$2e2bcd8739ae039 = $2e476c38123066cf$var$DragOutlined;



var $c3c073aab5c77f59$var$DragOutlined = function DragOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $2e476c38123066cf$export$2e2bcd8739ae039)
    }));
};
/**![drag](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS4zIDUwNi4zTDc4MS43IDQwNS42YTcuMjMgNy4yMyAwIDAwLTExLjcgNS43VjQ3Nkg1NDhWMjU0aDY0LjhjNiAwIDkuNC03IDUuNy0xMS43TDUxNy43IDExNC43YTcuMTQgNy4xNCAwIDAwLTExLjMgMEw0MDUuNiAyNDIuM2E3LjIzIDcuMjMgMCAwMDUuNyAxMS43SDQ3NnYyMjJIMjU0di02NC44YzAtNi03LTkuNC0xMS43LTUuN0wxMTQuNyA1MDYuM2E3LjE0IDcuMTQgMCAwMDAgMTEuM2wxMjcuNSAxMDAuOGM0LjcgMy43IDExLjcuNCAxMS43LTUuN1Y1NDhoMjIydjIyMmgtNjQuOGMtNiAwLTkuNCA3LTUuNyAxMS43bDEwMC44IDEyNy41YzIuOSAzLjcgOC41IDMuNyAxMS4zIDBsMTAwLjgtMTI3LjVjMy43LTQuNy40LTExLjctNS43LTExLjdINTQ4VjU0OGgyMjJ2NjQuOGMwIDYgNyA5LjQgMTEuNyA1LjdsMTI3LjUtMTAwLjhhNy4zIDcuMyAwIDAwLjEtMTEuNHoiIC8+PC9zdmc+) */ var $c3c073aab5c77f59$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($c3c073aab5c77f59$var$DragOutlined);
var $c3c073aab5c77f59$export$2e2bcd8739ae039 = $c3c073aab5c77f59$var$RefIcon;






var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");








var $ltGt3 = parcelRequire("ltGt3");








const $ce082749e682eba8$var$antStatusProcessing = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antStatusProcessing', {
    '0%': {
        transform: 'scale(0.8)',
        opacity: 0.5
    },
    '100%': {
        transform: 'scale(2.4)',
        opacity: 0
    }
});
const $ce082749e682eba8$var$antZoomBadgeIn = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomBadgeIn', {
    '0%': {
        transform: 'scale(0) translate(50%, -50%)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1) translate(50%, -50%)'
    }
});
const $ce082749e682eba8$var$antZoomBadgeOut = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antZoomBadgeOut', {
    '0%': {
        transform: 'scale(1) translate(50%, -50%)'
    },
    '100%': {
        transform: 'scale(0) translate(50%, -50%)',
        opacity: 0
    }
});
const $ce082749e682eba8$var$antNoWrapperZoomBadgeIn = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antNoWrapperZoomBadgeIn', {
    '0%': {
        transform: 'scale(0)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)'
    }
});
const $ce082749e682eba8$var$antNoWrapperZoomBadgeOut = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antNoWrapperZoomBadgeOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0)',
        opacity: 0
    }
});
const $ce082749e682eba8$var$antBadgeLoadingCircle = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('antBadgeLoadingCircle', {
    '0%': {
        transformOrigin: '50%'
    },
    '100%': {
        transform: 'translate(50%, -50%) rotate(360deg)',
        transformOrigin: '50%'
    }
});
const $ce082749e682eba8$var$genSharedBadgeStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, antCls: antCls, badgeShadowSize: badgeShadowSize, textFontSize: textFontSize, textFontSizeSM: textFontSizeSM, statusSize: statusSize, dotSize: dotSize, textFontWeight: textFontWeight, indicatorHeight: indicatorHeight, indicatorHeightSM: indicatorHeightSM, marginXS: marginXS, calc: calc } = token;
    const numberPrefixCls = `${antCls}-scroll-number`;
    const colorPreset = (0, $a6826a70be89cfee$export$2e2bcd8739ae039)(token, (colorKey, { darkColor: darkColor })=>({
            [`&${componentCls} ${componentCls}-color-${colorKey}`]: {
                background: darkColor,
                [`&:not(${componentCls}-count)`]: {
                    color: darkColor
                },
                'a:hover &': {
                    background: darkColor
                }
            }
        }));
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            position: 'relative',
            display: 'inline-block',
            width: 'fit-content',
            lineHeight: 1,
            [`${componentCls}-count`]: {
                display: 'inline-flex',
                justifyContent: 'center',
                zIndex: token.indicatorZIndex,
                minWidth: indicatorHeight,
                height: indicatorHeight,
                color: token.badgeTextColor,
                fontWeight: textFontWeight,
                fontSize: textFontSize,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(indicatorHeight),
                whiteSpace: 'nowrap',
                textAlign: 'center',
                background: token.badgeColor,
                borderRadius: calc(indicatorHeight).div(2).equal(),
                boxShadow: `0 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(badgeShadowSize)} ${token.badgeShadowColor}`,
                transition: `background ${token.motionDurationMid}`,
                a: {
                    color: token.badgeTextColor
                },
                'a:hover': {
                    color: token.badgeTextColor
                },
                'a:hover &': {
                    background: token.badgeColorHover
                }
            },
            [`${componentCls}-count-sm`]: {
                minWidth: indicatorHeightSM,
                height: indicatorHeightSM,
                fontSize: textFontSizeSM,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(indicatorHeightSM),
                borderRadius: calc(indicatorHeightSM).div(2).equal()
            },
            [`${componentCls}-multiple-words`]: {
                padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingXS)}`,
                bdi: {
                    unicodeBidi: 'plaintext'
                }
            },
            [`${componentCls}-dot`]: {
                zIndex: token.indicatorZIndex,
                width: dotSize,
                minWidth: dotSize,
                height: dotSize,
                background: token.badgeColor,
                borderRadius: '100%',
                boxShadow: `0 0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(badgeShadowSize)} ${token.badgeShadowColor}`
            },
            [`${componentCls}-count, ${componentCls}-dot, ${numberPrefixCls}-custom-component`]: {
                position: 'absolute',
                top: 0,
                insetInlineEnd: 0,
                transform: 'translate(50%, -50%)',
                transformOrigin: '100% 0%',
                [`&${iconCls}-spin`]: {
                    animationName: $ce082749e682eba8$var$antBadgeLoadingCircle,
                    animationDuration: '1s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear'
                }
            },
            [`&${componentCls}-status`]: {
                lineHeight: 'inherit',
                verticalAlign: 'baseline',
                [`${componentCls}-status-dot`]: {
                    position: 'relative',
                    top: -1,
                    // Magic number, but seems better experience
                    display: 'inline-block',
                    width: statusSize,
                    height: statusSize,
                    verticalAlign: 'middle',
                    borderRadius: '50%'
                },
                [`${componentCls}-status-success`]: {
                    backgroundColor: token.colorSuccess
                },
                [`${componentCls}-status-processing`]: {
                    overflow: 'visible',
                    color: token.colorInfo,
                    backgroundColor: token.colorInfo,
                    borderColor: 'currentcolor',
                    '&::after': {
                        position: 'absolute',
                        top: 0,
                        insetInlineStart: 0,
                        width: '100%',
                        height: '100%',
                        borderWidth: badgeShadowSize,
                        borderStyle: 'solid',
                        borderColor: 'inherit',
                        borderRadius: '50%',
                        animationName: $ce082749e682eba8$var$antStatusProcessing,
                        animationDuration: token.badgeProcessingDuration,
                        animationIterationCount: 'infinite',
                        animationTimingFunction: 'ease-in-out',
                        content: '""'
                    }
                },
                [`${componentCls}-status-default`]: {
                    backgroundColor: token.colorTextPlaceholder
                },
                [`${componentCls}-status-error`]: {
                    backgroundColor: token.colorError
                },
                [`${componentCls}-status-warning`]: {
                    backgroundColor: token.colorWarning
                },
                [`${componentCls}-status-text`]: {
                    marginInlineStart: marginXS,
                    color: token.colorText,
                    fontSize: token.fontSize
                }
            },
            ...colorPreset,
            [`${componentCls}-zoom-appear, ${componentCls}-zoom-enter`]: {
                animationName: $ce082749e682eba8$var$antZoomBadgeIn,
                animationDuration: token.motionDurationSlow,
                animationTimingFunction: token.motionEaseOutBack,
                animationFillMode: 'both'
            },
            [`${componentCls}-zoom-leave`]: {
                animationName: $ce082749e682eba8$var$antZoomBadgeOut,
                animationDuration: token.motionDurationSlow,
                animationTimingFunction: token.motionEaseOutBack,
                animationFillMode: 'both'
            },
            [`&${componentCls}-not-a-wrapper`]: {
                [`${componentCls}-zoom-appear, ${componentCls}-zoom-enter`]: {
                    animationName: $ce082749e682eba8$var$antNoWrapperZoomBadgeIn,
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseOutBack
                },
                [`${componentCls}-zoom-leave`]: {
                    animationName: $ce082749e682eba8$var$antNoWrapperZoomBadgeOut,
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseOutBack
                },
                [`&:not(${componentCls}-status)`]: {
                    verticalAlign: 'middle'
                },
                [`${numberPrefixCls}-custom-component, ${componentCls}-count`]: {
                    transform: 'none'
                },
                [`${numberPrefixCls}-custom-component, ${numberPrefixCls}`]: {
                    position: 'relative',
                    top: 'auto',
                    display: 'block',
                    transformOrigin: '50% 50%'
                }
            },
            [numberPrefixCls]: {
                overflow: 'hidden',
                transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack}`,
                [`${numberPrefixCls}-only`]: {
                    position: 'relative',
                    display: 'inline-block',
                    height: indicatorHeight,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseOutBack}`,
                    WebkitTransformStyle: 'preserve-3d',
                    WebkitBackfaceVisibility: 'hidden',
                    [`> p${numberPrefixCls}-only-unit`]: {
                        height: indicatorHeight,
                        margin: 0,
                        WebkitTransformStyle: 'preserve-3d',
                        WebkitBackfaceVisibility: 'hidden'
                    }
                },
                [`${numberPrefixCls}-symbol`]: {
                    verticalAlign: 'top'
                }
            },
            // ====================== RTL =======================
            '&-rtl': {
                direction: 'rtl',
                [`${componentCls}-count, ${componentCls}-dot, ${numberPrefixCls}-custom-component`]: {
                    transform: 'translate(-50%, -50%)'
                }
            }
        }
    };
};
const $ce082749e682eba8$export$362fb92a8f81bbf9 = (token)=>{
    const { fontHeight: fontHeight, lineWidth: lineWidth, marginXS: marginXS, colorBorderBg: colorBorderBg } = token;
    const badgeFontHeight = fontHeight;
    const badgeShadowSize = lineWidth;
    const badgeTextColor = token.colorTextLightSolid;
    const badgeColor = token.colorError;
    const badgeColorHover = token.colorErrorHover;
    const badgeToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        badgeFontHeight: badgeFontHeight,
        badgeShadowSize: badgeShadowSize,
        badgeTextColor: badgeTextColor,
        badgeColor: badgeColor,
        badgeColorHover: badgeColorHover,
        badgeShadowColor: colorBorderBg,
        badgeProcessingDuration: '1.2s',
        badgeRibbonOffset: marginXS,
        // Follow token just by Design. Not related with token
        badgeRibbonCornerTransform: 'scaleY(0.75)',
        badgeRibbonCornerFilter: `brightness(75%)`
    });
    return badgeToken;
};
const $ce082749e682eba8$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, fontSizeSM: fontSizeSM, lineWidth: lineWidth } = token;
    return {
        indicatorZIndex: 'auto',
        indicatorHeight: Math.round(fontSize * lineHeight) - 2 * lineWidth,
        indicatorHeightSM: fontSize,
        dotSize: fontSizeSM / 2,
        textFontSize: fontSizeSM,
        textFontSizeSM: fontSizeSM,
        textFontWeight: 'normal',
        statusSize: fontSizeSM / 2
    };
};
var $ce082749e682eba8$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Badge', (token)=>{
    const badgeToken = $ce082749e682eba8$export$362fb92a8f81bbf9(token);
    return $ce082749e682eba8$var$genSharedBadgeStyle(badgeToken);
}, $ce082749e682eba8$export$9ca1be8807fe0675);




// ============================== Ribbon ==============================
const $79e03d70da42552b$var$genRibbonStyle = (token)=>{
    const { antCls: antCls, badgeFontHeight: badgeFontHeight, marginXS: marginXS, badgeRibbonOffset: badgeRibbonOffset, calc: calc } = token;
    const ribbonPrefixCls = `${antCls}-ribbon`;
    const ribbonWrapperPrefixCls = `${antCls}-ribbon-wrapper`;
    const statusRibbonPreset = (0, $a6826a70be89cfee$export$2e2bcd8739ae039)(token, (colorKey, { darkColor: darkColor })=>({
            [`&${ribbonPrefixCls}-color-${colorKey}`]: {
                background: darkColor,
                color: darkColor
            }
        }));
    return {
        [ribbonWrapperPrefixCls]: {
            position: 'relative'
        },
        [ribbonPrefixCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            position: 'absolute',
            top: marginXS,
            padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingXS)}`,
            color: token.colorPrimary,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(badgeFontHeight),
            whiteSpace: 'nowrap',
            backgroundColor: token.colorPrimary,
            borderRadius: token.borderRadiusSM,
            [`${ribbonPrefixCls}-content`]: {
                color: token.badgeTextColor
            },
            [`${ribbonPrefixCls}-corner`]: {
                position: 'absolute',
                top: '100%',
                width: badgeRibbonOffset,
                height: badgeRibbonOffset,
                color: 'currentcolor',
                border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(badgeRibbonOffset).div(2).equal())} solid`,
                transform: token.badgeRibbonCornerTransform,
                transformOrigin: 'top',
                filter: token.badgeRibbonCornerFilter
            },
            ...statusRibbonPreset,
            [`&${ribbonPrefixCls}-placement-end`]: {
                insetInlineEnd: calc(badgeRibbonOffset).mul(-1).equal(),
                borderEndEndRadius: 0,
                [`${ribbonPrefixCls}-corner`]: {
                    insetInlineEnd: 0,
                    borderInlineEndColor: 'transparent',
                    borderBlockEndColor: 'transparent'
                }
            },
            [`&${ribbonPrefixCls}-placement-start`]: {
                insetInlineStart: calc(badgeRibbonOffset).mul(-1).equal(),
                borderEndStartRadius: 0,
                [`${ribbonPrefixCls}-corner`]: {
                    insetInlineStart: 0,
                    borderBlockEndColor: 'transparent',
                    borderInlineStartColor: 'transparent'
                }
            },
            // ====================== RTL =======================
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
var // ============================== Export ==============================
$79e03d70da42552b$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)([
    'Badge',
    'Ribbon'
], (token)=>{
    const badgeToken = (0, $ce082749e682eba8$export$362fb92a8f81bbf9)(token);
    return $79e03d70da42552b$var$genRibbonStyle(badgeToken);
}, (0, $ce082749e682eba8$export$9ca1be8807fe0675));


"use client";
const $84dbf0dceffafaef$var$Ribbon = (props)=>{
    const { className: className, prefixCls: customizePrefixCls, style: style, color: color, children: children, text: text, placement: placement = 'end', rootClassName: rootClassName, styles: styles, classNames: ribbonClassNames } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('ribbon');
    const prefixCls = getPrefixCls('ribbon', customizePrefixCls);
    const wrapperCls = `${prefixCls}-wrapper`;
    const [hashId, cssVarCls] = (0, $79e03d70da42552b$export$2e2bcd8739ae039)(prefixCls, wrapperCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        placement: placement
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        ribbonClassNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const colorInPreset = (0, $af9f1fd0e95fb060$export$ee62ebd6a58c4884)(color, false);
    const ribbonCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-placement-${placement}`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-color-${color}`]: colorInPreset
    }, className, contextClassName, mergedClassNames.indicator);
    const colorStyle = {};
    const cornerColorStyle = {};
    if (color && !colorInPreset) {
        colorStyle.background = color;
        cornerColorStyle.color = color;
    }
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(wrapperCls, rootClassName, hashId, cssVarCls, mergedClassNames.root),
        style: mergedStyles.root
    }, children, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(ribbonCls, hashId),
        style: {
            ...colorStyle,
            ...mergedStyles.indicator,
            ...contextStyle,
            ...style
        }
    }, /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-content`, mergedClassNames.content),
        style: mergedStyles.content
    }, text), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-corner`,
        style: cornerColorStyle
    })));
};
var $84dbf0dceffafaef$export$2e2bcd8739ae039 = $84dbf0dceffafaef$var$Ribbon;



var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");

"use client";
const $fa9d5e2cfa761d70$var$UnitNumber = (props)=>{
    const { prefixCls: prefixCls, value: value, current: current, offset: offset = 0 } = props;
    let style;
    if (offset) style = {
        position: 'absolute',
        top: `${offset}00%`,
        left: 0
    };
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        style: style,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-only-unit`, {
            current: current
        })
    }, value);
};
function $fa9d5e2cfa761d70$var$getOffset(start, end, unit) {
    let index = start;
    let offset = 0;
    while((index + 10) % 10 !== end){
        index += unit;
        offset += unit;
    }
    return offset;
}
const $fa9d5e2cfa761d70$var$SingleNumber = (props)=>{
    const { prefixCls: prefixCls, count: originCount, value: originValue } = props;
    const value = Number(originValue);
    const count = Math.abs(originCount);
    const [prevValue, setPrevValue] = $ltGt3.useState(value);
    const [prevCount, setPrevCount] = $ltGt3.useState(count);
    // ============================= Events =============================
    const onTransitionEnd = ()=>{
        setPrevValue(value);
        setPrevCount(count);
    };
    // Fallback if transition events are not supported
    $ltGt3.useEffect(()=>{
        const timer = setTimeout(onTransitionEnd, 1000);
        return ()=>clearTimeout(timer);
    }, [
        value
    ]);
    // ============================= Render =============================
    // Render unit list
    let unitNodes;
    let offsetStyle;
    if (prevValue === value || Number.isNaN(value) || Number.isNaN(prevValue)) {
        // Nothing to change
        unitNodes = [
            /*#__PURE__*/ $ltGt3.createElement($fa9d5e2cfa761d70$var$UnitNumber, {
                ...props,
                key: value,
                current: true
            })
        ];
        offsetStyle = {
            transition: 'none'
        };
    } else {
        unitNodes = [];
        // Fill basic number units
        const end = value + 10;
        const unitNumberList = [];
        for(let index = value; index <= end; index += 1)unitNumberList.push(index);
        const unit = prevCount < count ? 1 : -1;
        // Fill with number unit nodes
        const prevIndex = unitNumberList.findIndex((n)=>n % 10 === prevValue);
        // Cut list
        const cutUnitNumberList = unit < 0 ? unitNumberList.slice(0, prevIndex + 1) : unitNumberList.slice(prevIndex);
        unitNodes = cutUnitNumberList.map((n, index)=>{
            const singleUnit = n % 10;
            return /*#__PURE__*/ $ltGt3.createElement($fa9d5e2cfa761d70$var$UnitNumber, {
                ...props,
                key: n,
                value: singleUnit,
                offset: unit < 0 ? index - prevIndex : index,
                current: index === prevIndex
            });
        });
        // Calculate container offset value
        offsetStyle = {
            transform: `translateY(${-$fa9d5e2cfa761d70$var$getOffset(prevValue, value, unit)}00%)`
        };
    }
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-only`,
        style: offsetStyle,
        onTransitionEnd: onTransitionEnd
    }, unitNodes);
};
var $fa9d5e2cfa761d70$export$2e2bcd8739ae039 = $fa9d5e2cfa761d70$var$SingleNumber;


"use client";
const $6bd11025289a29df$var$ScrollNumber = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, count: count, className: className, motionClassName: motionClassName, style: style, title: title, show: show, component: Component = 'sup', children: children, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('scroll-number', customizePrefixCls);
    // ============================ Render ============================
    const newProps = {
        ...restProps,
        'data-show': show,
        style: style,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, className, motionClassName),
        title: title
    };
    // Only integer need motion
    let numberNodes = count;
    if (count && Number(count) % 1 === 0) {
        const numberList = String(count).split('');
        numberNodes = /*#__PURE__*/ $ltGt3.createElement("bdi", null, numberList.map((num, i)=>/*#__PURE__*/ $ltGt3.createElement((0, $fa9d5e2cfa761d70$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                count: Number(count),
                value: num,
                // eslint-disable-next-line react/no-array-index-key
                key: numberList.length - i
            })));
    }
    // allow specify the border
    // mock border-color by box-shadow for compatible with old usage:
    // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />
    if (style?.borderColor) newProps.style = {
        ...style,
        boxShadow: `0 0 0 1px ${style.borderColor} inset`
    };
    if (children) return (0, $66d38239e1a27993$export$e530037191fcd5d7)(children, (oriProps)=>({
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-custom-component`, oriProps?.className, motionClassName)
        }));
    return /*#__PURE__*/ $ltGt3.createElement(Component, {
        ...newProps,
        ref: ref
    }, numberNodes);
});
var $6bd11025289a29df$export$2e2bcd8739ae039 = $6bd11025289a29df$var$ScrollNumber;



"use client";
const $a382abb3be4865b2$var$InternalBadge = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, scrollNumberPrefixCls: customizeScrollNumberPrefixCls, children: children, status: status, text: text, color: color, count: count = null, overflowCount: overflowCount = 99, dot: dot = false, size: size = 'default', title: title, offset: offset, style: style, className: className, rootClassName: rootClassName, classNames: classNames, styles: styles, showZero: showZero = false, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('badge');
    const prefixCls = getPrefixCls('badge', customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ce082749e682eba8$export$2e2bcd8739ae039)(prefixCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        overflowCount: overflowCount,
        size: size,
        dot: dot,
        showZero: showZero
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ================================ Misc ================================
    const numberedDisplayCount = count > overflowCount ? `${overflowCount}+` : count;
    const isZero = numberedDisplayCount === '0' || numberedDisplayCount === 0 || text === '0' || text === 0;
    const ignoreCount = count === null || isZero && !showZero;
    const hasStatus = ((0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(status) || (0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(color)) && ignoreCount;
    const hasStatusValue = (0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(status) || !isZero;
    const showAsDot = dot && !isZero;
    const mergedCount = showAsDot ? '' : numberedDisplayCount;
    const isHidden = (0, $ltGt3.useMemo)(()=>{
        const isEmpty = (mergedCount === null || mergedCount === undefined || mergedCount === '') && (text === undefined || text === null || text === '');
        return (isEmpty || isZero && !showZero) && !showAsDot;
    }, [
        mergedCount,
        isZero,
        showZero,
        showAsDot,
        text
    ]);
    // Count should be cache in case hidden change it
    const countRef = (0, $ltGt3.useRef)(count);
    if (!isHidden) countRef.current = count;
    const livingCount = countRef.current;
    // We need cache count since remove motion should not change count display
    const displayCountRef = (0, $ltGt3.useRef)(mergedCount);
    if (!isHidden) displayCountRef.current = mergedCount;
    const displayCount = displayCountRef.current;
    // We will cache the dot status to avoid shaking on leaved motion
    const isDotRef = (0, $ltGt3.useRef)(showAsDot);
    if (!isHidden) isDotRef.current = showAsDot;
    // =============================== Styles ===============================
    const mergedStyle = (0, $ltGt3.useMemo)(()=>{
        if (!offset) return {
            ...contextStyle,
            ...style
        };
        const horizontalOffset = Number.parseInt(offset[0], 10);
        const offsetStyle = {
            marginTop: offset[1],
            insetInlineEnd: -horizontalOffset
        };
        return {
            ...offsetStyle,
            ...contextStyle,
            ...style
        };
    }, [
        offset,
        style,
        contextStyle
    ]);
    // =============================== Render ===============================
    // >>> Title
    const titleNode = title ?? (typeof livingCount === 'string' || typeof livingCount === 'number' ? livingCount : undefined);
    // >>> Status Text
    const showStatusTextNode = !isHidden && (text === 0 ? showZero : !!text && text !== true);
    const statusTextNode = !showStatusTextNode ? null : /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-status-text`
    }, text);
    // >>> Display Component
    const displayNode = !livingCount || typeof livingCount !== 'object' ? undefined : (0, $66d38239e1a27993$export$e530037191fcd5d7)(livingCount, (oriProps)=>({
            style: {
                ...mergedStyle,
                ...oriProps.style
            }
        }));
    // InternalColor
    const isInternalColor = (0, $af9f1fd0e95fb060$export$ee62ebd6a58c4884)(color, false);
    // Shared styles
    const statusCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassNames.indicator, {
        [`${prefixCls}-status-dot`]: hasStatus,
        [`${prefixCls}-status-${status}`]: !!status,
        [`${prefixCls}-color-${color}`]: isInternalColor
    });
    const statusStyle = {};
    if (color && !isInternalColor) {
        statusStyle.color = color;
        statusStyle.background = color;
    }
    const badgeClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-status`]: hasStatus,
        [`${prefixCls}-not-a-wrapper`]: !children,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, contextClassName, mergedClassNames.root, hashId, cssVarCls);
    // <Badge status="success" />
    if (!children && hasStatus && (text || hasStatusValue || !ignoreCount)) {
        const statusTextColor = mergedStyle.color;
        return /*#__PURE__*/ $ltGt3.createElement("span", {
            ...restProps,
            className: badgeClassName,
            style: {
                ...mergedStyles.root,
                ...mergedStyle
            }
        }, /*#__PURE__*/ $ltGt3.createElement("span", {
            className: statusCls,
            style: {
                ...mergedStyles.indicator,
                ...statusStyle
            }
        }), showStatusTextNode && /*#__PURE__*/ $ltGt3.createElement("span", {
            style: {
                color: statusTextColor
            },
            className: `${prefixCls}-status-text`
        }, text));
    }
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        ref: ref,
        ...restProps,
        className: badgeClassName,
        style: mergedStyles.root
    }, children, /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), {
        visible: !isHidden,
        motionName: `${prefixCls}-zoom`,
        motionAppear: false,
        motionDeadline: 1000
    }, ({ className: motionClassName })=>{
        const scrollNumberPrefixCls = getPrefixCls('scroll-number', customizeScrollNumberPrefixCls);
        const isDot = isDotRef.current;
        const scrollNumberCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassNames.indicator, {
            [`${prefixCls}-dot`]: isDot,
            [`${prefixCls}-count`]: !isDot,
            [`${prefixCls}-count-sm`]: size === 'small',
            [`${prefixCls}-multiple-words`]: !isDot && displayCount && displayCount.toString().length > 1,
            [`${prefixCls}-status-${status}`]: !!status,
            [`${prefixCls}-color-${color}`]: isInternalColor
        });
        let scrollNumberStyle = {
            ...mergedStyles.indicator,
            ...mergedStyle
        };
        if (color && !isInternalColor) {
            scrollNumberStyle = scrollNumberStyle || {};
            scrollNumberStyle.background = color;
        }
        return /*#__PURE__*/ $ltGt3.createElement((0, $6bd11025289a29df$export$2e2bcd8739ae039), {
            prefixCls: scrollNumberPrefixCls,
            show: !isHidden,
            motionClassName: motionClassName,
            className: scrollNumberCls,
            count: displayCount,
            title: titleNode,
            style: scrollNumberStyle,
            key: "scrollNumber"
        }, displayNode);
    }), statusTextNode);
});
const $a382abb3be4865b2$var$Badge = $a382abb3be4865b2$var$InternalBadge;
$a382abb3be4865b2$var$Badge.Ribbon = (0, $84dbf0dceffafaef$export$2e2bcd8739ae039);
var $a382abb3be4865b2$export$2e2bcd8739ae039 = $a382abb3be4865b2$var$Badge;






var $ltGt3 = parcelRequire("ltGt3");
/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */ 
var $ltGt3 = parcelRequire("ltGt3");
const $a5b41eab03e0c7d7$export$dfae7d399eea2568 = /*#__PURE__*/ $ltGt3.createContext(null);
const $a5b41eab03e0c7d7$export$e508d6f1a100e5dd = /*#__PURE__*/ $ltGt3.createContext({});



var $ltGt3 = parcelRequire("ltGt3");
const $954cbaaefa1b7d72$var$DropIndicator = (props)=>{
    const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, indent: indent } = props;
    const style = {
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        backgroundColor: 'red',
        height: 2
    };
    switch(dropPosition){
        case -1:
            style.top = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 1:
            style.bottom = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 0:
            style.bottom = 0;
            style.left = indent;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        style: style
    });
};
var $954cbaaefa1b7d72$export$2e2bcd8739ae039 = $954cbaaefa1b7d72$var$DropIndicator;





var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");
const $2ab704cde12fe9ed$var$Indent = ({ prefixCls: prefixCls, level: level, isStart: isStart, isEnd: isEnd })=>{
    const baseClassName = `${prefixCls}-indent-unit`;
    const list = [];
    for(let i = 0; i < level; i += 1)list.push(/*#__PURE__*/ $ltGt3.createElement("span", {
        key: i,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(baseClassName, {
            [`${baseClassName}-start`]: isStart[i],
            [`${baseClassName}-end`]: isEnd[i]
        })
    }));
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        "aria-hidden": "true",
        className: `${prefixCls}-indent`
    }, list);
};
var $2ab704cde12fe9ed$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.memo($2ab704cde12fe9ed$var$Indent);


function $a8a325450e627f23$export$2e2bcd8739ae039(keyEntities, key) {
    return keyEntities[key];
}






function $f32a159b6ed8d919$export$1690e12b840569b9(level, index) {
    return `${level}-${index}`;
}
function $f32a159b6ed8d919$export$1c189858aa1437d7(node) {
    return node && node.type && node.type.isTreeNode;
}
function $f32a159b6ed8d919$export$a47fb462a08de82f(key, pos) {
    if (key !== null && key !== undefined) return key;
    return pos;
}
function $f32a159b6ed8d919$export$6c519d302dced239(fieldNames) {
    const { title: title, _title: _title, key: key, children: children } = fieldNames || {};
    const mergedTitle = title || 'title';
    return {
        title: mergedTitle,
        _title: _title || [
            mergedTitle
        ],
        key: key || 'key',
        children: children || 'children'
    };
}
function $f32a159b6ed8d919$export$702780ec64d148df(treeData, fieldNames) {
    const keys = new Map();
    function dig(list, path = '') {
        (list || []).forEach((treeNode)=>{
            const key = treeNode[fieldNames.key];
            const children = treeNode[fieldNames.children];
            (0, $474154b5a64067c8$export$2e2bcd8739ae039)(key !== null && key !== undefined, `Tree node must have a certain key: [${path}${key}]`);
            const recordKey = String(key);
            (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!keys.has(recordKey) || key === null || key === undefined, `Same 'key' exist in the Tree: ${recordKey}`);
            keys.set(recordKey, true);
            dig(children, `${path}${recordKey} > `);
        });
    }
    dig(treeData);
}
function $f32a159b6ed8d919$export$6d8b10995563b669(rootNodes) {
    function dig(node) {
        const treeNodes = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(node);
        return treeNodes.map((treeNode)=>{
            // Filter invalidate node
            if (!$f32a159b6ed8d919$export$1c189858aa1437d7(treeNode)) {
                (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!treeNode, 'Tree/TreeNode can only accept TreeNode as children.');
                return null;
            }
            const { key: key } = treeNode;
            const { children: children, ...rest } = treeNode.props;
            const dataNode = {
                key: key,
                ...rest
            };
            const parsedChildren = dig(children);
            if (parsedChildren.length) dataNode.children = parsedChildren;
            return dataNode;
        }).filter((dataNode)=>dataNode);
    }
    return dig(rootNodes);
}
function $f32a159b6ed8d919$export$215c1b4f1ba88b23(treeNodeList, expandedKeys, fieldNames) {
    const { _title: fieldTitles, key: fieldKey, children: fieldChildren } = $f32a159b6ed8d919$export$6c519d302dced239(fieldNames);
    const expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
    const flattenList = [];
    function dig(list, parent = null) {
        return list.map((treeNode, index)=>{
            const pos = $f32a159b6ed8d919$export$1690e12b840569b9(parent ? parent.pos : '0', index);
            const mergedKey = $f32a159b6ed8d919$export$a47fb462a08de82f(treeNode[fieldKey], pos);
            // Pick matched title in field title list
            let mergedTitle;
            for(let i = 0; i < fieldTitles.length; i += 1){
                const fieldTitle = fieldTitles[i];
                if (treeNode[fieldTitle] !== undefined) {
                    mergedTitle = treeNode[fieldTitle];
                    break;
                }
            }
            // Add FlattenDataNode into list
            // We use `Object.assign` here to save perf since babel's `objectSpread` has perf issue
            const flattenNode = Object.assign((0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(treeNode, [
                ...fieldTitles,
                fieldKey,
                fieldChildren
            ]), {
                title: mergedTitle,
                key: mergedKey,
                parent: parent,
                pos: pos,
                children: null,
                data: treeNode,
                isStart: [
                    ...parent ? parent.isStart : [],
                    index === 0
                ],
                isEnd: [
                    ...parent ? parent.isEnd : [],
                    index === list.length - 1
                ]
            });
            flattenList.push(flattenNode);
            // Loop treeNode children
            if (expandedKeys === true || expandedKeySet.has(mergedKey)) flattenNode.children = dig(treeNode[fieldChildren] || [], flattenNode);
            else flattenNode.children = [];
            return flattenNode;
        });
    }
    dig(treeNodeList);
    return flattenList;
}
function $f32a159b6ed8d919$export$4b2e27469b557f9d(dataNodes, callback, // To avoid too many params, let use config instead of origin param
config) {
    let mergedConfig = {};
    if (typeof config === 'object') mergedConfig = config;
    else mergedConfig = {
        externalGetKey: config
    };
    mergedConfig = mergedConfig || {};
    // Init config
    const { childrenPropName: childrenPropName, externalGetKey: externalGetKey, fieldNames: fieldNames } = mergedConfig;
    const { key: fieldKey, children: fieldChildren } = $f32a159b6ed8d919$export$6c519d302dced239(fieldNames);
    const mergeChildrenPropName = childrenPropName || fieldChildren;
    // Get keys
    let syntheticGetKey;
    if (externalGetKey) {
        if (typeof externalGetKey === 'string') syntheticGetKey = (node)=>node[externalGetKey];
        else if (typeof externalGetKey === 'function') syntheticGetKey = (node)=>externalGetKey(node);
    } else syntheticGetKey = (node, pos)=>$f32a159b6ed8d919$export$a47fb462a08de82f(node[fieldKey], pos);
    // Process
    function processNode(node, index, parent, pathNodes) {
        const children = node ? node[mergeChildrenPropName] : dataNodes;
        const pos = node ? $f32a159b6ed8d919$export$1690e12b840569b9(parent.pos, index) : '0';
        const connectNodes = node ? [
            ...pathNodes,
            node
        ] : [];
        // Process node if is not root
        if (node) {
            const key = syntheticGetKey(node, pos);
            const data = {
                node: node,
                index: index,
                pos: pos,
                key: key,
                parentPos: parent.node ? parent.pos : null,
                level: parent.level + 1,
                nodes: connectNodes
            };
            callback(data);
        }
        // Process children node
        if (children) children.forEach((subNode, subIndex)=>{
            processNode(subNode, subIndex, {
                node: node,
                pos: pos,
                level: parent ? parent.level + 1 : -1
            }, connectNodes);
        });
    }
    processNode(null);
}
function $f32a159b6ed8d919$export$e5d831ce033a4615(dataNodes, { initWrapper: initWrapper, processEntity: processEntity, onProcessFinished: onProcessFinished, externalGetKey: externalGetKey, childrenPropName: childrenPropName, fieldNames: fieldNames } = {}, /** @deprecated Use `config.externalGetKey` instead */ legacyExternalGetKey) {
    // Init config
    const mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
    const posEntities = {};
    const keyEntities = {};
    let wrapper = {
        posEntities: posEntities,
        keyEntities: keyEntities
    };
    if (initWrapper) wrapper = initWrapper(wrapper) || wrapper;
    $f32a159b6ed8d919$export$4b2e27469b557f9d(dataNodes, (item)=>{
        const { node: node, index: index, pos: pos, key: key, parentPos: parentPos, level: level, nodes: nodes } = item;
        const entity = {
            node: node,
            nodes: nodes,
            index: index,
            key: key,
            pos: pos,
            level: level
        };
        const mergedKey = $f32a159b6ed8d919$export$a47fb462a08de82f(key, pos);
        posEntities[pos] = entity;
        keyEntities[mergedKey] = entity;
        // Fill children
        entity.parent = posEntities[parentPos];
        if (entity.parent) {
            entity.parent.children = entity.parent.children || [];
            entity.parent.children.push(entity);
        }
        if (processEntity) processEntity(entity, wrapper);
    }, {
        externalGetKey: mergedExternalGetKey,
        childrenPropName: childrenPropName,
        fieldNames: fieldNames
    });
    if (onProcessFinished) onProcessFinished(wrapper);
    return wrapper;
}
function $f32a159b6ed8d919$export$d961fd523a514db5(key, { expandedKeys: expandedKeys, selectedKeys: selectedKeys, loadedKeys: loadedKeys, loadingKeys: loadingKeys, checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys, dragOverNodeKey: dragOverNodeKey, dropPosition: dropPosition, keyEntities: keyEntities }) {
    const entity = (0, $a8a325450e627f23$export$2e2bcd8739ae039)(keyEntities, key);
    const treeNodeProps = {
        eventKey: key,
        expanded: expandedKeys.indexOf(key) !== -1,
        selected: selectedKeys.indexOf(key) !== -1,
        loaded: loadedKeys.indexOf(key) !== -1,
        loading: loadingKeys.indexOf(key) !== -1,
        checked: checkedKeys.indexOf(key) !== -1,
        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
        pos: String(entity ? entity.pos : ''),
        // [Legacy] Drag props
        // Since the interaction of drag is changed, the semantic of the props are
        // not accuracy, I think it should be finally removed
        dragOver: dragOverNodeKey === key && dropPosition === 0,
        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
    };
    return treeNodeProps;
}
function $f32a159b6ed8d919$export$7bd1b0fd4a8b540b(props) {
    const { data: data, expanded: expanded, selected: selected, checked: checked, loaded: loaded, loading: loading, halfChecked: halfChecked, dragOver: dragOver, dragOverGapTop: dragOverGapTop, dragOverGapBottom: dragOverGapBottom, pos: pos, active: active, eventKey: eventKey } = props;
    const eventData = {
        ...data,
        expanded: expanded,
        selected: selected,
        checked: checked,
        loaded: loaded,
        loading: loading,
        halfChecked: halfChecked,
        dragOver: dragOver,
        dragOverGapTop: dragOverGapTop,
        dragOverGapBottom: dragOverGapBottom,
        pos: pos,
        active: active,
        key: eventKey
    };
    if (!('props' in eventData)) Object.defineProperty(eventData, 'props', {
        get () {
            (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, 'Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.');
            return props;
        }
    });
    return eventData;
}


function $6784b3f679540467$var$_extends() {
    $6784b3f679540467$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6784b3f679540467$var$_extends.apply(this, arguments);
}
const $6784b3f679540467$var$ICON_OPEN = 'open';
const $6784b3f679540467$var$ICON_CLOSE = 'close';
const $6784b3f679540467$var$defaultTitle = '---';
const $6784b3f679540467$var$TreeNode = (props)=>{
    const { eventKey: eventKey, className: className, style: style, dragOver: dragOver, dragOverGapTop: dragOverGapTop, dragOverGapBottom: dragOverGapBottom, isLeaf: isLeaf, isStart: isStart, isEnd: isEnd, expanded: expanded, selected: selected, checked: checked, halfChecked: halfChecked, loading: loading, domRef: domRef, active: active, data: data, onMouseMove: onMouseMove, selectable: selectable, ...otherProps } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $a5b41eab03e0c7d7$export$dfae7d399eea2568));
    const { classNames: treeClassNames, styles: styles } = context || {};
    const unstableContext = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $a5b41eab03e0c7d7$export$e508d6f1a100e5dd));
    const selectHandleRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    const [dragNodeHighlight, setDragNodeHighlight] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(false);
    // ======= State: Disabled State =======
    const isDisabled = !!(context.disabled || props.disabled || unstableContext.nodeDisabled?.(data));
    const isCheckable = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        // Return false if tree or treeNode is not checkable
        if (!context.checkable || props.checkable === false) return false;
        return context.checkable;
    }, [
        context.checkable,
        props.checkable
    ]);
    // ======= Event Handlers: Selection and Check =======
    const onSelect = (e)=>{
        if (isDisabled) return;
        context.onNodeSelect(e, (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(props));
    };
    const onCheck = (e)=>{
        if (isDisabled) return;
        if (!isCheckable || props.disableCheckbox) return;
        context.onNodeCheck(e, (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(props), !checked);
    };
    // ======= State: Selectable Check =======
    const isSelectable = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        // Ignore when selectable is undefined or null
        if (typeof selectable === 'boolean') return selectable;
        return context.selectable;
    }, [
        selectable,
        context.selectable
    ]);
    const onSelectorClick = (e)=>{
        // Click trigger before select/check operation
        context.onNodeClick(e, (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(props));
        if (isSelectable) onSelect(e);
        else onCheck(e);
    };
    const onSelectorDoubleClick = (e)=>{
        context.onNodeDoubleClick(e, (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(props));
    };
    const onMouseEnter = (e)=>{
        context.onNodeMouseEnter(e, (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(props));
    };
    const onMouseLeave = (e)=>{
        context.onNodeMouseLeave(e, (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(props));
    };
    const onContextMenu = (e)=>{
        context.onNodeContextMenu(e, (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(props));
    };
    // ======= Drag: Drag Enabled =======
    const isDraggable = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        return !!(context.draggable && (!context.draggable.nodeDraggable || context.draggable.nodeDraggable(data)));
    }, [
        context.draggable,
        data
    ]);
    // ======= Drag: Drag Event Handlers =======
    const onDragStart = (e)=>{
        e.stopPropagation();
        setDragNodeHighlight(true);
        context.onNodeDragStart(e, props);
        try {
            // ie throw error
            // firefox-need-it
            e.dataTransfer.setData('text/plain', '');
        } catch  {
        // empty
        }
    };
    const onDragEnter = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        context.onNodeDragEnter(e, props);
    };
    const onDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        context.onNodeDragOver(e, props);
    };
    const onDragLeave = (e)=>{
        e.stopPropagation();
        context.onNodeDragLeave(e, props);
    };
    const onDragEnd = (e)=>{
        e.stopPropagation();
        setDragNodeHighlight(false);
        context.onNodeDragEnd(e, props);
    };
    const onDrop = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setDragNodeHighlight(false);
        context.onNodeDrop(e, props);
    };
    // ======= Expand: Node Expansion =======
    const onExpand = (e)=>{
        if (loading) return;
        context.onNodeExpand(e, (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(props));
    };
    // ======= State: Has Children =======
    const hasChildren = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        const { children: children } = (0, $a8a325450e627f23$export$2e2bcd8739ae039)(context.keyEntities, eventKey) || {};
        return Boolean((children || []).length);
    }, [
        context.keyEntities,
        eventKey
    ]);
    // ======= State: Leaf Check =======
    const memoizedIsLeaf = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        if (isLeaf === false) return false;
        return isLeaf || !context.loadData && !hasChildren || context.loadData && props.loaded && !hasChildren;
    }, [
        isLeaf,
        context.loadData,
        hasChildren,
        props.loaded
    ]);
    // ============== Effect ==============
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(()=>{
        // Load data to avoid default expanded tree without data
        if (loading) return;
        // read from state to avoid loadData at same time
        if (typeof context.loadData === 'function' && expanded && !memoizedIsLeaf && !props.loaded) // We needn't reload data when has children in sync logic
        // It's only needed in node expanded
        context.onNodeLoad((0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(props));
    }, [
        loading,
        context.loadData,
        context.onNodeLoad,
        expanded,
        memoizedIsLeaf,
        props
    ]);
    // ==================== Render: Drag Handler ====================
    const dragHandlerNode = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        if (!context.draggable?.icon) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            className: `${context.prefixCls}-draggable-icon`
        }, context.draggable.icon);
    }, [
        context.draggable
    ]);
    // ====================== Render: Switcher ======================
    const renderSwitcherIconDom = (isInternalLeaf)=>{
        const switcherIcon = props.switcherIcon || context.switcherIcon;
        // if switcherIconDom is null, no render switcher span
        if (typeof switcherIcon === 'function') return switcherIcon({
            ...props,
            isLeaf: isInternalLeaf
        });
        return switcherIcon;
    };
    // Switcher
    const renderSwitcher = ()=>{
        if (memoizedIsLeaf) {
            // if switcherIconDom is null, no render switcher span
            const switcherIconDom = renderSwitcherIconDom(true);
            return switcherIconDom !== false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${context.prefixCls}-switcher`, `${context.prefixCls}-switcher-noop`)
            }, switcherIconDom) : null;
        }
        const switcherIconDom = renderSwitcherIconDom(false);
        return switcherIconDom !== false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            onClick: onExpand,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${context.prefixCls}-switcher`, `${context.prefixCls}-switcher_${expanded ? $6784b3f679540467$var$ICON_OPEN : $6784b3f679540467$var$ICON_CLOSE}`)
        }, switcherIconDom) : null;
    };
    // ====================== Checkbox ======================
    const checkboxNode = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        if (!isCheckable) return null;
        // [Legacy] Custom element should be separate with `checkable` in future
        const $custom = typeof isCheckable !== 'boolean' ? isCheckable : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${context.prefixCls}-checkbox`, {
                [`${context.prefixCls}-checkbox-checked`]: checked,
                [`${context.prefixCls}-checkbox-indeterminate`]: !checked && halfChecked,
                [`${context.prefixCls}-checkbox-disabled`]: isDisabled || props.disableCheckbox
            }),
            onClick: onCheck,
            role: "checkbox",
            "aria-checked": halfChecked ? 'mixed' : checked,
            "aria-disabled": isDisabled || props.disableCheckbox,
            "aria-label": `Select ${typeof props.title === 'string' ? props.title : 'tree node'}`
        }, $custom);
    }, [
        isCheckable,
        checked,
        halfChecked,
        isDisabled,
        props.disableCheckbox,
        props.title
    ]);
    // ============== State: Node State (Open/Close) ==============
    const nodeState = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        if (memoizedIsLeaf) return null;
        return expanded ? $6784b3f679540467$var$ICON_OPEN : $6784b3f679540467$var$ICON_CLOSE;
    }, [
        memoizedIsLeaf,
        expanded
    ]);
    // ==================== Render: Title + Icon ====================
    const iconNode = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(treeClassNames?.itemIcon, `${context.prefixCls}-iconEle`, `${context.prefixCls}-icon__${nodeState || 'docu'}`, {
                [`${context.prefixCls}-icon_loading`]: loading
            }),
            style: styles?.itemIcon
        });
    }, [
        context.prefixCls,
        nodeState,
        loading
    ]);
    // =================== Drop Indicator ===================
    const dropIndicatorNode = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        const rootDraggable = Boolean(context.draggable);
        // allowDrop is calculated in Tree.tsx, there is no need for calc it here
        const showIndicator = !props.disabled && rootDraggable && context.dragOverNodeKey === eventKey;
        if (!showIndicator) return null;
        return context.dropIndicatorRender({
            dropPosition: context.dropPosition,
            dropLevelOffset: context.dropLevelOffset,
            indent: context.indent,
            prefixCls: context.prefixCls,
            direction: context.direction
        });
    }, [
        context.dropPosition,
        context.dropLevelOffset,
        context.indent,
        context.prefixCls,
        context.direction,
        context.draggable,
        context.dragOverNodeKey,
        context.dropIndicatorRender
    ]);
    // Icon + Title
    const selectorNode = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        const { title: title = $6784b3f679540467$var$defaultTitle } = props;
        const wrapClass = `${context.prefixCls}-node-content-wrapper`;
        // Icon - Still show loading icon when loading without showIcon
        let $icon;
        if (context.showIcon) {
            const currentIcon = props.icon || context.icon;
            $icon = currentIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(treeClassNames?.itemIcon, `${context.prefixCls}-iconEle`, `${context.prefixCls}-icon__customize`),
                style: styles?.itemIcon
            }, typeof currentIcon === 'function' ? currentIcon(props) : currentIcon) : iconNode;
        } else if (context.loadData && loading) $icon = iconNode;
        // Title
        let titleNode;
        if (typeof title === 'function') titleNode = title(data);
        else if (context.titleRender) titleNode = context.titleRender(data);
        else titleNode = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            ref: selectHandleRef,
            title: typeof title === 'string' ? title : '',
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(wrapClass, `${wrapClass}-${nodeState || 'normal'}`, {
                [`${context.prefixCls}-node-selected`]: !isDisabled && (selected || dragNodeHighlight)
            }),
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onContextMenu: onContextMenu,
            onClick: onSelectorClick,
            onDoubleClick: onSelectorDoubleClick
        }, $icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${context.prefixCls}-title`, treeClassNames?.itemTitle),
            style: styles?.itemTitle
        }, titleNode), dropIndicatorNode);
    }, [
        context.prefixCls,
        context.showIcon,
        props,
        context.icon,
        iconNode,
        context.titleRender,
        data,
        nodeState,
        onMouseEnter,
        onMouseLeave,
        onContextMenu,
        onSelectorClick,
        onSelectorDoubleClick
    ]);
    const dataOrAriaAttributeProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(otherProps, {
        aria: true,
        data: true
    });
    const { level: level } = (0, $a8a325450e627f23$export$2e2bcd8739ae039)(context.keyEntities, eventKey) || {};
    const isEndNode = isEnd[isEnd.length - 1];
    const draggableWithoutDisabled = !isDisabled && isDraggable;
    const dragging = context.draggingNodeKey === eventKey;
    const ariaSelected = selectable !== undefined ? {
        'aria-selected': !!selectable
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", $6784b3f679540467$var$_extends({
        ref: domRef,
        role: "treeitem",
        "aria-expanded": isLeaf ? undefined : expanded,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(className, `${context.prefixCls}-treenode`, treeClassNames?.item, {
            [`${context.prefixCls}-treenode-disabled`]: isDisabled,
            [`${context.prefixCls}-treenode-switcher-${expanded ? 'open' : 'close'}`]: !isLeaf,
            [`${context.prefixCls}-treenode-checkbox-checked`]: checked,
            [`${context.prefixCls}-treenode-checkbox-indeterminate`]: halfChecked,
            [`${context.prefixCls}-treenode-selected`]: selected,
            [`${context.prefixCls}-treenode-loading`]: loading,
            [`${context.prefixCls}-treenode-active`]: active,
            [`${context.prefixCls}-treenode-leaf-last`]: isEndNode,
            [`${context.prefixCls}-treenode-draggable`]: isDraggable,
            dragging: dragging,
            'drop-target': context.dropTargetKey === eventKey,
            'drop-container': context.dropContainerKey === eventKey,
            'drag-over': !isDisabled && dragOver,
            'drag-over-gap-top': !isDisabled && dragOverGapTop,
            'drag-over-gap-bottom': !isDisabled && dragOverGapBottom,
            'filter-node': context.filterTreeNode?.((0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(props)),
            [`${context.prefixCls}-treenode-leaf`]: memoizedIsLeaf
        }),
        style: {
            ...style,
            ...styles?.item
        },
        draggable: draggableWithoutDisabled,
        onDragStart: draggableWithoutDisabled ? onDragStart : undefined,
        onDragEnter: isDraggable ? onDragEnter : undefined,
        onDragOver: isDraggable ? onDragOver : undefined,
        onDragLeave: isDraggable ? onDragLeave : undefined,
        onDrop: isDraggable ? onDrop : undefined,
        onDragEnd: isDraggable ? onDragEnd : undefined,
        onMouseMove: onMouseMove
    }, ariaSelected, dataOrAriaAttributeProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $2ab704cde12fe9ed$export$2e2bcd8739ae039), {
        prefixCls: context.prefixCls,
        level: level,
        isStart: isStart,
        isEnd: isEnd
    }), dragHandlerNode, renderSwitcher(), checkboxNode, selectorNode);
};
$6784b3f679540467$var$TreeNode.isTreeNode = 1;
var $6784b3f679540467$export$2e2bcd8739ae039 = $6784b3f679540467$var$TreeNode;



var $ltGt3 = parcelRequire("ltGt3");

/**
 * Trigger only when component unmount
 */ function $0aa06e66e0eee0fd$var$useUnmount(triggerStart, triggerEnd) {
    const [firstMount, setFirstMount] = $ltGt3.useState(false);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (firstMount) {
            triggerStart();
            return ()=>{
                triggerEnd();
            };
        }
    }, [
        firstMount
    ]);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        setFirstMount(true);
        return ()=>{
            setFirstMount(false);
        };
    }, []);
}
var $0aa06e66e0eee0fd$export$2e2bcd8739ae039 = $0aa06e66e0eee0fd$var$useUnmount;



function $f6b516d0986362aa$var$_extends() {
    $f6b516d0986362aa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f6b516d0986362aa$var$_extends.apply(this, arguments);
}
const $f6b516d0986362aa$var$MotionTreeNode = /*#__PURE__*/ $ltGt3.forwardRef((oriProps, ref)=>{
    const { className: className, style: style, motion: motion, motionNodes: motionNodes, motionType: motionType, onMotionStart: onOriginMotionStart, onMotionEnd: onOriginMotionEnd, active: active, treeNodeRequiredProps: treeNodeRequiredProps, ...props } = oriProps;
    const [visible, setVisible] = $ltGt3.useState(true);
    const { prefixCls: prefixCls } = $ltGt3.useContext((0, $a5b41eab03e0c7d7$export$dfae7d399eea2568));
    // Calculate target visible here.
    // And apply in effect to make `leave` motion work.
    const targetVisible = motionNodes && motionType !== 'hide';
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (motionNodes) {
            if (targetVisible !== visible) setVisible(targetVisible);
        }
    }, [
        motionNodes
    ]);
    const triggerMotionStart = ()=>{
        if (motionNodes) onOriginMotionStart();
    };
    // Should only trigger once
    const triggerMotionEndRef = $ltGt3.useRef(false);
    const triggerMotionEnd = ()=>{
        if (motionNodes && !triggerMotionEndRef.current) {
            triggerMotionEndRef.current = true;
            onOriginMotionEnd();
        }
    };
    // Effect if unmount
    (0, $0aa06e66e0eee0fd$export$2e2bcd8739ae039)(triggerMotionStart, triggerMotionEnd);
    // Motion end event
    const onVisibleChanged = (nextVisible)=>{
        if (targetVisible === nextVisible) triggerMotionEnd();
    };
    if (motionNodes) return /*#__PURE__*/ $ltGt3.createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), $f6b516d0986362aa$var$_extends({
        ref: ref,
        visible: visible
    }, motion, {
        motionAppear: motionType === 'show',
        onVisibleChanged: onVisibleChanged
    }), ({ className: motionClassName, style: motionStyle }, motionRef)=>/*#__PURE__*/ $ltGt3.createElement("div", {
            ref: motionRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-treenode-motion`, motionClassName),
            style: motionStyle
        }, motionNodes.map((treeNode)=>{
            const { data: { ...restProps }, title: title, key: key, isStart: isStart, isEnd: isEnd } = treeNode;
            delete restProps.children;
            const treeNodeProps = (0, $f32a159b6ed8d919$export$d961fd523a514db5)(key, treeNodeRequiredProps);
            return /*#__PURE__*/ $ltGt3.createElement((0, $6784b3f679540467$export$2e2bcd8739ae039), $f6b516d0986362aa$var$_extends({}, restProps, treeNodeProps, {
                title: title,
                active: active,
                data: treeNode.data,
                key: key,
                isStart: isStart,
                isEnd: isEnd
            }));
        })));
    return /*#__PURE__*/ $ltGt3.createElement((0, $6784b3f679540467$export$2e2bcd8739ae039), $f6b516d0986362aa$var$_extends({
        domRef: ref,
        className: className,
        style: style
    }, props, {
        active: active
    }));
});
var $f6b516d0986362aa$export$2e2bcd8739ae039 = $f6b516d0986362aa$var$MotionTreeNode;


function $9f1dfbe9147450ae$export$d561f9b5d6be9236(prev = [], next = []) {
    const prevLen = prev.length;
    const nextLen = next.length;
    if (Math.abs(prevLen - nextLen) !== 1) return {
        add: false,
        key: null
    };
    function find(shorter, longer) {
        const cache = new Map();
        shorter.forEach((key)=>{
            cache.set(key, true);
        });
        const keys = longer.filter((key)=>!cache.has(key));
        return keys.length === 1 ? keys[0] : null;
    }
    if (prevLen < nextLen) return {
        add: true,
        key: find(prev, next)
    };
    return {
        add: false,
        key: find(next, prev)
    };
}
function $9f1dfbe9147450ae$export$d9cfb1169163442d(shorter, longer, key) {
    const shorterStartIndex = shorter.findIndex((data)=>data.key === key);
    const shorterEndNode = shorter[shorterStartIndex + 1];
    const longerStartIndex = longer.findIndex((data)=>data.key === key);
    if (shorterEndNode) {
        const longerEndIndex = longer.findIndex((data)=>data.key === shorterEndNode.key);
        return longer.slice(longerStartIndex + 1, longerEndIndex);
    }
    return longer.slice(longerStartIndex + 1);
}



function $e5b729c6cdd34c90$var$_extends() {
    $e5b729c6cdd34c90$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e5b729c6cdd34c90$var$_extends.apply(this, arguments);
}
const $e5b729c6cdd34c90$var$HIDDEN_STYLE = {
    width: 0,
    height: 0,
    display: 'flex',
    overflow: 'hidden',
    opacity: 0,
    border: 0,
    padding: 0,
    margin: 0
};
const $e5b729c6cdd34c90$var$noop = ()=>{};
const $e5b729c6cdd34c90$export$17c02cdd52a7d889 = `RC_TREE_MOTION_${Math.random()}`;
const $e5b729c6cdd34c90$var$MotionNode = {
    key: $e5b729c6cdd34c90$export$17c02cdd52a7d889
};
const $e5b729c6cdd34c90$export$2d18abad5109a402 = {
    key: $e5b729c6cdd34c90$export$17c02cdd52a7d889,
    level: 0,
    index: 0,
    pos: '0',
    node: $e5b729c6cdd34c90$var$MotionNode,
    nodes: [
        $e5b729c6cdd34c90$var$MotionNode
    ]
};
const $e5b729c6cdd34c90$var$MotionFlattenData = {
    parent: null,
    children: [],
    pos: $e5b729c6cdd34c90$export$2d18abad5109a402.pos,
    data: $e5b729c6cdd34c90$var$MotionNode,
    title: null,
    key: $e5b729c6cdd34c90$export$17c02cdd52a7d889,
    /** Hold empty list here since we do not use it */ isStart: [],
    isEnd: []
};
function $e5b729c6cdd34c90$export$435bacc8d7a01e14(list, virtual, height, itemHeight) {
    if (virtual === false || !height) return list;
    return list.slice(0, Math.ceil(height / itemHeight) + 1);
}
function $e5b729c6cdd34c90$var$itemKey(item) {
    const { key: key, pos: pos } = item;
    return (0, $f32a159b6ed8d919$export$a47fb462a08de82f)(key, pos);
}
function $e5b729c6cdd34c90$var$getAccessibilityPath(item) {
    let path = String(item.data.key);
    let current = item;
    while(current.parent){
        current = current.parent;
        path = `${current.data.key} > ${path}`;
    }
    return path;
}
const $e5b729c6cdd34c90$var$NodeList = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, data: data, selectable: selectable, checkable: checkable, expandedKeys: expandedKeys, selectedKeys: selectedKeys, checkedKeys: checkedKeys, loadedKeys: loadedKeys, loadingKeys: loadingKeys, halfCheckedKeys: halfCheckedKeys, keyEntities: keyEntities, disabled: disabled, dragging: dragging, dragOverNodeKey: dragOverNodeKey, dropPosition: dropPosition, motion: motion, height: height, itemHeight: itemHeight, virtual: virtual, scrollWidth: scrollWidth, focusable: focusable, activeItem: activeItem, focused: focused, tabIndex: tabIndex, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onActiveChange: onActiveChange, onListChangeStart: onListChangeStart, onListChangeEnd: onListChangeEnd, ...domProps } = props;
    // =============================== Ref ================================
    const listRef = $ltGt3.useRef(null);
    const indentMeasurerRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, ()=>({
            scrollTo: (scroll)=>{
                listRef.current.scrollTo(scroll);
            },
            getIndentWidth: ()=>indentMeasurerRef.current.offsetWidth
        }));
    // ============================== Motion ==============================
    const [prevExpandedKeys, setPrevExpandedKeys] = $ltGt3.useState(expandedKeys);
    const [prevData, setPrevData] = $ltGt3.useState(data);
    const [transitionData, setTransitionData] = $ltGt3.useState(data);
    const [transitionRange, setTransitionRange] = $ltGt3.useState([]);
    const [motionType, setMotionType] = $ltGt3.useState(null);
    // When motion end but data change, this will makes data back to previous one
    const dataRef = $ltGt3.useRef(data);
    dataRef.current = data;
    function onMotionEnd() {
        const latestData = dataRef.current;
        setPrevData(latestData);
        setTransitionData(latestData);
        setTransitionRange([]);
        setMotionType(null);
        onListChangeEnd();
    }
    // Do animation if expanded keys changed
    // layoutEffect here to avoid blink of node removing
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        setPrevExpandedKeys(expandedKeys);
        const diffExpanded = (0, $9f1dfbe9147450ae$export$d561f9b5d6be9236)(prevExpandedKeys, expandedKeys);
        if (diffExpanded.key !== null) {
            if (diffExpanded.add) {
                const keyIndex = prevData.findIndex(({ key: key })=>key === diffExpanded.key);
                const rangeNodes = $e5b729c6cdd34c90$export$435bacc8d7a01e14((0, $9f1dfbe9147450ae$export$d9cfb1169163442d)(prevData, data, diffExpanded.key), virtual, height, itemHeight);
                const newTransitionData = prevData.slice();
                newTransitionData.splice(keyIndex + 1, 0, $e5b729c6cdd34c90$var$MotionFlattenData);
                setTransitionData(newTransitionData);
                setTransitionRange(rangeNodes);
                setMotionType('show');
            } else {
                const keyIndex = data.findIndex(({ key: key })=>key === diffExpanded.key);
                const rangeNodes = $e5b729c6cdd34c90$export$435bacc8d7a01e14((0, $9f1dfbe9147450ae$export$d9cfb1169163442d)(data, prevData, diffExpanded.key), virtual, height, itemHeight);
                const newTransitionData = data.slice();
                newTransitionData.splice(keyIndex + 1, 0, $e5b729c6cdd34c90$var$MotionFlattenData);
                setTransitionData(newTransitionData);
                setTransitionRange(rangeNodes);
                setMotionType('hide');
            }
        } else if (prevData !== data) {
            // If whole data changed, we just refresh the list
            setPrevData(data);
            setTransitionData(data);
        }
    }, [
        expandedKeys,
        data
    ]);
    // We should clean up motion if is changed by dragging
    $ltGt3.useEffect(()=>{
        if (!dragging) onMotionEnd();
    }, [
        dragging
    ]);
    const mergedData = motion ? transitionData : data;
    const treeNodeRequiredProps = {
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        loadedKeys: loadedKeys,
        loadingKeys: loadingKeys,
        checkedKeys: checkedKeys,
        halfCheckedKeys: halfCheckedKeys,
        dragOverNodeKey: dragOverNodeKey,
        dropPosition: dropPosition,
        keyEntities: keyEntities
    };
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, focused && activeItem && /*#__PURE__*/ $ltGt3.createElement("span", {
        style: $e5b729c6cdd34c90$var$HIDDEN_STYLE,
        "aria-live": "assertive"
    }, $e5b729c6cdd34c90$var$getAccessibilityPath(activeItem)), /*#__PURE__*/ $ltGt3.createElement("div", null, /*#__PURE__*/ $ltGt3.createElement("input", {
        style: $e5b729c6cdd34c90$var$HIDDEN_STYLE,
        disabled: focusable === false || disabled,
        tabIndex: focusable !== false ? tabIndex : null,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        value: "",
        onChange: $e5b729c6cdd34c90$var$noop,
        "aria-label": "for screen reader"
    })), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-treenode`,
        "aria-hidden": true,
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            visibility: 'hidden',
            height: 0,
            overflow: 'hidden',
            border: 0,
            padding: 0
        }
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-indent`
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: indentMeasurerRef,
        className: `${prefixCls}-indent-unit`
    }))), /*#__PURE__*/ $ltGt3.createElement((0, $8ef74e3e8155f759$export$2e2bcd8739ae039), $e5b729c6cdd34c90$var$_extends({}, domProps, {
        data: mergedData,
        itemKey: $e5b729c6cdd34c90$var$itemKey,
        height: height,
        fullHeight: false,
        virtual: virtual,
        itemHeight: itemHeight,
        scrollWidth: scrollWidth,
        prefixCls: `${prefixCls}-list`,
        ref: listRef,
        role: "tree",
        onVisibleChange: (originList)=>{
            // The best match is using `fullList` - `originList` = `restList`
            // and check the `restList` to see if has the MOTION_KEY node
            // but this will cause performance issue for long list compare
            // we just check `originList` and repeat trigger `onMotionEnd`
            if (originList.every((item)=>$e5b729c6cdd34c90$var$itemKey(item) !== $e5b729c6cdd34c90$export$17c02cdd52a7d889)) onMotionEnd();
        }
    }), (treeNode)=>{
        const { pos: pos, data: { ...restProps }, title: title, key: key, isStart: isStart, isEnd: isEnd } = treeNode;
        const mergedKey = (0, $f32a159b6ed8d919$export$a47fb462a08de82f)(key, pos);
        delete restProps.key;
        delete restProps.children;
        const treeNodeProps = (0, $f32a159b6ed8d919$export$d961fd523a514db5)(mergedKey, treeNodeRequiredProps);
        return /*#__PURE__*/ $ltGt3.createElement((0, $f6b516d0986362aa$export$2e2bcd8739ae039), $e5b729c6cdd34c90$var$_extends({}, restProps, treeNodeProps, {
            title: title,
            active: !!activeItem && key === activeItem.key,
            pos: pos,
            data: treeNode.data,
            isStart: isStart,
            isEnd: isEnd,
            motion: motion,
            motionNodes: key === $e5b729c6cdd34c90$export$17c02cdd52a7d889 ? transitionRange : null,
            motionType: motionType,
            onMotionStart: onListChangeStart,
            onMotionEnd: onMotionEnd,
            treeNodeRequiredProps: treeNodeRequiredProps,
            onMouseMove: ()=>{
                onActiveChange(null);
            }
        }));
    }));
});
var $e5b729c6cdd34c90$export$2e2bcd8739ae039 = $e5b729c6cdd34c90$var$NodeList;





var $ltGt3 = parcelRequire("ltGt3");



function $e9e424090bbd8d70$var$_extends() {
    $e9e424090bbd8d70$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e9e424090bbd8d70$var$_extends.apply(this, arguments);
}
function $e9e424090bbd8d70$export$5bfb9ff497fe2298(list, value) {
    if (!list) return [];
    const clone = list.slice();
    const index = clone.indexOf(value);
    if (index >= 0) clone.splice(index, 1);
    return clone;
}
function $e9e424090bbd8d70$export$10663f6bbd2fd717(list, value) {
    const clone = (list || []).slice();
    if (clone.indexOf(value) === -1) clone.push(value);
    return clone;
}
function $e9e424090bbd8d70$export$ddaee97dc8907312(pos) {
    return pos.split('-');
}
function $e9e424090bbd8d70$export$b0610c44bcbb051c(dragNodeKey, keyEntities) {
    // not contains self
    // self for left or right drag
    const dragChildrenKeys = [];
    const entity = (0, $a8a325450e627f23$export$2e2bcd8739ae039)(keyEntities, dragNodeKey);
    function dig(list = []) {
        list.forEach(({ key: key, children: children })=>{
            dragChildrenKeys.push(key);
            dig(children);
        });
    }
    dig(entity.children);
    return dragChildrenKeys;
}
function $e9e424090bbd8d70$export$a9933931a4af6704(treeNodeEntity) {
    if (treeNodeEntity.parent) {
        const posArr = $e9e424090bbd8d70$export$ddaee97dc8907312(treeNodeEntity.pos);
        return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
    }
    return false;
}
function $e9e424090bbd8d70$export$b823688e4155eb8d(treeNodeEntity) {
    const posArr = $e9e424090bbd8d70$export$ddaee97dc8907312(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === 0;
}
function $e9e424090bbd8d70$export$78a5519d0fb779c3(event, dragNodeProps, targetNodeProps, indent, startMousePosition, allowDrop, flattenedNodes, keyEntities, expandKeys, direction) {
    const { clientX: clientX, clientY: clientY } = event;
    const { top: top, height: height } = event.target.getBoundingClientRect();
    // optional chain for testing
    const horizontalMouseOffset = (direction === 'rtl' ? -1 : 1) * ((startMousePosition?.x || 0) - clientX);
    const rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;
    // Filter the expanded keys to exclude the node that not has children currently (like async nodes).
    const filteredExpandKeys = expandKeys.filter((key)=>keyEntities[key]?.children?.length);
    // find abstract drop node by horizontal offset
    let abstractDropNodeEntity = (0, $a8a325450e627f23$export$2e2bcd8739ae039)(keyEntities, targetNodeProps.eventKey);
    if (clientY < top + height / 2) {
        // first half, set abstract drop node to previous node
        const nodeIndex = flattenedNodes.findIndex((flattenedNode)=>flattenedNode.key === abstractDropNodeEntity.key);
        const prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
        const prevNodeKey = flattenedNodes[prevNodeIndex].key;
        abstractDropNodeEntity = (0, $a8a325450e627f23$export$2e2bcd8739ae039)(keyEntities, prevNodeKey);
    }
    const initialAbstractDropNodeKey = abstractDropNodeEntity.key;
    const abstractDragOverEntity = abstractDropNodeEntity;
    const dragOverNodeKey = abstractDropNodeEntity.key;
    let dropPosition = 0;
    let dropLevelOffset = 0;
    // Only allow cross level drop when dragging on a non-expanded node
    if (!filteredExpandKeys.includes(initialAbstractDropNodeKey)) for(let i = 0; i < rawDropLevelOffset; i += 1){
        if ($e9e424090bbd8d70$export$a9933931a4af6704(abstractDropNodeEntity)) {
            abstractDropNodeEntity = abstractDropNodeEntity.parent;
            dropLevelOffset += 1;
        } else break;
    }
    const abstractDragDataNode = dragNodeProps.data;
    const abstractDropDataNode = abstractDropNodeEntity.node;
    let dropAllowed = true;
    if ($e9e424090bbd8d70$export$b823688e4155eb8d(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: -1
    }) && abstractDropNodeEntity.key === targetNodeProps.eventKey) // first half of first node in first level
    dropPosition = -1;
    else if ((abstractDragOverEntity.children || []).length && filteredExpandKeys.includes(dragOverNodeKey)) {
        // drop on expanded node
        // only allow drop inside
        if (allowDrop({
            dragNode: abstractDragDataNode,
            dropNode: abstractDropDataNode,
            dropPosition: 0
        })) dropPosition = 0;
        else dropAllowed = false;
    } else if (dropLevelOffset === 0) {
        if (rawDropLevelOffset > -1.5) {
            // | Node     | <- abstractDropNode
            // | -^-===== | <- mousePosition
            // 1. try drop after
            // 2. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        } else {
            // | Node     | <- abstractDropNode
            // | ---==^== | <- mousePosition
            // whether it has children or doesn't has children
            // always
            // 1. try drop inside
            // 2. try drop after
            // 3. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 0
            })) dropPosition = 0;
            else if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        }
    } else // | Node1 | <- abstractDropNode
    //      |  Node2  |
    // --^--|----=====| <- mousePosition
    // 1. try insert after Node1
    // 2. do not allow drop
    if (allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
    })) dropPosition = 1;
    else dropAllowed = false;
    return {
        dropPosition: dropPosition,
        dropLevelOffset: dropLevelOffset,
        dropTargetKey: abstractDropNodeEntity.key,
        dropTargetPos: abstractDropNodeEntity.pos,
        dragOverNodeKey: dragOverNodeKey,
        dropContainerKey: dropPosition === 0 ? null : abstractDropNodeEntity.parent?.key || null,
        dropAllowed: dropAllowed
    };
}
function $e9e424090bbd8d70$export$fffc10811828fd68(selectedKeys, props) {
    if (!selectedKeys) return undefined;
    const { multiple: multiple } = props;
    if (multiple) return selectedKeys.slice();
    if (selectedKeys.length) return [
        selectedKeys[0]
    ];
    return selectedKeys;
}
const $e9e424090bbd8d70$var$internalProcessProps = (props)=>props;
function $e9e424090bbd8d70$export$b28621e8354d6749(treeData, processor) {
    if (!treeData) return [];
    const { processProps: processProps = $e9e424090bbd8d70$var$internalProcessProps } = processor || {};
    const list = Array.isArray(treeData) ? treeData : [
        treeData
    ];
    return list.map(({ children: children, ...props })=>{
        const childrenNodes = $e9e424090bbd8d70$export$b28621e8354d6749(children, processor);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $6784b3f679540467$export$2e2bcd8739ae039), $e9e424090bbd8d70$var$_extends({
            key: props.key
        }, processProps(props)), childrenNodes);
    });
}
function $e9e424090bbd8d70$export$29d4989c23990d41(keys) {
    if (!keys) return null;
    // Convert keys to object format
    let keyProps;
    if (Array.isArray(keys)) // [Legacy] Follow the api doc
    keyProps = {
        checkedKeys: keys,
        halfCheckedKeys: undefined
    };
    else if (typeof keys === 'object') keyProps = {
        checkedKeys: keys.checked || undefined,
        halfCheckedKeys: keys.halfChecked || undefined
    };
    else {
        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, '`checkedKeys` is not an array or an object');
        return null;
    }
    return keyProps;
}
function $e9e424090bbd8d70$export$fac4a40c345ccd80(keyList, keyEntities) {
    const expandedKeys = new Set();
    function conductUp(key) {
        if (expandedKeys.has(key)) return;
        const entity = (0, $a8a325450e627f23$export$2e2bcd8739ae039)(keyEntities, key);
        if (!entity) return;
        expandedKeys.add(key);
        const { parent: parent, node: node } = entity;
        if (node.disabled) return;
        if (parent) conductUp(parent.key);
    }
    (keyList || []).forEach((key)=>{
        conductUp(key);
    });
    return [
        ...expandedKeys
    ];
}




function $57a33d03148eb2df$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
    const filteredKeys = new Set();
    halfCheckedKeys.forEach((key)=>{
        if (!checkedKeys.has(key)) filteredKeys.add(key);
    });
    return filteredKeys;
}
function $57a33d03148eb2df$export$ab01c86170b1dea0(node) {
    const { disabled: disabled, disableCheckbox: disableCheckbox, checkable: checkable } = node || {};
    return !!(disabled || disableCheckbox) || checkable === false;
}
// Fill miss keys
function $57a33d03148eb2df$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    const checkedKeys = new Set(keys);
    const halfCheckedKeys = new Set();
    // Add checked keys top to bottom
    for(let level = 0; level <= maxLevel; level += 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { key: key, node: node, children: children = [] } = entity;
            if (checkedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach((childEntity)=>{
                checkedKeys.add(childEntity.key);
            });
        });
    }
    // Add checked keys from bottom to top
    const visitedKeys = new Set();
    for(let level = maxLevel; level >= 0; level -= 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { parent: parent, node: node } = entity;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            let allChecked = true;
            let partialChecked = false;
            (parent.children || []).filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach(({ key: key })=>{
                const checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (allChecked) checkedKeys.add(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($57a33d03148eb2df$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
// Remove useless key
function $57a33d03148eb2df$var$cleanConductCheck(keys, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    const checkedKeys = new Set(keys);
    let halfCheckedKeys = new Set(halfKeys);
    // Remove checked keys from top to bottom
    for(let level = 0; level <= maxLevel; level += 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { key: key, node: node, children: children = [] } = entity;
            if (!checkedKeys.has(key) && !halfCheckedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach((childEntity)=>{
                checkedKeys.delete(childEntity.key);
            });
        });
    }
    // Remove checked keys form bottom to top
    halfCheckedKeys = new Set();
    const visitedKeys = new Set();
    for(let level = maxLevel; level >= 0; level -= 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { parent: parent, node: node } = entity;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            let allChecked = true;
            let partialChecked = false;
            (parent.children || []).filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach(({ key: key })=>{
                const checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (!allChecked) checkedKeys.delete(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($57a33d03148eb2df$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
function $57a33d03148eb2df$export$43adf2c483e3e633(keyList, checked, keyEntities, getCheckDisabled) {
    const warningMissKeys = [];
    let syntheticGetCheckDisabled;
    if (getCheckDisabled) syntheticGetCheckDisabled = getCheckDisabled;
    else syntheticGetCheckDisabled = $57a33d03148eb2df$export$ab01c86170b1dea0;
    // We only handle exist keys
    const keys = new Set(keyList.filter((key)=>{
        const hasEntity = !!(0, $a8a325450e627f23$export$2e2bcd8739ae039)(keyEntities, key);
        if (!hasEntity) warningMissKeys.push(key);
        return hasEntity;
    }));
    const levelEntities = new Map();
    let maxLevel = 0;
    // Convert entities by level for calculation
    Object.keys(keyEntities).forEach((key)=>{
        const entity = keyEntities[key];
        const { level: level } = entity;
        let levelSet = levelEntities.get(level);
        if (!levelSet) {
            levelSet = new Set();
            levelEntities.set(level, levelSet);
        }
        levelSet.add(entity);
        maxLevel = Math.max(maxLevel, level);
    });
    (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!warningMissKeys.length, `Tree missing follow keys: ${warningMissKeys.slice(0, 100).map((key)=>`'${key}'`).join(', ')}`);
    let result;
    if (checked === true) result = $57a33d03148eb2df$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    else result = $57a33d03148eb2df$var$cleanConductCheck(keys, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    return result;
}




function $2a87844f3d67a29c$var$_extends() {
    $2a87844f3d67a29c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2a87844f3d67a29c$var$_extends.apply(this, arguments);
}
const $2a87844f3d67a29c$var$MAX_RETRY_TIMES = 10;
class $2a87844f3d67a29c$var$Tree extends $ltGt3.Component {
    static defaultProps = {
        prefixCls: 'rc-tree',
        showLine: false,
        showIcon: true,
        selectable: true,
        multiple: false,
        checkable: false,
        disabled: false,
        checkStrictly: false,
        draggable: false,
        defaultExpandParent: true,
        autoExpandParent: false,
        defaultExpandAll: false,
        defaultExpandedKeys: [],
        defaultCheckedKeys: [],
        defaultSelectedKeys: [],
        dropIndicatorRender: (0, $954cbaaefa1b7d72$export$2e2bcd8739ae039),
        allowDrop: ()=>true,
        expandAction: false
    };
    static TreeNode = (0, $6784b3f679540467$export$2e2bcd8739ae039);
    destroyed = false;
    delayedDragEnterLogic;
    loadingRetryTimes = {};
    state = {
        keyEntities: {},
        indent: null,
        selectedKeys: [],
        checkedKeys: [],
        halfCheckedKeys: [],
        loadedKeys: [],
        loadingKeys: [],
        expandedKeys: [],
        draggingNodeKey: null,
        dragChildrenKeys: [],
        // dropTargetKey is the key of abstract-drop-node
        // the abstract-drop-node is the real drop node when drag and drop
        // not the DOM drag over node
        dropTargetKey: null,
        dropPosition: null,
        // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
        dropContainerKey: null,
        // the container key of abstract-drop-node if dropPosition is -1 or 1
        dropLevelOffset: null,
        // the drop level offset of abstract-drag-over-node
        dropTargetPos: null,
        // the pos of abstract-drop-node
        dropAllowed: true,
        // if drop to abstract-drop-node is allowed
        // the abstract-drag-over-node
        // if mouse is on the bottom of top dom node or no the top of the bottom dom node
        // abstract-drag-over-node is the top node
        dragOverNodeKey: null,
        treeData: [],
        flattenNodes: [],
        focused: false,
        activeKey: null,
        listChanging: false,
        prevProps: null,
        fieldNames: (0, $f32a159b6ed8d919$export$6c519d302dced239)()
    };
    dragStartMousePosition = null;
    dragNodeProps = null;
    currentMouseOverDroppableNodeKey = null;
    listRef = /*#__PURE__*/ $ltGt3.createRef();
    componentDidMount() {
        this.destroyed = false;
        this.onUpdated();
    }
    componentDidUpdate() {
        this.onUpdated();
    }
    onUpdated() {
        const { activeKey: activeKey, itemScrollOffset: itemScrollOffset = 0 } = this.props;
        if (activeKey !== undefined && activeKey !== this.state.activeKey) {
            this.setState({
                activeKey: activeKey
            });
            if (activeKey !== null) this.scrollTo({
                key: activeKey,
                offset: itemScrollOffset
            });
        }
    }
    componentWillUnmount() {
        window.removeEventListener('dragend', this.onWindowDragEnd);
        this.destroyed = true;
    }
    static getDerivedStateFromProps(props, prevState) {
        const { prevProps: prevProps } = prevState;
        const newState = {
            prevProps: props
        };
        function needSync(name) {
            return !prevProps && props.hasOwnProperty(name) || prevProps && prevProps[name] !== props[name];
        }
        // ================== Tree Node ==================
        let treeData;
        // fieldNames
        let { fieldNames: fieldNames } = prevState;
        if (needSync('fieldNames')) {
            fieldNames = (0, $f32a159b6ed8d919$export$6c519d302dced239)(props.fieldNames);
            newState.fieldNames = fieldNames;
        }
        // Check if `treeData` or `children` changed and save into the state.
        if (needSync('treeData')) ({ treeData: treeData } = props);
        else if (needSync('children')) {
            (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, '`children` of Tree is deprecated. Please use `treeData` instead.');
            treeData = (0, $f32a159b6ed8d919$export$6d8b10995563b669)(props.children);
        }
        // Save flatten nodes info and convert `treeData` into keyEntities
        if (treeData) {
            newState.treeData = treeData;
            const entitiesMap = (0, $f32a159b6ed8d919$export$e5d831ce033a4615)(treeData, {
                fieldNames: fieldNames
            });
            newState.keyEntities = {
                [(0, $e5b729c6cdd34c90$export$17c02cdd52a7d889)]: (0, $e5b729c6cdd34c90$export$2d18abad5109a402),
                ...entitiesMap.keyEntities
            };
        }
        const keyEntities = newState.keyEntities || prevState.keyEntities;
        // ================ expandedKeys =================
        if (needSync('expandedKeys') || prevProps && needSync('autoExpandParent')) newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? (0, $e9e424090bbd8d70$export$fac4a40c345ccd80)(props.expandedKeys, keyEntities) : props.expandedKeys;
        else if (!prevProps && props.defaultExpandAll) {
            const cloneKeyEntities = {
                ...keyEntities
            };
            delete cloneKeyEntities[0, $e5b729c6cdd34c90$export$17c02cdd52a7d889];
            // Only take the key who has the children to enhance the performance
            const nextExpandedKeys = [];
            Object.keys(cloneKeyEntities).forEach((key)=>{
                const entity = cloneKeyEntities[key];
                if (entity.children && entity.children.length) nextExpandedKeys.push(entity.key);
            });
            newState.expandedKeys = nextExpandedKeys;
        } else if (!prevProps && props.defaultExpandedKeys) newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? (0, $e9e424090bbd8d70$export$fac4a40c345ccd80)(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
        if (!newState.expandedKeys) delete newState.expandedKeys;
        // ================ flattenNodes =================
        if (treeData || newState.expandedKeys) {
            const flattenNodes = (0, $f32a159b6ed8d919$export$215c1b4f1ba88b23)(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys, fieldNames);
            newState.flattenNodes = flattenNodes;
        }
        // ================ selectedKeys =================
        if (props.selectable) {
            if (needSync('selectedKeys')) newState.selectedKeys = (0, $e9e424090bbd8d70$export$fffc10811828fd68)(props.selectedKeys, props);
            else if (!prevProps && props.defaultSelectedKeys) newState.selectedKeys = (0, $e9e424090bbd8d70$export$fffc10811828fd68)(props.defaultSelectedKeys, props);
        }
        // ================= checkedKeys =================
        if (props.checkable) {
            let checkedKeyEntity;
            if (needSync('checkedKeys')) checkedKeyEntity = (0, $e9e424090bbd8d70$export$29d4989c23990d41)(props.checkedKeys) || {};
            else if (!prevProps && props.defaultCheckedKeys) checkedKeyEntity = (0, $e9e424090bbd8d70$export$29d4989c23990d41)(props.defaultCheckedKeys) || {};
            else if (treeData) // If `treeData` changed, we also need check it
            checkedKeyEntity = (0, $e9e424090bbd8d70$export$29d4989c23990d41)(props.checkedKeys) || {
                checkedKeys: prevState.checkedKeys,
                halfCheckedKeys: prevState.halfCheckedKeys
            };
            if (checkedKeyEntity) {
                let { checkedKeys: checkedKeys = [], halfCheckedKeys: halfCheckedKeys = [] } = checkedKeyEntity;
                if (!props.checkStrictly) {
                    const conductKeys = (0, $57a33d03148eb2df$export$43adf2c483e3e633)(checkedKeys, true, keyEntities);
                    ({ checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = conductKeys);
                }
                newState.checkedKeys = checkedKeys;
                newState.halfCheckedKeys = halfCheckedKeys;
            }
        }
        // ================= loadedKeys ==================
        if (needSync('loadedKeys')) newState.loadedKeys = props.loadedKeys;
        return newState;
    }
    onNodeDragStart = (event, nodeProps)=>{
        const { expandedKeys: expandedKeys, keyEntities: keyEntities } = this.state;
        const { onDragStart: onDragStart } = this.props;
        const { eventKey: eventKey } = nodeProps;
        this.dragNodeProps = nodeProps;
        this.dragStartMousePosition = {
            x: event.clientX,
            y: event.clientY
        };
        const newExpandedKeys = (0, $e9e424090bbd8d70$export$5bfb9ff497fe2298)(expandedKeys, eventKey);
        this.setState({
            draggingNodeKey: eventKey,
            dragChildrenKeys: (0, $e9e424090bbd8d70$export$b0610c44bcbb051c)(eventKey, keyEntities),
            indent: this.listRef.current.getIndentWidth()
        });
        this.setExpandedKeys(newExpandedKeys);
        window.addEventListener('dragend', this.onWindowDragEnd);
        onDragStart?.({
            event: event,
            node: (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(nodeProps)
        });
    };
    /**
   * [Legacy] Select handler is smaller than node,
   * so that this will trigger when drag enter node or select handler.
   * This is a little tricky if customize css without padding.
   * Better for use mouse move event to refresh drag state.
   * But let's just keep it to avoid event trigger logic change.
   */ onNodeDragEnter = (event, nodeProps)=>{
        const { expandedKeys: expandedKeys, keyEntities: keyEntities, dragChildrenKeys: dragChildrenKeys, flattenNodes: flattenNodes, indent: indent } = this.state;
        const { onDragEnter: onDragEnter, onExpand: onExpand, allowDrop: allowDrop, direction: direction } = this.props;
        const { pos: pos, eventKey: eventKey } = nodeProps;
        // record the key of node which is latest entered, used in dragleave event.
        if (this.currentMouseOverDroppableNodeKey !== eventKey) this.currentMouseOverDroppableNodeKey = eventKey;
        if (!this.dragNodeProps) {
            this.resetDragState();
            return;
        }
        const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, dropTargetKey: dropTargetKey, dropContainerKey: dropContainerKey, dropTargetPos: dropTargetPos, dropAllowed: dropAllowed, dragOverNodeKey: dragOverNodeKey } = (0, $e9e424090bbd8d70$export$78a5519d0fb779c3)(event, this.dragNodeProps, nodeProps, indent, this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction);
        if (// don't allow drop inside its children
        dragChildrenKeys.includes(dropTargetKey) || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !dropAllowed) {
            this.resetDragState();
            return;
        }
        // Side effect for delay drag
        if (!this.delayedDragEnterLogic) this.delayedDragEnterLogic = {};
        Object.keys(this.delayedDragEnterLogic).forEach((key)=>{
            clearTimeout(this.delayedDragEnterLogic[key]);
        });
        if (this.dragNodeProps.eventKey !== nodeProps.eventKey) {
            // hoist expand logic here
            // since if logic is on the bottom
            // it will be blocked by abstract dragover node check
            //   => if you dragenter from top, you mouse will still be consider as in the top node
            event.persist();
            this.delayedDragEnterLogic[pos] = window.setTimeout(()=>{
                if (this.state.draggingNodeKey === null) return;
                let newExpandedKeys = [
                    ...expandedKeys
                ];
                const entity = (0, $a8a325450e627f23$export$2e2bcd8739ae039)(keyEntities, nodeProps.eventKey);
                if (entity && (entity.children || []).length) newExpandedKeys = (0, $e9e424090bbd8d70$export$10663f6bbd2fd717)(expandedKeys, nodeProps.eventKey);
                if (!this.props.hasOwnProperty('expandedKeys')) this.setExpandedKeys(newExpandedKeys);
                onExpand?.(newExpandedKeys, {
                    node: (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(nodeProps),
                    expanded: true,
                    nativeEvent: event.nativeEvent
                });
            }, 800);
        }
        // Skip if drag node is self
        if (this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
            this.resetDragState();
            return;
        }
        // Update drag over node and drag state
        this.setState({
            dragOverNodeKey: dragOverNodeKey,
            dropPosition: dropPosition,
            dropLevelOffset: dropLevelOffset,
            dropTargetKey: dropTargetKey,
            dropContainerKey: dropContainerKey,
            dropTargetPos: dropTargetPos,
            dropAllowed: dropAllowed
        });
        onDragEnter?.({
            event: event,
            node: (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(nodeProps),
            expandedKeys: expandedKeys
        });
    };
    onNodeDragOver = (event, nodeProps)=>{
        const { dragChildrenKeys: dragChildrenKeys, flattenNodes: flattenNodes, keyEntities: keyEntities, expandedKeys: expandedKeys, indent: indent } = this.state;
        const { onDragOver: onDragOver, allowDrop: allowDrop, direction: direction } = this.props;
        if (!this.dragNodeProps) return;
        const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, dropTargetKey: dropTargetKey, dropContainerKey: dropContainerKey, dropTargetPos: dropTargetPos, dropAllowed: dropAllowed, dragOverNodeKey: dragOverNodeKey } = (0, $e9e424090bbd8d70$export$78a5519d0fb779c3)(event, this.dragNodeProps, nodeProps, indent, this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction);
        if (dragChildrenKeys.includes(dropTargetKey) || !dropAllowed) // don't allow drop inside its children
        // don't allow drop when drop is not allowed calculated by calcDropPosition
        return;
        // Update drag position
        if (this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
            if (!(this.state.dropPosition === null && this.state.dropLevelOffset === null && this.state.dropTargetKey === null && this.state.dropContainerKey === null && this.state.dropTargetPos === null && this.state.dropAllowed === false && this.state.dragOverNodeKey === null)) this.resetDragState();
        } else if (!(dropPosition === this.state.dropPosition && dropLevelOffset === this.state.dropLevelOffset && dropTargetKey === this.state.dropTargetKey && dropContainerKey === this.state.dropContainerKey && dropTargetPos === this.state.dropTargetPos && dropAllowed === this.state.dropAllowed && dragOverNodeKey === this.state.dragOverNodeKey)) this.setState({
            dropPosition: dropPosition,
            dropLevelOffset: dropLevelOffset,
            dropTargetKey: dropTargetKey,
            dropContainerKey: dropContainerKey,
            dropTargetPos: dropTargetPos,
            dropAllowed: dropAllowed,
            dragOverNodeKey: dragOverNodeKey
        });
        onDragOver?.({
            event: event,
            node: (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(nodeProps)
        });
    };
    onNodeDragLeave = (event, nodeProps)=>{
        // if it is outside the droppable area
        // currentMouseOverDroppableNodeKey will be updated in dragenter event when into another droppable receiver.
        if (this.currentMouseOverDroppableNodeKey === nodeProps.eventKey && !event.currentTarget.contains(event.relatedTarget)) {
            this.resetDragState();
            this.currentMouseOverDroppableNodeKey = null;
        }
        const { onDragLeave: onDragLeave } = this.props;
        onDragLeave?.({
            event: event,
            node: (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(nodeProps)
        });
    };
    // since stopPropagation() is called in treeNode
    // if onWindowDrag is called, whice means state is keeped, drag state should be cleared
    onWindowDragEnd = (event)=>{
        this.onNodeDragEnd(event, null, true);
        window.removeEventListener('dragend', this.onWindowDragEnd);
    };
    // if onNodeDragEnd is called, onWindowDragEnd won't be called since stopPropagation() is called
    onNodeDragEnd = (event, nodeProps)=>{
        const { onDragEnd: onDragEnd } = this.props;
        this.setState({
            dragOverNodeKey: null
        });
        this.cleanDragState();
        onDragEnd?.({
            event: event,
            node: (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(nodeProps)
        });
        this.dragNodeProps = null;
        window.removeEventListener('dragend', this.onWindowDragEnd);
    };
    onNodeDrop = (event, _, outsideTree = false)=>{
        const { dragChildrenKeys: dragChildrenKeys, dropPosition: dropPosition, dropTargetKey: dropTargetKey, dropTargetPos: dropTargetPos, dropAllowed: dropAllowed } = this.state;
        if (!dropAllowed) return;
        const { onDrop: onDrop } = this.props;
        this.setState({
            dragOverNodeKey: null
        });
        this.cleanDragState();
        if (dropTargetKey === null) return;
        const abstractDropNodeProps = {
            ...(0, $f32a159b6ed8d919$export$d961fd523a514db5)(dropTargetKey, this.getTreeNodeRequiredProps()),
            active: this.getActiveItem()?.key === dropTargetKey,
            data: (0, $a8a325450e627f23$export$2e2bcd8739ae039)(this.state.keyEntities, dropTargetKey).node
        };
        const dropToChild = dragChildrenKeys.includes(dropTargetKey);
        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(!dropToChild, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
        const posArr = (0, $e9e424090bbd8d70$export$ddaee97dc8907312)(dropTargetPos);
        const dropResult = {
            event: event,
            node: (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(abstractDropNodeProps),
            dragNode: this.dragNodeProps ? (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)(this.dragNodeProps) : null,
            dragNodesKeys: [
                this.dragNodeProps.eventKey
            ].concat(dragChildrenKeys),
            dropToGap: dropPosition !== 0,
            dropPosition: dropPosition + Number(posArr[posArr.length - 1])
        };
        if (!outsideTree) onDrop?.(dropResult);
        this.dragNodeProps = null;
    };
    resetDragState() {
        this.setState({
            dragOverNodeKey: null,
            dropPosition: null,
            dropLevelOffset: null,
            dropTargetKey: null,
            dropContainerKey: null,
            dropTargetPos: null,
            dropAllowed: false
        });
    }
    cleanDragState = ()=>{
        const { draggingNodeKey: draggingNodeKey } = this.state;
        if (draggingNodeKey !== null) this.setState({
            draggingNodeKey: null,
            dropPosition: null,
            dropContainerKey: null,
            dropTargetKey: null,
            dropLevelOffset: null,
            dropAllowed: true,
            dragOverNodeKey: null
        });
        this.dragStartMousePosition = null;
        this.currentMouseOverDroppableNodeKey = null;
    };
    triggerExpandActionExpand = (e, treeNode)=>{
        const { expandedKeys: expandedKeys, flattenNodes: flattenNodes } = this.state;
        const { expanded: expanded, key: key, isLeaf: isLeaf } = treeNode;
        if (isLeaf || e.shiftKey || e.metaKey || e.ctrlKey) return;
        const node = flattenNodes.filter((nodeItem)=>nodeItem.key === key)[0];
        const eventNode = (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)({
            ...(0, $f32a159b6ed8d919$export$d961fd523a514db5)(key, this.getTreeNodeRequiredProps()),
            data: node.data
        });
        this.setExpandedKeys(expanded ? (0, $e9e424090bbd8d70$export$5bfb9ff497fe2298)(expandedKeys, key) : (0, $e9e424090bbd8d70$export$10663f6bbd2fd717)(expandedKeys, key));
        this.onNodeExpand(e, eventNode);
    };
    onNodeClick = (e, treeNode)=>{
        const { onClick: onClick, expandAction: expandAction } = this.props;
        if (expandAction === 'click') this.triggerExpandActionExpand(e, treeNode);
        onClick?.(e, treeNode);
    };
    onNodeDoubleClick = (e, treeNode)=>{
        const { onDoubleClick: onDoubleClick, expandAction: expandAction } = this.props;
        if (expandAction === 'doubleClick') this.triggerExpandActionExpand(e, treeNode);
        onDoubleClick?.(e, treeNode);
    };
    onNodeSelect = (e, treeNode)=>{
        let { selectedKeys: selectedKeys } = this.state;
        const { keyEntities: keyEntities, fieldNames: fieldNames } = this.state;
        const { onSelect: onSelect, multiple: multiple } = this.props;
        const { selected: selected } = treeNode;
        const key = treeNode[fieldNames.key];
        const targetSelected = !selected;
        // Update selected keys
        if (!targetSelected) selectedKeys = (0, $e9e424090bbd8d70$export$5bfb9ff497fe2298)(selectedKeys, key);
        else if (!multiple) selectedKeys = [
            key
        ];
        else selectedKeys = (0, $e9e424090bbd8d70$export$10663f6bbd2fd717)(selectedKeys, key);
        // [Legacy] Not found related usage in doc or upper libs
        const selectedNodes = selectedKeys.map((selectedKey)=>{
            const entity = (0, $a8a325450e627f23$export$2e2bcd8739ae039)(keyEntities, selectedKey);
            return entity ? entity.node : null;
        }).filter(Boolean);
        this.setUncontrolledState({
            selectedKeys: selectedKeys
        });
        onSelect?.(selectedKeys, {
            event: 'select',
            selected: targetSelected,
            node: treeNode,
            selectedNodes: selectedNodes,
            nativeEvent: e.nativeEvent
        });
    };
    onNodeCheck = (e, treeNode, checked)=>{
        const { keyEntities: keyEntities, checkedKeys: oriCheckedKeys, halfCheckedKeys: oriHalfCheckedKeys } = this.state;
        const { checkStrictly: checkStrictly, onCheck: onCheck } = this.props;
        const { key: key } = treeNode;
        // Prepare trigger arguments
        let checkedObj;
        const eventObj = {
            event: 'check',
            node: treeNode,
            checked: checked,
            nativeEvent: e.nativeEvent
        };
        if (checkStrictly) {
            const checkedKeys = checked ? (0, $e9e424090bbd8d70$export$10663f6bbd2fd717)(oriCheckedKeys, key) : (0, $e9e424090bbd8d70$export$5bfb9ff497fe2298)(oriCheckedKeys, key);
            const halfCheckedKeys = (0, $e9e424090bbd8d70$export$5bfb9ff497fe2298)(oriHalfCheckedKeys, key);
            checkedObj = {
                checked: checkedKeys,
                halfChecked: halfCheckedKeys
            };
            eventObj.checkedNodes = checkedKeys.map((checkedKey)=>(0, $a8a325450e627f23$export$2e2bcd8739ae039)(keyEntities, checkedKey)).filter(Boolean).map((entity)=>entity.node);
            this.setUncontrolledState({
                checkedKeys: checkedKeys
            });
        } else {
            // Always fill first
            let { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $57a33d03148eb2df$export$43adf2c483e3e633)([
                ...oriCheckedKeys,
                key
            ], true, keyEntities);
            // If remove, we do it again to correction
            if (!checked) {
                const keySet = new Set(checkedKeys);
                keySet.delete(key);
                ({ checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $57a33d03148eb2df$export$43adf2c483e3e633)(Array.from(keySet), {
                    checked: false,
                    halfCheckedKeys: halfCheckedKeys
                }, keyEntities));
            }
            checkedObj = checkedKeys;
            // [Legacy] This is used for `rc-tree-select`
            eventObj.checkedNodes = [];
            eventObj.checkedNodesPositions = [];
            eventObj.halfCheckedKeys = halfCheckedKeys;
            checkedKeys.forEach((checkedKey)=>{
                const entity = (0, $a8a325450e627f23$export$2e2bcd8739ae039)(keyEntities, checkedKey);
                if (!entity) return;
                const { node: node, pos: pos } = entity;
                eventObj.checkedNodes.push(node);
                eventObj.checkedNodesPositions.push({
                    node: node,
                    pos: pos
                });
            });
            this.setUncontrolledState({
                checkedKeys: checkedKeys
            }, false, {
                halfCheckedKeys: halfCheckedKeys
            });
        }
        onCheck?.(checkedObj, eventObj);
    };
    onNodeLoad = (treeNode)=>{
        const { key: key } = treeNode;
        const { keyEntities: keyEntities } = this.state;
        // Skip if has children already
        const entity = (0, $a8a325450e627f23$export$2e2bcd8739ae039)(keyEntities, key);
        if (entity?.children?.length) return;
        const loadPromise = new Promise((resolve, reject)=>{
            // We need to get the latest state of loading/loaded keys
            this.setState(({ loadedKeys: loadedKeys = [], loadingKeys: loadingKeys = [] })=>{
                const { loadData: loadData, onLoad: onLoad } = this.props;
                if (!loadData || loadedKeys.includes(key) || loadingKeys.includes(key)) return null;
                // Process load data
                const promise = loadData(treeNode);
                promise.then(()=>{
                    const { loadedKeys: currentLoadedKeys } = this.state;
                    const newLoadedKeys = (0, $e9e424090bbd8d70$export$10663f6bbd2fd717)(currentLoadedKeys, key);
                    // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
                    // https://github.com/ant-design/ant-design/issues/12464
                    onLoad?.(newLoadedKeys, {
                        event: 'load',
                        node: treeNode
                    });
                    this.setUncontrolledState({
                        loadedKeys: newLoadedKeys
                    });
                    this.setState((prevState)=>({
                            loadingKeys: (0, $e9e424090bbd8d70$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                        }));
                    resolve();
                }).catch((e)=>{
                    this.setState((prevState)=>({
                            loadingKeys: (0, $e9e424090bbd8d70$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                        }));
                    // If exceed max retry times, we give up retry
                    this.loadingRetryTimes[key] = (this.loadingRetryTimes[key] || 0) + 1;
                    if (this.loadingRetryTimes[key] >= $2a87844f3d67a29c$var$MAX_RETRY_TIMES) {
                        const { loadedKeys: currentLoadedKeys } = this.state;
                        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(false, 'Retry for `loadData` many times but still failed. No more retry.');
                        this.setUncontrolledState({
                            loadedKeys: (0, $e9e424090bbd8d70$export$10663f6bbd2fd717)(currentLoadedKeys, key)
                        });
                        resolve();
                    }
                    reject(e);
                });
                return {
                    loadingKeys: (0, $e9e424090bbd8d70$export$10663f6bbd2fd717)(loadingKeys, key)
                };
            });
        });
        // Not care warning if we ignore this
        loadPromise.catch(()=>{});
        return loadPromise;
    };
    onNodeMouseEnter = (event, node)=>{
        const { onMouseEnter: onMouseEnter } = this.props;
        onMouseEnter?.({
            event: event,
            node: node
        });
    };
    onNodeMouseLeave = (event, node)=>{
        const { onMouseLeave: onMouseLeave } = this.props;
        onMouseLeave?.({
            event: event,
            node: node
        });
    };
    onNodeContextMenu = (event, node)=>{
        const { onRightClick: onRightClick } = this.props;
        if (onRightClick) {
            event.preventDefault();
            onRightClick({
                event: event,
                node: node
            });
        }
    };
    onFocus = (...args)=>{
        const { onFocus: onFocus } = this.props;
        this.setState({
            focused: true
        });
        onFocus?.(...args);
    };
    onBlur = (...args)=>{
        const { onBlur: onBlur } = this.props;
        this.setState({
            focused: false
        });
        this.onActiveChange(null);
        onBlur?.(...args);
    };
    getTreeNodeRequiredProps = ()=>{
        const { expandedKeys: expandedKeys, selectedKeys: selectedKeys, loadedKeys: loadedKeys, loadingKeys: loadingKeys, checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys, dragOverNodeKey: dragOverNodeKey, dropPosition: dropPosition, keyEntities: keyEntities } = this.state;
        return {
            expandedKeys: expandedKeys || [],
            selectedKeys: selectedKeys || [],
            loadedKeys: loadedKeys || [],
            loadingKeys: loadingKeys || [],
            checkedKeys: checkedKeys || [],
            halfCheckedKeys: halfCheckedKeys || [],
            dragOverNodeKey: dragOverNodeKey,
            dropPosition: dropPosition,
            keyEntities: keyEntities
        };
    };
    // =========================== Expanded ===========================
    /** Set uncontrolled `expandedKeys`. This will also auto update `flattenNodes`. */ setExpandedKeys = (expandedKeys)=>{
        const { treeData: treeData, fieldNames: fieldNames } = this.state;
        const flattenNodes = (0, $f32a159b6ed8d919$export$215c1b4f1ba88b23)(treeData, expandedKeys, fieldNames);
        this.setUncontrolledState({
            expandedKeys: expandedKeys,
            flattenNodes: flattenNodes
        }, true);
    };
    onNodeExpand = (e, treeNode)=>{
        let { expandedKeys: expandedKeys } = this.state;
        const { listChanging: listChanging, fieldNames: fieldNames } = this.state;
        const { onExpand: onExpand, loadData: loadData } = this.props;
        const { expanded: expanded } = treeNode;
        const key = treeNode[fieldNames.key];
        // Do nothing when motion is in progress
        if (listChanging) return;
        // Update selected keys
        const certain = expandedKeys.includes(key);
        const targetExpanded = !expanded;
        (0, $474154b5a64067c8$export$2e2bcd8739ae039)(expanded && certain || !expanded && !certain, 'Expand state not sync with index check');
        expandedKeys = targetExpanded ? (0, $e9e424090bbd8d70$export$10663f6bbd2fd717)(expandedKeys, key) : (0, $e9e424090bbd8d70$export$5bfb9ff497fe2298)(expandedKeys, key);
        this.setExpandedKeys(expandedKeys);
        onExpand?.(expandedKeys, {
            node: treeNode,
            expanded: targetExpanded,
            nativeEvent: e.nativeEvent
        });
        // Async Load data
        if (targetExpanded && loadData) {
            const loadPromise = this.onNodeLoad(treeNode);
            if (loadPromise) loadPromise.then(()=>{
                // [Legacy] Refresh logic
                const newFlattenTreeData = (0, $f32a159b6ed8d919$export$215c1b4f1ba88b23)(this.state.treeData, expandedKeys, fieldNames);
                this.setUncontrolledState({
                    flattenNodes: newFlattenTreeData
                });
            }).catch(()=>{
                const { expandedKeys: currentExpandedKeys } = this.state;
                const expandedKeysToRestore = (0, $e9e424090bbd8d70$export$5bfb9ff497fe2298)(currentExpandedKeys, key);
                this.setExpandedKeys(expandedKeysToRestore);
            });
        }
    };
    onListChangeStart = ()=>{
        this.setUncontrolledState({
            listChanging: true
        });
    };
    onListChangeEnd = ()=>{
        setTimeout(()=>{
            this.setUncontrolledState({
                listChanging: false
            });
        });
    };
    // =========================== Keyboard ===========================
    onActiveChange = (newActiveKey)=>{
        const { activeKey: activeKey } = this.state;
        const { onActiveChange: onActiveChange, itemScrollOffset: itemScrollOffset = 0 } = this.props;
        if (activeKey === newActiveKey) return;
        this.setState({
            activeKey: newActiveKey
        });
        if (newActiveKey !== null) this.scrollTo({
            key: newActiveKey,
            offset: itemScrollOffset
        });
        onActiveChange?.(newActiveKey);
    };
    getActiveItem = ()=>{
        const { activeKey: activeKey, flattenNodes: flattenNodes } = this.state;
        if (activeKey === null) return null;
        return flattenNodes.find(({ key: key })=>key === activeKey) || null;
    };
    offsetActiveKey = (offset)=>{
        const { flattenNodes: flattenNodes, activeKey: activeKey } = this.state;
        let index = flattenNodes.findIndex(({ key: key })=>key === activeKey);
        // Align with index
        if (index === -1 && offset < 0) index = flattenNodes.length;
        index = (index + offset + flattenNodes.length) % flattenNodes.length;
        const item = flattenNodes[index];
        if (item) {
            const { key: key } = item;
            this.onActiveChange(key);
        } else this.onActiveChange(null);
    };
    onKeyDown = (event)=>{
        const { activeKey: activeKey, expandedKeys: expandedKeys, checkedKeys: checkedKeys, fieldNames: fieldNames } = this.state;
        const { onKeyDown: onKeyDown, checkable: checkable, selectable: selectable } = this.props;
        // >>>>>>>>>> Direction
        switch(event.which){
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).UP:
                this.offsetActiveKey(-1);
                event.preventDefault();
                break;
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).DOWN:
                this.offsetActiveKey(1);
                event.preventDefault();
                break;
        }
        // >>>>>>>>>> Expand & Selection
        const activeItem = this.getActiveItem();
        if (activeItem && activeItem.data) {
            const treeNodeRequiredProps = this.getTreeNodeRequiredProps();
            const expandable = activeItem.data.isLeaf === false || !!(activeItem.data[fieldNames.children] || []).length;
            const eventNode = (0, $f32a159b6ed8d919$export$7bd1b0fd4a8b540b)({
                ...(0, $f32a159b6ed8d919$export$d961fd523a514db5)(activeKey, treeNodeRequiredProps),
                data: activeItem.data,
                active: true
            });
            switch(event.which){
                // >>> Expand
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).LEFT:
                    // Collapse if possible
                    if (expandable && expandedKeys.includes(activeKey)) this.onNodeExpand({}, eventNode);
                    else if (activeItem.parent) this.onActiveChange(activeItem.parent.key);
                    event.preventDefault();
                    break;
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).RIGHT:
                    // Expand if possible
                    if (expandable && !expandedKeys.includes(activeKey)) this.onNodeExpand({}, eventNode);
                    else if (activeItem.children && activeItem.children.length) this.onActiveChange(activeItem.children[0].key);
                    event.preventDefault();
                    break;
                // Selection
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER:
                case (0, $b0616a5421b43292$export$2e2bcd8739ae039).SPACE:
                    if (checkable && !eventNode.disabled && eventNode.checkable !== false && !eventNode.disableCheckbox) this.onNodeCheck({}, eventNode, !checkedKeys.includes(activeKey));
                    else if (!checkable && selectable && !eventNode.disabled && eventNode.selectable !== false) this.onNodeSelect({}, eventNode);
                    break;
            }
        }
        onKeyDown?.(event);
    };
    /**
   * Only update the value which is not in props
   */ setUncontrolledState = (state, atomic = false, forceState = null)=>{
        if (!this.destroyed) {
            let needSync = false;
            let allPassed = true;
            const newState = {};
            Object.keys(state).forEach((name)=>{
                if (this.props.hasOwnProperty(name)) {
                    allPassed = false;
                    return;
                }
                needSync = true;
                newState[name] = state[name];
            });
            if (needSync && (!atomic || allPassed)) this.setState({
                ...newState,
                ...forceState
            });
        }
    };
    scrollTo = (scroll)=>{
        this.listRef.current.scrollTo(scroll);
    };
    render() {
        const { focused: focused, flattenNodes: flattenNodes, keyEntities: keyEntities, draggingNodeKey: draggingNodeKey, activeKey: activeKey, dropLevelOffset: dropLevelOffset, dropContainerKey: dropContainerKey, dropTargetKey: dropTargetKey, dropPosition: dropPosition, dragOverNodeKey: dragOverNodeKey, indent: indent } = this.state;
        const { prefixCls: prefixCls, className: className, style: style, styles: styles, classNames: treeClassNames, showLine: showLine, focusable: focusable, tabIndex: tabIndex = 0, selectable: selectable, showIcon: showIcon, icon: icon, switcherIcon: switcherIcon, draggable: draggable, checkable: checkable, checkStrictly: checkStrictly, disabled: disabled, motion: motion, loadData: loadData, filterTreeNode: filterTreeNode, height: height, itemHeight: itemHeight, scrollWidth: scrollWidth, virtual: virtual, titleRender: titleRender, dropIndicatorRender: dropIndicatorRender, onContextMenu: onContextMenu, onScroll: onScroll, direction: direction, rootClassName: rootClassName, rootStyle: rootStyle } = this.props;
        const domProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(this.props, {
            aria: true,
            data: true
        });
        // It's better move to hooks but we just simply keep here
        let draggableConfig;
        if (draggable) {
            if (typeof draggable === 'object') draggableConfig = draggable;
            else if (typeof draggable === 'function') draggableConfig = {
                nodeDraggable: draggable
            };
            else draggableConfig = {};
        }
        const contextValue = {
            styles: styles,
            classNames: treeClassNames,
            prefixCls: prefixCls,
            selectable: selectable,
            showIcon: showIcon,
            icon: icon,
            switcherIcon: switcherIcon,
            draggable: draggableConfig,
            draggingNodeKey: draggingNodeKey,
            checkable: checkable,
            checkStrictly: checkStrictly,
            disabled: disabled,
            keyEntities: keyEntities,
            dropLevelOffset: dropLevelOffset,
            dropContainerKey: dropContainerKey,
            dropTargetKey: dropTargetKey,
            dropPosition: dropPosition,
            dragOverNodeKey: dragOverNodeKey,
            indent: indent,
            direction: direction,
            dropIndicatorRender: dropIndicatorRender,
            loadData: loadData,
            filterTreeNode: filterTreeNode,
            titleRender: titleRender,
            onNodeClick: this.onNodeClick,
            onNodeDoubleClick: this.onNodeDoubleClick,
            onNodeExpand: this.onNodeExpand,
            onNodeSelect: this.onNodeSelect,
            onNodeCheck: this.onNodeCheck,
            onNodeLoad: this.onNodeLoad,
            onNodeMouseEnter: this.onNodeMouseEnter,
            onNodeMouseLeave: this.onNodeMouseLeave,
            onNodeContextMenu: this.onNodeContextMenu,
            onNodeDragStart: this.onNodeDragStart,
            onNodeDragEnter: this.onNodeDragEnter,
            onNodeDragOver: this.onNodeDragOver,
            onNodeDragLeave: this.onNodeDragLeave,
            onNodeDragEnd: this.onNodeDragEnd,
            onNodeDrop: this.onNodeDrop
        };
        return /*#__PURE__*/ $ltGt3.createElement((0, $a5b41eab03e0c7d7$export$dfae7d399eea2568).Provider, {
            value: contextValue
        }, /*#__PURE__*/ $ltGt3.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prefixCls, className, rootClassName, {
                [`${prefixCls}-show-line`]: showLine,
                [`${prefixCls}-focused`]: focused,
                [`${prefixCls}-active-focused`]: activeKey !== null
            }),
            style: rootStyle
        }, /*#__PURE__*/ $ltGt3.createElement((0, $e5b729c6cdd34c90$export$2e2bcd8739ae039), $2a87844f3d67a29c$var$_extends({
            ref: this.listRef,
            prefixCls: prefixCls,
            style: style,
            data: flattenNodes,
            disabled: disabled,
            selectable: selectable,
            checkable: !!checkable,
            motion: motion,
            dragging: draggingNodeKey !== null,
            height: height,
            itemHeight: itemHeight,
            virtual: virtual,
            focusable: focusable,
            focused: focused,
            tabIndex: tabIndex,
            activeItem: this.getActiveItem(),
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyDown,
            onActiveChange: this.onActiveChange,
            onListChangeStart: this.onListChangeStart,
            onListChangeEnd: this.onListChangeEnd,
            onContextMenu: onContextMenu,
            onScroll: onScroll,
            scrollWidth: scrollWidth
        }, this.getTreeNodeRequiredProps(), domProps))));
    }
}
var $2a87844f3d67a29c$export$2e2bcd8739ae039 = $2a87844f3d67a29c$var$Tree;




var $daab6fae7e931847$export$2e2bcd8739ae039 = (0, $2a87844f3d67a29c$export$2e2bcd8739ae039);




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $8d1d3a26211dc962$var$FileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file",
    "theme": "outlined"
};
var $8d1d3a26211dc962$export$2e2bcd8739ae039 = $8d1d3a26211dc962$var$FileOutlined;



function $5b794eb7912fcf12$var$_extends() {
    $5b794eb7912fcf12$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5b794eb7912fcf12$var$_extends.apply(this, arguments);
}
const $5b794eb7912fcf12$var$FileOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $5b794eb7912fcf12$var$_extends({}, props, {
        ref: ref,
        icon: (0, $8d1d3a26211dc962$export$2e2bcd8739ae039)
    }));
/**![file](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIC8+PC9zdmc+) */ const $5b794eb7912fcf12$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($5b794eb7912fcf12$var$FileOutlined);
var $5b794eb7912fcf12$export$2e2bcd8739ae039 = $5b794eb7912fcf12$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $528a7caace1d90e2$var$FolderOpenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    },
    "name": "folder-open",
    "theme": "outlined"
};
var $528a7caace1d90e2$export$2e2bcd8739ae039 = $528a7caace1d90e2$var$FolderOpenOutlined;



function $cbd34b02fc891a9b$var$_extends() {
    $cbd34b02fc891a9b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cbd34b02fc891a9b$var$_extends.apply(this, arguments);
}
const $cbd34b02fc891a9b$var$FolderOpenOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $cbd34b02fc891a9b$var$_extends({}, props, {
        ref: ref,
        icon: (0, $528a7caace1d90e2$export$2e2bcd8739ae039)
    }));
/**![folder-open](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCA0NDRIODIwVjMzMC40YzAtMTcuNy0xNC4zLTMyLTMyLTMySDQ3M0wzNTUuNyAxODYuMmE4LjE1IDguMTUgMCAwMC01LjUtMi4ySDk2Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY1OTJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjk4YzEzIDAgMjQuOC03LjkgMjkuNy0yMGwxMzQtMzMyYzEuNS0zLjggMi4zLTcuOSAyLjMtMTIgMC0xNy43LTE0LjMtMzItMzItMzJ6TTEzNiAyNTZoMTg4LjVsMTE5LjYgMTE0LjRINzQ4VjQ0NEgyMzhjLTEzIDAtMjQuOCA3LjktMjkuNyAyMEwxMzYgNjQzLjJWMjU2em02MzUuMyA1MTJIMTU5bDEwMy4zLTI1Nmg2MTIuNEw3NzEuMyA3Njh6IiAvPjwvc3ZnPg==) */ const $cbd34b02fc891a9b$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($cbd34b02fc891a9b$var$FolderOpenOutlined);
var $cbd34b02fc891a9b$export$2e2bcd8739ae039 = $cbd34b02fc891a9b$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $c1d99f3f495e957d$var$FolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    },
    "name": "folder",
    "theme": "outlined"
};
var $c1d99f3f495e957d$export$2e2bcd8739ae039 = $c1d99f3f495e957d$var$FolderOutlined;



function $d58a8ea0544bf9d8$var$_extends() {
    $d58a8ea0544bf9d8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d58a8ea0544bf9d8$var$_extends.apply(this, arguments);
}
const $d58a8ea0544bf9d8$var$FolderOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $d58a8ea0544bf9d8$var$_extends({}, props, {
        ref: ref,
        icon: (0, $c1d99f3f495e957d$export$2e2bcd8739ae039)
    }));
/**![folder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAyOTguNEg1MjFMNDAzLjcgMTg2LjJhOC4xNSA4LjE1IDAgMDAtNS41LTIuMkgxNDRjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjU5MmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg3MzZjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzMwLjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTg0MCA3NjhIMTg0VjI1NmgxODguNWwxMTkuNiAxMTQuNEg4NDBWNzY4eiIgLz48L3N2Zz4=) */ const $d58a8ea0544bf9d8$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($d58a8ea0544bf9d8$var$FolderOutlined);
var $d58a8ea0544bf9d8$export$2e2bcd8739ae039 = $d58a8ea0544bf9d8$var$RefIcon;







var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $a65da9bcd0efd9fb$var$HolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"
                }
            }
        ]
    },
    "name": "holder",
    "theme": "outlined"
};
var $a65da9bcd0efd9fb$export$2e2bcd8739ae039 = $a65da9bcd0efd9fb$var$HolderOutlined;



function $7537783cd0ab1f68$var$_extends() {
    $7537783cd0ab1f68$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7537783cd0ab1f68$var$_extends.apply(this, arguments);
}
const $7537783cd0ab1f68$var$HolderOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $7537783cd0ab1f68$var$_extends({}, props, {
        ref: ref,
        icon: (0, $a65da9bcd0efd9fb$export$2e2bcd8739ae039)
    }));
/**![holder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMwMCAyNzYuNWE1NiA1NiAwIDEwNTYtOTcgNTYgNTYgMCAwMC01NiA5N3ptMCAyODRhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCAyMjhhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDAwLTExMiAwek0zMDAgODQ0LjVhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCA3OTZhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6IiAvPjwvc3ZnPg==) */ const $7537783cd0ab1f68$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($7537783cd0ab1f68$var$HolderOutlined);
var $7537783cd0ab1f68$export$2e2bcd8739ae039 = $7537783cd0ab1f68$var$RefIcon;















// ============================ Directory =============================
const $368e7312ec1b112c$export$2f47474ee6fcebcf = ({ treeCls: treeCls, treeNodeCls: treeNodeCls, directoryNodeSelectedBg: directoryNodeSelectedBg, directoryNodeSelectedColor: directoryNodeSelectedColor, motionDurationMid: motionDurationMid, borderRadius: borderRadius, controlItemBgHover: controlItemBgHover })=>({
        [`${treeCls}${treeCls}-directory ${treeNodeCls}`]: {
            // >>> Title
            [`${treeCls}-node-content-wrapper`]: {
                position: 'static',
                [`&:has(${treeCls}-drop-indicator)`]: {
                    position: 'relative'
                },
                [`> *:not(${treeCls}-drop-indicator)`]: {
                    position: 'relative'
                },
                '&:hover': {
                    background: 'transparent'
                },
                // Expand interactive area to whole line
                '&:before': {
                    position: 'absolute',
                    inset: 0,
                    transition: `background-color ${motionDurationMid}`,
                    content: '""',
                    borderRadius: borderRadius
                },
                '&:hover:before': {
                    background: controlItemBgHover
                }
            },
            [`${treeCls}-switcher, ${treeCls}-checkbox, ${treeCls}-draggable-icon`]: {
                zIndex: 1
            },
            // ============= Selected =============
            '&-selected': {
                background: directoryNodeSelectedBg,
                borderRadius: borderRadius,
                [`${treeCls}-switcher, ${treeCls}-draggable-icon`]: {
                    color: directoryNodeSelectedColor
                },
                // >>> Title
                [`${treeCls}-node-content-wrapper`]: {
                    color: directoryNodeSelectedColor,
                    background: 'transparent',
                    '&, &:hover': {
                        color: directoryNodeSelectedColor
                    },
                    '&:before, &:hover:before': {
                        background: directoryNodeSelectedBg
                    }
                }
            }
        }
    });


// ============================ Keyframes =============================
const $96540e43e8a2966b$var$treeNodeFX = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)('ant-tree-node-fx-do-not-use', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
// ============================== Switch ==============================
const $96540e43e8a2966b$var$getSwitchStyle = (prefixCls, token)=>({
        [`.${prefixCls}-switcher-icon`]: {
            display: 'inline-block',
            fontSize: 10,
            verticalAlign: 'baseline',
            svg: {
                transition: `transform ${token.motionDurationSlow}`
            }
        }
    });
// =============================== Drop ===============================
const $96540e43e8a2966b$var$getDropIndicatorStyle = (prefixCls, token)=>({
        [`.${prefixCls}-drop-indicator`]: {
            position: 'absolute',
            // it should displayed over the following node
            zIndex: 1,
            height: 2,
            backgroundColor: token.colorPrimary,
            borderRadius: 1,
            pointerEvents: 'none',
            '&:after': {
                position: 'absolute',
                top: -3,
                insetInlineStart: -6,
                width: 8,
                height: 8,
                backgroundColor: 'transparent',
                border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidthBold)} solid ${token.colorPrimary}`,
                borderRadius: '50%',
                content: '""'
            }
        }
    });
const $96540e43e8a2966b$export$5ca74f7be820a85 = (prefixCls, token)=>{
    const { treeCls: treeCls, treeNodeCls: treeNodeCls, treeNodePadding: treeNodePadding, titleHeight: titleHeight, indentSize: indentSize, nodeSelectedBg: nodeSelectedBg, nodeHoverBg: nodeHoverBg, colorTextQuaternary: colorTextQuaternary, controlItemBgActiveDisabled: controlItemBgActiveDisabled } = token;
    return {
        [treeCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            // fix https://github.com/ant-design/ant-design/issues/50316
            ['--rc-virtual-list-scrollbar-bg']: token.colorSplit,
            background: token.colorBgContainer,
            borderRadius: token.borderRadius,
            transition: `background-color ${token.motionDurationSlow}`,
            '&-rtl': {
                direction: 'rtl'
            },
            [`&${treeCls}-rtl ${treeCls}-switcher_close ${treeCls}-switcher-icon svg`]: {
                transform: 'rotate(90deg)'
            },
            [`&-focused:not(:hover):not(${treeCls}-active-focused)`]: (0, $945cb0d2b7017a11$export$6539948f0a737e39)(token),
            // =================== Virtual List ===================
            [`${treeCls}-list-holder-inner`]: {
                alignItems: 'flex-start'
            },
            [`&${treeCls}-block-node`]: {
                [`${treeCls}-list-holder-inner`]: {
                    alignItems: 'stretch',
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        flex: 'auto'
                    },
                    // >>> Drag
                    [`${treeNodeCls}.dragging:after`]: {
                        position: 'absolute',
                        inset: 0,
                        border: `1px solid ${token.colorPrimary}`,
                        opacity: 0,
                        animationName: $96540e43e8a2966b$var$treeNodeFX,
                        animationDuration: token.motionDurationSlow,
                        animationPlayState: 'running',
                        animationFillMode: 'forwards',
                        content: '""',
                        pointerEvents: 'none',
                        borderRadius: token.borderRadius
                    }
                }
            },
            // ===================== TreeNode =====================
            [treeNodeCls]: {
                display: 'flex',
                alignItems: 'flex-start',
                marginBottom: treeNodePadding,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(titleHeight),
                position: 'relative',
                // 非常重要，避免 drop-indicator 在拖拽过程中闪烁
                '&:before': {
                    content: '""',
                    position: 'absolute',
                    zIndex: 1,
                    insetInlineStart: 0,
                    width: '100%',
                    top: '100%',
                    height: treeNodePadding
                },
                // Disabled
                [`&-disabled ${treeCls}-node-content-wrapper`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed',
                    '&:hover': {
                        background: 'transparent'
                    }
                },
                [`${treeCls}-checkbox-disabled + ${treeCls}-node-selected,&${treeNodeCls}-disabled${treeNodeCls}-selected ${treeCls}-node-content-wrapper`]: {
                    backgroundColor: controlItemBgActiveDisabled
                },
                // we can not set pointer-events to none for checkbox in tree
                // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-2605234058
                [`${treeCls}-checkbox-disabled`]: {
                    pointerEvents: 'unset'
                },
                // not disable
                [`&:not(${treeNodeCls}-disabled)`]: {
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        '&:hover': {
                            color: token.nodeHoverColor
                        }
                    }
                },
                [`&-active ${treeCls}-node-content-wrapper`]: {
                    background: token.controlItemBgHover
                },
                [`&:not(${treeNodeCls}-disabled).filter-node ${treeCls}-title`]: {
                    color: token.colorPrimary,
                    fontWeight: token.fontWeightStrong
                },
                '&-draggable': {
                    cursor: 'grab',
                    [`${treeCls}-draggable-icon`]: {
                        // https://github.com/ant-design/ant-design/issues/41915
                        flexShrink: 0,
                        width: titleHeight,
                        textAlign: 'center',
                        visibility: 'visible',
                        color: colorTextQuaternary
                    },
                    [`&${treeNodeCls}-disabled ${treeCls}-draggable-icon`]: {
                        visibility: 'hidden'
                    }
                }
            },
            // >>> Indent
            [`${treeCls}-indent`]: {
                alignSelf: 'stretch',
                whiteSpace: 'nowrap',
                userSelect: 'none',
                '&-unit': {
                    display: 'inline-block',
                    width: indentSize
                }
            },
            // >>> Drag Handler
            [`${treeCls}-draggable-icon`]: {
                visibility: 'hidden'
            },
            // Switcher / Checkbox
            [`${treeCls}-switcher, ${treeCls}-checkbox`]: {
                marginInlineEnd: token.calc(token.calc(titleHeight).sub(token.controlInteractiveSize)).div(2).equal()
            },
            // >>> Switcher
            [`${treeCls}-switcher`]: {
                ...$96540e43e8a2966b$var$getSwitchStyle(prefixCls, token),
                position: 'relative',
                flex: 'none',
                alignSelf: 'stretch',
                width: titleHeight,
                textAlign: 'center',
                cursor: 'pointer',
                userSelect: 'none',
                transition: `all ${token.motionDurationSlow}`,
                '&-noop': {
                    cursor: 'unset'
                },
                '&:before': {
                    pointerEvents: 'none',
                    content: '""',
                    width: titleHeight,
                    height: titleHeight,
                    position: 'absolute',
                    left: {
                        _skip_check_: true,
                        value: 0
                    },
                    top: 0,
                    borderRadius: token.borderRadius,
                    transition: `all ${token.motionDurationSlow}`
                },
                [`&:not(${treeCls}-switcher-noop):hover:before`]: {
                    backgroundColor: token.colorBgTextHover
                },
                [`&_close ${treeCls}-switcher-icon svg`]: {
                    transform: 'rotate(-90deg)'
                },
                '&-loading-icon': {
                    color: token.colorPrimary
                },
                '&-leaf-line': {
                    position: 'relative',
                    zIndex: 1,
                    display: 'inline-block',
                    width: '100%',
                    height: '100%',
                    // https://github.com/ant-design/ant-design/issues/31884
                    '&:before': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.calc(titleHeight).div(2).equal(),
                        bottom: token.calc(treeNodePadding).mul(-1).equal(),
                        marginInlineStart: -1,
                        borderInlineEnd: `1px solid ${token.colorBorder}`,
                        content: '""'
                    },
                    '&:after': {
                        position: 'absolute',
                        width: token.calc(token.calc(titleHeight).div(2).equal()).mul(0.8).equal(),
                        height: token.calc(titleHeight).div(2).equal(),
                        borderBottom: `1px solid ${token.colorBorder}`,
                        content: '""'
                    }
                }
            },
            // >>> Title
            // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
            [`${treeCls}-node-content-wrapper`]: {
                position: 'relative',
                minHeight: titleHeight,
                paddingBlock: 0,
                paddingInline: token.paddingXS,
                background: 'transparent',
                borderRadius: token.borderRadius,
                cursor: 'pointer',
                transition: `all ${token.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`,
                ...$96540e43e8a2966b$var$getDropIndicatorStyle(prefixCls, token),
                '&:hover': {
                    backgroundColor: nodeHoverBg
                },
                [`&${treeCls}-node-selected`]: {
                    color: token.nodeSelectedColor,
                    backgroundColor: nodeSelectedBg
                },
                // Icon
                [`${treeCls}-iconEle`]: {
                    display: 'inline-block',
                    width: titleHeight,
                    height: titleHeight,
                    textAlign: 'center',
                    verticalAlign: 'top',
                    '&:empty': {
                        display: 'none'
                    }
                }
            },
            // https://github.com/ant-design/ant-design/issues/28217
            [`${treeCls}-unselectable ${treeCls}-node-content-wrapper:hover`]: {
                backgroundColor: 'transparent'
            },
            [`${treeNodeCls}.drop-container > [draggable]`]: {
                boxShadow: `0 0 0 2px ${token.colorPrimary}`
            },
            // ==================== Show Line =====================
            '&-show-line': {
                // ================ Indent lines ================
                [`${treeCls}-indent-unit`]: {
                    position: 'relative',
                    height: '100%',
                    '&:before': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.calc(titleHeight).div(2).equal(),
                        bottom: token.calc(treeNodePadding).mul(-1).equal(),
                        borderInlineEnd: `1px solid ${token.colorBorder}`,
                        content: '""'
                    },
                    '&-end:before': {
                        display: 'none'
                    }
                },
                // ============== Cover Background ==============
                [`${treeCls}-switcher`]: {
                    background: 'transparent',
                    '&-line-icon': {
                        // https://github.com/ant-design/ant-design/issues/32813
                        verticalAlign: '-0.15em'
                    }
                }
            },
            [`${treeNodeCls}-leaf-last ${treeCls}-switcher-leaf-line:before`]: {
                top: 'auto !important',
                bottom: 'auto !important',
                height: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(titleHeight).div(2).equal())} !important`
            }
        }
    };
};
const $96540e43e8a2966b$export$6543b952798356f2 = (prefixCls, token, /**
 * @descCN 是否启用目录树样式
 * @descEN Whether to enable directory style
 * @default true
 */ enableDirectory = true)=>{
    const treeCls = `.${prefixCls}`;
    const treeNodeCls = `${treeCls}-treenode`;
    const treeNodePadding = token.calc(token.paddingXS).div(2).equal();
    const treeToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        treeCls: treeCls,
        treeNodeCls: treeNodeCls,
        treeNodePadding: treeNodePadding
    });
    return [
        // Basic
        $96540e43e8a2966b$export$5ca74f7be820a85(prefixCls, treeToken),
        // Directory
        enableDirectory && (0, $368e7312ec1b112c$export$2f47474ee6fcebcf)(treeToken)
    ].filter(Boolean);
};
const $96540e43e8a2966b$export$bd8b682992bc9781 = (token)=>{
    const { controlHeightSM: controlHeightSM, controlItemBgHover: controlItemBgHover, controlItemBgActive: controlItemBgActive } = token;
    const titleHeight = controlHeightSM;
    return {
        titleHeight: titleHeight,
        indentSize: titleHeight,
        nodeHoverBg: controlItemBgHover,
        nodeHoverColor: token.colorText,
        nodeSelectedBg: controlItemBgActive,
        nodeSelectedColor: token.colorText
    };
};
const $96540e43e8a2966b$export$9ca1be8807fe0675 = (token)=>{
    const { colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary } = token;
    return {
        ...$96540e43e8a2966b$export$bd8b682992bc9781(token),
        directoryNodeSelectedColor: colorTextLightSolid,
        directoryNodeSelectedBg: colorPrimary
    };
};
var $96540e43e8a2966b$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Tree', (token, { prefixCls: prefixCls })=>[
        {
            [token.componentCls]: (0, $2c6e5f034ccbdb08$export$3d2f074408bd1b82)(`${prefixCls}-checkbox`, token)
        },
        $96540e43e8a2966b$export$6543b952798356f2(prefixCls, token),
        (0, $5a999cf2ba92548d$export$2e2bcd8739ae039)(token)
    ], $96540e43e8a2966b$export$9ca1be8807fe0675);



var $ltGt3 = parcelRequire("ltGt3");
"use client";
const $d534576576c9f72d$export$cc800923e997bb8 = 4;
function $d534576576c9f72d$var$dropIndicatorRender(props) {
    const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, prefixCls: prefixCls, indent: indent, direction: direction = 'ltr' } = props;
    const startPosition = direction === 'ltr' ? 'left' : 'right';
    const endPosition = direction === 'ltr' ? 'right' : 'left';
    const style = {
        [startPosition]: -dropLevelOffset * indent + $d534576576c9f72d$export$cc800923e997bb8,
        [endPosition]: 0
    };
    switch(dropPosition){
        case -1:
            style.top = -3;
            break;
        case 1:
            style.bottom = -3;
            break;
        default:
            // dropPosition === 0
            style.bottom = -3;
            style[startPosition] = indent + $d534576576c9f72d$export$cc800923e997bb8;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        style: style,
        className: `${prefixCls}-drop-indicator`
    });
}
var $d534576576c9f72d$export$2e2bcd8739ae039 = $d534576576c9f72d$var$dropIndicatorRender;



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $8026dd00e48f91a8$var$CaretDownFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "filled"
};
var $8026dd00e48f91a8$export$2e2bcd8739ae039 = $8026dd00e48f91a8$var$CaretDownFilled;



function $4dcd253c6f96f851$var$_extends() {
    $4dcd253c6f96f851$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4dcd253c6f96f851$var$_extends.apply(this, arguments);
}
const $4dcd253c6f96f851$var$CaretDownFilled = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $4dcd253c6f96f851$var$_extends({}, props, {
        ref: ref,
        icon: (0, $8026dd00e48f91a8$export$2e2bcd8739ae039)
    }));
/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */ const $4dcd253c6f96f851$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($4dcd253c6f96f851$var$CaretDownFilled);
var $4dcd253c6f96f851$export$2e2bcd8739ae039 = $4dcd253c6f96f851$var$RefIcon;





var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $46e2d53807c98f11$var$MinusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "minus-square",
    "theme": "outlined"
};
var $46e2d53807c98f11$export$2e2bcd8739ae039 = $46e2d53807c98f11$var$MinusSquareOutlined;



function $b39fb50950a78f59$var$_extends() {
    $b39fb50950a78f59$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b39fb50950a78f59$var$_extends.apply(this, arguments);
}
const $b39fb50950a78f59$var$MinusSquareOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $b39fb50950a78f59$var$_extends({}, props, {
        ref: ref,
        icon: (0, $46e2d53807c98f11$export$2e2bcd8739ae039)
    }));
/**![minus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMzY4YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04SDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ const $b39fb50950a78f59$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($b39fb50950a78f59$var$MinusSquareOutlined);
var $b39fb50950a78f59$export$2e2bcd8739ae039 = $b39fb50950a78f59$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $e7a369ae5a8f3780$var$PlusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "plus-square",
    "theme": "outlined"
};
var $e7a369ae5a8f3780$export$2e2bcd8739ae039 = $e7a369ae5a8f3780$var$PlusSquareOutlined;



function $c7cb224ecd88e86c$var$_extends() {
    $c7cb224ecd88e86c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c7cb224ecd88e86c$var$_extends.apply(this, arguments);
}
const $c7cb224ecd88e86c$var$PlusSquareOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $c7cb224ecd88e86c$var$_extends({}, props, {
        ref: ref,
        icon: (0, $e7a369ae5a8f3780$export$2e2bcd8739ae039)
    }));
/**![plus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMTUydjE1MmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjU0NGgxNTJjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LThINTQ0VjMyOGMwLTQuNC0zLjYtOC04LThoLTQ4Yy00LjQgMC04IDMuNi04IDh2MTUySDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ const $c7cb224ecd88e86c$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($c7cb224ecd88e86c$var$PlusSquareOutlined);
var $c7cb224ecd88e86c$export$2e2bcd8739ae039 = $c7cb224ecd88e86c$var$RefIcon;




"use client";
const $86c2b8eb5984eeb2$var$SwitcherIconCom = (props)=>{
    const { prefixCls: prefixCls, switcherIcon: switcherIcon, treeNodeProps: treeNodeProps, showLine: showLine, switcherLoadingIcon: switcherLoadingIcon } = props;
    const { isLeaf: isLeaf, expanded: expanded, loading: loading } = treeNodeProps;
    if (loading) {
        if (/*#__PURE__*/ $ltGt3.isValidElement(switcherLoadingIcon)) return switcherLoadingIcon;
        return /*#__PURE__*/ $ltGt3.createElement((0, $8ede40f9e9e4f5c2$export$2e2bcd8739ae039), {
            className: `${prefixCls}-switcher-loading-icon`
        });
    }
    let showLeafIcon;
    if (showLine && typeof showLine === 'object') showLeafIcon = showLine.showLeafIcon;
    if (isLeaf) {
        if (!showLine) return null;
        if (typeof showLeafIcon !== 'boolean' && !!showLeafIcon) {
            const leafIcon = typeof showLeafIcon === 'function' ? showLeafIcon(treeNodeProps) : showLeafIcon;
            const leafCls = `${prefixCls}-switcher-line-custom-icon`;
            if (/*#__PURE__*/ $ltGt3.isValidElement(leafIcon)) return (0, $66d38239e1a27993$export$e530037191fcd5d7)(leafIcon, {
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(leafIcon.props?.className, leafCls)
            });
            return leafIcon;
        }
        return showLeafIcon ? /*#__PURE__*/ $ltGt3.createElement((0, $5b794eb7912fcf12$export$2e2bcd8739ae039), {
            className: `${prefixCls}-switcher-line-icon`
        }) : /*#__PURE__*/ $ltGt3.createElement("span", {
            className: `${prefixCls}-switcher-leaf-line`
        });
    }
    const switcherCls = `${prefixCls}-switcher-icon`;
    const switcher = typeof switcherIcon === 'function' ? switcherIcon(treeNodeProps) : switcherIcon;
    if (/*#__PURE__*/ $ltGt3.isValidElement(switcher)) return (0, $66d38239e1a27993$export$e530037191fcd5d7)(switcher, {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(switcher.props?.className, switcherCls)
    });
    if (switcher !== undefined) return switcher;
    if (showLine) return expanded ? /*#__PURE__*/ $ltGt3.createElement((0, $b39fb50950a78f59$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-line-icon`
    }) : /*#__PURE__*/ $ltGt3.createElement((0, $c7cb224ecd88e86c$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-line-icon`
    });
    return /*#__PURE__*/ $ltGt3.createElement((0, $4dcd253c6f96f851$export$2e2bcd8739ae039), {
        className: switcherCls
    });
};
var $86c2b8eb5984eeb2$export$2e2bcd8739ae039 = $86c2b8eb5984eeb2$var$SwitcherIconCom;


"use client";
const $51485bdb7468f5e7$var$Tree = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('tree');
    const { virtual: virtual } = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showIcon: showIcon = false, showLine: showLine, switcherIcon: switcherIcon, switcherLoadingIcon: switcherLoadingIcon, blockNode: blockNode = false, children: children, checkable: checkable = false, selectable: selectable = true, draggable: draggable, disabled: disabled, motion: customMotion, style: style, rootClassName: rootClassName, classNames: classNames, styles: styles } = props;
    const contextDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = disabled ?? contextDisabled;
    const prefixCls = getPrefixCls('tree', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const motion = customMotion ?? {
        ...(0, $32c4c593a0d4aef5$export$2e2bcd8739ae039)(rootPrefixCls),
        motionAppear: false
    };
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        showIcon: showIcon,
        blockNode: blockNode,
        checkable: checkable,
        selectable: selectable,
        disabled: mergedDisabled,
        motion: motion
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const newProps = {
        ...props,
        checkable: checkable,
        selectable: selectable,
        showIcon: showIcon,
        motion: motion,
        blockNode: blockNode,
        disabled: mergedDisabled,
        showLine: Boolean(showLine),
        dropIndicatorRender: $d534576576c9f72d$export$2e2bcd8739ae039
    };
    const [hashId, cssVarCls] = (0, $96540e43e8a2966b$export$2e2bcd8739ae039)(prefixCls);
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const itemHeight = token.paddingXS / 2 + (token.Tree?.titleHeight || token.controlHeightSM);
    const draggableConfig = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        if (!draggable) return false;
        let mergedDraggable = {};
        switch(typeof draggable){
            case 'function':
                mergedDraggable.nodeDraggable = draggable;
                break;
            case 'object':
                mergedDraggable = {
                    ...draggable
                };
                break;
            default:
                break;
        }
        if (mergedDraggable.icon !== false) mergedDraggable.icon = mergedDraggable.icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $7537783cd0ab1f68$export$2e2bcd8739ae039), null);
        return mergedDraggable;
    }, [
        draggable
    ]);
    const renderSwitcherIcon = (nodeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $86c2b8eb5984eeb2$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            switcherIcon: switcherIcon,
            switcherLoadingIcon: switcherLoadingIcon,
            treeNodeProps: nodeProps,
            showLine: showLine
        });
    return(/*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $daab6fae7e931847$export$2e2bcd8739ae039), {
        itemHeight: itemHeight,
        ref: ref,
        virtual: virtual,
        ...newProps,
        // newProps may contain style so declare style below it
        prefixCls: prefixCls,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
            [`${prefixCls}-icon-hide`]: !showIcon,
            [`${prefixCls}-block-node`]: blockNode,
            [`${prefixCls}-unselectable`]: !selectable,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-disabled`]: mergedDisabled
        }, contextClassName, className, hashId, cssVarCls),
        style: {
            ...contextStyle,
            ...style
        },
        rootClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassNames?.root, rootClassName),
        rootStyle: mergedStyles?.root,
        classNames: mergedClassNames,
        styles: mergedStyles,
        direction: direction,
        checkable: checkable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            className: `${prefixCls}-checkbox-inner`
        }) : checkable,
        selectable: selectable,
        switcherIcon: renderSwitcherIcon,
        draggable: draggableConfig
    }, children));
});
var $51485bdb7468f5e7$export$2e2bcd8739ae039 = $51485bdb7468f5e7$var$Tree;




const $f12c6c1651586b87$var$RECORD_NONE = 0;
const $f12c6c1651586b87$var$RECORD_START = 1;
const $f12c6c1651586b87$var$RECORD_END = 2;
function $f12c6c1651586b87$var$traverseNodesKey(treeData, callback, fieldNames) {
    const { key: fieldKey, children: fieldChildren } = fieldNames;
    function processNode(dataNode) {
        const key = dataNode[fieldKey];
        const children = dataNode[fieldChildren];
        if (callback(key, dataNode) !== false) $f12c6c1651586b87$var$traverseNodesKey(children || [], callback, fieldNames);
    }
    treeData.forEach(processNode);
}
function $f12c6c1651586b87$export$aad0b800290b42ab({ treeData: treeData, expandedKeys: expandedKeys, startKey: startKey, endKey: endKey, fieldNames: fieldNames }) {
    const keys = [];
    let record = $f12c6c1651586b87$var$RECORD_NONE;
    if (startKey && startKey === endKey) return [
        startKey
    ];
    if (!startKey || !endKey) return [];
    function matchKey(key) {
        return key === startKey || key === endKey;
    }
    $f12c6c1651586b87$var$traverseNodesKey(treeData, (key)=>{
        if (record === $f12c6c1651586b87$var$RECORD_END) return false;
        if (matchKey(key)) {
            // Match test
            keys.push(key);
            if (record === $f12c6c1651586b87$var$RECORD_NONE) record = $f12c6c1651586b87$var$RECORD_START;
            else if (record === $f12c6c1651586b87$var$RECORD_START) {
                record = $f12c6c1651586b87$var$RECORD_END;
                return false;
            }
        } else if (record === $f12c6c1651586b87$var$RECORD_START) // Append selection
        keys.push(key);
        return expandedKeys.includes(key);
    }, (0, $f32a159b6ed8d919$export$6c519d302dced239)(fieldNames));
    return keys;
}
function $f12c6c1651586b87$export$7d40a46ab3886826(treeData, keys, fieldNames) {
    const restKeys = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(keys);
    const nodes = [];
    $f12c6c1651586b87$var$traverseNodesKey(treeData, (key, node)=>{
        const index = restKeys.indexOf(key);
        if (index !== -1) {
            nodes.push(node);
            restKeys.splice(index, 1);
        }
        return !!restKeys.length;
    }, (0, $f32a159b6ed8d919$export$6c519d302dced239)(fieldNames));
    return nodes;
}


"use client";
function $74da52b2346a9578$var$getIcon(props) {
    const { isLeaf: isLeaf, expanded: expanded } = props;
    if (isLeaf) return /*#__PURE__*/ $ltGt3.createElement((0, $5b794eb7912fcf12$export$2e2bcd8739ae039), null);
    return expanded ? /*#__PURE__*/ $ltGt3.createElement((0, $cbd34b02fc891a9b$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $d58a8ea0544bf9d8$export$2e2bcd8739ae039), null);
}
function $74da52b2346a9578$var$getTreeData({ treeData: treeData, children: children }) {
    return treeData || (0, $f32a159b6ed8d919$export$6d8b10995563b669)(children);
}
const $74da52b2346a9578$var$DirectoryTree = ({ defaultExpandAll: defaultExpandAll, defaultExpandParent: defaultExpandParent, defaultExpandedKeys: defaultExpandedKeys, ...props }, ref)=>{
    // Shift click usage
    const lastSelectedKey = $ltGt3.useRef(null);
    const cachedSelectedKeys = $ltGt3.useRef(null);
    const getInitExpandedKeys = ()=>{
        const { keyEntities: keyEntities } = (0, $f32a159b6ed8d919$export$e5d831ce033a4615)($74da52b2346a9578$var$getTreeData(props), {
            fieldNames: props.fieldNames
        });
        let initExpandedKeys;
        // Expanded keys
        if (defaultExpandAll) initExpandedKeys = Object.keys(keyEntities);
        else if (defaultExpandParent) initExpandedKeys = (0, $e9e424090bbd8d70$export$fac4a40c345ccd80)(props.expandedKeys || defaultExpandedKeys || [], keyEntities);
        else initExpandedKeys = props.expandedKeys || defaultExpandedKeys || [];
        return initExpandedKeys;
    };
    const [selectedKeys, setSelectedKeys] = $ltGt3.useState(props.selectedKeys || props.defaultSelectedKeys || []);
    const [expandedKeys, setExpandedKeys] = $ltGt3.useState(()=>getInitExpandedKeys());
    $ltGt3.useEffect(()=>{
        if ('selectedKeys' in props) setSelectedKeys(props.selectedKeys);
    }, [
        props.selectedKeys
    ]);
    $ltGt3.useEffect(()=>{
        if ('expandedKeys' in props) setExpandedKeys(props.expandedKeys);
    }, [
        props.expandedKeys
    ]);
    const onExpand = (keys, info)=>{
        if (!('expandedKeys' in props)) setExpandedKeys(keys);
        // Call origin function
        return props.onExpand?.(keys, info);
    };
    const onSelect = (keys, event)=>{
        const { multiple: multiple, fieldNames: fieldNames } = props;
        const { node: node, nativeEvent: nativeEvent } = event;
        const { key: key = '' } = node;
        const treeData = $74da52b2346a9578$var$getTreeData(props);
        // const newState: DirectoryTreeState = {};
        // We need wrap this event since some value is not same
        const newEvent = {
            ...event,
            selected: true // Directory selected always true
        };
        // Windows / Mac single pick
        const ctrlPick = nativeEvent?.ctrlKey || nativeEvent?.metaKey;
        const shiftPick = nativeEvent?.shiftKey;
        // Generate new selected keys
        let newSelectedKeys;
        if (multiple && ctrlPick) {
            // Control click
            newSelectedKeys = keys;
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $f12c6c1651586b87$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        } else if (multiple && shiftPick) {
            // Shift click
            newSelectedKeys = Array.from(new Set([].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(cachedSelectedKeys.current || []), (0, $83d01b7684a01087$export$2e2bcd8739ae039)((0, $f12c6c1651586b87$export$aad0b800290b42ab)({
                treeData: treeData,
                expandedKeys: expandedKeys,
                startKey: key,
                endKey: lastSelectedKey.current,
                fieldNames: fieldNames
            })))));
            newEvent.selectedNodes = (0, $f12c6c1651586b87$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        } else {
            // Single click
            newSelectedKeys = [
                key
            ];
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $f12c6c1651586b87$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        }
        props.onSelect?.(newSelectedKeys, newEvent);
        if (!('selectedKeys' in props)) setSelectedKeys(newSelectedKeys);
    };
    const { getPrefixCls: getPrefixCls, direction: direction } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showIcon: showIcon = true, expandAction: expandAction = 'click', ...otherProps } = props;
    const prefixCls = getPrefixCls('tree', customizePrefixCls);
    const connectClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-directory`, {
        [`${prefixCls}-directory-rtl`]: direction === 'rtl'
    }, className);
    return /*#__PURE__*/ $ltGt3.createElement((0, $51485bdb7468f5e7$export$2e2bcd8739ae039), {
        icon: $74da52b2346a9578$var$getIcon,
        ref: ref,
        blockNode: true,
        ...otherProps,
        showIcon: showIcon,
        expandAction: expandAction,
        prefixCls: prefixCls,
        className: connectClassName,
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        onSelect: onSelect,
        onExpand: onExpand
    });
};
const $74da52b2346a9578$var$ForwardDirectoryTree = /*#__PURE__*/ $ltGt3.forwardRef($74da52b2346a9578$var$DirectoryTree);
var $74da52b2346a9578$export$2e2bcd8739ae039 = $74da52b2346a9578$var$ForwardDirectoryTree;



"use client";
const $14d9d6c9731a6b94$var$Tree = (0, $51485bdb7468f5e7$export$2e2bcd8739ae039);
$14d9d6c9731a6b94$var$Tree.DirectoryTree = (0, $74da52b2346a9578$export$2e2bcd8739ae039);
$14d9d6c9731a6b94$var$Tree.TreeNode = (0, $6784b3f679540467$export$2e2bcd8739ae039);
var $14d9d6c9731a6b94$export$2e2bcd8739ae039 = $14d9d6c9731a6b94$var$Tree;







var $ltGt3 = parcelRequire("ltGt3");


var $09b211249b4d5395$var$DownloadOutlined = function DownloadOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $33787546712c7579$export$2e2bcd8739ae039)
    }));
};
/**![download](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUwNS43IDY2MWE4IDggMCAwMDEyLjYgMGwxMTItMTQxLjdjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc0LjFWMTY4YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYzMzguM0g0MDBjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45bDExMiAxNDEuOHpNODc4IDYyNmgtNjBjLTQuNCAwLTggMy42LTggOHYxNTRIMjE0VjYzNGMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTk4YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDY4NGMxNy43IDAgMzItMTQuMyAzMi0zMlY2MzRjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ var $09b211249b4d5395$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($09b211249b4d5395$var$DownloadOutlined);
var $09b211249b4d5395$export$2e2bcd8739ae039 = $09b211249b4d5395$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");


var $49862f8da1b29c71$var$EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $8da5c664ebae8d1b$export$2e2bcd8739ae039)
    }));
};
/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */ var $49862f8da1b29c71$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($49862f8da1b29c71$var$EyeInvisibleOutlined);
var $49862f8da1b29c71$export$2e2bcd8739ae039 = $49862f8da1b29c71$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");


var $23373bbf303f3f45$var$EyeOutlined = function EyeOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $ede23975c723e724$export$2e2bcd8739ae039)
    }));
};
/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */ var $23373bbf303f3f45$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($23373bbf303f3f45$var$EyeOutlined);
var $23373bbf303f3f45$export$2e2bcd8739ae039 = $23373bbf303f3f45$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");


var $b7fa69e90b193286$var$QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $aff2e98d038295c5$export$2e2bcd8739ae039)
    }));
};
/**![question-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTYyMy42IDMxNi43QzU5My42IDI5MC40IDU1NCAyNzYgNTEyIDI3NnMtODEuNiAxNC41LTExMS42IDQwLjdDMzY5LjIgMzQ0IDM1MiAzODAuNyAzNTIgNDIwdjcuNmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjQyMGMwLTQ0LjEgNDMuMS04MCA5Ni04MHM5NiAzNS45IDk2IDgwYzAgMzEuMS0yMiA1OS42LTU2LjEgNzIuNy0yMS4yIDguMS0zOS4yIDIyLjMtNTIuMSA0MC45LTEzLjEgMTktMTkuOSA0MS44LTE5LjkgNjQuOVY2MjBjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOHYtMjIuN2E0OC4zIDQ4LjMgMCAwMTMwLjktNDQuOGM1OS0yMi43IDk3LjEtNzQuNyA5Ny4xLTEzMi41LjEtMzkuMy0xNy4xLTc2LTQ4LjMtMTAzLjN6TTQ3MiA3MzJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAweiIgLz48L3N2Zz4=) */ var $b7fa69e90b193286$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($b7fa69e90b193286$var$QuestionCircleOutlined);
var $b7fa69e90b193286$export$2e2bcd8739ae039 = $b7fa69e90b193286$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $c588f06fff8f04c4$var$ToTopOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z"
                }
            }
        ]
    },
    "name": "to-top",
    "theme": "outlined"
};
var $c588f06fff8f04c4$export$2e2bcd8739ae039 = $c588f06fff8f04c4$var$ToTopOutlined;



var $adc78e0e8ff63933$var$ToTopOutlined = function ToTopOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $c588f06fff8f04c4$export$2e2bcd8739ae039)
    }));
};
/**![to-top](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NSA3ODBIMTY1Yy00LjQgMC04IDMuNi04IDh2NjBjMCA0LjQgMy42IDggOCA4aDcyMGM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHpNNDAwIDMyNS43aDczLjlWNjY0YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWMzI1LjdINjI0YzYuNyAwIDEwLjQtNy43IDYuMy0xMi45TDUxOC4zIDE3MWE4IDggMCAwMC0xMi42IDBsLTExMiAxNDEuN2MtNC4xIDUuMy0uNCAxMyA2LjMgMTN6IiAvPjwvc3ZnPg==) */ var $adc78e0e8ff63933$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($adc78e0e8ff63933$var$ToTopOutlined);
var $adc78e0e8ff63933$export$2e2bcd8739ae039 = $adc78e0e8ff63933$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");








var $ltGt3 = parcelRequire("ltGt3");











// =============================== Base ===============================
const $817ae09dfb63af55$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, antCls: antCls, zIndexPopup: zIndexPopup, colorText: colorText, colorWarning: colorWarning, marginXXS: marginXXS, marginXS: marginXS, fontSize: fontSize, fontWeightStrong: fontWeightStrong, colorTextHeading: colorTextHeading } = token;
    return {
        [componentCls]: {
            zIndex: zIndexPopup,
            [`&${antCls}-popover`]: {
                fontSize: fontSize
            },
            [`${componentCls}-message`]: {
                marginBottom: marginXS,
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'start',
                [`> ${componentCls}-message-icon ${iconCls}`]: {
                    color: colorWarning,
                    fontSize: fontSize,
                    lineHeight: 1,
                    marginInlineEnd: marginXS
                },
                [`${componentCls}-title`]: {
                    fontWeight: fontWeightStrong,
                    color: colorTextHeading,
                    '&:only-child': {
                        fontWeight: 'normal'
                    }
                },
                [`${componentCls}-description`]: {
                    marginTop: marginXXS,
                    color: colorText
                }
            },
            [`${componentCls}-buttons`]: {
                textAlign: 'end',
                whiteSpace: 'nowrap',
                button: {
                    marginInlineStart: marginXS
                }
            }
        }
    };
};
const $817ae09dfb63af55$export$9ca1be8807fe0675 = (token)=>{
    const { zIndexPopupBase: zIndexPopupBase } = token;
    return {
        zIndexPopup: zIndexPopupBase + 60
    };
};
var $817ae09dfb63af55$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Popconfirm', (token)=>$817ae09dfb63af55$var$genBaseStyle(token), $817ae09dfb63af55$export$9ca1be8807fe0675, {
    resetStyle: false
});


"use client";
const $d3b0701dd19cdfbb$export$c6fdb837b070b4ff = (props)=>{
    const { prefixCls: prefixCls, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, title: title, description: description, cancelText: cancelText, okText: okText, okType: okType = 'primary', icon: icon = /*#__PURE__*/ $ltGt3.createElement((0, $951db5e2b3978281$export$2e2bcd8739ae039), null), showCancel: showCancel = true, close: close, onConfirm: onConfirm, onCancel: onCancel, onPopupClick: onPopupClick, classNames: classNames, styles: styles } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const [contextLocale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Popconfirm', (0, $29f4f00e8825a41b$export$2e2bcd8739ae039).Popconfirm);
    const titleNode = (0, $428795e0a4a9e60b$export$15e5fca53711d340)(title);
    const descriptionNode = (0, $428795e0a4a9e60b$export$15e5fca53711d340)(description);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-inner-content`,
        onClick: onPopupClick
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-message`
    }, icon && /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-message-icon`
    }, icon), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-message-text`
    }, titleNode && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-title`, classNames?.title),
        style: styles?.title
    }, titleNode), descriptionNode && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-description`, classNames?.content),
        style: styles?.content
    }, descriptionNode))), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-buttons`
    }, showCancel && /*#__PURE__*/ $ltGt3.createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
        onClick: onCancel,
        size: "small",
        ...cancelButtonProps
    }, cancelText || contextLocale?.cancelText), /*#__PURE__*/ $ltGt3.createElement((0, $34d79cb4b2f20181$export$2e2bcd8739ae039), {
        buttonProps: {
            size: 'small',
            ...(0, $ea3450de0c6c5939$export$19bc9a290855952)(okType),
            ...okButtonProps
        },
        actionFn: onConfirm,
        close: close,
        prefixCls: getPrefixCls('btn'),
        quitOnNullishReturnValue: true,
        emitEvent: true
    }, okText || contextLocale?.okText)));
};
const $d3b0701dd19cdfbb$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, placement: placement, className: className, style: style, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('popconfirm', customizePrefixCls);
    (0, $817ae09dfb63af55$export$2e2bcd8739ae039)(prefixCls);
    return /*#__PURE__*/ $ltGt3.createElement((0, $1208369eb14302c3$export$2e2bcd8739ae039), {
        placement: placement,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, className),
        style: style,
        content: /*#__PURE__*/ $ltGt3.createElement($d3b0701dd19cdfbb$export$c6fdb837b070b4ff, {
            prefixCls: prefixCls,
            ...restProps
        })
    });
};
var $d3b0701dd19cdfbb$export$2e2bcd8739ae039 = $d3b0701dd19cdfbb$var$PurePanel;



"use client";
const $851d8bae92f68e93$var$InternalPopconfirm = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, placement: placement = 'top', trigger: trigger = 'click', okType: okType = 'primary', icon: icon = /*#__PURE__*/ $ltGt3.createElement((0, $951db5e2b3978281$export$2e2bcd8739ae039), null), children: children, overlayClassName: overlayClassName, onOpenChange: onOpenChange, overlayStyle: overlayStyle, styles: styles, arrow: popconfirmArrow, classNames: classNames, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('popconfirm');
    const [open, setOpen] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(props.defaultOpen ?? false, props.open);
    const mergedArrow = (0, $3707a18e8e736900$export$2e2bcd8739ae039)(popconfirmArrow, contextArrow);
    const settingOpen = (value, e)=>{
        setOpen(value);
        onOpenChange?.(value, e);
    };
    const close = (e)=>{
        settingOpen(false, e);
    };
    const onConfirm = (e)=>props.onConfirm?.call(undefined, e);
    const onCancel = (e)=>{
        settingOpen(false, e);
        props.onCancel?.call(undefined, e);
    };
    const onInternalOpenChange = (value, e)=>{
        const { disabled: disabled = false } = props;
        if (disabled) return;
        settingOpen(value, e);
    };
    const prefixCls = getPrefixCls('popconfirm', customizePrefixCls);
    const mergedProps = {
        ...props,
        placement: placement,
        trigger: trigger,
        okType: okType,
        overlayStyle: overlayStyle,
        styles: styles,
        classNames: classNames
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, contextClassName, overlayClassName, mergedClassNames.root);
    (0, $817ae09dfb63af55$export$2e2bcd8739ae039)(prefixCls);
    return /*#__PURE__*/ $ltGt3.createElement((0, $6425aad248c6262a$export$2e2bcd8739ae039), {
        arrow: mergedArrow,
        ...(0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(restProps, [
            'title'
        ]),
        trigger: trigger,
        placement: placement,
        onOpenChange: onInternalOpenChange,
        open: open,
        ref: ref,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow
        },
        styles: {
            root: {
                ...contextStyle,
                ...mergedStyles.root,
                ...overlayStyle
            },
            container: mergedStyles.container,
            arrow: mergedStyles.arrow
        },
        content: /*#__PURE__*/ $ltGt3.createElement((0, $d3b0701dd19cdfbb$export$c6fdb837b070b4ff), {
            okType: okType,
            icon: icon,
            ...props,
            prefixCls: prefixCls,
            close: close,
            onConfirm: onConfirm,
            onCancel: onCancel,
            classNames: mergedClassNames,
            styles: mergedStyles
        }),
        "data-popover-inject": true
    }, children);
});
const $851d8bae92f68e93$var$Popconfirm = $851d8bae92f68e93$var$InternalPopconfirm;
// We don't care debug panel
/* istanbul ignore next */ $851d8bae92f68e93$var$Popconfirm._InternalPanelDoNotUseOrYouWillBeFired = (0, $d3b0701dd19cdfbb$export$2e2bcd8739ae039);
var $851d8bae92f68e93$export$2e2bcd8739ae039 = $851d8bae92f68e93$var$Popconfirm;


parcelRequire("ltGt3");



function $11743588678b461d$export$8d31071ec83ef19(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "plant-control-record",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))('plant-control-record__name', !props.isSpecimen && !props.isSingle && 'plant-control-record__name--category', props.isFromGardenPlan && 'plant-control-record__name--garden-plan'),
                children: [
                    props.plantName,
                    props.isFromGardenPlan && !props.isSpecimen && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                        placement: "bottom",
                        title: intl.formatMessage({
                            id: 'plantFromGardenPlan'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                            className: "plant-control-record__garden-plan-tag",
                            color: "gold",
                            children: intl.formatMessage({
                                id: 'gardenPlanTag'
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                className: "plant-control-record__description",
                children: [
                    !props.isSpecimen && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                        placement: "bottom",
                        title: intl.formatMessage({
                            id: 'openPlantDescription'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            size: "small",
                            shape: "circle",
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $792ee1d77f42b361$export$2e2bcd8739ae039), {}),
                            type: "link",
                            onClick: ()=>props.openPlantById(props.plantId)
                        })
                    }),
                    !props.isLocked && props.isPlanted && (props.isSpecimen || props.isSingle) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                        placement: "bottom",
                        title: intl.formatMessage({
                            id: 'digUpPlant'
                        }),
                        children: props.isSinglePlanted ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
                            placement: "bottom",
                            title: intl.formatMessage({
                                id: 'thisIsTheOnlyPlantedSpecimenOfThisPlant'
                            }),
                            description: intl.formatMessage({
                                id: 'afterDiggingThePlantWillBeTransferredToTheUnplantedOnes'
                            }),
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7fa69e90b193286$export$2e2bcd8739ae039), {
                                style: {
                                    color: 'red'
                                }
                            }),
                            onConfirm: async (e)=>{
                                e.stopPropagation();
                                props.digUpPlant(props.plantId, props.specimenNumber);
                            },
                            okText: intl.formatMessage({
                                id: 'continue'
                            }),
                            cancelText: intl.formatMessage({
                                id: 'cancel'
                            }),
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $adc78e0e8ff63933$export$2e2bcd8739ae039), {})
                        }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            size: "small",
                            shape: "circle",
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $adc78e0e8ff63933$export$2e2bcd8739ae039), {}),
                            type: "link",
                            onClick: (e)=>{
                                e.stopPropagation();
                                props.digUpPlant(props.plantId, props.specimenNumber);
                            }
                        })
                    }),
                    !props.isLocked && props.isPlanted && !props.isSpecimen && !props.isSingle && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                        placement: "bottom",
                        title: intl.formatMessage({
                            id: 'digUpAllPlantSpecimens'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
                            placement: "bottom",
                            title: intl.formatMessage({
                                id: 'areYouSureYouWantToDigUpAllTheSpecimensOfThisPlant'
                            }),
                            description: intl.formatMessage({
                                id: 'afterDiggingThePlantWillBeTransferredToTheUnplantedOnes'
                            }),
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7fa69e90b193286$export$2e2bcd8739ae039), {
                                style: {
                                    color: 'red'
                                }
                            }),
                            onConfirm: async ()=>{
                                props.digUpPlant(props.plantId);
                                props.setTool(null);
                            },
                            okText: intl.formatMessage({
                                id: 'yes'
                            }),
                            cancelText: intl.formatMessage({
                                id: 'no'
                            }),
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $5e27bf0dcee8b62c$export$2e2bcd8739ae039), {})
                        })
                    }),
                    !props.isLocked && !props.isPlanted && (props.isSingle || props.isSpecimen) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                        placement: "bottom",
                        title: intl.formatMessage({
                            id: 'plantPlant'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            size: "small",
                            shape: "circle",
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $09b211249b4d5395$export$2e2bcd8739ae039), {}),
                            type: "link",
                            onClick: (e)=>{
                                e.stopPropagation();
                                props.plantPlant(props.plantId, props.specimenNumber);
                            //props.setTool('plant')
                            }
                        })
                    }),
                    !props.isLocked && !props.isSpecimen && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                        placement: "bottom",
                        title: intl.formatMessage({
                            id: 'addPlantSpecimen'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            size: "small",
                            shape: "circle",
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $da40d833ab151490$export$2e2bcd8739ae039), {}),
                            type: "link",
                            onClick: ()=>{
                                props.addPlantSpecimen(props.plantId);
                            }
                        })
                    }),
                    !props.isLocked && props.isSpecimen && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                        placement: "bottom",
                        title: intl.formatMessage({
                            id: 'removePlantSpecimen'
                        }),
                        children: props.isSinglePlanted ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
                            placement: "bottom",
                            title: intl.formatMessage({
                                id: 'thisIsTheOnlyPlantedSpecimenOfThisPlant'
                            }),
                            description: intl.formatMessage({
                                id: 'afterRemovingThePlantWillBeTransferredToTheUnplantedOnes'
                            }),
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7fa69e90b193286$export$2e2bcd8739ae039), {
                                style: {
                                    color: 'red'
                                }
                            }),
                            onConfirm: async ()=>{
                                props.removePlantSpecimen(props.plantId, props.specimenNumber);
                            },
                            okText: intl.formatMessage({
                                id: 'yes'
                            }),
                            cancelText: intl.formatMessage({
                                id: 'no'
                            }),
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $55d49ed7f7b6dd4e$export$2e2bcd8739ae039), {})
                        }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            size: "small",
                            shape: "circle",
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $55d49ed7f7b6dd4e$export$2e2bcd8739ae039), {}),
                            type: "link",
                            onClick: ()=>{
                                props.removePlantSpecimen(props.plantId, props.specimenNumber);
                            }
                        })
                    }),
                    !props.isSpecimen && props.isPlanted && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                        placement: "bottom",
                        title: props.isVisible ? intl.formatMessage({
                            id: 'hidePlantOnSitePlan'
                        }) : intl.formatMessage({
                            id: 'showPlantOnSitePlan'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            size: "small",
                            shape: "circle",
                            icon: props.isVisible ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $23373bbf303f3f45$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $49862f8da1b29c71$export$2e2bcd8739ae039), {}),
                            type: "link",
                            onClick: (e)=>{
                                props.setVisibility(!props.isVisible);
                                e.stopPropagation();
                            }
                        })
                    })
                ]
            })
        ]
    });
}






var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $ae23c34b37e947f2$var$LinkOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M574 665.4a8.03 8.03 0 00-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 00-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 000 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 000 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 00-11.3 0L372.3 598.7a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z"
                }
            }
        ]
    },
    "name": "link",
    "theme": "outlined"
};
var $ae23c34b37e947f2$export$2e2bcd8739ae039 = $ae23c34b37e947f2$var$LinkOutlined;



var $078b852f57e503dd$var$LinkOutlined = function LinkOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $ae23c34b37e947f2$export$2e2bcd8739ae039)
    }));
};
/**![link](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTU3NCA2NjUuNGE4LjAzIDguMDMgMCAwMC0xMS4zIDBMNDQ2LjUgNzgxLjZjLTUzLjggNTMuOC0xNDQuNiA1OS41LTIwNCAwLTU5LjUtNTkuNS01My44LTE1MC4yIDAtMjA0bDExNi4yLTExNi4yYzMuMS0zLjEgMy4xLTguMiAwLTExLjNsLTM5LjgtMzkuOGE4LjAzIDguMDMgMCAwMC0xMS4zIDBMMTkxLjQgNTI2LjVjLTg0LjYgODQuNi04NC42IDIyMS41IDAgMzA2czIyMS41IDg0LjYgMzA2IDBsMTE2LjItMTE2LjJjMy4xLTMuMSAzLjEtOC4yIDAtMTEuM0w1NzQgNjY1LjR6bTI1OC42LTQ3NGMtODQuNi04NC42LTIyMS41LTg0LjYtMzA2IDBMNDEwLjMgMzA3LjZhOC4wMyA4LjAzIDAgMDAwIDExLjNsMzkuNyAzOS43YzMuMSAzLjEgOC4yIDMuMSAxMS4zIDBsMTE2LjItMTE2LjJjNTMuOC01My44IDE0NC42LTU5LjUgMjA0IDAgNTkuNSA1OS41IDUzLjggMTUwLjIgMCAyMDRMNjY1LjMgNTYyLjZhOC4wMyA4LjAzIDAgMDAwIDExLjNsMzkuOCAzOS44YzMuMSAzLjEgOC4yIDMuMSAxMS4zIDBsMTE2LjItMTE2LjJjODQuNS04NC42IDg0LjUtMjIxLjUgMC0zMDYuMXpNNjEwLjEgMzcyLjNhOC4wMyA4LjAzIDAgMDAtMTEuMyAwTDM3Mi4zIDU5OC43YTguMDMgOC4wMyAwIDAwMCAxMS4zbDM5LjYgMzkuNmMzLjEgMy4xIDguMiAzLjEgMTEuMyAwbDIyNi40LTIyNi40YzMuMS0zLjEgMy4xLTguMiAwLTExLjNsLTM5LjUtMzkuNnoiIC8+PC9zdmc+) */ var $078b852f57e503dd$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($078b852f57e503dd$var$LinkOutlined);
var $078b852f57e503dd$export$2e2bcd8739ae039 = $078b852f57e503dd$var$RefIcon;




var $ltGt3 = parcelRequire("ltGt3");

function $b3c9ef2c3743dcd0$export$284b0f68afdd142e(props) {
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [modalOpen, setModalOpen] = (0, $ltGt3.useState)(false);
    const [connectedPlant, setConnectedPlant] = (0, $ltGt3.useState)(null);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        style: {
            display: 'inline-flex',
            flexDirection: 'row',
            textOverflow: 'ellipsis',
            pointerEvents: 'all',
            flex: '1 1 auto'
        },
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                style: {
                    flexGrow: 1,
                    flexShrink: 1
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                    children: props.elementName
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                style: {
                    flexGrow: 0,
                    flexShrink: 0
                },
                children: [
                    props.isSolitariusTemplate && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                                placement: "bottom",
                                title: intl.formatMessage({
                                    id: 'combineElementWithPlant'
                                }),
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    size: "small",
                                    shape: "circle",
                                    icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $078b852f57e503dd$export$2e2bcd8739ae039), {}),
                                    type: "link",
                                    onClick: (e)=>{
                                        setModalOpen(true);
                                        e.stopPropagation();
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f189c84ec54ae7cf$export$2e2bcd8739ae039), {
                                open: modalOpen,
                                onOk: async ()=>{
                                    if (connectedPlant) {
                                        props.onConnectPlant(props.solitariusTemplateElement, connectedPlant.id);
                                        setConnectedPlant(null);
                                        setModalOpen(false);
                                    } else setModalOpen(false);
                                },
                                onCancel: ()=>{
                                    setConnectedPlant(null);
                                    setModalOpen(false);
                                },
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    onClick: (e)=>e.stopPropagation(),
                                    onMouseDown: (e)=>e.stopPropagation(),
                                    style: {
                                        paddingRight: '20px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                            children: intl.formatMessage({
                                                id: 'selectPlantForConnection'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                            style: {
                                                fontStyle: 'italic',
                                                color: 'rgb(244, 130, 84)'
                                            },
                                            children: props.solitariusTemplateElement.name
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                            children: ":"
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
                                            style: {
                                                width: '90%'
                                            },
                                            allowClear: true,
                                            options: props.plantsList?.map((plant)=>({
                                                    label: plant.name,
                                                    value: String(plant.id)
                                                })),
                                            onChange: (chosenPlantId)=>setConnectedPlant({
                                                    id: chosenPlantId,
                                                    name: props.plantsList.find((plant)=>String(plant.id) === chosenPlantId)?.name
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                            style: {
                                                fontStyle: 'italic'
                                            },
                                            children: [
                                                intl.formatMessage({
                                                    id: 'selectPlantForConnectionNote'
                                                }),
                                                "."
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                        placement: "bottom",
                        title: props.isVisible ? intl.formatMessage({
                            id: 'hideElementOnSitePlan'
                        }) : intl.formatMessage({
                            id: 'showElementOnSitePlan'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            size: "small",
                            shape: "circle",
                            icon: props.isVisible ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $23373bbf303f3f45$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $49862f8da1b29c71$export$2e2bcd8739ae039), {}),
                            type: "link",
                            onClick: (e)=>{
                                props.setVisibility(!props.isVisible);
                                e.stopPropagation();
                            }
                        })
                    })
                ]
            })
        ]
    });
}





parcelRequire("ltGt3");






function $7c9d56ba7d57d819$export$2c382ba8a10855ba({ treeDataElements: treeDataElements, onSelectElement: onSelectElement, compositionTreeExpandedKeys: compositionTreeExpandedKeys, setCompositionTreeExpandedKeys: setCompositionTreeExpandedKeys, selectedKeys: selectedKeys, sectionType: sectionType, name: name, description: description, icon: icon }) {
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: `canvas-data__section canvas-data__section--${sectionType}`,
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "canvas-data__section__header",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "canvas-data__section__header__icon",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                            icon: icon
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "canvas-data__section__header__text",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "canvas-data__section__header__text__name",
                                children: intl.formatMessage({
                                    id: name
                                })
                            }),
                            sectionType === 'planted-plants' && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                className: "canvas-data__section__header__text__description",
                                children: [
                                    "(",
                                    description ? intl.formatMessage({
                                        id: description
                                    }) : '',
                                    ")"
                                ]
                            }),
                            sectionType === 'solitarius-templates' && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                className: "canvas-data__section__header__text__description",
                                children: [
                                    "(",
                                    description ? intl.formatMessage({
                                        id: description
                                    }) : '',
                                    " ",
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $078b852f57e503dd$export$2e2bcd8739ae039), {}),
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "canvas-data__section__data",
                children: treeDataElements.length > 0 ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14d9d6c9731a6b94$export$2e2bcd8739ae039), {
                    multiple: true,
                    defaultExpandAll: false,
                    onSelect: onSelectElement,
                    expandedKeys: compositionTreeExpandedKeys,
                    onExpand: (keys, _info)=>setCompositionTreeExpandedKeys(keys),
                    selectedKeys: selectedKeys,
                    treeData: treeDataElements,
                    showIcon: true,
                    className: "elements-tree"
                }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                    className: "canvas-data__section__data__empty",
                    children: intl.formatMessage({
                        id: `noEntries`
                    })
                })
            })
        ]
    });
}



var $ltGt3 = parcelRequire("ltGt3");

const $06d8e952a1c52731$export$ab7620bfda727fc3 = 'gardenPlanVariant';
function $06d8e952a1c52731$export$7796d9afff69f3c5() {
    const [searchParams, setSearchParams] = (0, $6816d30a3e97278a$export$f1a78c17382fe22a)();
    const gardenPlanVariantId = searchParams.get($06d8e952a1c52731$export$ab7620bfda727fc3);
    const setGardenPlanVariantId = (0, $ltGt3.useCallback)((id)=>setSearchParams((params)=>{
            if (id) params.set($06d8e952a1c52731$export$ab7620bfda727fc3, id);
            else params.delete($06d8e952a1c52731$export$ab7620bfda727fc3);
            return params;
        }, {
            replace: true
        }), [
        setSearchParams
    ]);
    const withGardenPlanVariant = (0, $ltGt3.useCallback)((path)=>gardenPlanVariantId ? `${path}?${new URLSearchParams({
            [$06d8e952a1c52731$export$ab7620bfda727fc3]: gardenPlanVariantId
        })}` : path, [
        gardenPlanVariantId
    ]);
    return {
        gardenPlanVariantId: gardenPlanVariantId,
        setGardenPlanVariantId: setGardenPlanVariantId,
        withGardenPlanVariant: withGardenPlanVariant
    };
}


const { DirectoryTree: $742daf991fe38d83$var$DirectoryTree } = (0, $14d9d6c9731a6b94$export$2e2bcd8739ae039);
function $742daf991fe38d83$var$filterPlants(plants, type) {
    if (type === 'unplantedPlants') return plants.filter((plant)=>{
        if (!plant.coordinates || plant.coordinates.length === 0) return true;
        for(let index = 0; index < plant.coordinates.length; index++){
            if (Object.keys(plant.coordinates[index]).length > 0) return false;
        }
        return true;
    });
    else if (type === 'separatelyGrowing') return plants.filter((plant)=>{
        if (plant.elementId || !plant.coordinates || plant.coordinates.length === 0) return false;
        for(let index = 0; index < plant.coordinates.length; index++){
            if (Object.keys(plant.coordinates[index]).length > 0) return true;
        }
        return false;
    });
}
function $742daf991fe38d83$export$35ba9555a814f25c({ elements: elements, projectPlants: projectPlants, currentPlant: currentPlant, setCurrentPlant: setCurrentPlant, currentElementId: currentElementId, setCurrentElementId: setCurrentElementId, setPlantVisible: setPlantVisible, setElementVisible: setElementVisible, openPlantById: openPlantById, setTool: setTool, digUpPlant: digUpPlant, plantPlant: plantPlant, addPlantSpecimen: addPlantSpecimen, removePlantSpecimen: removePlantSpecimen, connectSolitariusTemplateToPlant: connectSolitariusTemplateToPlant, lockedPlantIds: lockedPlantIds = [] }) {
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [activeKey, setActiveKey] = (0, $ltGt3.useState)('1');
    const { gardenPlanVariantId: gardenPlanVariantId } = (0, $06d8e952a1c52731$export$7796d9afff69f3c5)();
    const unplantedPlants = $742daf991fe38d83$var$filterPlants(projectPlants, 'unplantedPlants');
    const unplantedPlantsCount = unplantedPlants.length;
    const previousPlantsCount = (0, $ltGt3.useRef)(projectPlants.length);
    const previousUnplantedPlantsCount = (0, $ltGt3.useRef)(unplantedPlantsCount);
    const previousGardenPlanVariantId = (0, $ltGt3.useRef)(gardenPlanVariantId);
    (0, $ltGt3.useEffect)(()=>{
        const isGardenPlanVariantChanged = gardenPlanVariantId !== previousGardenPlanVariantId.current;
        const hasUnplantedPlantsInGardenPlanVariant = unplantedPlants.some((plant)=>(plant.gardenPlanVariantId ?? null) === gardenPlanVariantId);
        if (isGardenPlanVariantChanged && !hasUnplantedPlantsInGardenPlanVariant) setActiveKey('1');
        else if (projectPlants.length > previousPlantsCount.current) setActiveKey('2');
        else if (unplantedPlantsCount < previousUnplantedPlantsCount.current) setActiveKey('1');
        previousPlantsCount.current = projectPlants.length;
        previousUnplantedPlantsCount.current = unplantedPlantsCount;
        previousGardenPlanVariantId.current = gardenPlanVariantId;
    }, [
        projectPlants.length,
        unplantedPlantsCount,
        gardenPlanVariantId
    ]);
    const [compositionTreeExpandedKeys, setCompositionTreeExpandedKeys] = (0, $ltGt3.useState)([
        1
    ]);
    const [unplantedTreeExpandedKeys, setUnplantedTreeExpandedKeys] = (0, $ltGt3.useState)([
        0
    ]);
    const addPlantSpecimenToCompositionTree = (plantId, newSpecimenCoordinates)=>{
        setCompositionTreeExpandedKeys((current)=>{
            const currentSet = new Set(current);
            currentSet.add(plantId);
            return [
                ...currentSet
            ];
        });
        addPlantSpecimen(plantId, newSpecimenCoordinates);
    };
    const addPlantSpecimenToUnplantedTree = (plantId, newSpecimenCoordinates)=>{
        setUnplantedTreeExpandedKeys((current)=>{
            const currentSet = new Set(current);
            currentSet.add(plantId);
            return [
                ...currentSet
            ];
        });
        addPlantSpecimen(plantId, newSpecimenCoordinates);
    };
    const onSelectElement = (keys, info)=>{
        if (!info.node.isPlant) {
            const newCurrentElementId = info.node.elementId;
            if (newCurrentElementId === currentElementId) setCurrentElementId(null);
            else setCurrentElementId(newCurrentElementId);
        } else {
            const newCurrentPlantId = info.node.plantId;
            const newSpecimenIndex = info.node.specimenIndex;
            if (newCurrentPlantId === currentPlant?.id && newSpecimenIndex === currentPlant?.specimenIndex) setCurrentPlant(null);
            else setCurrentPlant({
                id: newCurrentPlantId,
                specimenIndex: newSpecimenIndex
            });
        }
    };
    const onSelectUnplantedPlant = (keys, info)=>{
        if (!info.node.isPlant) {
            const newCurrentElementId = info.node.elementId //= parseInt(`${keys[0]}`, 10)
            ;
            if (newCurrentElementId === currentElementId) setCurrentElementId(null);
            else setCurrentElementId(newCurrentElementId);
        } else {
            const newCurrentPlantId = info.node.plantId;
            const newSpecimenIndex = info.node.specimenIndex;
            if (newCurrentPlantId === currentPlant?.id && newSpecimenIndex === currentPlant?.specimenIndex) setCurrentPlant(null);
            else setCurrentPlant({
                id: newCurrentPlantId,
                specimenIndex: newSpecimenIndex
            });
        }
    };
    function plantsTreeDataGenerator(plants, setPlantVisible, openPlantById, setTool, digUpPlant, plantPlant, addPlantSpecimen, removePlantSpecimen) {
        const sortedPlants = [
            ...plants
        ].sort((a, b)=>Number(!!b.gardenPlanVariantId) - Number(!!a.gardenPlanVariantId));
        const treePlants = sortedPlants.map((plant)=>{
            const numberOfPlantedSpecimens = plant.coordinates.map((coords)=>Object.keys(coords).length).filter((a)=>a > 0).length;
            const numberOfSpecimens = plant.coordinates.length;
            const isPlantPlanted = plant.coordinates.length >= 1 && plant.coordinates.map((coords)=>Object.keys(coords).length).some((a)=>a > 0);
            return {
                key: `1-${plant.id}`,
                title: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $11743588678b461d$export$8d31071ec83ef19), {
                    plantName: `${plant.name} 
            ${isPlantPlanted && numberOfSpecimens === 1 && numberOfSpecimens === numberOfPlantedSpecimens ? `` : ``}
            ${isPlantPlanted && numberOfSpecimens > 1 && numberOfSpecimens === numberOfPlantedSpecimens ? `(${numberOfSpecimens})` : ``}
            ${isPlantPlanted && numberOfSpecimens > 1 && numberOfSpecimens !== numberOfPlantedSpecimens ? `(${intl.formatMessage({
                        id: `planted`
                    })} ${numberOfPlantedSpecimens} ${intl.formatMessage({
                        id: `from2`
                    })} ${numberOfSpecimens})` : ``}
            ${!isPlantPlanted && numberOfSpecimens <= 1 ? `` : ``}
            ${!isPlantPlanted && numberOfSpecimens > 1 ? `(${intl.formatMessage({
                        id: `notPlanted`
                    })} ${numberOfSpecimens})` : ``}
            `,
                    isPlanted: isPlantPlanted,
                    isSingle: plant.coordinates.length <= 1,
                    isSinglePlanted: plant.coordinates.length <= 1 && isPlantPlanted,
                    isFromGardenPlan: !!plant.gardenPlanVariantId,
                    isLocked: lockedPlantIds.includes(plant.id),
                    isSpecimen: false,
                    specimenNumber: null,
                    isVisible: plant.isVisible,
                    plantId: plant.id,
                    setVisibility: (isVisible)=>{
                        setPlantVisible(plant.id, isVisible);
                    },
                    openPlantById: openPlantById,
                    setTool: setTool,
                    digUpPlant: digUpPlant,
                    plantPlant: plantPlant,
                    addPlantSpecimen: addPlantSpecimen
                }),
                isLeaf: plant.coordinates.length <= 1 ? true : false,
                isPlant: true,
                plantId: plant.id,
                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                    src: (0, $670e204136b37e30$export$9544d5bb712b01ea).getElementType('plant').templates[(0, $670e204136b37e30$export$9544d5bb712b01ea).chooseElementTypeTemplate('plant', plant.template)].src,
                    width: 20,
                    height: 20,
                    style: {
                        display: 'inline-flex'
                    }
                }),
                children: plant.coordinates.length <= 1 ? null : plant.coordinates.map((plantSpecimen, index)=>({
                        key: `${plant.id}-${index}`,
                        title: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $11743588678b461d$export$8d31071ec83ef19), {
                            plantName: `${plant.name} ${Object.keys(plantSpecimen).length > 0 ? `` : `(${intl.formatMessage({
                                id: `notPlanted`
                            })})`}`,
                            isPlanted: Object.keys(plantSpecimen).length === 0 ? false : true,
                            isSingle: false,
                            isSinglePlanted: Object.keys(plantSpecimen).length === 0 ? false : numberOfPlantedSpecimens === 1,
                            isSpecimen: true,
                            isFromGardenPlan: !!plant.gardenPlanVariantId,
                            isLocked: lockedPlantIds.includes(plant.id),
                            isVisible: true,
                            plantId: plant.id,
                            setVisibility: ()=>{},
                            openPlantById: openPlantById,
                            setTool: setTool,
                            digUpPlant: digUpPlant,
                            plantPlant: plantPlant,
                            specimenNumber: index,
                            removePlantSpecimen: removePlantSpecimen
                        }),
                        isLeaf: true,
                        isPlant: true,
                        plantId: plant.id,
                        specimenIndex: index,
                        icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                            src: (0, $670e204136b37e30$export$9544d5bb712b01ea).getElementType('plant').templates[(0, $670e204136b37e30$export$9544d5bb712b01ea).chooseElementTypeTemplate('plant', plant.template)].src,
                            width: 20,
                            height: 20,
                            style: {
                                display: 'inline-flex'
                            }
                        })
                    }))
            };
        });
        return treePlants;
    }
    //const treeDataElements: DataNode[] = []
    const treeDataElementsSeparatelyGrowing = [];
    const treeDataElementsSOlitariusTemplates = [];
    const treeDataElementsOther = [];
    const treeUnplantedDataElements = [];
    const elementsPerType = new Map();
    const elementsPerSolitariusType = new Map();
    const solitariusTemplateTypes = (0, $670e204136b37e30$export$9544d5bb712b01ea).getSolitariusElementTypes();
    for (const element of elements){
        const elementType = element.type;
        const elementTypesArray = elementsPerType.get(elementType) || elementsPerSolitariusType.get(elementType) || [];
        elementTypesArray.push(element);
        solitariusTemplateTypes.some((t)=>t === elementType) ? elementsPerSolitariusType.set(elementType, elementTypesArray) : elementsPerType.set(elementType, elementTypesArray);
    }
    // treeDataElementsSeparatelyGrowing.push({
    //   key: 1,
    //   title: intl.formatMessage({id: 'separatelyGrowing'}),
    //   children: plantsTreeDataGenerator(
    //     // projectPlants.filter(
    //     //   (plant) => !plant.elementId && plant.coordinates && plant.coordinates.length > 0
    //     // ),
    //     filterPlants(projectPlants, 'separatelyGrowing'),
    //     setPlantVisible,
    //     openPlantById,
    //     setTool,
    //     digUpPlant,
    //     plantPlant,
    //     addPlantSpecimenToCompositionTree,
    //     removePlantSpecimen
    //   ),
    // })
    //const separatelyGrowingPlants = filterPlants(projectPlants, 'separatelyGrowing')
    for (const plant of plantsTreeDataGenerator($742daf991fe38d83$var$filterPlants(projectPlants, 'separatelyGrowing'), setPlantVisible, openPlantById, setTool, digUpPlant, plantPlant, addPlantSpecimenToCompositionTree, removePlantSpecimen))treeDataElementsSeparatelyGrowing.push(plant);
    for (const elementTypeId of elementsPerSolitariusType.keys()){
        const elementType = (0, $670e204136b37e30$export$9544d5bb712b01ea).getElementType(elementTypeId);
        treeDataElementsSOlitariusTemplates.push({
            key: elementTypeId,
            title: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                style: {
                    color: 'green'
                },
                children: intl.formatMessage({
                    id: `${elementType.displayName}Plural`
                })
            }),
            children: elementsPerSolitariusType.get(elementTypeId).map((element)=>({
                    key: element.elementId,
                    elementId: element.elementId,
                    title: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b3c9ef2c3743dcd0$export$284b0f68afdd142e), {
                        elementName: element.name === '' ? intl.formatMessage({
                            id: `noTitle`
                        }) : element.name,
                        elementId: element.elementId,
                        isVisible: element.isVisible,
                        setVisibility: (isVisible)=>{
                            setElementVisible(element.elementId, isVisible);
                        },
                        isSolitariusTemplate: true,
                        solitariusTemplateElement: element,
                        plantsList: projectPlants,
                        elementsList: elements,
                        onConnectPlant: connectSolitariusTemplateToPlant
                    }),
                    isPlant: false,
                    children: plantsTreeDataGenerator(projectPlants.filter((plant)=>plant.elementId === element.elementId), setPlantVisible, openPlantById, setTool, digUpPlant, plantPlant, addPlantSpecimenToCompositionTree, removePlantSpecimen)
                }))
        });
    }
    for (const elementTypeId of elementsPerType.keys()){
        const elementType = (0, $670e204136b37e30$export$9544d5bb712b01ea).getElementType(elementTypeId);
        treeDataElementsOther.push({
            key: elementTypeId,
            title: intl.formatMessage({
                id: `${elementType.displayName}Plural`
            }),
            children: elementsPerType.get(elementTypeId).map((element)=>({
                    key: element.elementId,
                    elementId: element.elementId,
                    title: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b3c9ef2c3743dcd0$export$284b0f68afdd142e), {
                        elementName: element.name === '' ? intl.formatMessage({
                            id: `noTitle`
                        }) : element.name,
                        elementId: element.elementId,
                        isVisible: element.isVisible,
                        setVisibility: (isVisible)=>{
                            setElementVisible(element.elementId, isVisible);
                        },
                        isSolitariusTemplate: false
                    }),
                    isPlant: false,
                    children: plantsTreeDataGenerator(projectPlants.filter((plant)=>plant.elementId === element.elementId), setPlantVisible, openPlantById, setTool, digUpPlant, plantPlant, addPlantSpecimenToCompositionTree, removePlantSpecimen)
                }))
        });
    }
    treeUnplantedDataElements.push({
        key: 0,
        title: intl.formatMessage({
            id: 'unplantedPlants'
        }),
        children: plantsTreeDataGenerator($742daf991fe38d83$var$filterPlants(projectPlants, 'unplantedPlants'), setPlantVisible, openPlantById, setTool, digUpPlant, plantPlant, addPlantSpecimenToUnplantedTree, removePlantSpecimen)
    });
    const treeDataPlants = [];
    for (const plant of projectPlants)if (plant.elementId === currentElementId || currentElementId === null) treeDataPlants.push(plant);
    const elementKey = currentElementId;
    const plantKey = currentPlant?.id;
    const plantSpecimenKey = plantKey && typeof currentPlant?.specimenIndex === 'number' && `${plantKey}-${currentPlant?.specimenIndex}`;
    const selectedKeys = [
        elementKey
    ];
    if (plantKey) {
        selectedKeys.push(plantKey);
        if (plantSpecimenKey) selectedKeys.push(plantSpecimenKey);
    }
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $77eacb4b734e6c42$export$2e2bcd8739ae039), {
                onChange: (key)=>setActiveKey(key),
                type: "card",
                className: "canvas-data",
                activeKey: activeKey,
                items: [
                    {
                        key: '1',
                        label: intl.formatMessage({
                            id: 'projectComposition'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7c9d56ba7d57d819$export$2c382ba8a10855ba), {
                                    treeDataElements: treeDataElementsSeparatelyGrowing,
                                    onSelectElement: onSelectElement,
                                    compositionTreeExpandedKeys: compositionTreeExpandedKeys,
                                    setCompositionTreeExpandedKeys: setCompositionTreeExpandedKeys,
                                    selectedKeys: selectedKeys,
                                    sectionType: "planted-plants",
                                    name: "plantedPlants",
                                    description: "canvasDataDescriptionSeparatlyGrowing",
                                    icon: $1113a0aa61ab7765$export$8db7f2f70484e17e
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7c9d56ba7d57d819$export$2c382ba8a10855ba), {
                                    treeDataElements: treeDataElementsSOlitariusTemplates,
                                    onSelectElement: onSelectElement,
                                    compositionTreeExpandedKeys: compositionTreeExpandedKeys,
                                    setCompositionTreeExpandedKeys: setCompositionTreeExpandedKeys,
                                    selectedKeys: selectedKeys,
                                    sectionType: "solitarius-templates",
                                    name: "plantModelWithoutPlantRecord",
                                    description: "canvasDataDescriptionSolitariusTemplates",
                                    icon: $1113a0aa61ab7765$export$d7b60b8dbd03cfe4
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7c9d56ba7d57d819$export$2c382ba8a10855ba), {
                                    treeDataElements: treeDataElementsOther,
                                    onSelectElement: onSelectElement,
                                    compositionTreeExpandedKeys: compositionTreeExpandedKeys,
                                    setCompositionTreeExpandedKeys: setCompositionTreeExpandedKeys,
                                    selectedKeys: selectedKeys,
                                    sectionType: "other-elements",
                                    name: "otherSiteElements",
                                    description: null,
                                    icon: $1113a0aa61ab7765$export$75825a4c2b3375e
                                })
                            ]
                        })
                    },
                    {
                        key: '2',
                        label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                            style: {
                                display: 'flex',
                                alignItems: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                    style: {
                                        flex: '0 1 auto',
                                        textWrap: 'wrap'
                                    },
                                    children: intl.formatMessage({
                                        id: 'unplantedPlants'
                                    })
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a382abb3be4865b2$export$2e2bcd8739ae039), {
                                    count: treeUnplantedDataElements[0].children.length,
                                    style: {
                                        marginLeft: '5px',
                                        backgroundColor: '#f58153'
                                    }
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14d9d6c9731a6b94$export$2e2bcd8739ae039), {
                            // style={{
                            //   overflow: 'hidden',
                            //   overflowY: 'scroll',
                            // }}
                            multiple: true,
                            onSelect: onSelectUnplantedPlant,
                            expandedKeys: unplantedTreeExpandedKeys,
                            onExpand: (keys, _info)=>setUnplantedTreeExpandedKeys(keys),
                            selectedKeys: selectedKeys,
                            treeData: treeUnplantedDataElements,
                            showIcon: true,
                            className: "elements-tree"
                        })
                    }
                ]
            })
        ]
    });
}




function $3ec6bec65f655645$export$18cfe0f06ae2a925({ projectId: projectId, plotShape: plotShape, elements: elements, editable: editable, projectPlants: projectPlants, hasMap: hasMap, openPlantById: openPlantById, gardenPlanSelector: gardenPlanSelector }) {
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const language = intl.locale;
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    const pendingPlantChange = (0, $ltGt3.useRef)(null);
    const [currentElementId, setCurrentElementId] = (0, $ltGt3.useState)(null);
    const [currentPlant, setCurrentPlant] = (0, $ltGt3.useState)(null);
    const [plantsHiddenRecord, setPlantsHiddenRecord] = (0, $ltGt3.useState)({});
    const [elementsHiddenRecord, setElementsHiddenRecord] = (0, $ltGt3.useState)({});
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const { gardenPlanVariantId: gardenPlanVariantId, withGardenPlanVariant: withGardenPlanVariant } = (0, $06d8e952a1c52731$export$7796d9afff69f3c5)();
    // main project plants can't be changed while a plan variant is active
    const lockedPlantIds = (0, $ltGt3.useMemo)(()=>gardenPlanVariantId ? projectPlants.filter((plant)=>!plant.gardenPlanVariantId).map((plant)=>plant.id) : [], [
        gardenPlanVariantId,
        projectPlants
    ]);
    const isCurrentPlantLocked = !!currentPlant && lockedPlantIds.includes(currentPlant.id);
    const [tool, setTool] = (0, $ltGt3.useState)(null);
    const elementsPerType = new Map();
    for (const element of elements){
        const elementType = element.type;
        const elementTypesArray = elementsPerType.get(elementType) || [];
        elementTypesArray.push(element);
        elementsPerType.set(elementType, elementTypesArray);
    }
    const plantedProjectPlants = projectPlants.filter((plant)=>plant.coordinates);
    const editCurrentPlantProps = (0, $ltGt3.useCallback)(async (elementProps, specimenIndex)=>{
        if (!currentPlant || lockedPlantIds.includes(currentPlant.id)) return;
        const plant = projectPlants.find((plant)=>plant.id === currentPlant.id);
        if (!plant) return;
        const updatedElement = {
            x: elementProps.x,
            y: elementProps.y,
            width: elementProps.width,
            height: elementProps.height
        };
        const result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).editPlant({
            ...plant,
            coordinates: typeof currentPlant.specimenIndex === 'number' ? plant.coordinates.map((coordinates, index)=>{
                if (index === currentPlant.specimenIndex) return updatedElement;
                else return coordinates;
            }) : [
                updatedElement
            ]
        }, language);
        if (result.success) submit(null, {
            method: 'post'
        });
        else messageApi.open({
            type: 'error',
            content: result.error
        });
    }, [
        currentPlant?.id,
        currentPlant?.specimenIndex,
        projectPlants,
        lockedPlantIds
    ]);
    async function digUpPlant(diggingPlantId, diggingPlantSpecimenNumber) {
        const result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).removePlantFromCanvas(//diggingPlantId ? diggingPlantId : currentPlant.id,
        diggingPlantId, projectPlants.find((plant)=>plant.id === diggingPlantId).coordinates, diggingPlantSpecimenNumber);
        setTool(null);
        if (result.success) {
            submit(null, {
                method: 'post'
            });
            revalidator.revalidate();
            setCurrentPlant(null);
        } else messageApi.open({
            type: 'error',
            content: result.error?.message
        });
    }
    async function connectSolitariusTemplateToPlant(solitariusTemplateElement, plantId) {
        const result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).connectSolitariusTemplateToPlant(solitariusTemplateElement, parseInt(plantId, 10), projectId, projectPlants, elements);
        if (result.success) {
            submit(null, {
                method: 'post'
            });
            revalidator.revalidate();
        } else messageApi.open({
            type: 'error',
            content: result.error
        });
    }
    async function plantPlant(plantingPlantId, plantingPlantSpecimenNumber) {
        //setCurrentElementId(null)
        setCurrentPlant({
            id: plantingPlantId,
            specimenIndex: plantingPlantSpecimenNumber
        });
        setTool('plant');
    }
    async function addPlantSpecimen(plantId, newSpecimenCoordinates) {
        const result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).addPlantSpecimen(plantId, projectId, projectPlants.find((plant)=>plant.id === plantId).coordinates);
        setTool(null);
        if (result.success) {
            submit(null, {
                method: 'post'
            });
            revalidator.revalidate();
        } else messageApi.open({
            type: 'error',
            content: result.error?.message
        });
    }
    async function duplicatePlant(duplicatingPlantId, specimenNumber, specimenQuantity, direction) {
        const oldCoordinates = projectPlants.find((plant)=>plant.id === duplicatingPlantId).coordinates;
        const duplicatingSpecimenCoordinates = oldCoordinates[specimenNumber];
        const newCoordinates = [];
        for(let i = 0; i < specimenQuantity; i++)newCoordinates.push({
            ...duplicatingSpecimenCoordinates,
            x: duplicatingSpecimenCoordinates.x + duplicatingSpecimenCoordinates.width
        });
        const result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).addPlantSpecimen(duplicatingPlantId, projectId, oldCoordinates, newCoordinates);
        setTool(null);
        if (result.success) {
            submit(null, {
                method: 'post'
            });
            revalidator.revalidate();
            setCurrentPlant({
                id: currentPlant.id,
                specimenIndex: oldCoordinates.length + newCoordinates.length - 1
            });
        } else messageApi.open({
            type: 'error',
            content: result.error?.message
        });
    }
    async function removePlantSpecimen(plantId, plantSpecimenNumber) {
        const result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).removePlantSpecimen(plantId, projectId, projectPlants.find((plant)=>plant.id === plantId).coordinates, plantSpecimenNumber);
        setTool(null);
        if (result.success) {
            submit(null, {
                method: 'post'
            });
            revalidator.revalidate();
        } else messageApi.open({
            type: 'error',
            content: result.error?.message
        });
    }
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "view-project__plant-buttons",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        disabled: !currentPlant || isCurrentPlantLocked,
                        onClick: async ()=>{
                            setTool('plant');
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $c3c073aab5c77f59$export$2e2bcd8739ae039), {}),
                            projectPlants.find((plant)=>plant.id === currentPlant?.id)?.coordinates.length > 0 ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9d004cf64875b9d1$exports.Fragment), {
                                children: intl.formatMessage({
                                    id: 'replantPlant'
                                })
                            }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9d004cf64875b9d1$exports.Fragment), {
                                children: intl.formatMessage({
                                    id: 'plantPlant'
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        disabled: !currentPlant || isCurrentPlantLocked,
                        onClick: ()=>digUpPlant(currentPlant.id),
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1e0519456d104339$export$2e2bcd8739ae039), {}),
                            " ",
                            intl.formatMessage({
                                id: 'digUpPlant'
                            })
                        ]
                    }),
                    gardenPlanSelector,
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        id: "button-no-todos",
                        className: "add-plant-button",
                        onClick: ()=>{
                            navigate(withGardenPlanVariant(`/projects/${projectId}/plants/new`));
                        },
                        style: projectPlants.length > 0 ? {
                            color: '#f67d4e'
                        } : {
                            backgroundColor: '#f67d4e',
                            color: 'white'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3511e38a5bf0c930$export$2e2bcd8739ae039), {
                                style: {
                                    fontWeight: '700'
                                }
                            }),
                            projectPlants.length > 0 ? intl.formatMessage({
                                id: 'addPlant'
                            }) : intl.formatMessage({
                                id: 'createTheFirstPlantInTheProject'
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "view-project__canvas",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $395d89d67d098b23$export$e3d016329f8674e7), {
                    canvasEditorProps: {
                        projectId: projectId,
                        plotShape: plotShape,
                        elements: elements.filter((element)=>!elementsHiddenRecord[element.elementId]),
                        plants: plantedProjectPlants.filter((plant)=>!plantsHiddenRecord[plant.id]),
                        selectable: true,
                        plotShapeEditable: false,
                        editableTypes: [
                            'plant'
                        ],
                        lockedPlantIds: lockedPlantIds,
                        openPlantById: openPlantById,
                        selectedElementId: currentElementId,
                        setSelectedElementId: setCurrentElementId,
                        digUpPlant: digUpPlant,
                        duplicatePlant: duplicatePlant,
                        selectedPlant: currentPlant ? {
                            ...currentPlant,
                            name: projectPlants.find((plant)=>plant.id === currentPlant?.id)?.name
                        } : null,
                        setSelectedPlant: setCurrentPlant,
                        onElementChanged: (updatedElement)=>{
                            pendingPlantChange.current = {
                                updatedElement: updatedElement
                            };
                        },
                        hasMap: hasMap,
                        activeDraggableElement: null,
                        async onMouseUp () {
                            if (pendingPlantChange.current) {
                                const element = pendingPlantChange.current.updatedElement;
                                if (element.type !== 'plant') return;
                                await editCurrentPlantProps(element.props, element.specimenIndex);
                            }
                            pendingPlantChange.current = null;
                        }
                    },
                    tool: tool,
                    onElementDrawn: async function(shape) {
                        if (tool !== 'plant') {
                            setTool(null);
                            return;
                        }
                        await editCurrentPlantProps(shape.props, null);
                        setTool(null);
                    }
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "view-project__canvas-data",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $742daf991fe38d83$export$35ba9555a814f25c), {
                    elements: elements.map((element)=>({
                            ...element,
                            isVisible: !elementsHiddenRecord[element.elementId]
                        })),
                    projectPlants: projectPlants.map((plant)=>({
                            ...plant,
                            isVisible: !plantsHiddenRecord[plant.id]
                        })),
                    setPlantVisible: (plantId, isVisible)=>{
                        setPlantsHiddenRecord((current)=>({
                                ...current,
                                [plantId]: !isVisible
                            }));
                    },
                    setElementVisible: (elementId, isVisible)=>{
                        setElementsHiddenRecord((current)=>({
                                ...current,
                                [elementId]: !isVisible
                            }));
                    },
                    currentPlant: currentPlant,
                    setCurrentPlant: setCurrentPlant,
                    currentElementId: currentElementId,
                    setCurrentElementId: setCurrentElementId,
                    openPlantById: openPlantById,
                    setTool: setTool,
                    digUpPlant: digUpPlant,
                    plantPlant: plantPlant,
                    addPlantSpecimen: addPlantSpecimen,
                    removePlantSpecimen: removePlantSpecimen,
                    connectSolitariusTemplateToPlant: connectSolitariusTemplateToPlant,
                    lockedPlantIds: lockedPlantIds
                }, projectId)
            })
        ]
    });
}



parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");











var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $4a925ea9a82b34f3$var$DoubleLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    },
    "name": "double-left",
    "theme": "outlined"
};
var $4a925ea9a82b34f3$export$2e2bcd8739ae039 = $4a925ea9a82b34f3$var$DoubleLeftOutlined;



function $54a07f0b2f5e90b8$var$_extends() {
    $54a07f0b2f5e90b8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $54a07f0b2f5e90b8$var$_extends.apply(this, arguments);
}
const $54a07f0b2f5e90b8$var$DoubleLeftOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $54a07f0b2f5e90b8$var$_extends({}, props, {
        ref: ref,
        icon: (0, $4a925ea9a82b34f3$export$2e2bcd8739ae039)
    }));
/**![double-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI3Mi45IDUxMmwyNjUuNC0zMzkuMWM0LjEtNS4yLjQtMTIuOS02LjMtMTIuOWgtNzcuM2MtNC45IDAtOS42IDIuMy0xMi42IDYuMUwxODYuOCA0OTIuM2EzMS45OSAzMS45OSAwIDAwMCAzOS41bDI1NS4zIDMyNi4xYzMgMy45IDcuNyA2LjEgMTIuNiA2LjFINTMyYzYuNyAwIDEwLjQtNy43IDYuMy0xMi45TDI3Mi45IDUxMnptMzA0IDBsMjY1LjQtMzM5LjFjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc3LjNjLTQuOSAwLTkuNiAyLjMtMTIuNiA2LjFMNDkwLjggNDkyLjNhMzEuOTkgMzEuOTkgMCAwMDAgMzkuNWwyNTUuMyAzMjYuMWMzIDMuOSA3LjcgNi4xIDEyLjYgNi4xSDgzNmM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1NzYuOSA1MTJ6IiAvPjwvc3ZnPg==) */ const $54a07f0b2f5e90b8$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($54a07f0b2f5e90b8$var$DoubleLeftOutlined);
var $54a07f0b2f5e90b8$export$2e2bcd8739ae039 = $54a07f0b2f5e90b8$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $b350722fea640ff1$var$DoubleRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    },
    "name": "double-right",
    "theme": "outlined"
};
var $b350722fea640ff1$export$2e2bcd8739ae039 = $b350722fea640ff1$var$DoubleRightOutlined;



function $8ff117f64627ba29$var$_extends() {
    $8ff117f64627ba29$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8ff117f64627ba29$var$_extends.apply(this, arguments);
}
const $8ff117f64627ba29$var$DoubleRightOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $8ff117f64627ba29$var$_extends({}, props, {
        ref: ref,
        icon: (0, $b350722fea640ff1$export$2e2bcd8739ae039)
    }));
/**![double-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzMy4yIDQ5Mi4zTDI3Ny45IDE2Ni4xYy0zLTMuOS03LjctNi4xLTEyLjYtNi4xSDE4OGMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlMNDQ3LjEgNTEyIDE4MS43IDg1MS4xQTcuOTggNy45OCAwIDAwMTg4IDg2NGg3Ny4zYzQuOSAwIDkuNi0yLjMgMTIuNi02LjFsMjU1LjMtMzI2LjFjOS4xLTExLjcgOS4xLTI3LjkgMC0zOS41em0zMDQgMEw1ODEuOSAxNjYuMWMtMy0zLjktNy43LTYuMS0xMi42LTYuMUg0OTJjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45TDc1MS4xIDUxMiA0ODUuNyA4NTEuMUE3Ljk4IDcuOTggMCAwMDQ5MiA4NjRoNzcuM2M0LjkgMCA5LjYtMi4zIDEyLjYtNi4xbDI1NS4zLTMyNi4xYzkuMS0xMS43IDkuMS0yNy45IDAtMzkuNXoiIC8+PC9zdmc+) */ const $8ff117f64627ba29$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($8ff117f64627ba29$var$DoubleRightOutlined);
var $8ff117f64627ba29$export$2e2bcd8739ae039 = $8ff117f64627ba29$var$RefIcon;










var $ltGt3 = parcelRequire("ltGt3");
const $21f310e361ca3526$var$locale = {
    // Options
    items_per_page: "\u6761/\u9875",
    jump_to: "\u8DF3\u81F3",
    jump_to_confirm: "\u786E\u5B9A",
    page: "\u9875",
    // Pagination
    prev_page: "\u4E0A\u4E00\u9875",
    next_page: "\u4E0B\u4E00\u9875",
    prev_5: "\u5411\u524D 5 \u9875",
    next_5: "\u5411\u540E 5 \u9875",
    prev_3: "\u5411\u524D 3 \u9875",
    next_3: "\u5411\u540E 3 \u9875",
    page_size: "\u9875\u7801"
};
var $21f310e361ca3526$export$2e2bcd8739ae039 = $21f310e361ca3526$var$locale;




var $ltGt3 = parcelRequire("ltGt3");
const $ccc1172b11a88ae8$var$defaultPageSizeOptions = [
    10,
    20,
    50,
    100
];
const $ccc1172b11a88ae8$var$Options = (props)=>{
    const { pageSizeOptions: pageSizeOptions = $ccc1172b11a88ae8$var$defaultPageSizeOptions, locale: locale, changeSize: changeSize, pageSize: pageSize, goButton: goButton, quickGo: quickGo, rootPrefixCls: rootPrefixCls, disabled: disabled, buildOptionText: buildOptionText, showSizeChanger: showSizeChanger, sizeChangerRender: sizeChangerRender } = props;
    const [goInputText, setGoInputText] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState('');
    const getValidValue = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        return !goInputText || Number.isNaN(goInputText) ? undefined : Number(goInputText);
    }, [
        goInputText
    ]);
    const mergeBuildOptionText = typeof buildOptionText === 'function' ? buildOptionText : (value)=>`${value} ${locale.items_per_page}`;
    const handleChange = (e)=>{
        const value = e.target.value;
        if (/^\d*$/.test(value)) setGoInputText(value);
    };
    const handleBlur = (e)=>{
        if (goButton || goInputText === '') return;
        setGoInputText('');
        if (e.relatedTarget && (e.relatedTarget.className.includes(`${rootPrefixCls}-item-link`) || e.relatedTarget.className.includes(`${rootPrefixCls}-item`))) return;
        quickGo?.(getValidValue);
    };
    const go = (e)=>{
        if (goInputText === '') return;
        if (e.keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER || e.type === 'click') {
            setGoInputText('');
            quickGo?.(getValidValue);
        }
    };
    const getPageSizeOptions = ()=>{
        if (pageSizeOptions.some((option)=>option.toString() === pageSize.toString())) return pageSizeOptions;
        return pageSizeOptions.concat([
            pageSize
        ]).sort((a, b)=>{
            const numberA = Number.isNaN(Number(a)) ? 0 : Number(a);
            const numberB = Number.isNaN(Number(b)) ? 0 : Number(b);
            return numberA - numberB;
        });
    };
    // ============== cls ==============
    const prefixCls = `${rootPrefixCls}-options`;
    // ============== render ==============
    if (!showSizeChanger && !quickGo) return null;
    let changeSelect = null;
    let goInput = null;
    let gotoButton = null;
    // >>>>> Size Changer
    if (showSizeChanger && sizeChangerRender) changeSelect = sizeChangerRender({
        disabled: disabled,
        size: pageSize,
        onSizeChange: (nextValue)=>{
            changeSize?.(Number(nextValue));
        },
        'aria-label': locale.page_size,
        className: `${prefixCls}-size-changer`,
        options: getPageSizeOptions().map((opt)=>({
                label: mergeBuildOptionText(opt),
                value: opt
            }))
    });
    // >>>>> Quick Go
    if (quickGo) {
        if (goButton) gotoButton = typeof goButton === 'boolean' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("button", {
            type: "button",
            onClick: go,
            onKeyUp: go,
            disabled: disabled,
            className: `${prefixCls}-quick-jumper-button`
        }, locale.jump_to_confirm) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            onClick: go,
            onKeyUp: go
        }, goButton);
        goInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
            className: `${prefixCls}-quick-jumper`
        }, locale.jump_to, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("input", {
            disabled: disabled,
            type: "text",
            value: goInputText,
            onChange: handleChange,
            onKeyUp: go,
            onBlur: handleBlur,
            "aria-label": locale.page
        }), locale.page, gotoButton);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("li", {
        className: prefixCls
    }, changeSelect, goInput);
};
var $ccc1172b11a88ae8$export$2e2bcd8739ae039 = $ccc1172b11a88ae8$var$Options;


/* eslint react/prop-types: 0 */ 

var $ltGt3 = parcelRequire("ltGt3");
const $636660633072c2dc$var$Pager = (props)=>{
    const { rootPrefixCls: rootPrefixCls, page: page, active: active, className: className, style: style, showTitle: showTitle, onClick: onClick, onKeyPress: onKeyPress, itemRender: itemRender } = props;
    const prefixCls = `${rootPrefixCls}-item`;
    const cls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${page}`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-disabled`]: !page
    }, className);
    const handleClick = ()=>{
        onClick(page);
    };
    const handleKeyPress = (e)=>{
        onKeyPress(e, onClick, page);
    };
    const pager = itemRender(page, 'page', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("a", {
        rel: "nofollow"
    }, page));
    return pager ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("li", {
        title: showTitle ? String(page) : null,
        className: cls,
        style: style,
        onClick: handleClick,
        onKeyDown: handleKeyPress,
        tabIndex: 0
    }, pager) : null;
};
var $636660633072c2dc$export$2e2bcd8739ae039 = $636660633072c2dc$var$Pager;


function $136db0de561aee03$var$_extends() {
    $136db0de561aee03$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $136db0de561aee03$var$_extends.apply(this, arguments);
}
const $136db0de561aee03$var$defaultItemRender = (_, __, element)=>element;
function $136db0de561aee03$var$noop() {}
function $136db0de561aee03$var$isInteger(v) {
    const value = Number(v);
    return typeof value === 'number' && !Number.isNaN(value) && isFinite(value) && Math.floor(value) === value;
}
function $136db0de561aee03$var$calculatePage(p, pageSize, total) {
    const _pageSize = typeof p === 'undefined' ? pageSize : p;
    return Math.floor((total - 1) / _pageSize) + 1;
}
const $136db0de561aee03$var$Pagination = (props)=>{
    const { prefixCls: // cls
    prefixCls = 'rc-pagination', selectPrefixCls: selectPrefixCls = 'rc-select', className: className, classNames: paginationClassNames, styles: styles, // control
    current: currentProp, defaultCurrent: defaultCurrent = 1, total: total = 0, pageSize: pageSizeProp, defaultPageSize: defaultPageSize = 10, onChange: onChange = $136db0de561aee03$var$noop, hideOnSinglePage: // config
    hideOnSinglePage, align: align, showPrevNextJumpers: showPrevNextJumpers = true, showQuickJumper: showQuickJumper, showLessItems: showLessItems, showTitle: showTitle = true, onShowSizeChange: onShowSizeChange = $136db0de561aee03$var$noop, locale: locale = (0, $21f310e361ca3526$export$2e2bcd8739ae039), style: style, totalBoundaryShowSizeChanger: totalBoundaryShowSizeChanger = 50, disabled: disabled, simple: simple, showTotal: showTotal, showSizeChanger: showSizeChanger = total > totalBoundaryShowSizeChanger, sizeChangerRender: sizeChangerRender, pageSizeOptions: pageSizeOptions, itemRender: // render
    itemRender = $136db0de561aee03$var$defaultItemRender, jumpPrevIcon: jumpPrevIcon, jumpNextIcon: jumpNextIcon, prevIcon: prevIcon, nextIcon: nextIcon } = props;
    const paginationRef = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useRef(null);
    const [pageSize, setPageSize] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultPageSize, pageSizeProp);
    const [internalCurrent, setCurrent] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultCurrent, currentProp);
    const current = Math.max(1, Math.min(internalCurrent, $136db0de561aee03$var$calculatePage(undefined, pageSize, total)));
    const [internalInputVal, setInternalInputVal] = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useState(current);
    (0, $ltGt3.useEffect)(()=>{
        setInternalInputVal(current);
    }, [
        current
    ]);
    const hasOnChange = onChange !== $136db0de561aee03$var$noop;
    const hasCurrent = 'current' in props;
    const jumpPrevPage = Math.max(1, current - (showLessItems ? 3 : 5));
    const jumpNextPage = Math.min($136db0de561aee03$var$calculatePage(undefined, pageSize, total), current + (showLessItems ? 3 : 5));
    function getItemIcon(icon, label) {
        let iconNode = icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("button", {
            type: "button",
            "aria-label": label,
            className: `${prefixCls}-item-link`
        });
        if (typeof icon === 'function') iconNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(icon, props);
        return iconNode;
    }
    function getValidValue(e) {
        const inputValue = e.target.value;
        const allPages = $136db0de561aee03$var$calculatePage(undefined, pageSize, total);
        let value;
        if (inputValue === '') value = inputValue;
        else if (Number.isNaN(Number(inputValue))) value = internalInputVal;
        else if (inputValue >= allPages) value = allPages;
        else value = Number(inputValue);
        return value;
    }
    function isValid(page) {
        return $136db0de561aee03$var$isInteger(page) && page !== current && $136db0de561aee03$var$isInteger(total) && total > 0;
    }
    const shouldDisplayQuickJumper = total > pageSize ? showQuickJumper : false;
    /**
   * prevent "up arrow" key reseting cursor position within textbox
   * @see https://stackoverflow.com/a/1081114
   */ function handleKeyDown(event) {
        if (event.keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).UP || event.keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).DOWN) event.preventDefault();
    }
    function handleKeyUp(event) {
        const value = getValidValue(event);
        if (value !== internalInputVal) setInternalInputVal(value);
        switch(event.keyCode){
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER:
                handleChange(value);
                break;
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).UP:
                handleChange(value - 1);
                break;
            case (0, $b0616a5421b43292$export$2e2bcd8739ae039).DOWN:
                handleChange(value + 1);
                break;
            default:
                break;
        }
    }
    function handleBlur(event) {
        handleChange(getValidValue(event));
    }
    function changePageSize(size) {
        const newCurrent = $136db0de561aee03$var$calculatePage(size, pageSize, total);
        const nextCurrent = current > newCurrent && newCurrent !== 0 ? newCurrent : current;
        setPageSize(size);
        setInternalInputVal(nextCurrent);
        onShowSizeChange?.(current, size);
        setCurrent(nextCurrent);
        onChange?.(nextCurrent, size);
    }
    function handleChange(page) {
        if (isValid(page) && !disabled) {
            const currentPage = $136db0de561aee03$var$calculatePage(undefined, pageSize, total);
            let newPage = page;
            if (page > currentPage) newPage = currentPage;
            else if (page < 1) newPage = 1;
            if (newPage !== internalInputVal) setInternalInputVal(newPage);
            setCurrent(newPage);
            onChange?.(newPage, pageSize);
            return newPage;
        }
        return current;
    }
    const hasPrev = current > 1;
    const hasNext = current < $136db0de561aee03$var$calculatePage(undefined, pageSize, total);
    function prevHandle() {
        if (hasPrev) handleChange(current - 1);
    }
    function nextHandle() {
        if (hasNext) handleChange(current + 1);
    }
    function jumpPrevHandle() {
        handleChange(jumpPrevPage);
    }
    function jumpNextHandle() {
        handleChange(jumpNextPage);
    }
    function runIfEnter(event, callback, ...restParams) {
        if (event.key === 'Enter' || event.charCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER || event.keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER) callback(...restParams);
    }
    function runIfEnterPrev(event) {
        runIfEnter(event, prevHandle);
    }
    function runIfEnterNext(event) {
        runIfEnter(event, nextHandle);
    }
    function runIfEnterJumpPrev(event) {
        runIfEnter(event, jumpPrevHandle);
    }
    function runIfEnterJumpNext(event) {
        runIfEnter(event, jumpNextHandle);
    }
    function renderPrev(prevPage) {
        const prevButton = itemRender(prevPage, 'prev', getItemIcon(prevIcon, 'prev page'));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).isValidElement(prevButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(prevButton, {
            disabled: !hasPrev
        }) : prevButton;
    }
    function renderNext(nextPage) {
        const nextButton = itemRender(nextPage, 'next', getItemIcon(nextIcon, 'next page'));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).isValidElement(nextButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(nextButton, {
            disabled: !hasNext
        }) : nextButton;
    }
    function handleGoTO(event) {
        if (event.type === 'click' || event.keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER) handleChange(internalInputVal);
    }
    let jumpPrev = null;
    const dataOrAriaAttributeProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    });
    const totalText = showTotal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("li", {
        className: `${prefixCls}-total-text`
    }, showTotal(total, [
        total === 0 ? 0 : (current - 1) * pageSize + 1,
        current * pageSize > total ? total : current * pageSize
    ]));
    let jumpNext = null;
    const allPages = $136db0de561aee03$var$calculatePage(undefined, pageSize, total);
    // ================== Render ==================
    // When hideOnSinglePage is true and there is only 1 page, hide the pager
    if (hideOnSinglePage && total <= pageSize) return null;
    const pagerList = [];
    const pagerProps = {
        rootPrefixCls: prefixCls,
        onClick: handleChange,
        onKeyPress: runIfEnter,
        showTitle: showTitle,
        itemRender: itemRender,
        page: -1,
        className: paginationClassNames?.item,
        style: styles?.item
    };
    const prevPage = current - 1 > 0 ? current - 1 : 0;
    const nextPage = current + 1 < allPages ? current + 1 : allPages;
    const goButton = showQuickJumper && showQuickJumper.goButton;
    // ================== Simple ==================
    // FIXME: ts type
    const isReadOnly = typeof simple === 'object' ? simple.readOnly : !simple;
    let gotoButton = goButton;
    let simplePager = null;
    if (simple) {
        // ====== Simple quick jump ======
        if (goButton) {
            if (typeof goButton === 'boolean') gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("button", {
                type: "button",
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, locale.jump_to_confirm);
            else gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, goButton);
            gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("li", {
                title: showTitle ? `${locale.jump_to}${current}/${allPages}` : null,
                className: `${prefixCls}-simple-pager`
            }, gotoButton);
        }
        simplePager = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("li", {
            title: showTitle ? `${current}/${allPages}` : null,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-simple-pager`, paginationClassNames?.item),
            style: styles?.item
        }, isReadOnly ? internalInputVal : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("input", {
            type: "text",
            "aria-label": locale.jump_to,
            value: internalInputVal,
            disabled: disabled,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            onChange: handleKeyUp,
            onBlur: handleBlur,
            size: 3
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("span", {
            className: `${prefixCls}-slash`
        }, "/"), allPages);
    }
    // ====================== Normal ======================
    const pageBufferSize = showLessItems ? 1 : 2;
    if (allPages <= 3 + pageBufferSize * 2) {
        if (!allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $636660633072c2dc$export$2e2bcd8739ae039), $136db0de561aee03$var$_extends({}, pagerProps, {
            key: "noPager",
            page: 1,
            className: `${prefixCls}-item-disabled`
        })));
        for(let i = 1; i <= allPages; i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $636660633072c2dc$export$2e2bcd8739ae039), $136db0de561aee03$var$_extends({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
    } else {
        const prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
        const nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
        const jumpPrevContent = itemRender(jumpPrevPage, 'jump-prev', getItemIcon(jumpPrevIcon, 'prev page'));
        const jumpNextContent = itemRender(jumpNextPage, 'jump-next', getItemIcon(jumpNextIcon, 'next page'));
        if (showPrevNextJumpers) {
            jumpPrev = jumpPrevContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("li", {
                title: showTitle ? prevItemTitle : null,
                key: "prev",
                onClick: jumpPrevHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpPrev,
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-jump-prev`, {
                    [`${prefixCls}-jump-prev-custom-icon`]: !!jumpPrevIcon
                })
            }, jumpPrevContent) : null;
            jumpNext = jumpNextContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("li", {
                title: showTitle ? nextItemTitle : null,
                key: "next",
                onClick: jumpNextHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpNext,
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-jump-next`, {
                    [`${prefixCls}-jump-next-custom-icon`]: !!jumpNextIcon
                })
            }, jumpNextContent) : null;
        }
        let left = Math.max(1, current - pageBufferSize);
        let right = Math.min(current + pageBufferSize, allPages);
        if (current - 1 <= pageBufferSize) right = 1 + pageBufferSize * 2;
        if (allPages - current <= pageBufferSize) left = allPages - pageBufferSize * 2;
        for(let i = left; i <= right; i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $636660633072c2dc$export$2e2bcd8739ae039), $136db0de561aee03$var$_extends({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
        if (current - 1 >= pageBufferSize * 2 && current !== 3) {
            pagerList[0] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(pagerList[0], {
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-item-after-jump-prev`, pagerList[0].props.className)
            });
            pagerList.unshift(jumpPrev);
        }
        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
            const lastOne = pagerList[pagerList.length - 1];
            pagerList[pagerList.length - 1] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(lastOne, {
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-item-before-jump-next`, lastOne.props.className)
            });
            pagerList.push(jumpNext);
        }
        if (left !== 1) pagerList.unshift(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $636660633072c2dc$export$2e2bcd8739ae039), $136db0de561aee03$var$_extends({}, pagerProps, {
            key: 1,
            page: 1
        })));
        if (right !== allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $636660633072c2dc$export$2e2bcd8739ae039), $136db0de561aee03$var$_extends({}, pagerProps, {
            key: allPages,
            page: allPages
        })));
    }
    let prev = renderPrev(prevPage);
    if (prev) {
        const prevDisabled = !hasPrev || !allPages;
        prev = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("li", {
            title: showTitle ? locale.prev_page : null,
            onClick: prevHandle,
            tabIndex: prevDisabled ? null : 0,
            onKeyDown: runIfEnterPrev,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-prev`, paginationClassNames?.item, {
                [`${prefixCls}-disabled`]: prevDisabled
            }),
            style: styles?.item,
            "aria-disabled": prevDisabled
        }, prev);
    }
    let next = renderNext(nextPage);
    if (next) {
        let nextDisabled, nextTabIndex;
        if (simple) {
            nextDisabled = !hasNext;
            nextTabIndex = hasPrev ? 0 : null;
        } else {
            nextDisabled = !hasNext || !allPages;
            nextTabIndex = nextDisabled ? null : 0;
        }
        next = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("li", {
            title: showTitle ? locale.next_page : null,
            onClick: nextHandle,
            tabIndex: nextTabIndex,
            onKeyDown: runIfEnterNext,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-next`, paginationClassNames?.item, {
                [`${prefixCls}-disabled`]: nextDisabled
            }),
            style: styles?.item,
            "aria-disabled": nextDisabled
        }, next);
    }
    const cls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-start`]: align === 'start',
        [`${prefixCls}-center`]: align === 'center',
        [`${prefixCls}-end`]: align === 'end',
        [`${prefixCls}-simple`]: simple,
        [`${prefixCls}-disabled`]: disabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("ul", $136db0de561aee03$var$_extends({
        className: cls,
        style: style,
        ref: paginationRef
    }, dataOrAriaAttributeProps), totalText, prev, simple ? simplePager : pagerList, next, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $ccc1172b11a88ae8$export$2e2bcd8739ae039), {
        locale: locale,
        rootPrefixCls: prefixCls,
        disabled: disabled,
        selectPrefixCls: selectPrefixCls,
        changeSize: changePageSize,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions,
        quickGo: shouldDisplayQuickJumper ? handleChange : null,
        goButton: gotoButton,
        showSizeChanger: showSizeChanger,
        sizeChangerRender: sizeChangerRender
    }));
};
var $136db0de561aee03$export$2e2bcd8739ae039 = $136db0de561aee03$var$Pagination;



















const $c0985487f45e7820$var$genPaginationDisabledStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-disabled`]: {
            '&, &:hover': {
                cursor: 'not-allowed',
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            '&:focus-visible': {
                cursor: 'not-allowed',
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: 'not-allowed'
                }
            }
        },
        [`&${componentCls}-disabled`]: {
            cursor: 'not-allowed',
            [`${componentCls}-item`]: {
                cursor: 'not-allowed',
                backgroundColor: 'transparent',
                '&:hover, &:active': {
                    backgroundColor: 'transparent'
                },
                a: {
                    color: token.colorTextDisabled,
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'not-allowed'
                },
                '&-active': {
                    borderColor: token.colorBorder,
                    backgroundColor: token.itemActiveBgDisabled,
                    '&:hover, &:active': {
                        backgroundColor: token.itemActiveBgDisabled
                    },
                    a: {
                        color: token.itemActiveColorDisabled
                    }
                }
            },
            [`${componentCls}-item-link`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                '&:hover, &:active': {
                    backgroundColor: 'transparent'
                },
                [`${componentCls}-simple&`]: {
                    backgroundColor: 'transparent',
                    '&:hover, &:active': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            [`${componentCls}-simple-pager`]: {
                color: token.colorTextDisabled
            },
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 0
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 1
                }
            }
        }
    };
};
const $c0985487f45e7820$var$genPaginationMiniStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-mini ${componentCls}-total-text, &${componentCls}-mini ${componentCls}-simple-pager`]: {
            height: token.itemSizeSM,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.itemSizeSM)
        },
        [`&${componentCls}-mini ${componentCls}-item`]: {
            minWidth: token.itemSizeSM,
            height: token.itemSizeSM,
            margin: 0,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(token.itemSizeSM).sub(2).equal())
        },
        [`&${componentCls}-mini ${componentCls}-prev, &${componentCls}-mini ${componentCls}-next`]: {
            minWidth: token.itemSizeSM,
            height: token.itemSizeSM,
            margin: 0,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.itemSizeSM)
        },
        [`&${componentCls}-mini:not(${componentCls}-disabled)`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&:hover ${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgTextHover
                },
                [`&:active ${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgTextActive
                },
                [`&${componentCls}-disabled:hover ${componentCls}-item-link`]: {
                    backgroundColor: 'transparent'
                }
            }
        },
        [`
    &${componentCls}-mini ${componentCls}-prev ${componentCls}-item-link,
    &${componentCls}-mini ${componentCls}-next ${componentCls}-item-link
    `]: {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            '&::after': {
                height: token.itemSizeSM,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.itemSizeSM)
            }
        },
        [`&${componentCls}-mini ${componentCls}-jump-prev, &${componentCls}-mini ${componentCls}-jump-next`]: {
            height: token.itemSizeSM,
            marginInlineEnd: 0,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.itemSizeSM)
        },
        [`&${componentCls}-mini ${componentCls}-options`]: {
            marginInlineStart: token.paginationMiniOptionsMarginInlineStart,
            '&-size-changer': {
                top: token.miniOptionsSizeChangerTop
            },
            '&-quick-jumper': {
                height: token.itemSizeSM,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.itemSizeSM),
                input: {
                    ...(0, $ec12a8e9ea12e1d5$export$bb047f62c5a56f90)(token),
                    width: token.paginationMiniQuickJumperInputWidth,
                    height: token.controlHeightSM
                }
            }
        }
    };
};
const $c0985487f45e7820$var$genPaginationSimpleStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-simple`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                height: token.itemSize,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.itemSize),
                verticalAlign: 'top',
                [`${componentCls}-item-link`]: {
                    height: token.itemSize,
                    backgroundColor: 'transparent',
                    border: 0,
                    '&:hover': {
                        backgroundColor: token.colorBgTextHover
                    },
                    '&:active': {
                        backgroundColor: token.colorBgTextActive
                    },
                    '&::after': {
                        height: token.itemSize,
                        lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.itemSize)
                    }
                }
            },
            [`${componentCls}-simple-pager`]: {
                display: 'inline-flex',
                alignItems: 'center',
                height: token.itemSize,
                marginInlineEnd: token.marginXS,
                input: {
                    boxSizing: 'border-box',
                    height: '100%',
                    width: token.quickJumperInputWidth,
                    padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paginationItemPaddingInline)}`,
                    textAlign: 'center',
                    backgroundColor: token.itemInputBg,
                    border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadius,
                    outline: 'none',
                    transition: `border-color ${token.motionDurationMid}`,
                    color: 'inherit',
                    '&:hover': {
                        borderColor: token.colorPrimary
                    },
                    '&:focus': {
                        borderColor: token.colorPrimaryHover,
                        boxShadow: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.inputOutlineOffset)} 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.controlOutlineWidth)} ${token.controlOutline}`
                    },
                    '&[disabled]': {
                        color: token.colorTextDisabled,
                        backgroundColor: token.colorBgContainerDisabled,
                        borderColor: token.colorBorder,
                        cursor: 'not-allowed'
                    }
                }
            },
            [`&${componentCls}-disabled`]: {
                [`${componentCls}-prev, ${componentCls}-next`]: {
                    [`${componentCls}-item-link`]: {
                        '&:hover, &:active': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            [`&${componentCls}-mini`]: {
                [`${componentCls}-prev, ${componentCls}-next`]: {
                    height: token.itemSizeSM,
                    lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.itemSizeSM),
                    [`${componentCls}-item-link`]: {
                        height: token.itemSizeSM,
                        '&::after': {
                            height: token.itemSizeSM,
                            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.itemSizeSM)
                        }
                    }
                },
                [`${componentCls}-simple-pager`]: {
                    height: token.itemSizeSM,
                    input: {
                        width: token.paginationMiniQuickJumperInputWidth
                    }
                }
            }
        }
    };
};
const $c0985487f45e7820$var$genPaginationJumpStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
            outline: 0,
            [`${componentCls}-item-container`]: {
                position: 'relative',
                [`${componentCls}-item-link-icon`]: {
                    color: token.colorPrimary,
                    fontSize: token.fontSizeSM,
                    opacity: 0,
                    transition: `all ${token.motionDurationMid}`,
                    '&-svg': {
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        margin: 'auto'
                    }
                },
                [`${componentCls}-item-ellipsis`]: {
                    position: 'absolute',
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    display: 'block',
                    margin: 'auto',
                    color: token.colorTextDisabled,
                    letterSpacing: token.paginationEllipsisLetterSpacing,
                    textAlign: 'center',
                    textIndent: token.paginationEllipsisTextIndent,
                    opacity: 1,
                    transition: `all ${token.motionDurationMid}`
                }
            },
            '&:hover': {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 1
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 0
                }
            }
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            marginInlineEnd: token.marginXS
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-next,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            display: 'inline-block',
            minWidth: token.itemSize,
            height: token.itemSize,
            color: token.colorText,
            fontFamily: token.fontFamily,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.itemSize),
            textAlign: 'center',
            verticalAlign: 'middle',
            listStyle: 'none',
            borderRadius: token.borderRadius,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid}`
        },
        [`${componentCls}-prev, ${componentCls}-next`]: {
            outline: 0,
            button: {
                color: token.colorText,
                cursor: 'pointer',
                userSelect: 'none'
            },
            [`${componentCls}-item-link`]: {
                display: 'block',
                width: '100%',
                height: '100%',
                padding: 0,
                fontSize: token.fontSizeSM,
                textAlign: 'center',
                backgroundColor: 'transparent',
                border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                borderRadius: token.borderRadius,
                outline: 'none',
                transition: `all ${token.motionDurationMid}`
            },
            [`&:hover ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextHover
            },
            [`&:active ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextActive
            },
            [`&${componentCls}-disabled:hover`]: {
                [`${componentCls}-item-link`]: {
                    backgroundColor: 'transparent'
                }
            }
        },
        [`${componentCls}-slash`]: {
            marginInlineEnd: token.paginationSlashMarginInlineEnd,
            marginInlineStart: token.paginationSlashMarginInlineStart
        },
        [`${componentCls}-options`]: {
            display: 'inline-block',
            marginInlineStart: token.margin,
            verticalAlign: 'middle',
            '&-size-changer': {
                width: 'auto'
            },
            '&-quick-jumper': {
                display: 'inline-block',
                height: token.controlHeight,
                marginInlineStart: token.marginXS,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.controlHeight),
                verticalAlign: 'top',
                input: {
                    ...(0, $ec12a8e9ea12e1d5$export$8c9a381315f3ebcd)(token),
                    ...(0, $2e2c91ed88c5ebaa$export$8c569e4cc3fd115f)(token, {
                        borderColor: token.colorBorder,
                        hoverBorderColor: token.colorPrimaryHover,
                        activeBorderColor: token.colorPrimary,
                        activeShadow: token.activeShadow
                    }),
                    '&[disabled]': {
                        ...(0, $2e2c91ed88c5ebaa$export$12789f962d420a93)(token)
                    },
                    width: token.quickJumperInputWidth,
                    height: token.controlHeight,
                    boxSizing: 'border-box',
                    margin: 0,
                    marginInlineStart: token.marginXS,
                    marginInlineEnd: token.marginXS
                }
            }
        }
    };
};
const $c0985487f45e7820$var$genPaginationItemStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-item`]: {
            display: 'inline-block',
            minWidth: token.itemSize,
            height: token.itemSize,
            marginInlineEnd: token.marginXS,
            fontFamily: token.fontFamily,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(token.itemSize).sub(2).equal()),
            textAlign: 'center',
            verticalAlign: 'middle',
            listStyle: 'none',
            backgroundColor: token.itemBg,
            border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
            borderRadius: token.borderRadius,
            outline: 0,
            cursor: 'pointer',
            userSelect: 'none',
            a: {
                display: 'block',
                padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paginationItemPaddingInline)}`,
                color: token.colorText,
                '&:hover': {
                    textDecoration: 'none'
                }
            },
            [`&:not(${componentCls}-item-active)`]: {
                '&:hover': {
                    transition: `all ${token.motionDurationMid}`,
                    backgroundColor: token.colorBgTextHover
                },
                '&:active': {
                    backgroundColor: token.colorBgTextActive
                }
            },
            '&-active': {
                fontWeight: token.fontWeightStrong,
                backgroundColor: token.itemActiveBg,
                borderColor: token.colorPrimary,
                a: {
                    color: token.itemActiveColor
                },
                '&:hover': {
                    borderColor: token.colorPrimaryHover
                },
                '&:hover a': {
                    color: token.itemActiveColorHover
                }
            }
        }
    };
};
const $c0985487f45e7820$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            display: 'flex',
            '&-start': {
                justifyContent: 'start'
            },
            '&-center': {
                justifyContent: 'center'
            },
            '&-end': {
                justifyContent: 'end'
            },
            'ul, ol': {
                margin: 0,
                padding: 0,
                listStyle: 'none'
            },
            '&::after': {
                display: 'block',
                clear: 'both',
                height: 0,
                overflow: 'hidden',
                visibility: 'hidden',
                content: '""'
            },
            [`${componentCls}-total-text`]: {
                display: 'inline-block',
                height: token.itemSize,
                marginInlineEnd: token.marginXS,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(token.itemSize).sub(2).equal()),
                verticalAlign: 'middle'
            },
            // item style
            ...$c0985487f45e7820$var$genPaginationItemStyle(token),
            // jump btn style
            ...$c0985487f45e7820$var$genPaginationJumpStyle(token),
            // simple style
            ...$c0985487f45e7820$var$genPaginationSimpleStyle(token),
            // mini style
            ...$c0985487f45e7820$var$genPaginationMiniStyle(token),
            // disabled style
            ...$c0985487f45e7820$var$genPaginationDisabledStyle(token),
            // media query style
            [`@media only screen and (max-width: ${token.screenLG}px)`]: {
                [`${componentCls}-item`]: {
                    '&-after-jump-prev, &-before-jump-next': {
                        display: 'none'
                    }
                }
            },
            [`@media only screen and (max-width: ${token.screenSM}px)`]: {
                [`${componentCls}-options`]: {
                    display: 'none'
                }
            }
        },
        // rtl style
        [`&${token.componentCls}-rtl`]: {
            direction: 'rtl'
        }
    };
};
const $c0985487f45e7820$var$genPaginationFocusStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}:not(${componentCls}-disabled)`]: {
            [`${componentCls}-item`]: {
                ...(0, $945cb0d2b7017a11$export$a44db842bcb28231)(token)
            },
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                '&:focus-visible': {
                    [`${componentCls}-item-link-icon`]: {
                        opacity: 1
                    },
                    [`${componentCls}-item-ellipsis`]: {
                        opacity: 0
                    },
                    ...(0, $945cb0d2b7017a11$export$6539948f0a737e39)(token)
                }
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&:focus-visible ${componentCls}-item-link`]: (0, $945cb0d2b7017a11$export$6539948f0a737e39)(token)
            }
        }
    };
};
const $c0985487f45e7820$export$9ca1be8807fe0675 = (token)=>({
        itemBg: token.colorBgContainer,
        itemSize: token.controlHeight,
        itemSizeSM: token.controlHeightSM,
        itemActiveBg: token.colorBgContainer,
        itemActiveColor: token.colorPrimary,
        itemActiveColorHover: token.colorPrimaryHover,
        itemLinkBg: token.colorBgContainer,
        itemActiveColorDisabled: token.colorTextDisabled,
        itemActiveBgDisabled: token.controlItemBgActiveDisabled,
        itemInputBg: token.colorBgContainer,
        miniOptionsSizeChangerTop: 0,
        ...(0, $84cc1914d3f028b8$export$bd8b682992bc9781)(token)
    });
const $c0985487f45e7820$export$362fb92a8f81bbf9 = (token)=>(0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        inputOutlineOffset: 0,
        quickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.25).equal(),
        paginationMiniOptionsMarginInlineStart: token.calc(token.marginXXS).div(2).equal(),
        paginationMiniQuickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.1).equal(),
        paginationItemPaddingInline: token.calc(token.marginXXS).mul(1.5).equal(),
        paginationEllipsisLetterSpacing: token.calc(token.marginXXS).div(2).equal(),
        paginationSlashMarginInlineStart: token.marginSM,
        paginationSlashMarginInlineEnd: token.marginSM,
        paginationEllipsisTextIndent: '0.13em' // magic for ui experience
    }, (0, $84cc1914d3f028b8$export$a157d95850191a12)(token));
var // ============================== Export ==============================
$c0985487f45e7820$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Pagination', (token)=>{
    const paginationToken = $c0985487f45e7820$export$362fb92a8f81bbf9(token);
    return [
        $c0985487f45e7820$var$genPaginationStyle(paginationToken),
        $c0985487f45e7820$var$genPaginationFocusStyle(paginationToken)
    ];
}, $c0985487f45e7820$export$9ca1be8807fe0675);





const $257acfe2da246956$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}${componentCls}-bordered${componentCls}-disabled:not(${componentCls}-mini)`]: {
            '&, &:hover': {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            '&:focus-visible': {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            [`${componentCls}-item, ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgContainerDisabled,
                borderColor: token.colorBorder,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    a: {
                        color: token.colorTextDisabled
                    }
                },
                [`&${componentCls}-item-active`]: {
                    backgroundColor: token.itemActiveBgDisabled
                }
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                '&:hover button': {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    color: token.colorTextDisabled
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder
                }
            }
        },
        [`${componentCls}${componentCls}-bordered:not(${componentCls}-mini)`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                '&:hover button': {
                    borderColor: token.colorPrimaryHover,
                    backgroundColor: token.itemBg
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.itemLinkBg,
                    borderColor: token.colorBorder
                },
                [`&:hover ${componentCls}-item-link`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    color: token.colorPrimary
                },
                [`&${componentCls}-disabled`]: {
                    [`${componentCls}-item-link`]: {
                        borderColor: token.colorBorder,
                        color: token.colorTextDisabled
                    }
                }
            },
            [`${componentCls}-item`]: {
                backgroundColor: token.itemBg,
                border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    a: {
                        color: token.colorPrimary
                    }
                },
                '&-active': {
                    borderColor: token.colorPrimary
                }
            }
        }
    };
};
var $257acfe2da246956$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$1537386bc155ea56)([
    'Pagination',
    'bordered'
], (token)=>{
    const paginationToken = (0, $c0985487f45e7820$export$362fb92a8f81bbf9)(token);
    return $257acfe2da246956$var$genBorderedStyle(paginationToken);
}, (0, $c0985487f45e7820$export$9ca1be8807fe0675));



var $ltGt3 = parcelRequire("ltGt3");
function $1a02fc5742c34b7a$export$2e2bcd8739ae039(showSizeChanger) {
    return (0, $ltGt3.useMemo)(()=>{
        if (typeof showSizeChanger === 'boolean') return [
            showSizeChanger,
            {}
        ];
        if (showSizeChanger && typeof showSizeChanger === 'object') return [
            true,
            showSizeChanger
        ];
        return [
            undefined,
            undefined
        ];
    }, [
        showSizeChanger
    ]);
}


"use client";
const $157882c82885dfc5$var$Pagination = (props)=>{
    const { align: align, prefixCls: customizePrefixCls, selectPrefixCls: customizeSelectPrefixCls, className: className, rootClassName: rootClassName, style: style, size: customizeSize, locale: customLocale, responsive: responsive, showSizeChanger: showSizeChanger, selectComponentClass: selectComponentClass, pageSizeOptions: pageSizeOptions, styles: styles, classNames: classNames, ...restProps } = props;
    const { xs: xs } = (0, $ec3b57b710702d4d$export$2e2bcd8739ae039)(responsive);
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const { getPrefixCls: getPrefixCls, direction: direction, showSizeChanger: contextShowSizeChangerConfig, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('pagination');
    const prefixCls = getPrefixCls('pagination', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $c0985487f45e7820$export$2e2bcd8739ae039)(prefixCls);
    // ============================== Size ==============================
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)(customizeSize);
    const isSmall = mergedSize === 'small' || !!(xs && !mergedSize && responsive);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ============================= Locale =============================
    const [contextLocale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Pagination', (0, $307c281918c022d6$export$2e2bcd8739ae039));
    const locale = {
        ...contextLocale,
        ...customLocale
    };
    // ========================== Size Changer ==========================
    // Merge the props showSizeChanger
    const [propShowSizeChanger, propSizeChangerSelectProps] = (0, $1a02fc5742c34b7a$export$2e2bcd8739ae039)(showSizeChanger);
    const [contextShowSizeChanger, contextSizeChangerSelectProps] = (0, $1a02fc5742c34b7a$export$2e2bcd8739ae039)(contextShowSizeChangerConfig);
    const mergedShowSizeChanger = propShowSizeChanger ?? contextShowSizeChanger;
    const mergedShowSizeChangerSelectProps = propSizeChangerSelectProps ?? contextSizeChangerSelectProps;
    const SizeChanger = selectComponentClass || (0, $833302d2cabce31e$export$2e2bcd8739ae039);
    // Generate options
    const mergedPageSizeOptions = $ltGt3.useMemo(()=>{
        return pageSizeOptions ? pageSizeOptions.map((option)=>Number(option)) : undefined;
    }, [
        pageSizeOptions
    ]);
    // Render size changer
    const sizeChangerRender = (info)=>{
        const { disabled: disabled, size: pageSize, onSizeChange: onSizeChange, 'aria-label': ariaLabel, className: sizeChangerClassName, options: options } = info;
        const { className: propSizeChangerClassName, onChange: propSizeChangerOnChange } = mergedShowSizeChangerSelectProps || {};
        // Origin Select is using Select.Option,
        // So it make the option value must be string
        // Just for compatible
        const selectedValue = options.find((option)=>String(option.value) === String(pageSize))?.value;
        return /*#__PURE__*/ $ltGt3.createElement(SizeChanger, {
            disabled: disabled,
            showSearch: true,
            popupMatchSelectWidth: false,
            getPopupContainer: (triggerNode)=>triggerNode.parentNode,
            "aria-label": ariaLabel,
            options: options,
            ...mergedShowSizeChangerSelectProps,
            value: selectedValue,
            onChange: (nextSize, option)=>{
                onSizeChange?.(nextSize);
                propSizeChangerOnChange?.(nextSize, option);
            },
            size: isSmall ? 'small' : 'middle',
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(sizeChangerClassName, propSizeChangerClassName)
        });
    };
    // ============================= Render =============================
    const iconsProps = $ltGt3.useMemo(()=>{
        const ellipsis = /*#__PURE__*/ $ltGt3.createElement("span", {
            className: `${prefixCls}-item-ellipsis`
        }, "\u2022\u2022\u2022");
        const prevIcon = /*#__PURE__*/ $ltGt3.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === 'rtl' ? /*#__PURE__*/ $ltGt3.createElement((0, $a9490449fe252e7b$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $4fcbd32442f5797e$export$2e2bcd8739ae039), null));
        const nextIcon = /*#__PURE__*/ $ltGt3.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === 'rtl' ? /*#__PURE__*/ $ltGt3.createElement((0, $4fcbd32442f5797e$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $a9490449fe252e7b$export$2e2bcd8739ae039), null));
        const jumpPrevIcon = /*#__PURE__*/ // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
        $ltGt3.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $ltGt3.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === 'rtl' ? /*#__PURE__*/ $ltGt3.createElement((0, $8ff117f64627ba29$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $ltGt3.createElement((0, $54a07f0b2f5e90b8$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        const jumpNextIcon = /*#__PURE__*/ // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
        $ltGt3.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $ltGt3.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === 'rtl' ? /*#__PURE__*/ $ltGt3.createElement((0, $54a07f0b2f5e90b8$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $ltGt3.createElement((0, $8ff117f64627ba29$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        return {
            prevIcon: prevIcon,
            nextIcon: nextIcon,
            jumpPrevIcon: jumpPrevIcon,
            jumpNextIcon: jumpNextIcon
        };
    }, [
        direction,
        prefixCls
    ]);
    const selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
    const extendedClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
        [`${prefixCls}-${align}`]: !!align,
        [`${prefixCls}-mini`]: isSmall,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-bordered`]: token.wireframe
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls);
    const mergedStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, token.wireframe && /*#__PURE__*/ $ltGt3.createElement((0, $257acfe2da246956$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ $ltGt3.createElement((0, $136db0de561aee03$export$2e2bcd8739ae039), {
        ...iconsProps,
        ...restProps,
        styles: mergedStyles,
        classNames: mergedClassNames,
        style: mergedStyle,
        prefixCls: prefixCls,
        selectPrefixCls: selectPrefixCls,
        className: extendedClassName,
        locale: locale,
        pageSizeOptions: mergedPageSizeOptions,
        showSizeChanger: mergedShowSizeChanger,
        sizeChangerRender: sizeChangerRender
    }));
};
var $157882c82885dfc5$export$2e2bcd8739ae039 = $157882c82885dfc5$var$Pagination;


"use client";
var $ba6ccffd2ae02ebb$export$2e2bcd8739ae039 = (0, $157882c82885dfc5$export$2e2bcd8739ae039);




var $ltGt3 = parcelRequire("ltGt3");
const $7ed35f2bef733cfc$export$52411773e0d6f15d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createContext({});
const $7ed35f2bef733cfc$export$a3183b990150745c = $7ed35f2bef733cfc$export$52411773e0d6f15d.Consumer;



var $ltGt3 = parcelRequire("ltGt3");






"use client";
const $921f613a86552f18$export$b08a9033b36413fb = ({ prefixCls: customizePrefixCls, className: className, avatar: avatar, title: title, description: description, ...others })=>{
    const { getPrefixCls: getPrefixCls } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('list', customizePrefixCls);
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-item-meta`, className);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: `${prefixCls}-item-meta-content`
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("h4", {
        className: `${prefixCls}-item-meta-title`
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: `${prefixCls}-item-meta-description`
    }, description));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        ...others,
        className: classString
    }, avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        className: `${prefixCls}-item-meta-avatar`
    }, avatar), (title || description) && content);
};
const $921f613a86552f18$var$InternalItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, children: children, actions: actions, extra: extra, styles: styles, className: className, classNames: customizeClassNames, colStyle: colStyle, ...others } = props;
    const { grid: grid, itemLayout: itemLayout } = (0, $ltGt3.useContext)((0, $7ed35f2bef733cfc$export$52411773e0d6f15d));
    const { getPrefixCls: getPrefixCls, list: list } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const moduleClass = (moduleName)=>(0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(list?.item?.classNames?.[moduleName], customizeClassNames?.[moduleName]);
    const moduleStyle = (moduleName)=>({
            ...list?.item?.styles?.[moduleName],
            ...styles?.[moduleName]
        });
    const isItemContainsTextNodeAndNotSingular = ()=>{
        const childNodes = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children);
        const hasTextNode = childNodes.some((node)=>typeof node === 'string');
        return hasTextNode && childNodes.length > 1;
    };
    const isFlexMode = ()=>{
        if (itemLayout === 'vertical') return !!extra;
        return !isItemContainsTextNodeAndNotSingular();
    };
    const prefixCls = getPrefixCls('list', customizePrefixCls);
    const actionsContent = actions && actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("ul", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-item-action`, moduleClass('actions')),
        key: "actions",
        style: moduleStyle('actions')
    }, actions.map((action, i)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("li", {
            key: `${prefixCls}-item-action-${i}`
        }, action, i !== actions.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("em", {
            className: `${prefixCls}-item-action-split`
        }))));
    const Element = grid ? 'div' : 'li';
    const itemChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(Element, {
        ...others,
        ...!grid ? {
            ref: ref
        } : {},
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-item`, {
            [`${prefixCls}-item-no-flex`]: !isFlexMode()
        }, className)
    }, itemLayout === 'vertical' && extra ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
            className: `${prefixCls}-item-main`,
            key: "content"
        }, children, actionsContent),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-item-extra`, moduleClass('extra')),
            key: "extra",
            style: moduleStyle('extra')
        }, extra)
    ] : [
        children,
        actionsContent,
        (0, $66d38239e1a27993$export$e530037191fcd5d7)(extra, {
            key: 'extra'
        })
    ]);
    return grid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $4f41537f122e579d$export$2e2bcd8739ae039), {
        ref: ref,
        flex: 1,
        style: colStyle
    }, itemChildren) : itemChildren;
});
const $921f613a86552f18$var$Item = $921f613a86552f18$var$InternalItem;
$921f613a86552f18$var$Item.Meta = $921f613a86552f18$export$b08a9033b36413fb;
var $921f613a86552f18$export$2e2bcd8739ae039 = $921f613a86552f18$var$Item;





const $74b90c7456f9733d$var$genBorderedStyle = (token)=>{
    const { listBorderedCls: listBorderedCls, componentCls: componentCls, paddingLG: paddingLG, margin: margin, itemPaddingSM: itemPaddingSM, itemPaddingLG: itemPaddingLG, marginLG: marginLG, borderRadiusLG: borderRadiusLG } = token;
    const innerCornerBorderRadius = (0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.calc(borderRadiusLG).sub(token.lineWidth).equal());
    return {
        [listBorderedCls]: {
            border: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
            borderRadius: borderRadiusLG,
            [`${componentCls}-header`]: {
                borderRadius: `${innerCornerBorderRadius} ${innerCornerBorderRadius} 0 0`
            },
            [`${componentCls}-footer`]: {
                borderRadius: `0 0 ${innerCornerBorderRadius} ${innerCornerBorderRadius}`
            },
            [`${componentCls}-header,${componentCls}-footer,${componentCls}-item`]: {
                paddingInline: paddingLG
            },
            [`${componentCls}-pagination`]: {
                margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(margin)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(marginLG)}`
            }
        },
        [`${listBorderedCls}${componentCls}-sm`]: {
            [`${componentCls}-item,${componentCls}-header,${componentCls}-footer`]: {
                padding: itemPaddingSM
            }
        },
        [`${listBorderedCls}${componentCls}-lg`]: {
            [`${componentCls}-item,${componentCls}-header,${componentCls}-footer`]: {
                padding: itemPaddingLG
            }
        }
    };
};
const $74b90c7456f9733d$var$genResponsiveStyle = (token)=>{
    const { componentCls: componentCls, screenSM: screenSM, screenMD: screenMD, marginLG: marginLG, marginSM: marginSM, margin: margin } = token;
    return {
        [`@media screen and (max-width:${screenMD}px)`]: {
            [componentCls]: {
                [`${componentCls}-item`]: {
                    [`${componentCls}-item-action`]: {
                        marginInlineStart: marginLG
                    }
                }
            },
            [`${componentCls}-vertical`]: {
                [`${componentCls}-item`]: {
                    [`${componentCls}-item-extra`]: {
                        marginInlineStart: marginLG
                    }
                }
            }
        },
        [`@media screen and (max-width: ${screenSM}px)`]: {
            [componentCls]: {
                [`${componentCls}-item`]: {
                    flexWrap: 'wrap',
                    [`${componentCls}-action`]: {
                        marginInlineStart: marginSM
                    }
                }
            },
            [`${componentCls}-vertical`]: {
                [`${componentCls}-item`]: {
                    flexWrap: 'wrap-reverse',
                    [`${componentCls}-item-main`]: {
                        minWidth: token.contentWidth
                    },
                    [`${componentCls}-item-extra`]: {
                        margin: `auto auto ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(margin)}`
                    }
                }
            }
        }
    };
};
// =============================== Base ===============================
const $74b90c7456f9733d$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, controlHeight: controlHeight, minHeight: minHeight, paddingSM: paddingSM, marginLG: marginLG, padding: padding, itemPadding: itemPadding, colorPrimary: colorPrimary, itemPaddingSM: itemPaddingSM, itemPaddingLG: itemPaddingLG, paddingXS: paddingXS, margin: margin, colorText: colorText, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, lineWidth: lineWidth, headerBg: headerBg, footerBg: footerBg, emptyTextPadding: emptyTextPadding, metaMarginBottom: metaMarginBottom, avatarMarginRight: avatarMarginRight, titleMarginBottom: titleMarginBottom, descriptionFontSize: descriptionFontSize } = token;
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            position: 'relative',
            // fix https://github.com/ant-design/ant-design/issues/46177
            ['--rc-virtual-list-scrollbar-bg']: token.colorSplit,
            '*': {
                outline: 'none'
            },
            [`${componentCls}-header`]: {
                background: headerBg
            },
            [`${componentCls}-footer`]: {
                background: footerBg
            },
            [`${componentCls}-header, ${componentCls}-footer`]: {
                paddingBlock: paddingSM
            },
            [`${componentCls}-pagination`]: {
                marginBlockStart: marginLG,
                // https://github.com/ant-design/ant-design/issues/20037
                [`${antCls}-pagination-options`]: {
                    textAlign: 'start'
                }
            },
            [`${componentCls}-spin`]: {
                minHeight: minHeight,
                textAlign: 'center'
            },
            [`${componentCls}-items`]: {
                margin: 0,
                padding: 0,
                listStyle: 'none'
            },
            [`${componentCls}-item`]: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: itemPadding,
                color: colorText,
                [`${componentCls}-item-meta`]: {
                    display: 'flex',
                    flex: 1,
                    alignItems: 'flex-start',
                    maxWidth: '100%',
                    [`${componentCls}-item-meta-avatar`]: {
                        marginInlineEnd: avatarMarginRight
                    },
                    [`${componentCls}-item-meta-content`]: {
                        flex: '1 0',
                        width: 0,
                        color: colorText
                    },
                    [`${componentCls}-item-meta-title`]: {
                        margin: `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.marginXXS)} 0`,
                        color: colorText,
                        fontSize: token.fontSize,
                        lineHeight: token.lineHeight,
                        '> a': {
                            color: colorText,
                            transition: `all ${motionDurationSlow}`,
                            '&:hover': {
                                color: colorPrimary
                            }
                        }
                    },
                    [`${componentCls}-item-meta-description`]: {
                        color: colorTextDescription,
                        fontSize: descriptionFontSize,
                        lineHeight: token.lineHeight
                    }
                },
                [`${componentCls}-item-action`]: {
                    flex: '0 0 auto',
                    marginInlineStart: token.marginXXL,
                    padding: 0,
                    fontSize: 0,
                    listStyle: 'none',
                    '& > li': {
                        position: 'relative',
                        display: 'inline-block',
                        padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)}`,
                        color: colorTextDescription,
                        fontSize: token.fontSize,
                        lineHeight: token.lineHeight,
                        textAlign: 'center',
                        '&:first-child': {
                            paddingInlineStart: 0
                        }
                    },
                    [`${componentCls}-item-action-split`]: {
                        position: 'absolute',
                        insetBlockStart: '50%',
                        insetInlineEnd: 0,
                        width: lineWidth,
                        height: token.calc(token.fontHeight).sub(token.calc(token.marginXXS).mul(2)).equal(),
                        transform: 'translateY(-50%)',
                        backgroundColor: token.colorSplit
                    }
                }
            },
            [`${componentCls}-empty`]: {
                padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(padding)} 0`,
                color: colorTextDescription,
                fontSize: token.fontSizeSM,
                textAlign: 'center'
            },
            [`${componentCls}-empty-text`]: {
                padding: emptyTextPadding,
                color: token.colorTextDisabled,
                fontSize: token.fontSize,
                textAlign: 'center'
            },
            // ============================ without flex ============================
            [`${componentCls}-item-no-flex`]: {
                display: 'block'
            }
        },
        [`${componentCls}-grid ${antCls}-col > ${componentCls}-item`]: {
            display: 'block',
            maxWidth: '100%',
            marginBlockEnd: margin,
            paddingBlock: 0,
            borderBlockEnd: 'none'
        },
        [`${componentCls}-vertical ${componentCls}-item`]: {
            alignItems: 'initial',
            [`${componentCls}-item-main`]: {
                display: 'block',
                flex: 1
            },
            [`${componentCls}-item-extra`]: {
                marginInlineStart: marginLG
            },
            [`${componentCls}-item-meta`]: {
                marginBlockEnd: metaMarginBottom,
                [`${componentCls}-item-meta-title`]: {
                    marginBlockStart: 0,
                    marginBlockEnd: titleMarginBottom,
                    color: colorText,
                    fontSize: token.fontSizeLG,
                    lineHeight: token.lineHeightLG
                }
            },
            [`${componentCls}-item-action`]: {
                marginBlockStart: padding,
                marginInlineStart: 'auto',
                '> li': {
                    padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(padding)}`,
                    '&:first-child': {
                        paddingInlineStart: 0
                    }
                }
            }
        },
        [`${componentCls}-split ${componentCls}-item`]: {
            borderBlockEnd: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
            '&:last-child': {
                borderBlockEnd: 'none'
            }
        },
        [`${componentCls}-split ${componentCls}-header`]: {
            borderBlockEnd: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        },
        [`${componentCls}-split${componentCls}-empty ${componentCls}-footer`]: {
            borderTop: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        },
        [`${componentCls}-loading ${componentCls}-spin-nested-loading`]: {
            minHeight: controlHeight
        },
        [`${componentCls}-split${componentCls}-something-after-last-item ${antCls}-spin-container > ${componentCls}-items > ${componentCls}-item:last-child`]: {
            borderBlockEnd: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        },
        [`${componentCls}-lg ${componentCls}-item`]: {
            padding: itemPaddingLG
        },
        [`${componentCls}-sm ${componentCls}-item`]: {
            padding: itemPaddingSM
        },
        // Horizontal
        [`${componentCls}:not(${componentCls}-vertical)`]: {
            [`${componentCls}-item-no-flex`]: {
                [`${componentCls}-item-action`]: {
                    float: 'right'
                }
            }
        }
    };
};
const $74b90c7456f9733d$export$9ca1be8807fe0675 = (token)=>({
        contentWidth: 220,
        itemPadding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingContentVertical)} 0`,
        itemPaddingSM: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingContentVerticalSM)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingContentHorizontal)}`,
        itemPaddingLG: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingContentVerticalLG)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.paddingContentHorizontalLG)}`,
        headerBg: 'transparent',
        footerBg: 'transparent',
        emptyTextPadding: token.padding,
        metaMarginBottom: token.padding,
        avatarMarginRight: token.padding,
        titleMarginBottom: token.paddingSM,
        descriptionFontSize: token.fontSize
    });
var // ============================== Export ==============================
$74b90c7456f9733d$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('List', (token)=>{
    const listToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        listBorderedCls: `${token.componentCls}-bordered`,
        minHeight: token.controlHeightLG
    });
    return [
        $74b90c7456f9733d$var$genBaseStyle(listToken),
        $74b90c7456f9733d$var$genBorderedStyle(listToken),
        $74b90c7456f9733d$var$genResponsiveStyle(listToken)
    ];
}, $74b90c7456f9733d$export$9ca1be8807fe0675);


"use client";
const $6f840f72071c73c6$var$InternalList = (props, ref)=>{
    const { pagination: pagination = false, prefixCls: customizePrefixCls, bordered: bordered = false, split: split = true, className: className, rootClassName: rootClassName, style: style, children: children, itemLayout: itemLayout, loadMore: loadMore, grid: grid, dataSource: dataSource = [], size: customizeSize, header: header, footer: footer, loading: loading = false, rowKey: rowKey, renderItem: renderItem, locale: locale, ...rest } = props;
    const paginationObj = pagination && typeof pagination === 'object' ? pagination : {};
    const [paginationCurrent, setPaginationCurrent] = $ltGt3.useState(paginationObj.defaultCurrent || 1);
    const [paginationSize, setPaginationSize] = $ltGt3.useState(paginationObj.defaultPageSize || 10);
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('list');
    const { renderEmpty: renderEmpty } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const defaultPaginationProps = {
        current: 1,
        total: 0,
        position: 'bottom'
    };
    const triggerPaginationEvent = (eventName)=>(page, pageSize)=>{
            setPaginationCurrent(page);
            setPaginationSize(pageSize);
            if (pagination) pagination?.[eventName]?.(page, pageSize);
        };
    const onPaginationChange = triggerPaginationEvent('onChange');
    const onPaginationShowSizeChange = triggerPaginationEvent('onShowSizeChange');
    const renderInternalItem = (item, index)=>{
        if (!renderItem) return null;
        let key;
        if (typeof rowKey === 'function') key = rowKey(item);
        else if (rowKey) key = item[rowKey];
        else key = item.key;
        if (!key) key = `list-item-${index}`;
        return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, {
            key: key
        }, renderItem(item, index));
    };
    const isSomethingAfterLastItem = !!(loadMore || pagination || footer);
    const prefixCls = getPrefixCls('list', customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $74b90c7456f9733d$export$2e2bcd8739ae039)(prefixCls);
    let loadingProp = loading;
    if (typeof loadingProp === 'boolean') loadingProp = {
        spinning: loadingProp
    };
    const isLoading = !!loadingProp?.spinning;
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)(customizeSize);
    // large => lg
    // small => sm
    let sizeCls = '';
    switch(mergedSize){
        case 'large':
            sizeCls = 'lg';
            break;
        case 'small':
            sizeCls = 'sm';
            break;
        default:
            break;
    }
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-vertical`]: itemLayout === 'vertical',
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-split`]: split,
        [`${prefixCls}-bordered`]: bordered,
        [`${prefixCls}-loading`]: isLoading,
        [`${prefixCls}-grid`]: !!grid,
        [`${prefixCls}-something-after-last-item`]: isSomethingAfterLastItem,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, contextClassName, className, rootClassName, hashId, cssVarCls);
    const paginationProps = (0, $40cefbb323433535$export$2e2bcd8739ae039)(defaultPaginationProps, {
        total: dataSource.length,
        current: paginationCurrent,
        pageSize: paginationSize
    }, pagination || {});
    const largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);
    paginationProps.current = Math.min(paginationProps.current, largestPage);
    const paginationContent = pagination && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-pagination`)
    }, /*#__PURE__*/ $ltGt3.createElement((0, $ba6ccffd2ae02ebb$export$2e2bcd8739ae039), {
        align: "end",
        ...paginationProps,
        onChange: onPaginationChange,
        onShowSizeChange: onPaginationShowSizeChange
    }));
    let splitDataSource = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(dataSource);
    if (pagination) {
        if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) splitDataSource = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
    }
    const needResponsive = Object.keys(grid || {}).some((key)=>[
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            'xxl'
        ].includes(key));
    const screens = (0, $ec3b57b710702d4d$export$2e2bcd8739ae039)(needResponsive);
    const currentBreakpoint = $ltGt3.useMemo(()=>{
        for(let i = 0; i < (0, $86b5776d49437dca$export$74c1bf8296b1541f).length; i += 1){
            const breakpoint = (0, $86b5776d49437dca$export$74c1bf8296b1541f)[i];
            if (screens[breakpoint]) return breakpoint;
        }
        return undefined;
    }, [
        screens
    ]);
    const colStyle = $ltGt3.useMemo(()=>{
        if (!grid) return undefined;
        const columnCount = currentBreakpoint && grid[currentBreakpoint] ? grid[currentBreakpoint] : grid.column;
        if (columnCount) return {
            width: `${100 / columnCount}%`,
            maxWidth: `${100 / columnCount}%`
        };
    }, [
        JSON.stringify(grid),
        currentBreakpoint
    ]);
    let childrenContent = isLoading && /*#__PURE__*/ $ltGt3.createElement("div", {
        style: {
            minHeight: 53
        }
    });
    if (splitDataSource.length > 0) {
        const items = splitDataSource.map(renderInternalItem);
        childrenContent = grid ? /*#__PURE__*/ $ltGt3.createElement((0, $bd486463f4fb682b$export$2e2bcd8739ae039), {
            gutter: grid.gutter
        }, $ltGt3.Children.map(items, (child)=>/*#__PURE__*/ $ltGt3.createElement("div", {
                key: child?.key,
                style: colStyle
            }, child))) : /*#__PURE__*/ $ltGt3.createElement("ul", {
            className: `${prefixCls}-items`
        }, items);
    } else if (!children && !isLoading) childrenContent = /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-empty-text`
    }, locale?.emptyText || renderEmpty?.('List') || /*#__PURE__*/ $ltGt3.createElement((0, $48027d4a9fb402d4$export$2e2bcd8739ae039), {
        componentName: "List"
    }));
    const paginationPosition = paginationProps.position;
    const contextValue = $ltGt3.useMemo(()=>({
            grid: grid,
            itemLayout: itemLayout
        }), [
        JSON.stringify(grid),
        itemLayout
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $7ed35f2bef733cfc$export$52411773e0d6f15d).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: ref,
        style: {
            ...contextStyle,
            ...style
        },
        className: classString,
        ...rest
    }, (paginationPosition === 'top' || paginationPosition === 'both') && paginationContent, header && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-header`
    }, header), /*#__PURE__*/ $ltGt3.createElement((0, $f5e177132d6f3f0f$export$2e2bcd8739ae039), {
        ...loadingProp
    }, childrenContent, children), footer && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-footer`
    }, footer), loadMore || (paginationPosition === 'bottom' || paginationPosition === 'both') && paginationContent));
};
const $6f840f72071c73c6$var$ListWithForwardRef = /*#__PURE__*/ $ltGt3.forwardRef($6f840f72071c73c6$var$InternalList);
const $6f840f72071c73c6$var$List = $6f840f72071c73c6$var$ListWithForwardRef;
$6f840f72071c73c6$var$List.Item = (0, $921f613a86552f18$export$2e2bcd8739ae039);
var $6f840f72071c73c6$export$2e2bcd8739ae039 = $6f840f72071c73c6$var$List;






function $e5058ab3fce1e2a7$export$30b98ae171787f1a({ todos: todos, plantedPlantsNamesWithId: plantedPlantsNamesWithId = [] }) {
    const { token: token } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $ad1c3304c519fac5$export$2e2bcd8739ae039), {
        className: "news-page__list__card",
        style: {
            width: '100%'
        },
        title: intl.formatMessage({
            id: 'reminders'
        }),
        styles: {
            header: {
                borderBottom: '1px solid #f0f0f0'
            },
            body: {
                paddingTop: 16
            }
        },
        cover: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
            className: "news-page__list__card__orange-stripe"
        }),
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039), {
                // style={{width: '100%'}}
                // header={
                //   <Typography.Text color={'red'} strong>
                //     {intl.formatMessage({id: 'reminders'})}
                //   </Typography.Text>
                // }
                // footer={
                //   <Link to="/todos">
                //     {todos.length >= 1
                //       ? intl.formatMessage({id: 'seeAllReminders'})
                //       : intl.formatMessage({id: 'createFirstTask'})}
                //   </Link>
                // }
                //bordered
                dataSource: todos.length > 5 ? todos.slice(0, 5) : todos,
                renderItem: (item)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039).Item, {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            style: {
                                flexDirection: 'column'
                            },
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    style: {
                                        flexDirection: 'row'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                            children: [
                                                (0, $6dfc071b399cc1b6$export$bd87dd6af1226f02)(item.type).icon,
                                                item.type.type === 'custom' || !item.type.type ? (0, $6dfc071b399cc1b6$export$bd87dd6af1226f02)(item.type).name : intl.formatMessage({
                                                    id: `eventType-${(0, $6dfc071b399cc1b6$export$bd87dd6af1226f02)(item.type).name}`
                                                })
                                            ]
                                        }),
                                        item.plants.length > 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                            style: {
                                                color: '#f58153'
                                            },
                                            children: [
                                                `: `,
                                                item.plants.map((plant, index)=>index === 0 ? plant.name : `, ${plant.name}`)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                        className: "news-list-page__list__news__calendar",
                                        children: [
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9c348dd92383621c$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                className: "news-list-page__list__news__calendar__text",
                                                children: item.targetEndDateUtc ? `${item.targetStartDateUtc}-${item.targetEndDateUtc}` : item.targetStartDateUtc
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                style: {
                    margin: '12px 0'
                }
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("a", {
                className: "news-page__list__card__to-all",
                href: "/todos",
                children: [
                    todos.length >= 1 ? intl.formatMessage({
                        id: 'allPlannedTasks'
                    }) : intl.formatMessage({
                        id: 'createFirstTask'
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $532bc1903b13fec2$export$2e2bcd8739ae039), {
                        style: {
                            paddingLeft: '5px'
                        }
                    })
                ]
            })
        ]
    });
}









var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");


var $517c1002050921e0$var$DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $4a925ea9a82b34f3$export$2e2bcd8739ae039)
    }));
};
/**![double-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI3Mi45IDUxMmwyNjUuNC0zMzkuMWM0LjEtNS4yLjQtMTIuOS02LjMtMTIuOWgtNzcuM2MtNC45IDAtOS42IDIuMy0xMi42IDYuMUwxODYuOCA0OTIuM2EzMS45OSAzMS45OSAwIDAwMCAzOS41bDI1NS4zIDMyNi4xYzMgMy45IDcuNyA2LjEgMTIuNiA2LjFINTMyYzYuNyAwIDEwLjQtNy43IDYuMy0xMi45TDI3Mi45IDUxMnptMzA0IDBsMjY1LjQtMzM5LjFjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc3LjNjLTQuOSAwLTkuNiAyLjMtMTIuNiA2LjFMNDkwLjggNDkyLjNhMzEuOTkgMzEuOTkgMCAwMDAgMzkuNWwyNTUuMyAzMjYuMWMzIDMuOSA3LjcgNi4xIDEyLjYgNi4xSDgzNmM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1NzYuOSA1MTJ6IiAvPjwvc3ZnPg==) */ var $517c1002050921e0$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($517c1002050921e0$var$DoubleLeftOutlined);
var $517c1002050921e0$export$2e2bcd8739ae039 = $517c1002050921e0$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");


var $64e3e0e41d6a34f9$var$DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $b350722fea640ff1$export$2e2bcd8739ae039)
    }));
};
/**![double-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzMy4yIDQ5Mi4zTDI3Ny45IDE2Ni4xYy0zLTMuOS03LjctNi4xLTEyLjYtNi4xSDE4OGMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlMNDQ3LjEgNTEyIDE4MS43IDg1MS4xQTcuOTggNy45OCAwIDAwMTg4IDg2NGg3Ny4zYzQuOSAwIDkuNi0yLjMgMTIuNi02LjFsMjU1LjMtMzI2LjFjOS4xLTExLjcgOS4xLTI3LjkgMC0zOS41em0zMDQgMEw1ODEuOSAxNjYuMWMtMy0zLjktNy43LTYuMS0xMi42LTYuMUg0OTJjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45TDc1MS4xIDUxMiA0ODUuNyA4NTEuMUE3Ljk4IDcuOTggMCAwMDQ5MiA4NjRoNzcuM2M0LjkgMCA5LjYtMi4zIDEyLjYtNi4xbDI1NS4zLTMyNi4xYzkuMS0xMS43IDkuMS0yNy45IDAtMzkuNXoiIC8+PC9zdmc+) */ var $64e3e0e41d6a34f9$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($64e3e0e41d6a34f9$var$DoubleRightOutlined);
var $64e3e0e41d6a34f9$export$2e2bcd8739ae039 = $64e3e0e41d6a34f9$var$RefIcon;




var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");







var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
const $5de99243f2a09998$export$3062997f0b99863 = /*#__PURE__*/ $ltGt3.createContext(null);


function $91543cc69a4247ba$export$602246410992d405(src) {
    return new Promise((resolve)=>{
        if (!src) {
            resolve(false);
            return;
        }
        const img = document.createElement('img');
        img.onerror = ()=>resolve(false);
        img.onload = ()=>resolve(true);
        img.src = src;
    });
}
function $91543cc69a4247ba$export$1feb45891927fcb4() {
    const width = document.documentElement.clientWidth;
    const height = window.innerHeight || document.documentElement.clientHeight;
    return {
        width: width,
        height: height
    };
}





var $ltGt3 = parcelRequire("ltGt3");
const $4d96ce14b7a0053d$var$initialTransform = {
    x: 0,
    y: 0,
    rotate: 0,
    scale: 1,
    flipX: false,
    flipY: false
};
function $4d96ce14b7a0053d$export$2e2bcd8739ae039(imgRef, minScale, maxScale, onTransform) {
    const frame = (0, $ltGt3.useRef)(null);
    const queue = (0, $ltGt3.useRef)([]);
    const [transform, setTransform] = (0, $ltGt3.useState)($4d96ce14b7a0053d$var$initialTransform);
    const resetTransform = (action)=>{
        setTransform($4d96ce14b7a0053d$var$initialTransform);
        if (!(0, $003c57daacb79f0c$export$2e2bcd8739ae039)($4d96ce14b7a0053d$var$initialTransform, transform)) onTransform?.({
            transform: $4d96ce14b7a0053d$var$initialTransform,
            action: action
        });
    };
    /** Direct update transform */ const updateTransform = (newTransform, action)=>{
        if (frame.current === null) {
            queue.current = [];
            frame.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
                setTransform((preState)=>{
                    let memoState = preState;
                    queue.current.forEach((queueState)=>{
                        memoState = {
                            ...memoState,
                            ...queueState
                        };
                    });
                    frame.current = null;
                    onTransform?.({
                        transform: memoState,
                        action: action
                    });
                    return memoState;
                });
            });
        }
        queue.current.push({
            ...transform,
            ...newTransform
        });
    };
    /** Scale according to the position of centerX and centerY */ const dispatchZoomChange = (ratio, action, centerX, centerY, isTouch)=>{
        const { width: width, height: height, offsetWidth: offsetWidth, offsetHeight: offsetHeight, offsetLeft: offsetLeft, offsetTop: offsetTop } = imgRef.current;
        let newRatio = ratio;
        let newScale = transform.scale * ratio;
        if (newScale > maxScale) {
            newScale = maxScale;
            newRatio = maxScale / transform.scale;
        } else if (newScale < minScale) {
            // For mobile interactions, allow scaling down to the minimum scale.
            newScale = isTouch ? newScale : minScale;
            newRatio = newScale / transform.scale;
        }
        /** Default center point scaling */ const mergedCenterX = centerX ?? innerWidth / 2;
        const mergedCenterY = centerY ?? innerHeight / 2;
        const diffRatio = newRatio - 1;
        /** Deviation calculated from image size */ const diffImgX = diffRatio * width * 0.5;
        const diffImgY = diffRatio * height * 0.5;
        /** The difference between the click position and the edge of the document */ const diffOffsetLeft = diffRatio * (mergedCenterX - transform.x - offsetLeft);
        const diffOffsetTop = diffRatio * (mergedCenterY - transform.y - offsetTop);
        /** Final positioning */ let newX = transform.x - (diffOffsetLeft - diffImgX);
        let newY = transform.y - (diffOffsetTop - diffImgY);
        /**
     * When zooming the image
     * When the image size is smaller than the width and height of the window, the position is initialized
     */ if (ratio < 1 && newScale === 1) {
            const mergedWidth = offsetWidth * newScale;
            const mergedHeight = offsetHeight * newScale;
            const { width: clientWidth, height: clientHeight } = (0, $91543cc69a4247ba$export$1feb45891927fcb4)();
            if (mergedWidth <= clientWidth && mergedHeight <= clientHeight) {
                newX = 0;
                newY = 0;
            }
        }
        updateTransform({
            x: newX,
            y: newY,
            scale: newScale
        }, action);
    };
    return {
        transform: transform,
        resetTransform: resetTransform,
        updateTransform: updateTransform,
        dispatchZoomChange: dispatchZoomChange
    };
}




var $ltGt3 = parcelRequire("ltGt3");

function $699670bf7ffcb7e5$var$fixPoint(key, start, width, clientWidth) {
    const startAddWidth = start + width;
    const offsetStart = (width - clientWidth) / 2;
    if (width > clientWidth) {
        if (start > 0) return {
            [key]: offsetStart
        };
        if (start < 0 && startAddWidth < clientWidth) return {
            [key]: -offsetStart
        };
    } else if (start < 0 || startAddWidth > clientWidth) return {
        [key]: start < 0 ? offsetStart : -offsetStart
    };
    return {};
}
function $699670bf7ffcb7e5$export$2e2bcd8739ae039(width, height, left, top) {
    const { width: clientWidth, height: clientHeight } = (0, $91543cc69a4247ba$export$1feb45891927fcb4)();
    let fixPos = null;
    if (width <= clientWidth && height <= clientHeight) fixPos = {
        x: 0,
        y: 0
    };
    else if (width > clientWidth || height > clientHeight) fixPos = {
        ...$699670bf7ffcb7e5$var$fixPoint('x', left, width, clientWidth),
        ...$699670bf7ffcb7e5$var$fixPoint('y', top, height, clientHeight)
    };
    return fixPos;
}


/** Scale the ratio base */ const $eb61ade57920d383$export$6e76060232ffaf48 = 1;
const $eb61ade57920d383$export$137a7d87d4a2aae5 = 1;


function $7796be7b83c0f514$export$2e2bcd8739ae039(imgRef, movable, open, scaleStep, transform, updateTransform, dispatchZoomChange) {
    const { rotate: rotate, scale: scale, x: x, y: y } = transform;
    const [isMoving, setMoving] = (0, $ltGt3.useState)(false);
    const startPositionInfo = (0, $ltGt3.useRef)({
        diffX: 0,
        diffY: 0,
        transformX: 0,
        transformY: 0
    });
    const onMouseDown = (event)=>{
        // Only allow main button
        if (!movable || event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        startPositionInfo.current = {
            diffX: event.pageX - x,
            diffY: event.pageY - y,
            transformX: x,
            transformY: y
        };
        setMoving(true);
    };
    const onMouseMove = (event)=>{
        if (open && isMoving) updateTransform({
            x: event.pageX - startPositionInfo.current.diffX,
            y: event.pageY - startPositionInfo.current.diffY
        }, 'move');
    };
    const onMouseUp = ()=>{
        if (open && isMoving) {
            setMoving(false);
            /** No need to restore the position when the picture is not moved, So as not to interfere with the click */ const { transformX: transformX, transformY: transformY } = startPositionInfo.current;
            const hasChangedPosition = x !== transformX && y !== transformY;
            if (!hasChangedPosition) return;
            const width = imgRef.current.offsetWidth * scale;
            const height = imgRef.current.offsetHeight * scale;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { left: left, top: top } = imgRef.current.getBoundingClientRect();
            const isRotate = rotate % 180 !== 0;
            const fixState = (0, $699670bf7ffcb7e5$export$2e2bcd8739ae039)(isRotate ? height : width, isRotate ? width : height, left, top);
            if (fixState) updateTransform({
                ...fixState
            }, 'dragRebound');
        }
    };
    const onWheel = (event)=>{
        if (!open || event.deltaY == 0) return;
        // Scale ratio depends on the deltaY size
        const scaleRatio = Math.abs(event.deltaY / 100);
        // Limit the maximum scale ratio
        const mergedScaleRatio = Math.min(scaleRatio, (0, $eb61ade57920d383$export$137a7d87d4a2aae5));
        // Scale the ratio each time
        let ratio = (0, $eb61ade57920d383$export$6e76060232ffaf48) + mergedScaleRatio * scaleStep;
        if (event.deltaY > 0) ratio = (0, $eb61ade57920d383$export$6e76060232ffaf48) / ratio;
        dispatchZoomChange(ratio, 'wheel', event.clientX, event.clientY);
    };
    (0, $ltGt3.useEffect)(()=>{
        if (movable) {
            window.addEventListener('mouseup', onMouseUp, false);
            window.addEventListener('mousemove', onMouseMove, false);
            try {
                // Resolve if in iframe lost event
                /* istanbul ignore next */ if (window.top !== window.self) {
                    window.top.addEventListener('mouseup', onMouseUp, false);
                    window.top.addEventListener('mousemove', onMouseMove, false);
                }
            } catch (error) {
                /* istanbul ignore next */ (0, $474154b5a64067c8$export$491112666e282270)(false, `[rc-image] ${error}`);
            }
        }
        return ()=>{
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('mousemove', onMouseMove);
            // /* istanbul ignore next */
            window.top?.removeEventListener('mouseup', onMouseUp);
            // /* istanbul ignore next */
            window.top?.removeEventListener('mousemove', onMouseMove);
        };
    }, [
        open,
        isMoving,
        x,
        y,
        rotate,
        movable
    ]);
    return {
        isMoving: isMoving,
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        onWheel: onWheel
    };
}



var $ltGt3 = parcelRequire("ltGt3");

function $6d3a8fa7d29c357b$export$2e2bcd8739ae039({ src: src, isCustomPlaceholder: isCustomPlaceholder, fallback: fallback }) {
    const [status, setStatus] = (0, $ltGt3.useState)(isCustomPlaceholder ? 'loading' : 'normal');
    const isLoaded = (0, $ltGt3.useRef)(false);
    const isError = status === 'error';
    // https://github.com/react-component/image/pull/187
    (0, $ltGt3.useEffect)(()=>{
        let isCurrentSrc = true;
        (0, $91543cc69a4247ba$export$602246410992d405)(src).then((isValid)=>{
            // https://github.com/ant-design/ant-design/issues/44948
            // If src changes, the previous setStatus should not be triggered
            if (!isValid && isCurrentSrc) setStatus('error');
        });
        return ()=>{
            isCurrentSrc = false;
        };
    }, [
        src
    ]);
    (0, $ltGt3.useEffect)(()=>{
        if (isCustomPlaceholder && !isLoaded.current) setStatus('loading');
        else if (isError) setStatus('normal');
    }, [
        src
    ]);
    const onLoad = ()=>{
        setStatus('normal');
    };
    const getImgRef = (img)=>{
        isLoaded.current = false;
        if (status === 'loading' && img?.complete && (img.naturalWidth || img.naturalHeight)) {
            isLoaded.current = true;
            onLoad();
        }
    };
    const srcAndOnload = isError && fallback ? {
        src: fallback
    } : {
        onLoad: onLoad,
        src: src
    };
    return [
        getImgRef,
        srcAndOnload,
        status
    ];
}



var $ltGt3 = parcelRequire("ltGt3");

function $fa793af657a3ff03$var$getDistance(a, b) {
    const x = a.x - b.x;
    const y = a.y - b.y;
    return Math.hypot(x, y);
}
function $fa793af657a3ff03$var$getCenter(oldPoint1, oldPoint2, newPoint1, newPoint2) {
    // Calculate the distance each point has moved
    const distance1 = $fa793af657a3ff03$var$getDistance(oldPoint1, newPoint1);
    const distance2 = $fa793af657a3ff03$var$getDistance(oldPoint2, newPoint2);
    // If both distances are 0, return the original points
    if (distance1 === 0 && distance2 === 0) return [
        oldPoint1.x,
        oldPoint1.y
    ];
    // Calculate the ratio of the distances
    const ratio = distance1 / (distance1 + distance2);
    // Calculate the new center point based on the ratio
    const x = oldPoint1.x + ratio * (oldPoint2.x - oldPoint1.x);
    const y = oldPoint1.y + ratio * (oldPoint2.y - oldPoint1.y);
    return [
        x,
        y
    ];
}
function $fa793af657a3ff03$export$2e2bcd8739ae039(imgRef, movable, open, minScale, transform, updateTransform, dispatchZoomChange) {
    const { rotate: rotate, scale: scale, x: x, y: y } = transform;
    const [isTouching, setIsTouching] = (0, $ltGt3.useState)(false);
    const touchPointInfo = (0, $ltGt3.useRef)({
        point1: {
            x: 0,
            y: 0
        },
        point2: {
            x: 0,
            y: 0
        },
        eventType: 'none'
    });
    const updateTouchPointInfo = (values)=>{
        touchPointInfo.current = {
            ...touchPointInfo.current,
            ...values
        };
    };
    const onTouchStart = (event)=>{
        if (!movable) return;
        event.stopPropagation();
        setIsTouching(true);
        const { touches: touches = [] } = event;
        if (touches.length > 1) // touch zoom
        updateTouchPointInfo({
            point1: {
                x: touches[0].clientX,
                y: touches[0].clientY
            },
            point2: {
                x: touches[1].clientX,
                y: touches[1].clientY
            },
            eventType: 'touchZoom'
        });
        else // touch move
        updateTouchPointInfo({
            point1: {
                x: touches[0].clientX - x,
                y: touches[0].clientY - y
            },
            eventType: 'move'
        });
    };
    const onTouchMove = (event)=>{
        const { touches: touches = [] } = event;
        const { point1: point1, point2: point2, eventType: eventType } = touchPointInfo.current;
        if (touches.length > 1 && eventType === 'touchZoom') {
            // touch zoom
            const newPoint1 = {
                x: touches[0].clientX,
                y: touches[0].clientY
            };
            const newPoint2 = {
                x: touches[1].clientX,
                y: touches[1].clientY
            };
            const [centerX, centerY] = $fa793af657a3ff03$var$getCenter(point1, point2, newPoint1, newPoint2);
            const ratio = $fa793af657a3ff03$var$getDistance(newPoint1, newPoint2) / $fa793af657a3ff03$var$getDistance(point1, point2);
            dispatchZoomChange(ratio, 'touchZoom', centerX, centerY, true);
            updateTouchPointInfo({
                point1: newPoint1,
                point2: newPoint2,
                eventType: 'touchZoom'
            });
        } else if (eventType === 'move') {
            // touch move
            updateTransform({
                x: touches[0].clientX - point1.x,
                y: touches[0].clientY - point1.y
            }, 'move');
            updateTouchPointInfo({
                eventType: 'move'
            });
        }
    };
    const onTouchEnd = ()=>{
        if (!open) return;
        if (isTouching) setIsTouching(false);
        updateTouchPointInfo({
            eventType: 'none'
        });
        if (minScale > scale) /** When the scaling ratio is less than the minimum scaling ratio, reset the scaling ratio */ return updateTransform({
            x: 0,
            y: 0,
            scale: minScale
        }, 'touchZoom');
        const width = imgRef.current.offsetWidth * scale;
        const height = imgRef.current.offsetHeight * scale;
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { left: left, top: top } = imgRef.current.getBoundingClientRect();
        const isRotate = rotate % 180 !== 0;
        const fixState = (0, $699670bf7ffcb7e5$export$2e2bcd8739ae039)(isRotate ? height : width, isRotate ? width : height, left, top);
        if (fixState) updateTransform({
            ...fixState
        }, 'dragRebound');
    };
    (0, $ltGt3.useEffect)(()=>{
        const preventDefault = (e)=>{
            e.preventDefault();
        };
        if (open && movable) window.addEventListener('touchmove', preventDefault, {
            passive: false
        });
        return ()=>{
            window.removeEventListener('touchmove', preventDefault);
        };
    }, [
        open,
        movable
    ]);
    return {
        isTouching: isTouching,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
}




var $ltGt3 = parcelRequire("ltGt3");
function $6d8aade0194fa741$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, icon: icon, onClick: onClick } = props;
    return /*#__PURE__*/ $ltGt3.createElement("button", {
        className: `${prefixCls}-close`,
        onClick: onClick
    }, icon);
}




var $ltGt3 = parcelRequire("ltGt3");
function $8833bcc69b1a8b2e$export$2e2bcd8739ae039(props) {
    // 修改解构，添加缺失的属性，并提供默认值
    const { prefixCls: prefixCls, showProgress: showProgress, current: current, count: count, showSwitch: showSwitch, classNames: // Style
    classNames, styles: styles, icons: // render
    icons, image: image, transform: transform, countRender: countRender, actionsRender: actionsRender, scale: // Scale
    scale, minScale: minScale, maxScale: maxScale, onActive: // Actions
    onActive, onFlipY: onFlipY, onFlipX: onFlipX, onRotateLeft: onRotateLeft, onRotateRight: onRotateRight, onZoomOut: onZoomOut, onZoomIn: onZoomIn, onClose: onClose, onReset: onReset } = props;
    const { left: left, right: right, prev: prev, next: next, flipY: flipY, flipX: flipX, rotateLeft: rotateLeft, rotateRight: rotateRight, zoomOut: zoomOut, zoomIn: zoomIn } = icons;
    // ========================== Render ==========================
    // >>>>> Progress
    const progressNode = showProgress && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-progress`
    }, countRender ? countRender(current + 1, count) : /*#__PURE__*/ $ltGt3.createElement("bdi", null, `${current + 1} / ${count}`));
    // >>>>> Actions
    const actionCls = `${prefixCls}-actions-action`;
    const renderOperation = ({ type: type, disabled: disabled, onClick: onClick, icon: icon })=>{
        return /*#__PURE__*/ $ltGt3.createElement("div", {
            key: type,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(actionCls, `${actionCls}-${type}`, {
                [`${actionCls}-disabled`]: !!disabled
            }),
            onClick: onClick
        }, icon);
    };
    const switchPrevNode = showSwitch ? renderOperation({
        icon: prev ?? left,
        onClick: ()=>onActive(-1),
        type: 'prev',
        disabled: current === 0
    }) : undefined;
    const switchNextNode = showSwitch ? renderOperation({
        icon: next ?? right,
        onClick: ()=>onActive(1),
        type: 'next',
        disabled: current === count - 1
    }) : undefined;
    const flipYNode = renderOperation({
        icon: flipY,
        onClick: onFlipY,
        type: 'flipY'
    });
    const flipXNode = renderOperation({
        icon: flipX,
        onClick: onFlipX,
        type: 'flipX'
    });
    const rotateLeftNode = renderOperation({
        icon: rotateLeft,
        onClick: onRotateLeft,
        type: 'rotateLeft'
    });
    const rotateRightNode = renderOperation({
        icon: rotateRight,
        onClick: onRotateRight,
        type: 'rotateRight'
    });
    const zoomOutNode = renderOperation({
        icon: zoomOut,
        onClick: onZoomOut,
        type: 'zoomOut',
        disabled: scale <= minScale
    });
    const zoomInNode = renderOperation({
        icon: zoomIn,
        onClick: onZoomIn,
        type: 'zoomIn',
        disabled: scale === maxScale
    });
    const actionsNode = /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-actions`, classNames.actions),
        style: styles.actions
    }, flipYNode, flipXNode, rotateLeftNode, rotateRightNode, zoomOutNode, zoomInNode);
    // >>>>> Render
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-footer`, classNames.footer),
        style: styles.footer
    }, progressNode, actionsRender ? actionsRender(actionsNode, {
        icons: {
            prevIcon: switchPrevNode,
            nextIcon: switchNextNode,
            flipYIcon: flipYNode,
            flipXIcon: flipXNode,
            rotateLeftIcon: rotateLeftNode,
            rotateRightIcon: rotateRightNode,
            zoomOutIcon: zoomOutNode,
            zoomInIcon: zoomInNode
        },
        actions: {
            onActive: onActive,
            onFlipY: onFlipY,
            onFlipX: onFlipX,
            onRotateLeft: onRotateLeft,
            onRotateRight: onRotateRight,
            onZoomOut: onZoomOut,
            onZoomIn: onZoomIn,
            onReset: onReset,
            onClose: onClose
        },
        transform: transform,
        current: current,
        total: count,
        image: image
    }) : actionsNode);
}




var $ltGt3 = parcelRequire("ltGt3");
function $9f53fdc8bda6f2be$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, onActive: onActive, current: current, count: count, icons: { left: left, right: right, prev: prev, next: next } } = props;
    const switchCls = `${prefixCls}-switch`;
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(switchCls, `${switchCls}-prev`, {
            [`${switchCls}-disabled`]: current === 0
        }),
        onClick: ()=>onActive(-1)
    }, prev ?? left), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(switchCls, `${switchCls}-next`, {
            [`${switchCls}-disabled`]: current === count - 1
        }),
        onClick: ()=>onActive(1)
    }, next ?? right));
}


function $4e03ff9e4688d8e1$var$_extends() {
    $4e03ff9e4688d8e1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4e03ff9e4688d8e1$var$_extends.apply(this, arguments);
}
// Note: if you want to add `action`,
// pls contact @zombieJ or @thinkasany first.
const $4e03ff9e4688d8e1$var$PreviewImage = ({ fallback: fallback, src: src, imgRef: imgRef, ...props })=>{
    const [getImgRef, srcAndOnload] = (0, $6d3a8fa7d29c357b$export$2e2bcd8739ae039)({
        src: src,
        fallback: fallback
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("img", $4e03ff9e4688d8e1$var$_extends({
        ref: (ref)=>{
            imgRef.current = ref;
            getImgRef(ref);
        }
    }, props, srcAndOnload));
};
const $4e03ff9e4688d8e1$var$Preview = (props)=>{
    const { prefixCls: prefixCls, rootClassName: rootClassName, src: src, alt: alt, imageInfo: imageInfo, fallback: fallback, movable: movable = true, onClose: onClose, open: open, afterOpenChange: afterOpenChange, icons: icons = {}, closeIcon: closeIcon, getContainer: getContainer, current: current = 0, count: count = 1, countRender: countRender, scaleStep: scaleStep = 0.5, minScale: minScale = 1, maxScale: maxScale = 50, motionName: motionName = 'fade', imageRender: imageRender, imgCommonProps: imgCommonProps, actionsRender: actionsRender, onTransform: onTransform, onChange: onChange, classNames: classNames = {}, styles: styles = {}, mousePosition: mousePosition, zIndex: zIndex } = props;
    const imgRef = (0, $ltGt3.useRef)();
    const groupContext = (0, $ltGt3.useContext)((0, $5de99243f2a09998$export$3062997f0b99863));
    const showLeftOrRightSwitches = groupContext && count > 1;
    const showOperationsProgress = groupContext && count >= 1;
    // ======================== Transform =========================
    const [enableTransition, setEnableTransition] = (0, $ltGt3.useState)(true);
    const { transform: transform, resetTransform: resetTransform, updateTransform: updateTransform, dispatchZoomChange: dispatchZoomChange } = (0, $4d96ce14b7a0053d$export$2e2bcd8739ae039)(imgRef, minScale, maxScale, onTransform);
    const { isMoving: isMoving, onMouseDown: onMouseDown, onWheel: onWheel } = (0, $7796be7b83c0f514$export$2e2bcd8739ae039)(imgRef, movable, open, scaleStep, transform, updateTransform, dispatchZoomChange);
    const { isTouching: isTouching, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd } = (0, $fa793af657a3ff03$export$2e2bcd8739ae039)(imgRef, movable, open, minScale, transform, updateTransform, dispatchZoomChange);
    const { rotate: rotate, scale: scale } = transform;
    (0, $ltGt3.useEffect)(()=>{
        if (!enableTransition) setEnableTransition(true);
    }, [
        enableTransition
    ]);
    (0, $ltGt3.useEffect)(()=>{
        if (!open) resetTransform('close');
    }, [
        open
    ]);
    // ========================== Image ===========================
    const onDoubleClick = (event)=>{
        if (open) {
            if (scale !== 1) updateTransform({
                x: 0,
                y: 0,
                scale: 1
            }, 'doubleClick');
            else dispatchZoomChange((0, $eb61ade57920d383$export$6e76060232ffaf48) + scaleStep, 'doubleClick', event.clientX, event.clientY);
        }
    };
    const imgNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement($4e03ff9e4688d8e1$var$PreviewImage, $4e03ff9e4688d8e1$var$_extends({}, imgCommonProps, {
        width: props.width,
        height: props.height,
        imgRef: imgRef,
        className: `${prefixCls}-img`,
        alt: alt,
        style: {
            transform: `translate3d(${transform.x}px, ${transform.y}px, 0) scale3d(${transform.flipX ? '-' : ''}${scale}, ${transform.flipY ? '-' : ''}${scale}, 1) rotate(${rotate}deg)`,
            transitionDuration: (!enableTransition || isTouching) && '0s'
        },
        fallback: fallback,
        src: src,
        onWheel: onWheel,
        onMouseDown: onMouseDown,
        onDoubleClick: onDoubleClick,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onTouchCancel: onTouchEnd
    }));
    const image = {
        url: src,
        alt: alt,
        ...imageInfo
    };
    // ======================== Operation =========================
    // >>>>> Actions
    const onZoomIn = ()=>{
        dispatchZoomChange((0, $eb61ade57920d383$export$6e76060232ffaf48) + scaleStep, 'zoomIn');
    };
    const onZoomOut = ()=>{
        dispatchZoomChange((0, $eb61ade57920d383$export$6e76060232ffaf48) / ((0, $eb61ade57920d383$export$6e76060232ffaf48) + scaleStep), 'zoomOut');
    };
    const onRotateRight = ()=>{
        updateTransform({
            rotate: rotate + 90
        }, 'rotateRight');
    };
    const onRotateLeft = ()=>{
        updateTransform({
            rotate: rotate - 90
        }, 'rotateLeft');
    };
    const onFlipX = ()=>{
        updateTransform({
            flipX: !transform.flipX
        }, 'flipX');
    };
    const onFlipY = ()=>{
        updateTransform({
            flipY: !transform.flipY
        }, 'flipY');
    };
    const onReset = ()=>{
        resetTransform('reset');
    };
    const onActive = (offset)=>{
        const nextCurrent = current + offset;
        if (nextCurrent >= 0 && nextCurrent <= count - 1) {
            setEnableTransition(false);
            resetTransform(offset < 0 ? 'prev' : 'next');
            onChange?.(nextCurrent, current);
        }
    };
    // >>>>> Effect: Keyboard
    const onKeyDown = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((event)=>{
        if (open) {
            const { keyCode: keyCode } = event;
            if (keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ESC) onClose?.();
            if (showLeftOrRightSwitches) {
                if (keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).LEFT) onActive(-1);
                else if (keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).RIGHT) onActive(1);
            }
        }
    });
    (0, $ltGt3.useEffect)(()=>{
        if (open) {
            window.addEventListener('keydown', onKeyDown);
            return ()=>{
                window.removeEventListener('keydown', onKeyDown);
            };
        }
    }, [
        open
    ]);
    // ======================= Lock Scroll ========================
    const [lockScroll, setLockScroll] = (0, $ltGt3.useState)(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useEffect(()=>{
        if (open) setLockScroll(true);
    }, [
        open
    ]);
    const onVisibleChanged = (nextVisible)=>{
        if (!nextVisible) setLockScroll(false);
        afterOpenChange?.(nextVisible);
    };
    // ========================== Portal ==========================
    const [portalRender, setPortalRender] = (0, $ltGt3.useState)(false);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (open) setPortalRender(true);
    }, [
        open
    ]);
    // ========================== Render ==========================
    const bodyStyle = {
        ...styles.body
    };
    if (mousePosition) bodyStyle.transformOrigin = `${mousePosition.x}px ${mousePosition.y}px`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $0561688d8f19e269$export$2e2bcd8739ae039), {
        open: portalRender,
        getContainer: getContainer,
        autoLock: lockScroll
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $69429c2a85a175b0$export$2e2bcd8739ae039), {
        motionName: motionName,
        visible: portalRender && open,
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        onVisibleChanged: onVisibleChanged
    }, ({ className: motionClassName, style: motionStyle })=>{
        const mergedStyle = {
            ...styles.root,
            ...motionStyle
        };
        if (zIndex) mergedStyle.zIndex = zIndex;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prefixCls, rootClassName, classNames.root, motionClassName, {
                [`${prefixCls}-moving`]: isMoving
            }),
            style: mergedStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-mask`, classNames.mask),
            style: styles.mask,
            onClick: onClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-body`, classNames.body),
            style: bodyStyle
        }, imageRender ? imageRender(imgNode, {
            transform: transform,
            image: image,
            ...groupContext ? {
                current: current
            } : {}
        }) : imgNode), closeIcon !== false && closeIcon !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $6d8aade0194fa741$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            icon: closeIcon === true ? icons.close : closeIcon || icons.close,
            onClick: onClose
        }), showLeftOrRightSwitches && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $9f53fdc8bda6f2be$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            current: current,
            count: count,
            icons: icons,
            onActive: onActive
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $8833bcc69b1a8b2e$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            showProgress: showOperationsProgress,
            current: current,
            count: count,
            showSwitch: showLeftOrRightSwitches,
            classNames: classNames,
            styles: styles,
            image: image,
            transform: transform,
            icons: icons,
            countRender: countRender,
            actionsRender: actionsRender,
            scale: scale,
            minScale: minScale,
            maxScale: maxScale,
            onActive: onActive,
            onFlipY: onFlipY,
            onFlipX: onFlipX,
            onRotateLeft: onRotateLeft,
            onRotateRight: onRotateRight,
            onZoomOut: onZoomOut,
            onZoomIn: onZoomIn,
            onClose: onClose,
            onReset: onReset
        }));
    }));
};
var $4e03ff9e4688d8e1$export$2e2bcd8739ae039 = $4e03ff9e4688d8e1$var$Preview;





var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
const $cbbf7254e588c449$export$2367aee66755576 = [
    'crossOrigin',
    'decoding',
    'draggable',
    'loading',
    'referrerPolicy',
    'sizes',
    'srcSet',
    'useMap',
    'alt'
];


function $345530082e95b256$export$2e2bcd8739ae039(items) {
    // Context collection image data
    const [images, setImages] = $ltGt3.useState({});
    const registerImage = $ltGt3.useCallback((id, data)=>{
        setImages((imgs)=>({
                ...imgs,
                [id]: data
            }));
        return ()=>{
            setImages((imgs)=>{
                const cloneImgs = {
                    ...imgs
                };
                delete cloneImgs[id];
                return cloneImgs;
            });
        };
    }, []);
    // items
    const mergedItems = $ltGt3.useMemo(()=>{
        // use `items` first
        if (items) return items.map((item)=>{
            if (typeof item === 'string') return {
                data: {
                    src: item
                }
            };
            const data = {};
            Object.keys(item).forEach((key)=>{
                if ([
                    'src',
                    ...(0, $cbbf7254e588c449$export$2367aee66755576)
                ].includes(key)) data[key] = item[key];
            });
            return {
                data: data
            };
        });
        // use registered images secondly
        return Object.keys(images).reduce((total, id)=>{
            const { canPreview: canPreview, data: data } = images[id];
            if (canPreview) total.push({
                data: data,
                id: id
            });
            return total;
        }, []);
    }, [
        items,
        images
    ]);
    return [
        mergedItems,
        registerImage,
        !!items
    ];
}


function $97a903e3afe67f4d$var$_extends() {
    $97a903e3afe67f4d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97a903e3afe67f4d$var$_extends.apply(this, arguments);
}
const $97a903e3afe67f4d$var$Group = ({ previewPrefixCls: previewPrefixCls = 'rc-image-preview', classNames: classNames, styles: styles, children: children, icons: icons = {}, items: items, preview: preview, fallback: fallback })=>{
    const { open: previewOpen, onOpenChange: onOpenChange, current: currentIndex, onChange: onChange, ...restProps } = preview && typeof preview === 'object' ? preview : {};
    // ========================== Items ===========================
    const [mergedItems, register, fromItems] = (0, $345530082e95b256$export$2e2bcd8739ae039)(items);
    // ========================= Preview ==========================
    // >>> Index
    const [current, setCurrent] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(0, currentIndex);
    const [keepOpenIndex, setKeepOpenIndex] = (0, $ltGt3.useState)(false);
    // >>> Image
    const { src: src, ...imgCommonProps } = mergedItems[current]?.data || {};
    // >>> Visible
    const [isShowPreview, setShowPreview] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(!!previewOpen, previewOpen);
    const triggerShowPreview = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((next)=>{
        setShowPreview(next);
        if (next !== isShowPreview) onOpenChange?.(next, {
            current: current
        });
    });
    // >>> Position
    const [mousePosition, setMousePosition] = (0, $ltGt3.useState)(null);
    const onPreviewFromImage = $ltGt3.useCallback((id, imageSrc, mouseX, mouseY)=>{
        const index = fromItems ? mergedItems.findIndex((item)=>item.data.src === imageSrc) : mergedItems.findIndex((item)=>item.id === id);
        setCurrent(index < 0 ? 0 : index);
        triggerShowPreview(true);
        setMousePosition({
            x: mouseX,
            y: mouseY
        });
        setKeepOpenIndex(true);
    }, [
        mergedItems,
        fromItems
    ]);
    // Reset current when reopen
    $ltGt3.useEffect(()=>{
        if (isShowPreview) {
            if (!keepOpenIndex) setCurrent(0);
        } else setKeepOpenIndex(false);
    }, [
        isShowPreview
    ]);
    // ========================== Events ==========================
    const onInternalChange = (next, prev)=>{
        setCurrent(next);
        onChange?.(next, prev);
    };
    const onPreviewClose = ()=>{
        triggerShowPreview(false);
        setMousePosition(null);
    };
    // ========================= Context ==========================
    const previewGroupContext = $ltGt3.useMemo(()=>({
            register: register,
            onPreview: onPreviewFromImage
        }), [
        register,
        onPreviewFromImage
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $5de99243f2a09998$export$3062997f0b99863).Provider, {
        value: previewGroupContext
    }, children, /*#__PURE__*/ $ltGt3.createElement((0, $4e03ff9e4688d8e1$export$2e2bcd8739ae039), $97a903e3afe67f4d$var$_extends({
        "aria-hidden": !isShowPreview,
        open: isShowPreview,
        prefixCls: previewPrefixCls,
        onClose: onPreviewClose,
        mousePosition: mousePosition,
        imgCommonProps: imgCommonProps,
        src: src,
        fallback: fallback,
        icons: icons,
        current: current,
        count: mergedItems.length,
        onChange: onInternalChange
    }, restProps, {
        classNames: classNames?.popup,
        styles: styles?.popup
    })));
};
var $97a903e3afe67f4d$export$2e2bcd8739ae039 = $97a903e3afe67f4d$var$Group;





var $ltGt3 = parcelRequire("ltGt3");

let $d8206f10aa5767c2$var$uid = 0;
function $d8206f10aa5767c2$export$2e2bcd8739ae039(canPreview, data) {
    const [id] = $ltGt3.useState(()=>{
        $d8206f10aa5767c2$var$uid += 1;
        return String($d8206f10aa5767c2$var$uid);
    });
    const groupContext = $ltGt3.useContext((0, $5de99243f2a09998$export$3062997f0b99863));
    const registerData = {
        data: data,
        canPreview: canPreview
    };
    // Keep order start
    // Resolve https://github.com/ant-design/ant-design/issues/28881
    // Only need unRegister when component unMount
    $ltGt3.useEffect(()=>{
        if (groupContext) return groupContext.register(id, registerData);
    }, []);
    $ltGt3.useEffect(()=>{
        if (groupContext) groupContext.register(id, registerData);
    }, [
        canPreview,
        data
    ]);
    return id;
}



function $34f73b7a722fb461$var$_extends() {
    $34f73b7a722fb461$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $34f73b7a722fb461$var$_extends.apply(this, arguments);
}
const $34f73b7a722fb461$var$ImageInternal = (props)=>{
    const { prefixCls: // Misc
    prefixCls = 'rc-image', previewPrefixCls: previewPrefixCls = `${prefixCls}-preview`, rootClassName: // Style
    rootClassName, className: className, style: style, classNames: classNames = {}, styles: styles = {}, width: width, height: height, // Image
    src: imgSrc, alt: alt, placeholder: placeholder, fallback: fallback, preview: // Preview
    preview = true, onClick: // Events
    onClick, onError: onError, ...otherProps } = props;
    const groupContext = (0, $ltGt3.useContext)((0, $5de99243f2a09998$export$3062997f0b99863));
    // ========================== Preview ===========================
    const canPreview = !!preview;
    const { src: previewSrc, open: previewOpen, onOpenChange: onPreviewOpenChange, cover: cover, rootClassName: previewRootClassName, ...restProps } = preview && typeof preview === 'object' ? preview : {};
    const coverPlacement = typeof cover === 'object' && cover.placement ? cover.placement || 'center' : 'center';
    const coverNode = typeof cover === 'object' && cover.coverNode ? cover.coverNode : cover;
    // ============================ Open ============================
    const [isShowPreview, setShowPreview] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(!!previewOpen, previewOpen);
    const [mousePosition, setMousePosition] = (0, $ltGt3.useState)(null);
    const triggerPreviewOpen = (nextOpen)=>{
        setShowPreview(nextOpen);
        onPreviewOpenChange?.(nextOpen);
    };
    const onPreviewClose = ()=>{
        triggerPreviewOpen(false);
    };
    // ========================= ImageProps =========================
    const isCustomPlaceholder = placeholder && placeholder !== true;
    const src = previewSrc ?? imgSrc;
    const [getImgRef, srcAndOnload, status] = (0, $6d3a8fa7d29c357b$export$2e2bcd8739ae039)({
        src: imgSrc,
        isCustomPlaceholder: isCustomPlaceholder,
        fallback: fallback
    });
    const imgCommonProps = (0, $ltGt3.useMemo)(()=>{
        const obj = {};
        (0, $cbbf7254e588c449$export$2367aee66755576).forEach((prop)=>{
            if (props[prop] !== undefined) obj[prop] = props[prop];
        });
        return obj;
    }, (0, $cbbf7254e588c449$export$2367aee66755576).map((prop)=>props[prop]));
    // ========================== Register ==========================
    const registerData = (0, $ltGt3.useMemo)(()=>({
            ...imgCommonProps,
            src: src
        }), [
        src,
        imgCommonProps
    ]);
    const imageId = (0, $d8206f10aa5767c2$export$2e2bcd8739ae039)(canPreview, registerData);
    // ========================== Preview ===========================
    const onPreview = (e)=>{
        const rect = e.target.getBoundingClientRect();
        const left = rect.x + rect.width / 2;
        const top = rect.y + rect.height / 2;
        if (groupContext) groupContext.onPreview(imageId, src, left, top);
        else {
            setMousePosition({
                x: left,
                y: top
            });
            triggerPreviewOpen(true);
        }
        onClick?.(e);
    };
    // =========================== Render ===========================
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement("div", $34f73b7a722fb461$var$_extends({}, otherProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prefixCls, rootClassName, classNames.root, {
            [`${prefixCls}-error`]: status === 'error'
        }),
        onClick: canPreview ? onPreview : onClick,
        style: {
            width: width,
            height: height,
            ...styles.root
        }
    }), /*#__PURE__*/ $ltGt3.createElement("img", $34f73b7a722fb461$var$_extends({}, imgCommonProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-img`, {
            [`${prefixCls}-img-placeholder`]: placeholder === true
        }, classNames.image, className),
        style: {
            height: height,
            ...styles.image,
            ...style
        },
        ref: getImgRef
    }, srcAndOnload, {
        width: width,
        height: height,
        onError: onError
    })), status === 'loading' && /*#__PURE__*/ $ltGt3.createElement("div", {
        "aria-hidden": "true",
        className: `${prefixCls}-placeholder`
    }, placeholder), cover !== false && canPreview && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-cover`, classNames.cover, `${prefixCls}-cover-${coverPlacement}`),
        style: {
            display: style?.display === 'none' ? 'none' : undefined,
            ...styles.cover
        }
    }, coverNode)), !groupContext && canPreview && /*#__PURE__*/ $ltGt3.createElement((0, $4e03ff9e4688d8e1$export$2e2bcd8739ae039), $34f73b7a722fb461$var$_extends({
        "aria-hidden": !isShowPreview,
        open: isShowPreview,
        prefixCls: previewPrefixCls,
        onClose: onPreviewClose,
        mousePosition: mousePosition,
        src: src,
        alt: alt,
        imageInfo: {
            width: width,
            height: height
        },
        fallback: fallback,
        imgCommonProps: imgCommonProps
    }, restProps, {
        classNames: classNames?.popup,
        styles: styles?.popup,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(previewRootClassName, rootClassName)
    })));
};
$34f73b7a722fb461$var$ImageInternal.PreviewGroup = (0, $97a903e3afe67f4d$export$2e2bcd8739ae039);
var $34f73b7a722fb461$export$2e2bcd8739ae039 = $34f73b7a722fb461$var$ImageInternal;


var $9b5c159988343bb7$export$2e2bcd8739ae039 = (0, $34f73b7a722fb461$export$2e2bcd8739ae039);








var $ltGt3 = parcelRequire("ltGt3");



const $92c8c85df965f10d$var$useMergedPreviewConfig = (previewConfig, contextPreviewConfig, prefixCls, mergedRootClassName, getContextPopupContainer, icons, defaultCover)=>{
    const [zIndex] = (0, $ad5b6b465efa8f67$export$3e7906d4075187a4)('ImagePreview', previewConfig?.zIndex);
    const [mergedPreviewMask, blurClassName] = (0, $6bb365da95a17eb7$export$a4ac1bdd74570410)(previewConfig?.mask, contextPreviewConfig?.mask, `${prefixCls}-preview`);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>{
        if (!previewConfig) return previewConfig;
        const { cover: cover, getContainer: getContainer, closeIcon: closeIcon, rootClassName: previewRootClassName } = previewConfig;
        const { closeIcon: contextCloseIcon } = contextPreviewConfig ?? {};
        return {
            motionName: (0, $32c4c593a0d4aef5$export$27c72201b1d09951)(`${prefixCls}-preview`, 'fade'),
            ...previewConfig,
            ...defaultCover ? {
                cover: cover ?? defaultCover
            } : {},
            icons: icons,
            getContainer: getContainer ?? getContextPopupContainer,
            zIndex: zIndex,
            closeIcon: closeIcon ?? contextCloseIcon,
            rootClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedRootClassName, previewRootClassName),
            mask: mergedPreviewMask,
            blurClassName: blurClassName.mask
        };
    }, [
        previewConfig,
        contextPreviewConfig,
        prefixCls,
        mergedRootClassName,
        getContextPopupContainer,
        defaultCover,
        icons,
        zIndex,
        mergedPreviewMask,
        blurClassName
    ]);
};
var $92c8c85df965f10d$export$2e2bcd8739ae039 = $92c8c85df965f10d$var$useMergedPreviewConfig;



var $ltGt3 = parcelRequire("ltGt3");

function $4ac8e37e26036568$var$normalizeMask(mask) {
    if (/*#__PURE__*/ (0, $ltGt3.isValidElement)(mask)) return [
        mask,
        undefined
    ];
    if (typeof mask === 'boolean' || mask && typeof mask === 'object') return [
        undefined,
        mask
    ];
    return [
        undefined,
        undefined
    ];
}
function $4ac8e37e26036568$export$2e2bcd8739ae039(preview) {
    // Get origin preview config
    const rawPreviewConfig = (0, $ltGt3.useMemo)(()=>{
        if (typeof preview === 'boolean') return preview ? {} : null;
        return preview && typeof preview === 'object' ? preview : {};
    }, [
        preview
    ]);
    const splittedPreviewConfig = (0, $ltGt3.useMemo)(()=>{
        if (!rawPreviewConfig) return [
            rawPreviewConfig,
            '',
            ''
        ];
        const { open: open, onOpenChange: onOpenChange, cover: cover, actionsRender: actionsRender, visible: visible, onVisibleChange: onVisibleChange, rootClassName: rootClassName, maskClassName: maskClassName, mask: mask, forceRender: _forceRender, destroyOnClose: _destroyOnClose, toolbarRender: toolbarRender, ...restPreviewConfig } = rawPreviewConfig;
        let onInternalOpenChange;
        if (onOpenChange) onInternalOpenChange = onOpenChange;
        else if (onVisibleChange) onInternalOpenChange = (nextOpen, info)=>{
            const { current: current } = info || {};
            if (current !== undefined) onVisibleChange(nextOpen, !nextOpen, current);
            else onVisibleChange(nextOpen, !nextOpen);
        };
        const [coverElement, maskConfig] = $4ac8e37e26036568$var$normalizeMask(mask);
        return [
            {
                ...restPreviewConfig,
                open: open ?? visible,
                onOpenChange: onInternalOpenChange,
                cover: cover ?? coverElement,
                mask: maskConfig,
                actionsRender: actionsRender ?? toolbarRender
            },
            rootClassName,
            maskClassName
        ];
    }, [
        rawPreviewConfig
    ]);
    var deprecatedName, newName;
    return splittedPreviewConfig;
}



var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $484cab26a28dcd0d$var$RotateLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z"
                }
            }
        ]
    },
    "name": "rotate-left",
    "theme": "outlined"
};
var $484cab26a28dcd0d$export$2e2bcd8739ae039 = $484cab26a28dcd0d$var$RotateLeftOutlined;



function $5cd908edfa84a66d$var$_extends() {
    $5cd908edfa84a66d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5cd908edfa84a66d$var$_extends.apply(this, arguments);
}
const $5cd908edfa84a66d$var$RotateLeftOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $5cd908edfa84a66d$var$_extends({}, props, {
        ref: ref,
        icon: (0, $484cab26a28dcd0d$export$2e2bcd8739ae039)
    }));
/**![rotate-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik02NzIgNDE4SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NDE0YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDUyOGMxNy43IDAgMzItMTQuMyAzMi0zMlY0NTBjMC0xNy43LTE0LjMtMzItMzItMzJ6bS00NCA0MDJIMTg4VjQ5NGg0NDB2MzI2eiIgLz48cGF0aCBkPSJNODE5LjMgMzI4LjVjLTc4LjgtMTAwLjctMTk2LTE1My42LTMxNC42LTE1NC4ybC0uMi02NGMwLTYuNS03LjYtMTAuMS0xMi42LTYuMWwtMTI4IDEwMWMtNCAzLjEtMy45IDkuMSAwIDEyLjNMNDkyIDMxOC42YzUuMSA0IDEyLjcuNCAxMi42LTYuMXYtNjMuOWMxMi45LjEgMjUuOS45IDM4LjggMi41IDQyLjEgNS4yIDgyLjEgMTguMiAxMTkgMzguNyAzOC4xIDIxLjIgNzEuMiA0OS43IDk4LjQgODQuMyAyNy4xIDM0LjcgNDYuNyA3My43IDU4LjEgMTE1LjhhMzI1Ljk1IDMyNS45NSAwIDAxNi41IDE0MC45aDc0LjljMTQuOC0xMDMuNi0xMS4zLTIxMy04MS0zMDIuM3oiIC8+PC9zdmc+) */ const $5cd908edfa84a66d$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($5cd908edfa84a66d$var$RotateLeftOutlined);
var $5cd908edfa84a66d$export$2e2bcd8739ae039 = $5cd908edfa84a66d$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $4ac8b421d4104251$var$RotateRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z"
                }
            }
        ]
    },
    "name": "rotate-right",
    "theme": "outlined"
};
var $4ac8b421d4104251$export$2e2bcd8739ae039 = $4ac8b421d4104251$var$RotateRightOutlined;



function $83faa8637951a6fe$var$_extends() {
    $83faa8637951a6fe$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $83faa8637951a6fe$var$_extends.apply(this, arguments);
}
const $83faa8637951a6fe$var$RotateRightOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $83faa8637951a6fe$var$_extends({}, props, {
        ref: ref,
        icon: (0, $4ac8b421d4104251$export$2e2bcd8739ae039)
    }));
/**![rotate-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik00ODAuNSAyNTEuMmMxMy0xLjYgMjUuOS0yLjQgMzguOC0yLjV2NjMuOWMwIDYuNSA3LjUgMTAuMSAxMi42IDYuMUw2NjAgMjE3LjZjNC0zLjIgNC05LjIgMC0xMi4zbC0xMjgtMTAxYy01LjEtNC0xMi42LS40LTEyLjYgNi4xbC0uMiA2NGMtMTE4LjYuNS0yMzUuOCA1My40LTMxNC42IDE1NC4yQTM5OS43NSAzOTkuNzUgMCAwMDEyMy41IDYzMWg3NC45Yy0uOS01LjMtMS43LTEwLjctMi40LTE2LjEtNS4xLTQyLjEtMi4xLTg0LjEgOC45LTEyNC44IDExLjQtNDIuMiAzMS04MS4xIDU4LjEtMTE1LjggMjcuMi0zNC43IDYwLjMtNjMuMiA5OC40LTg0LjMgMzctMjAuNiA3Ni45LTMzLjYgMTE5LjEtMzguOHoiIC8+PHBhdGggZD0iTTg4MCA0MThIMzUyYy0xNy43IDAtMzIgMTQuMy0zMiAzMnY0MTRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNTI4YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjQ1MGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQ0IDQwMkgzOTZWNDk0aDQ0MHYzMjZ6IiAvPjwvc3ZnPg==) */ const $83faa8637951a6fe$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($83faa8637951a6fe$var$RotateRightOutlined);
var $83faa8637951a6fe$export$2e2bcd8739ae039 = $83faa8637951a6fe$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $93e14de039976d06$var$SwapOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "swap",
    "theme": "outlined"
};
var $93e14de039976d06$export$2e2bcd8739ae039 = $93e14de039976d06$var$SwapOutlined;



function $3e3d6f5f482f85c2$var$_extends() {
    $3e3d6f5f482f85c2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3e3d6f5f482f85c2$var$_extends.apply(this, arguments);
}
const $3e3d6f5f482f85c2$var$SwapOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $3e3d6f5f482f85c2$var$_extends({}, props, {
        ref: ref,
        icon: (0, $93e14de039976d06$export$2e2bcd8739ae039)
    }));
/**![swap](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0Ny45IDU5MkgxNTJjLTQuNCAwLTggMy42LTggOHY2MGMwIDQuNCAzLjYgOCA4IDhoNjA1LjJMNjEyLjkgODUxYy00LjEgNS4yLS40IDEzIDYuMyAxM2g3Mi41YzQuOSAwIDkuNS0yLjIgMTIuNi02LjFsMTY4LjgtMjE0LjFjMTYuNS0yMSAxLjYtNTEuOC0yNS4yLTUxLjh6TTg3MiAzNTZIMjY2LjhsMTQ0LjMtMTgzYzQuMS01LjIuNC0xMy02LjMtMTNoLTcyLjVjLTQuOSAwLTkuNSAyLjItMTIuNiA2LjFMMTUwLjkgMzgwLjJjLTE2LjUgMjEtMS42IDUxLjggMjUuMSA1MS44aDY5NmM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $3e3d6f5f482f85c2$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($3e3d6f5f482f85c2$var$SwapOutlined);
var $3e3d6f5f482f85c2$export$2e2bcd8739ae039 = $3e3d6f5f482f85c2$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $4069e0aec18c22ff$var$ZoomInOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    },
    "name": "zoom-in",
    "theme": "outlined"
};
var $4069e0aec18c22ff$export$2e2bcd8739ae039 = $4069e0aec18c22ff$var$ZoomInOutlined;



function $a9de745fc9ab7695$var$_extends() {
    $a9de745fc9ab7695$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9de745fc9ab7695$var$_extends.apply(this, arguments);
}
const $a9de745fc9ab7695$var$ZoomInOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $a9de745fc9ab7695$var$_extends({}, props, {
        ref: ref,
        icon: (0, $4069e0aec18c22ff$export$2e2bcd8739ae039)
    }));
/**![zoom-in](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzNyA0NDNINTE5VjMwOWMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTM0SDMyNWMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGgxMTh2MTM0YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWNTE5aDExOGM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHptMjg0IDQyNEw3NzUgNzIxYzEyMi4xLTE0OC45IDExMy42LTM2OS41LTI2LTUwOS0xNDgtMTQ4LjEtMzg4LjQtMTQ4LjEtNTM3IDAtMTQ4LjEgMTQ4LjYtMTQ4LjEgMzg5IDAgNTM3IDEzOS41IDEzOS42IDM2MC4xIDE0OC4xIDUwOSAyNmwxNDYgMTQ2YzMuMiAyLjggOC4zIDIuOCAxMSAwbDQzLTQzYzIuOC0yLjcgMi44LTcuOCAwLTExek02OTYgNjk2Yy0xMTguOCAxMTguNy0zMTEuMiAxMTguNy00MzAgMC0xMTguNy0xMTguOC0xMTguNy0zMTEuMiAwLTQzMCAxMTguOC0xMTguNyAzMTEuMi0xMTguNyA0MzAgMCAxMTguNyAxMTguOCAxMTguNyAzMTEuMiAwIDQzMHoiIC8+PC9zdmc+) */ const $a9de745fc9ab7695$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($a9de745fc9ab7695$var$ZoomInOutlined);
var $a9de745fc9ab7695$export$2e2bcd8739ae039 = $a9de745fc9ab7695$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $d10eef3b9395033d$var$ZoomOutOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    },
    "name": "zoom-out",
    "theme": "outlined"
};
var $d10eef3b9395033d$export$2e2bcd8739ae039 = $d10eef3b9395033d$var$ZoomOutOutlined;



function $0ddbfb08939621a2$var$_extends() {
    $0ddbfb08939621a2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0ddbfb08939621a2$var$_extends.apply(this, arguments);
}
const $0ddbfb08939621a2$var$ZoomOutOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $0ddbfb08939621a2$var$_extends({}, props, {
        ref: ref,
        icon: (0, $d10eef3b9395033d$export$2e2bcd8739ae039)
    }));
/**![zoom-out](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzNyA0NDNIMzI1Yy00LjQgMC04IDMuNi04IDh2NjBjMCA0LjQgMy42IDggOCA4aDMxMmM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHptMjg0IDQyNEw3NzUgNzIxYzEyMi4xLTE0OC45IDExMy42LTM2OS41LTI2LTUwOS0xNDgtMTQ4LjEtMzg4LjQtMTQ4LjEtNTM3IDAtMTQ4LjEgMTQ4LjYtMTQ4LjEgMzg5IDAgNTM3IDEzOS41IDEzOS42IDM2MC4xIDE0OC4xIDUwOSAyNmwxNDYgMTQ2YzMuMiAyLjggOC4zIDIuOCAxMSAwbDQzLTQzYzIuOC0yLjcgMi44LTcuOCAwLTExek02OTYgNjk2Yy0xMTguOCAxMTguNy0zMTEuMiAxMTguNy00MzAgMC0xMTguNy0xMTguOC0xMTguNy0zMTEuMiAwLTQzMCAxMTguOC0xMTguNyAzMTEuMi0xMTguNyA0MzAgMCAxMTguNyAxMTguOCAxMTguNyAzMTEuMiAwIDQzMHoiIC8+PC9zdmc+) */ const $0ddbfb08939621a2$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($0ddbfb08939621a2$var$ZoomOutOutlined);
var $0ddbfb08939621a2$export$2e2bcd8739ae039 = $0ddbfb08939621a2$var$RefIcon;













const $d55eda1863d5d731$export$cee50e75a801b845 = (position)=>({
        position: position || 'absolute',
        inset: 0
    });
const $d55eda1863d5d731$export$6a2be70d6f540150 = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, colorTextLightSolid: colorTextLightSolid } = token;
    return {
        [componentCls]: {
            [`${componentCls}-cover`]: {
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: colorTextLightSolid,
                background: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)('#000').setA(0.3).toRgbString(),
                cursor: 'pointer',
                opacity: 0,
                transition: `opacity ${motionDurationSlow}`
            },
            '&:hover': {
                [`${componentCls}-cover`]: {
                    opacity: 1
                }
            },
            [`${componentCls}-cover-top`]: {
                inset: '0 0 auto 0',
                justifyContent: 'center'
            },
            [`${componentCls}-cover-bottom`]: {
                inset: 'auto 0 0 0',
                justifyContent: 'center'
            }
        }
    };
};
const $d55eda1863d5d731$export$f8264fb430b07c9a = (token)=>{
    const { motionEaseOut: motionEaseOut, previewCls: previewCls, motionDurationSlow: motionDurationSlow, componentCls: componentCls, modalMaskBg: modalMaskBg, marginXL: marginXL, marginSM: marginSM, margin: margin, colorTextLightSolid: colorTextLightSolid, paddingSM: paddingSM, paddingLG: paddingLG, previewOperationHoverColor: previewOperationHoverColor, previewOperationColorDisabled: previewOperationColorDisabled, previewOperationSize: previewOperationSize, zIndexPopup: zIndexPopup } = token;
    const operationBg = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(modalMaskBg).setA(0.1);
    const operationBgHover = operationBg.clone().setA(0.2);
    const singleBtn = {
        position: 'absolute',
        color: colorTextLightSolid,
        backgroundColor: operationBg.toRgbString(),
        borderRadius: '50%',
        padding: paddingSM,
        outline: 0,
        border: 0,
        cursor: 'pointer',
        transition: `all ${motionDurationSlow}`,
        display: 'flex',
        fontSize: previewOperationSize,
        '&:hover': {
            backgroundColor: operationBgHover.toRgbString()
        },
        '&:active': {
            backgroundColor: operationBg.toRgbString()
        }
    };
    return {
        [`${componentCls}-preview`]: {
            textAlign: 'center',
            inset: 0,
            position: 'fixed',
            userSelect: 'none',
            zIndex: zIndexPopup,
            // ================= Mask =================
            [`${previewCls}-mask`]: {
                inset: 0,
                position: 'absolute',
                background: modalMaskBg,
                [`&${componentCls}-preview-mask-blur`]: {
                    ...(0, $945cb0d2b7017a11$export$eb00f0b59fe10024)
                },
                [`&${componentCls}-preview-mask-hidden`]: {
                    display: 'none'
                }
            },
            // ================= Body =================
            [`${previewCls}-body`]: {
                ...$d55eda1863d5d731$export$cee50e75a801b845(),
                'pointer-events': 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '> *': {
                    pointerEvents: 'auto'
                }
            },
            // Body > Image
            [`${previewCls}-img`]: {
                maxWidth: '100%',
                maxHeight: '70%',
                verticalAlign: 'middle',
                transform: 'scale3d(1, 1, 1)',
                cursor: 'grab',
                transition: `transform ${motionDurationSlow} ${motionEaseOut} 0s`
            },
            [`&-moving ${previewCls}-img`]: {
                cursor: 'grabbing'
            },
            // =============== CloseBtn ===============
            [`${previewCls}-close`]: {
                // Shared style
                ...singleBtn,
                top: marginSM,
                insetInlineEnd: marginSM
            },
            // ================ Switch ================
            [`${previewCls}-switch`]: {
                ...singleBtn,
                top: '50%',
                transform: `translateY(-50%)`,
                '&-disabled': {
                    '&, &:hover, &:active': {
                        color: previewOperationColorDisabled,
                        background: 'transparent',
                        cursor: 'not-allowed'
                    }
                },
                '&-prev': {
                    insetInlineStart: marginSM
                },
                '&-next': {
                    insetInlineEnd: marginSM
                }
            },
            // ================ Footer ================
            [`${previewCls}-footer`]: {
                position: 'absolute',
                bottom: marginXL,
                left: {
                    _skip_check_: true,
                    value: '50%'
                },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                color: token.previewOperationColor,
                transform: 'translateX(-50%)',
                gap: margin
            },
            // =============== Actions ================
            [`${previewCls}-actions`]: {
                display: 'flex',
                gap: paddingSM,
                padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingLG)}`,
                backgroundColor: operationBg.toRgbString(),
                borderRadius: 100,
                fontSize: previewOperationSize,
                '&-action': {
                    padding: paddingSM,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}`,
                    display: 'flex',
                    [`&:not(${previewCls}-actions-action-disabled):hover`]: {
                        color: previewOperationHoverColor
                    },
                    '&-disabled': {
                        color: previewOperationColorDisabled,
                        cursor: 'not-allowed'
                    }
                }
            }
        }
    };
};
const $d55eda1863d5d731$var$genImageStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ============================== image ==============================
        [componentCls]: {
            position: 'relative',
            display: 'inline-block',
            [`${componentCls}-img`]: {
                width: '100%',
                height: 'auto',
                verticalAlign: 'middle'
            },
            [`${componentCls}-img-placeholder`]: {
                backgroundColor: token.colorBgContainerDisabled,
                backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAyLjVoLTEzQS41LjUgMCAwIDAgMSAzdjEwYS41LjUgMCAwIDAgLjUuNWgxM2EuNS41IDAgMCAwIC41LS41VjNhLjUuNSAwIDAgMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTguMDMgNi44M2EuMTI3LjEyNyAwIDAgMS0uMDgxLjAzSDIuNzY5YS4xMjUuMTI1IDAgMCAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAgMSAuMTc3LS4wMTZsLjAxNi4wMTZMNy4wOCAxMC4wOWwyLjQ3LTIuOTNhLjEyNi4xMjYgMCAwIDEgLjE3Ny0uMDE2bC4wMTUuMDE2IDMuNTg4IDQuMjQ0YS4xMjcuMTI3IDAgMCAxLS4wMi4xNzV6IiBmaWxsPSIjOEM4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=')",
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: '30%'
            },
            [`${componentCls}-placeholder`]: {
                ...$d55eda1863d5d731$export$cee50e75a801b845()
            }
        }
    };
};
const $d55eda1863d5d731$var$genPreviewMotion = (token)=>{
    const { previewCls: previewCls, motionDurationSlow: motionDurationSlow } = token;
    return {
        [`${previewCls}`]: {
            '&-fade': {
                transition: `opacity ${motionDurationSlow}`,
                '&-enter, &-appear': {
                    opacity: 0,
                    [`${previewCls}-body`]: {
                        transform: 'scale(0)'
                    },
                    '&-active': {
                        opacity: 1,
                        [`${previewCls}-body`]: {
                            transform: 'scale(1)',
                            transition: `transform ${motionDurationSlow}`
                        }
                    }
                },
                '&-leave': {
                    opacity: 1,
                    '&-active': {
                        opacity: 0,
                        [`${previewCls}-body`]: {
                            transform: 'scale(0)',
                            transition: `transform ${motionDurationSlow}`
                        }
                    }
                }
            }
        }
    };
};
const $d55eda1863d5d731$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 80,
        previewOperationColor: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(token.colorTextLightSolid).setA(0.65).toRgbString(),
        previewOperationHoverColor: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(token.colorTextLightSolid).setA(0.85).toRgbString(),
        previewOperationColorDisabled: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(token.colorTextLightSolid).setA(0.25).toRgbString(),
        previewOperationSize: token.fontSizeIcon * 1.5 // FIXME: fontSizeIconLG
    });
var $d55eda1863d5d731$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Image', (token)=>{
    const previewCls = `${token.componentCls}-preview`;
    const imageToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        previewCls: previewCls,
        modalMaskBg: new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)('#000').setA(0.45).toRgbString(),
        // FIXME: Shared Token
        imagePreviewSwitchSize: token.controlHeightLG
    });
    return [
        $d55eda1863d5d731$var$genImageStyle(imageToken),
        $d55eda1863d5d731$export$6a2be70d6f540150(imageToken),
        $d55eda1863d5d731$export$f8264fb430b07c9a(imageToken),
        $d55eda1863d5d731$var$genPreviewMotion(imageToken)
    ];
}, $d55eda1863d5d731$export$9ca1be8807fe0675);


"use client";
const $5fecdf37bf5911e7$export$df03f54e09e486fa = {
    rotateLeft: /*#__PURE__*/ $ltGt3.createElement((0, $5cd908edfa84a66d$export$2e2bcd8739ae039), null),
    rotateRight: /*#__PURE__*/ $ltGt3.createElement((0, $83faa8637951a6fe$export$2e2bcd8739ae039), null),
    zoomIn: /*#__PURE__*/ $ltGt3.createElement((0, $a9de745fc9ab7695$export$2e2bcd8739ae039), null),
    zoomOut: /*#__PURE__*/ $ltGt3.createElement((0, $0ddbfb08939621a2$export$2e2bcd8739ae039), null),
    close: /*#__PURE__*/ $ltGt3.createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), null),
    left: /*#__PURE__*/ $ltGt3.createElement((0, $4fcbd32442f5797e$export$2e2bcd8739ae039), null),
    right: /*#__PURE__*/ $ltGt3.createElement((0, $a9490449fe252e7b$export$2e2bcd8739ae039), null),
    flipX: /*#__PURE__*/ $ltGt3.createElement((0, $3e3d6f5f482f85c2$export$2e2bcd8739ae039), null),
    flipY: /*#__PURE__*/ $ltGt3.createElement((0, $3e3d6f5f482f85c2$export$2e2bcd8739ae039), {
        rotate: 90
    })
};
const $5fecdf37bf5911e7$var$InternalPreviewGroup = ({ previewPrefixCls: customizePrefixCls, preview: preview, classNames: classNames, styles: styles, ...otherProps })=>{
    // =============================== MISC ===============================
    // Context
    const { getPrefixCls: getPrefixCls, getPopupContainer: getContextPopupContainer, direction: direction, preview: contextPreview, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('image');
    const prefixCls = getPrefixCls('image', customizePrefixCls);
    const previewPrefixCls = `${prefixCls}-preview`;
    // ============================== Style ===============================
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $d55eda1863d5d731$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mergedRootClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls);
    // ============================= Preview ==============================
    const [previewConfig, previewRootClassName, previewMaskClassName] = (0, $4ac8e37e26036568$export$2e2bcd8739ae039)(preview);
    const [contextPreviewConfig, contextPreviewRootClassName, contextPreviewMaskClassName] = (0, $4ac8e37e26036568$export$2e2bcd8739ae039)(contextPreview);
    // ============================ Semantics =============================
    const memoizedIcons = $ltGt3.useMemo(()=>({
            ...$5fecdf37bf5911e7$export$df03f54e09e486fa,
            left: direction === 'rtl' ? /*#__PURE__*/ $ltGt3.createElement((0, $a9490449fe252e7b$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $4fcbd32442f5797e$export$2e2bcd8739ae039), null),
            right: direction === 'rtl' ? /*#__PURE__*/ $ltGt3.createElement((0, $4fcbd32442f5797e$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $ltGt3.createElement((0, $a9490449fe252e7b$export$2e2bcd8739ae039), null)
        }), [
        direction
    ]);
    const mergedPreview = (0, $92c8c85df965f10d$export$2e2bcd8739ae039)(// Preview config
    previewConfig, contextPreviewConfig, // MISC
    prefixCls, mergedRootClassName, getContextPopupContainer, $5fecdf37bf5911e7$export$df03f54e09e486fa);
    const { mask: mergedMask, blurClassName: blurClassName } = mergedPreview ?? {};
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...otherProps,
        classNames: classNames,
        styles: styles
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames,
        {
            cover: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(contextPreviewMaskClassName, previewMaskClassName),
            popup: {
                root: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(contextPreviewRootClassName, previewRootClassName),
                mask: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                    [`${prefixCls}-preview-mask-hidden`]: !mergedMask
                }, blurClassName)
            }
        }
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        }
    });
    return /*#__PURE__*/ $ltGt3.createElement((0, $9b5c159988343bb7$export$2e2bcd8739ae039).PreviewGroup, {
        preview: mergedPreview,
        previewPrefixCls: previewPrefixCls,
        icons: memoizedIcons,
        ...otherProps,
        classNames: mergedClassNames,
        styles: mergedStyles
    });
};
var $5fecdf37bf5911e7$export$2e2bcd8739ae039 = $5fecdf37bf5911e7$var$InternalPreviewGroup;



"use client";
const $54759b2dc7aee7a8$var$Image = (props)=>{
    const { prefixCls: customizePrefixCls, preview: preview, className: className, rootClassName: rootClassName, style: style, styles: styles, classNames: classNames, wrapperStyle: wrapperStyle, fallback: fallback, ...otherProps } = props;
    // =============================== MISC ===============================
    // Context
    const { getPrefixCls: getPrefixCls, getPopupContainer: getContextPopupContainer, className: contextClassName, style: contextStyle, preview: contextPreview, styles: contextStyles, classNames: contextClassNames, fallback: contextFallback } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('image');
    const prefixCls = getPrefixCls('image', customizePrefixCls);
    // ============================== Styles ==============================
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $d55eda1863d5d731$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mergedRootClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(rootClassName, hashId, cssVarCls, rootCls);
    const mergedClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, hashId, contextClassName);
    // ============================= Preview ==============================
    const [previewConfig, previewRootClassName, previewMaskClassName] = (0, $4ac8e37e26036568$export$2e2bcd8739ae039)(preview);
    const [contextPreviewConfig, contextPreviewRootClassName, contextPreviewMaskClassName] = (0, $4ac8e37e26036568$export$2e2bcd8739ae039)(contextPreview);
    const mergedPreviewConfig = (0, $92c8c85df965f10d$export$2e2bcd8739ae039)(// Preview config
    previewConfig, contextPreviewConfig, // MISC
    prefixCls, mergedRootClassName, getContextPopupContainer, (0, $5fecdf37bf5911e7$export$df03f54e09e486fa), true);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        preview: mergedPreviewConfig
    };
    // ============================= Semantic =============================
    const mergedLegacyClassNames = $ltGt3.useMemo(()=>({
            cover: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(contextPreviewMaskClassName, previewMaskClassName),
            popup: {
                root: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(contextPreviewRootClassName, previewRootClassName)
            }
        }), [
        previewRootClassName,
        previewMaskClassName,
        contextPreviewRootClassName,
        contextPreviewMaskClassName
    ]);
    const { mask: mergedMask, blurClassName: blurClassName } = mergedPreviewConfig ?? {};
    const mergedPopupClassNames = $ltGt3.useMemo(()=>({
            mask: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                [`${prefixCls}-preview-mask-hidden`]: !mergedMask
            }, blurClassName)
        }), [
        mergedMask,
        prefixCls,
        blurClassName
    ]);
    const internalClassNames = $ltGt3.useMemo(()=>[
            contextClassNames,
            classNames,
            mergedLegacyClassNames,
            {
                popup: mergedPopupClassNames
            }
        ], [
        contextClassNames,
        classNames,
        mergedLegacyClassNames,
        mergedPopupClassNames
    ]);
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)(internalClassNames, [
        contextStyles,
        {
            root: wrapperStyle
        },
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        }
    });
    const mergedStyle = {
        ...contextStyle,
        ...style
    };
    const mergedFallback = fallback ?? contextFallback;
    // ============================== Render ==============================
    return /*#__PURE__*/ $ltGt3.createElement((0, $9b5c159988343bb7$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        preview: mergedPreviewConfig || false,
        rootClassName: mergedRootClassName,
        className: mergedClassName,
        style: mergedStyle,
        fallback: mergedFallback,
        ...otherProps,
        classNames: mergedClassNames,
        styles: mergedStyles
    });
};
$54759b2dc7aee7a8$var$Image.PreviewGroup = (0, $5fecdf37bf5911e7$export$2e2bcd8739ae039);
var $54759b2dc7aee7a8$export$2e2bcd8739ae039 = $54759b2dc7aee7a8$var$Image;



var $ltGt3 = parcelRequire("ltGt3");




parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");

const { CheckableTag: $ce20e1094e2afb09$var$CheckableTag } = (0, $275a14ee9b85c941$export$2e2bcd8739ae039);
function $ce20e1094e2afb09$export$6083e5dee0802eaa(props) {
    const [previewOpen, setPreviewOpen] = (0, $ltGt3.useState)(false);
    const [previewImage, setPreviewImage] = (0, $ltGt3.useState)('');
    const [previewTitle, setPreviewTitle] = (0, $ltGt3.useState)('');
    const filters = Object.fromEntries(props.fileList?.map((file)=>[
            file.photoType,
            false
        ]) || []);
    const [viewedTypesOfEvents, setViewedTypesOfEvents] = (0, $ltGt3.useState)(filters);
    const noFiltersSelected = Object.values(viewedTypesOfEvents).every((type)=>type === false);
    const handleCancel = ()=>setPreviewOpen(false);
    const handlePreview = async (file)=>{
        if (!file.url && !file.preview) return;
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
    };
    const uploadButton = /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $da40d833ab151490$export$2e2bcd8739ae039), {
                rev: undefined
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    marginTop: 8
                },
                children: "Upload"
            })
        ]
    });
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            props.tagFilters ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                children: [
                    Object.entries(filters).map(([key])=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($ce20e1094e2afb09$var$CheckableTag, {
                            checked: viewedTypesOfEvents[key],
                            onChange: (checked)=>setViewedTypesOfEvents((current)=>({
                                        ...current,
                                        [key]: checked
                                    })),
                            children: key
                        }, key)),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        onClick: async ()=>{
                            setViewedTypesOfEvents(filters);
                        },
                        type: "primary",
                        children: "Reset filters"
                    })
                ]
            }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9d004cf64875b9d1$exports.Fragment), {}),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $17454bf909e69d0f$export$2e2bcd8739ae039), {
                beforeUpload: ()=>false,
                fileList: props.fileList?.filter((event)=>viewedTypesOfEvents[event.photoType] || noFiltersSelected),
                onChange: props.onChange,
                listType: "picture-card",
                onPreview: handlePreview,
                disabled: props.disabled,
                className: !props.addable && 'upload-not-addable',
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    children: uploadButton
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f189c84ec54ae7cf$export$2e2bcd8739ae039), {
                open: previewOpen,
                title: null,
                footer: null,
                onCancel: handleCancel,
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                    alt: "example",
                    style: {
                        width: '100%'
                    },
                    src: previewImage
                })
            })
        ]
    });
}



class $2c180d070eb7e4fa$export$eb23245daa48d96f {
    async deleteAllPlantEventsForPlant(currentPlantId) {
        const userId = (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id;
        const photosList = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('photos').list(userId, {
            limit: 100,
            offset: 0,
            sortBy: {
                column: 'name',
                order: 'asc'
            }
        });
        let removingPhotosList = [];
        if (!photosList.error) removingPhotosList = photosList.data.map((photo)=>photo.name.startsWith(`${currentPlantId}-`) ? `${userId}/${photo.name}` : null);
        const storagePhotoRemovingResult = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('photos').remove(removingPhotosList);
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).from('journalEvents').delete().eq('plantId', currentPlantId);
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    async addPlantEventPhotos(plantPhoto, userId, plantId) {
        const errors = [];
        const photosNames = [];
        if (plantPhoto.length != 0) for (let photo of plantPhoto){
            const name = plantId.toString() + '-' + Date.now().toString();
            photosNames.push(name);
            const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('photos').upload(userId + '/' + name, photo.originFileObj, {
                cacheControl: '3600',
                upsert: false
            });
            if (error) errors.push(error);
        }
        if (errors.length !== 0) return {
            success: false,
            errors: errors
        };
        else return {
            success: true,
            photos: photosNames
        };
    }
    async deletePlantEventPhotos(plantPhoto, userId, plantId) {
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('photos').remove(plantPhoto.map((photo, index)=>userId + '/' + photo));
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true
        };
    }
    async getPlantEventImageURLs(plantEventPhotoNames = []) {
        if (plantEventPhotoNames?.length === 0) return {
            success: true,
            urls: []
        };
        const userId = (await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).auth.getSession()).data.session.user.id;
        const { data: data, error: error } = await (0, $22d3d943b761a5c9$export$a0b632a28672d3c0).storage.from('photos').createSignedUrls(plantEventPhotoNames?.map((photoName)=>`${userId}/${photoName}`), 60);
        if (error) return {
            success: false,
            error: error
        };
        else return {
            success: true,
            urls: data.map((element)=>element.signedUrl)
        };
    }
}
const $2c180d070eb7e4fa$export$9544d5bb712b01ea = new $2c180d070eb7e4fa$export$eb23245daa48d96f();


function $0ed5b0c7f51b3f3a$export$4a96334d5925dbf2(props) {
    const { value: signedPhotoURLs, isLoading: signedPhotoURLsLoading, reload: reloadSignedPhotoURLs } = (0, $1e104381209dd9b4$export$78a72ddb39bdd145)(null, ()=>(0, $2c180d070eb7e4fa$export$9544d5bb712b01ea).getPlantEventImageURLs(props.photosIds), [
        props.photosIds
    ]);
    if (signedPhotoURLs === null) return null;
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ce20e1094e2afb09$export$6083e5dee0802eaa), {
            fileList: props.photosIds.map((photoName, index)=>({
                    uid: index,
                    photoName: photoName,
                    name: index,
                    status: 'done',
                    url: signedPhotoURLs.urls[index]
                })),
            addable: false
        })
    });
}




var $ltGt3 = parcelRequire("ltGt3");






function $7d9a693fc5c62427$var$useLowerCaseSetMemo(oldArray = []) {
    const newSet = (0, $ltGt3.useMemo)(()=>new Set(oldArray.map((x)=>x.toLowerCase())), [
        oldArray
    ]);
    return newSet;
}
function $7d9a693fc5c62427$export$91535c314826c067(props) {
    const fruitingTimeSet = $7d9a693fc5c62427$var$useLowerCaseSetMemo(props.fruitingTime);
    const bloomingTimeSet = $7d9a693fc5c62427$var$useLowerCaseSetMemo(props.bloomingTime);
    const pruningTimeSet = $7d9a693fc5c62427$var$useLowerCaseSetMemo(props.pruningTime);
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const plantingCloseTimeSet = $7d9a693fc5c62427$var$useLowerCaseSetMemo(props.plantingCloseTime);
    const plantingOpenTimeSet = $7d9a693fc5c62427$var$useLowerCaseSetMemo(props.plantingOpenTime);
    const monthsSplit = props.mode === 'oneLine' ? [
        (0, $e0eda949f811dcf3$export$63a75ecf7f0afbfa)
    ] : [
        (0, $e0eda949f811dcf3$export$63a75ecf7f0afbfa).slice(0, 6),
        (0, $e0eda949f811dcf3$export$63a75ecf7f0afbfa).slice(6, (0, $e0eda949f811dcf3$export$63a75ecf7f0afbfa).length)
    ];
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                children: monthsSplit.map((months, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("table", {
                        className: "plant-calendar",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("tr", {
                                    children: months.map((n, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("th", {
                                            children: n
                                        }, index))
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("tbody", {
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("tr", {
                                    children: months.map((n, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("td", {
                                            children: [
                                                plantingCloseTimeSet.has(n) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                                        icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                                            icon: $1113a0aa61ab7765$export$dcadc0d67468dfa8
                                                        }),
                                                        color: "gray"
                                                    })
                                                }),
                                                plantingOpenTimeSet.has(n) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                                        icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                                            icon: $1113a0aa61ab7765$export$d7b60b8dbd03cfe4
                                                        }),
                                                        color: "green"
                                                    })
                                                }),
                                                bloomingTimeSet.has(n) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                                        icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                                            icon: $1113a0aa61ab7765$export$55145a3dae4f984a
                                                        }),
                                                        color: "orange"
                                                    })
                                                }),
                                                fruitingTimeSet.has(n) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                                        icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                                            icon: $1113a0aa61ab7765$export$12de8220d30453a3
                                                        }),
                                                        color: "red"
                                                    })
                                                }),
                                                pruningTimeSet.has(n) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                                        icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                                            icon: $1113a0aa61ab7765$export$b2a906a5928c6404
                                                        }),
                                                        color: "black"
                                                    })
                                                })
                                            ]
                                        }, index))
                                })
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "legend",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                    icon: $1113a0aa61ab7765$export$dcadc0d67468dfa8
                                }),
                                color: "gray"
                            }),
                            "-",
                            ' ',
                            intl.formatMessage({
                                id: 'plantingSeedlingsInClosedGround'
                            }),
                            ",",
                            ' '
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                    icon: $1113a0aa61ab7765$export$d7b60b8dbd03cfe4
                                }),
                                color: "green"
                            }),
                            "-",
                            ' ',
                            intl.formatMessage({
                                id: 'plantingSeedlingsInOpenedGround'
                            }),
                            ",",
                            ' '
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                    icon: $1113a0aa61ab7765$export$55145a3dae4f984a
                                }),
                                color: "orange"
                            }),
                            "-",
                            ' ',
                            intl.formatMessage({
                                id: 'eventType-blooming'
                            }),
                            ",",
                            ' '
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                    icon: $1113a0aa61ab7765$export$12de8220d30453a3
                                }),
                                color: "red"
                            }),
                            "-",
                            ' ',
                            intl.formatMessage({
                                id: 'eventType-harvesting'
                            }),
                            ",",
                            ' '
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                    icon: $1113a0aa61ab7765$export$b2a906a5928c6404
                                }),
                                color: "black"
                            }),
                            "-",
                            ' ',
                            intl.formatMessage({
                                id: 'eventType-pruning'
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");


var $296b06edb994d154$var$DownOutlined = function DownOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $58e38707396c6245$export$2e2bcd8739ae039)
    }));
};
/**![down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NCAyNTZoLTc1Yy01LjEgMC05LjkgMi41LTEyLjkgNi42TDUxMiA2NTQuMiAyMjcuOSAyNjIuNmMtMy00LjEtNy44LTYuNi0xMi45LTYuNmgtNzVjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDM1Mi42IDQ4Ni4xYzEyLjggMTcuNiAzOSAxNy42IDUxLjcgMGwzNTIuNi00ODYuMWMzLjktNS4zLjEtMTIuNy02LjQtMTIuN3oiIC8+PC9zdmc+) */ var $296b06edb994d154$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($296b06edb994d154$var$DownOutlined);
var $296b06edb994d154$export$2e2bcd8739ae039 = $296b06edb994d154$var$RefIcon;




function $4827afca4eacbfe8$export$2ddb90ad54e5f587(props) {
    const [modeCollapsed, setModeCollapsed] = (0, $ltGt3.useState)(false);
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "panel",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "panel__title",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("a", {
                    onClick: ()=>setModeCollapsed((current)=>!current),
                    className: "panel__title__collapser",
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            children: intl.formatMessage({
                                id: props.title
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            className: "panel__title__collapser__icon",
                            children: modeCollapsed ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $532bc1903b13fec2$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $296b06edb994d154$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            }),
            !modeCollapsed && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "panel__body",
                children: [
                    props.backgroundIcon && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "panel__body__background",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                            className: "panel__body__background__icon",
                            icon: props.backgroundIcon
                        })
                    }),
                    props.children
                ]
            })
        ]
    });
}








var $ltGt3 = parcelRequire("ltGt3");





const { CheckableTag: $4e173db25285d173$var$CheckableTag } = (0, $275a14ee9b85c941$export$2e2bcd8739ae039);
function $4e173db25285d173$var$preparePhotos(plantName, fieldName, urls, tag) {
    if (!Array.isArray(urls)) return [];
    return urls.map((url, index)=>({
            uid: index + tag,
            name: `${plantName}-${tag}-${index}`,
            status: 'done',
            url: url,
            photoType: fieldName
        }));
}
// const filters = Object.fromEntries(
//   Object.entries(DatabasePlantRecordMetadata)
//     .filter(([key, meta]) => meta.type === 'photo')
//     .map(([key, meta]) => [key, false])
// )
// filters.user = false
const $4e173db25285d173$var$groups = [
    {
        fieldName: "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F",
        propName: 'basePlantPhotos',
        tag: 'b'
    },
    {
        fieldName: "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0446\u0432\u0435\u0442\u043E\u0432",
        propName: 'basePlantFlowerPhotos',
        tag: 'f'
    },
    {
        fieldName: "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043B\u0438\u0441\u0442\u044C\u0435\u0432",
        propName: 'basePlantLeavesPhotos',
        tag: 'l'
    },
    {
        fieldName: "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043F\u043B\u043E\u0434\u043E\u0432",
        propName: 'basePlantFruitsPhotos',
        tag: 'fr'
    }
];
function $4e173db25285d173$export$2c6ba43c30045a9b(props) {
    const [previewOpen, setPreviewOpen] = (0, $ltGt3.useState)(false);
    const [previewImage, setPreviewImage] = (0, $ltGt3.useState)('');
    const [previewTitle, setPreviewTitle] = (0, $ltGt3.useState)('');
    const handleCancel = ()=>setPreviewOpen(false);
    const handlePreview = async (file)=>{
        if (!file.url && !file.preview) return;
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
    };
    const { value: imageList = [], error: error } = (0, $1e104381209dd9b4$export$78a72ddb39bdd145)([], async ()=>{
        let allPhotos = [];
        for (const { propName: propName } of $4e173db25285d173$var$groups)if (props[propName]?.length > 0) allPhotos = [
            ...allPhotos,
            ...props[propName]
        ];
        const photos = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getPlantDatabaseImageURLs(props.plantBaseId, allPhotos);
        if (!photos.success) return [];
        let index = 0;
        let imageList = [];
        for (const { fieldName: fieldName, propName: propName, tag: tag } of $4e173db25285d173$var$groups)if (props[propName]?.length > 0) {
            imageList = [
                ...imageList,
                ...$4e173db25285d173$var$preparePhotos(props.plantName, fieldName, photos.urls.slice(index, index + props[propName].length), tag)
            ];
            index += props[propName].length;
        }
        return imageList;
    }, [
        props.plantBaseId
    ]);
    //////////////////////////////////////
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const filters = Object.fromEntries(imageList?.map((image)=>[
            image.photoType,
            true
        ]) || []);
    const [viewedTypesOfPhotos, setviewedTypesOfPhotos] = (0, $ltGt3.useState)(filters);
    const noFiltersSelected = Object.values(viewedTypesOfPhotos).every((type)=>type === false);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            filters ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "image-tag-view__filters",
                children: Object.entries(filters).map(([key])=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($4e173db25285d173$var$CheckableTag, {
                        checked: viewedTypesOfPhotos[key],
                        onChange: (checked)=>setviewedTypesOfPhotos((current)=>({
                                    ...current,
                                    [key]: checked
                                })),
                        children: key
                    }, key))
            }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9d004cf64875b9d1$exports.Fragment), {}),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $17454bf909e69d0f$export$2e2bcd8739ae039), {
                beforeUpload: ()=>false,
                showUploadList: {
                    showRemoveIcon: false
                },
                fileList: imageList?.filter((photo)=>viewedTypesOfPhotos[photo.photoType] || noFiltersSelected),
                listType: "picture-card",
                onPreview: handlePreview
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f189c84ec54ae7cf$export$2e2bcd8739ae039), {
                open: previewOpen,
                title: null,
                footer: null,
                onCancel: handleCancel,
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                    alt: "example",
                    style: {
                        width: '100%'
                    },
                    src: previewImage
                })
            })
        ]
    });
}






var $ltGt3 = parcelRequire("ltGt3");



function $1d3237aa16cac649$var$toSelectItem(collection) {
    return {
        label: collection.name,
        //value: collection.color,
        value: String(collection.id)
    };
}
const $1d3237aa16cac649$var$tagRender = (props)=>{
    const { label: label, value: value, closable: closable, onClose: onClose } = props;
    const onPreventMouseDown = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const colors = [
        'green',
        'blue',
        'orange',
        'cyan'
    ];
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
        color: colors[value % colors.length],
        //color={value || 'gray'}
        onMouseDown: onPreventMouseDown,
        closable: closable,
        onClose: onClose,
        title: label,
        style: {
            marginRight: 3,
            maxWidth: 140,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        children: label
    }, value);
};
function $1d3237aa16cac649$export$a8f2899d4332e8e7({ plantCollections: plantCollections = [], plantId: plantId, onPlantCollectionsListUpdated: onPlantCollectionsListUpdated = ()=>{}, userPlantCollections: userPlantCollections, className: className }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    //const [displayedTags, setDisplayedTags] = useState(plantCollections.map(toSelectItem))
    const displayedTags = plantCollections.map($1d3237aa16cac649$var$toSelectItem);
    //const [selectOptions, setSelectOptions] = useState([])
    const [loading, setLoading] = (0, $ltGt3.useState)(false);
    const inputRef = (0, $ltGt3.useRef)(null);
    const [name, setName] = (0, $ltGt3.useState)('');
    const onNameChange = (event)=>{
        setName(event.target.value);
    };
    // useEffect(() => {
    //   ;(async () => {
    //     setLoading(true)
    //     try {
    //       const collections = await plantsService.getUserPlantCollections()
    //       setSelectOptions(collections.map(toSelectItem))
    //     } finally {
    //       setLoading(false)
    //     }
    //   })()
    // }, [])
    let index = 0;
    async function createCollection(e) {
        e.preventDefault();
        setLoading(true);
        try {
            const result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).createPlantCollection(name || `New item ${index++}`);
            if (result.success) onPlantCollectionsListUpdated();
        } finally{
            setName('');
            setLoading(false);
        }
    }
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
        className: className ? `collection-names ${className}` : 'collection-names',
        size: "large",
        placeholder: intl.formatMessage({
            id: 'collections'
        }),
        value: displayedTags,
        onChange: async (tags)=>{
            if (loading) return;
            setLoading(true);
            const result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).changePlantCollections(plantId, //tags as number[],
            tags.map((collection)=>Number(collection)), displayedTags.map((collection)=>Number(collection.value)));
            if (result.success) // setDisplayedTags(
            //   tags.map((tag) => ({
            //     label: selectOptions.find((x) => x.value === tag).label,
            //     value: String(tag),
            //   }))
            // )
            onPlantCollectionsListUpdated();
            setLoading(false);
        },
        mode: "tags",
        options: userPlantCollections.map($1d3237aa16cac649$var$toSelectItem),
        tagRender: $1d3237aa16cac649$var$tagRender,
        classNames: {
            popup: {
                root: 'collections-dropdown'
            }
        },
        popupRender: (menu)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f5e177132d6f3f0f$export$2e2bcd8739ae039), {
                spinning: loading,
                delay: 300,
                children: [
                    menu,
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                        style: {
                            margin: '8px 0'
                        }
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d029ee757225a242$export$2e2bcd8739ae039), {
                        style: {
                            padding: '0 8px 4px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039), {
                                placeholder: intl.formatMessage({
                                    id: 'newCollection'
                                }),
                                ref: inputRef,
                                value: name,
                                onChange: onNameChange,
                                onKeyDown: (e)=>e.stopPropagation()
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                type: "text",
                                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $da40d833ab151490$export$2e2bcd8739ae039), {}),
                                onClick: createCollection,
                                children: intl.formatMessage({
                                    id: 'add'
                                })
                            })
                        ]
                    })
                ]
            }),
        optionRender: (option)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "collection-item",
                style: {
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                        style: {
                            flexGrow: 1,
                            flexShrink: 1,
                            maxWidth: '100%',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis'
                        },
                        children: option.data.label
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                        style: {
                            flexGrow: 0,
                            flexShrink: 0
                        },
                        onClick: (e)=>e.stopPropagation(),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
                            placement: "bottom",
                            title: intl.formatMessage({
                                id: 'areYouSureYouWantToDeleteThisCollection'
                            }),
                            description: intl.formatMessage({
                                id: 'informationAboutWhichPlantsBelongedToThisCollectionWillAlsoBeRemoved'
                            }),
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7fa69e90b193286$export$2e2bcd8739ae039), {
                                style: {
                                    color: 'red'
                                }
                            }),
                            onConfirm: async ()=>{
                                setLoading(true);
                                const result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).deletePlantCollection(option.value);
                                if (result.success) //setSelectOptions(selectOptions.filter((x) => x.value !== option.value))
                                //setDisplayedTags(displayedTags.filter((x) => x.value !== option.value))
                                onPlantCollectionsListUpdated();
                                setLoading(false);
                            },
                            okText: intl.formatMessage({
                                id: 'yes'
                            }),
                            cancelText: intl.formatMessage({
                                id: 'no'
                            }),
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1e0519456d104339$export$2e2bcd8739ae039), {
                                className: "delete-collection",
                                color: "red"
                            })
                        })
                    })
                ]
            })
    });
}





// Register `Raw` in tree:
/// <reference types="mdast-util-to-hast" />
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Nodes} Nodes
 * @typedef {import('hast').Parents} Parents
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-to-jsx-runtime').Components} JsxRuntimeComponents
 * @typedef {import('remark-rehype').Options} RemarkRehypeOptions
 * @typedef {import('unist-util-visit').BuildVisitor<Root>} Visitor
 * @typedef {import('unified').PluggableList} PluggableList
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 *
 * @typedef {Partial<JsxRuntimeComponents>} Components
 *   Map tag names to components.
 *
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 *
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {string | null | undefined} [className]
 *   Wrap in a `div` with this class name.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 *
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ function $4b359f2d21305e76$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $4b359f2d21305e76$export$411ce8e5a71e3069() {}
function $4b359f2d21305e76$export$dcb8b3f0e2de7e49() {}
function $4b359f2d21305e76$export$565e9d9bd6b6e0d4() {}


// Register MDX nodes in mdast:
/// <reference types="mdast-util-mdx-expression" />
/// <reference types="mdast-util-mdx-jsx" />
/// <reference types="mdast-util-mdxjs-esm" />
/**
 * @typedef {import('estree').Identifier} Identifier
 * @typedef {import('estree').Literal} Literal
 * @typedef {import('estree').MemberExpression} MemberExpression
 * @typedef {import('estree').Expression} Expression
 * @typedef {import('estree').Program} Program
 *
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Nodes} Nodes
 * @typedef {import('hast').Parents} Parents
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 *
 * @typedef {import('mdast-util-mdx-expression').MdxFlowExpressionHast} MdxFlowExpression
 * @typedef {import('mdast-util-mdx-expression').MdxTextExpressionHast} MdxTextExpression
 *
 * @typedef {import('mdast-util-mdx-jsx').MdxJsxFlowElementHast} MdxJsxFlowElement
 * @typedef {import('mdast-util-mdx-jsx').MdxJsxTextElementHast} MdxJsxTextElement
 *
 * @typedef {import('mdast-util-mdxjs-esm').MdxjsEsmHast} MdxjsEsm
 *
 * @typedef {import('property-information').Schema} Schema
 *
 * @typedef {import('unist').Position} Position
 *
 * @typedef {import('./components.js').Components} Components
 */ /**
 * @typedef {JSX.Element | string | null | undefined} Child
 *   Child.
 *
 * @callback Create
 *   Create something in development or production.
 * @param {Nodes} node
 *   hast node.
 * @param {unknown} type
 *   Fragment symbol or tag name.
 * @param {Props} props
 *   Properties and children.
 * @param {string | undefined} key
 *   Key.
 * @returns {JSX.Element}
 *   Result.
 *
 * @callback CreateEvaluater
 *   Create an evaluator that turns ESTree ASTs from embedded MDX into values.
 * @returns {Evaluater}
 *   Evaluater.
 *
 * @typedef {'html' | 'react'} ElementAttributeNameCase
 *   Casing to use for attribute names.
 *
 *   HTML casing is for example `class`, `stroke-linecap`, `xml:lang`.
 *   React casing is for example `className`, `strokeLinecap`, `xmlLang`.
 *
 * @callback EvaluateExpression
 *   Turn an MDX expression into a value.
 * @param {Expression} expression
 *   ESTree expression.
 * @returns {unknown}
 *   Result of expression.
 *
 * @callback EvaluateProgram
 *   Turn an MDX program (export/import statements) into a value.
 * @param {Program} expression
 *   ESTree program.
 * @returns {unknown}
 *   Result of program;
 *   should likely be `undefined` as ESM changes the scope but doesn’t yield
 *   something.
 *
 * @typedef Evaluater
 *   Evaluator that turns ESTree ASTs from embedded MDX into values.
 * @property {EvaluateExpression} evaluateExpression
 *   Evaluate an expression.
 * @property {EvaluateProgram} evaluateProgram
 *   Evaluate a program.
 *
 * @typedef {[string, Value]} Field
 *   Property field.
 *
 * @typedef {unknown} Fragment
 *   Represent the children, typically a symbol.
 *
 * @callback Jsx
 *   Create a production element.
 * @param {unknown} type
 *   Element type: `Fragment` symbol, tag name (`string`), component.
 * @param {Props} props
 *   Element props, `children`, and maybe `node`.
 * @param {string | undefined} [key]
 *   Dynamicly generated key to use.
 * @returns {JSX.Element}
 *   Element from your framework.
 *
 * @callback JsxDev
 *   Create a development element.
 * @param {unknown} type
 *   Element type: `Fragment` symbol, tag name (`string`), component.
 * @param {Props} props
 *   Element props, `children`, and maybe `node`.
 * @param {string | undefined} key
 *   Dynamicly generated key to use.
 * @param {boolean} isStaticChildren
 *   Whether two or more children are passed (in an array), which is whether
 *   `jsxs` or `jsx` would be used.
 * @param {Source} source
 *   Info about source.
 * @param {undefined} self
 *   Nothing (this is used by frameworks that have components, we don’t).
 * @returns {JSX.Element}
 *   Element from your framework.
 *
 * @typedef {{children?: Array<Child> | Child, node?: Element | MdxJsxFlowElement | MdxJsxTextElement | undefined, [prop: string]: Array<Child> | Child | Element | MdxJsxFlowElement | MdxJsxTextElement | Value | undefined}} Props
 *   Properties and children.
 *
 * @typedef RegularFields
 *   Configuration.
 * @property {Partial<Components> | null | undefined} [components]
 *   Components to use (optional).
 * @property {CreateEvaluater | null | undefined} [createEvaluater]
 *   Create an evaluator that turns ESTree ASTs into values (optional).
 * @property {ElementAttributeNameCase | null | undefined} [elementAttributeNameCase='react']
 *   Specify casing to use for attribute names (default: `'react'`).
 * @property {string | null | undefined} [filePath]
 *   File path to the original source file (optional).
 *
 *   Passed in source info to `jsxDEV` when using the automatic runtime with
 *   `development: true`.
 * @property {boolean | null | undefined} [ignoreInvalidStyle=false]
 *   Ignore invalid CSS in `style` props (default: `false`);
 *   the default behavior is to throw an error.
 * @property {boolean | null | undefined} [passKeys=true]
 *   Generate keys to optimize frameworks that support them (default: `true`).
 *
 *   > 👉 **Note**: Solid currently fails if keys are passed.
 * @property {boolean | null | undefined} [passNode=false]
 *   Pass the hast element node to components (default: `false`).
 * @property {Space | null | undefined} [space='html']
 *   Whether `tree` is in the `'html'` or `'svg'` space (default: `'html'`).
 *
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it.
 * @property {StylePropertyNameCase | null | undefined} [stylePropertyNameCase='dom']
 *   Specify casing to use for property names in `style` objects (default:
 *   `'dom'`).
 * @property {boolean | null | undefined} [tableCellAlignToStyle=true]
 *   Turn obsolete `align` props on `td` and `th` into CSS `style` props
 *   (default: `true`).
 *
 * @typedef RuntimeDevelopment
 *   Runtime fields when development is on.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {true} development
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off).
 * @property {Jsx | null | undefined} [jsx]
 *   Dynamic JSX (optional).
 * @property {JsxDev} jsxDEV
 *   Development JSX.
 * @property {Jsx | null | undefined} [jsxs]
 *   Static JSX (optional).
 *
 * @typedef RuntimeProduction
 *   Runtime fields when development is off.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {false | null | undefined} [development]
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off) (optional).
 * @property {Jsx} jsx
 *   Dynamic JSX.
 * @property {JsxDev | null | undefined} [jsxDEV]
 *   Development JSX (optional).
 * @property {Jsx} jsxs
 *   Static JSX.
 *
 * @typedef RuntimeUnknown
 *   Runtime fields when development might be on or off.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {boolean} development
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off).
 * @property {Jsx | null | undefined} [jsx]
 *   Dynamic JSX (optional).
 * @property {JsxDev | null | undefined} [jsxDEV]
 *   Development JSX (optional).
 * @property {Jsx | null | undefined} [jsxs]
 *   Static JSX (optional).
 *
 * @typedef Source
 *   Info about source.
 * @property {number | undefined} columnNumber
 *   Column where thing starts (0-indexed).
 * @property {string | undefined} fileName
 *   Name of source file.
 * @property {number | undefined} lineNumber
 *   Line where thing starts (1-indexed).
 *
 * @typedef {'html' | 'svg'} Space
 *   Namespace.
 *
 *   > 👉 **Note**: hast is not XML.
 *   > It supports SVG as embedded in HTML.
 *   > It does not support the features available in XML.
 *   > Passing SVG might break but fragments of modern SVG should be fine.
 *   > Use `xast` if you need to support SVG as XML.
 *
 * @typedef State
 *   Info passed around.
 * @property {unknown} Fragment
 *   Fragment symbol.
 * @property {Array<Parents>} ancestors
 *   Stack of parents.
 * @property {Partial<Components>} components
 *   Components to swap.
 * @property {Create} create
 *   Create something in development or production.
 * @property {ElementAttributeNameCase} elementAttributeNameCase
 *   Casing to use for attribute names.
 * @property {Evaluater | undefined} evaluater
 *   Evaluator that turns ESTree ASTs into values.
 * @property {string | undefined} filePath
 *   File path.
 * @property {boolean} ignoreInvalidStyle
 *   Ignore invalid CSS in `style` props.
 * @property {boolean} passKeys
 *   Generate keys to optimize frameworks that support them.
 * @property {boolean} passNode
 *   Pass `node` to components.
 * @property {Schema} schema
 *   Current schema.
 * @property {StylePropertyNameCase} stylePropertyNameCase
 *   Casing to use for property names in `style` objects.
 * @property {boolean} tableCellAlignToStyle
 *   Turn obsolete `align` props on `td` and `th` into CSS `style` props.
 *
 * @typedef {Record<string, string>} Style
 *   Style map.
 *
 * @typedef {'css' | 'dom'} StylePropertyNameCase
 *   Casing to use for property names in `style` objects.
 *
 *   CSS casing is for example `background-color` and `-webkit-line-clamp`.
 *   DOM casing is for example `backgroundColor` and `WebkitLineClamp`.
 *
 * @typedef {Style | boolean | number | string} Value
 *   Primitive property value and `Style` map.
 */ /**
 * @typedef {RuntimeDevelopment & RegularFields} Development
 *   Configuration (development).
 * @typedef {Development | Production | Unknown} Options
 *   Configuration.
 * @typedef {RegularFields & RuntimeProduction} Production
 *   Configuration (production).
 * @typedef {RegularFields & RuntimeUnknown} Unknown
 *   Configuration (production or development).
 */ /**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $dbbea5b80810607b$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $dbbea5b80810607b$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}



/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */ const $a98724244e033a5d$var$startRe = /[$_\p{ID_Start}]/u;
const $a98724244e033a5d$var$contRe = /[$_\u{200C}\u{200D}\p{ID_Continue}]/u;
const $a98724244e033a5d$var$contReJsx = /[-$_\u{200C}\u{200D}\p{ID_Continue}]/u;
const $a98724244e033a5d$var$nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
const $a98724244e033a5d$var$nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
/** @type {Options} */ const $a98724244e033a5d$var$emptyOptions = {};
function $a98724244e033a5d$export$b3571188c770cc5a(code) {
    return code ? $a98724244e033a5d$var$startRe.test(String.fromCodePoint(code)) : false;
}
function $a98724244e033a5d$export$10eb6dc47bf009dc(code, options) {
    const settings = options || $a98724244e033a5d$var$emptyOptions;
    const re = settings.jsx ? $a98724244e033a5d$var$contReJsx : $a98724244e033a5d$var$contRe;
    return code ? re.test(String.fromCodePoint(code)) : false;
}
function $a98724244e033a5d$export$a8ff84c12d48cfa6(name, options) {
    const settings = options || $a98724244e033a5d$var$emptyOptions;
    const re = settings.jsx ? $a98724244e033a5d$var$nameReJsx : $a98724244e033a5d$var$nameRe;
    return re.test(name);
}


/**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $35e34100d63564ff$var$re = /[ \t\n\f\r]/g;
function $35e34100d63564ff$export$7af1228ff777d175(thing) {
    return typeof thing === 'object' ? thing.type === 'text' ? $35e34100d63564ff$var$empty(thing.value) : false : $35e34100d63564ff$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $35e34100d63564ff$var$empty(value) {
    return value.replace($35e34100d63564ff$var$re, '') === '';
}


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $1d5403ccbba5d396$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


class $04dbb0b5f04b8022$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $04dbb0b5f04b8022$export$c4868e4a24d48fad.prototype.space = null;
$04dbb0b5f04b8022$export$c4868e4a24d48fad.prototype.boolean = false;
$04dbb0b5f04b8022$export$c4868e4a24d48fad.prototype.booleanish = false;
$04dbb0b5f04b8022$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$04dbb0b5f04b8022$export$c4868e4a24d48fad.prototype.number = false;
$04dbb0b5f04b8022$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$04dbb0b5f04b8022$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$04dbb0b5f04b8022$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$04dbb0b5f04b8022$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$04dbb0b5f04b8022$export$c4868e4a24d48fad.prototype.defined = false;


var $7fa34fc91a4b34aa$exports = {};

$parcel$export($7fa34fc91a4b34aa$exports, "boolean", () => $7fa34fc91a4b34aa$export$4a21f16c33752377);
$parcel$export($7fa34fc91a4b34aa$exports, "booleanish", () => $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f);
$parcel$export($7fa34fc91a4b34aa$exports, "overloadedBoolean", () => $7fa34fc91a4b34aa$export$242ac3d3042558aa);
$parcel$export($7fa34fc91a4b34aa$exports, "number", () => $7fa34fc91a4b34aa$export$98e628dec113755e);
$parcel$export($7fa34fc91a4b34aa$exports, "spaceSeparated", () => $7fa34fc91a4b34aa$export$ab8645c862eb5a3e);
$parcel$export($7fa34fc91a4b34aa$exports, "commaSeparated", () => $7fa34fc91a4b34aa$export$9c8d678629b3d3);
$parcel$export($7fa34fc91a4b34aa$exports, "commaOrSpaceSeparated", () => $7fa34fc91a4b34aa$export$2ad25cfebf36cacd);
let $7fa34fc91a4b34aa$var$powers = 0;
const $7fa34fc91a4b34aa$export$4a21f16c33752377 = $7fa34fc91a4b34aa$var$increment();
const $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f = $7fa34fc91a4b34aa$var$increment();
const $7fa34fc91a4b34aa$export$242ac3d3042558aa = $7fa34fc91a4b34aa$var$increment();
const $7fa34fc91a4b34aa$export$98e628dec113755e = $7fa34fc91a4b34aa$var$increment();
const $7fa34fc91a4b34aa$export$ab8645c862eb5a3e = $7fa34fc91a4b34aa$var$increment();
const $7fa34fc91a4b34aa$export$9c8d678629b3d3 = $7fa34fc91a4b34aa$var$increment();
const $7fa34fc91a4b34aa$export$2ad25cfebf36cacd = $7fa34fc91a4b34aa$var$increment();
function $7fa34fc91a4b34aa$var$increment() {
    return 2 ** ++$7fa34fc91a4b34aa$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $bda9b02db9edeb23$var$checks = Object.keys($7fa34fc91a4b34aa$exports);
class $bda9b02db9edeb23$export$ea6b9f0064e88c9b extends (0, $04dbb0b5f04b8022$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $bda9b02db9edeb23$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $bda9b02db9edeb23$var$checks.length){
            const check = $bda9b02db9edeb23$var$checks[index];
            $bda9b02db9edeb23$var$mark(this, $bda9b02db9edeb23$var$checks[index], (mask & $7fa34fc91a4b34aa$exports[check]) === $7fa34fc91a4b34aa$exports[check]);
        }
    }
}
$bda9b02db9edeb23$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $bda9b02db9edeb23$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}



const $17d40d641940f0c8$var$valid = /^data[-\w.:]+$/i;
const $17d40d641940f0c8$var$dash = /-[a-z]/g;
const $17d40d641940f0c8$var$cap = /[A-Z]/g;
function $17d40d641940f0c8$export$71aa6c912b956294(schema, value) {
    const normal = (0, $1d5403ccbba5d396$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $04dbb0b5f04b8022$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $17d40d641940f0c8$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($17d40d641940f0c8$var$dash, $17d40d641940f0c8$var$camelcase);
            prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$17d40d641940f0c8$var$dash.test(rest)) {
                let dashes = rest.replace($17d40d641940f0c8$var$cap, $17d40d641940f0c8$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $bda9b02db9edeb23$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $17d40d641940f0c8$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $17d40d641940f0c8$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $e1ba9a64f0845235$export$d8abd7e5fb6871f9 = {
    classId: 'classID',
    dataType: 'datatype',
    itemId: 'itemID',
    strokeDashArray: 'strokeDasharray',
    strokeDashOffset: 'strokeDashoffset',
    strokeLineCap: 'strokeLinecap',
    strokeLineJoin: 'strokeLinejoin',
    strokeMiterLimit: 'strokeMiterlimit',
    typeOf: 'typeof',
    xLinkActuate: 'xlinkActuate',
    xLinkArcRole: 'xlinkArcrole',
    xLinkHref: 'xlinkHref',
    xLinkRole: 'xlinkRole',
    xLinkShow: 'xlinkShow',
    xLinkTitle: 'xlinkTitle',
    xLinkType: 'xlinkType',
    xmlnsXLink: 'xmlnsXlink'
};

/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $16d0d3c8a4e397ba$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $16d0d3c8a4e397ba$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $16d0d3c8a4e397ba$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $16d0d3c8a4e397ba$export$19342e026b58ebb7.prototype.space = null;


function $1eab1d0ddbf99f8c$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $16d0d3c8a4e397ba$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ 


const $8ecf12c3e506acf4$var$own = {}.hasOwnProperty;
function $8ecf12c3e506acf4$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($8ecf12c3e506acf4$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $bda9b02db9edeb23$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $1d5403ccbba5d396$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $1d5403ccbba5d396$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $16d0d3c8a4e397ba$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $a00b25fdc6f0c536$export$2bd1230ec7600845 = (0, $8ecf12c3e506acf4$export$185802fd694ee1f5)({
    space: 'xlink',
    transform (_, prop) {
        return 'xlink:' + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $99a6a83de999ec2c$export$f2913fe8983302e = (0, $8ecf12c3e506acf4$export$185802fd694ee1f5)({
    space: 'xml',
    transform (_, prop) {
        return 'xml:' + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $51256415cd24e9d5$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $f1ccc5320f757f1d$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $51256415cd24e9d5$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $cea76426a3c62436$export$e20c24a128671213 = (0, $8ecf12c3e506acf4$export$185802fd694ee1f5)({
    space: 'xmlns',
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    transform: (0, $f1ccc5320f757f1d$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $4edb59c253b2d43d$export$4d2d26490572750a = (0, $8ecf12c3e506acf4$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        ariaColIndex: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        ariaColSpan: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        ariaControls: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        ariaLevel: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        ariaPressed: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        ariaRowIndex: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        ariaRowSpan: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        ariaSelected: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        ariaValueMin: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        ariaValueNow: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $1ba7227f198dfb2a$export$c0bb0b647f701bb5 = (0, $8ecf12c3e506acf4$export$185802fd694ee1f5)({
    space: 'html',
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    transform: (0, $f1ccc5320f757f1d$export$32b9e4cec9c208e1),
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $7fa34fc91a4b34aa$export$9c8d678629b3d3),
        acceptCharset: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        accessKey: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        allowPaymentRequest: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        allowUserMedia: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        autoFocus: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        autoPlay: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        blocking: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        cite: null,
        className: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        cols: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        controls: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        controlsList: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        coords: (0, $7fa34fc91a4b34aa$export$98e628dec113755e) | (0, $7fa34fc91a4b34aa$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        defer: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        download: (0, $7fa34fc91a4b34aa$export$242ac3d3042558aa),
        draggable: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        height: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        hidden: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        high: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        httpEquiv: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        itemRef: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        itemScope: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        itemType: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        low: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        multiple: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        muted: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        noValidate: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        optimum: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        pattern: null,
        ping: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        required: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        reversed: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        rows: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        rowSpan: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        sandbox: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        seamless: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        selected: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        shadowRootClonable: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        spellCheck: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        useMap: null,
        value: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        width: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        declare: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        leftMargin: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        marginWidth: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        noResize: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        noHref: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        noShade: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        noWrap: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $7fa34fc91a4b34aa$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        disableRemotePlayback: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $58aaec8e137919fe$export$7ed1367e7fa1ad68 = (0, $8ecf12c3e506acf4$export$185802fd694ee1f5)({
    space: 'svg',
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    transform: (0, $51256415cd24e9d5$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $7fa34fc91a4b34aa$export$2ad25cfebf36cacd),
        accentHeight: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        amplitude: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        className: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        diffuseConstant: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $7fa34fc91a4b34aa$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $7fa34fc91a4b34aa$export$9c8d678629b3d3),
        g2: (0, $7fa34fc91a4b34aa$export$9c8d678629b3d3),
        glyphName: (0, $7fa34fc91a4b34aa$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        horizOriginX: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        horizOriginY: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        id: null,
        ideographic: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        k: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        k1: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        k2: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        k3: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        k4: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        kernelMatrix: (0, $7fa34fc91a4b34aa$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        overlineThickness: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $7fa34fc91a4b34aa$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        pointsAtY: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        pointsAtZ: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $7fa34fc91a4b34aa$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $7fa34fc91a4b34aa$export$2ad25cfebf36cacd),
        rev: (0, $7fa34fc91a4b34aa$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $7fa34fc91a4b34aa$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $7fa34fc91a4b34aa$export$2ad25cfebf36cacd),
        requiredFonts: (0, $7fa34fc91a4b34aa$export$2ad25cfebf36cacd),
        requiredFormats: (0, $7fa34fc91a4b34aa$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        specularExponent: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        strikethroughThickness: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $7fa34fc91a4b34aa$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        strokeOpacity: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $7fa34fc91a4b34aa$export$2ad25cfebf36cacd),
        tabIndex: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        targetY: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $7fa34fc91a4b34aa$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        underlineThickness: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        vMathematical: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        vIdeographic: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        vertOriginX: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        vertOriginY: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $7fa34fc91a4b34aa$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});





const $65e8d0fd40718f75$export$c0bb0b647f701bb5 = (0, $1eab1d0ddbf99f8c$export$4950aa0f605343fb)([
    (0, $99a6a83de999ec2c$export$f2913fe8983302e),
    (0, $a00b25fdc6f0c536$export$2bd1230ec7600845),
    (0, $cea76426a3c62436$export$e20c24a128671213),
    (0, $4edb59c253b2d43d$export$4d2d26490572750a),
    (0, $1ba7227f198dfb2a$export$c0bb0b647f701bb5)
], 'html');
const $65e8d0fd40718f75$export$7ed1367e7fa1ad68 = (0, $1eab1d0ddbf99f8c$export$4950aa0f605343fb)([
    (0, $99a6a83de999ec2c$export$f2913fe8983302e),
    (0, $a00b25fdc6f0c536$export$2bd1230ec7600845),
    (0, $cea76426a3c62436$export$e20c24a128671213),
    (0, $4edb59c253b2d43d$export$4d2d26490572750a),
    (0, $58aaec8e137919fe$export$7ed1367e7fa1ad68)
], 'svg');


/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $7659da7888b86a8e$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $7659da7888b86a8e$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}


var $5a8fc9ba9b2d0157$exports = {};
"use strict";
var $5a8fc9ba9b2d0157$var$__importDefault = $5a8fc9ba9b2d0157$exports && $5a8fc9ba9b2d0157$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($5a8fc9ba9b2d0157$exports, "__esModule", {
    value: true
});

var $5a8fc9ba9b2d0157$var$inline_style_parser_1 = $5a8fc9ba9b2d0157$var$__importDefault((parcelRequire("fyVfK")));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $5a8fc9ba9b2d0157$var$StyleToObject(style, iterator) {
    var styleObject = null;
    if (!style || typeof style !== 'string') return styleObject;
    var declarations = (0, $5a8fc9ba9b2d0157$var$inline_style_parser_1.default)(style);
    var hasIterator = typeof iterator === 'function';
    declarations.forEach(function(declaration) {
        if (declaration.type !== 'declaration') return;
        var property = declaration.property, value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}
$5a8fc9ba9b2d0157$exports.default = $5a8fc9ba9b2d0157$var$StyleToObject;


var // ensure compatibility with rollup umd build
$e2e50cf3f46f61c1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5a8fc9ba9b2d0157$exports))).default || (0, (/*@__PURE__*/$parcel$interopDefault($5a8fc9ba9b2d0157$exports)));


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $87a7d29188c64fce$export$da309cdce9dc2a25 = $87a7d29188c64fce$var$point('end');
const $87a7d29188c64fce$export$771bf3e4949bfbee = $87a7d29188c64fce$var$point('start');
/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $87a7d29188c64fce$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        if (typeof point.line === 'number' && point.line > 0 && typeof point.column === 'number' && point.column > 0) return {
            line: point.line,
            column: point.column,
            offset: typeof point.offset === 'number' && point.offset > -1 ? point.offset : undefined
        };
    }
}
function $87a7d29188c64fce$export$5880b8b5730aff45(node) {
    const start = $87a7d29188c64fce$export$771bf3e4949bfbee(node);
    const end = $87a7d29188c64fce$export$da309cdce9dc2a25(node);
    if (start && end) return {
        start: start,
        end: end
    };
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $6835c4f72960a9e7$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $6835c4f72960a9e7$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $6835c4f72960a9e7$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $6835c4f72960a9e7$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $6835c4f72960a9e7$var$point(point) {
    return $6835c4f72960a9e7$var$index(point && point.line) + ':' + $6835c4f72960a9e7$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $6835c4f72960a9e7$var$position(pos) {
    return $6835c4f72960a9e7$var$point(pos && pos.start) + '-' + $6835c4f72960a9e7$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $6835c4f72960a9e7$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


class $56d41ff9124ad29b$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // eslint-disable-next-line complexity
    constructor(causeOrReason, optionsOrParentOrPlace, origin){
        super();
        if (typeof optionsOrParentOrPlace === 'string') {
            origin = optionsOrParentOrPlace;
            optionsOrParentOrPlace = undefined;
        }
        /** @type {string} */ let reason = '';
        /** @type {Options} */ let options = {};
        let legacyCause = false;
        if (optionsOrParentOrPlace) {
            // Point.
            if ('line' in optionsOrParentOrPlace && 'column' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('start' in optionsOrParentOrPlace && 'end' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('type' in optionsOrParentOrPlace) options = {
                ancestors: [
                    optionsOrParentOrPlace
                ],
                place: optionsOrParentOrPlace.position
            };
            else options = {
                ...optionsOrParentOrPlace
            };
        }
        if (typeof causeOrReason === 'string') reason = causeOrReason;
        else if (!options.cause && causeOrReason) {
            legacyCause = true;
            reason = causeOrReason.message;
            options.cause = causeOrReason;
        }
        if (!options.ruleId && !options.source && typeof origin === 'string') {
            const index = origin.indexOf(':');
            if (index === -1) options.ruleId = origin;
            else {
                options.source = origin.slice(0, index);
                options.ruleId = origin.slice(index + 1);
            }
        }
        if (!options.place && options.ancestors && options.ancestors) {
            const parent = options.ancestors[options.ancestors.length - 1];
            if (parent) options.place = parent.position;
        }
        const start = options.place && 'start' in options.place ? options.place.start : options.place;
        /* eslint-disable no-unused-expressions */ /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */ this.ancestors = options.ancestors || undefined;
        /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */ this.cause = options.cause || undefined;
        /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */ this.column = start ? start.column : undefined;
        /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */ this.fatal = undefined;
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */ this.file;
        // Field from `Error`.
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = reason;
        /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */ this.line = start ? start.line : undefined;
        // Field from `Error`.
        /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $6835c4f72960a9e7$export$c304dd45fe166145)(options.place) || '1:1';
        /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */ this.place = options.place || undefined;
        /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */ this.ruleId = options.ruleId || undefined;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */ this.source = options.source || undefined;
        // Field from `Error`.
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = legacyCause && options.cause && typeof options.cause.stack === 'string' ? options.cause.stack : '';
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */ this.expected;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */ this.note;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */ this.url;
    /* eslint-enable no-unused-expressions */ }
}
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.file = '';
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.name = '';
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.reason = '';
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.message = '';
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.stack = '';
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.column = undefined;
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.line = undefined;
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.ancestors = undefined;
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.cause = undefined;
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.fatal = undefined;
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.place = undefined;
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.ruleId = undefined;
$56d41ff9124ad29b$export$752e5c445fe834ef.prototype.source = undefined;


const $ec6fdf630d7c0759$var$own = {}.hasOwnProperty;
/** @type {Map<string, number>} */ const $ec6fdf630d7c0759$var$emptyMap = new Map();
const $ec6fdf630d7c0759$var$cap = /[A-Z]/g;
const $ec6fdf630d7c0759$var$dashSomething = /-([a-z])/g;
// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.
// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const $ec6fdf630d7c0759$var$tableElements = new Set([
    'table',
    'tbody',
    'thead',
    'tfoot',
    'tr'
]);
const $ec6fdf630d7c0759$var$tableCellElement = new Set([
    'td',
    'th'
]);
const $ec6fdf630d7c0759$var$docs = 'https://github.com/syntax-tree/hast-util-to-jsx-runtime';
function $ec6fdf630d7c0759$export$59c10052b2dee561(tree, options) {
    if (!options || options.Fragment === undefined) throw new TypeError('Expected `Fragment` in options');
    const filePath = options.filePath || undefined;
    /** @type {Create} */ let create;
    if (options.development) {
        if (typeof options.jsxDEV !== 'function') throw new TypeError('Expected `jsxDEV` in options when `development: true`');
        create = $ec6fdf630d7c0759$var$developmentCreate(filePath, options.jsxDEV);
    } else {
        if (typeof options.jsx !== 'function') throw new TypeError('Expected `jsx` in production options');
        if (typeof options.jsxs !== 'function') throw new TypeError('Expected `jsxs` in production options');
        create = $ec6fdf630d7c0759$var$productionCreate(filePath, options.jsx, options.jsxs);
    }
    /** @type {State} */ const state = {
        Fragment: options.Fragment,
        ancestors: [],
        components: options.components || {},
        create: create,
        elementAttributeNameCase: options.elementAttributeNameCase || 'react',
        evaluater: options.createEvaluater ? options.createEvaluater() : undefined,
        filePath: filePath,
        ignoreInvalidStyle: options.ignoreInvalidStyle || false,
        passKeys: options.passKeys !== false,
        passNode: options.passNode || false,
        schema: options.space === 'svg' ? (0, $65e8d0fd40718f75$export$7ed1367e7fa1ad68) : (0, $65e8d0fd40718f75$export$c0bb0b647f701bb5),
        stylePropertyNameCase: options.stylePropertyNameCase || 'dom',
        tableCellAlignToStyle: options.tableCellAlignToStyle !== false
    };
    const result = $ec6fdf630d7c0759$var$one(state, tree, undefined);
    // JSX element.
    if (result && typeof result !== 'string') return result;
    // Text node or something that turned into nothing.
    return state.create(tree, state.Fragment, {
        children: result || undefined
    }, undefined);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ec6fdf630d7c0759$var$one(state, node, key) {
    if (node.type === 'element') return $ec6fdf630d7c0759$var$element(state, node, key);
    if (node.type === 'mdxFlowExpression' || node.type === 'mdxTextExpression') return $ec6fdf630d7c0759$var$mdxExpression(state, node);
    if (node.type === 'mdxJsxFlowElement' || node.type === 'mdxJsxTextElement') return $ec6fdf630d7c0759$var$mdxJsxElement(state, node, key);
    if (node.type === 'mdxjsEsm') return $ec6fdf630d7c0759$var$mdxEsm(state, node);
    if (node.type === 'root') return $ec6fdf630d7c0759$var$root(state, node, key);
    if (node.type === 'text') return $ec6fdf630d7c0759$var$text(state, node);
}
/**
 * Handle element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ec6fdf630d7c0759$var$element(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') {
        schema = (0, $65e8d0fd40718f75$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = $ec6fdf630d7c0759$var$findComponentFromName(state, node.tagName, false);
    const props = $ec6fdf630d7c0759$var$createElementProps(state, node);
    let children = $ec6fdf630d7c0759$var$createChildren(state, node);
    if ($ec6fdf630d7c0759$var$tableElements.has(node.tagName)) children = children.filter(function(child) {
        return typeof child === 'string' ? !(0, $35e34100d63564ff$export$7af1228ff777d175)(child) : true;
    });
    $ec6fdf630d7c0759$var$addNode(state, props, type, node);
    $ec6fdf630d7c0759$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle MDX expression.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxFlowExpression | MdxTextExpression} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ec6fdf630d7c0759$var$mdxExpression(state, node) {
    if (node.data && node.data.estree && state.evaluater) {
        const program = node.data.estree;
        const expression = program.body[0];
        (0, $4b359f2d21305e76$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
        // Assume result is a child.
        return /** @type {Child | undefined} */ state.evaluater.evaluateExpression(expression.expression);
    }
    $ec6fdf630d7c0759$var$crashEstree(state, node.position);
}
/**
 * Handle MDX ESM.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxjsEsm} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ec6fdf630d7c0759$var$mdxEsm(state, node) {
    if (node.data && node.data.estree && state.evaluater) // Assume result is a child.
    return /** @type {Child | undefined} */ state.evaluater.evaluateProgram(node.data.estree);
    $ec6fdf630d7c0759$var$crashEstree(state, node.position);
}
/**
 * Handle MDX JSX.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElement | MdxJsxTextElement} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ec6fdf630d7c0759$var$mdxJsxElement(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.name === 'svg' && parentSchema.space === 'html') {
        schema = (0, $65e8d0fd40718f75$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = node.name === null ? state.Fragment : $ec6fdf630d7c0759$var$findComponentFromName(state, node.name, true);
    const props = $ec6fdf630d7c0759$var$createJsxElementProps(state, node);
    const children = $ec6fdf630d7c0759$var$createChildren(state, node);
    $ec6fdf630d7c0759$var$addNode(state, props, type, node);
    $ec6fdf630d7c0759$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Root} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ec6fdf630d7c0759$var$root(state, node, key) {
    /** @type {Props} */ const props = {};
    $ec6fdf630d7c0759$var$addChildren(props, $ec6fdf630d7c0759$var$createChildren(state, node));
    return state.create(node, state.Fragment, props, key);
}
/**
 * Handle text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Text} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ec6fdf630d7c0759$var$text(_, node) {
    return node.value;
}
/**
 * Add `node` to props.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Props} props
 *   Props.
 * @param {unknown} type
 *   Type.
 * @param {Element | MdxJsxFlowElement | MdxJsxTextElement} node
 *   Node.
 * @returns {undefined}
 *   Nothing.
 */ function $ec6fdf630d7c0759$var$addNode(state, props, type, node) {
    // If this is swapped out for a component:
    if (typeof type !== 'string' && type !== state.Fragment && state.passNode) props.node = node;
}
/**
 * Add children to props.
 *
 * @param {Props} props
 *   Props.
 * @param {Array<Child>} children
 *   Children.
 * @returns {undefined}
 *   Nothing.
 */ function $ec6fdf630d7c0759$var$addChildren(props, children) {
    if (children.length > 0) {
        const value = children.length > 1 ? children : children[0];
        if (value) props.children = value;
    }
}
/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */ function $ec6fdf630d7c0759$var$productionCreate(_, jsx, jsxs) {
    return create;
    /** @type {Create} */ function create(_, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const fn = isStaticChildren ? jsxs : jsx;
        return key ? fn(type, props, key) : fn(type, props);
    }
}
/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */ function $ec6fdf630d7c0759$var$developmentCreate(filePath, jsxDEV) {
    return create;
    /** @type {Create} */ function create(node, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const point = (0, $87a7d29188c64fce$export$771bf3e4949bfbee)(node);
        return jsxDEV(type, props, key, isStaticChildren, {
            columnNumber: point ? point.column - 1 : undefined,
            fileName: filePath,
            lineNumber: point ? point.line : undefined
        }, undefined);
    }
}
/**
 * Create props from an element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current element.
 * @returns {Props}
 *   Props.
 */ function $ec6fdf630d7c0759$var$createElementProps(state, node) {
    /** @type {Props} */ const props = {};
    /** @type {string | undefined} */ let alignValue;
    /** @type {string} */ let prop;
    for(prop in node.properties)if (prop !== 'children' && $ec6fdf630d7c0759$var$own.call(node.properties, prop)) {
        const result = $ec6fdf630d7c0759$var$createProperty(state, prop, node.properties[prop]);
        if (result) {
            const [key, value] = result;
            if (state.tableCellAlignToStyle && key === 'align' && typeof value === 'string' && $ec6fdf630d7c0759$var$tableCellElement.has(node.tagName)) alignValue = value;
            else props[key] = value;
        }
    }
    if (alignValue) {
        // Assume style is an object.
        const style = /** @type {Style} */ props.style || (props.style = {});
        style[state.stylePropertyNameCase === 'css' ? 'text-align' : 'textAlign'] = alignValue;
    }
    return props;
}
/**
 * Create props from a JSX element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElement | MdxJsxTextElement} node
 *   Current JSX element.
 * @returns {Props}
 *   Props.
 */ function $ec6fdf630d7c0759$var$createJsxElementProps(state, node) {
    /** @type {Props} */ const props = {};
    for (const attribute of node.attributes)if (attribute.type === 'mdxJsxExpressionAttribute') {
        if (attribute.data && attribute.data.estree && state.evaluater) {
            const program = attribute.data.estree;
            const expression = program.body[0];
            (0, $4b359f2d21305e76$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
            const objectExpression = expression.expression;
            (0, $4b359f2d21305e76$export$dcb8b3f0e2de7e49)(objectExpression.type === 'ObjectExpression');
            const property = objectExpression.properties[0];
            (0, $4b359f2d21305e76$export$dcb8b3f0e2de7e49)(property.type === 'SpreadElement');
            Object.assign(props, state.evaluater.evaluateExpression(property.argument));
        } else $ec6fdf630d7c0759$var$crashEstree(state, node.position);
    } else {
        // For JSX, the author is responsible of passing in the correct values.
        const name = attribute.name;
        /** @type {unknown} */ let value;
        if (attribute.value && typeof attribute.value === 'object') {
            if (attribute.value.data && attribute.value.data.estree && state.evaluater) {
                const program = attribute.value.data.estree;
                const expression = program.body[0];
                (0, $4b359f2d21305e76$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
                value = state.evaluater.evaluateExpression(expression.expression);
            } else $ec6fdf630d7c0759$var$crashEstree(state, node.position);
        } else value = attribute.value === null ? true : attribute.value;
        // Assume a prop.
        props[name] = /** @type {Props[keyof Props]} */ value;
    }
    return props;
}
/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */ function $ec6fdf630d7c0759$var$createChildren(state, node) {
    /** @type {Array<Child>} */ const children = [];
    let index = -1;
    /** @type {Map<string, number>} */ // Note: test this when Solid doesn’t want to merge my upcoming PR.
    /* c8 ignore next */ const countsByName = state.passKeys ? new Map() : $ec6fdf630d7c0759$var$emptyMap;
    while(++index < node.children.length){
        const child = node.children[index];
        /** @type {string | undefined} */ let key;
        if (state.passKeys) {
            const name = child.type === 'element' ? child.tagName : child.type === 'mdxJsxFlowElement' || child.type === 'mdxJsxTextElement' ? child.name : undefined;
            if (name) {
                const count = countsByName.get(name) || 0;
                key = name + '-' + count;
                countsByName.set(name, count + 1);
            }
        }
        const result = $ec6fdf630d7c0759$var$one(state, child, key);
        if (result !== undefined) children.push(result);
    }
    return children;
}
/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */ function $ec6fdf630d7c0759$var$createProperty(state, prop, value) {
    const info = (0, $17d40d641940f0c8$export$71aa6c912b956294)(state.schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === null || value === undefined || typeof value === 'number' && Number.isNaN(value)) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $dbbea5b80810607b$export$fac44ee5b035f737)(value) : (0, $7659da7888b86a8e$export$fac44ee5b035f737)(value);
    // React only accepts `style` as object.
    if (info.property === 'style') {
        let styleObject = typeof value === 'object' ? value : $ec6fdf630d7c0759$var$parseStyle(state, String(value));
        if (state.stylePropertyNameCase === 'css') styleObject = $ec6fdf630d7c0759$var$transformStylesToCssCasing(styleObject);
        return [
            'style',
            styleObject
        ];
    }
    return [
        state.elementAttributeNameCase === 'react' && info.space ? (0, $e1ba9a64f0845235$export$d8abd7e5fb6871f9)[info.property] || info.property : info.attribute,
        value
    ];
}
/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */ function $ec6fdf630d7c0759$var$parseStyle(state, value) {
    /** @type {Style} */ const result = {};
    try {
        // @ts-expect-error: `style-to-object` types are broken.
        (0, $e2e50cf3f46f61c1$export$2e2bcd8739ae039)(value, replacer);
    } catch (error) {
        if (!state.ignoreInvalidStyle) {
            const cause = /** @type {Error} */ error;
            const message = new (0, $56d41ff9124ad29b$export$752e5c445fe834ef)('Cannot parse `style` attribute', {
                ancestors: state.ancestors,
                cause: cause,
                ruleId: 'style',
                source: 'hast-util-to-jsx-runtime'
            });
            message.file = state.filePath || undefined;
            message.url = $ec6fdf630d7c0759$var$docs + '#cannot-parse-style-attribute';
            throw message;
        }
    }
    return result;
    /**
   * Add a CSS property (normal, so with dashes) to `result` as a DOM CSS
   * property.
   *
   * @param {string} name
   *   Key.
   * @param {string} value
   *   Value
   * @returns {undefined}
   *   Nothing.
   */ function replacer(name, value) {
        let key = name;
        if (key.slice(0, 2) !== '--') {
            if (key.slice(0, 4) === '-ms-') key = 'ms-' + key.slice(4);
            key = key.replace($ec6fdf630d7c0759$var$dashSomething, $ec6fdf630d7c0759$var$toCamel);
        }
        result[key] = value;
    }
}
/**
 * Create a JSX name from a string.
 *
 * @param {State} state
 *   To do.
 * @param {string} name
 *   Name.
 * @param {boolean} allowExpression
 *   Allow member expressions and identifiers.
 * @returns {unknown}
 *   To do.
 */ function $ec6fdf630d7c0759$var$findComponentFromName(state, name, allowExpression) {
    /** @type {Identifier | Literal | MemberExpression} */ let result;
    if (!allowExpression) result = {
        type: 'Literal',
        value: name
    };
    else if (name.includes('.')) {
        const identifiers = name.split('.');
        let index = -1;
        /** @type {Identifier | Literal | MemberExpression | undefined} */ let node;
        while(++index < identifiers.length){
            /** @type {Identifier | Literal} */ const prop = (0, $a98724244e033a5d$export$a8ff84c12d48cfa6)(identifiers[index]) ? {
                type: 'Identifier',
                name: identifiers[index]
            } : {
                type: 'Literal',
                value: identifiers[index]
            };
            node = node ? {
                type: 'MemberExpression',
                object: node,
                property: prop,
                computed: Boolean(index && prop.type === 'Literal'),
                optional: false
            } : prop;
        }
        (0, $4b359f2d21305e76$export$dcb8b3f0e2de7e49)(node, 'always a result');
        result = node;
    } else result = (0, $a98724244e033a5d$export$a8ff84c12d48cfa6)(name) && !/^[a-z]/.test(name) ? {
        type: 'Identifier',
        name: name
    } : {
        type: 'Literal',
        value: name
    };
    // Only literals can be passed in `components` currently.
    // No identifiers / member expressions.
    if (result.type === 'Literal') {
        const name = /** @type {keyof JSX.IntrinsicElements} */ result.value;
        return $ec6fdf630d7c0759$var$own.call(state.components, name) ? state.components[name] : name;
    }
    // Assume component.
    if (state.evaluater) return state.evaluater.evaluateExpression(result);
    $ec6fdf630d7c0759$var$crashEstree(state);
}
/**
 * @param {State} state
 * @param {Position | undefined} [place]
 * @returns {never}
 */ function $ec6fdf630d7c0759$var$crashEstree(state, place) {
    const message = new (0, $56d41ff9124ad29b$export$752e5c445fe834ef)('Cannot handle MDX estrees without `createEvaluater`', {
        ancestors: state.ancestors,
        place: place,
        ruleId: 'mdx-estree',
        source: 'hast-util-to-jsx-runtime'
    });
    message.file = state.filePath || undefined;
    message.url = $ec6fdf630d7c0759$var$docs + '#cannot-handle-mdx-estrees-without-createevaluater';
    throw message;
}
/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */ function $ec6fdf630d7c0759$var$transformStylesToCssCasing(domCasing) {
    /** @type {Style} */ const cssCasing = {};
    /** @type {string} */ let from;
    for(from in domCasing)if ($ec6fdf630d7c0759$var$own.call(domCasing, from)) cssCasing[$ec6fdf630d7c0759$var$transformStyleToCssCasing(from)] = domCasing[from];
    return cssCasing;
}
/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */ function $ec6fdf630d7c0759$var$transformStyleToCssCasing(from) {
    let to = from.replace($ec6fdf630d7c0759$var$cap, $ec6fdf630d7c0759$var$toDash);
    // Handle `ms-xxx` -> `-ms-xxx`.
    if (to.slice(0, 3) === 'ms-') to = '-' + to;
    return to;
}
/**
 * Make `$1` capitalized.
 *
 * @param {string} _
 *   Whatever.
 * @param {string} $1
 *   Single ASCII alphabetical.
 * @returns {string}
 *   Capitalized `$1`.
 */ function $ec6fdf630d7c0759$var$toCamel(_, $1) {
    return $1.toUpperCase();
}
/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */ function $ec6fdf630d7c0759$var$toDash($0) {
    return '-' + $0.toLowerCase();
}


/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */ const $f684ad365ddeacff$export$de3e062aedff083a = {
    action: [
        'form'
    ],
    cite: [
        'blockquote',
        'del',
        'ins',
        'q'
    ],
    data: [
        'object'
    ],
    formAction: [
        'button',
        'input'
    ],
    href: [
        'a',
        'area',
        'base',
        'link'
    ],
    icon: [
        'menuitem'
    ],
    itemId: null,
    manifest: [
        'html'
    ],
    ping: [
        'a',
        'area'
    ],
    poster: [
        'video'
    ],
    src: [
        'audio',
        'embed',
        'iframe',
        'img',
        'input',
        'script',
        'source',
        'track',
        'video'
    ]
};



/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {Omit<FromMarkdownOptions, 'extensions' | 'mdastExtensions'>} Options
 */ /**
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 *
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Omit<Parent, 'children' | 'type'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | null | undefined | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {undefined | void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {undefined}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Fragment | Nodes>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {(this: CompileContext) => undefined} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {(this: CompileContext, node: Nodes, token: Token, onError?: OnEnterError) => undefined} enter
 *   Enter a node.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => undefined} exit
 *   Exit a node.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 * @property {CompileData} data
 *   Info passed around; key/value store.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $0f33f907a43b9110$var$emptyOptions = {};
function $0f33f907a43b9110$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $0f33f907a43b9110$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $0f33f907a43b9110$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $0f33f907a43b9110$var$one(value, includeImageAlt, includeHtml) {
    if ($0f33f907a43b9110$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $0f33f907a43b9110$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $0f33f907a43b9110$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $0f33f907a43b9110$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $0f33f907a43b9110$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $0f33f907a43b9110$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Options} Options
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @typedef {import('micromark-util-types').Compile} Compile
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').CompileData} CompileData
 * @typedef {import('micromark-util-types').CompileOptions} CompileOptions
 * @typedef {import('micromark-util-types').Definition} Definition
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedHtmlExtension} NormalizedHtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ /// <reference lib="dom" />
/* eslint-env browser */ const $e8fe3cd7ba40f7a4$var$element = document.createElement('i');
function $e8fe3cd7ba40f7a4$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $e8fe3cd7ba40f7a4$var$element.innerHTML = characterReference;
    const char = $e8fe3cd7ba40f7a4$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    if (char.charCodeAt(char.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    return char === characterReference ? false : char;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $c8d3d024107ff2e4$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $c8d3d024107ff2e4$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $c8d3d024107ff2e4$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ 
const $43d104fa13e8ac1c$var$hasOwnProperty = {}.hasOwnProperty;
function $43d104fa13e8ac1c$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$43d104fa13e8ac1c$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 */ function $43d104fa13e8ac1c$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $43d104fa13e8ac1c$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$43d104fa13e8ac1c$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $43d104fa13e8ac1c$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {undefined}
 */ function $43d104fa13e8ac1c$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $c8d3d024107ff2e4$export$869882364835d202)(existing, 0, 0, before);
}
function $43d104fa13e8ac1c$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$43d104fa13e8ac1c$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 */ function $43d104fa13e8ac1c$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $43d104fa13e8ac1c$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $7028cca99a5b92fc$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}


const $933f8d06a2662485$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $933f8d06a2662485$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return '&' + $933f8d06a2662485$var$characterReferences[value] + ';';
    }
}


/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $38c7d92ebba1b8ee$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, ' ')// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $e8f571d11e0b8583$export$d65d6b62c24d5436 = $e8f571d11e0b8583$var$regexCheck(/[A-Za-z]/);
const $e8f571d11e0b8583$export$75c76db11865a9f4 = $e8f571d11e0b8583$var$regexCheck(/[\dA-Za-z]/);
const $e8f571d11e0b8583$export$4397998b34fe597d = $e8f571d11e0b8583$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $e8f571d11e0b8583$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $e8f571d11e0b8583$export$ca8b5b1a6c320e6e = $e8f571d11e0b8583$var$regexCheck(/\d/);
const $e8f571d11e0b8583$export$eca2752363989806 = $e8f571d11e0b8583$var$regexCheck(/[\dA-Fa-f]/);
const $e8f571d11e0b8583$export$35794a7d1db99380 = $e8f571d11e0b8583$var$regexCheck(/[!-/:-@[-`{-~]/);
function $e8f571d11e0b8583$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $e8f571d11e0b8583$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $e8f571d11e0b8583$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $e8f571d11e0b8583$export$aa04114dd888a7a0 = $e8f571d11e0b8583$var$regexCheck(/\p{P}|\p{S}/u);
const $e8f571d11e0b8583$export$a0ff789c034ffdf4 = $e8f571d11e0b8583$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $e8f571d11e0b8583$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}



function $6af31a163e4e7cd8$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $933f8d06a2662485$export$c564cdbbe6da493)($6af31a163e4e7cd8$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $6af31a163e4e7cd8$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $e8f571d11e0b8583$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $e8f571d11e0b8583$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = '\uFFFD';
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


const $2b616fa8cda39f02$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $2b616fa8cda39f02$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $2b616fa8cda39f02$var$protocolSrc = /^https?$/i;
function $2b616fa8cda39f02$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $43d104fa13e8ac1c$export$eaf8c406dfb0a620)([
        defaultHandlers
    ].concat(settings.htmlExtensions || []));
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        tightStack: tightStack,
        definitions: definitions
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        encode: encode,
        raw: raw,
        tag: tag,
        buffer: buffer,
        resume: resume,
        setData: setData,
        getData: getData
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {Array<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === 'lineEnding' || events[index][1].type === 'lineEndingBlank')) // @ts-expect-error Hush, it’s a line ending.
            lineEndingStyle = events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === 'listOrdered' || events[index][1].type === 'listUnordered') {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === 'definition') {
                if (events[index][0] === 'enter') {
                    body = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(head, body);
        head = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($2b616fa8cda39f02$var$hasOwnProperty.call(handles, kind) && handle) handle.call(Object.assign({
                sliceSerialize: result[index][2].sliceSerialize
            }, context), result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {Array<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0 // Skip open.
        ;
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case 'listItemPrefix':
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case 'linePrefix':
                    break;
                case 'lineEndingBlank':
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $933f8d06a2662485$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined // Disallow tags.
        ;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer() // We can have line endings in the resource, ignore them.
        ;
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1 // Skip current.
        ;
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $38c7d92ebba1b8ee$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $6af31a163e4e7cd8$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $2b616fa8cda39f02$var$protocolSrc) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $6af31a163e4e7cd8$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $2b616fa8cda39f02$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $38c7d92ebba1b8ee$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$2b616fa8cda39f02$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        let value = this.sliceSerialize(token);
        // @ts-expect-error `decodeNamedCharacterReference` can return false for
        // invalid named character references, but everything we’ve tokenized is
        // valid.
        value = getData('characterReferenceType') ? (0, $7028cca99a5b92fc$export$15a69557afac2c20)(value, getData('characterReferenceType') === 'characterReferenceMarkerNumeric' ? 10 : 16) : (0, $e8fe3cd7ba40f7a4$export$289b6a6320f709b4)(value);
        raw(encode(value));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $6af31a163e4e7cd8$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $2b616fa8cda39f02$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $6af31a163e4e7cd8$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ 
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $7af1a744270cb61b$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $c31059f50a6db3f3$export$a7db06668cad9adb = {
    tokenize: $c31059f50a6db3f3$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $c31059f50a6db3f3$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, contentStart, 'linePrefix');
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter('paragraph');
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter('chunkText', {
            contentType: 'text',
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit('chunkText');
            effects.exit('paragraph');
            effects.consume(code);
            return;
        }
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit('chunkText');
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $49e7152ae0d747d9$export$5a7bfc01df82fcd1 = {
    tokenize: $49e7152ae0d747d9$var$initializeDocument
};
/** @type {Construct} */ const $49e7152ae0d747d9$var$containerConstruct = {
    tokenize: $49e7152ae0d747d9$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $49e7152ae0d747d9$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === 'chunkFlow') {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $c8d3d024107ff2e4$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($49e7152ae0d747d9$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($49e7152ae0d747d9$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter('chunkFlow', {
            contentType: 'flow',
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit('chunkFlow'), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit('chunkFlow'));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {undefined}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === 'chunkFlow') {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $c8d3d024107ff2e4$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {undefined}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $49e7152ae0d747d9$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), 'linePrefix', this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $26ae689d003d7070$export$d50d28ce3ab2a612 = {
    tokenize: $26ae689d003d7070$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $26ae689d003d7070$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code) ? (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push[...newElements]` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $3817ac7f0666f5fb$export$bd596157370df26e {
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $3817ac7f0666f5fb$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $3817ac7f0666f5fb$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $3817ac7f0666f5fb$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $3817ac7f0666f5fb$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $3817ac7f0666f5fb$var$chunkedPush(this.left, removed.reverse());
        }
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $3817ac7f0666f5fb$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}


function $da108b09675e6810$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $3817ac7f0666f5fb$export$bd596157370df26e)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $da108b09675e6810$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events.get(lineIndex)[1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $c8d3d024107ff2e4$export$869882364835d202)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $da108b09675e6810$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $b12b2aaab14ba4fb$export$a7db06668cad9adb = {
    tokenize: $b12b2aaab14ba4fb$var$tokenizeContent,
    resolve: $b12b2aaab14ba4fb$var$resolveContent
};
/** @type {Construct} */ const $b12b2aaab14ba4fb$var$continuationConstruct = {
    tokenize: $b12b2aaab14ba4fb$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $b12b2aaab14ba4fb$var$resolveContent(events) {
    (0, $da108b09675e6810$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b12b2aaab14ba4fb$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) return effects.check($b12b2aaab14ba4fb$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b12b2aaab14ba4fb$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $1b955b705e19e617$export$ccc7b0636abaffc3 = {
    tokenize: $1b955b705e19e617$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $1b955b705e19e617$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $26ae689d003d7070$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $b12b2aaab14ba4fb$export$a7db06668cad9adb), afterConstruct)), 'linePrefix')));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEndingBlank');
        effects.consume(code);
        effects.exit('lineEndingBlank');
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $5e38b068071bc1e8$export$50397835cbfdbc24 = {
    resolveAll: $5e38b068071bc1e8$var$createResolver()
};
const $5e38b068071bc1e8$export$22b082955e083ec3 = $5e38b068071bc1e8$var$initializeFactory('string');
const $5e38b068071bc1e8$export$6f093cfa640b7166 = $5e38b068071bc1e8$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $5e38b068071bc1e8$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $5e38b068071bc1e8$var$createResolver(field === 'text' ? $5e38b068071bc1e8$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter('data');
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit('data');
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $5e38b068071bc1e8$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === 'data') {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== 'data') {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $5e38b068071bc1e8$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === 'lineEnding') && events[eventIndex - 1][1].type === 'data') {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? 'lineSuffix' : 'hardBreakTrailing',
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {undefined}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {undefined}
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $b616cae76e1b978b$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $b67e8dbe1123881f$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $b616cae76e1b978b$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $b67e8dbe1123881f$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $b67e8dbe1123881f$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {undefined}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : 'tokenize' in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {undefined}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $c8d3d024107ff2e4$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $b67e8dbe1123881f$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $b67e8dbe1123881f$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = '\r';
                break;
            case -4:
                value = '\n';
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? ' ' : '\t';
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = ' ';
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


var $1e8bbfb5eafa7836$exports = {};

$parcel$export($1e8bbfb5eafa7836$exports, "document", () => $1e8bbfb5eafa7836$export$5a7bfc01df82fcd1);
$parcel$export($1e8bbfb5eafa7836$exports, "contentInitial", () => $1e8bbfb5eafa7836$export$5a2181fb44b58173);
$parcel$export($1e8bbfb5eafa7836$exports, "flowInitial", () => $1e8bbfb5eafa7836$export$cf8bead395eff824);
$parcel$export($1e8bbfb5eafa7836$exports, "flow", () => $1e8bbfb5eafa7836$export$ccc7b0636abaffc3);
$parcel$export($1e8bbfb5eafa7836$exports, "string", () => $1e8bbfb5eafa7836$export$22b082955e083ec3);
$parcel$export($1e8bbfb5eafa7836$exports, "text", () => $1e8bbfb5eafa7836$export$6f093cfa640b7166);
$parcel$export($1e8bbfb5eafa7836$exports, "insideSpan", () => $1e8bbfb5eafa7836$export$d44f260a3f9b69f5);
$parcel$export($1e8bbfb5eafa7836$exports, "attentionMarkers", () => $1e8bbfb5eafa7836$export$b9c0b60d74426aea);
$parcel$export($1e8bbfb5eafa7836$exports, "disable", () => $1e8bbfb5eafa7836$export$e20fbacbb41798b);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $80fdb4ed4b12a0e2$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code) || (0, $e8f571d11e0b8583$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $e8f571d11e0b8583$export$aa04114dd888a7a0)(code)) return 2;
}



const $ffbc4fc42949a30f$export$45b92471da762af7 = {
    name: 'attention',
    tokenize: $ffbc4fc42949a30f$var$tokenizeAttention,
    resolveAll: $ffbc4fc42949a30f$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $ffbc4fc42949a30f$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $ffbc4fc42949a30f$var$movePoint(start, -use);
            $ffbc4fc42949a30f$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(nextEvents, (0, $b616cae76e1b978b$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $c8d3d024107ff2e4$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ffbc4fc42949a30f$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $80fdb4ed4b12a0e2$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $80fdb4ed4b12a0e2$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {undefined}
 */ function $ffbc4fc42949a30f$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $ce7bccfadb18e36f$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $ce7bccfadb18e36f$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ce7bccfadb18e36f$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $e8f571d11e0b8583$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $e8f571d11e0b8583$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $e8f571d11e0b8583$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $e8f571d11e0b8583$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $e8f571d11e0b8583$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $e8f571d11e0b8583$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $e8f571d11e0b8583$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $1f978c0ae11a13af$export$200dcd0a5903c968 = {
    name: 'blockQuote',
    tokenize: $1f978c0ae11a13af$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $1f978c0ae11a13af$var$tokenizeBlockQuoteContinuation
    },
    exit: $1f978c0ae11a13af$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1f978c0ae11a13af$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1f978c0ae11a13af$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($1f978c0ae11a13af$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $1f978c0ae11a13af$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $a058ec21d21d620d$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $a058ec21d21d620d$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a058ec21d21d620d$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $e8f571d11e0b8583$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $ed0ae7fdd2ec1ee4$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $ed0ae7fdd2ec1ee4$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ed0ae7fdd2ec1ee4$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $e8f571d11e0b8583$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $e8f571d11e0b8583$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $e8f571d11e0b8583$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $e8f571d11e0b8583$export$75c76db11865a9f4) && !(0, $e8fe3cd7ba40f7a4$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $c156a0b3dd980e08$var$nonLazyContinuation = {
    tokenize: $c156a0b3dd980e08$var$tokenizeNonLazyContinuation,
    partial: true
};
const $c156a0b3dd980e08$export$c23e4921f8d87e7c = {
    name: 'codeFenced',
    tokenize: $c156a0b3dd980e08$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c156a0b3dd980e08$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code) ? (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($c156a0b3dd980e08$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code) ? (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) return effects.check($c156a0b3dd980e08$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code) ? (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code) ? (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c156a0b3dd980e08$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $c742f651d164b107$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $c742f651d164b107$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $c742f651d164b107$var$furtherStart = {
    tokenize: $c742f651d164b107$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c742f651d164b107$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) return effects.attempt($c742f651d164b107$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c742f651d164b107$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $b7575c4fc4adac7c$export$d24f93e715f9df88 = {
    name: 'codeText',
    tokenize: $b7575c4fc4adac7c$var$tokenizeCodeText,
    resolve: $b7575c4fc4adac7c$var$resolveCodeText,
    previous: $b7575c4fc4adac7c$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $b7575c4fc4adac7c$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $b7575c4fc4adac7c$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b7575c4fc4adac7c$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $74964c3699cb7ee9$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $e8f571d11e0b8583$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit('chunkString');
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code))) {
            effects.exit('chunkString');
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $e8f571d11e0b8583$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $eca5ed6d16e229fc$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return atBreak;
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit('chunkString');
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $4247cc94daff8255$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, atBreak, 'linePrefix');
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit('chunkString');
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $c8b1bc373c858933$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            seen = true;
            return start;
        }
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, start, seen ? 'linePrefix' : 'lineSuffix')(code);
        return ok(code);
    }
}




const $bace95c84c615890$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $bace95c84c615890$var$tokenizeDefinition
};
/** @type {Construct} */ const $bace95c84c615890$var$titleBefore = {
    tokenize: $bace95c84c615890$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $bace95c84c615890$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $eca5ed6d16e229fc$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $38c7d92ebba1b8ee$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code) ? (0, $c8b1bc373c858933$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $74964c3699cb7ee9$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($bace95c84c615890$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code) ? (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $bace95c84c615890$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code) ? (0, $c8b1bc373c858933$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $4247cc94daff8255$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code) ? (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $730820230ad45896$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $730820230ad45896$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $730820230ad45896$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $6de50aee395a4dea$export$3871e9deb360695c = {
    name: 'headingAtx',
    tokenize: $6de50aee395a4dea$var$tokenizeHeadingAtx,
    resolve: $6de50aee395a4dea$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $6de50aee395a4dea$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $c8d3d024107ff2e4$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6de50aee395a4dea$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $e09d70d0d885363c$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $e09d70d0d885363c$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $2edf8b4b7bf8a015$export$476ac411cb7d0d8f = {
    name: 'htmlFlow',
    tokenize: $2edf8b4b7bf8a015$var$tokenizeHtmlFlow,
    resolveTo: $2edf8b4b7bf8a015$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $2edf8b4b7bf8a015$var$blankLineBefore = {
    tokenize: $2edf8b4b7bf8a015$var$tokenizeBlankLineBefore,
    partial: true
};
const $2edf8b4b7bf8a015$var$nonLazyContinuationStart = {
    tokenize: $2edf8b4b7bf8a015$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $2edf8b4b7bf8a015$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2edf8b4b7bf8a015$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $e8f571d11e0b8583$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $e8f571d11e0b8583$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $e8f571d11e0b8583$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $e09d70d0d885363c$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $e09d70d0d885363c$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $e8f571d11e0b8583$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $e8f571d11e0b8583$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $e8f571d11e0b8583$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($2edf8b4b7bf8a015$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($2edf8b4b7bf8a015$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $e09d70d0d885363c$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $e8f571d11e0b8583$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2edf8b4b7bf8a015$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2edf8b4b7bf8a015$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $26ae689d003d7070$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $369249e9c823ff58$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $369249e9c823ff58$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $369249e9c823ff58$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $e8f571d11e0b8583$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $e8f571d11e0b8583$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $e8f571d11e0b8583$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $e8f571d11e0b8583$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $e8f571d11e0b8583$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $e8f571d11e0b8583$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $e8f571d11e0b8583$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code) ? (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $987199b9fdc68f00$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    tokenize: $987199b9fdc68f00$var$tokenizeLabelEnd,
    resolveTo: $987199b9fdc68f00$var$resolveToLabelEnd,
    resolveAll: $987199b9fdc68f00$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $987199b9fdc68f00$var$resourceConstruct = {
    tokenize: $987199b9fdc68f00$var$tokenizeResource
};
/** @type {Construct} */ const $987199b9fdc68f00$var$referenceFullConstruct = {
    tokenize: $987199b9fdc68f00$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $987199b9fdc68f00$var$referenceCollapsedConstruct = {
    tokenize: $987199b9fdc68f00$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $987199b9fdc68f00$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $987199b9fdc68f00$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(media, (0, $b616cae76e1b978b$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $c8d3d024107ff2e4$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $c8d3d024107ff2e4$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $987199b9fdc68f00$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $38c7d92ebba1b8ee$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($987199b9fdc68f00$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($987199b9fdc68f00$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($987199b9fdc68f00$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $987199b9fdc68f00$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code) ? (0, $c8b1bc373c858933$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $74964c3699cb7ee9$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code) ? (0, $c8b1bc373c858933$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $4247cc94daff8255$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $e8f571d11e0b8583$export$a30284361b3814b7)(code) ? (0, $c8b1bc373c858933$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $987199b9fdc68f00$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $eca5ed6d16e229fc$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $38c7d92ebba1b8ee$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $987199b9fdc68f00$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $bb0be7854a2a81b0$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    tokenize: $bb0be7854a2a81b0$var$tokenizeLabelStartImage,
    resolveAll: (0, $987199b9fdc68f00$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $bb0be7854a2a81b0$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $c8746c51d9028da2$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    tokenize: $c8746c51d9028da2$var$tokenizeLabelStartLink,
    resolveAll: (0, $987199b9fdc68f00$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c8746c51d9028da2$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $a681fcf474700f14$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $a681fcf474700f14$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a681fcf474700f14$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $747e5d4bbc55af63$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $747e5d4bbc55af63$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $747e5d4bbc55af63$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code) ? (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $003dcafe8f748848$export$8837f4fc672e936d = {
    name: 'list',
    tokenize: $003dcafe8f748848$var$tokenizeListStart,
    continuation: {
        tokenize: $003dcafe8f748848$var$tokenizeListContinuation
    },
    exit: $003dcafe8f748848$var$tokenizeListEnd
};
/** @type {Construct} */ const $003dcafe8f748848$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $003dcafe8f748848$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $003dcafe8f748848$var$indentConstruct = {
    tokenize: $003dcafe8f748848$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $003dcafe8f748848$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $e8f571d11e0b8583$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $747e5d4bbc55af63$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $e8f571d11e0b8583$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $26ae689d003d7070$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($003dcafe8f748848$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $003dcafe8f748848$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $26ae689d003d7070$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($003dcafe8f748848$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, effects.attempt($003dcafe8f748848$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $003dcafe8f748848$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $003dcafe8f748848$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $003dcafe8f748848$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $8988dab5409ab81d$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    tokenize: $8988dab5409ab81d$var$tokenizeSetextUnderline,
    resolveTo: $8988dab5409ab81d$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $8988dab5409ab81d$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8988dab5409ab81d$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $e8f571d11e0b8583$export$2c6cf65c1127992a)(code) ? (0, $7af1a744270cb61b$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $e8f571d11e0b8583$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $1e8bbfb5eafa7836$export$5a7bfc01df82fcd1 = {
    [42]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [43]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [45]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [48]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [49]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [50]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [51]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [52]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [53]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [54]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [55]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [56]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [57]: (0, $003dcafe8f748848$export$8837f4fc672e936d),
    [62]: (0, $1f978c0ae11a13af$export$200dcd0a5903c968)
};
const $1e8bbfb5eafa7836$export$5a2181fb44b58173 = {
    [91]: (0, $bace95c84c615890$export$69f215ed977cdb73)
};
const $1e8bbfb5eafa7836$export$cf8bead395eff824 = {
    [-2]: (0, $c742f651d164b107$export$47910b7ab28d1853),
    [-1]: (0, $c742f651d164b107$export$47910b7ab28d1853),
    [32]: (0, $c742f651d164b107$export$47910b7ab28d1853)
};
const $1e8bbfb5eafa7836$export$ccc7b0636abaffc3 = {
    [35]: (0, $6de50aee395a4dea$export$3871e9deb360695c),
    [42]: (0, $747e5d4bbc55af63$export$ba7b13e047416c03),
    [45]: [
        (0, $8988dab5409ab81d$export$e104e2de391dfde9),
        (0, $747e5d4bbc55af63$export$ba7b13e047416c03)
    ],
    [60]: (0, $2edf8b4b7bf8a015$export$476ac411cb7d0d8f),
    [61]: (0, $8988dab5409ab81d$export$e104e2de391dfde9),
    [95]: (0, $747e5d4bbc55af63$export$ba7b13e047416c03),
    [96]: (0, $c156a0b3dd980e08$export$c23e4921f8d87e7c),
    [126]: (0, $c156a0b3dd980e08$export$c23e4921f8d87e7c)
};
const $1e8bbfb5eafa7836$export$22b082955e083ec3 = {
    [38]: (0, $ed0ae7fdd2ec1ee4$export$e31905600aaf3d8e),
    [92]: (0, $a058ec21d21d620d$export$2005478564e78d96)
};
const $1e8bbfb5eafa7836$export$6f093cfa640b7166 = {
    [-5]: (0, $a681fcf474700f14$export$8e62e0ad51c97b2),
    [-4]: (0, $a681fcf474700f14$export$8e62e0ad51c97b2),
    [-3]: (0, $a681fcf474700f14$export$8e62e0ad51c97b2),
    [33]: (0, $bb0be7854a2a81b0$export$3d754936e25aa5f5),
    [38]: (0, $ed0ae7fdd2ec1ee4$export$e31905600aaf3d8e),
    [42]: (0, $ffbc4fc42949a30f$export$45b92471da762af7),
    [60]: [
        (0, $ce7bccfadb18e36f$export$17ddf85e4c916ad6),
        (0, $369249e9c823ff58$export$398af27f284914fe)
    ],
    [91]: (0, $c8746c51d9028da2$export$5c0cee0701a3b584),
    [92]: [
        (0, $730820230ad45896$export$86c573ab9e06f418),
        (0, $a058ec21d21d620d$export$2005478564e78d96)
    ],
    [93]: (0, $987199b9fdc68f00$export$470a5dafbbf62654),
    [95]: (0, $ffbc4fc42949a30f$export$45b92471da762af7),
    [96]: (0, $b7575c4fc4adac7c$export$d24f93e715f9df88)
};
const $1e8bbfb5eafa7836$export$d44f260a3f9b69f5 = {
    null: [
        (0, $ffbc4fc42949a30f$export$45b92471da762af7),
        (0, $5e38b068071bc1e8$export$50397835cbfdbc24)
    ]
};
const $1e8bbfb5eafa7836$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $1e8bbfb5eafa7836$export$e20fbacbb41798b = {
    null: []
};


function $1471322b604c820c$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $43d104fa13e8ac1c$export$86a865d89ef3c690)([
        $1e8bbfb5eafa7836$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $c31059f50a6db3f3$export$a7db06668cad9adb)),
        document: create((0, $49e7152ae0d747d9$export$5a7bfc01df82fcd1)),
        flow: create((0, $1b955b705e19e617$export$ccc7b0636abaffc3)),
        string: create((0, $5e38b068071bc1e8$export$22b082955e083ec3)),
        text: create((0, $5e38b068071bc1e8$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $b67e8dbe1123881f$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $bf3b6916322db573$export$bd0e6e1378a871d7(events) {
    while(!(0, $da108b09675e6810$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $11f787b32da0d8ba$var$search = /[\0\t\n\r]/g;
function $11f787b32da0d8ba$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $11f787b32da0d8ba$var$search.lastIndex = startPosition;
            match = $11f787b32da0d8ba$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $ebb7d2331cdd2359$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $2b616fa8cda39f02$export$ef7acd7185315e22)(options)((0, $bf3b6916322db573$export$bd0e6e1378a871d7)((0, $1471322b604c820c$export$98e6a39c04603d36)(options).document().write((0, $11f787b32da0d8ba$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





const $094e8276d12cdaab$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $094e8276d12cdaab$export$a0fb664af7d0cc44(value) {
    return value.replace($094e8276d12cdaab$var$characterEscapeOrReference, $094e8276d12cdaab$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $094e8276d12cdaab$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $7028cca99a5b92fc$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $e8fe3cd7ba40f7a4$export$289b6a6320f709b4)($2) || $0;
}





const $fde01048fd8d29af$var$own = {}.hasOwnProperty;
function $fde01048fd8d29af$export$d744d789c09bfde6(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return $fde01048fd8d29af$var$compiler(options)((0, $bf3b6916322db573$export$bd0e6e1378a871d7)((0, $1471322b604c820c$export$98e6a39c04603d36)(options).document().write((0, $11f787b32da0d8ba$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $fde01048fd8d29af$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $fde01048fd8d29af$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === 'listOrdered' || events[index][1].type === 'listUnordered') {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($fde01048fd8d29af$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $fde01048fd8d29af$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $fde01048fd8d29af$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $fde01048fd8d29af$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case 'listUnordered':
                case 'listOrdered':
                case 'blockQuote':
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case 'lineEndingBlank':
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case 'linePrefix':
                case 'listItemValue':
                case 'listItemMarker':
                case 'listItemPrefix':
                case 'listItemPrefixWhitespace':
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === 'listItemPrefix' || containerBalance === -1 && event[0] === 'exit' && (event[1].type === 'listUnordered' || event[1].type === 'listOrdered')) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === 'lineEnding' || tailEvent[1].type === 'lineEndingBlank') {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = 'lineEndingBlank';
                                listSpread = true;
                            }
                            tailEvent[1].type = 'lineEnding';
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === 'linePrefix' || tailEvent[1].type === 'blockQuotePrefix' || tailEvent[1].type === 'blockQuotePrefixWhitespace' || tailEvent[1].type === 'blockQuoteMarker' || tailEvent[1].type === 'listItemIndent') ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === 'listItemPrefix') {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {undefined}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Nodes} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {undefined}
   *   Nothing.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        node.position = {
            start: $fde01048fd8d29af$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {undefined}
   *   Nothing.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $6835c4f72960a9e7$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $fde01048fd8d29af$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $fde01048fd8d29af$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $0f33f907a43b9110$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $38c7d92ebba1b8ee$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $fde01048fd8d29af$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $fde01048fd8d29af$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $fde01048fd8d29af$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $094e8276d12cdaab$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $38c7d92ebba1b8ee$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $38c7d92ebba1b8ee$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $7028cca99a5b92fc$export$15a69557afac2c20)(data, type === 'characterReferenceMarkerNumeric' ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $e8fe3cd7ba40f7a4$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $fde01048fd8d29af$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $fde01048fd8d29af$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $fde01048fd8d29af$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $fde01048fd8d29af$var$configure(combined, value);
        else $fde01048fd8d29af$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $fde01048fd8d29af$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($fde01048fd8d29af$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $fde01048fd8d29af$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $6835c4f72960a9e7$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $6835c4f72960a9e7$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $6835c4f72960a9e7$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


function $823c0a06540af4f9$export$2e2bcd8739ae039(options) {
    /** @type {Processor} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    self.parser = parser;
    /**
   * @type {Parser}
   */ function parser(doc) {
        return (0, $fde01048fd8d29af$export$d744d789c09bfde6)(doc, {
            ...self.data('settings'),
            ...options,
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data('micromarkExtensions') || [],
            mdastExtensions: self.data('fromMarkdownExtensions') || []
        });
    }
}


// Include `data` fields in mdast and `raw` nodes in hast.
/// <reference types="mdast-util-to-hast" />
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} ToHastOptions
 * @typedef {import('unified').Processor} Processor
 * @typedef {import('vfile').VFile} VFile
 */ /**
 * @typedef {Omit<ToHastOptions, 'file'>} Options
 *
 * @callback TransformBridge
 *   Bridge-mode.
 *
 *   Runs the destination with the new hast tree.
 *   Discards result.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {Promise<undefined>}
 *   Nothing.
 *
 * @callback TransformMutate
 *  Mutate-mode.
 *
 *  Further transformers run on the hast tree.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {HastRoot}
 *   Tree (hast).
 */ /**
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('./state.js').Options} Options
 */ 
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @callback FootnoteBackContentTemplate
 *   Generate content for the backreference dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent> | ElementContent | string}
 *   Content for the backreference when linking back from definitions to their
 *   reference.
 *
 * @callback FootnoteBackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ const $5533fc299fb5918b$export$1cd1943b3a73bbe8 = -1;
const $5533fc299fb5918b$export$a44b4f3d5b73db95 = 0;
const $5533fc299fb5918b$export$b119f07080a207ba = 1;
const $5533fc299fb5918b$export$8b8a958a7f6f130c = 2;
const $5533fc299fb5918b$export$501a7fac1df67a49 = 3;
const $5533fc299fb5918b$export$cd2b220b1ea851b2 = 4;
const $5533fc299fb5918b$export$ce970371e0e850bc = 5;
const $5533fc299fb5918b$export$5e8f180ef0142226 = 6;
const $5533fc299fb5918b$export$103bedf43ba882db = 7;
const $5533fc299fb5918b$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;


const $99e98a5a362e7635$var$env = typeof self === 'object' ? self : globalThis;
const $99e98a5a362e7635$var$deserializer = ($, _)=>{
    const as = (out, index)=>{
        $.set(index, out);
        return out;
    };
    const unpair = (index)=>{
        if ($.has(index)) return $.get(index);
        const [type, value] = _[index];
        switch(type){
            case 0, $5533fc299fb5918b$export$a44b4f3d5b73db95:
            case 0, $5533fc299fb5918b$export$1cd1943b3a73bbe8:
                return as(value, index);
            case 0, $5533fc299fb5918b$export$b119f07080a207ba:
                {
                    const arr = as([], index);
                    for (const index of value)arr.push(unpair(index));
                    return arr;
                }
            case 0, $5533fc299fb5918b$export$8b8a958a7f6f130c:
                {
                    const object = as({}, index);
                    for (const [key, index] of value)object[unpair(key)] = unpair(index);
                    return object;
                }
            case 0, $5533fc299fb5918b$export$501a7fac1df67a49:
                return as(new Date(value), index);
            case 0, $5533fc299fb5918b$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $5533fc299fb5918b$export$ce970371e0e850bc:
                {
                    const map = as(new Map, index);
                    for (const [key, index] of value)map.set(unpair(key), unpair(index));
                    return map;
                }
            case 0, $5533fc299fb5918b$export$5e8f180ef0142226:
                {
                    const set = as(new Set, index);
                    for (const index of value)set.add(unpair(index));
                    return set;
                }
            case 0, $5533fc299fb5918b$export$103bedf43ba882db:
                {
                    const { name: name, message: message } = value;
                    return as(new $99e98a5a362e7635$var$env[name](message), index);
                }
            case 0, $5533fc299fb5918b$export$9f2207c8fceeefa8:
                return as(BigInt(value), index);
            case 'BigInt':
                return as(Object(BigInt(value)), index);
        }
        return as(new $99e98a5a362e7635$var$env[type](value), index);
    };
    return unpair;
};
const $99e98a5a362e7635$export$efcd34ab6248d3cd = (serialized)=>$99e98a5a362e7635$var$deserializer(new Map, serialized)(0);



const $d4f941656de272ea$var$EMPTY = '';
const { toString: $d4f941656de272ea$var$toString } = {};
const { keys: $d4f941656de272ea$var$keys } = Object;
const $d4f941656de272ea$var$typeOf = (value)=>{
    const type = typeof value;
    if (type !== 'object' || !value) return [
        (0, $5533fc299fb5918b$export$a44b4f3d5b73db95),
        type
    ];
    const asString = $d4f941656de272ea$var$toString.call(value).slice(8, -1);
    switch(asString){
        case 'Array':
            return [
                (0, $5533fc299fb5918b$export$b119f07080a207ba),
                $d4f941656de272ea$var$EMPTY
            ];
        case 'Object':
            return [
                (0, $5533fc299fb5918b$export$8b8a958a7f6f130c),
                $d4f941656de272ea$var$EMPTY
            ];
        case 'Date':
            return [
                (0, $5533fc299fb5918b$export$501a7fac1df67a49),
                $d4f941656de272ea$var$EMPTY
            ];
        case 'RegExp':
            return [
                (0, $5533fc299fb5918b$export$cd2b220b1ea851b2),
                $d4f941656de272ea$var$EMPTY
            ];
        case 'Map':
            return [
                (0, $5533fc299fb5918b$export$ce970371e0e850bc),
                $d4f941656de272ea$var$EMPTY
            ];
        case 'Set':
            return [
                (0, $5533fc299fb5918b$export$5e8f180ef0142226),
                $d4f941656de272ea$var$EMPTY
            ];
    }
    if (asString.includes('Array')) return [
        (0, $5533fc299fb5918b$export$b119f07080a207ba),
        asString
    ];
    if (asString.includes('Error')) return [
        (0, $5533fc299fb5918b$export$103bedf43ba882db),
        asString
    ];
    return [
        (0, $5533fc299fb5918b$export$8b8a958a7f6f130c),
        asString
    ];
};
const $d4f941656de272ea$var$shouldSkip = ([TYPE, type])=>TYPE === (0, $5533fc299fb5918b$export$a44b4f3d5b73db95) && (type === 'function' || type === 'symbol');
const $d4f941656de272ea$var$serializer = (strict, json, $, _)=>{
    const as = (out, value)=>{
        const index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    const pair = (value)=>{
        if ($.has(value)) return $.get(value);
        let [TYPE, type] = $d4f941656de272ea$var$typeOf(value);
        switch(TYPE){
            case 0, $5533fc299fb5918b$export$a44b4f3d5b73db95:
                {
                    let entry = value;
                    switch(type){
                        case 'bigint':
                            TYPE = (0, $5533fc299fb5918b$export$9f2207c8fceeefa8);
                            entry = value.toString();
                            break;
                        case 'function':
                        case 'symbol':
                            if (strict) throw new TypeError('unable to serialize ' + type);
                            entry = null;
                            break;
                        case 'undefined':
                            return as([
                                (0, $5533fc299fb5918b$export$1cd1943b3a73bbe8)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $5533fc299fb5918b$export$b119f07080a207ba:
                {
                    if (type) return as([
                        type,
                        [
                            ...value
                        ]
                    ], value);
                    const arr = [];
                    const index = as([
                        TYPE,
                        arr
                    ], value);
                    for (const entry of value)arr.push(pair(entry));
                    return index;
                }
            case 0, $5533fc299fb5918b$export$8b8a958a7f6f130c:
                {
                    if (type) switch(type){
                        case 'BigInt':
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case 'Boolean':
                        case 'Number':
                        case 'String':
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && 'toJSON' in value) return pair(value.toJSON());
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const key of $d4f941656de272ea$var$keys(value))if (strict || !$d4f941656de272ea$var$shouldSkip($d4f941656de272ea$var$typeOf(value[key]))) entries.push([
                        pair(key),
                        pair(value[key])
                    ]);
                    return index;
                }
            case 0, $5533fc299fb5918b$export$501a7fac1df67a49:
                return as([
                    TYPE,
                    value.toISOString()
                ], value);
            case 0, $5533fc299fb5918b$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $5533fc299fb5918b$export$ce970371e0e850bc:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const [key, entry] of value)if (strict || !($d4f941656de272ea$var$shouldSkip($d4f941656de272ea$var$typeOf(key)) || $d4f941656de272ea$var$shouldSkip($d4f941656de272ea$var$typeOf(entry)))) entries.push([
                        pair(key),
                        pair(entry)
                    ]);
                    return index;
                }
            case 0, $5533fc299fb5918b$export$5e8f180ef0142226:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const entry of value)if (strict || !$d4f941656de272ea$var$shouldSkip($d4f941656de272ea$var$typeOf(entry))) entries.push(pair(entry));
                    return index;
                }
        }
        const { message: message } = value;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
const $d4f941656de272ea$export$dfdc1655ccc5b9cb = (value, { json: json, lossy: lossy } = {})=>{
    const _ = [];
    return $d4f941656de272ea$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};


var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $d4cac1dceaae6077$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ (any, options)=>options && ('json' in options || 'lossy' in options) ? (0, $99e98a5a362e7635$export$efcd34ab6248d3cd)((0, $d4f941656de272ea$export$dfdc1655ccc5b9cb)(any, options)) : structuredClone(any) : (any, options)=>(0, $99e98a5a362e7635$export$efcd34ab6248d3cd)((0, $d4f941656de272ea$export$dfdc1655ccc5b9cb)(any, options));



function $e33fc7790570e365$export$4a6e1c4b9e5bc5d1(_, rereferenceIndex) {
    /** @type {Array<ElementContent>} */ const result = [
        {
            type: 'text',
            value: "\u21A9"
        }
    ];
    if (rereferenceIndex > 1) result.push({
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            {
                type: 'text',
                value: String(rereferenceIndex)
            }
        ]
    });
    return result;
}
function $e33fc7790570e365$export$d83e66a407212d3b(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $e33fc7790570e365$export$adb608be33961c98(state) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const footnoteBackContent = state.options.footnoteBackContent || $e33fc7790570e365$export$4a6e1c4b9e5bc5d1;
    const footnoteBackLabel = state.options.footnoteBackLabel || $e33fc7790570e365$export$d83e66a407212d3b;
    const footnoteLabel = state.options.footnoteLabel || 'Footnotes';
    const footnoteLabelTagName = state.options.footnoteLabelTagName || 'h2';
    const footnoteLabelProperties = state.options.footnoteLabelProperties || {
        className: [
            'sr-only'
        ]
    };
    /** @type {Array<ElementContent>} */ const listItems = [];
    let referenceIndex = -1;
    while(++referenceIndex < state.footnoteOrder.length){
        const def = state.footnoteById.get(state.footnoteOrder[referenceIndex]);
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $6af31a163e4e7cd8$export$e42a3e39590d28b5)(id.toLowerCase());
        let rereferenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        const counts = state.footnoteCounts.get(id);
        // eslint-disable-next-line no-unmodified-loop-condition
        while(counts !== undefined && ++rereferenceIndex <= counts){
            if (backReferences.length > 0) backReferences.push({
                type: 'text',
                value: ' '
            });
            let children = typeof footnoteBackContent === 'string' ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
            if (typeof children === 'string') children = {
                type: 'text',
                value: children
            };
            backReferences.push({
                type: 'element',
                tagName: 'a',
                properties: {
                    href: '#' + clobberPrefix + 'fnref-' + safeId + (rereferenceIndex > 1 ? '-' + rereferenceIndex : ''),
                    dataFootnoteBackref: '',
                    ariaLabel: typeof footnoteBackLabel === 'string' ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
                    className: [
                        'data-footnote-backref'
                    ]
                },
                children: Array.isArray(children) ? children : [
                    children
                ]
            });
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === 'element' && tail.tagName === 'p') {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === 'text') tailTail.value += ' ';
            else tail.children.push({
                type: 'text',
                value: ' '
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: 'element',
            tagName: 'li',
            properties: {
                id: clobberPrefix + 'fn-' + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: 'element',
        tagName: 'section',
        properties: {
            dataFootnotes: true,
            className: [
                'footnotes'
            ]
        },
        children: [
            {
                type: 'element',
                tagName: footnoteLabelTagName,
                properties: {
                    ...(0, $d4cac1dceaae6077$export$2e2bcd8739ae039)(footnoteLabelProperties),
                    id: 'footnote-label'
                },
                children: [
                    {
                        type: 'text',
                        value: footnoteLabel
                    }
                ]
            },
            {
                type: 'text',
                value: '\n'
            },
            {
                type: 'element',
                tagName: 'ol',
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: 'text',
                value: '\n'
            }
        ]
    };
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').RootContent} HastRootContent
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('mdast').Parents} MdastParents
 *
 * @typedef {import('vfile').VFile} VFile
 *
 * @typedef {import('./footer.js').FootnoteBackContentTemplate} FootnoteBackContentTemplate
 * @typedef {import('./footer.js').FootnoteBackLabelTemplate} FootnoteBackLabelTemplate
 */ /**
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | undefined} parent
 *   Parent of `node`.
 * @returns {Array<HastElementContent> | HastElementContent | undefined}
 *   hast node.
 *
 * @typedef {Partial<Record<MdastNodes['type'], Handler>>} Handlers
 *   Handle nodes.
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree (default:
 *   `false`).
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` property on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {VFile | null | undefined} [file]
 *   Corresponding virtual file representing the input document (optional).
 * @property {FootnoteBackContentTemplate | string | null | undefined} [footnoteBackContent]
 *   Content of the backreference back to references (default: `defaultFootnoteBackContent`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackContent(_, rereferenceIndex) {
 *     const result = [{type: 'text', value: '↩'}]
 *
 *     if (rereferenceIndex > 1) {
 *       result.push({
 *         type: 'element',
 *         tagName: 'sup',
 *         properties: {},
 *         children: [{type: 'text', value: String(rereferenceIndex)}]
 *       })
 *     }
 *
 *     return result
 *   }
 *   ```
 *
 *   This content is used in the `a` element of each backreference (the `↩`
 *   links).
 * @property {FootnoteBackLabelTemplate | string | null | undefined} [footnoteBackLabel]
 *   Label to describe the backreference back to references (default:
 *   `defaultFootnoteBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *   }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `ariaLabel` property on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (default: `{className:
 *   ['sr-only']}`).
 *
 *   Change it to show the label and add other properties.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different properties.
 *
 *   > 👉 **Note**: `id: 'footnote-label'` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes (optional).
 * @property {Array<MdastNodes['type']> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed)
 *   (optional).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes (optional).
 *
 * @typedef State
 *   Info passed around.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => HastElement | Type} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {Map<string, MdastDefinition>} definitionById
 *   Definitions by their identifier.
 * @property {Map<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Map<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {(node: MdastNodes, parent: MdastParents | undefined) => Array<HastElementContent> | HastElementContent | undefined} one
 *   Transform an mdast node to hast.
 * @property {Options} options
 *   Configuration.
 * @property {(from: MdastNodes, node: HastNodes) => undefined} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastRootContent>(nodes: Array<Type>, loose?: boolean | undefined) => Array<HastText | Type>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 */ 
/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $d6b631d9f632cdf5$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $d6b631d9f632cdf5$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$d6b631d9f632cdf5$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $d6b631d9f632cdf5$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $d6b631d9f632cdf5$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $d6b631d9f632cdf5$var$ok;
    if (typeof test === 'function') return $d6b631d9f632cdf5$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $d6b631d9f632cdf5$var$anyFactory(test) : $d6b631d9f632cdf5$var$propsFactory(test);
    if (typeof test === 'string') return $d6b631d9f632cdf5$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $d6b631d9f632cdf5$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $d6b631d9f632cdf5$export$9c68d69a4c5bbcf9(tests[index]);
    return $d6b631d9f632cdf5$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $d6b631d9f632cdf5$var$propsFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $d6b631d9f632cdf5$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $d6b631d9f632cdf5$var$typeFactory(check) {
    return $d6b631d9f632cdf5$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $d6b631d9f632cdf5$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($d6b631d9f632cdf5$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $d6b631d9f632cdf5$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $d6b631d9f632cdf5$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $f67a3e7f3b75c199$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $803085b83f77b413$var$empty = [];
const $803085b83f77b413$export$f4d8133c446fe484 = true;
const $803085b83f77b413$export$7f100f842f565dc9 = false;
const $803085b83f77b413$export$8773f85c2fb2c116 = 'skip';
function $803085b83f77b413$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $d6b631d9f632cdf5$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $f67a3e7f3b75c199$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $803085b83f77b413$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $803085b83f77b413$var$toResult(visitor(node, parents));
                if (result[0] === $803085b83f77b413$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $803085b83f77b413$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $803085b83f77b413$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $803085b83f77b413$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $803085b83f77b413$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $803085b83f77b413$var$empty : [
        value
    ];
}


function $d035daec8fd9ba8d$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $803085b83f77b413$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $d36e6319d2875fd8$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'blockquote',
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $4c8709fd49d18a29$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'br',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: 'text',
            value: '\n'
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $eb70ac1a94961808$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + '\n' : '';
    /** @type {Properties} */ const properties = {};
    if (node.lang) properties.className = [
        'language-' + node.lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: 'element',
        tagName: 'code',
        properties: properties,
        children: [
            {
                type: 'text',
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: 'element',
        tagName: 'pre',
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $1aba28bb26d57ec9$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'del',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $1c469128cb20ed5d$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'em',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../state.js').State} State
 */ 
function $47e86e60c74c44a0$export$7f87ee744075c1ba(state, node) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $6af31a163e4e7cd8$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    let reuseCounter = state.footnoteCounts.get(id);
    if (reuseCounter === undefined) {
        reuseCounter = 0;
        state.footnoteOrder.push(id);
        counter = state.footnoteOrder.length;
    } else counter = index + 1;
    reuseCounter += 1;
    state.footnoteCounts.set(id, reuseCounter);
    /** @type {Element} */ const link = {
        type: 'element',
        tagName: 'a',
        properties: {
            href: '#' + clobberPrefix + 'fn-' + safeId,
            id: clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : ''),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                'footnote-label'
            ]
        },
        children: [
            {
                type: 'text',
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $ab09ca25fc2a6d7c$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'h' + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Html} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ // Make VS Code show references to the above types.
'';
function $523e8ee2ebbbf9bb$export$c0bb0b647f701bb5(state, node) {
    if (state.options.allowDangerousHtml) {
        /** @type {Raw} */ const result = {
            type: 'raw',
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    return undefined;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Reference} Reference
 *
 * @typedef {import('./state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $8d056f5901dd4c0f$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = ']';
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return [
        {
            type: 'text',
            value: '![' + node.alt + suffix
        }
    ];
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift({
        type: 'text',
        value: '['
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push({
        type: 'text',
        value: suffix
    });
    return contents;
}


function $e95258b5b5f23a7d$export$f281796f6bc3b8db(state, node) {
    const id = String(node.identifier).toUpperCase();
    const def = state.definitionById.get(id);
    if (!def) return (0, $8d056f5901dd4c0f$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $6af31a163e4e7cd8$export$e42a3e39590d28b5)(def.url || ''),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $87bdb8055410bb48$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $6af31a163e4e7cd8$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $39dab6d63d746b7a$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: 'text',
        value: node.value.replace(/\r?\n|\r/g, ' ')
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'code',
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $942c142d68171a3e$export$e6c469b1b7b2bc6a(state, node) {
    const id = String(node.identifier).toUpperCase();
    const def = state.definitionById.get(id);
    if (!def) return (0, $8d056f5901dd4c0f$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $6af31a163e4e7cd8$export$e42a3e39590d28b5)(def.url || '')
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $1b252c656fe19c0f$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $6af31a163e4e7cd8$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $7daadc7693b66aa6$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $7daadc7693b66aa6$var$listLoose(parent) : $7daadc7693b66aa6$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === 'boolean') {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === 'element' && head.tagName === 'p') paragraph = head;
        else {
            paragraph = {
                type: 'element',
                tagName: 'p',
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: 'text',
            value: ' '
        });
        paragraph.children.unshift({
            type: 'element',
            tagName: 'input',
            properties: {
                type: 'checkbox',
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            'task-list-item'
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== 'element' || child.tagName !== 'p') children.push({
            type: 'text',
            value: '\n'
        });
        if (child.type === 'element' && child.tagName === 'p' && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) children.push({
        type: 'text',
        value: '\n'
    });
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'li',
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $7daadc7693b66aa6$var$listLoose(node) {
    let loose = false;
    if (node.type === 'list') {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $7daadc7693b66aa6$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $7daadc7693b66aa6$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === null || spread === undefined ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $000065359044742d$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === 'number' && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === 'element' && child.tagName === 'li' && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes('task-list-item')) {
            properties.className = [
                'contains-task-list'
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: node.ordered ? 'ol' : 'ul',
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $dd37a38bff66bb52$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'p',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Parents} HastParents
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $3bc4f83a854f76eb$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: 'root',
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $9df02da6e575a483$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'strong',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $d491e81ca430ccfa$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: 'element',
            tagName: 'thead',
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: 'element',
            tagName: 'tbody',
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $87a7d29188c64fce$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $87a7d29188c64fce$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start && end) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'table',
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $4b9671f40c53a128$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? 'th' : 'td';
    // To do: option to use `style`?
    const align = parent && parent.type === 'table' ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: 'element',
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(cell, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'tr',
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $6c64e7547614d9ee$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'td',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $785ab021544fe5d5$var$tab = 9 /* `\t` */ ;
const $785ab021544fe5d5$var$space = 32 /* ` ` */ ;
function $785ab021544fe5d5$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($785ab021544fe5d5$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($785ab021544fe5d5$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $785ab021544fe5d5$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $785ab021544fe5d5$var$tab || code === $785ab021544fe5d5$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $785ab021544fe5d5$var$tab || code === $785ab021544fe5d5$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}


function $9ff62835f155df8b$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: 'text',
        value: (0, $785ab021544fe5d5$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
'';
function $0d5ddb5237173a1f$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'hr',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $688e788549c991b3$export$455ce229eb3d2472 = {
    blockquote: $d36e6319d2875fd8$export$67dc04e652a298ca,
    break: (0, $4c8709fd49d18a29$export$371da9dd35aba193),
    code: $eb70ac1a94961808$export$6565f9f03506010b,
    delete: (0, $1aba28bb26d57ec9$export$19426ff118fe8be),
    emphasis: $1c469128cb20ed5d$export$bef81ba411953b51,
    footnoteReference: $47e86e60c74c44a0$export$7f87ee744075c1ba,
    heading: $ab09ca25fc2a6d7c$export$46e4a324ac90507f,
    html: $523e8ee2ebbbf9bb$export$c0bb0b647f701bb5,
    imageReference: $e95258b5b5f23a7d$export$f281796f6bc3b8db,
    image: $87bdb8055410bb48$export$5c452ff88e35e47d,
    inlineCode: $39dab6d63d746b7a$export$91b9bee19a0d8569,
    linkReference: $942c142d68171a3e$export$e6c469b1b7b2bc6a,
    link: $1b252c656fe19c0f$export$9c30223ca0a664fb,
    listItem: $7daadc7693b66aa6$export$76c7e83ecc9cdf05,
    list: $000065359044742d$export$8837f4fc672e936d,
    paragraph: $dd37a38bff66bb52$export$9c206ddddb32a9b,
    root: // @ts-expect-error: root is different, but hard to type.
    $3bc4f83a854f76eb$export$e8e78c978b129247,
    strong: $9df02da6e575a483$export$59ae2c325a998f89,
    table: $d491e81ca430ccfa$export$9852986a3ec5f6a0,
    tableCell: $6c64e7547614d9ee$export$e1e720e5f4603e6a,
    tableRow: $4b9671f40c53a128$export$ce666bf02318c957,
    text: $9ff62835f155df8b$export$6f093cfa640b7166,
    thematicBreak: $0d5ddb5237173a1f$export$ba7b13e047416c03,
    toml: $688e788549c991b3$var$ignore,
    yaml: $688e788549c991b3$var$ignore,
    definition: $688e788549c991b3$var$ignore,
    footnoteDefinition: $688e788549c991b3$var$ignore
};
// Return nothing for nodes that are ignored.
function $688e788549c991b3$var$ignore() {
    return undefined;
}


const $f52b2f36d156b803$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $f52b2f36d156b803$var$emptyOptions = {};
function $f52b2f36d156b803$export$e6a0daad8304de(tree, options) {
    const settings = options || $f52b2f36d156b803$var$emptyOptions;
    /** @type {Map<string, MdastDefinition>} */ const definitionById = new Map();
    /** @type {Map<string, MdastFootnoteDefinition>} */ const footnoteById = new Map();
    /** @type {Map<string, number>} */ const footnoteCounts = new Map();
    /** @type {Handlers} */ // @ts-expect-error: the root handler returns a root.
    // Hard to type.
    const handlers = {
        ...(0, $688e788549c991b3$export$455ce229eb3d2472),
        ...settings.handlers
    };
    /** @type {State} */ const state = {
        all: all,
        applyData: $f52b2f36d156b803$var$applyData,
        definitionById: definitionById,
        footnoteById: footnoteById,
        footnoteCounts: footnoteCounts,
        footnoteOrder: [],
        handlers: handlers,
        one: one,
        options: settings,
        patch: $f52b2f36d156b803$var$patch,
        wrap: $f52b2f36d156b803$export$4997ffc0176396a6
    };
    (0, $d035daec8fd9ba8d$export$bf638b60ea8b89b7)(tree, function(node) {
        if (node.type === 'definition' || node.type === 'footnoteDefinition') {
            const map = node.type === 'definition' ? definitionById : footnoteById;
            const id = String(node.identifier).toUpperCase();
            // Mimick CM behavior of link definitions.
            // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
            if (!map.has(id)) // @ts-expect-error: node type matches map.
            map.set(id, node);
        }
    });
    return state;
    /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */ function one(node, parent) {
        const type = node.type;
        const handle = state.handlers[type];
        if ($f52b2f36d156b803$var$own.call(state.handlers, type) && handle) return handle(state, node, parent);
        if (state.options.passThrough && state.options.passThrough.includes(type)) {
            if ('children' in node) {
                const { children: children, ...shallow } = node;
                const result = (0, $d4cac1dceaae6077$export$2e2bcd8739ae039)(shallow);
                // @ts-expect-error: TS doesn’t understand…
                result.children = state.all(node);
                // @ts-expect-error: TS doesn’t understand…
                return result;
            }
            // @ts-expect-error: it’s custom.
            return (0, $d4cac1dceaae6077$export$2e2bcd8739ae039)(node);
        }
        const unknown = state.options.unknownHandler || $f52b2f36d156b803$var$defaultUnknownHandler;
        return unknown(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function all(parent) {
        /** @type {Array<HastElementContent>} */ const values = [];
        if ('children' in parent) {
            const nodes = parent.children;
            let index = -1;
            while(++index < nodes.length){
                const result = state.one(nodes[index], parent);
                // To do: see if we van clean this? Can we merge texts?
                if (result) {
                    if (index && nodes[index - 1].type === 'break') {
                        if (!Array.isArray(result) && result.type === 'text') result.value = $f52b2f36d156b803$var$trimMarkdownSpaceStart(result.value);
                        if (!Array.isArray(result) && result.type === 'element') {
                            const head = result.children[0];
                            if (head && head.type === 'text') head.value = $f52b2f36d156b803$var$trimMarkdownSpaceStart(head.value);
                        }
                    }
                    if (Array.isArray(result)) values.push(...result);
                    else values.push(result);
                }
            }
        }
        return values;
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */ function $f52b2f36d156b803$var$patch(from, to) {
    if (from.position) to.position = (0, $87a7d29188c64fce$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */ function $f52b2f36d156b803$var$applyData(from, to) {
    /** @type {HastElement | Type} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === 'string') {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === 'element') result.tagName = hName;
            else {
                /** @type {Array<HastElementContent>} */ // @ts-expect-error: assume no doctypes in `root`.
                const children = 'children' in result ? result.children : [
                    result
                ];
                result = {
                    type: 'element',
                    tagName: hName,
                    properties: {},
                    children: children
                };
            }
        }
        if (result.type === 'element' && hProperties) Object.assign(result.properties, (0, $d4cac1dceaae6077$export$2e2bcd8739ae039)(hProperties));
        if ('children' in result && result.children && hChildren !== null && hChildren !== undefined) result.children = hChildren;
    }
    return result;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */ function $f52b2f36d156b803$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastElement | HastText} */ const result = 'value' in node && !($f52b2f36d156b803$var$own.call(data, 'hProperties') || $f52b2f36d156b803$var$own.call(data, 'hChildren')) ? {
        type: 'text',
        value: node.value
    } : {
        type: 'element',
        tagName: 'div',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $f52b2f36d156b803$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<HastText | Type>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: 'text',
        value: '\n'
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: 'text',
            value: '\n'
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: 'text',
        value: '\n'
    });
    return result;
}
/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */ function $f52b2f36d156b803$var$trimMarkdownSpaceStart(value) {
    let index = 0;
    let code = value.charCodeAt(index);
    while(code === 9 || code === 32){
        index++;
        code = value.charCodeAt(index);
    }
    return value.slice(index);
}


function $83586513cfe9a2b4$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $f52b2f36d156b803$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, undefined);
    const foot = (0, $e33fc7790570e365$export$adb608be33961c98)(state);
    /** @type {HastNodes} */ const result = Array.isArray(node) ? {
        type: 'root',
        children: node
    } : node || {
        type: 'root',
        children: []
    };
    if (foot) {
        // If there’s a footer, there were definitions, meaning block
        // content.
        // So `result` is a parent node.
        (0, $4b359f2d21305e76$export$dcb8b3f0e2de7e49)('children' in result);
        result.children.push({
            type: 'text',
            value: '\n'
        }, foot);
    }
    return result;
}


function $c14d62aed68a6d08$export$2e2bcd8739ae039(destination, options) {
    if (destination && 'run' in destination) /**
     * @type {TransformBridge}
     */ return async function(tree, file) {
        // Cast because root in -> root out.
        const hastTree = /** @type {HastRoot} */ (0, $83586513cfe9a2b4$export$c0e4c5cf07538633)(tree, {
            file: file,
            ...options
        });
        await destination.run(hastTree, file);
    };
    /**
   * @type {TransformMutate}
   */ return function(tree, file) {
        // Cast because root in -> root out.
        return /** @type {HastRoot} */ (0, $83586513cfe9a2b4$export$c0e4c5cf07538633)(tree, {
            file: file,
            ...options || destination
        });
    };
}


/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */ /**
 * @typedef {CompileResultMap[keyof CompileResultMap]} CompileResults
 *   Acceptable results from compilers.
 *
 *   To register custom results, add them to
 *   {@link CompileResultMap `CompileResultMap`}.
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the compiler receives (default: `Node`).
 * @template {CompileResults} [Result=CompileResults]
 *   The thing that the compiler yields (default: `CompileResults`).
 * @callback Compiler
 *   A **compiler** handles the compiling of a syntax tree to something else
 *   (in most cases, text) (TypeScript type).
 *
 *   It is used in the stringify phase and called with a {@link Node `Node`}
 *   and {@link VFile `VFile`} representation of the document to compile.
 *   It should return the textual representation of the given tree (typically
 *   `string`).
 *
 *   > 👉 **Note**: unified typically compiles by serializing: most compilers
 *   > return `string` (or `Uint8Array`).
 *   > Some compilers, such as the one configured with
 *   > [`rehype-react`][rehype-react], return other values (in this case, a
 *   > React tree).
 *   > If you’re using a compiler that doesn’t serialize, expect different
 *   > result values.
 *   >
 *   > To register custom results in TypeScript, add them to
 *   > {@link CompileResultMap `CompileResultMap`}.
 *
 *   [rehype-react]: https://github.com/rehypejs/rehype-react
 * @param {Tree} tree
 *   Tree to compile.
 * @param {VFile} file
 *   File associated with `tree`.
 * @returns {Result}
 *   New content: compiled text (`string` or `Uint8Array`, for `file.value`) or
 *   something else (for `file.result`).
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the parser yields (default: `Node`)
 * @callback Parser
 *   A **parser** handles the parsing of text to a syntax tree.
 *
 *   It is used in the parse phase and is called with a `string` and
 *   {@link VFile `VFile`} of the document to parse.
 *   It must return the syntax tree representation of the given file
 *   ({@link Node `Node`}).
 * @param {string} document
 *   Document to parse.
 * @param {VFile} file
 *   File associated with `document`.
 * @returns {Tree}
 *   Node representing the given file.
 */ /**
 * @typedef {(
 *   Plugin<Array<any>, any, any> |
 *   PluginTuple<Array<any>, any, any> |
 *   Preset
 * )} Pluggable
 *   Union of the different ways to add plugins and settings.
 */ /**
 * @typedef {Array<Pluggable>} PluggableList
 *   List of plugins and presets.
 */ // Note: we can’t use `callback` yet as it messes up `this`:
//  <https://github.com/microsoft/TypeScript/issues/55197>.
/**
 * @template {Array<unknown>} [PluginParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=Node]
 *   Value that is expected as input (default: `Node`).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be
 *       `string`.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be the
 *       node it expects.
 * @template [Output=Input]
 *   Value that is yielded as output (default: `Input`).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be
 *       result it yields.
 * @typedef {(
 *   (this: Processor, ...parameters: PluginParameters) =>
 *     Input extends string ? // Parser.
 *        Output extends Node | undefined ? undefined | void : never :
 *     Output extends CompileResults ? // Compiler.
 *        Input extends Node | undefined ? undefined | void : never :
 *     Transformer<
 *       Input extends Node ? Input : Node,
 *       Output extends Node ? Output : Node
 *     > | undefined | void
 * )} Plugin
 *   Single plugin.
 *
 *   Plugins configure the processors they are applied on in the following
 *   ways:
 *
 *   *   they change the processor, such as the parser, the compiler, or by
 *       configuring data
 *   *   they specify how to handle trees and files
 *
 *   In practice, they are functions that can receive options and configure the
 *   processor (`this`).
 *
 *   > 👉 **Note**: plugins are called when the processor is *frozen*, not when
 *   > they are applied.
 */ /**
 * Tuple of a plugin and its configuration.
 *
 * The first item is a plugin, the rest are its parameters.
 *
 * @template {Array<unknown>} [TupleParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=undefined]
 *   Value that is expected as input (optional).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be
 *       `string`.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be the
 *       node it expects.
 * @template [Output=undefined] (optional).
 *   Value that is yielded as output.
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be
 *       result it yields.
 * @typedef {(
 *   [
 *     plugin: Plugin<TupleParameters, Input, Output>,
 *     ...parameters: TupleParameters
 *   ]
 * )} PluginTuple
 */ /**
 * @typedef Preset
 *   Sharable configuration.
 *
 *   They can contain plugins and settings.
 * @property {PluggableList | undefined} [plugins]
 *   List of plugins and presets (optional).
 * @property {Settings | undefined} [settings]
 *   Shared settings for parsers and compilers (optional).
 */ /**
 * @template {VFile} [File=VFile]
 *   The file that the callback receives (default: `VFile`).
 * @callback ProcessCallback
 *   Callback called when the process is done.
 *
 *   Called with either an error or a result.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {File | undefined} [file]
 *   Processed file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Tree=Node]
 *   The tree that the callback receives (default: `Node`).
 * @callback RunCallback
 *   Callback called when transformers are done.
 *
 *   Called with either an error or results.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {Tree | undefined} [tree]
 *   Transformed tree (optional).
 * @param {VFile | undefined} [file]
 *   File (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Output=Node]
 *   Node type that the transformer yields (default: `Node`).
 * @callback TransformCallback
 *   Callback passed to transforms.
 *
 *   If the signature of a `transformer` accepts a third argument, the
 *   transformer may perform asynchronous operations, and must call it.
 * @param {Error | undefined} [error]
 *   Fatal error to stop the process (optional).
 * @param {Output | undefined} [tree]
 *   New, changed, tree (optional).
 * @param {VFile | undefined} [file]
 *   New, changed, file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Input=Node]
 *   Node type that the transformer expects (default: `Node`).
 * @template {Node} [Output=Input]
 *   Node type that the transformer yields (default: `Input`).
 * @callback Transformer
 *   Transformers handle syntax trees and files.
 *
 *   They are functions that are called each time a syntax tree and file are
 *   passed through the run phase.
 *   When an error occurs in them (either because it’s thrown, returned,
 *   rejected, or passed to `next`), the process stops.
 *
 *   The run phase is handled by [`trough`][trough], see its documentation for
 *   the exact semantics of these functions.
 *
 *   > 👉 **Note**: you should likely ignore `next`: don’t accept it.
 *   > it supports callback-style async work.
 *   > But promises are likely easier to reason about.
 *
 *   [trough]: https://github.com/wooorm/trough#function-fninput-next
 * @param {Input} tree
 *   Tree to handle.
 * @param {VFile} file
 *   File to handle.
 * @param {TransformCallback<Output>} next
 *   Callback.
 * @returns {(
 *   Promise<Output | undefined | void> |
 *   Promise<never> | // For some reason this is needed separately.
 *   Output |
 *   Error |
 *   undefined |
 *   void
 * )}
 *   If you accept `next`, nothing.
 *   Otherwise:
 *
 *   *   `Error` — fatal error to stop the process
 *   *   `Promise<undefined>` or `undefined` — the next transformer keeps using
 *       same tree
 *   *   `Promise<Node>` or `Node` — new, changed, tree
 */ /**
 * @template {Node | undefined} ParseTree
 *   Output of `parse`.
 * @template {Node | undefined} HeadTree
 *   Input for `run`.
 * @template {Node | undefined} TailTree
 *   Output for `run`.
 * @template {Node | undefined} CompileTree
 *   Input of `stringify`.
 * @template {CompileResults | undefined} CompileResult
 *   Output of `stringify`.
 * @template {Node | string | undefined} Input
 *   Input of plugin.
 * @template Output
 *   Output of plugin (optional).
 * @typedef {(
 *   Input extends string
 *     ? Output extends Node | undefined
 *       ? // Parser.
 *         Processor<
 *           Output extends undefined ? ParseTree : Output,
 *           HeadTree,
 *           TailTree,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Output extends CompileResults
 *     ? Input extends Node | undefined
 *       ? // Compiler.
 *         Processor<
 *           ParseTree,
 *           HeadTree,
 *           TailTree,
 *           Input extends undefined ? CompileTree : Input,
 *           Output extends undefined ? CompileResult : Output
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Input extends Node | undefined
 *     ? Output extends Node | undefined
 *       ? // Transform.
 *         Processor<
 *           ParseTree,
 *           HeadTree extends undefined ? Input : HeadTree,
 *           Output extends undefined ? TailTree : Output,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : // Unknown.
 *       Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 * )} UsePlugin
 *   Create a processor based on the input/output of a {@link Plugin plugin}.
 */ /**
 * @template {CompileResults | undefined} Result
 *   Node type that the transformer yields.
 * @typedef {(
 *   Result extends Value | undefined ?
 *     VFile :
 *     VFile & {result: Result}
 *   )} VFileWithOutput
 *   Type to generate a {@link VFile `VFile`} corresponding to a compiler result.
 *
 *   If a result that is not acceptable on a `VFile` is used, that will
 *   be stored on the `result` field of {@link VFile `VFile`}.
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $a13cceeeb86355b7$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}


var $7bbe383fe04d543e$exports = {};
'use strict';
var $7bbe383fe04d543e$var$hasOwn = Object.prototype.hasOwnProperty;
var $7bbe383fe04d543e$var$toStr = Object.prototype.toString;
var $7bbe383fe04d543e$var$defineProperty = Object.defineProperty;
var $7bbe383fe04d543e$var$gOPD = Object.getOwnPropertyDescriptor;
var $7bbe383fe04d543e$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $7bbe383fe04d543e$var$toStr.call(arr) === '[object Array]';
};
var $7bbe383fe04d543e$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $7bbe383fe04d543e$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $7bbe383fe04d543e$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $7bbe383fe04d543e$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $7bbe383fe04d543e$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $7bbe383fe04d543e$var$setProperty = function setProperty(target, options) {
    if ($7bbe383fe04d543e$var$defineProperty && options.name === '__proto__') $7bbe383fe04d543e$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $7bbe383fe04d543e$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$7bbe383fe04d543e$var$hasOwn.call(obj, name)) return void 0;
        else if ($7bbe383fe04d543e$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $7bbe383fe04d543e$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$7bbe383fe04d543e$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $7bbe383fe04d543e$var$getProperty(target, name);
            copy = $7bbe383fe04d543e$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($7bbe383fe04d543e$var$isPlainObject(copy) || (copyIsArray = $7bbe383fe04d543e$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $7bbe383fe04d543e$var$isArray(src) ? src : [];
                    } else clone = src && $7bbe383fe04d543e$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $7bbe383fe04d543e$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $7bbe383fe04d543e$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};



function $794055daeb840b5f$export$2e2bcd8739ae039(value) {
    if (typeof value !== 'object' || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $66e71dd6c6eee651$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== 'function') throw new TypeError('Expected function as last argument, not ' + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $66e71dd6c6eee651$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== 'function') throw new TypeError('Expected `middelware` to be a function, not ' + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $66e71dd6c6eee651$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 * @typedef {import('vfile-message').Options} MessageOptions
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {Options | URL | VFile | Value} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {string | null | undefined} [basename]
 *   Set `basename` (name).
 * @property {string | null | undefined} [cwd]
 *   Set `cwd` (working directory).
 * @property {Data | null | undefined} [data]
 *   Set `data` (associated info).
 * @property {string | null | undefined} [dirname]
 *   Set `dirname` (path w/o basename).
 * @property {string | null | undefined} [extname]
 *   Set `extname` (extension with dot).
 * @property {Array<string> | null | undefined} [history]
 *   Set `history` (paths the file moved between).
 * @property {URL | string | null | undefined} [path]
 *   Set `path` (current path).
 * @property {string | null | undefined} [stem]
 *   Set `stem` (name without extension).
 * @property {Value | null | undefined} [value]
 *   Set `value` (the contents of the file).
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/60adcb0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {Record<string, unknown> & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template [Settings=ReporterSettings]
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ 
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $634ab54ea7f809b5$export$bb654e07daaf8c3a = {
    basename: $634ab54ea7f809b5$var$basename,
    dirname: $634ab54ea7f809b5$var$dirname,
    extname: $634ab54ea7f809b5$var$extname,
    join: $634ab54ea7f809b5$var$join,
    sep: '/'
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $634ab54ea7f809b5$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    $634ab54ea7f809b5$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (ext === path) return '';
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.codePointAt(index) === ext.codePointAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $634ab54ea7f809b5$var$dirname(path) {
    $634ab54ea7f809b5$var$assertPath(path);
    if (path.length === 0) return '.';
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.codePointAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.codePointAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.codePointAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $634ab54ea7f809b5$var$extname(path) {
    $634ab54ea7f809b5$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.codePointAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $634ab54ea7f809b5$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $634ab54ea7f809b5$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
    return joined === undefined ? '.' : $634ab54ea7f809b5$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $634ab54ea7f809b5$var$normalize(path) {
    $634ab54ea7f809b5$var$assertPath(path);
    const absolute = path.codePointAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $634ab54ea7f809b5$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = '.';
    if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $634ab54ea7f809b5$var$normalizeString(path, allowAboveRoot) {
    let result = '';
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.codePointAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 /* `.` */  || result.codePointAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $634ab54ea7f809b5$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $edc0c918f230018f$export$97a5aaf482767187 = {
    cwd: $edc0c918f230018f$var$cwd
};
function $edc0c918f230018f$var$cwd() {
    return '/';
}


/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function $12ac0a31cfc3ef1e$export$8304a22d431f958(fileUrlOrPath) {
    return Boolean(fileUrlOrPath !== null && typeof fileUrlOrPath === 'object' && 'href' in fileUrlOrPath && fileUrlOrPath.href && 'protocol' in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === undefined);
}


function $ab132dc0a4fc92ef$export$9b2b676c902de799(path) {
    if (typeof path === 'string') path = new URL(path);
    else if (!(0, $12ac0a31cfc3ef1e$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + '`');
        error.code = 'ERR_INVALID_ARG_TYPE';
        throw error;
    }
    if (path.protocol !== 'file:') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The URL must be of scheme file');
        error.code = 'ERR_INVALID_URL_SCHEME';
        throw error;
    }
    return $ab132dc0a4fc92ef$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $ab132dc0a4fc92ef$var$getPathFromURLPosix(url) {
    if (url.hostname !== '') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = 'ERR_INVALID_FILE_URL_HOST';
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.codePointAt(index) === 37 /* `%` */  && pathname.codePointAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.codePointAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL path must not include encoded / characters');
            error.code = 'ERR_INVALID_FILE_URL_PATH';
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */ const $26b144b7a59f8cdb$var$order = /** @type {const} */ [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
class $26b144b7a59f8cdb$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if ((0, $12ac0a31cfc3ef1e$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else if (typeof value === 'string' || $26b144b7a59f8cdb$var$isUint8Array(value)) options = {
            value: value
        };
        else options = value;
        /* eslint-disable no-unused-expressions */ /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $edc0c918f230018f$export$97a5aaf482767187).cwd();
        /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $26b144b7a59f8cdb$var$order.length){
            const prop = $26b144b7a59f8cdb$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === 'history' ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$26b144b7a59f8cdb$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */ get basename() {
        return typeof this.path === 'string' ? (0, $634ab54ea7f809b5$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */ set basename(basename) {
        $26b144b7a59f8cdb$var$assertNonEmpty(basename, 'basename');
        $26b144b7a59f8cdb$var$assertPart(basename, 'basename');
        this.path = (0, $634ab54ea7f809b5$export$bb654e07daaf8c3a).join(this.dirname || '', basename);
    }
    /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */ get dirname() {
        return typeof this.path === 'string' ? (0, $634ab54ea7f809b5$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */ set dirname(dirname) {
        $26b144b7a59f8cdb$var$assertPath(this.basename, 'dirname');
        this.path = (0, $634ab54ea7f809b5$export$bb654e07daaf8c3a).join(dirname || '', this.basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */ get extname() {
        return typeof this.path === 'string' ? (0, $634ab54ea7f809b5$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */ set extname(extname) {
        $26b144b7a59f8cdb$var$assertPart(extname, 'extname');
        $26b144b7a59f8cdb$var$assertPath(this.dirname, 'extname');
        if (extname) {
            if (extname.codePointAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
            if (extname.includes('.', 1)) throw new Error('`extname` cannot contain multiple dots');
        }
        this.path = (0, $634ab54ea7f809b5$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ''));
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */ set path(path) {
        if ((0, $12ac0a31cfc3ef1e$export$8304a22d431f958)(path)) path = (0, $ab132dc0a4fc92ef$export$9b2b676c902de799)(path);
        $26b144b7a59f8cdb$var$assertNonEmpty(path, 'path');
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */ get stem() {
        return typeof this.path === 'string' ? (0, $634ab54ea7f809b5$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */ set stem(stem) {
        $26b144b7a59f8cdb$var$assertNonEmpty(stem, 'stem');
        $26b144b7a59f8cdb$var$assertPart(stem, 'stem');
        this.path = (0, $634ab54ea7f809b5$export$bb654e07daaf8c3a).join(this.dirname || '', stem + (this.extname || ''));
    }
    // Normal prototypal methods.
    /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */ fail(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = undefined;
        return message;
    }
    /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(causeOrReason, optionsOrParentOrPlace, origin) {
        const message = new (0, $56d41ff9124ad29b$export$752e5c445fe834ef)(// @ts-expect-error: the overloads are fine.
        causeOrReason, optionsOrParentOrPlace, origin);
        if (this.path) {
            message.name = this.path + ':' + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        if (this.value === undefined) return '';
        if (typeof this.value === 'string') return this.value;
        const decoder = new TextDecoder(encoding || undefined);
        return decoder.decode(this.value);
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */ function $26b144b7a59f8cdb$var$assertPart(part, name) {
    if (part && part.includes((0, $634ab54ea7f809b5$export$bb654e07daaf8c3a).sep)) throw new Error('`' + name + '` cannot be a path: did not expect `' + (0, $634ab54ea7f809b5$export$bb654e07daaf8c3a).sep + '`');
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $26b144b7a59f8cdb$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $26b144b7a59f8cdb$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $26b144b7a59f8cdb$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}


const $a22c5483685aa6e0$export$b7de1db558410812 = /** @type {unknown} */ /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */ function(property) {
    const self = this;
    const constr = self.constructor;
    const proto = /** @type {Record<string | symbol, Function>} */ // Prototypes do exist.
    // type-coverage:ignore-next-line
    constr.prototype;
    const func = proto[property];
    /** @type {(...parameters: Array<unknown>) => unknown} */ const apply = function() {
        return func.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    const names = Object.getOwnPropertyNames(func);
    for (const p of names){
        const descriptor = Object.getOwnPropertyDescriptor(func, p);
        if (descriptor) Object.defineProperty(apply, p, descriptor);
    }
    return apply;
};


// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.
// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.
const $25c33066a0c41ddd$var$own = {}.hasOwnProperty;
class $25c33066a0c41ddd$export$c30cd198d731db19 extends (0, $a22c5483685aa6e0$export$b7de1db558410812) {
    /**
   * Create a processor.
   */ constructor(){
        // If `Processor()` is called (w/o new), `copy` is called instead.
        super('copy');
        /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.Compiler = undefined;
        /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.Parser = undefined;
        // Note: the following fields are considered private.
        // However, they are needed for tests, and TSC generates an untyped
        // `private freezeIndex` field for, which trips `type-coverage` up.
        // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
        /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */ this.attachers = [];
        /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.compiler = undefined;
        /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */ this.freezeIndex = -1;
        /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */ this.frozen = undefined;
        /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */ this.namespace = {};
        /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.parser = undefined;
        /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */ this.transformers = (0, $66e71dd6c6eee651$export$91b56f5ca106aa43)();
    }
    /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@link Processor `Processor`}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */ copy() {
        // Cast as the type parameters will be the same after attaching.
        const destination = /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ new $25c33066a0c41ddd$export$c30cd198d731db19();
        let index = -1;
        while(++index < this.attachers.length){
            const attacher = this.attachers[index];
            destination.use(...attacher);
        }
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($7bbe383fe04d543e$exports)))(true, {}, this.namespace));
        return destination;
    }
    /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > 👉 **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > 👉 **Note**: to register custom data in TypeScript, augment the
   * > {@link Data `Data`} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */ data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $25c33066a0c41ddd$var$assertUnfrozen('data', this.frozen);
                this.namespace[key] = value;
                return this;
            }
            // Get `key`.
            return $25c33066a0c41ddd$var$own.call(this.namespace, key) && this.namespace[key] || undefined;
        }
        // Set space.
        if (key) {
            $25c33066a0c41ddd$var$assertUnfrozen('data', this.frozen);
            this.namespace = key;
            return this;
        }
        // Get space.
        return this.namespace;
    }
    /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */ freeze() {
        if (this.frozen) return this;
        // Cast so that we can type plugins easier.
        // Plugins are supposed to be usable on different processors, not just on
        // this exact processor.
        const self = /** @type {unknown} */ this;
        while(++this.freezeIndex < this.attachers.length){
            const [attacher, ...options] = this.attachers[this.freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            const transformer = attacher.call(self, ...options);
            if (typeof transformer === 'function') this.transformers.use(transformer);
        }
        this.frozen = true;
        this.freezeIndex = Number.POSITIVE_INFINITY;
        return this;
    }
    /**
   * Parse text to a syntax tree.
   *
   * > 👉 **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */ parse(file) {
        this.freeze();
        const realFile = $25c33066a0c41ddd$var$vfile(file);
        const parser = this.parser || this.Parser;
        $25c33066a0c41ddd$var$assertParser('parse', parser);
        return parser(String(realFile), realFile);
    }
    /**
   * Process the given file as configured on the processor.
   *
   * > 👉 **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ process(file, done) {
        const self = this;
        this.freeze();
        $25c33066a0c41ddd$var$assertParser('process', this.parser || this.Parser);
        $25c33066a0c41ddd$var$assertCompiler('process', this.compiler || this.Compiler);
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            const realFile = $25c33066a0c41ddd$var$vfile(file);
            // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
            // input of the first transform).
            const parseTree = /** @type {unknown} */ self.parse(realFile);
            self.run(parseTree, realFile, function(error, tree, file) {
                if (error || !tree || !file) return realDone(error);
                // Assume `TailTree` (the output of the last transform) matches
                // `CompileTree` (the input of the compiler).
                const compileTree = /** @type {unknown} */ tree;
                const compileResult = self.stringify(compileTree, file);
                if ($25c33066a0c41ddd$var$looksLikeAValue(compileResult)) file.value = compileResult;
                else file.result = compileResult;
                realDone(error, /** @type {VFileWithOutput<CompileResult>} */ file);
            });
            /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */ function realDone(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else {
                    (0, $4b359f2d21305e76$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                    done(undefined, file);
                }
            }
        }
    }
    /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ processSync(file) {
        /** @type {boolean} */ let complete = false;
        /** @type {VFileWithOutput<CompileResult> | undefined} */ let result;
        this.freeze();
        $25c33066a0c41ddd$var$assertParser('processSync', this.parser || this.Parser);
        $25c33066a0c41ddd$var$assertCompiler('processSync', this.compiler || this.Compiler);
        this.process(file, realDone);
        $25c33066a0c41ddd$var$assertDone('processSync', 'process', complete);
        (0, $4b359f2d21305e76$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */ function realDone(error, file) {
            complete = true;
            (0, $a13cceeeb86355b7$export$dd911e13ecb11e05)(error);
            result = file;
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * > 👉 **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */ run(tree, file, done) {
        $25c33066a0c41ddd$var$assertNode(tree);
        this.freeze();
        const transformers = this.transformers;
        if (!done && typeof file === 'function') {
            done = file;
            file = undefined;
        }
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            (0, $4b359f2d21305e76$export$dcb8b3f0e2de7e49)(typeof file !== 'function', "`file` can\u2019t be a `done` anymore, we checked");
            const realFile = $25c33066a0c41ddd$var$vfile(file);
            transformers.run(tree, realFile, realDone);
            /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */ function realDone(error, outputTree, file) {
                const resultingTree = /** @type {TailTree extends undefined ? Node : TailTree} */ outputTree || tree;
                if (error) reject(error);
                else if (resolve) resolve(resultingTree);
                else {
                    (0, $4b359f2d21305e76$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                    done(undefined, resultingTree, file);
                }
            }
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */ runSync(tree, file) {
        /** @type {boolean} */ let complete = false;
        /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */ let result;
        this.run(tree, file, realDone);
        $25c33066a0c41ddd$var$assertDone('runSync', 'run', complete);
        (0, $4b359f2d21305e76$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */ function realDone(error, tree) {
            (0, $a13cceeeb86355b7$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * Compile a syntax tree.
   *
   * > 👉 **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ stringify(tree, file) {
        this.freeze();
        const realFile = $25c33066a0c41ddd$var$vfile(file);
        const compiler = this.compiler || this.Compiler;
        $25c33066a0c41ddd$var$assertCompiler('stringify', compiler);
        $25c33066a0c41ddd$var$assertNode(tree);
        return compiler(tree, realFile);
    }
    /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > 👉 **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */ use(value, ...parameters) {
        const attachers = this.attachers;
        const namespace = this.namespace;
        $25c33066a0c41ddd$var$assertUnfrozen('use', this.frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin(value, parameters);
        else if (typeof value === 'object') {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError('Expected usable value, not `' + value + '`');
        return this;
        /**
     * @param {Pluggable} value
     * @returns {undefined}
     */ function add(value) {
            if (typeof value === 'function') addPlugin(value, []);
            else if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    const [plugin, ...parameters] = /** @type {PluginTuple<Array<unknown>>} */ value;
                    addPlugin(plugin, parameters);
                } else addPreset(value);
            } else throw new TypeError('Expected usable value, not `' + value + '`');
        }
        /**
     * @param {Preset} result
     * @returns {undefined}
     */ function addPreset(result) {
            if (!('plugins' in result) && !('settings' in result)) throw new Error('Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither');
            addList(result.plugins);
            if (result.settings) namespace.settings = (0, (/*@__PURE__*/$parcel$interopDefault($7bbe383fe04d543e$exports)))(true, namespace.settings, result.settings);
        }
        /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError('Expected a list of plugins, not `' + plugins + '`');
        }
        /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */ function addPlugin(plugin, parameters) {
            let index = -1;
            let entryIndex = -1;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entryIndex = index;
                break;
            }
            if (entryIndex === -1) attachers.push([
                plugin,
                ...parameters
            ]);
            else if (parameters.length > 0) {
                let [primary, ...rest] = parameters;
                const currentPrimary = attachers[entryIndex][1];
                if ((0, $794055daeb840b5f$export$2e2bcd8739ae039)(currentPrimary) && (0, $794055daeb840b5f$export$2e2bcd8739ae039)(primary)) primary = (0, (/*@__PURE__*/$parcel$interopDefault($7bbe383fe04d543e$exports)))(true, currentPrimary, primary);
                attachers[entryIndex] = [
                    plugin,
                    primary,
                    ...rest
                ];
            }
        }
    }
}
const $25c33066a0c41ddd$export$7cc1b2fe10c52bb = new $25c33066a0c41ddd$export$c30cd198d731db19().freeze();
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $25c33066a0c41ddd$var$assertParser(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `parser`');
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $25c33066a0c41ddd$var$assertCompiler(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `compiler`');
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $25c33066a0c41ddd$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot call `' + name + '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.');
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $25c33066a0c41ddd$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $794055daeb840b5f$export$2e2bcd8739ae039)(node) || typeof node.type !== 'string') throw new TypeError('Expected node, got `' + node + '`');
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $25c33066a0c41ddd$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */ function $25c33066a0c41ddd$var$vfile(value) {
    return $25c33066a0c41ddd$var$looksLikeAVFile(value) ? value : new (0, $26b144b7a59f8cdb$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */ function $25c33066a0c41ddd$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === 'object' && 'message' in value && 'messages' in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */ function $25c33066a0c41ddd$var$looksLikeAValue(value) {
    return typeof value === 'string' || $25c33066a0c41ddd$var$isUint8Array(value);
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $25c33066a0c41ddd$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}




const $fe71a44f130a0d39$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {PluggableList} */ const $fe71a44f130a0d39$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ const $fe71a44f130a0d39$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
const $fe71a44f130a0d39$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ const $fe71a44f130a0d39$var$deprecations = [
    {
        from: 'astPlugins',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowDangerousHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowNode',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowElement'
    },
    {
        from: 'allowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowedElements'
    },
    {
        from: 'disallowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'disallowedElements'
    },
    {
        from: 'escapeHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'includeElementIndex',
        id: '#remove-includeelementindex'
    },
    {
        from: 'includeNodeIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    },
    {
        from: 'linkTarget',
        id: 'remove-linktarget'
    },
    {
        from: 'plugins',
        id: 'change-plugins-to-remarkplugins',
        to: 'remarkPlugins'
    },
    {
        from: 'rawSourcePos',
        id: '#remove-rawsourcepos'
    },
    {
        from: 'renderers',
        id: 'change-renderers-to-components',
        to: 'components'
    },
    {
        from: 'source',
        id: 'change-source-to-children',
        to: 'children'
    },
    {
        from: 'sourcePos',
        id: '#remove-sourcepos'
    },
    {
        from: 'transformImageUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    },
    {
        from: 'transformLinkUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    }
];
function $fe71a44f130a0d39$export$7460c8b7e4ce9582(options) {
    const allowedElements = options.allowedElements;
    const allowElement = options.allowElement;
    const children = options.children || '';
    const className = options.className;
    const components = options.components;
    const disallowedElements = options.disallowedElements;
    const rehypePlugins = options.rehypePlugins || $fe71a44f130a0d39$var$emptyPlugins;
    const remarkPlugins = options.remarkPlugins || $fe71a44f130a0d39$var$emptyPlugins;
    const remarkRehypeOptions = options.remarkRehypeOptions ? {
        ...options.remarkRehypeOptions,
        ...$fe71a44f130a0d39$var$emptyRemarkRehypeOptions
    } : $fe71a44f130a0d39$var$emptyRemarkRehypeOptions;
    const skipHtml = options.skipHtml;
    const unwrapDisallowed = options.unwrapDisallowed;
    const urlTransform = options.urlTransform || $fe71a44f130a0d39$export$ca5e94754123e2f3;
    const processor = (0, $25c33066a0c41ddd$export$7cc1b2fe10c52bb)().use((0, $823c0a06540af4f9$export$2e2bcd8739ae039)).use(remarkPlugins).use((0, $c14d62aed68a6d08$export$2e2bcd8739ae039), remarkRehypeOptions).use(rehypePlugins);
    const file = new (0, $26b144b7a59f8cdb$export$93dff69eb10dc7ce)();
    if (typeof children === 'string') file.value = children;
    else (0, $4b359f2d21305e76$export$565e9d9bd6b6e0d4)('Unexpected value `' + children + '` for `children` prop, expected `string`');
    if (allowedElements && disallowedElements) (0, $4b359f2d21305e76$export$565e9d9bd6b6e0d4)('Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other');
    for (const deprecation of $fe71a44f130a0d39$var$deprecations)if (Object.hasOwn(options, deprecation.from)) (0, $4b359f2d21305e76$export$565e9d9bd6b6e0d4)('Unexpected `' + deprecation.from + '` prop, ' + (deprecation.to ? 'use `' + deprecation.to + '` instead' : 'remove it') + ' (see <' + $fe71a44f130a0d39$var$changelog + '#' + deprecation.id + '> for more info)');
    const mdastTree = processor.parse(file);
    /** @type {Nodes} */ let hastTree = processor.runSync(mdastTree, file);
    // Wrap in `div` if there’s a class name.
    if (className) hastTree = {
        type: 'element',
        tagName: 'div',
        properties: {
            className: className
        },
        // Assume no doctypes.
        children: /** @type {Array<ElementContent>} */ hastTree.type === 'root' ? hastTree.children : [
            hastTree
        ]
    };
    (0, $d035daec8fd9ba8d$export$bf638b60ea8b89b7)(hastTree, transform);
    return (0, $ec6fdf630d7c0759$export$59c10052b2dee561)(hastTree, {
        Fragment: $9d004cf64875b9d1$exports.Fragment,
        components: components,
        ignoreInvalidStyle: true,
        jsx: $9d004cf64875b9d1$exports.jsx,
        jsxs: $9d004cf64875b9d1$exports.jsxs,
        passKeys: true,
        passNode: true
    });
    /** @type {Visitor} */ function transform(node, index, parent) {
        if (node.type === 'raw' && parent && typeof index === 'number') {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: 'text',
                value: node.value
            };
            return index;
        }
        if (node.type === 'element') {
            /** @type {string} */ let key;
            for(key in 0, $f684ad365ddeacff$export$de3e062aedff083a)if (Object.hasOwn((0, $f684ad365ddeacff$export$de3e062aedff083a), key) && Object.hasOwn(node.properties, key)) {
                const value = node.properties[key];
                const test = (0, $f684ad365ddeacff$export$de3e062aedff083a)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ''), key, node);
            }
        }
        if (node.type === 'element') {
            let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === 'number') remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === 'number') {
                if (unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $fe71a44f130a0d39$export$ca5e94754123e2f3(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    $fe71a44f130a0d39$var$safeProtocol.test(value.slice(0, colon))) return value;
    return '';
}




parcelRequire("ltGt3");





function $c188a30f9d7415a1$export$66ad816e0b868324({ userPlantTemplateId: userPlantTemplateId, plantId: plantId, className: className }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const plantTemplates = (0, $670e204136b37e30$export$9544d5bb712b01ea).getElementTypeTemplates('plant');
    const plantTemplatesOptions = Object.keys(plantTemplates).map((templateId)=>({
            value: templateId,
            label: templateId
        }));
    const labelRender = (props)=>{
        if (!props.value) return null;
        const templateId = String(props.value);
        const template = plantTemplates[templateId];
        return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
            style: {
                display: 'flex',
                alignItems: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                    style: {
                        marginRight: 8
                    },
                    src: template.src,
                    width: 25,
                    height: 25
                }, templateId),
                intl.formatMessage({
                    id: templateId
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
        className: className,
        size: "large",
        placeholder: intl.formatMessage({
            id: 'template'
        }),
        defaultValue: userPlantTemplateId,
        onChange: async (template)=>{
            await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).editPlantTemplateByPlantId(plantId, template);
            (0, $f72b095965a02692$export$355b0b6aff080555)();
            revalidator.revalidate();
        },
        options: plantTemplatesOptions,
        labelRender: labelRender,
        optionRender: labelRender
    });
}







var $ltGt3 = parcelRequire("ltGt3");
const $3db3e2fc7df578e0$var$SEPARATOR = ', ';
const $3db3e2fc7df578e0$var$PROBE_CLASS = 'multi-value-tag--probe';
// Greedily fills one tag after another: a value only moves on to the next tag
// once the current one has no room left for it, so a value is never broken up.
//
// Every candidate is measured on a real tag rather than calculated, which is
// what makes the answer survive things a calculation would have to guess at -
// the web font, the icon, the padding the theme happens to give a tag.
const $3db3e2fc7df578e0$var$packValues = (values, suffix, row, probe)=>{
    const maxWidth = row.clientWidth;
    const text = probe.querySelector('.multi-value-tag__probe-text');
    if (!maxWidth || !text) return [
        values
    ];
    const fits = (candidate)=>{
        text.textContent = candidate;
        return probe.getBoundingClientRect().width <= maxWidth;
    };
    const groups = [];
    let current = [];
    values.forEach((value, index)=>{
        // The suffix trails the last value, so it is the last value that has to
        // find room for it as well.
        const trailer = index === values.length - 1 ? suffix : '';
        const candidate = [
            ...current,
            value
        ];
        if (current.length && !fits(candidate.join($3db3e2fc7df578e0$var$SEPARATOR) + trailer)) {
            groups.push(current);
            current = [
                value
            ];
        } else current = candidate;
    });
    if (current.length) groups.push(current);
    text.textContent = '';
    return groups;
};
const $3db3e2fc7df578e0$export$f61fe101cc42bf77 = ({ values: values, icon: icon, color: color, suffix: suffix = '' })=>{
    // The probe is held in state rather than in a ref so that the measuring below
    // re-runs against the live element whenever React hands over a new one.
    const [probeText, setProbeText] = (0, $ltGt3.useState)(null);
    const [groups, setGroups] = (0, $ltGt3.useState)([
        values
    ]);
    const valuesKey = values.join($3db3e2fc7df578e0$var$SEPARATOR);
    (0, $ltGt3.useLayoutEffect)(()=>{
        const probe = probeText?.closest(`.${$3db3e2fc7df578e0$var$PROBE_CLASS}`);
        const row = probe?.parentElement;
        if (!probe || !row) return;
        const repack = ()=>setGroups($3db3e2fc7df578e0$var$packValues(values, suffix, row, probe));
        repack();
        // The row is resized without anything remounting - by a rotation, by the
        // modal growing as the rest of the plant loads - and each time the values
        // have to be dealt out over the tags again.
        const observer = new ResizeObserver(repack);
        observer.observe(row);
        // A web font arriving after the first paint changes every width there is,
        // so what fitted while it was still the fallback font may no longer fit.
        let stale = false;
        document.fonts?.ready.then(()=>{
            if (!stale) repack();
        });
        return ()=>{
            stale = true;
            observer.disconnect();
        };
    }, [
        probeText,
        valuesKey,
        suffix
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
        children: [
            groups.map((group, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                    icon: icon,
                    color: color,
                    className: // A tag down to a single value has nothing left to split, so from
                    // here on it is the text itself that has to give way.
                    group.length === 1 ? 'multi-value-tag multi-value-tag--wrapping' : 'multi-value-tag',
                    children: [
                        group.join($3db3e2fc7df578e0$var$SEPARATOR),
                        index === groups.length - 1 ? suffix : ''
                    ]
                }, index)),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                "aria-hidden": true,
                icon: icon,
                color: color,
                className: `multi-value-tag ${$3db3e2fc7df578e0$var$PROBE_CLASS}`,
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                    className: "multi-value-tag__probe-text",
                    ref: setProbeText
                })
            })
        ]
    });
};


const $110286bf6cbe15ec$var$normalizeFile = (e)=>{
    if (Array.isArray(e)) return e;
    return e?.fileList;
};
const $110286bf6cbe15ec$export$607b0d8e07f2c21e = ({ currentPlant: currentPlant, plantTitlePhoto: plantTitlePhoto, projectsList: projectsList, userPlantCollections: userPlantCollections })=>{
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    //const projectElements = projectsService.getUserProjectElements(currentPlant.projectId)
    const currentPlantFields = currentPlant.fields;
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const [timelineCollapsed, setTimelineCollapsed] = (0, $ltGt3.useState)(false);
    const [confidenceInPlantVariety, setConfidenceInPlantVariety] = (0, $ltGt3.useState)(currentPlant?.confidenceInPlantVariety);
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    const refreshPlantData = ()=>{
        submit(null, {
            method: 'post'
        });
        (0, $6139c0a58835b448$export$f5708c5af9a60b0c)();
    };
    const { value: projectElement, isLoading: projectElementLoading, error: error } = (0, $1e104381209dd9b4$export$78a72ddb39bdd145)('', async ()=>{
        if (!currentPlant.projectId) return undefined;
        const projectElements = await (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).getUserProjectElements(currentPlant.projectId);
        return projectElements.find((x)=>x.elementId === currentPlant.elementId).name;
    }, [
        currentPlant
    ]);
    const { value: gardenPlanVariantName } = (0, $1e104381209dd9b4$export$78a72ddb39bdd145)(undefined, async ()=>{
        if (!currentPlant.gardenPlanVariantId || !currentPlant.projectId) return undefined;
        const result = await (0, $5fab5f2ee6cc184e$export$9544d5bb712b01ea).getProjectGardenPlanVariants(currentPlant.projectId);
        return result.success ? result.projectGardenPlanVariants.find((variant)=>variant.id === currentPlant.gardenPlanVariantId)?.name : undefined;
    }, [
        currentPlant.gardenPlanVariantId,
        currentPlant.projectId
    ]);
    // The tags sit in a panel of their own, so it only earns its background and
    // its spacing once at least one of them has something to say.
    const hasTags = Boolean(currentPlantFields["\u0422\u0438\u043F"]?.length || currentPlantFields["\u041F\u043E\u043B\u0438\u0432"] || currentPlantFields["\u041E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0435 \u043A \u043E\u0441\u0432\u0435\u0449\u0435\u043D\u043D\u043E\u0441\u0442\u0438"]?.length || currentPlantFields["\u0421\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0443\u0445\u043E\u0434\u0430"] || currentPlantFields["\u0417\u043E\u043D\u044B \u043C\u043E\u0440\u043E\u0437\u043E\u0441\u0442\u043E\u0439\u043A\u043E\u0441\u0442\u0438 (USDA-\u0437\u043E\u043D\u044B)"]?.length);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "main-column__left",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                        className: "main-column__photo",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $54759b2dc7aee7a8$export$2e2bcd8739ae039), {
                            src: plantTitlePhoto,
                            preview: false
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                        className: "main-column__names",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                className: "main-column__names__title",
                                children: [
                                    currentPlantFields["\u041E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"],
                                    " ",
                                    currentPlantFields.\u0421\u043E\u0440\u0442,
                                    ' ',
                                    currentPlantFields["\u0423\u0442\u043E\u0447\u043D\u044F\u044E\u0449\u0430\u044F \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0430"] ? `(${currentPlantFields["\u0423\u0442\u043E\u0447\u043D\u044F\u044E\u0449\u0430\u044F \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0430"]})` : ''
                                ]
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "main-column__names__latin",
                                children: currentPlantFields["\u041D\u0430\u0443\u0447\u043D\u043E\u0435 (\u043B\u0430\u0442\u0438\u043D\u0441\u043A\u043E\u0435) \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"]
                            }),
                            currentPlantFields["\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                children: [
                                    intl.formatMessage({
                                        id: 'otherNames'
                                    }),
                                    ":",
                                    ' ',
                                    currentPlantFields["\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F"].replace('\n', ', ')
                                ]
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "main-column__names__family",
                                children: currentPlantFields["\u0421\u0435\u043C\u0435\u0439\u0441\u0442\u0432\u043E"]
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d029ee757225a242$export$2e2bcd8739ae039), {
                                className: "main-column__factors-tags",
                                size: [
                                    0,
                                    8
                                ],
                                wrap: true,
                                children: currentPlantFields["\u0424\u0430\u043A\u0442\u043E\u0440\u044B \u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438"] && currentPlantFields["\u0424\u0430\u043A\u0442\u043E\u0440\u044B \u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438"].map((f, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                        color: "gold",
                                        children: f
                                    }, index))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                orientation: "horizontal"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "main-column__user",
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "main-column__user__fields",
                            children: [
                                currentPlant.projectId && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "main-column__user__fields__field",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                            className: "main-column__user__fields__label",
                                            children: [
                                                intl.formatMessage({
                                                    id: 'thePlantIsInTheProject'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
                                            className: "main-column__user__fields__control",
                                            size: "large",
                                            allowClear: true,
                                            disabled: !!currentPlant.gardenPlanVariantId,
                                            onChange: async (projectId)=>{
                                                await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).editPlantProjectByPlantId(currentPlant.id, projectId);
                                                (0, $f72b095965a02692$export$355b0b6aff080555)();
                                                refreshPlantData();
                                                revalidator.revalidate();
                                            },
                                            defaultValue: currentPlant.projectId,
                                            options: projectsList.map((project)=>({
                                                    label: project.name,
                                                    value: project.id
                                                }))
                                        }),
                                        gardenPlanVariantName && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3336d90a99ceb065$export$2e2bcd8739ae039), {
                                            type: "warning",
                                            showIcon: true,
                                            title: intl.formatMessage({
                                                id: 'plantIsCreatedInGardenPlan'
                                            }, {
                                                planName: gardenPlanVariantName
                                            })
                                        })
                                    ]
                                }),
                                currentPlant.elementId && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "main-column__user__fields__field main-column__user__fields__field--text",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                            className: "main-column__user__fields__label",
                                            children: [
                                                intl.formatMessage({
                                                    id: 'onElement'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                            className: "main-column__user__input",
                                            children: projectElement
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "main-column__user__fields__field",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                            className: "main-column__user__fields__label",
                                            children: [
                                                intl.formatMessage({
                                                    id: 'plantDesignationOnTheMap'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $c188a30f9d7415a1$export$66ad816e0b868324), {
                                            className: "main-column__user__fields__control",
                                            userPlantTemplateId: (0, $670e204136b37e30$export$9544d5bb712b01ea).chooseElementTypeTemplate('plant', currentPlant.template),
                                            plantId: currentPlant ? currentPlant.id : null
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "main-column__user__fields__field",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                            className: "main-column__user__fields__label",
                                            children: [
                                                intl.formatMessage({
                                                    id: 'myCollections'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1d3237aa16cac649$export$a8f2899d4332e8e7), {
                                            className: "main-column__user__fields__control",
                                            plantCollections: currentPlant.collections,
                                            plantId: currentPlant ? currentPlant.id : null,
                                            onPlantCollectionsListUpdated: refreshPlantData,
                                            userPlantCollections: userPlantCollections
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                            checked: confidenceInPlantVariety,
                            disabled: currentPlant ? false : true,
                            onChange: async (e)=>{
                                (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).editConfidenceInPlantVarietyByPlantId(currentPlant.id, e.target.checked);
                                setConfidenceInPlantVariety(e.target.checked);
                            },
                            children: intl.formatMessage({
                                id: 'confidenceInPlantVariety'
                            })
                        }),
                        currentPlant.comment && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                intl.formatMessage({
                                    id: 'comment'
                                }),
                                ":",
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                    className: "main-column__user__input",
                                    children: ` ${currentPlant.comment}`
                                })
                            ]
                        }),
                        hasTags && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                            orientation: "horizontal"
                        }),
                        currentPlant?.photos?.length > 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                intl.formatMessage({
                                    id: 'myPhotos'
                                }),
                                ":",
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0ed5b0c7f51b3f3a$export$4a96334d5925dbf2), {
                                    photosIds: currentPlant.photos
                                })
                            ]
                        }),
                        currentPlant.plantBaseId && (currentPlantFields?.["\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F"]?.length ? 1 : 0) + (currentPlantFields?.["\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0446\u0432\u0435\u0442\u043E\u0432"]?.length ? 1 : 0) + (currentPlantFields?.["\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043B\u0438\u0441\u0442\u044C\u0435\u0432"]?.length ? 1 : 0) + (currentPlantFields?.["\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043F\u043B\u043E\u0434\u043E\u0432"]?.length ? 1 : 0) > 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4e173db25285d173$export$2c6ba43c30045a9b), {
                                plantName: currentPlant.name,
                                basePlantPhotos: currentPlantFields?.["\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F"],
                                basePlantFlowerPhotos: currentPlantFields?.["\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0446\u0432\u0435\u0442\u043E\u0432"],
                                basePlantLeavesPhotos: currentPlantFields?.["\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043B\u0438\u0441\u0442\u044C\u0435\u0432"],
                                basePlantFruitsPhotos: currentPlantFields?.["\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043F\u043B\u043E\u0434\u043E\u0432"],
                                plantBaseId: currentPlant.plantBaseId
                            })
                        })
                    ]
                })
            }),
            hasTags && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "main-column__tags",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "main-column__tags__row",
                    children: [
                        currentPlantFields["\u0422\u0438\u043F"] && currentPlantFields["\u0422\u0438\u043F"].map((type, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                children: type
                            }, index)),
                        currentPlantFields["\u041F\u043E\u043B\u0438\u0432"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                icon: $1113a0aa61ab7765$export$cc1b6e60cb98fb90
                            }),
                            color: "blue",
                            children: currentPlantFields["\u041F\u043E\u043B\u0438\u0432"]
                        }),
                        currentPlantFields["\u041E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0435 \u043A \u043E\u0441\u0432\u0435\u0449\u0435\u043D\u043D\u043E\u0441\u0442\u0438"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3db3e2fc7df578e0$export$f61fe101cc42bf77), {
                            values: currentPlantFields["\u041E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0435 \u043A \u043E\u0441\u0432\u0435\u0449\u0435\u043D\u043D\u043E\u0441\u0442\u0438"],
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                icon: $1113a0aa61ab7765$export$2fa35dcbc038dbe9
                            }),
                            color: "yellow"
                        }),
                        currentPlantFields["\u0421\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0443\u0445\u043E\u0434\u0430"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                icon: $1113a0aa61ab7765$export$6638511b28df3be5
                            }),
                            color: "purple",
                            children: [
                                currentPlantFields["\u0421\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0443\u0445\u043E\u0434\u0430"],
                                " ",
                                intl.formatMessage({
                                    id: 'careDifficulty'
                                })
                            ]
                        }),
                        currentPlantFields["\u0417\u043E\u043D\u044B \u043C\u043E\u0440\u043E\u0437\u043E\u0441\u0442\u043E\u0439\u043A\u043E\u0441\u0442\u0438 (USDA-\u0437\u043E\u043D\u044B)"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3db3e2fc7df578e0$export$f61fe101cc42bf77), {
                            values: currentPlantFields["\u0417\u043E\u043D\u044B \u043C\u043E\u0440\u043E\u0437\u043E\u0441\u0442\u043E\u0439\u043A\u043E\u0441\u0442\u0438 (USDA-\u0437\u043E\u043D\u044B)"],
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                                icon: $1113a0aa61ab7765$export$bab8f3647c394f48
                            }),
                            color: "deepskyblue",
                            suffix: ` (${intl.formatMessage({
                                id: 'uSDA'
                            })})`
                        })
                    ]
                })
            }),
            (currentPlantFields["\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0441\u043E\u0440\u0442\u0430"] || currentPlantFields["\u0414\u043E\u0441\u0442\u043E\u0438\u043D\u0441\u0442\u0432\u0430 \u0441\u043E\u0440\u0442\u0430"] || currentPlantFields["\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043A\u0438 \u0441\u043E\u0440\u0442\u0430"]) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                title: "description",
                children: [
                    currentPlantFields["\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0441\u043E\u0440\u0442\u0430"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            className: "main-column__base-info",
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $fe71a44f130a0d39$export$7460c8b7e4ce9582), {
                                skipHtml: true,
                                children: currentPlantFields["\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0441\u043E\u0440\u0442\u0430"]
                            })
                        })
                    }),
                    currentPlantFields["\u0414\u043E\u0441\u0442\u043E\u0438\u043D\u0441\u0442\u0432\u0430 \u0441\u043E\u0440\u0442\u0430"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'advantages'
                                    }),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "main-column__base-info",
                                children: currentPlantFields["\u0414\u043E\u0441\u0442\u043E\u0438\u043D\u0441\u0442\u0432\u0430 \u0441\u043E\u0440\u0442\u0430"]
                            })
                        ]
                    }),
                    currentPlantFields["\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043A\u0438 \u0441\u043E\u0440\u0442\u0430"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'disadvantages'
                                    }),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "main-column__base-info",
                                children: currentPlantFields["\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043A\u0438 \u0441\u043E\u0440\u0442\u0430"]
                            })
                        ]
                    })
                ]
            }),
            (currentPlantFields["\u0416\u0438\u0437\u043D\u0435\u043D\u043D\u044B\u0439 \u0446\u0438\u043A\u043B"] || currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043F\u043B\u043E\u0434\u043E\u043D\u043E\u0448\u0435\u043D\u0438\u044F"] || currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0438 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442"] || currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0438 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442"] || currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u044F"] || currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0438"]) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                title: "lifeCycle",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "main-column__calendar",
                    children: [
                        currentPlantFields["\u0416\u0438\u0437\u043D\u0435\u043D\u043D\u044B\u0439 \u0446\u0438\u043A\u043B"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                            color: "#f58153",
                            children: currentPlantFields["\u0416\u0438\u0437\u043D\u0435\u043D\u043D\u044B\u0439 \u0446\u0438\u043A\u043B"]?.join(', ')
                        }),
                        currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0438 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442"]?.includes("\u043F\u043E\u0441\u043B\u0435 \u043C\u0438\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0433\u0440\u043E\u0437\u044B \u0437\u0430\u043C\u043E\u0440\u043E\u0437\u043A\u043E\u0432") && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                            color: "#f58153",
                            children: intl.formatMessage({
                                id: "timeForPlantingSeedlingsInOpenedGround-\u043F\u043E\u0441\u043B\u0435 \u043C\u0438\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0433\u0440\u043E\u0437\u044B \u0437\u0430\u043C\u043E\u0440\u043E\u0437\u043A\u043E\u0432"
                            })
                        }),
                        (currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043F\u043B\u043E\u0434\u043E\u043D\u043E\u0448\u0435\u043D\u0438\u044F"] || currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0438 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442"] || currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0438 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442"] || currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u044F"] || currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0438"]) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7d9a693fc5c62427$export$91535c314826c067), {
                            lifeCycle: currentPlantFields["\u0416\u0438\u0437\u043D\u0435\u043D\u043D\u044B\u0439 \u0446\u0438\u043A\u043B"],
                            fruitingTime: currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043F\u043B\u043E\u0434\u043E\u043D\u043E\u0448\u0435\u043D\u0438\u044F"],
                            plantingCloseTime: currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0438 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442"],
                            plantingOpenTime: currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0438 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442"],
                            bloomingTime: currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u044F"],
                            pruningTime: currentPlantFields["\u0412\u0440\u0435\u043C\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0438"],
                            mode: timelineCollapsed ? 'oneLine' : 'multiLine'
                        })
                    ]
                })
            }),
            (currentPlantFields["\u0412\u044B\u0441\u043E\u0442\u0430 \u043E\u0442 (\u043C)"] || currentPlantFields["\u0412\u044B\u0441\u043E\u0442\u0430 \u0434\u043E (\u043C)"] || currentPlantFields["\u0420\u0430\u0437\u043C\u0435\u0440 \u0446\u0432\u0435\u0442\u043E\u0432 (\u0441\u043C)"] || currentPlantFields["\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u043E\u0442 (\u043C)"] || currentPlantFields["\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u0434\u043E (\u043C)"] || currentPlantFields["\u041C\u0430\u0441\u0441\u0430 \u043F\u043B\u043E\u0434\u043E\u0432 (\u0433)"] || currentPlantFields["\u0426\u0432\u0435\u0442 \u043B\u0438\u0441\u0442\u044C\u0435\u0432"] || currentPlantFields["\u0426\u0432\u0435\u0442 \u0446\u0432\u0435\u0442\u043E\u0432"]) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                title: "appearance",
                children: [
                    (currentPlantFields["\u0412\u044B\u0441\u043E\u0442\u0430 \u043E\u0442 (\u043C)"] || currentPlantFields["\u0412\u044B\u0441\u043E\u0442\u0430 \u0434\u043E (\u043C)"]) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'height'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u0412\u044B\u0441\u043E\u0442\u0430 \u043E\u0442 (\u043C)"] ? currentPlantFields["\u0412\u044B\u0441\u043E\u0442\u0430 \u043E\u0442 (\u043C)"] : '...',
                            ' ',
                            ' - ',
                            ' ',
                            currentPlantFields["\u0412\u044B\u0441\u043E\u0442\u0430 \u0434\u043E (\u043C)"] ? currentPlantFields["\u0412\u044B\u0441\u043E\u0442\u0430 \u0434\u043E (\u043C)"] : '...',
                            ' ',
                            intl.formatMessage({
                                id: 'm'
                            })
                        ]
                    }),
                    (currentPlantFields["\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u043E\u0442 (\u043C)"] || currentPlantFields["\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u0434\u043E (\u043C)"]) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'spreading'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u043E\u0442 (\u043C)"] ? currentPlantFields["\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u043E\u0442 (\u043C)"] : '...',
                            ' ',
                            ' - ',
                            ' ',
                            currentPlantFields["\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u0434\u043E (\u043C)"] ? currentPlantFields["\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u0434\u043E (\u043C)"] : '...',
                            ' ',
                            intl.formatMessage({
                                id: 'm'
                            })
                        ]
                    }),
                    currentPlantFields["\u0420\u0430\u0437\u043C\u0435\u0440 \u0446\u0432\u0435\u0442\u043E\u0432 (\u0441\u043C)"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'flowerSize'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u0420\u0430\u0437\u043C\u0435\u0440 \u0446\u0432\u0435\u0442\u043E\u0432 (\u0441\u043C)"],
                            " ",
                            intl.formatMessage({
                                id: 'cm'
                            })
                        ]
                    }),
                    currentPlantFields["\u041C\u0430\u0441\u0441\u0430 \u043F\u043B\u043E\u0434\u043E\u0432 (\u0433)"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'fruitMass'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u041C\u0430\u0441\u0441\u0430 \u043F\u043B\u043E\u0434\u043E\u0432 (\u0433)"],
                            " ",
                            intl.formatMessage({
                                id: 'g'
                            })
                        ]
                    }),
                    currentPlantFields["\u0426\u0432\u0435\u0442 \u043B\u0438\u0441\u0442\u044C\u0435\u0432"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'leafColor'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u0426\u0432\u0435\u0442 \u043B\u0438\u0441\u0442\u044C\u0435\u0432"]
                        ]
                    }),
                    currentPlantFields["\u0426\u0432\u0435\u0442 \u0446\u0432\u0435\u0442\u043E\u0432"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'flowerColor'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u0426\u0432\u0435\u0442 \u0446\u0432\u0435\u0442\u043E\u0432"]
                        ]
                    })
                ]
            }),
            (currentPlantFields["\u0413\u043B\u0443\u0431\u0438\u043D\u0430 \u043F\u043E\u0441\u0430\u0434\u043A\u0438 (\u0441\u043C)"] || currentPlantFields["\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430"] || currentPlantFields["\u0421\u043F\u043E\u0441\u043E\u0431\u044B \u0440\u0430\u0437\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u044F"] || currentPlantFields["\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432\u044B\u0440\u0430\u0449\u0438\u0432\u0430\u043D\u0438\u044F"] || currentPlantFields["\u041F\u043E\u0447\u0432\u0430 (\u0441\u0443\u0431\u0441\u0442\u0440\u0430\u0442)"]) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                title: "plantingAndReproduction",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "main-column__plant",
                    children: [
                        currentPlantFields["\u0413\u043B\u0443\u0431\u0438\u043D\u0430 \u043F\u043E\u0441\u0430\u0434\u043A\u0438 (\u0441\u043C)"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                    className: "plant-title-info-names",
                                    children: [
                                        intl.formatMessage({
                                            id: 'plantingDepth'
                                        }),
                                        ': '
                                    ]
                                }),
                                currentPlantFields["\u0413\u043B\u0443\u0431\u0438\u043D\u0430 \u043F\u043E\u0441\u0430\u0434\u043A\u0438 (\u0441\u043C)"]
                            ]
                        }),
                        currentPlantFields["\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                    className: "plant-title-info-names",
                                    children: [
                                        intl.formatMessage({
                                            id: 'featuresOfStoringPlantingMaterial'
                                        }),
                                        ': '
                                    ]
                                }),
                                currentPlantFields["\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430"]
                            ]
                        }),
                        currentPlantFields["\u0421\u043F\u043E\u0441\u043E\u0431\u044B \u0440\u0430\u0437\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u044F"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                    className: "plant-title-info-names",
                                    children: [
                                        intl.formatMessage({
                                            id: 'reproductionMethods'
                                        }),
                                        ': '
                                    ]
                                }),
                                currentPlantFields["\u0421\u043F\u043E\u0441\u043E\u0431\u044B \u0440\u0430\u0437\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u044F"].join(', ')
                            ]
                        }),
                        currentPlantFields["\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432\u044B\u0440\u0430\u0449\u0438\u0432\u0430\u043D\u0438\u044F"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                    className: "plant-title-info-names",
                                    children: [
                                        intl.formatMessage({
                                            id: 'featuresOfCultivation'
                                        }),
                                        ': '
                                    ]
                                }),
                                currentPlantFields["\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432\u044B\u0440\u0430\u0449\u0438\u0432\u0430\u043D\u0438\u044F"].join(', ')
                            ]
                        }),
                        currentPlantFields["\u041F\u043E\u0447\u0432\u0430 (\u0441\u0443\u0431\u0441\u0442\u0440\u0430\u0442)"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                    className: "plant-title-info-names",
                                    children: [
                                        intl.formatMessage({
                                            id: 'soil'
                                        }),
                                        ': '
                                    ]
                                }),
                                currentPlantFields["\u041F\u043E\u0447\u0432\u0430 (\u0441\u0443\u0431\u0441\u0442\u0440\u0430\u0442)"]
                            ]
                        })
                    ]
                })
            }),
            (currentPlantFields["\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043F\u043E \u0443\u0445\u043E\u0434\u0443"] || currentPlantFields["\u0411\u043E\u043B\u0435\u0437\u043D\u0438"] || currentPlantFields["\u0412\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u0438"] || currentPlantFields["\u041F\u0435\u0441\u0442\u0438\u0446\u0438\u0434\u044B"] || currentPlantFields["\u0423\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u044F"] || currentPlantFields["\u0427\u0430\u0441\u0442\u043E\u0442\u0430 \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0443\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0439"] || currentPlantFields["\u0427\u0430\u0441\u0442\u043E\u0442\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0441\u0442\u0438\u0446\u0438\u0434\u0430\u043C\u0438"] || currentPlantFields["\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u043B\u043E\u0434\u043E\u0432"] || currentPlantFields["\u042F\u0434\u043E\u0432\u0438\u0442\u043E\u0441\u0442\u044C"]) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                title: "care",
                children: [
                    currentPlantFields["\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043F\u043E \u0443\u0445\u043E\u0434\u0443"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'additionalCareSteps'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043F\u043E \u0443\u0445\u043E\u0434\u0443"].join(', ')
                        ]
                    }),
                    currentPlantFields["\u0411\u043E\u043B\u0435\u0437\u043D\u0438"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'disease'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u0411\u043E\u043B\u0435\u0437\u043D\u0438"].join(', ')
                        ]
                    }),
                    currentPlantFields["\u0412\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u0438"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'pests'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u0412\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u0438"].join(', ')
                        ]
                    }),
                    currentPlantFields["\u041F\u0435\u0441\u0442\u0438\u0446\u0438\u0434\u044B"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'pesticides'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u041F\u0435\u0441\u0442\u0438\u0446\u0438\u0434\u044B"]
                        ]
                    }),
                    currentPlantFields["\u0423\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u044F"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'fertilizers'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u0423\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u044F"]
                        ]
                    }),
                    currentPlantFields["\u0427\u0430\u0441\u0442\u043E\u0442\u0430 \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0443\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0439"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'fertilizerFrequency'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u0427\u0430\u0441\u0442\u043E\u0442\u0430 \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0443\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0439"]
                        ]
                    }),
                    currentPlantFields["\u0427\u0430\u0441\u0442\u043E\u0442\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0441\u0442\u0438\u0446\u0438\u0434\u0430\u043C\u0438"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'pesticideTreatmentFrequency'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u0427\u0430\u0441\u0442\u043E\u0442\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0441\u0442\u0438\u0446\u0438\u0434\u0430\u043C\u0438"].join(', ')
                        ]
                    }),
                    currentPlantFields["\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u043B\u043E\u0434\u043E\u0432"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'featuresOfFruitStorage'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u043B\u043E\u0434\u043E\u0432"]
                        ]
                    }),
                    currentPlantFields["\u042F\u0434\u043E\u0432\u0438\u0442\u043E\u0441\u0442\u044C"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'toxicity'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u042F\u0434\u043E\u0432\u0438\u0442\u043E\u0441\u0442\u044C"]
                        ]
                    })
                ]
            }),
            (currentPlantFields["\u041F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0432 \u0434\u0438\u0437\u0430\u0439\u043D\u0435"] || currentPlantFields["\u041D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435/\u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435"] || currentPlantFields["\u0421\u044A\u0435\u0434\u043E\u0431\u043D\u043E\u0441\u0442\u044C"] || currentPlantFields["\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430"]) && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                title: "usage",
                children: [
                    currentPlantFields["\u041F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0432 \u0434\u0438\u0437\u0430\u0439\u043D\u0435"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'applicationInDesign'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u041F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0432 \u0434\u0438\u0437\u0430\u0439\u043D\u0435"].join(', ')
                        ]
                    }),
                    currentPlantFields["\u041D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435/\u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'purposeLocation'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u041D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435/\u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435"].join(', ')
                        ]
                    }),
                    currentPlantFields["\u0421\u044A\u0435\u0434\u043E\u0431\u043D\u043E\u0441\u0442\u044C"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'edibility'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u0421\u044A\u0435\u0434\u043E\u0431\u043D\u043E\u0441\u0442\u044C"]
                        ]
                    }),
                    currentPlantFields["\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                className: "plant-title-info-names",
                                children: [
                                    intl.formatMessage({
                                        id: 'medicalProperties'
                                    }),
                                    ': '
                                ]
                            }),
                            currentPlantFields["\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430"]
                        ]
                    })
                ]
            })
        ]
    });
};






var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $201f3cc77b73c71a$var$SwapRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z"
                }
            }
        ]
    },
    "name": "swap-right",
    "theme": "outlined"
};
var $201f3cc77b73c71a$export$2e2bcd8739ae039 = $201f3cc77b73c71a$var$SwapRightOutlined;



function $b19183c66f28f9f0$var$_extends() {
    $b19183c66f28f9f0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b19183c66f28f9f0$var$_extends.apply(this, arguments);
}
const $b19183c66f28f9f0$var$SwapRightOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $b19183c66f28f9f0$var$_extends({}, props, {
        ref: ref,
        icon: (0, $201f3cc77b73c71a$export$2e2bcd8739ae039)
    }));
/**![swap-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3My4xIDU5Ni4ybC0xNjQtMjA4QTMyIDMyIDAgMDA2ODQgMzc2aC02NC44Yy02LjcgMC0xMC40IDcuNy02LjMgMTNsMTQ0LjMgMTgzSDE1MmMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGg2OTUuOWMyNi44IDAgNDEuNy0zMC44IDI1LjItNTEuOHoiIC8+PC9zdmc+) */ const $b19183c66f28f9f0$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($b19183c66f28f9f0$var$SwapRightOutlined);
var $b19183c66f28f9f0$export$2e2bcd8739ae039 = $b19183c66f28f9f0$var$RefIcon;

















var $ltGt3 = parcelRequire("ltGt3");



const $6c42ae56b714e124$var$useMergedPickerSemantic = (pickerType, classNames, styles, popupClassName, popupStyle, mergedProps)=>{
    const { classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)(pickerType);
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        }
    });
    return $ltGt3.useMemo(()=>{
        // ClassNames
        const filledClassNames = {
            ...mergedClassNames,
            popup: {
                ...mergedClassNames.popup,
                root: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassNames.popup?.root, popupClassName)
            }
        };
        // Styles
        const filledStyles = {
            ...mergedStyles,
            popup: {
                ...mergedStyles.popup,
                root: {
                    ...mergedStyles.popup?.root,
                    ...popupStyle
                }
            }
        };
        // Return
        return [
            filledClassNames,
            filledStyles
        ];
    }, [
        mergedClassNames,
        mergedStyles,
        popupClassName,
        popupStyle
    ]);
};
var $6c42ae56b714e124$export$2e2bcd8739ae039 = $6c42ae56b714e124$var$useMergedPickerSemantic;





var $ltGt3 = parcelRequire("ltGt3");

function $0b6d333bb800f480$export$d3f5c5e0a5023fa0(locale, picker, customizePlaceholder) {
    if (customizePlaceholder !== undefined) return customizePlaceholder;
    if (picker === 'year' && locale.lang.yearPlaceholder) return locale.lang.yearPlaceholder;
    if (picker === 'quarter' && locale.lang.quarterPlaceholder) return locale.lang.quarterPlaceholder;
    if (picker === 'month' && locale.lang.monthPlaceholder) return locale.lang.monthPlaceholder;
    if (picker === 'week' && locale.lang.weekPlaceholder) return locale.lang.weekPlaceholder;
    if (picker === 'time' && locale.timePickerLocale.placeholder) return locale.timePickerLocale.placeholder;
    return locale.lang.placeholder;
}
function $0b6d333bb800f480$export$9793711a144eaeae(locale, picker, customizePlaceholder) {
    if (customizePlaceholder !== undefined) return customizePlaceholder;
    if (picker === 'year' && locale.lang.yearPlaceholder) return locale.lang.rangeYearPlaceholder;
    if (picker === 'quarter' && locale.lang.quarterPlaceholder) return locale.lang.rangeQuarterPlaceholder;
    if (picker === 'month' && locale.lang.monthPlaceholder) return locale.lang.rangeMonthPlaceholder;
    if (picker === 'week' && locale.lang.weekPlaceholder) return locale.lang.rangeWeekPlaceholder;
    if (picker === 'time' && locale.timePickerLocale.placeholder) return locale.timePickerLocale.rangePlaceholder;
    return locale.lang.rangePlaceholder;
}
function $0b6d333bb800f480$export$75b0b37acc90e887(props, prefixCls) {
    const { allowClear: allowClear = true } = props;
    const { clearIcon: clearIcon, removeIcon: removeIcon } = (0, $6bc1cdde7926dc7f$export$2e2bcd8739ae039)({
        ...props,
        prefixCls: prefixCls,
        componentName: 'DatePicker'
    });
    const mergedAllowClear = $ltGt3.useMemo(()=>{
        if (allowClear === false) return false;
        const allowClearConfig = allowClear === true ? {} : allowClear;
        return {
            clearIcon: clearIcon,
            ...allowClearConfig
        };
    }, [
        allowClear,
        clearIcon
    ]);
    return [
        mergedAllowClear,
        removeIcon
    ];
}


const [$89c605c7364ed48b$export$3241045aa1844a20, $89c605c7364ed48b$export$f57ec95c006d390a] = [
    'week',
    'WeekPicker'
];
const [$89c605c7364ed48b$export$fa5253a4540f3e3a, $89c605c7364ed48b$export$b559b5cedf9ce559] = [
    'month',
    'MonthPicker'
];
const [$89c605c7364ed48b$export$90b88dc425a06a95, $89c605c7364ed48b$export$f4594efb24b701b2] = [
    'year',
    'YearPicker'
];
const [$89c605c7364ed48b$export$b470e30983f4a62f, $89c605c7364ed48b$export$1a7d99927693cc9d] = [
    'quarter',
    'QuarterPicker'
];
const [$89c605c7364ed48b$export$a9905336c0111a3a, $89c605c7364ed48b$export$5d6b097b9c0b7454] = [
    'time',
    'TimePicker'
];



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");


function $2c076ef9d3d8c3c3$var$_extends() {
    $2c076ef9d3d8c3c3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2c076ef9d3d8c3c3$var$_extends.apply(this, arguments);
}
const $2c076ef9d3d8c3c3$var$CalendarOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $2c076ef9d3d8c3c3$var$_extends({}, props, {
        ref: ref,
        icon: (0, $c97e10c6cd070738$export$2e2bcd8739ae039)
    }));
/**![calendar](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAxODRINzEydi02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMzg0di02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY2NjRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjIxNmMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDY1NkgxODRWNDYwaDY1NnYzODB6TTE4NCAzOTJWMjU2aDEyOHY0OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04di00OGgyNTZ2NDhjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOHYtNDhoMTI4djEzNkgxODR6IiAvPjwvc3ZnPg==) */ const $2c076ef9d3d8c3c3$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($2c076ef9d3d8c3c3$var$CalendarOutlined);
var $2c076ef9d3d8c3c3$export$2e2bcd8739ae039 = $2c076ef9d3d8c3c3$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $f501550f97370f0b$var$ClockCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                }
            }
        ]
    },
    "name": "clock-circle",
    "theme": "outlined"
};
var $f501550f97370f0b$export$2e2bcd8739ae039 = $f501550f97370f0b$var$ClockCircleOutlined;



function $a2a0cd16cbe39cbc$var$_extends() {
    $a2a0cd16cbe39cbc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a2a0cd16cbe39cbc$var$_extends.apply(this, arguments);
}
const $a2a0cd16cbe39cbc$var$ClockCircleOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $a2a0cd16cbe39cbc$var$_extends({}, props, {
        ref: ref,
        icon: (0, $f501550f97370f0b$export$2e2bcd8739ae039)
    }));
/**![clock-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTY4Ni43IDYzOC42TDU0NC4xIDUzNS41VjI4OGMwLTQuNC0zLjYtOC04LThINDg4Yy00LjQgMC04IDMuNi04IDh2Mjc1LjRjMCAyLjYgMS4yIDUgMy4zIDYuNWwxNjUuNCAxMjAuNmMzLjYgMi42IDguNiAxLjggMTEuMi0xLjdsMjguNi0zOWMyLjYtMy43IDEuOC04LjctMS44LTExLjJ6IiAvPjwvc3ZnPg==) */ const $a2a0cd16cbe39cbc$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($a2a0cd16cbe39cbc$var$ClockCircleOutlined);
var $a2a0cd16cbe39cbc$export$2e2bcd8739ae039 = $a2a0cd16cbe39cbc$var$RefIcon;



"use client";
const $06c0b9e7753f4244$var$SuffixIcon = ({ picker: picker, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon, suffixIcon: suffixIcon })=>{
    if (suffixIcon === null || suffixIcon === false) return null;
    if (suffixIcon === true || suffixIcon === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Fragment, null, picker === (0, $89c605c7364ed48b$export$a9905336c0111a3a) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $a2a0cd16cbe39cbc$export$2e2bcd8739ae039), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $2c076ef9d3d8c3c3$export$2e2bcd8739ae039), null), hasFeedback && feedbackIcon);
    return suffixIcon;
};
var $06c0b9e7753f4244$export$2e2bcd8739ae039 = $06c0b9e7753f4244$var$SuffixIcon;



var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");

"use client";
const $552f76f3a52f0905$var$PickerButton = (props)=>/*#__PURE__*/ $ltGt3.createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
        size: "small",
        type: "primary",
        ...props
    });
var $552f76f3a52f0905$export$2e2bcd8739ae039 = $552f76f3a52f0905$var$PickerButton;


function $58f21446587c2d5f$export$2e2bcd8739ae039(components) {
    return (0, $ltGt3.useMemo)(()=>({
            button: (0, $552f76f3a52f0905$export$2e2bcd8739ae039),
            ...components
        }), [
        components
    ]);
}


"use client";
const $226ac81616049702$var$generateRangePicker = (generateConfig)=>{
    const RangePicker = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
        const { prefixCls: customizePrefixCls, getPopupContainer: customGetPopupContainer, components: components, className: className, style: style, classNames: classNames, styles: styles, placement: placement, size: customizeSize, disabled: customDisabled, bordered: bordered = true, placeholder: placeholder, status: customStatus, variant: customVariant, picker: picker, dropdownClassName: dropdownClassName, popupClassName: popupClassName, popupStyle: popupStyle, rootClassName: rootClassName, suffixIcon: suffixIcon, ...restProps } = props;
        const pickerType = picker === (0, $89c605c7364ed48b$export$a9905336c0111a3a) ? 'timePicker' : 'datePicker';
        var oldProp, newProp;
        const [mergedClassNames, mergedStyles] = (0, $6c42ae56b714e124$export$2e2bcd8739ae039)(pickerType, classNames, styles, popupClassName || dropdownClassName, popupStyle);
        const innerRef = $ltGt3.useRef(null);
        const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, rangePicker: rangePicker } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
        const prefixCls = getPrefixCls('picker', customizePrefixCls);
        const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $8eabd28975be2fa5$export$cd8cf9d7bab8dd4)(prefixCls, direction);
        const rootPrefixCls = getPrefixCls();
        const [variant, enableVariantCls] = (0, $714175bf01098e4f$export$2e2bcd8739ae039)('rangePicker', customVariant, bordered);
        const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
        const [hashId, cssVarCls] = (0, $4d618cd3d6169a20$export$2e2bcd8739ae039)(prefixCls, rootCls);
        const mergedRootClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls, rootClassName);
        // ===================== Icon =====================
        const [mergedAllowClear] = (0, $0b6d333bb800f480$export$75b0b37acc90e887)(props, prefixCls);
        // ================== components ==================
        const mergedComponents = (0, $58f21446587c2d5f$export$2e2bcd8739ae039)(components);
        // ===================== Size =====================
        const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
        // ===================== Disabled =====================
        const disabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
        const mergedDisabled = customDisabled ?? disabled;
        // ===================== FormItemInput =====================
        const formItemContext = (0, $ltGt3.useContext)((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
        const { hasFeedback: hasFeedback, status: contextStatus, feedbackIcon: feedbackIcon } = formItemContext;
        const mergedSuffixIcon = /*#__PURE__*/ $ltGt3.createElement((0, $06c0b9e7753f4244$export$2e2bcd8739ae039), {
            picker: picker,
            hasFeedback: hasFeedback,
            feedbackIcon: feedbackIcon,
            suffixIcon: suffixIcon
        });
        (0, $ltGt3.useImperativeHandle)(ref, ()=>innerRef.current);
        const [contextLocale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('Calendar', (0, $70b7f2c44368fe54$export$2e2bcd8739ae039));
        const locale = {
            ...contextLocale,
            ...props.locale
        };
        // ============================ zIndex ============================
        const [zIndex] = (0, $ad5b6b465efa8f67$export$3e7906d4075187a4)('DatePicker', mergedStyles?.popup?.root?.zIndex);
        return /*#__PURE__*/ $ltGt3.createElement((0, $31ba6c57c6d43aeb$export$2e2bcd8739ae039), {
            space: true
        }, /*#__PURE__*/ $ltGt3.createElement((0, $2ffff18146ce6002$export$2e2bcd8739ae039), {
            separator: /*#__PURE__*/ $ltGt3.createElement("span", {
                "aria-label": "to",
                className: `${prefixCls}-separator`
            }, /*#__PURE__*/ $ltGt3.createElement((0, $b19183c66f28f9f0$export$2e2bcd8739ae039), null)),
            disabled: mergedDisabled,
            ref: innerRef,
            placement: placement,
            placeholder: (0, $0b6d333bb800f480$export$9793711a144eaeae)(locale, picker, placeholder),
            suffixIcon: mergedSuffixIcon,
            prevIcon: /*#__PURE__*/ $ltGt3.createElement("span", {
                className: `${prefixCls}-prev-icon`
            }),
            nextIcon: /*#__PURE__*/ $ltGt3.createElement("span", {
                className: `${prefixCls}-next-icon`
            }),
            superPrevIcon: /*#__PURE__*/ $ltGt3.createElement("span", {
                className: `${prefixCls}-super-prev-icon`
            }),
            superNextIcon: /*#__PURE__*/ $ltGt3.createElement("span", {
                className: `${prefixCls}-super-next-icon`
            }),
            transitionName: `${rootPrefixCls}-slide-up`,
            picker: picker,
            ...restProps,
            locale: locale.lang,
            getPopupContainer: customGetPopupContainer || getPopupContainer,
            generateConfig: generateConfig,
            components: mergedComponents,
            direction: direction,
            // Style
            prefixCls: prefixCls,
            rootClassName: mergedRootClassName,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${mergedSize}`]: mergedSize,
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $7b7bdeafff468875$export$b08e7b47149942a2)(prefixCls, (0, $7b7bdeafff468875$export$314e193082d7ba49)(contextStatus, customStatus), hasFeedback), compactItemClassnames, className, rangePicker?.className),
            style: {
                ...rangePicker?.style,
                ...style
            },
            // Semantic Style
            classNames: mergedClassNames,
            styles: {
                ...mergedStyles,
                popup: {
                    ...mergedStyles.popup,
                    root: {
                        ...mergedStyles.popup.root,
                        zIndex: zIndex
                    }
                }
            },
            allowClear: mergedAllowClear
        }));
    });
    return RangePicker;
};
var $226ac81616049702$export$2e2bcd8739ae039 = $226ac81616049702$var$generateRangePicker;



var $ltGt3 = parcelRequire("ltGt3");





















"use client";
const $315d24d0670a9962$var$generatePicker = (generateConfig)=>{
    const getPicker = (picker, displayName)=>{
        const pickerType = displayName === (0, $89c605c7364ed48b$export$5d6b097b9c0b7454) ? 'timePicker' : 'datePicker';
        const Picker = /*#__PURE__*/ (0, $ltGt3.forwardRef)((props, ref)=>{
            const { prefixCls: customizePrefixCls, getPopupContainer: customizeGetPopupContainer, components: components, style: style, className: className, size: customizeSize, bordered: bordered, placement: placement, placeholder: placeholder, disabled: customDisabled, status: customStatus, variant: customVariant, onCalendarChange: onCalendarChange, classNames: classNames, styles: styles, dropdownClassName: dropdownClassName, popupClassName: popupClassName, popupStyle: popupStyle, rootClassName: rootClassName, suffixIcon: suffixIcon, ...restProps } = props;
            var oldProp, newProp;
            const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, // Consume different styles according to different names
            [pickerType]: contextPickerConfig } = (0, $ltGt3.useContext)((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
            const prefixCls = getPrefixCls('picker', customizePrefixCls);
            // ===================== Size =====================
            const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $8eabd28975be2fa5$export$cd8cf9d7bab8dd4)(prefixCls, direction);
            const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
            // ===================== Disabled =====================
            const disabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
            const mergedDisabled = customDisabled ?? disabled;
            // =========== Merged Props for Semantic ===========
            const mergedProps = {
                ...props,
                size: mergedSize,
                disabled: mergedDisabled,
                status: customStatus,
                variant: customVariant
            };
            // ========================= Style ==========================
            // Use original useMergedPickerSemantic for proper popup handling
            const [mergedClassNames, mergedStyles] = (0, $6c42ae56b714e124$export$2e2bcd8739ae039)(pickerType, classNames, styles, popupClassName || dropdownClassName, popupStyle, mergedProps);
            const innerRef = $ltGt3.useRef(null);
            const [variant, enableVariantCls] = (0, $714175bf01098e4f$export$2e2bcd8739ae039)('datePicker', customVariant, bordered);
            const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
            const [hashId, cssVarCls] = (0, $4d618cd3d6169a20$export$2e2bcd8739ae039)(prefixCls, rootCls);
            const mergedRootClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls, rootClassName);
            (0, $ltGt3.useImperativeHandle)(ref, ()=>innerRef.current);
            const additionalProps = {
                showToday: true
            };
            const mergedPicker = picker || props.picker;
            const rootPrefixCls = getPrefixCls();
            // ==================== Legacy =====================
            const { onSelect: onSelect, multiple: multiple } = restProps;
            const hasLegacyOnSelect = onSelect && picker === 'time' && !multiple;
            const onInternalCalendarChange = (date, dateStr, info)=>{
                onCalendarChange?.(date, dateStr, info);
                if (hasLegacyOnSelect) onSelect(date);
            };
            // ===================== Icon =====================
            const [mergedAllowClear, removeIcon] = (0, $0b6d333bb800f480$export$75b0b37acc90e887)(props, prefixCls);
            // ================== components ==================
            const mergedComponents = (0, $58f21446587c2d5f$export$2e2bcd8739ae039)(components);
            // ===================== FormItemInput =====================
            const formItemContext = (0, $ltGt3.useContext)((0, $2fc8703031980156$export$bbb5553c6c7a14ed));
            const { hasFeedback: hasFeedback, status: contextStatus, feedbackIcon: feedbackIcon } = formItemContext;
            const mergedSuffixIcon = /*#__PURE__*/ $ltGt3.createElement((0, $06c0b9e7753f4244$export$2e2bcd8739ae039), {
                picker: mergedPicker,
                hasFeedback: hasFeedback,
                feedbackIcon: feedbackIcon,
                suffixIcon: suffixIcon
            });
            const [contextLocale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('DatePicker', (0, $70b7f2c44368fe54$export$2e2bcd8739ae039));
            const locale = {
                ...contextLocale,
                ...props.locale
            };
            // ============================ zIndex ============================
            const [zIndex] = (0, $ad5b6b465efa8f67$export$3e7906d4075187a4)('DatePicker', mergedStyles?.popup?.root?.zIndex);
            return /*#__PURE__*/ $ltGt3.createElement((0, $31ba6c57c6d43aeb$export$2e2bcd8739ae039), {
                space: true
            }, /*#__PURE__*/ $ltGt3.createElement((0, $28b44cb19d9b3cf6$export$2e2bcd8739ae039), {
                ref: innerRef,
                placeholder: (0, $0b6d333bb800f480$export$d3f5c5e0a5023fa0)(locale, mergedPicker, placeholder),
                suffixIcon: mergedSuffixIcon,
                placement: placement,
                prevIcon: /*#__PURE__*/ $ltGt3.createElement("span", {
                    className: `${prefixCls}-prev-icon`
                }),
                nextIcon: /*#__PURE__*/ $ltGt3.createElement("span", {
                    className: `${prefixCls}-next-icon`
                }),
                superPrevIcon: /*#__PURE__*/ $ltGt3.createElement("span", {
                    className: `${prefixCls}-super-prev-icon`
                }),
                superNextIcon: /*#__PURE__*/ $ltGt3.createElement("span", {
                    className: `${prefixCls}-super-next-icon`
                }),
                transitionName: `${rootPrefixCls}-slide-up`,
                picker: picker,
                onCalendarChange: onInternalCalendarChange,
                ...additionalProps,
                ...restProps,
                locale: locale.lang,
                getPopupContainer: customizeGetPopupContainer || getPopupContainer,
                generateConfig: generateConfig,
                components: mergedComponents,
                direction: direction,
                disabled: mergedDisabled,
                // Style
                prefixCls: prefixCls,
                rootClassName: mergedRootClassName,
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
                    [`${prefixCls}-${mergedSize}`]: mergedSize,
                    [`${prefixCls}-${variant}`]: enableVariantCls
                }, (0, $7b7bdeafff468875$export$b08e7b47149942a2)(prefixCls, (0, $7b7bdeafff468875$export$314e193082d7ba49)(contextStatus, customStatus), hasFeedback), compactItemClassnames, contextPickerConfig?.className, className),
                style: {
                    ...contextPickerConfig?.style,
                    ...style
                },
                // Semantic Style
                classNames: mergedClassNames,
                styles: {
                    ...mergedStyles,
                    popup: {
                        ...mergedStyles.popup,
                        root: {
                            ...mergedStyles.popup.root,
                            zIndex: zIndex
                        }
                    }
                },
                allowClear: mergedAllowClear,
                removeIcon: removeIcon
            }));
        });
        return Picker;
    };
    const DatePicker = getPicker();
    const WeekPicker = getPicker((0, $89c605c7364ed48b$export$3241045aa1844a20), (0, $89c605c7364ed48b$export$f57ec95c006d390a));
    const MonthPicker = getPicker((0, $89c605c7364ed48b$export$fa5253a4540f3e3a), (0, $89c605c7364ed48b$export$b559b5cedf9ce559));
    const YearPicker = getPicker((0, $89c605c7364ed48b$export$90b88dc425a06a95), (0, $89c605c7364ed48b$export$f4594efb24b701b2));
    const QuarterPicker = getPicker((0, $89c605c7364ed48b$export$b470e30983f4a62f), (0, $89c605c7364ed48b$export$1a7d99927693cc9d));
    const TimePicker = getPicker((0, $89c605c7364ed48b$export$a9905336c0111a3a), (0, $89c605c7364ed48b$export$5d6b097b9c0b7454));
    return {
        DatePicker: DatePicker,
        WeekPicker: WeekPicker,
        MonthPicker: MonthPicker,
        YearPicker: YearPicker,
        TimePicker: TimePicker,
        QuarterPicker: QuarterPicker
    };
};
var $315d24d0670a9962$export$2e2bcd8739ae039 = $315d24d0670a9962$var$generatePicker;


"use client";
const $6403e5e58aef08df$var$generatePicker = (generateConfig)=>{
    // =========================== Picker ===========================
    const { DatePicker: DatePicker, WeekPicker: WeekPicker, MonthPicker: MonthPicker, YearPicker: YearPicker, TimePicker: TimePicker, QuarterPicker: QuarterPicker } = (0, $315d24d0670a9962$export$2e2bcd8739ae039)(generateConfig);
    // ======================== Range Picker ========================
    const RangePicker = (0, $226ac81616049702$export$2e2bcd8739ae039)(generateConfig);
    const MergedDatePicker = DatePicker;
    MergedDatePicker.WeekPicker = WeekPicker;
    MergedDatePicker.MonthPicker = MonthPicker;
    MergedDatePicker.YearPicker = YearPicker;
    MergedDatePicker.RangePicker = RangePicker;
    MergedDatePicker.TimePicker = TimePicker;
    MergedDatePicker.QuarterPicker = QuarterPicker;
    return MergedDatePicker;
};
var $6403e5e58aef08df$export$2e2bcd8739ae039 = $6403e5e58aef08df$var$generatePicker;


"use client";
const $878317098e859dd0$var$DatePicker = (0, $6403e5e58aef08df$export$2e2bcd8739ae039)((0, $a9d33dc0563db000$export$2e2bcd8739ae039));
// We don't care debug panel
/* istanbul ignore next */ const $878317098e859dd0$var$PurePanel = (0, $c64d2291d230fcde$export$2e2bcd8739ae039)($878317098e859dd0$var$DatePicker, 'popupAlign', undefined, 'picker');
$878317098e859dd0$var$DatePicker._InternalPanelDoNotUseOrYouWillBeFired = $878317098e859dd0$var$PurePanel;
const $878317098e859dd0$var$PureRangePanel = (0, $c64d2291d230fcde$export$2e2bcd8739ae039)($878317098e859dd0$var$DatePicker.RangePicker, 'popupAlign', undefined, 'picker');
$878317098e859dd0$var$DatePicker._InternalRangePanelDoNotUseOrYouWillBeFired = $878317098e859dd0$var$PureRangePanel;
$878317098e859dd0$var$DatePicker.generatePicker = (0, $6403e5e58aef08df$export$2e2bcd8739ae039);
var $878317098e859dd0$export$2e2bcd8739ae039 = $878317098e859dd0$var$DatePicker;



var $ltGt3 = parcelRequire("ltGt3");

const $ec20113856fdaafd$export$4e4cb19dd88cd821 = 'YYYY-MM-DD';




parcelRequire("ltGt3");




function $e3191dd369e6ad56$export$354073dd3a214b42({ selectedProjectId: selectedProjectId, projectsList: projectsList, fieldName: fieldName = 'elementId', preventFormCloseDueToModification: preventFormCloseDueToModification }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const projectFromRoute = ((0, $493cbc5b00d91baa$export$fd5d37484eab868d)('project') || {}).project || undefined;
    const { value: availableElements, isLoading: availableElementsLoading, error: error } = (0, $1e104381209dd9b4$export$78a72ddb39bdd145)([], async ()=>{
        const project = projectsList.find((p)=>p.id === selectedProjectId);
        if (!project) return [];
        if (project.id === projectFromRoute?.id) return projectFromRoute?.elements?.map((e)=>({
                value: e.elementId,
                label: e.name
            })) || [];
        const elements = await (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).getUserProjectElements(project.id);
        return elements.map((e)=>({
                value: e.elementId,
                label: e.name
            }));
    }, [
        selectedProjectId
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
        name: fieldName,
        label: intl.formatMessage({
            id: 'element'
        }),
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
            loading: availableElementsLoading,
            allowClear: true,
            options: availableElementsLoading ? [] : availableElements
        })
    });
}




parcelRequire("ltGt3");

function $6ffd02bbc967fbfd$export$358d287cc4a0d9bd({ projectsList: projectsList, fieldName: fieldName = 'projectId', preventFormCloseDueToModification: preventFormCloseDueToModification, disabled: disabled, extra: extra }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
        name: fieldName,
        label: intl.formatMessage({
            id: 'project'
        }),
        extra: extra,
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
            allowClear: true,
            disabled: disabled,
            onChange: preventFormCloseDueToModification,
            options: projectsList.map((project)=>({
                    label: project.name,
                    value: project.id
                }))
        })
    });
}





parcelRequire("ltGt3");


parcelRequire("ltGt3");



function $7d66179513d25bf3$export$b322c47b2525bd34(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        className: "ant-form-item",
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
            className: "edit-plant-form__range-field",
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                    md: 8,
                    className: "edit-plant-form__range-field-label",
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("label", {
                        htmlFor: props.fieldKeyFrom,
                        children: intl.formatMessage({
                            id: props.fieldName
                        })
                    })
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                    md: 16,
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d029ee757225a242$export$2e2bcd8739ae039).Compact, {
                        block: true,
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                name: props.fieldKeyFrom,
                                noStyle: true,
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $bbe04e8e6f6789c3$export$2e2bcd8739ae039), {
                                    addonAfter: "-",
                                    className: "edit-plant-form__range-field-input-wrapper"
                                })
                            }, props.fieldKeyFrom),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                name: props.fieldKeyTo,
                                noStyle: true,
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $bbe04e8e6f6789c3$export$2e2bcd8739ae039), {
                                    className: "edit-plant-form__range-field-input-wrapper"
                                })
                            }, props.fieldKeyTo)
                        ]
                    })
                })
            ]
        })
    });
}



function $920a43afcbc49243$export$624f702044eb7ad(group, preventFormCloseDueToModification) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return group.map(([key, field], index)=>{
        let element = null;
        if (field.type === 'range-start') {
            const fieldTo = group.find((f)=>f[1].type === 'range-end' && f[1].rangeId === field.rangeId);
            return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7d66179513d25bf3$export$b322c47b2525bd34), {
                fieldName: field.rangeId,
                fieldKeyFrom: key,
                filedFrom: field,
                fieldKeyTo: fieldTo[0],
                fieldTo: fieldTo[1]
            }, key);
        } else if (field.type === 'text') element = /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).TextArea, {
            autoSize: true
        }, index);
        else if (field.type === 'enum-dropdown') element = /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
            allowClear: true,
            onChange: preventFormCloseDueToModification,
            options: field.options.map((option)=>({
                    value: option,
                    label: field.monthsOptions ? intl.formatMessage({
                        id: option
                    }) : intl.formatMessage({
                        id: `${field.translationId}-${option}`
                    })
                })),
            mode: field.multiple === true ? 'multiple' : undefined
        }, index);
        if (!element) return null;
        return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
            name: key,
            label: intl.formatMessage({
                id: field.translationId
            }),
            tooltip: field.tooltip ? {
                title: intl.formatMessage({
                    id: `${field.translationId}-tooltip`
                }),
                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $35775a005ce7c86e$export$2e2bcd8739ae039), {})
            } : null,
            children: element
        }, key);
    });
}






function $013e30408cecb25a$var$preparePhotos(plantName, databasePlant, fieldName, tag) {
    const photos = databasePlant[fieldName];
    if (!Array.isArray(photos)) return [];
    return photos.map((photo, index)=>({
            uid: index + tag,
            name: `${plantName}-${tag}-${index}`,
            status: 'done',
            url: photo.url,
            photoType: fieldName
        }));
}
async function $013e30408cecb25a$export$bd5991ff6ac58908(plant, databasePlantFields) {
    const databasePlant = (0, $e0eda949f811dcf3$export$4e4b0a0660d01171)({}, databasePlantFields, {
        language: 'ru'
    }, true);
    const plantName = databasePlant["\u041E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"];
    const basePlantPhotos = $013e30408cecb25a$var$preparePhotos(plantName, databasePlant || {}, "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F");
    const basePlantFlowersPhotos = $013e30408cecb25a$var$preparePhotos(plantName, databasePlant || {}, "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0446\u0432\u0435\u0442\u043E\u0432", 'f');
    const basePlantLeavesPhotos = $013e30408cecb25a$var$preparePhotos(plantName, databasePlant || {}, "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043B\u0438\u0441\u0442\u044C\u0435\u0432", 'l');
    const basePlantFruitsPhotos = $013e30408cecb25a$var$preparePhotos(plantName, databasePlant || {}, "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043F\u043B\u043E\u0434\u043E\u0432", 'fr');
    const signedPhotoURLs = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getPlantImageURLs(plant?.photos);
    const userPlantPhotos = plant?.photos.map((photoName, index)=>({
            uid: index,
            photoName: photoName,
            name: plant.name + index,
            status: 'done',
            url: signedPhotoURLs.urls[index],
            photoType: "\u041C\u043E\u0438 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438"
        }));
    // только поля, зависящие от базового растения: собственные поля растения (название,
    // проект, участок, комментарий, дата посадки) не должны перезаписывать правки в форме
    const fieldValues = {
        ...databasePlant || {},
        ...plant?.overwrittenBaseFields,
        files: [
            ...basePlantPhotos,
            ...basePlantFlowersPhotos || [],
            ...basePlantLeavesPhotos || [],
            ...basePlantFruitsPhotos || [],
            ...userPlantPhotos || []
        ]
    };
    return fieldValues;
}










var $ltGt3 = parcelRequire("ltGt3");







var $ltGt3 = parcelRequire("ltGt3");

var $28c4ad1246a5f174$exports = {};
var $caec2e93a0bcddcb$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $caec2e93a0bcddcb$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$caec2e93a0bcddcb$exports = $caec2e93a0bcddcb$var$isObject;


var $7f4dc0d1abb9bf54$exports = {};
var $eef2fc5286ed9de2$exports = {};
var $77fd8497e040fe50$exports = {};
/** Detect free variable `global` from Node.js. */ var $77fd8497e040fe50$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$77fd8497e040fe50$exports = $77fd8497e040fe50$var$freeGlobal;


/** Detect free variable `self`. */ var $eef2fc5286ed9de2$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $eef2fc5286ed9de2$var$root = $77fd8497e040fe50$exports || $eef2fc5286ed9de2$var$freeSelf || Function('return this')();
$eef2fc5286ed9de2$exports = $eef2fc5286ed9de2$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $7f4dc0d1abb9bf54$var$now = function() {
    return $eef2fc5286ed9de2$exports.Date.now();
};
$7f4dc0d1abb9bf54$exports = $7f4dc0d1abb9bf54$var$now;


var $b1741a4c0880a8b3$exports = {};
var $281f34bd8b22ce6f$exports = {};
var $60bf771fd2d93d81$exports = {};
/** Used to match a single whitespace character. */ var $60bf771fd2d93d81$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $60bf771fd2d93d81$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $60bf771fd2d93d81$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$60bf771fd2d93d81$exports = $60bf771fd2d93d81$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $281f34bd8b22ce6f$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $281f34bd8b22ce6f$var$baseTrim(string) {
    return string ? string.slice(0, $60bf771fd2d93d81$exports(string) + 1).replace($281f34bd8b22ce6f$var$reTrimStart, '') : string;
}
$281f34bd8b22ce6f$exports = $281f34bd8b22ce6f$var$baseTrim;



var $bce216f79cd5ae3d$exports = {};
var $57e1989c22ba0835$exports = {};
var $d4943ac7302d43f5$exports = {};

/** Built-in value references. */ var $d4943ac7302d43f5$var$Symbol = $eef2fc5286ed9de2$exports.Symbol;
$d4943ac7302d43f5$exports = $d4943ac7302d43f5$var$Symbol;


var $121ffe2374e43ab0$exports = {};

/** Used for built-in method references. */ var $121ffe2374e43ab0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $121ffe2374e43ab0$var$hasOwnProperty = $121ffe2374e43ab0$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $121ffe2374e43ab0$var$nativeObjectToString = $121ffe2374e43ab0$var$objectProto.toString;
/** Built-in value references. */ var $121ffe2374e43ab0$var$symToStringTag = $d4943ac7302d43f5$exports ? $d4943ac7302d43f5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $121ffe2374e43ab0$var$getRawTag(value) {
    var isOwn = $121ffe2374e43ab0$var$hasOwnProperty.call(value, $121ffe2374e43ab0$var$symToStringTag), tag = value[$121ffe2374e43ab0$var$symToStringTag];
    try {
        value[$121ffe2374e43ab0$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $121ffe2374e43ab0$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$121ffe2374e43ab0$var$symToStringTag] = tag;
        else delete value[$121ffe2374e43ab0$var$symToStringTag];
    }
    return result;
}
$121ffe2374e43ab0$exports = $121ffe2374e43ab0$var$getRawTag;


var $9426fb5b1e688c6f$exports = {};
/** Used for built-in method references. */ var $9426fb5b1e688c6f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9426fb5b1e688c6f$var$nativeObjectToString = $9426fb5b1e688c6f$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $9426fb5b1e688c6f$var$objectToString(value) {
    return $9426fb5b1e688c6f$var$nativeObjectToString.call(value);
}
$9426fb5b1e688c6f$exports = $9426fb5b1e688c6f$var$objectToString;


/** `Object#toString` result references. */ var $57e1989c22ba0835$var$nullTag = '[object Null]', $57e1989c22ba0835$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $57e1989c22ba0835$var$symToStringTag = $d4943ac7302d43f5$exports ? $d4943ac7302d43f5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $57e1989c22ba0835$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $57e1989c22ba0835$var$undefinedTag : $57e1989c22ba0835$var$nullTag;
    return $57e1989c22ba0835$var$symToStringTag && $57e1989c22ba0835$var$symToStringTag in Object(value) ? $121ffe2374e43ab0$exports(value) : $9426fb5b1e688c6f$exports(value);
}
$57e1989c22ba0835$exports = $57e1989c22ba0835$var$baseGetTag;


var $c28614115d2118e4$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c28614115d2118e4$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$c28614115d2118e4$exports = $c28614115d2118e4$var$isObjectLike;


/** `Object#toString` result references. */ var $bce216f79cd5ae3d$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $bce216f79cd5ae3d$var$isSymbol(value) {
    return typeof value == 'symbol' || $c28614115d2118e4$exports(value) && $57e1989c22ba0835$exports(value) == $bce216f79cd5ae3d$var$symbolTag;
}
$bce216f79cd5ae3d$exports = $bce216f79cd5ae3d$var$isSymbol;


/** Used as references for various `Number` constants. */ var $b1741a4c0880a8b3$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $b1741a4c0880a8b3$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $b1741a4c0880a8b3$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $b1741a4c0880a8b3$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $b1741a4c0880a8b3$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $b1741a4c0880a8b3$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($bce216f79cd5ae3d$exports(value)) return $b1741a4c0880a8b3$var$NAN;
    if ($caec2e93a0bcddcb$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $caec2e93a0bcddcb$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $281f34bd8b22ce6f$exports(value);
    var isBinary = $b1741a4c0880a8b3$var$reIsBinary.test(value);
    return isBinary || $b1741a4c0880a8b3$var$reIsOctal.test(value) ? $b1741a4c0880a8b3$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $b1741a4c0880a8b3$var$reIsBadHex.test(value) ? $b1741a4c0880a8b3$var$NAN : +value;
}
$b1741a4c0880a8b3$exports = $b1741a4c0880a8b3$var$toNumber;


/** Error message constants. */ var $28c4ad1246a5f174$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $28c4ad1246a5f174$var$nativeMax = Math.max, $28c4ad1246a5f174$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $28c4ad1246a5f174$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($28c4ad1246a5f174$var$FUNC_ERROR_TEXT);
    wait = $b1741a4c0880a8b3$exports(wait) || 0;
    if ($caec2e93a0bcddcb$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $28c4ad1246a5f174$var$nativeMax($b1741a4c0880a8b3$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $28c4ad1246a5f174$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $7f4dc0d1abb9bf54$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($7f4dc0d1abb9bf54$exports());
    }
    function debounced() {
        var time = $7f4dc0d1abb9bf54$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$28c4ad1246a5f174$exports = $28c4ad1246a5f174$var$debounce;



const $f4f00b057006fa03$var$noImageUrl = '';
function $f4f00b057006fa03$export$266657211bb29907({ debounceTimeout: debounceTimeout = 500, onDBPlantSelected: onDBPlantSelected }) {
    const fetchRef = (0, $ltGt3.useRef)(0);
    const selectRef = (0, $ltGt3.useRef)(null);
    const [loading, setLoading] = (0, $ltGt3.useState)(false);
    const [options, setOptions] = (0, $ltGt3.useState)([]);
    const [selectedOptionId, setSelectedOptionId] = (0, $ltGt3.useState)(null);
    const [isDropdownOpen, setDropdownOpen] = (0, $ltGt3.useState)(false);
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const debouncedOptionsLoader = (0, $ltGt3.useMemo)(()=>{
        const loadOptions = async (searchQuery)=>{
            if (!searchQuery || searchQuery.length < 3) {
                setLoading(false);
                setOptions([]);
                return;
            }
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            const searchResult = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).searchPlantsDatabase(searchQuery);
            if (fetchId != fetchRef.current) return;
            setLoading(false);
            if (!searchResult.success) return;
            setOptions(searchResult.data?.data?.records || []);
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($28c4ad1246a5f174$exports)))(loadOptions, debounceTimeout);
    }, [
        debounceTimeout
    ]);
    (0, $ltGt3.useEffect)(()=>{
        const frame = requestAnimationFrame(()=>selectRef.current?.focus());
        return ()=>cancelAnimationFrame(frame);
    }, []);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
            ref: selectRef,
            showSearch: true,
            allowClear: true,
            labelInValue: true,
            filterOption: false,
            onSearch: debouncedOptionsLoader,
            notFoundContent: loading ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f5e177132d6f3f0f$export$2e2bcd8739ae039), {
                size: "small"
            }) : null,
            style: {
                width: '100%',
                height: 'auto'
            },
            classNames: {
                popup: {
                    root: 'plant-search-dropdown'
                }
            },
            // The option list is left open after a pick unless it is driven
            // explicitly. With a mouse that is only untidy, but on a touch device the
            // list covers the confirm button underneath it, so there is no way to
            // finish choosing a base plant.
            open: isDropdownOpen,
            onOpenChange: setDropdownOpen,
            onChange: (value, { option: option = null } = {})=>{
                setDropdownOpen(false);
                setSelectedOptionId(value);
                onDBPlantSelected(option);
            },
            value: selectedOptionId,
            placeholder: intl.formatMessage({
                id: 'searchForBasePlant'
            }),
            children: options.map((option)=>{
                const fields = (0, $e0eda949f811dcf3$export$4e4b0a0660d01171)({}, option.fields, {
                    language: intl.locale
                }, true);
                return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039).Option, {
                    value: option.id,
                    option: option,
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "plant-search-option",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "plant-search-option__image",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                                        src: option.thumbnailUrl || $f4f00b057006fa03$var$noImageUrl
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                className: "plant-search-option__fields",
                                children: [
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                        children: fields["\u041E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"]
                                    }),
                                    fields["\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("small", {
                                        className: "other-names wrap",
                                        children: fields["\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F"]
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("em", {
                                        children: fields["\u041D\u0430\u0443\u0447\u043D\u043E\u0435 (\u043B\u0430\u0442\u0438\u043D\u0441\u043A\u043E\u0435) \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"]
                                    }),
                                    fields["\u0421\u043E\u0440\u0442"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                        className: "variety wrap",
                                        children: fields["\u0421\u043E\u0440\u0442"]
                                    }),
                                    fields["\u0423\u0442\u043E\u0447\u043D\u044F\u044E\u0449\u0430\u044F \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0430"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("small", {
                                        children: [
                                            "(",
                                            fields["\u0423\u0442\u043E\u0447\u043D\u044F\u044E\u0449\u0430\u044F \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0430"],
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }, option.id);
            })
        })
    });
}
function $f4f00b057006fa03$export$83fc57ddcf2f1ee8(props) {
    const [selectedPlant, setSelectedPlant] = (0, $ltGt3.useState)(null);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "baseplant-search",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "baseplant-search__field",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($f4f00b057006fa03$export$266657211bb29907, {
                    onDBPlantSelected: setSelectedPlant
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                className: "baseplant-search__confirm",
                disabled: selectedPlant === null,
                type: "primary",
                size: "middle",
                onClick: ()=>{
                    if (selectedPlant) props.onDBPlantSelected(selectedPlant);
                },
                children: props.selectButtonText
            })
        ]
    });
}



function $408c96f367a310dd$export$6787be8007574362({ basePlantId: basePlantId, onBasePlantSelected: onBasePlantSelected }) {
    const [selectedBasePlant, setSelectedBasePlant] = (0, $ltGt3.useState)(null);
    const [isLoading, setLoading] = (0, $ltGt3.useState)(Boolean(basePlantId));
    const [isSelectorVisible, setSelectorVisible] = (0, $ltGt3.useState)(false);
    const [clearBaseFieldsChecked, setClearBaseFieldsChecked] = (0, $ltGt3.useState)(false);
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    (0, $ltGt3.useEffect)(()=>{
        if (!basePlantId) {
            setSelectedBasePlant(null);
            return;
        }
        (async ()=>{
            try {
                const initialPlant = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getPlantFromPlantDatabaseById(basePlantId);
                if (initialPlant.status === 'found') setSelectedBasePlant(initialPlant.data);
            } finally{
                setLoading(false);
            }
        })();
    }, [
        basePlantId
    ]);
    // <div>{intl.formatMessage({id: 'searchingPlantBase'})}</div>
    //     <PlantDatabaseSearchField
    //       initialSelectedPlantId={currentPlant.plantBaseId}
    //       onDBPlantSelected={(p) => {
    //         setSearchSelectedBasePlant(p)
    //       }}
    //     />
    if (isLoading) return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f5e177132d6f3f0f$export$2e2bcd8739ae039), {});
    const renderBasePlantSelectPopover = (content)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6425aad248c6262a$export$2e2bcd8739ae039), {
            destroyTooltipOnHide: true,
            classNames: {
                root: 'baseplant-popover'
            },
            content: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f4f00b057006fa03$export$83fc57ddcf2f1ee8), {
                selectButtonText: selectedBasePlant ? intl.formatMessage({
                    id: 'overwriteBasePlant'
                }) : intl.formatMessage({
                    id: 'select'
                }),
                onDBPlantSelected: (plant)=>{
                    setSelectorVisible(false);
                    onBasePlantSelected(plant, selectedBasePlant ? selectedBasePlant?.fields || {} : {}, plant.thumbnailUrl);
                }
            }),
            trigger: "click",
            open: isSelectorVisible,
            onOpenChange: setSelectorVisible,
            placement: "bottom",
            children: content
        });
    if (!selectedBasePlant) return renderBasePlantSelectPopover(/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
        className: "baseplant-add-button",
        children: intl.formatMessage({
            id: 'addFromPlantDatabase'
        })
    }));
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
            children: [
                intl.formatMessage({
                    id: 'nowUsingBasePlant'
                }),
                ":",
                ' ',
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("strong", {
                    style: {
                        marginRight: 10
                    },
                    children: [
                        selectedBasePlant.fields["\u041E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"],
                        selectedBasePlant.fields["\u0421\u043E\u0440\u0442_eng"] || selectedBasePlant.fields["\u0421\u043E\u0440\u0442_ru"] ? ` ${selectedBasePlant.fields["\u0421\u043E\u0440\u0442_eng"]}` ? ` ${selectedBasePlant.fields["\u0421\u043E\u0440\u0442_eng"]}` : ` ${selectedBasePlant.fields["\u0421\u043E\u0440\u0442_ru"]}` : ''
                    ]
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039).Group, {
                    size: "small",
                    className: "baseplant-edit-button-group",
                    children: [
                        renderBasePlantSelectPopover(/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $792ee1d77f42b361$export$2e2bcd8739ae039), {}),
                            children: intl.formatMessage({
                                id: 'changeBasePlant'
                            })
                        })),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
                            title: `${intl.formatMessage({
                                id: 'confirmClearBasePlant'
                            })}?`,
                            onOpenChange: ()=>setClearBaseFieldsChecked(false),
                            onConfirm: ()=>onBasePlantSelected(null, clearBaseFieldsChecked ? selectedBasePlant?.fields || {} : {}, null),
                            description: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                                    checked: clearBaseFieldsChecked,
                                    onChange: (e)=>setClearBaseFieldsChecked(e.target.checked),
                                    children: [
                                        intl.formatMessage({
                                            id: 'clearBasePlantMatchingFields'
                                        }),
                                        "?"
                                    ]
                                })
                            }),
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                danger: true,
                                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1e0519456d104339$export$2e2bcd8739ae039), {}),
                                children: intl.formatMessage({
                                    id: 'clearBasePlant'
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}



var $Ohofd = parcelRequire("Ohofd");




const $be73dcef9e9c7a3e$var$validateMessages = {
    required: '${label} is required!'
};
const $be73dcef9e9c7a3e$var$normalizeFile = (e)=>{
    if (Array.isArray(e)) return e;
    return e?.fileList;
};
const $be73dcef9e9c7a3e$export$9abfcccccba0453a = ({ currentPlant: currentPlant, setMode: setMode, plantTitlePhoto: plantTitlePhoto, projectsList: projectsList, onClose: onClose, preventFormClose: preventFormClose, mode: mode })=>{
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const user = (0, $d433dc3c3e640619$export$3901076af3749fa9)();
    const [form] = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useForm();
    const [basePlantId, setBasePlantId] = (0, $ltGt3.useState)(currentPlant?.plantBaseId);
    const [basePlantTitlePhoto, setBasePlantTitlePhoto] = (0, $ltGt3.useState)(plantTitlePhoto);
    const [isSubmitting, setSubmitting] = (0, $ltGt3.useState)(false);
    const [isLoading, setLoading] = (0, $ltGt3.useState)(true);
    const files = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useWatch('files', form);
    const newFiles = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useWatch('newFiles', form);
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const language = intl.locale;
    const projectRouteData = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('project') || {};
    const projectFromRoute = projectRouteData.project || undefined;
    const { gardenPlanVariantId: gardenPlanVariantId } = (0, $06d8e952a1c52731$export$7796d9afff69f3c5)();
    const gardenPlanVariantForNewPlant = mode === 'create' ? (projectRouteData.projectGardenPlanVariants || []).find((variant)=>variant.id === gardenPlanVariantId) : undefined;
    const { value: currentPlantGardenPlanVariantName } = (0, $1e104381209dd9b4$export$78a72ddb39bdd145)(undefined, async ()=>{
        if (!currentPlant?.gardenPlanVariantId || !currentPlant.projectId) return undefined;
        const result = await (0, $5fab5f2ee6cc184e$export$9544d5bb712b01ea).getProjectGardenPlanVariants(currentPlant.projectId);
        return result.success ? result.projectGardenPlanVariants.find((variant)=>variant.id === currentPlant.gardenPlanVariantId)?.name : undefined;
    }, [
        currentPlant?.gardenPlanVariantId,
        currentPlant?.projectId
    ]);
    const gardenPlanVariantName = gardenPlanVariantForNewPlant?.name ?? currentPlantGardenPlanVariantName;
    const isProjectLocked = !!currentPlant?.gardenPlanVariantId || mode === 'create' && !!projectFromRoute;
    const selectedProjectId = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useWatch('projectId', form);
    (0, $ltGt3.useEffect)(()=>{
        form.setFieldValue('projectId', currentPlant?.projectId || projectFromRoute?.id);
    }, [
        projectFromRoute?.id
    ]);
    (0, $ltGt3.useEffect)(()=>{
        form.setFieldValue('elementId', selectedProjectId === currentPlant?.projectId ? currentPlant?.elementId : undefined);
    }, [
        selectedProjectId,
        currentPlant?.projectId
    ]);
    (0, $ltGt3.useEffect)(()=>{
        (async ()=>{
            setLoading(true);
            try {
                form.setFieldsValue({
                    ...currentPlant?.fields || {},
                    name: currentPlant?.name || '',
                    files: currentPlant?.photos || [],
                    comment: currentPlant?.comment || '',
                    dateOfPlanting: currentPlant?.dateOfPlantingUtc ? (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(currentPlant.dateOfPlantingUtc, (0, $ec20113856fdaafd$export$4e4cb19dd88cd821)) : null
                });
            } finally{
                setLoading(false);
            }
        })();
    }, [
        currentPlant
    ]);
    const fieldGroups = (0, $0023026720e9f6ec$export$3f063810d7bf01bd)(Object.entries((0, $db1b4356c7e82244$export$b4d1d5ccd59b78e3)), ([key, field])=>field.group);
    const preventFormCloseDueToModification = ()=>{
        preventFormClose(intl.formatMessage({
            id: 'formModifiedButNotSaved'
        }));
    };
    const items = [
        {
            key: '1',
            label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                className: 'edit-plant-form__tabs__label',
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                        icon: $1113a0aa61ab7765$export$7c497bae2754a087
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                        children: intl.formatMessage({
                            id: 'taxonomy'
                        })
                    })
                ]
            }),
            children: (0, $920a43afcbc49243$export$624f702044eb7ad)(fieldGroups['main'], preventFormCloseDueToModification)
        },
        {
            key: '2',
            forceRender: true,
            label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                className: 'edit-plant-form__tabs__label',
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                        icon: $1113a0aa61ab7765$export$4be92fa780613f93
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                        children: intl.formatMessage({
                            id: 'locationPlant'
                        })
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                children: [
                    !currentPlant && !gardenPlanVariantForNewPlant && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        name: "dateOfPlanting",
                        label: intl.formatMessage({
                            id: 'dateOfPlanting'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $878317098e859dd0$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6ffd02bbc967fbfd$export$358d287cc4a0d9bd), {
                        projectsList: projectsList,
                        preventFormCloseDueToModification: preventFormCloseDueToModification,
                        disabled: isProjectLocked,
                        extra: gardenPlanVariantName && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3336d90a99ceb065$export$2e2bcd8739ae039), {
                            type: "warning",
                            showIcon: true,
                            title: intl.formatMessage({
                                id: 'plantIsCreatedInGardenPlan'
                            }, {
                                planName: gardenPlanVariantName
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e3191dd369e6ad56$export$354073dd3a214b42), {
                        selectedProjectId: selectedProjectId,
                        projectsList: projectsList,
                        preventFormCloseDueToModification: preventFormCloseDueToModification
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        name: "comment",
                        label: intl.formatMessage({
                            id: 'comment'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).TextArea, {})
                    })
                ]
            })
        },
        {
            key: '3',
            label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                className: 'edit-plant-form__tabs__label',
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                        icon: $1113a0aa61ab7765$export$aa9288aeadf882fa
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                        children: intl.formatMessage({
                            id: 'characteristics'
                        })
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                children: [
                    (0, $920a43afcbc49243$export$624f702044eb7ad)(fieldGroups['common'], preventFormCloseDueToModification),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                        title: "overview",
                        backgroundIcon: $1113a0aa61ab7765$export$2c5a9d8548d8810e,
                        children: (0, $920a43afcbc49243$export$624f702044eb7ad)(fieldGroups['overview'], preventFormCloseDueToModification)
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                        title: "growing-conditions",
                        backgroundIcon: $1113a0aa61ab7765$export$4be92fa780613f93,
                        children: (0, $920a43afcbc49243$export$624f702044eb7ad)(fieldGroups['growing-conditions'], preventFormCloseDueToModification)
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                        title: "size-appearance",
                        backgroundIcon: $1113a0aa61ab7765$export$7937ea574fb1389,
                        children: (0, $920a43afcbc49243$export$624f702044eb7ad)(fieldGroups['size-appearance'], preventFormCloseDueToModification)
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                        title: "properties",
                        backgroundIcon: $1113a0aa61ab7765$export$c062100d54a2da00,
                        children: (0, $920a43afcbc49243$export$624f702044eb7ad)(fieldGroups['properties'], preventFormCloseDueToModification)
                    })
                ]
            })
        },
        {
            key: '4',
            label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                className: 'edit-plant-form__tabs__label',
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                        icon: $1113a0aa61ab7765$export$cc1b6e60cb98fb90
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                        children: intl.formatMessage({
                            id: 'care'
                        })
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                children: [
                    (0, $920a43afcbc49243$export$624f702044eb7ad)(fieldGroups['care'], preventFormCloseDueToModification),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                        title: "plant-health",
                        backgroundIcon: $1113a0aa61ab7765$export$77a38850ff8b0407,
                        children: (0, $920a43afcbc49243$export$624f702044eb7ad)(fieldGroups['plant-health'], preventFormCloseDueToModification)
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                        title: "fruiting",
                        backgroundIcon: $1113a0aa61ab7765$export$12de8220d30453a3,
                        children: (0, $920a43afcbc49243$export$624f702044eb7ad)(fieldGroups['fruiting'], preventFormCloseDueToModification)
                    })
                ]
            })
        },
        {
            key: '5',
            label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                className: 'edit-plant-form__tabs__label',
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2b2181a84a15541d$export$2b9260d4a45c8710), {
                        icon: $1113a0aa61ab7765$export$d7b60b8dbd03cfe4
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                        children: intl.formatMessage({
                            id: 'propagation-planting'
                        })
                    })
                ]
            }),
            children: (0, $920a43afcbc49243$export$624f702044eb7ad)(fieldGroups['propagation-planting'], preventFormCloseDueToModification)
        }
    ];
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $b56d75f9dce54730$export$2e2bcd8739ae039), {
        form: form,
        labelCol: {
            span: 8
        },
        wrapperCol: {
            span: 16
        },
        labelWrap: true,
        autoComplete: "off",
        layout: "horizontal",
        validateMessages: $be73dcef9e9c7a3e$var$validateMessages,
        onChange: preventFormCloseDueToModification,
        onFinish: async (formState)=>{
            setSubmitting(true);
            let result;
            const plant = {
                name: formState.name,
                dateOfPlantingUtc: formState.dateOfPlanting,
                userId: user.id,
                comment: formState.comment,
                projectId: formState.projectId,
                gardenPlanVariantId: currentPlant ? currentPlant.gardenPlanVariantId : gardenPlanVariantForNewPlant?.id,
                elementId: formState.elementId || null,
                confidenceInPlantVariety: formState.confidenceInPlantVariety,
                overwrittenBaseFields: currentPlant ? currentPlant.overwrittenBaseFields : {},
                plantBaseId: basePlantId,
                fields: undefined
            };
            if (currentPlant) //const {projectName, ...existingPlant} = currentPlant
            result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).editPlant({
                id: currentPlant.id,
                collections: currentPlant.collections,
                ...plant,
                overwrittenBaseFields: formState
            }, language);
            else result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).createPlant({
                ...plant,
                overwrittenBaseFields: formState
            }, formState.newFiles, language, basePlantId);
            setSubmitting(false);
            if (result.success) {
                submit(result.id ? {
                    id: String(result.id)
                } : null, {
                    method: 'post'
                });
                if (currentPlant) setMode('view');
            } else messageApi.open({
                type: 'error',
                content: result.error
            });
        },
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: 'edit-plant-form__top',
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                            children: mode === 'create' ? intl.formatMessage({
                                id: 'addingNewPlant'
                            }) : intl.formatMessage({
                                id: 'editingPlant'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                            className: 'edit-plant-form__top__save-cancel',
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    onClick: ()=>mode === 'create' ? onClose() : setMode('view'),
                                    children: intl.formatMessage({
                                        id: 'cancel'
                                    })
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    htmlType: "submit",
                                    type: "primary",
                                    children: intl.formatMessage({
                                        id: 'save'
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                className: 'edit-plant-form__header',
                children: [
                    basePlantTitlePhoto && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                        className: 'edit-plant-form__header__photo',
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $54759b2dc7aee7a8$export$2e2bcd8739ae039), {
                            src: basePlantTitlePhoto
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                        className: 'edit-plant-form__header__fields',
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                name: "name",
                                label: intl.formatMessage({
                                    id: 'plantName'
                                }),
                                rules: [
                                    {
                                        required: true
                                    }
                                ],
                                tooltip: {
                                    title: intl.formatMessage({
                                        id: 'plantName-tooltip'
                                    }),
                                    icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $35775a005ce7c86e$export$2e2bcd8739ae039), {})
                                },
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                name: "base",
                                label: intl.formatMessage({
                                    id: 'basePlant'
                                }),
                                tooltip: {
                                    title: intl.formatMessage({
                                        id: 'basePlant-tooltip'
                                    }),
                                    icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $35775a005ce7c86e$export$2e2bcd8739ae039), {})
                                },
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $408c96f367a310dd$export$6787be8007574362), {
                                    basePlantId: basePlantId,
                                    onBasePlantSelected: async (dbPlant, fieldsToClear, titlePhoto)=>{
                                        setBasePlantId(dbPlant === null ? undefined : dbPlant.id);
                                        const preparedFieldsToClear = await (0, $013e30408cecb25a$export$bd5991ff6ac58908)(undefined, fieldsToClear);
                                        for (const fieldName of Object.keys(preparedFieldsToClear))if ((0, $0023026720e9f6ec$export$5693503523434e2b)(form.getFieldValue(fieldName), fieldsToClear[fieldName])) form.setFieldValue(fieldName, undefined);
                                        form.setFieldsValue(await (0, $013e30408cecb25a$export$bd5991ff6ac58908)(currentPlant || undefined, dbPlant ? dbPlant?.fields : {}));
                                        setBasePlantTitlePhoto(titlePhoto);
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $77eacb4b734e6c42$export$2e2bcd8739ae039), {
                className: 'edit-plant-form__tabs',
                defaultActiveKey: "1",
                items: items
            })
        ]
    });
};





var $ltGt3 = parcelRequire("ltGt3");


function $0bd3f5c1d2d81d43$export$cac7cb74f59833e(props) {
    const [isChecked, setIsChecked] = (0, $ltGt3.useState)(Boolean(props.defaultChecked));
    const [isCheckedSecond\u0421ondition, setIsCheckedSecond\u0421ondition] = (0, $ltGt3.useState)(false);
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    (0, $ltGt3.useEffect)(()=>{
        if (props.isOpen) setIsChecked(Boolean(props.defaultChecked));
    }, [
        props.isOpen
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f189c84ec54ae7cf$export$2e2bcd8739ae039), {
        destroyOnHidden: true,
        width: 500,
        onOk: ()=>props.onOk(isChecked, isCheckedSecond\u0421ondition),
        open: props.isOpen,
        onCancel: props.onCancel,
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                children: props.label
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                checked: isChecked,
                onChange: (e)=>setIsChecked(e.target.checked),
                children: props.checkboxLabel
            }),
            props.checkboxLabelSecond\u0421ondition && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                disabled: !isChecked,
                checked: isChecked ? isCheckedSecond\u0421ondition : isChecked,
                onChange: (e)=>setIsCheckedSecond\u0421ondition(e.target.checked),
                children: props.checkboxLabelSecond\u0421ondition
            })
        ]
    });
}




var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");

function $978c6aa8dce011f8$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, className: className, style: style, status: status } = props;
    const railCls = `${prefixCls}-rail`;
    // ============================= render =============================
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(railCls, `${railCls}-${status}`, className),
        style: style
    });
}



var $ltGt3 = parcelRequire("ltGt3");
const $6ba8c6d18ca09c16$export$e508d6f1a100e5dd = /*#__PURE__*/ $ltGt3.createContext({});



var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
const $e03e522b295b533c$export$3592d73ed1131d52 = /*#__PURE__*/ $ltGt3.createContext(null);



function $49ad84d957b5cd52$var$_extends() {
    $49ad84d957b5cd52$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $49ad84d957b5cd52$var$_extends.apply(this, arguments);
}
const $49ad84d957b5cd52$export$7b06b07495b1e032 = /*#__PURE__*/ $ltGt3.createContext({});
const $49ad84d957b5cd52$var$StepIcon = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { className: className, style: style, children: children, ...restProps } = props;
    const { prefixCls: prefixCls, classNames: classNames, styles: styles } = $ltGt3.useContext((0, $e03e522b295b533c$export$3592d73ed1131d52));
    const { className: itemClassName, style: itemStyle } = $ltGt3.useContext($49ad84d957b5cd52$export$7b06b07495b1e032);
    const itemCls = `${prefixCls}-item`;
    return /*#__PURE__*/ $ltGt3.createElement("div", $49ad84d957b5cd52$var$_extends({}, (0, $297f85de79f8d325$export$2e2bcd8739ae039)(restProps, false), {
        ref: ref,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${itemCls}-icon`, classNames.itemIcon, itemClassName, className),
        style: {
            ...styles.itemIcon,
            ...itemStyle,
            ...style
        }
    }), children);
});
var $49ad84d957b5cd52$export$2e2bcd8739ae039 = $49ad84d957b5cd52$var$StepIcon;



function $e4b8fea703be3e1b$var$_extends() {
    $e4b8fea703be3e1b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e4b8fea703be3e1b$var$_extends.apply(this, arguments);
}
function $e4b8fea703be3e1b$var$hasContent(value) {
    return value !== undefined && value !== null;
}
function $e4b8fea703be3e1b$export$2e2bcd8739ae039(props) {
    const { prefixCls: // style
    prefixCls, classNames: classNames, styles: styles, data: // data
    data, last: last, nextStatus: nextStatus, active: active, index: index, itemRender: // render
    itemRender, iconRender: iconRender, itemWrapperRender: itemWrapperRender, onClick: // events
    onClick } = props;
    const itemCls = `${prefixCls}-item`;
    // ======================== Contexts ========================
    const { railFollowPrevStatus: railFollowPrevStatus } = $ltGt3.useContext((0, $6ba8c6d18ca09c16$export$e508d6f1a100e5dd));
    const { ItemComponent: ItemComponent } = $ltGt3.useContext((0, $e03e522b295b533c$export$3592d73ed1131d52));
    // ========================== Data ==========================
    const { onClick: onItemClick, title: title, subTitle: subTitle, content: content, description: description, disabled: disabled, icon: icon, status: status, className: className, style: style, classNames: itemClassNames = {}, styles: itemStyles = {}, ...restItemProps } = data;
    const mergedContent = content ?? description;
    const renderInfo = {
        item: {
            ...data,
            content: mergedContent
        },
        index: index,
        active: active
    };
    // ========================= Click ==========================
    const clickable = !!(onClick || onItemClick) && !disabled;
    const accessibilityProps = {};
    if (clickable) {
        accessibilityProps.role = 'button';
        accessibilityProps.tabIndex = 0;
        accessibilityProps.onClick = (e)=>{
            onItemClick?.(e);
            onClick(index);
        };
        accessibilityProps.onKeyDown = (e)=>{
            const { which: which } = e;
            if (which === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER || which === (0, $b0616a5421b43292$export$2e2bcd8739ae039).SPACE) onClick(index);
        };
    }
    // ========================= Render =========================
    const mergedStatus = status || 'wait';
    const hasTitle = $e4b8fea703be3e1b$var$hasContent(title);
    const hasSubTitle = $e4b8fea703be3e1b$var$hasContent(subTitle);
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(itemCls, `${itemCls}-${mergedStatus}`, {
        [`${itemCls}-custom`]: icon,
        [`${itemCls}-active`]: active,
        [`${itemCls}-disabled`]: disabled === true,
        [`${itemCls}-empty-header`]: !hasTitle && !hasSubTitle
    }, className, classNames.item, itemClassNames.root);
    let iconNode = /*#__PURE__*/ $ltGt3.createElement((0, $49ad84d957b5cd52$export$2e2bcd8739ae039), null);
    if (iconRender) iconNode = iconRender(iconNode, {
        ...renderInfo,
        components: {
            Icon: (0, $49ad84d957b5cd52$export$2e2bcd8739ae039)
        }
    });
    const wrapperNode = /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${itemCls}-wrapper`, classNames.itemWrapper, itemClassNames.wrapper),
        style: {
            ...styles.itemWrapper,
            ...itemStyles.wrapper
        }
    }, /*#__PURE__*/ $ltGt3.createElement((0, $49ad84d957b5cd52$export$7b06b07495b1e032).Provider, {
        value: {
            className: itemClassNames.icon,
            style: itemStyles.icon
        }
    }, iconNode), /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${itemCls}-section`, classNames.itemSection, itemClassNames.section),
        style: {
            ...styles.itemSection,
            ...itemStyles.section
        }
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${itemCls}-header`, classNames.itemHeader, itemClassNames.header),
        style: {
            ...styles.itemHeader,
            ...itemStyles.header
        }
    }, hasTitle && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${itemCls}-title`, classNames.itemTitle, itemClassNames.title),
        style: {
            ...styles.itemTitle,
            ...itemStyles.title
        }
    }, title), hasSubTitle && /*#__PURE__*/ $ltGt3.createElement("div", {
        title: typeof subTitle === 'string' ? subTitle : undefined,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${itemCls}-subtitle`, classNames.itemSubtitle, itemClassNames.subtitle),
        style: {
            ...styles.itemSubtitle,
            ...itemStyles.subtitle
        }
    }, subTitle), !last && /*#__PURE__*/ $ltGt3.createElement((0, $978c6aa8dce011f8$export$2e2bcd8739ae039), {
        prefixCls: itemCls,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(classNames.itemRail, itemClassNames.rail),
        style: {
            ...styles.itemRail,
            ...itemStyles.rail
        },
        status: railFollowPrevStatus ? status : nextStatus
    })), $e4b8fea703be3e1b$var$hasContent(mergedContent) && /*#__PURE__*/ $ltGt3.createElement("div", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${itemCls}-content`, classNames.itemContent, itemClassNames.content),
        style: {
            ...styles.itemContent,
            ...itemStyles.content
        }
    }, mergedContent)));
    let stepNode = /*#__PURE__*/ $ltGt3.createElement(ItemComponent, $e4b8fea703be3e1b$var$_extends({}, restItemProps, accessibilityProps, {
        className: classString,
        style: {
            ...styles.item,
            ...itemStyles.root,
            ...style
        }
    }), itemWrapperRender ? itemWrapperRender(wrapperNode) : wrapperNode);
    if (itemRender) stepNode = itemRender(stepNode, renderInfo) || null;
    return stepNode;
}



function $3c6f4a77b26875a0$var$_extends() {
    $3c6f4a77b26875a0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3c6f4a77b26875a0$var$_extends.apply(this, arguments);
}
const $3c6f4a77b26875a0$var$EmptyObject = {};
function $3c6f4a77b26875a0$export$2e2bcd8739ae039(props) {
    const { prefixCls: // style
    prefixCls = 'rc-steps', style: style, className: className, classNames: classNames = $3c6f4a77b26875a0$var$EmptyObject, styles: styles = $3c6f4a77b26875a0$var$EmptyObject, rootClassName: rootClassName, orientation: // layout
    orientation, titlePlacement: titlePlacement, components: components, status: // data
    status = 'process', current: current = 0, initial: initial = 0, onChange: onChange, items: items, iconRender: // render
    iconRender, itemRender: itemRender, itemWrapperRender: itemWrapperRender, ...restProps } = props;
    // ============================= layout =============================
    const isVertical = orientation === 'vertical';
    const mergedOrientation = isVertical ? 'vertical' : 'horizontal';
    const mergeTitlePlacement = !isVertical && titlePlacement === 'vertical' ? 'vertical' : 'horizontal';
    // ============================= styles =============================
    const classString = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${mergedOrientation}`, `${prefixCls}-title-${mergeTitlePlacement}`, rootClassName, className, classNames.root);
    // ============================== Data ==============================
    const mergedItems = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>(items || []).filter(Boolean), [
        items
    ]);
    const statuses = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>mergedItems.map(({ status: itemStatus }, index)=>{
            const stepNumber = initial + index;
            if (!itemStatus) {
                if (stepNumber === current) return status;
                else if (stepNumber < current) return 'finish';
                return 'wait';
            }
            return itemStatus;
        }), [
        mergedItems,
        status,
        current,
        initial
    ]);
    // ============================= events =============================
    const onStepClick = (next)=>{
        if (onChange && current !== next) onChange(next);
    };
    // =========================== components ===========================
    const { root: RootComponent = 'div', item: ItemComponent = 'div' } = components || {};
    // ============================ contexts ============================
    const stepIconContext = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).useMemo(()=>({
            prefixCls: prefixCls,
            classNames: classNames,
            styles: styles,
            ItemComponent: ItemComponent
        }), [
        prefixCls,
        classNames,
        styles,
        ItemComponent
    ]);
    // ============================= render =============================
    const renderStep = (item, index)=>{
        const stepIndex = initial + index;
        const itemStatus = statuses[index];
        const nextStatus = statuses[index + 1];
        const data = {
            ...item,
            status: itemStatus
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $e4b8fea703be3e1b$export$2e2bcd8739ae039), {
            key: stepIndex,
            prefixCls: prefixCls,
            classNames: classNames,
            styles: styles,
            data: data,
            nextStatus: nextStatus,
            active: stepIndex === current,
            index: stepIndex,
            last: mergedItems.length - 1 === index,
            iconRender: iconRender,
            itemRender: itemRender,
            itemWrapperRender: itemWrapperRender,
            onClick: onChange && onStepClick
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement(RootComponent, $3c6f4a77b26875a0$var$_extends({
        className: classString,
        style: {
            ...style,
            ...styles?.root
        }
    }, restProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $e03e522b295b533c$export$3592d73ed1131d52).Provider, {
        value: stepIconContext
    }, mergedItems.map(renderStep)));
}




var $453f72b01ec42c81$export$2e2bcd8739ae039 = (0, $3c6f4a77b26875a0$export$2e2bcd8739ae039);







var $ltGt3 = parcelRequire("ltGt3");













var $ltGt3 = parcelRequire("ltGt3");
const $ee6ed0e90dc98d4c$export$d056f9c7816498b6 = /*#__PURE__*/ $ltGt3.createContext(null);



var $ltGt3 = parcelRequire("ltGt3");
"use client";
function $e42d4f52e707f4ad$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls } = props;
    return /*#__PURE__*/ $ltGt3.createElement("svg", {
        className: `${prefixCls}-panel-arrow`,
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ $ltGt3.createElement("title", null, "Arrow"), /*#__PURE__*/ $ltGt3.createElement("path", {
        d: "M 0 0 L 100 50 L 0 100"
    }));
}



var $ltGt3 = parcelRequire("ltGt3");

"use client";
function $b04b24d8f7224c8e$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, children: children, percent: percent } = props;
    const progressCls = `${prefixCls}-item-progress-icon`;
    const circleCls = `${progressCls}-circle`;
    const dashArray = `calc(var(--progress-r) * 2 * ${Math.PI * percent / 100}) 9999`;
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement("svg", {
        className: `${progressCls}-svg`,
        viewBox: "0 0 100 100",
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-valuemax": 100,
        "aria-valuemin": 0,
        "aria-valuenow": percent
    }, /*#__PURE__*/ $ltGt3.createElement("title", null, "Progress"), /*#__PURE__*/ $ltGt3.createElement("circle", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(circleCls, `${circleCls}-rail`)
    }), /*#__PURE__*/ $ltGt3.createElement("circle", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(circleCls, `${circleCls}-ptg`),
        strokeDasharray: dashArray,
        transform: "rotate(-90 50 50)"
    })), children);
}




const $5c96570707a3dddc$var$genHorizontalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const itemCls = `${componentCls}-item`; // .ant-steps-item
    return {
        [`${componentCls}-horizontal`]: {
            [`> ${itemCls}`]: {
                flex: '1 1 auto',
                minWidth: token.iconSize,
                [`${itemCls}-rail`]: {
                    '--steps-horizontal-rail-margin': 'calc(var(--steps-icon-size-max) / 2 + var(--steps-item-wrapper-padding-top))',
                    position: 'static',
                    marginTop: 'var(--steps-horizontal-rail-margin)',
                    width: 'auto',
                    borderBlockStartWidth: 'var(--steps-rail-size)',
                    flex: 1,
                    minWidth: 0,
                    alignSelf: 'flex-start',
                    transform: 'translateY(-50%)'
                }
            }
        }
    };
};
var $5c96570707a3dddc$export$2e2bcd8739ae039 = $5c96570707a3dddc$var$genHorizontalStyle;


const $bfb0cb92c78a049d$var$genIconStyle = (token)=>{
    const { componentCls: componentCls, customIconFontSize: customIconFontSize, motionDurationSlow: motionDurationSlow } = token;
    const itemCls = `${componentCls}-item`;
    return {
        [componentCls]: {
            '--steps-icon-size': token.iconSize,
            '--steps-icon-border-width': token.lineWidth,
            [`${itemCls}-icon`]: {
                width: 'var(--steps-icon-size)',
                height: 'var(--steps-icon-size)',
                margin: 0,
                flex: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: token.iconFontSize,
                fontFamily: token.fontFamily,
                lineHeight: 'var(--steps-icon-size)',
                textAlign: 'center',
                borderRadius: 'var(--steps-icon-size)',
                border: `var(--steps-icon-border-width) ${token.lineType} transparent`,
                transition: [
                    'background',
                    'border',
                    'color',
                    'inset',
                    'transform'
                ].map((key)=>`${key} ${motionDurationSlow}`).join(', '),
                zIndex: 1
            },
            // ==================== Custom ====================
            [`${itemCls}-custom ${itemCls}-icon`]: {
                background: 'none',
                border: 0,
                fontSize: customIconFontSize
            }
        }
    };
};
var $bfb0cb92c78a049d$export$2e2bcd8739ae039 = $bfb0cb92c78a049d$var$genIconStyle;


const $7267c7737561c86f$var$genInlineStyle = (token)=>{
    const { componentCls: componentCls, inlineDotSize: inlineDotSize } = token;
    const containerPaddingTop = token.calc(token.paddingXS).add(token.lineWidth).equal();
    const itemCls = `${componentCls}-item`;
    return {
        [`${componentCls}-inline`]: {
            '--steps-items-offset': '0',
            '--steps-item-wrapper-padding-top': containerPaddingTop,
            display: 'inline-flex',
            '&:before': {
                content: '""',
                flex: 'var(--steps-items-offset)'
            },
            [itemCls]: {
                // ========================= Variable =========================
                // Item
                '--steps-title-vertical-row-gap': token.paddingXS,
                // Icon
                '--steps-icon-size': inlineDotSize,
                '--steps-icon-size-active': inlineDotSize,
                // Title
                '--steps-title-font-size': token.fontSizeSM,
                '--steps-title-line-height': token.lineHeightSM,
                '--steps-item-title-color': token.colorTextSecondary,
                '--steps-subtitle-font-size': token.fontSizeSM,
                '--steps-subtitle-line-height': token.lineHeightSM,
                '--steps-item-subtitle-color': token.colorTextQuaternary,
                // Rail
                '--steps-rail-size': token.lineWidth,
                '--steps-title-horizontal-rail-gap': '0px',
                // ========================== Styles ==========================
                flex: 1,
                '&-wrapper': {
                    paddingInline: token.paddingXXS,
                    marginInline: token.calc(token.marginXXS).div(2).equal(),
                    borderRadius: token.borderRadiusSM,
                    cursor: 'pointer',
                    transition: `background ${token.motionDurationMid}`,
                    '&:hover': {
                        background: token.controlItemBgHover
                    }
                },
                // Icon
                '&-icon': {
                    [`${itemCls}-icon-dot`]: {
                        '&:after': {
                            display: 'none'
                        }
                    }
                },
                // Header
                '&-title': {
                    fontWeight: 'normal',
                    whiteSpace: 'nowrap'
                },
                '&-content': {
                    display: 'none'
                }
            }
        }
    };
};
var $7267c7737561c86f$export$2e2bcd8739ae039 = $7267c7737561c86f$var$genInlineStyle;


function $281a6501f45c2b7c$var$withoutVar(cssVar) {
    return (cssVar || '--ant-not-exist').replace(/var\((.*)\)/, '$1');
}
function $281a6501f45c2b7c$export$f0196ef13ff2a3b7(token, marginSize, optionalStyle) {
    const { calc: calc, componentCls: componentCls, descriptionMaxWidth: descriptionMaxWidth } = token;
    const itemCls = `${componentCls}-item`;
    return {
        [`@container style(${$281a6501f45c2b7c$var$withoutVar(descriptionMaxWidth)})`]: [
            {
                // Icon
                [`${itemCls}-icon`]: {
                    marginInlineStart: calc(descriptionMaxWidth).sub(`var(--steps-icon-size)`).div(2).equal()
                },
                // >>> Rail
                [`${itemCls}-rail`]: {
                    width: 'auto',
                    insetInlineStart: calc(descriptionMaxWidth).add(`var(--steps-icon-size)`).div(2).add(marginSize).equal(),
                    insetInlineEnd: calc(descriptionMaxWidth).sub(`var(--steps-icon-size)`).div(2).sub(marginSize).mul(-1).equal()
                }
            },
            optionalStyle
        ]
    };
}


const $d5651aebf047db21$var$genLabelPlacementStyle = (token)=>{
    const { componentCls: componentCls, descriptionMaxWidth: descriptionMaxWidth, marginXS: marginXS, fontHeightLG: fontHeightLG, calc: calc } = token;
    const itemCls = `${componentCls}-item`;
    return {
        // ====================== Shared ======================
        [componentCls]: {
            // Dot Steps active icon size is 2px larger than the default icon size
            '--steps-icon-size-max': 'max(var(--steps-icon-size), var(--steps-icon-size-active, var(--steps-icon-size)))',
            // Icon
            [`${itemCls}-icon`]: {
                marginBlockStart: `calc((var(--steps-heading-height) - var(--steps-icon-size)) / 2)`
            }
        },
        // ==================== Horizontal ====================
        [`${componentCls}-title-horizontal`]: {
            '--steps-title-horizontal-item-margin': token.margin,
            '--steps-title-horizontal-rail-margin': token.margin,
            '--steps-title-horizontal-title-height': fontHeightLG,
            '--steps-heading-height': `max(var(--steps-icon-size), var(--steps-title-horizontal-title-height))`,
            // Horizontal only
            [`&${componentCls}-horizontal, &${componentCls}-horizontal-alternate`]: {
                [`${itemCls}:not(:first-child)`]: {
                    marginInlineStart: `var(--steps-title-horizontal-item-margin)`
                },
                [`${itemCls}:last-child`]: {
                    flex: '0 1 auto'
                },
                [`${itemCls}-wrapper`]: {
                    columnGap: token.marginXS
                }
            },
            // Vertical only
            [`&${componentCls}-vertical`]: {
                [`${itemCls}-wrapper`]: {
                    columnGap: token.margin
                },
                [`${itemCls}-empty-header`]: {
                    [`${itemCls}-header`]: {
                        minHeight: 'auto'
                    },
                    [`${itemCls}-content`]: {
                        marginTop: calc('var(--steps-heading-height)').sub(token.fontHeight).div(2).equal()
                    }
                }
            },
            // Shared
            [`${itemCls}-section`]: {
                flex: 1,
                minWidth: 0
            },
            [`${itemCls}-header`]: {
                minHeight: 'var(--steps-heading-height)'
            },
            [`${itemCls}-title`]: {
                flex: '0 1 auto'
            },
            [`${itemCls}-content`]: {
                maxWidth: descriptionMaxWidth
            },
            [`${itemCls}-subtitle`]: {
                flex: '0 9999 auto'
            },
            [`&${componentCls}-horizontal ${itemCls}-rail`]: {
                '--steps-item-wrapper-padding-top': '0px',
                flex: 1,
                marginInlineStart: `var(--steps-title-horizontal-rail-margin)`
            }
        },
        // ===================== Vertical =====================
        [`${componentCls}-title-vertical`]: {
            '--steps-title-vertical-row-gap': token.paddingSM,
            '--steps-title-horizontal-rail-gap': token.marginXXS,
            '--steps-heading-height': 'var(--steps-icon-size-max)',
            [`> ${itemCls}`]: {
                flex: 1,
                [`${itemCls}-wrapper`]: {
                    flexDirection: 'column',
                    rowGap: `var(--steps-title-vertical-row-gap)`,
                    alignItems: 'center'
                },
                // Section
                [`${itemCls}-section`]: {
                    alignSelf: 'stretch'
                },
                // Header
                [`${itemCls}-header`]: {
                    flexDirection: 'column',
                    alignItems: 'center'
                },
                // >>> title & subtitle & Content
                [`${itemCls}-title, ${itemCls}-subtitle, ${itemCls}-content`]: {
                    textAlign: 'center',
                    maxWidth: '100%'
                },
                [`${itemCls}-subtitle`]: {
                    margin: 0
                },
                // >>> rail
                [`${itemCls}-rail`]: {
                    position: 'absolute',
                    top: 0,
                    width: `calc(100% - var(--steps-icon-size) - var(--steps-title-horizontal-rail-gap) * 2)`,
                    insetInlineStart: `calc(50% + var(--steps-icon-size) / 2 + var(--steps-title-horizontal-rail-gap))`
                }
            },
            // With descriptionMaxWidth
            ...(0, $281a6501f45c2b7c$export$f0196ef13ff2a3b7)(token, marginXS, {
                [`${itemCls}:last-child`]: {
                    flex: 'none'
                },
                // Icon
                [`${itemCls}-icon`]: {
                    alignSelf: 'flex-start'
                },
                // Section
                [`${itemCls}-section`]: {
                    width: descriptionMaxWidth
                }
            })
        }
    };
};
var $d5651aebf047db21$export$2e2bcd8739ae039 = $d5651aebf047db21$var$genLabelPlacementStyle;



const $8909f079fb757c73$var$genLegacyNavStyle = (token)=>{
    const { componentCls: componentCls, fontSizeIcon: fontSizeIcon, calc: calc, navContentMaxWidth: navContentMaxWidth, navArrowColor: navArrowColor, colorPrimary: colorPrimary, motionDurationSlow: motionDurationSlow } = token;
    const itemCls = `${componentCls}-item`;
    const stepsNavActiveColor = colorPrimary;
    return {
        [`${componentCls}${componentCls}-navigation`]: {
            // ==========================================================
            // ==                        Shared                        ==
            // ==========================================================
            // ========================== Item ==========================
            [`${itemCls.repeat(4)}`]: {
                display: 'flex',
                justifyContent: 'center',
                position: 'relative',
                flex: 1,
                marginInlineStart: 0,
                [`${itemCls}-wrapper`]: {
                    paddingBlock: token.paddingSM
                },
                // Section
                [`${itemCls}-section`]: {
                    maxWidth: navContentMaxWidth
                },
                // Rail
                [`${itemCls}-rail`]: {
                    display: 'none'
                },
                // ======================== Active ========================
                '&:before': {
                    position: 'absolute',
                    display: 'block',
                    backgroundColor: stepsNavActiveColor,
                    transition: `all ${motionDurationSlow}`,
                    transitionTimingFunction: 'ease-out',
                    content: '""'
                },
                '&:not(:last-child):after': {
                    position: 'absolute',
                    display: 'block',
                    borderTop: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${navArrowColor}`,
                    borderBottom: 'none',
                    borderInlineStart: 'none',
                    borderInlineEnd: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${navArrowColor}`,
                    content: '""'
                },
                // Reset active item style to same as default
                [`&${itemCls}-active`]: {
                    '--steps-item-content-active-color': `var(--steps-item-content-color)`,
                    '--steps-item-icon-active-bg-color': 'var(--steps-item-icon-bg-color)',
                    '--steps-item-icon-active-border-color': 'var(--steps-item-icon-border-color)',
                    '--steps-item-icon-active-text-color': 'var(--steps-item-icon-text-color)'
                }
            },
            // ==========================================================
            // ==                       Horizontal                     ==
            // ==========================================================
            [`&${componentCls}-horizontal`]: {
                [itemCls]: {
                    '&:before': {
                        bottom: 0,
                        insetInlineStart: '50%',
                        width: 0,
                        height: token.lineWidthBold
                    },
                    [`&${itemCls}-active:before`]: {
                        insetInlineStart: 0,
                        width: '100%'
                    },
                    '&:not(:last-child):after': {
                        top: `50%`,
                        insetInlineStart: calc(fontSizeIcon).div(2).mul(-1).add('100%').equal(),
                        width: fontSizeIcon,
                        height: fontSizeIcon,
                        transform: 'translateY(-50%) rotate(45deg)'
                    }
                }
            },
            // ==========================================================
            // ==                        Vertical                      ==
            // ==========================================================
            [`&${componentCls}-vertical`]: {
                [`${itemCls.repeat(4)}`]: {
                    [`${itemCls}-content`]: {
                        padding: 0
                    },
                    '&:before': {
                        insetInlineEnd: 0,
                        top: '50%',
                        width: token.lineWidthBold,
                        height: 0
                    },
                    [`&${itemCls}-active::before`]: {
                        top: 0,
                        height: '100%'
                    },
                    '&:not(:last-child):after': {
                        left: {
                            _skip_check_: true,
                            value: '50%'
                        },
                        top: '100%',
                        width: calc(fontSizeIcon).div(3).mul(2).equal(),
                        height: calc(fontSizeIcon).div(3).mul(2).equal(),
                        transform: 'translateY(-50%) translateX(-50%) rotate(135deg)'
                    }
                }
            }
        }
    };
};
var $8909f079fb757c73$export$2e2bcd8739ae039 = $8909f079fb757c73$var$genLegacyNavStyle;



const $db459faefcdb0a28$var$genPanelStyle = (token)=>{
    const { componentCls: componentCls, calc: calc, lineWidthBold: lineWidthBold, borderRadius: borderRadius, borderRadiusSM: borderRadiusSM, motionDurationMid: motionDurationMid } = token;
    const itemCls = `${componentCls}-item`;
    const borderStyle = `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidthBold)} ${token.lineType} var(--steps-panel-border-color)`;
    return {
        [`${componentCls}${componentCls}-panel`]: [
            // ==========================================================
            // ==                       Clean up                       ==
            // ==========================================================
            {
                // ====================== Shared ======================
                [`${itemCls}-rail`]: {
                    display: 'none'
                },
                // ==================== Horizontal ====================
                [`&${componentCls}-horizontal`]: {
                    alignItems: 'stretch',
                    [itemCls]: {
                        flex: 1,
                        margin: 0
                    }
                }
            },
            // ==========================================================
            // ==                       Template                       ==
            // ==========================================================
            {
                '&': {
                    '--steps-panel-padding': token.paddingSM,
                    '--steps-item-border-radius': borderRadius,
                    [itemCls]: {
                        // Panel background
                        '--steps-panel-bg-color': 'var(--steps-item-icon-bg-color)',
                        '--steps-panel-border-color': 'var(--steps-item-icon-border-color)',
                        '--steps-panel-active-bg-color': 'var(--steps-item-icon-active-bg-color)',
                        '--steps-panel-active-border-color': 'var(--steps-item-icon-active-border-color)',
                        '--steps-panel-title-height': `calc(var(--steps-title-font-size) * var(--steps-title-line-height))`,
                        // Base height = padding * 2 + iconSize + contentHeight
                        '--steps-item-base-height': calc('var(--steps-panel-padding)').mul(2).add('var(--steps-icon-size)').add('var(--steps-panel-title-height)').equal(),
                        '--steps-item-base-width': 'calc(var(--steps-item-base-height) * 0.7071)',
                        transition: `background ${motionDurationMid}`
                    }
                },
                // ======================= Icon =======================
                [`${itemCls}-icon`]: {
                    display: 'none'
                },
                // ====================== Header ======================
                [`${itemCls}-header`]: {
                    minHeight: 'auto'
                },
                // ====================== Arrow =======================
                [`${componentCls}-panel-arrow`]: {
                    position: 'absolute',
                    top: calc(lineWidthBold).mul(-1).equal(),
                    insetInlineStart: '100%',
                    zIndex: 1,
                    height: calc(lineWidthBold).mul(2).add('100%').equal(),
                    width: 'var(--steps-item-base-width)',
                    overflow: 'visible',
                    strokeLinecap: 'round',
                    path: {
                        fill: 'var(--steps-panel-bg-color)',
                        stroke: 'var(--steps-panel-border-color)',
                        strokeWidth: lineWidthBold,
                        vectorEffect: 'non-scaling-stroke',
                        transition: `fill ${motionDurationMid}`
                    }
                },
                [`${itemCls}:last-child ${componentCls}-panel-arrow`]: {
                    display: 'none'
                },
                // ======================= Item =======================
                [itemCls]: {
                    padding: 'var(--steps-panel-padding)',
                    background: 'var(--steps-panel-bg-color)',
                    position: 'relative',
                    borderBlock: borderStyle,
                    '&:not(:first-child)': {
                        paddingInlineStart: `calc(var(--steps-panel-padding) + var(--steps-item-base-width))`
                    },
                    '&:first-child': {
                        borderInlineStart: borderStyle,
                        borderStartStartRadius: 'var(--steps-item-border-radius)',
                        borderEndStartRadius: 'var(--steps-item-border-radius)'
                    },
                    '&:last-child': {
                        borderInlineEnd: borderStyle,
                        borderStartEndRadius: 'var(--steps-item-border-radius)',
                        borderEndEndRadius: 'var(--steps-item-border-radius)'
                    },
                    '&-active': {
                        background: 'var(--steps-panel-active-bg-color)',
                        borderColor: 'var(--steps-panel-active-border-color)',
                        [`${componentCls}-panel-arrow`]: {
                            path: {
                                fill: 'var(--steps-panel-active-bg-color)',
                                stroke: 'var(--steps-panel-active-border-color)'
                            }
                        },
                        [`${itemCls}-title, ${itemCls}-subtitle, ${itemCls}-content`]: {
                            color: 'var(--steps-item-icon-active-text-color)'
                        }
                    }
                }
            },
            // ==========================================================
            // ==                         Size                         ==
            // ==========================================================
            {
                [`&${componentCls}-small`]: {
                    '--steps-panel-padding': token.paddingXS,
                    '--steps-item-border-radius': borderRadiusSM
                }
            },
            // ==========================================================
            // ==                        Filled                        ==
            // ==========================================================
            {
                [`&${componentCls}-filled`]: {
                    [itemCls]: {
                        '&:not(:first-child)': {
                            clipPath: `polygon(${[
                                `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidthBold)} 0`,
                                'calc(100% + var(--steps-item-base-width)) 0',
                                'calc(100% + var(--steps-item-base-width)) 100%',
                                `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidthBold)} 100%`,
                                `calc(var(--steps-item-base-width) + ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidthBold)}) 50%`
                            ].join(',')})`
                        }
                    }
                }
            },
            // ==========================================================
            // ==                       Outlined                       ==
            // ==========================================================
            {
                [`&${componentCls}-outlined`]: {
                    [`${componentCls}-panel-arrow`]: {
                        top: calc(lineWidthBold).div(2).mul(-1).equal(),
                        height: calc(lineWidthBold).add('100%').equal()
                    }
                }
            }
        ]
    };
};
var $db459faefcdb0a28$export$2e2bcd8739ae039 = $db459faefcdb0a28$var$genPanelStyle;



const $8bd1bd01febdb0ec$var$genStepsProgressStyle = (token)=>{
    const { calc: calc, antCls: antCls, componentCls: componentCls, iconSize: iconSize, iconSizeSM: iconSizeSM, lineWidthBold: lineWidthBold, paddingXXS: paddingXXS } = token;
    const itemCls = `${componentCls}-item`;
    const progressSize = token.calc(iconSize).add(token.calc(lineWidthBold).mul(4).equal()).equal();
    const progressSizeSM = token.calc(iconSizeSM).add(token.calc(token.lineWidth).mul(4).equal()).equal();
    const enhanceSize = calc(lineWidthBold).add(lineWidthBold).equal();
    return {
        [`${componentCls}${componentCls}-with-progress`]: {
            '--steps-item-wrapper-padding-top': enhanceSize,
            [`${itemCls}${itemCls}-process`]: {
                [`${itemCls}-icon`]: {
                    position: 'relative'
                }
            },
            [`${itemCls}-progress-icon`]: {
                '&-svg': {
                    '--steps-svg-size': calc(enhanceSize).mul(2).add(`var(--steps-icon-size)`).equal(),
                    '--icon-size-ptg-unitless': `calc(100 / tan(atan2(var(--steps-svg-size),1px)))`,
                    fontSize: `var(--steps-svg-size)`,
                    lineHeight: `var(--icon-size-ptg-unitless)`,
                    position: 'absolute',
                    inset: calc(enhanceSize).mul(-1).equal(),
                    width: 'auto',
                    height: 'auto'
                },
                '&-circle': {
                    lineHeight: `var(--icon-size-ptg-unitless)`,
                    strokeWidth: calc(`var(--icon-size-ptg-unitless)`).mul(lineWidthBold).equal(),
                    '--progress-r': calc(`var(--steps-svg-size)`).sub(lineWidthBold).mul(`var(--icon-size-ptg-unitless)`).div(2).equal(),
                    r: `var(--progress-r)`,
                    fill: 'none',
                    cx: 50,
                    cy: 50,
                    transition: `all ${token.motionDurationSlow} ease-in-out`,
                    '&-rail': {
                        stroke: token.colorSplit
                    },
                    '&-ptg': {
                        stroke: token.colorPrimary
                    }
                }
            }
        },
        [`&${componentCls}-with-progress11`]: {
            // ==========================================================
            // ==                        Shared                        ==
            // ==========================================================
            [itemCls]: {
                paddingTop: paddingXXS,
                paddingInlineStart: paddingXXS
            },
            [`${itemCls}-icon`]: {
                position: 'relative',
                [`${antCls}-progress`]: {
                    position: 'absolute',
                    left: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    '&-body': {
                        width: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(progressSize)} !important`,
                        height: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(progressSize)} !important`
                    }
                }
            },
            [`&${componentCls}-small`]: {
                [`${itemCls}-icon ${antCls}-progress-body`]: {
                    width: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(progressSizeSM)} !important`,
                    height: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(progressSizeSM)} !important`
                }
            }
        }
    };
};
var $8bd1bd01febdb0ec$export$2e2bcd8739ae039 = $8bd1bd01febdb0ec$var$genStepsProgressStyle;



const $165dcbb4c22a7e80$var$genDotStyle = (token)=>{
    const { componentCls: componentCls, iconSize: iconSize, dotSize: dotSize, dotCurrentSize: dotCurrentSize, marginXXS: marginXXS, lineWidthBold: lineWidthBold, fontSizeSM: fontSizeSM } = token;
    const itemCls = `${componentCls}-item`;
    return {
        [`${componentCls}${componentCls}-dot`]: {
            '--steps-icon-size-active': dotCurrentSize,
            '--steps-icon-size': dotSize,
            '--steps-dot-icon-size': dotSize,
            '--steps-dot-icon-border-width': token.lineWidthBold,
            '--steps-rail-size': lineWidthBold,
            '--steps-icon-border-width': lineWidthBold,
            // ========================= Shared ==========================
            // Icon
            [`${itemCls}-custom ${itemCls}-icon`]: {
                fontSize: fontSizeSM
            },
            [`${itemCls}-icon`]: {
                position: 'relative',
                '&:after': {
                    content: '""',
                    width: iconSize,
                    height: iconSize,
                    display: 'block',
                    position: 'absolute',
                    top: '50%',
                    left: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translate(-50%, -50%)'
                }
            },
            // // >>> active
            [`${itemCls}-active ${itemCls}-icon`]: {
                '--steps-icon-size': 'var(--steps-icon-size-active)'
            },
            // ======================= Horizontal ========================
            [`&${componentCls}-horizontal`]: {
                // With descriptionMaxWidth
                [`&, &${componentCls}-small`]: (0, $281a6501f45c2b7c$export$f0196ef13ff2a3b7)(token, marginXXS)
            }
        }
    };
};
var $165dcbb4c22a7e80$export$2e2bcd8739ae039 = $165dcbb4c22a7e80$var$genDotStyle;



const $650ae588a80f6505$var$genRTLStyle = (token)=>{
    const { componentCls: componentCls, lineWidthBold: lineWidthBold } = token;
    const itemCls = `${componentCls}-item`;
    return {
        [`${componentCls}${componentCls}-rtl`]: {
            direction: 'rtl',
            // nav
            [`&${componentCls}-navigation${componentCls}-horizontal`]: {
                [`${itemCls}:after`]: {
                    transform: 'translateY(-50%) rotate(-45deg)'
                }
            },
            // panel
            [`&${componentCls}-panel`]: {
                [`${componentCls}-panel-arrow`]: {
                    transform: `scaleX(-1)`
                },
                [`&${componentCls}-filled`]: {
                    [itemCls]: {
                        '&:not(:first-child)': {
                            clipPath: `polygon(${[
                                `calc(0px - var(--steps-item-base-width)) 0px`,
                                `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidthBold)}) 0px`,
                                `calc(100% - var(--steps-item-base-width) - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidthBold)}) 50%`,
                                `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidthBold)}) 100%`,
                                `calc(0px - var(--steps-item-base-width)) 100%`
                            ].join(',')})`
                        }
                    }
                }
            }
        }
    };
};
var $650ae588a80f6505$export$2e2bcd8739ae039 = $650ae588a80f6505$var$genRTLStyle;



const $98e4ddcdc7b8e916$var$genSmallStyle = (token)=>{
    const { componentCls: componentCls, iconSizeSM: iconSizeSM, fontSize: fontSize, lineHeight: lineHeight, marginXS: marginXS } = token;
    return {
        [`${componentCls}${componentCls}-small`]: {
            '--steps-icon-size': iconSizeSM,
            '--steps-title-horizontal-item-margin': token.marginSM,
            '--steps-title-vertical-row-gap': token.paddingXS,
            '--steps-title-font-size': fontSize,
            '--steps-title-line-height': lineHeight,
            '--steps-title-horizontal-rail-margin': token.marginXS,
            '--steps-title-horizontal-title-height': token.fontHeight,
            // Horizontal: label vertical
            [`&${componentCls}-horizontal${componentCls}-title-vertical`]: (0, $281a6501f45c2b7c$export$f0196ef13ff2a3b7)(token, marginXS)
        }
    };
};
var $98e4ddcdc7b8e916$export$2e2bcd8739ae039 = $98e4ddcdc7b8e916$var$genSmallStyle;


const $5e2646a6854b1381$export$d49353233049811e = 'wait';
const $5e2646a6854b1381$export$a9cb6a5cf5715b5b = 'process';
const $5e2646a6854b1381$export$1b962970083dc27b = 'finish';
const $5e2646a6854b1381$export$6ef4b5709ac3acad = 'error';
const $5e2646a6854b1381$var$genStatusStyle = (token)=>{
    const { componentCls: componentCls, colorTextDisabled: colorTextDisabled, colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary, colorTextLabel: colorTextLabel, colorError: colorError, colorText: colorText, colorTextDescription: colorTextDescription, colorBgContainer: colorBgContainer, colorPrimaryHover: colorPrimaryHover } = token;
    const itemCls = `${componentCls}-item`;
    return {
        [componentCls]: [
            {
                // ========================= Variable =========================
                [itemCls]: {
                    // Normal
                    // >>> line
                    '--steps-item-solid-line-color': '#000',
                    // >>> text
                    '--steps-item-title-color': '#000',
                    '--steps-item-content-color': '#000',
                    '--steps-item-subtitle-color': 'var(--steps-item-content-color)',
                    // >>> icon
                    '--steps-item-icon-custom-color': '#000',
                    '--steps-item-icon-bg-color': '#000',
                    '--steps-item-icon-border-color': '#000',
                    '--steps-item-icon-text-color': '#fff',
                    // >>> dot
                    '--steps-item-icon-dot-color': '#000',
                    '--steps-item-icon-dot-bg-color': 'var(--steps-item-icon-dot-color)',
                    '--steps-item-icon-dot-border-color': 'var(--steps-item-icon-dot-color)',
                    // Hover
                    // >>> text
                    '--steps-item-text-hover-color': '#000',
                    // >>> icon
                    '--steps-item-icon-bg-hover-color': `var(--steps-item-icon-bg-color)`,
                    '--steps-item-icon-border-hover-color': `var(--steps-item-icon-border-color)`,
                    '--steps-item-icon-text-hover-color': `var(--steps-item-icon-text-color)`,
                    // Active
                    // >>> text
                    '--steps-item-content-active-color': `var(--steps-item-content-color)`,
                    // >>> icon
                    '--steps-item-icon-active-bg-color': 'var(--steps-item-icon-bg-color)',
                    '--steps-item-icon-active-border-color': 'var(--steps-item-icon-border-color)',
                    '--steps-item-icon-active-text-color': 'var(--steps-item-icon-text-color)',
                    // Status
                    '--steps-item-process-rail-line-style': token.lineType
                },
                // ========================= Template =========================
                // Normal
                // >>> line
                [`${itemCls}-rail`]: {
                    borderColor: `var(--steps-item-solid-line-color)`
                },
                // >>> icon
                [`${itemCls}-custom ${itemCls}-icon`]: {
                    color: `var(--steps-item-icon-custom-color)`
                },
                // >>> text
                [`${itemCls}-title`]: {
                    color: `var(--steps-item-title-color)`
                },
                [`${itemCls}-subtitle`]: {
                    color: `var(--steps-item-subtitle-color)`
                },
                [`${itemCls}-content`]: {
                    color: `var(--steps-item-content-color)`
                },
                // Active
                // >>> icon
                [`${itemCls}-active ${itemCls}-icon`]: {},
                // >>> text
                [`${itemCls}-active ${itemCls}-content`]: {
                    color: `var(--steps-item-content-active-color)`
                },
                // Hover
                // >>> text
                [`${itemCls}[role='button']:not(${itemCls}-active):hover`]: {
                    [`${itemCls}-title, ${itemCls}-content`]: {
                        color: `var(--steps-item-text-hover-color)`
                    }
                },
                // Not dot
                [`&:not(${componentCls}-dot)`]: {
                    [`${itemCls}:not(${itemCls}-custom)`]: {
                        [`${itemCls}-icon`]: {
                            background: `var(--steps-item-icon-bg-color)`,
                            borderColor: `var(--steps-item-icon-border-color)`,
                            color: `var(--steps-item-icon-text-color)`
                        },
                        // Hover
                        [`&[role='button']:not(${itemCls}-active):hover`]: {
                            [`${itemCls}-icon`]: {
                                background: `var(--steps-item-icon-bg-hover-color)`,
                                borderColor: `var(--steps-item-icon-border-hover-color)`,
                                color: `var(--steps-item-icon-text-hover-color)`
                            }
                        },
                        // Active
                        [`&${itemCls}-active`]: {
                            [`${itemCls}-icon`]: {
                                background: `var(--steps-item-icon-active-bg-color)`,
                                borderColor: `var(--steps-item-icon-active-border-color)`,
                                color: `var(--steps-item-icon-active-text-color)`
                            }
                        }
                    }
                },
                // Dot
                [`&${componentCls}-dot`]: {
                    [`${itemCls}-icon`]: {
                        background: `var(--steps-item-icon-dot-bg-color)`,
                        borderColor: `var(--steps-item-icon-dot-border-color)`,
                        color: `var(--steps-item-icon-dot-color)`,
                        [`&${itemCls}-icon-dot-custom`]: {
                            background: 'transparent',
                            border: 'none'
                        }
                    }
                }
            },
            {
                // ========================== Shared ==========================
                // Wait
                [`${itemCls}-${$5e2646a6854b1381$export$d49353233049811e}`]: {
                    '--steps-item-icon-custom-color': colorTextDisabled,
                    '--steps-item-title-color': colorTextDescription,
                    '--steps-item-content-color': colorTextDescription,
                    '--steps-item-content-active-color': colorText,
                    '--steps-item-text-hover-color': colorPrimaryHover
                },
                [`${itemCls}-rail-${$5e2646a6854b1381$export$d49353233049811e}`]: {
                    '--steps-item-solid-line-color': colorTextDisabled
                },
                // Process
                [`${itemCls}-${$5e2646a6854b1381$export$a9cb6a5cf5715b5b}`]: {
                    '--steps-item-icon-custom-color': colorPrimary,
                    '--steps-item-title-color': colorText,
                    '--steps-item-content-color': colorTextDescription,
                    '--steps-item-content-active-color': colorText,
                    '--steps-item-text-hover-color': colorPrimaryHover
                },
                [`${itemCls}-rail-${$5e2646a6854b1381$export$a9cb6a5cf5715b5b}`]: {
                    '--steps-item-solid-line-color': colorPrimary,
                    // Special for Timeline usage
                    '--steps-rail-line-style': 'var(--steps-item-process-rail-line-style)'
                },
                // Finish
                [`${itemCls}-${$5e2646a6854b1381$export$1b962970083dc27b}`]: {
                    '--steps-item-icon-custom-color': colorPrimary,
                    '--steps-item-title-color': colorText,
                    '--steps-item-content-color': colorTextDescription,
                    '--steps-item-content-active-color': colorText,
                    '--steps-item-text-hover-color': colorPrimaryHover
                },
                [`${itemCls}-rail-${$5e2646a6854b1381$export$1b962970083dc27b}`]: {
                    '--steps-item-solid-line-color': colorPrimary
                },
                // Error
                [`${itemCls}-${$5e2646a6854b1381$export$6ef4b5709ac3acad}`]: {
                    '--steps-item-icon-custom-color': colorError,
                    '--steps-item-title-color': colorError,
                    '--steps-item-content-color': colorError,
                    '--steps-item-content-active-color': colorError,
                    '--steps-item-text-hover-color': token.colorErrorHover
                },
                [`${itemCls}-rail-${$5e2646a6854b1381$export$6ef4b5709ac3acad}`]: {
                    '--steps-item-solid-line-color': colorError
                }
            },
            {
                // ========================== Filled ==========================
                [`&${componentCls}-filled`]: {
                    [itemCls]: {
                        '--steps-item-icon-dot-border-color': 'transparent'
                    },
                    // Wait
                    [`${itemCls}-${$5e2646a6854b1381$export$d49353233049811e}`]: {
                        '--steps-item-icon-bg-color': token.colorFillTertiary,
                        '--steps-item-icon-border-color': 'transparent',
                        '--steps-item-icon-text-color': colorTextLabel,
                        '--steps-item-icon-dot-bg-color': colorTextDisabled,
                        // Hover
                        '--steps-item-icon-bg-hover-color': token.colorPrimaryBgHover,
                        '--steps-item-icon-border-hover-color': 'transparent',
                        '--steps-item-icon-text-hover-color': colorPrimary,
                        // Active
                        '--steps-item-icon-active-bg-color': colorPrimary,
                        '--steps-item-icon-active-border-color': 'transparent',
                        '--steps-item-icon-active-text-color': colorTextLightSolid
                    },
                    // Finish & Process
                    [`${itemCls}-${$5e2646a6854b1381$export$a9cb6a5cf5715b5b}, ${itemCls}-${$5e2646a6854b1381$export$1b962970083dc27b}`]: {
                        '--steps-item-icon-bg-color': token.colorPrimaryBg,
                        '--steps-item-icon-border-color': 'transparent',
                        '--steps-item-icon-text-color': colorPrimary,
                        '--steps-item-icon-dot-bg-color': colorPrimary,
                        // Hover
                        '--steps-item-icon-bg-hover-color': token.colorPrimaryBgHover,
                        '--steps-item-icon-border-hover-color': 'transparent',
                        '--steps-item-icon-text-hover-color': colorPrimary,
                        // Active
                        '--steps-item-icon-active-bg-color': colorPrimary,
                        '--steps-item-icon-active-border-color': 'transparent',
                        '--steps-item-icon-active-text-color': colorTextLightSolid
                    },
                    // Error
                    [`${itemCls}-${$5e2646a6854b1381$export$6ef4b5709ac3acad}`]: {
                        '--steps-item-icon-bg-color': token.colorErrorBg,
                        '--steps-item-icon-border-color': 'transparent',
                        '--steps-item-icon-text-color': colorError,
                        '--steps-item-icon-dot-bg-color': colorError,
                        // Hover
                        '--steps-item-icon-bg-hover-color': token.colorErrorBgFilledHover,
                        '--steps-item-icon-border-hover-color': 'transparent',
                        '--steps-item-icon-text-hover-color': colorError,
                        // Active
                        '--steps-item-icon-active-bg-color': colorError,
                        '--steps-item-icon-active-border-color': 'transparent',
                        '--steps-item-icon-active-text-color': colorTextLightSolid
                    }
                }
            },
            {
                // ========================= Outlined =========================
                [`&${componentCls}-outlined`]: {
                    [itemCls]: {
                        '--steps-item-icon-dot-bg-color': 'transparent'
                    },
                    // Wait
                    [`${itemCls}-${$5e2646a6854b1381$export$d49353233049811e}`]: {
                        '--steps-item-icon-bg-color': colorBgContainer,
                        '--steps-item-icon-border-color': colorTextDisabled,
                        '--steps-item-icon-text-color': colorTextDisabled,
                        '--steps-item-icon-dot-color': colorTextDisabled,
                        // Hover
                        '--steps-item-icon-bg-hover-color': 'transparent',
                        '--steps-item-icon-border-hover-color': colorPrimaryHover,
                        '--steps-item-icon-text-hover-color': colorPrimaryHover,
                        // Active
                        '--steps-item-icon-active-bg-color': token.colorFillTertiary
                    },
                    // Finish & Process
                    [`${itemCls}-${$5e2646a6854b1381$export$a9cb6a5cf5715b5b}, ${itemCls}-${$5e2646a6854b1381$export$1b962970083dc27b}`]: {
                        '--steps-item-icon-bg-color': colorBgContainer,
                        '--steps-item-icon-border-color': colorPrimary,
                        '--steps-item-icon-text-color': colorPrimary,
                        '--steps-item-icon-dot-color': colorPrimary,
                        // Hover
                        '--steps-item-icon-bg-hover-color': 'transparent',
                        '--steps-item-icon-border-hover-color': token.colorPrimaryHover,
                        '--steps-item-icon-text-hover-color': token.colorPrimaryHover,
                        // Active
                        '--steps-item-icon-active-bg-color': token.colorPrimaryBg
                    },
                    // Error
                    [`${itemCls}-${$5e2646a6854b1381$export$6ef4b5709ac3acad}`]: {
                        '--steps-item-icon-bg-color': colorBgContainer,
                        '--steps-item-icon-border-color': colorError,
                        '--steps-item-icon-text-color': colorError,
                        '--steps-item-icon-dot-color': colorError,
                        // Hover
                        '--steps-item-icon-bg-hover-color': 'transparent',
                        '--steps-item-icon-border-hover-color': token.colorErrorHover,
                        '--steps-item-icon-text-hover-color': token.colorErrorHover,
                        // Active
                        '--steps-item-icon-active-bg-color': token.colorErrorBg
                    }
                }
            }
        ]
    };
};
var $5e2646a6854b1381$export$2e2bcd8739ae039 = $5e2646a6854b1381$var$genStatusStyle;


const $4575ef62cd89d899$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    const itemCls = `${componentCls}-item`;
    return {
        [`${componentCls}-vertical`]: {
            '--steps-vertical-rail-margin': calc(token.marginXXS).mul(1.5).equal(),
            flexDirection: 'column',
            alignItems: 'stretch',
            // Item
            [`> ${itemCls}`]: {
                minHeight: calc(token.controlHeight).mul(1.5).equal(),
                paddingBottom: token.paddingSM,
                '&:last-child': {
                    paddingBottom: 0
                },
                // Icon
                [`${itemCls}-icon`]: {
                    marginInlineStart: 'calc((var(--steps-icon-size-max) - var(--steps-icon-size)) / 2)'
                },
                // >>> Rail
                [`${itemCls}-rail`]: {
                    '--steps-rail-offset': calc('var(--steps-heading-height)').sub('var(--steps-icon-size)').div(2).equal(),
                    borderInlineStartWidth: 'var(--steps-rail-size)',
                    position: 'absolute',
                    top: calc(`var(--steps-icon-size)`).add('var(--steps-item-wrapper-padding-top)').add('var(--steps-rail-offset)').add('var(--steps-vertical-rail-margin)').equal(),
                    insetInlineStart: calc(`var(--steps-icon-size-max)`).div(2).equal(),
                    bottom: calc('var(--steps-vertical-rail-margin)').sub('var(--steps-rail-offset)').equal(),
                    marginInlineStart: `calc(var(--steps-rail-size) / -2)`
                }
            }
        }
    };
};
var $4575ef62cd89d899$export$2e2bcd8739ae039 = $4575ef62cd89d899$var$genVerticalStyle;


const $55d7c7741ff860db$var$genBasicStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const itemCls = `${componentCls}-item`;
    return {
        [componentCls]: {
            // TODO: use `genCssVar` hook to generate css variables
            '--steps-title-font-size': token.fontSizeLG,
            '--steps-title-line-height': token.lineHeightLG,
            '--steps-subtitle-font-size': token.fontSize,
            '--steps-subtitle-line-height': token.lineHeight,
            '--steps-item-wrapper-padding-top': '0px',
            '--steps-rail-size': token.lineWidth,
            '--steps-rail-line-style': token.lineType,
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            display: 'flex',
            flexWrap: 'nowrap',
            alignItems: 'flex-start',
            [itemCls]: {
                flex: 'none',
                position: 'relative'
            },
            [`${itemCls}-wrapper`]: {
                display: 'flex',
                flexWrap: 'nowrap',
                paddingTop: `var(--steps-item-wrapper-padding-top)`
            },
            // Icon
            // Check `./icon.ts`
            // Header
            [`${itemCls}-header`]: {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'center'
            },
            // >>> Title
            [`${itemCls}-title`]: {
                color: token.colorText,
                fontSize: `var(--steps-title-font-size)`,
                lineHeight: `var(--steps-title-line-height)`,
                wordBreak: 'break-word'
            },
            // >>> Sub Title
            [`${itemCls}-subtitle`]: {
                color: token.colorTextDescription,
                fontWeight: 'normal',
                fontSize: `var(--steps-subtitle-font-size)`,
                lineHeight: `var(--steps-subtitle-line-height)`,
                marginInlineStart: token.marginXS,
                wordBreak: 'break-word'
            },
            // Content
            [`${itemCls}-content`]: {
                color: token.colorTextDescription,
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                wordBreak: 'break-word'
            },
            // Rail
            [`${itemCls}-rail`]: {
                borderStyle: 'var(--steps-rail-line-style)',
                borderWidth: 0
            },
            // Motion
            [`${itemCls}-title, ${itemCls}-subtitle, ${itemCls}-content, ${itemCls}-rail`]: {
                transition: `all ${token.motionDurationSlow}`
            },
            // ========================== Ellipsis ==========================
            [`&${componentCls}-ellipsis`]: {
                [`${itemCls}-title, ${itemCls}-subtitle, ${itemCls}-content`]: (0, $945cb0d2b7017a11$export$b2b65df0d0824629)
            },
            // ========================= Clickable ==========================
            [`${itemCls}[role='button']:not(${itemCls}-active):hover`]: {
                cursor: 'pointer'
            }
        }
    };
};
const $55d7c7741ff860db$export$9ca1be8807fe0675 = (token)=>({
        titleLineHeight: token.controlHeight,
        customIconSize: token.controlHeight,
        customIconTop: 0,
        customIconFontSize: token.controlHeightSM,
        iconSize: token.controlHeight,
        iconTop: -0.5,
        // magic for ui experience
        iconFontSize: token.fontSize,
        iconSizeSM: token.fontSizeHeading3,
        dotSize: token.controlHeight / 4,
        dotCurrentSize: token.controlHeightLG / 4,
        navArrowColor: token.colorTextDisabled,
        navContentMaxWidth: 'unset',
        descriptionMaxWidth: undefined,
        // should be `undefined` to create css var
        waitIconColor: token.wireframe ? token.colorTextDisabled : token.colorTextLabel,
        waitIconBgColor: token.wireframe ? token.colorBgContainer : token.colorFillContent,
        waitIconBorderColor: token.wireframe ? token.colorTextDisabled : 'transparent',
        finishIconBgColor: token.wireframe ? token.colorBgContainer : token.controlItemBgActive,
        finishIconBorderColor: token.wireframe ? token.colorPrimary : token.controlItemBgActive
    });
var $55d7c7741ff860db$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Steps', (token)=>{
    const stepsToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        inlineDotSize: 6
    });
    return [
        $55d7c7741ff860db$var$genBasicStyle(stepsToken),
        (0, $bfb0cb92c78a049d$export$2e2bcd8739ae039)(stepsToken),
        (0, $4575ef62cd89d899$export$2e2bcd8739ae039)(stepsToken),
        (0, $5c96570707a3dddc$export$2e2bcd8739ae039)(stepsToken),
        (0, $d5651aebf047db21$export$2e2bcd8739ae039)(stepsToken),
        (0, $98e4ddcdc7b8e916$export$2e2bcd8739ae039)(stepsToken),
        (0, $165dcbb4c22a7e80$export$2e2bcd8739ae039)(stepsToken),
        (0, $5e2646a6854b1381$export$2e2bcd8739ae039)(stepsToken),
        (0, $8909f079fb757c73$export$2e2bcd8739ae039)(stepsToken),
        (0, $db459faefcdb0a28$export$2e2bcd8739ae039)(stepsToken),
        (0, $7267c7737561c86f$export$2e2bcd8739ae039)(stepsToken),
        (0, $8bd1bd01febdb0ec$export$2e2bcd8739ae039)(stepsToken),
        (0, $650ae588a80f6505$export$2e2bcd8739ae039)(stepsToken)
    ];
}, $55d7c7741ff860db$export$9ca1be8807fe0675);


"use client";
const $69a1a6b4bc56205c$var$waveEffectClassNames = {
    itemIcon: (0, $59c6657b0a346860$export$23466a5792b7a5d3)
};
const $69a1a6b4bc56205c$var$Steps = (props)=>{
    const { size: // Style
    size, className: className, rootClassName: rootClassName, style: style, variant: variant = 'filled', type: type, classNames: classNames, styles: styles, direction: // Layout
    direction, orientation: orientation, responsive: responsive = true, progressDot: progressDot, labelPlacement: labelPlacement, titlePlacement: titlePlacement, ellipsis: ellipsis, offset: offset = 0, items: // Data
    items, percent: percent, current: current = 0, onChange: onChange, iconRender: // Render
    iconRender, // MISC
    ...restProps } = props;
    const internalContent = $ltGt3.useContext((0, $ee6ed0e90dc98d4c$export$d056f9c7816498b6));
    const contextContent = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('steps');
    const { getPrefixCls: getPrefixCls, direction: rtlDirection, className: contextClassName, style: contextStyle } = contextContent;
    let contextClassNames;
    let contextStyles;
    let components = {};
    if (internalContent) components = {
        root: internalContent.rootComponent,
        item: internalContent.itemComponent
    };
    else ({ classNames: contextClassNames, styles: contextStyles } = contextContent);
    const prefixCls = getPrefixCls('steps', props.prefixCls);
    const itemIconCls = `${prefixCls}-item-icon`;
    const [hashId, cssVarCls] = (0, $55d7c7741ff860db$export$2e2bcd8739ae039)(prefixCls);
    // ============================= Size =============================
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)(size);
    // ============================= Item =============================
    const mergedItems = $ltGt3.useMemo(()=>(items || []).filter(Boolean), [
        items
    ]);
    // ============================ Layout ============================
    const { xs: xs } = (0, $ec3b57b710702d4d$export$2e2bcd8739ae039)(responsive);
    // Type
    const mergedType = $ltGt3.useMemo(()=>{
        if (type && type !== 'default') return type;
        if (progressDot) return 'dot';
        return type;
    }, [
        progressDot,
        type
    ]);
    const isInline = mergedType === 'inline';
    const isDot = mergedType === 'dot' || mergedType === 'inline';
    // Progress Dot Render function
    const legacyProgressDotRender = $ltGt3.useMemo(()=>{
        return mergedType === 'dot' && typeof progressDot === 'function' ? progressDot : undefined;
    }, [
        mergedType,
        progressDot
    ]);
    const mergedOrientation = $ltGt3.useMemo(()=>{
        const nextOrientation = orientation || direction;
        if (mergedType === 'panel') return 'horizontal';
        return responsive && xs || nextOrientation === 'vertical' ? 'vertical' : 'horizontal';
    }, [
        orientation,
        direction,
        mergedType,
        responsive,
        xs
    ]);
    const mergedTitlePlacement = $ltGt3.useMemo(()=>{
        if (isDot || mergedOrientation === 'vertical') return mergedOrientation === 'vertical' ? 'horizontal' : 'vertical';
        if (type === 'navigation') return 'horizontal';
        return titlePlacement || labelPlacement || 'horizontal';
    }, [
        isDot,
        labelPlacement,
        mergedOrientation,
        titlePlacement,
        type
    ]);
    // ========================== Percentage ==========================
    const mergedPercent = isInline ? undefined : percent;
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        variant: variant,
        size: mergedSize,
        type: mergedType,
        orientation: mergedOrientation,
        titlePlacement: mergedTitlePlacement,
        current: current,
        percent: mergedPercent,
        responsive: responsive,
        offset: offset
    };
    // ============================ Styles ============================
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        $69a1a6b4bc56205c$var$waveEffectClassNames,
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ============================= Icon =============================
    const internalIconRender = (_, info)=>{
        const { item: item, index: index, active: active, components: { Icon: StepIcon } } = info;
        const { status: status, icon: icon } = item;
        let iconContent = null;
        if (isDot || icon) iconContent = icon;
        else switch(status){
            case 'finish':
                iconContent = /*#__PURE__*/ $ltGt3.createElement((0, $69caf2b39a25e974$export$2e2bcd8739ae039), {
                    className: `${itemIconCls}-finish`
                });
                break;
            case 'error':
                iconContent = /*#__PURE__*/ $ltGt3.createElement((0, $7448fa8744d68ce1$export$2e2bcd8739ae039), {
                    className: `${itemIconCls}-error`
                });
                break;
            default:
                {
                    let numNode = /*#__PURE__*/ $ltGt3.createElement("span", {
                        className: `${itemIconCls}-number`
                    }, info.index + 1);
                    if (status === 'process' && mergedPercent !== undefined) numNode = /*#__PURE__*/ $ltGt3.createElement((0, $b04b24d8f7224c8e$export$2e2bcd8739ae039), {
                        prefixCls: prefixCls,
                        percent: mergedPercent
                    }, numNode);
                    iconContent = numNode;
                }
        }
        let iconNode = /*#__PURE__*/ $ltGt3.createElement(StepIcon, null, iconContent);
        // Custom Render Props
        if (iconRender) iconNode = iconRender(iconNode, {
            index: index,
            active: active,
            item: item,
            components: {
                Icon: StepIcon
            }
        });
        else if (typeof legacyProgressDotRender === 'function') iconNode = legacyProgressDotRender(iconNode, {
            index: index,
            ...item
        });
        return iconNode;
    };
    // ============================ Custom ============================
    const itemRender = (itemNode, itemInfo)=>{
        let content = itemNode;
        if (isInline && itemInfo.item.content) content = /*#__PURE__*/ $ltGt3.createElement((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
            destroyOnHidden: true,
            title: itemInfo.item.content
        }, itemNode);
        return /*#__PURE__*/ $ltGt3.createElement((0, $b5f0e609aabb59e2$export$2e2bcd8739ae039), {
            component: "Steps",
            disabled: itemInfo.item.disabled || !onChange,
            colorSource: variant === 'filled' ? 'color' : null
        }, content);
    };
    const itemWrapperRender = mergedType === 'panel' ? (itemNode)=>{
        return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, itemNode, /*#__PURE__*/ $ltGt3.createElement((0, $e42d4f52e707f4ad$export$2e2bcd8739ae039), {
            prefixCls: prefixCls
        }));
    } : undefined;
    // ============================ Styles ============================
    const mergedStyle = {
        '--steps-items-offset': `${offset}`,
        ...contextStyle,
        ...style
    };
    const stepsClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(contextClassName, `${prefixCls}-${variant}`, {
        [`${prefixCls}-${mergedType}`]: mergedType !== 'dot' ? mergedType : false,
        [`${prefixCls}-rtl`]: rtlDirection === 'rtl',
        [`${prefixCls}-dot`]: isDot,
        [`${prefixCls}-ellipsis`]: ellipsis,
        [`${prefixCls}-with-progress`]: mergedPercent !== undefined,
        [`${prefixCls}-${mergedSize}`]: mergedSize
    }, className, rootClassName, hashId, cssVarCls);
    var item;
    // ============================ Render ============================
    return /*#__PURE__*/ $ltGt3.createElement((0, $453f72b01ec42c81$export$2e2bcd8739ae039), {
        ...restProps,
        // Style
        prefixCls: prefixCls,
        className: stepsClassName,
        style: mergedStyle,
        classNames: mergedClassNames,
        styles: mergedStyles,
        // Layout
        orientation: mergedOrientation,
        titlePlacement: mergedTitlePlacement,
        components: components,
        // Data
        current: current,
        items: mergedItems,
        onChange: onChange,
        // Render
        iconRender: internalIconRender,
        itemRender: itemRender,
        itemWrapperRender: itemWrapperRender
    });
};
var $69a1a6b4bc56205c$export$2e2bcd8739ae039 = $69a1a6b4bc56205c$var$Steps;






const $379ae66b2cda8d94$var$genHorizontalStyle = (token)=>{
    const { componentCls: componentCls, fontHeight: fontHeight } = token;
    const itemCls = `${componentCls}-item`;
    return {
        [`${componentCls}-horizontal`]: {
            '--steps-title-vertical-row-gap': token.paddingXS,
            '--timeline-content-height': `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(fontHeight)}`,
            // =============================================================
            // ==                          Share                          ==
            // =============================================================
            alignItems: 'stretch',
            // =============================================================
            // ==                        Alternate                        ==
            // =============================================================
            [`&${componentCls}-layout-alternate`]: {
                [itemCls]: {
                    [`${itemCls}-wrapper`]: {
                        '--timeline-alternate-content-offset': `calc(var(--timeline-content-height) + var(--steps-title-vertical-row-gap) * 2 + var(--steps-icon-size-max))`,
                        height: `calc(var(--timeline-content-height) * 2 + var(--steps-title-vertical-row-gap) * 2 + var(--steps-icon-size-max))`
                    },
                    // Icon
                    [`${itemCls}-icon`]: {
                        position: 'absolute'
                    },
                    // Icon & Rail
                    [`${itemCls}-icon, ${itemCls}-rail`]: {
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        margin: 0
                    },
                    // Title & Content
                    [`${itemCls}-title, ${itemCls}-subtitle, ${itemCls}-content`]: {
                        whiteSpace: 'nowrap',
                        maxWidth: 'unset'
                    },
                    // Title
                    [`${itemCls}-title`]: {
                        position: 'absolute',
                        left: {
                            _skip_check_: true,
                            value: '50%'
                        },
                        transform: 'translateX(-50%)'
                    },
                    // Content
                    [`${itemCls}-content`]: {
                        position: 'absolute',
                        left: {
                            _skip_check_: true,
                            value: '50%'
                        },
                        transform: 'translateX(-50%)'
                    },
                    // Placement
                    '&-placement-start': {
                        [`${itemCls}-title`]: {
                            bottom: 'var(--timeline-alternate-content-offset)'
                        },
                        [`${itemCls}-content`]: {
                            top: 'var(--timeline-alternate-content-offset)'
                        }
                    },
                    '&-placement-end': {
                        [`${itemCls}-title`]: {
                            top: 'var(--timeline-alternate-content-offset)'
                        },
                        [`${itemCls}-content`]: {
                            bottom: 'var(--timeline-alternate-content-offset)'
                        }
                    }
                }
            },
            // =============================================================
            // ==                        Same Side                        ==
            // =============================================================
            [`&:not(${componentCls}-layout-alternate)`]: {
                [`${itemCls}-placement-end`]: {
                    display: 'flex',
                    alignItems: 'flex-end',
                    [`${itemCls}-wrapper`]: {
                        flex: 'auto',
                        flexDirection: 'column-reverse'
                    },
                    [`${itemCls}-rail`]: {
                        top: 'auto',
                        bottom: 'var(--steps-horizontal-rail-margin)',
                        transform: 'translateY(50%)'
                    }
                }
            }
        }
    };
};
var $379ae66b2cda8d94$export$2e2bcd8739ae039 = $379ae66b2cda8d94$var$genHorizontalStyle;


const $fb8e770ff87ed5be$var$genTimelineStyle = (token)=>{
    const { componentCls: componentCls, tailColor: tailColor } = token;
    const itemCls = `${componentCls}-item`;
    return {
        [componentCls]: [
            // ==============================================================
            // ==                           Item                           ==
            // ==============================================================
            {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                [itemCls]: {
                    '--steps-title-horizontal-title-height': token.fontHeight,
                    '--steps-vertical-rail-margin': '0px',
                    '--steps-title-horizontal-rail-gap': '0px',
                    // Root Level: Record Steps icon size and support fallback
                    '--steps-icon-dot-size-origin': 'var(--steps-icon-size-active)',
                    '--steps-icon-dot-size-custom': token.dotSize,
                    // Item Level: Record Steps icon color and support fallback
                    '--steps-item-icon-dot-bg-color-origin': 'var(--steps-item-icon-dot-bg-color)',
                    '--steps-item-icon-dot-bg-color-custom': token.dotBg,
                    '--steps-icon-size': 'var(--steps-icon-dot-size-custom, var(--steps-icon-dot-size-origin))',
                    // Icon
                    [`${itemCls}-icon`]: {
                        '--steps-dot-icon-border-width': token.dotBorderWidth,
                        '--steps-dot-icon-size': 'var(--steps-icon-size)',
                        '--steps-item-icon-dot-bg-color': 'var(--steps-item-icon-dot-bg-color-custom, var(--steps-item-icon-dot-bg-color-origin))'
                    },
                    // Title
                    [`${itemCls}-title`]: {
                        fontSize: token.fontSize,
                        lineHeight: token.lineHeight
                    },
                    // Content
                    [`${itemCls}-content`]: {
                        color: token.colorText
                    },
                    // Rail
                    [`${itemCls}-rail`]: {
                        '--steps-item-solid-line-color': tailColor,
                        '--steps-rail-size': token.tailWidth
                    }
                }
            },
            // ==============================================================
            // ==                          Status                          ==
            // ==============================================================
            {
                [itemCls]: {
                    '--steps-item-process-rail-line-style': 'dotted'
                },
                [`${itemCls}${itemCls}${itemCls}-color`]: {
                    '&-blue': {
                        '--steps-item-icon-dot-color': token.colorPrimary
                    },
                    '&-red': {
                        '--steps-item-icon-dot-color': token.colorError
                    },
                    '&-green': {
                        '--steps-item-icon-dot-color': token.colorSuccess
                    },
                    '&-gray': {
                        '--steps-item-icon-dot-color': token.colorTextDisabled
                    }
                }
            }
        ]
    };
};
const $fb8e770ff87ed5be$var$genVerticalStyle = (token)=>{
    const { calc: calc, componentCls: componentCls, itemPaddingBottom: itemPaddingBottom } = token;
    const itemCls = `${componentCls}-item`;
    return {
        [`${componentCls}:not(${componentCls}-horizontal)`]: {
            '--timeline-head-span': '12',
            '--timeline-head-span-ptg': 'calc(var(--timeline-head-span) / 24 * 100%)',
            // =============================================================
            // ==                        Alternate                        ==
            // =============================================================
            [`&${componentCls}-layout-alternate`]: {
                [itemCls]: {
                    '--timeline-alternate-gap': calc(token.margin).mul(2).add('var(--steps-dot-icon-size)').equal(),
                    minHeight: 'auto',
                    paddingBottom: itemPaddingBottom,
                    // Icon & Rail
                    [`${itemCls}-icon, ${itemCls}-rail`]: {
                        position: 'absolute',
                        insetInlineStart: 'var(--timeline-head-span-ptg)'
                    },
                    // Icon
                    [`${itemCls}-icon`]: {
                        marginInlineStart: `calc(var(--steps-icon-size) / -2)`
                    },
                    // Section
                    [`${itemCls}-section`]: {
                        display: 'flex',
                        flexWrap: 'nowrap',
                        gap: 'var(--timeline-alternate-gap)'
                    },
                    // >>> Header
                    [`${itemCls}-header`]: {
                        textAlign: 'end',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        flex: '1 1 calc(var(--timeline-head-span-ptg) - var(--timeline-alternate-gap) / 2)'
                    },
                    // >>> Content
                    [`${itemCls}-content`]: {
                        textAlign: 'start',
                        flex: '1 1 calc(100% - var(--timeline-head-span-ptg) - var(--timeline-alternate-gap) / 2)'
                    },
                    // Placement
                    '&-placement-end': {
                        [`${itemCls}-header`]: {
                            textAlign: 'start',
                            order: 1
                        },
                        [`${itemCls}-content`]: {
                            textAlign: 'end'
                        },
                        [`${itemCls}-icon, ${itemCls}-rail`]: {
                            insetInlineStart: 'calc(100% - var(--timeline-head-span-ptg))'
                        }
                    }
                }
            },
            // =============================================================
            // ==                        Same Side                        ==
            // =============================================================
            [`&:not(${componentCls}-layout-alternate)`]: {
                [`${itemCls}-placement-end`]: {
                    textAlign: 'end',
                    [`${itemCls}-icon`]: {
                        order: 1
                    },
                    [`${itemCls}-rail`]: {
                        insetInlineStart: 'auto',
                        insetInlineEnd: 'calc(var(--steps-icon-size) / 2)',
                        marginInlineEnd: `calc(var(--steps-rail-size) / -2)`
                    }
                }
            }
        }
    };
};
const $fb8e770ff87ed5be$export$9ca1be8807fe0675 = (token)=>({
        tailColor: token.colorSplit,
        tailWidth: token.lineWidthBold,
        dotBorderWidth: token.lineWidthBold,
        dotBg: undefined,
        dotSize: undefined,
        itemPaddingBottom: token.padding * 1.25
    });
var $fb8e770ff87ed5be$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Timeline', (token)=>{
    const timeLineToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        itemHeadSize: 10,
        customHeadPaddingVertical: token.paddingXXS,
        paddingInlineEnd: 2
    });
    return [
        $fb8e770ff87ed5be$var$genTimelineStyle(timeLineToken),
        $fb8e770ff87ed5be$var$genVerticalStyle(timeLineToken),
        (0, $379ae66b2cda8d94$export$2e2bcd8739ae039)(timeLineToken)
    ];
}, $fb8e770ff87ed5be$export$9ca1be8807fe0675);



var $ltGt3 = parcelRequire("ltGt3");



"use client";
function $2566b8bfe2ae1cad$export$2e2bcd8739ae039(prefixCls, mode, items, children, pending, pendingDot) {
    const itemCls = `${prefixCls}-item`;
    // Merge items and children
    const parseItems = $ltGt3.useMemo(()=>{
        return Array.isArray(items) ? items : (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children).map((ele)=>({
                ...ele.props
            }));
    }, [
        items,
        children
    ]);
    // convert legacy type
    return $ltGt3.useMemo(()=>{
        const mergedItems = parseItems.map((item, index)=>{
            const { label: label, children: children, title: title, content: content, color: color, className: className, style: style, icon: icon, dot: dot, placement: placement, position: position, loading: loading, ...restProps } = item;
            let mergedStyle = style;
            let mergedClassName = className;
            // Color
            if (color) {
                if ([
                    'blue',
                    'red',
                    'green',
                    'gray'
                ].includes(color)) mergedClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, `${itemCls}-color-${color}`);
                else mergedStyle = {
                    '--steps-item-icon-dot-color': color,
                    ...style
                };
            }
            // Placement
            const mergedPlacement = placement ?? position ?? (mode === 'alternate' ? index % 2 === 0 ? 'start' : 'end' : mode);
            mergedClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(mergedClassName, `${itemCls}-placement-${mergedPlacement}`);
            // Icon
            let mergedIcon = icon ?? dot;
            if (!mergedIcon && loading) mergedIcon = /*#__PURE__*/ $ltGt3.createElement((0, $8ede40f9e9e4f5c2$export$2e2bcd8739ae039), null);
            return {
                ...restProps,
                title: title ?? label,
                content: content ?? children,
                style: mergedStyle,
                className: mergedClassName,
                icon: mergedIcon,
                status: loading ? 'process' : 'finish'
            };
        });
        if (pending) mergedItems.push({
            icon: pendingDot ?? /*#__PURE__*/ $ltGt3.createElement((0, $8ede40f9e9e4f5c2$export$2e2bcd8739ae039), null),
            content: pending,
            status: 'process'
        });
        return mergedItems;
    }, [
        parseItems,
        pending,
        pendingDot,
        itemCls,
        mode
    ]);
}


"use client";
const $e00bc8ddbeda9bf2$var$stepInternalContext = {
    rootComponent: 'ol',
    itemComponent: 'li'
};
const $e00bc8ddbeda9bf2$var$Timeline = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('timeline');
    const { prefixCls: customizePrefixCls, className: // Style
    className, style: style, classNames: classNames, styles: styles, variant: // Design
    variant = 'outlined', mode: mode, orientation: orientation = 'vertical', titleSpan: titleSpan, items: // Data
    items, children: children, reverse: reverse, pending: // Legacy Pending
    pending, pendingDot: pendingDot, ...restProps } = props;
    // ===================== MISC =======================
    const prefixCls = getPrefixCls('timeline', customizePrefixCls);
    // ==================== Styles ======================
    // This will be duplicated with Steps's hashId & cssVarCls when they have same token
    // But this is safe to keep here since web will do nothing
    const [hashId, cssVarCls] = (0, $fb8e770ff87ed5be$export$2e2bcd8739ae039)(prefixCls);
    const stepsClassNames = $ltGt3.useMemo(()=>({
            item: `${prefixCls}-item`,
            itemTitle: `${prefixCls}-item-title`,
            itemIcon: `${prefixCls}-item-icon`,
            itemContent: `${prefixCls}-item-content`,
            itemRail: `${prefixCls}-item-rail`,
            itemWrapper: `${prefixCls}-item-wrapper`,
            itemSection: `${prefixCls}-item-section`,
            itemHeader: `${prefixCls}-item-header`
        }), [
        prefixCls
    ]);
    // ===================== Mode =======================
    const mergedMode = $ltGt3.useMemo(()=>{
        // Deprecated
        if (mode === 'left') return 'start';
        if (mode === 'right') return 'end';
        // Fill
        const modeList = [
            'alternate',
            'start',
            'end'
        ];
        return modeList.includes(mode) ? mode : 'start';
    }, [
        mode
    ]);
    // ===================== Data =======================
    const rawItems = (0, $2566b8bfe2ae1cad$export$2e2bcd8739ae039)(prefixCls, mergedMode, items, children, pending, pendingDot);
    const mergedItems = $ltGt3.useMemo(()=>reverse ? (0, $83d01b7684a01087$export$2e2bcd8739ae039)(rawItems).reverse() : rawItems, [
        reverse,
        rawItems
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        variant: variant,
        mode: mergedMode,
        orientation: orientation,
        items: mergedItems
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        stepsClassNames,
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const stepContext = $ltGt3.useMemo(()=>({
            railFollowPrevStatus: reverse
        }), [
        reverse
    ]);
    // ==================== Design ======================
    const layoutAlternate = $ltGt3.useMemo(()=>mergedMode === 'alternate' || orientation === 'vertical' && mergedItems.some((item)=>item.title), [
        mergedItems,
        mergedMode,
        orientation
    ]);
    var oldProp, newProp, item;
    // ==================== Render ======================
    const stepStyle = {
        ...contextStyle,
        ...style
    };
    if (titleSpan && mergedMode !== 'alternate') {
        if (typeof titleSpan === 'number') stepStyle['--timeline-head-span'] = titleSpan;
        else stepStyle['--timeline-head-span-ptg'] = titleSpan;
    }
    return /*#__PURE__*/ $ltGt3.createElement((0, $ee6ed0e90dc98d4c$export$d056f9c7816498b6).Provider, {
        value: $e00bc8ddbeda9bf2$var$stepInternalContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $6ba8c6d18ca09c16$export$e508d6f1a100e5dd).Provider, {
        value: stepContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $69a1a6b4bc56205c$export$2e2bcd8739ae039), {
        ...restProps,
        // Style
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, contextClassName, className, hashId, cssVarCls, {
            [`${prefixCls}-${orientation}`]: orientation === 'horizontal',
            [`${prefixCls}-layout-alternate`]: layoutAlternate,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }),
        style: stepStyle,
        classNames: mergedClassNames,
        styles: mergedStyles,
        // Design
        variant: variant,
        orientation: orientation,
        // Layout
        type: "dot",
        items: mergedItems,
        current: mergedItems.length - 1
    })));
};
$e00bc8ddbeda9bf2$var$Timeline.Item = ()=>{};
var $e00bc8ddbeda9bf2$export$2e2bcd8739ae039 = $e00bc8ddbeda9bf2$var$Timeline;


"use client";
var $3b19d9d783aeb5e8$export$2e2bcd8739ae039 = (0, $e00bc8ddbeda9bf2$export$2e2bcd8739ae039);




var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");



function $fdcf5d1352ed4c5d$var$_extends() {
    $fdcf5d1352ed4c5d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fdcf5d1352ed4c5d$var$_extends.apply(this, arguments);
}
const $fdcf5d1352ed4c5d$var$Switch = /*#__PURE__*/ $ltGt3.forwardRef(({ prefixCls: prefixCls = 'rc-switch', className: className, checked: checked, defaultChecked: defaultChecked, disabled: disabled, loadingIcon: loadingIcon, checkedChildren: checkedChildren, unCheckedChildren: unCheckedChildren, onClick: onClick, onChange: onChange, onKeyDown: onKeyDown, styles: styles, classNames: switchClassNames, ...restProps }, ref)=>{
    const [innerChecked, setInnerChecked] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultChecked ?? false, checked);
    function triggerChange(newChecked, event) {
        let mergedChecked = innerChecked;
        if (!disabled) {
            mergedChecked = newChecked;
            setInnerChecked(mergedChecked);
            onChange?.(mergedChecked, event);
        }
        return mergedChecked;
    }
    function onInternalKeyDown(e) {
        if (e.which === (0, $b0616a5421b43292$export$2e2bcd8739ae039).LEFT) triggerChange(false, e);
        else if (e.which === (0, $b0616a5421b43292$export$2e2bcd8739ae039).RIGHT) triggerChange(true, e);
        onKeyDown?.(e);
    }
    function onInternalClick(e) {
        const ret = triggerChange(!innerChecked, e);
        // [Legacy] trigger onClick with value
        onClick?.(ret, e);
    }
    const switchClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prefixCls, className, {
        [`${prefixCls}-checked`]: innerChecked,
        [`${prefixCls}-disabled`]: disabled
    });
    return /*#__PURE__*/ $ltGt3.createElement("button", $fdcf5d1352ed4c5d$var$_extends({}, restProps, {
        type: "button",
        role: "switch",
        "aria-checked": innerChecked,
        disabled: disabled,
        className: switchClassName,
        ref: ref,
        onKeyDown: onInternalKeyDown,
        onClick: onInternalClick
    }), loadingIcon, /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${prefixCls}-inner`
    }, /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-inner-checked`, switchClassNames?.content),
        style: styles?.content
    }, checkedChildren), /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(`${prefixCls}-inner-unchecked`, switchClassNames?.content),
        style: styles?.content
    }, unCheckedChildren)));
});
$fdcf5d1352ed4c5d$var$Switch.displayName = 'Switch';
var $fdcf5d1352ed4c5d$export$2e2bcd8739ae039 = $fdcf5d1352ed4c5d$var$Switch;













const $be0a847a02ec5dd1$var$genSwitchSmallStyle = (token)=>{
    const { componentCls: componentCls, trackHeightSM: trackHeightSM, trackPadding: trackPadding, trackMinWidthSM: trackMinWidthSM, innerMinMarginSM: innerMinMarginSM, innerMaxMarginSM: innerMaxMarginSM, handleSizeSM: handleSizeSM, calc: calc } = token;
    const switchInnerCls = `${componentCls}-inner`;
    const trackPaddingCalc = (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(handleSizeSM).add(calc(trackPadding).mul(2)).equal());
    const innerMaxMarginCalc = (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(innerMaxMarginSM).mul(2).equal());
    return {
        [componentCls]: {
            [`&${componentCls}-small`]: {
                minWidth: trackMinWidthSM,
                height: trackHeightSM,
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(trackHeightSM),
                [`${componentCls}-inner`]: {
                    paddingInlineStart: innerMaxMarginSM,
                    paddingInlineEnd: innerMinMarginSM,
                    [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
                        minHeight: trackHeightSM
                    },
                    [`${switchInnerCls}-checked`]: {
                        marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
                        marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
                    },
                    [`${switchInnerCls}-unchecked`]: {
                        marginTop: calc(trackHeightSM).mul(-1).equal(),
                        marginInlineStart: 0,
                        marginInlineEnd: 0
                    }
                },
                [`${componentCls}-handle`]: {
                    width: handleSizeSM,
                    height: handleSizeSM
                },
                [`${componentCls}-loading-icon`]: {
                    top: calc(calc(handleSizeSM).sub(token.switchLoadingIconSize)).div(2).equal(),
                    fontSize: token.switchLoadingIconSize
                },
                [`&${componentCls}-checked`]: {
                    [`${componentCls}-inner`]: {
                        paddingInlineStart: innerMinMarginSM,
                        paddingInlineEnd: innerMaxMarginSM,
                        [`${switchInnerCls}-checked`]: {
                            marginInlineStart: 0,
                            marginInlineEnd: 0
                        },
                        [`${switchInnerCls}-unchecked`]: {
                            marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
                            marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
                        }
                    },
                    [`${componentCls}-handle`]: {
                        insetInlineStart: `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(handleSizeSM).add(trackPadding).equal())})`
                    }
                },
                [`&:not(${componentCls}-disabled):active`]: {
                    [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
                        [`${switchInnerCls}-unchecked`]: {
                            marginInlineStart: calc(token.marginXXS).div(2).equal(),
                            marginInlineEnd: calc(token.marginXXS).mul(-1).div(2).equal()
                        }
                    },
                    [`&${componentCls}-checked ${switchInnerCls}`]: {
                        [`${switchInnerCls}-checked`]: {
                            marginInlineStart: calc(token.marginXXS).mul(-1).div(2).equal(),
                            marginInlineEnd: calc(token.marginXXS).div(2).equal()
                        }
                    }
                }
            }
        }
    };
};
const $be0a847a02ec5dd1$var$genSwitchLoadingStyle = (token)=>{
    const { componentCls: componentCls, handleSize: handleSize, calc: calc } = token;
    return {
        [componentCls]: {
            [`${componentCls}-loading-icon${token.iconCls}`]: {
                position: 'relative',
                top: calc(calc(handleSize).sub(token.fontSize)).div(2).equal(),
                color: token.switchLoadingIconColor,
                verticalAlign: 'top'
            },
            [`&${componentCls}-checked ${componentCls}-loading-icon`]: {
                color: token.switchColor
            }
        }
    };
};
const $be0a847a02ec5dd1$var$genSwitchHandleStyle = (token)=>{
    const { componentCls: componentCls, trackPadding: trackPadding, handleBg: handleBg, handleShadow: handleShadow, handleSize: handleSize, calc: calc } = token;
    const switchHandleCls = `${componentCls}-handle`;
    return {
        [componentCls]: {
            [switchHandleCls]: {
                position: 'absolute',
                top: trackPadding,
                insetInlineStart: trackPadding,
                width: handleSize,
                height: handleSize,
                transition: `all ${token.switchDuration} ease-in-out`,
                '&::before': {
                    position: 'absolute',
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    backgroundColor: handleBg,
                    borderRadius: calc(handleSize).div(2).equal(),
                    boxShadow: handleShadow,
                    transition: `all ${token.switchDuration} ease-in-out`,
                    content: '""'
                }
            },
            [`&${componentCls}-checked ${switchHandleCls}`]: {
                insetInlineStart: `calc(100% - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(handleSize).add(trackPadding).equal())})`
            },
            [`&:not(${componentCls}-disabled):active`]: {
                [`${switchHandleCls}::before`]: {
                    insetInlineEnd: token.switchHandleActiveInset,
                    insetInlineStart: 0
                },
                [`&${componentCls}-checked ${switchHandleCls}::before`]: {
                    insetInlineEnd: 0,
                    insetInlineStart: token.switchHandleActiveInset
                }
            }
        }
    };
};
const $be0a847a02ec5dd1$var$genSwitchInnerStyle = (token)=>{
    const { componentCls: componentCls, trackHeight: trackHeight, trackPadding: trackPadding, innerMinMargin: innerMinMargin, innerMaxMargin: innerMaxMargin, handleSize: handleSize, calc: calc } = token;
    const switchInnerCls = `${componentCls}-inner`;
    const trackPaddingCalc = (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(handleSize).add(calc(trackPadding).mul(2)).equal());
    const innerMaxMarginCalc = (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(innerMaxMargin).mul(2).equal());
    return {
        [componentCls]: {
            [switchInnerCls]: {
                display: 'block',
                overflow: 'hidden',
                borderRadius: 100,
                height: '100%',
                paddingInlineStart: innerMaxMargin,
                paddingInlineEnd: innerMinMargin,
                transition: `padding-inline-start ${token.switchDuration} ease-in-out, padding-inline-end ${token.switchDuration} ease-in-out`,
                [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
                    display: 'block',
                    color: token.colorTextLightSolid,
                    fontSize: token.fontSizeSM,
                    transition: `margin-inline-start ${token.switchDuration} ease-in-out, margin-inline-end ${token.switchDuration} ease-in-out`,
                    pointerEvents: 'none',
                    minHeight: trackHeight
                },
                [`${switchInnerCls}-checked`]: {
                    marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
                    marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
                },
                [`${switchInnerCls}-unchecked`]: {
                    marginTop: calc(trackHeight).mul(-1).equal(),
                    marginInlineStart: 0,
                    marginInlineEnd: 0
                }
            },
            [`&${componentCls}-checked ${switchInnerCls}`]: {
                paddingInlineStart: innerMinMargin,
                paddingInlineEnd: innerMaxMargin,
                [`${switchInnerCls}-checked`]: {
                    marginInlineStart: 0,
                    marginInlineEnd: 0
                },
                [`${switchInnerCls}-unchecked`]: {
                    marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
                    marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
                }
            },
            [`&:not(${componentCls}-disabled):active`]: {
                [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
                    [`${switchInnerCls}-unchecked`]: {
                        marginInlineStart: calc(trackPadding).mul(2).equal(),
                        marginInlineEnd: calc(trackPadding).mul(-1).mul(2).equal()
                    }
                },
                [`&${componentCls}-checked ${switchInnerCls}`]: {
                    [`${switchInnerCls}-checked`]: {
                        marginInlineStart: calc(trackPadding).mul(-1).mul(2).equal(),
                        marginInlineEnd: calc(trackPadding).mul(2).equal()
                    }
                }
            }
        }
    };
};
const $be0a847a02ec5dd1$var$genSwitchStyle = (token)=>{
    const { componentCls: componentCls, trackHeight: trackHeight, trackMinWidth: trackMinWidth } = token;
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            position: 'relative',
            display: 'inline-block',
            boxSizing: 'border-box',
            minWidth: trackMinWidth,
            height: trackHeight,
            lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(trackHeight),
            verticalAlign: 'middle',
            background: token.colorTextQuaternary,
            border: '0',
            borderRadius: 100,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid}`,
            userSelect: 'none',
            [`&:hover:not(${componentCls}-disabled)`]: {
                background: token.colorTextTertiary
            },
            ...(0, $945cb0d2b7017a11$export$a44db842bcb28231)(token),
            [`&${componentCls}-checked`]: {
                background: token.switchColor,
                [`&:hover:not(${componentCls}-disabled)`]: {
                    background: token.colorPrimaryHover
                }
            },
            [`&${componentCls}-loading, &${componentCls}-disabled`]: {
                cursor: 'not-allowed',
                opacity: token.switchDisabledOpacity,
                '*': {
                    boxShadow: 'none',
                    cursor: 'not-allowed'
                }
            },
            // rtl style
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            }
        }
    };
};
const $be0a847a02ec5dd1$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, controlHeight: controlHeight, colorWhite: colorWhite } = token;
    const height = fontSize * lineHeight;
    const heightSM = controlHeight / 2;
    const padding = 2; // Fixed value
    const handleSize = height - padding * 2;
    const handleSizeSM = heightSM - padding * 2;
    return {
        trackHeight: height,
        trackHeightSM: heightSM,
        trackMinWidth: handleSize * 2 + padding * 4,
        trackMinWidthSM: handleSizeSM * 2 + padding * 2,
        trackPadding: padding,
        // Fixed value
        handleBg: colorWhite,
        handleSize: handleSize,
        handleSizeSM: handleSizeSM,
        handleShadow: `0 2px 4px 0 ${new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)('#00230b').setA(0.2).toRgbString()}`,
        innerMinMargin: handleSize / 2,
        innerMaxMargin: handleSize + padding + padding * 2,
        innerMinMarginSM: handleSizeSM / 2,
        innerMaxMarginSM: handleSizeSM + padding + padding * 2
    };
};
var $be0a847a02ec5dd1$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Switch', (token)=>{
    const switchToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        switchDuration: token.motionDurationMid,
        switchColor: token.colorPrimary,
        switchDisabledOpacity: token.opacityLoading,
        switchLoadingIconSize: token.calc(token.fontSizeIcon).mul(0.75).equal(),
        switchLoadingIconColor: `rgba(0, 0, 0, ${token.opacityLoading})`,
        switchHandleActiveInset: '-30%'
    });
    return [
        $be0a847a02ec5dd1$var$genSwitchStyle(switchToken),
        // inner style
        $be0a847a02ec5dd1$var$genSwitchInnerStyle(switchToken),
        // handle style
        $be0a847a02ec5dd1$var$genSwitchHandleStyle(switchToken),
        // loading style
        $be0a847a02ec5dd1$var$genSwitchLoadingStyle(switchToken),
        // small style
        $be0a847a02ec5dd1$var$genSwitchSmallStyle(switchToken)
    ];
}, $be0a847a02ec5dd1$export$9ca1be8807fe0675);


"use client";
const $9abdade5fdd0845b$var$InternalSwitch = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, size: customizeSize, disabled: customDisabled, loading: loading, className: className, rootClassName: rootClassName, style: style, checked: checkedProp, value: value, defaultChecked: defaultCheckedProp, defaultValue: defaultValue, onChange: onChange, styles: styles, classNames: classNames, ...restProps } = props;
    const [checked, setChecked] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultCheckedProp ?? defaultValue ?? false, checkedProp ?? value);
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('switch');
    // ===================== Disabled =====================
    const disabled = $ltGt3.useContext((0, $6171cc8a6fbd07d0$export$2e2bcd8739ae039));
    const mergedDisabled = (customDisabled ?? disabled) || loading;
    const prefixCls = getPrefixCls('switch', customizePrefixCls);
    const loadingIcon = /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-handle`
    }, loading && /*#__PURE__*/ $ltGt3.createElement((0, $8ede40f9e9e4f5c2$export$2e2bcd8739ae039), {
        className: `${prefixCls}-loading-icon`
    }));
    // Style
    const [hashId, cssVarCls] = (0, $be0a847a02ec5dd1$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)(customizeSize);
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: mergedDisabled
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const classes = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(contextClassName, {
        [`${prefixCls}-small`]: mergedSize === 'small',
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, mergedClassNames.root, hashId, cssVarCls);
    const mergedStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    const changeHandler = (...args)=>{
        setChecked(args[0]);
        onChange?.(...args);
    };
    return /*#__PURE__*/ $ltGt3.createElement((0, $b5f0e609aabb59e2$export$2e2bcd8739ae039), {
        component: "Switch",
        disabled: mergedDisabled
    }, /*#__PURE__*/ $ltGt3.createElement((0, $fdcf5d1352ed4c5d$export$2e2bcd8739ae039), {
        ...restProps,
        classNames: mergedClassNames,
        styles: mergedStyles,
        checked: checked,
        onChange: changeHandler,
        prefixCls: prefixCls,
        className: classes,
        style: mergedStyle,
        disabled: mergedDisabled,
        ref: ref,
        loadingIcon: loadingIcon
    }));
});
const $9abdade5fdd0845b$var$Switch = $9abdade5fdd0845b$var$InternalSwitch;
$9abdade5fdd0845b$var$Switch.__ANT_SWITCH = true;
var $9abdade5fdd0845b$export$2e2bcd8739ae039 = $9abdade5fdd0845b$var$Switch;



var $ltGt3 = parcelRequire("ltGt3");



var $Ohofd = parcelRequire("Ohofd");

var $f2de6326bdf75f7a$exports = {};
!function(t, i) {
    $f2de6326bdf75f7a$exports = i();
}($f2de6326bdf75f7a$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});


var $5fac0199f9afa6dd$exports = {};
!function(e, t) {
    $5fac0199f9afa6dd$exports = t();
}($5fac0199f9afa6dd$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});







var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");



var $3373240be9e80763$exports = {};
$3373240be9e80763$exports = JSON.parse('{"categories":[{"id":"people","emojis":["grinning","smiley","smile","grin","laughing","sweat_smile","rolling_on_the_floor_laughing","joy","slightly_smiling_face","upside_down_face","melting_face","wink","blush","innocent","smiling_face_with_3_hearts","heart_eyes","star-struck","kissing_heart","kissing","relaxed","kissing_closed_eyes","kissing_smiling_eyes","smiling_face_with_tear","yum","stuck_out_tongue","stuck_out_tongue_winking_eye","zany_face","stuck_out_tongue_closed_eyes","money_mouth_face","hugging_face","face_with_hand_over_mouth","face_with_open_eyes_and_hand_over_mouth","face_with_peeking_eye","shushing_face","thinking_face","saluting_face","zipper_mouth_face","face_with_raised_eyebrow","neutral_face","expressionless","no_mouth","dotted_line_face","face_in_clouds","smirk","unamused","face_with_rolling_eyes","grimacing","face_exhaling","lying_face","shaking_face","relieved","pensive","sleepy","drooling_face","sleeping","mask","face_with_thermometer","face_with_head_bandage","nauseated_face","face_vomiting","sneezing_face","hot_face","cold_face","woozy_face","dizzy_face","face_with_spiral_eyes","exploding_head","face_with_cowboy_hat","partying_face","disguised_face","sunglasses","nerd_face","face_with_monocle","confused","face_with_diagonal_mouth","worried","slightly_frowning_face","white_frowning_face","open_mouth","hushed","astonished","flushed","pleading_face","face_holding_back_tears","frowning","anguished","fearful","cold_sweat","disappointed_relieved","cry","sob","scream","confounded","persevere","disappointed","sweat","weary","tired_face","yawning_face","triumph","rage","angry","face_with_symbols_on_mouth","smiling_imp","imp","skull","skull_and_crossbones","hankey","clown_face","japanese_ogre","japanese_goblin","ghost","alien","space_invader","wave","raised_back_of_hand","raised_hand_with_fingers_splayed","hand","spock-hand","rightwards_hand","leftwards_hand","palm_down_hand","palm_up_hand","leftwards_pushing_hand","rightwards_pushing_hand","ok_hand","pinched_fingers","pinching_hand","v","crossed_fingers","hand_with_index_finger_and_thumb_crossed","i_love_you_hand_sign","the_horns","call_me_hand","point_left","point_right","point_up_2","middle_finger","point_down","point_up","index_pointing_at_the_viewer","+1","-1","fist","facepunch","left-facing_fist","right-facing_fist","clap","raised_hands","heart_hands","open_hands","palms_up_together","handshake","pray","writing_hand","nail_care","selfie","muscle","mechanical_arm","mechanical_leg","leg","foot","ear","ear_with_hearing_aid","nose","brain","anatomical_heart","lungs","tooth","bone","eyes","eye","tongue","lips","biting_lip","baby","child","boy","girl","adult","person_with_blond_hair","man","bearded_person","man_with_beard","woman_with_beard","red_haired_man","curly_haired_man","white_haired_man","bald_man","woman","red_haired_woman","red_haired_person","curly_haired_woman","curly_haired_person","white_haired_woman","white_haired_person","bald_woman","bald_person","blond-haired-woman","blond-haired-man","older_adult","older_man","older_woman","person_frowning","man-frowning","woman-frowning","person_with_pouting_face","man-pouting","woman-pouting","no_good","man-gesturing-no","woman-gesturing-no","ok_woman","man-gesturing-ok","woman-gesturing-ok","information_desk_person","man-tipping-hand","woman-tipping-hand","raising_hand","man-raising-hand","woman-raising-hand","deaf_person","deaf_man","deaf_woman","bow","man-bowing","woman-bowing","face_palm","man-facepalming","woman-facepalming","shrug","man-shrugging","woman-shrugging","health_worker","male-doctor","female-doctor","student","male-student","female-student","teacher","male-teacher","female-teacher","judge","male-judge","female-judge","farmer","male-farmer","female-farmer","cook","male-cook","female-cook","mechanic","male-mechanic","female-mechanic","factory_worker","male-factory-worker","female-factory-worker","office_worker","male-office-worker","female-office-worker","scientist","male-scientist","female-scientist","technologist","male-technologist","female-technologist","singer","male-singer","female-singer","artist","male-artist","female-artist","pilot","male-pilot","female-pilot","astronaut","male-astronaut","female-astronaut","firefighter","male-firefighter","female-firefighter","cop","male-police-officer","female-police-officer","sleuth_or_spy","male-detective","female-detective","guardsman","male-guard","female-guard","ninja","construction_worker","male-construction-worker","female-construction-worker","person_with_crown","prince","princess","man_with_turban","man-wearing-turban","woman-wearing-turban","man_with_gua_pi_mao","person_with_headscarf","person_in_tuxedo","man_in_tuxedo","woman_in_tuxedo","bride_with_veil","man_with_veil","woman_with_veil","pregnant_woman","pregnant_man","pregnant_person","breast-feeding","woman_feeding_baby","man_feeding_baby","person_feeding_baby","angel","santa","mrs_claus","mx_claus","superhero","male_superhero","female_superhero","supervillain","male_supervillain","female_supervillain","mage","male_mage","female_mage","fairy","male_fairy","female_fairy","vampire","male_vampire","female_vampire","merperson","merman","mermaid","elf","male_elf","female_elf","genie","male_genie","female_genie","zombie","male_zombie","female_zombie","troll","massage","man-getting-massage","woman-getting-massage","haircut","man-getting-haircut","woman-getting-haircut","walking","man-walking","woman-walking","standing_person","man_standing","woman_standing","kneeling_person","man_kneeling","woman_kneeling","person_with_probing_cane","man_with_probing_cane","woman_with_probing_cane","person_in_motorized_wheelchair","man_in_motorized_wheelchair","woman_in_motorized_wheelchair","person_in_manual_wheelchair","man_in_manual_wheelchair","woman_in_manual_wheelchair","runner","man-running","woman-running","dancer","man_dancing","man_in_business_suit_levitating","dancers","men-with-bunny-ears-partying","women-with-bunny-ears-partying","person_in_steamy_room","man_in_steamy_room","woman_in_steamy_room","person_climbing","man_climbing","woman_climbing","fencer","horse_racing","skier","snowboarder","golfer","man-golfing","woman-golfing","surfer","man-surfing","woman-surfing","rowboat","man-rowing-boat","woman-rowing-boat","swimmer","man-swimming","woman-swimming","person_with_ball","man-bouncing-ball","woman-bouncing-ball","weight_lifter","man-lifting-weights","woman-lifting-weights","bicyclist","man-biking","woman-biking","mountain_bicyclist","man-mountain-biking","woman-mountain-biking","person_doing_cartwheel","man-cartwheeling","woman-cartwheeling","wrestlers","man-wrestling","woman-wrestling","water_polo","man-playing-water-polo","woman-playing-water-polo","handball","man-playing-handball","woman-playing-handball","juggling","man-juggling","woman-juggling","person_in_lotus_position","man_in_lotus_position","woman_in_lotus_position","bath","sleeping_accommodation","people_holding_hands","two_women_holding_hands","man_and_woman_holding_hands","two_men_holding_hands","couplekiss","woman-kiss-man","man-kiss-man","woman-kiss-woman","couple_with_heart","woman-heart-man","man-heart-man","woman-heart-woman","family","man-woman-boy","man-woman-girl","man-woman-girl-boy","man-woman-boy-boy","man-woman-girl-girl","man-man-boy","man-man-girl","man-man-girl-boy","man-man-boy-boy","man-man-girl-girl","woman-woman-boy","woman-woman-girl","woman-woman-girl-boy","woman-woman-boy-boy","woman-woman-girl-girl","man-boy","man-boy-boy","man-girl","man-girl-boy","man-girl-girl","woman-boy","woman-boy-boy","woman-girl","woman-girl-boy","woman-girl-girl","speaking_head_in_silhouette","bust_in_silhouette","busts_in_silhouette","people_hugging","footprints","robot_face","smiley_cat","smile_cat","joy_cat","heart_eyes_cat","smirk_cat","kissing_cat","scream_cat","crying_cat_face","pouting_cat","see_no_evil","hear_no_evil","speak_no_evil","love_letter","cupid","gift_heart","sparkling_heart","heartpulse","heartbeat","revolving_hearts","two_hearts","heart_decoration","heavy_heart_exclamation_mark_ornament","broken_heart","heart_on_fire","mending_heart","heart","pink_heart","orange_heart","yellow_heart","green_heart","blue_heart","light_blue_heart","purple_heart","brown_heart","black_heart","grey_heart","white_heart","kiss","100","anger","boom","dizzy","sweat_drops","dash","hole","speech_balloon","eye-in-speech-bubble","left_speech_bubble","right_anger_bubble","thought_balloon","zzz"]},{"id":"nature","emojis":["monkey_face","monkey","gorilla","orangutan","dog","dog2","guide_dog","service_dog","poodle","wolf","fox_face","raccoon","cat","cat2","black_cat","lion_face","tiger","tiger2","leopard","horse","moose","donkey","racehorse","unicorn_face","zebra_face","deer","bison","cow","ox","water_buffalo","cow2","pig","pig2","boar","pig_nose","ram","sheep","goat","dromedary_camel","camel","llama","giraffe_face","elephant","mammoth","rhinoceros","hippopotamus","mouse","mouse2","rat","hamster","rabbit","rabbit2","chipmunk","beaver","hedgehog","bat","bear","polar_bear","koala","panda_face","sloth","otter","skunk","kangaroo","badger","feet","turkey","chicken","rooster","hatching_chick","baby_chick","hatched_chick","bird","penguin","dove_of_peace","eagle","duck","swan","owl","dodo","feather","flamingo","peacock","parrot","wing","black_bird","goose","frog","crocodile","turtle","lizard","snake","dragon_face","dragon","sauropod","t-rex","whale","whale2","dolphin","seal","fish","tropical_fish","blowfish","shark","octopus","shell","coral","jellyfish","snail","butterfly","bug","ant","bee","beetle","ladybug","cricket","cockroach","spider","spider_web","scorpion","mosquito","fly","worm","microbe","bouquet","cherry_blossom","white_flower","lotus","rosette","rose","wilted_flower","hibiscus","sunflower","blossom","tulip","hyacinth","seedling","potted_plant","evergreen_tree","deciduous_tree","palm_tree","cactus","ear_of_rice","herb","shamrock","four_leaf_clover","maple_leaf","fallen_leaf","leaves","empty_nest","nest_with_eggs","mushroom"]},{"id":"foods","emojis":["grapes","melon","watermelon","tangerine","lemon","banana","pineapple","mango","apple","green_apple","pear","peach","cherries","strawberry","blueberries","kiwifruit","tomato","olive","coconut","avocado","eggplant","potato","carrot","corn","hot_pepper","bell_pepper","cucumber","leafy_green","broccoli","garlic","onion","peanuts","beans","chestnut","ginger_root","pea_pod","bread","croissant","baguette_bread","flatbread","pretzel","bagel","pancakes","waffle","cheese_wedge","meat_on_bone","poultry_leg","cut_of_meat","bacon","hamburger","fries","pizza","hotdog","sandwich","taco","burrito","tamale","stuffed_flatbread","falafel","egg","fried_egg","shallow_pan_of_food","stew","fondue","bowl_with_spoon","green_salad","popcorn","butter","salt","canned_food","bento","rice_cracker","rice_ball","rice","curry","ramen","spaghetti","sweet_potato","oden","sushi","fried_shrimp","fish_cake","moon_cake","dango","dumpling","fortune_cookie","takeout_box","crab","lobster","shrimp","squid","oyster","icecream","shaved_ice","ice_cream","doughnut","cookie","birthday","cake","cupcake","pie","chocolate_bar","candy","lollipop","custard","honey_pot","baby_bottle","glass_of_milk","coffee","teapot","tea","sake","champagne","wine_glass","cocktail","tropical_drink","beer","beers","clinking_glasses","tumbler_glass","pouring_liquid","cup_with_straw","bubble_tea","beverage_box","mate_drink","ice_cube","chopsticks","knife_fork_plate","fork_and_knife","spoon","hocho","jar","amphora"]},{"id":"activity","emojis":["jack_o_lantern","christmas_tree","fireworks","sparkler","firecracker","sparkles","balloon","tada","confetti_ball","tanabata_tree","bamboo","dolls","flags","wind_chime","rice_scene","red_envelope","ribbon","gift","reminder_ribbon","admission_tickets","ticket","medal","trophy","sports_medal","first_place_medal","second_place_medal","third_place_medal","soccer","baseball","softball","basketball","volleyball","football","rugby_football","tennis","flying_disc","bowling","cricket_bat_and_ball","field_hockey_stick_and_ball","ice_hockey_stick_and_puck","lacrosse","table_tennis_paddle_and_ball","badminton_racquet_and_shuttlecock","boxing_glove","martial_arts_uniform","goal_net","golf","ice_skate","fishing_pole_and_fish","diving_mask","running_shirt_with_sash","ski","sled","curling_stone","dart","yo-yo","kite","gun","8ball","crystal_ball","magic_wand","video_game","joystick","slot_machine","game_die","jigsaw","teddy_bear","pinata","mirror_ball","nesting_dolls","spades","hearts","diamonds","clubs","chess_pawn","black_joker","mahjong","flower_playing_cards","performing_arts","frame_with_picture","art","thread","sewing_needle","yarn","knot"]},{"id":"places","emojis":["earth_africa","earth_americas","earth_asia","globe_with_meridians","world_map","japan","compass","snow_capped_mountain","mountain","volcano","mount_fuji","camping","beach_with_umbrella","desert","desert_island","national_park","stadium","classical_building","building_construction","bricks","rock","wood","hut","house_buildings","derelict_house_building","house","house_with_garden","office","post_office","european_post_office","hospital","bank","hotel","love_hotel","convenience_store","school","department_store","factory","japanese_castle","european_castle","wedding","tokyo_tower","statue_of_liberty","church","mosque","hindu_temple","synagogue","shinto_shrine","kaaba","fountain","tent","foggy","night_with_stars","cityscape","sunrise_over_mountains","sunrise","city_sunset","city_sunrise","bridge_at_night","hotsprings","carousel_horse","playground_slide","ferris_wheel","roller_coaster","barber","circus_tent","steam_locomotive","railway_car","bullettrain_side","bullettrain_front","train2","metro","light_rail","station","tram","monorail","mountain_railway","train","bus","oncoming_bus","trolleybus","minibus","ambulance","fire_engine","police_car","oncoming_police_car","taxi","oncoming_taxi","car","oncoming_automobile","blue_car","pickup_truck","truck","articulated_lorry","tractor","racing_car","racing_motorcycle","motor_scooter","manual_wheelchair","motorized_wheelchair","auto_rickshaw","bike","scooter","skateboard","roller_skate","busstop","motorway","railway_track","oil_drum","fuelpump","wheel","rotating_light","traffic_light","vertical_traffic_light","octagonal_sign","construction","anchor","ring_buoy","boat","canoe","speedboat","passenger_ship","ferry","motor_boat","ship","airplane","small_airplane","airplane_departure","airplane_arriving","parachute","seat","helicopter","suspension_railway","mountain_cableway","aerial_tramway","satellite","rocket","flying_saucer","bellhop_bell","luggage","hourglass","hourglass_flowing_sand","watch","alarm_clock","stopwatch","timer_clock","mantelpiece_clock","clock12","clock1230","clock1","clock130","clock2","clock230","clock3","clock330","clock4","clock430","clock5","clock530","clock6","clock630","clock7","clock730","clock8","clock830","clock9","clock930","clock10","clock1030","clock11","clock1130","new_moon","waxing_crescent_moon","first_quarter_moon","moon","full_moon","waning_gibbous_moon","last_quarter_moon","waning_crescent_moon","crescent_moon","new_moon_with_face","first_quarter_moon_with_face","last_quarter_moon_with_face","thermometer","sunny","full_moon_with_face","sun_with_face","ringed_planet","star","star2","stars","milky_way","cloud","partly_sunny","thunder_cloud_and_rain","mostly_sunny","barely_sunny","partly_sunny_rain","rain_cloud","snow_cloud","lightning","tornado","fog","wind_blowing_face","cyclone","rainbow","closed_umbrella","umbrella","umbrella_with_rain_drops","umbrella_on_ground","zap","snowflake","snowman","snowman_without_snow","comet","fire","droplet","ocean"]},{"id":"objects","emojis":["eyeglasses","dark_sunglasses","goggles","lab_coat","safety_vest","necktie","shirt","jeans","scarf","gloves","coat","socks","dress","kimono","sari","one-piece_swimsuit","briefs","shorts","bikini","womans_clothes","folding_hand_fan","purse","handbag","pouch","shopping_bags","school_satchel","thong_sandal","mans_shoe","athletic_shoe","hiking_boot","womans_flat_shoe","high_heel","sandal","ballet_shoes","boot","hair_pick","crown","womans_hat","tophat","mortar_board","billed_cap","military_helmet","helmet_with_white_cross","prayer_beads","lipstick","ring","gem","mute","speaker","sound","loud_sound","loudspeaker","mega","postal_horn","bell","no_bell","musical_score","musical_note","notes","studio_microphone","level_slider","control_knobs","microphone","headphones","radio","saxophone","accordion","guitar","musical_keyboard","trumpet","violin","banjo","drum_with_drumsticks","long_drum","maracas","flute","iphone","calling","phone","telephone_receiver","pager","fax","battery","low_battery","electric_plug","computer","desktop_computer","printer","keyboard","three_button_mouse","trackball","minidisc","floppy_disk","cd","dvd","abacus","movie_camera","film_frames","film_projector","clapper","tv","camera","camera_with_flash","video_camera","vhs","mag","mag_right","candle","bulb","flashlight","izakaya_lantern","diya_lamp","notebook_with_decorative_cover","closed_book","book","green_book","blue_book","orange_book","books","notebook","ledger","page_with_curl","scroll","page_facing_up","newspaper","rolled_up_newspaper","bookmark_tabs","bookmark","label","moneybag","coin","yen","dollar","euro","pound","money_with_wings","credit_card","receipt","chart","email","e-mail","incoming_envelope","envelope_with_arrow","outbox_tray","inbox_tray","package","mailbox","mailbox_closed","mailbox_with_mail","mailbox_with_no_mail","postbox","ballot_box_with_ballot","pencil2","black_nib","lower_left_fountain_pen","lower_left_ballpoint_pen","lower_left_paintbrush","lower_left_crayon","memo","briefcase","file_folder","open_file_folder","card_index_dividers","date","calendar","spiral_note_pad","spiral_calendar_pad","card_index","chart_with_upwards_trend","chart_with_downwards_trend","bar_chart","clipboard","pushpin","round_pushpin","paperclip","linked_paperclips","straight_ruler","triangular_ruler","scissors","card_file_box","file_cabinet","wastebasket","lock","unlock","lock_with_ink_pen","closed_lock_with_key","key","old_key","hammer","axe","pick","hammer_and_pick","hammer_and_wrench","dagger_knife","crossed_swords","bomb","boomerang","bow_and_arrow","shield","carpentry_saw","wrench","screwdriver","nut_and_bolt","gear","compression","scales","probing_cane","link","chains","hook","toolbox","magnet","ladder","alembic","test_tube","petri_dish","dna","microscope","telescope","satellite_antenna","syringe","drop_of_blood","pill","adhesive_bandage","crutch","stethoscope","x-ray","door","elevator","mirror","window","bed","couch_and_lamp","chair","toilet","plunger","shower","bathtub","mouse_trap","razor","lotion_bottle","safety_pin","broom","basket","roll_of_paper","bucket","soap","bubbles","toothbrush","sponge","fire_extinguisher","shopping_trolley","smoking","coffin","headstone","funeral_urn","nazar_amulet","hamsa","moyai","placard","identification_card"]},{"id":"symbols","emojis":["atm","put_litter_in_its_place","potable_water","wheelchair","mens","womens","restroom","baby_symbol","wc","passport_control","customs","baggage_claim","left_luggage","warning","children_crossing","no_entry","no_entry_sign","no_bicycles","no_smoking","do_not_litter","non-potable_water","no_pedestrians","no_mobile_phones","underage","radioactive_sign","biohazard_sign","arrow_up","arrow_upper_right","arrow_right","arrow_lower_right","arrow_down","arrow_lower_left","arrow_left","arrow_upper_left","arrow_up_down","left_right_arrow","leftwards_arrow_with_hook","arrow_right_hook","arrow_heading_up","arrow_heading_down","arrows_clockwise","arrows_counterclockwise","back","end","on","soon","top","place_of_worship","atom_symbol","om_symbol","star_of_david","wheel_of_dharma","yin_yang","latin_cross","orthodox_cross","star_and_crescent","peace_symbol","menorah_with_nine_branches","six_pointed_star","khanda","aries","taurus","gemini","cancer","leo","virgo","libra","scorpius","sagittarius","capricorn","aquarius","pisces","ophiuchus","twisted_rightwards_arrows","repeat","repeat_one","arrow_forward","fast_forward","black_right_pointing_double_triangle_with_vertical_bar","black_right_pointing_triangle_with_double_vertical_bar","arrow_backward","rewind","black_left_pointing_double_triangle_with_vertical_bar","arrow_up_small","arrow_double_up","arrow_down_small","arrow_double_down","double_vertical_bar","black_square_for_stop","black_circle_for_record","eject","cinema","low_brightness","high_brightness","signal_strength","wireless","vibration_mode","mobile_phone_off","female_sign","male_sign","transgender_symbol","heavy_multiplication_x","heavy_plus_sign","heavy_minus_sign","heavy_division_sign","heavy_equals_sign","infinity","bangbang","interrobang","question","grey_question","grey_exclamation","exclamation","wavy_dash","currency_exchange","heavy_dollar_sign","medical_symbol","recycle","fleur_de_lis","trident","name_badge","beginner","o","white_check_mark","ballot_box_with_check","heavy_check_mark","x","negative_squared_cross_mark","curly_loop","loop","part_alternation_mark","eight_spoked_asterisk","eight_pointed_black_star","sparkle","copyright","registered","tm","hash","keycap_star","zero","one","two","three","four","five","six","seven","eight","nine","keycap_ten","capital_abcd","abcd","1234","symbols","abc","a","ab","b","cl","cool","free","information_source","id","m","new","ng","o2","ok","parking","sos","up","vs","koko","sa","u6708","u6709","u6307","ideograph_advantage","u5272","u7121","u7981","accept","u7533","u5408","u7a7a","congratulations","secret","u55b6","u6e80","red_circle","large_orange_circle","large_yellow_circle","large_green_circle","large_blue_circle","large_purple_circle","large_brown_circle","black_circle","white_circle","large_red_square","large_orange_square","large_yellow_square","large_green_square","large_blue_square","large_purple_square","large_brown_square","black_large_square","white_large_square","black_medium_square","white_medium_square","black_medium_small_square","white_medium_small_square","black_small_square","white_small_square","large_orange_diamond","large_blue_diamond","small_orange_diamond","small_blue_diamond","small_red_triangle","small_red_triangle_down","diamond_shape_with_a_dot_inside","radio_button","white_square_button","black_square_button"]},{"id":"flags","emojis":["checkered_flag","cn","crossed_flags","de","es","flag-ac","flag-ad","flag-ae","flag-af","flag-ag","flag-ai","flag-al","flag-am","flag-ao","flag-aq","flag-ar","flag-as","flag-at","flag-au","flag-aw","flag-ax","flag-az","flag-ba","flag-bb","flag-bd","flag-be","flag-bf","flag-bg","flag-bh","flag-bi","flag-bj","flag-bl","flag-bm","flag-bn","flag-bo","flag-bq","flag-br","flag-bs","flag-bt","flag-bv","flag-bw","flag-by","flag-bz","flag-ca","flag-cc","flag-cd","flag-cf","flag-cg","flag-ch","flag-ci","flag-ck","flag-cl","flag-cm","flag-co","flag-cp","flag-cr","flag-cu","flag-cv","flag-cw","flag-cx","flag-cy","flag-cz","flag-dg","flag-dj","flag-dk","flag-dm","flag-do","flag-dz","flag-ea","flag-ec","flag-ee","flag-eg","flag-eh","flag-england","flag-er","flag-et","flag-eu","flag-fi","flag-fj","flag-fk","flag-fm","flag-fo","flag-ga","flag-gd","flag-ge","flag-gf","flag-gg","flag-gh","flag-gi","flag-gl","flag-gm","flag-gn","flag-gp","flag-gq","flag-gr","flag-gs","flag-gt","flag-gu","flag-gw","flag-gy","flag-hk","flag-hm","flag-hn","flag-hr","flag-ht","flag-hu","flag-ic","flag-id","flag-ie","flag-il","flag-im","flag-in","flag-io","flag-iq","flag-ir","flag-is","flag-je","flag-jm","flag-jo","flag-ke","flag-kg","flag-kh","flag-ki","flag-km","flag-kn","flag-kp","flag-kw","flag-ky","flag-kz","flag-la","flag-lb","flag-lc","flag-li","flag-lk","flag-lr","flag-ls","flag-lt","flag-lu","flag-lv","flag-ly","flag-ma","flag-mc","flag-md","flag-me","flag-mf","flag-mg","flag-mh","flag-mk","flag-ml","flag-mm","flag-mn","flag-mo","flag-mp","flag-mq","flag-mr","flag-ms","flag-mt","flag-mu","flag-mv","flag-mw","flag-mx","flag-my","flag-mz","flag-na","flag-nc","flag-ne","flag-nf","flag-ng","flag-ni","flag-nl","flag-no","flag-np","flag-nr","flag-nu","flag-nz","flag-om","flag-pa","flag-pe","flag-pf","flag-pg","flag-ph","flag-pk","flag-pl","flag-pm","flag-pn","flag-pr","flag-ps","flag-pt","flag-pw","flag-py","flag-qa","flag-re","flag-ro","flag-rs","flag-rw","flag-sa","flag-sb","flag-sc","flag-scotland","flag-sd","flag-se","flag-sg","flag-sh","flag-si","flag-sj","flag-sk","flag-sl","flag-sm","flag-sn","flag-so","flag-sr","flag-ss","flag-st","flag-sv","flag-sx","flag-sy","flag-sz","flag-ta","flag-tc","flag-td","flag-tf","flag-tg","flag-th","flag-tj","flag-tk","flag-tl","flag-tm","flag-tn","flag-to","flag-tr","flag-tt","flag-tv","flag-tw","flag-tz","flag-ua","flag-ug","flag-um","flag-un","flag-uy","flag-uz","flag-va","flag-vc","flag-ve","flag-vg","flag-vi","flag-vn","flag-vu","flag-wales","flag-wf","flag-ws","flag-xk","flag-ye","flag-yt","flag-za","flag-zm","flag-zw","fr","gb","it","jp","kr","pirate_flag","rainbow-flag","ru","transgender_flag","triangular_flag_on_post","us","waving_black_flag","waving_white_flag"]}],"emojis":{"100":{"id":"100","name":"Hundred Points","keywords":["100","score","perfect","numbers","century","exam","quiz","test","pass"],"skins":[{"unified":"1f4af","native":"\uD83D\uDCAF"}],"version":1},"1234":{"id":"1234","name":"Input Numbers","keywords":["1234","blue","square","1","2","3","4"],"skins":[{"unified":"1f522","native":"\uD83D\uDD22"}],"version":1},"grinning":{"id":"grinning","name":"Grinning Face","emoticons":[":D"],"keywords":["smile","happy","joy",":D","grin"],"skins":[{"unified":"1f600","native":"\uD83D\uDE00"}],"version":1},"smiley":{"id":"smiley","name":"Grinning Face with Big Eyes","emoticons":[":)","=)","=-)"],"keywords":["smiley","happy","joy","haha",":D",":)","smile","funny"],"skins":[{"unified":"1f603","native":"\uD83D\uDE03"}],"version":1},"smile":{"id":"smile","name":"Grinning Face with Smiling Eyes","emoticons":[":)","C:","c:",":D",":-D"],"keywords":["smile","happy","joy","funny","haha","laugh","like",":D",":)"],"skins":[{"unified":"1f604","native":"\uD83D\uDE04"}],"version":1},"grin":{"id":"grin","name":"Beaming Face with Smiling Eyes","keywords":["grin","happy","smile","joy","kawaii"],"skins":[{"unified":"1f601","native":"\uD83D\uDE01"}],"version":1},"laughing":{"id":"laughing","name":"Grinning Squinting Face","emoticons":[":>",":->"],"keywords":["laughing","satisfied","happy","joy","lol","haha","glad","XD","laugh"],"skins":[{"unified":"1f606","native":"\uD83D\uDE06"}],"version":1},"sweat_smile":{"id":"sweat_smile","name":"Grinning Face with Sweat","keywords":["smile","hot","happy","laugh","relief"],"skins":[{"unified":"1f605","native":"\uD83D\uDE05"}],"version":1},"rolling_on_the_floor_laughing":{"id":"rolling_on_the_floor_laughing","name":"Rolling on the Floor Laughing","keywords":["face","lol","haha","rofl"],"skins":[{"unified":"1f923","native":"\uD83E\uDD23"}],"version":3},"joy":{"id":"joy","name":"Face with Tears of Joy","keywords":["cry","weep","happy","happytears","haha"],"skins":[{"unified":"1f602","native":"\uD83D\uDE02"}],"version":1},"slightly_smiling_face":{"id":"slightly_smiling_face","name":"Slightly Smiling Face","emoticons":[":)","(:",":-)"],"keywords":["smile"],"skins":[{"unified":"1f642","native":"\uD83D\uDE42"}],"version":1},"upside_down_face":{"id":"upside_down_face","name":"Upside-Down Face","keywords":["upside","down","flipped","silly","smile"],"skins":[{"unified":"1f643","native":"\uD83D\uDE43"}],"version":1},"melting_face":{"id":"melting_face","name":"Melting Face","keywords":["hot","heat"],"skins":[{"unified":"1fae0","native":"\uD83E\uDEE0"}],"version":14},"wink":{"id":"wink","name":"Winking Face","emoticons":[";)",";-)"],"keywords":["wink","happy","mischievous","secret",";)","smile","eye"],"skins":[{"unified":"1f609","native":"\uD83D\uDE09"}],"version":1},"blush":{"id":"blush","name":"Smiling Face with Smiling Eyes","emoticons":[":)"],"keywords":["blush","smile","happy","flushed","crush","embarrassed","shy","joy"],"skins":[{"unified":"1f60a","native":"\uD83D\uDE0A"}],"version":1},"innocent":{"id":"innocent","name":"Smiling Face with Halo","keywords":["innocent","angel","heaven"],"skins":[{"unified":"1f607","native":"\uD83D\uDE07"}],"version":1},"smiling_face_with_3_hearts":{"id":"smiling_face_with_3_hearts","name":"Smiling Face with Hearts","keywords":["3","love","like","affection","valentines","infatuation","crush","adore"],"skins":[{"unified":"1f970","native":"\uD83E\uDD70"}],"version":11},"heart_eyes":{"id":"heart_eyes","name":"Smiling Face with Heart-Eyes","keywords":["heart","eyes","love","like","affection","valentines","infatuation","crush"],"skins":[{"unified":"1f60d","native":"\uD83D\uDE0D"}],"version":1},"star-struck":{"id":"star-struck","name":"Star-Struck","keywords":["star","struck","grinning","face","with","eyes","smile","starry"],"skins":[{"unified":"1f929","native":"\uD83E\uDD29"}],"version":5},"kissing_heart":{"id":"kissing_heart","name":"Face Blowing a Kiss","emoticons":[":*",":-*"],"keywords":["kissing","heart","love","like","affection","valentines","infatuation"],"skins":[{"unified":"1f618","native":"\uD83D\uDE18"}],"version":1},"kissing":{"id":"kissing","name":"Kissing Face","keywords":["love","like","3","valentines","infatuation","kiss"],"skins":[{"unified":"1f617","native":"\uD83D\uDE17"}],"version":1},"relaxed":{"id":"relaxed","name":"Smiling Face","keywords":["relaxed","blush","massage","happiness"],"skins":[{"unified":"263a-fe0f","native":"\u263A\uFE0F"}],"version":1},"kissing_closed_eyes":{"id":"kissing_closed_eyes","name":"Kissing Face with Closed Eyes","keywords":["love","like","affection","valentines","infatuation","kiss"],"skins":[{"unified":"1f61a","native":"\uD83D\uDE1A"}],"version":1},"kissing_smiling_eyes":{"id":"kissing_smiling_eyes","name":"Kissing Face with Smiling Eyes","keywords":["affection","valentines","infatuation","kiss"],"skins":[{"unified":"1f619","native":"\uD83D\uDE19"}],"version":1},"smiling_face_with_tear":{"id":"smiling_face_with_tear","name":"Smiling Face with Tear","keywords":["sad","cry","pretend"],"skins":[{"unified":"1f972","native":"\uD83E\uDD72"}],"version":13},"yum":{"id":"yum","name":"Face Savoring Food","keywords":["yum","happy","joy","tongue","smile","silly","yummy","nom","delicious","savouring"],"skins":[{"unified":"1f60b","native":"\uD83D\uDE0B"}],"version":1},"stuck_out_tongue":{"id":"stuck_out_tongue","name":"Face with Tongue","emoticons":[":p",":-p",":P",":-P",":b",":-b"],"keywords":["stuck","out","prank","childish","playful","mischievous","smile"],"skins":[{"unified":"1f61b","native":"\uD83D\uDE1B"}],"version":1},"stuck_out_tongue_winking_eye":{"id":"stuck_out_tongue_winking_eye","name":"Winking Face with Tongue","emoticons":[";p",";-p",";b",";-b",";P",";-P"],"keywords":["stuck","out","eye","prank","childish","playful","mischievous","smile","wink"],"skins":[{"unified":"1f61c","native":"\uD83D\uDE1C"}],"version":1},"zany_face":{"id":"zany_face","name":"Zany Face","keywords":["grinning","with","one","large","and","small","eye","goofy","crazy"],"skins":[{"unified":"1f92a","native":"\uD83E\uDD2A"}],"version":5},"stuck_out_tongue_closed_eyes":{"id":"stuck_out_tongue_closed_eyes","name":"Squinting Face with Tongue","keywords":["stuck","out","closed","eyes","prank","playful","mischievous","smile"],"skins":[{"unified":"1f61d","native":"\uD83D\uDE1D"}],"version":1},"money_mouth_face":{"id":"money_mouth_face","name":"Money-Mouth Face","keywords":["money","mouth","rich","dollar"],"skins":[{"unified":"1f911","native":"\uD83E\uDD11"}],"version":1},"hugging_face":{"id":"hugging_face","name":"Hugging Face","keywords":["smile","hug"],"skins":[{"unified":"1f917","native":"\uD83E\uDD17"}],"version":1},"face_with_hand_over_mouth":{"id":"face_with_hand_over_mouth","name":"Face with Hand over Mouth","keywords":["smiling","eyes","and","covering","whoops","shock","surprise"],"skins":[{"unified":"1f92d","native":"\uD83E\uDD2D"}],"version":5},"face_with_open_eyes_and_hand_over_mouth":{"id":"face_with_open_eyes_and_hand_over_mouth","name":"Face with Open Eyes and Hand over Mouth","keywords":["silence","secret","shock","surprise"],"skins":[{"unified":"1fae2","native":"\uD83E\uDEE2"}],"version":14},"face_with_peeking_eye":{"id":"face_with_peeking_eye","name":"Face with Peeking Eye","keywords":["scared","frightening","embarrassing","shy"],"skins":[{"unified":"1fae3","native":"\uD83E\uDEE3"}],"version":14},"shushing_face":{"id":"shushing_face","name":"Shushing Face","keywords":["with","finger","covering","closed","lips","quiet","shhh"],"skins":[{"unified":"1f92b","native":"\uD83E\uDD2B"}],"version":5},"thinking_face":{"id":"thinking_face","name":"Thinking Face","keywords":["hmmm","think","consider"],"skins":[{"unified":"1f914","native":"\uD83E\uDD14"}],"version":1},"saluting_face":{"id":"saluting_face","name":"Saluting Face","keywords":["respect","salute"],"skins":[{"unified":"1fae1","native":"\uD83E\uDEE1"}],"version":14},"zipper_mouth_face":{"id":"zipper_mouth_face","name":"Zipper-Mouth Face","keywords":["zipper","mouth","sealed","secret"],"skins":[{"unified":"1f910","native":"\uD83E\uDD10"}],"version":1},"face_with_raised_eyebrow":{"id":"face_with_raised_eyebrow","name":"Face with Raised Eyebrow","keywords":["one","distrust","scepticism","disapproval","disbelief","surprise"],"skins":[{"unified":"1f928","native":"\uD83E\uDD28"}],"version":5},"neutral_face":{"id":"neutral_face","name":"Neutral Face","emoticons":[":|",":-|"],"keywords":["indifference","meh",":",""],"skins":[{"unified":"1f610","native":"\uD83D\uDE10"}],"version":1},"expressionless":{"id":"expressionless","name":"Expressionless Face","emoticons":["-_-"],"keywords":["indifferent","-","","meh","deadpan"],"skins":[{"unified":"1f611","native":"\uD83D\uDE11"}],"version":1},"no_mouth":{"id":"no_mouth","name":"Face Without Mouth","keywords":["no","hellokitty"],"skins":[{"unified":"1f636","native":"\uD83D\uDE36"}],"version":1},"dotted_line_face":{"id":"dotted_line_face","name":"Dotted Line Face","keywords":["invisible","lonely","isolation","depression"],"skins":[{"unified":"1fae5","native":"\uD83E\uDEE5"}],"version":14},"face_in_clouds":{"id":"face_in_clouds","name":"Face in Clouds","keywords":["shower","steam","dream"],"skins":[{"unified":"1f636-200d-1f32b-fe0f","native":"\uD83D\uDE36\u200D\uD83C\uDF2B\uFE0F"}],"version":13.1},"smirk":{"id":"smirk","name":"Smirking Face","keywords":["smirk","smile","mean","prank","smug","sarcasm"],"skins":[{"unified":"1f60f","native":"\uD83D\uDE0F"}],"version":1},"unamused":{"id":"unamused","name":"Unamused Face","emoticons":[":("],"keywords":["indifference","bored","straight","serious","sarcasm","unimpressed","skeptical","dubious","side","eye"],"skins":[{"unified":"1f612","native":"\uD83D\uDE12"}],"version":1},"face_with_rolling_eyes":{"id":"face_with_rolling_eyes","name":"Face with Rolling Eyes","keywords":["eyeroll","frustrated"],"skins":[{"unified":"1f644","native":"\uD83D\uDE44"}],"version":1},"grimacing":{"id":"grimacing","name":"Grimacing Face","keywords":["grimace","teeth"],"skins":[{"unified":"1f62c","native":"\uD83D\uDE2C"}],"version":1},"face_exhaling":{"id":"face_exhaling","name":"Face Exhaling","keywords":["relieve","relief","tired","sigh"],"skins":[{"unified":"1f62e-200d-1f4a8","native":"\uD83D\uDE2E\u200D\uD83D\uDCA8"}],"version":13.1},"lying_face":{"id":"lying_face","name":"Lying Face","keywords":["lie","pinocchio"],"skins":[{"unified":"1f925","native":"\uD83E\uDD25"}],"version":3},"shaking_face":{"id":"shaking_face","name":"Shaking Face","keywords":["dizzy","shock","blurry","earthquake"],"skins":[{"unified":"1fae8","native":"\uD83E\uDEE8"}],"version":15},"relieved":{"id":"relieved","name":"Relieved Face","keywords":["relaxed","phew","massage","happiness"],"skins":[{"unified":"1f60c","native":"\uD83D\uDE0C"}],"version":1},"pensive":{"id":"pensive","name":"Pensive Face","keywords":["sad","depressed","upset"],"skins":[{"unified":"1f614","native":"\uD83D\uDE14"}],"version":1},"sleepy":{"id":"sleepy","name":"Sleepy Face","keywords":["tired","rest","nap"],"skins":[{"unified":"1f62a","native":"\uD83D\uDE2A"}],"version":1},"drooling_face":{"id":"drooling_face","name":"Drooling Face","keywords":[],"skins":[{"unified":"1f924","native":"\uD83E\uDD24"}],"version":3},"sleeping":{"id":"sleeping","name":"Sleeping Face","keywords":["tired","sleepy","night","zzz"],"skins":[{"unified":"1f634","native":"\uD83D\uDE34"}],"version":1},"mask":{"id":"mask","name":"Face with Medical Mask","keywords":["sick","ill","disease","covid"],"skins":[{"unified":"1f637","native":"\uD83D\uDE37"}],"version":1},"face_with_thermometer":{"id":"face_with_thermometer","name":"Face with Thermometer","keywords":["sick","temperature","cold","fever","covid"],"skins":[{"unified":"1f912","native":"\uD83E\uDD12"}],"version":1},"face_with_head_bandage":{"id":"face_with_head_bandage","name":"Face with Head-Bandage","keywords":["head","bandage","injured","clumsy","hurt"],"skins":[{"unified":"1f915","native":"\uD83E\uDD15"}],"version":1},"nauseated_face":{"id":"nauseated_face","name":"Nauseated Face","keywords":["vomit","gross","green","sick","throw","up","ill"],"skins":[{"unified":"1f922","native":"\uD83E\uDD22"}],"version":3},"face_vomiting":{"id":"face_vomiting","name":"Face Vomiting","keywords":["with","open","mouth","sick"],"skins":[{"unified":"1f92e","native":"\uD83E\uDD2E"}],"version":5},"sneezing_face":{"id":"sneezing_face","name":"Sneezing Face","keywords":["gesundheit","sneeze","sick","allergy"],"skins":[{"unified":"1f927","native":"\uD83E\uDD27"}],"version":3},"hot_face":{"id":"hot_face","name":"Hot Face","keywords":["feverish","heat","red","sweating"],"skins":[{"unified":"1f975","native":"\uD83E\uDD75"}],"version":11},"cold_face":{"id":"cold_face","name":"Cold Face","keywords":["blue","freezing","frozen","frostbite","icicles"],"skins":[{"unified":"1f976","native":"\uD83E\uDD76"}],"version":11},"woozy_face":{"id":"woozy_face","name":"Woozy Face","keywords":["dizzy","intoxicated","tipsy","wavy"],"skins":[{"unified":"1f974","native":"\uD83E\uDD74"}],"version":11},"dizzy_face":{"id":"dizzy_face","name":"Dizzy Face","keywords":["spent","unconscious","xox"],"skins":[{"unified":"1f635","native":"\uD83D\uDE35"}],"version":1},"face_with_spiral_eyes":{"id":"face_with_spiral_eyes","name":"Face with Spiral Eyes","keywords":["sick","ill","confused","nauseous","nausea"],"skins":[{"unified":"1f635-200d-1f4ab","native":"\uD83D\uDE35\u200D\uD83D\uDCAB"}],"version":13.1},"exploding_head":{"id":"exploding_head","name":"Exploding Head","keywords":["shocked","face","with","mind","blown"],"skins":[{"unified":"1f92f","native":"\uD83E\uDD2F"}],"version":5},"face_with_cowboy_hat":{"id":"face_with_cowboy_hat","name":"Cowboy Hat Face","keywords":["with","cowgirl"],"skins":[{"unified":"1f920","native":"\uD83E\uDD20"}],"version":3},"partying_face":{"id":"partying_face","name":"Partying Face","keywords":["celebration","woohoo"],"skins":[{"unified":"1f973","native":"\uD83E\uDD73"}],"version":11},"disguised_face":{"id":"disguised_face","name":"Disguised Face","keywords":["pretent","brows","glasses","moustache"],"skins":[{"unified":"1f978","native":"\uD83E\uDD78"}],"version":13},"sunglasses":{"id":"sunglasses","name":"Smiling Face with Sunglasses","emoticons":["8)"],"keywords":["cool","smile","summer","beach","sunglass"],"skins":[{"unified":"1f60e","native":"\uD83D\uDE0E"}],"version":1},"nerd_face":{"id":"nerd_face","name":"Nerd Face","keywords":["nerdy","geek","dork"],"skins":[{"unified":"1f913","native":"\uD83E\uDD13"}],"version":1},"face_with_monocle":{"id":"face_with_monocle","name":"Face with Monocle","keywords":["stuffy","wealthy"],"skins":[{"unified":"1f9d0","native":"\uD83E\uDDD0"}],"version":5},"confused":{"id":"confused","name":"Confused Face","emoticons":[":\\\\",":-\\\\",":/",":-/"],"keywords":["indifference","huh","weird","hmmm",":/"],"skins":[{"unified":"1f615","native":"\uD83D\uDE15"}],"version":1},"face_with_diagonal_mouth":{"id":"face_with_diagonal_mouth","name":"Face with Diagonal Mouth","keywords":["skeptic","confuse","frustrated","indifferent"],"skins":[{"unified":"1fae4","native":"\uD83E\uDEE4"}],"version":14},"worried":{"id":"worried","name":"Worried Face","keywords":["concern","nervous",":("],"skins":[{"unified":"1f61f","native":"\uD83D\uDE1F"}],"version":1},"slightly_frowning_face":{"id":"slightly_frowning_face","name":"Slightly Frowning Face","keywords":["disappointed","sad","upset"],"skins":[{"unified":"1f641","native":"\uD83D\uDE41"}],"version":1},"white_frowning_face":{"id":"white_frowning_face","name":"Frowning Face","keywords":["white","sad","upset","frown"],"skins":[{"unified":"2639-fe0f","native":"\u2639\uFE0F"}],"version":1},"open_mouth":{"id":"open_mouth","name":"Face with Open Mouth","emoticons":[":o",":-o",":O",":-O"],"keywords":["surprise","impressed","wow","whoa",":O"],"skins":[{"unified":"1f62e","native":"\uD83D\uDE2E"}],"version":1},"hushed":{"id":"hushed","name":"Hushed Face","keywords":["woo","shh"],"skins":[{"unified":"1f62f","native":"\uD83D\uDE2F"}],"version":1},"astonished":{"id":"astonished","name":"Astonished Face","keywords":["xox","surprised","poisoned"],"skins":[{"unified":"1f632","native":"\uD83D\uDE32"}],"version":1},"flushed":{"id":"flushed","name":"Flushed Face","keywords":["blush","shy","flattered"],"skins":[{"unified":"1f633","native":"\uD83D\uDE33"}],"version":1},"pleading_face":{"id":"pleading_face","name":"Pleading Face","keywords":["begging","mercy","cry","tears","sad","grievance"],"skins":[{"unified":"1f97a","native":"\uD83E\uDD7A"}],"version":11},"face_holding_back_tears":{"id":"face_holding_back_tears","name":"Face Holding Back Tears","keywords":["touched","gratitude","cry"],"skins":[{"unified":"1f979","native":"\uD83E\uDD79"}],"version":14},"frowning":{"id":"frowning","name":"Frowning Face with Open Mouth","keywords":["aw","what"],"skins":[{"unified":"1f626","native":"\uD83D\uDE26"}],"version":1},"anguished":{"id":"anguished","name":"Anguished Face","emoticons":["D:"],"keywords":["stunned","nervous"],"skins":[{"unified":"1f627","native":"\uD83D\uDE27"}],"version":1},"fearful":{"id":"fearful","name":"Fearful Face","keywords":["scared","terrified","nervous"],"skins":[{"unified":"1f628","native":"\uD83D\uDE28"}],"version":1},"cold_sweat":{"id":"cold_sweat","name":"Anxious Face with Sweat","keywords":["cold","nervous"],"skins":[{"unified":"1f630","native":"\uD83D\uDE30"}],"version":1},"disappointed_relieved":{"id":"disappointed_relieved","name":"Sad but Relieved Face","keywords":["disappointed","phew","sweat","nervous"],"skins":[{"unified":"1f625","native":"\uD83D\uDE25"}],"version":1},"cry":{"id":"cry","name":"Crying Face","emoticons":[":\'("],"keywords":["cry","tears","sad","depressed","upset",":\'("],"skins":[{"unified":"1f622","native":"\uD83D\uDE22"}],"version":1},"sob":{"id":"sob","name":"Loudly Crying Face","emoticons":[":\'("],"keywords":["sob","cry","tears","sad","upset","depressed"],"skins":[{"unified":"1f62d","native":"\uD83D\uDE2D"}],"version":1},"scream":{"id":"scream","name":"Face Screaming in Fear","keywords":["scream","munch","scared","omg"],"skins":[{"unified":"1f631","native":"\uD83D\uDE31"}],"version":1},"confounded":{"id":"confounded","name":"Confounded Face","keywords":["confused","sick","unwell","oops",":S"],"skins":[{"unified":"1f616","native":"\uD83D\uDE16"}],"version":1},"persevere":{"id":"persevere","name":"Persevering Face","keywords":["persevere","sick","no","upset","oops"],"skins":[{"unified":"1f623","native":"\uD83D\uDE23"}],"version":1},"disappointed":{"id":"disappointed","name":"Disappointed Face","emoticons":["):",":(",":-("],"keywords":["sad","upset","depressed",":("],"skins":[{"unified":"1f61e","native":"\uD83D\uDE1E"}],"version":1},"sweat":{"id":"sweat","name":"Face with Cold Sweat","keywords":["downcast","hot","sad","tired","exercise"],"skins":[{"unified":"1f613","native":"\uD83D\uDE13"}],"version":1},"weary":{"id":"weary","name":"Weary Face","keywords":["tired","sleepy","sad","frustrated","upset"],"skins":[{"unified":"1f629","native":"\uD83D\uDE29"}],"version":1},"tired_face":{"id":"tired_face","name":"Tired Face","keywords":["sick","whine","upset","frustrated"],"skins":[{"unified":"1f62b","native":"\uD83D\uDE2B"}],"version":1},"yawning_face":{"id":"yawning_face","name":"Yawning Face","keywords":["tired","sleepy"],"skins":[{"unified":"1f971","native":"\uD83E\uDD71"}],"version":12},"triumph":{"id":"triumph","name":"Face with Look of Triumph","keywords":["steam","from","nose","gas","phew","proud","pride"],"skins":[{"unified":"1f624","native":"\uD83D\uDE24"}],"version":1},"rage":{"id":"rage","name":"Pouting Face","keywords":["rage","angry","mad","hate","despise"],"skins":[{"unified":"1f621","native":"\uD83D\uDE21"}],"version":1},"angry":{"id":"angry","name":"Angry Face","emoticons":[">:(",">:-("],"keywords":["mad","annoyed","frustrated"],"skins":[{"unified":"1f620","native":"\uD83D\uDE20"}],"version":1},"face_with_symbols_on_mouth":{"id":"face_with_symbols_on_mouth","name":"Face with Symbols on Mouth","keywords":["serious","covering","swearing","cursing","cussing","profanity","expletive"],"skins":[{"unified":"1f92c","native":"\uD83E\uDD2C"}],"version":5},"smiling_imp":{"id":"smiling_imp","name":"Smiling Face with Horns","keywords":["imp","devil"],"skins":[{"unified":"1f608","native":"\uD83D\uDE08"}],"version":1},"imp":{"id":"imp","name":"Imp","keywords":["angry","face","with","horns","devil"],"skins":[{"unified":"1f47f","native":"\uD83D\uDC7F"}],"version":1},"skull":{"id":"skull","name":"Skull","keywords":["dead","skeleton","creepy","death"],"skins":[{"unified":"1f480","native":"\uD83D\uDC80"}],"version":1},"skull_and_crossbones":{"id":"skull_and_crossbones","name":"Skull and Crossbones","keywords":["poison","danger","deadly","scary","death","pirate","evil"],"skins":[{"unified":"2620-fe0f","native":"\u2620\uFE0F"}],"version":1},"hankey":{"id":"hankey","name":"Pile of Poo","keywords":["hankey","poop","shit","shitface","fail","turd"],"skins":[{"unified":"1f4a9","native":"\uD83D\uDCA9"}],"version":1},"clown_face":{"id":"clown_face","name":"Clown Face","keywords":[],"skins":[{"unified":"1f921","native":"\uD83E\uDD21"}],"version":3},"japanese_ogre":{"id":"japanese_ogre","name":"Ogre","keywords":["japanese","monster","red","mask","halloween","scary","creepy","devil","demon"],"skins":[{"unified":"1f479","native":"\uD83D\uDC79"}],"version":1},"japanese_goblin":{"id":"japanese_goblin","name":"Goblin","keywords":["japanese","red","evil","mask","monster","scary","creepy"],"skins":[{"unified":"1f47a","native":"\uD83D\uDC7A"}],"version":1},"ghost":{"id":"ghost","name":"Ghost","keywords":["halloween","spooky","scary"],"skins":[{"unified":"1f47b","native":"\uD83D\uDC7B"}],"version":1},"alien":{"id":"alien","name":"Alien","keywords":["UFO","paul","weird","outer","space"],"skins":[{"unified":"1f47d","native":"\uD83D\uDC7D"}],"version":1},"space_invader":{"id":"space_invader","name":"Alien Monster","keywords":["space","invader","game","arcade","play"],"skins":[{"unified":"1f47e","native":"\uD83D\uDC7E"}],"version":1},"robot_face":{"id":"robot_face","name":"Robot","keywords":["face","computer","machine","bot"],"skins":[{"unified":"1f916","native":"\uD83E\uDD16"}],"version":1},"smiley_cat":{"id":"smiley_cat","name":"Grinning Cat","keywords":["smiley","animal","cats","happy","smile"],"skins":[{"unified":"1f63a","native":"\uD83D\uDE3A"}],"version":1},"smile_cat":{"id":"smile_cat","name":"Grinning Cat with Smiling Eyes","keywords":["smile","animal","cats"],"skins":[{"unified":"1f638","native":"\uD83D\uDE38"}],"version":1},"joy_cat":{"id":"joy_cat","name":"Cat with Tears of Joy","keywords":["animal","cats","haha","happy"],"skins":[{"unified":"1f639","native":"\uD83D\uDE39"}],"version":1},"heart_eyes_cat":{"id":"heart_eyes_cat","name":"Smiling Cat with Heart-Eyes","keywords":["heart","eyes","animal","love","like","affection","cats","valentines"],"skins":[{"unified":"1f63b","native":"\uD83D\uDE3B"}],"version":1},"smirk_cat":{"id":"smirk_cat","name":"Cat with Wry Smile","keywords":["smirk","animal","cats"],"skins":[{"unified":"1f63c","native":"\uD83D\uDE3C"}],"version":1},"kissing_cat":{"id":"kissing_cat","name":"Kissing Cat","keywords":["animal","cats","kiss"],"skins":[{"unified":"1f63d","native":"\uD83D\uDE3D"}],"version":1},"scream_cat":{"id":"scream_cat","name":"Weary Cat","keywords":["scream","animal","cats","munch","scared"],"skins":[{"unified":"1f640","native":"\uD83D\uDE40"}],"version":1},"crying_cat_face":{"id":"crying_cat_face","name":"Crying Cat","keywords":["face","animal","tears","weep","sad","cats","upset","cry"],"skins":[{"unified":"1f63f","native":"\uD83D\uDE3F"}],"version":1},"pouting_cat":{"id":"pouting_cat","name":"Pouting Cat","keywords":["animal","cats"],"skins":[{"unified":"1f63e","native":"\uD83D\uDE3E"}],"version":1},"see_no_evil":{"id":"see_no_evil","name":"See-No-Evil Monkey","keywords":["see","no","evil","animal","nature","haha"],"skins":[{"unified":"1f648","native":"\uD83D\uDE48"}],"version":1},"hear_no_evil":{"id":"hear_no_evil","name":"Hear-No-Evil Monkey","keywords":["hear","no","evil","animal","nature"],"skins":[{"unified":"1f649","native":"\uD83D\uDE49"}],"version":1},"speak_no_evil":{"id":"speak_no_evil","name":"Speak-No-Evil Monkey","keywords":["speak","no","evil","animal","nature","omg"],"skins":[{"unified":"1f64a","native":"\uD83D\uDE4A"}],"version":1},"love_letter":{"id":"love_letter","name":"Love Letter","keywords":["email","like","affection","envelope","valentines"],"skins":[{"unified":"1f48c","native":"\uD83D\uDC8C"}],"version":1},"cupid":{"id":"cupid","name":"Heart with Arrow","keywords":["cupid","love","like","affection","valentines"],"skins":[{"unified":"1f498","native":"\uD83D\uDC98"}],"version":1},"gift_heart":{"id":"gift_heart","name":"Heart with Ribbon","keywords":["gift","love","valentines"],"skins":[{"unified":"1f49d","native":"\uD83D\uDC9D"}],"version":1},"sparkling_heart":{"id":"sparkling_heart","name":"Sparkling Heart","keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f496","native":"\uD83D\uDC96"}],"version":1},"heartpulse":{"id":"heartpulse","name":"Growing Heart","keywords":["heartpulse","like","love","affection","valentines","pink"],"skins":[{"unified":"1f497","native":"\uD83D\uDC97"}],"version":1},"heartbeat":{"id":"heartbeat","name":"Beating Heart","keywords":["heartbeat","love","like","affection","valentines","pink"],"skins":[{"unified":"1f493","native":"\uD83D\uDC93"}],"version":1},"revolving_hearts":{"id":"revolving_hearts","name":"Revolving Hearts","keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f49e","native":"\uD83D\uDC9E"}],"version":1},"two_hearts":{"id":"two_hearts","name":"Two Hearts","keywords":["love","like","affection","valentines","heart"],"skins":[{"unified":"1f495","native":"\uD83D\uDC95"}],"version":1},"heart_decoration":{"id":"heart_decoration","name":"Heart Decoration","keywords":["purple","square","love","like"],"skins":[{"unified":"1f49f","native":"\uD83D\uDC9F"}],"version":1},"heavy_heart_exclamation_mark_ornament":{"id":"heavy_heart_exclamation_mark_ornament","name":"Heart Exclamation","keywords":["heavy","mark","ornament","decoration","love"],"skins":[{"unified":"2763-fe0f","native":"\u2763\uFE0F"}],"version":1},"broken_heart":{"id":"broken_heart","name":"Broken Heart","emoticons":["</3"],"keywords":["sad","sorry","break","heartbreak"],"skins":[{"unified":"1f494","native":"\uD83D\uDC94"}],"version":1},"heart_on_fire":{"id":"heart_on_fire","name":"Heart on Fire","keywords":["passionate","enthusiastic"],"skins":[{"unified":"2764-fe0f-200d-1f525","native":"\u2764\uFE0F\u200D\uD83D\uDD25"}],"version":13.1},"mending_heart":{"id":"mending_heart","name":"Mending Heart","keywords":["broken","bandage","wounded"],"skins":[{"unified":"2764-fe0f-200d-1fa79","native":"\u2764\uFE0F\u200D\uD83E\uDE79"}],"version":13.1},"heart":{"id":"heart","name":"Red Heart","emoticons":["<3"],"keywords":["love","like","valentines"],"skins":[{"unified":"2764-fe0f","native":"\u2764\uFE0F"}],"version":1},"pink_heart":{"id":"pink_heart","name":"Pink Heart","keywords":["valentines"],"skins":[{"unified":"1fa77","native":"\uD83E\uDE77"}],"version":15},"orange_heart":{"id":"orange_heart","name":"Orange Heart","keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f9e1","native":"\uD83E\uDDE1"}],"version":5},"yellow_heart":{"id":"yellow_heart","name":"Yellow Heart","emoticons":["<3"],"keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f49b","native":"\uD83D\uDC9B"}],"version":1},"green_heart":{"id":"green_heart","name":"Green Heart","emoticons":["<3"],"keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f49a","native":"\uD83D\uDC9A"}],"version":1},"blue_heart":{"id":"blue_heart","name":"Blue Heart","emoticons":["<3"],"keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f499","native":"\uD83D\uDC99"}],"version":1},"light_blue_heart":{"id":"light_blue_heart","name":"Light Blue Heart","keywords":["ice","baby"],"skins":[{"unified":"1fa75","native":"\uD83E\uDE75"}],"version":15},"purple_heart":{"id":"purple_heart","name":"Purple Heart","emoticons":["<3"],"keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f49c","native":"\uD83D\uDC9C"}],"version":1},"brown_heart":{"id":"brown_heart","name":"Brown Heart","keywords":["coffee"],"skins":[{"unified":"1f90e","native":"\uD83E\uDD0E"}],"version":12},"black_heart":{"id":"black_heart","name":"Black Heart","keywords":["evil"],"skins":[{"unified":"1f5a4","native":"\uD83D\uDDA4"}],"version":3},"grey_heart":{"id":"grey_heart","name":"Grey Heart","keywords":["silver","monochrome"],"skins":[{"unified":"1fa76","native":"\uD83E\uDE76"}],"version":15},"white_heart":{"id":"white_heart","name":"White Heart","keywords":["pure"],"skins":[{"unified":"1f90d","native":"\uD83E\uDD0D"}],"version":12},"kiss":{"id":"kiss","name":"Kiss Mark","keywords":["face","lips","love","like","affection","valentines"],"skins":[{"unified":"1f48b","native":"\uD83D\uDC8B"}],"version":1},"anger":{"id":"anger","name":"Anger Symbol","keywords":["angry","mad"],"skins":[{"unified":"1f4a2","native":"\uD83D\uDCA2"}],"version":1},"boom":{"id":"boom","name":"Collision","keywords":["boom","bomb","explode","explosion","blown"],"skins":[{"unified":"1f4a5","native":"\uD83D\uDCA5"}],"version":1},"dizzy":{"id":"dizzy","name":"Dizzy","keywords":["star","sparkle","shoot","magic"],"skins":[{"unified":"1f4ab","native":"\uD83D\uDCAB"}],"version":1},"sweat_drops":{"id":"sweat_drops","name":"Sweat Droplets","keywords":["drops","water","drip","oops"],"skins":[{"unified":"1f4a6","native":"\uD83D\uDCA6"}],"version":1},"dash":{"id":"dash","name":"Dash Symbol","keywords":["dashing","away","wind","air","fast","shoo","fart","smoke","puff"],"skins":[{"unified":"1f4a8","native":"\uD83D\uDCA8"}],"version":1},"hole":{"id":"hole","name":"Hole","keywords":["embarrassing"],"skins":[{"unified":"1f573-fe0f","native":"\uD83D\uDD73\uFE0F"}],"version":1},"speech_balloon":{"id":"speech_balloon","name":"Speech Balloon","keywords":["bubble","words","message","talk","chatting"],"skins":[{"unified":"1f4ac","native":"\uD83D\uDCAC"}],"version":1},"eye-in-speech-bubble":{"id":"eye-in-speech-bubble","name":"Eye in Speech Bubble","keywords":["in-speech-bubble","info"],"skins":[{"unified":"1f441-fe0f-200d-1f5e8-fe0f","native":"\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F"}],"version":2},"left_speech_bubble":{"id":"left_speech_bubble","name":"Left Speech Bubble","keywords":["words","message","talk","chatting"],"skins":[{"unified":"1f5e8-fe0f","native":"\uD83D\uDDE8\uFE0F"}],"version":2},"right_anger_bubble":{"id":"right_anger_bubble","name":"Right Anger Bubble","keywords":["caption","speech","thinking","mad"],"skins":[{"unified":"1f5ef-fe0f","native":"\uD83D\uDDEF\uFE0F"}],"version":1},"thought_balloon":{"id":"thought_balloon","name":"Thought Balloon","keywords":["bubble","cloud","speech","thinking","dream"],"skins":[{"unified":"1f4ad","native":"\uD83D\uDCAD"}],"version":1},"zzz":{"id":"zzz","name":"Zzz","keywords":["sleepy","tired","dream"],"skins":[{"unified":"1f4a4","native":"\uD83D\uDCA4"}],"version":1},"wave":{"id":"wave","name":"Waving Hand","keywords":["wave","hands","gesture","goodbye","solong","farewell","hello","hi","palm"],"skins":[{"unified":"1f44b","native":"\uD83D\uDC4B"},{"unified":"1f44b-1f3fb","native":"\uD83D\uDC4B\uD83C\uDFFB"},{"unified":"1f44b-1f3fc","native":"\uD83D\uDC4B\uD83C\uDFFC"},{"unified":"1f44b-1f3fd","native":"\uD83D\uDC4B\uD83C\uDFFD"},{"unified":"1f44b-1f3fe","native":"\uD83D\uDC4B\uD83C\uDFFE"},{"unified":"1f44b-1f3ff","native":"\uD83D\uDC4B\uD83C\uDFFF"}],"version":1},"raised_back_of_hand":{"id":"raised_back_of_hand","name":"Raised Back of Hand","keywords":["fingers","backhand"],"skins":[{"unified":"1f91a","native":"\uD83E\uDD1A"},{"unified":"1f91a-1f3fb","native":"\uD83E\uDD1A\uD83C\uDFFB"},{"unified":"1f91a-1f3fc","native":"\uD83E\uDD1A\uD83C\uDFFC"},{"unified":"1f91a-1f3fd","native":"\uD83E\uDD1A\uD83C\uDFFD"},{"unified":"1f91a-1f3fe","native":"\uD83E\uDD1A\uD83C\uDFFE"},{"unified":"1f91a-1f3ff","native":"\uD83E\uDD1A\uD83C\uDFFF"}],"version":3},"raised_hand_with_fingers_splayed":{"id":"raised_hand_with_fingers_splayed","name":"Hand with Fingers Splayed","keywords":["raised","palm"],"skins":[{"unified":"1f590-fe0f","native":"\uD83D\uDD90\uFE0F"},{"unified":"1f590-1f3fb","native":"\uD83D\uDD90\uD83C\uDFFB"},{"unified":"1f590-1f3fc","native":"\uD83D\uDD90\uD83C\uDFFC"},{"unified":"1f590-1f3fd","native":"\uD83D\uDD90\uD83C\uDFFD"},{"unified":"1f590-1f3fe","native":"\uD83D\uDD90\uD83C\uDFFE"},{"unified":"1f590-1f3ff","native":"\uD83D\uDD90\uD83C\uDFFF"}],"version":1},"hand":{"id":"hand","name":"Raised Hand","keywords":["fingers","stop","highfive","high","five","palm","ban"],"skins":[{"unified":"270b","native":"\u270B"},{"unified":"270b-1f3fb","native":"\u270B\uD83C\uDFFB"},{"unified":"270b-1f3fc","native":"\u270B\uD83C\uDFFC"},{"unified":"270b-1f3fd","native":"\u270B\uD83C\uDFFD"},{"unified":"270b-1f3fe","native":"\u270B\uD83C\uDFFE"},{"unified":"270b-1f3ff","native":"\u270B\uD83C\uDFFF"}],"version":1},"spock-hand":{"id":"spock-hand","name":"Vulcan Salute","keywords":["spock","hand","fingers","star","trek"],"skins":[{"unified":"1f596","native":"\uD83D\uDD96"},{"unified":"1f596-1f3fb","native":"\uD83D\uDD96\uD83C\uDFFB"},{"unified":"1f596-1f3fc","native":"\uD83D\uDD96\uD83C\uDFFC"},{"unified":"1f596-1f3fd","native":"\uD83D\uDD96\uD83C\uDFFD"},{"unified":"1f596-1f3fe","native":"\uD83D\uDD96\uD83C\uDFFE"},{"unified":"1f596-1f3ff","native":"\uD83D\uDD96\uD83C\uDFFF"}],"version":1},"rightwards_hand":{"id":"rightwards_hand","name":"Rightwards Hand","keywords":["palm","offer"],"skins":[{"unified":"1faf1","native":"\uD83E\uDEF1"},{"unified":"1faf1-1f3fb","native":"\uD83E\uDEF1\uD83C\uDFFB"},{"unified":"1faf1-1f3fc","native":"\uD83E\uDEF1\uD83C\uDFFC"},{"unified":"1faf1-1f3fd","native":"\uD83E\uDEF1\uD83C\uDFFD"},{"unified":"1faf1-1f3fe","native":"\uD83E\uDEF1\uD83C\uDFFE"},{"unified":"1faf1-1f3ff","native":"\uD83E\uDEF1\uD83C\uDFFF"}],"version":14},"leftwards_hand":{"id":"leftwards_hand","name":"Leftwards Hand","keywords":["palm","offer"],"skins":[{"unified":"1faf2","native":"\uD83E\uDEF2"},{"unified":"1faf2-1f3fb","native":"\uD83E\uDEF2\uD83C\uDFFB"},{"unified":"1faf2-1f3fc","native":"\uD83E\uDEF2\uD83C\uDFFC"},{"unified":"1faf2-1f3fd","native":"\uD83E\uDEF2\uD83C\uDFFD"},{"unified":"1faf2-1f3fe","native":"\uD83E\uDEF2\uD83C\uDFFE"},{"unified":"1faf2-1f3ff","native":"\uD83E\uDEF2\uD83C\uDFFF"}],"version":14},"palm_down_hand":{"id":"palm_down_hand","name":"Palm Down Hand","keywords":["drop"],"skins":[{"unified":"1faf3","native":"\uD83E\uDEF3"},{"unified":"1faf3-1f3fb","native":"\uD83E\uDEF3\uD83C\uDFFB"},{"unified":"1faf3-1f3fc","native":"\uD83E\uDEF3\uD83C\uDFFC"},{"unified":"1faf3-1f3fd","native":"\uD83E\uDEF3\uD83C\uDFFD"},{"unified":"1faf3-1f3fe","native":"\uD83E\uDEF3\uD83C\uDFFE"},{"unified":"1faf3-1f3ff","native":"\uD83E\uDEF3\uD83C\uDFFF"}],"version":14},"palm_up_hand":{"id":"palm_up_hand","name":"Palm Up Hand","keywords":["lift","offer","demand"],"skins":[{"unified":"1faf4","native":"\uD83E\uDEF4"},{"unified":"1faf4-1f3fb","native":"\uD83E\uDEF4\uD83C\uDFFB"},{"unified":"1faf4-1f3fc","native":"\uD83E\uDEF4\uD83C\uDFFC"},{"unified":"1faf4-1f3fd","native":"\uD83E\uDEF4\uD83C\uDFFD"},{"unified":"1faf4-1f3fe","native":"\uD83E\uDEF4\uD83C\uDFFE"},{"unified":"1faf4-1f3ff","native":"\uD83E\uDEF4\uD83C\uDFFF"}],"version":14},"leftwards_pushing_hand":{"id":"leftwards_pushing_hand","name":"Leftwards Pushing Hand","keywords":["highfive","high","five","pressing","stop"],"skins":[{"unified":"1faf7","native":"\uD83E\uDEF7"},{"unified":"1faf7-1f3fb","native":"\uD83E\uDEF7\uD83C\uDFFB"},{"unified":"1faf7-1f3fc","native":"\uD83E\uDEF7\uD83C\uDFFC"},{"unified":"1faf7-1f3fd","native":"\uD83E\uDEF7\uD83C\uDFFD"},{"unified":"1faf7-1f3fe","native":"\uD83E\uDEF7\uD83C\uDFFE"},{"unified":"1faf7-1f3ff","native":"\uD83E\uDEF7\uD83C\uDFFF"}],"version":15},"rightwards_pushing_hand":{"id":"rightwards_pushing_hand","name":"Rightwards Pushing Hand","keywords":["highfive","high","five","pressing","stop"],"skins":[{"unified":"1faf8","native":"\uD83E\uDEF8"},{"unified":"1faf8-1f3fb","native":"\uD83E\uDEF8\uD83C\uDFFB"},{"unified":"1faf8-1f3fc","native":"\uD83E\uDEF8\uD83C\uDFFC"},{"unified":"1faf8-1f3fd","native":"\uD83E\uDEF8\uD83C\uDFFD"},{"unified":"1faf8-1f3fe","native":"\uD83E\uDEF8\uD83C\uDFFE"},{"unified":"1faf8-1f3ff","native":"\uD83E\uDEF8\uD83C\uDFFF"}],"version":15},"ok_hand":{"id":"ok_hand","name":"Ok Hand","keywords":["fingers","limbs","perfect","okay"],"skins":[{"unified":"1f44c","native":"\uD83D\uDC4C"},{"unified":"1f44c-1f3fb","native":"\uD83D\uDC4C\uD83C\uDFFB"},{"unified":"1f44c-1f3fc","native":"\uD83D\uDC4C\uD83C\uDFFC"},{"unified":"1f44c-1f3fd","native":"\uD83D\uDC4C\uD83C\uDFFD"},{"unified":"1f44c-1f3fe","native":"\uD83D\uDC4C\uD83C\uDFFE"},{"unified":"1f44c-1f3ff","native":"\uD83D\uDC4C\uD83C\uDFFF"}],"version":1},"pinched_fingers":{"id":"pinched_fingers","name":"Pinched Fingers","keywords":["size","tiny","small"],"skins":[{"unified":"1f90c","native":"\uD83E\uDD0C"},{"unified":"1f90c-1f3fb","native":"\uD83E\uDD0C\uD83C\uDFFB"},{"unified":"1f90c-1f3fc","native":"\uD83E\uDD0C\uD83C\uDFFC"},{"unified":"1f90c-1f3fd","native":"\uD83E\uDD0C\uD83C\uDFFD"},{"unified":"1f90c-1f3fe","native":"\uD83E\uDD0C\uD83C\uDFFE"},{"unified":"1f90c-1f3ff","native":"\uD83E\uDD0C\uD83C\uDFFF"}],"version":13},"pinching_hand":{"id":"pinching_hand","name":"Pinching Hand","keywords":["tiny","small","size"],"skins":[{"unified":"1f90f","native":"\uD83E\uDD0F"},{"unified":"1f90f-1f3fb","native":"\uD83E\uDD0F\uD83C\uDFFB"},{"unified":"1f90f-1f3fc","native":"\uD83E\uDD0F\uD83C\uDFFC"},{"unified":"1f90f-1f3fd","native":"\uD83E\uDD0F\uD83C\uDFFD"},{"unified":"1f90f-1f3fe","native":"\uD83E\uDD0F\uD83C\uDFFE"},{"unified":"1f90f-1f3ff","native":"\uD83E\uDD0F\uD83C\uDFFF"}],"version":12},"v":{"id":"v","name":"Victory Hand","keywords":["v","fingers","ohyeah","peace","two"],"skins":[{"unified":"270c-fe0f","native":"\u270C\uFE0F"},{"unified":"270c-1f3fb","native":"\u270C\uD83C\uDFFB"},{"unified":"270c-1f3fc","native":"\u270C\uD83C\uDFFC"},{"unified":"270c-1f3fd","native":"\u270C\uD83C\uDFFD"},{"unified":"270c-1f3fe","native":"\u270C\uD83C\uDFFE"},{"unified":"270c-1f3ff","native":"\u270C\uD83C\uDFFF"}],"version":1},"crossed_fingers":{"id":"crossed_fingers","name":"Crossed Fingers","keywords":["hand","with","index","and","middle","good","lucky"],"skins":[{"unified":"1f91e","native":"\uD83E\uDD1E"},{"unified":"1f91e-1f3fb","native":"\uD83E\uDD1E\uD83C\uDFFB"},{"unified":"1f91e-1f3fc","native":"\uD83E\uDD1E\uD83C\uDFFC"},{"unified":"1f91e-1f3fd","native":"\uD83E\uDD1E\uD83C\uDFFD"},{"unified":"1f91e-1f3fe","native":"\uD83E\uDD1E\uD83C\uDFFE"},{"unified":"1f91e-1f3ff","native":"\uD83E\uDD1E\uD83C\uDFFF"}],"version":3},"hand_with_index_finger_and_thumb_crossed":{"id":"hand_with_index_finger_and_thumb_crossed","name":"Hand with Index Finger and Thumb Crossed","keywords":["heart","love","money","expensive"],"skins":[{"unified":"1faf0","native":"\uD83E\uDEF0"},{"unified":"1faf0-1f3fb","native":"\uD83E\uDEF0\uD83C\uDFFB"},{"unified":"1faf0-1f3fc","native":"\uD83E\uDEF0\uD83C\uDFFC"},{"unified":"1faf0-1f3fd","native":"\uD83E\uDEF0\uD83C\uDFFD"},{"unified":"1faf0-1f3fe","native":"\uD83E\uDEF0\uD83C\uDFFE"},{"unified":"1faf0-1f3ff","native":"\uD83E\uDEF0\uD83C\uDFFF"}],"version":14},"i_love_you_hand_sign":{"id":"i_love_you_hand_sign","name":"Love-You Gesture","keywords":["i","love","you","hand","sign","fingers"],"skins":[{"unified":"1f91f","native":"\uD83E\uDD1F"},{"unified":"1f91f-1f3fb","native":"\uD83E\uDD1F\uD83C\uDFFB"},{"unified":"1f91f-1f3fc","native":"\uD83E\uDD1F\uD83C\uDFFC"},{"unified":"1f91f-1f3fd","native":"\uD83E\uDD1F\uD83C\uDFFD"},{"unified":"1f91f-1f3fe","native":"\uD83E\uDD1F\uD83C\uDFFE"},{"unified":"1f91f-1f3ff","native":"\uD83E\uDD1F\uD83C\uDFFF"}],"version":5},"the_horns":{"id":"the_horns","name":"Sign of the Horns","keywords":["hand","fingers","evil","eye","rock","on"],"skins":[{"unified":"1f918","native":"\uD83E\uDD18"},{"unified":"1f918-1f3fb","native":"\uD83E\uDD18\uD83C\uDFFB"},{"unified":"1f918-1f3fc","native":"\uD83E\uDD18\uD83C\uDFFC"},{"unified":"1f918-1f3fd","native":"\uD83E\uDD18\uD83C\uDFFD"},{"unified":"1f918-1f3fe","native":"\uD83E\uDD18\uD83C\uDFFE"},{"unified":"1f918-1f3ff","native":"\uD83E\uDD18\uD83C\uDFFF"}],"version":1},"call_me_hand":{"id":"call_me_hand","name":"Call Me Hand","keywords":["hands","gesture","shaka"],"skins":[{"unified":"1f919","native":"\uD83E\uDD19"},{"unified":"1f919-1f3fb","native":"\uD83E\uDD19\uD83C\uDFFB"},{"unified":"1f919-1f3fc","native":"\uD83E\uDD19\uD83C\uDFFC"},{"unified":"1f919-1f3fd","native":"\uD83E\uDD19\uD83C\uDFFD"},{"unified":"1f919-1f3fe","native":"\uD83E\uDD19\uD83C\uDFFE"},{"unified":"1f919-1f3ff","native":"\uD83E\uDD19\uD83C\uDFFF"}],"version":3},"point_left":{"id":"point_left","name":"Backhand Index Pointing Left","keywords":["point","direction","fingers","hand"],"skins":[{"unified":"1f448","native":"\uD83D\uDC48"},{"unified":"1f448-1f3fb","native":"\uD83D\uDC48\uD83C\uDFFB"},{"unified":"1f448-1f3fc","native":"\uD83D\uDC48\uD83C\uDFFC"},{"unified":"1f448-1f3fd","native":"\uD83D\uDC48\uD83C\uDFFD"},{"unified":"1f448-1f3fe","native":"\uD83D\uDC48\uD83C\uDFFE"},{"unified":"1f448-1f3ff","native":"\uD83D\uDC48\uD83C\uDFFF"}],"version":1},"point_right":{"id":"point_right","name":"Backhand Index Pointing Right","keywords":["point","fingers","hand","direction"],"skins":[{"unified":"1f449","native":"\uD83D\uDC49"},{"unified":"1f449-1f3fb","native":"\uD83D\uDC49\uD83C\uDFFB"},{"unified":"1f449-1f3fc","native":"\uD83D\uDC49\uD83C\uDFFC"},{"unified":"1f449-1f3fd","native":"\uD83D\uDC49\uD83C\uDFFD"},{"unified":"1f449-1f3fe","native":"\uD83D\uDC49\uD83C\uDFFE"},{"unified":"1f449-1f3ff","native":"\uD83D\uDC49\uD83C\uDFFF"}],"version":1},"point_up_2":{"id":"point_up_2","name":"Backhand Index Pointing Up","keywords":["point","2","fingers","hand","direction"],"skins":[{"unified":"1f446","native":"\uD83D\uDC46"},{"unified":"1f446-1f3fb","native":"\uD83D\uDC46\uD83C\uDFFB"},{"unified":"1f446-1f3fc","native":"\uD83D\uDC46\uD83C\uDFFC"},{"unified":"1f446-1f3fd","native":"\uD83D\uDC46\uD83C\uDFFD"},{"unified":"1f446-1f3fe","native":"\uD83D\uDC46\uD83C\uDFFE"},{"unified":"1f446-1f3ff","native":"\uD83D\uDC46\uD83C\uDFFF"}],"version":1},"middle_finger":{"id":"middle_finger","name":"Middle Finger","keywords":["reversed","hand","with","extended","fingers","rude","flipping"],"skins":[{"unified":"1f595","native":"\uD83D\uDD95"},{"unified":"1f595-1f3fb","native":"\uD83D\uDD95\uD83C\uDFFB"},{"unified":"1f595-1f3fc","native":"\uD83D\uDD95\uD83C\uDFFC"},{"unified":"1f595-1f3fd","native":"\uD83D\uDD95\uD83C\uDFFD"},{"unified":"1f595-1f3fe","native":"\uD83D\uDD95\uD83C\uDFFE"},{"unified":"1f595-1f3ff","native":"\uD83D\uDD95\uD83C\uDFFF"}],"version":1},"point_down":{"id":"point_down","name":"Backhand Index Pointing Down","keywords":["point","fingers","hand","direction"],"skins":[{"unified":"1f447","native":"\uD83D\uDC47"},{"unified":"1f447-1f3fb","native":"\uD83D\uDC47\uD83C\uDFFB"},{"unified":"1f447-1f3fc","native":"\uD83D\uDC47\uD83C\uDFFC"},{"unified":"1f447-1f3fd","native":"\uD83D\uDC47\uD83C\uDFFD"},{"unified":"1f447-1f3fe","native":"\uD83D\uDC47\uD83C\uDFFE"},{"unified":"1f447-1f3ff","native":"\uD83D\uDC47\uD83C\uDFFF"}],"version":1},"point_up":{"id":"point_up","name":"Index Pointing Up","keywords":["point","hand","fingers","direction"],"skins":[{"unified":"261d-fe0f","native":"\u261D\uFE0F"},{"unified":"261d-1f3fb","native":"\u261D\uD83C\uDFFB"},{"unified":"261d-1f3fc","native":"\u261D\uD83C\uDFFC"},{"unified":"261d-1f3fd","native":"\u261D\uD83C\uDFFD"},{"unified":"261d-1f3fe","native":"\u261D\uD83C\uDFFE"},{"unified":"261d-1f3ff","native":"\u261D\uD83C\uDFFF"}],"version":1},"index_pointing_at_the_viewer":{"id":"index_pointing_at_the_viewer","name":"Index Pointing at the Viewer","keywords":["you","recruit"],"skins":[{"unified":"1faf5","native":"\uD83E\uDEF5"},{"unified":"1faf5-1f3fb","native":"\uD83E\uDEF5\uD83C\uDFFB"},{"unified":"1faf5-1f3fc","native":"\uD83E\uDEF5\uD83C\uDFFC"},{"unified":"1faf5-1f3fd","native":"\uD83E\uDEF5\uD83C\uDFFD"},{"unified":"1faf5-1f3fe","native":"\uD83E\uDEF5\uD83C\uDFFE"},{"unified":"1faf5-1f3ff","native":"\uD83E\uDEF5\uD83C\uDFFF"}],"version":14},"+1":{"id":"+1","name":"Thumbs Up","keywords":["+1","thumbsup","yes","awesome","good","agree","accept","cool","hand","like"],"skins":[{"unified":"1f44d","native":"\uD83D\uDC4D"},{"unified":"1f44d-1f3fb","native":"\uD83D\uDC4D\uD83C\uDFFB"},{"unified":"1f44d-1f3fc","native":"\uD83D\uDC4D\uD83C\uDFFC"},{"unified":"1f44d-1f3fd","native":"\uD83D\uDC4D\uD83C\uDFFD"},{"unified":"1f44d-1f3fe","native":"\uD83D\uDC4D\uD83C\uDFFE"},{"unified":"1f44d-1f3ff","native":"\uD83D\uDC4D\uD83C\uDFFF"}],"version":1},"-1":{"id":"-1","name":"Thumbs Down","keywords":["-1","thumbsdown","no","dislike","hand"],"skins":[{"unified":"1f44e","native":"\uD83D\uDC4E"},{"unified":"1f44e-1f3fb","native":"\uD83D\uDC4E\uD83C\uDFFB"},{"unified":"1f44e-1f3fc","native":"\uD83D\uDC4E\uD83C\uDFFC"},{"unified":"1f44e-1f3fd","native":"\uD83D\uDC4E\uD83C\uDFFD"},{"unified":"1f44e-1f3fe","native":"\uD83D\uDC4E\uD83C\uDFFE"},{"unified":"1f44e-1f3ff","native":"\uD83D\uDC4E\uD83C\uDFFF"}],"version":1},"fist":{"id":"fist","name":"Raised Fist","keywords":["fingers","hand","grasp"],"skins":[{"unified":"270a","native":"\u270A"},{"unified":"270a-1f3fb","native":"\u270A\uD83C\uDFFB"},{"unified":"270a-1f3fc","native":"\u270A\uD83C\uDFFC"},{"unified":"270a-1f3fd","native":"\u270A\uD83C\uDFFD"},{"unified":"270a-1f3fe","native":"\u270A\uD83C\uDFFE"},{"unified":"270a-1f3ff","native":"\u270A\uD83C\uDFFF"}],"version":1},"facepunch":{"id":"facepunch","name":"Oncoming Fist","keywords":["facepunch","punch","angry","violence","hit","attack","hand"],"skins":[{"unified":"1f44a","native":"\uD83D\uDC4A"},{"unified":"1f44a-1f3fb","native":"\uD83D\uDC4A\uD83C\uDFFB"},{"unified":"1f44a-1f3fc","native":"\uD83D\uDC4A\uD83C\uDFFC"},{"unified":"1f44a-1f3fd","native":"\uD83D\uDC4A\uD83C\uDFFD"},{"unified":"1f44a-1f3fe","native":"\uD83D\uDC4A\uD83C\uDFFE"},{"unified":"1f44a-1f3ff","native":"\uD83D\uDC4A\uD83C\uDFFF"}],"version":1},"left-facing_fist":{"id":"left-facing_fist","name":"Left-Facing Fist","keywords":["left","facing","hand","fistbump"],"skins":[{"unified":"1f91b","native":"\uD83E\uDD1B"},{"unified":"1f91b-1f3fb","native":"\uD83E\uDD1B\uD83C\uDFFB"},{"unified":"1f91b-1f3fc","native":"\uD83E\uDD1B\uD83C\uDFFC"},{"unified":"1f91b-1f3fd","native":"\uD83E\uDD1B\uD83C\uDFFD"},{"unified":"1f91b-1f3fe","native":"\uD83E\uDD1B\uD83C\uDFFE"},{"unified":"1f91b-1f3ff","native":"\uD83E\uDD1B\uD83C\uDFFF"}],"version":3},"right-facing_fist":{"id":"right-facing_fist","name":"Right-Facing Fist","keywords":["right","facing","hand","fistbump"],"skins":[{"unified":"1f91c","native":"\uD83E\uDD1C"},{"unified":"1f91c-1f3fb","native":"\uD83E\uDD1C\uD83C\uDFFB"},{"unified":"1f91c-1f3fc","native":"\uD83E\uDD1C\uD83C\uDFFC"},{"unified":"1f91c-1f3fd","native":"\uD83E\uDD1C\uD83C\uDFFD"},{"unified":"1f91c-1f3fe","native":"\uD83E\uDD1C\uD83C\uDFFE"},{"unified":"1f91c-1f3ff","native":"\uD83E\uDD1C\uD83C\uDFFF"}],"version":3},"clap":{"id":"clap","name":"Clapping Hands","keywords":["clap","praise","applause","congrats","yay"],"skins":[{"unified":"1f44f","native":"\uD83D\uDC4F"},{"unified":"1f44f-1f3fb","native":"\uD83D\uDC4F\uD83C\uDFFB"},{"unified":"1f44f-1f3fc","native":"\uD83D\uDC4F\uD83C\uDFFC"},{"unified":"1f44f-1f3fd","native":"\uD83D\uDC4F\uD83C\uDFFD"},{"unified":"1f44f-1f3fe","native":"\uD83D\uDC4F\uD83C\uDFFE"},{"unified":"1f44f-1f3ff","native":"\uD83D\uDC4F\uD83C\uDFFF"}],"version":1},"raised_hands":{"id":"raised_hands","name":"Raising Hands","keywords":["raised","gesture","hooray","yea","celebration"],"skins":[{"unified":"1f64c","native":"\uD83D\uDE4C"},{"unified":"1f64c-1f3fb","native":"\uD83D\uDE4C\uD83C\uDFFB"},{"unified":"1f64c-1f3fc","native":"\uD83D\uDE4C\uD83C\uDFFC"},{"unified":"1f64c-1f3fd","native":"\uD83D\uDE4C\uD83C\uDFFD"},{"unified":"1f64c-1f3fe","native":"\uD83D\uDE4C\uD83C\uDFFE"},{"unified":"1f64c-1f3ff","native":"\uD83D\uDE4C\uD83C\uDFFF"}],"version":1},"heart_hands":{"id":"heart_hands","name":"Heart Hands","keywords":["love","appreciation","support"],"skins":[{"unified":"1faf6","native":"\uD83E\uDEF6"},{"unified":"1faf6-1f3fb","native":"\uD83E\uDEF6\uD83C\uDFFB"},{"unified":"1faf6-1f3fc","native":"\uD83E\uDEF6\uD83C\uDFFC"},{"unified":"1faf6-1f3fd","native":"\uD83E\uDEF6\uD83C\uDFFD"},{"unified":"1faf6-1f3fe","native":"\uD83E\uDEF6\uD83C\uDFFE"},{"unified":"1faf6-1f3ff","native":"\uD83E\uDEF6\uD83C\uDFFF"}],"version":14},"open_hands":{"id":"open_hands","name":"Open Hands","keywords":["fingers","butterfly"],"skins":[{"unified":"1f450","native":"\uD83D\uDC50"},{"unified":"1f450-1f3fb","native":"\uD83D\uDC50\uD83C\uDFFB"},{"unified":"1f450-1f3fc","native":"\uD83D\uDC50\uD83C\uDFFC"},{"unified":"1f450-1f3fd","native":"\uD83D\uDC50\uD83C\uDFFD"},{"unified":"1f450-1f3fe","native":"\uD83D\uDC50\uD83C\uDFFE"},{"unified":"1f450-1f3ff","native":"\uD83D\uDC50\uD83C\uDFFF"}],"version":1},"palms_up_together":{"id":"palms_up_together","name":"Palms Up Together","keywords":["hands","gesture","cupped","prayer"],"skins":[{"unified":"1f932","native":"\uD83E\uDD32"},{"unified":"1f932-1f3fb","native":"\uD83E\uDD32\uD83C\uDFFB"},{"unified":"1f932-1f3fc","native":"\uD83E\uDD32\uD83C\uDFFC"},{"unified":"1f932-1f3fd","native":"\uD83E\uDD32\uD83C\uDFFD"},{"unified":"1f932-1f3fe","native":"\uD83E\uDD32\uD83C\uDFFE"},{"unified":"1f932-1f3ff","native":"\uD83E\uDD32\uD83C\uDFFF"}],"version":5},"handshake":{"id":"handshake","name":"Handshake","keywords":["agreement","shake"],"skins":[{"unified":"1f91d","native":"\uD83E\uDD1D"},{"unified":"1f91d-1f3fb","native":"\uD83E\uDD1D\uD83C\uDFFB"},{"unified":"1f91d-1f3fc","native":"\uD83E\uDD1D\uD83C\uDFFC"},{"unified":"1f91d-1f3fd","native":"\uD83E\uDD1D\uD83C\uDFFD"},{"unified":"1f91d-1f3fe","native":"\uD83E\uDD1D\uD83C\uDFFE"},{"unified":"1f91d-1f3ff","native":"\uD83E\uDD1D\uD83C\uDFFF"}],"version":3},"pray":{"id":"pray","name":"Folded Hands","keywords":["pray","please","hope","wish","namaste","highfive","high","five","thank","you","thanks","appreciate"],"skins":[{"unified":"1f64f","native":"\uD83D\uDE4F"},{"unified":"1f64f-1f3fb","native":"\uD83D\uDE4F\uD83C\uDFFB"},{"unified":"1f64f-1f3fc","native":"\uD83D\uDE4F\uD83C\uDFFC"},{"unified":"1f64f-1f3fd","native":"\uD83D\uDE4F\uD83C\uDFFD"},{"unified":"1f64f-1f3fe","native":"\uD83D\uDE4F\uD83C\uDFFE"},{"unified":"1f64f-1f3ff","native":"\uD83D\uDE4F\uD83C\uDFFF"}],"version":1},"writing_hand":{"id":"writing_hand","name":"Writing Hand","keywords":["lower","left","ballpoint","pen","stationery","write","compose"],"skins":[{"unified":"270d-fe0f","native":"\u270D\uFE0F"},{"unified":"270d-1f3fb","native":"\u270D\uD83C\uDFFB"},{"unified":"270d-1f3fc","native":"\u270D\uD83C\uDFFC"},{"unified":"270d-1f3fd","native":"\u270D\uD83C\uDFFD"},{"unified":"270d-1f3fe","native":"\u270D\uD83C\uDFFE"},{"unified":"270d-1f3ff","native":"\u270D\uD83C\uDFFF"}],"version":1},"nail_care":{"id":"nail_care","name":"Nail Polish","keywords":["care","beauty","manicure","finger","fashion"],"skins":[{"unified":"1f485","native":"\uD83D\uDC85"},{"unified":"1f485-1f3fb","native":"\uD83D\uDC85\uD83C\uDFFB"},{"unified":"1f485-1f3fc","native":"\uD83D\uDC85\uD83C\uDFFC"},{"unified":"1f485-1f3fd","native":"\uD83D\uDC85\uD83C\uDFFD"},{"unified":"1f485-1f3fe","native":"\uD83D\uDC85\uD83C\uDFFE"},{"unified":"1f485-1f3ff","native":"\uD83D\uDC85\uD83C\uDFFF"}],"version":1},"selfie":{"id":"selfie","name":"Selfie","keywords":["camera","phone"],"skins":[{"unified":"1f933","native":"\uD83E\uDD33"},{"unified":"1f933-1f3fb","native":"\uD83E\uDD33\uD83C\uDFFB"},{"unified":"1f933-1f3fc","native":"\uD83E\uDD33\uD83C\uDFFC"},{"unified":"1f933-1f3fd","native":"\uD83E\uDD33\uD83C\uDFFD"},{"unified":"1f933-1f3fe","native":"\uD83E\uDD33\uD83C\uDFFE"},{"unified":"1f933-1f3ff","native":"\uD83E\uDD33\uD83C\uDFFF"}],"version":3},"muscle":{"id":"muscle","name":"Flexed Biceps","keywords":["muscle","arm","flex","hand","summer","strong"],"skins":[{"unified":"1f4aa","native":"\uD83D\uDCAA"},{"unified":"1f4aa-1f3fb","native":"\uD83D\uDCAA\uD83C\uDFFB"},{"unified":"1f4aa-1f3fc","native":"\uD83D\uDCAA\uD83C\uDFFC"},{"unified":"1f4aa-1f3fd","native":"\uD83D\uDCAA\uD83C\uDFFD"},{"unified":"1f4aa-1f3fe","native":"\uD83D\uDCAA\uD83C\uDFFE"},{"unified":"1f4aa-1f3ff","native":"\uD83D\uDCAA\uD83C\uDFFF"}],"version":1},"mechanical_arm":{"id":"mechanical_arm","name":"Mechanical Arm","keywords":["accessibility"],"skins":[{"unified":"1f9be","native":"\uD83E\uDDBE"}],"version":12},"mechanical_leg":{"id":"mechanical_leg","name":"Mechanical Leg","keywords":["accessibility"],"skins":[{"unified":"1f9bf","native":"\uD83E\uDDBF"}],"version":12},"leg":{"id":"leg","name":"Leg","keywords":["kick","limb"],"skins":[{"unified":"1f9b5","native":"\uD83E\uDDB5"},{"unified":"1f9b5-1f3fb","native":"\uD83E\uDDB5\uD83C\uDFFB"},{"unified":"1f9b5-1f3fc","native":"\uD83E\uDDB5\uD83C\uDFFC"},{"unified":"1f9b5-1f3fd","native":"\uD83E\uDDB5\uD83C\uDFFD"},{"unified":"1f9b5-1f3fe","native":"\uD83E\uDDB5\uD83C\uDFFE"},{"unified":"1f9b5-1f3ff","native":"\uD83E\uDDB5\uD83C\uDFFF"}],"version":11},"foot":{"id":"foot","name":"Foot","keywords":["kick","stomp"],"skins":[{"unified":"1f9b6","native":"\uD83E\uDDB6"},{"unified":"1f9b6-1f3fb","native":"\uD83E\uDDB6\uD83C\uDFFB"},{"unified":"1f9b6-1f3fc","native":"\uD83E\uDDB6\uD83C\uDFFC"},{"unified":"1f9b6-1f3fd","native":"\uD83E\uDDB6\uD83C\uDFFD"},{"unified":"1f9b6-1f3fe","native":"\uD83E\uDDB6\uD83C\uDFFE"},{"unified":"1f9b6-1f3ff","native":"\uD83E\uDDB6\uD83C\uDFFF"}],"version":11},"ear":{"id":"ear","name":"Ear","keywords":["face","hear","sound","listen"],"skins":[{"unified":"1f442","native":"\uD83D\uDC42"},{"unified":"1f442-1f3fb","native":"\uD83D\uDC42\uD83C\uDFFB"},{"unified":"1f442-1f3fc","native":"\uD83D\uDC42\uD83C\uDFFC"},{"unified":"1f442-1f3fd","native":"\uD83D\uDC42\uD83C\uDFFD"},{"unified":"1f442-1f3fe","native":"\uD83D\uDC42\uD83C\uDFFE"},{"unified":"1f442-1f3ff","native":"\uD83D\uDC42\uD83C\uDFFF"}],"version":1},"ear_with_hearing_aid":{"id":"ear_with_hearing_aid","name":"Ear with Hearing Aid","keywords":["accessibility"],"skins":[{"unified":"1f9bb","native":"\uD83E\uDDBB"},{"unified":"1f9bb-1f3fb","native":"\uD83E\uDDBB\uD83C\uDFFB"},{"unified":"1f9bb-1f3fc","native":"\uD83E\uDDBB\uD83C\uDFFC"},{"unified":"1f9bb-1f3fd","native":"\uD83E\uDDBB\uD83C\uDFFD"},{"unified":"1f9bb-1f3fe","native":"\uD83E\uDDBB\uD83C\uDFFE"},{"unified":"1f9bb-1f3ff","native":"\uD83E\uDDBB\uD83C\uDFFF"}],"version":12},"nose":{"id":"nose","name":"Nose","keywords":["smell","sniff"],"skins":[{"unified":"1f443","native":"\uD83D\uDC43"},{"unified":"1f443-1f3fb","native":"\uD83D\uDC43\uD83C\uDFFB"},{"unified":"1f443-1f3fc","native":"\uD83D\uDC43\uD83C\uDFFC"},{"unified":"1f443-1f3fd","native":"\uD83D\uDC43\uD83C\uDFFD"},{"unified":"1f443-1f3fe","native":"\uD83D\uDC43\uD83C\uDFFE"},{"unified":"1f443-1f3ff","native":"\uD83D\uDC43\uD83C\uDFFF"}],"version":1},"brain":{"id":"brain","name":"Brain","keywords":["smart","intelligent"],"skins":[{"unified":"1f9e0","native":"\uD83E\uDDE0"}],"version":5},"anatomical_heart":{"id":"anatomical_heart","name":"Anatomical Heart","keywords":["health","heartbeat"],"skins":[{"unified":"1fac0","native":"\uD83E\uDEC0"}],"version":13},"lungs":{"id":"lungs","name":"Lungs","keywords":["breathe"],"skins":[{"unified":"1fac1","native":"\uD83E\uDEC1"}],"version":13},"tooth":{"id":"tooth","name":"Tooth","keywords":["teeth","dentist"],"skins":[{"unified":"1f9b7","native":"\uD83E\uDDB7"}],"version":11},"bone":{"id":"bone","name":"Bone","keywords":["skeleton"],"skins":[{"unified":"1f9b4","native":"\uD83E\uDDB4"}],"version":11},"eyes":{"id":"eyes","name":"Eyes","keywords":["look","watch","stalk","peek","see"],"skins":[{"unified":"1f440","native":"\uD83D\uDC40"}],"version":1},"eye":{"id":"eye","name":"Eye","keywords":["face","look","see","watch","stare"],"skins":[{"unified":"1f441-fe0f","native":"\uD83D\uDC41\uFE0F"}],"version":1},"tongue":{"id":"tongue","name":"Tongue","keywords":["mouth","playful"],"skins":[{"unified":"1f445","native":"\uD83D\uDC45"}],"version":1},"lips":{"id":"lips","name":"Mouth","keywords":["lips","kiss"],"skins":[{"unified":"1f444","native":"\uD83D\uDC44"}],"version":1},"biting_lip":{"id":"biting_lip","name":"Biting Lip","keywords":["flirt","sexy","pain","worry"],"skins":[{"unified":"1fae6","native":"\uD83E\uDEE6"}],"version":14},"baby":{"id":"baby","name":"Baby","keywords":["child","boy","girl","toddler"],"skins":[{"unified":"1f476","native":"\uD83D\uDC76"},{"unified":"1f476-1f3fb","native":"\uD83D\uDC76\uD83C\uDFFB"},{"unified":"1f476-1f3fc","native":"\uD83D\uDC76\uD83C\uDFFC"},{"unified":"1f476-1f3fd","native":"\uD83D\uDC76\uD83C\uDFFD"},{"unified":"1f476-1f3fe","native":"\uD83D\uDC76\uD83C\uDFFE"},{"unified":"1f476-1f3ff","native":"\uD83D\uDC76\uD83C\uDFFF"}],"version":1},"child":{"id":"child","name":"Child","keywords":["gender","neutral","young"],"skins":[{"unified":"1f9d2","native":"\uD83E\uDDD2"},{"unified":"1f9d2-1f3fb","native":"\uD83E\uDDD2\uD83C\uDFFB"},{"unified":"1f9d2-1f3fc","native":"\uD83E\uDDD2\uD83C\uDFFC"},{"unified":"1f9d2-1f3fd","native":"\uD83E\uDDD2\uD83C\uDFFD"},{"unified":"1f9d2-1f3fe","native":"\uD83E\uDDD2\uD83C\uDFFE"},{"unified":"1f9d2-1f3ff","native":"\uD83E\uDDD2\uD83C\uDFFF"}],"version":5},"boy":{"id":"boy","name":"Boy","keywords":["man","male","guy","teenager"],"skins":[{"unified":"1f466","native":"\uD83D\uDC66"},{"unified":"1f466-1f3fb","native":"\uD83D\uDC66\uD83C\uDFFB"},{"unified":"1f466-1f3fc","native":"\uD83D\uDC66\uD83C\uDFFC"},{"unified":"1f466-1f3fd","native":"\uD83D\uDC66\uD83C\uDFFD"},{"unified":"1f466-1f3fe","native":"\uD83D\uDC66\uD83C\uDFFE"},{"unified":"1f466-1f3ff","native":"\uD83D\uDC66\uD83C\uDFFF"}],"version":1},"girl":{"id":"girl","name":"Girl","keywords":["female","woman","teenager"],"skins":[{"unified":"1f467","native":"\uD83D\uDC67"},{"unified":"1f467-1f3fb","native":"\uD83D\uDC67\uD83C\uDFFB"},{"unified":"1f467-1f3fc","native":"\uD83D\uDC67\uD83C\uDFFC"},{"unified":"1f467-1f3fd","native":"\uD83D\uDC67\uD83C\uDFFD"},{"unified":"1f467-1f3fe","native":"\uD83D\uDC67\uD83C\uDFFE"},{"unified":"1f467-1f3ff","native":"\uD83D\uDC67\uD83C\uDFFF"}],"version":1},"adult":{"id":"adult","name":"Adult","keywords":["person","gender","neutral"],"skins":[{"unified":"1f9d1","native":"\uD83E\uDDD1"},{"unified":"1f9d1-1f3fb","native":"\uD83E\uDDD1\uD83C\uDFFB"},{"unified":"1f9d1-1f3fc","native":"\uD83E\uDDD1\uD83C\uDFFC"},{"unified":"1f9d1-1f3fd","native":"\uD83E\uDDD1\uD83C\uDFFD"},{"unified":"1f9d1-1f3fe","native":"\uD83E\uDDD1\uD83C\uDFFE"},{"unified":"1f9d1-1f3ff","native":"\uD83E\uDDD1\uD83C\uDFFF"}],"version":5},"person_with_blond_hair":{"id":"person_with_blond_hair","name":"Person Blond Hair","keywords":["with","hairstyle"],"skins":[{"unified":"1f471","native":"\uD83D\uDC71"},{"unified":"1f471-1f3fb","native":"\uD83D\uDC71\uD83C\uDFFB"},{"unified":"1f471-1f3fc","native":"\uD83D\uDC71\uD83C\uDFFC"},{"unified":"1f471-1f3fd","native":"\uD83D\uDC71\uD83C\uDFFD"},{"unified":"1f471-1f3fe","native":"\uD83D\uDC71\uD83C\uDFFE"},{"unified":"1f471-1f3ff","native":"\uD83D\uDC71\uD83C\uDFFF"}],"version":1},"man":{"id":"man","name":"Man","keywords":["mustache","father","dad","guy","classy","sir","moustache"],"skins":[{"unified":"1f468","native":"\uD83D\uDC68"},{"unified":"1f468-1f3fb","native":"\uD83D\uDC68\uD83C\uDFFB"},{"unified":"1f468-1f3fc","native":"\uD83D\uDC68\uD83C\uDFFC"},{"unified":"1f468-1f3fd","native":"\uD83D\uDC68\uD83C\uDFFD"},{"unified":"1f468-1f3fe","native":"\uD83D\uDC68\uD83C\uDFFE"},{"unified":"1f468-1f3ff","native":"\uD83D\uDC68\uD83C\uDFFF"}],"version":1},"bearded_person":{"id":"bearded_person","name":"Person Beard","keywords":["bearded","man","bewhiskered"],"skins":[{"unified":"1f9d4","native":"\uD83E\uDDD4"},{"unified":"1f9d4-1f3fb","native":"\uD83E\uDDD4\uD83C\uDFFB"},{"unified":"1f9d4-1f3fc","native":"\uD83E\uDDD4\uD83C\uDFFC"},{"unified":"1f9d4-1f3fd","native":"\uD83E\uDDD4\uD83C\uDFFD"},{"unified":"1f9d4-1f3fe","native":"\uD83E\uDDD4\uD83C\uDFFE"},{"unified":"1f9d4-1f3ff","native":"\uD83E\uDDD4\uD83C\uDFFF"}],"version":5},"man_with_beard":{"id":"man_with_beard","name":"Man: Beard","keywords":["man","with","facial","hair"],"skins":[{"unified":"1f9d4-200d-2642-fe0f","native":"\uD83E\uDDD4\u200D\u2642\uFE0F"},{"unified":"1f9d4-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9d4-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9d4-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9d4-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9d4-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":13.1},"woman_with_beard":{"id":"woman_with_beard","name":"Woman: Beard","keywords":["woman","with","facial","hair"],"skins":[{"unified":"1f9d4-200d-2640-fe0f","native":"\uD83E\uDDD4\u200D\u2640\uFE0F"},{"unified":"1f9d4-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9d4-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9d4-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9d4-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9d4-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDD4\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":13.1},"red_haired_man":{"id":"red_haired_man","name":"Man: Red Hair","keywords":["haired","man","hairstyle"],"skins":[{"unified":"1f468-200d-1f9b0","native":"\uD83D\uDC68\u200D\uD83E\uDDB0"},{"unified":"1f468-1f3fb-200d-1f9b0","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB0"},{"unified":"1f468-1f3fc-200d-1f9b0","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB0"},{"unified":"1f468-1f3fd-200d-1f9b0","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB0"},{"unified":"1f468-1f3fe-200d-1f9b0","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB0"},{"unified":"1f468-1f3ff-200d-1f9b0","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB0"}],"version":11},"curly_haired_man":{"id":"curly_haired_man","name":"Man: Curly Hair","keywords":["haired","man","hairstyle"],"skins":[{"unified":"1f468-200d-1f9b1","native":"\uD83D\uDC68\u200D\uD83E\uDDB1"},{"unified":"1f468-1f3fb-200d-1f9b1","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB1"},{"unified":"1f468-1f3fc-200d-1f9b1","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB1"},{"unified":"1f468-1f3fd-200d-1f9b1","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB1"},{"unified":"1f468-1f3fe-200d-1f9b1","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB1"},{"unified":"1f468-1f3ff-200d-1f9b1","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB1"}],"version":11},"white_haired_man":{"id":"white_haired_man","name":"Man: White Hair","keywords":["haired","man","old","elder"],"skins":[{"unified":"1f468-200d-1f9b3","native":"\uD83D\uDC68\u200D\uD83E\uDDB3"},{"unified":"1f468-1f3fb-200d-1f9b3","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB3"},{"unified":"1f468-1f3fc-200d-1f9b3","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB3"},{"unified":"1f468-1f3fd-200d-1f9b3","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB3"},{"unified":"1f468-1f3fe-200d-1f9b3","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB3"},{"unified":"1f468-1f3ff-200d-1f9b3","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB3"}],"version":11},"bald_man":{"id":"bald_man","name":"Man: Bald","keywords":["man","hairless"],"skins":[{"unified":"1f468-200d-1f9b2","native":"\uD83D\uDC68\u200D\uD83E\uDDB2"},{"unified":"1f468-1f3fb-200d-1f9b2","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB2"},{"unified":"1f468-1f3fc-200d-1f9b2","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB2"},{"unified":"1f468-1f3fd-200d-1f9b2","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB2"},{"unified":"1f468-1f3fe-200d-1f9b2","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB2"},{"unified":"1f468-1f3ff-200d-1f9b2","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB2"}],"version":11},"woman":{"id":"woman","name":"Woman","keywords":["female","girls","lady"],"skins":[{"unified":"1f469","native":"\uD83D\uDC69"},{"unified":"1f469-1f3fb","native":"\uD83D\uDC69\uD83C\uDFFB"},{"unified":"1f469-1f3fc","native":"\uD83D\uDC69\uD83C\uDFFC"},{"unified":"1f469-1f3fd","native":"\uD83D\uDC69\uD83C\uDFFD"},{"unified":"1f469-1f3fe","native":"\uD83D\uDC69\uD83C\uDFFE"},{"unified":"1f469-1f3ff","native":"\uD83D\uDC69\uD83C\uDFFF"}],"version":1},"red_haired_woman":{"id":"red_haired_woman","name":"Woman: Red Hair","keywords":["haired","woman","hairstyle"],"skins":[{"unified":"1f469-200d-1f9b0","native":"\uD83D\uDC69\u200D\uD83E\uDDB0"},{"unified":"1f469-1f3fb-200d-1f9b0","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB0"},{"unified":"1f469-1f3fc-200d-1f9b0","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB0"},{"unified":"1f469-1f3fd-200d-1f9b0","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB0"},{"unified":"1f469-1f3fe-200d-1f9b0","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB0"},{"unified":"1f469-1f3ff-200d-1f9b0","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB0"}],"version":11},"red_haired_person":{"id":"red_haired_person","name":"Person: Red Hair","keywords":["haired","person","hairstyle"],"skins":[{"unified":"1f9d1-200d-1f9b0","native":"\uD83E\uDDD1\u200D\uD83E\uDDB0"},{"unified":"1f9d1-1f3fb-200d-1f9b0","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB0"},{"unified":"1f9d1-1f3fc-200d-1f9b0","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB0"},{"unified":"1f9d1-1f3fd-200d-1f9b0","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB0"},{"unified":"1f9d1-1f3fe-200d-1f9b0","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB0"},{"unified":"1f9d1-1f3ff-200d-1f9b0","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB0"}],"version":12.1},"curly_haired_woman":{"id":"curly_haired_woman","name":"Woman: Curly Hair","keywords":["haired","woman","hairstyle"],"skins":[{"unified":"1f469-200d-1f9b1","native":"\uD83D\uDC69\u200D\uD83E\uDDB1"},{"unified":"1f469-1f3fb-200d-1f9b1","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB1"},{"unified":"1f469-1f3fc-200d-1f9b1","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB1"},{"unified":"1f469-1f3fd-200d-1f9b1","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB1"},{"unified":"1f469-1f3fe-200d-1f9b1","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB1"},{"unified":"1f469-1f3ff-200d-1f9b1","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB1"}],"version":11},"curly_haired_person":{"id":"curly_haired_person","name":"Person: Curly Hair","keywords":["haired","person","hairstyle"],"skins":[{"unified":"1f9d1-200d-1f9b1","native":"\uD83E\uDDD1\u200D\uD83E\uDDB1"},{"unified":"1f9d1-1f3fb-200d-1f9b1","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB1"},{"unified":"1f9d1-1f3fc-200d-1f9b1","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB1"},{"unified":"1f9d1-1f3fd-200d-1f9b1","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB1"},{"unified":"1f9d1-1f3fe-200d-1f9b1","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB1"},{"unified":"1f9d1-1f3ff-200d-1f9b1","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB1"}],"version":12.1},"white_haired_woman":{"id":"white_haired_woman","name":"Woman: White Hair","keywords":["haired","woman","old","elder"],"skins":[{"unified":"1f469-200d-1f9b3","native":"\uD83D\uDC69\u200D\uD83E\uDDB3"},{"unified":"1f469-1f3fb-200d-1f9b3","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB3"},{"unified":"1f469-1f3fc-200d-1f9b3","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB3"},{"unified":"1f469-1f3fd-200d-1f9b3","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB3"},{"unified":"1f469-1f3fe-200d-1f9b3","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB3"},{"unified":"1f469-1f3ff-200d-1f9b3","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB3"}],"version":11},"white_haired_person":{"id":"white_haired_person","name":"Person: White Hair","keywords":["haired","person","elder","old"],"skins":[{"unified":"1f9d1-200d-1f9b3","native":"\uD83E\uDDD1\u200D\uD83E\uDDB3"},{"unified":"1f9d1-1f3fb-200d-1f9b3","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB3"},{"unified":"1f9d1-1f3fc-200d-1f9b3","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB3"},{"unified":"1f9d1-1f3fd-200d-1f9b3","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB3"},{"unified":"1f9d1-1f3fe-200d-1f9b3","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB3"},{"unified":"1f9d1-1f3ff-200d-1f9b3","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB3"}],"version":12.1},"bald_woman":{"id":"bald_woman","name":"Woman: Bald","keywords":["woman","hairless"],"skins":[{"unified":"1f469-200d-1f9b2","native":"\uD83D\uDC69\u200D\uD83E\uDDB2"},{"unified":"1f469-1f3fb-200d-1f9b2","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB2"},{"unified":"1f469-1f3fc-200d-1f9b2","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB2"},{"unified":"1f469-1f3fd-200d-1f9b2","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB2"},{"unified":"1f469-1f3fe-200d-1f9b2","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB2"},{"unified":"1f469-1f3ff-200d-1f9b2","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB2"}],"version":11},"bald_person":{"id":"bald_person","name":"Person: Bald","keywords":["person","hairless"],"skins":[{"unified":"1f9d1-200d-1f9b2","native":"\uD83E\uDDD1\u200D\uD83E\uDDB2"},{"unified":"1f9d1-1f3fb-200d-1f9b2","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB2"},{"unified":"1f9d1-1f3fc-200d-1f9b2","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB2"},{"unified":"1f9d1-1f3fd-200d-1f9b2","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB2"},{"unified":"1f9d1-1f3fe-200d-1f9b2","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB2"},{"unified":"1f9d1-1f3ff-200d-1f9b2","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB2"}],"version":12.1},"blond-haired-woman":{"id":"blond-haired-woman","name":"Woman: Blond Hair","keywords":["haired-woman","woman","female","girl","blonde","person"],"skins":[{"unified":"1f471-200d-2640-fe0f","native":"\uD83D\uDC71\u200D\u2640\uFE0F"},{"unified":"1f471-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC71\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f471-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC71\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f471-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC71\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f471-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC71\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f471-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC71\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"blond-haired-man":{"id":"blond-haired-man","name":"Man: Blond Hair","keywords":["haired-man","man","male","boy","blonde","guy","person"],"skins":[{"unified":"1f471-200d-2642-fe0f","native":"\uD83D\uDC71\u200D\u2642\uFE0F"},{"unified":"1f471-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC71\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f471-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC71\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f471-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC71\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f471-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC71\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f471-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC71\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"older_adult":{"id":"older_adult","name":"Older Adult","keywords":["person","human","elder","senior","gender","neutral"],"skins":[{"unified":"1f9d3","native":"\uD83E\uDDD3"},{"unified":"1f9d3-1f3fb","native":"\uD83E\uDDD3\uD83C\uDFFB"},{"unified":"1f9d3-1f3fc","native":"\uD83E\uDDD3\uD83C\uDFFC"},{"unified":"1f9d3-1f3fd","native":"\uD83E\uDDD3\uD83C\uDFFD"},{"unified":"1f9d3-1f3fe","native":"\uD83E\uDDD3\uD83C\uDFFE"},{"unified":"1f9d3-1f3ff","native":"\uD83E\uDDD3\uD83C\uDFFF"}],"version":5},"older_man":{"id":"older_man","name":"Old Man","keywords":["older","human","male","men","elder","senior"],"skins":[{"unified":"1f474","native":"\uD83D\uDC74"},{"unified":"1f474-1f3fb","native":"\uD83D\uDC74\uD83C\uDFFB"},{"unified":"1f474-1f3fc","native":"\uD83D\uDC74\uD83C\uDFFC"},{"unified":"1f474-1f3fd","native":"\uD83D\uDC74\uD83C\uDFFD"},{"unified":"1f474-1f3fe","native":"\uD83D\uDC74\uD83C\uDFFE"},{"unified":"1f474-1f3ff","native":"\uD83D\uDC74\uD83C\uDFFF"}],"version":1},"older_woman":{"id":"older_woman","name":"Old Woman","keywords":["older","human","female","women","lady","elder","senior"],"skins":[{"unified":"1f475","native":"\uD83D\uDC75"},{"unified":"1f475-1f3fb","native":"\uD83D\uDC75\uD83C\uDFFB"},{"unified":"1f475-1f3fc","native":"\uD83D\uDC75\uD83C\uDFFC"},{"unified":"1f475-1f3fd","native":"\uD83D\uDC75\uD83C\uDFFD"},{"unified":"1f475-1f3fe","native":"\uD83D\uDC75\uD83C\uDFFE"},{"unified":"1f475-1f3ff","native":"\uD83D\uDC75\uD83C\uDFFF"}],"version":1},"person_frowning":{"id":"person_frowning","name":"Person Frowning","keywords":["worried"],"skins":[{"unified":"1f64d","native":"\uD83D\uDE4D"},{"unified":"1f64d-1f3fb","native":"\uD83D\uDE4D\uD83C\uDFFB"},{"unified":"1f64d-1f3fc","native":"\uD83D\uDE4D\uD83C\uDFFC"},{"unified":"1f64d-1f3fd","native":"\uD83D\uDE4D\uD83C\uDFFD"},{"unified":"1f64d-1f3fe","native":"\uD83D\uDE4D\uD83C\uDFFE"},{"unified":"1f64d-1f3ff","native":"\uD83D\uDE4D\uD83C\uDFFF"}],"version":1},"man-frowning":{"id":"man-frowning","name":"Man Frowning","keywords":["male","boy","sad","depressed","discouraged","unhappy"],"skins":[{"unified":"1f64d-200d-2642-fe0f","native":"\uD83D\uDE4D\u200D\u2642\uFE0F"},{"unified":"1f64d-1f3fb-200d-2642-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f64d-1f3fc-200d-2642-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f64d-1f3fd-200d-2642-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f64d-1f3fe-200d-2642-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f64d-1f3ff-200d-2642-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-frowning":{"id":"woman-frowning","name":"Woman Frowning","keywords":["female","girl","sad","depressed","discouraged","unhappy"],"skins":[{"unified":"1f64d-200d-2640-fe0f","native":"\uD83D\uDE4D\u200D\u2640\uFE0F"},{"unified":"1f64d-1f3fb-200d-2640-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f64d-1f3fc-200d-2640-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f64d-1f3fd-200d-2640-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f64d-1f3fe-200d-2640-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f64d-1f3ff-200d-2640-fe0f","native":"\uD83D\uDE4D\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"person_with_pouting_face":{"id":"person_with_pouting_face","name":"Person Pouting","keywords":["with","face","upset"],"skins":[{"unified":"1f64e","native":"\uD83D\uDE4E"},{"unified":"1f64e-1f3fb","native":"\uD83D\uDE4E\uD83C\uDFFB"},{"unified":"1f64e-1f3fc","native":"\uD83D\uDE4E\uD83C\uDFFC"},{"unified":"1f64e-1f3fd","native":"\uD83D\uDE4E\uD83C\uDFFD"},{"unified":"1f64e-1f3fe","native":"\uD83D\uDE4E\uD83C\uDFFE"},{"unified":"1f64e-1f3ff","native":"\uD83D\uDE4E\uD83C\uDFFF"}],"version":1},"man-pouting":{"id":"man-pouting","name":"Man Pouting","keywords":["male","boy"],"skins":[{"unified":"1f64e-200d-2642-fe0f","native":"\uD83D\uDE4E\u200D\u2642\uFE0F"},{"unified":"1f64e-1f3fb-200d-2642-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f64e-1f3fc-200d-2642-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f64e-1f3fd-200d-2642-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f64e-1f3fe-200d-2642-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f64e-1f3ff-200d-2642-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-pouting":{"id":"woman-pouting","name":"Woman Pouting","keywords":["female","girl"],"skins":[{"unified":"1f64e-200d-2640-fe0f","native":"\uD83D\uDE4E\u200D\u2640\uFE0F"},{"unified":"1f64e-1f3fb-200d-2640-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f64e-1f3fc-200d-2640-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f64e-1f3fd-200d-2640-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f64e-1f3fe-200d-2640-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f64e-1f3ff-200d-2640-fe0f","native":"\uD83D\uDE4E\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"no_good":{"id":"no_good","name":"Person Gesturing No","keywords":["good","decline"],"skins":[{"unified":"1f645","native":"\uD83D\uDE45"},{"unified":"1f645-1f3fb","native":"\uD83D\uDE45\uD83C\uDFFB"},{"unified":"1f645-1f3fc","native":"\uD83D\uDE45\uD83C\uDFFC"},{"unified":"1f645-1f3fd","native":"\uD83D\uDE45\uD83C\uDFFD"},{"unified":"1f645-1f3fe","native":"\uD83D\uDE45\uD83C\uDFFE"},{"unified":"1f645-1f3ff","native":"\uD83D\uDE45\uD83C\uDFFF"}],"version":1},"man-gesturing-no":{"id":"man-gesturing-no","name":"Man Gesturing No","keywords":["gesturing-no","male","boy","nope"],"skins":[{"unified":"1f645-200d-2642-fe0f","native":"\uD83D\uDE45\u200D\u2642\uFE0F"},{"unified":"1f645-1f3fb-200d-2642-fe0f","native":"\uD83D\uDE45\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f645-1f3fc-200d-2642-fe0f","native":"\uD83D\uDE45\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f645-1f3fd-200d-2642-fe0f","native":"\uD83D\uDE45\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f645-1f3fe-200d-2642-fe0f","native":"\uD83D\uDE45\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f645-1f3ff-200d-2642-fe0f","native":"\uD83D\uDE45\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-gesturing-no":{"id":"woman-gesturing-no","name":"Woman Gesturing No","keywords":["gesturing-no","female","girl","nope"],"skins":[{"unified":"1f645-200d-2640-fe0f","native":"\uD83D\uDE45\u200D\u2640\uFE0F"},{"unified":"1f645-1f3fb-200d-2640-fe0f","native":"\uD83D\uDE45\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f645-1f3fc-200d-2640-fe0f","native":"\uD83D\uDE45\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f645-1f3fd-200d-2640-fe0f","native":"\uD83D\uDE45\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f645-1f3fe-200d-2640-fe0f","native":"\uD83D\uDE45\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f645-1f3ff-200d-2640-fe0f","native":"\uD83D\uDE45\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"ok_woman":{"id":"ok_woman","name":"Person Gesturing Ok","keywords":["woman","agree"],"skins":[{"unified":"1f646","native":"\uD83D\uDE46"},{"unified":"1f646-1f3fb","native":"\uD83D\uDE46\uD83C\uDFFB"},{"unified":"1f646-1f3fc","native":"\uD83D\uDE46\uD83C\uDFFC"},{"unified":"1f646-1f3fd","native":"\uD83D\uDE46\uD83C\uDFFD"},{"unified":"1f646-1f3fe","native":"\uD83D\uDE46\uD83C\uDFFE"},{"unified":"1f646-1f3ff","native":"\uD83D\uDE46\uD83C\uDFFF"}],"version":1},"man-gesturing-ok":{"id":"man-gesturing-ok","name":"Man Gesturing Ok","keywords":["gesturing-ok","men","boy","male","blue","human"],"skins":[{"unified":"1f646-200d-2642-fe0f","native":"\uD83D\uDE46\u200D\u2642\uFE0F"},{"unified":"1f646-1f3fb-200d-2642-fe0f","native":"\uD83D\uDE46\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f646-1f3fc-200d-2642-fe0f","native":"\uD83D\uDE46\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f646-1f3fd-200d-2642-fe0f","native":"\uD83D\uDE46\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f646-1f3fe-200d-2642-fe0f","native":"\uD83D\uDE46\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f646-1f3ff-200d-2642-fe0f","native":"\uD83D\uDE46\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-gesturing-ok":{"id":"woman-gesturing-ok","name":"Woman Gesturing Ok","keywords":["gesturing-ok","women","girl","female","pink","human"],"skins":[{"unified":"1f646-200d-2640-fe0f","native":"\uD83D\uDE46\u200D\u2640\uFE0F"},{"unified":"1f646-1f3fb-200d-2640-fe0f","native":"\uD83D\uDE46\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f646-1f3fc-200d-2640-fe0f","native":"\uD83D\uDE46\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f646-1f3fd-200d-2640-fe0f","native":"\uD83D\uDE46\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f646-1f3fe-200d-2640-fe0f","native":"\uD83D\uDE46\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f646-1f3ff-200d-2640-fe0f","native":"\uD83D\uDE46\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"information_desk_person":{"id":"information_desk_person","name":"Person Tipping Hand","keywords":["information","desk"],"skins":[{"unified":"1f481","native":"\uD83D\uDC81"},{"unified":"1f481-1f3fb","native":"\uD83D\uDC81\uD83C\uDFFB"},{"unified":"1f481-1f3fc","native":"\uD83D\uDC81\uD83C\uDFFC"},{"unified":"1f481-1f3fd","native":"\uD83D\uDC81\uD83C\uDFFD"},{"unified":"1f481-1f3fe","native":"\uD83D\uDC81\uD83C\uDFFE"},{"unified":"1f481-1f3ff","native":"\uD83D\uDC81\uD83C\uDFFF"}],"version":1},"man-tipping-hand":{"id":"man-tipping-hand","name":"Man Tipping Hand","keywords":["tipping-hand","male","boy","human","information"],"skins":[{"unified":"1f481-200d-2642-fe0f","native":"\uD83D\uDC81\u200D\u2642\uFE0F"},{"unified":"1f481-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC81\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f481-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC81\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f481-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC81\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f481-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC81\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f481-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC81\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-tipping-hand":{"id":"woman-tipping-hand","name":"Woman Tipping Hand","keywords":["tipping-hand","female","girl","human","information"],"skins":[{"unified":"1f481-200d-2640-fe0f","native":"\uD83D\uDC81\u200D\u2640\uFE0F"},{"unified":"1f481-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC81\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f481-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC81\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f481-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC81\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f481-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC81\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f481-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC81\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"raising_hand":{"id":"raising_hand","name":"Person Raising Hand","keywords":["question"],"skins":[{"unified":"1f64b","native":"\uD83D\uDE4B"},{"unified":"1f64b-1f3fb","native":"\uD83D\uDE4B\uD83C\uDFFB"},{"unified":"1f64b-1f3fc","native":"\uD83D\uDE4B\uD83C\uDFFC"},{"unified":"1f64b-1f3fd","native":"\uD83D\uDE4B\uD83C\uDFFD"},{"unified":"1f64b-1f3fe","native":"\uD83D\uDE4B\uD83C\uDFFE"},{"unified":"1f64b-1f3ff","native":"\uD83D\uDE4B\uD83C\uDFFF"}],"version":1},"man-raising-hand":{"id":"man-raising-hand","name":"Man Raising Hand","keywords":["raising-hand","male","boy"],"skins":[{"unified":"1f64b-200d-2642-fe0f","native":"\uD83D\uDE4B\u200D\u2642\uFE0F"},{"unified":"1f64b-1f3fb-200d-2642-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f64b-1f3fc-200d-2642-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f64b-1f3fd-200d-2642-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f64b-1f3fe-200d-2642-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f64b-1f3ff-200d-2642-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-raising-hand":{"id":"woman-raising-hand","name":"Woman Raising Hand","keywords":["raising-hand","female","girl"],"skins":[{"unified":"1f64b-200d-2640-fe0f","native":"\uD83D\uDE4B\u200D\u2640\uFE0F"},{"unified":"1f64b-1f3fb-200d-2640-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f64b-1f3fc-200d-2640-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f64b-1f3fd-200d-2640-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f64b-1f3fe-200d-2640-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f64b-1f3ff-200d-2640-fe0f","native":"\uD83D\uDE4B\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"deaf_person":{"id":"deaf_person","name":"Deaf Person","keywords":["accessibility"],"skins":[{"unified":"1f9cf","native":"\uD83E\uDDCF"},{"unified":"1f9cf-1f3fb","native":"\uD83E\uDDCF\uD83C\uDFFB"},{"unified":"1f9cf-1f3fc","native":"\uD83E\uDDCF\uD83C\uDFFC"},{"unified":"1f9cf-1f3fd","native":"\uD83E\uDDCF\uD83C\uDFFD"},{"unified":"1f9cf-1f3fe","native":"\uD83E\uDDCF\uD83C\uDFFE"},{"unified":"1f9cf-1f3ff","native":"\uD83E\uDDCF\uD83C\uDFFF"}],"version":12},"deaf_man":{"id":"deaf_man","name":"Deaf Man","keywords":["accessibility"],"skins":[{"unified":"1f9cf-200d-2642-fe0f","native":"\uD83E\uDDCF\u200D\u2642\uFE0F"},{"unified":"1f9cf-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9cf-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9cf-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9cf-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9cf-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":12},"deaf_woman":{"id":"deaf_woman","name":"Deaf Woman","keywords":["accessibility"],"skins":[{"unified":"1f9cf-200d-2640-fe0f","native":"\uD83E\uDDCF\u200D\u2640\uFE0F"},{"unified":"1f9cf-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9cf-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9cf-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9cf-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9cf-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDCF\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":12},"bow":{"id":"bow","name":"Person Bowing","keywords":["bow","respectiful"],"skins":[{"unified":"1f647","native":"\uD83D\uDE47"},{"unified":"1f647-1f3fb","native":"\uD83D\uDE47\uD83C\uDFFB"},{"unified":"1f647-1f3fc","native":"\uD83D\uDE47\uD83C\uDFFC"},{"unified":"1f647-1f3fd","native":"\uD83D\uDE47\uD83C\uDFFD"},{"unified":"1f647-1f3fe","native":"\uD83D\uDE47\uD83C\uDFFE"},{"unified":"1f647-1f3ff","native":"\uD83D\uDE47\uD83C\uDFFF"}],"version":1},"man-bowing":{"id":"man-bowing","name":"Man Bowing","keywords":["male","boy"],"skins":[{"unified":"1f647-200d-2642-fe0f","native":"\uD83D\uDE47\u200D\u2642\uFE0F"},{"unified":"1f647-1f3fb-200d-2642-fe0f","native":"\uD83D\uDE47\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f647-1f3fc-200d-2642-fe0f","native":"\uD83D\uDE47\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f647-1f3fd-200d-2642-fe0f","native":"\uD83D\uDE47\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f647-1f3fe-200d-2642-fe0f","native":"\uD83D\uDE47\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f647-1f3ff-200d-2642-fe0f","native":"\uD83D\uDE47\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-bowing":{"id":"woman-bowing","name":"Woman Bowing","keywords":["female","girl"],"skins":[{"unified":"1f647-200d-2640-fe0f","native":"\uD83D\uDE47\u200D\u2640\uFE0F"},{"unified":"1f647-1f3fb-200d-2640-fe0f","native":"\uD83D\uDE47\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f647-1f3fc-200d-2640-fe0f","native":"\uD83D\uDE47\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f647-1f3fd-200d-2640-fe0f","native":"\uD83D\uDE47\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f647-1f3fe-200d-2640-fe0f","native":"\uD83D\uDE47\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f647-1f3ff-200d-2640-fe0f","native":"\uD83D\uDE47\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"face_palm":{"id":"face_palm","name":"Face Palm","keywords":["person","facepalming","disappointed"],"skins":[{"unified":"1f926","native":"\uD83E\uDD26"},{"unified":"1f926-1f3fb","native":"\uD83E\uDD26\uD83C\uDFFB"},{"unified":"1f926-1f3fc","native":"\uD83E\uDD26\uD83C\uDFFC"},{"unified":"1f926-1f3fd","native":"\uD83E\uDD26\uD83C\uDFFD"},{"unified":"1f926-1f3fe","native":"\uD83E\uDD26\uD83C\uDFFE"},{"unified":"1f926-1f3ff","native":"\uD83E\uDD26\uD83C\uDFFF"}],"version":3},"man-facepalming":{"id":"man-facepalming","name":"Man Facepalming","keywords":["male","boy","disbelief"],"skins":[{"unified":"1f926-200d-2642-fe0f","native":"\uD83E\uDD26\u200D\u2642\uFE0F"},{"unified":"1f926-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD26\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f926-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD26\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f926-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD26\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f926-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD26\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f926-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD26\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-facepalming":{"id":"woman-facepalming","name":"Woman Facepalming","keywords":["female","girl","disbelief"],"skins":[{"unified":"1f926-200d-2640-fe0f","native":"\uD83E\uDD26\u200D\u2640\uFE0F"},{"unified":"1f926-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD26\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f926-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD26\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f926-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD26\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f926-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD26\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f926-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD26\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"shrug":{"id":"shrug","name":"Shrug","keywords":["person","shrugging","regardless"],"skins":[{"unified":"1f937","native":"\uD83E\uDD37"},{"unified":"1f937-1f3fb","native":"\uD83E\uDD37\uD83C\uDFFB"},{"unified":"1f937-1f3fc","native":"\uD83E\uDD37\uD83C\uDFFC"},{"unified":"1f937-1f3fd","native":"\uD83E\uDD37\uD83C\uDFFD"},{"unified":"1f937-1f3fe","native":"\uD83E\uDD37\uD83C\uDFFE"},{"unified":"1f937-1f3ff","native":"\uD83E\uDD37\uD83C\uDFFF"}],"version":3},"man-shrugging":{"id":"man-shrugging","name":"Man Shrugging","keywords":["male","boy","confused","indifferent","doubt"],"skins":[{"unified":"1f937-200d-2642-fe0f","native":"\uD83E\uDD37\u200D\u2642\uFE0F"},{"unified":"1f937-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD37\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f937-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD37\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f937-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD37\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f937-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD37\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f937-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD37\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-shrugging":{"id":"woman-shrugging","name":"Woman Shrugging","keywords":["female","girl","confused","indifferent","doubt"],"skins":[{"unified":"1f937-200d-2640-fe0f","native":"\uD83E\uDD37\u200D\u2640\uFE0F"},{"unified":"1f937-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD37\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f937-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD37\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f937-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD37\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f937-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD37\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f937-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD37\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"health_worker":{"id":"health_worker","name":"Health Worker","keywords":["hospital"],"skins":[{"unified":"1f9d1-200d-2695-fe0f","native":"\uD83E\uDDD1\u200D\u2695\uFE0F"},{"unified":"1f9d1-1f3fb-200d-2695-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\u2695\uFE0F"},{"unified":"1f9d1-1f3fc-200d-2695-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\u2695\uFE0F"},{"unified":"1f9d1-1f3fd-200d-2695-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\u2695\uFE0F"},{"unified":"1f9d1-1f3fe-200d-2695-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\u2695\uFE0F"},{"unified":"1f9d1-1f3ff-200d-2695-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\u2695\uFE0F"}],"version":12.1},"male-doctor":{"id":"male-doctor","name":"Man Health Worker","keywords":["male","doctor","nurse","therapist","healthcare","human"],"skins":[{"unified":"1f468-200d-2695-fe0f","native":"\uD83D\uDC68\u200D\u2695\uFE0F"},{"unified":"1f468-1f3fb-200d-2695-fe0f","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\u2695\uFE0F"},{"unified":"1f468-1f3fc-200d-2695-fe0f","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\u2695\uFE0F"},{"unified":"1f468-1f3fd-200d-2695-fe0f","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\u2695\uFE0F"},{"unified":"1f468-1f3fe-200d-2695-fe0f","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\u2695\uFE0F"},{"unified":"1f468-1f3ff-200d-2695-fe0f","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\u2695\uFE0F"}],"version":4},"female-doctor":{"id":"female-doctor","name":"Woman Health Worker","keywords":["female","doctor","nurse","therapist","healthcare","human"],"skins":[{"unified":"1f469-200d-2695-fe0f","native":"\uD83D\uDC69\u200D\u2695\uFE0F"},{"unified":"1f469-1f3fb-200d-2695-fe0f","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2695\uFE0F"},{"unified":"1f469-1f3fc-200d-2695-fe0f","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2695\uFE0F"},{"unified":"1f469-1f3fd-200d-2695-fe0f","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2695\uFE0F"},{"unified":"1f469-1f3fe-200d-2695-fe0f","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2695\uFE0F"},{"unified":"1f469-1f3ff-200d-2695-fe0f","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2695\uFE0F"}],"version":4},"student":{"id":"student","name":"Student","keywords":["learn"],"skins":[{"unified":"1f9d1-200d-1f393","native":"\uD83E\uDDD1\u200D\uD83C\uDF93"},{"unified":"1f9d1-1f3fb-200d-1f393","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF93"},{"unified":"1f9d1-1f3fc-200d-1f393","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF93"},{"unified":"1f9d1-1f3fd-200d-1f393","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF93"},{"unified":"1f9d1-1f3fe-200d-1f393","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF93"},{"unified":"1f9d1-1f3ff-200d-1f393","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF93"}],"version":12.1},"male-student":{"id":"male-student","name":"Man Student","keywords":["male","graduate","human"],"skins":[{"unified":"1f468-200d-1f393","native":"\uD83D\uDC68\u200D\uD83C\uDF93"},{"unified":"1f468-1f3fb-200d-1f393","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF93"},{"unified":"1f468-1f3fc-200d-1f393","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF93"},{"unified":"1f468-1f3fd-200d-1f393","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF93"},{"unified":"1f468-1f3fe-200d-1f393","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF93"},{"unified":"1f468-1f3ff-200d-1f393","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF93"}],"version":4},"female-student":{"id":"female-student","name":"Woman Student","keywords":["female","graduate","human"],"skins":[{"unified":"1f469-200d-1f393","native":"\uD83D\uDC69\u200D\uD83C\uDF93"},{"unified":"1f469-1f3fb-200d-1f393","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF93"},{"unified":"1f469-1f3fc-200d-1f393","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF93"},{"unified":"1f469-1f3fd-200d-1f393","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF93"},{"unified":"1f469-1f3fe-200d-1f393","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF93"},{"unified":"1f469-1f3ff-200d-1f393","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF93"}],"version":4},"teacher":{"id":"teacher","name":"Teacher","keywords":["professor"],"skins":[{"unified":"1f9d1-200d-1f3eb","native":"\uD83E\uDDD1\u200D\uD83C\uDFEB"},{"unified":"1f9d1-1f3fb-200d-1f3eb","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFEB"},{"unified":"1f9d1-1f3fc-200d-1f3eb","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFEB"},{"unified":"1f9d1-1f3fd-200d-1f3eb","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFEB"},{"unified":"1f9d1-1f3fe-200d-1f3eb","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFEB"},{"unified":"1f9d1-1f3ff-200d-1f3eb","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFEB"}],"version":12.1},"male-teacher":{"id":"male-teacher","name":"Man Teacher","keywords":["male","instructor","professor","human"],"skins":[{"unified":"1f468-200d-1f3eb","native":"\uD83D\uDC68\u200D\uD83C\uDFEB"},{"unified":"1f468-1f3fb-200d-1f3eb","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFEB"},{"unified":"1f468-1f3fc-200d-1f3eb","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFEB"},{"unified":"1f468-1f3fd-200d-1f3eb","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFEB"},{"unified":"1f468-1f3fe-200d-1f3eb","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFEB"},{"unified":"1f468-1f3ff-200d-1f3eb","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFEB"}],"version":4},"female-teacher":{"id":"female-teacher","name":"Woman Teacher","keywords":["female","instructor","professor","human"],"skins":[{"unified":"1f469-200d-1f3eb","native":"\uD83D\uDC69\u200D\uD83C\uDFEB"},{"unified":"1f469-1f3fb-200d-1f3eb","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFEB"},{"unified":"1f469-1f3fc-200d-1f3eb","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFEB"},{"unified":"1f469-1f3fd-200d-1f3eb","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFEB"},{"unified":"1f469-1f3fe-200d-1f3eb","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFEB"},{"unified":"1f469-1f3ff-200d-1f3eb","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFEB"}],"version":4},"judge":{"id":"judge","name":"Judge","keywords":["law"],"skins":[{"unified":"1f9d1-200d-2696-fe0f","native":"\uD83E\uDDD1\u200D\u2696\uFE0F"},{"unified":"1f9d1-1f3fb-200d-2696-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\u2696\uFE0F"},{"unified":"1f9d1-1f3fc-200d-2696-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\u2696\uFE0F"},{"unified":"1f9d1-1f3fd-200d-2696-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\u2696\uFE0F"},{"unified":"1f9d1-1f3fe-200d-2696-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\u2696\uFE0F"},{"unified":"1f9d1-1f3ff-200d-2696-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\u2696\uFE0F"}],"version":12.1},"male-judge":{"id":"male-judge","name":"Man Judge","keywords":["male","justice","court","human"],"skins":[{"unified":"1f468-200d-2696-fe0f","native":"\uD83D\uDC68\u200D\u2696\uFE0F"},{"unified":"1f468-1f3fb-200d-2696-fe0f","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\u2696\uFE0F"},{"unified":"1f468-1f3fc-200d-2696-fe0f","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\u2696\uFE0F"},{"unified":"1f468-1f3fd-200d-2696-fe0f","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\u2696\uFE0F"},{"unified":"1f468-1f3fe-200d-2696-fe0f","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\u2696\uFE0F"},{"unified":"1f468-1f3ff-200d-2696-fe0f","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\u2696\uFE0F"}],"version":4},"female-judge":{"id":"female-judge","name":"Woman Judge","keywords":["female","justice","court","human"],"skins":[{"unified":"1f469-200d-2696-fe0f","native":"\uD83D\uDC69\u200D\u2696\uFE0F"},{"unified":"1f469-1f3fb-200d-2696-fe0f","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2696\uFE0F"},{"unified":"1f469-1f3fc-200d-2696-fe0f","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2696\uFE0F"},{"unified":"1f469-1f3fd-200d-2696-fe0f","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2696\uFE0F"},{"unified":"1f469-1f3fe-200d-2696-fe0f","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2696\uFE0F"},{"unified":"1f469-1f3ff-200d-2696-fe0f","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2696\uFE0F"}],"version":4},"farmer":{"id":"farmer","name":"Farmer","keywords":["crops"],"skins":[{"unified":"1f9d1-200d-1f33e","native":"\uD83E\uDDD1\u200D\uD83C\uDF3E"},{"unified":"1f9d1-1f3fb-200d-1f33e","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF3E"},{"unified":"1f9d1-1f3fc-200d-1f33e","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF3E"},{"unified":"1f9d1-1f3fd-200d-1f33e","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF3E"},{"unified":"1f9d1-1f3fe-200d-1f33e","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF3E"},{"unified":"1f9d1-1f3ff-200d-1f33e","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF3E"}],"version":12.1},"male-farmer":{"id":"male-farmer","name":"Man Farmer","keywords":["male","rancher","gardener","human"],"skins":[{"unified":"1f468-200d-1f33e","native":"\uD83D\uDC68\u200D\uD83C\uDF3E"},{"unified":"1f468-1f3fb-200d-1f33e","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF3E"},{"unified":"1f468-1f3fc-200d-1f33e","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF3E"},{"unified":"1f468-1f3fd-200d-1f33e","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF3E"},{"unified":"1f468-1f3fe-200d-1f33e","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF3E"},{"unified":"1f468-1f3ff-200d-1f33e","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF3E"}],"version":4},"female-farmer":{"id":"female-farmer","name":"Woman Farmer","keywords":["female","rancher","gardener","human"],"skins":[{"unified":"1f469-200d-1f33e","native":"\uD83D\uDC69\u200D\uD83C\uDF3E"},{"unified":"1f469-1f3fb-200d-1f33e","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF3E"},{"unified":"1f469-1f3fc-200d-1f33e","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF3E"},{"unified":"1f469-1f3fd-200d-1f33e","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF3E"},{"unified":"1f469-1f3fe-200d-1f33e","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF3E"},{"unified":"1f469-1f3ff-200d-1f33e","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF3E"}],"version":4},"cook":{"id":"cook","name":"Cook","keywords":["food","kitchen","culinary"],"skins":[{"unified":"1f9d1-200d-1f373","native":"\uD83E\uDDD1\u200D\uD83C\uDF73"},{"unified":"1f9d1-1f3fb-200d-1f373","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF73"},{"unified":"1f9d1-1f3fc-200d-1f373","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF73"},{"unified":"1f9d1-1f3fd-200d-1f373","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF73"},{"unified":"1f9d1-1f3fe-200d-1f373","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF73"},{"unified":"1f9d1-1f3ff-200d-1f373","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF73"}],"version":12.1},"male-cook":{"id":"male-cook","name":"Man Cook","keywords":["male","chef","human"],"skins":[{"unified":"1f468-200d-1f373","native":"\uD83D\uDC68\u200D\uD83C\uDF73"},{"unified":"1f468-1f3fb-200d-1f373","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF73"},{"unified":"1f468-1f3fc-200d-1f373","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF73"},{"unified":"1f468-1f3fd-200d-1f373","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF73"},{"unified":"1f468-1f3fe-200d-1f373","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF73"},{"unified":"1f468-1f3ff-200d-1f373","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF73"}],"version":4},"female-cook":{"id":"female-cook","name":"Woman Cook","keywords":["female","chef","human"],"skins":[{"unified":"1f469-200d-1f373","native":"\uD83D\uDC69\u200D\uD83C\uDF73"},{"unified":"1f469-1f3fb-200d-1f373","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF73"},{"unified":"1f469-1f3fc-200d-1f373","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF73"},{"unified":"1f469-1f3fd-200d-1f373","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF73"},{"unified":"1f469-1f3fe-200d-1f373","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF73"},{"unified":"1f469-1f3ff-200d-1f373","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF73"}],"version":4},"mechanic":{"id":"mechanic","name":"Mechanic","keywords":["worker","technician"],"skins":[{"unified":"1f9d1-200d-1f527","native":"\uD83E\uDDD1\u200D\uD83D\uDD27"},{"unified":"1f9d1-1f3fb-200d-1f527","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDD27"},{"unified":"1f9d1-1f3fc-200d-1f527","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDD27"},{"unified":"1f9d1-1f3fd-200d-1f527","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDD27"},{"unified":"1f9d1-1f3fe-200d-1f527","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDD27"},{"unified":"1f9d1-1f3ff-200d-1f527","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDD27"}],"version":12.1},"male-mechanic":{"id":"male-mechanic","name":"Man Mechanic","keywords":["male","plumber","human","wrench"],"skins":[{"unified":"1f468-200d-1f527","native":"\uD83D\uDC68\u200D\uD83D\uDD27"},{"unified":"1f468-1f3fb-200d-1f527","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD27"},{"unified":"1f468-1f3fc-200d-1f527","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD27"},{"unified":"1f468-1f3fd-200d-1f527","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD27"},{"unified":"1f468-1f3fe-200d-1f527","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD27"},{"unified":"1f468-1f3ff-200d-1f527","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD27"}],"version":4},"female-mechanic":{"id":"female-mechanic","name":"Woman Mechanic","keywords":["female","plumber","human","wrench"],"skins":[{"unified":"1f469-200d-1f527","native":"\uD83D\uDC69\u200D\uD83D\uDD27"},{"unified":"1f469-1f3fb-200d-1f527","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD27"},{"unified":"1f469-1f3fc-200d-1f527","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD27"},{"unified":"1f469-1f3fd-200d-1f527","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD27"},{"unified":"1f469-1f3fe-200d-1f527","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD27"},{"unified":"1f469-1f3ff-200d-1f527","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD27"}],"version":4},"factory_worker":{"id":"factory_worker","name":"Factory Worker","keywords":["labor"],"skins":[{"unified":"1f9d1-200d-1f3ed","native":"\uD83E\uDDD1\u200D\uD83C\uDFED"},{"unified":"1f9d1-1f3fb-200d-1f3ed","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFED"},{"unified":"1f9d1-1f3fc-200d-1f3ed","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFED"},{"unified":"1f9d1-1f3fd-200d-1f3ed","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFED"},{"unified":"1f9d1-1f3fe-200d-1f3ed","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFED"},{"unified":"1f9d1-1f3ff-200d-1f3ed","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFED"}],"version":12.1},"male-factory-worker":{"id":"male-factory-worker","name":"Man Factory Worker","keywords":["male","factory-worker","assembly","industrial","human"],"skins":[{"unified":"1f468-200d-1f3ed","native":"\uD83D\uDC68\u200D\uD83C\uDFED"},{"unified":"1f468-1f3fb-200d-1f3ed","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFED"},{"unified":"1f468-1f3fc-200d-1f3ed","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFED"},{"unified":"1f468-1f3fd-200d-1f3ed","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFED"},{"unified":"1f468-1f3fe-200d-1f3ed","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFED"},{"unified":"1f468-1f3ff-200d-1f3ed","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFED"}],"version":4},"female-factory-worker":{"id":"female-factory-worker","name":"Woman Factory Worker","keywords":["female","factory-worker","assembly","industrial","human"],"skins":[{"unified":"1f469-200d-1f3ed","native":"\uD83D\uDC69\u200D\uD83C\uDFED"},{"unified":"1f469-1f3fb-200d-1f3ed","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFED"},{"unified":"1f469-1f3fc-200d-1f3ed","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFED"},{"unified":"1f469-1f3fd-200d-1f3ed","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFED"},{"unified":"1f469-1f3fe-200d-1f3ed","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFED"},{"unified":"1f469-1f3ff-200d-1f3ed","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFED"}],"version":4},"office_worker":{"id":"office_worker","name":"Office Worker","keywords":["business"],"skins":[{"unified":"1f9d1-200d-1f4bc","native":"\uD83E\uDDD1\u200D\uD83D\uDCBC"},{"unified":"1f9d1-1f3fb-200d-1f4bc","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDCBC"},{"unified":"1f9d1-1f3fc-200d-1f4bc","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDCBC"},{"unified":"1f9d1-1f3fd-200d-1f4bc","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDCBC"},{"unified":"1f9d1-1f3fe-200d-1f4bc","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDCBC"},{"unified":"1f9d1-1f3ff-200d-1f4bc","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDCBC"}],"version":12.1},"male-office-worker":{"id":"male-office-worker","name":"Man Office Worker","keywords":["male","office-worker","business","manager","human"],"skins":[{"unified":"1f468-200d-1f4bc","native":"\uD83D\uDC68\u200D\uD83D\uDCBC"},{"unified":"1f468-1f3fb-200d-1f4bc","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBC"},{"unified":"1f468-1f3fc-200d-1f4bc","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBC"},{"unified":"1f468-1f3fd-200d-1f4bc","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBC"},{"unified":"1f468-1f3fe-200d-1f4bc","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBC"},{"unified":"1f468-1f3ff-200d-1f4bc","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBC"}],"version":4},"female-office-worker":{"id":"female-office-worker","name":"Woman Office Worker","keywords":["female","office-worker","business","manager","human"],"skins":[{"unified":"1f469-200d-1f4bc","native":"\uD83D\uDC69\u200D\uD83D\uDCBC"},{"unified":"1f469-1f3fb-200d-1f4bc","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBC"},{"unified":"1f469-1f3fc-200d-1f4bc","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBC"},{"unified":"1f469-1f3fd-200d-1f4bc","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBC"},{"unified":"1f469-1f3fe-200d-1f4bc","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBC"},{"unified":"1f469-1f3ff-200d-1f4bc","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBC"}],"version":4},"scientist":{"id":"scientist","name":"Scientist","keywords":["chemistry"],"skins":[{"unified":"1f9d1-200d-1f52c","native":"\uD83E\uDDD1\u200D\uD83D\uDD2C"},{"unified":"1f9d1-1f3fb-200d-1f52c","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDD2C"},{"unified":"1f9d1-1f3fc-200d-1f52c","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDD2C"},{"unified":"1f9d1-1f3fd-200d-1f52c","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDD2C"},{"unified":"1f9d1-1f3fe-200d-1f52c","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDD2C"},{"unified":"1f9d1-1f3ff-200d-1f52c","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDD2C"}],"version":12.1},"male-scientist":{"id":"male-scientist","name":"Man Scientist","keywords":["male","biologist","chemist","engineer","physicist","human"],"skins":[{"unified":"1f468-200d-1f52c","native":"\uD83D\uDC68\u200D\uD83D\uDD2C"},{"unified":"1f468-1f3fb-200d-1f52c","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD2C"},{"unified":"1f468-1f3fc-200d-1f52c","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD2C"},{"unified":"1f468-1f3fd-200d-1f52c","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD2C"},{"unified":"1f468-1f3fe-200d-1f52c","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD2C"},{"unified":"1f468-1f3ff-200d-1f52c","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD2C"}],"version":4},"female-scientist":{"id":"female-scientist","name":"Woman Scientist","keywords":["female","biologist","chemist","engineer","physicist","human"],"skins":[{"unified":"1f469-200d-1f52c","native":"\uD83D\uDC69\u200D\uD83D\uDD2C"},{"unified":"1f469-1f3fb-200d-1f52c","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD2C"},{"unified":"1f469-1f3fc-200d-1f52c","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD2C"},{"unified":"1f469-1f3fd-200d-1f52c","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD2C"},{"unified":"1f469-1f3fe-200d-1f52c","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD2C"},{"unified":"1f469-1f3ff-200d-1f52c","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD2C"}],"version":4},"technologist":{"id":"technologist","name":"Technologist","keywords":["computer"],"skins":[{"unified":"1f9d1-200d-1f4bb","native":"\uD83E\uDDD1\u200D\uD83D\uDCBB"},{"unified":"1f9d1-1f3fb-200d-1f4bb","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDCBB"},{"unified":"1f9d1-1f3fc-200d-1f4bb","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDCBB"},{"unified":"1f9d1-1f3fd-200d-1f4bb","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDCBB"},{"unified":"1f9d1-1f3fe-200d-1f4bb","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDCBB"},{"unified":"1f9d1-1f3ff-200d-1f4bb","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDCBB"}],"version":12.1},"male-technologist":{"id":"male-technologist","name":"Man Technologist","keywords":["male","coder","developer","engineer","programmer","software","human","laptop","computer"],"skins":[{"unified":"1f468-200d-1f4bb","native":"\uD83D\uDC68\u200D\uD83D\uDCBB"},{"unified":"1f468-1f3fb-200d-1f4bb","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBB"},{"unified":"1f468-1f3fc-200d-1f4bb","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBB"},{"unified":"1f468-1f3fd-200d-1f4bb","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBB"},{"unified":"1f468-1f3fe-200d-1f4bb","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBB"},{"unified":"1f468-1f3ff-200d-1f4bb","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBB"}],"version":4},"female-technologist":{"id":"female-technologist","name":"Woman Technologist","keywords":["female","coder","developer","engineer","programmer","software","human","laptop","computer"],"skins":[{"unified":"1f469-200d-1f4bb","native":"\uD83D\uDC69\u200D\uD83D\uDCBB"},{"unified":"1f469-1f3fb-200d-1f4bb","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBB"},{"unified":"1f469-1f3fc-200d-1f4bb","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBB"},{"unified":"1f469-1f3fd-200d-1f4bb","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBB"},{"unified":"1f469-1f3fe-200d-1f4bb","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBB"},{"unified":"1f469-1f3ff-200d-1f4bb","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBB"}],"version":4},"singer":{"id":"singer","name":"Singer","keywords":["song","artist","performer"],"skins":[{"unified":"1f9d1-200d-1f3a4","native":"\uD83E\uDDD1\u200D\uD83C\uDFA4"},{"unified":"1f9d1-1f3fb-200d-1f3a4","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFA4"},{"unified":"1f9d1-1f3fc-200d-1f3a4","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFA4"},{"unified":"1f9d1-1f3fd-200d-1f3a4","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFA4"},{"unified":"1f9d1-1f3fe-200d-1f3a4","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFA4"},{"unified":"1f9d1-1f3ff-200d-1f3a4","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFA4"}],"version":12.1},"male-singer":{"id":"male-singer","name":"Man Singer","keywords":["male","rockstar","entertainer","human"],"skins":[{"unified":"1f468-200d-1f3a4","native":"\uD83D\uDC68\u200D\uD83C\uDFA4"},{"unified":"1f468-1f3fb-200d-1f3a4","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA4"},{"unified":"1f468-1f3fc-200d-1f3a4","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA4"},{"unified":"1f468-1f3fd-200d-1f3a4","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA4"},{"unified":"1f468-1f3fe-200d-1f3a4","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA4"},{"unified":"1f468-1f3ff-200d-1f3a4","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA4"}],"version":4},"female-singer":{"id":"female-singer","name":"Woman Singer","keywords":["female","rockstar","entertainer","human"],"skins":[{"unified":"1f469-200d-1f3a4","native":"\uD83D\uDC69\u200D\uD83C\uDFA4"},{"unified":"1f469-1f3fb-200d-1f3a4","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA4"},{"unified":"1f469-1f3fc-200d-1f3a4","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA4"},{"unified":"1f469-1f3fd-200d-1f3a4","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA4"},{"unified":"1f469-1f3fe-200d-1f3a4","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA4"},{"unified":"1f469-1f3ff-200d-1f3a4","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA4"}],"version":4},"artist":{"id":"artist","name":"Artist","keywords":["painting","draw","creativity"],"skins":[{"unified":"1f9d1-200d-1f3a8","native":"\uD83E\uDDD1\u200D\uD83C\uDFA8"},{"unified":"1f9d1-1f3fb-200d-1f3a8","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFA8"},{"unified":"1f9d1-1f3fc-200d-1f3a8","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFA8"},{"unified":"1f9d1-1f3fd-200d-1f3a8","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFA8"},{"unified":"1f9d1-1f3fe-200d-1f3a8","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFA8"},{"unified":"1f9d1-1f3ff-200d-1f3a8","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFA8"}],"version":12.1},"male-artist":{"id":"male-artist","name":"Man Artist","keywords":["male","painter","human"],"skins":[{"unified":"1f468-200d-1f3a8","native":"\uD83D\uDC68\u200D\uD83C\uDFA8"},{"unified":"1f468-1f3fb-200d-1f3a8","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA8"},{"unified":"1f468-1f3fc-200d-1f3a8","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA8"},{"unified":"1f468-1f3fd-200d-1f3a8","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA8"},{"unified":"1f468-1f3fe-200d-1f3a8","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA8"},{"unified":"1f468-1f3ff-200d-1f3a8","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA8"}],"version":4},"female-artist":{"id":"female-artist","name":"Woman Artist","keywords":["female","painter","human"],"skins":[{"unified":"1f469-200d-1f3a8","native":"\uD83D\uDC69\u200D\uD83C\uDFA8"},{"unified":"1f469-1f3fb-200d-1f3a8","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA8"},{"unified":"1f469-1f3fc-200d-1f3a8","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA8"},{"unified":"1f469-1f3fd-200d-1f3a8","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA8"},{"unified":"1f469-1f3fe-200d-1f3a8","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA8"},{"unified":"1f469-1f3ff-200d-1f3a8","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA8"}],"version":4},"pilot":{"id":"pilot","name":"Pilot","keywords":["fly","plane","airplane"],"skins":[{"unified":"1f9d1-200d-2708-fe0f","native":"\uD83E\uDDD1\u200D\u2708\uFE0F"},{"unified":"1f9d1-1f3fb-200d-2708-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\u2708\uFE0F"},{"unified":"1f9d1-1f3fc-200d-2708-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\u2708\uFE0F"},{"unified":"1f9d1-1f3fd-200d-2708-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\u2708\uFE0F"},{"unified":"1f9d1-1f3fe-200d-2708-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\u2708\uFE0F"},{"unified":"1f9d1-1f3ff-200d-2708-fe0f","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\u2708\uFE0F"}],"version":12.1},"male-pilot":{"id":"male-pilot","name":"Man Pilot","keywords":["male","aviator","plane","human"],"skins":[{"unified":"1f468-200d-2708-fe0f","native":"\uD83D\uDC68\u200D\u2708\uFE0F"},{"unified":"1f468-1f3fb-200d-2708-fe0f","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\u2708\uFE0F"},{"unified":"1f468-1f3fc-200d-2708-fe0f","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\u2708\uFE0F"},{"unified":"1f468-1f3fd-200d-2708-fe0f","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\u2708\uFE0F"},{"unified":"1f468-1f3fe-200d-2708-fe0f","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\u2708\uFE0F"},{"unified":"1f468-1f3ff-200d-2708-fe0f","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\u2708\uFE0F"}],"version":4},"female-pilot":{"id":"female-pilot","name":"Woman Pilot","keywords":["female","aviator","plane","human"],"skins":[{"unified":"1f469-200d-2708-fe0f","native":"\uD83D\uDC69\u200D\u2708\uFE0F"},{"unified":"1f469-1f3fb-200d-2708-fe0f","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2708\uFE0F"},{"unified":"1f469-1f3fc-200d-2708-fe0f","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2708\uFE0F"},{"unified":"1f469-1f3fd-200d-2708-fe0f","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2708\uFE0F"},{"unified":"1f469-1f3fe-200d-2708-fe0f","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2708\uFE0F"},{"unified":"1f469-1f3ff-200d-2708-fe0f","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2708\uFE0F"}],"version":4},"astronaut":{"id":"astronaut","name":"Astronaut","keywords":["outerspace"],"skins":[{"unified":"1f9d1-200d-1f680","native":"\uD83E\uDDD1\u200D\uD83D\uDE80"},{"unified":"1f9d1-1f3fb-200d-1f680","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDE80"},{"unified":"1f9d1-1f3fc-200d-1f680","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDE80"},{"unified":"1f9d1-1f3fd-200d-1f680","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDE80"},{"unified":"1f9d1-1f3fe-200d-1f680","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDE80"},{"unified":"1f9d1-1f3ff-200d-1f680","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDE80"}],"version":12.1},"male-astronaut":{"id":"male-astronaut","name":"Man Astronaut","keywords":["male","space","rocket","human"],"skins":[{"unified":"1f468-200d-1f680","native":"\uD83D\uDC68\u200D\uD83D\uDE80"},{"unified":"1f468-1f3fb-200d-1f680","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE80"},{"unified":"1f468-1f3fc-200d-1f680","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE80"},{"unified":"1f468-1f3fd-200d-1f680","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE80"},{"unified":"1f468-1f3fe-200d-1f680","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE80"},{"unified":"1f468-1f3ff-200d-1f680","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE80"}],"version":4},"female-astronaut":{"id":"female-astronaut","name":"Woman Astronaut","keywords":["female","space","rocket","human"],"skins":[{"unified":"1f469-200d-1f680","native":"\uD83D\uDC69\u200D\uD83D\uDE80"},{"unified":"1f469-1f3fb-200d-1f680","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE80"},{"unified":"1f469-1f3fc-200d-1f680","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE80"},{"unified":"1f469-1f3fd-200d-1f680","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE80"},{"unified":"1f469-1f3fe-200d-1f680","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE80"},{"unified":"1f469-1f3ff-200d-1f680","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE80"}],"version":4},"firefighter":{"id":"firefighter","name":"Firefighter","keywords":["fire"],"skins":[{"unified":"1f9d1-200d-1f692","native":"\uD83E\uDDD1\u200D\uD83D\uDE92"},{"unified":"1f9d1-1f3fb-200d-1f692","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDE92"},{"unified":"1f9d1-1f3fc-200d-1f692","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDE92"},{"unified":"1f9d1-1f3fd-200d-1f692","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDE92"},{"unified":"1f9d1-1f3fe-200d-1f692","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDE92"},{"unified":"1f9d1-1f3ff-200d-1f692","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDE92"}],"version":12.1},"male-firefighter":{"id":"male-firefighter","name":"Man Firefighter","keywords":["male","fireman","human"],"skins":[{"unified":"1f468-200d-1f692","native":"\uD83D\uDC68\u200D\uD83D\uDE92"},{"unified":"1f468-1f3fb-200d-1f692","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE92"},{"unified":"1f468-1f3fc-200d-1f692","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE92"},{"unified":"1f468-1f3fd-200d-1f692","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE92"},{"unified":"1f468-1f3fe-200d-1f692","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE92"},{"unified":"1f468-1f3ff-200d-1f692","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE92"}],"version":4},"female-firefighter":{"id":"female-firefighter","name":"Woman Firefighter","keywords":["female","fireman","human"],"skins":[{"unified":"1f469-200d-1f692","native":"\uD83D\uDC69\u200D\uD83D\uDE92"},{"unified":"1f469-1f3fb-200d-1f692","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE92"},{"unified":"1f469-1f3fc-200d-1f692","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE92"},{"unified":"1f469-1f3fd-200d-1f692","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE92"},{"unified":"1f469-1f3fe-200d-1f692","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE92"},{"unified":"1f469-1f3ff-200d-1f692","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE92"}],"version":4},"cop":{"id":"cop","name":"Police Officer","keywords":["cop"],"skins":[{"unified":"1f46e","native":"\uD83D\uDC6E"},{"unified":"1f46e-1f3fb","native":"\uD83D\uDC6E\uD83C\uDFFB"},{"unified":"1f46e-1f3fc","native":"\uD83D\uDC6E\uD83C\uDFFC"},{"unified":"1f46e-1f3fd","native":"\uD83D\uDC6E\uD83C\uDFFD"},{"unified":"1f46e-1f3fe","native":"\uD83D\uDC6E\uD83C\uDFFE"},{"unified":"1f46e-1f3ff","native":"\uD83D\uDC6E\uD83C\uDFFF"}],"version":1},"male-police-officer":{"id":"male-police-officer","name":"Man Police Officer","keywords":["male","police-officer","law","legal","enforcement","arrest","911"],"skins":[{"unified":"1f46e-200d-2642-fe0f","native":"\uD83D\uDC6E\u200D\u2642\uFE0F"},{"unified":"1f46e-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f46e-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f46e-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f46e-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f46e-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"female-police-officer":{"id":"female-police-officer","name":"Woman Police Officer","keywords":["female","police-officer","law","legal","enforcement","arrest","911"],"skins":[{"unified":"1f46e-200d-2640-fe0f","native":"\uD83D\uDC6E\u200D\u2640\uFE0F"},{"unified":"1f46e-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f46e-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f46e-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f46e-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f46e-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC6E\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"sleuth_or_spy":{"id":"sleuth_or_spy","name":"Detective","keywords":["sleuth","or","spy","human"],"skins":[{"unified":"1f575-fe0f","native":"\uD83D\uDD75\uFE0F"},{"unified":"1f575-1f3fb","native":"\uD83D\uDD75\uD83C\uDFFB"},{"unified":"1f575-1f3fc","native":"\uD83D\uDD75\uD83C\uDFFC"},{"unified":"1f575-1f3fd","native":"\uD83D\uDD75\uD83C\uDFFD"},{"unified":"1f575-1f3fe","native":"\uD83D\uDD75\uD83C\uDFFE"},{"unified":"1f575-1f3ff","native":"\uD83D\uDD75\uD83C\uDFFF"}],"version":1},"male-detective":{"id":"male-detective","name":"Man Detective","keywords":["male","crime"],"skins":[{"unified":"1f575-fe0f-200d-2642-fe0f","native":"\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F"},{"unified":"1f575-1f3fb-200d-2642-fe0f","native":"\uD83D\uDD75\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f575-1f3fc-200d-2642-fe0f","native":"\uD83D\uDD75\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f575-1f3fd-200d-2642-fe0f","native":"\uD83D\uDD75\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f575-1f3fe-200d-2642-fe0f","native":"\uD83D\uDD75\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f575-1f3ff-200d-2642-fe0f","native":"\uD83D\uDD75\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"female-detective":{"id":"female-detective","name":"Woman Detective","keywords":["female","human","spy"],"skins":[{"unified":"1f575-fe0f-200d-2640-fe0f","native":"\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F"},{"unified":"1f575-1f3fb-200d-2640-fe0f","native":"\uD83D\uDD75\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f575-1f3fc-200d-2640-fe0f","native":"\uD83D\uDD75\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f575-1f3fd-200d-2640-fe0f","native":"\uD83D\uDD75\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f575-1f3fe-200d-2640-fe0f","native":"\uD83D\uDD75\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f575-1f3ff-200d-2640-fe0f","native":"\uD83D\uDD75\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"guardsman":{"id":"guardsman","name":"Guard","keywords":["guardsman","protect"],"skins":[{"unified":"1f482","native":"\uD83D\uDC82"},{"unified":"1f482-1f3fb","native":"\uD83D\uDC82\uD83C\uDFFB"},{"unified":"1f482-1f3fc","native":"\uD83D\uDC82\uD83C\uDFFC"},{"unified":"1f482-1f3fd","native":"\uD83D\uDC82\uD83C\uDFFD"},{"unified":"1f482-1f3fe","native":"\uD83D\uDC82\uD83C\uDFFE"},{"unified":"1f482-1f3ff","native":"\uD83D\uDC82\uD83C\uDFFF"}],"version":1},"male-guard":{"id":"male-guard","name":"Man Guard","keywords":["male","uk","gb","british","guy","royal"],"skins":[{"unified":"1f482-200d-2642-fe0f","native":"\uD83D\uDC82\u200D\u2642\uFE0F"},{"unified":"1f482-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC82\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f482-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC82\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f482-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC82\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f482-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC82\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f482-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC82\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"female-guard":{"id":"female-guard","name":"Woman Guard","keywords":["female","uk","gb","british","royal"],"skins":[{"unified":"1f482-200d-2640-fe0f","native":"\uD83D\uDC82\u200D\u2640\uFE0F"},{"unified":"1f482-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC82\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f482-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC82\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f482-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC82\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f482-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC82\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f482-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC82\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"ninja":{"id":"ninja","name":"Ninja","keywords":["ninjutsu","skills","japanese"],"skins":[{"unified":"1f977","native":"\uD83E\uDD77"},{"unified":"1f977-1f3fb","native":"\uD83E\uDD77\uD83C\uDFFB"},{"unified":"1f977-1f3fc","native":"\uD83E\uDD77\uD83C\uDFFC"},{"unified":"1f977-1f3fd","native":"\uD83E\uDD77\uD83C\uDFFD"},{"unified":"1f977-1f3fe","native":"\uD83E\uDD77\uD83C\uDFFE"},{"unified":"1f977-1f3ff","native":"\uD83E\uDD77\uD83C\uDFFF"}],"version":13},"construction_worker":{"id":"construction_worker","name":"Construction Worker","keywords":["labor","build"],"skins":[{"unified":"1f477","native":"\uD83D\uDC77"},{"unified":"1f477-1f3fb","native":"\uD83D\uDC77\uD83C\uDFFB"},{"unified":"1f477-1f3fc","native":"\uD83D\uDC77\uD83C\uDFFC"},{"unified":"1f477-1f3fd","native":"\uD83D\uDC77\uD83C\uDFFD"},{"unified":"1f477-1f3fe","native":"\uD83D\uDC77\uD83C\uDFFE"},{"unified":"1f477-1f3ff","native":"\uD83D\uDC77\uD83C\uDFFF"}],"version":1},"male-construction-worker":{"id":"male-construction-worker","name":"Man Construction Worker","keywords":["male","construction-worker","human","wip","guy","build","labor"],"skins":[{"unified":"1f477-200d-2642-fe0f","native":"\uD83D\uDC77\u200D\u2642\uFE0F"},{"unified":"1f477-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC77\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f477-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC77\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f477-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC77\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f477-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC77\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f477-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC77\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"female-construction-worker":{"id":"female-construction-worker","name":"Woman Construction Worker","keywords":["female","construction-worker","human","wip","build","labor"],"skins":[{"unified":"1f477-200d-2640-fe0f","native":"\uD83D\uDC77\u200D\u2640\uFE0F"},{"unified":"1f477-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC77\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f477-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC77\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f477-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC77\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f477-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC77\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f477-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC77\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"person_with_crown":{"id":"person_with_crown","name":"Person with Crown","keywords":["royalty","power"],"skins":[{"unified":"1fac5","native":"\uD83E\uDEC5"},{"unified":"1fac5-1f3fb","native":"\uD83E\uDEC5\uD83C\uDFFB"},{"unified":"1fac5-1f3fc","native":"\uD83E\uDEC5\uD83C\uDFFC"},{"unified":"1fac5-1f3fd","native":"\uD83E\uDEC5\uD83C\uDFFD"},{"unified":"1fac5-1f3fe","native":"\uD83E\uDEC5\uD83C\uDFFE"},{"unified":"1fac5-1f3ff","native":"\uD83E\uDEC5\uD83C\uDFFF"}],"version":14},"prince":{"id":"prince","name":"Prince","keywords":["boy","man","male","crown","royal","king"],"skins":[{"unified":"1f934","native":"\uD83E\uDD34"},{"unified":"1f934-1f3fb","native":"\uD83E\uDD34\uD83C\uDFFB"},{"unified":"1f934-1f3fc","native":"\uD83E\uDD34\uD83C\uDFFC"},{"unified":"1f934-1f3fd","native":"\uD83E\uDD34\uD83C\uDFFD"},{"unified":"1f934-1f3fe","native":"\uD83E\uDD34\uD83C\uDFFE"},{"unified":"1f934-1f3ff","native":"\uD83E\uDD34\uD83C\uDFFF"}],"version":3},"princess":{"id":"princess","name":"Princess","keywords":["girl","woman","female","blond","crown","royal","queen"],"skins":[{"unified":"1f478","native":"\uD83D\uDC78"},{"unified":"1f478-1f3fb","native":"\uD83D\uDC78\uD83C\uDFFB"},{"unified":"1f478-1f3fc","native":"\uD83D\uDC78\uD83C\uDFFC"},{"unified":"1f478-1f3fd","native":"\uD83D\uDC78\uD83C\uDFFD"},{"unified":"1f478-1f3fe","native":"\uD83D\uDC78\uD83C\uDFFE"},{"unified":"1f478-1f3ff","native":"\uD83D\uDC78\uD83C\uDFFF"}],"version":1},"man_with_turban":{"id":"man_with_turban","name":"Man with Turban","keywords":["person","wearing","headdress"],"skins":[{"unified":"1f473","native":"\uD83D\uDC73"},{"unified":"1f473-1f3fb","native":"\uD83D\uDC73\uD83C\uDFFB"},{"unified":"1f473-1f3fc","native":"\uD83D\uDC73\uD83C\uDFFC"},{"unified":"1f473-1f3fd","native":"\uD83D\uDC73\uD83C\uDFFD"},{"unified":"1f473-1f3fe","native":"\uD83D\uDC73\uD83C\uDFFE"},{"unified":"1f473-1f3ff","native":"\uD83D\uDC73\uD83C\uDFFF"}],"version":1},"man-wearing-turban":{"id":"man-wearing-turban","name":"Man Wearing Turban","keywords":["wearing-turban","male","indian","hinduism","arabs"],"skins":[{"unified":"1f473-200d-2642-fe0f","native":"\uD83D\uDC73\u200D\u2642\uFE0F"},{"unified":"1f473-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC73\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f473-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC73\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f473-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC73\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f473-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC73\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f473-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC73\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-wearing-turban":{"id":"woman-wearing-turban","name":"Woman Wearing Turban","keywords":["wearing-turban","female","indian","hinduism","arabs"],"skins":[{"unified":"1f473-200d-2640-fe0f","native":"\uD83D\uDC73\u200D\u2640\uFE0F"},{"unified":"1f473-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC73\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f473-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC73\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f473-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC73\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f473-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC73\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f473-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC73\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"man_with_gua_pi_mao":{"id":"man_with_gua_pi_mao","name":"Man with Gua Pi Mao","keywords":["skullcap","male","boy","chinese"],"skins":[{"unified":"1f472","native":"\uD83D\uDC72"},{"unified":"1f472-1f3fb","native":"\uD83D\uDC72\uD83C\uDFFB"},{"unified":"1f472-1f3fc","native":"\uD83D\uDC72\uD83C\uDFFC"},{"unified":"1f472-1f3fd","native":"\uD83D\uDC72\uD83C\uDFFD"},{"unified":"1f472-1f3fe","native":"\uD83D\uDC72\uD83C\uDFFE"},{"unified":"1f472-1f3ff","native":"\uD83D\uDC72\uD83C\uDFFF"}],"version":1},"person_with_headscarf":{"id":"person_with_headscarf","name":"Woman with Headscarf","keywords":["person","female","hijab","mantilla","tichel"],"skins":[{"unified":"1f9d5","native":"\uD83E\uDDD5"},{"unified":"1f9d5-1f3fb","native":"\uD83E\uDDD5\uD83C\uDFFB"},{"unified":"1f9d5-1f3fc","native":"\uD83E\uDDD5\uD83C\uDFFC"},{"unified":"1f9d5-1f3fd","native":"\uD83E\uDDD5\uD83C\uDFFD"},{"unified":"1f9d5-1f3fe","native":"\uD83E\uDDD5\uD83C\uDFFE"},{"unified":"1f9d5-1f3ff","native":"\uD83E\uDDD5\uD83C\uDFFF"}],"version":5},"person_in_tuxedo":{"id":"person_in_tuxedo","name":"Man in Tuxedo","keywords":["person","couple","marriage","wedding","groom"],"skins":[{"unified":"1f935","native":"\uD83E\uDD35"},{"unified":"1f935-1f3fb","native":"\uD83E\uDD35\uD83C\uDFFB"},{"unified":"1f935-1f3fc","native":"\uD83E\uDD35\uD83C\uDFFC"},{"unified":"1f935-1f3fd","native":"\uD83E\uDD35\uD83C\uDFFD"},{"unified":"1f935-1f3fe","native":"\uD83E\uDD35\uD83C\uDFFE"},{"unified":"1f935-1f3ff","native":"\uD83E\uDD35\uD83C\uDFFF"}],"version":3},"man_in_tuxedo":{"id":"man_in_tuxedo","name":"Man in Tuxedo","keywords":["formal","fashion"],"skins":[{"unified":"1f935-200d-2642-fe0f","native":"\uD83E\uDD35\u200D\u2642\uFE0F"},{"unified":"1f935-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD35\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f935-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD35\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f935-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD35\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f935-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD35\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f935-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD35\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":13},"woman_in_tuxedo":{"id":"woman_in_tuxedo","name":"Woman in Tuxedo","keywords":["formal","fashion"],"skins":[{"unified":"1f935-200d-2640-fe0f","native":"\uD83E\uDD35\u200D\u2640\uFE0F"},{"unified":"1f935-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD35\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f935-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD35\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f935-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD35\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f935-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD35\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f935-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD35\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":13},"bride_with_veil":{"id":"bride_with_veil","name":"Bride with Veil","keywords":["couple","marriage","wedding","woman"],"skins":[{"unified":"1f470","native":"\uD83D\uDC70"},{"unified":"1f470-1f3fb","native":"\uD83D\uDC70\uD83C\uDFFB"},{"unified":"1f470-1f3fc","native":"\uD83D\uDC70\uD83C\uDFFC"},{"unified":"1f470-1f3fd","native":"\uD83D\uDC70\uD83C\uDFFD"},{"unified":"1f470-1f3fe","native":"\uD83D\uDC70\uD83C\uDFFE"},{"unified":"1f470-1f3ff","native":"\uD83D\uDC70\uD83C\uDFFF"}],"version":1},"man_with_veil":{"id":"man_with_veil","name":"Man with Veil","keywords":["wedding","marriage"],"skins":[{"unified":"1f470-200d-2642-fe0f","native":"\uD83D\uDC70\u200D\u2642\uFE0F"},{"unified":"1f470-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC70\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f470-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC70\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f470-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC70\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f470-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC70\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f470-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC70\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":13},"woman_with_veil":{"id":"woman_with_veil","name":"Woman with Veil","keywords":["wedding","marriage"],"skins":[{"unified":"1f470-200d-2640-fe0f","native":"\uD83D\uDC70\u200D\u2640\uFE0F"},{"unified":"1f470-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC70\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f470-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC70\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f470-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC70\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f470-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC70\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f470-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC70\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":13},"pregnant_woman":{"id":"pregnant_woman","name":"Pregnant Woman","keywords":["baby"],"skins":[{"unified":"1f930","native":"\uD83E\uDD30"},{"unified":"1f930-1f3fb","native":"\uD83E\uDD30\uD83C\uDFFB"},{"unified":"1f930-1f3fc","native":"\uD83E\uDD30\uD83C\uDFFC"},{"unified":"1f930-1f3fd","native":"\uD83E\uDD30\uD83C\uDFFD"},{"unified":"1f930-1f3fe","native":"\uD83E\uDD30\uD83C\uDFFE"},{"unified":"1f930-1f3ff","native":"\uD83E\uDD30\uD83C\uDFFF"}],"version":3},"pregnant_man":{"id":"pregnant_man","name":"Pregnant Man","keywords":["baby","belly"],"skins":[{"unified":"1fac3","native":"\uD83E\uDEC3"},{"unified":"1fac3-1f3fb","native":"\uD83E\uDEC3\uD83C\uDFFB"},{"unified":"1fac3-1f3fc","native":"\uD83E\uDEC3\uD83C\uDFFC"},{"unified":"1fac3-1f3fd","native":"\uD83E\uDEC3\uD83C\uDFFD"},{"unified":"1fac3-1f3fe","native":"\uD83E\uDEC3\uD83C\uDFFE"},{"unified":"1fac3-1f3ff","native":"\uD83E\uDEC3\uD83C\uDFFF"}],"version":14},"pregnant_person":{"id":"pregnant_person","name":"Pregnant Person","keywords":["baby","belly"],"skins":[{"unified":"1fac4","native":"\uD83E\uDEC4"},{"unified":"1fac4-1f3fb","native":"\uD83E\uDEC4\uD83C\uDFFB"},{"unified":"1fac4-1f3fc","native":"\uD83E\uDEC4\uD83C\uDFFC"},{"unified":"1fac4-1f3fd","native":"\uD83E\uDEC4\uD83C\uDFFD"},{"unified":"1fac4-1f3fe","native":"\uD83E\uDEC4\uD83C\uDFFE"},{"unified":"1fac4-1f3ff","native":"\uD83E\uDEC4\uD83C\uDFFF"}],"version":14},"breast-feeding":{"id":"breast-feeding","name":"Breast-Feeding","keywords":["breast","feeding","nursing","baby"],"skins":[{"unified":"1f931","native":"\uD83E\uDD31"},{"unified":"1f931-1f3fb","native":"\uD83E\uDD31\uD83C\uDFFB"},{"unified":"1f931-1f3fc","native":"\uD83E\uDD31\uD83C\uDFFC"},{"unified":"1f931-1f3fd","native":"\uD83E\uDD31\uD83C\uDFFD"},{"unified":"1f931-1f3fe","native":"\uD83E\uDD31\uD83C\uDFFE"},{"unified":"1f931-1f3ff","native":"\uD83E\uDD31\uD83C\uDFFF"}],"version":5},"woman_feeding_baby":{"id":"woman_feeding_baby","name":"Woman Feeding Baby","keywords":["birth","food"],"skins":[{"unified":"1f469-200d-1f37c","native":"\uD83D\uDC69\u200D\uD83C\uDF7C"},{"unified":"1f469-1f3fb-200d-1f37c","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF7C"},{"unified":"1f469-1f3fc-200d-1f37c","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF7C"},{"unified":"1f469-1f3fd-200d-1f37c","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF7C"},{"unified":"1f469-1f3fe-200d-1f37c","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF7C"},{"unified":"1f469-1f3ff-200d-1f37c","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF7C"}],"version":13},"man_feeding_baby":{"id":"man_feeding_baby","name":"Man Feeding Baby","keywords":["birth","food"],"skins":[{"unified":"1f468-200d-1f37c","native":"\uD83D\uDC68\u200D\uD83C\uDF7C"},{"unified":"1f468-1f3fb-200d-1f37c","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF7C"},{"unified":"1f468-1f3fc-200d-1f37c","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF7C"},{"unified":"1f468-1f3fd-200d-1f37c","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF7C"},{"unified":"1f468-1f3fe-200d-1f37c","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF7C"},{"unified":"1f468-1f3ff-200d-1f37c","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF7C"}],"version":13},"person_feeding_baby":{"id":"person_feeding_baby","name":"Person Feeding Baby","keywords":["birth","food"],"skins":[{"unified":"1f9d1-200d-1f37c","native":"\uD83E\uDDD1\u200D\uD83C\uDF7C"},{"unified":"1f9d1-1f3fb-200d-1f37c","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF7C"},{"unified":"1f9d1-1f3fc-200d-1f37c","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF7C"},{"unified":"1f9d1-1f3fd-200d-1f37c","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF7C"},{"unified":"1f9d1-1f3fe-200d-1f37c","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF7C"},{"unified":"1f9d1-1f3ff-200d-1f37c","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF7C"}],"version":13},"angel":{"id":"angel","name":"Baby Angel","keywords":["heaven","wings","halo"],"skins":[{"unified":"1f47c","native":"\uD83D\uDC7C"},{"unified":"1f47c-1f3fb","native":"\uD83D\uDC7C\uD83C\uDFFB"},{"unified":"1f47c-1f3fc","native":"\uD83D\uDC7C\uD83C\uDFFC"},{"unified":"1f47c-1f3fd","native":"\uD83D\uDC7C\uD83C\uDFFD"},{"unified":"1f47c-1f3fe","native":"\uD83D\uDC7C\uD83C\uDFFE"},{"unified":"1f47c-1f3ff","native":"\uD83D\uDC7C\uD83C\uDFFF"}],"version":1},"santa":{"id":"santa","name":"Santa Claus","keywords":["festival","man","male","xmas","father","christmas"],"skins":[{"unified":"1f385","native":"\uD83C\uDF85"},{"unified":"1f385-1f3fb","native":"\uD83C\uDF85\uD83C\uDFFB"},{"unified":"1f385-1f3fc","native":"\uD83C\uDF85\uD83C\uDFFC"},{"unified":"1f385-1f3fd","native":"\uD83C\uDF85\uD83C\uDFFD"},{"unified":"1f385-1f3fe","native":"\uD83C\uDF85\uD83C\uDFFE"},{"unified":"1f385-1f3ff","native":"\uD83C\uDF85\uD83C\uDFFF"}],"version":1},"mrs_claus":{"id":"mrs_claus","name":"Mrs. Claus","keywords":["mrs","mother","christmas","woman","female","xmas"],"skins":[{"unified":"1f936","native":"\uD83E\uDD36"},{"unified":"1f936-1f3fb","native":"\uD83E\uDD36\uD83C\uDFFB"},{"unified":"1f936-1f3fc","native":"\uD83E\uDD36\uD83C\uDFFC"},{"unified":"1f936-1f3fd","native":"\uD83E\uDD36\uD83C\uDFFD"},{"unified":"1f936-1f3fe","native":"\uD83E\uDD36\uD83C\uDFFE"},{"unified":"1f936-1f3ff","native":"\uD83E\uDD36\uD83C\uDFFF"}],"version":3},"mx_claus":{"id":"mx_claus","name":"Mx Claus","keywords":["christmas"],"skins":[{"unified":"1f9d1-200d-1f384","native":"\uD83E\uDDD1\u200D\uD83C\uDF84"},{"unified":"1f9d1-1f3fb-200d-1f384","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF84"},{"unified":"1f9d1-1f3fc-200d-1f384","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF84"},{"unified":"1f9d1-1f3fd-200d-1f384","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF84"},{"unified":"1f9d1-1f3fe-200d-1f384","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF84"},{"unified":"1f9d1-1f3ff-200d-1f384","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF84"}],"version":13},"superhero":{"id":"superhero","name":"Superhero","keywords":["marvel"],"skins":[{"unified":"1f9b8","native":"\uD83E\uDDB8"},{"unified":"1f9b8-1f3fb","native":"\uD83E\uDDB8\uD83C\uDFFB"},{"unified":"1f9b8-1f3fc","native":"\uD83E\uDDB8\uD83C\uDFFC"},{"unified":"1f9b8-1f3fd","native":"\uD83E\uDDB8\uD83C\uDFFD"},{"unified":"1f9b8-1f3fe","native":"\uD83E\uDDB8\uD83C\uDFFE"},{"unified":"1f9b8-1f3ff","native":"\uD83E\uDDB8\uD83C\uDFFF"}],"version":11},"male_superhero":{"id":"male_superhero","name":"Man Superhero","keywords":["male","good","hero","superpowers"],"skins":[{"unified":"1f9b8-200d-2642-fe0f","native":"\uD83E\uDDB8\u200D\u2642\uFE0F"},{"unified":"1f9b8-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9b8-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9b8-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9b8-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9b8-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":11},"female_superhero":{"id":"female_superhero","name":"Woman Superhero","keywords":["female","good","heroine","superpowers"],"skins":[{"unified":"1f9b8-200d-2640-fe0f","native":"\uD83E\uDDB8\u200D\u2640\uFE0F"},{"unified":"1f9b8-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9b8-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9b8-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9b8-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9b8-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDB8\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":11},"supervillain":{"id":"supervillain","name":"Supervillain","keywords":["marvel"],"skins":[{"unified":"1f9b9","native":"\uD83E\uDDB9"},{"unified":"1f9b9-1f3fb","native":"\uD83E\uDDB9\uD83C\uDFFB"},{"unified":"1f9b9-1f3fc","native":"\uD83E\uDDB9\uD83C\uDFFC"},{"unified":"1f9b9-1f3fd","native":"\uD83E\uDDB9\uD83C\uDFFD"},{"unified":"1f9b9-1f3fe","native":"\uD83E\uDDB9\uD83C\uDFFE"},{"unified":"1f9b9-1f3ff","native":"\uD83E\uDDB9\uD83C\uDFFF"}],"version":11},"male_supervillain":{"id":"male_supervillain","name":"Man Supervillain","keywords":["male","evil","bad","criminal","hero","superpowers"],"skins":[{"unified":"1f9b9-200d-2642-fe0f","native":"\uD83E\uDDB9\u200D\u2642\uFE0F"},{"unified":"1f9b9-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9b9-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9b9-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9b9-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9b9-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":11},"female_supervillain":{"id":"female_supervillain","name":"Woman Supervillain","keywords":["female","evil","bad","criminal","heroine","superpowers"],"skins":[{"unified":"1f9b9-200d-2640-fe0f","native":"\uD83E\uDDB9\u200D\u2640\uFE0F"},{"unified":"1f9b9-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9b9-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9b9-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9b9-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9b9-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDB9\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":11},"mage":{"id":"mage","name":"Mage","keywords":["magic"],"skins":[{"unified":"1f9d9","native":"\uD83E\uDDD9"},{"unified":"1f9d9-1f3fb","native":"\uD83E\uDDD9\uD83C\uDFFB"},{"unified":"1f9d9-1f3fc","native":"\uD83E\uDDD9\uD83C\uDFFC"},{"unified":"1f9d9-1f3fd","native":"\uD83E\uDDD9\uD83C\uDFFD"},{"unified":"1f9d9-1f3fe","native":"\uD83E\uDDD9\uD83C\uDFFE"},{"unified":"1f9d9-1f3ff","native":"\uD83E\uDDD9\uD83C\uDFFF"}],"version":5},"male_mage":{"id":"male_mage","name":"Man Mage","keywords":["male","sorcerer"],"skins":[{"unified":"1f9d9-200d-2642-fe0f","native":"\uD83E\uDDD9\u200D\u2642\uFE0F"},{"unified":"1f9d9-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9d9-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9d9-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9d9-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9d9-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"female_mage":{"id":"female_mage","name":"Woman Mage","keywords":["female","witch"],"skins":[{"unified":"1f9d9-200d-2640-fe0f","native":"\uD83E\uDDD9\u200D\u2640\uFE0F"},{"unified":"1f9d9-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9d9-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9d9-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9d9-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9d9-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDD9\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"fairy":{"id":"fairy","name":"Fairy","keywords":["wings","magical"],"skins":[{"unified":"1f9da","native":"\uD83E\uDDDA"},{"unified":"1f9da-1f3fb","native":"\uD83E\uDDDA\uD83C\uDFFB"},{"unified":"1f9da-1f3fc","native":"\uD83E\uDDDA\uD83C\uDFFC"},{"unified":"1f9da-1f3fd","native":"\uD83E\uDDDA\uD83C\uDFFD"},{"unified":"1f9da-1f3fe","native":"\uD83E\uDDDA\uD83C\uDFFE"},{"unified":"1f9da-1f3ff","native":"\uD83E\uDDDA\uD83C\uDFFF"}],"version":5},"male_fairy":{"id":"male_fairy","name":"Man Fairy","keywords":["male"],"skins":[{"unified":"1f9da-200d-2642-fe0f","native":"\uD83E\uDDDA\u200D\u2642\uFE0F"},{"unified":"1f9da-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9da-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9da-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9da-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9da-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"female_fairy":{"id":"female_fairy","name":"Woman Fairy","keywords":["female"],"skins":[{"unified":"1f9da-200d-2640-fe0f","native":"\uD83E\uDDDA\u200D\u2640\uFE0F"},{"unified":"1f9da-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9da-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9da-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9da-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9da-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDDA\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"vampire":{"id":"vampire","name":"Vampire","keywords":["blood","twilight"],"skins":[{"unified":"1f9db","native":"\uD83E\uDDDB"},{"unified":"1f9db-1f3fb","native":"\uD83E\uDDDB\uD83C\uDFFB"},{"unified":"1f9db-1f3fc","native":"\uD83E\uDDDB\uD83C\uDFFC"},{"unified":"1f9db-1f3fd","native":"\uD83E\uDDDB\uD83C\uDFFD"},{"unified":"1f9db-1f3fe","native":"\uD83E\uDDDB\uD83C\uDFFE"},{"unified":"1f9db-1f3ff","native":"\uD83E\uDDDB\uD83C\uDFFF"}],"version":5},"male_vampire":{"id":"male_vampire","name":"Man Vampire","keywords":["male","dracula"],"skins":[{"unified":"1f9db-200d-2642-fe0f","native":"\uD83E\uDDDB\u200D\u2642\uFE0F"},{"unified":"1f9db-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9db-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9db-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9db-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9db-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"female_vampire":{"id":"female_vampire","name":"Woman Vampire","keywords":["female"],"skins":[{"unified":"1f9db-200d-2640-fe0f","native":"\uD83E\uDDDB\u200D\u2640\uFE0F"},{"unified":"1f9db-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9db-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9db-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9db-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9db-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDDB\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"merperson":{"id":"merperson","name":"Merperson","keywords":["sea"],"skins":[{"unified":"1f9dc","native":"\uD83E\uDDDC"},{"unified":"1f9dc-1f3fb","native":"\uD83E\uDDDC\uD83C\uDFFB"},{"unified":"1f9dc-1f3fc","native":"\uD83E\uDDDC\uD83C\uDFFC"},{"unified":"1f9dc-1f3fd","native":"\uD83E\uDDDC\uD83C\uDFFD"},{"unified":"1f9dc-1f3fe","native":"\uD83E\uDDDC\uD83C\uDFFE"},{"unified":"1f9dc-1f3ff","native":"\uD83E\uDDDC\uD83C\uDFFF"}],"version":5},"merman":{"id":"merman","name":"Merman","keywords":["man","male","triton"],"skins":[{"unified":"1f9dc-200d-2642-fe0f","native":"\uD83E\uDDDC\u200D\u2642\uFE0F"},{"unified":"1f9dc-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9dc-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9dc-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9dc-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9dc-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"mermaid":{"id":"mermaid","name":"Mermaid","keywords":["woman","female","merwoman","ariel"],"skins":[{"unified":"1f9dc-200d-2640-fe0f","native":"\uD83E\uDDDC\u200D\u2640\uFE0F"},{"unified":"1f9dc-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9dc-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9dc-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9dc-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9dc-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDDC\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"elf":{"id":"elf","name":"Elf","keywords":["magical"],"skins":[{"unified":"1f9dd","native":"\uD83E\uDDDD"},{"unified":"1f9dd-1f3fb","native":"\uD83E\uDDDD\uD83C\uDFFB"},{"unified":"1f9dd-1f3fc","native":"\uD83E\uDDDD\uD83C\uDFFC"},{"unified":"1f9dd-1f3fd","native":"\uD83E\uDDDD\uD83C\uDFFD"},{"unified":"1f9dd-1f3fe","native":"\uD83E\uDDDD\uD83C\uDFFE"},{"unified":"1f9dd-1f3ff","native":"\uD83E\uDDDD\uD83C\uDFFF"}],"version":5},"male_elf":{"id":"male_elf","name":"Man Elf","keywords":["male"],"skins":[{"unified":"1f9dd-200d-2642-fe0f","native":"\uD83E\uDDDD\u200D\u2642\uFE0F"},{"unified":"1f9dd-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9dd-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9dd-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9dd-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9dd-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"female_elf":{"id":"female_elf","name":"Woman Elf","keywords":["female"],"skins":[{"unified":"1f9dd-200d-2640-fe0f","native":"\uD83E\uDDDD\u200D\u2640\uFE0F"},{"unified":"1f9dd-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9dd-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9dd-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9dd-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9dd-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDDD\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"genie":{"id":"genie","name":"Genie","keywords":["magical","wishes"],"skins":[{"unified":"1f9de","native":"\uD83E\uDDDE"}],"version":5},"male_genie":{"id":"male_genie","name":"Man Genie","keywords":["male"],"skins":[{"unified":"1f9de-200d-2642-fe0f","native":"\uD83E\uDDDE\u200D\u2642\uFE0F"}],"version":5},"female_genie":{"id":"female_genie","name":"Woman Genie","keywords":["female"],"skins":[{"unified":"1f9de-200d-2640-fe0f","native":"\uD83E\uDDDE\u200D\u2640\uFE0F"}],"version":5},"zombie":{"id":"zombie","name":"Zombie","keywords":["dead"],"skins":[{"unified":"1f9df","native":"\uD83E\uDDDF"}],"version":5},"male_zombie":{"id":"male_zombie","name":"Man Zombie","keywords":["male","dracula","undead","walking","dead"],"skins":[{"unified":"1f9df-200d-2642-fe0f","native":"\uD83E\uDDDF\u200D\u2642\uFE0F"}],"version":5},"female_zombie":{"id":"female_zombie","name":"Woman Zombie","keywords":["female","undead","walking","dead"],"skins":[{"unified":"1f9df-200d-2640-fe0f","native":"\uD83E\uDDDF\u200D\u2640\uFE0F"}],"version":5},"troll":{"id":"troll","name":"Troll","keywords":["mystical","monster"],"skins":[{"unified":"1f9cc","native":"\uD83E\uDDCC"}],"version":14},"massage":{"id":"massage","name":"Face Massage","keywords":["person","getting","relax"],"skins":[{"unified":"1f486","native":"\uD83D\uDC86"},{"unified":"1f486-1f3fb","native":"\uD83D\uDC86\uD83C\uDFFB"},{"unified":"1f486-1f3fc","native":"\uD83D\uDC86\uD83C\uDFFC"},{"unified":"1f486-1f3fd","native":"\uD83D\uDC86\uD83C\uDFFD"},{"unified":"1f486-1f3fe","native":"\uD83D\uDC86\uD83C\uDFFE"},{"unified":"1f486-1f3ff","native":"\uD83D\uDC86\uD83C\uDFFF"}],"version":1},"man-getting-massage":{"id":"man-getting-massage","name":"Man Getting Massage","keywords":["getting-massage","male","boy","head"],"skins":[{"unified":"1f486-200d-2642-fe0f","native":"\uD83D\uDC86\u200D\u2642\uFE0F"},{"unified":"1f486-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC86\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f486-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC86\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f486-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC86\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f486-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC86\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f486-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC86\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-getting-massage":{"id":"woman-getting-massage","name":"Woman Getting Massage","keywords":["getting-massage","female","girl","head"],"skins":[{"unified":"1f486-200d-2640-fe0f","native":"\uD83D\uDC86\u200D\u2640\uFE0F"},{"unified":"1f486-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC86\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f486-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC86\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f486-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC86\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f486-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC86\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f486-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC86\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"haircut":{"id":"haircut","name":"Haircut","keywords":["person","getting","hairstyle"],"skins":[{"unified":"1f487","native":"\uD83D\uDC87"},{"unified":"1f487-1f3fb","native":"\uD83D\uDC87\uD83C\uDFFB"},{"unified":"1f487-1f3fc","native":"\uD83D\uDC87\uD83C\uDFFC"},{"unified":"1f487-1f3fd","native":"\uD83D\uDC87\uD83C\uDFFD"},{"unified":"1f487-1f3fe","native":"\uD83D\uDC87\uD83C\uDFFE"},{"unified":"1f487-1f3ff","native":"\uD83D\uDC87\uD83C\uDFFF"}],"version":1},"man-getting-haircut":{"id":"man-getting-haircut","name":"Man Getting Haircut","keywords":["getting-haircut","male","boy"],"skins":[{"unified":"1f487-200d-2642-fe0f","native":"\uD83D\uDC87\u200D\u2642\uFE0F"},{"unified":"1f487-1f3fb-200d-2642-fe0f","native":"\uD83D\uDC87\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f487-1f3fc-200d-2642-fe0f","native":"\uD83D\uDC87\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f487-1f3fd-200d-2642-fe0f","native":"\uD83D\uDC87\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f487-1f3fe-200d-2642-fe0f","native":"\uD83D\uDC87\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f487-1f3ff-200d-2642-fe0f","native":"\uD83D\uDC87\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-getting-haircut":{"id":"woman-getting-haircut","name":"Woman Getting Haircut","keywords":["getting-haircut","female","girl"],"skins":[{"unified":"1f487-200d-2640-fe0f","native":"\uD83D\uDC87\u200D\u2640\uFE0F"},{"unified":"1f487-1f3fb-200d-2640-fe0f","native":"\uD83D\uDC87\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f487-1f3fc-200d-2640-fe0f","native":"\uD83D\uDC87\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f487-1f3fd-200d-2640-fe0f","native":"\uD83D\uDC87\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f487-1f3fe-200d-2640-fe0f","native":"\uD83D\uDC87\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f487-1f3ff-200d-2640-fe0f","native":"\uD83D\uDC87\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"walking":{"id":"walking","name":"Pedestrian","keywords":["walking","person","move"],"skins":[{"unified":"1f6b6","native":"\uD83D\uDEB6"},{"unified":"1f6b6-1f3fb","native":"\uD83D\uDEB6\uD83C\uDFFB"},{"unified":"1f6b6-1f3fc","native":"\uD83D\uDEB6\uD83C\uDFFC"},{"unified":"1f6b6-1f3fd","native":"\uD83D\uDEB6\uD83C\uDFFD"},{"unified":"1f6b6-1f3fe","native":"\uD83D\uDEB6\uD83C\uDFFE"},{"unified":"1f6b6-1f3ff","native":"\uD83D\uDEB6\uD83C\uDFFF"}],"version":1},"man-walking":{"id":"man-walking","name":"Man Walking","keywords":["human","feet","steps"],"skins":[{"unified":"1f6b6-200d-2642-fe0f","native":"\uD83D\uDEB6\u200D\u2642\uFE0F"},{"unified":"1f6b6-1f3fb-200d-2642-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f6b6-1f3fc-200d-2642-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f6b6-1f3fd-200d-2642-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f6b6-1f3fe-200d-2642-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f6b6-1f3ff-200d-2642-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-walking":{"id":"woman-walking","name":"Woman Walking","keywords":["human","feet","steps","female"],"skins":[{"unified":"1f6b6-200d-2640-fe0f","native":"\uD83D\uDEB6\u200D\u2640\uFE0F"},{"unified":"1f6b6-1f3fb-200d-2640-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f6b6-1f3fc-200d-2640-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f6b6-1f3fd-200d-2640-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f6b6-1f3fe-200d-2640-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f6b6-1f3ff-200d-2640-fe0f","native":"\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"standing_person":{"id":"standing_person","name":"Standing Person","keywords":["still"],"skins":[{"unified":"1f9cd","native":"\uD83E\uDDCD"},{"unified":"1f9cd-1f3fb","native":"\uD83E\uDDCD\uD83C\uDFFB"},{"unified":"1f9cd-1f3fc","native":"\uD83E\uDDCD\uD83C\uDFFC"},{"unified":"1f9cd-1f3fd","native":"\uD83E\uDDCD\uD83C\uDFFD"},{"unified":"1f9cd-1f3fe","native":"\uD83E\uDDCD\uD83C\uDFFE"},{"unified":"1f9cd-1f3ff","native":"\uD83E\uDDCD\uD83C\uDFFF"}],"version":12},"man_standing":{"id":"man_standing","name":"Man Standing","keywords":["still"],"skins":[{"unified":"1f9cd-200d-2642-fe0f","native":"\uD83E\uDDCD\u200D\u2642\uFE0F"},{"unified":"1f9cd-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9cd-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9cd-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9cd-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9cd-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":12},"woman_standing":{"id":"woman_standing","name":"Woman Standing","keywords":["still"],"skins":[{"unified":"1f9cd-200d-2640-fe0f","native":"\uD83E\uDDCD\u200D\u2640\uFE0F"},{"unified":"1f9cd-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9cd-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9cd-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9cd-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9cd-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDCD\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":12},"kneeling_person":{"id":"kneeling_person","name":"Kneeling Person","keywords":["pray","respectful"],"skins":[{"unified":"1f9ce","native":"\uD83E\uDDCE"},{"unified":"1f9ce-1f3fb","native":"\uD83E\uDDCE\uD83C\uDFFB"},{"unified":"1f9ce-1f3fc","native":"\uD83E\uDDCE\uD83C\uDFFC"},{"unified":"1f9ce-1f3fd","native":"\uD83E\uDDCE\uD83C\uDFFD"},{"unified":"1f9ce-1f3fe","native":"\uD83E\uDDCE\uD83C\uDFFE"},{"unified":"1f9ce-1f3ff","native":"\uD83E\uDDCE\uD83C\uDFFF"}],"version":12},"man_kneeling":{"id":"man_kneeling","name":"Man Kneeling","keywords":["pray","respectful"],"skins":[{"unified":"1f9ce-200d-2642-fe0f","native":"\uD83E\uDDCE\u200D\u2642\uFE0F"},{"unified":"1f9ce-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9ce-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9ce-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9ce-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9ce-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":12},"woman_kneeling":{"id":"woman_kneeling","name":"Woman Kneeling","keywords":["respectful","pray"],"skins":[{"unified":"1f9ce-200d-2640-fe0f","native":"\uD83E\uDDCE\u200D\u2640\uFE0F"},{"unified":"1f9ce-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9ce-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9ce-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9ce-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9ce-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDCE\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":12},"person_with_probing_cane":{"id":"person_with_probing_cane","name":"Person with White Cane","keywords":["probing","blind"],"skins":[{"unified":"1f9d1-200d-1f9af","native":"\uD83E\uDDD1\u200D\uD83E\uDDAF"},{"unified":"1f9d1-1f3fb-200d-1f9af","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDAF"},{"unified":"1f9d1-1f3fc-200d-1f9af","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDAF"},{"unified":"1f9d1-1f3fd-200d-1f9af","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDAF"},{"unified":"1f9d1-1f3fe-200d-1f9af","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDAF"},{"unified":"1f9d1-1f3ff-200d-1f9af","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDAF"}],"version":12.1},"man_with_probing_cane":{"id":"man_with_probing_cane","name":"Man with White Cane","keywords":["probing","blind"],"skins":[{"unified":"1f468-200d-1f9af","native":"\uD83D\uDC68\u200D\uD83E\uDDAF"},{"unified":"1f468-1f3fb-200d-1f9af","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDAF"},{"unified":"1f468-1f3fc-200d-1f9af","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDAF"},{"unified":"1f468-1f3fd-200d-1f9af","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDAF"},{"unified":"1f468-1f3fe-200d-1f9af","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDAF"},{"unified":"1f468-1f3ff-200d-1f9af","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDAF"}],"version":12},"woman_with_probing_cane":{"id":"woman_with_probing_cane","name":"Woman with White Cane","keywords":["probing","blind"],"skins":[{"unified":"1f469-200d-1f9af","native":"\uD83D\uDC69\u200D\uD83E\uDDAF"},{"unified":"1f469-1f3fb-200d-1f9af","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDAF"},{"unified":"1f469-1f3fc-200d-1f9af","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDAF"},{"unified":"1f469-1f3fd-200d-1f9af","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDAF"},{"unified":"1f469-1f3fe-200d-1f9af","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDAF"},{"unified":"1f469-1f3ff-200d-1f9af","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDAF"}],"version":12},"person_in_motorized_wheelchair":{"id":"person_in_motorized_wheelchair","name":"Person in Motorized Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f9d1-200d-1f9bc","native":"\uD83E\uDDD1\u200D\uD83E\uDDBC"},{"unified":"1f9d1-1f3fb-200d-1f9bc","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBC"},{"unified":"1f9d1-1f3fc-200d-1f9bc","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBC"},{"unified":"1f9d1-1f3fd-200d-1f9bc","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBC"},{"unified":"1f9d1-1f3fe-200d-1f9bc","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBC"},{"unified":"1f9d1-1f3ff-200d-1f9bc","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBC"}],"version":12.1},"man_in_motorized_wheelchair":{"id":"man_in_motorized_wheelchair","name":"Man in Motorized Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f468-200d-1f9bc","native":"\uD83D\uDC68\u200D\uD83E\uDDBC"},{"unified":"1f468-1f3fb-200d-1f9bc","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBC"},{"unified":"1f468-1f3fc-200d-1f9bc","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBC"},{"unified":"1f468-1f3fd-200d-1f9bc","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBC"},{"unified":"1f468-1f3fe-200d-1f9bc","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBC"},{"unified":"1f468-1f3ff-200d-1f9bc","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBC"}],"version":12},"woman_in_motorized_wheelchair":{"id":"woman_in_motorized_wheelchair","name":"Woman in Motorized Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f469-200d-1f9bc","native":"\uD83D\uDC69\u200D\uD83E\uDDBC"},{"unified":"1f469-1f3fb-200d-1f9bc","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBC"},{"unified":"1f469-1f3fc-200d-1f9bc","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBC"},{"unified":"1f469-1f3fd-200d-1f9bc","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBC"},{"unified":"1f469-1f3fe-200d-1f9bc","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBC"},{"unified":"1f469-1f3ff-200d-1f9bc","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBC"}],"version":12},"person_in_manual_wheelchair":{"id":"person_in_manual_wheelchair","name":"Person in Manual Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f9d1-200d-1f9bd","native":"\uD83E\uDDD1\u200D\uD83E\uDDBD"},{"unified":"1f9d1-1f3fb-200d-1f9bd","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBD"},{"unified":"1f9d1-1f3fc-200d-1f9bd","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBD"},{"unified":"1f9d1-1f3fd-200d-1f9bd","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBD"},{"unified":"1f9d1-1f3fe-200d-1f9bd","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBD"},{"unified":"1f9d1-1f3ff-200d-1f9bd","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBD"}],"version":12.1},"man_in_manual_wheelchair":{"id":"man_in_manual_wheelchair","name":"Man in Manual Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f468-200d-1f9bd","native":"\uD83D\uDC68\u200D\uD83E\uDDBD"},{"unified":"1f468-1f3fb-200d-1f9bd","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBD"},{"unified":"1f468-1f3fc-200d-1f9bd","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBD"},{"unified":"1f468-1f3fd-200d-1f9bd","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBD"},{"unified":"1f468-1f3fe-200d-1f9bd","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBD"},{"unified":"1f468-1f3ff-200d-1f9bd","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBD"}],"version":12},"woman_in_manual_wheelchair":{"id":"woman_in_manual_wheelchair","name":"Woman in Manual Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f469-200d-1f9bd","native":"\uD83D\uDC69\u200D\uD83E\uDDBD"},{"unified":"1f469-1f3fb-200d-1f9bd","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBD"},{"unified":"1f469-1f3fc-200d-1f9bd","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBD"},{"unified":"1f469-1f3fd-200d-1f9bd","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBD"},{"unified":"1f469-1f3fe-200d-1f9bd","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBD"},{"unified":"1f469-1f3ff-200d-1f9bd","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBD"}],"version":12},"runner":{"id":"runner","name":"Runner","keywords":["running","person","move"],"skins":[{"unified":"1f3c3","native":"\uD83C\uDFC3"},{"unified":"1f3c3-1f3fb","native":"\uD83C\uDFC3\uD83C\uDFFB"},{"unified":"1f3c3-1f3fc","native":"\uD83C\uDFC3\uD83C\uDFFC"},{"unified":"1f3c3-1f3fd","native":"\uD83C\uDFC3\uD83C\uDFFD"},{"unified":"1f3c3-1f3fe","native":"\uD83C\uDFC3\uD83C\uDFFE"},{"unified":"1f3c3-1f3ff","native":"\uD83C\uDFC3\uD83C\uDFFF"}],"version":1},"man-running":{"id":"man-running","name":"Man Running","keywords":["walking","exercise","race"],"skins":[{"unified":"1f3c3-200d-2642-fe0f","native":"\uD83C\uDFC3\u200D\u2642\uFE0F"},{"unified":"1f3c3-1f3fb-200d-2642-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f3c3-1f3fc-200d-2642-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f3c3-1f3fd-200d-2642-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f3c3-1f3fe-200d-2642-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f3c3-1f3ff-200d-2642-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-running":{"id":"woman-running","name":"Woman Running","keywords":["walking","exercise","race","female"],"skins":[{"unified":"1f3c3-200d-2640-fe0f","native":"\uD83C\uDFC3\u200D\u2640\uFE0F"},{"unified":"1f3c3-1f3fb-200d-2640-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f3c3-1f3fc-200d-2640-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f3c3-1f3fd-200d-2640-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f3c3-1f3fe-200d-2640-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f3c3-1f3ff-200d-2640-fe0f","native":"\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"dancer":{"id":"dancer","name":"Dancer","keywords":["woman","dancing","female","girl","fun"],"skins":[{"unified":"1f483","native":"\uD83D\uDC83"},{"unified":"1f483-1f3fb","native":"\uD83D\uDC83\uD83C\uDFFB"},{"unified":"1f483-1f3fc","native":"\uD83D\uDC83\uD83C\uDFFC"},{"unified":"1f483-1f3fd","native":"\uD83D\uDC83\uD83C\uDFFD"},{"unified":"1f483-1f3fe","native":"\uD83D\uDC83\uD83C\uDFFE"},{"unified":"1f483-1f3ff","native":"\uD83D\uDC83\uD83C\uDFFF"}],"version":1},"man_dancing":{"id":"man_dancing","name":"Man Dancing","keywords":["male","boy","fun","dancer"],"skins":[{"unified":"1f57a","native":"\uD83D\uDD7A"},{"unified":"1f57a-1f3fb","native":"\uD83D\uDD7A\uD83C\uDFFB"},{"unified":"1f57a-1f3fc","native":"\uD83D\uDD7A\uD83C\uDFFC"},{"unified":"1f57a-1f3fd","native":"\uD83D\uDD7A\uD83C\uDFFD"},{"unified":"1f57a-1f3fe","native":"\uD83D\uDD7A\uD83C\uDFFE"},{"unified":"1f57a-1f3ff","native":"\uD83D\uDD7A\uD83C\uDFFF"}],"version":3},"man_in_business_suit_levitating":{"id":"man_in_business_suit_levitating","name":"Person in Suit Levitating","keywords":["man","business","levitate","hover","jump"],"skins":[{"unified":"1f574-fe0f","native":"\uD83D\uDD74\uFE0F"},{"unified":"1f574-1f3fb","native":"\uD83D\uDD74\uD83C\uDFFB"},{"unified":"1f574-1f3fc","native":"\uD83D\uDD74\uD83C\uDFFC"},{"unified":"1f574-1f3fd","native":"\uD83D\uDD74\uD83C\uDFFD"},{"unified":"1f574-1f3fe","native":"\uD83D\uDD74\uD83C\uDFFE"},{"unified":"1f574-1f3ff","native":"\uD83D\uDD74\uD83C\uDFFF"}],"version":1},"dancers":{"id":"dancers","name":"Woman with Bunny Ears","keywords":["dancers","people","perform","costume"],"skins":[{"unified":"1f46f","native":"\uD83D\uDC6F"}],"version":1},"men-with-bunny-ears-partying":{"id":"men-with-bunny-ears-partying","name":"Men with Bunny Ears","keywords":["with-bunny-ears-partying","man","male","boys"],"skins":[{"unified":"1f46f-200d-2642-fe0f","native":"\uD83D\uDC6F\u200D\u2642\uFE0F"}],"version":4},"women-with-bunny-ears-partying":{"id":"women-with-bunny-ears-partying","name":"Women with Bunny Ears","keywords":["with-bunny-ears-partying","woman","female","girls"],"skins":[{"unified":"1f46f-200d-2640-fe0f","native":"\uD83D\uDC6F\u200D\u2640\uFE0F"}],"version":4},"person_in_steamy_room":{"id":"person_in_steamy_room","name":"Person in Steamy Room","keywords":["relax","spa"],"skins":[{"unified":"1f9d6","native":"\uD83E\uDDD6"},{"unified":"1f9d6-1f3fb","native":"\uD83E\uDDD6\uD83C\uDFFB"},{"unified":"1f9d6-1f3fc","native":"\uD83E\uDDD6\uD83C\uDFFC"},{"unified":"1f9d6-1f3fd","native":"\uD83E\uDDD6\uD83C\uDFFD"},{"unified":"1f9d6-1f3fe","native":"\uD83E\uDDD6\uD83C\uDFFE"},{"unified":"1f9d6-1f3ff","native":"\uD83E\uDDD6\uD83C\uDFFF"}],"version":5},"man_in_steamy_room":{"id":"man_in_steamy_room","name":"Man in Steamy Room","keywords":["male","spa","steamroom","sauna"],"skins":[{"unified":"1f9d6-200d-2642-fe0f","native":"\uD83E\uDDD6\u200D\u2642\uFE0F"},{"unified":"1f9d6-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9d6-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9d6-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9d6-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9d6-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"woman_in_steamy_room":{"id":"woman_in_steamy_room","name":"Woman in Steamy Room","keywords":["female","spa","steamroom","sauna"],"skins":[{"unified":"1f9d6-200d-2640-fe0f","native":"\uD83E\uDDD6\u200D\u2640\uFE0F"},{"unified":"1f9d6-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9d6-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9d6-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9d6-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9d6-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDD6\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"person_climbing":{"id":"person_climbing","name":"Person Climbing","keywords":["sport"],"skins":[{"unified":"1f9d7","native":"\uD83E\uDDD7"},{"unified":"1f9d7-1f3fb","native":"\uD83E\uDDD7\uD83C\uDFFB"},{"unified":"1f9d7-1f3fc","native":"\uD83E\uDDD7\uD83C\uDFFC"},{"unified":"1f9d7-1f3fd","native":"\uD83E\uDDD7\uD83C\uDFFD"},{"unified":"1f9d7-1f3fe","native":"\uD83E\uDDD7\uD83C\uDFFE"},{"unified":"1f9d7-1f3ff","native":"\uD83E\uDDD7\uD83C\uDFFF"}],"version":5},"man_climbing":{"id":"man_climbing","name":"Man Climbing","keywords":["sports","hobby","male","rock"],"skins":[{"unified":"1f9d7-200d-2642-fe0f","native":"\uD83E\uDDD7\u200D\u2642\uFE0F"},{"unified":"1f9d7-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9d7-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9d7-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9d7-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9d7-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"woman_climbing":{"id":"woman_climbing","name":"Woman Climbing","keywords":["sports","hobby","female","rock"],"skins":[{"unified":"1f9d7-200d-2640-fe0f","native":"\uD83E\uDDD7\u200D\u2640\uFE0F"},{"unified":"1f9d7-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9d7-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9d7-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9d7-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9d7-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDD7\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"fencer":{"id":"fencer","name":"Fencer","keywords":["person","fencing","sports","sword"],"skins":[{"unified":"1f93a","native":"\uD83E\uDD3A"}],"version":3},"horse_racing":{"id":"horse_racing","name":"Horse Racing","keywords":["animal","betting","competition","gambling","luck"],"skins":[{"unified":"1f3c7","native":"\uD83C\uDFC7"},{"unified":"1f3c7-1f3fb","native":"\uD83C\uDFC7\uD83C\uDFFB"},{"unified":"1f3c7-1f3fc","native":"\uD83C\uDFC7\uD83C\uDFFC"},{"unified":"1f3c7-1f3fd","native":"\uD83C\uDFC7\uD83C\uDFFD"},{"unified":"1f3c7-1f3fe","native":"\uD83C\uDFC7\uD83C\uDFFE"},{"unified":"1f3c7-1f3ff","native":"\uD83C\uDFC7\uD83C\uDFFF"}],"version":1},"skier":{"id":"skier","name":"Skier","keywords":["sports","winter","snow"],"skins":[{"unified":"26f7-fe0f","native":"\u26F7\uFE0F"}],"version":1},"snowboarder":{"id":"snowboarder","name":"Snowboarder","keywords":["sports","winter"],"skins":[{"unified":"1f3c2","native":"\uD83C\uDFC2"},{"unified":"1f3c2-1f3fb","native":"\uD83C\uDFC2\uD83C\uDFFB"},{"unified":"1f3c2-1f3fc","native":"\uD83C\uDFC2\uD83C\uDFFC"},{"unified":"1f3c2-1f3fd","native":"\uD83C\uDFC2\uD83C\uDFFD"},{"unified":"1f3c2-1f3fe","native":"\uD83C\uDFC2\uD83C\uDFFE"},{"unified":"1f3c2-1f3ff","native":"\uD83C\uDFC2\uD83C\uDFFF"}],"version":1},"golfer":{"id":"golfer","name":"Person Golfing","keywords":["golfer","sports","business"],"skins":[{"unified":"1f3cc-fe0f","native":"\uD83C\uDFCC\uFE0F"},{"unified":"1f3cc-1f3fb","native":"\uD83C\uDFCC\uD83C\uDFFB"},{"unified":"1f3cc-1f3fc","native":"\uD83C\uDFCC\uD83C\uDFFC"},{"unified":"1f3cc-1f3fd","native":"\uD83C\uDFCC\uD83C\uDFFD"},{"unified":"1f3cc-1f3fe","native":"\uD83C\uDFCC\uD83C\uDFFE"},{"unified":"1f3cc-1f3ff","native":"\uD83C\uDFCC\uD83C\uDFFF"}],"version":1},"man-golfing":{"id":"man-golfing","name":"Man Golfing","keywords":["sport"],"skins":[{"unified":"1f3cc-fe0f-200d-2642-fe0f","native":"\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F"},{"unified":"1f3cc-1f3fb-200d-2642-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f3cc-1f3fc-200d-2642-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f3cc-1f3fd-200d-2642-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f3cc-1f3fe-200d-2642-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f3cc-1f3ff-200d-2642-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-golfing":{"id":"woman-golfing","name":"Woman Golfing","keywords":["sports","business","female"],"skins":[{"unified":"1f3cc-fe0f-200d-2640-fe0f","native":"\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F"},{"unified":"1f3cc-1f3fb-200d-2640-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f3cc-1f3fc-200d-2640-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f3cc-1f3fd-200d-2640-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f3cc-1f3fe-200d-2640-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f3cc-1f3ff-200d-2640-fe0f","native":"\uD83C\uDFCC\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"surfer":{"id":"surfer","name":"Surfer","keywords":["person","surfing","sport","sea"],"skins":[{"unified":"1f3c4","native":"\uD83C\uDFC4"},{"unified":"1f3c4-1f3fb","native":"\uD83C\uDFC4\uD83C\uDFFB"},{"unified":"1f3c4-1f3fc","native":"\uD83C\uDFC4\uD83C\uDFFC"},{"unified":"1f3c4-1f3fd","native":"\uD83C\uDFC4\uD83C\uDFFD"},{"unified":"1f3c4-1f3fe","native":"\uD83C\uDFC4\uD83C\uDFFE"},{"unified":"1f3c4-1f3ff","native":"\uD83C\uDFC4\uD83C\uDFFF"}],"version":1},"man-surfing":{"id":"man-surfing","name":"Man Surfing","keywords":["sports","ocean","sea","summer","beach"],"skins":[{"unified":"1f3c4-200d-2642-fe0f","native":"\uD83C\uDFC4\u200D\u2642\uFE0F"},{"unified":"1f3c4-1f3fb-200d-2642-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f3c4-1f3fc-200d-2642-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f3c4-1f3fd-200d-2642-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f3c4-1f3fe-200d-2642-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f3c4-1f3ff-200d-2642-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-surfing":{"id":"woman-surfing","name":"Woman Surfing","keywords":["sports","ocean","sea","summer","beach","female"],"skins":[{"unified":"1f3c4-200d-2640-fe0f","native":"\uD83C\uDFC4\u200D\u2640\uFE0F"},{"unified":"1f3c4-1f3fb-200d-2640-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f3c4-1f3fc-200d-2640-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f3c4-1f3fd-200d-2640-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f3c4-1f3fe-200d-2640-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f3c4-1f3ff-200d-2640-fe0f","native":"\uD83C\uDFC4\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"rowboat":{"id":"rowboat","name":"Rowboat","keywords":["person","rowing","boat","sport","move"],"skins":[{"unified":"1f6a3","native":"\uD83D\uDEA3"},{"unified":"1f6a3-1f3fb","native":"\uD83D\uDEA3\uD83C\uDFFB"},{"unified":"1f6a3-1f3fc","native":"\uD83D\uDEA3\uD83C\uDFFC"},{"unified":"1f6a3-1f3fd","native":"\uD83D\uDEA3\uD83C\uDFFD"},{"unified":"1f6a3-1f3fe","native":"\uD83D\uDEA3\uD83C\uDFFE"},{"unified":"1f6a3-1f3ff","native":"\uD83D\uDEA3\uD83C\uDFFF"}],"version":1},"man-rowing-boat":{"id":"man-rowing-boat","name":"Man Rowing Boat","keywords":["rowing-boat","sports","hobby","water","ship"],"skins":[{"unified":"1f6a3-200d-2642-fe0f","native":"\uD83D\uDEA3\u200D\u2642\uFE0F"},{"unified":"1f6a3-1f3fb-200d-2642-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f6a3-1f3fc-200d-2642-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f6a3-1f3fd-200d-2642-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f6a3-1f3fe-200d-2642-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f6a3-1f3ff-200d-2642-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-rowing-boat":{"id":"woman-rowing-boat","name":"Woman Rowing Boat","keywords":["rowing-boat","sports","hobby","water","ship","female"],"skins":[{"unified":"1f6a3-200d-2640-fe0f","native":"\uD83D\uDEA3\u200D\u2640\uFE0F"},{"unified":"1f6a3-1f3fb-200d-2640-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f6a3-1f3fc-200d-2640-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f6a3-1f3fd-200d-2640-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f6a3-1f3fe-200d-2640-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f6a3-1f3ff-200d-2640-fe0f","native":"\uD83D\uDEA3\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"swimmer":{"id":"swimmer","name":"Swimmer","keywords":["person","swimming","sport","pool"],"skins":[{"unified":"1f3ca","native":"\uD83C\uDFCA"},{"unified":"1f3ca-1f3fb","native":"\uD83C\uDFCA\uD83C\uDFFB"},{"unified":"1f3ca-1f3fc","native":"\uD83C\uDFCA\uD83C\uDFFC"},{"unified":"1f3ca-1f3fd","native":"\uD83C\uDFCA\uD83C\uDFFD"},{"unified":"1f3ca-1f3fe","native":"\uD83C\uDFCA\uD83C\uDFFE"},{"unified":"1f3ca-1f3ff","native":"\uD83C\uDFCA\uD83C\uDFFF"}],"version":1},"man-swimming":{"id":"man-swimming","name":"Man Swimming","keywords":["sports","exercise","human","athlete","water","summer"],"skins":[{"unified":"1f3ca-200d-2642-fe0f","native":"\uD83C\uDFCA\u200D\u2642\uFE0F"},{"unified":"1f3ca-1f3fb-200d-2642-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f3ca-1f3fc-200d-2642-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f3ca-1f3fd-200d-2642-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f3ca-1f3fe-200d-2642-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f3ca-1f3ff-200d-2642-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-swimming":{"id":"woman-swimming","name":"Woman Swimming","keywords":["sports","exercise","human","athlete","water","summer","female"],"skins":[{"unified":"1f3ca-200d-2640-fe0f","native":"\uD83C\uDFCA\u200D\u2640\uFE0F"},{"unified":"1f3ca-1f3fb-200d-2640-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f3ca-1f3fc-200d-2640-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f3ca-1f3fd-200d-2640-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f3ca-1f3fe-200d-2640-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f3ca-1f3ff-200d-2640-fe0f","native":"\uD83C\uDFCA\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"person_with_ball":{"id":"person_with_ball","name":"Person Bouncing Ball","keywords":["with","sports","human"],"skins":[{"unified":"26f9-fe0f","native":"\u26F9\uFE0F"},{"unified":"26f9-1f3fb","native":"\u26F9\uD83C\uDFFB"},{"unified":"26f9-1f3fc","native":"\u26F9\uD83C\uDFFC"},{"unified":"26f9-1f3fd","native":"\u26F9\uD83C\uDFFD"},{"unified":"26f9-1f3fe","native":"\u26F9\uD83C\uDFFE"},{"unified":"26f9-1f3ff","native":"\u26F9\uD83C\uDFFF"}],"version":1},"man-bouncing-ball":{"id":"man-bouncing-ball","name":"Man Bouncing Ball","keywords":["bouncing-ball","sport"],"skins":[{"unified":"26f9-fe0f-200d-2642-fe0f","native":"\u26F9\uFE0F\u200D\u2642\uFE0F"},{"unified":"26f9-1f3fb-200d-2642-fe0f","native":"\u26F9\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"26f9-1f3fc-200d-2642-fe0f","native":"\u26F9\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"26f9-1f3fd-200d-2642-fe0f","native":"\u26F9\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"26f9-1f3fe-200d-2642-fe0f","native":"\u26F9\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"26f9-1f3ff-200d-2642-fe0f","native":"\u26F9\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-bouncing-ball":{"id":"woman-bouncing-ball","name":"Woman Bouncing Ball","keywords":["bouncing-ball","sports","human","female"],"skins":[{"unified":"26f9-fe0f-200d-2640-fe0f","native":"\u26F9\uFE0F\u200D\u2640\uFE0F"},{"unified":"26f9-1f3fb-200d-2640-fe0f","native":"\u26F9\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"26f9-1f3fc-200d-2640-fe0f","native":"\u26F9\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"26f9-1f3fd-200d-2640-fe0f","native":"\u26F9\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"26f9-1f3fe-200d-2640-fe0f","native":"\u26F9\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"26f9-1f3ff-200d-2640-fe0f","native":"\u26F9\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"weight_lifter":{"id":"weight_lifter","name":"Person Lifting Weights","keywords":["weight","lifter","sports","training","exercise"],"skins":[{"unified":"1f3cb-fe0f","native":"\uD83C\uDFCB\uFE0F"},{"unified":"1f3cb-1f3fb","native":"\uD83C\uDFCB\uD83C\uDFFB"},{"unified":"1f3cb-1f3fc","native":"\uD83C\uDFCB\uD83C\uDFFC"},{"unified":"1f3cb-1f3fd","native":"\uD83C\uDFCB\uD83C\uDFFD"},{"unified":"1f3cb-1f3fe","native":"\uD83C\uDFCB\uD83C\uDFFE"},{"unified":"1f3cb-1f3ff","native":"\uD83C\uDFCB\uD83C\uDFFF"}],"version":1},"man-lifting-weights":{"id":"man-lifting-weights","name":"Man Lifting Weights","keywords":["lifting-weights","sport"],"skins":[{"unified":"1f3cb-fe0f-200d-2642-fe0f","native":"\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F"},{"unified":"1f3cb-1f3fb-200d-2642-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f3cb-1f3fc-200d-2642-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f3cb-1f3fd-200d-2642-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f3cb-1f3fe-200d-2642-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f3cb-1f3ff-200d-2642-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-lifting-weights":{"id":"woman-lifting-weights","name":"Woman Lifting Weights","keywords":["lifting-weights","sports","training","exercise","female"],"skins":[{"unified":"1f3cb-fe0f-200d-2640-fe0f","native":"\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F"},{"unified":"1f3cb-1f3fb-200d-2640-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f3cb-1f3fc-200d-2640-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f3cb-1f3fd-200d-2640-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f3cb-1f3fe-200d-2640-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f3cb-1f3ff-200d-2640-fe0f","native":"\uD83C\uDFCB\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"bicyclist":{"id":"bicyclist","name":"Bicyclist","keywords":["person","biking","sport","move"],"skins":[{"unified":"1f6b4","native":"\uD83D\uDEB4"},{"unified":"1f6b4-1f3fb","native":"\uD83D\uDEB4\uD83C\uDFFB"},{"unified":"1f6b4-1f3fc","native":"\uD83D\uDEB4\uD83C\uDFFC"},{"unified":"1f6b4-1f3fd","native":"\uD83D\uDEB4\uD83C\uDFFD"},{"unified":"1f6b4-1f3fe","native":"\uD83D\uDEB4\uD83C\uDFFE"},{"unified":"1f6b4-1f3ff","native":"\uD83D\uDEB4\uD83C\uDFFF"}],"version":1},"man-biking":{"id":"man-biking","name":"Man Biking","keywords":["sports","bike","exercise","hipster"],"skins":[{"unified":"1f6b4-200d-2642-fe0f","native":"\uD83D\uDEB4\u200D\u2642\uFE0F"},{"unified":"1f6b4-1f3fb-200d-2642-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f6b4-1f3fc-200d-2642-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f6b4-1f3fd-200d-2642-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f6b4-1f3fe-200d-2642-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f6b4-1f3ff-200d-2642-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-biking":{"id":"woman-biking","name":"Woman Biking","keywords":["sports","bike","exercise","hipster","female"],"skins":[{"unified":"1f6b4-200d-2640-fe0f","native":"\uD83D\uDEB4\u200D\u2640\uFE0F"},{"unified":"1f6b4-1f3fb-200d-2640-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f6b4-1f3fc-200d-2640-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f6b4-1f3fd-200d-2640-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f6b4-1f3fe-200d-2640-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f6b4-1f3ff-200d-2640-fe0f","native":"\uD83D\uDEB4\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"mountain_bicyclist":{"id":"mountain_bicyclist","name":"Mountain Bicyclist","keywords":["person","biking","sport","move"],"skins":[{"unified":"1f6b5","native":"\uD83D\uDEB5"},{"unified":"1f6b5-1f3fb","native":"\uD83D\uDEB5\uD83C\uDFFB"},{"unified":"1f6b5-1f3fc","native":"\uD83D\uDEB5\uD83C\uDFFC"},{"unified":"1f6b5-1f3fd","native":"\uD83D\uDEB5\uD83C\uDFFD"},{"unified":"1f6b5-1f3fe","native":"\uD83D\uDEB5\uD83C\uDFFE"},{"unified":"1f6b5-1f3ff","native":"\uD83D\uDEB5\uD83C\uDFFF"}],"version":1},"man-mountain-biking":{"id":"man-mountain-biking","name":"Man Mountain Biking","keywords":["mountain-biking","transportation","sports","human","race","bike"],"skins":[{"unified":"1f6b5-200d-2642-fe0f","native":"\uD83D\uDEB5\u200D\u2642\uFE0F"},{"unified":"1f6b5-1f3fb-200d-2642-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f6b5-1f3fc-200d-2642-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f6b5-1f3fd-200d-2642-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f6b5-1f3fe-200d-2642-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f6b5-1f3ff-200d-2642-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-mountain-biking":{"id":"woman-mountain-biking","name":"Woman Mountain Biking","keywords":["mountain-biking","transportation","sports","human","race","bike","female"],"skins":[{"unified":"1f6b5-200d-2640-fe0f","native":"\uD83D\uDEB5\u200D\u2640\uFE0F"},{"unified":"1f6b5-1f3fb-200d-2640-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f6b5-1f3fc-200d-2640-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f6b5-1f3fd-200d-2640-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f6b5-1f3fe-200d-2640-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f6b5-1f3ff-200d-2640-fe0f","native":"\uD83D\uDEB5\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"person_doing_cartwheel":{"id":"person_doing_cartwheel","name":"Person Cartwheeling","keywords":["doing","cartwheel","sport","gymnastic"],"skins":[{"unified":"1f938","native":"\uD83E\uDD38"},{"unified":"1f938-1f3fb","native":"\uD83E\uDD38\uD83C\uDFFB"},{"unified":"1f938-1f3fc","native":"\uD83E\uDD38\uD83C\uDFFC"},{"unified":"1f938-1f3fd","native":"\uD83E\uDD38\uD83C\uDFFD"},{"unified":"1f938-1f3fe","native":"\uD83E\uDD38\uD83C\uDFFE"},{"unified":"1f938-1f3ff","native":"\uD83E\uDD38\uD83C\uDFFF"}],"version":3},"man-cartwheeling":{"id":"man-cartwheeling","name":"Man Cartwheeling","keywords":["gymnastics"],"skins":[{"unified":"1f938-200d-2642-fe0f","native":"\uD83E\uDD38\u200D\u2642\uFE0F"},{"unified":"1f938-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD38\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f938-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD38\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f938-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD38\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f938-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD38\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f938-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD38\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-cartwheeling":{"id":"woman-cartwheeling","name":"Woman Cartwheeling","keywords":["gymnastics"],"skins":[{"unified":"1f938-200d-2640-fe0f","native":"\uD83E\uDD38\u200D\u2640\uFE0F"},{"unified":"1f938-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD38\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f938-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD38\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f938-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD38\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f938-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD38\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f938-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD38\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"wrestlers":{"id":"wrestlers","name":"Wrestlers","keywords":["people","wrestling","sport"],"skins":[{"unified":"1f93c","native":"\uD83E\uDD3C"}],"version":3},"man-wrestling":{"id":"man-wrestling","name":"Men Wrestling","keywords":["man","sports","wrestlers"],"skins":[{"unified":"1f93c-200d-2642-fe0f","native":"\uD83E\uDD3C\u200D\u2642\uFE0F"}],"version":4},"woman-wrestling":{"id":"woman-wrestling","name":"Women Wrestling","keywords":["woman","sports","wrestlers"],"skins":[{"unified":"1f93c-200d-2640-fe0f","native":"\uD83E\uDD3C\u200D\u2640\uFE0F"}],"version":4},"water_polo":{"id":"water_polo","name":"Water Polo","keywords":["person","playing","sport"],"skins":[{"unified":"1f93d","native":"\uD83E\uDD3D"},{"unified":"1f93d-1f3fb","native":"\uD83E\uDD3D\uD83C\uDFFB"},{"unified":"1f93d-1f3fc","native":"\uD83E\uDD3D\uD83C\uDFFC"},{"unified":"1f93d-1f3fd","native":"\uD83E\uDD3D\uD83C\uDFFD"},{"unified":"1f93d-1f3fe","native":"\uD83E\uDD3D\uD83C\uDFFE"},{"unified":"1f93d-1f3ff","native":"\uD83E\uDD3D\uD83C\uDFFF"}],"version":3},"man-playing-water-polo":{"id":"man-playing-water-polo","name":"Man Playing Water Polo","keywords":["playing-water-polo","sports","pool"],"skins":[{"unified":"1f93d-200d-2642-fe0f","native":"\uD83E\uDD3D\u200D\u2642\uFE0F"},{"unified":"1f93d-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f93d-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f93d-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f93d-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f93d-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-playing-water-polo":{"id":"woman-playing-water-polo","name":"Woman Playing Water Polo","keywords":["playing-water-polo","sports","pool"],"skins":[{"unified":"1f93d-200d-2640-fe0f","native":"\uD83E\uDD3D\u200D\u2640\uFE0F"},{"unified":"1f93d-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f93d-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f93d-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f93d-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f93d-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD3D\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"handball":{"id":"handball","name":"Handball","keywords":["person","playing","sport"],"skins":[{"unified":"1f93e","native":"\uD83E\uDD3E"},{"unified":"1f93e-1f3fb","native":"\uD83E\uDD3E\uD83C\uDFFB"},{"unified":"1f93e-1f3fc","native":"\uD83E\uDD3E\uD83C\uDFFC"},{"unified":"1f93e-1f3fd","native":"\uD83E\uDD3E\uD83C\uDFFD"},{"unified":"1f93e-1f3fe","native":"\uD83E\uDD3E\uD83C\uDFFE"},{"unified":"1f93e-1f3ff","native":"\uD83E\uDD3E\uD83C\uDFFF"}],"version":3},"man-playing-handball":{"id":"man-playing-handball","name":"Man Playing Handball","keywords":["playing-handball","sports"],"skins":[{"unified":"1f93e-200d-2642-fe0f","native":"\uD83E\uDD3E\u200D\u2642\uFE0F"},{"unified":"1f93e-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f93e-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f93e-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f93e-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f93e-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-playing-handball":{"id":"woman-playing-handball","name":"Woman Playing Handball","keywords":["playing-handball","sports"],"skins":[{"unified":"1f93e-200d-2640-fe0f","native":"\uD83E\uDD3E\u200D\u2640\uFE0F"},{"unified":"1f93e-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f93e-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f93e-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f93e-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f93e-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD3E\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"juggling":{"id":"juggling","name":"Juggling","keywords":["person","performance","balance"],"skins":[{"unified":"1f939","native":"\uD83E\uDD39"},{"unified":"1f939-1f3fb","native":"\uD83E\uDD39\uD83C\uDFFB"},{"unified":"1f939-1f3fc","native":"\uD83E\uDD39\uD83C\uDFFC"},{"unified":"1f939-1f3fd","native":"\uD83E\uDD39\uD83C\uDFFD"},{"unified":"1f939-1f3fe","native":"\uD83E\uDD39\uD83C\uDFFE"},{"unified":"1f939-1f3ff","native":"\uD83E\uDD39\uD83C\uDFFF"}],"version":3},"man-juggling":{"id":"man-juggling","name":"Man Juggling","keywords":["juggle","balance","skill","multitask"],"skins":[{"unified":"1f939-200d-2642-fe0f","native":"\uD83E\uDD39\u200D\u2642\uFE0F"},{"unified":"1f939-1f3fb-200d-2642-fe0f","native":"\uD83E\uDD39\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f939-1f3fc-200d-2642-fe0f","native":"\uD83E\uDD39\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f939-1f3fd-200d-2642-fe0f","native":"\uD83E\uDD39\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f939-1f3fe-200d-2642-fe0f","native":"\uD83E\uDD39\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f939-1f3ff-200d-2642-fe0f","native":"\uD83E\uDD39\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":4},"woman-juggling":{"id":"woman-juggling","name":"Woman Juggling","keywords":["juggle","balance","skill","multitask"],"skins":[{"unified":"1f939-200d-2640-fe0f","native":"\uD83E\uDD39\u200D\u2640\uFE0F"},{"unified":"1f939-1f3fb-200d-2640-fe0f","native":"\uD83E\uDD39\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f939-1f3fc-200d-2640-fe0f","native":"\uD83E\uDD39\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f939-1f3fd-200d-2640-fe0f","native":"\uD83E\uDD39\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f939-1f3fe-200d-2640-fe0f","native":"\uD83E\uDD39\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f939-1f3ff-200d-2640-fe0f","native":"\uD83E\uDD39\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":4},"person_in_lotus_position":{"id":"person_in_lotus_position","name":"Person in Lotus Position","keywords":["meditate"],"skins":[{"unified":"1f9d8","native":"\uD83E\uDDD8"},{"unified":"1f9d8-1f3fb","native":"\uD83E\uDDD8\uD83C\uDFFB"},{"unified":"1f9d8-1f3fc","native":"\uD83E\uDDD8\uD83C\uDFFC"},{"unified":"1f9d8-1f3fd","native":"\uD83E\uDDD8\uD83C\uDFFD"},{"unified":"1f9d8-1f3fe","native":"\uD83E\uDDD8\uD83C\uDFFE"},{"unified":"1f9d8-1f3ff","native":"\uD83E\uDDD8\uD83C\uDFFF"}],"version":5},"man_in_lotus_position":{"id":"man_in_lotus_position","name":"Man in Lotus Position","keywords":["male","meditation","yoga","serenity","zen","mindfulness"],"skins":[{"unified":"1f9d8-200d-2642-fe0f","native":"\uD83E\uDDD8\u200D\u2642\uFE0F"},{"unified":"1f9d8-1f3fb-200d-2642-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFB\u200D\u2642\uFE0F"},{"unified":"1f9d8-1f3fc-200d-2642-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFC\u200D\u2642\uFE0F"},{"unified":"1f9d8-1f3fd-200d-2642-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFD\u200D\u2642\uFE0F"},{"unified":"1f9d8-1f3fe-200d-2642-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFE\u200D\u2642\uFE0F"},{"unified":"1f9d8-1f3ff-200d-2642-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFF\u200D\u2642\uFE0F"}],"version":5},"woman_in_lotus_position":{"id":"woman_in_lotus_position","name":"Woman in Lotus Position","keywords":["female","meditation","yoga","serenity","zen","mindfulness"],"skins":[{"unified":"1f9d8-200d-2640-fe0f","native":"\uD83E\uDDD8\u200D\u2640\uFE0F"},{"unified":"1f9d8-1f3fb-200d-2640-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFB\u200D\u2640\uFE0F"},{"unified":"1f9d8-1f3fc-200d-2640-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFC\u200D\u2640\uFE0F"},{"unified":"1f9d8-1f3fd-200d-2640-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFD\u200D\u2640\uFE0F"},{"unified":"1f9d8-1f3fe-200d-2640-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFE\u200D\u2640\uFE0F"},{"unified":"1f9d8-1f3ff-200d-2640-fe0f","native":"\uD83E\uDDD8\uD83C\uDFFF\u200D\u2640\uFE0F"}],"version":5},"bath":{"id":"bath","name":"Bath","keywords":["person","taking","clean","shower","bathroom"],"skins":[{"unified":"1f6c0","native":"\uD83D\uDEC0"},{"unified":"1f6c0-1f3fb","native":"\uD83D\uDEC0\uD83C\uDFFB"},{"unified":"1f6c0-1f3fc","native":"\uD83D\uDEC0\uD83C\uDFFC"},{"unified":"1f6c0-1f3fd","native":"\uD83D\uDEC0\uD83C\uDFFD"},{"unified":"1f6c0-1f3fe","native":"\uD83D\uDEC0\uD83C\uDFFE"},{"unified":"1f6c0-1f3ff","native":"\uD83D\uDEC0\uD83C\uDFFF"}],"version":1},"sleeping_accommodation":{"id":"sleeping_accommodation","name":"Person in Bed","keywords":["sleeping","accommodation","rest"],"skins":[{"unified":"1f6cc","native":"\uD83D\uDECC"},{"unified":"1f6cc-1f3fb","native":"\uD83D\uDECC\uD83C\uDFFB"},{"unified":"1f6cc-1f3fc","native":"\uD83D\uDECC\uD83C\uDFFC"},{"unified":"1f6cc-1f3fd","native":"\uD83D\uDECC\uD83C\uDFFD"},{"unified":"1f6cc-1f3fe","native":"\uD83D\uDECC\uD83C\uDFFE"},{"unified":"1f6cc-1f3ff","native":"\uD83D\uDECC\uD83C\uDFFF"}],"version":1},"people_holding_hands":{"id":"people_holding_hands","name":"People Holding Hands","keywords":["friendship"],"skins":[{"unified":"1f9d1-200d-1f91d-200d-1f9d1","native":"\uD83E\uDDD1\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1"},{"unified":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb","native":"\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB"},{"unified":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc","native":"\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC"},{"unified":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd","native":"\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD"},{"unified":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe","native":"\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE"},{"unified":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff","native":"\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF"}],"version":12},"two_women_holding_hands":{"id":"two_women_holding_hands","name":"Women Holding Hands","keywords":["two","pair","friendship","couple","love","like","female","people","human"],"skins":[{"unified":"1f46d","native":"\uD83D\uDC6D"},{"unified":"1f46d-1f3fb","native":"\uD83D\uDC6D\uD83C\uDFFB"},{"unified":"1f46d-1f3fc","native":"\uD83D\uDC6D\uD83C\uDFFC"},{"unified":"1f46d-1f3fd","native":"\uD83D\uDC6D\uD83C\uDFFD"},{"unified":"1f46d-1f3fe","native":"\uD83D\uDC6D\uD83C\uDFFE"},{"unified":"1f46d-1f3ff","native":"\uD83D\uDC6D\uD83C\uDFFF"}],"version":1},"man_and_woman_holding_hands":{"id":"man_and_woman_holding_hands","name":"Man and Woman Holding Hands","keywords":["couple","pair","people","human","love","date","dating","like","affection","valentines","marriage"],"skins":[{"unified":"1f46b","native":"\uD83D\uDC6B"},{"unified":"1f46b-1f3fb","native":"\uD83D\uDC6B\uD83C\uDFFB"},{"unified":"1f46b-1f3fc","native":"\uD83D\uDC6B\uD83C\uDFFC"},{"unified":"1f46b-1f3fd","native":"\uD83D\uDC6B\uD83C\uDFFD"},{"unified":"1f46b-1f3fe","native":"\uD83D\uDC6B\uD83C\uDFFE"},{"unified":"1f46b-1f3ff","native":"\uD83D\uDC6B\uD83C\uDFFF"}],"version":1},"two_men_holding_hands":{"id":"two_men_holding_hands","name":"Men Holding Hands","keywords":["two","pair","couple","love","like","bromance","friendship","people","human"],"skins":[{"unified":"1f46c","native":"\uD83D\uDC6C"},{"unified":"1f46c-1f3fb","native":"\uD83D\uDC6C\uD83C\uDFFB"},{"unified":"1f46c-1f3fc","native":"\uD83D\uDC6C\uD83C\uDFFC"},{"unified":"1f46c-1f3fd","native":"\uD83D\uDC6C\uD83C\uDFFD"},{"unified":"1f46c-1f3fe","native":"\uD83D\uDC6C\uD83C\uDFFE"},{"unified":"1f46c-1f3ff","native":"\uD83D\uDC6C\uD83C\uDFFF"}],"version":1},"couplekiss":{"id":"couplekiss","name":"Kiss","keywords":["couplekiss","pair","valentines","love","like","dating","marriage"],"skins":[{"unified":"1f48f","native":"\uD83D\uDC8F"},{"unified":"1f48f-1f3fb","native":"\uD83D\uDC8F\uD83C\uDFFB"},{"unified":"1f48f-1f3fc","native":"\uD83D\uDC8F\uD83C\uDFFC"},{"unified":"1f48f-1f3fd","native":"\uD83D\uDC8F\uD83C\uDFFD"},{"unified":"1f48f-1f3fe","native":"\uD83D\uDC8F\uD83C\uDFFE"},{"unified":"1f48f-1f3ff","native":"\uD83D\uDC8F\uD83C\uDFFF"}],"version":1},"woman-kiss-man":{"id":"woman-kiss-man","name":"Kiss: Woman, Man","keywords":["woman","kiss-man","kiss","love"],"skins":[{"unified":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f468","native":"\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68"},{"unified":"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"},{"unified":"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"},{"unified":"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"},{"unified":"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"},{"unified":"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"}],"version":2},"man-kiss-man":{"id":"man-kiss-man","name":"Kiss: Man, Man","keywords":["kiss-man","kiss","pair","valentines","love","like","dating","marriage"],"skins":[{"unified":"1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","native":"\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68"},{"unified":"1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"},{"unified":"1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"},{"unified":"1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"},{"unified":"1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"},{"unified":"1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"}],"version":2},"woman-kiss-woman":{"id":"woman-kiss-woman","name":"Kiss: Woman, Woman","keywords":["kiss-woman","kiss","pair","valentines","love","like","dating","marriage"],"skins":[{"unified":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","native":"\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69"},{"unified":"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB"},{"unified":"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC"},{"unified":"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD"},{"unified":"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE"},{"unified":"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF"}],"version":2},"couple_with_heart":{"id":"couple_with_heart","name":"Couple with Heart","keywords":["pair","love","like","affection","human","dating","valentines","marriage"],"skins":[{"unified":"1f491","native":"\uD83D\uDC91"},{"unified":"1f491-1f3fb","native":"\uD83D\uDC91\uD83C\uDFFB"},{"unified":"1f491-1f3fc","native":"\uD83D\uDC91\uD83C\uDFFC"},{"unified":"1f491-1f3fd","native":"\uD83D\uDC91\uD83C\uDFFD"},{"unified":"1f491-1f3fe","native":"\uD83D\uDC91\uD83C\uDFFE"},{"unified":"1f491-1f3ff","native":"\uD83D\uDC91\uD83C\uDFFF"}],"version":1},"woman-heart-man":{"id":"woman-heart-man","name":"Couple with Heart: Woman, Man","keywords":["woman","heart-man","heart","love"],"skins":[{"unified":"1f469-200d-2764-fe0f-200d-1f468","native":"\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68"},{"unified":"1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"},{"unified":"1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"},{"unified":"1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"},{"unified":"1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"},{"unified":"1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"}],"version":2},"man-heart-man":{"id":"man-heart-man","name":"Couple with Heart: Man, Man","keywords":["heart-man","heart","pair","love","like","affection","human","dating","valentines","marriage"],"skins":[{"unified":"1f468-200d-2764-fe0f-200d-1f468","native":"\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68"},{"unified":"1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb","native":"\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"},{"unified":"1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc","native":"\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"},{"unified":"1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd","native":"\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"},{"unified":"1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe","native":"\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"},{"unified":"1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff","native":"\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"}],"version":2},"woman-heart-woman":{"id":"woman-heart-woman","name":"Couple with Heart: Woman, Woman","keywords":["heart-woman","heart","pair","love","like","affection","human","dating","valentines","marriage"],"skins":[{"unified":"1f469-200d-2764-fe0f-200d-1f469","native":"\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69"},{"unified":"1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb","native":"\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB"},{"unified":"1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc","native":"\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC"},{"unified":"1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd","native":"\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD"},{"unified":"1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe","native":"\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE"},{"unified":"1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff","native":"\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF"}],"version":2},"family":{"id":"family","name":"Family","keywords":["home","parents","child","mom","dad","father","mother","people","human"],"skins":[{"unified":"1f46a","native":"\uD83D\uDC6A"}],"version":1},"man-woman-boy":{"id":"man-woman-boy","name":"Family: Man, Woman, Boy","keywords":["man","woman-boy","family","woman","love"],"skins":[{"unified":"1f468-200d-1f469-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66"}],"version":2},"man-woman-girl":{"id":"man-woman-girl","name":"Family: Man, Woman, Girl","keywords":["man","woman-girl","family","woman","home","parents","people","human","child"],"skins":[{"unified":"1f468-200d-1f469-200d-1f467","native":"\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67"}],"version":2},"man-woman-girl-boy":{"id":"man-woman-girl-boy","name":"Family: Man, Woman, Girl, Boy","keywords":["man","woman-girl-boy","family","woman","girl","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f469-200d-1f467-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66"}],"version":2},"man-woman-boy-boy":{"id":"man-woman-boy-boy","name":"Family: Man, Woman, Boy, Boy","keywords":["man","woman-boy-boy","family","woman","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f469-200d-1f466-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66"}],"version":2},"man-woman-girl-girl":{"id":"man-woman-girl-girl","name":"Family: Man, Woman, Girl, Girl","keywords":["man","woman-girl-girl","family","woman","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f469-200d-1f467-200d-1f467","native":"\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67"}],"version":2},"man-man-boy":{"id":"man-man-boy","name":"Family: Man, Man, Boy","keywords":["man","man-boy","family","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66"}],"version":2},"man-man-girl":{"id":"man-man-girl","name":"Family: Man, Man, Girl","keywords":["man","man-girl","family","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f467","native":"\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67"}],"version":2},"man-man-girl-boy":{"id":"man-man-girl-boy","name":"Family: Man, Man, Girl, Boy","keywords":["man","man-girl-boy","family","girl","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f467-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66"}],"version":2},"man-man-boy-boy":{"id":"man-man-boy-boy","name":"Family: Man, Man, Boy, Boy","keywords":["man","man-boy-boy","family","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f466-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66"}],"version":2},"man-man-girl-girl":{"id":"man-man-girl-girl","name":"Family: Man, Man, Girl, Girl","keywords":["man","man-girl-girl","family","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f467-200d-1f467","native":"\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67"}],"version":2},"woman-woman-boy":{"id":"woman-woman-boy","name":"Family: Woman, Woman, Boy","keywords":["woman","woman-boy","family","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f466","native":"\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66"}],"version":2},"woman-woman-girl":{"id":"woman-woman-girl","name":"Family: Woman, Woman, Girl","keywords":["woman","woman-girl","family","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f467","native":"\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67"}],"version":2},"woman-woman-girl-boy":{"id":"woman-woman-girl-boy","name":"Family: Woman, Woman, Girl, Boy","keywords":["woman","woman-girl-boy","family","girl","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f467-200d-1f466","native":"\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66"}],"version":2},"woman-woman-boy-boy":{"id":"woman-woman-boy-boy","name":"Family: Woman, Woman, Boy, Boy","keywords":["woman","woman-boy-boy","family","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f466-200d-1f466","native":"\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66"}],"version":2},"woman-woman-girl-girl":{"id":"woman-woman-girl-girl","name":"Family: Woman, Woman, Girl, Girl","keywords":["woman","woman-girl-girl","family","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f467-200d-1f467","native":"\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67"}],"version":2},"man-boy":{"id":"man-boy","name":"Family: Man, Boy","keywords":["man","family","home","parent","people","human","child"],"skins":[{"unified":"1f468-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC66"}],"version":4},"man-boy-boy":{"id":"man-boy-boy","name":"Family: Man, Boy, Boy","keywords":["man","boy-boy","family","home","parent","people","human","children"],"skins":[{"unified":"1f468-200d-1f466-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66"}],"version":4},"man-girl":{"id":"man-girl","name":"Family: Man, Girl","keywords":["man","family","home","parent","people","human","child"],"skins":[{"unified":"1f468-200d-1f467","native":"\uD83D\uDC68\u200D\uD83D\uDC67"}],"version":4},"man-girl-boy":{"id":"man-girl-boy","name":"Family: Man, Girl, Boy","keywords":["man","girl-boy","family","girl","home","parent","people","human","children"],"skins":[{"unified":"1f468-200d-1f467-200d-1f466","native":"\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66"}],"version":4},"man-girl-girl":{"id":"man-girl-girl","name":"Family: Man, Girl, Girl","keywords":["man","girl-girl","family","home","parent","people","human","children"],"skins":[{"unified":"1f468-200d-1f467-200d-1f467","native":"\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67"}],"version":4},"woman-boy":{"id":"woman-boy","name":"Family: Woman, Boy","keywords":["woman","family","home","parent","people","human","child"],"skins":[{"unified":"1f469-200d-1f466","native":"\uD83D\uDC69\u200D\uD83D\uDC66"}],"version":4},"woman-boy-boy":{"id":"woman-boy-boy","name":"Family: Woman, Boy, Boy","keywords":["woman","boy-boy","family","home","parent","people","human","children"],"skins":[{"unified":"1f469-200d-1f466-200d-1f466","native":"\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66"}],"version":4},"woman-girl":{"id":"woman-girl","name":"Family: Woman, Girl","keywords":["woman","family","home","parent","people","human","child"],"skins":[{"unified":"1f469-200d-1f467","native":"\uD83D\uDC69\u200D\uD83D\uDC67"}],"version":4},"woman-girl-boy":{"id":"woman-girl-boy","name":"Family: Woman, Girl, Boy","keywords":["woman","girl-boy","family","girl","home","parent","people","human","children"],"skins":[{"unified":"1f469-200d-1f467-200d-1f466","native":"\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66"}],"version":4},"woman-girl-girl":{"id":"woman-girl-girl","name":"Family: Woman, Girl, Girl","keywords":["woman","girl-girl","family","home","parent","people","human","children"],"skins":[{"unified":"1f469-200d-1f467-200d-1f467","native":"\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67"}],"version":4},"speaking_head_in_silhouette":{"id":"speaking_head_in_silhouette","name":"Speaking Head","keywords":["in","silhouette","user","person","human","sing","say","talk"],"skins":[{"unified":"1f5e3-fe0f","native":"\uD83D\uDDE3\uFE0F"}],"version":1},"bust_in_silhouette":{"id":"bust_in_silhouette","name":"Bust in Silhouette","keywords":["user","person","human"],"skins":[{"unified":"1f464","native":"\uD83D\uDC64"}],"version":1},"busts_in_silhouette":{"id":"busts_in_silhouette","name":"Busts in Silhouette","keywords":["user","person","human","group","team"],"skins":[{"unified":"1f465","native":"\uD83D\uDC65"}],"version":1},"people_hugging":{"id":"people_hugging","name":"People Hugging","keywords":["care"],"skins":[{"unified":"1fac2","native":"\uD83E\uDEC2"}],"version":13},"footprints":{"id":"footprints","name":"Footprints","keywords":["feet","tracking","walking","beach"],"skins":[{"unified":"1f463","native":"\uD83D\uDC63"}],"version":1},"monkey_face":{"id":"monkey_face","name":"Monkey Face","emoticons":[":o)"],"keywords":["animal","nature","circus"],"skins":[{"unified":"1f435","native":"\uD83D\uDC35"}],"version":1},"monkey":{"id":"monkey","name":"Monkey","keywords":["animal","nature","banana","circus"],"skins":[{"unified":"1f412","native":"\uD83D\uDC12"}],"version":1},"gorilla":{"id":"gorilla","name":"Gorilla","keywords":["animal","nature","circus"],"skins":[{"unified":"1f98d","native":"\uD83E\uDD8D"}],"version":3},"orangutan":{"id":"orangutan","name":"Orangutan","keywords":["animal"],"skins":[{"unified":"1f9a7","native":"\uD83E\uDDA7"}],"version":12},"dog":{"id":"dog","name":"Dog Face","keywords":["animal","friend","nature","woof","puppy","pet","faithful"],"skins":[{"unified":"1f436","native":"\uD83D\uDC36"}],"version":1},"dog2":{"id":"dog2","name":"Dog","keywords":["dog2","animal","nature","friend","doge","pet","faithful"],"skins":[{"unified":"1f415","native":"\uD83D\uDC15"}],"version":1},"guide_dog":{"id":"guide_dog","name":"Guide Dog","keywords":["animal","blind"],"skins":[{"unified":"1f9ae","native":"\uD83E\uDDAE"}],"version":12},"service_dog":{"id":"service_dog","name":"Service Dog","keywords":["blind","animal"],"skins":[{"unified":"1f415-200d-1f9ba","native":"\uD83D\uDC15\u200D\uD83E\uDDBA"}],"version":12},"poodle":{"id":"poodle","name":"Poodle","keywords":["dog","animal","101","nature","pet"],"skins":[{"unified":"1f429","native":"\uD83D\uDC29"}],"version":1},"wolf":{"id":"wolf","name":"Wolf","keywords":["animal","nature","wild"],"skins":[{"unified":"1f43a","native":"\uD83D\uDC3A"}],"version":1},"fox_face":{"id":"fox_face","name":"Fox","keywords":["face","animal","nature"],"skins":[{"unified":"1f98a","native":"\uD83E\uDD8A"}],"version":3},"raccoon":{"id":"raccoon","name":"Raccoon","keywords":["animal","nature"],"skins":[{"unified":"1f99d","native":"\uD83E\uDD9D"}],"version":11},"cat":{"id":"cat","name":"Cat Face","keywords":["animal","meow","nature","pet","kitten"],"skins":[{"unified":"1f431","native":"\uD83D\uDC31"}],"version":1},"cat2":{"id":"cat2","name":"Cat","keywords":["cat2","animal","meow","pet","cats"],"skins":[{"unified":"1f408","native":"\uD83D\uDC08"}],"version":1},"black_cat":{"id":"black_cat","name":"Black Cat","keywords":["superstition","luck"],"skins":[{"unified":"1f408-200d-2b1b","native":"\uD83D\uDC08\u200D\u2B1B"}],"version":13},"lion_face":{"id":"lion_face","name":"Lion","keywords":["face","animal","nature"],"skins":[{"unified":"1f981","native":"\uD83E\uDD81"}],"version":1},"tiger":{"id":"tiger","name":"Tiger Face","keywords":["animal","cat","danger","wild","nature","roar"],"skins":[{"unified":"1f42f","native":"\uD83D\uDC2F"}],"version":1},"tiger2":{"id":"tiger2","name":"Tiger","keywords":["tiger2","animal","nature","roar"],"skins":[{"unified":"1f405","native":"\uD83D\uDC05"}],"version":1},"leopard":{"id":"leopard","name":"Leopard","keywords":["animal","nature"],"skins":[{"unified":"1f406","native":"\uD83D\uDC06"}],"version":1},"horse":{"id":"horse","name":"Horse Face","keywords":["animal","brown","nature"],"skins":[{"unified":"1f434","native":"\uD83D\uDC34"}],"version":1},"moose":{"id":"moose","name":"Moose","keywords":["shrek","canada","sweden","sven","cool"],"skins":[{"unified":"1face","native":"\uD83E\uDECE"}],"version":15},"donkey":{"id":"donkey","name":"Donkey","keywords":["eeyore","mule"],"skins":[{"unified":"1facf","native":"\uD83E\uDECF"}],"version":15},"racehorse":{"id":"racehorse","name":"Horse","keywords":["racehorse","animal","gamble","luck"],"skins":[{"unified":"1f40e","native":"\uD83D\uDC0E"}],"version":1},"unicorn_face":{"id":"unicorn_face","name":"Unicorn","keywords":["face","animal","nature","mystical"],"skins":[{"unified":"1f984","native":"\uD83E\uDD84"}],"version":1},"zebra_face":{"id":"zebra_face","name":"Zebra","keywords":["face","animal","nature","stripes","safari"],"skins":[{"unified":"1f993","native":"\uD83E\uDD93"}],"version":5},"deer":{"id":"deer","name":"Deer","keywords":["animal","nature","horns","venison"],"skins":[{"unified":"1f98c","native":"\uD83E\uDD8C"}],"version":3},"bison":{"id":"bison","name":"Bison","keywords":["ox"],"skins":[{"unified":"1f9ac","native":"\uD83E\uDDAC"}],"version":13},"cow":{"id":"cow","name":"Cow Face","keywords":["beef","ox","animal","nature","moo","milk"],"skins":[{"unified":"1f42e","native":"\uD83D\uDC2E"}],"version":1},"ox":{"id":"ox","name":"Ox","keywords":["animal","cow","beef"],"skins":[{"unified":"1f402","native":"\uD83D\uDC02"}],"version":1},"water_buffalo":{"id":"water_buffalo","name":"Water Buffalo","keywords":["animal","nature","ox","cow"],"skins":[{"unified":"1f403","native":"\uD83D\uDC03"}],"version":1},"cow2":{"id":"cow2","name":"Cow","keywords":["cow2","beef","ox","animal","nature","moo","milk"],"skins":[{"unified":"1f404","native":"\uD83D\uDC04"}],"version":1},"pig":{"id":"pig","name":"Pig Face","keywords":["animal","oink","nature"],"skins":[{"unified":"1f437","native":"\uD83D\uDC37"}],"version":1},"pig2":{"id":"pig2","name":"Pig","keywords":["pig2","animal","nature"],"skins":[{"unified":"1f416","native":"\uD83D\uDC16"}],"version":1},"boar":{"id":"boar","name":"Boar","keywords":["animal","nature"],"skins":[{"unified":"1f417","native":"\uD83D\uDC17"}],"version":1},"pig_nose":{"id":"pig_nose","name":"Pig Nose","keywords":["animal","oink"],"skins":[{"unified":"1f43d","native":"\uD83D\uDC3D"}],"version":1},"ram":{"id":"ram","name":"Ram","keywords":["animal","sheep","nature"],"skins":[{"unified":"1f40f","native":"\uD83D\uDC0F"}],"version":1},"sheep":{"id":"sheep","name":"Ewe","keywords":["sheep","animal","nature","wool","shipit"],"skins":[{"unified":"1f411","native":"\uD83D\uDC11"}],"version":1},"goat":{"id":"goat","name":"Goat","keywords":["animal","nature"],"skins":[{"unified":"1f410","native":"\uD83D\uDC10"}],"version":1},"dromedary_camel":{"id":"dromedary_camel","name":"Camel","keywords":["dromedary","animal","hot","desert","hump"],"skins":[{"unified":"1f42a","native":"\uD83D\uDC2A"}],"version":1},"camel":{"id":"camel","name":"Bactrian Camel","keywords":["two","hump","animal","nature","hot","desert"],"skins":[{"unified":"1f42b","native":"\uD83D\uDC2B"}],"version":1},"llama":{"id":"llama","name":"Llama","keywords":["animal","nature","alpaca"],"skins":[{"unified":"1f999","native":"\uD83E\uDD99"}],"version":11},"giraffe_face":{"id":"giraffe_face","name":"Giraffe","keywords":["face","animal","nature","spots","safari"],"skins":[{"unified":"1f992","native":"\uD83E\uDD92"}],"version":5},"elephant":{"id":"elephant","name":"Elephant","keywords":["animal","nature","nose","th","circus"],"skins":[{"unified":"1f418","native":"\uD83D\uDC18"}],"version":1},"mammoth":{"id":"mammoth","name":"Mammoth","keywords":["elephant","tusks"],"skins":[{"unified":"1f9a3","native":"\uD83E\uDDA3"}],"version":13},"rhinoceros":{"id":"rhinoceros","name":"Rhinoceros","keywords":["animal","nature","horn"],"skins":[{"unified":"1f98f","native":"\uD83E\uDD8F"}],"version":3},"hippopotamus":{"id":"hippopotamus","name":"Hippopotamus","keywords":["animal","nature"],"skins":[{"unified":"1f99b","native":"\uD83E\uDD9B"}],"version":11},"mouse":{"id":"mouse","name":"Mouse Face","keywords":["animal","nature","cheese","wedge","rodent"],"skins":[{"unified":"1f42d","native":"\uD83D\uDC2D"}],"version":1},"mouse2":{"id":"mouse2","name":"Mouse","keywords":["mouse2","animal","nature","rodent"],"skins":[{"unified":"1f401","native":"\uD83D\uDC01"}],"version":1},"rat":{"id":"rat","name":"Rat","keywords":["animal","mouse","rodent"],"skins":[{"unified":"1f400","native":"\uD83D\uDC00"}],"version":1},"hamster":{"id":"hamster","name":"Hamster","keywords":["animal","nature"],"skins":[{"unified":"1f439","native":"\uD83D\uDC39"}],"version":1},"rabbit":{"id":"rabbit","name":"Rabbit Face","keywords":["animal","nature","pet","spring","magic","bunny"],"skins":[{"unified":"1f430","native":"\uD83D\uDC30"}],"version":1},"rabbit2":{"id":"rabbit2","name":"Rabbit","keywords":["rabbit2","animal","nature","pet","magic","spring"],"skins":[{"unified":"1f407","native":"\uD83D\uDC07"}],"version":1},"chipmunk":{"id":"chipmunk","name":"Chipmunk","keywords":["animal","nature","rodent","squirrel"],"skins":[{"unified":"1f43f-fe0f","native":"\uD83D\uDC3F\uFE0F"}],"version":1},"beaver":{"id":"beaver","name":"Beaver","keywords":["animal","rodent"],"skins":[{"unified":"1f9ab","native":"\uD83E\uDDAB"}],"version":13},"hedgehog":{"id":"hedgehog","name":"Hedgehog","keywords":["animal","nature","spiny"],"skins":[{"unified":"1f994","native":"\uD83E\uDD94"}],"version":5},"bat":{"id":"bat","name":"Bat","keywords":["animal","nature","blind","vampire"],"skins":[{"unified":"1f987","native":"\uD83E\uDD87"}],"version":3},"bear":{"id":"bear","name":"Bear","keywords":["animal","nature","wild"],"skins":[{"unified":"1f43b","native":"\uD83D\uDC3B"}],"version":1},"polar_bear":{"id":"polar_bear","name":"Polar Bear","keywords":["animal","arctic"],"skins":[{"unified":"1f43b-200d-2744-fe0f","native":"\uD83D\uDC3B\u200D\u2744\uFE0F"}],"version":13},"koala":{"id":"koala","name":"Koala","keywords":["animal","nature"],"skins":[{"unified":"1f428","native":"\uD83D\uDC28"}],"version":1},"panda_face":{"id":"panda_face","name":"Panda","keywords":["face","animal","nature"],"skins":[{"unified":"1f43c","native":"\uD83D\uDC3C"}],"version":1},"sloth":{"id":"sloth","name":"Sloth","keywords":["animal"],"skins":[{"unified":"1f9a5","native":"\uD83E\uDDA5"}],"version":12},"otter":{"id":"otter","name":"Otter","keywords":["animal"],"skins":[{"unified":"1f9a6","native":"\uD83E\uDDA6"}],"version":12},"skunk":{"id":"skunk","name":"Skunk","keywords":["animal"],"skins":[{"unified":"1f9a8","native":"\uD83E\uDDA8"}],"version":12},"kangaroo":{"id":"kangaroo","name":"Kangaroo","keywords":["animal","nature","australia","joey","hop","marsupial"],"skins":[{"unified":"1f998","native":"\uD83E\uDD98"}],"version":11},"badger":{"id":"badger","name":"Badger","keywords":["animal","nature","honey"],"skins":[{"unified":"1f9a1","native":"\uD83E\uDDA1"}],"version":11},"feet":{"id":"feet","name":"Paw Prints","keywords":["feet","animal","tracking","footprints","dog","cat","pet"],"skins":[{"unified":"1f43e","native":"\uD83D\uDC3E"}],"version":1},"turkey":{"id":"turkey","name":"Turkey","keywords":["animal","bird"],"skins":[{"unified":"1f983","native":"\uD83E\uDD83"}],"version":1},"chicken":{"id":"chicken","name":"Chicken","keywords":["animal","cluck","nature","bird"],"skins":[{"unified":"1f414","native":"\uD83D\uDC14"}],"version":1},"rooster":{"id":"rooster","name":"Rooster","keywords":["animal","nature","chicken"],"skins":[{"unified":"1f413","native":"\uD83D\uDC13"}],"version":1},"hatching_chick":{"id":"hatching_chick","name":"Hatching Chick","keywords":["animal","chicken","egg","born","baby","bird"],"skins":[{"unified":"1f423","native":"\uD83D\uDC23"}],"version":1},"baby_chick":{"id":"baby_chick","name":"Baby Chick","keywords":["animal","chicken","bird"],"skins":[{"unified":"1f424","native":"\uD83D\uDC24"}],"version":1},"hatched_chick":{"id":"hatched_chick","name":"Front-Facing Baby Chick","keywords":["hatched","front","facing","animal","chicken","bird"],"skins":[{"unified":"1f425","native":"\uD83D\uDC25"}],"version":1},"bird":{"id":"bird","name":"Bird","keywords":["animal","nature","fly","tweet","spring"],"skins":[{"unified":"1f426","native":"\uD83D\uDC26"}],"version":1},"penguin":{"id":"penguin","name":"Penguin","keywords":["animal","nature"],"skins":[{"unified":"1f427","native":"\uD83D\uDC27"}],"version":1},"dove_of_peace":{"id":"dove_of_peace","name":"Dove","keywords":["of","peace","animal","bird"],"skins":[{"unified":"1f54a-fe0f","native":"\uD83D\uDD4A\uFE0F"}],"version":1},"eagle":{"id":"eagle","name":"Eagle","keywords":["animal","nature","bird"],"skins":[{"unified":"1f985","native":"\uD83E\uDD85"}],"version":3},"duck":{"id":"duck","name":"Duck","keywords":["animal","nature","bird","mallard"],"skins":[{"unified":"1f986","native":"\uD83E\uDD86"}],"version":3},"swan":{"id":"swan","name":"Swan","keywords":["animal","nature","bird"],"skins":[{"unified":"1f9a2","native":"\uD83E\uDDA2"}],"version":11},"owl":{"id":"owl","name":"Owl","keywords":["animal","nature","bird","hoot"],"skins":[{"unified":"1f989","native":"\uD83E\uDD89"}],"version":3},"dodo":{"id":"dodo","name":"Dodo","keywords":["animal","bird"],"skins":[{"unified":"1f9a4","native":"\uD83E\uDDA4"}],"version":13},"feather":{"id":"feather","name":"Feather","keywords":["bird","fly"],"skins":[{"unified":"1fab6","native":"\uD83E\uDEB6"}],"version":13},"flamingo":{"id":"flamingo","name":"Flamingo","keywords":["animal"],"skins":[{"unified":"1f9a9","native":"\uD83E\uDDA9"}],"version":12},"peacock":{"id":"peacock","name":"Peacock","keywords":["animal","nature","peahen","bird"],"skins":[{"unified":"1f99a","native":"\uD83E\uDD9A"}],"version":11},"parrot":{"id":"parrot","name":"Parrot","keywords":["animal","nature","bird","pirate","talk"],"skins":[{"unified":"1f99c","native":"\uD83E\uDD9C"}],"version":11},"wing":{"id":"wing","name":"Wing","keywords":["angel","birds","flying"],"skins":[{"unified":"1fabd","native":"\uD83E\uDEBD"}],"version":15},"black_bird":{"id":"black_bird","name":"Black Bird","keywords":["crow"],"skins":[{"unified":"1f426-200d-2b1b","native":"\uD83D\uDC26\u200D\u2B1B"}],"version":15},"goose":{"id":"goose","name":"Goose","keywords":["silly","jemima","goosebumps"],"skins":[{"unified":"1fabf","native":"\uD83E\uDEBF"}],"version":15},"frog":{"id":"frog","name":"Frog","keywords":["animal","nature","croak","toad"],"skins":[{"unified":"1f438","native":"\uD83D\uDC38"}],"version":1},"crocodile":{"id":"crocodile","name":"Crocodile","keywords":["animal","nature","reptile","lizard","alligator"],"skins":[{"unified":"1f40a","native":"\uD83D\uDC0A"}],"version":1},"turtle":{"id":"turtle","name":"Turtle","keywords":["animal","slow","nature","tortoise"],"skins":[{"unified":"1f422","native":"\uD83D\uDC22"}],"version":1},"lizard":{"id":"lizard","name":"Lizard","keywords":["animal","nature","reptile"],"skins":[{"unified":"1f98e","native":"\uD83E\uDD8E"}],"version":3},"snake":{"id":"snake","name":"Snake","keywords":["animal","evil","nature","hiss","python"],"skins":[{"unified":"1f40d","native":"\uD83D\uDC0D"}],"version":1},"dragon_face":{"id":"dragon_face","name":"Dragon Face","keywords":["animal","myth","nature","chinese","green"],"skins":[{"unified":"1f432","native":"\uD83D\uDC32"}],"version":1},"dragon":{"id":"dragon","name":"Dragon","keywords":["animal","myth","nature","chinese","green"],"skins":[{"unified":"1f409","native":"\uD83D\uDC09"}],"version":1},"sauropod":{"id":"sauropod","name":"Sauropod","keywords":["animal","nature","dinosaur","brachiosaurus","brontosaurus","diplodocus","extinct"],"skins":[{"unified":"1f995","native":"\uD83E\uDD95"}],"version":5},"t-rex":{"id":"t-rex","name":"T-Rex","keywords":["t","rex","animal","nature","dinosaur","tyrannosaurus","extinct"],"skins":[{"unified":"1f996","native":"\uD83E\uDD96"}],"version":5},"whale":{"id":"whale","name":"Spouting Whale","keywords":["animal","nature","sea","ocean"],"skins":[{"unified":"1f433","native":"\uD83D\uDC33"}],"version":1},"whale2":{"id":"whale2","name":"Whale","keywords":["whale2","animal","nature","sea","ocean"],"skins":[{"unified":"1f40b","native":"\uD83D\uDC0B"}],"version":1},"dolphin":{"id":"dolphin","name":"Dolphin","keywords":["flipper","animal","nature","fish","sea","ocean","fins","beach"],"skins":[{"unified":"1f42c","native":"\uD83D\uDC2C"}],"version":1},"seal":{"id":"seal","name":"Seal","keywords":["animal","creature","sea"],"skins":[{"unified":"1f9ad","native":"\uD83E\uDDAD"}],"version":13},"fish":{"id":"fish","name":"Fish","keywords":["animal","food","nature"],"skins":[{"unified":"1f41f","native":"\uD83D\uDC1F"}],"version":1},"tropical_fish":{"id":"tropical_fish","name":"Tropical Fish","keywords":["animal","swim","ocean","beach","nemo"],"skins":[{"unified":"1f420","native":"\uD83D\uDC20"}],"version":1},"blowfish":{"id":"blowfish","name":"Blowfish","keywords":["animal","nature","food","sea","ocean"],"skins":[{"unified":"1f421","native":"\uD83D\uDC21"}],"version":1},"shark":{"id":"shark","name":"Shark","keywords":["animal","nature","fish","sea","ocean","jaws","fins","beach"],"skins":[{"unified":"1f988","native":"\uD83E\uDD88"}],"version":3},"octopus":{"id":"octopus","name":"Octopus","keywords":["animal","creature","ocean","sea","nature","beach"],"skins":[{"unified":"1f419","native":"\uD83D\uDC19"}],"version":1},"shell":{"id":"shell","name":"Spiral Shell","keywords":["nature","sea","beach"],"skins":[{"unified":"1f41a","native":"\uD83D\uDC1A"}],"version":1},"coral":{"id":"coral","name":"Coral","keywords":["ocean","sea","reef"],"skins":[{"unified":"1fab8","native":"\uD83E\uDEB8"}],"version":14},"jellyfish":{"id":"jellyfish","name":"Jellyfish","keywords":["sting","tentacles"],"skins":[{"unified":"1fabc","native":"\uD83E\uDEBC"}],"version":15},"snail":{"id":"snail","name":"Snail","keywords":["slow","animal","shell"],"skins":[{"unified":"1f40c","native":"\uD83D\uDC0C"}],"version":1},"butterfly":{"id":"butterfly","name":"Butterfly","keywords":["animal","insect","nature","caterpillar"],"skins":[{"unified":"1f98b","native":"\uD83E\uDD8B"}],"version":3},"bug":{"id":"bug","name":"Bug","keywords":["animal","insect","nature","worm"],"skins":[{"unified":"1f41b","native":"\uD83D\uDC1B"}],"version":1},"ant":{"id":"ant","name":"Ant","keywords":["animal","insect","nature","bug"],"skins":[{"unified":"1f41c","native":"\uD83D\uDC1C"}],"version":1},"bee":{"id":"bee","name":"Honeybee","keywords":["bee","animal","insect","nature","bug","spring","honey"],"skins":[{"unified":"1f41d","native":"\uD83D\uDC1D"}],"version":1},"beetle":{"id":"beetle","name":"Beetle","keywords":["insect"],"skins":[{"unified":"1fab2","native":"\uD83E\uDEB2"}],"version":13},"ladybug":{"id":"ladybug","name":"Lady Beetle","keywords":["ladybug","animal","insect","nature"],"skins":[{"unified":"1f41e","native":"\uD83D\uDC1E"}],"version":1},"cricket":{"id":"cricket","name":"Cricket","keywords":["animal","chirp"],"skins":[{"unified":"1f997","native":"\uD83E\uDD97"}],"version":5},"cockroach":{"id":"cockroach","name":"Cockroach","keywords":["insect","pests"],"skins":[{"unified":"1fab3","native":"\uD83E\uDEB3"}],"version":13},"spider":{"id":"spider","name":"Spider","keywords":["animal","arachnid"],"skins":[{"unified":"1f577-fe0f","native":"\uD83D\uDD77\uFE0F"}],"version":1},"spider_web":{"id":"spider_web","name":"Spider Web","keywords":["animal","insect","arachnid","silk"],"skins":[{"unified":"1f578-fe0f","native":"\uD83D\uDD78\uFE0F"}],"version":1},"scorpion":{"id":"scorpion","name":"Scorpion","keywords":["animal","arachnid"],"skins":[{"unified":"1f982","native":"\uD83E\uDD82"}],"version":1},"mosquito":{"id":"mosquito","name":"Mosquito","keywords":["animal","nature","insect","malaria"],"skins":[{"unified":"1f99f","native":"\uD83E\uDD9F"}],"version":11},"fly":{"id":"fly","name":"Fly","keywords":["insect"],"skins":[{"unified":"1fab0","native":"\uD83E\uDEB0"}],"version":13},"worm":{"id":"worm","name":"Worm","keywords":["animal"],"skins":[{"unified":"1fab1","native":"\uD83E\uDEB1"}],"version":13},"microbe":{"id":"microbe","name":"Microbe","keywords":["amoeba","bacteria","germs","virus","covid"],"skins":[{"unified":"1f9a0","native":"\uD83E\uDDA0"}],"version":11},"bouquet":{"id":"bouquet","name":"Bouquet","keywords":["flowers","nature","spring"],"skins":[{"unified":"1f490","native":"\uD83D\uDC90"}],"version":1},"cherry_blossom":{"id":"cherry_blossom","name":"Cherry Blossom","keywords":["nature","plant","spring","flower"],"skins":[{"unified":"1f338","native":"\uD83C\uDF38"}],"version":1},"white_flower":{"id":"white_flower","name":"White Flower","keywords":["japanese","spring"],"skins":[{"unified":"1f4ae","native":"\uD83D\uDCAE"}],"version":1},"lotus":{"id":"lotus","name":"Lotus","keywords":["flower","calm","meditation"],"skins":[{"unified":"1fab7","native":"\uD83E\uDEB7"}],"version":14},"rosette":{"id":"rosette","name":"Rosette","keywords":["flower","decoration","military"],"skins":[{"unified":"1f3f5-fe0f","native":"\uD83C\uDFF5\uFE0F"}],"version":1},"rose":{"id":"rose","name":"Rose","keywords":["flowers","valentines","love","spring"],"skins":[{"unified":"1f339","native":"\uD83C\uDF39"}],"version":1},"wilted_flower":{"id":"wilted_flower","name":"Wilted Flower","keywords":["plant","nature","rose"],"skins":[{"unified":"1f940","native":"\uD83E\uDD40"}],"version":3},"hibiscus":{"id":"hibiscus","name":"Hibiscus","keywords":["plant","vegetable","flowers","beach"],"skins":[{"unified":"1f33a","native":"\uD83C\uDF3A"}],"version":1},"sunflower":{"id":"sunflower","name":"Sunflower","keywords":["nature","plant","fall"],"skins":[{"unified":"1f33b","native":"\uD83C\uDF3B"}],"version":1},"blossom":{"id":"blossom","name":"Blossom","keywords":["nature","flowers","yellow"],"skins":[{"unified":"1f33c","native":"\uD83C\uDF3C"}],"version":1},"tulip":{"id":"tulip","name":"Tulip","keywords":["flowers","plant","nature","summer","spring"],"skins":[{"unified":"1f337","native":"\uD83C\uDF37"}],"version":1},"hyacinth":{"id":"hyacinth","name":"Hyacinth","keywords":["flower","lavender"],"skins":[{"unified":"1fabb","native":"\uD83E\uDEBB"}],"version":15},"seedling":{"id":"seedling","name":"Seedling","keywords":["plant","nature","grass","lawn","spring"],"skins":[{"unified":"1f331","native":"\uD83C\uDF31"}],"version":1},"potted_plant":{"id":"potted_plant","name":"Potted Plant","keywords":["greenery","house"],"skins":[{"unified":"1fab4","native":"\uD83E\uDEB4"}],"version":13},"evergreen_tree":{"id":"evergreen_tree","name":"Evergreen Tree","keywords":["plant","nature"],"skins":[{"unified":"1f332","native":"\uD83C\uDF32"}],"version":1},"deciduous_tree":{"id":"deciduous_tree","name":"Deciduous Tree","keywords":["plant","nature"],"skins":[{"unified":"1f333","native":"\uD83C\uDF33"}],"version":1},"palm_tree":{"id":"palm_tree","name":"Palm Tree","keywords":["plant","vegetable","nature","summer","beach","mojito","tropical"],"skins":[{"unified":"1f334","native":"\uD83C\uDF34"}],"version":1},"cactus":{"id":"cactus","name":"Cactus","keywords":["vegetable","plant","nature"],"skins":[{"unified":"1f335","native":"\uD83C\uDF35"}],"version":1},"ear_of_rice":{"id":"ear_of_rice","name":"Ear of Rice","keywords":["sheaf","nature","plant"],"skins":[{"unified":"1f33e","native":"\uD83C\uDF3E"}],"version":1},"herb":{"id":"herb","name":"Herb","keywords":["vegetable","plant","medicine","weed","grass","lawn"],"skins":[{"unified":"1f33f","native":"\uD83C\uDF3F"}],"version":1},"shamrock":{"id":"shamrock","name":"Shamrock","keywords":["vegetable","plant","nature","irish","clover"],"skins":[{"unified":"2618-fe0f","native":"\u2618\uFE0F"}],"version":1},"four_leaf_clover":{"id":"four_leaf_clover","name":"Four Leaf Clover","keywords":["vegetable","plant","nature","lucky","irish"],"skins":[{"unified":"1f340","native":"\uD83C\uDF40"}],"version":1},"maple_leaf":{"id":"maple_leaf","name":"Maple Leaf","keywords":["nature","plant","vegetable","ca","fall"],"skins":[{"unified":"1f341","native":"\uD83C\uDF41"}],"version":1},"fallen_leaf":{"id":"fallen_leaf","name":"Fallen Leaf","keywords":["nature","plant","vegetable","leaves"],"skins":[{"unified":"1f342","native":"\uD83C\uDF42"}],"version":1},"leaves":{"id":"leaves","name":"Leaf Fluttering in Wind","keywords":["leaves","nature","plant","tree","vegetable","grass","lawn","spring"],"skins":[{"unified":"1f343","native":"\uD83C\uDF43"}],"version":1},"empty_nest":{"id":"empty_nest","name":"Empty Nest","keywords":["bird"],"skins":[{"unified":"1fab9","native":"\uD83E\uDEB9"}],"version":14},"nest_with_eggs":{"id":"nest_with_eggs","name":"Nest with Eggs","keywords":["bird"],"skins":[{"unified":"1faba","native":"\uD83E\uDEBA"}],"version":14},"mushroom":{"id":"mushroom","name":"Mushroom","keywords":["plant","vegetable"],"skins":[{"unified":"1f344","native":"\uD83C\uDF44"}],"version":1},"grapes":{"id":"grapes","name":"Grapes","keywords":["fruit","food","wine"],"skins":[{"unified":"1f347","native":"\uD83C\uDF47"}],"version":1},"melon":{"id":"melon","name":"Melon","keywords":["fruit","nature","food"],"skins":[{"unified":"1f348","native":"\uD83C\uDF48"}],"version":1},"watermelon":{"id":"watermelon","name":"Watermelon","keywords":["fruit","food","picnic","summer"],"skins":[{"unified":"1f349","native":"\uD83C\uDF49"}],"version":1},"tangerine":{"id":"tangerine","name":"Tangerine","keywords":["food","fruit","nature","orange"],"skins":[{"unified":"1f34a","native":"\uD83C\uDF4A"}],"version":1},"lemon":{"id":"lemon","name":"Lemon","keywords":["fruit","nature"],"skins":[{"unified":"1f34b","native":"\uD83C\uDF4B"}],"version":1},"banana":{"id":"banana","name":"Banana","keywords":["fruit","food","monkey"],"skins":[{"unified":"1f34c","native":"\uD83C\uDF4C"}],"version":1},"pineapple":{"id":"pineapple","name":"Pineapple","keywords":["fruit","nature","food"],"skins":[{"unified":"1f34d","native":"\uD83C\uDF4D"}],"version":1},"mango":{"id":"mango","name":"Mango","keywords":["fruit","food","tropical"],"skins":[{"unified":"1f96d","native":"\uD83E\uDD6D"}],"version":11},"apple":{"id":"apple","name":"Red Apple","keywords":["fruit","mac","school"],"skins":[{"unified":"1f34e","native":"\uD83C\uDF4E"}],"version":1},"green_apple":{"id":"green_apple","name":"Green Apple","keywords":["fruit","nature"],"skins":[{"unified":"1f34f","native":"\uD83C\uDF4F"}],"version":1},"pear":{"id":"pear","name":"Pear","keywords":["fruit","nature","food"],"skins":[{"unified":"1f350","native":"\uD83C\uDF50"}],"version":1},"peach":{"id":"peach","name":"Peach","keywords":["fruit","nature","food"],"skins":[{"unified":"1f351","native":"\uD83C\uDF51"}],"version":1},"cherries":{"id":"cherries","name":"Cherries","keywords":["food","fruit"],"skins":[{"unified":"1f352","native":"\uD83C\uDF52"}],"version":1},"strawberry":{"id":"strawberry","name":"Strawberry","keywords":["fruit","food","nature"],"skins":[{"unified":"1f353","native":"\uD83C\uDF53"}],"version":1},"blueberries":{"id":"blueberries","name":"Blueberries","keywords":["fruit"],"skins":[{"unified":"1fad0","native":"\uD83E\uDED0"}],"version":13},"kiwifruit":{"id":"kiwifruit","name":"Kiwifruit","keywords":["kiwi","fruit","food"],"skins":[{"unified":"1f95d","native":"\uD83E\uDD5D"}],"version":3},"tomato":{"id":"tomato","name":"Tomato","keywords":["fruit","vegetable","nature","food"],"skins":[{"unified":"1f345","native":"\uD83C\uDF45"}],"version":1},"olive":{"id":"olive","name":"Olive","keywords":["fruit"],"skins":[{"unified":"1fad2","native":"\uD83E\uDED2"}],"version":13},"coconut":{"id":"coconut","name":"Coconut","keywords":["fruit","nature","food","palm"],"skins":[{"unified":"1f965","native":"\uD83E\uDD65"}],"version":5},"avocado":{"id":"avocado","name":"Avocado","keywords":["fruit","food"],"skins":[{"unified":"1f951","native":"\uD83E\uDD51"}],"version":3},"eggplant":{"id":"eggplant","name":"Eggplant","keywords":["vegetable","nature","food","aubergine"],"skins":[{"unified":"1f346","native":"\uD83C\uDF46"}],"version":1},"potato":{"id":"potato","name":"Potato","keywords":["food","tuber","vegatable","starch"],"skins":[{"unified":"1f954","native":"\uD83E\uDD54"}],"version":3},"carrot":{"id":"carrot","name":"Carrot","keywords":["vegetable","food","orange"],"skins":[{"unified":"1f955","native":"\uD83E\uDD55"}],"version":3},"corn":{"id":"corn","name":"Ear of Corn","keywords":["food","vegetable","plant"],"skins":[{"unified":"1f33d","native":"\uD83C\uDF3D"}],"version":1},"hot_pepper":{"id":"hot_pepper","name":"Hot Pepper","keywords":["food","spicy","chilli","chili"],"skins":[{"unified":"1f336-fe0f","native":"\uD83C\uDF36\uFE0F"}],"version":1},"bell_pepper":{"id":"bell_pepper","name":"Bell Pepper","keywords":["fruit","plant"],"skins":[{"unified":"1fad1","native":"\uD83E\uDED1"}],"version":13},"cucumber":{"id":"cucumber","name":"Cucumber","keywords":["fruit","food","pickle"],"skins":[{"unified":"1f952","native":"\uD83E\uDD52"}],"version":3},"leafy_green":{"id":"leafy_green","name":"Leafy Green","keywords":["food","vegetable","plant","bok","choy","cabbage","kale","lettuce"],"skins":[{"unified":"1f96c","native":"\uD83E\uDD6C"}],"version":11},"broccoli":{"id":"broccoli","name":"Broccoli","keywords":["fruit","food","vegetable"],"skins":[{"unified":"1f966","native":"\uD83E\uDD66"}],"version":5},"garlic":{"id":"garlic","name":"Garlic","keywords":["food","spice","cook"],"skins":[{"unified":"1f9c4","native":"\uD83E\uDDC4"}],"version":12},"onion":{"id":"onion","name":"Onion","keywords":["cook","food","spice"],"skins":[{"unified":"1f9c5","native":"\uD83E\uDDC5"}],"version":12},"peanuts":{"id":"peanuts","name":"Peanuts","keywords":["food","nut"],"skins":[{"unified":"1f95c","native":"\uD83E\uDD5C"}],"version":3},"beans":{"id":"beans","name":"Beans","keywords":["food"],"skins":[{"unified":"1fad8","native":"\uD83E\uDED8"}],"version":14},"chestnut":{"id":"chestnut","name":"Chestnut","keywords":["food","squirrel"],"skins":[{"unified":"1f330","native":"\uD83C\uDF30"}],"version":1},"ginger_root":{"id":"ginger_root","name":"Ginger Root","keywords":["spice","yellow","cooking","gingerbread"],"skins":[{"unified":"1fada","native":"\uD83E\uDEDA"}],"version":15},"pea_pod":{"id":"pea_pod","name":"Pea Pod","keywords":["cozy","green"],"skins":[{"unified":"1fadb","native":"\uD83E\uDEDB"}],"version":15},"bread":{"id":"bread","name":"Bread","keywords":["food","wheat","breakfast","toast"],"skins":[{"unified":"1f35e","native":"\uD83C\uDF5E"}],"version":1},"croissant":{"id":"croissant","name":"Croissant","keywords":["food","bread","french"],"skins":[{"unified":"1f950","native":"\uD83E\uDD50"}],"version":3},"baguette_bread":{"id":"baguette_bread","name":"Baguette Bread","keywords":["food","french","france","bakery"],"skins":[{"unified":"1f956","native":"\uD83E\uDD56"}],"version":3},"flatbread":{"id":"flatbread","name":"Flatbread","keywords":["flour","food","bakery"],"skins":[{"unified":"1fad3","native":"\uD83E\uDED3"}],"version":13},"pretzel":{"id":"pretzel","name":"Pretzel","keywords":["food","bread","twisted","germany","bakery"],"skins":[{"unified":"1f968","native":"\uD83E\uDD68"}],"version":5},"bagel":{"id":"bagel","name":"Bagel","keywords":["food","bread","bakery","schmear","jewish"],"skins":[{"unified":"1f96f","native":"\uD83E\uDD6F"}],"version":11},"pancakes":{"id":"pancakes","name":"Pancakes","keywords":["food","breakfast","flapjacks","hotcakes","brunch"],"skins":[{"unified":"1f95e","native":"\uD83E\uDD5E"}],"version":3},"waffle":{"id":"waffle","name":"Waffle","keywords":["food","breakfast","brunch"],"skins":[{"unified":"1f9c7","native":"\uD83E\uDDC7"}],"version":12},"cheese_wedge":{"id":"cheese_wedge","name":"Cheese Wedge","keywords":["food","chadder","swiss"],"skins":[{"unified":"1f9c0","native":"\uD83E\uDDC0"}],"version":1},"meat_on_bone":{"id":"meat_on_bone","name":"Meat on Bone","keywords":["good","food","drumstick"],"skins":[{"unified":"1f356","native":"\uD83C\uDF56"}],"version":1},"poultry_leg":{"id":"poultry_leg","name":"Poultry Leg","keywords":["food","meat","drumstick","bird","chicken","turkey"],"skins":[{"unified":"1f357","native":"\uD83C\uDF57"}],"version":1},"cut_of_meat":{"id":"cut_of_meat","name":"Cut of Meat","keywords":["food","cow","chop","lambchop","porkchop"],"skins":[{"unified":"1f969","native":"\uD83E\uDD69"}],"version":5},"bacon":{"id":"bacon","name":"Bacon","keywords":["food","breakfast","pork","pig","meat","brunch"],"skins":[{"unified":"1f953","native":"\uD83E\uDD53"}],"version":3},"hamburger":{"id":"hamburger","name":"Hamburger","keywords":["meat","fast","food","beef","cheeseburger","mcdonalds","burger","king"],"skins":[{"unified":"1f354","native":"\uD83C\uDF54"}],"version":1},"fries":{"id":"fries","name":"French Fries","keywords":["chips","snack","fast","food","potato"],"skins":[{"unified":"1f35f","native":"\uD83C\uDF5F"}],"version":1},"pizza":{"id":"pizza","name":"Pizza","keywords":["food","party","italy"],"skins":[{"unified":"1f355","native":"\uD83C\uDF55"}],"version":1},"hotdog":{"id":"hotdog","name":"Hot Dog","keywords":["hotdog","food","frankfurter","america"],"skins":[{"unified":"1f32d","native":"\uD83C\uDF2D"}],"version":1},"sandwich":{"id":"sandwich","name":"Sandwich","keywords":["food","lunch","bread","toast","bakery"],"skins":[{"unified":"1f96a","native":"\uD83E\uDD6A"}],"version":5},"taco":{"id":"taco","name":"Taco","keywords":["food","mexican"],"skins":[{"unified":"1f32e","native":"\uD83C\uDF2E"}],"version":1},"burrito":{"id":"burrito","name":"Burrito","keywords":["food","mexican"],"skins":[{"unified":"1f32f","native":"\uD83C\uDF2F"}],"version":1},"tamale":{"id":"tamale","name":"Tamale","keywords":["food","masa"],"skins":[{"unified":"1fad4","native":"\uD83E\uDED4"}],"version":13},"stuffed_flatbread":{"id":"stuffed_flatbread","name":"Stuffed Flatbread","keywords":["food","gyro","mediterranean"],"skins":[{"unified":"1f959","native":"\uD83E\uDD59"}],"version":3},"falafel":{"id":"falafel","name":"Falafel","keywords":["food","mediterranean"],"skins":[{"unified":"1f9c6","native":"\uD83E\uDDC6"}],"version":12},"egg":{"id":"egg","name":"Egg","keywords":["food","chicken","breakfast"],"skins":[{"unified":"1f95a","native":"\uD83E\uDD5A"}],"version":3},"fried_egg":{"id":"fried_egg","name":"Cooking","keywords":["fried","egg","food","breakfast","kitchen","skillet"],"skins":[{"unified":"1f373","native":"\uD83C\uDF73"}],"version":1},"shallow_pan_of_food":{"id":"shallow_pan_of_food","name":"Shallow Pan of Food","keywords":["cooking","casserole","paella","skillet"],"skins":[{"unified":"1f958","native":"\uD83E\uDD58"}],"version":3},"stew":{"id":"stew","name":"Pot of Food","keywords":["stew","meat","soup","hot"],"skins":[{"unified":"1f372","native":"\uD83C\uDF72"}],"version":1},"fondue":{"id":"fondue","name":"Fondue","keywords":["cheese","pot","food"],"skins":[{"unified":"1fad5","native":"\uD83E\uDED5"}],"version":13},"bowl_with_spoon":{"id":"bowl_with_spoon","name":"Bowl with Spoon","keywords":["food","breakfast","cereal","oatmeal","porridge"],"skins":[{"unified":"1f963","native":"\uD83E\uDD63"}],"version":5},"green_salad":{"id":"green_salad","name":"Green Salad","keywords":["food","healthy","lettuce","vegetable"],"skins":[{"unified":"1f957","native":"\uD83E\uDD57"}],"version":3},"popcorn":{"id":"popcorn","name":"Popcorn","keywords":["food","movie","theater","films","snack","drama"],"skins":[{"unified":"1f37f","native":"\uD83C\uDF7F"}],"version":1},"butter":{"id":"butter","name":"Butter","keywords":["food","cook"],"skins":[{"unified":"1f9c8","native":"\uD83E\uDDC8"}],"version":12},"salt":{"id":"salt","name":"Salt","keywords":["condiment","shaker"],"skins":[{"unified":"1f9c2","native":"\uD83E\uDDC2"}],"version":11},"canned_food":{"id":"canned_food","name":"Canned Food","keywords":["soup","tomatoes"],"skins":[{"unified":"1f96b","native":"\uD83E\uDD6B"}],"version":5},"bento":{"id":"bento","name":"Bento Box","keywords":["food","japanese","lunch"],"skins":[{"unified":"1f371","native":"\uD83C\uDF71"}],"version":1},"rice_cracker":{"id":"rice_cracker","name":"Rice Cracker","keywords":["food","japanese","snack"],"skins":[{"unified":"1f358","native":"\uD83C\uDF58"}],"version":1},"rice_ball":{"id":"rice_ball","name":"Rice Ball","keywords":["food","japanese"],"skins":[{"unified":"1f359","native":"\uD83C\uDF59"}],"version":1},"rice":{"id":"rice","name":"Cooked Rice","keywords":["food","asian"],"skins":[{"unified":"1f35a","native":"\uD83C\uDF5A"}],"version":1},"curry":{"id":"curry","name":"Curry Rice","keywords":["food","spicy","hot","indian"],"skins":[{"unified":"1f35b","native":"\uD83C\uDF5B"}],"version":1},"ramen":{"id":"ramen","name":"Steaming Bowl","keywords":["ramen","food","japanese","noodle","chopsticks"],"skins":[{"unified":"1f35c","native":"\uD83C\uDF5C"}],"version":1},"spaghetti":{"id":"spaghetti","name":"Spaghetti","keywords":["food","italian","pasta","noodle"],"skins":[{"unified":"1f35d","native":"\uD83C\uDF5D"}],"version":1},"sweet_potato":{"id":"sweet_potato","name":"Roasted Sweet Potato","keywords":["food","nature","plant"],"skins":[{"unified":"1f360","native":"\uD83C\uDF60"}],"version":1},"oden":{"id":"oden","name":"Oden","keywords":["food","japanese"],"skins":[{"unified":"1f362","native":"\uD83C\uDF62"}],"version":1},"sushi":{"id":"sushi","name":"Sushi","keywords":["food","fish","japanese","rice"],"skins":[{"unified":"1f363","native":"\uD83C\uDF63"}],"version":1},"fried_shrimp":{"id":"fried_shrimp","name":"Fried Shrimp","keywords":["food","animal","appetizer","summer"],"skins":[{"unified":"1f364","native":"\uD83C\uDF64"}],"version":1},"fish_cake":{"id":"fish_cake","name":"Fish Cake with Swirl","keywords":["food","japan","sea","beach","narutomaki","pink","kamaboko","surimi","ramen"],"skins":[{"unified":"1f365","native":"\uD83C\uDF65"}],"version":1},"moon_cake":{"id":"moon_cake","name":"Moon Cake","keywords":["food","autumn","dessert"],"skins":[{"unified":"1f96e","native":"\uD83E\uDD6E"}],"version":11},"dango":{"id":"dango","name":"Dango","keywords":["food","dessert","sweet","japanese","barbecue","meat"],"skins":[{"unified":"1f361","native":"\uD83C\uDF61"}],"version":1},"dumpling":{"id":"dumpling","name":"Dumpling","keywords":["food","empanada","pierogi","potsticker","gyoza"],"skins":[{"unified":"1f95f","native":"\uD83E\uDD5F"}],"version":5},"fortune_cookie":{"id":"fortune_cookie","name":"Fortune Cookie","keywords":["food","prophecy","dessert"],"skins":[{"unified":"1f960","native":"\uD83E\uDD60"}],"version":5},"takeout_box":{"id":"takeout_box","name":"Takeout Box","keywords":["food","leftovers"],"skins":[{"unified":"1f961","native":"\uD83E\uDD61"}],"version":5},"crab":{"id":"crab","name":"Crab","keywords":["animal","crustacean"],"skins":[{"unified":"1f980","native":"\uD83E\uDD80"}],"version":1},"lobster":{"id":"lobster","name":"Lobster","keywords":["animal","nature","bisque","claws","seafood"],"skins":[{"unified":"1f99e","native":"\uD83E\uDD9E"}],"version":11},"shrimp":{"id":"shrimp","name":"Shrimp","keywords":["animal","ocean","nature","seafood"],"skins":[{"unified":"1f990","native":"\uD83E\uDD90"}],"version":3},"squid":{"id":"squid","name":"Squid","keywords":["animal","nature","ocean","sea"],"skins":[{"unified":"1f991","native":"\uD83E\uDD91"}],"version":3},"oyster":{"id":"oyster","name":"Oyster","keywords":["food"],"skins":[{"unified":"1f9aa","native":"\uD83E\uDDAA"}],"version":12},"icecream":{"id":"icecream","name":"Soft Ice Cream","keywords":["icecream","food","hot","dessert","summer"],"skins":[{"unified":"1f366","native":"\uD83C\uDF66"}],"version":1},"shaved_ice":{"id":"shaved_ice","name":"Shaved Ice","keywords":["hot","dessert","summer"],"skins":[{"unified":"1f367","native":"\uD83C\uDF67"}],"version":1},"ice_cream":{"id":"ice_cream","name":"Ice Cream","keywords":["food","hot","dessert"],"skins":[{"unified":"1f368","native":"\uD83C\uDF68"}],"version":1},"doughnut":{"id":"doughnut","name":"Doughnut","keywords":["food","dessert","snack","sweet","donut"],"skins":[{"unified":"1f369","native":"\uD83C\uDF69"}],"version":1},"cookie":{"id":"cookie","name":"Cookie","keywords":["food","snack","oreo","chocolate","sweet","dessert"],"skins":[{"unified":"1f36a","native":"\uD83C\uDF6A"}],"version":1},"birthday":{"id":"birthday","name":"Birthday Cake","keywords":["food","dessert"],"skins":[{"unified":"1f382","native":"\uD83C\uDF82"}],"version":1},"cake":{"id":"cake","name":"Shortcake","keywords":["cake","food","dessert"],"skins":[{"unified":"1f370","native":"\uD83C\uDF70"}],"version":1},"cupcake":{"id":"cupcake","name":"Cupcake","keywords":["food","dessert","bakery","sweet"],"skins":[{"unified":"1f9c1","native":"\uD83E\uDDC1"}],"version":11},"pie":{"id":"pie","name":"Pie","keywords":["food","dessert","pastry"],"skins":[{"unified":"1f967","native":"\uD83E\uDD67"}],"version":5},"chocolate_bar":{"id":"chocolate_bar","name":"Chocolate Bar","keywords":["food","snack","dessert","sweet"],"skins":[{"unified":"1f36b","native":"\uD83C\uDF6B"}],"version":1},"candy":{"id":"candy","name":"Candy","keywords":["snack","dessert","sweet","lolly"],"skins":[{"unified":"1f36c","native":"\uD83C\uDF6C"}],"version":1},"lollipop":{"id":"lollipop","name":"Lollipop","keywords":["food","snack","candy","sweet"],"skins":[{"unified":"1f36d","native":"\uD83C\uDF6D"}],"version":1},"custard":{"id":"custard","name":"Custard","keywords":["dessert","food"],"skins":[{"unified":"1f36e","native":"\uD83C\uDF6E"}],"version":1},"honey_pot":{"id":"honey_pot","name":"Honey Pot","keywords":["bees","sweet","kitchen"],"skins":[{"unified":"1f36f","native":"\uD83C\uDF6F"}],"version":1},"baby_bottle":{"id":"baby_bottle","name":"Baby Bottle","keywords":["food","container","milk"],"skins":[{"unified":"1f37c","native":"\uD83C\uDF7C"}],"version":1},"glass_of_milk":{"id":"glass_of_milk","name":"Glass of Milk","keywords":["beverage","drink","cow"],"skins":[{"unified":"1f95b","native":"\uD83E\uDD5B"}],"version":3},"coffee":{"id":"coffee","name":"Hot Beverage","keywords":["coffee","caffeine","latte","espresso","mug"],"skins":[{"unified":"2615","native":"\u2615"}],"version":1},"teapot":{"id":"teapot","name":"Teapot","keywords":["drink","hot"],"skins":[{"unified":"1fad6","native":"\uD83E\uDED6"}],"version":13},"tea":{"id":"tea","name":"Teacup Without Handle","keywords":["tea","drink","bowl","breakfast","green","british"],"skins":[{"unified":"1f375","native":"\uD83C\uDF75"}],"version":1},"sake":{"id":"sake","name":"Sake","keywords":["wine","drink","drunk","beverage","japanese","alcohol","booze"],"skins":[{"unified":"1f376","native":"\uD83C\uDF76"}],"version":1},"champagne":{"id":"champagne","name":"Bottle with Popping Cork","keywords":["champagne","drink","wine","celebration"],"skins":[{"unified":"1f37e","native":"\uD83C\uDF7E"}],"version":1},"wine_glass":{"id":"wine_glass","name":"Wine Glass","keywords":["drink","beverage","drunk","alcohol","booze"],"skins":[{"unified":"1f377","native":"\uD83C\uDF77"}],"version":1},"cocktail":{"id":"cocktail","name":"Cocktail Glass","keywords":["drink","drunk","alcohol","beverage","booze","mojito"],"skins":[{"unified":"1f378","native":"\uD83C\uDF78"}],"version":1},"tropical_drink":{"id":"tropical_drink","name":"Tropical Drink","keywords":["beverage","cocktail","summer","beach","alcohol","booze","mojito"],"skins":[{"unified":"1f379","native":"\uD83C\uDF79"}],"version":1},"beer":{"id":"beer","name":"Beer Mug","keywords":["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"skins":[{"unified":"1f37a","native":"\uD83C\uDF7A"}],"version":1},"beers":{"id":"beers","name":"Clinking Beer Mugs","keywords":["beers","relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"skins":[{"unified":"1f37b","native":"\uD83C\uDF7B"}],"version":1},"clinking_glasses":{"id":"clinking_glasses","name":"Clinking Glasses","keywords":["beverage","drink","party","alcohol","celebrate","cheers","wine","champagne","toast"],"skins":[{"unified":"1f942","native":"\uD83E\uDD42"}],"version":3},"tumbler_glass":{"id":"tumbler_glass","name":"Tumbler Glass","keywords":["drink","beverage","drunk","alcohol","liquor","booze","bourbon","scotch","whisky","shot"],"skins":[{"unified":"1f943","native":"\uD83E\uDD43"}],"version":3},"pouring_liquid":{"id":"pouring_liquid","name":"Pouring Liquid","keywords":["cup","water"],"skins":[{"unified":"1fad7","native":"\uD83E\uDED7"}],"version":14},"cup_with_straw":{"id":"cup_with_straw","name":"Cup with Straw","keywords":["drink","soda"],"skins":[{"unified":"1f964","native":"\uD83E\uDD64"}],"version":5},"bubble_tea":{"id":"bubble_tea","name":"Bubble Tea","keywords":["taiwan","boba","milk","straw"],"skins":[{"unified":"1f9cb","native":"\uD83E\uDDCB"}],"version":13},"beverage_box":{"id":"beverage_box","name":"Beverage Box","keywords":["drink"],"skins":[{"unified":"1f9c3","native":"\uD83E\uDDC3"}],"version":12},"mate_drink":{"id":"mate_drink","name":"Mate","keywords":["drink","tea","beverage"],"skins":[{"unified":"1f9c9","native":"\uD83E\uDDC9"}],"version":12},"ice_cube":{"id":"ice_cube","name":"Ice","keywords":["cube","water","cold"],"skins":[{"unified":"1f9ca","native":"\uD83E\uDDCA"}],"version":12},"chopsticks":{"id":"chopsticks","name":"Chopsticks","keywords":["food"],"skins":[{"unified":"1f962","native":"\uD83E\uDD62"}],"version":5},"knife_fork_plate":{"id":"knife_fork_plate","name":"Fork and Knife with Plate","keywords":["food","eat","meal","lunch","dinner","restaurant"],"skins":[{"unified":"1f37d-fe0f","native":"\uD83C\uDF7D\uFE0F"}],"version":1},"fork_and_knife":{"id":"fork_and_knife","name":"Fork and Knife","keywords":["cutlery","kitchen"],"skins":[{"unified":"1f374","native":"\uD83C\uDF74"}],"version":1},"spoon":{"id":"spoon","name":"Spoon","keywords":["cutlery","kitchen","tableware"],"skins":[{"unified":"1f944","native":"\uD83E\uDD44"}],"version":3},"hocho":{"id":"hocho","name":"Hocho","keywords":["knife","kitchen","blade","cutlery","weapon"],"skins":[{"unified":"1f52a","native":"\uD83D\uDD2A"}],"version":1},"jar":{"id":"jar","name":"Jar","keywords":["container","sauce"],"skins":[{"unified":"1fad9","native":"\uD83E\uDED9"}],"version":14},"amphora":{"id":"amphora","name":"Amphora","keywords":["vase","jar"],"skins":[{"unified":"1f3fa","native":"\uD83C\uDFFA"}],"version":1},"earth_africa":{"id":"earth_africa","name":"Earth Globe Europe-Africa","keywords":["africa","showing","europe","world","international"],"skins":[{"unified":"1f30d","native":"\uD83C\uDF0D"}],"version":1},"earth_americas":{"id":"earth_americas","name":"Earth Globe Americas","keywords":["showing","world","USA","international"],"skins":[{"unified":"1f30e","native":"\uD83C\uDF0E"}],"version":1},"earth_asia":{"id":"earth_asia","name":"Earth Globe Asia-Australia","keywords":["asia","showing","australia","world","east","international"],"skins":[{"unified":"1f30f","native":"\uD83C\uDF0F"}],"version":1},"globe_with_meridians":{"id":"globe_with_meridians","name":"Globe with Meridians","keywords":["earth","international","world","internet","interweb","i18n"],"skins":[{"unified":"1f310","native":"\uD83C\uDF10"}],"version":1},"world_map":{"id":"world_map","name":"World Map","keywords":["location","direction"],"skins":[{"unified":"1f5fa-fe0f","native":"\uD83D\uDDFA\uFE0F"}],"version":1},"japan":{"id":"japan","name":"Map of Japan","keywords":["nation","country","japanese","asia"],"skins":[{"unified":"1f5fe","native":"\uD83D\uDDFE"}],"version":1},"compass":{"id":"compass","name":"Compass","keywords":["magnetic","navigation","orienteering"],"skins":[{"unified":"1f9ed","native":"\uD83E\uDDED"}],"version":11},"snow_capped_mountain":{"id":"snow_capped_mountain","name":"Snow-Capped Mountain","keywords":["snow","capped","photo","nature","environment","winter","cold"],"skins":[{"unified":"1f3d4-fe0f","native":"\uD83C\uDFD4\uFE0F"}],"version":1},"mountain":{"id":"mountain","name":"Mountain","keywords":["photo","nature","environment"],"skins":[{"unified":"26f0-fe0f","native":"\u26F0\uFE0F"}],"version":1},"volcano":{"id":"volcano","name":"Volcano","keywords":["photo","nature","disaster"],"skins":[{"unified":"1f30b","native":"\uD83C\uDF0B"}],"version":1},"mount_fuji":{"id":"mount_fuji","name":"Mount Fuji","keywords":["photo","mountain","nature","japanese"],"skins":[{"unified":"1f5fb","native":"\uD83D\uDDFB"}],"version":1},"camping":{"id":"camping","name":"Camping","keywords":["photo","outdoors","tent"],"skins":[{"unified":"1f3d5-fe0f","native":"\uD83C\uDFD5\uFE0F"}],"version":1},"beach_with_umbrella":{"id":"beach_with_umbrella","name":"Beach with Umbrella","keywords":["weather","summer","sunny","sand","mojito"],"skins":[{"unified":"1f3d6-fe0f","native":"\uD83C\uDFD6\uFE0F"}],"version":1},"desert":{"id":"desert","name":"Desert","keywords":["photo","warm","saharah"],"skins":[{"unified":"1f3dc-fe0f","native":"\uD83C\uDFDC\uFE0F"}],"version":1},"desert_island":{"id":"desert_island","name":"Desert Island","keywords":["photo","tropical","mojito"],"skins":[{"unified":"1f3dd-fe0f","native":"\uD83C\uDFDD\uFE0F"}],"version":1},"national_park":{"id":"national_park","name":"National Park","keywords":["photo","environment","nature"],"skins":[{"unified":"1f3de-fe0f","native":"\uD83C\uDFDE\uFE0F"}],"version":1},"stadium":{"id":"stadium","name":"Stadium","keywords":["photo","place","sports","concert","venue"],"skins":[{"unified":"1f3df-fe0f","native":"\uD83C\uDFDF\uFE0F"}],"version":1},"classical_building":{"id":"classical_building","name":"Classical Building","keywords":["art","culture","history"],"skins":[{"unified":"1f3db-fe0f","native":"\uD83C\uDFDB\uFE0F"}],"version":1},"building_construction":{"id":"building_construction","name":"Building Construction","keywords":["wip","working","progress"],"skins":[{"unified":"1f3d7-fe0f","native":"\uD83C\uDFD7\uFE0F"}],"version":1},"bricks":{"id":"bricks","name":"Brick","keywords":["bricks"],"skins":[{"unified":"1f9f1","native":"\uD83E\uDDF1"}],"version":11},"rock":{"id":"rock","name":"Rock","keywords":["stone"],"skins":[{"unified":"1faa8","native":"\uD83E\uDEA8"}],"version":13},"wood":{"id":"wood","name":"Wood","keywords":["nature","timber","trunk"],"skins":[{"unified":"1fab5","native":"\uD83E\uDEB5"}],"version":13},"hut":{"id":"hut","name":"Hut","keywords":["house","structure"],"skins":[{"unified":"1f6d6","native":"\uD83D\uDED6"}],"version":13},"house_buildings":{"id":"house_buildings","name":"Houses","keywords":["house","buildings","photo"],"skins":[{"unified":"1f3d8-fe0f","native":"\uD83C\uDFD8\uFE0F"}],"version":1},"derelict_house_building":{"id":"derelict_house_building","name":"Derelict House","keywords":["building","abandon","evict","broken"],"skins":[{"unified":"1f3da-fe0f","native":"\uD83C\uDFDA\uFE0F"}],"version":1},"house":{"id":"house","name":"House","keywords":["building","home"],"skins":[{"unified":"1f3e0","native":"\uD83C\uDFE0"}],"version":1},"house_with_garden":{"id":"house_with_garden","name":"House with Garden","keywords":["home","plant","nature"],"skins":[{"unified":"1f3e1","native":"\uD83C\uDFE1"}],"version":1},"office":{"id":"office","name":"Office Building","keywords":["bureau","work"],"skins":[{"unified":"1f3e2","native":"\uD83C\uDFE2"}],"version":1},"post_office":{"id":"post_office","name":"Japanese Post Office","keywords":["building","envelope","communication"],"skins":[{"unified":"1f3e3","native":"\uD83C\uDFE3"}],"version":1},"european_post_office":{"id":"european_post_office","name":"Post Office","keywords":["european","building","email"],"skins":[{"unified":"1f3e4","native":"\uD83C\uDFE4"}],"version":1},"hospital":{"id":"hospital","name":"Hospital","keywords":["building","health","surgery","doctor"],"skins":[{"unified":"1f3e5","native":"\uD83C\uDFE5"}],"version":1},"bank":{"id":"bank","name":"Bank","keywords":["building","money","sales","cash","business","enterprise"],"skins":[{"unified":"1f3e6","native":"\uD83C\uDFE6"}],"version":1},"hotel":{"id":"hotel","name":"Hotel","keywords":["building","accomodation","checkin"],"skins":[{"unified":"1f3e8","native":"\uD83C\uDFE8"}],"version":1},"love_hotel":{"id":"love_hotel","name":"Love Hotel","keywords":["like","affection","dating"],"skins":[{"unified":"1f3e9","native":"\uD83C\uDFE9"}],"version":1},"convenience_store":{"id":"convenience_store","name":"Convenience Store","keywords":["building","shopping","groceries"],"skins":[{"unified":"1f3ea","native":"\uD83C\uDFEA"}],"version":1},"school":{"id":"school","name":"School","keywords":["building","student","education","learn","teach"],"skins":[{"unified":"1f3eb","native":"\uD83C\uDFEB"}],"version":1},"department_store":{"id":"department_store","name":"Department Store","keywords":["building","shopping","mall"],"skins":[{"unified":"1f3ec","native":"\uD83C\uDFEC"}],"version":1},"factory":{"id":"factory","name":"Factory","keywords":["building","industry","pollution","smoke"],"skins":[{"unified":"1f3ed","native":"\uD83C\uDFED"}],"version":1},"japanese_castle":{"id":"japanese_castle","name":"Japanese Castle","keywords":["photo","building"],"skins":[{"unified":"1f3ef","native":"\uD83C\uDFEF"}],"version":1},"european_castle":{"id":"european_castle","name":"Castle","keywords":["european","building","royalty","history"],"skins":[{"unified":"1f3f0","native":"\uD83C\uDFF0"}],"version":1},"wedding":{"id":"wedding","name":"Wedding","keywords":["love","like","affection","couple","marriage","bride","groom"],"skins":[{"unified":"1f492","native":"\uD83D\uDC92"}],"version":1},"tokyo_tower":{"id":"tokyo_tower","name":"Tokyo Tower","keywords":["photo","japanese"],"skins":[{"unified":"1f5fc","native":"\uD83D\uDDFC"}],"version":1},"statue_of_liberty":{"id":"statue_of_liberty","name":"Statue of Liberty","keywords":["american","newyork"],"skins":[{"unified":"1f5fd","native":"\uD83D\uDDFD"}],"version":1},"church":{"id":"church","name":"Church","keywords":["building","religion","christ"],"skins":[{"unified":"26ea","native":"\u26EA"}],"version":1},"mosque":{"id":"mosque","name":"Mosque","keywords":["islam","worship","minaret"],"skins":[{"unified":"1f54c","native":"\uD83D\uDD4C"}],"version":1},"hindu_temple":{"id":"hindu_temple","name":"Hindu Temple","keywords":["religion"],"skins":[{"unified":"1f6d5","native":"\uD83D\uDED5"}],"version":12},"synagogue":{"id":"synagogue","name":"Synagogue","keywords":["judaism","worship","temple","jewish"],"skins":[{"unified":"1f54d","native":"\uD83D\uDD4D"}],"version":1},"shinto_shrine":{"id":"shinto_shrine","name":"Shinto Shrine","keywords":["temple","japan","kyoto"],"skins":[{"unified":"26e9-fe0f","native":"\u26E9\uFE0F"}],"version":1},"kaaba":{"id":"kaaba","name":"Kaaba","keywords":["mecca","mosque","islam"],"skins":[{"unified":"1f54b","native":"\uD83D\uDD4B"}],"version":1},"fountain":{"id":"fountain","name":"Fountain","keywords":["photo","summer","water","fresh"],"skins":[{"unified":"26f2","native":"\u26F2"}],"version":1},"tent":{"id":"tent","name":"Tent","keywords":["photo","camping","outdoors"],"skins":[{"unified":"26fa","native":"\u26FA"}],"version":1},"foggy":{"id":"foggy","name":"Foggy","keywords":["photo","mountain"],"skins":[{"unified":"1f301","native":"\uD83C\uDF01"}],"version":1},"night_with_stars":{"id":"night_with_stars","name":"Night with Stars","keywords":["evening","city","downtown"],"skins":[{"unified":"1f303","native":"\uD83C\uDF03"}],"version":1},"cityscape":{"id":"cityscape","name":"Cityscape","keywords":["photo","night","life","urban"],"skins":[{"unified":"1f3d9-fe0f","native":"\uD83C\uDFD9\uFE0F"}],"version":1},"sunrise_over_mountains":{"id":"sunrise_over_mountains","name":"Sunrise over Mountains","keywords":["view","vacation","photo"],"skins":[{"unified":"1f304","native":"\uD83C\uDF04"}],"version":1},"sunrise":{"id":"sunrise","name":"Sunrise","keywords":["morning","view","vacation","photo"],"skins":[{"unified":"1f305","native":"\uD83C\uDF05"}],"version":1},"city_sunset":{"id":"city_sunset","name":"Cityscape at Dusk","keywords":["city","sunset","photo","evening","sky","buildings"],"skins":[{"unified":"1f306","native":"\uD83C\uDF06"}],"version":1},"city_sunrise":{"id":"city_sunrise","name":"Sunset","keywords":["city","sunrise","photo","good","morning","dawn"],"skins":[{"unified":"1f307","native":"\uD83C\uDF07"}],"version":1},"bridge_at_night":{"id":"bridge_at_night","name":"Bridge at Night","keywords":["photo","sanfrancisco"],"skins":[{"unified":"1f309","native":"\uD83C\uDF09"}],"version":1},"hotsprings":{"id":"hotsprings","name":"Hot Springs","keywords":["hotsprings","bath","warm","relax"],"skins":[{"unified":"2668-fe0f","native":"\u2668\uFE0F"}],"version":1},"carousel_horse":{"id":"carousel_horse","name":"Carousel Horse","keywords":["photo","carnival"],"skins":[{"unified":"1f3a0","native":"\uD83C\uDFA0"}],"version":1},"playground_slide":{"id":"playground_slide","name":"Playground Slide","keywords":["fun","park"],"skins":[{"unified":"1f6dd","native":"\uD83D\uDEDD"}],"version":14},"ferris_wheel":{"id":"ferris_wheel","name":"Ferris Wheel","keywords":["photo","carnival","londoneye"],"skins":[{"unified":"1f3a1","native":"\uD83C\uDFA1"}],"version":1},"roller_coaster":{"id":"roller_coaster","name":"Roller Coaster","keywords":["carnival","playground","photo","fun"],"skins":[{"unified":"1f3a2","native":"\uD83C\uDFA2"}],"version":1},"barber":{"id":"barber","name":"Barber Pole","keywords":["hair","salon","style"],"skins":[{"unified":"1f488","native":"\uD83D\uDC88"}],"version":1},"circus_tent":{"id":"circus_tent","name":"Circus Tent","keywords":["festival","carnival","party"],"skins":[{"unified":"1f3aa","native":"\uD83C\uDFAA"}],"version":1},"steam_locomotive":{"id":"steam_locomotive","name":"Locomotive","keywords":["steam","transportation","vehicle","train"],"skins":[{"unified":"1f682","native":"\uD83D\uDE82"}],"version":1},"railway_car":{"id":"railway_car","name":"Railway Car","keywords":["transportation","vehicle"],"skins":[{"unified":"1f683","native":"\uD83D\uDE83"}],"version":1},"bullettrain_side":{"id":"bullettrain_side","name":"High-Speed Train","keywords":["bullettrain","side","high","speed","transportation","vehicle"],"skins":[{"unified":"1f684","native":"\uD83D\uDE84"}],"version":1},"bullettrain_front":{"id":"bullettrain_front","name":"Bullet Train","keywords":["bullettrain","front","transportation","vehicle","speed","fast","public","travel"],"skins":[{"unified":"1f685","native":"\uD83D\uDE85"}],"version":1},"train2":{"id":"train2","name":"Train","keywords":["train2","transportation","vehicle"],"skins":[{"unified":"1f686","native":"\uD83D\uDE86"}],"version":1},"metro":{"id":"metro","name":"Metro","keywords":["transportation","blue","square","mrt","underground","tube"],"skins":[{"unified":"1f687","native":"\uD83D\uDE87"}],"version":1},"light_rail":{"id":"light_rail","name":"Light Rail","keywords":["transportation","vehicle"],"skins":[{"unified":"1f688","native":"\uD83D\uDE88"}],"version":1},"station":{"id":"station","name":"Station","keywords":["transportation","vehicle","public"],"skins":[{"unified":"1f689","native":"\uD83D\uDE89"}],"version":1},"tram":{"id":"tram","name":"Tram","keywords":["transportation","vehicle"],"skins":[{"unified":"1f68a","native":"\uD83D\uDE8A"}],"version":1},"monorail":{"id":"monorail","name":"Monorail","keywords":["transportation","vehicle"],"skins":[{"unified":"1f69d","native":"\uD83D\uDE9D"}],"version":1},"mountain_railway":{"id":"mountain_railway","name":"Mountain Railway","keywords":["transportation","vehicle"],"skins":[{"unified":"1f69e","native":"\uD83D\uDE9E"}],"version":1},"train":{"id":"train","name":"Tram Car","keywords":["train","transportation","vehicle","carriage","public","travel"],"skins":[{"unified":"1f68b","native":"\uD83D\uDE8B"}],"version":1},"bus":{"id":"bus","name":"Bus","keywords":["car","vehicle","transportation"],"skins":[{"unified":"1f68c","native":"\uD83D\uDE8C"}],"version":1},"oncoming_bus":{"id":"oncoming_bus","name":"Oncoming Bus","keywords":["vehicle","transportation"],"skins":[{"unified":"1f68d","native":"\uD83D\uDE8D"}],"version":1},"trolleybus":{"id":"trolleybus","name":"Trolleybus","keywords":["bart","transportation","vehicle"],"skins":[{"unified":"1f68e","native":"\uD83D\uDE8E"}],"version":1},"minibus":{"id":"minibus","name":"Minibus","keywords":["vehicle","car","transportation"],"skins":[{"unified":"1f690","native":"\uD83D\uDE90"}],"version":1},"ambulance":{"id":"ambulance","name":"Ambulance","keywords":["health","911","hospital"],"skins":[{"unified":"1f691","native":"\uD83D\uDE91"}],"version":1},"fire_engine":{"id":"fire_engine","name":"Fire Engine","keywords":["transportation","cars","vehicle"],"skins":[{"unified":"1f692","native":"\uD83D\uDE92"}],"version":1},"police_car":{"id":"police_car","name":"Police Car","keywords":["vehicle","cars","transportation","law","legal","enforcement"],"skins":[{"unified":"1f693","native":"\uD83D\uDE93"}],"version":1},"oncoming_police_car":{"id":"oncoming_police_car","name":"Oncoming Police Car","keywords":["vehicle","law","legal","enforcement","911"],"skins":[{"unified":"1f694","native":"\uD83D\uDE94"}],"version":1},"taxi":{"id":"taxi","name":"Taxi","keywords":["uber","vehicle","cars","transportation"],"skins":[{"unified":"1f695","native":"\uD83D\uDE95"}],"version":1},"oncoming_taxi":{"id":"oncoming_taxi","name":"Oncoming Taxi","keywords":["vehicle","cars","uber"],"skins":[{"unified":"1f696","native":"\uD83D\uDE96"}],"version":1},"car":{"id":"car","name":"Automobile","keywords":["car","red","transportation","vehicle"],"skins":[{"unified":"1f697","native":"\uD83D\uDE97"}],"version":1},"oncoming_automobile":{"id":"oncoming_automobile","name":"Oncoming Automobile","keywords":["car","vehicle","transportation"],"skins":[{"unified":"1f698","native":"\uD83D\uDE98"}],"version":1},"blue_car":{"id":"blue_car","name":"Recreational Vehicle","keywords":["blue","car","sport","utility","transportation"],"skins":[{"unified":"1f699","native":"\uD83D\uDE99"}],"version":1},"pickup_truck":{"id":"pickup_truck","name":"Pickup Truck","keywords":["car","transportation"],"skins":[{"unified":"1f6fb","native":"\uD83D\uDEFB"}],"version":13},"truck":{"id":"truck","name":"Delivery Truck","keywords":["cars","transportation"],"skins":[{"unified":"1f69a","native":"\uD83D\uDE9A"}],"version":1},"articulated_lorry":{"id":"articulated_lorry","name":"Articulated Lorry","keywords":["vehicle","cars","transportation","express"],"skins":[{"unified":"1f69b","native":"\uD83D\uDE9B"}],"version":1},"tractor":{"id":"tractor","name":"Tractor","keywords":["vehicle","car","farming","agriculture"],"skins":[{"unified":"1f69c","native":"\uD83D\uDE9C"}],"version":1},"racing_car":{"id":"racing_car","name":"Racing Car","keywords":["sports","race","fast","formula","f1"],"skins":[{"unified":"1f3ce-fe0f","native":"\uD83C\uDFCE\uFE0F"}],"version":1},"racing_motorcycle":{"id":"racing_motorcycle","name":"Motorcycle","keywords":["racing","race","sports","fast"],"skins":[{"unified":"1f3cd-fe0f","native":"\uD83C\uDFCD\uFE0F"}],"version":1},"motor_scooter":{"id":"motor_scooter","name":"Motor Scooter","keywords":["vehicle","vespa","sasha"],"skins":[{"unified":"1f6f5","native":"\uD83D\uDEF5"}],"version":3},"manual_wheelchair":{"id":"manual_wheelchair","name":"Manual Wheelchair","keywords":["accessibility"],"skins":[{"unified":"1f9bd","native":"\uD83E\uDDBD"}],"version":12},"motorized_wheelchair":{"id":"motorized_wheelchair","name":"Motorized Wheelchair","keywords":["accessibility"],"skins":[{"unified":"1f9bc","native":"\uD83E\uDDBC"}],"version":12},"auto_rickshaw":{"id":"auto_rickshaw","name":"Auto Rickshaw","keywords":["move","transportation"],"skins":[{"unified":"1f6fa","native":"\uD83D\uDEFA"}],"version":12},"bike":{"id":"bike","name":"Bicycle","keywords":["bike","sports","exercise","hipster"],"skins":[{"unified":"1f6b2","native":"\uD83D\uDEB2"}],"version":1},"scooter":{"id":"scooter","name":"Scooter","keywords":["kick","vehicle","razor"],"skins":[{"unified":"1f6f4","native":"\uD83D\uDEF4"}],"version":3},"skateboard":{"id":"skateboard","name":"Skateboard","keywords":["board"],"skins":[{"unified":"1f6f9","native":"\uD83D\uDEF9"}],"version":11},"roller_skate":{"id":"roller_skate","name":"Roller Skate","keywords":["footwear","sports"],"skins":[{"unified":"1f6fc","native":"\uD83D\uDEFC"}],"version":13},"busstop":{"id":"busstop","name":"Bus Stop","keywords":["busstop","transportation","wait"],"skins":[{"unified":"1f68f","native":"\uD83D\uDE8F"}],"version":1},"motorway":{"id":"motorway","name":"Motorway","keywords":["road","cupertino","interstate","highway"],"skins":[{"unified":"1f6e3-fe0f","native":"\uD83D\uDEE3\uFE0F"}],"version":1},"railway_track":{"id":"railway_track","name":"Railway Track","keywords":["train","transportation"],"skins":[{"unified":"1f6e4-fe0f","native":"\uD83D\uDEE4\uFE0F"}],"version":1},"oil_drum":{"id":"oil_drum","name":"Oil Drum","keywords":["barrell"],"skins":[{"unified":"1f6e2-fe0f","native":"\uD83D\uDEE2\uFE0F"}],"version":1},"fuelpump":{"id":"fuelpump","name":"Fuel Pump","keywords":["fuelpump","gas","station","petroleum"],"skins":[{"unified":"26fd","native":"\u26FD"}],"version":1},"wheel":{"id":"wheel","name":"Wheel","keywords":["car","transport"],"skins":[{"unified":"1f6de","native":"\uD83D\uDEDE"}],"version":14},"rotating_light":{"id":"rotating_light","name":"Police Car Light","keywords":["rotating","ambulance","911","emergency","alert","error","pinged","law","legal"],"skins":[{"unified":"1f6a8","native":"\uD83D\uDEA8"}],"version":1},"traffic_light":{"id":"traffic_light","name":"Horizontal Traffic Light","keywords":["transportation","signal"],"skins":[{"unified":"1f6a5","native":"\uD83D\uDEA5"}],"version":1},"vertical_traffic_light":{"id":"vertical_traffic_light","name":"Vertical Traffic Light","keywords":["transportation","driving"],"skins":[{"unified":"1f6a6","native":"\uD83D\uDEA6"}],"version":1},"octagonal_sign":{"id":"octagonal_sign","name":"Stop Sign","keywords":["octagonal"],"skins":[{"unified":"1f6d1","native":"\uD83D\uDED1"}],"version":3},"construction":{"id":"construction","name":"Construction","keywords":["wip","progress","caution","warning"],"skins":[{"unified":"1f6a7","native":"\uD83D\uDEA7"}],"version":1},"anchor":{"id":"anchor","name":"Anchor","keywords":["ship","ferry","sea","boat"],"skins":[{"unified":"2693","native":"\u2693"}],"version":1},"ring_buoy":{"id":"ring_buoy","name":"Ring Buoy","keywords":["life","saver","preserver"],"skins":[{"unified":"1f6df","native":"\uD83D\uDEDF"}],"version":14},"boat":{"id":"boat","name":"Sailboat","keywords":["boat","ship","summer","transportation","water","sailing"],"skins":[{"unified":"26f5","native":"\u26F5"}],"version":1},"canoe":{"id":"canoe","name":"Canoe","keywords":["boat","paddle","water","ship"],"skins":[{"unified":"1f6f6","native":"\uD83D\uDEF6"}],"version":3},"speedboat":{"id":"speedboat","name":"Speedboat","keywords":["ship","transportation","vehicle","summer"],"skins":[{"unified":"1f6a4","native":"\uD83D\uDEA4"}],"version":1},"passenger_ship":{"id":"passenger_ship","name":"Passenger Ship","keywords":["yacht","cruise","ferry"],"skins":[{"unified":"1f6f3-fe0f","native":"\uD83D\uDEF3\uFE0F"}],"version":1},"ferry":{"id":"ferry","name":"Ferry","keywords":["boat","ship","yacht"],"skins":[{"unified":"26f4-fe0f","native":"\u26F4\uFE0F"}],"version":1},"motor_boat":{"id":"motor_boat","name":"Motor Boat","keywords":["ship"],"skins":[{"unified":"1f6e5-fe0f","native":"\uD83D\uDEE5\uFE0F"}],"version":1},"ship":{"id":"ship","name":"Ship","keywords":["transportation","titanic","deploy"],"skins":[{"unified":"1f6a2","native":"\uD83D\uDEA2"}],"version":1},"airplane":{"id":"airplane","name":"Airplane","keywords":["vehicle","transportation","flight","fly"],"skins":[{"unified":"2708-fe0f","native":"\u2708\uFE0F"}],"version":1},"small_airplane":{"id":"small_airplane","name":"Small Airplane","keywords":["flight","transportation","fly","vehicle"],"skins":[{"unified":"1f6e9-fe0f","native":"\uD83D\uDEE9\uFE0F"}],"version":1},"airplane_departure":{"id":"airplane_departure","name":"Airplane Departure","keywords":["airport","flight","landing"],"skins":[{"unified":"1f6eb","native":"\uD83D\uDEEB"}],"version":1},"airplane_arriving":{"id":"airplane_arriving","name":"Airplane Arrival","keywords":["arriving","airport","flight","boarding"],"skins":[{"unified":"1f6ec","native":"\uD83D\uDEEC"}],"version":1},"parachute":{"id":"parachute","name":"Parachute","keywords":["fly","glide"],"skins":[{"unified":"1fa82","native":"\uD83E\uDE82"}],"version":12},"seat":{"id":"seat","name":"Seat","keywords":["sit","airplane","transport","bus","flight","fly"],"skins":[{"unified":"1f4ba","native":"\uD83D\uDCBA"}],"version":1},"helicopter":{"id":"helicopter","name":"Helicopter","keywords":["transportation","vehicle","fly"],"skins":[{"unified":"1f681","native":"\uD83D\uDE81"}],"version":1},"suspension_railway":{"id":"suspension_railway","name":"Suspension Railway","keywords":["vehicle","transportation"],"skins":[{"unified":"1f69f","native":"\uD83D\uDE9F"}],"version":1},"mountain_cableway":{"id":"mountain_cableway","name":"Mountain Cableway","keywords":["transportation","vehicle","ski"],"skins":[{"unified":"1f6a0","native":"\uD83D\uDEA0"}],"version":1},"aerial_tramway":{"id":"aerial_tramway","name":"Aerial Tramway","keywords":["transportation","vehicle","ski"],"skins":[{"unified":"1f6a1","native":"\uD83D\uDEA1"}],"version":1},"satellite":{"id":"satellite","name":"Satellite","keywords":["communication","gps","orbit","spaceflight","NASA","ISS"],"skins":[{"unified":"1f6f0-fe0f","native":"\uD83D\uDEF0\uFE0F"}],"version":1},"rocket":{"id":"rocket","name":"Rocket","keywords":["launch","ship","staffmode","NASA","outer","space","fly"],"skins":[{"unified":"1f680","native":"\uD83D\uDE80"}],"version":1},"flying_saucer":{"id":"flying_saucer","name":"Flying Saucer","keywords":["transportation","vehicle","ufo"],"skins":[{"unified":"1f6f8","native":"\uD83D\uDEF8"}],"version":5},"bellhop_bell":{"id":"bellhop_bell","name":"Bellhop Bell","keywords":["service"],"skins":[{"unified":"1f6ce-fe0f","native":"\uD83D\uDECE\uFE0F"}],"version":1},"luggage":{"id":"luggage","name":"Luggage","keywords":["packing","travel"],"skins":[{"unified":"1f9f3","native":"\uD83E\uDDF3"}],"version":11},"hourglass":{"id":"hourglass","name":"Hourglass","keywords":["done","time","clock","oldschool","limit","exam","quiz","test"],"skins":[{"unified":"231b","native":"\u231B"}],"version":1},"hourglass_flowing_sand":{"id":"hourglass_flowing_sand","name":"Hourglass Not Done","keywords":["flowing","sand","oldschool","time","countdown"],"skins":[{"unified":"23f3","native":"\u23F3"}],"version":1},"watch":{"id":"watch","name":"Watch","keywords":["time","accessories"],"skins":[{"unified":"231a","native":"\u231A"}],"version":1},"alarm_clock":{"id":"alarm_clock","name":"Alarm Clock","keywords":["time","wake"],"skins":[{"unified":"23f0","native":"\u23F0"}],"version":1},"stopwatch":{"id":"stopwatch","name":"Stopwatch","keywords":["time","deadline"],"skins":[{"unified":"23f1-fe0f","native":"\u23F1\uFE0F"}],"version":1},"timer_clock":{"id":"timer_clock","name":"Timer Clock","keywords":["alarm"],"skins":[{"unified":"23f2-fe0f","native":"\u23F2\uFE0F"}],"version":1},"mantelpiece_clock":{"id":"mantelpiece_clock","name":"Mantelpiece Clock","keywords":["time"],"skins":[{"unified":"1f570-fe0f","native":"\uD83D\uDD70\uFE0F"}],"version":1},"clock12":{"id":"clock12","name":"Twelve O\u2019clock","keywords":["clock12","o","clock","12","00:00","0000","12:00","1200","time","noon","midnight","midday","late","early","schedule"],"skins":[{"unified":"1f55b","native":"\uD83D\uDD5B"}],"version":1},"clock1230":{"id":"clock1230","name":"Twelve-Thirty","keywords":["clock1230","twelve","thirty","00:30","0030","12:30","1230","time","late","early","schedule"],"skins":[{"unified":"1f567","native":"\uD83D\uDD67"}],"version":1},"clock1":{"id":"clock1","name":"One O\u2019clock","keywords":["clock1","o","clock","1","1:00","100","13:00","1300","time","late","early","schedule"],"skins":[{"unified":"1f550","native":"\uD83D\uDD50"}],"version":1},"clock130":{"id":"clock130","name":"One-Thirty","keywords":["clock130","one","thirty","1:30","130","13:30","1330","time","late","early","schedule"],"skins":[{"unified":"1f55c","native":"\uD83D\uDD5C"}],"version":1},"clock2":{"id":"clock2","name":"Two O\u2019clock","keywords":["clock2","o","clock","2","2:00","200","14:00","1400","time","late","early","schedule"],"skins":[{"unified":"1f551","native":"\uD83D\uDD51"}],"version":1},"clock230":{"id":"clock230","name":"Two-Thirty","keywords":["clock230","two","thirty","2:30","230","14:30","1430","time","late","early","schedule"],"skins":[{"unified":"1f55d","native":"\uD83D\uDD5D"}],"version":1},"clock3":{"id":"clock3","name":"Three O\u2019clock","keywords":["clock3","o","clock","3","3:00","300","15:00","1500","time","late","early","schedule"],"skins":[{"unified":"1f552","native":"\uD83D\uDD52"}],"version":1},"clock330":{"id":"clock330","name":"Three-Thirty","keywords":["clock330","three","thirty","3:30","330","15:30","1530","time","late","early","schedule"],"skins":[{"unified":"1f55e","native":"\uD83D\uDD5E"}],"version":1},"clock4":{"id":"clock4","name":"Four O\u2019clock","keywords":["clock4","o","clock","4","4:00","400","16:00","1600","time","late","early","schedule"],"skins":[{"unified":"1f553","native":"\uD83D\uDD53"}],"version":1},"clock430":{"id":"clock430","name":"Four-Thirty","keywords":["clock430","four","thirty","4:30","430","16:30","1630","time","late","early","schedule"],"skins":[{"unified":"1f55f","native":"\uD83D\uDD5F"}],"version":1},"clock5":{"id":"clock5","name":"Five O\u2019clock","keywords":["clock5","o","clock","5","5:00","500","17:00","1700","time","late","early","schedule"],"skins":[{"unified":"1f554","native":"\uD83D\uDD54"}],"version":1},"clock530":{"id":"clock530","name":"Five-Thirty","keywords":["clock530","five","thirty","5:30","530","17:30","1730","time","late","early","schedule"],"skins":[{"unified":"1f560","native":"\uD83D\uDD60"}],"version":1},"clock6":{"id":"clock6","name":"Six O\u2019clock","keywords":["clock6","o","clock","6","6:00","600","18:00","1800","time","late","early","schedule","dawn","dusk"],"skins":[{"unified":"1f555","native":"\uD83D\uDD55"}],"version":1},"clock630":{"id":"clock630","name":"Six-Thirty","keywords":["clock630","six","thirty","6:30","630","18:30","1830","time","late","early","schedule"],"skins":[{"unified":"1f561","native":"\uD83D\uDD61"}],"version":1},"clock7":{"id":"clock7","name":"Seven O\u2019clock","keywords":["clock7","o","clock","7","7:00","700","19:00","1900","time","late","early","schedule"],"skins":[{"unified":"1f556","native":"\uD83D\uDD56"}],"version":1},"clock730":{"id":"clock730","name":"Seven-Thirty","keywords":["clock730","seven","thirty","7:30","730","19:30","1930","time","late","early","schedule"],"skins":[{"unified":"1f562","native":"\uD83D\uDD62"}],"version":1},"clock8":{"id":"clock8","name":"Eight O\u2019clock","keywords":["clock8","o","clock","8","8:00","800","20:00","2000","time","late","early","schedule"],"skins":[{"unified":"1f557","native":"\uD83D\uDD57"}],"version":1},"clock830":{"id":"clock830","name":"Eight-Thirty","keywords":["clock830","eight","thirty","8:30","830","20:30","2030","time","late","early","schedule"],"skins":[{"unified":"1f563","native":"\uD83D\uDD63"}],"version":1},"clock9":{"id":"clock9","name":"Nine O\u2019clock","keywords":["clock9","o","clock","9","9:00","900","21:00","2100","time","late","early","schedule"],"skins":[{"unified":"1f558","native":"\uD83D\uDD58"}],"version":1},"clock930":{"id":"clock930","name":"Nine-Thirty","keywords":["clock930","nine","thirty","9:30","930","21:30","2130","time","late","early","schedule"],"skins":[{"unified":"1f564","native":"\uD83D\uDD64"}],"version":1},"clock10":{"id":"clock10","name":"Ten O\u2019clock","keywords":["clock10","o","clock","10","10:00","1000","22:00","2200","time","late","early","schedule"],"skins":[{"unified":"1f559","native":"\uD83D\uDD59"}],"version":1},"clock1030":{"id":"clock1030","name":"Ten-Thirty","keywords":["clock1030","ten","thirty","10:30","1030","22:30","2230","time","late","early","schedule"],"skins":[{"unified":"1f565","native":"\uD83D\uDD65"}],"version":1},"clock11":{"id":"clock11","name":"Eleven O\u2019clock","keywords":["clock11","o","clock","11","11:00","1100","23:00","2300","time","late","early","schedule"],"skins":[{"unified":"1f55a","native":"\uD83D\uDD5A"}],"version":1},"clock1130":{"id":"clock1130","name":"Eleven-Thirty","keywords":["clock1130","eleven","thirty","11:30","1130","23:30","2330","time","late","early","schedule"],"skins":[{"unified":"1f566","native":"\uD83D\uDD66"}],"version":1},"new_moon":{"id":"new_moon","name":"New Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f311","native":"\uD83C\uDF11"}],"version":1},"waxing_crescent_moon":{"id":"waxing_crescent_moon","name":"Waxing Crescent Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f312","native":"\uD83C\uDF12"}],"version":1},"first_quarter_moon":{"id":"first_quarter_moon","name":"First Quarter Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f313","native":"\uD83C\uDF13"}],"version":1},"moon":{"id":"moon","name":"Waxing Gibbous Moon","keywords":["nature","night","sky","gray","twilight","planet","space","evening","sleep"],"skins":[{"unified":"1f314","native":"\uD83C\uDF14"}],"version":1},"full_moon":{"id":"full_moon","name":"Full Moon","keywords":["nature","yellow","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f315","native":"\uD83C\uDF15"}],"version":1},"waning_gibbous_moon":{"id":"waning_gibbous_moon","name":"Waning Gibbous Moon","keywords":["nature","twilight","planet","space","night","evening","sleep","waxing"],"skins":[{"unified":"1f316","native":"\uD83C\uDF16"}],"version":1},"last_quarter_moon":{"id":"last_quarter_moon","name":"Last Quarter Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f317","native":"\uD83C\uDF17"}],"version":1},"waning_crescent_moon":{"id":"waning_crescent_moon","name":"Waning Crescent Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f318","native":"\uD83C\uDF18"}],"version":1},"crescent_moon":{"id":"crescent_moon","name":"Crescent Moon","keywords":["night","sleep","sky","evening","magic"],"skins":[{"unified":"1f319","native":"\uD83C\uDF19"}],"version":1},"new_moon_with_face":{"id":"new_moon_with_face","name":"New Moon Face","keywords":["with","nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f31a","native":"\uD83C\uDF1A"}],"version":1},"first_quarter_moon_with_face":{"id":"first_quarter_moon_with_face","name":"First Quarter Moon Face","keywords":["with","nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f31b","native":"\uD83C\uDF1B"}],"version":1},"last_quarter_moon_with_face":{"id":"last_quarter_moon_with_face","name":"Last Quarter Moon Face","keywords":["with","nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f31c","native":"\uD83C\uDF1C"}],"version":1},"thermometer":{"id":"thermometer","name":"Thermometer","keywords":["weather","temperature","hot","cold"],"skins":[{"unified":"1f321-fe0f","native":"\uD83C\uDF21\uFE0F"}],"version":1},"sunny":{"id":"sunny","name":"Sun","keywords":["sunny","weather","nature","brightness","summer","beach","spring"],"skins":[{"unified":"2600-fe0f","native":"\u2600\uFE0F"}],"version":1},"full_moon_with_face":{"id":"full_moon_with_face","name":"Full Moon Face","keywords":["with","nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f31d","native":"\uD83C\uDF1D"}],"version":1},"sun_with_face":{"id":"sun_with_face","name":"Sun with Face","keywords":["nature","morning","sky"],"skins":[{"unified":"1f31e","native":"\uD83C\uDF1E"}],"version":1},"ringed_planet":{"id":"ringed_planet","name":"Ringed Planet","keywords":["outerspace"],"skins":[{"unified":"1fa90","native":"\uD83E\uDE90"}],"version":12},"star":{"id":"star","name":"Star","keywords":["night","yellow"],"skins":[{"unified":"2b50","native":"\u2B50"}],"version":1},"star2":{"id":"star2","name":"Glowing Star","keywords":["star2","night","sparkle","awesome","good","magic"],"skins":[{"unified":"1f31f","native":"\uD83C\uDF1F"}],"version":1},"stars":{"id":"stars","name":"Shooting Star","keywords":["stars","night","photo"],"skins":[{"unified":"1f320","native":"\uD83C\uDF20"}],"version":1},"milky_way":{"id":"milky_way","name":"Milky Way","keywords":["photo","space","stars"],"skins":[{"unified":"1f30c","native":"\uD83C\uDF0C"}],"version":1},"cloud":{"id":"cloud","name":"Cloud","keywords":["weather","sky"],"skins":[{"unified":"2601-fe0f","native":"\u2601\uFE0F"}],"version":1},"partly_sunny":{"id":"partly_sunny","name":"Sun Behind Cloud","keywords":["partly","sunny","weather","nature","cloudy","morning","fall","spring"],"skins":[{"unified":"26c5","native":"\u26C5"}],"version":1},"thunder_cloud_and_rain":{"id":"thunder_cloud_and_rain","name":"Cloud with Lightning and Rain","keywords":["thunder","weather"],"skins":[{"unified":"26c8-fe0f","native":"\u26C8\uFE0F"}],"version":1},"mostly_sunny":{"id":"mostly_sunny","name":"Sun Behind Small Cloud","keywords":["mostly","sunny","weather"],"skins":[{"unified":"1f324-fe0f","native":"\uD83C\uDF24\uFE0F"}],"version":1},"barely_sunny":{"id":"barely_sunny","name":"Sun Behind Large Cloud","keywords":["barely","sunny","weather"],"skins":[{"unified":"1f325-fe0f","native":"\uD83C\uDF25\uFE0F"}],"version":1},"partly_sunny_rain":{"id":"partly_sunny_rain","name":"Sun Behind Rain Cloud","keywords":["partly","sunny","weather"],"skins":[{"unified":"1f326-fe0f","native":"\uD83C\uDF26\uFE0F"}],"version":1},"rain_cloud":{"id":"rain_cloud","name":"Cloud with Rain","keywords":["weather"],"skins":[{"unified":"1f327-fe0f","native":"\uD83C\uDF27\uFE0F"}],"version":1},"snow_cloud":{"id":"snow_cloud","name":"Cloud with Snow","keywords":["weather"],"skins":[{"unified":"1f328-fe0f","native":"\uD83C\uDF28\uFE0F"}],"version":1},"lightning":{"id":"lightning","name":"Cloud with Lightning","keywords":["weather","thunder"],"skins":[{"unified":"1f329-fe0f","native":"\uD83C\uDF29\uFE0F"}],"version":1},"tornado":{"id":"tornado","name":"Tornado","keywords":["cloud","weather","cyclone","twister"],"skins":[{"unified":"1f32a-fe0f","native":"\uD83C\uDF2A\uFE0F"}],"version":1},"fog":{"id":"fog","name":"Fog","keywords":["weather"],"skins":[{"unified":"1f32b-fe0f","native":"\uD83C\uDF2B\uFE0F"}],"version":1},"wind_blowing_face":{"id":"wind_blowing_face","name":"Wind Face","keywords":["blowing","gust","air"],"skins":[{"unified":"1f32c-fe0f","native":"\uD83C\uDF2C\uFE0F"}],"version":1},"cyclone":{"id":"cyclone","name":"Cyclone","keywords":["weather","swirl","blue","cloud","vortex","spiral","whirlpool","spin","tornado","hurricane","typhoon"],"skins":[{"unified":"1f300","native":"\uD83C\uDF00"}],"version":1},"rainbow":{"id":"rainbow","name":"Rainbow","keywords":["nature","happy","unicorn","face","photo","sky","spring"],"skins":[{"unified":"1f308","native":"\uD83C\uDF08"}],"version":1},"closed_umbrella":{"id":"closed_umbrella","name":"Closed Umbrella","keywords":["weather","rain","drizzle"],"skins":[{"unified":"1f302","native":"\uD83C\uDF02"}],"version":1},"umbrella":{"id":"umbrella","name":"Umbrella","keywords":["weather","spring"],"skins":[{"unified":"2602-fe0f","native":"\u2602\uFE0F"}],"version":1},"umbrella_with_rain_drops":{"id":"umbrella_with_rain_drops","name":"Umbrella with Rain Drops","keywords":["rainy","weather","spring"],"skins":[{"unified":"2614","native":"\u2614"}],"version":1},"umbrella_on_ground":{"id":"umbrella_on_ground","name":"Umbrella on Ground","keywords":["weather","summer"],"skins":[{"unified":"26f1-fe0f","native":"\u26F1\uFE0F"}],"version":1},"zap":{"id":"zap","name":"High Voltage","keywords":["zap","thunder","weather","lightning","bolt","fast"],"skins":[{"unified":"26a1","native":"\u26A1"}],"version":1},"snowflake":{"id":"snowflake","name":"Snowflake","keywords":["winter","season","cold","weather","christmas","xmas"],"skins":[{"unified":"2744-fe0f","native":"\u2744\uFE0F"}],"version":1},"snowman":{"id":"snowman","name":"Snowman","keywords":["winter","season","cold","weather","christmas","xmas","frozen"],"skins":[{"unified":"2603-fe0f","native":"\u2603\uFE0F"}],"version":1},"snowman_without_snow":{"id":"snowman_without_snow","name":"Snowman Without Snow","keywords":["winter","season","cold","weather","christmas","xmas","frozen"],"skins":[{"unified":"26c4","native":"\u26C4"}],"version":1},"comet":{"id":"comet","name":"Comet","keywords":["space"],"skins":[{"unified":"2604-fe0f","native":"\u2604\uFE0F"}],"version":1},"fire":{"id":"fire","name":"Fire","keywords":["hot","cook","flame"],"skins":[{"unified":"1f525","native":"\uD83D\uDD25"}],"version":1},"droplet":{"id":"droplet","name":"Droplet","keywords":["water","drip","faucet","spring"],"skins":[{"unified":"1f4a7","native":"\uD83D\uDCA7"}],"version":1},"ocean":{"id":"ocean","name":"Water Wave","keywords":["ocean","sea","nature","tsunami","disaster"],"skins":[{"unified":"1f30a","native":"\uD83C\uDF0A"}],"version":1},"jack_o_lantern":{"id":"jack_o_lantern","name":"Jack-O-Lantern","keywords":["jack","o","lantern","halloween","light","pumpkin","creepy","fall"],"skins":[{"unified":"1f383","native":"\uD83C\uDF83"}],"version":1},"christmas_tree":{"id":"christmas_tree","name":"Christmas Tree","keywords":["festival","vacation","december","xmas","celebration"],"skins":[{"unified":"1f384","native":"\uD83C\uDF84"}],"version":1},"fireworks":{"id":"fireworks","name":"Fireworks","keywords":["photo","festival","carnival","congratulations"],"skins":[{"unified":"1f386","native":"\uD83C\uDF86"}],"version":1},"sparkler":{"id":"sparkler","name":"Sparkler","keywords":["stars","night","shine"],"skins":[{"unified":"1f387","native":"\uD83C\uDF87"}],"version":1},"firecracker":{"id":"firecracker","name":"Firecracker","keywords":["dynamite","boom","explode","explosion","explosive"],"skins":[{"unified":"1f9e8","native":"\uD83E\uDDE8"}],"version":11},"sparkles":{"id":"sparkles","name":"Sparkles","keywords":["stars","shine","shiny","cool","awesome","good","magic"],"skins":[{"unified":"2728","native":"\u2728"}],"version":1},"balloon":{"id":"balloon","name":"Balloon","keywords":["party","celebration","birthday","circus"],"skins":[{"unified":"1f388","native":"\uD83C\uDF88"}],"version":1},"tada":{"id":"tada","name":"Party Popper","keywords":["tada","congratulations","birthday","magic","circus","celebration"],"skins":[{"unified":"1f389","native":"\uD83C\uDF89"}],"version":1},"confetti_ball":{"id":"confetti_ball","name":"Confetti Ball","keywords":["festival","party","birthday","circus"],"skins":[{"unified":"1f38a","native":"\uD83C\uDF8A"}],"version":1},"tanabata_tree":{"id":"tanabata_tree","name":"Tanabata Tree","keywords":["plant","nature","branch","summer","bamboo","wish","star","festival","tanzaku"],"skins":[{"unified":"1f38b","native":"\uD83C\uDF8B"}],"version":1},"bamboo":{"id":"bamboo","name":"Pine Decoration","keywords":["bamboo","japanese","plant","nature","vegetable","panda","new","years"],"skins":[{"unified":"1f38d","native":"\uD83C\uDF8D"}],"version":1},"dolls":{"id":"dolls","name":"Japanese Dolls","keywords":["toy","kimono"],"skins":[{"unified":"1f38e","native":"\uD83C\uDF8E"}],"version":1},"flags":{"id":"flags","name":"Carp Streamer","keywords":["flags","fish","japanese","koinobori","banner"],"skins":[{"unified":"1f38f","native":"\uD83C\uDF8F"}],"version":1},"wind_chime":{"id":"wind_chime","name":"Wind Chime","keywords":["nature","ding","spring","bell"],"skins":[{"unified":"1f390","native":"\uD83C\uDF90"}],"version":1},"rice_scene":{"id":"rice_scene","name":"Moon Viewing Ceremony","keywords":["rice","scene","photo","japan","asia","tsukimi"],"skins":[{"unified":"1f391","native":"\uD83C\uDF91"}],"version":1},"red_envelope":{"id":"red_envelope","name":"Red Envelope","keywords":["gift"],"skins":[{"unified":"1f9e7","native":"\uD83E\uDDE7"}],"version":11},"ribbon":{"id":"ribbon","name":"Ribbon","keywords":["decoration","pink","girl","bowtie"],"skins":[{"unified":"1f380","native":"\uD83C\uDF80"}],"version":1},"gift":{"id":"gift","name":"Wrapped Gift","keywords":["present","birthday","christmas","xmas"],"skins":[{"unified":"1f381","native":"\uD83C\uDF81"}],"version":1},"reminder_ribbon":{"id":"reminder_ribbon","name":"Reminder Ribbon","keywords":["sports","cause","support","awareness"],"skins":[{"unified":"1f397-fe0f","native":"\uD83C\uDF97\uFE0F"}],"version":1},"admission_tickets":{"id":"admission_tickets","name":"Admission Tickets","keywords":["sports","concert","entrance"],"skins":[{"unified":"1f39f-fe0f","native":"\uD83C\uDF9F\uFE0F"}],"version":1},"ticket":{"id":"ticket","name":"Ticket","keywords":["event","concert","pass"],"skins":[{"unified":"1f3ab","native":"\uD83C\uDFAB"}],"version":1},"medal":{"id":"medal","name":"Military Medal","keywords":["award","winning","army"],"skins":[{"unified":"1f396-fe0f","native":"\uD83C\uDF96\uFE0F"}],"version":1},"trophy":{"id":"trophy","name":"Trophy","keywords":["win","award","contest","place","ftw","ceremony"],"skins":[{"unified":"1f3c6","native":"\uD83C\uDFC6"}],"version":1},"sports_medal":{"id":"sports_medal","name":"Sports Medal","keywords":["award","winning"],"skins":[{"unified":"1f3c5","native":"\uD83C\uDFC5"}],"version":1},"first_place_medal":{"id":"first_place_medal","name":"1st Place Medal","keywords":["first","award","winning"],"skins":[{"unified":"1f947","native":"\uD83E\uDD47"}],"version":3},"second_place_medal":{"id":"second_place_medal","name":"2nd Place Medal","keywords":["second","award"],"skins":[{"unified":"1f948","native":"\uD83E\uDD48"}],"version":3},"third_place_medal":{"id":"third_place_medal","name":"3rd Place Medal","keywords":["third","award"],"skins":[{"unified":"1f949","native":"\uD83E\uDD49"}],"version":3},"soccer":{"id":"soccer","name":"Soccer Ball","keywords":["sports","football"],"skins":[{"unified":"26bd","native":"\u26BD"}],"version":1},"baseball":{"id":"baseball","name":"Baseball","keywords":["sports","balls"],"skins":[{"unified":"26be","native":"\u26BE"}],"version":1},"softball":{"id":"softball","name":"Softball","keywords":["sports","balls"],"skins":[{"unified":"1f94e","native":"\uD83E\uDD4E"}],"version":11},"basketball":{"id":"basketball","name":"Basketball","keywords":["sports","balls","NBA"],"skins":[{"unified":"1f3c0","native":"\uD83C\uDFC0"}],"version":1},"volleyball":{"id":"volleyball","name":"Volleyball","keywords":["sports","balls"],"skins":[{"unified":"1f3d0","native":"\uD83C\uDFD0"}],"version":1},"football":{"id":"football","name":"American Football","keywords":["sports","balls","NFL"],"skins":[{"unified":"1f3c8","native":"\uD83C\uDFC8"}],"version":1},"rugby_football":{"id":"rugby_football","name":"Rugby Football","keywords":["sports","team"],"skins":[{"unified":"1f3c9","native":"\uD83C\uDFC9"}],"version":1},"tennis":{"id":"tennis","name":"Tennis","keywords":["sports","balls","green"],"skins":[{"unified":"1f3be","native":"\uD83C\uDFBE"}],"version":1},"flying_disc":{"id":"flying_disc","name":"Flying Disc","keywords":["sports","frisbee","ultimate"],"skins":[{"unified":"1f94f","native":"\uD83E\uDD4F"}],"version":11},"bowling":{"id":"bowling","name":"Bowling","keywords":["sports","fun","play"],"skins":[{"unified":"1f3b3","native":"\uD83C\uDFB3"}],"version":1},"cricket_bat_and_ball":{"id":"cricket_bat_and_ball","name":"Cricket Game","keywords":["bat","and","ball","sports"],"skins":[{"unified":"1f3cf","native":"\uD83C\uDFCF"}],"version":1},"field_hockey_stick_and_ball":{"id":"field_hockey_stick_and_ball","name":"Field Hockey","keywords":["stick","and","ball","sports"],"skins":[{"unified":"1f3d1","native":"\uD83C\uDFD1"}],"version":1},"ice_hockey_stick_and_puck":{"id":"ice_hockey_stick_and_puck","name":"Ice Hockey","keywords":["stick","and","puck","sports"],"skins":[{"unified":"1f3d2","native":"\uD83C\uDFD2"}],"version":1},"lacrosse":{"id":"lacrosse","name":"Lacrosse","keywords":["sports","ball","stick"],"skins":[{"unified":"1f94d","native":"\uD83E\uDD4D"}],"version":11},"table_tennis_paddle_and_ball":{"id":"table_tennis_paddle_and_ball","name":"Ping Pong","keywords":["table","tennis","paddle","and","ball","sports","pingpong"],"skins":[{"unified":"1f3d3","native":"\uD83C\uDFD3"}],"version":1},"badminton_racquet_and_shuttlecock":{"id":"badminton_racquet_and_shuttlecock","name":"Badminton","keywords":["racquet","and","shuttlecock","sports"],"skins":[{"unified":"1f3f8","native":"\uD83C\uDFF8"}],"version":1},"boxing_glove":{"id":"boxing_glove","name":"Boxing Glove","keywords":["sports","fighting"],"skins":[{"unified":"1f94a","native":"\uD83E\uDD4A"}],"version":3},"martial_arts_uniform":{"id":"martial_arts_uniform","name":"Martial Arts Uniform","keywords":["judo","karate","taekwondo"],"skins":[{"unified":"1f94b","native":"\uD83E\uDD4B"}],"version":3},"goal_net":{"id":"goal_net","name":"Goal Net","keywords":["sports"],"skins":[{"unified":"1f945","native":"\uD83E\uDD45"}],"version":3},"golf":{"id":"golf","name":"Flag in Hole","keywords":["golf","sports","business","summer"],"skins":[{"unified":"26f3","native":"\u26F3"}],"version":1},"ice_skate":{"id":"ice_skate","name":"Ice Skate","keywords":["sports"],"skins":[{"unified":"26f8-fe0f","native":"\u26F8\uFE0F"}],"version":1},"fishing_pole_and_fish":{"id":"fishing_pole_and_fish","name":"Fishing Pole","keywords":["and","fish","food","hobby","summer"],"skins":[{"unified":"1f3a3","native":"\uD83C\uDFA3"}],"version":1},"diving_mask":{"id":"diving_mask","name":"Diving Mask","keywords":["sport","ocean"],"skins":[{"unified":"1f93f","native":"\uD83E\uDD3F"}],"version":12},"running_shirt_with_sash":{"id":"running_shirt_with_sash","name":"Running Shirt","keywords":["with","sash","play","pageant"],"skins":[{"unified":"1f3bd","native":"\uD83C\uDFBD"}],"version":1},"ski":{"id":"ski","name":"Skis","keywords":["ski","sports","winter","cold","snow"],"skins":[{"unified":"1f3bf","native":"\uD83C\uDFBF"}],"version":1},"sled":{"id":"sled","name":"Sled","keywords":["sleigh","luge","toboggan"],"skins":[{"unified":"1f6f7","native":"\uD83D\uDEF7"}],"version":5},"curling_stone":{"id":"curling_stone","name":"Curling Stone","keywords":["sports"],"skins":[{"unified":"1f94c","native":"\uD83E\uDD4C"}],"version":5},"dart":{"id":"dart","name":"Bullseye","keywords":["dart","direct","hit","game","play","bar","target"],"skins":[{"unified":"1f3af","native":"\uD83C\uDFAF"}],"version":1},"yo-yo":{"id":"yo-yo","name":"Yo-Yo","keywords":["yo","toy"],"skins":[{"unified":"1fa80","native":"\uD83E\uDE80"}],"version":12},"kite":{"id":"kite","name":"Kite","keywords":["wind","fly"],"skins":[{"unified":"1fa81","native":"\uD83E\uDE81"}],"version":12},"gun":{"id":"gun","name":"Pistol","keywords":["gun","violence","weapon","revolver"],"skins":[{"unified":"1f52b","native":"\uD83D\uDD2B"}],"version":1},"8ball":{"id":"8ball","name":"Billiards","keywords":["8ball","pool","8","ball","hobby","game","luck","magic"],"skins":[{"unified":"1f3b1","native":"\uD83C\uDFB1"}],"version":1},"crystal_ball":{"id":"crystal_ball","name":"Crystal Ball","keywords":["disco","party","magic","circus","fortune","teller"],"skins":[{"unified":"1f52e","native":"\uD83D\uDD2E"}],"version":1},"magic_wand":{"id":"magic_wand","name":"Magic Wand","keywords":["supernature","power"],"skins":[{"unified":"1fa84","native":"\uD83E\uDE84"}],"version":13},"video_game":{"id":"video_game","name":"Video Game","keywords":["play","console","PS4","controller"],"skins":[{"unified":"1f3ae","native":"\uD83C\uDFAE"}],"version":1},"joystick":{"id":"joystick","name":"Joystick","keywords":["game","play"],"skins":[{"unified":"1f579-fe0f","native":"\uD83D\uDD79\uFE0F"}],"version":1},"slot_machine":{"id":"slot_machine","name":"Slot Machine","keywords":["bet","gamble","vegas","fruit","luck","casino"],"skins":[{"unified":"1f3b0","native":"\uD83C\uDFB0"}],"version":1},"game_die":{"id":"game_die","name":"Game Die","keywords":["dice","random","tabletop","play","luck"],"skins":[{"unified":"1f3b2","native":"\uD83C\uDFB2"}],"version":1},"jigsaw":{"id":"jigsaw","name":"Puzzle Piece","keywords":["jigsaw","interlocking"],"skins":[{"unified":"1f9e9","native":"\uD83E\uDDE9"}],"version":11},"teddy_bear":{"id":"teddy_bear","name":"Teddy Bear","keywords":["plush","stuffed"],"skins":[{"unified":"1f9f8","native":"\uD83E\uDDF8"}],"version":11},"pinata":{"id":"pinata","name":"Pinata","keywords":["mexico","candy","celebration"],"skins":[{"unified":"1fa85","native":"\uD83E\uDE85"}],"version":13},"mirror_ball":{"id":"mirror_ball","name":"Mirror Ball","keywords":["disco","dance","party"],"skins":[{"unified":"1faa9","native":"\uD83E\uDEA9"}],"version":14},"nesting_dolls":{"id":"nesting_dolls","name":"Nesting Dolls","keywords":["matryoshka","toy"],"skins":[{"unified":"1fa86","native":"\uD83E\uDE86"}],"version":13},"spades":{"id":"spades","name":"Spade Suit","keywords":["spades","poker","cards","suits","magic"],"skins":[{"unified":"2660-fe0f","native":"\u2660\uFE0F"}],"version":1},"hearts":{"id":"hearts","name":"Heart Suit","keywords":["hearts","poker","cards","magic","suits"],"skins":[{"unified":"2665-fe0f","native":"\u2665\uFE0F"}],"version":1},"diamonds":{"id":"diamonds","name":"Diamond Suit","keywords":["diamonds","poker","cards","magic","suits"],"skins":[{"unified":"2666-fe0f","native":"\u2666\uFE0F"}],"version":1},"clubs":{"id":"clubs","name":"Club Suit","keywords":["clubs","poker","cards","magic","suits"],"skins":[{"unified":"2663-fe0f","native":"\u2663\uFE0F"}],"version":1},"chess_pawn":{"id":"chess_pawn","name":"Chess Pawn","keywords":["expendable"],"skins":[{"unified":"265f-fe0f","native":"\u265F\uFE0F"}],"version":11},"black_joker":{"id":"black_joker","name":"Joker","keywords":["black","poker","cards","game","play","magic"],"skins":[{"unified":"1f0cf","native":"\uD83C\uDCCF"}],"version":1},"mahjong":{"id":"mahjong","name":"Mahjong Red Dragon","keywords":["game","play","chinese","kanji"],"skins":[{"unified":"1f004","native":"\uD83C\uDC04"}],"version":1},"flower_playing_cards":{"id":"flower_playing_cards","name":"Flower Playing Cards","keywords":["game","sunset","red"],"skins":[{"unified":"1f3b4","native":"\uD83C\uDFB4"}],"version":1},"performing_arts":{"id":"performing_arts","name":"Performing Arts","keywords":["acting","theater","drama"],"skins":[{"unified":"1f3ad","native":"\uD83C\uDFAD"}],"version":1},"frame_with_picture":{"id":"frame_with_picture","name":"Framed Picture","keywords":["frame","with","photography"],"skins":[{"unified":"1f5bc-fe0f","native":"\uD83D\uDDBC\uFE0F"}],"version":1},"art":{"id":"art","name":"Artist Palette","keywords":["art","design","paint","draw","colors"],"skins":[{"unified":"1f3a8","native":"\uD83C\uDFA8"}],"version":1},"thread":{"id":"thread","name":"Thread","keywords":["needle","sewing","spool","string"],"skins":[{"unified":"1f9f5","native":"\uD83E\uDDF5"}],"version":11},"sewing_needle":{"id":"sewing_needle","name":"Sewing Needle","keywords":["stitches"],"skins":[{"unified":"1faa1","native":"\uD83E\uDEA1"}],"version":13},"yarn":{"id":"yarn","name":"Yarn","keywords":["ball","crochet","knit"],"skins":[{"unified":"1f9f6","native":"\uD83E\uDDF6"}],"version":11},"knot":{"id":"knot","name":"Knot","keywords":["rope","scout"],"skins":[{"unified":"1faa2","native":"\uD83E\uDEA2"}],"version":13},"eyeglasses":{"id":"eyeglasses","name":"Glasses","keywords":["eyeglasses","fashion","accessories","eyesight","nerdy","dork","geek"],"skins":[{"unified":"1f453","native":"\uD83D\uDC53"}],"version":1},"dark_sunglasses":{"id":"dark_sunglasses","name":"Sunglasses","keywords":["dark","face","cool","accessories"],"skins":[{"unified":"1f576-fe0f","native":"\uD83D\uDD76\uFE0F"}],"version":1},"goggles":{"id":"goggles","name":"Goggles","keywords":["eyes","protection","safety"],"skins":[{"unified":"1f97d","native":"\uD83E\uDD7D"}],"version":11},"lab_coat":{"id":"lab_coat","name":"Lab Coat","keywords":["doctor","experiment","scientist","chemist"],"skins":[{"unified":"1f97c","native":"\uD83E\uDD7C"}],"version":11},"safety_vest":{"id":"safety_vest","name":"Safety Vest","keywords":["protection"],"skins":[{"unified":"1f9ba","native":"\uD83E\uDDBA"}],"version":12},"necktie":{"id":"necktie","name":"Necktie","keywords":["shirt","suitup","formal","fashion","cloth","business"],"skins":[{"unified":"1f454","native":"\uD83D\uDC54"}],"version":1},"shirt":{"id":"shirt","name":"T-Shirt","keywords":["shirt","tshirt","t","fashion","cloth","casual","tee"],"skins":[{"unified":"1f455","native":"\uD83D\uDC55"}],"version":1},"jeans":{"id":"jeans","name":"Jeans","keywords":["fashion","shopping"],"skins":[{"unified":"1f456","native":"\uD83D\uDC56"}],"version":1},"scarf":{"id":"scarf","name":"Scarf","keywords":["neck","winter","clothes"],"skins":[{"unified":"1f9e3","native":"\uD83E\uDDE3"}],"version":5},"gloves":{"id":"gloves","name":"Gloves","keywords":["hands","winter","clothes"],"skins":[{"unified":"1f9e4","native":"\uD83E\uDDE4"}],"version":5},"coat":{"id":"coat","name":"Coat","keywords":["jacket"],"skins":[{"unified":"1f9e5","native":"\uD83E\uDDE5"}],"version":5},"socks":{"id":"socks","name":"Socks","keywords":["stockings","clothes"],"skins":[{"unified":"1f9e6","native":"\uD83E\uDDE6"}],"version":5},"dress":{"id":"dress","name":"Dress","keywords":["clothes","fashion","shopping"],"skins":[{"unified":"1f457","native":"\uD83D\uDC57"}],"version":1},"kimono":{"id":"kimono","name":"Kimono","keywords":["dress","fashion","women","female","japanese"],"skins":[{"unified":"1f458","native":"\uD83D\uDC58"}],"version":1},"sari":{"id":"sari","name":"Sari","keywords":["dress"],"skins":[{"unified":"1f97b","native":"\uD83E\uDD7B"}],"version":12},"one-piece_swimsuit":{"id":"one-piece_swimsuit","name":"One-Piece Swimsuit","keywords":["one","piece","fashion"],"skins":[{"unified":"1fa71","native":"\uD83E\uDE71"}],"version":12},"briefs":{"id":"briefs","name":"Briefs","keywords":["clothing"],"skins":[{"unified":"1fa72","native":"\uD83E\uDE72"}],"version":12},"shorts":{"id":"shorts","name":"Shorts","keywords":["clothing"],"skins":[{"unified":"1fa73","native":"\uD83E\uDE73"}],"version":12},"bikini":{"id":"bikini","name":"Bikini","keywords":["swimming","female","woman","girl","fashion","beach","summer"],"skins":[{"unified":"1f459","native":"\uD83D\uDC59"}],"version":1},"womans_clothes":{"id":"womans_clothes","name":"Womans Clothes","keywords":["woman","s","fashion","shopping","bags","female"],"skins":[{"unified":"1f45a","native":"\uD83D\uDC5A"}],"version":1},"folding_hand_fan":{"id":"folding_hand_fan","name":"Folding Hand Fan","keywords":["flamenco","hot"],"skins":[{"unified":"1faad","native":"\uD83E\uDEAD"}],"version":15},"purse":{"id":"purse","name":"Purse","keywords":["fashion","accessories","money","sales","shopping"],"skins":[{"unified":"1f45b","native":"\uD83D\uDC5B"}],"version":1},"handbag":{"id":"handbag","name":"Handbag","keywords":["fashion","accessory","accessories","shopping"],"skins":[{"unified":"1f45c","native":"\uD83D\uDC5C"}],"version":1},"pouch":{"id":"pouch","name":"Pouch","keywords":["clutch","bag","accessories","shopping"],"skins":[{"unified":"1f45d","native":"\uD83D\uDC5D"}],"version":1},"shopping_bags":{"id":"shopping_bags","name":"Shopping Bags","keywords":["mall","buy","purchase"],"skins":[{"unified":"1f6cd-fe0f","native":"\uD83D\uDECD\uFE0F"}],"version":1},"school_satchel":{"id":"school_satchel","name":"Backpack","keywords":["school","satchel","student","education","bag"],"skins":[{"unified":"1f392","native":"\uD83C\uDF92"}],"version":1},"thong_sandal":{"id":"thong_sandal","name":"Thong Sandal","keywords":["footwear","summer"],"skins":[{"unified":"1fa74","native":"\uD83E\uDE74"}],"version":13},"mans_shoe":{"id":"mans_shoe","name":"Mans Shoe","keywords":["man","s","fashion","male"],"skins":[{"unified":"1f45e","native":"\uD83D\uDC5E"}],"version":1},"athletic_shoe":{"id":"athletic_shoe","name":"Running Shoe","keywords":["athletic","shoes","sports","sneakers"],"skins":[{"unified":"1f45f","native":"\uD83D\uDC5F"}],"version":1},"hiking_boot":{"id":"hiking_boot","name":"Hiking Boot","keywords":["backpacking","camping"],"skins":[{"unified":"1f97e","native":"\uD83E\uDD7E"}],"version":11},"womans_flat_shoe":{"id":"womans_flat_shoe","name":"Flat Shoe","keywords":["womans","ballet","slip","on","slipper"],"skins":[{"unified":"1f97f","native":"\uD83E\uDD7F"}],"version":11},"high_heel":{"id":"high_heel","name":"High-Heeled Shoe","keywords":["high","heel","heeled","fashion","shoes","female","pumps","stiletto"],"skins":[{"unified":"1f460","native":"\uD83D\uDC60"}],"version":1},"sandal":{"id":"sandal","name":"Womans Sandal","keywords":["woman","s","shoes","fashion","flip","flops"],"skins":[{"unified":"1f461","native":"\uD83D\uDC61"}],"version":1},"ballet_shoes":{"id":"ballet_shoes","name":"Ballet Shoes","keywords":["dance"],"skins":[{"unified":"1fa70","native":"\uD83E\uDE70"}],"version":12},"boot":{"id":"boot","name":"Womans Boots","keywords":["boot","woman","s","shoes","fashion"],"skins":[{"unified":"1f462","native":"\uD83D\uDC62"}],"version":1},"hair_pick":{"id":"hair_pick","name":"Hair Pick","keywords":["afro","comb"],"skins":[{"unified":"1faae","native":"\uD83E\uDEAE"}],"version":15},"crown":{"id":"crown","name":"Crown","keywords":["king","kod","leader","royalty","lord"],"skins":[{"unified":"1f451","native":"\uD83D\uDC51"}],"version":1},"womans_hat":{"id":"womans_hat","name":"Womans Hat","keywords":["woman","s","fashion","accessories","female","lady","spring"],"skins":[{"unified":"1f452","native":"\uD83D\uDC52"}],"version":1},"tophat":{"id":"tophat","name":"Top Hat","keywords":["tophat","magic","gentleman","classy","circus"],"skins":[{"unified":"1f3a9","native":"\uD83C\uDFA9"}],"version":1},"mortar_board":{"id":"mortar_board","name":"Graduation Cap","keywords":["mortar","board","school","college","degree","university","hat","legal","learn","education"],"skins":[{"unified":"1f393","native":"\uD83C\uDF93"}],"version":1},"billed_cap":{"id":"billed_cap","name":"Billed Cap","keywords":["baseball"],"skins":[{"unified":"1f9e2","native":"\uD83E\uDDE2"}],"version":5},"military_helmet":{"id":"military_helmet","name":"Military Helmet","keywords":["army","protection"],"skins":[{"unified":"1fa96","native":"\uD83E\uDE96"}],"version":13},"helmet_with_white_cross":{"id":"helmet_with_white_cross","name":"Rescue Worker\u2019s Helmet","keywords":["with","white","cross","worker","s","construction","build"],"skins":[{"unified":"26d1-fe0f","native":"\u26D1\uFE0F"}],"version":1},"prayer_beads":{"id":"prayer_beads","name":"Prayer Beads","keywords":["dhikr","religious"],"skins":[{"unified":"1f4ff","native":"\uD83D\uDCFF"}],"version":1},"lipstick":{"id":"lipstick","name":"Lipstick","keywords":["female","girl","fashion","woman"],"skins":[{"unified":"1f484","native":"\uD83D\uDC84"}],"version":1},"ring":{"id":"ring","name":"Ring","keywords":["wedding","propose","marriage","valentines","diamond","fashion","jewelry","gem","engagement"],"skins":[{"unified":"1f48d","native":"\uD83D\uDC8D"}],"version":1},"gem":{"id":"gem","name":"Gem Stone","keywords":["blue","ruby","diamond","jewelry"],"skins":[{"unified":"1f48e","native":"\uD83D\uDC8E"}],"version":1},"mute":{"id":"mute","name":"Muted Speaker","keywords":["mute","sound","volume","silence","quiet"],"skins":[{"unified":"1f507","native":"\uD83D\uDD07"}],"version":1},"speaker":{"id":"speaker","name":"Speaker","keywords":["low","volume","sound","silence","broadcast"],"skins":[{"unified":"1f508","native":"\uD83D\uDD08"}],"version":1},"sound":{"id":"sound","name":"Speaker Medium Volume","keywords":["sound","broadcast"],"skins":[{"unified":"1f509","native":"\uD83D\uDD09"}],"version":1},"loud_sound":{"id":"loud_sound","name":"Speaker High Volume","keywords":["loud","sound","noise","noisy","broadcast"],"skins":[{"unified":"1f50a","native":"\uD83D\uDD0A"}],"version":1},"loudspeaker":{"id":"loudspeaker","name":"Loudspeaker","keywords":["volume","sound"],"skins":[{"unified":"1f4e2","native":"\uD83D\uDCE2"}],"version":1},"mega":{"id":"mega","name":"Megaphone","keywords":["mega","sound","speaker","volume"],"skins":[{"unified":"1f4e3","native":"\uD83D\uDCE3"}],"version":1},"postal_horn":{"id":"postal_horn","name":"Postal Horn","keywords":["instrument","music"],"skins":[{"unified":"1f4ef","native":"\uD83D\uDCEF"}],"version":1},"bell":{"id":"bell","name":"Bell","keywords":["sound","notification","christmas","xmas","chime"],"skins":[{"unified":"1f514","native":"\uD83D\uDD14"}],"version":1},"no_bell":{"id":"no_bell","name":"Bell with Slash","keywords":["no","sound","volume","mute","quiet","silent"],"skins":[{"unified":"1f515","native":"\uD83D\uDD15"}],"version":1},"musical_score":{"id":"musical_score","name":"Musical Score","keywords":["treble","clef","compose"],"skins":[{"unified":"1f3bc","native":"\uD83C\uDFBC"}],"version":1},"musical_note":{"id":"musical_note","name":"Musical Note","keywords":["score","tone","sound"],"skins":[{"unified":"1f3b5","native":"\uD83C\uDFB5"}],"version":1},"notes":{"id":"notes","name":"Musical Notes","keywords":["music","score"],"skins":[{"unified":"1f3b6","native":"\uD83C\uDFB6"}],"version":1},"studio_microphone":{"id":"studio_microphone","name":"Studio Microphone","keywords":["sing","recording","artist","talkshow"],"skins":[{"unified":"1f399-fe0f","native":"\uD83C\uDF99\uFE0F"}],"version":1},"level_slider":{"id":"level_slider","name":"Level Slider","keywords":["scale"],"skins":[{"unified":"1f39a-fe0f","native":"\uD83C\uDF9A\uFE0F"}],"version":1},"control_knobs":{"id":"control_knobs","name":"Control Knobs","keywords":["dial"],"skins":[{"unified":"1f39b-fe0f","native":"\uD83C\uDF9B\uFE0F"}],"version":1},"microphone":{"id":"microphone","name":"Microphone","keywords":["sound","music","PA","sing","talkshow"],"skins":[{"unified":"1f3a4","native":"\uD83C\uDFA4"}],"version":1},"headphones":{"id":"headphones","name":"Headphone","keywords":["headphones","music","score","gadgets"],"skins":[{"unified":"1f3a7","native":"\uD83C\uDFA7"}],"version":1},"radio":{"id":"radio","name":"Radio","keywords":["communication","music","podcast","program"],"skins":[{"unified":"1f4fb","native":"\uD83D\uDCFB"}],"version":1},"saxophone":{"id":"saxophone","name":"Saxophone","keywords":["music","instrument","jazz","blues"],"skins":[{"unified":"1f3b7","native":"\uD83C\uDFB7"}],"version":1},"accordion":{"id":"accordion","name":"Accordion","keywords":["music"],"skins":[{"unified":"1fa97","native":"\uD83E\uDE97"}],"version":13},"guitar":{"id":"guitar","name":"Guitar","keywords":["music","instrument"],"skins":[{"unified":"1f3b8","native":"\uD83C\uDFB8"}],"version":1},"musical_keyboard":{"id":"musical_keyboard","name":"Musical Keyboard","keywords":["piano","instrument","compose"],"skins":[{"unified":"1f3b9","native":"\uD83C\uDFB9"}],"version":1},"trumpet":{"id":"trumpet","name":"Trumpet","keywords":["music","brass"],"skins":[{"unified":"1f3ba","native":"\uD83C\uDFBA"}],"version":1},"violin":{"id":"violin","name":"Violin","keywords":["music","instrument","orchestra","symphony"],"skins":[{"unified":"1f3bb","native":"\uD83C\uDFBB"}],"version":1},"banjo":{"id":"banjo","name":"Banjo","keywords":["music","instructment"],"skins":[{"unified":"1fa95","native":"\uD83E\uDE95"}],"version":12},"drum_with_drumsticks":{"id":"drum_with_drumsticks","name":"Drum","keywords":["with","drumsticks","music","instrument","snare"],"skins":[{"unified":"1f941","native":"\uD83E\uDD41"}],"version":3},"long_drum":{"id":"long_drum","name":"Long Drum","keywords":["music"],"skins":[{"unified":"1fa98","native":"\uD83E\uDE98"}],"version":13},"maracas":{"id":"maracas","name":"Maracas","keywords":["music","instrument","percussion"],"skins":[{"unified":"1fa87","native":"\uD83E\uDE87"}],"version":15},"flute":{"id":"flute","name":"Flute","keywords":["bamboo","music","instrument","pied","piper"],"skins":[{"unified":"1fa88","native":"\uD83E\uDE88"}],"version":15},"iphone":{"id":"iphone","name":"Mobile Phone","keywords":["iphone","technology","apple","gadgets","dial"],"skins":[{"unified":"1f4f1","native":"\uD83D\uDCF1"}],"version":1},"calling":{"id":"calling","name":"Mobile Phone with Arrow","keywords":["calling","iphone","incoming"],"skins":[{"unified":"1f4f2","native":"\uD83D\uDCF2"}],"version":1},"phone":{"id":"phone","name":"Telephone","keywords":["phone","technology","communication","dial"],"skins":[{"unified":"260e-fe0f","native":"\u260E\uFE0F"}],"version":1},"telephone_receiver":{"id":"telephone_receiver","name":"Telephone Receiver","keywords":["technology","communication","dial"],"skins":[{"unified":"1f4de","native":"\uD83D\uDCDE"}],"version":1},"pager":{"id":"pager","name":"Pager","keywords":["bbcall","oldschool","90s"],"skins":[{"unified":"1f4df","native":"\uD83D\uDCDF"}],"version":1},"fax":{"id":"fax","name":"Fax Machine","keywords":["communication","technology"],"skins":[{"unified":"1f4e0","native":"\uD83D\uDCE0"}],"version":1},"battery":{"id":"battery","name":"Battery","keywords":["power","energy","sustain"],"skins":[{"unified":"1f50b","native":"\uD83D\uDD0B"}],"version":1},"low_battery":{"id":"low_battery","name":"Low Battery","keywords":["drained","dead"],"skins":[{"unified":"1faab","native":"\uD83E\uDEAB"}],"version":14},"electric_plug":{"id":"electric_plug","name":"Electric Plug","keywords":["charger","power"],"skins":[{"unified":"1f50c","native":"\uD83D\uDD0C"}],"version":1},"computer":{"id":"computer","name":"Laptop","keywords":["computer","technology","screen","display","monitor"],"skins":[{"unified":"1f4bb","native":"\uD83D\uDCBB"}],"version":1},"desktop_computer":{"id":"desktop_computer","name":"Desktop Computer","keywords":["technology","computing","screen"],"skins":[{"unified":"1f5a5-fe0f","native":"\uD83D\uDDA5\uFE0F"}],"version":1},"printer":{"id":"printer","name":"Printer","keywords":["paper","ink"],"skins":[{"unified":"1f5a8-fe0f","native":"\uD83D\uDDA8\uFE0F"}],"version":1},"keyboard":{"id":"keyboard","name":"Keyboard","keywords":["technology","computer","type","input","text"],"skins":[{"unified":"2328-fe0f","native":"\u2328\uFE0F"}],"version":1},"three_button_mouse":{"id":"three_button_mouse","name":"Computer Mouse","keywords":["three","button","click"],"skins":[{"unified":"1f5b1-fe0f","native":"\uD83D\uDDB1\uFE0F"}],"version":1},"trackball":{"id":"trackball","name":"Trackball","keywords":["technology","trackpad"],"skins":[{"unified":"1f5b2-fe0f","native":"\uD83D\uDDB2\uFE0F"}],"version":1},"minidisc":{"id":"minidisc","name":"Minidisc","keywords":["computer","disk","technology","record","data","90s"],"skins":[{"unified":"1f4bd","native":"\uD83D\uDCBD"}],"version":1},"floppy_disk":{"id":"floppy_disk","name":"Floppy Disk","keywords":["oldschool","technology","save","90s","80s"],"skins":[{"unified":"1f4be","native":"\uD83D\uDCBE"}],"version":1},"cd":{"id":"cd","name":"Optical Disc","keywords":["cd","disk","technology","dvd","90s"],"skins":[{"unified":"1f4bf","native":"\uD83D\uDCBF"}],"version":1},"dvd":{"id":"dvd","name":"Dvd","keywords":["cd","disk","disc"],"skins":[{"unified":"1f4c0","native":"\uD83D\uDCC0"}],"version":1},"abacus":{"id":"abacus","name":"Abacus","keywords":["calculation"],"skins":[{"unified":"1f9ee","native":"\uD83E\uDDEE"}],"version":11},"movie_camera":{"id":"movie_camera","name":"Movie Camera","keywords":["film","record"],"skins":[{"unified":"1f3a5","native":"\uD83C\uDFA5"}],"version":1},"film_frames":{"id":"film_frames","name":"Film Frames","keywords":["movie"],"skins":[{"unified":"1f39e-fe0f","native":"\uD83C\uDF9E\uFE0F"}],"version":1},"film_projector":{"id":"film_projector","name":"Film Projector","keywords":["video","tape","record","movie"],"skins":[{"unified":"1f4fd-fe0f","native":"\uD83D\uDCFD\uFE0F"}],"version":1},"clapper":{"id":"clapper","name":"Clapper Board","keywords":["movie","film","record"],"skins":[{"unified":"1f3ac","native":"\uD83C\uDFAC"}],"version":1},"tv":{"id":"tv","name":"Television","keywords":["tv","technology","program","oldschool","show"],"skins":[{"unified":"1f4fa","native":"\uD83D\uDCFA"}],"version":1},"camera":{"id":"camera","name":"Camera","keywords":["gadgets","photography"],"skins":[{"unified":"1f4f7","native":"\uD83D\uDCF7"}],"version":1},"camera_with_flash":{"id":"camera_with_flash","name":"Camera with Flash","keywords":["photography","gadgets"],"skins":[{"unified":"1f4f8","native":"\uD83D\uDCF8"}],"version":1},"video_camera":{"id":"video_camera","name":"Video Camera","keywords":["film","record"],"skins":[{"unified":"1f4f9","native":"\uD83D\uDCF9"}],"version":1},"vhs":{"id":"vhs","name":"Videocassette","keywords":["vhs","record","video","oldschool","90s","80s"],"skins":[{"unified":"1f4fc","native":"\uD83D\uDCFC"}],"version":1},"mag":{"id":"mag","name":"Magnifying Glass Tilted Left","keywords":["mag","search","zoom","find","detective"],"skins":[{"unified":"1f50d","native":"\uD83D\uDD0D"}],"version":1},"mag_right":{"id":"mag_right","name":"Magnifying Glass Tilted Right","keywords":["mag","search","zoom","find","detective"],"skins":[{"unified":"1f50e","native":"\uD83D\uDD0E"}],"version":1},"candle":{"id":"candle","name":"Candle","keywords":["fire","wax"],"skins":[{"unified":"1f56f-fe0f","native":"\uD83D\uDD6F\uFE0F"}],"version":1},"bulb":{"id":"bulb","name":"Light Bulb","keywords":["electricity","idea"],"skins":[{"unified":"1f4a1","native":"\uD83D\uDCA1"}],"version":1},"flashlight":{"id":"flashlight","name":"Flashlight","keywords":["dark","camping","sight","night"],"skins":[{"unified":"1f526","native":"\uD83D\uDD26"}],"version":1},"izakaya_lantern":{"id":"izakaya_lantern","name":"Izakaya Lantern","keywords":["red","paper","light","halloween","spooky"],"skins":[{"unified":"1f3ee","native":"\uD83C\uDFEE"}],"version":1},"diya_lamp":{"id":"diya_lamp","name":"Diya Lamp","keywords":["lighting"],"skins":[{"unified":"1fa94","native":"\uD83E\uDE94"}],"version":12},"notebook_with_decorative_cover":{"id":"notebook_with_decorative_cover","name":"Notebook with Decorative Cover","keywords":["classroom","notes","record","paper","study"],"skins":[{"unified":"1f4d4","native":"\uD83D\uDCD4"}],"version":1},"closed_book":{"id":"closed_book","name":"Closed Book","keywords":["read","library","knowledge","textbook","learn"],"skins":[{"unified":"1f4d5","native":"\uD83D\uDCD5"}],"version":1},"book":{"id":"book","name":"Open Book","keywords":["read","library","knowledge","literature","learn","study"],"skins":[{"unified":"1f4d6","native":"\uD83D\uDCD6"}],"version":1},"green_book":{"id":"green_book","name":"Green Book","keywords":["read","library","knowledge","study"],"skins":[{"unified":"1f4d7","native":"\uD83D\uDCD7"}],"version":1},"blue_book":{"id":"blue_book","name":"Blue Book","keywords":["read","library","knowledge","learn","study"],"skins":[{"unified":"1f4d8","native":"\uD83D\uDCD8"}],"version":1},"orange_book":{"id":"orange_book","name":"Orange Book","keywords":["read","library","knowledge","textbook","study"],"skins":[{"unified":"1f4d9","native":"\uD83D\uDCD9"}],"version":1},"books":{"id":"books","name":"Books","keywords":["literature","library","study"],"skins":[{"unified":"1f4da","native":"\uD83D\uDCDA"}],"version":1},"notebook":{"id":"notebook","name":"Notebook","keywords":["stationery","record","notes","paper","study"],"skins":[{"unified":"1f4d3","native":"\uD83D\uDCD3"}],"version":1},"ledger":{"id":"ledger","name":"Ledger","keywords":["notes","paper"],"skins":[{"unified":"1f4d2","native":"\uD83D\uDCD2"}],"version":1},"page_with_curl":{"id":"page_with_curl","name":"Page with Curl","keywords":["documents","office","paper"],"skins":[{"unified":"1f4c3","native":"\uD83D\uDCC3"}],"version":1},"scroll":{"id":"scroll","name":"Scroll","keywords":["documents","ancient","history","paper"],"skins":[{"unified":"1f4dc","native":"\uD83D\uDCDC"}],"version":1},"page_facing_up":{"id":"page_facing_up","name":"Page Facing Up","keywords":["documents","office","paper","information"],"skins":[{"unified":"1f4c4","native":"\uD83D\uDCC4"}],"version":1},"newspaper":{"id":"newspaper","name":"Newspaper","keywords":["press","headline"],"skins":[{"unified":"1f4f0","native":"\uD83D\uDCF0"}],"version":1},"rolled_up_newspaper":{"id":"rolled_up_newspaper","name":"Rolled-Up Newspaper","keywords":["rolled","up","press","headline"],"skins":[{"unified":"1f5de-fe0f","native":"\uD83D\uDDDE\uFE0F"}],"version":1},"bookmark_tabs":{"id":"bookmark_tabs","name":"Bookmark Tabs","keywords":["favorite","save","order","tidy"],"skins":[{"unified":"1f4d1","native":"\uD83D\uDCD1"}],"version":1},"bookmark":{"id":"bookmark","name":"Bookmark","keywords":["favorite","label","save"],"skins":[{"unified":"1f516","native":"\uD83D\uDD16"}],"version":1},"label":{"id":"label","name":"Label","keywords":["sale","tag"],"skins":[{"unified":"1f3f7-fe0f","native":"\uD83C\uDFF7\uFE0F"}],"version":1},"moneybag":{"id":"moneybag","name":"Money Bag","keywords":["moneybag","dollar","payment","coins","sale"],"skins":[{"unified":"1f4b0","native":"\uD83D\uDCB0"}],"version":1},"coin":{"id":"coin","name":"Coin","keywords":["money","currency"],"skins":[{"unified":"1fa99","native":"\uD83E\uDE99"}],"version":13},"yen":{"id":"yen","name":"Yen Banknote","keywords":["money","sales","japanese","dollar","currency"],"skins":[{"unified":"1f4b4","native":"\uD83D\uDCB4"}],"version":1},"dollar":{"id":"dollar","name":"Dollar Banknote","keywords":["money","sales","bill","currency"],"skins":[{"unified":"1f4b5","native":"\uD83D\uDCB5"}],"version":1},"euro":{"id":"euro","name":"Euro Banknote","keywords":["money","sales","dollar","currency"],"skins":[{"unified":"1f4b6","native":"\uD83D\uDCB6"}],"version":1},"pound":{"id":"pound","name":"Pound Banknote","keywords":["british","sterling","money","sales","bills","uk","england","currency"],"skins":[{"unified":"1f4b7","native":"\uD83D\uDCB7"}],"version":1},"money_with_wings":{"id":"money_with_wings","name":"Money with Wings","keywords":["dollar","bills","payment","sale"],"skins":[{"unified":"1f4b8","native":"\uD83D\uDCB8"}],"version":1},"credit_card":{"id":"credit_card","name":"Credit Card","keywords":["money","sales","dollar","bill","payment","shopping"],"skins":[{"unified":"1f4b3","native":"\uD83D\uDCB3"}],"version":1},"receipt":{"id":"receipt","name":"Receipt","keywords":["accounting","expenses"],"skins":[{"unified":"1f9fe","native":"\uD83E\uDDFE"}],"version":11},"chart":{"id":"chart","name":"Chart Increasing with Yen","keywords":["green","square","graph","presentation","stats"],"skins":[{"unified":"1f4b9","native":"\uD83D\uDCB9"}],"version":1},"email":{"id":"email","name":"Envelope","keywords":["email","letter","postal","inbox","communication"],"skins":[{"unified":"2709-fe0f","native":"\u2709\uFE0F"}],"version":1},"e-mail":{"id":"e-mail","name":"E-Mail","keywords":["e","mail","communication","inbox"],"skins":[{"unified":"1f4e7","native":"\uD83D\uDCE7"}],"version":1},"incoming_envelope":{"id":"incoming_envelope","name":"Incoming Envelope","keywords":["email","inbox"],"skins":[{"unified":"1f4e8","native":"\uD83D\uDCE8"}],"version":1},"envelope_with_arrow":{"id":"envelope_with_arrow","name":"Envelope with Arrow","keywords":["email","communication"],"skins":[{"unified":"1f4e9","native":"\uD83D\uDCE9"}],"version":1},"outbox_tray":{"id":"outbox_tray","name":"Outbox Tray","keywords":["inbox","email"],"skins":[{"unified":"1f4e4","native":"\uD83D\uDCE4"}],"version":1},"inbox_tray":{"id":"inbox_tray","name":"Inbox Tray","keywords":["email","documents"],"skins":[{"unified":"1f4e5","native":"\uD83D\uDCE5"}],"version":1},"package":{"id":"package","name":"Package","keywords":["mail","gift","cardboard","box","moving"],"skins":[{"unified":"1f4e6","native":"\uD83D\uDCE6"}],"version":1},"mailbox":{"id":"mailbox","name":"Closed Mailbox with Raised Flag","keywords":["email","inbox","communication"],"skins":[{"unified":"1f4eb","native":"\uD83D\uDCEB"}],"version":1},"mailbox_closed":{"id":"mailbox_closed","name":"Closed Mailbox with Lowered Flag","keywords":["email","communication","inbox"],"skins":[{"unified":"1f4ea","native":"\uD83D\uDCEA"}],"version":1},"mailbox_with_mail":{"id":"mailbox_with_mail","name":"Open Mailbox with Raised Flag","keywords":["mail","email","inbox","communication"],"skins":[{"unified":"1f4ec","native":"\uD83D\uDCEC"}],"version":1},"mailbox_with_no_mail":{"id":"mailbox_with_no_mail","name":"Open Mailbox with Lowered Flag","keywords":["no","mail","email","inbox"],"skins":[{"unified":"1f4ed","native":"\uD83D\uDCED"}],"version":1},"postbox":{"id":"postbox","name":"Postbox","keywords":["email","letter","envelope"],"skins":[{"unified":"1f4ee","native":"\uD83D\uDCEE"}],"version":1},"ballot_box_with_ballot":{"id":"ballot_box_with_ballot","name":"Ballot Box with Ballot","keywords":["election","vote"],"skins":[{"unified":"1f5f3-fe0f","native":"\uD83D\uDDF3\uFE0F"}],"version":1},"pencil2":{"id":"pencil2","name":"Pencil","keywords":["pencil2","stationery","write","paper","writing","school","study"],"skins":[{"unified":"270f-fe0f","native":"\u270F\uFE0F"}],"version":1},"black_nib":{"id":"black_nib","name":"Black Nib","keywords":["pen","stationery","writing","write"],"skins":[{"unified":"2712-fe0f","native":"\u2712\uFE0F"}],"version":1},"lower_left_fountain_pen":{"id":"lower_left_fountain_pen","name":"Fountain Pen","keywords":["lower","left","stationery","writing","write"],"skins":[{"unified":"1f58b-fe0f","native":"\uD83D\uDD8B\uFE0F"}],"version":1},"lower_left_ballpoint_pen":{"id":"lower_left_ballpoint_pen","name":"Pen","keywords":["lower","left","ballpoint","stationery","writing","write"],"skins":[{"unified":"1f58a-fe0f","native":"\uD83D\uDD8A\uFE0F"}],"version":1},"lower_left_paintbrush":{"id":"lower_left_paintbrush","name":"Paintbrush","keywords":["lower","left","drawing","creativity","art"],"skins":[{"unified":"1f58c-fe0f","native":"\uD83D\uDD8C\uFE0F"}],"version":1},"lower_left_crayon":{"id":"lower_left_crayon","name":"Crayon","keywords":["lower","left","drawing","creativity"],"skins":[{"unified":"1f58d-fe0f","native":"\uD83D\uDD8D\uFE0F"}],"version":1},"memo":{"id":"memo","name":"Memo","keywords":["pencil","write","documents","stationery","paper","writing","legal","exam","quiz","test","study","compose"],"skins":[{"unified":"1f4dd","native":"\uD83D\uDCDD"}],"version":1},"briefcase":{"id":"briefcase","name":"Briefcase","keywords":["business","documents","work","law","legal","job","career"],"skins":[{"unified":"1f4bc","native":"\uD83D\uDCBC"}],"version":1},"file_folder":{"id":"file_folder","name":"File Folder","keywords":["documents","business","office"],"skins":[{"unified":"1f4c1","native":"\uD83D\uDCC1"}],"version":1},"open_file_folder":{"id":"open_file_folder","name":"Open File Folder","keywords":["documents","load"],"skins":[{"unified":"1f4c2","native":"\uD83D\uDCC2"}],"version":1},"card_index_dividers":{"id":"card_index_dividers","name":"Card Index Dividers","keywords":["organizing","business","stationery"],"skins":[{"unified":"1f5c2-fe0f","native":"\uD83D\uDDC2\uFE0F"}],"version":1},"date":{"id":"date","name":"Calendar","keywords":["date","schedule"],"skins":[{"unified":"1f4c5","native":"\uD83D\uDCC5"}],"version":1},"calendar":{"id":"calendar","name":"Tear-off Calendar","keywords":["tear","off","schedule","date","planning"],"skins":[{"unified":"1f4c6","native":"\uD83D\uDCC6"}],"version":1},"spiral_note_pad":{"id":"spiral_note_pad","name":"Spiral Notepad","keywords":["note","pad","memo","stationery"],"skins":[{"unified":"1f5d2-fe0f","native":"\uD83D\uDDD2\uFE0F"}],"version":1},"spiral_calendar_pad":{"id":"spiral_calendar_pad","name":"Spiral Calendar","keywords":["pad","date","schedule","planning"],"skins":[{"unified":"1f5d3-fe0f","native":"\uD83D\uDDD3\uFE0F"}],"version":1},"card_index":{"id":"card_index","name":"Card Index","keywords":["business","stationery"],"skins":[{"unified":"1f4c7","native":"\uD83D\uDCC7"}],"version":1},"chart_with_upwards_trend":{"id":"chart_with_upwards_trend","name":"Chart Increasing","keywords":["with","upwards","trend","graph","presentation","stats","recovery","business","economics","money","sales","good","success"],"skins":[{"unified":"1f4c8","native":"\uD83D\uDCC8"}],"version":1},"chart_with_downwards_trend":{"id":"chart_with_downwards_trend","name":"Chart Decreasing","keywords":["with","downwards","trend","graph","presentation","stats","recession","business","economics","money","sales","bad","failure"],"skins":[{"unified":"1f4c9","native":"\uD83D\uDCC9"}],"version":1},"bar_chart":{"id":"bar_chart","name":"Bar Chart","keywords":["graph","presentation","stats"],"skins":[{"unified":"1f4ca","native":"\uD83D\uDCCA"}],"version":1},"clipboard":{"id":"clipboard","name":"Clipboard","keywords":["stationery","documents"],"skins":[{"unified":"1f4cb","native":"\uD83D\uDCCB"}],"version":1},"pushpin":{"id":"pushpin","name":"Pushpin","keywords":["stationery","mark","here"],"skins":[{"unified":"1f4cc","native":"\uD83D\uDCCC"}],"version":1},"round_pushpin":{"id":"round_pushpin","name":"Round Pushpin","keywords":["stationery","location","map","here"],"skins":[{"unified":"1f4cd","native":"\uD83D\uDCCD"}],"version":1},"paperclip":{"id":"paperclip","name":"Paperclip","keywords":["documents","stationery"],"skins":[{"unified":"1f4ce","native":"\uD83D\uDCCE"}],"version":1},"linked_paperclips":{"id":"linked_paperclips","name":"Linked Paperclips","keywords":["documents","stationery"],"skins":[{"unified":"1f587-fe0f","native":"\uD83D\uDD87\uFE0F"}],"version":1},"straight_ruler":{"id":"straight_ruler","name":"Straight Ruler","keywords":["stationery","calculate","length","math","school","drawing","architect","sketch"],"skins":[{"unified":"1f4cf","native":"\uD83D\uDCCF"}],"version":1},"triangular_ruler":{"id":"triangular_ruler","name":"Triangular Ruler","keywords":["stationery","math","architect","sketch"],"skins":[{"unified":"1f4d0","native":"\uD83D\uDCD0"}],"version":1},"scissors":{"id":"scissors","name":"Scissors","keywords":["stationery","cut"],"skins":[{"unified":"2702-fe0f","native":"\u2702\uFE0F"}],"version":1},"card_file_box":{"id":"card_file_box","name":"Card File Box","keywords":["business","stationery"],"skins":[{"unified":"1f5c3-fe0f","native":"\uD83D\uDDC3\uFE0F"}],"version":1},"file_cabinet":{"id":"file_cabinet","name":"File Cabinet","keywords":["filing","organizing"],"skins":[{"unified":"1f5c4-fe0f","native":"\uD83D\uDDC4\uFE0F"}],"version":1},"wastebasket":{"id":"wastebasket","name":"Wastebasket","keywords":["bin","trash","rubbish","garbage","toss"],"skins":[{"unified":"1f5d1-fe0f","native":"\uD83D\uDDD1\uFE0F"}],"version":1},"lock":{"id":"lock","name":"Lock","keywords":["locked","security","password","padlock"],"skins":[{"unified":"1f512","native":"\uD83D\uDD12"}],"version":1},"unlock":{"id":"unlock","name":"Unlocked","keywords":["unlock","privacy","security"],"skins":[{"unified":"1f513","native":"\uD83D\uDD13"}],"version":1},"lock_with_ink_pen":{"id":"lock_with_ink_pen","name":"Locked with Pen","keywords":["lock","ink","security","secret"],"skins":[{"unified":"1f50f","native":"\uD83D\uDD0F"}],"version":1},"closed_lock_with_key":{"id":"closed_lock_with_key","name":"Locked with Key","keywords":["closed","lock","security","privacy"],"skins":[{"unified":"1f510","native":"\uD83D\uDD10"}],"version":1},"key":{"id":"key","name":"Key","keywords":["lock","door","password"],"skins":[{"unified":"1f511","native":"\uD83D\uDD11"}],"version":1},"old_key":{"id":"old_key","name":"Old Key","keywords":["lock","door","password"],"skins":[{"unified":"1f5dd-fe0f","native":"\uD83D\uDDDD\uFE0F"}],"version":1},"hammer":{"id":"hammer","name":"Hammer","keywords":["tools","build","create"],"skins":[{"unified":"1f528","native":"\uD83D\uDD28"}],"version":1},"axe":{"id":"axe","name":"Axe","keywords":["tool","chop","cut"],"skins":[{"unified":"1fa93","native":"\uD83E\uDE93"}],"version":12},"pick":{"id":"pick","name":"Pick","keywords":["tools","dig"],"skins":[{"unified":"26cf-fe0f","native":"\u26CF\uFE0F"}],"version":1},"hammer_and_pick":{"id":"hammer_and_pick","name":"Hammer and Pick","keywords":["tools","build","create"],"skins":[{"unified":"2692-fe0f","native":"\u2692\uFE0F"}],"version":1},"hammer_and_wrench":{"id":"hammer_and_wrench","name":"Hammer and Wrench","keywords":["tools","build","create"],"skins":[{"unified":"1f6e0-fe0f","native":"\uD83D\uDEE0\uFE0F"}],"version":1},"dagger_knife":{"id":"dagger_knife","name":"Dagger","keywords":["knife","weapon"],"skins":[{"unified":"1f5e1-fe0f","native":"\uD83D\uDDE1\uFE0F"}],"version":1},"crossed_swords":{"id":"crossed_swords","name":"Crossed Swords","keywords":["weapon"],"skins":[{"unified":"2694-fe0f","native":"\u2694\uFE0F"}],"version":1},"bomb":{"id":"bomb","name":"Bomb","keywords":["boom","explode","explosion","terrorism"],"skins":[{"unified":"1f4a3","native":"\uD83D\uDCA3"}],"version":1},"boomerang":{"id":"boomerang","name":"Boomerang","keywords":["weapon"],"skins":[{"unified":"1fa83","native":"\uD83E\uDE83"}],"version":13},"bow_and_arrow":{"id":"bow_and_arrow","name":"Bow and Arrow","keywords":["sports"],"skins":[{"unified":"1f3f9","native":"\uD83C\uDFF9"}],"version":1},"shield":{"id":"shield","name":"Shield","keywords":["protection","security"],"skins":[{"unified":"1f6e1-fe0f","native":"\uD83D\uDEE1\uFE0F"}],"version":1},"carpentry_saw":{"id":"carpentry_saw","name":"Carpentry Saw","keywords":["cut","chop"],"skins":[{"unified":"1fa9a","native":"\uD83E\uDE9A"}],"version":13},"wrench":{"id":"wrench","name":"Wrench","keywords":["tools","diy","ikea","fix","maintainer"],"skins":[{"unified":"1f527","native":"\uD83D\uDD27"}],"version":1},"screwdriver":{"id":"screwdriver","name":"Screwdriver","keywords":["tools"],"skins":[{"unified":"1fa9b","native":"\uD83E\uDE9B"}],"version":13},"nut_and_bolt":{"id":"nut_and_bolt","name":"Nut and Bolt","keywords":["handy","tools","fix"],"skins":[{"unified":"1f529","native":"\uD83D\uDD29"}],"version":1},"gear":{"id":"gear","name":"Gear","keywords":["cog"],"skins":[{"unified":"2699-fe0f","native":"\u2699\uFE0F"}],"version":1},"compression":{"id":"compression","name":"Clamp","keywords":["compression","tool"],"skins":[{"unified":"1f5dc-fe0f","native":"\uD83D\uDDDC\uFE0F"}],"version":1},"scales":{"id":"scales","name":"Balance Scale","keywords":["scales","law","fairness","weight"],"skins":[{"unified":"2696-fe0f","native":"\u2696\uFE0F"}],"version":1},"probing_cane":{"id":"probing_cane","name":"White Cane","keywords":["probing","accessibility"],"skins":[{"unified":"1f9af","native":"\uD83E\uDDAF"}],"version":12},"link":{"id":"link","name":"Link","keywords":["rings","url"],"skins":[{"unified":"1f517","native":"\uD83D\uDD17"}],"version":1},"chains":{"id":"chains","name":"Chains","keywords":["lock","arrest"],"skins":[{"unified":"26d3-fe0f","native":"\u26D3\uFE0F"}],"version":1},"hook":{"id":"hook","name":"Hook","keywords":["tools"],"skins":[{"unified":"1fa9d","native":"\uD83E\uDE9D"}],"version":13},"toolbox":{"id":"toolbox","name":"Toolbox","keywords":["tools","diy","fix","maintainer","mechanic"],"skins":[{"unified":"1f9f0","native":"\uD83E\uDDF0"}],"version":11},"magnet":{"id":"magnet","name":"Magnet","keywords":["attraction","magnetic"],"skins":[{"unified":"1f9f2","native":"\uD83E\uDDF2"}],"version":11},"ladder":{"id":"ladder","name":"Ladder","keywords":["tools"],"skins":[{"unified":"1fa9c","native":"\uD83E\uDE9C"}],"version":13},"alembic":{"id":"alembic","name":"Alembic","keywords":["distilling","science","experiment","chemistry"],"skins":[{"unified":"2697-fe0f","native":"\u2697\uFE0F"}],"version":1},"test_tube":{"id":"test_tube","name":"Test Tube","keywords":["chemistry","experiment","lab","science"],"skins":[{"unified":"1f9ea","native":"\uD83E\uDDEA"}],"version":11},"petri_dish":{"id":"petri_dish","name":"Petri Dish","keywords":["bacteria","biology","culture","lab"],"skins":[{"unified":"1f9eb","native":"\uD83E\uDDEB"}],"version":11},"dna":{"id":"dna","name":"Dna","keywords":["biologist","genetics","life"],"skins":[{"unified":"1f9ec","native":"\uD83E\uDDEC"}],"version":11},"microscope":{"id":"microscope","name":"Microscope","keywords":["laboratory","experiment","zoomin","science","study"],"skins":[{"unified":"1f52c","native":"\uD83D\uDD2C"}],"version":1},"telescope":{"id":"telescope","name":"Telescope","keywords":["stars","space","zoom","science","astronomy"],"skins":[{"unified":"1f52d","native":"\uD83D\uDD2D"}],"version":1},"satellite_antenna":{"id":"satellite_antenna","name":"Satellite Antenna","keywords":["communication","future","radio","space"],"skins":[{"unified":"1f4e1","native":"\uD83D\uDCE1"}],"version":1},"syringe":{"id":"syringe","name":"Syringe","keywords":["health","hospital","drugs","blood","medicine","needle","doctor","nurse"],"skins":[{"unified":"1f489","native":"\uD83D\uDC89"}],"version":1},"drop_of_blood":{"id":"drop_of_blood","name":"Drop of Blood","keywords":["period","hurt","harm","wound"],"skins":[{"unified":"1fa78","native":"\uD83E\uDE78"}],"version":12},"pill":{"id":"pill","name":"Pill","keywords":["health","medicine","doctor","pharmacy","drug"],"skins":[{"unified":"1f48a","native":"\uD83D\uDC8A"}],"version":1},"adhesive_bandage":{"id":"adhesive_bandage","name":"Adhesive Bandage","keywords":["heal"],"skins":[{"unified":"1fa79","native":"\uD83E\uDE79"}],"version":12},"crutch":{"id":"crutch","name":"Crutch","keywords":["accessibility","assist"],"skins":[{"unified":"1fa7c","native":"\uD83E\uDE7C"}],"version":14},"stethoscope":{"id":"stethoscope","name":"Stethoscope","keywords":["health"],"skins":[{"unified":"1fa7a","native":"\uD83E\uDE7A"}],"version":12},"x-ray":{"id":"x-ray","name":"X-Ray","keywords":["x","ray","skeleton","medicine"],"skins":[{"unified":"1fa7b","native":"\uD83E\uDE7B"}],"version":14},"door":{"id":"door","name":"Door","keywords":["house","entry","exit"],"skins":[{"unified":"1f6aa","native":"\uD83D\uDEAA"}],"version":1},"elevator":{"id":"elevator","name":"Elevator","keywords":["lift"],"skins":[{"unified":"1f6d7","native":"\uD83D\uDED7"}],"version":13},"mirror":{"id":"mirror","name":"Mirror","keywords":["reflection"],"skins":[{"unified":"1fa9e","native":"\uD83E\uDE9E"}],"version":13},"window":{"id":"window","name":"Window","keywords":["scenery"],"skins":[{"unified":"1fa9f","native":"\uD83E\uDE9F"}],"version":13},"bed":{"id":"bed","name":"Bed","keywords":["sleep","rest"],"skins":[{"unified":"1f6cf-fe0f","native":"\uD83D\uDECF\uFE0F"}],"version":1},"couch_and_lamp":{"id":"couch_and_lamp","name":"Couch and Lamp","keywords":["read","chill"],"skins":[{"unified":"1f6cb-fe0f","native":"\uD83D\uDECB\uFE0F"}],"version":1},"chair":{"id":"chair","name":"Chair","keywords":["sit","furniture"],"skins":[{"unified":"1fa91","native":"\uD83E\uDE91"}],"version":12},"toilet":{"id":"toilet","name":"Toilet","keywords":["restroom","wc","washroom","bathroom","potty"],"skins":[{"unified":"1f6bd","native":"\uD83D\uDEBD"}],"version":1},"plunger":{"id":"plunger","name":"Plunger","keywords":["toilet"],"skins":[{"unified":"1faa0","native":"\uD83E\uDEA0"}],"version":13},"shower":{"id":"shower","name":"Shower","keywords":["clean","water","bathroom"],"skins":[{"unified":"1f6bf","native":"\uD83D\uDEBF"}],"version":1},"bathtub":{"id":"bathtub","name":"Bathtub","keywords":["clean","shower","bathroom"],"skins":[{"unified":"1f6c1","native":"\uD83D\uDEC1"}],"version":1},"mouse_trap":{"id":"mouse_trap","name":"Mouse Trap","keywords":["cheese"],"skins":[{"unified":"1faa4","native":"\uD83E\uDEA4"}],"version":13},"razor":{"id":"razor","name":"Razor","keywords":["cut"],"skins":[{"unified":"1fa92","native":"\uD83E\uDE92"}],"version":12},"lotion_bottle":{"id":"lotion_bottle","name":"Lotion Bottle","keywords":["moisturizer","sunscreen"],"skins":[{"unified":"1f9f4","native":"\uD83E\uDDF4"}],"version":11},"safety_pin":{"id":"safety_pin","name":"Safety Pin","keywords":["diaper"],"skins":[{"unified":"1f9f7","native":"\uD83E\uDDF7"}],"version":11},"broom":{"id":"broom","name":"Broom","keywords":["cleaning","sweeping","witch"],"skins":[{"unified":"1f9f9","native":"\uD83E\uDDF9"}],"version":11},"basket":{"id":"basket","name":"Basket","keywords":["laundry"],"skins":[{"unified":"1f9fa","native":"\uD83E\uDDFA"}],"version":11},"roll_of_paper":{"id":"roll_of_paper","name":"Roll of Paper","keywords":[],"skins":[{"unified":"1f9fb","native":"\uD83E\uDDFB"}],"version":11},"bucket":{"id":"bucket","name":"Bucket","keywords":["water","container"],"skins":[{"unified":"1faa3","native":"\uD83E\uDEA3"}],"version":13},"soap":{"id":"soap","name":"Soap","keywords":["bar","bathing","cleaning","lather"],"skins":[{"unified":"1f9fc","native":"\uD83E\uDDFC"}],"version":11},"bubbles":{"id":"bubbles","name":"Bubbles","keywords":["soap","fun","carbonation","sparkling"],"skins":[{"unified":"1fae7","native":"\uD83E\uDEE7"}],"version":14},"toothbrush":{"id":"toothbrush","name":"Toothbrush","keywords":["hygiene","dental"],"skins":[{"unified":"1faa5","native":"\uD83E\uDEA5"}],"version":13},"sponge":{"id":"sponge","name":"Sponge","keywords":["absorbing","cleaning","porous"],"skins":[{"unified":"1f9fd","native":"\uD83E\uDDFD"}],"version":11},"fire_extinguisher":{"id":"fire_extinguisher","name":"Fire Extinguisher","keywords":["quench"],"skins":[{"unified":"1f9ef","native":"\uD83E\uDDEF"}],"version":11},"shopping_trolley":{"id":"shopping_trolley","name":"Shopping Cart","keywords":["trolley"],"skins":[{"unified":"1f6d2","native":"\uD83D\uDED2"}],"version":3},"smoking":{"id":"smoking","name":"Cigarette","keywords":["smoking","kills","tobacco","joint","smoke"],"skins":[{"unified":"1f6ac","native":"\uD83D\uDEAC"}],"version":1},"coffin":{"id":"coffin","name":"Coffin","keywords":["vampire","dead","die","death","rip","graveyard","cemetery","casket","funeral","box"],"skins":[{"unified":"26b0-fe0f","native":"\u26B0\uFE0F"}],"version":1},"headstone":{"id":"headstone","name":"Headstone","keywords":["death","rip","grave"],"skins":[{"unified":"1faa6","native":"\uD83E\uDEA6"}],"version":13},"funeral_urn":{"id":"funeral_urn","name":"Funeral Urn","keywords":["dead","die","death","rip","ashes"],"skins":[{"unified":"26b1-fe0f","native":"\u26B1\uFE0F"}],"version":1},"nazar_amulet":{"id":"nazar_amulet","name":"Nazar Amulet","keywords":["bead","charm"],"skins":[{"unified":"1f9ff","native":"\uD83E\uDDFF"}],"version":11},"hamsa":{"id":"hamsa","name":"Hamsa","keywords":["religion","protection"],"skins":[{"unified":"1faac","native":"\uD83E\uDEAC"}],"version":14},"moyai":{"id":"moyai","name":"Moai","keywords":["moyai","rock","easter","island"],"skins":[{"unified":"1f5ff","native":"\uD83D\uDDFF"}],"version":1},"placard":{"id":"placard","name":"Placard","keywords":["announcement"],"skins":[{"unified":"1faa7","native":"\uD83E\uDEA7"}],"version":13},"identification_card":{"id":"identification_card","name":"Identification Card","keywords":["document"],"skins":[{"unified":"1faaa","native":"\uD83E\uDEAA"}],"version":14},"atm":{"id":"atm","name":"Atm Sign","keywords":["money","sales","cash","blue","square","payment","bank"],"skins":[{"unified":"1f3e7","native":"\uD83C\uDFE7"}],"version":1},"put_litter_in_its_place":{"id":"put_litter_in_its_place","name":"Litter in Bin Sign","keywords":["put","its","place","blue","square","human","info"],"skins":[{"unified":"1f6ae","native":"\uD83D\uDEAE"}],"version":1},"potable_water":{"id":"potable_water","name":"Potable Water","keywords":["blue","square","liquid","restroom","cleaning","faucet"],"skins":[{"unified":"1f6b0","native":"\uD83D\uDEB0"}],"version":1},"wheelchair":{"id":"wheelchair","name":"Wheelchair Symbol","keywords":["blue","square","disabled","accessibility"],"skins":[{"unified":"267f","native":"\u267F"}],"version":1},"mens":{"id":"mens","name":"Men\u2019s Room","keywords":["mens","men","s","toilet","restroom","wc","blue","square","gender","male"],"skins":[{"unified":"1f6b9","native":"\uD83D\uDEB9"}],"version":1},"womens":{"id":"womens","name":"Women\u2019s Room","keywords":["womens","women","s","purple","square","woman","female","toilet","loo","restroom","gender"],"skins":[{"unified":"1f6ba","native":"\uD83D\uDEBA"}],"version":1},"restroom":{"id":"restroom","name":"Restroom","keywords":["blue","square","toilet","refresh","wc","gender"],"skins":[{"unified":"1f6bb","native":"\uD83D\uDEBB"}],"version":1},"baby_symbol":{"id":"baby_symbol","name":"Baby Symbol","keywords":["orange","square","child"],"skins":[{"unified":"1f6bc","native":"\uD83D\uDEBC"}],"version":1},"wc":{"id":"wc","name":"Water Closet","keywords":["wc","toilet","restroom","blue","square"],"skins":[{"unified":"1f6be","native":"\uD83D\uDEBE"}],"version":1},"passport_control":{"id":"passport_control","name":"Passport Control","keywords":["custom","blue","square"],"skins":[{"unified":"1f6c2","native":"\uD83D\uDEC2"}],"version":1},"customs":{"id":"customs","name":"Customs","keywords":["passport","border","blue","square"],"skins":[{"unified":"1f6c3","native":"\uD83D\uDEC3"}],"version":1},"baggage_claim":{"id":"baggage_claim","name":"Baggage Claim","keywords":["blue","square","airport","transport"],"skins":[{"unified":"1f6c4","native":"\uD83D\uDEC4"}],"version":1},"left_luggage":{"id":"left_luggage","name":"Left Luggage","keywords":["blue","square","travel"],"skins":[{"unified":"1f6c5","native":"\uD83D\uDEC5"}],"version":1},"warning":{"id":"warning","name":"Warning","keywords":["exclamation","wip","alert","error","problem","issue"],"skins":[{"unified":"26a0-fe0f","native":"\u26A0\uFE0F"}],"version":1},"children_crossing":{"id":"children_crossing","name":"Children Crossing","keywords":["school","warning","danger","sign","driving","yellow","diamond"],"skins":[{"unified":"1f6b8","native":"\uD83D\uDEB8"}],"version":1},"no_entry":{"id":"no_entry","name":"No Entry","keywords":["limit","security","privacy","bad","denied","stop","circle"],"skins":[{"unified":"26d4","native":"\u26D4"}],"version":1},"no_entry_sign":{"id":"no_entry_sign","name":"Prohibited","keywords":["no","entry","sign","forbid","stop","limit","denied","disallow","circle"],"skins":[{"unified":"1f6ab","native":"\uD83D\uDEAB"}],"version":1},"no_bicycles":{"id":"no_bicycles","name":"No Bicycles","keywords":["cyclist","prohibited","circle"],"skins":[{"unified":"1f6b3","native":"\uD83D\uDEB3"}],"version":1},"no_smoking":{"id":"no_smoking","name":"No Smoking","keywords":["cigarette","blue","square","smell","smoke"],"skins":[{"unified":"1f6ad","native":"\uD83D\uDEAD"}],"version":1},"do_not_litter":{"id":"do_not_litter","name":"No Littering","keywords":["do","not","litter","trash","bin","garbage","circle"],"skins":[{"unified":"1f6af","native":"\uD83D\uDEAF"}],"version":1},"non-potable_water":{"id":"non-potable_water","name":"Non-Potable Water","keywords":["non","potable","drink","faucet","tap","circle"],"skins":[{"unified":"1f6b1","native":"\uD83D\uDEB1"}],"version":1},"no_pedestrians":{"id":"no_pedestrians","name":"No Pedestrians","keywords":["rules","crossing","walking","circle"],"skins":[{"unified":"1f6b7","native":"\uD83D\uDEB7"}],"version":1},"no_mobile_phones":{"id":"no_mobile_phones","name":"No Mobile Phones","keywords":["iphone","mute","circle"],"skins":[{"unified":"1f4f5","native":"\uD83D\uDCF5"}],"version":1},"underage":{"id":"underage","name":"No One Under Eighteen","keywords":["underage","18","drink","pub","night","minor","circle"],"skins":[{"unified":"1f51e","native":"\uD83D\uDD1E"}],"version":1},"radioactive_sign":{"id":"radioactive_sign","name":"Radioactive","keywords":["sign","nuclear","danger"],"skins":[{"unified":"2622-fe0f","native":"\u2622\uFE0F"}],"version":1},"biohazard_sign":{"id":"biohazard_sign","name":"Biohazard","keywords":["sign","danger"],"skins":[{"unified":"2623-fe0f","native":"\u2623\uFE0F"}],"version":1},"arrow_up":{"id":"arrow_up","name":"Up Arrow","keywords":["blue","square","continue","top","direction"],"skins":[{"unified":"2b06-fe0f","native":"\u2B06\uFE0F"}],"version":1},"arrow_upper_right":{"id":"arrow_upper_right","name":"Up-Right Arrow","keywords":["upper","right","up","blue","square","point","direction","diagonal","northeast"],"skins":[{"unified":"2197-fe0f","native":"\u2197\uFE0F"}],"version":1},"arrow_right":{"id":"arrow_right","name":"Right Arrow","keywords":["blue","square","next"],"skins":[{"unified":"27a1-fe0f","native":"\u27A1\uFE0F"}],"version":1},"arrow_lower_right":{"id":"arrow_lower_right","name":"South East Arrow","keywords":["lower","right","down","blue","square","direction","diagonal","southeast"],"skins":[{"unified":"2198-fe0f","native":"\u2198\uFE0F"}],"version":1},"arrow_down":{"id":"arrow_down","name":"Down Arrow","keywords":["blue","square","direction","bottom"],"skins":[{"unified":"2b07-fe0f","native":"\u2B07\uFE0F"}],"version":1},"arrow_lower_left":{"id":"arrow_lower_left","name":"Down-Left Arrow","keywords":["lower","left","down","blue","square","direction","diagonal","southwest"],"skins":[{"unified":"2199-fe0f","native":"\u2199\uFE0F"}],"version":1},"arrow_left":{"id":"arrow_left","name":"Left Arrow","keywords":["blue","square","previous","back"],"skins":[{"unified":"2b05-fe0f","native":"\u2B05\uFE0F"}],"version":1},"arrow_upper_left":{"id":"arrow_upper_left","name":"Up-Left Arrow","keywords":["upper","left","up","blue","square","point","direction","diagonal","northwest"],"skins":[{"unified":"2196-fe0f","native":"\u2196\uFE0F"}],"version":1},"arrow_up_down":{"id":"arrow_up_down","name":"Up Down Arrow","keywords":["blue","square","direction","way","vertical"],"skins":[{"unified":"2195-fe0f","native":"\u2195\uFE0F"}],"version":1},"left_right_arrow":{"id":"left_right_arrow","name":"Left Right Arrow","keywords":["shape","direction","horizontal","sideways"],"skins":[{"unified":"2194-fe0f","native":"\u2194\uFE0F"}],"version":1},"leftwards_arrow_with_hook":{"id":"leftwards_arrow_with_hook","name":"Right Arrow Curving Left","keywords":["leftwards","with","hook","back","return","blue","square","undo","enter"],"skins":[{"unified":"21a9-fe0f","native":"\u21A9\uFE0F"}],"version":1},"arrow_right_hook":{"id":"arrow_right_hook","name":"Left Arrow Curving Right","keywords":["hook","blue","square","return","rotate","direction"],"skins":[{"unified":"21aa-fe0f","native":"\u21AA\uFE0F"}],"version":1},"arrow_heading_up":{"id":"arrow_heading_up","name":"Right Arrow Curving Up","keywords":["heading","blue","square","direction","top"],"skins":[{"unified":"2934-fe0f","native":"\u2934\uFE0F"}],"version":1},"arrow_heading_down":{"id":"arrow_heading_down","name":"Right Arrow Curving Down","keywords":["heading","blue","square","direction","bottom"],"skins":[{"unified":"2935-fe0f","native":"\u2935\uFE0F"}],"version":1},"arrows_clockwise":{"id":"arrows_clockwise","name":"Clockwise Vertical Arrows","keywords":["sync","cycle","round","repeat"],"skins":[{"unified":"1f503","native":"\uD83D\uDD03"}],"version":1},"arrows_counterclockwise":{"id":"arrows_counterclockwise","name":"Counterclockwise Arrows Button","keywords":["blue","square","sync","cycle"],"skins":[{"unified":"1f504","native":"\uD83D\uDD04"}],"version":1},"back":{"id":"back","name":"Back Arrow","keywords":["words","return"],"skins":[{"unified":"1f519","native":"\uD83D\uDD19"}],"version":1},"end":{"id":"end","name":"End Arrow","keywords":["words"],"skins":[{"unified":"1f51a","native":"\uD83D\uDD1A"}],"version":1},"on":{"id":"on","name":"On! Arrow","keywords":["on","words"],"skins":[{"unified":"1f51b","native":"\uD83D\uDD1B"}],"version":1},"soon":{"id":"soon","name":"Soon Arrow","keywords":["words"],"skins":[{"unified":"1f51c","native":"\uD83D\uDD1C"}],"version":1},"top":{"id":"top","name":"Top Arrow","keywords":["words","blue","square"],"skins":[{"unified":"1f51d","native":"\uD83D\uDD1D"}],"version":1},"place_of_worship":{"id":"place_of_worship","name":"Place of Worship","keywords":["religion","church","temple","prayer"],"skins":[{"unified":"1f6d0","native":"\uD83D\uDED0"}],"version":1},"atom_symbol":{"id":"atom_symbol","name":"Atom Symbol","keywords":["science","physics","chemistry"],"skins":[{"unified":"269b-fe0f","native":"\u269B\uFE0F"}],"version":1},"om_symbol":{"id":"om_symbol","name":"Om","keywords":["symbol","hinduism","buddhism","sikhism","jainism"],"skins":[{"unified":"1f549-fe0f","native":"\uD83D\uDD49\uFE0F"}],"version":1},"star_of_david":{"id":"star_of_david","name":"Star of David","keywords":["judaism"],"skins":[{"unified":"2721-fe0f","native":"\u2721\uFE0F"}],"version":1},"wheel_of_dharma":{"id":"wheel_of_dharma","name":"Wheel of Dharma","keywords":["hinduism","buddhism","sikhism","jainism"],"skins":[{"unified":"2638-fe0f","native":"\u2638\uFE0F"}],"version":1},"yin_yang":{"id":"yin_yang","name":"Yin Yang","keywords":["balance"],"skins":[{"unified":"262f-fe0f","native":"\u262F\uFE0F"}],"version":1},"latin_cross":{"id":"latin_cross","name":"Latin Cross","keywords":["christianity"],"skins":[{"unified":"271d-fe0f","native":"\u271D\uFE0F"}],"version":1},"orthodox_cross":{"id":"orthodox_cross","name":"Orthodox Cross","keywords":["suppedaneum","religion"],"skins":[{"unified":"2626-fe0f","native":"\u2626\uFE0F"}],"version":1},"star_and_crescent":{"id":"star_and_crescent","name":"Star and Crescent","keywords":["islam"],"skins":[{"unified":"262a-fe0f","native":"\u262A\uFE0F"}],"version":1},"peace_symbol":{"id":"peace_symbol","name":"Peace Symbol","keywords":["hippie"],"skins":[{"unified":"262e-fe0f","native":"\u262E\uFE0F"}],"version":1},"menorah_with_nine_branches":{"id":"menorah_with_nine_branches","name":"Menorah","keywords":["with","nine","branches","hanukkah","candles","jewish"],"skins":[{"unified":"1f54e","native":"\uD83D\uDD4E"}],"version":1},"six_pointed_star":{"id":"six_pointed_star","name":"Dotted Six-Pointed Star","keywords":["six","pointed","purple","square","religion","jewish","hexagram"],"skins":[{"unified":"1f52f","native":"\uD83D\uDD2F"}],"version":1},"khanda":{"id":"khanda","name":"Khanda","keywords":["Sikhism","religion"],"skins":[{"unified":"1faaf","native":"\uD83E\uDEAF"}],"version":15},"aries":{"id":"aries","name":"Aries","keywords":["sign","purple","square","zodiac","astrology"],"skins":[{"unified":"2648","native":"\u2648"}],"version":1},"taurus":{"id":"taurus","name":"Taurus","keywords":["purple","square","sign","zodiac","astrology"],"skins":[{"unified":"2649","native":"\u2649"}],"version":1},"gemini":{"id":"gemini","name":"Gemini","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"264a","native":"\u264A"}],"version":1},"cancer":{"id":"cancer","name":"Cancer","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"264b","native":"\u264B"}],"version":1},"leo":{"id":"leo","name":"Leo","keywords":["sign","purple","square","zodiac","astrology"],"skins":[{"unified":"264c","native":"\u264C"}],"version":1},"virgo":{"id":"virgo","name":"Virgo","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"264d","native":"\u264D"}],"version":1},"libra":{"id":"libra","name":"Libra","keywords":["sign","purple","square","zodiac","astrology"],"skins":[{"unified":"264e","native":"\u264E"}],"version":1},"scorpius":{"id":"scorpius","name":"Scorpio","keywords":["scorpius","sign","zodiac","purple","square","astrology"],"skins":[{"unified":"264f","native":"\u264F"}],"version":1},"sagittarius":{"id":"sagittarius","name":"Sagittarius","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"2650","native":"\u2650"}],"version":1},"capricorn":{"id":"capricorn","name":"Capricorn","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"2651","native":"\u2651"}],"version":1},"aquarius":{"id":"aquarius","name":"Aquarius","keywords":["sign","purple","square","zodiac","astrology"],"skins":[{"unified":"2652","native":"\u2652"}],"version":1},"pisces":{"id":"pisces","name":"Pisces","keywords":["purple","square","sign","zodiac","astrology"],"skins":[{"unified":"2653","native":"\u2653"}],"version":1},"ophiuchus":{"id":"ophiuchus","name":"Ophiuchus","keywords":["sign","purple","square","constellation","astrology"],"skins":[{"unified":"26ce","native":"\u26CE"}],"version":1},"twisted_rightwards_arrows":{"id":"twisted_rightwards_arrows","name":"Shuffle Tracks Button","keywords":["twisted","rightwards","arrows","blue","square","music","random"],"skins":[{"unified":"1f500","native":"\uD83D\uDD00"}],"version":1},"repeat":{"id":"repeat","name":"Repeat Button","keywords":["loop","record"],"skins":[{"unified":"1f501","native":"\uD83D\uDD01"}],"version":1},"repeat_one":{"id":"repeat_one","name":"Repeat Single Button","keywords":["one","blue","square","loop"],"skins":[{"unified":"1f502","native":"\uD83D\uDD02"}],"version":1},"arrow_forward":{"id":"arrow_forward","name":"Play Button","keywords":["arrow","forward","blue","square","right","direction"],"skins":[{"unified":"25b6-fe0f","native":"\u25B6\uFE0F"}],"version":1},"fast_forward":{"id":"fast_forward","name":"Fast-Forward Button","keywords":["fast","forward","blue","square","play","speed","continue"],"skins":[{"unified":"23e9","native":"\u23E9"}],"version":1},"black_right_pointing_double_triangle_with_vertical_bar":{"id":"black_right_pointing_double_triangle_with_vertical_bar","name":"Next Track Button","keywords":["black","right","pointing","double","triangle","with","vertical","bar","forward","blue","square"],"skins":[{"unified":"23ed-fe0f","native":"\u23ED\uFE0F"}],"version":1},"black_right_pointing_triangle_with_double_vertical_bar":{"id":"black_right_pointing_triangle_with_double_vertical_bar","name":"Play or Pause Button","keywords":["black","right","pointing","triangle","with","double","vertical","bar","blue","square"],"skins":[{"unified":"23ef-fe0f","native":"\u23EF\uFE0F"}],"version":1},"arrow_backward":{"id":"arrow_backward","name":"Reverse Button","keywords":["arrow","backward","blue","square","left","direction"],"skins":[{"unified":"25c0-fe0f","native":"\u25C0\uFE0F"}],"version":1},"rewind":{"id":"rewind","name":"Fast Reverse Button","keywords":["rewind","play","blue","square"],"skins":[{"unified":"23ea","native":"\u23EA"}],"version":1},"black_left_pointing_double_triangle_with_vertical_bar":{"id":"black_left_pointing_double_triangle_with_vertical_bar","name":"Last Track Button","keywords":["black","left","pointing","double","triangle","with","vertical","bar","backward"],"skins":[{"unified":"23ee-fe0f","native":"\u23EE\uFE0F"}],"version":1},"arrow_up_small":{"id":"arrow_up_small","name":"Upwards Button","keywords":["arrow","up","small","blue","square","triangle","direction","point","forward","top"],"skins":[{"unified":"1f53c","native":"\uD83D\uDD3C"}],"version":1},"arrow_double_up":{"id":"arrow_double_up","name":"Fast Up Button","keywords":["arrow","double","blue","square","direction","top"],"skins":[{"unified":"23eb","native":"\u23EB"}],"version":1},"arrow_down_small":{"id":"arrow_down_small","name":"Downwards Button","keywords":["arrow","down","small","blue","square","direction","bottom"],"skins":[{"unified":"1f53d","native":"\uD83D\uDD3D"}],"version":1},"arrow_double_down":{"id":"arrow_double_down","name":"Fast Down Button","keywords":["arrow","double","blue","square","direction","bottom"],"skins":[{"unified":"23ec","native":"\u23EC"}],"version":1},"double_vertical_bar":{"id":"double_vertical_bar","name":"Pause Button","keywords":["double","vertical","bar","blue","square"],"skins":[{"unified":"23f8-fe0f","native":"\u23F8\uFE0F"}],"version":1},"black_square_for_stop":{"id":"black_square_for_stop","name":"Stop Button","keywords":["black","square","for","blue"],"skins":[{"unified":"23f9-fe0f","native":"\u23F9\uFE0F"}],"version":1},"black_circle_for_record":{"id":"black_circle_for_record","name":"Record Button","keywords":["black","circle","for","blue","square"],"skins":[{"unified":"23fa-fe0f","native":"\u23FA\uFE0F"}],"version":1},"eject":{"id":"eject","name":"Eject Button","keywords":["blue","square"],"skins":[{"unified":"23cf-fe0f","native":"\u23CF\uFE0F"}],"version":1},"cinema":{"id":"cinema","name":"Cinema","keywords":["blue","square","record","film","movie","curtain","stage","theater"],"skins":[{"unified":"1f3a6","native":"\uD83C\uDFA6"}],"version":1},"low_brightness":{"id":"low_brightness","name":"Dim Button","keywords":["low","brightness","sun","afternoon","warm","summer"],"skins":[{"unified":"1f505","native":"\uD83D\uDD05"}],"version":1},"high_brightness":{"id":"high_brightness","name":"Bright Button","keywords":["high","brightness","sun","light"],"skins":[{"unified":"1f506","native":"\uD83D\uDD06"}],"version":1},"signal_strength":{"id":"signal_strength","name":"Antenna Bars","keywords":["signal","strength","blue","square","reception","phone","internet","connection","wifi","bluetooth"],"skins":[{"unified":"1f4f6","native":"\uD83D\uDCF6"}],"version":1},"wireless":{"id":"wireless","name":"Wireless","keywords":["wifi","internet","contactless","signal"],"skins":[{"unified":"1f6dc","native":"\uD83D\uDEDC"}],"version":15},"vibration_mode":{"id":"vibration_mode","name":"Vibration Mode","keywords":["orange","square","phone"],"skins":[{"unified":"1f4f3","native":"\uD83D\uDCF3"}],"version":1},"mobile_phone_off":{"id":"mobile_phone_off","name":"Mobile Phone off","keywords":["mute","orange","square","silence","quiet"],"skins":[{"unified":"1f4f4","native":"\uD83D\uDCF4"}],"version":1},"female_sign":{"id":"female_sign","name":"Female Sign","keywords":["woman","women","lady","girl"],"skins":[{"unified":"2640-fe0f","native":"\u2640\uFE0F"}],"version":4},"male_sign":{"id":"male_sign","name":"Male Sign","keywords":["man","boy","men"],"skins":[{"unified":"2642-fe0f","native":"\u2642\uFE0F"}],"version":4},"transgender_symbol":{"id":"transgender_symbol","name":"Transgender Symbol","keywords":["lgbtq"],"skins":[{"unified":"26a7-fe0f","native":"\u26A7\uFE0F"}],"version":13},"heavy_multiplication_x":{"id":"heavy_multiplication_x","name":"Multiply","keywords":["heavy","multiplication","x","sign","math","calculation"],"skins":[{"unified":"2716-fe0f","native":"\u2716\uFE0F"}],"version":1},"heavy_plus_sign":{"id":"heavy_plus_sign","name":"Plus","keywords":["heavy","sign","math","calculation","addition","more","increase"],"skins":[{"unified":"2795","native":"\u2795"}],"version":1},"heavy_minus_sign":{"id":"heavy_minus_sign","name":"Minus","keywords":["heavy","sign","math","calculation","subtract","less"],"skins":[{"unified":"2796","native":"\u2796"}],"version":1},"heavy_division_sign":{"id":"heavy_division_sign","name":"Divide","keywords":["heavy","division","sign","math","calculation"],"skins":[{"unified":"2797","native":"\u2797"}],"version":1},"heavy_equals_sign":{"id":"heavy_equals_sign","name":"Heavy Equals Sign","keywords":["math"],"skins":[{"unified":"1f7f0","native":"\uD83D\uDFF0"}],"version":14},"infinity":{"id":"infinity","name":"Infinity","keywords":["forever"],"skins":[{"unified":"267e-fe0f","native":"\u267E\uFE0F"}],"version":11},"bangbang":{"id":"bangbang","name":"Double Exclamation Mark","keywords":["bangbang","surprise"],"skins":[{"unified":"203c-fe0f","native":"\u203C\uFE0F"}],"version":1},"interrobang":{"id":"interrobang","name":"Exclamation Question Mark","keywords":["interrobang","wat","punctuation","surprise"],"skins":[{"unified":"2049-fe0f","native":"\u2049\uFE0F"}],"version":1},"question":{"id":"question","name":"Red Question Mark","keywords":["doubt","confused"],"skins":[{"unified":"2753","native":"\u2753"}],"version":1},"grey_question":{"id":"grey_question","name":"White Question Mark","keywords":["grey","doubts","gray","huh","confused"],"skins":[{"unified":"2754","native":"\u2754"}],"version":1},"grey_exclamation":{"id":"grey_exclamation","name":"White Exclamation Mark","keywords":["grey","surprise","punctuation","gray","wow","warning"],"skins":[{"unified":"2755","native":"\u2755"}],"version":1},"exclamation":{"id":"exclamation","name":"Red Exclamation Mark","keywords":["heavy","danger","surprise","punctuation","wow","warning"],"skins":[{"unified":"2757","native":"\u2757"}],"version":1},"wavy_dash":{"id":"wavy_dash","name":"Wavy Dash","keywords":["draw","line","moustache","mustache","squiggle","scribble"],"skins":[{"unified":"3030-fe0f","native":"\u3030\uFE0F"}],"version":1},"currency_exchange":{"id":"currency_exchange","name":"Currency Exchange","keywords":["money","sales","dollar","travel"],"skins":[{"unified":"1f4b1","native":"\uD83D\uDCB1"}],"version":1},"heavy_dollar_sign":{"id":"heavy_dollar_sign","name":"Heavy Dollar Sign","keywords":["money","sales","payment","currency","buck"],"skins":[{"unified":"1f4b2","native":"\uD83D\uDCB2"}],"version":1},"medical_symbol":{"id":"medical_symbol","name":"Medical Symbol","keywords":["staff","of","aesculapius","health","hospital"],"skins":[{"unified":"2695-fe0f","native":"\u2695\uFE0F"}],"version":4},"recycle":{"id":"recycle","name":"Recycling Symbol","keywords":["recycle","arrow","environment","garbage","trash"],"skins":[{"unified":"267b-fe0f","native":"\u267B\uFE0F"}],"version":1},"fleur_de_lis":{"id":"fleur_de_lis","name":"Fleur-De-Lis","keywords":["fleur","de","lis","decorative","scout"],"skins":[{"unified":"269c-fe0f","native":"\u269C\uFE0F"}],"version":1},"trident":{"id":"trident","name":"Trident Emblem","keywords":["weapon","spear"],"skins":[{"unified":"1f531","native":"\uD83D\uDD31"}],"version":1},"name_badge":{"id":"name_badge","name":"Name Badge","keywords":["fire","forbid"],"skins":[{"unified":"1f4db","native":"\uD83D\uDCDB"}],"version":1},"beginner":{"id":"beginner","name":"Japanese Symbol for Beginner","keywords":["badge","shield"],"skins":[{"unified":"1f530","native":"\uD83D\uDD30"}],"version":1},"o":{"id":"o","name":"Hollow Red Circle","keywords":["o","round"],"skins":[{"unified":"2b55","native":"\u2B55"}],"version":1},"white_check_mark":{"id":"white_check_mark","name":"Check Mark Button","keywords":["white","green","square","ok","agree","vote","election","answer","tick"],"skins":[{"unified":"2705","native":"\u2705"}],"version":1},"ballot_box_with_check":{"id":"ballot_box_with_check","name":"Check Box with Check","keywords":["ballot","ok","agree","confirm","black","square","vote","election","yes","tick"],"skins":[{"unified":"2611-fe0f","native":"\u2611\uFE0F"}],"version":1},"heavy_check_mark":{"id":"heavy_check_mark","name":"Check Mark","keywords":["heavy","ok","nike","answer","yes","tick"],"skins":[{"unified":"2714-fe0f","native":"\u2714\uFE0F"}],"version":1},"x":{"id":"x","name":"Cross Mark","keywords":["x","no","delete","remove","cancel","red"],"skins":[{"unified":"274c","native":"\u274C"}],"version":1},"negative_squared_cross_mark":{"id":"negative_squared_cross_mark","name":"Cross Mark Button","keywords":["negative","squared","x","green","square","no","deny"],"skins":[{"unified":"274e","native":"\u274E"}],"version":1},"curly_loop":{"id":"curly_loop","name":"Curly Loop","keywords":["scribble","draw","shape","squiggle"],"skins":[{"unified":"27b0","native":"\u27B0"}],"version":1},"loop":{"id":"loop","name":"Double Curly Loop","keywords":["tape","cassette"],"skins":[{"unified":"27bf","native":"\u27BF"}],"version":1},"part_alternation_mark":{"id":"part_alternation_mark","name":"Part Alternation Mark","keywords":["graph","presentation","stats","business","economics","bad"],"skins":[{"unified":"303d-fe0f","native":"\u303D\uFE0F"}],"version":1},"eight_spoked_asterisk":{"id":"eight_spoked_asterisk","name":"Eight Spoked Asterisk","keywords":["star","sparkle","green","square"],"skins":[{"unified":"2733-fe0f","native":"\u2733\uFE0F"}],"version":1},"eight_pointed_black_star":{"id":"eight_pointed_black_star","name":"Eight-Pointed Star","keywords":["eight","pointed","black","orange","square","shape","polygon"],"skins":[{"unified":"2734-fe0f","native":"\u2734\uFE0F"}],"version":1},"sparkle":{"id":"sparkle","name":"Sparkle","keywords":["stars","green","square","awesome","good","fireworks"],"skins":[{"unified":"2747-fe0f","native":"\u2747\uFE0F"}],"version":1},"copyright":{"id":"copyright","name":"Copyright","keywords":["ip","license","circle","law","legal"],"skins":[{"unified":"00a9-fe0f","native":"\xa9\uFE0F"}],"version":1},"registered":{"id":"registered","name":"Registered","keywords":["alphabet","circle"],"skins":[{"unified":"00ae-fe0f","native":"\xae\uFE0F"}],"version":1},"tm":{"id":"tm","name":"Trade Mark","keywords":["tm","trademark","brand","law","legal"],"skins":[{"unified":"2122-fe0f","native":"\u2122\uFE0F"}],"version":1},"hash":{"id":"hash","name":"Hash Key","keywords":["keycap","","symbol","blue","square","twitter"],"skins":[{"unified":"0023-fe0f-20e3","native":"#\uFE0F\u20E3"}],"version":1},"keycap_star":{"id":"keycap_star","name":"Keycap: *","keywords":["keycap","star",""],"skins":[{"unified":"002a-fe0f-20e3","native":"*\uFE0F\u20E3"}],"version":2},"zero":{"id":"zero","name":"Keycap 0","keywords":["zero","numbers","blue","square","null"],"skins":[{"unified":"0030-fe0f-20e3","native":"0\uFE0F\u20E3"}],"version":1},"one":{"id":"one","name":"Keycap 1","keywords":["one","blue","square","numbers"],"skins":[{"unified":"0031-fe0f-20e3","native":"1\uFE0F\u20E3"}],"version":1},"two":{"id":"two","name":"Keycap 2","keywords":["two","numbers","prime","blue","square"],"skins":[{"unified":"0032-fe0f-20e3","native":"2\uFE0F\u20E3"}],"version":1},"three":{"id":"three","name":"Keycap 3","keywords":["three","numbers","prime","blue","square"],"skins":[{"unified":"0033-fe0f-20e3","native":"3\uFE0F\u20E3"}],"version":1},"four":{"id":"four","name":"Keycap 4","keywords":["four","numbers","blue","square"],"skins":[{"unified":"0034-fe0f-20e3","native":"4\uFE0F\u20E3"}],"version":1},"five":{"id":"five","name":"Keycap 5","keywords":["five","numbers","blue","square","prime"],"skins":[{"unified":"0035-fe0f-20e3","native":"5\uFE0F\u20E3"}],"version":1},"six":{"id":"six","name":"Keycap 6","keywords":["six","numbers","blue","square"],"skins":[{"unified":"0036-fe0f-20e3","native":"6\uFE0F\u20E3"}],"version":1},"seven":{"id":"seven","name":"Keycap 7","keywords":["seven","numbers","blue","square","prime"],"skins":[{"unified":"0037-fe0f-20e3","native":"7\uFE0F\u20E3"}],"version":1},"eight":{"id":"eight","name":"Keycap 8","keywords":["eight","blue","square","numbers"],"skins":[{"unified":"0038-fe0f-20e3","native":"8\uFE0F\u20E3"}],"version":1},"nine":{"id":"nine","name":"Keycap 9","keywords":["nine","blue","square","numbers"],"skins":[{"unified":"0039-fe0f-20e3","native":"9\uFE0F\u20E3"}],"version":1},"keycap_ten":{"id":"keycap_ten","name":"Keycap 10","keywords":["ten","numbers","blue","square"],"skins":[{"unified":"1f51f","native":"\uD83D\uDD1F"}],"version":1},"capital_abcd":{"id":"capital_abcd","name":"Input Latin Uppercase","keywords":["capital","abcd","alphabet","words","blue","square"],"skins":[{"unified":"1f520","native":"\uD83D\uDD20"}],"version":1},"abcd":{"id":"abcd","name":"Input Latin Lowercase","keywords":["abcd","blue","square","alphabet"],"skins":[{"unified":"1f521","native":"\uD83D\uDD21"}],"version":1},"symbols":{"id":"symbols","name":"Input Symbols","keywords":["blue","square","music","note","ampersand","percent","glyphs","characters"],"skins":[{"unified":"1f523","native":"\uD83D\uDD23"}],"version":1},"abc":{"id":"abc","name":"Input Latin Letters","keywords":["abc","blue","square","alphabet"],"skins":[{"unified":"1f524","native":"\uD83D\uDD24"}],"version":1},"a":{"id":"a","name":"A Button (blood Type)","keywords":["red","square","alphabet","letter"],"skins":[{"unified":"1f170-fe0f","native":"\uD83C\uDD70\uFE0F"}],"version":1},"ab":{"id":"ab","name":"Negative Squared Ab","keywords":["button","red","square","alphabet"],"skins":[{"unified":"1f18e","native":"\uD83C\uDD8E"}],"version":1},"b":{"id":"b","name":"B Button (blood Type)","keywords":["red","square","alphabet","letter"],"skins":[{"unified":"1f171-fe0f","native":"\uD83C\uDD71\uFE0F"}],"version":1},"cl":{"id":"cl","name":"Cl Button","keywords":["alphabet","words","red","square"],"skins":[{"unified":"1f191","native":"\uD83C\uDD91"}],"version":1},"cool":{"id":"cool","name":"Cool Button","keywords":["words","blue","square"],"skins":[{"unified":"1f192","native":"\uD83C\uDD92"}],"version":1},"free":{"id":"free","name":"Free Button","keywords":["blue","square","words"],"skins":[{"unified":"1f193","native":"\uD83C\uDD93"}],"version":1},"information_source":{"id":"information_source","name":"Information","keywords":["source","blue","square","alphabet","letter"],"skins":[{"unified":"2139-fe0f","native":"\u2139\uFE0F"}],"version":1},"id":{"id":"id","name":"Id Button","keywords":["purple","square","words"],"skins":[{"unified":"1f194","native":"\uD83C\uDD94"}],"version":1},"m":{"id":"m","name":"Circled M","keywords":["alphabet","blue","circle","letter"],"skins":[{"unified":"24c2-fe0f","native":"\u24C2\uFE0F"}],"version":1},"new":{"id":"new","name":"New Button","keywords":["blue","square","words","start"],"skins":[{"unified":"1f195","native":"\uD83C\uDD95"}],"version":1},"ng":{"id":"ng","name":"Ng Button","keywords":["blue","square","words","shape","icon"],"skins":[{"unified":"1f196","native":"\uD83C\uDD96"}],"version":1},"o2":{"id":"o2","name":"O Button (blood Type)","keywords":["o2","alphabet","red","square","letter"],"skins":[{"unified":"1f17e-fe0f","native":"\uD83C\uDD7E\uFE0F"}],"version":1},"ok":{"id":"ok","name":"Ok Button","keywords":["good","agree","yes","blue","square"],"skins":[{"unified":"1f197","native":"\uD83C\uDD97"}],"version":1},"parking":{"id":"parking","name":"P Button","keywords":["parking","cars","blue","square","alphabet","letter"],"skins":[{"unified":"1f17f-fe0f","native":"\uD83C\uDD7F\uFE0F"}],"version":1},"sos":{"id":"sos","name":"Sos Button","keywords":["help","red","square","words","emergency","911"],"skins":[{"unified":"1f198","native":"\uD83C\uDD98"}],"version":1},"up":{"id":"up","name":"Up! Button","keywords":["up","blue","square","above","high"],"skins":[{"unified":"1f199","native":"\uD83C\uDD99"}],"version":1},"vs":{"id":"vs","name":"Vs Button","keywords":["words","orange","square"],"skins":[{"unified":"1f19a","native":"\uD83C\uDD9A"}],"version":1},"koko":{"id":"koko","name":"Squared Katakana Koko","keywords":["japanese","here","button","blue","square","destination"],"skins":[{"unified":"1f201","native":"\uD83C\uDE01"}],"version":1},"sa":{"id":"sa","name":"Squared Katakana Sa","keywords":["japanese","service","charge","button","blue","square"],"skins":[{"unified":"1f202-fe0f","native":"\uD83C\uDE02\uFE0F"}],"version":1},"u6708":{"id":"u6708","name":"Japanese \u201Cmonthly Amount\u201D Button","keywords":["u6708","monthly","amount","chinese","month","moon","orange","square","kanji"],"skins":[{"unified":"1f237-fe0f","native":"\uD83C\uDE37\uFE0F"}],"version":1},"u6709":{"id":"u6709","name":"Squared Cjk Unified Ideograph-6709","keywords":["u6709","japanese","not","free","of","charge","button","orange","square","chinese","have","kanji"],"skins":[{"unified":"1f236","native":"\uD83C\uDE36"}],"version":1},"u6307":{"id":"u6307","name":"Japanese \u201Creserved\u201D Button","keywords":["u6307","reserved","chinese","point","green","square","kanji"],"skins":[{"unified":"1f22f","native":"\uD83C\uDE2F"}],"version":1},"ideograph_advantage":{"id":"ideograph_advantage","name":"Japanese \u201Cbargain\u201D Button","keywords":["ideograph","advantage","bargain","chinese","kanji","obtain","get","circle"],"skins":[{"unified":"1f250","native":"\uD83C\uDE50"}],"version":1},"u5272":{"id":"u5272","name":"Japanese \u201Cdiscount\u201D Button","keywords":["u5272","discount","cut","divide","chinese","kanji","pink","square"],"skins":[{"unified":"1f239","native":"\uD83C\uDE39"}],"version":1},"u7121":{"id":"u7121","name":"Japanese \u201Cfree of Charge\u201D Button","keywords":["u7121","free","charge","nothing","chinese","kanji","orange","square"],"skins":[{"unified":"1f21a","native":"\uD83C\uDE1A"}],"version":1},"u7981":{"id":"u7981","name":"Japanese \u201Cprohibited\u201D Button","keywords":["u7981","prohibited","kanji","chinese","forbidden","limit","restricted","red","square"],"skins":[{"unified":"1f232","native":"\uD83C\uDE32"}],"version":1},"accept":{"id":"accept","name":"Circled Ideograph Accept","keywords":["japanese","acceptable","button","ok","good","chinese","kanji","agree","yes","orange","circle"],"skins":[{"unified":"1f251","native":"\uD83C\uDE51"}],"version":1},"u7533":{"id":"u7533","name":"Japanese \u201Capplication\u201D Button","keywords":["u7533","application","chinese","kanji","orange","square"],"skins":[{"unified":"1f238","native":"\uD83C\uDE38"}],"version":1},"u5408":{"id":"u5408","name":"Japanese \u201Cpassing Grade\u201D Button","keywords":["u5408","passing","grade","chinese","join","kanji","red","square"],"skins":[{"unified":"1f234","native":"\uD83C\uDE34"}],"version":1},"u7a7a":{"id":"u7a7a","name":"Japanese \u201Cvacancy\u201D Button","keywords":["u7a7a","vacancy","kanji","chinese","empty","sky","blue","square"],"skins":[{"unified":"1f233","native":"\uD83C\uDE33"}],"version":1},"congratulations":{"id":"congratulations","name":"Circled Ideograph Congratulation","keywords":["congratulations","japanese","button","chinese","kanji","red","circle"],"skins":[{"unified":"3297-fe0f","native":"\u3297\uFE0F"}],"version":1},"secret":{"id":"secret","name":"Circled Ideograph Secret","keywords":["japanese","button","privacy","chinese","sshh","kanji","red","circle"],"skins":[{"unified":"3299-fe0f","native":"\u3299\uFE0F"}],"version":1},"u55b6":{"id":"u55b6","name":"Squared Cjk Unified Ideograph-55b6","keywords":["u55b6","japanese","open","for","business","button","opening","hours","orange","square"],"skins":[{"unified":"1f23a","native":"\uD83C\uDE3A"}],"version":1},"u6e80":{"id":"u6e80","name":"Japanese \u201Cno Vacancy\u201D Button","keywords":["u6e80","no","vacancy","full","chinese","red","square","kanji"],"skins":[{"unified":"1f235","native":"\uD83C\uDE35"}],"version":1},"red_circle":{"id":"red_circle","name":"Red Circle","keywords":["shape","error","danger"],"skins":[{"unified":"1f534","native":"\uD83D\uDD34"}],"version":1},"large_orange_circle":{"id":"large_orange_circle","name":"Orange Circle","keywords":["large","round"],"skins":[{"unified":"1f7e0","native":"\uD83D\uDFE0"}],"version":12},"large_yellow_circle":{"id":"large_yellow_circle","name":"Yellow Circle","keywords":["large","round"],"skins":[{"unified":"1f7e1","native":"\uD83D\uDFE1"}],"version":12},"large_green_circle":{"id":"large_green_circle","name":"Green Circle","keywords":["large","round"],"skins":[{"unified":"1f7e2","native":"\uD83D\uDFE2"}],"version":12},"large_blue_circle":{"id":"large_blue_circle","name":"Blue Circle","keywords":["large","shape","icon","button"],"skins":[{"unified":"1f535","native":"\uD83D\uDD35"}],"version":1},"large_purple_circle":{"id":"large_purple_circle","name":"Purple Circle","keywords":["large","round"],"skins":[{"unified":"1f7e3","native":"\uD83D\uDFE3"}],"version":12},"large_brown_circle":{"id":"large_brown_circle","name":"Brown Circle","keywords":["large","round"],"skins":[{"unified":"1f7e4","native":"\uD83D\uDFE4"}],"version":12},"black_circle":{"id":"black_circle","name":"Black Circle","keywords":["shape","button","round"],"skins":[{"unified":"26ab","native":"\u26AB"}],"version":1},"white_circle":{"id":"white_circle","name":"White Circle","keywords":["shape","round"],"skins":[{"unified":"26aa","native":"\u26AA"}],"version":1},"large_red_square":{"id":"large_red_square","name":"Red Square","keywords":["large"],"skins":[{"unified":"1f7e5","native":"\uD83D\uDFE5"}],"version":12},"large_orange_square":{"id":"large_orange_square","name":"Orange Square","keywords":["large"],"skins":[{"unified":"1f7e7","native":"\uD83D\uDFE7"}],"version":12},"large_yellow_square":{"id":"large_yellow_square","name":"Yellow Square","keywords":["large"],"skins":[{"unified":"1f7e8","native":"\uD83D\uDFE8"}],"version":12},"large_green_square":{"id":"large_green_square","name":"Green Square","keywords":["large"],"skins":[{"unified":"1f7e9","native":"\uD83D\uDFE9"}],"version":12},"large_blue_square":{"id":"large_blue_square","name":"Blue Square","keywords":["large"],"skins":[{"unified":"1f7e6","native":"\uD83D\uDFE6"}],"version":12},"large_purple_square":{"id":"large_purple_square","name":"Purple Square","keywords":["large"],"skins":[{"unified":"1f7ea","native":"\uD83D\uDFEA"}],"version":12},"large_brown_square":{"id":"large_brown_square","name":"Brown Square","keywords":["large"],"skins":[{"unified":"1f7eb","native":"\uD83D\uDFEB"}],"version":12},"black_large_square":{"id":"black_large_square","name":"Black Large Square","keywords":["shape","icon","button"],"skins":[{"unified":"2b1b","native":"\u2B1B"}],"version":1},"white_large_square":{"id":"white_large_square","name":"White Large Square","keywords":["shape","icon","stone","button"],"skins":[{"unified":"2b1c","native":"\u2B1C"}],"version":1},"black_medium_square":{"id":"black_medium_square","name":"Black Medium Square","keywords":["shape","button","icon"],"skins":[{"unified":"25fc-fe0f","native":"\u25FC\uFE0F"}],"version":1},"white_medium_square":{"id":"white_medium_square","name":"White Medium Square","keywords":["shape","stone","icon"],"skins":[{"unified":"25fb-fe0f","native":"\u25FB\uFE0F"}],"version":1},"black_medium_small_square":{"id":"black_medium_small_square","name":"Black Medium Small Square","keywords":["icon","shape","button"],"skins":[{"unified":"25fe","native":"\u25FE"}],"version":1},"white_medium_small_square":{"id":"white_medium_small_square","name":"White Medium Small Square","keywords":["shape","stone","icon","button"],"skins":[{"unified":"25fd","native":"\u25FD"}],"version":1},"black_small_square":{"id":"black_small_square","name":"Black Small Square","keywords":["shape","icon"],"skins":[{"unified":"25aa-fe0f","native":"\u25AA\uFE0F"}],"version":1},"white_small_square":{"id":"white_small_square","name":"White Small Square","keywords":["shape","icon"],"skins":[{"unified":"25ab-fe0f","native":"\u25AB\uFE0F"}],"version":1},"large_orange_diamond":{"id":"large_orange_diamond","name":"Large Orange Diamond","keywords":["shape","jewel","gem"],"skins":[{"unified":"1f536","native":"\uD83D\uDD36"}],"version":1},"large_blue_diamond":{"id":"large_blue_diamond","name":"Large Blue Diamond","keywords":["shape","jewel","gem"],"skins":[{"unified":"1f537","native":"\uD83D\uDD37"}],"version":1},"small_orange_diamond":{"id":"small_orange_diamond","name":"Small Orange Diamond","keywords":["shape","jewel","gem"],"skins":[{"unified":"1f538","native":"\uD83D\uDD38"}],"version":1},"small_blue_diamond":{"id":"small_blue_diamond","name":"Small Blue Diamond","keywords":["shape","jewel","gem"],"skins":[{"unified":"1f539","native":"\uD83D\uDD39"}],"version":1},"small_red_triangle":{"id":"small_red_triangle","name":"Red Triangle Pointed Up","keywords":["small","shape","direction","top"],"skins":[{"unified":"1f53a","native":"\uD83D\uDD3A"}],"version":1},"small_red_triangle_down":{"id":"small_red_triangle_down","name":"Red Triangle Pointed Down","keywords":["small","shape","direction","bottom"],"skins":[{"unified":"1f53b","native":"\uD83D\uDD3B"}],"version":1},"diamond_shape_with_a_dot_inside":{"id":"diamond_shape_with_a_dot_inside","name":"Diamond with a Dot","keywords":["shape","inside","jewel","blue","gem","crystal","fancy"],"skins":[{"unified":"1f4a0","native":"\uD83D\uDCA0"}],"version":1},"radio_button":{"id":"radio_button","name":"Radio Button","keywords":["input","old","music","circle"],"skins":[{"unified":"1f518","native":"\uD83D\uDD18"}],"version":1},"white_square_button":{"id":"white_square_button","name":"White Square Button","keywords":["shape","input"],"skins":[{"unified":"1f533","native":"\uD83D\uDD33"}],"version":1},"black_square_button":{"id":"black_square_button","name":"Black Square Button","keywords":["shape","input","frame"],"skins":[{"unified":"1f532","native":"\uD83D\uDD32"}],"version":1},"checkered_flag":{"id":"checkered_flag","name":"Chequered Flag","keywords":["checkered","contest","finishline","race","gokart"],"skins":[{"unified":"1f3c1","native":"\uD83C\uDFC1"}],"version":1},"triangular_flag_on_post":{"id":"triangular_flag_on_post","name":"Triangular Flag","keywords":["on","post","mark","milestone","place"],"skins":[{"unified":"1f6a9","native":"\uD83D\uDEA9"}],"version":1},"crossed_flags":{"id":"crossed_flags","name":"Crossed Flags","keywords":["japanese","nation","country","border"],"skins":[{"unified":"1f38c","native":"\uD83C\uDF8C"}],"version":1},"waving_black_flag":{"id":"waving_black_flag","name":"Black Flag","keywords":["waving","pirate"],"skins":[{"unified":"1f3f4","native":"\uD83C\uDFF4"}],"version":1},"waving_white_flag":{"id":"waving_white_flag","name":"White Flag","keywords":["waving","losing","loser","lost","surrender","give","up","fail"],"skins":[{"unified":"1f3f3-fe0f","native":"\uD83C\uDFF3\uFE0F"}],"version":1},"rainbow-flag":{"id":"rainbow-flag","name":"Rainbow Flag","keywords":["pride","gay","lgbt","glbt","queer","homosexual","lesbian","bisexual","transgender"],"skins":[{"unified":"1f3f3-fe0f-200d-1f308","native":"\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08"}],"version":4},"transgender_flag":{"id":"transgender_flag","name":"Transgender Flag","keywords":["lgbtq"],"skins":[{"unified":"1f3f3-fe0f-200d-26a7-fe0f","native":"\uD83C\uDFF3\uFE0F\u200D\u26A7\uFE0F"}],"version":13},"pirate_flag":{"id":"pirate_flag","name":"Pirate Flag","keywords":["skull","crossbones","banner"],"skins":[{"unified":"1f3f4-200d-2620-fe0f","native":"\uD83C\uDFF4\u200D\u2620\uFE0F"}],"version":11},"flag-ac":{"id":"flag-ac","name":"Ascension Island Flag","keywords":["ac"],"skins":[{"unified":"1f1e6-1f1e8","native":"\uD83C\uDDE6\uD83C\uDDE8"}],"version":2},"flag-ad":{"id":"flag-ad","name":"Andorra Flag","keywords":["ad","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1e9","native":"\uD83C\uDDE6\uD83C\uDDE9"}],"version":2},"flag-ae":{"id":"flag-ae","name":"United Arab Emirates Flag","keywords":["ae","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1ea","native":"\uD83C\uDDE6\uD83C\uDDEA"}],"version":2},"flag-af":{"id":"flag-af","name":"Afghanistan Flag","keywords":["af","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1eb","native":"\uD83C\uDDE6\uD83C\uDDEB"}],"version":2},"flag-ag":{"id":"flag-ag","name":"Antigua & Barbuda Flag","keywords":["ag","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1ec","native":"\uD83C\uDDE6\uD83C\uDDEC"}],"version":2},"flag-ai":{"id":"flag-ai","name":"Anguilla Flag","keywords":["ai","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1ee","native":"\uD83C\uDDE6\uD83C\uDDEE"}],"version":2},"flag-al":{"id":"flag-al","name":"Albania Flag","keywords":["al","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f1","native":"\uD83C\uDDE6\uD83C\uDDF1"}],"version":2},"flag-am":{"id":"flag-am","name":"Armenia Flag","keywords":["am","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f2","native":"\uD83C\uDDE6\uD83C\uDDF2"}],"version":2},"flag-ao":{"id":"flag-ao","name":"Angola Flag","keywords":["ao","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f4","native":"\uD83C\uDDE6\uD83C\uDDF4"}],"version":2},"flag-aq":{"id":"flag-aq","name":"Antarctica Flag","keywords":["aq","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f6","native":"\uD83C\uDDE6\uD83C\uDDF6"}],"version":2},"flag-ar":{"id":"flag-ar","name":"Argentina Flag","keywords":["ar","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f7","native":"\uD83C\uDDE6\uD83C\uDDF7"}],"version":2},"flag-as":{"id":"flag-as","name":"American Samoa Flag","keywords":["as","ws","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f8","native":"\uD83C\uDDE6\uD83C\uDDF8"}],"version":2},"flag-at":{"id":"flag-at","name":"Austria Flag","keywords":["at","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f9","native":"\uD83C\uDDE6\uD83C\uDDF9"}],"version":2},"flag-au":{"id":"flag-au","name":"Australia Flag","keywords":["au","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1fa","native":"\uD83C\uDDE6\uD83C\uDDFA"}],"version":2},"flag-aw":{"id":"flag-aw","name":"Aruba Flag","keywords":["aw","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1fc","native":"\uD83C\uDDE6\uD83C\uDDFC"}],"version":2},"flag-ax":{"id":"flag-ax","name":"\xc5land Islands Flag","keywords":["ax","aland","Aland","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1fd","native":"\uD83C\uDDE6\uD83C\uDDFD"}],"version":2},"flag-az":{"id":"flag-az","name":"Azerbaijan Flag","keywords":["az","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1ff","native":"\uD83C\uDDE6\uD83C\uDDFF"}],"version":2},"flag-ba":{"id":"flag-ba","name":"Bosnia & Herzegovina Flag","keywords":["ba","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1e6","native":"\uD83C\uDDE7\uD83C\uDDE6"}],"version":2},"flag-bb":{"id":"flag-bb","name":"Barbados Flag","keywords":["bb","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1e7","native":"\uD83C\uDDE7\uD83C\uDDE7"}],"version":2},"flag-bd":{"id":"flag-bd","name":"Bangladesh Flag","keywords":["bd","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1e9","native":"\uD83C\uDDE7\uD83C\uDDE9"}],"version":2},"flag-be":{"id":"flag-be","name":"Belgium Flag","keywords":["be","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ea","native":"\uD83C\uDDE7\uD83C\uDDEA"}],"version":2},"flag-bf":{"id":"flag-bf","name":"Burkina Faso Flag","keywords":["bf","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1eb","native":"\uD83C\uDDE7\uD83C\uDDEB"}],"version":2},"flag-bg":{"id":"flag-bg","name":"Bulgaria Flag","keywords":["bg","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ec","native":"\uD83C\uDDE7\uD83C\uDDEC"}],"version":2},"flag-bh":{"id":"flag-bh","name":"Bahrain Flag","keywords":["bh","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ed","native":"\uD83C\uDDE7\uD83C\uDDED"}],"version":2},"flag-bi":{"id":"flag-bi","name":"Burundi Flag","keywords":["bi","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ee","native":"\uD83C\uDDE7\uD83C\uDDEE"}],"version":2},"flag-bj":{"id":"flag-bj","name":"Benin Flag","keywords":["bj","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ef","native":"\uD83C\uDDE7\uD83C\uDDEF"}],"version":2},"flag-bl":{"id":"flag-bl","name":"St. Barth\xe9lemy Flag","keywords":["bl","st","barthelemy","saint","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f1","native":"\uD83C\uDDE7\uD83C\uDDF1"}],"version":2},"flag-bm":{"id":"flag-bm","name":"Bermuda Flag","keywords":["bm","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f2","native":"\uD83C\uDDE7\uD83C\uDDF2"}],"version":2},"flag-bn":{"id":"flag-bn","name":"Brunei Flag","keywords":["bn","darussalam","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f3","native":"\uD83C\uDDE7\uD83C\uDDF3"}],"version":2},"flag-bo":{"id":"flag-bo","name":"Bolivia Flag","keywords":["bo","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f4","native":"\uD83C\uDDE7\uD83C\uDDF4"}],"version":2},"flag-bq":{"id":"flag-bq","name":"Caribbean Netherlands Flag","keywords":["bq","bonaire","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f6","native":"\uD83C\uDDE7\uD83C\uDDF6"}],"version":2},"flag-br":{"id":"flag-br","name":"Brazil Flag","keywords":["br","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f7","native":"\uD83C\uDDE7\uD83C\uDDF7"}],"version":2},"flag-bs":{"id":"flag-bs","name":"Bahamas Flag","keywords":["bs","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f8","native":"\uD83C\uDDE7\uD83C\uDDF8"}],"version":2},"flag-bt":{"id":"flag-bt","name":"Bhutan Flag","keywords":["bt","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f9","native":"\uD83C\uDDE7\uD83C\uDDF9"}],"version":2},"flag-bv":{"id":"flag-bv","name":"Bouvet Island Flag","keywords":["bv","norway"],"skins":[{"unified":"1f1e7-1f1fb","native":"\uD83C\uDDE7\uD83C\uDDFB"}],"version":2},"flag-bw":{"id":"flag-bw","name":"Botswana Flag","keywords":["bw","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1fc","native":"\uD83C\uDDE7\uD83C\uDDFC"}],"version":2},"flag-by":{"id":"flag-by","name":"Belarus Flag","keywords":["by","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1fe","native":"\uD83C\uDDE7\uD83C\uDDFE"}],"version":2},"flag-bz":{"id":"flag-bz","name":"Belize Flag","keywords":["bz","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ff","native":"\uD83C\uDDE7\uD83C\uDDFF"}],"version":2},"flag-ca":{"id":"flag-ca","name":"Canada Flag","keywords":["ca","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1e6","native":"\uD83C\uDDE8\uD83C\uDDE6"}],"version":2},"flag-cc":{"id":"flag-cc","name":"Cocos (keeling) Islands Flag","keywords":["cc","keeling","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1e8","native":"\uD83C\uDDE8\uD83C\uDDE8"}],"version":2},"flag-cd":{"id":"flag-cd","name":"Congo - Kinshasa Flag","keywords":["cd","democratic","republic","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1e9","native":"\uD83C\uDDE8\uD83C\uDDE9"}],"version":2},"flag-cf":{"id":"flag-cf","name":"Central African Republic Flag","keywords":["cf","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1eb","native":"\uD83C\uDDE8\uD83C\uDDEB"}],"version":2},"flag-cg":{"id":"flag-cg","name":"Congo - Brazzaville Flag","keywords":["cg","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1ec","native":"\uD83C\uDDE8\uD83C\uDDEC"}],"version":2},"flag-ch":{"id":"flag-ch","name":"Switzerland Flag","keywords":["ch","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1ed","native":"\uD83C\uDDE8\uD83C\uDDED"}],"version":2},"flag-ci":{"id":"flag-ci","name":"C\xf4te D\u2019ivoire Flag","keywords":["ci","cote","d","ivoire","ivory","coast","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1ee","native":"\uD83C\uDDE8\uD83C\uDDEE"}],"version":2},"flag-ck":{"id":"flag-ck","name":"Cook Islands Flag","keywords":["ck","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f0","native":"\uD83C\uDDE8\uD83C\uDDF0"}],"version":2},"flag-cl":{"id":"flag-cl","name":"Chile Flag","keywords":["cl","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f1","native":"\uD83C\uDDE8\uD83C\uDDF1"}],"version":2},"flag-cm":{"id":"flag-cm","name":"Cameroon Flag","keywords":["cm","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f2","native":"\uD83C\uDDE8\uD83C\uDDF2"}],"version":2},"cn":{"id":"cn","name":"China Flag","keywords":["cn","chinese","prc","country","nation","banner"],"skins":[{"unified":"1f1e8-1f1f3","native":"\uD83C\uDDE8\uD83C\uDDF3"}],"version":1},"flag-co":{"id":"flag-co","name":"Colombia Flag","keywords":["co","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f4","native":"\uD83C\uDDE8\uD83C\uDDF4"}],"version":2},"flag-cp":{"id":"flag-cp","name":"Clipperton Island Flag","keywords":["cp"],"skins":[{"unified":"1f1e8-1f1f5","native":"\uD83C\uDDE8\uD83C\uDDF5"}],"version":2},"flag-cr":{"id":"flag-cr","name":"Costa Rica Flag","keywords":["cr","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f7","native":"\uD83C\uDDE8\uD83C\uDDF7"}],"version":2},"flag-cu":{"id":"flag-cu","name":"Cuba Flag","keywords":["cu","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fa","native":"\uD83C\uDDE8\uD83C\uDDFA"}],"version":2},"flag-cv":{"id":"flag-cv","name":"Cape Verde Flag","keywords":["cv","cabo","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fb","native":"\uD83C\uDDE8\uD83C\uDDFB"}],"version":2},"flag-cw":{"id":"flag-cw","name":"Cura\xe7ao Flag","keywords":["cw","curacao","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fc","native":"\uD83C\uDDE8\uD83C\uDDFC"}],"version":2},"flag-cx":{"id":"flag-cx","name":"Christmas Island Flag","keywords":["cx","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fd","native":"\uD83C\uDDE8\uD83C\uDDFD"}],"version":2},"flag-cy":{"id":"flag-cy","name":"Cyprus Flag","keywords":["cy","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fe","native":"\uD83C\uDDE8\uD83C\uDDFE"}],"version":2},"flag-cz":{"id":"flag-cz","name":"Czechia Flag","keywords":["cz","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1ff","native":"\uD83C\uDDE8\uD83C\uDDFF"}],"version":2},"de":{"id":"de","name":"Germany Flag","keywords":["de","german","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1ea","native":"\uD83C\uDDE9\uD83C\uDDEA"}],"version":1},"flag-dg":{"id":"flag-dg","name":"Diego Garcia Flag","keywords":["dg"],"skins":[{"unified":"1f1e9-1f1ec","native":"\uD83C\uDDE9\uD83C\uDDEC"}],"version":2},"flag-dj":{"id":"flag-dj","name":"Djibouti Flag","keywords":["dj","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1ef","native":"\uD83C\uDDE9\uD83C\uDDEF"}],"version":2},"flag-dk":{"id":"flag-dk","name":"Denmark Flag","keywords":["dk","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1f0","native":"\uD83C\uDDE9\uD83C\uDDF0"}],"version":2},"flag-dm":{"id":"flag-dm","name":"Dominica Flag","keywords":["dm","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1f2","native":"\uD83C\uDDE9\uD83C\uDDF2"}],"version":2},"flag-do":{"id":"flag-do","name":"Dominican Republic Flag","keywords":["do","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1f4","native":"\uD83C\uDDE9\uD83C\uDDF4"}],"version":2},"flag-dz":{"id":"flag-dz","name":"Algeria Flag","keywords":["dz","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1ff","native":"\uD83C\uDDE9\uD83C\uDDFF"}],"version":2},"flag-ea":{"id":"flag-ea","name":"Ceuta & Melilla Flag","keywords":["ea"],"skins":[{"unified":"1f1ea-1f1e6","native":"\uD83C\uDDEA\uD83C\uDDE6"}],"version":2},"flag-ec":{"id":"flag-ec","name":"Ecuador Flag","keywords":["ec","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1e8","native":"\uD83C\uDDEA\uD83C\uDDE8"}],"version":2},"flag-ee":{"id":"flag-ee","name":"Estonia Flag","keywords":["ee","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1ea","native":"\uD83C\uDDEA\uD83C\uDDEA"}],"version":2},"flag-eg":{"id":"flag-eg","name":"Egypt Flag","keywords":["eg","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1ec","native":"\uD83C\uDDEA\uD83C\uDDEC"}],"version":2},"flag-eh":{"id":"flag-eh","name":"Western Sahara Flag","keywords":["eh","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1ed","native":"\uD83C\uDDEA\uD83C\uDDED"}],"version":2},"flag-er":{"id":"flag-er","name":"Eritrea Flag","keywords":["er","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1f7","native":"\uD83C\uDDEA\uD83C\uDDF7"}],"version":2},"es":{"id":"es","name":"Spain Flag","keywords":["es","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1f8","native":"\uD83C\uDDEA\uD83C\uDDF8"}],"version":1},"flag-et":{"id":"flag-et","name":"Ethiopia Flag","keywords":["et","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1f9","native":"\uD83C\uDDEA\uD83C\uDDF9"}],"version":2},"flag-eu":{"id":"flag-eu","name":"European Union Flag","keywords":["eu","banner"],"skins":[{"unified":"1f1ea-1f1fa","native":"\uD83C\uDDEA\uD83C\uDDFA"}],"version":2},"flag-fi":{"id":"flag-fi","name":"Finland Flag","keywords":["fi","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1ee","native":"\uD83C\uDDEB\uD83C\uDDEE"}],"version":2},"flag-fj":{"id":"flag-fj","name":"Fiji Flag","keywords":["fj","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1ef","native":"\uD83C\uDDEB\uD83C\uDDEF"}],"version":2},"flag-fk":{"id":"flag-fk","name":"Falkland Islands Flag","keywords":["fk","malvinas","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1f0","native":"\uD83C\uDDEB\uD83C\uDDF0"}],"version":2},"flag-fm":{"id":"flag-fm","name":"Micronesia Flag","keywords":["fm","federated","states","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1f2","native":"\uD83C\uDDEB\uD83C\uDDF2"}],"version":2},"flag-fo":{"id":"flag-fo","name":"Faroe Islands Flag","keywords":["fo","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1f4","native":"\uD83C\uDDEB\uD83C\uDDF4"}],"version":2},"fr":{"id":"fr","name":"France Flag","keywords":["fr","banner","nation","french","country"],"skins":[{"unified":"1f1eb-1f1f7","native":"\uD83C\uDDEB\uD83C\uDDF7"}],"version":1},"flag-ga":{"id":"flag-ga","name":"Gabon Flag","keywords":["ga","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1e6","native":"\uD83C\uDDEC\uD83C\uDDE6"}],"version":2},"gb":{"id":"gb","name":"United Kingdom Flag","keywords":["gb","uk","great","britain","northern","ireland","nation","country","banner","british","UK","english","england","union","jack"],"skins":[{"unified":"1f1ec-1f1e7","native":"\uD83C\uDDEC\uD83C\uDDE7"}],"version":1},"flag-gd":{"id":"flag-gd","name":"Grenada Flag","keywords":["gd","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1e9","native":"\uD83C\uDDEC\uD83C\uDDE9"}],"version":2},"flag-ge":{"id":"flag-ge","name":"Georgia Flag","keywords":["ge","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1ea","native":"\uD83C\uDDEC\uD83C\uDDEA"}],"version":2},"flag-gf":{"id":"flag-gf","name":"French Guiana Flag","keywords":["gf","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1eb","native":"\uD83C\uDDEC\uD83C\uDDEB"}],"version":2},"flag-gg":{"id":"flag-gg","name":"Guernsey Flag","keywords":["gg","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1ec","native":"\uD83C\uDDEC\uD83C\uDDEC"}],"version":2},"flag-gh":{"id":"flag-gh","name":"Ghana Flag","keywords":["gh","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1ed","native":"\uD83C\uDDEC\uD83C\uDDED"}],"version":2},"flag-gi":{"id":"flag-gi","name":"Gibraltar Flag","keywords":["gi","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1ee","native":"\uD83C\uDDEC\uD83C\uDDEE"}],"version":2},"flag-gl":{"id":"flag-gl","name":"Greenland Flag","keywords":["gl","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f1","native":"\uD83C\uDDEC\uD83C\uDDF1"}],"version":2},"flag-gm":{"id":"flag-gm","name":"Gambia Flag","keywords":["gm","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f2","native":"\uD83C\uDDEC\uD83C\uDDF2"}],"version":2},"flag-gn":{"id":"flag-gn","name":"Guinea Flag","keywords":["gn","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f3","native":"\uD83C\uDDEC\uD83C\uDDF3"}],"version":2},"flag-gp":{"id":"flag-gp","name":"Guadeloupe Flag","keywords":["gp","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f5","native":"\uD83C\uDDEC\uD83C\uDDF5"}],"version":2},"flag-gq":{"id":"flag-gq","name":"Equatorial Guinea Flag","keywords":["gq","gn","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f6","native":"\uD83C\uDDEC\uD83C\uDDF6"}],"version":2},"flag-gr":{"id":"flag-gr","name":"Greece Flag","keywords":["gr","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f7","native":"\uD83C\uDDEC\uD83C\uDDF7"}],"version":2},"flag-gs":{"id":"flag-gs","name":"South Georgia & South Sandwich Islands Flag","keywords":["gs","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f8","native":"\uD83C\uDDEC\uD83C\uDDF8"}],"version":2},"flag-gt":{"id":"flag-gt","name":"Guatemala Flag","keywords":["gt","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f9","native":"\uD83C\uDDEC\uD83C\uDDF9"}],"version":2},"flag-gu":{"id":"flag-gu","name":"Guam Flag","keywords":["gu","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1fa","native":"\uD83C\uDDEC\uD83C\uDDFA"}],"version":2},"flag-gw":{"id":"flag-gw","name":"Guinea-Bissau Flag","keywords":["gw","guinea","bissau","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1fc","native":"\uD83C\uDDEC\uD83C\uDDFC"}],"version":2},"flag-gy":{"id":"flag-gy","name":"Guyana Flag","keywords":["gy","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1fe","native":"\uD83C\uDDEC\uD83C\uDDFE"}],"version":2},"flag-hk":{"id":"flag-hk","name":"Hong Kong Sar China Flag","keywords":["hk","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1f0","native":"\uD83C\uDDED\uD83C\uDDF0"}],"version":2},"flag-hm":{"id":"flag-hm","name":"Heard & Mcdonald Islands Flag","keywords":["hm"],"skins":[{"unified":"1f1ed-1f1f2","native":"\uD83C\uDDED\uD83C\uDDF2"}],"version":2},"flag-hn":{"id":"flag-hn","name":"Honduras Flag","keywords":["hn","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1f3","native":"\uD83C\uDDED\uD83C\uDDF3"}],"version":2},"flag-hr":{"id":"flag-hr","name":"Croatia Flag","keywords":["hr","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1f7","native":"\uD83C\uDDED\uD83C\uDDF7"}],"version":2},"flag-ht":{"id":"flag-ht","name":"Haiti Flag","keywords":["ht","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1f9","native":"\uD83C\uDDED\uD83C\uDDF9"}],"version":2},"flag-hu":{"id":"flag-hu","name":"Hungary Flag","keywords":["hu","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1fa","native":"\uD83C\uDDED\uD83C\uDDFA"}],"version":2},"flag-ic":{"id":"flag-ic","name":"Canary Islands Flag","keywords":["ic","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1e8","native":"\uD83C\uDDEE\uD83C\uDDE8"}],"version":2},"flag-id":{"id":"flag-id","name":"Indonesia Flag","keywords":["id","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1e9","native":"\uD83C\uDDEE\uD83C\uDDE9"}],"version":2},"flag-ie":{"id":"flag-ie","name":"Ireland Flag","keywords":["ie","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1ea","native":"\uD83C\uDDEE\uD83C\uDDEA"}],"version":2},"flag-il":{"id":"flag-il","name":"Israel Flag","keywords":["il","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f1","native":"\uD83C\uDDEE\uD83C\uDDF1"}],"version":2},"flag-im":{"id":"flag-im","name":"Isle of Man Flag","keywords":["im","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f2","native":"\uD83C\uDDEE\uD83C\uDDF2"}],"version":2},"flag-in":{"id":"flag-in","name":"India Flag","keywords":["in","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f3","native":"\uD83C\uDDEE\uD83C\uDDF3"}],"version":2},"flag-io":{"id":"flag-io","name":"British Indian Ocean Territory Flag","keywords":["io","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f4","native":"\uD83C\uDDEE\uD83C\uDDF4"}],"version":2},"flag-iq":{"id":"flag-iq","name":"Iraq Flag","keywords":["iq","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f6","native":"\uD83C\uDDEE\uD83C\uDDF6"}],"version":2},"flag-ir":{"id":"flag-ir","name":"Iran Flag","keywords":["ir","islamic","republic","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f7","native":"\uD83C\uDDEE\uD83C\uDDF7"}],"version":2},"flag-is":{"id":"flag-is","name":"Iceland Flag","keywords":["is","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f8","native":"\uD83C\uDDEE\uD83C\uDDF8"}],"version":2},"it":{"id":"it","name":"Italy Flag","keywords":["it","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f9","native":"\uD83C\uDDEE\uD83C\uDDF9"}],"version":1},"flag-je":{"id":"flag-je","name":"Jersey Flag","keywords":["je","nation","country","banner"],"skins":[{"unified":"1f1ef-1f1ea","native":"\uD83C\uDDEF\uD83C\uDDEA"}],"version":2},"flag-jm":{"id":"flag-jm","name":"Jamaica Flag","keywords":["jm","nation","country","banner"],"skins":[{"unified":"1f1ef-1f1f2","native":"\uD83C\uDDEF\uD83C\uDDF2"}],"version":2},"flag-jo":{"id":"flag-jo","name":"Jordan Flag","keywords":["jo","nation","country","banner"],"skins":[{"unified":"1f1ef-1f1f4","native":"\uD83C\uDDEF\uD83C\uDDF4"}],"version":2},"jp":{"id":"jp","name":"Japan Flag","keywords":["jp","japanese","nation","country","banner","ja"],"skins":[{"unified":"1f1ef-1f1f5","native":"\uD83C\uDDEF\uD83C\uDDF5"}],"version":1},"flag-ke":{"id":"flag-ke","name":"Kenya Flag","keywords":["ke","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ea","native":"\uD83C\uDDF0\uD83C\uDDEA"}],"version":2},"flag-kg":{"id":"flag-kg","name":"Kyrgyzstan Flag","keywords":["kg","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ec","native":"\uD83C\uDDF0\uD83C\uDDEC"}],"version":2},"flag-kh":{"id":"flag-kh","name":"Cambodia Flag","keywords":["kh","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ed","native":"\uD83C\uDDF0\uD83C\uDDED"}],"version":2},"flag-ki":{"id":"flag-ki","name":"Kiribati Flag","keywords":["ki","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ee","native":"\uD83C\uDDF0\uD83C\uDDEE"}],"version":2},"flag-km":{"id":"flag-km","name":"Comoros Flag","keywords":["km","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1f2","native":"\uD83C\uDDF0\uD83C\uDDF2"}],"version":2},"flag-kn":{"id":"flag-kn","name":"St. Kitts & Nevis Flag","keywords":["kn","st","saint","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1f3","native":"\uD83C\uDDF0\uD83C\uDDF3"}],"version":2},"flag-kp":{"id":"flag-kp","name":"North Korea Flag","keywords":["kp","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1f5","native":"\uD83C\uDDF0\uD83C\uDDF5"}],"version":2},"kr":{"id":"kr","name":"South Korea Flag","keywords":["kr","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1f7","native":"\uD83C\uDDF0\uD83C\uDDF7"}],"version":1},"flag-kw":{"id":"flag-kw","name":"Kuwait Flag","keywords":["kw","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1fc","native":"\uD83C\uDDF0\uD83C\uDDFC"}],"version":2},"flag-ky":{"id":"flag-ky","name":"Cayman Islands Flag","keywords":["ky","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1fe","native":"\uD83C\uDDF0\uD83C\uDDFE"}],"version":2},"flag-kz":{"id":"flag-kz","name":"Kazakhstan Flag","keywords":["kz","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ff","native":"\uD83C\uDDF0\uD83C\uDDFF"}],"version":2},"flag-la":{"id":"flag-la","name":"Laos Flag","keywords":["la","lao","democratic","republic","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1e6","native":"\uD83C\uDDF1\uD83C\uDDE6"}],"version":2},"flag-lb":{"id":"flag-lb","name":"Lebanon Flag","keywords":["lb","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1e7","native":"\uD83C\uDDF1\uD83C\uDDE7"}],"version":2},"flag-lc":{"id":"flag-lc","name":"St. Lucia Flag","keywords":["lc","st","saint","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1e8","native":"\uD83C\uDDF1\uD83C\uDDE8"}],"version":2},"flag-li":{"id":"flag-li","name":"Liechtenstein Flag","keywords":["li","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1ee","native":"\uD83C\uDDF1\uD83C\uDDEE"}],"version":2},"flag-lk":{"id":"flag-lk","name":"Sri Lanka Flag","keywords":["lk","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1f0","native":"\uD83C\uDDF1\uD83C\uDDF0"}],"version":2},"flag-lr":{"id":"flag-lr","name":"Liberia Flag","keywords":["lr","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1f7","native":"\uD83C\uDDF1\uD83C\uDDF7"}],"version":2},"flag-ls":{"id":"flag-ls","name":"Lesotho Flag","keywords":["ls","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1f8","native":"\uD83C\uDDF1\uD83C\uDDF8"}],"version":2},"flag-lt":{"id":"flag-lt","name":"Lithuania Flag","keywords":["lt","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1f9","native":"\uD83C\uDDF1\uD83C\uDDF9"}],"version":2},"flag-lu":{"id":"flag-lu","name":"Luxembourg Flag","keywords":["lu","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1fa","native":"\uD83C\uDDF1\uD83C\uDDFA"}],"version":2},"flag-lv":{"id":"flag-lv","name":"Latvia Flag","keywords":["lv","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1fb","native":"\uD83C\uDDF1\uD83C\uDDFB"}],"version":2},"flag-ly":{"id":"flag-ly","name":"Libya Flag","keywords":["ly","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1fe","native":"\uD83C\uDDF1\uD83C\uDDFE"}],"version":2},"flag-ma":{"id":"flag-ma","name":"Morocco Flag","keywords":["ma","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1e6","native":"\uD83C\uDDF2\uD83C\uDDE6"}],"version":2},"flag-mc":{"id":"flag-mc","name":"Monaco Flag","keywords":["mc","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1e8","native":"\uD83C\uDDF2\uD83C\uDDE8"}],"version":2},"flag-md":{"id":"flag-md","name":"Moldova Flag","keywords":["md","republic","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1e9","native":"\uD83C\uDDF2\uD83C\uDDE9"}],"version":2},"flag-me":{"id":"flag-me","name":"Montenegro Flag","keywords":["me","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1ea","native":"\uD83C\uDDF2\uD83C\uDDEA"}],"version":2},"flag-mf":{"id":"flag-mf","name":"St. Martin Flag","keywords":["mf","st"],"skins":[{"unified":"1f1f2-1f1eb","native":"\uD83C\uDDF2\uD83C\uDDEB"}],"version":2},"flag-mg":{"id":"flag-mg","name":"Madagascar Flag","keywords":["mg","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1ec","native":"\uD83C\uDDF2\uD83C\uDDEC"}],"version":2},"flag-mh":{"id":"flag-mh","name":"Marshall Islands Flag","keywords":["mh","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1ed","native":"\uD83C\uDDF2\uD83C\uDDED"}],"version":2},"flag-mk":{"id":"flag-mk","name":"North Macedonia Flag","keywords":["mk","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f0","native":"\uD83C\uDDF2\uD83C\uDDF0"}],"version":2},"flag-ml":{"id":"flag-ml","name":"Mali Flag","keywords":["ml","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f1","native":"\uD83C\uDDF2\uD83C\uDDF1"}],"version":2},"flag-mm":{"id":"flag-mm","name":"Myanmar (burma) Flag","keywords":["mm","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f2","native":"\uD83C\uDDF2\uD83C\uDDF2"}],"version":2},"flag-mn":{"id":"flag-mn","name":"Mongolia Flag","keywords":["mn","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f3","native":"\uD83C\uDDF2\uD83C\uDDF3"}],"version":2},"flag-mo":{"id":"flag-mo","name":"Macao Sar China Flag","keywords":["mo","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f4","native":"\uD83C\uDDF2\uD83C\uDDF4"}],"version":2},"flag-mp":{"id":"flag-mp","name":"Northern Mariana Islands Flag","keywords":["mp","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f5","native":"\uD83C\uDDF2\uD83C\uDDF5"}],"version":2},"flag-mq":{"id":"flag-mq","name":"Martinique Flag","keywords":["mq","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f6","native":"\uD83C\uDDF2\uD83C\uDDF6"}],"version":2},"flag-mr":{"id":"flag-mr","name":"Mauritania Flag","keywords":["mr","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f7","native":"\uD83C\uDDF2\uD83C\uDDF7"}],"version":2},"flag-ms":{"id":"flag-ms","name":"Montserrat Flag","keywords":["ms","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f8","native":"\uD83C\uDDF2\uD83C\uDDF8"}],"version":2},"flag-mt":{"id":"flag-mt","name":"Malta Flag","keywords":["mt","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f9","native":"\uD83C\uDDF2\uD83C\uDDF9"}],"version":2},"flag-mu":{"id":"flag-mu","name":"Mauritius Flag","keywords":["mu","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fa","native":"\uD83C\uDDF2\uD83C\uDDFA"}],"version":2},"flag-mv":{"id":"flag-mv","name":"Maldives Flag","keywords":["mv","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fb","native":"\uD83C\uDDF2\uD83C\uDDFB"}],"version":2},"flag-mw":{"id":"flag-mw","name":"Malawi Flag","keywords":["mw","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fc","native":"\uD83C\uDDF2\uD83C\uDDFC"}],"version":2},"flag-mx":{"id":"flag-mx","name":"Mexico Flag","keywords":["mx","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fd","native":"\uD83C\uDDF2\uD83C\uDDFD"}],"version":2},"flag-my":{"id":"flag-my","name":"Malaysia Flag","keywords":["my","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fe","native":"\uD83C\uDDF2\uD83C\uDDFE"}],"version":2},"flag-mz":{"id":"flag-mz","name":"Mozambique Flag","keywords":["mz","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1ff","native":"\uD83C\uDDF2\uD83C\uDDFF"}],"version":2},"flag-na":{"id":"flag-na","name":"Namibia Flag","keywords":["na","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1e6","native":"\uD83C\uDDF3\uD83C\uDDE6"}],"version":2},"flag-nc":{"id":"flag-nc","name":"New Caledonia Flag","keywords":["nc","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1e8","native":"\uD83C\uDDF3\uD83C\uDDE8"}],"version":2},"flag-ne":{"id":"flag-ne","name":"Niger Flag","keywords":["ne","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1ea","native":"\uD83C\uDDF3\uD83C\uDDEA"}],"version":2},"flag-nf":{"id":"flag-nf","name":"Norfolk Island Flag","keywords":["nf","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1eb","native":"\uD83C\uDDF3\uD83C\uDDEB"}],"version":2},"flag-ng":{"id":"flag-ng","name":"Nigeria Flag","keywords":["ng","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1ec","native":"\uD83C\uDDF3\uD83C\uDDEC"}],"version":2},"flag-ni":{"id":"flag-ni","name":"Nicaragua Flag","keywords":["ni","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1ee","native":"\uD83C\uDDF3\uD83C\uDDEE"}],"version":2},"flag-nl":{"id":"flag-nl","name":"Netherlands Flag","keywords":["nl","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1f1","native":"\uD83C\uDDF3\uD83C\uDDF1"}],"version":2},"flag-no":{"id":"flag-no","name":"Norway Flag","keywords":["no","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1f4","native":"\uD83C\uDDF3\uD83C\uDDF4"}],"version":2},"flag-np":{"id":"flag-np","name":"Nepal Flag","keywords":["np","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1f5","native":"\uD83C\uDDF3\uD83C\uDDF5"}],"version":2},"flag-nr":{"id":"flag-nr","name":"Nauru Flag","keywords":["nr","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1f7","native":"\uD83C\uDDF3\uD83C\uDDF7"}],"version":2},"flag-nu":{"id":"flag-nu","name":"Niue Flag","keywords":["nu","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1fa","native":"\uD83C\uDDF3\uD83C\uDDFA"}],"version":2},"flag-nz":{"id":"flag-nz","name":"New Zealand Flag","keywords":["nz","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1ff","native":"\uD83C\uDDF3\uD83C\uDDFF"}],"version":2},"flag-om":{"id":"flag-om","name":"Oman Flag","keywords":["om","symbol","nation","country","banner"],"skins":[{"unified":"1f1f4-1f1f2","native":"\uD83C\uDDF4\uD83C\uDDF2"}],"version":2},"flag-pa":{"id":"flag-pa","name":"Panama Flag","keywords":["pa","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1e6","native":"\uD83C\uDDF5\uD83C\uDDE6"}],"version":2},"flag-pe":{"id":"flag-pe","name":"Peru Flag","keywords":["pe","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1ea","native":"\uD83C\uDDF5\uD83C\uDDEA"}],"version":2},"flag-pf":{"id":"flag-pf","name":"French Polynesia Flag","keywords":["pf","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1eb","native":"\uD83C\uDDF5\uD83C\uDDEB"}],"version":2},"flag-pg":{"id":"flag-pg","name":"Papua New Guinea Flag","keywords":["pg","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1ec","native":"\uD83C\uDDF5\uD83C\uDDEC"}],"version":2},"flag-ph":{"id":"flag-ph","name":"Philippines Flag","keywords":["ph","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1ed","native":"\uD83C\uDDF5\uD83C\uDDED"}],"version":2},"flag-pk":{"id":"flag-pk","name":"Pakistan Flag","keywords":["pk","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f0","native":"\uD83C\uDDF5\uD83C\uDDF0"}],"version":2},"flag-pl":{"id":"flag-pl","name":"Poland Flag","keywords":["pl","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f1","native":"\uD83C\uDDF5\uD83C\uDDF1"}],"version":2},"flag-pm":{"id":"flag-pm","name":"St. Pierre & Miquelon Flag","keywords":["pm","st","saint","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f2","native":"\uD83C\uDDF5\uD83C\uDDF2"}],"version":2},"flag-pn":{"id":"flag-pn","name":"Pitcairn Islands Flag","keywords":["pn","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f3","native":"\uD83C\uDDF5\uD83C\uDDF3"}],"version":2},"flag-pr":{"id":"flag-pr","name":"Puerto Rico Flag","keywords":["pr","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f7","native":"\uD83C\uDDF5\uD83C\uDDF7"}],"version":2},"flag-ps":{"id":"flag-ps","name":"Palestinian Territories Flag","keywords":["ps","palestine","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f8","native":"\uD83C\uDDF5\uD83C\uDDF8"}],"version":2},"flag-pt":{"id":"flag-pt","name":"Portugal Flag","keywords":["pt","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f9","native":"\uD83C\uDDF5\uD83C\uDDF9"}],"version":2},"flag-pw":{"id":"flag-pw","name":"Palau Flag","keywords":["pw","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1fc","native":"\uD83C\uDDF5\uD83C\uDDFC"}],"version":2},"flag-py":{"id":"flag-py","name":"Paraguay Flag","keywords":["py","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1fe","native":"\uD83C\uDDF5\uD83C\uDDFE"}],"version":2},"flag-qa":{"id":"flag-qa","name":"Qatar Flag","keywords":["qa","nation","country","banner"],"skins":[{"unified":"1f1f6-1f1e6","native":"\uD83C\uDDF6\uD83C\uDDE6"}],"version":2},"flag-re":{"id":"flag-re","name":"R\xe9union Flag","keywords":["re","reunion","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1ea","native":"\uD83C\uDDF7\uD83C\uDDEA"}],"version":2},"flag-ro":{"id":"flag-ro","name":"Romania Flag","keywords":["ro","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1f4","native":"\uD83C\uDDF7\uD83C\uDDF4"}],"version":2},"flag-rs":{"id":"flag-rs","name":"Serbia Flag","keywords":["rs","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1f8","native":"\uD83C\uDDF7\uD83C\uDDF8"}],"version":2},"ru":{"id":"ru","name":"Russia Flag","keywords":["ru","russian","federation","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1fa","native":"\uD83C\uDDF7\uD83C\uDDFA"}],"version":1},"flag-rw":{"id":"flag-rw","name":"Rwanda Flag","keywords":["rw","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1fc","native":"\uD83C\uDDF7\uD83C\uDDFC"}],"version":2},"flag-sa":{"id":"flag-sa","name":"Saudi Arabia Flag","keywords":["sa","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1e6","native":"\uD83C\uDDF8\uD83C\uDDE6"}],"version":2},"flag-sb":{"id":"flag-sb","name":"Solomon Islands Flag","keywords":["sb","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1e7","native":"\uD83C\uDDF8\uD83C\uDDE7"}],"version":2},"flag-sc":{"id":"flag-sc","name":"Seychelles Flag","keywords":["sc","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1e8","native":"\uD83C\uDDF8\uD83C\uDDE8"}],"version":2},"flag-sd":{"id":"flag-sd","name":"Sudan Flag","keywords":["sd","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1e9","native":"\uD83C\uDDF8\uD83C\uDDE9"}],"version":2},"flag-se":{"id":"flag-se","name":"Sweden Flag","keywords":["se","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ea","native":"\uD83C\uDDF8\uD83C\uDDEA"}],"version":2},"flag-sg":{"id":"flag-sg","name":"Singapore Flag","keywords":["sg","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ec","native":"\uD83C\uDDF8\uD83C\uDDEC"}],"version":2},"flag-sh":{"id":"flag-sh","name":"St. Helena Flag","keywords":["sh","st","saint","ascension","tristan","cunha","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ed","native":"\uD83C\uDDF8\uD83C\uDDED"}],"version":2},"flag-si":{"id":"flag-si","name":"Slovenia Flag","keywords":["si","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ee","native":"\uD83C\uDDF8\uD83C\uDDEE"}],"version":2},"flag-sj":{"id":"flag-sj","name":"Svalbard & Jan Mayen Flag","keywords":["sj"],"skins":[{"unified":"1f1f8-1f1ef","native":"\uD83C\uDDF8\uD83C\uDDEF"}],"version":2},"flag-sk":{"id":"flag-sk","name":"Slovakia Flag","keywords":["sk","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f0","native":"\uD83C\uDDF8\uD83C\uDDF0"}],"version":2},"flag-sl":{"id":"flag-sl","name":"Sierra Leone Flag","keywords":["sl","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f1","native":"\uD83C\uDDF8\uD83C\uDDF1"}],"version":2},"flag-sm":{"id":"flag-sm","name":"San Marino Flag","keywords":["sm","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f2","native":"\uD83C\uDDF8\uD83C\uDDF2"}],"version":2},"flag-sn":{"id":"flag-sn","name":"Senegal Flag","keywords":["sn","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f3","native":"\uD83C\uDDF8\uD83C\uDDF3"}],"version":2},"flag-so":{"id":"flag-so","name":"Somalia Flag","keywords":["so","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f4","native":"\uD83C\uDDF8\uD83C\uDDF4"}],"version":2},"flag-sr":{"id":"flag-sr","name":"Suriname Flag","keywords":["sr","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f7","native":"\uD83C\uDDF8\uD83C\uDDF7"}],"version":2},"flag-ss":{"id":"flag-ss","name":"South Sudan Flag","keywords":["ss","sd","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f8","native":"\uD83C\uDDF8\uD83C\uDDF8"}],"version":2},"flag-st":{"id":"flag-st","name":"S\xe3o Tom\xe9 & Pr\xedncipe Flag","keywords":["st","sao","tome","principe","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f9","native":"\uD83C\uDDF8\uD83C\uDDF9"}],"version":2},"flag-sv":{"id":"flag-sv","name":"El Salvador Flag","keywords":["sv","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1fb","native":"\uD83C\uDDF8\uD83C\uDDFB"}],"version":2},"flag-sx":{"id":"flag-sx","name":"Sint Maarten Flag","keywords":["sx","dutch","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1fd","native":"\uD83C\uDDF8\uD83C\uDDFD"}],"version":2},"flag-sy":{"id":"flag-sy","name":"Syria Flag","keywords":["sy","syrian","arab","republic","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1fe","native":"\uD83C\uDDF8\uD83C\uDDFE"}],"version":2},"flag-sz":{"id":"flag-sz","name":"Eswatini Flag","keywords":["sz","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ff","native":"\uD83C\uDDF8\uD83C\uDDFF"}],"version":2},"flag-ta":{"id":"flag-ta","name":"Tristan Da Cunha Flag","keywords":["ta"],"skins":[{"unified":"1f1f9-1f1e6","native":"\uD83C\uDDF9\uD83C\uDDE6"}],"version":2},"flag-tc":{"id":"flag-tc","name":"Turks & Caicos Islands Flag","keywords":["tc","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1e8","native":"\uD83C\uDDF9\uD83C\uDDE8"}],"version":2},"flag-td":{"id":"flag-td","name":"Chad Flag","keywords":["td","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1e9","native":"\uD83C\uDDF9\uD83C\uDDE9"}],"version":2},"flag-tf":{"id":"flag-tf","name":"French Southern Territories Flag","keywords":["tf","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1eb","native":"\uD83C\uDDF9\uD83C\uDDEB"}],"version":2},"flag-tg":{"id":"flag-tg","name":"Togo Flag","keywords":["tg","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1ec","native":"\uD83C\uDDF9\uD83C\uDDEC"}],"version":2},"flag-th":{"id":"flag-th","name":"Thailand Flag","keywords":["th","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1ed","native":"\uD83C\uDDF9\uD83C\uDDED"}],"version":2},"flag-tj":{"id":"flag-tj","name":"Tajikistan Flag","keywords":["tj","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1ef","native":"\uD83C\uDDF9\uD83C\uDDEF"}],"version":2},"flag-tk":{"id":"flag-tk","name":"Tokelau Flag","keywords":["tk","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f0","native":"\uD83C\uDDF9\uD83C\uDDF0"}],"version":2},"flag-tl":{"id":"flag-tl","name":"Timor-Leste Flag","keywords":["tl","timor","leste","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f1","native":"\uD83C\uDDF9\uD83C\uDDF1"}],"version":2},"flag-tm":{"id":"flag-tm","name":"Turkmenistan Flag","keywords":["tm","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f2","native":"\uD83C\uDDF9\uD83C\uDDF2"}],"version":2},"flag-tn":{"id":"flag-tn","name":"Tunisia Flag","keywords":["tn","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f3","native":"\uD83C\uDDF9\uD83C\uDDF3"}],"version":2},"flag-to":{"id":"flag-to","name":"Tonga Flag","keywords":["to","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f4","native":"\uD83C\uDDF9\uD83C\uDDF4"}],"version":2},"flag-tr":{"id":"flag-tr","name":"Turkey Flag","keywords":["tr","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f7","native":"\uD83C\uDDF9\uD83C\uDDF7"}],"version":2},"flag-tt":{"id":"flag-tt","name":"Trinidad & Tobago Flag","keywords":["tt","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f9","native":"\uD83C\uDDF9\uD83C\uDDF9"}],"version":2},"flag-tv":{"id":"flag-tv","name":"Tuvalu Flag","keywords":["tv","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1fb","native":"\uD83C\uDDF9\uD83C\uDDFB"}],"version":2},"flag-tw":{"id":"flag-tw","name":"Taiwan Flag","keywords":["tw","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1fc","native":"\uD83C\uDDF9\uD83C\uDDFC"}],"version":2},"flag-tz":{"id":"flag-tz","name":"Tanzania Flag","keywords":["tz","united","republic","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1ff","native":"\uD83C\uDDF9\uD83C\uDDFF"}],"version":2},"flag-ua":{"id":"flag-ua","name":"Ukraine Flag","keywords":["ua","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1e6","native":"\uD83C\uDDFA\uD83C\uDDE6"}],"version":2},"flag-ug":{"id":"flag-ug","name":"Uganda Flag","keywords":["ug","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1ec","native":"\uD83C\uDDFA\uD83C\uDDEC"}],"version":2},"flag-um":{"id":"flag-um","name":"U.s. Outlying Islands Flag","keywords":["um","u","s"],"skins":[{"unified":"1f1fa-1f1f2","native":"\uD83C\uDDFA\uD83C\uDDF2"}],"version":2},"flag-un":{"id":"flag-un","name":"United Nations Flag","keywords":["un","banner"],"skins":[{"unified":"1f1fa-1f1f3","native":"\uD83C\uDDFA\uD83C\uDDF3"}],"version":4},"us":{"id":"us","name":"United States Flag","keywords":["us","america","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1f8","native":"\uD83C\uDDFA\uD83C\uDDF8"}],"version":1},"flag-uy":{"id":"flag-uy","name":"Uruguay Flag","keywords":["uy","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1fe","native":"\uD83C\uDDFA\uD83C\uDDFE"}],"version":2},"flag-uz":{"id":"flag-uz","name":"Uzbekistan Flag","keywords":["uz","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1ff","native":"\uD83C\uDDFA\uD83C\uDDFF"}],"version":2},"flag-va":{"id":"flag-va","name":"Vatican City Flag","keywords":["va","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1e6","native":"\uD83C\uDDFB\uD83C\uDDE6"}],"version":2},"flag-vc":{"id":"flag-vc","name":"St. Vincent & Grenadines Flag","keywords":["vc","st","saint","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1e8","native":"\uD83C\uDDFB\uD83C\uDDE8"}],"version":2},"flag-ve":{"id":"flag-ve","name":"Venezuela Flag","keywords":["ve","bolivarian","republic","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1ea","native":"\uD83C\uDDFB\uD83C\uDDEA"}],"version":2},"flag-vg":{"id":"flag-vg","name":"British Virgin Islands Flag","keywords":["vg","bvi","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1ec","native":"\uD83C\uDDFB\uD83C\uDDEC"}],"version":2},"flag-vi":{"id":"flag-vi","name":"U.s. Virgin Islands Flag","keywords":["vi","u","s","us","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1ee","native":"\uD83C\uDDFB\uD83C\uDDEE"}],"version":2},"flag-vn":{"id":"flag-vn","name":"Vietnam Flag","keywords":["vn","viet","nam","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1f3","native":"\uD83C\uDDFB\uD83C\uDDF3"}],"version":2},"flag-vu":{"id":"flag-vu","name":"Vanuatu Flag","keywords":["vu","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1fa","native":"\uD83C\uDDFB\uD83C\uDDFA"}],"version":2},"flag-wf":{"id":"flag-wf","name":"Wallis & Futuna Flag","keywords":["wf","nation","country","banner"],"skins":[{"unified":"1f1fc-1f1eb","native":"\uD83C\uDDFC\uD83C\uDDEB"}],"version":2},"flag-ws":{"id":"flag-ws","name":"Samoa Flag","keywords":["ws","nation","country","banner"],"skins":[{"unified":"1f1fc-1f1f8","native":"\uD83C\uDDFC\uD83C\uDDF8"}],"version":2},"flag-xk":{"id":"flag-xk","name":"Kosovo Flag","keywords":["xk","nation","country","banner"],"skins":[{"unified":"1f1fd-1f1f0","native":"\uD83C\uDDFD\uD83C\uDDF0"}],"version":2},"flag-ye":{"id":"flag-ye","name":"Yemen Flag","keywords":["ye","nation","country","banner"],"skins":[{"unified":"1f1fe-1f1ea","native":"\uD83C\uDDFE\uD83C\uDDEA"}],"version":2},"flag-yt":{"id":"flag-yt","name":"Mayotte Flag","keywords":["yt","nation","country","banner"],"skins":[{"unified":"1f1fe-1f1f9","native":"\uD83C\uDDFE\uD83C\uDDF9"}],"version":2},"flag-za":{"id":"flag-za","name":"South Africa Flag","keywords":["za","nation","country","banner"],"skins":[{"unified":"1f1ff-1f1e6","native":"\uD83C\uDDFF\uD83C\uDDE6"}],"version":2},"flag-zm":{"id":"flag-zm","name":"Zambia Flag","keywords":["zm","nation","country","banner"],"skins":[{"unified":"1f1ff-1f1f2","native":"\uD83C\uDDFF\uD83C\uDDF2"}],"version":2},"flag-zw":{"id":"flag-zw","name":"Zimbabwe Flag","keywords":["zw","nation","country","banner"],"skins":[{"unified":"1f1ff-1f1fc","native":"\uD83C\uDDFF\uD83C\uDDFC"}],"version":2},"flag-england":{"id":"flag-england","name":"England Flag","keywords":["english"],"skins":[{"unified":"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f","native":"\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F"}],"version":5},"flag-scotland":{"id":"flag-scotland","name":"Scotland Flag","keywords":["scottish"],"skins":[{"unified":"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f","native":"\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F"}],"version":5},"flag-wales":{"id":"flag-wales","name":"Wales Flag","keywords":["welsh"],"skins":[{"unified":"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f","native":"\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F"}],"version":5}},"aliases":{"satisfied":"laughing","grinning_face_with_star_eyes":"star-struck","grinning_face_with_one_large_and_one_small_eye":"zany_face","smiling_face_with_smiling_eyes_and_hand_covering_mouth":"face_with_hand_over_mouth","face_with_finger_covering_closed_lips":"shushing_face","face_with_one_eyebrow_raised":"face_with_raised_eyebrow","face_with_open_mouth_vomiting":"face_vomiting","shocked_face_with_exploding_head":"exploding_head","serious_face_with_symbols_covering_mouth":"face_with_symbols_on_mouth","poop":"hankey","shit":"hankey","collision":"boom","raised_hand":"hand","hand_with_index_and_middle_fingers_crossed":"crossed_fingers","sign_of_the_horns":"the_horns","reversed_hand_with_middle_finger_extended":"middle_finger","thumbsup":"+1","thumbsdown":"-1","punch":"facepunch","mother_christmas":"mrs_claus","running":"runner","man-with-bunny-ears-partying":"men-with-bunny-ears-partying","woman-with-bunny-ears-partying":"women-with-bunny-ears-partying","women_holding_hands":"two_women_holding_hands","woman_and_man_holding_hands":"man_and_woman_holding_hands","couple":"man_and_woman_holding_hands","men_holding_hands":"two_men_holding_hands","paw_prints":"feet","flipper":"dolphin","honeybee":"bee","lady_beetle":"ladybug","cooking":"fried_egg","knife":"hocho","red_car":"car","sailboat":"boat","waxing_gibbous_moon":"moon","sun_small_cloud":"mostly_sunny","sun_behind_cloud":"barely_sunny","sun_behind_rain_cloud":"partly_sunny_rain","lightning_cloud":"lightning","tornado_cloud":"tornado","tshirt":"shirt","shoe":"mans_shoe","telephone":"phone","lantern":"izakaya_lantern","open_book":"book","envelope":"email","pencil":"memo","heavy_exclamation_mark":"exclamation","staff_of_aesculapius":"medical_symbol","flag-cn":"cn","flag-de":"de","flag-es":"es","flag-fr":"fr","uk":"gb","flag-gb":"gb","flag-it":"it","flag-jp":"jp","flag-kr":"kr","flag-ru":"ru","flag-us":"us"},"sheet":{"cols":61,"rows":61}}');



var $ltGt3 = parcelRequire("ltGt3");
function $8c104cf9ab4badc0$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$n, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$u, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$a8257692ac88316c, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$t, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$r, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$o, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$f, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$e = {}, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$c = [], $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$a(n1, l1) {
    for(var u1 in l1)n1[u1] = l1[u1];
    return n1;
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$h(n2) {
    var l2 = n2.parentNode;
    l2 && l2.removeChild(n2);
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d(l3, u2, i1) {
    var t1, r1, o1, f1 = {};
    for(o1 in u2)"key" == o1 ? t1 = u2[o1] : "ref" == o1 ? r1 = u2[o1] : f1[o1] = u2[o1];
    if (arguments.length > 2 && (f1.children = arguments.length > 3 ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$n.call(arguments, 2) : i1), "function" == typeof l3 && null != l3.defaultProps) for(o1 in l3.defaultProps)void 0 === f1[o1] && (f1[o1] = l3.defaultProps[o1]);
    return $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$y(l3, f1, t1, r1, null);
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$y(n3, i2, t2, r2, o2) {
    var f2 = {
        type: n3,
        props: i2,
        key: t2,
        ref: r2,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o2 ? ++$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$u : o2
    };
    return null == o2 && null != $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode(f2), f2;
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$ffb0004e005737fa(n4) {
    return n4.children;
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8(n5, l4) {
    this.props = n5, this.context = l4;
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$k(n6, l5) {
    if (null == l5) return n6.__ ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$k(n6.__, n6.__.__k.indexOf(n6) + 1) : null;
    for(var u3; l5 < n6.__k.length; l5++)if (null != (u3 = n6.__k[l5]) && null != u3.__e) return u3.__e;
    return "function" == typeof n6.type ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$k(n6) : null;
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$b(n7) {
    var l6, u4;
    if (null != (n7 = n7.__) && null != n7.__c) {
        for(n7.__e = n7.__c.base = null, l6 = 0; l6 < n7.__k.length; l6++)if (null != (u4 = n7.__k[l6]) && null != u4.__e) {
            n7.__e = n7.__c.base = u4.__e;
            break;
        }
        return $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$b(n7);
    }
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$m(n8) {
    (!n8.__d && (n8.__d = !0) && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$t.push(n8) && !$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$g.__r++ || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$o !== $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.debounceRendering) && (($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$o = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.debounceRendering) || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$r)($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$g);
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$g() {
    for(var n9; $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$g.__r = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$t.length;)n9 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$t.sort(function(n10, l7) {
        return n10.__v.__b - l7.__v.__b;
    }), $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$t = [], n9.some(function(n11) {
        var l8, u5, i3, t3, r3, o3;
        n11.__d && (r3 = (t3 = (l8 = n11).__v).__e, (o3 = l8.__P) && (u5 = [], (i3 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$a({}, t3)).__v = t3.__v + 1, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$j(o3, t3, i3, l8.__n, void 0 !== o3.ownerSVGElement, null != t3.__h ? [
            r3
        ] : null, u5, null == r3 ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$k(t3) : r3, t3.__h), $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$z(u5, t3), t3.__e != r3 && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$b(t3)));
    });
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$w(n12, l9, u6, i4, t4, r4, o4, f3, s1, a1) {
    var h1, v1, p1, _1, b1, m1, g1, w1 = i4 && i4.__k || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$c, A1 = w1.length;
    for(u6.__k = [], h1 = 0; h1 < l9.length; h1++)if (null != (_1 = u6.__k[h1] = null == (_1 = l9[h1]) || "boolean" == typeof _1 ? null : "string" == typeof _1 || "number" == typeof _1 || "bigint" == typeof _1 ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$y(null, _1, null, null, _1) : Array.isArray(_1) ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$y($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$ffb0004e005737fa, {
        children: _1
    }, null, null, null) : _1.__b > 0 ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$y(_1.type, _1.props, _1.key, null, _1.__v) : _1)) {
        if (_1.__ = u6, _1.__b = u6.__b + 1, null === (p1 = w1[h1]) || p1 && _1.key == p1.key && _1.type === p1.type) w1[h1] = void 0;
        else for(v1 = 0; v1 < A1; v1++){
            if ((p1 = w1[v1]) && _1.key == p1.key && _1.type === p1.type) {
                w1[v1] = void 0;
                break;
            }
            p1 = null;
        }
        $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$j(n12, _1, p1 = p1 || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$e, t4, r4, o4, f3, s1, a1), b1 = _1.__e, (v1 = _1.ref) && p1.ref != v1 && (g1 || (g1 = []), p1.ref && g1.push(p1.ref, null, _1), g1.push(v1, _1.__c || b1, _1)), null != b1 ? (null == m1 && (m1 = b1), "function" == typeof _1.type && _1.__k === p1.__k ? _1.__d = s1 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$x(_1, s1, n12) : s1 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$P(n12, _1, p1, w1, b1, s1), "function" == typeof u6.type && (u6.__d = s1)) : s1 && p1.__e == s1 && s1.parentNode != n12 && (s1 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$k(p1));
    }
    for(u6.__e = m1, h1 = A1; h1--;)null != w1[h1] && ("function" == typeof u6.type && null != w1[h1].__e && w1[h1].__e == u6.__d && (u6.__d = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$k(i4, h1 + 1)), $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$N(w1[h1], w1[h1]));
    if (g1) for(h1 = 0; h1 < g1.length; h1++)$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$M(g1[h1], g1[++h1], g1[++h1]);
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$x(n13, l10, u7) {
    for(var i5, t5 = n13.__k, r5 = 0; t5 && r5 < t5.length; r5++)(i5 = t5[r5]) && (i5.__ = n13, l10 = "function" == typeof i5.type ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$x(i5, l10, u7) : $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$P(u7, i5, i5, t5, i5.__e, l10));
    return l10;
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$47e4c5b300681277(n14, l11) {
    return l11 = l11 || [], null == n14 || "boolean" == typeof n14 || (Array.isArray(n14) ? n14.some(function(n15) {
        $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$47e4c5b300681277(n15, l11);
    }) : l11.push(n14)), l11;
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$P(n16, l12, u8, i6, t6, r6) {
    var o5, f4, e1;
    if (void 0 !== l12.__d) o5 = l12.__d, l12.__d = void 0;
    else if (null == u8 || t6 != r6 || null == t6.parentNode) n: if (null == r6 || r6.parentNode !== n16) n16.appendChild(t6), o5 = null;
    else {
        for(f4 = r6, e1 = 0; (f4 = f4.nextSibling) && e1 < i6.length; e1 += 2)if (f4 == t6) break n;
        n16.insertBefore(t6, r6), o5 = r6;
    }
    return void 0 !== o5 ? o5 : t6.nextSibling;
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$C(n17, l13, u9, i7, t7) {
    var r7;
    for(r7 in u9)"children" === r7 || "key" === r7 || r7 in l13 || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$H(n17, r7, null, u9[r7], i7);
    for(r7 in l13)t7 && "function" != typeof l13[r7] || "children" === r7 || "key" === r7 || "value" === r7 || "checked" === r7 || u9[r7] === l13[r7] || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$H(n17, r7, l13[r7], u9[r7], i7);
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$$(n18, l14, u10) {
    "-" === l14[0] ? n18.setProperty(l14, u10) : n18[l14] = null == u10 ? "" : "number" != typeof u10 || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$s.test(l14) ? u10 : u10 + "px";
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$H(n19, l15, u11, i8, t8) {
    var r8;
    n: if ("style" === l15) {
        if ("string" == typeof u11) n19.style.cssText = u11;
        else {
            if ("string" == typeof i8 && (n19.style.cssText = i8 = ""), i8) for(l15 in i8)u11 && l15 in u11 || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$$(n19.style, l15, "");
            if (u11) for(l15 in u11)i8 && u11[l15] === i8[l15] || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$$(n19.style, l15, u11[l15]);
        }
    } else if ("o" === l15[0] && "n" === l15[1]) r8 = l15 !== (l15 = l15.replace(/Capture$/, "")), l15 = l15.toLowerCase() in n19 ? l15.toLowerCase().slice(2) : l15.slice(2), n19.l || (n19.l = {}), n19.l[l15 + r8] = u11, u11 ? i8 || n19.addEventListener(l15, r8 ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$T : $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$I, r8) : n19.removeEventListener(l15, r8 ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$T : $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$I, r8);
    else if ("dangerouslySetInnerHTML" !== l15) {
        if (t8) l15 = l15.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
        else if ("href" !== l15 && "list" !== l15 && "form" !== l15 && "tabIndex" !== l15 && "download" !== l15 && l15 in n19) try {
            n19[l15] = null == u11 ? "" : u11;
            break n;
        } catch (n) {}
        "function" == typeof u11 || (null != u11 && (!1 !== u11 || "a" === l15[0] && "r" === l15[1]) ? n19.setAttribute(l15, u11) : n19.removeAttribute(l15));
    }
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$I(n20) {
    this.l[n20.type + !1]($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.event ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.event(n20) : n20);
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$T(n21) {
    this.l[n21.type + !0]($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.event ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.event(n21) : n21);
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$j(n22, u12, i9, t9, r9, o6, f5, e2, c1) {
    var s2, h2, v2, y1, p2, k1, b2, m2, g2, x1, A2, P1 = u12.type;
    if (void 0 !== u12.constructor) return null;
    null != i9.__h && (c1 = i9.__h, e2 = u12.__e = i9.__e, u12.__h = null, o6 = [
        e2
    ]), (s2 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__b) && s2(u12);
    try {
        n: if ("function" == typeof P1) {
            if (m2 = u12.props, g2 = (s2 = P1.contextType) && t9[s2.__c], x1 = s2 ? g2 ? g2.props.value : s2.__ : t9, i9.__c ? b2 = (h2 = u12.__c = i9.__c).__ = h2.__E : ("prototype" in P1 && P1.prototype.render ? u12.__c = h2 = new P1(m2, x1) : (u12.__c = h2 = new $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8(m2, x1), h2.constructor = P1, h2.render = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$O), g2 && g2.sub(h2), h2.props = m2, h2.state || (h2.state = {}), h2.context = x1, h2.__n = t9, v2 = h2.__d = !0, h2.__h = []), null == h2.__s && (h2.__s = h2.state), null != P1.getDerivedStateFromProps && (h2.__s == h2.state && (h2.__s = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$a({}, h2.__s)), $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$a(h2.__s, P1.getDerivedStateFromProps(m2, h2.__s))), y1 = h2.props, p2 = h2.state, v2) null == P1.getDerivedStateFromProps && null != h2.componentWillMount && h2.componentWillMount(), null != h2.componentDidMount && h2.__h.push(h2.componentDidMount);
            else {
                if (null == P1.getDerivedStateFromProps && m2 !== y1 && null != h2.componentWillReceiveProps && h2.componentWillReceiveProps(m2, x1), !h2.__e && null != h2.shouldComponentUpdate && !1 === h2.shouldComponentUpdate(m2, h2.__s, x1) || u12.__v === i9.__v) {
                    h2.props = m2, h2.state = h2.__s, u12.__v !== i9.__v && (h2.__d = !1), h2.__v = u12, u12.__e = i9.__e, u12.__k = i9.__k, u12.__k.forEach(function(n23) {
                        n23 && (n23.__ = u12);
                    }), h2.__h.length && f5.push(h2);
                    break n;
                }
                null != h2.componentWillUpdate && h2.componentWillUpdate(m2, h2.__s, x1), null != h2.componentDidUpdate && h2.__h.push(function() {
                    h2.componentDidUpdate(y1, p2, k1);
                });
            }
            h2.context = x1, h2.props = m2, h2.state = h2.__s, (s2 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__r) && s2(u12), h2.__d = !1, h2.__v = u12, h2.__P = n22, s2 = h2.render(h2.props, h2.state, h2.context), h2.state = h2.__s, null != h2.getChildContext && (t9 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$a($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$a({}, t9), h2.getChildContext())), v2 || null == h2.getSnapshotBeforeUpdate || (k1 = h2.getSnapshotBeforeUpdate(y1, p2)), A2 = null != s2 && s2.type === $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$ffb0004e005737fa && null == s2.key ? s2.props.children : s2, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$w(n22, Array.isArray(A2) ? A2 : [
                A2
            ], u12, i9, t9, r9, o6, f5, e2, c1), h2.base = u12.__e, u12.__h = null, h2.__h.length && f5.push(h2), b2 && (h2.__E = h2.__ = null), h2.__e = !1;
        } else null == o6 && u12.__v === i9.__v ? (u12.__k = i9.__k, u12.__e = i9.__e) : u12.__e = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$L(i9.__e, u12, i9, t9, r9, o6, f5, c1);
        (s2 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.diffed) && s2(u12);
    } catch (n24) {
        u12.__v = null, (c1 || null != o6) && (u12.__e = e2, u12.__h = !!c1, o6[o6.indexOf(e2)] = null), $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n24, u12, i9);
    }
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$z(n25, u13) {
    $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__c && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__c(u13, n25), n25.some(function(u14) {
        try {
            n25 = u14.__h, u14.__h = [], n25.some(function(n26) {
                n26.call(u14);
            });
        } catch (n27) {
            $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n27, u14.__v);
        }
    });
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$L(l16, u15, i10, t10, r10, o7, f6, c2) {
    var s3, a2, v3, y2 = i10.props, p3 = u15.props, d1 = u15.type, _2 = 0;
    if ("svg" === d1 && (r10 = !0), null != o7) {
        for(; _2 < o7.length; _2++)if ((s3 = o7[_2]) && "setAttribute" in s3 == !!d1 && (d1 ? s3.localName === d1 : 3 === s3.nodeType)) {
            l16 = s3, o7[_2] = null;
            break;
        }
    }
    if (null == l16) {
        if (null === d1) return document.createTextNode(p3);
        l16 = r10 ? document.createElementNS("http://www.w3.org/2000/svg", d1) : document.createElement(d1, p3.is && p3), o7 = null, c2 = !1;
    }
    if (null === d1) y2 === p3 || c2 && l16.data === p3 || (l16.data = p3);
    else {
        if (o7 = o7 && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$n.call(l16.childNodes), a2 = (y2 = i10.props || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$e).dangerouslySetInnerHTML, v3 = p3.dangerouslySetInnerHTML, !c2) {
            if (null != o7) for(y2 = {}, _2 = 0; _2 < l16.attributes.length; _2++)y2[l16.attributes[_2].name] = l16.attributes[_2].value;
            (v3 || a2) && (v3 && (a2 && v3.__html == a2.__html || v3.__html === l16.innerHTML) || (l16.innerHTML = v3 && v3.__html || ""));
        }
        if ($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$C(l16, p3, y2, r10, c2), v3) u15.__k = [];
        else if (_2 = u15.props.children, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$w(l16, Array.isArray(_2) ? _2 : [
            _2
        ], u15, i10, t10, r10 && "foreignObject" !== d1, o7, f6, o7 ? o7[0] : i10.__k && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$k(i10, 0), c2), null != o7) for(_2 = o7.length; _2--;)null != o7[_2] && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$h(o7[_2]);
        c2 || ("value" in p3 && void 0 !== (_2 = p3.value) && (_2 !== y2.value || _2 !== l16.value || "progress" === d1 && !_2) && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$H(l16, "value", _2, y2.value, !1), "checked" in p3 && void 0 !== (_2 = p3.checked) && _2 !== l16.checked && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$H(l16, "checked", _2, y2.checked, !1));
    }
    return l16;
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$M(n28, u16, i11) {
    try {
        "function" == typeof n28 ? n28(u16) : n28.current = u16;
    } catch (n29) {
        $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n29, i11);
    }
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$N(n30, u17, i12) {
    var t11, r11;
    if ($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount(n30), (t11 = n30.ref) && (t11.current && t11.current !== n30.__e || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$M(t11, null, u17)), null != (t11 = n30.__c)) {
        if (t11.componentWillUnmount) try {
            t11.componentWillUnmount();
        } catch (n31) {
            $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n31, u17);
        }
        t11.base = t11.__P = null;
    }
    if (t11 = n30.__k) for(r11 = 0; r11 < t11.length; r11++)t11[r11] && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$N(t11[r11], u17, "function" != typeof n30.type);
    i12 || null == n30.__e || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$h(n30.__e), n30.__e = n30.__d = void 0;
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$O(n32, l, u18) {
    return this.constructor(n32, u18);
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99(u19, i13, t12) {
    var r12, o8, f7;
    $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__ && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__(u19, i13), o8 = (r12 = "function" == typeof t12) ? null : t12 && t12.__k || i13.__k, f7 = [], $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$j(i13, u19 = (!r12 && t12 || i13).__k = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$ffb0004e005737fa, null, [
        u19
    ]), o8 || $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$e, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$e, void 0 !== i13.ownerSVGElement, !r12 && t12 ? [
        t12
    ] : o8 ? null : i13.firstChild ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$n.call(i13.childNodes) : null, f7, !r12 && t12 ? t12 : o8 ? o8.__e : i13.firstChild, r12), $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$z(f7, u19);
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$fa8d919ba61d84db(n33, l17) {
    $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99(n33, l17, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$fa8d919ba61d84db);
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$e530037191fcd5d7(l18, u20, i14) {
    var t13, r13, o9, f8 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$a({}, l18.props);
    for(o9 in u20)"key" == o9 ? t13 = u20[o9] : "ref" == o9 ? r13 = u20[o9] : f8[o9] = u20[o9];
    return arguments.length > 2 && (f8.children = arguments.length > 3 ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$n.call(arguments, 2) : i14), $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$y(l18.type, f8, t13 || l18.key, r13 || l18.ref, null);
}
function $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$fd42f52fd3ae1109(n34, l19) {
    var u21 = {
        __c: l19 = "__cC" + $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$f++,
        __: n34,
        Consumer: function(n35, l20) {
            return n35.children(l20);
        },
        Provider: function(n36) {
            var u22, i15;
            return this.getChildContext || (u22 = [], (i15 = {})[l19] = this, this.getChildContext = function() {
                return i15;
            }, this.shouldComponentUpdate = function(n37) {
                this.props.value !== n37.value && u22.some($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$m);
            }, this.sub = function(n38) {
                u22.push(n38);
                var l21 = n38.componentWillUnmount;
                n38.componentWillUnmount = function() {
                    u22.splice(u22.indexOf(n38), 1), l21 && l21.call(n38);
                };
            }), n36.children;
        }
    };
    return u21.Provider.__ = u21.Consumer.contextType = u21;
}
$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$n = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$c.slice, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2 = {
    __e: function(n39, l22) {
        for(var u23, i16, t14; l22 = l22.__;)if ((u23 = l22.__c) && !u23.__) try {
            if ((i16 = u23.constructor) && null != i16.getDerivedStateFromError && (u23.setState(i16.getDerivedStateFromError(n39)), t14 = u23.__d), null != u23.componentDidCatch && (u23.componentDidCatch(n39), t14 = u23.__d), t14) return u23.__E = u23;
        } catch (l23) {
            n39 = l23;
        }
        throw n39;
    }
}, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$u = 0, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$a8257692ac88316c = function(n40) {
    return null != n40 && void 0 === n40.constructor;
}, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.setState = function(n41, l24) {
    var u24;
    u24 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$a({}, this.state), "function" == typeof n41 && (n41 = n41($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$a({}, u24), this.props)), n41 && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$a(u24, n41), null != n41 && this.__v && (l24 && this.__h.push(l24), $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$m(this));
}, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.forceUpdate = function(n42) {
    this.__v && (this.__e = !0, n42 && this.__h.push(n42), $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$m(this));
}, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.render = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$ffb0004e005737fa, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$t = [], $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$g.__r = 0, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$var$f = 0;
var $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$var$o = 0;
function $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b(_1, e1, n, t, f) {
    var l, s, u = {};
    for(s in e1)"ref" == s ? l = e1[s] : u[s] = e1[s];
    var a = {
        type: _1,
        props: u,
        key: n,
        ref: l,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: --$8c104cf9ab4badc0$var$$bd9dd35321b03dd4$var$o,
        __source: t,
        __self: f
    };
    if ("function" == typeof _1 && (l = _1.defaultProps)) for(s in l)void 0 === u[s] && (u[s] = l[s]);
    return $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode(a), a;
}
function $8c104cf9ab4badc0$var$$f72b75cf796873c7$var$set(key, value) {
    try {
        window.localStorage[`emoji-mart.${key}`] = JSON.stringify(value);
    } catch (error) {}
}
function $8c104cf9ab4badc0$var$$f72b75cf796873c7$var$get(key) {
    try {
        const value = window.localStorage[`emoji-mart.${key}`];
        if (value) return JSON.parse(value);
    } catch (error) {}
}
var $8c104cf9ab4badc0$export$390f32400eaf98c9 = {
    set: $8c104cf9ab4badc0$var$$f72b75cf796873c7$var$set,
    get: $8c104cf9ab4badc0$var$$f72b75cf796873c7$var$get
};
const $8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$CACHE = new Map();
const $8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$VERSIONS = [
    {
        v: 15,
        emoji: "\uD83E\uDEE8"
    },
    {
        v: 14,
        emoji: "\uD83E\uDEE0"
    },
    {
        v: 13.1,
        emoji: "\uD83D\uDE36\u200D\uD83C\uDF2B\uFE0F"
    },
    {
        v: 13,
        emoji: "\uD83E\uDD78"
    },
    {
        v: 12.1,
        emoji: "\uD83E\uDDD1\u200D\uD83E\uDDB0"
    },
    {
        v: 12,
        emoji: "\uD83E\uDD71"
    },
    {
        v: 11,
        emoji: "\uD83E\uDD70"
    },
    {
        v: 5,
        emoji: "\uD83E\uDD29"
    },
    {
        v: 4,
        emoji: "\uD83D\uDC71\u200D\u2640\uFE0F"
    },
    {
        v: 3,
        emoji: "\uD83E\uDD23"
    },
    {
        v: 2,
        emoji: "\uD83D\uDC4B\uD83C\uDFFB"
    },
    {
        v: 1,
        emoji: "\uD83D\uDE43"
    }
];
function $8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$latestVersion() {
    for (const { v: v, emoji: emoji } of $8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$VERSIONS){
        if ($8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$isSupported(emoji)) return v;
    }
}
function $8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$noCountryFlags() {
    if ($8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$isSupported("\uD83C\uDDE8\uD83C\uDDE6")) return false;
    return true;
}
function $8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$isSupported(emoji) {
    if ($8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$CACHE.has(emoji)) return $8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$CACHE.get(emoji);
    const supported = $8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$isEmojiSupported(emoji);
    $8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$CACHE.set(emoji, supported);
    return supported;
}
// https://github.com/koala-interactive/is-emoji-supported
const $8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$isEmojiSupported = (()=>{
    let ctx = null;
    try {
        if (!navigator.userAgent.includes("jsdom")) ctx = document.createElement("canvas").getContext("2d", {
            willReadFrequently: true
        });
    } catch  {}
    // Not in browser env
    if (!ctx) return ()=>false;
    const CANVAS_HEIGHT = 25;
    const CANVAS_WIDTH = 20;
    const textSize = Math.floor(CANVAS_HEIGHT / 2);
    // Initialize convas context
    ctx.font = textSize + "px Arial, Sans-Serif";
    ctx.textBaseline = "top";
    ctx.canvas.width = CANVAS_WIDTH * 2;
    ctx.canvas.height = CANVAS_HEIGHT;
    return (unicode)=>{
        ctx.clearRect(0, 0, CANVAS_WIDTH * 2, CANVAS_HEIGHT);
        // Draw in red on the left
        ctx.fillStyle = "#FF0000";
        ctx.fillText(unicode, 0, 22);
        // Draw in blue on right
        ctx.fillStyle = "#0000FF";
        ctx.fillText(unicode, CANVAS_WIDTH, 22);
        const a = ctx.getImageData(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT).data;
        const count = a.length;
        let i = 0;
        // Search the first visible pixel
        for(; i < count && !a[i + 3]; i += 4);
        // No visible pixel
        if (i >= count) return false;
        // Emoji has immutable color, so we check the color of the emoji in two different colors
        // the result show be the same.
        const x = CANVAS_WIDTH + i / 4 % CANVAS_WIDTH;
        const y = Math.floor(i / 4 / CANVAS_WIDTH);
        const b = ctx.getImageData(x, y, 1, 1).data;
        if (a[i] !== b[0] || a[i + 2] !== b[2]) return false;
        // Some emojis are a contraction of different ones, so if it's not
        // supported, it will show multiple characters
        if (ctx.measureText(unicode).width >= CANVAS_WIDTH) return false;
        // Supported
        return true;
    };
})();
var $8c104cf9ab4badc0$var$$c84d045dcc34faf5$export$2e2bcd8739ae039 = {
    latestVersion: $8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$latestVersion,
    noCountryFlags: $8c104cf9ab4badc0$var$$c84d045dcc34faf5$var$noCountryFlags
};
const $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$DEFAULTS = [
    "+1",
    "grinning",
    "kissing_heart",
    "heart_eyes",
    "laughing",
    "stuck_out_tongue_winking_eye",
    "sweat_smile",
    "joy",
    "scream",
    "disappointed",
    "unamused",
    "weary",
    "sob",
    "sunglasses",
    "heart"
];
let $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index = null;
function $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$add(emoji) {
    $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index || ($8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index = $8c104cf9ab4badc0$export$390f32400eaf98c9.get("frequently") || {});
    const emojiId = emoji.id || emoji;
    if (!emojiId) return;
    $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index[emojiId] || ($8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index[emojiId] = 0);
    $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index[emojiId] += 1;
    $8c104cf9ab4badc0$export$390f32400eaf98c9.set("last", emojiId);
    $8c104cf9ab4badc0$export$390f32400eaf98c9.set("frequently", $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index);
}
function $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$get({ maxFrequentRows: maxFrequentRows, perLine: perLine }) {
    if (!maxFrequentRows) return [];
    $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index || ($8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index = $8c104cf9ab4badc0$export$390f32400eaf98c9.get("frequently"));
    let emojiIds = [];
    if (!$8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index) {
        $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index = {};
        for(let i in $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$DEFAULTS.slice(0, perLine)){
            const emojiId = $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$DEFAULTS[i];
            $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index[emojiId] = perLine - i;
            emojiIds.push(emojiId);
        }
        return emojiIds;
    }
    const max = maxFrequentRows * perLine;
    const last = $8c104cf9ab4badc0$export$390f32400eaf98c9.get("last");
    for(let emojiId in $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index)emojiIds.push(emojiId);
    emojiIds.sort((a, b)=>{
        const aScore = $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index[b];
        const bScore = $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index[a];
        if (aScore == bScore) return a.localeCompare(b);
        return aScore - bScore;
    });
    if (emojiIds.length > max) {
        const removedIds = emojiIds.slice(max);
        emojiIds = emojiIds.slice(0, max);
        for (let removedId of removedIds){
            if (removedId == last) continue;
            delete $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index[removedId];
        }
        if (last && emojiIds.indexOf(last) == -1) {
            delete $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index[emojiIds[emojiIds.length - 1]];
            emojiIds.splice(-1, 1, last);
        }
        $8c104cf9ab4badc0$export$390f32400eaf98c9.set("frequently", $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$Index);
    }
    return emojiIds;
}
var $8c104cf9ab4badc0$export$d42f766cf4e359f3 = {
    add: $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$add,
    get: $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$get,
    DEFAULTS: $8c104cf9ab4badc0$var$$b22cfd0a55410b4f$var$DEFAULTS
};
var $8c104cf9ab4badc0$var$$8d50d93417ef682a$exports = {};
$8c104cf9ab4badc0$var$$8d50d93417ef682a$exports = JSON.parse('{"search":"Search","search_no_results_1":"Oh no!","search_no_results_2":"That emoji couldn\u2019t be found","pick":"Pick an emoji\u2026","add_custom":"Add custom emoji","categories":{"activity":"Activity","custom":"Custom","flags":"Flags","foods":"Food & Drink","frequent":"Frequently used","nature":"Animals & Nature","objects":"Objects","people":"Smileys & People","places":"Travel & Places","search":"Search Results","symbols":"Symbols"},"skins":{"1":"Default","2":"Light","3":"Medium-Light","4":"Medium","5":"Medium-Dark","6":"Dark","choose":"Choose default skin tone"}}');
var $8c104cf9ab4badc0$var$$b247ea80b67298d5$export$2e2bcd8739ae039 = {
    autoFocus: {
        value: false
    },
    dynamicWidth: {
        value: false
    },
    emojiButtonColors: {
        value: null
    },
    emojiButtonRadius: {
        value: "100%"
    },
    emojiButtonSize: {
        value: 36
    },
    emojiSize: {
        value: 24
    },
    emojiVersion: {
        value: 15,
        choices: [
            1,
            2,
            3,
            4,
            5,
            11,
            12,
            12.1,
            13,
            13.1,
            14,
            15
        ]
    },
    exceptEmojis: {
        value: []
    },
    icons: {
        value: "auto",
        choices: [
            "auto",
            "outline",
            "solid"
        ]
    },
    locale: {
        value: "en",
        choices: [
            "en",
            "ar",
            "be",
            "cs",
            "de",
            "es",
            "fa",
            "fi",
            "fr",
            "hi",
            "it",
            "ja",
            "ko",
            "nl",
            "pl",
            "pt",
            "ru",
            "sa",
            "tr",
            "uk",
            "vi",
            "zh"
        ]
    },
    maxFrequentRows: {
        value: 4
    },
    navPosition: {
        value: "top",
        choices: [
            "top",
            "bottom",
            "none"
        ]
    },
    noCountryFlags: {
        value: false
    },
    noResultsEmoji: {
        value: null
    },
    perLine: {
        value: 9
    },
    previewEmoji: {
        value: null
    },
    previewPosition: {
        value: "bottom",
        choices: [
            "top",
            "bottom",
            "none"
        ]
    },
    searchPosition: {
        value: "sticky",
        choices: [
            "sticky",
            "static",
            "none"
        ]
    },
    set: {
        value: "native",
        choices: [
            "native",
            "apple",
            "facebook",
            "google",
            "twitter"
        ]
    },
    skin: {
        value: 1,
        choices: [
            1,
            2,
            3,
            4,
            5,
            6
        ]
    },
    skinTonePosition: {
        value: "preview",
        choices: [
            "preview",
            "search",
            "none"
        ]
    },
    theme: {
        value: "auto",
        choices: [
            "auto",
            "light",
            "dark"
        ]
    },
    // Data
    categories: null,
    categoryIcons: null,
    custom: null,
    data: null,
    i18n: null,
    // Callbacks
    getImageURL: null,
    getSpritesheetURL: null,
    onAddCustomEmoji: null,
    onClickOutside: null,
    onEmojiSelect: null,
    // Deprecated
    stickySearch: {
        deprecated: true,
        value: true
    }
};
let $8c104cf9ab4badc0$export$dbe3113d60765c1a = null;
let $8c104cf9ab4badc0$export$2d0294657ab35f1b = null;
const $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$fetchCache = {};
async function $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$fetchJSON(src) {
    if ($8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$fetchCache[src]) return $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$fetchCache[src];
    const response = await fetch(src);
    const json = await response.json();
    $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$fetchCache[src] = json;
    return json;
}
let $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$promise = null;
let $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$initiated = false;
let $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$initCallback = null;
let $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$initialized = false;
function $8c104cf9ab4badc0$export$2cd8252107eb640b(options, { caller: caller } = {}) {
    $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$promise || ($8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$promise = new Promise((resolve)=>{
        $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$initCallback = resolve;
    }));
    if (options) $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$_init(options);
    else if (caller && !$8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$initialized) console.warn(`\`${caller}\` requires data to be initialized first. Promise will be pending until \`init\` is called.`);
    return $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$promise;
}
async function $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$_init(props) {
    $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$initialized = true;
    let { emojiVersion: emojiVersion, set: set, locale: locale } = props;
    emojiVersion || (emojiVersion = $8c104cf9ab4badc0$var$$b247ea80b67298d5$export$2e2bcd8739ae039.emojiVersion.value);
    set || (set = $8c104cf9ab4badc0$var$$b247ea80b67298d5$export$2e2bcd8739ae039.set.value);
    locale || (locale = $8c104cf9ab4badc0$var$$b247ea80b67298d5$export$2e2bcd8739ae039.locale.value);
    if (!$8c104cf9ab4badc0$export$2d0294657ab35f1b) {
        $8c104cf9ab4badc0$export$2d0294657ab35f1b = (typeof props.data === "function" ? await props.data() : props.data) || await $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$fetchJSON(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/sets/${emojiVersion}/${set}.json`);
        $8c104cf9ab4badc0$export$2d0294657ab35f1b.emoticons = {};
        $8c104cf9ab4badc0$export$2d0294657ab35f1b.natives = {};
        $8c104cf9ab4badc0$export$2d0294657ab35f1b.categories.unshift({
            id: "frequent",
            emojis: []
        });
        for(const alias in $8c104cf9ab4badc0$export$2d0294657ab35f1b.aliases){
            const emojiId = $8c104cf9ab4badc0$export$2d0294657ab35f1b.aliases[alias];
            const emoji = $8c104cf9ab4badc0$export$2d0294657ab35f1b.emojis[emojiId];
            if (!emoji) continue;
            emoji.aliases || (emoji.aliases = []);
            emoji.aliases.push(alias);
        }
        $8c104cf9ab4badc0$export$2d0294657ab35f1b.originalCategories = $8c104cf9ab4badc0$export$2d0294657ab35f1b.categories;
    } else $8c104cf9ab4badc0$export$2d0294657ab35f1b.categories = $8c104cf9ab4badc0$export$2d0294657ab35f1b.categories.filter((c)=>{
        const isCustom = !!c.name;
        if (!isCustom) return true;
        return false;
    });
    $8c104cf9ab4badc0$export$dbe3113d60765c1a = (typeof props.i18n === "function" ? await props.i18n() : props.i18n) || (locale == "en" ? /*@__PURE__*/ $8c104cf9ab4badc0$var$$parcel$interopDefault($8c104cf9ab4badc0$var$$8d50d93417ef682a$exports) : await $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$fetchJSON(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/i18n/${locale}.json`));
    if (props.custom) for(let i in props.custom){
        i = parseInt(i);
        const category = props.custom[i];
        const prevCategory = props.custom[i - 1];
        if (!category.emojis || !category.emojis.length) continue;
        category.id || (category.id = `custom_${i + 1}`);
        category.name || (category.name = $8c104cf9ab4badc0$export$dbe3113d60765c1a.categories.custom);
        if (prevCategory && !category.icon) category.target = prevCategory.target || prevCategory;
        $8c104cf9ab4badc0$export$2d0294657ab35f1b.categories.push(category);
        for (const emoji of category.emojis)$8c104cf9ab4badc0$export$2d0294657ab35f1b.emojis[emoji.id] = emoji;
    }
    if (props.categories) $8c104cf9ab4badc0$export$2d0294657ab35f1b.categories = $8c104cf9ab4badc0$export$2d0294657ab35f1b.originalCategories.filter((c)=>{
        return props.categories.indexOf(c.id) != -1;
    }).sort((c1, c2)=>{
        const i1 = props.categories.indexOf(c1.id);
        const i2 = props.categories.indexOf(c2.id);
        return i1 - i2;
    });
    let latestVersionSupport = null;
    let noCountryFlags = null;
    if (set == "native") {
        latestVersionSupport = $8c104cf9ab4badc0$var$$c84d045dcc34faf5$export$2e2bcd8739ae039.latestVersion();
        noCountryFlags = props.noCountryFlags || $8c104cf9ab4badc0$var$$c84d045dcc34faf5$export$2e2bcd8739ae039.noCountryFlags();
    }
    let categoryIndex = $8c104cf9ab4badc0$export$2d0294657ab35f1b.categories.length;
    let resetSearchIndex = false;
    while(categoryIndex--){
        const category = $8c104cf9ab4badc0$export$2d0294657ab35f1b.categories[categoryIndex];
        if (category.id == "frequent") {
            let { maxFrequentRows: maxFrequentRows, perLine: perLine } = props;
            maxFrequentRows = maxFrequentRows >= 0 ? maxFrequentRows : $8c104cf9ab4badc0$var$$b247ea80b67298d5$export$2e2bcd8739ae039.maxFrequentRows.value;
            perLine || (perLine = $8c104cf9ab4badc0$var$$b247ea80b67298d5$export$2e2bcd8739ae039.perLine.value);
            category.emojis = $8c104cf9ab4badc0$export$d42f766cf4e359f3.get({
                maxFrequentRows: maxFrequentRows,
                perLine: perLine
            });
        }
        if (!category.emojis || !category.emojis.length) {
            $8c104cf9ab4badc0$export$2d0294657ab35f1b.categories.splice(categoryIndex, 1);
            continue;
        }
        const { categoryIcons: categoryIcons } = props;
        if (categoryIcons) {
            const icon = categoryIcons[category.id];
            if (icon && !category.icon) category.icon = icon;
        }
        let emojiIndex = category.emojis.length;
        while(emojiIndex--){
            const emojiId = category.emojis[emojiIndex];
            const emoji = emojiId.id ? emojiId : $8c104cf9ab4badc0$export$2d0294657ab35f1b.emojis[emojiId];
            const ignore = ()=>{
                category.emojis.splice(emojiIndex, 1);
            };
            if (!emoji || props.exceptEmojis && props.exceptEmojis.includes(emoji.id)) {
                ignore();
                continue;
            }
            if (latestVersionSupport && emoji.version > latestVersionSupport) {
                ignore();
                continue;
            }
            if (noCountryFlags && category.id == "flags") {
                if (!$8c104cf9ab4badc0$export$bcb25aa587e9cb13.includes(emoji.id)) {
                    ignore();
                    continue;
                }
            }
            if (!emoji.search) {
                resetSearchIndex = true;
                emoji.search = "," + [
                    [
                        emoji.id,
                        false
                    ],
                    [
                        emoji.name,
                        true
                    ],
                    [
                        emoji.keywords,
                        false
                    ],
                    [
                        emoji.emoticons,
                        false
                    ]
                ].map(([strings, split])=>{
                    if (!strings) return;
                    return (Array.isArray(strings) ? strings : [
                        strings
                    ]).map((string)=>{
                        return (split ? string.split(/[-|_|\s]+/) : [
                            string
                        ]).map((s)=>s.toLowerCase());
                    }).flat();
                }).flat().filter((a)=>a && a.trim()).join(",");
                if (emoji.emoticons) for (const emoticon of emoji.emoticons){
                    if ($8c104cf9ab4badc0$export$2d0294657ab35f1b.emoticons[emoticon]) continue;
                    $8c104cf9ab4badc0$export$2d0294657ab35f1b.emoticons[emoticon] = emoji.id;
                }
                let skinIndex = 0;
                for (const skin of emoji.skins){
                    if (!skin) continue;
                    skinIndex++;
                    const { native: native } = skin;
                    if (native) {
                        $8c104cf9ab4badc0$export$2d0294657ab35f1b.natives[native] = emoji.id;
                        emoji.search += `,${native}`;
                    }
                    const skinShortcodes = skinIndex == 1 ? "" : `:skin-tone-${skinIndex}:`;
                    skin.shortcodes = `:${emoji.id}:${skinShortcodes}`;
                }
            }
        }
    }
    if (resetSearchIndex) $8c104cf9ab4badc0$export$147b480b3694c1f3.reset();
    $8c104cf9ab4badc0$var$$7adb23b0109cc36a$var$initCallback();
}
function $8c104cf9ab4badc0$var$$7adb23b0109cc36a$export$75fe5f91d452f94b(props, defaultProps, element) {
    props || (props = {});
    const _props = {};
    for(let k in defaultProps)_props[k] = $8c104cf9ab4badc0$var$$7adb23b0109cc36a$export$88c9ddb45cea7241(k, props, defaultProps, element);
    return _props;
}
function $8c104cf9ab4badc0$var$$7adb23b0109cc36a$export$88c9ddb45cea7241(propName, props, defaultProps, element) {
    const defaults = defaultProps[propName];
    let value = element && element.getAttribute(propName) || (props[propName] != null && props[propName] != undefined ? props[propName] : null);
    if (!defaults) return value;
    if (value != null && defaults.value && typeof defaults.value != typeof value) {
        if (typeof defaults.value == "boolean") value = value == "false" ? false : true;
        else value = defaults.value.constructor(value);
    }
    if (defaults.transform && value) value = defaults.transform(value);
    if (value == null || defaults.choices && defaults.choices.indexOf(value) == -1) value = defaults.value;
    return value;
}
const $8c104cf9ab4badc0$var$$c4d155af13ad4d4b$var$SHORTCODES_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
let $8c104cf9ab4badc0$var$$c4d155af13ad4d4b$var$Pool = null;
function $8c104cf9ab4badc0$var$$c4d155af13ad4d4b$var$get(emojiId) {
    if (emojiId.id) return emojiId;
    return $8c104cf9ab4badc0$export$2d0294657ab35f1b.emojis[emojiId] || $8c104cf9ab4badc0$export$2d0294657ab35f1b.emojis[$8c104cf9ab4badc0$export$2d0294657ab35f1b.aliases[emojiId]] || $8c104cf9ab4badc0$export$2d0294657ab35f1b.emojis[$8c104cf9ab4badc0$export$2d0294657ab35f1b.natives[emojiId]];
}
function $8c104cf9ab4badc0$var$$c4d155af13ad4d4b$var$reset() {
    $8c104cf9ab4badc0$var$$c4d155af13ad4d4b$var$Pool = null;
}
async function $8c104cf9ab4badc0$var$$c4d155af13ad4d4b$var$search(value, { maxResults: maxResults, caller: caller } = {}) {
    if (!value || !value.trim().length) return null;
    maxResults || (maxResults = 90);
    await $8c104cf9ab4badc0$export$2cd8252107eb640b(null, {
        caller: caller || "SearchIndex.search"
    });
    const values = value.toLowerCase().replace(/(\w)-/, "$1 ").split(/[\s|,]+/).filter((word, i, words)=>{
        return word.trim() && words.indexOf(word) == i;
    });
    if (!values.length) return;
    let pool = $8c104cf9ab4badc0$var$$c4d155af13ad4d4b$var$Pool || ($8c104cf9ab4badc0$var$$c4d155af13ad4d4b$var$Pool = Object.values($8c104cf9ab4badc0$export$2d0294657ab35f1b.emojis));
    let results, scores;
    for (const value1 of values){
        if (!pool.length) break;
        results = [];
        scores = {};
        for (const emoji of pool){
            if (!emoji.search) continue;
            const score = emoji.search.indexOf(`,${value1}`);
            if (score == -1) continue;
            results.push(emoji);
            scores[emoji.id] || (scores[emoji.id] = 0);
            scores[emoji.id] += emoji.id == value1 ? 0 : score + 1;
        }
        pool = results;
    }
    if (results.length < 2) return results;
    results.sort((a, b)=>{
        const aScore = scores[a.id];
        const bScore = scores[b.id];
        if (aScore == bScore) return a.id.localeCompare(b.id);
        return aScore - bScore;
    });
    if (results.length > maxResults) results = results.slice(0, maxResults);
    return results;
}
var $8c104cf9ab4badc0$export$147b480b3694c1f3 = {
    search: $8c104cf9ab4badc0$var$$c4d155af13ad4d4b$var$search,
    get: $8c104cf9ab4badc0$var$$c4d155af13ad4d4b$var$get,
    reset: $8c104cf9ab4badc0$var$$c4d155af13ad4d4b$var$reset,
    SHORTCODES_REGEX: $8c104cf9ab4badc0$var$$c4d155af13ad4d4b$var$SHORTCODES_REGEX
};
const $8c104cf9ab4badc0$export$bcb25aa587e9cb13 = [
    "checkered_flag",
    "crossed_flags",
    "pirate_flag",
    "rainbow-flag",
    "transgender_flag",
    "triangular_flag_on_post",
    "waving_black_flag",
    "waving_white_flag"
];
function $8c104cf9ab4badc0$var$$693b183b0a78708f$export$9cb4719e2e525b7a(a, b) {
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index)=>val == b[index]);
}
async function $8c104cf9ab4badc0$var$$693b183b0a78708f$export$e772c8ff12451969(frames = 1) {
    for(let _ in [
        ...Array(frames).keys()
    ])await new Promise(requestAnimationFrame);
}
function $8c104cf9ab4badc0$var$$693b183b0a78708f$export$d10ac59fbe52a745(emoji, { skinIndex: skinIndex = 0 } = {}) {
    const skin = emoji.skins[skinIndex] || (()=>{
        skinIndex = 0;
        return emoji.skins[skinIndex];
    })();
    const emojiData = {
        id: emoji.id,
        name: emoji.name,
        native: skin.native,
        unified: skin.unified,
        keywords: emoji.keywords,
        shortcodes: skin.shortcodes || emoji.shortcodes
    };
    if (emoji.skins.length > 1) emojiData.skin = skinIndex + 1;
    if (skin.src) emojiData.src = skin.src;
    if (emoji.aliases && emoji.aliases.length) emojiData.aliases = emoji.aliases;
    if (emoji.emoticons && emoji.emoticons.length) emojiData.emoticons = emoji.emoticons;
    return emojiData;
}
async function $8c104cf9ab4badc0$export$5ef5574deca44bc0(nativeString) {
    const results = await $8c104cf9ab4badc0$export$147b480b3694c1f3.search(nativeString, {
        maxResults: 1,
        caller: "getEmojiDataFromNative"
    });
    if (!results || !results.length) return null;
    const emoji = results[0];
    let skinIndex = 0;
    for (let skin of emoji.skins){
        if (skin.native == nativeString) break;
        skinIndex++;
    }
    return $8c104cf9ab4badc0$var$$693b183b0a78708f$export$d10ac59fbe52a745(emoji, {
        skinIndex: skinIndex
    });
}
const $8c104cf9ab4badc0$var$$fcccfb36ed0cde68$var$categories = {
    activity: {
        outline: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
            })
        }),
        solid: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M16.17 337.5c0 44.98 7.565 83.54 13.98 107.9C35.22 464.3 50.46 496 174.9 496c9.566 0 19.59-.4707 29.84-1.271L17.33 307.3C16.53 317.6 16.17 327.7 16.17 337.5zM495.8 174.5c0-44.98-7.565-83.53-13.98-107.9c-4.688-17.54-18.34-31.23-36.04-35.95C435.5 27.91 392.9 16 337 16c-9.564 0-19.59 .4707-29.84 1.271l187.5 187.5C495.5 194.4 495.8 184.3 495.8 174.5zM26.77 248.8l236.3 236.3c142-36.1 203.9-150.4 222.2-221.1L248.9 26.87C106.9 62.96 45.07 177.2 26.77 248.8zM256 335.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L164.7 283.3C161.6 280.2 160 276.1 160 271.1c0-8.529 6.865-16 16-16c4.095 0 8.189 1.562 11.31 4.688l64.01 64C254.4 327.8 256 331.9 256 335.1zM304 287.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L212.7 235.3C209.6 232.2 208 228.1 208 223.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01C302.5 279.8 304 283.9 304 287.1zM256 175.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01c3.125 3.125 4.688 7.219 4.688 11.31c0 9.133-7.468 16-16 16c-4.094 0-8.189-1.562-11.31-4.688l-64.01-64.01C257.6 184.2 256 180.1 256 175.1z"
            })
        })
    },
    custom: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512",
        children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
            d: "M417.1 368c-5.937 10.27-16.69 16-27.75 16c-5.422 0-10.92-1.375-15.97-4.281L256 311.4V448c0 17.67-14.33 32-31.1 32S192 465.7 192 448V311.4l-118.3 68.29C68.67 382.6 63.17 384 57.75 384c-11.06 0-21.81-5.734-27.75-16c-8.828-15.31-3.594-34.88 11.72-43.72L159.1 256L41.72 187.7C26.41 178.9 21.17 159.3 29.1 144C36.63 132.5 49.26 126.7 61.65 128.2C65.78 128.7 69.88 130.1 73.72 132.3L192 200.6V64c0-17.67 14.33-32 32-32S256 46.33 256 64v136.6l118.3-68.29c3.838-2.213 7.939-3.539 12.07-4.051C398.7 126.7 411.4 132.5 417.1 144c8.828 15.31 3.594 34.88-11.72 43.72L288 256l118.3 68.28C421.6 333.1 426.8 352.7 417.1 368z"
        })
    }),
    flags: {
        outline: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
            })
        }),
        solid: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M64 496C64 504.8 56.75 512 48 512h-32C7.25 512 0 504.8 0 496V32c0-17.75 14.25-32 32-32s32 14.25 32 32V496zM476.3 0c-6.365 0-13.01 1.35-19.34 4.233c-45.69 20.86-79.56 27.94-107.8 27.94c-59.96 0-94.81-31.86-163.9-31.87C160.9 .3055 131.6 4.867 96 15.75v350.5c32-9.984 59.87-14.1 84.85-14.1c73.63 0 124.9 31.78 198.6 31.78c31.91 0 68.02-5.971 111.1-23.09C504.1 355.9 512 344.4 512 332.1V30.73C512 11.1 495.3 0 476.3 0z"
            })
        })
    },
    foods: {
        outline: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
            })
        }),
        solid: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M481.9 270.1C490.9 279.1 496 291.3 496 304C496 316.7 490.9 328.9 481.9 337.9C472.9 346.9 460.7 352 448 352H64C51.27 352 39.06 346.9 30.06 337.9C21.06 328.9 16 316.7 16 304C16 291.3 21.06 279.1 30.06 270.1C39.06 261.1 51.27 256 64 256H448C460.7 256 472.9 261.1 481.9 270.1zM475.3 388.7C478.3 391.7 480 395.8 480 400V416C480 432.1 473.3 449.3 461.3 461.3C449.3 473.3 432.1 480 416 480H96C79.03 480 62.75 473.3 50.75 461.3C38.74 449.3 32 432.1 32 416V400C32 395.8 33.69 391.7 36.69 388.7C39.69 385.7 43.76 384 48 384H464C468.2 384 472.3 385.7 475.3 388.7zM50.39 220.8C45.93 218.6 42.03 215.5 38.97 211.6C35.91 207.7 33.79 203.2 32.75 198.4C31.71 193.5 31.8 188.5 32.99 183.7C54.98 97.02 146.5 32 256 32C365.5 32 457 97.02 479 183.7C480.2 188.5 480.3 193.5 479.2 198.4C478.2 203.2 476.1 207.7 473 211.6C469.1 215.5 466.1 218.6 461.6 220.8C457.2 222.9 452.3 224 447.3 224H64.67C59.73 224 54.84 222.9 50.39 220.8zM372.7 116.7C369.7 119.7 368 123.8 368 128C368 131.2 368.9 134.3 370.7 136.9C372.5 139.5 374.1 141.6 377.9 142.8C380.8 143.1 384 144.3 387.1 143.7C390.2 143.1 393.1 141.6 395.3 139.3C397.6 137.1 399.1 134.2 399.7 131.1C400.3 128 399.1 124.8 398.8 121.9C397.6 118.1 395.5 116.5 392.9 114.7C390.3 112.9 387.2 111.1 384 111.1C379.8 111.1 375.7 113.7 372.7 116.7V116.7zM244.7 84.69C241.7 87.69 240 91.76 240 96C240 99.16 240.9 102.3 242.7 104.9C244.5 107.5 246.1 109.6 249.9 110.8C252.8 111.1 256 112.3 259.1 111.7C262.2 111.1 265.1 109.6 267.3 107.3C269.6 105.1 271.1 102.2 271.7 99.12C272.3 96.02 271.1 92.8 270.8 89.88C269.6 86.95 267.5 84.45 264.9 82.7C262.3 80.94 259.2 79.1 256 79.1C251.8 79.1 247.7 81.69 244.7 84.69V84.69zM116.7 116.7C113.7 119.7 112 123.8 112 128C112 131.2 112.9 134.3 114.7 136.9C116.5 139.5 118.1 141.6 121.9 142.8C124.8 143.1 128 144.3 131.1 143.7C134.2 143.1 137.1 141.6 139.3 139.3C141.6 137.1 143.1 134.2 143.7 131.1C144.3 128 143.1 124.8 142.8 121.9C141.6 118.1 139.5 116.5 136.9 114.7C134.3 112.9 131.2 111.1 128 111.1C123.8 111.1 119.7 113.7 116.7 116.7L116.7 116.7z"
            })
        })
    },
    frequent: {
        outline: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
                }),
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
                })
            ]
        }),
        solid: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z"
            })
        })
    },
    nature: {
        outline: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
                }),
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
                })
            ]
        }),
        solid: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 576 512",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M332.7 19.85C334.6 8.395 344.5 0 356.1 0C363.6 0 370.6 3.52 375.1 9.502L392 32H444.1C456.8 32 469.1 37.06 478.1 46.06L496 64H552C565.3 64 576 74.75 576 88V112C576 156.2 540.2 192 496 192H426.7L421.6 222.5L309.6 158.5L332.7 19.85zM448 64C439.2 64 432 71.16 432 80C432 88.84 439.2 96 448 96C456.8 96 464 88.84 464 80C464 71.16 456.8 64 448 64zM416 256.1V480C416 497.7 401.7 512 384 512H352C334.3 512 320 497.7 320 480V364.8C295.1 377.1 268.8 384 240 384C211.2 384 184 377.1 160 364.8V480C160 497.7 145.7 512 128 512H96C78.33 512 64 497.7 64 480V249.8C35.23 238.9 12.64 214.5 4.836 183.3L.9558 167.8C-3.331 150.6 7.094 133.2 24.24 128.1C41.38 124.7 58.76 135.1 63.05 152.2L66.93 167.8C70.49 182 83.29 191.1 97.97 191.1H303.8L416 256.1z"
            })
        })
    },
    objects: {
        outline: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
                }),
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
                })
            ]
        }),
        solid: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 384 512",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M112.1 454.3c0 6.297 1.816 12.44 5.284 17.69l17.14 25.69c5.25 7.875 17.17 14.28 26.64 14.28h61.67c9.438 0 21.36-6.401 26.61-14.28l17.08-25.68c2.938-4.438 5.348-12.37 5.348-17.7L272 415.1h-160L112.1 454.3zM191.4 .0132C89.44 .3257 16 82.97 16 175.1c0 44.38 16.44 84.84 43.56 115.8c16.53 18.84 42.34 58.23 52.22 91.45c.0313 .25 .0938 .5166 .125 .7823h160.2c.0313-.2656 .0938-.5166 .125-.7823c9.875-33.22 35.69-72.61 52.22-91.45C351.6 260.8 368 220.4 368 175.1C368 78.61 288.9-.2837 191.4 .0132zM192 96.01c-44.13 0-80 35.89-80 79.1C112 184.8 104.8 192 96 192S80 184.8 80 176c0-61.76 50.25-111.1 112-111.1c8.844 0 16 7.159 16 16S200.8 96.01 192 96.01z"
            })
        })
    },
    people: {
        outline: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
                }),
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
                })
            ]
        }),
        solid: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 432C332.1 432 396.2 382 415.2 314.1C419.1 300.4 407.8 288 393.6 288H118.4C104.2 288 92.92 300.4 96.76 314.1C115.8 382 179.9 432 256 432V432zM176.4 160C158.7 160 144.4 174.3 144.4 192C144.4 209.7 158.7 224 176.4 224C194 224 208.4 209.7 208.4 192C208.4 174.3 194 160 176.4 160zM336.4 224C354 224 368.4 209.7 368.4 192C368.4 174.3 354 160 336.4 160C318.7 160 304.4 174.3 304.4 192C304.4 209.7 318.7 224 336.4 224z"
            })
        })
    },
    places: {
        outline: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: [
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
                }),
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                    d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
                })
            ]
        }),
        solid: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M39.61 196.8L74.8 96.29C88.27 57.78 124.6 32 165.4 32H346.6C387.4 32 423.7 57.78 437.2 96.29L472.4 196.8C495.6 206.4 512 229.3 512 256V448C512 465.7 497.7 480 480 480H448C430.3 480 416 465.7 416 448V400H96V448C96 465.7 81.67 480 64 480H32C14.33 480 0 465.7 0 448V256C0 229.3 16.36 206.4 39.61 196.8V196.8zM109.1 192H402.9L376.8 117.4C372.3 104.6 360.2 96 346.6 96H165.4C151.8 96 139.7 104.6 135.2 117.4L109.1 192zM96 256C78.33 256 64 270.3 64 288C64 305.7 78.33 320 96 320C113.7 320 128 305.7 128 288C128 270.3 113.7 256 96 256zM416 320C433.7 320 448 305.7 448 288C448 270.3 433.7 256 416 256C398.3 256 384 270.3 384 288C384 305.7 398.3 320 416 320z"
            })
        })
    },
    symbols: {
        outline: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
            })
        }),
        solid: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
                d: "M500.3 7.251C507.7 13.33 512 22.41 512 31.1V175.1C512 202.5 483.3 223.1 447.1 223.1C412.7 223.1 383.1 202.5 383.1 175.1C383.1 149.5 412.7 127.1 447.1 127.1V71.03L351.1 90.23V207.1C351.1 234.5 323.3 255.1 287.1 255.1C252.7 255.1 223.1 234.5 223.1 207.1C223.1 181.5 252.7 159.1 287.1 159.1V63.1C287.1 48.74 298.8 35.61 313.7 32.62L473.7 .6198C483.1-1.261 492.9 1.173 500.3 7.251H500.3zM74.66 303.1L86.5 286.2C92.43 277.3 102.4 271.1 113.1 271.1H174.9C185.6 271.1 195.6 277.3 201.5 286.2L213.3 303.1H239.1C266.5 303.1 287.1 325.5 287.1 351.1V463.1C287.1 490.5 266.5 511.1 239.1 511.1H47.1C21.49 511.1-.0019 490.5-.0019 463.1V351.1C-.0019 325.5 21.49 303.1 47.1 303.1H74.66zM143.1 359.1C117.5 359.1 95.1 381.5 95.1 407.1C95.1 434.5 117.5 455.1 143.1 455.1C170.5 455.1 191.1 434.5 191.1 407.1C191.1 381.5 170.5 359.1 143.1 359.1zM440.3 367.1H496C502.7 367.1 508.6 372.1 510.1 378.4C513.3 384.6 511.6 391.7 506.5 396L378.5 508C372.9 512.1 364.6 513.3 358.6 508.9C352.6 504.6 350.3 496.6 353.3 489.7L391.7 399.1H336C329.3 399.1 323.4 395.9 321 389.6C318.7 383.4 320.4 376.3 325.5 371.1L453.5 259.1C459.1 255 467.4 254.7 473.4 259.1C479.4 263.4 481.6 271.4 478.7 278.3L440.3 367.1zM116.7 219.1L19.85 119.2C-8.112 90.26-6.614 42.31 24.85 15.34C51.82-8.137 93.26-3.642 118.2 21.83L128.2 32.32L137.7 21.83C162.7-3.642 203.6-8.137 231.6 15.34C262.6 42.31 264.1 90.26 236.1 119.2L139.7 219.1C133.2 225.6 122.7 225.6 116.7 219.1H116.7z"
            })
        })
    }
};
const $8c104cf9ab4badc0$var$$fcccfb36ed0cde68$var$search = {
    loupe: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
            d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
        })
    }),
    delete: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("path", {
            d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
        })
    })
};
var $8c104cf9ab4badc0$var$$fcccfb36ed0cde68$export$2e2bcd8739ae039 = {
    categories: $8c104cf9ab4badc0$var$$fcccfb36ed0cde68$var$categories,
    search: $8c104cf9ab4badc0$var$$fcccfb36ed0cde68$var$search
};
function $8c104cf9ab4badc0$var$$254755d3f438722f$export$2e2bcd8739ae039(props) {
    let { id: id, skin: skin, emoji: emoji } = props;
    if (props.shortcodes) {
        const matches = props.shortcodes.match($8c104cf9ab4badc0$export$147b480b3694c1f3.SHORTCODES_REGEX);
        if (matches) {
            id = matches[1];
            if (matches[2]) skin = matches[2];
        }
    }
    emoji || (emoji = $8c104cf9ab4badc0$export$147b480b3694c1f3.get(id || props.native));
    if (!emoji) return props.fallback;
    const emojiSkin = emoji.skins[skin - 1] || emoji.skins[0];
    const imageSrc = emojiSkin.src || (props.set != "native" && !props.spritesheet ? typeof props.getImageURL === "function" ? props.getImageURL(props.set, emojiSkin.unified) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${props.set}@15.0.1/img/${props.set}/64/${emojiSkin.unified}.png` : undefined);
    const spritesheetSrc = typeof props.getSpritesheetURL === "function" ? props.getSpritesheetURL(props.set) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${props.set}@15.0.1/img/${props.set}/sheets-256/64.png`;
    return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
        class: "emoji-mart-emoji",
        "data-emoji-set": props.set,
        children: imageSrc ? $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("img", {
            style: {
                maxWidth: props.size || "1em",
                maxHeight: props.size || "1em",
                display: "inline-block"
            },
            alt: emojiSkin.native || emojiSkin.shortcodes,
            src: imageSrc
        }) : props.set == "native" ? $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
            style: {
                fontSize: props.size,
                fontFamily: '"EmojiMart", "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "Android Emoji"'
            },
            children: emojiSkin.native
        }) : $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
            style: {
                display: "block",
                width: props.size,
                height: props.size,
                backgroundImage: `url(${spritesheetSrc})`,
                backgroundSize: `${100 * $8c104cf9ab4badc0$export$2d0294657ab35f1b.sheet.cols}% ${100 * $8c104cf9ab4badc0$export$2d0294657ab35f1b.sheet.rows}%`,
                backgroundPosition: `${100 / ($8c104cf9ab4badc0$export$2d0294657ab35f1b.sheet.cols - 1) * emojiSkin.x}% ${100 / ($8c104cf9ab4badc0$export$2d0294657ab35f1b.sheet.rows - 1) * emojiSkin.y}%`
            }
        })
    });
}
const $8c104cf9ab4badc0$var$$6f57cc9cd54c5aaa$var$WindowHTMLElement = typeof window !== "undefined" && window.HTMLElement ? window.HTMLElement : Object;
class $8c104cf9ab4badc0$var$$6f57cc9cd54c5aaa$export$2e2bcd8739ae039 extends $8c104cf9ab4badc0$var$$6f57cc9cd54c5aaa$var$WindowHTMLElement {
    static get observedAttributes() {
        return Object.keys(this.Props);
    }
    update(props = {}) {
        for(let k in props)this.attributeChangedCallback(k, null, props[k]);
    }
    attributeChangedCallback(attr, _, newValue) {
        if (!this.component) return;
        const value = $8c104cf9ab4badc0$var$$7adb23b0109cc36a$export$88c9ddb45cea7241(attr, {
            [attr]: newValue
        }, this.constructor.Props, this);
        if (this.component.componentWillReceiveProps) this.component.componentWillReceiveProps({
            [attr]: value
        });
        else {
            this.component.props[attr] = value;
            this.component.forceUpdate();
        }
    }
    disconnectedCallback() {
        this.disconnected = true;
        if (this.component && this.component.unregister) this.component.unregister();
    }
    constructor(props = {}){
        super();
        this.props = props;
        if (props.parent || props.ref) {
            let ref = null;
            const parent = props.parent || (ref = props.ref && props.ref.current);
            if (ref) ref.innerHTML = "";
            if (parent) parent.appendChild(this);
        }
    }
}
class $8c104cf9ab4badc0$var$$26f27c338a96b1a6$export$2e2bcd8739ae039 extends $8c104cf9ab4badc0$var$$6f57cc9cd54c5aaa$export$2e2bcd8739ae039 {
    setShadow() {
        this.attachShadow({
            mode: "open"
        });
    }
    injectStyles(styles) {
        if (!styles) return;
        const style = document.createElement("style");
        style.textContent = styles;
        this.shadowRoot.insertBefore(style, this.shadowRoot.firstChild);
    }
    constructor(props, { styles: styles } = {}){
        super(props);
        this.setShadow();
        this.injectStyles(styles);
    }
}
var $8c104cf9ab4badc0$var$$3d90f6e46fb2dd47$export$2e2bcd8739ae039 = {
    fallback: "",
    id: "",
    native: "",
    shortcodes: "",
    size: {
        value: "",
        transform: (value)=>{
            // If the value is a number, then we assume it’s a pixel value.
            if (!/\D/.test(value)) return `${value}px`;
            return value;
        }
    },
    // Shared
    set: $8c104cf9ab4badc0$var$$b247ea80b67298d5$export$2e2bcd8739ae039.set,
    skin: $8c104cf9ab4badc0$var$$b247ea80b67298d5$export$2e2bcd8739ae039.skin
};
class $8c104cf9ab4badc0$export$56cc48506ff790a extends $8c104cf9ab4badc0$var$$6f57cc9cd54c5aaa$export$2e2bcd8739ae039 {
    async connectedCallback() {
        const props = $8c104cf9ab4badc0$var$$7adb23b0109cc36a$export$75fe5f91d452f94b(this.props, $8c104cf9ab4badc0$var$$3d90f6e46fb2dd47$export$2e2bcd8739ae039, this);
        props.element = this;
        props.ref = (component)=>{
            this.component = component;
        };
        await $8c104cf9ab4badc0$export$2cd8252107eb640b();
        if (this.disconnected) return;
        $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99($8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b($8c104cf9ab4badc0$var$$254755d3f438722f$export$2e2bcd8739ae039, {
            ...props
        }), this);
    }
    constructor(props){
        super(props);
    }
}
$8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039($8c104cf9ab4badc0$export$56cc48506ff790a, "Props", $8c104cf9ab4badc0$var$$3d90f6e46fb2dd47$export$2e2bcd8739ae039);
if (typeof customElements !== "undefined" && !customElements.get("em-emoji")) customElements.define("em-emoji", $8c104cf9ab4badc0$export$56cc48506ff790a);
var $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$t, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$r, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$o = 0, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$i = [], $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$c = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__b, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$f = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__r, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$e = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.diffed, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$a = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__c, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$v = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount;
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$m(t1, r1) {
    $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__h && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__h($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u, t1, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$o || r1), $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$o = 0;
    var i1 = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u.__H || ($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u.__H = {
        __: [],
        __h: []
    });
    return t1 >= i1.__.length && i1.__.push({}), i1.__[t1];
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$60241385465d0a34(n1) {
    return $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$o = 1, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$13e3392192263954($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$w, n1);
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$13e3392192263954(n2, r2, o1) {
    var i2 = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$m($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$t++, 2);
    return i2.t = n2, i2.__c || (i2.__ = [
        o1 ? o1(r2) : $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$w(void 0, r2),
        function(n3) {
            var t2 = i2.t(i2.__[0], n3);
            i2.__[0] !== t2 && (i2.__ = [
                t2,
                i2.__[1]
            ], i2.__c.setState({}));
        }
    ], i2.__c = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u), i2.__;
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$6d9c69b0de29b591(r3, o2) {
    var i3 = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$m($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$t++, 3);
    !$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__s && $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$k(i3.__H, o2) && (i3.__ = r3, i3.__H = o2, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u.__H.__h.push(i3));
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$e5c5a5f917a5871c(r4, o3) {
    var i4 = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$m($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$t++, 4);
    !$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__s && $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$k(i4.__H, o3) && (i4.__ = r4, i4.__H = o3, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u.__h.push(i4));
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$b8f5890fc79d6aca(n4) {
    return $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$o = 5, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$1538c33de8887b59(function() {
        return {
            current: n4
        };
    }, []);
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$d5a552a76deda3c2(n5, t3, u1) {
    $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$o = 6, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$e5c5a5f917a5871c(function() {
        "function" == typeof n5 ? n5(t3()) : n5 && (n5.current = t3());
    }, null == u1 ? u1 : u1.concat(n5));
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$1538c33de8887b59(n6, u2) {
    var r5 = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$m($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$t++, 7);
    return $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$k(r5.__H, u2) && (r5.__ = n6(), r5.__H = u2, r5.__h = n6), r5.__;
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$35808ee640e87ca7(n7, t4) {
    return $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$o = 8, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$1538c33de8887b59(function() {
        return n7;
    }, t4);
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$fae74005e78b1a27(n8) {
    var r6 = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u.context[n8.__c], o4 = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$m($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$t++, 9);
    return o4.c = n8, r6 ? (null == o4.__ && (o4.__ = !0, r6.sub($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u)), r6.props.value) : n8.__;
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$dc8fbce3eb94dc1e(t5, u3) {
    $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.useDebugValue && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.useDebugValue(u3 ? u3(t5) : t5);
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$c052f6604b7d51fe(n9) {
    var r7 = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$m($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$t++, 10), o5 = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$60241385465d0a34();
    return r7.__ = n9, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u.componentDidCatch || ($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u.componentDidCatch = function(n10) {
        r7.__ && r7.__(n10), o5[1](n10);
    }), [
        o5[0],
        function() {
            o5[1](void 0);
        }
    ];
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$x() {
    var t6;
    for($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$i.sort(function(n11, t7) {
        return n11.__v.__b - t7.__v.__b;
    }); t6 = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$i.pop();)if (t6.__P) try {
        t6.__H.__h.forEach($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$g), t6.__H.__h.forEach($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$j), t6.__H.__h = [];
    } catch (u4) {
        t6.__H.__h = [], $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(u4, t6.__v);
    }
}
$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__b = function(n12) {
    $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u = null, $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$c && $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$c(n12);
}, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__r = function(n13) {
    $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$f && $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$f(n13), $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$t = 0;
    var r8 = ($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u = n13.__c).__H;
    r8 && (r8.__h.forEach($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$g), r8.__h.forEach($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$j), r8.__h = []);
}, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.diffed = function(t8) {
    $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$e && $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$e(t8);
    var o6 = t8.__c;
    o6 && o6.__H && o6.__H.__h.length && (1 !== $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$i.push(o6) && $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$r === $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.requestAnimationFrame || (($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$r = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.requestAnimationFrame) || function(n14) {
        var t9, u5 = function() {
            clearTimeout(r9), $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$b && cancelAnimationFrame(t9), setTimeout(n14);
        }, r9 = setTimeout(u5, 100);
        $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$b && (t9 = requestAnimationFrame(u5));
    })($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$x)), $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u = null;
}, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__c = function(t10, u6) {
    u6.some(function(t11) {
        try {
            t11.__h.forEach($8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$g), t11.__h = t11.__h.filter(function(n15) {
                return !n15.__ || $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$j(n15);
            });
        } catch (r10) {
            u6.some(function(n16) {
                n16.__h && (n16.__h = []);
            }), u6 = [], $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(r10, t11.__v);
        }
    }), $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$a && $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$a(t10, u6);
}, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount = function(t12) {
    $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$v && $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$v(t12);
    var u7, r11 = t12.__c;
    r11 && r11.__H && (r11.__H.__.forEach(function(n17) {
        try {
            $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$g(n17);
        } catch (n18) {
            u7 = n18;
        }
    }), u7 && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(u7, r11.__v));
};
var $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$b = "function" == typeof requestAnimationFrame;
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$g(n19) {
    var t13 = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u, r12 = n19.__c;
    "function" == typeof r12 && (n19.__c = void 0, r12()), $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u = t13;
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$j(n20) {
    var t14 = $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u;
    n20.__c = n20.__(), $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$u = t14;
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$k(n21, t15) {
    return !n21 || n21.length !== t15.length || t15.some(function(t16, u8) {
        return t16 !== n21[u8];
    });
}
function $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$var$w(n22, t17) {
    return "function" == typeof t17 ? t17(n22) : t17;
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$var$S(n1, t1) {
    for(var e1 in t1)n1[e1] = t1[e1];
    return n1;
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$var$C(n2, t2) {
    for(var e2 in n2)if ("__source" !== e2 && !(e2 in t2)) return !0;
    for(var r1 in t2)if ("__source" !== r1 && n2[r1] !== t2[r1]) return !0;
    return !1;
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$221d75b3f55bb0bd(n3) {
    this.props = n3;
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$7c73462e0d25e514(n4, t3) {
    function e3(n5) {
        var e4 = this.props.ref, r3 = e4 == n5.ref;
        return !r3 && e4 && (e4.call ? e4(null) : e4.current = null), t3 ? !t3(this.props, n5) || !r3 : $8c104cf9ab4badc0$var$$dc040a17866866fa$var$C(this.props, n5);
    }
    function r2(t4) {
        return this.shouldComponentUpdate = e3, $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d(n4, t4);
    }
    return r2.displayName = "Memo(" + (n4.displayName || n4.name) + ")", r2.prototype.isReactComponent = !0, r2.__f = !0, r2;
}
($8c104cf9ab4badc0$var$$dc040a17866866fa$export$221d75b3f55bb0bd.prototype = new $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8).isPureReactComponent = !0, $8c104cf9ab4badc0$var$$dc040a17866866fa$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n6, t5) {
    return $8c104cf9ab4badc0$var$$dc040a17866866fa$var$C(this.props, n6) || $8c104cf9ab4badc0$var$$dc040a17866866fa$var$C(this.state, t5);
};
var $8c104cf9ab4badc0$var$$dc040a17866866fa$var$w = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__b;
$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__b = function(n7) {
    n7.type && n7.type.__f && n7.ref && (n7.props.ref = n7.ref, n7.ref = null), $8c104cf9ab4badc0$var$$dc040a17866866fa$var$w && $8c104cf9ab4badc0$var$$dc040a17866866fa$var$w(n7);
};
var $8c104cf9ab4badc0$var$$dc040a17866866fa$var$R = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$257a8862b851cb5b(n8) {
    function t6(t7, e5) {
        var r4 = $8c104cf9ab4badc0$var$$dc040a17866866fa$var$S({}, t7);
        return delete r4.ref, n8(r4, (e5 = t7.ref || e5) && ("object" != typeof e5 || "current" in e5) ? e5 : null);
    }
    return t6.$$typeof = $8c104cf9ab4badc0$var$$dc040a17866866fa$var$R, t6.render = t6, t6.prototype.isReactComponent = t6.__f = !0, t6.displayName = "ForwardRef(" + (n8.displayName || n8.name) + ")", t6;
}
var $8c104cf9ab4badc0$var$$dc040a17866866fa$var$N = function(n9, t8) {
    return null == n9 ? null : $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$47e4c5b300681277($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$47e4c5b300681277(n9).map(t8));
}, $8c104cf9ab4badc0$var$$dc040a17866866fa$export$dca3b0875bd9a954 = {
    map: $8c104cf9ab4badc0$var$$dc040a17866866fa$var$N,
    forEach: $8c104cf9ab4badc0$var$$dc040a17866866fa$var$N,
    count: function(n10) {
        return n10 ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$47e4c5b300681277(n10).length : 0;
    },
    only: function(n11) {
        var t9 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$47e4c5b300681277(n11);
        if (1 !== t9.length) throw "Children.only";
        return t9[0];
    },
    toArray: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$47e4c5b300681277
}, $8c104cf9ab4badc0$var$$dc040a17866866fa$var$A = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e;
$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__e = function(n12, t10, e6) {
    if (n12.then) {
        for(var r5, u1 = t10; u1 = u1.__;)if ((r5 = u1.__c) && r5.__c) return null == t10.__e && (t10.__e = e6.__e, t10.__k = e6.__k), r5.__c(n12, t10);
    }
    $8c104cf9ab4badc0$var$$dc040a17866866fa$var$A(n12, t10, e6);
};
var $8c104cf9ab4badc0$var$$dc040a17866866fa$var$O = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount;
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$var$U(n13) {
    var t11 = n13.__.__c;
    return t11 && t11.__e && t11.__e(n13);
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$488013bae63b21da(n14) {
    var t12, e7, r6;
    function u2(u3) {
        if (t12 || (t12 = n14()).then(function(n15) {
            e7 = n15.default || n15;
        }, function(n16) {
            r6 = n16;
        }), r6) throw r6;
        if (!e7) throw t12;
        return $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d(e7, u3);
    }
    return u2.displayName = "Lazy", u2.__f = !0, u2;
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount = function(n17) {
    var t13 = n17.__c;
    t13 && t13.__R && t13.__R(), t13 && !0 === n17.__h && (n17.type = null), $8c104cf9ab4badc0$var$$dc040a17866866fa$var$O && $8c104cf9ab4badc0$var$$dc040a17866866fa$var$O(n17);
}, ($8c104cf9ab4badc0$var$$dc040a17866866fa$export$74bf444e3cd11ea5.prototype = new $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8).__c = function(n18, t14) {
    var e8 = t14.__c, r7 = this;
    null == r7.t && (r7.t = []), r7.t.push(e8);
    var u4 = $8c104cf9ab4badc0$var$$dc040a17866866fa$var$U(r7.__v), o1 = !1, i1 = function() {
        o1 || (o1 = !0, e8.__R = null, u4 ? u4(l1) : l1());
    };
    e8.__R = i1;
    var l1 = function() {
        if (!--r7.__u) {
            if (r7.state.__e) {
                var n19 = r7.state.__e;
                r7.__v.__k[0] = function n22(t17, e9, r8) {
                    return t17 && (t17.__v = null, t17.__k = t17.__k && t17.__k.map(function(t18) {
                        return n22(t18, e9, r8);
                    }), t17.__c && t17.__c.__P === e9 && (t17.__e && r8.insertBefore(t17.__e, t17.__d), t17.__c.__e = !0, t17.__c.__P = r8)), t17;
                }(n19, n19.__c.__P, n19.__c.__O);
            }
            var t15;
            for(r7.setState({
                __e: r7.__b = null
            }); t15 = r7.t.pop();)t15.forceUpdate();
        }
    }, c1 = !0 === t14.__h;
    r7.__u++ || c1 || r7.setState({
        __e: r7.__b = r7.__v.__k[0]
    }), n18.then(i1, i1);
}, $8c104cf9ab4badc0$var$$dc040a17866866fa$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $8c104cf9ab4badc0$var$$dc040a17866866fa$export$74bf444e3cd11ea5.prototype.render = function(n23, t19) {
    if (this.__b) {
        if (this.__v.__k) {
            var e10 = document.createElement("div"), r9 = this.__v.__k[0].__c;
            this.__v.__k[0] = function n24(t20, e13, r12) {
                return t20 && (t20.__c && t20.__c.__H && (t20.__c.__H.__.forEach(function(n25) {
                    "function" == typeof n25.__c && n25.__c();
                }), t20.__c.__H = null), null != (t20 = $8c104cf9ab4badc0$var$$dc040a17866866fa$var$S({}, t20)).__c && (t20.__c.__P === r12 && (t20.__c.__P = e13), t20.__c = null), t20.__k = t20.__k && t20.__k.map(function(t21) {
                    return n24(t21, e13, r12);
                })), t20;
            }(this.__b, e10, r9.__O = r9.__P);
        }
        this.__b = null;
    }
    var u5 = t19.__e && $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$ffb0004e005737fa, null, n23.fallback);
    return u5 && (u5.__h = null), [
        $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$ffb0004e005737fa, null, t19.__e ? null : n23.children),
        u5
    ];
};
var $8c104cf9ab4badc0$var$$dc040a17866866fa$var$T = function(n26, t22, e14) {
    if (++e14[1] === e14[0] && n26.o.delete(t22), n26.props.revealOrder && ("t" !== n26.props.revealOrder[0] || !n26.o.size)) for(e14 = n26.u; e14;){
        for(; e14.length > 3;)e14.pop()();
        if (e14[1] < e14[0]) break;
        n26.u = e14 = e14[2];
    }
};
function $8c104cf9ab4badc0$var$$dc040a17866866fa$var$D(n27) {
    return this.getChildContext = function() {
        return n27.context;
    }, n27.children;
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$var$I(n28) {
    var t23 = this, e15 = n28.i;
    t23.componentWillUnmount = function() {
        $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99(null, t23.l), t23.l = null, t23.i = null;
    }, t23.i && t23.i !== e15 && t23.componentWillUnmount(), n28.__v ? (t23.l || (t23.i = e15, t23.l = {
        nodeType: 1,
        parentNode: e15,
        childNodes: [],
        appendChild: function(n29) {
            this.childNodes.push(n29), t23.i.appendChild(n29);
        },
        insertBefore: function(n30, e) {
            this.childNodes.push(n30), t23.i.appendChild(n30);
        },
        removeChild: function(n31) {
            this.childNodes.splice(this.childNodes.indexOf(n31) >>> 1, 1), t23.i.removeChild(n31);
        }
    }), $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d($8c104cf9ab4badc0$var$$dc040a17866866fa$var$D, {
        context: t23.context
    }, n28.__v), t23.l)) : t23.l && t23.componentWillUnmount();
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$d39a5bbd09211389(n32, t24) {
    return $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d($8c104cf9ab4badc0$var$$dc040a17866866fa$var$I, {
        __v: n32,
        i: t24
    });
}
($8c104cf9ab4badc0$var$$dc040a17866866fa$export$998bcd577473dd93.prototype = new $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8).__e = function(n33) {
    var t25 = this, e16 = $8c104cf9ab4badc0$var$$dc040a17866866fa$var$U(t25.__v), r13 = t25.o.get(n33);
    return r13[0]++, function(u6) {
        var o2 = function() {
            t25.props.revealOrder ? (r13.push(u6), $8c104cf9ab4badc0$var$$dc040a17866866fa$var$T(t25, n33, r13)) : u6();
        };
        e16 ? e16(o2) : o2();
    };
}, $8c104cf9ab4badc0$var$$dc040a17866866fa$export$998bcd577473dd93.prototype.render = function(n34) {
    this.u = null, this.o = new Map;
    var t26 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$47e4c5b300681277(n34.children);
    n34.revealOrder && "b" === n34.revealOrder[0] && t26.reverse();
    for(var e17 = t26.length; e17--;)this.o.set(t26[e17], this.u = [
        1,
        0,
        this.u
    ]);
    return n34.children;
}, $8c104cf9ab4badc0$var$$dc040a17866866fa$export$998bcd577473dd93.prototype.componentDidUpdate = $8c104cf9ab4badc0$var$$dc040a17866866fa$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n35 = this;
    this.o.forEach(function(t27, e18) {
        $8c104cf9ab4badc0$var$$dc040a17866866fa$var$T(n35, e18, t27);
    });
};
var $8c104cf9ab4badc0$var$$dc040a17866866fa$var$j = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $8c104cf9ab4badc0$var$$dc040a17866866fa$var$P = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $8c104cf9ab4badc0$var$$dc040a17866866fa$var$V = "undefined" != typeof document, $8c104cf9ab4badc0$var$$dc040a17866866fa$var$z = function(n36) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n36);
};
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$b3890eb0ae9dca99(n37, t28, e19) {
    return null == t28.__k && (t28.textContent = ""), $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99(n37, t28), "function" == typeof e19 && e19(), n37 ? n37.__c : null;
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$fa8d919ba61d84db(n38, t29, e20) {
    return $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$fa8d919ba61d84db(n38, t29), "function" == typeof e20 && e20(), n38 ? n38.__c : null;
}
$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(n39) {
    Object.defineProperty($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype, n39, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + n39];
        },
        set: function(t30) {
            Object.defineProperty(this, n39, {
                configurable: !0,
                writable: !0,
                value: t30
            });
        }
    });
});
var $8c104cf9ab4badc0$var$$dc040a17866866fa$var$H = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.event;
function $8c104cf9ab4badc0$var$$dc040a17866866fa$var$Z() {}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$var$Y() {
    return this.cancelBubble;
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$var$q() {
    return this.defaultPrevented;
}
$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.event = function(n40) {
    return $8c104cf9ab4badc0$var$$dc040a17866866fa$var$H && (n40 = $8c104cf9ab4badc0$var$$dc040a17866866fa$var$H(n40)), n40.persist = $8c104cf9ab4badc0$var$$dc040a17866866fa$var$Z, n40.isPropagationStopped = $8c104cf9ab4badc0$var$$dc040a17866866fa$var$Y, n40.isDefaultPrevented = $8c104cf9ab4badc0$var$$dc040a17866866fa$var$q, n40.nativeEvent = n40;
};
var $8c104cf9ab4badc0$var$$dc040a17866866fa$var$G, $8c104cf9ab4badc0$var$$dc040a17866866fa$var$J = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $8c104cf9ab4badc0$var$$dc040a17866866fa$var$K = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode;
$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode = function(n41) {
    var t31 = n41.type, e21 = n41.props, r14 = e21;
    if ("string" == typeof t31) {
        var u7 = -1 === t31.indexOf("-");
        for(var o3 in r14 = {}, e21){
            var i2 = e21[o3];
            $8c104cf9ab4badc0$var$$dc040a17866866fa$var$V && "children" === o3 && "noscript" === t31 || "value" === o3 && "defaultValue" in e21 && null == i2 || ("defaultValue" === o3 && "value" in e21 && null == e21.value ? o3 = "value" : "download" === o3 && !0 === i2 ? i2 = "" : /ondoubleclick/i.test(o3) ? o3 = "ondblclick" : /^onchange(textarea|input)/i.test(o3 + t31) && !$8c104cf9ab4badc0$var$$dc040a17866866fa$var$z(e21.type) ? o3 = "oninput" : /^onfocus$/i.test(o3) ? o3 = "onfocusin" : /^onblur$/i.test(o3) ? o3 = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp)/.test(o3) ? o3 = o3.toLowerCase() : u7 && $8c104cf9ab4badc0$var$$dc040a17866866fa$var$P.test(o3) ? o3 = o3.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === i2 && (i2 = void 0), r14[o3] = i2);
        }
        "select" == t31 && r14.multiple && Array.isArray(r14.value) && (r14.value = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$47e4c5b300681277(e21.children).forEach(function(n42) {
            n42.props.selected = -1 != r14.value.indexOf(n42.props.value);
        })), "select" == t31 && null != r14.defaultValue && (r14.value = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$47e4c5b300681277(e21.children).forEach(function(n43) {
            n43.props.selected = r14.multiple ? -1 != r14.defaultValue.indexOf(n43.props.value) : r14.defaultValue == n43.props.value;
        })), n41.props = r14, e21.class != e21.className && ($8c104cf9ab4badc0$var$$dc040a17866866fa$var$J.enumerable = "className" in e21, null != e21.className && (r14.class = e21.className), Object.defineProperty(r14, "className", $8c104cf9ab4badc0$var$$dc040a17866866fa$var$J));
    }
    n41.$$typeof = $8c104cf9ab4badc0$var$$dc040a17866866fa$var$j, $8c104cf9ab4badc0$var$$dc040a17866866fa$var$K && $8c104cf9ab4badc0$var$$dc040a17866866fa$var$K(n41);
};
var $8c104cf9ab4badc0$var$$dc040a17866866fa$var$Q = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__r;
$8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$41c562ebe57d11e2.__r = function(n44) {
    $8c104cf9ab4badc0$var$$dc040a17866866fa$var$Q && $8c104cf9ab4badc0$var$$dc040a17866866fa$var$Q(n44), $8c104cf9ab4badc0$var$$dc040a17866866fa$var$G = n44.__c;
};
var $8c104cf9ab4badc0$var$$dc040a17866866fa$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n45) {
                return $8c104cf9ab4badc0$var$$dc040a17866866fa$var$G.__n[n45.__c].props.value;
            }
        }
    }
}, $8c104cf9ab4badc0$var$$dc040a17866866fa$export$83d89fbfd8236492 = "17.0.2";
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$d38cd72104c1f0e9(n46) {
    return $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d.bind(null, n46);
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$a8257692ac88316c(n47) {
    return !!n47 && n47.$$typeof === $8c104cf9ab4badc0$var$$dc040a17866866fa$var$j;
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$e530037191fcd5d7(n48) {
    return $8c104cf9ab4badc0$var$$dc040a17866866fa$export$a8257692ac88316c(n48) ? $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$e530037191fcd5d7.apply(null, arguments) : n48;
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$502457920280e6be(n49) {
    return !!n49.__k && ($8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99(null, n49), !0);
}
function $8c104cf9ab4badc0$var$$dc040a17866866fa$export$466bfc07425424d5(n50) {
    return n50 && (n50.base || 1 === n50.nodeType && n50) || null;
}
var $8c104cf9ab4badc0$var$$dc040a17866866fa$export$c78a37762a8d58e1 = function(n51, t32) {
    return n51(t32);
}, $8c104cf9ab4badc0$var$$dc040a17866866fa$export$cd75ccfd720a3cd4 = function(n52, t33) {
    return n52(t33);
}, $8c104cf9ab4badc0$var$$dc040a17866866fa$export$5f8d39834fd61797 = $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$ffb0004e005737fa;
var $8c104cf9ab4badc0$var$$dc040a17866866fa$export$2e2bcd8739ae039 = {
    useState: $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$60241385465d0a34,
    useReducer: $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$13e3392192263954,
    useEffect: $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$6d9c69b0de29b591,
    useLayoutEffect: $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$e5c5a5f917a5871c,
    useRef: $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$b8f5890fc79d6aca,
    useImperativeHandle: $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$d5a552a76deda3c2,
    useMemo: $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$1538c33de8887b59,
    useCallback: $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$35808ee640e87ca7,
    useContext: $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$fae74005e78b1a27,
    useDebugValue: $8c104cf9ab4badc0$var$$1a9a8ef576b7773d$export$dc8fbce3eb94dc1e,
    version: "17.0.2",
    Children: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$dca3b0875bd9a954,
    render: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$b3890eb0ae9dca99,
    hydrate: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$fa8d919ba61d84db,
    unmountComponentAtNode: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$502457920280e6be,
    createPortal: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$d39a5bbd09211389,
    createElement: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$c8a8987d4410bf2d,
    createContext: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$fd42f52fd3ae1109,
    createFactory: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$d38cd72104c1f0e9,
    cloneElement: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$e530037191fcd5d7,
    createRef: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43,
    Fragment: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$ffb0004e005737fa,
    isValidElement: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$a8257692ac88316c,
    findDOMNode: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$466bfc07425424d5,
    Component: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8,
    PureComponent: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$221d75b3f55bb0bd,
    memo: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$7c73462e0d25e514,
    forwardRef: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$257a8862b851cb5b,
    flushSync: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$c78a37762a8d58e1,
    StrictMode: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$ffb0004e005737fa,
    Suspense: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$74bf444e3cd11ea5,
    SuspenseList: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$998bcd577473dd93,
    lazy: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $8c104cf9ab4badc0$var$$dc040a17866866fa$export$ae55be85d98224ed
};
const $8c104cf9ab4badc0$var$$ec8c39fdad15601a$var$THEME_ICONS = {
    light: "outline",
    dark: "solid"
};
class $8c104cf9ab4badc0$var$$ec8c39fdad15601a$export$2e2bcd8739ae039 extends $8c104cf9ab4badc0$var$$dc040a17866866fa$export$221d75b3f55bb0bd {
    renderIcon(category) {
        const { icon: icon } = category;
        if (icon) {
            if (icon.svg) return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
                class: "flex",
                dangerouslySetInnerHTML: {
                    __html: icon.svg
                }
            });
            if (icon.src) return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("img", {
                src: icon.src
            });
        }
        const categoryIcons = $8c104cf9ab4badc0$var$$fcccfb36ed0cde68$export$2e2bcd8739ae039.categories[category.id] || $8c104cf9ab4badc0$var$$fcccfb36ed0cde68$export$2e2bcd8739ae039.categories.custom;
        const style = this.props.icons == "auto" ? $8c104cf9ab4badc0$var$$ec8c39fdad15601a$var$THEME_ICONS[this.props.theme] : this.props.icons;
        return categoryIcons[style] || categoryIcons;
    }
    render() {
        let selectedCategoryIndex = null;
        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("nav", {
            id: "nav",
            class: "padding",
            "data-position": this.props.position,
            dir: this.props.dir,
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                class: "flex relative",
                children: [
                    this.categories.map((category, i)=>{
                        const title = category.name || $8c104cf9ab4badc0$export$dbe3113d60765c1a.categories[category.id];
                        const selected = !this.props.unfocused && category.id == this.state.categoryId;
                        if (selected) selectedCategoryIndex = i;
                        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("button", {
                            "aria-label": title,
                            "aria-selected": selected || undefined,
                            title: title,
                            type: "button",
                            class: "flex flex-grow flex-center",
                            onMouseDown: (e)=>e.preventDefault(),
                            onClick: ()=>{
                                this.props.onClick({
                                    category: category,
                                    i: i
                                });
                            },
                            children: this.renderIcon(category)
                        });
                    }),
                    $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                        class: "bar",
                        style: {
                            width: `${100 / this.categories.length}%`,
                            opacity: selectedCategoryIndex == null ? 0 : 1,
                            transform: this.props.dir === "rtl" ? `scaleX(-1) translateX(${selectedCategoryIndex * 100}%)` : `translateX(${selectedCategoryIndex * 100}%)`
                        }
                    })
                ]
            })
        });
    }
    constructor(){
        super();
        this.categories = $8c104cf9ab4badc0$export$2d0294657ab35f1b.categories.filter((category)=>{
            return !category.target;
        });
        this.state = {
            categoryId: this.categories[0].id
        };
    }
}
class $8c104cf9ab4badc0$var$$e0d4dda61265ff1e$export$2e2bcd8739ae039 extends $8c104cf9ab4badc0$var$$dc040a17866866fa$export$221d75b3f55bb0bd {
    shouldComponentUpdate(nextProps) {
        for(let k in nextProps){
            if (k == "children") continue;
            if (nextProps[k] != this.props[k]) return true;
        }
        return false;
    }
    render() {
        return this.props.children;
    }
}
const $8c104cf9ab4badc0$var$$89bd6bb200cc8fef$var$Performance = {
    rowsPerRender: 10
};
class $8c104cf9ab4badc0$var$$89bd6bb200cc8fef$export$2e2bcd8739ae039 extends $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$16fa2f45be04daa8 {
    getInitialState(props = this.props) {
        return {
            skin: $8c104cf9ab4badc0$export$390f32400eaf98c9.get("skin") || props.skin,
            theme: this.initTheme(props.theme)
        };
    }
    componentWillMount() {
        this.dir = $8c104cf9ab4badc0$export$dbe3113d60765c1a.rtl ? "rtl" : "ltr";
        this.refs = {
            menu: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
            navigation: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
            scroll: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
            search: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
            searchInput: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
            skinToneButton: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
            skinToneRadio: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43()
        };
        this.initGrid();
        if (this.props.stickySearch == false && this.props.searchPosition == "sticky") {
            console.warn("[EmojiMart] Deprecation warning: `stickySearch` has been renamed `searchPosition`.");
            this.props.searchPosition = "static";
        }
    }
    componentDidMount() {
        this.register();
        this.shadowRoot = this.base.parentNode;
        if (this.props.autoFocus) {
            const { searchInput: searchInput } = this.refs;
            if (searchInput.current) searchInput.current.focus();
        }
    }
    componentWillReceiveProps(nextProps) {
        this.nextState || (this.nextState = {});
        for(const k1 in nextProps)this.nextState[k1] = nextProps[k1];
        clearTimeout(this.nextStateTimer);
        this.nextStateTimer = setTimeout(()=>{
            let requiresGridReset = false;
            for(const k in this.nextState){
                this.props[k] = this.nextState[k];
                if (k === "custom" || k === "categories") requiresGridReset = true;
            }
            delete this.nextState;
            const nextState = this.getInitialState();
            if (requiresGridReset) return this.reset(nextState);
            this.setState(nextState);
        });
    }
    componentWillUnmount() {
        this.unregister();
    }
    async reset(nextState = {}) {
        await $8c104cf9ab4badc0$export$2cd8252107eb640b(this.props);
        this.initGrid();
        this.unobserve();
        this.setState(nextState, ()=>{
            this.observeCategories();
            this.observeRows();
        });
    }
    register() {
        document.addEventListener("click", this.handleClickOutside);
        this.observe();
    }
    unregister() {
        document.removeEventListener("click", this.handleClickOutside);
        this.darkMedia?.removeEventListener("change", this.darkMediaCallback);
        this.unobserve();
    }
    observe() {
        this.observeCategories();
        this.observeRows();
    }
    unobserve({ except: except = [] } = {}) {
        if (!Array.isArray(except)) except = [
            except
        ];
        for (const observer of this.observers){
            if (except.includes(observer)) continue;
            observer.disconnect();
        }
        this.observers = [].concat(except);
    }
    initGrid() {
        const { categories: categories } = $8c104cf9ab4badc0$export$2d0294657ab35f1b;
        this.refs.categories = new Map();
        const navKey = $8c104cf9ab4badc0$export$2d0294657ab35f1b.categories.map((category)=>category.id).join(",");
        if (this.navKey && this.navKey != navKey) this.refs.scroll.current && (this.refs.scroll.current.scrollTop = 0);
        this.navKey = navKey;
        this.grid = [];
        this.grid.setsize = 0;
        const addRow = (rows, category)=>{
            const row = [];
            row.__categoryId = category.id;
            row.__index = rows.length;
            this.grid.push(row);
            const rowIndex = this.grid.length - 1;
            const rowRef = rowIndex % $8c104cf9ab4badc0$var$$89bd6bb200cc8fef$var$Performance.rowsPerRender ? {} : $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43();
            rowRef.index = rowIndex;
            rowRef.posinset = this.grid.setsize + 1;
            rows.push(rowRef);
            return row;
        };
        for (let category1 of categories){
            const rows = [];
            let row = addRow(rows, category1);
            for (let emoji of category1.emojis){
                if (row.length == this.getPerLine()) row = addRow(rows, category1);
                this.grid.setsize += 1;
                row.push(emoji);
            }
            this.refs.categories.set(category1.id, {
                root: $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$7d1e3a5e95ceca43(),
                rows: rows
            });
        }
    }
    initTheme(theme) {
        if (theme != "auto") return theme;
        if (!this.darkMedia) {
            this.darkMedia = matchMedia("(prefers-color-scheme: dark)");
            if (this.darkMedia.media.match(/^not/)) return "light";
            this.darkMedia.addEventListener("change", this.darkMediaCallback);
        }
        return this.darkMedia.matches ? "dark" : "light";
    }
    initDynamicPerLine(props = this.props) {
        if (!props.dynamicWidth) return;
        const { element: element, emojiButtonSize: emojiButtonSize } = props;
        const calculatePerLine = ()=>{
            const { width: width } = element.getBoundingClientRect();
            return Math.floor(width / emojiButtonSize);
        };
        const observer = new ResizeObserver(()=>{
            this.unobserve({
                except: observer
            });
            this.setState({
                perLine: calculatePerLine()
            }, ()=>{
                this.initGrid();
                this.forceUpdate(()=>{
                    this.observeCategories();
                    this.observeRows();
                });
            });
        });
        observer.observe(element);
        this.observers.push(observer);
        return calculatePerLine();
    }
    getPerLine() {
        return this.state.perLine || this.props.perLine;
    }
    getEmojiByPos([p1, p2]) {
        const grid = this.state.searchResults || this.grid;
        const emoji = grid[p1] && grid[p1][p2];
        if (!emoji) return;
        return $8c104cf9ab4badc0$export$147b480b3694c1f3.get(emoji);
    }
    observeCategories() {
        const navigation = this.refs.navigation.current;
        if (!navigation) return;
        const visibleCategories = new Map();
        const setFocusedCategory = (categoryId)=>{
            if (categoryId != navigation.state.categoryId) navigation.setState({
                categoryId: categoryId
            });
        };
        const observerOptions = {
            root: this.refs.scroll.current,
            threshold: [
                0.0,
                1.0
            ]
        };
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries){
                const id = entry.target.dataset.id;
                visibleCategories.set(id, entry.intersectionRatio);
            }
            const ratios = [
                ...visibleCategories
            ];
            for (const [id, ratio] of ratios)if (ratio) {
                setFocusedCategory(id);
                break;
            }
        }, observerOptions);
        for (const { root: root } of this.refs.categories.values())observer.observe(root.current);
        this.observers.push(observer);
    }
    observeRows() {
        const visibleRows = {
            ...this.state.visibleRows
        };
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries){
                const index = parseInt(entry.target.dataset.index);
                if (entry.isIntersecting) visibleRows[index] = true;
                else delete visibleRows[index];
            }
            this.setState({
                visibleRows: visibleRows
            });
        }, {
            root: this.refs.scroll.current,
            rootMargin: `${this.props.emojiButtonSize * ($8c104cf9ab4badc0$var$$89bd6bb200cc8fef$var$Performance.rowsPerRender + 5)}px 0px ${this.props.emojiButtonSize * $8c104cf9ab4badc0$var$$89bd6bb200cc8fef$var$Performance.rowsPerRender}px`
        });
        for (const { rows: rows } of this.refs.categories.values()){
            for (const row of rows)if (row.current) observer.observe(row.current);
        }
        this.observers.push(observer);
    }
    preventDefault(e) {
        e.preventDefault();
    }
    unfocusSearch() {
        const input = this.refs.searchInput.current;
        if (!input) return;
        input.blur();
    }
    navigate({ e: e, input: input, left: left, right: right, up: up, down: down }) {
        const grid = this.state.searchResults || this.grid;
        if (!grid.length) return;
        let [p1, p2] = this.state.pos;
        const pos = (()=>{
            if (p1 == 0) {
                if (p2 == 0 && !e.repeat && (left || up)) return null;
            }
            if (p1 == -1) {
                if (!e.repeat && (right || down) && input.selectionStart == input.value.length) return [
                    0,
                    0
                ];
                return null;
            }
            if (left || right) {
                let row = grid[p1];
                const increment = left ? -1 : 1;
                p2 += increment;
                if (!row[p2]) {
                    p1 += increment;
                    row = grid[p1];
                    if (!row) {
                        p1 = left ? 0 : grid.length - 1;
                        p2 = left ? 0 : grid[p1].length - 1;
                        return [
                            p1,
                            p2
                        ];
                    }
                    p2 = left ? row.length - 1 : 0;
                }
                return [
                    p1,
                    p2
                ];
            }
            if (up || down) {
                p1 += up ? -1 : 1;
                const row = grid[p1];
                if (!row) {
                    p1 = up ? 0 : grid.length - 1;
                    p2 = up ? 0 : grid[p1].length - 1;
                    return [
                        p1,
                        p2
                    ];
                }
                if (!row[p2]) p2 = row.length - 1;
                return [
                    p1,
                    p2
                ];
            }
        })();
        if (pos) e.preventDefault();
        else {
            if (this.state.pos[0] > -1) this.setState({
                pos: [
                    -1,
                    -1
                ]
            });
            return;
        }
        this.setState({
            pos: pos,
            keyboard: true
        }, ()=>{
            this.scrollTo({
                row: pos[0]
            });
        });
    }
    scrollTo({ categoryId: categoryId, row: row }) {
        const grid = this.state.searchResults || this.grid;
        if (!grid.length) return;
        const scroll = this.refs.scroll.current;
        const scrollRect = scroll.getBoundingClientRect();
        let scrollTop = 0;
        if (row >= 0) categoryId = grid[row].__categoryId;
        if (categoryId) {
            const ref = this.refs[categoryId] || this.refs.categories.get(categoryId).root;
            const categoryRect = ref.current.getBoundingClientRect();
            scrollTop = categoryRect.top - (scrollRect.top - scroll.scrollTop) + 1;
        }
        if (row >= 0) {
            if (!row) scrollTop = 0;
            else {
                const rowIndex = grid[row].__index;
                const rowTop = scrollTop + rowIndex * this.props.emojiButtonSize;
                const rowBot = rowTop + this.props.emojiButtonSize + this.props.emojiButtonSize * 0.88;
                if (rowTop < scroll.scrollTop) scrollTop = rowTop;
                else if (rowBot > scroll.scrollTop + scrollRect.height) scrollTop = rowBot - scrollRect.height;
                else return;
            }
        }
        this.ignoreMouse();
        scroll.scrollTop = scrollTop;
    }
    ignoreMouse() {
        this.mouseIsIgnored = true;
        clearTimeout(this.ignoreMouseTimer);
        this.ignoreMouseTimer = setTimeout(()=>{
            delete this.mouseIsIgnored;
        }, 100);
    }
    handleEmojiOver(pos) {
        if (this.mouseIsIgnored || this.state.showSkins) return;
        this.setState({
            pos: pos || [
                -1,
                -1
            ],
            keyboard: false
        });
    }
    handleEmojiClick({ e: e, emoji: emoji, pos: pos }) {
        if (!this.props.onEmojiSelect) return;
        if (!emoji && pos) emoji = this.getEmojiByPos(pos);
        if (emoji) {
            const emojiData = $8c104cf9ab4badc0$var$$693b183b0a78708f$export$d10ac59fbe52a745(emoji, {
                skinIndex: this.state.skin - 1
            });
            if (this.props.maxFrequentRows) $8c104cf9ab4badc0$export$d42f766cf4e359f3.add(emojiData, this.props);
            this.props.onEmojiSelect(emojiData, e);
        }
    }
    closeSkins() {
        if (!this.state.showSkins) return;
        this.setState({
            showSkins: null,
            tempSkin: null
        });
        this.base.removeEventListener("click", this.handleBaseClick);
        this.base.removeEventListener("keydown", this.handleBaseKeydown);
    }
    handleSkinMouseOver(tempSkin) {
        this.setState({
            tempSkin: tempSkin
        });
    }
    handleSkinClick(skin) {
        this.ignoreMouse();
        this.closeSkins();
        this.setState({
            skin: skin,
            tempSkin: null
        });
        $8c104cf9ab4badc0$export$390f32400eaf98c9.set("skin", skin);
    }
    renderNav() {
        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b($8c104cf9ab4badc0$var$$ec8c39fdad15601a$export$2e2bcd8739ae039, {
            ref: this.refs.navigation,
            icons: this.props.icons,
            theme: this.state.theme,
            dir: this.dir,
            unfocused: !!this.state.searchResults,
            position: this.props.navPosition,
            onClick: this.handleCategoryClick
        }, this.navKey);
    }
    renderPreview() {
        const emoji = this.getEmojiByPos(this.state.pos);
        const noSearchResults = this.state.searchResults && !this.state.searchResults.length;
        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            id: "preview",
            class: "flex flex-middle",
            dir: this.dir,
            "data-position": this.props.previewPosition,
            children: [
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    class: "flex flex-middle flex-grow",
                    children: [
                        $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                            class: "flex flex-auto flex-middle flex-center",
                            style: {
                                height: this.props.emojiButtonSize,
                                fontSize: this.props.emojiButtonSize
                            },
                            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b($8c104cf9ab4badc0$var$$254755d3f438722f$export$2e2bcd8739ae039, {
                                emoji: emoji,
                                id: noSearchResults ? this.props.noResultsEmoji || "cry" : this.props.previewEmoji || (this.props.previewPosition == "top" ? "point_down" : "point_up"),
                                set: this.props.set,
                                size: this.props.emojiButtonSize,
                                skin: this.state.tempSkin || this.state.skin,
                                spritesheet: true,
                                getSpritesheetURL: this.props.getSpritesheetURL
                            })
                        }),
                        $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                            class: `margin-${this.dir[0]}`,
                            children: emoji || noSearchResults ? $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                                class: `padding-${this.dir[2]} align-${this.dir[0]}`,
                                children: [
                                    $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                                        class: "preview-title ellipsis",
                                        children: emoji ? emoji.name : $8c104cf9ab4badc0$export$dbe3113d60765c1a.search_no_results_1
                                    }),
                                    $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                                        class: "preview-subtitle ellipsis color-c",
                                        children: emoji ? emoji.skins[0].shortcodes : $8c104cf9ab4badc0$export$dbe3113d60765c1a.search_no_results_2
                                    })
                                ]
                            }) : $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                                class: "preview-placeholder color-c",
                                children: $8c104cf9ab4badc0$export$dbe3113d60765c1a.pick
                            })
                        })
                    ]
                }),
                !emoji && this.props.skinTonePosition == "preview" && this.renderSkinToneButton()
            ]
        });
    }
    renderEmojiButton(emoji, { pos: pos, posinset: posinset, grid: grid }) {
        const size = this.props.emojiButtonSize;
        const skin = this.state.tempSkin || this.state.skin;
        const emojiSkin = emoji.skins[skin - 1] || emoji.skins[0];
        const native = emojiSkin.native;
        const selected = $8c104cf9ab4badc0$var$$693b183b0a78708f$export$9cb4719e2e525b7a(this.state.pos, pos);
        const key = pos.concat(emoji.id).join("");
        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b($8c104cf9ab4badc0$var$$e0d4dda61265ff1e$export$2e2bcd8739ae039, {
            selected: selected,
            skin: skin,
            size: size,
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("button", {
                "aria-label": native,
                "aria-selected": selected || undefined,
                "aria-posinset": posinset,
                "aria-setsize": grid.setsize,
                "data-keyboard": this.state.keyboard,
                title: this.props.previewPosition == "none" ? emoji.name : undefined,
                type: "button",
                class: "flex flex-center flex-middle",
                tabindex: "-1",
                onClick: (e)=>this.handleEmojiClick({
                        e: e,
                        emoji: emoji
                    }),
                onMouseEnter: ()=>this.handleEmojiOver(pos),
                onMouseLeave: ()=>this.handleEmojiOver(),
                style: {
                    width: this.props.emojiButtonSize,
                    height: this.props.emojiButtonSize,
                    fontSize: this.props.emojiSize,
                    lineHeight: 0
                },
                children: [
                    $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                        "aria-hidden": "true",
                        class: "background",
                        style: {
                            borderRadius: this.props.emojiButtonRadius,
                            backgroundColor: this.props.emojiButtonColors ? this.props.emojiButtonColors[(posinset - 1) % this.props.emojiButtonColors.length] : undefined
                        }
                    }),
                    $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b($8c104cf9ab4badc0$var$$254755d3f438722f$export$2e2bcd8739ae039, {
                        emoji: emoji,
                        set: this.props.set,
                        size: this.props.emojiSize,
                        skin: skin,
                        spritesheet: true,
                        getSpritesheetURL: this.props.getSpritesheetURL
                    })
                ]
            })
        }, key);
    }
    renderSearch() {
        const renderSkinTone = this.props.previewPosition == "none" || this.props.skinTonePosition == "search";
        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            children: [
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    class: "spacer"
                }),
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    class: "flex flex-middle",
                    children: [
                        $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                            class: "search relative flex-grow",
                            children: [
                                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("input", {
                                    type: "search",
                                    ref: this.refs.searchInput,
                                    placeholder: $8c104cf9ab4badc0$export$dbe3113d60765c1a.search,
                                    onClick: this.handleSearchClick,
                                    onInput: this.handleSearchInput,
                                    onKeyDown: this.handleSearchKeyDown,
                                    autoComplete: "off"
                                }),
                                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
                                    class: "icon loupe flex",
                                    children: $8c104cf9ab4badc0$var$$fcccfb36ed0cde68$export$2e2bcd8739ae039.search.loupe
                                }),
                                this.state.searchResults && $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("button", {
                                    title: "Clear",
                                    "aria-label": "Clear",
                                    type: "button",
                                    class: "icon delete flex",
                                    onClick: this.clearSearch,
                                    onMouseDown: this.preventDefault,
                                    children: $8c104cf9ab4badc0$var$$fcccfb36ed0cde68$export$2e2bcd8739ae039.search.delete
                                })
                            ]
                        }),
                        renderSkinTone && this.renderSkinToneButton()
                    ]
                })
            ]
        });
    }
    renderSearchResults() {
        const { searchResults: searchResults } = this.state;
        if (!searchResults) return null;
        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            class: "category",
            ref: this.refs.search,
            children: [
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    class: `sticky padding-small align-${this.dir[0]}`,
                    children: $8c104cf9ab4badc0$export$dbe3113d60765c1a.categories.search
                }),
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    children: !searchResults.length ? $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                        class: `padding-small align-${this.dir[0]}`,
                        children: this.props.onAddCustomEmoji && $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("a", {
                            onClick: this.props.onAddCustomEmoji,
                            children: $8c104cf9ab4badc0$export$dbe3113d60765c1a.add_custom
                        })
                    }) : searchResults.map((row, i)=>{
                        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                            class: "flex",
                            children: row.map((emoji, ii)=>{
                                return this.renderEmojiButton(emoji, {
                                    pos: [
                                        i,
                                        ii
                                    ],
                                    posinset: i * this.props.perLine + ii + 1,
                                    grid: searchResults
                                });
                            })
                        });
                    })
                })
            ]
        });
    }
    renderCategories() {
        const { categories: categories } = $8c104cf9ab4badc0$export$2d0294657ab35f1b;
        const hidden = !!this.state.searchResults;
        const perLine = this.getPerLine();
        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            style: {
                visibility: hidden ? "hidden" : undefined,
                display: hidden ? "none" : undefined,
                height: "100%"
            },
            children: categories.map((category)=>{
                const { root: root, rows: rows } = this.refs.categories.get(category.id);
                return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    "data-id": category.target ? category.target.id : category.id,
                    class: "category",
                    ref: root,
                    children: [
                        $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                            class: `sticky padding-small align-${this.dir[0]}`,
                            children: category.name || $8c104cf9ab4badc0$export$dbe3113d60765c1a.categories[category.id]
                        }),
                        $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                            class: "relative",
                            style: {
                                height: rows.length * this.props.emojiButtonSize
                            },
                            children: rows.map((row, i)=>{
                                const targetRow = row.index - row.index % $8c104cf9ab4badc0$var$$89bd6bb200cc8fef$var$Performance.rowsPerRender;
                                const visible = this.state.visibleRows[targetRow];
                                const ref = "current" in row ? row : undefined;
                                if (!visible && !ref) return null;
                                const start = i * perLine;
                                const end = start + perLine;
                                const emojiIds = category.emojis.slice(start, end);
                                if (emojiIds.length < perLine) emojiIds.push(...new Array(perLine - emojiIds.length));
                                return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                                    "data-index": row.index,
                                    ref: ref,
                                    class: "flex row",
                                    style: {
                                        top: i * this.props.emojiButtonSize
                                    },
                                    children: visible && emojiIds.map((emojiId, ii)=>{
                                        if (!emojiId) return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                                            style: {
                                                width: this.props.emojiButtonSize,
                                                height: this.props.emojiButtonSize
                                            }
                                        });
                                        const emoji = $8c104cf9ab4badc0$export$147b480b3694c1f3.get(emojiId);
                                        return this.renderEmojiButton(emoji, {
                                            pos: [
                                                row.index,
                                                ii
                                            ],
                                            posinset: row.posinset + ii,
                                            grid: this.grid
                                        });
                                    })
                                }, row.index);
                            })
                        })
                    ]
                });
            })
        });
    }
    renderSkinToneButton() {
        if (this.props.skinTonePosition == "none") return null;
        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            class: "flex flex-auto flex-center flex-middle",
            style: {
                position: "relative",
                width: this.props.emojiButtonSize,
                height: this.props.emojiButtonSize
            },
            children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("button", {
                type: "button",
                ref: this.refs.skinToneButton,
                class: "skin-tone-button flex flex-auto flex-center flex-middle",
                "aria-selected": this.state.showSkins ? "" : undefined,
                "aria-label": $8c104cf9ab4badc0$export$dbe3113d60765c1a.skins.choose,
                title: $8c104cf9ab4badc0$export$dbe3113d60765c1a.skins.choose,
                onClick: this.openSkins,
                style: {
                    width: this.props.emojiSize,
                    height: this.props.emojiSize
                },
                children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
                    class: `skin-tone skin-tone-${this.state.skin}`
                })
            })
        });
    }
    renderLiveRegion() {
        const emoji = this.getEmojiByPos(this.state.pos);
        const contents = emoji ? emoji.name : "";
        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            "aria-live": "polite",
            class: "sr-only",
            children: contents
        });
    }
    renderSkins() {
        const skinToneButton = this.refs.skinToneButton.current;
        const skinToneButtonRect = skinToneButton.getBoundingClientRect();
        const baseRect = this.base.getBoundingClientRect();
        const position = {};
        if (this.dir == "ltr") position.right = baseRect.right - skinToneButtonRect.right - 3;
        else position.left = skinToneButtonRect.left - baseRect.left - 3;
        if (this.props.previewPosition == "bottom" && this.props.skinTonePosition == "preview") position.bottom = baseRect.bottom - skinToneButtonRect.top + 6;
        else {
            position.top = skinToneButtonRect.bottom - baseRect.top + 3;
            position.bottom = "auto";
        }
        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
            ref: this.refs.menu,
            role: "radiogroup",
            dir: this.dir,
            "aria-label": $8c104cf9ab4badc0$export$dbe3113d60765c1a.skins.choose,
            class: "menu hidden",
            "data-position": position.top ? "top" : "bottom",
            style: position,
            children: [
                ...Array(6).keys()
            ].map((i)=>{
                const skin = i + 1;
                const checked = this.state.skin == skin;
                return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    children: [
                        $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("input", {
                            type: "radio",
                            name: "skin-tone",
                            value: skin,
                            "aria-label": $8c104cf9ab4badc0$export$dbe3113d60765c1a.skins[skin],
                            ref: checked ? this.refs.skinToneRadio : null,
                            defaultChecked: checked,
                            onChange: ()=>this.handleSkinMouseOver(skin),
                            onKeyDown: (e)=>{
                                if (e.code == "Enter" || e.code == "Space" || e.code == "Tab") {
                                    e.preventDefault();
                                    this.handleSkinClick(skin);
                                }
                            }
                        }),
                        $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("button", {
                            "aria-hidden": "true",
                            tabindex: "-1",
                            onClick: ()=>this.handleSkinClick(skin),
                            onMouseEnter: ()=>this.handleSkinMouseOver(skin),
                            onMouseLeave: ()=>this.handleSkinMouseOver(),
                            class: "option flex flex-grow flex-middle",
                            children: [
                                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
                                    class: `skin-tone skin-tone-${skin}`
                                }),
                                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("span", {
                                    class: "margin-small-lr",
                                    children: $8c104cf9ab4badc0$export$dbe3113d60765c1a.skins[skin]
                                })
                            ]
                        })
                    ]
                });
            })
        });
    }
    render() {
        const lineWidth = this.props.perLine * this.props.emojiButtonSize;
        return $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("section", {
            id: "root",
            class: "flex flex-column",
            dir: this.dir,
            style: {
                width: this.props.dynamicWidth ? "100%" : `calc(${lineWidth}px + (var(--padding) + var(--sidebar-width)))`
            },
            "data-emoji-set": this.props.set,
            "data-theme": this.state.theme,
            "data-menu": this.state.showSkins ? "" : undefined,
            children: [
                this.props.previewPosition == "top" && this.renderPreview(),
                this.props.navPosition == "top" && this.renderNav(),
                this.props.searchPosition == "sticky" && $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    class: "padding-lr",
                    children: this.renderSearch()
                }),
                $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                    ref: this.refs.scroll,
                    class: "scroll flex-grow padding-lr",
                    children: $8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b("div", {
                        style: {
                            width: this.props.dynamicWidth ? "100%" : lineWidth,
                            height: "100%"
                        },
                        children: [
                            this.props.searchPosition == "static" && this.renderSearch(),
                            this.renderSearchResults(),
                            this.renderCategories()
                        ]
                    })
                }),
                this.props.navPosition == "bottom" && this.renderNav(),
                this.props.previewPosition == "bottom" && this.renderPreview(),
                this.state.showSkins && this.renderSkins(),
                this.renderLiveRegion()
            ]
        });
    }
    constructor(props){
        super();
        $8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "darkMediaCallback", ()=>{
            if (this.props.theme != "auto") return;
            this.setState({
                theme: this.darkMedia.matches ? "dark" : "light"
            });
        });
        $8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleClickOutside", (e)=>{
            const { element: element } = this.props;
            if (e.target != element) {
                if (this.state.showSkins) this.closeSkins();
                if (this.props.onClickOutside) this.props.onClickOutside(e);
            }
        });
        $8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleBaseClick", (e)=>{
            if (!this.state.showSkins) return;
            if (!e.target.closest(".menu")) {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.closeSkins();
            }
        });
        $8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleBaseKeydown", (e)=>{
            if (!this.state.showSkins) return;
            if (e.key == "Escape") {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.closeSkins();
            }
        });
        $8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleSearchClick", ()=>{
            const emoji = this.getEmojiByPos(this.state.pos);
            if (!emoji) return;
            this.setState({
                pos: [
                    -1,
                    -1
                ]
            });
        });
        $8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleSearchInput", async ()=>{
            const input = this.refs.searchInput.current;
            if (!input) return;
            const { value: value } = input;
            const searchResults = await $8c104cf9ab4badc0$export$147b480b3694c1f3.search(value);
            const afterRender = ()=>{
                if (!this.refs.scroll.current) return;
                this.refs.scroll.current.scrollTop = 0;
            };
            if (!searchResults) return this.setState({
                searchResults: searchResults,
                pos: [
                    -1,
                    -1
                ]
            }, afterRender);
            const pos = input.selectionStart == input.value.length ? [
                0,
                0
            ] : [
                -1,
                -1
            ];
            const grid = [];
            grid.setsize = searchResults.length;
            let row = null;
            for (let emoji of searchResults){
                if (!grid.length || row.length == this.getPerLine()) {
                    row = [];
                    row.__categoryId = "search";
                    row.__index = grid.length;
                    grid.push(row);
                }
                row.push(emoji);
            }
            this.ignoreMouse();
            this.setState({
                searchResults: grid,
                pos: pos
            }, afterRender);
        });
        $8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleSearchKeyDown", (e)=>{
            // const specialKey = e.altKey || e.ctrlKey || e.metaKey
            const input = e.currentTarget;
            e.stopImmediatePropagation();
            switch(e.key){
                case "ArrowLeft":
                    // if (specialKey) return
                    // e.preventDefault()
                    this.navigate({
                        e: e,
                        input: input,
                        left: true
                    });
                    break;
                case "ArrowRight":
                    // if (specialKey) return
                    // e.preventDefault()
                    this.navigate({
                        e: e,
                        input: input,
                        right: true
                    });
                    break;
                case "ArrowUp":
                    // if (specialKey) return
                    // e.preventDefault()
                    this.navigate({
                        e: e,
                        input: input,
                        up: true
                    });
                    break;
                case "ArrowDown":
                    // if (specialKey) return
                    // e.preventDefault()
                    this.navigate({
                        e: e,
                        input: input,
                        down: true
                    });
                    break;
                case "Enter":
                    e.preventDefault();
                    this.handleEmojiClick({
                        e: e,
                        pos: this.state.pos
                    });
                    break;
                case "Escape":
                    e.preventDefault();
                    if (this.state.searchResults) this.clearSearch();
                    else this.unfocusSearch();
                    break;
                default:
                    break;
            }
        });
        $8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "clearSearch", ()=>{
            const input = this.refs.searchInput.current;
            if (!input) return;
            input.value = "";
            input.focus();
            this.handleSearchInput();
        });
        $8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "handleCategoryClick", ({ category: category, i: i })=>{
            this.scrollTo(i == 0 ? {
                row: -1
            } : {
                categoryId: category.id
            });
        });
        $8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039(this, "openSkins", (e)=>{
            const { currentTarget: currentTarget } = e;
            const rect = currentTarget.getBoundingClientRect();
            this.setState({
                showSkins: rect
            }, async ()=>{
                // Firefox requires 2 frames for the transition to consistenly work
                await $8c104cf9ab4badc0$var$$693b183b0a78708f$export$e772c8ff12451969(2);
                const menu = this.refs.menu.current;
                if (!menu) return;
                menu.classList.remove("hidden");
                this.refs.skinToneRadio.current.focus();
                this.base.addEventListener("click", this.handleBaseClick, true);
                this.base.addEventListener("keydown", this.handleBaseKeydown, true);
            });
        });
        this.observers = [];
        this.state = {
            pos: [
                -1,
                -1
            ],
            perLine: this.initDynamicPerLine(props),
            visibleRows: {
                0: true
            },
            ...this.getInitialState(props)
        };
    }
}
class $8c104cf9ab4badc0$export$ba25329847403e11 extends $8c104cf9ab4badc0$var$$26f27c338a96b1a6$export$2e2bcd8739ae039 {
    async connectedCallback() {
        const props = $8c104cf9ab4badc0$var$$7adb23b0109cc36a$export$75fe5f91d452f94b(this.props, $8c104cf9ab4badc0$var$$b247ea80b67298d5$export$2e2bcd8739ae039, this);
        props.element = this;
        props.ref = (component)=>{
            this.component = component;
        };
        await $8c104cf9ab4badc0$export$2cd8252107eb640b(props);
        if (this.disconnected) return;
        $8c104cf9ab4badc0$var$$fb96b826c0c5f37a$export$b3890eb0ae9dca99($8c104cf9ab4badc0$var$$bd9dd35321b03dd4$export$34b9dba7ce09269b($8c104cf9ab4badc0$var$$89bd6bb200cc8fef$export$2e2bcd8739ae039, {
            ...props
        }), this.shadowRoot);
    }
    constructor(props){
        super(props, {
            styles: /*@__PURE__*/ $8c104cf9ab4badc0$var$$parcel$interopDefault($8c104cf9ab4badc0$var$$329d53ba9fd7125f$exports)
        });
    }
}
$8c104cf9ab4badc0$var$$c770c458706daa72$export$2e2bcd8739ae039($8c104cf9ab4badc0$export$ba25329847403e11, "Props", $8c104cf9ab4badc0$var$$b247ea80b67298d5$export$2e2bcd8739ae039);
if (typeof customElements !== "undefined" && !customElements.get("em-emoji-picker")) customElements.define("em-emoji-picker", $8c104cf9ab4badc0$export$ba25329847403e11);
var $8c104cf9ab4badc0$var$$329d53ba9fd7125f$exports = {};
$8c104cf9ab4badc0$var$$329d53ba9fd7125f$exports = ":host {\n  width: min-content;\n  height: 435px;\n  min-height: 230px;\n  border-radius: var(--border-radius);\n  box-shadow: var(--shadow);\n  --border-radius: 10px;\n  --category-icon-size: 18px;\n  --font-family: -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", sans-serif;\n  --font-size: 15px;\n  --preview-placeholder-size: 21px;\n  --preview-title-size: 1.1em;\n  --preview-subtitle-size: .9em;\n  --shadow-color: 0deg 0% 0%;\n  --shadow: .3px .5px 2.7px hsl(var(--shadow-color) / .14), .4px .8px 1px -3.2px hsl(var(--shadow-color) / .14), 1px 2px 2.5px -4.5px hsl(var(--shadow-color) / .14);\n  display: flex;\n}\n\n[data-theme=\"light\"] {\n  --em-rgb-color: var(--rgb-color, 34, 36, 39);\n  --em-rgb-accent: var(--rgb-accent, 34, 102, 237);\n  --em-rgb-background: var(--rgb-background, 255, 255, 255);\n  --em-rgb-input: var(--rgb-input, 255, 255, 255);\n  --em-color-border: var(--color-border, rgba(0, 0, 0, .05));\n  --em-color-border-over: var(--color-border-over, rgba(0, 0, 0, .1));\n}\n\n[data-theme=\"dark\"] {\n  --em-rgb-color: var(--rgb-color, 222, 222, 221);\n  --em-rgb-accent: var(--rgb-accent, 58, 130, 247);\n  --em-rgb-background: var(--rgb-background, 21, 22, 23);\n  --em-rgb-input: var(--rgb-input, 0, 0, 0);\n  --em-color-border: var(--color-border, rgba(255, 255, 255, .1));\n  --em-color-border-over: var(--color-border-over, rgba(255, 255, 255, .2));\n}\n\n#root {\n  --color-a: rgb(var(--em-rgb-color));\n  --color-b: rgba(var(--em-rgb-color), .65);\n  --color-c: rgba(var(--em-rgb-color), .45);\n  --padding: 12px;\n  --padding-small: calc(var(--padding) / 2);\n  --sidebar-width: 16px;\n  --duration: 225ms;\n  --duration-fast: 125ms;\n  --duration-instant: 50ms;\n  --easing: cubic-bezier(.4, 0, .2, 1);\n  width: 100%;\n  text-align: left;\n  border-radius: var(--border-radius);\n  background-color: rgb(var(--em-rgb-background));\n  position: relative;\n}\n\n@media (prefers-reduced-motion) {\n  #root {\n    --duration: 0;\n    --duration-fast: 0;\n    --duration-instant: 0;\n  }\n}\n\n#root[data-menu] button {\n  cursor: auto;\n}\n\n#root[data-menu] .menu button {\n  cursor: pointer;\n}\n\n:host, #root, input, button {\n  color: rgb(var(--em-rgb-color));\n  font-family: var(--font-family);\n  font-size: var(--font-size);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: normal;\n}\n\n*, :before, :after {\n  box-sizing: border-box;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.relative {\n  position: relative;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-auto {\n  flex: none;\n}\n\n.flex-center {\n  justify-content: center;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n\n.flex-grow {\n  flex: auto;\n}\n\n.flex-middle {\n  align-items: center;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.padding {\n  padding: var(--padding);\n}\n\n.padding-t {\n  padding-top: var(--padding);\n}\n\n.padding-lr {\n  padding-left: var(--padding);\n  padding-right: var(--padding);\n}\n\n.padding-r {\n  padding-right: var(--padding);\n}\n\n.padding-small {\n  padding: var(--padding-small);\n}\n\n.padding-small-b {\n  padding-bottom: var(--padding-small);\n}\n\n.padding-small-lr {\n  padding-left: var(--padding-small);\n  padding-right: var(--padding-small);\n}\n\n.margin {\n  margin: var(--padding);\n}\n\n.margin-r {\n  margin-right: var(--padding);\n}\n\n.margin-l {\n  margin-left: var(--padding);\n}\n\n.margin-small-l {\n  margin-left: var(--padding-small);\n}\n\n.margin-small-lr {\n  margin-left: var(--padding-small);\n  margin-right: var(--padding-small);\n}\n\n.align-l {\n  text-align: left;\n}\n\n.align-r {\n  text-align: right;\n}\n\n.color-a {\n  color: var(--color-a);\n}\n\n.color-b {\n  color: var(--color-b);\n}\n\n.color-c {\n  color: var(--color-c);\n}\n\n.ellipsis {\n  white-space: nowrap;\n  max-width: 100%;\n  width: auto;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.sr-only {\n  width: 1px;\n  height: 1px;\n  position: absolute;\n  top: auto;\n  left: -10000px;\n  overflow: hidden;\n}\n\na {\n  cursor: pointer;\n  color: rgb(var(--em-rgb-accent));\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.spacer {\n  height: 10px;\n}\n\n[dir=\"rtl\"] .scroll {\n  padding-left: 0;\n  padding-right: var(--padding);\n}\n\n.scroll {\n  padding-right: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.scroll::-webkit-scrollbar {\n  width: var(--sidebar-width);\n  height: var(--sidebar-width);\n}\n\n.scroll::-webkit-scrollbar-track {\n  border: 0;\n}\n\n.scroll::-webkit-scrollbar-button {\n  width: 0;\n  height: 0;\n  display: none;\n}\n\n.scroll::-webkit-scrollbar-corner {\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.scroll::-webkit-scrollbar-thumb {\n  min-height: 20%;\n  min-height: 65px;\n  border: 4px solid rgb(var(--em-rgb-background));\n  border-radius: 8px;\n}\n\n.scroll::-webkit-scrollbar-thumb:hover {\n  background-color: var(--em-color-border-over) !important;\n}\n\n.scroll:hover::-webkit-scrollbar-thumb {\n  background-color: var(--em-color-border);\n}\n\n.sticky {\n  z-index: 1;\n  background-color: rgba(var(--em-rgb-background), .9);\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n  font-weight: 500;\n  position: sticky;\n  top: -1px;\n}\n\n[dir=\"rtl\"] .search input[type=\"search\"] {\n  padding: 10px 2.2em 10px 2em;\n}\n\n[dir=\"rtl\"] .search .loupe {\n  left: auto;\n  right: .7em;\n}\n\n[dir=\"rtl\"] .search .delete {\n  left: .7em;\n  right: auto;\n}\n\n.search {\n  z-index: 2;\n  position: relative;\n}\n\n.search input, .search button {\n  font-size: calc(var(--font-size)  - 1px);\n}\n\n.search input[type=\"search\"] {\n  width: 100%;\n  background-color: var(--em-color-border);\n  transition-duration: var(--duration);\n  transition-property: background-color, box-shadow;\n  transition-timing-function: var(--easing);\n  border: 0;\n  border-radius: 10px;\n  outline: 0;\n  padding: 10px 2em 10px 2.2em;\n  display: block;\n}\n\n.search input[type=\"search\"]::-ms-input-placeholder {\n  color: inherit;\n  opacity: .6;\n}\n\n.search input[type=\"search\"]::placeholder {\n  color: inherit;\n  opacity: .6;\n}\n\n.search input[type=\"search\"], .search input[type=\"search\"]::-webkit-search-decoration, .search input[type=\"search\"]::-webkit-search-cancel-button, .search input[type=\"search\"]::-webkit-search-results-button, .search input[type=\"search\"]::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n}\n\n.search input[type=\"search\"]:focus {\n  background-color: rgb(var(--em-rgb-input));\n  box-shadow: inset 0 0 0 1px rgb(var(--em-rgb-accent)), 0 1px 3px rgba(65, 69, 73, .2);\n}\n\n.search .icon {\n  z-index: 1;\n  color: rgba(var(--em-rgb-color), .7);\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.search .loupe {\n  pointer-events: none;\n  left: .7em;\n}\n\n.search .delete {\n  right: .7em;\n}\n\nsvg {\n  fill: currentColor;\n  width: 1em;\n  height: 1em;\n}\n\nbutton {\n  -webkit-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  color: currentColor;\n  background-color: rgba(0, 0, 0, 0);\n  border: 0;\n}\n\n#nav {\n  z-index: 2;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  padding-right: var(--sidebar-width);\n  position: relative;\n}\n\n#nav button {\n  color: var(--color-b);\n  transition: color var(--duration) var(--easing);\n}\n\n#nav button:hover {\n  color: var(--color-a);\n}\n\n#nav svg, #nav img {\n  width: var(--category-icon-size);\n  height: var(--category-icon-size);\n}\n\n#nav[dir=\"rtl\"] .bar {\n  left: auto;\n  right: 0;\n}\n\n#nav .bar {\n  width: 100%;\n  height: 3px;\n  background-color: rgb(var(--em-rgb-accent));\n  transition: transform var(--duration) var(--easing);\n  border-radius: 3px 3px 0 0;\n  position: absolute;\n  bottom: -12px;\n  left: 0;\n}\n\n#nav button[aria-selected] {\n  color: rgb(var(--em-rgb-accent));\n}\n\n#preview {\n  z-index: 2;\n  padding: calc(var(--padding)  + 4px) var(--padding);\n  padding-right: var(--sidebar-width);\n  position: relative;\n}\n\n#preview .preview-placeholder {\n  font-size: var(--preview-placeholder-size);\n}\n\n#preview .preview-title {\n  font-size: var(--preview-title-size);\n}\n\n#preview .preview-subtitle {\n  font-size: var(--preview-subtitle-size);\n}\n\n#nav:before, #preview:before {\n  content: \"\";\n  height: 2px;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n\n#nav[data-position=\"top\"]:before, #preview[data-position=\"top\"]:before {\n  background: linear-gradient(to bottom, var(--em-color-border), transparent);\n  top: 100%;\n}\n\n#nav[data-position=\"bottom\"]:before, #preview[data-position=\"bottom\"]:before {\n  background: linear-gradient(to top, var(--em-color-border), transparent);\n  bottom: 100%;\n}\n\n.category:last-child {\n  min-height: calc(100% + 1px);\n}\n\n.category button {\n  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;\n  position: relative;\n}\n\n.category button > * {\n  position: relative;\n}\n\n.category button .background {\n  opacity: 0;\n  background-color: var(--em-color-border);\n  transition: opacity var(--duration-fast) var(--easing) var(--duration-instant);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.category button:hover .background {\n  transition-duration: var(--duration-instant);\n  transition-delay: 0s;\n}\n\n.category button[aria-selected] .background {\n  opacity: 1;\n}\n\n.category button[data-keyboard] .background {\n  transition: none;\n}\n\n.row {\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.skin-tone-button {\n  border: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 100%;\n}\n\n.skin-tone-button:hover {\n  border-color: var(--em-color-border);\n}\n\n.skin-tone-button:active .skin-tone {\n  transform: scale(.85) !important;\n}\n\n.skin-tone-button .skin-tone {\n  transition: transform var(--duration) var(--easing);\n}\n\n.skin-tone-button[aria-selected] {\n  background-color: var(--em-color-border);\n  border-top-color: rgba(0, 0, 0, .05);\n  border-bottom-color: rgba(0, 0, 0, 0);\n  border-left-width: 0;\n  border-right-width: 0;\n}\n\n.skin-tone-button[aria-selected] .skin-tone {\n  transform: scale(.9);\n}\n\n.menu {\n  z-index: 2;\n  white-space: nowrap;\n  border: 1px solid var(--em-color-border);\n  background-color: rgba(var(--em-rgb-background), .9);\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n  transition-property: opacity, transform;\n  transition-duration: var(--duration);\n  transition-timing-function: var(--easing);\n  border-radius: 10px;\n  padding: 4px;\n  position: absolute;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, .05);\n}\n\n.menu.hidden {\n  opacity: 0;\n}\n\n.menu[data-position=\"bottom\"] {\n  transform-origin: 100% 100%;\n}\n\n.menu[data-position=\"bottom\"].hidden {\n  transform: scale(.9)rotate(-3deg)translateY(5%);\n}\n\n.menu[data-position=\"top\"] {\n  transform-origin: 100% 0;\n}\n\n.menu[data-position=\"top\"].hidden {\n  transform: scale(.9)rotate(3deg)translateY(-5%);\n}\n\n.menu input[type=\"radio\"] {\n  clip: rect(0 0 0 0);\n  width: 1px;\n  height: 1px;\n  border: 0;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  overflow: hidden;\n}\n\n.menu input[type=\"radio\"]:checked + .option {\n  box-shadow: 0 0 0 2px rgb(var(--em-rgb-accent));\n}\n\n.option {\n  width: 100%;\n  border-radius: 6px;\n  padding: 4px 6px;\n}\n\n.option:hover {\n  color: #fff;\n  background-color: rgb(var(--em-rgb-accent));\n}\n\n.skin-tone {\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n}\n\n.skin-tone:after {\n  content: \"\";\n  mix-blend-mode: overlay;\n  background: linear-gradient(rgba(255, 255, 255, .2), rgba(0, 0, 0, 0));\n  border: 1px solid rgba(0, 0, 0, .8);\n  border-radius: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  box-shadow: inset 0 -2px 3px #000, inset 0 1px 2px #fff;\n}\n\n.skin-tone-1 {\n  background-color: #ffc93a;\n}\n\n.skin-tone-2 {\n  background-color: #ffdab7;\n}\n\n.skin-tone-3 {\n  background-color: #e7b98f;\n}\n\n.skin-tone-4 {\n  background-color: #c88c61;\n}\n\n.skin-tone-5 {\n  background-color: #a46134;\n}\n\n.skin-tone-6 {\n  background-color: #5d4437;\n}\n\n[data-index] {\n  justify-content: space-between;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone:after {\n  box-shadow: none;\n  border-color: rgba(0, 0, 0, .5);\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-1 {\n  background-color: #fade72;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-2 {\n  background-color: #f3dfd0;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-3 {\n  background-color: #eed3a8;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-4 {\n  background-color: #cfad8d;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-5 {\n  background-color: #a8805d;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-6 {\n  background-color: #765542;\n}\n\n[data-emoji-set=\"google\"] .skin-tone:after {\n  box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, .4);\n}\n\n[data-emoji-set=\"google\"] .skin-tone-1 {\n  background-color: #f5c748;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-2 {\n  background-color: #f1d5aa;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-3 {\n  background-color: #d4b48d;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-4 {\n  background-color: #aa876b;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-5 {\n  background-color: #916544;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-6 {\n  background-color: #61493f;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone:after {\n  border-color: rgba(0, 0, 0, .4);\n  box-shadow: inset 0 -2px 3px #000, inset 0 1px 4px #fff;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-1 {\n  background-color: #f5c748;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-2 {\n  background-color: #f1d5aa;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-3 {\n  background-color: #d4b48d;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-4 {\n  background-color: #aa876b;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-5 {\n  background-color: #916544;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-6 {\n  background-color: #61493f;\n}\n\n";


function $e34a4b0cfc4ca7b4$export$2e2bcd8739ae039(props) {
    const ref = (0, $ltGt3.useRef)(null);
    const instance = (0, $ltGt3.useRef)(null);
    if (instance.current) instance.current.update(props);
    (0, $ltGt3.useEffect)(()=>{
        instance.current = new (0, $8c104cf9ab4badc0$export$ba25329847403e11)({
            ...props,
            ref: ref
        });
        return ()=>{
            instance.current = null;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
        ref: ref
    });
}



parcelRequire("ltGt3");
function $f952978d00baf9e4$export$60d30b2661acb1b8(props) {
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("em-emoji", {
        ...props
    });
}


function $596463b50963aa35$export$c252589de2aeff00(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [isPickerVisible, setIsPickerVisible] = (0, $ltGt3.useState)(false);
    const pickerRef = (0, $ltGt3.useRef)(null);
    (0, $ltGt3.useEffect)(()=>{
        const onVisibleChange = props.onEmojiDropdownVisibleChange;
        if (typeof onVisibleChange === 'function') {
            if (isPickerVisible) onVisibleChange(true);
            else // TODO: antd uses setTimeout with 10ms delay before triggering dropdown visibility update
            // so to counter that we have to introduce our own timeout which is also based on
            // animation delay :(
            window.setTimeout(()=>onVisibleChange(false), 400);
        }
    }, [
        isPickerVisible
    ]);
    const picker = /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        ref: pickerRef,
        onClick: (e)=>{
            e.stopPropagation();
        },
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e34a4b0cfc4ca7b4$export$2e2bcd8739ae039), {
            ref: pickerRef,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($3373240be9e80763$exports))),
            onEmojiSelect: (e)=>{
                props.setUserType({
                    ...props.userType,
                    icon: e.id
                });
                setIsPickerVisible(false);
            },
            onClick: (e)=>{
                e.stopPropagation();
            }
        })
    });
    (0, $ltGt3.useLayoutEffect)(()=>{
        const globalClickHandler = (e)=>{
            if (!pickerRef.current) return;
            if (pickerRef.current.contains(e?.target)) return;
            if (isPickerVisible) setIsPickerVisible(false);
        };
        document.addEventListener('click', globalClickHandler);
        return ()=>document.removeEventListener('click', globalClickHandler);
    });
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
        style: {
            display: 'flex'
        },
        onClick: (e)=>e.stopPropagation(),
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6425aad248c6262a$export$2e2bcd8739ae039), {
                placement: "bottomLeft",
                content: picker,
                trigger: [],
                open: isPickerVisible,
                onOpenChange: (open)=>setIsPickerVisible(open),
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                    onClick: (e)=>setIsPickerVisible(true),
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f952978d00baf9e4$export$60d30b2661acb1b8), {
                        id: props.userType.icon,
                        size: "1em"
                    })
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    width: '100%',
                    position: 'relative'
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039), {
                    disabled: false,
                    value: props.userType.name,
                    readOnly: false,
                    placeholder: intl.formatMessage({
                        id: 'newTypeName'
                    }),
                    onChange: (e)=>{
                        props.setUserType({
                            ...props.userType,
                            name: e.target.value
                        });
                    }
                })
            })
        ]
    });
}


function $1a7e848651bd1caa$export$b271fe335228f2ed(props) {
    const [modalOpen, setModalOpen] = (0, $ltGt3.useState)(false);
    const [newUserType, setNewUserType] = (0, $ltGt3.useState)(props.userType);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f189c84ec54ae7cf$export$2e2bcd8739ae039), {
                open: modalOpen,
                onOk: async ()=>{
                    const result = await props.onEditType(newUserType);
                    if (result.success) {
                        setNewUserType(props.userType);
                        setModalOpen(false);
                    }
                },
                onCancel: ()=>setModalOpen(false),
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    onClick: (e)=>e.stopPropagation(),
                    onMouseDown: (e)=>e.stopPropagation(),
                    style: {
                        paddingRight: '20px'
                    },
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $596463b50963aa35$export$c252589de2aeff00), {
                        userType: newUserType,
                        setUserType: setNewUserType
                    })
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                type: "link",
                color: "primary",
                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $792ee1d77f42b361$export$2e2bcd8739ae039), {}),
                onClick: ()=>{
                    setNewUserType(props.userType);
                    setModalOpen(true);
                }
            })
        ]
    });
}




function $1a1127575c7055e0$var$getOptionKey(item) {
    if (!item.id) return `custom-${item.name}`;
    else return item.id;
}
function $1a1127575c7055e0$var$todoTypeToSelectOption(item) {
    return {
        item: item,
        label: item,
        value: $1a1127575c7055e0$var$getOptionKey(item)
    };
}
function $1a1127575c7055e0$export$cb478945c10344f6({ commonTypes: commonTypes, userTypes: userTypes, chosenType: chosenType, onChange: onChange = (newChosenType)=>{}, createNewItem: createNewItem, editType: editType, deleteUserType: deleteUserType, defaultWhenCleared: defaultWhenCleared = null, editable: editable = true, isAllowClear: isAllowClear = true }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    //const revalidator = useRevalidator()
    //const [selectedType, setSelectedType] = useState(toSelectItem(chosenType))
    const selectOptions = [
        ...commonTypes,
        ...userTypes
    ];
    const [loading, setLoading] = (0, $ltGt3.useState)(false);
    const [dropdownOpen, setDropdownOpen] = (0, $ltGt3.useState)(false);
    const [dropdownSticky, setDropdownSticky] = (0, $ltGt3.useState)(false);
    const [newUserType, setNewUserType] = (0, $ltGt3.useState)({
        id: null,
        icon: "\uD83E\uDDD1\u200D\uD83C\uDF3E",
        name: ''
    });
    const inputRef = (0, $ltGt3.useRef)(null);
    const [name, setName] = (0, $ltGt3.useState)('');
    const onNameChange = (event)=>{
        setName(event.target.value);
    };
    let index = 0;
    async function createUserType(e) {
        e.preventDefault();
        setLoading(true);
        try {
            const result = await createNewItem(newUserType.name || `New item ${index++}`, newUserType.icon);
            result.success;
        } finally{
            setName('');
            setLoading(false);
        }
    }
    (0, $ltGt3.useEffect)(()=>{
        if (!chosenType?.id) return;
        let found = false;
        for (const userType of userTypes)if (chosenType.id === userType.id) {
            onChange(userType);
            found = true;
        }
        if (!found) onChange(defaultWhenCleared);
    }, [
        userTypes
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
        optionLabelProp: "label",
        open: dropdownOpen,
        onOpenChange: (newValue)=>{
            if (dropdownSticky) return;
            setDropdownOpen(newValue);
        },
        style: {
            minWidth: 200,
            marginTop: 10,
            marginBottom: 10
        },
        placeholder: intl.formatMessage({
            id: 'chooseType'
        }),
        value: chosenType ? $1a1127575c7055e0$var$todoTypeToSelectOption(chosenType) : undefined,
        labelInValue: true,
        onChange: (_, newType)=>{
            if (Array.isArray(newType)) newType = newType[0];
            if (loading) return;
            onChange(newType ? newType.item : null);
        },
        //defaultValue={todoTypeToSelectOption({id: null, name: 'general', icon: '📄'})}
        allowClear: isAllowClear,
        disabled: !editable,
        options: [
            ...commonTypes,
            ...userTypes
        ].map($1a1127575c7055e0$var$todoTypeToSelectOption),
        popupRender: (menu)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f5e177132d6f3f0f$export$2e2bcd8739ae039), {
                spinning: loading,
                delay: 300,
                children: [
                    menu,
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                        style: {
                            margin: '8px 0'
                        }
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d029ee757225a242$export$2e2bcd8739ae039), {
                        style: {
                            padding: '0 8px 4px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $596463b50963aa35$export$c252589de2aeff00), {
                                userType: newUserType,
                                setUserType: setNewUserType,
                                onEmojiDropdownVisibleChange: setDropdownSticky
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                type: "text",
                                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $da40d833ab151490$export$2e2bcd8739ae039), {}),
                                onClick: async (e)=>{
                                    await createUserType(e);
                                    setNewUserType({
                                        id: null,
                                        icon: "\uD83E\uDDD1\u200D\uD83C\uDF3E",
                                        name: ''
                                    });
                                }
                            })
                        ]
                    })
                ]
            }),
        labelRender: (label)=>{
            const { id: id, name: name, icon: icon } = label.label;
            return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "type-item",
                style: {
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    alignItems: 'center'
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                    style: {
                        flexGrow: 1,
                        flexShrink: 1,
                        maxWidth: '100%',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis'
                    },
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f952978d00baf9e4$export$60d30b2661acb1b8), {
                            id: icon,
                            size: "1em"
                        }),
                        ` ${id ? name : name ? intl.formatMessage({
                            id: `eventType-${name}`
                        }) : ''}`
                    ]
                })
            });
        },
        optionRender: (option)=>{
            const item = option.data.item;
            const { id: id, name: name, icon: icon } = item;
            return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9d004cf64875b9d1$exports.Fragment), {
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "type-item",
                    style: {
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        alignItems: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                            style: {
                                flexGrow: 1,
                                flexShrink: 1,
                                maxWidth: '100%',
                                overflow: 'hidden',
                                textWrap: 'wrap'
                            },
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f952978d00baf9e4$export$60d30b2661acb1b8), {
                                    id: icon,
                                    size: "1em"
                                }),
                                ` ${id ? name : intl.formatMessage({
                                    id: `eventType-${name}`
                                })}`
                            ]
                        }),
                        id !== null && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1a7e848651bd1caa$export$b271fe335228f2ed), {
                                    userType: {
                                        ...item,
                                        id: id
                                    },
                                    onEditType: async (editedType)=>{
                                        const editingResult = await editType(editedType);
                                        // setSelectOptions(
                                        //   selectOptions.map((opt) => {
                                        //     if (opt.id === editedType.id) {
                                        //       return editedType
                                        //     } else {
                                        //       return opt
                                        //     }
                                        //   })
                                        // )
                                        return editingResult;
                                    }
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                    style: {
                                        flexGrow: 0,
                                        flexShrink: 0
                                    },
                                    onClick: (e)=>e.stopPropagation(),
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
                                        placement: "bottom",
                                        title: intl.formatMessage({
                                            id: 'areYouSureYouWantToDeleteThisType'
                                        }),
                                        description: intl.formatMessage({
                                            id: 'typeOfTheCorrespondingTasksAndEventsWillBeChangedToGeneral'
                                        }),
                                        icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7fa69e90b193286$export$2e2bcd8739ae039), {
                                            style: {
                                                color: 'red'
                                            }
                                        }),
                                        onConfirm: ()=>{
                                            setLoading(true);
                                            deleteUserType(id);
                                            // setSelectOptions(
                                            //   selectOptions.filter((opt) => {
                                            //     return opt.id != option.data.objectData.id
                                            //   })
                                            // )
                                            //revalidator.revalidate()
                                            setLoading(false);
                                        },
                                        okText: intl.formatMessage({
                                            id: 'yes'
                                        }),
                                        cancelText: intl.formatMessage({
                                            id: 'no'
                                        }),
                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1e0519456d104339$export$2e2bcd8739ae039), {
                                            className: "delete-collection",
                                            color: "red"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            });
        }
    });
}





parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
const $37433922b4b56270$export$cc878a2dec777c51 = 1320;
const $37433922b4b56270$export$c82cc3fe6a7d47b7 = 700;
function $37433922b4b56270$export$32d5543ab307c01(query) {
    const [matches, setMatches] = (0, $ltGt3.useState)(()=>window.matchMedia?.(query).matches ?? false);
    (0, $ltGt3.useEffect)(()=>{
        const mediaQueryList = window.matchMedia?.(query);
        if (!mediaQueryList) return;
        const onChange = (e)=>setMatches(e.matches);
        setMatches(mediaQueryList.matches);
        mediaQueryList.addEventListener('change', onChange);
        return ()=>mediaQueryList.removeEventListener('change', onChange);
    }, [
        query
    ]);
    return matches;
}
function $37433922b4b56270$export$323ff2a228bf6a81() {
    return $37433922b4b56270$export$32d5543ab307c01(`only screen and (max-width: ${$37433922b4b56270$export$cc878a2dec777c51}px)`);
}
function $37433922b4b56270$export$83fa72011cf1e8d2() {
    return $37433922b4b56270$export$32d5543ab307c01(`only screen and (max-width: ${$37433922b4b56270$export$c82cc3fe6a7d47b7}px)`);
}



function $e846e12ce1da647b$export$17334619f3ac2224({ value: value, onChange: onChange, id: id, disabled: disabled, presets: presets }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const isMobileNarrow = (0, $37433922b4b56270$export$83fa72011cf1e8d2)();
    const [start, end] = value || [
        null,
        null
    ];
    if (!isMobileNarrow) return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $878317098e859dd0$export$2e2bcd8739ae039).RangePicker, {
        id: id,
        disabled: disabled,
        value: value,
        presets: presets,
        onChange: (dates)=>onChange?.(dates || [
                null,
                null
            ])
    });
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "date-range-picker",
        children: [
            presets?.length > 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "date-range-picker__presets",
                children: presets.map((preset)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        size: "small",
                        disabled: disabled,
                        onClick: ()=>onChange?.(preset.value),
                        children: preset.label
                    }, preset.label))
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "date-range-picker__fields",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $878317098e859dd0$export$2e2bcd8739ae039), {
                        id: id,
                        disabled: disabled,
                        value: start,
                        maxDate: end || undefined,
                        placeholder: intl.formatMessage({
                            id: 'startDate'
                        }),
                        onChange: (newStart)=>onChange?.([
                                newStart,
                                end
                            ])
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $878317098e859dd0$export$2e2bcd8739ae039), {
                        disabled: disabled,
                        value: end,
                        minDate: start || undefined,
                        placeholder: intl.formatMessage({
                            id: 'endDate'
                        }),
                        onChange: (newEnd)=>onChange?.([
                                start,
                                newEnd
                            ])
                    })
                ]
            })
        ]
    });
}


(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).extend((0, (/*@__PURE__*/$parcel$interopDefault($f2de6326bdf75f7a$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5fac0199f9afa6dd$exports))));
const $a8a4f61d59f3eccc$var$validateMessages = {
    required: '${label} is required!'
};
const $a8a4f61d59f3eccc$var$normFile = (e)=>{
    if (Array.isArray(e)) return e;
    return e?.fileList;
};
function $a8a4f61d59f3eccc$export$5fbfe03fe02b533e({ onFormClose: onFormClose, currentEvent: currentEvent, plantId: plantId, onPlantEventListUpdated: onPlantEventListUpdated = ()=>{}, editable: editable = true, setLoading: setLoading = ()=>{}, userJournalEventTypes: userJournalEventTypes, currentPlant: currentPlant }) {
    const [eventForm] = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useForm();
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const files = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useWatch('files', eventForm);
    const newFiles = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useWatch('newFiles', eventForm);
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    const [isRange, setIsRange] = (0, $ltGt3.useState)(false);
    (0, $ltGt3.useEffect)(()=>{
        (async ()=>{
            const fieldValues = !currentEvent ? {} : {
                ...currentEvent,
                startDateUtc: currentEvent?.startDateUtc ? (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(currentEvent.startDateUtc, (0, $ec20113856fdaafd$export$4e4cb19dd88cd821)) : null,
                endDateUtc: currentEvent?.endDateUtc ? (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(currentEvent.endDateUtc, (0, $ec20113856fdaafd$export$4e4cb19dd88cd821)) : null,
                actualCompletionDateUtc: currentEvent?.actualCompletionDateUtc ? (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(currentEvent.actualCompletionDateUtc, (0, $ec20113856fdaafd$export$4e4cb19dd88cd821)) : null,
                files: [],
                chosenType: currentEvent.type.type === 'custom' ? currentEvent.type.customJournalEventType : {
                    id: null,
                    name: currentEvent.type.type,
                    icon: (0, $6dfc071b399cc1b6$export$43852040ec70d1af)(currentEvent.type).icon
                }
            };
            eventForm.setFieldsValue(fieldValues);
        // const signedPhotoURLs = await eventsService.getPlantEventImageURLs(currentEvent?.photos)
        // eventForm.setFieldsValue({
        //   ...fieldValues,
        //   files: currentEvent?.photos?.map((photoName, index) => ({
        //     uid: index,
        //     photoName: photoName,
        //     status: 'done',
        //     //url: signedPhotoURLs.urls[index],
        //   })),
        // })
        })();
    }, [
        currentEvent
    ]);
    const onCreateUserEventType = async (name, icon)=>{
        const creatingResult = await (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).createUserJournalEventType(name, icon);
        if (creatingResult.success) {
            (0, $6139c0a58835b448$export$f5708c5af9a60b0c)();
            revalidator.revalidate();
        }
        return creatingResult;
    };
    const onEditUserEventType = async (newType)=>{
        const editingResult = await (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).editUserJournalEventType(newType);
        if (editingResult.success) {
            (0, $6139c0a58835b448$export$f5708c5af9a60b0c)();
            revalidator.revalidate();
        }
        return editingResult;
    };
    const onDeleteUserEventType = async (deletedTypeId)=>{
        const deletingResult = await (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).deleteUserJournalEventType(deletedTypeId);
        if (deletingResult.success) {
            (0, $6139c0a58835b448$export$f5708c5af9a60b0c)();
            revalidator.revalidate();
        }
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ad1c3304c519fac5$export$2e2bcd8739ae039), {
                title: intl.formatMessage({
                    id: 'eventInfo'
                }),
                className: "plant-event-form",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $b56d75f9dce54730$export$2e2bcd8739ae039), {
                    form: eventForm,
                    labelCol: {
                        span: 24
                    },
                    wrapperCol: {
                        span: 24
                    },
                    autoComplete: "off",
                    layout: "vertical",
                    validateMessages: $a8a4f61d59f3eccc$var$validateMessages,
                    onFinish: async (formState)=>{
                        let result;
                        const timeEvent = {
                            comment: formState.comment,
                            type: formState.chosenType.id ? {
                                type: 'custom',
                                customJournalEventType: formState.chosenType
                            } : {
                                type: formState.chosenType.name
                            },
                            plant: {
                                id: plantId,
                                name: ''
                            },
                            actualCompletionDateUtc: (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(formState.actualCompletionDateUtc).utc(true),
                            startDateUtc: isRange ? formState.dateRange?.[0]?.format((0, $ec20113856fdaafd$export$4e4cb19dd88cd821)) : formState.date?.format((0, $ec20113856fdaafd$export$4e4cb19dd88cd821)),
                            endDateUtc: isRange ? formState.dateRange?.[1]?.format((0, $ec20113856fdaafd$export$4e4cb19dd88cd821)) : null
                        };
                        if (currentEvent) {
                            const { ...existingPlantEvent } = currentEvent;
                            result = await (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).editJournalEvent({
                                ...existingPlantEvent,
                                ...timeEvent
                            }, formState.newFiles, formState.files?.map((file, index)=>file.photoName));
                        } else result = await (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).createJournalEvent(timeEvent, formState.newFiles);
                        if (result.success) {
                            revalidator.revalidate();
                            onPlantEventListUpdated();
                            submit(currentPlant ? {
                                id: String(currentPlant.id)
                            } : null, {
                                method: 'post'
                            });
                        } else messageApi.open({
                            type: 'error',
                            content: result.error
                        });
                        onFormClose();
                    },
                    children: [
                        currentEvent?.plant?.id && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                intl.formatMessage({
                                    id: 'plant'
                                }),
                                " :",
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                    to: `/journal/${currentEvent.id}/plants/${currentEvent.plant.id}`,
                                    children: currentEvent.plant.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                            name: "chosenType",
                            valuePropName: "chosenType",
                            label: intl.formatMessage({
                                id: 'eventType'
                            }),
                            children: editable ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1a1127575c7055e0$export$cb478945c10344f6), {
                                commonTypes: Object.keys((0, $6dfc071b399cc1b6$export$84362538fd926f28)).map((type)=>({
                                        id: null,
                                        name: type,
                                        icon: (0, $6dfc071b399cc1b6$export$84362538fd926f28)[type]?.icon
                                    })),
                                userTypes: userJournalEventTypes.map((type)=>({
                                        id: type.customJournalEventType.id,
                                        name: type.customJournalEventType.name,
                                        icon: type.customJournalEventType.icon
                                    })),
                                createNewItem: onCreateUserEventType,
                                editable: editable,
                                deleteUserType: onDeleteUserEventType,
                                editType: onEditUserEventType,
                                isAllowClear: false
                            }) : currentEvent.type.type && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9d004cf64875b9d1$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                    children: ` ${(0, $6dfc071b399cc1b6$export$43852040ec70d1af)(currentEvent.type).icon} ${intl.formatMessage({
                                        id: `eventType-${(0, $6dfc071b399cc1b6$export$43852040ec70d1af)(currentEvent.type).name}`
                                    })}`
                                })
                            })
                        }),
                        editable ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column'
                            },
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                    label: intl.formatMessage({
                                        id: 'dateRange'
                                    }),
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9abdade5fdd0845b$export$2e2bcd8739ae039), {
                                        checked: isRange,
                                        onChange: setIsRange
                                    })
                                }),
                                isRange ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                    name: "dateRange",
                                    label: intl.formatMessage({
                                        id: 'dateRange'
                                    }),
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e846e12ce1da647b$export$17334619f3ac2224), {})
                                }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                    name: "date",
                                    label: intl.formatMessage({
                                        id: 'date'
                                    }),
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $878317098e859dd0$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }) : currentEvent.startDateUtc && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                intl.formatMessage({
                                    id: 'date'
                                }),
                                ":",
                                ` ${currentEvent.startDateUtc}`,
                                currentEvent.endDateUtc && ` - ${currentEvent.endDateUtc}`
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                            name: "actualCompletionDateUtc",
                            label: intl.formatMessage({
                                id: 'eventEndDate'
                            }),
                            rules: [
                                {
                                    required: true
                                }
                            ],
                            children: editable ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $878317098e859dd0$export$2e2bcd8739ae039), {
                                disabled: !editable
                            }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                children: `${currentEvent.actualCompletionDateUtc}`
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                            name: "comment",
                            label: intl.formatMessage({
                                id: 'comment'
                            }),
                            children: editable ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).TextArea, {
                                disabled: !editable
                            }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                children: `${currentEvent.comment ? currentEvent.comment : ''}`
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            },
                            children: [
                                editable && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                        onClick: async ()=>{
                                            onFormClose();
                                        },
                                        children: intl.formatMessage({
                                            id: 'cancel'
                                        })
                                    })
                                }),
                                currentEvent ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
                                        title: intl.formatMessage({
                                            id: 'deleteEvent'
                                        }),
                                        description: `${intl.formatMessage({
                                            id: 'areYouSureYouWantToDeleteThisEvent'
                                        })} ${intl.formatMessage({
                                            id: 'thisOperationIsIrreversible'
                                        })}`,
                                        onConfirm: async ()=>{
                                            await (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).deleteJournalEvent(currentEvent);
                                            onPlantEventListUpdated();
                                            onFormClose();
                                            //submit(null, {method: 'delete'})
                                            submit(currentPlant ? {
                                                id: String(currentPlant.id)
                                            } : null, {
                                                method: 'post'
                                            });
                                        },
                                        onCancel: ()=>{},
                                        okText: intl.formatMessage({
                                            id: 'yes'
                                        }),
                                        cancelText: intl.formatMessage({
                                            id: 'no'
                                        }),
                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                            children: intl.formatMessage({
                                                id: 'deleteEvent'
                                            })
                                        })
                                    })
                                }) : null,
                                editable && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                        htmlType: "submit",
                                        type: "primary",
                                        children: currentEvent ? intl.formatMessage({
                                            id: 'saveEvent'
                                        }) : intl.formatMessage({
                                            id: 'addEvent'
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}










var $ltGt3 = parcelRequire("ltGt3");





var $Ohofd = parcelRequire("Ohofd");



parcelRequire("ltGt3");

function $e5aba1e909288d7b$export$1556c52bf683f8cb(plant, isCurrent) {
    return {
        label: plant.name,
        value: String(plant.id),
        disabled: isCurrent
    };
}
function $e5aba1e909288d7b$export$cf5de6bdb4916f6b({ plantsList: plantsList, currentPlant: currentPlant, fieldName: fieldName = 'todoPlants' }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
        name: fieldName,
        label: intl.formatMessage({
            id: 'plant'
        }),
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
            allowClear: !currentPlant,
            mode: "multiple",
            options: plantsList?.map((plant)=>$e5aba1e909288d7b$export$1556c52bf683f8cb(plant, currentPlant && plant.id === currentPlant.id)),
            filterOption: (search, option)=>(option?.label ?? '').toLowerCase().includes(search.toLowerCase())
        })
    });
}






parcelRequire("ltGt3");



function $b3fbbf7661b740f8$export$69587e66a3f77d63(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039), {
            className: "todo__filters__list",
            itemLayout: "horizontal",
            dataSource: [
                ...props.elements || []
            ],
            renderItem: (item)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039).Item, {
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                            checked: props.checkedElements[item.id],
                            onChange: (e)=>{
                                const { checked: checked } = e.target;
                                props.setCheckedElements({
                                    ...props.checkedElements,
                                    [item.id]: checked
                                });
                            },
                            children: item.name
                        })
                    })
                })
        })
    });
}
function $b3fbbf7661b740f8$export$b8f146b49a08b426(props) {
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($b3fbbf7661b740f8$export$69587e66a3f77d63, {
        elements: props.elements,
        checkedElements: props.value || {},
        setCheckedElements: props.onChange || (()=>{}),
        currentPlant: props.currentPlant
    });
}




var $ltGt3 = parcelRequire("ltGt3");









function $6c5e1b366c6fbae7$export$fd08269e63299641(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [changedUserType, setChangedUserType] = (0, $ltGt3.useState)(props.customToDoType);
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    if (props.customToDoType.id === props.editableTypeId) return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $596463b50963aa35$export$c252589de2aeff00), {
                userType: changedUserType,
                setUserType: setChangedUserType
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                type: "link",
                onClick: async ()=>{
                    const result = await (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).editUserToDoType(props.customToDoType);
                    if (result.success) {
                        props.setEditableTypeId(null);
                        props.onChangeUserType(result.data);
                        submit(result.data.id ? {
                            id: String(result.data.id)
                        } : null, {
                            method: 'post'
                        });
                    }
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b22ab34d306c7e4e$export$2e2bcd8739ae039), {})
            })
        ]
    });
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039), {
        value: props.customToDoType,
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
            style: {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                    style: {
                        flexGrow: 1,
                        wordBreak: 'break-word'
                    },
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f952978d00baf9e4$export$60d30b2661acb1b8), {
                            id: props.customToDoType.icon,
                            size: "1em"
                        }),
                        props.customToDoType.name
                    ]
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                    style: {
                        display: 'flex',
                        flexWrap: 'nowrap',
                        flexDirection: 'row',
                        width: 'min-content',
                        alignItems: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1a7e848651bd1caa$export$b271fe335228f2ed), {
                            userType: props.customToDoType,
                            onEditType: props.onChangeUserType
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
                            placement: "bottom",
                            title: intl.formatMessage({
                                id: 'areYouSureYouWantToDelete'
                            }),
                            description: intl.formatMessage({
                                id: 'thisOperationIsIrreversible'
                            }),
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7fa69e90b193286$export$2e2bcd8739ae039), {
                                style: {
                                    color: 'red'
                                }
                            }),
                            onConfirm: (e)=>props.onDeleteUserType(props.customToDoType.id),
                            okText: intl.formatMessage({
                                id: 'yes'
                            }),
                            cancelText: intl.formatMessage({
                                id: 'no'
                            }),
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                type: "link",
                                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1e0519456d104339$export$2e2bcd8739ae039), {})
                            })
                        })
                    ]
                })
            ]
        })
    });
}






var $ltGt3 = parcelRequire("ltGt3");







var $Ohofd = parcelRequire("Ohofd");




let $25dcb8eadeb85629$var$forceRevalidate = true;
function $25dcb8eadeb85629$export$fd2a4e136cbbe0d7() {
    $25dcb8eadeb85629$var$forceRevalidate = true;
}
const $25dcb8eadeb85629$export$351c88f98aecaeee = ({ currentParams: currentParams, nextParams: nextParams, formMethod: formMethod })=>{
    if (formMethod === 'post') return true;
    if ($25dcb8eadeb85629$var$forceRevalidate) {
        $25dcb8eadeb85629$var$forceRevalidate = false;
        return true;
    }
    return currentParams.todoId != nextParams.todoId;
};


const $275f7c91555fa32e$var$defaultEventType = {
    id: null,
    name: (0, $6dfc071b399cc1b6$export$84362538fd926f28).general.name,
    icon: (0, $6dfc071b399cc1b6$export$84362538fd926f28).general.icon
};
function $275f7c91555fa32e$export$378cead5a31fefcf(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [completionDate, setCompletionDate] = (0, $ltGt3.useState)(new Date());
    const [finishedToDoEventType, setFinishedToDoEventType] = (0, $ltGt3.useState)(!props.finishedTodo.type || props.finishedTodo.type.type === 'custom' || !props.finishedTodo.type?.type ? $275f7c91555fa32e$var$defaultEventType : {
        id: null,
        name: (0, $6dfc071b399cc1b6$export$84362538fd926f28)[(0, $6dfc071b399cc1b6$export$a348c25fe51a3de8)[props.finishedTodo.type.type]].name,
        icon: (0, $6dfc071b399cc1b6$export$84362538fd926f28)[(0, $6dfc071b399cc1b6$export$a348c25fe51a3de8)[props.finishedTodo.type.type]].icon
    });
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const onCreateNewUserEventType = async (name, icon)=>{
        const result = await (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).createUserJournalEventType(name, icon);
        if (result.success) {
            (0, $6139c0a58835b448$export$f5708c5af9a60b0c)();
            (0, $25dcb8eadeb85629$export$fd2a4e136cbbe0d7)();
            revalidator.revalidate();
        }
        return result;
    };
    const onEditUserEventType = async (editedType)=>{
        const editingResult = await (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).editUserJournalEventType(editedType);
        if (editingResult.success) {
            (0, $6139c0a58835b448$export$f5708c5af9a60b0c)();
            (0, $25dcb8eadeb85629$export$fd2a4e136cbbe0d7)();
            revalidator.revalidate();
        }
        return editingResult;
    };
    const onDeleteUserEventType = async (deletedTypeId)=>{
        const deletingResult = await (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).deleteUserJournalEventType(deletedTypeId);
        if (deletingResult.success) {
            (0, $6139c0a58835b448$export$f5708c5af9a60b0c)();
            (0, $25dcb8eadeb85629$export$fd2a4e136cbbe0d7)();
            revalidator.revalidate();
        }
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
        placement: "bottom",
        title: intl.formatMessage({
            id: 'areYouSureYouWantToFinish'
        }),
        description: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    children: intl.formatMessage({
                        id: 'thisOperationWillMoveTask'
                    })
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    children: [
                        intl.formatMessage({
                            id: 'selectTheTaskCompletionDate'
                        }),
                        ":",
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $878317098e859dd0$export$2e2bcd8739ae039), {
                                    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(completionDate),
                                    onChange: (value)=>{
                                        setCompletionDate(value.toDate());
                                    }
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1a1127575c7055e0$export$cb478945c10344f6), {
                                    chosenType: finishedToDoEventType || undefined,
                                    onChange: setFinishedToDoEventType,
                                    commonTypes: Object.keys((0, $6dfc071b399cc1b6$export$84362538fd926f28)).map((type)=>({
                                            id: null,
                                            name: type,
                                            icon: (0, $6dfc071b399cc1b6$export$84362538fd926f28)[type].icon
                                        })),
                                    userTypes: props.userJournalEventTypes.map((type)=>({
                                            id: type.customJournalEventType.id,
                                            name: type.customJournalEventType.name,
                                            icon: type.customJournalEventType.icon
                                        })),
                                    createNewItem: onCreateNewUserEventType,
                                    editType: onEditUserEventType,
                                    deleteUserType: onDeleteUserEventType,
                                    defaultWhenCleared: $275f7c91555fa32e$var$defaultEventType,
                                    isAllowClear: false
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7fa69e90b193286$export$2e2bcd8739ae039), {
            style: {
                color: 'red'
            }
        }),
        onConfirm: async ()=>{
            const result = await (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).finishToDo(props.finishedTodo, completionDate, finishedToDoEventType || $275f7c91555fa32e$var$defaultEventType);
            if (result.success) submit(null, {
                method: 'post'
            });
            else (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).open({
                type: 'error',
                content: result.error?.message
            });
        },
        okText: intl.formatMessage({
            id: 'yes'
        }),
        cancelText: intl.formatMessage({
            id: 'no'
        }),
        children: props.isText ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
            type: "primary",
            style: {
                display: 'flex'
            },
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b22ab34d306c7e4e$export$2e2bcd8739ae039), {}, "done"),
                props.isText && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                    children: intl.formatMessage({
                        id: 'finish'
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b22ab34d306c7e4e$export$2e2bcd8739ae039), {
            onClick: (e)=>{
                e.stopPropagation();
                e.preventDefault();
            }
        }, "done")
    });
}



parcelRequire("ltGt3");



function $fc0c5f29861e5024$export$19b7ae6871c2a60c({ userCollections: userCollections, isOpen: isOpen, onCloseNewSelected: onCloseNewSelected, onCancel: onCancel, chosenUserCollections: chosenUserCollections, setChosenUserCollections: setChosenUserCollections }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f189c84ec54ae7cf$export$2e2bcd8739ae039), {
        className: "collections-select",
        open: isOpen,
        onCancel: onCancel,
        title: intl.formatMessage({
            id: 'collections'
        }),
        destroyOnHidden: true,
        okText: intl.formatMessage({
            id: 'select'
        }),
        onOk: onCloseNewSelected,
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
            children: [
                intl.formatMessage({
                    id: 'selectPlantsFromTheMarkedCollections'
                }),
                ":",
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039), {
                    className: "collections-select__list",
                    itemLayout: "horizontal",
                    dataSource: [
                        ...userCollections
                    ],
                    renderItem: (item)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039).Item, {
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                                    checked: chosenUserCollections[item.id],
                                    onChange: (e)=>{
                                        const { checked: checked } = e.target;
                                        setChosenUserCollections({
                                            ...chosenUserCollections,
                                            [item.id]: checked
                                        });
                                    },
                                    children: item.name
                                })
                            })
                        })
                })
            ]
        })
    });
}






const $cd7dce9aaa9186a9$var$validateMessages = {
    required: '${label} is required!'
};
function $cd7dce9aaa9186a9$export$9e07cf364e4725cb({ currentToDo: currentToDo, projectId: projectId, isFinished: isFinished, currentPlant: currentPlant, plantedPlantsNamesWithId: plantedPlantsNamesWithId, toDoTypes: toDoTypes, userEventTypes: //setToDoTypes,
userEventTypes, closeModal: closeModal = ()=>{}, setLoading: setLoading = ()=>{}, isFullForm: isFullForm, userPlantCollections: userPlantCollections, userPlantCollectionsWithPlantsIds: userPlantCollectionsWithPlantsIds }) {
    const [form] = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useForm();
    const [isRange, setIsRange] = (0, $ltGt3.useState)(false);
    const [isSubmitting, setSubmitting] = (0, $ltGt3.useState)(false);
    const [newUserType, setNewUserType] = (0, $ltGt3.useState)({
        id: null,
        icon: "\uD83E\uDDD1\u200D\uD83C\uDF3E",
        name: ''
    });
    const [editableTypeId, setEditableTypeId] = (0, $ltGt3.useState)(null);
    const user = (0, $d433dc3c3e640619$export$3901076af3749fa9)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const availablePlants = plantedPlantsNamesWithId?.filter((plant)=>!plant.gardenPlanVariantId);
    const [isSelectCollectionsModalOpen, setIsSelectCollectionsModalOpen] = (0, $ltGt3.useState)(false);
    const [chosenUserCollections, setChosenUserCollections] = (0, $ltGt3.useState)({});
    (0, $ltGt3.useEffect)(()=>{
        const newFieldValues = {
            importance: 'normal',
            ...currentToDo || {}
        };
        let startDate = null;
        let endDate = null;
        if (currentToDo?.targetStartDateUtc) startDate = (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(currentToDo.targetStartDateUtc, (0, $ec20113856fdaafd$export$4e4cb19dd88cd821));
        if (currentToDo?.targetEndDateUtc) endDate = (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(currentToDo.targetEndDateUtc, (0, $ec20113856fdaafd$export$4e4cb19dd88cd821));
        // read once so the union narrows; a predefined type has no id of its own
        const currentType = currentToDo?.type;
        const chosenType = !currentType ? null : currentType.type === 'custom' ? currentType.customToDoType : {
            id: null,
            name: currentType.type,
            icon: (0, $6dfc071b399cc1b6$export$bd87dd6af1226f02)(currentType).icon
        };
        form.setFieldsValue({
            importance: 'normal',
            todoPlants: currentPlant && !currentToDo ? [
                (0, $e5aba1e909288d7b$export$1556c52bf683f8cb)(currentPlant, true)
            ] : plantedPlantsNamesWithId?.filter((plant)=>currentToDo?.plants?.map((todoPlant)=>todoPlant.id === plant.id).some((x)=>x)).map((plant)=>(0, $e5aba1e909288d7b$export$1556c52bf683f8cb)(plant, currentPlant && plant.id === currentPlant.id)) || null,
            ...currentToDo || {},
            date: startDate,
            dateRange: [
                startDate,
                endDate
            ],
            chosenType: chosenType
        });
        setIsRange(Boolean(currentToDo?.targetEndDateUtc));
    }, [
        currentToDo
    ]);
    const onDeleteUserToDoType = async (deletedTypeId)=>{
        const deletingResult = await (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).deleteUserToDoType(deletedTypeId);
        if (deletingResult.success) {
            (0, $6139c0a58835b448$export$f5708c5af9a60b0c)();
            (0, $25dcb8eadeb85629$export$fd2a4e136cbbe0d7)();
            revalidator.revalidate();
            // if (!isFullForm && form.getFieldValue('chosenType').id === deletedTypeId) {
            //   form.setFieldValue('chosenType', {id: null, icon: '📄', name: undefined})
            // }
            setEditableTypeId(null);
        }
    };
    const onEditUserToDoType = async (editedType)=>{
        const editingResult = await (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).editUserToDoType(editedType);
        if (editingResult.success) {
            (0, $6139c0a58835b448$export$f5708c5af9a60b0c)();
            (0, $25dcb8eadeb85629$export$fd2a4e136cbbe0d7)();
            revalidator.revalidate();
        // if (!isFullForm && form.getFieldValue('chosenType').id === editedType.id) {
        //   form.setFieldValue('chosenType', editedType)
        // }
        }
        return editingResult;
    };
    const onCreateNewUserToDoType = async (name, icon)=>{
        const result = await (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).createUserToDoType(name, icon);
        if (result.success) {
            setNewUserType({
                id: null,
                icon: "\uD83E\uDDD1\u200D\uD83C\uDF3E",
                name: ''
            });
            // setToDoTypes([...toDoTypes, {type: 'custom', customToDoType: result.data}])
            // form.setFieldsValue({chosenType: result.data})
            (0, $6139c0a58835b448$export$f5708c5af9a60b0c)();
            (0, $25dcb8eadeb85629$export$fd2a4e136cbbe0d7)();
            revalidator.revalidate();
        }
        return result;
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: `todo-form ${isFullForm ? 'todo-form--full' : 'todo-form--modal'}`,
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f5e177132d6f3f0f$export$2e2bcd8739ae039), {
                spinning: isSubmitting,
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $b56d75f9dce54730$export$2e2bcd8739ae039), {
                    form: form,
                    autoComplete: "off",
                    labelCol: isFullForm ? {
                        span: 10
                    } : {
                        span: 10
                    },
                    wrapperCol: {
                        span: 14
                    },
                    labelWrap: true,
                    layout: isFullForm ? 'vertical' : 'horizontal',
                    validateMessages: $cd7dce9aaa9186a9$var$validateMessages,
                    onKeyDown: (e)=>{
                        if (e.key === 'Enter') e.preventDefault();
                    },
                    onFinish: async (formState)=>{
                        setSubmitting(true);
                        let result;
                        const toDo = {
                            plants: isFullForm ? Object.keys(formState.plants || {}).map(Number).filter((id)=>!Number.isNaN(id) && formState.plants[id]).map((id)=>({
                                    id: id
                                })) : formState.todoPlants?.length > 0 ? formState.todoPlants.map((todoPlant)=>({
                                    id: Number(todoPlant.value)
                                })) : [],
                            type: formState.chosenType?.id ? {
                                type: 'custom',
                                customToDoType: formState.chosenType
                            } : {
                                type: formState.chosenType?.name
                            },
                            comment: formState.comment,
                            targetStartDateUtc: (isRange ? formState.dateRange?.[0]?.format((0, $ec20113856fdaafd$export$4e4cb19dd88cd821)) : formState.date?.format((0, $ec20113856fdaafd$export$4e4cb19dd88cd821))) || null,
                            targetEndDateUtc: (isRange ? formState.dateRange?.[1]?.format((0, $ec20113856fdaafd$export$4e4cb19dd88cd821)) : null) || null,
                            importance: formState.importance,
                            creationDateUtc: (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().format((0, $ec20113856fdaafd$export$4e4cb19dd88cd821)),
                            ownerId: user.id
                        };
                        if (currentToDo) result = await (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).editToDo({
                            ...currentToDo,
                            ...toDo
                        });
                        else {
                            setLoading(true);
                            result = await (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).upsertToDo(toDo);
                        }
                        if (result.success) {
                            setLoading(false);
                            form.resetFields();
                            setIsRange(false);
                            closeModal();
                            submit(currentPlant ? {
                                id: String(currentPlant.id)
                            } : null, {
                                method: 'post'
                            });
                        } else {
                            setLoading(false);
                            messageApi.open({
                                type: 'error',
                                content: result.error?.message
                            });
                        }
                        setSubmitting(false);
                    },
                    children: [
                        isFullForm && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "todo-form__type column",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                    name: "chosenType",
                                    label: intl.formatMessage({
                                        id: 'taskType'
                                    }),
                                    className: "todo-type-form-item",
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Group, {
                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                            className: "todo-type-selector",
                                            children: [
                                                (0, $6dfc071b399cc1b6$export$b406e03ca3884ba).map((item)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039), {
                                                        value: (0, $6dfc071b399cc1b6$export$2a2c75ecbbc622ea)[item],
                                                        children: [
                                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f952978d00baf9e4$export$60d30b2661acb1b8), {
                                                                id: (0, $6dfc071b399cc1b6$export$2a2c75ecbbc622ea)[item].icon,
                                                                size: "1em"
                                                            }),
                                                            intl.formatMessage({
                                                                id: `eventType-${item}`
                                                            })
                                                        ]
                                                    }, item)),
                                                toDoTypes?.map(({ customToDoType: customToDoType })=>customToDoType ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6c5e1b366c6fbae7$export$fd08269e63299641), {
                                                        customToDoType: customToDoType,
                                                        editableTypeId: editableTypeId,
                                                        setEditableTypeId: setEditableTypeId,
                                                        onChangeUserType: onEditUserToDoType,
                                                        onDeleteUserType: onDeleteUserToDoType
                                                    }, customToDoType.id) : null)
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "new-type-input",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $596463b50963aa35$export$c252589de2aeff00), {
                                            userType: newUserType,
                                            setUserType: setNewUserType
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                            type: "primary",
                                            disabled: newUserType.name === '',
                                            onClick: (e)=>onCreateNewUserToDoType(newUserType.name, newUserType.icon),
                                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $da40d833ab151490$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isFullForm && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9d004cf64875b9d1$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                name: "chosenType",
                                valuePropName: "chosenType",
                                label: intl.formatMessage({
                                    id: 'taskType'
                                }),
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1a1127575c7055e0$export$cb478945c10344f6), {
                                    commonTypes: Object.keys((0, $6dfc071b399cc1b6$export$2a2c75ecbbc622ea)).map((type)=>({
                                            id: null,
                                            name: type,
                                            icon: (0, $6dfc071b399cc1b6$export$2a2c75ecbbc622ea)[type].icon
                                        })),
                                    userTypes: toDoTypes.flatMap(({ customToDoType: customToDoType })=>customToDoType ? [
                                            customToDoType
                                        ] : []),
                                    createNewItem: onCreateNewUserToDoType,
                                    editType: onEditUserToDoType,
                                    deleteUserType: onDeleteUserToDoType
                                })
                            })
                        }),
                        isFullForm ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "todo-form__plant column",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                    name: "plants",
                                    label: intl.formatMessage({
                                        id: 'plants'
                                    }),
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b3fbbf7661b740f8$export$b8f146b49a08b426), {
                                        elements: availablePlants,
                                        currentPlant: currentPlant
                                    })
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    onClick: ()=>setIsSelectCollectionsModalOpen(true),
                                    children: intl.formatMessage({
                                        id: 'collections'
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e5aba1e909288d7b$export$cf5de6bdb4916f6b), {
                            currentPlant: currentPlant,
                            plantsList: availablePlants
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "todo-form__fields column",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'column'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                            label: intl.formatMessage({
                                                id: 'dateRange'
                                            }),
                                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9abdade5fdd0845b$export$2e2bcd8739ae039), {
                                                checked: isRange,
                                                onChange: setIsRange,
                                                "aria-label": intl.formatMessage({
                                                    id: 'dateRange'
                                                })
                                            })
                                        }),
                                        isRange ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                            name: "dateRange",
                                            label: intl.formatMessage({
                                                id: 'dateRange'
                                            }),
                                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e846e12ce1da647b$export$17334619f3ac2224), {})
                                        }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                            name: "date",
                                            label: intl.formatMessage({
                                                id: 'date'
                                            }),
                                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $878317098e859dd0$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                    name: "comment",
                                    label: intl.formatMessage({
                                        id: 'comment'
                                    }),
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).TextArea, {})
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                    label: intl.formatMessage({
                                        id: 'importance'
                                    }),
                                    name: "importance",
                                    className: "todo-form__importance",
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Group, {
                                        children: [
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                                                value: "critical",
                                                children: intl.formatMessage({
                                                    id: 'critical'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                                                value: "urgent",
                                                children: intl.formatMessage({
                                                    id: 'urgent'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                                                value: "normal",
                                                children: intl.formatMessage({
                                                    id: 'normal'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                                                value: "low",
                                                children: intl.formatMessage({
                                                    id: 'low'
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "todo-form__actions",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                                    className: "todo-form__submit column",
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                        htmlType: "submit",
                                        type: "primary",
                                        children: intl.formatMessage({
                                            id: 'save'
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "todo-form__actions__secondary",
                                    children: [
                                        !isFullForm && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                            type: "link",
                                            onClick: ()=>{
                                                closeModal();
                                            },
                                            children: intl.formatMessage({
                                                id: 'cancel'
                                            })
                                        }),
                                        currentToDo && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
                                            placement: "bottom",
                                            title: intl.formatMessage({
                                                id: 'areYouSureYouWantToDelete'
                                            }),
                                            description: intl.formatMessage({
                                                id: 'thisOperationIsIrreversible'
                                            }),
                                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7fa69e90b193286$export$2e2bcd8739ae039), {
                                                style: {
                                                    color: 'red'
                                                }
                                            }),
                                            onConfirm: async ()=>{
                                                const result = await (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).deleteToDo(currentToDo.id);
                                                if (result.success) {
                                                    closeModal();
                                                    submit(currentPlant ? {
                                                        id: String(currentPlant.id)
                                                    } : null, {
                                                        method: 'post'
                                                    });
                                                } else messageApi.open({
                                                    type: 'error',
                                                    content: result.error?.message
                                                });
                                            },
                                            okText: intl.formatMessage({
                                                id: 'yes'
                                            }),
                                            cancelText: intl.formatMessage({
                                                id: 'no'
                                            }),
                                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                                type: "link",
                                                children: intl.formatMessage({
                                                    id: 'delete'
                                                })
                                            })
                                        }),
                                        currentToDo && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275f7c91555fa32e$export$378cead5a31fefcf), {
                                            userJournalEventTypes: userEventTypes,
                                            finishedTodo: currentToDo,
                                            isText: true
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $fc0c5f29861e5024$export$19b7ae6871c2a60c), {
                userCollections: userPlantCollections,
                chosenUserCollections: chosenUserCollections,
                setChosenUserCollections: setChosenUserCollections,
                isOpen: isSelectCollectionsModalOpen,
                onCancel: ()=>{
                    setIsSelectCollectionsModalOpen(false);
                    setChosenUserCollections({});
                },
                onCloseNewSelected: ()=>{
                    setIsSelectCollectionsModalOpen(false);
                    const plantIds = userPlantCollectionsWithPlantsIds.flatMap((collection)=>chosenUserCollections[collection.id] ? collection.plantsIds.map((plant)=>plant.plantedPlantsId) : []);
                    const newSelectedPlants = form.getFieldValue('plants') || {};
                    for (const plantId of plantIds)if (availablePlants?.some((plant)=>plant.id === plantId)) newSelectedPlants[plantId] = true;
                    form.setFieldsValue({
                        plants: newSelectedPlants
                    });
                    setChosenUserCollections({});
                }
            })
        ]
    });
}







var $Ohofd = parcelRequire("Ohofd");

const { CheckableTag: $b74fb5cffe8beb2d$var$CheckableTag } = (0, $275a14ee9b85c941$export$2e2bcd8739ae039);
const $b74fb5cffe8beb2d$var$filters = Object.fromEntries([
    ...Object.entries((0, $6dfc071b399cc1b6$export$84362538fd926f28)).map(([key, meta])=>[
            key,
            false
        ]),
    ...Object.entries((0, $6dfc071b399cc1b6$export$2a2c75ecbbc622ea)).map(([key, meta])=>[
            key,
            false
        ])
]);
function $b74fb5cffe8beb2d$export$c08119d35eaa2f1f({ currentPlantId: currentPlantId, currentPlantName: currentPlantName, timeEvents: plantTimeEvents, plantToDos: plantToDos, userToDoTypes: userToDoTypes, userEventTypes: userEventTypes, isPlantDeleted: isPlantDeleted }) {
    const { token: { colorPrimary: colorPrimary, colorPrimaryBorder: colorPrimaryBorder, borderRadiusXS: borderRadiusXS } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    const [viewedTypesOfEvents, setViewedTypesOfEvents] = (0, $ltGt3.useState)($b74fb5cffe8beb2d$var$filters);
    const [isAddingEvent, setAddingEvent] = (0, $ltGt3.useState)(false);
    const [isAddingTask, setAddingTask] = (0, $ltGt3.useState)(false);
    const [currentPlantEventId, setCurrentPlantEventId] = (0, $ltGt3.useState)(null);
    const [currentPlantTask, setCurrentPlantTask] = (0, $ltGt3.useState)(null);
    const user = (0, $d433dc3c3e640619$export$3901076af3749fa9)();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    const refreshPlantData = ()=>submit(null, {
            method: 'post'
        });
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    //const [toDoTypes, setToDoTypes] = useState<CustomToDoType[]>(userToDoTypes)
    const { value: plantedPlantsNamesWithId, isLoading: plantedPlantsNamesWithIdLoading, error: error } = (0, $1e104381209dd9b4$export$78a72ddb39bdd145)([], async ()=>{
        const plantedPlantsNamesWithId = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getUserPlantsNamesWithId();
        return plantedPlantsNamesWithId;
    }, [
        currentPlantId
    ]);
    const noFiltersSelected = Object.values(viewedTypesOfEvents).every((type)=>type === false);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "plant-time",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "plant-time__title title--feature",
                children: intl.formatMessage({
                    id: 'myPlantTimeline'
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4827afca4eacbfe8$export$2ddb90ad54e5f587), {
                title: intl.formatMessage({
                    id: 'taskAndEventFilters'
                }),
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "event__filters",
                    id: "timeline-filters",
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            children: Object.entries(viewedTypesOfEvents).map(([key, isChecked])=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($b74fb5cffe8beb2d$var$CheckableTag, {
                                    className: "tag",
                                    checked: isChecked,
                                    onChange: (checked)=>setViewedTypesOfEvents((current)=>({
                                                ...current,
                                                [key]: checked
                                            })),
                                    children: intl.formatMessage({
                                        id: `eventType-${key}`
                                    })
                                }, key))
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            id: "reset-filters",
                            onClick: async ()=>{
                                setViewedTypesOfEvents($b74fb5cffe8beb2d$var$filters);
                            },
                            type: "dashed",
                            children: intl.formatMessage({
                                id: 'resetFilters'
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "plant-time-todos",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "title",
                        children: intl.formatMessage({
                            id: 'plannedTasks'
                        })
                    }),
                    plantToDos.length > 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "plant-time-todos__list",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039), {
                            //style={{backgroundColor: '#c7e0dc', margin: '10px 0'}}
                            bordered: true,
                            dataSource: plantToDos.filter((todo)=>(todo.type ? viewedTypesOfEvents[todo.type.type] : false) || noFiltersSelected),
                            renderItem: (toDoItem)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039).Item, {
                                    className: "todo-item",
                                    children: currentPlantTask?.id !== toDoItem.id ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                        className: "todo-item__title",
                                        to: "#",
                                        onClick: async (ev)=>{
                                            ev.preventDefault();
                                            setCurrentPlantTask(toDoItem);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                                className: "todo-item__title__type",
                                                style: {
                                                    display: 'flex',
                                                    justifyContent: 'space-between'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f952978d00baf9e4$export$60d30b2661acb1b8), {
                                                        id: (0, $6dfc071b399cc1b6$export$bd87dd6af1226f02)(toDoItem.type).icon,
                                                        size: "1em"
                                                    }),
                                                    ' ',
                                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                        style: {
                                                            marginLeft: '5px'
                                                        },
                                                        children: toDoItem.type?.type === 'custom' || !toDoItem.type?.type ? (0, $6dfc071b399cc1b6$export$bd87dd6af1226f02)(toDoItem.type).name : intl.formatMessage({
                                                            id: `eventType-${toDoItem.type?.type}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                style: {
                                                    color: 'grey'
                                                },
                                                children: toDoItem.targetEndDateUtc ? `${(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(toDoItem.targetStartDateUtc).format('ll')} - ${(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(toDoItem.targetEndDateUtc).format('ll')}` : toDoItem.targetStartDateUtc ? (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(toDoItem.targetStartDateUtc).format('ll') : ''
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                                                title: intl.formatMessage({
                                                    id: `finishTask`
                                                }),
                                                color: colorPrimary,
                                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                                    onClick: (e)=>e.stopPropagation(),
                                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275f7c91555fa32e$export$378cead5a31fefcf), {
                                                        userJournalEventTypes: userEventTypes,
                                                        finishedTodo: toDoItem,
                                                        isText: false
                                                    })
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                        className: "todo-item__form",
                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $cd7dce9aaa9186a9$export$9e07cf364e4725cb), {
                                            currentToDo: toDoItem,
                                            currentPlant: {
                                                id: currentPlantId,
                                                name: currentPlantName ?? ''
                                            },
                                            toDoTypes: userToDoTypes,
                                            //setToDoTypes={setToDoTypes}
                                            userEventTypes: userEventTypes,
                                            closeModal: ()=>{
                                                setCurrentPlantTask(null);
                                                setAddingTask(false);
                                            },
                                            plantedPlantsNamesWithId: plantedPlantsNamesWithId,
                                            userPlantCollections: [],
                                            userPlantCollectionsWithPlantsIds: []
                                        })
                                    })
                                })
                        })
                    }),
                    isAddingTask && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "todo-item__new",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $cd7dce9aaa9186a9$export$9e07cf364e4725cb), {
                            currentPlant: {
                                id: currentPlantId,
                                name: currentPlantName ?? ''
                            },
                            toDoTypes: userToDoTypes,
                            //setToDoTypes={setToDoTypes}
                            userEventTypes: userEventTypes,
                            closeModal: ()=>{
                                setAddingTask(false);
                            },
                            plantedPlantsNamesWithId: plantedPlantsNamesWithId,
                            userPlantCollections: [],
                            userPlantCollectionsWithPlantsIds: []
                        })
                    }),
                    !(isAddingEvent || isAddingTask) && !isPlantDeleted && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            onClick: async ()=>{
                                setAddingTask(true);
                            },
                            //type="primary"
                            className: "add__new__event__button",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $da40d833ab151490$export$2e2bcd8739ae039), {}),
                                intl.formatMessage({
                                    id: 'addNewTask'
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "plant-time-events",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "title",
                        children: intl.formatMessage({
                            id: 'pastEvents'
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3b19d9d783aeb5e8$export$2e2bcd8739ae039), {
                        className: "timeline",
                        items: plantTimeEvents.sort((a, b)=>a.actualCompletionDateUtc < b.actualCompletionDateUtc ? 1 : -1).filter((event)=>(event.type ? viewedTypesOfEvents[event.type.type] : false) || noFiltersSelected).map((e)=>({
                                // An item that has its edit form open is no longer a point on the
                                // timeline, so it gives up the date column and the dot it would
                                // otherwise be indented behind - see `.timeline__item--editing`.
                                className: currentPlantEventId === e.id ? 'timeline__item--editing' : undefined,
                                content: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                    children: currentPlantEventId === e.id ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                        className: "todo-item__form",
                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a8a4f61d59f3eccc$export$5fbfe03fe02b533e), {
                                            onFormClose: ()=>setCurrentPlantEventId(null),
                                            currentEvent: e,
                                            onPlantEventListUpdated: refreshPlantData,
                                            plantId: currentPlantId,
                                            userJournalEventTypes: userEventTypes
                                        })
                                    }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                                to: "#",
                                                onClick: async (ev)=>{
                                                    ev.preventDefault();
                                                    setCurrentPlantEventId(e.id);
                                                },
                                                children: e.type?.type === 'custom' && e.type.customJournalEventType || !e.type?.type ? (0, $6dfc071b399cc1b6$export$43852040ec70d1af)(e.type).name : intl.formatMessage({
                                                    id: `eventType-${e.type?.type}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                                children: e.comment
                                            })
                                        ]
                                    })
                                }),
                                title: currentPlantEventId === e.id ? '' : e.actualCompletionDateUtc ? e.actualCompletionDateUtc.toString() : '',
                                color: (0, $6dfc071b399cc1b6$export$43852040ec70d1af)(e.type).color,
                                icon: currentPlantEventId === e.id ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9d004cf64875b9d1$exports.Fragment), {}) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($de8c74995637f2ce$exports))),
                                    className: "timeline__icon"
                                })
                            })),
                        mode: 'start',
                        titleSpan: "130px"
                    }),
                    !(isAddingEvent || isAddingTask) && !isPlantDeleted && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            onClick: async ()=>{
                                setAddingEvent(true);
                            },
                            //type="primary"
                            className: "add__new__event__button",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $da40d833ab151490$export$2e2bcd8739ae039), {}),
                                intl.formatMessage({
                                    id: 'addNewEvent'
                                })
                            ]
                        })
                    }),
                    isAddingEvent && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "todo-item__new",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a8a4f61d59f3eccc$export$5fbfe03fe02b533e), {
                            onFormClose: ()=>setAddingEvent(false),
                            onPlantEventListUpdated: refreshPlantData,
                            plantId: currentPlantId,
                            userJournalEventTypes: userEventTypes
                        })
                    })
                ]
            })
        ]
    });
}


async function $db466e07b5db4cf5$export$c2d2f8bd7e19a792(id) {
    if (!id) return {};
    const plantFromDatabaseAns = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getPlantFromPlantDatabaseById(id);
    if (plantFromDatabaseAns.status === 'found') return plantFromDatabaseAns.data.fields;
    return {};
}
function $db466e07b5db4cf5$export$2808d37c1d127408({ plantData: plantData, isLoading: isLoading, onClose: onClose = ()=>{}, preventFormClose: preventFormClose }) {
    const { plant: plant = null, plantTitlePhoto: plantTitlePhoto = null, userPlantCollections: userPlantCollections = [], plantTimeEvents: plantTimeEvents = [], plantTasks: plantToDos = [], userToDoTypes: userToDoTypes = [], userEventTypes: userEventTypes = [] } = plantData;
    const { projectNames: projectNames = [] } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('root');
    const [mode, setMode] = (0, $ltGt3.useState)(!plant ? 'create' : 'view');
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const [isOpenDeleteModal, setOpenDeleteModal] = (0, $ltGt3.useState)(false);
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    (0, $ltGt3.useEffect)(()=>{
        preventFormClose(null);
    }, [
        mode
    ]);
    const [timelineCollapsed, setTimelineCollapsed] = (0, $ltGt3.useState)(false);
    const onOkDelete = async (isDeletePlantEvents)=>{
        // if (isDeletePlantEvents) {
        //   const resultEventsDel = await eventsService.deleteAllPlantEventsForPlant(plant.id)
        //   if (resultEventsDel.success) {
        //     revalidator.revalidate()
        //   } else {
        //     messageApi.open({
        //       type: 'error',
        //       content: resultEventsDel.error?.message,
        //     })
        //   }
        // }
        const result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).deletePlant(plant.id, isDeletePlantEvents, plant.projectId);
        if (result.success) {
            setOpenDeleteModal(false);
            submit({}, {
                method: 'delete'
            });
        } else messageApi.open({
            type: 'error',
            content: result.error?.message
        });
    };
    (0, $ltGt3.useEffect)(()=>{
        if (plant) setMode('view');
        else setMode('create');
    }, [
        plant?.id
    ]);
    const titles = {
        create: intl.formatMessage({
            id: 'addingNewPlant'
        }),
        edit: intl.formatMessage({
            id: 'editingPlant'
        }),
        view: plant?.name
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f5e177132d6f3f0f$export$2e2bcd8739ae039), {
            spinning: isLoading,
            children: [
                mode === 'view' && plant && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("h2", {
                    className: "plant-view__header",
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                            children: titles[mode]
                        }),
                        plant.isPlantDeleted ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                            className: "deleted_plant",
                            children: [
                                "(",
                                intl.formatMessage({
                                    id: 'thePlantWasRemovedByTheUser'
                                }),
                                ")"
                            ]
                        }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                            className: "plant-view__header__actions",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    className: "plant-view__header__edit",
                                    icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $792ee1d77f42b361$export$2e2bcd8739ae039), {}),
                                    onClick: ()=>setMode('edit'),
                                    children: intl.formatMessage({
                                        id: 'editPlant'
                                    })
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                    danger: true,
                                    icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1e0519456d104339$export$2e2bcd8739ae039), {}),
                                    onClick: ()=>setOpenDeleteModal(true),
                                    children: intl.formatMessage({
                                        id: 'deletePlant'
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0bd3f5c1d2d81d43$export$cac7cb74f59833e), {
                    checkboxLabel: intl.formatMessage({
                        id: 'deletePlantEventsConfirm'
                    }),
                    label: `${intl.formatMessage({
                        id: 'deletePlantConfirm'
                    })} ${intl.formatMessage({
                        id: 'deletePlantFromToDoConfirm'
                    })}`,
                    isOpen: isOpenDeleteModal,
                    onCancel: ()=>setOpenDeleteModal(false),
                    onOk: onOkDelete
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                    className: "plant-form-container",
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                        className: "main-column",
                        children: [
                            (mode === 'edit' || mode === 'create') && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $be73dcef9e9c7a3e$export$9abfcccccba0453a), {
                                    currentPlant: plant,
                                    setMode: setMode,
                                    plantTitlePhoto: plantTitlePhoto,
                                    projectsList: projectNames,
                                    onClose: onClose,
                                    preventFormClose: preventFormClose,
                                    mode: mode
                                })
                            }),
                            mode === 'view' && plant && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                className: "plant-view",
                                children: [
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                        className: "plant-view__content",
                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $110286bf6cbe15ec$export$607b0d8e07f2c21e), {
                                            currentPlant: plant,
                                            plantTitlePhoto: plantTitlePhoto,
                                            projectsList: projectNames,
                                            userPlantCollections: userPlantCollections
                                        })
                                    }),
                                    !plant.gardenPlanVariantId && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                                                className: "plant-view__divider",
                                                orientation: "vertical",
                                                titlePlacement: "left"
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                                className: timelineCollapsed ? 'plant-view__timeline plant-view__timeline--collapsed' : 'plant-view__timeline',
                                                children: [
                                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                                        className: "plant-view__timeline__header",
                                                        children: [
                                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                                                className: "plant-view__timeline__collapser",
                                                                onClick: ()=>setTimelineCollapsed((current)=>!current),
                                                                icon: timelineCollapsed ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $517c1002050921e0$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $64e3e0e41d6a34f9$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                                                className: "plant-view__timeline__title title--feature",
                                                                children: intl.formatMessage({
                                                                    id: 'myPlantTimeline'
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    !timelineCollapsed && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b74fb5cffe8beb2d$export$c08119d35eaa2f1f), {
                                                        currentPlantId: plant?.id,
                                                        currentPlantName: plant?.name,
                                                        timeEvents: plantTimeEvents,
                                                        plantToDos: plantToDos,
                                                        userToDoTypes: userToDoTypes,
                                                        userEventTypes: userEventTypes,
                                                        isPlantDeleted: plant.isPlantDeleted
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}



var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
const $a97af2bd258d22ad$var$MousePositionContext = /*#__PURE__*/ (0, $ltGt3.createContext)(null);
function $a97af2bd258d22ad$export$5875b7c002c3b550(props) {
    const [mousePosition, setMousePosition] = (0, $ltGt3.useState)(null);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($a97af2bd258d22ad$var$MousePositionContext.Provider, {
        value: {
            mousePosition: mousePosition,
            setMousePosition: setMousePosition
        },
        children: props.children
    });
}
function $a97af2bd258d22ad$export$30c58b43fa91b94d() {
    return (0, $ltGt3.useContext)($a97af2bd258d22ad$var$MousePositionContext);
}




var $ltGt3 = parcelRequire("ltGt3");


var $e95182a359f0bb22$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $667d177906f36dff$export$2e2bcd8739ae039)
    }));
};
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ var $e95182a359f0bb22$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($e95182a359f0bb22$var$ExclamationCircleFilled);
var $e95182a359f0bb22$export$2e2bcd8739ae039 = $e95182a359f0bb22$var$RefIcon;




function $7c982b663463d13d$export$9037afc3347b6505({ routeWhenClosed: routeWhenClosed }) {
    const navigation = (0, $493cbc5b00d91baa$export$d0fd4b7106de2769)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const routeParams = (0, $493cbc5b00d91baa$export$99eaa27ddbbb95ef)();
    const { mousePosition: mousePosition } = (0, $a97af2bd258d22ad$export$30c58b43fa91b94d)();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const app = (0, $4f475c9b6cb2d3a2$export$2e2bcd8739ae039).useApp();
    const navigateDelayed = (to, options)=>setTimeout(()=>{
            navigate(to, options);
        }, 0);
    const plantPopupVisible = Boolean(routeParams.plantId);
    const plantLoading = plantPopupVisible && navigation.state === 'loading';
    const plantRouteLoaderData = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('plant');
    const projectPlantRouteLoaderData = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('projectWithPlant');
    const toDoPlantRouteLoaderData = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('toDoWithPlant');
    const journalEventPlantRouteLoaderData = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('journalRecordWithPlant');
    const routeData = plantRouteLoaderData || projectPlantRouteLoaderData || toDoPlantRouteLoaderData || journalEventPlantRouteLoaderData || {
        type: 'newPlant'
    };
    const [closePreventedReason, setClosePreventedReason] = (0, $ltGt3.useState)(null);
    const onClose = ()=>{
        if (closePreventedReason) app.modal.confirm({
            title: intl.formatMessage({
                id: 'confirmFormCloseTitle'
            }),
            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e95182a359f0bb22$export$2e2bcd8739ae039), {}),
            content: closePreventedReason,
            onOk () {
                navigateDelayed(routeWhenClosed);
            },
            onCancel () {}
        });
        else navigateDelayed(routeWhenClosed);
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f189c84ec54ae7cf$export$2e2bcd8739ae039), {
        className: "plant-modal",
        open: plantPopupVisible,
        onCancel: onClose,
        mousePosition: mousePosition || undefined,
        footer: null,
        destroyOnHidden: true,
        width: 1200,
        children: routeData.type === 'notFound' ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("h2", {
            children: [
                "Plant with id ",
                routeParams.plantId,
                " not found"
            ]
        }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $db466e07b5db4cf5$export$2808d37c1d127408), {
            plantData: routeData,
            isLoading: plantLoading,
            onClose: onClose,
            preventFormClose: setClosePreventedReason
        })
    });
}








var $ltGt3 = parcelRequire("ltGt3");







var $ltGt3 = parcelRequire("ltGt3");


function $924fa59b56cef81b$export$5f6174955f1c9d6e({ gardenPlanVariant: gardenPlanVariant, onGardenPlanVariantEdited: onGardenPlanVariantEdited }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [modalOpen, setModalOpen] = (0, $ltGt3.useState)(false);
    const [name, setName] = (0, $ltGt3.useState)(gardenPlanVariant.name);
    const [loading, setLoading] = (0, $ltGt3.useState)(false);
    const inputRef = (0, $ltGt3.useRef)(null);
    async function saveName() {
        if (loading || !name.trim()) return;
        setLoading(true);
        try {
            const result = await (0, $5fab5f2ee6cc184e$export$9544d5bb712b01ea).editGardenPlanVariantName({
                ...gardenPlanVariant,
                name: name.trim()
            });
            if (result.success) {
                setModalOpen(false);
                onGardenPlanVariantEdited();
            }
        } finally{
            setLoading(false);
        }
    }
    return(// rendered inside a select option: the portaled modal's events still bubble to the select
    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
        onClick: (e)=>e.stopPropagation(),
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f189c84ec54ae7cf$export$2e2bcd8739ae039), {
                modalRender: (modal)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        onMouseDown: (e)=>e.stopPropagation(),
                        onKeyDown: (e)=>e.stopPropagation(),
                        children: modal
                    }),
                title: intl.formatMessage({
                    id: 'editGardenPlan'
                }),
                open: modalOpen,
                onOk: saveName,
                onCancel: ()=>setModalOpen(false),
                okButtonProps: {
                    disabled: !name.trim(),
                    loading: loading
                },
                destroyOnHidden: true,
                // the select keeps focus on its own, so move it to the input explicitly
                afterOpenChange: (open)=>open && inputRef.current?.focus(),
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039), {
                    ref: inputRef,
                    value: name,
                    onChange: (event)=>setName(event.target.value),
                    onPressEnter: saveName
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                className: "edit-garden-plan-variant",
                type: "link",
                size: "small",
                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $792ee1d77f42b361$export$2e2bcd8739ae039), {}),
                onClick: ()=>{
                    setName(gardenPlanVariant.name);
                    setModalOpen(true);
                }
            })
        ]
    }));
}


const $29d1fb9d72e8d84f$var$DEFAULT_VARIANT_VALUE = '';
const $29d1fb9d72e8d84f$var$MIN_VISIBLE_NAME_CHARS = 10;
function $29d1fb9d72e8d84f$var$getNameSizerText(name) {
    return name.length > $29d1fb9d72e8d84f$var$MIN_VISIBLE_NAME_CHARS ? `${name.slice(0, $29d1fb9d72e8d84f$var$MIN_VISIBLE_NAME_CHARS)}\u{2026}` : name;
}
function $29d1fb9d72e8d84f$export$5a5700c14b853078({ projectId: projectId, gardenPlanVariants: gardenPlanVariants = [], activeGardenPlanVariantId: activeGardenPlanVariantId, onActiveGardenPlanVariantIdChange: onActiveGardenPlanVariantIdChange = ()=>{}, onGardenPlanVariantsListUpdated: onGardenPlanVariantsListUpdated = ()=>{}, className: className }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const inputRef = (0, $ltGt3.useRef)(null);
    const [name, setName] = (0, $ltGt3.useState)('');
    const [loading, setLoading] = (0, $ltGt3.useState)(false);
    async function createGardenPlanVariant(e) {
        e.preventDefault();
        if (loading || !name.trim()) return;
        setLoading(true);
        try {
            const result = await (0, $5fab5f2ee6cc184e$export$9544d5bb712b01ea).createGardenPlanVariant({
                projectId: projectId,
                name: name.trim()
            });
            if (result.success) onGardenPlanVariantsListUpdated();
        } finally{
            setName('');
            setLoading(false);
        }
    }
    async function applyGardenPlanVariant(variantId) {
        setLoading(true);
        try {
            const result = await (0, $5fab5f2ee6cc184e$export$9544d5bb712b01ea).applyGardenPlanVariantToProject(variantId);
            if (result.success) {
                onActiveGardenPlanVariantIdChange(null);
                onGardenPlanVariantsListUpdated();
            }
        } finally{
            setLoading(false);
        }
    }
    async function deleteGardenPlanVariant(variantId) {
        setLoading(true);
        try {
            const result = await (0, $5fab5f2ee6cc184e$export$9544d5bb712b01ea).deleteGardenPlanVariant(variantId);
            if (result.success) onGardenPlanVariantsListUpdated();
        } finally{
            setLoading(false);
        }
    }
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
        className: className ? `garden-plan-variants ${className}` : 'garden-plan-variants',
        placeholder: intl.formatMessage({
            id: 'gardenPlan'
        }),
        prefix: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
            title: intl.formatMessage({
                id: 'gardenPlanVariantsHint'
            }),
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $35775a005ce7c86e$export$2e2bcd8739ae039), {
                className: "garden-plan-variants__hint"
            })
        }),
        value: activeGardenPlanVariantId ?? $29d1fb9d72e8d84f$var$DEFAULT_VARIANT_VALUE,
        onChange: (value)=>onActiveGardenPlanVariantIdChange(value || null),
        labelRender: ({ label: label, value: value })=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "garden-plan-variant-item",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                        className: "garden-plan-variant-item__name garden-plan-variant-item__name--selected",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                className: "garden-plan-variant-item__sizer",
                                "aria-hidden": true,
                                children: $29d1fb9d72e8d84f$var$getNameSizerText(String(label))
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                children: label
                            })
                        ]
                    }),
                    value !== $29d1fb9d72e8d84f$var$DEFAULT_VARIANT_VALUE && // keep the click from opening the dropdown
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                        className: "apply-garden-plan-variant",
                        onMouseDown: (e)=>e.stopPropagation(),
                        onClick: (e)=>e.stopPropagation(),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
                            placement: "bottom",
                            title: intl.formatMessage({
                                id: 'applyGardenPlanTitle'
                            }, {
                                planName: label
                            }),
                            description: intl.formatMessage({
                                id: 'applyGardenPlanDescription'
                            }),
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7fa69e90b193286$export$2e2bcd8739ae039), {}),
                            onConfirm: ()=>applyGardenPlanVariant(value),
                            okText: intl.formatMessage({
                                id: 'yes'
                            }),
                            cancelText: intl.formatMessage({
                                id: 'no'
                            }),
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                color: "primary",
                                variant: "outlined",
                                size: "small",
                                loading: loading,
                                children: intl.formatMessage({
                                    id: 'apply'
                                })
                            })
                        })
                    })
                ]
            }),
        options: [
            {
                value: $29d1fb9d72e8d84f$var$DEFAULT_VARIANT_VALUE,
                label: intl.formatMessage({
                    id: 'defaultProjectWithoutPlans'
                }),
                variant: null
            },
            ...gardenPlanVariants.map((variant)=>({
                    value: variant.id,
                    label: variant.name,
                    variant: variant
                }))
        ],
        classNames: {
            popup: {
                root: 'garden-plan-variants-dropdown'
            }
        },
        popupRender: (menu)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f5e177132d6f3f0f$export$2e2bcd8739ae039), {
                spinning: loading,
                delay: 300,
                children: [
                    menu,
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                        style: {
                            margin: '8px 0'
                        }
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d029ee757225a242$export$2e2bcd8739ae039), {
                        style: {
                            padding: '0 8px 4px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039), {
                                placeholder: intl.formatMessage({
                                    id: 'newGardenPlan'
                                }),
                                ref: inputRef,
                                value: name,
                                onChange: (event)=>setName(event.target.value),
                                onKeyDown: (e)=>e.stopPropagation()
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                type: "text",
                                icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $da40d833ab151490$export$2e2bcd8739ae039), {}),
                                onClick: createGardenPlanVariant,
                                children: intl.formatMessage({
                                    id: 'add'
                                })
                            })
                        ]
                    })
                ]
            }),
        optionRender: (option)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "garden-plan-variant-item",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                        className: "garden-plan-variant-item__name",
                        children: option.data.label
                    }),
                    option.data.variant && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $924fa59b56cef81b$export$5f6174955f1c9d6e), {
                        gardenPlanVariant: option.data.variant,
                        onGardenPlanVariantEdited: onGardenPlanVariantsListUpdated
                    }),
                    option.data.variant && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                        onClick: (e)=>e.stopPropagation(),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
                            placement: "bottom",
                            title: intl.formatMessage({
                                id: 'areYouSureYouWantToDeleteThisPlan'
                            }),
                            description: intl.formatMessage({
                                id: 'thisOperationIsIrreversible'
                            }),
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7fa69e90b193286$export$2e2bcd8739ae039), {
                                style: {
                                    color: 'red'
                                }
                            }),
                            onConfirm: ()=>deleteGardenPlanVariant(option.value),
                            okText: intl.formatMessage({
                                id: 'yes'
                            }),
                            cancelText: intl.formatMessage({
                                id: 'no'
                            }),
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1e0519456d104339$export$2e2bcd8739ae039), {
                                className: "delete-garden-plan-variant"
                            })
                        })
                    })
                ]
            })
    });
}




function $f12218d38d58bc43$export$a4770e9edd2382f({ isSnapshot: isSnapshot = false }) {
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const { token: { controlHeightSM: controlHeightSM } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    const { project: project, projectPlants: projectPlants, projectToDos: projectToDos, plantedPlantsNamesWithId: plantedPlantsNamesWithId, projectGardenPlanVariants: projectGardenPlanVariants } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)(isSnapshot ? 'snapshot' : 'project');
    const { gardenPlanVariantId: gardenPlanVariantId, setGardenPlanVariantId: setGardenPlanVariantId, withGardenPlanVariant: withGardenPlanVariant } = (0, $06d8e952a1c52731$export$7796d9afff69f3c5)();
    // drop ids from the URL that don't belong to this project (e.g. a deleted variant)
    const activeGardenPlanVariantId = projectGardenPlanVariants.some((variant)=>variant.id === gardenPlanVariantId) ? gardenPlanVariantId : null;
    (0, $ltGt3.useEffect)(()=>{
        if (gardenPlanVariantId && !activeGardenPlanVariantId) setGardenPlanVariantId(null);
    }, [
        gardenPlanVariantId,
        activeGardenPlanVariantId,
        setGardenPlanVariantId
    ]);
    const currentProjectPlants = (0, $ltGt3.useMemo)(()=>projectPlants.filter((plant)=>!plant.gardenPlanVariantId || plant.gardenPlanVariantId === activeGardenPlanVariantId), [
        projectPlants,
        activeGardenPlanVariantId
    ]);
    // const [filters, setFilters] = useState<PlantedPlantsFilters>({})
    // const filteredPlants = projectPlants.filter((plant) => {
    //   if (filters.date) {
    //     if (
    //       new Date(plant.dateOfPlantingUtc) < filters.date.startDate ||
    //       new Date(plant.dateOfPlantingUtc) > filters.date.endDate
    //     ) {
    //       return false
    //     }
    //   }
    //   if (filters.plant) {
    //     if (plant.name.toLowerCase().indexOf(filters.plant.toLowerCase()) < 0) {
    //       return false
    //     }
    //   }
    //   if (filters.projects) {
    //     if (filters.projects.indexOf(String(plant.projectId)) < 0) {
    //       return false
    //     }
    //   }
    //   return true
    // })
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const onDeleteConfirm = async (isDeletePlants, isDeletePlantsEvents)=>{
        const result = await (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).deleteProject(project.id, isDeletePlants, isDeletePlantsEvents);
        if (result.success === true) {
            navigate('/projects');
            revalidator.revalidate();
        } else messageApi.open({
            type: 'error',
            content: result.error?.message
        });
    };
    const [isOpenDeleteModal, setOpenDeleteModal] = (0, $ltGt3.useState)(false);
    const itemsProjectSettings = [
        {
            key: 'delete',
            label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                type: "text",
                onClick: ()=>setOpenDeleteModal(true),
                children: intl.formatMessage({
                    id: 'deleteProject'
                })
            })
        }
    ];
    const refEdit = (0, $ltGt3.useRef)(null);
    const refAddPlant = (0, $ltGt3.useRef)(null);
    const refSketch = (0, $ltGt3.useRef)(null);
    const refSnapshot = (0, $ltGt3.useRef)(null);
    const refReminders = (0, $ltGt3.useRef)(null);
    const openPlant = (plantId)=>navigate(withGardenPlanVariant(`/projects/${project.id}/plants/${plantId}`));
    const [openTour, setOpenTour] = (0, $ltGt3.useState)(false);
    const steps = [
        {
            title: intl.formatMessage({
                id: 'projectPage'
            }),
            description: intl.formatMessage({
                id: 'projectPageTourDescriptionAll'
            }),
            target: null
        },
        {
            title: intl.formatMessage({
                id: 'editProject'
            }),
            description: intl.formatMessage({
                id: 'projectPageTourDescriptionEdit'
            }),
            target: ()=>refEdit.current
        },
        {
            title: intl.formatMessage({
                id: 'addPlant'
            }),
            description: intl.formatMessage({
                id: 'projectPageTourDescriptionAddPlant'
            }),
            target: ()=>refAddPlant.current
        },
        {
            title: intl.formatMessage({
                id: 'plantPlant'
            }),
            description: intl.formatMessage({
                id: 'projectPageTourDescriptionCanvas'
            }),
            target: null
        },
        // {
        //   title: intl.formatMessage({id: 'projectSnapshot'}),
        //   description: intl.formatMessage({id: 'projectPageTourDescriptionSnapshot'}),
        //   target: () => refSnapshot.current!,
        // },
        {
            title: intl.formatMessage({
                id: 'projectReminders'
            }),
            description: intl.formatMessage({
                id: 'projectPageTourDescriptionReminders'
            }),
            placement: 'left',
            target: null
        }
    ];
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "project-title",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                                style: {
                                    flex: '1 1 auto'
                                },
                                children: project.name
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                className: "project-title__buttons",
                                children: [
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                        onClick: ()=>setOpenTour(true),
                                        children: intl.formatMessage({
                                            id: 'projectPageTour'
                                        })
                                    }),
                                    !isSnapshot && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                        type: "link",
                                        style: {
                                            color: (0, $f9b009df50b30ac5$export$ad766f34ace1cafd)[5]
                                        },
                                        to: withGardenPlanVariant(`/projects/${project.id}/edit`),
                                        ref: refEdit,
                                        children: intl.formatMessage({
                                            id: 'edit'
                                        })
                                    }),
                                    isSnapshot && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a246c3fe19a7f5f4$export$2e2bcd8739ae039), {}),
                                        color: (0, $f9b009df50b30ac5$export$ad766f34ace1cafd)[5],
                                        children: intl.formatMessage({
                                            id: 'snapshot'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $fdbae0f0e90936fe$export$2e2bcd8739ae039), {
                                        menu: {
                                            items: itemsProjectSettings
                                        },
                                        placement: "bottomLeft",
                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                            type: "link",
                                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ebfc7c0b6e3488d8$export$2e2bcd8739ae039), {})
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                        style: {
                            height: 'auto'
                        }
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "view-project",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3ec6bec65f655645$export$18cfe0f06ae2a925), {
                                plotShape: project.plotShape,
                                elements: project.elements,
                                editable: true,
                                projectPlants: currentProjectPlants,
                                projectId: project.id,
                                hasMap: Boolean(project?.location?.map),
                                openPlantById: openPlant,
                                gardenPlanSelector: !isSnapshot && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
                                    children: [
                                        activeGardenPlanVariantId && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3336d90a99ceb065$export$2e2bcd8739ae039), {
                                            className: "planning-mode-warning",
                                            type: "warning",
                                            showIcon: true,
                                            title: intl.formatMessage({
                                                id: 'planningModeWarning'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $29d1fb9d72e8d84f$export$5a5700c14b853078), {
                                            projectId: project.id,
                                            gardenPlanVariants: projectGardenPlanVariants,
                                            activeGardenPlanVariantId: activeGardenPlanVariantId,
                                            onActiveGardenPlanVariantIdChange: setGardenPlanVariantId,
                                            onGardenPlanVariantsListUpdated: ()=>{
                                                (0, $f72b095965a02692$export$355b0b6aff080555)();
                                                revalidator.revalidate();
                                            }
                                        })
                                    ]
                                })
                            }),
                            !isSnapshot && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                        className: "view-project__calendar",
                                        style: {
                                            margin: `${controlHeightSM}px 0`
                                        },
                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $75d4ef8c0094c908$export$4cc5481925352c83), {
                                            todos: projectToDos,
                                            plantedPlantsNamesWithId: plantedPlantsNamesWithId
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                        className: "view-project__reminders",
                                        ref: refReminders,
                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e5058ab3fce1e2a7$export$30b98ae171787f1a), {
                                            todos: projectToDos,
                                            plantedPlantsNamesWithId: plantedPlantsNamesWithId
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $eabf9c7db89c7211$export$2e2bcd8739ae039), {
                open: openTour,
                onClose: ()=>setOpenTour(false),
                steps: steps,
                indicatorsRender: (current, total)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                        children: [
                            current + 1,
                            " / ",
                            total
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7c982b663463d13d$export$9037afc3347b6505), {
                routeWhenClosed: withGardenPlanVariant(`/projects/${project.id}`)
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0bd3f5c1d2d81d43$export$cac7cb74f59833e), {
                checkboxLabel: intl.formatMessage({
                    id: 'deleteProjectWithPlantsConfirm'
                }),
                label: intl.formatMessage({
                    id: 'areYouSureYouWantToDelete'
                }),
                isOpen: isOpenDeleteModal,
                onCancel: ()=>setOpenDeleteModal(false),
                onOk: onDeleteConfirm,
                checkboxLabelSecond\u0421ondition: intl.formatMessage({
                    id: 'deleteProjectWithPlantsAndEventsConfirm'
                })
            })
        ]
    });
}





var $ltGt3 = parcelRequire("ltGt3");




const $e0fec9ca9a676038$var$routeSteps = [
    {
        route: '/edit',
        step: 0
    },
    {
        route: '/edit/plot',
        step: 1
    },
    {
        route: '/edit/buildings',
        step: 2
    },
    {
        route: '/edit/hardscape',
        step: 3
    },
    {
        route: '/edit/sectors',
        step: 4
    },
    {
        route: '/edit/waterscape',
        step: 5
    },
    {
        route: '/edit/solitarius',
        step: 6
    },
    {
        route: '/edit/other',
        step: 7
    }
];
function $e0fec9ca9a676038$export$93dfedba8fa3490f(currentStep, step) {
    if (currentStep === step) return 'process';
    else if (currentStep > step) return 'finish';
    else return 'wait';
}
const $e0fec9ca9a676038$export$68671cbc8e95f886 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createContext({
    setNextStepConfirmation: ()=>{}
});
function $e0fec9ca9a676038$export$3e899a3b88b0b908({ type: type }) {
    const { token: { controlHeightSM: controlHeightSM } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const location = (0, $493cbc5b00d91baa$export$45d76561a5302f2b)();
    const { withGardenPlanVariant: withGardenPlanVariant } = (0, $06d8e952a1c52731$export$7796d9afff69f3c5)();
    let project = null;
    if (type === 'edit') {
        const data = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('project');
        project = data.project;
    }
    let currentStep = 0;
    for (const { route: route, step: step } of $e0fec9ca9a676038$var$routeSteps)if (location.pathname.endsWith(route)) {
        currentStep = step;
        break;
    }
    const onStepChange = (value)=>{
        for (const { route: route, step: step } of $e0fec9ca9a676038$var$routeSteps)if (value === step) {
            navigate(withGardenPlanVariant(`/projects/${project?.id}${route}`));
            return;
        }
    };
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [nextStepConfirmation, setNextStepConfirmation] = (0, $ltGt3.useState)(null);
    const [nextStepConfirmOpen, setNextStepConfirmOpen] = (0, $ltGt3.useState)(false);
    const setConfirmOpen = (nextOpen)=>{
        if (!nextOpen) setNextStepConfirmOpen(false);
        if (!nextStepConfirmation) onNextStepClick();
        else setNextStepConfirmOpen(true);
    };
    (0, $ltGt3.useEffect)(()=>{
        setNextStepConfirmation(null);
        setNextStepConfirmOpen(false);
    }, [
        currentStep
    ]);
    const isLastStep = currentStep === $e0fec9ca9a676038$var$routeSteps[$e0fec9ca9a676038$var$routeSteps.length - 1].step;
    const onNextStepClick = ()=>{
        if (isLastStep) navigate(withGardenPlanVariant(`/projects/${project?.id}`));
        else onStepChange(currentStep + 1);
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                            style: {
                                display: 'inline'
                            },
                            children: project?.name
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                        style: {
                            height: 'auto'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $69a1a6b4bc56205c$export$2e2bcd8739ae039), {
                            type: "navigation",
                            current: currentStep,
                            onChange: onStepChange,
                            className: "site-navigation-steps",
                            items: [
                                {
                                    title: intl.formatMessage({
                                        id: 'step'
                                    }) + ' 1',
                                    status: $e0fec9ca9a676038$export$93dfedba8fa3490f(currentStep, 0),
                                    description: intl.formatMessage({
                                        id: 'editStepDefGenInfo'
                                    })
                                },
                                {
                                    title: intl.formatMessage({
                                        id: 'step'
                                    }) + ' 2',
                                    status: $e0fec9ca9a676038$export$93dfedba8fa3490f(currentStep, 1),
                                    description: intl.formatMessage({
                                        id: 'editStepDefPlot'
                                    }),
                                    disabled: currentStep < 1 && type === 'new' ? true : false
                                },
                                {
                                    title: intl.formatMessage({
                                        id: 'step'
                                    }) + ' 3',
                                    status: $e0fec9ca9a676038$export$93dfedba8fa3490f(currentStep, 2),
                                    description: intl.formatMessage({
                                        id: 'editStepDefBuildings'
                                    }),
                                    disabled: currentStep < 2 && type === 'new' ? true : false
                                },
                                {
                                    title: intl.formatMessage({
                                        id: 'step'
                                    }) + ' 4',
                                    status: $e0fec9ca9a676038$export$93dfedba8fa3490f(currentStep, 3),
                                    description: intl.formatMessage({
                                        id: 'editStepDefHardscape'
                                    }),
                                    disabled: currentStep < 3 && type === 'new' ? true : false
                                },
                                {
                                    title: intl.formatMessage({
                                        id: 'step'
                                    }) + ' 5',
                                    status: $e0fec9ca9a676038$export$93dfedba8fa3490f(currentStep, 4),
                                    description: intl.formatMessage({
                                        id: 'editStepDefSoftscape'
                                    }),
                                    disabled: currentStep < 4 && type === 'new' ? true : false
                                },
                                {
                                    title: intl.formatMessage({
                                        id: 'step'
                                    }) + ' 6',
                                    status: $e0fec9ca9a676038$export$93dfedba8fa3490f(currentStep, 5),
                                    description: intl.formatMessage({
                                        id: 'editStepDefWaterscape'
                                    }),
                                    disabled: currentStep < 5 && type === 'new' ? true : false
                                },
                                {
                                    title: intl.formatMessage({
                                        id: 'step'
                                    }) + ' 7',
                                    status: $e0fec9ca9a676038$export$93dfedba8fa3490f(currentStep, 6),
                                    description: intl.formatMessage({
                                        id: 'editStepDefSolitarius'
                                    }),
                                    disabled: currentStep < 6 && type === 'new' ? true : false
                                },
                                {
                                    title: intl.formatMessage({
                                        id: 'step'
                                    }) + ' 8',
                                    status: $e0fec9ca9a676038$export$93dfedba8fa3490f(currentStep, 7),
                                    description: intl.formatMessage({
                                        id: 'editStepDefOtherElements'
                                    }),
                                    disabled: currentStep < 7 && type === 'new' ? true : false
                                }
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                            style: {
                                height: 'auto'
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                    style: {
                        width: '100%'
                    },
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        style: {
                            backgroundColor: '#fff7e6',
                            padding: '20px',
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                        style: {
                                            position: 'absolute',
                                            height: 50
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("h2", {
                                        style: {
                                            display: 'inline'
                                        },
                                        children: [
                                            intl.formatMessage({
                                                id: 'step'
                                            }),
                                            " ",
                                            currentStep + 1
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
                                        open: nextStepConfirmOpen,
                                        onOpenChange: setConfirmOpen,
                                        title: intl.formatMessage({
                                            id: 'projectIsNotSaved'
                                        }),
                                        overlayStyle: {
                                            maxWidth: 700
                                        },
                                        description: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                                    children: nextStepConfirmation?.message
                                                }),
                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                                    style: {
                                                        marginBottom: '-40px',
                                                        marginTop: '10px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                                            onClick: ()=>setNextStepConfirmOpen(false),
                                                            children: intl.formatMessage({
                                                                id: 'cancel'
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                                            style: {
                                                                marginLeft: '10px'
                                                            },
                                                            onClick: ()=>{
                                                                setNextStepConfirmOpen(false);
                                                                onNextStepClick();
                                                            },
                                                            children: intl.formatMessage({
                                                                id: 'continueWithoutSaving'
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        showCancel: false,
                                        onConfirm: async ()=>{
                                            await nextStepConfirmation?.onConfirm?.();
                                            onNextStepClick();
                                        },
                                        okText: intl.formatMessage({
                                            id: 'saveAndContinue'
                                        }),
                                        okButtonProps: {
                                            size: 'middle'
                                        },
                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                            style: {
                                                position: 'absolute',
                                                right: '15px'
                                            },
                                            type: "primary",
                                            children: isLastStep ? intl.formatMessage({
                                                id: 'projectPage'
                                            }) : intl.formatMessage({
                                                id: 'next'
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($e0fec9ca9a676038$export$68671cbc8e95f886.Provider, {
                                value: {
                                    setNextStepConfirmation: setNextStepConfirmation
                                },
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $493cbc5b00d91baa$export$910ae8079b2c2852), {})
                            })
                        ]
                    })
                })
            })
        ]
    });
}




parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $2cd40fc88a00f7d0$var$GoogleCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z"
                }
            }
        ]
    },
    "name": "google-circle",
    "theme": "filled"
};
var $2cd40fc88a00f7d0$export$2e2bcd8739ae039 = $2cd40fc88a00f7d0$var$GoogleCircleFilled;



var $fa9c689edb05e85b$var$GoogleCircleFilled = function GoogleCircleFilled(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $2cd40fc88a00f7d0$export$2e2bcd8739ae039)
    }));
};
/**![google-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xNjcgNjMzLjZDNjM4LjQgNzM1IDU4MyA3NTcgNTE2LjkgNzU3Yy05NS43IDAtMTc4LjUtNTQuOS0yMTguOC0xMzQuOUMyODEuNSA1ODkgMjcyIDU1MS42IDI3MiA1MTJzOS41LTc3IDI2LjEtMTEwLjFjNDAuMy04MC4xIDEyMy4xLTEzNSAyMTguOC0xMzUgNjYgMCAxMjEuNCAyNC4zIDE2My45IDYzLjhMNjEwLjYgNDAxYy0yNS40LTI0LjMtNTcuNy0zNi42LTkzLjYtMzYuNi02My44IDAtMTE3LjggNDMuMS0xMzcuMSAxMDEtNC45IDE0LjctNy43IDMwLjQtNy43IDQ2LjZzMi44IDMxLjkgNy43IDQ2LjZjMTkuMyA1Ny45IDczLjMgMTAxIDEzNyAxMDEgMzMgMCA2MS04LjcgODIuOS0yMy40IDI2LTE3LjQgNDMuMi00My4zIDQ4LjktNzRINTE2Ljl2LTk0LjhoMjMwLjdjMi45IDE2LjEgNC40IDMyLjggNC40IDUwLjEgMCA3NC43LTI2LjcgMTM3LjQtNzMgMTgwLjF6IiAvPjwvc3ZnPg==) */ var $fa9c689edb05e85b$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($fa9c689edb05e85b$var$GoogleCircleFilled);
var $fa9c689edb05e85b$export$2e2bcd8739ae039 = $fa9c689edb05e85b$var$RefIcon;







var $ltGt3 = parcelRequire("ltGt3");




function $9bc26c77997fb3d5$export$1f58f750f20f344b() {
    const [form] = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useForm();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const [isSubmitting, setSubmitting] = (0, $ltGt3.useState)(false);
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const [globalError, setGlobalError] = (0, $ltGt3.useState)();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const validateMessages = {
        required: intl.formatMessage({
            id: 'fieldIsRequired'
        }, {
            field: '${label}'
        }),
        types: {
            email: intl.formatMessage({
                id: 'emailIsIncorrect'
            })
        }
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        style: {
            width: '100%'
        },
        children: [
            contextHolder,
            globalError && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3336d90a99ceb065$export$2e2bcd8739ae039), {
                    type: "error",
                    showIcon: true,
                    closable: true,
                    onClose: ()=>setGlobalError(null),
                    message: intl.formatMessage({
                        id: 'errorDuringLogin'
                    }),
                    description: globalError
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $b56d75f9dce54730$export$2e2bcd8739ae039), {
                form: form,
                layout: "vertical",
                validateMessages: validateMessages,
                onFinish: async (formState)=>{
                    setSubmitting(true);
                    const result = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).signInEmailPassword(formState.email, formState.password);
                    setSubmitting(false);
                    if (result.success) {
                        revalidator.revalidate();
                        navigate('/home');
                    } else setGlobalError(result.error?.message);
                },
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        name: "email",
                        label: intl.formatMessage({
                            id: 'email'
                        }),
                        rules: [
                            {
                                required: true,
                                type: 'email'
                            }
                        ],
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        name: "password",
                        label: intl.formatMessage({
                            id: 'password'
                        }),
                        rules: [
                            {
                                required: true
                            }
                        ],
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).Password, {})
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            htmlType: "submit",
                            size: "large",
                            type: "primary",
                            style: {
                                width: '100%'
                            },
                            children: intl.formatMessage({
                                id: 'continue'
                            })
                        })
                    })
                ]
            })
        ]
    });
}



function $dc5d57b23f0b65bc$export$f14c0e3f98d164c0() {
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        style: {
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                    className: "logo",
                    to: "/",
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h1", {
                        children: "TerraSketch"
                    })
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                    children: intl.formatMessage({
                        id: 'logIn'
                    })
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9bc26c77997fb3d5$export$1f58f750f20f344b), {}),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                    to: "/reset-password",
                    children: [
                        intl.formatMessage({
                            id: 'forgotPassword'
                        }),
                        "?"
                    ]
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $fa9c689edb05e85b$export$2e2bcd8739ae039), {}),
                    size: "large",
                    onClick: async ()=>{
                        const result = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).signInGoogle();
                        if (!result.success) messageApi.open({
                            type: 'error',
                            content: result.error.message
                        });
                        else navigate('/home');
                    },
                    children: intl.formatMessage({
                        id: 'logInWithGoogle'
                    })
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    style: {
                        textAlign: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                intl.formatMessage({
                                    id: 'byClickingLogInWithGoogle'
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                            to: "/policies",
                            children: intl.formatMessage({
                                id: 'policyTerrasketch'
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    style: {
                        textAlign: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            children: intl.formatMessage({
                                id: 'ifYouDontHaveAccount'
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                            to: "/signup",
                            children: intl.formatMessage({
                                id: 'signUp'
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
                                defaultValue: "eng",
                                style: {
                                    width: 120
                                },
                                onChange: ()=>{},
                                options: [
                                    {
                                        value: 'eng',
                                        label: 'English'
                                    },
                                    {
                                        value: 'pl',
                                        label: 'Polish'
                                    },
                                    {
                                        value: 'ru',
                                        label: 'Russian'
                                    }
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}





var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");
const $4ba85974d660b691$export$e1053575ddfcb301 = {};
const $4ba85974d660b691$export$91b75cf262680225 = 'rc-table-internal-hook';






var $ltGt3 = parcelRequire("ltGt3");

function $f653da5403feaada$export$fd42f52fd3ae1109(defaultValue) {
    const Context = /*#__PURE__*/ $ltGt3.createContext(undefined);
    const Provider = ({ value: value, children: children })=>{
        const valueRef = $ltGt3.useRef(value);
        valueRef.current = value;
        const [context] = $ltGt3.useState(()=>({
                getValue: ()=>valueRef.current,
                listeners: new Set()
            }));
        (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
            (0, $35c0fb1a856c78db$exports.unstable_batchedUpdates)(()=>{
                context.listeners.forEach((listener)=>{
                    listener(value);
                });
            });
        }, [
            value
        ]);
        return /*#__PURE__*/ $ltGt3.createElement(Context.Provider, {
            value: context
        }, children);
    };
    return {
        Context: Context,
        Provider: Provider,
        defaultValue: defaultValue
    };
}
function $f653da5403feaada$export$fae74005e78b1a27(holder, selector) {
    const eventSelector = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(typeof selector === 'function' ? selector : (ctx)=>{
        if (selector === undefined) return ctx;
        if (!Array.isArray(selector)) return ctx[selector];
        const obj = {};
        selector.forEach((key)=>{
            obj[key] = ctx[key];
        });
        return obj;
    });
    const context = $ltGt3.useContext(holder?.Context);
    const { listeners: listeners, getValue: getValue } = context || {};
    const valueRef = $ltGt3.useRef();
    valueRef.current = eventSelector(context ? getValue() : holder?.defaultValue);
    const [, forceUpdate] = $ltGt3.useState({});
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (!context) return;
        function trigger(nextValue) {
            const nextSelectorValue = eventSelector(nextValue);
            if (!(0, $003c57daacb79f0c$export$2e2bcd8739ae039)(valueRef.current, nextSelectorValue, true)) forceUpdate({});
        }
        listeners.add(trigger);
        return ()=>{
            listeners.delete(trigger);
        };
    }, [
        context
    ]);
    return valueRef.current;
}




var $ltGt3 = parcelRequire("ltGt3");
function $61b6d74af70da25c$var$_extends() {
    $61b6d74af70da25c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $61b6d74af70da25c$var$_extends.apply(this, arguments);
}
function $61b6d74af70da25c$export$2e2bcd8739ae039() {
    const ImmutableContext = /*#__PURE__*/ $ltGt3.createContext(null);
    /**
   * Get render update mark by `makeImmutable` root.
   * Do not deps on the return value as render times
   * but only use for `useMemo` or `useCallback` deps.
   */ function useImmutableMark() {
        return $ltGt3.useContext(ImmutableContext);
    }
    /**
  * Wrapped Component will be marked as Immutable.
  * When Component parent trigger render,
  * it will notice children component (use with `responseImmutable`) node that parent has updated.
  * @param Component Passed Component
  * @param triggerRender Customize trigger `responseImmutable` children re-render logic. Default will always trigger re-render when this component re-render.
  */ function makeImmutable(Component, shouldTriggerRender) {
        const refAble = (0, $22ff46e28c8066e1$export$c1cec34af06bcf7)(Component);
        const ImmutableComponent = (props, ref)=>{
            const refProps = refAble ? {
                ref: ref
            } : {};
            const renderTimesRef = $ltGt3.useRef(0);
            const prevProps = $ltGt3.useRef(props);
            // If parent has the context, we do not wrap it
            const mark = useImmutableMark();
            if (mark !== null) return /*#__PURE__*/ $ltGt3.createElement(Component, $61b6d74af70da25c$var$_extends({}, props, refProps));
            if (// Always trigger re-render if `shouldTriggerRender` is not provided
            !shouldTriggerRender || shouldTriggerRender(prevProps.current, props)) renderTimesRef.current += 1;
            prevProps.current = props;
            return /*#__PURE__*/ $ltGt3.createElement(ImmutableContext.Provider, {
                value: renderTimesRef.current
            }, /*#__PURE__*/ $ltGt3.createElement(Component, $61b6d74af70da25c$var$_extends({}, props, refProps)));
        };
        return refAble ? /*#__PURE__*/ $ltGt3.forwardRef(ImmutableComponent) : ImmutableComponent;
    }
    /**
   * Wrapped Component with `React.memo`.
   * But will rerender when parent with `makeImmutable` rerender.
   */ function responseImmutable(Component, propsAreEqual) {
        const refAble = (0, $22ff46e28c8066e1$export$c1cec34af06bcf7)(Component);
        const ImmutableComponent = (props, ref)=>{
            const refProps = refAble ? {
                ref: ref
            } : {};
            useImmutableMark();
            return /*#__PURE__*/ $ltGt3.createElement(Component, $61b6d74af70da25c$var$_extends({}, props, refProps));
        };
        return /*#__PURE__*/ $ltGt3.memo(refAble ? /*#__PURE__*/ $ltGt3.forwardRef(ImmutableComponent) : ImmutableComponent, propsAreEqual);
    }
    return {
        makeImmutable: makeImmutable,
        responseImmutable: responseImmutable,
        useImmutableMark: useImmutableMark
    };
}


// For legacy usage, we export it directly
const { makeImmutable: $69b13c1a45e4f2fb$export$ffd6d5bef5eaf0a4, responseImmutable: $69b13c1a45e4f2fb$export$e9e4cb9eb9e2b4c4, useImmutableMark: $69b13c1a45e4f2fb$export$c5d829a463bd3201 } = (0, $61b6d74af70da25c$export$2e2bcd8739ae039)();



var $ltGt3 = parcelRequire("ltGt3");

const { makeImmutable: $9b7ee26d9935a15f$export$ffd6d5bef5eaf0a4, responseImmutable: $9b7ee26d9935a15f$export$e9e4cb9eb9e2b4c4, useImmutableMark: $9b7ee26d9935a15f$export$c5d829a463bd3201 } = (0, $61b6d74af70da25c$export$2e2bcd8739ae039)();
const $9b7ee26d9935a15f$var$TableContext = (0, $f653da5403feaada$export$fd42f52fd3ae1109)();
var $9b7ee26d9935a15f$export$2e2bcd8739ae039 = $9b7ee26d9935a15f$var$TableContext;


/* istanbul ignore file */ 
var $ltGt3 = parcelRequire("ltGt3");
function $0ec5277012cf8329$var$useRenderTimes(props, debug) {
    // Render times
    const timesRef = $ltGt3.useRef(0);
    timesRef.current += 1;
    // Props changed
    const propsRef = $ltGt3.useRef(props);
    const keys = [];
    Object.keys(props || {}).map((key)=>{
        if (props?.[key] !== propsRef.current?.[key]) keys.push(key);
    });
    propsRef.current = props;
    // Cache keys since React rerender may cause it lost
    const keysRef = $ltGt3.useRef([]);
    if (keys.length) keysRef.current = keys;
    $ltGt3.useDebugValue(timesRef.current);
    $ltGt3.useDebugValue(keysRef.current.join(', '));
    if (debug) console.log(`${debug}:`, timesRef.current, keysRef.current);
    return timesRef.current;
}
var $0ec5277012cf8329$export$2e2bcd8739ae039 = ()=>{};
const $0ec5277012cf8329$export$e57c788cafefed4f = /*#__PURE__*/ $ltGt3.memo(()=>{
    const times = $0ec5277012cf8329$var$useRenderTimes();
    return /*#__PURE__*/ $ltGt3.createElement("h1", null, "Render Times: ", times);
});



var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");







var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// TODO: Remove when use `responsiveImmutable`
const $4e107f2629492abe$var$PerfContext = /*#__PURE__*/ $ltGt3.createContext({
    renderWithProps: false
});
var $4e107f2629492abe$export$2e2bcd8739ae039 = $4e107f2629492abe$var$PerfContext;


const $5e76e853ff0fad9c$var$INTERNAL_KEY_PREFIX = 'RC_TABLE_KEY';
function $5e76e853ff0fad9c$var$toArray(arr) {
    if (arr === undefined || arr === null) return [];
    return Array.isArray(arr) ? arr : [
        arr
    ];
}
function $5e76e853ff0fad9c$export$fd2ca5407d9be470(columns) {
    const columnKeys = [];
    const keys = {};
    columns.forEach((column)=>{
        const { key: key, dataIndex: dataIndex } = column || {};
        let mergedKey = key || $5e76e853ff0fad9c$var$toArray(dataIndex).join('-') || $5e76e853ff0fad9c$var$INTERNAL_KEY_PREFIX;
        while(keys[mergedKey])mergedKey = `${mergedKey}_next`;
        keys[mergedKey] = true;
        columnKeys.push(mergedKey);
    });
    return columnKeys;
}
function $5e76e853ff0fad9c$export$b76e9316566cc26e(val) {
    return val !== null && val !== undefined;
}
function $5e76e853ff0fad9c$export$b1cd2bdabe361feb(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}



function $6deb6472bf3f5c8d$var$isRenderCell(data) {
    return data && typeof data === 'object' && !Array.isArray(data) && !/*#__PURE__*/ $ltGt3.isValidElement(data);
}
function $6deb6472bf3f5c8d$export$2e2bcd8739ae039(record, dataIndex, renderIndex, children, render, shouldCellUpdate) {
    // TODO: Remove this after next major version
    const perfRecord = $ltGt3.useContext((0, $4e107f2629492abe$export$2e2bcd8739ae039));
    const mark = (0, $9b7ee26d9935a15f$export$c5d829a463bd3201)();
    // ======================== Render ========================
    const retData = (0, $dcca1fcd5fa22f3b$export$2e2bcd8739ae039)(()=>{
        if ((0, $5e76e853ff0fad9c$export$b76e9316566cc26e)(children)) return [
            children
        ];
        const path = dataIndex === null || dataIndex === undefined || dataIndex === '' ? [] : Array.isArray(dataIndex) ? dataIndex : [
            dataIndex
        ];
        const value = (0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(record, path);
        // Customize render node
        let returnChildNode = value;
        let returnCellProps = undefined;
        if (render) {
            const renderData = render(value, record, renderIndex);
            if ($6deb6472bf3f5c8d$var$isRenderCell(renderData)) {
                returnChildNode = renderData.children;
                returnCellProps = renderData.props;
                perfRecord.renderWithProps = true;
            } else returnChildNode = renderData;
        }
        return [
            returnChildNode,
            returnCellProps
        ];
    }, [
        // Force update deps
        mark,
        // Normal deps
        record,
        children,
        dataIndex,
        render,
        renderIndex
    ], (prev, next)=>{
        if (shouldCellUpdate) {
            const [, prevRecord] = prev;
            const [, nextRecord] = next;
            return shouldCellUpdate(nextRecord, prevRecord);
        }
        // Legacy mode should always update
        if (perfRecord.renderWithProps) return true;
        return !(0, $003c57daacb79f0c$export$2e2bcd8739ae039)(prev, next, true);
    });
    return retData;
}




/** Check if cell is in hover range */ function $f84d16f120738ab2$var$inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
    const cellEndRow = cellStartRow + cellRowSpan - 1;
    return cellStartRow <= endRow && cellEndRow >= startRow;
}
function $f84d16f120738ab2$export$2e2bcd8739ae039(rowIndex, rowSpan) {
    return (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), (ctx)=>{
        const hovering = $f84d16f120738ab2$var$inHoverRange(rowIndex, rowSpan || 1, ctx.hoverStartRow, ctx.hoverEndRow);
        return [
            hovering,
            ctx.onHover
        ];
    });
}



function $d1d596939e15211a$var$_extends() {
    $d1d596939e15211a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d1d596939e15211a$var$_extends.apply(this, arguments);
}
const $d1d596939e15211a$var$getTitleFromCellRenderChildren = ({ ellipsis: ellipsis, rowType: rowType, children: children })=>{
    let title;
    const ellipsisConfig = ellipsis === true ? {
        showTitle: true
    } : ellipsis;
    if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === 'header')) {
        if (typeof children === 'string' || typeof children === 'number') title = children.toString();
        else if (/*#__PURE__*/ $ltGt3.isValidElement(children) && typeof children.props?.children === 'string') title = children.props?.children;
    }
    return title;
};
const $d1d596939e15211a$var$Cell = (props)=>{
    const { component: Component, children: children, ellipsis: ellipsis, scope: scope, prefixCls: // Style
    prefixCls, className: className, style: style, align: align, record: // Value
    record, render: render, dataIndex: dataIndex, renderIndex: renderIndex, shouldCellUpdate: shouldCellUpdate, index: // Row
    index, rowType: rowType, colSpan: // Span
    colSpan, rowSpan: rowSpan, fixStart: // Fixed
    fixStart, fixEnd: fixEnd, fixedStartShadow: fixedStartShadow, fixedEndShadow: fixedEndShadow, offsetFixedStartShadow: offsetFixedStartShadow, offsetFixedEndShadow: offsetFixedEndShadow, zIndex: zIndex, zIndexReverse: zIndexReverse, appendNode: // Private
    appendNode, additionalProps: additionalProps = {}, isSticky: isSticky } = props;
    const cellPrefixCls = `${prefixCls}-cell`;
    const { allColumnsFixedLeft: allColumnsFixedLeft, rowHoverable: rowHoverable } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), [
        'allColumnsFixedLeft',
        'rowHoverable'
    ]);
    // ====================== Value =======================
    const [childNode, legacyCellProps] = (0, $6deb6472bf3f5c8d$export$2e2bcd8739ae039)(record, dataIndex, renderIndex, children, render, shouldCellUpdate);
    // ====================== Fixed =======================
    const fixedStyle = {};
    const isFixStart = typeof fixStart === 'number' && !allColumnsFixedLeft;
    const isFixEnd = typeof fixEnd === 'number' && !allColumnsFixedLeft;
    const [showFixStartShadow, showFixEndShadow] = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), ({ scrollInfo: scrollInfo })=>{
        if (!isFixStart && !isFixEnd) return [
            false,
            false
        ];
        const [absScroll, scrollWidth] = scrollInfo;
        const showStartShadow = (isFixStart && fixedStartShadow && absScroll) - // For precision, we not show shadow by default which has better user experience.
        offsetFixedStartShadow >= 1;
        const showEndShadow = (isFixEnd && fixedEndShadow && scrollWidth - absScroll) - // Same as above
        offsetFixedEndShadow > 1;
        return [
            showStartShadow,
            showEndShadow
        ];
    });
    if (isFixStart) {
        fixedStyle.insetInlineStart = fixStart;
        fixedStyle['--z-offset'] = zIndex;
        fixedStyle['--z-offset-reverse'] = zIndexReverse;
    }
    if (isFixEnd) {
        fixedStyle.insetInlineEnd = fixEnd;
        fixedStyle['--z-offset'] = zIndex;
        fixedStyle['--z-offset-reverse'] = zIndexReverse;
    }
    // ================ RowSpan & ColSpan =================
    const mergedColSpan = legacyCellProps?.colSpan ?? additionalProps.colSpan ?? colSpan ?? 1;
    const mergedRowSpan = legacyCellProps?.rowSpan ?? additionalProps.rowSpan ?? rowSpan ?? 1;
    // ====================== Hover =======================
    const [hovering, onHover] = (0, $f84d16f120738ab2$export$2e2bcd8739ae039)(index, mergedRowSpan);
    const onMouseEnter = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((event)=>{
        if (record) onHover(index, index + mergedRowSpan - 1);
        additionalProps?.onMouseEnter?.(event);
    });
    const onMouseLeave = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((event)=>{
        if (record) onHover(-1, -1);
        additionalProps?.onMouseLeave?.(event);
    });
    // ====================== Render ======================
    if (mergedColSpan === 0 || mergedRowSpan === 0) return null;
    // >>>>> Title
    const title = additionalProps.title ?? $d1d596939e15211a$var$getTitleFromCellRenderChildren({
        rowType: rowType,
        ellipsis: ellipsis,
        children: childNode
    });
    // >>>>> ClassName
    const mergedClassName = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(cellPrefixCls, className, {
        // Fixed
        [`${cellPrefixCls}-fix`]: isFixStart || isFixEnd,
        [`${cellPrefixCls}-fix-start`]: isFixStart,
        [`${cellPrefixCls}-fix-end`]: isFixEnd,
        // Fixed shadow
        [`${cellPrefixCls}-fix-start-shadow`]: fixedStartShadow,
        [`${cellPrefixCls}-fix-start-shadow-show`]: fixedStartShadow && showFixStartShadow,
        [`${cellPrefixCls}-fix-end-shadow`]: fixedEndShadow,
        [`${cellPrefixCls}-fix-end-shadow-show`]: fixedEndShadow && showFixEndShadow,
        [`${cellPrefixCls}-ellipsis`]: ellipsis,
        [`${cellPrefixCls}-with-append`]: appendNode,
        [`${cellPrefixCls}-fix-sticky`]: (isFixStart || isFixEnd) && isSticky,
        [`${cellPrefixCls}-row-hover`]: !legacyCellProps && hovering
    }, additionalProps.className, legacyCellProps?.className);
    // >>>>> Style
    const alignStyle = {};
    if (align) alignStyle.textAlign = align;
    // The order is important since user can overwrite style.
    // For example ant-design/ant-design#51763
    const mergedStyle = {
        ...legacyCellProps?.style,
        ...fixedStyle,
        ...alignStyle,
        ...additionalProps.style,
        ...style
    };
    // >>>>> Children Node
    let mergedChildNode = childNode;
    // Not crash if final `childNode` is not validate ReactNode
    if (typeof mergedChildNode === 'object' && !Array.isArray(mergedChildNode) && !/*#__PURE__*/ $ltGt3.isValidElement(mergedChildNode)) mergedChildNode = null;
    if (ellipsis && (fixedStartShadow || fixedEndShadow)) mergedChildNode = /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${cellPrefixCls}-content`
    }, mergedChildNode);
    return /*#__PURE__*/ $ltGt3.createElement(Component, $d1d596939e15211a$var$_extends({}, legacyCellProps, additionalProps, {
        className: mergedClassName,
        style: mergedStyle,
        title: title,
        scope: scope,
        onMouseEnter: rowHoverable ? onMouseEnter : undefined,
        onMouseLeave: rowHoverable ? onMouseLeave : undefined,
        colSpan: mergedColSpan !== 1 ? mergedColSpan : null,
        rowSpan: mergedRowSpan !== 1 ? mergedRowSpan : null
    }), appendNode, mergedChildNode);
};
var $d1d596939e15211a$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.memo($d1d596939e15211a$var$Cell);




function $4e464164fad088e8$var$isFixedStart(column) {
    return column.fixed === 'start';
}
function $4e464164fad088e8$var$isFixedEnd(column) {
    return column.fixed === 'end';
}
function $4e464164fad088e8$export$695db918331141f3(colStart, colEnd, columns, stickyOffsets) {
    const startColumn = columns[colStart] || {};
    const endColumn = columns[colEnd] || {};
    let fixStart = null;
    let fixEnd = null;
    if ($4e464164fad088e8$var$isFixedStart(startColumn) && $4e464164fad088e8$var$isFixedStart(endColumn)) fixStart = stickyOffsets.start[colStart];
    else if ($4e464164fad088e8$var$isFixedEnd(endColumn) && $4e464164fad088e8$var$isFixedEnd(startColumn)) fixEnd = stickyOffsets.end[colEnd];
    // check if need to add shadow
    let fixedStartShadow = false;
    let fixedEndShadow = false;
    // Calc `zIndex`.
    // first fixed start (start -> end) column `zIndex` should be greater than next column.
    // first fixed end (end -> start) column `zIndex` should be greater than next column.
    let zIndex = 0;
    let zIndexReverse = 0;
    if (fixStart !== null) {
        fixedStartShadow = !columns[colEnd + 1] || !$4e464164fad088e8$var$isFixedStart(columns[colEnd + 1]);
        zIndex = columns.length * 2 - colStart; // Fix start always overlay fix end
        zIndexReverse = columns.length + colStart;
    }
    if (fixEnd !== null) {
        fixedEndShadow = !columns[colStart - 1] || !$4e464164fad088e8$var$isFixedEnd(columns[colStart - 1]);
        zIndex = colEnd;
        zIndexReverse = columns.length - colEnd; // Fix end always overlay fix start
    }
    // Check if scrollLeft will show the shadow
    let offsetFixedStartShadow = 0;
    let offsetFixedEndShadow = 0;
    if (fixedStartShadow) {
        for(let i = 0; i < colStart; i += 1)if (!$4e464164fad088e8$var$isFixedStart(columns[i])) offsetFixedStartShadow += stickyOffsets.widths[i] || 0;
    }
    if (fixedEndShadow) {
        for(let i = columns.length - 1; i > colEnd; i -= 1)if (!$4e464164fad088e8$var$isFixedEnd(columns[i])) offsetFixedEndShadow += stickyOffsets.widths[i] || 0;
    }
    return {
        fixStart: fixStart,
        fixEnd: fixEnd,
        fixedStartShadow: fixedStartShadow,
        fixedEndShadow: fixedEndShadow,
        offsetFixedStartShadow: offsetFixedStartShadow,
        offsetFixedEndShadow: offsetFixedEndShadow,
        isSticky: stickyOffsets.isSticky,
        zIndex: zIndex,
        zIndexReverse: zIndexReverse
    };
}



var $ltGt3 = parcelRequire("ltGt3");
const $1993ed75e9e5dc2e$var$SummaryContext = /*#__PURE__*/ $ltGt3.createContext({});
var $1993ed75e9e5dc2e$export$2e2bcd8739ae039 = $1993ed75e9e5dc2e$var$SummaryContext;


function $9b8e4ed14e497f36$var$_extends() {
    $9b8e4ed14e497f36$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9b8e4ed14e497f36$var$_extends.apply(this, arguments);
}
const $9b8e4ed14e497f36$var$SummaryCell = (props)=>{
    const { className: className, index: index, children: children, colSpan: colSpan = 1, rowSpan: rowSpan, align: align } = props;
    const { prefixCls: prefixCls } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), [
        'prefixCls'
    ]);
    const { scrollColumnIndex: scrollColumnIndex, stickyOffsets: stickyOffsets, flattenColumns: flattenColumns } = $ltGt3.useContext((0, $1993ed75e9e5dc2e$export$2e2bcd8739ae039));
    const lastIndex = index + colSpan - 1;
    const mergedColSpan = lastIndex + 1 === scrollColumnIndex ? colSpan + 1 : colSpan;
    const fixedInfo = $ltGt3.useMemo(()=>(0, $4e464164fad088e8$export$695db918331141f3)(index, index + mergedColSpan - 1, flattenColumns, stickyOffsets), [
        index,
        mergedColSpan,
        flattenColumns,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $d1d596939e15211a$export$2e2bcd8739ae039), $9b8e4ed14e497f36$var$_extends({
        className: className,
        index: index,
        component: "td",
        prefixCls: prefixCls,
        record: null,
        dataIndex: null,
        align: align,
        colSpan: mergedColSpan,
        rowSpan: rowSpan,
        render: ()=>children
    }, fixedInfo));
};
var $9b8e4ed14e497f36$export$2e2bcd8739ae039 = $9b8e4ed14e497f36$var$SummaryCell;



var $ltGt3 = parcelRequire("ltGt3");
const $d79fc036d158abd2$var$FooterRow = (props)=>{
    const { children: children, ...restProps } = props;
    return /*#__PURE__*/ $ltGt3.createElement("tr", restProps, children);
};
var $d79fc036d158abd2$export$2e2bcd8739ae039 = $d79fc036d158abd2$var$FooterRow;


/**
 * Syntactic sugar. Do not support HOC.
 */ const $914dc1290b03be67$var$Summary = (props)=>{
    const { children: children } = props;
    return children;
};
$914dc1290b03be67$var$Summary.Row = (0, $d79fc036d158abd2$export$2e2bcd8739ae039);
$914dc1290b03be67$var$Summary.Cell = (0, $9b8e4ed14e497f36$export$2e2bcd8739ae039);
var $914dc1290b03be67$export$2e2bcd8739ae039 = $914dc1290b03be67$var$Summary;



const $9267102c2ff8aee5$var$Footer = (props)=>{
    const { children: children, stickyOffsets: stickyOffsets, flattenColumns: flattenColumns } = props;
    const prefixCls = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), 'prefixCls');
    const lastColumnIndex = flattenColumns.length - 1;
    const scrollColumn = flattenColumns[lastColumnIndex];
    const summaryContext = $ltGt3.useMemo(()=>({
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns,
            scrollColumnIndex: scrollColumn?.scrollbar ? lastColumnIndex : null
        }), [
        scrollColumn,
        flattenColumns,
        lastColumnIndex,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $1993ed75e9e5dc2e$export$2e2bcd8739ae039).Provider, {
        value: summaryContext
    }, /*#__PURE__*/ $ltGt3.createElement("tfoot", {
        className: `${prefixCls}-summary`
    }, children));
};
var $9267102c2ff8aee5$export$2e2bcd8739ae039 = (0, $9b7ee26d9935a15f$export$e9e4cb9eb9e2b4c4)($9267102c2ff8aee5$var$Footer);
const $9267102c2ff8aee5$export$d605f3af09eef683 = (0, $914dc1290b03be67$export$2e2bcd8739ae039);


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $9f2bf0fb1ad5c6d0$var$Column(_) {
    return null;
}
var $9f2bf0fb1ad5c6d0$export$2e2bcd8739ae039 = $9f2bf0fb1ad5c6d0$var$Column;


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $89c42773f9f37277$var$ColumnGroup(_) {
    return null;
}
var $89c42773f9f37277$export$2e2bcd8739ae039 = $89c42773f9f37277$var$ColumnGroup;










var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");
// recursion (flat tree structure)
function $239e00f5e77b43d1$var$fillRecords(list, record, indent, childrenColumnName, expandedKeys, getRowKey, index) {
    const key = getRowKey(record, index);
    list.push({
        record: record,
        indent: indent,
        index: index,
        rowKey: key
    });
    const expanded = expandedKeys?.has(key);
    if (record && Array.isArray(record[childrenColumnName]) && expanded) // expanded state, flat record
    for(let i = 0; i < record[childrenColumnName].length; i += 1)$239e00f5e77b43d1$var$fillRecords(list, record[childrenColumnName][i], indent + 1, childrenColumnName, expandedKeys, getRowKey, i);
}
function $239e00f5e77b43d1$export$2e2bcd8739ae039(data, childrenColumnName, expandedKeys, getRowKey) {
    const arr = $ltGt3.useMemo(()=>{
        if (expandedKeys?.size) {
            const list = [];
            // collect flattened record
            for(let i = 0; i < data?.length; i += 1){
                const record = data[i];
                // using array.push or spread operator may cause "Maximum call stack size exceeded" exception if array size is big enough.
                $239e00f5e77b43d1$var$fillRecords(list, record, 0, childrenColumnName, expandedKeys, getRowKey, i);
            }
            return list;
        }
        return data?.map((item, index)=>{
            return {
                record: item,
                indent: 0,
                index: index,
                rowKey: getRowKey(item, index)
            };
        });
    }, [
        data,
        childrenColumnName,
        expandedKeys,
        getRowKey
    ]);
    return arr;
}






var $ltGt3 = parcelRequire("ltGt3");








function $9d56bedc6f834880$export$2e2bcd8739ae039(record, rowKey, recordIndex, indent) {
    const context = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), [
        'prefixCls',
        'fixedInfoList',
        'flattenColumns',
        'expandableType',
        'expandRowByClick',
        'onTriggerExpand',
        'rowClassName',
        'expandedRowClassName',
        'indentSize',
        'expandIcon',
        'expandedRowRender',
        'expandIconColumnIndex',
        'expandedKeys',
        'childrenColumnName',
        'rowExpandable',
        'onRow'
    ]);
    const { flattenColumns: flattenColumns, expandableType: expandableType, expandedKeys: expandedKeys, childrenColumnName: childrenColumnName, onTriggerExpand: onTriggerExpand, rowExpandable: rowExpandable, onRow: onRow, expandRowByClick: expandRowByClick, rowClassName: rowClassName } = context;
    // ======================= Expandable =======================
    // Only when row is not expandable and `children` exist in record
    const nestExpandable = expandableType === 'nest';
    const rowSupportExpand = expandableType === 'row' && (!rowExpandable || rowExpandable(record));
    const mergedExpandable = rowSupportExpand || nestExpandable;
    const expanded = expandedKeys && expandedKeys.has(rowKey);
    const hasNestChildren = childrenColumnName && record && record[childrenColumnName];
    const onInternalTriggerExpand = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(onTriggerExpand);
    // ========================= onRow ==========================
    const rowProps = onRow?.(record, recordIndex);
    const onRowClick = rowProps?.onClick;
    const onClick = (event, ...args)=>{
        if (expandRowByClick && mergedExpandable) onTriggerExpand(record, event);
        onRowClick?.(event, ...args);
    };
    // ====================== RowClassName ======================
    let computeRowClassName;
    if (typeof rowClassName === 'string') computeRowClassName = rowClassName;
    else if (typeof rowClassName === 'function') computeRowClassName = rowClassName(record, recordIndex, indent);
    // ========================= Column =========================
    const columnsKey = (0, $5e76e853ff0fad9c$export$fd2ca5407d9be470)(flattenColumns);
    return {
        ...context,
        columnsKey: columnsKey,
        nestExpandable: nestExpandable,
        expanded: expanded,
        hasNestChildren: hasNestChildren,
        record: record,
        onTriggerExpand: onInternalTriggerExpand,
        rowSupportExpand: rowSupportExpand,
        expandable: mergedExpandable,
        rowProps: {
            ...rowProps,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(computeRowClassName, rowProps?.className),
            onClick: onClick
        }
    };
}




var $ltGt3 = parcelRequire("ltGt3");



const $14b8fb6d592f6830$var$ExpandedRow = (props)=>{
    const { prefixCls: prefixCls, children: children, component: Component, cellComponent: cellComponent, className: className, expanded: expanded, colSpan: colSpan, isEmpty: isEmpty, stickyOffset: stickyOffset = 0 } = props;
    const { scrollbarSize: scrollbarSize, fixHeader: fixHeader, fixColumn: fixColumn, componentWidth: componentWidth, horizonScroll: horizonScroll } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), [
        'scrollbarSize',
        'fixHeader',
        'fixColumn',
        'componentWidth',
        'horizonScroll'
    ]);
    // Cache render node
    let contentNode = children;
    if (isEmpty ? horizonScroll && componentWidth : fixColumn) contentNode = /*#__PURE__*/ $ltGt3.createElement("div", {
        style: {
            width: componentWidth - stickyOffset - (fixHeader && !isEmpty ? scrollbarSize : 0),
            position: 'sticky',
            left: stickyOffset,
            overflow: 'hidden'
        },
        className: `${prefixCls}-expanded-row-fixed`
    }, contentNode);
    return /*#__PURE__*/ $ltGt3.createElement(Component, {
        className: className,
        style: {
            display: expanded ? null : 'none'
        }
    }, /*#__PURE__*/ $ltGt3.createElement((0, $d1d596939e15211a$export$2e2bcd8739ae039), {
        component: cellComponent,
        prefixCls: prefixCls,
        colSpan: colSpan
    }, contentNode));
};
var $14b8fb6d592f6830$export$2e2bcd8739ae039 = $14b8fb6d592f6830$var$ExpandedRow;



var $ltGt3 = parcelRequire("ltGt3");

function $e770fa404d4c4535$export$ae14373a7f810e33({ prefixCls: prefixCls, record: record, onExpand: onExpand, expanded: expanded, expandable: expandable }) {
    const expandClassName = `${prefixCls}-row-expand-icon`;
    if (!expandable) return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(expandClassName, `${prefixCls}-row-spaced`)
    });
    const onClick = (event)=>{
        onExpand(record, event);
        event.stopPropagation();
    };
    return /*#__PURE__*/ $ltGt3.createElement("span", {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(expandClassName, {
            [`${prefixCls}-row-expanded`]: expanded,
            [`${prefixCls}-row-collapsed`]: !expanded
        }),
        onClick: onClick
    });
}
function $e770fa404d4c4535$export$49bec56f6055f375(data, getRowKey, childrenColumnName) {
    const keys = [];
    function dig(list) {
        (list || []).forEach((item, index)=>{
            keys.push(getRowKey(item, index));
            dig(item[childrenColumnName]);
        });
    }
    dig(data);
    return keys;
}
function $e770fa404d4c4535$export$c5c465afb98f57b6(cls, record, index, indent) {
    if (typeof cls === 'string') return cls;
    if (typeof cls === 'function') return cls(record, index, indent);
    return '';
}


function $02955f9e72f1628f$var$_extends() {
    $02955f9e72f1628f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $02955f9e72f1628f$var$_extends.apply(this, arguments);
}
function $02955f9e72f1628f$export$16400ac709c56616(rowInfo, column, colIndex, indent, index, rowKeys = [], expandedRowOffset = 0) {
    const { record: record, prefixCls: prefixCls, columnsKey: columnsKey, fixedInfoList: fixedInfoList, expandIconColumnIndex: expandIconColumnIndex, nestExpandable: nestExpandable, indentSize: indentSize, expandIcon: expandIcon, expanded: expanded, hasNestChildren: hasNestChildren, onTriggerExpand: onTriggerExpand, expandable: expandable, expandedKeys: expandedKeys } = rowInfo;
    const key = columnsKey[colIndex];
    const fixedInfo = fixedInfoList[colIndex];
    // ============= Used for nest expandable =============
    let appendCellNode;
    if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) appendCellNode = /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement("span", {
        style: {
            paddingLeft: `${indentSize * indent}px`
        },
        className: `${prefixCls}-row-indent indent-level-${indent}`
    }), expandIcon({
        prefixCls: prefixCls,
        expanded: expanded,
        expandable: hasNestChildren,
        record: record,
        onExpand: onTriggerExpand
    }));
    const additionalCellProps = column.onCell?.(record, index) || {};
    // Expandable row has offset
    if (expandedRowOffset) {
        const { rowSpan: rowSpan = 1 } = additionalCellProps;
        // For expandable row with rowSpan,
        // We should increase the rowSpan if the row is expanded
        if (expandable && rowSpan && colIndex < expandedRowOffset) {
            let currentRowSpan = rowSpan;
            for(let i = index; i < index + rowSpan; i += 1){
                const rowKey = rowKeys[i];
                if (expandedKeys.has(rowKey)) currentRowSpan += 1;
            }
            additionalCellProps.rowSpan = currentRowSpan;
        }
    }
    return {
        key: key,
        fixedInfo: fixedInfo,
        appendCellNode: appendCellNode,
        additionalCellProps: additionalCellProps
    };
}
// ==================================================================================
// ==                                 getCellProps                                 ==
// ==================================================================================
const $02955f9e72f1628f$var$BodyRow = (props)=>{
    const { className: className, style: style, classNames: classNames, styles: styles, record: record, index: index, renderIndex: renderIndex, rowKey: rowKey, rowKeys: rowKeys, indent: indent = 0, rowComponent: RowComponent, cellComponent: cellComponent, scopeCellComponent: scopeCellComponent, expandedRowInfo: expandedRowInfo } = props;
    const rowInfo = (0, $9d56bedc6f834880$export$2e2bcd8739ae039)(record, rowKey, index, indent);
    const { prefixCls: prefixCls, flattenColumns: flattenColumns, expandedRowClassName: expandedRowClassName, expandedRowRender: expandedRowRender, rowProps: rowProps, expanded: // Misc
    expanded, rowSupportExpand: rowSupportExpand } = rowInfo;
    // Force render expand row if expanded before
    const expandedRef = $ltGt3.useRef(false);
    expandedRef.current ||= expanded;
    // 若没有 expandedRowRender 参数, 将使用 baseRowNode 渲染 Children
    // 此时如果 level > 1 则说明是 expandedRow, 一样需要附加 computedExpandedRowClassName
    const expandedClsName = (0, $e770fa404d4c4535$export$c5c465afb98f57b6)(expandedRowClassName, record, index, indent);
    // ======================== Base tr row ========================
    const baseRowNode = /*#__PURE__*/ $ltGt3.createElement(RowComponent, $02955f9e72f1628f$var$_extends({}, rowProps, {
        "data-row-key": rowKey,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, `${prefixCls}-row`, `${prefixCls}-row-level-${indent}`, rowProps?.className, classNames.row, {
            [expandedClsName]: indent >= 1
        }),
        style: {
            ...style,
            ...rowProps?.style,
            ...styles.row
        }
    }), flattenColumns.map((column, colIndex)=>{
        const { render: render, dataIndex: dataIndex, className: columnClassName } = column;
        const { key: key, fixedInfo: fixedInfo, appendCellNode: appendCellNode, additionalCellProps: additionalCellProps } = $02955f9e72f1628f$export$16400ac709c56616(rowInfo, column, colIndex, indent, index, rowKeys, expandedRowInfo?.offset);
        return /*#__PURE__*/ $ltGt3.createElement((0, $d1d596939e15211a$export$2e2bcd8739ae039), $02955f9e72f1628f$var$_extends({
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(columnClassName, classNames.cell),
            style: styles.cell,
            ellipsis: column.ellipsis,
            align: column.align,
            scope: column.rowScope,
            component: column.rowScope ? scopeCellComponent : cellComponent,
            prefixCls: prefixCls,
            key: key,
            record: record,
            index: index,
            renderIndex: renderIndex,
            dataIndex: dataIndex,
            render: render,
            shouldCellUpdate: column.shouldCellUpdate
        }, fixedInfo, {
            appendNode: appendCellNode,
            additionalProps: additionalCellProps
        }));
    }));
    // ======================== Expand Row =========================
    let expandRowNode;
    if (rowSupportExpand && (expandedRef.current || expanded)) {
        const expandContent = expandedRowRender(record, index, indent + 1, expanded);
        expandRowNode = /*#__PURE__*/ $ltGt3.createElement((0, $14b8fb6d592f6830$export$2e2bcd8739ae039), {
            expanded: expanded,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-expanded-row`, `${prefixCls}-expanded-row-level-${indent + 1}`, expandedClsName),
            prefixCls: prefixCls,
            component: RowComponent,
            cellComponent: cellComponent,
            colSpan: expandedRowInfo ? expandedRowInfo.colSpan : flattenColumns.length,
            isEmpty: false,
            stickyOffset: expandedRowInfo?.sticky
        }, expandContent);
    }
    return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, baseRowNode, expandRowNode);
};
var $02955f9e72f1628f$export$2e2bcd8739ae039 = (0, $9b7ee26d9935a15f$export$e9e4cb9eb9e2b4c4)($02955f9e72f1628f$var$BodyRow);




var $ltGt3 = parcelRequire("ltGt3");


var $ltGt3 = parcelRequire("ltGt3");


const $14122203e7aa7c31$var$MeasureCell = (props)=>{
    const { columnKey: columnKey, onColumnResize: onColumnResize, title: title } = props;
    const cellRef = $ltGt3.useRef(null);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (cellRef.current) onColumnResize(columnKey, cellRef.current.offsetWidth);
    }, []);
    return /*#__PURE__*/ $ltGt3.createElement((0, $9ed13185b45d829d$export$2e2bcd8739ae039), {
        data: columnKey
    }, /*#__PURE__*/ $ltGt3.createElement("td", {
        ref: cellRef,
        style: {
            paddingTop: 0,
            paddingBottom: 0,
            borderTop: 0,
            borderBottom: 0,
            height: 0
        }
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        style: {
            height: 0,
            overflow: 'hidden',
            fontWeight: 'bold'
        }
    }, title || '\xa0')));
};
var $14122203e7aa7c31$export$2e2bcd8739ae039 = $14122203e7aa7c31$var$MeasureCell;





const $7e56ecfa5583a125$var$MeasureRow = ({ prefixCls: prefixCls, columnsKey: columnsKey, onColumnResize: onColumnResize, columns: columns })=>{
    const ref = $ltGt3.useRef(null);
    const { measureRowRender: measureRowRender } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), [
        'measureRowRender'
    ]);
    const measureRow = /*#__PURE__*/ $ltGt3.createElement("tr", {
        "aria-hidden": "true",
        className: `${prefixCls}-measure-row`,
        style: {
            height: 0
        },
        ref: ref
    }, /*#__PURE__*/ $ltGt3.createElement((0, $9ed13185b45d829d$export$2e2bcd8739ae039).Collection, {
        onBatchResize: (infoList)=>{
            if ((0, $d3c89c1e130d7e35$export$2e2bcd8739ae039)(ref.current)) infoList.forEach(({ data: columnKey, size: size })=>{
                onColumnResize(columnKey, size.offsetWidth);
            });
        }
    }, columnsKey.map((columnKey)=>{
        const column = columns.find((col)=>col.key === columnKey);
        const rawTitle = column?.title;
        const titleForMeasure = /*#__PURE__*/ $ltGt3.isValidElement(rawTitle) ? /*#__PURE__*/ $ltGt3.cloneElement(rawTitle, {
            ref: null
        }) : rawTitle;
        return /*#__PURE__*/ $ltGt3.createElement((0, $14122203e7aa7c31$export$2e2bcd8739ae039), {
            key: columnKey,
            columnKey: columnKey,
            onColumnResize: onColumnResize,
            title: titleForMeasure
        });
    })));
    return typeof measureRowRender === 'function' ? measureRowRender(measureRow) : measureRow;
};
var $7e56ecfa5583a125$export$2e2bcd8739ae039 = $7e56ecfa5583a125$var$MeasureRow;


const $6b1a2f391084e986$var$Body = (props)=>{
    const { data: data, measureColumnWidth: measureColumnWidth } = props;
    const { prefixCls: prefixCls, getComponent: getComponent, onColumnResize: onColumnResize, flattenColumns: flattenColumns, getRowKey: getRowKey, expandedKeys: expandedKeys, childrenColumnName: childrenColumnName, emptyNode: emptyNode, classNames: classNames, styles: styles, expandedRowOffset: expandedRowOffset = 0, colWidths: colWidths } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), [
        'prefixCls',
        'getComponent',
        'onColumnResize',
        'flattenColumns',
        'getRowKey',
        'expandedKeys',
        'childrenColumnName',
        'emptyNode',
        'classNames',
        'styles',
        'expandedRowOffset',
        'fixedInfoList',
        'colWidths'
    ]);
    const { body: bodyCls = {} } = classNames || {};
    const { body: bodyStyles = {} } = styles || {};
    const flattenData = (0, $239e00f5e77b43d1$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey);
    const rowKeys = $ltGt3.useMemo(()=>flattenData.map((item)=>item.rowKey), [
        flattenData
    ]);
    // =================== Performance ====================
    const perfRef = $ltGt3.useRef({
        renderWithProps: false
    });
    // ===================== Expanded =====================
    // `expandedRowOffset` data is same for all the rows.
    // Let's calc on Body side to save performance.
    const expandedRowInfo = $ltGt3.useMemo(()=>{
        const expandedColSpan = flattenColumns.length - expandedRowOffset;
        let expandedStickyStart = 0;
        for(let i = 0; i < expandedRowOffset; i += 1)expandedStickyStart += colWidths[i] || 0;
        return {
            offset: expandedRowOffset,
            colSpan: expandedColSpan,
            sticky: expandedStickyStart
        };
    }, [
        flattenColumns.length,
        expandedRowOffset,
        colWidths
    ]);
    // ====================== Render ======================
    const WrapperComponent = getComponent([
        'body',
        'wrapper'
    ], 'tbody');
    const trComponent = getComponent([
        'body',
        'row'
    ], 'tr');
    const tdComponent = getComponent([
        'body',
        'cell'
    ], 'td');
    const thComponent = getComponent([
        'body',
        'cell'
    ], 'th');
    let rows;
    if (data.length) rows = flattenData.map((item, idx)=>{
        const { record: record, indent: indent, index: renderIndex, rowKey: rowKey } = item;
        return /*#__PURE__*/ $ltGt3.createElement((0, $02955f9e72f1628f$export$2e2bcd8739ae039), {
            classNames: bodyCls,
            styles: bodyStyles,
            key: rowKey,
            rowKey: rowKey,
            rowKeys: rowKeys,
            record: record,
            index: idx,
            renderIndex: renderIndex,
            rowComponent: trComponent,
            cellComponent: tdComponent,
            scopeCellComponent: thComponent,
            indent: indent,
            expandedRowInfo: expandedRowInfo
        });
    });
    else rows = /*#__PURE__*/ $ltGt3.createElement((0, $14b8fb6d592f6830$export$2e2bcd8739ae039), {
        expanded: true,
        className: `${prefixCls}-placeholder`,
        prefixCls: prefixCls,
        component: trComponent,
        cellComponent: tdComponent,
        colSpan: flattenColumns.length,
        isEmpty: true
    }, emptyNode);
    const columnsKey = (0, $5e76e853ff0fad9c$export$fd2ca5407d9be470)(flattenColumns);
    return /*#__PURE__*/ $ltGt3.createElement((0, $4e107f2629492abe$export$2e2bcd8739ae039).Provider, {
        value: perfRef.current
    }, /*#__PURE__*/ $ltGt3.createElement(WrapperComponent, {
        style: bodyStyles.wrapper,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-tbody`, bodyCls.wrapper)
    }, measureColumnWidth && /*#__PURE__*/ $ltGt3.createElement((0, $7e56ecfa5583a125$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        columnsKey: columnsKey,
        onColumnResize: onColumnResize,
        columns: flattenColumns
    }), rows));
};
var $6b1a2f391084e986$export$2e2bcd8739ae039 = (0, $9b7ee26d9935a15f$export$e9e4cb9eb9e2b4c4)($6b1a2f391084e986$var$Body);



var $ltGt3 = parcelRequire("ltGt3");

const $dafd2d773d2769d9$export$f8dba99c0d5b6b87 = 'RC_TABLE_INTERNAL_COL_DEFINE';
function $dafd2d773d2769d9$export$e215b9806eacdfb5(props) {
    const { expandable: expandable, ...legacyExpandableConfig } = props;
    let config;
    if ('expandable' in props) config = {
        ...legacyExpandableConfig,
        ...expandable
    };
    else config = legacyExpandableConfig;
    if (config.showExpandColumn === false) config.expandIconColumnIndex = -1;
    return config;
}




function $19d48080cb1866a7$var$_extends() {
    $19d48080cb1866a7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $19d48080cb1866a7$var$_extends.apply(this, arguments);
}
const $19d48080cb1866a7$var$ColGroup = (props)=>{
    const { colWidths: colWidths, columns: columns, columCount: columCount } = props;
    const { tableLayout: tableLayout } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), [
        'tableLayout'
    ]);
    const cols = [];
    const len = columCount || columns.length;
    // Only insert col with width & additional props
    // Skip if rest col do not have any useful info
    let mustInsert = false;
    for(let i = len - 1; i >= 0; i -= 1){
        const width = colWidths[i];
        const column = columns && columns[i];
        let additionalProps;
        let minWidth;
        if (column) {
            additionalProps = column[0, $dafd2d773d2769d9$export$f8dba99c0d5b6b87];
            // fixed will cause layout problems
            if (tableLayout === 'auto') minWidth = column.minWidth;
        }
        if (width || minWidth || additionalProps || mustInsert) {
            const { columnType: columnType, ...restAdditionalProps } = additionalProps || {};
            cols.unshift(/*#__PURE__*/ $ltGt3.createElement("col", $19d48080cb1866a7$var$_extends({
                key: i,
                style: {
                    width: width,
                    minWidth: minWidth
                }
            }, restAdditionalProps)));
            mustInsert = true;
        }
    }
    return cols.length > 0 ? /*#__PURE__*/ $ltGt3.createElement("colgroup", null, cols) : null;
};
var $19d48080cb1866a7$export$2e2bcd8739ae039 = $19d48080cb1866a7$var$ColGroup;








var $ltGt3 = parcelRequire("ltGt3");



function $fc9312ec697f5ea2$var$useColumnWidth(colWidths, columCount) {
    return (0, $ltGt3.useMemo)(()=>{
        const cloneColumns = [];
        for(let i = 0; i < columCount; i += 1){
            const val = colWidths[i];
            if (val !== undefined) cloneColumns[i] = val;
            else return null;
        }
        return cloneColumns;
    }, [
        colWidths.join('_'),
        columCount
    ]);
}
const $fc9312ec697f5ea2$var$FixedHolder = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { className: className, style: style, noData: noData, columns: columns, flattenColumns: flattenColumns, colWidths: colWidths, colGroup: colGroup, columCount: columCount, stickyOffsets: stickyOffsets, direction: direction, fixHeader: fixHeader, stickyTopOffset: stickyTopOffset, stickyBottomOffset: stickyBottomOffset, stickyClassName: stickyClassName, scrollX: scrollX, tableLayout: tableLayout = 'fixed', onScroll: onScroll, maxContentScroll: maxContentScroll, children: children, ...restProps } = props;
    const { prefixCls: prefixCls, scrollbarSize: scrollbarSize, isSticky: isSticky, getComponent: getComponent } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), [
        'prefixCls',
        'scrollbarSize',
        'isSticky',
        'getComponent'
    ]);
    const TableComponent = getComponent([
        'header',
        'table'
    ], 'table');
    const combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize;
    // Pass wheel to scroll event
    const scrollRef = $ltGt3.useRef(null);
    const setScrollRef = $ltGt3.useCallback((element)=>{
        (0, $22ff46e28c8066e1$export$f17fd18fa51dcb5b)(ref, element);
        (0, $22ff46e28c8066e1$export$f17fd18fa51dcb5b)(scrollRef, element);
    }, []);
    $ltGt3.useEffect(()=>{
        function onWheel(e) {
            const { currentTarget: currentTarget, deltaX: deltaX } = e;
            if (deltaX) {
                const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = currentTarget;
                const maxScrollWidth = scrollWidth - clientWidth;
                let nextScroll = scrollLeft + deltaX;
                if (direction === 'rtl') {
                    nextScroll = Math.max(-maxScrollWidth, nextScroll);
                    nextScroll = Math.min(0, nextScroll);
                } else {
                    nextScroll = Math.min(maxScrollWidth, nextScroll);
                    nextScroll = Math.max(0, nextScroll);
                }
                onScroll({
                    currentTarget: currentTarget,
                    scrollLeft: nextScroll
                });
                e.preventDefault();
            }
        }
        const scrollEle = scrollRef.current;
        scrollEle?.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>{
            scrollEle?.removeEventListener('wheel', onWheel);
        };
    }, []);
    // Add scrollbar column
    const lastColumn = flattenColumns[flattenColumns.length - 1];
    const ScrollBarColumn = {
        fixed: lastColumn ? lastColumn.fixed : null,
        scrollbar: true,
        onHeaderCell: ()=>({
                className: `${prefixCls}-cell-scrollbar`
            })
    };
    const columnsWithScrollbar = (0, $ltGt3.useMemo)(()=>combinationScrollBarSize ? [
            ...columns,
            ScrollBarColumn
        ] : columns, [
        combinationScrollBarSize,
        columns
    ]);
    const flattenColumnsWithScrollbar = (0, $ltGt3.useMemo)(()=>combinationScrollBarSize ? [
            ...flattenColumns,
            ScrollBarColumn
        ] : flattenColumns, [
        combinationScrollBarSize,
        flattenColumns
    ]);
    // Calculate the sticky offsets
    const headerStickyOffsets = (0, $ltGt3.useMemo)(()=>{
        const { start: start, end: end } = stickyOffsets;
        return {
            ...stickyOffsets,
            // left:
            //   direction === 'rtl' ? [...left.map(width => width + combinationScrollBarSize), 0] : left,
            // right:
            //   direction === 'rtl' ? right : [...right.map(width => width + combinationScrollBarSize), 0],
            start: start,
            end: [
                ...end.map((width)=>width + combinationScrollBarSize),
                0
            ],
            isSticky: isSticky
        };
    }, [
        combinationScrollBarSize,
        stickyOffsets,
        isSticky
    ]);
    const mergedColumnWidth = $fc9312ec697f5ea2$var$useColumnWidth(colWidths, columCount);
    const isColGroupEmpty = (0, $ltGt3.useMemo)(()=>{
        // use original ColGroup if no data or no calculated column width, otherwise use calculated column width
        // Return original colGroup if no data, or mergedColumnWidth is empty, or all widths are falsy
        const noWidth = !mergedColumnWidth || !mergedColumnWidth.length || mergedColumnWidth.every((w)=>!w);
        return noData || noWidth;
    }, [
        noData,
        mergedColumnWidth
    ]);
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        style: {
            overflow: 'hidden',
            ...isSticky ? {
                top: stickyTopOffset,
                bottom: stickyBottomOffset
            } : {},
            ...style
        },
        ref: setScrollRef,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, {
            [stickyClassName]: !!stickyClassName
        })
    }, /*#__PURE__*/ $ltGt3.createElement(TableComponent, {
        style: {
            tableLayout: tableLayout,
            minWidth: '100%',
            // https://github.com/ant-design/ant-design/issues/54894
            width: scrollX
        }
    }, isColGroupEmpty ? colGroup : /*#__PURE__*/ $ltGt3.createElement((0, $19d48080cb1866a7$export$2e2bcd8739ae039), {
        colWidths: [
            ...mergedColumnWidth,
            combinationScrollBarSize
        ],
        columCount: columCount + 1,
        columns: flattenColumnsWithScrollbar
    }), children({
        ...restProps,
        stickyOffsets: headerStickyOffsets,
        columns: columnsWithScrollbar,
        flattenColumns: flattenColumnsWithScrollbar
    })));
});
var /** Return a table in div as fixed element which contains sticky info */ // export default responseImmutable(FixedHolder);
$fc9312ec697f5ea2$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.memo($fc9312ec697f5ea2$var$FixedHolder);





var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");





function $cb1f4380451cfa15$var$_extends() {
    $cb1f4380451cfa15$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cb1f4380451cfa15$var$_extends.apply(this, arguments);
}
const $cb1f4380451cfa15$var$HeaderRow = (props)=>{
    const { cells: cells, stickyOffsets: stickyOffsets, flattenColumns: flattenColumns, rowComponent: RowComponent, cellComponent: CellComponent, onHeaderRow: onHeaderRow, index: index, classNames: classNames, styles: styles } = props;
    const { prefixCls: prefixCls } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), [
        'prefixCls'
    ]);
    let rowProps;
    if (onHeaderRow) rowProps = onHeaderRow(cells.map((cell)=>cell.column), index);
    const columnsKey = (0, $5e76e853ff0fad9c$export$fd2ca5407d9be470)(cells.map((cell)=>cell.column));
    return /*#__PURE__*/ $ltGt3.createElement(RowComponent, $cb1f4380451cfa15$var$_extends({}, rowProps, {
        className: classNames.row,
        style: styles.row
    }), cells.map((cell, cellIndex)=>{
        const { column: column, colStart: colStart, colEnd: colEnd, colSpan: colSpan } = cell;
        const fixedInfo = (0, $4e464164fad088e8$export$695db918331141f3)(colStart, colEnd, flattenColumns, stickyOffsets);
        const additionalProps = column?.onHeaderCell?.(column) || {};
        return /*#__PURE__*/ $ltGt3.createElement((0, $d1d596939e15211a$export$2e2bcd8739ae039), $cb1f4380451cfa15$var$_extends({}, cell, {
            scope: column.title ? colSpan > 1 ? 'colgroup' : 'col' : null,
            ellipsis: column.ellipsis,
            align: column.align,
            component: CellComponent,
            prefixCls: prefixCls,
            key: columnsKey[cellIndex]
        }, fixedInfo, {
            additionalProps: additionalProps,
            rowType: "header"
        }));
    }));
};
var $cb1f4380451cfa15$export$2e2bcd8739ae039 = $cb1f4380451cfa15$var$HeaderRow;


function $9762ccb0ad0ed302$var$parseHeaderRows(rootColumns, classNames, styles) {
    const rows = [];
    function fillRowCells(columns, colIndex, rowIndex = 0) {
        // Init rows
        rows[rowIndex] = rows[rowIndex] || [];
        let currentColIndex = colIndex;
        const colSpans = columns.filter(Boolean).map((column)=>{
            const cell = {
                key: column.key,
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(column.className, classNames.cell) || '',
                style: styles.cell,
                children: column.title,
                column: column,
                colStart: currentColIndex
            };
            let colSpan = 1;
            const subColumns = column.children;
            if (subColumns && subColumns.length > 0) {
                colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce((total, count)=>total + count, 0);
                cell.hasSubColumns = true;
            }
            if ('colSpan' in column) ({ colSpan: colSpan } = column);
            if ('rowSpan' in column) cell.rowSpan = column.rowSpan;
            cell.colSpan = colSpan;
            cell.colEnd = cell.colStart + colSpan - 1;
            rows[rowIndex].push(cell);
            currentColIndex += colSpan;
            return colSpan;
        });
        return colSpans;
    }
    // Generate `rows` cell data
    fillRowCells(rootColumns, 0);
    // Handle `rowSpan`
    const rowCount = rows.length;
    for(let rowIndex = 0; rowIndex < rowCount; rowIndex += 1)rows[rowIndex].forEach((cell)=>{
        if (!('rowSpan' in cell) && !cell.hasSubColumns) // eslint-disable-next-line no-param-reassign
        cell.rowSpan = rowCount - rowIndex;
    });
    return rows;
}
const $9762ccb0ad0ed302$var$Header = (props)=>{
    const { stickyOffsets: stickyOffsets, columns: columns, flattenColumns: flattenColumns, onHeaderRow: onHeaderRow } = props;
    const { prefixCls: prefixCls, getComponent: getComponent, classNames: classNames, styles: styles } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), [
        'prefixCls',
        'getComponent',
        'classNames',
        'styles'
    ]);
    const { header: headerCls = {} } = classNames || {};
    const { header: headerStyles = {} } = styles || {};
    const rows = $ltGt3.useMemo(()=>$9762ccb0ad0ed302$var$parseHeaderRows(columns, headerCls, headerStyles), [
        columns,
        headerCls,
        headerStyles
    ]);
    const WrapperComponent = getComponent([
        'header',
        'wrapper'
    ], 'thead');
    const trComponent = getComponent([
        'header',
        'row'
    ], 'tr');
    const thComponent = getComponent([
        'header',
        'cell'
    ], 'th');
    return /*#__PURE__*/ $ltGt3.createElement(WrapperComponent, {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-thead`, headerCls.wrapper),
        style: headerStyles.wrapper
    }, rows.map((row, rowIndex)=>{
        const rowNode = /*#__PURE__*/ $ltGt3.createElement((0, $cb1f4380451cfa15$export$2e2bcd8739ae039), {
            classNames: headerCls,
            styles: headerStyles,
            key: rowIndex,
            flattenColumns: flattenColumns,
            cells: row,
            stickyOffsets: stickyOffsets,
            rowComponent: trComponent,
            cellComponent: thComponent,
            onHeaderRow: onHeaderRow,
            index: rowIndex
        });
        return rowNode;
    }));
};
var $9762ccb0ad0ed302$export$2e2bcd8739ae039 = (0, $9b7ee26d9935a15f$export$e9e4cb9eb9e2b4c4)($9762ccb0ad0ed302$var$Header);





var $ltGt3 = parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
function $f109a5b962f17687$var$parseColWidth(totalWidth, width = '') {
    if (typeof width === 'number') return width;
    if (width.endsWith('%')) return totalWidth * parseFloat(width) / 100;
    return null;
}
function $f109a5b962f17687$export$2e2bcd8739ae039(flattenColumns, scrollWidth, clientWidth) {
    return $ltGt3.useMemo(()=>{
        // Fill width if needed
        if (scrollWidth && scrollWidth > 0) {
            let totalWidth = 0;
            let missWidthCount = 0;
            // collect not given width column
            flattenColumns.forEach((col)=>{
                const colWidth = $f109a5b962f17687$var$parseColWidth(scrollWidth, col.width);
                if (colWidth) totalWidth += colWidth;
                else missWidthCount += 1;
            });
            // Fill width
            const maxFitWidth = Math.max(scrollWidth, clientWidth);
            let restWidth = Math.max(maxFitWidth - totalWidth, missWidthCount);
            let restCount = missWidthCount;
            const avgWidth = restWidth / missWidthCount;
            let realTotal = 0;
            const filledColumns = flattenColumns.map((col)=>{
                const clone = {
                    ...col
                };
                const colWidth = $f109a5b962f17687$var$parseColWidth(scrollWidth, clone.width);
                if (colWidth) clone.width = colWidth;
                else {
                    const colAvgWidth = Math.floor(avgWidth);
                    clone.width = restCount === 1 ? restWidth : colAvgWidth;
                    restWidth -= colAvgWidth;
                    restCount -= 1;
                }
                realTotal += clone.width;
                return clone;
            });
            // If realTotal is less than clientWidth,
            // We need extend column width
            if (realTotal < maxFitWidth) {
                const scale = maxFitWidth / realTotal;
                restWidth = maxFitWidth;
                filledColumns.forEach((col, index)=>{
                    const colWidth = Math.floor(col.width * scale);
                    col.width = index === filledColumns.length - 1 ? restWidth : colWidth;
                    restWidth -= colWidth;
                });
            }
            return [
                filledColumns,
                Math.max(realTotal, maxFitWidth)
            ];
        }
        return [
            flattenColumns,
            scrollWidth
        ];
    }, [
        flattenColumns,
        scrollWidth,
        clientWidth
    ]);
}


function $d2518e2a43538dac$export$d87a97eba44e0f9c(children) {
    return (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children).filter((node)=>/*#__PURE__*/ $ltGt3.isValidElement(node)).map((node)=>{
        const { key: key, props: props } = node;
        const { children: nodeChildren, ...restProps } = props;
        const column = {
            key: key,
            ...restProps
        };
        if (nodeChildren) column.children = $d2518e2a43538dac$export$d87a97eba44e0f9c(nodeChildren);
        return column;
    });
}
function $d2518e2a43538dac$var$filterHiddenColumns(columns) {
    return columns.filter((column)=>column && typeof column === 'object' && !column.hidden).map((column)=>{
        const subColumns = column.children;
        if (subColumns && subColumns.length > 0) return {
            ...column,
            children: $d2518e2a43538dac$var$filterHiddenColumns(subColumns)
        };
        return column;
    });
}
function $d2518e2a43538dac$var$flatColumns(columns, parentKey = 'key') {
    return columns.filter((column)=>column && typeof column === 'object').reduce((list, column, index)=>{
        const { fixed: fixed } = column;
        const parsedFixed = fixed === true || fixed === 'left' ? 'start' : fixed === 'right' ? 'end' : fixed;
        const mergedKey = `${parentKey}-${index}`;
        const subColumns = column.children;
        if (subColumns && subColumns.length > 0) return [
            ...list,
            ...$d2518e2a43538dac$var$flatColumns(subColumns, mergedKey).map((subColum)=>({
                    ...subColum,
                    fixed: subColum.fixed ?? parsedFixed
                }))
        ];
        return [
            ...list,
            {
                key: mergedKey,
                ...column,
                fixed: parsedFixed
            }
        ];
    }, []);
}
/**
 * Parse `columns` & `children` into `columns`.
 */ function $d2518e2a43538dac$var$useColumns({ prefixCls: prefixCls, columns: columns, children: children, expandable: expandable, expandedKeys: expandedKeys, columnTitle: columnTitle, getRowKey: getRowKey, onTriggerExpand: onTriggerExpand, expandIcon: expandIcon, rowExpandable: rowExpandable, expandIconColumnIndex: expandIconColumnIndex, expandedRowOffset: expandedRowOffset = 0, direction: direction, expandRowByClick: expandRowByClick, columnWidth: columnWidth, fixed: fixed, scrollWidth: scrollWidth, clientWidth: clientWidth }, transformColumns) {
    const baseColumns = $ltGt3.useMemo(()=>{
        const newColumns = columns || $d2518e2a43538dac$export$d87a97eba44e0f9c(children) || [];
        return $d2518e2a43538dac$var$filterHiddenColumns(newColumns.slice());
    }, [
        columns,
        children
    ]);
    // ========================== Expand ==========================
    const withExpandColumns = $ltGt3.useMemo(()=>{
        if (expandable) {
            let cloneColumns = baseColumns.slice();
            // >>> Insert expand column if not exist
            if (!cloneColumns.includes((0, $4ba85974d660b691$export$e1053575ddfcb301))) {
                const expandColIndex = expandIconColumnIndex || 0;
                const insertIndex = expandColIndex === 0 && (fixed === 'right' || fixed === 'end') ? baseColumns.length : expandColIndex;
                if (insertIndex >= 0) cloneColumns.splice(insertIndex, 0, (0, $4ba85974d660b691$export$e1053575ddfcb301));
            }
            const expandColumnIndex = cloneColumns.indexOf((0, $4ba85974d660b691$export$e1053575ddfcb301));
            cloneColumns = cloneColumns.filter((column, index)=>column !== (0, $4ba85974d660b691$export$e1053575ddfcb301) || index === expandColumnIndex);
            // >>> Check if expand column need to fixed
            const prevColumn = baseColumns[expandColumnIndex];
            let fixedColumn;
            if (fixed) fixedColumn = fixed;
            else fixedColumn = prevColumn ? prevColumn.fixed : null;
            // >>> Create expandable column
            const expandColumn = {
                [(0, $dafd2d773d2769d9$export$f8dba99c0d5b6b87)]: {
                    className: `${prefixCls}-expand-icon-col`,
                    columnType: 'EXPAND_COLUMN'
                },
                title: columnTitle,
                fixed: fixedColumn,
                className: `${prefixCls}-row-expand-icon-cell`,
                width: columnWidth,
                render: (_, record, index)=>{
                    const rowKey = getRowKey(record, index);
                    const expanded = expandedKeys.has(rowKey);
                    const recordExpandable = rowExpandable ? rowExpandable(record) : true;
                    const icon = expandIcon({
                        prefixCls: prefixCls,
                        expanded: expanded,
                        expandable: recordExpandable,
                        record: record,
                        onExpand: onTriggerExpand
                    });
                    if (expandRowByClick) return /*#__PURE__*/ $ltGt3.createElement("span", {
                        onClick: (e)=>e.stopPropagation()
                    }, icon);
                    return icon;
                }
            };
            return cloneColumns.map((col, index)=>{
                const column = col === (0, $4ba85974d660b691$export$e1053575ddfcb301) ? expandColumn : col;
                if (index < expandedRowOffset) return {
                    ...column,
                    fixed: column.fixed || 'start'
                };
                return column;
            });
        }
        return baseColumns.filter((col)=>col !== (0, $4ba85974d660b691$export$e1053575ddfcb301));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expandable,
        baseColumns,
        getRowKey,
        expandedKeys,
        expandIcon,
        direction,
        expandedRowOffset
    ]);
    // ========================= Transform ========================
    const mergedColumns = $ltGt3.useMemo(()=>{
        let finalColumns = withExpandColumns;
        if (transformColumns) finalColumns = transformColumns(finalColumns);
        // Always provides at least one column for table display
        if (!finalColumns.length) finalColumns = [
            {
                render: ()=>null
            }
        ];
        return finalColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        transformColumns,
        withExpandColumns,
        direction
    ]);
    // ========================== Flatten =========================
    const flattenColumns = $ltGt3.useMemo(()=>$d2518e2a43538dac$var$flatColumns(mergedColumns), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        mergedColumns,
        direction,
        scrollWidth
    ]);
    // ========================= FillWidth ========================
    const [filledColumns, realScrollWidth] = (0, $f109a5b962f17687$export$2e2bcd8739ae039)(flattenColumns, scrollWidth, clientWidth);
    return [
        mergedColumns,
        filledColumns,
        realScrollWidth
    ];
}
var $d2518e2a43538dac$export$2e2bcd8739ae039 = $d2518e2a43538dac$var$useColumns;




var $ltGt3 = parcelRequire("ltGt3");



function $e7fa6a3fbdce2fbe$export$2e2bcd8739ae039(props, mergedData, getRowKey) {
    const expandableConfig = (0, $dafd2d773d2769d9$export$e215b9806eacdfb5)(props);
    const { expandIcon: expandIcon, expandedRowKeys: expandedRowKeys, defaultExpandedRowKeys: defaultExpandedRowKeys, defaultExpandAllRows: defaultExpandAllRows, expandedRowRender: expandedRowRender, onExpand: onExpand, onExpandedRowsChange: onExpandedRowsChange, childrenColumnName: childrenColumnName } = expandableConfig;
    const mergedExpandIcon = expandIcon || (0, $e770fa404d4c4535$export$ae14373a7f810e33);
    const mergedChildrenColumnName = childrenColumnName || 'children';
    const expandableType = $ltGt3.useMemo(()=>{
        if (expandedRowRender) return 'row';
        /* eslint-disable no-underscore-dangle */ /**
     * Fix https://github.com/ant-design/ant-design/issues/21154
     * This is a workaround to not to break current behavior.
     * We can remove follow code after final release.
     *
     * To other developer:
     *  Do not use `__PARENT_RENDER_ICON__` in prod since we will remove this when refactor
     */ if (props.expandable && props.internalHooks === (0, $4ba85974d660b691$export$91b75cf262680225) && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some((record)=>record && typeof record === 'object' && record[mergedChildrenColumnName])) return 'nest';
        /* eslint-enable */ return false;
    }, [
        !!expandedRowRender,
        mergedData
    ]);
    const [innerExpandedKeys, setInnerExpandedKeys] = $ltGt3.useState(()=>{
        if (defaultExpandedRowKeys) return defaultExpandedRowKeys;
        if (defaultExpandAllRows) return (0, $e770fa404d4c4535$export$49bec56f6055f375)(mergedData, getRowKey, mergedChildrenColumnName);
        return [];
    });
    const mergedExpandedKeys = $ltGt3.useMemo(()=>new Set(expandedRowKeys || innerExpandedKeys || []), [
        expandedRowKeys,
        innerExpandedKeys
    ]);
    const onTriggerExpand = $ltGt3.useCallback((record)=>{
        const key = getRowKey(record, mergedData.indexOf(record));
        let newExpandedKeys;
        const hasKey = mergedExpandedKeys.has(key);
        if (hasKey) {
            mergedExpandedKeys.delete(key);
            newExpandedKeys = [
                ...mergedExpandedKeys
            ];
        } else newExpandedKeys = [
            ...mergedExpandedKeys,
            key
        ];
        setInnerExpandedKeys(newExpandedKeys);
        if (onExpand) onExpand(!hasKey, record);
        if (onExpandedRowsChange) onExpandedRowsChange(newExpandedKeys);
    }, [
        getRowKey,
        mergedExpandedKeys,
        mergedData,
        onExpand,
        onExpandedRowsChange
    ]);
    return [
        expandableConfig,
        expandableType,
        mergedExpandedKeys,
        mergedExpandIcon,
        mergedChildrenColumnName,
        onTriggerExpand
    ];
}






var $ltGt3 = parcelRequire("ltGt3");
function $40980b5fc8ed6d04$export$2e2bcd8739ae039(flattenColumns, stickyOffsets) {
    const fixedInfoList = $ltGt3.useMemo(()=>flattenColumns.map((_, colIndex)=>(0, $4e464164fad088e8$export$695db918331141f3)(colIndex, colIndex, flattenColumns, stickyOffsets)), [
        flattenColumns,
        stickyOffsets
    ]);
    return (0, $dcca1fcd5fa22f3b$export$2e2bcd8739ae039)(()=>fixedInfoList, [
        fixedInfoList
    ], (prev, next)=>!(0, $003c57daacb79f0c$export$2e2bcd8739ae039)(prev, next));
}



var $ltGt3 = parcelRequire("ltGt3");
function $67ed6d4aa497594b$export$510e4dd13e0b67dd(defaultState) {
    const stateRef = (0, $ltGt3.useRef)(defaultState);
    const [, forceUpdate] = (0, $ltGt3.useState)({});
    const lastPromiseRef = (0, $ltGt3.useRef)(null);
    const updateBatchRef = (0, $ltGt3.useRef)([]);
    function setFrameState(updater) {
        updateBatchRef.current.push(updater);
        const promise = Promise.resolve();
        lastPromiseRef.current = promise;
        promise.then(()=>{
            if (lastPromiseRef.current === promise) {
                const prevBatch = updateBatchRef.current;
                const prevState = stateRef.current;
                updateBatchRef.current = [];
                prevBatch.forEach((batchUpdater)=>{
                    stateRef.current = batchUpdater(stateRef.current);
                });
                lastPromiseRef.current = null;
                if (prevState !== stateRef.current) forceUpdate({});
            }
        });
    }
    (0, $ltGt3.useEffect)(()=>()=>{
            lastPromiseRef.current = null;
        }, []);
    return [
        stateRef.current,
        setFrameState
    ];
}
function $67ed6d4aa497594b$export$d63c72d5e6d02249(defaultState) {
    const frameRef = (0, $ltGt3.useRef)(defaultState || null);
    const timeoutRef = (0, $ltGt3.useRef)(null);
    function cleanUp() {
        clearTimeout(timeoutRef.current);
    }
    function setState(newState) {
        frameRef.current = newState;
        cleanUp();
        timeoutRef.current = setTimeout(()=>{
            frameRef.current = null;
            timeoutRef.current = undefined;
        }, 100);
    }
    function getState() {
        return frameRef.current;
    }
    (0, $ltGt3.useEffect)(()=>cleanUp, []);
    return [
        setState,
        getState
    ];
}



var $ltGt3 = parcelRequire("ltGt3");
function $b2909765d3681f07$export$2e2bcd8739ae039() {
    const [startRow, setStartRow] = $ltGt3.useState(-1);
    const [endRow, setEndRow] = $ltGt3.useState(-1);
    const onHover = $ltGt3.useCallback((start, end)=>{
        setStartRow(start);
        setEndRow(end);
    }, []);
    return [
        startRow,
        endRow,
        onHover
    ];
}



var $ltGt3 = parcelRequire("ltGt3");

// fix ssr render
const $edd7aafd6667cd96$var$defaultContainer = (0, $19612225313d4e36$export$2e2bcd8739ae039)() ? window : null;
function $edd7aafd6667cd96$export$2e2bcd8739ae039(sticky, prefixCls) {
    const { offsetHeader: offsetHeader = 0, offsetSummary: offsetSummary = 0, offsetScroll: offsetScroll = 0, getContainer: getContainer = ()=>$edd7aafd6667cd96$var$defaultContainer } = typeof sticky === 'object' ? sticky : {};
    const container = getContainer() || $edd7aafd6667cd96$var$defaultContainer;
    const isSticky = !!sticky;
    return $ltGt3.useMemo(()=>{
        return {
            isSticky: isSticky,
            stickyClassName: isSticky ? `${prefixCls}-sticky-holder` : '',
            offsetHeader: offsetHeader,
            offsetSummary: offsetSummary,
            offsetScroll: offsetScroll,
            container: container
        };
    }, [
        isSticky,
        offsetScroll,
        offsetHeader,
        offsetSummary,
        prefixCls,
        container
    ]);
}



var $ltGt3 = parcelRequire("ltGt3");
/**
 * Get sticky column offset width
 */ function $adcb216b61e01dea$var$useStickyOffsets(colWidths, flattenColumns) {
    const stickyOffsets = (0, $ltGt3.useMemo)(()=>{
        const columnCount = flattenColumns.length;
        const getOffsets = (startIndex, endIndex, offset)=>{
            const offsets = [];
            let total = 0;
            for(let i = startIndex; i !== endIndex; i += offset){
                offsets.push(total);
                if (flattenColumns[i].fixed) total += colWidths[i] || 0;
            }
            return offsets;
        };
        const startOffsets = getOffsets(0, columnCount, 1);
        const endOffsets = getOffsets(columnCount - 1, -1, -1).reverse();
        return {
            start: startOffsets,
            end: endOffsets,
            widths: colWidths
        };
    }, [
        colWidths,
        flattenColumns
    ]);
    return stickyOffsets;
}
var $adcb216b61e01dea$export$2e2bcd8739ae039 = $adcb216b61e01dea$var$useStickyOffsets;



var $ltGt3 = parcelRequire("ltGt3");
const $3e72ed1a2a80ae4e$var$Panel = (props)=>{
    const { children: children, className: className, style: style } = props;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: className,
        style: style
    }, children);
};
var $3e72ed1a2a80ae4e$export$2e2bcd8739ae039 = $3e72ed1a2a80ae4e$var$Panel;






var $ltGt3 = parcelRequire("ltGt3");




function $c03778a0e20003af$export$622cea445a1c5b7d(node) {
    const element = (0, $8e3ff42e4a468fd4$export$9aa546fdc20ae5b3)(node);
    const box = element.getBoundingClientRect();
    const docElem = document.documentElement;
    // < ie8 not support win.pageXOffset, use docElem.scrollLeft instead
    return {
        left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
        top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
    };
}



const $b9dd5e29458d10b8$var$MOUSEUP_EVENT = 'mouseup';
const $b9dd5e29458d10b8$var$MOUSEMOVE_EVENT = 'mousemove';
const $b9dd5e29458d10b8$var$SCROLL_EVENT = 'scroll';
const $b9dd5e29458d10b8$var$RESIZE_EVENT = 'resize';
const $b9dd5e29458d10b8$var$StickyScrollBar = (props, ref)=>{
    const { scrollBodyRef: scrollBodyRef, onScroll: onScroll, offsetScroll: offsetScroll, container: container, direction: direction } = props;
    const prefixCls = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), 'prefixCls');
    const bodyScrollWidth = scrollBodyRef.current?.scrollWidth || 0;
    const bodyWidth = scrollBodyRef.current?.clientWidth || 0;
    const scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
    const scrollBarRef = $ltGt3.useRef(null);
    const [scrollState, setScrollState] = (0, $67ed6d4aa497594b$export$510e4dd13e0b67dd)({
        scrollLeft: 0,
        isHiddenScrollBar: true
    });
    const refState = $ltGt3.useRef({
        delta: 0,
        x: 0
    });
    const [isActive, setActive] = $ltGt3.useState(false);
    const rafRef = $ltGt3.useRef(null);
    $ltGt3.useEffect(()=>()=>{
            (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(rafRef.current);
        }, []);
    const onMouseUp = ()=>{
        setActive(false);
    };
    const onMouseDown = (event)=>{
        event.persist();
        refState.current.delta = event.pageX - scrollState.scrollLeft;
        refState.current.x = 0;
        setActive(true);
        event.preventDefault();
    };
    const onMouseMove = (event)=>{
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
        const { buttons: buttons } = event || window?.event;
        if (!isActive || buttons === 0) {
            // If out body mouse up, we can set isActive false when mouse move
            if (isActive) setActive(false);
            return;
        }
        let left = refState.current.x + event.pageX - refState.current.x - refState.current.delta;
        const isRTL = direction === 'rtl';
        // Limit scroll range
        left = Math.max(isRTL ? scrollBarWidth - bodyWidth : 0, Math.min(isRTL ? 0 : bodyWidth - scrollBarWidth, left));
        // Calculate the scroll position and update
        const shouldScroll = !isRTL || Math.abs(left) + Math.abs(scrollBarWidth) < bodyWidth;
        if (shouldScroll) {
            onScroll({
                scrollLeft: left / bodyWidth * (bodyScrollWidth + 2)
            });
            refState.current.x = event.pageX;
        }
    };
    const checkScrollBarVisible = ()=>{
        (0, $04c6b38c8eff394e$export$2e2bcd8739ae039).cancel(rafRef.current);
        rafRef.current = (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(()=>{
            if (!scrollBodyRef.current) return;
            const tableOffsetTop = (0, $c03778a0e20003af$export$622cea445a1c5b7d)(scrollBodyRef.current).top;
            const tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
            const currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : (0, $c03778a0e20003af$export$622cea445a1c5b7d)(container).top + container.clientHeight;
            if (tableBottomOffset - (0, $3b9e061be790b547$export$2e2bcd8739ae039)() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) setScrollState((state)=>({
                    ...state,
                    isHiddenScrollBar: true
                }));
            else setScrollState((state)=>({
                    ...state,
                    isHiddenScrollBar: false
                }));
        });
    };
    const setScrollLeft = (left)=>{
        setScrollState((state)=>{
            return {
                ...state,
                scrollLeft: left / bodyScrollWidth * bodyWidth || 0
            };
        });
    };
    $ltGt3.useImperativeHandle(ref, ()=>({
            setScrollLeft: setScrollLeft,
            checkScrollBarVisible: checkScrollBarVisible
        }));
    $ltGt3.useEffect(()=>{
        document.body.addEventListener($b9dd5e29458d10b8$var$MOUSEUP_EVENT, onMouseUp, false);
        document.body.addEventListener($b9dd5e29458d10b8$var$MOUSEMOVE_EVENT, onMouseMove, false);
        checkScrollBarVisible();
        return ()=>{
            document.body.removeEventListener($b9dd5e29458d10b8$var$MOUSEUP_EVENT, onMouseUp);
            document.body.removeEventListener($b9dd5e29458d10b8$var$MOUSEMOVE_EVENT, onMouseMove);
        };
    }, [
        scrollBarWidth,
        isActive
    ]);
    // Loop for scroll event check
    $ltGt3.useEffect(()=>{
        if (scrollBodyRef.current) {
            const scrollParents = [];
            let parent = (0, $8e3ff42e4a468fd4$export$9aa546fdc20ae5b3)(scrollBodyRef.current);
            while(parent){
                scrollParents.push(parent);
                parent = parent.parentElement;
            }
            scrollParents.forEach((p)=>{
                p.addEventListener($b9dd5e29458d10b8$var$SCROLL_EVENT, checkScrollBarVisible, false);
            });
            window.addEventListener($b9dd5e29458d10b8$var$RESIZE_EVENT, checkScrollBarVisible, false);
            window.addEventListener($b9dd5e29458d10b8$var$SCROLL_EVENT, checkScrollBarVisible, false);
            container.addEventListener($b9dd5e29458d10b8$var$SCROLL_EVENT, checkScrollBarVisible, false);
            return ()=>{
                scrollParents.forEach((p)=>{
                    p.removeEventListener($b9dd5e29458d10b8$var$SCROLL_EVENT, checkScrollBarVisible);
                });
                window.removeEventListener($b9dd5e29458d10b8$var$RESIZE_EVENT, checkScrollBarVisible);
                window.removeEventListener($b9dd5e29458d10b8$var$SCROLL_EVENT, checkScrollBarVisible);
                container.removeEventListener($b9dd5e29458d10b8$var$SCROLL_EVENT, checkScrollBarVisible);
            };
        }
    }, [
        container
    ]);
    $ltGt3.useEffect(()=>{
        if (!scrollState.isHiddenScrollBar) setScrollState((state)=>{
            const bodyNode = scrollBodyRef.current;
            if (!bodyNode) return state;
            return {
                ...state,
                scrollLeft: bodyNode.scrollLeft / bodyNode.scrollWidth * bodyNode.clientWidth
            };
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scrollState.isHiddenScrollBar
    ]);
    if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) return null;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        style: {
            height: (0, $3b9e061be790b547$export$2e2bcd8739ae039)(),
            width: bodyWidth,
            bottom: offsetScroll
        },
        className: `${prefixCls}-sticky-scroll`
    }, /*#__PURE__*/ $ltGt3.createElement("div", {
        onMouseDown: onMouseDown,
        ref: scrollBarRef,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-sticky-scroll-bar`, {
            [`${prefixCls}-sticky-scroll-bar-active`]: isActive
        }),
        style: {
            width: `${scrollBarWidth}px`,
            transform: `translate3d(${scrollState.scrollLeft}px, 0, 0)`
        }
    }));
};
var $b9dd5e29458d10b8$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.forwardRef($b9dd5e29458d10b8$var$StickyScrollBar);








function $7049eb65ab1ff2d8$var$_extends() {
    $7049eb65ab1ff2d8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7049eb65ab1ff2d8$var$_extends.apply(this, arguments);
}
const $7049eb65ab1ff2d8$export$c42ed95a478b1ec5 = 'rc-table';
// Used for conditions cache
const $7049eb65ab1ff2d8$var$EMPTY_DATA = [];
// Used for customize scroll
const $7049eb65ab1ff2d8$var$EMPTY_SCROLL_TARGET = {};
function $7049eb65ab1ff2d8$var$defaultEmpty() {
    return 'No Data';
}
const $7049eb65ab1ff2d8$var$Table = (tableProps, ref)=>{
    const props = {
        rowKey: 'key',
        prefixCls: $7049eb65ab1ff2d8$export$c42ed95a478b1ec5,
        emptyText: $7049eb65ab1ff2d8$var$defaultEmpty,
        ...tableProps
    };
    const { prefixCls: prefixCls, className: className, rowClassName: rowClassName, style: style, classNames: classNames, styles: styles, data: data, rowKey: rowKey, scroll: scroll, tableLayout: tableLayout, direction: direction, title: // Additional Part
    title, footer: footer, summary: summary, caption: caption, id: // Customize
    id, showHeader: showHeader, components: components, emptyText: emptyText, onRow: onRow, onHeaderRow: onHeaderRow, measureRowRender: // Measure Row
    measureRowRender, onScroll: // Events
    onScroll, internalHooks: // Internal
    internalHooks, transformColumns: transformColumns, internalRefs: internalRefs, tailor: tailor, getContainerWidth: getContainerWidth, sticky: sticky, rowHoverable: rowHoverable = true } = props;
    const mergedData = data || $7049eb65ab1ff2d8$var$EMPTY_DATA;
    const hasData = !!mergedData.length;
    const useInternalHooks = internalHooks === (0, $4ba85974d660b691$export$91b75cf262680225);
    var name;
    // ==================== Customize =====================
    const getComponent = $ltGt3.useCallback((path, defaultComponent)=>(0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(components, path) || defaultComponent, [
        components
    ]);
    const getRowKey = $ltGt3.useMemo(()=>{
        if (typeof rowKey === 'function') return rowKey;
        return (record)=>{
            const key = record && record[rowKey];
            return key;
        };
    }, [
        rowKey
    ]);
    const customizeScrollBody = getComponent([
        'body'
    ]);
    // ====================== Hover =======================
    const [startRow, endRow, onHover] = (0, $b2909765d3681f07$export$2e2bcd8739ae039)();
    // ====================== Expand ======================
    const [expandableConfig, expandableType, mergedExpandedKeys, mergedExpandIcon, mergedChildrenColumnName, onTriggerExpand] = (0, $e7fa6a3fbdce2fbe$export$2e2bcd8739ae039)(props, mergedData, getRowKey);
    // ====================== Column ======================
    const scrollX = scroll?.x;
    const [componentWidth, setComponentWidth] = $ltGt3.useState(0);
    const [columns, flattenColumns, flattenScrollX] = (0, $d2518e2a43538dac$export$2e2bcd8739ae039)({
        ...props,
        ...expandableConfig,
        expandable: !!expandableConfig.expandedRowRender,
        columnTitle: expandableConfig.columnTitle,
        expandedKeys: mergedExpandedKeys,
        getRowKey: getRowKey,
        onTriggerExpand: // https://github.com/ant-design/ant-design/issues/23894
        onTriggerExpand,
        expandIcon: mergedExpandIcon,
        expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
        direction: direction,
        scrollWidth: useInternalHooks && tailor && typeof scrollX === 'number' ? scrollX : null,
        clientWidth: componentWidth
    }, useInternalHooks ? transformColumns : null);
    const mergedScrollX = flattenScrollX ?? scrollX;
    const columnContext = $ltGt3.useMemo(()=>({
            columns: columns,
            flattenColumns: flattenColumns
        }), [
        columns,
        flattenColumns
    ]);
    // ======================= Refs =======================
    const fullTableRef = $ltGt3.useRef(null);
    const scrollHeaderRef = $ltGt3.useRef(null);
    const scrollBodyRef = $ltGt3.useRef(null);
    const scrollBodyContainerRef = $ltGt3.useRef(null);
    $ltGt3.useImperativeHandle(ref, ()=>{
        return {
            nativeElement: fullTableRef.current,
            scrollTo: (config)=>{
                if (scrollBodyRef.current instanceof HTMLElement) {
                    // Native scroll
                    const { index: index, top: top, key: key, offset: offset } = config;
                    if ((0, $5e76e853ff0fad9c$export$b1cd2bdabe361feb)(top)) // In top mode, offset is ignored
                    scrollBodyRef.current?.scrollTo({
                        top: top
                    });
                    else {
                        const mergedKey = key ?? getRowKey(mergedData[index]);
                        const targetElement = scrollBodyRef.current.querySelector(`[data-row-key="${mergedKey}"]`);
                        if (targetElement) {
                            if (!offset) // No offset, use scrollIntoView for default behavior
                            targetElement.scrollIntoView();
                            else {
                                // With offset, use element's offsetTop + offset
                                const elementTop = targetElement.offsetTop;
                                scrollBodyRef.current.scrollTo({
                                    top: elementTop + offset
                                });
                            }
                        }
                    }
                } else if (scrollBodyRef.current?.scrollTo) // Pass to proxy
                scrollBodyRef.current.scrollTo(config);
            }
        };
    });
    // ====================== Scroll ======================
    const scrollSummaryRef = $ltGt3.useRef(null);
    const [shadowStart, setShadowStart] = $ltGt3.useState(false);
    const [shadowEnd, setShadowEnd] = $ltGt3.useState(false);
    const [colsWidths, updateColsWidths] = $ltGt3.useState(new Map());
    // Convert map to number width
    const colsKeys = (0, $5e76e853ff0fad9c$export$fd2ca5407d9be470)(flattenColumns);
    const pureColWidths = colsKeys.map((columnKey)=>colsWidths.get(columnKey));
    const colWidths = $ltGt3.useMemo(()=>pureColWidths, [
        pureColWidths.join('_')
    ]);
    const stickyOffsets = (0, $adcb216b61e01dea$export$2e2bcd8739ae039)(colWidths, flattenColumns);
    const fixHeader = scroll && (0, $5e76e853ff0fad9c$export$b76e9316566cc26e)(scroll.y);
    const horizonScroll = scroll && (0, $5e76e853ff0fad9c$export$b76e9316566cc26e)(mergedScrollX) || Boolean(expandableConfig.fixed);
    const fixColumn = horizonScroll && flattenColumns.some(({ fixed: fixed })=>fixed);
    // Sticky
    const stickyRef = $ltGt3.useRef(null);
    const { isSticky: isSticky, offsetHeader: offsetHeader, offsetSummary: offsetSummary, offsetScroll: offsetScroll, stickyClassName: stickyClassName, container: container } = (0, $edd7aafd6667cd96$export$2e2bcd8739ae039)(sticky, prefixCls);
    // Footer (Fix footer must fixed header)
    const summaryNode = $ltGt3.useMemo(()=>summary?.(mergedData), [
        summary,
        mergedData
    ]);
    const fixFooter = (fixHeader || isSticky) && /*#__PURE__*/ $ltGt3.isValidElement(summaryNode) && summaryNode.type === (0, $914dc1290b03be67$export$2e2bcd8739ae039) && summaryNode.props.fixed;
    // Scroll
    let scrollXStyle;
    let scrollYStyle;
    let scrollTableStyle;
    if (fixHeader) scrollYStyle = {
        overflowY: hasData ? 'scroll' : 'auto',
        maxHeight: scroll.y
    };
    if (horizonScroll) {
        scrollXStyle = {
            overflowX: 'auto'
        };
        // When no vertical scrollbar, should hide it
        // https://github.com/ant-design/ant-design/pull/20705
        // https://github.com/ant-design/ant-design/issues/21879
        if (!fixHeader) scrollYStyle = {
            overflowY: 'hidden'
        };
        scrollTableStyle = {
            width: mergedScrollX === true ? 'auto' : mergedScrollX,
            minWidth: '100%'
        };
    }
    const onColumnResize = $ltGt3.useCallback((columnKey, width)=>{
        updateColsWidths((widths)=>{
            if (widths.get(columnKey) !== width) {
                const newWidths = new Map(widths);
                newWidths.set(columnKey, width);
                return newWidths;
            }
            return widths;
        });
    }, []);
    const [setScrollTarget, getScrollTarget] = (0, $67ed6d4aa497594b$export$d63c72d5e6d02249)(null);
    function forceScroll(scrollLeft, target) {
        if (!target) return;
        if (typeof target === 'function') target(scrollLeft);
        else if (target.scrollLeft !== scrollLeft) {
            target.scrollLeft = scrollLeft;
            // Delay to force scroll position if not sync
            // ref: https://github.com/ant-design/ant-design/issues/37179
            if (target.scrollLeft !== scrollLeft) setTimeout(()=>{
                target.scrollLeft = scrollLeft;
            }, 0);
        }
    }
    const [scrollInfo, setScrollInfo] = $ltGt3.useState([
        0,
        0
    ]);
    const onInternalScroll = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(({ currentTarget: currentTarget, scrollLeft: scrollLeft })=>{
        const mergedScrollLeft = typeof scrollLeft === 'number' ? scrollLeft : currentTarget.scrollLeft;
        const compareTarget = currentTarget || $7049eb65ab1ff2d8$var$EMPTY_SCROLL_TARGET;
        if (!getScrollTarget() || getScrollTarget() === compareTarget) {
            setScrollTarget(compareTarget);
            forceScroll(mergedScrollLeft, scrollHeaderRef.current);
            forceScroll(mergedScrollLeft, scrollBodyRef.current);
            forceScroll(mergedScrollLeft, scrollSummaryRef.current);
            forceScroll(mergedScrollLeft, stickyRef.current?.setScrollLeft);
        }
        const measureTarget = currentTarget || scrollHeaderRef.current;
        if (measureTarget) {
            const scrollWidth = // Should use mergedScrollX in virtual table(useInternalHooks && tailor === true)
            useInternalHooks && tailor && typeof mergedScrollX === 'number' ? mergedScrollX : measureTarget.scrollWidth;
            const clientWidth = measureTarget.clientWidth;
            const absScrollStart = Math.abs(mergedScrollLeft);
            setScrollInfo((ori)=>{
                const nextScrollInfo = [
                    absScrollStart,
                    scrollWidth - clientWidth
                ];
                return (0, $003c57daacb79f0c$export$2e2bcd8739ae039)(ori, nextScrollInfo) ? ori : nextScrollInfo;
            });
            // There is no space to scroll
            if (scrollWidth === clientWidth) {
                setShadowStart(false);
                setShadowEnd(false);
                return;
            }
            setShadowStart(absScrollStart > 0);
            setShadowEnd(absScrollStart < scrollWidth - clientWidth - 1);
        }
    });
    const onBodyScroll = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((e)=>{
        onInternalScroll(e);
        onScroll?.(e);
    });
    const triggerOnScroll = ()=>{
        if (horizonScroll && scrollBodyRef.current) onInternalScroll({
            currentTarget: (0, $8e3ff42e4a468fd4$export$9aa546fdc20ae5b3)(scrollBodyRef.current),
            scrollLeft: scrollBodyRef.current?.scrollLeft
        });
        else {
            setShadowStart(false);
            setShadowEnd(false);
        }
    };
    const onFullTableResize = (offsetWidth)=>{
        stickyRef.current?.checkScrollBarVisible();
        let mergedWidth = offsetWidth ?? fullTableRef.current?.offsetWidth ?? 0;
        if (useInternalHooks && getContainerWidth && fullTableRef.current) mergedWidth = getContainerWidth(fullTableRef.current, mergedWidth) || mergedWidth;
        if (mergedWidth !== componentWidth) {
            triggerOnScroll();
            setComponentWidth(mergedWidth);
        }
    };
    // fix https://github.com/ant-design/ant-design/issues/49279
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (horizonScroll) onFullTableResize();
    }, [
        horizonScroll
    ]);
    // Sync scroll bar when init or `horizonScroll`, `data` and `columns.length` changed
    const mounted = $ltGt3.useRef(false);
    $ltGt3.useEffect(()=>{
        // onFullTableResize will be trigger once when ResizeObserver is mounted
        // This will reduce one duplicated triggerOnScroll time
        if (mounted.current) triggerOnScroll();
    }, [
        horizonScroll,
        data,
        columns.length
    ]);
    $ltGt3.useEffect(()=>{
        mounted.current = true;
    }, []);
    // ===================== Effects ======================
    const [scrollbarSize, setScrollbarSize] = $ltGt3.useState(0);
    (0, $b51fc3415a3f1104$export$2e2bcd8739ae039)(()=>{
        if (!tailor || !useInternalHooks) {
            if (scrollBodyRef.current instanceof Element) setScrollbarSize((0, $3b9e061be790b547$export$4f3ef2310365b56a)(scrollBodyRef.current).width);
            else setScrollbarSize((0, $3b9e061be790b547$export$4f3ef2310365b56a)(scrollBodyContainerRef.current).width);
        }
    }, []);
    // ================== INTERNAL HOOKS ==================
    $ltGt3.useEffect(()=>{
        if (useInternalHooks && internalRefs) internalRefs.body.current = scrollBodyRef.current;
    });
    // ========================================================================
    // ==                               Render                               ==
    // ========================================================================
    // =================== Render: Func ===================
    const renderFixedHeaderTable = $ltGt3.useCallback((fixedHolderPassProps)=>/*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement((0, $9762ccb0ad0ed302$export$2e2bcd8739ae039), fixedHolderPassProps), fixFooter === 'top' && /*#__PURE__*/ $ltGt3.createElement((0, $9267102c2ff8aee5$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode)), [
        fixFooter,
        summaryNode
    ]);
    const renderFixedFooterTable = $ltGt3.useCallback((fixedHolderPassProps)=>/*#__PURE__*/ $ltGt3.createElement((0, $9267102c2ff8aee5$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode), [
        summaryNode
    ]);
    // =================== Render: Node ===================
    const TableComponent = getComponent([
        'table'
    ], 'table');
    // Table layout
    const mergedTableLayout = $ltGt3.useMemo(()=>{
        if (tableLayout) return tableLayout;
        // https://github.com/ant-design/ant-design/issues/25227
        // When scroll.x is max-content, no need to fix table layout
        // it's width should stretch out to fit content
        if (fixColumn) return mergedScrollX === 'max-content' ? 'auto' : 'fixed';
        if (fixHeader || isSticky || flattenColumns.some(({ ellipsis: ellipsis })=>ellipsis)) return 'fixed';
        return 'auto';
    }, [
        fixHeader,
        fixColumn,
        flattenColumns,
        tableLayout,
        isSticky
    ]);
    let groupTableNode;
    // Header props
    const headerProps = {
        colWidths: colWidths,
        columCount: flattenColumns.length,
        stickyOffsets: stickyOffsets,
        onHeaderRow: onHeaderRow,
        fixHeader: fixHeader,
        scroll: scroll
    };
    // Empty
    const emptyNode = $ltGt3.useMemo(()=>{
        if (hasData) return null;
        if (typeof emptyText === 'function') return emptyText();
        return emptyText;
    }, [
        hasData,
        emptyText
    ]);
    // Body
    const bodyTable = /*#__PURE__*/ $ltGt3.createElement((0, $6b1a2f391084e986$export$2e2bcd8739ae039), {
        data: mergedData,
        measureColumnWidth: fixHeader || horizonScroll || isSticky
    });
    const bodyColGroup = /*#__PURE__*/ $ltGt3.createElement((0, $19d48080cb1866a7$export$2e2bcd8739ae039), {
        colWidths: flattenColumns.map(({ width: width })=>width),
        columns: flattenColumns
    });
    const captionElement = caption !== null && caption !== undefined ? /*#__PURE__*/ $ltGt3.createElement("caption", {
        className: `${prefixCls}-caption`
    }, caption) : undefined;
    const dataProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(props, {
        data: true
    });
    const ariaProps = (0, $297f85de79f8d325$export$2e2bcd8739ae039)(props, {
        aria: true
    });
    if (fixHeader || isSticky) {
        // >>>>>> Fixed Header
        let bodyContent;
        if (typeof customizeScrollBody === 'function') {
            bodyContent = customizeScrollBody(mergedData, {
                scrollbarSize: scrollbarSize,
                ref: scrollBodyRef,
                onScroll: onInternalScroll
            });
            headerProps.colWidths = flattenColumns.map(({ width: width }, index)=>{
                const colWidth = index === flattenColumns.length - 1 ? width - scrollbarSize : width;
                if (typeof colWidth === 'number' && !Number.isNaN(colWidth)) return colWidth;
                return 0;
            });
        } else bodyContent = /*#__PURE__*/ $ltGt3.createElement("div", {
            style: {
                ...scrollXStyle,
                ...scrollYStyle
            },
            onScroll: onBodyScroll,
            ref: scrollBodyRef,
            className: `${prefixCls}-body`
        }, /*#__PURE__*/ $ltGt3.createElement(TableComponent, $7049eb65ab1ff2d8$var$_extends({
            style: {
                ...scrollTableStyle,
                tableLayout: mergedTableLayout
            }
        }, ariaProps), captionElement, bodyColGroup, bodyTable, !fixFooter && summaryNode && /*#__PURE__*/ $ltGt3.createElement((0, $9267102c2ff8aee5$export$2e2bcd8739ae039), {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns
        }, summaryNode)));
        // Fixed holder share the props
        const fixedHolderProps = {
            noData: !mergedData.length,
            maxContentScroll: horizonScroll && mergedScrollX === 'max-content',
            ...headerProps,
            ...columnContext,
            direction: direction,
            stickyClassName: stickyClassName,
            scrollX: mergedScrollX,
            tableLayout: mergedTableLayout,
            onScroll: onInternalScroll
        };
        groupTableNode = /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, showHeader !== false && /*#__PURE__*/ $ltGt3.createElement((0, $fc9312ec697f5ea2$export$2e2bcd8739ae039), $7049eb65ab1ff2d8$var$_extends({}, fixedHolderProps, {
            stickyTopOffset: offsetHeader,
            className: `${prefixCls}-header`,
            ref: scrollHeaderRef,
            colGroup: bodyColGroup
        }), renderFixedHeaderTable), bodyContent, fixFooter && fixFooter !== 'top' && /*#__PURE__*/ $ltGt3.createElement((0, $fc9312ec697f5ea2$export$2e2bcd8739ae039), $7049eb65ab1ff2d8$var$_extends({}, fixedHolderProps, {
            stickyBottomOffset: offsetSummary,
            className: `${prefixCls}-summary`,
            ref: scrollSummaryRef,
            colGroup: bodyColGroup
        }), renderFixedFooterTable), isSticky && scrollBodyRef.current && scrollBodyRef.current instanceof Element && /*#__PURE__*/ $ltGt3.createElement((0, $b9dd5e29458d10b8$export$2e2bcd8739ae039), {
            ref: stickyRef,
            offsetScroll: offsetScroll,
            scrollBodyRef: scrollBodyRef,
            onScroll: onInternalScroll,
            container: container,
            direction: direction
        }));
    } else // >>>>>> Unique table
    groupTableNode = /*#__PURE__*/ $ltGt3.createElement("div", {
        style: {
            ...scrollXStyle,
            ...scrollYStyle,
            ...styles?.content
        },
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-content`, classNames?.content),
        onScroll: onInternalScroll,
        ref: scrollBodyRef
    }, /*#__PURE__*/ $ltGt3.createElement(TableComponent, $7049eb65ab1ff2d8$var$_extends({
        style: {
            ...scrollTableStyle,
            tableLayout: mergedTableLayout
        }
    }, ariaProps), captionElement, bodyColGroup, showHeader !== false && /*#__PURE__*/ $ltGt3.createElement((0, $9762ccb0ad0ed302$export$2e2bcd8739ae039), $7049eb65ab1ff2d8$var$_extends({}, headerProps, columnContext)), bodyTable, summaryNode && /*#__PURE__*/ $ltGt3.createElement((0, $9267102c2ff8aee5$export$2e2bcd8739ae039), {
        stickyOffsets: stickyOffsets,
        flattenColumns: flattenColumns
    }, summaryNode)));
    const tableStyle = {
        ...style
    };
    // Add css var for sticky header `zIndex` calc
    if (isSticky) tableStyle['--columns-count'] = flattenColumns.length;
    let fullTable = /*#__PURE__*/ $ltGt3.createElement("div", $7049eb65ab1ff2d8$var$_extends({
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, className, {
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-fix-start-shadow`]: horizonScroll,
            [`${prefixCls}-fix-end-shadow`]: horizonScroll,
            [`${prefixCls}-fix-start-shadow-show`]: horizonScroll && shadowStart,
            [`${prefixCls}-fix-end-shadow-show`]: horizonScroll && shadowEnd,
            [`${prefixCls}-layout-fixed`]: tableLayout === 'fixed',
            [`${prefixCls}-fixed-header`]: fixHeader,
            /** No used but for compatible */ [`${prefixCls}-fixed-column`]: fixColumn,
            [`${prefixCls}-scroll-horizontal`]: horizonScroll,
            [`${prefixCls}-has-fix-start`]: flattenColumns[0]?.fixed,
            [`${prefixCls}-has-fix-end`]: flattenColumns[flattenColumns.length - 1]?.fixed === 'end'
        }),
        style: tableStyle,
        id: id,
        ref: fullTableRef
    }, dataProps), title && /*#__PURE__*/ $ltGt3.createElement((0, $3e72ed1a2a80ae4e$export$2e2bcd8739ae039), {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-title`, classNames?.title),
        style: styles?.title
    }, title(mergedData)), /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: scrollBodyContainerRef,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-container`, classNames?.section),
        style: styles?.section
    }, groupTableNode), footer && /*#__PURE__*/ $ltGt3.createElement((0, $3e72ed1a2a80ae4e$export$2e2bcd8739ae039), {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, classNames?.footer),
        style: styles?.footer
    }, footer(mergedData)));
    if (horizonScroll) fullTable = /*#__PURE__*/ $ltGt3.createElement((0, $9ed13185b45d829d$export$2e2bcd8739ae039), {
        onResize: ({ offsetWidth: offsetWidth })=>onFullTableResize(offsetWidth)
    }, fullTable);
    const fixedInfoList = (0, $40980b5fc8ed6d04$export$2e2bcd8739ae039)(flattenColumns, stickyOffsets);
    const TableContextValue = $ltGt3.useMemo(()=>({
            // Scroll
            scrollX: mergedScrollX,
            scrollInfo: scrollInfo,
            classNames: classNames,
            styles: styles,
            prefixCls: // Table
            prefixCls,
            getComponent: getComponent,
            scrollbarSize: scrollbarSize,
            direction: direction,
            fixedInfoList: fixedInfoList,
            isSticky: isSticky,
            componentWidth: componentWidth,
            fixHeader: fixHeader,
            fixColumn: fixColumn,
            horizonScroll: horizonScroll,
            // Body
            tableLayout: mergedTableLayout,
            rowClassName: rowClassName,
            expandedRowClassName: expandableConfig.expandedRowClassName,
            expandIcon: mergedExpandIcon,
            expandableType: expandableType,
            expandRowByClick: expandableConfig.expandRowByClick,
            expandedRowRender: expandableConfig.expandedRowRender,
            expandedRowOffset: expandableConfig.expandedRowOffset,
            onTriggerExpand: onTriggerExpand,
            expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
            indentSize: expandableConfig.indentSize,
            allColumnsFixedLeft: flattenColumns.every((col)=>col.fixed === 'start'),
            emptyNode: emptyNode,
            columns: // Column
            columns,
            flattenColumns: flattenColumns,
            onColumnResize: onColumnResize,
            colWidths: colWidths,
            // Row
            hoverStartRow: startRow,
            hoverEndRow: endRow,
            onHover: onHover,
            rowExpandable: expandableConfig.rowExpandable,
            onRow: onRow,
            getRowKey: getRowKey,
            expandedKeys: mergedExpandedKeys,
            childrenColumnName: mergedChildrenColumnName,
            rowHoverable: rowHoverable,
            measureRowRender: // Measure Row
            measureRowRender
        }), [
        // Scroll
        mergedScrollX,
        scrollInfo,
        classNames,
        styles,
        // Table
        prefixCls,
        getComponent,
        scrollbarSize,
        direction,
        fixedInfoList,
        isSticky,
        componentWidth,
        fixHeader,
        fixColumn,
        horizonScroll,
        // Body
        mergedTableLayout,
        rowClassName,
        expandableConfig.expandedRowClassName,
        mergedExpandIcon,
        expandableType,
        expandableConfig.expandRowByClick,
        expandableConfig.expandedRowRender,
        expandableConfig.expandedRowOffset,
        onTriggerExpand,
        expandableConfig.expandIconColumnIndex,
        expandableConfig.indentSize,
        emptyNode,
        // Column
        columns,
        flattenColumns,
        onColumnResize,
        colWidths,
        // Row
        startRow,
        endRow,
        onHover,
        expandableConfig.rowExpandable,
        onRow,
        getRowKey,
        mergedExpandedKeys,
        mergedChildrenColumnName,
        rowHoverable,
        measureRowRender
    ]);
    return /*#__PURE__*/ $ltGt3.createElement((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039).Provider, {
        value: TableContextValue
    }, fullTable);
};
const $7049eb65ab1ff2d8$var$RefTable = /*#__PURE__*/ $ltGt3.forwardRef($7049eb65ab1ff2d8$var$Table);
const $7049eb65ab1ff2d8$export$13da147d1fdf3e3c = (shouldTriggerRender)=>{
    return (0, $9b7ee26d9935a15f$export$ffd6d5bef5eaf0a4)($7049eb65ab1ff2d8$var$RefTable, shouldTriggerRender);
};
const $7049eb65ab1ff2d8$var$ImmutableTable = $7049eb65ab1ff2d8$export$13da147d1fdf3e3c();
$7049eb65ab1ff2d8$var$ImmutableTable.EXPAND_COLUMN = (0, $4ba85974d660b691$export$e1053575ddfcb301);
$7049eb65ab1ff2d8$var$ImmutableTable.INTERNAL_HOOKS = (0, $4ba85974d660b691$export$91b75cf262680225);
$7049eb65ab1ff2d8$var$ImmutableTable.Column = (0, $9f2bf0fb1ad5c6d0$export$2e2bcd8739ae039);
$7049eb65ab1ff2d8$var$ImmutableTable.ColumnGroup = (0, $89c42773f9f37277$export$2e2bcd8739ae039);
$7049eb65ab1ff2d8$var$ImmutableTable.Summary = (0, $9267102c2ff8aee5$export$d605f3af09eef683);
var $7049eb65ab1ff2d8$export$2e2bcd8739ae039 = $7049eb65ab1ff2d8$var$ImmutableTable;






var $ltGt3 = parcelRequire("ltGt3");






var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");






var $ltGt3 = parcelRequire("ltGt3");



const $c5622889da69504b$export$fbb76fda59aa02a2 = (0, $f653da5403feaada$export$fd42f52fd3ae1109)(null);
const $c5622889da69504b$export$11cae3e04ab99fae = (0, $f653da5403feaada$export$fd42f52fd3ae1109)(null);


function $49ec530404eee0b1$var$_extends() {
    $49ec530404eee0b1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $49ec530404eee0b1$var$_extends.apply(this, arguments);
}
function $49ec530404eee0b1$export$dfa11a34ceba822(colIndex, colSpan, columnsOffset) {
    const mergedColSpan = colSpan || 1;
    return columnsOffset[colIndex + mergedColSpan] - (columnsOffset[colIndex] || 0);
}
const $49ec530404eee0b1$var$VirtualCell = (props)=>{
    const { rowInfo: rowInfo, column: column, colIndex: colIndex, indent: indent, index: index, component: component, renderIndex: renderIndex, record: record, style: style, className: className, inverse: inverse, getHeight: getHeight } = props;
    const { render: render, dataIndex: dataIndex, className: columnClassName, width: colWidth } = column;
    const { columnsOffset: columnsOffset } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $c5622889da69504b$export$11cae3e04ab99fae), [
        'columnsOffset'
    ]);
    // TODO: support `expandableRowOffset`
    const { key: key, fixedInfo: fixedInfo, appendCellNode: appendCellNode, additionalCellProps: additionalCellProps } = (0, $02955f9e72f1628f$export$16400ac709c56616)(rowInfo, column, colIndex, indent, index);
    const { style: cellStyle, colSpan: colSpan = 1, rowSpan: rowSpan = 1 } = additionalCellProps;
    // ========================= ColWidth =========================
    // column width
    const startColIndex = colIndex - 1;
    const concatColWidth = $49ec530404eee0b1$export$dfa11a34ceba822(startColIndex, colSpan, columnsOffset);
    // margin offset
    const marginOffset = colSpan > 1 ? colWidth - concatColWidth : 0;
    // ========================== Style ===========================
    const mergedStyle = {
        ...cellStyle,
        ...style,
        flex: `0 0 ${concatColWidth}px`,
        width: `${concatColWidth}px`,
        marginRight: marginOffset,
        pointerEvents: 'auto'
    };
    // When `colSpan` or `rowSpan` is `0`, should skip render.
    const needHide = $ltGt3.useMemo(()=>{
        if (inverse) return rowSpan <= 1;
        else return colSpan === 0 || rowSpan === 0 || rowSpan > 1;
    }, [
        rowSpan,
        colSpan,
        inverse
    ]);
    // 0 rowSpan or colSpan should not render
    if (needHide) mergedStyle.visibility = 'hidden';
    else if (inverse) mergedStyle.height = getHeight?.(rowSpan);
    const mergedRender = needHide ? ()=>null : render;
    // ========================== Render ==========================
    const cellSpan = {};
    // Virtual should reset `colSpan` & `rowSpan`
    if (rowSpan === 0 || colSpan === 0) {
        cellSpan.rowSpan = 1;
        cellSpan.colSpan = 1;
    }
    return /*#__PURE__*/ $ltGt3.createElement((0, $d1d596939e15211a$export$2e2bcd8739ae039), $49ec530404eee0b1$var$_extends({
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(columnClassName, className),
        ellipsis: column.ellipsis,
        align: column.align,
        scope: column.rowScope,
        component: component,
        prefixCls: rowInfo.prefixCls,
        key: key,
        record: record,
        index: index,
        renderIndex: renderIndex,
        dataIndex: dataIndex,
        render: mergedRender,
        shouldCellUpdate: column.shouldCellUpdate
    }, fixedInfo, {
        appendNode: appendCellNode,
        additionalProps: {
            ...additionalCellProps,
            style: mergedStyle,
            ...cellSpan
        }
    }));
};
var $49ec530404eee0b1$export$2e2bcd8739ae039 = $49ec530404eee0b1$var$VirtualCell;




function $b64f4517ab64d5eb$var$_extends() {
    $b64f4517ab64d5eb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b64f4517ab64d5eb$var$_extends.apply(this, arguments);
}
const $b64f4517ab64d5eb$var$BodyLine = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { data: data, index: index, className: className, rowKey: rowKey, style: style, extra: extra, getHeight: getHeight, ...restProps } = props;
    const { record: record, indent: indent, index: renderIndex } = data;
    const { scrollX: scrollX, flattenColumns: flattenColumns, prefixCls: prefixCls, fixColumn: fixColumn, componentWidth: componentWidth } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), [
        'prefixCls',
        'flattenColumns',
        'fixColumn',
        'componentWidth',
        'scrollX'
    ]);
    const { getComponent: getComponent } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $c5622889da69504b$export$fbb76fda59aa02a2), [
        'getComponent'
    ]);
    const rowInfo = (0, $9d56bedc6f834880$export$2e2bcd8739ae039)(record, rowKey, index, indent);
    const RowComponent = getComponent([
        'body',
        'row'
    ], 'div');
    const cellComponent = getComponent([
        'body',
        'cell'
    ], 'div');
    // ========================== Expand ==========================
    const { rowSupportExpand: rowSupportExpand, expanded: expanded, rowProps: rowProps, expandedRowRender: expandedRowRender, expandedRowClassName: expandedRowClassName } = rowInfo;
    let expandRowNode;
    if (rowSupportExpand && expanded) {
        const expandContent = expandedRowRender(record, index, indent + 1, expanded);
        const expandedClsName = (0, $e770fa404d4c4535$export$c5c465afb98f57b6)(expandedRowClassName, record, index, indent);
        let additionalProps = {};
        if (fixColumn) additionalProps = {
            style: {
                ['--virtual-width']: `${componentWidth}px`
            }
        };
        const rowCellCls = `${prefixCls}-expanded-row-cell`;
        expandRowNode = /*#__PURE__*/ $ltGt3.createElement(RowComponent, {
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-expanded-row`, `${prefixCls}-expanded-row-level-${indent + 1}`, expandedClsName)
        }, /*#__PURE__*/ $ltGt3.createElement((0, $d1d596939e15211a$export$2e2bcd8739ae039), {
            component: cellComponent,
            prefixCls: prefixCls,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(rowCellCls, {
                [`${rowCellCls}-fixed`]: fixColumn
            }),
            additionalProps: additionalProps
        }, expandContent));
    }
    // ========================== Render ==========================
    const rowStyle = {
        ...style,
        width: scrollX
    };
    if (extra) {
        rowStyle.position = 'absolute';
        rowStyle.pointerEvents = 'none';
    }
    const rowNode = /*#__PURE__*/ $ltGt3.createElement(RowComponent, $b64f4517ab64d5eb$var$_extends({}, rowProps, restProps, {
        "data-row-key": rowKey,
        ref: rowSupportExpand ? null : ref,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, `${prefixCls}-row`, rowProps?.className, {
            [`${prefixCls}-row-extra`]: extra
        }),
        style: {
            ...rowStyle,
            ...rowProps?.style
        }
    }), flattenColumns.map((column, colIndex)=>{
        return /*#__PURE__*/ $ltGt3.createElement((0, $49ec530404eee0b1$export$2e2bcd8739ae039), {
            key: colIndex,
            component: cellComponent,
            rowInfo: rowInfo,
            column: column,
            colIndex: colIndex,
            indent: indent,
            index: index,
            renderIndex: renderIndex,
            record: record,
            inverse: extra,
            getHeight: getHeight
        });
    }));
    if (rowSupportExpand) return /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: ref
    }, rowNode, expandRowNode);
    return rowNode;
});
const $b64f4517ab64d5eb$var$ResponseBodyLine = (0, $9b7ee26d9935a15f$export$e9e4cb9eb9e2b4c4)($b64f4517ab64d5eb$var$BodyLine);
var $b64f4517ab64d5eb$export$2e2bcd8739ae039 = $b64f4517ab64d5eb$var$ResponseBodyLine;



const $c2a9cdc7f605c557$var$Grid = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { data: data, onScroll: onScroll } = props;
    const { flattenColumns: flattenColumns, onColumnResize: onColumnResize, getRowKey: getRowKey, expandedKeys: expandedKeys, prefixCls: prefixCls, childrenColumnName: childrenColumnName, scrollX: scrollX, direction: direction } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $9b7ee26d9935a15f$export$2e2bcd8739ae039), [
        'flattenColumns',
        'onColumnResize',
        'getRowKey',
        'prefixCls',
        'expandedKeys',
        'childrenColumnName',
        'scrollX',
        'direction'
    ]);
    const { sticky: sticky, scrollY: scrollY, listItemHeight: listItemHeight, getComponent: getComponent, onScroll: onTablePropScroll } = (0, $f653da5403feaada$export$fae74005e78b1a27)((0, $c5622889da69504b$export$fbb76fda59aa02a2));
    // =========================== Ref ============================
    const listRef = $ltGt3.useRef(null);
    // =========================== Data ===========================
    const flattenData = (0, $239e00f5e77b43d1$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey);
    // ========================== Column ==========================
    const columnsWidth = $ltGt3.useMemo(()=>{
        let total = 0;
        return flattenColumns.map(({ width: width, minWidth: minWidth, key: key })=>{
            const finalWidth = Math.max(width || 0, minWidth || 0);
            total += finalWidth;
            return [
                key,
                finalWidth,
                total
            ];
        });
    }, [
        flattenColumns
    ]);
    const columnsOffset = $ltGt3.useMemo(()=>columnsWidth.map((colWidth)=>colWidth[2]), [
        columnsWidth
    ]);
    $ltGt3.useEffect(()=>{
        columnsWidth.forEach(([key, width])=>{
            onColumnResize(key, width);
        });
    }, [
        columnsWidth
    ]);
    // =========================== Ref ============================
    $ltGt3.useImperativeHandle(ref, ()=>{
        const obj = {
            scrollTo: (config)=>{
                const { offset: offset, ...restConfig } = config;
                // If offset is provided, force align to 'top' for consistent behavior
                if (offset) listRef.current?.scrollTo({
                    ...restConfig,
                    offset: offset,
                    align: 'top'
                });
                else listRef.current?.scrollTo(config);
            },
            nativeElement: listRef.current?.nativeElement
        };
        Object.defineProperty(obj, 'scrollLeft', {
            get: ()=>listRef.current?.getScrollInfo().x || 0,
            set: (value)=>{
                listRef.current?.scrollTo({
                    left: value
                });
            }
        });
        // https://github.com/ant-design/ant-design/issues/54734
        Object.defineProperty(obj, 'scrollTop', {
            get: ()=>listRef.current?.getScrollInfo().y || 0,
            set: (value)=>{
                listRef.current?.scrollTo({
                    top: value
                });
            }
        });
        return obj;
    });
    // ======================= Col/Row Span =======================
    const getRowSpan = (column, index)=>{
        const record = flattenData[index]?.record;
        const { onCell: onCell } = column;
        if (onCell) {
            const cellProps = onCell(record, index);
            return cellProps?.rowSpan ?? 1;
        }
        return 1;
    };
    const extraRender = (info)=>{
        const { start: start, end: end, getSize: getSize, offsetY: offsetY } = info;
        // Do nothing if no data
        if (end < 0) return null;
        // Find first rowSpan column
        let firstRowSpanColumns = flattenColumns.filter(// rowSpan is 0
        (column)=>getRowSpan(column, start) === 0);
        let startIndex = start;
        for(let i = start; i >= 0; i -= 1){
            firstRowSpanColumns = firstRowSpanColumns.filter((column)=>getRowSpan(column, i) === 0);
            if (!firstRowSpanColumns.length) {
                startIndex = i;
                break;
            }
        }
        // Find last rowSpan column
        let lastRowSpanColumns = flattenColumns.filter(// rowSpan is not 1
        (column)=>getRowSpan(column, end) !== 1);
        let endIndex = end;
        for(let i = end; i < flattenData.length; i += 1){
            lastRowSpanColumns = lastRowSpanColumns.filter((column)=>getRowSpan(column, i) !== 1);
            if (!lastRowSpanColumns.length) {
                endIndex = Math.max(i - 1, end);
                break;
            }
        }
        // Collect the line who has rowSpan
        const spanLines = [];
        for(let i = startIndex; i <= endIndex; i += 1){
            const item = flattenData[i];
            // This code will never reach, just incase
            if (!item) continue;
            if (flattenColumns.some((column)=>getRowSpan(column, i) > 1)) spanLines.push(i);
        }
        // Patch extra line on the page
        const nodes = spanLines.map((index)=>{
            const item = flattenData[index];
            const rowKey = getRowKey(item.record, index);
            const getHeight = (rowSpan)=>{
                const endItemIndex = index + rowSpan - 1;
                const endItemKey = getRowKey(flattenData[endItemIndex].record, endItemIndex);
                const sizeInfo = getSize(rowKey, endItemKey);
                return sizeInfo.bottom - sizeInfo.top;
            };
            const sizeInfo = getSize(rowKey);
            return /*#__PURE__*/ $ltGt3.createElement((0, $b64f4517ab64d5eb$export$2e2bcd8739ae039), {
                key: index,
                data: item,
                rowKey: rowKey,
                index: index,
                style: {
                    top: -offsetY + sizeInfo.top
                },
                extra: true,
                getHeight: getHeight
            });
        });
        return nodes;
    };
    // ========================= Context ==========================
    const gridContext = $ltGt3.useMemo(()=>({
            columnsOffset: columnsOffset
        }), [
        columnsOffset
    ]);
    // ========================== Render ==========================
    const tblPrefixCls = `${prefixCls}-tbody`;
    // default 'div' in rc-virtual-list
    const wrapperComponent = getComponent([
        'body',
        'wrapper'
    ]);
    // ========================== Sticky Scroll Bar ==========================
    const horizontalScrollBarStyle = {};
    if (sticky) {
        horizontalScrollBarStyle.position = 'sticky';
        horizontalScrollBarStyle.bottom = 0;
        if (typeof sticky === 'object' && sticky.offsetScroll) horizontalScrollBarStyle.bottom = sticky.offsetScroll;
    }
    return /*#__PURE__*/ $ltGt3.createElement((0, $c5622889da69504b$export$11cae3e04ab99fae).Provider, {
        value: gridContext
    }, /*#__PURE__*/ $ltGt3.createElement((0, $8ef74e3e8155f759$export$2e2bcd8739ae039), {
        fullHeight: false,
        ref: listRef,
        prefixCls: `${tblPrefixCls}-virtual`,
        styles: {
            horizontalScrollBar: horizontalScrollBarStyle
        },
        className: tblPrefixCls,
        height: scrollY,
        itemHeight: listItemHeight || 24,
        data: flattenData,
        itemKey: (item)=>getRowKey(item.record),
        component: wrapperComponent,
        scrollWidth: scrollX,
        direction: direction,
        onVirtualScroll: ({ x: x })=>{
            onScroll({
                currentTarget: listRef.current?.nativeElement,
                scrollLeft: x
            });
        },
        onScroll: onTablePropScroll,
        extraRender: extraRender
    }, (item, index, itemProps)=>{
        const rowKey = getRowKey(item.record, index);
        return /*#__PURE__*/ $ltGt3.createElement((0, $b64f4517ab64d5eb$export$2e2bcd8739ae039), {
            data: item,
            rowKey: rowKey,
            index: index,
            style: itemProps.style
        });
    }));
});
const $c2a9cdc7f605c557$var$ResponseGrid = (0, $9b7ee26d9935a15f$export$e9e4cb9eb9e2b4c4)($c2a9cdc7f605c557$var$Grid);
var $c2a9cdc7f605c557$export$2e2bcd8739ae039 = $c2a9cdc7f605c557$var$ResponseGrid;




function $fac77e864cd6e6a0$var$_extends() {
    $fac77e864cd6e6a0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fac77e864cd6e6a0$var$_extends.apply(this, arguments);
}
const $fac77e864cd6e6a0$var$renderBody = (rawData, props)=>{
    const { ref: ref, onScroll: onScroll } = props;
    return /*#__PURE__*/ $ltGt3.createElement((0, $c2a9cdc7f605c557$export$2e2bcd8739ae039), {
        ref: ref,
        data: rawData,
        onScroll: onScroll
    });
};
const $fac77e864cd6e6a0$var$VirtualTable = (props, ref)=>{
    const { data: data, columns: columns, scroll: scroll, sticky: sticky, prefixCls: prefixCls = (0, $7049eb65ab1ff2d8$export$c42ed95a478b1ec5), className: className, listItemHeight: listItemHeight, components: components, onScroll: onScroll } = props;
    let { x: scrollX, y: scrollY } = scroll || {};
    // Fill scrollX
    if (typeof scrollX !== 'number') scrollX = 1;
    // Fill scrollY
    if (typeof scrollY !== 'number') scrollY = 500;
    const getComponent = (0, $deca6326d2021bca$export$2e2bcd8739ae039)((path, defaultComponent)=>(0, $d5b82237eb4bdd3f$export$2e2bcd8739ae039)(components, path) || defaultComponent);
    // Memo this
    const onInternalScroll = (0, $deca6326d2021bca$export$2e2bcd8739ae039)(onScroll);
    // ========================= Context ==========================
    const context = $ltGt3.useMemo(()=>({
            sticky: sticky,
            scrollY: scrollY,
            listItemHeight: listItemHeight,
            getComponent: getComponent,
            onScroll: onInternalScroll
        }), [
        sticky,
        scrollY,
        listItemHeight,
        getComponent,
        onInternalScroll
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ $ltGt3.createElement((0, $c5622889da69504b$export$fbb76fda59aa02a2).Provider, {
        value: context
    }, /*#__PURE__*/ $ltGt3.createElement((0, $7049eb65ab1ff2d8$export$2e2bcd8739ae039), $fac77e864cd6e6a0$var$_extends({}, props, {
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(className, `${prefixCls}-virtual`),
        scroll: {
            ...scroll,
            x: scrollX
        },
        components: {
            ...components,
            // fix https://github.com/ant-design/ant-design/issues/48991
            body: data?.length ? $fac77e864cd6e6a0$var$renderBody : undefined
        },
        columns: columns,
        internalHooks: (0, $4ba85974d660b691$export$91b75cf262680225),
        tailor: true,
        ref: ref
    })));
};
const $fac77e864cd6e6a0$var$RefVirtualTable = /*#__PURE__*/ $ltGt3.forwardRef($fac77e864cd6e6a0$var$VirtualTable);
const $fac77e864cd6e6a0$export$4747b79b36862360 = (shouldTriggerRender)=>{
    return (0, $9b7ee26d9935a15f$export$ffd6d5bef5eaf0a4)($fac77e864cd6e6a0$var$RefVirtualTable, shouldTriggerRender);
};
var $fac77e864cd6e6a0$export$2e2bcd8739ae039 = $fac77e864cd6e6a0$export$4747b79b36862360();


var $25f413f1cccba335$export$2e2bcd8739ae039 = (0, $7049eb65ab1ff2d8$export$2e2bcd8739ae039);


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ const $96df4e82291bed2e$var$Column = (_)=>null;
var $96df4e82291bed2e$export$2e2bcd8739ae039 = $96df4e82291bed2e$var$Column;


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ const $66ec4bd99f8d6372$var$ColumnGroup = (_)=>null;
var $66ec4bd99f8d6372$export$2e2bcd8739ae039 = $66ec4bd99f8d6372$var$ColumnGroup;




var $ltGt3 = parcelRequire("ltGt3");








var $ltGt3 = parcelRequire("ltGt3");
const $75b4ece8510c5c83$export$3f339a531a4f3fb4 = (getKey)=>{
    const [prevSelectedIndex, setPrevSelectedIndex] = (0, $ltGt3.useState)(null);
    const multipleSelect = (0, $ltGt3.useCallback)((currentSelectedIndex, data, selectedKeys)=>{
        const configPrevSelectedIndex = prevSelectedIndex ?? currentSelectedIndex;
        // add/delete the selected range
        const startIndex = Math.min(configPrevSelectedIndex || 0, currentSelectedIndex);
        const endIndex = Math.max(configPrevSelectedIndex || 0, currentSelectedIndex);
        const rangeKeys = data.slice(startIndex, endIndex + 1).map(getKey);
        const shouldSelected = rangeKeys.some((rangeKey)=>!selectedKeys.has(rangeKey));
        const changedKeys = [];
        rangeKeys.forEach((item)=>{
            if (shouldSelected) {
                if (!selectedKeys.has(item)) changedKeys.push(item);
                selectedKeys.add(item);
            } else {
                selectedKeys.delete(item);
                changedKeys.push(item);
            }
        });
        setPrevSelectedIndex(shouldSelected ? endIndex : null);
        return changedKeys;
    }, [
        prevSelectedIndex
    ]);
    return [
        multipleSelect,
        setPrevSelectedIndex
    ];
};






"use client";
const $6123fa3b01478a1b$export$ed10248435b8f218 = {};
const $6123fa3b01478a1b$export$14159cd9e2a500c8 = 'SELECT_ALL';
const $6123fa3b01478a1b$export$625c4f68eaaf8cfd = 'SELECT_INVERT';
const $6123fa3b01478a1b$export$c1a725540f5a63bd = 'SELECT_NONE';
const $6123fa3b01478a1b$var$EMPTY_LIST = [];
const $6123fa3b01478a1b$var$flattenData = (childrenColumnName, data, list = [])=>{
    (data || []).forEach((record)=>{
        list.push(record);
        if (record && typeof record === 'object' && childrenColumnName in record) $6123fa3b01478a1b$var$flattenData(childrenColumnName, record[childrenColumnName], list);
    });
    return list;
};
const $6123fa3b01478a1b$var$useSelection = (config, rowSelection)=>{
    const { preserveSelectedRowKeys: preserveSelectedRowKeys, selectedRowKeys: selectedRowKeys, defaultSelectedRowKeys: defaultSelectedRowKeys, getCheckboxProps: getCheckboxProps, getTitleCheckboxProps: getTitleCheckboxProps, onChange: onSelectionChange, onSelect: onSelect, onSelectAll: onSelectAll, onSelectInvert: onSelectInvert, onSelectNone: onSelectNone, onSelectMultiple: onSelectMultiple, columnWidth: selectionColWidth, type: selectionType, selections: selections, fixed: fixed, renderCell: customizeRenderCell, hideSelectAll: hideSelectAll, checkStrictly: checkStrictly = true } = rowSelection || {};
    const { prefixCls: prefixCls, data: data, pageData: pageData, getRecordByKey: getRecordByKey, getRowKey: getRowKey, expandType: expandType, childrenColumnName: childrenColumnName, locale: tableLocale, getPopupContainer: getPopupContainer } = config;
    const warning = (0, $9530c27c700696d0$export$cf977aa92c751e61)('Table');
    // ========================= MultipleSelect =========================
    const [multipleSelect, updatePrevSelectedIndex] = (0, $75b4ece8510c5c83$export$3f339a531a4f3fb4)((item)=>item);
    // ========================= Keys =========================
    const [mergedSelectedKeys, setMergedSelectedKeys] = (0, $5d9e8c1fae772521$export$2e2bcd8739ae039)(defaultSelectedRowKeys || $6123fa3b01478a1b$var$EMPTY_LIST, selectedRowKeys);
    // ======================== Caches ========================
    const preserveRecordsRef = $ltGt3.useRef(new Map());
    const updatePreserveRecordsCache = (0, $ltGt3.useCallback)((keys)=>{
        if (preserveSelectedRowKeys) {
            const newCache = new Map();
            // Keep key if mark as preserveSelectedRowKeys
            keys.forEach((key)=>{
                let record = getRecordByKey(key);
                if (!record && preserveRecordsRef.current.has(key)) record = preserveRecordsRef.current.get(key);
                newCache.set(key, record);
            });
            // Refresh to new cache
            preserveRecordsRef.current = newCache;
        }
    }, [
        getRecordByKey,
        preserveSelectedRowKeys
    ]);
    // Update cache with selectedKeys
    $ltGt3.useEffect(()=>{
        updatePreserveRecordsCache(mergedSelectedKeys);
    }, [
        mergedSelectedKeys
    ]);
    // Get flatten data
    const flattedData = (0, $ltGt3.useMemo)(()=>$6123fa3b01478a1b$var$flattenData(childrenColumnName, pageData), [
        childrenColumnName,
        pageData
    ]);
    const { keyEntities: keyEntities } = (0, $ltGt3.useMemo)(()=>{
        if (checkStrictly) return {
            keyEntities: null
        };
        let convertData = data;
        if (preserveSelectedRowKeys) {
            // use flattedData keys
            const keysSet = new Set(flattedData.map((record, index)=>getRowKey(record, index)));
            // remove preserveRecords that duplicate data
            const preserveRecords = Array.from(preserveRecordsRef.current).reduce((total, [key, value])=>keysSet.has(key) ? total : total.concat(value), []);
            convertData = [].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(convertData), (0, $83d01b7684a01087$export$2e2bcd8739ae039)(preserveRecords));
        }
        return (0, $f32a159b6ed8d919$export$e5d831ce033a4615)(convertData, {
            externalGetKey: getRowKey,
            childrenPropName: childrenColumnName
        });
    }, [
        data,
        getRowKey,
        checkStrictly,
        childrenColumnName,
        preserveSelectedRowKeys,
        flattedData
    ]);
    // Get all checkbox props
    const checkboxPropsMap = (0, $ltGt3.useMemo)(()=>{
        const map = new Map();
        flattedData.forEach((record, index)=>{
            const key = getRowKey(record, index);
            const checkboxProps = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
            map.set(key, checkboxProps);
        });
        return map;
    }, [
        flattedData,
        getRowKey,
        getCheckboxProps
    ]);
    const isCheckboxDisabled = (0, $ltGt3.useCallback)((r)=>{
        const rowKey = getRowKey(r);
        let checkboxProps;
        if (checkboxPropsMap.has(rowKey)) checkboxProps = checkboxPropsMap.get(getRowKey(r));
        else checkboxProps = getCheckboxProps ? getCheckboxProps(r) : undefined;
        return !!checkboxProps?.disabled;
    }, [
        checkboxPropsMap,
        getRowKey
    ]);
    const [derivedSelectedKeys, derivedHalfSelectedKeys] = (0, $ltGt3.useMemo)(()=>{
        if (checkStrictly) return [
            mergedSelectedKeys || [],
            []
        ];
        const { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $57a33d03148eb2df$export$43adf2c483e3e633)(mergedSelectedKeys, true, keyEntities, isCheckboxDisabled);
        return [
            checkedKeys || [],
            halfCheckedKeys
        ];
    }, [
        mergedSelectedKeys,
        checkStrictly,
        keyEntities,
        isCheckboxDisabled
    ]);
    const derivedSelectedKeySet = (0, $ltGt3.useMemo)(()=>{
        const keys = selectionType === 'radio' ? derivedSelectedKeys.slice(0, 1) : derivedSelectedKeys;
        return new Set(keys);
    }, [
        derivedSelectedKeys,
        selectionType
    ]);
    const derivedHalfSelectedKeySet = (0, $ltGt3.useMemo)(()=>selectionType === 'radio' ? new Set() : new Set(derivedHalfSelectedKeys), [
        derivedHalfSelectedKeys,
        selectionType
    ]);
    // Reset if rowSelection reset
    $ltGt3.useEffect(()=>{
        if (!rowSelection) setMergedSelectedKeys($6123fa3b01478a1b$var$EMPTY_LIST);
    }, [
        !!rowSelection
    ]);
    const setSelectedKeys = (0, $ltGt3.useCallback)((keys, method)=>{
        let availableKeys;
        let records;
        updatePreserveRecordsCache(keys);
        if (preserveSelectedRowKeys) {
            availableKeys = keys;
            records = keys.map((key)=>preserveRecordsRef.current.get(key));
        } else {
            // Filter key which not exist in the `dataSource`
            availableKeys = [];
            records = [];
            keys.forEach((key)=>{
                const record = getRecordByKey(key);
                if (record !== undefined) {
                    availableKeys.push(key);
                    records.push(record);
                }
            });
        }
        setMergedSelectedKeys(availableKeys);
        onSelectionChange?.(availableKeys, records, {
            type: method
        });
    }, [
        setMergedSelectedKeys,
        getRecordByKey,
        onSelectionChange,
        preserveSelectedRowKeys
    ]);
    // ====================== Selections ======================
    // Trigger single `onSelect` event
    const triggerSingleSelection = (0, $ltGt3.useCallback)((key, selected, keys, event)=>{
        if (onSelect) {
            const rows = keys.map((k)=>getRecordByKey(k));
            onSelect(getRecordByKey(key), selected, rows, event);
        }
        setSelectedKeys(keys, 'single');
    }, [
        onSelect,
        getRecordByKey,
        setSelectedKeys
    ]);
    const mergedSelections = (0, $ltGt3.useMemo)(()=>{
        if (!selections || hideSelectAll) return null;
        const selectionList = selections === true ? [
            $6123fa3b01478a1b$export$14159cd9e2a500c8,
            $6123fa3b01478a1b$export$625c4f68eaaf8cfd,
            $6123fa3b01478a1b$export$c1a725540f5a63bd
        ] : selections;
        return selectionList.map((selection)=>{
            if (selection === $6123fa3b01478a1b$export$14159cd9e2a500c8) return {
                key: 'all',
                text: tableLocale.selectionAll,
                onSelect () {
                    setSelectedKeys(data.map((record, index)=>getRowKey(record, index)).filter((key)=>{
                        const checkProps = checkboxPropsMap.get(key);
                        return !checkProps?.disabled || derivedSelectedKeySet.has(key);
                    }), 'all');
                }
            };
            if (selection === $6123fa3b01478a1b$export$625c4f68eaaf8cfd) return {
                key: 'invert',
                text: tableLocale.selectInvert,
                onSelect () {
                    const keySet = new Set(derivedSelectedKeySet);
                    pageData.forEach((record, index)=>{
                        const key = getRowKey(record, index);
                        const checkProps = checkboxPropsMap.get(key);
                        if (!checkProps?.disabled) {
                            if (keySet.has(key)) keySet.delete(key);
                            else keySet.add(key);
                        }
                    });
                    const keys = Array.from(keySet);
                    if (onSelectInvert) {
                        warning.deprecated(false, 'onSelectInvert', 'onChange');
                        onSelectInvert(keys);
                    }
                    setSelectedKeys(keys, 'invert');
                }
            };
            if (selection === $6123fa3b01478a1b$export$c1a725540f5a63bd) return {
                key: 'none',
                text: tableLocale.selectNone,
                onSelect () {
                    onSelectNone?.();
                    setSelectedKeys(Array.from(derivedSelectedKeySet).filter((key)=>{
                        const checkProps = checkboxPropsMap.get(key);
                        return checkProps?.disabled;
                    }), 'none');
                }
            };
            return selection;
        }).map((selection)=>({
                ...selection,
                onSelect: (...rest)=>{
                    selection.onSelect?.(...rest);
                    updatePrevSelectedIndex(null);
                }
            }));
    }, [
        selections,
        hideSelectAll,
        tableLocale.selectionAll,
        tableLocale.selectInvert,
        tableLocale.selectNone,
        checkboxPropsMap,
        derivedSelectedKeySet,
        data,
        pageData,
        getRowKey,
        onSelectInvert,
        setSelectedKeys
    ]);
    // ======================= Columns ========================
    const transformColumns = (0, $ltGt3.useCallback)((columns)=>{
        // >>>>>>>>>>> Skip if not exists `rowSelection`
        if (!rowSelection) return columns.filter((col)=>col !== $6123fa3b01478a1b$export$ed10248435b8f218);
        // >>>>>>>>>>> Support selection
        let cloneColumns = (0, $83d01b7684a01087$export$2e2bcd8739ae039)(columns);
        const keySet = new Set(derivedSelectedKeySet);
        // Record key only need check with enabled
        const recordKeys = flattedData.map(getRowKey).filter((key)=>!checkboxPropsMap.get(key).disabled);
        const checkedCurrentAll = recordKeys.every((key)=>keySet.has(key));
        const checkedCurrentSome = recordKeys.some((key)=>keySet.has(key));
        const onSelectAllChange = ()=>{
            const changeKeys = [];
            if (checkedCurrentAll) recordKeys.forEach((key)=>{
                keySet.delete(key);
                changeKeys.push(key);
            });
            else recordKeys.forEach((key)=>{
                if (!keySet.has(key)) {
                    keySet.add(key);
                    changeKeys.push(key);
                }
            });
            const keys = Array.from(keySet);
            onSelectAll?.(!checkedCurrentAll, keys.map((k)=>getRecordByKey(k)), changeKeys.map((k)=>getRecordByKey(k)));
            setSelectedKeys(keys, 'all');
            updatePrevSelectedIndex(null);
        };
        // ===================== Render =====================
        // Title Cell
        let title;
        let columnTitleCheckbox;
        if (selectionType !== 'radio') {
            let customizeSelections;
            if (mergedSelections) {
                const menu = {
                    getPopupContainer: getPopupContainer,
                    items: mergedSelections.map((selection, index)=>{
                        const { key: key, text: text, onSelect: onSelectionClick } = selection;
                        return {
                            key: key ?? index,
                            onClick: ()=>{
                                onSelectionClick?.(recordKeys);
                            },
                            label: text
                        };
                    })
                };
                customizeSelections = /*#__PURE__*/ $ltGt3.createElement("div", {
                    className: `${prefixCls}-selection-extra`
                }, /*#__PURE__*/ $ltGt3.createElement((0, $fdbae0f0e90936fe$export$2e2bcd8739ae039), {
                    menu: menu,
                    getPopupContainer: getPopupContainer
                }, /*#__PURE__*/ $ltGt3.createElement("span", null, /*#__PURE__*/ $ltGt3.createElement((0, $a3f64d9a77de028d$export$2e2bcd8739ae039), null))));
            }
            const allDisabledData = flattedData.map((record, index)=>{
                const key = getRowKey(record, index);
                const checkboxProps = checkboxPropsMap.get(key) || {};
                return {
                    checked: keySet.has(key),
                    ...checkboxProps
                };
            }).filter(({ disabled: disabled })=>disabled);
            const allDisabled = !!allDisabledData.length && allDisabledData.length === flattedData.length;
            const allDisabledAndChecked = allDisabled && allDisabledData.every(({ checked: checked })=>checked);
            const allDisabledSomeChecked = allDisabled && allDisabledData.some(({ checked: checked })=>checked);
            const customCheckboxProps = getTitleCheckboxProps?.() || {};
            const { onChange: onChange, disabled: disabled } = customCheckboxProps;
            columnTitleCheckbox = /*#__PURE__*/ $ltGt3.createElement((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                "aria-label": customizeSelections ? 'Custom selection' : 'Select all',
                ...customCheckboxProps,
                checked: !allDisabled ? !!flattedData.length && checkedCurrentAll : allDisabledAndChecked,
                indeterminate: !allDisabled ? !checkedCurrentAll && checkedCurrentSome : !allDisabledAndChecked && allDisabledSomeChecked,
                onChange: (e)=>{
                    onSelectAllChange();
                    onChange?.(e);
                },
                disabled: disabled ?? (flattedData.length === 0 || allDisabled),
                skipGroup: true
            });
            title = !hideSelectAll && /*#__PURE__*/ $ltGt3.createElement("div", {
                className: `${prefixCls}-selection`
            }, columnTitleCheckbox, customizeSelections);
        }
        // Body Cell
        let renderCell;
        if (selectionType === 'radio') renderCell = (_, record, index)=>{
            const key = getRowKey(record, index);
            const checked = keySet.has(key);
            const checkboxProps = checkboxPropsMap.get(key);
            return {
                node: /*#__PURE__*/ $ltGt3.createElement((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039), {
                    ...checkboxProps,
                    checked: checked,
                    onClick: (e)=>{
                        e.stopPropagation();
                        checkboxProps?.onClick?.(e);
                    },
                    onChange: (event)=>{
                        if (!keySet.has(key)) triggerSingleSelection(key, true, [
                            key
                        ], event.nativeEvent);
                        checkboxProps?.onChange?.(event);
                    }
                }),
                checked: checked
            };
        };
        else renderCell = (_, record, index)=>{
            const key = getRowKey(record, index);
            const checked = keySet.has(key);
            const indeterminate = derivedHalfSelectedKeySet.has(key);
            const checkboxProps = checkboxPropsMap.get(key);
            let mergedIndeterminate;
            if (expandType === 'nest') mergedIndeterminate = indeterminate;
            else mergedIndeterminate = checkboxProps?.indeterminate ?? indeterminate;
            // Record checked
            return {
                node: /*#__PURE__*/ $ltGt3.createElement((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                    ...checkboxProps,
                    indeterminate: mergedIndeterminate,
                    checked: checked,
                    skipGroup: true,
                    onClick: (e)=>{
                        e.stopPropagation();
                        checkboxProps?.onClick?.(e);
                    },
                    onChange: (event)=>{
                        const { nativeEvent: nativeEvent } = event;
                        const { shiftKey: shiftKey } = nativeEvent;
                        const currentSelectedIndex = recordKeys.indexOf(key);
                        const isMultiple = derivedSelectedKeys.some((item)=>recordKeys.includes(item));
                        if (shiftKey && checkStrictly && isMultiple) {
                            const changedKeys = multipleSelect(currentSelectedIndex, recordKeys, keySet);
                            const keys = Array.from(keySet);
                            onSelectMultiple?.(!checked, keys.map((recordKey)=>getRecordByKey(recordKey)), changedKeys.map((recordKey)=>getRecordByKey(recordKey)));
                            setSelectedKeys(keys, 'multiple');
                        } else {
                            // Single record selected
                            const originCheckedKeys = derivedSelectedKeys;
                            if (checkStrictly) {
                                const checkedKeys = checked ? (0, $e9e424090bbd8d70$export$5bfb9ff497fe2298)(originCheckedKeys, key) : (0, $e9e424090bbd8d70$export$10663f6bbd2fd717)(originCheckedKeys, key);
                                triggerSingleSelection(key, !checked, checkedKeys, nativeEvent);
                            } else {
                                // Always fill first
                                const result = (0, $57a33d03148eb2df$export$43adf2c483e3e633)([].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(originCheckedKeys), [
                                    key
                                ]), true, keyEntities, isCheckboxDisabled);
                                const { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = result;
                                let nextCheckedKeys = checkedKeys;
                                // If remove, we do it again to correction
                                if (checked) {
                                    const tempKeySet = new Set(checkedKeys);
                                    tempKeySet.delete(key);
                                    nextCheckedKeys = (0, $57a33d03148eb2df$export$43adf2c483e3e633)(Array.from(tempKeySet), {
                                        checked: false,
                                        halfCheckedKeys: halfCheckedKeys
                                    }, keyEntities, isCheckboxDisabled).checkedKeys;
                                }
                                triggerSingleSelection(key, !checked, nextCheckedKeys, nativeEvent);
                            }
                        }
                        if (checked) updatePrevSelectedIndex(null);
                        else updatePrevSelectedIndex(currentSelectedIndex);
                        checkboxProps?.onChange?.(event);
                    }
                }),
                checked: checked
            };
        };
        const renderSelectionCell = (_, record, index)=>{
            const { node: node, checked: checked } = renderCell(_, record, index);
            if (customizeRenderCell) return customizeRenderCell(checked, record, index, node);
            return node;
        };
        // Insert selection column if not exist
        if (!cloneColumns.includes($6123fa3b01478a1b$export$ed10248435b8f218)) {
            // Always after expand icon
            if (cloneColumns.findIndex((col)=>col[0, $dafd2d773d2769d9$export$f8dba99c0d5b6b87]?.columnType === 'EXPAND_COLUMN') === 0) {
                const [expandColumn, ...restColumns] = cloneColumns;
                cloneColumns = [
                    expandColumn,
                    $6123fa3b01478a1b$export$ed10248435b8f218
                ].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(restColumns));
            } else // Normal insert at first column
            cloneColumns = [
                $6123fa3b01478a1b$export$ed10248435b8f218
            ].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(cloneColumns));
        }
        // Deduplicate selection column
        const selectionColumnIndex = cloneColumns.indexOf($6123fa3b01478a1b$export$ed10248435b8f218);
        cloneColumns = cloneColumns.filter((column, index)=>column !== $6123fa3b01478a1b$export$ed10248435b8f218 || index === selectionColumnIndex);
        // Fixed column logic
        const prevCol = cloneColumns[selectionColumnIndex - 1];
        const nextCol = cloneColumns[selectionColumnIndex + 1];
        let mergedFixed = fixed;
        if (mergedFixed === undefined) {
            if (nextCol?.fixed !== undefined) mergedFixed = nextCol.fixed;
            else if (prevCol?.fixed !== undefined) mergedFixed = prevCol.fixed;
        }
        if (mergedFixed && prevCol && prevCol[0, $dafd2d773d2769d9$export$f8dba99c0d5b6b87]?.columnType === 'EXPAND_COLUMN' && prevCol.fixed === undefined) prevCol.fixed = mergedFixed;
        const columnCls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-selection-col`, {
            [`${prefixCls}-selection-col-with-dropdown`]: selections && selectionType === 'checkbox'
        });
        const renderColumnTitle = ()=>{
            if (!rowSelection?.columnTitle) return title;
            if (typeof rowSelection.columnTitle === 'function') return rowSelection.columnTitle(columnTitleCheckbox);
            return rowSelection.columnTitle;
        };
        // Replace with real selection column
        const selectionColumn = {
            fixed: mergedFixed,
            width: selectionColWidth,
            className: `${prefixCls}-selection-column`,
            title: renderColumnTitle(),
            render: renderSelectionCell,
            onCell: rowSelection.onCell,
            align: rowSelection.align,
            [(0, $dafd2d773d2769d9$export$f8dba99c0d5b6b87)]: {
                className: columnCls
            }
        };
        return cloneColumns.map((col)=>col === $6123fa3b01478a1b$export$ed10248435b8f218 ? selectionColumn : col);
    }, [
        getRowKey,
        flattedData,
        rowSelection,
        derivedSelectedKeys,
        derivedSelectedKeySet,
        derivedHalfSelectedKeySet,
        selectionColWidth,
        mergedSelections,
        expandType,
        checkboxPropsMap,
        onSelectMultiple,
        triggerSingleSelection,
        isCheckboxDisabled
    ]);
    return [
        transformColumns,
        derivedSelectedKeySet
    ];
};
var $6123fa3b01478a1b$export$2e2bcd8739ae039 = $6123fa3b01478a1b$var$useSelection;



var $ltGt3 = parcelRequire("ltGt3");




// Proxy the dom ref with `{ nativeElement, otherFn }` type
// ref: https://github.com/ant-design/ant-design/discussions/45242

var $ltGt3 = parcelRequire("ltGt3");
const $419ec1eb7c226115$var$fillProxy = (element, handler)=>{
    element._antProxy = element._antProxy || {};
    Object.keys(handler).forEach((key)=>{
        if (!(key in element._antProxy)) {
            const ori = element[key];
            element._antProxy[key] = ori;
            element[key] = handler[key];
        }
    });
    return element;
};
const $419ec1eb7c226115$export$8edbe0145ad77a36 = (ref, init)=>{
    return (0, $ltGt3.useImperativeHandle)(ref, ()=>{
        const refObj = init();
        const { nativeElement: nativeElement } = refObj;
        if (typeof Proxy !== 'undefined') return new Proxy(nativeElement, {
            get (obj, prop) {
                if (refObj[prop]) return refObj[prop];
                return Reflect.get(obj, prop);
            }
        });
        // Fallback of IE
        return $419ec1eb7c226115$var$fillProxy(nativeElement, refObj);
    });
};



function $c6dd26da1be56821$export$24656b269d8df7d6(t, b, c, d) {
    const cc = c - b;
    t /= d / 2;
    if (t < 1) return cc / 2 * t * t * t + b;
    // biome-ignore lint: it is a common easing function
    return cc / 2 * ((t -= 2) * t * t + 2) + b;
}



function $a4d7fb1564185ff9$export$5a096129d439f843(obj) {
    return (0, $2e40f05689cf6d67$export$2e2bcd8739ae039)(obj) && obj === obj.window;
}
const $a4d7fb1564185ff9$var$getScroll = (target)=>{
    if (typeof window === 'undefined') /* istanbul ignore next */ return 0;
    let result = 0;
    if ($a4d7fb1564185ff9$export$5a096129d439f843(target)) result = target.pageYOffset;
    else if (target instanceof Document) result = target.documentElement.scrollTop;
    else if (target instanceof HTMLElement) result = target.scrollTop;
    else if (target) // According to the type inference, the `target` is `never` type.
    // Since we configured the loose mode type checking, and supports mocking the target with such shape below::
    //    `{ documentElement: { scrollLeft: 200, scrollTop: 400 } }`,
    //    the program may falls into this branch.
    // Check the corresponding tests for details. Don't sure what is the real scenario this happens.
    /* biome-ignore lint/complexity/useLiteralKeys: target is a never type */ /* eslint-disable-next-line dot-notation */ result = target['scrollTop'];
    if (target && !$a4d7fb1564185ff9$export$5a096129d439f843(target) && typeof result !== 'number') result = (target.ownerDocument ?? target).documentElement?.scrollTop;
    return result;
};
var $a4d7fb1564185ff9$export$2e2bcd8739ae039 = $a4d7fb1564185ff9$var$getScroll;


function $85a964b764a2b7f9$export$2e2bcd8739ae039(y, options = {}) {
    const { getContainer: getContainer = ()=>window, callback: callback, duration: duration = 450 } = options;
    const container = getContainer();
    const scrollTop = (0, $a4d7fb1564185ff9$export$2e2bcd8739ae039)(container);
    const startTime = Date.now();
    const frameFunc = ()=>{
        const timestamp = Date.now();
        const time = timestamp - startTime;
        const nextScrollTop = (0, $c6dd26da1be56821$export$24656b269d8df7d6)(time > duration ? duration : time, scrollTop, y, duration);
        if ((0, $a4d7fb1564185ff9$export$5a096129d439f843)(container)) container.scrollTo(window.pageXOffset, nextScrollTop);
        else if (container instanceof Document || container.constructor.name === 'HTMLDocument') container.documentElement.scrollTop = nextScrollTop;
        else container.scrollTop = nextScrollTop;
        if (time < duration) (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(frameFunc);
        else if (typeof callback === 'function') callback();
    };
    (0, $04c6b38c8eff394e$export$2e2bcd8739ae039)(frameFunc);
}















var $ltGt3 = parcelRequire("ltGt3");

"use client";
function $d828521527a4e705$var$renderExpandIcon(locale) {
    return (props)=>{
        const { prefixCls: prefixCls, onExpand: onExpand, record: record, expanded: expanded, expandable: expandable } = props;
        const iconPrefix = `${prefixCls}-row-expand-icon`;
        return /*#__PURE__*/ $ltGt3.createElement("button", {
            type: "button",
            onClick: (e)=>{
                onExpand(record, e);
                e.stopPropagation();
            },
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(iconPrefix, {
                [`${iconPrefix}-spaced`]: !expandable,
                [`${iconPrefix}-expanded`]: expandable && expanded,
                [`${iconPrefix}-collapsed`]: expandable && !expanded
            }),
            "aria-label": expanded ? locale.collapse : locale.expand,
            "aria-expanded": expanded
        });
    };
}
var $d828521527a4e705$export$2e2bcd8739ae039 = $d828521527a4e705$var$renderExpandIcon;


function $14b7b313d9bf7845$export$2e2bcd8739ae039(prefixCls) {
    const getContainerWidth = (ele, width)=>{
        const container = ele.querySelector(`.${prefixCls}-container`);
        let returnWidth = width;
        if (container) {
            const style = getComputedStyle(container);
            const borderLeft = Number.parseInt(style.borderLeftWidth, 10);
            const borderRight = Number.parseInt(style.borderRightWidth, 10);
            returnWidth = width - borderLeft - borderRight;
        }
        return returnWidth;
    };
    return getContainerWidth;
}




var $ltGt3 = parcelRequire("ltGt3");

const $85493e88663c6d66$export$480219a02f196e72 = (column, defaultKey)=>{
    if ('key' in column && column.key !== undefined && column.key !== null) return column.key;
    if (column.dataIndex) return Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex;
    return defaultKey;
};
function $85493e88663c6d66$export$7e4db04adce9b4db(index, pos) {
    return pos ? `${pos}-${index}` : `${index}`;
}
const $85493e88663c6d66$export$cfda450db2088de7 = (title, props)=>{
    if (typeof title === 'function') return title(props);
    return title;
};
const $85493e88663c6d66$export$1c24e0676a106839 = (title, props)=>{
    const res = $85493e88663c6d66$export$cfda450db2088de7(title, props);
    if (Object.prototype.toString.call(res) === '[object Object]') return '';
    return res;
};




var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $24550c7a483db733$var$FilterFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
                }
            }
        ]
    },
    "name": "filter",
    "theme": "filled"
};
var $24550c7a483db733$export$2e2bcd8739ae039 = $24550c7a483db733$var$FilterFilled;



function $25a4aec57280e9f6$var$_extends() {
    $25a4aec57280e9f6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $25a4aec57280e9f6$var$_extends.apply(this, arguments);
}
const $25a4aec57280e9f6$var$FilterFilled = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $25a4aec57280e9f6$var$_extends({}, props, {
        ref: ref,
        icon: (0, $24550c7a483db733$export$2e2bcd8739ae039)
    }));
/**![filter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM0OSA4MzhjMCAxNy43IDE0LjIgMzIgMzEuOCAzMmgyNjIuNGMxNy42IDAgMzEuOC0xNC4zIDMxLjgtMzJWNjQySDM0OXYxOTZ6bTUzMS4xLTY4NEgxNDMuOWMtMjQuNSAwLTM5LjggMjYuNy0yNy41IDQ4bDIyMS4zIDM3NmgzNDguOGwyMjEuMy0zNzZjMTIuMS0yMS4zLTMuMi00OC0yNy43LTQ4eiIgLz48L3N2Zz4=) */ const $25a4aec57280e9f6$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($25a4aec57280e9f6$var$FilterFilled);
var $25a4aec57280e9f6$export$2e2bcd8739ae039 = $25a4aec57280e9f6$var$RefIcon;






var $ltGt3 = parcelRequire("ltGt3");

const $df7f2d20d3190386$export$bd58d1a153fd4998 = (initialValue)=>{
    const ref = $ltGt3.useRef(initialValue);
    const [, forceUpdate] = (0, $a4dbd33868ca5b2a$export$91db9bc4f8ac944a)();
    return [
        ()=>ref.current,
        (newValue)=>{
            ref.current = newValue;
            forceUpdate();
        }
    ];
};













var $ltGt3 = parcelRequire("ltGt3");


"use client";
const $7d6387c8900e444a$var$FilterSearch = (props)=>{
    const { value: value, filterSearch: filterSearch, tablePrefixCls: tablePrefixCls, locale: locale, onChange: onChange } = props;
    if (!filterSearch) return null;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${tablePrefixCls}-filter-dropdown-search`
    }, /*#__PURE__*/ $ltGt3.createElement((0, $3ef8aed3a0e2360a$export$2e2bcd8739ae039), {
        prefix: /*#__PURE__*/ $ltGt3.createElement((0, $84123a67634fb0f3$export$2e2bcd8739ae039), null),
        placeholder: locale.filterSearchPlaceholder,
        onChange: onChange,
        value: value,
        // for skip min-width of input
        htmlSize: 1,
        className: `${tablePrefixCls}-filter-dropdown-search-input`
    }));
};
var $7d6387c8900e444a$export$2e2bcd8739ae039 = $7d6387c8900e444a$var$FilterSearch;



var $ltGt3 = parcelRequire("ltGt3");

"use client";
const $70bf0d093cd00e2f$var$onKeyDown = (event)=>{
    const { keyCode: keyCode } = event;
    if (keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER) event.stopPropagation();
};
const $70bf0d093cd00e2f$var$FilterDropdownMenuWrapper = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>/*#__PURE__*/ $ltGt3.createElement("div", {
        className: props.className,
        onClick: (e)=>e.stopPropagation(),
        onKeyDown: $70bf0d093cd00e2f$var$onKeyDown,
        ref: ref
    }, props.children));
var $70bf0d093cd00e2f$export$2e2bcd8739ae039 = $70bf0d093cd00e2f$var$FilterDropdownMenuWrapper;


"use client";
function $dcc236c1f0c9f9fa$export$50792ddeed01ab0a(filters) {
    let keys = [];
    (filters || []).forEach(({ value: value, children: children })=>{
        keys.push(value);
        if (children) keys = [].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(keys), (0, $83d01b7684a01087$export$2e2bcd8739ae039)($dcc236c1f0c9f9fa$export$50792ddeed01ab0a(children)));
    });
    return keys;
}
function $dcc236c1f0c9f9fa$var$hasSubMenu(filters) {
    return filters.some(({ children: children })=>children);
}
function $dcc236c1f0c9f9fa$var$searchValueMatched(searchValue, text) {
    if (typeof text === 'string' || typeof text === 'number') return text?.toString().toLowerCase().includes(searchValue.trim().toLowerCase());
    return false;
}
function $dcc236c1f0c9f9fa$var$renderFilterItems({ filters: filters, prefixCls: prefixCls, filteredKeys: filteredKeys, filterMultiple: filterMultiple, searchValue: searchValue, filterSearch: filterSearch }) {
    return filters.map((filter, index)=>{
        const key = String(filter.value);
        if (filter.children) return {
            key: key || index,
            label: filter.text,
            popupClassName: `${prefixCls}-dropdown-submenu`,
            children: $dcc236c1f0c9f9fa$var$renderFilterItems({
                filters: filter.children,
                prefixCls: prefixCls,
                filteredKeys: filteredKeys,
                filterMultiple: filterMultiple,
                searchValue: searchValue,
                filterSearch: filterSearch
            })
        };
        const Component = filterMultiple ? (0, $0fa8595e616a52f3$export$2e2bcd8739ae039) : (0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039);
        const item = {
            key: filter.value !== undefined ? key : index,
            label: /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement(Component, {
                checked: filteredKeys.includes(key)
            }), /*#__PURE__*/ $ltGt3.createElement("span", null, filter.text))
        };
        if (searchValue.trim()) {
            if (typeof filterSearch === 'function') return filterSearch(searchValue, filter) ? item : null;
            return $dcc236c1f0c9f9fa$var$searchValueMatched(searchValue, filter.text) ? item : null;
        }
        return item;
    });
}
function $dcc236c1f0c9f9fa$var$wrapStringListType(keys) {
    return keys || [];
}
const $dcc236c1f0c9f9fa$var$FilterDropdown = (props)=>{
    const { tablePrefixCls: tablePrefixCls, prefixCls: prefixCls, column: column, dropdownPrefixCls: dropdownPrefixCls, columnKey: columnKey, filterOnClose: filterOnClose, filterMultiple: filterMultiple, filterMode: filterMode = 'menu', filterSearch: filterSearch = false, filterState: filterState, triggerFilter: triggerFilter, locale: locale, children: children, getPopupContainer: getPopupContainer, rootClassName: rootClassName } = props;
    const { filterResetToDefaultFilteredValue: filterResetToDefaultFilteredValue, defaultFilteredValue: defaultFilteredValue, filterDropdownProps: filterDropdownProps = {}, filterDropdownOpen: // Deprecated
    filterDropdownOpen, onFilterDropdownOpenChange: onFilterDropdownOpenChange } = column;
    const [visible, setVisible] = $ltGt3.useState(false);
    const filtered = !!(filterState && (filterState.filteredKeys?.length || filterState.forceFiltered));
    const triggerVisible = (newVisible)=>{
        setVisible(newVisible);
        filterDropdownProps.onOpenChange?.(newVisible);
        // deprecated
        onFilterDropdownOpenChange?.(newVisible);
    };
    var deprecatedName, newName;
    const mergedVisible = filterDropdownProps.open ?? filterDropdownOpen ?? // deprecated
    visible; // inner state
    // ===================== Select Keys =====================
    const propFilteredKeys = filterState?.filteredKeys;
    const [getFilteredKeysSync, setFilteredKeysSync] = (0, $df7f2d20d3190386$export$bd58d1a153fd4998)($dcc236c1f0c9f9fa$var$wrapStringListType(propFilteredKeys));
    const onSelectKeys = ({ selectedKeys: selectedKeys })=>{
        setFilteredKeysSync(selectedKeys);
    };
    const onCheck = (keys, { node: node, checked: checked })=>{
        if (!filterMultiple) onSelectKeys({
            selectedKeys: checked && node.key ? [
                node.key
            ] : []
        });
        else onSelectKeys({
            selectedKeys: keys
        });
    };
    $ltGt3.useEffect(()=>{
        if (!visible) return;
        onSelectKeys({
            selectedKeys: $dcc236c1f0c9f9fa$var$wrapStringListType(propFilteredKeys)
        });
    }, [
        propFilteredKeys
    ]);
    // ====================== Open Keys ======================
    const [openKeys, setOpenKeys] = $ltGt3.useState([]);
    const onOpenChange = (keys)=>{
        setOpenKeys(keys);
    };
    // search in tree mode column filter
    const [searchValue, setSearchValue] = $ltGt3.useState('');
    const onSearch = (e)=>{
        const { value: value } = e.target;
        setSearchValue(value);
    };
    // clear search value after close filter dropdown
    $ltGt3.useEffect(()=>{
        if (!visible) setSearchValue('');
    }, [
        visible
    ]);
    // ======================= Submit ========================
    const internalTriggerFilter = (keys)=>{
        const mergedKeys = keys?.length ? keys : null;
        if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) return null;
        if ((0, $003c57daacb79f0c$export$2e2bcd8739ae039)(mergedKeys, filterState?.filteredKeys, true)) return null;
        triggerFilter({
            column: column,
            key: columnKey,
            filteredKeys: mergedKeys
        });
    };
    const onConfirm = ()=>{
        triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onReset = ({ confirm: confirm, closeDropdown: closeDropdown } = {
        confirm: false,
        closeDropdown: false
    })=>{
        if (confirm) internalTriggerFilter([]);
        if (closeDropdown) triggerVisible(false);
        setSearchValue('');
        if (filterResetToDefaultFilteredValue) setFilteredKeysSync((defaultFilteredValue || []).map((key)=>String(key)));
        else setFilteredKeysSync([]);
    };
    const doFilter = ({ closeDropdown: closeDropdown } = {
        closeDropdown: true
    })=>{
        if (closeDropdown) triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onVisibleChange = (newVisible, info)=>{
        if (info.source === 'trigger') {
            if (newVisible && propFilteredKeys !== undefined) // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefined)
            setFilteredKeysSync($dcc236c1f0c9f9fa$var$wrapStringListType(propFilteredKeys));
            triggerVisible(newVisible);
            if (!newVisible && !column.filterDropdown && filterOnClose) onConfirm();
        }
    };
    // ======================== Style ========================
    const dropdownMenuClass = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
        [`${dropdownPrefixCls}-menu-without-submenu`]: !$dcc236c1f0c9f9fa$var$hasSubMenu(column.filters || [])
    });
    const onCheckAll = (e)=>{
        if (e.target.checked) {
            const allFilterKeys = $dcc236c1f0c9f9fa$export$50792ddeed01ab0a(column?.filters).map((key)=>String(key));
            setFilteredKeysSync(allFilterKeys);
        } else setFilteredKeysSync([]);
    };
    const getTreeData = ({ filters: filters })=>(filters || []).map((filter, index)=>{
            const key = String(filter.value);
            const item = {
                title: filter.text,
                key: filter.value !== undefined ? key : String(index)
            };
            if (filter.children) item.children = getTreeData({
                filters: filter.children
            });
            return item;
        });
    const getFilterData = (node)=>({
            ...node,
            text: node.title,
            value: node.key,
            children: node.children?.map((item)=>getFilterData(item)) || []
        });
    let dropdownContent;
    const { direction: direction, renderEmpty: renderEmpty } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    if (typeof column.filterDropdown === 'function') dropdownContent = column.filterDropdown({
        prefixCls: `${dropdownPrefixCls}-custom`,
        setSelectedKeys: (selectedKeys)=>onSelectKeys({
                selectedKeys: selectedKeys
            }),
        selectedKeys: getFilteredKeysSync(),
        confirm: doFilter,
        clearFilters: onReset,
        filters: column.filters,
        visible: mergedVisible,
        close: ()=>{
            triggerVisible(false);
        }
    });
    else if (column.filterDropdown) dropdownContent = column.filterDropdown;
    else {
        const selectedKeys = getFilteredKeysSync() || [];
        const getFilterComponent = ()=>{
            const empty = renderEmpty?.('Table.filter') ?? /*#__PURE__*/ $ltGt3.createElement((0, $d84476b6e9011da3$export$2e2bcd8739ae039), {
                image: (0, $d84476b6e9011da3$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                description: locale.filterEmptyText,
                styles: {
                    image: {
                        height: 24
                    }
                },
                style: {
                    margin: 0,
                    padding: '16px 0'
                }
            });
            if ((column.filters || []).length === 0) return empty;
            if (filterMode === 'tree') return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement((0, $7d6387c8900e444a$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), /*#__PURE__*/ $ltGt3.createElement("div", {
                className: `${tablePrefixCls}-filter-dropdown-tree`
            }, filterMultiple ? /*#__PURE__*/ $ltGt3.createElement((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                checked: selectedKeys.length === $dcc236c1f0c9f9fa$export$50792ddeed01ab0a(column.filters).length,
                indeterminate: selectedKeys.length > 0 && selectedKeys.length < $dcc236c1f0c9f9fa$export$50792ddeed01ab0a(column.filters).length,
                className: `${tablePrefixCls}-filter-dropdown-checkall`,
                onChange: onCheckAll
            }, locale?.filterCheckall ?? locale?.filterCheckAll) : null, /*#__PURE__*/ $ltGt3.createElement((0, $14d9d6c9731a6b94$export$2e2bcd8739ae039), {
                checkable: true,
                selectable: false,
                blockNode: true,
                multiple: filterMultiple,
                checkStrictly: !filterMultiple,
                className: `${dropdownPrefixCls}-menu`,
                onCheck: onCheck,
                checkedKeys: selectedKeys,
                selectedKeys: selectedKeys,
                showIcon: false,
                treeData: getTreeData({
                    filters: column.filters
                }),
                autoExpandParent: true,
                defaultExpandAll: true,
                filterTreeNode: searchValue.trim() ? (node)=>{
                    if (typeof filterSearch === 'function') return filterSearch(searchValue, getFilterData(node));
                    return $dcc236c1f0c9f9fa$var$searchValueMatched(searchValue, node.title);
                } : undefined
            })));
            const items = $dcc236c1f0c9f9fa$var$renderFilterItems({
                filters: column.filters || [],
                filterSearch: filterSearch,
                prefixCls: prefixCls,
                filteredKeys: getFilteredKeysSync(),
                filterMultiple: filterMultiple,
                searchValue: searchValue
            });
            const isEmpty = items.every((item)=>item === null);
            return /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, /*#__PURE__*/ $ltGt3.createElement((0, $7d6387c8900e444a$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), isEmpty ? empty : /*#__PURE__*/ $ltGt3.createElement((0, $ad53fe0065acc0ef$export$2e2bcd8739ae039), {
                selectable: true,
                multiple: filterMultiple,
                prefixCls: `${dropdownPrefixCls}-menu`,
                className: dropdownMenuClass,
                onSelect: onSelectKeys,
                onDeselect: onSelectKeys,
                selectedKeys: selectedKeys,
                getPopupContainer: getPopupContainer,
                openKeys: openKeys,
                onOpenChange: onOpenChange,
                items: items
            }));
        };
        const getResetDisabled = ()=>{
            if (filterResetToDefaultFilteredValue) return (0, $003c57daacb79f0c$export$2e2bcd8739ae039)((defaultFilteredValue || []).map((key)=>String(key)), selectedKeys, true);
            return selectedKeys.length === 0;
        };
        dropdownContent = /*#__PURE__*/ $ltGt3.createElement($ltGt3.Fragment, null, getFilterComponent(), /*#__PURE__*/ $ltGt3.createElement("div", {
            className: `${prefixCls}-dropdown-btns`
        }, /*#__PURE__*/ $ltGt3.createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
            type: "link",
            size: "small",
            disabled: getResetDisabled(),
            onClick: ()=>onReset()
        }, locale.filterReset), /*#__PURE__*/ $ltGt3.createElement((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
            type: "primary",
            size: "small",
            onClick: onConfirm
        }, locale.filterConfirm)));
    }
    // We should not block customize Menu with additional props
    if (column.filterDropdown) dropdownContent = /*#__PURE__*/ $ltGt3.createElement((0, $0c0f4dfb7618b339$export$9bd434816b0530d0), {
        selectable: undefined
    }, dropdownContent);
    dropdownContent = /*#__PURE__*/ $ltGt3.createElement((0, $70bf0d093cd00e2f$export$2e2bcd8739ae039), {
        className: `${prefixCls}-dropdown`
    }, dropdownContent);
    const getDropdownTrigger = ()=>{
        let filterIcon;
        if (typeof column.filterIcon === 'function') filterIcon = column.filterIcon(filtered);
        else if (column.filterIcon) filterIcon = column.filterIcon;
        else filterIcon = /*#__PURE__*/ $ltGt3.createElement((0, $25a4aec57280e9f6$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ $ltGt3.createElement("span", {
            role: "button",
            tabIndex: -1,
            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-trigger`, {
                active: filtered
            }),
            onClick: (e)=>{
                e.stopPropagation();
            }
        }, filterIcon);
    };
    const mergedDropdownProps = (0, $40cefbb323433535$export$2e2bcd8739ae039)({
        trigger: [
            'click'
        ],
        placement: direction === 'rtl' ? 'bottomLeft' : 'bottomRight',
        children: getDropdownTrigger(),
        getPopupContainer: getPopupContainer
    }, {
        ...filterDropdownProps,
        rootClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(rootClassName, filterDropdownProps.rootClassName),
        open: mergedVisible,
        onOpenChange: onVisibleChange,
        popupRender: ()=>{
            if (typeof filterDropdownProps?.dropdownRender === 'function') return filterDropdownProps.dropdownRender(dropdownContent);
            return dropdownContent;
        }
    });
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: `${prefixCls}-column`
    }, /*#__PURE__*/ $ltGt3.createElement("span", {
        className: `${tablePrefixCls}-column-title`
    }, children), /*#__PURE__*/ $ltGt3.createElement((0, $fdbae0f0e90936fe$export$2e2bcd8739ae039), {
        ...mergedDropdownProps
    }));
};
var $dcc236c1f0c9f9fa$export$2e2bcd8739ae039 = $dcc236c1f0c9f9fa$var$FilterDropdown;


"use client";
const $27eeb92c49e83bd8$var$collectFilterStates = (columns, init, pos)=>{
    let filterStates = [];
    (columns || []).forEach((column, index)=>{
        const columnPos = (0, $85493e88663c6d66$export$7e4db04adce9b4db)(index, pos);
        const filterDropdownIsDefined = column.filterDropdown !== undefined;
        if (column.filters || filterDropdownIsDefined || 'onFilter' in column) {
            if ('filteredValue' in column) {
                // Controlled
                let filteredValues = column.filteredValue;
                if (!filterDropdownIsDefined) filteredValues = filteredValues?.map(String) ?? filteredValues;
                filterStates.push({
                    column: column,
                    key: (0, $85493e88663c6d66$export$480219a02f196e72)(column, columnPos),
                    filteredKeys: filteredValues,
                    forceFiltered: column.filtered
                });
            } else // Uncontrolled
            filterStates.push({
                column: column,
                key: (0, $85493e88663c6d66$export$480219a02f196e72)(column, columnPos),
                filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
                forceFiltered: column.filtered
            });
        }
        if ('children' in column) filterStates = [].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(filterStates), (0, $83d01b7684a01087$export$2e2bcd8739ae039)($27eeb92c49e83bd8$var$collectFilterStates(column.children, init, columnPos)));
    });
    return filterStates;
};
function $27eeb92c49e83bd8$var$injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, locale, triggerFilter, getPopupContainer, pos, rootClassName) {
    return columns.map((column, index)=>{
        const columnPos = (0, $85493e88663c6d66$export$7e4db04adce9b4db)(index, pos);
        const { filterOnClose: filterOnClose = true, filterMultiple: filterMultiple = true, filterMode: filterMode, filterSearch: filterSearch } = column;
        let newColumn = column;
        if (newColumn.filters || newColumn.filterDropdown) {
            const columnKey = (0, $85493e88663c6d66$export$480219a02f196e72)(newColumn, columnPos);
            const filterState = filterStates.find(({ key: key })=>columnKey === key);
            newColumn = {
                ...newColumn,
                title: (renderProps)=>/*#__PURE__*/ $ltGt3.createElement((0, $dcc236c1f0c9f9fa$export$2e2bcd8739ae039), {
                        tablePrefixCls: prefixCls,
                        prefixCls: `${prefixCls}-filter`,
                        dropdownPrefixCls: dropdownPrefixCls,
                        column: newColumn,
                        columnKey: columnKey,
                        filterState: filterState,
                        filterOnClose: filterOnClose,
                        filterMultiple: filterMultiple,
                        filterMode: filterMode,
                        filterSearch: filterSearch,
                        triggerFilter: triggerFilter,
                        locale: locale,
                        getPopupContainer: getPopupContainer,
                        rootClassName: rootClassName
                    }, (0, $85493e88663c6d66$export$cfda450db2088de7)(column.title, renderProps))
            };
        }
        if ('children' in newColumn) newColumn = {
            ...newColumn,
            children: $27eeb92c49e83bd8$var$injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, locale, triggerFilter, getPopupContainer, columnPos, rootClassName)
        };
        return newColumn;
    });
}
const $27eeb92c49e83bd8$var$generateFilterInfo = (filterStates)=>{
    const currentFilters = {};
    filterStates.forEach(({ key: key, filteredKeys: filteredKeys, column: column })=>{
        const keyAsString = key;
        const { filters: filters, filterDropdown: filterDropdown } = column;
        if (filterDropdown) currentFilters[keyAsString] = filteredKeys || null;
        else if (Array.isArray(filteredKeys)) {
            const keys = (0, $dcc236c1f0c9f9fa$export$50792ddeed01ab0a)(filters);
            currentFilters[keyAsString] = keys.filter((originKey)=>filteredKeys.includes(String(originKey)));
        } else currentFilters[keyAsString] = null;
    });
    return currentFilters;
};
const $27eeb92c49e83bd8$export$37643bb40f4c1c56 = (data, filterStates, childrenColumnName)=>{
    const filterDatas = filterStates.reduce((currentData, filterState)=>{
        const { column: { onFilter: onFilter, filters: filters }, filteredKeys: filteredKeys } = filterState;
        if (onFilter && filteredKeys && filteredKeys.length) return currentData// shallow copy
        .map((record)=>({
                ...record
            })).filter((record)=>filteredKeys.some((key)=>{
                const keys = (0, $dcc236c1f0c9f9fa$export$50792ddeed01ab0a)(filters);
                const keyIndex = keys.findIndex((k)=>String(k) === String(key));
                const realKey = keyIndex !== -1 ? keys[keyIndex] : key;
                // filter children
                if (record[childrenColumnName]) record[childrenColumnName] = $27eeb92c49e83bd8$export$37643bb40f4c1c56(record[childrenColumnName], filterStates, childrenColumnName);
                return onFilter(realKey, record);
            }));
        return currentData;
    }, data);
    return filterDatas;
};
const $27eeb92c49e83bd8$var$getMergedColumns = (rawMergedColumns)=>rawMergedColumns.flatMap((column)=>{
        if ('children' in column) return [
            column
        ].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)($27eeb92c49e83bd8$var$getMergedColumns(column.children || [])));
        return [
            column
        ];
    });
const $27eeb92c49e83bd8$var$useFilter = (props)=>{
    const { prefixCls: prefixCls, dropdownPrefixCls: dropdownPrefixCls, mergedColumns: rawMergedColumns, onFilterChange: onFilterChange, getPopupContainer: getPopupContainer, locale: tableLocale, rootClassName: rootClassName } = props;
    const warning = (0, $9530c27c700696d0$export$cf977aa92c751e61)('Table');
    const mergedColumns = $ltGt3.useMemo(()=>$27eeb92c49e83bd8$var$getMergedColumns(rawMergedColumns || []), [
        rawMergedColumns
    ]);
    const [filterStates, setFilterStates] = $ltGt3.useState(()=>$27eeb92c49e83bd8$var$collectFilterStates(mergedColumns, true));
    const mergedFilterStates = $ltGt3.useMemo(()=>{
        const collectedStates = $27eeb92c49e83bd8$var$collectFilterStates(mergedColumns, false);
        if (collectedStates.length === 0) return collectedStates;
        let filteredKeysIsAllNotControlled = true;
        let filteredKeysIsAllControlled = true;
        collectedStates.forEach(({ filteredKeys: filteredKeys })=>{
            if (filteredKeys !== undefined) filteredKeysIsAllNotControlled = false;
            else filteredKeysIsAllControlled = false;
        });
        // Return if not controlled
        if (filteredKeysIsAllNotControlled) {
            // Filter column may have been removed
            const keyList = (mergedColumns || []).map((column, index)=>(0, $85493e88663c6d66$export$480219a02f196e72)(column, (0, $85493e88663c6d66$export$7e4db04adce9b4db)(index)));
            return filterStates.filter(({ key: key })=>keyList.includes(key)).map((item)=>{
                const col = mergedColumns[keyList.indexOf(item.key)];
                return {
                    ...item,
                    column: {
                        ...item.column,
                        ...col
                    },
                    forceFiltered: col.filtered
                };
            });
        }
        return collectedStates;
    }, [
        mergedColumns,
        filterStates
    ]);
    const filters = $ltGt3.useMemo(()=>$27eeb92c49e83bd8$var$generateFilterInfo(mergedFilterStates), [
        mergedFilterStates
    ]);
    const triggerFilter = (filterState)=>{
        const newFilterStates = mergedFilterStates.filter(({ key: key })=>key !== filterState.key);
        newFilterStates.push(filterState);
        setFilterStates(newFilterStates);
        onFilterChange($27eeb92c49e83bd8$var$generateFilterInfo(newFilterStates), newFilterStates);
    };
    const transformColumns = (innerColumns)=>$27eeb92c49e83bd8$var$injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, tableLocale, triggerFilter, getPopupContainer, undefined, rootClassName);
    return [
        transformColumns,
        mergedFilterStates,
        filters
    ];
};
var $27eeb92c49e83bd8$export$2e2bcd8739ae039 = $27eeb92c49e83bd8$var$useFilter;



var $ltGt3 = parcelRequire("ltGt3");
const $e510d0c3c7177ff8$var$useLazyKVMap = (data, childrenColumnName, getRowKey)=>{
    const mapCacheRef = $ltGt3.useRef({});
    function getRecordByKey(key) {
        if (!mapCacheRef.current || mapCacheRef.current.data !== data || mapCacheRef.current.childrenColumnName !== childrenColumnName || mapCacheRef.current.getRowKey !== getRowKey) {
            const kvMap = new Map();
            function dig(records) {
                records.forEach((record, index)=>{
                    const rowKey = getRowKey(record, index);
                    kvMap.set(rowKey, record);
                    if (record && typeof record === 'object' && childrenColumnName in record) dig(record[childrenColumnName] || []);
                });
            }
            dig(data);
            mapCacheRef.current = {
                data: data,
                childrenColumnName: childrenColumnName,
                kvMap: kvMap,
                getRowKey: getRowKey
            };
        }
        return mapCacheRef.current.kvMap?.get(key);
    }
    return [
        getRecordByKey
    ];
};
var $e510d0c3c7177ff8$export$2e2bcd8739ae039 = $e510d0c3c7177ff8$var$useLazyKVMap;



var $ltGt3 = parcelRequire("ltGt3");

const $1beaf17c90985ea4$export$5716e8bcb003888d = 10;
function $1beaf17c90985ea4$export$27eceeed7bf0f4c2(mergedPagination, pagination) {
    const param = {
        current: mergedPagination.current,
        pageSize: mergedPagination.pageSize
    };
    const paginationObj = pagination && typeof pagination === 'object' ? pagination : {};
    Object.keys(paginationObj).forEach((pageProp)=>{
        const value = mergedPagination[pageProp];
        if (typeof value !== 'function') param[pageProp] = value;
    });
    return param;
}
function $1beaf17c90985ea4$var$usePagination(total, onChange, pagination) {
    const { total: paginationTotal = 0, ...paginationObj } = pagination && typeof pagination === 'object' ? pagination : {};
    const [innerPagination, setInnerPagination] = (0, $ltGt3.useState)(()=>({
            current: 'defaultCurrent' in paginationObj ? paginationObj.defaultCurrent : 1,
            pageSize: 'defaultPageSize' in paginationObj ? paginationObj.defaultPageSize : $1beaf17c90985ea4$export$5716e8bcb003888d
        }));
    // ============ Basic Pagination Config ============
    const mergedPagination = (0, $40cefbb323433535$export$2e2bcd8739ae039)(innerPagination, paginationObj, {
        total: paginationTotal > 0 ? paginationTotal : total
    });
    // Reset `current` if data length or pageSize changed
    const maxPage = Math.ceil((paginationTotal || total) / mergedPagination.pageSize);
    if (mergedPagination.current > maxPage) // Prevent a maximum page count of 0
    mergedPagination.current = maxPage || 1;
    const refreshPagination = (current, pageSize)=>{
        setInnerPagination({
            current: current ?? 1,
            pageSize: pageSize || mergedPagination.pageSize
        });
    };
    const onInternalChange = (current, pageSize)=>{
        if (pagination) pagination.onChange?.(current, pageSize);
        refreshPagination(current, pageSize);
        onChange(current, pageSize || mergedPagination?.pageSize);
    };
    if (pagination === false) return [
        {},
        ()=>{}
    ];
    return [
        {
            ...mergedPagination,
            onChange: onInternalChange
        },
        refreshPagination
    ];
}
var $1beaf17c90985ea4$export$2e2bcd8739ae039 = $1beaf17c90985ea4$var$usePagination;





var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $d3df26376dec3d28$var$CaretDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "outlined"
};
var $d3df26376dec3d28$export$2e2bcd8739ae039 = $d3df26376dec3d28$var$CaretDownOutlined;



function $d19a24d24877ca43$var$_extends() {
    $d19a24d24877ca43$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d19a24d24877ca43$var$_extends.apply(this, arguments);
}
const $d19a24d24877ca43$var$CaretDownOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $d19a24d24877ca43$var$_extends({}, props, {
        ref: ref,
        icon: (0, $d3df26376dec3d28$export$2e2bcd8739ae039)
    }));
/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */ const $d19a24d24877ca43$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($d19a24d24877ca43$var$CaretDownOutlined);
var $d19a24d24877ca43$export$2e2bcd8739ae039 = $d19a24d24877ca43$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $c38f3e4dc89c2dcc$var$CaretUpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    },
    "name": "caret-up",
    "theme": "outlined"
};
var $c38f3e4dc89c2dcc$export$2e2bcd8739ae039 = $c38f3e4dc89c2dcc$var$CaretUpOutlined;



function $56df5c6544b25d14$var$_extends() {
    $56df5c6544b25d14$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $56df5c6544b25d14$var$_extends.apply(this, arguments);
}
const $56df5c6544b25d14$var$CaretUpOutlined = (props, ref)=>/*#__PURE__*/ $ltGt3.createElement((0, $e767a45d917d435a$export$2e2bcd8739ae039), $56df5c6544b25d14$var$_extends({}, props, {
        ref: ref,
        icon: (0, $c38f3e4dc89c2dcc$export$2e2bcd8739ae039)
    }));
/**![caret-up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OC45IDY4OUw1MzAuNSAzMDguMmMtOS40LTEwLjktMjcuNS0xMC45LTM3IDBMMTY1LjEgNjg5Yy0xMi4yIDE0LjItMS4yIDM1IDE4LjUgMzVoNjU2LjhjMTkuNyAwIDMwLjctMjAuOCAxOC41LTM1eiIgLz48L3N2Zz4=) */ const $56df5c6544b25d14$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($56df5c6544b25d14$var$CaretUpOutlined);
var $56df5c6544b25d14$export$2e2bcd8739ae039 = $56df5c6544b25d14$var$RefIcon;






"use client";
const $11e1b20a1cf2ab5b$var$ASCEND = 'ascend';
const $11e1b20a1cf2ab5b$var$DESCEND = 'descend';
const $11e1b20a1cf2ab5b$var$getMultiplePriority = (column)=>{
    if (typeof column.sorter === 'object' && typeof column.sorter.multiple === 'number') return column.sorter.multiple;
    return false;
};
const $11e1b20a1cf2ab5b$var$getSortFunction = (sorter)=>{
    if (typeof sorter === 'function') return sorter;
    if (sorter && typeof sorter === 'object' && sorter.compare) return sorter.compare;
    return false;
};
const $11e1b20a1cf2ab5b$var$nextSortDirection = (sortDirections, current)=>{
    if (!current) return sortDirections[0];
    return sortDirections[sortDirections.indexOf(current) + 1];
};
const $11e1b20a1cf2ab5b$var$collectSortStates = (columns, init, pos)=>{
    let sortStates = [];
    const pushState = (column, columnPos)=>{
        sortStates.push({
            column: column,
            key: (0, $85493e88663c6d66$export$480219a02f196e72)(column, columnPos),
            multiplePriority: $11e1b20a1cf2ab5b$var$getMultiplePriority(column),
            sortOrder: column.sortOrder
        });
    };
    (columns || []).forEach((column, index)=>{
        const columnPos = (0, $85493e88663c6d66$export$7e4db04adce9b4db)(index, pos);
        if (column.children) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            sortStates = [].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(sortStates), (0, $83d01b7684a01087$export$2e2bcd8739ae039)($11e1b20a1cf2ab5b$var$collectSortStates(column.children, init, columnPos)));
        } else if (column.sorter) {
            if ('sortOrder' in column) // Controlled
            pushState(column, columnPos);
            else if (init && column.defaultSortOrder) // Default sorter
            sortStates.push({
                column: column,
                key: (0, $85493e88663c6d66$export$480219a02f196e72)(column, columnPos),
                multiplePriority: $11e1b20a1cf2ab5b$var$getMultiplePriority(column),
                sortOrder: column.defaultSortOrder
            });
        }
    });
    return sortStates;
};
const $11e1b20a1cf2ab5b$var$injectSorter = (prefixCls, columns, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos, a11yLocale)=>{
    const finalColumns = (columns || []).map((column, index)=>{
        const columnPos = (0, $85493e88663c6d66$export$7e4db04adce9b4db)(index, pos);
        let newColumn = column;
        if (newColumn.sorter) {
            const sortDirections = newColumn.sortDirections || defaultSortDirections;
            const showSorterTooltip = newColumn.showSorterTooltip === undefined ? tableShowSorterTooltip : newColumn.showSorterTooltip;
            const columnKey = (0, $85493e88663c6d66$export$480219a02f196e72)(newColumn, columnPos);
            const sorterState = sorterStates.find(({ key: key })=>key === columnKey);
            const sortOrder = sorterState ? sorterState.sortOrder : null;
            const nextSortOrder = $11e1b20a1cf2ab5b$var$nextSortDirection(sortDirections, sortOrder);
            let sorter;
            if (column.sortIcon) sorter = column.sortIcon({
                sortOrder: sortOrder
            });
            else {
                const upNode = sortDirections.includes($11e1b20a1cf2ab5b$var$ASCEND) && /*#__PURE__*/ $ltGt3.createElement((0, $56df5c6544b25d14$export$2e2bcd8739ae039), {
                    className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-column-sorter-up`, {
                        active: sortOrder === $11e1b20a1cf2ab5b$var$ASCEND
                    })
                });
                const downNode = sortDirections.includes($11e1b20a1cf2ab5b$var$DESCEND) && /*#__PURE__*/ $ltGt3.createElement((0, $d19a24d24877ca43$export$2e2bcd8739ae039), {
                    className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-column-sorter-down`, {
                        active: sortOrder === $11e1b20a1cf2ab5b$var$DESCEND
                    })
                });
                sorter = /*#__PURE__*/ $ltGt3.createElement("span", {
                    className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-column-sorter`, {
                        [`${prefixCls}-column-sorter-full`]: !!(upNode && downNode)
                    })
                }, /*#__PURE__*/ $ltGt3.createElement("span", {
                    className: `${prefixCls}-column-sorter-inner`,
                    "aria-hidden": "true"
                }, upNode, downNode));
            }
            const { cancelSort: cancelSort, triggerAsc: triggerAsc, triggerDesc: triggerDesc } = tableLocale || {};
            let sortTip = cancelSort;
            if (nextSortOrder === $11e1b20a1cf2ab5b$var$DESCEND) sortTip = triggerDesc;
            else if (nextSortOrder === $11e1b20a1cf2ab5b$var$ASCEND) sortTip = triggerAsc;
            const tooltipProps = typeof showSorterTooltip === 'object' ? {
                title: sortTip,
                ...showSorterTooltip
            } : {
                title: sortTip
            };
            newColumn = {
                ...newColumn,
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(newColumn.className, {
                    [`${prefixCls}-column-sort`]: sortOrder
                }),
                title: (renderProps)=>{
                    const columnSortersClass = `${prefixCls}-column-sorters`;
                    const renderColumnTitleWrapper = /*#__PURE__*/ $ltGt3.createElement("span", {
                        className: `${prefixCls}-column-title`
                    }, (0, $85493e88663c6d66$export$cfda450db2088de7)(column.title, renderProps));
                    const renderSortTitle = /*#__PURE__*/ $ltGt3.createElement("div", {
                        className: columnSortersClass
                    }, renderColumnTitleWrapper, sorter);
                    if (showSorterTooltip) {
                        if (typeof showSorterTooltip !== 'boolean' && showSorterTooltip?.target === 'sorter-icon') return /*#__PURE__*/ $ltGt3.createElement("div", {
                            className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(columnSortersClass, `${columnSortersClass}-tooltip-target-sorter`)
                        }, renderColumnTitleWrapper, /*#__PURE__*/ $ltGt3.createElement((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                            ...tooltipProps
                        }, sorter));
                        return /*#__PURE__*/ $ltGt3.createElement((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                            ...tooltipProps
                        }, renderSortTitle);
                    }
                    return renderSortTitle;
                },
                onHeaderCell: (col)=>{
                    const cell = column.onHeaderCell?.(col) || {};
                    const originOnClick = cell.onClick;
                    const originOKeyDown = cell.onKeyDown;
                    cell.onClick = (event)=>{
                        triggerSorter({
                            column: column,
                            key: columnKey,
                            sortOrder: nextSortOrder,
                            multiplePriority: $11e1b20a1cf2ab5b$var$getMultiplePriority(column)
                        });
                        originOnClick?.(event);
                    };
                    cell.onKeyDown = (event)=>{
                        if (event.keyCode === (0, $b0616a5421b43292$export$2e2bcd8739ae039).ENTER) {
                            triggerSorter({
                                column: column,
                                key: columnKey,
                                sortOrder: nextSortOrder,
                                multiplePriority: $11e1b20a1cf2ab5b$var$getMultiplePriority(column)
                            });
                            originOKeyDown?.(event);
                        }
                    };
                    const renderTitle = (0, $85493e88663c6d66$export$1c24e0676a106839)(column.title, {});
                    const displayTitle = renderTitle?.toString();
                    // Inform the screen-reader so it can tell the visually impaired user which column is sorted
                    if (sortOrder) cell['aria-sort'] = sortOrder === 'ascend' ? 'ascending' : 'descending';
                    // Inform the screen-reader so it can tell the visually impaired user that this column can be sorted
                    cell['aria-description'] = a11yLocale?.sortable;
                    cell['aria-label'] = displayTitle || '';
                    cell.className = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(cell.className, `${prefixCls}-column-has-sorters`);
                    cell.tabIndex = 0;
                    if (column.ellipsis) cell.title = (renderTitle ?? '').toString();
                    return cell;
                }
            };
        }
        if ('children' in newColumn) newColumn = {
            ...newColumn,
            children: $11e1b20a1cf2ab5b$var$injectSorter(prefixCls, newColumn.children, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos, a11yLocale)
        };
        return newColumn;
    });
    return finalColumns;
};
const $11e1b20a1cf2ab5b$var$stateToInfo = (sorterState)=>{
    const { column: column, sortOrder: sortOrder } = sorterState;
    return {
        column: column,
        order: sortOrder,
        field: column.dataIndex,
        columnKey: column.key
    };
};
const $11e1b20a1cf2ab5b$var$generateSorterInfo = (sorterStates)=>{
    const activeSorters = sorterStates.filter(({ sortOrder: sortOrder })=>sortOrder).map($11e1b20a1cf2ab5b$var$stateToInfo);
    // =========== Legacy compatible support ===========
    // https://github.com/ant-design/ant-design/pull/19226
    if (activeSorters.length === 0 && sorterStates.length) {
        const lastIndex = sorterStates.length - 1;
        return {
            ...$11e1b20a1cf2ab5b$var$stateToInfo(sorterStates[lastIndex]),
            column: undefined,
            order: undefined,
            field: undefined,
            columnKey: undefined
        };
    }
    if (activeSorters.length <= 1) return activeSorters[0] || {};
    return activeSorters;
};
const $11e1b20a1cf2ab5b$export$594b2c8da4a70ee = (data, sortStates, childrenColumnName)=>{
    const innerSorterStates = sortStates.slice().sort((a, b)=>b.multiplePriority - a.multiplePriority);
    const cloneData = data.slice();
    const runningSorters = innerSorterStates.filter(({ column: { sorter: sorter }, sortOrder: sortOrder })=>$11e1b20a1cf2ab5b$var$getSortFunction(sorter) && sortOrder);
    // Skip if no sorter needed
    if (!runningSorters.length) return cloneData;
    return cloneData.sort((record1, record2)=>{
        for(let i = 0; i < runningSorters.length; i += 1){
            const sorterState = runningSorters[i];
            const { column: { sorter: sorter }, sortOrder: sortOrder } = sorterState;
            const compareFn = $11e1b20a1cf2ab5b$var$getSortFunction(sorter);
            if (compareFn && sortOrder) {
                const compareResult = compareFn(record1, record2, sortOrder);
                if (compareResult !== 0) return sortOrder === $11e1b20a1cf2ab5b$var$ASCEND ? compareResult : -compareResult;
            }
        }
        return 0;
    }).map((record)=>{
        const subRecords = record[childrenColumnName];
        if (subRecords) return {
            ...record,
            [childrenColumnName]: $11e1b20a1cf2ab5b$export$594b2c8da4a70ee(subRecords, sortStates, childrenColumnName)
        };
        return record;
    });
};
const $11e1b20a1cf2ab5b$var$useFilterSorter = (props)=>{
    const { prefixCls: prefixCls, mergedColumns: mergedColumns, sortDirections: sortDirections, tableLocale: tableLocale, showSorterTooltip: showSorterTooltip, onSorterChange: onSorterChange, globalLocale: globalLocale } = props;
    const [sortStates, setSortStates] = $ltGt3.useState(()=>$11e1b20a1cf2ab5b$var$collectSortStates(mergedColumns, true));
    const getColumnKeys = (columns, pos)=>{
        const newKeys = [];
        columns.forEach((item, index)=>{
            const columnPos = (0, $85493e88663c6d66$export$7e4db04adce9b4db)(index, pos);
            newKeys.push((0, $85493e88663c6d66$export$480219a02f196e72)(item, columnPos));
            if (Array.isArray(item.children)) {
                const childKeys = getColumnKeys(item.children, columnPos);
                newKeys.push.apply(newKeys, (0, $83d01b7684a01087$export$2e2bcd8739ae039)(childKeys));
            }
        });
        return newKeys;
    };
    const mergedSorterStates = $ltGt3.useMemo(()=>{
        let validate = true;
        const collectedStates = $11e1b20a1cf2ab5b$var$collectSortStates(mergedColumns, false);
        // Return if not controlled
        if (!collectedStates.length) {
            const mergedColumnsKeys = getColumnKeys(mergedColumns);
            return sortStates.filter(({ key: key })=>mergedColumnsKeys.includes(key));
        }
        const validateStates = [];
        function patchStates(state) {
            if (validate) validateStates.push(state);
            else validateStates.push({
                ...state,
                sortOrder: null
            });
        }
        let multipleMode = null;
        collectedStates.forEach((state)=>{
            if (multipleMode === null) {
                patchStates(state);
                if (state.sortOrder) {
                    if (state.multiplePriority === false) validate = false;
                    else multipleMode = true;
                }
            } else if (multipleMode && state.multiplePriority !== false) patchStates(state);
            else {
                validate = false;
                patchStates(state);
            }
        });
        return validateStates;
    }, [
        mergedColumns,
        sortStates
    ]);
    // Get render columns title required props
    const columnTitleSorterProps = $ltGt3.useMemo(()=>{
        const sortColumns = mergedSorterStates.map(({ column: column, sortOrder: sortOrder })=>({
                column: column,
                order: sortOrder
            }));
        return {
            sortColumns: sortColumns,
            // Legacy
            sortColumn: sortColumns[0]?.column,
            sortOrder: sortColumns[0]?.order
        };
    }, [
        mergedSorterStates
    ]);
    const triggerSorter = (sortState)=>{
        let newSorterStates;
        if (sortState.multiplePriority === false || !mergedSorterStates.length || mergedSorterStates[0].multiplePriority === false) newSorterStates = [
            sortState
        ];
        else newSorterStates = [].concat((0, $83d01b7684a01087$export$2e2bcd8739ae039)(mergedSorterStates.filter(({ key: key })=>key !== sortState.key)), [
            sortState
        ]);
        setSortStates(newSorterStates);
        onSorterChange($11e1b20a1cf2ab5b$var$generateSorterInfo(newSorterStates), newSorterStates);
    };
    const transformColumns = (innerColumns)=>$11e1b20a1cf2ab5b$var$injectSorter(prefixCls, innerColumns, mergedSorterStates, triggerSorter, sortDirections, tableLocale, showSorterTooltip, undefined, globalLocale);
    const getSorters = ()=>$11e1b20a1cf2ab5b$var$generateSorterInfo(mergedSorterStates);
    return [
        transformColumns,
        mergedSorterStates,
        columnTitleSorterProps,
        getSorters
    ];
};
var $11e1b20a1cf2ab5b$export$2e2bcd8739ae039 = $11e1b20a1cf2ab5b$var$useFilterSorter;



var $ltGt3 = parcelRequire("ltGt3");

const $b72755658fb492cf$var$fillTitle = (columns, columnTitleProps)=>{
    const finalColumns = columns.map((column)=>{
        const cloneColumn = {
            ...column
        };
        cloneColumn.title = (0, $85493e88663c6d66$export$cfda450db2088de7)(column.title, columnTitleProps);
        if ('children' in cloneColumn) cloneColumn.children = $b72755658fb492cf$var$fillTitle(cloneColumn.children, columnTitleProps);
        return cloneColumn;
    });
    return finalColumns;
};
const $b72755658fb492cf$var$useTitleColumns = (columnTitleProps)=>{
    const filledColumns = $ltGt3.useCallback((columns)=>$b72755658fb492cf$var$fillTitle(columns, columnTitleProps), [
        columnTitleProps
    ]);
    return [
        filledColumns
    ];
};
var $b72755658fb492cf$export$2e2bcd8739ae039 = $b72755658fb492cf$var$useTitleColumns;



"use client";
/**
 * Same as `rc-component/table` but we modify trigger children update logic instead.
 */ const $1bf997e2285a78cc$var$RcTable = (0, $7049eb65ab1ff2d8$export$13da147d1fdf3e3c)((prev, next)=>{
    const { _renderTimes: prevRenderTimes } = prev;
    const { _renderTimes: nextRenderTimes } = next;
    return prevRenderTimes !== nextRenderTimes;
});
var $1bf997e2285a78cc$export$2e2bcd8739ae039 = $1bf997e2285a78cc$var$RcTable;



"use client";
/**
 * Same as `rc-component/table` but we modify trigger children update logic instead.
 */ const $c3f70cb43f9f7cd6$var$RcVirtualTable = (0, $fac77e864cd6e6a0$export$4747b79b36862360)((prev, next)=>{
    const { _renderTimes: prevRenderTimes } = prev;
    const { _renderTimes: nextRenderTimes } = next;
    return prevRenderTimes !== nextRenderTimes;
});
var $c3f70cb43f9f7cd6$export$2e2bcd8739ae039 = $c3f70cb43f9f7cd6$var$RcVirtualTable;







const $ec35b3ce33ed358a$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, tableHeaderBg: tableHeaderBg, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, calc: calc } = token;
    const tableBorder = `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const getSizeBorderStyle = (size, paddingVertical, paddingHorizontal)=>({
            [`&${componentCls}-${size}`]: {
                [`> ${componentCls}-container`]: {
                    [`> ${componentCls}-content, > ${componentCls}-body`]: {
                        [`
            > table > tbody > tr > th,
            > table > tbody > tr > td
          `]: {
                            [`> ${componentCls}-expanded-row-fixed`]: {
                                margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal())}
              ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(calc(paddingHorizontal).add(lineWidth)).mul(-1).equal())}`
                            }
                        }
                    }
                }
            }
        });
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}${componentCls}-bordered`]: {
                // ============================ Title =============================
                [`> ${componentCls}-title`]: {
                    border: tableBorder,
                    borderBottom: 0
                },
                // ============================ Content ============================
                [`> ${componentCls}-container`]: {
                    borderInlineStart: tableBorder,
                    borderTop: tableBorder,
                    [`
            > ${componentCls}-content,
            > ${componentCls}-header,
            > ${componentCls}-body,
            > ${componentCls}-summary
          `]: {
                        '> table': {
                            // ============================= Cell =============================
                            [`
                > thead > tr > th,
                > thead > tr > td,
                > tbody > tr > th,
                > tbody > tr > td,
                > tfoot > tr > th,
                > tfoot > tr > td
              `]: {
                                borderInlineEnd: tableBorder
                            },
                            // ============================ Header ============================
                            '> thead': {
                                '> tr:not(:last-child) > th': {
                                    borderBottom: tableBorder
                                },
                                '> tr > th::before': {
                                    backgroundColor: 'transparent !important'
                                }
                            },
                            // Fixed right should provides additional border
                            [`
                > thead > tr,
                > tbody > tr,
                > tfoot > tr
              `]: {
                                [`> ${componentCls}-cell-fix-right-first::after`]: {
                                    borderInlineEnd: tableBorder
                                }
                            },
                            // ========================== Expandable ==========================
                            [`
                > tbody > tr > th,
                > tbody > tr > td
              `]: {
                                [`> ${componentCls}-expanded-row-fixed`]: {
                                    margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal())} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(calc(tablePaddingHorizontal).add(lineWidth)).mul(-1).equal())}`,
                                    '&::after': {
                                        position: 'absolute',
                                        top: 0,
                                        insetInlineEnd: lineWidth,
                                        bottom: 0,
                                        borderInlineEnd: tableBorder,
                                        content: '""'
                                    }
                                }
                            }
                        }
                    }
                },
                // ============================ Scroll ============================
                [`&${componentCls}-scroll-horizontal`]: {
                    [`> ${componentCls}-container > ${componentCls}-body`]: {
                        '> table > tbody': {
                            [`
                > tr${componentCls}-expanded-row,
                > tr${componentCls}-placeholder
              `]: {
                                '> th, > td': {
                                    borderInlineEnd: 0
                                }
                            }
                        }
                    }
                },
                // ============================ Size ============================
                ...getSizeBorderStyle('middle', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle),
                ...getSizeBorderStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall),
                // ============================ Footer ============================
                [`> ${componentCls}-footer`]: {
                    border: tableBorder,
                    borderTop: 0
                }
            },
            // ============================ Nested ============================
            [`${componentCls}-cell`]: {
                [`${componentCls}-container:first-child`]: {
                    // :first-child to avoid the case when bordered and title is set
                    borderTop: 0
                },
                // https://github.com/ant-design/ant-design/issues/35577
                '&-scrollbar:not([rowspan])': {
                    boxShadow: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${tableHeaderBg}`
                }
            },
            [`${componentCls}-bordered ${componentCls}-cell-scrollbar`]: {
                borderInlineEnd: tableBorder
            }
        }
    };
};
var $ec35b3ce33ed358a$export$2e2bcd8739ae039 = $ec35b3ce33ed358a$var$genBorderedStyle;



const $873afba772138fbe$var$genEllipsisStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-cell-ellipsis`]: {
                ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
                wordBreak: 'keep-all',
                // Fixed first or last should special process
                [`
          &${componentCls}-cell-fix-start-shadow,
          &${componentCls}-cell-fix-end-shadow
        `]: {
                    overflow: 'visible',
                    [`${componentCls}-cell-content`]: {
                        ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
                        display: 'block'
                    }
                },
                [`${componentCls}-column-title`]: {
                    ...(0, $945cb0d2b7017a11$export$b2b65df0d0824629),
                    wordBreak: 'keep-all'
                }
            }
        }
    };
};
var $873afba772138fbe$export$2e2bcd8739ae039 = $873afba772138fbe$var$genEllipsisStyle;


// ========================= Placeholder ==========================
const $fa9126501ac2a700$var$genEmptyStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-tbody > tr${componentCls}-placeholder`]: {
                textAlign: 'center',
                color: token.colorTextDisabled,
                [`
          &:hover > th,
          &:hover > td,
        `]: {
                    background: token.colorBgContainer
                }
            }
        }
    };
};
var $fa9126501ac2a700$export$2e2bcd8739ae039 = $fa9126501ac2a700$var$genEmptyStyle;




const $a7accc1a822aafe8$var$genExpandStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, motionDurationSlow: motionDurationSlow, lineWidth: lineWidth, paddingXS: paddingXS, lineType: lineType, tableBorderColor: tableBorderColor, tableExpandIconBg: tableExpandIconBg, tableExpandColumnWidth: tableExpandColumnWidth, borderRadius: borderRadius, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, tableExpandedRowBg: tableExpandedRowBg, paddingXXS: paddingXXS, expandIconMarginTop: expandIconMarginTop, expandIconSize: expandIconSize, expandIconHalfInner: expandIconHalfInner, expandIconScale: expandIconScale, calc: calc } = token;
    const tableBorder = `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const expandIconLineOffset = calc(paddingXXS).sub(lineWidth).equal();
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-expand-icon-col`]: {
                width: tableExpandColumnWidth
            },
            [`${componentCls}-row-expand-icon-cell`]: {
                textAlign: 'center',
                [`${componentCls}-row-expand-icon`]: {
                    display: 'inline-flex',
                    float: 'none',
                    verticalAlign: 'sub'
                }
            },
            [`${componentCls}-row-indent`]: {
                height: 1,
                float: 'left'
            },
            [`${componentCls}-row-expand-icon`]: {
                ...(0, $945cb0d2b7017a11$export$9a16e7694a707ab4)(token),
                position: 'relative',
                float: 'left',
                width: expandIconSize,
                height: expandIconSize,
                color: 'inherit',
                lineHeight: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(expandIconSize),
                background: tableExpandIconBg,
                border: tableBorder,
                borderRadius: borderRadius,
                transform: `scale(${expandIconScale})`,
                '&:focus, &:hover, &:active': {
                    borderColor: 'currentcolor'
                },
                '&::before, &::after': {
                    position: 'absolute',
                    background: 'currentcolor',
                    transition: `transform ${motionDurationSlow} ease-out`,
                    content: '""'
                },
                '&::before': {
                    top: expandIconHalfInner,
                    insetInlineEnd: expandIconLineOffset,
                    insetInlineStart: expandIconLineOffset,
                    height: lineWidth
                },
                '&::after': {
                    top: expandIconLineOffset,
                    bottom: expandIconLineOffset,
                    insetInlineStart: expandIconHalfInner,
                    width: lineWidth,
                    transform: 'rotate(90deg)'
                },
                // Motion effect
                '&-collapsed::before': {
                    transform: 'rotate(-180deg)'
                },
                '&-collapsed::after': {
                    transform: 'rotate(0deg)'
                },
                '&-spaced': {
                    '&::before, &::after': {
                        display: 'none',
                        content: 'none'
                    },
                    background: 'transparent',
                    border: 0,
                    visibility: 'hidden'
                }
            },
            [`${componentCls}-row-indent + ${componentCls}-row-expand-icon`]: {
                marginTop: expandIconMarginTop,
                marginInlineEnd: paddingXS
            },
            [`tr${componentCls}-expanded-row`]: {
                '&, &:hover': {
                    '> th, > td': {
                        background: tableExpandedRowBg
                    }
                },
                // https://github.com/ant-design/ant-design/issues/25573
                [`${antCls}-descriptions-view`]: {
                    display: 'flex',
                    table: {
                        flex: 'auto',
                        width: '100%'
                    }
                }
            },
            // With fixed
            [`${componentCls}-expanded-row-fixed`]: {
                position: 'relative',
                margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal())} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tablePaddingHorizontal)}`
            }
        }
    };
};
var $a7accc1a822aafe8$export$2e2bcd8739ae039 = $a7accc1a822aafe8$var$genExpandStyle;




const $45db5a2cb456a1e7$var$genFilterStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, tableFilterDropdownWidth: tableFilterDropdownWidth, tableFilterDropdownSearchWidth: tableFilterDropdownSearchWidth, paddingXXS: paddingXXS, paddingXS: paddingXS, colorText: colorText, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, headerIconColor: headerIconColor, fontSizeSM: fontSizeSM, tablePaddingHorizontal: tablePaddingHorizontal, borderRadius: borderRadius, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorPrimary: colorPrimary, tableHeaderFilterActiveBg: tableHeaderFilterActiveBg, colorTextDisabled: colorTextDisabled, tableFilterDropdownBg: tableFilterDropdownBg, tableFilterDropdownHeight: tableFilterDropdownHeight, controlItemBgHover: controlItemBgHover, controlItemBgActive: controlItemBgActive, boxShadowSecondary: boxShadowSecondary, filterDropdownMenuBg: filterDropdownMenuBg, calc: calc } = token;
    const dropdownPrefixCls = `${antCls}-dropdown`;
    const tableFilterDropdownPrefixCls = `${componentCls}-filter-dropdown`;
    const treePrefixCls = `${antCls}-tree`;
    const tableBorder = `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return [
        {
            [`${componentCls}-wrapper`]: {
                [`${componentCls}-filter-column`]: {
                    display: 'flex',
                    justifyContent: 'space-between'
                },
                [`${componentCls}-filter-trigger`]: {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    marginBlock: calc(paddingXXS).mul(-1).equal(),
                    marginInline: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXXS)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(tablePaddingHorizontal).div(2).mul(-1).equal())}`,
                    padding: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXXS)}`,
                    color: headerIconColor,
                    fontSize: fontSizeSM,
                    borderRadius: borderRadius,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}`,
                    '&:hover': {
                        color: colorIcon,
                        background: tableHeaderFilterActiveBg
                    },
                    '&.active': {
                        color: colorPrimary
                    }
                }
            }
        },
        {
            // Dropdown
            [`${antCls}-dropdown`]: {
                [tableFilterDropdownPrefixCls]: {
                    ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                    minWidth: tableFilterDropdownWidth,
                    backgroundColor: tableFilterDropdownBg,
                    borderRadius: borderRadius,
                    boxShadow: boxShadowSecondary,
                    overflow: 'hidden',
                    // Reset menu
                    [`${dropdownPrefixCls}-menu`]: {
                        // https://github.com/ant-design/ant-design/issues/4916
                        // https://github.com/ant-design/ant-design/issues/19542
                        maxHeight: tableFilterDropdownHeight,
                        overflowX: 'hidden',
                        border: 0,
                        boxShadow: 'none',
                        borderRadius: 'unset',
                        backgroundColor: filterDropdownMenuBg,
                        '&:empty::after': {
                            display: 'block',
                            padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)} 0`,
                            color: colorTextDisabled,
                            fontSize: fontSizeSM,
                            textAlign: 'center',
                            content: '"Not Found"'
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-tree`]: {
                        paddingBlock: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)} 0`,
                        paddingInline: paddingXS,
                        [treePrefixCls]: {
                            padding: 0
                        },
                        [`${treePrefixCls}-treenode ${treePrefixCls}-node-content-wrapper:hover`]: {
                            backgroundColor: controlItemBgHover
                        },
                        [`${treePrefixCls}-treenode-checkbox-checked ${treePrefixCls}-node-content-wrapper`]: {
                            '&, &:hover': {
                                backgroundColor: controlItemBgActive
                            }
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-search`]: {
                        padding: paddingXS,
                        borderBottom: tableBorder,
                        '&-input': {
                            input: {
                                minWidth: tableFilterDropdownSearchWidth
                            },
                            [iconCls]: {
                                color: colorTextDisabled
                            }
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-checkall`]: {
                        width: '100%',
                        marginBottom: paddingXXS,
                        marginInlineStart: paddingXXS
                    },
                    // Operation
                    [`${tableFilterDropdownPrefixCls}-btns`]: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(paddingXS).sub(lineWidth).equal())} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingXS)}`,
                        overflow: 'hidden',
                        borderTop: tableBorder
                    }
                }
            }
        },
        // Dropdown Menu & SubMenu
        {
            // submenu of table filter dropdown
            [`${antCls}-dropdown ${tableFilterDropdownPrefixCls}, ${tableFilterDropdownPrefixCls}-submenu`]: {
                // Checkbox
                [`${antCls}-checkbox-wrapper + span`]: {
                    paddingInlineStart: paddingXS,
                    color: colorText
                },
                '> ul': {
                    maxHeight: 'calc(100vh - 130px)',
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }
            }
        }
    ];
};
var $45db5a2cb456a1e7$export$2e2bcd8739ae039 = $45db5a2cb456a1e7$var$genFilterStyle;


function $ab5d0f30b41f144b$export$a16fd84c5da6565a({ colorSplit: shadowColor }) {
    const leftShadowStyle = {
        boxShadow: `inset 10px 0 8px -8px ${shadowColor}`
    };
    const rightShadowStyle = {
        boxShadow: `inset -10px 0 8px -8px ${shadowColor}`
    };
    return [
        leftShadowStyle,
        rightShadowStyle
    ];
}
const $ab5d0f30b41f144b$var$genFixedStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, motionDurationSlow: motionDurationSlow, zIndexTableFixed: zIndexTableFixed, tableBg: tableBg, calc: calc } = token;
    const cellCls = `${componentCls}-cell`;
    const fixCellCls = `${cellCls}-fix`;
    const sharedShadowStyle = {
        position: 'absolute',
        top: 0,
        bottom: calc(lineWidth).mul(-1).equal(),
        width: 30,
        transition: `box-shadow ${motionDurationSlow}`,
        content: '""',
        pointerEvents: 'none'
    };
    const [leftShadowStyle, rightShadowStyle] = $ab5d0f30b41f144b$export$a16fd84c5da6565a(token);
    // Follow style is magic of shadow which should not follow token:
    return {
        [`${componentCls}-wrapper`]: {
            // ====================== Cell ======================
            [`${cellCls}${fixCellCls}`]: {
                position: 'sticky'
            },
            [fixCellCls]: {
                zIndex: `calc(var(--z-offset-reverse) + ${zIndexTableFixed})`,
                background: tableBg,
                '&:after': sharedShadowStyle,
                // Position
                '&-start:after': {
                    insetInlineStart: '100%'
                },
                '&-end:after': {
                    insetInlineEnd: '100%'
                },
                // visible
                '&-start-shadow-show:after': leftShadowStyle,
                '&-end-shadow-show:after': rightShadowStyle
            },
            // =================== Container ====================
            [`${componentCls}-container`]: {
                position: 'relative',
                '&:before, &:after': {
                    ...sharedShadowStyle,
                    zIndex: `calc(var(--columns-count) * 2 + ${zIndexTableFixed} + 1)`
                },
                '&:before': {
                    insetInlineStart: 0
                },
                '&:after': {
                    insetInlineEnd: 0
                }
            },
            [`${componentCls}-has-fix-start ${componentCls}-container:before`]: {
                display: 'none'
            },
            [`${componentCls}-has-fix-end ${componentCls}-container:after`]: {
                display: 'none'
            },
            [`${componentCls}-fix-start-shadow-show ${componentCls}-container:before`]: leftShadowStyle,
            [`${componentCls}-fix-end-shadow-show ${componentCls}-container:after`]: rightShadowStyle
        }
    };
};
var $ab5d0f30b41f144b$export$2e2bcd8739ae039 = $ab5d0f30b41f144b$var$genFixedStyle;



const $902be1b1ba38ff75$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, margin: margin } = token;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Pagination ==========================
            [`${componentCls}-pagination${antCls}-pagination`]: {
                margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(margin)} 0`
            },
            [`${componentCls}-pagination`]: {
                display: 'flex',
                flexWrap: 'wrap',
                rowGap: token.paddingXS,
                '> *': {
                    flex: 'none'
                },
                '&-start': {
                    justifyContent: 'flex-start'
                },
                '&-center': {
                    justifyContent: 'center'
                },
                '&-end': {
                    justifyContent: 'flex-end'
                }
            }
        }
    };
};
var $902be1b1ba38ff75$export$2e2bcd8739ae039 = $902be1b1ba38ff75$var$genPaginationStyle;



const $ea077e93f1ef47a8$var$genRadiusStyle = (token)=>{
    const { componentCls: componentCls, tableRadius: tableRadius } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [componentCls]: {
                // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
                [`${componentCls}-title, ${componentCls}-header`]: {
                    borderRadius: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tableRadius)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tableRadius)} 0 0`
                },
                [`${componentCls}-title + ${componentCls}-container`]: {
                    borderStartStartRadius: 0,
                    borderStartEndRadius: 0,
                    // https://github.com/ant-design/ant-design/issues/41975
                    [`${componentCls}-header, table`]: {
                        borderRadius: 0
                    },
                    'table > thead > tr:first-child': {
                        'th:first-child, th:last-child, td:first-child, td:last-child': {
                            borderRadius: 0
                        }
                    }
                },
                '&-container': {
                    borderStartStartRadius: tableRadius,
                    borderStartEndRadius: tableRadius,
                    'table > thead > tr:first-child': {
                        '> *:first-child': {
                            borderStartStartRadius: tableRadius
                        },
                        '> *:last-child': {
                            borderStartEndRadius: tableRadius
                        }
                    }
                },
                '&-footer': {
                    borderRadius: `0 0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tableRadius)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tableRadius)}`
                }
            }
        }
    };
};
var $ea077e93f1ef47a8$export$2e2bcd8739ae039 = $ea077e93f1ef47a8$var$genRadiusStyle;



const $9b2130585e5769ff$var$genStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const [leftShadowStyle, rightShadowStyle] = (0, $ab5d0f30b41f144b$export$a16fd84c5da6565a)(token);
    return {
        [`${componentCls}-wrapper-rtl`]: {
            direction: 'rtl',
            table: {
                direction: 'rtl'
            },
            [`${componentCls}-row-expand-icon`]: {
                float: 'right',
                '&::after': {
                    transform: 'rotate(-90deg)'
                },
                '&-collapsed::before': {
                    transform: 'rotate(180deg)'
                },
                '&-collapsed::after': {
                    transform: 'rotate(0deg)'
                }
            },
            // ====================== Cell ======================
            [`${componentCls}-cell-fix`]: {
                '&-start-shadow-show:after': rightShadowStyle,
                '&-end-shadow-show:after': leftShadowStyle
            },
            // =================== Container ====================
            [`${componentCls}-container`]: {
                [`${componentCls}-row-indent`]: {
                    float: 'right'
                }
            },
            [`${componentCls}-fix-start-shadow-show ${componentCls}-container:before`]: rightShadowStyle,
            [`${componentCls}-fix-end-shadow-show ${componentCls}-container:after`]: leftShadowStyle
        }
    };
};
var $9b2130585e5769ff$export$2e2bcd8739ae039 = $9b2130585e5769ff$var$genStyle;



const $4eb555a5bbc376ef$var$genSelectionStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, fontSizeIcon: fontSizeIcon, padding: padding, paddingXS: paddingXS, headerIconColor: headerIconColor, headerIconHoverColor: headerIconHoverColor, tableSelectionColumnWidth: tableSelectionColumnWidth, tableSelectedRowBg: tableSelectedRowBg, tableSelectedRowHoverBg: tableSelectedRowHoverBg, tableRowHoverBg: tableRowHoverBg, tablePaddingHorizontal: tablePaddingHorizontal, calc: calc } = token;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Selections ==========================
            [`${componentCls}-selection-col`]: {
                width: tableSelectionColumnWidth,
                [`&${componentCls}-selection-col-with-dropdown`]: {
                    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).equal()
                }
            },
            [`${componentCls}-bordered ${componentCls}-selection-col`]: {
                width: calc(tableSelectionColumnWidth).add(calc(paddingXS).mul(2)).equal(),
                [`&${componentCls}-selection-col-with-dropdown`]: {
                    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).add(calc(paddingXS).mul(2)).equal()
                }
            },
            [`
        table tr th${componentCls}-selection-column,
        table tr td${componentCls}-selection-column,
        ${componentCls}-selection-column
      `]: {
                paddingInlineEnd: token.paddingXS,
                paddingInlineStart: token.paddingXS,
                textAlign: 'center',
                [`${antCls}-radio-wrapper`]: {
                    marginInlineEnd: 0
                }
            },
            [`table tr th${componentCls}-selection-column${componentCls}-cell-fix-left`]: {
                zIndex: calc(token.zIndexTableFixed).add(1).equal({
                    unit: false
                })
            },
            [`table tr th${componentCls}-selection-column::after`]: {
                backgroundColor: 'transparent !important'
            },
            [`${componentCls}-selection`]: {
                position: 'relative',
                display: 'inline-flex',
                flexDirection: 'column'
            },
            [`${componentCls}-selection-extra`]: {
                position: 'absolute',
                top: 0,
                zIndex: 1,
                cursor: 'pointer',
                transition: `all ${token.motionDurationSlow}`,
                marginInlineStart: '100%',
                paddingInlineStart: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(tablePaddingHorizontal).div(4).equal()),
                [iconCls]: {
                    color: headerIconColor,
                    fontSize: fontSizeIcon,
                    verticalAlign: 'baseline',
                    '&:hover': {
                        color: headerIconHoverColor
                    }
                }
            },
            // ============================= Rows =============================
            [`${componentCls}-tbody`]: {
                [`${componentCls}-row`]: {
                    [`&${componentCls}-row-selected`]: {
                        [`> ${componentCls}-cell`]: {
                            background: tableSelectedRowBg,
                            '&-row-hover': {
                                background: tableSelectedRowHoverBg
                            }
                        }
                    },
                    [`> ${componentCls}-cell-row-hover`]: {
                        background: tableRowHoverBg
                    }
                }
            }
        }
    };
};
var $4eb555a5bbc376ef$export$2e2bcd8739ae039 = $4eb555a5bbc376ef$var$genSelectionStyle;



const $515bcff98fb64782$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, tableExpandColumnWidth: tableExpandColumnWidth, calc: calc } = token;
    const getSizeStyle = (size, paddingVertical, paddingHorizontal, fontSize)=>({
            [`${componentCls}${componentCls}-${size}`]: {
                fontSize: fontSize,
                [`
        ${componentCls}-title,
        ${componentCls}-footer,
        ${componentCls}-cell,
        ${componentCls}-thead > tr > th,
        ${componentCls}-tbody > tr > th,
        ${componentCls}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
                    padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingVertical)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(paddingHorizontal)}`
                },
                [`${componentCls}-filter-trigger`]: {
                    marginInlineEnd: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(paddingHorizontal).div(2).mul(-1).equal())
                },
                [`${componentCls}-expanded-row-fixed`]: {
                    margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal())} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(paddingHorizontal).mul(-1).equal())}`
                },
                [`${componentCls}-tbody`]: {
                    // ========================= Nest Table ===========================
                    [`${componentCls}-wrapper:only-child ${componentCls}`]: {
                        marginBlock: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal()),
                        marginInline: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(tableExpandColumnWidth).sub(paddingHorizontal).equal())} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(paddingHorizontal).mul(-1).equal())}`
                    }
                },
                // https://github.com/ant-design/ant-design/issues/35167
                [`${componentCls}-selection-extra`]: {
                    paddingInlineStart: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(paddingHorizontal).div(4).equal())
                }
            }
        });
    return {
        [`${componentCls}-wrapper`]: {
            ...getSizeStyle('middle', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle, token.tableFontSizeMiddle),
            ...getSizeStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall, token.tableFontSizeSmall)
        }
    };
};
var $515bcff98fb64782$export$2e2bcd8739ae039 = $515bcff98fb64782$var$genSizeStyle;


const $0e0754ba8468997b$var$genSorterStyle = (token)=>{
    const { componentCls: componentCls, marginXXS: marginXXS, fontSizeIcon: fontSizeIcon, headerIconColor: headerIconColor, headerIconHoverColor: headerIconHoverColor } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-thead th${componentCls}-column-has-sorters`]: {
                outline: 'none',
                cursor: 'pointer',
                // why left 0s? Avoid column header move with transition when left is changed
                // https://github.com/ant-design/ant-design/issues/50588
                transition: `all ${token.motionDurationSlow}, left 0s`,
                '&:hover': {
                    background: token.tableHeaderSortHoverBg,
                    '&::before': {
                        backgroundColor: 'transparent !important'
                    }
                },
                '&:focus-visible': {
                    color: token.colorPrimary
                },
                // https://github.com/ant-design/ant-design/issues/30969
                [`
          &${componentCls}-cell-fix-left:hover,
          &${componentCls}-cell-fix-right:hover
        `]: {
                    background: token.tableFixedHeaderSortActiveBg
                }
            },
            [`${componentCls}-thead th${componentCls}-column-sort`]: {
                background: token.tableHeaderSortBg,
                '&::before': {
                    backgroundColor: 'transparent !important'
                }
            },
            [`td${componentCls}-column-sort`]: {
                background: token.tableBodySortBg
            },
            [`${componentCls}-column-title`]: {
                position: 'relative',
                zIndex: 1,
                flex: 1,
                minWidth: 0
            },
            [`${componentCls}-column-sorters`]: {
                display: 'flex',
                flex: 'auto',
                alignItems: 'center',
                justifyContent: 'space-between',
                '&::after': {
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    content: '""'
                }
            },
            [`${componentCls}-column-sorters-tooltip-target-sorter`]: {
                '&::after': {
                    content: 'none'
                }
            },
            [`${componentCls}-column-sorter`]: {
                marginInlineStart: marginXXS,
                color: headerIconColor,
                fontSize: 0,
                transition: `color ${token.motionDurationSlow}`,
                '&-inner': {
                    display: 'inline-flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                },
                '&-up, &-down': {
                    fontSize: fontSizeIcon,
                    '&.active': {
                        color: token.colorPrimary
                    }
                },
                [`${componentCls}-column-sorter-up + ${componentCls}-column-sorter-down`]: {
                    marginTop: '-0.3em'
                }
            },
            [`${componentCls}-column-sorters:hover ${componentCls}-column-sorter`]: {
                color: headerIconHoverColor
            }
        }
    };
};
var $0e0754ba8468997b$export$2e2bcd8739ae039 = $0e0754ba8468997b$var$genSorterStyle;



const $210768d814cb2ec6$var$genStickyStyle = (token)=>{
    const { componentCls: componentCls, opacityLoading: opacityLoading, tableScrollThumbBg: tableScrollThumbBg, tableScrollThumbBgHover: tableScrollThumbBgHover, tableScrollThumbSize: tableScrollThumbSize, tableScrollBg: tableScrollBg, stickyScrollBarBorderRadius: stickyScrollBarBorderRadius, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, zIndexTableFixed: zIndexTableFixed } = token;
    const tableBorder = `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-sticky`]: {
                '&-holder': {
                    position: 'sticky',
                    zIndex: `calc(var(--columns-count) * 2 + ${zIndexTableFixed} + 1)`,
                    background: token.colorBgContainer
                },
                '&-scroll': {
                    position: 'sticky',
                    bottom: 0,
                    height: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tableScrollThumbSize)} !important`,
                    zIndex: `calc(var(--columns-count) * 2 + ${zIndexTableFixed} + 1)`,
                    display: 'flex',
                    alignItems: 'center',
                    background: tableScrollBg,
                    borderTop: tableBorder,
                    opacity: opacityLoading,
                    '&:hover': {
                        transformOrigin: 'center bottom'
                    },
                    // fake scrollbar style of sticky
                    '&-bar': {
                        height: tableScrollThumbSize,
                        backgroundColor: tableScrollThumbBg,
                        borderRadius: stickyScrollBarBorderRadius,
                        transition: `all ${token.motionDurationSlow}, transform 0s`,
                        position: 'absolute',
                        bottom: 0,
                        '&:hover, &-active': {
                            backgroundColor: tableScrollThumbBgHover
                        }
                    }
                }
            }
        }
    };
};
var $210768d814cb2ec6$export$2e2bcd8739ae039 = $210768d814cb2ec6$var$genStickyStyle;



const $83aefcef421de04e$var$genSummaryStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, tableBorderColor: tableBorderColor, calc: calc } = token;
    const tableBorder = `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${token.lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-summary`]: {
                position: 'relative',
                zIndex: token.zIndexTableFixed,
                background: token.tableBg,
                '> tr': {
                    '> th, > td': {
                        borderBottom: tableBorder
                    }
                }
            },
            [`div${componentCls}-summary`]: {
                boxShadow: `0 ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(lineWidth).mul(-1).equal())} 0 ${tableBorderColor}`
            }
        }
    };
};
var $83aefcef421de04e$export$2e2bcd8739ae039 = $83aefcef421de04e$var$genSummaryStyle;



const $48671f1a812f0828$var$genVirtualStyle = (token)=>{
    const { componentCls: componentCls, motionDurationMid: motionDurationMid, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, calc: calc } = token;
    const tableBorder = `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const rowCellCls = `${componentCls}-expanded-row-cell`;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Row ==========================
            [`${componentCls}-tbody-virtual`]: {
                [`${componentCls}-tbody-virtual-holder-inner`]: {
                    [`
            & > ${componentCls}-row, 
            & > div:not(${componentCls}-row) > ${componentCls}-row
          `]: {
                        display: 'flex',
                        boxSizing: 'border-box',
                        width: '100%'
                    }
                },
                [`${componentCls}-cell`]: {
                    borderBottom: tableBorder,
                    transition: `background ${motionDurationMid}`
                },
                [`${componentCls}-expanded-row`]: {
                    [`${rowCellCls}${rowCellCls}-fixed`]: {
                        position: 'sticky',
                        insetInlineStart: 0,
                        overflow: 'hidden',
                        width: `calc(var(--virtual-width) - ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)})`,
                        borderInlineEnd: 'none'
                    }
                }
            },
            // ======================== Border =========================
            [`${componentCls}-bordered`]: {
                [`${componentCls}-tbody-virtual`]: {
                    '&:after': {
                        content: '""',
                        insetInline: 0,
                        bottom: 0,
                        borderBottom: tableBorder,
                        position: 'absolute'
                    },
                    [`${componentCls}-cell`]: {
                        borderInlineEnd: tableBorder,
                        [`&${componentCls}-cell-fix-right-first:before`]: {
                            content: '""',
                            position: 'absolute',
                            insetBlock: 0,
                            insetInlineStart: calc(lineWidth).mul(-1).equal(),
                            borderInlineStart: tableBorder
                        }
                    }
                },
                // Empty placeholder
                [`&${componentCls}-virtual`]: {
                    [`${componentCls}-placeholder ${componentCls}-cell`]: {
                        borderInlineEnd: tableBorder,
                        borderBottom: tableBorder
                    }
                }
            }
        }
    };
};
var $48671f1a812f0828$export$2e2bcd8739ae039 = $48671f1a812f0828$var$genVirtualStyle;


const $46e200be8a051710$var$genTableStyle = (token)=>{
    const { componentCls: componentCls, fontWeightStrong: fontWeightStrong, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, tableExpandColumnWidth: tableExpandColumnWidth, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, tableFontSize: tableFontSize, tableBg: tableBg, tableRadius: tableRadius, tableHeaderTextColor: tableHeaderTextColor, motionDurationMid: motionDurationMid, tableHeaderBg: tableHeaderBg, tableHeaderCellSplitColor: tableHeaderCellSplitColor, tableFooterTextColor: tableFooterTextColor, tableFooterBg: tableFooterBg, calc: calc } = token;
    const tableBorder = `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            clear: 'both',
            maxWidth: '100%',
            // fix https://github.com/ant-design/ant-design/issues/46177
            ['--rc-virtual-list-scrollbar-bg']: token.tableScrollBg,
            ...(0, $945cb0d2b7017a11$export$8c467e8859fdef13)(),
            [componentCls]: {
                ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
                fontSize: tableFontSize,
                background: tableBg,
                borderRadius: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tableRadius)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tableRadius)} 0 0`,
                // https://github.com/ant-design/ant-design/issues/47486
                scrollbarColor: `${token.tableScrollThumbBg} ${token.tableScrollBg}`
            },
            // https://github.com/ant-design/ant-design/issues/17611
            table: {
                width: '100%',
                textAlign: 'start',
                borderRadius: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tableRadius)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tableRadius)} 0 0`,
                borderCollapse: 'separate',
                borderSpacing: 0
            },
            // ============================= Cell ==============================
            [`
          ${componentCls}-cell,
          ${componentCls}-thead > tr > th,
          ${componentCls}-tbody > tr > th,
          ${componentCls}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
                position: 'relative',
                padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tablePaddingHorizontal)}`,
                overflowWrap: 'break-word'
            },
            // ============================ Title =============================
            [`${componentCls}-title`]: {
                padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tablePaddingHorizontal)}`
            },
            // ============================ Header ============================
            [`${componentCls}-thead`]: {
                [`
          > tr > th,
          > tr > td
        `]: {
                    position: 'relative',
                    color: tableHeaderTextColor,
                    fontWeight: fontWeightStrong,
                    textAlign: 'start',
                    background: tableHeaderBg,
                    borderBottom: tableBorder,
                    transition: `background ${motionDurationMid} ease`,
                    "&[colspan]:not([colspan='1'])": {
                        textAlign: 'center'
                    },
                    [`&:not(:last-child):not(${componentCls}-selection-column):not(${componentCls}-row-expand-icon-cell):not([colspan])::before`]: {
                        position: 'absolute',
                        top: '50%',
                        insetInlineEnd: 0,
                        width: 1,
                        height: '1.6em',
                        backgroundColor: tableHeaderCellSplitColor,
                        transform: 'translateY(-50%)',
                        transition: `background-color ${motionDurationMid}`,
                        content: '""'
                    }
                },
                '> tr:not(:last-child) > th[colspan]': {
                    borderBottom: 0
                }
            },
            // ============================ Body ============================
            [`${componentCls}-tbody`]: {
                '> tr': {
                    '> th, > td': {
                        transition: `background ${motionDurationMid}, border-color ${motionDurationMid}`,
                        borderBottom: tableBorder,
                        // ========================= Nest Table ===========================
                        [`
              > ${componentCls}-wrapper:only-child,
              > ${componentCls}-expanded-row-fixed > ${componentCls}-wrapper:only-child
            `]: {
                            [componentCls]: {
                                marginBlock: (0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal()),
                                marginInline: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(tableExpandColumnWidth).sub(tablePaddingHorizontal).equal())}
                ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                                [`${componentCls}-tbody > tr:last-child > td`]: {
                                    borderBottomWidth: 0,
                                    '&:first-child, &:last-child': {
                                        borderRadius: 0
                                    }
                                }
                            }
                        }
                    },
                    '> th': {
                        position: 'relative',
                        color: tableHeaderTextColor,
                        fontWeight: fontWeightStrong,
                        textAlign: 'start',
                        background: tableHeaderBg,
                        borderBottom: tableBorder,
                        transition: `background ${motionDurationMid} ease`
                    },
                    // measure cell styles
                    [`& > ${componentCls}-measure-cell`]: {
                        paddingBlock: `0 !important`,
                        borderBlock: `0 !important`,
                        [`${componentCls}-measure-cell-content`]: {
                            height: 0,
                            overflow: 'hidden',
                            pointerEvents: 'none'
                        }
                    }
                }
            },
            // ============================ Footer ============================
            [`${componentCls}-footer`]: {
                padding: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(tablePaddingHorizontal)}`,
                color: tableFooterTextColor,
                background: tableFooterBg
            }
        }
    };
};
const $46e200be8a051710$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillAlter: colorFillAlter, colorBgContainer: colorBgContainer, colorTextHeading: colorTextHeading, colorFillSecondary: colorFillSecondary, colorFillContent: colorFillContent, controlItemBgActive: controlItemBgActive, controlItemBgActiveHover: controlItemBgActiveHover, padding: padding, paddingSM: paddingSM, paddingXS: paddingXS, colorBorderSecondary: colorBorderSecondary, borderRadiusLG: borderRadiusLG, controlHeight: controlHeight, colorTextPlaceholder: colorTextPlaceholder, fontSize: fontSize, fontSizeSM: fontSizeSM, lineHeight: lineHeight, lineWidth: lineWidth, colorIcon: colorIcon, colorIconHover: colorIconHover, opacityLoading: opacityLoading, controlInteractiveSize: controlInteractiveSize } = token;
    const colorFillSecondarySolid = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(colorFillSecondary).onBackground(colorBgContainer).toHexString();
    const colorFillContentSolid = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(colorFillContent).onBackground(colorBgContainer).toHexString();
    const colorFillAlterSolid = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(colorFillAlter).onBackground(colorBgContainer).toHexString();
    const baseColorAction = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(colorIcon);
    const baseColorActionHover = new (0, $bafdd58c7fe9c8d0$export$2c4f38d6c0ecc25a)(colorIconHover);
    const expandIconHalfInner = controlInteractiveSize / 2 - lineWidth;
    const expandIconSize = expandIconHalfInner * 2 + lineWidth * 3;
    return {
        headerBg: colorFillAlterSolid,
        headerColor: colorTextHeading,
        headerSortActiveBg: colorFillSecondarySolid,
        headerSortHoverBg: colorFillContentSolid,
        bodySortBg: colorFillAlterSolid,
        rowHoverBg: colorFillAlterSolid,
        rowSelectedBg: controlItemBgActive,
        rowSelectedHoverBg: controlItemBgActiveHover,
        rowExpandedBg: colorFillAlter,
        cellPaddingBlock: padding,
        cellPaddingInline: padding,
        cellPaddingBlockMD: paddingSM,
        cellPaddingInlineMD: paddingXS,
        cellPaddingBlockSM: paddingXS,
        cellPaddingInlineSM: paddingXS,
        borderColor: colorBorderSecondary,
        headerBorderRadius: borderRadiusLG,
        footerBg: colorFillAlterSolid,
        footerColor: colorTextHeading,
        cellFontSize: fontSize,
        cellFontSizeMD: fontSize,
        cellFontSizeSM: fontSize,
        headerSplitColor: colorBorderSecondary,
        fixedHeaderSortActiveBg: colorFillSecondarySolid,
        headerFilterHoverBg: colorFillContent,
        filterDropdownMenuBg: colorBgContainer,
        filterDropdownBg: colorBgContainer,
        expandIconBg: colorBgContainer,
        selectionColumnWidth: controlHeight,
        stickyScrollBarBg: colorTextPlaceholder,
        stickyScrollBarBorderRadius: 100,
        expandIconMarginTop: (fontSize * lineHeight - lineWidth * 3) / 2 - Math.ceil((fontSizeSM * 1.4 - lineWidth * 3) / 2),
        headerIconColor: baseColorAction.clone().setA(baseColorAction.a * opacityLoading).toRgbString(),
        headerIconHoverColor: baseColorActionHover.clone().setA(baseColorActionHover.a * opacityLoading).toRgbString(),
        expandIconHalfInner: expandIconHalfInner,
        expandIconSize: expandIconSize,
        expandIconScale: controlInteractiveSize / expandIconSize
    };
};
const $46e200be8a051710$var$zIndexTableFixed = 2;
var // ============================== Export ==============================
$46e200be8a051710$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Table', (token)=>{
    const { colorTextHeading: colorTextHeading, colorSplit: colorSplit, colorBgContainer: colorBgContainer, controlInteractiveSize: checkboxSize, headerBg: headerBg, headerColor: headerColor, headerSortActiveBg: headerSortActiveBg, headerSortHoverBg: headerSortHoverBg, bodySortBg: bodySortBg, rowHoverBg: rowHoverBg, rowSelectedBg: rowSelectedBg, rowSelectedHoverBg: rowSelectedHoverBg, rowExpandedBg: rowExpandedBg, cellPaddingBlock: cellPaddingBlock, cellPaddingInline: cellPaddingInline, cellPaddingBlockMD: cellPaddingBlockMD, cellPaddingInlineMD: cellPaddingInlineMD, cellPaddingBlockSM: cellPaddingBlockSM, cellPaddingInlineSM: cellPaddingInlineSM, borderColor: borderColor, footerBg: footerBg, footerColor: footerColor, headerBorderRadius: headerBorderRadius, cellFontSize: cellFontSize, cellFontSizeMD: cellFontSizeMD, cellFontSizeSM: cellFontSizeSM, headerSplitColor: headerSplitColor, fixedHeaderSortActiveBg: fixedHeaderSortActiveBg, headerFilterHoverBg: headerFilterHoverBg, filterDropdownBg: filterDropdownBg, expandIconBg: expandIconBg, selectionColumnWidth: selectionColumnWidth, stickyScrollBarBg: stickyScrollBarBg, calc: calc } = token;
    const tableToken = (0, $a8ae4dfe7c8ed6db$export$4950aa0f605343fb)(token, {
        tableFontSize: cellFontSize,
        tableBg: colorBgContainer,
        tableRadius: headerBorderRadius,
        tablePaddingVertical: cellPaddingBlock,
        tablePaddingHorizontal: cellPaddingInline,
        tablePaddingVerticalMiddle: cellPaddingBlockMD,
        tablePaddingHorizontalMiddle: cellPaddingInlineMD,
        tablePaddingVerticalSmall: cellPaddingBlockSM,
        tablePaddingHorizontalSmall: cellPaddingInlineSM,
        tableBorderColor: borderColor,
        tableHeaderTextColor: headerColor,
        tableHeaderBg: headerBg,
        tableFooterTextColor: footerColor,
        tableFooterBg: footerBg,
        tableHeaderCellSplitColor: headerSplitColor,
        tableHeaderSortBg: headerSortActiveBg,
        tableHeaderSortHoverBg: headerSortHoverBg,
        tableBodySortBg: bodySortBg,
        tableFixedHeaderSortActiveBg: fixedHeaderSortActiveBg,
        tableHeaderFilterActiveBg: headerFilterHoverBg,
        tableFilterDropdownBg: filterDropdownBg,
        tableRowHoverBg: rowHoverBg,
        tableSelectedRowBg: rowSelectedBg,
        tableSelectedRowHoverBg: rowSelectedHoverBg,
        zIndexTableFixed: $46e200be8a051710$var$zIndexTableFixed,
        tableFontSizeMiddle: cellFontSizeMD,
        tableFontSizeSmall: cellFontSizeSM,
        tableSelectionColumnWidth: selectionColumnWidth,
        tableExpandIconBg: expandIconBg,
        tableExpandColumnWidth: calc(checkboxSize).add(calc(token.padding).mul(2)).equal(),
        tableExpandedRowBg: rowExpandedBg,
        // Dropdown
        tableFilterDropdownWidth: 120,
        tableFilterDropdownHeight: 264,
        tableFilterDropdownSearchWidth: 140,
        // Virtual Scroll Bar
        tableScrollThumbSize: 8,
        // Mac scroll bar size
        tableScrollThumbBg: stickyScrollBarBg,
        tableScrollThumbBgHover: colorTextHeading,
        tableScrollBg: colorSplit
    });
    return [
        $46e200be8a051710$var$genTableStyle(tableToken),
        (0, $902be1b1ba38ff75$export$2e2bcd8739ae039)(tableToken),
        (0, $83aefcef421de04e$export$2e2bcd8739ae039)(tableToken),
        (0, $0e0754ba8468997b$export$2e2bcd8739ae039)(tableToken),
        (0, $45db5a2cb456a1e7$export$2e2bcd8739ae039)(tableToken),
        (0, $ec35b3ce33ed358a$export$2e2bcd8739ae039)(tableToken),
        (0, $ea077e93f1ef47a8$export$2e2bcd8739ae039)(tableToken),
        (0, $a7accc1a822aafe8$export$2e2bcd8739ae039)(tableToken),
        (0, $83aefcef421de04e$export$2e2bcd8739ae039)(tableToken),
        (0, $fa9126501ac2a700$export$2e2bcd8739ae039)(tableToken),
        (0, $4eb555a5bbc376ef$export$2e2bcd8739ae039)(tableToken),
        (0, $ab5d0f30b41f144b$export$2e2bcd8739ae039)(tableToken),
        (0, $210768d814cb2ec6$export$2e2bcd8739ae039)(tableToken),
        (0, $873afba772138fbe$export$2e2bcd8739ae039)(tableToken),
        (0, $515bcff98fb64782$export$2e2bcd8739ae039)(tableToken),
        (0, $9b2130585e5769ff$export$2e2bcd8739ae039)(tableToken),
        (0, $48671f1a812f0828$export$2e2bcd8739ae039)(tableToken)
    ];
}, $46e200be8a051710$export$9ca1be8807fe0675, {
    unitless: {
        expandIconScale: true
    }
});


"use client";
const $00e656142858a9b0$var$EMPTY_LIST = [];
const $00e656142858a9b0$var$InternalTable = (props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, classNames: classNames, styles: styles, size: customizeSize, bordered: bordered, dropdownPrefixCls: customizeDropdownPrefixCls, dataSource: dataSource, pagination: pagination, rowSelection: rowSelection, rowKey: customizeRowKey, rowClassName: rowClassName, columns: columns, children: children, childrenColumnName: legacyChildrenColumnName, onChange: onChange, getPopupContainer: getPopupContainer, loading: loading, expandIcon: expandIcon, expandable: expandable, expandedRowRender: expandedRowRender, expandIconColumnIndex: expandIconColumnIndex, indentSize: indentSize, scroll: scroll, sortDirections: sortDirections, locale: locale, showSorterTooltip: showSorterTooltip = {
        target: 'full-header'
    }, virtual: virtual } = props;
    const warning = (0, $9530c27c700696d0$export$cf977aa92c751e61)('Table');
    const baseColumns = $ltGt3.useMemo(()=>columns || (0, $d2518e2a43538dac$export$d87a97eba44e0f9c)(children), [
        columns,
        children
    ]);
    const needResponsive = $ltGt3.useMemo(()=>baseColumns.some((col)=>col.responsive), [
        baseColumns
    ]);
    const screens = (0, $ec3b57b710702d4d$export$2e2bcd8739ae039)(needResponsive);
    const mergedColumns = $ltGt3.useMemo(()=>{
        const matched = new Set(Object.keys(screens).filter((m)=>screens[m]));
        return baseColumns.filter((c)=>!c.responsive || c.responsive.some((r)=>matched.has(r)));
    }, [
        baseColumns,
        screens
    ]);
    const tableProps = (0, $ce9e10bdc01e86dc$export$2e2bcd8739ae039)(props, [
        'className',
        'style',
        'columns'
    ]);
    const { locale: contextLocale = (0, $29f4f00e8825a41b$export$2e2bcd8739ae039), table: table } = $ltGt3.useContext((0, $d13451568443aeb8$export$a92f85ab3e9ad68b));
    const { getPrefixCls: getPrefixCls, direction: direction, renderEmpty: renderEmpty, getPopupContainer: getContextPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('table');
    const mergedSize = (0, $7bb31c172903861d$export$2e2bcd8739ae039)(customizeSize);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        bordered: bordered
    };
    const [mergedClassNames, mergedStyles] = (0, $859a31e79ed756e5$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        pagination: {
            _default: 'root'
        },
        header: {
            _default: 'wrapper'
        },
        body: {
            _default: 'wrapper'
        }
    });
    const tableLocale = {
        ...contextLocale.Table,
        ...locale
    };
    const [globalLocale] = (0, $8bb479a5dbe8bc5c$export$2e2bcd8739ae039)('global', (0, $29f4f00e8825a41b$export$2e2bcd8739ae039).global);
    const rawData = dataSource || $00e656142858a9b0$var$EMPTY_LIST;
    const prefixCls = getPrefixCls('table', customizePrefixCls);
    const dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
    const [, token] = (0, $42a04fd86d13249e$export$2e2bcd8739ae039)();
    const rootCls = (0, $7422cbcd731d5b67$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $46e200be8a051710$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mergedExpandable = {
        childrenColumnName: legacyChildrenColumnName,
        expandIconColumnIndex: expandIconColumnIndex,
        ...expandable,
        expandIcon: expandable?.expandIcon ?? table?.expandable?.expandIcon
    };
    const { childrenColumnName: childrenColumnName = 'children' } = mergedExpandable;
    const expandType = $ltGt3.useMemo(()=>{
        if (rawData.some((item)=>item?.[childrenColumnName])) return 'nest';
        if (expandedRowRender || expandable?.expandedRowRender) return 'row';
        return null;
    }, [
        childrenColumnName,
        rawData
    ]);
    const internalRefs = {
        body: $ltGt3.useRef(null)
    };
    // ============================ Width =============================
    const getContainerWidth = (0, $14b7b313d9bf7845$export$2e2bcd8739ae039)(prefixCls);
    // ============================= Refs =============================
    const rootRef = $ltGt3.useRef(null);
    const tblRef = $ltGt3.useRef(null);
    (0, $419ec1eb7c226115$export$8edbe0145ad77a36)(ref, ()=>({
            ...tblRef.current,
            nativeElement: rootRef.current
        }));
    // ============================ RowKey ============================
    const rowKey = customizeRowKey || table?.rowKey || 'key';
    const getRowKey = $ltGt3.useMemo(()=>{
        if (typeof rowKey === 'function') return rowKey;
        return (record)=>record?.[rowKey];
    }, [
        rowKey
    ]);
    const [getRecordByKey] = (0, $e510d0c3c7177ff8$export$2e2bcd8739ae039)(rawData, childrenColumnName, getRowKey);
    // ============================ Events =============================
    const changeEventInfo = {};
    const triggerOnChange = (info, action, reset = false)=>{
        const changeInfo = {
            ...changeEventInfo,
            ...info
        };
        if (reset) {
            changeEventInfo.resetPagination?.();
            // Reset event param
            if (changeInfo.pagination?.current) changeInfo.pagination.current = 1;
            // Trigger pagination events
            if (pagination) pagination.onChange?.(1, changeInfo.pagination?.pageSize);
        }
        if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRefs.body.current) (0, $85a964b764a2b7f9$export$2e2bcd8739ae039)(0, {
            getContainer: ()=>internalRefs.body.current
        });
        onChange?.(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
            currentDataSource: (0, $27eeb92c49e83bd8$export$37643bb40f4c1c56)((0, $11e1b20a1cf2ab5b$export$594b2c8da4a70ee)(rawData, changeInfo.sorterStates, childrenColumnName), changeInfo.filterStates, childrenColumnName),
            action: action
        });
    };
    /**
   * Controlled state in `columns` is not a good idea that makes too many code (1000+ line?) to read
   * state out and then put it back to title render. Move these code into `hooks` but still too
   * complex. We should provides Table props like `sorter` & `filter` to handle control in next big
   * version.
   */ // ============================ Sorter =============================
    const onSorterChange = (sorter, sorterStates)=>{
        triggerOnChange({
            sorter: sorter,
            sorterStates: sorterStates
        }, 'sort', false);
    };
    const [transformSorterColumns, sortStates, sorterTitleProps, getSorters] = (0, $11e1b20a1cf2ab5b$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        mergedColumns: mergedColumns,
        onSorterChange: onSorterChange,
        sortDirections: sortDirections || [
            'ascend',
            'descend'
        ],
        tableLocale: tableLocale,
        showSorterTooltip: showSorterTooltip,
        globalLocale: globalLocale
    });
    const sortedData = $ltGt3.useMemo(()=>(0, $11e1b20a1cf2ab5b$export$594b2c8da4a70ee)(rawData, sortStates, childrenColumnName), [
        childrenColumnName,
        rawData,
        sortStates
    ]);
    changeEventInfo.sorter = getSorters();
    changeEventInfo.sorterStates = sortStates;
    // ============================ Filter ============================
    const onFilterChange = (filters, filterStates)=>{
        triggerOnChange({
            filters: filters,
            filterStates: filterStates
        }, 'filter', true);
    };
    const [transformFilterColumns, filterStates, filters] = (0, $27eeb92c49e83bd8$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        locale: tableLocale,
        dropdownPrefixCls: dropdownPrefixCls,
        mergedColumns: mergedColumns,
        onFilterChange: onFilterChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        rootClassName: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(rootClassName, rootCls)
    });
    const mergedData = (0, $27eeb92c49e83bd8$export$37643bb40f4c1c56)(sortedData, filterStates, childrenColumnName);
    changeEventInfo.filters = filters;
    changeEventInfo.filterStates = filterStates;
    // ============================ Column ============================
    const columnTitleProps = $ltGt3.useMemo(()=>{
        const mergedFilters = {};
        Object.keys(filters).forEach((filterKey)=>{
            if (filters[filterKey] !== null) mergedFilters[filterKey] = filters[filterKey];
        });
        return {
            ...sorterTitleProps,
            filters: mergedFilters
        };
    }, [
        sorterTitleProps,
        filters
    ]);
    const [transformTitleColumns] = (0, $b72755658fb492cf$export$2e2bcd8739ae039)(columnTitleProps);
    // ========================== Pagination ==========================
    const onPaginationChange = (current, pageSize)=>{
        triggerOnChange({
            pagination: {
                ...changeEventInfo.pagination,
                current: current,
                pageSize: pageSize
            }
        }, 'paginate');
    };
    const [mergedPagination, resetPagination] = (0, $1beaf17c90985ea4$export$2e2bcd8739ae039)(mergedData.length, onPaginationChange, pagination);
    changeEventInfo.pagination = pagination === false ? {} : (0, $1beaf17c90985ea4$export$27eceeed7bf0f4c2)(mergedPagination, pagination);
    changeEventInfo.resetPagination = resetPagination;
    // ============================= Data =============================
    const pageData = $ltGt3.useMemo(()=>{
        if (pagination === false || !mergedPagination.pageSize) return mergedData;
        const { current: current = 1, total: total, pageSize: pageSize = (0, $1beaf17c90985ea4$export$5716e8bcb003888d) } = mergedPagination;
        // Dynamic table data
        if (mergedData.length < total) {
            if (mergedData.length > pageSize) return mergedData.slice((current - 1) * pageSize, current * pageSize);
            return mergedData;
        }
        return mergedData.slice((current - 1) * pageSize, current * pageSize);
    }, [
        !!pagination,
        mergedData,
        mergedPagination?.current,
        mergedPagination?.pageSize,
        mergedPagination?.total
    ]);
    // ========================== Selections ==========================
    const [transformSelectionColumns, selectedKeySet] = (0, $6123fa3b01478a1b$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        data: mergedData,
        pageData: pageData,
        getRowKey: getRowKey,
        getRecordByKey: getRecordByKey,
        expandType: expandType,
        childrenColumnName: childrenColumnName,
        locale: tableLocale,
        getPopupContainer: getPopupContainer || getContextPopupContainer
    }, rowSelection);
    const internalRowClassName = (record, index, indent)=>{
        const resolvedRowClassName = typeof rowClassName === 'function' ? rowClassName(record, index, indent) : rowClassName;
        return (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
            [`${prefixCls}-row-selected`]: selectedKeySet.has(getRowKey(record, index))
        }, resolvedRowClassName);
    };
    // ========================== Expandable ==========================
    // Pass origin render status into `@rc-component/table`, this can be removed when refactor with `@rc-component/table`
    mergedExpandable.__PARENT_RENDER_ICON__ = mergedExpandable.expandIcon;
    // Customize expandable icon
    mergedExpandable.expandIcon = mergedExpandable.expandIcon || expandIcon || (0, $d828521527a4e705$export$2e2bcd8739ae039)(tableLocale);
    // Adjust expand icon index, no overwrite expandIconColumnIndex if set.
    if (expandType === 'nest' && mergedExpandable.expandIconColumnIndex === undefined) mergedExpandable.expandIconColumnIndex = rowSelection ? 1 : 0;
    else if (mergedExpandable.expandIconColumnIndex > 0 && rowSelection) mergedExpandable.expandIconColumnIndex -= 1;
    // Indent size
    if (typeof mergedExpandable.indentSize !== 'number') mergedExpandable.indentSize = typeof indentSize === 'number' ? indentSize : 15;
    // ============================ Render ============================
    const transformColumns = $ltGt3.useCallback((innerColumns)=>transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(innerColumns)))), [
        transformSorterColumns,
        transformFilterColumns,
        transformSelectionColumns
    ]);
    let topPaginationNode;
    let bottomPaginationNode;
    if (pagination !== false && mergedPagination?.total) {
        let paginationSize;
        if (mergedPagination.size) paginationSize = mergedPagination.size;
        else paginationSize = mergedSize === 'small' || mergedSize === 'middle' ? 'small' : undefined;
        const renderPagination = (placement = 'end')=>/*#__PURE__*/ $ltGt3.createElement((0, $ba6ccffd2ae02ebb$export$2e2bcd8739ae039), {
                ...mergedPagination,
                classNames: mergedClassNames.pagination,
                styles: mergedStyles.pagination,
                className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(`${prefixCls}-pagination ${prefixCls}-pagination-${placement}`, mergedPagination.className),
                size: paginationSize
            });
        const { placement: placement, position: position } = mergedPagination;
        const mergedPlacement = placement ?? position;
        const normalizePlacement = (pos)=>{
            const lowerPos = pos.toLowerCase();
            if (lowerPos.includes('center')) return 'center';
            return lowerPos.includes('left') || lowerPos.includes('start') ? 'start' : 'end';
        };
        if (Array.isArray(mergedPlacement)) {
            const [topPos, bottomPos] = [
                'top',
                'bottom'
            ].map((dir)=>mergedPlacement.find((p)=>p.includes(dir)));
            const isDisable = mergedPlacement.every((p)=>`${p}` === 'none');
            if (!topPos && !bottomPos && !isDisable) bottomPaginationNode = renderPagination();
            if (topPos) topPaginationNode = renderPagination(normalizePlacement(topPos));
            if (bottomPos) bottomPaginationNode = renderPagination(normalizePlacement(bottomPos));
        } else bottomPaginationNode = renderPagination();
    }
    // >>>>>>>>> Spinning
    const spinProps = $ltGt3.useMemo(()=>{
        if (typeof loading === 'boolean') return {
            spinning: loading
        };
        else if (typeof loading === 'object' && loading !== null) return {
            spinning: true,
            ...loading
        };
        else return undefined;
    }, [
        loading
    ]);
    const wrappercls = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(cssVarCls, rootCls, `${prefixCls}-wrapper`, contextClassName, {
        [`${prefixCls}-wrapper-rtl`]: direction === 'rtl'
    }, className, rootClassName, mergedClassNames.root, hashId);
    const mergedStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    // ========== empty ==========
    const mergedEmptyNode = $ltGt3.useMemo(()=>{
        // When dataSource is null/undefined (detected by reference equality with EMPTY_LIST),
        // and the table is in a loading state, we only show the loading spinner without the empty placeholder.
        // For empty arrays (datasource={[]}), both loading and empty states would normally be shown.
        // discussion https://github.com/ant-design/ant-design/issues/54601#issuecomment-3158091383
        if (spinProps?.spinning && rawData === $00e656142858a9b0$var$EMPTY_LIST) return null;
        if (typeof locale?.emptyText !== 'undefined') return locale.emptyText;
        return renderEmpty?.('Table') || /*#__PURE__*/ $ltGt3.createElement((0, $48027d4a9fb402d4$export$2e2bcd8739ae039), {
            componentName: "Table"
        });
    }, [
        spinProps?.spinning,
        rawData,
        locale?.emptyText,
        renderEmpty
    ]);
    // ========================== Render ==========================
    const TableComponent = virtual ? (0, $c3f70cb43f9f7cd6$export$2e2bcd8739ae039) : (0, $1bf997e2285a78cc$export$2e2bcd8739ae039);
    // >>> Virtual Table props. We set height here since it will affect height collection
    const virtualProps = {};
    const listItemHeight = $ltGt3.useMemo(()=>{
        const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, padding: padding, paddingXS: paddingXS, paddingSM: paddingSM } = token;
        const fontHeight = Math.floor(fontSize * lineHeight);
        switch(mergedSize){
            case 'middle':
                return paddingSM * 2 + fontHeight + lineWidth;
            case 'small':
                return paddingXS * 2 + fontHeight + lineWidth;
            default:
                return padding * 2 + fontHeight + lineWidth;
        }
    }, [
        token,
        mergedSize
    ]);
    if (virtual) virtualProps.listItemHeight = listItemHeight;
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        ref: rootRef,
        className: wrappercls,
        style: mergedStyle
    }, /*#__PURE__*/ $ltGt3.createElement((0, $f5e177132d6f3f0f$export$2e2bcd8739ae039), {
        spinning: false,
        ...spinProps
    }, topPaginationNode, /*#__PURE__*/ $ltGt3.createElement(TableComponent, {
        ...virtualProps,
        ...tableProps,
        classNames: mergedClassNames,
        styles: mergedStyles,
        ref: tblRef,
        columns: mergedColumns,
        direction: direction,
        expandable: mergedExpandable,
        prefixCls: prefixCls,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)({
            [`${prefixCls}-middle`]: mergedSize === 'middle',
            [`${prefixCls}-small`]: mergedSize === 'small',
            [`${prefixCls}-bordered`]: bordered,
            [`${prefixCls}-empty`]: rawData.length === 0
        }, cssVarCls, rootCls, hashId),
        data: pageData,
        rowKey: getRowKey,
        rowClassName: internalRowClassName,
        emptyText: mergedEmptyNode,
        // Internal
        internalHooks: (0, $4ba85974d660b691$export$91b75cf262680225),
        internalRefs: internalRefs,
        transformColumns: transformColumns,
        getContainerWidth: getContainerWidth,
        measureRowRender: (measureRow)=>/*#__PURE__*/ $ltGt3.createElement((0, $3f88559997256af7$export$2e2bcd8739ae039), {
                getPopupContainer: (node)=>node
            }, measureRow)
    }), bottomPaginationNode));
};
var $00e656142858a9b0$export$2e2bcd8739ae039 = /*#__PURE__*/ $ltGt3.forwardRef($00e656142858a9b0$var$InternalTable);


"use client";
const $b28ee72a5726dd5d$var$Table = (props, ref)=>{
    const renderTimesRef = $ltGt3.useRef(0);
    renderTimesRef.current += 1;
    return /*#__PURE__*/ $ltGt3.createElement((0, $00e656142858a9b0$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        _renderTimes: renderTimesRef.current
    });
};
const $b28ee72a5726dd5d$var$ForwardTable = /*#__PURE__*/ $ltGt3.forwardRef($b28ee72a5726dd5d$var$Table);
$b28ee72a5726dd5d$var$ForwardTable.SELECTION_COLUMN = (0, $6123fa3b01478a1b$export$ed10248435b8f218);
$b28ee72a5726dd5d$var$ForwardTable.EXPAND_COLUMN = (0, $4ba85974d660b691$export$e1053575ddfcb301);
$b28ee72a5726dd5d$var$ForwardTable.SELECTION_ALL = (0, $6123fa3b01478a1b$export$14159cd9e2a500c8);
$b28ee72a5726dd5d$var$ForwardTable.SELECTION_INVERT = (0, $6123fa3b01478a1b$export$625c4f68eaaf8cfd);
$b28ee72a5726dd5d$var$ForwardTable.SELECTION_NONE = (0, $6123fa3b01478a1b$export$c1a725540f5a63bd);
$b28ee72a5726dd5d$var$ForwardTable.Column = (0, $96df4e82291bed2e$export$2e2bcd8739ae039);
$b28ee72a5726dd5d$var$ForwardTable.ColumnGroup = (0, $66ec4bd99f8d6372$export$2e2bcd8739ae039);
$b28ee72a5726dd5d$var$ForwardTable.Summary = (0, $9267102c2ff8aee5$export$d605f3af09eef683);
var $b28ee72a5726dd5d$export$2e2bcd8739ae039 = $b28ee72a5726dd5d$var$ForwardTable;


"use client";
var $78bdab97c3b51c4b$export$2e2bcd8739ae039 = (0, $b28ee72a5726dd5d$export$2e2bcd8739ae039);



var $ltGt3 = parcelRequire("ltGt3");





function $8b808d063eaa0654$export$86bf0b152bae8da8({ plants: plants, isLoading: isLoading, getPlantLink: getPlantLink, parentRoute: parentRoute, newPlantRoute: newPlantRoute }) {
    const [isOpenForm, setIsOpenForm] = (0, $ltGt3.useState)(false);
    const [currentPlant, setCurrentPlant] = (0, $ltGt3.useState)(null);
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const { projectNames: projectNames } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('root');
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const { setMousePosition: setMousePosition } = (0, $a97af2bd258d22ad$export$30c58b43fa91b94d)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const columns = [
        {
            title: intl.formatMessage({
                id: 'name'
            }),
            key: 'name',
            render: (plant)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                            to: getPlantLink(plant),
                            onClick: (e)=>setMousePosition({
                                    x: e.pageX,
                                    y: e.pageY
                                }),
                            children: plant.name
                        }),
                        plant.plantBaseId && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                "(",
                                plant.fields["\u041E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"],
                                plant.fields["\u0421\u043E\u0440\u0442_eng"] || plant.fields["\u0421\u043E\u0440\u0442_ru"] ? ` ${plant.fields["\u0421\u043E\u0440\u0442_eng"]}` ? ` ${plant.fields["\u0421\u043E\u0440\u0442_eng"]}` : ` ${plant.fields["\u0421\u043E\u0440\u0442_ru"]}` : '',
                                ")"
                            ]
                        })
                    ]
                })
        },
        {
            title: intl.formatMessage({
                id: 'dateOfPlanting'
            }),
            dataIndex: 'dateOfPlantingUtc',
            key: 'dateOfPlantingUtc',
            render: (value)=>value ? String(value) : ''
        },
        // {
        //   title: intl.formatMessage({id: 'description'}),
        //   dataIndex: 'description',
        //   key: 'description',
        // },
        {
            title: intl.formatMessage({
                id: 'collections'
            }),
            dataIndex: 'collections',
            key: 'collections',
            render: (value)=>{
                if (value.length >= 1) return value.map((collection)=>collection.name).join(', ');
            }
        },
        {
            title: intl.formatMessage({
                id: 'project'
            }),
            dataIndex: 'projectName',
            key: 'projectName',
            render: (projectName, plant)=>plant.gardenPlanVariantName ? `${projectName} (${plant.gardenPlanVariantName})` : projectName
        },
        {
            title: intl.formatMessage({
                id: 'comment'
            }),
            dataIndex: 'comment',
            key: 'comment'
        }
    ];
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $78bdab97c3b51c4b$export$2e2bcd8739ae039), {
                id: "plants-table",
                onRow: (plant)=>({
                        onClick: (e)=>{
                            setMousePosition({
                                x: e.pageX,
                                y: e.pageY
                            });
                            navigate(getPlantLink(plant) + location.search);
                        }
                    }),
                rowClassName: "plants-table-row",
                rowKey: "id",
                dataSource: plants.filter((plant)=>{
                    if (!plant.isPlantDeleted) return {
                        ...plant,
                        key: plant.id
                    };
                }),
                columns: columns,
                loading: isLoading,
                pagination: false,
                scroll: {
                    x: 'max-content'
                }
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7c982b663463d13d$export$9037afc3347b6505), {
                routeWhenClosed: parentRoute + location.search
            })
        ]
    });
}





parcelRequire("ltGt3");






var $ltGt3 = parcelRequire("ltGt3");
function $e85cdb7458afb6af$export$a973cef5093a8d22({ loadMore: loadMore, hasMore: hasMore, items: items, rootMargin: rootMargin = 200 }) {
    const sentinelRef = (0, $ltGt3.useRef)(null);
    const loadMoreRef = (0, $ltGt3.useRef)(loadMore);
    loadMoreRef.current = loadMore;
    (0, $ltGt3.useEffect)(()=>{
        const el = sentinelRef.current;
        if (!el) return;
        const observer = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting) loadMoreRef.current?.();
        }, {
            rootMargin: `${rootMargin}px`
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, [
        rootMargin
    ]);
    (0, $ltGt3.useEffect)(()=>{
        if (!hasMore) return;
        const el = sentinelRef.current;
        if (!el) return;
        const triggerZoneBottom = window.innerHeight + rootMargin;
        if (el.getBoundingClientRect().top <= triggerZoneBottom) loadMoreRef.current?.();
    }, [
        items,
        hasMore,
        rootMargin
    ]);
    return sentinelRef;
}





parcelRequire("ltGt3");

const { Meta: $ae4f7d1e2e806571$var$Meta } = (0, $ad1c3304c519fac5$export$2e2bcd8739ae039);
function $ae4f7d1e2e806571$export$45ba68a69de774e4({ photo: photo, sun: sun, watering: watering, name: name, description: description }) {
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ad1c3304c519fac5$export$2e2bcd8739ae039), {
        className: "plant-card",
        hoverable: true,
        style: {
            width: 300,
            minHeight: 200,
            margin: 10,
            height: '100%'
        },
        cover: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
            style: {
                width: 300,
                height: 200,
                objectFit: 'cover'
            },
            alt: "image",
            src: photo
        }),
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($ae4f7d1e2e806571$var$Meta, {
            title: name,
            description: description
        })
    });
}


function $959ccd62a460e059$export$19c34617cb9a7080({ plants: plants, getPlantLink: getPlantLink, parentRoute: parentRoute, loadMore: loadMore, hasMore: hasMore, isLoadingMore: isLoadingMore }) {
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const sentinelRef = (0, $e85cdb7458afb6af$export$a973cef5093a8d22)({
        loadMore: loadMore,
        hasMore: hasMore,
        items: plants
    });
    const { value: plantTitlePhotos, isLoading: plantPhotoLoading, error: error } = (0, $1e104381209dd9b4$export$78a72ddb39bdd145)([], async ()=>{
        return await Promise.all(plants.map(async (plant)=>({
                plantId: plant.id,
                plantTitlePhoto: await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getTitlePlantPhoto(plant.titlePhotoName, plant.photos[0])
            })));
    }, [
        plants
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "plants__list",
                children: plants.map((plant, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("a", {
                        className: "plants__list__link",
                        onClick: ()=>{
                            //setIsOpenForm(true)
                            //setcurrentPlant(plant)
                            navigate(getPlantLink(plant));
                        },
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ae4f7d1e2e806571$export$45ba68a69de774e4), {
                            photo: plantTitlePhotos[index]?.plantTitlePhoto,
                            sun: 0,
                            watering: 0,
                            name: plant.name,
                            description: plant.plantBaseId ? `${plant.fields["\u041E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"]} ${plant.fields["\u0421\u043E\u0440\u0442_eng"] || plant.fields["\u0421\u043E\u0440\u0442_ru"] ? ` ${plant.fields["\u0421\u043E\u0440\u0442_eng"]}` ? ` ${plant.fields["\u0421\u043E\u0440\u0442_eng"]}` : ` ${plant.fields["\u0421\u043E\u0440\u0442_ru"]}` : ''}` : ''
                        })
                    }, index))
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                ref: sentinelRef
            }),
            isLoadingMore && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '20px'
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f5e177132d6f3f0f$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7c982b663463d13d$export$9037afc3347b6505), {
                routeWhenClosed: parentRoute
            })
        ]
    });
}



parcelRequire("ltGt3");









var $Ohofd = parcelRequire("Ohofd");
const $daec8bf9c9ed5832$var$FALLBACK_COLORS = [
    'rgb(160, 122, 108)',
    'rgb(245, 129, 83)',
    'rgb(53, 171, 151)',
    'rgb(154, 83, 245)'
];
function $daec8bf9c9ed5832$var$collectionColor(collection) {
    return collection.color || $daec8bf9c9ed5832$var$FALLBACK_COLORS[collection.id % $daec8bf9c9ed5832$var$FALLBACK_COLORS.length];
}
function $daec8bf9c9ed5832$export$8bd6654a6c34d0a0({ plants: plants, getPlantLink: getPlantLink, parentRoute: parentRoute, loadMore: loadMore, hasMore: hasMore, isLoadingMore: isLoadingMore }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const location = (0, $493cbc5b00d91baa$export$45d76561a5302f2b)();
    const sentinelRef = (0, $e85cdb7458afb6af$export$a973cef5093a8d22)({
        loadMore: loadMore,
        hasMore: hasMore,
        items: plants
    });
    const { value: plantTitlePhotos } = (0, $1e104381209dd9b4$export$78a72ddb39bdd145)([], async ()=>Promise.all(plants.map(async (plant)=>({
                plantId: plant.id,
                url: await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getTitlePlantPhoto(plant.titlePhotoName, plant.photos?.[0])
            }))), [
        plants
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "plants-card-list",
        children: [
            plants.map((plant, index)=>{
                const f = plant.fields || {};
                const photo = plantTitlePhotos[index]?.url;
                const hasPhoto = !!(plant.titlePhotoName || plant.photos?.[0]);
                const primaryName = f["\u041E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"] || plant.name;
                return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "plants-card-list__item",
                    onClick: ()=>navigate(getPlantLink(plant) + location.search),
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            className: "plants-card-list__photo",
                            children: hasPhoto ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                                src: photo,
                                alt: plant.name
                            }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "plants-card-list__photo-placeholder",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("svg", {
                                    width: "240",
                                    height: "160",
                                    viewBox: "0 0 240 160",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    role: "img",
                                    "aria-labelledby": "title desc",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("g", {
                                            opacity: "0.95",
                                            stroke: "#6F8F72",
                                            strokeWidth: "2.3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: [
                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("path", {
                                                    d: "M96 118h48",
                                                    opacity: "0.35"
                                                }),
                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("path", {
                                                    d: "M101 91h38l-5.5 29h-27L101 91Z",
                                                    fill: "#E7EFE3"
                                                }),
                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("path", {
                                                    d: "M120 91V48"
                                                }),
                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("path", {
                                                    d: "M120 69c-10.5-8-19-9.5-28-6 3.5 9.5 13.5 14.5 28 6Z",
                                                    fill: "#DDEBDC"
                                                }),
                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("path", {
                                                    d: "M121 58c9.5-10 18-13 28-10-1.5 11-12.5 18.5-28 10Z",
                                                    fill: "#DDEBDC"
                                                }),
                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("path", {
                                                    d: "M119 47c-7-8-8.5-17-4.5-26 9 4 12.5 14.5 4.5 26Z",
                                                    fill: "#DDEBDC"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("defs", {
                                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("linearGradient", {
                                                id: "bg",
                                                x1: "22",
                                                y1: "12",
                                                x2: "221",
                                                y2: "147",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("stop", {
                                                        stopColor: "#F6F8F1"
                                                    }),
                                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("stop", {
                                                        offset: "0.55",
                                                        stopColor: "#EEF5EA"
                                                    }),
                                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("stop", {
                                                        offset: "1",
                                                        stopColor: "#FAF6ED"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "plants-card-list__info",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "plants-card-list__title",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                            className: "plants-card-list__title__name",
                                            children: [
                                                plant.name,
                                                plant.gardenPlanVariantId && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                                                    placement: "bottom",
                                                    title: intl.formatMessage({
                                                        id: 'plantFromGardenPlan'
                                                    }),
                                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                                        className: "plants-card-list__garden-plan-tag",
                                                        color: "gold",
                                                        children: intl.formatMessage({
                                                            id: 'gardenPlanTag'
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        plant.dateOfPlantingUtc && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $450c77e4cd681750$export$2e2bcd8739ae039), {
                                            color: "white",
                                            title: intl.formatMessage({
                                                id: 'dateOfPlanting'
                                            }),
                                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                                className: "plants-card-list__title__date",
                                                children: [
                                                    "\uD83C\uDF31 ",
                                                    (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(plant.dateOfPlantingUtc).format('ll')
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "plants-card-list__title__name",
                                    children: [
                                        f["\u041E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                            children: f["\u041E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"]
                                        }),
                                        f["\u0421\u043E\u0440\u0442"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                            className: "plants-card-list__variety",
                                            children: [
                                                " ",
                                                f["\u0421\u043E\u0440\u0442"]
                                            ]
                                        }),
                                        f["\u0423\u0442\u043E\u0447\u043D\u044F\u044E\u0449\u0430\u044F \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0430"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                            className: "plants-card-list__spec",
                                            children: [
                                                ' ',
                                                "(",
                                                f["\u0423\u0442\u043E\u0447\u043D\u044F\u044E\u0449\u0430\u044F \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0430"],
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                f["\u041D\u0430\u0443\u0447\u043D\u043E\u0435 (\u043B\u0430\u0442\u0438\u043D\u0441\u043A\u043E\u0435) \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                    className: "plants-card-list__latin",
                                    children: f["\u041D\u0430\u0443\u0447\u043D\u043E\u0435 (\u043B\u0430\u0442\u0438\u043D\u0441\u043A\u043E\u0435) \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"]
                                }),
                                f["\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F"] && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "plants-card-list__other-names",
                                    children: [
                                        intl.formatMessage({
                                            id: 'otherNames'
                                        }),
                                        ": ",
                                        f["\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F"]
                                    ]
                                }),
                                plant.collections && plant.collections.length > 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d029ee757225a242$export$2e2bcd8739ae039), {
                                    className: "plants-card-list__collections",
                                    size: [
                                        4,
                                        4
                                    ],
                                    wrap: true,
                                    children: plant.collections.map((collection)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                            color: $daec8bf9c9ed5832$var$collectionColor(collection),
                                            title: collection.name,
                                            style: {
                                                maxWidth: 180,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: collection.name
                                        }, collection.id))
                                }),
                                plant.projectId && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "plants-card-list__other-names",
                                    children: [
                                        intl.formatMessage({
                                            id: 'project'
                                        }),
                                        ": ",
                                        plant.projectName
                                    ]
                                })
                            ]
                        })
                    ]
                }, plant.id);
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                ref: sentinelRef
            }),
            isLoadingMore && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '20px',
                    gridColumn: '1 / -1'
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f5e177132d6f3f0f$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7c982b663463d13d$export$9037afc3347b6505), {
                routeWhenClosed: parentRoute + location.search
            })
        ]
    });
}







var $ltGt3 = parcelRequire("ltGt3");


var $Ohofd = parcelRequire("Ohofd");



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $1054e45af8a4564b$var$FilterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z"
                }
            }
        ]
    },
    "name": "filter",
    "theme": "outlined"
};
var $1054e45af8a4564b$export$2e2bcd8739ae039 = $1054e45af8a4564b$var$FilterOutlined;



var $805fc64935351fe7$var$FilterOutlined = function FilterOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $1054e45af8a4564b$export$2e2bcd8739ae039)
    }));
};
/**![filter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MC4xIDE1NEgxNDMuOWMtMjQuNSAwLTM5LjggMjYuNy0yNy41IDQ4TDM0OSA1OTcuNFY4MzhjMCAxNy43IDE0LjIgMzIgMzEuOCAzMmgyNjIuNGMxNy42IDAgMzEuOC0xNC4zIDMxLjgtMzJWNTk3LjRMOTA3LjcgMjAyYzEyLjItMjEuMy0zLjEtNDgtMjcuNi00OHpNNjAzLjQgNzk4SDQyMC42VjY0MmgxODIuOXYxNTZ6bTkuNi0yMzYuNmwtOS41IDE2LjZoLTE4M2wtOS41LTE2LjZMMjEyLjcgMjI2aDU5OC42TDYxMyA1NjEuNHoiIC8+PC9zdmc+) */ var $805fc64935351fe7$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($805fc64935351fe7$var$FilterOutlined);
var $805fc64935351fe7$export$2e2bcd8739ae039 = $805fc64935351fe7$var$RefIcon;



(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).extend((0, (/*@__PURE__*/$parcel$interopDefault($89358fe654dbfc1b$exports))));
const $c29bdac8aed3afcb$var$dateFormat = 'YYYY/MM/DD';
function $c29bdac8aed3afcb$export$ce4baeeb74cb909c(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const { projectNames: projectNames } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('root');
    const [open, setOpen] = (0, $ltGt3.useState)(false);
    const hasDateFilter = !!(props.filters.startPlantingDate || props.filters.endPlantingDate);
    const hasProjectsFilter = !!(props.filters.projects && props.filters.projects.length > 0);
    const hasCollectionsFilter = !!(props.filters.collections && props.filters.collections.length > 0);
    const activeCount = [
        hasDateFilter,
        hasProjectsFilter,
        hasCollectionsFilter,
        !!props.filters.hideGardenPlanVariantPlants
    ].filter(Boolean).length;
    const content = /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        className: "plants-filter__popover",
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d029ee757225a242$export$2e2bcd8739ae039), {
            direction: "vertical",
            style: {
                width: '100%'
            },
            size: "middle",
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "plants-filter__label",
                            children: [
                                intl.formatMessage({
                                    id: 'project'
                                }),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
                            mode: "multiple",
                            style: {
                                width: '100%'
                            },
                            allowClear: true,
                            value: props.filters.projects || [],
                            onChange: (value)=>props.setFilters((current)=>({
                                        ...current,
                                        projects: value
                                    })),
                            options: projectNames.map((project)=>({
                                    label: project.name,
                                    value: project.id
                                }))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "plants-filter__label",
                            children: [
                                intl.formatMessage({
                                    id: 'collections'
                                }),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
                            mode: "multiple",
                            style: {
                                width: '100%'
                            },
                            allowClear: true,
                            value: props.filters.collections || [],
                            onChange: (value)=>props.setFilters((current)=>({
                                        ...current,
                                        collections: value
                                    })),
                            options: props.userPlantCollections.map((c)=>({
                                    label: c.name,
                                    value: c.id
                                }))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "plants-filter__label",
                            children: [
                                intl.formatMessage({
                                    id: 'date'
                                }),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $878317098e859dd0$export$2e2bcd8739ae039).RangePicker, {
                            style: {
                                width: '100%'
                            },
                            allowEmpty: [
                                true,
                                true
                            ],
                            value: [
                                props.filters.startPlantingDate ? (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(props.filters.startPlantingDate) : null,
                                props.filters.endPlantingDate ? (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(props.filters.endPlantingDate) : null
                            ],
                            format: $c29bdac8aed3afcb$var$dateFormat,
                            onChange: (values)=>props.setFilters((current)=>({
                                        ...current,
                                        startPlantingDate: values?.[0]?.toDate() || null,
                                        endPlantingDate: values?.[1]?.toDate() || null
                                    })),
                            presets: [
                                {
                                    label: intl.formatMessage({
                                        id: 'lastWeek'
                                    }),
                                    value: [
                                        (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().add(-7, 'day'),
                                        (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))()
                                    ]
                                },
                                {
                                    label: intl.formatMessage({
                                        id: 'lastMonth'
                                    }),
                                    value: [
                                        (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().add(-30, 'day'),
                                        (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))()
                                    ]
                                },
                                {
                                    label: intl.formatMessage({
                                        id: 'last90days'
                                    }),
                                    value: [
                                        (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().add(-90, 'day'),
                                        (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))()
                                    ]
                                },
                                {
                                    label: intl.formatMessage({
                                        id: 'lastYear'
                                    }),
                                    value: [
                                        (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().add(-365, 'day'),
                                        (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))()
                                    ]
                                }
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                    checked: !!props.filters.hideGardenPlanVariantPlants,
                    onChange: (e)=>props.setFilters((current)=>({
                                ...current,
                                hideGardenPlanVariantPlants: e.target.checked
                            })),
                    children: intl.formatMessage({
                        id: 'hideGardenPlanVariantPlants'
                    })
                })
            ]
        })
    });
    const title = /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "plants-filter__popover-title",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                children: intl.formatMessage({
                    id: 'filtersUp'
                })
            }),
            activeCount > 0 && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("a", {
                onClick: (e)=>{
                    e.stopPropagation();
                    props.setFilters(()=>({
                            name: '',
                            projectId: undefined,
                            startPlantingDate: undefined,
                            endPlantingDate: undefined,
                            collections: undefined,
                            hideGardenPlanVariantPlants: undefined
                        }));
                },
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1e0519456d104339$export$2e2bcd8739ae039), {}),
                    " ",
                    intl.formatMessage({
                        id: 'clearFilters'
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6425aad248c6262a$export$2e2bcd8739ae039), {
        content: content,
        title: title,
        trigger: "click",
        open: open,
        onOpenChange: setOpen,
        placement: "bottomLeft",
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $805fc64935351fe7$export$2e2bcd8739ae039), {}),
            type: activeCount > 0 ? 'primary' : 'default',
            children: [
                intl.formatMessage({
                    id: 'filters'
                }),
                activeCount > 0 && ` (${activeCount})`
            ]
        })
    });
}




var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $f3a3cbbc718f0358$var$AppstoreOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z"
                }
            }
        ]
    },
    "name": "appstore",
    "theme": "outlined"
};
var $f3a3cbbc718f0358$export$2e2bcd8739ae039 = $f3a3cbbc718f0358$var$AppstoreOutlined;



var $8f860c1d180d1ba4$var$AppstoreOutlined = function AppstoreOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $f3a3cbbc718f0358$export$2e2bcd8739ae039)
    }));
};
/**![appstore](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ2NCAxNDRIMTYwYy04LjggMC0xNiA3LjItMTYgMTZ2MzA0YzAgOC44IDcuMiAxNiAxNiAxNmgzMDRjOC44IDAgMTYtNy4yIDE2LTE2VjE2MGMwLTguOC03LjItMTYtMTYtMTZ6bS01MiAyNjhIMjEyVjIxMmgyMDB2MjAwem00NTItMjY4SDU2MGMtOC44IDAtMTYgNy4yLTE2IDE2djMwNGMwIDguOCA3LjIgMTYgMTYgMTZoMzA0YzguOCAwIDE2LTcuMiAxNi0xNlYxNjBjMC04LjgtNy4yLTE2LTE2LTE2em0tNTIgMjY4SDYxMlYyMTJoMjAwdjIwMHpNNDY0IDU0NEgxNjBjLTguOCAwLTE2IDcuMi0xNiAxNnYzMDRjMCA4LjggNy4yIDE2IDE2IDE2aDMwNGM4LjggMCAxNi03LjIgMTYtMTZWNTYwYzAtOC44LTcuMi0xNi0xNi0xNnptLTUyIDI2OEgyMTJWNjEyaDIwMHYyMDB6bTQ1Mi0yNjhINTYwYy04LjggMC0xNiA3LjItMTYgMTZ2MzA0YzAgOC44IDcuMiAxNiAxNiAxNmgzMDRjOC44IDAgMTYtNy4yIDE2LTE2VjU2MGMwLTguOC03LjItMTYtMTYtMTZ6bS01MiAyNjhINjEyVjYxMmgyMDB2MjAweiIgLz48L3N2Zz4=) */ var $8f860c1d180d1ba4$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($8f860c1d180d1ba4$var$AppstoreOutlined);
var $8f860c1d180d1ba4$export$2e2bcd8739ae039 = $8f860c1d180d1ba4$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $4de42f51f234e615$var$PictureOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z"
                }
            }
        ]
    },
    "name": "picture",
    "theme": "outlined"
};
var $4de42f51f234e615$export$2e2bcd8739ae039 = $4de42f51f234e615$var$PictureOutlined;



var $408bc24c1bd8a52d$var$PictureOutlined = function PictureOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $4de42f51f234e615$export$2e2bcd8739ae039)
    }));
};
/**![picture](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNjMySDEzNnYtMzkuOWwxMzguNS0xNjQuMyAxNTAuMSAxNzhMNjU4LjEgNDg5IDg4OCA3NjEuNlY3OTJ6bTAtMTI5LjhMNjY0LjIgMzk2LjhjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDQyNC42IDY2Ni40bC0xNDQtMTcwLjdjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDEzNiA2NTIuN1YyMzJoNzUydjQzMC4yek0zMDQgNDU2YTg4IDg4IDAgMTAwLTE3NiA4OCA4OCAwIDAwMCAxNzZ6bTAtMTE2YzE1LjUgMCAyOCAxMi41IDI4IDI4cy0xMi41IDI4LTI4IDI4LTI4LTEyLjUtMjgtMjggMTIuNS0yOCAyOC0yOHoiIC8+PC9zdmc+) */ var $408bc24c1bd8a52d$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($408bc24c1bd8a52d$var$PictureOutlined);
var $408bc24c1bd8a52d$export$2e2bcd8739ae039 = $408bc24c1bd8a52d$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $e4044996e887792b$var$SortAscendingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M839.6 433.8L749 150.5a9.24 9.24 0 00-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 00-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 00-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0012.6 0l112-141.9c4.1-5.2.4-13-6.3-13z"
                }
            }
        ]
    },
    "name": "sort-ascending",
    "theme": "outlined"
};
var $e4044996e887792b$export$2e2bcd8739ae039 = $e4044996e887792b$var$SortAscendingOutlined;



var $36f7eb0e6ad26c47$var$SortAscendingOutlined = function SortAscendingOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $e4044996e887792b$export$2e2bcd8739ae039)
    }));
};
/**![sort-ascending](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzOS42IDQzMy44TDc0OSAxNTAuNWE5LjI0IDkuMjQgMCAwMC04LjktNi41aC03Ny40Yy00LjEgMC03LjYgMi42LTguOSA2LjVsLTkxLjMgMjgzLjNjLS4zLjktLjUgMS45LS41IDIuOSAwIDUuMSA0LjIgOS4zIDkuMyA5LjNoNTYuNGM0LjIgMCA3LjgtMi44IDktNi44bDE3LjUtNjEuNmg4OWwxNy4zIDYxLjVjMS4xIDQgNC44IDYuOCA5IDYuOGg2MS4yYzEgMCAxLjktLjEgMi44LS40IDIuNC0uOCA0LjMtMi40IDUuNS00LjYgMS4xLTIuMiAxLjMtNC43LjYtNy4xek02NjMuMyAzMjUuNWwzMi44LTExNi45aDYuM2wzMi4xIDExNi45aC03MS4yem0xNDMuNSA0OTIuOUg2NzcuMnYtLjRsMTMyLjYtMTg4LjljMS4xLTEuNiAxLjctMy40IDEuNy01LjR2LTM2LjRjMC01LjEtNC4yLTkuMy05LjMtOS4zaC0yMDRjLTUuMSAwLTkuMyA0LjItOS4zIDkuM3Y0M2MwIDUuMSA0LjIgOS4zIDkuMyA5LjNoMTIyLjZ2LjRMNTg3LjcgODI4LjlhOS4zNSA5LjM1IDAgMDAtMS43IDUuNHYzNi40YzAgNS4xIDQuMiA5LjMgOS4zIDkuM2gyMTEuNGM1LjEgMCA5LjMtNC4yIDkuMy05LjN2LTQzYTkuMiA5LjIgMCAwMC05LjItOS4zek00MTYgNzAyaC03NlYxNzJjMC00LjQtMy42LTgtOC04aC01NmMtNC40IDAtOCAzLjYtOCA4djUzMGgtNzZjLTYuNyAwLTEwLjUgNy44LTYuMyAxM2wxMTIgMTQxLjlhOCA4IDAgMDAxMi42IDBsMTEyLTE0MS45YzQuMS01LjIuNC0xMy02LjMtMTN6IiAvPjwvc3ZnPg==) */ var $36f7eb0e6ad26c47$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($36f7eb0e6ad26c47$var$SortAscendingOutlined);
var $36f7eb0e6ad26c47$export$2e2bcd8739ae039 = $36f7eb0e6ad26c47$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $e76336fa0e6f8532$var$SortDescendingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M839.6 433.8L749 150.5a9.24 9.24 0 00-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 00-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 00-9.2-9.3zM310.3 167.1a8 8 0 00-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z"
                }
            }
        ]
    },
    "name": "sort-descending",
    "theme": "outlined"
};
var $e76336fa0e6f8532$export$2e2bcd8739ae039 = $e76336fa0e6f8532$var$SortDescendingOutlined;



var $867e72afe7ade565$var$SortDescendingOutlined = function SortDescendingOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $e76336fa0e6f8532$export$2e2bcd8739ae039)
    }));
};
/**![sort-descending](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzOS42IDQzMy44TDc0OSAxNTAuNWE5LjI0IDkuMjQgMCAwMC04LjktNi41aC03Ny40Yy00LjEgMC03LjYgMi42LTguOSA2LjVsLTkxLjMgMjgzLjNjLS4zLjktLjUgMS45LS41IDIuOSAwIDUuMSA0LjIgOS4zIDkuMyA5LjNoNTYuNGM0LjIgMCA3LjgtMi44IDktNi44bDE3LjUtNjEuNmg4OWwxNy4zIDYxLjVjMS4xIDQgNC44IDYuOCA5IDYuOGg2MS4yYzEgMCAxLjktLjEgMi44LS40IDIuNC0uOCA0LjMtMi40IDUuNS00LjYgMS4xLTIuMiAxLjMtNC43LjYtNy4xek02NjMuMyAzMjUuNWwzMi44LTExNi45aDYuM2wzMi4xIDExNi45aC03MS4yem0xNDMuNSA0OTIuOUg2NzcuMnYtLjRsMTMyLjYtMTg4LjljMS4xLTEuNiAxLjctMy40IDEuNy01LjR2LTM2LjRjMC01LjEtNC4yLTkuMy05LjMtOS4zaC0yMDRjLTUuMSAwLTkuMyA0LjItOS4zIDkuM3Y0M2MwIDUuMSA0LjIgOS4zIDkuMyA5LjNoMTIyLjZ2LjRMNTg3LjcgODI4LjlhOS4zNSA5LjM1IDAgMDAtMS43IDUuNHYzNi40YzAgNS4xIDQuMiA5LjMgOS4zIDkuM2gyMTEuNGM1LjEgMCA5LjMtNC4yIDkuMy05LjN2LTQzYTkuMiA5LjIgMCAwMC05LjItOS4zek0zMTAuMyAxNjcuMWE4IDggMCAwMC0xMi42IDBMMTg1LjcgMzA5Yy00LjIgNS4zLS40IDEzIDYuMyAxM2g3NnY1MzBjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOFYzMjJoNzZjNi43IDAgMTAuNS03LjggNi4zLTEzbC0xMTItMTQxLjl6IiAvPjwvc3ZnPg==) */ var $867e72afe7ade565$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($867e72afe7ade565$var$SortDescendingOutlined);
var $867e72afe7ade565$export$2e2bcd8739ae039 = $867e72afe7ade565$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $2128005dd6a587ab$var$TableOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z"
                }
            }
        ]
    },
    "name": "table",
    "theme": "outlined"
};
var $2128005dd6a587ab$export$2e2bcd8739ae039 = $2128005dd6a587ab$var$TableOutlined;



var $a995787eb7d878ad$var$TableOutlined = function TableOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $2128005dd6a587ab$export$2e2bcd8739ae039)
    }));
};
/**![table](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgMjA4SDY3NlYyMzJoMjEydjEzNnptMCAyMjRINjc2VjQzMmgyMTJ2MTYwek00MTIgNDMyaDIwMHYxNjBINDEyVjQzMnptMjAwLTY0SDQxMlYyMzJoMjAwdjEzNnptLTQ3NiA2NGgyMTJ2MTYwSDEzNlY0MzJ6bTAtMjAwaDIxMnYxMzZIMTM2VjIzMnptMCA0MjRoMjEydjEzNkgxMzZWNjU2em0yNzYgMGgyMDB2MTM2SDQxMlY2NTZ6bTQ3NiAxMzZINjc2VjY1NmgyMTJ2MTM2eiIgLz48L3N2Zz4=) */ var $a995787eb7d878ad$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($a995787eb7d878ad$var$TableOutlined);
var $a995787eb7d878ad$export$2e2bcd8739ae039 = $a995787eb7d878ad$var$RefIcon;




const $6c7041734928af05$var$INFINITE_SCROLL_PAGE_SIZE = (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).DEFAULT_PER_PAGE;
function $6c7041734928af05$export$101e9a04d85a8578() {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const [searchParams, setSearchParams] = (0, $6816d30a3e97278a$export$f1a78c17382fe22a)();
    // View mode lives in the URL rather than component state, so it shares a
    // single source of truth with the data params. Cards is the default and
    // carries no `view` param; Gallery and Table are explicit.
    const viewParam = searchParams.get('view');
    const viewMode = viewParam === 'Gallery' || viewParam === 'Table' ? viewParam : 'Cards';
    const { token: { colorBgContainer: colorBgContainer } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    const { userPlants: userPlants, userPlantCollections: userPlantCollections, totalCount: totalCount, tableParams: tableParams, dataKey: dataKey } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('plantsList');
    const viewModes = [
        {
            label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $8f860c1d180d1ba4$export$2e2bcd8739ae039), {}),
                    " ",
                    intl.formatMessage({
                        id: 'cards'
                    })
                ]
            }),
            value: 'Cards'
        },
        {
            label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $408bc24c1bd8a52d$export$2e2bcd8739ae039), {}),
                    " ",
                    intl.formatMessage({
                        id: 'gallery'
                    })
                ]
            }),
            value: 'Gallery'
        },
        {
            label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a995787eb7d878ad$export$2e2bcd8739ae039), {}),
                    " ",
                    intl.formatMessage({
                        id: 'table'
                    })
                ]
            }),
            value: 'Table'
        }
    ];
    const viewPageSizes = (0, $ltGt3.useMemo)(()=>{
        const availH = window.innerHeight - 320;
        const tableSize = Math.max(5, Math.floor((availH - 57) / 54));
        return {
            Table: tableSize,
            Gallery: $6c7041734928af05$var$INFINITE_SCROLL_PAGE_SIZE,
            Cards: $6c7041734928af05$var$INFINITE_SCROLL_PAGE_SIZE
        };
    }, []);
    // Keep perPage in sync with the active view's page size. This covers mount and
    // directly-loaded URLs (e.g. a shared `?view=Table` link); a view switch sets
    // perPage atomically in onViewModeChange, so this effect is a no-op then. The
    // page is intentionally left untouched here - resetting it on a view change is
    // owned by onViewModeChange, so a bookmarked deep page survives a refresh.
    (0, $ltGt3.useEffect)(()=>{
        const targetSize = viewPageSizes[viewMode];
        if (!targetSize || tableParams.perPage === targetSize) return;
        setSearchParams((current)=>{
            const params = Object.fromEntries(current);
            if (targetSize === (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).DEFAULT_PER_PAGE) delete params.perPage;
            else params.perPage = String(targetSize);
            return params;
        }, {
            replace: true
        });
    }, [
        viewMode,
        viewPageSizes,
        tableParams.perPage
    ]);
    const [name, setName] = (0, $ltGt3.useState)(tableParams.filters.plantName || '');
    const updateFilters = (0, $ltGt3.useCallback)((updater)=>{
        const filters = updater(tableParams.filters);
        setSearchParams((current)=>{
            const params = Object.fromEntries(current);
            const cleanedUpFilters = {};
            for (const key of Object.keys(filters)){
                const value = filters[key];
                if (!value) continue;
                if (Array.isArray(value) && value.length === 0) continue;
                cleanedUpFilters[key] = value;
            }
            const jsonFilters = JSON.stringify(cleanedUpFilters);
            if (jsonFilters === '{}') delete params.filter;
            else params.filter = jsonFilters;
            if (params.page) delete params.page;
            return params;
        });
    }, [
        tableParams.filters,
        setSearchParams
    ]);
    const setNameDebounced = (0, $ltGt3.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($28c4ad1246a5f174$exports)))((newName)=>updateFilters((current)=>({
                    ...current,
                    plantName: newName
                })), 300), [
        updateFilters
    ]);
    (0, $ltGt3.useEffect)(()=>{
        setNameDebounced(name);
    }, [
        name
    ]);
    // Infinite scroll state for Cards and Gallery. The loader provides the first
    // page (userPlants); extraPlants accumulates the pages fetched afterwards, so
    // it starts from page 2.
    const [extraPlants, setExtraPlants] = (0, $ltGt3.useState)([]);
    const [nextPage, setNextPage] = (0, $ltGt3.useState)(2);
    const [isLoadingMore, setIsLoadingMore] = (0, $ltGt3.useState)(false);
    // Reset the accumulated infinite-scroll pages whenever the loader returns a
    // new dataset (sort/filter change, or a revalidation after an add/edit).
    // Doing this during render - guarded by the stable dataKey the loader stamps
    // on every run - lets React discard this render pass before it commits, so
    // the new first page is never painted combined with the previous query's
    // stale extra pages (which would otherwise flash duplicate/stale rows).
    const [loadedDataKey, setLoadedDataKey] = (0, $ltGt3.useState)(dataKey);
    if (loadedDataKey !== dataKey) {
        setLoadedDataKey(dataKey);
        setExtraPlants([]);
        setNextPage(2);
    }
    const isInfiniteScrollMode = viewMode === 'Cards' || viewMode === 'Gallery';
    const allPlants = (0, $ltGt3.useMemo)(()=>isInfiniteScrollMode ? [
            ...userPlants,
            ...extraPlants
        ] : userPlants, [
        isInfiniteScrollMode,
        userPlants,
        extraPlants
    ]);
    const hasMore = allPlants.length < totalCount;
    const loadMore = (0, $ltGt3.useCallback)(async ()=>{
        if (isLoadingMore || !hasMore) return;
        setIsLoadingMore(true);
        try {
            const result = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getUserFilteredPlants({
                page: nextPage,
                perPage: $6c7041734928af05$var$INFINITE_SCROLL_PAGE_SIZE,
                filters: tableParams.filters,
                sort: tableParams.sortField ? {
                    field: tableParams.sortField,
                    direction: tableParams.sortOrder || 'asc'
                } : null
            }, intl.locale);
            // Only grow the list (and advance the page) when the page actually
            // returned rows. Appending an empty result would still produce a new array
            // reference, re-triggering the fill check and looping if the backend's
            // count and rows ever disagree.
            if (result.plants.length === 0) return;
            setExtraPlants((prev)=>[
                    ...prev,
                    ...result.plants
                ]);
            setNextPage((prev)=>prev + 1);
        } finally{
            setIsLoadingMore(false);
        }
    }, [
        isLoadingMore,
        hasMore,
        nextPage,
        tableParams,
        intl.locale
    ]);
    const handlePaginationChange = (current, pageSize)=>setSearchParams((searchParams)=>{
            const page = current;
            const perPage = pageSize;
            const params = Object.fromEntries(searchParams);
            if (page !== 1) params.page = String(page);
            else delete params.page;
            if (perPage !== (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).DEFAULT_PER_PAGE) params.perPage = String(perPage);
            else delete params.perPage;
            return params;
        });
    const onViewModeChange = ({ target: { value: value } })=>{
        setSearchParams((current)=>{
            const params = Object.fromEntries(current);
            // Cards is the default view and carries no param.
            if (value === 'Cards') delete params.view;
            else params.view = value;
            // The page size follows the view; omit it when it equals the default.
            const targetSize = viewPageSizes[value];
            if (targetSize && targetSize !== (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).DEFAULT_PER_PAGE) params.perPage = String(targetSize);
            else delete params.perPage;
            // Switching the view returns to the first page.
            delete params.page;
            return params;
        });
    };
    const pagination = {
        current: tableParams.page,
        pageSize: tableParams.perPage,
        total: totalCount
    };
    const viewProps = {
        getPlantLink: (plant)=>`/plants/${plant.id}`,
        parentRoute: '/plants',
        plants: isInfiniteScrollMode ? allPlants : userPlants,
        isLoading: false,
        newPlantRoute: `/plants/new`,
        ...isInfiniteScrollMode && {
            loadMore: loadMore,
            hasMore: hasMore,
            isLoadingMore: isLoadingMore
        }
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "plants-page",
        style: {
            background: colorBgContainer
        },
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "plants-page__header",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "plants-page__header__title",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("svg", {
                                className: "plants-page__header__title__icon",
                                width: "29.096069",
                                height: "50.079987",
                                viewBox: "0 0 58.192139 100.15997",
                                fill: "none",
                                role: "img",
                                "aria-labelledby": "title desc",
                                version: "1.1",
                                id: "svg7",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("defs", {
                                        id: "defs7"
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("g", {
                                        opacity: "0.95",
                                        stroke: "#6f8f72",
                                        strokeWidth: "2.3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        id: "g7",
                                        transform: "translate(-91.361043,-20.340025)",
                                        children: [
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("path", {
                                                d: "m 96,118 h 48",
                                                opacity: "0.35",
                                                id: "path1"
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("path", {
                                                d: "m 101,91 h 38 l -5.5,29 h -27 z",
                                                fill: "#e7efe3",
                                                id: "path2"
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("path", {
                                                d: "M 120,91 V 48",
                                                id: "path4"
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("path", {
                                                d: "m 120,69 c -10.5,-8 -19,-9.5 -28,-6 3.5,9.5 13.5,14.5 28,6 z",
                                                fill: "#ddebdc",
                                                id: "path5"
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("path", {
                                                d: "m 121,58 c 9.5,-10 18,-13 28,-10 -1.5,11 -12.5,18.5 -28,10 z",
                                                fill: "#ddebdc",
                                                id: "path6"
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("path", {
                                                d: "m 119,47 c -7,-8 -8.5,-17 -4.5,-26 9,4 12.5,14.5 4.5,26 z",
                                                fill: "#ddebdc",
                                                id: "path7"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                                        className: "todos",
                                        children: intl.formatMessage({
                                            id: 'myPlants'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                        className: "plants-page__header__subtitle",
                                        children: `${totalCount} ${intl.formatMessage({
                                            id: 'plants'
                                        })}`
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039), {
                        className: "plants-page__header__search",
                        size: "large",
                        placeholder: intl.formatMessage({
                            id: 'plantName'
                        }),
                        prefix: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $8397f586b179aba6$export$2e2bcd8739ae039), {}),
                        allowClear: true,
                        value: name,
                        onChange: (e)=>setName(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "plants-page__header__settings",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Group, {
                            className: "view-modes",
                            size: "large",
                            options: viewModes,
                            onChange: onViewModeChange,
                            value: viewMode,
                            optionType: "button",
                            buttonStyle: "solid"
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        size: "large",
                        className: "plants-page__header__add-plant-button",
                        type: "primary",
                        onClick: ()=>{
                            navigate(`/plants/new` + location.search);
                        },
                        children: [
                            intl.formatMessage({
                                id: 'addPlant'
                            }),
                            "..."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "plants-page__toolbar",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $c29bdac8aed3afcb$export$ce4baeeb74cb909c), {
                        filters: tableParams.filters,
                        setFilters: updateFilters,
                        userPlantCollections: userPlantCollections
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
                        value: tableParams.sortField,
                        style: {
                            minWidth: 180
                        },
                        prefix: intl.formatMessage({
                            id: 'sortBy'
                        }) + ':',
                        onChange: (sortField)=>setSearchParams((current)=>{
                                const params = Object.fromEntries(current);
                                params.sortField = sortField;
                                // A different ordering changes which rows fall on the first page,
                                // so jump back to it (relevant for the paginated Table view).
                                delete params.page;
                                return params;
                            }),
                        options: (0, $e0eda949f811dcf3$export$965cd5f3a2d1fc05).map((field)=>({
                                value: field,
                                label: intl.formatMessage({
                                    id: field
                                })
                            }))
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        icon: tableParams.sortOrder === 'desc' ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $867e72afe7ade565$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $36f7eb0e6ad26c47$export$2e2bcd8739ae039), {}),
                        onClick: ()=>setSearchParams((current)=>{
                                const params = Object.fromEntries(current);
                                params.sortOrder = tableParams.sortOrder === 'desc' ? 'asc' : 'desc';
                                delete params.page;
                                return params;
                            })
                    })
                ]
            }),
            viewMode === 'Table' && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $8b808d063eaa0654$export$86bf0b152bae8da8), {
                    ...viewProps
                })
            }),
            viewMode === 'Gallery' && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $959ccd62a460e059$export$19c34617cb9a7080), {
                    ...viewProps
                })
            }),
            viewMode === 'Cards' && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $daec8bf9c9ed5832$export$8bd6654a6c34d0a0), {
                    ...viewProps
                })
            }),
            viewMode === 'Table' && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ba6ccffd2ae02ebb$export$2e2bcd8739ae039), {
                style: {
                    justifyContent: 'flex-end',
                    paddingTop: '20px'
                },
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: pagination.total,
                onChange: handlePaginationChange
            })
        ]
    });
}





var $ltGt3 = parcelRequire("ltGt3");



parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $6b52cc9bb499fd76$var$BuildOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z"
                }
            }
        ]
    },
    "name": "build",
    "theme": "outlined"
};
var $6b52cc9bb499fd76$export$2e2bcd8739ae039 = $6b52cc9bb499fd76$var$BuildOutlined;



var $0c9b5513b3696834$var$BuildOutlined = function BuildOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $6b52cc9bb499fd76$export$2e2bcd8739ae039)
    }));
};
/**![build](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxNiAyMTBIMzc2Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnYyMzZIMTA4Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnYyNzJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNTQwYzE3LjcgMCAzMi0xNC4zIDMyLTMyVjU0NmgyMzZjMTcuNyAwIDMyLTE0LjMgMzItMzJWMjQyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNTA0IDY4aDIwMHYyMDBINDEyVjI3OHptLTY4IDQ2OEgxNDRWNTQ2aDIwMHYyMDB6bTI2OCAwSDQxMlY1NDZoMjAwdjIwMHptMjY4LTI2OEg2ODBWMjc4aDIwMHYyMDB6IiAvPjwvc3ZnPg==) */ var $0c9b5513b3696834$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($0c9b5513b3696834$var$BuildOutlined);
var $0c9b5513b3696834$export$2e2bcd8739ae039 = $0c9b5513b3696834$var$RefIcon;



parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");

function $3e3514cbc64b8723$export$982b3886e8b437c4(props) {
    const TransformerUIComponent = (0, $ltGt3.useMemo)(()=>(0, $3b2a1dec172ced19$export$bbdb2c97169ec0d5)[props.element.shapeType]?.transformerUI, [
        props.element.shapeType
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)(TransformerUIComponent, {
        element: props.element,
        onChange: props.onChange,
        transformerProps: props.transformerProps,
        onTransformerPropsChange: props.onTransformerPropsChange
    });
}


function $4dfe00ac500ada22$export$3861ec25786c92bd(props) {
    let sides = [];
    // if (props.plot && props.plot.shapeType === 'polygon') {
    //   sides = CalculateEdges(props.plot?.props.points)
    // }
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "editor-fields-name",
                children: [
                    intl.formatMessage({
                        id: 'usePlotDrawingTool'
                    }),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Group, {
                value: props.isToolSelected ? 1 : null,
                style: {
                    paddingBottom: '15px'
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                    className: "editor-fields-radio",
                    value: 1,
                    onClick: props.onToolSelected,
                    style: {
                        height: 65
                    },
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "editor-fields-radio-icon",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0c9b5513b3696834$export$2e2bcd8739ae039), {})
                    })
                })
            }),
            props.plot && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3e3514cbc64b8723$export$982b3886e8b437c4), {
                element: {
                    ...props.plot,
                    type: 'plot'
                },
                onChange: props.onPlotUpdated,
                transformerProps: props.transformerProps,
                onTransformerPropsChange: props.onTransformerPropsChange
            })
        ]
    });
}




parcelRequire("ltGt3");



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $2b040e9ce9b07e7c$var$GatewayOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z"
                }
            }
        ]
    },
    "name": "gateway",
    "theme": "outlined"
};
var $2b040e9ce9b07e7c$export$2e2bcd8739ae039 = $2b040e9ce9b07e7c$var$GatewayOutlined;



var $b2f4ca77633c08ed$var$GatewayOutlined = function GatewayOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $2b040e9ce9b07e7c$export$2e2bcd8739ae039)
    }));
};
/**![gateway](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAzOTJjOC44IDAgMTYtNy4yIDE2LTE2VjE5MmMwLTguOC03LjItMTYtMTYtMTZINzQ0Yy04LjggMC0xNiA3LjItMTYgMTZ2NTZIMjk2di01NmMwLTguOC03LjItMTYtMTYtMTZIOTZjLTguOCAwLTE2IDcuMi0xNiAxNnYxODRjMCA4LjggNy4yIDE2IDE2IDE2aDU2djI0MEg5NmMtOC44IDAtMTYgNy4yLTE2IDE2djE4NGMwIDguOCA3LjIgMTYgMTYgMTZoMTg0YzguOCAwIDE2LTcuMiAxNi0xNnYtNTZoNDMydjU2YzAgOC44IDcuMiAxNiAxNiAxNmgxODRjOC44IDAgMTYtNy4yIDE2LTE2VjY0OGMwLTguOC03LjItMTYtMTYtMTZoLTU2VjM5Mmg1NnpNNzkyIDI0MGg4OHY4OGgtODh2LTg4em0tNjQ4IDg4di04OGg4OHY4OGgtODh6bTg4IDQ1NmgtODh2LTg4aDg4djg4em02NDgtODh2ODhoLTg4di04OGg4OHptLTgwLTY0aC01NmMtOC44IDAtMTYgNy4yLTE2IDE2djU2SDI5NnYtNTZjMC04LjgtNy4yLTE2LTE2LTE2aC01NlYzOTJoNTZjOC44IDAgMTYtNy4yIDE2LTE2di01Nmg0MzJ2NTZjMCA4LjggNy4yIDE2IDE2IDE2aDU2djI0MHoiIC8+PC9zdmc+) */ var $b2f4ca77633c08ed$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($b2f4ca77633c08ed$var$GatewayOutlined);
var $b2f4ca77633c08ed$export$2e2bcd8739ae039 = $b2f4ca77633c08ed$var$RefIcon;


function $92b5328027bcb13e$export$a9950ac456e129c8(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "editor-fields-name",
                children: [
                    intl.formatMessage({
                        id: 'usePlotDrawingTool'
                    }),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Group, {
                value: props.isToolSelected ? 1 : null,
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                    className: "editor-fields-radio",
                    style: {
                        height: 65
                    },
                    value: 1,
                    onClick: props.onToolSelected,
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "editor-fields-radio-icon",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b2f4ca77633c08ed$export$2e2bcd8739ae039), {})
                    })
                })
            }),
            props.plot && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d029ee757225a242$export$2e2bcd8739ae039), {
                direction: "vertical",
                className: "editor-fields-value",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "editor-fields-name",
                        children: [
                            intl.formatMessage({
                                id: 'enterPlotEdgesDimensions'
                            }),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $bbe04e8e6f6789c3$export$2e2bcd8739ae039), {
                        style: {
                            width: '100%'
                        },
                        addonBefore: intl.formatMessage({
                            id: 'length'
                        }),
                        addonAfter: intl.formatMessage({
                            id: 'm'
                        }),
                        value: props.plot?.props.width / 100,
                        onChange: (value)=>{
                            props.onPlotUpdated({
                                ...props.plot,
                                props: {
                                    ...props.plot.props,
                                    width: value * 100
                                }
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $bbe04e8e6f6789c3$export$2e2bcd8739ae039), {
                        style: {
                            width: '100%'
                        },
                        addonBefore: intl.formatMessage({
                            id: 'width'
                        }),
                        addonAfter: intl.formatMessage({
                            id: 'm'
                        }),
                        value: props.plot?.props.height / 100,
                        onChange: (value)=>{
                            props.onPlotUpdated({
                                ...props.plot,
                                props: {
                                    ...props.plot.props,
                                    height: value * 100
                                }
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {})
        ]
    });
}




function $2ef5a0d874aed4aa$export$a3a42d21b798dc07(props) {
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "editor-fields-name",
                children: [
                    intl.formatMessage({
                        id: 'choosePlotType'
                    }),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Group, {
                value: props.plotShapeType,
                onChange: (e)=>props.onPlotShapeTypeChanged(e.target.value),
                className: "editor-fields-radio-group",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                        className: "editor-fields-radio",
                        value: "rect",
                        style: {
                            height: 'auto'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "editor-fields-radio-icon",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b2f4ca77633c08ed$export$2e2bcd8739ae039), {})
                            }),
                            intl.formatMessage({
                                id: 'rect'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                        className: "editor-fields-radio",
                        value: "polygon",
                        style: {
                            height: 'auto'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "editor-fields-radio-icon",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0c9b5513b3696834$export$2e2bcd8739ae039), {})
                            }),
                            intl.formatMessage({
                                id: 'polygon'
                            })
                        ]
                    })
                ]
            }),
            props.plotShapeType === 'rect' ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $92b5328027bcb13e$export$a9950ac456e129c8), {
                plot: props.plot,
                isToolSelected: props.tool === 'rect',
                onToolSelected: ()=>props.onToolSelected('rect'),
                onPlotUpdated: props.onPlotUpdated
            }) : null,
            props.plotShapeType === 'polygon' ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4dfe00ac500ada22$export$3861ec25786c92bd), {
                plot: props.plot,
                isToolSelected: props.tool === 'polygon',
                onToolSelected: ()=>props.onToolSelected('polygon'),
                onPlotUpdated: props.onPlotUpdated,
                transformerProps: props.transformerProps,
                onTransformerPropsChange: props.onTransformerPropsChange
            }) : null
        ]
    });
}








var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $0df6045d2a06f6db$var$BulbOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z"
                }
            }
        ]
    },
    "name": "bulb",
    "theme": "outlined"
};
var $0df6045d2a06f6db$export$2e2bcd8739ae039 = $0df6045d2a06f6db$var$BulbOutlined;



var $812c1713fed4df14$var$BulbOutlined = function BulbOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $0df6045d2a06f6db$export$2e2bcd8739ae039)
    }));
};
/**![bulb](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzMiA4ODhIMzkyYy00LjQgMC04IDMuNi04IDh2MzJjMCAxNy43IDE0LjMgMzIgMzIgMzJoMTkyYzE3LjcgMCAzMi0xNC4zIDMyLTMydi0zMmMwLTQuNC0zLjYtOC04LTh6TTUxMiA2NGMtMTgxLjEgMC0zMjggMTQ2LjktMzI4IDMyOCAwIDEyMS40IDY2IDIyNy40IDE2NCAyODQuMVY3OTJjMCAxNy43IDE0LjMgMzIgMzIgMzJoMjY0YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjY3Ni4xYzk4LTU2LjcgMTY0LTE2Mi43IDE2NC0yODQuMSAwLTE4MS4xLTE0Ni45LTMyOC0zMjgtMzI4em0xMjcuOSA1NDkuOEw2MDQgNjM0LjZWNzUySDQyMFY2MzQuNmwtMzUuOS0yMC44QzMwNS40IDU2OC4zIDI1NiA0ODQuNSAyNTYgMzkyYzAtMTQxLjQgMTE0LjYtMjU2IDI1Ni0yNTZzMjU2IDExNC42IDI1NiAyNTZjMCA5Mi41LTQ5LjQgMTc2LjMtMTI4LjEgMjIxLjh6IiAvPjwvc3ZnPg==) */ var $812c1713fed4df14$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($812c1713fed4df14$var$BulbOutlined);
var $812c1713fed4df14$export$2e2bcd8739ae039 = $812c1713fed4df14$var$RefIcon;


function $8a67ad5a3b6dcccc$export$d4fc59a76aa37d5e() {
    const { project: project } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('project');
    const [currentElementIndex, setCurrentElementIndex] = (0, $ltGt3.useState)(-1);
    const [currentPlotShape, setPlotShape] = (0, $ltGt3.useState)(project.plotShape ? {
        ...project.plotShape,
        type: 'plot'
    } : null);
    const [plotShapeType, setPlotShapeType] = (0, $ltGt3.useState)(currentPlotShape?.shapeType);
    const [tool, setTool] = (0, $ltGt3.useState)(null);
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const [transformerProps, setTransformerProps] = (0, $ltGt3.useState)(null);
    const [isUnsaved, setIsUnsaved] = (0, $ltGt3.useState)(false);
    (0, $ltGt3.useEffect)(()=>{
        if (!project.plotShape && !currentPlotShape) setIsUnsaved(false);
        else if (project.plotShape && !currentPlotShape) setIsUnsaved(true);
        else setIsUnsaved(project.plotShape ? JSON.stringify(project.plotShape.props) !== JSON.stringify(currentPlotShape.props) : true);
    }, [
        currentPlotShape
    ]);
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
            padding: '10px'
        },
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "editor-create-elements",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2ef5a0d874aed4aa$export$a3a42d21b798dc07), {
                        plot: currentPlotShape,
                        plotShapeType: plotShapeType,
                        onPlotShapeTypeChanged: setPlotShapeType,
                        onPlotUpdated: setPlotShape,
                        tool: tool,
                        onToolSelected: (tool)=>{
                            if (currentPlotShape) {
                                if (confirm(intl.formatMessage({
                                    id: 'plotWillBeDeleted'
                                }))) {
                                    setPlotShape(null);
                                    setTool(tool);
                                }
                            } else setTool(tool);
                        },
                        transformerProps: transformerProps,
                        onTransformerPropsChange: setTransformerProps
                    }),
                    isUnsaved ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "editor-fields-warning",
                        children: intl.formatMessage({
                            id: 'projectChangedSaveBeforeProceedingToTheNextStep'
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        type: "primary",
                        style: {
                            margin: '20px 0',
                            width: '100%'
                        },
                        onClick: async ()=>{
                            const result = await (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).editProject({
                                ...project,
                                plotShape: currentPlotShape
                            });
                            if (result.success === false) messageApi.open({
                                type: 'error',
                                content: result.error?.message
                            });
                            else setIsUnsaved(false);
                        },
                        children: intl.formatMessage({
                            id: 'save'
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        style: {
                            color: 'green',
                            display: 'flex',
                            alignItems: 'flex-start',
                            minWidth: '320px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $812c1713fed4df14$export$2e2bcd8739ae039), {
                                style: {
                                    padding: '5px 10px 0px 0px'
                                }
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                children: intl.formatMessage({
                                    id: 'advicePlotMapFirst'
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    padding: '15px',
                    width: '100%'
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    style: {
                        boxShadow: '15px 15px #fa8c16',
                        height: '100%'
                    },
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $395d89d67d098b23$export$e3d016329f8674e7), {
                        canvasEditorProps: {
                            projectId: project?.id,
                            plotShape: currentPlotShape,
                            elements: project?.elements,
                            selectable: false,
                            plotShapeEditable: true,
                            onPlotShapeChanged: (newShape)=>{
                                setPlotShape({
                                    ...newShape,
                                    type: 'plot'
                                });
                            },
                            onElementChanged: (updatedElement)=>{
                                setPlotShape(updatedElement);
                            },
                            selectedElementId: currentElementIndex,
                            setSelectedElementId: setCurrentElementIndex,
                            hasMap: Boolean(project?.location?.map),
                            transformerLayerProps: transformerProps
                        },
                        tool: tool,
                        onElementDrawn: (shape)=>{
                            setPlotShape({
                                shapeType: shape.type,
                                props: shape.props,
                                elementId: 0,
                                name: 'plot',
                                type: 'plot'
                            });
                            setCurrentElementIndex(-1);
                            setTool(null);
                        }
                    })
                })
            })
        ]
    });
}



parcelRequire("ltGt3");




var $ltGt3 = parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");







var $ltGt3 = parcelRequire("ltGt3");


var $6dff246b005d5aab$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $71b60cba26c9f93f$export$2e2bcd8739ae039)
    }));
};
/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */ var $6dff246b005d5aab$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($6dff246b005d5aab$var$CloseOutlined);
var $6dff246b005d5aab$export$2e2bcd8739ae039 = $6dff246b005d5aab$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $51f33d6fc002557d$var$FullscreenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M290 236.4l43.9-43.9a8.01 8.01 0 00-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0013.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 000 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 00-11.3 0l-42.4 42.3a8.03 8.03 0 000 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 004.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 00-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 00-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z"
                }
            }
        ]
    },
    "name": "fullscreen",
    "theme": "outlined"
};
var $51f33d6fc002557d$export$2e2bcd8739ae039 = $51f33d6fc002557d$var$FullscreenOutlined;



var $51f453c7b12fa8db$var$FullscreenOutlined = function FullscreenOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $51f33d6fc002557d$export$2e2bcd8739ae039)
    }));
};
/**![fullscreen](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5MCAyMzYuNGw0My45LTQzLjlhOC4wMSA4LjAxIDAgMDAtNC43LTEzLjZMMTY5IDE2MGMtNS4xLS42LTkuNSAzLjctOC45IDguOUwxNzkgMzI5LjFjLjggNi42IDguOSA5LjQgMTMuNiA0LjdsNDMuNy00My43TDM3MCA0MjMuN2MzLjEgMy4xIDguMiAzLjEgMTEuMyAwbDQyLjQtNDIuM2MzLjEtMy4xIDMuMS04LjIgMC0xMS4zTDI5MCAyMzYuNHptMzUyLjcgMTg3LjNjMy4xIDMuMSA4LjIgMy4xIDExLjMgMGwxMzMuNy0xMzMuNiA0My43IDQzLjdhOC4wMSA4LjAxIDAgMDAxMy42LTQuN0w4NjMuOSAxNjljLjYtNS4xLTMuNy05LjUtOC45LTguOUw2OTQuOCAxNzljLTYuNi44LTkuNCA4LjktNC43IDEzLjZsNDMuOSA0My45TDYwMC4zIDM3MGE4LjAzIDguMDMgMCAwMDAgMTEuM2w0Mi40IDQyLjR6TTg0NSA2OTQuOWMtLjgtNi42LTguOS05LjQtMTMuNi00LjdsLTQzLjcgNDMuN0w2NTQgNjAwLjNhOC4wMyA4LjAzIDAgMDAtMTEuMyAwbC00Mi40IDQyLjNhOC4wMyA4LjAzIDAgMDAwIDExLjNMNzM0IDc4Ny42bC00My45IDQzLjlhOC4wMSA4LjAxIDAgMDA0LjcgMTMuNkw4NTUgODY0YzUuMS42IDkuNS0zLjcgOC45LTguOUw4NDUgNjk0Ljl6bS00NjMuNy05NC42YTguMDMgOC4wMyAwIDAwLTExLjMgMEwyMzYuMyA3MzMuOWwtNDMuNy00My43YTguMDEgOC4wMSAwIDAwLTEzLjYgNC43TDE2MC4xIDg1NWMtLjYgNS4xIDMuNyA5LjUgOC45IDguOUwzMjkuMiA4NDVjNi42LS44IDkuNC04LjkgNC43LTEzLjZMMjkwIDc4Ny42IDQyMy43IDY1NGMzLjEtMy4xIDMuMS04LjIgMC0xMS4zbC00Mi40LTQyLjR6IiAvPjwvc3ZnPg==) */ var $51f453c7b12fa8db$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($51f453c7b12fa8db$var$FullscreenOutlined);
var $51f453c7b12fa8db$export$2e2bcd8739ae039 = $51f453c7b12fa8db$var$RefIcon;



var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $db758418c7f8dbde$var$Loading3QuartersOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z"
                }
            }
        ]
    },
    "name": "loading-3-quarters",
    "theme": "outlined"
};
var $db758418c7f8dbde$export$2e2bcd8739ae039 = $db758418c7f8dbde$var$Loading3QuartersOutlined;



var $b4b754c60aeac452$var$Loading3QuartersOutlined = function Loading3QuartersOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $db758418c7f8dbde$export$2e2bcd8739ae039)
    }));
};
/**![loading-3-quarters](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiAxMDI0Yy02OS4xIDAtMTM2LjItMTMuNS0xOTkuMy00MC4yQzI1MS43IDk1OCAxOTcgOTIxIDE1MCA4NzRjLTQ3LTQ3LTg0LTEwMS43LTEwOS44LTE2Mi43QzEzLjUgNjQ4LjIgMCA1ODEuMSAwIDUxMmMwLTE5LjkgMTYuMS0zNiAzNi0zNnMzNiAxNi4xIDM2IDM2YzAgNTkuNCAxMS42IDExNyAzNC42IDE3MS4zIDIyLjIgNTIuNCA1My45IDk5LjUgOTQuMyAxMzkuOSA0MC40IDQwLjQgODcuNSA3Mi4yIDEzOS45IDk0LjNDMzk1IDk0MC40IDQ1Mi42IDk1MiA1MTIgOTUyYzU5LjQgMCAxMTctMTEuNiAxNzEuMy0zNC42IDUyLjQtMjIuMiA5OS41LTUzLjkgMTM5LjktOTQuMyA0MC40LTQwLjQgNzIuMi04Ny41IDk0LjMtMTM5LjlDOTQwLjQgNjI5IDk1MiA1NzEuNCA5NTIgNTEyYzAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4yQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjNzLTEzLjUgMTM2LjItNDAuMiAxOTkuM0M5NTggNzcyLjMgOTIxIDgyNyA4NzQgODc0Yy00NyA0Ny0xMDEuOCA4My45LTE2Mi43IDEwOS43LTYzLjEgMjYuOC0xMzAuMiA0MC4zLTE5OS4zIDQwLjN6IiAvPjwvc3ZnPg==) */ var $b4b754c60aeac452$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($b4b754c60aeac452$var$Loading3QuartersOutlined);
var $b4b754c60aeac452$export$2e2bcd8739ae039 = $b4b754c60aeac452$var$RefIcon;



parcelRequire("ltGt3");


function $40e0eca0e4bab393$export$d935a54dbefba16(props) {
    const { token: { colorPrimary: colorPrimary } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        style: {
            color: colorPrimary,
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-around',
            maxHeight: '300px',
            overflow: 'hidden',
            overflowY: 'scroll'
        },
        children: props.templates ? Object.keys(props.templates).map((templateId, index)=>{
            const template = props.templates[templateId];
            return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    flexWrap: 'wrap',
                    justifyContent: 'space-around'
                },
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                        onDragCapture: (e)=>{
                            props.setDraggableElement(templateId);
                            props.setCurrentElementName(intl.formatMessage({
                                id: `elementName-${templateId}`
                            }));
                        },
                        width: 64,
                        height: 64,
                        src: template.src
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                        style: {
                            textWrap: 'wrap'
                        },
                        children: intl.formatMessage({
                            id: `elementName-${templateId}`
                        })
                    })
                ]
            }, index);
        }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
            children: intl.formatMessage({
                id: 'noTemplatesForThisType'
            })
        })
    });
}


function $fcd88008ffc41445$export$34ce843811f95944(props) {
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const availableShapeTypesSet = (0, $ltGt3.useMemo)(()=>new Set((0, $670e204136b37e30$export$9544d5bb712b01ea).getElementType(props.selectedElementType).availableShapeTypes), [
        props.selectedElementType
    ]);
    const templates = (0, $670e204136b37e30$export$9544d5bb712b01ea).getElementTypeTemplates(props.selectedElementType) || {};
    const shapes = [
        {
            value: 'rect',
            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b2f4ca77633c08ed$export$2e2bcd8739ae039), {})
        },
        {
            value: 'polygon',
            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0c9b5513b3696834$export$2e2bcd8739ae039), {})
        },
        {
            value: 'ellipse',
            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b4b754c60aeac452$export$2e2bcd8739ae039), {})
        }
    ];
    const showTemplates = Object.keys(templates).length > 0;
    const showShapes = shapes.some((shape)=>availableShapeTypesSet.has(shape.value));
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "editor-create-elements",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "editor-fields-name",
                children: [
                    intl.formatMessage({
                        id: 'chooseMode'
                    }),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Group, {
                value: props.currentMode,
                onChange: (e)=>props.onCurrentModeChange(e.target.value),
                className: "editor-fields-radio-group",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                        className: "editor-fields-radio",
                        value: "create",
                        style: {
                            height: 'auto'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "editor-fields-radio-icon",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $da40d833ab151490$export$2e2bcd8739ae039), {})
                            }),
                            intl.formatMessage({
                                id: 'createElement'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                        className: "editor-fields-radio",
                        value: "edit",
                        style: {
                            height: 'auto'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "editor-fields-radio-icon",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $51f453c7b12fa8db$export$2e2bcd8739ae039), {})
                            }),
                            intl.formatMessage({
                                id: 'editElement'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                        className: "editor-fields-radio",
                        value: "delete",
                        style: {
                            height: 'auto'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "editor-fields-radio-icon",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6dff246b005d5aab$export$2e2bcd8739ae039), {})
                            }),
                            intl.formatMessage({
                                id: 'deleteElement'
                            })
                        ]
                    })
                ]
            }),
            props.currentMode ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {}) : null,
            props.currentMode === 'create' ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "editor-fields",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                className: "editor-fields-name",
                                children: [
                                    intl.formatMessage({
                                        id: 'chooseObjectType'
                                    }),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
                                value: props.selectedElementType,
                                style: {
                                    width: '100%',
                                    marginBottom: '10px'
                                },
                                onChange: props.onElementTypeSelected,
                                options: props.availableElementTypes.map((elementTypeId)=>({
                                        value: elementTypeId,
                                        label: intl.formatMessage({
                                            id: (0, $670e204136b37e30$export$9544d5bb712b01ea).getElementType(elementTypeId).displayName
                                        })
                                    }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "editor-fields-name",
                        children: [
                            intl.formatMessage({
                                id: 'selectTemplateOrDrawingTool'
                            }),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $77eacb4b734e6c42$export$2e2bcd8739ae039), {
                        onChange: ()=>null,
                        type: "card",
                        items: [
                            showTemplates && {
                                key: '1',
                                label: intl.formatMessage({
                                    id: 'createFromTemplate'
                                }),
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $40e0eca0e4bab393$export$d935a54dbefba16), {
                                    templates: templates,
                                    setDraggableElement: props.onDraggableElementChange,
                                    setCurrentElementName: props.onCurrentElementNameChange
                                })
                            },
                            showShapes && {
                                key: '2',
                                label: intl.formatMessage({
                                    id: 'draw'
                                }),
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "editor-fields",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                            className: "editor-fields-name",
                                            children: [
                                                intl.formatMessage({
                                                    id: 'chooseObjectForm'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Group, {
                                            value: props.tool,
                                            onChange: (e)=>props.onToolSelected(e.target.value),
                                            style: {
                                                wordWrap: 'break-word',
                                                display: 'flex'
                                            },
                                            children: shapes.filter((shape)=>availableShapeTypesSet.has(shape.value)).map((shape)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                                                    className: "editor-fields-radio",
                                                    value: shape.value,
                                                    style: {
                                                        height: 'auto',
                                                        overflowWrap: 'anywhere'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                                            className: "editor-fields-radio-icon",
                                                            children: shape.icon
                                                        }),
                                                        intl.formatMessage({
                                                            id: shape.value
                                                        })
                                                    ]
                                                }, shape.value))
                                        }),
                                        props.tool ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                            children: intl.formatMessage({
                                                id: 'putObjectOnThePlan'
                                            })
                                        }) : null
                                    ]
                                })
                            }
                        ].filter(Boolean)
                    })
                ]
            }) : null,
            props.currentMode === 'edit' ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                children: !props.currentElement ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    className: "editor-fields-name",
                    children: intl.formatMessage({
                        id: 'selectAnObjectForEditing'
                    })
                }) : !props.availableElementTypes.some((type)=>type === props.currentElement.type) ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    className: "editor-fields-name",
                    children: intl.formatMessage({
                        id: 'editedInAnotherStep'
                    })
                }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "editor-fields",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "editor-fields-name",
                                    children: [
                                        intl.formatMessage({
                                            id: 'objectName'
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039), {
                                    value: props.currentElement.name,
                                    onChange: (evt)=>{
                                        props.onCurrentElementUpdated({
                                            ...props.currentElement,
                                            name: evt.target.value
                                        });
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "editor-fields",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "editor-fields-name",
                                    children: [
                                        intl.formatMessage({
                                            id: 'objectType'
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
                                    value: props.currentElement.type,
                                    style: {
                                        width: 120
                                    },
                                    onChange: (newType)=>{
                                        props.onCurrentElementUpdated({
                                            ...props.currentElement,
                                            type: newType
                                        });
                                    },
                                    options: props.availableElementTypes.map((elementTypeId)=>({
                                            value: elementTypeId,
                                            label: intl.formatMessage({
                                                id: (0, $670e204136b37e30$export$9544d5bb712b01ea).getElementType(elementTypeId).displayName
                                            })
                                        }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "editor-fields",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "editor-fields-name",
                                    children: [
                                        intl.formatMessage({
                                            id: 'objectParameters'
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                    className: "editor-fields-value",
                                    children: props.currentElement && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3e3514cbc64b8723$export$982b3886e8b437c4), {
                                        element: props.currentElement,
                                        onChange: props.onCurrentElementUpdated,
                                        transformerProps: props.transformerProps,
                                        onTransformerPropsChange: props.onTransformerPropsChange
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            props.currentMode === 'delete' ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                children: !props.currentElement ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    className: "editor-fields-name",
                    children: intl.formatMessage({
                        id: 'selectAnElementForDeleting'
                    })
                }) : !props.availableElementTypes.some((type)=>type === props.currentElement.type) ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    className: "editor-fields-name",
                    children: intl.formatMessage({
                        id: 'editedInAnotherStep'
                    })
                }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "editor-fields-name",
                            children: [
                                intl.formatMessage({
                                    id: 'doYouReallyWantToDelete'
                                }),
                                ' ',
                                intl.formatMessage({
                                    id: props.currentElement.type
                                }),
                                " ",
                                props.currentElement.name,
                                "?"
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Group, {
                            className: "editor-fields",
                            value: '',
                            onChange: (e)=>{
                                if (e.target.value === 'yes') // props.elementsList.splice(
                                //   props.elementsList.findIndex(
                                //     (item) => item.elementId === props.currentElement.elementId
                                //   ),
                                //   1
                                // )
                                // submit({method: 'post'})
                                props.onCurrentElementDeleted(props.currentElement.elementId);
                                else if (e.target.value === 'no') props.onCurrentModeChange('edit');
                            },
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                                    value: 'yes',
                                    children: intl.formatMessage({
                                        id: 'yes'
                                    })
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e6a2ebed9d2f17f5$export$2e2bcd8739ae039).Button, {
                                    value: 'no',
                                    children: intl.formatMessage({
                                        id: 'no'
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            props.isUnsaved ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "editor-fields-warning",
                children: intl.formatMessage({
                    id: 'projectChangedSaveBeforeProceedingToTheNextStep'
                })
            }) : null,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                style: {
                    margin: '20px 0',
                    width: '100%'
                },
                type: "primary",
                onClick: props.onSave,
                children: intl.formatMessage({
                    id: 'save'
                })
            })
        ]
    });
}






function $b7c8a10e768eadb0$export$2d003b3d2748ba71(props) {
    const { project: project } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('project');
    const [tool, setTool] = (0, $ltGt3.useState)(null);
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const [currentMode, setCurrentMode] = (0, $ltGt3.useState)('create');
    const [elementsList, setElementsList] = (0, $ltGt3.useState)(project.elements);
    const [currentElementIndex, setCurrentElementIndex] = (0, $ltGt3.useState)(null);
    const [currentElementName, setCurrentElementName] = (0, $ltGt3.useState)('');
    const [currentElementType, setCurrentElementType] = (0, $ltGt3.useState)(props.availableElementTypes[0]);
    const [transformerProps, setTransformerProps] = (0, $ltGt3.useState)(null);
    const [draggableElement, setDraggableElement] = (0, $ltGt3.useState)(null);
    (0, $ltGt3.useEffect)(()=>{
        setTransformerProps(null);
        setCurrentElementName('');
    }, [
        currentElementIndex
    ]);
    (0, $ltGt3.useEffect)(()=>{
        setElementsList(project.elements);
    }, [
        project
    ]);
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    const isUnsaved = project.elements !== elementsList;
    const { setNextStepConfirmation: setNextStepConfirmation } = (0, $ltGt3.useContext)((0, $e0fec9ca9a676038$export$68671cbc8e95f886));
    const onSave = async ()=>{
        const result = await (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).editProject({
            ...project,
            elements: elementsList
        });
        if (result.success === false) messageApi.open({
            type: 'error',
            content: result.error?.message
        });
        else submit({
            method: 'post'
        });
    };
    (0, $ltGt3.useEffect)(()=>{
        if (isUnsaved) setNextStepConfirmation({
            message: intl.formatMessage({
                id: 'doYouWantToSaveTheProjectBeforeMovingOnToTheNextStep'
            }),
            onConfirm: onSave
        });
        else setNextStepConfirmation(null);
    }, [
        isUnsaved
    ]);
    const onCurrentElementUpdated = (updatedElement)=>{
        setElementsList((list)=>list.map((element)=>{
                if (element.elementId === currentElementIndex) return {
                    ...element,
                    ...updatedElement
                };
                else return element;
            }));
    };
    const onCurrentElementDeleted = (deletedElementId)=>{
        setElementsList(elementsList.filter((item)=>item.elementId !== deletedElementId));
    //submit({method: 'post'})
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "canvas-editor-step",
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "canvas-editor-step-panel",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $fcd88008ffc41445$export$34ce843811f95944), {
                    onSave: onSave,
                    project: project,
                    onToolSelected: setTool,
                    tool: tool,
                    isUnsaved: isUnsaved,
                    currentElementName: currentElementName,
                    onCurrentElementNameChange: setCurrentElementName,
                    selectedElementType: currentElementType,
                    onElementTypeSelected: (newType)=>{
                        setCurrentElementType(newType);
                    //setCurrentElementName('')
                    },
                    availableElementTypes: props.availableElementTypes,
                    elementsList: elementsList,
                    onCurrentElementUpdated: onCurrentElementUpdated,
                    currentElement: elementsList.find((item)=>item.elementId === currentElementIndex),
                    onCurrentElementSelected: (element)=>{
                        const elementIndex = elementsList.findIndex((e)=>element.elementId === e.elementId);
                        if (elementIndex < 0) setCurrentElementIndex(null);
                        else setCurrentElementIndex(elementIndex);
                    },
                    onCurrentElementDeleted: onCurrentElementDeleted,
                    currentMode: currentMode,
                    onCurrentModeChange: setCurrentMode,
                    transformerProps: transformerProps,
                    onTransformerPropsChange: setTransformerProps,
                    onDraggableElementChange: setDraggableElement
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "canvas-editor-step-canvas",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    className: "canvas-editor-step-canvas-frame",
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $395d89d67d098b23$export$e3d016329f8674e7), {
                        canvasEditorProps: {
                            projectId: project.id,
                            plotShape: project.plotShape,
                            elements: elementsList,
                            plotShapeEditable: false,
                            currentMode: currentMode,
                            editableTypes: props.availableElementTypes,
                            selectedElementId: currentElementIndex,
                            setSelectedElementId: setCurrentElementIndex,
                            selectable: false,
                            hasMap: Boolean(project?.location?.map),
                            onElementChanged: (updatedElement)=>{
                                setElementsList((list)=>list.map((element)=>{
                                        if (element.elementId === updatedElement.elementId) return {
                                            ...element,
                                            ...updatedElement
                                        };
                                        else return element;
                                    }));
                            },
                            transformerLayerProps: transformerProps,
                            activeDraggableElement: {
                                elementTypeId: currentElementType,
                                temaplateId: draggableElement
                            },
                            onDraggableElementChange: setDraggableElement,
                            onDragEnd: ()=>{}
                        },
                        tool: tool,
                        onElementDrawn: (shape)=>{
                            setElementsList((elementsList)=>[
                                    ...elementsList,
                                    {
                                        type: currentElementType,
                                        shapeType: shape.type,
                                        props: shape.props,
                                        elementId: Date.now(),
                                        name: currentElementName === '' ? intl.formatMessage({
                                            id: `elementName-${currentElementType}`
                                        }) : currentElementName,
                                        template: draggableElement
                                    }
                                ]);
                            setTool(null);
                        // setCurrentElementName(
                        //   currentElementName === ''
                        //     ? intl.formatMessage({id: `elementName-${currentElementType}`})
                        //     : currentElementName
                        // )
                        }
                    })
                })
            })
        ]
    });
}


function $4d176004a991ca7c$export$d8823776fba9c96b() {
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7c8a10e768eadb0$export$2d003b3d2748ba71), {
        availableElementTypes: (0, $670e204136b37e30$export$9544d5bb712b01ea).getSectorElementTypes()
    });
}



parcelRequire("ltGt3");


const $5f19c843348431c2$var$validateMessages = {
    required: '${label} is required!'
};
function $5f19c843348431c2$export$8ddb6c216a54fb67() {
    const { project: project } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('project');
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e8a81dc5c286a0b4$export$b0a6aac4fb7b7221), {
            project: project
        })
    });
}


/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 

var $ltGt3 = parcelRequire("ltGt3");







var $1b3f73a07b1faf2e$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem'
];
function $1b3f73a07b1faf2e$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $6bfecfb8d11a0816$export$4ee1db8ce44a209b)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $6bfecfb8d11a0816$export$d697c39a2985a4c)(options, $1b3f73a07b1faf2e$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $1b3f73a07b1faf2e$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $1b3f73a07b1faf2e$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $6e50856a3f9e8f8c$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $1b3f73a07b1faf2e$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $1b3f73a07b1faf2e$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $6e50856a3f9e8f8c$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return [];
}





var $85db74b05ab481f0$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $85db74b05ab481f0$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $6bfecfb8d11a0816$export$4ee1db8ce44a209b)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $6bfecfb8d11a0816$export$d697c39a2985a4c)(options, $85db74b05ab481f0$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $85db74b05ab481f0$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $54a41c29fe456628$export$7369836851cc1329)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $54a41c29fe456628$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $85db74b05ab481f0$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $6e50856a3f9e8f8c$export$e3b7eee1dbc44895)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}





var $c214f26314ccdb25$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $c214f26314ccdb25$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $6bfecfb8d11a0816$export$4ee1db8ce44a209b)(formats, type, format, onError));
    var filteredOptions = (0, $6bfecfb8d11a0816$export$d697c39a2985a4c)(options, $c214f26314ccdb25$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $c214f26314ccdb25$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $c214f26314ccdb25$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $6e50856a3f9e8f8c$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $c214f26314ccdb25$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $c214f26314ccdb25$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $6e50856a3f9e8f8c$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $c214f26314ccdb25$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $6bfecfb8d11a0816$export$d697c39a2985a4c)(options, $c214f26314ccdb25$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $6e50856a3f9e8f8c$export$e3b7eee1dbc44895)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $c214f26314ccdb25$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $c214f26314ccdb25$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $6e50856a3f9e8f8c$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $c214f26314ccdb25$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $c214f26314ccdb25$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $6e50856a3f9e8f8c$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return [];
}





var $1209865dd6ac1b2b$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $1209865dd6ac1b2b$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $54a41c29fe456628$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $54a41c29fe456628$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $6bfecfb8d11a0816$export$d697c39a2985a4c)(options, $1209865dd6ac1b2b$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $6e50856a3f9e8f8c$export$e3b7eee1dbc44895)('Error formatting plural.', locale, e));
    }
    return 'other';
}







function $ce754347136935aa$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $ce754347136935aa$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $ce754347136935aa$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $d9fb39cdb8f28949$export$d342343268debc40).formats;
    return (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, mfFormats), f1), {
        date: $ce754347136935aa$var$deepMergeOptions($ce754347136935aa$var$setTimeZoneInOptions(mfFormats.date, timeZone), $ce754347136935aa$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $ce754347136935aa$var$deepMergeOptions($ce754347136935aa$var$setTimeZoneInOptions(mfFormats.time, timeZone), $ce754347136935aa$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $ce754347136935aa$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $5ce90fd99210cb3b$export$f5708dca728d7177)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $7586ed0c7ce7f1de$export$b87f371cbc396fcf).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, defaultRichTextElements), values || {});
    formats = $ce754347136935aa$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $ce754347136935aa$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $6e50856a3f9e8f8c$export$2ddcb436d0aa3688)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $6e50856a3f9e8f8c$export$74a601a3d3f31621)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $d92d5619ced5d58e$export$18ce0697a983be9b)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $6e50856a3f9e8f8c$export$74a601a3d3f31621)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $6e50856a3f9e8f8c$export$74a601a3d3f31621)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};






var $460efa66e15dbe67$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $460efa66e15dbe67$var$now = Date.now();
function $460efa66e15dbe67$var$generateToken(i) {
    return "".concat($460efa66e15dbe67$var$now, "_").concat(i, "_").concat($460efa66e15dbe67$var$now);
}
function $460efa66e15dbe67$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $460efa66e15dbe67$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $460efa66e15dbe67$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $54a41c29fe456628$export$7369836851cc1329)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $54a41c29fe456628$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $6bfecfb8d11a0816$export$d697c39a2985a4c)(options, $460efa66e15dbe67$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $460efa66e15dbe67$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $6e50856a3f9e8f8c$export$e3b7eee1dbc44895)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}





var $c2cdc015e7469958$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $c2cdc015e7469958$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $54a41c29fe456628$export$7369836851cc1329)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $54a41c29fe456628$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $6bfecfb8d11a0816$export$d697c39a2985a4c)(options, $c2cdc015e7469958$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $6e50856a3f9e8f8c$export$e3b7eee1dbc44895)('Error formatting display name.', locale, e));
    }
}


function $33cef5007fd8c1db$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $33cef5007fd8c1db$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $33cef5007fd8c1db$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $33cef5007fd8c1db$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $6bfecfb8d11a0816$export$c3f4cd5551df13fd)(cache);
    var resolvedConfig = (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, (0, $6bfecfb8d11a0816$export$b52f8d6fc0d47415)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $6e50856a3f9e8f8c$export$3ca04dd7fb305893)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $6e50856a3f9e8f8c$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $6e50856a3f9e8f8c$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $33cef5007fd8c1db$var$verifyConfigMessages(resolvedConfig);
    return (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $1b3f73a07b1faf2e$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $1b3f73a07b1faf2e$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $85db74b05ab481f0$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $c214f26314ccdb25$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $c214f26314ccdb25$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $c214f26314ccdb25$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $c214f26314ccdb25$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $c214f26314ccdb25$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $1209865dd6ac1b2b$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $ce754347136935aa$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $ce754347136935aa$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $460efa66e15dbe67$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $460efa66e15dbe67$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $c2cdc015e7469958$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}



function $60e07c536e35ad98$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $60e07c536e35ad98$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $5704e94fd88393f9$export$df0c12a2d414a163)(v) ? (0, $854e3ebeaed1c3ee$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
var $60e07c536e35ad98$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $60e07c536e35ad98$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $ce754347136935aa$export$25868d1e8e76735f).apply(void 0, (0, $d92d5619ced5d58e$export$1216008129fb82ed)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $ltGt3.Children.toArray(chunks);
    return chunks;
};
var $60e07c536e35ad98$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $d92d5619ced5d58e$export$3c9a16f847548506)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $60e07c536e35ad98$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $33cef5007fd8c1db$export$7e4cbedfdd7b4c0d)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, (0, $854e3ebeaed1c3ee$export$b52f8d6fc0d47415)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $d92d5619ced5d58e$export$18ce0697a983be9b)((0, $d92d5619ced5d58e$export$18ce0697a983be9b)({}, coreIntl), {
        // @ts-expect-error fix this
        formatMessage: $60e07c536e35ad98$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $60e07c536e35ad98$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
var $60e07c536e35ad98$var$IntlProvider = /** @class */ function(_super) {
    (0, $d92d5619ced5d58e$export$a8ba968b8961cb8a)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $6bfecfb8d11a0816$export$51c4f4e973f2dc00)();
        _this.state = {
            cache: _this.cache,
            intl: $60e07c536e35ad98$export$7e4cbedfdd7b4c0d($60e07c536e35ad98$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $60e07c536e35ad98$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $60e07c536e35ad98$var$processIntlConfig(props);
        if (!(0, $854e3ebeaed1c3ee$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: $60e07c536e35ad98$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $854e3ebeaed1c3ee$export$45c4bbf6e55bba1f)(this.state.intl);
        return $ltGt3.createElement((0, $bc0361bb479b8e2e$export$2881499e37b75b9a), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $854e3ebeaed1c3ee$export$b52f8d6fc0d47415);
    return IntlProvider;
}($ltGt3.PureComponent);
var $60e07c536e35ad98$export$2e2bcd8739ae039 = $60e07c536e35ad98$var$IntlProvider;


var $c71c6b81b4aafe7a$exports = {};
$c71c6b81b4aafe7a$exports = JSON.parse('{"1000Plants":"1000+ plants in database","1000PlantsDescription":"Add plants from the database, use plant information and care suggestions","actions":"Actions","add":"Add","apply":"Apply","applyGardenPlanTitle":"Apply the plan \\"{planName}\\" to the project?","applyGardenPlanDescription":"The plan\'s plants will be moved to the main project, and the plan will be deleted.","addCollection":"Add collection","addEvent":"Add event","addFromPlantDatabase":"Add plant from Database","addingNewPlant":"Adding new plant","addingNewTask":"Adding new task","additionalCareSteps":"Additional care steps","addNewEvent":"Add new event","addNewTask":"Add new task","addPlant":"Add plant","addPlantSpecimen":"Add plant specimen","addTask":"Add task","advantages":"Advantages","advicePlotMapFirst":"Tip: For more precise plot placement, display a map. Map usage can be enabled in Step 1.","afterDiggingThePlantWillBeTransferredToTheUnplantedOnes":"After digging, the plant will be transferred to the unplanted ones.","afterRemovingThePlantWillBeTransferredToTheUnplantedOnes":"After digging, the plant will be transferred to the unplanted ones.","allNews":"All news","allPlannedTasks":"All planned tasks","allProjects":"All projects","allReminders":"All reminders","allTutorials":"All tutorials","allUsefulMaterials":"All useful materials","appearance":"Appearance","applicationInDesign":"Application in design","applyingFertilizer":"Applying fertilizer","areYouSureYouWantToDelete":"Are you sure you want to delete?","areYouSureYouWantToDeleteThisPlan":"Are you sure you want to delete this plan variant?","areYouSureYouWantToDeleteThisCollection":"Are you sure you want to delete this collection?","areYouSureYouWantToDeleteThisType":"Are you sure you want to delete this type?","areYouSureYouWantToDeleteThisEvent":"Are you sure you want to delete this event?","areYouSureYouWantToDigUpAllTheSpecimensOfThisPlant":"Are you sure you want to dig up all the specimens of this plant?","areYouSureYouWantToFinish":"Are you sure you want to finish task?","areYouSureYouWantToMakeSnapshot":"Are you sure you want to make snapshot?","attitudeToLight":"Attitude to light","basePlant":"Base plant","basePlant-tooltip":"When you select a base plant, your plant\'s fields will be updated with information from the TerraSketch database associated with that plant. You can add to or edit this information. Changes you make are visible only to you.","building":"Building","buildingPlural":"Buildings","bush":"Bush","bushPlural":"Bushes","bushCat":"Bushes and grasses","bushCatPlural":"Bushes and grasses","byClickingLogInWithGoogle":"By clicking Log in with Google above, you acknowledge that you have read and understood, and agree to ","byClickingSignUpWithGoogle":"By clicking Sign up with Google above, you acknowledge that you have read and understood, and agree to ","cancel":"Cancel","canvasDataDescriptionSeparatlyGrowing":"having a record in the list of plants and a model on the plan","canvasDataDescriptionSolitariusTemplates":"can be linked to a plant record by clicking on ","canvasDataDescriptionOther":"Other site elements","care":"Care","careDifficulty":"care difficulty","carePlan":"Care plan","category":"Category","center":"Center","changeBasePlant":"Change base plant","changePassword":"Change password","changeProjectLocation":"Change project location","characteristics":"Characteristics","checkAllPlantsFromTheCollection":"Check all plants from the collection","checkYourEmail":"Please check your email to continue.","chooseMode":"Choose mode","chooseObjectType":"Choose object type","chooseObjectForm":"Choose object form","choosePlotType":"Choose plot type","chooseProjectImage":"Choose project image","chooseType":"Choose type","clearBasePlant":"Cleare base plant","clearBasePlantMatchingFields":"Clear also fields pre-filled based on this base plant","clearFilters":"Clear filters","clearSorting":"Clear sorting","closeEvent":"Close event","cm":"cm","collections":"\u0421ollections","collections-tooltip":"collections","combineElementWithPlant":"Combine an element with a plant","comment":"Comment","commonInfo":"Common info","completedActions":"Completed actions","confidenceInPlantVariety":"Confidence in plant variety","confirm":"Confirm","confirmClearBasePlant":"Do you really want to clear the base plant","confirmFormCloseTitle":"Do you really want to close the plant editing form?","contacts":"Contact us","continue":"Continue","continueWithoutSaving":"Continue without saving","court":"Court","createATaskListAssociatedWithTheProjectAndEnterTheFirstTask":"Create a task list associated with the project and enter the first task","createElement":"Create","createNewProject":"Create new project","createFirstProject":"Create your first project","createFirstTask":"Create your first task","createFromTemplate":"Create from template","createTheFirstPlantInTheProject":"Create the first plant in the project","createPolygonPlot":"Create polygon plot","createYourFirstProjectDescription1":"For ease of work in TerraSketch, everything is organized within projects.","createYourFirstProjectDescription2":"To get started, you just need to create a new project. You yourself determine what is meant by the project. This could be a plot, a house, a separate flower bed, and so on.","createYourFirstProjectDescription3":"You can work with each project separately, create a plan for placing objects, mark planting locations, and plan tasks. In the Reminders, Plants, Journal sections you can work with a summary of data for all projects at once.","createYourFirstProjectDescription4":"We recommend starting with the maximum scale of the project (for example, the entire site), and then, if necessary, separating individual parts into different projects.","creatingOfNewProject":"Creating of New Project","critical":"critical","date":"Date","dateOfEvent":"Date of event","dateOfPlanting":"Date of planting","dateOfPlantingUtc":"Date of planting","dateRange":"Date range","defaultProjectWithoutPlans":"Default project (without plans)","delete":"Delete","deleteAccount":"Delete account","deleteElement":"Delete","deleteEvent":"Delete the event","deletePlant":"Delete plant","deletePlantConfirm":"Do you really want to delete this plant?","deletePlantEventsConfirm":"Also delete from the journal all events associated with this plant","deletePlantFromToDoConfirm":"The reference to this plant will be removed from the tasks.","deleteProject":"Delete project","deleteProjectWithPlantsAndEventsConfirm":"Also delete from the journal all events associated with these plants","deleteProjectWithPlantsConfirm":"Also delete all plants associated with this project","description":"Description","digUpAllPlantSpecimens":"Dig up all plant specimens","digUpPlant":"Dig up the plant","disadvantages":"Disadvantages","disease":"Disease","doYouReallyWantToDelete":"Do you really want to delete","doYouReallyWantToDeleteThisAccount":"Do you want to delete this account?","doYouWantToSaveTheProjectBeforeMovingOnToTheNextStep":"Do you want to save the project before moving on to the next step? Unsaved changes will be lost.","draw":"Draw","duplicatePlant":"Duplicate plant","edge":"Edge","edibility":"Edibility","edit":"Edit","editedInAnotherStep":"The selected element is edited in another step","editElement":"Edit","editGardenPlan":"Rename plan variant","editingPlant":"Plant editing","editor":"Plot editor","editPlant":"Edit plant","editProject":"Edit project","editStepDefGenInfo":"Enter general information about the project.","editStepDefPlot":"Create a plot base.","editStepDefSoftscape":"Create softscape elements.","editStepDefBuildings":"Create buildings and fences.","editStepDefHardscape":"Create hardscape elements.","editStepDefLargePlants":"Place large plants.","editStepDefWaterscape":"Create waterscape elements.","editStepDefSolitarius":"Place individual plants.","editStepDefOtherElements":"Create other elements.","editTask":"Edit task","ellipse":"Ellipse","email":"Email","emailIsIncorrect":"The value entered is not a valid email address.","emailUs":"Email us","endDate":"End date","enterObjectName":"Enter object name","enterProjectLocation":"Enter project location","enterPlotEdgesDimensions":"Enter plot edges dimensions","enterResetEmail":"Enter your email to reset your password","entrance":"Entrance","entrancePlural":"Entrances","errorDuringLogin":"Login error","eventCategory":"Event category","eventEndDate":"Event end date","eventInfo":"Event info","eventName":"Name of event","eventPhotos":"Photos","eventType":"Type of event","failedToDeleteTask":"failed to delete task","family":"Family","familyRu":"Family (ru)","familyLa":"Family","faq":"Frequently Asked Questions","faqAnswer1":"The basic functionality of the product is free for all users. There are paid plans that add additional features, such as uploading more of your photos.","faqAnswer2":"The plant database is filled in by our experts and is updated daily with new specimens. All photographs posted in the plant database represent unique content, obtained by the product developers and belong to the copyright holder of the product.","faqAnswer3":"At the moment, the mobile application is under development. Users have access to a mobile version of the site, adapted for use on small screens.","faqAnswer4":"User data belongs exclusively to users, is stored on the server, is not used in the product\'s plant database, and is not available to other users.","faqQuestion1":"Is the product paid?","faqQuestion2":"Where does the information in the plant database come from?","faqQuestion3":"Is there a mobile application TerraSketch?","faqQuestion4":"How my data is used and who has access to it?","featuresOfCultivation":"Features of cultivation","featuresOfFruitStorage":"Features of fruit storage","featuresOfStoringPlantingMaterial":"Features of storing planting material","fence":"Fence","fertilizerFrequency":"Fertilizer frequency","fertilizers":"Fertilizers","fieldIsRequired":"The field {field} is required","filter":"Filter","filters":"Filters","filtersAndSorting":"Filters and sorting","filtersUp":"Filters","finish":"Finish","finishTask":"Finish task","finishToDo":"Finish ToDo and put it in journal","flowerbed":"Flowerbed","flowerbedPlural":"Flowerbeds","flowerCat":"Flowers","flowerColor":"Flower color","flowersPhotos":"Flowers photos","flowerSize":"Flower size","forgotPassword":"Forgot password","formModifiedButNotSaved":"Plant was modified, but not saved.","from":"from","from2":"from","fruiting":"Fruiting","fruitingTime":"Fruiting time","fruitMass":"Fruit mass","fruitsPhotos":"Fruits photos","furniture":"Furniture","furniturePlural":"Furniture","g":"g","cards":"Cards","gallery":"Gallery","garden":"Garden","gardenPlan":"Garden plan","gardenPlanVariantsHint":"Plan variants let you add planned but not yet planted vegetation and compare different planting options. Only one variant can be displayed at a time. A variant can be applied to the project, at which point it becomes part of it.","gardeningWork":"Gardening work","gardenPlural":"Gardens","gardenJournal":"Garden Journal","gardenJournalDescription":"Keep records of your plants and their growth history over many years","greenhouse":"Greenhouse","growing-conditions":"Growing conditions","growthRate":"Growth rate","home":"Home","hedge":"Hedge","hedgePlural":"Hedges","height":"Height","hideElementOnSitePlan":"Hide element on site plan","hideGardenPlanVariantPlants":"Hide plants from plan variants","hidePlantOnSitePlan":"Hide plant on site plan","ifYouDontHaveAccount":"If you don\'t have account ","ifYouHaveAccount":"If you already have an account ","importance":"Importance","informationAboutWhichPlantsBelongedToThisCollectionWillAlsoBeRemoved":"Information about which plants belonged to this collection will also be removed.","isRequired":"is required","journal":"Journal","landingPlantHydrangea":"Bigleaf hydrangea Madame Emile Mouillere","landingPlantBerberis":"Japanese barberry Admiration","landingPlantSymphotrichum":"Aster dumosus","landingPlantCrocus":"Crocus","landingPlantDasiphora":"Dasiphora fruticosa Pink Beauty","landingPlantAnemone":"Anemone hybrida","landingPlantSedum":"Hylotelephium spectabile","lastWeek":"Last week","lastMonth":"Last month","last90days":"Last 90 days","lastYear":"Last year","leafColor":"Leaf color","leafPhotos":"Leaf photos","length":"Length","lifeCycle":"Life cycle","lighting":"Lighting","lightingPlural":"Lighting","location":"Location","locationPlant":"Location","locationReference":"Location - reference to geographic coordinates","locationReferenceInfo":"You can use the project location to add a terrain map to your project and display the current weather conditions in your area.","logIn":"Log in","logInWithGoogle":"Log in with Google","logOut":"Log out","low":"low","lawn":"Lawn","lawnPlural":"Lawns","m":"m","mainInfo":"Main info","makeSnapshot":"Make snapshot","makingSnapshotDescription":"A project snapshot is an unedited copy of a project as of a specific date. The copy contains a list of sites and plants located on the project.","mapCoordinatesWillBeReset":"Map coordinates will be reset","mapNotFound":"Map not found. Save the map in step 1 of editing the project.","medicalProperties":"Medical properties","meter":"meter(s)","metricSystem":"Metric system","myCollections":"My collections","myPhotos":"My photos","myPlants":"My plants","myPlantTimeline":"My plant timeline","myProjects":"My projects","mySnapshots":"My snapshots","myToDos":"My ToDos","name":"Name","nameOfTask":"Name of task","next":"Next","newCollection":"New collection","newGardenPlan":"New plan variant","newPassword":"New password","news":"News","newTaskAdding":"New task adding","newTaskList":"Create new task list","newTypeName":"New type name","newList":"New List","no":"no","noEntries":"no entries","noInformationAboutProjectLocation":"no information about project location","normal":"normal","noTemplatesForThisType":"There are no templates for this type","noTitle":"no title","notPlanted":"not planted","nowUsingBasePlant":"Base plant used","objectName":"Object name","objectParameters":"Object parameters","objectType":"Object type","onElement":"on element","onlineEditor":"Online plot editor","onlineEditorDescription":"Create a plan for your plot and track planted plants on it","openPlantDescription":"Open plant description","other":"Other","otherPlural":"Other","otherNames":"Other names","otherNews":"Other news","otherSiteElements":"Other site elements","overview":"Overview","overwriteBasePlant":"Overwrite base plant","password":"Password","passwordMismatch":"Password mismatch","pastEvents":"Past events","pathway":"Pathway","pathwayPlural":"Pathways","patio":"Patio","pesticides":"Pesticides","pesticideTreatmentFrequency":"Pesticide Treatment Frequency","pests":"Pests","passwordValidation":"Use Latin letters (a\u2013z, A\u2013Z), at least one number, and at least 6 characters.","photos":"Photos","placeTheMap":"Place the map in the window so that it covers the entire territory that you need in the future for planning the site (the site itself, adjacent roads, etc.)","plantFromGardenPlan":"The plant was added in the selected plan variant and is not part of the original project","gardenPlanTag":"Plan","plantIsCreatedInGardenPlan":"The plant is being created within the plan variant \\"{planName}\\"","planningModeWarning":"You are in planning mode: plants will be saved within the selected plan variant without being added to the original project. You can\'t move plants from the original project in this mode.","plannedCompletionDate":"Planned completion date","plannedTasks":"Planned tasks","plant":"Plant","plant-health":"Plant health","plantcomposition":"Plant composition","plantcompositionPlural":"Plant compositions","plantDatabase":"Plant database","plantDesignationOnTheMap":"Designation on the map","planted":"planted","plantedDate":"Date of planting","plantedIn":"Planted in the project","plantedPlants":"Planted plants","plantingAndReproduction":"Planting and reproduction","plantingDepth":"Planting depth","plantingSeedlingsInClosedGround":"planting seedlings in closed ground","plantingSeedlingsInOpenedGround":"planting in opened ground","plantingWork":"Planting work","plantModelWithoutPlantRecord":"Plant model without plant record","plantName":"Name of plant","plantName-tooltip":"Name of plant","plantPageWorkWithTodo":"Working with tasks from the plant page","plantPhotos":"Photos","plantPlant":"Plant the plant","plants":"Plants","plantsTaskList":"Other tasks related to plants","plantTypeDistributionDiagram":"Plant type distribution diagram","plotWillBeDeleted":"plot will be deleted","policy":"Terms and Privacy Policy","policyTerrasketch":"TerraSketch\'s Terms and Privacy Policy","polygon":"Polygon","pond":"Pond","pool":"Pool/Pond","preserveMapCoordinates":"Preserve map coordinates","project":"Project","projectChangedSaveBeforeProceedingToTheNextStep":"The project has been modified. Save before proceeding to the next step.","projectComposition":"Project composition","projectCoordinates":"Coordinates","projectDescription":"Project description","projectIsNotSaved":"The project contains unsaved changes.","projectName":"Project name","projectPage":"Project page","projectPageTour":"How to work with the project?","projectPageTourDescriptionAll":"On the project page, you can view individual elements of the project, add new plants and mark them on the plan.","projectPageTourDescriptionEdit":"Switch to project editing mode. In this mode, it is possible to edit the project description, place new and edit already added site elements.","projectPageTourDescriptionAddPlant":"When adding a new plant, you can use the information from the TerraSketch database as a basis, or you can create an entry from scratch.","projectPageTourDescriptionCanvas":"Planting a plant means placing it on the project plan. To plant a plant, you need to add a record about it to the project, then select this record in the \'Unplanted Plants\' tab and click the \'Plant the plant\' button.","projectPageTourDescriptionSnapshot":"You can save the current state of the site as a project snapshot. We recommend taking a photo at least once per season.","projectPageTourDescriptionReminders":"The 10 most pressing tasks associated with this project are displayed. You work with the list of tasks on the To-Do Lists page.","projects":"Projects","projectOverview":"Project overview","projectsOverview":"Projects overview","projectSketch":"Project sketch","projectSnapshot":"Project snapshot","projectReminders":"Project reminders","propagation-planting":"Propagation & Planting","properties":"Properties","purposeLocation":"Purpose/location","putObjectOnThePlan":"Put object on the plan","rect":"Rectangle","reminders":"Reminders","removePlantSpecimen":"Remove plant specimen","repeatPassword":"repeat password","repeatNewPassword":"Repeat new password","replantPlant":"Replant the plant","reproductionMethods":"Reproduction methods","requiredField":"${label} is required!","resetFilters":"Reset filters","resetPassword":"Reset password","ruler":"Ruler","save":"Save","saveAndContinue":"Save and continue","saveEvent":"Save event","searchForBasePlant":"Enter a name to search in the plant database","searchForLocation":"Search for location","searchForNews":"Search for news","searchingPlantBase":"Searching in plant base","seeAllProjects":"See all projects","seeAllReminders":"See all reminders","select":"Select","selectAnObjectForEditing":"Select an object for editing","selectAnElementForDeleting":"Select an element for deleting","selectPlantsFromTheMarkedCollections":"Select plants from the marked collections","selectPlantForConnection":"Select plant for connection with ","selectPlantForConnectionNote":"Note: After clicking the \'OK\' button, the display of all instances of the selected plant will change.","selectTemplateOrDrawingTool":"Select template or drawing tool","selectTheTaskCompletionDate":"Select the task completion date","sendEmailToResetPassword":"Send an email to reset your password","separatelyGrowing":"Separately growing","showGridWithSpacing":"Show grid with spacing ","showMap":"Show map","showElementOnSitePlan":"Show element on site plan","showPlantOnSitePlan":"Show plant on site plan","side":"Side","signUpWithGoogle":"Sign up with Google","signUp":"Sign Up","size-appearance":"Size & Appearance","sloganElevate":"Elevate your gardening experience","snapshot":"Snapshot","snapshots":"Snapshots","soil":"Soil (substrate)","solitarius":"Solitarius","sortBy":"Sort by","sorting":"Sorting","sortingBy":"Sorting by","sortingDirectionAsc":"ascending","sortingDirectionDesc":"descending","specification":"specification","spreading":"Spreading","stairs":"Stairs","stairsPlural":"Stairs","startDate":"Start date","startToday":"Start today","step":"Step","structure":"Garden structure","structurePlural":"Garden structures","subSloganElevate":"Discover TerraSketch, where we transform the way you plan and care for your garden. Our platform not only helps you visualize your dream garden but also supports you through every step of its growth. Start your journey with TerraSketch today and watch your garden flourish.","table":"Table","tag-news":"news","tag-tutorials":"tutorials","taskDeleting":"Task deleting","taskDescription":"Task description","taskEditing":"Task editing","taskFinishing":"Task finishing","taskPlanner":"Task planner","taskPlannerDescription":"Make to-do lists for your areas and monitor the condition of your plants","taxonomy":"Taxonomy","taskAndEventFilters":"Task and event filters","taskType":"Task type","taskTypes":"Task types","terrace":"Terrace","terracePlural":"Terraces","terraSketchEditor":"TerraSketch Online Editor","terraSketchEditorDescription1":"Begin your gardening journey by creating a comprehensive plan for your plot","terraSketchEditorDescription2":"Mark and catalog the plants you\'ve introduced to your garden","terraSketchEditorDescription3":"Use your planting history to organize proper crop rotations","terraSketchEditorDescription4":"Estimate the volume of planting materials and consumables needed for your garden projects","terraSketchEditorDescription5":"Save snapshots of your plot at specific dates to document how it grows and evolves over time","terraSketchTaskPlanner":"TerraSketch Task Planner","terraSketchTaskPlannerDescription1":"Create customized lists for your garden area, organizing tasks to align perfectly with your garden\'s unique requirements","terraSketchTaskPlannerDescription2":"Keep a close eye on the health and condition of your plants","terraSketchTaskPlannerDescription3":"Document the growth and development stages of your plants using specialized timelines","terraSketchTaskPlannerDescription4":"Look back on your garden\'s history with the gardener\'s journal","terraSketchPlantDatabase":"TerraSketch Plants Database","terraSketchPlantDatabaseDescription":"Explore the heart of TerraSketch \u2014 our meticulously curated plant database, where over 1,000 entries await to inspire and guide your gardening journey. Each entry, crafted with care by our product developers, features photographs, detailed descriptions, and tailored care recommendations. Grow the garden of your dreams with TerraSketch, where every plant inspires and tells a story.","theLatestPostsAndGuides":"The latest posts and guides. Select an article to read the full text.","thePlantIsInTheProject":"The plant is in the project","thePlantWasRemovedByTheUser":"The plant was removed by the user","thisIsTheOnlyPlantedSpecimenOfThisPlant":"This is the only planted specimen of this plant.","thisOperationIsIrreversible":"This operation is irreversible.","thisOperationWillMoveTask":"This operation will move the task to the journal.","thisMonth":"This month","thisWeek":"This week","tile":"Tile","tilePlural":"Tiles","timeForPlantingSeedlingsInClosedGround":"Time for planting seedlings in closed ground","timeForPlantingSeedlingsInOpenedGround":"Time for planting seedlings in opened ground","today":"Today","todoGroup-overdue":"Overdue","todoGroup-today":"Today","todoGroup-tomorrow":"Tomorrow","todoGroup-laterThisWeek":"Later this week","todoGroup-laterThisMonth":"Later this month","todoGroup-nextMonth":"Next month","todoGroup-later":"Later","todoGroup-noDate":"No date","toDisplayWeather":"To display weather and related recommendations, enter the project location in settings","todoLists":"To-Do Lists","todoPage":"To-Do Page","todoPageTour":"How to work with To-Do tasks?","todoPageTourDescriptionAll":"\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0437\u0430\u0434\u0430\u0447 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C, \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438 \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0438, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0441 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F\u043C\u0438 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u0440\u0430\u0431\u043E\u0442\u0430\u043C\u0438.","todoPageTourDescriptionAdd":"\u041F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u043D\u043E\u0432\u043E\u0439 \u0437\u0430\u0434\u0430\u0447\u0438 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043E\u0434\u0438\u043D \u0438\u0437 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0445 \u0442\u0438\u043F\u043E\u0432 (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u043E\u0431\u0440\u0435\u0437\u043A\u0430) \u0438\u043B\u0438 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0432\u043E\u0439. \u0422\u0438\u043F\u044B \u043F\u043E\u043C\u043E\u0433\u0430\u044E\u0442 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C \u0436\u0438\u0437\u043D\u0435\u043D\u043D\u044B\u0439 \u0446\u0438\u043A\u043B \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0440\u0430\u0437\u043D\u044B\u0435 \u0437\u0430\u0434\u0430\u0447\u0438 \u043F\u043E \u0441\u0430\u0434\u0443. \u0422\u0430\u043A\u0436\u0435 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0432\u044F\u0437\u0430\u0442\u044C \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0435\u043C\u0443\u044E \u0437\u0430\u0434\u0430\u0447\u0443 \u0441 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u043C\u0438 \u0432\u0430\u043C\u0438 \u0440\u0430\u043D\u0435\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F\u043C\u0438, \u0437\u0430\u0434\u0430\u0442\u044C \u0436\u0435\u043B\u0430\u0435\u043C\u044B\u0435 \u0441\u0440\u043E\u043A\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0438 \u043F\u0435\u0440\u0432\u043E\u043E\u0447\u0435\u0440\u0435\u0434\u043D\u043E\u0441\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0438.","todoPageTourDescriptionList":"\u0412\u0441\u0435 \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0435 \u0440\u0430\u043D\u0435\u0435 \u0437\u0430\u0434\u0430\u0447\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0432 \u0432\u0438\u0434\u0435 \u043A\u0430\u0440\u0442\u043E\u0447\u0435\u043A.","todoPageTourDescriptionFilter":"\u0418\u0441\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0444\u0438\u043B\u044C\u0442\u0440 \u0438 \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0443 \u0434\u043B\u044F \u043F\u043E\u0432\u044B\u0448\u0435\u043D\u0438\u044F \u044D\u0444\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0441\u0432\u043E\u0435\u0439 \u0440\u0430\u0431\u043E\u0442\u044B. \u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0438, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0441 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u043C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 \u0437\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435 \u0432\u044B\u0445\u043E\u0434\u043D\u044B\u0435.","todoPageTourDescriptionEdit":"\u0414\u043B\u044F \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0438 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0431\u043E\u043B\u0435\u0435 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u0437\u0430\u0434\u0430\u0447\u0435 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0437\u043D\u0430\u0447\u043E\u043A \u043A\u0430\u0440\u0430\u043D\u0434\u0430\u0448\u0430 \u043D\u0430 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0435 \u0437\u0430\u0434\u0430\u0447\u0438.","todoPageTourDescriptionEndTask1":"\u0427\u0442\u043E\u0431\u044B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0437\u043D\u0430\u0447\u043E\u043A \u043F\u0442\u0438\u0447\u043A\u0438. \u041F\u0440\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0443\u043A\u0430\u0436\u0438\u0442\u0435 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0443\u044E \u0434\u0430\u0442\u0443 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438, \u043F\u0440\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438, \u0438\u0441\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0442\u0438\u043F \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u043E\u0439 \u0437\u0430\u0434\u0430\u0447\u0438. ","todoPageTourDescriptionEndTask2":"\u041F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0437\u0430\u0434\u0430\u0447\u0430 \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u0431\u044B\u0442\u0438\u0435, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u043E \u0432 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u0443\u044E \u0432\u0430\u043C\u0438 \u0434\u0430\u0442\u0443. \u0415\u0441\u043B\u0438 \u0437\u0430\u0434\u0430\u0447\u0430 \u0431\u044B\u043B\u0430 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u0430 \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043A \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u043C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F\u043C, \u0442\u043E \u043F\u0440\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0437\u0430\u0434\u0430\u0447\u0438 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0435\u0442 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0438\u0437 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439. ","todoPageTourDescriptionEndTask3":"\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u0434\u0430\u0447 (\u0441\u043E\u0431\u044B\u0442\u0438\u0439) \u0432 \u0414\u043D\u0435\u0432\u043D\u0438\u043A\u0435 \u0438\u043B\u0438 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0433\u043E \u0441 \u0437\u0430\u0434\u0430\u0447\u0435\u0439 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F.","todoPageTourDescriptionDeleteTask":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0437\u0430\u0434\u0430\u0447\u0443 \u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0436\u0430\u0432 \u043D\u0430 \u0437\u043D\u0430\u0447\u043E\u043A \u043A\u043E\u0440\u0437\u0438\u043D\u044B. \u041F\u0440\u0438 \u044D\u0442\u043E\u043C \u0437\u0430\u0434\u0430\u0447\u0430 \u043D\u0435 \u043F\u043E\u043F\u0430\u0434\u0435\u0442 \u0432 \u0434\u043D\u0435\u0432\u043D\u0438\u043A, \u0430 \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u0430 \u0431\u0435\u0437 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.","todoPageTourDescriptionPlantPage":"\u0420\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0441 \u0437\u0430\u0434\u0430\u0447\u0430\u043C\u0438 \u043C\u043E\u0436\u043D\u043E \u0442\u0430\u043A\u0436\u0435 \u0441\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u0432\u0430\u043C\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439. \u0412\u0441\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445, \u043E\u0442\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0438\u043B\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0445 \u0442\u0430\u043A\u0438\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u0437\u0430\u0434\u0430\u0447\u0430\u0445 \u0431\u0443\u0434\u0435\u0442 \u0432\u0438\u0434\u043D\u0430 \u0442\u0430\u043A\u0436\u0435 \u0438 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u041C\u043E\u0438 \u0441\u043F\u0438\u0441\u043A\u0438 \u0437\u0430\u0434\u0430\u0447.","totalPlantsInTheProject":"Total plants in the project","toxicity":"Toxicity","tree":"Tree","treeCat":"Trees","treeCatPlural":"Trees","trimTime":"Trim time","type":"Type","typeOfTheCorrespondingTasksAndEventsWillBeChangedToGeneral":"The type of the corresponding tasks and events will be changed to General.","unplantedPlants":"Unplanted plants","uploadPhotos":"Upload photos","uploadPlantPhotos":"Upload plant photos","urgent":"urgent","usage":"Usage","uSDA":"USDA scale","usefulMaterials":"Useful materials","useMapForProjectCreating":"Use map for project creating","useMyCurrentLocation":"Use my current location","usePlotDrawingTool":"Use plot drawing tool","userAccount":"User account","userEmail":"User email","userInfo":"User info","userName":"User name","userSettings":"User settings","variety":"Variety","varietyEng":"Variety","vegetableCat":"Vegetables","vegetableCatPlural":"Vegetables","vegetablegarden":"Vegetable garden","vegetablegardenPlural":"Vegetable gardens","water":"Water - other elements","waterPlural":"Water","watering":"Watering","width":"Width","yes":"yes","yourActionsCannotBeUndone":"Your actions cannot be undone","metricSystemTooltip":"The metric system determines units, what measured values will be used in the application","userNameTooltip":"The username is only used within the application for convenience","commonName":"Common name","scienceName":"Science name","element":"Element","heightFrom":"Height from (\u043C)","heightTo":"Height to (\u043C)","height-rangeField":"Height(\u043C)","spreadingFrom":"Spreading from (\u043C)","spreadingTo":"Spreading to (\u043C)","spreading-rangeField":"Spreading (\u043C)","flowerSize-rangeField":"Flower/inflorescence size (cm)","attractionFactors":"Attraction factors","bloomingTime":"Blooming time","eventType-":" ","eventType-planting":"planting","eventType-repotting":"repotting","eventType-propagation":"propagation","eventType-seedsowing":"seed sowing","eventType-seedlingsemerge":"seedlings emerge","eventType-trueleaves":"true leaves","eventType-prickingout":"pricking out","eventType-hardeningoff":"hardening off","eventType-transplanting":"transplanting","eventType-harvesting":"harvesting","eventType-pruning":"pruning","eventType-weeding":"weeding","eventType-fertilizing":"fertilizing","eventType-blooming":"blooming","eventType-watering":"watering","eventType-chemicals":"chemicals","eventType-general":"general","eventType-buying":"buying","eventType-preplanting":"preparing planting material","eventType-winter":"preparing for winter","uSDA-0":"0","uSDA-1":"1","uSDA-2":"2","uSDA-3":"3","uSDA-4":"4","uSDA-5":"5","uSDA-6":"6","uSDA-7":"7","uSDA-8":"8","uSDA-9":"9","uSDA-10":"10","uSDA-11":"11","uSDA-12":"12","\u044F\u043D\u0432\u0430\u0440\u044C":"\u044F\u043D\u0432\u0430\u0440\u044C","\u0444\u0435\u0432\u0440\u0430\u043B\u044C":"\u0444\u0435\u0432\u0440\u0430\u043B\u044C","\u043C\u0430\u0440\u0442":"\u043C\u0430\u0440\u0442","\u0430\u043F\u0440\u0435\u043B\u044C":"\u0430\u043F\u0440\u0435\u043B\u044C","\u043C\u0430\u0439":"\u043C\u0430\u0439","\u0438\u044E\u043D\u044C":"\u0438\u044E\u043D\u044C","\u0438\u044E\u043B\u044C":"\u0438\u044E\u043B\u044C","\u0430\u0432\u0433\u0443\u0441\u0442":"\u0430\u0432\u0433\u0443\u0441\u0442","\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C":"\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C","\u043E\u043A\u0442\u044F\u0431\u0440\u044C":"\u043E\u043A\u0442\u044F\u0431\u0440\u044C","\u043D\u043E\u044F\u0431\u0440\u044C":"\u043D\u043E\u044F\u0431\u0440\u044C","\u0434\u0435\u043A\u0430\u0431\u0440\u044C":"\u0434\u0435\u043A\u0430\u0431\u0440\u044C","\u043F\u043E\u0441\u043B\u0435 \u043C\u0438\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0433\u0440\u043E\u0437\u044B \u0437\u0430\u043C\u043E\u0440\u043E\u0437\u043A\u043E\u0432":"\u043F\u043E\u0441\u043B\u0435 \u043C\u0438\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0433\u0440\u043E\u0437\u044B \u0437\u0430\u043C\u043E\u0440\u043E\u0437\u043A\u043E\u0432","careDifficulty-\u043D\u0438\u0437\u043A\u0430\u044F":"\u043D\u0438\u0437\u043A\u0430\u044F","careDifficulty-\u0441\u0440\u0435\u0434\u043D\u044F\u044F":"\u0441\u0440\u0435\u0434\u043D\u044F\u044F","careDifficulty-\u0432\u044B\u0441\u043E\u043A\u0430\u044F":"\u0432\u044B\u0441\u043E\u043A\u0430\u044F","purposeLocation-\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440\u043D\u043E\u0435":"\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440\u043D\u043E\u0435","purposeLocation-\u043A\u043E\u043C\u043D\u0430\u0442\u043D\u043E\u0435":"\u043A\u043E\u043C\u043D\u0430\u0442\u043D\u043E\u0435","purposeLocation-\u0443\u043B\u0438\u0447\u043D\u043E\u0435":"\u0443\u043B\u0438\u0447\u043D\u043E\u0435","purposeLocation-\u0441\u0435\u0437\u043E\u043D\u043D\u043E\u0435":"\u0441\u0435\u0437\u043E\u043D\u043D\u043E\u0435","lifeCycle-\u043C\u043D\u043E\u0433\u043E\u043B\u0435\u0442\u043D\u0435\u0435":"\u043C\u043D\u043E\u0433\u043E\u043B\u0435\u0442\u043D\u0435\u0435","lifeCycle-\u0434\u0432\u0443\u0445\u043B\u0435\u0442\u043D\u0435\u0435":"\u0434\u0432\u0443\u0445\u043B\u0435\u0442\u043D\u0435\u0435","lifeCycle-\u043E\u0434\u043D\u043E\u043B\u0435\u0442\u043D\u0435\u0435":"\u043E\u0434\u043D\u043E\u043B\u0435\u0442\u043D\u0435\u0435","watering-\u0447\u0430\u0441\u0442\u044B\u0439":"\u0447\u0430\u0441\u0442\u044B\u0439","watering-1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E":"1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E","watering-2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E":"2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E","watering-\u0443\u043C\u0435\u0440\u0435\u043D\u043D\u044B\u0439":"\u0443\u043C\u0435\u0440\u0435\u043D\u043D\u044B\u0439","watering-\u0440\u0435\u0434\u043A\u0438\u0439":"\u0440\u0435\u0434\u043A\u0438\u0439","watering-\u043F\u043E \u043C\u0435\u0440\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438":"\u043F\u043E \u043C\u0435\u0440\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438","watering-\u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u0438\u0432\u0430":"\u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u0438\u0432\u0430","watering-\u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u043E \u0432\u043B\u0430\u0436\u043D\u0430\u044F \u043F\u043E\u0447\u0432\u0430":"\u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u043E \u0432\u043B\u0430\u0436\u043D\u0430\u044F \u043F\u043E\u0447\u0432\u0430","attitudeToLight-\u0441\u043E\u043B\u043D\u0446\u0435":"\u0441\u043E\u043B\u043D\u0446\u0435","attitudeToLight-\u043F\u043E\u043B\u0443\u0442\u0435\u043D\u044C":"\u043F\u043E\u043B\u0443\u0442\u0435\u043D\u044C","attitudeToLight-\u0442\u0435\u043D\u044C":"\u0442\u0435\u043D\u044C","attitudeToLight-\u043B\u0435\u0433\u043A\u0430\u044F \u043F\u043E\u043B\u0443\u0442\u0435\u043D\u044C":"\u043F\u043E\u043B\u0443\u0442\u0435\u043D\u044C","attitudeToLight-\u0440\u0430\u0441\u0441\u0435\u044F\u043D\u043D\u044B\u0439 \u0441\u0432\u0435\u0442":"\u0441\u0432\u0435\u0442","attitudeToLight-\u044F\u0440\u043A\u0438\u0439 \u0440\u0430\u0441\u0441\u0435\u044F\u043D\u043D\u044B\u0439 \u0441\u0432\u0435\u0442":"\u0441\u0432\u0435\u0442","edibility-\u0431\u0443\u0442\u043E\u043D\u044B":"\u0431\u0443\u0442\u043E\u043D\u044B","edibility-\u043A\u043B\u0443\u0431\u043D\u0438":"\u043A\u043B\u0443\u0431\u043D\u0438","edibility-\u043A\u043E\u0440\u043D\u0438":"\u043A\u043E\u0440\u043D\u0438","edibility-\u043B\u0438\u0441\u0442\u044C\u044F":"\u043B\u0438\u0441\u0442\u044C\u044F","edibility-\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430":"\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430","edibility-\u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430":"\u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430","edibility-\u043C\u043E\u043B\u043E\u0434\u044B\u0435 \u043F\u043E\u0431\u0435\u0433\u0438":"\u043C\u043E\u043B\u043E\u0434\u044B\u0435 \u043F\u043E\u0431\u0435\u0433\u0438","edibility-\u043E\u0432\u043E\u0449\u0438":"\u043E\u0432\u043E\u0449\u0438","edibility-\u043F\u043B\u043E\u0434\u044B":"\u043F\u043B\u043E\u0434\u044B","edibility-\u0441\u0435\u043C\u0435\u043D\u0430":"\u0441\u0435\u043C\u0435\u043D\u0430","edibility-\u0441\u043E\u0446\u0432\u0435\u0442\u0438\u044F":"\u0441\u043E\u0446\u0432\u0435\u0442\u0438\u044F","edibility-\u0444\u0440\u0443\u043A\u0442\u044B":"\u0444\u0440\u0443\u043A\u0442\u044B","edibility-\u044F\u0433\u043E\u0434\u044B":"\u044F\u0433\u043E\u0434\u044B","toxicity-\u0432\u0441\u0435 \u0447\u0430\u0441\u0442\u0438":"\u0432\u0441\u0435 \u0447\u0430\u0441\u0442\u0438","toxicity-\u043A\u043E\u0440\u0430":"\u043A\u043E\u0440\u0430","toxicity-\u043A\u043E\u0440\u043D\u0438":"\u043A\u043E\u0440\u043D\u0438","toxicity-\u043B\u0438\u0441\u0442\u044C\u044F":"\u043B\u0438\u0441\u0442\u044C\u044F","toxicity-\u043F\u043B\u043E\u0434\u044B":"\u043F\u043B\u043E\u0434\u044B","toxicity-\u0441\u043E\u043A":"\u0441\u043E\u043A","toxicity-\u0441\u0442\u0435\u0431\u0435\u043B\u044C":"\u0441\u0442\u0435\u0431\u0435\u043B\u044C","toxicity-\u0446\u0432\u0435\u0442\u044B":"\u0446\u0432\u0435\u0442\u044B","toxicity-\u044F\u0434\u043E\u0432\u0438\u0442\u043E\u0435":"\u044F\u0434\u043E\u0432\u0438\u0442\u043E\u0435","type-\u0432\u0435\u0440\u0435\u0441\u043A":"\u0432\u0435\u0440\u0435\u0441\u043A","type-\u0432\u043E\u0434\u043D\u043E\u0435":"\u0432\u043E\u0434\u043D\u043E\u0435","type-\u0432\u044C\u044E\u0449\u0438\u0435\u0441\u044F \u0438 \u043B\u0438\u0430\u043D\u044B":"\u0432\u044C\u044E\u0449\u0438\u0435\u0441\u044F \u0438 \u043B\u0438\u0430\u043D\u044B","type-\u0434\u0435\u0440\u0435\u0432\u043E":"\u0434\u0435\u0440\u0435\u0432\u043E","type-\u043A\u0430\u043A\u0442\u0443\u0441\u044B \u0438 \u0441\u0443\u043A\u043A\u0443\u043B\u0435\u043D\u0442\u044B":"\u043A\u0430\u043A\u0442\u0443\u0441\u044B \u0438 \u0441\u0443\u043A\u043A\u0443\u043B\u0435\u043D\u0442\u044B","type-\u043A\u043B\u0443\u0431\u043D\u0435\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u043E\u0435":"\u043A\u043B\u0443\u0431\u043D\u0435\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u043E\u0435","type-\u043A\u0443\u0441\u0442\u0430\u0440\u043D\u0438\u043A":"\u043A\u0443\u0441\u0442\u0430\u0440\u043D\u0438\u043A","type-\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u043E\u0435":"\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u043E\u0435","type-\u043F\u0430\u043B\u044C\u043C\u043E\u0432\u044B\u0435 \u0438 \u0441\u0430\u0433\u043E\u0432\u043D\u0438\u043A\u043E\u0432\u044B\u0435":"\u043F\u0430\u043B\u044C\u043C\u043E\u0432\u044B\u0435 \u0438 \u0441\u0430\u0433\u043E\u0432\u043D\u0438\u043A\u043E\u0432\u044B\u0435","type-\u043F\u0430\u043F\u043E\u0440\u043E\u0442\u043D\u0438\u043A":"\u043F\u0430\u043F\u043E\u0440\u043E\u0442\u043D\u0438\u043A","type-\u043F\u043B\u043E\u0442\u043E\u044F\u0434\u043D\u043E\u0435":"\u043F\u043B\u043E\u0442\u043E\u044F\u0434\u043D\u043E\u0435","type-\u043F\u043E\u043B\u0443\u043A\u0443\u0441\u0442\u0430\u0440\u043D\u0438\u043A":"\u043F\u043E\u043B\u0443\u043A\u0443\u0441\u0442\u0430\u0440\u043D\u0438\u043A","type-\u0442\u0440\u0430\u0432\u044F\u043D\u0438\u0441\u0442\u043E\u0435":"\u0442\u0440\u0430\u0432\u044F\u043D\u0438\u0441\u0442\u043E\u0435","type-\u0446\u0432\u0435\u0442\u0443\u0449\u0435\u0435":"\u0446\u0432\u0435\u0442\u0443\u0449\u0435\u0435","type-\u043D\u0435\u0431\u043E\u043B\u044C\u0448\u043E\u0435 \u0434\u0435\u0440\u0435\u0432\u043E":"\u043D\u0435\u0431\u043E\u043B\u044C\u0448\u043E\u0435 \u0434\u0435\u0440\u0435\u0432\u043E","type-\u044D\u043F\u0438\u0444\u0438\u0442":"\u044D\u043F\u0438\u0444\u0438\u0442","attractionFactors-\u0430\u043C\u043F\u0435\u043B\u044C\u043D\u043E\u0435":"\u0430\u043C\u043F\u0435\u043B\u044C\u043D\u043E\u0435","attractionFactors-\u0431\u044B\u0441\u0442\u0440\u043E\u0440\u0430\u0441\u0442\u0443\u0449\u0435\u0435":"\u0431\u044B\u0441\u0442\u0440\u043E\u0440\u0430\u0441\u0442\u0443\u0449\u0435\u0435","attractionFactors-\u0432\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u0430\u044F \u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C":"\u0432\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u0430\u044F \u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C","attractionFactors-\u0433\u0438\u0433\u0440\u043E\u0444\u0438\u0442":"\u0433\u0438\u0433\u0440\u043E\u0444\u0438\u0442","attractionFactors-\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u043A\u043E\u0440\u0430":"\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u043A\u043E\u0440\u0430","attractionFactors-\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u0444\u043E\u0440\u043C\u0430 \u043A\u0440\u043E\u043D\u044B":"\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u0444\u043E\u0440\u043C\u0430 \u043A\u0440\u043E\u043D\u044B","attractionFactors-\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u043F\u043B\u043E\u0434\u043E\u043D\u043E\u0448\u0435\u043D\u0438\u0435":"\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u043F\u043B\u043E\u0434\u043E\u043D\u043E\u0448\u0435\u043D\u0438\u0435","attractionFactors-\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435":"\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435","attractionFactors-\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u043B\u0438\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435":"\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u043B\u0438\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435","attractionFactors-\u043A\u0441\u0435\u0440\u043E\u0444\u0438\u0442":"\u043A\u0441\u0435\u0440\u043E\u0444\u0438\u0442","attractionFactors-\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E\u0440\u0430\u0441\u0442\u0443\u0449\u0435\u0435":"\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E\u0440\u0430\u0441\u0442\u0443\u0449\u0435\u0435","attractionFactors-\u043C\u043E\u0440\u043E\u0437\u043E\u0441\u0442\u043E\u0439\u043A\u043E\u0435":"\u043C\u043E\u0440\u043E\u0437\u043E\u0441\u0442\u043E\u0439\u043A\u043E\u0435","attractionFactors-\u043E\u0447\u0438\u0449\u0430\u0435\u0442 \u0432\u043E\u0437\u0434\u0443\u0445":"\u043E\u0447\u0438\u0449\u0430\u0435\u0442 \u0432\u043E\u0437\u0434\u0443\u0445","attractionFactors-\u043F\u043B\u0435\u0442\u0443\u0449\u0435\u0435\u0441\u044F":"\u043F\u043B\u0435\u0442\u0443\u0449\u0435\u0435\u0441\u044F","attractionFactors-\u043F\u043E\u0447\u0432\u043E\u043F\u043E\u043A\u0440\u043E\u0432\u043D\u043E\u0435":"\u043F\u043E\u0447\u0432\u043E\u043F\u043E\u043A\u0440\u043E\u0432\u043D\u043E\u0435","attractionFactors-\u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u044E\u0449\u0435\u0435 \u043E\u043F\u044B\u043B\u0438\u0442\u0435\u043B\u0435\u0439":"\u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u044E\u0449\u0435\u0435 \u043E\u043F\u044B\u043B\u0438\u0442\u0435\u043B\u0435\u0439","attractionFactors-\u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435":"\u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435","attractionFactors-\u0441\u044A\u0435\u0434\u043E\u0431\u043D\u043E\u0435":"\u0441\u044A\u0435\u0434\u043E\u0431\u043D\u043E\u0435","attractionFactors-\u0442\u0435\u043D\u0435\u0432\u044B\u043D\u043E\u0441\u043B\u0438\u0432\u043E\u0435":"\u0442\u0435\u043D\u0435\u0432\u044B\u043D\u043E\u0441\u043B\u0438\u0432\u043E\u0435","attractionFactors-\u0442\u0435\u043D\u0435\u043B\u044E\u0431\u0438\u0432\u043E\u0435":"\u0442\u0435\u043D\u0435\u043B\u044E\u0431\u0438\u0432\u043E\u0435","attractionFactors-\u0442\u043E\u043F\u0438\u0430\u0440\u043D\u044B\u0435 \u0444\u043E\u0440\u043C\u044B":"\u0444\u043E\u0440\u043C\u044B","attractionFactors-\u0445\u0432\u043E\u0439\u043D\u043E\u0435":"\u0445\u0432\u043E\u0439\u043D\u043E\u0435","attractionFactors-\u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435 \u0432 \u0440\u0430\u043D\u043D\u0435\u0432\u0435\u0441\u0435\u043D\u043D\u0438\u0439 \u043F\u0435\u0440\u0438\u043E\u0434":"\u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435 \u0432 \u0440\u0430\u043D\u043D\u0435\u0432\u0435\u0441\u0435\u043D\u043D\u0438\u0439 \u043F\u0435\u0440\u0438\u043E\u0434","attractionFactors-\u044D\u043A\u0437\u043E\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0432\u043D\u0435\u0448\u043D\u0438\u0439 \u0432\u0438\u0434":"\u044D\u043A\u0437\u043E\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0432\u043D\u0435\u0448\u043D\u0438\u0439 \u0432\u0438\u0434","featuresOfCultivation-\u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442":"\u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442","featuresOfCultivation-\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0430 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0430\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443":"\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0430 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0430\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443","featuresOfCultivation-\u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u043E\u0440\u0430\u0449\u0438\u0435\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0443\u0431\u043D\u0435\u0439":"\u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u043E\u0440\u0430\u0449\u0438\u0435\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0443\u0431\u043D\u0435\u0439","featuresOfCultivation-\u0441\u0442\u0440\u0430\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430":"\u0441\u0442\u0440\u0430\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430","featuresOfCultivation-\u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430":"\u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430","featuresOfCultivation-\u0435\u0441\u0442\u044C \u043F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u043A\u043E\u044F":"\u0435\u0441\u0442\u044C \u043F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u043A\u043E\u044F","featuresOfCultivation-\u0432\u043E\u0437\u043C\u043E\u0436\u0435\u043D \u043F\u043E\u0441\u0435\u0432 \u0441\u0435\u043C\u044F\u043D \u0432 \u0433\u0440\u0443\u043D\u0442 \u043F\u043E\u0434 \u0437\u0438\u043C\u0443":"\u0432\u043E\u0437\u043C\u043E\u0436\u0435\u043D \u043F\u043E\u0441\u0435\u0432 \u0441\u0435\u043C\u044F\u043D \u0432 \u0433\u0440\u0443\u043D\u0442 \u043F\u043E\u0434 \u0437\u0438\u043C\u0443","featuresOfCultivation-\u0441\u043A\u0430\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0441\u0435\u043C\u044F\u043D \u043F\u0440\u0438 \u043F\u043E\u0441\u0430\u0434\u043A\u0435 \u0432\u0435\u0441\u043D\u043E\u0439":"\u0441\u043A\u0430\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0441\u0435\u043C\u044F\u043D \u043F\u0440\u0438 \u043F\u043E\u0441\u0430\u0434\u043A\u0435 \u0432\u0435\u0441\u043D\u043E\u0439","reproductionMethods-\u0431\u043E\u043A\u043E\u0432\u044B\u043C\u0438 \u043F\u043E\u0431\u0435\u0433\u0430\u043C\u0438":"\u0431\u043E\u043A\u043E\u0432\u044B\u043C\u0438 \u043F\u043E\u0431\u0435\u0433\u0430\u043C\u0438","reproductionMethods-\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u043B\u0443\u0431\u043D\u044F":"\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u043B\u0443\u0431\u043D\u044F","reproductionMethods-\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u043E\u0440\u043D\u0435\u0432\u0438\u0449\u0430":"\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u043E\u0440\u043D\u0435\u0432\u0438\u0449\u0430","reproductionMethods-\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u0443\u0441\u0442\u0430":"\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u0443\u0441\u0442\u0430","reproductionMethods-\u043A\u043B\u0443\u0431\u043D\u0435\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430\u043C\u0438":"\u043A\u043B\u0443\u0431\u043D\u0435\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430\u043C\u0438","reproductionMethods-\u043A\u043B\u0443\u0431\u043D\u0435\u043F\u043E\u0447\u043A\u0430\u043C\u0438":"\u043A\u043B\u0443\u0431\u043D\u0435\u043F\u043E\u0447\u043A\u0430\u043C\u0438","reproductionMethods-\u043B\u0438\u0441\u0442\u043E\u043C":"\u043B\u0438\u0441\u0442\u043E\u043C","reproductionMethods-\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430\u043C\u0438":"\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430\u043C\u0438","reproductionMethods-\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u044B\u043C\u0438 \u0447\u0435\u0448\u0443\u0439\u043A\u0430\u043C\u0438":"\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u044B\u043C\u0438 \u0447\u0435\u0448\u0443\u0439\u043A\u0430\u043C\u0438","reproductionMethods-\u043E\u0442\u0432\u043E\u0434\u043A\u0430\u043C\u0438":"\u043E\u0442\u0432\u043E\u0434\u043A\u0430\u043C\u0438","reproductionMethods-\u043F\u0440\u0438\u0432\u0438\u0432\u043A\u043E\u0439":"\u043F\u0440\u0438\u0432\u0438\u0432\u043A\u043E\u0439","reproductionMethods-\u0441\u0435\u043C\u0435\u043D\u0430\u043C\u0438":"\u0441\u0435\u043C\u0435\u043D\u0430\u043C\u0438","reproductionMethods-\u0441\u043F\u043E\u0440\u0430\u043C\u0438":"\u0441\u043F\u043E\u0440\u0430\u043C\u0438","reproductionMethods-\u0447\u0430\u0441\u0442\u044C\u044E \u043B\u0438\u0441\u0442\u0430":"\u0447\u0430\u0441\u0442\u044C\u044E \u043B\u0438\u0441\u0442\u0430","reproductionMethods-\u0447\u0435\u0440\u0435\u043D\u043A\u043E\u0432\u0430\u043D\u0438\u0435\u043C":"\u0447\u0435\u0440\u0435\u043D\u043A\u043E\u0432\u0430\u043D\u0438\u0435\u043C","timeForPlantingSeedlingsInOpenedGround-\u043F\u043E\u0441\u043B\u0435 \u043C\u0438\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0433\u0440\u043E\u0437\u044B \u0437\u0430\u043C\u043E\u0440\u043E\u0437\u043A\u043E\u0432":"\u043F\u043E\u0441\u043B\u0435 \u043C\u0438\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0433\u0440\u043E\u0437\u044B \u0437\u0430\u043C\u043E\u0440\u043E\u0437\u043A\u043E\u0432","additionalCareSteps-\u043E\u0431\u0440\u0435\u0437\u043A\u0430 \u043D\u0430 \u0437\u0438\u043C\u0443":"\u043E\u0431\u0440\u0435\u0437\u043A\u0430 \u043D\u0430 \u0437\u0438\u043C\u0443","additionalCareSteps-\u043E\u043C\u043E\u043B\u0430\u0436\u0438\u0432\u0430\u044E\u0449\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430":"\u043E\u043C\u043E\u043B\u0430\u0436\u0438\u0432\u0430\u044E\u0449\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430","additionalCareSteps-\u043F\u043E\u043B\u043B\u0430\u0440\u0434\u0438\u043D\u0433":"\u043F\u043E\u043B\u043B\u0430\u0440\u0434\u0438\u043D\u0433","additionalCareSteps-\u043F\u0440\u0438\u0449\u0438\u043F\u044B\u0432\u0430\u043D\u0438\u0435":"\u043F\u0440\u0438\u0449\u0438\u043F\u044B\u0432\u0430\u043D\u0438\u0435","additionalCareSteps-\u0441\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430":"\u0441\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430","additionalCareSteps-\u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0443\u0432\u044F\u0434\u0448\u0438\u0445 \u0446\u0432\u0435\u0442\u043E\u0432":"\u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0443\u0432\u044F\u0434\u0448\u0438\u0445 \u0446\u0432\u0435\u0442\u043E\u0432","additionalCareSteps-\u0443\u043A\u0440\u044B\u0442\u0438\u0435 \u043D\u0430 \u0437\u0438\u043C\u0443":"\u0443\u043A\u0440\u044B\u0442\u0438\u0435 \u043D\u0430 \u0437\u0438\u043C\u0443","additionalCareSteps-\u0444\u043E\u0440\u043C\u043E\u0432\u043E\u0447\u043D\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430":"\u0444\u043E\u0440\u043C\u043E\u0432\u043E\u0447\u043D\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430","additionalCareSteps-\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0437\u0438\u043C\u043E\u0439 \u0432 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0438":"\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0437\u0438\u043C\u043E\u0439 \u0432 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0438","applicationInDesign-\u0430\u043A\u0432\u0430\u0440\u0438\u0443\u043C":"\u0430\u043A\u0432\u0430\u0440\u0438\u0443\u043C","applicationInDesign-\u0430\u043B\u043B\u0435\u044F":"\u0430\u043B\u043B\u0435\u044F","applicationInDesign-\u0430\u043B\u044C\u043F\u0438\u0439\u0441\u043A\u0430\u044F \u0433\u043E\u0440\u043A\u0430 (\u0430\u043B\u044C\u043F\u0438\u043D\u0430\u0440\u0438\u0439)":"\u0430\u043B\u044C\u043F\u0438\u0439\u0441\u043A\u0430\u044F \u0433\u043E\u0440\u043A\u0430 (\u0430\u043B\u044C\u043F\u0438\u043D\u0430\u0440\u0438\u0439)","applicationInDesign-\u0431\u0430\u043B\u043A\u043E\u043D":"\u0431\u0430\u043B\u043A\u043E\u043D","applicationInDesign-\u0431\u0435\u0440\u0441\u043E":"\u0431\u0435\u0440\u0441\u043E","applicationInDesign-\u0431\u043E\u043D\u0441\u0430\u0439":"\u0431\u043E\u043D\u0441\u0430\u0439","applicationInDesign-\u0431\u043E\u0440\u0434\u044E\u0440":"\u0431\u043E\u0440\u0434\u044E\u0440","applicationInDesign-\u0432 \u0438\u043D\u0442\u0435\u0440\u044C\u0435\u0440\u0435":"\u0432 \u0438\u043D\u0442\u0435\u0440\u044C\u0435\u0440\u0435","applicationInDesign-\u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435 \u043E\u0437\u0435\u043B\u0435\u043D\u0435\u043D\u0438\u0435":"\u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435 \u043E\u0437\u0435\u043B\u0435\u043D\u0435\u043D\u0438\u0435","applicationInDesign-\u0433\u0435\u0440\u0431\u0430\u0440\u0438\u0439":"\u0433\u0435\u0440\u0431\u0430\u0440\u0438\u0439","applicationInDesign-\u0433\u0440\u0443\u043F\u043F\u043E\u0432\u0430\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0430":"\u0433\u0440\u0443\u043F\u043F\u043E\u0432\u0430\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0430","applicationInDesign-\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u043C\u0438\u043D\u0438-\u0432\u043E\u0434\u043E\u0435\u043C":"\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u043C\u0438\u043D\u0438-\u0432\u043E\u0434\u043E\u0435\u043C","applicationInDesign-\u0436\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C":"\u0436\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C","applicationInDesign-\u043A\u0430\u0448\u043F\u043E":"\u043A\u0430\u0448\u043F\u043E","applicationInDesign-\u043A\u043B\u0443\u043C\u0431\u0430":"\u043A\u043B\u0443\u043C\u0431\u0430","applicationInDesign-\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440":"\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440","applicationInDesign-\u043A\u0443\u043B\u0438\u0441\u044B":"\u043A\u0443\u043B\u0438\u0441\u044B","applicationInDesign-\u043C\u0438\u043A\u0441\u0431\u043E\u0440\u0434\u0435\u0440":"\u043C\u0438\u043A\u0441\u0431\u043E\u0440\u0434\u0435\u0440","applicationInDesign-\u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u0443\u0434\u0438\u043A":"\u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u0443\u0434\u0438\u043A","applicationInDesign-\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0431\u0443\u043A\u0435\u0442\u0430":"\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0431\u0443\u043A\u0435\u0442\u0430","applicationInDesign-\u043F\u0430\u043B\u044C\u043C\u0435\u0442\u0442\u0430":"\u043F\u0430\u043B\u044C\u043C\u0435\u0442\u0442\u0430","applicationInDesign-\u0440\u0430\u0431\u0430\u0442\u043A\u0430":"\u0440\u0430\u0431\u0430\u0442\u043A\u0430","applicationInDesign-\u0440\u043E\u043A\u0430\u0440\u0438\u0439":"\u0440\u043E\u043A\u0430\u0440\u0438\u0439","applicationInDesign-\u0441\u043E\u043B\u0438\u0442\u0435\u0440 (\u043E\u0434\u0438\u043D\u043E\u0447\u043D\u043E\u0435)":"\u0441\u043E\u043B\u0438\u0442\u0435\u0440 (\u043E\u0434\u0438\u043D\u043E\u0447\u043D\u043E\u0435)","applicationInDesign-\u0441\u0440\u0435\u0437\u043A\u0430":"\u0441\u0440\u0435\u0437\u043A\u0430","applicationInDesign-\u0441\u0443\u0445\u043E\u0439 \u0431\u0443\u043A\u0435\u0442":"\u0441\u0443\u0445\u043E\u0439 \u0431\u0443\u043A\u0435\u0442","applicationInDesign-\u0442\u043E\u043F\u0438\u0430\u0440\u043D\u044B\u0435 \u0444\u0438\u0433\u0443\u0440\u044B":"\u0442\u043E\u043F\u0438\u0430\u0440\u043D\u044B\u0435 \u0444\u0438\u0433\u0443\u0440\u044B","applicationInDesign-\u0444\u0438\u0442\u043E\u043F\u043B\u0430\u0441\u0442\u0438\u043A\u0430":"\u0444\u0438\u0442\u043E\u043F\u043B\u0430\u0441\u0442\u0438\u043A\u0430","applicationInDesign-\u0444\u043B\u043E\u0440\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0434\u0438\u0437\u0430\u0439\u043D":"\u0444\u043B\u043E\u0440\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0434\u0438\u0437\u0430\u0439\u043D","applicationInDesign-\u0448\u043F\u0430\u043B\u0435\u0440\u0430":"\u0448\u043F\u0430\u043B\u0435\u0440\u0430","applicationInDesign-\u044F\u043F\u043E\u043D\u0441\u043A\u0438\u0439 \u0441\u0430\u0434":"\u044F\u043F\u043E\u043D\u0441\u043A\u0438\u0439 \u0441\u0430\u0434","disease-\u0430\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0440\u0438\u043E\u0437":"\u0430\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0440\u0438\u043E\u0437","disease-\u0430\u043D\u0442\u0440\u0430\u043A\u043D\u043E\u0437":"\u0430\u043D\u0442\u0440\u0430\u043A\u043D\u043E\u0437","disease-\u0430\u0441\u0442\u0440\u043E\u0432\u044B\u0439 \u0432\u0438\u043B\u0442":"\u0430\u0441\u0442\u0440\u043E\u0432\u044B\u0439 \u0432\u0438\u043B\u0442","disease-\u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0436\u043E\u0433":"\u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0436\u043E\u0433","disease-\u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0440\u044F\u0431\u0443\u0445\u0430":"\u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0440\u044F\u0431\u0443\u0445\u0430","disease-\u0431\u0435\u043B\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u0431\u0435\u043B\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u0431\u0435\u043B\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C":"\u0431\u0435\u043B\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C","disease-\u0431\u0438\u0430\u0442\u043E\u0440\u0435\u043B\u043B\u043E\u0432\u044B\u0439 \u0440\u0430\u043A \u0442\u0438\u0441\u0430":"\u0431\u0438\u0430\u0442\u043E\u0440\u0435\u043B\u043B\u043E\u0432\u044B\u0439 \u0440\u0430\u043A \u0442\u0438\u0441\u0430","disease-\u0431\u0443\u0440\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C":"\u0431\u0443\u0440\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C","disease-\u0432\u0435\u0440\u0442\u0438\u0446\u0438\u043B\u043B\u0435\u0437":"\u0432\u0435\u0440\u0442\u0438\u0446\u0438\u043B\u043B\u0435\u0437","disease-\u0432\u0435\u0440\u0448\u0438\u043D\u043D\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u0432\u0435\u0440\u0448\u0438\u043D\u043D\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u0432\u0438\u0440\u0443\u0441 \u043B\u044E\u0446\u0435\u0440\u043D\u043E\u0432\u043E\u0439 \u043C\u043E\u0437\u0430\u0438\u043A\u0438":"\u0432\u0438\u0440\u0443\u0441 \u043B\u044E\u0446\u0435\u0440\u043D\u043E\u0432\u043E\u0439 \u043C\u043E\u0437\u0430\u0438\u043A\u0438","disease-\u0432\u0438\u0440\u0443\u0441 \u043C\u043E\u0437\u0430\u0438\u043A\u0438":"\u0432\u0438\u0440\u0443\u0441 \u043C\u043E\u0437\u0430\u0438\u043A\u0438","disease-\u0432\u0438\u0440\u0443\u0441 \u043D\u0435\u043A\u0440\u043E\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u043B\u043E\u0441\u0430\u0442\u043E\u0441\u0442\u0438 \u043B\u0438\u043B\u0438\u0438":"\u0432\u0438\u0440\u0443\u0441 \u043D\u0435\u043A\u0440\u043E\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u043B\u043E\u0441\u0430\u0442\u043E\u0441\u0442\u0438 \u043B\u0438\u043B\u0438\u0438","disease-\u0432\u0438\u0440\u0443\u0441 \u0445\u043E\u0441\u0442\u044B X":"\u0432\u0438\u0440\u0443\u0441 \u0445\u043E\u0441\u0442\u044B X","disease-\u0432\u043E\u0434\u044F\u043D\u0438\u0441\u0442\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u0432\u043E\u0434\u044F\u043D\u0438\u0441\u0442\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u0433\u043D\u0438\u043B\u044C \u0441\u0442\u0435\u0431\u043B\u044F":"\u0433\u043D\u0438\u043B\u044C \u0441\u0442\u0435\u0431\u043B\u044F","disease-\u0433\u0440\u0438\u0431\u043A\u043E\u0432\u044B\u0435 \u0437\u0430\u0431\u043E\u043B\u0435\u0432\u0430\u043D\u0438\u044F":"\u0433\u0440\u0438\u0431\u043A\u043E\u0432\u044B\u0435 \u0437\u0430\u0431\u043E\u043B\u0435\u0432\u0430\u043D\u0438\u044F","disease-\u043A\u0438\u043B\u0430 \u043A\u0430\u043F\u0443\u0441\u0442\u043D\u044B\u0445":"\u043A\u0438\u043B\u0430 \u043A\u0430\u043F\u0443\u0441\u0442\u043D\u044B\u0445","disease-\u043A\u043B\u044F\u0441\u0442\u0435\u0440\u043E\u0441\u043F\u043E\u0440\u0438\u043E\u0437":"\u043A\u043B\u044F\u0441\u0442\u0435\u0440\u043E\u0441\u043F\u043E\u0440\u0438\u043E\u0437","disease-\u043A\u043E\u0440\u043D\u0435\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u043A\u043E\u0440\u043D\u0435\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u043A\u043E\u0440\u043D\u0435\u0432\u043E\u0439 \u0440\u0430\u043A":"\u043A\u043E\u0440\u043D\u0435\u0432\u043E\u0439 \u0440\u0430\u043A","disease-\u043B\u043E\u0436\u043D\u0430\u044F \u043C\u0443\u0447\u043D\u0438\u0441\u0442\u0430\u044F \u0440\u043E\u0441\u0430":"\u043F\u0435\u0440\u043E\u043D\u043E\u0441\u043F\u043E\u0440\u043E\u0437 (\u043B\u043E\u0436\u043D\u0430\u044F \u043C\u0443\u0447\u043D\u0438\u0441\u0442\u0430\u044F \u0440\u043E\u0441\u0430)","disease-\u043C\u043E\u0437\u0430\u0438\u0447\u043D\u0430\u044F \u0431\u043E\u043B\u0435\u0437\u043D\u044C \u043B\u0438\u0441\u0442\u044C\u0435\u0432":"\u043C\u043E\u0437\u0430\u0438\u0447\u043D\u0430\u044F \u0431\u043E\u043B\u0435\u0437\u043D\u044C \u043B\u0438\u0441\u0442\u044C\u0435\u0432","disease-\u043C\u043E\u043A\u0440\u0430\u044F \u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u043C\u043E\u043A\u0440\u0430\u044F \u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u043C\u043E\u043D\u0442\u0430\u0440\u044C":"\u043C\u043E\u043D\u0442\u0430\u0440\u044C","disease-\u043C\u0443\u0447\u043D\u0438\u0441\u0442\u0430\u044F \u0440\u043E\u0441\u0430":"\u043C\u0443\u0447\u043D\u0438\u0441\u0442\u0430\u044F \u0440\u043E\u0441\u0430","disease-\u043E\u0433\u0443\u0440\u0435\u0447\u043D\u0430\u044F \u043C\u043E\u0437\u0430\u0438\u043A\u0430":"\u043E\u0433\u0443\u0440\u0435\u0447\u043D\u0430\u044F \u043C\u043E\u0437\u0430\u0438\u043A\u0430","disease-\u043E\u0438\u0434\u0438\u0443\u043C \u0432\u0438\u043D\u043E\u0433\u0440\u0430\u0434\u0430":"\u043E\u0438\u0434\u0438\u0443\u043C \u0432\u0438\u043D\u043E\u0433\u0440\u0430\u0434\u0430","disease-\u043F\u0430\u0440\u0448\u0430":"\u043F\u0430\u0440\u0448\u0430","disease-\u043F\u0435\u043D\u0438\u0446\u0438\u043B\u043B\u0435\u0437":"\u043F\u0435\u043D\u0438\u0446\u0438\u043B\u043B\u0435\u0437","disease-\u043F\u0435\u0441\u0442\u0430\u043B\u043E\u0446\u0438\u0435\u0432\u044B\u0439 \u043D\u0435\u043A\u0440\u043E\u0437":"\u043F\u0435\u0441\u0442\u0430\u043B\u043E\u0446\u0438\u0435\u0432\u044B\u0439 \u043D\u0435\u043A\u0440\u043E\u0437","disease-\u043F\u0435\u0441\u0442\u0440\u043E\u043B\u0435\u043F\u0435\u0441\u0442\u043D\u043E\u0441\u0442\u044C":"\u043F\u0435\u0441\u0442\u0440\u043E\u043B\u0435\u043F\u0435\u0441\u0442\u043D\u043E\u0441\u0442\u044C","disease-\u043F\u043B\u043E\u0434\u043E\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C (\u043C\u043E\u043D\u0438\u043B\u0438\u043E\u0437)":"\u043F\u043B\u043E\u0434\u043E\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C (\u043C\u043E\u043D\u0438\u043B\u0438\u043E\u0437)","disease-\u043F\u043E\u0434\u0433\u0430\u0440 \u0442\u0430\u0431\u0430\u043A\u0430":"\u043F\u043E\u0434\u0433\u0430\u0440 \u0442\u0430\u0431\u0430\u043A\u0430","disease-\u043F\u043E\u0436\u0438\u043B\u043A\u043E\u0432\u044B\u0439 \u0445\u043B\u043E\u0440\u043E\u0437":"\u043F\u043E\u0436\u0438\u043B\u043A\u043E\u0432\u044B\u0439 \u0445\u043B\u043E\u0440\u043E\u0437","disease-\u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u043B\u0438\u0441\u0442\u044C\u0435\u0432":"\u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u043B\u0438\u0441\u0442\u044C\u0435\u0432","disease-\u0440\u0430\u043A":"\u0440\u0430\u043A","disease-\u0440\u0430\u0441\u0441\u0430\u0434\u043D\u0430\u044F (\u0441\u0442\u0435\u0431\u043B\u0435\u0432\u0430\u044F) \u0433\u043D\u0438\u043B\u044C":"\u0440\u0430\u0441\u0441\u0430\u0434\u043D\u0430\u044F (\u0441\u0442\u0435\u0431\u043B\u0435\u0432\u0430\u044F) \u0433\u043D\u0438\u043B\u044C","disease-\u0440\u0435\u0432\u0435\u0440\u0441\u0438\u044F \u0447\u0435\u0440\u043D\u043E\u0439 \u0441\u043C\u043E\u0440\u043E\u0434\u0438\u043D\u044B":"\u0440\u0435\u0432\u0435\u0440\u0441\u0438\u044F \u0447\u0435\u0440\u043D\u043E\u0439 \u0441\u043C\u043E\u0440\u043E\u0434\u0438\u043D\u044B","disease-\u0440\u0436\u0430\u0432\u0447\u0438\u043D\u0430":"\u0440\u0436\u0430\u0432\u0447\u0438\u043D\u0430","disease-\u0440\u0438\u0437\u043E\u043A\u0442\u043E\u043D\u0438\u043E\u0437 (\u0431\u0443\u0440\u0430\u044F \u0433\u043D\u0438\u043B\u044C)":"\u0440\u0438\u0437\u043E\u043A\u0442\u043E\u043D\u0438\u043E\u0437 (\u0431\u0443\u0440\u0430\u044F \u0433\u043D\u0438\u043B\u044C)","disease-\u0441\u0430\u0436\u0438\u0441\u0442\u044B\u0439 \u0433\u0440\u0438\u0431":"\u0441\u0430\u0436\u0438\u0441\u0442\u044B\u0439 \u0433\u0440\u0438\u0431","disease-\u0441\u0435\u0440\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u0441\u0435\u0440\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u0441\u0435\u0440\u0430\u044F \u043F\u043B\u0435\u0441\u0435\u043D\u044C":"\u0441\u0435\u0440\u0430\u044F \u043F\u043B\u0435\u0441\u0435\u043D\u044C","disease-\u0441\u0442\u0430\u0433\u0430\u043D\u043E\u0441\u043F\u043E\u0440\u043E\u0437":"\u0441\u0442\u0430\u0433\u0430\u043D\u043E\u0441\u043F\u043E\u0440\u043E\u0437","disease-\u0441\u0442\u0432\u043E\u043B\u043E\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u0441\u0442\u0432\u043E\u043B\u043E\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u0442\u0430\u0431\u0430\u0447\u043D\u0430\u044F \u043C\u043E\u0437\u0430\u0438\u043A\u0430":"\u0442\u0430\u0431\u0430\u0447\u043D\u0430\u044F \u043C\u043E\u0437\u0430\u0438\u043A\u0430","disease-\u0443- \u0432\u0438\u0440\u0443\u0441 \u043A\u0430\u0440\u0442\u043E\u0444\u0435\u043B\u044F (\u0431\u0435\u043B\u0430\u044F \u043F\u0435\u0441\u0442\u0440\u0438\u0446\u0430)":"\u0443- \u0432\u0438\u0440\u0443\u0441 \u043A\u0430\u0440\u0442\u043E\u0444\u0435\u043B\u044F (\u0431\u0435\u043B\u0430\u044F \u043F\u0435\u0441\u0442\u0440\u0438\u0446\u0430)","disease-\u0444\u0438\u0442\u043E\u0444\u0442\u043E\u0440\u043E\u0437":"\u0444\u0438\u0442\u043E\u0444\u0442\u043E\u0440\u043E\u0437","disease-\u0444\u043E\u043C\u043E\u0437 \u0442\u0438\u0441\u0430":"\u0444\u043E\u043C\u043E\u0437 \u0442\u0438\u0441\u0430","disease-\u0444\u043E\u043C\u043E\u0437":"\u0444\u043E\u043C\u043E\u0437","disease-\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437":"\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437","disease-\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437\u043D\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C":"\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437\u043D\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C","disease-\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437\u043D\u043E\u0435 \u0443\u0432\u044F\u0434\u0430\u043D\u0438\u0435":"\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437\u043D\u043E\u0435 \u0443\u0432\u044F\u0434\u0430\u043D\u0438\u0435","disease-\u0445\u043B\u043E\u0440\u043E\u0437":"\u0445\u043B\u043E\u0440\u043E\u0437","disease-\u0446\u0435\u0440\u043A\u043E\u0441\u043F\u043E\u0440\u043E\u0437":"\u0446\u0435\u0440\u043A\u043E\u0441\u043F\u043E\u0440\u043E\u0437","disease-\u0447\u0435\u0440\u043D\u0430\u044F \u043D\u043E\u0436\u043A\u0430":"\u0447\u0435\u0440\u043D\u0430\u044F \u043D\u043E\u0436\u043A\u0430","disease-\u0447\u0435\u0440\u043D\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C":"\u0447\u0435\u0440\u043D\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C","disease-\u0447\u0435\u0440\u043D\u044C":"\u0447\u0435\u0440\u043D\u044C","disease-\u0448\u044E\u0442\u0442\u0435 \u0431\u0443\u0440\u043E\u0435":"\u0448\u044E\u0442\u0442\u0435 \u0431\u0443\u0440\u043E\u0435","pests-\u0431\u0435\u043B\u043E\u043A\u0440\u044B\u043B\u043A\u0430":"\u0431\u0435\u043B\u043E\u043A\u0440\u044B\u043B\u043A\u0430","pests-\u0431\u043B\u043E\u0448\u043A\u0430 \u043A\u0440\u0435\u0441\u0442\u043E\u0446\u0432\u0435\u0442\u043D\u0430\u044F":"\u0431\u043B\u043E\u0448\u043A\u0430 \u043A\u0440\u0435\u0441\u0442\u043E\u0446\u0432\u0435\u0442\u043D\u0430\u044F","pests-\u0432\u043E\u0439\u043B\u043E\u0447\u043D\u044B\u0439 \u043E\u0440\u0435\u0445\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449":"\u0432\u043E\u0439\u043B\u043E\u0447\u043D\u044B\u0439 \u043E\u0440\u0435\u0445\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u0433\u0430\u043B\u043B\u0438\u0446\u044B":"\u0433\u0430\u043B\u043B\u0438\u0446\u044B","pests-\u0433\u043E\u0440\u043E\u0445\u043E\u0432\u0430\u044F \u0437\u0435\u0440\u043D\u043E\u0432\u043A\u0430":"\u0433\u043E\u0440\u043E\u0445\u043E\u0432\u0430\u044F \u0437\u0435\u0440\u043D\u043E\u0432\u043A\u0430","pests-\u0433\u0443\u0441\u0435\u043D\u0438\u0446\u044B":"\u0433\u0443\u0441\u0435\u043D\u0438\u0446\u044B","pests-\u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0441\u0438\u043A":"\u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0441\u0438\u043A","pests-\u0435\u043B\u043E\u0432\u0430\u044F \u043B\u0438\u0441\u0442\u043E\u0432\u0435\u0440\u0442\u043A\u0430-\u0438\u0433\u043B\u043E\u0435\u0434":"\u0435\u043B\u043E\u0432\u0430\u044F \u043B\u0438\u0441\u0442\u043E\u0432\u0435\u0440\u0442\u043A\u0430-\u0438\u0433\u043B\u043E\u0435\u0434","pests-\u0437\u043E\u043D\u0442\u0438\u0447\u043D\u0430\u044F \u043C\u043E\u043B\u044C":"\u0437\u043E\u043D\u0442\u0438\u0447\u043D\u0430\u044F \u043C\u043E\u043B\u044C","pests-\u043A\u0430\u043F\u0443\u0441\u0442\u043D\u0430\u044F \u0433\u0443\u0441\u0435\u043D\u0438\u0446\u0430":"\u043A\u0430\u043F\u0443\u0441\u0442\u043D\u0430\u044F \u0433\u0443\u0441\u0435\u043D\u0438\u0446\u0430","pests-\u043A\u0430\u043F\u0443\u0441\u0442\u043D\u0430\u044F \u043C\u0443\u0445\u0430":"\u043A\u0430\u043F\u0443\u0441\u0442\u043D\u0430\u044F \u043C\u0443\u0445\u0430","pests-\u043A\u043B\u043E\u043F \u0432\u043E\u043D\u044E\u0447\u0438\u0439":"\u043A\u043B\u043E\u043F \u0432\u043E\u043D\u044E\u0447\u0438\u0439","pests-\u043A\u043E\u043B\u043E\u0440\u0430\u0434\u0441\u043A\u0438\u0439 \u0436\u0443\u043A":"\u043A\u043E\u043B\u043E\u0440\u0430\u0434\u0441\u043A\u0438\u0439 \u0436\u0443\u043A","pests-\u043A\u043E\u043C\u0430\u0440\u044B-\u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0436\u043A\u0438":"\u043A\u043E\u043C\u0430\u0440\u044B-\u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0436\u043A\u0438","pests-\u043A\u043E\u0440\u043D\u0435\u0432\u043E\u0439 \u043B\u0443\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449":"\u043A\u043E\u0440\u043D\u0435\u0432\u043E\u0439 \u043B\u0443\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u043A\u0440\u0435\u0441\u0442\u043E\u0446\u0432\u0435\u0442\u043D\u0430\u044F \u0431\u043B\u043E\u0448\u043A\u0430":"\u043A\u0440\u0435\u0441\u0442\u043E\u0446\u0432\u0435\u0442\u043D\u0430\u044F \u0431\u043B\u043E\u0448\u043A\u0430","pests-\u043A\u0440\u043E\u0442":"\u043A\u0440\u043E\u0442","pests-\u043B\u0438\u043B\u0435\u0439\u043D\u0430\u044F \u043C\u0443\u0445\u0430":"\u043B\u0438\u043B\u0435\u0439\u043D\u0430\u044F \u043C\u0443\u0445\u0430","pests-\u043B\u0438\u043B\u0435\u0439\u043D\u044B\u0439 \u0436\u0443\u043A":"\u043B\u0438\u043B\u0435\u0439\u043D\u044B\u0439 \u0436\u0443\u043A","pests-\u043B\u0438\u0441\u0442\u043E\u0431\u043B\u043E\u0448\u043A\u0430":"\u043B\u0438\u0441\u0442\u043E\u0431\u043B\u043E\u0448\u043A\u0430","pests-\u043B\u0438\u0441\u0442\u043E\u0432\u0430\u044F \u0431\u043B\u043E\u0448\u043A\u0430":"\u043B\u0438\u0441\u0442\u043E\u0432\u0430\u044F \u0431\u043B\u043E\u0448\u043A\u0430","pests-\u043B\u0438\u0441\u0442\u043E\u0432\u0435\u0440\u0442\u043A\u0430":"\u043B\u0438\u0441\u0442\u043E\u0432\u0435\u0440\u0442\u043A\u0430","pests-\u043B\u0438\u0441\u0442\u043E\u0435\u0434\u044B":"\u043B\u0438\u0441\u0442\u043E\u0435\u0434\u044B","pests-\u043B\u0443\u043A\u043E\u0432\u0430\u044F \u0436\u0443\u0440\u0447\u0430\u043B\u043A\u0430":"\u043B\u0443\u043A\u043E\u0432\u0430\u044F \u0436\u0443\u0440\u0447\u0430\u043B\u043A\u0430","pests-\u043B\u0443\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449":"\u043B\u0443\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u043C\u0430\u043B\u0438\u043D\u043D\u044B\u0439 \u0436\u0443\u043A":"\u043C\u0430\u043B\u0438\u043D\u043D\u044B\u0439 \u0436\u0443\u043A","pests-\u043C\u0435\u0434\u0432\u0435\u0434\u043A\u0430":"\u043C\u0435\u0434\u0432\u0435\u0434\u043A\u0430","pests-\u043C\u043E\u0440\u043A\u043E\u0432\u043D\u0430\u044F \u043C\u0443\u0445\u0430":"\u043C\u043E\u0440\u043A\u043E\u0432\u043D\u0430\u044F \u043C\u0443\u0445\u0430","pests-\u043C\u0438\u043D\u0438\u0440\u0443\u044E\u0449\u0430\u044F \u043C\u0443\u0445\u0430":"\u043C\u0438\u043D\u0438\u0440\u0443\u044E\u0449\u0430\u044F \u043C\u0443\u0445\u0430","pests-\u043C\u0443\u0440\u0430\u0432\u044C\u0438":"\u043C\u0443\u0440\u0430\u0432\u044C\u0438","pests-\u043C\u0443\u0447\u043D\u0438\u0441\u0442\u044B\u0439 \u0447\u0435\u0440\u0432\u0435\u0446":"\u043C\u0443\u0447\u043D\u0438\u0441\u0442\u044B\u0439 \u0447\u0435\u0440\u0432\u0435\u0446","pests-\u043C\u044F\u0433\u043A\u0430\u044F \u043B\u043E\u0436\u043D\u043E\u0449\u0438\u0442\u043E\u0432\u043A\u0430":"\u043C\u044F\u0433\u043A\u0430\u044F \u043B\u043E\u0436\u043D\u043E\u0449\u0438\u0442\u043E\u0432\u043A\u0430","pests-\u043D\u0435\u043C\u0430\u0442\u043E\u0434\u044B":"\u043D\u0435\u043C\u0430\u0442\u043E\u0434\u044B","pests-\u043E\u0433\u043D\u0435\u0432\u043A\u0430":"\u043E\u0433\u043D\u0435\u0432\u043A\u0430","pests-\u043F\u0430\u0443\u0442\u0438\u043D\u043D\u044B\u0439 \u043A\u043B\u0435\u0449":"\u043F\u0430\u0443\u0442\u0438\u043D\u043D\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u043F\u0438\u043B\u0438\u043B\u044C\u0449\u0438\u043A":"\u043F\u0438\u043B\u0438\u043B\u044C\u0449\u0438\u043A","pests-\u043F\u043B\u043E\u0434\u043E\u0436\u043E\u0440\u043A\u0430":"\u043F\u043B\u043E\u0434\u043E\u0436\u043E\u0440\u043A\u0430","pests-\u043F\u043E\u043B\u0435\u0432\u0430\u044F \u043C\u044B\u0448\u044C":"\u043F\u043E\u043B\u0435\u0432\u0430\u044F \u043C\u044B\u0448\u044C","pests-\u043F\u043E\u043B\u0435\u0432\u043E\u0439 \u043A\u043B\u043E\u043F":"\u043F\u043E\u043B\u0435\u0432\u043E\u0439 \u043A\u043B\u043E\u043F","pests-\u043F\u043E\u043B\u043E\u0441\u0430\u0442\u044B\u0439 \u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0441\u0438\u043A":"\u043F\u043E\u043B\u043E\u0441\u0430\u0442\u044B\u0439 \u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0441\u0438\u043A","pests-\u043F\u043E\u0447\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449":"\u043F\u043E\u0447\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u043F\u0440\u043E\u0432\u043E\u043B\u043E\u0447\u043D\u0438\u043A":"\u043F\u0440\u043E\u0432\u043E\u043B\u043E\u0447\u043D\u0438\u043A","pests-\u0440\u0430\u0441\u0442\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u044F\u0434\u043D\u044B\u0439 \u043A\u043B\u0435\u0449":"\u0440\u0430\u0441\u0442\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u044F\u0434\u043D\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u0441\u0430\u043C\u0448\u0438\u0442\u043E\u0432\u0430\u044F \u043E\u0433\u043D\u0435\u0432\u043A\u0430":"\u0441\u0430\u043C\u0448\u0438\u0442\u043E\u0432\u0430\u044F \u043E\u0433\u043D\u0435\u0432\u043A\u0430","pests-\u0441\u0435\u043B\u044C\u0434\u0435\u0440\u0435\u0439\u043D\u0430\u044F \u043C\u0443\u0445\u0430":"\u0441\u0435\u043B\u044C\u0434\u0435\u0440\u0435\u0439\u043D\u0430\u044F \u043C\u0443\u0445\u0430","pests-\u0441\u043B\u0438\u0437\u043D\u0438":"\u0441\u043B\u0438\u0437\u043D\u0438","pests-\u0441\u043B\u044E\u043D\u044F\u0432\u0430\u044F \u043F\u0435\u043D\u043D\u0438\u0446\u0430":"\u0441\u043B\u044E\u043D\u044F\u0432\u0430\u044F \u043F\u0435\u043D\u043D\u0438\u0446\u0430","pests-\u0441\u0442\u0435\u0431\u043B\u0435\u0432\u0430\u044F \u043D\u0435\u043C\u0430\u0442\u043E\u0434\u0430":"\u0441\u0442\u0435\u0431\u043B\u0435\u0432\u0430\u044F \u043D\u0435\u043C\u0430\u0442\u043E\u0434\u0430","pests-\u0442\u0430\u0431\u0430\u0447\u043D\u044B\u0439 \u043F\u0440\u043E\u0432\u043E\u043B\u043E\u0447\u043D\u0438\u043A":"\u0442\u0430\u0431\u0430\u0447\u043D\u044B\u0439 \u043F\u0440\u043E\u0432\u043E\u043B\u043E\u0447\u043D\u0438\u043A","pests-\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u0433\u0430\u043B\u043B\u0438\u0446\u0430":"\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u0433\u0430\u043B\u043B\u0438\u0446\u0430","pests-\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u043B\u043E\u0436\u043D\u043E\u0449\u0438\u0442\u043E\u0432\u043A\u0430":"\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u043B\u043E\u0436\u043D\u043E\u0449\u0438\u0442\u043E\u0432\u043A\u0430","pests-\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u043F\u043B\u043E\u0441\u043A\u043E\u0442\u0435\u043B\u043A\u0430":"\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u043F\u043B\u043E\u0441\u043A\u043E\u0442\u0435\u043B\u043A\u0430","pests-\u0442\u0438\u0441\u043E\u0432\u044B\u0439 \u043F\u043E\u0447\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449":"\u0442\u0438\u0441\u043E\u0432\u044B\u0439 \u043F\u043E\u0447\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u0442\u043B\u044F":"\u0442\u043B\u044F","pests-\u0442\u0440\u0438\u043F\u0441\u044B":"\u0442\u0440\u0438\u043F\u0441\u044B","pests-\u0442\u044E\u043B\u044C\u043F\u0430\u043D\u043E\u0432\u0430\u044F \u043E\u0433\u043D\u0451\u0432\u043A\u0430":"\u0442\u044E\u043B\u044C\u043F\u0430\u043D\u043E\u0432\u0430\u044F \u043E\u0433\u043D\u0451\u0432\u043A\u0430","pests-\u0443\u043B\u0438\u0442\u043A\u0438":"\u0443\u043B\u0438\u0442\u043A\u0438","pests-\u0444\u0430\u0441\u043E\u043B\u0435\u0432\u0430\u044F \u0437\u0435\u0440\u043D\u043E\u0432\u043A\u0430":"\u0444\u0430\u0441\u043E\u043B\u0435\u0432\u0430\u044F \u0437\u0435\u0440\u043D\u043E\u0432\u043A\u0430","pests-\u0445\u0440\u0443\u0449":"\u0445\u0440\u0443\u0449","pests-\u0446\u0432\u0435\u0442\u043E\u0447\u043D\u0430\u044F \u043F\u044F\u0434\u0435\u043D\u0438\u0446\u0430":"\u0446\u0432\u0435\u0442\u043E\u0447\u043D\u0430\u044F \u043F\u044F\u0434\u0435\u043D\u0438\u0446\u0430","pests-\u0449\u0438\u0442\u043E\u0432\u043A\u0430":"\u0449\u0438\u0442\u043E\u0432\u043A\u0430","pesticideTreatmentFrequency-1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E":"1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E","pesticideTreatmentFrequency-2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E":"2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E","pesticideTreatmentFrequency-1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446":"1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446","pesticideTreatmentFrequency-2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446":"2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446","pesticideTreatmentFrequency-1 \u0440\u0430\u0437 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D":"1 \u0440\u0430\u0437 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D","pesticideTreatmentFrequency-\u043F\u043E \u043C\u0435\u0440\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438":"\u043F\u043E \u043C\u0435\u0440\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438","pesticideTreatmentFrequency-\u043F\u0440\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445":"\u043F\u0440\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445","fertilizerFrequency-1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E":"1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E","fertilizerFrequency-2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E":"2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E","fertilizerFrequency-1 \u0440\u0430\u0437 \u0432 2 \u043D\u0435\u0434\u0435\u043B\u0438":"1 \u0440\u0430\u0437 \u0432 2 \u043D\u0435\u0434\u0435\u043B\u0438","fertilizerFrequency-1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446":"1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446","fertilizerFrequency-2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446":"2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446","fertilizerFrequency-1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446 \u0432 \u0432\u0435\u0433\u0435\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434":"1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446 \u0432 \u0432\u0435\u0433\u0435\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434","fertilizerFrequency-2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446 \u0432 \u0432\u0435\u0433\u0435\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434":"2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446 \u0432 \u0432\u0435\u0433\u0435\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434","fertilizerFrequency-1 \u0440\u0430\u0437 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D":"1 \u0440\u0430\u0437 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D","fertilizerFrequency-2 \u0440\u0430\u0437\u0430 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D":"2 \u0440\u0430\u0437\u0430 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D","fertilizerFrequency-3-4 \u0440\u0430\u0437\u0430 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D":"3-4 \u0440\u0430\u0437\u0430 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D","fertilizerFrequency-\u043F\u0440\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445":"\u043F\u0440\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445","elementName-building":"building","elementName-building1":"building 1","elementName-building2":"building 2","elementName-building3":"building 3","elementName-building4":"building 4","elementName-building5":"building 5","elementName-building6":"building 6","elementName-building7":"building 7","elementName-building8":"building 8","elementName-building9":"building 9","elementName-building10":"building 10","elementName-building11":"building 11","elementName-building12":"building 12","elementName-building13":"building 13","elementName-building14":"building 14","elementName-building15":"building 15","elementName-building16":"building 16","elementName-building17":"building 17","elementName-building18":"building 18","elementName-garden":"garden","elementName-lawn":"lawn","elementName-flowerbed":"flower bed","elementName-flowerbed1":"square flower bed","elementName-flowerbed2":"round flower bed","elementName-flowerbed11":"square flower bed","elementName-flowerbed22":"round flower bed","elementName-greenhouse":"greenhouse","elementName-greenhouse1":"greenhouse1","elementName-vegetablegarden":"veg garden","elementName-veggardencabbage":"veg garden cabbage","elementName-veggarden11":"veg garden 11","elementName-veggarden12":"veg garden 12","elementName-veggarden2":"veg garden 2","elementName-veggarden4":"veg garden 4","elementName-veggarden7":"veg garden 7","elementName-veggarden26":"veg garden 26","elementName-tile":"tile","elementName-tile1":"tile 1","elementName-tile2":"tile 2","elementName-tile3":"tile 3","elementName-tile4":"tile 4","elementName-tile5":"tile 5","elementName-tile6":"tile 6","elementName-stairs":"stairs","elementName-stairs1":"stairs 1","elementName-stairs2":"stairs 2","elementName-terrace":"terrace","elementName-terrace1":"terrace 1","elementName-patio":"patio","elementName-patio1":"patio 1","elementName-patio2":"patio 2","elementName-fence":"fence","elementName-fence1":"fence 1","elementName-fence2":"fence 2","elementName-fence3":"fence 3","elementName-fence4":"fence 4","elementName-entrance":"entrance","elementName-gate1":"double gate","elementName-gate2":"single gate","elementName-wicket":"wicket","elementName-plantcomposition":"plant composition","elementName-rockery1":"rockery 1","elementName-rockery2":"rockery 2","elementName-rockery3":"rockery 3","elementName-tree":"tree","elementName-bush":"bush","elementName-redBush":"red bush","elementName-grass":"grass","elementName-structure":"structure","elementName-gazebo1":"gazebo 1","elementName-pathway":"pathway","elementName-pathway1":"pathway 1","elementName-pathway2":"pathway 2","elementName-pathway3":"pathway 3","elementName-pathway4":"pathway 4","elementName-pathway5":"pathway 5","elementName-pathway6":"pathway 6","elementName-pathway7":"pathway 7","elementName-pathway8":"pathway 8","elementName-pathway9":"pathway 9","elementName-pathway10":"pathway 10","elementName-pathway11":"pathway 11","elementName-pathway12":"pathway 12","elementName-pathway13":"pathway 13","elementName-pathway14":"pathway 14","elementName-court":"court","elementName-court1":"court 1","elementName-court2":"court 2","elementName-hedge":"hedge","elementName-hedge1":"hedge 1","elementName-hedge2":"hedge 2","elementName-hedge3":"hedge 3","elementName-hedge4":"hedge 4","elementName-hedge5":"hedge 5","elementName-hedge6":"hedge 6","elementName-tree1":"tree 1","elementName-treeapple":"fruit tree","elementName-bush3":"bush","elementName-bush4":"bush","elementName-bush6":"bush","elementName-bush7":"bush","elementName-grass_gray":"gray grass","elementName-carex":"carex","elementName-bushflowersorange":"bush with orange flowers","elementName-bushflowersred":"bush with red flowers","elementName-boxwoodball":"ball","elementName-cabbage":"cabbage","elementName-carrot":"carrot","elementName-eggplant":"eggplant","elementName-beet":"beet","elementName-onion":"onion","elementName-salad":"salad","elementName-pool":"pool","elementName-waterpool1":"waterpool 1","elementName-waterpool2":"waterpool 2","elementName-waterpool3":"waterpool 3","elementName-waterpool4":"waterpool 4","elementName-waterpool5":"waterpool 5","elementName-waterpool6":"waterpool 6","elementName-waterpool7":"waterpool 7","elementName-waterpool8":"waterpool 8","elementName-waterpool9":"waterpool 9","elementName-water":"water element","elementName-fountain1":"fountain 1","elementNamewaterfall2":"waterfall 2","elementName-stone1":"stone 1","elementName-stone2":"stone 2","elementName-stone3":"stone 3","elementName-stone4":"stone 4","elementName-flowerpot1":"flower pot","elementName-turtle":"turtle","elementName-car1":"car","elementName-sofa1":"sofa","elementName-chair1":"chair","elementName-table1":"table","elementName-lampball":"lamp ball","elementName-lamp":"lamp","elementName-spotlight":"spotlight"}');


var $20178330a7afdb4e$exports = {};
$20178330a7afdb4e$exports = JSON.parse('{"1000Plants":"1000+ \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439 \u0432 \u0431\u0430\u0437\u0435 \u0434\u0430\u043D\u043D\u044B\u0445","1000PlantsDescription":"\u0414\u043E\u0431\u0430\u0432\u043B\u044F\u0439\u0442\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0438\u0437 \u0431\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u043F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0438 \u043F\u043E \u0443\u0445\u043E\u0434\u0443","actions":"\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F","addCollection":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044E","add":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C","apply":"\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C","applyGardenPlanTitle":"\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043B\u0430\u043D \\"{planName}\\" \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443?","applyGardenPlanDescription":"\u0420\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0438\u0437 \u043F\u043B\u0430\u043D\u0430 \u0431\u0443\u0434\u0443\u0442 \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0435\u043D\u044B \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439 \u043F\u0440\u043E\u0435\u043A\u0442, \u0430 \u0441\u0430\u043C \u043F\u043B\u0430\u043D \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0451\u043D.","addEvent":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u0431\u044B\u0442\u0438\u0435","addFromPlantDatabase":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u0438\u0437 \u0431\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445","addingNewPlant":"\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","addingNewTask":"\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0439 \u0437\u0430\u0434\u0430\u0447\u0438","additionalCareSteps":"\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043F\u043E \u0443\u0445\u043E\u0434\u0443","addNewEvent":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u0435","addNewTask":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0437\u0430\u0434\u0430\u0447\u0443","addPlant":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","addPlantSpecimen":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u044D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","addTask":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443","advantages":"\u0414\u043E\u0441\u0442\u043E\u0438\u043D\u0441\u0442\u0432\u0430","advicePlotMapFirst":"\u0421\u043E\u0432\u0435\u0442: \u0414\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0442\u043E\u0447\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u0443\u0447\u0430\u0441\u0442\u043A\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0435 \u043A\u0430\u0440\u0442\u0443. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u0430\u0440\u0442\u044B \u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u0435 \u043C\u043E\u0436\u043D\u043E \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043D\u0430 \u0428\u0430\u0433\u0435 1.","afterDiggingThePlantWillBeTransferredToTheUnplantedOnes":"\u041F\u043E\u0441\u043B\u0435 \u0432\u044B\u043A\u0430\u043F\u044B\u0432\u0430\u043D\u0438\u044F \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u0431\u0443\u0434\u0435\u0442 \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0435\u043D\u043E \u0432 \u043D\u0435\u0432\u044B\u0441\u0430\u0436\u0435\u043D\u043D\u044B\u0435.","afterRemovingThePlantWillBeTransferredToTheUnplantedOnes":"\u041F\u043E\u0441\u043B\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u0431\u0443\u0434\u0435\u0442 \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0435\u043D\u043E \u0432 \u043D\u0435\u0432\u044B\u0441\u0430\u0436\u0435\u043D\u043D\u044B\u0435.","allNews":"\u0412\u0441\u0435 \u043D\u043E\u0432\u043E\u0441\u0442\u0438","allProjects":"\u0412\u0441\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u044B","allReminders":"\u0412\u0441\u0435 \u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F","allPlannedTasks":"\u0412\u0441\u0435 \u0437\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0437\u0430\u0434\u0430\u0447\u0438","allTutorials":"\u0412\u0441\u0435 \u043F\u043E\u043B\u0435\u0437\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B","allUsefulMaterials":"\u0412\u0441\u0435 \u043F\u043E\u043B\u0435\u0437\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B","appearance":"\u0412\u043D\u0435\u0448\u043D\u0438\u0439 \u0432\u0438\u0434","applicationInDesign":"\u041F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0432 \u0434\u0438\u0437\u0430\u0439\u043D\u0435","applyingFertilizer":"\u0412\u043D\u0435\u0441\u0435\u043D\u0438\u0435 \u0443\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0439","areYouSureYouWantToDelete":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C?","areYouSureYouWantToDeleteThisPlan":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u043F\u043B\u0430\u043D?","areYouSureYouWantToDeleteThisCollection":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044E?","areYouSureYouWantToDeleteThisEvent":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E \u0441\u043E\u0431\u044B\u0442\u0438\u0435?","areYouSureYouWantToDigUpAllTheSpecimensOfThisPlant":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0432\u044B\u043A\u043E\u043F\u0430\u0442\u044C \u0432\u0441\u0435 \u044D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440\u044B \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F?","areYouSureYouWantToFinish":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443?","areYouSureYouWantToMakeSnapshot":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0441\u043D\u0438\u043C\u043E\u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0430?","attitudeToLight":"\u041E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0435 \u043A \u043E\u0441\u0432\u0435\u0449\u0435\u043D\u043D\u043E\u0441\u0442\u0438","basePlant":"\u0411\u0430\u0437\u043E\u0432\u043E\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","basePlant-tooltip":"\u041F\u0440\u0438 \u0432\u044B\u0431\u043E\u0440\u0435 \u0431\u0430\u0437\u043E\u0432\u043E\u0433\u043E \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0431\u0443\u0434\u0443\u0442 \u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u044B \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0435\u0439 \u0438\u0437 \u0431\u0430\u0437\u044B \u0434\u0430\u043D\u043D\u044B\u0445 TerraSketch, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0439 \u0441 \u0434\u0430\u043D\u043D\u044B\u043C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435\u043C. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u043E\u043F\u043E\u043B\u043D\u044F\u0442\u044C \u0438\u043B\u0438 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u0430\u043D\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E. \u0412\u043D\u0435\u0441\u0435\u043D\u043D\u044B\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u043D\u044B \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u0430\u043C.","building":"\u0417\u0434\u0430\u043D\u0438\u0435","buildingPlural":"\u0417\u0434\u0430\u043D\u0438\u044F","bush":"\u041A\u0443\u0441\u0442","bushPlural":"\u041A\u0443\u0441\u0442\u044B","bushCat":"\u041A\u0443\u0441\u0442\u044B \u0438 \u0442\u0440\u0430\u0432\u044B","bushCatPlural":"\u041A\u0443\u0441\u0442\u044B \u0438 \u0442\u0440\u0430\u0432\u044B","byClickingLogInWithGoogle":"\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u0432\u043E\u0439\u0442\u0438 \u0441 Google \u0432\u044B\u0448\u0435, \u0432\u044B \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043B\u0438 \u0438 \u043F\u043E\u043D\u044F\u043B\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u043B\u0438\u0441\u044C c ","byClickingSignUpWithGoogle":"\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0441 Google \u0432\u044B\u0448\u0435, \u0432\u044B \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043B\u0438 \u0438 \u043F\u043E\u043D\u044F\u043B\u0438, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u043B\u0438\u0441\u044C c ","cancel":"\u041E\u0442\u043C\u0435\u043D\u0430","canvasDataDescriptionSeparatlyGrowing":"\u0438\u043C\u0435\u044E\u0449\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u044C \u0432 \u0441\u043F\u0438\u0441\u043A\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439 \u0438 \u043C\u043E\u0434\u0435\u043B\u044C \u043D\u0430 \u043F\u043B\u0430\u043D\u0435","canvasDataDescriptionSolitariusTemplates":"\u043C\u043E\u0436\u043D\u043E \u0441\u0432\u044F\u0437\u0430\u0442\u044C \u0441 \u0437\u0430\u043F\u0438\u0441\u044C\u044E \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u043D\u0430\u0436\u0430\u0442\u0438\u0435\u043C \u043D\u0430 ","canvasDataDescriptionOther":"\u0414\u0440\u0443\u0433\u0438\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u0443\u0447\u0430\u0441\u0442\u043A\u0430","care":"\u0423\u0445\u043E\u0434","careDifficulty":"\u0421\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0443\u0445\u043E\u0434\u0430","carePlan":"\u041F\u043B\u0430\u043D \u0443\u0445\u043E\u0434\u0430 (\u0437\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0437\u0430\u0434\u0430\u0447\u0438)","category":"\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F","center":"\u0426\u0435\u043D\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C","changeBasePlant":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0431\u0430\u0437\u043E\u0432\u043E\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","changePassword":"\u0421\u043C\u0435\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u044F","changeProjectLocation":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430","characteristics":"\u0425\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438","checkAllPlantsFromTheCollection":"\u041E\u0442\u043C\u0435\u0442\u0438\u0442\u044C \u0432\u0441\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0438\u0437 \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438","checkYourEmail":"\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u0432\u043E\u044E \u043F\u043E\u0447\u0442\u0443, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C.","chooseMode":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0435\u0436\u0438\u043C","chooseObjectType":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u043E\u0431\u044A\u0435\u043A\u0442\u0430","chooseObjectForm":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u0443 \u043E\u0431\u044A\u0435\u043A\u0442\u0430","choosePlotType":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0443\u0447\u0430\u0441\u0442\u043A\u0430","chooseProjectImage":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u0430","chooseType":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F","clearBasePlant":"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0431\u0430\u0437\u043E\u0432\u043E\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","clearBasePlantMatchingFields":"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0442\u0430\u043A\u0436\u0435 \u043F\u043E\u043B\u044F \u043F\u0440\u0435\u0434\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0435 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0435 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0431\u0430\u0437\u043E\u0432\u043E\u0433\u043E \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","clearFilters":"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B","clearSorting":"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0443","closeEvent":"\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0441\u043E\u0431\u044B\u0442\u0438\u0435","cm":"\u0441\u043C","collections":"\u041A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438","collections-tooltip":"\u041A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438 \u0441\u043E\u0437\u0434\u0430\u044E\u0442\u0441\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0434\u043B\u044F \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430. \u042D\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0432\u0438\u0434 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0438\u043B\u0438 \u043A\u0430\u043A\u0430\u044F-\u0442\u043E \u0435\u0433\u043E \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0430. \u0414\u0430\u043D\u043D\u043E\u0435 \u043F\u043E\u043B\u0435 \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0430\u0448\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0438 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0442\u044C \u0443\u0434\u043E\u0431\u043D\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C.","combineElementWithPlant":"\u041E\u0431\u044A\u0435\u0434\u0438\u043D\u0438\u0442\u044C \u044D\u043B\u0435\u043C\u0435\u043D\u0442 \u0441 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435\u043C","comment":"\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439","commonInfo":"\u041E\u0431\u0449\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F","completedActions":"\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F","confidenceInPlantVariety":"\u0423\u0432\u0435\u0440\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0432 \u0441\u043E\u0440\u0442\u0435","confirm":"\u041F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435","confirmClearBasePlant":"\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0431\u0430\u0437\u043E\u0432\u043E\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","confirmFormCloseTitle":"\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u0444\u043E\u0440\u043C\u0443 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F?","court":"\u041A\u043E\u0440\u0442/\u041F\u043B\u043E\u0449\u0430\u0434\u043A\u0430","createATaskListAssociatedWithTheProjectAndEnterTheFirstTask":"\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0441\u043F\u0438\u0441\u043E\u043A \u0437\u0430\u0434\u0430\u0447, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0439 \u0441 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C, \u0438 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0435\u0440\u0432\u0443\u044E \u0437\u0430\u0434\u0430\u0447\u0443","createElement":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C","createFirstProject":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0435\u0440\u0432\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442","createFirstTask":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0435\u0440\u0432\u0443\u044E \u0437\u0430\u0434\u0430\u0447\u0443","createFromTemplate":"\u0428\u0430\u0431\u043B\u043E\u043D","createNewProject":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442","createPolygonPlot":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u043E\u043B\u0438\u0433\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u0443\u0447\u0430\u0441\u0442\u043E\u043A","createTheFirstPlantInTheProject":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u0435 \u043F\u0435\u0440\u0432\u043E\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","createYourFirstProjectDescription1":"\u0414\u043B\u044F \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430 \u0440\u0430\u0431\u043E\u0442\u044B \u0432 TerraSketch \u0432\u0441\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u043E\u0432\u0430\u043D\u043E \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432.","createYourFirstProjectDescription2":"\u0427\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443, \u0432\u0430\u043C \u043D\u0430\u0434\u043E \u043F\u0440\u043E\u0441\u0442\u043E \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442. \u0412\u044B \u0441\u0430\u043C\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0435, \u0447\u0442\u043E \u043F\u043E\u0434\u0440\u0430\u0437\u0443\u043C\u0435\u0432\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0434 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C. \u042D\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043E\u043A, \u0434\u043E\u043C, \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u0430\u044F \u043A\u043B\u0443\u043C\u0431\u0430 \u0438 \u0442\u0430\u043A \u0434\u0430\u043B\u0435\u0435.","createYourFirstProjectDescription3":"\u0421 \u043A\u0430\u0436\u0434\u044B\u043C \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C \u043C\u043E\u0436\u043D\u043E \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u043F\u043E \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438, \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043F\u043B\u0430\u043D \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432, \u043E\u0442\u043C\u0435\u0447\u0430\u0442\u044C \u043C\u0435\u0441\u0442\u0430 \u043F\u043E\u0441\u0430\u0434\u043A\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439, \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0438. \u0412 \u0440\u0430\u0437\u0434\u0435\u043B\u0430\u0445 \u041D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F, \u0420\u0430\u0441\u0442\u0435\u043D\u0438\u044F, \u0416\u0443\u0440\u043D\u0430\u043B \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0441\u043E \u0441\u0432\u043E\u0434\u043A\u043E\u0439 \u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E \u0432\u0441\u0435\u043C \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u043C \u0441\u0440\u0430\u0437\u0443.","createYourFirstProjectDescription4":"\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043D\u0430\u0447\u0438\u043D\u0430\u0442\u044C \u0441 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0432\u0435\u0441\u044C \u0443\u0447\u0430\u0441\u0442\u043E\u043A), \u0430 \u043F\u043E\u0442\u043E\u043C, \u043F\u0440\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438, \u0432\u044B\u0434\u0435\u043B\u044F\u0442\u044C \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u0447\u0430\u0441\u0442\u0438 \u0432 \u0440\u0430\u0437\u043D\u044B\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u044B.","creatingOfNewProject":"\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430","critical":"\u043A\u0440\u0438\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439","contacts":"\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B","continue":"\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C","continueWithoutSaving":"\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0431\u0435\u0437 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F","date":"\u0414\u0430\u0442\u0430","dateOfEvent":"\u0414\u0430\u0442\u0430 \u0441\u043E\u0431\u044B\u0442\u0438\u044F","dateOfPlanting":"\u0414\u0430\u0442\u0430 \u043F\u043E\u0441\u0430\u0434\u043A\u0438","dateOfPlantingUtc":"\u0414\u0430\u0442\u0430 \u043F\u043E\u0441\u0430\u0434\u043A\u0438","dateRange":"\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442","defaultProjectWithoutPlans":"\u041F\u0440\u043E\u0435\u043A\u0442 \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E (\u0431\u0435\u0437 \u043F\u043B\u0430\u043D\u043E\u0432)","delete":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C","deleteAccount":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442","deleteElement":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C","deleteEvent":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u043E\u0431\u044B\u0442\u0438\u0435","deletePlant":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","deletePlantConfirm":"\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435?","deletePlantEventsConfirm":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u0437 \u0436\u0443\u0440\u043D\u0430\u043B\u0430 \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0441 \u044D\u0442\u0438\u043C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435\u043C","deletePlantFromToDoConfirm":"\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u044D\u0442\u043E \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u0430 \u0438\u0437 \u0437\u0430\u0434\u0430\u0447.","deleteProject":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442","deleteProjectWithPlantsAndEventsConfirm":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u0437 \u0436\u0443\u0440\u043D\u0430\u043B\u0430 \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0441 \u044D\u0442\u0438\u043C\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F\u043C\u0438","deleteProjectWithPlantsConfirm":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u0437 \u0436\u0443\u0440\u043D\u0430\u043B\u0430 \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0441 \u044D\u0442\u0438\u043C \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C","description":"\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435","disadvantages":"\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043A\u0438","disease":"\u0411\u043E\u043B\u0435\u0437\u043D\u0438","digUpAllPlantSpecimens":"\u0412\u044B\u043A\u043E\u043F\u0430\u0442\u044C \u0432\u0441\u0435 \u044D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440\u044B \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439","digUpPlant":"\u0412\u044B\u043A\u043E\u043F\u0430\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","doYouReallyWantToDelete":"\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C","doYouReallyWantToDeleteThisAccount":"\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0430\u043A\u043A\u0430\u0443\u043D\u0442?","doYouWantToSaveTheProjectBeforeMovingOnToTheNextStep":"\u0425\u043E\u0442\u0438\u0442\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442 \u043F\u0435\u0440\u0435\u0434 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u043E\u043C \u043A \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C\u0443 \u0448\u0430\u0433\u0443? \u041D\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0431\u0443\u0434\u0443\u0442 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u044B.","draw":"\u041D\u0430\u0440\u0438\u0441\u043E\u0432\u0430\u0442\u044C","duplicatePlant":"\u041F\u0440\u043E\u0434\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","edge":"\u0413\u0440\u0430\u043D\u0438\u0446\u0430","edibility":"\u0421\u044A\u0435\u0434\u043E\u0431\u043D\u043E\u0441\u0442\u044C","edit":"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C","editedInAnotherStep":"\u0412\u044B\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0439 \u044D\u043B\u0435\u043C\u0435\u043D\u0442 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043D\u0430 \u0434\u0440\u0443\u0433\u043E\u043C \u0448\u0430\u0433\u0435","editElement":"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C","editGardenPlan":"\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u043F\u043B\u0430\u043D","editingPlant":"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","editor":"\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0443\u0447\u0430\u0441\u0442\u043A\u0430","editPlant":"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","editProject":"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442","editStepDefGenInfo":"\u0412\u0432\u0435\u0441\u0442\u0438 \u043E\u0431\u0449\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0435.","editStepDefPlot":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043E\u0441\u043D\u043E\u0432\u0443 \u0443\u0447\u0430\u0441\u0442\u043A\u0430.","editStepDefSoftscape":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0435\u043B\u0435\u043D\u044B\u0435 \u0437\u043E\u043D\u044B \u0443\u0447\u0430\u0441\u0442\u043A\u0430.","editStepDefHardscape":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0438 \u0438 \u0434\u043E\u0440\u043E\u0436\u043A\u0438.","editStepDefBuildings":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u044F \u0438 \u043E\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F.","editStepDefLargePlants":"\u0420\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043A\u0440\u0443\u043F\u043D\u044B\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F.","editStepDefWaterscape":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0432\u043E\u0434\u043D\u044B\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u044B.","editStepDefSolitarius":"\u0420\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F.","editStepDefOtherElements":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u0438\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B.","editTask":"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443","ellipse":"\u042D\u043B\u043B\u0438\u043F\u0441\u043E\u0438\u0434\u0430\u043B\u044C\u043D\u044B\u0439","email":"\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430","emailIsIncorrect":"\u0412\u0432\u0435\u0434\u0435\u043D\u043D\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0430\u0434\u0440\u0435\u0441\u043E\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B.","emailUs":"\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043D\u0430\u043C","enterProjectLocation":"\u0412\u0432\u0435\u0441\u0442\u0438 \u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430","endDate":"\u0414\u0430\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F","enterObjectName":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u0430","enterPlotEdgesDimensions":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0440\u0430\u0437\u043C\u0435\u0440\u044B \u0433\u0440\u0430\u043D\u0438\u0446 \u0443\u0447\u0430\u0441\u0442\u043A\u0430","enterResetEmail":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u043F\u043E\u0447\u0442\u044B \u0434\u043B\u044F \u0441\u0431\u0440\u043E\u0441\u0430 \u043F\u0430\u0440\u043E\u043B\u044F","entrance":"\u0412\u0445\u043E\u0434\u043D\u0430\u044F \u0433\u0440\u0443\u043F\u043F\u0430","entrancePlural":"\u0412\u0445\u043E\u0434\u043D\u044B\u0435 \u0433\u0440\u0443\u043F\u043F\u044B","errorDuringLogin":"\u041E\u0448\u0438\u0431\u043A\u0430 \u0432\u0445\u043E\u0434\u0430","eventCategory":"\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0441\u043E\u0431\u044B\u0442\u0438\u044F","eventEndDate":"\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u043E\u0431\u044B\u0442\u0438\u044F","eventInfo":"\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0441\u043E\u0431\u044B\u0442\u0438\u0438","eventPhotos":"\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438","eventName":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F","eventType":"\u0422\u0438\u043F \u0441\u043E\u0431\u044B\u0442\u0438\u044F","failedToDeleteTask":"\u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443","family":"\u0421\u0435\u043C\u0435\u0439\u0441\u0442\u0432\u043E","familyRu":"\u0421\u0435\u043C\u0435\u0439\u0441\u0442\u0432\u043E (\u0440\u0443\u0441.)","familyLa":"\u0421\u0435\u043C\u0435\u0439\u0441\u0442\u0432\u043E","faq":"\u0427\u0430\u0441\u0442\u043E \u0437\u0430\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B","faqAnswer1":"\u0411\u0430\u0437\u043E\u0432\u0430\u044F \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E\u0439 \u0434\u043B\u044F \u0432\u0441\u0435\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439. \u0418\u043C\u0435\u044E\u0442\u0441\u044F \u043F\u043B\u0430\u0442\u043D\u044B\u0435 \u0442\u0430\u0440\u0438\u0444\u044B, \u0434\u043E\u0431\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0435 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0443 \u0431\u043E\u043B\u044C\u0448\u0435\u0433\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430 \u0441\u0432\u043E\u0438\u0445 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0439.","faqAnswer2":"\u0411\u0430\u0437\u0430 \u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439 \u0437\u0430\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F \u043D\u0430\u0448\u0438\u043C\u0438 \u044D\u043A\u0441\u043F\u0435\u0440\u0442\u0430\u043C\u0438 \u0438 \u0435\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u043E \u043F\u043E\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F \u043D\u043E\u0432\u044B\u043C\u0438 \u044D\u043A\u0437\u0435\u043C\u043B\u044F\u0440\u0430\u043C\u0438.  \u0412\u0441\u0435 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u0435 \u0432 \u0431\u0430\u0437\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439, \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0442 \u0441\u043E\u0431\u043E\u0439 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u044B \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430\u043C\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430 \u0438 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0442 \u043F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430.","faqAnswer3":"\u041D\u0430 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F \u0441\u0430\u0439\u0442\u0430, \u0430\u0434\u0430\u043F\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043D\u0430 \u043C\u0430\u043B\u044B\u0445 \u044D\u043A\u0440\u0430\u043D\u0430\u0445.","faqAnswer4":"\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0442 \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C, \u0445\u0440\u0430\u043D\u044F\u0442\u0441\u044F \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435, \u043D\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u0432 \u0431\u0430\u0437\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430 \u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0434\u0440\u0443\u0433\u0438\u043C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C.","faqQuestion1":"\u042F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043B\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442 \u043F\u043B\u0430\u0442\u043D\u044B\u043C?","faqQuestion2":"\u041E\u0442\u043A\u0443\u0434\u0430 \u0431\u0435\u0440\u0435\u0442\u0441\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0432 \u0431\u0430\u0437\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439?","faqQuestion3":"\u0418\u043C\u0435\u0435\u0442\u0441\u044F \u043B\u0438 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 TerraSketch?","faqQuestion4":"\u041A\u0430\u043A \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u0438 \u043A\u043E\u043C\u0443 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u043C\u043E\u0438 \u0434\u0430\u043D\u043D\u044B\u0435?","featuresOfCultivation":"\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432\u044B\u0440\u0430\u0449\u0438\u0432\u0430\u043D\u0438\u044F","featuresOfFruitStorage":"\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u043B\u043E\u0434\u043E\u0432","featuresOfStoringPlantingMaterial":"\u041E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430","fence":"\u041E\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u0435","fertilizerFrequency":"\u0427\u0430\u0441\u0442\u043E\u0442\u0430 \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0443\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0439","fertilizers":"\u0423\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u044F","fieldIsRequired":"\u041F\u043E\u043B\u0435 {field} \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u043C","filter":"\u0424\u0438\u043B\u044C\u0442\u0440","filters":"\u0424\u0438\u043B\u044C\u0442\u0440\u044B","filtersAndSorting":"\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0438 \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430","filtersUp":"\u0424\u0438\u043B\u044C\u0442\u0440\u044B","finish":"\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C","finishTask":"\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443","finishToDo":"\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443 \u0438 \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0435\u0435 \u0432 \u0430\u0440\u0445\u0438\u0432","flowerCat":"\u0426\u0432\u0435\u0442\u044B","flowerCatPlural":"\u0426\u0432\u0435\u0442\u044B","flowerbed":"\u041A\u043B\u0443\u043C\u0431\u0430","flowerbedPlural":"\u041A\u043B\u0443\u043C\u0431\u044B","flowerColor":"\u0426\u0432\u0435\u0442 \u0446\u0432\u0435\u0442\u043E\u0432","flowersPhotos":"\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0446\u0432\u0435\u0442\u043E\u0432","flowerSize":"\u0420\u0430\u0437\u043C\u0435\u0440 \u0446\u0432\u0435\u0442\u043E\u0432 (\u0441\u043E\u0446\u0432\u0435\u0442\u0438\u0439)","forgotPassword":"\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C","formModifiedButNotSaved":"\u0420\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u0431\u044B\u043B\u043E \u043C\u043E\u0434\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043E, \u043D\u043E \u043D\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E.","from":"\u043E\u0442","from2":"\u0438\u0437","fruiting":"\u041F\u043B\u043E\u0434\u043E\u043D\u043E\u0448\u0435\u043D\u0438\u0435","fruitingTime":"\u0412\u0440\u0435\u043C\u044F \u043F\u043B\u043E\u0434\u043E\u043D\u043E\u0448\u0435\u043D\u0438\u044F","fruitMass":"\u041C\u0430\u0441\u0441\u0430 \u043F\u043B\u043E\u0434\u043E\u0432","fruitsPhotos":"\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043F\u043B\u043E\u0434\u043E\u0432","furniture":"\u041C\u0435\u0431\u0435\u043B\u044C","furniturePlural":"\u041C\u0435\u0431\u0435\u043B\u044C","g":"\u0433","cards":"\u041A\u0430\u0440\u0442\u043E\u0447\u043A\u0438","gallery":"\u0413\u0430\u043B\u0435\u0440\u0435\u044F","garden":"\u0421\u0430\u0434","gardenPlan":"\u041F\u043B\u0430\u043D \u0441\u0430\u0434\u0430","gardenPlanVariantsHint":"\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u043F\u043B\u0430\u043D\u0430 \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0442 \u0434\u043E\u0431\u0430\u0432\u043B\u044F\u0442\u044C \u0437\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435, \u043D\u043E \u0435\u0449\u0451 \u043D\u0435 \u043F\u043E\u0441\u0430\u0436\u0435\u043D\u043D\u044B\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0438 \u0441\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u0442\u044C \u0440\u0430\u0437\u043D\u044B\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u043F\u043E\u0441\u0430\u0434\u043E\u043A. \u041E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0434\u0438\u043D \u0432\u0430\u0440\u0438\u0430\u043D\u0442. \u0412\u0430\u0440\u0438\u0430\u043D\u0442 \u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443, \u0438 \u0442\u043E\u0433\u0434\u0430 \u043E\u043D \u0441\u0442\u0430\u043D\u0435\u0442 \u0435\u0433\u043E \u0447\u0430\u0441\u0442\u044C\u044E.","gardeningWork":"\u0421\u0430\u0434\u043E\u0432\u043E-\u043E\u0433\u043E\u0440\u043E\u0434\u043D\u044B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B","gardenPlural":"\u0421\u0430\u0434\u044B","gardenJournal":"\u0421\u0430\u0434\u043E\u0432\u044B\u0439 \u0434\u043D\u0435\u0432\u043D\u0438\u043A","gardenJournalDescription":"\u0421\u043E\u0445\u0440\u0430\u043D\u044F\u0439\u0442\u0435 \u0437\u0430\u043F\u0438\u0441\u0438 \u043E \u043F\u043E\u0441\u0430\u0436\u0435\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F\u0445 \u0438 \u043E\u0441\u043E\u0431\u0435\u043D\u043D\u043E\u0441\u0442\u044F\u0445 \u0443\u0445\u043E\u0434\u0430 \u0437\u0430 \u043D\u0438\u043C\u0438 \u043D\u0430 \u043F\u0440\u043E\u0442\u044F\u0436\u0435\u043D\u0438\u0438 \u043C\u043D\u043E\u0433\u0438\u0445 \u043B\u0435\u0442","greenhouse":"\u0422\u0435\u043F\u043B\u0438\u0446\u0430","growing-conditions":"\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u043F\u0440\u043E\u0438\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044F","growthRate":"\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C \u0440\u043E\u0441\u0442\u0430","hedge":"\u0416\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C","hedgePlural":"\u0416\u0438\u0432\u044B\u0435 \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u0438","height":"\u0412\u044B\u0441\u043E\u0442\u0430","hideElementOnSitePlan":"\u0421\u043F\u0440\u044F\u0442\u0430\u0442\u044C \u044D\u043B\u0435\u043C\u0435\u043D\u0442 \u043D\u0430 \u043F\u043B\u0430\u043D\u0435 \u0443\u0447\u0430\u0441\u0442\u043A\u0430","hideGardenPlanVariantPlants":"\u0421\u043A\u0440\u044B\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0438\u0437 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432 \u043F\u043B\u0430\u043D\u0430","hidePlantOnSitePlan":"\u0421\u043F\u0440\u044F\u0442\u0430\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u043D\u0430 \u043F\u043B\u0430\u043D\u0435 \u0443\u0447\u0430\u0441\u0442\u043A\u0430","home":"\u0414\u043E\u043C\u0430\u0448\u043D\u044F\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430","ifYouDontHaveAccount":"\u0415\u0441\u043B\u0438 \u0443 \u0432\u0430\u0441 \u043D\u0435\u0442 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 ","ifYouHaveAccount":"\u0415\u0441\u043B\u0438 \u0443 \u0432\u0430\u0441 \u0443\u0436\u0435 \u0435\u0441\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442 ","importance":"\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442","informationAboutWhichPlantsBelongedToThisCollectionWillAlsoBeRemoved":"\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0442\u043E\u043C, \u043A\u0430\u043A\u0438\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u043E\u0442\u043D\u043E\u0441\u0438\u043B\u0438\u0441\u044C \u043A \u044D\u0442\u043E\u0439 \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438, \u0442\u0430\u043A\u0436\u0435 \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u0430.","isRequired":"- \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F","journal":"\u0414\u043D\u0435\u0432\u043D\u0438\u043A","landingPlantHydrangea":"\u0413\u043E\u0440\u0442\u0435\u043D\u0437\u0438\u044F \u043A\u0440\u0443\u043F\u043D\u043E\u043B\u0438\u0441\u0442\u043D\u0430\u044F Madame Emile Mouillere","landingPlantBerberis":"\u0411\u0430\u0440\u0431\u0430\u0440\u0438\u0441 \u0422\u0443\u043D\u0431\u0435\u0440\u0433\u0430 Admiration","landingPlantSymphotrichum":"\u0410\u0441\u0442\u0440\u0430 \u043A\u0443\u0441\u0442\u0430\u0440\u043D\u0438\u043A\u043E\u0432\u0430\u044F","landingPlantCrocus":"\u041A\u0440\u043E\u043A\u0443\u0441","landingPlantDasiphora":"\u041B\u0430\u043F\u0447\u0430\u0442\u043A\u0430 \u043A\u0443\u0441\u0442\u0430\u0440\u043D\u0438\u043A\u043E\u0432\u0430\u044F Pink Beauty","landingPlantAnemone":"\u0410\u043D\u0435\u043C\u043E\u043D\u0430 \u0433\u0438\u0431\u0440\u0438\u0434\u043D\u0430\u044F Serenade","landingPlantSedum":"\u041E\u0447\u0438\u0442\u043D\u0438\u043A \u0432\u0438\u0434\u043D\u044B\u0439","lastWeek":"\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F \u043D\u0435\u0434\u0435\u043B\u044F","lastMonth":"\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u043C\u0435\u0441\u044F\u0446","last90days":"\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 90 \u0434\u043D\u0435\u0439","lastYear":"\u041F\u0441\u043E\u043B\u0435\u0434\u043D\u0438\u0439 \u0433\u043E\u0434","lawn":"\u0413\u0430\u0437\u043E\u043D","lawnPlural":"\u0413\u0430\u0437\u043E\u043D\u044B","leafColor":"\u0426\u0432\u0435\u0442 \u043B\u0438\u0441\u0442\u044C\u0435\u0432","leafPhotos":"\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043B\u0438\u0441\u0442\u044C\u0435\u0432","length":"\u0414\u043B\u0438\u043D\u0430","lifeCycle":"\u0416\u0438\u0437\u043D\u0435\u043D\u043D\u044B\u0439 \u0446\u0438\u043A\u043B","lighting":"\u041E\u0441\u0432\u0435\u0449\u0435\u043D\u0438\u0435","lightingPlural":"\u041E\u0441\u0432\u0435\u0449\u0435\u043D\u0438\u0435","location":"\u0420\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435","locationPlant":"\u0420\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0435","locationReference":"\u0420\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 - \u043F\u0440\u0438\u0432\u044F\u0437\u043A\u0430 \u043A \u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u0430\u043C","locationReferenceInfo":"\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0434\u043B\u044F \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043A\u0430\u0440\u0442\u044B \u043C\u0435\u0441\u0442\u043D\u043E\u0441\u0442\u0438 \u0432 \u043F\u0440\u043E\u0435\u043A\u0442 \u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u043F\u043E\u0433\u043E\u0434\u044B \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0443\u0447\u0430\u0441\u0442\u043A\u0435.","logIn":"\u0412\u043E\u0439\u0442\u0438","logInWithGoogle":"\u0417\u0430\u0439\u0442\u0438 \u0441 Google","logOut":"\u0412\u044B\u0439\u0442\u0438","low":"\u043D\u0438\u0437\u043A\u0438\u0439","m":"\u043C","mainInfo":"\u0413\u043B\u0430\u0432\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F","makeSnapshot":"\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u0441\u043D\u0438\u043C\u043E\u043A","makingSnapshotDescription":"\u0421\u043D\u0438\u043C\u043E\u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0441\u043E\u0431\u043E\u0439 \u043D\u0435\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0443\u0435\u043C\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043D\u0430 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u0443\u044E \u0434\u0430\u0442\u0443. \u041A\u043E\u043F\u0438\u044F \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043F\u0435\u0440\u0435\u0447\u0435\u043D\u044C \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043D\u044B\u0445 \u043D\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u0435 \u0443\u0447\u0430\u0441\u0442\u043A\u043E\u0432 \u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439.","mapCoordinatesWillBeReset":"\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B \u043A\u0430\u0440\u0442\u044B \u0431\u0443\u0434\u0443\u0442 \u043F\u0435\u0440\u0435\u0437\u0430\u043F\u0438\u0441\u0430\u043D\u044B","mapNotFound":"\u041A\u0430\u0440\u0442\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430. \u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u043A\u0430\u0440\u0442\u0443 \u043D\u0430 \u0448\u0430\u0433\u0435 1 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u0430.","medicalProperties":"\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430","meter":"\u043C\u0435\u0442\u0440(-\u0430,-\u043E\u0432)","metricSystem":"\u041C\u0435\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430","myCollections":"\u041C\u043E\u0438 \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438","myPhotos":"\u041C\u043E\u0438 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438","myPlants":"M\u043E\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","myPlantTimeline":"\u041C\u043E\u044F \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u044F \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","myProjects":"\u041C\u043E\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u044B","mySnapshots":"\u041C\u043E\u0438 \u0441\u043D\u0438\u043C\u043A\u0438","myToDos":"\u041C\u043E\u0438 \u0441\u043F\u0438\u0441\u043A\u0438 \u0437\u0430\u0434\u0430\u0447","name":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435","nameOfTask":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438","next":"\u0414\u0430\u043B\u0435\u0435","newCollection":"\u041D\u043E\u0432\u0430\u044F \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044F","newGardenPlan":"\u041D\u043E\u0432\u044B\u0439 \u043F\u043B\u0430\u043D","newPassword":"\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C","news":"\u041D\u043E\u0432\u043E\u0441\u0442\u0438","newTaskAdding":"\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0439 \u0437\u0430\u0434\u0430\u0447\u0438","newTaskList":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A \u0437\u0430\u0434\u0430\u0447","newTypeName":"\u041D\u043E\u0432\u044B\u0439 \u0442\u0438\u043F","no":"\u043D\u0435\u0442","noEntries":"\u043D\u0435\u0442 \u0437\u0430\u043F\u0438\u0441\u0435\u0439","noInformationAboutProjectLocation":"\u043D\u0435\u0442 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430","normal":"\u0441\u0440\u0435\u0434\u043D\u0438\u0439","noTemplatesForThisType":"\u0414\u043B\u044F \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430 \u043D\u0435\u0442 \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432","noTitle":"\u043D\u0435\u0442 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F","notPlanted":"\u043D\u0435 \u0432\u044B\u0441\u0430\u0436\u0435\u043D\u043E","nowUsingBasePlant":"\u041D\u0430 \u043E\u0441\u043D\u043E\u0432\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0438\u0437 \u0431\u0430\u0437\u044B TerraSketch","objectName":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u0430","objectParameters":"\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u043E\u0431\u044A\u0435\u043A\u0442\u0430","objectType":"\u0422\u0438\u043F \u043E\u0431\u044A\u0435\u043A\u0442\u0430","onElement":"\u043D\u0430 \u0443\u0447\u0430\u0441\u0442\u043A\u0435","onlineEditor":"\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0443\u0447\u0430\u0441\u0442\u043A\u0430 \u043E\u043D\u043B\u0430\u0439\u043D","onlineEditorDescription":"\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u043B\u0430\u043D \u0441\u0432\u043E\u0435\u0433\u043E \u0443\u0447\u0430\u0441\u0442\u043A\u0430 \u0438 \u0440\u0430\u0437\u043C\u0435\u0449\u0430\u0439\u0442\u0435 \u043D\u0430 \u043D\u0435\u043C \u043F\u043E\u0441\u0430\u0436\u0435\u043D\u043D\u044B\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","openPlantDescription":"\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","other":"\u0414\u0440\u0443\u0433\u043E\u0435","otherPlural":"\u0414\u0440\u0443\u0433\u043E\u0435","otherNames":"\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F","otherNews":"\u0414\u0440\u0443\u0433\u0438\u0435 \u043D\u043E\u0432\u043E\u0441\u0442\u0438","otherSiteElements":"\u0414\u0440\u0443\u0433\u0438\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u0443\u0447\u0430\u0441\u0442\u043A\u0430","overview":"\u041E\u0431\u0449\u0435\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435","overwriteBasePlant":"\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u0431\u0430\u0437\u043E\u0432\u043E\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","password":"\u041F\u0430\u0440\u043E\u043B\u044C","passwordMismatch":"\u041F\u0430\u0440\u043E\u043B\u0438 \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442","passwordValidation":"\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043B\u0430\u0442\u0438\u043D\u0441\u043A\u0438\u0435 \u0431\u0443\u043A\u0432\u044B (a\u2013z, A\u2013Z), \u043A\u0430\u043A \u043C\u0438\u043D\u0438\u043C\u0443\u043C \u043E\u0434\u043D\u0443 \u0446\u0438\u0444\u0440\u0443 \u0438 \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 6 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432.","pastEvents":"\u041F\u0440\u043E\u0448\u0435\u0434\u0448\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F","pathway":"\u0414\u043E\u0440\u043E\u0436\u043A\u0430","pathwayPlural":"\u0414\u043E\u0440\u043E\u0436\u043A\u0438","patio":"\u041F\u0430\u0442\u0438\u043E","pesticides":"\u041F\u0435\u0441\u0442\u0438\u0446\u0438\u0434\u044B","pesticideTreatmentFrequency":"\u0427\u0430\u0441\u0442\u043E\u0442\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0435\u0441\u0442\u0438\u0446\u0438\u0434\u0430\u043C\u0438","pests":"\u0412\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u0438","photos":"\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438","placeTheMap":"\u0420\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u0435 \u043A\u0430\u0440\u0442\u0443 \u0432 \u043E\u043A\u043D\u0435 \u0442\u0430\u043A, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0430 \u043F\u043E\u043A\u0440\u044B\u0432\u0430\u043B\u0430 \u0432\u0441\u044E \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044E, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0443\u044E \u0432\u0430\u043C \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C \u0434\u043B\u044F \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0447\u0430\u0441\u0442\u043A\u0430 (\u0441\u0430\u043C \u0443\u0447\u0430\u0441\u0442\u043E\u043A, \u043F\u0440\u0438\u043C\u044B\u043A\u0430\u044E\u0449\u0438\u0435 \u0434\u043E\u0440\u043E\u0433\u0438 \u0438 \u0442.\u0434.)","plantFromGardenPlan":"\u0420\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E \u0432 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u043C \u043F\u043B\u0430\u043D\u0435 \u0438 \u043D\u0435 \u0432\u0445\u043E\u0434\u0438\u0442 \u0432 \u0438\u0441\u0445\u043E\u0434\u043D\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442","gardenPlanTag":"\u041F\u043B\u0430\u043D","plantIsCreatedInGardenPlan":"\u0420\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u0441\u043E\u0437\u0434\u0430\u0451\u0442\u0441\u044F \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u043F\u043B\u0430\u043D\u0430 \xab{planName}\xbb","planningModeWarning":"\u0412\u044B \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F: \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0431\u0443\u0434\u0443\u0442 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B \u0432 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u043C \u043F\u043B\u0430\u043D\u0435 \u0438 \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u044B \u0432 \u0438\u0441\u0445\u043E\u0434\u043D\u044B\u0439 \u043F\u0440\u043E\u0435\u043A\u0442. \u0412\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0430\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0438\u0437 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u043E\u043A\u0430 \u0440\u0435\u0436\u0438\u043C \u0430\u043A\u0442\u0438\u0432\u0435\u043D.","plannedCompletionDate":"\u0417\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u0434\u0430\u0442\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F","plannedTasks":"\u0417\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0437\u0430\u0434\u0430\u0447\u0438","plant":"\u0420\u0430\u0441\u0442\u0435\u043D\u0438\u0435","plant-health":"\u0417\u0434\u043E\u0440\u043E\u0432\u044C\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","plantcomposition":"\u041A\u043E\u043C\u043F\u043E\u0437\u0438\u0446\u0438\u044F \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439","plantcompositionPlural":"\u041A\u043E\u043C\u043F\u043E\u0437\u0438\u0446\u0438\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439","plantDatabase":"\u0411\u0430\u0437\u0430 \u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439","plantDesignationOnTheMap":"\u041E\u0431\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043D\u0430 \u043A\u0430\u0440\u0442\u0435","plantedDate":"\u0414\u0430\u0442\u0430 \u043F\u043E\u0441\u0430\u0434\u043A\u0438","plantedIn":"\u0412\u044B\u0441\u0430\u0436\u0435\u043D\u043E \u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u0435","planted":"\u0432\u044B\u0441\u0430\u0436\u0435\u043D\u043E","plantedPlants":"\u0412\u044B\u0441\u0430\u0436\u0435\u043D\u043D\u044B\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","plantingAndReproduction":"\u041F\u043E\u0441\u0430\u0434\u043A\u0430 \u0438 \u0432\u044B\u0440\u0430\u0449\u0438\u0432\u0430\u043D\u0438\u0435","plantingDepth":"\u0413\u043B\u0443\u0431\u0438\u043D\u0430 \u043F\u043E\u0441\u0430\u0434\u043A\u0438","plantingSeedlingsInClosedGround":"\u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442","plantingSeedlingsInOpenedGround":"\u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442","plantingWork":"\u041F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u044B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B","plantModelWithoutPlantRecord":"\u041C\u043E\u0434\u0435\u043B\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439 \u0431\u0435\u0437 \u043F\u0440\u0438\u0432\u044F\u0437\u043A\u0438 \u043A \u0437\u0430\u043F\u0438\u0441\u0438","plantName":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","plantName-tooltip":"\u0412 \u0434\u0430\u043D\u043D\u043E\u043C \u043F\u043E\u043B\u0435 \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0432\u0430\u0448\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F. \u041E\u043D\u043E \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0442\u044C \u0441 \u043E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u043C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u043C \u0438\u043B\u0438 \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u0435\u0435 \u0441\u043F\u0435\u0446\u0438\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u043C, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u0435\u0449\u0435 \u043D\u0430 \u043C\u0435\u0441\u0442\u043E\u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0443 \u0432\u0430\u0441 \u043D\u0430 \u0443\u0447\u0430\u0441\u0442\u043A\u0435 \u0438\u043B\u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u043A\u0438. \u0423\u043A\u0430\u0437\u0430\u043D\u0438\u0435 \u0431\u043E\u043B\u0435\u0435 \u0441\u043F\u0435\u0446\u0438\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u043E\u0431\u043B\u0435\u0433\u0447\u0438\u0442 \u0434\u043B\u044F \u0432\u0430\u0441 \u0440\u0430\u0431\u043E\u0442\u0443 \u0441 \u044D\u0442\u0438\u043C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435\u043C \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C, \u043E\u0441\u043E\u0431\u0435\u043D\u043D\u043E \u043F\u0440\u0438 \u043D\u0430\u043B\u0438\u0447\u0438\u0438 \u043D\u0430 \u0443\u0447\u0430\u0441\u0442\u043A\u0435 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u043F\u043E\u0434\u043E\u0431\u043D\u044B\u0445 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439.","plantPageWorkWithTodo":"\u0420\u0430\u0431\u043E\u0442\u0430 \u0441 \u0437\u0430\u0434\u0430\u0447\u0430\u043C\u0438 \u0441\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","plantPhotos":"\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","plantPlant":"\u041F\u043E\u0441\u0430\u0434\u0438\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","plants":"\u0420\u0430\u0441\u0442\u0435\u043D\u0438\u044F","plantsTaskList":"\u0414\u0440\u0443\u0433\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0441 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F\u043C\u0438","plantTypeDistributionDiagram":"\u0414\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0430 \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u043E\u0432 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439","plotWillBeDeleted":"\u0443\u0447\u0430\u0441\u0442\u043E\u043A \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D","policy":"\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0438 \u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F","policyTerrasketch":"\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430\u043C\u0438 \u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u0430\u043C\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F TerraSketch","polygon":"\u041F\u043E\u043B\u0438\u0433\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439","pond":"\u041F\u0440\u0443\u0434","pool":"\u0411\u0430\u0441\u0441\u0435\u0439\u043D/\u041F\u0440\u0443\u0434","preserveMapCoordinates":"\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B \u043A\u0430\u0440\u0442\u044B","project":"\u041F\u0440\u043E\u0435\u043A\u0442","projectChangedSaveBeforeProceedingToTheNextStep":"\u041F\u0440\u043E\u0435\u043A\u0442 \u0438\u0437\u043C\u0435\u043D\u0435\u043D. \u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u043F\u0435\u0440\u0435\u0434 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u043E\u043C \u043A \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C\u0443 \u0448\u0430\u0433\u0443.","projectComposition":"\u041A\u043E\u043C\u043F\u043E\u0437\u0438\u0446\u0438\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u0430","projectCoordinates":"\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B","projectDescription":"\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430","projectIsNotSaved":"\u0412 \u043F\u0440\u043E\u0435\u043A\u0442\u0435 \u0438\u043C\u0435\u044E\u0442\u0441\u044F \u043D\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F.","projectName":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430","projectPage":"\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u0430","projectPageTour":"\u041A\u0430\u043A \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0441 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C?","projectPageTourDescriptionAll":"\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u043B\u044F\u0442\u044C \u043D\u043E\u0432\u044B\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0438 \u043E\u0442\u043C\u0435\u0447\u0430\u0442\u044C \u0438\u0445 \u043D\u0430 \u043F\u043B\u0430\u043D\u0435 \u0443\u0447\u0430\u0441\u0442\u043A\u0430.","projectPageTourDescriptionEdit":"\u041F\u0435\u0440\u0435\u0445\u043E\u0434 \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u0430. \u0412 \u044D\u0442\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u0430, \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0435 \u043D\u043E\u0432\u044B\u0445 \u0438 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0443\u0436\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u0443\u0447\u0430\u0441\u0442\u043A\u0430.","projectPageTourDescriptionAddPlant":"\u041F\u0440\u0438 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u043D\u043E\u0432\u043E\u0433\u043E \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0438\u0437 \u0431\u0430\u0437\u044B TerraSketch \u043A\u0430\u043A \u043E\u0441\u043D\u043E\u0432\u0443 \u0438\u043B\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C \u0441 \u0447\u0438\u0441\u0442\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430.","projectPageTourDescriptionCanvas":"\u041F\u043E\u0441\u0430\u0434\u0438\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435 - \u0437\u043D\u0430\u0447\u0438\u0442, \u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0435\u0433\u043E \u043D\u0430 \u043F\u043B\u0430\u043D\u0435 \u0443\u0447\u0430\u0441\u0442\u043A\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u0430. \u0427\u0442\u043E\u0431\u044B \u043F\u043E\u0441\u0430\u0434\u0438\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C \u043E \u043D\u0435\u043C \u0432 \u043F\u0440\u043E\u0435\u043A\u0442, \u0437\u0430\u0442\u0435\u043C \u0432\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C \u043D\u0430 \u0432\u043A\u043B\u0430\u0434\u043A\u0435 \'\u041D\u0435\u0432\u044B\u0441\u0430\u0436\u0435\u043D\u043D\u044B\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F\' \u0438 \u043D\u0430\u0436\u0430\u0442\u044C \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443 \'\u041F\u043E\u0441\u0430\u0434\u0438\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435\'.","projectPageTourDescriptionSnapshot":"\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0442\u0435\u043A\u0443\u0449\u0435\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u0443\u0447\u0430\u0441\u0442\u043A\u0430 \u0432 \u0432\u0438\u0434\u0435 \u0441\u043D\u0438\u043C\u043A\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u0430. \u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0434\u0435\u043B\u0430\u0442\u044C \u0441\u043D\u0438\u043C\u043E\u043A \u0445\u043E\u0442\u044F \u0431\u044B 1 \u0440\u0430\u0437 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D.","projectPageTourDescriptionReminders":"\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F 10 \u043D\u0430\u0438\u0431\u043E\u043B\u0435\u0435 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0445 \u0437\u0430\u0434\u0430\u0447, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u0434\u0430\u043D\u043D\u044B\u043C \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C. \u0420\u0430\u0431\u043E\u0442\u0430 \u0441\u043E \u0441\u043F\u0438\u0441\u043A\u043E\u043C \u0437\u0430\u0434\u0430\u0447 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435.","projects":"\u041F\u0440\u043E\u0435\u043A\u0442\u044B","projectOverview":"\u041E\u0431\u0437\u043E\u0440 \u043F\u0440\u043E\u0435\u043A\u0442\u0430","projectsOverview":"\u041E\u0431\u0437\u043E\u0440 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432","projectSketch":"\u0421\u043A\u0435\u0442\u0447 \u043F\u0440\u043E\u0435\u043A\u0442\u0430","projectSnapshot":"\u0421\u043D\u0438\u043C\u043E\u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0430","projectReminders":"\u041D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F \u043F\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0443","propagation-planting":"\u0420\u0430\u0437\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u0435 \u0438 \u043F\u043E\u0441\u0430\u0434\u043A\u0430","properties":"\u0421\u0432\u043E\u0439\u0441\u0442\u0432\u0430","purposeLocation":"\u041D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435/\u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435","putObjectOnThePlan":"\u0420\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u0435 \u043E\u0431\u044A\u0435\u043A\u0442 \u043D\u0430 \u043F\u043B\u0430\u043D\u0435","rect":"\u041F\u0440\u044F\u043C\u043E\u0443\u0433\u043E\u043B\u044C\u043D\u044B\u0439","reminders":"\u041D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F","removePlantSpecimen":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","repeatPassword":"\u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C","repeatNewPassword":"\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C","replantPlant":"\u041F\u0435\u0440\u0435\u0441\u0430\u0434\u0438\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435","reproductionMethods":"\u0421\u043F\u043E\u0441\u043E\u0431\u044B \u0440\u0430\u0437\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u044F","requiredField":"${label} \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F","resetFilters":"\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B","resetPassword":"\u0421\u0431\u0440\u043E\u0441 \u043F\u0430\u0440\u043E\u043B\u044F","ruler":"\u041B\u0438\u043D\u0435\u0439\u043A\u0430","save":"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C","saveAndContinue":"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C","saveEvent":"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0441\u043E\u0431\u044B\u0442\u0438\u0435","searchForBasePlant":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0434\u043B\u044F \u043F\u043E\u0438\u0441\u043A\u0430 \u043F\u043E \u0431\u0430\u0437\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439","searchForLocation":"\u041F\u043E\u0438\u0441\u043A \u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F","searchForNews":"\u041F\u043E\u0438\u0441\u043A \u043D\u043E\u0432\u043E\u0441\u0442\u0435\u0439","searchingPlantBase":"\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0431\u0430\u0437\u0435","seeAllProjects":"\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u044B","seeAllReminders":"\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A\u043E \u0432\u0441\u0435\u043C \u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F\u043C","select":"\u0412\u044B\u0431\u0440\u0430\u0442\u044C","selectAnElementForDeleting":"\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442 \u0434\u043B\u044F \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F","selectAnObjectForEditing":"\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442 \u0434\u043B\u044F \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F","selectPlantsFromTheMarkedCollections":"\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F \u0438\u0437 \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u0445 \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0439","selectPlantForConnection":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u0441\u0432\u044F\u0437\u0438 c ","selectPlantForConnectionNote":"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u041F\u043E\u0441\u043B\u0435 \u043D\u0430\u0436\u0430\u0442\u0438\u044F \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443 \'\u041E\u043A\' \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u0441\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0432\u0441\u0435\u0445 \u044D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440\u043E\u0432 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","selectTemplateOrDrawingTool":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0430\u0431\u043B\u043E\u043D \u0438\u043B\u0438 \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442 \u0434\u043B\u044F \u0440\u0438\u0441\u043E\u0432\u0430\u043D\u0438\u044F","selectTheTaskCompletionDate":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0437\u0430\u0434\u0430\u0447\u0438","sendEmailToResetPassword":"\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0438\u0441\u044C\u043C\u043E \u0434\u043B\u044F \u0441\u0431\u0440\u043E\u0441\u0430 \u043F\u0430\u0440\u043E\u043B\u044F","separatelyGrowing":"\u041E\u0442\u0434\u0435\u043B\u044C\u043D\u043E \u0440\u0430\u0441\u0442\u0443\u0449\u0438\u0435","showGridWithSpacing":"\u041E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u0435\u0442\u043A\u0443 \u0441 \u0448\u0430\u0433\u043E\u043C ","showMap":"\u041E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u043A\u0430\u0440\u0442\u0443","showElementOnSitePlan":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u044D\u043B\u0435\u043C\u0435\u043D\u0442 \u043D\u0430 \u043F\u043B\u0430\u043D\u0435 \u0443\u0447\u0430\u0441\u0442\u043A\u0430","showPlantOnSitePlan":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u043D\u0430 \u043F\u043B\u0430\u043D\u0435 \u0443\u0447\u0430\u0441\u0442\u043A\u0430","side":"\u0421\u0442\u043E\u0440\u043E\u043D\u0430","signUp":"\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F","signUpWithGoogle":"\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F c Google","size-appearance":"\u0420\u0430\u0437\u043C\u0435\u0440 \u0438 \u0432\u043D\u0435\u0448\u043D\u0438\u0439 \u0432\u0438\u0434","sloganElevate":"\u041D\u043E\u0432\u044B\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C \u0441\u0430\u0434\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u0430","snapshot":"\u0421\u043D\u0438\u043C\u043E\u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0430","snapshots":"\u0421\u043D\u0438\u043C\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432","soil":"\u041F\u043E\u0447\u0432\u0430 (\u0441\u0443\u0431\u0441\u0442\u0440\u0430\u0442)","solitarius":"\u0421\u043E\u043B\u0438\u0442\u0435\u0440","sortBy":"\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E","sorting":"\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430","sortingBy":"\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E","sortingDirectionAsc":"\u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E","sortingDirectionDesc":"\u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E","specification":"\u0423\u0442\u043E\u0447\u043D\u044F\u044E\u0449\u0430\u044F \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0430","spreading":"\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C","stairs":"\u041B\u0435\u0441\u0442\u043D\u0438\u0446\u0430","stairsPlural":"\u041B\u0435\u0441\u0442\u043D\u0438\u0446\u044B","startDate":"\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430","startToday":"\u041D\u0430\u0447\u0430\u0442\u044C \u0441\u0435\u0433\u043E\u0434\u043D\u044F","step":"\u0428\u0430\u0433","structure":"\u0411\u0435\u0441\u0435\u0434\u043A\u0430/\u043F\u0430\u0432\u0438\u043B\u044C\u043E\u043D","structurePlural":"\u0411\u0435\u0441\u0435\u0434\u043A\u0438/\u043F\u0430\u0432\u0438\u043B\u044C\u043E\u043D\u044B","subSloganElevate":"\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u0434\u043B\u044F \u0441\u0435\u0431\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0443 TerraSketch, \u0442\u0440\u0430\u043D\u0441\u0444\u043E\u0440\u043C\u0438\u0440\u0443\u044E\u0449\u0443\u044E \u043F\u043E\u0434\u0445\u043E\u0434 \u043A \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044E \u0438 \u0443\u0445\u043E\u0434\u0443 \u0437\u0430 \u0443\u0447\u0430\u0441\u0442\u043A\u043E\u043C. \u041D\u0430\u0448\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u043D\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u043C\u043E\u0436\u0435\u0442 \u0432\u0438\u0437\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0430\u0448 \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0430\u0434, \u043D\u043E \u0438 \u0431\u0443\u0434\u0435\u0442 \u0441\u043E\u043F\u0440\u043E\u0432\u043E\u0436\u0434\u0430\u0442\u044C \u0432\u0430\u0441 \u043D\u0430 \u043A\u0430\u0436\u0434\u043E\u043C \u044D\u0442\u0430\u043F\u0435 \u0435\u0433\u043E \u0440\u043E\u0441\u0442\u0430. \u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043F\u0443\u0442\u044C \u0441 TerraSketch \u0443\u0436\u0435 \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0438 \u043D\u0430\u0431\u043B\u044E\u0434\u0430\u0439\u0442\u0435, \u043A\u0430\u043A \u0432\u0430\u0448 \u0441\u0430\u0434 \u0440\u0430\u0441\u0446\u0432\u0435\u0442\u0430\u0435\u0442.","table":"\u0422\u0430\u0431\u043B\u0438\u0446\u0430","tag-news":"\u043D\u043E\u0432\u043E\u0441\u0442\u0438","tag-tutorials":"\u043F\u043E\u043B\u0435\u0437\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B","taskAndEventFilters":"\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0437\u0430\u0434\u0430\u0447 \u0438 \u0441\u043E\u0431\u044B\u0442\u0438\u0439","taskDeleting":"\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438","taskDescription":"\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438","taskEditing":"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438","taskFinishing":"\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438","taskPlanner":"\u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0449\u0438\u043A \u0437\u0430\u0434\u0430\u0447","taskPlannerDescription":"\u0421\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0439\u0442\u0435 \u0441\u043F\u0438\u0441\u043A\u0438 \u0437\u0430\u0434\u0430\u0447 \u043F\u043E \u0443\u0447\u0430\u0441\u0442\u043A\u0443, \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u0442\u0435 \u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0438\u043D\u0433 \u0440\u043E\u0441\u0442\u0430 \u0438 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439","taskType":" \u0422\u0438\u043F \u0437\u0430\u0434\u0430\u0447\u0438","taskTypes":" \u0422\u0438\u043F\u044B \u0437\u0430\u0434\u0430\u0447\u0438","taxonomy":"\u0422\u0430\u043A\u0441\u043E\u043D\u043E\u043C\u0438\u044F","terrace":"\u0422\u0435\u0440\u0440\u0430\u0441\u0430","terracePlural":"\u0422\u0435\u0440\u0440\u0430\u0441\u044B","terraSketchEditor":"\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0443\u0447\u0430\u0441\u0442\u043A\u0430 TerraSketch","terraSketchEditorDescription1":"\u0412\u0438\u0437\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0443\u0439\u0442\u0435 \u043E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u0437\u043E\u043D\u044B \u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u044B \u043D\u0430 \u043F\u043B\u0430\u043D\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u0443\u0447\u0430\u0441\u0442\u043A\u0430","terraSketchEditorDescription2":"\u041E\u0442\u043C\u0435\u0447\u0430\u0439\u0442\u0435 \u0438 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0438\u0437\u0438\u0440\u0443\u0439\u0442\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0432\u044B \u043F\u043E\u0441\u0430\u0434\u0438\u043B\u0438 \u043D\u0430 \u0443\u0447\u0430\u0441\u0442\u043A\u0435","terraSketchEditorDescription3":"\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0438\u0441\u0442\u043E\u0440\u0438\u044E \u0432\u0430\u0448\u0438\u0445 \u043F\u043E\u0441\u0430\u0434\u043E\u043A \u0434\u043B\u044F \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0441\u0435\u0432\u043E\u043E\u0431\u043E\u0440\u043E\u0442\u0430","terraSketchEditorDescription4":"\u041E\u0446\u0435\u043D\u0438\u0432\u0430\u0439\u0442\u0435 \u043E\u0431\u044A\u0435\u043C \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u044B\u0445 \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0445 \u0434\u043B\u044F \u0432\u0430\u0448\u0438\u0445 \u0441\u0430\u0434\u043E\u0432\u044B\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432","terraSketchEditorDescription5":"\u0424\u0438\u043A\u0441\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u0443\u0447\u0430\u0441\u0442\u043A\u0430 \u043D\u0430 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u0435 \u0434\u0430\u0442\u044B, \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0440\u0443\u044F \u0440\u043E\u0441\u0442 \u0438 \u0442\u0440\u0430\u043D\u0441\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0441\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0435\u043C","terraSketchTaskPlanner":"\u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0449\u0438\u043A \u0437\u0430\u0434\u0430\u0447 TerraSketch","terraSketchTaskPlannerDescription1":"\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u0435 \u0441\u043F\u0438\u0441\u043A\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u0441\u0430\u0434\u043E\u0432\u043E\u0433\u043E \u0443\u0447\u0430\u0441\u0442\u043A\u0430, \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u043E \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u043C \u043F\u043E\u0442\u0440\u0435\u0431\u043D\u043E\u0441\u0442\u044F\u043C \u0432\u0430\u0448\u0435\u0433\u043E \u0441\u0430\u0434\u0430","terraSketchTaskPlannerDescription2":"\u0412\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043B\u0435\u0434\u0438\u0442\u0435 \u0437\u0430 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u043C \u0438 \u0437\u0434\u043E\u0440\u043E\u0432\u044C\u0435\u043C \u0432\u0430\u0448\u0438\u0445 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439","terraSketchTaskPlannerDescription3":"\u0417\u0430\u043F\u0438\u0441\u044B\u0432\u0430\u0439\u0442\u0435 \u044D\u0442\u0430\u043F\u044B \u0440\u043E\u0441\u0442\u0430 \u0438 \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u044F \u0432\u0430\u0448\u0438\u0445 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439 \u043D\u0430 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0445 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0445 \u0448\u043A\u0430\u043B\u0430\u0445","terraSketchTaskPlannerDescription4":"\u0410\u043D\u0430\u043B\u0438\u0437\u0438\u0440\u0443\u0439\u0442\u0435 \u0438\u0441\u0442\u043E\u0440\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u0443\u0447\u0430\u0441\u0442\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0436\u0443\u0440\u043D\u0430\u043B\u0430 \u0441\u0430\u0434\u043E\u0432\u043E\u0434\u0430","terraSketchPlantDatabase":"\u0411\u0430\u0437\u0430 \u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439 TerraSketch","terraSketchPlantDatabaseDescription":"\u0421\u0435\u0440\u0434\u0446\u0435 TerraSketch \u2014 \u043D\u0430\u0448\u0430 \u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u043E \u0440\u0430\u0441\u0448\u0438\u0440\u044F\u044E\u0449\u0430\u044F\u0441\u044F \u0431\u0430\u0437\u0430 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439, \u0433\u0434\u0435 \u0431\u043E\u043B\u0435\u0435 1000 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u0443\u0436\u0435 \u0436\u0434\u0443\u0442, \u0447\u0442\u043E\u0431\u044B \u0432\u0434\u043E\u0445\u043D\u043E\u0432\u0438\u0442\u044C \u0438 \u043D\u0430\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0432\u0430\u0448\u0435 \u0441\u0430\u0434\u043E\u0432\u043E\u0434\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u0443\u0442\u0435\u0448\u0435\u0441\u0442\u0432\u0438\u0435. \u041A\u0430\u0436\u0434\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C, \u0441 \u043B\u044E\u0431\u043E\u0432\u044C\u044E \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u0430\u044F \u043D\u0430\u0448\u0438\u043C\u0438 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430\u043C\u0438, \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438, \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u044B\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u0438 \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u043F\u043E \u0443\u0445\u043E\u0434\u0443. \u0412\u044B\u0440\u0430\u0441\u0442\u0438\u0442\u0435 \u0434\u043B\u044F \u0441\u0435\u0431\u044F \u0441\u0430\u0434 \u043C\u0435\u0447\u0442\u044B \u0432\u043C\u0435\u0441\u0442\u0435 \u0441 TerraSketch, \u0433\u0434\u0435 \u043A\u0430\u0436\u0434\u043E\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u0432\u0434\u043E\u0445\u043D\u043E\u0432\u043B\u044F\u0435\u0442 \u0438 \u0440\u0430\u0441\u0441\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442 \u0441\u0432\u043E\u044E \u0438\u0441\u0442\u043E\u0440\u0438\u044E.","thePlantIsInTheProject":"\u0420\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u0435","thePlantWasRemovedByTheUser":"\u0420\u0430\u0441\u0442\u0435\u043D\u0438\u0435 \u0431\u044B\u043B\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C","theLatestPostsAndGuides":"\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u043D\u043E\u0432\u043E\u0441\u0442\u0438 \u0438 \u043F\u043E\u043B\u0435\u0437\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B. \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0430\u0442\u044C\u044E, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442.","thisIsTheOnlyPlantedSpecimenOfThisPlant":"\u042D\u0442\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0432\u044B\u0441\u0430\u0436\u0435\u043D\u043D\u044B\u0439 \u044D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F.","thisOperationIsIrreversible":"\u042D\u0442\u0430 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043D\u0435\u043E\u0431\u0440\u0430\u0442\u0438\u043C\u0430.","tile":"\u041F\u043B\u0438\u0442\u043A\u0430","tilePlural":"\u041F\u043B\u0438\u0442\u043A\u0430","timeForPlantingSeedlingsInClosedGround":"\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0438 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442","timeForPlantingSeedlingsInOpenedGround":"\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0438 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442","today":"\u0421\u0435\u0433\u043E\u0434\u043D\u044F","todoGroup-overdue":"\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u043E","todoGroup-today":"\u0421\u0435\u0433\u043E\u0434\u043D\u044F","todoGroup-tomorrow":"\u0417\u0430\u0432\u0442\u0440\u0430","todoGroup-laterThisWeek":"\u041D\u0430 \u044D\u0442\u043E\u0439 \u043D\u0435\u0434\u0435\u043B\u0435","todoGroup-laterThisMonth":"\u0412 \u044D\u0442\u043E\u043C \u043C\u0435\u0441\u044F\u0446\u0435","todoGroup-nextMonth":"\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u043C\u0435\u0441\u044F\u0446\u0435","todoGroup-later":"\u041F\u043E\u0437\u0434\u043D\u0435\u0435","todoGroup-noDate":"\u0411\u0435\u0437 \u0434\u0430\u0442\u044B","toDisplayWeather":"\u0414\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043F\u043E\u0433\u043E\u0434\u044B \u0438 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0439 \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445","todoLists":"\u0421\u043F\u0438\u0441\u043A\u0438 \u0437\u0430\u0434\u0430\u0447","todoPage":"\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0437\u0430\u0434\u0430\u0447","todoPageTour":"\u041A\u0430\u043A \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0441 \u0437\u0430\u0434\u0430\u0447\u0430\u043C\u0438?","todoPageTourDescriptionAll":"\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0437\u0430\u0434\u0430\u0447 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C, \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438 \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0438, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0441 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F\u043C\u0438 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u0440\u0430\u0431\u043E\u0442\u0430\u043C\u0438.","todoPageTourDescriptionAdd":"\u041F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u043D\u043E\u0432\u043E\u0439 \u0437\u0430\u0434\u0430\u0447\u0438 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043E\u0434\u0438\u043D \u0438\u0437 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0445 \u0442\u0438\u043F\u043E\u0432 (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u043E\u0431\u0440\u0435\u0437\u043A\u0430) \u0438\u043B\u0438 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0432\u043E\u0439. \u0422\u0438\u043F\u044B \u043F\u043E\u043C\u043E\u0433\u0430\u044E\u0442 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C \u0436\u0438\u0437\u043D\u0435\u043D\u043D\u044B\u0439 \u0446\u0438\u043A\u043B \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0440\u0430\u0437\u043D\u044B\u0435 \u0437\u0430\u0434\u0430\u0447\u0438 \u043F\u043E \u0441\u0430\u0434\u0443. \u0422\u0430\u043A\u0436\u0435 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0432\u044F\u0437\u0430\u0442\u044C \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0435\u043C\u0443\u044E \u0437\u0430\u0434\u0430\u0447\u0443 \u0441 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u043C\u0438 \u0432\u0430\u043C\u0438 \u0440\u0430\u043D\u0435\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F\u043C\u0438, \u0437\u0430\u0434\u0430\u0442\u044C \u0436\u0435\u043B\u0430\u0435\u043C\u044B\u0435 \u0441\u0440\u043E\u043A\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0438 \u043F\u0435\u0440\u0432\u043E\u043E\u0447\u0435\u0440\u0435\u0434\u043D\u043E\u0441\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0438.","todoPageTourDescriptionList":"\u0412\u0441\u0435 \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0435 \u0440\u0430\u043D\u0435\u0435 \u0437\u0430\u0434\u0430\u0447\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0432 \u0432\u0438\u0434\u0435 \u043A\u0430\u0440\u0442\u043E\u0447\u0435\u043A.","todoPageTourDescriptionFilter":"\u0418\u0441\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0444\u0438\u043B\u044C\u0442\u0440 \u0438 \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0443 \u0434\u043B\u044F \u043F\u043E\u0432\u044B\u0448\u0435\u043D\u0438\u044F \u044D\u0444\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0441\u0432\u043E\u0435\u0439 \u0440\u0430\u0431\u043E\u0442\u044B. \u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0438, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0441 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u043C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 \u0437\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435 \u0432\u044B\u0445\u043E\u0434\u043D\u044B\u0435.","todoPageTourDescriptionEdit":"\u0414\u043B\u044F \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0438 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0431\u043E\u043B\u0435\u0435 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u0437\u0430\u0434\u0430\u0447\u0435 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0437\u043D\u0430\u0447\u043E\u043A \u043A\u0430\u0440\u0430\u043D\u0434\u0430\u0448\u0430 \u043D\u0430 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0435 \u0437\u0430\u0434\u0430\u0447\u0438.","todoPageTourDescriptionEndTask1":"\u0427\u0442\u043E\u0431\u044B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0437\u043D\u0430\u0447\u043E\u043A \u043F\u0442\u0438\u0447\u043A\u0438. \u041F\u0440\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0443\u043A\u0430\u0436\u0438\u0442\u0435 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0443\u044E \u0434\u0430\u0442\u0443 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438, \u043F\u0440\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438, \u0438\u0441\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0442\u0438\u043F \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u043E\u0439 \u0437\u0430\u0434\u0430\u0447\u0438. ","todoPageTourDescriptionEndTask2":"\u041F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0437\u0430\u0434\u0430\u0447\u0430 \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u0431\u044B\u0442\u0438\u0435, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u043E \u0432 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u0443\u044E \u0432\u0430\u043C\u0438 \u0434\u0430\u0442\u0443. \u0415\u0441\u043B\u0438 \u0437\u0430\u0434\u0430\u0447\u0430 \u0431\u044B\u043B\u0430 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u0430 \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043A \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u043C \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F\u043C, \u0442\u043E \u043F\u0440\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0437\u0430\u0434\u0430\u0447\u0438 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0435\u0442 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0438\u0437 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439. ","todoPageTourDescriptionEndTask3":"\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0441\u0435\u0433\u0434\u0430 \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u0434\u0430\u0447 (\u0441\u043E\u0431\u044B\u0442\u0438\u0439) \u0432 \u0414\u043D\u0435\u0432\u043D\u0438\u043A\u0435 \u0438\u043B\u0438 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0433\u043E \u0441 \u0437\u0430\u0434\u0430\u0447\u0435\u0439 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F.","todoPageTourDescriptionDeleteTask":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0437\u0430\u0434\u0430\u0447\u0443 \u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0436\u0430\u0432 \u043D\u0430 \u0437\u043D\u0430\u0447\u043E\u043A \u043A\u043E\u0440\u0437\u0438\u043D\u044B. \u041F\u0440\u0438 \u044D\u0442\u043E\u043C \u0437\u0430\u0434\u0430\u0447\u0430 \u043D\u0435 \u043F\u043E\u043F\u0430\u0434\u0435\u0442 \u0432 \u0434\u043D\u0435\u0432\u043D\u0438\u043A, \u0430 \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u0430 \u0431\u0435\u0437 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.","todoPageTourDescriptionPlantPage":"\u0420\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0441 \u0437\u0430\u0434\u0430\u0447\u0430\u043C\u0438 \u043C\u043E\u0436\u043D\u043E \u0442\u0430\u043A\u0436\u0435 \u0441\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u0432\u0430\u043C\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439. \u0412\u0441\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445, \u043E\u0442\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0438\u043B\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0445 \u0442\u0430\u043A\u0438\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C \u0437\u0430\u0434\u0430\u0447\u0430\u0445 \u0431\u0443\u0434\u0435\u0442 \u0432\u0438\u0434\u043D\u0430 \u0442\u0430\u043A\u0436\u0435 \u0438 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u041C\u043E\u0438 \u0441\u043F\u0438\u0441\u043A\u0438 \u0437\u0430\u0434\u0430\u0447.","totalPlantsInTheProject":"\u0412\u0441\u0435\u0433\u043E \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439 \u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u0435","toxicity":"\u042F\u0434\u043E\u0432\u0438\u0442\u043E\u0441\u0442\u044C","tree":"\u0414\u0435\u0440\u0435\u0432\u043E","treeCat":"\u0414\u0435\u0440\u0435\u0432\u044C\u044F","treeCatPlural":"\u0414\u0435\u0440\u0435\u0432\u044C\u044F","trimTime":"\u0412\u0440\u0435\u043C\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0438","thisOperationWillMoveTask":"\u042D\u0442\u0430 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442 \u0437\u0430\u0434\u0430\u0447\u0443 \u0432 \u0434\u043D\u0435\u0432\u043D\u0438\u043A.","thisMonth":"\u042D\u0442\u043E\u0442 \u043C\u0435\u0441\u044F\u0446","thisWeek":"\u042D\u0442\u0430 \u043D\u0435\u0434\u0435\u043B\u044F","type":"\u0422\u0438\u043F","typeOfTheCorrespondingTasksAndEventsWillBeChangedToGeneral":"\u0422\u0438\u043F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0443\u044E\u0449\u0438\u0445 \u0437\u0430\u0434\u0430\u0447 \u0438 \u0441\u043E\u0431\u044B\u0442\u0438\u0439 \u0431\u0443\u0434\u0435\u0442 \u0438\u0437\u043C\u0435\u043D\u0435\u043D \u043D\u0430 \u041E\u0431\u0449\u0438\u0439.","unplantedPlants":"\u041D\u0435\u0432\u044B\u0441\u0430\u0436\u0435\u043D\u043D\u044B\u0435 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","uploadPhotos":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438","uploadPlantPhotos":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u044F","urgent":"\u0441\u0440\u043E\u0447\u043D\u044B\u0439","usage":"\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435","uSDA":"USDA-\u0437\u043E\u043D\u044B","usefulMaterials":"\u041F\u043E\u043B\u0435\u0437\u043D\u044B\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B","useMapForProjectCreating":"\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043A\u0430\u0440\u0442\u0443 \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430","useMyCurrentLocation":"\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043C\u043E\u0435 \u0442\u0435\u043A\u0443\u0449\u0435\u0435 \u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435","usePlotDrawingTool":"\u0412\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435\u0441\u044C \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u043E\u043C \u0434\u043B\u044F \u0440\u0438\u0441\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0447\u0430\u0441\u0442\u043A\u0430","userAccount":"\u041A\u0430\u0431\u0438\u043D\u0435\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F","userEmail":"Email \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F","userInfo":"\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F","userName":"\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F","userSettings":"\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F","variety":"\u0421\u043E\u0440\u0442","varietyEng":"\u0421\u043E\u0440\u0442","varietyRu":"\u0421\u043E\u0440\u0442 (\u0440\u0443\u0441.)","vegetableCat":"\u041E\u0432\u043E\u0449\u0438","vegetableCatPlural":"\u041E\u0432\u043E\u0449\u0438","vegetablegarden":"\u0413\u0440\u044F\u0434\u043A\u0430","vegetablegardenPlural":"\u0413\u0440\u044F\u0434\u043A\u0438","water":"\u0412\u043E\u0434\u0430 - \u0434\u0440\u0443\u0433\u0438\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B","waterPlural":"\u0412\u043E\u0434\u0430","watering":"\u041F\u043E\u043B\u0438\u0432","width":"\u0428\u0438\u0440\u0438\u043D\u0430","yes":"\u0434\u0430","yourActionsCannotBeUndone":"\u0414\u0430\u043D\u043D\u043E\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E","metricSystemTooltip":"\u041C\u0435\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442 \u0435\u0434\u0438\u043D\u0438\u0446\u044B, \u0432 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0431\u0443\u0434\u0443\u0442 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u0438\u0437\u043C\u0435\u0440\u044F\u0435\u043C\u044B\u0435 \u0432\u0435\u043B\u0438\u0447\u0438\u043D\u044B","userNameTooltip":"\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u043D\u0443\u0442\u0440\u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430","commonName":"\u041E\u0431\u0449\u0435\u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435","scienceName":"\u041D\u0430\u0443\u0447\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435","element":"\u0423\u0447\u0430\u0441\u0442\u043E\u043A","heightFrom":"\u0412\u044B\u0441\u043E\u0442\u0430 \u043E\u0442 (\u043C)","heightTo":"\u0412\u044B\u0441\u043E\u0442\u0430 \u0434\u043E (\u043C)","height-rangeField":"\u0412\u044B\u0441\u043E\u0442\u0430 (\u043C)","spreadingFrom":"\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u043E\u0442 (\u043C)","spreadingTo":"\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u0434\u043E (\u043C)","spreading-rangeField":"\u0420\u0430\u0441\u043A\u0438\u0434\u0438\u0441\u0442\u043E\u0441\u0442\u044C (\u043C)","flowerSize-rangeField":"\u0420\u0430\u0437\u043C\u0435\u0440 \u0446\u0432\u0435\u0442\u043E\u0432/\u0441\u043E\u0446\u0432\u0435\u0442\u0438\u0439 (\u0441\u043C)","attractionFactors":"\u0424\u0430\u043A\u0442\u043E\u0440\u044B \u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438","bloomingTime":"\u0412\u0440\u0435\u043C\u044F \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u044F","eventType-":" ","eventType-planting":"\u043F\u043E\u0441\u0430\u0434\u043A\u0430","eventType-repotting":"\u043F\u0435\u0440\u0435\u0441\u0430\u0434\u043A\u0430","eventType-propagation":"\u0440\u0430\u0437\u043C\u043D\u043E\u0436\u0435\u043D\u0438\u0435","eventType-seedsowing":"\u043F\u043E\u0441\u0435\u0432 \u0441\u0435\u043C\u044F\u043D","eventType-seedlingsemerge":"\u043F\u043E\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0432\u0441\u0445\u043E\u0434\u043E\u0432","eventType-trueleaves":"\u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0435 \u043B\u0438\u0441\u0442\u044C\u044F","eventType-prickingout":"\u043F\u0438\u043A\u0438\u0440\u043E\u0432\u043A\u0430","eventType-hardeningoff":"\u0437\u0430\u043A\u0430\u043B\u0438\u0432\u0430\u043D\u0438\u0435","eventType-transplanting":"\u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u0432 \u0433\u0440\u0443\u043D\u0442","eventType-harvesting":"\u0441\u0431\u043E\u0440 \u0443\u0440\u043E\u0436\u0430\u044F","eventType-pruning":"\u043E\u0431\u0440\u0435\u0437\u043A\u0430","eventType-weeding":"\u043F\u0440\u043E\u043F\u043E\u043B\u043A\u0430","eventType-fertilizing":"\u0443\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0435","eventType-blooming":"\u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435","eventType-watering":"\u043F\u043E\u043B\u0438\u0432","eventType-trimming":"\u0441\u0442\u0440\u0438\u0436\u043A\u0430","eventType-chemicals":"\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u0445\u0438\u043C\u0438\u043A\u0430\u0442\u0430\u043C\u0438","eventType-buying":"\u043F\u043E\u043A\u0443\u043F\u043A\u0430","eventType-general":"\u043E\u0431\u0449\u0435\u0435","eventType-preplanting":"\u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430","eventType-winter":"\u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u043A \u0437\u0438\u043C\u0435","uSDA-tooltip":"\u0417\u043E\u043D\u044B \u043C\u043E\u0440\u043E\u0437\u043E\u0441\u0442\u043E\u0439\u043A\u043E\u0441\u0442\u0438 - \u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0441\u043E \u0441\u0445\u043E\u0434\u043D\u044B\u043C\u0438 \u043A\u043B\u0438\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u043C\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438","uSDA-0":"0","uSDA-1":"1","uSDA-2":"2","uSDA-3":"3","uSDA-4":"4","uSDA-5":"5","uSDA-6":"6","uSDA-7":"7","uSDA-8":"8","uSDA-9":"9","uSDA-10":"10","uSDA-11":"11","uSDA-12":"12","\u044F\u043D\u0432\u0430\u0440\u044C":"\u044F\u043D\u0432\u0430\u0440\u044C","\u0444\u0435\u0432\u0440\u0430\u043B\u044C":"\u0444\u0435\u0432\u0440\u0430\u043B\u044C","\u043C\u0430\u0440\u0442":"\u043C\u0430\u0440\u0442","\u0430\u043F\u0440\u0435\u043B\u044C":"\u0430\u043F\u0440\u0435\u043B\u044C","\u043C\u0430\u0439":"\u043C\u0430\u0439","\u0438\u044E\u043D\u044C":"\u0438\u044E\u043D\u044C","\u0438\u044E\u043B\u044C":"\u0438\u044E\u043B\u044C","\u0430\u0432\u0433\u0443\u0441\u0442":"\u0430\u0432\u0433\u0443\u0441\u0442","\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C":"\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C","\u043E\u043A\u0442\u044F\u0431\u0440\u044C":"\u043E\u043A\u0442\u044F\u0431\u0440\u044C","\u043D\u043E\u044F\u0431\u0440\u044C":"\u043D\u043E\u044F\u0431\u0440\u044C","\u0434\u0435\u043A\u0430\u0431\u0440\u044C":"\u0434\u0435\u043A\u0430\u0431\u0440\u044C","\u043F\u043E\u0441\u043B\u0435 \u043C\u0438\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0433\u0440\u043E\u0437\u044B \u0437\u0430\u043C\u043E\u0440\u043E\u0437\u043A\u043E\u0432":"\u043F\u043E\u0441\u043B\u0435 \u043C\u0438\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0433\u0440\u043E\u0437\u044B \u0437\u0430\u043C\u043E\u0440\u043E\u0437\u043A\u043E\u0432","careDifficulty-\u043D\u0438\u0437\u043A\u0430\u044F":"\u043D\u0438\u0437\u043A\u0430\u044F","careDifficulty-\u0441\u0440\u0435\u0434\u043D\u044F\u044F":"\u0441\u0440\u0435\u0434\u043D\u044F\u044F","careDifficulty-\u0432\u044B\u0441\u043E\u043A\u0430\u044F":"\u0432\u044B\u0441\u043E\u043A\u0430\u044F","purposeLocation-\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440\u043D\u043E\u0435":"\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440\u043D\u043E\u0435","purposeLocation-\u043A\u043E\u043C\u043D\u0430\u0442\u043D\u043E\u0435":"\u043A\u043E\u043C\u043D\u0430\u0442\u043D\u043E\u0435","purposeLocation-\u0443\u043B\u0438\u0447\u043D\u043E\u0435":"\u0443\u043B\u0438\u0447\u043D\u043E\u0435","purposeLocation-\u0441\u0435\u0437\u043E\u043D\u043D\u043E\u0435":"\u0441\u0435\u0437\u043E\u043D\u043D\u043E\u0435","lifeCycle-\u043C\u043D\u043E\u0433\u043E\u043B\u0435\u0442\u043D\u0435\u0435":"\u043C\u043D\u043E\u0433\u043E\u043B\u0435\u0442\u043D\u0435\u0435","lifeCycle-\u0434\u0432\u0443\u0445\u043B\u0435\u0442\u043D\u0435\u0435":"\u0434\u0432\u0443\u0445\u043B\u0435\u0442\u043D\u0435\u0435","lifeCycle-\u043E\u0434\u043D\u043E\u043B\u0435\u0442\u043D\u0435\u0435":"\u043E\u0434\u043D\u043E\u043B\u0435\u0442\u043D\u0435\u0435","watering-\u0447\u0430\u0441\u0442\u044B\u0439":"\u0447\u0430\u0441\u0442\u044B\u0439","watering-1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E":"1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E","watering-2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E":"2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E","watering-\u0443\u043C\u0435\u0440\u0435\u043D\u043D\u044B\u0439":"\u0443\u043C\u0435\u0440\u0435\u043D\u043D\u044B\u0439","watering-\u0440\u0435\u0434\u043A\u0438\u0439":"\u0440\u0435\u0434\u043A\u0438\u0439","watering-\u043F\u043E \u043C\u0435\u0440\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438":"\u043F\u043E \u043C\u0435\u0440\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438","watering-\u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u0438\u0432\u0430":"\u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u0438\u0432\u0430","watering-\u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u043E \u0432\u043B\u0430\u0436\u043D\u0430\u044F \u043F\u043E\u0447\u0432\u0430":"\u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u043E \u0432\u043B\u0430\u0436\u043D\u0430\u044F \u043F\u043E\u0447\u0432\u0430","attitudeToLight-\u0441\u043E\u043B\u043D\u0446\u0435":"\u0441\u043E\u043B\u043D\u0446\u0435","attitudeToLight-\u043F\u043E\u043B\u0443\u0442\u0435\u043D\u044C":"\u043F\u043E\u043B\u0443\u0442\u0435\u043D\u044C","attitudeToLight-\u0442\u0435\u043D\u044C":"\u0442\u0435\u043D\u044C","attitudeToLight-\u043B\u0435\u0433\u043A\u0430\u044F \u043F\u043E\u043B\u0443\u0442\u0435\u043D\u044C":"\u043F\u043E\u043B\u0443\u0442\u0435\u043D\u044C","attitudeToLight-\u0440\u0430\u0441\u0441\u0435\u044F\u043D\u043D\u044B\u0439 \u0441\u0432\u0435\u0442":"\u0441\u0432\u0435\u0442","attitudeToLight-\u044F\u0440\u043A\u0438\u0439 \u0440\u0430\u0441\u0441\u0435\u044F\u043D\u043D\u044B\u0439 \u0441\u0432\u0435\u0442":"\u0441\u0432\u0435\u0442","edibility-\u0431\u0443\u0442\u043E\u043D\u044B":"\u0431\u0443\u0442\u043E\u043D\u044B","edibility-\u043A\u043B\u0443\u0431\u043D\u0438":"\u043A\u043B\u0443\u0431\u043D\u0438","edibility-\u043A\u043E\u0440\u043D\u0438":"\u043A\u043E\u0440\u043D\u0438","edibility-\u043B\u0438\u0441\u0442\u044C\u044F":"\u043B\u0438\u0441\u0442\u044C\u044F","edibility-\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430":"\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430","edibility-\u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430":"\u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430","edibility-\u043C\u043E\u043B\u043E\u0434\u044B\u0435 \u043F\u043E\u0431\u0435\u0433\u0438":"\u043C\u043E\u043B\u043E\u0434\u044B\u0435 \u043F\u043E\u0431\u0435\u0433\u0438","edibility-\u043E\u0432\u043E\u0449\u0438":"\u043E\u0432\u043E\u0449\u0438","edibility-\u043F\u043B\u043E\u0434\u044B":"\u043F\u043B\u043E\u0434\u044B","edibility-\u0441\u0435\u043C\u0435\u043D\u0430":"\u0441\u0435\u043C\u0435\u043D\u0430","edibility-\u0441\u043E\u0446\u0432\u0435\u0442\u0438\u044F":"\u0441\u043E\u0446\u0432\u0435\u0442\u0438\u044F","edibility-\u0444\u0440\u0443\u043A\u0442\u044B":"\u0444\u0440\u0443\u043A\u0442\u044B","edibility-\u044F\u0433\u043E\u0434\u044B":"\u044F\u0433\u043E\u0434\u044B","toxicity-\u0432\u0441\u0435 \u0447\u0430\u0441\u0442\u0438":"\u0432\u0441\u0435 \u0447\u0430\u0441\u0442\u0438","toxicity-\u043A\u043E\u0440\u0430":"\u043A\u043E\u0440\u0430","toxicity-\u043A\u043E\u0440\u043D\u0438":"\u043A\u043E\u0440\u043D\u0438","toxicity-\u043B\u0438\u0441\u0442\u044C\u044F":"\u043B\u0438\u0441\u0442\u044C\u044F","toxicity-\u043F\u043B\u043E\u0434\u044B":"\u043F\u043B\u043E\u0434\u044B","toxicity-\u0441\u043E\u043A":"\u0441\u043E\u043A","toxicity-\u0441\u0442\u0435\u0431\u0435\u043B\u044C":"\u0441\u0442\u0435\u0431\u0435\u043B\u044C","toxicity-\u0446\u0432\u0435\u0442\u044B":"\u0446\u0432\u0435\u0442\u044B","toxicity-\u044F\u0434\u043E\u0432\u0438\u0442\u043E\u0435":"\u044F\u0434\u043E\u0432\u0438\u0442\u043E\u0435","type-\u0432\u0435\u0440\u0435\u0441\u043A":"\u0432\u0435\u0440\u0435\u0441\u043A","type-\u0432\u043E\u0434\u043D\u043E\u0435":"\u0432\u043E\u0434\u043D\u043E\u0435","type-\u0432\u044C\u044E\u0449\u0438\u0435\u0441\u044F \u0438 \u043B\u0438\u0430\u043D\u044B":"\u0432\u044C\u044E\u0449\u0438\u0435\u0441\u044F \u0438 \u043B\u0438\u0430\u043D\u044B","type-\u0434\u0435\u0440\u0435\u0432\u043E":"\u0434\u0435\u0440\u0435\u0432\u043E","type-\u043A\u0430\u043A\u0442\u0443\u0441\u044B \u0438 \u0441\u0443\u043A\u043A\u0443\u043B\u0435\u043D\u0442\u044B":"\u043A\u0430\u043A\u0442\u0443\u0441\u044B \u0438 \u0441\u0443\u043A\u043A\u0443\u043B\u0435\u043D\u0442\u044B","type-\u043A\u043B\u0443\u0431\u043D\u0435\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u043E\u0435":"\u043A\u043B\u0443\u0431\u043D\u0435\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u043E\u0435","type-\u043A\u0443\u0441\u0442\u0430\u0440\u043D\u0438\u043A":"\u043A\u0443\u0441\u0442\u0430\u0440\u043D\u0438\u043A","type-\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u043E\u0435":"\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u043E\u0435","type-\u043F\u0430\u043B\u044C\u043C\u043E\u0432\u044B\u0435 \u0438 \u0441\u0430\u0433\u043E\u0432\u043D\u0438\u043A\u043E\u0432\u044B\u0435":"\u043F\u0430\u043B\u044C\u043C\u043E\u0432\u044B\u0435 \u0438 \u0441\u0430\u0433\u043E\u0432\u043D\u0438\u043A\u043E\u0432\u044B\u0435","type-\u043F\u0430\u043F\u043E\u0440\u043E\u0442\u043D\u0438\u043A":"\u043F\u0430\u043F\u043E\u0440\u043E\u0442\u043D\u0438\u043A","type-\u043F\u043B\u043E\u0442\u043E\u044F\u0434\u043D\u043E\u0435":"\u043F\u043B\u043E\u0442\u043E\u044F\u0434\u043D\u043E\u0435","type-\u043F\u043E\u043B\u0443\u043A\u0443\u0441\u0442\u0430\u0440\u043D\u0438\u043A":"\u043F\u043E\u043B\u0443\u043A\u0443\u0441\u0442\u0430\u0440\u043D\u0438\u043A","type-\u0442\u0440\u0430\u0432\u044F\u043D\u0438\u0441\u0442\u043E\u0435":"\u0442\u0440\u0430\u0432\u044F\u043D\u0438\u0441\u0442\u043E\u0435","type-\u0446\u0432\u0435\u0442\u0443\u0449\u0435\u0435":"\u0446\u0432\u0435\u0442\u0443\u0449\u0435\u0435","type-\u043D\u0435\u0431\u043E\u043B\u044C\u0448\u043E\u0435 \u0434\u0435\u0440\u0435\u0432\u043E":"\u043D\u0435\u0431\u043E\u043B\u044C\u0448\u043E\u0435 \u0434\u0435\u0440\u0435\u0432\u043E","type-\u044D\u043F\u0438\u0444\u0438\u0442":"\u044D\u043F\u0438\u0444\u0438\u0442","attractionFactors-\u0430\u043C\u043F\u0435\u043B\u044C\u043D\u043E\u0435":"\u0430\u043C\u043F\u0435\u043B\u044C\u043D\u043E\u0435","attractionFactors-\u0431\u044B\u0441\u0442\u0440\u043E\u0440\u0430\u0441\u0442\u0443\u0449\u0435\u0435":"\u0431\u044B\u0441\u0442\u0440\u043E\u0440\u0430\u0441\u0442\u0443\u0449\u0435\u0435","attractionFactors-\u0432\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u0430\u044F \u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C":"\u0432\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u0430\u044F \u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C","attractionFactors-\u0433\u0438\u0433\u0440\u043E\u0444\u0438\u0442":"\u0433\u0438\u0433\u0440\u043E\u0444\u0438\u0442","attractionFactors-\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u043A\u043E\u0440\u0430":"\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u043A\u043E\u0440\u0430","attractionFactors-\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u0444\u043E\u0440\u043C\u0430 \u043A\u0440\u043E\u043D\u044B":"\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u0444\u043E\u0440\u043C\u0430 \u043A\u0440\u043E\u043D\u044B","attractionFactors-\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u043F\u043B\u043E\u0434\u043E\u043D\u043E\u0448\u0435\u043D\u0438\u0435":"\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u043F\u043B\u043E\u0434\u043E\u043D\u043E\u0448\u0435\u043D\u0438\u0435","attractionFactors-\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435":"\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435","attractionFactors-\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u043B\u0438\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435":"\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u043B\u0438\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435","attractionFactors-\u043A\u0441\u0435\u0440\u043E\u0444\u0438\u0442":"\u043A\u0441\u0435\u0440\u043E\u0444\u0438\u0442","attractionFactors-\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E\u0440\u0430\u0441\u0442\u0443\u0449\u0435\u0435":"\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E\u0440\u0430\u0441\u0442\u0443\u0449\u0435\u0435","attractionFactors-\u043C\u043E\u0440\u043E\u0437\u043E\u0441\u0442\u043E\u0439\u043A\u043E\u0435":"\u043C\u043E\u0440\u043E\u0437\u043E\u0441\u0442\u043E\u0439\u043A\u043E\u0435","attractionFactors-\u043E\u0447\u0438\u0449\u0430\u0435\u0442 \u0432\u043E\u0437\u0434\u0443\u0445":"\u043E\u0447\u0438\u0449\u0430\u0435\u0442 \u0432\u043E\u0437\u0434\u0443\u0445","attractionFactors-\u043F\u043B\u0435\u0442\u0443\u0449\u0435\u0435\u0441\u044F":"\u043F\u043B\u0435\u0442\u0443\u0449\u0435\u0435\u0441\u044F","attractionFactors-\u043F\u043E\u0447\u0432\u043E\u043F\u043E\u043A\u0440\u043E\u0432\u043D\u043E\u0435":"\u043F\u043E\u0447\u0432\u043E\u043F\u043E\u043A\u0440\u043E\u0432\u043D\u043E\u0435","attractionFactors-\u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u044E\u0449\u0435\u0435 \u043E\u043F\u044B\u043B\u0438\u0442\u0435\u043B\u0435\u0439":"\u043F\u0440\u0438\u0432\u043B\u0435\u043A\u0430\u044E\u0449\u0435\u0435 \u043E\u043F\u044B\u043B\u0438\u0442\u0435\u043B\u0435\u0439","attractionFactors-\u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435":"\u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435","attractionFactors-\u0441\u044A\u0435\u0434\u043E\u0431\u043D\u043E\u0435":"\u0441\u044A\u0435\u0434\u043E\u0431\u043D\u043E\u0435","attractionFactors-\u0442\u0435\u043D\u0435\u0432\u044B\u043D\u043E\u0441\u043B\u0438\u0432\u043E\u0435":"\u0442\u0435\u043D\u0435\u0432\u044B\u043D\u043E\u0441\u043B\u0438\u0432\u043E\u0435","attractionFactors-\u0442\u0435\u043D\u0435\u043B\u044E\u0431\u0438\u0432\u043E\u0435":"\u0442\u0435\u043D\u0435\u043B\u044E\u0431\u0438\u0432\u043E\u0435","attractionFactors-\u0442\u043E\u043F\u0438\u0430\u0440\u043D\u044B\u0435 \u0444\u043E\u0440\u043C\u044B":"\u0444\u043E\u0440\u043C\u044B","attractionFactors-\u0445\u0432\u043E\u0439\u043D\u043E\u0435":"\u0445\u0432\u043E\u0439\u043D\u043E\u0435","attractionFactors-\u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435 \u0432 \u0440\u0430\u043D\u043D\u0435\u0432\u0435\u0441\u0435\u043D\u043D\u0438\u0439 \u043F\u0435\u0440\u0438\u043E\u0434":"\u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435 \u0432 \u0440\u0430\u043D\u043D\u0435\u0432\u0435\u0441\u0435\u043D\u043D\u0438\u0439 \u043F\u0435\u0440\u0438\u043E\u0434","attractionFactors-\u044D\u043A\u0437\u043E\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0432\u043D\u0435\u0448\u043D\u0438\u0439 \u0432\u0438\u0434":"\u044D\u043A\u0437\u043E\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0432\u043D\u0435\u0448\u043D\u0438\u0439 \u0432\u0438\u0434","featuresOfCultivation-\u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442":"\u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443 \u0432 \u0437\u0430\u043A\u0440\u044B\u0442\u044B\u0439 \u0433\u0440\u0443\u043D\u0442","featuresOfCultivation-\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0430 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0430\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443":"\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0430 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0430\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0432\u044B\u0441\u0430\u0434\u043A\u0430 \u043D\u0430 \u0440\u0430\u0441\u0441\u0430\u0434\u0443","featuresOfCultivation-\u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u043E\u0440\u0430\u0449\u0438\u0435\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0443\u0431\u043D\u0435\u0439":"\u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u043E\u0440\u0430\u0449\u0438\u0435\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0443\u0431\u043D\u0435\u0439","featuresOfCultivation-\u0441\u0442\u0440\u0430\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430":"\u0441\u0442\u0440\u0430\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430","featuresOfCultivation-\u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430":"\u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043F\u043E\u0441\u0430\u0434\u043E\u0447\u043D\u043E\u0433\u043E \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u0430","featuresOfCultivation-\u0435\u0441\u0442\u044C \u043F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u043A\u043E\u044F":"\u0435\u0441\u0442\u044C \u043F\u0435\u0440\u0438\u043E\u0434 \u043F\u043E\u043A\u043E\u044F","featuresOfCultivation-\u0432\u043E\u0437\u043C\u043E\u0436\u0435\u043D \u043F\u043E\u0441\u0435\u0432 \u0441\u0435\u043C\u044F\u043D \u0432 \u0433\u0440\u0443\u043D\u0442 \u043F\u043E\u0434 \u0437\u0438\u043C\u0443":"\u0432\u043E\u0437\u043C\u043E\u0436\u0435\u043D \u043F\u043E\u0441\u0435\u0432 \u0441\u0435\u043C\u044F\u043D \u0432 \u0433\u0440\u0443\u043D\u0442 \u043F\u043E\u0434 \u0437\u0438\u043C\u0443","featuresOfCultivation-\u0441\u043A\u0430\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0441\u0435\u043C\u044F\u043D \u043F\u0440\u0438 \u043F\u043E\u0441\u0430\u0434\u043A\u0435 \u0432\u0435\u0441\u043D\u043E\u0439":"\u0441\u043A\u0430\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0441\u0435\u043C\u044F\u043D \u043F\u0440\u0438 \u043F\u043E\u0441\u0430\u0434\u043A\u0435 \u0432\u0435\u0441\u043D\u043E\u0439","reproductionMethods-\u0431\u043E\u043A\u043E\u0432\u044B\u043C\u0438 \u043F\u043E\u0431\u0435\u0433\u0430\u043C\u0438":"\u0431\u043E\u043A\u043E\u0432\u044B\u043C\u0438 \u043F\u043E\u0431\u0435\u0433\u0430\u043C\u0438","reproductionMethods-\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u043B\u0443\u0431\u043D\u044F":"\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u043B\u0443\u0431\u043D\u044F","reproductionMethods-\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u043E\u0440\u043D\u0435\u0432\u0438\u0449\u0430":"\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u043E\u0440\u043D\u0435\u0432\u0438\u0449\u0430","reproductionMethods-\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u0443\u0441\u0442\u0430":"\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043C \u043A\u0443\u0441\u0442\u0430","reproductionMethods-\u043A\u043B\u0443\u0431\u043D\u0435\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430\u043C\u0438":"\u043A\u043B\u0443\u0431\u043D\u0435\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430\u043C\u0438","reproductionMethods-\u043A\u043B\u0443\u0431\u043D\u0435\u043F\u043E\u0447\u043A\u0430\u043C\u0438":"\u043A\u043B\u0443\u0431\u043D\u0435\u043F\u043E\u0447\u043A\u0430\u043C\u0438","reproductionMethods-\u043B\u0438\u0441\u0442\u043E\u043C":"\u043B\u0438\u0441\u0442\u043E\u043C","reproductionMethods-\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430\u043C\u0438":"\u043B\u0443\u043A\u043E\u0432\u0438\u0446\u0430\u043C\u0438","reproductionMethods-\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u044B\u043C\u0438 \u0447\u0435\u0448\u0443\u0439\u043A\u0430\u043C\u0438":"\u043B\u0443\u043A\u043E\u0432\u0438\u0447\u043D\u044B\u043C\u0438 \u0447\u0435\u0448\u0443\u0439\u043A\u0430\u043C\u0438","reproductionMethods-\u043E\u0442\u0432\u043E\u0434\u043A\u0430\u043C\u0438":"\u043E\u0442\u0432\u043E\u0434\u043A\u0430\u043C\u0438","reproductionMethods-\u043F\u0440\u0438\u0432\u0438\u0432\u043A\u043E\u0439":"\u043F\u0440\u0438\u0432\u0438\u0432\u043A\u043E\u0439","reproductionMethods-\u0441\u0435\u043C\u0435\u043D\u0430\u043C\u0438":"\u0441\u0435\u043C\u0435\u043D\u0430\u043C\u0438","reproductionMethods-\u0441\u043F\u043E\u0440\u0430\u043C\u0438":"\u0441\u043F\u043E\u0440\u0430\u043C\u0438","reproductionMethods-\u0447\u0430\u0441\u0442\u044C\u044E \u043B\u0438\u0441\u0442\u0430":"\u0447\u0430\u0441\u0442\u044C\u044E \u043B\u0438\u0441\u0442\u0430","reproductionMethods-\u0447\u0435\u0440\u0435\u043D\u043A\u043E\u0432\u0430\u043D\u0438\u0435\u043C":"\u0447\u0435\u0440\u0435\u043D\u043A\u043E\u0432\u0430\u043D\u0438\u0435\u043C","timeForPlantingSeedlingsInOpenedGround-\u043F\u043E\u0441\u043B\u0435 \u043C\u0438\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0433\u0440\u043E\u0437\u044B \u0437\u0430\u043C\u043E\u0440\u043E\u0437\u043A\u043E\u0432":"\u043F\u043E\u0441\u043B\u0435 \u043C\u0438\u043D\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0433\u0440\u043E\u0437\u044B \u0437\u0430\u043C\u043E\u0440\u043E\u0437\u043A\u043E\u0432","additionalCareSteps-\u043E\u0431\u0440\u0435\u0437\u043A\u0430 \u043D\u0430 \u0437\u0438\u043C\u0443":"\u043E\u0431\u0440\u0435\u0437\u043A\u0430 \u043D\u0430 \u0437\u0438\u043C\u0443","additionalCareSteps-\u043E\u043C\u043E\u043B\u0430\u0436\u0438\u0432\u0430\u044E\u0449\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430":"\u043E\u043C\u043E\u043B\u0430\u0436\u0438\u0432\u0430\u044E\u0449\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430","additionalCareSteps-\u043F\u043E\u043B\u043B\u0430\u0440\u0434\u0438\u043D\u0433":"\u043F\u043E\u043B\u043B\u0430\u0440\u0434\u0438\u043D\u0433","additionalCareSteps-\u043F\u0440\u0438\u0449\u0438\u043F\u044B\u0432\u0430\u043D\u0438\u0435":"\u043F\u0440\u0438\u0449\u0438\u043F\u044B\u0432\u0430\u043D\u0438\u0435","additionalCareSteps-\u0441\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430":"\u0441\u0430\u043D\u0438\u0442\u0430\u0440\u043D\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430","additionalCareSteps-\u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0443\u0432\u044F\u0434\u0448\u0438\u0445 \u0446\u0432\u0435\u0442\u043E\u0432":"\u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0443\u0432\u044F\u0434\u0448\u0438\u0445 \u0446\u0432\u0435\u0442\u043E\u0432","additionalCareSteps-\u0443\u043A\u0440\u044B\u0442\u0438\u0435 \u043D\u0430 \u0437\u0438\u043C\u0443":"\u0443\u043A\u0440\u044B\u0442\u0438\u0435 \u043D\u0430 \u0437\u0438\u043C\u0443","additionalCareSteps-\u0444\u043E\u0440\u043C\u043E\u0432\u043E\u0447\u043D\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430":"\u0444\u043E\u0440\u043C\u043E\u0432\u043E\u0447\u043D\u0430\u044F \u043E\u0431\u0440\u0435\u0437\u043A\u0430","additionalCareSteps-\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0437\u0438\u043C\u043E\u0439 \u0432 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0438":"\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0437\u0438\u043C\u043E\u0439 \u0432 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0438","applicationInDesign-\u0430\u043A\u0432\u0430\u0440\u0438\u0443\u043C":"\u0430\u043A\u0432\u0430\u0440\u0438\u0443\u043C","applicationInDesign-\u0430\u043B\u043B\u0435\u044F":"\u0430\u043B\u043B\u0435\u044F","applicationInDesign-\u0430\u043B\u044C\u043F\u0438\u0439\u0441\u043A\u0430\u044F \u0433\u043E\u0440\u043A\u0430 (\u0430\u043B\u044C\u043F\u0438\u043D\u0430\u0440\u0438\u0439)":"\u0430\u043B\u044C\u043F\u0438\u0439\u0441\u043A\u0430\u044F \u0433\u043E\u0440\u043A\u0430 (\u0430\u043B\u044C\u043F\u0438\u043D\u0430\u0440\u0438\u0439)","applicationInDesign-\u0431\u0430\u043B\u043A\u043E\u043D":"\u0431\u0430\u043B\u043A\u043E\u043D","applicationInDesign-\u0431\u0435\u0440\u0441\u043E":"\u0431\u0435\u0440\u0441\u043E","applicationInDesign-\u0431\u043E\u043D\u0441\u0430\u0439":"\u0431\u043E\u043D\u0441\u0430\u0439","applicationInDesign-\u0431\u043E\u0440\u0434\u044E\u0440":"\u0431\u043E\u0440\u0434\u044E\u0440","applicationInDesign-\u0432 \u0438\u043D\u0442\u0435\u0440\u044C\u0435\u0440\u0435":"\u0432 \u0438\u043D\u0442\u0435\u0440\u044C\u0435\u0440\u0435","applicationInDesign-\u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435 \u043E\u0437\u0435\u043B\u0435\u043D\u0435\u043D\u0438\u0435":"\u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435 \u043E\u0437\u0435\u043B\u0435\u043D\u0435\u043D\u0438\u0435","applicationInDesign-\u0433\u0435\u0440\u0431\u0430\u0440\u0438\u0439":"\u0433\u0435\u0440\u0431\u0430\u0440\u0438\u0439","applicationInDesign-\u0433\u0440\u0443\u043F\u043F\u043E\u0432\u0430\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0430":"\u0433\u0440\u0443\u043F\u043F\u043E\u0432\u0430\u044F \u043F\u043E\u0441\u0430\u0434\u043A\u0430","applicationInDesign-\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u043C\u0438\u043D\u0438-\u0432\u043E\u0434\u043E\u0435\u043C":"\u0434\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u043C\u0438\u043D\u0438-\u0432\u043E\u0434\u043E\u0435\u043C","applicationInDesign-\u0436\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C":"\u0436\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C","applicationInDesign-\u043A\u0430\u0448\u043F\u043E":"\u043A\u0430\u0448\u043F\u043E","applicationInDesign-\u043A\u043B\u0443\u043C\u0431\u0430":"\u043A\u043B\u0443\u043C\u0431\u0430","applicationInDesign-\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440":"\u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440","applicationInDesign-\u043A\u0443\u043B\u0438\u0441\u044B":"\u043A\u0443\u043B\u0438\u0441\u044B","applicationInDesign-\u043C\u0438\u043A\u0441\u0431\u043E\u0440\u0434\u0435\u0440":"\u043C\u0438\u043A\u0441\u0431\u043E\u0440\u0434\u0435\u0440","applicationInDesign-\u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u0443\u0434\u0438\u043A":"\u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u0443\u0434\u0438\u043A","applicationInDesign-\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0431\u0443\u043A\u0435\u0442\u0430":"\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0431\u0443\u043A\u0435\u0442\u0430","applicationInDesign-\u043F\u0430\u043B\u044C\u043C\u0435\u0442\u0442\u0430":"\u043F\u0430\u043B\u044C\u043C\u0435\u0442\u0442\u0430","applicationInDesign-\u0440\u0430\u0431\u0430\u0442\u043A\u0430":"\u0440\u0430\u0431\u0430\u0442\u043A\u0430","applicationInDesign-\u0440\u043E\u043A\u0430\u0440\u0438\u0439":"\u0440\u043E\u043A\u0430\u0440\u0438\u0439","applicationInDesign-\u0441\u043E\u043B\u0438\u0442\u0435\u0440 (\u043E\u0434\u0438\u043D\u043E\u0447\u043D\u043E\u0435)":"\u0441\u043E\u043B\u0438\u0442\u0435\u0440 (\u043E\u0434\u0438\u043D\u043E\u0447\u043D\u043E\u0435)","applicationInDesign-\u0441\u0440\u0435\u0437\u043A\u0430":"\u0441\u0440\u0435\u0437\u043A\u0430","applicationInDesign-\u0441\u0443\u0445\u043E\u0439 \u0431\u0443\u043A\u0435\u0442":"\u0441\u0443\u0445\u043E\u0439 \u0431\u0443\u043A\u0435\u0442","applicationInDesign-\u0442\u043E\u043F\u0438\u0430\u0440\u043D\u044B\u0435 \u0444\u0438\u0433\u0443\u0440\u044B":"\u0442\u043E\u043F\u0438\u0430\u0440\u043D\u044B\u0435 \u0444\u0438\u0433\u0443\u0440\u044B","applicationInDesign-\u0444\u0438\u0442\u043E\u043F\u043B\u0430\u0441\u0442\u0438\u043A\u0430":"\u0444\u0438\u0442\u043E\u043F\u043B\u0430\u0441\u0442\u0438\u043A\u0430","applicationInDesign-\u0444\u043B\u043E\u0440\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0434\u0438\u0437\u0430\u0439\u043D":"\u0444\u043B\u043E\u0440\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0434\u0438\u0437\u0430\u0439\u043D","applicationInDesign-\u0448\u043F\u0430\u043B\u0435\u0440\u0430":"\u0448\u043F\u0430\u043B\u0435\u0440\u0430","applicationInDesign-\u044F\u043F\u043E\u043D\u0441\u043A\u0438\u0439 \u0441\u0430\u0434":"\u044F\u043F\u043E\u043D\u0441\u043A\u0438\u0439 \u0441\u0430\u0434","disease-\u0430\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0440\u0438\u043E\u0437":"\u0430\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0440\u0438\u043E\u0437","disease-\u0430\u043D\u0442\u0440\u0430\u043A\u043D\u043E\u0437":"\u0430\u043D\u0442\u0440\u0430\u043A\u043D\u043E\u0437","disease-\u0430\u0441\u0442\u0440\u043E\u0432\u044B\u0439 \u0432\u0438\u043B\u0442":"\u0430\u0441\u0442\u0440\u043E\u0432\u044B\u0439 \u0432\u0438\u043B\u0442","disease-\u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0436\u043E\u0433":"\u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0436\u043E\u0433","disease-\u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0440\u044F\u0431\u0443\u0445\u0430":"\u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0440\u044F\u0431\u0443\u0445\u0430","disease-\u0431\u0435\u043B\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u0431\u0435\u043B\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u0431\u0435\u043B\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C":"\u0431\u0435\u043B\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C","disease-\u0431\u0438\u0430\u0442\u043E\u0440\u0435\u043B\u043B\u043E\u0432\u044B\u0439 \u0440\u0430\u043A \u0442\u0438\u0441\u0430":"\u0431\u0438\u0430\u0442\u043E\u0440\u0435\u043B\u043B\u043E\u0432\u044B\u0439 \u0440\u0430\u043A \u0442\u0438\u0441\u0430","disease-\u0431\u0443\u0440\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C":"\u0431\u0443\u0440\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C","disease-\u0432\u0435\u0440\u0442\u0438\u0446\u0438\u043B\u043B\u0435\u0437":"\u0432\u0435\u0440\u0442\u0438\u0446\u0438\u043B\u043B\u0435\u0437","disease-\u0432\u0435\u0440\u0448\u0438\u043D\u043D\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u0432\u0435\u0440\u0448\u0438\u043D\u043D\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u0432\u0438\u0440\u0443\u0441 \u043B\u044E\u0446\u0435\u0440\u043D\u043E\u0432\u043E\u0439 \u043C\u043E\u0437\u0430\u0438\u043A\u0438":"\u0432\u0438\u0440\u0443\u0441 \u043B\u044E\u0446\u0435\u0440\u043D\u043E\u0432\u043E\u0439 \u043C\u043E\u0437\u0430\u0438\u043A\u0438","disease-\u0432\u0438\u0440\u0443\u0441 \u043C\u043E\u0437\u0430\u0438\u043A\u0438":"\u0432\u0438\u0440\u0443\u0441 \u043C\u043E\u0437\u0430\u0438\u043A\u0438","disease-\u0432\u0438\u0440\u0443\u0441 \u043D\u0435\u043A\u0440\u043E\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u043B\u043E\u0441\u0430\u0442\u043E\u0441\u0442\u0438 \u043B\u0438\u043B\u0438\u0438":"\u0432\u0438\u0440\u0443\u0441 \u043D\u0435\u043A\u0440\u043E\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u043B\u043E\u0441\u0430\u0442\u043E\u0441\u0442\u0438 \u043B\u0438\u043B\u0438\u0438","disease-\u0432\u0438\u0440\u0443\u0441 \u0445\u043E\u0441\u0442\u044B X":"\u0432\u0438\u0440\u0443\u0441 \u0445\u043E\u0441\u0442\u044B X","disease-\u0432\u043E\u0434\u044F\u043D\u0438\u0441\u0442\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u0432\u043E\u0434\u044F\u043D\u0438\u0441\u0442\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u0433\u043D\u0438\u043B\u044C \u0441\u0442\u0435\u0431\u043B\u044F":"\u0433\u043D\u0438\u043B\u044C \u0441\u0442\u0435\u0431\u043B\u044F","disease-\u0433\u0440\u0438\u0431\u043A\u043E\u0432\u044B\u0435 \u0437\u0430\u0431\u043E\u043B\u0435\u0432\u0430\u043D\u0438\u044F":"\u0433\u0440\u0438\u0431\u043A\u043E\u0432\u044B\u0435 \u0437\u0430\u0431\u043E\u043B\u0435\u0432\u0430\u043D\u0438\u044F","disease-\u043A\u0438\u043B\u0430 \u043A\u0430\u043F\u0443\u0441\u0442\u043D\u044B\u0445":"\u043A\u0438\u043B\u0430 \u043A\u0430\u043F\u0443\u0441\u0442\u043D\u044B\u0445","disease-\u043A\u043B\u044F\u0441\u0442\u0435\u0440\u043E\u0441\u043F\u043E\u0440\u0438\u043E\u0437":"\u043A\u043B\u044F\u0441\u0442\u0435\u0440\u043E\u0441\u043F\u043E\u0440\u0438\u043E\u0437","disease-\u043A\u043E\u0440\u043D\u0435\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u043A\u043E\u0440\u043D\u0435\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u043A\u043E\u0440\u043D\u0435\u0432\u043E\u0439 \u0440\u0430\u043A":"\u043A\u043E\u0440\u043D\u0435\u0432\u043E\u0439 \u0440\u0430\u043A","disease-\u043B\u043E\u0436\u043D\u0430\u044F \u043C\u0443\u0447\u043D\u0438\u0441\u0442\u0430\u044F \u0440\u043E\u0441\u0430":"\u043F\u0435\u0440\u043E\u043D\u043E\u0441\u043F\u043E\u0440\u043E\u0437 (\u043B\u043E\u0436\u043D\u0430\u044F \u043C\u0443\u0447\u043D\u0438\u0441\u0442\u0430\u044F \u0440\u043E\u0441\u0430)","disease-\u043C\u043E\u0437\u0430\u0438\u0447\u043D\u0430\u044F \u0431\u043E\u043B\u0435\u0437\u043D\u044C \u043B\u0438\u0441\u0442\u044C\u0435\u0432":"\u043C\u043E\u0437\u0430\u0438\u0447\u043D\u0430\u044F \u0431\u043E\u043B\u0435\u0437\u043D\u044C \u043B\u0438\u0441\u0442\u044C\u0435\u0432","disease-\u043C\u043E\u043A\u0440\u0430\u044F \u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u043C\u043E\u043A\u0440\u0430\u044F \u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u043C\u043E\u043D\u0442\u0430\u0440\u044C":"\u043C\u043E\u043D\u0442\u0430\u0440\u044C","disease-\u043C\u0443\u0447\u043D\u0438\u0441\u0442\u0430\u044F \u0440\u043E\u0441\u0430":"\u043C\u0443\u0447\u043D\u0438\u0441\u0442\u0430\u044F \u0440\u043E\u0441\u0430","disease-\u043E\u0433\u0443\u0440\u0435\u0447\u043D\u0430\u044F \u043C\u043E\u0437\u0430\u0438\u043A\u0430":"\u043E\u0433\u0443\u0440\u0435\u0447\u043D\u0430\u044F \u043C\u043E\u0437\u0430\u0438\u043A\u0430","disease-\u043E\u0438\u0434\u0438\u0443\u043C \u0432\u0438\u043D\u043E\u0433\u0440\u0430\u0434\u0430":"\u043E\u0438\u0434\u0438\u0443\u043C \u0432\u0438\u043D\u043E\u0433\u0440\u0430\u0434\u0430","disease-\u043F\u0430\u0440\u0448\u0430":"\u043F\u0430\u0440\u0448\u0430","disease-\u043F\u0435\u043D\u0438\u0446\u0438\u043B\u043B\u0435\u0437":"\u043F\u0435\u043D\u0438\u0446\u0438\u043B\u043B\u0435\u0437","disease-\u043F\u0435\u0441\u0442\u0430\u043B\u043E\u0446\u0438\u0435\u0432\u044B\u0439 \u043D\u0435\u043A\u0440\u043E\u0437":"\u043F\u0435\u0441\u0442\u0430\u043B\u043E\u0446\u0438\u0435\u0432\u044B\u0439 \u043D\u0435\u043A\u0440\u043E\u0437","disease-\u043F\u0435\u0441\u0442\u0440\u043E\u043B\u0435\u043F\u0435\u0441\u0442\u043D\u043E\u0441\u0442\u044C":"\u043F\u0435\u0441\u0442\u0440\u043E\u043B\u0435\u043F\u0435\u0441\u0442\u043D\u043E\u0441\u0442\u044C","disease-\u043F\u043B\u043E\u0434\u043E\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C (\u043C\u043E\u043D\u0438\u043B\u0438\u043E\u0437)":"\u043F\u043B\u043E\u0434\u043E\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C (\u043C\u043E\u043D\u0438\u043B\u0438\u043E\u0437)","disease-\u043F\u043E\u0434\u0433\u0430\u0440 \u0442\u0430\u0431\u0430\u043A\u0430":"\u043F\u043E\u0434\u0433\u0430\u0440 \u0442\u0430\u0431\u0430\u043A\u0430","disease-\u043F\u043E\u0436\u0438\u043B\u043A\u043E\u0432\u044B\u0439 \u0445\u043B\u043E\u0440\u043E\u0437":"\u043F\u043E\u0436\u0438\u043B\u043A\u043E\u0432\u044B\u0439 \u0445\u043B\u043E\u0440\u043E\u0437","disease-\u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u043B\u0438\u0441\u0442\u044C\u0435\u0432":"\u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C \u043B\u0438\u0441\u0442\u044C\u0435\u0432","disease-\u0440\u0430\u043A":"\u0440\u0430\u043A","disease-\u0440\u0430\u0441\u0441\u0430\u0434\u043D\u0430\u044F (\u0441\u0442\u0435\u0431\u043B\u0435\u0432\u0430\u044F) \u0433\u043D\u0438\u043B\u044C":"\u0440\u0430\u0441\u0441\u0430\u0434\u043D\u0430\u044F (\u0441\u0442\u0435\u0431\u043B\u0435\u0432\u0430\u044F) \u0433\u043D\u0438\u043B\u044C","disease-\u0440\u0435\u0432\u0435\u0440\u0441\u0438\u044F \u0447\u0435\u0440\u043D\u043E\u0439 \u0441\u043C\u043E\u0440\u043E\u0434\u0438\u043D\u044B":"\u0440\u0435\u0432\u0435\u0440\u0441\u0438\u044F \u0447\u0435\u0440\u043D\u043E\u0439 \u0441\u043C\u043E\u0440\u043E\u0434\u0438\u043D\u044B","disease-\u0440\u0436\u0430\u0432\u0447\u0438\u043D\u0430":"\u0440\u0436\u0430\u0432\u0447\u0438\u043D\u0430","disease-\u0440\u0438\u0437\u043E\u043A\u0442\u043E\u043D\u0438\u043E\u0437 (\u0431\u0443\u0440\u0430\u044F \u0433\u043D\u0438\u043B\u044C)":"\u0440\u0438\u0437\u043E\u043A\u0442\u043E\u043D\u0438\u043E\u0437 (\u0431\u0443\u0440\u0430\u044F \u0433\u043D\u0438\u043B\u044C)","disease-\u0441\u0430\u0436\u0438\u0441\u0442\u044B\u0439 \u0433\u0440\u0438\u0431":"\u0441\u0430\u0436\u0438\u0441\u0442\u044B\u0439 \u0433\u0440\u0438\u0431","disease-\u0441\u0435\u0440\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u0441\u0435\u0440\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u0441\u0435\u0440\u0430\u044F \u043F\u043B\u0435\u0441\u0435\u043D\u044C":"\u0441\u0435\u0440\u0430\u044F \u043F\u043B\u0435\u0441\u0435\u043D\u044C","disease-\u0441\u0442\u0430\u0433\u0430\u043D\u043E\u0441\u043F\u043E\u0440\u043E\u0437":"\u0441\u0442\u0430\u0433\u0430\u043D\u043E\u0441\u043F\u043E\u0440\u043E\u0437","disease-\u0441\u0442\u0432\u043E\u043B\u043E\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C":"\u0441\u0442\u0432\u043E\u043B\u043E\u0432\u0430\u044F \u0433\u043D\u0438\u043B\u044C","disease-\u0442\u0430\u0431\u0430\u0447\u043D\u0430\u044F \u043C\u043E\u0437\u0430\u0438\u043A\u0430":"\u0442\u0430\u0431\u0430\u0447\u043D\u0430\u044F \u043C\u043E\u0437\u0430\u0438\u043A\u0430","disease-\u0443- \u0432\u0438\u0440\u0443\u0441 \u043A\u0430\u0440\u0442\u043E\u0444\u0435\u043B\u044F (\u0431\u0435\u043B\u0430\u044F \u043F\u0435\u0441\u0442\u0440\u0438\u0446\u0430)":"\u0443- \u0432\u0438\u0440\u0443\u0441 \u043A\u0430\u0440\u0442\u043E\u0444\u0435\u043B\u044F (\u0431\u0435\u043B\u0430\u044F \u043F\u0435\u0441\u0442\u0440\u0438\u0446\u0430)","disease-\u0444\u0438\u0442\u043E\u0444\u0442\u043E\u0440\u043E\u0437":"\u0444\u0438\u0442\u043E\u0444\u0442\u043E\u0440\u043E\u0437","disease-\u0444\u043E\u043C\u043E\u0437":"\u0444\u043E\u043C\u043E\u0437","disease-\u0444\u043E\u043C\u043E\u0437 \u0442\u0438\u0441\u0430":"\u0444\u043E\u043C\u043E\u0437 \u0442\u0438\u0441\u0430","disease-\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437":"\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437","disease-\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437\u043D\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C":"\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437\u043D\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C","disease-\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437\u043D\u043E\u0435 \u0443\u0432\u044F\u0434\u0430\u043D\u0438\u0435":"\u0444\u0443\u0437\u0430\u0440\u0438\u043E\u0437\u043D\u043E\u0435 \u0443\u0432\u044F\u0434\u0430\u043D\u0438\u0435","disease-\u0445\u043B\u043E\u0440\u043E\u0437":"\u0445\u043B\u043E\u0440\u043E\u0437","disease-\u0446\u0435\u0440\u043A\u043E\u0441\u043F\u043E\u0440\u043E\u0437":"\u0446\u0435\u0440\u043A\u043E\u0441\u043F\u043E\u0440\u043E\u0437","disease-\u0447\u0435\u0440\u043D\u0430\u044F \u043D\u043E\u0436\u043A\u0430":"\u0447\u0435\u0440\u043D\u0430\u044F \u043D\u043E\u0436\u043A\u0430","disease-\u0447\u0435\u0440\u043D\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C":"\u0447\u0435\u0440\u043D\u0430\u044F \u043F\u044F\u0442\u043D\u0438\u0441\u0442\u043E\u0441\u0442\u044C","disease-\u0447\u0435\u0440\u043D\u044C":"\u0447\u0435\u0440\u043D\u044C","disease-\u0448\u044E\u0442\u0442\u0435 \u0431\u0443\u0440\u043E\u0435":"\u0448\u044E\u0442\u0442\u0435 \u0431\u0443\u0440\u043E\u0435","pests-\u0431\u0435\u043B\u043E\u043A\u0440\u044B\u043B\u043A\u0430":"\u0431\u0435\u043B\u043E\u043A\u0440\u044B\u043B\u043A\u0430","pests-\u0431\u043B\u043E\u0448\u043A\u0430 \u043A\u0440\u0435\u0441\u0442\u043E\u0446\u0432\u0435\u0442\u043D\u0430\u044F":"\u0431\u043B\u043E\u0448\u043A\u0430 \u043A\u0440\u0435\u0441\u0442\u043E\u0446\u0432\u0435\u0442\u043D\u0430\u044F","pests-\u0432\u043E\u0439\u043B\u043E\u0447\u043D\u044B\u0439 \u043E\u0440\u0435\u0445\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449":"\u0432\u043E\u0439\u043B\u043E\u0447\u043D\u044B\u0439 \u043E\u0440\u0435\u0445\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u0433\u0430\u043B\u043B\u0438\u0446\u044B":"\u0433\u0430\u043B\u043B\u0438\u0446\u044B","pests-\u0433\u043E\u0440\u043E\u0445\u043E\u0432\u0430\u044F \u0437\u0435\u0440\u043D\u043E\u0432\u043A\u0430":"\u0433\u043E\u0440\u043E\u0445\u043E\u0432\u0430\u044F \u0437\u0435\u0440\u043D\u043E\u0432\u043A\u0430","pests-\u0433\u0443\u0441\u0435\u043D\u0438\u0446\u044B":"\u0433\u0443\u0441\u0435\u043D\u0438\u0446\u044B","pests-\u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0441\u0438\u043A":"\u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0441\u0438\u043A","pests-\u0435\u043B\u043E\u0432\u0430\u044F \u043B\u0438\u0441\u0442\u043E\u0432\u0435\u0440\u0442\u043A\u0430-\u0438\u0433\u043B\u043E\u0435\u0434":"\u0435\u043B\u043E\u0432\u0430\u044F \u043B\u0438\u0441\u0442\u043E\u0432\u0435\u0440\u0442\u043A\u0430-\u0438\u0433\u043B\u043E\u0435\u0434","pests-\u0437\u043E\u043D\u0442\u0438\u0447\u043D\u0430\u044F \u043C\u043E\u043B\u044C":"\u0437\u043E\u043D\u0442\u0438\u0447\u043D\u0430\u044F \u043C\u043E\u043B\u044C","pests-\u043A\u0430\u043F\u0443\u0441\u0442\u043D\u0430\u044F \u0433\u0443\u0441\u0435\u043D\u0438\u0446\u0430":"\u043A\u0430\u043F\u0443\u0441\u0442\u043D\u0430\u044F \u0433\u0443\u0441\u0435\u043D\u0438\u0446\u0430","pests-\u043A\u0430\u043F\u0443\u0441\u0442\u043D\u0430\u044F \u043C\u0443\u0445\u0430":"\u043A\u0430\u043F\u0443\u0441\u0442\u043D\u0430\u044F \u043C\u0443\u0445\u0430","pests-\u043A\u043B\u043E\u043F \u0432\u043E\u043D\u044E\u0447\u0438\u0439":"\u043A\u043B\u043E\u043F \u0432\u043E\u043D\u044E\u0447\u0438\u0439","pests-\u043A\u043E\u043B\u043E\u0440\u0430\u0434\u0441\u043A\u0438\u0439 \u0436\u0443\u043A":"\u043A\u043E\u043B\u043E\u0440\u0430\u0434\u0441\u043A\u0438\u0439 \u0436\u0443\u043A","pests-\u043A\u043E\u043C\u0430\u0440\u044B-\u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0436\u043A\u0438":"\u043A\u043E\u043C\u0430\u0440\u044B-\u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0436\u043A\u0438","pests-\u043A\u043E\u0440\u043D\u0435\u0432\u043E\u0439 \u043B\u0443\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449":"\u043A\u043E\u0440\u043D\u0435\u0432\u043E\u0439 \u043B\u0443\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u043A\u0440\u0435\u0441\u0442\u043E\u0446\u0432\u0435\u0442\u043D\u0430\u044F \u0431\u043B\u043E\u0448\u043A\u0430":"\u043A\u0440\u0435\u0441\u0442\u043E\u0446\u0432\u0435\u0442\u043D\u0430\u044F \u0431\u043B\u043E\u0448\u043A\u0430","pests-\u043A\u0440\u043E\u0442":"\u043A\u0440\u043E\u0442","pests-\u043B\u0438\u043B\u0435\u0439\u043D\u0430\u044F \u043C\u0443\u0445\u0430":"\u043B\u0438\u043B\u0435\u0439\u043D\u0430\u044F \u043C\u0443\u0445\u0430","pests-\u043B\u0438\u043B\u0435\u0439\u043D\u044B\u0439 \u0436\u0443\u043A":"\u043B\u0438\u043B\u0435\u0439\u043D\u044B\u0439 \u0436\u0443\u043A","pests-\u043B\u0438\u0441\u0442\u043E\u0431\u043B\u043E\u0448\u043A\u0430":"\u043B\u0438\u0441\u0442\u043E\u0431\u043B\u043E\u0448\u043A\u0430","pests-\u043B\u0438\u0441\u0442\u043E\u0432\u0430\u044F \u0431\u043B\u043E\u0448\u043A\u0430":"\u043B\u0438\u0441\u0442\u043E\u0432\u0430\u044F \u0431\u043B\u043E\u0448\u043A\u0430","pests-\u043B\u0438\u0441\u0442\u043E\u0432\u0435\u0440\u0442\u043A\u0430":"\u043B\u0438\u0441\u0442\u043E\u0432\u0435\u0440\u0442\u043A\u0430","pests-\u043B\u0438\u0441\u0442\u043E\u0435\u0434\u044B":"\u043B\u0438\u0441\u0442\u043E\u0435\u0434\u044B","pests-\u043B\u0443\u043A\u043E\u0432\u0430\u044F \u0436\u0443\u0440\u0447\u0430\u043B\u043A\u0430":"\u043B\u0443\u043A\u043E\u0432\u0430\u044F \u0436\u0443\u0440\u0447\u0430\u043B\u043A\u0430","pests-\u043B\u0443\u043A\u043E\u0432\u0430\u044F \u043C\u0443\u0445\u0430":"\u043B\u0443\u043A\u043E\u0432\u0430\u044F \u043C\u0443\u0445\u0430","pests-\u043B\u0443\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449":"\u043B\u0443\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u043C\u0430\u043B\u0438\u043D\u043D\u044B\u0439 \u0436\u0443\u043A":"\u043C\u0430\u043B\u0438\u043D\u043D\u044B\u0439 \u0436\u0443\u043A","pests-\u043C\u0435\u0434\u0432\u0435\u0434\u043A\u0430":"\u043C\u0435\u0434\u0432\u0435\u0434\u043A\u0430","pests-\u043C\u0438\u043D\u0438\u0440\u0443\u044E\u0449\u0430\u044F \u043C\u0443\u0445\u0430":"\u043C\u0438\u043D\u0438\u0440\u0443\u044E\u0449\u0430\u044F \u043C\u0443\u0445\u0430","pests-\u043C\u0443\u0440\u0430\u0432\u044C\u0438":"\u043C\u0443\u0440\u0430\u0432\u044C\u0438","pests-\u043C\u0443\u0447\u043D\u0438\u0441\u0442\u044B\u0439 \u0447\u0435\u0440\u0432\u0435\u0446":"\u043C\u0443\u0447\u043D\u0438\u0441\u0442\u044B\u0439 \u0447\u0435\u0440\u0432\u0435\u0446","pests-\u043C\u044F\u0433\u043A\u0430\u044F \u043B\u043E\u0436\u043D\u043E\u0449\u0438\u0442\u043E\u0432\u043A\u0430":"\u043C\u044F\u0433\u043A\u0430\u044F \u043B\u043E\u0436\u043D\u043E\u0449\u0438\u0442\u043E\u0432\u043A\u0430","pests-\u043D\u0435\u043C\u0430\u0442\u043E\u0434\u044B":"\u043D\u0435\u043C\u0430\u0442\u043E\u0434\u044B","pests-\u043E\u0433\u043D\u0435\u0432\u043A\u0430":"\u043E\u0433\u043D\u0435\u0432\u043A\u0430","pests-\u043F\u0430\u0443\u0442\u0438\u043D\u043D\u044B\u0439 \u043A\u043B\u0435\u0449":"\u043F\u0430\u0443\u0442\u0438\u043D\u043D\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u043F\u0438\u043B\u0438\u043B\u044C\u0449\u0438\u043A":"\u043F\u0438\u043B\u0438\u043B\u044C\u0449\u0438\u043A","pests-\u043F\u043B\u043E\u0434\u043E\u0436\u043E\u0440\u043A\u0430":"\u043F\u043B\u043E\u0434\u043E\u0436\u043E\u0440\u043A\u0430","pests-\u043F\u043E\u043B\u0435\u0432\u0430\u044F \u043C\u044B\u0448\u044C":"\u043F\u043E\u043B\u0435\u0432\u0430\u044F \u043C\u044B\u0448\u044C","pests-\u043F\u043E\u043B\u0435\u0432\u043E\u0439 \u043A\u043B\u043E\u043F":"\u043F\u043E\u043B\u0435\u0432\u043E\u0439 \u043A\u043B\u043E\u043F","pests-\u043F\u043E\u043B\u043E\u0441\u0430\u0442\u044B\u0439 \u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0441\u0438\u043A":"\u043F\u043E\u043B\u043E\u0441\u0430\u0442\u044B\u0439 \u0434\u043E\u043B\u0433\u043E\u043D\u043E\u0441\u0438\u043A","pests-\u043F\u043E\u0447\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449":"\u043F\u043E\u0447\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u043F\u0440\u043E\u0432\u043E\u043B\u043E\u0447\u043D\u0438\u043A":"\u043F\u0440\u043E\u0432\u043E\u043B\u043E\u0447\u043D\u0438\u043A","pests-\u0440\u0430\u0441\u0442\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u044F\u0434\u043D\u044B\u0439 \u043A\u043B\u0435\u0449":"\u0440\u0430\u0441\u0442\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u044F\u0434\u043D\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u0441\u0430\u043C\u0448\u0438\u0442\u043E\u0432\u0430\u044F \u043E\u0433\u043D\u0435\u0432\u043A\u0430":"\u0441\u0430\u043C\u0448\u0438\u0442\u043E\u0432\u0430\u044F \u043E\u0433\u043D\u0435\u0432\u043A\u0430","pests-\u0441\u0435\u043B\u044C\u0434\u0435\u0440\u0435\u0439\u043D\u0430\u044F \u043C\u0443\u0445\u0430":"\u0441\u0435\u043B\u044C\u0434\u0435\u0440\u0435\u0439\u043D\u0430\u044F \u043C\u0443\u0445\u0430","pests-\u0441\u043B\u0438\u0437\u043D\u0438":"\u0441\u043B\u0438\u0437\u043D\u0438","pests-\u0441\u043B\u044E\u043D\u044F\u0432\u0430\u044F \u043F\u0435\u043D\u043D\u0438\u0446\u0430":"\u0441\u043B\u044E\u043D\u044F\u0432\u0430\u044F \u043F\u0435\u043D\u043D\u0438\u0446\u0430","pests-\u0441\u0442\u0435\u0431\u043B\u0435\u0432\u0430\u044F \u043D\u0435\u043C\u0430\u0442\u043E\u0434\u0430":"\u0441\u0442\u0435\u0431\u043B\u0435\u0432\u0430\u044F \u043D\u0435\u043C\u0430\u0442\u043E\u0434\u0430","pests-\u0442\u0430\u0431\u0430\u0447\u043D\u044B\u0439 \u043F\u0440\u043E\u0432\u043E\u043B\u043E\u0447\u043D\u0438\u043A":"\u0442\u0430\u0431\u0430\u0447\u043D\u044B\u0439 \u043F\u0440\u043E\u0432\u043E\u043B\u043E\u0447\u043D\u0438\u043A","pests-\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u0433\u0430\u043B\u043B\u0438\u0446\u0430":"\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u0433\u0430\u043B\u043B\u0438\u0446\u0430","pests-\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u043B\u043E\u0436\u043D\u043E\u0449\u0438\u0442\u043E\u0432\u043A\u0430":"\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u043B\u043E\u0436\u043D\u043E\u0449\u0438\u0442\u043E\u0432\u043A\u0430","pests-\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u043F\u043B\u043E\u0441\u043A\u043E\u0442\u0435\u043B\u043A\u0430":"\u0442\u0438\u0441\u043E\u0432\u0430\u044F \u043F\u043B\u043E\u0441\u043A\u043E\u0442\u0435\u043B\u043A\u0430","pests-\u0442\u0438\u0441\u043E\u0432\u044B\u0439 \u043F\u043E\u0447\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449":"\u0442\u0438\u0441\u043E\u0432\u044B\u0439 \u043F\u043E\u0447\u043A\u043E\u0432\u044B\u0439 \u043A\u043B\u0435\u0449","pests-\u0442\u043B\u044F":"\u0442\u043B\u044F","pests-\u0442\u0440\u0438\u043F\u0441\u044B":"\u0442\u0440\u0438\u043F\u0441\u044B","pests-\u0442\u044E\u043B\u044C\u043F\u0430\u043D\u043E\u0432\u0430\u044F \u043E\u0433\u043D\u0451\u0432\u043A\u0430":"\u0442\u044E\u043B\u044C\u043F\u0430\u043D\u043E\u0432\u0430\u044F \u043E\u0433\u043D\u0451\u0432\u043A\u0430","pests-\u0443\u043B\u0438\u0442\u043A\u0438":"\u0443\u043B\u0438\u0442\u043A\u0438","pests-\u0444\u0430\u0441\u043E\u043B\u0435\u0432\u0430\u044F \u0437\u0435\u0440\u043D\u043E\u0432\u043A\u0430":"\u0444\u0430\u0441\u043E\u043B\u0435\u0432\u0430\u044F \u0437\u0435\u0440\u043D\u043E\u0432\u043A\u0430","pests-\u0445\u0440\u0443\u0449":"\u0445\u0440\u0443\u0449","pests-\u0446\u0432\u0435\u0442\u043E\u0447\u043D\u0430\u044F \u043F\u044F\u0434\u0435\u043D\u0438\u0446\u0430":"\u0446\u0432\u0435\u0442\u043E\u0447\u043D\u0430\u044F \u043F\u044F\u0434\u0435\u043D\u0438\u0446\u0430","pests-\u0449\u0438\u0442\u043E\u0432\u043A\u0430":"\u0449\u0438\u0442\u043E\u0432\u043A\u0430","pesticideTreatmentFrequency-1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E":"1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E","pesticideTreatmentFrequency-2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E":"2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E","pesticideTreatmentFrequency-1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446":"1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446","pesticideTreatmentFrequency-2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446":"2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446","pesticideTreatmentFrequency-1 \u0440\u0430\u0437 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D":"1 \u0440\u0430\u0437 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D","pesticideTreatmentFrequency-\u043F\u043E \u043C\u0435\u0440\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438":"\u043F\u043E \u043C\u0435\u0440\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438","pesticideTreatmentFrequency-\u043F\u0440\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445":"\u043F\u0440\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445","fertilizerFrequency-1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E":"1 \u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E","fertilizerFrequency-2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E":"2 \u0440\u0430\u0437\u0430 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E","fertilizerFrequency-1 \u0440\u0430\u0437 \u0432 2 \u043D\u0435\u0434\u0435\u043B\u0438":"1 \u0440\u0430\u0437 \u0432 2 \u043D\u0435\u0434\u0435\u043B\u0438","fertilizerFrequency-1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446":"1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446","fertilizerFrequency-2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446":"2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446","fertilizerFrequency-1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446 \u0432 \u0432\u0435\u0433\u0435\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434":"1 \u0440\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446 \u0432 \u0432\u0435\u0433\u0435\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434","fertilizerFrequency-2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446 \u0432 \u0432\u0435\u0433\u0435\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434":"2 \u0440\u0430\u0437\u0430 \u0432 \u043C\u0435\u0441\u044F\u0446 \u0432 \u0432\u0435\u0433\u0435\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434","fertilizerFrequency-1 \u0440\u0430\u0437 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D":"1 \u0440\u0430\u0437 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D","fertilizerFrequency-2 \u0440\u0430\u0437\u0430 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D":"2 \u0440\u0430\u0437\u0430 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D","fertilizerFrequency-3-4 \u0440\u0430\u0437\u0430 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D":"3-4 \u0440\u0430\u0437\u0430 \u0437\u0430 \u0441\u0435\u0437\u043E\u043D","fertilizerFrequency-\u043F\u0440\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445":"\u043F\u0440\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445","elementName-building":"\u0437\u0434\u0430\u043D\u0438\u0435","elementName-building1":"\u0437\u0434\u0430\u043D\u0438\u0435 1","elementName-building2":"\u0437\u0434\u0430\u043D\u0438\u0435 2","elementName-building3":"\u0437\u0434\u0430\u043D\u0438\u0435 3","elementName-building4":"\u0437\u0434\u0430\u043D\u0438\u0435 4","elementName-building5":"\u0437\u0434\u0430\u043D\u0438\u0435 5","elementName-building6":"\u0437\u0434\u0430\u043D\u0438\u0435 6","elementName-building7":"\u0437\u0434\u0430\u043D\u0438\u0435 7","elementName-building8":"\u0437\u0434\u0430\u043D\u0438\u0435 8","elementName-building9":"\u0437\u0434\u0430\u043D\u0438\u0435 9","elementName-building10":"\u0437\u0434\u0430\u043D\u0438\u0435 10","elementName-building11":"\u0437\u0434\u0430\u043D\u0438\u0435 11","elementName-building12":"\u0437\u0434\u0430\u043D\u0438\u0435 12","elementName-building13":"\u0437\u0434\u0430\u043D\u0438\u0435 13","elementName-building14":"\u0437\u0434\u0430\u043D\u0438\u0435 14","elementName-building15":"\u0437\u0434\u0430\u043D\u0438\u0435 15","elementName-building16":"\u0437\u0434\u0430\u043D\u0438\u0435 16","elementName-building17":"\u0437\u0434\u0430\u043D\u0438\u0435 17","elementName-building18":"\u0437\u0434\u0430\u043D\u0438\u0435 18","elementName-garden":"\u0441\u0430\u0434","elementName-lawn":"\u0433\u0430\u0437\u043E\u043D","elementName-flowerbed":"\u043A\u043B\u0443\u043C\u0431\u0430","elementName-flowerbed1":"\u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u0430\u044F \u043A\u043B\u0443\u043C\u0431\u0430","elementName-flowerbed2":"\u043A\u0440\u0443\u0433\u043B\u0430\u044F \u043A\u043B\u0443\u043C\u0431\u0430","elementName-flowerbed11":"\u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u0430\u044F \u043A\u043B\u0443\u043C\u0431\u0430","elementName-flowerbed22":"\u043A\u0440\u0443\u0433\u043B\u0430\u044F \u043A\u043B\u0443\u043C\u0431\u0430","elementName-greenhouse":"\u0442\u0435\u043F\u043B\u0438\u0446\u0430","elementName-greenhouse1":"\u0442\u0435\u043F\u043B\u0438\u0446\u0430 1","elementName-vegetablegarden":"\u0433\u0440\u044F\u0434\u043A\u0430","elementName-veggardencabbage":"\u0433\u0440\u044F\u0434\u043A\u0430 - \u043A\u0430\u043F\u0443\u0441\u0442\u0430","elementName-veggarden11":"\u0433\u0440\u044F\u0434\u043A\u0430 11","elementName-veggarden12":"\u0433\u0440\u044F\u0434\u043A\u0430 12","elementName-veggarden2":"\u0433\u0440\u044F\u0434\u043A\u0430 2","elementName-veggarden4":"\u0433\u0440\u044F\u0434\u043A\u0430 4","elementName-veggarden7":"\u0433\u0440\u044F\u0434\u043A\u0430 7","elementName-veggarden26":"\u0433\u0440\u044F\u0434\u043A\u0430 26","elementName-tile":"\u043F\u043B\u0438\u0442\u043A\u0430","elementName-tile1":"\u043F\u043B\u0438\u0442\u043A\u0430 1","elementName-tile2":"\u043F\u043B\u0438\u0442\u043A\u0430 2","elementName-tile3":"\u043F\u043B\u0438\u0442\u043A\u0430 3","elementName-tile4":"\u043F\u043B\u0438\u0442\u043A\u0430 4","elementName-tile5":"\u043F\u043B\u0438\u0442\u043A\u0430 5","elementName-tile6":"\u043F\u043B\u0438\u0442\u043A\u0430 6","elementName-stairs":"\u043B\u0435\u0441\u0442\u043D\u0438\u0446\u0430","elementName-stairs1":"\u043B\u0435\u0441\u0442\u043D\u0438\u0446\u0430 1","elementName-stairs2":"\u043B\u0435\u0441\u0442\u043D\u0438\u0446\u0430 2","elementName-terrace":"\u0442\u0435\u0440\u0430\u0441\u0441\u0430","elementName-terrace1":"\u0442\u0435\u0440\u0430\u0441\u0441\u0430 1","elementName-patio":"\u043F\u0430\u0442\u0438\u043E","elementName-patio1":"\u043F\u0430\u0442\u0438\u043E 1","elementName-patio2":"\u043F\u0430\u0442\u0438\u043E 2","elementName-fence":"\u0437\u0430\u0431\u043E\u0440","elementName-fence1":"\u0437\u0430\u0431\u043E\u0440 1","elementName-fence2":"\u0437\u0430\u0431\u043E\u0440 2","elementName-fence3":"\u0437\u0430\u0431\u043E\u0440 3","elementName-fence4":"\u0437\u0430\u0431\u043E\u0440 4","elementName-entrance":"\u0432\u0445\u043E\u0434\u043D\u0430\u044F \u0433\u0440\u0443\u043F\u043F\u0430","elementName-gate1":"\u0434\u0432\u0443\u0441\u0442\u0432\u043E\u0440\u0447\u0430\u0442\u044B\u0435 \u0432\u043E\u0440\u043E\u0442\u0430","elementName-gate2":"\u043E\u0434\u043D\u043E\u0441\u0442\u0432\u043E\u0440\u0447\u0430\u0442\u044B\u0435 \u0432\u043E\u0440\u043E\u0442\u0430","elementName-wicket":"\u043A\u0430\u043B\u0438\u0442\u043A\u0430","elementName-plantcomposition":"\u043A\u043E\u043C\u043F\u043E\u0437\u0438\u0446\u0438\u044F \u0440\u0430\u0441\u0442\u0435\u043D\u0438\u0439","elementName-rockery1":"\u0440\u043E\u043A\u0430\u0440\u0438\u0439 1","elementName-rockery2":"\u0440\u043E\u043A\u0430\u0440\u0438\u0439 2","elementName-rockery3":"\u0440\u043E\u043A\u0430\u0440\u0438\u0439 3","elementName-tree":"\u0434\u0435\u0440\u0435\u0432\u043E","elementName-bush":"\u043A\u0443\u0441\u0442","elementName-redBush":"\u043A\u0440\u0430\u0441\u043D\u044B\u0439 \u043A\u0443\u0441\u0442","elementName-grass":"\u0442\u0440\u0430\u0432\u0430","elementName-structure":"\u0431\u0435\u0441\u0435\u0434\u043A\u0430/\u043F\u0430\u0432\u0438\u043B\u044C\u043E\u043D","elementName-gazebo1":"\u0433\u0430\u0437\u0435\u0431\u043E 1","elementName-pathway":"\u0434\u043E\u0440\u043E\u0433\u0430","elementName-pathway1":"\u0434\u043E\u0440\u043E\u0433\u0430 1","elementName-pathway2":"\u0434\u043E\u0440\u043E\u0433\u0430 2","elementName-pathway3":"\u0434\u043E\u0440\u043E\u0433\u0430 3","elementName-pathway4":"\u0434\u043E\u0440\u043E\u0433\u0430 4","elementName-pathway5":"\u0434\u043E\u0440\u043E\u0433\u0430 5","elementName-pathway6":"\u0434\u043E\u0440\u043E\u0433\u0430 6","elementName-pathway7":"\u0434\u043E\u0440\u043E\u0433\u0430 7","elementName-pathway8":"\u0434\u043E\u0440\u043E\u0433\u0430 8","elementName-pathway9":"\u0434\u043E\u0440\u043E\u0433\u0430 9","elementName-pathway10":"\u0434\u043E\u0440\u043E\u0433\u0430 10","elementName-pathway11":"\u0434\u043E\u0440\u043E\u0433\u0430 11","elementName-pathway12":"\u0434\u043E\u0440\u043E\u0433\u0430 12","elementName-pathway13":"\u0434\u043E\u0440\u043E\u0433\u0430 13","elementName-pathway14":"\u0434\u043E\u0440\u043E\u0433\u0430 14","elementName-court":"\u043A\u043E\u0440\u0442 ","elementName-court1":"\u043A\u043E\u0440\u0442 1","elementName-court2":"\u043A\u043E\u0440\u0442 2","elementName-hedge":"\u0436\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C","elementName-hedge1":"\u0436\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C 1","elementName-hedge2":"\u0436\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C 2","elementName-hedge3":"\u0436\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C 3","elementName-hedge4":"\u0436\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C 4","elementName-hedge5":"\u0436\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C 5","elementName-hedge6":"\u0436\u0438\u0432\u0430\u044F \u0438\u0437\u0433\u043E\u0440\u043E\u0434\u044C 6","elementName-tree1":"\u0434\u0435\u0440\u0435\u0432\u043E 1","elementName-treeapple":"\u0444\u0440\u0443\u043A\u0442\u043E\u0432\u043E\u0435 \u0434\u0435\u0440\u0435\u0432\u043E","elementName-bush3":"\u043A\u0443\u0441\u0442","elementName-bush4":"\u043A\u0443\u0441\u0442","elementName-bush6":"\u043A\u0443\u0441\u0442","elementName-bush7":"\u043A\u0443\u0441\u0442","elementName-grass_gray":"\u0441\u0435\u0440\u0430\u044F \u0442\u0440\u0430\u0432\u0430","elementName-carex":"\u043E\u0441\u043E\u043A\u0430","elementName-bushflowersorange":"\u043A\u0443\u0441\u0442 \u0441 \u043E\u0440\u0430\u043D\u0436\u0435\u0432\u044B\u043C\u0438 \u0446\u0432\u0435\u0442\u0430\u043C\u0438","elementName-bushflowersred":"\u043A\u0443\u0441\u0442 \u0441 \u043A\u0440\u0430\u0441\u043D\u044B\u043C\u0438 \u0446\u0432\u0435\u0442\u0430\u043C\u0438","elementName-boxwoodball":"\u0448\u0430\u0440","elementName-cabbage":"\u043A\u0430\u043F\u0443\u0441\u0442\u0430","elementName-carrot":"\u043C\u043E\u0440\u043A\u043E\u0432\u044C","elementName-eggplant":"\u043A\u0430\u0431\u0430\u0447\u043E\u043A","elementName-beet":"\u0441\u0432\u0435\u043A\u043B\u0430","elementName-onion":"\u043B\u0443\u043A","elementName-salad":"\u0441\u0430\u043B\u0430\u0442","elementName-waterpool1":"\u0431\u0430\u0441\u0441\u0435\u0439\u043D 1","elementName-waterpool2":"\u0431\u0430\u0441\u0441\u0435\u0439\u043D 2","elementName-waterpool3":"\u0431\u0430\u0441\u0441\u0435\u0439\u043D 3","elementName-waterpool4":"\u0431\u0430\u0441\u0441\u0435\u0439\u043D 4","elementName-waterpool5":"\u0431\u0430\u0441\u0441\u0435\u0439\u043D 5","elementName-waterpool6":"\u0431\u0430\u0441\u0441\u0435\u0439\u043D 6","elementName-waterpool7":"\u0431\u0430\u0441\u0441\u0435\u0439\u043D 7","elementName-waterpool8":"\u0431\u0430\u0441\u0441\u0435\u0439\u043D 8","elementName-waterpool9":"\u0431\u0430\u0441\u0441\u0435\u0439\u043D 9","elementName-pool":"\u0431\u0430\u0441\u0441\u0435\u0439\u043D","elementName-water":"\u0432\u043E\u0434\u043D\u044B\u0439 \u044D\u043B\u0435\u043C\u0435\u043D\u0442","elementName-fountain1":"\u0444\u043E\u043D\u0442\u0430\u043D 1","elementNamewaterfall2":"\u0432\u043E\u0434\u043E\u043F\u0430\u0434 2","elementName-stone1":"\u043A\u0430\u043C\u0435\u043D\u044C 1","elementName-stone2":"\u043A\u0430\u043C\u0435\u043D\u044C 2","elementName-stone3":"\u043A\u0430\u043C\u0435\u043D\u044C 3","elementName-stone4":"\u043A\u0430\u043C\u0435\u043D\u044C 4","elementName-flowerpot1":"\u0433\u043E\u0440\u0448\u043E\u043A \u0441 \u0446\u0432\u0435\u0442\u043A\u043E\u043C","elementName-turtle":"\u0447\u0435\u0440\u0435\u043F\u0430\u0445\u0430","elementName-car1":"\u043C\u0430\u0448\u0438\u043D\u0430","elementName-sofa1":"\u0434\u0438\u0432\u0430\u043D","elementName-chair1":"\u043A\u0440\u0435\u0441\u043B\u043E","elementName-table1":"\u0441\u0442\u043E\u043B","elementName-lampball":"\u0441\u0432\u0435\u0442\u0438\u043B\u044C\u043D\u0438\u043A \u0448\u0430\u0440","elementName-lamp":"\u0441\u0432\u0435\u0442\u0438\u043B\u044C\u043D\u0438\u043A","elementName-spotlight":"\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u0441\u0432\u0435\u0442"}');




parcelRequire("ltGt3");


function $20bc9ae7172cc79d$export$129166de1fe98653() {
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7c8a10e768eadb0$export$2d003b3d2748ba71), {
        availableElementTypes: (0, $670e204136b37e30$export$9544d5bb712b01ea).getBuildingsElementTypes()
    });
}





var $ltGt3 = parcelRequire("ltGt3");





parcelRequire("ltGt3");

function $b22cace386b16db2$export$b29681f2435a5f20({ onFilterValueSet: onFilterValueSet, filterValue: filterValue }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).Search, {
        allowClear: true,
        enterButton: intl.formatMessage({
            id: 'filter'
        }),
        onSearch: onFilterValueSet,
        defaultValue: filterValue
    });
}




parcelRequire("ltGt3");
function $80a9e843ab830944$export$22af41375a581f5d({ onFilterValueSet: onFilterValueSet, filterValue: filterValue }) {
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $878317098e859dd0$export$2e2bcd8739ae039).RangePicker, {
        allowEmpty: [
            true,
            true
        ],
        onCalendarChange: (_dayjsDates, dates)=>onFilterValueSet(dates)
    });
}







var $ltGt3 = parcelRequire("ltGt3");



function $d97f0b5be94c0670$export$6405fa88e4f48979({ routeWhenClosed: routeWhenClosed }) {
    const navigation = (0, $493cbc5b00d91baa$export$d0fd4b7106de2769)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const [isLoading, setLoading] = (0, $ltGt3.useState)(false);
    const routeParams = (0, $493cbc5b00d91baa$export$99eaa27ddbbb95ef)();
    const { mousePosition: mousePosition } = (0, $a97af2bd258d22ad$export$30c58b43fa91b94d)();
    const toDoPopupVisible = Boolean(routeParams.recordId) && !routeParams.plantId;
    const plantLoading = toDoPopupVisible && navigation.state === 'loading';
    const { plantedPlantsNamesWithId: plantedPlantsNamesWithId, userJournalEventTypes: userJournalEventTypes, userJournalEvents: userJournalEvents } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('journal');
    const recordId = Number(routeParams.recordId);
    const plantId = Number(routeParams.plantId);
    const record = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('journalRecordById');
    const onClose = ()=>navigate(routeWhenClosed);
    const closeModal = ()=>{
        navigate(routeWhenClosed);
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f189c84ec54ae7cf$export$2e2bcd8739ae039), {
        open: toDoPopupVisible,
        onCancel: onClose,
        mousePosition: mousePosition || undefined,
        footer: null,
        destroyOnHidden: true,
        width: 1000,
        loading: isLoading,
        children: record === null ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("h2", {
            children: [
                "Journal record with id ",
                recordId,
                " not found!"
            ]
        }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a8a4f61d59f3eccc$export$5fbfe03fe02b533e), {
            //currentEvent={userJournalEvents.data.find((record) => record.id === recordId)}
            currentEvent: record,
            onFormClose: closeModal,
            setLoading: setLoading,
            editable: false,
            userJournalEventTypes: userJournalEventTypes
        })
    });
}



function $6d63ee2dceea6705$export$78465ea4c1305108() {
    const { projectNames: projectNames } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('root');
    const { plantedPlantsNamesWithId: plantedPlantsNamesWithId, userJournalEventTypes: userJournalEventTypes, userJournalEvents: userJournalEvents, tableParams: tableParams } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('journal');
    const [openFormState, setOpenFormState] = (0, $ltGt3.useState)(false);
    const [currentRecord, setCurrentRecord] = (0, $ltGt3.useState)(null);
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const { setMousePosition: setMousePosition } = (0, $a97af2bd258d22ad$export$30c58b43fa91b94d)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const [searchParams, setSearchParams] = (0, $6816d30a3e97278a$export$f1a78c17382fe22a)();
    const location = (0, $493cbc5b00d91baa$export$45d76561a5302f2b)();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const columns = [
        {
            title: intl.formatMessage({
                id: 'type'
            }),
            dataIndex: 'type',
            key: 'type',
            sorter: true,
            sortDirections: [
                'ascend',
                'descend',
                null
            ],
            render: (type)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                    children: type ? `${(0, $6dfc071b399cc1b6$export$43852040ec70d1af)(type).icon} ${type.type === 'custom' ? (0, $6dfc071b399cc1b6$export$43852040ec70d1af)(type).name : intl.formatMessage({
                        id: `eventType-${(0, $6dfc071b399cc1b6$export$43852040ec70d1af)(type).name}`
                    })}` : ''
                }),
            filters: [
                ...Object.entries((0, $6dfc071b399cc1b6$export$84362538fd926f28)).map(([key, meta])=>({
                        value: key,
                        text: `${meta.icon} ${intl.formatMessage({
                            id: `eventType-${meta.name}`
                        })}`
                    })),
                ...userJournalEventTypes.map((userType, key)=>({
                        value: userType.type === 'custom' ? userType.customJournalEventType.id : key,
                        text: `${userType.customJournalEventType.icon} ${userType.customJournalEventType.name}`
                    }))
            ]
        },
        {
            title: intl.formatMessage({
                id: 'eventEndDate'
            }),
            dataIndex: 'actualCompletionDateUtc',
            key: 'actualCompletionDateUtc',
            sorter: true,
            sortDirections: [
                'ascend',
                'descend',
                null
            ],
            render: (value)=>value ? String(value) : '',
            filterDropdown: ({ setSelectedKeys: setSelectedKeys, selectedKeys: selectedKeys, confirm: confirm, clearFilters: clearFilters, close: close })=>{
                return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    style: {
                        padding: 8
                    },
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $80a9e843ab830944$export$22af41375a581f5d), {
                        filterValue: selectedKeys[0],
                        onFilterValueSet: ([startDate, endDate])=>{
                            if (!startDate && !endDate) {
                                clearFilters();
                                confirm();
                            } else {
                                setSelectedKeys([
                                    startDate,
                                    endDate
                                ]);
                                confirm();
                            }
                        }
                    })
                });
            },
            filterIcon: (filtered)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $8397f586b179aba6$export$2e2bcd8739ae039), {
                    style: {
                        color: filtered ? '#1677ff' : undefined
                    }
                })
        },
        {
            title: intl.formatMessage({
                id: 'plant'
            }),
            dataIndex: [
                'plant',
                'name'
            ],
            sorter: true,
            sortDirections: [
                'ascend',
                'descend',
                null
            ],
            key: 'plant',
            render: (plant)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                    children: plant ? plant : ''
                }),
            filterDropdown: ({ setSelectedKeys: setSelectedKeys, selectedKeys: selectedKeys, confirm: confirm, clearFilters: clearFilters, close: close })=>{
                return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                    style: {
                        padding: 8
                    },
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b22cace386b16db2$export$b29681f2435a5f20), {
                        filterValue: selectedKeys[0],
                        onFilterValueSet: (value)=>{
                            if (value === '') {
                                clearFilters();
                                confirm();
                            } else {
                                setSelectedKeys([
                                    value
                                ]);
                                confirm();
                            }
                        }
                    })
                });
            },
            filterIcon: (filtered)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $8397f586b179aba6$export$2e2bcd8739ae039), {
                    style: {
                        color: filtered ? '#1677ff' : undefined
                    }
                })
        },
        {
            title: intl.formatMessage({
                id: 'comment'
            }),
            dataIndex: 'comment',
            key: 'comment'
        }
    ];
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                    children: intl.formatMessage({
                        id: 'gardenJournal'
                    })
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $78bdab97c3b51c4b$export$2e2bcd8739ae039), {
                        rowKey: "id",
                        dataSource: userJournalEvents.data,
                        columns: columns.map((column)=>({
                                ...column,
                                sortOrder: tableParams.sortField === column.key ? tableParams.sortOrder === 'asc' ? 'ascend' : 'descend' : null
                            })),
                        onChange: (tableParams, filters, sorter)=>{
                            const page = tableParams.current;
                            const perPage = tableParams.pageSize;
                            const newSearchParams = new URLSearchParams();
                            if (page !== 1) newSearchParams.set('page', String(page));
                            if (perPage !== 10) newSearchParams.set('perPage', String(perPage));
                            const filter = {
                                actualCompletionDateUtc: filters.actualCompletionDateUtc ? {
                                    startDate: filters.actualCompletionDateUtc[0] ? new Date(filters.actualCompletionDateUtc[0]) : undefined,
                                    endDate: filters.actualCompletionDateUtc[1] ? new Date(filters.actualCompletionDateUtc[1]) : undefined
                                } : undefined,
                                eventType: filters.type?.length > 0 ? filters.type : undefined,
                                plant: filters.plant ? filters.plant[0] : undefined,
                                project: filters.project?.length > 0 ? filters.project : undefined
                            };
                            const filterJson = JSON.stringify(filter);
                            if (filterJson !== '{}') newSearchParams.set('filter', filterJson);
                            const sortConfig = Array.isArray(sorter) ? sorter[0] : sorter;
                            const sortField = sortConfig.columnKey;
                            const sortOrder = sortConfig.order;
                            if (sortOrder && sortField) {
                                newSearchParams.set('sortOrder', sortOrder === 'ascend' ? 'asc' : 'desc');
                                newSearchParams.set('sortField', String(sortField));
                            }
                            setSearchParams(newSearchParams);
                        },
                        pagination: {
                            pageSize: tableParams.perPage,
                            current: tableParams.page,
                            total: userJournalEvents.count,
                            showSizeChanger: true
                        },
                        scroll: {
                            x: 'max-content'
                        },
                        onRow: (record)=>({
                                onClick: (e)=>{
                                    setMousePosition({
                                        x: e.pageX,
                                        y: e.pageY
                                    });
                                    //setOpenFormState(true)
                                    navigate(`${record.id}` + location.search);
                                    setCurrentRecord(record);
                                }
                            })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d97f0b5be94c0670$export$6405fa88e4f48979), {
                        routeWhenClosed: '/journal' + location.search
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7c982b663463d13d$export$9037afc3347b6505), {
                        routeWhenClosed: `/journal` + location.search
                    })
                ]
            })
        ]
    });
}



parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");










var $ltGt3 = parcelRequire("ltGt3");












var $ltGt3 = parcelRequire("ltGt3");
var $fe7572fe45be224e$var$initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
};
var $fe7572fe45be224e$export$2e2bcd8739ae039 = $fe7572fe45be224e$var$initialState;






var $ltGt3 = parcelRequire("ltGt3");

var $ltGt3 = parcelRequire("ltGt3");
var $665d89af0f094860$var$defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("ul", {
            style: {
                display: "block"
            }
        }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true,
    asNavFor: null
};
var $665d89af0f094860$export$2e2bcd8739ae039 = $665d89af0f094860$var$defaultProps;


function $ac430e59d4178fe3$export$7d15b64cf5a3a4c4(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
}
var $ac430e59d4178fe3$export$ed7b1178205ba7d = function safePreventDefault(event) {
    var passiveEvents = [
        "onTouchStart",
        "onTouchMove",
        "onWheel"
    ];
    if (!passiveEvents.includes(event._reactName)) event.preventDefault();
};
var $ac430e59d4178fe3$export$62701ea96990f316 = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = $ac430e59d4178fe3$export$8931689ba1e6a542(spec);
    var endIndex = $ac430e59d4178fe3$export$fc4e3e46621b5503(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)if (spec.lazyLoadedList.indexOf(slideIndex) < 0) onDemandSlides.push(slideIndex);
    return onDemandSlides;
};
var $ac430e59d4178fe3$export$61de20028e4bc291 = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = $ac430e59d4178fe3$export$8931689ba1e6a542(spec);
    var endIndex = $ac430e59d4178fe3$export$fc4e3e46621b5503(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)requiredSlides.push(slideIndex);
    return requiredSlides;
};
var $ac430e59d4178fe3$export$8931689ba1e6a542 = function lazyStartIndex(spec) {
    return spec.currentSlide - $ac430e59d4178fe3$export$2c85b0e65618cf24(spec);
};
var $ac430e59d4178fe3$export$fc4e3e46621b5503 = function lazyEndIndex(spec) {
    return spec.currentSlide + $ac430e59d4178fe3$export$d4d84a0677f3a05c(spec);
};
var $ac430e59d4178fe3$export$2c85b0e65618cf24 = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var $ac430e59d4178fe3$export$d4d84a0677f3a05c = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};
var $ac430e59d4178fe3$export$3c49c185de0c2bfc = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
};
var $ac430e59d4178fe3$export$c08559766941f856 = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
};
var $ac430e59d4178fe3$export$67fc172604a155ba = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) return "left";
    if (swipeAngle >= 135 && swipeAngle <= 225) return "right";
    if (verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) return "up";
        else return "down";
    }
    return "vertical";
};
var $ac430e59d4178fe3$export$30e977044f8f3618 = function canGoNext(spec) {
    var canGo = true;
    if (!spec.infinite) {
        if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) canGo = false;
        else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) canGo = false;
    }
    return canGo;
};
var $ac430e59d4178fe3$export$e9dd1a4ab6b7c5b0 = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
        return newObject[key] = spec[key];
    });
    return newObject;
};
var $ac430e59d4178fe3$export$446226dbc576c3ab = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil($ac430e59d4178fe3$export$3c49c185de0c2bfc(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil($ac430e59d4178fe3$export$3c49c185de0c2bfc(trackNode));
    var slideWidth;
    if (!spec.vertical) {
        var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
        if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") centerPaddingAdj *= listWidth / 100;
        slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else slideWidth = listWidth;
    var slideHeight = listNode && $ac430e59d4178fe3$export$c08559766941f856(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === undefined) currentSlide = slideCount - 1 - spec.initialSlide;
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = $ac430e59d4178fe3$export$62701ea96990f316((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
        currentSlide: currentSlide,
        lazyLoadedList: lazyLoadedList
    }));
    lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
    var state = {
        slideCount: slideCount,
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth,
        currentSlide: currentSlide,
        slideHeight: slideHeight,
        listHeight: listHeight,
        lazyLoadedList: lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) state["autoplaying"] = "playing";
    return state;
};
var $ac430e59d4178fe3$export$961f912fd58954b = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    var lazyLoadedList = spec.lazyLoadedList;
    if (waitForAnimate && animating) return {};
    var animationSlide = index, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index : $ac430e59d4178fe3$export$7d15b64cf5a3a4c4(index, 0, slideCount - 1);
    if (fade) {
        if (!infinite && (index < 0 || index >= slideCount)) return {};
        if (index < 0) animationSlide = index + slideCount;
        else if (index >= slideCount) animationSlide = index - slideCount;
        if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) lazyLoadedList = lazyLoadedList.concat(animationSlide);
        state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList,
            targetSlide: animationSlide
        };
        nextState = {
            animating: false,
            targetSlide: animationSlide
        };
    } else {
        finalSlide = animationSlide;
        if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;
            else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
        } else if (!$ac430e59d4178fe3$export$30e977044f8f3618(spec) && animationSlide > currentSlide) animationSlide = finalSlide = currentSlide;
        else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
        } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;
            else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
        }
        if (!infinite && animationSlide + slidesToShow >= slideCount) finalSlide = slideCount - slidesToShow;
        animationLeft = $ac430e59d4178fe3$export$e6afb656f970c8d4((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
            slideIndex: animationSlide
        }));
        finalLeft = $ac430e59d4178fe3$export$e6afb656f970c8d4((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
            slideIndex: finalSlide
        }));
        if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
        }
        if (lazyLoad) lazyLoadedList = lazyLoadedList.concat($ac430e59d4178fe3$export$62701ea96990f316((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
            currentSlide: animationSlide
        })));
        if (!useCSS) state = {
            currentSlide: finalSlide,
            trackStyle: $ac430e59d4178fe3$export$a56204438fe3ba9e((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
                left: finalLeft
            })),
            lazyLoadedList: lazyLoadedList,
            targetSlide: targetSlide
        };
        else {
            state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: $ac430e59d4178fe3$export$529c0c74aae30645((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
                    left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList,
                targetSlide: targetSlide
            };
            nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: $ac430e59d4178fe3$export$a56204438fe3ba9e((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
                    left: finalLeft
                })),
                swipeLeft: null,
                targetSlide: targetSlide
            };
        }
    }
    return {
        state: state,
        nextState: nextState
    };
};
var $ac430e59d4178fe3$export$2b178751aa586095 = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
        slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
        if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
        }
        if (!infinite) targetSlide = previousTargetSlide - slidesToScroll;
    } else if (options.message === "next") {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
        if (lazyLoad && !infinite) targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
        if (!infinite) targetSlide = previousTargetSlide + slidesToScroll;
    } else if (options.message === "dots") // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    else if (options.message === "children") {
        // Click on the slides
        targetSlide = options.index;
        if (infinite) {
            var direction = $ac430e59d4178fe3$export$660692989fc3ca25((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
                targetSlide: targetSlide
            }));
            if (targetSlide > options.currentSlide && direction === "left") targetSlide = targetSlide - slideCount;
            else if (targetSlide < options.currentSlide && direction === "right") targetSlide = targetSlide + slideCount;
        }
    } else if (options.message === "index") targetSlide = Number(options.index);
    return targetSlide;
};
var $ac430e59d4178fe3$export$53be3f01be2e49ac = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
};
var $ac430e59d4178fe3$export$517240397a2d6b8e = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && $ac430e59d4178fe3$export$ed7b1178205ba7d(e);
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
        dragging: true,
        touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
        }
    };
};
var $ac430e59d4178fe3$export$b6bbad7797799ea9 = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return $ac430e59d4178fe3$export$ed7b1178205ba7d(e);
    if (vertical && swipeToSlide && verticalSwiping) $ac430e59d4178fe3$export$ed7b1178205ba7d(e);
    var swipeLeft, state = {};
    var curLeft = $ac430e59d4178fe3$export$e6afb656f970c8d4(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) return {
        scrolling: true
    };
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = $ac430e59d4178fe3$export$67fc172604a155ba(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
        if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !$ac430e59d4178fe3$export$30e977044f8f3618(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;
            if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state["edgeDragged"] = true;
            }
        }
    }
    if (!swiped && swipeEvent) {
        swipeEvent(swipeDirection);
        state["swiped"] = true;
    }
    if (!vertical) {
        if (!rtl) swipeLeft = curLeft + touchSwipeLength * positionOffset;
        else swipeLeft = curLeft - touchSwipeLength * positionOffset;
    } else swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    if (verticalSwiping) swipeLeft = curLeft + touchSwipeLength * positionOffset;
    state = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, state), {}, {
        touchObject: touchObject,
        swipeLeft: swipeLeft,
        trackStyle: $ac430e59d4178fe3$export$a56204438fe3ba9e((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
            left: swipeLeft
        }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) return state;
    if (touchObject.swipeLength > 10) {
        state["swiping"] = true;
        $ac430e59d4178fe3$export$ed7b1178205ba7d(e);
    }
    return state;
};
var $ac430e59d4178fe3$export$a1cf77dc3a4b9ee0 = function swipeEnd(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
        if (swipe) $ac430e59d4178fe3$export$ed7b1178205ba7d(e);
        return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = $ac430e59d4178fe3$export$67fc172604a155ba(touchObject, verticalSwiping);
    // reset the state of touch related state variables.
    var state = {
        dragging: false,
        edgeDragged: false,
        scrolling: false,
        swiping: false,
        swiped: false,
        swipeLeft: null,
        touchObject: {}
    };
    if (scrolling) return state;
    if (!touchObject.swipeLength) return state;
    if (touchObject.swipeLength > minSwipe) {
        $ac430e59d4178fe3$export$ed7b1178205ba7d(e);
        if (onSwipe) onSwipe(swipeDirection);
        var slideCount, newSlide;
        var activeSlide = infinite ? currentSlide : targetSlide;
        switch(swipeDirection){
            case "left":
            case "up":
                newSlide = activeSlide + $ac430e59d4178fe3$export$d5dbde6ad0a0e1f2(spec);
                slideCount = swipeToSlide ? $ac430e59d4178fe3$export$17fa202e6fecedb5(spec, newSlide) : newSlide;
                state["currentDirection"] = 0;
                break;
            case "right":
            case "down":
                newSlide = activeSlide - $ac430e59d4178fe3$export$d5dbde6ad0a0e1f2(spec);
                slideCount = swipeToSlide ? $ac430e59d4178fe3$export$17fa202e6fecedb5(spec, newSlide) : newSlide;
                state["currentDirection"] = 1;
                break;
            default:
                slideCount = activeSlide;
        }
        state["triggerSlideHandler"] = slideCount;
    } else {
        // Adjust the track back to it's original position.
        var currentLeft = $ac430e59d4178fe3$export$e6afb656f970c8d4(spec);
        state["trackStyle"] = $ac430e59d4178fe3$export$529c0c74aae30645((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
            left: currentLeft
        }));
    }
    return state;
};
var $ac430e59d4178fe3$export$51be2376bcc08466 = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while(breakpoint < max){
        indexes.push(breakpoint);
        breakpoint = counter + spec.slidesToScroll;
        counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
};
var $ac430e59d4178fe3$export$17fa202e6fecedb5 = function checkNavigable(spec, index) {
    var navigables = $ac430e59d4178fe3$export$51be2376bcc08466(spec);
    var prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
    else for(var n in navigables){
        if (index < navigables[n]) {
            index = prevNavigable;
            break;
        }
        prevNavigable = navigables[n];
    }
    return index;
};
var $ac430e59d4178fe3$export$d5dbde6ad0a0e1f2 = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
        var swipedSlide;
        var slickList = spec.listRef;
        var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
        Array.from(slides).every(function(slide) {
            if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + $ac430e59d4178fe3$export$3c49c185de0c2bfc(slide) / 2 > spec.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            } else if (slide.offsetTop + $ac430e59d4178fe3$export$c08559766941f856(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
            }
            return true;
        });
        if (!swipedSlide) return 0;
        var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
        var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
        return slidesTraversed;
    } else return spec.slidesToScroll;
};
var $ac430e59d4178fe3$export$86da4920db51899b = function checkSpecKeys(spec, keysArray) {
    return(// eslint-disable-next-line no-prototype-builtins
    keysArray.reduce(function(value, key) {
        return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec));
};
var $ac430e59d4178fe3$export$a56204438fe3ba9e = function getTrackCSS(spec) {
    $ac430e59d4178fe3$export$86da4920db51899b(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth"
    ]);
    var trackWidth, trackHeight;
    if (!spec.vertical) trackWidth = $ac430e59d4178fe3$export$f865154a8ab21780(spec) * spec.slideWidth;
    else {
        var trackChildren = spec.unslick ? spec.slideCount : spec.slideCount + 2 * spec.slidesToShow;
        trackHeight = trackChildren * spec.slideHeight;
    }
    var style = {
        opacity: 1,
        transition: "",
        WebkitTransition: ""
    };
    if (spec.useTransform) {
        var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
        style = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, style), {}, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
        });
    } else if (spec.vertical) style["top"] = spec.left;
    else style["left"] = spec.left;
    if (spec.fade) style = {
        opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight;
    // Fallback for IE8
    if (window && !window.addEventListener && window.attachEvent) {
        if (!spec.vertical) style.marginLeft = spec.left + "px";
        else style.marginTop = spec.left + "px";
    }
    return style;
};
var $ac430e59d4178fe3$export$529c0c74aae30645 = function getTrackAnimateCSS(spec) {
    $ac430e59d4178fe3$export$86da4920db51899b(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth",
        "speed",
        "cssEase"
    ]);
    var style = $ac430e59d4178fe3$export$a56204438fe3ba9e(spec);
    // useCSS is true by default so it can be undefined
    if (spec.useTransform) {
        style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
        style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else if (spec.vertical) style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    else style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    return style;
};
var $ac430e59d4178fe3$export$e6afb656f970c8d4 = function getTrackLeft(spec) {
    if (spec.unslick) return 0;
    $ac430e59d4178fe3$export$86da4920db51899b(spec, [
        "slideIndex",
        "trackRef",
        "infinite",
        "centerMode",
        "slideCount",
        "slidesToShow",
        "slidesToScroll",
        "slideWidth",
        "listWidth",
        "variableWidth",
        "slideHeight"
    ]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) return 0;
    var slidesToOffset = 0;
    if (infinite) {
        slidesToOffset = -$ac430e59d4178fe3$export$b7c426bbf733f421(spec); // bring active slide to the beginning of visual area
        // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
        // shift current slide to center of the frame
        if (centerMode) slidesToOffset += parseInt(slidesToShow / 2);
    } else {
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = slidesToShow - slideCount % slidesToScroll;
        if (centerMode) slidesToOffset = parseInt(slidesToShow / 2);
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    else targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    if (variableWidth === true) {
        var targetSlideIndex;
        var trackElem = trackRef && trackRef.node;
        targetSlideIndex = slideIndex + $ac430e59d4178fe3$export$b7c426bbf733f421(spec);
        targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
        targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + $ac430e59d4178fe3$export$b7c426bbf733f421(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;
            for(var slide = 0; slide < targetSlideIndex; slide++)targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
        }
    }
    return targetLeft;
};
var $ac430e59d4178fe3$export$b7c426bbf733f421 = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var $ac430e59d4178fe3$export$50a387a8fd3c60d = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    return spec.slideCount;
};
var $ac430e59d4178fe3$export$f865154a8ab21780 = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : $ac430e59d4178fe3$export$b7c426bbf733f421(spec) + spec.slideCount + $ac430e59d4178fe3$export$50a387a8fd3c60d(spec);
};
var $ac430e59d4178fe3$export$660692989fc3ca25 = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
        if (spec.targetSlide > spec.currentSlide + $ac430e59d4178fe3$export$10cb311a34b9e55b(spec)) return "left";
        return "right";
    } else {
        if (spec.targetSlide < spec.currentSlide - $ac430e59d4178fe3$export$56584c3df96565e5(spec)) return "right";
        return "left";
    }
};
var $ac430e59d4178fe3$export$10cb311a34b9e55b = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    // returns no of slides on the right of active slide
    if (centerMode) {
        var right = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) right += 1;
        if (rtl && slidesToShow % 2 === 0) right += 1;
        return right;
    }
    if (rtl) return 0;
    return slidesToShow - 1;
};
var $ac430e59d4178fe3$export$56584c3df96565e5 = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    // returns no of slides on the left of active slide
    if (centerMode) {
        var left = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) left += 1;
        if (!rtl && slidesToShow % 2 === 0) left += 1;
        return left;
    }
    if (rtl) return slidesToShow - 1;
    return 0;
};
var $ac430e59d4178fe3$export$71594e8a50f746f4 = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
var $ac430e59d4178fe3$export$dbd19fc785436235 = Object.keys((0, $665d89af0f094860$export$2e2bcd8739ae039));
function $ac430e59d4178fe3$export$b01d4e122f0895e5(settings) {
    return $ac430e59d4178fe3$export$dbd19fc785436235.reduce(function(acc, settingName) {
        if (settings.hasOwnProperty(settingName)) acc[settingName] = settings[settingName];
        return acc;
    }, {});
}












var $ltGt3 = parcelRequire("ltGt3");


"use strict";
function $10d18c737c715c2b$var$_callSuper(t, o, e) {
    return o = (0, $842b6e0da6891434$export$2e2bcd8739ae039)(o), (0, $72c3cf5bc8600437$export$2e2bcd8739ae039)(t, (0, $d3a6f09ccec9fd7e$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $842b6e0da6891434$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var $10d18c737c715c2b$var$getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;
    if (spec.rtl) index = spec.slideCount - 1 - spec.index;
    else index = spec.index;
    slickCloned = index < 0 || index >= spec.slideCount;
    if (spec.centerMode) {
        centerOffset = Math.floor(spec.slidesToShow / 2);
        slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
        if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) slickActive = true;
    } else slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    var focusedSlide;
    if (spec.targetSlide < 0) focusedSlide = spec.targetSlide + spec.slideCount;
    else if (spec.targetSlide >= spec.slideCount) focusedSlide = spec.targetSlide - spec.slideCount;
    else focusedSlide = spec.targetSlide;
    var slickCurrent = index === focusedSlide;
    return {
        "slick-slide": true,
        "slick-active": slickActive,
        "slick-center": slickCenter,
        "slick-cloned": slickCloned,
        "slick-current": slickCurrent // dubious in case of RTL
    };
};
var $10d18c737c715c2b$var$getSlideStyle = function getSlideStyle(spec) {
    var style = {};
    if (spec.variableWidth === undefined || spec.variableWidth === false) style.width = spec.slideWidth;
    if (spec.fade) {
        style.position = "relative";
        if (spec.vertical && spec.slideHeight) style.top = -spec.index * parseInt(spec.slideHeight);
        else style.left = -spec.index * parseInt(spec.slideWidth);
        style.opacity = spec.currentSlide === spec.index ? 1 : 0;
        style.zIndex = spec.currentSlide === spec.index ? 999 : 998;
        if (spec.useCSS) style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
    return style;
};
var $10d18c737c715c2b$var$getKey = function getKey(child, fallbackKey) {
    return child.key + "-" + fallbackKey;
};
var $10d18c737c715c2b$var$renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.count(spec.children);
    var startIndex = (0, $ac430e59d4178fe3$export$8931689ba1e6a542)(spec);
    var endIndex = (0, $ac430e59d4178fe3$export$fc4e3e46621b5503)(spec);
    (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.forEach(spec.children, function(elem, index) {
        var child;
        var childOnClickOptions = {
            message: "children",
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
        };
        // in case of lazyLoad, whether or not we want to fetch the slide
        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) child = elem;
        else child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", null);
        var childStyle = $10d18c737c715c2b$var$getSlideStyle((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
            index: index
        }));
        var slideClass = child.props.className || "";
        var slideClasses = $10d18c737c715c2b$var$getSlideClasses((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
            index: index
        }));
        // push a cloned element of the desired slide
        slides.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(child, {
            key: "original" + $10d18c737c715c2b$var$getKey(child, index),
            "data-index": index,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(slideClasses, slideClass),
            tabIndex: "-1",
            "aria-hidden": !slideClasses["slick-active"],
            style: (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({
                outline: "none"
            }, child.props.style || {}), childStyle),
            onClick: function onClick(e) {
                child.props && child.props.onClick && child.props.onClick(e);
                if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
            }
        }));
        // if slide needs to be precloned or postcloned
        if (spec.infinite && childrenCount > 1 && spec.fade === false && !spec.unslick) {
            var preCloneNo = childrenCount - index;
            if (preCloneNo <= (0, $ac430e59d4178fe3$export$b7c426bbf733f421)(spec)) {
                key = -preCloneNo;
                if (key >= startIndex) child = elem;
                slideClasses = $10d18c737c715c2b$var$getSlideClasses((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
                    index: key
                }));
                preCloneSlides.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(child, {
                    key: "precloned" + $10d18c737c715c2b$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
            key = childrenCount + index;
            if (key < endIndex) child = elem;
            slideClasses = $10d18c737c715c2b$var$getSlideClasses((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
                index: key
            }));
            postCloneSlides.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(child, {
                key: "postcloned" + $10d18c737c715c2b$var$getKey(child, key),
                "data-index": key,
                tabIndex: "-1",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(slideClasses, slideClass),
                "aria-hidden": !slideClasses["slick-active"],
                style: (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, child.props.style || {}), childStyle),
                onClick: function onClick(e) {
                    child.props && child.props.onClick && child.props.onClick(e);
                    if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                }
            }));
        }
    });
    if (spec.rtl) return preCloneSlides.concat(slides, postCloneSlides).reverse();
    else return preCloneSlides.concat(slides, postCloneSlides);
};
var $10d18c737c715c2b$export$13921ac0cc260818 = /*#__PURE__*/ function(_React$PureComponent) {
    function Track() {
        var _this;
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, Track);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $10d18c737c715c2b$var$_callSuper(this, Track, [].concat(args));
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "node", null);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "handleRef", function(ref) {
            _this.node = ref;
        });
        return _this;
    }
    (0, $56605f2979837676$export$2e2bcd8739ae039)(Track, _React$PureComponent);
    return (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(Track, [
        {
            key: "render",
            value: function render() {
                var slides = $10d18c737c715c2b$var$renderSlides(this.props);
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
                    ref: this.handleRef,
                    className: "slick-track",
                    style: this.props.trackStyle
                }, mouseEvents), slides);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).PureComponent);










var $ltGt3 = parcelRequire("ltGt3");


"use strict";
function $8dcb1bb217cfb83a$var$_callSuper(t, o, e) {
    return o = (0, $842b6e0da6891434$export$2e2bcd8739ae039)(o), (0, $72c3cf5bc8600437$export$2e2bcd8739ae039)(t, (0, $d3a6f09ccec9fd7e$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $842b6e0da6891434$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
var $8dcb1bb217cfb83a$var$getDotCount = function getDotCount(spec) {
    var dots;
    if (spec.infinite) dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    else dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    return dots;
};
var $8dcb1bb217cfb83a$export$8da50d3722682be0 = /*#__PURE__*/ function(_React$PureComponent) {
    function Dots() {
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, Dots);
        return $8dcb1bb217cfb83a$var$_callSuper(this, Dots, arguments);
    }
    (0, $56605f2979837676$export$2e2bcd8739ae039)(Dots, _React$PureComponent);
    return (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(Dots, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                // In Autoplay the focus stays on clicked button even after transition
                // to next slide. That only goes away by click somewhere outside
                e.preventDefault();
                this.props.clickHandler(options);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
                var dotCount = $8dcb1bb217cfb83a$var$getDotCount({
                    slideCount: slideCount,
                    slidesToScroll: slidesToScroll,
                    slidesToShow: slidesToShow,
                    infinite: infinite
                });
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                var dots = [];
                for(var i = 0; i < dotCount; i++){
                    var _rightBound = (i + 1) * slidesToScroll - 1;
                    var rightBound = infinite ? _rightBound : (0, $ac430e59d4178fe3$export$7d15b64cf5a3a4c4)(_rightBound, 0, slideCount - 1);
                    var _leftBound = rightBound - (slidesToScroll - 1);
                    var leftBound = infinite ? _leftBound : (0, $ac430e59d4178fe3$export$7d15b64cf5a3a4c4)(_leftBound, 0, slideCount - 1);
                    var className = (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))({
                        "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
                    });
                    var dotOptions = {
                        message: "dots",
                        index: i,
                        slidesToScroll: slidesToScroll,
                        currentSlide: currentSlide
                    };
                    var onClick = this.clickHandler.bind(this, dotOptions);
                    dots = dots.concat(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("li", {
                        key: i,
                        className: className
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(this.props.customPaging(i), {
                        onClick: onClick
                    })));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(this.props.appendDots(dots), (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({
                    className: this.props.dotsClass
                }, mouseEvents));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).PureComponent);











var $ltGt3 = parcelRequire("ltGt3");


"use strict";
function $7714cfbbbc039618$var$_callSuper(t, o, e) {
    return o = (0, $842b6e0da6891434$export$2e2bcd8739ae039)(o), (0, $72c3cf5bc8600437$export$2e2bcd8739ae039)(t, (0, $d3a6f09ccec9fd7e$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $842b6e0da6891434$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
var $7714cfbbbc039618$export$9c1f62bf9cbb344b = /*#__PURE__*/ function(_React$PureComponent) {
    function PrevArrow() {
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, PrevArrow);
        return $7714cfbbbc039618$var$_callSuper(this, PrevArrow, arguments);
    }
    (0, $56605f2979837676$export$2e2bcd8739ae039)(PrevArrow, _React$PureComponent);
    return (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(PrevArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var prevClasses = {
                    "slick-arrow": true,
                    "slick-prev": true
                };
                var prevHandler = this.clickHandler.bind(this, {
                    message: "previous"
                });
                if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
                    prevClasses["slick-disabled"] = true;
                    prevHandler = null;
                }
                var prevArrowProps = {
                    key: "0",
                    "data-role": "none",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(prevClasses),
                    style: {
                        display: "block"
                    },
                    onClick: prevHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var prevArrow;
                if (this.props.prevArrow) prevArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(this.props.prevArrow, (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, prevArrowProps), customProps));
                else prevArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("button", (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
                    key: "0",
                    type: "button"
                }, prevArrowProps), " ", "Previous");
                return prevArrow;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).PureComponent);
var $7714cfbbbc039618$export$40405f1f48d6dbd = /*#__PURE__*/ function(_React$PureComponent2) {
    function NextArrow() {
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, NextArrow);
        return $7714cfbbbc039618$var$_callSuper(this, NextArrow, arguments);
    }
    (0, $56605f2979837676$export$2e2bcd8739ae039)(NextArrow, _React$PureComponent2);
    return (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(NextArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var nextClasses = {
                    "slick-arrow": true,
                    "slick-next": true
                };
                var nextHandler = this.clickHandler.bind(this, {
                    message: "next"
                });
                if (!(0, $ac430e59d4178fe3$export$30e977044f8f3618)(this.props)) {
                    nextClasses["slick-disabled"] = true;
                    nextHandler = null;
                }
                var nextArrowProps = {
                    key: "1",
                    "data-role": "none",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))(nextClasses),
                    style: {
                        display: "block"
                    },
                    onClick: nextHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var nextArrow;
                if (this.props.nextArrow) nextArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(this.props.nextArrow, (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, nextArrowProps), customProps));
                else nextArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("button", (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
                    key: "1",
                    type: "button"
                }, nextArrowProps), " ", "Next");
                return nextArrow;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).PureComponent);



"use strict";
var $091dbe8b71d86cf9$var$_excluded = [
    "animating"
];
function $091dbe8b71d86cf9$var$_callSuper(t, o, e) {
    return o = (0, $842b6e0da6891434$export$2e2bcd8739ae039)(o), (0, $72c3cf5bc8600437$export$2e2bcd8739ae039)(t, (0, $d3a6f09ccec9fd7e$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $842b6e0da6891434$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
var $091dbe8b71d86cf9$export$14a303763f47951d = /*#__PURE__*/ function(_React$Component) {
    function InnerSlider(props) {
        var _this;
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, InnerSlider);
        _this = $091dbe8b71d86cf9$var$_callSuper(this, InnerSlider, [
            props
        ]);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "listRefHandler", function(ref) {
            return _this.list = ref;
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "trackRefHandler", function(ref) {
            return _this.track = ref;
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "adaptHeight", function() {
            if (_this.props.adaptiveHeight && _this.list) {
                var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
                _this.list.style.height = (0, $ac430e59d4178fe3$export$c08559766941f856)(elem) + "px";
            }
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "componentDidMount", function() {
            _this.props.onInit && _this.props.onInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $ac430e59d4178fe3$export$62701ea96990f316)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            var spec = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props);
            _this.updateState(spec, true, function() {
                _this.adaptHeight();
                _this.props.autoplay && _this.autoPlay("playing");
            });
            if (_this.props.lazyLoad === "progressive") _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            _this.ro = new (0, $abb744758b801129$export$2e2bcd8739ae039)(function() {
                if (_this.state.animating) {
                    _this.onWindowResized(false); // don't set trackStyle hence don't break animation
                    _this.callbackTimers.push(setTimeout(function() {
                        return _this.onWindowResized();
                    }, _this.props.speed));
                } else _this.onWindowResized();
            });
            _this.ro.observe(_this.list);
            document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
                slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
                slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            });
            if (window.addEventListener) window.addEventListener("resize", _this.onWindowResized);
            else window.attachEvent("onresize", _this.onWindowResized);
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "componentWillUnmount", function() {
            if (_this.animationEndCallback) clearTimeout(_this.animationEndCallback);
            if (_this.lazyLoadTimer) clearInterval(_this.lazyLoadTimer);
            if (_this.callbackTimers.length) {
                _this.callbackTimers.forEach(function(timer) {
                    return clearTimeout(timer);
                });
                _this.callbackTimers = [];
            }
            if (window.addEventListener) window.removeEventListener("resize", _this.onWindowResized);
            else window.detachEvent("onresize", _this.onWindowResized);
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            _this.ro.disconnect();
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "componentDidUpdate", function(prevProps) {
            _this.checkImagesLoad();
            _this.props.onReInit && _this.props.onReInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $ac430e59d4178fe3$export$62701ea96990f316)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }
            _this.adaptHeight();
            var spec = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            var setTrackStyle = _this.didPropsChange(prevProps);
            setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
                if (_this.state.currentSlide >= (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.count(_this.props.children)) _this.changeSlide({
                    message: "index",
                    index: (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.count(_this.props.children) - _this.props.slidesToShow,
                    currentSlide: _this.state.currentSlide
                });
                if (prevProps.autoplay !== _this.props.autoplay || prevProps.autoplaySpeed !== _this.props.autoplaySpeed) {
                    if (!prevProps.autoplay && _this.props.autoplay) _this.autoPlay("playing");
                    else if (_this.props.autoplay) _this.autoPlay("update");
                    else _this.pause("paused");
                }
            });
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "onWindowResized", function(setTrackStyle) {
            if (_this.debouncedResize) _this.debouncedResize.cancel();
            _this.debouncedResize = (0, $ce01a065a9be66f3$export$61fc7d43ac8f84b0)(50, function() {
                return _this.resizeWindow(setTrackStyle);
            });
            _this.debouncedResize();
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "resizeWindow", function() {
            var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var isTrackMounted = Boolean(_this.track && _this.track.node);
            // prevent warning: setting state on unmounted component (server side rendering)
            if (!isTrackMounted) return;
            var spec = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            _this.updateState(spec, setTrackStyle, function() {
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
            // animating state should be cleared while resizing, otherwise autoplay stops working
            _this.setState({
                animating: false
            });
            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "updateState", function(spec, setTrackStyle, callback) {
            var updatedState = (0, $ac430e59d4178fe3$export$446226dbc576c3ab)(spec);
            spec = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), updatedState), {}, {
                slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, $ac430e59d4178fe3$export$e6afb656f970c8d4)(spec);
            spec = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, spec), {}, {
                left: targetLeft
            });
            var trackStyle = (0, $ac430e59d4178fe3$export$a56204438fe3ba9e)(spec);
            if (setTrackStyle || (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.count(_this.props.children) !== (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.count(spec.children)) updatedState["trackStyle"] = trackStyle;
            _this.setState(updatedState, callback);
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "ssrInit", function() {
            if (_this.props.variableWidth) {
                var _trackWidth = 0, _trackLeft = 0;
                var childrenWidths = [];
                var preClones = (0, $ac430e59d4178fe3$export$b7c426bbf733f421)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                var postClones = (0, $ac430e59d4178fe3$export$50a387a8fd3c60d)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                _this.props.children.forEach(function(child) {
                    childrenWidths.push(child.props.style.width);
                    _trackWidth += child.props.style.width;
                });
                for(var i = 0; i < preClones; i++){
                    _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
                    _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
                }
                for(var _i = 0; _i < postClones; _i++)_trackWidth += childrenWidths[_i];
                for(var _i2 = 0; _i2 < _this.state.currentSlide; _i2++)_trackLeft += childrenWidths[_i2];
                var _trackStyle = {
                    width: _trackWidth + "px",
                    left: -_trackLeft + "px"
                };
                if (_this.props.centerMode) {
                    var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
                    _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
                }
                return {
                    trackStyle: _trackStyle
                };
            }
            var childrenCount = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.count(_this.props.children);
            var spec = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                slideCount: childrenCount
            });
            var slideCount = (0, $ac430e59d4178fe3$export$b7c426bbf733f421)(spec) + (0, $ac430e59d4178fe3$export$50a387a8fd3c60d)(spec) + childrenCount;
            var trackWidth = 100 / _this.props.slidesToShow * slideCount;
            var slideWidth = 100 / slideCount;
            var trackLeft = -slideWidth * ((0, $ac430e59d4178fe3$export$b7c426bbf733f421)(spec) + _this.state.currentSlide) * trackWidth / 100;
            if (_this.props.centerMode) trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
            var trackStyle = {
                width: trackWidth + "%",
                left: trackLeft + "%"
            };
            return {
                slideWidth: slideWidth + "%",
                trackStyle: trackStyle
            };
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "checkImagesLoad", function() {
            var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
            var imagesCount = images.length, loadedCount = 0;
            Array.prototype.forEach.call(images, function(image) {
                var handler = function handler() {
                    return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
                };
                if (!image.onclick) image.onclick = function() {
                    return image.parentNode.focus();
                };
                else {
                    var prevClickHandler = image.onclick;
                    image.onclick = function(e) {
                        prevClickHandler(e);
                        image.parentNode.focus();
                    };
                }
                if (!image.onload) {
                    if (_this.props.lazyLoad) image.onload = function() {
                        _this.adaptHeight();
                        _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                    };
                    else {
                        image.onload = handler;
                        image.onerror = function() {
                            handler();
                            _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                        };
                    }
                }
            });
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "progressiveLazyLoad", function() {
            var slidesToLoad = [];
            var spec = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, _this.props), _this.state);
            for(var index = _this.state.currentSlide; index < _this.state.slideCount + (0, $ac430e59d4178fe3$export$50a387a8fd3c60d)(spec); index++)if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
            }
            for(var _index = _this.state.currentSlide - 1; _index >= -(0, $ac430e59d4178fe3$export$b7c426bbf733f421)(spec); _index--)if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
            }
            if (slidesToLoad.length > 0) {
                _this.setState(function(state) {
                    return {
                        lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                    };
                });
                if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
            } else if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
            }
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "slideHandler", function(index) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange;
            // capture currentslide before state is updated
            var currentSlide = _this.state.currentSlide;
            var _slideHandler = (0, $ac430e59d4178fe3$export$961f912fd58954b)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({
                index: index
            }, _this.props), _this.state), {}, {
                trackRef: _this.track,
                useCSS: _this.props.useCSS && !dontAnimate
            })), state = _slideHandler.state, nextState = _slideHandler.nextState;
            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function(value) {
                return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
            if (!_this.props.waitForAnimate && _this.animationEndCallback) {
                clearTimeout(_this.animationEndCallback);
                afterChange && afterChange(currentSlide);
                delete _this.animationEndCallback;
            }
            _this.setState(state, function() {
                // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
                if (asNavFor && _this.asNavForIndex !== index) {
                    _this.asNavForIndex = index;
                    asNavFor.innerSlider.slideHandler(index);
                }
                if (!nextState) return;
                _this.animationEndCallback = setTimeout(function() {
                    var animating = nextState.animating, firstBatch = (0, $289081aecb178230$export$2e2bcd8739ae039)(nextState, $091dbe8b71d86cf9$var$_excluded);
                    _this.setState(firstBatch, function() {
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.setState({
                                animating: animating
                            });
                        }, 10));
                        afterChange && afterChange(state.currentSlide);
                        delete _this.animationEndCallback;
                    });
                }, speed);
            });
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "changeSlide", function(options) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var spec = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, _this.props), _this.state);
            var targetSlide = (0, $ac430e59d4178fe3$export$2b178751aa586095)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;
            if (dontAnimate === true) _this.slideHandler(targetSlide, dontAnimate);
            else _this.slideHandler(targetSlide);
            _this.props.autoplay && _this.autoPlay("update");
            if (_this.props.focusOnSelect) {
                var nodes = _this.list.querySelectorAll(".slick-current");
                nodes[0] && nodes[0].focus();
            }
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "clickHandler", function(e) {
            if (_this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
            }
            _this.clickable = true;
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "keyHandler", function(e) {
            var dir = (0, $ac430e59d4178fe3$export$53be3f01be2e49ac)(e, _this.props.accessibility, _this.props.rtl);
            dir !== "" && _this.changeSlide({
                message: dir
            });
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "selectHandler", function(options) {
            _this.changeSlide(options);
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "disableBodyScroll", function() {
            var preventDefault = function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            };
            window.ontouchmove = preventDefault;
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "enableBodyScroll", function() {
            window.ontouchmove = null;
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "swipeStart", function(e) {
            if (_this.props.verticalSwiping) _this.disableBodyScroll();
            var state = (0, $ac430e59d4178fe3$export$517240397a2d6b8e)(e, _this.props.swipe, _this.props.draggable);
            state !== "" && _this.setState(state);
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "swipeMove", function(e) {
            var state = (0, $ac430e59d4178fe3$export$b6bbad7797799ea9)(e, (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            if (state["swiping"]) _this.clickable = false;
            _this.setState(state);
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "swipeEnd", function(e) {
            var state = (0, $ac430e59d4178fe3$export$a1cf77dc3a4b9ee0)(e, (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state["triggerSlideHandler"];
            delete state["triggerSlideHandler"];
            _this.setState(state);
            if (triggerSlideHandler === undefined) return;
            _this.slideHandler(triggerSlideHandler);
            if (_this.props.verticalSwiping) _this.enableBodyScroll();
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "touchEnd", function(e) {
            _this.swipeEnd(e);
            _this.clickable = true;
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "slickPrev", function() {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "previous"
                });
            }, 0));
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "slickNext", function() {
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "next"
                });
            }, 0));
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            slide = Number(slide);
            if (isNaN(slide)) return "";
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "index",
                    index: slide,
                    currentSlide: _this.state.currentSlide
                }, dontAnimate);
            }, 0));
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "play", function() {
            var nextIndex;
            if (_this.props.rtl) nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            else {
                if ((0, $ac430e59d4178fe3$export$30e977044f8f3618)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, _this.props), _this.state))) nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
                else return false;
            }
            _this.slideHandler(nextIndex);
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "autoPlay", function(playType) {
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            var autoplaying = _this.state.autoplaying;
            if (playType === "update") {
                if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") return;
            } else if (playType === "leave") {
                if (autoplaying === "paused" || autoplaying === "focused") return;
            } else if (playType === "blur") {
                if (autoplaying === "paused" || autoplaying === "hovered") return;
            }
            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
            _this.setState({
                autoplaying: "playing"
            });
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "pause", function(pauseType) {
            if (_this.autoplayTimer) {
                clearInterval(_this.autoplayTimer);
                _this.autoplayTimer = null;
            }
            var autoplaying = _this.state.autoplaying;
            if (pauseType === "paused") _this.setState({
                autoplaying: "paused"
            });
            else if (pauseType === "focused") {
                if (autoplaying === "hovered" || autoplaying === "playing") _this.setState({
                    autoplaying: "focused"
                });
            } else // pauseType  is 'hovered'
            if (autoplaying === "playing") _this.setState({
                autoplaying: "hovered"
            });
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "onDotsOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "onDotsLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "onTrackOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "onTrackLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "onSlideFocus", function() {
            return _this.props.autoplay && _this.pause("focused");
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "onSlideBlur", function() {
            return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "render", function() {
            var className = (0, (/*@__PURE__*/$parcel$interopDefault($10b4a7927d31a5fa$exports)))("slick-slider", _this.props.className, {
                "slick-vertical": _this.props.vertical,
                "slick-initialized": true
            });
            var spec = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, _this.props), _this.state);
            var trackProps = (0, $ac430e59d4178fe3$export$e9dd1a4ab6b7c5b0)(spec, [
                "fade",
                "cssEase",
                "speed",
                "infinite",
                "centerMode",
                "focusOnSelect",
                "currentSlide",
                "lazyLoad",
                "lazyLoadedList",
                "rtl",
                "slideWidth",
                "slideHeight",
                "listHeight",
                "vertical",
                "slidesToShow",
                "slidesToScroll",
                "slideCount",
                "trackStyle",
                "variableWidth",
                "unslick",
                "centerPadding",
                "targetSlide",
                "useCSS"
            ]);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, trackProps), {}, {
                onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
                onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
                onMouseOver: pauseOnHover ? _this.onTrackOver : null,
                focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
            });
            var dots;
            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
                var dotProps = (0, $ac430e59d4178fe3$export$e9dd1a4ab6b7c5b0)(spec, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots"
                ]);
                var pauseOnDotsHover = _this.props.pauseOnDotsHover;
                dotProps = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, dotProps), {}, {
                    clickHandler: _this.changeSlide,
                    onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                    onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                    onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
                });
                dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $8dcb1bb217cfb83a$export$8da50d3722682be0), dotProps);
            }
            var prevArrow, nextArrow;
            var arrowProps = (0, $ac430e59d4178fe3$export$e9dd1a4ab6b7c5b0)(spec, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow"
            ]);
            arrowProps.clickHandler = _this.changeSlide;
            if (_this.props.arrows) {
                prevArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $7714cfbbbc039618$export$9c1f62bf9cbb344b), arrowProps);
                nextArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $7714cfbbbc039618$export$40405f1f48d6dbd), arrowProps);
            }
            var verticalHeightStyle = null;
            if (_this.props.vertical) verticalHeightStyle = {
                height: _this.state.listHeight
            };
            var centerPaddingStyle = null;
            if (_this.props.vertical === false) {
                if (_this.props.centerMode === true) centerPaddingStyle = {
                    padding: "0px " + _this.props.centerPadding
                };
            } else if (_this.props.centerMode === true) centerPaddingStyle = {
                padding: _this.props.centerPadding + " 0px"
            };
            var listStyle = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, verticalHeightStyle), centerPaddingStyle);
            var touchMove = _this.props.touchMove;
            var listProps = {
                className: "slick-list",
                style: listStyle,
                onClick: _this.clickHandler,
                onMouseDown: touchMove ? _this.swipeStart : null,
                onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onMouseUp: touchMove ? _this.swipeEnd : null,
                onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onTouchStart: touchMove ? _this.swipeStart : null,
                onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onTouchEnd: touchMove ? _this.touchEnd : null,
                onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
                className: className,
                dir: "ltr",
                style: _this.props.style
            };
            if (_this.props.unslick) {
                listProps = {
                    className: "slick-list"
                };
                innerSliderProps = {
                    className: className,
                    style: _this.props.style
                };
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
                ref: _this.listRefHandler
            }, listProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $10d18c737c715c2b$export$13921ac0cc260818), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
                ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
        });
        _this.list = null;
        _this.track = null;
        _this.state = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, (0, $fe7572fe45be224e$export$2e2bcd8739ae039)), {}, {
            currentSlide: _this.props.initialSlide,
            targetSlide: _this.props.initialSlide ? _this.props.initialSlide : 0,
            slideCount: (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.count(_this.props.children)
        });
        _this.callbackTimers = [];
        _this.clickable = true;
        _this.debouncedResize = null;
        var ssrState = _this.ssrInit();
        _this.state = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, _this.state), ssrState);
        return _this;
    }
    (0, $56605f2979837676$export$2e2bcd8739ae039)(InnerSlider, _React$Component);
    return (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(InnerSlider, [
        {
            key: "didPropsChange",
            value: function didPropsChange(prevProps) {
                var setTrackStyle = false;
                for(var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    // eslint-disable-next-line no-prototype-builtins
                    if (!prevProps.hasOwnProperty(key)) {
                        setTrackStyle = true;
                        break;
                    }
                    if ((0, $8fc9a8f8dc109eed$export$2e2bcd8739ae039)(prevProps[key]) === "object" || typeof prevProps[key] === "function" || isNaN(prevProps[key])) continue;
                    if (prevProps[key] !== this.props[key]) {
                        setTrackStyle = true;
                        break;
                    }
                }
                return setTrackStyle || (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.count(this.props.children) !== (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.count(prevProps.children);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Component);


var $a0a14f803c773911$exports = {};
var $9925d4ded07e35b8$exports = {};
var $9925d4ded07e35b8$var$camel2hyphen = function(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return '-' + match.toLowerCase();
    }).toLowerCase();
};
$9925d4ded07e35b8$exports = $9925d4ded07e35b8$var$camel2hyphen;


var $a0a14f803c773911$var$isDimension = function(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $a0a14f803c773911$var$obj2mq = function(obj) {
    var mq = '';
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $9925d4ded07e35b8$exports(feature);
        // Add px to dimension features
        if ($a0a14f803c773911$var$isDimension(feature) && typeof value === 'number') value = value + 'px';
        if (value === true) mq += feature;
        else if (value === false) mq += 'not ' + feature;
        else mq += '(' + feature + ': ' + value + ')';
        if (index < features.length - 1) mq += ' and ';
    });
    return mq;
};
var $a0a14f803c773911$var$json2mq = function(query) {
    var mq = '';
    if (typeof query === 'string') return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $a0a14f803c773911$var$obj2mq(q);
            if (index < query.length - 1) mq += ', ';
        });
        return mq;
    }
    // Handling single media query
    return $a0a14f803c773911$var$obj2mq(query);
};
$a0a14f803c773911$exports = $a0a14f803c773911$var$json2mq;




"use strict";
function $b5e0a61683b60c87$var$_callSuper(t, o, e) {
    return o = (0, $842b6e0da6891434$export$2e2bcd8739ae039)(o), (0, $72c3cf5bc8600437$export$2e2bcd8739ae039)(t, (0, $d3a6f09ccec9fd7e$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $842b6e0da6891434$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
var $b5e0a61683b60c87$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function Slider(props) {
        var _this;
        (0, $e27c3b84810c9c06$export$2e2bcd8739ae039)(this, Slider);
        _this = $b5e0a61683b60c87$var$_callSuper(this, Slider, [
            props
        ]);
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "innerSliderRefHandler", function(ref) {
            return _this.innerSlider = ref;
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "slickPrev", function() {
            return _this.innerSlider.slickPrev();
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "slickNext", function() {
            return _this.innerSlider.slickNext();
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return _this.innerSlider.slickGoTo(slide, dontAnimate);
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "slickPause", function() {
            return _this.innerSlider.pause("paused");
        });
        (0, $db13280b58f1be94$export$2e2bcd8739ae039)(_this, "slickPlay", function() {
            return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
            breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
    }
    (0, $56605f2979837676$export$2e2bcd8739ae039)(Slider, _React$Component);
    return (0, $a6abaaa62f37bab5$export$2e2bcd8739ae039)(Slider, [
        {
            key: "media",
            value: function media(query, handler) {
                // javascript handler for  css media query
                var mql = window.matchMedia(query);
                var listener = function listener(_ref) {
                    var matches = _ref.matches;
                    if (matches) handler();
                };
                mql.addListener(listener);
                listener(mql);
                this._responsiveMediaHandlers.push({
                    mql: mql,
                    query: query,
                    listener: listener
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // performance monitoring
                //if (process.env.NODE_ENV !== 'production') {
                //const { whyDidYouUpdate } = require('why-did-you-update')
                //whyDidYouUpdate(React)
                //}
                if (this.props.responsive) {
                    var breakpoints = this.props.responsive.map(function(breakpt) {
                        return breakpt.breakpoint;
                    });
                    // sort them in increasing order of their numerical value
                    breakpoints.sort(function(x, y) {
                        return x - y;
                    });
                    breakpoints.forEach(function(breakpoint, index) {
                        // media query for each breakpoint
                        var bQuery;
                        if (index === 0) bQuery = (0, (/*@__PURE__*/$parcel$interopDefault($a0a14f803c773911$exports)))({
                            minWidth: 0,
                            maxWidth: breakpoint
                        });
                        else bQuery = (0, (/*@__PURE__*/$parcel$interopDefault($a0a14f803c773911$exports)))({
                            minWidth: breakpoints[index - 1] + 1,
                            maxWidth: breakpoint
                        });
                        // when not using server side rendering
                        (0, $ac430e59d4178fe3$export$71594e8a50f746f4)() && _this2.media(bQuery, function() {
                            _this2.setState({
                                breakpoint: breakpoint
                            });
                        });
                    });
                    // Register media query for full screen. Need to support resize from small to large
                    // convert javascript object to media query string
                    var query = (0, (/*@__PURE__*/$parcel$interopDefault($a0a14f803c773911$exports)))({
                        minWidth: breakpoints.slice(-1)[0]
                    });
                    (0, $ac430e59d4178fe3$export$71594e8a50f746f4)() && this.media(query, function() {
                        _this2.setState({
                            breakpoint: null
                        });
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._responsiveMediaHandlers.forEach(function(obj) {
                    obj.mql.removeListener(obj.listener);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var settings;
                var newProps;
                if (this.state.breakpoint) {
                    newProps = this.props.responsive.filter(function(resp) {
                        return resp.breakpoint === _this3.state.breakpoint;
                    });
                    settings = newProps[0].settings === "unslick" ? "unslick" : (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, (0, $665d89af0f094860$export$2e2bcd8739ae039)), this.props), newProps[0].settings);
                } else settings = (0, $34ce29ac4bb97565$export$2e2bcd8739ae039)((0, $34ce29ac4bb97565$export$2e2bcd8739ae039)({}, (0, $665d89af0f094860$export$2e2bcd8739ae039)), this.props);
                // force scrolling by one if centerMode is on
                if (settings.centerMode) {
                    settings.slidesToScroll;
                    settings.slidesToScroll = 1;
                }
                // force showing one slide and scrolling by one if the fade mode is on
                if (settings.fade) {
                    settings.slidesToShow;
                    settings.slidesToScroll;
                    settings.slidesToShow = 1;
                    settings.slidesToScroll = 1;
                }
                // makes sure that children is an array, even when there is only 1 child
                var children = (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Children.toArray(this.props.children);
                // Children may contain false or null, so we should filter them
                // children may also contain string filled with spaces (in certain cases where we use jsx strings)
                children = children.filter(function(child) {
                    if (typeof child === "string") return !!child.trim();
                    return !!child;
                });
                // rows and slidesPerRow logic is handled here
                if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                    console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                    settings.variableWidth = false;
                }
                var newChildren = [];
                var currentWidth = null;
                for(var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow){
                    var newSlide = [];
                    for(var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow){
                        var row = [];
                        for(var k = j; k < j + settings.slidesPerRow; k += 1){
                            if (settings.variableWidth && children[k].props.style) currentWidth = children[k].props.style.width;
                            if (k >= children.length) break;
                            row.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).cloneElement(children[k], {
                                key: 100 * i + 10 * j + k,
                                tabIndex: -1,
                                style: {
                                    width: "".concat(100 / settings.slidesPerRow, "%"),
                                    display: "inline-block"
                                }
                            }));
                        }
                        newSlide.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
                            key: 10 * i + j
                        }, row));
                    }
                    if (settings.variableWidth) newChildren.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
                        key: i,
                        style: {
                            width: currentWidth
                        }
                    }, newSlide));
                    else newChildren.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
                        key: i
                    }, newSlide));
                }
                if (settings === "unslick") {
                    var className = "regular slider " + (this.props.className || "");
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement("div", {
                        className: className
                    }, children);
                } else if (newChildren.length <= settings.slidesToShow && !settings.infinite) settings.unslick = true;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $091dbe8b71d86cf9$export$14a303763f47951d), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({
                    style: this.props.style,
                    ref: this.innerSliderRefHandler
                }, (0, $ac430e59d4178fe3$export$b01d4e122f0895e5)(settings)), newChildren);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).Component);


var $53b323091abd98d5$export$2e2bcd8739ae039 = (0, $b5e0a61683b60c87$export$2e2bcd8739ae039);









const $776f0dfecef84d1b$export$313f763ccae4d53d = '--dot-duration';
const $776f0dfecef84d1b$var$genCarouselStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [componentCls]: {
            ...(0, $945cb0d2b7017a11$export$23997c3e44cc1c59)(token),
            '.slick-slider': {
                position: 'relative',
                display: 'block',
                boxSizing: 'border-box',
                touchAction: 'pan-y',
                WebkitTouchCallout: 'none',
                WebkitTapHighlightColor: 'transparent',
                '.slick-track, .slick-list': {
                    transform: 'translate3d(0, 0, 0)',
                    touchAction: 'pan-y'
                }
            },
            '.slick-list': {
                position: 'relative',
                display: 'block',
                margin: 0,
                padding: 0,
                overflow: 'hidden',
                '&:focus': {
                    outline: 'none'
                },
                '&.dragging': {
                    cursor: 'pointer'
                },
                '.slick-slide': {
                    pointerEvents: 'none',
                    // https://github.com/ant-design/ant-design/issues/23294
                    [`input${antCls}-radio-input, input${antCls}-checkbox-input`]: {
                        visibility: 'hidden'
                    },
                    '&.slick-active': {
                        pointerEvents: 'auto',
                        [`input${antCls}-radio-input, input${antCls}-checkbox-input`]: {
                            visibility: 'visible'
                        }
                    },
                    // fix Carousel content height not match parent node
                    // when children is empty node
                    // https://github.com/ant-design/ant-design/issues/25878
                    '> div > div': {
                        verticalAlign: 'bottom'
                    }
                }
            },
            '.slick-track': {
                position: 'relative',
                top: 0,
                insetInlineStart: 0,
                display: 'block',
                '&::before, &::after': {
                    display: 'table',
                    content: '""'
                },
                '&::after': {
                    clear: 'both'
                }
            },
            '.slick-slide': {
                display: 'none',
                float: 'left',
                height: '100%',
                minHeight: 1,
                img: {
                    display: 'block'
                },
                '&.dragging img': {
                    pointerEvents: 'none'
                }
            },
            '.slick-initialized .slick-slide': {
                display: 'block'
            },
            '.slick-vertical .slick-slide': {
                display: 'block',
                height: 'auto'
            }
        }
    };
};
const $776f0dfecef84d1b$var$genArrowsStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, arrowSize: arrowSize, arrowOffset: arrowOffset } = token;
    const arrowLength = token.calc(arrowSize).div(Math.SQRT2).equal();
    return {
        [componentCls]: {
            // Arrows
            '.slick-prev, .slick-next': {
                position: 'absolute',
                top: '50%',
                width: arrowSize,
                height: arrowSize,
                transform: 'translateY(-50%)',
                color: '#fff',
                opacity: 0.4,
                background: 'transparent',
                padding: 0,
                lineHeight: 0,
                border: 0,
                outline: 'none',
                cursor: 'pointer',
                zIndex: 1,
                transition: `opacity ${motionDurationSlow}`,
                '&:hover, &:focus': {
                    opacity: 1
                },
                '&.slick-disabled': {
                    pointerEvents: 'none',
                    opacity: 0
                },
                '&::after': {
                    boxSizing: 'border-box',
                    position: 'absolute',
                    top: token.calc(arrowSize).sub(arrowLength).div(2).equal(),
                    insetInlineStart: token.calc(arrowSize).sub(arrowLength).div(2).equal(),
                    display: 'inline-block',
                    width: arrowLength,
                    height: arrowLength,
                    border: `0 solid currentcolor`,
                    borderInlineStartWidth: 2,
                    borderBlockStartWidth: 2,
                    borderRadius: 1,
                    content: '""'
                }
            },
            '.slick-prev': {
                insetInlineStart: arrowOffset,
                '&::after': {
                    transform: 'rotate(-45deg)'
                }
            },
            '.slick-next': {
                insetInlineEnd: arrowOffset,
                '&::after': {
                    transform: 'rotate(135deg)'
                }
            }
        }
    };
};
const $776f0dfecef84d1b$var$genDotsStyle = (token)=>{
    const { componentCls: componentCls, dotOffset: dotOffset, dotWidth: dotWidth, dotHeight: dotHeight, dotGap: dotGap, colorBgContainer: colorBgContainer, motionDurationSlow: motionDurationSlow } = token;
    const animation = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)(`${token.prefixCls}-dot-animation`, {
        from: {
            width: 0
        },
        to: {
            width: token.dotActiveWidth
        }
    });
    return {
        [componentCls]: {
            '.slick-dots': {
                position: 'absolute',
                insetInlineEnd: 0,
                bottom: 0,
                insetInlineStart: 0,
                zIndex: 15,
                display: 'flex !important',
                justifyContent: 'center',
                paddingInlineStart: 0,
                margin: 0,
                listStyle: 'none',
                '&-bottom': {
                    bottom: dotOffset
                },
                '&-top': {
                    top: dotOffset,
                    bottom: 'auto'
                },
                li: {
                    position: 'relative',
                    display: 'inline-block',
                    flex: '0 1 auto',
                    boxSizing: 'content-box',
                    width: dotWidth,
                    height: dotHeight,
                    marginInline: dotGap,
                    padding: 0,
                    textAlign: 'center',
                    textIndent: -999,
                    verticalAlign: 'top',
                    transition: `all ${motionDurationSlow}`,
                    borderRadius: dotHeight,
                    overflow: 'hidden',
                    '&::after': {
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        insetInlineStart: 0,
                        width: 0,
                        height: dotHeight,
                        content: '""',
                        background: 'transparent',
                        borderRadius: dotHeight,
                        opacity: 1,
                        outline: 'none',
                        cursor: 'pointer',
                        overflow: 'hidden'
                    },
                    button: {
                        position: 'relative',
                        display: 'block',
                        width: '100%',
                        height: dotHeight,
                        padding: 0,
                        color: 'transparent',
                        fontSize: 0,
                        background: colorBgContainer,
                        border: 0,
                        borderRadius: dotHeight,
                        outline: 'none',
                        cursor: 'pointer',
                        opacity: 0.2,
                        transition: `all ${motionDurationSlow}`,
                        overflow: 'hidden',
                        '&:hover': {
                            opacity: 0.75
                        },
                        '&::after': {
                            position: 'absolute',
                            inset: token.calc(dotGap).mul(-1).equal(),
                            content: '""'
                        }
                    },
                    '&.slick-active': {
                        width: token.dotActiveWidth,
                        position: 'relative',
                        '&:hover': {
                            opacity: 1
                        },
                        '&::after': {
                            background: colorBgContainer,
                            animationName: animation,
                            animationDuration: `var(${$776f0dfecef84d1b$export$313f763ccae4d53d})`,
                            animationTimingFunction: 'ease-out',
                            animationFillMode: 'forwards'
                        }
                    }
                }
            }
        }
    };
};
const $776f0dfecef84d1b$var$genCarouselVerticalStyle = (token)=>{
    const { componentCls: componentCls, dotOffset: dotOffset, arrowOffset: arrowOffset, marginXXS: marginXXS } = token;
    const animation = new (0, $eb725c9f616c62dd$export$2e2bcd8739ae039)(`${token.prefixCls}-dot-vertical-animation`, {
        from: {
            height: 0
        },
        to: {
            height: token.dotActiveWidth
        }
    });
    const reverseSizeOfDot = {
        width: token.dotHeight,
        height: token.dotWidth
    };
    return {
        [`${componentCls}-vertical`]: {
            '.slick-prev, .slick-next': {
                insetInlineStart: '50%',
                marginBlockStart: 'unset',
                transform: 'translateX(-50%)'
            },
            '.slick-prev': {
                insetBlockStart: arrowOffset,
                insetInlineStart: '50%',
                '&::after': {
                    transform: 'rotate(45deg)'
                }
            },
            '.slick-next': {
                insetBlockStart: 'auto',
                insetBlockEnd: arrowOffset,
                '&::after': {
                    transform: 'rotate(-135deg)'
                }
            },
            '.slick-dots': {
                top: '50%',
                bottom: 'auto',
                flexDirection: 'column',
                width: token.dotHeight,
                height: 'auto',
                margin: 0,
                transform: 'translateY(-50%)',
                '&-start': {
                    insetInlineEnd: 'auto',
                    insetInlineStart: dotOffset
                },
                '&-end': {
                    insetInlineEnd: dotOffset,
                    insetInlineStart: 'auto'
                },
                li: {
                    // reverse width and height in vertical situation
                    ...reverseSizeOfDot,
                    margin: `${(0, $df37b8d23d0b3c71$export$523c0b569236b342)(marginXXS)} 0`,
                    verticalAlign: 'baseline',
                    button: reverseSizeOfDot,
                    '&::after': {
                        ...reverseSizeOfDot,
                        height: 0
                    },
                    '&.slick-active': {
                        ...reverseSizeOfDot,
                        height: token.dotActiveWidth,
                        button: {
                            ...reverseSizeOfDot,
                            height: token.dotActiveWidth
                        },
                        '&::after': {
                            ...reverseSizeOfDot,
                            animationName: animation,
                            animationDuration: `var(${$776f0dfecef84d1b$export$313f763ccae4d53d})`,
                            animationTimingFunction: 'ease-out',
                            animationFillMode: 'forwards'
                        }
                    }
                }
            }
        }
    };
};
const $776f0dfecef84d1b$var$genCarouselRtlStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        {
            [`${componentCls}-rtl`]: {
                direction: 'rtl'
            }
        },
        {
            [`${componentCls}-vertical`]: {
                '.slick-dots': {
                    [`${componentCls}-rtl&`]: {
                        flexDirection: 'column'
                    }
                }
            }
        }
    ];
};
const $776f0dfecef84d1b$export$9ca1be8807fe0675 = (token)=>{
    const dotActiveWidth = 24;
    return {
        arrowSize: 16,
        arrowOffset: token.marginXS,
        dotWidth: 16,
        dotHeight: 3,
        dotGap: token.marginXXS,
        dotOffset: 12,
        dotWidthActive: dotActiveWidth,
        dotActiveWidth: dotActiveWidth
    };
};
var // ============================== Export ==============================
$776f0dfecef84d1b$export$2e2bcd8739ae039 = (0, $2acdd5777733fef1$export$51ec95de45185b42)('Carousel', (token)=>[
        $776f0dfecef84d1b$var$genCarouselStyle(token),
        $776f0dfecef84d1b$var$genArrowsStyle(token),
        $776f0dfecef84d1b$var$genDotsStyle(token),
        $776f0dfecef84d1b$var$genCarouselVerticalStyle(token),
        $776f0dfecef84d1b$var$genCarouselRtlStyle(token)
    ], $776f0dfecef84d1b$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            'dotWidthActive',
            'dotActiveWidth'
        ]
    ]
});


"use client";
const $feb258f80618e96e$var$dotsClass = 'slick-dots';
const $feb258f80618e96e$var$ArrowButton = ({ currentSlide: currentSlide, slideCount: slideCount, ...rest })=>/*#__PURE__*/ $ltGt3.createElement("button", {
        type: "button",
        ...rest
    });
const $feb258f80618e96e$var$Carousel = /*#__PURE__*/ $ltGt3.forwardRef((props, ref)=>{
    const { dots: dots = true, arrows: arrows = false, prevArrow: prevArrow, nextArrow: nextArrow, draggable: draggable = false, waitForAnimate: waitForAnimate = false, dotPosition: dotPosition, dotPlacement: dotPlacement, vertical: vertical, rootClassName: rootClassName, className: customClassName, style: style, id: id, autoplay: autoplay = false, autoplaySpeed: autoplaySpeed = 3000, rtl: rtl, ...otherProps } = props;
    const mergedDotPlacement = $ltGt3.useMemo(()=>{
        const placement = dotPlacement ?? dotPosition ?? 'bottom';
        switch(placement){
            case 'left':
                return 'start';
            case 'right':
                return 'end';
            default:
                return placement;
        }
    }, [
        dotPosition,
        dotPlacement
    ]);
    const mergedVertical = vertical ?? (mergedDotPlacement === 'start' || mergedDotPlacement === 'end');
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle } = (0, $d13451568443aeb8$export$46f4bd6436a25a31)('carousel');
    const slickRef = $ltGt3.useRef(null);
    const goTo = (slide, dontAnimate = false)=>{
        slickRef.current.slickGoTo(slide, dontAnimate);
    };
    $ltGt3.useImperativeHandle(ref, ()=>({
            goTo: goTo,
            autoPlay: slickRef.current.innerSlider.autoPlay,
            innerSlider: slickRef.current.innerSlider,
            prev: slickRef.current.slickPrev,
            next: slickRef.current.slickNext
        }), [
        slickRef.current
    ]);
    const { children: children, initialSlide: initialSlide = 0 } = props;
    const childNodes = (0, $0f02b0eb7b37195f$export$2e2bcd8739ae039)(children);
    const count = childNodes.length;
    const isRTL = (rtl ?? direction === 'rtl') && !vertical;
    $ltGt3.useEffect(()=>{
        if (count > 0) {
            const newIndex = isRTL ? count - initialSlide - 1 : initialSlide;
            goTo(newIndex, false);
        }
    }, [
        count,
        initialSlide,
        isRTL
    ]);
    const newProps = {
        vertical: mergedVertical,
        className: (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(customClassName, contextClassName),
        style: {
            ...contextStyle,
            ...style
        },
        autoplay: !!autoplay,
        ...otherProps
    };
    if (newProps.effect === 'fade') newProps.fade = true;
    const prefixCls = getPrefixCls('carousel', newProps.prefixCls);
    const enableDots = !!dots;
    const dsClass = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)($feb258f80618e96e$var$dotsClass, `${$feb258f80618e96e$var$dotsClass}-${mergedDotPlacement}`, typeof dots === 'boolean' ? false : dots?.className);
    const [hashId, cssVarCls] = (0, $776f0dfecef84d1b$export$2e2bcd8739ae039)(prefixCls);
    const className = (0, $9385a2419c7c77f5$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-rtl`]: isRTL,
        [`${prefixCls}-vertical`]: newProps.vertical
    }, hashId, cssVarCls, rootClassName);
    const mergedShowDuration = autoplay && (typeof autoplay === 'object' ? autoplay.dotDuration : false);
    const dotDurationStyle = mergedShowDuration ? {
        [(0, $776f0dfecef84d1b$export$313f763ccae4d53d)]: `${autoplaySpeed}ms`
    } : {};
    return /*#__PURE__*/ $ltGt3.createElement("div", {
        className: className,
        id: id,
        style: dotDurationStyle
    }, /*#__PURE__*/ $ltGt3.createElement((0, $53b323091abd98d5$export$2e2bcd8739ae039), {
        ref: slickRef,
        ...newProps,
        dots: enableDots,
        dotsClass: dsClass,
        arrows: arrows,
        prevArrow: prevArrow ?? /*#__PURE__*/ $ltGt3.createElement($feb258f80618e96e$var$ArrowButton, {
            "aria-label": isRTL ? 'next' : 'prev'
        }),
        nextArrow: nextArrow ?? /*#__PURE__*/ $ltGt3.createElement($feb258f80618e96e$var$ArrowButton, {
            "aria-label": isRTL ? 'prev' : 'next'
        }),
        draggable: draggable,
        verticalSwiping: mergedVertical,
        autoplaySpeed: autoplaySpeed,
        waitForAnimate: waitForAnimate,
        rtl: isRTL
    }));
});
var $feb258f80618e96e$export$2e2bcd8739ae039 = $feb258f80618e96e$var$Carousel;


var $95474f4b2108bbd8$exports = {};
$95474f4b2108bbd8$exports = import.meta.resolve("bromv");


var $f909e68ba614a9c8$exports = {};
$f909e68ba614a9c8$exports = import.meta.resolve("gAFQ4");


var $745fdee392b75c4d$exports = {};
$745fdee392b75c4d$exports = import.meta.resolve("3Kp3O");


var $5c936e253ac109fa$exports = {};
$5c936e253ac109fa$exports = import.meta.resolve("U5EyO");


var $f7e25c76b70e23d1$exports = {};
$f7e25c76b70e23d1$exports = import.meta.resolve("3JvvK");



var $d1c46aad3512e378$exports = {};
$d1c46aad3512e378$exports = import.meta.resolve("4YD38");


var $091b93eca0a9afa6$exports = {};
$091b93eca0a9afa6$exports = import.meta.resolve("63Xpa");


var $47edc64bcaa4c04c$exports = {};
$47edc64bcaa4c04c$exports = import.meta.resolve("aJ8vs");


var $677a42ee1598fcf0$exports = {};
$677a42ee1598fcf0$exports = import.meta.resolve("5vMhq");


var $58115ded4f531fdb$exports = {};
$58115ded4f531fdb$exports = import.meta.resolve("gR4Xx");


var $ef5ef19b940e6a04$exports = {};
$ef5ef19b940e6a04$exports = import.meta.resolve("iqryH");


var $e788d57ce23b020c$exports = {};
$e788d57ce23b020c$exports = import.meta.resolve("78Gwk");


var $713d2b8fd737de71$exports = {};
$713d2b8fd737de71$exports = import.meta.resolve("g48Y4");


var $801af93680357ac7$exports = {};
$801af93680357ac7$exports = import.meta.resolve("lHb21");


var $b24f7b0150b9cfe5$exports = {};
$b24f7b0150b9cfe5$exports = import.meta.resolve("5QOBn");


var $f477ef5552394111$exports = {};
$f477ef5552394111$exports = import.meta.resolve("0B89W");


var $3c1e75aeea76120d$exports = {};
$3c1e75aeea76120d$exports = import.meta.resolve("itVXU");


var $6707872cc532ae3e$exports = {};
$6707872cc532ae3e$exports = import.meta.resolve("5heGD");





var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $4d7bc138ee9970ad$var$InstagramOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 00-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z"
                }
            }
        ]
    },
    "name": "instagram",
    "theme": "outlined"
};
var $4d7bc138ee9970ad$export$2e2bcd8739ae039 = $4d7bc138ee9970ad$var$InstagramOutlined;



var $8093499fcf838655$var$InstagramOutlined = function InstagramOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $4d7bc138ee9970ad$export$2e2bcd8739ae039)
    }));
};
/**![instagram](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiAzMDYuOWMtMTEzLjUgMC0yMDUuMSA5MS42LTIwNS4xIDIwNS4xUzM5OC41IDcxNy4xIDUxMiA3MTcuMSA3MTcuMSA2MjUuNSA3MTcuMSA1MTIgNjI1LjUgMzA2LjkgNTEyIDMwNi45em0wIDMzOC40Yy03My40IDAtMTMzLjMtNTkuOS0xMzMuMy0xMzMuM1M0MzguNiAzNzguNyA1MTIgMzc4LjcgNjQ1LjMgNDM4LjYgNjQ1LjMgNTEyIDU4NS40IDY0NS4zIDUxMiA2NDUuM3ptMjEzLjUtMzk0LjZjLTI2LjUgMC00Ny45IDIxLjQtNDcuOSA0Ny45czIxLjQgNDcuOSA0Ny45IDQ3LjkgNDcuOS0yMS4zIDQ3LjktNDcuOWE0Ny44NCA0Ny44NCAwIDAwLTQ3LjktNDcuOXpNOTExLjggNTEyYzAtNTUuMi41LTEwOS45LTIuNi0xNjUtMy4xLTY0LTE3LjctMTIwLjgtNjQuNS0xNjcuNi00Ni45LTQ2LjktMTAzLjYtNjEuNC0xNjcuNi02NC41LTU1LjItMy4xLTEwOS45LTIuNi0xNjUtMi42LTU1LjIgMC0xMDkuOS0uNS0xNjUgMi42LTY0IDMuMS0xMjAuOCAxNy43LTE2Ny42IDY0LjVDMTMyLjYgMjI2LjMgMTE4LjEgMjgzIDExNSAzNDdjLTMuMSA1NS4yLTIuNiAxMDkuOS0yLjYgMTY1cy0uNSAxMDkuOSAyLjYgMTY1YzMuMSA2NCAxNy43IDEyMC44IDY0LjUgMTY3LjYgNDYuOSA0Ni45IDEwMy42IDYxLjQgMTY3LjYgNjQuNSA1NS4yIDMuMSAxMDkuOSAyLjYgMTY1IDIuNiA1NS4yIDAgMTA5LjkuNSAxNjUtMi42IDY0LTMuMSAxMjAuOC0xNy43IDE2Ny42LTY0LjUgNDYuOS00Ni45IDYxLjQtMTAzLjYgNjQuNS0xNjcuNiAzLjItNTUuMSAyLjYtMTA5LjggMi42LTE2NXptLTg4IDIzNS44Yy03LjMgMTguMi0xNi4xIDMxLjgtMzAuMiA0NS44LTE0LjEgMTQuMS0yNy42IDIyLjktNDUuOCAzMC4yQzY5NS4yIDg0NC43IDU3MC4zIDg0MCA1MTIgODQwYy01OC4zIDAtMTgzLjMgNC43LTIzNS45LTE2LjEtMTguMi03LjMtMzEuOC0xNi4xLTQ1LjgtMzAuMi0xNC4xLTE0LjEtMjIuOS0yNy42LTMwLjItNDUuOEMxNzkuMyA2OTUuMiAxODQgNTcwLjMgMTg0IDUxMmMwLTU4LjMtNC43LTE4My4zIDE2LjEtMjM1LjkgNy4zLTE4LjIgMTYuMS0zMS44IDMwLjItNDUuOHMyNy42LTIyLjkgNDUuOC0zMC4yQzMyOC43IDE3OS4zIDQ1My43IDE4NCA1MTIgMTg0czE4My4zLTQuNyAyMzUuOSAxNi4xYzE4LjIgNy4zIDMxLjggMTYuMSA0NS44IDMwLjIgMTQuMSAxNC4xIDIyLjkgMjcuNiAzMC4yIDQ1LjhDODQ0LjcgMzI4LjcgODQwIDQ1My43IDg0MCA1MTJjMCA1OC4zIDQuNyAxODMuMi0xNi4yIDIzNS44eiIgLz48L3N2Zz4=) */ var $8093499fcf838655$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($8093499fcf838655$var$InstagramOutlined);
var $8093499fcf838655$export$2e2bcd8739ae039 = $8093499fcf838655$var$RefIcon;





var $ltGt3 = parcelRequire("ltGt3");


var $34debced7ffdd98e$var$LeftOutlined = function LeftOutlined(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $3cf76e1ffa693476$export$2e2bcd8739ae039)
    }));
};
/**![left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcyNCAyMTguM1YxNDFjMC02LjctNy43LTEwLjQtMTIuOS02LjNMMjYwLjMgNDg2LjhhMzEuODYgMzEuODYgMCAwMDAgNTAuM2w0NTAuOCAzNTIuMWM1LjMgNC4xIDEyLjkuNCAxMi45LTYuM3YtNzcuM2MwLTQuOS0yLjMtOS42LTYuMS0xMi42bC0zNjAtMjgxIDM2MC0yODEuMWMzLjgtMyA2LjEtNy43IDYuMS0xMi42eiIgLz48L3N2Zz4=) */ var $34debced7ffdd98e$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($34debced7ffdd98e$var$LeftOutlined);
var $34debced7ffdd98e$export$2e2bcd8739ae039 = $34debced7ffdd98e$var$RefIcon;




var $ltGt3 = parcelRequire("ltGt3");

function $d7dc3086abe626ed$var$getByIndexWithCyclicWrap(array, index) {
    const { length: length1 } = array;
    while(index < 0)index += length1;
    while(index >= length1)index -= length1;
    return array[index];
}
function $d7dc3086abe626ed$export$91c8055d7b33e381({ plants: plants, slidesPerView: slidesPerView }) {
    const [firstCardIndex, setFirstCardIndex] = (0, $ltGt3.useState)(0);
    const [animationOffset, setAnimationOffset] = (0, $ltGt3.useState)(0);
    const [animationEnabled, setAnimationEnabled] = (0, $ltGt3.useState)(false);
    const sliderContainerRef = (0, $ltGt3.useRef)();
    const plantCopyBufferLength = 2;
    const plantsToDisplay = [];
    const rerenderCards = (0, $ltGt3.useCallback)((offset)=>{
        setFirstCardIndex((current)=>{
            let newValue = current + offset;
            while(newValue < 0)newValue += plants.length;
            while(newValue >= length)newValue -= plants.length;
            return newValue;
        });
    }, [
        setFirstCardIndex,
        plants.length
    ]);
    const slideCards = (0, $ltGt3.useCallback)((direction)=>{
        setAnimationEnabled(true);
        requestAnimationFrame(()=>{
            if (!sliderContainerRef.current) return;
            const cardWidth = sliderContainerRef.current.clientWidth / (slidesPerView + plantCopyBufferLength + plantCopyBufferLength);
            setAnimationOffset(direction === 'left' ? cardWidth : -cardWidth);
        });
    }, [
        setAnimationOffset
    ]);
    for(let i = firstCardIndex - plantCopyBufferLength; i < firstCardIndex + slidesPerView + plantCopyBufferLength; i++){
        const plant = $d7dc3086abe626ed$var$getByIndexWithCyclicWrap(plants, i);
        plantsToDisplay.push(plant);
    }
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            overflow: 'hidden',
            alignItems: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'row',
                    transition: animationEnabled ? 'transform .5s' : undefined,
                    transform: `translateX(${animationOffset}px)`
                },
                ref: sliderContainerRef,
                onTransitionEnd: (e)=>{
                    if (e.target === e.currentTarget) {
                        rerenderCards(animationOffset < 0 ? 1 : -1);
                        setAnimationEnabled(false);
                        setAnimationOffset(0);
                    }
                },
                children: plantsToDisplay.map((plant, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'row'
                        },
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ae4f7d1e2e806571$export$45ba68a69de774e4), {
                            photo: plant.photo,
                            sun: plant.sun,
                            watering: plant.watering,
                            name: plant.name,
                            description: plant.description
                        })
                    }, `${plant.name}-${index}`))
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px 0'
                },
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        type: "text",
                        style: {
                            color: '#2F5D55'
                        },
                        onClick: ()=>{
                            if (animationEnabled) return;
                            slideCards('left');
                        },
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $34debced7ffdd98e$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        type: "text",
                        style: {
                            color: '#2F5D55'
                        },
                        onClick: ()=>{
                            if (animationEnabled) return;
                            slideCards('right');
                        },
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $532bc1903b13fec2$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
}


function $0f7f21fec06ab1e8$export$355f3d6a1f8b250c() {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const navigation = (0, $493cbc5b00d91baa$export$d0fd4b7106de2769)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const changeLocale = (0, $17695373636e29e1$export$3013d29b72c2d37b)();
    const items = [
        {
            label: intl.formatMessage({
                id: 'editor'
            }),
            key: 'editor'
        },
        {
            label: intl.formatMessage({
                id: 'taskPlanner'
            }),
            key: 'taskPlanner'
        },
        {
            label: intl.formatMessage({
                id: 'plantDatabase'
            }),
            key: 'plantDatabase'
        },
        {
            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                id: "language-icon",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $faae94e2180ec81a$export$2e2bcd8739ae039), {})
            }),
            key: 'language',
            children: [
                {
                    label: 'en',
                    key: 'en',
                    onClick: ()=>changeLocale('en')
                },
                {
                    label: 'ru',
                    key: 'ru',
                    onClick: ()=>changeLocale('ru')
                }
            ]
        }
    ];
    const questionsWithAnswers = [
        {
            key: '1',
            label: intl.formatMessage({
                id: 'faqQuestion1'
            }),
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: intl.formatMessage({
                    id: 'faqAnswer1'
                })
            })
        },
        {
            key: '2',
            label: intl.formatMessage({
                id: 'faqQuestion2'
            }),
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: intl.formatMessage({
                    id: 'faqAnswer2'
                })
            })
        },
        {
            key: '3',
            label: intl.formatMessage({
                id: 'faqQuestion3'
            }),
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: intl.formatMessage({
                    id: 'faqAnswer3'
                })
            })
        },
        {
            key: '4',
            label: intl.formatMessage({
                id: 'faqQuestion4'
            }),
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: intl.formatMessage({
                    id: 'faqAnswer4'
                })
            })
        }
    ];
    const plantCardsInfo = [
        {
            photo: (0, (/*@__PURE__*/$parcel$interopDefault($e788d57ce23b020c$exports))),
            sun: 2,
            watering: 3,
            name: intl.formatMessage({
                id: 'landingPlantHydrangea'
            }),
            description: 'Hydrangea macrophylla'
        },
        {
            photo: (0, (/*@__PURE__*/$parcel$interopDefault($713d2b8fd737de71$exports))),
            sun: 2,
            watering: 3,
            name: intl.formatMessage({
                id: 'landingPlantBerberis'
            }),
            description: 'Berberis thunbergii'
        },
        {
            photo: (0, (/*@__PURE__*/$parcel$interopDefault($801af93680357ac7$exports))),
            sun: 2,
            watering: 3,
            name: intl.formatMessage({
                id: 'landingPlantSymphotrichum'
            }),
            description: 'Symphyotrichum dumosum'
        },
        {
            photo: (0, (/*@__PURE__*/$parcel$interopDefault($b24f7b0150b9cfe5$exports))),
            sun: 2,
            watering: 3,
            name: intl.formatMessage({
                id: 'landingPlantCrocus'
            }),
            description: 'Crocus'
        },
        {
            photo: (0, (/*@__PURE__*/$parcel$interopDefault($f477ef5552394111$exports))),
            sun: 2,
            watering: 3,
            name: intl.formatMessage({
                id: 'landingPlantDasiphora'
            }),
            description: 'Dasiphora fruticosa'
        },
        {
            photo: (0, (/*@__PURE__*/$parcel$interopDefault($3c1e75aeea76120d$exports))),
            sun: 2,
            watering: 3,
            name: intl.formatMessage({
                id: 'landingPlantAnemone'
            }),
            description: 'Anemone hybrida'
        },
        {
            photo: (0, (/*@__PURE__*/$parcel$interopDefault($6707872cc532ae3e$exports))),
            sun: 2,
            watering: 3,
            name: intl.formatMessage({
                id: 'landingPlantSedum'
            }),
            description: 'Sedum spectabile'
        }
    ];
    const onClick = (e)=>{
        var elem = document.getElementById(e.key);
        if (elem) {
            var jump = elem.getBoundingClientRect().top;
            document.body.scrollTop += jump;
            document.documentElement.scrollTop += jump;
        }
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "layout",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "hero-image",
                style: {
                    backgroundImage: `url('${(0, (/*@__PURE__*/$parcel$interopDefault($95474f4b2108bbd8$exports)))}')`
                }
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "menu",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "menu__row",
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            className: "menu__row__logo",
                            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h1", {
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d1c46aad3512e378$exports)))
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ad53fe0065acc0ef$export$2e2bcd8739ae039), {
                            className: "menu__row__items",
                            mode: "horizontal",
                            overflowedIndicator: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d145441113989bb5$export$2e2bcd8739ae039), {}),
                            items: items,
                            onClick: onClick
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            onClick: async ()=>{
                                navigate('/login');
                            },
                            children: intl.formatMessage({
                                id: 'logIn'
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "hero-content",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "hero-content__info",
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                            className: "hero-content__info__slogan",
                            children: intl.formatMessage({
                                id: 'sloganElevate'
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            className: "hero-content__info__subslogan",
                            children: intl.formatMessage({
                                id: 'subSloganElevate'
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            className: "hero-content__info__button",
                            size: "large",
                            onClick: async ()=>{
                                navigate('/signup');
                            },
                            children: intl.formatMessage({
                                id: 'startToday'
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "features",
                children: [
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f909e68ba614a9c8$exports))),
                        text: intl.formatMessage({
                            id: 'onlineEditor'
                        }),
                        subtext: intl.formatMessage({
                            id: 'onlineEditorDescription'
                        })
                    },
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($745fdee392b75c4d$exports))),
                        text: intl.formatMessage({
                            id: 'taskPlanner'
                        }),
                        subtext: intl.formatMessage({
                            id: 'taskPlannerDescription'
                        })
                    },
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5c936e253ac109fa$exports))),
                        text: intl.formatMessage({
                            id: '1000Plants'
                        }),
                        subtext: intl.formatMessage({
                            id: '1000PlantsDescription'
                        })
                    },
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f7e25c76b70e23d1$exports))),
                        text: intl.formatMessage({
                            id: 'gardenJournal'
                        }),
                        subtext: intl.formatMessage({
                            id: 'gardenJournalDescription'
                        })
                    }
                ].map((f, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "features__item",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                className: "features__item__icon",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                                    src: f.icon
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                                children: f.text
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h4", {
                                children: f.subtext
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                id: "editor",
                className: "content",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "content__header",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                            children: intl.formatMessage({
                                id: 'terraSketchEditor'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "content__back",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "content__back__info",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                    className: "carousel",
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $feb258f80618e96e$export$2e2bcd8739ae039), {
                                        autoplay: true,
                                        effect: "fade",
                                        autoplaySpeed: 4000,
                                        children: [
                                            (0, (/*@__PURE__*/$parcel$interopDefault($091b93eca0a9afa6$exports))),
                                            (0, (/*@__PURE__*/$parcel$interopDefault($47edc64bcaa4c04c$exports))),
                                            (0, (/*@__PURE__*/$parcel$interopDefault($677a42ee1598fcf0$exports))),
                                            (0, (/*@__PURE__*/$parcel$interopDefault($58115ded4f531fdb$exports)))
                                        ].map((imageUrl, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                                    className: "carousel__image",
                                                    style: {
                                                        backgroundImage: `url('${imageUrl}')`
                                                    }
                                                })
                                            }, index))
                                    })
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                    className: "content__back__info__item",
                                    children: [
                                        intl.formatMessage({
                                            id: 'terraSketchEditorDescription1'
                                        }),
                                        intl.formatMessage({
                                            id: 'terraSketchEditorDescription2'
                                        }),
                                        intl.formatMessage({
                                            id: 'terraSketchEditorDescription3'
                                        }),
                                        intl.formatMessage({
                                            id: 'terraSketchEditorDescription4'
                                        }),
                                        intl.formatMessage({
                                            id: 'terraSketchEditorDescription5'
                                        })
                                    ].map((text, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                            className: "content__back__info__item__li",
                                            children: [
                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                                                    className: "content__back__info__item__li__icon",
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($de8c74995637f2ce$exports)))
                                                }),
                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                    className: "content__back__info__item__li__text",
                                                    children: text
                                                })
                                            ]
                                        }, index))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                id: "taskPlanner",
                className: "planner",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "planner__header",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                            children: intl.formatMessage({
                                id: 'terraSketchTaskPlanner'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "planner__list",
                        children: [
                            intl.formatMessage({
                                id: 'terraSketchTaskPlannerDescription1'
                            }),
                            intl.formatMessage({
                                id: 'terraSketchTaskPlannerDescription2'
                            }),
                            intl.formatMessage({
                                id: 'terraSketchTaskPlannerDescription3'
                            }),
                            intl.formatMessage({
                                id: 'terraSketchTaskPlannerDescription4'
                            })
                        ].map((text, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                className: "planner__list__item",
                                children: [
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($de8c74995637f2ce$exports)))
                                    }),
                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                        children: text
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "planner__image",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ef5ef19b940e6a04$exports)))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                id: "plantDatabase",
                className: "plants",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "plants__header",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                            children: intl.formatMessage({
                                id: 'terraSketchPlantDatabase'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "plants__subheader",
                        children: intl.formatMessage({
                            id: 'terraSketchPlantDatabaseDescription'
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "plants__slider",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d7dc3086abe626ed$export$91c8055d7b33e381), {
                            plants: plantCardsInfo,
                            slidesPerView: 5
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                id: "faq",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "faq",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                            children: intl.formatMessage({
                                id: 'faq'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f7961d3e6a10fa4b$export$2e2bcd8739ae039), {
                        className: "faq__collapse",
                        items: questionsWithAnswers,
                        defaultActiveKey: [
                            '1'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "footer",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "footer__left",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                            to: "/#",
                            children: "TerraSketch"
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "footer__right",
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                to: "/policies",
                                children: intl.formatMessage({
                                    id: 'policy'
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                to: "mailto:terrasketch.info@gmail.com",
                                children: intl.formatMessage({
                                    id: 'emailUs'
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                to: "/#",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $8093499fcf838655$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $ltGt3 = parcelRequire("ltGt3");

var $c57fa23ac9c77f20$exports = {};
$c57fa23ac9c77f20$exports = import.meta.resolve("fswQx");




var $ltGt3 = parcelRequire("ltGt3");
// This icon file is generated automatically.
var $23af3a3bc9ce3077$var$InstagramFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 01-47.9 47.9z"
                }
            }
        ]
    },
    "name": "instagram",
    "theme": "filled"
};
var $23af3a3bc9ce3077$export$2e2bcd8739ae039 = $23af3a3bc9ce3077$var$InstagramFilled;



var $59c3f0ee037ec04a$var$InstagramFilled = function InstagramFilled(props, ref) {
    return /*#__PURE__*/ $ltGt3.createElement((0, $bbfd9d0fd6e02593$export$2e2bcd8739ae039), (0, $647338af032ea9a1$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $23af3a3bc9ce3077$export$2e2bcd8739ae039)
    }));
};
/**![instagram](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiAzNzguN2MtNzMuNCAwLTEzMy4zIDU5LjktMTMzLjMgMTMzLjNTNDM4LjYgNjQ1LjMgNTEyIDY0NS4zIDY0NS4zIDU4NS40IDY0NS4zIDUxMiA1ODUuNCAzNzguNyA1MTIgMzc4Ljd6TTkxMS44IDUxMmMwLTU1LjIuNS0xMDkuOS0yLjYtMTY1LTMuMS02NC0xNy43LTEyMC44LTY0LjUtMTY3LjYtNDYuOS00Ni45LTEwMy42LTYxLjQtMTY3LjYtNjQuNS01NS4yLTMuMS0xMDkuOS0yLjYtMTY1LTIuNi01NS4yIDAtMTA5LjktLjUtMTY1IDIuNi02NCAzLjEtMTIwLjggMTcuNy0xNjcuNiA2NC41QzEzMi42IDIyNi4zIDExOC4xIDI4MyAxMTUgMzQ3Yy0zLjEgNTUuMi0yLjYgMTA5LjktMi42IDE2NXMtLjUgMTA5LjkgMi42IDE2NWMzLjEgNjQgMTcuNyAxMjAuOCA2NC41IDE2Ny42IDQ2LjkgNDYuOSAxMDMuNiA2MS40IDE2Ny42IDY0LjUgNTUuMiAzLjEgMTA5LjkgMi42IDE2NSAyLjYgNTUuMiAwIDEwOS45LjUgMTY1LTIuNiA2NC0zLjEgMTIwLjgtMTcuNyAxNjcuNi02NC41IDQ2LjktNDYuOSA2MS40LTEwMy42IDY0LjUtMTY3LjYgMy4yLTU1LjEgMi42LTEwOS44IDIuNi0xNjV6TTUxMiA3MTcuMWMtMTEzLjUgMC0yMDUuMS05MS42LTIwNS4xLTIwNS4xUzM5OC41IDMwNi45IDUxMiAzMDYuOSA3MTcuMSAzOTguNSA3MTcuMSA1MTIgNjI1LjUgNzE3LjEgNTEyIDcxNy4xem0yMTMuNS0zNzAuN2MtMjYuNSAwLTQ3LjktMjEuNC00Ny45LTQ3LjlzMjEuNC00Ny45IDQ3LjktNDcuOSA0Ny45IDIxLjQgNDcuOSA0Ny45YTQ3Ljg0IDQ3Ljg0IDAgMDEtNDcuOSA0Ny45eiIgLz48L3N2Zz4=) */ var $59c3f0ee037ec04a$var$RefIcon = /*#__PURE__*/ $ltGt3.forwardRef($59c3f0ee037ec04a$var$InstagramFilled);
var $59c3f0ee037ec04a$export$2e2bcd8739ae039 = $59c3f0ee037ec04a$var$RefIcon;


function $5e1384582c6f6a64$export$171cf93cb8c45e5d() {
    const animationContainerRef = (0, $ltGt3.useRef)(null);
    (0, $ltGt3.useLayoutEffect)(()=>{
        let vantaEffect = null;
        (async ()=>{
        // const [{default: p5}, {default: vantaTopology}] = await Promise.all([
        //   import('p5'),
        //   import('vanta/src/vanta.topology.js'),
        // ])
        // p5['disableSketchChecker'] = true
        // vantaEffect = vantaTopology({
        //   el: animationContainerRef.current,
        //   p5: p5,
        //   color: '#fff6e7',
        //   backgroundColor: '#317041',
        // })
        })();
        return ()=>{
            if (vantaEffect) vantaEffect.destroy();
        };
    }, []);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "coming-soon",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "coming-soon__animation-container",
                ref: animationContainerRef
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "coming-soon__info",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "logo",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($c57fa23ac9c77f20$exports)))
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h1", {
                        children: "Coming soon"
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        className: "coming-soon__info__contact",
                        children: [
                            "Follow us:",
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("a", {
                                href: "https://instagram.com/terrasketch.app",
                                target: "_blank",
                                rel: "noreferer noopener",
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $59c3f0ee037ec04a$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $ltGt3 = parcelRequire("ltGt3");







var $ltGt3 = parcelRequire("ltGt3");




const $c838bdb408d971ee$export$26261a22216d6763 = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $c838bdb408d971ee$export$11cade6ce1ea211f = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{6,}/g;


function $41c1e0b26f8eb524$export$3bd2b4ee8d70ffe2(props) {
    const [form] = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useForm();
    const [isSubmitting, setSubmitting] = (0, $ltGt3.useState)(false);
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const password1 = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useWatch('password1', form);
    const password2 = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useWatch('password2', form);
    const passwordsMatch = password1 === password2;
    const validateMessages = {
        required: intl.formatMessage({
            id: 'fieldIsRequired'
        }, {
            field: '${label}'
        }),
        types: {
            email: intl.formatMessage({
                id: 'emailIsIncorrect'
            })
        },
        pattern: {
            mismatch: intl.formatMessage({
                id: 'passwordValidation'
            })
        }
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $b56d75f9dce54730$export$2e2bcd8739ae039), {
                form: form,
                layout: "vertical",
                style: {
                    width: 500
                },
                validateMessages: validateMessages,
                onFinish: async (formState)=>{
                    setSubmitting(true);
                    let result;
                    const signUp = {
                        email: formState.email,
                        password1: formState.password1,
                        password2: formState.password2
                    };
                    setSubmitting(false);
                    if (passwordsMatch) {
                        result = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).signUpEmailPassword(signUp.email, signUp.password1);
                        if (result.success) {
                            revalidator.revalidate();
                            props.setEmailSent(true);
                        } else messageApi.open({
                            type: 'error',
                            content: result.error?.message
                        });
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        name: "email",
                        label: intl.formatMessage({
                            id: 'email'
                        }),
                        rules: [
                            {
                                required: true,
                                type: 'email'
                            }
                        ],
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        name: "password1",
                        label: intl.formatMessage({
                            id: 'password'
                        }),
                        rules: [
                            {
                                required: true,
                                pattern: (0, $c838bdb408d971ee$export$11cade6ce1ea211f)
                            }
                        ],
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).Password, {})
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        name: "password2",
                        label: intl.formatMessage({
                            id: 'repeatPassword'
                        }),
                        rules: [
                            {
                                required: true
                            },
                            {
                                validator (_rule, value) {
                                    if (value !== password1) return Promise.reject(intl.formatMessage({
                                        id: 'passwordMismatch'
                                    }));
                                    return Promise.resolve();
                                }
                            }
                        ],
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).Password, {})
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            htmlType: "submit",
                            size: "large",
                            type: "primary",
                            style: {
                                width: '100%'
                            },
                            children: intl.formatMessage({
                                id: 'continue'
                            })
                        })
                    })
                ]
            })
        ]
    });
}



function $c444ab16c9a31f55$export$265471dcab9022d3() {
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const [isEmailSent, setEmailSent] = (0, $ltGt3.useState)(false);
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        style: {
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                    className: "logo",
                    to: "/",
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h1", {
                        children: "TerraSketch"
                    })
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                    children: intl.formatMessage({
                        id: 'signUp'
                    })
                }),
                isEmailSent ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "email-check",
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            children: intl.formatMessage({
                                id: 'checkYourEmail'
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            size: "large",
                            type: "primary",
                            onClick: async ()=>{
                                navigate('/login');
                            },
                            children: intl.formatMessage({
                                id: 'ok'
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $9d004cf64875b9d1$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $41c1e0b26f8eb524$export$3bd2b4ee8d70ffe2), {
                            setEmailSent: setEmailSent
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $fa9c689edb05e85b$export$2e2bcd8739ae039), {}),
                            size: "large",
                            onClick: async ()=>{
                                const result = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).signUpGoogle();
                                if (!result.success) messageApi.open({
                                    type: 'error',
                                    content: result.error.message
                                });
                                else navigate('/home');
                            },
                            children: intl.formatMessage({
                                id: 'signUpWithGoogle'
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            style: {
                                textAlign: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    children: [
                                        intl.formatMessage({
                                            id: 'byClickingSignUpWithGoogle'
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                    to: "/#",
                                    children: intl.formatMessage({
                                        id: 'policyTerrasketch'
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            style: {
                                textAlign: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                    children: intl.formatMessage({
                                        id: 'ifYouHaveAccount'
                                    })
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                    to: "/login",
                                    children: intl.formatMessage({
                                        id: 'logIn'
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



parcelRequire("ltGt3");


function $cf3491f814c58ba2$export$e9859ad90648930b() {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h1", {
                children: "TerraSketch Privacy Policy"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "Last updated: February 17, 2024"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                children: "Interpretation and Definitions"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                children: "Interpretation"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                children: "Definitions"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "For the purposes of this Privacy Policy:"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Account"
                                }),
                                " means a unique account created for You to access our Service or parts of our Service."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Affiliate"
                                }),
                                ' means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.'
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Company"
                                }),
                                ' (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to TerraSketch.'
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Cookies"
                                }),
                                " are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Country"
                                }),
                                " refers to: Poland"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Device"
                                }),
                                " means any device that can access the Service such as a computer, a cellphone or a digital tablet."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Personal Data"
                                }),
                                " is any information that relates to an identified or identifiable individual."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Service"
                                }),
                                " refers to the Website."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Service Provider"
                                }),
                                " means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Third-party Social Media Service"
                                }),
                                " refers to any website or any social network website through which a User can log in or create an account to use the Service."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Usage Data"
                                }),
                                " refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit)."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Website"
                                }),
                                " refers to TerraSketch, accessible from",
                                ' ',
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                    to: "https://terrasketch.app/",
                                    rel: "external nofollow noopener",
                                    target: "_blank",
                                    children: "https://terrasketch.app/"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "You"
                                }),
                                " means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                children: "Collecting and Using Your Personal Data"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                children: "Types of Data Collected"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h4", {
                children: "Personal Data"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                            children: "Email address"
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                            children: "Usage Data"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h4", {
                children: "Usage Data"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "Usage Data is collected automatically when using the Service."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h4", {
                children: "Information from Third-Party Social Media Services"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "The Company allows You to create an account and log in to use the Service through Google, a Third-party Social Media Service."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "If You decide to register through or otherwise grant us access to a Third-Party Social Media Service, We may collect Personal data that is already associated with Your Third-Party Social Media Service's account, such as Your name, Your email address, Your activities or Your contact list associated with that account."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "You may also have the option of sharing additional information with the Company through Your Third-Party Social Media Service's account. If You choose to provide such information and Personal Data, during registration or otherwise, You are giving the Company permission to use, share, and store it in a manner consistent with this Privacy Policy."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h4", {
                children: "Tracking Technologies and Cookies"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies We use may include:"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                children: "Cookies or Browser Cookies."
                            }),
                            " A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies."
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                children: "Web Beacons."
                            }),
                            " Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity)."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: 'Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser.'
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "We use both Session and Persistent Cookies for the purposes set out below:"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Necessary / Essential Cookies"
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                children: "Type: Session Cookies"
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                children: "Administered by: Us"
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                children: "Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Cookies Policy / Notice Acceptance Cookies"
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                children: "Type: Persistent Cookies"
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                children: "Administered by: Us"
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                children: "Purpose: These Cookies identify if users have accepted the use of cookies on the Website."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "Functionality Cookies"
                                })
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                children: "Type: Persistent Cookies"
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                children: "Administered by: Us"
                            }),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                children: "Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                children: "Use of Your Personal Data"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "The Company may use Personal Data for the following purposes:"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "To provide and maintain our Service"
                                }),
                                ", including to monitor the usage of our Service."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "To manage Your Account:"
                                }),
                                " to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "For the performance of a contract:"
                                }),
                                " the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "To contact You:"
                                }),
                                " To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "To provide You"
                                }),
                                " with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "To manage Your requests:"
                                }),
                                " To attend and manage Your requests to Us."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "For business transfers:"
                                }),
                                " We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                    children: "For other purposes"
                                }),
                                ": We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "We may share Your personal information in the following situations:"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                children: "With Service Providers:"
                            }),
                            " We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You."
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                children: "For business transfers:"
                            }),
                            " We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company."
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                children: "With Affiliates:"
                            }),
                            " We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us."
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                children: "With business partners:"
                            }),
                            " We may share Your information with Our business partners to offer You certain products, services or promotions."
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                children: "With other users:"
                            }),
                            " when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside. If You interact with other users or register through a Third-Party Social Media Service, Your contacts on the Third-Party Social Media Service may see Your name, profile, pictures and description of Your activity. Similarly, other users will be able to view descriptions of Your activity, communicate with You and view Your profile."
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("strong", {
                                children: "With Your consent"
                            }),
                            ": We may disclose Your personal information for any other purpose with Your consent."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                children: "Retention of Your Personal Data"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                children: "Transfer of Your Personal Data"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to \u2014 and maintained on \u2014 computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                children: "Delete Your Personal Data"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "Our Service may give You the ability to delete certain information about You from within the Service."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                children: "Disclosure of Your Personal Data"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h4", {
                children: "Business Transactions"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h4", {
                children: "Law enforcement"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency)."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h4", {
                children: "Other legal requirements"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: "Comply with a legal obligation"
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: "Protect and defend the rights or property of the Company"
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: "Prevent or investigate possible wrongdoing in connection with the Service"
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: "Protect the personal safety of Users of the Service or the public"
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("li", {
                        children: "Protect against legal liability"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                children: "Security of Your Personal Data"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                children: "Children's Privacy"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                children: "Links to Other Websites"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                children: "Changes to this Privacy Policy"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: 'We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.'
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page."
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                children: "Contact Us"
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                children: "If you have any questions about this Privacy Policy, You can contact us by email: terrasketch.info@gmail.com"
            })
        ]
    });
}







var $ltGt3 = parcelRequire("ltGt3");




const { confirm: $77093591b2bff7c8$var$confirm } = (0, $f189c84ec54ae7cf$export$2e2bcd8739ae039);
function $77093591b2bff7c8$export$ecdc3cf9d1cfe143() {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    //const [form] = Form.useForm()
    const [isSubmitting, setSubmitting] = (0, $ltGt3.useState)(false);
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const { userSettings: userSettings } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('user');
    const [isEmailSent, setEmailSent] = (0, $ltGt3.useState)(false);
    const app = (0, $4f475c9b6cb2d3a2$export$2e2bcd8739ae039).useApp();
    const showConfirm = ()=>{
        app.modal.confirm({
            title: intl.formatMessage({
                id: 'doYouReallyWantToDeleteThisAccount'
            }),
            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e95182a359f0bb22$export$2e2bcd8739ae039), {}),
            content: intl.formatMessage({
                id: 'yourActionsCannotBeUndone'
            }),
            async onOk () {
                const result = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).deleteCurrentUser();
                if (result.success) //document.cookie = 'supabase-auth-token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT'
                navigate('/');
            }
        });
    };
    // useEffect(() => {
    //   form.setFieldsValue(userSettings)
    // }, [userSettings])
    const user = (0, $d433dc3c3e640619$export$3901076af3749fa9)();
    if (!user) return null;
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                style: {
                    marginBottom: 40
                },
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                    children: intl.formatMessage({
                        id: 'userSettings'
                    })
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                        children: [
                            intl.formatMessage({
                                id: 'userEmail'
                            }),
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                        style: {
                            fontStyle: 'italic'
                        },
                        children: userSettings.email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    width: 'min-content'
                },
                children: [
                    isEmailSent ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        children: intl.formatMessage({
                            id: 'checkYourEmail'
                        })
                    }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        style: {
                            marginTop: '30px'
                        },
                        onClick: async ()=>{
                            (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).resetPassword(userSettings.email);
                            setEmailSent(true);
                        },
                        children: intl.formatMessage({
                            id: 'changePassword'
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        style: {
                            marginTop: '30px'
                        },
                        danger: true,
                        onClick: showConfirm,
                        children: intl.formatMessage({
                            id: 'deleteAccount'
                        })
                    })
                ]
            })
        ]
    });
}



parcelRequire("ltGt3");








var $Ohofd = parcelRequire("Ohofd");

(0, $e1ba9a64f0845235$export$d8abd7e5fb6871f9)['src'];
function $e5e6fea58ba80009$export$8f6ed4bdad4b778c() {
    const { news: news, newsList: newsList } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('news');
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "news-page home-layout__content",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "news-page__text",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                        style: {
                            minWidth: '100%',
                            height: 200,
                            objectFit: 'cover'
                        },
                        alt: "image",
                        src: news.titlePhotoURL ? news.titlePhotoURL : (0, (/*@__PURE__*/$parcel$interopDefault($f0a4ffbb486b57b4$exports)))
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h1", {
                        children: intl.locale === 'en' ? news.newsName : news.newsNameRU
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                        style: {
                            color: 'rgba(0,0,0,0.45)'
                        },
                        children: [
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9c348dd92383621c$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                style: {
                                    marginLeft: '10px'
                                },
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(news.dateOfCreating).format('ll')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $fe71a44f130a0d39$export$7460c8b7e4ce9582), {
                        className: "news-page__text__description",
                        skipHtml: true,
                        children: intl.locale === 'en' ? news.text : news.textRU
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "news-page__list",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $ad1c3304c519fac5$export$2e2bcd8739ae039), {
                    className: "news-page__list__card",
                    title: intl.formatMessage({
                        id: 'otherNews'
                    }),
                    styles: {
                        header: {
                            borderBottom: '1px solid #f0f0f0'
                        },
                        body: {
                            paddingTop: 16
                        }
                    },
                    cover: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "news-page__list__card__orange-stripe"
                    }),
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039), {
                            dataSource: newsList,
                            split: true,
                            renderItem: (item)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039).Item, {
                                    style: {
                                        padding: '14px 0'
                                    },
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039).Item.Meta, {
                                        avatar: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $54759b2dc7aee7a8$export$2e2bcd8739ae039), {
                                            src: item.titlePhotoURL,
                                            alt: item.newsName,
                                            width: 72,
                                            height: 72,
                                            preview: false,
                                            style: {
                                                borderRadius: 8,
                                                objectFit: 'cover'
                                            }
                                        }),
                                        title: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("a", {
                                            href: `/home/news/${item.url}`,
                                            style: {
                                                color: 'rgba(0,0,0,0.88)',
                                                fontWeight: 600,
                                                lineHeight: 1.25,
                                                display: 'inline-block'
                                            },
                                            children: intl.locale === 'en' ? item.newsName : item.newsNameRU
                                        }),
                                        description: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                                    style: {
                                                        color: 'rgba(0,0,0,0.45)'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9c348dd92383621c$export$2e2bcd8739ae039), {}),
                                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                            style: {
                                                                marginLeft: '10px'
                                                            },
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(item.dateOfCreating).format('ll')
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                                    className: "news-page__list__card__news-tag",
                                                    children: intl.formatMessage({
                                                        id: `tag-${item.newsType}`
                                                    })
                                                }),
                                                (item.tags || []).map((t)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                                        className: "news-page__list__card__news-tag",
                                                        style: {
                                                            color: t.color ? t.color : '#f58153'
                                                        },
                                                        children: intl.locale === 'en' ? t.tagName : t.tagNameRu
                                                    }, t.id))
                                            ]
                                        })
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                            style: {
                                margin: '12px 0'
                            }
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("a", {
                            className: "news-page__list__card__to-all",
                            href: "/home/news",
                            children: [
                                intl.formatMessage({
                                    id: `allNews`
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $532bc1903b13fec2$export$2e2bcd8739ae039), {
                                    style: {
                                        paddingLeft: '5px'
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




parcelRequire("ltGt3");






function $589b3104a4ffe1e7$export$d50ff52389c11f75() {
    const { unfinishedUserToDos: unfinishedUserToDos = [], plantedPlantsNamesWithId: plantedPlantsNamesWithId = [] } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('homeAll');
    const user = (0, $d433dc3c3e640619$export$3901076af3749fa9)();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const { token: { controlHeightSM: controlHeightSM } } = (0, $dab4aa82f341ad46$export$2e2bcd8739ae039).useToken();
    if (!user) return null;
    const navigation = (0, $493cbc5b00d91baa$export$d0fd4b7106de2769)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "home-layout",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $493cbc5b00d91baa$export$910ae8079b2c2852), {}),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "home-layout__calendar",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $75d4ef8c0094c908$export$4cc5481925352c83), {
                    todos: unfinishedUserToDos
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "home-layout__reminders",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e5058ab3fce1e2a7$export$30b98ae171787f1a), {
                    todos: unfinishedUserToDos,
                    plantedPlantsNamesWithId: plantedPlantsNamesWithId
                })
            })
        ]
    });
}






var $ltGt3 = parcelRequire("ltGt3");






var $ltGt3 = parcelRequire("ltGt3");



var $Ohofd = parcelRequire("Ohofd");







var $ltGt3 = parcelRequire("ltGt3");


var $Ohofd = parcelRequire("Ohofd");




(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).extend((0, (/*@__PURE__*/$parcel$interopDefault($89358fe654dbfc1b$exports))));
// The filters are stored as objects keyed by type/plant id, so the selection
// always travels as the string keys of those objects.
function $a5c89ae8328ae3bb$var$toSelectionMap(values) {
    return Object.fromEntries(values.map((value)=>[
            value,
            true
        ]));
}
function $a5c89ae8328ae3bb$export$28a619364da3b01c({ plantedPlantsNamesWithId: plantedPlantsNamesWithId, userToDoTypes: userToDoTypes, filters: filters, setFilters: setFilters }) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const typeOptions = (0, $ltGt3.useMemo)(()=>[
            ...(0, $6dfc071b399cc1b6$export$b406e03ca3884ba).map((type)=>({
                    value: type,
                    label: intl.formatMessage({
                        id: `eventType-${type}`
                    }),
                    icon: (0, $6dfc071b399cc1b6$export$2a2c75ecbbc622ea)[type].icon
                })),
            ...userToDoTypes.flatMap(({ customToDoType: customToDoType })=>customToDoType ? [
                    {
                        value: String(customToDoType.id),
                        label: customToDoType.name,
                        icon: customToDoType.icon
                    }
                ] : [])
        ], [
        userToDoTypes,
        intl
    ]);
    const typeIcons = (0, $ltGt3.useMemo)(()=>Object.fromEntries(typeOptions.map((option)=>[
                option.value,
                option.icon
            ])), [
        typeOptions
    ]);
    const plantOptions = (0, $ltGt3.useMemo)(()=>plantedPlantsNamesWithId.map(({ id: id, name: name })=>({
                value: String(id),
                label: name
            })), [
        plantedPlantsNamesWithId
    ]);
    const datePresets = [
        {
            label: intl.formatMessage({
                id: 'today'
            }),
            value: [
                (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(),
                (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))()
            ]
        },
        {
            label: intl.formatMessage({
                id: 'thisWeek'
            }),
            value: [
                (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().weekday(0),
                (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().weekday(6)
            ]
        },
        {
            label: intl.formatMessage({
                id: 'thisMonth'
            }),
            value: [
                (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().startOf('month'),
                (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().endOf('month')
            ]
        }
    ];
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $b56d75f9dce54730$export$2e2bcd8739ae039), {
        className: "todo__filters-small",
        layout: "vertical",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                label: intl.formatMessage({
                    id: 'taskTypes'
                }),
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
                    mode: "multiple",
                    allowClear: true,
                    placeholder: intl.formatMessage({
                        id: 'chooseType'
                    }),
                    value: Object.keys(filters.types),
                    options: typeOptions,
                    optionFilterProp: "label",
                    optionRender: (option)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                            className: "todo__filters-small__type-item",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f952978d00baf9e4$export$60d30b2661acb1b8), {
                                    id: option.data.icon,
                                    size: "1em"
                                }),
                                " ",
                                option.data.label
                            ]
                        }),
                    labelRender: ({ label: label, value: value })=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                            className: "todo__filters-small__type-item",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f952978d00baf9e4$export$60d30b2661acb1b8), {
                                    id: typeIcons[value],
                                    size: "1em"
                                }),
                                " ",
                                label
                            ]
                        }),
                    onChange: (values)=>setFilters({
                            ...filters,
                            types: $a5c89ae8328ae3bb$var$toSelectionMap(values)
                        })
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                label: intl.formatMessage({
                    id: 'plants'
                }),
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
                    mode: "multiple",
                    allowClear: true,
                    placeholder: intl.formatMessage({
                        id: 'plants'
                    }),
                    value: Object.keys(filters.plants),
                    options: plantOptions,
                    optionFilterProp: "label",
                    onChange: (values)=>setFilters({
                            ...filters,
                            plants: $a5c89ae8328ae3bb$var$toSelectionMap(values)
                        })
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                label: intl.formatMessage({
                    id: 'date'
                }),
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e846e12ce1da647b$export$17334619f3ac2224), {
                    value: [
                        filters.startDate ? (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(filters.startDate) : null,
                        filters.endDate ? (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(filters.endDate) : null
                    ],
                    presets: datePresets,
                    onChange: (dates)=>setFilters({
                            ...filters,
                            startDate: dates?.[0]?.toDate() || undefined,
                            endDate: dates?.[1]?.toDate() || undefined
                        })
                })
            })
        ]
    });
}



(0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).extend((0, (/*@__PURE__*/$parcel$interopDefault($89358fe654dbfc1b$exports))));
const $2579e621b3c141c2$var$onPanelChange = (value, mode)=>{
// console.log(value.format('YYYY-MM-DD'), mode)
};
const $2579e621b3c141c2$var$dateFormat = 'YYYY/MM/DD';
const $2579e621b3c141c2$var$toDoSortingFields = [
    'date',
    'plants',
    'taskType'
];
function $2579e621b3c141c2$export$b2b7a46ff48ca9d6(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const calendarRef = (0, $ltGt3.useRef)(null);
    // the plants column drops off the row before the panel itself runs out of width
    const isNarrow = (0, $37433922b4b56270$export$323ff2a228bf6a81)();
    const isMobileNarrow = (0, $37433922b4b56270$export$83fa72011cf1e8d2)();
    const [filtersCollapsed, setFiltersCollapsed] = (0, $ltGt3.useState)(true);
    const plantNameLookup = (0, $ltGt3.useMemo)(()=>{
        // keyed by string because the ids come back out of Object.keys
        const lookup = {};
        for (const { id: id, name: name } of props.plantedPlantsNamesWithId)lookup[id] = name;
        return lookup;
    }, [
        props.plantedPlantsNamesWithId
    ]);
    const hasDateFilter = props.filters.startDate && props.filters.endDate;
    const hasTypeFilter = Object.keys(props.filters.types).length > 0;
    const hasPlantFilter = Object.keys(props.filters.plants).length > 0;
    const hasFilters = hasDateFilter || hasTypeFilter || hasPlantFilter;
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f7961d3e6a10fa4b$export$2e2bcd8739ae039), {
        className: "todo__filters-collapse",
        bordered: false,
        activeKey: filtersCollapsed ? [] : [
            '0'
        ],
        onChange: (k)=>setFiltersCollapsed(k[0] === '0' ? false : true),
        items: [
            {
                key: '0',
                label: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("h4", {
                            style: {
                                display: 'inline'
                            },
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $805fc64935351fe7$export$2e2bcd8739ae039), {}),
                                " ",
                                intl.formatMessage({
                                    id: 'filtersAndSorting'
                                }),
                                hasFilters && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                    style: {
                                        marginLeft: 30,
                                        fontWeight: 400
                                    },
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("a", {
                                        onClick: (e)=>{
                                            props.setFilters({
                                                plants: {},
                                                types: {},
                                                startDate: undefined,
                                                endDate: undefined
                                            });
                                            e.stopPropagation();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1e0519456d104339$export$2e2bcd8739ae039), {}),
                                            " ",
                                            intl.formatMessage({
                                                id: 'clearFilters'
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        filtersCollapsed && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            children: [
                                hasTypeFilter ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("em", {
                                            children: [
                                                intl.formatMessage({
                                                    id: 'taskTypes'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        ' ',
                                        Object.keys(props.filters.types).map((type)=>intl.formatMessage({
                                                id: `eventType-${type}`
                                            })).join(', ')
                                    ]
                                }) : null,
                                hasDateFilter ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("em", {
                                            children: [
                                                intl.formatMessage({
                                                    id: 'date'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        ' ',
                                        (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(props.filters.startDate).format($2579e621b3c141c2$var$dateFormat),
                                        " -",
                                        ' ',
                                        (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(props.filters.endDate).format($2579e621b3c141c2$var$dateFormat)
                                    ]
                                }) : null,
                                hasPlantFilter ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("em", {
                                            children: [
                                                intl.formatMessage({
                                                    id: 'plants'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        ' ',
                                        Object.keys(props.filters.plants).map((plantId)=>plantNameLookup[plantId]).join(', ')
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("em", {
                                            children: [
                                                intl.formatMessage({
                                                    id: 'sortingBy'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        ' ',
                                        intl.formatMessage({
                                            id: props.sortingField
                                        }),
                                        props.sortingDirection ? " \u2191" : " \u2193"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "todo__filters__sorting",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("em", {
                                    children: [
                                        intl.formatMessage({
                                            id: 'sortBy'
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "todo__filters__sorting__controls",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
                                            value: props.sortingField,
                                            onChange: (value)=>props.setSortingField(value),
                                            options: $2579e621b3c141c2$var$toDoSortingFields.map((field)=>({
                                                    value: field,
                                                    label: intl.formatMessage({
                                                        id: field
                                                    })
                                                }))
                                        }),
                                        isMobileNarrow ? // the icon carries the direction on its own, leaving the row's
                                        // width to the field select - same control as the plants page
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                                            "aria-label": intl.formatMessage({
                                                id: props.sortingDirection ? 'sortingDirectionAsc' : 'sortingDirectionDesc'
                                            }),
                                            icon: props.sortingDirection ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $36f7eb0e6ad26c47$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $867e72afe7ade565$export$2e2bcd8739ae039), {}),
                                            onClick: ()=>props.setSortingDirection(!props.sortingDirection)
                                        }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $833302d2cabce31e$export$2e2bcd8739ae039), {
                                            value: props.sortingDirection,
                                            onChange: (value)=>props.setSortingDirection(value),
                                            options: [
                                                {
                                                    value: false,
                                                    label: intl.formatMessage({
                                                        id: `sortingDirectionDesc`
                                                    })
                                                },
                                                {
                                                    value: true,
                                                    label: intl.formatMessage({
                                                        id: `sortingDirectionAsc`
                                                    })
                                                }
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        isNarrow ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a5c89ae8328ae3bb$export$28a619364da3b01c), {
                            plantedPlantsNamesWithId: props.plantedPlantsNamesWithId,
                            userToDoTypes: props.userToDoTypes,
                            filters: props.filters,
                            setFilters: props.setFilters
                        }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            className: "todo__filters",
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "todo__filters__type",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("h4", {
                                            children: [
                                                intl.formatMessage({
                                                    id: 'taskTypes'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039), {
                                            className: "todo__filters__list",
                                            itemLayout: "horizontal",
                                            dataSource: [
                                                ...(0, $6dfc071b399cc1b6$export$b406e03ca3884ba).map((type)=>({
                                                        key: type,
                                                        name: intl.formatMessage({
                                                            id: `eventType-${type}`
                                                        }),
                                                        icon: (0, $6dfc071b399cc1b6$export$2a2c75ecbbc622ea)[type].icon
                                                    })),
                                                // a type the user deleted has no name left to filter by
                                                ...props.userToDoTypes.flatMap(({ customToDoType: customToDoType })=>customToDoType ? [
                                                        {
                                                            key: customToDoType.id,
                                                            name: customToDoType.name,
                                                            icon: customToDoType.icon
                                                        }
                                                    ] : [])
                                            ],
                                            renderItem: (item)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039).Item, {
                                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                                                            checked: props.filters.types[item.key],
                                                            onChange: (e)=>{
                                                                const { checked: checked } = e.target;
                                                                props.setFilters({
                                                                    ...props.filters,
                                                                    types: {
                                                                        ...props.filters.types,
                                                                        [item.key]: checked
                                                                    }
                                                                });
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f952978d00baf9e4$export$60d30b2661acb1b8), {
                                                                    id: item.icon,
                                                                    size: "1em"
                                                                }),
                                                                " ",
                                                                item.name
                                                            ]
                                                        })
                                                    })
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                    className: "todo__filters__date",
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                        className: "todo__filters__date__calendar",
                                        ref: calendarRef,
                                        children: [
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("h4", {
                                                children: [
                                                    intl.formatMessage({
                                                        id: 'date'
                                                    }),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $878317098e859dd0$export$2e2bcd8739ae039).RangePicker, {
                                                value: [
                                                    props.filters.startDate ? (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(props.filters.startDate) : null,
                                                    props.filters.endDate ? (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(props.filters.endDate) : null
                                                ],
                                                format: $2579e621b3c141c2$var$dateFormat,
                                                open: true,
                                                getPopupContainer: ()=>calendarRef.current,
                                                classNames: {
                                                    popup: {
                                                        root: 'todo__filters__date__calendar__container__calendar'
                                                    }
                                                },
                                                onChange: (values)=>props.setFilters({
                                                        ...props.filters,
                                                        startDate: values?.[0]?.toDate() || undefined,
                                                        endDate: values?.[1]?.toDate() || undefined
                                                    }),
                                                presets: [
                                                    {
                                                        label: intl.formatMessage({
                                                            id: 'today'
                                                        }),
                                                        value: [
                                                            (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(),
                                                            (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))()
                                                        ]
                                                    },
                                                    {
                                                        label: intl.formatMessage({
                                                            id: 'thisWeek'
                                                        }),
                                                        value: [
                                                            (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().weekday(0),
                                                            (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().weekday(6)
                                                        ]
                                                    },
                                                    {
                                                        label: intl.formatMessage({
                                                            id: 'thisMonth'
                                                        }),
                                                        value: [
                                                            (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().startOf('month'),
                                                            (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().endOf('month')
                                                        ]
                                                    }
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                                className: "todo__filters__date__calendar__container",
                                                ref: calendarRef
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                    className: "todo__filters__plants",
                                    children: [
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("h4", {
                                            children: [
                                                intl.formatMessage({
                                                    id: 'plants'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039), {
                                            className: "todo__filters__list",
                                            itemLayout: "horizontal",
                                            dataSource: props.plantedPlantsNamesWithId,
                                            renderItem: (item)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039).Item, {
                                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0fa8595e616a52f3$export$2e2bcd8739ae039), {
                                                            checked: props.filters.plants[item.id],
                                                            onChange: (e)=>props.setFilters({
                                                                    ...props.filters,
                                                                    plants: {
                                                                        ...props.filters.plants,
                                                                        [item.id]: e.target.checked
                                                                    }
                                                                }),
                                                            children: item.name
                                                        })
                                                    })
                                                })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }
        ]
    });
}



var $Ohofd = parcelRequire("Ohofd");

// Deleting a custom task type leaves the reference behind on the tasks that
// used it, so the type is not always there to be named.
function $43a3259999c1d9b3$var$toDoTypeName(todo) {
    const type = todo.type;
    if (!type || !type.type) return '';
    return type.type === 'custom' ? type.customToDoType?.name || '' : type.type;
}
// the task is filed under whichever of its plants comes first alphabetically
function $43a3259999c1d9b3$var$firstPlantName(todo) {
    const plants = todo.plants;
    if (!plants || plants.length === 0) return '';
    return [
        ...plants
    ].sort((p1, p2)=>(p1.name || '').localeCompare(p2.name || ''))[0].name || '';
}
function $43a3259999c1d9b3$export$e536ffce05fd41e1(todos, sortingField, sortingDirection) {
    const sortedToDos = todos.sort((todo1, todo2)=>{
        if (sortingField === 'plants') {
            const plant1 = $43a3259999c1d9b3$var$firstPlantName(todo1);
            const plant2 = $43a3259999c1d9b3$var$firstPlantName(todo2);
            return sortingDirection ? plant1.localeCompare(plant2) : plant1.localeCompare(plant2) * -1;
        } else if (sortingField === 'taskType') {
            const type1 = $43a3259999c1d9b3$var$toDoTypeName(todo1);
            const type2 = $43a3259999c1d9b3$var$toDoTypeName(todo2);
            return sortingDirection ? type1.localeCompare(type2) : type1.localeCompare(type2) * -1;
        } else if (sortingField === 'date') {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(todo1.targetStartDateUtc, (0, $ec20113856fdaafd$export$4e4cb19dd88cd821)) < (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(todo2.targetStartDateUtc, (0, $ec20113856fdaafd$export$4e4cb19dd88cd821))) return sortingDirection ? -1 : 1;
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(todo1.targetStartDateUtc, (0, $ec20113856fdaafd$export$4e4cb19dd88cd821)) > (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(todo2.targetStartDateUtc, (0, $ec20113856fdaafd$export$4e4cb19dd88cd821))) return sortingDirection ? 1 : -1;
            else return 0;
        }
        return 0;
    });
    return sortedToDos;
}




var $ltGt3 = parcelRequire("ltGt3");





function $6360bc90d10715e3$export$4f504dc4a1251584(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    // the full form's four columns have no room on a narrow screen
    const isMobileNarrow = (0, $37433922b4b56270$export$83fa72011cf1e8d2)();
    const [newTodoFormCollapsed, setNewTodoFormCollapsed] = (0, $ltGt3.useState)(true);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        style: {
            width: '100%'
        },
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f7961d3e6a10fa4b$export$2e2bcd8739ae039), {
            bordered: false,
            activeKey: newTodoFormCollapsed ? [] : [
                '0'
            ],
            onChange: (k)=>setNewTodoFormCollapsed(k[0] === '0' ? false : true),
            items: [
                {
                    key: '0',
                    label: intl.formatMessage({
                        id: 'addNewTask'
                    }),
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $cd7dce9aaa9186a9$export$9e07cf364e4725cb), {
                        plantedPlantsNamesWithId: props.plantedPlantsNamesWithId,
                        isFullForm: !isMobileNarrow,
                        toDoTypes: props.toDoTypes,
                        closeModal: async ()=>setNewTodoFormCollapsed(true),
                        userPlantCollections: props.userPlantCollections,
                        userPlantCollectionsWithPlantsIds: props.userPlantCollectionsWithPlantsIds,
                        userEventTypes: []
                    })
                }
            ]
        })
    });
}



parcelRequire("ltGt3");





var $ltGt3 = parcelRequire("ltGt3");









function $7c86cbdfab721d10$export$3914c7e0aa99ad3f(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const [isLoading, setLoading] = (0, $ltGt3.useState)(false);
    const submit = (0, $6816d30a3e97278a$export$47c85c6e3a081d3)();
    const [completionDate, setCompletionDate] = (0, $ltGt3.useState)(new Date());
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const actions = [
        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $792ee1d77f42b361$export$2e2bcd8739ae039), {
            onClick: ()=>navigate(`/todos/${props.todo.id}`)
        }, "edit"),
        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $851d8bae92f68e93$export$2e2bcd8739ae039), {
            placement: "bottom",
            title: intl.formatMessage({
                id: 'areYouSureYouWantToDelete'
            }),
            description: intl.formatMessage({
                id: 'thisOperationIsIrreversible'
            }),
            icon: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7fa69e90b193286$export$2e2bcd8739ae039), {
                style: {
                    color: 'red'
                }
            }),
            onConfirm: async ()=>{
                setLoading(true);
                const result = await (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).deleteToDo(props.todo.id);
                setLoading(false);
                if (result.success) submit(null, {
                    method: 'post'
                });
                else (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).warning(intl.formatMessage({
                    id: 'failedToDeleteTask'
                }));
            },
            okText: intl.formatMessage({
                id: 'yes'
            }),
            cancelText: intl.formatMessage({
                id: 'no'
            }),
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $1e0519456d104339$export$2e2bcd8739ae039), {
                disabled: isLoading,
                onClick: (e)=>e.stopPropagation()
            }, "delete")
        }),
        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275f7c91555fa32e$export$378cead5a31fefcf), {
            userJournalEventTypes: props.userJournalEventTypes,
            finishedTodo: props.todo,
            isText: false
        })
    ];
    const eventTypeInfo = (0, $6dfc071b399cc1b6$export$bd87dd6af1226f02)(props.todo.type);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        className: "todo__list__cards__card",
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ad1c3304c519fac5$export$2e2bcd8739ae039), {
            actions: actions,
            hoverable: true,
            className: "todo__list__cards__card__item",
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ad1c3304c519fac5$export$2e2bcd8739ae039).Meta, {
                // avatar={<Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=1" />}
                avatar: eventTypeInfo ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f952978d00baf9e4$export$60d30b2661acb1b8), {
                    id: eventTypeInfo.icon,
                    size: "1em"
                }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7fa69e90b193286$export$2e2bcd8739ae039), {}),
                title: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap'
                    },
                    children: [
                        props.todo.type && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                            style: {
                                color: 'black',
                                textWrap: 'initial'
                            },
                            to: `/todos/${props.todo.id}`,
                            children: props.todo.type.type === 'custom' || !props.todo.type.type ? eventTypeInfo.name : intl.formatMessage({
                                id: `eventType-${props.todo.type.type}`
                            })
                        }),
                        props.todo.importance && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                            color: props.todo.importance === 'urgent' ? 'red' : 'green',
                            children: intl.formatMessage({
                                id: props.todo.importance
                            })
                        })
                    ]
                }),
                description: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "todo__list__cards__card__description",
                    children: [
                        props.todo.plants && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                            children: props.todo.plants.map((plant, index)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                                    to: `/todos/${props.todo.id}/plants/${plant.id}`,
                                    children: [
                                        index !== 0 ? ', ' : '',
                                        plant.name,
                                        ' '
                                    ]
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                            style: {
                                display: 'flex'
                            },
                            children: [
                                props.todo.targetStartDateUtc && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                                    children: props.todo.targetStartDateUtc
                                }),
                                props.todo.targetEndDateUtc && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("p", {
                                    children: [
                                        " - ",
                                        props.todo.targetEndDateUtc
                                    ]
                                })
                            ]
                        }),
                        props.todo.comment && /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                            children: props.todo.comment
                        })
                    ]
                })
            })
        })
    });
}




var $Ohofd = parcelRequire("Ohofd");
const $ae400fdcb44e79e9$var$GROUP_ORDER = [
    'overdue',
    'today',
    'tomorrow',
    'laterThisWeek',
    'laterThisMonth',
    'nextMonth',
    'later',
    'noDate'
];
function $ae400fdcb44e79e9$var$getDateGroup(todo) {
    if (!todo.targetStartDateUtc) return 'noDate';
    const today = (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))().startOf('day');
    const date = (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(todo.targetStartDateUtc, (0, $ec20113856fdaafd$export$4e4cb19dd88cd821)).startOf('day');
    if (date.isBefore(today)) return 'overdue';
    if (date.isSame(today)) return 'today';
    if (date.isSame(today.add(1, 'day'))) return 'tomorrow';
    if (date.isSame(today, 'week')) return 'laterThisWeek';
    if (date.isSame(today, 'month')) return 'laterThisMonth';
    if (date.isSame(today.add(1, 'month'), 'month')) return 'nextMonth';
    return 'later';
}
function $ae400fdcb44e79e9$export$e1ba70b5461430a8(props) {
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const { userJournalEventTypes: userJournalEventTypes } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('todos');
    const groups = new Map();
    for (const group of $ae400fdcb44e79e9$var$GROUP_ORDER)groups.set(group, []);
    for (const todo of props.unfinishedToDos)groups.get($ae400fdcb44e79e9$var$getDateGroup(todo)).push(todo);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        style: {
            width: '100%'
        },
        children: $ae400fdcb44e79e9$var$GROUP_ORDER.map((group)=>{
            const todos = groups.get(group);
            if (todos.length === 0) return null;
            return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                className: "todo__group",
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h3", {
                        className: "todo__group__header",
                        children: intl.formatMessage({
                            id: `todoGroup-${group}`
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                        className: "todo__list__cards",
                        children: todos.map((todo)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7c86cbdfab721d10$export$3914c7e0aa99ad3f), {
                                todo: todo,
                                userJournalEventTypes: userJournalEventTypes
                            }, todo.id))
                    })
                ]
            }, group);
        })
    });
}






var $ltGt3 = parcelRequire("ltGt3");



function $d3bb1e19d023a492$export$713727c9f622e975({ routeWhenClosed: routeWhenClosed, unfinishedToDos: unfinishedToDos, toDoTypes: toDoTypes, userEventTypes: userEventTypes }) {
    const navigation = (0, $493cbc5b00d91baa$export$d0fd4b7106de2769)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const [isLoading, setLoading] = (0, $ltGt3.useState)(false);
    const routeParams = (0, $493cbc5b00d91baa$export$99eaa27ddbbb95ef)();
    const { mousePosition: mousePosition } = (0, $a97af2bd258d22ad$export$30c58b43fa91b94d)();
    const toDoPopupVisible = Boolean(routeParams.todoId) && !routeParams.plantId;
    const plantLoading = toDoPopupVisible && navigation.state === 'loading';
    const { plantedPlantsNamesWithId: plantedPlantsNamesWithId, userPlantCollections: userPlantCollections, userPlantCollectionsWithPlantsIds: userPlantCollectionsWithPlantsIds } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('todos');
    const toDoId = Number(routeParams.todoId);
    const plantId = Number(routeParams.plantId);
    const onClose = ()=>navigate(routeWhenClosed);
    const closeModal = ()=>{
        navigate(routeWhenClosed);
    };
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f189c84ec54ae7cf$export$2e2bcd8739ae039), {
        className: "todo-modal",
        open: toDoPopupVisible,
        onCancel: onClose,
        mousePosition: mousePosition || undefined,
        footer: null,
        destroyOnHidden: true,
        width: 800,
        loading: isLoading,
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $cd7dce9aaa9186a9$export$9e07cf364e4725cb), {
            currentToDo: unfinishedToDos.find((todo)=>todo.id === toDoId),
            plantedPlantsNamesWithId: plantedPlantsNamesWithId,
            toDoTypes: toDoTypes,
            userEventTypes: userEventTypes,
            closeModal: closeModal,
            setLoading: setLoading,
            isFullForm: false,
            userPlantCollections: userPlantCollections,
            userPlantCollectionsWithPlantsIds: userPlantCollectionsWithPlantsIds
        })
    });
}


function $8dbe7fe972b92695$export$19e0fcd208294781(obj) {
    const copy = {
        ...obj
    };
    for (const key of Object.keys(copy))if (!copy[key]) delete copy[key];
    return copy;
}
function $8dbe7fe972b92695$export$c1c10d961c680d69() {
    const { plantedPlantsNamesWithId: plantedPlantsNamesWithId = [], unfinishedToDos: unfinishedToDos = [], userToDoTypes: userToDoTypes, userJournalEventTypes: userJournalEventTypes, userPlantCollections: userPlantCollections, userPlantCollectionsWithPlantsIds: userPlantCollectionsWithPlantsIds } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('todos');
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const [userToDos, setUserToDos] = (0, $ltGt3.useState)(unfinishedToDos);
    const [filters, setFilters] = (0, $ltGt3.useState)({
        types: {},
        plants: {}
    });
    const [toDoSortingField, setToDoSortingField] = (0, $ltGt3.useState)('date');
    const [sortingDirection, setSortingDirection] = (0, $ltGt3.useState)(true);
    const filteredToDos = userToDos.filter((todo)=>{
        //TODO добавить проверку, если все фильтры пустые, - равнозначно, что все выбрано?
        const startDate = todo.targetStartDateUtc ? new Date(todo.targetStartDateUtc) : null;
        if (filters?.startDate) {
            if (!startDate || startDate < filters.startDate) return false;
        }
        if (filters?.endDate) {
            if (!startDate || startDate > filters.endDate) return false;
        }
        if (Object.keys(filters.types).length !== 0) {
            // read once so the union narrows across the branches
            const type = todo.type;
            if (!type || !type.type) return false;
            else if (type.type !== 'custom') {
                if (!filters.types[type.type]) return false;
            } else if (!type.customToDoType) return false;
            else if (!filters.types[type.customToDoType.id]) return false;
        }
        // if (
        //   Object.keys(filters.types).length !== 0 &&
        //   !(todo.type.type !== 'custom'
        //     ? filters.types[todo.type.type]
        //     : filters.types[todo.type.customToDoType.id])
        // ) {
        //   return false
        // }
        const firstPlantId = todo.plants?.[0]?.id;
        if (Object.keys(filters.plants).length !== 0 && (firstPlantId === undefined || !filters.plants[firstPlantId])) return false;
        return true;
    });
    const sortedFilteredToDos = (0, $43a3259999c1d9b3$export$e536ffce05fd41e1)(filteredToDos, toDoSortingField, sortingDirection);
    (0, $ltGt3.useEffect)(()=>{
        setUserToDos((current)=>current.map((todo)=>{
                const type = todo.type;
                if (!type || type.type !== 'custom') return todo;
                // a type the user has since deleted keeps its reference but loses its name
                const orphaned = {
                    type: 'custom',
                    customToDoType: null
                };
                const customToDoType = type.customToDoType;
                if (!customToDoType) return {
                    ...todo,
                    type: orphaned
                };
                const newType = userToDoTypes.find((x)=>x.customToDoType?.id === customToDoType.id);
                return {
                    ...todo,
                    type: newType ? newType : orphaned
                };
            }));
    }, [
        userToDoTypes
    ]);
    (0, $ltGt3.useEffect)(()=>{
        setUserToDos(unfinishedToDos);
    }, [
        unfinishedToDos
    ]);
    const refAddToDo = (0, $ltGt3.useRef)(null);
    const refToDoFilters = (0, $ltGt3.useRef)(null);
    const refToDoList = (0, $ltGt3.useRef)(null);
    const [openTour, setOpenTour] = (0, $ltGt3.useState)(false);
    const steps = [
        {
            title: intl.formatMessage({
                id: 'todoPage'
            }),
            description: intl.formatMessage({
                id: 'todoPageTourDescriptionAll'
            }),
            target: null
        },
        {
            title: intl.formatMessage({
                id: 'newTaskAdding'
            }),
            description: intl.formatMessage({
                id: 'todoPageTourDescriptionAdd'
            }),
            target: ()=>refAddToDo.current
        },
        {
            title: intl.formatMessage({
                id: 'todoLists'
            }),
            description: intl.formatMessage({
                id: 'todoPageTourDescriptionList'
            }),
            target: null
        },
        {
            title: intl.formatMessage({
                id: 'filtersAndSorting'
            }),
            description: intl.formatMessage({
                id: 'todoPageTourDescriptionFilter'
            }),
            target: null
        },
        {
            title: intl.formatMessage({
                id: 'taskEditing'
            }),
            description: intl.formatMessage({
                id: 'todoPageTourDescriptionEdit'
            }),
            placement: 'left',
            target: null
        },
        {
            title: intl.formatMessage({
                id: 'taskFinishing'
            }),
            description: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                        children: intl.formatMessage({
                            id: 'todoPageTourDescriptionEndTask1'
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                        children: intl.formatMessage({
                            id: 'todoPageTourDescriptionEndTask2'
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("p", {
                        children: intl.formatMessage({
                            id: 'todoPageTourDescriptionEndTask3'
                        })
                    })
                ]
            }),
            placement: 'left',
            target: null
        },
        {
            title: intl.formatMessage({
                id: 'taskDeleting'
            }),
            description: intl.formatMessage({
                id: 'todoPageTourDescriptionDeleteTask'
            }),
            target: null
        },
        {
            title: intl.formatMessage({
                id: 'plantPageWorkWithTodo'
            }),
            description: intl.formatMessage({
                id: 'todoPageTourDescriptionPlantPage'
            }),
            target: null
        }
    ];
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                style: {
                    justifyContent: 'space-between',
                    alignItems: 'baseline'
                },
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                        children: intl.formatMessage({
                            id: 'myToDos'
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                        onClick: ()=>setOpenTour(true),
                        children: intl.formatMessage({
                            id: 'todoPageTour'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                className: "todo__new",
                ref: refAddToDo,
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6360bc90d10715e3$export$4f504dc4a1251584), {
                    plantedPlantsNamesWithId: plantedPlantsNamesWithId,
                    toDoTypes: userToDoTypes,
                    userPlantCollections: userPlantCollections,
                    userPlantCollectionsWithPlantsIds: userPlantCollectionsWithPlantsIds
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                ref: refToDoFilters,
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2579e621b3c141c2$export$b2b7a46ff48ca9d6), {
                    plantedPlantsNamesWithId: plantedPlantsNamesWithId,
                    userToDoTypes: userToDoTypes,
                    filters: filters,
                    setFilters: (newFilters)=>{
                        newFilters.plants = $8dbe7fe972b92695$export$19e0fcd208294781(newFilters.plants);
                        newFilters.types = $8dbe7fe972b92695$export$19e0fcd208294781(newFilters.types);
                        setFilters(newFilters);
                    },
                    sortingField: toDoSortingField,
                    setSortingField: setToDoSortingField,
                    sortingDirection: sortingDirection,
                    setSortingDirection: setSortingDirection
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                className: "todo__list",
                ref: refToDoList,
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ae400fdcb44e79e9$export$e1ba70b5461430a8), {
                    unfinishedToDos: sortedFilteredToDos,
                    plantedPlantsNamesWithId: plantedPlantsNamesWithId
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $eabf9c7db89c7211$export$2e2bcd8739ae039), {
                open: openTour,
                onClose: ()=>setOpenTour(false),
                steps: steps,
                indicatorsRender: (current, total)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                        children: [
                            current + 1,
                            " / ",
                            total
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $7c982b663463d13d$export$9037afc3347b6505), {
                routeWhenClosed: `/todos`
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d3bb1e19d023a492$export$713727c9f622e975), {
                routeWhenClosed: `/todos`,
                unfinishedToDos: sortedFilteredToDos,
                toDoTypes: userToDoTypes,
                userEventTypes: userJournalEventTypes
            })
        ]
    });
}



var $Ohofd = parcelRequire("Ohofd");



parcelRequire("ltGt3");


function $3b87a246b0c38605$export$702eb8b1ba6a823a() {
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7c8a10e768eadb0$export$2d003b3d2748ba71), {
        availableElementTypes: (0, $670e204136b37e30$export$9544d5bb712b01ea).getHardscapeElementTypes()
    });
}



parcelRequire("ltGt3");


function $93a693e6e5e6a940$export$dfbc6370f8a27c1a() {
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7c8a10e768eadb0$export$2d003b3d2748ba71), {
        availableElementTypes: (0, $670e204136b37e30$export$9544d5bb712b01ea).getWaterscapeElementTypes()
    });
}



parcelRequire("ltGt3");


function $cda1d3c0f1927738$export$d8a21290379b6776() {
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7c8a10e768eadb0$export$2d003b3d2748ba71), {
        availableElementTypes: (0, $670e204136b37e30$export$9544d5bb712b01ea).getOtherElementTypes()
    });
}




parcelRequire("ltGt3");


function $bb66df5e44264cab$export$4ab4927f5c385cb5() {
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b7c8a10e768eadb0$export$2d003b3d2748ba71), {
        availableElementTypes: (0, $670e204136b37e30$export$9544d5bb712b01ea).getSolitariusElementTypes()
    });
}





var $ltGt3 = parcelRequire("ltGt3");






var $ltGt3 = parcelRequire("ltGt3");





const $fbd54ca598a44eba$var$validateMessages = {
    required: '${label} is required!'
};
function $fbd54ca598a44eba$export$ef0ae802e3ecfb1(props) {
    const [form] = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useForm();
    const [isSubmitting, setSubmitting] = (0, $ltGt3.useState)(false);
    const revalidator = (0, $493cbc5b00d91baa$export$600dc272ed516c15)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const password1 = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useWatch('password1', form);
    const password2 = (0, $b56d75f9dce54730$export$2e2bcd8739ae039).useWatch('password2', form);
    const passwordsMatch = password1 === password2;
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $b56d75f9dce54730$export$2e2bcd8739ae039), {
                form: form,
                layout: "vertical",
                style: {
                    width: 500
                },
                validateMessages: $fbd54ca598a44eba$var$validateMessages,
                onFinish: async (formState)=>{
                    setSubmitting(true);
                    let result;
                    const signUp = {
                        password1: formState.password1,
                        password2: formState.password2
                    };
                    setSubmitting(false);
                    if (passwordsMatch) {
                        result = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).changePassword(signUp.password1);
                        if (result.success) {
                            revalidator.revalidate();
                            navigate('/login');
                        //props.setEmailSent(true)
                        } else messageApi.open({
                            type: 'error',
                            content: result.error?.message
                        });
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        name: "password1",
                        label: intl.formatMessage({
                            id: 'newPassword'
                        }),
                        rules: [
                            {
                                required: true
                            }
                        ],
                        help: password1 ? password1.match((0, $c838bdb408d971ee$export$11cade6ce1ea211f)) ? '' : intl.formatMessage({
                            id: 'passwordValidation'
                        }) : '',
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).Password, {})
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        name: "password2",
                        label: intl.formatMessage({
                            id: 'repeatNewPassword'
                        }),
                        rules: [
                            {
                                required: true
                            }
                        ],
                        validateStatus: passwordsMatch ? '' : 'error',
                        help: passwordsMatch ? '' : intl.formatMessage({
                            id: 'passwordMismatch'
                        }),
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).Password, {})
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $b56d75f9dce54730$export$2e2bcd8739ae039).Item, {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            htmlType: "submit",
                            size: "large",
                            type: "primary",
                            style: {
                                width: '100%'
                            },
                            children: intl.formatMessage({
                                id: 'continue'
                            })
                        })
                    })
                ]
            })
        ]
    });
}


function $2d820d50293f0c90$export$8ec0fb1e4323236d() {
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const [isEmailSent, setEmailSent] = (0, $ltGt3.useState)(false);
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        style: {
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                    className: "logo",
                    to: "/",
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h1", {
                        children: "TerraSketch"
                    })
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                    children: intl.formatMessage({
                        id: 'changePassword'
                    })
                }),
                isEmailSent ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "email-check",
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            children: intl.formatMessage({
                                id: 'checkYourEmail'
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            size: "large",
                            type: "primary",
                            onClick: async ()=>{
                                navigate('/login');
                            },
                            children: intl.formatMessage({
                                id: 'ok'
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9d004cf64875b9d1$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $fbd54ca598a44eba$export$ef0ae802e3ecfb1), {
                        setEmailSent: setEmailSent
                    })
                })
            ]
        })
    });
}




var $ltGt3 = parcelRequire("ltGt3");






function $d393dd2112f6afbf$export$da4433e8d8a5678() {
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    const [messageApi, contextHolder] = (0, $0fb9549ff19d4b13$export$2e2bcd8739ae039).useMessage();
    const [isEmailSent, setEmailSent] = (0, $ltGt3.useState)(false);
    const [email, setEmail] = (0, $ltGt3.useState)('');
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const isEmailValidated = (0, $c838bdb408d971ee$export$26261a22216d6763).test(email);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
        style: {
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6816d30a3e97278a$export$a6c7ac8248d6e38a), {
                    className: "logo",
                    to: "/",
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h1", {
                        children: "TerraSketch"
                    })
                }),
                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h2", {
                    children: intl.formatMessage({
                        id: 'resetPassword'
                    })
                }),
                isEmailSent ? /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "email-check",
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                            children: intl.formatMessage({
                                id: 'checkYourEmail'
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            size: "large",
                            type: "primary",
                            onClick: async ()=>{
                                navigate('/login');
                            },
                            children: intl.formatMessage({
                                id: 'ok'
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                    className: "reset-email",
                    children: [
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                            children: intl.formatMessage({
                                id: 'enterResetEmail'
                            })
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039), {
                            className: "reset-email__input",
                            placeholder: "email",
                            value: email,
                            onChange: (e)=>setEmail(e.currentTarget.value)
                        }),
                        /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f0f3fa344d92230d$export$2e2bcd8739ae039), {
                            size: "large",
                            type: "primary",
                            disabled: email === '' || !isEmailValidated,
                            onClick: async ()=>{
                                const result = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).resetPassword(email);
                                if (!result.success) messageApi.open({
                                    type: 'error',
                                    content: result.error.message
                                });
                                else setEmailSent(true);
                            },
                            children: intl.formatMessage({
                                id: 'sendEmailToResetPassword'
                            })
                        })
                    ]
                })
            ]
        })
    });
}





var $ltGt3 = parcelRequire("ltGt3");




var $06178126a12151d7$exports = {};
$06178126a12151d7$exports = import.meta.resolve("6IHb2");




var $Ohofd = parcelRequire("Ohofd");


(0, $e1ba9a64f0845235$export$d8abd7e5fb6871f9)['src'];
function $acb650247792d24e$export$584a0e12fce03072() {
    const { newsList: newsList, pageParams: pageParams } = (0, $493cbc5b00d91baa$export$fd5d37484eab868d)('newsList');
    const [activeTags, setActiveTags] = (0, $ltGt3.useState)({
        news: false,
        tutorials: false
    });
    const [searchParams, setSearchParams] = (0, $6816d30a3e97278a$export$f1a78c17382fe22a)();
    const intl = (0, $f383e3fcbf2e13f1$export$2e2bcd8739ae039)();
    const handlePaginationChange = (current)=>setSearchParams((searchParams)=>{
            const page = current;
            const params = Object.fromEntries(searchParams);
            if (page !== 1) params.page = String(page);
            else delete params.page;
            return params;
        });
    const toggleTag = (value)=>{
        setActiveTags({
            ...activeTags,
            [value]: !activeTags[value]
        });
    };
    (0, $ltGt3.useEffect)(()=>{
        setSearchParams((searchParams)=>{
            const params = Object.fromEntries(searchParams);
            if (activeTags.news || activeTags.tutorials) params.tags = Object.entries(activeTags).filter(([, v])=>v).map(([key])=>key).join(',');
            else delete params.tags;
            return params;
        });
    }, [
        activeTags
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
        className: "news-list-page home-layout__content",
        children: [
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "news-list-page__header",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("img", {
                    className: "news-list-page__header__image",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($06178126a12151d7$exports))),
                    alt: "News banner"
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("h1", {
                className: "news-list-page__title",
                style: {},
                children: intl.formatMessage({
                    id: `news`
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "news-list-page__title__description",
                children: intl.formatMessage({
                    id: `theLatestPostsAndGuides`
                })
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                gutter: [
                    16,
                    16
                ],
                align: "middle",
                style: {
                    marginBottom: 18
                },
                children: [
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                        xs: 24,
                        md: 12,
                        lg: 10,
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a57f5862981f5e9d$export$2e2bcd8739ae039).Search, {
                            placeholder: intl.formatMessage({
                                id: `searchForNews`
                            }),
                            allowClear: true,
                            size: "large",
                            onSearch: (value)=>setSearchParams((searchParams)=>{
                                    const search = value;
                                    const params = Object.fromEntries(searchParams);
                                    if (search !== '') params.search = String(search);
                                    else delete params.search;
                                    return params;
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                        xs: 24,
                        md: 12,
                        lg: 14,
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $d029ee757225a242$export$2e2bcd8739ae039), {
                            wrap: true,
                            size: [
                                10,
                                10
                            ],
                            style: {
                                justifyContent: 'flex-end',
                                width: '100%'
                            },
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                    className: "news-list-page__search__tag",
                                    style: {
                                        backgroundColor: activeTags.news ? 'rgba(244, 106, 42, 0.12)' : '#fff'
                                    },
                                    onClick: ()=>toggleTag('news'),
                                    children: intl.formatMessage({
                                        id: `tag-news`
                                    })
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                    className: "news-list-page__search__tag",
                                    style: {
                                        backgroundColor: activeTags.tutorials ? 'rgba(244, 106, 42, 0.12)' : '#fff'
                                    },
                                    onClick: ()=>toggleTag('tutorials'),
                                    children: intl.formatMessage({
                                        id: `tag-tutorials`
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $638ba0bcda633638$export$2e2bcd8739ae039), {
                style: {
                    margin: '10px 0 18px'
                }
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6f840f72071c73c6$export$2e2bcd8739ae039), {
                dataSource: newsList,
                split: false,
                renderItem: (item)=>/*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ad1c3304c519fac5$export$2e2bcd8739ae039), {
                        className: "news-list-page__list__news",
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)((0, $2e3ea5da034cc5f6$export$2e2bcd8739ae039), {
                            gutter: 16,
                            wrap: false,
                            children: [
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                                    flex: "120px",
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $54759b2dc7aee7a8$export$2e2bcd8739ae039), {
                                        className: "news-list-page__list__news__image",
                                        src: item.titlePhotoURL,
                                        alt: item.newsName,
                                        width: 120,
                                        height: 90,
                                        preview: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d4ae9b90c2a44432$export$2e2bcd8739ae039), {
                                    flex: "auto",
                                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                        className: "news-list-page__list__news__info",
                                        children: [
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("a", {
                                                className: "news-list-page__list__news__name",
                                                href: `/home/news/${item.url}`,
                                                children: intl.locale === 'en' ? item.newsName : item.newsNameRU
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsxs)("span", {
                                                        className: "news-list-page__list__news__calendar",
                                                        children: [
                                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $9c348dd92383621c$export$2e2bcd8739ae039), {}),
                                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("span", {
                                                                className: "news-list-page__list__news__calendar__text",
                                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd)))(item.dateOfCreating).format('ll')
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $275a14ee9b85c941$export$2e2bcd8739ae039), {
                                                        className: "news-list-page__list__news__tag",
                                                        children: intl.formatMessage({
                                                            id: `tag-${item.newsType}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                                                className: "news-list-page__list__news__text",
                                                children: `${intl.locale === 'en' ? item.text : item.textRU}...`
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }, item.id)
            }),
            /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)("div", {
                className: "news-list-page__pagination",
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $ba6ccffd2ae02ebb$export$2e2bcd8739ae039), {
                    defaultCurrent: 1,
                    total: pageParams.total,
                    pageSize: (0, $0270799cdc102f8c$export$9544d5bb712b01ea).DEFAULT_PER_PAGE,
                    showSizeChanger: false,
                    onChange: handlePaginationChange
                })
            })
        ]
    });
}


let $2c0104ccc23bafb3$var$currentLocale = (0, $309a8477a77bc963$export$d7f512c98c859244);
function $2c0104ccc23bafb3$export$2d37eac8c56b0d57(props) {
    const [loading, setLoading] = (0, $ltGt3.useState)(true);
    const navigate = (0, $493cbc5b00d91baa$export$9770f232ac06a008)();
    (0, $ltGt3.useEffect)(()=>{
        (async ()=>{
            const user = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).getCurrentUser();
            if (user) navigate('/home');
            else setLoading(false);
        })();
    }, []);
    return loading ? null : props.children;
}
const $2c0104ccc23bafb3$var$localizedMessages = {
    en: $c71c6b81b4aafe7a$exports,
    ru: $20178330a7afdb4e$exports
};
(0, $8c104cf9ab4badc0$export$2cd8252107eb640b)({
    data: (/*@__PURE__*/$parcel$interopDefault($3373240be9e80763$exports))
});
const $2c0104ccc23bafb3$var$plantLoader = async ({ params: params, request: request })=>{
    if (params.plantId === 'new') return {
        type: 'newPlant'
    };
    const plantId = parseInt(params.plantId, 10);
    const getPlantByIdResult = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getPlantById(plantId, $2c0104ccc23bafb3$var$currentLocale);
    if (!getPlantByIdResult.success) return {
        type: 'notFound'
    };
    const { plant: plant } = getPlantByIdResult;
    const [plantTitlePhoto, userPlantCollections, plantTimeEvents, plantTasks, userToDoTypes, userEventTypes] = await Promise.all([
        (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getTitlePlantPhoto(plant.titlePhotoName, plant.photos[0]),
        (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getUserPlantCollections(),
        (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).getJournalEventsByPlantId(plantId),
        (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).getUserUnfinishedPlantsToDosByPlantId(plantId),
        (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).getUserToDoTypes(),
        (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).getUserJournalEventTypes()
    ]);
    return {
        type: 'existingPlant',
        plant: plant,
        plantTitlePhoto: plantTitlePhoto,
        userPlantCollections: userPlantCollections,
        plantTimeEvents: plantTimeEvents,
        plantTasks: plantTasks,
        userToDoTypes: userToDoTypes.success === true ? userToDoTypes.data : [],
        userEventTypes: userEventTypes.success === true ? userEventTypes.data : []
    };
};
const $2c0104ccc23bafb3$var$journalRecordLoader = async ({ params: params })=>{
    const recordId = parseInt(params.recordId, 10);
    const record = await (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).getUserJournalRecordById(recordId);
    if (record.error === 'notFound') return null;
    return record.success === true ? record.data : null;
};
const $2c0104ccc23bafb3$var$projectAction = ()=>null;
const $2c0104ccc23bafb3$var$router = (0, $6816d30a3e97278a$export$1f3f55432a00e06d)([
    {
        path: '/',
        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($2c0104ccc23bafb3$export$2d37eac8c56b0d57, {
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $5e1384582c6f6a64$export$171cf93cb8c45e5d), {})
        }),
        loader: async ()=>{
            const user = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).getCurrentUser();
            if (user) return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)('/home');
            return null;
        }
    },
    {
        path: '/landing',
        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)($2c0104ccc23bafb3$export$2d37eac8c56b0d57, {
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $0f7f21fec06ab1e8$export$355f3d6a1f8b250c), {})
        }),
        loader: async ()=>{
            const user = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).getCurrentUser();
            if (user) return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)('/home');
            return null;
        }
    },
    {
        path: '/login',
        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $dc5d57b23f0b65bc$export$f14c0e3f98d164c0), {})
    },
    {
        path: '/signup',
        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $c444ab16c9a31f55$export$265471dcab9022d3), {})
    },
    {
        path: '/change-password',
        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $2d820d50293f0c90$export$8ec0fb1e4323236d), {}),
        loader: async ()=>{
            const user = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).getCurrentUser();
            if (!user) return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)('/login');
        }
    },
    {
        path: '/reset-password',
        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d393dd2112f6afbf$export$da4433e8d8a5678), {})
    },
    {
        path: '/policies',
        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $cf3491f814c58ba2$export$e9859ad90648930b), {})
    },
    {
        path: '/',
        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $602b6ac290f4e7f6$export$c84671f46d6a1ca), {}),
        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {
            showLogout: true
        }),
        id: 'root',
        loader: async ()=>{
            const user = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).getCurrentUser();
            if (!user) return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)('/login');
            const projectNames = await (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).getUserProjectsNames();
            return {
                user: user,
                projectNames: projectNames
            };
        },
        shouldRevalidate: ()=>true,
        children: [
            {
                path: '/home',
                id: 'homeAll',
                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $589b3104a4ffe1e7$export$d50ff52389c11f75), {}),
                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                loader: async ()=>{
                    const [unfinishedUserToDos, plantedPlantsNamesWithId] = await Promise.all([
                        (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).getUserUnfinishedToDos(),
                        (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getUserPlantsNamesWithId()
                    ]);
                    return {
                        unfinishedUserToDos: unfinishedUserToDos,
                        plantedPlantsNamesWithId: plantedPlantsNamesWithId
                    };
                },
                children: [
                    {
                        path: '/home',
                        id: 'home',
                        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $fc259b96ee86e762$export$b94310965bed44e6), {}),
                        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                        loader: async ()=>{
                            const [newsList, projectStatistics, plantedPlantsNamesWithId] = await Promise.all([
                                (0, $0270799cdc102f8c$export$9544d5bb712b01ea).getNewsLists(10),
                                (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).getUserProjectMaxPlantsInfoStatistics(),
                                (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getUserPlantsNamesWithId()
                            ]);
                            return {
                                newsList: newsList,
                                projectStatistics: projectStatistics,
                                plantedPlantsNamesWithId: plantedPlantsNamesWithId
                            };
                        }
                    },
                    {
                        path: '/home/news',
                        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $acb650247792d24e$export$584a0e12fce03072), {}),
                        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                        id: 'newsList',
                        loader: async ({ request: request })=>{
                            const queryParams = new URL(request.url).searchParams;
                            let page = Number.parseInt(queryParams.get('page'), 10) || 1;
                            let perPage = (0, $0270799cdc102f8c$export$9544d5bb712b01ea).DEFAULT_PER_PAGE;
                            if (page < 1) page = 1;
                            const search = queryParams.get('search');
                            const tags = queryParams.get('tags')?.split(',') || [];
                            const filteredNewsList = await (0, $0270799cdc102f8c$export$9544d5bb712b01ea).getFilteredNewsLists({
                                page: page,
                                perPage: perPage,
                                searchQuery: search,
                                tagFilters: tags
                            }, $2c0104ccc23bafb3$var$currentLocale);
                            const maxPossiblePage = Math.ceil(filteredNewsList.totalCount / perPage);
                            if (page > maxPossiblePage) page = maxPossiblePage - 1;
                            return {
                                newsList: filteredNewsList.newsList,
                                pageParams: {
                                    currentPage: page,
                                    pageSize: perPage,
                                    total: filteredNewsList.totalCount,
                                    searchQuery: search,
                                    tags: tags
                                }
                            };
                        }
                    },
                    {
                        path: '/home/news/:newsURL',
                        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e5e6fea58ba80009$export$8f6ed4bdad4b778c), {}),
                        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                        id: 'news',
                        loader: async ({ params: params })=>{
                            const url = params.newsURL;
                            const [news, newsList] = await Promise.all([
                                (0, $0270799cdc102f8c$export$9544d5bb712b01ea).getNewsById(url),
                                (0, $0270799cdc102f8c$export$9544d5bb712b01ea).getNewsLists(10)
                            ]);
                            return {
                                news: news,
                                newsList: newsList
                            };
                        }
                    }
                ]
            },
            {
                path: '/user',
                id: 'user',
                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $77093591b2bff7c8$export$ecdc3cf9d1cfe143), {}),
                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                loader: async ()=>{
                    const userSettings = await (0, $5f9ff9fded7ff792$export$9544d5bb712b01ea).getUserSettings();
                    if (userSettings.success) return {
                        userSettings: userSettings.data
                    };
                    else return null;
                }
            },
            {
                path: '/projects',
                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $73b9d62da83bfae6$export$ca6fbb51b35e375c), {}),
                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                loader: ()=>(0, $9b35792dcb248bd5$export$9544d5bb712b01ea).getUserProjects()
            },
            {
                path: '/projects/new',
                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $d345b195f03a6bb2$export$7d3b6c592d61741e), {}),
                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                action: async ({ request: request })=>{
                    const data = await request.formData();
                    return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)(`/projects/${data.get('id')}/edit/plot`);
                }
            },
            {
                path: '/projects/:projectId',
                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $927e51d10bec7c73$export$b6032183171af19f), {}),
                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                id: 'project',
                loader: async ({ params: params })=>{
                    const id = params.projectId;
                    const [project, projectPlants, projectToDos, plantedPlantsNamesWithId, projectGardenPlanVariants] = await Promise.all([
                        (0, $9b35792dcb248bd5$export$9544d5bb712b01ea).getUserProjectById(id),
                        (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getProjectPlants(id),
                        (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).getUserUnfinishedToDos(),
                        (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getUserPlantsNamesWithId(),
                        (0, $5fab5f2ee6cc184e$export$9544d5bb712b01ea).getProjectGardenPlanVariants(id)
                    ]);
                    return {
                        project: project,
                        projectPlants: projectPlants,
                        projectToDos: projectToDos,
                        plantedPlantsNamesWithId: plantedPlantsNamesWithId,
                        projectGardenPlanVariants: projectGardenPlanVariants.success ? projectGardenPlanVariants.projectGardenPlanVariants : []
                    };
                },
                shouldRevalidate: (0, $f72b095965a02692$export$32ba182c8dac3e61),
                action: $2c0104ccc23bafb3$var$projectAction,
                children: [
                    {
                        path: '/projects/:projectId/',
                        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f12218d38d58bc43$export$a4770e9edd2382f), {}),
                        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                        action: $2c0104ccc23bafb3$var$projectAction
                    },
                    {
                        path: '/projects/:projectId/plants/:plantId',
                        id: 'projectWithPlant',
                        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $f12218d38d58bc43$export$a4770e9edd2382f), {}),
                        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                        loader: $2c0104ccc23bafb3$var$plantLoader,
                        shouldRevalidate: (0, $6139c0a58835b448$export$7d2dde62355c39dc),
                        action: async ({ params: params, request: request })=>{
                            const formData = await request.formData();
                            const { search: search } = new URL(request.url);
                            if (formData.has('id')) return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)(`/projects/${params.projectId}/plants/${formData.get('id')}${search}`);
                            if (request?.method?.toLowerCase() === 'delete') return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)(`/projects/${params.projectId}${search}`);
                            return null;
                        }
                    },
                    {
                        path: '/projects/:projectId/edit',
                        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $e0fec9ca9a676038$export$3e899a3b88b0b908), {
                            type: "edit"
                        }),
                        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                        children: [
                            {
                                path: '/projects/:projectId/edit',
                                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $5f19c843348431c2$export$8ddb6c216a54fb67), {}),
                                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                                shouldRevalidate: (0, $f72b095965a02692$export$32ba182c8dac3e61),
                                action: async ({ request: request })=>{
                                    const data = await request.formData();
                                    return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)(`/projects/${data.get('id')}/edit/plot${new URL(request.url).search}`);
                                }
                            },
                            {
                                path: '/projects/:projectId/edit/plot',
                                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $8a67ad5a3b6dcccc$export$d4fc59a76aa37d5e), {}),
                                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                                shouldRevalidate: (0, $f72b095965a02692$export$32ba182c8dac3e61),
                                action: $2c0104ccc23bafb3$var$projectAction
                            },
                            {
                                path: '/projects/:projectId/edit/buildings',
                                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $20bc9ae7172cc79d$export$129166de1fe98653), {}),
                                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                                shouldRevalidate: (0, $f72b095965a02692$export$32ba182c8dac3e61),
                                action: $2c0104ccc23bafb3$var$projectAction
                            },
                            {
                                path: '/projects/:projectId/edit/hardscape',
                                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3b87a246b0c38605$export$702eb8b1ba6a823a), {}),
                                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                                shouldRevalidate: (0, $f72b095965a02692$export$32ba182c8dac3e61),
                                action: $2c0104ccc23bafb3$var$projectAction
                            },
                            {
                                path: '/projects/:projectId/edit/sectors',
                                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4d176004a991ca7c$export$d8823776fba9c96b), {}),
                                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                                shouldRevalidate: (0, $f72b095965a02692$export$32ba182c8dac3e61),
                                action: $2c0104ccc23bafb3$var$projectAction
                            },
                            {
                                path: '/projects/:projectId/edit/waterscape',
                                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $93a693e6e5e6a940$export$dfbc6370f8a27c1a), {}),
                                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                                shouldRevalidate: (0, $f72b095965a02692$export$32ba182c8dac3e61),
                                action: $2c0104ccc23bafb3$var$projectAction
                            },
                            {
                                path: '/projects/:projectId/edit/solitarius',
                                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $bb66df5e44264cab$export$4ab4927f5c385cb5), {}),
                                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                                shouldRevalidate: (0, $f72b095965a02692$export$32ba182c8dac3e61),
                                action: $2c0104ccc23bafb3$var$projectAction
                            },
                            {
                                path: '/projects/:projectId/edit/other',
                                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $cda1d3c0f1927738$export$d8a21290379b6776), {}),
                                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                                shouldRevalidate: (0, $f72b095965a02692$export$32ba182c8dac3e61),
                                action: $2c0104ccc23bafb3$var$projectAction
                            }
                        ]
                    }
                ]
            },
            {
                path: '/todos',
                id: 'todos',
                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $8dbe7fe972b92695$export$c1c10d961c680d69), {}),
                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                loader: async ()=>{
                    const [plantedPlantsNamesWithId, unfinishedToDos, userToDoTypes, userJournalEventTypes, userPlantCollections, userPlantCollectionsWithPlantsIds] = await Promise.all([
                        (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getUserPlantsNamesWithId(),
                        (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).getUserUnfinishedToDos(),
                        (0, $b6a40c35fe89493a$export$9544d5bb712b01ea).getUserToDoTypes(),
                        (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).getUserJournalEventTypes(),
                        (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getUserPlantCollections(),
                        (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getUserPlantCollectionsWithPlantsIds()
                    ]);
                    return {
                        plantedPlantsNamesWithId: plantedPlantsNamesWithId,
                        unfinishedToDos: unfinishedToDos,
                        userToDoTypes: userToDoTypes.success === true ? userToDoTypes.data : [],
                        userJournalEventTypes: userJournalEventTypes.success === true ? userJournalEventTypes.data : [],
                        userPlantCollections: userPlantCollections,
                        userPlantCollectionsWithPlantsIds: userPlantCollectionsWithPlantsIds
                    };
                },
                shouldRevalidate: (0, $25dcb8eadeb85629$export$351c88f98aecaeee),
                action: async ({ request: request })=>null,
                children: [
                    {
                        path: '/todos/:todoId/',
                        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $8dbe7fe972b92695$export$c1c10d961c680d69), {}),
                        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                        shouldRevalidate: (0, $25dcb8eadeb85629$export$351c88f98aecaeee)
                    },
                    {
                        path: '/todos/:todoId/plants/:plantId',
                        id: 'toDoWithPlant',
                        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $8dbe7fe972b92695$export$c1c10d961c680d69), {}),
                        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                        loader: $2c0104ccc23bafb3$var$plantLoader,
                        shouldRevalidate: ({ currentParams: currentParams, nextParams: nextParams, formMethod: formMethod })=>{
                            if (formMethod === 'post') return true;
                            return currentParams.plantId != nextParams.plantId;
                        },
                        action: async ({ params: params, request: request })=>{
                            const formData = await request.formData();
                            if (formData.has('id')) return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)(`/todos/${params.todoId}/plants/${formData.get('id')}`);
                            return null;
                        }
                    }
                ]
            },
            {
                path: '/plants',
                id: 'plantsList',
                // loader: async ({params}) => {
                //   return {plantsRevalidationToken: Number(new Date())}
                // },
                // shouldRevalidate: ({formMethod}) => formMethod === 'post' || formMethod === 'delete',
                loader: async ({ request: request })=>{
                    const queryParams = new URL(request.url).searchParams;
                    let page = Number.parseInt(queryParams.get('page'), 10) || 1;
                    let perPage = Number.parseInt(queryParams.get('perPage'), 10) || (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).DEFAULT_PER_PAGE;
                    if (page < 1) page = 1;
                    if (perPage < 5) perPage = 5;
                    if (perPage > 100) perPage = 100;
                    let filters = {};
                    try {
                        filters = JSON.parse(queryParams.get('filter')) || {};
                    } catch (ex) {
                        console.error('incorrect filter will be ignored');
                    }
                    const sortOrder = queryParams.get('sortOrder') === 'desc' ? 'desc' : 'asc';
                    let sortField = queryParams.get('sortField');
                    if (!(0, $e0eda949f811dcf3$export$965cd5f3a2d1fc05).some((field)=>field === sortField)) sortField = 'name';
                    // const [plantedPlantsNamesWithId, userJournalEventTypes, userJournalEvents] =
                    //   await Promise.all([
                    //     plantsService.getUserPlantsNamesWithId(),
                    //     journalService.getUserJournalEventTypes(),
                    //     journalService.getUserJournalRecords({
                    //       page,
                    //       perPage,
                    //       filters,
                    //       sort: sortField
                    //         ? {
                    //             field: sortField,
                    //             direction: sortOrder === 'asc' ? 'asc' : 'desc',
                    //           }
                    //         : null,
                    //     }),
                    //   ])
                    const userFilteredPlants = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getUserFilteredPlants({
                        page: page,
                        perPage: perPage,
                        filters: filters,
                        sort: sortField ? {
                            field: sortField,
                            direction: sortOrder
                        } : null
                    }, $2c0104ccc23bafb3$var$currentLocale);
                    const maxPossiblePage = Math.ceil(userFilteredPlants.totalCount / perPage);
                    if (page > maxPossiblePage) page = maxPossiblePage - 1;
                    const userPlantCollections = await (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getUserPlantCollections();
                    return {
                        userPlants: userFilteredPlants.plants,
                        userPlantCollections: userPlantCollections,
                        totalCount: userFilteredPlants.totalCount,
                        tableParams: {
                            page: page,
                            perPage: perPage,
                            sortField: sortField,
                            sortOrder: sortOrder,
                            filters: filters
                        },
                        dataKey: Date.now()
                    };
                },
                shouldRevalidate: ({ formMethod: formMethod, currentUrl: currentUrl, nextUrl: nextUrl })=>{
                    if (formMethod === 'post' || formMethod === 'delete') return true;
                    const currentQueryParams = new URL(currentUrl).searchParams;
                    const nextQueryParams = new URL(nextUrl).searchParams;
                    // `view` (Cards/Gallery/Table) is a display-only param and does not
                    // affect the fetched data, so changing it alone must not refetch.
                    currentQueryParams.delete('view');
                    nextQueryParams.delete('view');
                    if (currentQueryParams.size !== nextQueryParams.size) return true;
                    for (const [param, value] of currentQueryParams.entries()){
                        if (value !== nextQueryParams.get(param)) return true;
                    }
                    return false;
                },
                children: [
                    {
                        path: '',
                        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6c7041734928af05$export$101e9a04d85a8578), {}),
                        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {})
                    },
                    {
                        path: '/plants/:plantId',
                        id: 'plant',
                        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6c7041734928af05$export$101e9a04d85a8578), {}),
                        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                        loader: $2c0104ccc23bafb3$var$plantLoader,
                        shouldRevalidate: (0, $6139c0a58835b448$export$7d2dde62355c39dc),
                        action: async ({ request: request })=>{
                            if (request.method === 'DELETE') return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)(`/plants`);
                            const formData = await request.formData();
                            if (formData.has('id')) return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)(`/plants/${formData.get('id')}`);
                            return null;
                        }
                    }
                ]
            },
            {
                path: '/journal',
                id: 'journal',
                element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6d63ee2dceea6705$export$78465ea4c1305108), {}),
                errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                shouldRevalidate: ({ formMethod: formMethod, currentUrl: currentUrl, nextUrl: nextUrl })=>{
                    if (formMethod === 'post' || formMethod === 'delete') return true;
                    const currentQueryParams = new URL(currentUrl).searchParams;
                    const nextQueryParams = new URL(nextUrl).searchParams;
                    if (currentQueryParams.size !== nextQueryParams.size) return true;
                    for (const [param, value] of currentQueryParams.entries()){
                        if (value !== nextQueryParams.get(param)) return true;
                    }
                    return false;
                },
                action: async ({ request: request })=>null,
                loader: async ({ request: request })=>{
                    const queryParams = new URL(request.url).searchParams;
                    let page = Number.parseInt(queryParams.get('page'), 10) || 1;
                    let perPage = Number.parseInt(queryParams.get('perPage'), 10) || 10;
                    if (page < 1) page = 1;
                    if (perPage < 5) perPage = 5;
                    if (perPage > 100) perPage = 100;
                    let filters = {};
                    try {
                        filters = JSON.parse(queryParams.get('filter')) || {};
                    } catch (ex) {
                        console.error('incorrect filter will be ignored');
                    }
                    const sortOrder = queryParams.get('sortOrder');
                    const sortField = queryParams.get('sortField');
                    const [plantedPlantsNamesWithId, userJournalEventTypes, userJournalEvents] = await Promise.all([
                        (0, $e0eda949f811dcf3$export$9544d5bb712b01ea).getUserPlantsNamesWithId(),
                        (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).getUserJournalEventTypes(),
                        (0, $48c8ca5db8a0a10e$export$9544d5bb712b01ea).getUserJournalRecords({
                            page: page,
                            perPage: perPage,
                            filters: filters,
                            sort: sortField ? {
                                field: sortField,
                                direction: sortOrder === 'asc' ? 'asc' : 'desc'
                            } : null
                        })
                    ]);
                    const maxPossiblePage = Math.ceil(userJournalEvents.count / perPage);
                    if (page > maxPossiblePage) page = maxPossiblePage - 1;
                    return {
                        plantedPlantsNamesWithId: plantedPlantsNamesWithId,
                        userJournalEventTypes: userJournalEventTypes.success === true ? userJournalEventTypes.data : [],
                        userJournalEvents: userJournalEvents,
                        tableParams: {
                            page: page,
                            perPage: perPage,
                            sortField: sortField,
                            sortOrder: sortOrder
                        }
                    };
                },
                children: [
                    {
                        path: '/journal/:recordId/',
                        id: 'journalRecordById',
                        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6d63ee2dceea6705$export$78465ea4c1305108), {}),
                        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                        loader: $2c0104ccc23bafb3$var$journalRecordLoader,
                        shouldRevalidate: ({ formMethod: formMethod })=>formMethod === 'post' || formMethod === 'delete',
                        action: ({ request: request })=>{
                            if (request.method === 'DELETE') return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)('/journal');
                        }
                    },
                    {
                        path: '/journal/:recordId/plants/:plantId',
                        id: 'journalRecordWithPlant',
                        element: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $6d63ee2dceea6705$export$78465ea4c1305108), {}),
                        errorElement: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $14aea88a2e71fbc9$export$c120a0e80fd44ca6), {}),
                        loader: $2c0104ccc23bafb3$var$plantLoader,
                        shouldRevalidate: ({ currentParams: currentParams, nextParams: nextParams, formMethod: formMethod })=>{
                            if (formMethod === 'post') return true;
                            return currentParams.plantId != nextParams.plantId;
                        },
                        action: async ({ params: params, request: request })=>{
                            if (request.method === 'DELETE') return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)(`/journal`);
                            const formData = await request.formData();
                            if (formData.has('id')) return (0, $16791ace69c4cf4f$export$89e12c5b50f7529d)(`/journal/${params.recordId}/plants/${formData.get('id')}`);
                            return null;
                        }
                    }
                ]
            }
        ]
    }
], {
    basename: "/"
});
function $2c0104ccc23bafb3$export$86fbec116b87613f() {
    const [locale, setLocaleState] = (0, $ltGt3.useState)((0, $309a8477a77bc963$export$d7f512c98c859244));
    const localeInfo = (0, $17695373636e29e1$export$8e1c4644f466949c)[locale];
    const setLocale = (newLocale)=>{
        const newLocaleInfo = (0, $17695373636e29e1$export$8e1c4644f466949c)[newLocale];
        (0, (/*@__PURE__*/$parcel$interopDefault($Ohofd))).locale(newLocaleInfo.dayjs);
        setLocaleState(newLocale);
    };
    (0, $ltGt3.useEffect)(()=>{
        $2c0104ccc23bafb3$var$currentLocale = locale;
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $4f475c9b6cb2d3a2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $17695373636e29e1$export$51216bcc3983e55d).Provider, {
            value: {
                setLocale: setLocale,
                getLocale: ()=>locale
            },
            children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $60e07c536e35ad98$export$2e2bcd8739ae039), {
                messages: $2c0104ccc23bafb3$var$localizedMessages[locale],
                locale: locale,
                defaultLocale: (0, $309a8477a77bc963$export$d7f512c98c859244),
                onError: ()=>{},
                children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $3f88559997256af7$export$2e2bcd8739ae039), {
                    theme: {
                        token: {
                            colorPrimary: '#F48254',
                            colorLink: '#F2703D',
                            colorLinkHover: '#F8A483',
                            colorBgContainer: '#FAF8F5',
                            fontSize: 16,
                            fontFamily: "'Open Sans', sans-serif"
                        },
                        components: {
                            Layout: {
                                headerBg: '#F2703D',
                                colorLink: 'white'
                            },
                            Menu: {}
                        }
                    },
                    locale: localeInfo.antd,
                    warning: {
                        strict: false
                    },
                    children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $a97af2bd258d22ad$export$5875b7c002c3b550), {
                        children: /*#__PURE__*/ (0, $9d004cf64875b9d1$exports.jsx)((0, $493cbc5b00d91baa$export$323e4fc2fa4753fb), {
                            router: $2c0104ccc23bafb3$var$router
                        })
                    })
                })
            })
        })
    });
}




const $c6a0deb3845a17cb$var$container = document.getElementById('root');
const $c6a0deb3845a17cb$var$root = (0, $d13952e353ee92c1$export$882461b6382ed46c)($c6a0deb3845a17cb$var$container);
$c6a0deb3845a17cb$var$root.render((0, (/*@__PURE__*/$parcel$interopDefault($ltGt3))).createElement((0, $2c0104ccc23bafb3$export$86fbec116b87613f)));


//# sourceMappingURL=repo.b17b9b74.js.map
